{
  "af": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "Huidige wagwoord",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "E-pos",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "Wagwoord",
          "password_confirmation": "Wagwoord bevestiging",
          "remember_created_at": null,
          "remember_me": "Onthou my",
          "reset_password_sent_at": null,
          "reset_password_token": "Herstel wagwoord egtheidsbewys",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "Ontsluit egtheidsbewys",
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validering het misluk: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan rekord nie skrap nie omdat afhanklike %{record} bestaan",
            "has_one": "Kan rekord nie skrap nie omdat 'n afhanklike %{record} bestaan"
          }
        }
      },
      "models": {
        "user": {
          "one": "Gebruiker",
          "other": "Gebruiker"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Son",
        "Maan",
        "Dins",
        "Woe",
        "Don",
        "Vry",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Des"
      ],
      "day_names": [
        "Sondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrydag",
        "Saterdag"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Januarie",
        "Februarie",
        "Maart",
        "April",
        "Mei",
        "Junie",
        "Julie",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ongeveer %{count} uur",
          "other": "ongeveer %{count} ure"
        },
        "about_x_months": {
          "one": "ongeveer %{count} maand",
          "other": "ongeveer %{count} maande"
        },
        "about_x_years": {
          "one": "ongeveer %{count} jaar",
          "other": "ongeveer %{count} jaar"
        },
        "almost_x_years": {
          "one": "sowat %{count} jaar",
          "other": "sowat %{count} jaar"
        },
        "half_a_minute": "halfminuut",
        "less_than_x_minutes": {
          "one": "minder as %{count} minuut",
          "other": "minder as %{count} minute"
        },
        "less_than_x_seconds": {
          "one": "minder as %{count} sekonde",
          "other": "minder as %{count} sekondes"
        },
        "over_x_years": {
          "one": "meer as %{count} jaar",
          "other": "meer as %{count} jaar"
        },
        "x_days": {
          "one": "%{count} dag",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minuut",
          "other": "%{count} minute"
        },
        "x_months": {
          "one": "%{count} maand",
          "other": "%{count} maande"
        },
        "x_seconds": {
          "one": "%{count} sekonde",
          "other": "%{count} sekondes"
        },
        "x_years": {
          "one": "%{count} jaar",
          "other": "%{count} jare"
        }
      },
      "prompts": {
        "day": "Dag",
        "hour": "Uur",
        "minute": "Minuut",
        "month": "Maand",
        "second": "Sekondes",
        "year": "Jaar"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Jou e-posadres is suksesvol bevestig.",
        "new": {
          "resend_confirmation_instructions": "Stuur weer bevestigingsinstruksies"
        },
        "send_instructions": "Jy sal 'n e-pos ontvang met instruksies vir hoe om jou e-posadres te bevestig oor 'n paar minute.",
        "send_paranoid_instructions": "Indien jou e-posadres in ons databasis bestaan, sal jy 'n e-pos ontvang met instruksies vir hoe om jou e-posadres te bevestig oor 'n paar minute."
      },
      "failure": {
        "already_authenticated": "Jy is alreeds aangeteken.",
        "inactive": "Jou rekening is nog nie geaktiveer nie.",
        "invalid": null,
        "last_attempt": "Jy het nog een poging voor jou rekening gesluit sal word.",
        "locked": "Jou rekening is gesluit.",
        "not_found_in_database": null,
        "timeout": "Jou sessie het verstryk. Teken asseblief aan om voort te gaan.",
        "unauthenticated": "Jy moet aanteken of inteken voor jy voortgaan.",
        "unconfirmed": "Jy moet jou e-posadres bevestig voor jy voortgaan."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bevestig my rekening",
          "greeting": "Welkom %{recipient}!",
          "instruction": "Jy kan jou rekening e-pos bevestig deur die onderstaande skakel:",
          "subject": "Bevestigingsinstruksies"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Hallo %{recipient}!",
          "message": "Ons kontak jou om jou in kennis te stel dat jou wagwoord verander is.",
          "subject": "Wagwoord Verander"
        },
        "reset_password_instructions": {
          "action": "Verander my wagwoord",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Iemand het 'n skakel versoek om jou wagwoord te verander, en jy kan dit doen deur die onderstaande skakel.",
          "instruction_2": "As jy nie hierdie versoek het nie, ignoreer asseblief hierdie e-pos.",
          "instruction_3": "Jou wagwoord sal nie verander totdat jy die skakel hierbo besoek en 'n nuwe een skep nie.",
          "subject": "Herstel wagwoord instruksies"
        },
        "unlock_instructions": {
          "action": "Ontsluit my rekening",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Klik op die onderstaande skakel om jou rekening te ontsluit:",
          "message": "Jou rekening was gesluit as gevolg van 'n oormatige hoeveelheid onsuksesvolle aantekenpogings.",
          "subject": "Ontsluitingsinstruksies"
        }
      },
      "omniauth_callbacks": {
        "failure": "Kon jou nie waarmerk vanaf %{kind} nie oor \"%{reason}\".",
        "success": "Suksesvol gewaarmerk vanaf %{kind} rekening."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Verander my wagwoord",
          "change_your_password": "Verander jou wagwoord",
          "confirm_new_password": "Bevestig nuwe wagwoord",
          "new_password": "Nuwe wagwoord"
        },
        "new": {
          "forgot_your_password": "Jou wagwoord vergeet?",
          "send_me_reset_password_instructions": "Stuur wagwoordherstelinstruksies aan my"
        },
        "no_token": "Jy kan nie toegang tot hierdie bladsy kry sonder dat jy afkomstig van 'n wagwoord herstel e-pos is nie. Indien jy wel van 'n wagwoord herstel e-pos kom, maak asseblief seker dat jy die volle verskafde bronadres gebruik het.",
        "send_instructions": "Jy sal 'n e-pos ontvang met instruksies oor hoe om jou wagwoord te herstel oor 'n paar minute.",
        "send_paranoid_instructions": "Indien jou e-posadres in ons databasis bestaan, sal jy 'n wagwoordherstelskakel by jou e-posadres ontvang binne 'n paar minute.",
        "updated": "Jou wagwoord was suksesvol gewysig. Jy is nou ingeteken.",
        "updated_not_active": "Jou wagwoord was suksesvol gewysig."
      },
      "registrations": {
        "destroyed": "Totsiens! Jou rekening was suksesvol gekanselleer. Ons hoop om jou gou weer te sien.",
        "edit": {
          "are_you_sure": "Is jy seker?",
          "cancel_my_account": "Kanselleer my rekening",
          "currently_waiting_confirmation_for_email": "Wag tans bevestiging vir: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "los skoon indien jy dit nie wil verander nie",
          "title": "Wysig %{resource}",
          "unhappy": "Ongelukkig",
          "update": "Opdateer",
          "we_need_your_current_password_to_confirm_your_changes": "ons benodig jou huidige wagwoord om jou veranderinge te bevestig"
        },
        "new": {
          "sign_up": "Teken in"
        },
        "signed_up": "Welkom! Jy het suksesvol ingeteken.",
        "signed_up_but_inactive": "Jy het suksesvol ingeteken. Ons kon jou wel nie inteken nie omdat jou rekening nog nie geaktiveer is nie.",
        "signed_up_but_locked": "Jy het suksesvol ingeteken. Ons kon jou wel nie inteken nie omdat jou rekening gesluit is.",
        "signed_up_but_unconfirmed": "'n Boodskap met 'n bevestigingsskakel was gestuur na jou e-posadres. Volg asseblief die skakel om jou rekening te aktiveer.",
        "update_needs_confirmation": "Jy het jou rekening suksesvol opgedateer, maar ons moet eerst jou nuwe e-posadres verifieer. Kyk asseblief na jou e-posse en volg die bevestigingsskakel om jou nuwe e-posadres te bevestig.",
        "updated": "Jou rekening was suksesvol opgedateer.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Suksesvol uitgeteken.",
        "new": {
          "sign_in": "Teken aan"
        },
        "signed_in": "Suksesvol aangeteken.",
        "signed_out": "Suksesvol afgeteken."
      },
      "shared": {
        "links": {
          "back": "Terug",
          "didn_t_receive_confirmation_instructions": "Nie bevestigingsinstruksies ontvang nie?",
          "didn_t_receive_unlock_instructions": "Het nie ontsluitingsinstruksies ontvang nie?",
          "forgot_your_password": "Jou wagwoord vergeet?",
          "sign_in": "Teken aan",
          "sign_in_with_provider": "Teken aan met %{provider}",
          "sign_up": "Teken in"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Stuur weer ontsluitingsinstruksies"
        },
        "send_instructions": "Jy sal 'n e-pos ontvang met instruksies vir hoe om jou rekening te ontsluit binne 'n paar minute.",
        "send_paranoid_instructions": "Indien jou rekening bestaan, sal jy 'n e-pos ontvang met instruksies vir hoe om dit te ontsluit oor 'n paar minute.",
        "unlocked": "Jou rekening was suksesvol ontsluit. Teken asseblief aan om voort te gaan."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "moet aanvaar word",
        "already_confirmed": "was alreeds bevestig, probeer inteken",
        "blank": "mag nie leeg wees nie",
        "confirmation": "pas nie by bevestiging nie",
        "confirmation_period_expired": "moet bevestig word binne %{period}, versoek asseblief 'n nuwe een",
        "empty": "mag nie leeg wees nie",
        "equal_to": "moet gelyk wees aan %{count}",
        "even": "moet ewe wees",
        "exclusion": "is bespreek",
        "expired": "het verstryk, versoek asseblief 'n nuwe een",
        "greater_than": "moet meer wees as %{count}",
        "greater_than_or_equal_to": "moet meer of gelykstaande wees aan %{count}",
        "inclusion": "is nie by die lys ingesluit nie",
        "invalid": "is ongeldig",
        "less_than": "moet minder wees as %{count}",
        "less_than_or_equal_to": "moet minder of gelykstaande wees aan %{count}",
        "model_invalid": "Validering het misluk: %{errors}",
        "not_a_number": "is nie 'n getal nie",
        "not_an_integer": "moet 'n heelgetal wees",
        "not_found": "nie gevind nie",
        "not_locked": "was nie gesluit nie",
        "not_saved": {
          "one": "1 fout het verhoed dat hierdie %{resource} gestoor word:",
          "other": "%{count} foute het verhoed dat hierdie %{resource} gestoor word:"
        },
        "odd": "moet onewe wees",
        "other_than": "moet anders wees as %{count}",
        "present": "moet leeg wees",
        "required": "moet bestaan",
        "taken": "is reeds geneem",
        "too_long": {
          "one": "is te lank (maksimum is %{count} karakter)",
          "other": "is te lank (maksimum is %{count} karakters)"
        },
        "too_short": {
          "one": "is te kort (minimum is %{count} karakter)",
          "other": "is te kort (minimum is %{count} karakters)"
        },
        "wrong_length": {
          "one": "is die verkeerde lengte (moet %{count} karakter wees)",
          "other": "is die verkeerde lengte (moet %{count} karakters wees)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} fout het verhoed dat hierdie %{model} gestoor kon word",
          "other": "%{count} foute het verhoed dat hierdie %{model} gestoor kon word"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Kies asseblief"
      },
      "submit": {
        "create": "Skep %{model}",
        "submit": "Stoor %{model}",
        "update": "Dateer %{model} op"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%u %n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "R"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miljard",
            "million": "miljoen",
            "quadrillion": "biljard",
            "thousand": "duisend",
            "trillion": "biljoen",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Greep",
              "other": "Grepe"
            },
            "gb": "GG",
            "kb": "kG",
            "mb": "MG",
            "tb": "TG"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", en ",
        "two_words_connector": " en ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "vm",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "nm"
    }
  },
  "ar": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "تم إرسال رسالة التأكيد في",
          "confirmation_token": "رمز التوكن للتأكيد",
          "confirmed_at": "تم التأكيد في",
          "created_at": "تم الإنشاء في",
          "current_password": "كلمة المرور الحالية",
          "current_sign_in_at": "تسجيل الدخول الحالي في",
          "current_sign_in_ip": "عنوان IP لتسجيل الدخول الحالي",
          "email": "بريد إلكتروني",
          "encrypted_password": "كلمة المرور المشفرة",
          "failed_attempts": "محاولات فاشلة",
          "last_sign_in_at": "آخر تسجيل دخول في",
          "last_sign_in_ip": "عنوان IP لآخر تسجيل دخول",
          "locked_at": "تم القفل في",
          "password": "كلمة المرور",
          "password_confirmation": "تأكيد كلمة المرور",
          "remember_created_at": "تم إنشاء التذكير في",
          "remember_me": "تذكرني",
          "reset_password_sent_at": "إعادة تعيين كلمة المرور مرسلة في",
          "reset_password_token": "رمز التوكن لإعادة تعيين كلمة المرور",
          "sign_in_count": "عدد تسجيلات الدخول",
          "unconfirmed_email": "البريد الإلكتروني غير مؤكد",
          "unlock_token": "فتح قفل رمز التوكن",
          "updated_at": "تم التحديث في"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "فشل التحقّق من: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "لا يمكن حذف السجل لوجود سجلات تعتمد عليه %{record}",
            "has_one": "لا يمكن حذف السجل لوجود سجل يعتمد عليه %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": "المستخدم",
          "many": "المستخدم",
          "one": "المستخدم",
          "other": "المستخدم",
          "two": "المستخدم",
          "zero": "المستخدم"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "الأحد",
        "الإثنين",
        "الثّلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السّبت"
      ],
      "abbr_month_names": [
        null,
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
      ],
      "day_names": [
        "الأحد",
        "الإثنين",
        "الثّلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السّبت"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%e %B، %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "حوالي %{count} ساعات",
          "many": "حوالي %{count} ساعة",
          "one": "حوالي ساعة واحدة",
          "other": "حوالي %{count} ساعة",
          "two": "حوالي ساعتان",
          "zero": "حوالي صفر ساعات"
        },
        "about_x_months": {
          "few": "حوالي %{count} أشهر",
          "many": "حوالي %{count} شهر",
          "one": "حوالي شهر واحد",
          "other": "حوالي %{count} شهر",
          "two": "حوالي شهران",
          "zero": "حوالي صفر أشهر"
        },
        "about_x_years": {
          "few": "حوالي %{count} سنوات",
          "many": "حوالي %{count} سنة",
          "one": "حوالي سنة",
          "other": "حوالي %{count} سنة",
          "two": "حوالي سنتان",
          "zero": "حوالي صفر سنوات"
        },
        "almost_x_years": {
          "few": "ما يقرب من %{count} سنوات",
          "many": "ما يقرب من %{count} سنة",
          "one": "تقريبا سنة واحدة",
          "other": "ما يقرب من %{count} سنة",
          "two": "ما يقرب من سنتين",
          "zero": "ما يقرب من صفر سنوات"
        },
        "half_a_minute": "نصف دقيقة",
        "less_than_x_minutes": {
          "few": "أقل من %{count} دقائق",
          "many": "أقل من %{count} دقيقة",
          "one": "أقل من دقيقة",
          "other": "أقل من %{count} دقيقة",
          "two": "أقل من دقيقتان",
          "zero": "أقل من صفر دقائق"
        },
        "less_than_x_seconds": {
          "few": "أقل من %{count} ثوان",
          "many": "أقل من %{count} ثانية",
          "one": "أقل من ثانية",
          "other": "أقل من %{count} ثانية",
          "two": "أقل من ثانيتان",
          "zero": "أقل من صفر ثواني"
        },
        "over_x_years": {
          "few": "أكثر من %{count} سنوات",
          "many": "أكثر من %{count} سنة",
          "one": "أكثر من سنة",
          "other": "أكثر من %{count} سنة",
          "two": "أكثر من سنتين",
          "zero": "أكثر من صفر سنوات"
        },
        "x_days": {
          "few": "%{count} أيام",
          "many": "%{count} يوم",
          "one": "يوم واحد",
          "other": "%{count} يوم",
          "two": "يومان",
          "zero": "صفر أيام"
        },
        "x_minutes": {
          "few": "%{count} دقائق",
          "many": "%{count} دقيقة",
          "one": "دقيقة واحدة",
          "other": "%{count} دقيقة",
          "two": "دقيقتان",
          "zero": "صفر دقائق"
        },
        "x_months": {
          "few": "%{count} أشهر",
          "many": "%{count} شهر",
          "one": "شهر واحد",
          "other": "%{count} شهر",
          "two": "شهران",
          "zero": "صفر أشهر"
        },
        "x_seconds": {
          "few": "%{count} ثوان",
          "many": "%{count} ثانية",
          "one": "ثانية واحدة",
          "other": "%{count} ثانية",
          "two": "ثانيتان",
          "zero": "صفر ثواني"
        }
      },
      "prompts": {
        "day": "اليوم",
        "hour": "ساعة",
        "minute": "دقيقة",
        "month": "الشهر",
        "second": "ثانية",
        "year": "السنة"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "تم تأكيد عنوان بريدك الإلكتروني بنجاح.",
        "new": {
          "resend_confirmation_instructions": "إعادة إرسال تعليمات التأكيد"
        },
        "send_instructions": "ستتلقى رسالة بريد إلكتروني بها تعليمات عن كيفية تأكيد عنوان بريدك الإلكتروني في غضون بضع دقائق.",
        "send_paranoid_instructions": "إذا كان بريدك الإلكتروني موجود في قاعدة البيانات لدينا، ستتلقى رسالة بريد إلكتروني بها تعليمات عن كيفية تأكيد عنوان بريدك الإلكتروني في بضع دقائق."
      },
      "failure": {
        "already_authenticated": "لقد قمت بتسجيل الدخول بالفعل.",
        "inactive": "لم يتم تفعيل حسابك بعد.",
        "invalid": "خطأ في إسم المستخدم او كلمة المرور",
        "invited": "لديك دعوة معلّقة، يجب عليك قبولها للإنتهاء من إنشاء حسابك.",
        "last_attempt": "لديك محاولة أو أكثر قبل غلق حسابك.",
        "locked": "تم غلق حسابك.",
        "not_found_in_database": "اسم المستخدم غير موجود",
        "timeout": "انتهى الوقت المخصص للجلسة. الرجاء تسجيل الدخول مرة أخرى للمتابعة.",
        "unauthenticated": "تحتاج إلى تسجيل الدخول أو التسجيل قبل المتابعة.",
        "unconfirmed": "تحتاج إلى تأكيد عنوان بريدك الإلكتروني قبل المتابعة."
      },
      "invitations": {
        "edit": {
          "header": "تحديد كلمة المرور",
          "submit_button": "حدد كلمة المرور"
        },
        "invitation_removed": "تم حذف دعوتك.",
        "invitation_token_invalid": "كود الدعوة غير صحيح",
        "new": {
          "header": "ارسال الدعوة",
          "submit_button": "ارسل الدعوة"
        },
        "no_invitations_remaining": "لم يبق لديك دعوات",
        "send_instructions": "تم إرسال الدعوة إلى البريد الإلكتروني %{email}.",
        "updated": "تم تحديد كلمة المرور الخاص بك، انت الآن مسجل دخول."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "تأكيد حسابي",
          "greeting": "مرحباً %{recipient}",
          "instruction": "يُمكنك تأكيد بريدك الإلكتروني من خلال الرابط أدناه:",
          "subject": "تعليمات التأكيد"
        },
        "email_changed": {
          "greeting": "أهلا %{recipient} !",
          "message": "نتصل بك لإخبارك أنّ عنوان بريدك الإلكتروني قد تم تغييره إلى %{email}.",
          "message_unconfirmed": "نقوم بالتواصل معك لإعلامك بتغيير بريدك الإلكتروني إلى %{email}.",
          "subject": "تم تغيير عنوان البريد الإلكتروني"
        },
        "invitation_instructions": {
          "accept": "قبول الدعوة",
          "hello": "مرحبا %{email}",
          "ignore": "إذا كنت لا تريد قبول الدعوة، الرجاء تجاهل هذا البريد.<br />لن يتم إنشاء حساب خاص بك إلا إذا دخلت على الرابط أعلاه وحددت كلمة مرور خاص بك.",
          "someone_invited_you": "تم إرسال دعوة لك إلى %{url}, يمكنك الموافقة من خلال الرابط في الأسفل",
          "subject": "تعليمات الدعوة"
        },
        "password_change": {
          "greeting": "مرحباً %{recipient}",
          "message": "لقد قمنا بالاتصال بك لإخبارك أنه قد تم تغيير كلمة مرورك.",
          "subject": "تم تغيير كلمة المرور"
        },
        "reset_password_instructions": {
          "action": "تغيير كلمة مروري",
          "greeting": "مرحباً %{recipient}",
          "instruction": "لقد طلب شخص ما رابط لتغيير كلمة مرورك، ويُمكنك القيام بذلك من خلال الرابط أدناه.",
          "instruction_2": "إذا لم تقم بطلب ذلك، الرجاء تجاهل هذه الرسالة.",
          "instruction_3": "لن يتم تغيير كلمة مرورك حتى تقوم بفتح الرابط أعلاه وإنشاء كلمة مرور جديدة.",
          "subject": "تعليمات إعادة تعيين كلمة المرور"
        },
        "unlock_instructions": {
          "action": "إلغاء قفل حسابي",
          "greeting": "مرحباً %{recipient}",
          "instruction": "انقر فوق الرابط أدناه لإلغاء قفل حسابك:",
          "message": "تم غلق حسابك بسبب العدد الكبير من محاولات تسجيل الدخول غير الناجحة.",
          "subject": "تعليمات إلغاء القفل"
        }
      },
      "omniauth_callbacks": {
        "failure": "تعذر التحقق منك من %{kind} بسبب \"%{reason}\".",
        "success": "تمت المصادقة بنجاح من حساب %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "تغيير كلمة مروري",
          "change_your_password": "تغيير كلمة مرورك",
          "confirm_new_password": "تأكيد كلمة المرور الجديدة",
          "new_password": "كلمة المرور الجديدة"
        },
        "new": {
          "forgot_your_password": "نسيت كلمة مرورك؟",
          "send_me_reset_password_instructions": "أرسل لي تعليمات إعادة تعيين كلمة المرور"
        },
        "no_token": "لا يُمكنك الوصول إلى هذه الصفحة دون تأكيد رسالة البريد الإلكتروني المحتوية على إعادة تعيين كلمة المرور. إذا كنت قد انتقلت من رسالة تعيين كلمة المرور، الرجاء التأكد من أنك استخدمت رابط URL الكامل الموجود في الرسالة.",
        "send_instructions": "ستتلقى رسالة بريد إلكرتوني بها تعليمات ععن كيفية إعادة تعيين كلمة مرورك في غضون بضع دقائق.",
        "send_paranoid_instructions": "إذا كان بريدك الإلكتروني موجود في قاعدة البيانات لدينا، ستتلقى رابط استعادة كلمة المرور على عنوان بريدك الإلكتروني في غضون بضع دقائق.",
        "updated": "تم تغيير كلمة مرورك بنجاح. أنت الآن مُسجِّل الدخول.",
        "updated_not_active": "تم تغيير كلمة مرورك بنجاح."
      },
      "registrations": {
        "destroyed": "وداعاً! تم إلغاء حسابك بنجاح. نأمل أن نراك مرة أخرى في القريب العاجل.",
        "edit": {
          "are_you_sure": "هل أنت متأكد؟",
          "cancel_my_account": "إلغاء حسابي",
          "currently_waiting_confirmation_for_email": "قيد انتظار التأكيد حالياً لـ: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "اتركه فارغاً إذا كنت لا ترغب في تغييره",
          "title": "تحرير %{resource}",
          "unhappy": "غير سعيد؟",
          "update": "تحديث",
          "we_need_your_current_password_to_confirm_your_changes": "نحتاج إلى كلمة مرورك الحالية لتأكيد التغيرات التي قمت بها"
        },
        "new": {
          "sign_up": "التسجيل"
        },
        "signed_up": "مرحباً! لقد قمت بالتسجيل بنجاح.",
        "signed_up_but_inactive": "لقد قمت بالتسجيل بنجاح. ومع ذلك، لن نتمكن من تسجيل دخولك لحسابك لأن حسابك لم يتم تفعيله بعد.",
        "signed_up_but_locked": "لقد قمت بالتسجيل بنجاح. ومع ذلك، لن نتمكن من تسجيل دخولك لحسابك لأن حسابك مغلق.",
        "signed_up_but_unconfirmed": "تم إرسال رسالة بها رابط التأكيد إلى عنوان بريدك الإلكتروني. الرجاء اتباع الرابط لتفعيل حسابك.",
        "update_needs_confirmation": "لقد قمت بتحديث حسابك بنجاح، ولكن نحتاج إلى تأكيد عنوان بريدك الإلكتروني الجديد. الرجاء التحقق من بريدك الإلكتروني واتباع رابط التأكيد لتأكيد عنوان بريدك الإلكتروني الجديد.",
        "updated": "تم تحديث حسابك بنجاح.",
        "updated_but_not_signed_in": "تمت عملية تغيير معلومات حسابك بنجاح، و لأنك قمت بتغيير كلمة المرور نرجو منك تسجيل الدخول مرة أخرى."
      },
      "sessions": {
        "already_signed_out": "تم تسجيل الخروج بنجاح.",
        "new": {
          "sign_in": "تسجيل الدخول"
        },
        "signed_in": "تم تسجيل الدخول بنجاح.",
        "signed_out": "تم تسجيل الخروج بنجاح."
      },
      "shared": {
        "links": {
          "back": "رجوع",
          "didn_t_receive_confirmation_instructions": "لم تتلقى تعليمات التأكيد؟",
          "didn_t_receive_unlock_instructions": "لم تتلقى تعليمات إلغاء القفل؟",
          "forgot_your_password": "نسيت كلمة مرورك؟",
          "sign_in": "تسجيل الدخول",
          "sign_in_with_provider": "تسجيل الدخول باستخدام %{provider}",
          "sign_up": "التسجيل"
        },
        "minimum_password_length": {
          "few": null,
          "many": null,
          "one": null,
          "other": null,
          "two": null,
          "zero": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "إعادة إرسال تعليمات إلغاء القفل"
        },
        "send_instructions": "ستتلقى رسالة بريد إلكتروني بها تعليمات عن كيفية إلغاء قفل حسابك في غضون بضع دقائق.",
        "send_paranoid_instructions": "إذا كان حسابك موجود، ستتلقى رسالة بريد إلكتروني بها تعليمات عن كيفية إلغاء القفلل غي غضون دقائق.",
        "unlocked": "تم إلغاء قفل حسابك بنجاح. الرجاء تسجيل الدخول للمتابعة."
      }
    },
    "errors": {
      "format": "%{message}",
      "messages": {
        "accepted": "يجب أن تقبل %{attribute}",
        "already_confirmed": "تم تأكيده بالفعل، الرجاء محاولة تسجيل الدخول",
        "blank": "لا يمكن أن يكون محتوى %{attribute} فارغاً",
        "confirmation": "محتوى %{attribute} لا يتوافق مع %{attribute}",
        "confirmation_period_expired": "يحتاج إلى التأكيد في غضون %{period}،الرجاء طلب رابط تأكيد جديد",
        "empty": "لا يمكن أن يكون محتوى %{attribute} فارغاً",
        "equal_to": "يجب أن يساوي طول %{attribute} %{count}",
        "even": "يجب أن يكون عدد %{attribute} زوجياً",
        "exclusion": "حقل %{attribute} محجوز",
        "expired": "قد انتهت المدة، الرجاء طلب رابط تأكيد جديد",
        "greater_than": "يجب أن يكون عدد %{attribute} أكبر من %{count}",
        "greater_than_or_equal_to": "يجب أن يكون عدد %{attribute} أكبر أو يساوي %{count}",
        "inclusion": "%{attribute} غير وارد في القائمة",
        "invalid": "محتوى %{attribute} غير صالح",
        "less_than": "يجب أن يكون عدد %{attribute} أصغر من %{count}",
        "less_than_or_equal_to": "يجب أن يكون عدد %{attribute} أصغر أو  يساوي %{count}",
        "not_a_number": "يجب أن يكون محتوى %{attribute} رقماً",
        "not_an_integer": "يجب أن يكون عدد %{attribute} عدد صحيحاً",
        "not_found": "غير موجود",
        "not_locked": "لم يتم إلغاء قفله",
        "not_saved": {
          "few": "%{count} أخطاء منع %{resource} هذا من أن يتم حفظه:",
          "many": "%{count} أخطاء منع %{resource} هذا من أن يتم حفظه:",
          "one": "1 خطأ منع %{resource} هذا من أن يتم حفظه:",
          "other": "%{count} أخطاء منع %{resource} هذا من أن يتم حفظه:",
          "two": "%{count} أخطاء منع %{resource} هذا من أن يتم حفظه:",
          "zero": "%{count} أخطاء منع %{resource} هذا من أن يتم حفظه:"
        },
        "odd": "يجب أن يكون عدد %{attribute} عدداً فردياً",
        "other_than": {
          "few": "طول %{attribute} يجب ألاّ يكون %{count} أحرف",
          "many": "طول %{attribute} يجب ألاّ يكون %{count} حرفاً",
          "one": "طول %{attribute} يجب ألاّ يكون حرفاً واحداً",
          "other": "طول %{attribute} يجب ألاّ يكون %{count} حرفاً",
          "two": "طول %{attribute} يجب ألاّ يكون حرفان",
          "zero": "طول %{attribute} يجب ألاّ يكون صفر حرف"
        },
        "present": "يجب ترك حقل %{attribute} فارغاً",
        "taken": "حقل %{attribute} محجوز مسبقاً",
        "too_long": {
          "few": "محتوى %{attribute} أطول من اللّازم (الحد الأقصى هو %{count} حروف)",
          "many": "محتوى %{attribute} أطول من اللّازم (الحد الأقصى هو %{count} حرف)",
          "one": "محتوى %{attribute} أطول من اللّازم (الحد الأقصى هو حرف واحد)",
          "other": "محتوى %{attribute} أطول من اللّازم (الحد الأقصى هو %{count} حرف)",
          "two": "محتوى %{attribute} أطول من اللّازم (الحد الأقصى هو حرفان)",
          "zero": "محتوى %{attribute} أطول من اللّازم (الحد الأقصى هو ولا حرف)"
        },
        "too_short": {
          "few": "محتوى %{attribute} أقصر من اللّازم (الحد الأدنى هو %{count} حروف)",
          "many": "محتوى %{attribute} أقصر من اللّازم (الحد الأدنى هو %{count} حرف)",
          "one": "محتوى %{attribute} أقصر من اللّازم (الحد الأدنى هو حرف واحد)",
          "other": "محتوى %{attribute} أقصر من اللّازم (الحد الأدنى هو %{count} حرف)",
          "two": "محتوى %{attribute} أقصر من اللّازم (الحد الأدنى هو حرفان)",
          "zero": "محتوى %{attribute} أقصر من اللّازم (الحد الأدنى هو ولا حرف)"
        },
        "wrong_length": {
          "few": "طول %{attribute} غير مطابق للحد المطلوب (يجب أن يكون %{count} أحرف)",
          "many": "طول %{attribute} غير مطابق للحد المطلوب (يجب أن يكون %{count} حرف)",
          "one": "طول %{attribute} غير مطابق للحد المطلوب (يجب أن يكون حرف واحد)",
          "other": "طول %{attribute} غير مطابق للحد المطلوب (يجب أن يكون %{count} حرف)",
          "two": "طول %{attribute} غير مطابق للحد المطلوب (يجب أن يكون حرفان)",
          "zero": "طول %{attribute} غير مطابق للحد المطلوب (يجب أن يكون ولا حرف)"
        }
      },
      "template": {
        "body": "يُرجى التحقّق من الحقول التّالية:%{attribute}",
        "header": {
          "few": "ليس بالامكان حفظ %{model} لسبب وجود %{count} أخطاء.",
          "many": "ليس بالامكان حفظ %{model} لسبب وجود %{count} خطأ.",
          "one": "ليس بالامكان حفظ %{model} لسبب وجود خطأ واحد.",
          "other": "ليس بالامكان حفظ %{model} لسبب وجود %{count} خطأ.",
          "two": "ليس بالامكان حفظ %{model} لسبب وجود خطئان.",
          "zero": "ليس بالامكان حفظ %{model} لسبب ولا خطأ."
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#####",
          "####",
          "###"
        ],
        "city": [
          "#{city_prefix} #{Name.first_name}",
          "#{city_prefix} #{city_name}"
        ],
        "city_name": [
          "المدينة",
          "ابراء",
          "ابها",
          "أبو ظبي",
          "ارمناز",
          "ازرع",
          "ازويرات",
          "ادلب",
          "اكجوجت",
          "الإسكندرية",
          "الإسماعيلية",
          "الأبيض",
          "الأتارب",
          "الأزرق",
          "الأغواط",
          "الأقصر",
          "الباب",
          "الباحة",
          "البتراء",
          "البديع",
          "البريمي",
          "البصرة",
          "البغدادي",
          "البليدة",
          "البيرة",
          "البيضاء",
          "البيضاء",
          "التاجي",
          "التل",
          "الثورة",
          "الجبيل",
          "الجديدة",
          "الجزائر",
          "الجش",
          "الجفر",
          "الجلفة",
          "الجنينة",
          "الجوف",
          "الجوف",
          "الجيزة",
          "الحجرة",
          "الحديدة",
          "الحريق",
          "الحسكة",
          "الحسيمة",
          "الحلة",
          "الحمرا",
          "الحوامدية",
          "الخبر",
          "الخرج",
          "الخرطوم",
          "الخروب",
          "الخليل",
          "الخمس",
          "الخميسات",
          "الدار البيضاء",
          "الدامر",
          "الدامور",
          "الدرعية",
          "الدقم",
          "دمازين",
          "الدمام",
          "الدوادمي",
          "الدوحة",
          "الدور",
          "الدويم",
          "الديماس",
          "الديوانية",
          "الراشيدية",
          "الرباط",
          "الرس",
          "الرستاق",
          "الرستن",
          "الرطبة",
          "الرفاع الغربي",
          "الرقة",
          "الرمادي",
          "الرمثا",
          "الرملة",
          "الرميلة",
          "الرويس",
          "الرياض",
          "الزاوية",
          "الزرقاء",
          "الزقازيق",
          "الزيمة",
          "السبت اولاد النمة",
          "السفيرة",
          "السقيلبية",
          "السلط",
          "السليل",
          "السليمانية",
          "السماوة",
          "السويداء",
          "السويس",
          "السويق",
          "السيب",
          "السيب",
          "الشارقة",
          "الشامية",
          "الشحر",
          "الشلف",
          "الشوف",
          "الصويرة",
          "الضعين",
          "الطائف",
          "الطريف",
          "الطينطان",
          "الظهران",
          "العرائش",
          "العريش",
          "العزيزية",
          "العضيلية",
          "العقبة",
          "العقير",
          "العلا",
          "العلمة",
          "العمارة",
          "العمران",
          "العوجا",
          "العين",
          "العيون",
          "العيون",
          "العيون",
          "العيينة",
          "الغردقة",
          "الفاشر",
          "الفجيرة",
          "الفحيحيل",
          "الفحيص",
          "الفقيه بنصالح",
          "الفلوجة",
          "الفنيدق",
          "فيفاء",
          "الفيوم",
          "القامشلي",
          "القاهرة",
          "القائم",
          "القبة",
          "القدموس",
          "القحطانية",
          "القدس",
          "القريات",
          "القصر الكبير",
          "القضارف",
          "القضيمة",
          "القطيفة",
          "القطيف",
          "القنفذة",
          "القنيطرة",
          "القنيطرة",
          "القويسمة",
          "القويعية",
          "القيروان",
          "القيصومة",
          "الكاظمية",
          "الكرك",
          "الكسوة",
          "الكوت",
          "اللاذقية",
          "اللد",
          "الليث",
          "المالكية",
          "المالكية",
          "المجمعة",
          "المحرق",
          "المحلة الكبرى",
          "المحمدية",
          "المحمدية",
          "المدية",
          "المدينة المنورة",
          "المراوعة",
          "المرج",
          "المرسى",
          "المزاحمية",
          "المسيلة",
          "المطرية",
          "المقدادية",
          "المكلا",
          "المناقل",
          "المنامة",
          "المنستير",
          "المنصورة",
          "المنطقة الخضراء",
          "المنيا",
          "الموصل",
          "الميادين",
          "القرداحة",
          "الناصرة",
          "الناصرية",
          "الناظور",
          "الناعورة",
          "النبطية",
          "النبك",
          "النجف",
          "النعمة",
          "النماص",
          "النهود",
          "الهفوف",
          "الوادي",
          "الوجه",
          "الوكرة",
          "اليوسفية",
          "انواديبو",
          "اوبيو",
          "اولاد التايمة",
          "إب",
          "إجدابيا",
          "إدفو",
          "إدلب",
          "إربد",
          "إزكي",
          "إسكندرية",
          "أبو كبير",
          "أبو كمال",
          "أخميم",
          "أدم",
          "أربيل",
          "أرتا",
          "أريحا",
          "أريحا",
          "أسفي",
          "أسوان",
          "أسيلا",
          "أسيوط",
          "أطار",
          "أعزاز",
          "أغادير",
          "أم الفحم",
          "أم القيوين",
          "أم درمان",
          "أم رواب",
          "أم قصر",
          "أوبوك",
          "آلاك",
          "باب الزوار",
          "بابابى",
          "باتنة",
          "باجل",
          "باقة الغربية",
          "بالهو",
          "بانياس",
          "بجاية",
          "بدبد",
          "بدر حنين",
          "براقي",
          "بربرة",
          "برج الكيفان",
          "برج بو عريريج",
          "برديرا",
          "برشيد",
          "بركاء",
          "بركان",
          "بريدة",
          "بريكة",
          "بسكرة",
          "بشار",
          "بعبدا",
          "بعلبك",
          "بغداد",
          "بقيق",
          "بلبيس",
          "بلجرشي",
          "بلد",
          "بليث وين",
          "بن عروس",
          "بنت جبيل",
          "بنجرير",
          "بنزرت",
          "بنغازي",
          "بنها",
          "بنى سويف",
          "بني ملال",
          "بني وليد",
          "بهلا",
          "بو سعادة",
          "بوتلميت",
          "بور سعيد",
          "بورتسودان",
          "بورو",
          "بوكادوم",
          "بوكى",
          "بيت الفقيه",
          "بيت حانون",
          "بيت لاهيا",
          "بيت لحم",
          "بيجي",
          "بيروت",
          "بيشة",
          "بريدة ‏",
          "تبوك",
          "تاروت",
          "تارودانت",
          "تازة",
          "تبسة",
          "تربة البقوم",
          "تجكجة",
          "تدمر",
          "ترهونة",
          "تزنيت",
          "تطوان",
          "تعز",
          "تقورت",
          "تكريت",
          "تل رفعت",
          "تل كيف",
          "تلعفر",
          "تلكلخ",
          "تلمسان",
          "تنبدغة",
          "تنومة",
          "توريرت",
          "تونس",
          "تيارت",
          "تيفلت",
          "تيماء",
          "ثادق",
          "ثقبة",
          "ثول",
          "جاردو",
          "جازان",
          "جالكاسيو",
          "جباليا",
          "جبلة",
          "جت",
          "جحفية",
          "جرابلس",
          "جد حفص",
          "جدة",
          "جرجا",
          "جرسيف",
          "جرش",
          "جزيرة الحمراء",
          "جزين",
          "جسر الشغور",
          "جعار",
          "جلاجل",
          "جلافي",
          "جلب",
          "جنين",
          "جوبا",
          "جونية",
          "جيبوتي",
          "جيجل",
          "حائل",
          "حارم",
          "حجة",
          "حديثة",
          "حفر الباطن",
          "حقل",
          "حلب",
          "حلبا",
          "حلبجة",
          "حلفا الجديدة",
          "حماة",
          "حمص",
          "حوطة بني تميم",
          "حيفا",
          "خان شيخون",
          "خان يونس",
          "خانقين",
          "خريبة السوق",
          "خريبكة",
          "خصب",
          "خفجي",
          "خميس مشيط",
          "خنشلة",
          "خنيفرة",
          "خور أنجار",
          "خور فكان",
          "داريا",
          "دبا",
          "دبى",
          "دخان",
          "دخيل",
          "درعا",
          "درنة",
          "دسوق",
          "دمشق",
          "دمنهور",
          "دمياط",
          "دهبان",
          "دهوك",
          "دورا",
          "دوما",
          "دومة الجندل",
          "دير البلح",
          "دير الزور",
          "دير القمر",
          "دير عطية",
          "ذمار",
          "ذي سفال",
          "رابغ",
          "رام الله",
          "راس العين",
          "رأس الخيمة",
          "رأس تنورة",
          "رأس لفان",
          "ربك",
          "رداع",
          "رفح",
          "رفحا",
          "رندا",
          "روصو",
          "ريان",
          "ريسوت",
          "زاخو",
          "زبيد",
          "زحلة",
          "زلفي",
          "زليطن",
          "زوارة",
          "سامراء",
          "سبها",
          "سترة",
          "سحاب",
          "سحار",
          "سخنين",
          "سرت",
          "سطات",
          "سطيف",
          "سعيدة",
          "سكاكا",
          "سكيكدة",
          "سلفيت",
          "سلمية",
          "سمائل",
          "سنار",
          "سنجة",
          "سوسه",
          "سوق أهراس",
          "سوهاج",
          "سيان",
          "سيدي بلعباس",
          "سيدي سليمان",
          "سيدي قاسم",
          "سيلبابي",
          "سيهات",
          "شبرا الخيمة",
          "شبين الكوم",
          "شرورة",
          "شفاعمرو",
          "شقراء",
          "شلالة العذاورة",
          "شمسطار",
          "شهبا",
          "شناص",
          "شندي",
          "شيبه",
          "صافيتا",
          "صبراتة",
          "صحار",
          "صحم",
          "صرمان",
          "صفاقس",
          "صفرو",
          "صفوى",
          "صلالة",
          "صلخد",
          "صلنفة",
          "صنعاء",
          "صور",
          "صور",
          "صوران",
          "صيدا",
          "صير بني ياس",
          "ضبا",
          "ضرما",
          "طانطان",
          "طبرق",
          "طرابلس",
          "طرابلس",
          "طرطوس",
          "طرعان",
          "طنجة",
          "طنطا",
          "طوباس",
          "طولكرم",
          "طيبة الامام",
          "عالي",
          "عبري",
          "عامودا",
          "عجلون",
          "عجمان",
          "عدل بكرو",
          "عدن",
          "عرعر",
          "عشرة رمضان",
          "عطبرة",
          "عفرين",
          "عفك",
          "عفيف",
          "عقوبة",
          "عكا",
          "علي صبيح",
          "عمان",
          "عمران",
          "عنابة",
          "عنيزة",
          "عين البيضاء",
          "عين العرب",
          "عين وسارة",
          "غارو",
          "غرداية",
          "غريان",
          "غزة",
          "غليزان",
          "غليلة",
          "فاس",
          "فرسان",
          "قابس",
          "قالمة",
          "قريات",
          "قرية الجهراء",
          "قرية سار",
          "قصرين",
          "قلعة السراغنة",
          "قلقيلية",
          "قليوب",
          "قنا",
          "قسنطينة",
          "كادوقلي",
          "كربلاء",
          "كركوك",
          "كرو",
          "كسلا",
          "كسماوي",
          "كفر الدوار",
          "كفر الشيخ",
          "كفر قاسم",
          "كفر كنا",
          "كفرشوبا",
          "كفرنجة",
          "كلميم",
          "كوستي",
          "كيفة",
          "كيهيدي",
          "لحج",
          "لوك",
          "لؤلؤة قطر",
          "ليلى",
          "ليوا",
          "مادبا",
          "مال",
          "مدحاء",
          "مدنين",
          "مدينة الحرير",
          "مدينة الصدر",
          "مدينة الكويت",
          "مدينة الملك عبد الله الاقتصادية",
          "مدينة حمد",
          "مدينة ستة أكتوبر",
          "مدينة عيسى",
          "مراكش",
          "مرزق",
          "مرسى مطروح",
          "مستغانم",
          "مسعد",
          "مسقط",
          "مسيعيد",
          "مصراتة",
          "مصياف",
          "مصيرة",
          "مطرح",
          "معرة النعمان",
          "مقديشو",
          "مقطع لحجار",
          "مكة المكرمة",
          "مكناس",
          "ملكال",
          "ملوى",
          "منبج",
          "منح",
          "ميت غمر",
          "نابل",
          "نابلس",
          "نالوت",
          "نجران",
          "نزوى",
          "نواكشوط",
          "نوى",
          "نيالا",
          "هرجيسة",
          "هولهول",
          "هيت",
          "وادي الدواسر",
          "وادي حلفا",
          "وادي زم",
          "واو",
          "وجدة",
          "ودمدني",
          "ورزازات",
          "ورقلة",
          "وزان",
          "ولاتة",
          "وهران",
          "يافا",
          "يامبيو",
          "يبرود",
          "يريم",
          "يفرن",
          "ينبع",
          "يوبوكي",
          "يي"
        ],
        "city_prefix": [
          "شمال",
          "شرق",
          "غرب",
          "جنوب",
          "بلدة",
          "منفذ",
          "مدينة",
          "أرض",
          "بلدة",
          "منطقة إدارية",
          "ميناء",
          "قرية",
          "معبر"
        ],
        "country": [
          "آروبا",
          "إثيوبيا",
          "أذربيجان",
          "أرمينيا",
          "أريتريا",
          "إسبانيا",
          "أستراليا",
          "أستونيا",
          "إسرائيل",
          "أفغانستان",
          "الأراضي الفلسطينية",
          "الأرجنتين",
          "الأردن",
          "الإقليم البريطاني في المحيط الهندي",
          "الإكوادور",
          "الإمارات العربية المتحدة",
          "ألبانيا",
          "الباهاما",
          "البحرين",
          "البرازيل",
          "البرتغال",
          "البوسنة والهرسك",
          "الجابون",
          "الجبل الأسود",
          "الجزائر",
          "الدانمرك",
          "الرأس الأخضر",
          "السلفادور",
          "السنغال",
          "السودان",
          "السويد",
          "الصحراء الغربية",
          "الصومال",
          "الصين",
          "العراق",
          "الفاتيكان",
          "الفلبين",
          "الكاميرون",
          "الكونغو - برازافيل",
          "الكونغو - كينشاسا",
          "الكويت",
          "ألمانيا",
          "المغرب",
          "المقاطعات الجنوبية الفرنسية",
          "المكسيك",
          "المملكة العربية السعودية",
          "المملكة المتحدة",
          "النرويج",
          "النمسا",
          "النيجر",
          "الهند",
          "الولايات المتحدة",
          "اليابان",
          "اليمن",
          "اليونان",
          "أنتاركتيكا",
          "أنتيغوا وبربودا",
          "أندورا",
          "أندونيسيا",
          "أنغولا",
          "أنغويلا",
          "أورغواي",
          "أوزبكستان",
          "أوغندا",
          "أوكرانيا",
          "إيران",
          "أيرلندا",
          "أيسلندا",
          "إيطاليا",
          "بابوا غينيا الجديدة",
          "باراغواي",
          "باكستان",
          "بالاو",
          "بتسوانا",
          "بربادوس",
          "برمودا",
          "بروناي",
          "بلجيكا",
          "بلغاريا",
          "بليز",
          "بنجلاديش",
          "بنما",
          "بنين",
          "بوتان",
          "بورتوريكو",
          "بوركينا فاسو",
          "بوروندي",
          "بولندا",
          "بوليفيا",
          "بولينيزيا الفرنسية",
          "بيرو",
          "تانزانيا",
          "تايلاند",
          "تايوان",
          "تركمانستان",
          "تركيا",
          "تريستان دي كونها",
          "ترينيداد وتوباغو",
          "تشاد",
          "توجو",
          "توفالو",
          "توكيلو",
          "تونس",
          "تونغا",
          "تيمور الشرقية",
          "جامايكا",
          "جبل طارق",
          "جزر آلاند",
          "جزر الترك وجايكوس",
          "جزر القمر",
          "جزر الكايمن",
          "جزر الكناري",
          "جزر المارشال",
          "جزر المالديف",
          "جزر الولايات المتحدة النائية",
          "جزر بيتكيرن",
          "جزر سليمان",
          "جزر فارو",
          "جزر فرجين الأمريكية",
          "جزر فرجين البريطانية",
          "جزر فوكلاند",
          "جزر كوك",
          "جزر كوكوس",
          "جزر ماريانا الشمالية",
          "جزر والس وفوتونا",
          "جزيرة أسينشيون",
          "جزيرة الكريسماس",
          "جزيرة مان",
          "جزيرة نورفوك",
          "جمهورية أفريقيا الوسطى",
          "جمهورية التشيك",
          "جمهورية الدومينيك",
          "جنوب أفريقيا",
          "جنوب السودان",
          "جوادلوب",
          "جورجيا",
          "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
          "جيبوتي",
          "جيرسي",
          "دومينيكا",
          "دييغو غارسيا",
          "رواندا",
          "روسيا",
          "روسيا البيضاء",
          "رومانيا",
          "روينيون",
          "زامبيا",
          "زيمبابوي",
          "ساحل العاج",
          "ساموا",
          "ساموا الأمريكية",
          "سان بارتليمي",
          "سان مارينو",
          "سانت بيير وميكولون",
          "سانت فنسنت وغرنادين",
          "سانت كيتس ونيفيس",
          "سانت لوسيا",
          "سانت مارتن",
          "سانت هيلنا",
          "ساو تومي وبرينسيبي",
          "سريلانكا",
          "سفالبارد وجان مايان",
          "سلوفاكيا",
          "سلوفينيا",
          "سنغافورة",
          "سوازيلاند",
          "سوريا",
          "سورينام",
          "سويسرا",
          "سيراليون",
          "سيشل",
          "سينت مارتن",
          "سيوتا وميليلا",
          "شيلي",
          "صربيا",
          "طاجكستان",
          "عُمان",
          "غامبيا",
          "غانا",
          "غرينادا",
          "غرينلاند",
          "غواتيمالا",
          "غوام",
          "غويانا الفرنسية",
          "غيانا",
          "غيرنزي",
          "غينيا",
          "غينيا الإستوائية",
          "غينيا بيساو",
          "فانواتو",
          "فرنسا",
          "فنزويلا",
          "فنلندا",
          "فيتنام",
          "فيجي",
          "قبرص",
          "قرغيزستان",
          "قطر",
          "كازاخستان",
          "كاليدونيا الجديدة",
          "كرواتيا",
          "كمبوديا",
          "كندا",
          "كوبا",
          "كوراساو",
          "كوريا الجنوبية",
          "كوريا الشمالية",
          "كوستاريكا",
          "كوسوفو",
          "كولومبيا",
          "كيريباتي",
          "كينيا",
          "لاتفيا",
          "لاوس",
          "لبنان",
          "لوكسمبورغ",
          "ليبيا",
          "ليبيريا",
          "ليتوانيا",
          "ليختنشتاين",
          "ليسوتو",
          "مارتينيك",
          "مالطا",
          "مالي",
          "ماليزيا",
          "مايوت",
          "مدغشقر",
          "مصر",
          "مقدونيا",
          "مكاو الصينية (منطقة إدارية خاصة)",
          "ملاوي",
          "منغوليا",
          "موريتانيا",
          "موريشيوس",
          "موزمبيق",
          "مولدافيا",
          "موناكو",
          "مونتسرات",
          "ميانمار -بورما",
          "ميكرونيزيا",
          "ناميبيا",
          "ناورو",
          "نيبال",
          "نيجيريا",
          "نيكاراغوا",
          "نيوزيلاندا",
          "نيوي",
          "هايتي",
          "هندوراس",
          "هنغاريا",
          "هولندا",
          "هولندا الكاريبية",
          "هونغ كونغ الصينية"
        ],
        "default_country": [
          "المملكة العربية السعودية"
        ],
        "default_country_code": [
          "SA"
        ],
        "full_address": [
          "#{street_address}, #{city}",
          "#{secondary_address} #{street_address}, #{city}"
        ],
        "postcode": [
          "#####",
          "#####-####"
        ],
        "secondary_address": [
          "شقة. ###",
          "جناح ###"
        ],
        "street_address": [
          "#{building_number} #{street_name}"
        ],
        "street_name": [
          "#{streets}"
        ],
        "streets": [
          "طريق الملك عبد العزيز",
          "شارع الأمير سلطان",
          "شارع العشرين",
          "شارع الأربعين",
          "شارع الستّين",
          "شارع السّبعين",
          "الشّارع الأول",
          "الشّارع الثاني",
          "الشّارع الثّالث",
          "الشّارع",
          "الرّابع",
          "الشّارع الخامس",
          "الشّارع السادس",
          "الشّارع السّابع",
          "شارع طلحة ابن الزبير",
          "شارع عمّار بن ياسر",
          "شارع غازي القصيبي",
          "شارع الورود",
          "شارع خالد ابن الوليد",
          "شارع جرير",
          "شارع عبد الله فؤاد",
          "شارع جرير",
          "شارع حمزة بن عبد المطلّب",
          "شارع محمد الثبيتي",
          "شارع حمد",
          "شارع القاهرة",
          "شارع قطر",
          "طريق الكورنيش",
          "شارع عبد الله بن عبّاد",
          "شارع الكويت"
        ]
      },
      "app": {
        "author": [
          "#{Name.name}",
          "#{Company.name}"
        ],
        "name": [
          "العبها صح",
          "لعبة ملابس",
          "أصدقاء",
          "لعبة تفحيط",
          "لعبة اصطياد الأسماك",
          "محرّر نصّي",
          "خريطة البلدة",
          "منظّم البريد الالكتروني",
          "قائمة المهام",
          "منبّه الصّلاة",
          "أوقات الصّلوات",
          "البوصلة",
          "التقويم الهجري",
          "راميدوكس",
          "توصيل",
          "قارئ الكتب"
        ],
        "version": [
          "0.#.#",
          "0.##",
          "#.##",
          "#.#",
          "#.#.#"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "genre": [
          "كلاسيك",
          "كوميكس",
          "جرائم وتحقيق",
          "كتب تراثية",
          "كتب دينية",
          "خيال علمي",
          "روايات",
          "تاريخ خياليّ",
          "رعب",
          "كوميديا",
          "غموض",
          "أساطير",
          "قصص قصيرة",
          "قصص طويلة",
          "أدب أمريكي",
          "أدب روسي",
          "أدب انجليزي",
          "أدب ياباني",
          "بيولوجيا",
          "كتب مرجعية"
        ],
        "publisher": [
          "دار الآداب",
          "دار الفارابي",
          "دار الشروق",
          "دار الفراشة",
          "دار النهضة",
          "دار العرب",
          "دار العلوم",
          "مؤسسة القوافل للترجمة",
          "مؤسسة الكتاب",
          "دار الجندي",
          "الدار الأهلي",
          "دار الكتب التراثية",
          "دار المعارف",
          "دار الترجمة"
        ],
        "title": [
          "البداية والنهاية",
          "مقدّمة ابن خلدون",
          "سيرة الصحابة",
          "سيرة ابن هشام",
          "الفرج بعد الشدّة",
          "ذهب مع الريح",
          "جريمة في قطار الشرق السريع",
          "آن في المرتفعات الخضراء",
          "هايدي",
          "الجبل والبحر",
          "بينما أموت",
          "أنشودة المقهى الحزين",
          "ظلّ الرّيح",
          "شجرتي شجرة البرتقال الرائعة",
          "يوميّات بيسوا",
          "السرّ الحارق",
          "الموت السعيد",
          "المؤمن الصّادق",
          "ساعات القدر في تاريخ البشرية",
          "الإخوة الأعداء",
          "اختراع العزلة",
          "لعبة دي نيرو",
          "عصفور من الشرق",
          "الحاج مراد",
          "لعبة الكريات الزجاجية",
          "حياة في الإدارة",
          "الجوع",
          "دراكولا",
          "الحرب والسّلم",
          "بلدي",
          "تحفة العروس",
          "عقلاء المجانين",
          "طبقات الشعراء",
          "ديوان علية بنت المهدي",
          "ديوان عبد الغني النابلسي",
          "ديوان المتنبّي",
          "نقد مراتب الإجماع",
          "كتاب صفة الجنّة\"\""
        ]
      },
      "color": {
        "name": [
          "أحمر",
          "أخضر",
          "أزرق",
          "أصفر",
          "بنفسجيّ",
          "نعناعيّ",
          "أبيض",
          "أسود",
          "برتقاليّ",
          "ورديّ",
          "رماديّ",
          "كستنائيّ",
          "تركواز",
          "سماريّ",
          "خوخيّ",
          "أوركيديّ",
          "زيتونيّ",
          "أرجوانيّ",
          "ليمونيّ",
          "نيليّ",
          "ذهبيّ",
          "فوشيه",
          "لازورديّ",
          "فضّي"
        ]
      },
      "commerce": {
        "department": [
          "كتب",
          "أفلام",
          "موسيقى",
          "آلعاب",
          "الكترونيات",
          "حاسبات",
          "منزل",
          "حديقة",
          "أدوات",
          "بقالة",
          "صحة",
          "جمال",
          "آلعاب",
          "أطفال",
          "رضّع",
          "ملابس",
          "أحذية",
          "مجوهرات",
          "رياضة",
          "أنشطة خارجيّة",
          "سيّارات",
          "صناعات"
        ],
        "product_name": {
          "adjective": [
            "صغير",
            "مريح",
            "مصدّي",
            "ذكيّ",
            "بهيّ",
            "خرافيّ",
            "رائع",
            "عمليّ",
            "أملس",
            "ضخم",
            "عادي",
            "مؤازر",
            "واجب ثقيل",
            "خفيف",
            "متين",
            "محتمل",
            "جميل",
            "سيئ",
            "مخادع"
          ],
          "material": [
            "صلب",
            "خشب",
            "خرسانة",
            "بلاستيك",
            "قطّن",
            "غرانيت",
            "مطّاط",
            "جلد",
            "سيلك",
            "صوف",
            "كتّان",
            "رخام",
            "حديد",
            "برونز",
            "نحاس",
            "ألمنيوم",
            "ورق"
          ],
          "product": [
            "كرسيّ",
            "سيّارة",
            "حاسب",
            "قفّازات",
            "بنطال",
            "قميص",
            "طاولة",
            "أحذية",
            "قبّعة",
            "صحن",
            "سكّين",
            "علبة",
            "معطف",
            "مصباح",
            "لوحة مفاتيح",
            "حقيبة",
            "مقعد",
            "ساعة حائط",
            "ساعة يدويّة",
            "محفظة"
          ]
        },
        "promotion_code": {
          "adjective": [
            "رائع",
            "عظيم",
            "مذهل",
            "جيّد",
            "جذّاب",
            "خارق",
            "قاتل",
            "استثنائيّ",
            "مميّز",
            "ممتاز"
          ],
          "noun": [
            "شيفرة",
            "صفقة",
            "تخفيضات",
            "سعر",
            "ترويج",
            "توفير"
          ]
        }
      },
      "company": {
        "bs": [
          [
            "ينفّذ",
            "ينفع",
            "يدمج",
            "يحسّن",
            "يتطوّر",
            "يعانق",
            "يتيح",
            "ينسجم",
            "نفوذ",
            "يعيد اختراع",
            "يجمع",
            "ينشر",
            "عزّز",
            "حفّز",
            "يتحوّل",
            "يمكّن",
            "ينتقد",
            "يسخّر",
            "يسهّل",
            "يحجز",
            "يتضافر",
            "يضع استراتيجية",
            "ينمو",
            "يستهدف",
            "ينقّب",
            "يولّف",
            "يوصّل",
            "يهرس",
            "يحتضن",
            "ينضمّ",
            "يزيد للحدّ الأعلى",
            "يؤشّر",
            "يسرّع",
            "سبّورة",
            "يزرع",
            "ينتج",
            "يعيد تعريف"
          ],
          [
            "نقرات وقذائف",
            "قيمة مضافة",
            "عمودي",
            "استباقي",
            "متين",
            "ثوريّ",
            "قابل للتوسعة",
            "رائد",
            "مبدع",
            "حدسي",
            "استراتيجي",
            "أعمال",
            "المهام الحرجة",
            "لزج",
            "واحد لواحد",
            "٢٤/٧",
            "نهاية لنهاية",
            "عالمي",
            "محبّب",
            "غير قابل للاحتكاك",
            "افتراضي",
            "فيروسيّ",
            "ديناميكيّ",
            "٢٤/٣٦٥. أفضل الفصائل",
            "قاتل",
            "مغناطيسيّ",
            "متاح الويب",
            "فعّال",
            "جذّاب",
            "متفاعل",
            "موزّع",
            "سلس",
            "قابل للتجديد",
            "مفتوح المصدر",
            "متعدْد المنصّات",
            "خارج الصّندوق",
            "مؤثّر",
            "الجيل القادم",
            "مخصّص",
            "متعاون",
            "غنيّ"
          ],
          [
            "القابضة",
            "نماذج",
            "الأسواق",
            "الشراكات",
            "البنى التّحتية",
            "منصّات",
            "مبادرات",
            "قنوات",
            "مجتمعات",
            "حلول",
            "نقاط البيع الالكترونيّة",
            "الخدمات الالكترونيّة",
            "بوّابات",
            "تكنولوجيا",
            "محتوى",
            "سلاسل التوريد",
            "نقطة التقاء",
            "علاقات",
            "عمارة",
            "واجهات",
            "أسواق الكترونية",
            "تجارة الكترونية",
            "أنظمة",
            "وسطاء المعلومات",
            "نماذج",
            "إنجازات",
            "مستخدمين",
            "مخططات",
            "شبكات",
            "تطبيقات",
            "وظائف",
            "خبرات",
            "خدمات ويب",
            "المنهجيات"
          ]
        ],
        "buzzwords": [
          [
            "حركات",
            "رهيب",
            "بعد نظر",
            "تقنية",
            "هوس",
            "أغاني",
            "مفتاح",
            "صاروخ",
            "حرّية",
            "قوي",
            "نار",
            "سعادة",
            "امبراطورية",
            "ذهب",
            "قيادة",
            "واو",
            "طيب",
            "لطيف",
            "تقويم",
            "معاصر",
            "عرض",
            "فلوس",
            "تويتر",
            "ابتساماة",
            "حلاوة",
            "مذهل",
            "قصص",
            "طائر",
            "صورة",
            "رمز",
            "أسطورة",
            "عميق",
            "مشاعر",
            "حصار",
            "ملاك",
            "حقيقة",
            "بصيرة",
            "مهرجان",
            "تجارب",
            "زندقة",
            "حكمة",
            "مسؤولية",
            "عمامة",
            "قدرة",
            "كتاب",
            "قراءة",
            "مبهر"
          ]
        ],
        "industry": [
          "الدّفاع والفضاء",
          "عتاد عتاد الحاسب",
          "برمجيات الحاسب",
          "شبكات الحاسب",
          "الانترنت",
          "الاتصالات",
          "المحاماة",
          "الخدمات القانونية",
          "الاستشارات الإدارية",
          "التقنيات الحيويّة",
          "الممارسة الطّبية",
          "المستشفيات والرعاية الصحّيّة",
          "الصيدليّة",
          "الطبّ البيطري",
          "الأجهزة الطبية",
          "الأدوات التّجميلية",
          "ملابس وأزياء",
          "أدرات رياضيْة",
          "التبغ",
          "محلاّت التّموين",
          "الإنتاج الغذائي",
          "الكترونيات",
          "استهلاكيات",
          "أثاث",
          "قطاع التجزأة",
          "الترفيه",
          "القمار والكازينوهات",
          "الترفيه والسفر والسياحة",
          "الضّيافة",
          "المطاعم",
          "الرياضة",
          "المواد الغذائية والمشروبات",
          "الصّور المتحرّكة والسّينما",
          "وسائل الإعلام",
          "المتاحف والمؤسسات",
          "الفنون الراقية",
          "الفنون التمثيلية",
          "المرافق والخدمات الترفيهية",
          "البنوك",
          "التأمينات",
          "الخدمات الماليّة",
          "العقارات",
          "المصرفيات الاستثمارية",
          "إدارة الاستثمارات",
          "المحاسبة",
          "البناء والتشييد",
          "أدوات التمثيل",
          "العمارة والتخطيط",
          "الهندسة المدنية",
          "الطيران والفضاء",
          "السيارات",
          "الصناعات الكيميائيّة",
          "التّجارة",
          "المعادن والتعدين",
          "الطاقة والنفط",
          "بناء السّفن",
          "خدمات",
          "المنسوجات",
          "منتجات الورق والغابات",
          "تصنيع السكك الحديدية",
          "المزارع",
          "تربية المواشي",
          "الصّيد",
          "التّعليم الأساسي والمتوسّط",
          "التعليم العالي",
          "إدارة التعليم",
          "البحوث",
          "الجيش",
          "الشؤون الخارجيّة",
          "مكتب تنفيذيّ",
          "الأمن العام",
          "التسويق والإعلان",
          "الصحف",
          "النشر",
          "الطّباعة",
          "المكتبات",
          "الخدمات البيئية",
          "الخدمات الفردية والعائليّة",
          "المؤسسات الدينية",
          "المنظمات المدنية والاجتماعيّة",
          "خدمات المستهلك",
          "الخطوط الجوية / الطيران",
          "العلاقات العامّة والتواصل",
          "التّصميم",
          "الكتابة والتعديل"
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name} و #{Name.last_name} و #{Name.last_name}"
        ],
        "profession": [
          "معلّم",
          "ممثّل",
          "موسيقيّ",
          "فيلسوف",
          "كاتب",
          "طبيب",
          "محاسب",
          "مزارع",
          "معماريّ",
          "اقتصاديّ",
          "مهندس",
          "مبادر",
          "محامي قانونيّ",
          "محامي الدّفاع",
          "أمين مكتبة",
          "احصائيّ",
          "الموارد البشرية",
          "رجل إطفاء",
          "قاضي",
          "شرطيّ",
          "عالم فلك",
          "عالم أحياء",
          "كيميائيّ",
          "فيزيائيّ",
          "مبرمج",
          "مطوّر ويب",
          "مصمّم"
        ],
        "suffix": [
          "شركة",
          "وأبناؤه",
          "المحدودة"
        ]
      },
      "name": {
        "female_first_name": [
          "عبير",
          "حنان",
          "الخنساء",
          "خديجة",
          "فوزية",
          "فوز",
          "سميّة",
          "مريم",
          "فاطمة",
          "إسراء",
          "ألهام",
          "دانة",
          "شمس",
          "عائشة",
          "خديجة",
          "نوف",
          "إيمان",
          "غادة",
          "غدير",
          "سندس",
          "رؤية",
          "بدوية",
          "رابعة",
          "خالدة",
          "صفية",
          "ابتهال",
          "خلود",
          "خولة"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "الخالدي",
          "العمريّ",
          "القادريّ",
          "التميمي",
          "القحطاني",
          "الأسمري",
          "الأخضر",
          "الزهراني",
          "الغامدي",
          "المالكيّ",
          "مجدي",
          "أبو ياسين",
          "أبو خالد",
          "إمام",
          "نصريّ",
          "الحكيم",
          "الأمير",
          "حسني",
          "زكي",
          "الجزايرلي",
          "القلعاوي",
          "الشريف",
          "حلمي",
          "الجريتلي",
          "رشدي",
          "شلبي",
          "عيد",
          "شاهين",
          "المهندس",
          "زايد",
          "المهنّا",
          "شوكت",
          "سعيد",
          "الصعيدي",
          "فتحي",
          "الصنعاني",
          "العديني",
          "بامحمّد",
          "بامحفوظ",
          "باسهل",
          "العمودي",
          "باصهيب",
          "الدوعني",
          "السقّاف",
          "العطّاس",
          "فاروق",
          "خيّاط",
          "كوسة",
          "اللاحم",
          "النابلسي",
          "الغزاوي"
        ],
        "male_first_name": [
          "حمزة",
          "خالد",
          "نوّاف",
          "عبدالصّمد",
          "عبدالرزّاق",
          "عبدالرحمن",
          "عبدالله",
          "أحمد",
          "محمّد",
          "عمر",
          "نايف",
          "فهد",
          "عمّار",
          "عمرو",
          "أبو بكر",
          "وائل",
          "وائل",
          "مالك",
          "عبدالوهّاب",
          "حاتم",
          "مصعب",
          "مهنّد",
          "عبدالمحسن",
          "عبدالعزيز"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{first_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}"
        ],
        "prefix": [
          "السيّد",
          "السيّدة",
          "الآنسة",
          "الدكتور"
        ]
      },
      "separator": " و ",
      "team": {
        "creature": [
          "الأبطال",
          "الخفافيش",
          "الدببة",
          "النّحل",
          "الطيور",
          "الخارقون",
          "القطط",
          "الدجاجات",
          "الكلاب",
          "الدلافين",
          "البط",
          "الفيلة",
          "الأسماك",
          "الثعالب",
          "الضفادع",
          "الماعز",
          "الخيول",
          "الكنغارو",
          "الأسود",
          "القرود",
          "البوم",
          "الثيران",
          "البطاريق",
          "الناس",
          "الأرانب",
          "الخرفان",
          "النّمور",
          "الحيتان",
          "الذّئاب",
          "الحمير الوحشية",
          "الغربان",
          "القطط السّوداء",
          "الأشباح",
          "المتآمرون",
          "التّنينات",
          "الأقزام",
          "المسحورين",
          "التعويذيّون",
          "الأبناء",
          "العمالقة",
          "غيلان",
          "أعداء",
          "سحرة",
          "عناكب",
          "أرواح",
          "مصّاصي دماء",
          "العنقاء",
          "المستذئبون",
          "السّاحرات",
          "الزومبي"
        ],
        "name": [
          "#{creature}"
        ],
        "sport": [
          "بيسبول",
          "كرة سلّة",
          "كرة قدم",
          "الهوكي",
          "رجبي",
          "كرة تنس"
        ]
      },
      "university": {
        "name": [
          "#{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{Name.last_name}",
          "#{University.prefix} #{Address.state} #{University.suffix}"
        ],
        "prefix": [
          "جامعة",
          "كلّية",
          "معهد",
          "أكاديميّة"
        ],
        "suffix": [
          "الشمالية",
          "الغربيّة",
          "الجنوبية",
          "الشرقية",
          "الأولى"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "يُرجى الاختيار"
      },
      "submit": {
        "create": "%{model} إنشاء",
        "submit": "%{model} حِفظ",
        "update": "%{model} تحديث"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "zero",
          "one",
          "two",
          "few",
          "many",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 3,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "KWD"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "مليار",
            "million": "مليون",
            "quadrillion": "كدريليون",
            "thousand": "ألفّ",
            "trillion": "تريليون",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "Bytes",
              "many": "Bytes",
              "one": "Byte",
              "other": "Bytes",
              "two": "Bytes",
              "zero": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " و ",
        "two_words_connector": " و ",
        "words_connector": " ، "
      }
    },
    "time": {
      "am": "صباحًا",
      "formats": {
        "default": "%a %d %b %Y %H:%M:%S %Z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "مساءً"
    }
  },
  "az": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Təsdiqləmə göndərildi",
          "confirmation_token": "Təsdiqləmə nişanəsi",
          "confirmed_at": "Təsdiqləndi",
          "created_at": "Yaradıldı",
          "current_password": "Hazırki şifrə",
          "current_sign_in_at": "Hazırki giriş",
          "current_sign_in_ip": "Hazırki girişin IP ünvanı ",
          "email": "E-poçt",
          "encrypted_password": "Şifrələnmiş şifrə",
          "failed_attempts": "Uğursuz cəhdlər",
          "last_sign_in_at": "Sonuncu giriş",
          "last_sign_in_ip": "Sonuncu girişin IP ünvanı",
          "locked_at": "Donduruldu",
          "password": "Şifrə",
          "password_confirmation": "Şifrənin təsdiqi",
          "remember_created_at": "Yaradılma tarixini yadda saxla",
          "remember_me": "Yadda saxla",
          "reset_password_sent_at": "Şifrənin göndərilmə tarixini yenilə",
          "reset_password_token": "Şifrə nişanəsini yenilə",
          "sign_in_count": "Giriş sayı",
          "unconfirmed_email": "Təsdiqlənməmiş email",
          "unlock_token": "Nişanəni aktivləşdir",
          "updated_at": "Yeniləndi"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Yoxlama uğursuz oldu: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Əlaqəli %{record} yazılar olduğundan bu yazını silmək mümkün deyil",
            "has_one": "Əlaqəli %{record} yazı olduğundan bu yazını silmək mümkün deyil"
          }
        }
      },
      "models": {
        "user": {
          "one": "İstifadəçi",
          "other": "İstifadəçi"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "B.",
        "B.E.",
        "Ç.A.",
        "Ç.",
        "C.A.",
        "C.",
        "Ş."
      ],
      "abbr_month_names": [
        null,
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "İyn",
        "İyl",
        "Avq",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
      ],
      "day_names": [
        "Bazar",
        "Bazar ertəsi",
        "Çərşənbə axşamı",
        "Çərşənbə",
        "Cümə axşamı",
        "Cümə",
        "Şənbə"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "İyun",
        "İyul",
        "Avqust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "təxminən %{count} saat",
          "other": "təxminən %{count} saat"
        },
        "about_x_months": {
          "one": "təxminən %{count} ay",
          "other": "təxminən %{count} ay"
        },
        "about_x_years": {
          "one": "təxminən %{count} il",
          "other": "təxminən %{count} il"
        },
        "almost_x_years": {
          "one": "təqribən %{count} il",
          "other": "təqribən %{count} il"
        },
        "half_a_minute": "yarım dəqiqə",
        "less_than_x_minutes": {
          "one": "%{count} dəqiqədən az",
          "other": "%{count} dəqiqədən az"
        },
        "less_than_x_seconds": {
          "one": "%{count} saniyədən az",
          "other": "%{count} saniyədən az"
        },
        "over_x_years": {
          "one": "%{count} ildən çox",
          "other": "%{count} ildən çox"
        },
        "x_days": {
          "one": "%{count} gün",
          "other": "%{count} gün"
        },
        "x_minutes": {
          "one": "%{count} dəqiqə",
          "other": "%{count} dəqiqə"
        },
        "x_months": {
          "one": "%{count} ay",
          "other": "%{count} ay"
        },
        "x_seconds": {
          "one": "%{count} saniyə",
          "other": "%{count} saniyə"
        }
      },
      "prompts": {
        "day": "Gün",
        "hour": "Saat",
        "minute": "Dəqiqə",
        "month": "Ay",
        "second": "Saniyə",
        "year": "İl"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Sizin email ünvanınız uğurla təsdiqləndi.",
        "new": {
          "resend_confirmation_instructions": "Təsdiqləmə təlimatlarını yenidən göndər"
        },
        "send_instructions": "Bir neçə dəqiqə ərzində hesabınızı təstiqləməklə bağlı təlimatlar email ünvanınıza göndəriləcəkdir.",
        "send_paranoid_instructions": "Əgər email ünvanınız bazamızda varsa, bir neçə dəqiqə ərzində hesabınızı təsdiqləmək üçün sizə təlimat göndəriləcəkdir."
      },
      "failure": {
        "already_authenticated": "Siz artıq hesabınıza daxil olmuşsunuz.",
        "inactive": "Sizin hesabınız hələ ki aktivləşdirilməyib.",
        "invalid": "Şifrə və ya %{authentication_keys} yanlışdır.",
        "last_attempt": "Hesabınız bağlanmazdan öncə sizin daha bir cəhdiniz qalıb.",
        "locked": "Sizin hesabınız bloklanmışdır.",
        "not_found_in_database": "Şifrə və ya %{authentication_keys} yanlışdır.",
        "timeout": "Sessiyanızın vaxtı bitmişdir. Davam etmək üçün, zəhmət olmasa yenidən daxil olun.",
        "unauthenticated": "Davam etmək üçün hesabınıza daxil olmalı və ya qeydiyyatdan keçməlisiniz.",
        "unconfirmed": "Davam etmək üçün hesabınızı təsdiqləməlisiniz."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Hesabımı təsdiqlə",
          "greeting": "Xoş gəlmisiniz, %{recipient}!",
          "instruction": "Hesabınızı aşağıdakı keçiddən istifadə etməklə təsdiqləyə bilərsiniz.",
          "subject": "Təsdiqləmə təlimatları"
        },
        "email_changed": {
          "greeting": "Salam, %{recipient}!",
          "message": "Bu məktub, elektron ünvanınızın %{email} ilə dəyişdirildiyini bildirmək üçün, sizə göndərilib.",
          "message_unconfirmed": null,
          "subject": "Elektron ünvanınız dəyişdirildi"
        },
        "password_change": {
          "greeting": "Salam, %{recipient}!",
          "message": "Bu məktub, şifrənizin dəyişildiyini bildirmək üçün sizə göndərilib.",
          "subject": "Şifrə dəyişildi"
        },
        "reset_password_instructions": {
          "action": "Şifrəmi dəyiş",
          "greeting": "Salam, %{recipient}!",
          "instruction": "Kimsə şifrəni yeniləmək üçün keçid istədi. Aşağıdaki keçiddən istifadə etməklə, şifrənizi dəyişə bilərsiniz.",
          "instruction_2": "Əgər keçidi siz istəməmisinizsə, zəhmət olmasa bu məktubu boş verin.",
          "instruction_3": "Yuxarıdakı keçiddən istifadə etmədiyiniz və yeni şifrə təyin etmədiyiniz müddətdə, şifrəniz dəyişilməyəcək.",
          "subject": "Şifrənin yenilənməsi"
        },
        "unlock_instructions": {
          "action": "Hesabımı blokdan çıxar",
          "greeting": "Salam, %{recipient}!",
          "instruction": "Hesabınızı blokdan çıxarmaq üçün, aşağıdakı keçidə klik edin:",
          "message": "Uğursuz giriş cəhdləri sayının həddən artıq olması səbəbi ilə, hesabınız dondurulmuşdur.",
          "subject": "Hesabın blokdan çıxardılması"
        }
      },
      "omniauth_callbacks": {
        "failure": "\"%{reason}\" səbəbindən sizi %{kind} autentikasiya etmək mümkün olmadı.",
        "success": "%{kind} hesabıyla uğurla daxil oldunuz."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Şifrəmi yenilə",
          "change_your_password": "Şifrənizi dəyişin",
          "confirm_new_password": "Yeni şifrəni təsdiqləyin",
          "new_password": "Yeni şifrə"
        },
        "new": {
          "forgot_your_password": "Şifrənizi unutmusunuz?",
          "send_me_reset_password_instructions": "Şifrənin yenilənməsi ilə bağlı təlimatlar al"
        },
        "no_token": "Bu səhifəyə şifrəni yeniləmə məktubundan keçid etmisinizsə,  tam URL-dən istifadə etdiyinizi yoxlayın. Əks halda səhifəni görə bilməzsiniz.",
        "send_instructions": "Siz bir neçə dəqiqə ərazində, şifrənizi dəyişməklə bağlı təlimatlar olan email qəbul edəcəksiniz.",
        "send_paranoid_instructions": "Əgər email ünvanınız bazamızda varsa, sizə bir neçə dəqiqə ərzində şifrəni bərpanı etmək üçün keçid göndəriləcəkdir.",
        "updated": "Şifrəniz uğurla dəyişdirildi. Siz hazırda sistemə daxil olmusunuz.",
        "updated_not_active": "Şifrəniz uğurla dəyişdirildi."
      },
      "registrations": {
        "destroyed": "Hesabınız sistemimizdən uğurla çıxarıldı. Sizi qısa zamanda yenidən görmək ümidi ilə, hələlik!",
        "edit": {
          "are_you_sure": "Əminsiniz?",
          "cancel_my_account": "Hesabımı ləğv et",
          "currently_waiting_confirmation_for_email": "Hazırda %{email} ünvanının təsdiqlənməsi gözlənilir",
          "leave_blank_if_you_don_t_want_to_change_it": "dəyişmək istəmirsinizsə, boş buraxın",
          "title": "%{resource} resursunun redaktəsi",
          "unhappy": "Narazısınız?",
          "update": "Yenilə",
          "we_need_your_current_password_to_confirm_your_changes": "dəyişiklikləri təsdiq etmək üçün, hazırki şifrənizi daxil etməlisiniz"
        },
        "new": {
          "sign_up": "Qeydiyyat"
        },
        "signed_up": "Təbriklər! Siz uğurla qeydiyyatdan keçdiniz.",
        "signed_up_but_inactive": "Siz uğurla qeydiyyatdan keçdiniz. Halbuki, sistemə yalnız hesabınızı aktiv etdikdən sonra daxil ola bilərsiniz.",
        "signed_up_but_locked": "Siz uğurla qeydiyyatdan keçdiniz. Ancaq hesabınız blokda olduğu üçün biz sizi sistemə daxil edə bilmirik.",
        "signed_up_but_unconfirmed": "Təstiq linkini özündə saxlayan məktub sizə email vasitəsiylə göndərildi. Hesabınızı aktivləşdirmək üçün zəhmət olmasa linki açın.",
        "update_needs_confirmation": "Hesabınızı uğurla yenilədiniz, ancaq biz sizin email ünvanınızı yoxlamalıyıq. Zəhmət olmasa email qutunuzu yoxlayın və təstiq linkinə daxil olaraq yeni email ünvanınızı təstiqləyin.",
        "updated": "Hesabınızı uğurla yenilədiniz.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Ugurlu cıxış.",
        "new": {
          "sign_in": "Daxil ol"
        },
        "signed_in": "Sistemə uğurla daxil oldunuz.",
        "signed_out": "Sistemdən uğurla çıxdınız."
      },
      "shared": {
        "links": {
          "back": "Geri",
          "didn_t_receive_confirmation_instructions": "Təsdiqləmə təlimatları almamısınız?",
          "didn_t_receive_unlock_instructions": "Blokdan çıxarma təlimatları almamısınız?",
          "forgot_your_password": "Şifrənizi unutmusunuz?",
          "sign_in": "Daxil ol",
          "sign_in_with_provider": "%{provider} ilə daxil ol",
          "sign_up": "Qeydiyyat"
        },
        "minimum_password_length": {
          "one": "(minimum %{count} simvol)",
          "other": "(minimum %{count} simvol)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Bərpa ilə bağlı təlimatları yenidən göndər"
        },
        "send_instructions": "Bir neçə dəqiqə ərzində hesabınızı blokdan çıxarmaqla bağlı təlimatlar email ünvanınıza göndəriləcəkdir.",
        "send_paranoid_instructions": "Əgər bazada belə bir hesab varsa, bir neçə dəqiqə ərzində hesabınızı blokdan çıxarmaqla bağlı təlimatlar email ünvanınıza göndəriləcəkdir.",
        "unlocked": "Hesabınız uğurla blokdan çıxarıldı, davam etmək üçün zəhmət olmasa hesabınıza daxil olun"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "qəbul olunmalıdır",
        "already_confirmed": "artıq təsdiq olunmuşdur, zəhmət olmasa daxil olmağa çalışın",
        "blank": "boş ola bilməz",
        "confirmation": "təsdiqə uygun deyil",
        "confirmation_period_expired": ", %{period} ərzində təstiqlənməlidir, zəhmət olmasa yenisini istəyin",
        "empty": "boş ola bilməz",
        "equal_to": "%{count}-ə bərabər olmalıdır",
        "even": "cüt olmalıdır",
        "exclusion": "qorunur",
        "expired": "vaxtı bitmişdir, zəhmət olmasa yenisini istəyin",
        "greater_than": "%{count}-dən böyük olmalıdır",
        "greater_than_or_equal_to": "böyük və ya %{count}-ə bərabər olmalıdır",
        "inclusion": "siyahiyə daxil deyil",
        "invalid": "yanlışdır",
        "less_than": "%{count}-dən kiçik olmalıdır",
        "less_than_or_equal_to": "kiçik və ya %{count}-ə bərabər olmalıdır",
        "model_invalid": "Yoxlama uğursuz oldu: %{errors}",
        "not_a_number": "rəqəm deyil",
        "not_an_integer": "tam rəqəm olmalıdır",
        "not_found": "tapılmadı",
        "not_locked": "bloklanmış deyildi",
        "not_saved": {
          "one": "%{count} səhv / səhvlər %{resource} resursunun yenilənməsinə mane olur",
          "other": "%{count} səhv / səhvlər %{resource} resursunun yenilənməsinə mane olur"
        },
        "odd": "tək olmalıdır",
        "other_than": "%{count}-dən fərqli olmalıdır",
        "present": "boş olmalıdır",
        "required": "mövcud olmalıdır",
        "taken": "artıq mövcuddur",
        "too_long": "çox uzundur (%{count} simvoldan çox olmalı deyil)",
        "too_short": "çox qısadır (%{count} simvoldan az olmalı deyil)",
        "wrong_length": "uzunluqu səhvdir (%{count} simvol olmalıdır)"
      },
      "template": {
        "body": "Aşağıdaki səhvlər üzə çıxdı:",
        "header": {
          "one": "%{model} saxlanmadı: %{count} səhv",
          "other": "%{model} saxlanmadı: %{count} səhv"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Seçin"
      },
      "submit": {
        "create": "%{model} yarat",
        "submit": "%{model} saxla",
        "update": "%{model} yenilə"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "C": "J",
          "J": "Zh",
          "Q": "G",
          "X": "Kh",
          "c": "j",
          "j": "zh",
          "q": "g",
          "x": "kh",
          "Ç": "Ch",
          "Ü": "U",
          "ç": "ch",
          "ü": "u",
          "Ğ": "Gh",
          "ğ": "gh",
          "İ": "I",
          "ı": "i",
          "Ş": "Sh",
          "ş": "sh",
          "Ə": "E",
          "ə": "e"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "AZN"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Milyard",
            "million": "Milyon",
            "quadrillion": "Kvadrilyon",
            "thousand": "Min",
            "trillion": "Trilyon",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Bayt",
              "other": "Bayt"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " və ",
        "two_words_connector": " və ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "günortaya qədər",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "günortadan sonra"
    }
  },
  "be": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "Сучасны пароль",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "Email",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "Пароль",
          "password_confirmation": "пацвердзіце пароль",
          "remember_created_at": null,
          "remember_me": "Запомніць мяне",
          "reset_password_sent_at": null,
          "reset_password_token": "Спасылка скіду пароля",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "Токен разблакоўкі",
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Памылкі валідацыі: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Нельга выдаліць запіс, таму што існуюць залежнасці %{record}",
            "has_one": "Нельга выдаліць запіс, таму што існуе залежнасць %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": "Карыстальнік",
          "many": "Карыстальнік",
          "one": "Карыстальнік",
          "other": "Карыстальнік"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Пан",
        "Аўт",
        "Сер",
        "Чцв",
        "Пят",
        "Суб",
        "Ндз"
      ],
      "abbr_month_names": [
        null,
        "Сту",
        "Лют",
        "Сак",
        "Кра",
        "Тра",
        "Чэр",
        "Ліп",
        "Жні",
        "Вер",
        "Кас",
        "Ліс",
        "Сне"
      ],
      "day_names": [
        "Нядзеля",
        "Панядзелак",
        "Аўторак",
        "Серада",
        "Чацвер",
        "Пятніца",
        "Субота"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "Студзень",
        "Люты",
        "Сакавік",
        "Красавік",
        "Травень",
        "Чэрвень",
        "Ліпень",
        "Жнівень",
        "Верасень",
        "Кастрычнік",
        "Лістапад",
        "Снежань"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "каля %{count} гадзін",
          "many": "каля %{count} гадзін",
          "one": "каля %{count} гадзіны",
          "other": "каля %{count} гадзін"
        },
        "about_x_months": {
          "few": "каля %{count} месяцаў",
          "many": "каля %{count} месяцаў",
          "one": "каля %{count} месяца",
          "other": "каля %{count} месяцаў"
        },
        "about_x_years": {
          "few": "каля %{count} гадоў",
          "many": "каля %{count} гадоў",
          "one": "каля %{count} года",
          "other": "каля %{count} гадоў"
        },
        "almost_x_years": {
          "few": "амаль %{count} гады",
          "many": "амаль %{count} гадоў",
          "one": "амаль %{count} год",
          "other": "амаль %{count} гадоў"
        },
        "half_a_minute": "палова хвіліны",
        "less_than_x_minutes": {
          "few": "меней за %{count} хвіліны",
          "many": "меней за %{count} хвілін",
          "one": "меней за %{count} хвіліну",
          "other": "меней за %{count} хвіліны"
        },
        "less_than_x_seconds": {
          "few": "меней за %{count} секунды",
          "many": "меней за %{count} секунд",
          "one": "меней за %{count} секунду",
          "other": "меней за %{count} секунды"
        },
        "over_x_years": {
          "few": "болей за %{count} гады",
          "many": "болей за %{count} гадоў",
          "one": "болей за %{count} год",
          "other": "болей за %{count} года"
        },
        "x_days": {
          "few": "%{count} дні",
          "many": "%{count} дзён",
          "one": "%{count} дзень",
          "other": "%{count} дня"
        },
        "x_minutes": {
          "few": "%{count} хвіліны",
          "many": "%{count} хвілін",
          "one": "%{count} хвіліна",
          "other": "%{count} хвіліны"
        },
        "x_months": {
          "few": "%{count} месяцы",
          "many": "%{count} месяцаў",
          "one": "%{count} месяц",
          "other": "%{count} месяца"
        },
        "x_seconds": {
          "few": "%{count} секунды",
          "many": "%{count} секунд",
          "one": "%{count} секунда",
          "other": "%{count} секунды"
        },
        "x_years": {
          "few": "%{count} гады",
          "many": "%{count} гадоў",
          "one": "%{count} год",
          "other": "%{count} года"
        }
      },
      "prompts": {
        "day": "Дзень",
        "hour": "Гадзіна",
        "minute": "Хвіліна",
        "month": "Месяц",
        "second": "Секунда",
        "year": "Год"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ваш адрас эл. пошты паспяхова пацверджаны.",
        "new": {
          "resend_confirmation_instructions": "Выслаць паўторна ліст з актывацыяй"
        },
        "send_instructions": "Цягам некалькіх хвілін вы атрымаеце ліст з інструкцыямі па пацверджанні адраса эл. пошты.",
        "send_paranoid_instructions": "Калі ваш адрас эл. пошты ёсть y сістэме, то цягам некалькіх хвілін вы атрымаеце ліст з інструкцыямі па яго пацверджанні."
      },
      "failure": {
        "already_authenticated": "Вы ўжо ўвайшлі ў сістэму.",
        "inactive": "Ваш уліковы запіс яшчэ не актываваны.",
        "invalid": null,
        "last_attempt": "У вас засталася апошняя спроба ўводу пароля да блакавання ўліковага запісу.",
        "locked": "Ваш уліковы запіс заблакаваны.",
        "not_found_in_database": null,
        "timeout": "Ваш сеанс скончыўся. Калі ласка, увайдзіце ў сістэму зноў.",
        "unauthenticated": "Вам трэба ўвайсці ў сістэму ці зарэгістравацца",
        "unconfirmed": "Вы павінны пацвердзіць ваш уліковы запіс."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Актываваць",
          "greeting": "Прывітанні, %{recipient} !",
          "instruction": "Вы можаце актываваць свой уліковы запіс, націснуўшы спасылку знізу:",
          "subject": "Інструкцыі па пацверджанні ўліковага запісу"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Вітаны, %{recipient}!",
          "message": "Мы спрабуем звязацца з вамі, каб паведаміць, што ваш пароль быў зменены.",
          "subject": "Пароль зменены"
        },
        "reset_password_instructions": {
          "action": "Змяніць пароль",
          "greeting": "Прывітанні, %{recipient}!",
          "instruction": "Вы (ці нехта яшчэ) запыталі змену пароля. Для змены пароля націсніце спасылку ніжэй:",
          "instruction_2": "Калі вы не запытвалі змену пароля - праігнаруйце гэта паведамленне",
          "instruction_3": "Ваш пароль не зменіцца пакуль вы не націснеце на спасылку і не ўведзяце новы.",
          "subject": "Інструкцыі па аднаўленні пароля"
        },
        "unlock_instructions": {
          "action": "Разблакаваць уліковы запіс",
          "greeting": "Добры дзень, %{recipient}!",
          "instruction": "Націсніце спасылку для актывацыі ўліковага запісу:",
          "message": "Ваш уліковы запіс быў заблакаваны ў звязку з перавышэннем ліміту няўдалых спроб уваходу.",
          "subject": "Інструкцыі па разблакоўцы ўліковага запісу"
        }
      },
      "omniauth_callbacks": {
        "failure": "Вы не можаце ўвайсці ў сістэму з уліковым запісам з %{kind}, бо \"%{reason}\".",
        "success": "Уваход у сістэму выкананы з уліковым запісам з %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Змяніць мой пароль",
          "change_your_password": "Змяніць пароль",
          "confirm_new_password": "Паўторыце новы пароль",
          "new_password": "Новы пароль"
        },
        "new": {
          "forgot_your_password": "Забыліся пароль?",
          "send_me_reset_password_instructions": "Выслаць новы пароль"
        },
        "no_token": "Доступ да гэтай старонкі магчымы толькі па спасылцы з ліста пра аднаўленне пароля. Калі вы прыйшлі па такой спасылцы, калі ласка, пераканаецеся, што Вы скапіявалі ўсю спасылку цаліком.",
        "send_instructions": "Цягам некалькіх хвілін вы атрымаеце ліст з інструкцыямі па аднаўленні пароля.",
        "send_paranoid_instructions": "Калі ваш адрас эл. пошты ёсць у сістэме, то цягам некалькіх хвілін вы атрымаеце ліст з інструкцыямі па аднаўленні пароля.",
        "updated": "Ваш пароль зменены. Зараз вы ўвайшлі ў сістэму.",
        "updated_not_active": "Ваш пароль зменены."
      },
      "registrations": {
        "destroyed": "Да спаткання! Ваш уліковы запіс выдалены. Спадзяёмся зноў убачыць вас.",
        "edit": {
          "are_you_sure": "Вы ўпэўнены?",
          "cancel_my_account": "Выдаліць уліковы запіс",
          "currently_waiting_confirmation_for_email": "Чакаецца пацверджанне адрасаE-mail: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "пакіньце крысу пустым, калі не хочаце яго змяняць",
          "title": "Рэдагаваць %{resource}",
          "unhappy": "Расчараваны",
          "update": "Абнавіць",
          "we_need_your_current_password_to_confirm_your_changes": "увядзіце бягучы пароль для пацверджання змен"
        },
        "new": {
          "sign_up": "Рэгістрацыя"
        },
        "signed_up": "Сардэчна запрашаем! Вы паспяхова зарэгістраваліся.",
        "signed_up_but_inactive": "Вы паспяхова зарэгістраваны. Аднак, вы не можаце ўвайсці ў сістэму, таму што ваш уліковы запіс не актываваны.",
        "signed_up_but_locked": "Вы паспяхова зарэгістраваны. Аднак, вы не можаце ўвайсці ў сістэму, таму што ваш уліковы запіс заблакаваны.",
        "signed_up_but_unconfirmed": "Ліст са спасылкай для пацверджання быў адпраўлена на ваш адрас эл. пошты. Калі ласка, перайдзіце па спасылцы, каб пацвердзіць уліковы запіс.",
        "update_needs_confirmation": "Вы паспяхова абнавілі дадзеныя ўліковага запісу, але трэба пацвердзіць новы адрас эл. пошты. Калі ласка, праверце паштовую скрынку і перайдзіце па спасылцы, каб скончыць працэдуру праверкі новага адраса",
        "updated": "Ваш уліковы запіс зменены.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Выйсце з сістэмы ўжо выкананае.",
        "new": {
          "sign_in": "Увайсці"
        },
        "signed_in": "Уваход у сістэму выкананы.",
        "signed_out": "Выхад з сістэмы выкананы."
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Не атрымалі пацверджанне?",
          "didn_t_receive_unlock_instructions": "Не атрымалі кодаў разблакоўкі?",
          "forgot_your_password": "Забыліся пароль?",
          "sign_in": "Увайсці",
          "sign_in_with_provider": "Увайсці з дапамогай:  %{provider}",
          "sign_up": "Рэгістрацыя"
        },
        "minimum_password_length": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Выслаць пацверджанне зноўку"
        },
        "send_instructions": "Цягам некалькіх хвілін вы атрымаеце ліст з інструкцыямі па разблакоўцы ўліковага запісу.",
        "send_paranoid_instructions": "Калі ваш уліковы запіс існуе, то цягам некалькіх хвілін вы атрымаеце ліст з інструкцыямі па яе разблакоўцы.",
        "unlocked": "Ваш уліковы запіс разблакаваны. Зараз вы можаце ўвайсці ў сістэму."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "трэба прыняць",
        "already_confirmed": "ужо пацверджаны. Калі ласка, паспрабуйце ўвайсці ў сістэму",
        "blank": "не можа быць пустым",
        "confirmation": "не супадае з %{attribute}",
        "confirmation_period_expired": "павінен быць пацверджаны ў плынь %{period}, калі ласка, паўторыце запыт на пацверджанне",
        "empty": "не можа быць пустым",
        "equal_to": "павінна быць роўным %{count}",
        "even": "павінна быць цотным",
        "exclusion": "мае зарэзерваванае значэнне",
        "expired": "састарэлая. Калі ласка, запытаеце новую",
        "greater_than": "павінна быць болей за %{count}",
        "greater_than_or_equal_to": "павінна быць болей ці роўным %{count}",
        "inclusion": "значэнне не уключана ў спіс",
        "invalid": "няправільнае значэнне",
        "less_than": "павінна быць меней за %{count}",
        "less_than_or_equal_to": "павінна быць меней ці роўным %{count}",
        "model_invalid": "Узніклі настпупныя памылкі: %{errors}",
        "not_a_number": "гэта не лічба",
        "not_an_integer": "павінна быць цэлай лічбай",
        "not_found": "не знойдзены",
        "not_locked": "не заблакаван",
        "not_saved": {
          "few": "%{resource}: захаванне не атрымалася з-за %{count} памылак:",
          "many": "%{resource}: захаванне не атрымалася з-за %{count} памылак:",
          "one": "%{resource}: захаванне не атрымалася з-за %{count} памылкі:",
          "other": "%{resource}: захаванне не атрымалася з-за %{count} памылкі:"
        },
        "odd": "павінна быць няцотным",
        "other_than": "павінна адрознівацца ад %{count}",
        "present": "павінна быць пустым",
        "required": "не можа адсутнічаць",
        "taken": "ўжо занята",
        "too_long": {
          "few": "занадта доўгі (максімум %{count} сімвала)",
          "many": "занадта доўгі (максімум %{count} сімвалаў)",
          "one": "занадта доўгі (максімум %{count} сімвал)",
          "other": "занадта доўгі (максімум %{count} сімвалаў)"
        },
        "too_short": {
          "few": "занадта кароткі (мінімум %{count} сімвала)",
          "many": "занадта кароткі (мінімум %{count} сімвалаў)",
          "one": "занадта кароткі (мінімум %{count} сімвал)",
          "other": "занадта кароткі (мінімум %{count} сімвалаў)"
        },
        "wrong_length": {
          "few": "няправільная даўжыня (павінен быць %{count} сімвала)",
          "many": "няправільная даўжыня (павінны быць %{count} сімвалаў)",
          "one": "няправільная даўжыня (павінен быць %{count} сімвал)",
          "other": "няправільная даўжыня (павінны быць %{count} сімвалаў)"
        }
      },
      "template": {
        "body": "Узніклі праблемы з наступнымі палямі:",
        "header": {
          "few": "не атрымалася захаваць %{model} з-за %{count} памылак",
          "many": "не атрымалася захаваць %{model} з-за %{count} памылак",
          "one": "не атрымалася захаваць %{model} з-за %{count} памылкі",
          "other": "не атрымалася захаваць %{model} з-за %{count} памылак"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Калі ласка, абярыце"
      },
      "submit": {
        "create": "Стварыць %{model}",
        "submit": "Захаваць %{model}",
        "update": "Абнавіць %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "many",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "руб."
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "мільярда",
              "many": "мільярдаў",
              "one": "мільярд",
              "other": "мільярда"
            },
            "million": {
              "few": "мільёна",
              "many": "мільёнаў",
              "one": "мільён",
              "other": "мільёна"
            },
            "quadrillion": {
              "few": "квадрыльёна",
              "many": "квадрыльёнаў",
              "one": "квадрыльён",
              "other": "квадрыльёна"
            },
            "thousand": {
              "few": "тысячы",
              "many": "тысяч",
              "one": "тысяча",
              "other": "тысячы"
            },
            "trillion": {
              "few": "трыльёна",
              "many": "трыльёнаў",
              "one": "трыльён",
              "other": "трыльёна"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "байта",
              "many": "байтаў",
              "one": "байт",
              "other": "байта"
            },
            "eb": "ЭБ",
            "gb": "ГБ",
            "kb": "КБ",
            "mb": "МБ",
            "pb": "ПБ",
            "tb": "ТБ"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " і ",
        "two_words_connector": " і ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "раніцы",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "вечара"
    }
  },
  "bg": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "Настояща парола",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "Имейл",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "Парола",
          "password_confirmation": "Потвърждаване на паролата",
          "remember_created_at": null,
          "remember_me": "Запомни ме",
          "reset_password_sent_at": null,
          "reset_password_token": "Код за промяна на парола",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "Код за отключване на профил",
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "имаше грешки: %{errors}"
        }
      },
      "models": {
        "user": {
          "one": "Потребител",
          "other": "Потребител"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "нед",
        "пон",
        "вт",
        "ср",
        "чет",
        "пет",
        "съб"
      ],
      "abbr_month_names": [
        null,
        "ян.",
        "фев.",
        "март",
        "апр.",
        "май",
        "юни",
        "юли",
        "авг.",
        "сеп.",
        "окт.",
        "ноем.",
        "дек."
      ],
      "day_names": [
        "неделя",
        "понеделник",
        "вторник",
        "сряда",
        "четвъртък",
        "петък",
        "събота"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "януари",
        "февруари",
        "март",
        "април",
        "май",
        "юни",
        "юли",
        "август",
        "септември",
        "октомври",
        "ноември",
        "декември"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "около %{count} час",
          "other": "около %{count} часа"
        },
        "about_x_months": {
          "one": "около %{count} месец",
          "other": "около %{count} месеца"
        },
        "about_x_years": {
          "one": "около %{count} година",
          "other": "около %{count} години"
        },
        "almost_x_years": {
          "one": "почти %{count} година",
          "other": "почти %{count} години"
        },
        "half_a_minute": "половин минута",
        "less_than_x_minutes": {
          "one": "по-малко от %{count} минута",
          "other": "по-малко от %{count} минути"
        },
        "less_than_x_seconds": {
          "one": "по-малко от %{count} секунда",
          "other": "по-малко от %{count} секунди"
        },
        "over_x_years": {
          "one": "над %{count} година",
          "other": "над %{count} години"
        },
        "x_days": {
          "one": "%{count} ден",
          "other": "%{count} дни"
        },
        "x_minutes": {
          "one": "%{count} минута",
          "other": "%{count} минути"
        },
        "x_months": {
          "one": "%{count} месец",
          "other": "%{count} месеца"
        },
        "x_seconds": {
          "one": "%{count} секунда",
          "other": "%{count} секунди"
        }
      },
      "prompts": {
        "day": "Ден",
        "hour": "Час",
        "minute": "Минута",
        "month": "Месец",
        "second": "Секунда",
        "year": "Година"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Регистрацията Ви е потвърдена.",
        "new": {
          "resend_confirmation_instructions": "Повторно изпращане на инструкции за потвърждаване"
        },
        "send_instructions": "Ще получите имейл с инструкции за потвърждаване на Вашата регистрация до няколко минути.",
        "send_paranoid_instructions": "Ако Вашият имейл адрес съществува в нашата база данни, ще получите имейл с инструкции за потвърждаване на Вашия профил до няколко минути."
      },
      "failure": {
        "already_authenticated": "Вече сте влезли в профила си.",
        "inactive": "Профилът Ви все още не е активиран.",
        "invalid": null,
        "last_attempt": "Имате още един опит преди акаунтът Ви да бъде заключен.",
        "locked": "Профилът Ви е заключен.",
        "not_found_in_database": null,
        "timeout": "Сесията Ви е изтекла, моля влезте отново, за да продължите.",
        "unauthenticated": "Преди да продължите, трябва да влезете в профила си или да се регистрирате.",
        "unconfirmed": "Преди да продължите, трябва да потвърдите регистрацията си."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Потвърждаване на профил",
          "greeting": "Добре дошли, %{recipient}!",
          "instruction": "Можете да потвърдите имейл адреса си чрез линка по-долу:",
          "subject": "Инструкции за потвърждаване"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Здравейте, %{recipient}!",
          "message": "Пишем Ви, за да Ви уведомим, че паролата Ви беше променена.",
          "subject": "Променена парола"
        },
        "reset_password_instructions": {
          "action": "Смяна на парола",
          "greeting": "Здравейте, %{recipient}!",
          "instruction": "Някой е поискал линк за промяна на паролата Ви. Можете да промените паролата си чрез линка по-долу.",
          "instruction_2": "В случай че не сте поискали промяна на паролата си, просто игнорирайте този имейл.",
          "instruction_3": "Паролата Ви няма да бъде променена, докато не използвате горния линк, за да създадете нова.",
          "subject": "Инструкции за промяна на парола"
        },
        "unlock_instructions": {
          "action": "Отключване на профил",
          "greeting": "Здравейте, %{recipient}!",
          "instruction": "Кликнете върху линка по-долу, за да отключите профила си:",
          "message": "Профилът Ви е заключен поради надвишаване на максималния позволен брой неуспешни опити за вход.",
          "subject": "Инструкции за отключване"
        }
      },
      "omniauth_callbacks": {
        "failure": "Не успяхме да ви оторизираме чрез %{kind}, защото %{reason}.",
        "success": "Успешна оторизация чрез %{kind} профил."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Промяна на паролата ми",
          "change_your_password": "Променете паролата си",
          "confirm_new_password": "Потвърждение на новата парола",
          "new_password": "Нова парола"
        },
        "new": {
          "forgot_your_password": "Забравена парола?",
          "send_me_reset_password_instructions": "Изпрати инструкции за промяна на парола"
        },
        "no_token": "Може да достъпвате тази страница само от имейл за промяна на паролата. Ако сте отворили тази страница от такъв имейл, уверете се, че използвате целия URL-адрес, който сме Ви изпратили.",
        "send_instructions": "Ще получите имейл с инструкции как да промените паролата си до няколко минути.",
        "send_paranoid_instructions": "Ако Вашият имейл адрес съществува в базата ни, ще получите инструкции за промяна на Вашата парола.",
        "updated": "Паролата Ви е променена успешно. Влязохте успешно в профила си.",
        "updated_not_active": "Паролата Ви е променена успешно."
      },
      "registrations": {
        "destroyed": "Довиждане! Вашият профил беше успешно изтрит. Надяваме се скоро да Ви видим отново.",
        "edit": {
          "are_you_sure": "Сигурни ли сте?",
          "cancel_my_account": "Закриване на профил",
          "currently_waiting_confirmation_for_email": "Очаква се потвърждение за: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "оставете празно, ако не искате да го променяте",
          "title": "Редакция на %{resource}",
          "unhappy": "Недоволни",
          "update": "Обновяване",
          "we_need_your_current_password_to_confirm_your_changes": "въведете настоящата си парола за потвърждаване на промените"
        },
        "new": {
          "sign_up": "Регистрация"
        },
        "signed_up": "Добре дошли! Вие се регистрирахте успешно.",
        "signed_up_but_inactive": "Регистирахте се успешно. Въпреки това, не можете да влезете в профила си, защото той все още не е активиран.",
        "signed_up_but_locked": "Регистрирахте се успешно. Въпреки това, не можете да влезете в профила си, защото той е заключен.",
        "signed_up_but_unconfirmed": "Писмо с линк за потвърждаване на профила Ви беше изпратено на вашия имейл адрес. Моля, отворете линка, за да активирате Вашия профил.",
        "update_needs_confirmation": "Обновихте профила си успешно, но трябва да проверим Вашия нов имейл адрес. Моля, проверете пощата си и отворете линка за потвърждаване на новия адрес.",
        "updated": "Обновихте профила си успешно.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Излязохте успешно.",
        "new": {
          "sign_in": "Вход"
        },
        "signed_in": "Влязохте успешно.",
        "signed_out": "Излязохте успешно."
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Не сте получили инструкции за потвърждаване?",
          "didn_t_receive_unlock_instructions": "Не сте получили инструкции за отключване?",
          "forgot_your_password": "Забравена парола?",
          "sign_in": "Вход",
          "sign_in_with_provider": "Вход с %{provider}",
          "sign_up": "Регистрация"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Повторно изпращане на инструкции за отключване"
        },
        "send_instructions": "Ще получите имейл с инструкции как да отключите профила си до няколко минути.",
        "send_paranoid_instructions": "Ако профилът Ви съществува в базата ни, ще получите имейл с инструкции за отключването му до няколко минути.",
        "unlocked": "Профилът Ви е отключен успешно. За да продължите, моля влезте."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "трябва да се потвърди",
        "already_confirmed": "е вече потвърден, моля опитайте да влезете в профила си",
        "blank": "не може да е без стойност",
        "confirmation": "не съответства на потвърждението",
        "confirmation_period_expired": "трябва да се потвърди в рамките на %{period}, моля направете нова заявка за потвърждаване",
        "empty": "не може да е празно",
        "equal_to": "трябва да има стойност, равна на %{count}",
        "even": "трябва да е нечетно",
        "exclusion": "съдържа предварително зададена стойност",
        "expired": "е изтекъл, моля заявете нов",
        "greater_than": "трябва да има стойност, по-голяма от %{count}",
        "greater_than_or_equal_to": "трябва да има стойност, по-голяма или равна на %{count}",
        "inclusion": "съдържа непредвидена стойност",
        "invalid": "съдържа невярна стойност",
        "less_than": "трябва да има стойност, по-малка от %{count}",
        "less_than_or_equal_to": "трябва да има стойност, по-малка или равна на %{count}",
        "not_a_number": "не е число",
        "not_an_integer": "не е цяло число",
        "not_found": "не е намерен",
        "not_locked": "не бе заключен",
        "not_saved": {
          "one": "Една грешка попречи този %{resource} да бъде записан:",
          "other": "%{count} грешки попречиха този %{resource} да бъде записан:"
        },
        "odd": "трябва да е четно",
        "taken": "вече съществува",
        "too_long": "е прекаленo дълго (не може да е повече от %{count} символа)",
        "too_short": "е прекалено късо (не може да бъде по-малко от %{count} символа)",
        "wrong_length": "е с грешна дължина (трябва да е с дължина, равна на %{count} символа)"
      },
      "template": {
        "body": "Възникнаха проблеми със следните полета:",
        "header": {
          "one": "%{model}: записът е неуспешен заради %{count} грешка",
          "other": "%{model}: записът е неуспешен заради %{count} грешки"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#",
          "##",
          "###"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Айтос",
          "Аксаково",
          "Алфатар",
          "Антоново",
          "Априлци",
          "Ардино",
          "Асеновград",
          "Ахелой",
          "Ахтопол",
          "Балчик",
          "Банкя",
          "Банско",
          "Баня",
          "Батак",
          "Батановци",
          "Белене",
          "Белица",
          "Белово",
          "Белоградчик",
          "Белослав",
          "Берковица",
          "Благоевград",
          "Бобов Дол",
          "Бобошево",
          "Божурище",
          "Бойчиновци",
          "Болярово",
          "Борово",
          "Ботевград",
          "Брацигово",
          "Брегово",
          "Брезник",
          "Брезово",
          "Брусарци",
          "Бургас",
          "Бухово",
          "Българово",
          "Бяла",
          "Бяла",
          "Бяла Слатина",
          "Бяла Черква",
          "Варна",
          "Велики Преслав",
          "Велико Търново",
          "Велинград",
          "Ветово",
          "Ветрен",
          "Видин",
          "Враца",
          "Вълчедръм",
          "Вълчи Дол",
          "Върбица",
          "Вършец",
          "Габрово",
          "Генерал Тошево",
          "Главиница",
          "Глоджево",
          "Годеч",
          "Горна Оряховица",
          "Гоце Делчев",
          "Грамада",
          "Гулянци",
          "Гурково",
          "Гълъбово",
          "Две Могили",
          "Дебелец",
          "Девин",
          "Девня",
          "Джебел",
          "Димитровград",
          "Димово",
          "Добринище",
          "Добрич",
          "Долна Баня",
          "Долна Митрополия",
          "Долна Оряховица",
          "Долни Дъбник",
          "Долни Чифлик",
          "Доспат",
          "Драгоман",
          "Дряново",
          "Дулово",
          "Дунавци",
          "Дупница",
          "Дългопол",
          "Елена",
          "Елин Пелин",
          "Елхово",
          "Етрополе",
          "Завет",
          "Земен",
          "Златарица",
          "Златица",
          "Златоград",
          "Ивайловград",
          "Игнатиево",
          "Искър",
          "Исперих",
          "Ихтиман",
          "Каблешково",
          "Каварна",
          "Казанлък",
          "Калофер",
          "Камено",
          "Каолиново",
          "Карлово",
          "Карнобат",
          "Каспичан",
          "Кермен",
          "Килифарево",
          "Китен",
          "Клисура",
          "Кнежа",
          "Козлодуй",
          "Койнаре",
          "Копривщица",
          "Костандово",
          "Костенец",
          "Костинброд",
          "Котел",
          "Кочериново",
          "Кресна",
          "Криводол",
          "Кричим",
          "Крумовград",
          "Крън",
          "Кубрат",
          "Куклен",
          "Кула",
          "Кърджали",
          "Кюстендил",
          "Левски",
          "Летница",
          "Ловеч",
          "Лозница",
          "Лом",
          "Луковит",
          "Лъки",
          "Любимец",
          "Лясковец",
          "Мадан",
          "Маджарово",
          "Малко Търново",
          "Мартен",
          "Мездра",
          "Мелник",
          "Меричлери",
          "Мизия",
          "Момин Проход",
          "Момчилград",
          "Монтана",
          "Мъглиж",
          "Неделино",
          "Несебър",
          "Николаево",
          "Никопол",
          "Нова Загора",
          "Нови Искър",
          "Нови Пазар",
          "Обзор",
          "Омуртаг",
          "Опака",
          "Оряхово",
          "Павел Баня",
          "Павликени",
          "Пазарджик",
          "Панагюрище",
          "Перник",
          "Перущица",
          "Петрич",
          "Пещера",
          "Пирдоп",
          "Плачковци",
          "Плевен",
          "Плиска",
          "Пловдив",
          "Полски Тръмбеш",
          "Поморие",
          "Попово",
          "Пордим",
          "Правец",
          "Приморско",
          "Провадия",
          "Първомай",
          "Раднево",
          "Радомир",
          "Разград",
          "Разлог",
          "Ракитово",
          "Раковски",
          "Рила",
          "Роман",
          "Рудозем",
          "Русе",
          "Садово",
          "Самоков",
          "Сандански",
          "Сапарева Баня",
          "Свети Влас",
          "Свиленград",
          "Свищов",
          "Своге",
          "Севлиево",
          "Сеново",
          "Септември",
          "Силистра",
          "Симеоновград",
          "Симитли",
          "Славяново",
          "Сливен",
          "Сливница",
          "Сливо Поле",
          "Смолян",
          "Смядово",
          "Созопол",
          "Сопот",
          "София",
          "Средец",
          "Стамболийски",
          "Стара Загора",
          "Стражица",
          "Стралджа",
          "Стрелча",
          "Суворово",
          "Сунгурларе",
          "Сухиндол",
          "Съединение",
          "Сърница",
          "Твърдица",
          "Тервел",
          "Тетевен",
          "Тополовград",
          "Троян",
          "Трън",
          "Тръстеник",
          "Трявна",
          "Тутракан",
          "Търговище",
          "Угърчин",
          "Хаджидимово",
          "Харманли",
          "Хасково",
          "Хисаря",
          "Цар Калоян",
          "Царево",
          "Чепеларе",
          "Червен Бряг",
          "Черноморец",
          "Чипровци",
          "Чирпан",
          "Шабла",
          "Шивачево",
          "Шипка",
          "Шумен",
          "Ябланица",
          "Якоруда",
          "Ямбол"
        ],
        "country": [
          "Австралия",
          "Австрия",
          "Азербайджан",
          "Аландски острови",
          "Албания",
          "Алжир",
          "Американска Самоа",
          "Американски Вирджински острови",
          "Англия",
          "Ангола",
          "Ангуила",
          "Андора",
          "Антарктика",
          "Антигуа и Барбуда",
          "Аржентина",
          "Армения",
          "Аруба",
          "Афганистан",
          "Бангладеш",
          "Барбадос",
          "Бахамски острови",
          "Бахрейн",
          "Беларус",
          "Белгия",
          "Белиз",
          "Бенин",
          "Бермудски острови",
          "Боливия",
          "Босна и Херцеговина",
          "Ботсвана",
          "Бразилия",
          "Британска територия в Индийския океан",
          "Британски Вирджински острови",
          "Бруней Даруссалам",
          "Бряг на слоновата кост Кот д'Ивоар",
          "Буве",
          "Буркина Фасо",
          "Бурунди",
          "Бутан",
          "България",
          "Вануату",
          "Ватикана",
          "Венецуела",
          "Виетнам",
          "Габон",
          "Гамбия",
          "Гана",
          "Гаяна",
          "Гваделупа",
          "Гватемала",
          "Гвинея",
          "Гвинея-Бисау",
          "Германия",
          "Гибралтар",
          "Гренада",
          "Гренландия",
          "Грузия",
          "Гуам",
          "Гърнси",
          "Гърция",
          "Дания",
          "Демократична република Конго Заир",
          "Джибути",
          "Джърси",
          "Доминика",
          "Доминиканска република",
          "Египет",
          "Еквадор",
          "Екваториална Гвинея",
          "Ел Салвадор",
          "Еритрея",
          "Естония",
          "Етиопия",
          "Замбия",
          "Западна Сахара",
          "Зимбабве",
          "Йемен",
          "Израел",
          "Източен Тимор",
          "Индия",
          "Индонезия",
          "Йордания",
          "Ирак",
          "Иран",
          "Ирландия",
          "Исландия",
          "Испания",
          "Италия",
          "Кабо Верде острови Зелени Нос",
          "Казахстан",
          "Каймански острови",
          "Камбоджа",
          "Камерун",
          "Канада",
          "Карибска Холандия",
          "Катар",
          "Кения",
          "Кипър",
          "Киргизстан",
          "Кирибати",
          "Китай",
          "Кокосови острови",
          "Коледни острови",
          "Колумбия",
          "Коморски острови",
          "Конго",
          "Коста Рика",
          "Куба",
          "Кувейт",
          "Кюрасао ç",
          "Лаос",
          "Латвия",
          "Лесото",
          "Либерия",
          "Либия",
          "Ливан",
          "Литва",
          "Лихтенщайн",
          "Люксембург",
          "Мавритания",
          "Мавриций",
          "Мадагаскар",
          "Майот",
          "Макао",
          "Македония",
          "Малави",
          "Малайзия",
          "Малдиви",
          "Мали",
          "Малта",
          "Ман остров",
          "Мароко",
          "Мартиника",
          "Маршалови острови",
          "Мексико",
          "Мианмар",
          "Микронезия",
          "Мозамбик",
          "Молдова",
          "Монако",
          "Монголия",
          "Монсерат",
          "Намибия",
          "Науру",
          "Непал",
          "Нигер",
          "Нигерия",
          "Никарагуа",
          "Ниуе",
          "Нова Зеландия",
          "Нова Каледония",
          "Норвегия",
          "Норфолк остров",
          "Обединени арабски емирства",
          "Оман",
          "Острови Кук",
          "Острови Хърд и Макдоналд",
          "Пакистан",
          "Палау",
          "Палестина",
          "Панама",
          "Папуа Нова Гвинея",
          "Парагвай",
          "Перу",
          "Питкерн",
          "Полша",
          "Португалия",
          "Пуерто Рико",
          "Реюнион",
          "Руанда",
          "Румъния",
          "Русия",
          "Самоа",
          "Сан марино",
          "Сао Томе и Принсипи",
          "Саудитска Арабия",
          "САЩ",
          "Свазиленд",
          "Свалбард и Ян Майен",
          "Света Елена остров",
          "Северна Корея",
          "Северни Мариански острови",
          "Сейнт Бартс",
          "Сейнт Винсент и Гренадини",
          "Сейнт Китс и Невис",
          "Сейнт Лусия",
          "Сейшели",
          "Сен Мартен Франция",
          "Сен Пиер и Микелон",
          "Сенегал",
          "Сиера Леоне",
          "Сингапур",
          "Синт Мартен Холандия",
          "Сирия",
          "Словакия",
          "Словения",
          "Соломонови острови",
          "Сомалия",
          "Судан",
          "Суринам",
          "Сърбия",
          "Таджикистан",
          "Тайван",
          "Тайланд",
          "Танзания",
          "Того",
          "Токелау",
          "Тонга",
          "Тринидад и Тобаго",
          "Тувалу",
          "Тунис",
          "Туркменистан",
          "Турция",
          "Търкс и Кайкос",
          "Уганда",
          "Узбекистан",
          "Украйна",
          "Унгария",
          "Уолис и Футуна",
          "Уругвай",
          "Фарьорски острови",
          "Фиджи",
          "Филипини",
          "Финландия",
          "Фолкландски острови",
          "Франция",
          "Френска Полинезия",
          "Френски южни и антарктически територии",
          "Фреска Гвиана",
          "Хаити",
          "Холандия",
          "Хондурас",
          "Хонконг",
          "Хърватска",
          "Централноафриканска република",
          "Чад",
          "Черна гора",
          "Чехия",
          "Чили",
          "Швейцария",
          "Швеция",
          "Шри Ланка",
          "ЮАР",
          "Южен Судан",
          "Южна Джорджия и Южни Сандвичеви острови",
          "Южна Корея",
          "Ямайка",
          "Япония"
        ],
        "default_country": [
          "България"
        ],
        "default_country_code": [
          "BG"
        ],
        "postcode": [
          "####"
        ],
        "street_address": [
          "#{street_name}, #{building_number}"
        ],
        "street_name": [
          "#{street_suffix} #{street_title}"
        ],
        "street_suffix": [
          "ул.",
          "улица",
          "площад",
          "пл.",
          "булевард",
          "бул."
        ],
        "street_title": [
          "България",
          "Демокрация",
          "Патриарх Евтимий",
          "Опълченска",
          "Княз Борис",
          "Народно събрание",
          "Симеон Велики",
          "Лъчезар Станчев",
          "Г.М Димитров",
          "Мария Габровска",
          "Оборище",
          "Иван Вазов",
          "Бъднина",
          "Орлинска",
          "Николавеска",
          "Цар Петър",
          "Будапеща",
          "Чехов",
          "Три Уши",
          "Вила",
          "Първи Май",
          "Тотлебен",
          "Симеоновско Шосе",
          "Васил Левски",
          "Черни Връх",
          "Йерусалим",
          "Акация",
          "Самодива",
          "Георги Аспарухов",
          "Иван Шишман",
          "Славейков",
          "Македония",
          "Христо Ботев",
          "Руски Паметник",
          "Обзор",
          "Свети Климент Охридски",
          "Дъбница",
          "Айдемир",
          "Професор Марко Семов",
          "Баку",
          "Никола Габровски",
          "8 декември",
          "Джон Ленън",
          "Професор Кирил Попов",
          "Петър Попов",
          "Чавдар Мутафов",
          "Могилата",
          "Филип Кутев",
          "Сребърна",
          "Козяк",
          "Емилиян Станев",
          "Хенрик Ибсен",
          "Бадемова Гора",
          "Петко Тодоров",
          "Тодор Каблешков",
          "Пирин",
          "Казбек",
          "Света Марина",
          "Приррода",
          "Люляк",
          "Лелинска Чука",
          "Пчела",
          "Белмекен",
          "Мусала",
          "Вихрен",
          "Будилник",
          "Горица",
          "Европа",
          "Любляна",
          "Брюксел",
          "Ливада",
          "Букет",
          "Нов Век",
          "Чуката",
          "Кустут",
          "Овча Купел",
          "Войводина Могила",
          "Народно хоро",
          "Камелия",
          "Маестро Кънев",
          "Петя Дубарова",
          "Промишлена",
          "Джеймс Баучер",
          "Гайтанци"
        ]
      },
      "cell_phone": {
        "formats": [
          "088#######",
          "087#######",
          "089#######"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "bg",
          "info",
          "бг",
          "net",
          "org"
        ]
      },
      "name": {
        "female_first_name": [
          "Мария",
          "Иванка",
          "Елена",
          "Йорданка",
          "Пенка",
          "Маргарита",
          "Виолета",
          "Лиляна",
          "Цветанка",
          "Радка",
          "Надежда",
          "Марийка",
          "Румяна",
          "Тодорка",
          "Стефка",
          "Стоянка",
          "Василка",
          "Росица",
          "Станка",
          "Емилия",
          "Донка",
          "Милка",
          "Величка",
          "Райна",
          "Анка",
          "Красимира",
          "Снежана",
          "Мариана",
          "Валентина",
          "Янка",
          "Христина",
          "Катя",
          "Николина",
          "Даниела",
          "Татяна",
          "Светла",
          "Галина",
          "Златка",
          "Лилия",
          "Екатерина",
          "Цветана",
          "Недялка",
          "Диана",
          "Антоанета",
          "Павлина",
          "Анна",
          "Веселина",
          "Славка",
          "Марияна",
          "Юлия"
        ],
        "female_last_name": [
          "Иванова",
          "Георгиева",
          "Димитрова",
          "Петрова",
          "Николова",
          "Стоянова",
          "Христова",
          "Тодорова",
          "Илиева",
          "Василева",
          "Атанасова",
          "Петкова",
          "Ангелова",
          "Колева",
          "Йорданова",
          "Маринова",
          "Стефанова",
          "Попова",
          "Михайлова",
          "Кръстева",
          "Костова",
          "Димова",
          "Павлова",
          "Костадинова",
          "Митева",
          "Симеонова",
          "цветкова",
          "Александрова",
          "Маркова",
          "Спасова",
          "Лазарова",
          "Добрева",
          "Младенова",
          "Андреева",
          "Янева",
          "Радева",
          "Русева",
          "Янкова",
          "Пенева",
          "Вълчева",
          "Григорова",
          "Кирова",
          "Найденова",
          "Станчева",
          "Алексиева",
          "Стойчева",
          "Борисова",
          "Славова",
          "Станева",
          "Панайотова"
        ],
        "female_middle_name": [
          "Александрова",
          "Адрианова",
          "Ангелова",
          "Аспарухова",
          "Алексиева",
          "Марианов",
          "Бисерова",
          "Благовестова",
          "Боримирова",
          "Викториева",
          "Владимирова",
          "Валентинова",
          "Венциславова",
          "Георгиева",
          "Григорова",
          "Грозданова",
          "Димитрова",
          "Даниелова",
          "Денисова",
          "Дамянова",
          "Добромирова",
          "Евгениева",
          "Петрова",
          "Иванова",
          "Павлова"
        ],
        "first_name": [
          "#{male_first_name}",
          "#{female_first_name}"
        ],
        "male_first_name": [
          "Александър",
          "Антонио",
          "Адриан",
          "Ангел",
          "Аспарух",
          "Алекси",
          "Борислав",
          "Борис",
          "Бойко",
          "Бисер",
          "Благовест",
          "Боримир",
          "Виктор",
          "Владимир",
          "Владислав",
          "Валентин",
          "Валери",
          "Венцислав",
          "Героги",
          "Григор",
          "Гроздан",
          "Геро",
          "Димитър",
          "Даниел",
          "Денис",
          "Денислав",
          "Дамян",
          "Добромир",
          "Динко",
          "Добрин",
          "Евгени",
          "Емил",
          "Евтим",
          "Евстати",
          "Еленко",
          "Живко",
          "Желязко",
          "Жельо",
          "Здравко",
          "Захари",
          "Златомир",
          "Звездомир",
          "Ивам. Илиян",
          "Илия",
          "Ивелин",
          "Игор",
          "Йордан",
          "Йосиф",
          "Йонко",
          "Кристиян",
          "Калоян",
          "Крис",
          "Красимир",
          "Камен",
          "Кирил",
          "Крум",
          "Кубрат",
          "Кристоф",
          "Любомир",
          "Лъчезар",
          "Лазар",
          "Мартин",
          "Максим",
          "Мирослав",
          "Максимилиан",
          "Матей",
          "Мариан",
          "Милко",
          "Николай",
          "Недялко",
          "Никофор",
          "Нестор",
          "Огнян",
          "Орлин",
          "Пламен",
          "Пресиан",
          "Пеко",
          "Петър",
          "Павел",
          "Радослав",
          "Росен",
          "Румен",
          "Самуил",
          "Симеон",
          "Станислав",
          "Спас",
          "Спиридон",
          "Теодор",
          "Тони",
          "Тома",
          "Тихомир",
          "Филип",
          "Христо",
          "Христослав",
          "Христиан",
          "Цеко",
          "Цветан",
          "Цветелин",
          "Чавдар",
          "Чочо",
          "Щилян",
          "Юлиан",
          "Юри",
          "Явор",
          "Ясен",
          "Янис",
          "Янко"
        ],
        "male_last_name": [
          "Иванов",
          "Георгиев",
          "Димитров",
          "Петров",
          "Николов",
          "Христов",
          "Стоянов",
          "Тодоров",
          "Илиев",
          "Василев",
          "Атанасов",
          "Петков",
          "Янгелов",
          "Колев",
          "Йорданов",
          "Маринов",
          "Стефанов",
          "Попов",
          "Михайлов",
          "Кръстев",
          "Костов",
          "Димов",
          "Костадинов",
          "Павлов",
          "Митев",
          "Симеонов",
          "Цветков",
          "Александров",
          "Марков",
          "Спасов",
          "Лазаров",
          "Добрев",
          "Андреев",
          "Младенов",
          "Русев",
          "Вълчев",
          "Радев",
          "Янев",
          "Найденов",
          "Пенев",
          "Янков",
          "Станчев",
          "Стойчев",
          "Славов",
          "Григоров",
          "Киров",
          "Алексиев",
          "Станев",
          "Стойков",
          "Борисов"
        ],
        "male_middle_name": [
          "Александров",
          "Адрианов",
          "Ангелов",
          "Аспарухов",
          "Алексиев",
          "Бориславов",
          "Бисеров",
          "Благовестов",
          "Боримиров",
          "Викторов",
          "Владимиров",
          "Владиславов",
          "Валентинов",
          "Венциславов",
          "Георгиев",
          "Григоров",
          "Грозданов",
          "Димитров",
          "Даниелов",
          "Денисов",
          "Дениславов",
          "Дамянов",
          "Добромиров",
          "Евгениев",
          "Петров",
          "Иванов",
          "Павлов"
        ],
        "name": [
          "#{male_first_name} #{male_last_name}",
          "#{male_last_name} #{male_first_name}",
          "#{male_first_name} #{male_middle_name} #{male_last_name}",
          "#{male_last_name} #{male_first_name} #{male_middle_name}",
          "#{female_first_name} #{female_last_name}",
          "#{female_last_name} #{female_first_name}",
          "#{female_first_name} #{female_middle_name} #{female_last_name}",
          "#{female_last_name} #{female_first_name} #{female_middle_name}"
        ]
      },
      "separator": " и "
    },
    "helpers": {
      "select": {
        "prompt": "Моля отбележете"
      },
      "submit": {
        "create": "Създай %{model}",
        "submit": "Запази %{model}",
        "update": "Обнови %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "А": "A",
          "Б": "B",
          "В": "V",
          "Г": "G",
          "Д": "D",
          "Е": "E",
          "Ж": "Zh",
          "З": "Z",
          "И": "I",
          "Й": "Y",
          "К": "K",
          "Л": "L",
          "М": "M",
          "Н": "N",
          "О": "O",
          "П": "P",
          "Р": "R",
          "С": "S",
          "Т": "T",
          "У": "U",
          "Ф": "F",
          "Х": "H",
          "Ц": "Ts",
          "Ч": "Ch",
          "Ш": "Sh",
          "Щ": "Sht",
          "Ъ": "A",
          "Ь": "Y",
          "Ю": "Yu",
          "Я": "Ya",
          "а": "a",
          "б": "b",
          "в": "v",
          "г": "g",
          "д": "d",
          "е": "e",
          "ж": "zh",
          "з": "z",
          "и": "i",
          "й": "y",
          "к": "k",
          "л": "l",
          "м": "m",
          "н": "n",
          "о": "o",
          "п": "p",
          "р": "r",
          "с": "s",
          "т": "t",
          "у": "u",
          "ф": "f",
          "х": "h",
          "ц": "ts",
          "ч": "ch",
          "ш": "sh",
          "щ": "sht",
          "ъ": "a",
          "ь": "y",
          "ю": "yu",
          "я": "ya"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "лв."
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "милиарда",
            "million": "милиона",
            "quadrillion": "квадрилиона",
            "thousand": "хиляди",
            "trillion": "трилиона",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Байт",
              "other": "Байта"
            },
            "gb": "ГБ",
            "kb": "КБ",
            "mb": "МБ",
            "tb": "ТБ"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " и ",
        "two_words_connector": " и ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "преди обяд",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "следобед"
    }
  },
  "bn": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "কনফার্মেশন পাঠানোর সময়",
          "confirmation_token": "কনফার্মেশন টোকেন",
          "confirmed_at": "কনফার্মেশন সময়",
          "created_at": "তৈরীর সময়",
          "current_password": "বর্তমান পাসওয়ার্ড",
          "current_sign_in_at": "বর্তমান সাইন ইন সময়",
          "current_sign_in_ip": "বর্তমান সাইন ইন আইপি",
          "email": "ইমেইল",
          "encrypted_password": "এনক্রিপ্টেড পাসওয়ার্ড",
          "failed_attempts": "ব্যর্থ চেষ্টা",
          "last_sign_in_at": "শেষ সাইন ইন সময়",
          "last_sign_in_ip": "শেষ সাইন ইন আইপি",
          "locked_at": "লক সময়",
          "password": "পাসওয়ার্ড",
          "password_confirmation": "পাসওয়ার্ড নিশ্চিতকরণ",
          "remember_created_at": "মনে রাখার সময়",
          "remember_me": "মনে রাখুন",
          "reset_password_sent_at": "পাসওয়ার্ড পুনরুদ্ধার পাঠানোর সময়",
          "reset_password_token": "পাসওয়ার্ড পুনরুদ্ধার টোকেন",
          "sign_in_count": "সাইন ইন সংখ্যা",
          "unconfirmed_email": "অনিশ্চিত ইমেইল",
          "unlock_token": "আনলক টোকেন",
          "updated_at": "আপডেটেড সময়"
        }
      },
      "models": {
        "user": {
          "one": "ব্যবহারকারী",
          "other": "ব্যবহারকারী"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "রবিবার",
        "সোমবার",
        "মঙ্গলবার",
        "বুধবার",
        "বৃহস্পতিবার",
        "শুক্রবার",
        "শনিবার"
      ],
      "abbr_month_names": [
        null,
        "জানুয়ারি",
        "ফেব্রুয়ারি",
        "মার্চ",
        "এপ্রিল",
        "মে",
        "জুন",
        "জুলাই",
        "আগস্ট",
        "সেপ্টেম্বর",
        "অক্টোবর",
        "নভেম্বর",
        "ডিসেম্বর"
      ],
      "day_names": [
        "রবিবার",
        "সোমবার",
        "মঙ্গলবার",
        "বুধবার",
        "বৃহস্পতিবার",
        "শুক্রবার",
        "শনিবার"
      ],
      "formats": {
        "default": "%e/%m/%Y",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "জানুয়ারি",
        "ফেব্রুয়ারি",
        "মার্চ",
        "এপ্রিল",
        "মে",
        "জুন",
        "জুলাই",
        "আগস্ট",
        "সেপ্টেম্বর",
        "অক্টোবর",
        "নভেম্বর",
        "ডিসেম্বর"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "প্রায় ১ ঘণ্টা",
          "other": "প্রায় %{count} ঘণ্টা"
        },
        "about_x_months": {
          "one": "প্রায় ১ মাস",
          "other": "প্রায় %{count} মাস"
        },
        "about_x_years": {
          "one": "প্রায় ১ বছর",
          "other": "প্রায় %{count} বছর"
        },
        "almost_x_years": {
          "one": "প্রায় ১ বছর",
          "other": "প্রায় %{count} বছর"
        },
        "half_a_minute": "অর্ধ মিনিট",
        "less_than_x_minutes": {
          "one": "১ মিনিটের কম",
          "other": "%{count} মিনিটের কম"
        },
        "less_than_x_seconds": {
          "one": "১ সেকেন্ডর কম",
          "other": "%{count} সেকেন্ডের কম"
        },
        "over_x_years": {
          "one": "১ বছরের বেশি",
          "other": "%{count} বছরের বেশি"
        },
        "x_days": {
          "one": "১ দিন",
          "other": "%{count} দিন"
        },
        "x_minutes": {
          "one": "১ মিনিট",
          "other": "%{count} মিনিট"
        },
        "x_months": {
          "one": "১ মাস",
          "other": "%{count} মাস"
        },
        "x_seconds": {
          "one": "১ সেকেন্ড",
          "other": "%{count} সেকেন্ড"
        }
      },
      "prompts": {
        "day": "দিন",
        "hour": "ঘণ্টা",
        "minute": "মিনিট",
        "month": "মাস",
        "second": "সেকেন্ড",
        "year": "বছর"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "আপনার ইমেল ঠিকানা সফলভাবে নিশ্চিত করা হয়েছে।",
        "new": {
          "resend_confirmation_instructions": null
        },
        "send_instructions": "আপনি কয়েক মিনিটের মধ্যে আপনার ইমেল ঠিকানা নিশ্চিত করার জন্যে নির্দেশাবলী সহ একটি ইমেল পাবেন।",
        "send_paranoid_instructions": "আপনার ইমেল ঠিকানা আমাদের ডাটাবেসের মধ্যে উপস্থিত থাকলে, আপনি কয়েক মিনিটের মধ্যে আপনার ইমেল ঠিকানা নিশ্চিত করার জন্যে নির্দেশাবলী সহ একটি ইমেল পাবেন।"
      },
      "failure": {
        "already_authenticated": "আপনি ইতিমধ্যে সাইন ইন করেছেন।",
        "inactive": "আপনার অ্যাকাউন্ট এখনো সক্রিয় হয়নি।",
        "invalid": null,
        "last_attempt": "আপনার অ্যাকাউন্ট লক হওয়ার আগে আপনার আরও একটি চেষ্টা বাকি আছে।",
        "locked": "আপনার অ্যাকাউন্ট লক করা আছে।",
        "not_found_in_database": null,
        "timeout": "আপনার অধিবেশনের মেয়াদ শেষ. অব্যাহত রাখার জন্য আবার সাইন ইন করুন.",
        "unauthenticated": "আপনি চালিয়ে যাওয়ার আগে আপনার সাইন ইন বা সাইন আপ করতে হবে।",
        "unconfirmed": "আপনি চালিয়ে যাওয়ার আগে আপনার ইমেল ঠিকানা নিশ্চিত করতে হবে।"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "নিশ্চিতকরণ নির্দেশাবলী পাঠান",
          "greeting": "স্বাগতম %{recipient}!",
          "instruction": "আপনার ইমেল ঠিকানা নিশ্চিত করার জন্য নিম্নলিখিত লিঙ্কটি ক্লিক করুন:",
          "subject": "নিশ্চিতকরণ নির্দেশাবলী"
        },
        "email_changed": {
          "greeting": "স্বাগতম %{recipient}!",
          "message": "আমরা আপনাকে জানাতে চাচ্ছি যে আপনার ইমেল ঠিকানা পরিবর্তন হয়েছে এবং এটি এখন থেকে %{email} হয়েছে।",
          "message_unconfirmed": "আমরা আপনাকে জানাতে চাচ্ছি যে আপনার ইমেল ঠিকানা পরিবর্তন হয়েছে এবং এটি এখন থেকে %{email} হয়েছে।",
          "subject": "ইমেল পরিবর্তন হয়েছে"
        },
        "password_change": {
          "greeting": "স্বাগতম %{recipient}!",
          "message": "আমরা আপনাকে জানাতে চাচ্ছি যে আপনার পাসওয়ার্ড পরিবর্তন হয়েছে।",
          "subject": "পাসওয়ার্ড পরিবর্তন হয়েছে"
        },
        "reset_password_instructions": {
          "action": "আমার পাসওয়ার্ড পুনরুদ্ধার করুন",
          "greeting": "স্বাগতম %{recipient}!",
          "instruction": "আপনার পাসওয়ার্ড পুনরুদ্ধার করার জন্য নিম্নলিখিত লিঙ্কটি ক্লিক করুন:",
          "instruction_2": "আপনি যদি পাসওয়ার্ড পুনরুদ্ধার করার অনুরোধ না করে থাকেন, তবে আর কিছু করার দরকার নেই।",
          "instruction_3": "আপনার পাসওয়ার্ড পরিবর্তন কেবল লিংকে ক্লিক করে তা পরিবর্তনের মাধ্যমে সম্পন্ন হবে।",
          "subject": "পাসওয়ার্ড রিসেট করার নির্দেশাবলী"
        },
        "unlock_instructions": {
          "action": "আমার একাউন্ট আনলক করুন",
          "greeting": "স্বাগতম %{recipient}!",
          "instruction": "আপনার একাউন্ট আনলক করার জন্য নিম্নলিখিত লিঙ্কটি ক্লিক করুন:",
          "message": "আমরা আপনাকে জানাতে চাচ্ছি যে আপনার একাউন্ট লক করা হয়েছে অনেক বেশি ব্যর্থ চেষ্টা করার কারণে।",
          "subject": "আনলক করার নির্দেশাবলী"
        }
      },
      "omniauth_callbacks": {
        "failure": "আপনি %{kind} থেকে এসেছেন, এটি প্রমান করা যায়নি কারন \"%{reason}\".",
        "success": "আপনার %{kind} থেকে আসা নিশ্চিত হয়েছে।"
      },
      "passwords": {
        "edit": {
          "change_my_password": "আমার পাসওয়ার্ড পরিবর্তন করুন",
          "change_your_password": "আপনার পাসওয়ার্ড পরিবর্তন করুন",
          "confirm_new_password": "নতুন পাসওয়ার্ড নিশ্চিত করুন",
          "new_password": "নতুন পাসওয়ার্ড"
        },
        "new": {
          "forgot_your_password": "আপনি পাসওয়ার্ড ভুলে গেছেন?",
          "send_me_reset_password_instructions": "আমাকে পাসওয়ার্ড পুনরুদ্ধার নির্দেশাবলী পাঠান"
        },
        "no_token": "আপনি পাসওয়ার্ড রিসেট ইমেইল থেকে আসা ছাড়া এই পৃষ্ঠায় প্রবেশ করতে পারবেন না। আপনি যদি পাসওয়ার্ড রিসেট ইমেইল থেকে এসে থাকেন, তাহলে নিশ্চিত করুন যে আপনি সম্পুর্ণ লিঙ্ক ব্যবহার করেছেন।",
        "send_instructions": "আপনি কয়েক মিনিটের মধ্যে আপনার পাসওয়ার্ড পুনরুদ্ধার নির্দেশাবলী সহ একটি ইমেল পাবেন।",
        "send_paranoid_instructions": "আপনার ইমেল ঠিকানা আমাদের ডাটাবেসের মধ্যে উপস্থিত থাকলে, আপনি কয়েক মিনিটের মধ্যে আপনার ইমেইল ঠিকানায় একটি পাসওয়ার্ড পুনরুদ্ধার লিঙ্ক পাবেন।",
        "updated": "আপনার পাসওয়ার্ড সফলভাবে পরিবর্তন করা হয়েছে. আপনি এখন সাইন ইন করেছেন।",
        "updated_not_active": "আপনার পাসওয়ার্ড সফলভাবে পরিবর্তন করা হয়েছে।"
      },
      "registrations": {
        "destroyed": "বিদায়! আপনার অ্যাকাউন্ট সফলভাবে বাতিল করা হয়েছে. আশা করি শীঘ্রই আপনি আবার আসবেন।",
        "edit": {
          "are_you_sure": "আপনি কি নিশ্চিত?",
          "cancel_my_account": "আমার অ্যাকাউন্ট বাতিল করুন",
          "currently_waiting_confirmation_for_email": "%{email} এর জন্য নিশ্চিতকরণ অপেক্ষা করছেন।",
          "leave_blank_if_you_don_t_want_to_change_it": "আপনি যদি এটি পরিবর্তন করতে না চান তাহলে খালি রাখুন।",
          "title": "%{resource} সম্পাদনা করুন",
          "unhappy": "অসন্তুষ্ট?",
          "update": "আপডেট করুন",
          "we_need_your_current_password_to_confirm_your_changes": "আপনার পরিবর্তন নিশ্চিত করতে আমাদের আপনার বর্তমান পাসওয়ার্ড দরকার।"
        },
        "new": {
          "sign_up": "সাইন আপ করুন"
        },
        "signed_up": "স্বাগতম! আপনি সফলভাবে সাইন আপ করেছেন।",
        "signed_up_but_inactive": "আপনি সফলভাবে সাইন আপ করেছেন। যদিও আপনার অ্যাকাউন্ট এখনো সক্রিয় না হওয়ায়, আপনি সাইন ইন করতে পারবেন না।",
        "signed_up_but_locked": "আপনি সফলভাবে সাইন আপ করেছেন। যদিও আপনার অ্যাকাউন্ট লক থাকায় আপনি সাইন ইন করতে পারবেন না।",
        "signed_up_but_unconfirmed": "একটি নিশ্চিতকরণ লিঙ্ক সহ একটি বার্তা আপনার ইমেইল ঠিকানায় পাঠানো হয়েছে। আপনার অ্যাকাউন্ট সক্রিয় করার জন্য লিঙ্ক অনুসরণ করুন।",
        "update_needs_confirmation": "আপনি সফলভাবে আপনার একাউন্ট আপডেট করেছেন, কিন্তু আপনার নতুন ইমেইল ঠিকানা যাচাই করতে হবে. আপনার ইমেইল চেক করুন এবং আপনার নতুন ইমেইল ঠিকানা যাচাই করতে নিশ্চিতকরন লিঙ্কটি অনুসরণ করুন।",
        "updated": "আপনার অ্যাকাউন্ট সফলভাবে আপডেট করা হয়েছে।",
        "updated_but_not_signed_in": "আপনার অ্যাকাউন্ট সফলভাবে আপডেট হয়েছে, তবে আপনার পাসওয়ার্ড যেহেতু পরিবর্তন হয়েছে, আপনার আবার সাইন ইন করতে হবে।"
      },
      "sessions": {
        "already_signed_out": "সফলভাবে সাইন আউট করেছেন।",
        "new": {
          "sign_in": "লগইন করুন"
        },
        "signed_in": "সফলভাবে সাইন ইন করেছেন।",
        "signed_out": "সফলভাবে সাইন আউট করেছেন।"
      },
      "shared": {
        "links": {
          "back": "ফিরে যান",
          "didn_t_receive_confirmation_instructions": "কনফার্মেশন নির্দেশাবলী পাননি?",
          "didn_t_receive_unlock_instructions": "আনলক নির্দেশাবলী পাননি?",
          "forgot_your_password": "আপনি পাসওয়ার্ড ভুলে গেছেন?",
          "sign_in": "লগইন করুন",
          "sign_in_with_provider": "%{provider} দিয়ে সাইন ইন করুন",
          "sign_up": "সাইন আপ করুন"
        },
        "minimum_password_length": {
          "one": "(%{count} অক্ষর সর্বনিম্ন)",
          "other": "(%{count} অক্ষর সর্বনিম্ন)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": null
        },
        "send_instructions": "আপনি কয়েক মিনিটের মধ্যে আপনার অ্যাকাউন্ট আনলক করার জন্যে নির্দেশাবলী সহ একটি ইমেল পাবেন।",
        "send_paranoid_instructions": "আপনার অ্যাকাউন্ট উপস্থিত থাকলে, আপনি কয়েক মিনিটের মধ্যে এটি আনলক করার জন্যে নির্দেশাবলী সহ একটি ইমেল পাবেন।",
        "unlocked": "আপনার অ্যাকাউন্ট সফলভাবে উদ্ঘাটিত হয়েছে। চালিয়ে যাওয়ার জন্য সাইন ইন করুন।"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "গ্রাহ্য করতে হবে",
        "already_confirmed": "ইতিমধ্যে নিশ্চিত হয়েছে, সাইন ইন করার চেষ্টা করুন",
        "blank": "ফাঁকা রাখা যাবে না",
        "confirmation": "অনুমোদনের সঙ্গে মিলছে না",
        "confirmation_period_expired": "%{period}এর মধ্যে নিশ্চিত করা প্রয়োজন, একটি নতুন অনুরোধ করুন",
        "empty": "খালি রাখা যাবে না",
        "equal_to": "%{count} এর সঙ্গে সমান হতে হবে",
        "even": "জোড় হতে হবে",
        "exclusion": "রিসার্ভ করা আছে",
        "expired": "মেয়াদ শেষ হয়ে গেছে, একটি নতুন অনুরোধ করুন",
        "greater_than": "%{count} থেকে বড় হতে হবে",
        "greater_than_or_equal_to": "%{count} থেকে বড় অথবা তার সমান হতে হবে",
        "inclusion": "তালিকায় অন্তর্ভুক্ত নয়",
        "invalid": "সঠিক নয়",
        "less_than": "%{count} থেকে ছোটো হতে হবে",
        "less_than_or_equal_to": "%{count} থেকে ছোটো অথবা তার সমান হতে হবে",
        "not_a_number": "নম্বর নয়",
        "not_found": "খুঁজে পাওয়া যায় নি",
        "not_locked": "লক করা ছিল না",
        "not_saved": {
          "one": "১ টি ভুলের কারনে এই %{resource} কে সংরক্ষিণ করা যাচ্ছে না:",
          "other": "%{count} টি ভুলের কারনে এই %{resource} কে সংরক্ষণ করা যাচ্ছে না:"
        },
        "odd": "বেজোড় হতে হবে",
        "taken": "আগেই নিয়ে নেওয়া হয়েছে",
        "too_long": "খুব বড়ো (সর্বোচ্চ %{count} অক্ষর)",
        "too_short": "খুব ছোটো (সর্বনিম্ন %{count} অক্ষর)",
        "wrong_length": "দৈর্ঘ্যটি সঠিক নয় (%{count} অক্ষর হতে হবে)"
      },
      "template": {
        "body": "এই ফিল্ডগুলোতে কিছু সমস্যা দেখা দিয়েছে:",
        "header": {
          "one": "১টি ত্রুটির কারণে %{model} সংরক্ষণ করা সম্ভব হয়নি",
          "other": "%{count}টি ত্রুটির কারণে %{model} সংরক্ষণ করা সম্ভব হয়নি"
        }
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "৳"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "বাইট",
              "other": "বাইট"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", এবং ",
        "two_words_connector": " এবং ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %e %B %Y %H:%M:%S %z",
        "long": "%e %B %Y %H:%M",
        "short": "%e %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "bs": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": null,
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": null,
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": null,
          "password_confirmation": null,
          "remember_created_at": null,
          "remember_me": null,
          "reset_password_sent_at": null,
          "reset_password_token": null,
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": null,
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validacija nije uspjela: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Nije moguće izbrisati zapis jer postoje ovisni %{record}",
            "has_one": "Nije moguće izbrisati zapis jer postoji ovisan %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ned",
        "pon",
        "uto",
        "sri",
        "čet",
        "pet",
        "sub"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "četvrtak",
        "petak",
        "subota"
      ],
      "formats": {
        "default": "%d.%m.%Y.",
        "long": "%e. %B %Y.",
        "short": "%e. %b. %Y."
      },
      "month_names": [
        null,
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "oko %{count} sata",
          "many": "oko %{count} sati",
          "one": "oko sat",
          "other": "oko %{count} sati"
        },
        "about_x_months": {
          "few": "oko %{count} mjeseca",
          "many": "oko %{count} mjeseci",
          "one": "oko mjesec",
          "other": "oko %{count} mjeseci"
        },
        "about_x_years": {
          "few": "oko %{count} godine",
          "many": "oko %{count} godina",
          "one": "oko godine",
          "other": "oko %{count} godina"
        },
        "almost_x_years": {
          "few": "skoro %{count} godine",
          "many": "skoro %{count} godina",
          "one": "skoro %{count} godina",
          "other": "skoro %{count} godina"
        },
        "half_a_minute": "pola minute",
        "less_than_x_minutes": {
          "few": "manje od %{count} minute",
          "many": "manje od %{count} minuta",
          "one": "manje od minute",
          "other": "manje od %{count} minuta"
        },
        "less_than_x_seconds": {
          "few": "manje od %{count} sekunde",
          "many": "manje od %{count} sekundi",
          "one": "manje od sekunde",
          "other": "manje od %{count} sekundi"
        },
        "over_x_years": {
          "few": "preko %{count} godine",
          "many": "preko %{count} godina",
          "one": "preko godine",
          "other": "preko %{count} godina"
        },
        "x_days": {
          "few": "%{count} dana",
          "many": "%{count} dana",
          "one": "%{count} dan",
          "other": "%{count} dana"
        },
        "x_minutes": {
          "few": "%{count} minute",
          "many": "%{count} minuta",
          "one": "%{count} minut",
          "other": "%{count} minuta"
        },
        "x_months": {
          "few": "%{count} mjeseca",
          "many": "%{count} mjeseci",
          "one": "%{count} mjesec",
          "other": "%{count} mjeseci"
        },
        "x_seconds": {
          "few": "%{count} sekunde",
          "many": "%{count} sekundi",
          "one": "%{count} sekund",
          "other": "%{count} sekundi"
        }
      },
      "prompts": {
        "day": "dan",
        "hour": "sat",
        "minute": "minut",
        "month": "mjesec",
        "second": "sekundi",
        "year": "godina"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Vaš račun je potvrđen.",
        "new": {
          "resend_confirmation_instructions": null
        },
        "send_instructions": "U roku nekoliko minuta ćete primiti e-mail s uputama za potvrdu Vašeg računa.",
        "send_paranoid_instructions": "Ukoliko se Vaša email adresa nalazi u našoj bazi u roku od nekoliko minuta ćete primiti e-mail s uputama kako potvrditi Vaš račun."
      },
      "failure": {
        "already_authenticated": "Već ste prijavljeni.",
        "inactive": "Vaš račun još nije aktiviran.",
        "invalid": null,
        "last_attempt": "Imate još jedan pokušaj prije nego Vaš račun bude zaključan.",
        "locked": "Vaš račun je zaključan.",
        "not_found_in_database": null,
        "timeout": "Vrijeme trajanja Vaše sesije je isteklo. Molimo prijavite se ponovo.",
        "unauthenticated": "Za nastavak se morate prijaviti ili registrovati.",
        "unconfirmed": "Za nastavak morate potvrditi Vaš račun."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "subject": "Upute za potvrdu korisničkog računa"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": null,
          "message": null,
          "subject": null
        },
        "reset_password_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "instruction_2": null,
          "instruction_3": null,
          "subject": "Upute za promjenu lozinke"
        },
        "unlock_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "message": null,
          "subject": "Upute za otključavanje korisničkog računa"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nismo Vas u mogućnosti autorizirati sa %{kind} računom zbog \"%{reason}\".",
        "success": "Uspješna autorizacija sa %{kind} računa."
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": null,
          "send_me_reset_password_instructions": null
        },
        "no_token": "Ne možete pristupiti ovoj stranici ako niste kliknuli na link u e-mailu za resetovanje lozinke.",
        "send_instructions": "U roku nekoliko minuta ćete primiti e-mail s uputama za resetovanje Vaše lozinke.",
        "send_paranoid_instructions": "Ukoliko se Vaša e-mail adresa nalazi u našoj bazi, u roku nekoliko minuta ćete primiti link za resetovanje lozinke.",
        "updated": "Vaša lozinka je uspješno promjenjena. Sad ste prijavljeni.",
        "updated_not_active": "Vaša lozinka je uspješno izmijenjena."
      },
      "registrations": {
        "destroyed": "Pozdrav! Vaš račun je uspješno obrisan. Nadamo se da ćete se brzo vratiti.",
        "edit": {
          "are_you_sure": null,
          "cancel_my_account": null,
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": null,
          "title": null,
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": null
        },
        "new": {
          "sign_up": null
        },
        "signed_up": "Dobrodošli! Uspješno ste se registrovali.",
        "signed_up_but_inactive": "Uspješno ste se registrovali. Nažalost, ne možete se prijaviti, jer Vaš račun još nije aktiviran.",
        "signed_up_but_locked": "Uspješno ste se registrovali. Nažalost, ne možete se prijaviti, jer Vam je račun zaključan.",
        "signed_up_but_unconfirmed": "Poruka s linkom za potvrdu je poslana na Vašu e-mail adresu. Molimo kliknite na link da aktivirate Vaš račun.",
        "update_needs_confirmation": "Uspješno ste ažurirali Vaš račun, ali trebamo potvrditi Vašu novu e-mail adresu. Molimo provjerite svoje sanduče i kliknite na link za potvrdu.",
        "updated": "Uspješno ste izmjenili Vaš račun.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": null,
        "new": {
          "sign_in": null
        },
        "signed_in": "Uspješno ste se prijavili.",
        "signed_out": "Uspješno ste se odjavili."
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": null,
          "didn_t_receive_unlock_instructions": null,
          "forgot_your_password": null,
          "sign_in": null,
          "sign_in_with_provider": null,
          "sign_up": null
        },
        "minimum_password_length": {
          "few": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": null
        },
        "send_instructions": "U roku nekoliko minuta ćete primiti e-mail s uputama za otključavanje Vašeg računa.",
        "send_paranoid_instructions": "Ako Vaš račun postoji, na e-mail ćete u roku nekoliko minuta primiti upute kako ga otključati.",
        "unlocked": "Vaš račun je uspješno otključan. Molimo prijavite se."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "mora biti prihvaćeno",
        "already_confirmed": "je već potvrđen, molimo pokušajte se prijaviti",
        "blank": "ne smije biti prazno",
        "confirmation": "se ne poklapa sa potvrdom",
        "confirmation_period_expired": "je trebao biti potvrđen tokom perioda %{period}, molimo tražite novi",
        "empty": "ne smije biti prazno",
        "equal_to": "mora biti %{count}",
        "even": "mora biti parno",
        "exclusion": "je rezervisano",
        "expired": "je istekao, molimo zatražite novi",
        "greater_than": "mora biti veće od %{count}",
        "greater_than_or_equal_to": "mora biti veće ili jednako %{count}",
        "inclusion": "nije uključeno u listu",
        "invalid": "nije validno",
        "less_than": "mora biti manje od %{count}",
        "less_than_or_equal_to": "mora biti manje ili jednako %{count}",
        "not_a_number": "nije broj",
        "not_an_integer": "mora biti cijeli broj",
        "not_found": "nije pronađeno",
        "not_locked": "nije zaključan",
        "not_saved": {
          "few": "%{count} greške sprječavaju sačuvanje %{resource}:",
          "one": "1 greška sprječava sačuvanje %{resource}:",
          "other": "%{count} grešaka sprječavaju sačuvanje %{resource}:"
        },
        "odd": "mora biti neparno",
        "other_than": "mora biti različito od %{count}",
        "present": "mora biti prazno",
        "taken": "je već zauzet",
        "too_long": "je predugo (maksimalno je dozvoljeno %{count} znakova)",
        "too_short": "je prekratko (predviđeno je minimalno %{count} znakova)",
        "wrong_length": "je pogrešne dužine (trebalo bi biti tačno %{count} znakova)"
      },
      "template": {
        "body": "Desili su se problemi sa sljedećim poljima:",
        "header": {
          "few": "%{count} greške su spriječile da se ovaj %{model} spremi",
          "many": "%{count} grešaka je spriječilo da se ovaj %{model} spremi",
          "one": "%{count} greška je spriječila da se ovaj %{model} spremi",
          "other": "%{count} grešaka je spriječilo da se ovaj %{model} spremi"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Molimo odaberite"
      },
      "submit": {
        "create": "Kreiraj %{model}",
        "submit": "Sačuvaj %{model}",
        "update": "Osvježi %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n%u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": true,
          "unit": "KM"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": true
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "milijarde",
              "many": "milijardi",
              "one": "milijarda",
              "other": "milijardi"
            },
            "million": {
              "few": "miliona",
              "many": "miliona",
              "one": "milion",
              "other": "miliona"
            },
            "quadrillion": {
              "few": "bilijarde",
              "many": "bilijardi",
              "one": "bilijarda",
              "other": "bilijardi"
            },
            "thousand": {
              "few": "hiljade",
              "many": "hiljada",
              "one": "hiljada",
              "other": "hiljada"
            },
            "trillion": {
              "few": "biliona",
              "many": "biliona",
              "one": "bilion",
              "other": "biliona"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 0,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "bajta",
              "many": "bajtova",
              "one": "bajt",
              "other": "bajtova"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " i ",
        "two_words_connector": " i ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d.%m.%Y. %H:%M:%S",
        "long": "%d. %B %Y. - %H:%M:%S",
        "short": "%d. %b %Y. %H:%M"
      },
      "pm": "pm"
    }
  },
  "ca": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "S'ha enviat la confirmació a",
          "confirmation_token": "Token de confirmació",
          "confirmed_at": "Confirmat a les",
          "created_at": "Creat a les",
          "current_password": "Contrasenya actual",
          "current_sign_in_at": "Inici de sessió actual a les",
          "current_sign_in_ip": "Sessió actual amb la IP",
          "email": "Adreça electrònica",
          "encrypted_password": "Contrasenya xifrada",
          "failed_attempts": "Intents fallits",
          "last_sign_in_at": "Darrere inici de sessió a les",
          "last_sign_in_ip": "Última IP",
          "locked_at": "Bloquejat a les",
          "password": "Contrasenya",
          "password_confirmation": "Confirmar contrasenya",
          "remember_created_at": "Recorda'm creat a les",
          "remember_me": "Recorda'm",
          "reset_password_sent_at": "Restabliment de contrasenya enviat a les",
          "reset_password_token": "Restabliment de token de la contrasenya",
          "sign_in_count": "Nombre d'inicis de sessió",
          "unconfirmed_email": "Correu electrònic no confirmat",
          "unlock_token": "Desbloquejar el token",
          "updated_at": "Actualitzat a les"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validació ha fallat: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No es pot eliminar el registre perquè existeixen %{record} dependents",
            "has_one": "No es pot eliminar el registre perquè existeix un %{record} dependent"
          }
        }
      },
      "models": {
        "user": {
          "one": "Usuari",
          "other": "Usuari"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Dg",
        "Dl",
        "Dm",
        "Dc",
        "Dj",
        "Dv",
        "Ds"
      ],
      "abbr_month_names": [
        null,
        "Gen",
        "Feb",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Oct",
        "Nov",
        "Des"
      ],
      "day_names": [
        "Diumenge",
        "Dilluns",
        "Dimarts",
        "Dimecres",
        "Dijous",
        "Divendres",
        "Dissabte"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "Gener",
        "Febrer",
        "Març",
        "Abril",
        "Maig",
        "Juny",
        "Juliol",
        "Agost",
        "Setembre",
        "Octubre",
        "Novembre",
        "Desembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "aproximadament %{count} hora",
          "other": "aproximadament %{count} hores"
        },
        "about_x_months": {
          "one": "aproximadament %{count} mes",
          "other": "aproximadament %{count} mesos"
        },
        "about_x_years": {
          "one": "aproximadament %{count} any",
          "other": "aproximadament %{count} anys"
        },
        "almost_x_years": {
          "one": "quasi %{count} any",
          "other": "quasi %{count} anys"
        },
        "half_a_minute": "mig minut",
        "less_than_x_minutes": {
          "one": "menys d'%{count} minut",
          "other": "menys de %{count} minuts"
        },
        "less_than_x_seconds": {
          "one": "menys d'%{count} segon",
          "other": "menys de %{count} segons"
        },
        "over_x_years": {
          "one": "més d'%{count} any",
          "other": "més de %{count} anys"
        },
        "x_days": {
          "one": "%{count} dia",
          "other": "%{count} dies"
        },
        "x_minutes": {
          "one": "%{count} minut",
          "other": "%{count} minuts"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} mesos"
        },
        "x_seconds": {
          "one": "%{count} segon",
          "other": "%{count} segons"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "dia",
        "hour": "hora",
        "minute": "minut",
        "month": "mes",
        "second": "segon",
        "year": "any"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "La vostra adreça electrònica ha estat confirmada correctament.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instruccions de confirmació"
        },
        "send_instructions": "En breu rebràs un correu electrònic amb instruccions sobre com confirmar el teu compte.",
        "send_paranoid_instructions": "Si la teva adreça electrònica existeix a la base de dades, rebràs un correu electrònic amb instruccions sobre com confirmar el teu compte."
      },
      "failure": {
        "already_authenticated": "Ja estàs identificat.",
        "inactive": "El teu compte encara no ha estat activat.",
        "invalid": "%{authentication_keys} o contrasenya invàlida.",
        "invited": "Tens una invitació pendent, accepta-la per acabar de crear el teu compte.",
        "last_attempt": "Disposa d'un intent més abans de que li bloquegem el compte.",
        "locked": "El teu compte està bloquejat.",
        "not_found_in_database": "%{authentication_keys} o contrasenya invàlida.",
        "timeout": "La teva sessió ha caducat. Si us plau, torna a iniciar sessió per a continuar.",
        "unauthenticated": "Has d'iniciar sessió o bé registrar-te abans de continuar.",
        "unconfirmed": "Has de confirmar el teu compte abans de continuar."
      },
      "invitations": {
        "edit": {
          "header": "Establir contrasenya",
          "submit_button": "Guardar la meva contrasenya"
        },
        "invitation_removed": "S'ha retirat la seva invitació",
        "invitation_token_invalid": "La invitació no es vàlida!",
        "new": {
          "header": "Enviar Invitació",
          "submit_button": "Envia una invitació"
        },
        "no_invitations_remaining": "No queden invitacions",
        "send_instructions": "S'ha enviat una invitació a %{email}.",
        "updated": "S'ha configurat la seva contrasenya i s'ha ingressat al sistema",
        "updated_not_active": "La seva contrasenya s'ha configurat correctament."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar el meu compte",
          "greeting": "Benvingut %{recipient}!",
          "instruction": "Pots confirmar el correu electrònic del teu compte a través d'aquest enllaç:",
          "subject": "Instruccions de confirmació"
        },
        "email_changed": {
          "greeting": "Hola %{recipient}!",
          "message": "Et contactem per avisar-vos que el vostre correu electrònic s'ha modificat a %{email}.",
          "message_unconfirmed": null,
          "subject": "S'ha canviat el correu electrònic"
        },
        "invitation_instructions": {
          "accept": "Aceptar la invitació",
          "accept_until": "Aquesta invitació expirarà en %{due_date}.",
          "hello": "Hola %{email}",
          "ignore": "Si no li interessa aquesta invitació, simplement ignori aquest correu. No es crearà el teu compte fins que accedeixis a l'anterior enllaç i creïs una contrasenya",
          "someone_invited_you": "Has estat invitat a %{url}, pots acceptar-ho seguint el següent enllaç",
          "subject": "Instruccions de la invitació"
        },
        "password_change": {
          "greeting": "Hola, %{recipient}!",
          "message": "Us hem contactat per notificar-vos que s'ha modificat la vostra contrasenya.",
          "subject": "Contrasenya modificada"
        },
        "reset_password_instructions": {
          "action": "Canviar la meva contrasenya",
          "greeting": "Hola %{recipient}!",
          "instruction": "Algú ha sol·licitat un enllaç per a canviar la teva contrasenya, pots fer-ho amb el següent enllaç.",
          "instruction_2": "Si tu no ho has sol·licitat, si us plau ignora aquest email.",
          "instruction_3": "La teva contrasenya no serà canviada fins que accedeixis a l'enllaç i en creïs una nova.",
          "subject": "Instruccions de regeneració de contrasenya"
        },
        "unlock_instructions": {
          "action": "Desbloquejar el meu compte",
          "greeting": "Hola %{recipient}!",
          "instruction": "Obre el següent enllaç per a desbloquejar el teu compte:",
          "message": "El teu compte s'ha bloquejat a causa d'una quantitat excessiva d'intents fallits per a accedir-hi.",
          "subject": "Instruccions de desbloqueig"
        }
      },
      "omniauth_callbacks": {
        "failure": "No hem pogut autoritzar el compte des de %{kind} perquè \"%{reason}\".",
        "success": "Autoritzat satisfactoriament el compte des de %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Canviar la meva contrasenya",
          "change_your_password": "Canviar la teva contrasenya",
          "confirm_new_password": "Confirmar nova contrasenya",
          "new_password": "Nova contrasenya"
        },
        "new": {
          "forgot_your_password": "Has oblidat la teva contrasenya?",
          "send_me_reset_password_instructions": "Enviar les instruccions per a regenerar la meva contrasenya"
        },
        "no_token": "Només pots accedir a aquesta pàgina des d'un correu electrònic de recuperació de la contrasenya. Si realment has fet servir l'enllaç del correu electrònic, comprova que has utilitzat la URL completa.",
        "send_instructions": "En breu rebràs un correu electrònic amb instruccions sobre com restablir la teva contrasenya.",
        "send_paranoid_instructions": "Si la teva adreça electrònica existeix a la base de dades, rebràs un correu electrònic amb un enllaç per reestablir la contrasenya.",
        "updated": "La teva contrasenya ha estat canviada correctament. S'ha iniciat la sessió.",
        "updated_not_active": "La teva contrasenya ha estat canviada correctament."
      },
      "registrations": {
        "destroyed": "Adéu! El teu compte ha estat cancel·lat correctament. Esperem tornar-te a veure!",
        "edit": {
          "are_you_sure": "Estàs segur?",
          "cancel_my_account": "Cancel·lar el meu compte",
          "currently_waiting_confirmation_for_email": "Esperant confirmació de: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "deixa'l en blanc si no el vols canviar",
          "title": "Editar %{resource}",
          "unhappy": "Descontent",
          "update": "Actualitzar",
          "we_need_your_current_password_to_confirm_your_changes": "necessitem la teva contrasenya actual per a confirmar els canvis"
        },
        "new": {
          "sign_up": "Registrar-se"
        },
        "signed_up": "Has estat registrat correctament.",
        "signed_up_but_inactive": "El teu compte ha estat creat correctament. Tanmateix, no hem pogut inciar la sessió perquè el teu compte encara no està activat.",
        "signed_up_but_locked": "El teu compte ha estat creat correctament. Tanmateix, no hem pogut inciar la sessió perquè el teu compte està bloquejat.",
        "signed_up_but_unconfirmed": "S'ha enviat un missatge amb un enllaç de confirmació al teu correu electrònic. Obre l'enllaç per activar el teu compte.",
        "update_needs_confirmation": "Has actualitzat el teu compte correctament, però cal confirmar el teu nou correu electrònic. Si us plau, comprova el teu correu i segueix l'enllaç de confirmació per finalitzar la comprovació del nou correu eletrònic.",
        "updated": "Has actualitzat el teu compte correctament.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Desconnectat satisfactoriament.",
        "new": {
          "sign_in": "Iniciar sessió"
        },
        "signed_in": "Sessió iniciada correctament.",
        "signed_out": "Sessió tancada correctament."
      },
      "shared": {
        "links": {
          "back": "Tornar",
          "didn_t_receive_confirmation_instructions": "No has rebut les instruccions de confirmació?",
          "didn_t_receive_unlock_instructions": "No has rebut les instruccions de desbloqueig?",
          "forgot_your_password": "Has oblidat la teva contrasenya?",
          "sign_in": "Iniciar sessió",
          "sign_in_with_provider": "Iniciar sessió amb %{provider}",
          "sign_up": "Registrar-se"
        },
        "minimum_password_length": {
          "one": "(mínim %{count} caràcter)",
          "other": "(mínim de %{count} caràcters)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instruccions de desbloqueig"
        },
        "send_instructions": "En breu rebràs un correu electrònic amb instruccions sobre com desbloquejar el teu compte.",
        "send_paranoid_instructions": "Si el teu compte existeix, rebràs un correu electrònic amb instruccions sobre com desbloquejar-lo.",
        "unlocked": "El teu compte ha estat desbloquejat correctament. S'ha iniciat la sessió."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ha de ser acceptat",
        "already_confirmed": "ja està confirmat",
        "blank": "no pot estar en blanc",
        "confirmation": "no coincideix",
        "confirmation_period_expired": "necessita ser confirmat en %{period}, si us plau demana'n un de nou",
        "empty": "no pot estar buit",
        "equal_to": "ha de ser igual a %{count}",
        "even": "ha de ser parell",
        "exclusion": "està reservat",
        "expired": "ha caducat, si us plau demana'n un de nou",
        "greater_than": "ha de ser més gran que %{count}",
        "greater_than_or_equal_to": "ha de ser més gran o igual a %{count}",
        "inclusion": "no està inclós a la llista",
        "invalid": "no és vàlid",
        "less_than": "ha de ser menor que %{count}",
        "less_than_or_equal_to": "ha de ser menor o igual a %{count}",
        "model_invalid": "La validació ha fallat: %{errors}",
        "not_a_number": "no és un número",
        "not_an_integer": "ha de ser un enter",
        "not_found": "no s'ha trobat",
        "not_locked": "no està bloquejat",
        "not_saved": {
          "one": "1 error ha evitat que %{resource} es pugui desar:",
          "other": "%{count} errors han evitat que %{resource} es pugui desar:"
        },
        "odd": "ha de ser senar",
        "other_than": "ha de ser diferent de %{count}",
        "present": "ha d'estar en blanc",
        "required": "ha d'existir",
        "taken": "no està disponible",
        "too_long": {
          "one": "és massa llarg (%{count} caràcter màxim)",
          "other": "és massa llarg (%{count} caràcters màxim)"
        },
        "too_short": {
          "one": "és massa curt (%{count} caràcter mínim)",
          "other": "és massa curt (%{count} caràcters mínim)"
        },
        "wrong_length": {
          "one": "no té la longitud correcta (%{count} caràcter exactament)",
          "other": "no té la longitud correcta (%{count} caràcters exactament)"
        }
      },
      "template": {
        "body": "Hi ha hagut problemes amb els següents camps:",
        "header": {
          "one": "No s'ha pogut desar aquest/a %{model} perquè hi ha %{count} error",
          "other": "No s'ha pogut desar aquest/a %{model} perquè hi ha hagut %{count} errors"
        }
      }
    },
    "faker": {
      "color": {
        "name": [
          "aiguamarina",
          "albercoc",
          "amarant",
          "ambre",
          "ametista",
          "atzur",
          "beix",
          "bistre",
          "blanc",
          "blat",
          "blau",
          "blau cel",
          "blau fosc",
          "blau marí",
          "blau reial",
          "blauet",
          "bronze",
          "camussa",
          "canyella",
          "caqui",
          "cardenal",
          "carmesí",
          "carmí",
          "carnació",
          "castany rogenc",
          "celadont",
          "ceruli",
          "chartreuse",
          "cian",
          "cirera",
          "corall",
          "coure",
          "crema",
          "escarlata",
          "granat",
          "gris",
          "gris fosc",
          "groc",
          "lavanda",
          "lila",
          "llima",
          "magenta",
          "malva",
          "marró",
          "morat",
          "ocre",
          "or",
          "orquídia",
          "panotxa",
          "plata",
          "porpra",
          "préssec",
          "pruna",
          "verd",
          "verd maragda",
          "verd oliva",
          "verd veronès",
          "vermell",
          "vermell fosc",
          "vermelló",
          "vinca",
          "violat",
          "vori"
        ]
      },
      "name": {
        "female_first_name": [
          "Abellera",
          "Abril",
          "Ada",
          "Adaleda",
          "Adaleis",
          "Àgata",
          "Agnès",
          "Aida",
          "Aidé",
          "Ailo",
          "Aina",
          "Alamanda",
          "Alba",
          "Aledis",
          "Alfreda",
          "Alícia",
          "Alix",
          "Almodis",
          "Aloma",
          "Anaïs",
          "Anastàsia",
          "Àneu",
          "Àngela",
          "Àngels",
          "Anna",
          "Antiga",
          "Antònia",
          "Arcàngela",
          "Ardoina",
          "Ariadna",
          "Arlet",
          "Arsenda",
          "Arsendis",
          "Assumpció",
          "Aura",
          "Àurea",
          "Aurembiaix",
          "Aurora",
          "Bàrbara",
          "Bartomeva",
          "Beatriu",
          "Benvinguda",
          "Betlem",
          "Bibianna",
          "Blanca",
          "Blau",
          "Bondia",
          "Bruguers",
          "Brugués",
          "Bruna",
          "Brunisenda",
          "Candela",
          "Carla",
          "Carlota",
          "Carme",
          "Carolina",
          "Casilda",
          "Caterina",
          "Cèlia",
          "Chaymae",
          "Cinta",
          "Cior",
          "Cira",
          "Cixilona",
          "Clotilde",
          "Constança",
          "Cristina",
          "Dalila",
          "Dolça",
          "Dolors",
          "Duna",
          "Elena",
          "Èlia",
          "Elionor",
          "Elisabet",
          "Elisenda",
          "Elvira",
          "Emma",
          "Enriqueta",
          "Escarlata",
          "Esclarmunda",
          "Estel",
          "Estel·la",
          "Ester",
          "Eugènia",
          "Eulàlia",
          "Fe",
          "Ferrera",
          "Foix",
          "Gal·la",
          "Gemma",
          "Georgina",
          "Glòria",
          "Gotlana",
          "Gotruda",
          "Gueralda",
          "Guillelma",
          "Guillema",
          "Guisla",
          "Helena",
          "Ia",
          "Immaculada",
          "Inda",
          "Iolanda",
          "Irene",
          "Isaura",
          "Isona",
          "Ivet",
          "Jacina",
          "Jara",
          "Joana",
          "Jordina",
          "Judit",
          "Judith",
          "Júlia",
          "Laia",
          "Laura",
          "Lerenna",
          "Letgarda",
          "Letícia",
          "Lia",
          "Lídia",
          "Llúcia",
          "Lluïsa",
          "Llura",
          "Mafalda",
          "Mar",
          "Margalida",
          "Maria",
          "Mariona",
          "Marta",
          "Martina",
          "Mercè",
          "Meritxell",
          "Mireia",
          "Mònica",
          "Montserrat",
          "Natàlia",
          "Nati",
          "Neus",
          "Nit",
          "Noa",
          "Noemí",
          "Norma",
          "Nura",
          "Núria",
          "Olga",
          "Oliva",
          "Pagesa",
          "Patrícia",
          "Paula",
          "Peregrina",
          "Peronella",
          "Pilar",
          "Ponça",
          "Queralt",
          "Quima",
          "Ramona",
          "Raquel",
          "Remei",
          "Riquilda",
          "Rita",
          "Romea",
          "Rosa",
          "Rosalia",
          "Roser",
          "Rosó",
          "Rovella",
          "Rut",
          "Sança",
          "Sancia",
          "Sancina",
          "Saurina",
          "Selma",
          "Senda",
          "Siara",
          "Sibil·la",
          "Sibilia",
          "Silvana",
          "Sílvia",
          "Sira",
          "Sònia",
          "Suavas",
          "Suevis",
          "Tamar",
          "Teia",
          "Timburguera",
          "Tresa",
          "Tuixén",
          "Tura",
          "Urgell",
          "Úrsula",
          "Valèria",
          "Vanessa",
          "Verònica",
          "Victòria",
          "Vinyet",
          "Violant",
          "Violeta",
          "Virgínia",
          "Xènia",
          "Zenaida",
          "Zoa"
        ],
        "female_prefix": [
          "Sra."
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Adell",
          "Albert",
          "Aubert",
          "Alemany",
          "Armengol",
          "Armengou",
          "Amengual",
          "Mengual",
          "Balasch",
          "Bonastre",
          "Bosch",
          "Batallé",
          "Cabot",
          "Calafell",
          "Camprubí",
          "Cardona",
          "Casajuana",
          "Casajoana",
          "Canudas",
          "Codina",
          "Codines",
          "Codinas",
          "Comas",
          "Comes",
          "Coma",
          "Danés",
          "Danès",
          "Estruch",
          "Fabré",
          "Febrer",
          "Ferrer",
          "Ferré",
          "Farré",
          "Ferrés",
          "Farrés",
          "Fortuny",
          "Gasull",
          "Gassull",
          "Grau",
          "Garau",
          "Gual",
          "Gol",
          "Guasch",
          "Gasch",
          "Guarch",
          "Guasp",
          "Jordà",
          "Llach",
          "Llobet",
          "Magrans",
          "Maymó",
          "Maimó",
          "Mas",
          "Massot",
          "Masot",
          "Melis",
          "Miquel",
          "Molas",
          "Moragues",
          "Moragas",
          "Nàcher",
          "Nadal",
          "de Nadal",
          "Oriol",
          "Pitarch",
          "Pitart",
          "Pons",
          "Prat",
          "Raga",
          "Reixach",
          "Rexach",
          "Riera",
          "Reixachs",
          "Rexachs",
          "Ricart",
          "Robert",
          "Rubert",
          "Roig",
          "Roma",
          "Ros",
          "Sabater",
          "Sabaté",
          "Sabatés",
          "Sabaters",
          "Sala",
          "Salom",
          "Santacana",
          "Sentmartí",
          "Serra",
          "Soler",
          "Solé",
          "Sulé",
          "Taberner",
          "Taberné",
          "Taverner",
          "Taverné",
          "Tió",
          "Thió",
          "Vidal",
          "Vives"
        ],
        "male_first_name": [
          "Aaró",
          "Aaron",
          "Abacuc",
          "Abba",
          "Abel",
          "Abelard",
          "Abraham",
          "Acfred",
          "Adam",
          "Adrià",
          "Albà",
          "Albert",
          "Aleix",
          "Aleu",
          "Àlex",
          "Álex",
          "Alexandre",
          "Alfons",
          "Alfred",
          "Àlvar",
          "Amadeu",
          "Amador",
          "Amalric",
          "Amand",
          "Anastasi",
          "Andreu",
          "Àngel",
          "Aniol",
          "Antoni",
          "Apel·les",
          "Arcadi",
          "Armand",
          "Armengol",
          "Arnau",
          "Artal",
          "Artur",
          "August",
          "Àxel",
          "Bartolí",
          "Bartolomeu",
          "Benet",
          "Bert",
          "Biel",
          "Blai",
          "Blanc",
          "Boi",
          "Bonaventura",
          "Borja",
          "Borràs",
          "Borrell",
          "Bru",
          "Carbó",
          "Carles",
          "Castelló",
          "Cèsar",
          "Cesc",
          "Constantí",
          "Cristià",
          "Cugat",
          "Damià",
          "Daniel",
          "David",
          "Dídac",
          "Domènec",
          "Donat",
          "Drac",
          "Eduard",
          "Egidi",
          "Elm",
          "Eloi",
          "Enric",
          "Èric",
          "Ermengol",
          "Ernest",
          "Estanislau",
          "Eudald",
          "Feliu",
          "Fèlix",
          "Ferriol",
          "Fortià",
          "Garbí",
          "Gastó",
          "Gaufred",
          "Gausbert",
          "Gausfred",
          "Gelabert",
          "Genís",
          "Gerai",
          "Gerald",
          "Gerard",
          "Germà",
          "Gonçal",
          "Grau",
          "Gregori",
          "Guerau",
          "Guifré",
          "Guim",
          "Guiu",
          "Gustau",
          "Habacuc",
          "Hèctor",
          "Hug",
          "Ignasi",
          "Iol",
          "Isaac",
          "Isma",
          "Iu",
          "Ivan",
          "Izan",
          "Joan",
          "Joel",
          "Jofre",
          "Jonàs",
          "Jordi",
          "Josefí",
          "Josep",
          "Julià",
          "Kilian",
          "Laureà",
          "Llàtzer",
          "Lledó",
          "Lleó",
          "Lluc",
          "Llucià",
          "Lluis",
          "Llull",
          "Llum",
          "Luard",
          "Magí",
          "Manel",
          "Marc",
          "Marçal",
          "Margarit",
          "Maricel",
          "Marimon",
          "Martí",
          "Mateu",
          "Maurici",
          "Milos",
          "Miquel",
          "Miró",
          "Mirt",
          "Modest",
          "Natan",
          "Nèstor",
          "Nil",
          "Olaf",
          "Olau",
          "Oleguer",
          "Oliver",
          "Oriol",
          "Oscar",
          "Òscar",
          "Ot",
          "Ota",
          "Otger",
          "Palau",
          "Pau",
          "Peris",
          "Pol",
          "Quel",
          "Quer",
          "Quim",
          "Quintí",
          "Quirze",
          "Quixot",
          "Radulf",
          "Rafael",
          "Rafaela",
          "Raimon",
          "Ramir",
          "Raül",
          "Rauric",
          "Renat",
          "Rispau",
          "Robert",
          "Roc",
          "Roderic",
          "Roger",
          "Rosseyó",
          "Rubén",
          "Rutger",
          "Samuel",
          "Sanç",
          "Santiago",
          "Saoni",
          "Serafí",
          "Sergi",
          "Sever",
          "Severí",
          "Sibil",
          "Silvà",
          "Siset",
          "Sunyer",
          "Telm",
          "Uguet",
          "Uriel",
          "Valentí",
          "Valeri",
          "Vicenç",
          "Víctor",
          "Vidal",
          "Xavier",
          "Zacaries",
          "Zenon",
          "Zotan"
        ],
        "male_prefix": [
          "Sr."
        ],
        "name": [
          "#{female_prefix} #{female_first_name} #{last_name} #{last_name}",
          "#{female_first_name} #{last_name} i #{last_name}",
          "#{female_first_name} #{last_name} #{last_name}",
          "#{male_prefix} #{male_first_name} #{last_name} #{last_name}",
          "#{male_first_name} #{last_name} i #{last_name}",
          "#{male_first_name} #{last_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Si us plau tria"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualitzar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Á": "A",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ë": "E",
          "Í": "I",
          "Ï": "I",
          "Ò": "O",
          "Ó": "O",
          "Ú": "U",
          "Ü": "U",
          "à": "a",
          "á": "a",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ë": "e",
          "í": "i",
          "ï": "i",
          "ò": "o",
          "ó": "o",
          "ú": "u",
          "ü": "u"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil milions",
            "million": {
              "one": "milió",
              "other": "milions"
            },
            "quadrillion": {
              "one": "quadrilió",
              "other": "quadrilions"
            },
            "thousand": {
              "one": "miler",
              "other": "milers"
            },
            "trillion": {
              "one": "bilió",
              "other": "bilions"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", i ",
        "two_words_connector": " i ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %d de %B de %Y %H:%M:%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d de %B de %Y, %H:%M"
            }
          }
        },
        "long": "%d de %B de %Y %H:%M",
        "short": "%d de %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "ca-CAT": {
    "faker": {
      "address": {
        "building_number": [
          " s/n.",
          ", #",
          ", ##",
          " #",
          " ##"
        ],
        "city": [
          "Amposta",
          "Badalona",
          "Barberà del Vallès",
          "Barcelona",
          "Blanes",
          "Calafell",
          "Cambrils",
          "Castellar del Vallès",
          "Castelldefels",
          "Cerdanyola del Vallès",
          "Cornellà de Llobregat",
          "El Masnou",
          "El Prat de Llobregat",
          "El Vendrell",
          "Esparreguera",
          "Esplugues de Llobregat",
          "Figueres",
          "Gavà",
          "Girona",
          "Granollers",
          "Igualada",
          "Lleida",
          "Lloret de Mar",
          "Manlleu",
          "Manresa",
          "Martorell",
          "Mataró",
          "Molins de Rei",
          "Mollet del Vallès",
          "Montcada i Reixac",
          "Olesa de Montserrat",
          "Olot",
          "Palafrugell",
          "Pineda de Mar",
          "Premià de Mar",
          "Reus",
          "Ripollet",
          "Rubí",
          "Sabadell",
          "Salou",
          "Salt",
          "Sant Adrià de Besòs",
          "Sant Andreu de la Barca",
          "Sant Boi de Llobregat",
          "Sant Cugat del Vallès",
          "Sant Feliu de Guíxols",
          "Sant Feliu de Llobregat",
          "Sant Joan Despí",
          "Sant Pere de Ribes",
          "Sant Vicenç dels Horts",
          "Santa Coloma de Gramenet",
          "Santa Perpètua de Mogoda",
          "Sitges",
          "Tarragona",
          "Terrassa",
          "Tortosa",
          "Valls",
          "Vic",
          "Vila-seca",
          "Viladecans",
          "Vilafranca del Penedès",
          "Vilanova i la Geltrú"
        ],
        "country": [
          "Afganistan",
          "Albània",
          "Alemanya",
          "Algèria",
          "Andorra",
          "Angola",
          "Antigua i Barbuda",
          "Aràbia Saudita",
          "Argentina",
          "Armènia",
          "Austràlia",
          "Àustria",
          "Azerbaidjan",
          "Bahames",
          "Bahrain",
          "Bangla Desh",
          "Barbados",
          "Bèlgica",
          "Belize",
          "Benín",
          "Bhutan",
          "Bielorússia",
          "Bolívia",
          "Bòsnia i Hercegovina",
          "Botswana",
          "Brasil",
          "Brunei",
          "Bulgària",
          "Burkina Faso",
          "Burundi",
          "Cambodja",
          "Camerun",
          "Canadà",
          "Cap Verd",
          "Catalunya",
          "Ciutat del Vaticà",
          "Colòmbia",
          "Comores",
          "Corea del Nord",
          "Corea del Sud",
          "Costa d''Ivori",
          "Costa Rica",
          "Croàcia",
          "Cuba",
          "Dinamarca",
          "Djibouti",
          "Dominica",
          "Egipte",
          "El Salvador",
          "Emirats Àrabs Units",
          "Equador",
          "Eritrea",
          "Eslovàquia",
          "Eslovènia",
          "Espanya",
          "Estats Federats de Micronèsia",
          "Estats Units",
          "Estònia",
          "Etiòpia",
          "Fiji",
          "Filipines",
          "Finlàndia",
          "França",
          "Gabon",
          "Gàmbia",
          "Geòrgia",
          "Ghana",
          "Grècia",
          "Grenada",
          "Guatemala",
          "Guinea",
          "Guinea Bissau",
          "Guinea Equatorial",
          "Guyana",
          "Haití",
          "Hondures",
          "Hongria",
          "Iemen",
          "Illes Marshall",
          "Índia",
          "Indonèsia",
          "Iran",
          "Iraq",
          "Islàndia",
          "Israel",
          "Itàlia",
          "Jamaica",
          "Japó",
          "Jordània",
          "Kazakhstan",
          "Kenya",
          "Kirguizistan",
          "Kiribati",
          "Kuwait",
          "Laos",
          "Lesotho",
          "Letònia",
          "Líban",
          "Libèria",
          "Líbia",
          "Liechtenstein",
          "Lituània",
          "Luxemburg",
          "Macedònia",
          "Madagascar",
          "Malàisia",
          "Malawi",
          "Maldives",
          "Mali",
          "Malta",
          "Marroc",
          "Maurici",
          "Mauritània",
          "Mèxic",
          "Moçambic",
          "Moldàvia",
          "Mònaco",
          "Mongòlia",
          "Myanmar",
          "Namíbia",
          "Nauru",
          "Nepal",
          "Nicaragua",
          "Níger",
          "Nigèria",
          "Noruega",
          "Nova Zelanda",
          "Oman",
          "Països Baixos",
          "Pakistan",
          "Palau",
          "Panamà",
          "Papua Nova Guinea",
          "Paraguai",
          "Perú",
          "Polònia",
          "Portugal",
          "Qatar",
          "Regne Unit",
          "República Centreafricana",
          "República d''Irlanda",
          "República de la Xina",
          "República del Congo",
          "República Democràtica del Congo",
          "República Dominicana",
          "República Popular de la Xina",
          "República Txeca",
          "Romania",
          "Rússia",
          "Rwanda",
          "Saint Kitts i Nevis",
          "Saint Lucia",
          "Saint Vincent i les Grenadines",
          "Salomó",
          "Samoa Occidental",
          "San Marino",
          "São Tomé i Príncipe",
          "Senegal",
          "Sèrbia i Montenegro",
          "Seychelles",
          "Sierra Leone",
          "Singapur",
          "Síria",
          "Somàlia",
          "Sri Lanka",
          "Sud-àfrica",
          "Sudan",
          "Sudan del Sud",
          "Suècia",
          "Suïssa",
          "Surinam",
          "Swazilàndia",
          "Tadjikistan",
          "Tailàndia",
          "Tanzània",
          "Timor Oriental",
          "Togo",
          "Tonga",
          "Trinitat i Tobago",
          "Tunísia",
          "Turkmenistan",
          "Turquia",
          "Tuvalu",
          "Txad",
          "Ucraïna",
          "Uganda",
          "Uruguai",
          "Uzbekistan",
          "Vanuatu",
          "Veneçuela",
          "Vietnam",
          "Xile",
          "Xipre",
          "Zàmbia",
          "Zimbabwe"
        ],
        "default_country": [
          "Catalunya"
        ],
        "postcode": [
          "#####"
        ],
        "province": [
          "Barcelona",
          "Girona",
          "Lleida",
          "Tarragona"
        ],
        "secondary_address": [
          "Esc. ###",
          "Porta ###"
        ],
        "state": [
          "l''Alt Camp",
          "l''Alt Empordà",
          "l''Alt Penedès",
          "l''Alt Urgell",
          "l''Alta Ribagorça",
          "l''Anoia",
          "el Bages",
          "el Baix Camp",
          "el Baix Ebre",
          "el Baix Empordà",
          "el Baix Llobregat",
          "el Baix Penedès",
          "el Barcelonès",
          "el Berguedà",
          "la Cerdanya",
          "la Conca de Barberà",
          "el Garraf",
          "les Garrigues",
          "la Garrotxa",
          "el Gironès",
          "el Maresme",
          "el Moianès",
          "el Montsià",
          "la Noguera",
          "Osona",
          "el Pallars Jussà",
          "el Pallars Sobirà",
          "el Pla d''Urgell",
          "el Pla de l''Estany",
          "el Priorat",
          "la Ribera d''Ebre",
          "el Ripollès",
          "la Segarra",
          "el Segrià",
          "la Selva",
          "el Solsonès",
          "el Tarragonès",
          "la Terra Alta",
          "l''Urgell",
          "la Val d''Aran",
          "el Vallès Occidental",
          "el Vallès Oriental"
        ],
        "street_address": [
          "#{street_name}#{building_number}",
          "#{street_name}#{building_number} #{secondary_address}"
        ],
        "street_name": [
          "#{street_suffix} #{Name.first_name}",
          "#{street_suffix} #{Name.first_name} #{Name.last_name}",
          "#{street_suffix} #{country}"
        ],
        "street_suffix": [
          "Avinguda",
          "Baixada",
          "Barranc",
          "Barri",
          "Carrer",
          "Camí",
          "Carretera",
          "Coll",
          "Passeig",
          "Plaça",
          "Polígon",
          "Rambla",
          "Riera",
          "Ronda",
          "Torrent",
          "Travessia"
        ]
      },
      "cell_phone": {
        "formats": [
          "6##-###-###",
          "6##.###.###",
          "6## ### ###",
          "6########"
        ]
      },
      "phone_number": {
        "formats": [
          "9##-###-###",
          "9##.###.###",
          "9## ### ###",
          "9########"
        ]
      }
    }
  },
  "cnr": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validacija nije uspjela: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Nije moguće izbrisati zapis jer postoje zavisni %{record}",
            "has_one": "Nije moguće izbrisati zapis jer postoji zavisan %{record}"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ned",
        "pon",
        "uto",
        "sri",
        "čet",
        "pet",
        "sub"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "nedjelja",
        "poneđeljak",
        "utorak",
        "srijeda",
        "četvrtak",
        "petak",
        "subota"
      ],
      "formats": {
        "default": "%d.%m.%Y.",
        "long": "%e. %B %Y.",
        "short": "%e. %b. %Y."
      },
      "month_names": [
        null,
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "oko %{count} sata",
          "many": "oko %{count} sati",
          "one": "oko sat",
          "other": "oko %{count} sati"
        },
        "about_x_months": {
          "few": "oko %{count} mjeseca",
          "many": "oko %{count} mjeseci",
          "one": "oko mjesec",
          "other": "oko %{count} mjeseci"
        },
        "about_x_years": {
          "few": "oko %{count} godine",
          "many": "oko %{count} godina",
          "one": "oko godine",
          "other": "oko %{count} godina"
        },
        "almost_x_years": {
          "few": "skoro %{count} godine",
          "many": "skoro %{count} godina",
          "one": "skoro %{count} godina",
          "other": "skoro %{count} godina"
        },
        "half_a_minute": "pola minute",
        "less_than_x_minutes": {
          "few": "manje od %{count} minute",
          "many": "manje od %{count} minuta",
          "one": "manje od minute",
          "other": "manje od %{count} minuta"
        },
        "less_than_x_seconds": {
          "few": "manje od %{count} sekunde",
          "many": "manje od %{count} sekundi",
          "one": "manje od sekunde",
          "other": "manje od %{count} sekundi"
        },
        "over_x_years": {
          "few": "preko %{count} godine",
          "many": "preko %{count} godina",
          "one": "preko godine",
          "other": "preko %{count} godina"
        },
        "x_days": {
          "few": "%{count} dana",
          "many": "%{count} dana",
          "one": "%{count} dan",
          "other": "%{count} dana"
        },
        "x_minutes": {
          "few": "%{count} minute",
          "many": "%{count} minuta",
          "one": "%{count} minut",
          "other": "%{count} minuta"
        },
        "x_months": {
          "few": "%{count} mjeseca",
          "many": "%{count} mjeseci",
          "one": "%{count} mjesec",
          "other": "%{count} mjeseci"
        },
        "x_seconds": {
          "few": "%{count} sekunde",
          "many": "%{count} sekundi",
          "one": "%{count} sekund",
          "other": "%{count} sekundi"
        }
      },
      "prompts": {
        "day": "dan",
        "hour": "sat",
        "minute": "minut",
        "month": "mjesec",
        "second": "sekundi",
        "year": "godina"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "mora biti prihvaćeno",
        "blank": "ne smije biti prazno",
        "confirmation": "se ne poklapa sa potvrdom",
        "empty": "ne smije biti prazno",
        "equal_to": "mora biti %{count}",
        "even": "mora biti parno",
        "exclusion": "je rezervisano",
        "greater_than": "mora biti veće od %{count}",
        "greater_than_or_equal_to": "mora biti veće ili jednako %{count}",
        "inclusion": "nije uključeno u listu",
        "invalid": "nije validno",
        "less_than": "mora biti manje od %{count}",
        "less_than_or_equal_to": "mora biti manje ili jednako %{count}",
        "not_a_number": "nije broj",
        "not_an_integer": "mora biti cijeli broj",
        "odd": "mora biti neparno",
        "other_than": "mora biti različito od %{count}",
        "present": "mora biti prazno",
        "taken": "je već zauzeto",
        "too_long": "je predugo (maksimalno je dozvoljeno %{count} znakova)",
        "too_short": "je prekratko (predviđeno je minimalno %{count} znakova)",
        "wrong_length": "je pogrešne dužine (trebalo bi biti tačno %{count} znakova)"
      },
      "template": {
        "body": "Desili su se problemi sa sljedećim poljima:",
        "header": {
          "few": "%{count} greške su spriječile da se ovaj %{model} sačuva",
          "many": "%{count} grešaka je spriječilo da se ovaj %{model} sačuva",
          "one": "%{count} greška je spriječila da se ovaj %{model} sačuva",
          "other": "%{count} grešaka je spriječilo da se ovaj %{model} sačuva"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Molimo odaberite"
      },
      "submit": {
        "create": "Kreiraj %{model}",
        "submit": "Sačuvaj %{model}",
        "update": "Ažuriraj %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": true,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": true
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "milijarde",
              "many": "milijardi",
              "one": "milijarda",
              "other": "milijardi"
            },
            "million": {
              "few": "miliona",
              "many": "miliona",
              "one": "milion",
              "other": "miliona"
            },
            "quadrillion": {
              "few": "bilijarde",
              "many": "bilijardi",
              "one": "bilijarda",
              "other": "bilijardi"
            },
            "thousand": {
              "few": "hiljade",
              "many": "hiljada",
              "one": "hiljada",
              "other": "hiljada"
            },
            "trillion": {
              "few": "biliona",
              "many": "biliona",
              "one": "bilion",
              "other": "biliona"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 0,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "bajta",
              "many": "bajtova",
              "one": "bajt",
              "other": "bajtova"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " i ",
        "two_words_connector": " i ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d.%m.%Y. %H:%M:%S",
        "long": "%d. %B %Y. - %H:%M:%S",
        "short": "%d. %b %Y. %H:%M"
      },
      "pm": "pm"
    }
  },
  "cs": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Potvrzení zasláno",
          "confirmation_token": "Potvrzovací token",
          "confirmed_at": "Potvrzeno",
          "created_at": "Vytvořeno",
          "current_password": "Současné heslo",
          "current_sign_in_at": "Současné přihlášení",
          "current_sign_in_ip": "Současné přihlášení z IP",
          "email": "E-mail",
          "encrypted_password": "Zašifrované heslo",
          "failed_attempts": "Chybných pokusů",
          "last_sign_in_at": "Poslední přihlášení",
          "last_sign_in_ip": "Poslední přihlášení z IP",
          "locked_at": "Uzamčeno",
          "password": "Heslo",
          "password_confirmation": "Potvrzení hesla",
          "remember_created_at": "Zapamatování vytvořeno",
          "remember_me": "Zapamatuj si mě",
          "reset_password_sent_at": "Obnova hesla poslána",
          "reset_password_token": "Token obnovy hesla",
          "sign_in_count": "Počet přihlášení",
          "unconfirmed_email": "Nepotvrzený e-mail",
          "unlock_token": "Odemykací token",
          "updated_at": "Upraveno"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validace je neúspešná: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Nemůžu smazat položku protože existuje závislé/ý %{record}",
            "has_one": "Nemůžu smazat položku protože existuje závislá/ý/é %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": "Uživatel",
          "many": "Uživatel",
          "one": "Uživatel",
          "other": "Uživatel"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Ne",
        "Po",
        "Út",
        "St",
        "Čt",
        "Pá",
        "So"
      ],
      "abbr_month_names": [
        null,
        "Led",
        "Úno",
        "Bře",
        "Dub",
        "Kvě",
        "Čvn",
        "Čvc",
        "Srp",
        "Zář",
        "Říj",
        "Lis",
        "Pro"
      ],
      "day_names": [
        "Neděle",
        "Pondělí",
        "Úterý",
        "Středa",
        "Čtvrtek",
        "Pátek",
        "Sobota"
      ],
      "formats": {
        "default": "%d. %m. %Y",
        "long": "%d. %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Leden",
        "Únor",
        "Březen",
        "Duben",
        "Květen",
        "Červen",
        "Červenec",
        "Srpen",
        "Září",
        "Říjen",
        "Listopad",
        "Prosinec"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "asi %{count} hodinami",
          "one": "asi hodinou",
          "other": "asi %{count} hodinami"
        },
        "about_x_months": {
          "few": "asi %{count} měsíci",
          "one": "asi měsícem",
          "other": "asi %{count} měsíci"
        },
        "about_x_years": {
          "few": "asi %{count} roky",
          "one": "asi rokem",
          "other": "asi %{count} roky"
        },
        "almost_x_years": {
          "few": "téměř %{count} roky",
          "one": "téměř rokem",
          "other": "téměř %{count} roky"
        },
        "half_a_minute": "půl minutou",
        "less_than_x_minutes": {
          "few": "ani ne %{count} minutami",
          "one": "necelou minutou",
          "other": "ani ne %{count} minutami"
        },
        "less_than_x_seconds": {
          "few": "ani ne %{count} sekundami",
          "one": "necelou sekundou",
          "other": "ani ne %{count} sekundami"
        },
        "over_x_years": {
          "few": "více než %{count} roky",
          "one": "více než rokem",
          "other": "více než %{count} roky"
        },
        "x_days": {
          "few": "%{count} dny",
          "one": "24 hodinami",
          "other": "%{count} dny"
        },
        "x_minutes": {
          "few": "%{count} minutami",
          "one": "minutou",
          "other": "%{count} minutami"
        },
        "x_months": {
          "few": "%{count} měsíci",
          "one": "měsícem",
          "other": "%{count} měsíci"
        },
        "x_seconds": {
          "few": "%{count} sekundami",
          "one": "sekundou",
          "other": "%{count} sekundami"
        }
      },
      "prompts": {
        "day": "Den",
        "hour": "Hodina",
        "minute": "Minuta",
        "month": "Měsíc",
        "second": "Sekunda",
        "year": "Rok"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Vaše e-mailová adresa byla úspěšně potvrzena.",
        "new": {
          "resend_confirmation_instructions": "Opět poslat instrukce pro potvrzení"
        },
        "send_instructions": "Za několik minut obdržíte e-mail s instrukcemi k potvrzení Vašeho účtu.",
        "send_paranoid_instructions": "Pokud Váš e-mail existuje v naší databázi, za několik minut obdržíte e-mail s pokyny o tom, jak potvrdit svůj účet."
      },
      "failure": {
        "already_authenticated": "Jste již přihlášen(a).",
        "inactive": "Váš účet ještě nebyl aktivován.",
        "invalid": "Neplatné %{authentication_keys} nebo heslo.",
        "last_attempt": "Máte ještě jeden pokus než bude Váš účet uzamčen.",
        "locked": "Váš účet je uzamčen.",
        "not_found_in_database": "Neplatné %{authentication_keys} nebo heslo.",
        "timeout": "Vaše relace vypršela, přihlaste se znovu, pak budete moct pokračovat.",
        "unauthenticated": "Musíte se zaregistrovat nebo přihlásit, teprve poté budete moct pokračovat.",
        "unconfirmed": "Musíte potvrdit svoji e-mailovou adresu, teprve poté budete moct pokračovat."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potvrdit můj účet",
          "greeting": "Vítejte, %{recipient}!",
          "instruction": "Můžete potvrdit e-mailovou adresu pomocí níže uvedeného odkazu:",
          "subject": "Instrukce k potvrzení"
        },
        "email_changed": {
          "greeting": "Ahoj, %{recipient}!",
          "message": "Kontaktovali jsme Vás, abychom Vás upozornili, že se Vaše e-mailová adresa mění na %{email}.",
          "message_unconfirmed": "Kontaktujeme vás, protože váš email byl změněn na %{email}.",
          "subject": "E-mail změněn"
        },
        "password_change": {
          "greeting": "Ahoj %{recipient}!",
          "message": "Dáváme vám vědět, že Vaše heslo bylo změněno.",
          "subject": "Heslo změněno"
        },
        "reset_password_instructions": {
          "action": "Změna hesla",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Někdo si vyžádal odkaz pro změnu Vašeho hesla. Změnu můžete provést pomocí odkazu níže.",
          "instruction_2": "Pokud jste si toto nevyžádali, ignorujte tento e-mail.",
          "instruction_3": "Vaše heslo se nezmění dokud neotevřete výše uvedený odkaz a nevytvoříte si nové heslo.",
          "subject": "Instrukce k nastavení nového hesla"
        },
        "unlock_instructions": {
          "action": "Odblokovat můj účet",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Účet odblokujete kliknutím na níže uvedený odkazu:",
          "message": "Váš účet byl zablokován pro nadměrný počet neúspěšných pokusů o přihlášení.",
          "subject": "Instrukce k odemknutí účtu"
        }
      },
      "omniauth_callbacks": {
        "failure": "Není možné autorizovat z %{kind}, protože \"%{reason}\".",
        "success": "Úspěšná autorizace z účtu %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Změnit mé heslo",
          "change_your_password": "Změna Vašeho hesla",
          "confirm_new_password": "Potvrdit nové heslo",
          "new_password": "Nové heslo"
        },
        "new": {
          "forgot_your_password": "Zapomněli jste své heslo?",
          "send_me_reset_password_instructions": "Poslat instrukce pro obnovení hesla"
        },
        "no_token": "Na tuto stránku se nelze dostat jinak než z e-mailu pro resetování hesla. Pokud jste přišli z takového e-mailu, přesvědčte se že jste použili celou URL adresu.",
        "send_instructions": "Za několik minut obdržíte e-mail s instrukcemi pro nastavení nového hesla.",
        "send_paranoid_instructions": "Pokud Vaše e-mailová adresa existuje v naší databázi, za několik minut obdržíte e-mail s instrukcemi pro nastavení nového hesla.",
        "updated": "Vaše heslo bylo změněno. Nyní jste přihlášen(a).",
        "updated_not_active": "Vaše heslo bylo změněno."
      },
      "registrations": {
        "destroyed": "Mějte se! Váš účet byl úspěšně zrušen. Doufáme, že se brzy opět uvidíme.",
        "edit": {
          "are_you_sure": "Jste si jist(á)?",
          "cancel_my_account": "Zrušit můj účet",
          "currently_waiting_confirmation_for_email": "Momentálně čeká na potvrzení pro: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "nevyplňujte, pokud ho nechcete měnit",
          "title": "Upravit %{resource}",
          "unhappy": "Nejste zde šťastni?",
          "update": "Aktualizovat",
          "we_need_your_current_password_to_confirm_your_changes": "Vaše současné heslo je nutné pro potvrzení změn."
        },
        "new": {
          "sign_up": "Zaregistrovat se"
        },
        "signed_up": "Vítejte! Úspěšně jste se zaregistroval(a).",
        "signed_up_but_inactive": "Úspěšně jste se zaregistroval(a). Bohužel se nemůžete přihlásit, protože Váš účet ještě není aktivován.",
        "signed_up_but_locked": "Úspěšně jste se zaregistroval(a). Bohužel se nemůžete přihlásit, protože Váš účet je zamknutý.",
        "signed_up_but_unconfirmed": "Byl vám zaslán potvrzovací e-mail. Pro dokončení klikněte na aktivační odkaz zaslaný na Váš e-mail.",
        "update_needs_confirmation": "Úspěšně jste aktualizovali svůj účet, ale ještě musíte ověřit svou novou e-mailovou adresu. Zkontrolujte svou schránku a klikněte na odkaz pro dokončení ověření Vaší nové e-mailové adresy.",
        "updated": "Váš účet byl úspěšně aktualizován.",
        "updated_but_not_signed_in": "Váš účet byl úspěšně aktualizován. Protože došlo ke změně hesla, je nutné se znovu přihlásit."
      },
      "sessions": {
        "already_signed_out": "Odhlášen(a).",
        "new": {
          "sign_in": "Přihlásit se"
        },
        "signed_in": "Přihlášen(a).",
        "signed_out": "Odhlášen(a)."
      },
      "shared": {
        "links": {
          "back": "Zpět",
          "didn_t_receive_confirmation_instructions": "Nedostali jste informace pro potvrzení?",
          "didn_t_receive_unlock_instructions": "Nedostali jste instrukce pro odblokování?",
          "forgot_your_password": "Zapomněli jste heslo?",
          "sign_in": "Přihlásit se",
          "sign_in_with_provider": "Přihlásit se přes %{provider}",
          "sign_up": "Zaregistrovat se"
        },
        "minimum_password_length": {
          "few": "(minimálně %{count} znaky)",
          "many": "(minimálně %{count} znaky)",
          "one": "(minimálně %{count} znaky)",
          "other": "(minimálně %{count} znaky)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Znovu odeslat instrukce pro odblokování"
        },
        "send_instructions": "Za několik minut obdržíte e-mail s instrukcemi, jak odemknout svůj účet.",
        "send_paranoid_instructions": "Pokud Váš e-mail existuje v naší databázi, za několik minut obdržíte e-mail s instrukcemi pro odemknutí účtu.",
        "unlocked": "Váš účet byl úspěšně odblokován."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "musí být potvrzeno",
        "already_confirmed": "byl již potvrzen, zkuste se přihlásit",
        "blank": "je povinná položka",
        "confirmation": "nebylo potvrzeno",
        "confirmation_period_expired": "Je potřeba potvrdit do %{period},  požádejte o novou",
        "empty": "nesmí být prázdný/á/é",
        "equal_to": "musí být rovno %{count}",
        "even": "musí být sudé číslo",
        "exclusion": "je vyhrazeno pro jiný účel",
        "expired": "vypršela, požádejte o nové",
        "greater_than": "musí být větší než %{count}",
        "greater_than_or_equal_to": "musí být větší nebo rovno %{count}",
        "inclusion": "není v seznamu povolených hodnot",
        "invalid": "není platná hodnota",
        "less_than": "musí být méně než %{count}",
        "less_than_or_equal_to": "musí být méně nebo rovno %{count}",
        "not_a_number": "není číslo",
        "not_an_integer": "musí být celé číslo",
        "not_found": "nenalezen",
        "not_locked": "nebyl uzamčen",
        "not_saved": {
          "few": "%{resource} nebyl uložen kvůli %{count} chybám:",
          "many": "%{resource} nebyl uložen kvůli %{count} chybám:",
          "one": "%{resource} nebyl uložen kvůli %{count} chybám:",
          "other": "%{resource} nebyl uložen kvůli %{count} chybám:"
        },
        "odd": "musí být liché číslo",
        "other_than": "musí být rozdílný/á/é od %{count}",
        "present": "musí být prázdný/á/é",
        "required": "musí existovat",
        "taken": "již databáze obsahuje",
        "too_long": "je příliš dlouhý/á/é (max. %{count} znaků)",
        "too_short": "je příliš krátký/á/é (min. %{count} znaků)",
        "wrong_length": "nemá správnou délku (očekáváno %{count} znaků)"
      },
      "template": {
        "body": "Následující pole obsahují chybně vyplněné údaje: ",
        "header": {
          "few": "Při ukládání objektu %{model} došlo ke %{count} chybám a nebylo možné jej uložit",
          "one": "Při ukládání objektu %{model} došlo k chybám a nebylo jej možné uložit",
          "other": "Při ukládání objektu %{model} došlo ke %{count} chybám a nebylo možné jej uložit"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Prosím vyberte si"
      },
      "submit": {
        "create": "Vytvořit %{model}",
        "submit": "Uložit %{model}",
        "update": "Aktualizovat %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "Kč"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miliarda",
            "million": "Milion",
            "quadrillion": "Biliarda",
            "thousand": "Tisíc",
            "trillion": "Bilion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "B",
              "one": "B",
              "other": "B"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " a ",
        "two_words_connector": " a ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "dopoledne",
      "formats": {
        "default": "%a %e. %B %Y %H:%M %z",
        "long": "%A %e. %B %Y %H:%M",
        "short": "%e. %-m. %H:%M"
      },
      "pm": "odpoledne"
    }
  },
  "cy": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Wedi methu dilysu: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Methu dileu cofnod oherwydd bod %{record} yn bodoli",
            "has_one": "Methu dileu cofnod oherwydd bod %{record} yn bodoli"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sul",
        "Llun",
        "Maw",
        "Mer",
        "Iau",
        "Gwe",
        "Sad"
      ],
      "abbr_month_names": [
        null,
        "Ion",
        "Chw",
        "Maw",
        "Ebr",
        "Mai",
        "Meh",
        "Gor",
        "Awst",
        "Med",
        "Hyd",
        "Tach",
        "Rha"
      ],
      "day_names": [
        "Dydd Sul",
        "Dydd Llun",
        "Dydd Mawrth",
        "Dydd Mercher",
        "Dydd Iau",
        "Dydd Gwener",
        "Dydd Sadwrn"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Ionawr",
        "Chwefror",
        "Mawrth",
        "Ebrill",
        "Mai",
        "Mehefin",
        "Gorffennaf",
        "Awst",
        "Medi",
        "Hydref",
        "Tachwedd",
        "Rhagfyr"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "tua %{count} awr",
          "many": "tua %{count} awr",
          "one": "tuag awr",
          "other": "tua %{count} awr",
          "two": "tua %{count} awr",
          "zero": "tua %{count} awr"
        },
        "about_x_months": {
          "few": "tua %{count} mis",
          "many": "tua %{count} mis",
          "one": "tua mis",
          "other": "tua %{count} mis",
          "two": "tua %{count} mis",
          "zero": "tua %{count} mis"
        },
        "about_x_years": {
          "few": "tua %{count} blynedd",
          "many": "tua %{count} blynedd",
          "one": "tua blwyddyn",
          "other": "tua %{count} blynedd",
          "two": "tua %{count} blynedd",
          "zero": "tua %{count} blynedd"
        },
        "almost_x_years": {
          "few": "bron yn %{count} blynedd",
          "many": "bron yn %{count} blynedd",
          "one": "bron yn flwyddyn",
          "other": "bron yn %{count} blynedd",
          "two": "bron yn %{count} blynedd",
          "zero": "bron yn %{count} blynedd"
        },
        "half_a_minute": "hanner munud",
        "less_than_x_minutes": {
          "few": "llai na %{count} munud",
          "many": "llai na %{count} munud",
          "one": "llai na munud",
          "other": "llai na %{count} munud",
          "two": "llai na %{count} munud",
          "zero": "llai na %{count} munud"
        },
        "less_than_x_seconds": {
          "few": "llai na %{count} eiliad",
          "many": "llai na %{count} eiliad",
          "one": "llai nag eiliad",
          "other": "llai na %{count} eiliad",
          "two": "llai na %{count} eiliad",
          "zero": "llai na %{count} eiliad"
        },
        "over_x_years": {
          "few": "dros %{count} blynedd",
          "many": "dros %{count} blynedd",
          "one": "dros flwyddyn",
          "other": "dros %{count} blynedd",
          "two": "dros %{count} blynedd",
          "zero": "dros %{count} blynedd"
        },
        "x_days": {
          "few": "%{count} diwrnod",
          "many": "%{count} diwrnod",
          "one": "1 diwrnod",
          "other": "%{count} diwrnod",
          "two": "%{count} diwrnod",
          "zero": "%{count} diwrnod"
        },
        "x_minutes": {
          "few": "%{count} o funudau",
          "many": "%{count} o funudau",
          "one": "1 munud",
          "other": "%{count} o funudau",
          "two": "%{count} o funudau",
          "zero": "%{count} o funudau"
        },
        "x_months": {
          "few": "%{count} mis",
          "many": "%{count} mis",
          "one": "1 mis",
          "other": "%{count} mis",
          "two": "%{count} mis",
          "zero": "%{count} mis"
        },
        "x_seconds": {
          "few": "%{count} o eiliadau",
          "many": "%{count} o eiliadau",
          "one": "1 eiliad",
          "other": "%{count} o eiliadau",
          "two": "%{count} o eiliadau",
          "zero": "%{count} o eiliadau"
        },
        "x_years": {
          "few": "%{count} blwyddyn",
          "many": "%{count} blwyddyn",
          "one": "1 flwyddyn",
          "other": "%{count} blwyddyn",
          "two": "%{count} blwyddyn",
          "zero": "%{count} blwyddyn"
        }
      },
      "prompts": {
        "day": "Diwrnod",
        "hour": "Awr",
        "minute": "Munud",
        "month": "Mis",
        "second": "Eiliad",
        "year": "Blwyddyn"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "angen ei dderbyn",
        "blank": "methu bod yn wag",
        "confirmation": "heb fod yn gyfateb",
        "empty": "methu bod yn wag",
        "equal_to": "angen bod yn %{count}",
        "even": "rhaid bod yn eilrif",
        "exclusion": "wedi cadw",
        "greater_than": "angen bod yn fwy na %{count}",
        "greater_than_or_equal_to": "angen bod yr un maint neu fwy na %{count}",
        "in": "rhaid bod mewn %{count}",
        "inclusion": "heb fod yn y rhestr",
        "invalid": "heb fod yn nheilwng",
        "less_than": "angen bod yn llai na %{count}",
        "less_than_or_equal_to": "angen bod yr un maint neu lai na %{count}",
        "model_invalid": "Methodd y dilysu: %{errors}",
        "not_a_number": "heb fod yn rhif",
        "not_an_integer": "heb fod yn rhif llawn",
        "odd": "rhaid bod yn odrif",
        "other_than": "rhaid bod yn wahanol na %{count}",
        "present": "rhaid bod yn wag",
        "required": "rhaid bodoli",
        "taken": "wedi'i gymryd yn barod",
        "too_long": "yn rhy hir (cewch %{count} llythyren ar y fwyaf)",
        "too_short": "yn rhy fyr (rhaid am o leiaf %{count} llythyren)",
        "wrong_length": "gyda maint anghywir o lythrennau (dylai fod yn %{count} llythyren)"
      },
      "template": {
        "body": "Cafwyd broblemau gyda'r meysydd canlynol:",
        "header": {
          "few": "Atalwyd y %{model} hwn rhag ei gadw gan %{count} nam",
          "many": "Atalwyd y %{model} hwn rhag ei gadw gan %{count} nam",
          "one": "Atalwyd y %{model} hwn rhag ei gadw gan 1 nam",
          "other": "Atalwyd y %{model} hwn rhag ei gadw gan %{count} nam",
          "two": "Atalwyd y %{model} hwn rhag ei gadw gan %{count} nam",
          "zero": "Atalwyd y %{model} hwn rhag ei gadw gan 0 nam"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Dewiswch"
      },
      "submit": {
        "create": "Creu %{model}",
        "submit": "Cadw %{model}",
        "update": "Diweddaru %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "£"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Biliwn",
            "million": "Miliwn",
            "quadrillion": "Cwadriliwn",
            "thousand": "Mil",
            "trillion": "Triliwn",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "Bytes",
              "many": "Bytes",
              "one": "Byte",
              "other": "Bytes",
              "two": "Bytes",
              "zero": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", a ",
        "two_words_connector": " a ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "yb",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "yh"
    }
  },
  "da": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bekræftelse sendt",
          "confirmation_token": "Bekræftelsesnøgle",
          "confirmed_at": "Bekræftet",
          "created_at": "Oprettet",
          "current_password": "Nuværende adgangskode",
          "current_sign_in_at": "Nuværende log ind tidspunkt",
          "current_sign_in_ip": "Nuværende log ind IP",
          "email": "E-mail",
          "encrypted_password": "Krypteret adgangskode",
          "failed_attempts": "Mislykkede forsøg",
          "invitation_accepted_at": "Invitation accepteret",
          "invitation_created_at": "Invitation oprettet",
          "invitation_limit": "Invitationsbegrænsning",
          "invitation_sent_at": "Invitation sendt",
          "invitation_token": "Invitationsnøgle",
          "invitations_count": "Antal invitationer",
          "invited_by": "Inviteret af",
          "last_sign_in_at": "Sidste log ind tidspunkt",
          "last_sign_in_ip": "Sidste log ind IP",
          "locked_at": "Låst",
          "password": "Adgangskode",
          "password_confirmation": "Gentag adgangskode",
          "remember_created_at": "Husk mig tidspunkt",
          "remember_me": "Husk mig",
          "reset_password_sent_at": "Nulstil adgangskode",
          "reset_password_token": "Nulstil adgangskode nøgle",
          "sign_in_count": "Log ind antal",
          "unconfirmed_email": "Ubekræftet e-mail",
          "unlock_token": "Låse-op nøgle",
          "updated_at": "Opdateret"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Godkendelse gik galt: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kunne ikke slette posten fordi afhængige %{record} findes",
            "has_one": "Kunne ikke slette posten fordi en afhængig %{record} findes"
          }
        }
      },
      "models": {
        "user": {
          "one": "Bruger",
          "other": "Bruger"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "søn",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "lør"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "søndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lørdag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b %Y"
      },
      "month_names": [
        null,
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cirka en time",
          "other": "cirka %{count} timer"
        },
        "about_x_months": {
          "one": "cirka en måned",
          "other": "cirka %{count} måneder"
        },
        "about_x_years": {
          "one": "cirka et år",
          "other": "cirka %{count} år"
        },
        "almost_x_years": {
          "one": "næsten et år",
          "other": "næsten %{count} år"
        },
        "half_a_minute": "et halvt minut",
        "less_than_x_minutes": {
          "one": "mindre end et minut",
          "other": "mindre end %{count} minutter"
        },
        "less_than_x_seconds": {
          "one": "mindre end et sekund",
          "other": "mindre end %{count} sekunder"
        },
        "over_x_years": {
          "one": "mere end et år",
          "other": "mere end %{count} år"
        },
        "x_days": {
          "one": "en dag",
          "other": "%{count} dage"
        },
        "x_minutes": {
          "one": "et minut",
          "other": "%{count} minutter"
        },
        "x_months": {
          "one": "en måned",
          "other": "%{count} måneder"
        },
        "x_seconds": {
          "one": "et sekund",
          "other": "%{count} sekunder"
        },
        "x_years": {
          "one": "et år",
          "other": "%{count} år"
        }
      },
      "prompts": {
        "day": "Dag",
        "hour": "Time",
        "minute": "Minut",
        "month": "Måned",
        "second": "Sekund",
        "year": "År"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Din e-mail er nu bekræftet.",
        "new": {
          "resend_confirmation_instructions": "Gensend bekræftelsesinstruktioner"
        },
        "send_instructions": "Du vil i løbet af få minutter modtage en mail med instruktioner om, hvordan du bekræfter din e-mail.",
        "send_paranoid_instructions": "Hvis din e-mail findes i vores database, vil du i løbet af få minutter modtage en mail med instruktioner om, hvordan du bekræfter din e-mail."
      },
      "failure": {
        "already_authenticated": "Du er allerede logget ind.",
        "inactive": "Din konto er endnu ikke aktiveret.",
        "invalid": "Ugyldig %{authentication_keys} eller adgangskode.",
        "invited": "Du har allerede en ventende invitation, som du bedes acceptere for at oprette en konto.",
        "last_attempt": "Du har ét forsøg mere, før din konto bliver låst.",
        "locked": "Din konto er låst.",
        "not_found_in_database": "Ugyldig %{authentication_keys} eller adgangskode.",
        "timeout": "Din adgang er udløbet. Venligst log ind igen for at fortsætte.",
        "unauthenticated": "Du skal logge ind eller oprette en konto for at kunne fortsætte.",
        "unconfirmed": "Du skal bekræfte din e-mail, før du kan fortsætte."
      },
      "invitations": {
        "edit": {
          "header": "Vælg din adgangskode",
          "submit_button": "Gem adgangskode"
        },
        "invitation_removed": "Din invitation er blevet fjernet.",
        "invitation_token_invalid": "Den angivne invitationsnøgle er ikke gyldig.",
        "new": {
          "header": "Send en invitation",
          "submit_button": "Send mail"
        },
        "no_invitations_remaining": "Ikke flere invitationer tilbage",
        "send_instructions": "Der er sendt en invitationsmail til %{email}.",
        "updated": "Din adgangskode er gemt, og du er nu logget ind.",
        "updated_not_active": "Din adgangskode er gemt, og du kan nu logge ind på din konto."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bekræft min konto",
          "greeting": "Velkommen %{recipient}",
          "instruction": "Du kan bekræfte din konto og e-mail via linket herunder:",
          "subject": "Bekræftelsesinstruktioner"
        },
        "email_changed": {
          "greeting": "Hej %{recipient}",
          "message": "Vi skriver til dig for at oplyse dig om, at din e-mail er blevet ændret til %{email}.",
          "message_unconfirmed": "Vi kontakter dig for at fortælle at din email er ændret til %{email}.",
          "subject": "E-mail ændret"
        },
        "invitation_instructions": {
          "accept": "Accepter invitation",
          "accept_until": "Invitation gælder indtil %{due_date}.",
          "hello": "Hej %{email}",
          "ignore": "Hvis du ikke vil tage imod invitationen om at oprette en konto, kan du blot ignorere denne mail.<br />\nDer vil ikke blive oprettet nogen konto, medmindre du følger linket herover og derefter opretter en adgangskode.",
          "someone_invited_you": "Du er blevet inviteret til at oprette en konto på %{url}, og du kan gøre det via linket herunder.",
          "subject": "Invitation til at oprette en konto"
        },
        "password_change": {
          "greeting": "Hej %{recipient}",
          "message": "Vi skriver til dig for at oplyse dig om, at din adgangskode er blevet ændret.",
          "subject": "Adgangskode ændret"
        },
        "reset_password_instructions": {
          "action": "Skift adgangskode",
          "greeting": "Hej %{recipient}",
          "instruction": "Der er blevet anmodet om at ændre din adgangskode. Du kan ændre den via linket herunder.",
          "instruction_2": "Hvis du ikke har anmodet om dette, så se venligst bort fra denne mail.",
          "instruction_3": "Din adgangskode forbliver uændret, indtil du laver en ny via linket herover.",
          "subject": "Skift-adgangskode-instruktioner"
        },
        "unlock_instructions": {
          "action": "Lås min konto op",
          "greeting": "Hej %{recipient}",
          "instruction": "Klik på linket herunder for at låse din konto op:",
          "message": "Din konto er blevet låst efter for mange forkerte forsøg på at logge ind.",
          "subject": "Låse-op-instruktioner"
        }
      },
      "omniauth_callbacks": {
        "failure": "Kunne ikke godkende %{kind} fordi \"%{reason}\".",
        "success": "Godkendt %{kind} konto."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Skift min adgangskode",
          "change_your_password": "Skift din adgangskode",
          "confirm_new_password": "Bekræft ny adgangskode",
          "new_password": "Ny adgangskode"
        },
        "new": {
          "forgot_your_password": "Glemt adgangskode?",
          "send_me_reset_password_instructions": "Send mig instruktioner om at skifte adgangskode"
        },
        "no_token": "Du kan ikke tilgå denne side uden at komme fra en mail med instruktioner om, hvordan du skifter din adgangskode. Hvis du kommer fra en sådan mail, så tjek venligst, at du har benyttet det fulde link, som er angivet.",
        "send_instructions": "Du vil i løbet af få minutter modtage en mail med instruktioner om, hvordan du skifter din adgangskode.",
        "send_paranoid_instructions": "Hvis din e-mail findes i vores database, vil du i løbet af få minutter modtage en mail med instruktioner om, hvordan du skifter din adgangskode.",
        "updated": "Din adgangskode er ændret, og du er nu logget ind.",
        "updated_not_active": "Din adgangskode er ændret."
      },
      "registrations": {
        "destroyed": "Din konto er nu lukket.",
        "edit": {
          "are_you_sure": "Er du sikker?",
          "cancel_my_account": "Luk min konto",
          "currently_waiting_confirmation_for_email": "Afventer bekræftelse af: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lad være tomt, hvis du ikke ønsker at ændre ",
          "title": "Rediger %{resource}",
          "unhappy": "Utilfreds?",
          "update": "Opdater",
          "we_need_your_current_password_to_confirm_your_changes": "vi skal bruge din nuværende adgangskode for at bekræfte ændringerne."
        },
        "new": {
          "sign_up": "Opret konto"
        },
        "signed_up": "Velkommen! Din konto er nu oprettet.",
        "signed_up_but_inactive": "Din konto er oprettet, men vi kunne ikke logge dig ind, da din konto endnu ikke er blevet aktiveret.",
        "signed_up_but_locked": "Din konto er oprettet, men vi kunne ikke logge dig ind, da din konto er låst.",
        "signed_up_but_unconfirmed": "En besked med et bekræftelses-link er blevet sendt til din e-mail. Tryk venligst på linket for at aktivere din konto.",
        "update_needs_confirmation": "Du har nu opdateret din konto, men vi skal godkende din nye e-mail. Tjek venligst din mail og tryk på bekræftelses-linket for at godkende.",
        "updated": "Din konto er opdateret.",
        "updated_but_not_signed_in": "Din konto er blevet opdateret, men du skal logge ind igen fordi dit kodeord er ændret."
      },
      "sessions": {
        "already_signed_out": "Logget ud",
        "new": {
          "sign_in": "Log ind"
        },
        "signed_in": "Logget ind.",
        "signed_out": "Logget ud."
      },
      "shared": {
        "links": {
          "back": "Tilbage",
          "didn_t_receive_confirmation_instructions": "Har du ikke modtaget bekræftelsesinstruktioner?",
          "didn_t_receive_unlock_instructions": "Har du ikke modtaget låse-op-instruktioner?",
          "forgot_your_password": "Glemt adgangskode?",
          "sign_in": "Log ind",
          "sign_in_with_provider": "Log ind med %{provider}",
          "sign_up": "Opret konto"
        },
        "minimum_password_length": {
          "one": "(Mindst %{count} tegn)",
          "other": "(Mindst %{count} tegn)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Gensend låse-op-instruktioner"
        },
        "send_instructions": "Du vil i løbet af få minutter modtage en mail med instruktioner om, hvordan du låser din konto op.",
        "send_paranoid_instructions": "Hvis din e-mail findes i vores database, vil du i løbet af få minutter modtage en mail med instruktioner om, hvordan du låser din konto op.",
        "unlocked": "Din konto er nu låst op. Venligst log ind for at fortsætte."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "skal accepteres",
        "already_confirmed": "er allerede bekræftet, prøv venligst at logge ind",
        "blank": "skal udfyldes",
        "confirmation": "stemmer ikke overens med %{attribute}",
        "confirmation_period_expired": "skal bekræftes inden for %{period}, anmod venligst om en ny",
        "empty": "må ikke udelades",
        "equal_to": "skal være %{count}",
        "even": "skal være et lige tal",
        "exclusion": "er reserveret",
        "expired": "er udløbet, anmod venligst om en ny",
        "greater_than": "skal være større end %{count}",
        "greater_than_or_equal_to": "skal være større end eller lig med %{count}",
        "inclusion": "er ikke på listen",
        "invalid": "er ikke gyldig",
        "less_than": "skal være mindre end %{count}",
        "less_than_or_equal_to": "skal være mindre end eller lig med %{count}",
        "model_invalid": "Godkendelse gik galt: %{errors}",
        "not_a_number": "er ikke et tal",
        "not_an_integer": "er ikke et heltal",
        "not_found": "ikke fundet",
        "not_locked": "var ikke låst",
        "not_saved": {
          "one": "En fejl medførte, at denne %{resource} ikke kunne gemmes:",
          "other": "%{count} fejl medførte, at denne %{resource} ikke kunne gemmes:"
        },
        "odd": "skal være et ulige tal",
        "other_than": "skal være forskellig fra %{count}",
        "present": "skal være tom",
        "required": "skal udfyldes",
        "taken": "er allerede brugt",
        "too_long": {
          "one": "er for lang (højst %{count} tegn)",
          "other": "er for lang (højst %{count} tegn)"
        },
        "too_short": {
          "one": "er for kort (mindst %{count} tegn)",
          "other": "er for kort (mindst %{count} tegn)"
        },
        "wrong_length": {
          "one": "har forkert længde (skulle være %{count} tegn)",
          "other": "har forkert længde (skulle være %{count} tegn)"
        }
      },
      "template": {
        "body": "Der var problemer med følgende felter:",
        "header": {
          "one": "En fejl forhindrede %{model} i at blive gemt",
          "other": "%{count} fejl forhindrede %{model} i at blive gemt"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Vælg..."
      },
      "submit": {
        "create": "Opret %{model}",
        "submit": "Gem %{model}",
        "update": "Opdater %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "Å": "Aa",
          "Æ": "Ae",
          "Ø": "Oe",
          "å": "aa",
          "æ": "ae",
          "ø": "oe"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u %n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "DKK"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "milliard",
              "other": "milliarder"
            },
            "million": {
              "one": "million",
              "other": "millioner"
            },
            "quadrillion": {
              "one": "Billiard",
              "other": "Billiarder"
            },
            "thousand": "tusind",
            "trillion": {
              "one": "billion",
              "other": "billioner"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "byte",
              "other": "bytes"
            },
            "gb": "GB",
            "kb": "kB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " og ",
        "two_words_connector": " og ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%e. %B %Y, %H.%M",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%e. %B %Y kl. %H.%M"
            }
          }
        },
        "long": "%A d. %e. %B %Y, %H.%M",
        "short": "%e. %b %Y, %H.%M"
      },
      "pm": "pm"
    }
  },
  "da-DK": {
    "devise": {
      "mailer": {
        "confirmation_instructions": {
          "confirm_account_link": "Bekræft min konto",
          "confirm_link_msg": "Du kan bekræfte din kontos email gennem linket herunder:"
        },
        "reset_password_instructions": {
          "ignore_mail_msg": "Hvis du ikke anmodede om dette, ignorer venligst denne email.",
          "no_changes_msg": "Dit kodeord ændres først når du følger linket ovenfor og skaber et nyt.",
          "password_change_link": "Skift mit kodeord.",
          "request_reset_link_msg": "Nogen har anmodet om et link til at ændre dit kodeord. Det kan du gøre via linket nedenfor."
        },
        "unlock_instructions": {
          "account_lock_msg": "Din konto er blevet låst fordi der har været for mange ugyldige log ind-forsøg.",
          "unlock_link": "Lås min konto op",
          "unlock_link_msg": "Klik linket nedenfor, for at låse din konto op:"
        }
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Omdirigering til '%{redirect_url}' er ikke tilladt."
      },
      "passwords": {
        "missing_email": "Du skal udfylde email feltet.",
        "missing_passwords": "Du skal udfylde både kodeord og bekræftelse af kodeord.",
        "missing_redirect_url": "Der er ingen omdirigeringsadresse.",
        "password_not_required": "Denne bruger kræver ikke et kodeord. Log ind med '%{provider}' konto i stedet.",
        "redirect_url_not_allowed": "Omdirigering til '%{redirect_url}' er ikke tilladt.",
        "sended": "En email er blevet sendt til '%{email}' med instruktioner for at nulstille dit kodeord.",
        "successfully_updated": "Dit kodeord er opdateret.",
        "user_not_found": "Kan ikke finde en bruger med '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Kan ikke finde kontoen som skal slettes.",
        "account_with_uid_destroyed": "Kontoen med UID '%{uid}' er slettet.",
        "email_already_exists": "Der eksisterer allerede en konto med '%{email}'",
        "missing_confirm_success_url": "Der mangler et 'confirm_success_url' parameter.",
        "redirect_url_not_allowed": "Omdirigering til '%{redirect_url}' er ikke tilladt.",
        "user_not_found": "Brugeren ikke fundet."
      },
      "sessions": {
        "bad_credentials": "Ugyldig kombination af brugernavn og kodeord. Prøv venligst igen.",
        "not_confirmed": "Der er sendt en bekræftelsesemail til din konto på '%{email}'. Følg venligst instruktionerne i emailen for at aktivere din konto.",
        "not_supported": "Brug POST /sign_in for at logge ind. GET er ikke supporteret.",
        "user_not_found": "Brugeren er ikke fundet eller er ikke logget ind."
      },
      "token_validations": {
        "invalid": "Ugyldige legitimationsoplysninger."
      },
      "unlocks": {
        "missing_email": "Du skal udfylde en email.",
        "sended": "En email er blevet sendt til '%{email}', som indeholder instruktioner for at låse kontoen op.",
        "user_not_found": "Kan ikke finde en bruger med email '%{email}'."
      }
    },
    "errors": {
      "messages": {
        "not_email": "er ikke en email",
        "validate_account_update_params": "Angiv venligst en passende konto opdatering i request body.",
        "validate_sign_up_params": "Angiv venligst passende registeringsdata i request body."
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_prefix}#{city_suffix}"
        ],
        "city_prefix": [
          "Nord",
          "Birke",
          "Ny",
          "Lille",
          "Frederiks",
          "Vær",
          "Ring",
          "Støv",
          "Sven",
          "Munke",
          "Kerte",
          "Horn",
          "Aa",
          "Bør",
          "Otte",
          "Had",
          "Vi",
          "Rud",
          "Bro",
          "Vide",
          "Jyde",
          "Lange"
        ],
        "city_suffix": [
          "by",
          "hus",
          "borg",
          "holm",
          "bjerg",
          "lund",
          "bro",
          "bæk",
          "løse",
          "slev",
          "rød",
          "å",
          "sør",
          "skov",
          "slet",
          "værk",
          "strup",
          "købing",
          "sted",
          "sten",
          "kro",
          "toft",
          "ring",
          "vig",
          "bo"
        ],
        "common_street_suffix": [
          "vej",
          "gade"
        ],
        "country": [
          "Rusland",
          "Canada",
          "Kina",
          "USA",
          "Brasilien",
          "Australien",
          "Indien",
          "Argentina",
          "Kasakhstan",
          "Algeriet",
          "Den Demokratiske Republik Congo",
          "Danmark",
          "Færøerne",
          "Grønland",
          "Saudi-Arabien",
          "Mexico",
          "Indonesien",
          "Sudan",
          "Libyen",
          "Iran",
          "Mongoliet",
          "Peru",
          "Chad",
          "Niger",
          "Angola",
          "Mali",
          "Sydafrika",
          "Colombia",
          "Etiopien",
          "Bolivia",
          "Mauretanien",
          "Egypten",
          "Tanzania",
          "Nigeria",
          "Venezuela",
          "Namibia",
          "Pakistan",
          "Mocambique",
          "Tyrkiet",
          "Chile",
          "Zambia",
          "Marokko",
          "Vestsahara",
          "Burma",
          "Afghanistan",
          "Somalia",
          "Den Centralafrikanske Republik",
          "Sydsudan",
          "Ukraine",
          "Botswana",
          "Madagaskar",
          "Kenya",
          "Frankrig",
          "Fransk Guyana",
          "Yemen",
          "Thailand",
          "Spanien",
          "Turkmenistan",
          "Cameroun",
          "Papua Ny Guinea",
          "Sverige",
          "Usbekistan",
          "Irak",
          "Paraguay",
          "Zimbabwe",
          "Japan",
          "Tyskland",
          "Congo",
          "Finland",
          "Malaysia",
          "Vietnam",
          "Norge",
          "Svalbard",
          "Jan Mayen",
          "Elfenbenskysten",
          "Polen",
          "Italien",
          "Filippinerne",
          "Ecuador",
          "Burkina Faso",
          "Nya Zealand",
          "Gabon",
          "Guinea",
          "Storbritannien",
          "Ghana",
          "Rumænien",
          "Laos",
          "Uganda",
          "Guyana",
          "Oman",
          "Hviderusland",
          "Kirgisistan",
          "Senegal",
          "Syrien",
          "Cambodja",
          "Uruguay",
          "Tunesien",
          "Surinam",
          "Nepal",
          "Bangladesh",
          "Tadsjikistan",
          "Grækenland",
          "Nicaragua",
          "Eritrea",
          "Nordkorea",
          "Malawi",
          "Benin",
          "Honduras",
          "Liberia",
          "Bulgarien",
          "Cuba",
          "Guatemala",
          "Island",
          "Sydkorea",
          "Ungarn",
          "Portugal",
          "Jordan",
          "Serbien",
          "Aserbajdsjan",
          "Østrig",
          "De Forenede Arabiske Emirater",
          "Tjekkiet",
          "Panama",
          "Sierra Leone",
          "Irland",
          "Georgien",
          "Sri Lanka",
          "Litauen",
          "Letland",
          "Togo",
          "Kroatien",
          "Bosnien og Hercegovina",
          "Costa Rica",
          "Slovakiet",
          "Den Dominikanske republik",
          "Bhutan",
          "Estland",
          "Danmark",
          "Færøerne",
          "Grønland",
          "Nederlænderne",
          "Schweiz",
          "Guinea-Bissau",
          "Taiwan",
          "Moldova",
          "Belgien",
          "Lesotho",
          "Armenien",
          "Albanien",
          "Salomonøerne",
          "Ækvatorialguinea",
          "Burundi",
          "Haiti",
          "Rwanda",
          "Makedonien",
          "Djibouti",
          "Belize",
          "Israel",
          "El Salvador",
          "Slovenien",
          "Fiji",
          "Kuwait",
          "Swaziland",
          "Østtimor",
          "Montenegro",
          "Bahamas",
          "Vanuatu",
          "Qatar",
          "Gambia",
          "Jamaica",
          "Kosovo",
          "Libanon",
          "Cypern",
          "Brunei",
          "Trinidad og Tobago",
          "Kap Verde",
          "Samoa",
          "Luxembourg",
          "Comorerne",
          "Mauritius",
          "São Tomé og Principe",
          "Kiribati",
          "Dominica",
          "Tonga",
          "Mikronesien",
          "Singapore",
          "Bahrain",
          "Saint Lucia",
          "Andorra",
          "Palau",
          "Seychellerne",
          "Antigua og Barbuda",
          "Barbados",
          "Saint Vincent og Grenadinerne",
          "Grenada",
          "Malta",
          "Maldiverne",
          "Saint Kitts og Nevis",
          "Marshalløerne",
          "Liechtenstein",
          "San Marino",
          "Tuvalu",
          "Nauru",
          "Monaco",
          "Vatikanstaten"
        ],
        "default_country": [
          "Danmark"
        ],
        "default_country_code": [
          "DK"
        ],
        "postcode": [
          "####"
        ],
        "secondary_address": [
          "Hus ###",
          "# TH.",
          "#TV.",
          "# MF.",
          "# ST."
        ],
        "state": [
          "Region Nordjylland",
          "Region Midtjylland",
          "Region Syddanmark",
          "Region Hovedstaden",
          "Region Sjælland"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_root}#{street_suffix}",
          "#{street_prefix} #{street_root}#{street_suffix}",
          "#{Name.first_name}#{common_street_suffix}",
          "#{Name.last_name}#{common_street_suffix}"
        ],
        "street_prefix": [
          "Vester",
          "Øster",
          "Nørre",
          "Over",
          "Under"
        ],
        "street_root": [
          "Lærke",
          "Birke",
          "Vinkel",
          "Vibe",
          "Mølle",
          "Ring",
          "Skole",
          "Skov",
          "Ny",
          "Ege",
          "Sol",
          "Industri",
          "Kirke",
          "Park",
          "Strand",
          "Eng"
        ],
        "street_suffix": [
          "vej",
          "gade",
          "gyde",
          "allé"
        ]
      },
      "cell_phone": {
        "formats": [
          "20 ## ## ##",
          "30 ## ## ##",
          "40 ## ## ##"
        ]
      },
      "color": {
        "name": [
          "hvid",
          "sølv",
          "grå",
          "sort",
          "rød",
          "grøn",
          "blå",
          "gul",
          "lilla",
          "guld",
          "brun",
          "rosa]"
        ]
      },
      "commerce": {
        "department": [
          "Bøger",
          "Film",
          "Musik",
          "Spil",
          "Elektronik",
          "Computere",
          "Hus",
          "Have",
          "Værktøj",
          "Fødevarer",
          "Helse",
          "Skønhed",
          "Legetøj",
          "Tøj",
          "Sko",
          "Smykker",
          "Sport"
        ],
        "product_name": {
          "adjective": [
            "Lille",
            "Ergonomisk",
            "Robust",
            "Intelligent",
            "Sød",
            "Utrolig",
            "Fantastisk",
            "Praktisk",
            "Slank",
            "Fed",
            "Enorm",
            "Enkel",
            "Tung",
            "Let",
            "Multianvendelig",
            "Udholdende"
          ],
          "material": [
            "Stål",
            "Metal",
            "Træ",
            "Beton",
            "Plastic",
            "Bomuld",
            "Granit",
            "Gummi",
            "Latex",
            "Læder",
            "Silke",
            "Uld",
            "Ruskind",
            "Linned",
            "Marmor",
            "Jern",
            "Bronze",
            "Kobber",
            "Messing",
            "Aluminium",
            "Papir"
          ],
          "product": [
            "Stol",
            "Bil",
            "Computer",
            "Buks",
            "Trøje",
            "Bord",
            "Hat",
            "Tallerken",
            "Kniv",
            "Flaske",
            "Jakke",
            "Lampe",
            "Tastatur",
            "Taske",
            "Bænk",
            "Ur",
            "Pung"
          ]
        }
      },
      "company": {
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name} #{Name.last_name} #{suffix}"
        ],
        "suffix": [
          "A/S",
          "ApS",
          "I/S",
          "IVS",
          "Holding",
          "SMBA",
          "K/S",
          "SPW"
        ]
      },
      "internet": {
        "domain_suffix": [
          "dk",
          "nu",
          "com"
        ]
      },
      "name": {
        "first_name": [
          "Peter",
          "Jens",
          "Lars",
          "Michael",
          "Henrik",
          "Thomas",
          "Søren",
          "Jan",
          "Christian",
          "Niels",
          "Anne",
          "Kirsten",
          "Hanne",
          "Mette",
          "Anna",
          "Helle",
          "Susanne",
          "Lene",
          "Maria",
          "Marianne"
        ],
        "last_name": [
          "Nielsen",
          "Jensen",
          "Hansen",
          "Pedersen",
          "Andersen",
          "Christensen",
          "Larsen",
          "Sørensen",
          "Rasmussen",
          "Jørgensen"
        ],
        "name": [
          "#{first_name} #{last_name}",
          "#{prefix} #{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Dr.",
          "Prof.",
          "Cand.mag.",
          "Cand.jur."
        ],
        "title": {
          "descriptor": [
            "Leder",
            "Senior",
            "Fremtid",
            "Produkt",
            "National",
            "Regional",
            "Distrikt",
            "Central",
            "Global",
            "Kunde",
            "Investor",
            "Dynamic",
            "International",
            "Legacy",
            "Forward",
            "Intern",
            "HR",
            "Direktør",
            "Rektor"
          ],
          "job": [
            "Supervisor",
            "Officer",
            "Manager",
            "Ingeniør",
            "Specialist",
            "Direktør",
            "Koordinator",
            "Administrator",
            "Arkitekt",
            "Analytiker",
            "Designer",
            "Planner",
            "Tekniker",
            "Udvikler",
            "Producer",
            "Konsultant",
            "Assistant",
            "Agent",
            "Tillidsrepræsentant",
            "Strateg"
          ],
          "level": [
            "Solutions",
            "Program",
            "Brand",
            "Sikkerhed",
            "Research",
            "Marketing",
            "Directives",
            "Implementering",
            "Integration",
            "Funktionalitet",
            "Respons",
            "Paradigme",
            "Taktik",
            "Identitet",
            "Markeder",
            "Gruppe",
            "Division",
            "Applikationer",
            "Optimering",
            "Operationer",
            "Infrastruktur",
            "Intranet",
            "Kommunikation",
            "Web",
            "Branding",
            "Kvalitet",
            "Kontrol",
            "Mobilitet",
            "Regnskab",
            "Data",
            "Kreativ",
            "Konfiguration",
            "Interaktioner",
            "Faktorer",
            "Anvendelighed",
            "Metrik"
          ]
        }
      },
      "phone_number": {
        "country_code": [
          "45"
        ],
        "formats": [
          "## ## ## ##",
          "##-##-##-##"
        ]
      }
    },
    "hello": "hej",
    "welcome": "velkommen"
  },
  "de": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bestätigung gesendet am",
          "confirmation_token": "Bestätigungs-Token",
          "confirmed_at": "Bestätigt am",
          "created_at": "Erstellt am",
          "current_password": "Bisheriges Passwort",
          "current_sign_in_at": "Aktuelle Anmeldung am",
          "current_sign_in_ip": "IP der aktuellen Anmeldung",
          "email": "E-Mail",
          "encrypted_password": "Verschlüsseltes Passwort",
          "failed_attempts": "Fehlversuche",
          "last_sign_in_at": "Letzte Anmeldung am",
          "last_sign_in_ip": "IP der letzten Anmeldung",
          "locked_at": "Gesperrt am",
          "password": "Passwort",
          "password_confirmation": "Passwortbestätigung",
          "remember_created_at": "\"Angemeldet bleiben\" erstellt am",
          "remember_me": "Angemeldet bleiben",
          "reset_password_sent_at": "E-Mail zum Zurücksetzen des Passworts gesendet am",
          "reset_password_token": "Token zum Zurücksetzen des Passworts",
          "sign_in_count": "Anzahl der Anmeldungen",
          "unconfirmed_email": "Unbestätigte E-Mail-Adresse",
          "unlock_token": "Entsperrungs-Token",
          "updated_at": "Aktualisiert am"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Datensatz kann nicht gelöscht werden, da abhängige %{record} existieren.",
            "has_one": "Datensatz kann nicht gelöscht werden, da ein abhängiger %{record}-Datensatz existiert."
          }
        }
      },
      "models": {
        "user": {
          "one": "Benutzer",
          "other": "Benutzer"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "day_names": [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "etwa eine Stunde",
          "other": "etwa %{count} Stunden"
        },
        "about_x_months": {
          "one": "etwa ein Monat",
          "other": "etwa %{count} Monate"
        },
        "about_x_years": {
          "one": "etwa ein Jahr",
          "other": "etwa %{count} Jahre"
        },
        "almost_x_years": {
          "one": "fast ein Jahr",
          "other": "fast %{count} Jahre"
        },
        "half_a_minute": "eine halbe Minute",
        "less_than_x_minutes": {
          "one": "weniger als eine Minute",
          "other": "weniger als %{count} Minuten"
        },
        "less_than_x_seconds": {
          "one": "weniger als eine Sekunde",
          "other": "weniger als %{count} Sekunden"
        },
        "over_x_years": {
          "one": "mehr als ein Jahr",
          "other": "mehr als %{count} Jahre"
        },
        "x_days": {
          "one": "ein Tag",
          "other": "%{count} Tage"
        },
        "x_minutes": {
          "one": "eine Minute",
          "other": "%{count} Minuten"
        },
        "x_months": {
          "one": "ein Monat",
          "other": "%{count} Monate"
        },
        "x_seconds": {
          "one": "eine Sekunde",
          "other": "%{count} Sekunden"
        },
        "x_years": {
          "one": "ein Jahr",
          "other": "%{count} Jahre"
        }
      },
      "prompts": {
        "day": "Tag",
        "hour": "Stunde",
        "minute": "Minute",
        "month": "Monat",
        "second": "Sekunde",
        "year": "Jahr"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ihre E-Mail-Adresse wurde erfolgreich bestätigt.",
        "new": {
          "resend_confirmation_instructions": "Bestätigungsanleitung erneut senden"
        },
        "send_instructions": "In wenigen Minuten erhalten Sie eine E-Mail zur Bestätigung Ihrer Registrierung.",
        "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail zur Bestätigung Ihrer Registrierung."
      },
      "failure": {
        "already_authenticated": "Sie sind bereits angemeldet.",
        "inactive": "Ihr Konto ist noch nicht aktiv.",
        "invalid": "%{authentication_keys} oder Passwort ist ungültig.",
        "invited": "Du hast bereits eine Einladung erhalten. Nimm die Einladung an um dein Nutzerkonto zu erstellen.",
        "last_attempt": "Sie haben noch einen Versuch, bevor Ihr Konto gesperrt wird.",
        "locked": "Ihr Konto ist gesperrt.",
        "not_found_in_database": "%{authentication_keys} oder Passwort ist ungültig.",
        "timeout": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
        "unauthenticated": "Sie müssen sich anmelden oder registrieren, um fortzufahren.",
        "unconfirmed": "Sie müssen Ihr Konto bestätigen, bevor Sie fortfahren können."
      },
      "invitations": {
        "edit": {
          "header": "Setze ein Passwort",
          "submit_button": "Passwort setzen"
        },
        "invitation_removed": "Deine Einladung wurde gelöscht.",
        "invitation_token_invalid": "Der Einladungs-Code ist ungültig!",
        "new": {
          "header": "Einladung schicken",
          "submit_button": "Einladung schicken"
        },
        "no_invitations_remaining": "Es gibt keine weiteren Einladungen",
        "send_instructions": "Eine Einladung wurde an %{email} verschickt.",
        "updated": "Dein Passwort wurde gesetzt. Du bist nun angemeldet.",
        "updated_not_active": "Dein Passwort wurde gesetzt."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Mein Konto bestätigen",
          "confirm_account_link": "Konto bestätigen",
          "confirm_link_msg": "Sie können Ihr Konto über den untenstehenden Link bestätigen:",
          "greeting": "Willkommen %{recipient}!",
          "instruction": "Klicken Sie auf den folgenden Link, um Ihr Konto zu bestätigen:",
          "subject": "Bestätigung Ihres Kontos"
        },
        "email_changed": {
          "greeting": "Hallo %{recipient}!",
          "message": "Wir möchten Sie informieren, dass Ihre E-Mail-Adresse zu %{email} geändert wurde.",
          "message_unconfirmed": "Wir möchten Sie informieren, dass Ihre E-Mail-Adresse zu %{email} geändert wird.",
          "subject": "E-Mail-Adresse geändert"
        },
        "invitation_instructions": {
          "accept": "Einladung annehmen",
          "accept_until": "Diese Einladung ist gültig bis zum %{due_date}.",
          "hello": "Hallo %{email}",
          "ignore": "Wenn du die Einladung nicht annehmen willst, ignoriere diese E-Mail einfach. Es wird kein Benutzerkonto erstellt solange du nicht die Einladung mittels des Links oben annimmst.",
          "someone_invited_you": "Jemand hat dich zu %{url} eingeladen. Du kannst die Einladung mit dem Link unten annehmen.",
          "subject": "Einladung"
        },
        "password_change": {
          "greeting": "Hallo %{recipient}!",
          "message": "Wir möchten Sie darüber informieren, dass Ihr Passwort geändert wurde.",
          "subject": "Passwortänderung"
        },
        "reset_password_instructions": {
          "action": "Passwort ändern",
          "greeting": "Hallo %{recipient}!",
          "ignore_mail_msg": "Wenn Sie keine Änderung Ihres Passwortes angefordert haben, ignorieren Sie bitte diese E-Mail:",
          "instruction": "Jemand hat einen Link zum Ändern Ihres Passworts angefordert. Klicken Sie auf den folgenden Link, um Ihr Passwort zu ändern.",
          "instruction_2": "Ignorieren Sie diese E-Mail, wenn Sie kein neues Passwort angefordert haben.",
          "instruction_3": "Ihr Passwort wird erst geändert, wenn Sie den obigen Link nutzen und ein neues Passwort festlegen.",
          "no_changes_msg": "Ihr Passwort wird nicht geändert, bis Sie auf den obigen Link zugreifen und eine neues Passwort erstellen.",
          "password_change_link": "Passwort ändern",
          "request_reset_link_msg": "Jemand hat einen Link zur Änderungen Ihres Passwortes angefordert. Sie können dies durch den folgenden Link tun:",
          "subject": "Passwort zurücksetzen"
        },
        "unlock_instructions": {
          "account_lock_msg": "Ihr Konto wurde aufgrund einer übermäßigen Anzahl von erfolglosen Anmeldeversuchen gesperrt.",
          "action": "Mein Konto entsperren",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Klicken Sie auf den folgenden Link, um Ihr Konto zu entsperren:",
          "message": "Aufgrund zahlreicher fehlgeschlagener Anmeldeversuche wurde Ihr Konto gesperrt.",
          "subject": "Anweisungen zum Entsperren Ihres Kontos",
          "unlock_link": "Entsperren Sie Ihr Konto",
          "unlock_link_msg": "Klicken Sie auf den Link unten, um Ihr Konto zu entsperren:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Die Anmeldung mit Ihrem %{kind}-Konto war aufgrund des folgenden Grundes nicht möglich: \"%{reason}\".",
        "success": "Sie haben sich erfolgreich über Ihr %{kind}-Konto angemeldet."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Mein Passwort ändern",
          "change_your_password": "Ihr Passwort ändern",
          "confirm_new_password": "Neues Passwort bestätigen",
          "new_password": "Neues Passwort"
        },
        "new": {
          "forgot_your_password": "Haben Sie Ihr Passwort vergessen?",
          "send_me_reset_password_instructions": "Anweisungen zum Zurücksetzen meines Passworts senden"
        },
        "no_token": "Sie können diese Seite nicht nutzen, es sei denn, Sie stammen von einer Passwort-Zurücksetzen-E-Mail. Wenn dies der Fall ist, stellen Sie sicher, dass Sie die vollständige URL verwendet haben.",
        "send_instructions": "Sie erhalten in Kürze eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts.",
        "send_paranoid_instructions": "Wenn Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in Kürze eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts.",
        "updated": "Ihr Passwort wurde geändert. Sie sind jetzt angemeldet.",
        "updated_not_active": "Ihr Passwort wurde erfolgreich geändert."
      },
      "registrations": {
        "destroyed": "Ihr Konto wurde gelöscht. Wir hoffen, Sie bald wiederzusehen.",
        "edit": {
          "are_you_sure": "Sind Sie sicher, dass Sie das tun möchten?",
          "cancel_my_account": "Konto löschen",
          "currently_waiting_confirmation_for_email": "Bestätigung für %{email} ausstehend.",
          "leave_blank_if_you_don_t_want_to_change_it": "Leer lassen, wenn Sie es unverändert lassen möchten.",
          "title": "%{resource} bearbeiten",
          "unhappy": "Nicht zufrieden?",
          "update": "Änderungen speichern",
          "we_need_your_current_password_to_confirm_your_changes": "Zur Bestätigung geben Sie bitte Ihr aktuelles Passwort ein."
        },
        "new": {
          "sign_up": "Registrieren"
        },
        "signed_up": "Sie haben sich erfolgreich registriert.",
        "signed_up_but_inactive": "Ihre Registrierung war erfolgreich, Ihr Konto ist jedoch noch nicht aktiviert.",
        "signed_up_but_locked": "Ihre Registierung war erfolgreich, Ihr Konto ist jedoch gesperrt.",
        "signed_up_but_unconfirmed": "Sie erhalten in Kürze eine Bestätigungs-E-Mail. Bitte klicken Sie auf den darin enthaltenen Link, um Ihr Konto zu aktivieren.",
        "update_needs_confirmation": "Sie haben Ihre Daten aktualisiert. Eine Bestätigungs-E-Mail wird Ihnen zugesandt. Bitte klicken Sie auf den Link in der E-Mail, um Ihre Änderungen zu bestätigen.",
        "updated": "Ihre Einstellungen wurden aktualisiert.",
        "updated_but_not_signed_in": "Sie haben Ihre Daten aktualisiert, aber Sie müssen sich wegen einer Passwortänderung erneut anmelden."
      },
      "sessions": {
        "already_signed_out": "Sie sind bereits abgemeldet.",
        "new": {
          "sign_in": "Anmelden"
        },
        "signed_in": "Sie sind nun angemeldet.",
        "signed_out": "Sie haben sich erfolgreich abgemeldet."
      },
      "shared": {
        "links": {
          "back": "Zurück",
          "didn_t_receive_confirmation_instructions": "Keine Bestätigungs-E-Mail erhalten?",
          "didn_t_receive_unlock_instructions": "Keine Anweisungen zum Entsperren erhalten?",
          "forgot_your_password": "Passwort vergessen?",
          "sign_in": "Anmelden",
          "sign_in_with_provider": "Mit %{provider} anmelden",
          "sign_up": "Registrieren"
        },
        "minimum_password_length": {
          "one": "(mindestens %{count} Zeichen)",
          "other": "(mindestens %{count} Zeichen)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Anweisungen zum Entsperren erneut senden"
        },
        "send_instructions": "Sie erhalten in Kürze eine E-Mail mit Anweisungen, wie Sie Ihr Konto entsperren können.",
        "send_paranoid_instructions": "Wenn Ihre E-Mail-Adresse in unserer Datenbank verzeichnet ist, erhalten Sie Anweisungen zur Entsperrung Ihres Kontos.",
        "unlocked": "Ihr Konto wurde entsperrt. Bitte melden Sie sich jetzt an."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Weiterleitung zu '%{redirect_url}' ist nicht gestattet."
      },
      "passwords": {
        "missing_email": "Sie müssen eine E-Mail-Adresse angeben.",
        "missing_passwords": "Sie müssen die Felder 'Passwort' und 'Passwortbestätigung' ausfüllen.",
        "missing_redirect_url": "Es fehlt die URL zu Weiterleitung.",
        "not_allowed_redirect_url": "Weiterleitung zu '%{redirect_url}' ist nicht gestattet.",
        "password_not_required": "Dieser Account benötigt kein Passwort. Melden Sie sich stattdessen über Ihren Account bei '%{provider}' an.",
        "sended": "Ein E-Mail mit der Anleitung zum Zurücksetzen Ihres Passwortes wurde an '%{email}' gesendet.",
        "successfully_updated": "Ihr Passwort wurde erfolgreich aktualisiert.",
        "user_not_found": "Der Benutzer mit der E-Mail-Adresse '%{email}' kann nicht gefunden werden."
      },
      "registrations": {
        "account_to_destroy_not_found": "Der zu löschende Account kann nicht gefunden werden.",
        "account_with_uid_destroyed": "Account mit der uid '%{uid}' wurde gelöscht.",
        "email_already_exists": "Es gibt bereits einen Account für '%{email}'.",
        "missing_confirm_success_url": "Fehlender Paramter 'confirm_success_url'.",
        "redirect_url_not_allowed": "Weiterleitung zu '%{redirect_url}' ist nicht gestattet.",
        "user_not_found": "Benutzer kann nicht gefunden werden."
      },
      "sessions": {
        "bad_credentials": "Ungültige Anmeldeinformationen. Bitte versuchen Sie es erneut.",
        "not_confirmed": "Eine Bestätigungs-E-Mail wurde an Ihre Adresse '%{email}' gesendet. Sie müssen der Anleitung in der E-Mail folgen, um Ihren Account zu aktivieren.",
        "not_supported": "Verwenden Sie POST /sign_in zur Anmeldung. GET wird nicht unterstützt.",
        "user_not_found": "Benutzer wurde nicht gefunden oder konnte nicht angemeldet werden."
      },
      "token_validations": {
        "invalid": "Ungültige Anmeldeinformationen"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "muss akzeptiert werden",
        "already_confirmed": "Bereits bestätigt. Versuchen Sie, sich anzumelden.",
        "blank": "muss ausgefüllt werden",
        "confirmation": "stimmt nicht mit %{attribute} überein",
        "confirmation_period_expired": "Die Bestätigungsfrist von %{period} ist abgelaufen. Bitte erneut anfordern.",
        "empty": "muss ausgefüllt werden",
        "equal_to": "muss genau %{count} sein",
        "even": "muss gerade sein",
        "exclusion": "ist nicht verfügbar",
        "expired": "Der Link ist abgelaufen. Bitte erneut anfordern.",
        "greater_than": "muss größer als %{count} sein",
        "greater_than_or_equal_to": "muss größer oder gleich %{count} sein",
        "inclusion": "ist kein gültiger Wert",
        "invalid": "ist nicht gültig",
        "less_than": "muss kleiner als %{count} sein",
        "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
        "model_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
        "not_a_number": "ist keine Zahl",
        "not_an_integer": "muss ganzzahlig sein",
        "not_email": "ist keine E-Mail-Adresse",
        "not_found": "Nicht gefunden.",
        "not_locked": "Nicht gesperrt.",
        "not_saved": {
          "one": "%{resource} konnte wegen eines Fehlers nicht gespeichert werden:",
          "other": "%{count} Fehler verhinderten das Speichern von %{resource}:"
        },
        "odd": "muss ungerade sein",
        "other_than": "darf nicht gleich %{count} sein",
        "password_too_long": "ist zu lang",
        "present": "darf nicht ausgefüllt werden",
        "required": "muss ausgefüllt werden",
        "taken": "ist bereits vergeben",
        "too_long": {
          "one": "ist zu lang (mehr als %{count} Zeichen)",
          "other": "ist zu lang (mehr als %{count} Zeichen)"
        },
        "too_short": {
          "one": "ist zu kurz (weniger als %{count} Zeichen)",
          "other": "ist zu kurz (weniger als %{count} Zeichen)"
        },
        "validate_account_update_params": "Bitte übermitteln sie vollständige Informationen zur Aktualisierung im Body des Requests.",
        "validate_sign_up_params": "Bitte übermitteln sie vollständige Anmeldeinformationen im Body des Requests.",
        "wrong_length": {
          "one": "hat die falsche Länge (muss genau %{count} Zeichen haben)",
          "other": "hat die falsche Länge (muss genau %{count} Zeichen haben)"
        }
      },
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#",
          "##a",
          "##b",
          "##c"
        ],
        "city": [
          "#{city_prefix} #{Name.first_name}#{city_suffix}",
          "#{city_prefix} #{Name.first_name}",
          "#{Name.first_name}#{city_suffix}",
          "#{Name.last_name}#{city_suffix}"
        ],
        "city_prefix": [
          "Nord",
          "Ost",
          "West",
          "Süd",
          "Neu",
          "Alt",
          "Bad",
          "Groß",
          "Klein",
          "Schön"
        ],
        "city_suffix": [
          "stadt",
          "dorf",
          "land",
          "scheid",
          "burg",
          "berg",
          "heim",
          "hagen",
          "feld",
          "brunn",
          "grün"
        ],
        "country": [
          "Ägypten",
          "Äquatorialguinea",
          "Äthiopien",
          "Österreich",
          "Afghanistan",
          "Albanien",
          "Algerien",
          "Amerikanisch-Samoa",
          "Amerikanische Jungferninseln",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarktis",
          "Antigua und Barbuda",
          "Argentinien",
          "Armenien",
          "Aruba",
          "Aserbaidschan",
          "Australien",
          "Bahamas",
          "Bahrain",
          "Bangladesch",
          "Barbados",
          "Belarus",
          "Belgien",
          "Belize",
          "Benin",
          "die Bermudas",
          "Bhutan",
          "Bolivien",
          "Bosnien und Herzegowina",
          "Botsuana",
          "Bouvetinsel",
          "Brasilien",
          "Britische Jungferninseln",
          "Britisches Territorium im Indischen Ozean",
          "Brunei Darussalam",
          "Bulgarien",
          "Burkina Faso",
          "Burundi",
          "Chile",
          "China",
          "Cookinseln",
          "Costa Rica",
          "Dänemark",
          "Demokratische Republik Kongo",
          "Demokratische Volksrepublik Korea",
          "Deutschland",
          "Dominica",
          "Dominikanische Republik",
          "Dschibuti",
          "Ecuador",
          "El Salvador",
          "Eritrea",
          "Estland",
          "Färöer",
          "Falklandinseln",
          "Fidschi",
          "Finnland",
          "Frankreich",
          "Französisch-Guayana",
          "Französisch-Polynesien",
          "Französische Gebiete im südlichen Indischen Ozean",
          "Gabun",
          "Gambia",
          "Georgien",
          "Ghana",
          "Gibraltar",
          "Grönland",
          "Grenada",
          "Griechenland",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard und McDonaldinseln",
          "Honduras",
          "Hongkong",
          "Indien",
          "Indonesien",
          "Irak",
          "Iran",
          "Irland",
          "Island",
          "Israel",
          "Italien",
          "Jamaika",
          "Japan",
          "Jemen",
          "Jordanien",
          "Jugoslawien",
          "Kaimaninseln",
          "Kambodscha",
          "Kamerun",
          "Kanada",
          "Kap Verde",
          "Kasachstan",
          "Katar",
          "Kenia",
          "Kirgisistan",
          "Kiribati",
          "Kleinere amerikanische Überseeinseln",
          "Kokosinseln",
          "Kolumbien",
          "Komoren",
          "Kongo",
          "Kroatien",
          "Kuba",
          "Kuwait",
          "Laos",
          "Lesotho",
          "Lettland",
          "Libanon",
          "Liberia",
          "Libyen",
          "Liechtenstein",
          "Litauen",
          "Luxemburg",
          "Macau",
          "Madagaskar",
          "Malawi",
          "Malaysia",
          "Malediven",
          "Mali",
          "Malta",
          "ehemalige jugoslawische Republik Mazedonien",
          "Marokko",
          "Marshallinseln",
          "Martinique",
          "Mauretanien",
          "Mauritius",
          "Mayotte",
          "Mexiko",
          "Mikronesien",
          "Monaco",
          "Mongolei",
          "Montserrat",
          "Mosambik",
          "Myanmar",
          "Nördliche Marianen",
          "Namibia",
          "Nauru",
          "Nepal",
          "Neukaledonien",
          "Neuseeland",
          "Nicaragua",
          "Niederländische Antillen",
          "Niederlande",
          "Niger",
          "Nigeria",
          "Niue",
          "Norfolkinsel",
          "Norwegen",
          "Oman",
          "Osttimor",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua-Neuguinea",
          "Paraguay",
          "Peru",
          "Philippinen",
          "Pitcairninseln",
          "Polen",
          "Portugal",
          "Puerto Rico",
          "Réunion",
          "Republik Korea",
          "Republik Moldau",
          "Ruanda",
          "Rumänien",
          "Russische Föderation",
          "São Tomé und Príncipe",
          "Südafrika",
          "Südgeorgien und Südliche Sandwichinseln",
          "Salomonen",
          "Sambia",
          "Samoa",
          "San Marino",
          "Saudi-Arabien",
          "Schweden",
          "Schweiz",
          "Senegal",
          "Seychellen",
          "Sierra Leone",
          "Simbabwe",
          "Singapur",
          "Slowakei",
          "Slowenien",
          "Somalien",
          "Spanien",
          "Sri Lanka",
          "St. Helena",
          "St. Kitts und Nevis",
          "St. Lucia",
          "St. Pierre und Miquelon",
          "St. Vincent und die Grenadinen",
          "Sudan",
          "Surinam",
          "Svalbard und Jan Mayen",
          "Swasiland",
          "Syrien",
          "Türkei",
          "Tadschikistan",
          "Taiwan",
          "Tansania",
          "Thailand",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad und Tobago",
          "Tschad",
          "Tschechische Republik",
          "Tunesien",
          "Turkmenistan",
          "Turks- und Caicosinseln",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "Ungarn",
          "Uruguay",
          "Usbekistan",
          "Vanuatu",
          "Vatikanstadt",
          "Venezuela",
          "Vereinigte Arabische Emirate",
          "Vereinigte Staaten",
          "Vereinigtes Königreich",
          "Vietnam",
          "Wallis und Futuna",
          "Weihnachtsinsel",
          "Westsahara",
          "Zentralafrikanische Republik",
          "Zypern"
        ],
        "default_country": [
          "Deutschland"
        ],
        "default_country_code": [
          "DE"
        ],
        "postcode": [
          "#####",
          "#####"
        ],
        "secondary_address": [
          "Apt. ###",
          "Zimmer ###",
          "# OG"
        ],
        "state": [
          "Baden-Württemberg",
          "Bayern",
          "Berlin",
          "Brandenburg",
          "Bremen",
          "Hamburg",
          "Hessen",
          "Mecklenburg-Vorpommern",
          "Niedersachsen",
          "Nordrhein-Westfalen",
          "Rheinland-Pfalz",
          "Saarland",
          "Sachsen",
          "Sachsen-Anhalt",
          "Schleswig-Holstein",
          "Thüringen"
        ],
        "state_abbr": [
          "BW",
          "BY",
          "BE",
          "BB",
          "HB",
          "HH",
          "HE",
          "MV",
          "NI",
          "NW",
          "RP",
          "SL",
          "SN",
          "ST",
          "SH",
          "TH"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_root}"
        ],
        "street_root": [
          "Ackerweg",
          "Adalbert-Stifter-Str.",
          "Adalbertstr.",
          "Adolf-Baeyer-Str.",
          "Adolf-Kaschny-Str.",
          "Adolf-Reichwein-Str.",
          "Adolfsstr.",
          "Ahornweg",
          "Ahrstr.",
          "Akazienweg",
          "Albert-Einstein-Str.",
          "Albert-Schweitzer-Str.",
          "Albertus-Magnus-Str.",
          "Albert-Zarthe-Weg",
          "Albin-Edelmann-Str.",
          "Albrecht-Haushofer-Str.",
          "Aldegundisstr.",
          "Alexanderstr.",
          "Alfred-Delp-Str.",
          "Alfred-Kubin-Str.",
          "Alfred-Stock-Str.",
          "Alkenrather Str.",
          "Allensteiner Str.",
          "Alsenstr.",
          "Alt Steinbücheler Weg",
          "Alte Garten",
          "Alte Heide",
          "Alte Landstr.",
          "Alte Ziegelei",
          "Altenberger Str.",
          "Altenhof",
          "Alter Grenzweg",
          "Altstadtstr.",
          "Am Alten Gaswerk",
          "Am Alten Schafstall",
          "Am Arenzberg",
          "Am Benthal",
          "Am Birkenberg",
          "Am Blauen Berg",
          "Am Borsberg",
          "Am Brungen",
          "Am Büchelter Hof",
          "Am Buttermarkt",
          "Am Ehrenfriedhof",
          "Am Eselsdamm",
          "Am Falkenberg",
          "Am Frankenberg",
          "Am Gesundheitspark",
          "Am Gierlichshof",
          "Am Graben",
          "Am Hagelkreuz",
          "Am Hang",
          "Am Heidkamp",
          "Am Hemmelrather Hof",
          "Am Hofacker",
          "Am Hohen Ufer",
          "Am Höllers Eck",
          "Am Hühnerberg",
          "Am Jägerhof",
          "Am Junkernkamp",
          "Am Kemperstiegel",
          "Am Kettnersbusch",
          "Am Kiesberg",
          "Am Klösterchen",
          "Am Knechtsgraben",
          "Am Köllerweg",
          "Am Köttersbach",
          "Am Kreispark",
          "Am Kronefeld",
          "Am Küchenhof",
          "Am Kühnsbusch",
          "Am Lindenfeld",
          "Am Märchen",
          "Am Mittelberg",
          "Am Mönchshof",
          "Am Mühlenbach",
          "Am Neuenhof",
          "Am Nonnenbruch",
          "Am Plattenbusch",
          "Am Quettinger Feld",
          "Am Rosenhügel",
          "Am Sandberg",
          "Am Scherfenbrand",
          "Am Schokker",
          "Am Silbersee",
          "Am Sonnenhang",
          "Am Sportplatz",
          "Am Stadtpark",
          "Am Steinberg",
          "Am Telegraf",
          "Am Thelenhof",
          "Am Vogelkreuz",
          "Am Vogelsang",
          "Am Vogelsfeldchen",
          "Am Wambacher Hof",
          "Am Wasserturm",
          "Am Weidenbusch",
          "Am Weiher",
          "Am Weingarten",
          "Am Werth",
          "Amselweg",
          "An den Irlen",
          "An den Rheinauen",
          "An der Bergerweide",
          "An der Dingbank",
          "An der Evangelischen Kirche",
          "An der Evgl. Kirche",
          "An der Feldgasse",
          "An der Fettehenne",
          "An der Kante",
          "An der Laach",
          "An der Lehmkuhle",
          "An der Lichtenburg",
          "An der Luisenburg",
          "An der Robertsburg",
          "An der Schmitten",
          "An der Schusterinsel",
          "An der Steinrütsch",
          "An St. Andreas",
          "An St. Remigius",
          "Andreasstr.",
          "Ankerweg",
          "Annette-Kolb-Str.",
          "Apenrader Str.",
          "Arnold-Ohletz-Str.",
          "Atzlenbacher Str.",
          "Auerweg",
          "Auestr.",
          "Auf dem Acker",
          "Auf dem Blahnenhof",
          "Auf dem Bohnbüchel",
          "Auf dem Bruch",
          "Auf dem End",
          "Auf dem Forst",
          "Auf dem Herberg",
          "Auf dem Lehn",
          "Auf dem Stein",
          "Auf dem Weierberg",
          "Auf dem Weiherhahn",
          "Auf den Reien",
          "Auf der Donnen",
          "Auf der Grieße",
          "Auf der Ohmer",
          "Auf der Weide",
          "Auf'm Berg",
          "Auf'm Kamp",
          "Augustastr.",
          "August-Kekulé-Str.",
          "A.-W.-v.-Hofmann-Str.",
          "Bahnallee",
          "Bahnhofstr.",
          "Baltrumstr.",
          "Bamberger Str.",
          "Baumberger Str.",
          "Bebelstr.",
          "Beckers Kämpchen",
          "Beerenstr.",
          "Beethovenstr.",
          "Behringstr.",
          "Bendenweg",
          "Bensberger Str.",
          "Benzstr.",
          "Bergische Landstr.",
          "Bergstr.",
          "Berliner Platz",
          "Berliner Str.",
          "Bernhard-Letterhaus-Str.",
          "Bernhard-Lichtenberg-Str.",
          "Bernhard-Ridder-Str.",
          "Bernsteinstr.",
          "Bertha-Middelhauve-Str.",
          "Bertha-von-Suttner-Str.",
          "Bertolt-Brecht-Str.",
          "Berzeliusstr.",
          "Bielertstr.",
          "Biesenbach",
          "Billrothstr.",
          "Birkenbergstr.",
          "Birkengartenstr.",
          "Birkenweg",
          "Bismarckstr.",
          "Bitterfelder Str.",
          "Blankenburg",
          "Blaukehlchenweg",
          "Blütenstr.",
          "Boberstr.",
          "Böcklerstr.",
          "Bodelschwinghstr.",
          "Bodestr.",
          "Bogenstr.",
          "Bohnenkampsweg",
          "Bohofsweg",
          "Bonifatiusstr.",
          "Bonner Str.",
          "Borkumstr.",
          "Bornheimer Str.",
          "Borsigstr.",
          "Borussiastr.",
          "Bracknellstr.",
          "Brahmsweg",
          "Brandenburger Str.",
          "Breidenbachstr.",
          "Breslauer Str.",
          "Bruchhauser Str.",
          "Brückenstr.",
          "Brucknerstr.",
          "Brüder-Bonhoeffer-Str.",
          "Buchenweg",
          "Bürgerbuschweg",
          "Burgloch",
          "Burgplatz",
          "Burgstr.",
          "Burgweg",
          "Bürriger Weg",
          "Burscheider Str.",
          "Buschkämpchen",
          "Butterheider Str.",
          "Carl-Duisberg-Platz",
          "Carl-Duisberg-Str.",
          "Carl-Leverkus-Str.",
          "Carl-Maria-von-Weber-Platz",
          "Carl-Maria-von-Weber-Str.",
          "Carlo-Mierendorff-Str.",
          "Carl-Rumpff-Str.",
          "Carl-von-Ossietzky-Str.",
          "Charlottenburger Str.",
          "Christian-Heß-Str.",
          "Claasbruch",
          "Clemens-Winkler-Str.",
          "Concordiastr.",
          "Cranachstr.",
          "Dahlemer Str.",
          "Daimlerstr.",
          "Damaschkestr.",
          "Danziger Str.",
          "Debengasse",
          "Dechant-Fein-Str.",
          "Dechant-Krey-Str.",
          "Deichtorstr.",
          "Dhünnberg",
          "Dhünnstr.",
          "Dianastr.",
          "Diedenhofener Str.",
          "Diepental",
          "Diepenthaler Str.",
          "Dieselstr.",
          "Dillinger Str.",
          "Distelkamp",
          "Dohrgasse",
          "Domblick",
          "Dönhoffstr.",
          "Dornierstr.",
          "Drachenfelsstr.",
          "Dr.-August-Blank-Str.",
          "Dresdener Str.",
          "Driescher Hecke",
          "Drosselweg",
          "Dudweilerstr.",
          "Dünenweg",
          "Dünfelder Str.",
          "Dünnwalder Grenzweg",
          "Düppeler Str.",
          "Dürerstr.",
          "Dürscheider Weg",
          "Düsseldorfer Str.",
          "Edelrather Weg",
          "Edmund-Husserl-Str.",
          "Eduard-Spranger-Str.",
          "Ehrlichstr.",
          "Eichenkamp",
          "Eichenweg",
          "Eidechsenweg",
          "Eifelstr.",
          "Eifgenstr.",
          "Eintrachtstr.",
          "Elbestr.",
          "Elisabeth-Langgässer-Str.",
          "Elisabethstr.",
          "Elisabeth-von-Thadden-Str.",
          "Elisenstr.",
          "Elsa-Brändström-Str.",
          "Elsbachstr.",
          "Else-Lasker-Schüler-Str.",
          "Elsterstr.",
          "Emil-Fischer-Str.",
          "Emil-Nolde-Str.",
          "Engelbertstr.",
          "Engstenberger Weg",
          "Entenpfuhl",
          "Erbelegasse",
          "Erftstr.",
          "Erfurter Str.",
          "Erich-Heckel-Str.",
          "Erich-Klausener-Str.",
          "Erich-Ollenhauer-Str.",
          "Erlenweg",
          "Ernst-Bloch-Str.",
          "Ernst-Ludwig-Kirchner-Str.",
          "Erzbergerstr.",
          "Eschenallee",
          "Eschenweg",
          "Esmarchstr.",
          "Espenweg",
          "Euckenstr.",
          "Eulengasse",
          "Eulenkamp",
          "Ewald-Flamme-Str.",
          "Ewald-Röll-Str.",
          "Fährstr.",
          "Farnweg",
          "Fasanenweg",
          "Faßbacher Hof",
          "Felderstr.",
          "Feldkampstr.",
          "Feldsiefer Weg",
          "Feldsiefer Wiesen",
          "Feldstr.",
          "Feldtorstr.",
          "Felix-von-Roll-Str.",
          "Ferdinand-Lassalle-Str.",
          "Fester Weg",
          "Feuerbachstr.",
          "Feuerdornweg",
          "Fichtenweg",
          "Fichtestr.",
          "Finkelsteinstr.",
          "Finkenweg",
          "Fixheider Str.",
          "Flabbenhäuschen",
          "Flensburger Str.",
          "Fliederweg",
          "Florastr.",
          "Florianweg",
          "Flotowstr.",
          "Flurstr.",
          "Föhrenweg",
          "Fontanestr.",
          "Forellental",
          "Fortunastr.",
          "Franz-Esser-Str.",
          "Franz-Hitze-Str.",
          "Franz-Kail-Str.",
          "Franz-Marc-Str.",
          "Freiburger Str.",
          "Freiheitstr.",
          "Freiherr-vom-Stein-Str.",
          "Freudenthal",
          "Freudenthaler Weg",
          "Fridtjof-Nansen-Str.",
          "Friedenberger Str.",
          "Friedensstr.",
          "Friedhofstr.",
          "Friedlandstr.",
          "Friedlieb-Ferdinand-Runge-Str.",
          "Friedrich-Bayer-Str.",
          "Friedrich-Bergius-Platz",
          "Friedrich-Ebert-Platz",
          "Friedrich-Ebert-Str.",
          "Friedrich-Engels-Str.",
          "Friedrich-List-Str.",
          "Friedrich-Naumann-Str.",
          "Friedrich-Sertürner-Str.",
          "Friedrichstr.",
          "Friedrich-Weskott-Str.",
          "Friesenweg",
          "Frischenberg",
          "Fritz-Erler-Str.",
          "Fritz-Henseler-Str.",
          "Fröbelstr.",
          "Fürstenbergplatz",
          "Fürstenbergstr.",
          "Gabriele-Münter-Str.",
          "Gartenstr.",
          "Gebhardstr.",
          "Geibelstr.",
          "Gellertstr.",
          "Georg-von-Vollmar-Str.",
          "Gerhard-Domagk-Str.",
          "Gerhart-Hauptmann-Str.",
          "Gerichtsstr.",
          "Geschwister-Scholl-Str.",
          "Gezelinallee",
          "Gierener Weg",
          "Ginsterweg",
          "Gisbert-Cremer-Str.",
          "Glücksburger Str.",
          "Gluckstr.",
          "Gneisenaustr.",
          "Goetheplatz",
          "Goethestr.",
          "Golo-Mann-Str.",
          "Görlitzer Str.",
          "Görresstr.",
          "Graebestr.",
          "Graf-Galen-Platz",
          "Gregor-Mendel-Str.",
          "Greifswalder Str.",
          "Grillenweg",
          "Gronenborner Weg",
          "Große Kirchstr.",
          "Grunder Wiesen",
          "Grundermühle",
          "Grundermühlenhof",
          "Grundermühlenweg",
          "Grüner Weg",
          "Grunewaldstr.",
          "Grünstr.",
          "Günther-Weisenborn-Str.",
          "Gustav-Freytag-Str.",
          "Gustav-Heinemann-Str.",
          "Gustav-Radbruch-Str.",
          "Gut Reuschenberg",
          "Gutenbergstr.",
          "Haberstr.",
          "Habichtgasse",
          "Hafenstr.",
          "Hagenauer Str.",
          "Hahnenblecher",
          "Halenseestr.",
          "Halfenleimbach",
          "Hallesche Str.",
          "Halligstr.",
          "Hamberger Str.",
          "Hammerweg",
          "Händelstr.",
          "Hannah-Höch-Str.",
          "Hans-Arp-Str.",
          "Hans-Gerhard-Str.",
          "Hans-Sachs-Str.",
          "Hans-Schlehahn-Str.",
          "Hans-von-Dohnanyi-Str.",
          "Hardenbergstr.",
          "Haselweg",
          "Hauptstr.",
          "Haus-Vorster-Str.",
          "Hauweg",
          "Havelstr.",
          "Havensteinstr.",
          "Haydnstr.",
          "Hebbelstr.",
          "Heckenweg",
          "Heerweg",
          "Hegelstr.",
          "Heidberg",
          "Heidehöhe",
          "Heidestr.",
          "Heimstättenweg",
          "Heinrich-Böll-Str.",
          "Heinrich-Brüning-Str.",
          "Heinrich-Claes-Str.",
          "Heinrich-Heine-Str.",
          "Heinrich-Hörlein-Str.",
          "Heinrich-Lübke-Str.",
          "Heinrich-Lützenkirchen-Weg",
          "Heinrichstr.",
          "Heinrich-Strerath-Str.",
          "Heinrich-von-Kleist-Str.",
          "Heinrich-von-Stephan-Str.",
          "Heisterbachstr.",
          "Helenenstr.",
          "Helmestr.",
          "Hemmelrather Weg",
          "Henry-T.-v.-Böttinger-Str.",
          "Herderstr.",
          "Heribertstr.",
          "Hermann-Ehlers-Str.",
          "Hermann-Hesse-Str.",
          "Hermann-König-Str.",
          "Hermann-Löns-Str.",
          "Hermann-Milde-Str.",
          "Hermann-Nörrenberg-Str.",
          "Hermann-von-Helmholtz-Str.",
          "Hermann-Waibel-Str.",
          "Herzogstr.",
          "Heymannstr.",
          "Hindenburgstr.",
          "Hirzenberg",
          "Hitdorfer Kirchweg",
          "Hitdorfer Str.",
          "Höfer Mühle",
          "Höfer Weg",
          "Hohe Str.",
          "Höhenstr.",
          "Höltgestal",
          "Holunderweg",
          "Holzer Weg",
          "Holzer Wiesen",
          "Hornpottweg",
          "Hubertusweg",
          "Hufelandstr.",
          "Hufer Weg",
          "Humboldtstr.",
          "Hummelsheim",
          "Hummelweg",
          "Humperdinckstr.",
          "Hüscheider Gärten",
          "Hüscheider Str.",
          "Hütte",
          "Ilmstr.",
          "Im Bergischen Heim",
          "Im Bruch",
          "Im Buchenhain",
          "Im Bühl",
          "Im Burgfeld",
          "Im Dorf",
          "Im Eisholz",
          "Im Friedenstal",
          "Im Frohental",
          "Im Grunde",
          "Im Hederichsfeld",
          "Im Jücherfeld",
          "Im Kalkfeld",
          "Im Kirberg",
          "Im Kirchfeld",
          "Im Kreuzbruch",
          "Im Mühlenfeld",
          "Im Nesselrader Kamp",
          "Im Oberdorf",
          "Im Oberfeld",
          "Im Rosengarten",
          "Im Rottland",
          "Im Scheffengarten",
          "Im Staderfeld",
          "Im Steinfeld",
          "Im Weidenblech",
          "Im Winkel",
          "Im Ziegelfeld",
          "Imbach",
          "Imbacher Weg",
          "Immenweg",
          "In den Blechenhöfen",
          "In den Dehlen",
          "In der Birkenau",
          "In der Dasladen",
          "In der Felderhütten",
          "In der Hartmannswiese",
          "In der Höhle",
          "In der Schaafsdellen",
          "In der Wasserkuhl",
          "In der Wüste",
          "In Holzhausen",
          "Insterstr.",
          "Jacob-Fröhlen-Str.",
          "Jägerstr.",
          "Jahnstr.",
          "Jakob-Eulenberg-Weg",
          "Jakobistr.",
          "Jakob-Kaiser-Str.",
          "Jenaer Str.",
          "Johannes-Baptist-Str.",
          "Johannes-Dott-Str.",
          "Johannes-Popitz-Str.",
          "Johannes-Wislicenus-Str.",
          "Johannisburger Str.",
          "Johann-Janssen-Str.",
          "Johann-Wirtz-Weg",
          "Josefstr.",
          "Jüch",
          "Julius-Doms-Str.",
          "Julius-Leber-Str.",
          "Kaiserplatz",
          "Kaiserstr.",
          "Kaiser-Wilhelm-Allee",
          "Kalkstr.",
          "Kämpchenstr.",
          "Kämpenwiese",
          "Kämper Weg",
          "Kamptalweg",
          "Kanalstr.",
          "Kandinskystr.",
          "Kantstr.",
          "Kapellenstr.",
          "Karl-Arnold-Str.",
          "Karl-Bosch-Str.",
          "Karl-Bückart-Str.",
          "Karl-Carstens-Ring",
          "Karl-Friedrich-Goerdeler-Str.",
          "Karl-Jaspers-Str.",
          "Karl-König-Str.",
          "Karl-Krekeler-Str.",
          "Karl-Marx-Str.",
          "Karlstr.",
          "Karl-Ulitzka-Str.",
          "Karl-Wichmann-Str.",
          "Karl-Wingchen-Str.",
          "Käsenbrod",
          "Käthe-Kollwitz-Str.",
          "Katzbachstr.",
          "Kerschensteinerstr.",
          "Kiefernweg",
          "Kieler Str.",
          "Kieselstr.",
          "Kiesweg",
          "Kinderhausen",
          "Kleiberweg",
          "Kleine Kirchstr.",
          "Kleingansweg",
          "Kleinheider Weg",
          "Klief",
          "Kneippstr.",
          "Knochenbergsweg",
          "Kochergarten",
          "Kocherstr.",
          "Kockelsberg",
          "Kolberger Str.",
          "Kolmarer Str.",
          "Kölner Gasse",
          "Kölner Str.",
          "Kolpingstr.",
          "Königsberger Platz",
          "Konrad-Adenauer-Platz",
          "Köpenicker Str.",
          "Kopernikusstr.",
          "Körnerstr.",
          "Köschenberg",
          "Köttershof",
          "Kreuzbroicher Str.",
          "Kreuzkamp",
          "Krummer Weg",
          "Kruppstr.",
          "Kuhlmannweg",
          "Kump",
          "Kumper Weg",
          "Kunstfeldstr.",
          "Küppersteger Str.",
          "Kursiefen",
          "Kursiefer Weg",
          "Kurtekottenweg",
          "Kurt-Schumacher-Ring",
          "Kyllstr.",
          "Langenfelder Str.",
          "Längsleimbach",
          "Lärchenweg",
          "Legienstr.",
          "Lehner Mühle",
          "Leichlinger Str.",
          "Leimbacher Hof",
          "Leinestr.",
          "Leineweberstr.",
          "Leipziger Str.",
          "Lerchengasse",
          "Lessingstr.",
          "Libellenweg",
          "Lichstr.",
          "Liebigstr.",
          "Lindenstr.",
          "Lingenfeld",
          "Linienstr.",
          "Lippe",
          "Löchergraben",
          "Löfflerstr.",
          "Loheweg",
          "Lohrbergstr.",
          "Lohrstr.",
          "Löhstr.",
          "Lortzingstr.",
          "Lötzener Str.",
          "Löwenburgstr.",
          "Lucasstr.",
          "Ludwig-Erhard-Platz",
          "Ludwig-Girtler-Str.",
          "Ludwig-Knorr-Str.",
          "Luisenstr.",
          "Lupinenweg",
          "Lurchenweg",
          "Lützenkirchener Str.",
          "Lycker Str.",
          "Maashofstr.",
          "Manforter Str.",
          "Marc-Chagall-Str.",
          "Maria-Dresen-Str.",
          "Maria-Terwiel-Str.",
          "Marie-Curie-Str.",
          "Marienburger Str.",
          "Mariendorfer Str.",
          "Marienwerderstr.",
          "Marie-Schlei-Str.",
          "Marktplatz",
          "Markusweg",
          "Martin-Buber-Str.",
          "Martin-Heidegger-Str.",
          "Martin-Luther-Str.",
          "Masurenstr.",
          "Mathildenweg",
          "Maurinusstr.",
          "Mauspfad",
          "Max-Beckmann-Str.",
          "Max-Delbrück-Str.",
          "Max-Ernst-Str.",
          "Max-Holthausen-Platz",
          "Max-Horkheimer-Str.",
          "Max-Liebermann-Str.",
          "Max-Pechstein-Str.",
          "Max-Planck-Str.",
          "Max-Scheler-Str.",
          "Max-Schönenberg-Str.",
          "Maybachstr.",
          "Meckhofer Feld",
          "Meisenweg",
          "Memelstr.",
          "Menchendahler Str.",
          "Mendelssohnstr.",
          "Merziger Str.",
          "Mettlacher Str.",
          "Metzer Str.",
          "Michaelsweg",
          "Miselohestr.",
          "Mittelstr.",
          "Mohlenstr.",
          "Moltkestr.",
          "Monheimer Str.",
          "Montanusstr.",
          "Montessoriweg",
          "Moosweg",
          "Morsbroicher Str.",
          "Moselstr.",
          "Moskauer Str.",
          "Mozartstr.",
          "Mühlenweg",
          "Muhrgasse",
          "Muldestr.",
          "Mülhausener Str.",
          "Mülheimer Str.",
          "Münsters Gäßchen",
          "Münzstr.",
          "Müritzstr.",
          "Myliusstr.",
          "Nachtigallenweg",
          "Nauener Str.",
          "Neißestr.",
          "Nelly-Sachs-Str.",
          "Netzestr.",
          "Neuendriesch",
          "Neuenhausgasse",
          "Neuenkamp",
          "Neujudenhof",
          "Neukronenberger Str.",
          "Neustadtstr.",
          "Nicolai-Hartmann-Str.",
          "Niederblecher",
          "Niederfeldstr.",
          "Nietzschestr.",
          "Nikolaus-Groß-Str.",
          "Nobelstr.",
          "Norderneystr.",
          "Nordstr.",
          "Ober dem Hof",
          "Obere Lindenstr.",
          "Obere Str.",
          "Oberölbach",
          "Odenthaler Str.",
          "Oderstr.",
          "Okerstr.",
          "Olof-Palme-Str.",
          "Ophovener Str.",
          "Opladener Platz",
          "Opladener Str.",
          "Ortelsburger Str.",
          "Oskar-Moll-Str.",
          "Oskar-Schlemmer-Str.",
          "Oststr.",
          "Oswald-Spengler-Str.",
          "Otto-Dix-Str.",
          "Otto-Grimm-Str.",
          "Otto-Hahn-Str.",
          "Otto-Müller-Str.",
          "Otto-Stange-Str.",
          "Ottostr.",
          "Otto-Varnhagen-Str.",
          "Otto-Wels-Str.",
          "Ottweilerstr.",
          "Oulustr.",
          "Overfeldweg",
          "Pappelweg",
          "Paracelsusstr.",
          "Parkstr.",
          "Pastor-Louis-Str.",
          "Pastor-Scheibler-Str.",
          "Pastorskamp",
          "Paul-Klee-Str.",
          "Paul-Löbe-Str.",
          "Paulstr.",
          "Peenestr.",
          "Pescher Busch",
          "Peschstr.",
          "Pestalozzistr.",
          "Peter-Grieß-Str.",
          "Peter-Joseph-Lenné-Str.",
          "Peter-Neuenheuser-Str.",
          "Petersbergstr.",
          "Peterstr.",
          "Pfarrer-Jekel-Str.",
          "Pfarrer-Klein-Str.",
          "Pfarrer-Röhr-Str.",
          "Pfeilshofstr.",
          "Philipp-Ott-Str.",
          "Piet-Mondrian-Str.",
          "Platanenweg",
          "Pommernstr.",
          "Porschestr.",
          "Poststr.",
          "Potsdamer Str.",
          "Pregelstr.",
          "Prießnitzstr.",
          "Pützdelle",
          "Quarzstr.",
          "Quettinger Str.",
          "Rat-Deycks-Str.",
          "Rathenaustr.",
          "Ratherkämp",
          "Ratiborer Str.",
          "Raushofstr.",
          "Regensburger Str.",
          "Reinickendorfer Str.",
          "Renkgasse",
          "Rennbaumplatz",
          "Rennbaumstr.",
          "Reuschenberger Str.",
          "Reusrather Str.",
          "Reuterstr.",
          "Rheinallee",
          "Rheindorfer Str.",
          "Rheinstr.",
          "Rhein-Wupper-Platz",
          "Richard-Wagner-Str.",
          "Rilkestr.",
          "Ringstr.",
          "Robert-Blum-Str.",
          "Robert-Koch-Str.",
          "Robert-Medenwald-Str.",
          "Rolandstr.",
          "Romberg",
          "Röntgenstr.",
          "Roonstr.",
          "Ropenstall",
          "Ropenstaller Weg",
          "Rosenthal",
          "Rostocker Str.",
          "Rotdornweg",
          "Röttgerweg",
          "Rückertstr.",
          "Rudolf-Breitscheid-Str.",
          "Rudolf-Mann-Platz",
          "Rudolf-Stracke-Str.",
          "Ruhlachplatz",
          "Ruhlachstr.",
          "Rüttersweg",
          "Saalestr.",
          "Saarbrücker Str.",
          "Saarlauterner Str.",
          "Saarstr.",
          "Salamanderweg",
          "Samlandstr.",
          "Sanddornstr.",
          "Sandstr.",
          "Sauerbruchstr.",
          "Schäfershütte",
          "Scharnhorststr.",
          "Scheffershof",
          "Scheidemannstr.",
          "Schellingstr.",
          "Schenkendorfstr.",
          "Schießbergstr.",
          "Schillerstr.",
          "Schlangenhecke",
          "Schlebuscher Heide",
          "Schlebuscher Str.",
          "Schlebuschrath",
          "Schlehdornstr.",
          "Schleiermacherstr.",
          "Schloßstr.",
          "Schmalenbruch",
          "Schnepfenflucht",
          "Schöffenweg",
          "Schöllerstr.",
          "Schöne Aussicht",
          "Schöneberger Str.",
          "Schopenhauerstr.",
          "Schubertplatz",
          "Schubertstr.",
          "Schulberg",
          "Schulstr.",
          "Schumannstr.",
          "Schwalbenweg",
          "Schwarzastr.",
          "Sebastianusweg",
          "Semmelweisstr.",
          "Siebelplatz",
          "Siemensstr.",
          "Solinger Str.",
          "Sonderburger Str.",
          "Spandauer Str.",
          "Speestr.",
          "Sperberweg",
          "Sperlingsweg",
          "Spitzwegstr.",
          "Sporrenberger Mühle",
          "Spreestr.",
          "St. Ingberter Str.",
          "Starenweg",
          "Stauffenbergstr.",
          "Stefan-Zweig-Str.",
          "Stegerwaldstr.",
          "Steglitzer Str.",
          "Steinbücheler Feld",
          "Steinbücheler Str.",
          "Steinstr.",
          "Steinweg",
          "Stephan-Lochner-Str.",
          "Stephanusstr.",
          "Stettiner Str.",
          "Stixchesstr.",
          "Stöckenstr.",
          "Stralsunder Str.",
          "Straßburger Str.",
          "Stresemannplatz",
          "Strombergstr.",
          "Stromstr.",
          "Stüttekofener Str.",
          "Sudestr.",
          "Sürderstr.",
          "Syltstr.",
          "Talstr.",
          "Tannenbergstr.",
          "Tannenweg",
          "Taubenweg",
          "Teitscheider Weg",
          "Telegrafenstr.",
          "Teltower Str.",
          "Tempelhofer Str.",
          "Theodor-Adorno-Str.",
          "Theodor-Fliedner-Str.",
          "Theodor-Gierath-Str.",
          "Theodor-Haubach-Str.",
          "Theodor-Heuss-Ring",
          "Theodor-Storm-Str.",
          "Theodorstr.",
          "Thomas-Dehler-Str.",
          "Thomas-Morus-Str.",
          "Thomas-von-Aquin-Str.",
          "Tönges Feld",
          "Torstr.",
          "Treptower Str.",
          "Treuburger Str.",
          "Uhlandstr.",
          "Ulmenweg",
          "Ulmer Str.",
          "Ulrichstr.",
          "Ulrich-von-Hassell-Str.",
          "Umlag",
          "Unstrutstr.",
          "Unter dem Schildchen",
          "Unterölbach",
          "Unterstr.",
          "Uppersberg",
          "Van't-Hoff-Str.",
          "Veit-Stoß-Str.",
          "Vereinsstr.",
          "Viktor-Meyer-Str.",
          "Vincent-van-Gogh-Str.",
          "Virchowstr.",
          "Voigtslach",
          "Volhardstr.",
          "Völklinger Str.",
          "Von-Brentano-Str.",
          "Von-Diergardt-Str.",
          "Von-Eichendorff-Str.",
          "Von-Ketteler-Str.",
          "Von-Knoeringen-Str.",
          "Von-Pettenkofer-Str.",
          "Von-Siebold-Str.",
          "Wacholderweg",
          "Waldstr.",
          "Walter-Flex-Str.",
          "Walter-Hempel-Str.",
          "Walter-Hochapfel-Str.",
          "Walter-Nernst-Str.",
          "Wannseestr.",
          "Warnowstr.",
          "Warthestr.",
          "Weddigenstr.",
          "Weichselstr.",
          "Weidenstr.",
          "Weidfeldstr.",
          "Weiherfeld",
          "Weiherstr.",
          "Weinhäuser Str.",
          "Weißdornweg",
          "Weißenseestr.",
          "Weizkamp",
          "Werftstr.",
          "Werkstättenstr.",
          "Werner-Heisenberg-Str.",
          "Werrastr.",
          "Weyerweg",
          "Widdauener Str.",
          "Wiebertshof",
          "Wiehbachtal",
          "Wiembachallee",
          "Wiesdorfer Platz",
          "Wiesenstr.",
          "Wilhelm-Busch-Str.",
          "Wilhelm-Hastrich-Str.",
          "Wilhelm-Leuschner-Str.",
          "Wilhelm-Liebknecht-Str.",
          "Wilhelmsgasse",
          "Wilhelmstr.",
          "Willi-Baumeister-Str.",
          "Willy-Brandt-Ring",
          "Winand-Rossi-Str.",
          "Windthorststr.",
          "Winkelweg",
          "Winterberg",
          "Wittenbergstr.",
          "Wolf-Vostell-Str.",
          "Wolkenburgstr.",
          "Wupperstr.",
          "Wuppertalstr.",
          "Wüstenhof",
          "Yitzhak-Rabin-Str.",
          "Zauberkuhle",
          "Zedernweg",
          "Zehlendorfer Str.",
          "Zehntenweg",
          "Zeisigweg",
          "Zeppelinstr.",
          "Zschopaustr.",
          "Zum Claashäuschen",
          "Zündhütchenweg",
          "Zur Alten Brauerei",
          "Zur alten Fabrik"
        ],
        "time_zone": [
          "MEZ",
          "Europe/Berlin",
          "Central European Time",
          "CET"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "publisher": [
          "Acabus Verlag",
          "Achterbahn",
          "AIM-Verlagshaus",
          "Aisthesis Verlag",
          "Akademische Arbeitsgemeinschaft Verlag",
          "Akademische Druck- und Verlagsanstalt",
          "Verlag Karl Alber",
          "Alibri Verlag",
          "Amadeus Verlag",
          "Amalthea Signum Verlag",
          "Andere Zeiten",
          "Andiamo Verlag",
          "Allgemeine Ortskrankenkasse",
          "AOL-Verlag",
          "Appelhans Verlag",
          "Apprimus Wissenschaftsverlag",
          "Ararat-Verlag",
          "Arbeitsgemeinschaft für zeitgemäßes Bauen",
          "Arco Verlag",
          "Arovell Verlag",
          "Das Arsenal",
          "Assoziation Linker Verlage",
          "AT Verlag",
          "Athesia",
          "Atlas Verlag",
          "Atlas Verlag",
          "Carl-Auer-Verlag",
          "Aula-Verlag",
          "AZ Medien Gruppe",
          "Badischer Verlag",
          "C. Bange Verlag",
          "Bärenreiter-Verlag",
          "Bastei Lübbe Verlag",
          "Musikverlag M. P. Belaieff",
          "Belser-Verlag",
          "Beltz-Verlag",
          "Benteli",
          "Bibliographisches Institut",
          "Klaus Bielefeld Verlag",
          "Black Ink Verlag",
          "Bonnier",
          "BPX Edition",
          "Joh. Brendow & Sohn Verlag",
          "Brighton Verlag",
          "R. Brockhaus",
          "Bruno Gmünder Verlag",
          "Bundes-Verlag",
          "Bunte Raben Verlag",
          "Burda Verlag",
          "ça ira Verlag",
          "Callwey Verlag",
          "Castrum Peregrini",
          "Centaurus Verlag",
          "Christliche Literatur-Verbreitung",
          "Claassen-Verlag",
          "Cosmos-Verlag",
          "Verlag Deutsche Polizeiliteratur",
          "Deutscher Verlag der Wissenschaften",
          "Deutscher Wissenschafts-Verlag",
          "Neue Sachlichkeit",
          "Dieterich’sche Verlagsbuchhandlung",
          "Draksal Fachverlag",
          "Drei Eichen Verlag",
          "Literaturverlag Droschl",
          "Echtzeit Verlag",
          "Ecowin Verlag",
          "Edition Antaios",
          "Edition AV",
          "Edition Erdmann",
          "Edition Gorz",
          "Edition Phantasia",
          "Edition Raetia",
          "edition taberna kritika",
          "Edition Va Bene",
          "Edition YE",
          "Verlag Empirische Pädagogik",
          "Ernst & Sohn",
          "Esslinger Verlag J. F. Schreiber",
          "Ernst Eulenburg",
          "ERF-Verlag",
          "Wilhelm Fink Verlag",
          "Folgen Verlag",
          "Forum Media Group",
          "Franzis-Verlag",
          "Friedrich Verlag",
          "Das Wort",
          "Gebrüder Borntraeger Verlagsbuchhandlung",
          "Geest-Verlag",
          "Gerstenberg Verlag",
          "GFMK Verlagsgesellschaft",
          "Gimpel Verlag",
          "Glaux Verlag Christine Jäger",
          "Godewind Verlag",
          "Greifenverlag",
          "Verlag grünes herz",
          "Verlag Peter Guhl",
          "Hamburger Edition",
          "Hamburger Lesehefte",
          "Hänssler Verlag",
          "Peter Hammer Verlag",
          "Rudolf Haufe Verlag",
          "Haupt Verlag",
          "Verlag Heinz Heise",
          "Henschel Musik",
          "hep verlag",
          "Verlag Herder",
          "Hippokrates Verlag",
          "Verlag Peter Hopf",
          "Horlemann Verlag",
          "Huber Verlag",
          "Hueber Verlag",
          "Verlagsgruppe Husum",
          "IDEA Verlag",
          "IKS Garamond Verlag",
          "Info Verlag",
          "Isensee Verlag",
          "Junfermann Verlag",
          "Jung und Jung",
          "K&K Verlagsanstalt",
          "Kairos Edition",
          "Kawohl-Verlag",
          "Kehrer Verlag",
          "Kladdebuchverlag",
          "Klever Verlag",
          "Kohl Verlag",
          "Konradin Mediengruppe",
          "Kookbooks",
          "Kopp Verlag",
          "Verlag Dr. Kova?",
          "Kremayr & Scheriau",
          "Verlag Kreuz",
          "Kulturmaschinen",
          "Verlag der Kunst",
          "Lambertus Verlag",
          "Peter Lang Verlagsgruppe",
          "Lichtdruck- und Bildverlag der Kunst",
          "Lichtung Verlag",
          "Literarisches Comptoir Zürich und Winterthur",
          "Luchterhand Fachverlag",
          "Lusatia Verlag",
          "luxbooks",
          "m+a Verlag für Messen, Ausstellungen und Kongresse",
          "Maas & Peither",
          "MairDumont",
          "Manutius Verlag",
          "Osnabrücker Tageblatt",
          "Memento Verlag",
          "Mercator-Verlag",
          "Merlin Verlag",
          "Metropolis",
          "Johann Heinrich Meyer",
          "Meyer & Meyer",
          "MM Verlag",
          "Verlag moderne Industrie",
          "Verlag Ch. Möllmann",
          "Morstadt Verlag",
          "Mosaik Steinchen für Steinchen Verlag",
          "Mosquito Verlag",
          "Munzinger-Archiv",
          "NV-Verlag",
          "NDV Neue Darmstädter Verlagsanstalt",
          "Neisse Verlag",
          "Neofelis Verlag",
          "Neuer Deutscher Verlag",
          "Neumann Verlag",
          "Verlag J. Neumann-Neudamm",
          "Neuromedizin Verlag",
          "Nomos Verlag",
          "Edition Olms",
          "Georg Olms Verlag",
          "J. G. Oncken Nachf.",
          "SCM-Verlag",
          "Ontos Verlag",
          "Open House Verlag",
          "Pabel-Moewig",
          "Panini Verlag",
          "Panini Verlag",
          "Paul Parey Verlag",
          "Pattloch Verlag",
          "Persen Verlag",
          "Primus Verlag",
          "Prisma Verlag",
          "Propyläen Verlag",
          "Promedia Verlag",
          "Prospero Verlag",
          "Provinz Verlag",
          "Verlag Friedrich Pustet",
          "Random House Verlagsgruppe",
          "Rhein Ruhr Verlag",
          "Ravensburger Buchverlag",
          "Philipp Reclam jun.",
          "Dietrich Reimer Verlag",
          "Residenz Verlag",
          "Rimbaud Verlag",
          "Ritter Verlag",
          "Verlag Rockstuhl",
          "Romantruhe",
          "Verlag Rosa Winkel",
          "Rowohlt Verlag",
          "Salleck Publications",
          "Verlag Sauerländer",
          "Schattauer Verlag",
          "Schardt Verlag",
          "Schlütersche Verlagsgesellschaft",
          "Verlag Schnell und Steiner",
          "Verlag Ferdinand Schöningh",
          "Schott Music",
          "E. Schweizerbart’sche Verlagsbuchhandlung",
          "Verlag C. A. Schwetschke & Sohn",
          "scius-Verlag",
          "Peter-Segler-Verlag",
          "Severus Verlag",
          "Shaker Verlag",
          "Siedler Verlag",
          "Silberburg-Verlag",
          "Sonnenberg Verlag",
          "Sonntag Verlag",
          "Spektrum Akademischer Verlag",
          "Spitta-Verlag",
          "Splitter",
          "Axel Springer AG",
          "Stachelbart-Verlag",
          "Conrad Stein Verlag",
          "Steinklopfer-Verlag]] [[Paul Heinzelmann",
          "Verlag J. F. Steinkopf",
          "Leopold Stocker Verlag",
          "Styria Medien AG",
          "Südwest-Verlag",
          "Tectum Verlag",
          "Buchwerkstatt Thanhäuser",
          "transcript Verlag",
          "Transpress Verlag",
          "Ulrike Helmer Verlag",
          "Velbrück Wissenschaft",
          "Internationaler Fachverlag J. M. E. Weber",
          "Weger Verlag",
          "Weingarten Verlag",
          "WEKA-Verlagsgruppe",
          "Wieser Verlag",
          "Wiley-VCH Verlag",
          "Wochenschau Verlag",
          "Wolfbach Verlag",
          "Kurt Wolff Verlag",
          "YinYang Media Verlag",
          "Zauberkreis Verlag",
          "W. Zuckschwerdt Verlag GmbH",
          "Zwiebelzwerg Verlag",
          "Ziegler Druck- und Verlags-AG",
          "J. F. Ziegler KG Druckerei und Verlag",
          "Zytglogge Verlag"
        ],
        "title": [
          "Also sprach Zarathustra",
          "Andorra",
          "Ansichten Eines Clowns",
          "Atemschaukel",
          "Aus dem Leben eines Taugenichts",
          "Bekenntnisse des Hochstaplers Felix Krull",
          "Berlin Alexanderplatz",
          "Biedermann und die Brandstifter",
          "Billiard um halbzehn",
          "Catharina von Georgien",
          "Cleopatra",
          "Damals war es Friedrich",
          "Dantons Tod",
          "Das Boot",
          "Das Marmorbild",
          "Das Parfum",
          "Das Schiff Esperanza",
          "Das Versprechen",
          "Das kalte Herz",
          "Das steinerne Herz",
          "Der (kleine) Schatz im Kugelbauch",
          "Der Augenblick der Liebe",
          "Der Ausflug der toten Mädchen",
          "Der Besuch der alten Dame",
          "Der Brief des Lord Chandos",
          "Der Goldene Topf",
          "Der Hauptmann von Köpenick",
          "Der Mann ohne Eigenschaften",
          "Der Prozess",
          "Der Richter und sein Henker",
          "Der Sandmann",
          "Der Schimmelreiter",
          "Der Spaziergang",
          "Der Stechlin",
          "Der Stellvertreter",
          "Der Steppenwolf",
          "Der Tod in Venedig und andere Erzählungen",
          "Der Tor und der Tod",
          "Der Untertan",
          "Der Verdacht",
          "Der Vorleser",
          "Der Vulkan",
          "Der Zauberberg",
          "Der abenteuerliche Simplicissimus",
          "Der arme Spielmann",
          "Der eiserne Gustav",
          "Der geteilte Himmel",
          "Der grüne Heinrich",
          "Der gute Mensch von Sezuan",
          "Der veruntreute Himmel",
          "Der zerbrochene Krug",
          "Des Teufels General",
          "Deutschland. Ein Wintermärchen",
          "Die Aufzeichnungen des Malte Laurids Brigge",
          "Die Blechtrommel",
          "Die Box",
          "Die Buddenbrooks",
          "Die Dreigroschenoper",
          "Die Erschiessung des Landesverräters Ernst S.",
          "Die Lehre der Sainte-Victoire",
          "Die Leiden des jungen Werther",
          "Die Leute von Seldwyla",
          "Die Marquise von O...",
          "Die Panne",
          "Die Physiker",
          "Die Rote",
          "Die Räuber",
          "Die Verwandlung/Erstes Leid",
          "Die Waffen nieder!",
          "Die Welt als Wille & Wahn",
          "Die neuen Leiden des jungen Werthers",
          "Die unendliche Geschichte",
          "Die verlorene Ehre der Katharina Blum",
          "Die zärtlichen Schwestern",
          "Don Karlos",
          "Effi Briest",
          "Ehen in Philippsburg",
          "Eiche und Angora",
          "Ein fliehendes Pferd",
          "Ende einer Dienstfahrt",
          "Es geschah im Nachbarhaus",
          "Fabian",
          "Faserland",
          "Faust, Part I",
          "Franziska Linkerhand",
          "Frühlings Erwachen",
          "Ganz unten",
          "Gehirne",
          "Die Weber",
          "Götz von Berlichingen",
          "Haus ohne Hüter",
          "Heidi",
          "Heinrich von Ofterdingen",
          "Helden wie wir",
          "Homo faber",
          "Hyperion oder der Eremit in Griechenland",
          "Im Krebsgang",
          "Im Westen nichts Neues",
          "Iphigenie auf Tauris",
          "Italienische Reise",
          "Jahrestage",
          "Jakob der Lügner",
          "Jedermann",
          "Kabale und Liebe",
          "Katz und Maus",
          "Leben des Galilei",
          "Lenz",
          "Lerne lachen ohne zu weinen",
          "Emilia Galotti",
          "Lieutenant Gustl",
          "Maria Magdalene",
          "Maria Stuart",
          "Mario und der Zauberer",
          "Mephisto",
          "Minna von Barnhelm",
          "Miss Sara Sampson",
          "Mutter Courage und ihre Kinder",
          "Narziss und Goldmund",
          "Narziß und Goldmund",
          "Nathan der Weise",
          "Paare, Passanten",
          "Panter, Tiger & Co.",
          "Reigen",
          "Romeo und Julia auf dem Dorfe",
          "Romulus der Große",
          "Sansibar oder der letzte Grund",
          "Schachnovelle",
          "Siddhartha",
          "Sterbender Cato",
          "Stolz und Vorurteil",
          "Tauben im Gras",
          "Till Eulenspiegel",
          "Traumnovelle/Die Braut",
          "Tödliche Versprechen/Das Imperium der Wölfe",
          "Unterhaltungen deutscher Ausgewanderten",
          "Unterm Rad",
          "Vor Sonnenaufgang",
          "Wer einmal aus dem Blechnapf frisst",
          "Wilhelm Meisters Wanderjahre oder die Entsagenden",
          "Wilhelm Tell",
          "Winnetou",
          "Winnetou II",
          "Woyzeck",
          "Über das Studium der griechischen Poesie"
        ]
      },
      "cell_phone": {
        "formats": [
          "15##-#######",
          "16#-#######",
          "17#-#######"
        ]
      },
      "chuck_norris": {
        "fact": [
          "Einmal warf Chuck Norris eine Handgranate und tötete damit 100 Leute. Zwei Sekunden später explodierte sie.",
          "Am Anfang war das Nichts. Dann roundhousekickte Chuck Norris dieses Nichts und sagte: \"Such‘ Dir einen Job!\" Das ist die Geschichte der Entstehung des Universums.",
          "Neulich wurde eine in 3D gedrehte Folge von \"Walker, Texas Ranger\" im Kino gezeigt. Es gab keine Überlebenden.",
          "Chuck Norris übernimmt die Projektleitung des Flughafens Berlin Brandenburg. Eröffnung ist morgen früh um 06:30 Uhr.",
          "Chuck Norris kann wirbellosen Tieren trotzdem das Genick brechen.",
          "Chuck Norris ließ sich an einen Lügendetektor anschließen. Die Maschine gestand.",
          "Einmal wurde Chuck Norris auf Latein beleidigt. Seitdem gilt es als tote Sprache.",
          "Der Sensenmann fürchtet sich vor dem Tag, an dem Chuck Norris bei ihm vor der Tür steht.",
          "Chuck Norris zündet ein Feuer an, indem er zwei Eiswürfel aneinander reibt.",
          "Chuck Norris hat seine praktische Führerscheinprüfung bestanden – zu Fuß.",
          "Chuck Norris kann im Kinderkarussell überholen.",
          "Geister sitzen um das Lagerfeuer und erzählen sich Chuck-Norris-Geschichten.",
          "Die GEZ zahlt Chuck-Norris-Gebühren.",
          "Wenn Chuck Norris Wäsche wäscht, werden sogar schwarze Hemden strahlend weiß.",
          "Chuck Norris wurde neulich geblitzt – beim Einparken.",
          "Chuck Norris wurde einmal von einer Königskobra gebissen. Nach fünf qualvollen Tagen voller Schmerz starb die Kobra.",
          "Chuck Norris hat bis Unendlich gezählt – zwei Mal.",
          "Chuck Norris erfuhr einmal, dass nichts ihn besiegen könne. Deshalb machte er sich auf die Suche nach dem Nichts und tötete es.",
          "Chuck Norris ist so schnell – wenn er das Licht ausschaltet, ist er im Bett bevor der Raum dunkel ist.",
          "Das einzige Mal an dem Chuck Norris falsch lag, war, als er dachte, er habe einen Fehler gemacht.",
          "Wenn Chuck Norris beim Russisch Roulette verliert, will er eine Revanche.",
          "Chuck Norris kann eine Party schmeißen. 100 Meter weit.",
          "Chuck Norris hat einmal 37 Terroristen mit zwei Kugeln getötet. Die erste Kugel war ein Warnschuss.",
          "Wenn Du alleine ein Rennen gegen Chuck Norris fährst, wirst Du Dritter.",
          "Chuck Norris lügt nicht. Die Wahrheit ist einfach falsch.",
          "Chuck Norris‘ Passwort? Die Zahl Pi.",
          "Chuck Norris kann eine Bombe zerlegen – und zwar in ein Kaugummi, einen Faden, ein Streichholz und MacGyver.",
          "Chuck Norris isst keinen Honig. Chuck Norris kaut Bienen."
        ]
      },
      "color": {
        "name": [
          "rot",
          "grün",
          "blau",
          "gelb",
          "lila",
          "weiß",
          "schwarz",
          "orange",
          "rosa",
          "grau",
          "braun",
          "violett",
          "türkis",
          "oliv",
          "beige",
          "ocker",
          "sand",
          "mocka",
          "bordeaux",
          "aprikose",
          "mint-grün",
          "magenta",
          "gold",
          "silber",
          "bronze",
          "limette",
          "azur",
          "pink"
        ]
      },
      "commerce": {
        "department": [
          "Bücher",
          "Filme",
          "Musik",
          "Spiele",
          "Elektronik",
          "Computer",
          "Haushalt",
          "Garten",
          "Werkzeug",
          "Lebensmittel",
          "Gesundheit",
          "Beauty",
          "Spielzeug",
          "Kinder",
          "Kleinkinder",
          "Kleider",
          "Schuhe",
          "Schmuck",
          "Sport",
          "Outdoor",
          "Auto",
          "Industrie"
        ],
        "product_name": {
          "adjective": [
            "Kleine",
            "Ergonomische",
            "Rustikale",
            "Intelligente",
            "Wunderschöne",
            "Unglaubliche",
            "Fantastische",
            "Praktische",
            "Glatte",
            "Grossartige",
            "Enorme",
            "Mittelmässige",
            "Synergetische",
            "Strapazierfähige",
            "Leichtgewichtige",
            "Aerodynamische",
            "Haltbare"
          ],
          "material": [
            "Stahl",
            "Holz",
            "Beton",
            "Plastik",
            "Baumwoll",
            "Granit",
            "Gummi",
            "Leder",
            "Seiden",
            "Wolle",
            "Leinen",
            "Marmor",
            "Eisen",
            "Bronze",
            "Kupfer",
            "Aluminium",
            "Papier"
          ],
          "product": [
            "Stuhl",
            "Auto",
            "Computer",
            "Handschuh",
            "Hose",
            "Hemd",
            "Tisch",
            "Schuh",
            "Hut",
            "Teller",
            "Messer",
            "Flasche",
            "Mantel",
            "Lampe",
            "Tastatur",
            "Tasche",
            "Bank",
            "Uhr",
            "Armbanduhr",
            "Geldbörse"
          ]
        }
      },
      "company": {
        "legal_form": [
          "GmbH",
          "AG",
          "Gruppe",
          "KG",
          "GmbH & Co. KG",
          "UG",
          "OHG"
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
        ],
        "suffix": [
          "GmbH",
          "AG",
          "Gruppe",
          "KG",
          "GmbH & Co. KG",
          "UG",
          "OHG"
        ]
      },
      "compass": {
        "abbreviation": [
          "#{cardinal_abbreviation}",
          "#{ordinal_abbreviation}",
          "#{half_wind_abbreviation}",
          "#{quarter_wind_abbreviation}"
        ],
        "azimuth": [
          "#{cardinal_azimuth}",
          "#{ordinal_azimuth}",
          "#{half_wind_azimuth}",
          "#{quarter_wind_azimuth}"
        ],
        "cardinal": {
          "abbreviation": [
            "N",
            "O",
            "S",
            "W"
          ],
          "azimuth": [
            "0",
            "90",
            "180",
            "270"
          ],
          "word": [
            "Norden",
            "Osten",
            "Süden",
            "Westen"
          ]
        },
        "direction": [
          "#{cardinal}",
          "#{ordinal}",
          "#{half_wind}",
          "#{quarter_wind}"
        ],
        "half-wind": {
          "abbreviation": [
            "NNO",
            "ONO",
            "OSO",
            "SSO",
            "SSW",
            "WSW",
            "WNW",
            "NNW"
          ],
          "azimuth": [
            "22.5",
            "67.5",
            "112.5",
            "157.5",
            "202.5",
            "247.5",
            "292.5",
            "337.5"
          ],
          "word": [
            "Nord-Nordost",
            "Ost-Nordost",
            "Ost-Südost",
            "Süd-Südost",
            "Süd-Südwest",
            "West-Südwest",
            "West-Nordwest",
            "Nord-Nordwest"
          ]
        },
        "ordinal": {
          "abbreviation": [
            "NO",
            "SO",
            "SW",
            "NW"
          ],
          "azimuth": [
            "45",
            "135",
            "225",
            "315"
          ],
          "word": [
            "Nordosten",
            "Südosten",
            "Südwesten",
            "Nordwesten"
          ]
        },
        "quarter-wind": {
          "abbreviation": [
            "NvO",
            "NOvN",
            "NOvO",
            "OvN",
            "OvS",
            "SOvO",
            "SOvS",
            "SvO",
            "SvW",
            "SWvS",
            "SWvW",
            "WvS",
            "WvN",
            "NWvW",
            "NWvN",
            "NvW"
          ],
          "azimuth": [
            "11.25",
            "33.75",
            "56.25",
            "78.75",
            "101.25",
            "123.75",
            "146.25",
            "168.75",
            "191.25",
            "213.75",
            "236.25",
            "258.75",
            "281.25",
            "303.75",
            "326.25",
            "348.75"
          ],
          "word": [
            "Norden von Osten",
            "Nordosten von Norden",
            "Nordosten von Osten",
            "Osten von Norden",
            "Osten von Süden",
            "Südosten von Osten",
            "Südosten von Süden",
            "Süden von Osten",
            "Süden von Westen",
            "Südwesten von Süden",
            "Südwesten von Westen",
            "Westen von Süden",
            "Westen von Norden",
            "Nordwesten von Westen",
            "Nordwesten von Norden",
            "Norden von Westen"
          ]
        }
      },
      "dr_who": {
        "the_doctors": [
          "Erster Doktor",
          "Zweiter Doktor",
          "Dritter Doktor",
          "Vierter Doktor",
          "Fünfter Doktor",
          "Sechster Doktor",
          "Siebenter Doktor",
          "Achter Doktor",
          "Neunter Doktor",
          "Zehnter Doktor",
          "Elfter Doktor",
          "Zwölfter Doktor"
        ]
      },
      "food": {
        "ingredients": [
          "Aal",
          "Aceto Balsamico",
          "Ackersalat",
          "Agar-Agar",
          "Agavendicksaft",
          "Ahornsirup",
          "Ajvar",
          "Akazienhonig",
          "Algen",
          "Amaranth",
          "Amaretto",
          "Ananas",
          "Ananassaft",
          "Anchovis",
          "Angostura",
          "Anisschnaps",
          "Aperol",
          "Apfeldicksaft",
          "Apfelmus",
          "Apfelringe",
          "Apfelsaft",
          "Apfelsinen",
          "Appenzeller",
          "Aprikosen",
          "Aprikosenmarmelade",
          "Aprikosensaft",
          "Aprikosensirup",
          "Arrak",
          "Artischocken",
          "Auberginen",
          "Austern",
          "Austernpilze",
          "Avocado",
          "Backpflaumen",
          "Backpulver",
          "Backzucker",
          "Baharat",
          "Bambussprossen",
          "Bananen",
          "Bananenchips",
          "Bandnudeln",
          "Batida de Coco",
          "Bavette",
          "Belegkirschen",
          "Bergkäse",
          "Bier",
          "Birnen",
          "Birnendicksaft",
          "Birnensaft",
          "Biskuitboden",
          "Bittermandelaroma",
          "Bitterschokolade",
          "Blattsalat",
          "Blauschimmelkäse",
          "Bleichsellerie",
          "Blumenkohl",
          "Blutorange",
          "Blutwurst",
          "Blätterteig",
          "Bohnen",
          "Bouquet garni",
          "Branntwein",
          "Brathähnchen",
          "Bratwurst",
          "Brauner Zucker",
          "Brie",
          "Brokkoli",
          "Brombeeren",
          "Brombeersaft",
          "Brötchen",
          "Buchweizen",
          "Buchweizenmehl",
          "Bulgur",
          "Butter",
          "Butterkekse",
          "Butterkäse",
          "Buttermilch",
          "Butterschmalz",
          "Bärlauchpesto",
          "Bündner Fleisch",
          "Cachaca",
          "Calvados",
          "Camembert",
          "Campari",
          "Cashewkerne",
          "Cassis-Likör",
          "Catfish",
          "Champagner",
          "Champignons",
          "Cheddarkäse",
          "Chicoree",
          "Chilipaste",
          "Chilipulver",
          "Chilisauce",
          "Chilischote",
          "Chinakohl",
          "Chorizzo",
          "Cidre",
          "Cognac",
          "Cointreau",
          "Couscous",
          "Cranberries",
          "Cranberrysaft",
          "Creme double",
          "Creme fraiche",
          "Creme fraiche mit Kräutern",
          "Cremefine",
          "Curacao Blue",
          "Curry",
          "Curryketchup",
          "Currypaste",
          "Datteln",
          "Dickmilch",
          "Dijonsenf",
          "Dinkelmehl",
          "Dorade",
          "Dörr-Aprikosen",
          "Dörrfleisch",
          "Edamer",
          "Eier",
          "Eierlikör",
          "Eisbergsalat",
          "Eiswürfel",
          "Emmentaler",
          "Ente",
          "Entenbrust",
          "Entenleber",
          "Entrecotes",
          "Erbsen",
          "Erdbeeren",
          "Erdbeermarmelade",
          "Erdbeersaft",
          "Erdbeersirup",
          "Erdnussbutter",
          "Erdnussöl",
          "Erdnüsse",
          "Espresso",
          "Essig",
          "Esskastanien",
          "Farfalle",
          "Fasan",
          "Feigen",
          "Fenchelsamen",
          "Feta",
          "Fettuccine",
          "Fisch",
          "Fischfond",
          "Fleischbrühe",
          "Fleischsalat",
          "Fleischtomaten",
          "Foie gras",
          "Fondor",
          "Forelle",
          "Frischkäse",
          "Frühlingszwiebeln",
          "Frühstücksspeck",
          "Fünf-Gewürz-Pulver",
          "Gans",
          "Garam Masala",
          "Garnelen",
          "Geflügelbouillon",
          "Gelatine",
          "Gelierzucker",
          "Gemüse",
          "Gemüsebrühe",
          "Gemüsesaft",
          "Gewürze",
          "Gewürzgurken",
          "Gin",
          "Ginger Ale",
          "Glasnudeln",
          "Glutamat",
          "Gouda",
          "Grammeln",
          "Granatapfel",
          "Granatapfelsirup",
          "Grapefruit",
          "Grapefruitsaft",
          "Gratinkäse",
          "Graupen",
          "Greyerzer Käse",
          "Grieß",
          "Grüner Speck",
          "Grünkern",
          "Grünkohl",
          "Guave",
          "Gänsebrust",
          "Gänsekeule",
          "Gänseleber",
          "Götterspeise",
          "Hackfleisch",
          "Hafer",
          "Haferflocken",
          "Hagebutten",
          "Hagelzucker",
          "Halloumi",
          "Hartkäse",
          "Harzer",
          "Hase",
          "Haselnussglasur",
          "Haselnüsse",
          "Hecht",
          "Hefe",
          "Heidelbeeren",
          "Hering",
          "Herz",
          "Himbeeren",
          "Himbeermarmelade",
          "Himbeersaft",
          "Himbeersirup",
          "Hirsch",
          "Hirschhornsalz",
          "Hirse",
          "Hoisin-Sauce",
          "Holunderbeeren",
          "Holunderbeersaft",
          "Holundersirup",
          "Honigmelone",
          "Huhn",
          "Hummer",
          "Hähnchenbrust",
          "Hähnchenkeulen",
          "Hühnerleber",
          "Hüttenkäse",
          "Ingwersaft",
          "Ingwersirup",
          "Jakobsmuscheln",
          "Jalapenos",
          "Joghurt",
          "Johannisbeeren",
          "Johannisbeermarmelade",
          "Johannisbeersirup",
          "Josta-Beeren",
          "Kabeljau",
          "Kaffee",
          "Kaffeelikör",
          "Kakao",
          "Kaktusfeige",
          "Kalbfleisch",
          "Kalbsbrät",
          "Kalbsfond",
          "Kalbshaxen",
          "Kalbsleber",
          "Kalbsnuss",
          "Kalbsschnitzel",
          "Kandiszucker",
          "Kaninchen",
          "Karambole",
          "Karamellsirup",
          "Kardamom",
          "Karotten",
          "Karottensaft",
          "Karpfen",
          "Kartoffeln",
          "Kartoffelpüree",
          "Kassler",
          "Kaviar",
          "Kefir",
          "Ketchup",
          "Kichererbsen",
          "Kidneybohnen",
          "Kirschlikör",
          "Kirschmarmelade",
          "Kirschsaft",
          "Kirschtomaten",
          "Kirschwasser",
          "Kiwi",
          "Kochbananen",
          "Kohlrabi",
          "Kokosfett",
          "Kokosmilch",
          "Kokosnuss",
          "Kokosraspeln",
          "Kokossirup",
          "Kondensmilch",
          "Koriandergrün",
          "Koriandersamen",
          "Krabben",
          "Krabbenpaste",
          "Krebse",
          "Krokant",
          "Kräuter",
          "Kräuterbutter",
          "Kräuterfrischkäse",
          "Kräuterquark",
          "Kumquat",
          "Kuvertüre",
          "Kürbiskerne",
          "Kürbiskernöl",
          "Lachs",
          "Lammfleisch",
          "Lammhack",
          "Lammkeule",
          "Lammleber",
          "Langkornreis",
          "Lasagneblätter",
          "Lauch",
          "Lauchzwiebeln",
          "Leberkäse",
          "Lebkuchengewürz",
          "Leinsamen",
          "Letscho",
          "Liebstöckl",
          "Linguine",
          "Linsen",
          "Litschi",
          "Lyoner",
          "Löffelbiskuits",
          "Macadamia",
          "Madeira",
          "Magermilchjoghurt",
          "Magerquark",
          "Mais",
          "Maiskeimöl",
          "Maismehl",
          "Mandarinen",
          "Mandelmus",
          "Mandeln",
          "Mango",
          "Mango-Chutney",
          "Mangold",
          "Mangosirup",
          "Margarine",
          "Marsala",
          "Marzipan",
          "Marzipanrohmasse",
          "Mascarpone",
          "Mayonnaise",
          "Mehl",
          "Melone",
          "Mettenden",
          "Mexikanisches Gewürz",
          "Miesmuscheln",
          "Milch",
          "Milchreis",
          "Milchschokolade",
          "Mineralwasser",
          "Mirabellen",
          "Mischpilze",
          "Misopaste",
          "Mohn",
          "Morcheln",
          "Mozzarella",
          "Muh-Err Pilze (Wolkenohrpilze)",
          "Multivitaminsaft",
          "Mungobohnensprossen",
          "Möhren",
          "Münsterkäse",
          "Natron",
          "Natto",
          "Nektarine",
          "Nelken",
          "Nieren",
          "Noilly Prat",
          "Nougat",
          "Nudeln",
          "Nutella",
          "Nüsse",
          "Oblaten",
          "Obst",
          "Obstessig",
          "Okraschoten",
          "Oktopus",
          "Olivenöl",
          "Orangeat",
          "Orangenaroma",
          "Orangenblütenwasser",
          "Orangenlikör",
          "Orangenmarmelade",
          "Orangensaft",
          "Orangensirup",
          "Palmzucker",
          "Paniermehl",
          "Papaya",
          "Paprikamark",
          "Paprikapulver edelsüß",
          "Paradiescreme",
          "Parfait Amour",
          "Parmaschinken",
          "Parmesan",
          "Passionsfrucht",
          "Pastinaken",
          "Pastis",
          "Patissons",
          "Pecorino",
          "Pekannüsse",
          "Pellkartoffeln",
          "Perlzwiebeln",
          "Pesto",
          "Petersilienwurzel",
          "Pfefferkörner",
          "Pfifferlinge",
          "Pfirsiche",
          "Pfirsichsaft",
          "Pflanzencreme",
          "Pflaumen",
          "Pflaumenmus",
          "Pflaumensauce",
          "Pflaumenwein",
          "Physalis",
          "Pinienkerne",
          "Pistazie",
          "Polenta",
          "Portwein",
          "Pottasche",
          "Preiselbeeren",
          "Preiselbeermarmelade",
          "Prosecco",
          "Puderzucker",
          "Pute",
          "Putenbrust",
          "Putenkeulen",
          "Putenleber",
          "Putenrollbraten",
          "Putenschnitzel",
          "Quark",
          "Quimiq",
          "Quitten",
          "Radieschen",
          "Rahm",
          "Rapsöl",
          "Rebhuhn",
          "Reh",
          "Reis",
          "Reisessig",
          "Reisnudeln",
          "Reispapier",
          "Reissirup",
          "Reiswein",
          "Rettich",
          "Ricotta",
          "Riesengarnelen",
          "Riesling",
          "Rinderfilet",
          "Rinderhack",
          "Rinderleber",
          "Rindfleisch",
          "Risotto-Reis",
          "Roastbeef",
          "Roggenmehl",
          "Rohrzucker",
          "Rosa Pfeffer",
          "Rosenkohl",
          "Rosenpaprika",
          "Rosenwasser",
          "Rosinen",
          "Rote Beete",
          "Rote-Beete-Saft",
          "Rotkohl",
          "Rotweinessig",
          "Rumaroma",
          "Räucherlachs",
          "Röstzwiebeln",
          "Rübensirup",
          "Sahne",
          "Sahnejoghurt",
          "Sahnemeerrettich",
          "Sahnesteif",
          "Salami",
          "Salatgurke",
          "Sambal Oelek",
          "Sambuca",
          "Sanddornsaft",
          "Sanddornsirup",
          "Sardellenfilets",
          "Sardellenpaste",
          "Sardinen",
          "Sauerkirschen",
          "Sauerkirschsaft",
          "Sauerkraut",
          "Sauerteig",
          "Saure Sahne",
          "Saurer Halbrahm",
          "Sbrinz",
          "Schafskäse",
          "Schalotten",
          "Schinkenwurst",
          "Schlagsahne",
          "Schmalz",
          "Schmand",
          "Schmelzkäse",
          "Schnitzel",
          "Schokoladensauce",
          "Scholle",
          "Schwarzbrot",
          "Schwarzer Johannisbeersaft",
          "Schwarzwurzeln",
          "Schweinefilet",
          "Schweinefleisch",
          "Schweineleber",
          "Schweinelende",
          "Schweinenacken",
          "Seehecht",
          "Seeteufel",
          "Seitan",
          "Sekt",
          "Sellerieknolle",
          "Selleriesalz",
          "Senfkörner",
          "Senfmehl",
          "Sesam",
          "Sesampaste",
          "Sesamöl",
          "Sharonfrüchte (Kaki)",
          "Sherry",
          "Shiitake-Pilze",
          "Silberzwiebeln",
          "Sojamilch",
          "Sojasauce",
          "Sojasprossen",
          "Sojaöl",
          "Sonnenblumenkerne",
          "Sonnenblumenöl",
          "Soßenbinder",
          "Spaghetti",
          "Spanferkel",
          "Spargel",
          "Speck",
          "Speisestärke",
          "Spinat",
          "Spitzkohl",
          "Sprossen",
          "Stachelbeeren",
          "Staudensellerie",
          "Steckrüben",
          "Steinpilze",
          "Sternfrucht",
          "Stubenküken",
          "Suppenfleisch",
          "Suppengrün",
          "Süsskartoffeln",
          "Süßkirschen",
          "Süßstoff",
          "Tabasco",
          "Tafelspitz",
          "Tagliatelle",
          "Tahini",
          "Tamarillo",
          "Tequila",
          "Thunfisch",
          "Thunfischsteak",
          "Toastbrot",
          "Tofu",
          "Tomaten",
          "Tomatenmark",
          "Tomatensaft",
          "Tomato al gusto mit Kräuter",
          "Tortenguss",
          "Traubenkernöl",
          "Traubensaft",
          "Trockenfrüchte",
          "Trockenhefe",
          "Tsatsiki",
          "Vanillearoma",
          "Vanilleeis",
          "Vanillepudding",
          "Vanillesauce",
          "Vanilleschote",
          "Vanillezucker",
          "Vollkornmehl",
          "Wachtelbohnen",
          "Wachteleier",
          "Wachteln",
          "Waldfrüchte",
          "Waldmeistersirup",
          "Walnusskerne",
          "Walnussöl",
          "Wasser",
          "Weinbrand",
          "Weinessig",
          "Weintrauben",
          "Weizenkeime",
          "Weißbrot",
          "Weißkohl",
          "Weißwein",
          "Wermut",
          "Whisky",
          "Wild",
          "Wildschwein",
          "Wirsing",
          "Wodka",
          "Worcestersauce",
          "Wurst",
          "Würfelzucker",
          "Würstchen",
          "Zander",
          "Ziegenkäse",
          "Zigeunersauce",
          "Zitronat",
          "Zitrone",
          "Zitronenaroma",
          "Zitronenglasur",
          "Zitronensaft",
          "Zitronenschale",
          "Zitronensirup",
          "Zucchini",
          "Zucchiniblüten",
          "Zuckerglasur",
          "Zuckerschoten",
          "Zunge",
          "Zwetschgen",
          "Zwieback",
          "Zwiebelsuppe",
          "brauner Rum",
          "gedörrte Feigen",
          "gekochter Schinken",
          "gelbe Paprika",
          "geräucherte Putenbrust",
          "getrocknete Tomaten",
          "grüne Bohnen",
          "grüne Oliven",
          "grüne Paprika",
          "passierte Tomaten",
          "roher Schinken",
          "rote Paprika",
          "rote Zwiebeln",
          "schwarze Oliven",
          "weiße Bohnen",
          "weiße Schokolade",
          "weiße Zwiebeln",
          "weißer Heilbutt",
          "weißer Rum",
          "Äpfel",
          "Öl"
        ],
        "measurement_sizes": [
          "1/4",
          "1/3",
          "1/2",
          "1",
          "2",
          "3"
        ],
        "measurements": [
          "Teelöffel",
          "Esslöffel",
          "Tasse",
          "Prise",
          "Messerspitze",
          "Packung"
        ],
        "spices": [
          "Ajowan",
          "Anis",
          "Annatto",
          "Asant",
          "Bärlauch",
          "Bärwurz",
          "Basilikum",
          "Beifuß",
          "Berbere",
          "Bergkümmel",
          "Bertram",
          "Bockshornklee",
          "Bohnenkraut",
          "Borretsch",
          "Brunnenkresse",
          "Cardamom",
          "Cayennepfeffer",
          "Chili",
          "Cilantro",
          "Cumin",
          "Curcuma",
          "Curryblätter",
          "Currykraut",
          "Currypulver",
          "Dill",
          "Dost",
          "Eberraute",
          "Einlegegewürz",
          "Engelwurz",
          "Epazote",
          "Estragon",
          "Färberdistel",
          "Fenchel",
          "Fetthenne",
          "Gagel",
          "Galgant",
          "Galgant",
          "Gänseblümchen",
          "Garam",
          "Gelbwurz",
          "Gochujang",
          "Gomashio",
          "Gurkenkraut",
          "Harissa",
          "Herbes",
          "Honig",
          "gemeiner",
          "Ingwer",
          "Kaffernlimette",
          "Kakaopulver",
          "Kalmus",
          "Kapern",
          "Kapuzinerkresse",
          "Grüner",
          "Schwarzer",
          "Kerbel",
          "Kemirinuss",
          "Knoblauch",
          "Koriander",
          "Kren",
          "Kresse",
          "Große",
          "Kreuzkümmel",
          "Kubebenpfeffer",
          "Kümmel",
          "Kürbis",
          "Kurkuma",
          "Langer",
          "Lakritze",
          "Lavendel",
          "Liebstöckel",
          "Limette",
          "Lorbeer",
          "Lorbeer",
          "Löffelkraut",
          "Macis",
          "Mandel",
          "Majoran",
          "spreizende",
          "Meerrettich",
          "Melisse",
          "Minze",
          "Mitsuba",
          "Mohnsamen",
          "Muskat",
          "Myrrhenkerbel",
          "Nelkenpfeffer",
          "Ölkürbis",
          "Orangen",
          "Oregano",
          "Pandanus",
          "Paradieskörner",
          "Paprika",
          "Pastinake",
          "Peperoni",
          "Perilla",
          "Petersilie",
          "Pfeffer",
          "Pfefferminze",
          "Piment",
          "Pimpinelle",
          "Portulak",
          "Quendel",
          "Ras",
          "Rhabarber",
          "Rosmarin",
          "Rotwein",
          "Rouille",
          "Rucola",
          "Safran",
          "Salbei",
          "Salz",
          "Sambal",
          "Sassafras",
          "Sauerampfer",
          "Schabzigerklee",
          "Schalotte",
          "Schafgarbe",
          "Schnittknoblauch",
          "Schnittlauch",
          "Schwarzkümmel",
          "Sellerie",
          "Senf",
          "Soumbala",
          "Spitzwegerich",
          "Sternanis",
          "Stevia",
          "Sumach",
          "Süßdolde",
          "Süßholz",
          "Szechuanpfeffer",
          "Tamarinde",
          "Tanduri",
          "Tasmanischer",
          "Tonkabohne",
          "Thymian",
          "Tripmadam",
          "Trüffel",
          "Tschubritza",
          "Wasabi",
          "Wacholder",
          "Waldmeister",
          "Wald-Weidenröschen",
          "Wasserpfeffer",
          "Weinblätter",
          "Weinraute",
          "Ysop",
          "Zichorie",
          "Zimt",
          "Zitronengras",
          "Zitronenmelisse",
          "Zitronen",
          "Zitronenstrauch",
          "Zitronenthymian",
          "Zitwerwurzel",
          "Zucker",
          "Zwiebel"
        ]
      },
      "games": {
        "pokemon": {
          "names": [
            "Bisasam",
            "Bisaknosp",
            "Bisaflor",
            "Glumanda",
            "Glutexo",
            "Glurak",
            "Schiggy",
            "Schillok",
            "Turtok",
            "Raupy",
            "Safcon",
            "Smettbo",
            "Hornliu",
            "Kokuna",
            "Bibor",
            "Taubsi",
            "Tauboga",
            "Tauboss",
            "Rattfratz",
            "Rattikarl",
            "Habitak",
            "Ibitak",
            "Rettan",
            "Arbok",
            "Pikachu",
            "Raichu",
            "Sandan",
            "Sandamer",
            "Nidoran♀",
            "Nidorina",
            "Nidoqueen",
            "Nidoran♂",
            "Nidorino",
            "Nidoking",
            "Piepi",
            "Pixi",
            "Vulpix",
            "Vulnona",
            "Pummeluff",
            "Knuddeluff",
            "Zubat",
            "Golbat",
            "Myrapla",
            "Duflor",
            "Giflor",
            "Paras",
            "Parasek",
            "Bluzuk",
            "Omot",
            "Digda",
            "Digdri",
            "Mauzi",
            "Snobilikat",
            "Enton",
            "Entoron",
            "Menki",
            "Rasaff",
            "Fukano",
            "Arkani",
            "Quapsel",
            "Quaputzi",
            "Quappo",
            "Abra",
            "Kadabra",
            "Simsala",
            "Machollo",
            "Maschock",
            "Machomei",
            "Knofensa",
            "Ultrigaria",
            "Sarzenia",
            "Tentacha",
            "Tentoxa",
            "Kleinstein",
            "Georok",
            "Geowaz",
            "Ponita",
            "Gallopa",
            "Flegmon",
            "Lahmus",
            "Magnetilo",
            "Magneton",
            "Porenta",
            "Dodu",
            "Dodri",
            "Jurob",
            "Jugong",
            "Sleima",
            "Sleimok",
            "Muschas",
            "Austos",
            "Nebelk",
            "Alpollo",
            "Gengar",
            "Onix",
            "Traumato",
            "Hypno",
            "Krabby",
            "Kingler",
            "Voltobal",
            "Lektrobal",
            "Owei",
            "Kokowei",
            "Tragosso",
            "Knogga",
            "Kicklee",
            "Nockchan",
            "Schlurp",
            "Smogon",
            "Smogmog",
            "Rihorn",
            "Rizeros",
            "Chaneira",
            "Tangela",
            "Kangama",
            "Seeper",
            "Seemon",
            "Goldini",
            "Golking",
            "Sterndu",
            "Starmie",
            "Pantimos",
            "Sichlor",
            "Rossana",
            "Elektek",
            "Magmar",
            "Pinsir",
            "Tauros",
            "Karpador",
            "Garados",
            "Lapras",
            "Ditto",
            "Evoli",
            "Aquana",
            "Blitza",
            "Flamara",
            "Porygon",
            "Amonitas",
            "Amoroso",
            "Kabuto",
            "Kabutops",
            "Aerodactyl",
            "Relaxo",
            "Arktos",
            "Zapdos",
            "Lavados",
            "Dratini",
            "Dragonir",
            "Dragoran",
            "Mewtu",
            "Mew"
          ]
        }
      },
      "hipster": {
        "words": [
          "8-Bit",
          "Adrenalinjunkie",
          "Artisan",
          "Artpreneur",
          "Bart",
          "Basic Bitch",
          "Beanie",
          "Braux Pas",
          "Brunch",
          "Craft Beer",
          "Cutester",
          "DIY",
          "Earthporn",
          "Fake",
          "Fashin Girl",
          "Flittern",
          "Foodporn",
          "Freshman at life",
          "Frienvy",
          "Frunch",
          "Genderfriend",
          "Ghosting",
          "Helicopter-Freundin",
          "Hipster",
          "Influencer",
          "Inspiration",
          "Instagram",
          "Jutebeutel",
          "Kombucha",
          "Lomo",
          "Love Interest",
          "Lumbersexual",
          "Mansplaining",
          "Mate",
          "Mingle",
          "Mustache",
          "Möchtegern",
          "Nomophobia",
          "Normcore",
          "OMG",
          "Pinterest",
          "Polaroid",
          "Praktikantenlunch",
          "Pseudointellektuelle",
          "Quinoa",
          "Ringle",
          "SWAG",
          "Sapiosexuell",
          "Sexting",
          "Smoothie",
          "Spornosexuell",
          "Star Wars",
          "Strickmütze",
          "Suchtie",
          "Sushi",
          "Tattoo",
          "Tinder-Finger",
          "Trashopfer",
          "Twitternerds",
          "Undercut",
          "Urban Gardening",
          "Urbane Bohème",
          "Vans",
          "Vice",
          "WTF",
          "YOLO",
          "Yuccies",
          "Zumbatante",
          "awesome",
          "beziehungsunfähig",
          "blog",
          "chillen",
          "crazy",
          "handmade",
          "home brewed",
          "häkeln",
          "organic",
          "party hard",
          "passiv bisexuell",
          "retro",
          "snacken",
          "stricken",
          "suchten",
          "tl;dr",
          "vegan",
          "veganz",
          "veggie",
          "vintage",
          "viral",
          "vlog"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "info",
          "name",
          "net",
          "org",
          "de",
          "ch"
        ]
      },
      "lorem": {
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "music": {
        "instruments": [
          "Akkordeon",
          "Balalaika",
          "Banjo",
          "Bass-Gitarre",
          "Basstuba",
          "Becken-Paar",
          "Blockflöte",
          "Bongo",
          "Bratsche",
          "Cabasa",
          "Celesta",
          "Cello",
          "Cembalo",
          "Dudelsack",
          "E-Bass",
          "E-Gitarre",
          "Fagott",
          "Geige",
          "Gitarre",
          "Gong",
          "Hammondorgel",
          "Harfe",
          "Horn",
          "Keybord",
          "Klarinette",
          "Klavier",
          "Kontrabaß",
          "Laute",
          "Mandoline",
          "Marimba",
          "Mauren",
          "Melodica",
          "Mundharmonika",
          "Oboe",
          "Orgel",
          "Panflöte",
          "Pauke",
          "Piano",
          "Piccoloflöte",
          "Querflöte",
          "Rassel",
          "Sackpfeife",
          "Saxophon",
          "Schellentrommel",
          "Synthesizer",
          "Tamburin",
          "Triangel",
          "Trommel",
          "Trompete",
          "Tuba",
          "Vibraphon",
          "Viola",
          "Violine",
          "Xylophon",
          "Zither"
        ]
      },
      "name": {
        "female_first_name": [
          "Aaliyah",
          "Abby",
          "Abigail",
          "Ada",
          "Adelina",
          "Adriana",
          "Aileen",
          "Aimee",
          "Alana",
          "Alea",
          "Alena",
          "Alessa",
          "Alessia",
          "Alexa",
          "Alexandra",
          "Alexia",
          "Alexis",
          "Aleyna",
          "Alia",
          "Alica",
          "Alice",
          "Alicia",
          "Alina",
          "Alisa",
          "Alisha",
          "Alissa",
          "Aliya",
          "Aliyah",
          "Allegra",
          "Alma",
          "Alyssa",
          "Amalia",
          "Amanda",
          "Amelia",
          "Amelie",
          "Amina",
          "Amira",
          "Amy",
          "Ana",
          "Anabel",
          "Anastasia",
          "Andrea",
          "Angela",
          "Angelina",
          "Angelique",
          "Anja",
          "Ann",
          "Anna",
          "Annabel",
          "Annabell",
          "Annabelle",
          "Annalena",
          "Anne",
          "Anneke",
          "Annelie",
          "Annemarie",
          "Anni",
          "Annie",
          "Annika",
          "Anny",
          "Anouk",
          "Antonia",
          "Arda",
          "Ariana",
          "Ariane",
          "Arwen",
          "Ashley",
          "Asya",
          "Aurelia",
          "Aurora",
          "Ava",
          "Ayleen",
          "Aylin",
          "Ayse",
          "Azra",
          "Betty",
          "Bianca",
          "Bianka",
          "Brigitte",
          "Caitlin",
          "Cara",
          "Carina",
          "Carla",
          "Carlotta",
          "Carmen",
          "Carolin",
          "Carolina",
          "Caroline",
          "Cassandra",
          "Catharina",
          "Catrin",
          "Cecile",
          "Cecilia",
          "Celia",
          "Celina",
          "Celine",
          "Ceyda",
          "Ceylin",
          "Chantal",
          "Charleen",
          "Charlotta",
          "Charlotte",
          "Chayenne",
          "Cheyenne",
          "Chiara",
          "Christin",
          "Christiane",
          "Christina",
          "Cindy",
          "Claire",
          "Clara",
          "Clarissa",
          "Colleen",
          "Collien",
          "Cora",
          "Corinna",
          "Cosima",
          "Dana",
          "Daniela",
          "Daria",
          "Darleen",
          "Defne",
          "Delia",
          "Denise",
          "Diana",
          "Dilara",
          "Dina",
          "Dorothea",
          "Ecrin",
          "Eda",
          "Eileen",
          "Ela",
          "Elaine",
          "Elanur",
          "Elea",
          "Elena",
          "Eleni",
          "Eleonora",
          "Eliana",
          "Elif",
          "Elina",
          "Elisa",
          "Elisabeth",
          "Ella",
          "Ellen",
          "Elli",
          "Elly",
          "Elsa",
          "Emelie",
          "Emely",
          "Emilia",
          "Emilie",
          "Emily",
          "Emma",
          "Emmely",
          "Emmi",
          "Emmy",
          "Enie",
          "Enna",
          "Enya",
          "Esma",
          "Estelle",
          "Esther",
          "Eva",
          "Evelin",
          "Evelina",
          "Eveline",
          "Evelyn",
          "Fabienne",
          "Fatima",
          "Fatma",
          "Felicia",
          "Felicitas",
          "Felina",
          "Femke",
          "Fenja",
          "Fine",
          "Finia",
          "Finja",
          "Finnja",
          "Fiona",
          "Flora",
          "Florentine",
          "Francesca",
          "Franka",
          "Franziska",
          "Frederike",
          "Freya",
          "Frida",
          "Frieda",
          "Friederike",
          "Giada",
          "Gina",
          "Giulia",
          "Giuliana",
          "Greta",
          "Hailey",
          "Hana",
          "Hanna",
          "Hannah",
          "Heidi",
          "Helen",
          "Helena",
          "Helene",
          "Helin",
          "Henriette",
          "Henrike",
          "Hermine",
          "Ida",
          "Ilayda",
          "Imke",
          "Ina",
          "Ines",
          "Inga",
          "Inka",
          "Irem",
          "Isa",
          "Isabel",
          "Isabell",
          "Isabella",
          "Isabelle",
          "Ivonne",
          "Jacqueline",
          "Jamie",
          "Jamila",
          "Jana",
          "Jane",
          "Janin",
          "Janina",
          "Janine",
          "Janna",
          "Janne",
          "Jara",
          "Jasmin",
          "Jasmina",
          "Jasmine",
          "Jella",
          "Jenna",
          "Jennifer",
          "Jenny",
          "Jessica",
          "Jessy",
          "Jette",
          "Jil",
          "Jill",
          "Joana",
          "Joanna",
          "Joelina",
          "Joeline",
          "Joelle",
          "Johanna",
          "Joleen",
          "Jolie",
          "Jolien",
          "Jolin",
          "Jolina",
          "Joline",
          "Jona",
          "Jonah",
          "Jonna",
          "Josefin",
          "Josefine",
          "Josephin",
          "Josephine",
          "Josie",
          "Josy",
          "Joy",
          "Joyce",
          "Judith",
          "Judy",
          "Jule",
          "Julia",
          "Juliana",
          "Juliane",
          "Julie",
          "Julienne",
          "Julika",
          "Julina",
          "Juna",
          "Justine",
          "Kaja",
          "Karina",
          "Karla",
          "Karlotta",
          "Karolina",
          "Karoline",
          "Kassandra",
          "Katarina",
          "Katharina",
          "Kathrin",
          "Katja",
          "Katrin",
          "Kaya",
          "Kayra",
          "Kiana",
          "Kiara",
          "Kim",
          "Kimberley",
          "Kimberly",
          "Kira",
          "Klara",
          "Korinna",
          "Kristin",
          "Kyra",
          "Laila",
          "Lana",
          "Lara",
          "Larissa",
          "Laura",
          "Laureen",
          "Lavinia",
          "Lea",
          "Leah",
          "Leana",
          "Leandra",
          "Leann",
          "Lee",
          "Leila",
          "Lena",
          "Lene",
          "Leni",
          "Lenia",
          "Lenja",
          "Lenya",
          "Leona",
          "Leoni",
          "Leonie",
          "Leonora",
          "Leticia",
          "Letizia",
          "Levke",
          "Leyla",
          "Lia",
          "Liah",
          "Liana",
          "Lili",
          "Lilia",
          "Lilian",
          "Liliana",
          "Lilith",
          "Lilli",
          "Lillian",
          "Lilly",
          "Lily",
          "Lina",
          "Linda",
          "Lindsay",
          "Line",
          "Linn",
          "Linnea",
          "Lisa",
          "Lisann",
          "Lisanne",
          "Liv",
          "Livia",
          "Liz",
          "Lola",
          "Loreen",
          "Lorena",
          "Lotta",
          "Lotte",
          "Louisa",
          "Louise",
          "Luana",
          "Luca",
          "Lucia",
          "Lucie",
          "Lucienne",
          "Lucy",
          "Luisa",
          "Luise",
          "Luka",
          "Luna",
          "Luzie",
          "Lya",
          "Lydia",
          "Lyn",
          "Lynn",
          "Madeleine",
          "Madita",
          "Madleen",
          "Madlen",
          "Magdalena",
          "Maike",
          "Mailin",
          "Maira",
          "Maja",
          "Malena",
          "Malia",
          "Malin",
          "Malina",
          "Mandy",
          "Mara",
          "Marah",
          "Mareike",
          "Maren",
          "Maria",
          "Mariam",
          "Marie",
          "Marieke",
          "Mariella",
          "Marika",
          "Marina",
          "Marisa",
          "Marissa",
          "Marit",
          "Marla",
          "Marleen",
          "Marlen",
          "Marlena",
          "Marlene",
          "Marta",
          "Martha",
          "Mary",
          "Maryam",
          "Mathilda",
          "Mathilde",
          "Matilda",
          "Maxi",
          "Maxima",
          "Maxine",
          "Maya",
          "Mayra",
          "Medina",
          "Medine",
          "Meike",
          "Melanie",
          "Melek",
          "Melike",
          "Melina",
          "Melinda",
          "Melis",
          "Melisa",
          "Melissa",
          "Merle",
          "Merve",
          "Meryem",
          "Mette",
          "Mia",
          "Michaela",
          "Michelle",
          "Mieke",
          "Mila",
          "Milana",
          "Milena",
          "Milla",
          "Mina",
          "Mira",
          "Miray",
          "Miriam",
          "Mirja",
          "Mona",
          "Monique",
          "Nadine",
          "Nadja",
          "Naemi",
          "Nancy",
          "Naomi",
          "Natalia",
          "Natalie",
          "Nathalie",
          "Neele",
          "Nela",
          "Nele",
          "Nelli",
          "Nelly",
          "Nia",
          "Nicole",
          "Nika",
          "Nike",
          "Nikita",
          "Nila",
          "Nina",
          "Nisa",
          "Noemi",
          "Nora",
          "Olivia",
          "Patricia",
          "Patrizia",
          "Paula",
          "Paulina",
          "Pauline",
          "Penelope",
          "Philine",
          "Phoebe",
          "Pia",
          "Rahel",
          "Rania",
          "Rebecca",
          "Rebekka",
          "Riana",
          "Rieke",
          "Rike",
          "Romina",
          "Romy",
          "Ronja",
          "Rosa",
          "Rosalie",
          "Ruby",
          "Sabrina",
          "Sahra",
          "Sally",
          "Salome",
          "Samantha",
          "Samia",
          "Samira",
          "Sandra",
          "Sandy",
          "Sanja",
          "Saphira",
          "Sara",
          "Sarah",
          "Saskia",
          "Selin",
          "Selina",
          "Selma",
          "Sena",
          "Sidney",
          "Sienna",
          "Silja",
          "Sina",
          "Sinja",
          "Smilla",
          "Sofia",
          "Sofie",
          "Sonja",
          "Sophia",
          "Sophie",
          "Soraya",
          "Stefanie",
          "Stella",
          "Stephanie",
          "Stina",
          "Sude",
          "Summer",
          "Susanne",
          "Svea",
          "Svenja",
          "Sydney",
          "Tabea",
          "Talea",
          "Talia",
          "Tamara",
          "Tamia",
          "Tamina",
          "Tanja",
          "Tara",
          "Tarja",
          "Teresa",
          "Tessa",
          "Thalea",
          "Thalia",
          "Thea",
          "Theresa",
          "Tia",
          "Tina",
          "Tomke",
          "Tuana",
          "Valentina",
          "Valeria",
          "Valerie",
          "Vanessa",
          "Vera",
          "Veronika",
          "Victoria",
          "Viktoria",
          "Viola",
          "Vivian",
          "Vivien",
          "Vivienne",
          "Wibke",
          "Wiebke",
          "Xenia",
          "Yara",
          "Yaren",
          "Yasmin",
          "Ylvi",
          "Ylvie",
          "Yvonne",
          "Zara",
          "Zehra",
          "Zeynep",
          "Zoe",
          "Zoey",
          "Zoé"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Abel",
          "Abicht",
          "Abraham",
          "Abramovic",
          "Abt",
          "Achilles",
          "Achkinadze",
          "Ackermann",
          "Adam",
          "Adams",
          "Ade",
          "Agostini",
          "Ahlke",
          "Ahrenberg",
          "Ahrens",
          "Aigner",
          "Albert",
          "Albrecht",
          "Alexa",
          "Alexander",
          "Alizadeh",
          "Allgeyer",
          "Amann",
          "Amberg",
          "Anding",
          "Anggreny",
          "Apitz",
          "Arendt",
          "Arens",
          "Arndt",
          "Aryee",
          "Aschenbroich",
          "Assmus",
          "Astafei",
          "Auer",
          "Axmann",
          "Baarck",
          "Bachmann",
          "Badane",
          "Bader",
          "Baganz",
          "Bahl",
          "Bak",
          "Balcer",
          "Balck",
          "Balkow",
          "Balnuweit",
          "Balzer",
          "Banse",
          "Barr",
          "Bartels",
          "Barth",
          "Barylla",
          "Baseda",
          "Battke",
          "Bauer",
          "Bauermeister",
          "Baumann",
          "Baumeister",
          "Bauschinger",
          "Bauschke",
          "Bayer",
          "Beavogui",
          "Beck",
          "Beckel",
          "Becker",
          "Beckmann",
          "Bedewitz",
          "Beele",
          "Beer",
          "Beggerow",
          "Beh",
          "Behnke",
          "Behnert",
          "Behr",
          "Behrenbruch",
          "Belz",
          "Bender",
          "Benecke",
          "Benner",
          "Benninger",
          "Benzing",
          "Berends",
          "Berger",
          "Berner",
          "Berning",
          "Bertenbreiter",
          "Best",
          "Bethke",
          "Betz",
          "Beushausen",
          "Beutelspacher",
          "Beyer",
          "Biba",
          "Bichler",
          "Bickel",
          "Biedermann",
          "Bieler",
          "Bielert",
          "Bienasch",
          "Bienias",
          "Biesenbach",
          "Bigdeli",
          "Birkemeyer",
          "Bittner",
          "Blank",
          "Blaschek",
          "Blassneck",
          "Bloch",
          "Blochwitz",
          "Blockhaus",
          "Blum",
          "Blume",
          "Bock",
          "Bode",
          "Bogdashin",
          "Bogenrieder",
          "Bohge",
          "Bolm",
          "Borgschulze",
          "Bork",
          "Bormann",
          "Bornscheuer",
          "Borrmann",
          "Borsch",
          "Boruschewski",
          "Bos",
          "Bosler",
          "Bourrouag",
          "Bouschen",
          "Boxhammer",
          "Boyde",
          "Bozsik",
          "Brand",
          "Brandenburg",
          "Brandis",
          "Brandt",
          "Brauer",
          "Braun",
          "Brehmer",
          "Breitenstein",
          "Bremer",
          "Bremser",
          "Brenner",
          "Brettschneider",
          "Breu",
          "Breuer",
          "Briesenick",
          "Bringmann",
          "Brinkmann",
          "Brix",
          "Broening",
          "Brosch",
          "Bruckmann",
          "Bruder",
          "Bruhns",
          "Brunner",
          "Bruns",
          "Bräutigam",
          "Brömme",
          "Brüggmann",
          "Buchholz",
          "Buchrucker",
          "Buder",
          "Bultmann",
          "Bunjes",
          "Burger",
          "Burghagen",
          "Burkhard",
          "Burkhardt",
          "Burmeister",
          "Busch",
          "Buschbaum",
          "Busemann",
          "Buss",
          "Busse",
          "Bussmann",
          "Byrd",
          "Bäcker",
          "Böhm",
          "Bönisch",
          "Börgeling",
          "Börner",
          "Böttner",
          "Büchele",
          "Bühler",
          "Büker",
          "Büngener",
          "Bürger",
          "Bürklein",
          "Büscher",
          "Büttner",
          "Camara",
          "Carlowitz",
          "Carlsohn",
          "Caspari",
          "Caspers",
          "Chapron",
          "Christ",
          "Cierpinski",
          "Clarius",
          "Cleem",
          "Cleve",
          "Co",
          "Conrad",
          "Cordes",
          "Cornelsen",
          "Cors",
          "Cotthardt",
          "Crews",
          "Cronjäger",
          "Crosskofp",
          "Da",
          "Dahm",
          "Dahmen",
          "Daimer",
          "Damaske",
          "Danneberg",
          "Danner",
          "Daub",
          "Daubner",
          "Daudrich",
          "Dauer",
          "Daum",
          "Dauth",
          "Dautzenberg",
          "De",
          "Decker",
          "Deckert",
          "Deerberg",
          "Dehmel",
          "Deja",
          "Delonge",
          "Demut",
          "Dengler",
          "Denner",
          "Denzinger",
          "Derr",
          "Dertmann",
          "Dethloff",
          "Deuschle",
          "Dieckmann",
          "Diedrich",
          "Diekmann",
          "Dienel",
          "Dies",
          "Dietrich",
          "Dietz",
          "Dietzsch",
          "Diezel",
          "Dilla",
          "Dingelstedt",
          "Dippl",
          "Dittmann",
          "Dittmar",
          "Dittmer",
          "Dix",
          "Dobbrunz",
          "Dobler",
          "Dohring",
          "Dolch",
          "Dold",
          "Dombrowski",
          "Donie",
          "Doskoczynski",
          "Dragu",
          "Drechsler",
          "Drees",
          "Dreher",
          "Dreier",
          "Dreissigacker",
          "Dressler",
          "Drews",
          "Duma",
          "Dutkiewicz",
          "Dyett",
          "Dylus",
          "Dächert",
          "Döbel",
          "Döring",
          "Dörner",
          "Dörre",
          "Dück",
          "Eberhard",
          "Eberhardt",
          "Ecker",
          "Eckhardt",
          "Edorh",
          "Effler",
          "Eggenmueller",
          "Ehm",
          "Ehmann",
          "Ehrig",
          "Eich",
          "Eifert",
          "Einert",
          "Eisenlauer",
          "Ekpo",
          "Elbe",
          "Eleyth",
          "Elss",
          "Emert",
          "Emmelmann",
          "Ender",
          "Engel",
          "Engelen",
          "Engelmann",
          "Eplinius",
          "Erdmann",
          "Erhardt",
          "Erlei",
          "Erm",
          "Ernst",
          "Ertl",
          "Erwes",
          "Esenwein",
          "Esser",
          "Evers",
          "Everts",
          "Ewald",
          "Fahner",
          "Faller",
          "Falter",
          "Farber",
          "Fassbender",
          "Faulhaber",
          "Fehrig",
          "Feld",
          "Felke",
          "Feller",
          "Fenner",
          "Fenske",
          "Feuerbach",
          "Fietz",
          "Figl",
          "Figura",
          "Filipowski",
          "Filsinger",
          "Fincke",
          "Fink",
          "Finke",
          "Fischer",
          "Fitschen",
          "Fleischer",
          "Fleischmann",
          "Floder",
          "Florczak",
          "Flore",
          "Flottmann",
          "Forkel",
          "Forst",
          "Frahmeke",
          "Frank",
          "Franke",
          "Franta",
          "Frantz",
          "Franz",
          "Franzis",
          "Franzmann",
          "Frauen",
          "Frauendorf",
          "Freigang",
          "Freimann",
          "Freimuth",
          "Freisen",
          "Frenzel",
          "Frey",
          "Fricke",
          "Fried",
          "Friedek",
          "Friedenberg",
          "Friedmann",
          "Friedrich",
          "Friess",
          "Frisch",
          "Frohn",
          "Frosch",
          "Fuchs",
          "Fuhlbrügge",
          "Fusenig",
          "Fust",
          "Förster",
          "Gaba",
          "Gabius",
          "Gabler",
          "Gadschiew",
          "Gakstädter",
          "Galander",
          "Gamlin",
          "Gamper",
          "Gangnus",
          "Ganzmann",
          "Garatva",
          "Gast",
          "Gastel",
          "Gatzka",
          "Gauder",
          "Gebhardt",
          "Geese",
          "Gehre",
          "Gehrig",
          "Gehring",
          "Gehrke",
          "Geiger",
          "Geisler",
          "Geissler",
          "Gelling",
          "Gens",
          "Gerbennow",
          "Gerdel",
          "Gerhardt",
          "Gerschler",
          "Gerson",
          "Gesell",
          "Geyer",
          "Ghirmai",
          "Ghosh",
          "Giehl",
          "Gierisch",
          "Giesa",
          "Giesche",
          "Gilde",
          "Glatting",
          "Goebel",
          "Goedicke",
          "Goldbeck",
          "Goldfuss",
          "Goldkamp",
          "Goldkühle",
          "Goller",
          "Golling",
          "Gollnow",
          "Golomski",
          "Gombert",
          "Gotthardt",
          "Gottschalk",
          "Gotz",
          "Goy",
          "Gradzki",
          "Graf",
          "Grams",
          "Grasse",
          "Gratzky",
          "Grau",
          "Greb",
          "Green",
          "Greger",
          "Greithanner",
          "Greschner",
          "Griem",
          "Griese",
          "Grimm",
          "Gromisch",
          "Gross",
          "Grosser",
          "Grossheim",
          "Grosskopf",
          "Grothaus",
          "Grothkopp",
          "Grotke",
          "Grube",
          "Gruber",
          "Grundmann",
          "Gruning",
          "Gruszecki",
          "Gröss",
          "Grötzinger",
          "Grün",
          "Grüner",
          "Gummelt",
          "Gunkel",
          "Gunther",
          "Gutjahr",
          "Gutowicz",
          "Gutschank",
          "Göbel",
          "Göckeritz",
          "Göhler",
          "Görlich",
          "Görmer",
          "Götz",
          "Götzelmann",
          "Güldemeister",
          "Günther",
          "Günz",
          "Gürbig",
          "Haack",
          "Haaf",
          "Habel",
          "Hache",
          "Hackbusch",
          "Hackelbusch",
          "Hadfield",
          "Hadwich",
          "Haferkamp",
          "Hahn",
          "Hajek",
          "Hallmann",
          "Hamann",
          "Hanenberger",
          "Hannecker",
          "Hanniske",
          "Hansen",
          "Hardy",
          "Hargasser",
          "Harms",
          "Harnapp",
          "Harter",
          "Harting",
          "Hartlieb",
          "Hartmann",
          "Hartwig",
          "Hartz",
          "Haschke",
          "Hasler",
          "Hasse",
          "Hassfeld",
          "Haug",
          "Hauke",
          "Haupt",
          "Haverney",
          "Heberstreit",
          "Hechler",
          "Hecht",
          "Heck",
          "Hedermann",
          "Hehl",
          "Heidelmann",
          "Heidler",
          "Heinemann",
          "Heinig",
          "Heinke",
          "Heinrich",
          "Heinze",
          "Heiser",
          "Heist",
          "Hellmann",
          "Helm",
          "Helmke",
          "Helpling",
          "Hengmith",
          "Henkel",
          "Hennes",
          "Henry",
          "Hense",
          "Hensel",
          "Hentel",
          "Hentschel",
          "Hentschke",
          "Hepperle",
          "Herberger",
          "Herbrand",
          "Hering",
          "Hermann",
          "Hermecke",
          "Herms",
          "Herold",
          "Herrmann",
          "Herschmann",
          "Hertel",
          "Herweg",
          "Herwig",
          "Herzenberg",
          "Hess",
          "Hesse",
          "Hessek",
          "Hessler",
          "Hetzler",
          "Heuck",
          "Heydemüller",
          "Hiebl",
          "Hildebrand",
          "Hildenbrand",
          "Hilgendorf",
          "Hillard",
          "Hiller",
          "Hingsen",
          "Hingst",
          "Hinrichs",
          "Hirsch",
          "Hirschberg",
          "Hirt",
          "Hodea",
          "Hoffman",
          "Hoffmann",
          "Hofmann",
          "Hohenberger",
          "Hohl",
          "Hohn",
          "Hohnheiser",
          "Hold",
          "Holdt",
          "Holinski",
          "Holl",
          "Holtfreter",
          "Holz",
          "Holzdeppe",
          "Holzner",
          "Hommel",
          "Honz",
          "Hooss",
          "Hoppe",
          "Horak",
          "Horn",
          "Horna",
          "Hornung",
          "Hort",
          "Howard",
          "Huber",
          "Huckestein",
          "Hudak",
          "Huebel",
          "Hugo",
          "Huhn",
          "Hujo",
          "Huke",
          "Huls",
          "Humbert",
          "Huneke",
          "Huth",
          "Häber",
          "Häfner",
          "Höcke",
          "Höft",
          "Höhne",
          "Hönig",
          "Hördt",
          "Hübenbecker",
          "Hübl",
          "Hübner",
          "Hügel",
          "Hüttcher",
          "Hütter",
          "Ibe",
          "Ihly",
          "Illing",
          "Isak",
          "Isekenmeier",
          "Itt",
          "Jacob",
          "Jacobs",
          "Jagusch",
          "Jahn",
          "Jahnke",
          "Jakobs",
          "Jakubczyk",
          "Jambor",
          "Jamrozy",
          "Jander",
          "Janich",
          "Janke",
          "Jansen",
          "Jarets",
          "Jaros",
          "Jasinski",
          "Jasper",
          "Jegorov",
          "Jellinghaus",
          "Jeorga",
          "Jerschabek",
          "Jess",
          "John",
          "Jonas",
          "Jossa",
          "Jucken",
          "Jung",
          "Jungbluth",
          "Jungton",
          "Just",
          "Jürgens",
          "Kaczmarek",
          "Kaesmacher",
          "Kahl",
          "Kahlert",
          "Kahles",
          "Kahlmeyer",
          "Kaiser",
          "Kalinowski",
          "Kallabis",
          "Kallensee",
          "Kampf",
          "Kampschulte",
          "Kappe",
          "Kappler",
          "Karhoff",
          "Karrass",
          "Karst",
          "Karsten",
          "Karus",
          "Kass",
          "Kasten",
          "Kastner",
          "Katzinski",
          "Kaufmann",
          "Kaul",
          "Kausemann",
          "Kawohl",
          "Kazmarek",
          "Kedzierski",
          "Keil",
          "Keiner",
          "Keller",
          "Kelm",
          "Kempe",
          "Kemper",
          "Kempter",
          "Kerl",
          "Kern",
          "Kesselring",
          "Kesselschläger",
          "Kette",
          "Kettenis",
          "Keutel",
          "Kick",
          "Kiessling",
          "Kinadeter",
          "Kinzel",
          "Kinzy",
          "Kirch",
          "Kirst",
          "Kisabaka",
          "Klaas",
          "Klabuhn",
          "Klapper",
          "Klauder",
          "Klaus",
          "Kleeberg",
          "Kleiber",
          "Klein",
          "Kleinert",
          "Kleininger",
          "Kleinmann",
          "Kleinsteuber",
          "Kleiss",
          "Klemme",
          "Klimczak",
          "Klinger",
          "Klink",
          "Klopsch",
          "Klose",
          "Kloss",
          "Kluge",
          "Kluwe",
          "Knabe",
          "Kneifel",
          "Knetsch",
          "Knies",
          "Knippel",
          "Knobel",
          "Knoblich",
          "Knoll",
          "Knorr",
          "Knorscheidt",
          "Knut",
          "Kobs",
          "Koch",
          "Kochan",
          "Kock",
          "Koczulla",
          "Koderisch",
          "Koehl",
          "Koehler",
          "Koenig",
          "Koester",
          "Kofferschlager",
          "Koha",
          "Kohle",
          "Kohlmann",
          "Kohnle",
          "Kohrt",
          "Koj",
          "Kolb",
          "Koleiski",
          "Kolokas",
          "Komoll",
          "Konieczny",
          "Konig",
          "Konow",
          "Konya",
          "Koob",
          "Kopf",
          "Kosenkow",
          "Koster",
          "Koszewski",
          "Koubaa",
          "Kovacs",
          "Kowalick",
          "Kowalinski",
          "Kozakiewicz",
          "Krabbe",
          "Kraft",
          "Kral",
          "Kramer",
          "Krauel",
          "Kraus",
          "Krause",
          "Krauspe",
          "Kreb",
          "Krebs",
          "Kreissig",
          "Kresse",
          "Kreutz",
          "Krieger",
          "Krippner",
          "Krodinger",
          "Krohn",
          "Krol",
          "Kron",
          "Krueger",
          "Krug",
          "Kruger",
          "Krull",
          "Kruschinski",
          "Krämer",
          "Kröckert",
          "Kröger",
          "Krüger",
          "Kubera",
          "Kufahl",
          "Kuhlee",
          "Kuhnen",
          "Kulimann",
          "Kulma",
          "Kumbernuss",
          "Kummle",
          "Kunz",
          "Kupfer",
          "Kupprion",
          "Kuprion",
          "Kurnicki",
          "Kurrat",
          "Kurschilgen",
          "Kuschewitz",
          "Kuschmann",
          "Kuske",
          "Kustermann",
          "Kutscherauer",
          "Kutzner",
          "Kwadwo",
          "Kähler",
          "Käther",
          "Köhler",
          "Köhrbrück",
          "Köhre",
          "Kölotzei",
          "König",
          "Köpernick",
          "Köseoglu",
          "Kúhn",
          "Kúhnert",
          "Kühn",
          "Kühnel",
          "Kühnemund",
          "Kühnert",
          "Kühnke",
          "Küsters",
          "Küter",
          "Laack",
          "Lack",
          "Ladewig",
          "Lakomy",
          "Lammert",
          "Lamos",
          "Landmann",
          "Lang",
          "Lange",
          "Langfeld",
          "Langhirt",
          "Lanig",
          "Lauckner",
          "Lauinger",
          "Laurén",
          "Lausecker",
          "Laux",
          "Laws",
          "Lax",
          "Leberer",
          "Lehmann",
          "Lehner",
          "Leibold",
          "Leide",
          "Leimbach",
          "Leipold",
          "Leist",
          "Leiter",
          "Leiteritz",
          "Leitheim",
          "Leiwesmeier",
          "Lenfers",
          "Lenk",
          "Lenz",
          "Lenzen",
          "Leo",
          "Lepthin",
          "Lesch",
          "Leschnik",
          "Letzelter",
          "Lewin",
          "Lewke",
          "Leyckes",
          "Lg",
          "Lichtenfeld",
          "Lichtenhagen",
          "Lichtl",
          "Liebach",
          "Liebe",
          "Liebich",
          "Liebold",
          "Lieder",
          "Lienshöft",
          "Linden",
          "Lindenberg",
          "Lindenmayer",
          "Lindner",
          "Linke",
          "Linnenbaum",
          "Lippe",
          "Lipske",
          "Lipus",
          "Lischka",
          "Lobinger",
          "Logsch",
          "Lohmann",
          "Lohre",
          "Lohse",
          "Lokar",
          "Loogen",
          "Lorenz",
          "Losch",
          "Loska",
          "Lott",
          "Loy",
          "Lubina",
          "Ludolf",
          "Lufft",
          "Lukoschek",
          "Lutje",
          "Lutz",
          "Löser",
          "Löwa",
          "Lübke",
          "Maak",
          "Maczey",
          "Madetzky",
          "Madubuko",
          "Mai",
          "Maier",
          "Maisch",
          "Malek",
          "Malkus",
          "Mallmann",
          "Malucha",
          "Manns",
          "Manz",
          "Marahrens",
          "Marchewski",
          "Margis",
          "Markowski",
          "Marl",
          "Marner",
          "Marquart",
          "Marschek",
          "Martel",
          "Marten",
          "Martin",
          "Marx",
          "Marxen",
          "Mathes",
          "Mathies",
          "Mathiszik",
          "Matschke",
          "Mattern",
          "Matthes",
          "Matula",
          "Mau",
          "Maurer",
          "Mauroff",
          "May",
          "Maybach",
          "Mayer",
          "Mebold",
          "Mehl",
          "Mehlhorn",
          "Mehlorn",
          "Meier",
          "Meisch",
          "Meissner",
          "Meloni",
          "Melzer",
          "Menga",
          "Menne",
          "Mensah",
          "Mensing",
          "Merkel",
          "Merseburg",
          "Mertens",
          "Mesloh",
          "Metzger",
          "Metzner",
          "Mewes",
          "Meyer",
          "Michallek",
          "Michel",
          "Mielke",
          "Mikitenko",
          "Milde",
          "Minah",
          "Mintzlaff",
          "Mockenhaupt",
          "Moede",
          "Moedl",
          "Moeller",
          "Moguenara",
          "Mohr",
          "Mohrhard",
          "Molitor",
          "Moll",
          "Moller",
          "Molzan",
          "Montag",
          "Moormann",
          "Mordhorst",
          "Morgenstern",
          "Morhelfer",
          "Moritz",
          "Moser",
          "Motchebon",
          "Motzenbbäcker",
          "Mrugalla",
          "Muckenthaler",
          "Mues",
          "Muller",
          "Mulrain",
          "Mächtig",
          "Mäder",
          "Möcks",
          "Mögenburg",
          "Möhsner",
          "Möldner",
          "Möllenbeck",
          "Möller",
          "Möllinger",
          "Mörsch",
          "Mühleis",
          "Müller",
          "Münch",
          "Nabein",
          "Nabow",
          "Nagel",
          "Nannen",
          "Nastvogel",
          "Nau",
          "Naubert",
          "Naumann",
          "Ne",
          "Neimke",
          "Nerius",
          "Neubauer",
          "Neubert",
          "Neuendorf",
          "Neumair",
          "Neumann",
          "Neupert",
          "Neurohr",
          "Neuschwander",
          "Newton",
          "Ney",
          "Nicolay",
          "Niedermeier",
          "Nieklauson",
          "Niklaus",
          "Nitzsche",
          "Noack",
          "Nodler",
          "Nolte",
          "Normann",
          "Norris",
          "Northoff",
          "Nowak",
          "Nussbeck",
          "Nwachukwu",
          "Nytra",
          "Nöh",
          "Oberem",
          "Obergföll",
          "Obermaier",
          "Ochs",
          "Oeser",
          "Olbrich",
          "Onnen",
          "Ophey",
          "Oppong",
          "Orth",
          "Orthmann",
          "Oschkenat",
          "Osei",
          "Osenberg",
          "Ostendarp",
          "Ostwald",
          "Otte",
          "Otto",
          "Paesler",
          "Pajonk",
          "Pallentin",
          "Panzig",
          "Paschke",
          "Patzwahl",
          "Paukner",
          "Peselman",
          "Peter",
          "Peters",
          "Petzold",
          "Pfeiffer",
          "Pfennig",
          "Pfersich",
          "Pfingsten",
          "Pflieger",
          "Pflügner",
          "Philipp",
          "Pichlmaier",
          "Piesker",
          "Pietsch",
          "Pingpank",
          "Pinnock",
          "Pippig",
          "Pitschugin",
          "Plank",
          "Plass",
          "Platzer",
          "Plauk",
          "Plautz",
          "Pletsch",
          "Plotzitzka",
          "Poehn",
          "Poeschl",
          "Pogorzelski",
          "Pohl",
          "Pohland",
          "Pohle",
          "Polifka",
          "Polizzi",
          "Pollmächer",
          "Pomp",
          "Ponitzsch",
          "Porsche",
          "Porth",
          "Poschmann",
          "Poser",
          "Pottel",
          "Prah",
          "Prange",
          "Prediger",
          "Pressler",
          "Preuk",
          "Preuss",
          "Prey",
          "Priemer",
          "Proske",
          "Pusch",
          "Pöche",
          "Pöge",
          "Raabe",
          "Rabenstein",
          "Rach",
          "Radtke",
          "Rahn",
          "Ranftl",
          "Rangen",
          "Ranz",
          "Rapp",
          "Rath",
          "Rau",
          "Raubuch",
          "Raukuc",
          "Rautenkranz",
          "Rehwagen",
          "Reiber",
          "Reichardt",
          "Reichel",
          "Reichling",
          "Reif",
          "Reifenrath",
          "Reimann",
          "Reinberg",
          "Reinelt",
          "Reinhardt",
          "Reinke",
          "Reitze",
          "Renk",
          "Rentz",
          "Renz",
          "Reppin",
          "Restle",
          "Restorff",
          "Retzke",
          "Reuber",
          "Reumann",
          "Reus",
          "Reuss",
          "Reusse",
          "Rheder",
          "Rhoden",
          "Richards",
          "Richter",
          "Riedel",
          "Riediger",
          "Rieger",
          "Riekmann",
          "Riepl",
          "Riermeier",
          "Riester",
          "Riethmüller",
          "Rietmüller",
          "Rietscher",
          "Ringel",
          "Ringer",
          "Rink",
          "Ripken",
          "Ritosek",
          "Ritschel",
          "Ritter",
          "Rittweg",
          "Ritz",
          "Roba",
          "Rockmeier",
          "Rodehau",
          "Rodowski",
          "Roecker",
          "Roggatz",
          "Rohländer",
          "Rohrer",
          "Rokossa",
          "Roleder",
          "Roloff",
          "Roos",
          "Rosbach",
          "Roschinsky",
          "Rose",
          "Rosenauer",
          "Rosenbauer",
          "Rosenthal",
          "Rosksch",
          "Rossberg",
          "Rossler",
          "Roth",
          "Rother",
          "Ruch",
          "Ruckdeschel",
          "Rumpf",
          "Rupprecht",
          "Ruth",
          "Ryjikh",
          "Ryzih",
          "Rädler",
          "Räntsch",
          "Rödiger",
          "Röse",
          "Röttger",
          "Rücker",
          "Rüdiger",
          "Rüter",
          "Sachse",
          "Sack",
          "Saflanis",
          "Sagafe",
          "Sagonas",
          "Sahner",
          "Saile",
          "Sailer",
          "Salow",
          "Salzer",
          "Salzmann",
          "Sammert",
          "Sander",
          "Sarvari",
          "Sattelmaier",
          "Sauer",
          "Sauerland",
          "Saumweber",
          "Savoia",
          "Scc",
          "Schacht",
          "Schaefer",
          "Schaffarzik",
          "Schahbasian",
          "Scharf",
          "Schedler",
          "Scheer",
          "Schelk",
          "Schellenbeck",
          "Schembera",
          "Schenk",
          "Scherbarth",
          "Scherer",
          "Schersing",
          "Scherz",
          "Scheurer",
          "Scheuring",
          "Scheytt",
          "Schielke",
          "Schieskow",
          "Schildhauer",
          "Schilling",
          "Schima",
          "Schimmer",
          "Schindzielorz",
          "Schirmer",
          "Schirrmeister",
          "Schlachter",
          "Schlangen",
          "Schlawitz",
          "Schlechtweg",
          "Schley",
          "Schlicht",
          "Schlitzer",
          "Schmalzle",
          "Schmid",
          "Schmidt",
          "Schmidtchen",
          "Schmitt",
          "Schmitz",
          "Schmuhl",
          "Schneider",
          "Schnelting",
          "Schnieder",
          "Schniedermeier",
          "Schnürer",
          "Schoberg",
          "Scholz",
          "Schonberg",
          "Schondelmaier",
          "Schorr",
          "Schott",
          "Schottmann",
          "Schouren",
          "Schrader",
          "Schramm",
          "Schreck",
          "Schreiber",
          "Schreiner",
          "Schreiter",
          "Schroder",
          "Schröder",
          "Schuermann",
          "Schuff",
          "Schuhaj",
          "Schuldt",
          "Schult",
          "Schulte",
          "Schultz",
          "Schultze",
          "Schulz",
          "Schulze",
          "Schumacher",
          "Schumann",
          "Schupp",
          "Schuri",
          "Schuster",
          "Schwab",
          "Schwalm",
          "Schwanbeck",
          "Schwandke",
          "Schwanitz",
          "Schwarthoff",
          "Schwartz",
          "Schwarz",
          "Schwarzer",
          "Schwarzkopf",
          "Schwarzmeier",
          "Schwatlo",
          "Schweisfurth",
          "Schwennen",
          "Schwerdtner",
          "Schwidde",
          "Schwirkschlies",
          "Schwuchow",
          "Schäfer",
          "Schäffel",
          "Schäffer",
          "Schäning",
          "Schöckel",
          "Schönball",
          "Schönbeck",
          "Schönberg",
          "Schönebeck",
          "Schönenberger",
          "Schönfeld",
          "Schönherr",
          "Schönlebe",
          "Schötz",
          "Schüler",
          "Schüppel",
          "Schütz",
          "Schütze",
          "Seeger",
          "Seelig",
          "Sehls",
          "Seibold",
          "Seidel",
          "Seiders",
          "Seigel",
          "Seiler",
          "Seitz",
          "Semisch",
          "Senkel",
          "Sewald",
          "Siebel",
          "Siebert",
          "Siegling",
          "Sielemann",
          "Siemon",
          "Siener",
          "Sievers",
          "Siewert",
          "Sihler",
          "Sillah",
          "Simon",
          "Sinnhuber",
          "Sischka",
          "Skibicki",
          "Sladek",
          "Slotta",
          "Smieja",
          "Soboll",
          "Sokolowski",
          "Soller",
          "Sollner",
          "Sommer",
          "Somssich",
          "Sonn",
          "Sonnabend",
          "Spahn",
          "Spank",
          "Spelmeyer",
          "Spiegelburg",
          "Spielvogel",
          "Spinner",
          "Spitzmüller",
          "Splinter",
          "Sporrer",
          "Sprenger",
          "Spöttel",
          "Stahl",
          "Stang",
          "Stanger",
          "Stauss",
          "Steding",
          "Steffen",
          "Steffny",
          "Steidl",
          "Steigauf",
          "Stein",
          "Steinecke",
          "Steinert",
          "Steinkamp",
          "Steinmetz",
          "Stelkens",
          "Stengel",
          "Stengl",
          "Stenzel",
          "Stepanov",
          "Stephan",
          "Stern",
          "Steuk",
          "Stief",
          "Stifel",
          "Stoll",
          "Stolle",
          "Stolz",
          "Storl",
          "Storp",
          "Stoutjesdijk",
          "Stratmann",
          "Straub",
          "Strausa",
          "Streck",
          "Streese",
          "Strege",
          "Streit",
          "Streller",
          "Strieder",
          "Striezel",
          "Strogies",
          "Strohschank",
          "Strunz",
          "Strutz",
          "Stube",
          "Stöckert",
          "Stöppler",
          "Stöwer",
          "Stürmer",
          "Suffa",
          "Sujew",
          "Sussmann",
          "Suthe",
          "Sutschet",
          "Swillims",
          "Szendrei",
          "Sören",
          "Sürth",
          "Tafelmeier",
          "Tang",
          "Tasche",
          "Taufratshofer",
          "Tegethof",
          "Teichmann",
          "Tepper",
          "Terheiden",
          "Terlecki",
          "Teufel",
          "Theele",
          "Thieke",
          "Thimm",
          "Thiomas",
          "Thomas",
          "Thriene",
          "Thränhardt",
          "Thust",
          "Thyssen",
          "Thöne",
          "Tidow",
          "Tiedtke",
          "Tietze",
          "Tilgner",
          "Tillack",
          "Timmermann",
          "Tischler",
          "Tischmann",
          "Tittman",
          "Tivontschik",
          "Tonat",
          "Tonn",
          "Trampeli",
          "Trauth",
          "Trautmann",
          "Travan",
          "Treff",
          "Tremmel",
          "Tress",
          "Tsamonikian",
          "Tschiers",
          "Tschirch",
          "Tuch",
          "Tucholke",
          "Tudow",
          "Tuschmo",
          "Tächl",
          "Többen",
          "Töpfer",
          "Uhlemann",
          "Uhlig",
          "Uhrig",
          "Uibel",
          "Uliczka",
          "Ullmann",
          "Ullrich",
          "Umbach",
          "Umlauft",
          "Umminger",
          "Unger",
          "Unterpaintner",
          "Urban",
          "Urbaniak",
          "Urbansky",
          "Urhig",
          "Vahlensieck",
          "Van",
          "Vangermain",
          "Vater",
          "Venghaus",
          "Verniest",
          "Verzi",
          "Vey",
          "Viellehner",
          "Vieweg",
          "Voelkel",
          "Vogel",
          "Vogelgsang",
          "Vogt",
          "Voigt",
          "Vokuhl",
          "Volk",
          "Volker",
          "Volkmann",
          "Von",
          "Vona",
          "Vontein",
          "Wachenbrunner",
          "Wachtel",
          "Wagner",
          "Waibel",
          "Wakan",
          "Waldmann",
          "Wallner",
          "Wallstab",
          "Walter",
          "Walther",
          "Walton",
          "Walz",
          "Wanner",
          "Wartenberg",
          "Waschbüsch",
          "Wassilew",
          "Wassiluk",
          "Weber",
          "Wehrsen",
          "Weidlich",
          "Weidner",
          "Weigel",
          "Weight",
          "Weiler",
          "Weimer",
          "Weis",
          "Weiss",
          "Weller",
          "Welsch",
          "Welz",
          "Welzel",
          "Weniger",
          "Wenk",
          "Werle",
          "Werner",
          "Werrmann",
          "Wessel",
          "Wessinghage",
          "Weyel",
          "Wezel",
          "Wichmann",
          "Wickert",
          "Wiebe",
          "Wiechmann",
          "Wiegelmann",
          "Wierig",
          "Wiese",
          "Wieser",
          "Wilhelm",
          "Wilky",
          "Will",
          "Willwacher",
          "Wilts",
          "Wimmer",
          "Winkelmann",
          "Winkler",
          "Winter",
          "Wischek",
          "Wischer",
          "Wissing",
          "Wittich",
          "Wittl",
          "Wolf",
          "Wolfarth",
          "Wolff",
          "Wollenberg",
          "Wollmann",
          "Woytkowska",
          "Wujak",
          "Wurm",
          "Wyludda",
          "Wölpert",
          "Wöschler",
          "Wühn",
          "Wünsche",
          "Zach",
          "Zaczkiewicz",
          "Zahn",
          "Zaituc",
          "Zandt",
          "Zanner",
          "Zapletal",
          "Zauber",
          "Zeidler",
          "Zekl",
          "Zender",
          "Zeuch",
          "Zeyen",
          "Zeyhle",
          "Ziegler",
          "Zimanyi",
          "Zimmer",
          "Zimmermann",
          "Zinser",
          "Zintl",
          "Zipp",
          "Zipse",
          "Zschunke",
          "Zuber",
          "Zwiener",
          "Zümsande",
          "Östringer",
          "Überacker"
        ],
        "male_first_name": [
          "Aaron",
          "Abdul",
          "Abdullah",
          "Adam",
          "Adrian",
          "Adriano",
          "Ahmad",
          "Ahmed",
          "Ahmet",
          "Alan",
          "Albert",
          "Alessandro",
          "Alessio",
          "Alex",
          "Alexander",
          "Alfred",
          "Ali",
          "Amar",
          "Amir",
          "Amon",
          "Andre",
          "Andreas",
          "Andrew",
          "Angelo",
          "Ansgar",
          "Anthony",
          "Anton",
          "Antonio",
          "Arda",
          "Arian",
          "Armin",
          "Arne",
          "Arno",
          "Arthur",
          "Artur",
          "Arved",
          "Arvid",
          "Ayman",
          "Baran",
          "Baris",
          "Bastian",
          "Batuhan",
          "Bela",
          "Ben",
          "Benedikt",
          "Benjamin",
          "Bennet",
          "Bennett",
          "Benno",
          "Bent",
          "Berat",
          "Berkay",
          "Bernd",
          "Bilal",
          "Bjarne",
          "Björn",
          "Bo",
          "Boris",
          "Brandon",
          "Brian",
          "Bruno",
          "Bryan",
          "Burak",
          "Calvin",
          "Can",
          "Carl",
          "Carlo",
          "Carlos",
          "Carsten",
          "Caspar",
          "Cedric",
          "Cedrik",
          "Cem",
          "Charlie",
          "Chris",
          "Christian",
          "Christiano",
          "Christoph",
          "Christopher",
          "Claas",
          "Clemens",
          "Colin",
          "Collin",
          "Conner",
          "Connor",
          "Constantin",
          "Corvin",
          "Curt",
          "Damian",
          "Damien",
          "Daniel",
          "Danilo",
          "Danny",
          "Darian",
          "Dario",
          "Darius",
          "Darren",
          "David",
          "Davide",
          "Davin",
          "Dean",
          "Deniz",
          "Dennis",
          "Denny",
          "Devin",
          "Diego",
          "Dion",
          "Domenic",
          "Domenik",
          "Dominic",
          "Dominik",
          "Dorian",
          "Dustin",
          "Dylan",
          "Ecrin",
          "Eddi",
          "Eddy",
          "Edgar",
          "Edwin",
          "Efe",
          "Ege",
          "Elia",
          "Eliah",
          "Elias",
          "Elijah",
          "Emanuel",
          "Emil",
          "Emilian",
          "Emilio",
          "Emir",
          "Emirhan",
          "Emre",
          "Enes",
          "Enno",
          "Enrico",
          "Eren",
          "Eric",
          "Erik",
          "Etienne",
          "Fabian",
          "Fabien",
          "Fabio",
          "Fabrice",
          "Falk",
          "Felix",
          "Ferdinand",
          "Fiete",
          "Filip",
          "Finlay",
          "Finley",
          "Finn",
          "Finnley",
          "Florian",
          "Francesco",
          "Franz",
          "Frederic",
          "Frederick",
          "Frederik",
          "Friedrich",
          "Fritz",
          "Furkan",
          "Fynn",
          "Gabriel",
          "Georg",
          "Gerrit",
          "Gian",
          "Gianluca",
          "Gino",
          "Giuliano",
          "Giuseppe",
          "Gregor",
          "Gustav",
          "Hagen",
          "Hamza",
          "Hannes",
          "Hanno",
          "Hans",
          "Hasan",
          "Hassan",
          "Hauke",
          "Hendrik",
          "Hennes",
          "Henning",
          "Henri",
          "Henrick",
          "Henrik",
          "Henry",
          "Hugo",
          "Hussein",
          "Ian",
          "Ibrahim",
          "Ilias",
          "Ilja",
          "Ilyas",
          "Immanuel",
          "Ismael",
          "Ismail",
          "Ivan",
          "Iven",
          "Jack",
          "Jacob",
          "Jaden",
          "Jakob",
          "Jamal",
          "James",
          "Jamie",
          "Jan",
          "Janek",
          "Janis",
          "Janne",
          "Jannek",
          "Jannes",
          "Jannik",
          "Jannis",
          "Jano",
          "Janosch",
          "Jared",
          "Jari",
          "Jarne",
          "Jarno",
          "Jaron",
          "Jason",
          "Jasper",
          "Jay",
          "Jayden",
          "Jayson",
          "Jean",
          "Jens",
          "Jeremias",
          "Jeremie",
          "Jeremy",
          "Jermaine",
          "Jerome",
          "Jesper",
          "Jesse",
          "Jim",
          "Jimmy",
          "Joe",
          "Joel",
          "Joey",
          "Johann",
          "Johannes",
          "John",
          "Johnny",
          "Jon",
          "Jona",
          "Jonah",
          "Jonas",
          "Jonathan",
          "Jonte",
          "Joost",
          "Jordan",
          "Joris",
          "Joscha",
          "Joschua",
          "Josef",
          "Joseph",
          "Josh",
          "Joshua",
          "Josua",
          "Juan",
          "Julian",
          "Julien",
          "Julius",
          "Juri",
          "Justin",
          "Justus",
          "Kaan",
          "Kai",
          "Kalle",
          "Karim",
          "Karl",
          "Karlo",
          "Kay",
          "Keanu",
          "Kenan",
          "Kenny",
          "Keno",
          "Kerem",
          "Kerim",
          "Kevin",
          "Kian",
          "Kilian",
          "Kim",
          "Kimi",
          "Kjell",
          "Klaas",
          "Klemens",
          "Konrad",
          "Konstantin",
          "Koray",
          "Korbinian",
          "Kurt",
          "Lars",
          "Lasse",
          "Laurence",
          "Laurens",
          "Laurenz",
          "Laurin",
          "Lean",
          "Leander",
          "Leandro",
          "Leif",
          "Len",
          "Lenn",
          "Lennard",
          "Lennart",
          "Lennert",
          "Lennie",
          "Lennox",
          "Lenny",
          "Leo",
          "Leon",
          "Leonard",
          "Leonardo",
          "Leonhard",
          "Leonidas",
          "Leopold",
          "Leroy",
          "Levent",
          "Levi",
          "Levin",
          "Lewin",
          "Lewis",
          "Liam",
          "Lian",
          "Lias",
          "Lino",
          "Linus",
          "Lio",
          "Lion",
          "Lionel",
          "Logan",
          "Lorenz",
          "Lorenzo",
          "Loris",
          "Louis",
          "Luan",
          "Luc",
          "Luca",
          "Lucas",
          "Lucian",
          "Lucien",
          "Ludwig",
          "Luis",
          "Luiz",
          "Luk",
          "Luka",
          "Lukas",
          "Luke",
          "Lutz",
          "Maddox",
          "Mads",
          "Magnus",
          "Maik",
          "Maksim",
          "Malik",
          "Malte",
          "Manuel",
          "Marc",
          "Marcel",
          "Marco",
          "Marcus",
          "Marek",
          "Marian",
          "Mario",
          "Marius",
          "Mark",
          "Marko",
          "Markus",
          "Marlo",
          "Marlon",
          "Marten",
          "Martin",
          "Marvin",
          "Marwin",
          "Mateo",
          "Mathis",
          "Matis",
          "Mats",
          "Matteo",
          "Mattes",
          "Matthias",
          "Matthis",
          "Matti",
          "Mattis",
          "Maurice",
          "Max",
          "Maxim",
          "Maximilian",
          "Mehmet",
          "Meik",
          "Melvin",
          "Merlin",
          "Mert",
          "Michael",
          "Michel",
          "Mick",
          "Miguel",
          "Mika",
          "Mikail",
          "Mike",
          "Milan",
          "Milo",
          "Mio",
          "Mirac",
          "Mirco",
          "Mirko",
          "Mohamed",
          "Mohammad",
          "Mohammed",
          "Moritz",
          "Morten",
          "Muhammed",
          "Murat",
          "Mustafa",
          "Nathan",
          "Nathanael",
          "Nelson",
          "Neo",
          "Nevio",
          "Nick",
          "Niclas",
          "Nico",
          "Nicolai",
          "Nicolas",
          "Niels",
          "Nikita",
          "Niklas",
          "Niko",
          "Nikolai",
          "Nikolas",
          "Nils",
          "Nino",
          "Noah",
          "Noel",
          "Norman",
          "Odin",
          "Oke",
          "Ole",
          "Oliver",
          "Omar",
          "Onur",
          "Oscar",
          "Oskar",
          "Pascal",
          "Patrice",
          "Patrick",
          "Paul",
          "Peer",
          "Pepe",
          "Peter",
          "Phil",
          "Philip",
          "Philipp",
          "Pierre",
          "Piet",
          "Pit",
          "Pius",
          "Quentin",
          "Quirin",
          "Rafael",
          "Raik",
          "Ramon",
          "Raphael",
          "Rasmus",
          "Raul",
          "Rayan",
          "René",
          "Ricardo",
          "Riccardo",
          "Richard",
          "Rick",
          "Rico",
          "Robert",
          "Robin",
          "Rocco",
          "Roman",
          "Romeo",
          "Ron",
          "Ruben",
          "Ryan",
          "Said",
          "Salih",
          "Sam",
          "Sami",
          "Sammy",
          "Samuel",
          "Sandro",
          "Santino",
          "Sascha",
          "Sean",
          "Sebastian",
          "Selim",
          "Semih",
          "Shawn",
          "Silas",
          "Simeon",
          "Simon",
          "Sinan",
          "Sky",
          "Stefan",
          "Steffen",
          "Stephan",
          "Steve",
          "Steven",
          "Sven",
          "Sönke",
          "Sören",
          "Taha",
          "Tamino",
          "Tammo",
          "Tarik",
          "Tayler",
          "Taylor",
          "Teo",
          "Theo",
          "Theodor",
          "Thies",
          "Thilo",
          "Thomas",
          "Thorben",
          "Thore",
          "Thorge",
          "Tiago",
          "Til",
          "Till",
          "Tillmann",
          "Tim",
          "Timm",
          "Timo",
          "Timon",
          "Timothy",
          "Tino",
          "Titus",
          "Tizian",
          "Tjark",
          "Tobias",
          "Tom",
          "Tommy",
          "Toni",
          "Tony",
          "Torben",
          "Tore",
          "Tristan",
          "Tyler",
          "Tyron",
          "Umut",
          "Uwe",
          "Valentin",
          "Valentino",
          "Veit",
          "Victor",
          "Viktor",
          "Vin",
          "Vincent",
          "Vito",
          "Vitus",
          "Wilhelm",
          "Willi",
          "William",
          "Willy",
          "Xaver",
          "Yannic",
          "Yannick",
          "Yannik",
          "Yannis",
          "Yasin",
          "Youssef",
          "Yunus",
          "Yusuf",
          "Yven",
          "Yves",
          "Ömer"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{nobility_title} #{first_name} #{last_name}",
          "#{first_name} #{nobility_title_prefix} #{last_name}",
          "#{nobility_title} #{first_name} #{nobility_title_prefix} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "nobility_title": [
          "Baron",
          "Baronin",
          "Freiherr",
          "Freiherrin",
          "Graf",
          "Gräfin"
        ],
        "nobility_title_prefix": [
          "zu",
          "von",
          "vom",
          "von der"
        ],
        "prefix": [
          "Hr.",
          "Fr.",
          "Dr.",
          "Prof.",
          "Prof. Dr.",
          "Prof. Dr. Dr.",
          "Dipl.-Ing."
        ]
      },
      "phone_number": {
        "country_code": [
          "49"
        ],
        "formats": [
          "(0###) #########",
          "(0####) #######",
          "###-#######",
          "####-########"
        ]
      },
      "simpsons": {
        "characters": [
          "Homer Simpson",
          "Marge Simpson",
          "Bart Simpson",
          "Lisa Simpson",
          "Maggie Simpson",
          "Grampa Simpson",
          "Abraham Jedediah \"Abe\" Simpson",
          "Patty Bouvier",
          "Selma Bouvier",
          "Mona Bouvier",
          "Charles Montgomery Burns",
          "Waylon Smithers",
          "Lenford \"Lenny\" Leonard",
          "Carl Carlson",
          "Charlie",
          "Ned Flanders",
          "Maude Flanders",
          "Rod Flanders",
          "Todd Flanders",
          "Janey Powell",
          "Ralph Wiggum",
          "Becky",
          "Alison Taylor",
          "Database",
          "Lewis",
          "Martin Prince",
          "Milhouse van Houten",
          "Nelson Muntz",
          "Richard",
          "Jaffee",
          "Melissa",
          "Sherri",
          "Terri",
          "Wendell Borton",
          "Dolphin Starbeam",
          "Jimbo Jones",
          "Kearney Zzyzwicz",
          "Uter Zörker",
          "Rektor Seymour Skinner",
          "Oberschulrat Chalmers",
          "Edna Krabappel",
          "Elizabeth Hoover",
          "Dewey Largo",
          "Sportlehrer Mr. Krupt",
          "Dr. J. Loren Pryor",
          "Hausmeister Willie",
          "Küchenhilfe Doris Peterson",
          "Otto Mann",
          "Krusty der Clown",
          "Herschel Krustofski",
          "Sideshow Raheem",
          "Tingeltangel-Bob",
          "Tingeltangel-Mel",
          "Mr. Teeny",
          "Bubbles",
          "Itchy",
          "Scratchy",
          "Bienenmann",
          "Scott Christian",
          "Kent Brockman",
          "Arnie Pye",
          "Rainier Wolfcastle",
          "Troy McClure",
          "Lurleen Lumpkin",
          "Duffman",
          "Chief Clancy Wiggum",
          "Lou",
          "Eddie",
          "Comicbuchverkäufer",
          "Roger Meyers Junior",
          "Artie Ziff",
          "Horatio McCallister",
          "Alter Kapitän",
          "Lothar Folkman",
          "Luigi Risotto",
          "Aristotle Amadopolis",
          "Herman",
          "Lindsay Naegle",
          "Cookie Kwan",
          "Dr. Julius Hibbert",
          "Dr. Nick Riviera",
          "Dr. Marvin Monroe",
          "Jasper Beardley",
          "Ralph Melish",
          "Hans Maulwurf",
          "Asa",
          "Mrs. Glick",
          "Sylvia Winfield",
          "Mr. Winfield",
          "Morris \"Moe\" Szyslak",
          "Barney Gumble",
          "Sam",
          "Larry",
          "Akira",
          "Joseph Quimby",
          "Freddy Quimby",
          "Mary Bailey",
          "Roy Snyder",
          "Constance Harm",
          "Lionel Hutz",
          "Blauhaariger Anwalt",
          "Gil Gunderson",
          "Der alte Gil",
          "In der Kirche",
          "Reverend Timothy Lovejoy",
          "Helen Lovejoy",
          "Jessica Lovejoy",
          "Anthony \"Fat Tony\" D'Amico",
          "Legs",
          "Louie",
          "Johnny",
          "Schmallippe",
          "Jacques Brunswick",
          "Disco Stu",
          "Eleanor Abernathy",
          "Katzenlady",
          "Prof. Frink",
          "Kirk van Houten",
          "Luann van Houten",
          "Shauna Tifton",
          "Prinzessin Kashmir",
          "Snake",
          "Jeremy Peterson",
          "Agnes Skinner",
          "Cletus Spuckler",
          "Brandine Spuckler",
          "Mary Spuckler",
          "Apu Nahasapeemapetilon",
          "Manjula Nahasapeemapetilon",
          "Zahnfleischbluter Murphy",
          "Reicher Texaner",
          "Hyman Krustofski",
          "Laura Powers",
          "Ruth Powers",
          "Drederick Tatum",
          "Kang",
          "Kodos"
        ],
        "locations_TODO": []
      },
      "space": {
        "agency": [
          "National Aeronautics and Space Administration",
          "European Space Agency",
          "Deutsches Zentrum für Luft- und Raumfahrt",
          "Indian Space Research Organization",
          "China National Space Administration",
          "UK Space Agency",
          "Brazilian Space Agency",
          "Mexican Space Agency",
          "Israeli Space Agency",
          "Italian Space Agency",
          "Japan Aerospace Exploration Agency",
          "National Space Agency of Ukraine",
          "Russian Federal Space Agency",
          "Swedish National Space Board"
        ],
        "constellation": [
          "Achterdeck",
          "Adler",
          "Altar",
          "Andromeda",
          "Bärenhüter",
          "Becher",
          "Bildhauer",
          "Chamäleon",
          "Chemischer",
          "Delphin",
          "Drache",
          "Dreieck",
          "Eidechse",
          "Einhorn",
          "Eridanus",
          "Fische",
          "Fliege",
          "Fliegender",
          "Fuchs",
          "Fuhrmann",
          "Füllen",
          "Giraffe",
          "Grabstichel",
          "Großer",
          "Großer",
          "Haar",
          "Hase",
          "Herkules",
          "Indianer",
          "Jagdhunde",
          "Jungfrau",
          "Kassiopeia",
          "Kepheus",
          "Kiel",
          "Kleine",
          "Kleiner",
          "Kleiner",
          "Kleiner",
          "Kranich",
          "Krebs",
          "Kreuz",
          "Leier",
          "Löwe",
          "Luchs",
          "Luftpumpe",
          "Maler",
          "Mikroskop",
          "Netz",
          "Nördliche",
          "Oktant",
          "Orion",
          "Paradiesvogel",
          "Pegasus",
          "Pendeluhr",
          "Perseus",
          "Pfau",
          "Pfeil",
          "Phönix",
          "Rabe",
          "Schiffskompass",
          "Schild",
          "Schlange",
          "Schlangenträger",
          "Schütze",
          "Schwan",
          "Schwertfisch",
          "Segel",
          "Sextant",
          "Skorpion",
          "Steinbock",
          "Stier",
          "Südliche",
          "Südlicher",
          "Südliches",
          "Tafelberg",
          "Taube",
          "Teleskop",
          "Tukan",
          "Waage",
          "Walfisch",
          "Wassermann",
          "Wasserschlange",
          "Widder",
          "Winkelmaß",
          "Wolf",
          "Zentaur",
          "Zirkel",
          "Zwillinge"
        ],
        "distance_measurement": [
          "Lichtjahre",
          "AE",
          "Parsec",
          "Kiloparsec",
          "Megaparsec"
        ],
        "galaxy": [
          "Andromeda I",
          "Andromeda II",
          "Andromeda III",
          "Andromeda IX",
          "Andromeda V",
          "Andromeda VI",
          "Andromeda VII",
          "Andromeda VIII",
          "Andromeda X",
          "Andromeda XI",
          "Andromeda XII",
          "Andromeda XIII",
          "Andromeda XIV",
          "Andromeda XIX",
          "Andromeda XV",
          "Andromeda XVI",
          "Andromeda XVII",
          "Andromeda XVIII",
          "Andromeda XX",
          "Andromeda XXI",
          "Andromeda XXII",
          "Andromeda XXIII",
          "Andromeda XXIV",
          "Andromeda XXIX",
          "Andromeda XXV",
          "Andromeda XXVI",
          "Andromeda XXVII",
          "Andromeda XXVIII",
          "Andromedagalaxie",
          "Antlia-Zwerg",
          "Aquarius-Zwerg",
          "Barnards Galaxie",
          "Bootes-I-Zwerg",
          "Bootes-II-Zwerg",
          "Bootes-III-Zwerg",
          "Canes Venatici-I-Zwerg",
          "Canes-Venatici-II-Zwerg",
          "Canis-Major-Zwerg",
          "Carina-Zwerg",
          "Cetus-Zwerg",
          "Coma-Berenices-Zwerggalaxie",
          "Draco-Zwerg",
          "Dreiecksnebel",
          "Fornax-Zwerg",
          "Große Magellansche Wolke",
          "Hercules-Zwerg",
          "IC 10",
          "IC 1613",
          "Kleine Magellansche Wolke",
          "Leo I",
          "Leo II",
          "Leo III",
          "Leo IV",
          "Leo V",
          "LGS 3",
          "M110",
          "M32",
          "Milchstraße",
          "NGC 147",
          "NGC 185",
          "NGC 3109",
          "Pegasus-Zwerg",
          "Phoenix-Zwerg",
          "Pisces II",
          "SagDIG",
          "Sagittarius-Zwerggalaxie",
          "Sculptor-Zwerg",
          "Segue 2",
          "Sextans A",
          "Sextans B",
          "Sextans-Zwerg",
          "Tucana-Zwerg",
          "Ursa-Major-I",
          "Ursa Major II",
          "Ursa-Minor-Zwerg",
          "Wolf-Lundmark-Melotte"
        ],
        "moon": [
          "Mond",
          "Adrastea",
          "Aegaeon",
          "Aegir",
          "Aitne",
          "Albiorix",
          "Amalthea",
          "Ananke",
          "Anthe",
          "Aoede",
          "Arche",
          "Ariel",
          "Atlas",
          "Autonoe",
          "Bebhionn",
          "Belinda",
          "Bergelmir",
          "Bestla",
          "Bianca",
          "Caliban",
          "Callirrhoe",
          "Calypso",
          "Carme",
          "Carpo",
          "Chaldene",
          "Charon",
          "Cordelia",
          "Cressida",
          "Cupid",
          "Cyllene",
          "Daphnis",
          "Deimos",
          "Desdemona",
          "Despina",
          "Dione",
          "Dysnomia",
          "Elara",
          "Enceladus",
          "Epimetheus",
          "Erinome",
          "Erriapus",
          "Euanthe",
          "Eukelade",
          "Euporie",
          "Europa",
          "Eurydome",
          "Farbauti",
          "Fenrir",
          "Ferdinand",
          "Fornjot",
          "Francisco",
          "Galatea",
          "Ganymed",
          "Greip",
          "Halimede",
          "Harpalyke",
          "Hati",
          "Hegemone",
          "Helene",
          "Helike",
          "Hermippe",
          "Herse",
          "Himalia",
          "Hiʻiaka",
          "Hydra",
          "Hyperion",
          "Hyrrokkin",
          "Iapetus",
          "Ijiraq",
          "Io",
          "Iocaste",
          "Isonoe",
          "Janus",
          "Jarnsaxa",
          "Juliet",
          "Kale",
          "Kallichore",
          "Kallisto",
          "Kalyke",
          "Kari",
          "Kerberos",
          "Kiviuq",
          "Kore",
          "Laomedeia",
          "Larissa",
          "Leda",
          "Loge",
          "Lysithea",
          "Mab",
          "Margaret",
          "Megaclite",
          "Methone",
          "Metis",
          "Mimas",
          "Miranda",
          "Mneme",
          "Mundilfari",
          "Naiad",
          "Namaka",
          "Narvi",
          "Nereid",
          "Neso",
          "Nix",
          "Oberon",
          "Ophelia",
          "Orthosie",
          "Paaliaq",
          "Pallene",
          "Pan",
          "Pandora",
          "Pasiphae",
          "Pasithee",
          "Perdita",
          "Phobos",
          "Phoebe",
          "Polydeuces",
          "Portia",
          "Praxidike",
          "Prometheus",
          "Prospero",
          "Proteus",
          "Psamathe",
          "Puck",
          "Rhea",
          "Rosalind",
          "Sao",
          "Setebos",
          "Siarnaq",
          "Sinope",
          "Skathi",
          "Skoll",
          "Sponde",
          "Stephano",
          "Styx",
          "Surtur",
          "Suttungr",
          "Sycorax",
          "Tarqeq",
          "Tarvos",
          "Taygete",
          "Telesto",
          "Tethys",
          "Thalassa",
          "Thebe",
          "Thelxinoe",
          "Themisto",
          "Thrymr",
          "Thyone",
          "Titan",
          "Titania",
          "Trinculo",
          "Triton",
          "Umbriel",
          "Ymir"
        ],
        "nebula": [
          "Blauer Schneeball",
          "Blinking Planetary",
          "Blue Flash Nebula",
          "Blue Planetary Nebula",
          "Bowtie Nebula",
          "Box Nebula",
          "Bumerangnebel",
          "Camel's Eye",
          "Cleopatra’s Eye",
          "Emerald Nebula",
          "Eskimonebel",
          "Eulennebel",
          "Hantelnebel",
          "Helixnebel",
          "Jupiters Geist",
          "Käfer-Nebel",
          "Katzenaugennebel",
          "Kleiner Hantelnebel",
          "Little Gem Nebula",
          "Little Ghost Nebula",
          "Magic Carpet Nebula",
          "Medusanebel",
          "Phantom Streak Nebula",
          "Retinanebel",
          "Ringnebel",
          "Roter Rechtecknebel",
          "Roter Spinnennebel",
          "Saturnnebel",
          "Schildkrötennebel",
          "Schmetterlingsnebel",
          "Skull Nebula",
          "Snowglobe Nebula",
          "Spiral Planetary Nebula",
          "Spirographnebel",
          "Stechrochennebel",
          "Stundenglasnebel",
          "Südlicher Krebsnebel",
          "Südlicher Ringnebel"
        ],
        "planet": [
          "Merkur",
          "Venus",
          "Erde",
          "Mars",
          "Jupiter",
          "Saturn",
          "Uranus",
          "Neptun"
        ],
        "star": [
          "Acamar",
          "Achernar",
          "Achird",
          "Acrux",
          "Acubens",
          "Adhara",
          "Adhil",
          "Agena",
          "Ain",
          "Akrab",
          "Al Kalb al Rai",
          "Al Minliar al Asad",
          "Aladfar",
          "Alamak",
          "Alasco",
          "Alathfar",
          "Albaldah",
          "Albali",
          "Albireo",
          "Alchiba",
          "Alcyone",
          "Aldebaran",
          "Alderamin",
          "Aldhafera",
          "Aldhanab",
          "Aldhibah",
          "Alfecca Meridiana",
          "Alfirk",
          "Algenib",
          "Algieba",
          "Algiedi",
          "Algol",
          "Algorab",
          "Alhena",
          "Alioth",
          "Alkaid",
          "Alkalurops",
          "Al Kaphrah",
          "Alkes",
          "Alkione",
          "Alkor",
          "Alkurah",
          "Al Kurud",
          "Almaaz",
          "Al Nair",
          "Alnasl",
          "Alnilam",
          "Alnitak",
          "Alniyat",
          "Alpha Centauri",
          "Alphard",
          "Alphecca",
          "Alpheratz",
          "Alrakis",
          "Alrischa",
          "Alsafi",
          "Alschain",
          "Alshat",
          "Alsciaukat",
          "Altarf",
          "Altair",
          "Altais",
          "Alterf",
          "Al Thalimain Posterior",
          "Al Thalimain Prior",
          "Aludra",
          "Alula Australi",
          "Alula Borealis",
          "Alwaid",
          "Alya",
          "Alzir",
          "Ancha",
          "Angetenar",
          "Ankaa",
          "Antares",
          "Anser",
          "Anwar Al Farkadain",
          "Arcturus",
          "Arkab Prior",
          "Arkab Posterior",
          "Arm",
          "Arneb",
          "Arrakis",
          "Asellus Australis",
          "Asellus Borealis",
          "Asellus Primus",
          "Asellus Secundus",
          "Asellus Tertius",
          "Askella",
          "Aspidiske",
          "Asterion",
          "Asterope",
          "Atik",
          "Atlas",
          "Atria",
          "Avior",
          "Azaleh",
          "Azelfafage",
          "Azha",
          "Azmidiske",
          "Baham",
          "Barnards Pfeilstern",
          "Baten Kaitos",
          "Becrux",
          "Beid",
          "Bellatrix",
          "Benetnasch",
          "Beteigeuze",
          "Betria",
          "Bharani",
          "Bogardus",
          "Botein",
          "Brachium",
          "Bunda",
          "Canopus",
          "Caph",
          "Capella",
          "Castor",
          "Cebalrai",
          "Ceginus",
          "Celaeno",
          "Cervantes",
          "Chalawan",
          "Chara",
          "Chertan",
          "Chow",
          "Copernicus",
          "Cor Caroli",
          "Cursa",
          "Dabih",
          "Decrux",
          "Deneb",
          "Deneb Algedi",
          "Deneb Algenubi",
          "Deneb Dulfim",
          "Deneb el Okab Australis",
          "Deneb el Okab Borealis",
          "Deneb Kaitos",
          "Deneb Kaitos Schemali",
          "Denebola",
          "Dheneb",
          "Diadem",
          "Diphda",
          "Dschubba",
          "Dubhe",
          "Duhr",
          "Edasich",
          "Elektra",
          "Elmuthalleth",
          "Elnath",
          "Elscheratain",
          "Enif",
          "Errai",
          "Etamin",
          "Fafnir",
          "Fomalhaut",
          "Fum al Samakah",
          "Furud",
          "Gacrux",
          "Gatria",
          "Gemma",
          "Gianfar",
          "Giedi",
          "Gienah",
          "Gienah",
          "Girtab",
          "Gomeisa",
          "Gorgonea Secunda",
          "Gorgonea Tertia",
          "Gorgonea Quarta",
          "Graffias",
          "Granatstern",
          "Grumium",
          "Hadar",
          "Hadir",
          "Haedus",
          "Haldus",
          "Hamal",
          "Han",
          "Hassaleh",
          "Hatysa",
          "Head of Hydrus",
          "Heka",
          "Helvetios",
          "Heze",
          "Homam",
          "Hyadum I",
          "Hyadum II",
          "Intercrus",
          "Izar",
          "Jabbah",
          "Jih",
          "Kaffaljidhm",
          "Kajam",
          "Kapteyns Stern",
          "Kastra",
          "Kaus Australis",
          "Kaus Borealis",
          "Kaus Medius",
          "Keid",
          "Kitalpha",
          "Kochab",
          "Kornephoros",
          "Kraz",
          "Ksora",
          "Kullat Nunu",
          "Kuma",
          "La Superba",
          "Lesath",
          "Libertas",
          "Lukida",
          "Lukida Anseris",
          "Luytens Stern",
          "Maasym",
          "Maia",
          "Marfark",
          "Marfik",
          "Markab",
          "Matar",
          "Mebsuta",
          "Megrez",
          "Mekbuda",
          "Meissa",
          "Menkalinan",
          "Menkar",
          "Menkent",
          "Menchib",
          "Merak",
          "Merga",
          "Merope",
          "Mesarthim",
          "Miaplacidus",
          "Minchir",
          "Minelava",
          "Minkar",
          "Mintaka",
          "Mira",
          "Mirach",
          "Miram",
          "Mirfak",
          "Mirzam",
          "Misam",
          "Mizar",
          "Mothallah",
          "Mufrid",
          "Muliphein",
          "Murzim",
          "Muscida",
          "Musica",
          "Nair Al Saif",
          "Naos",
          "Nash",
          "Nashira",
          "Navi",
          "Nembus",
          "Nekkar",
          "Nihal",
          "Nunki",
          "Nusakan",
          "Ogma",
          "Okul",
          "Peacock",
          "Phakt",
          "Phekda",
          "Pherkad",
          "Pherkard",
          "Pistolenstern",
          "Pleione",
          "Polaris Australis",
          "Polarstern",
          "Pollux",
          "Porrima",
          "Praecipua",
          "Prijipati",
          "Prokyon",
          "Propus",
          "Proxima Centauri",
          "Ran",
          "Rana",
          "Rasalas",
          "Ras Algethi",
          "Ras Alhague",
          "Ras Elased Australis",
          "Rastaban",
          "Regor",
          "Regulus",
          "Rigel",
          "Rigil Kentaurus",
          "Rijl al Awwa",
          "Rotanev",
          "Ruchbah",
          "Rukbat",
          "Sabik",
          "Sadachbia",
          "Sadalbari",
          "Sadalmelik",
          "Sadalsuud",
          "Sadr",
          "Saiph",
          "Salm",
          "Sargas",
          "Sarin",
          "Sarir",
          "Sceptrum",
          "Scheat",
          "Scheddi",
          "Schedir",
          "Segin",
          "Seginus",
          "Sham",
          "Sheliak",
          "Sheratan",
          "Shaula",
          "Skat",
          "Sirius",
          "Sirrah",
          "Situla",
          "Spica",
          "Sonne",
          "Sterope",
          "Sualocin",
          "Subra",
          "Suhail",
          "Sulafat",
          "Syrma",
          "Tabit",
          "Talitha Australis",
          "Talitha Borealis",
          "Tania Australis",
          "Tania Borealis",
          "Tarazed",
          "Taygeta",
          "Teegardens Stern",
          "Tegmen",
          "Terebellum",
          "Tejat Posterior",
          "Tejat Prior",
          "Thabit",
          "Theemin",
          "Thuban",
          "Tien Kuan",
          "Titawin",
          "Toliman",
          "Tonatiuh",
          "Torcularis Septentrionalis",
          "Tseen Kee",
          "Turais",
          "Rho Puppis",
          "Tyl",
          "Unukalhai",
          "Van Maanens Stern",
          "Veritate",
          "Vindemiatrix",
          "Wasat",
          "Wega",
          "Wei",
          "Wezen",
          "Yed Prior",
          "Yed Posterior",
          "Zaniah",
          "Zaurak",
          "Zavijava",
          "Zibal",
          "Zosma",
          "Zuben-el-Akrab",
          "Zuben-el-Akribi",
          "Zuben-el-dschenubi",
          "Zuben-el-schemali"
        ],
        "star_cluster": [
          "Chi Persei",
          "Coma-Berenices-Haufen",
          "Eulenhaufen",
          "Hyaden",
          "Herkuleshaufen",
          "Kleiderbügelhaufen",
          "Kleiner Skorpion",
          "Krippe",
          "Intergalaktischer Wanderer",
          "Muskelmännchen",
          "Omega Centauri",
          "Plejaden",
          "Praesepe",
          "Ptolomaeus Sternhaufen",
          "Schmetterlingshaufen",
          "Schmuckkästchen",
          "Siebengestirn",
          "Südliche Plejaden",
          "Tucanae",
          "Weihnachtsbaum-Sternhaufen",
          "Wildentenhaufen"
        ]
      },
      "university": {
        "name": [
          "#{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{University.suffix} #{Address.city}",
          "#{University.suffix} #{Address.city}"
        ],
        "prefix": [
          "Technische"
        ],
        "suffix": [
          "Universität",
          "Hochschule"
        ]
      }
    },
    "hello": "hallo",
    "helpers": {
      "select": {
        "prompt": "Bitte wählen"
      },
      "submit": {
        "create": "%{model} erstellen",
        "submit": "%{model} speichern",
        "update": "%{model} aktualisieren"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "Ä": "Ae",
          "Ö": "Oe",
          "Ü": "Ue",
          "ß": "ss",
          "ä": "ae",
          "é": "e",
          "ö": "oe",
          "ü": "ue",
          "ẞ": "SS"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "Milliarde",
              "other": "Milliarden"
            },
            "million": {
              "one": "Million",
              "other": "Millionen"
            },
            "quadrillion": {
              "one": "Billiarde",
              "other": "Billiarden"
            },
            "thousand": "Tausend",
            "trillion": {
              "one": "Billion",
              "other": "Billionen"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " und ",
        "two_words_connector": " und ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "vormittags",
      "formats": {
        "default": "%A, %d. %B %Y, %H:%M Uhr",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d. %B %Y %H:%M"
            }
          }
        },
        "long": "%A, %d. %B %Y, %H:%M Uhr",
        "short": "%d. %b, %H:%M Uhr"
      },
      "pm": "nachmittags"
    },
    "welcome": "willkommen"
  },
  "de-AT": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Datensatz kann nicht gelöscht werden, da abhängige %{record} existieren.",
            "has_one": "Datensatz kann nicht gelöscht werden, da ein abhängiger %{record}-Datensatz existiert."
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ],
      "abbr_month_names": [
        null,
        "Jän",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "day_names": [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "Jänner",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "etwa eine Stunde",
          "other": "etwa %{count} Stunden"
        },
        "about_x_months": {
          "one": "etwa ein Monat",
          "other": "etwa %{count} Monate"
        },
        "about_x_years": {
          "one": "etwa ein Jahr",
          "other": "etwa %{count} Jahre"
        },
        "almost_x_years": {
          "one": "fast ein Jahr",
          "other": "fast %{count} Jahre"
        },
        "half_a_minute": "eine halbe Minute",
        "less_than_x_minutes": {
          "one": "weniger als eine Minute",
          "other": "weniger als %{count} Minuten"
        },
        "less_than_x_seconds": {
          "one": "weniger als eine Sekunde",
          "other": "weniger als %{count} Sekunden"
        },
        "over_x_years": {
          "one": "mehr als ein Jahr",
          "other": "mehr als %{count} Jahre"
        },
        "x_days": {
          "one": "ein Tag",
          "other": "%{count} Tage"
        },
        "x_minutes": {
          "one": "eine Minute",
          "other": "%{count} Minuten"
        },
        "x_months": {
          "one": "ein Monat",
          "other": "%{count} Monate"
        },
        "x_seconds": {
          "one": "eine Sekunde",
          "other": "%{count} Sekunden"
        }
      },
      "prompts": {
        "day": "Tag",
        "hour": "Stunde",
        "minute": "Minuten",
        "month": "Monat",
        "second": "Sekunden",
        "year": "Jahr"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "muss akzeptiert werden",
        "blank": "muss ausgefüllt werden",
        "confirmation": "stimmt nicht mit %{attribute} überein",
        "empty": "muss ausgefüllt werden",
        "equal_to": "muss genau %{count} sein",
        "even": "muss gerade sein",
        "exclusion": "ist nicht verfügbar",
        "greater_than": "muss größer als %{count} sein",
        "greater_than_or_equal_to": "muss größer oder gleich %{count} sein",
        "inclusion": "ist kein gültiger Wert",
        "invalid": "ist nicht gültig",
        "less_than": "muss kleiner als %{count} sein",
        "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
        "model_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
        "not_a_number": "ist keine Zahl",
        "not_an_integer": "muss ganzzahlig sein",
        "odd": "muss ungerade sein",
        "other_than": "darf nicht gleich %{count} sein",
        "password_too_long": "ist zu lang",
        "present": "darf nicht ausgefüllt werden",
        "required": "muss ausgefüllt werden",
        "taken": "ist bereits vergeben",
        "too_long": {
          "one": "ist zu lang (mehr als %{count} Zeichen)",
          "other": "ist zu lang (mehr als %{count} Zeichen)"
        },
        "too_short": {
          "one": "ist zu kurz (weniger als %{count} Zeichen)",
          "other": "ist zu kurz (weniger als %{count} Zeichen)"
        },
        "wrong_length": {
          "one": "hat die falsche Länge (muss genau %{count} Zeichen haben)",
          "other": "hat die falsche Länge (muss genau %{count} Zeichen haben)"
        }
      },
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#",
          "##a",
          "##b",
          "##c"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Aigen im Mühlkreis",
          "Allerheiligen bei Wildon",
          "Altenfelden",
          "Arriach",
          "Axams",
          "Baumgartenberg",
          "Bergern im Dunkelsteinerwald",
          "Berndorf bei Salzburg",
          "Bregenz",
          "Breitenbach am Inn",
          "Deutsch-Wagram",
          "Dienten am Hochkönig",
          "Dietach",
          "Dornbirn",
          "Dürnkrut",
          "Eben im Pongau",
          "Ebenthal in Kärnten",
          "Eichgraben",
          "Eisenstadt",
          "Ellmau",
          "Feistritz am Wechsel",
          "Finkenberg",
          "Fiss",
          "Frantschach-St. Gertraud",
          "Fritzens",
          "Gams bei Hieflau",
          "Geiersberg",
          "Graz",
          "Großhöflein",
          "Gößnitz",
          "Hartl",
          "Hausleiten",
          "Herzogenburg",
          "Hinterhornbach",
          "Hochwolkersdorf",
          "Ilz",
          "Ilztal",
          "Innerbraz",
          "Innsbruck",
          "Itter",
          "Jagerberg",
          "Jeging",
          "Johnsbach",
          "Johnsdorf-Brunn",
          "Jungholz",
          "Kirchdorf am Inn",
          "Klagenfurt",
          "Kottes-Purk",
          "Krumau am Kamp",
          "Krumbach",
          "Lavamünd",
          "Lech",
          "Linz",
          "Ludesch",
          "Lödersdorf",
          "Marbach an der Donau",
          "Mattsee",
          "Mautern an der Donau",
          "Mauterndorf",
          "Mitterbach am Erlaufsee",
          "Neudorf bei Passail",
          "Neudorf bei Staatz",
          "Neukirchen an der Enknach",
          "Neustift an der Lafnitz",
          "Niederleis",
          "Oberndorf in Tirol",
          "Oberstorcha",
          "Oberwaltersdorf",
          "Oed-Oehling",
          "Ort im Innkreis",
          "Pilgersdorf",
          "Pitschgau",
          "Pollham",
          "Preitenegg",
          "Purbach am Neusiedler See",
          "Rabenwald",
          "Raiding",
          "Rastenfeld",
          "Ratten",
          "Rettenegg",
          "Salzburg",
          "Sankt Johann im Saggautal",
          "St. Peter am Kammersberg",
          "St. Pölten",
          "St. Veit an der Glan",
          "Taxenbach",
          "Tragwein",
          "Trebesing",
          "Trieben",
          "Turnau",
          "Ungerdorf",
          "Unterauersbach",
          "Unterstinkenbrunn",
          "Untertilliach",
          "Uttendorf",
          "Vals",
          "Velden am Wörther See",
          "Viehhofen",
          "Villach",
          "Vitis",
          "Waidhofen an der Thaya",
          "Waldkirchen am Wesen",
          "Weißkirchen an der Traun",
          "Wien",
          "Wimpassing im Schwarzatale",
          "Ybbs an der Donau",
          "Ybbsitz",
          "Yspertal",
          "Zeillern",
          "Zell am Pettenfirst",
          "Zell an der Pram",
          "Zerlach",
          "Zwölfaxing",
          "Öblarn",
          "Übelbach",
          "Überackern",
          "Übersaxen",
          "Übersbach"
        ],
        "country": [
          "Ägypten",
          "Äquatorialguinea",
          "Äthiopien",
          "Österreich",
          "Afghanistan",
          "Albanien",
          "Algerien",
          "Amerikanisch-Samoa",
          "Amerikanische Jungferninseln",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarktis",
          "Antigua und Barbuda",
          "Argentinien",
          "Armenien",
          "Aruba",
          "Aserbaidschan",
          "Australien",
          "Bahamas",
          "Bahrain",
          "Bangladesch",
          "Barbados",
          "Belarus",
          "Belgien",
          "Belize",
          "Benin",
          "die Bermudas",
          "Bhutan",
          "Bolivien",
          "Bosnien und Herzegowina",
          "Botsuana",
          "Bouvetinsel",
          "Brasilien",
          "Britische Jungferninseln",
          "Britisches Territorium im Indischen Ozean",
          "Brunei Darussalam",
          "Bulgarien",
          "Burkina Faso",
          "Burundi",
          "Chile",
          "China",
          "Cookinseln",
          "Costa Rica",
          "Dänemark",
          "Demokratische Republik Kongo",
          "Demokratische Volksrepublik Korea",
          "Deutschland",
          "Dominica",
          "Dominikanische Republik",
          "Dschibuti",
          "Ecuador",
          "El Salvador",
          "Eritrea",
          "Estland",
          "Färöer",
          "Falklandinseln",
          "Fidschi",
          "Finnland",
          "Frankreich",
          "Französisch-Guayana",
          "Französisch-Polynesien",
          "Französische Gebiete im südlichen Indischen Ozean",
          "Gabun",
          "Gambia",
          "Georgien",
          "Ghana",
          "Gibraltar",
          "Grönland",
          "Grenada",
          "Griechenland",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard und McDonaldinseln",
          "Honduras",
          "Hongkong",
          "Indien",
          "Indonesien",
          "Irak",
          "Iran",
          "Irland",
          "Island",
          "Israel",
          "Italien",
          "Jamaika",
          "Japan",
          "Jemen",
          "Jordanien",
          "Jugoslawien",
          "Kaimaninseln",
          "Kambodscha",
          "Kamerun",
          "Kanada",
          "Kap Verde",
          "Kasachstan",
          "Katar",
          "Kenia",
          "Kirgisistan",
          "Kiribati",
          "Kleinere amerikanische Überseeinseln",
          "Kokosinseln",
          "Kolumbien",
          "Komoren",
          "Kongo",
          "Kroatien",
          "Kuba",
          "Kuwait",
          "Laos",
          "Lesotho",
          "Lettland",
          "Libanon",
          "Liberia",
          "Libyen",
          "Liechtenstein",
          "Litauen",
          "Luxemburg",
          "Macau",
          "Madagaskar",
          "Malawi",
          "Malaysia",
          "Malediven",
          "Mali",
          "Malta",
          "ehemalige jugoslawische Republik Mazedonien",
          "Marokko",
          "Marshallinseln",
          "Martinique",
          "Mauretanien",
          "Mauritius",
          "Mayotte",
          "Mexiko",
          "Mikronesien",
          "Monaco",
          "Mongolei",
          "Montserrat",
          "Mosambik",
          "Myanmar",
          "Nördliche Marianen",
          "Namibia",
          "Nauru",
          "Nepal",
          "Neukaledonien",
          "Neuseeland",
          "Nicaragua",
          "Niederländische Antillen",
          "Niederlande",
          "Niger",
          "Nigeria",
          "Niue",
          "Norfolkinsel",
          "Norwegen",
          "Oman",
          "Osttimor",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua-Neuguinea",
          "Paraguay",
          "Peru",
          "Philippinen",
          "Pitcairninseln",
          "Polen",
          "Portugal",
          "Puerto Rico",
          "Réunion",
          "Republik Korea",
          "Republik Moldau",
          "Ruanda",
          "Rumänien",
          "Russische Föderation",
          "São Tomé und Príncipe",
          "Südafrika",
          "Südgeorgien und Südliche Sandwichinseln",
          "Salomonen",
          "Sambia",
          "Samoa",
          "San Marino",
          "Saudi-Arabien",
          "Schweden",
          "Schweiz",
          "Senegal",
          "Seychellen",
          "Sierra Leone",
          "Simbabwe",
          "Singapur",
          "Slowakei",
          "Slowenien",
          "Somalien",
          "Spanien",
          "Sri Lanka",
          "St. Helena",
          "St. Kitts und Nevis",
          "St. Lucia",
          "St. Pierre und Miquelon",
          "St. Vincent und die Grenadinen",
          "Sudan",
          "Surinam",
          "Svalbard und Jan Mayen",
          "Swasiland",
          "Syrien",
          "Türkei",
          "Tadschikistan",
          "Taiwan",
          "Tansania",
          "Thailand",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad und Tobago",
          "Tschad",
          "Tschechische Republik",
          "Tunesien",
          "Turkmenistan",
          "Turks- und Caicosinseln",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "Ungarn",
          "Uruguay",
          "Usbekistan",
          "Vanuatu",
          "Vatikanstadt",
          "Venezuela",
          "Vereinigte Arabische Emirate",
          "Vereinigte Staaten",
          "Vereinigtes Königreich",
          "Vietnam",
          "Wallis und Futuna",
          "Weihnachtsinsel",
          "Westsahara",
          "Zentralafrikanische Republik",
          "Zypern"
        ],
        "default_country": [
          "Österreich"
        ],
        "default_country_code": [
          "AT"
        ],
        "postcode": [
          "####"
        ],
        "secondary_address": [
          "Apt. ###",
          "Zimmer ###",
          "# OG"
        ],
        "state": [
          "Burgenland",
          "Kärnten",
          "Niederösterreich",
          "Oberösterreich",
          "Salzburg",
          "Steiermark",
          "Tirol",
          "Vorarlberg",
          "Wien"
        ],
        "state_abbr": [
          "Bgld.",
          "Ktn.",
          "NÖ",
          "OÖ",
          "Sbg.",
          "Stmk.",
          "T",
          "Vbg.",
          "W"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_root}"
        ],
        "street_root": [
          "Ahorn",
          "Ahorngasse (St. Andrä)",
          "Alleestraße (Poysbrunn)",
          "Alpenlandstraße",
          "Alte Poststraße",
          "Alte Ufergasse",
          "Am Kronawett (Hagenbrunn)",
          "Am Mühlwasser",
          "Am Rebenhang",
          "Am Sternweg",
          "Anton Wildgans-Straße",
          "Auer-von-Welsbach-Weg",
          "Auf der Stift",
          "Aufeldgasse",
          "Bahngasse",
          "Bahnhofstraße",
          "Bahnstraße (Gerhaus)",
          "Basteigasse",
          "Berggasse",
          "Bergstraße",
          "Birkenweg",
          "Blasiussteig",
          "Blattur",
          "Bruderhofgasse",
          "Brunnelligasse",
          "Bühelweg",
          "Darnautgasse",
          "Donaugasse",
          "Dorfplatz (Haselbach)",
          "Dr.-Oberreiter-Straße",
          "Dr.Karl Holoubek-Str.",
          "Drautal Bundesstraße",
          "Dürnrohrer Straße",
          "Ebenthalerstraße",
          "Eckgrabenweg",
          "Erlenstraße",
          "Erlenweg",
          "Eschenweg",
          "Etrichgasse",
          "Fassergasse",
          "Feichteggerwiese",
          "Feld-Weg",
          "Feldgasse",
          "Feldstapfe",
          "Fischpointweg",
          "Flachbergstraße",
          "Flurweg",
          "Franz Schubert-Gasse",
          "Franz-Schneeweiß-Weg",
          "Franz-von-Assisi-Straße",
          "Fritz-Pregl-Straße",
          "Fuchsgrubenweg",
          "Födlerweg",
          "Föhrenweg",
          "Fünfhaus (Paasdorf)",
          "Gabelsbergerstraße",
          "Gartenstraße",
          "Geigen",
          "Geigergasse",
          "Gemeindeaugasse",
          "Gemeindeplatz",
          "Georg-Aichinger-Straße",
          "Glanfeldbachweg",
          "Graben (Burgauberg)",
          "Grub",
          "Gröretgasse",
          "Grünbach",
          "Gösting",
          "Hainschwang",
          "Hans-Mauracher-Straße",
          "Hart",
          "Teichstraße",
          "Hauptplatz",
          "Hauptstraße",
          "Heideweg",
          "Heinrich Landauer Gasse",
          "Helenengasse",
          "Hermann von Gilmweg",
          "Hermann-Löns-Gasse",
          "Herminengasse",
          "Hernstorferstraße",
          "Hirsdorf",
          "Hochfeistritz",
          "Hochhaus Neue Donau",
          "Hof",
          "Hussovits Gasse",
          "Höggen",
          "Hütten",
          "Janzgasse",
          "Jochriemgutstraße",
          "Johann-Strauß-Gasse",
          "Julius-Raab-Straße",
          "Kahlenberger Straße",
          "Karl Kraft-Straße",
          "Kegelprielstraße",
          "Keltenberg-Eponaweg",
          "Kennedybrücke",
          "Kerpelystraße",
          "Kindergartenstraße",
          "Kinderheimgasse",
          "Kirchenplatz",
          "Kirchweg",
          "Klagenfurter Straße",
          "Klamm",
          "Kleinbaumgarten",
          "Klingergasse",
          "Koloniestraße",
          "Konrad-Duden-Gasse",
          "Krankenhausstraße",
          "Kubinstraße",
          "Köhldorfergasse",
          "Lackenweg",
          "Lange Mekotte",
          "Leifling",
          "Leopold Frank-Straße (Pellendorf)",
          "Lerchengasse (Pirka)",
          "Lichtensternsiedlung V",
          "Lindenhofstraße",
          "Lindenweg",
          "Luegstraße",
          "Maierhof",
          "Malerweg",
          "Mitterweg",
          "Mittlere Hauptstraße",
          "Moosbachgasse",
          "Morettigasse",
          "Musikpavillon Riezlern",
          "Mühlboden",
          "Mühle",
          "Mühlenweg",
          "Neustiftgasse",
          "Niederegg",
          "Niedergams",
          "Nordwestbahnbrücke",
          "Oberbödenalm",
          "Obere Berggasse",
          "Oedt",
          "Am Färberberg",
          "Ottogasse",
          "Paul Peters-Gasse",
          "Perspektivstraße",
          "Poppichl",
          "Privatweg",
          "Prixgasse",
          "Pyhra",
          "Radetzkystraße",
          "Raiden",
          "Reichensteinstraße",
          "Reitbauernstraße",
          "Reiterweg",
          "Reitschulgasse",
          "Ringweg",
          "Rupertistraße",
          "Römerstraße",
          "Römerweg",
          "Sackgasse",
          "Schaunbergerstraße",
          "Schloßweg",
          "Schulgasse (Langeck)",
          "Schönholdsiedlung",
          "Seeblick",
          "Seestraße",
          "Semriacherstraße",
          "Simling",
          "Sipbachzeller Straße",
          "Sonnenweg",
          "Spargelfeldgasse",
          "Spiesmayrweg",
          "Sportplatzstraße",
          "St.Ulrich",
          "Steilmannstraße",
          "Steingrüneredt",
          "Strassfeld",
          "Straßerau",
          "Stöpflweg",
          "Stüra",
          "Taferngasse",
          "Tennweg",
          "Thomas Koschat-Gasse",
          "Tiroler Straße",
          "Torrogasse",
          "Uferstraße (Schwarzau am Steinfeld)",
          "Unterdörfl",
          "Unterer Sonnrainweg",
          "Verwaltersiedlung",
          "Waldhang",
          "Wasen",
          "Weidenstraße",
          "Weiherweg",
          "Wettsteingasse",
          "Wiener Straße",
          "Windisch",
          "Zebragasse",
          "Zellerstraße",
          "Ziehrerstraße",
          "Zulechnerweg",
          "Zwergjoch",
          "Ötzbruck"
        ]
      },
      "cell_phone": {
        "formats": [
          "6##-#######",
          "06##-########",
          "6#########",
          "06##########"
        ]
      },
      "company": {
        "legal_form": [
          "GmbH",
          "AG",
          "Gruppe",
          "KG",
          "GmbH & Co. KG",
          "UG",
          "OG"
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
        ],
        "suffix": [
          "GmbH",
          "AG",
          "Gruppe",
          "KG",
          "GmbH & Co. KG",
          "UG",
          "OG"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "info",
          "name",
          "net",
          "org",
          "de",
          "ch",
          "at"
        ]
      },
      "name": {
        "first_name": [
          "Aaron",
          "Abdul",
          "Abdullah",
          "Adam",
          "Adrian",
          "Adriano",
          "Ahmad",
          "Ahmed",
          "Ahmet",
          "Alan",
          "Albert",
          "Alessandro",
          "Alessio",
          "Alex",
          "Alexander",
          "Alfred",
          "Ali",
          "Amar",
          "Amir",
          "Amon",
          "Andre",
          "Andreas",
          "Andrew",
          "Angelo",
          "Ansgar",
          "Anthony",
          "Anton",
          "Antonio",
          "Arda",
          "Arian",
          "Armin",
          "Arne",
          "Arno",
          "Arthur",
          "Artur",
          "Arved",
          "Arvid",
          "Ayman",
          "Baran",
          "Baris",
          "Bastian",
          "Batuhan",
          "Bela",
          "Ben",
          "Benedikt",
          "Benjamin",
          "Bennet",
          "Bennett",
          "Benno",
          "Bent",
          "Berat",
          "Berkay",
          "Bernd",
          "Bilal",
          "Bjarne",
          "Björn",
          "Bo",
          "Boris",
          "Brandon",
          "Brian",
          "Bruno",
          "Bryan",
          "Burak",
          "Calvin",
          "Can",
          "Carl",
          "Carlo",
          "Carlos",
          "Caspar",
          "Cedric",
          "Cedrik",
          "Cem",
          "Charlie",
          "Chris",
          "Christian",
          "Christiano",
          "Christoph",
          "Christopher",
          "Claas",
          "Clemens",
          "Colin",
          "Collin",
          "Conner",
          "Connor",
          "Constantin",
          "Corvin",
          "Curt",
          "Damian",
          "Damien",
          "Daniel",
          "Danilo",
          "Danny",
          "Darian",
          "Dario",
          "Darius",
          "Darren",
          "David",
          "Davide",
          "Davin",
          "Dean",
          "Deniz",
          "Dennis",
          "Denny",
          "Devin",
          "Diego",
          "Dion",
          "Domenic",
          "Domenik",
          "Dominic",
          "Dominik",
          "Dorian",
          "Dustin",
          "Dylan",
          "Ecrin",
          "Eddi",
          "Eddy",
          "Edgar",
          "Edwin",
          "Efe",
          "Ege",
          "Elia",
          "Eliah",
          "Elias",
          "Elijah",
          "Emanuel",
          "Emil",
          "Emilian",
          "Emilio",
          "Emir",
          "Emirhan",
          "Emre",
          "Enes",
          "Enno",
          "Enrico",
          "Eren",
          "Eric",
          "Erik",
          "Etienne",
          "Fabian",
          "Fabien",
          "Fabio",
          "Fabrice",
          "Falk",
          "Felix",
          "Ferdinand",
          "Fiete",
          "Filip",
          "Finlay",
          "Finley",
          "Finn",
          "Finnley",
          "Florian",
          "Francesco",
          "Franz",
          "Frederic",
          "Frederick",
          "Frederik",
          "Friedrich",
          "Fritz",
          "Furkan",
          "Fynn",
          "Gabriel",
          "Georg",
          "Gerrit",
          "Gian",
          "Gianluca",
          "Gino",
          "Giuliano",
          "Giuseppe",
          "Gregor",
          "Gustav",
          "Hagen",
          "Hamza",
          "Hannes",
          "Hanno",
          "Hans",
          "Hasan",
          "Hassan",
          "Hauke",
          "Hendrik",
          "Hennes",
          "Henning",
          "Henri",
          "Henrick",
          "Henrik",
          "Henry",
          "Hugo",
          "Hussein",
          "Ian",
          "Ibrahim",
          "Ilias",
          "Ilja",
          "Ilyas",
          "Immanuel",
          "Ismael",
          "Ismail",
          "Ivan",
          "Iven",
          "Jack",
          "Jacob",
          "Jaden",
          "Jakob",
          "Jamal",
          "James",
          "Jamie",
          "Jan",
          "Janek",
          "Janis",
          "Janne",
          "Jannek",
          "Jannes",
          "Jannik",
          "Jannis",
          "Jano",
          "Janosch",
          "Jared",
          "Jari",
          "Jarne",
          "Jarno",
          "Jaron",
          "Jason",
          "Jasper",
          "Jay",
          "Jayden",
          "Jayson",
          "Jean",
          "Jens",
          "Jeremias",
          "Jeremie",
          "Jeremy",
          "Jermaine",
          "Jerome",
          "Jesper",
          "Jesse",
          "Jim",
          "Jimmy",
          "Joe",
          "Joel",
          "Joey",
          "Johann",
          "Johannes",
          "John",
          "Johnny",
          "Jon",
          "Jona",
          "Jonah",
          "Jonas",
          "Jonathan",
          "Jonte",
          "Joost",
          "Jordan",
          "Joris",
          "Joscha",
          "Joschua",
          "Josef",
          "Joseph",
          "Josh",
          "Joshua",
          "Josua",
          "Juan",
          "Julian",
          "Julien",
          "Julius",
          "Juri",
          "Justin",
          "Justus",
          "Kaan",
          "Kai",
          "Kalle",
          "Karim",
          "Karl",
          "Karlo",
          "Kay",
          "Keanu",
          "Kenan",
          "Kenny",
          "Keno",
          "Kerem",
          "Kerim",
          "Kevin",
          "Kian",
          "Kilian",
          "Kim",
          "Kimi",
          "Kjell",
          "Klaas",
          "Klemens",
          "Konrad",
          "Konstantin",
          "Koray",
          "Korbinian",
          "Kurt",
          "Lars",
          "Lasse",
          "Laurence",
          "Laurens",
          "Laurenz",
          "Laurin",
          "Lean",
          "Leander",
          "Leandro",
          "Leif",
          "Len",
          "Lenn",
          "Lennard",
          "Lennart",
          "Lennert",
          "Lennie",
          "Lennox",
          "Lenny",
          "Leo",
          "Leon",
          "Leonard",
          "Leonardo",
          "Leonhard",
          "Leonidas",
          "Leopold",
          "Leroy",
          "Levent",
          "Levi",
          "Levin",
          "Lewin",
          "Lewis",
          "Liam",
          "Lian",
          "Lias",
          "Lino",
          "Linus",
          "Lio",
          "Lion",
          "Lionel",
          "Logan",
          "Lorenz",
          "Lorenzo",
          "Loris",
          "Louis",
          "Luan",
          "Luc",
          "Luca",
          "Lucas",
          "Lucian",
          "Lucien",
          "Ludwig",
          "Luis",
          "Luiz",
          "Luk",
          "Luka",
          "Lukas",
          "Luke",
          "Lutz",
          "Maddox",
          "Mads",
          "Magnus",
          "Maik",
          "Maksim",
          "Malik",
          "Malte",
          "Manuel",
          "Marc",
          "Marcel",
          "Marco",
          "Marcus",
          "Marek",
          "Marian",
          "Mario",
          "Marius",
          "Mark",
          "Marko",
          "Markus",
          "Marlo",
          "Marlon",
          "Marten",
          "Martin",
          "Marvin",
          "Marwin",
          "Mateo",
          "Mathis",
          "Matis",
          "Mats",
          "Matteo",
          "Mattes",
          "Matthias",
          "Matthis",
          "Matti",
          "Mattis",
          "Maurice",
          "Max",
          "Maxim",
          "Maximilian",
          "Mehmet",
          "Meik",
          "Melvin",
          "Merlin",
          "Mert",
          "Michael",
          "Michel",
          "Mick",
          "Miguel",
          "Mika",
          "Mikail",
          "Mike",
          "Milan",
          "Milo",
          "Mio",
          "Mirac",
          "Mirco",
          "Mirko",
          "Mohamed",
          "Mohammad",
          "Mohammed",
          "Moritz",
          "Morten",
          "Muhammed",
          "Murat",
          "Mustafa",
          "Nathan",
          "Nathanael",
          "Nelson",
          "Neo",
          "Nevio",
          "Nick",
          "Niclas",
          "Nico",
          "Nicolai",
          "Nicolas",
          "Niels",
          "Nikita",
          "Niklas",
          "Niko",
          "Nikolai",
          "Nikolas",
          "Nils",
          "Nino",
          "Noah",
          "Noel",
          "Norman",
          "Odin",
          "Oke",
          "Ole",
          "Oliver",
          "Omar",
          "Onur",
          "Oscar",
          "Oskar",
          "Pascal",
          "Patrice",
          "Patrick",
          "Paul",
          "Peer",
          "Pepe",
          "Peter",
          "Phil",
          "Philip",
          "Philipp",
          "Pierre",
          "Piet",
          "Pit",
          "Pius",
          "Quentin",
          "Quirin",
          "Rafael",
          "Raik",
          "Ramon",
          "Raphael",
          "Rasmus",
          "Raul",
          "Rayan",
          "René",
          "Ricardo",
          "Riccardo",
          "Richard",
          "Rick",
          "Rico",
          "Robert",
          "Robin",
          "Rocco",
          "Roman",
          "Romeo",
          "Ron",
          "Ruben",
          "Ryan",
          "Said",
          "Salih",
          "Sam",
          "Sami",
          "Sammy",
          "Samuel",
          "Sandro",
          "Santino",
          "Sascha",
          "Sean",
          "Sebastian",
          "Selim",
          "Semih",
          "Shawn",
          "Silas",
          "Simeon",
          "Simon",
          "Sinan",
          "Sky",
          "Stefan",
          "Steffen",
          "Stephan",
          "Steve",
          "Steven",
          "Sven",
          "Sönke",
          "Sören",
          "Taha",
          "Tamino",
          "Tammo",
          "Tarik",
          "Tayler",
          "Taylor",
          "Teo",
          "Theo",
          "Theodor",
          "Thies",
          "Thilo",
          "Thomas",
          "Thorben",
          "Thore",
          "Thorge",
          "Tiago",
          "Til",
          "Till",
          "Tillmann",
          "Tim",
          "Timm",
          "Timo",
          "Timon",
          "Timothy",
          "Tino",
          "Titus",
          "Tizian",
          "Tjark",
          "Tobias",
          "Tom",
          "Tommy",
          "Toni",
          "Tony",
          "Torben",
          "Tore",
          "Tristan",
          "Tyler",
          "Tyron",
          "Umut",
          "Valentin",
          "Valentino",
          "Veit",
          "Victor",
          "Viktor",
          "Vin",
          "Vincent",
          "Vito",
          "Vitus",
          "Wilhelm",
          "Willi",
          "William",
          "Willy",
          "Xaver",
          "Yannic",
          "Yannick",
          "Yannik",
          "Yannis",
          "Yasin",
          "Youssef",
          "Yunus",
          "Yusuf",
          "Yven",
          "Yves",
          "Ömer",
          "Aaliyah",
          "Abby",
          "Abigail",
          "Ada",
          "Adelina",
          "Adriana",
          "Aileen",
          "Aimee",
          "Alana",
          "Alea",
          "Alena",
          "Alessa",
          "Alessia",
          "Alexa",
          "Alexandra",
          "Alexia",
          "Alexis",
          "Aleyna",
          "Alia",
          "Alica",
          "Alice",
          "Alicia",
          "Alina",
          "Alisa",
          "Alisha",
          "Alissa",
          "Aliya",
          "Aliyah",
          "Allegra",
          "Alma",
          "Alyssa",
          "Amalia",
          "Amanda",
          "Amelia",
          "Amelie",
          "Amina",
          "Amira",
          "Amy",
          "Ana",
          "Anabel",
          "Anastasia",
          "Andrea",
          "Angela",
          "Angelina",
          "Angelique",
          "Anja",
          "Ann",
          "Anna",
          "Annabel",
          "Annabell",
          "Annabelle",
          "Annalena",
          "Anne",
          "Anneke",
          "Annelie",
          "Annemarie",
          "Anni",
          "Annie",
          "Annika",
          "Anny",
          "Anouk",
          "Antonia",
          "Arda",
          "Ariana",
          "Ariane",
          "Arwen",
          "Ashley",
          "Asya",
          "Aurelia",
          "Aurora",
          "Ava",
          "Ayleen",
          "Aylin",
          "Ayse",
          "Azra",
          "Betty",
          "Bianca",
          "Bianka",
          "Caitlin",
          "Cara",
          "Carina",
          "Carla",
          "Carlotta",
          "Carmen",
          "Carolin",
          "Carolina",
          "Caroline",
          "Cassandra",
          "Catharina",
          "Catrin",
          "Cecile",
          "Cecilia",
          "Celia",
          "Celina",
          "Celine",
          "Ceyda",
          "Ceylin",
          "Chantal",
          "Charleen",
          "Charlotta",
          "Charlotte",
          "Chayenne",
          "Cheyenne",
          "Chiara",
          "Christin",
          "Christina",
          "Cindy",
          "Claire",
          "Clara",
          "Clarissa",
          "Colleen",
          "Collien",
          "Cora",
          "Corinna",
          "Cosima",
          "Dana",
          "Daniela",
          "Daria",
          "Darleen",
          "Defne",
          "Delia",
          "Denise",
          "Diana",
          "Dilara",
          "Dina",
          "Dorothea",
          "Ecrin",
          "Eda",
          "Eileen",
          "Ela",
          "Elaine",
          "Elanur",
          "Elea",
          "Elena",
          "Eleni",
          "Eleonora",
          "Eliana",
          "Elif",
          "Elina",
          "Elisa",
          "Elisabeth",
          "Ella",
          "Ellen",
          "Elli",
          "Elly",
          "Elsa",
          "Emelie",
          "Emely",
          "Emilia",
          "Emilie",
          "Emily",
          "Emma",
          "Emmely",
          "Emmi",
          "Emmy",
          "Enie",
          "Enna",
          "Enya",
          "Esma",
          "Estelle",
          "Esther",
          "Eva",
          "Evelin",
          "Evelina",
          "Eveline",
          "Evelyn",
          "Fabienne",
          "Fatima",
          "Fatma",
          "Felicia",
          "Felicitas",
          "Felina",
          "Femke",
          "Fenja",
          "Fine",
          "Finia",
          "Finja",
          "Finnja",
          "Fiona",
          "Flora",
          "Florentine",
          "Francesca",
          "Franka",
          "Franziska",
          "Frederike",
          "Freya",
          "Frida",
          "Frieda",
          "Friederike",
          "Giada",
          "Gina",
          "Giulia",
          "Giuliana",
          "Greta",
          "Hailey",
          "Hana",
          "Hanna",
          "Hannah",
          "Heidi",
          "Helen",
          "Helena",
          "Helene",
          "Helin",
          "Henriette",
          "Henrike",
          "Hermine",
          "Ida",
          "Ilayda",
          "Imke",
          "Ina",
          "Ines",
          "Inga",
          "Inka",
          "Irem",
          "Isa",
          "Isabel",
          "Isabell",
          "Isabella",
          "Isabelle",
          "Ivonne",
          "Jacqueline",
          "Jamie",
          "Jamila",
          "Jana",
          "Jane",
          "Janin",
          "Janina",
          "Janine",
          "Janna",
          "Janne",
          "Jara",
          "Jasmin",
          "Jasmina",
          "Jasmine",
          "Jella",
          "Jenna",
          "Jennifer",
          "Jenny",
          "Jessica",
          "Jessy",
          "Jette",
          "Jil",
          "Jill",
          "Joana",
          "Joanna",
          "Joelina",
          "Joeline",
          "Joelle",
          "Johanna",
          "Joleen",
          "Jolie",
          "Jolien",
          "Jolin",
          "Jolina",
          "Joline",
          "Jona",
          "Jonah",
          "Jonna",
          "Josefin",
          "Josefine",
          "Josephin",
          "Josephine",
          "Josie",
          "Josy",
          "Joy",
          "Joyce",
          "Judith",
          "Judy",
          "Jule",
          "Julia",
          "Juliana",
          "Juliane",
          "Julie",
          "Julienne",
          "Julika",
          "Julina",
          "Juna",
          "Justine",
          "Kaja",
          "Karina",
          "Karla",
          "Karlotta",
          "Karolina",
          "Karoline",
          "Kassandra",
          "Katarina",
          "Katharina",
          "Kathrin",
          "Katja",
          "Katrin",
          "Kaya",
          "Kayra",
          "Kiana",
          "Kiara",
          "Kim",
          "Kimberley",
          "Kimberly",
          "Kira",
          "Klara",
          "Korinna",
          "Kristin",
          "Kyra",
          "Laila",
          "Lana",
          "Lara",
          "Larissa",
          "Laura",
          "Laureen",
          "Lavinia",
          "Lea",
          "Leah",
          "Leana",
          "Leandra",
          "Leann",
          "Lee",
          "Leila",
          "Lena",
          "Lene",
          "Leni",
          "Lenia",
          "Lenja",
          "Lenya",
          "Leona",
          "Leoni",
          "Leonie",
          "Leonora",
          "Leticia",
          "Letizia",
          "Levke",
          "Leyla",
          "Lia",
          "Liah",
          "Liana",
          "Lili",
          "Lilia",
          "Lilian",
          "Liliana",
          "Lilith",
          "Lilli",
          "Lillian",
          "Lilly",
          "Lily",
          "Lina",
          "Linda",
          "Lindsay",
          "Line",
          "Linn",
          "Linnea",
          "Lisa",
          "Lisann",
          "Lisanne",
          "Liv",
          "Livia",
          "Liz",
          "Lola",
          "Loreen",
          "Lorena",
          "Lotta",
          "Lotte",
          "Louisa",
          "Louise",
          "Luana",
          "Luca",
          "Lucia",
          "Lucie",
          "Lucienne",
          "Lucy",
          "Luisa",
          "Luise",
          "Luka",
          "Luna",
          "Luzie",
          "Lya",
          "Lydia",
          "Lyn",
          "Lynn",
          "Madeleine",
          "Madita",
          "Madleen",
          "Madlen",
          "Magdalena",
          "Maike",
          "Mailin",
          "Maira",
          "Maja",
          "Malena",
          "Malia",
          "Malin",
          "Malina",
          "Mandy",
          "Mara",
          "Marah",
          "Mareike",
          "Maren",
          "Maria",
          "Mariam",
          "Marie",
          "Marieke",
          "Mariella",
          "Marika",
          "Marina",
          "Marisa",
          "Marissa",
          "Marit",
          "Marla",
          "Marleen",
          "Marlen",
          "Marlena",
          "Marlene",
          "Marta",
          "Martha",
          "Mary",
          "Maryam",
          "Mathilda",
          "Mathilde",
          "Matilda",
          "Maxi",
          "Maxima",
          "Maxine",
          "Maya",
          "Mayra",
          "Medina",
          "Medine",
          "Meike",
          "Melanie",
          "Melek",
          "Melike",
          "Melina",
          "Melinda",
          "Melis",
          "Melisa",
          "Melissa",
          "Merle",
          "Merve",
          "Meryem",
          "Mette",
          "Mia",
          "Michaela",
          "Michelle",
          "Mieke",
          "Mila",
          "Milana",
          "Milena",
          "Milla",
          "Mina",
          "Mira",
          "Miray",
          "Miriam",
          "Mirja",
          "Mona",
          "Monique",
          "Nadine",
          "Nadja",
          "Naemi",
          "Nancy",
          "Naomi",
          "Natalia",
          "Natalie",
          "Nathalie",
          "Neele",
          "Nela",
          "Nele",
          "Nelli",
          "Nelly",
          "Nia",
          "Nicole",
          "Nika",
          "Nike",
          "Nikita",
          "Nila",
          "Nina",
          "Nisa",
          "Noemi",
          "Nora",
          "Olivia",
          "Patricia",
          "Patrizia",
          "Paula",
          "Paulina",
          "Pauline",
          "Penelope",
          "Philine",
          "Phoebe",
          "Pia",
          "Rahel",
          "Rania",
          "Rebecca",
          "Rebekka",
          "Riana",
          "Rieke",
          "Rike",
          "Romina",
          "Romy",
          "Ronja",
          "Rosa",
          "Rosalie",
          "Ruby",
          "Sabrina",
          "Sahra",
          "Sally",
          "Salome",
          "Samantha",
          "Samia",
          "Samira",
          "Sandra",
          "Sandy",
          "Sanja",
          "Saphira",
          "Sara",
          "Sarah",
          "Saskia",
          "Selin",
          "Selina",
          "Selma",
          "Sena",
          "Sidney",
          "Sienna",
          "Silja",
          "Sina",
          "Sinja",
          "Smilla",
          "Sofia",
          "Sofie",
          "Sonja",
          "Sophia",
          "Sophie",
          "Soraya",
          "Stefanie",
          "Stella",
          "Stephanie",
          "Stina",
          "Sude",
          "Summer",
          "Susanne",
          "Svea",
          "Svenja",
          "Sydney",
          "Tabea",
          "Talea",
          "Talia",
          "Tamara",
          "Tamia",
          "Tamina",
          "Tanja",
          "Tara",
          "Tarja",
          "Teresa",
          "Tessa",
          "Thalea",
          "Thalia",
          "Thea",
          "Theresa",
          "Tia",
          "Tina",
          "Tomke",
          "Tuana",
          "Valentina",
          "Valeria",
          "Valerie",
          "Vanessa",
          "Vera",
          "Veronika",
          "Victoria",
          "Viktoria",
          "Viola",
          "Vivian",
          "Vivien",
          "Vivienne",
          "Wibke",
          "Wiebke",
          "Xenia",
          "Yara",
          "Yaren",
          "Yasmin",
          "Ylvi",
          "Ylvie",
          "Yvonne",
          "Zara",
          "Zehra",
          "Zeynep",
          "Zoe",
          "Zoey",
          "Zoé"
        ],
        "last_name": [
          "Abel",
          "Abicht",
          "Abraham",
          "Abramovic",
          "Abt",
          "Achilles",
          "Achkinadze",
          "Ackermann",
          "Adam",
          "Adams",
          "Ade",
          "Agostini",
          "Ahlke",
          "Ahrenberg",
          "Ahrens",
          "Aigner",
          "Albert",
          "Albrecht",
          "Alexa",
          "Alexander",
          "Alizadeh",
          "Allgeyer",
          "Amann",
          "Amberg",
          "Anding",
          "Anggreny",
          "Apitz",
          "Arendt",
          "Arens",
          "Arndt",
          "Aryee",
          "Aschenbroich",
          "Assmus",
          "Astafei",
          "Auer",
          "Axmann",
          "Baarck",
          "Bachmann",
          "Badane",
          "Bader",
          "Baganz",
          "Bahl",
          "Bak",
          "Balcer",
          "Balck",
          "Balkow",
          "Balnuweit",
          "Balzer",
          "Banse",
          "Barr",
          "Bartels",
          "Barth",
          "Barylla",
          "Baseda",
          "Battke",
          "Bauer",
          "Bauermeister",
          "Baumann",
          "Baumeister",
          "Bauschinger",
          "Bauschke",
          "Bayer",
          "Beavogui",
          "Beck",
          "Beckel",
          "Becker",
          "Beckmann",
          "Bedewitz",
          "Beele",
          "Beer",
          "Beggerow",
          "Beh",
          "Behr",
          "Behrenbruch",
          "Belz",
          "Bender",
          "Benecke",
          "Benner",
          "Benninger",
          "Benzing",
          "Berends",
          "Berger",
          "Berner",
          "Berning",
          "Bertenbreiter",
          "Best",
          "Bethke",
          "Betz",
          "Beushausen",
          "Beutelspacher",
          "Beyer",
          "Biba",
          "Bichler",
          "Bickel",
          "Biedermann",
          "Bieler",
          "Bielert",
          "Bienasch",
          "Bienias",
          "Biesenbach",
          "Bigdeli",
          "Birkemeyer",
          "Bittner",
          "Blank",
          "Blaschek",
          "Blassneck",
          "Bloch",
          "Blochwitz",
          "Blockhaus",
          "Blum",
          "Blume",
          "Bock",
          "Bode",
          "Bogdashin",
          "Bogenrieder",
          "Bohge",
          "Bolm",
          "Borgschulze",
          "Bork",
          "Bormann",
          "Bornscheuer",
          "Borrmann",
          "Borsch",
          "Boruschewski",
          "Bos",
          "Bosler",
          "Bourrouag",
          "Bouschen",
          "Boxhammer",
          "Boyde",
          "Bozsik",
          "Brand",
          "Brandenburg",
          "Brandis",
          "Brandt",
          "Brauer",
          "Braun",
          "Brehmer",
          "Breitenstein",
          "Bremer",
          "Bremser",
          "Brenner",
          "Brettschneider",
          "Breu",
          "Breuer",
          "Briesenick",
          "Bringmann",
          "Brinkmann",
          "Brix",
          "Broening",
          "Brosch",
          "Bruckmann",
          "Bruder",
          "Bruhns",
          "Brunner",
          "Bruns",
          "Bräutigam",
          "Brömme",
          "Brüggmann",
          "Buchholz",
          "Buchrucker",
          "Buder",
          "Bultmann",
          "Bunjes",
          "Burger",
          "Burghagen",
          "Burkhard",
          "Burkhardt",
          "Burmeister",
          "Busch",
          "Buschbaum",
          "Busemann",
          "Buss",
          "Busse",
          "Bussmann",
          "Byrd",
          "Bäcker",
          "Böhm",
          "Bönisch",
          "Börgeling",
          "Börner",
          "Böttner",
          "Büchele",
          "Bühler",
          "Büker",
          "Büngener",
          "Bürger",
          "Bürklein",
          "Büscher",
          "Büttner",
          "Camara",
          "Carlowitz",
          "Carlsohn",
          "Caspari",
          "Caspers",
          "Chapron",
          "Christ",
          "Cierpinski",
          "Clarius",
          "Cleem",
          "Cleve",
          "Co",
          "Conrad",
          "Cordes",
          "Cornelsen",
          "Cors",
          "Cotthardt",
          "Crews",
          "Cronjäger",
          "Crosskofp",
          "Da",
          "Dahm",
          "Dahmen",
          "Daimer",
          "Damaske",
          "Danneberg",
          "Danner",
          "Daub",
          "Daubner",
          "Daudrich",
          "Dauer",
          "Daum",
          "Dauth",
          "Dautzenberg",
          "De",
          "Decker",
          "Deckert",
          "Deerberg",
          "Dehmel",
          "Deja",
          "Delonge",
          "Demut",
          "Dengler",
          "Denner",
          "Denzinger",
          "Derr",
          "Dertmann",
          "Dethloff",
          "Deuschle",
          "Dieckmann",
          "Diedrich",
          "Diekmann",
          "Dienel",
          "Dies",
          "Dietrich",
          "Dietz",
          "Dietzsch",
          "Diezel",
          "Dilla",
          "Dingelstedt",
          "Dippl",
          "Dittmann",
          "Dittmar",
          "Dittmer",
          "Dix",
          "Dobbrunz",
          "Dobler",
          "Dohring",
          "Dolch",
          "Dold",
          "Dombrowski",
          "Donie",
          "Doskoczynski",
          "Dragu",
          "Drechsler",
          "Drees",
          "Dreher",
          "Dreier",
          "Dreissigacker",
          "Dressler",
          "Drews",
          "Duma",
          "Dutkiewicz",
          "Dyett",
          "Dylus",
          "Dächert",
          "Döbel",
          "Döring",
          "Dörner",
          "Dörre",
          "Dück",
          "Eberhard",
          "Eberhardt",
          "Ecker",
          "Eckhardt",
          "Edorh",
          "Effler",
          "Eggenmueller",
          "Ehm",
          "Ehmann",
          "Ehrig",
          "Eich",
          "Eifert",
          "Einert",
          "Eisenlauer",
          "Ekpo",
          "Elbe",
          "Eleyth",
          "Elss",
          "Emert",
          "Emmelmann",
          "Ender",
          "Engel",
          "Engelen",
          "Engelmann",
          "Eplinius",
          "Erdmann",
          "Erhardt",
          "Erlei",
          "Erm",
          "Ernst",
          "Ertl",
          "Erwes",
          "Esenwein",
          "Esser",
          "Evers",
          "Everts",
          "Ewald",
          "Fahner",
          "Faller",
          "Falter",
          "Farber",
          "Fassbender",
          "Faulhaber",
          "Fehrig",
          "Feld",
          "Felke",
          "Feller",
          "Fenner",
          "Fenske",
          "Feuerbach",
          "Fietz",
          "Figl",
          "Figura",
          "Filipowski",
          "Filsinger",
          "Fincke",
          "Fink",
          "Finke",
          "Fischer",
          "Fitschen",
          "Fleischer",
          "Fleischmann",
          "Floder",
          "Florczak",
          "Flore",
          "Flottmann",
          "Forkel",
          "Forst",
          "Frahmeke",
          "Frank",
          "Franke",
          "Franta",
          "Frantz",
          "Franz",
          "Franzis",
          "Franzmann",
          "Frauen",
          "Frauendorf",
          "Freigang",
          "Freimann",
          "Freimuth",
          "Freisen",
          "Frenzel",
          "Frey",
          "Fricke",
          "Fried",
          "Friedek",
          "Friedenberg",
          "Friedmann",
          "Friedrich",
          "Friess",
          "Frisch",
          "Frohn",
          "Frosch",
          "Fuchs",
          "Fuhlbrügge",
          "Fusenig",
          "Fust",
          "Förster",
          "Gaba",
          "Gabius",
          "Gabler",
          "Gadschiew",
          "Gakstädter",
          "Galander",
          "Gamlin",
          "Gamper",
          "Gangnus",
          "Ganzmann",
          "Garatva",
          "Gast",
          "Gastel",
          "Gatzka",
          "Gauder",
          "Gebhardt",
          "Geese",
          "Gehre",
          "Gehrig",
          "Gehring",
          "Gehrke",
          "Geiger",
          "Geisler",
          "Geissler",
          "Gelling",
          "Gens",
          "Gerbennow",
          "Gerdel",
          "Gerhardt",
          "Gerschler",
          "Gerson",
          "Gesell",
          "Geyer",
          "Ghirmai",
          "Ghosh",
          "Giehl",
          "Gierisch",
          "Giesa",
          "Giesche",
          "Gilde",
          "Glatting",
          "Goebel",
          "Goedicke",
          "Goldbeck",
          "Goldfuss",
          "Goldkamp",
          "Goldkühle",
          "Goller",
          "Golling",
          "Gollnow",
          "Golomski",
          "Gombert",
          "Gotthardt",
          "Gottschalk",
          "Gotz",
          "Goy",
          "Gradzki",
          "Graf",
          "Grams",
          "Grasse",
          "Gratzky",
          "Grau",
          "Greb",
          "Green",
          "Greger",
          "Greithanner",
          "Greschner",
          "Griem",
          "Griese",
          "Grimm",
          "Gromisch",
          "Gross",
          "Grosser",
          "Grossheim",
          "Grosskopf",
          "Grothaus",
          "Grothkopp",
          "Grotke",
          "Grube",
          "Gruber",
          "Grundmann",
          "Gruning",
          "Gruszecki",
          "Gröss",
          "Grötzinger",
          "Grün",
          "Grüner",
          "Gummelt",
          "Gunkel",
          "Gunther",
          "Gutjahr",
          "Gutowicz",
          "Gutschank",
          "Göbel",
          "Göckeritz",
          "Göhler",
          "Görlich",
          "Görmer",
          "Götz",
          "Götzelmann",
          "Güldemeister",
          "Günther",
          "Günz",
          "Gürbig",
          "Haack",
          "Haaf",
          "Habel",
          "Hache",
          "Hackbusch",
          "Hackelbusch",
          "Hadfield",
          "Hadwich",
          "Haferkamp",
          "Hahn",
          "Hajek",
          "Hallmann",
          "Hamann",
          "Hanenberger",
          "Hannecker",
          "Hanniske",
          "Hansen",
          "Hardy",
          "Hargasser",
          "Harms",
          "Harnapp",
          "Harter",
          "Harting",
          "Hartlieb",
          "Hartmann",
          "Hartwig",
          "Hartz",
          "Haschke",
          "Hasler",
          "Hasse",
          "Hassfeld",
          "Haug",
          "Hauke",
          "Haupt",
          "Haverney",
          "Heberstreit",
          "Hechler",
          "Hecht",
          "Heck",
          "Hedermann",
          "Hehl",
          "Heidelmann",
          "Heidler",
          "Heinemann",
          "Heinig",
          "Heinke",
          "Heinrich",
          "Heinze",
          "Heiser",
          "Heist",
          "Hellmann",
          "Helm",
          "Helmke",
          "Helpling",
          "Hengmith",
          "Henkel",
          "Hennes",
          "Henry",
          "Hense",
          "Hensel",
          "Hentel",
          "Hentschel",
          "Hentschke",
          "Hepperle",
          "Herberger",
          "Herbrand",
          "Hering",
          "Hermann",
          "Hermecke",
          "Herms",
          "Herold",
          "Herrmann",
          "Herschmann",
          "Hertel",
          "Herweg",
          "Herwig",
          "Herzenberg",
          "Hess",
          "Hesse",
          "Hessek",
          "Hessler",
          "Hetzler",
          "Heuck",
          "Heydemüller",
          "Hiebl",
          "Hildebrand",
          "Hildenbrand",
          "Hilgendorf",
          "Hillard",
          "Hiller",
          "Hingsen",
          "Hingst",
          "Hinrichs",
          "Hirsch",
          "Hirschberg",
          "Hirt",
          "Hodea",
          "Hoffman",
          "Hoffmann",
          "Hofmann",
          "Hohenberger",
          "Hohl",
          "Hohn",
          "Hohnheiser",
          "Hold",
          "Holdt",
          "Holinski",
          "Holl",
          "Holtfreter",
          "Holz",
          "Holzdeppe",
          "Holzner",
          "Hommel",
          "Honz",
          "Hooss",
          "Hoppe",
          "Horak",
          "Horn",
          "Horna",
          "Hornung",
          "Hort",
          "Howard",
          "Huber",
          "Huckestein",
          "Hudak",
          "Huebel",
          "Hugo",
          "Huhn",
          "Hujo",
          "Huke",
          "Huls",
          "Humbert",
          "Huneke",
          "Huth",
          "Häber",
          "Häfner",
          "Höcke",
          "Höft",
          "Höhne",
          "Hönig",
          "Hördt",
          "Hübenbecker",
          "Hübl",
          "Hübner",
          "Hügel",
          "Hüttcher",
          "Hütter",
          "Ibe",
          "Ihly",
          "Illing",
          "Isak",
          "Isekenmeier",
          "Itt",
          "Jacob",
          "Jacobs",
          "Jagusch",
          "Jahn",
          "Jahnke",
          "Jakobs",
          "Jakubczyk",
          "Jambor",
          "Jamrozy",
          "Jander",
          "Janich",
          "Janke",
          "Jansen",
          "Jarets",
          "Jaros",
          "Jasinski",
          "Jasper",
          "Jegorov",
          "Jellinghaus",
          "Jeorga",
          "Jerschabek",
          "Jess",
          "John",
          "Jonas",
          "Jossa",
          "Jucken",
          "Jung",
          "Jungbluth",
          "Jungton",
          "Just",
          "Jürgens",
          "Kaczmarek",
          "Kaesmacher",
          "Kahl",
          "Kahlert",
          "Kahles",
          "Kahlmeyer",
          "Kaiser",
          "Kalinowski",
          "Kallabis",
          "Kallensee",
          "Kampf",
          "Kampschulte",
          "Kappe",
          "Kappler",
          "Karhoff",
          "Karrass",
          "Karst",
          "Karsten",
          "Karus",
          "Kass",
          "Kasten",
          "Kastner",
          "Katzinski",
          "Kaufmann",
          "Kaul",
          "Kausemann",
          "Kawohl",
          "Kazmarek",
          "Kedzierski",
          "Keil",
          "Keiner",
          "Keller",
          "Kelm",
          "Kempe",
          "Kemper",
          "Kempter",
          "Kerl",
          "Kern",
          "Kesselring",
          "Kesselschläger",
          "Kette",
          "Kettenis",
          "Keutel",
          "Kick",
          "Kiessling",
          "Kinadeter",
          "Kinzel",
          "Kinzy",
          "Kirch",
          "Kirst",
          "Kisabaka",
          "Klaas",
          "Klabuhn",
          "Klapper",
          "Klauder",
          "Klaus",
          "Kleeberg",
          "Kleiber",
          "Klein",
          "Kleinert",
          "Kleininger",
          "Kleinmann",
          "Kleinsteuber",
          "Kleiss",
          "Klemme",
          "Klimczak",
          "Klinger",
          "Klink",
          "Klopsch",
          "Klose",
          "Kloss",
          "Kluge",
          "Kluwe",
          "Knabe",
          "Kneifel",
          "Knetsch",
          "Knies",
          "Knippel",
          "Knobel",
          "Knoblich",
          "Knoll",
          "Knorr",
          "Knorscheidt",
          "Knut",
          "Kobs",
          "Koch",
          "Kochan",
          "Kock",
          "Koczulla",
          "Koderisch",
          "Koehl",
          "Koehler",
          "Koenig",
          "Koester",
          "Kofferschlager",
          "Koha",
          "Kohle",
          "Kohlmann",
          "Kohnle",
          "Kohrt",
          "Koj",
          "Kolb",
          "Koleiski",
          "Kolokas",
          "Komoll",
          "Konieczny",
          "Konig",
          "Konow",
          "Konya",
          "Koob",
          "Kopf",
          "Kosenkow",
          "Koster",
          "Koszewski",
          "Koubaa",
          "Kovacs",
          "Kowalick",
          "Kowalinski",
          "Kozakiewicz",
          "Krabbe",
          "Kraft",
          "Kral",
          "Kramer",
          "Krauel",
          "Kraus",
          "Krause",
          "Krauspe",
          "Kreb",
          "Krebs",
          "Kreissig",
          "Kresse",
          "Kreutz",
          "Krieger",
          "Krippner",
          "Krodinger",
          "Krohn",
          "Krol",
          "Kron",
          "Krueger",
          "Krug",
          "Kruger",
          "Krull",
          "Kruschinski",
          "Krämer",
          "Kröckert",
          "Kröger",
          "Krüger",
          "Kubera",
          "Kufahl",
          "Kuhlee",
          "Kuhnen",
          "Kulimann",
          "Kulma",
          "Kumbernuss",
          "Kummle",
          "Kunz",
          "Kupfer",
          "Kupprion",
          "Kuprion",
          "Kurnicki",
          "Kurrat",
          "Kurschilgen",
          "Kuschewitz",
          "Kuschmann",
          "Kuske",
          "Kustermann",
          "Kutscherauer",
          "Kutzner",
          "Kwadwo",
          "Kähler",
          "Käther",
          "Köhler",
          "Köhrbrück",
          "Köhre",
          "Kölotzei",
          "König",
          "Köpernick",
          "Köseoglu",
          "Kúhn",
          "Kúhnert",
          "Kühn",
          "Kühnel",
          "Kühnemund",
          "Kühnert",
          "Kühnke",
          "Küsters",
          "Küter",
          "Laack",
          "Lack",
          "Ladewig",
          "Lakomy",
          "Lammert",
          "Lamos",
          "Landmann",
          "Lang",
          "Lange",
          "Langfeld",
          "Langhirt",
          "Lanig",
          "Lauckner",
          "Lauinger",
          "Laurén",
          "Lausecker",
          "Laux",
          "Laws",
          "Lax",
          "Leberer",
          "Lehmann",
          "Lehner",
          "Leibold",
          "Leide",
          "Leimbach",
          "Leipold",
          "Leist",
          "Leiter",
          "Leiteritz",
          "Leitheim",
          "Leiwesmeier",
          "Lenfers",
          "Lenk",
          "Lenz",
          "Lenzen",
          "Leo",
          "Lepthin",
          "Lesch",
          "Leschnik",
          "Letzelter",
          "Lewin",
          "Lewke",
          "Leyckes",
          "Lg",
          "Lichtenfeld",
          "Lichtenhagen",
          "Lichtl",
          "Liebach",
          "Liebe",
          "Liebich",
          "Liebold",
          "Lieder",
          "Lienshöft",
          "Linden",
          "Lindenberg",
          "Lindenmayer",
          "Lindner",
          "Linke",
          "Linnenbaum",
          "Lippe",
          "Lipske",
          "Lipus",
          "Lischka",
          "Lobinger",
          "Logsch",
          "Lohmann",
          "Lohre",
          "Lohse",
          "Lokar",
          "Loogen",
          "Lorenz",
          "Losch",
          "Loska",
          "Lott",
          "Loy",
          "Lubina",
          "Ludolf",
          "Lufft",
          "Lukoschek",
          "Lutje",
          "Lutz",
          "Löser",
          "Löwa",
          "Lübke",
          "Maak",
          "Maczey",
          "Madetzky",
          "Madubuko",
          "Mai",
          "Maier",
          "Maisch",
          "Malek",
          "Malkus",
          "Mallmann",
          "Malucha",
          "Manns",
          "Manz",
          "Marahrens",
          "Marchewski",
          "Margis",
          "Markowski",
          "Marl",
          "Marner",
          "Marquart",
          "Marschek",
          "Martel",
          "Marten",
          "Martin",
          "Marx",
          "Marxen",
          "Mathes",
          "Mathies",
          "Mathiszik",
          "Matschke",
          "Mattern",
          "Matthes",
          "Matula",
          "Mau",
          "Maurer",
          "Mauroff",
          "May",
          "Maybach",
          "Mayer",
          "Mebold",
          "Mehl",
          "Mehlhorn",
          "Mehlorn",
          "Meier",
          "Meisch",
          "Meissner",
          "Meloni",
          "Melzer",
          "Menga",
          "Menne",
          "Mensah",
          "Mensing",
          "Merkel",
          "Merseburg",
          "Mertens",
          "Mesloh",
          "Metzger",
          "Metzner",
          "Mewes",
          "Meyer",
          "Michallek",
          "Michel",
          "Mielke",
          "Mikitenko",
          "Milde",
          "Minah",
          "Mintzlaff",
          "Mockenhaupt",
          "Moede",
          "Moedl",
          "Moeller",
          "Moguenara",
          "Mohr",
          "Mohrhard",
          "Molitor",
          "Moll",
          "Moller",
          "Molzan",
          "Montag",
          "Moormann",
          "Mordhorst",
          "Morgenstern",
          "Morhelfer",
          "Moritz",
          "Moser",
          "Motchebon",
          "Motzenbbäcker",
          "Mrugalla",
          "Muckenthaler",
          "Mues",
          "Muller",
          "Mulrain",
          "Mächtig",
          "Mäder",
          "Möcks",
          "Mögenburg",
          "Möhsner",
          "Möldner",
          "Möllenbeck",
          "Möller",
          "Möllinger",
          "Mörsch",
          "Mühleis",
          "Müller",
          "Münch",
          "Nabein",
          "Nabow",
          "Nagel",
          "Nannen",
          "Nastvogel",
          "Nau",
          "Naubert",
          "Naumann",
          "Ne",
          "Neimke",
          "Nerius",
          "Neubauer",
          "Neubert",
          "Neuendorf",
          "Neumair",
          "Neumann",
          "Neupert",
          "Neurohr",
          "Neuschwander",
          "Newton",
          "Ney",
          "Nicolay",
          "Niedermeier",
          "Nieklauson",
          "Niklaus",
          "Nitzsche",
          "Noack",
          "Nodler",
          "Nolte",
          "Normann",
          "Norris",
          "Northoff",
          "Nowak",
          "Nussbeck",
          "Nwachukwu",
          "Nytra",
          "Nöh",
          "Oberem",
          "Obergföll",
          "Obermaier",
          "Ochs",
          "Oeser",
          "Olbrich",
          "Onnen",
          "Ophey",
          "Oppong",
          "Orth",
          "Orthmann",
          "Oschkenat",
          "Osei",
          "Osenberg",
          "Ostendarp",
          "Ostwald",
          "Otte",
          "Otto",
          "Paesler",
          "Pajonk",
          "Pallentin",
          "Panzig",
          "Paschke",
          "Patzwahl",
          "Paukner",
          "Peselman",
          "Peter",
          "Peters",
          "Petzold",
          "Pfeiffer",
          "Pfennig",
          "Pfersich",
          "Pfingsten",
          "Pflieger",
          "Pflügner",
          "Philipp",
          "Pichlmaier",
          "Piesker",
          "Pietsch",
          "Pingpank",
          "Pinnock",
          "Pippig",
          "Pitschugin",
          "Plank",
          "Plass",
          "Platzer",
          "Plauk",
          "Plautz",
          "Pletsch",
          "Plotzitzka",
          "Poehn",
          "Poeschl",
          "Pogorzelski",
          "Pohl",
          "Pohland",
          "Pohle",
          "Polifka",
          "Polizzi",
          "Pollmächer",
          "Pomp",
          "Ponitzsch",
          "Porsche",
          "Porth",
          "Poschmann",
          "Poser",
          "Pottel",
          "Prah",
          "Prange",
          "Prediger",
          "Pressler",
          "Preuk",
          "Preuss",
          "Prey",
          "Priemer",
          "Proske",
          "Pusch",
          "Pöche",
          "Pöge",
          "Raabe",
          "Rabenstein",
          "Rach",
          "Radtke",
          "Rahn",
          "Ranftl",
          "Rangen",
          "Ranz",
          "Rapp",
          "Rath",
          "Rau",
          "Raubuch",
          "Raukuc",
          "Rautenkranz",
          "Rehwagen",
          "Reiber",
          "Reichardt",
          "Reichel",
          "Reichling",
          "Reif",
          "Reifenrath",
          "Reimann",
          "Reinberg",
          "Reinelt",
          "Reinhardt",
          "Reinke",
          "Reitze",
          "Renk",
          "Rentz",
          "Renz",
          "Reppin",
          "Restle",
          "Restorff",
          "Retzke",
          "Reuber",
          "Reumann",
          "Reus",
          "Reuss",
          "Reusse",
          "Rheder",
          "Rhoden",
          "Richards",
          "Richter",
          "Riedel",
          "Riediger",
          "Rieger",
          "Riekmann",
          "Riepl",
          "Riermeier",
          "Riester",
          "Riethmüller",
          "Rietmüller",
          "Rietscher",
          "Ringel",
          "Ringer",
          "Rink",
          "Ripken",
          "Ritosek",
          "Ritschel",
          "Ritter",
          "Rittweg",
          "Ritz",
          "Roba",
          "Rockmeier",
          "Rodehau",
          "Rodowski",
          "Roecker",
          "Roggatz",
          "Rohländer",
          "Rohrer",
          "Rokossa",
          "Roleder",
          "Roloff",
          "Roos",
          "Rosbach",
          "Roschinsky",
          "Rose",
          "Rosenauer",
          "Rosenbauer",
          "Rosenthal",
          "Rosksch",
          "Rossberg",
          "Rossler",
          "Roth",
          "Rother",
          "Ruch",
          "Ruckdeschel",
          "Rumpf",
          "Rupprecht",
          "Ruth",
          "Ryjikh",
          "Ryzih",
          "Rädler",
          "Räntsch",
          "Rödiger",
          "Röse",
          "Röttger",
          "Rücker",
          "Rüdiger",
          "Rüter",
          "Sachse",
          "Sack",
          "Saflanis",
          "Sagafe",
          "Sagonas",
          "Sahner",
          "Saile",
          "Sailer",
          "Salow",
          "Salzer",
          "Salzmann",
          "Sammert",
          "Sander",
          "Sarvari",
          "Sattelmaier",
          "Sauer",
          "Sauerland",
          "Saumweber",
          "Savoia",
          "Scc",
          "Schacht",
          "Schaefer",
          "Schaffarzik",
          "Schahbasian",
          "Scharf",
          "Schedler",
          "Scheer",
          "Schelk",
          "Schellenbeck",
          "Schembera",
          "Schenk",
          "Scherbarth",
          "Scherer",
          "Schersing",
          "Scherz",
          "Scheurer",
          "Scheuring",
          "Scheytt",
          "Schielke",
          "Schieskow",
          "Schildhauer",
          "Schilling",
          "Schima",
          "Schimmer",
          "Schindzielorz",
          "Schirmer",
          "Schirrmeister",
          "Schlachter",
          "Schlangen",
          "Schlawitz",
          "Schlechtweg",
          "Schley",
          "Schlicht",
          "Schlitzer",
          "Schmalzle",
          "Schmid",
          "Schmidt",
          "Schmidtchen",
          "Schmitt",
          "Schmitz",
          "Schmuhl",
          "Schneider",
          "Schnelting",
          "Schnieder",
          "Schniedermeier",
          "Schnürer",
          "Schoberg",
          "Scholz",
          "Schonberg",
          "Schondelmaier",
          "Schorr",
          "Schott",
          "Schottmann",
          "Schouren",
          "Schrader",
          "Schramm",
          "Schreck",
          "Schreiber",
          "Schreiner",
          "Schreiter",
          "Schroder",
          "Schröder",
          "Schuermann",
          "Schuff",
          "Schuhaj",
          "Schuldt",
          "Schult",
          "Schulte",
          "Schultz",
          "Schultze",
          "Schulz",
          "Schulze",
          "Schumacher",
          "Schumann",
          "Schupp",
          "Schuri",
          "Schuster",
          "Schwab",
          "Schwalm",
          "Schwanbeck",
          "Schwandke",
          "Schwanitz",
          "Schwarthoff",
          "Schwartz",
          "Schwarz",
          "Schwarzer",
          "Schwarzkopf",
          "Schwarzmeier",
          "Schwatlo",
          "Schweisfurth",
          "Schwennen",
          "Schwerdtner",
          "Schwidde",
          "Schwirkschlies",
          "Schwuchow",
          "Schäfer",
          "Schäffel",
          "Schäffer",
          "Schäning",
          "Schöckel",
          "Schönball",
          "Schönbeck",
          "Schönberg",
          "Schönebeck",
          "Schönenberger",
          "Schönfeld",
          "Schönherr",
          "Schönlebe",
          "Schötz",
          "Schüler",
          "Schüppel",
          "Schütz",
          "Schütze",
          "Seeger",
          "Seelig",
          "Sehls",
          "Seibold",
          "Seidel",
          "Seiders",
          "Seigel",
          "Seiler",
          "Seitz",
          "Semisch",
          "Senkel",
          "Sewald",
          "Siebel",
          "Siebert",
          "Siegling",
          "Sielemann",
          "Siemon",
          "Siener",
          "Sievers",
          "Siewert",
          "Sihler",
          "Sillah",
          "Simon",
          "Sinnhuber",
          "Sischka",
          "Skibicki",
          "Sladek",
          "Slotta",
          "Smieja",
          "Soboll",
          "Sokolowski",
          "Soller",
          "Sollner",
          "Sommer",
          "Somssich",
          "Sonn",
          "Sonnabend",
          "Spahn",
          "Spank",
          "Spelmeyer",
          "Spiegelburg",
          "Spielvogel",
          "Spinner",
          "Spitzmüller",
          "Splinter",
          "Sporrer",
          "Sprenger",
          "Spöttel",
          "Stahl",
          "Stang",
          "Stanger",
          "Stauss",
          "Steding",
          "Steffen",
          "Steffny",
          "Steidl",
          "Steigauf",
          "Stein",
          "Steinecke",
          "Steinert",
          "Steinkamp",
          "Steinmetz",
          "Stelkens",
          "Stengel",
          "Stengl",
          "Stenzel",
          "Stepanov",
          "Stephan",
          "Stern",
          "Steuk",
          "Stief",
          "Stifel",
          "Stoll",
          "Stolle",
          "Stolz",
          "Storl",
          "Storp",
          "Stoutjesdijk",
          "Stratmann",
          "Straub",
          "Strausa",
          "Streck",
          "Streese",
          "Strege",
          "Streit",
          "Streller",
          "Strieder",
          "Striezel",
          "Strogies",
          "Strohschank",
          "Strunz",
          "Strutz",
          "Stube",
          "Stöckert",
          "Stöppler",
          "Stöwer",
          "Stürmer",
          "Suffa",
          "Sujew",
          "Sussmann",
          "Suthe",
          "Sutschet",
          "Swillims",
          "Szendrei",
          "Sören",
          "Sürth",
          "Tafelmeier",
          "Tang",
          "Tasche",
          "Taufratshofer",
          "Tegethof",
          "Teichmann",
          "Tepper",
          "Terheiden",
          "Terlecki",
          "Teufel",
          "Theele",
          "Thieke",
          "Thimm",
          "Thiomas",
          "Thomas",
          "Thriene",
          "Thränhardt",
          "Thust",
          "Thyssen",
          "Thöne",
          "Tidow",
          "Tiedtke",
          "Tietze",
          "Tilgner",
          "Tillack",
          "Timmermann",
          "Tischler",
          "Tischmann",
          "Tittman",
          "Tivontschik",
          "Tonat",
          "Tonn",
          "Trampeli",
          "Trauth",
          "Trautmann",
          "Travan",
          "Treff",
          "Tremmel",
          "Tress",
          "Tsamonikian",
          "Tschiers",
          "Tschirch",
          "Tuch",
          "Tucholke",
          "Tudow",
          "Tuschmo",
          "Tächl",
          "Többen",
          "Töpfer",
          "Uhlemann",
          "Uhlig",
          "Uhrig",
          "Uibel",
          "Uliczka",
          "Ullmann",
          "Ullrich",
          "Umbach",
          "Umlauft",
          "Umminger",
          "Unger",
          "Unterpaintner",
          "Urban",
          "Urbaniak",
          "Urbansky",
          "Urhig",
          "Vahlensieck",
          "Van",
          "Vangermain",
          "Vater",
          "Venghaus",
          "Verniest",
          "Verzi",
          "Vey",
          "Viellehner",
          "Vieweg",
          "Voelkel",
          "Vogel",
          "Vogelgsang",
          "Vogt",
          "Voigt",
          "Vokuhl",
          "Volk",
          "Volker",
          "Volkmann",
          "Von",
          "Vona",
          "Vontein",
          "Wachenbrunner",
          "Wachtel",
          "Wagner",
          "Waibel",
          "Wakan",
          "Waldmann",
          "Wallner",
          "Wallstab",
          "Walter",
          "Walther",
          "Walton",
          "Walz",
          "Wanner",
          "Wartenberg",
          "Waschbüsch",
          "Wassilew",
          "Wassiluk",
          "Weber",
          "Wehrsen",
          "Weidlich",
          "Weidner",
          "Weigel",
          "Weight",
          "Weiler",
          "Weimer",
          "Weis",
          "Weiss",
          "Weller",
          "Welsch",
          "Welz",
          "Welzel",
          "Weniger",
          "Wenk",
          "Werle",
          "Werner",
          "Werrmann",
          "Wessel",
          "Wessinghage",
          "Weyel",
          "Wezel",
          "Wichmann",
          "Wickert",
          "Wiebe",
          "Wiechmann",
          "Wiegelmann",
          "Wierig",
          "Wiese",
          "Wieser",
          "Wilhelm",
          "Wilky",
          "Will",
          "Willwacher",
          "Wilts",
          "Wimmer",
          "Winkelmann",
          "Winkler",
          "Winter",
          "Wischek",
          "Wischer",
          "Wissing",
          "Wittich",
          "Wittl",
          "Wolf",
          "Wolfarth",
          "Wolff",
          "Wollenberg",
          "Wollmann",
          "Woytkowska",
          "Wujak",
          "Wurm",
          "Wyludda",
          "Wölpert",
          "Wöschler",
          "Wühn",
          "Wünsche",
          "Zach",
          "Zaczkiewicz",
          "Zahn",
          "Zaituc",
          "Zandt",
          "Zanner",
          "Zapletal",
          "Zauber",
          "Zeidler",
          "Zekl",
          "Zender",
          "Zeuch",
          "Zeyen",
          "Zeyhle",
          "Ziegler",
          "Zimanyi",
          "Zimmer",
          "Zimmermann",
          "Zinser",
          "Zintl",
          "Zipp",
          "Zipse",
          "Zschunke",
          "Zuber",
          "Zwiener",
          "Zümsande",
          "Östringer",
          "Überacker"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{nobility_title_prefix} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "nobility_title_prefix": [
          "zu",
          "von",
          "vom",
          "von der"
        ],
        "prefix": [
          "Dr.",
          "Prof. Dr."
        ]
      },
      "phone_number": {
        "country_code": [
          "43"
        ],
        "formats": [
          "01 #######",
          "01#######",
          "1-#######",
          "1#######",
          "0#### ####",
          "0#########",
          "####-####",
          "########"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Bitte wählen"
      },
      "submit": {
        "create": "%{model} erstellen",
        "submit": "%{model} speichern",
        "update": "%{model} aktualisieren"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u %n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "Milliarde",
              "other": "Milliarden"
            },
            "million": {
              "one": "Million",
              "other": "Millionen"
            },
            "quadrillion": {
              "one": "Billiarde",
              "other": "Billiarden"
            },
            "thousand": "Tausend",
            "trillion": {
              "one": "Billion",
              "other": "Billionen"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " und ",
        "two_words_connector": " und ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "vormittags",
      "formats": {
        "default": "%A, %d. %B %Y, %H:%M Uhr",
        "long": "%A, %d. %B %Y, %H:%M Uhr",
        "short": "%d. %b, %H:%M Uhr"
      },
      "pm": "nachmittags"
    }
  },
  "de-CH": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bestätigung gesendet am",
          "confirmation_token": "Bestätigungs-Token",
          "confirmed_at": "Bestätigt am",
          "created_at": "Erstellt am",
          "current_password": "Bisheriges Passwort",
          "current_sign_in_at": "Aktuelle Anmeldung vom",
          "current_sign_in_ip": "IP der aktuellen Anmeldung",
          "email": "E-Mail",
          "encrypted_password": "Verschlüsseltes Passwort",
          "failed_attempts": "Fehlversuche",
          "last_sign_in_at": "Letzte Anmeldung am",
          "last_sign_in_ip": "IP der letzten Anmeldung",
          "locked_at": "Gesperrt am",
          "password": "Passwort",
          "password_confirmation": "Passwortbestätigung",
          "remember_created_at": "Angemeldet bleiben vom",
          "remember_me": "Angemeldet bleiben",
          "reset_password_sent_at": "Passwort-Zurücksetzen-E-Mail gesendet am",
          "reset_password_token": "Passwort-Zurücksetzen-Token",
          "sign_in_count": "Anzahl Anmeldungen",
          "unconfirmed_email": "Unbestätigte E-Mail-Adresse",
          "unlock_token": "Entsperrungs-Token",
          "updated_at": "Aktualisiert am"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Datensatz kann nicht gelöscht werden, da abhängige %{record} existieren.",
            "has_one": "Datensatz kann nicht gelöscht werden, da ein abhängiger %{record}-Datensatz existiert."
          }
        }
      },
      "models": {
        "user": {
          "one": "Benutzer",
          "other": "Benutzer"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "day_names": [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "etwa eine Stunde",
          "other": "etwa %{count} Stunden"
        },
        "about_x_months": {
          "one": "etwa ein Monat",
          "other": "etwa %{count} Monate"
        },
        "about_x_years": {
          "one": "etwa ein Jahr",
          "other": "etwa %{count} Jahre"
        },
        "almost_x_years": {
          "one": "fast ein Jahr",
          "other": "fast %{count} Jahre"
        },
        "half_a_minute": "eine halbe Minute",
        "less_than_x_minutes": {
          "one": "weniger als eine Minute",
          "other": "weniger als %{count} Minuten"
        },
        "less_than_x_seconds": {
          "one": "weniger als eine Sekunde",
          "other": "weniger als %{count} Sekunden"
        },
        "over_x_years": {
          "one": "mehr als ein Jahr",
          "other": "mehr als %{count} Jahre"
        },
        "x_days": {
          "one": "ein Tag",
          "other": "%{count} Tage"
        },
        "x_minutes": {
          "one": "eine Minute",
          "other": "%{count} Minuten"
        },
        "x_months": {
          "one": "ein Monat",
          "other": "%{count} Monate"
        },
        "x_seconds": {
          "one": "eine Sekunde",
          "other": "%{count} Sekunden"
        }
      },
      "prompts": {
        "day": "Tag",
        "hour": "Stunde",
        "minute": "Minute",
        "month": "Monat",
        "second": "Sekunde",
        "year": "Jahr"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ihre E-Mail Adresse wurde erfolgreich bestätigt.",
        "new": {
          "resend_confirmation_instructions": "Anleitung zur Bestätigung noch mal schicken"
        },
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können.",
        "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können."
      },
      "failure": {
        "already_authenticated": "Sie sind bereits angemeldet.",
        "inactive": "Ihr Account ist nicht aktiv.",
        "invalid": "%{authentication_keys} oder Passwort ungültig.",
        "last_attempt": "Sie haben noch einen Versuch, bis Ihr Account gesperrt wird.",
        "locked": "Ihr Account ist gesperrt.",
        "not_found_in_database": "%{authentication_keys} oder Passwort ungültig.",
        "timeout": "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.",
        "unauthenticated": "Sie müssen sich anmelden oder registrieren, bevor Sie fortfahren können.",
        "unconfirmed": "Sie müssen Ihren Account bestätigen, bevor Sie fortfahren können."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Mein Konto bestätigen",
          "greeting": "Willkommen %{recipient}!",
          "instruction": "Folgen Sie dem untenstehenden Link, um Ihr Konto zu bestätigen:",
          "subject": "Anleitung zur Bestätigung Ihres Accounts"
        },
        "email_changed": {
          "greeting": "Hallo %{recipient}!",
          "message": "Wir schreiben Ihnen, um Sie darüber zu informieren, dass Ihre E-Mail-Adresse zu %{email} geändert wurde.",
          "message_unconfirmed": null,
          "subject": "E-Mail-Adresse geändert"
        },
        "password_change": {
          "greeting": "Hallo %{recipient}!",
          "message": "Wir kontaktieren Sie, um Ihnen mitzuteilen, dass Ihr Passwort geändert wurde.",
          "subject": "Passwort geändert"
        },
        "reset_password_instructions": {
          "action": "Passwort ändern",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Jemand hat einen Link angefordert, um Ihr Passwort zu ändern. Klicken Sie auf den unten aufgeführten Link um das Passwort zu ändern.",
          "instruction_2": "Bitte ignorieren Sie diese E-Mail, wenn Sie kein neues Passwort angefordert haben.",
          "instruction_3": "Das Passwort wird nicht geändert bis Sie den obenstehenden Link abrufen und ein neues Passwort bestimmen.",
          "subject": "Anleitung für das Zurücksetzen Ihres Passworts"
        },
        "unlock_instructions": {
          "action": "Mein Konto entsperren",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Folgen Sie dem untenstehenden Link, um Ihr Konto zu entsperren:",
          "message": "Ihr Konto wurde aufgrund einer grossen Anzahl von fehlgeschlagenen Anmeldeversuchen gesperrt.",
          "subject": "Anleitung für die Account-Freischaltung"
        }
      },
      "omniauth_callbacks": {
        "failure": "Sie konnten nicht mit Ihrem %{kind}-Account angemeldet werden, weil \"%{reason}\".",
        "success": "Sie haben sich erfolgreich mit Ihrem %{kind}-Account angemeldet."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Ändere mein Passwort",
          "change_your_password": "Passwort ändern",
          "confirm_new_password": "Neues Passwort bestätigen",
          "new_password": "Neues Passwort"
        },
        "new": {
          "forgot_your_password": "Haben Sie Ihr Passwort vergessen?",
          "send_me_reset_password_instructions": "Schicken Sie mir die Anleitung, um mein Passwort zurückzusetzen"
        },
        "no_token": "Sie können sich nicht auf dieser Seite anmelden, wenn Sie nicht von einer Passwort-Zurücksetzen-E-Mail kommen. Wenn Sie von solch einer E-Mail kommen, überprüfen Sie bitte, ob Sie die gesamte URL verwendeten.",
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können.",
        "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können.",
        "updated": "\t\nIhr Passwort wurde geändert. Sie sind jetzt angemeldet.",
        "updated_not_active": "Ihr Passwort wurde geändert."
      },
      "registrations": {
        "destroyed": "Ihr Account wurde gelöscht.",
        "edit": {
          "are_you_sure": "Sind Sie sicher?",
          "cancel_my_account": "Konto löschen",
          "currently_waiting_confirmation_for_email": "Warte auf Bestätigung von %{email}.",
          "leave_blank_if_you_don_t_want_to_change_it": "freilassen, wenn Sie das nicht ändern wollen",
          "title": "%{resource} bearbeiten",
          "unhappy": "Unglücklich",
          "update": "Aktualisieren",
          "we_need_your_current_password_to_confirm_your_changes": "wir benötigen Ihr aktuelles Passwort, um die Änderung zu bestätigen"
        },
        "new": {
          "sign_up": "Registrieren"
        },
        "signed_up": "Sie haben sich erfolgreich registriert.",
        "signed_up_but_inactive": "Sie haben sich erfolgreich registriert. Wir konnten Sie jedoch nicht anmelden, weil Ihr Account noch nicht aktiviert ist.",
        "signed_up_but_locked": "Sie haben sich erfolgreich registriert. Wir konnten Sie jedoch nicht anmelden, weil Ihr Account gesperrt ist.",
        "signed_up_but_unconfirmed": "Sie erhalten in wenigen Minuten eine E-Mail mit einem Link für die Bestätigung der Registrierung. Klicken Sie auf den Link um Ihren Account zu aktivieren.",
        "update_needs_confirmation": "Ihre Daten wurden aktualisiert, aber Sie müssen Ihre neue E-Mail-Adresse bestätigen. Sie erhalten in wenigen Minuten eine E-Mail, mit der Sie die Änderung Ihrer E-Mail-Adresse abschliessen können.",
        "updated": "Ihre Daten wurden aktualisiert.",
        "updated_but_not_signed_in": "Ihre Daten wurden aktualisiert, aber da sich Ihr Passwort geändert hat, müssen Sie sich erneut anmelden"
      },
      "sessions": {
        "already_signed_out": "Erfolgreich abgemeldet.",
        "new": {
          "sign_in": "Anmelden"
        },
        "signed_in": "Erfolgreich angemeldet.",
        "signed_out": "Erfolgreich abgemeldet."
      },
      "shared": {
        "links": {
          "back": "Zurück",
          "didn_t_receive_confirmation_instructions": "Keine Anleitung zur Bestätigung erhalten?",
          "didn_t_receive_unlock_instructions": "Keine Anleitung zum Entsperren erhalten?",
          "forgot_your_password": "Passwort vergessen?",
          "sign_in": "\nAnmelden\n",
          "sign_in_with_provider": "Mit %{provider} anmelden",
          "sign_up": "Registrieren"
        },
        "minimum_password_length": {
          "one": "(mindestens %{count} Zeichen)",
          "other": "(mindestens %{count} Zeichen)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Anleitung zum Entsperren noch mal schicken"
        },
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihren Account entsperren können.",
        "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Anleitung, wie Sie Ihren Account entsperren können.",
        "unlocked": "Ihr Account wurde entsperrt. Sie sind jetzt angemeldet."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "muss akzeptiert werden",
        "already_confirmed": "wurde bereits bestätigt, bitte versuchen Sie, sich anzumelden",
        "blank": "muss ausgefüllt werden",
        "confirmation": "stimmt nicht mit %{attribute} überein",
        "confirmation_period_expired": "muss innerhalb von %{period} bestätigt werden, bitte neu anfordern.",
        "empty": "muss ausgefüllt werden",
        "equal_to": "muss genau %{count} sein",
        "even": "muss gerade sein",
        "exclusion": "ist nicht verfügbar",
        "expired": "ist abgelaufen, bitte neu anfordern",
        "greater_than": "muss grösser als %{count} sein",
        "greater_than_or_equal_to": "muss grösser oder gleich %{count} sein",
        "inclusion": "ist kein gültiger Wert",
        "invalid": "ist nicht gültig",
        "less_than": "muss kleiner als %{count} sein",
        "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
        "model_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
        "not_a_number": "ist keine Zahl",
        "not_an_integer": "muss ganzzahlig sein",
        "not_found": "nicht gefunden",
        "not_locked": "ist nicht gesperrt",
        "not_saved": {
          "one": "%{resource} konnte aufgrund eines Fehlers nicht gespeichert werden:",
          "other": "%{count} Fehler verhinderten das Speichern von %{resource}:"
        },
        "odd": "muss ungerade sein",
        "other_than": "darf nicht gleich %{count} sein",
        "password_too_long": "ist zu lang",
        "present": "darf nicht ausgefüllt werden",
        "required": "muss ausgefüllt werden",
        "taken": "ist bereits vergeben",
        "too_long": {
          "one": "ist zu lang (mehr als %{count} Zeichen)",
          "other": "ist zu lang (mehr als %{count} Zeichen)"
        },
        "too_short": {
          "one": "ist zu kurz (weniger als %{count} Zeichen)",
          "other": "ist zu kurz (weniger als %{count} Zeichen)"
        },
        "wrong_length": {
          "one": "hat die falsche Länge (muss genau %{count} Zeichen haben)",
          "other": "hat die falsche Länge (muss genau %{count} Zeichen haben)"
        }
      },
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#",
          "##a",
          "##b",
          "##c"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Basel",
          "Bern",
          "Zürich",
          "Genf",
          "Olten",
          "Solothurn",
          "Oberhünigen",
          "Heiden",
          "Le Brouillet",
          "Davos Wolfgang",
          "Gimel",
          "Preonzo",
          "Augio",
          "Vendlincourt",
          "Trogen",
          "Aurigeno",
          "Limpach",
          "Altendorf",
          "Dotzigen",
          "Montherod",
          "Mézières VD",
          "Bure",
          "Hemberg",
          "Greich",
          "Verdasio",
          "Zug",
          "Schwändi b. Schwanden",
          "Buchs ZH",
          "Lostallo",
          "Cressier NE",
          "Schachen LU",
          "Stäfa",
          "Horn",
          "Bedigliora",
          "Realp",
          "Lauterbrunnen",
          "Adligenswil",
          "Niederwangen b. Bern",
          "Wettingen",
          "Wolfwil",
          "Teufenthal AG",
          "Zollikofen",
          "Plasselb",
          "Chancy",
          "Frenkendorf",
          "Cinuos-chel",
          "Lalden",
          "Genève",
          "Osco",
          "Rickenbach b. Wil",
          "Gamsen",
          "Lausanne",
          "Visperterminen",
          "Corzoneso",
          "Crans-Montana",
          "Emmetten",
          "Meikirch",
          "Châtel-St-Denis",
          "Splügen",
          "Les Moulins VS (Liddes)",
          "Cama",
          "Rigi Klösterli",
          "Axalp",
          "Recherswil",
          "Weiningen TG",
          "Schachen b. Herisau",
          "Cugnasco",
          "Hindelbank",
          "Rohrmatt",
          "Rüschegg Gambach",
          "Sorengo",
          "Banco",
          "Bannwil",
          "Hattenhausen",
          "Wiler b. Utzenstorf",
          "Champlan (Grimisuat)",
          "Acquarossa",
          "Sils/Segl Maria",
          "Otelfingen",
          "Kaisten",
          "Studen BE",
          "Hägglingen",
          "Grächen",
          "Weinfelden",
          "Le Sentier",
          "Alosen",
          "Tartegnin",
          "Bettlach",
          "Illgau",
          "Eggenwil",
          "Dornach",
          "Hessigkofen",
          "Obergoldbach",
          "Châtonnaye",
          "Ursenbach",
          "Rueyres-les-Prés",
          "Auenstein",
          "Möriken AG",
          "Fraubrunnen",
          "Glattfelden",
          "Seewen SO",
          "Engi",
          "Riom",
          "Schlatt ZH",
          "Rieden SG",
          "Dino",
          "Zimmerwald",
          "La Cibourg",
          "Pitasch",
          "Gerlafingen",
          "Chevenez",
          "Liddes",
          "Wauwil",
          "Walde SG",
          "Boningen",
          "Gurtnellen",
          "La Neuveville",
          "Thierachern",
          "Soral",
          "Fuldera",
          "Gundetswil",
          "Salenstein",
          "Affoltern im Emmental",
          "Uors (Lumnezia)",
          "Galgenen",
          "Montbrelloz",
          "Rickenbach ZH",
          "Günsberg",
          "Villarbeney",
          "Le Pâquier NE",
          "Chesalles-sur-Moudon",
          "Sundlauenen",
          "Dürnten",
          "Jungfraujoch",
          "Bätterkinden",
          "Corpataux",
          "Mehlsecken",
          "Schmidrüti",
          "Siggenthal Station",
          "Arogno",
          "Odogno",
          "Courchavon",
          "La Garde (Sembrancher)",
          "Rapperswil BE",
          "Wildhaus",
          "Pfungen",
          "Wiedlisbach",
          "Basel",
          "Koblenz",
          "Allmendingen b. Bern",
          "Vacallo",
          "Epauvillers",
          "Bättwil",
          "Winterthur",
          "Casima",
          "Syens",
          "Courgevaux",
          "Morlon",
          "Oberbalmberg",
          "Insone",
          "Wiezikon b. Sirnach",
          "Tegerfelden",
          "Kirchenthurnen",
          "Maseltrangen",
          "Wohlen b. Bern",
          "Avenches",
          "Giubiasco",
          "Gadenstätt",
          "Goppenstein",
          "Mosogno",
          "Einsiedeln",
          "Lindau",
          "Zinal",
          "Riehen",
          "Stetten SH",
          "Emmen",
          "Fulenbach",
          "Umiken",
          "Wasen im Emmental",
          "Mauensee",
          "Gebenstorf",
          "Agriswil",
          "Le Mont-Pèlerin",
          "Unterkulm",
          "Buch b. Kümmertshausen",
          "Premier",
          "Matzendorf",
          "Diepoldsau",
          "Le Séchey",
          "Fajauna",
          "Bad Zurzach",
          "Vullierens",
          "Ottikon (Gossau ZH)",
          "Rohrbach",
          "Rueun",
          "Tübach",
          "Corcelles BE",
          "Ersigen",
          "Russin",
          "Villars-sous-Mont",
          "Kaiserstuhl AG",
          "Lausanne",
          "Fey (Nendaz)",
          "Nussbaumen TG",
          "Le Crêt-du-Locle",
          "Nesslau",
          "Commugny",
          "Schwarzenbach SG",
          "Präz",
          "Wileroltigen",
          "Rigi Staffel",
          "Romairon",
          "Bignasco",
          "Sils/Segl Baselgia",
          "Ramosch",
          "Gams",
          "Bossonnens",
          "Au ZH",
          "Büchslen",
          "Cauco",
          "Gandria",
          "Rumendingen",
          "Le Château-de-Ste-Croix",
          "Champtauroz",
          "Oberbuchsiten",
          "Pohlern",
          "Altwis",
          "Waldstatt",
          "Ramsei",
          "Castel San Pietro",
          "Romanel-sur-Morges",
          "Nidfurn",
          "Bassecourt",
          "Ohmstal",
          "Davos Monstein",
          "Cevio",
          "Chez-le-Bart",
          "Engwang",
          "Obermutten",
          "Vaulion",
          "Rengg",
          "Brienz/Brinzauls GR",
          "Büren SO",
          "Les Paccots",
          "Chernex",
          "Hofen SH",
          "Villaraboud",
          "Bellikon",
          "Cerniaz VD",
          "Duvin",
          "Hauptikon",
          "Wichtrach",
          "Schliern b. Köniz",
          "Orselina",
          "Dulliken",
          "Pedrinate",
          "Geltwil",
          "Petit Vichères (Liddes)",
          "Golaten",
          "Vermes",
          "Guschelmuth",
          "Bedano",
          "Brusino Arsizio",
          "Steinerberg",
          "Isone",
          "Iffwil",
          "Soyhières",
          "Masein",
          "Suchy",
          "Cottens VD",
          "Surpierre",
          "Gretzenbach",
          "Siebnen",
          "Berg (Dägerlen)",
          "Morbio Inferiore",
          "Montet (Glâne)",
          "Zihlschlacht",
          "Ottoberg",
          "Rekingen AG",
          "Seengen",
          "Au TG",
          "Oberuzwil",
          "Weisstannen",
          "Oberschan",
          "Dürrenäsch",
          "Lampenberg",
          "Niederösch",
          "Seedorf BE",
          "Personico",
          "Scheuren",
          "Bombinasco",
          "Trasadingen",
          "Pont (Veveyse)",
          "Montaubion-Chardonney",
          "Sergey",
          "Ufhusen",
          "La Ferrière",
          "Appenzell Schlatt",
          "Lamperswil TG",
          "Hagenwil b. Amriswil",
          "Villigen",
          "Lugano"
        ],
        "default_country": [
          "Schweiz"
        ],
        "default_country_code": [
          "CH"
        ],
        "full_address": [
          "#{street_address}, #{zip_code} #{city}",
          "#{street_address}, #{zip_code} #{city}",
          "#{street_address}, c/o #{Name.name}, #{zip_code} #{city}",
          "#{street_address}, CH - #{zip_code} #{city}",
          "#{street_address}, Postfach, #{zip_code} #{city}"
        ],
        "postcode": [
          "1###",
          "2###",
          "3###",
          "4###",
          "5###",
          "6###",
          "7###",
          "8###",
          "9###"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "Ahorn",
          "Ahorngasse",
          "Alleestrasse",
          "Alpenlandstrasse",
          "Alte Poststrasse",
          "Alte Ufergasse",
          "Am Kronawett",
          "Am Mühlwasser",
          "Am Rebenhang",
          "Am Sternweg",
          "Alpenweg",
          "Aufeldgasse",
          "Bahngasse",
          "Bahnhofstrasse",
          "St. Gallerring",
          "Basteigasse",
          "Berggasse",
          "Bergstrasse",
          "Birkenweg",
          "Blasiussteig",
          "Bruderhofgasse",
          "Brunnelligasse",
          "Bühelweg",
          "Rheinweg",
          "Aarestrasse",
          "Bernstrasse",
          "Ebenthalerstrasse",
          "Eckgrabenweg",
          "Erlenstrasse",
          "Erlenweg",
          "Eschenweg",
          "Fichtenweg",
          "Amselweg",
          "Drosselweg",
          "Feld-Weg",
          "Feldgasse",
          "Flachbergstrasse",
          "Flurweg",
          "Friedhofstrasse",
          "Frohburgstrasse",
          "Gartenstrasse",
          "Nordstrasse",
          "Südstrasse",
          "Ostweg",
          "Westweg",
          "Baselstrasse",
          "Zürichstrasse"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "publisher": [
          "Stämpfli Verlag",
          "Rotpunkt",
          "Kein & Aber Verlag",
          "Appenzeller Verlag",
          "Applaus",
          "AT Verlag",
          "Bilger Verlag",
          "Cornelsen Schweiz",
          "Cosmos",
          "Diogenes Verlag",
          "Schwabe Verlag",
          "Vogel Verlag",
          "Zytglogge Verlag"
        ],
        "title": [
          "Also sprach Zarathustra",
          "Andorra",
          "Ansichten Eines Clowns",
          "Atemschaukel",
          "Aus dem Leben eines Taugenichts",
          "Bekenntnisse des Hochstaplers Felix Krull",
          "Berlin Alexanderplatz",
          "Biedermann und die Brandstifter",
          "Billiard um halbzehn",
          "Catharina von Georgien",
          "Cleopatra",
          "Damals war es Friedrich",
          "Dantons Tod",
          "Das Boot",
          "Das Marmorbild",
          "Das Parfum",
          "Das Schiff Esperanza",
          "Das Versprechen",
          "Das kalte Herz",
          "Das steinerne Herz",
          "Der (kleine) Schatz im Kugelbauch",
          "Der Augenblick der Liebe",
          "Der Ausflug der toten Mädchen",
          "Der Besuch der alten Dame",
          "Der Brief des Lord Chandos",
          "Der Goldene Topf",
          "Der Hauptmann von Köpenick",
          "Der Mann ohne Eigenschaften",
          "Der Prozess",
          "Der Richter und sein Henker",
          "Der Sandmann",
          "Der Schimmelreiter",
          "Der Spaziergang",
          "Der Stechlin",
          "Der Stellvertreter",
          "Der Steppenwolf",
          "Der Tod in Venedig und andere Erzählungen",
          "Der Tor und der Tod",
          "Der Untertan",
          "Der Verdacht",
          "Der Vorleser",
          "Der Vulkan",
          "Der Zauberberg",
          "Der abenteuerliche Simplicissimus",
          "Der arme Spielmann",
          "Der eiserne Gustav",
          "Der geteilte Himmel",
          "Der grüne Heinrich",
          "Der gute Mensch von Sezuan",
          "Der veruntreute Himmel",
          "Der zerbrochene Krug",
          "Des Teufels General",
          "Deutschland. Ein Wintermärchen",
          "Die Aufzeichnungen des Malte Laurids Brigge",
          "Die Blechtrommel",
          "Die Box",
          "Die Buddenbrooks",
          "Die Dreigroschenoper",
          "Die Erschiessung des Landesverräters Ernst S.",
          "Die Lehre der Sainte-Victoire",
          "Die Leiden des jungen Werther",
          "Die Leute von Seldwyla",
          "Die Marquise von O...",
          "Die Panne",
          "Die Physiker",
          "Die Rote",
          "Die Räuber",
          "Die Verwandlung/Erstes Leid",
          "Die Waffen nieder!",
          "Die Welt als Wille & Wahn",
          "Die neuen Leiden des jungen Werthers",
          "Die unendliche Geschichte",
          "Die verlorene Ehre der Katharina Blum",
          "Die zärtlichen Schwestern",
          "Don Karlos",
          "Effi Briest",
          "Ehen in Philippsburg",
          "Eiche und Angora",
          "Ein fliehendes Pferd",
          "Ende einer Dienstfahrt",
          "Es geschah im Nachbarhaus",
          "Fabian",
          "Faserland",
          "Faust, Part I",
          "Franziska Linkerhand",
          "Frühlings Erwachen",
          "Ganz unten",
          "Gehirne",
          "Die Weber",
          "Götz von Berlichingen",
          "Haus ohne Hüter",
          "Heidi",
          "Heinrich von Ofterdingen",
          "Helden wie wir",
          "Homo faber",
          "Hyperion oder der Eremit in Griechenland",
          "Im Krebsgang",
          "Im Westen nichts Neues",
          "Iphigenie auf Tauris",
          "Italienische Reise",
          "Jahrestage",
          "Jakob der Lügner",
          "Jedermann",
          "Kabale und Liebe",
          "Katz und Maus",
          "Leben des Galilei",
          "Lenz",
          "Lerne lachen ohne zu weinen",
          "Emilia Galotti",
          "Lieutenant Gustl",
          "Maria Magdalene",
          "Maria Stuart",
          "Mario und der Zauberer",
          "Mephisto",
          "Minna von Barnhelm",
          "Miss Sara Sampson",
          "Mutter Courage und ihre Kinder",
          "Narziss und Goldmund",
          "Narziss und Goldmund",
          "Nathan der Weise",
          "Paare, Passanten",
          "Panter, Tiger & Co.",
          "Reigen",
          "Romeo und Julia auf dem Dorfe",
          "Romulus der Grosse",
          "Sansibar oder der letzte Grund",
          "Schachnovelle",
          "Siddhartha",
          "Nada oder die Frage eines Augenblicks",
          "Stolz und Vorurteil",
          "Tauben im Gras",
          "Till Eulenspiegel",
          "Traumnovelle/Die Braut",
          "Tödliche Versprechen/Das Imperium der Wölfe",
          "Unterhaltungen deutscher Ausgewanderten",
          "Unterm Rad",
          "Vor Sonnenaufgang",
          "Wer einmal aus dem Blechnapf frisst",
          "Wilhelm Meisters Wanderjahre oder die Entsagenden",
          "Wilhelm Tell",
          "Winnetou",
          "Seltsame Schleife",
          "Woyzeck",
          "Über das Studium der griechischen Poesie"
        ]
      },
      "cell_phone": {
        "formats": [
          "+41 79 ### ## ##",
          "+41 78 ### ## ##",
          "+41 77 ### ## ##",
          "+41 76 ### ## ##",
          "079 ### ## ##",
          "078 ### ## ##",
          "077 ### ## ##",
          "076 ### ## ##"
        ]
      },
      "chuck_norris": {
        "fact": [
          "Einmal warf Chuck Norris eine Handgranate und tötete damit 100 Leute. Zwei Sekunden später explodierte sie.",
          "Am Anfang war das Nichts. Dann roundhousekickte Chuck Norris dieses Nichts und sagte: \"Such‘ Dir einen Job!\" Das ist die Geschichte der Entstehung des Universums.",
          "Neulich wurde eine in 3D gedrehte Folge von \"Walker, Texas Ranger\" im Kino gezeigt. Es gab keine Überlebenden.",
          "Chuck Norris übernimmt die Projektleitung des Flughafens Berlin Brandenburg. Eröffnung ist morgen früh um 06:30 Uhr.",
          "Chuck Norris kann wirbellosen Tieren trotzdem das Genick brechen.",
          "Chuck Norris liess sich an einen Lügendetektor anschliessen. Die Maschine gestand.",
          "Einmal wurde Chuck Norris auf Latein beleidigt. Seitdem gilt es als tote Sprache.",
          "Der Sensenmann fürchtet sich vor dem Tag, an dem Chuck Norris bei ihm vor der Tür steht.",
          "Chuck Norris zündet ein Feuer an, indem er zwei Eiswürfel aneinander reibt.",
          "Chuck Norris hat seine praktische Führerscheinprüfung bestanden – zu Fuss.",
          "Chuck Norris kann im Kinderkarussell überholen.",
          "Geister sitzen um das Lagerfeuer und erzählen sich Chuck-Norris-Geschichten.",
          "Die GEZ zahlt Chuck-Norris-Gebühren.",
          "Wenn Chuck Norris Wäsche wäscht, werden sogar schwarze Hemden strahlend weiss.",
          "Chuck Norris wurde neulich geblitzt – beim Einparken.",
          "Chuck Norris wurde einmal von einer Königskobra gebissen. Nach fünf qualvollen Tagen voller Schmerz starb die Kobra.",
          "Chuck Norris hat bis Unendlich gezählt – zwei Mal.",
          "Chuck Norris erfuhr einmal, dass nichts ihn besiegen könne. Deshalb machte er sich auf die Suche nach dem Nichts und tötete es.",
          "Chuck Norris ist so schnell – wenn er das Licht ausschaltet, ist er im Bett bevor der Raum dunkel ist.",
          "Das einzige Mal an dem Chuck Norris falsch lag, war, als er dachte, er habe einen Fehler gemacht.",
          "Wenn Chuck Norris beim Russisch Roulette verliert, will er eine Revanche.",
          "Chuck Norris kann eine Party schmeissen. 100 Meter weit.",
          "Chuck Norris hat einmal 37 Terroristen mit zwei Kugeln getötet. Die erste Kugel war ein Warnschuss.",
          "Wenn Du alleine ein Rennen gegen Chuck Norris fährst, wirst Du Dritter.",
          "Chuck Norris lügt nicht. Die Wahrheit ist einfach falsch.",
          "Chuck Norris‘ Passwort? Die Zahl Pi.",
          "Chuck Norris kann eine Bombe zerlegen – und zwar in ein Kaugummi, einen Faden, ein Streichholz und MacGyver.",
          "Chuck Norris isst keinen Honig. Chuck Norris kaut Bienen."
        ]
      },
      "color": {
        "name": [
          "rot",
          "grün",
          "blau",
          "gelb",
          "lila",
          "weiss",
          "schwarz",
          "orange",
          "rosa",
          "grau",
          "braun",
          "violett",
          "türkis",
          "oliv",
          "beige",
          "ocker",
          "sand",
          "mocka",
          "bordeaux",
          "aprikose",
          "mint-grün",
          "magenta",
          "gold",
          "silber",
          "bronze",
          "limette",
          "azur",
          "pink"
        ]
      },
      "commerce": {
        "department": [
          "Bücher",
          "Filme",
          "Musik",
          "Spiele",
          "Elektronik",
          "Computer",
          "Haushalt",
          "Garten",
          "Werkzeug",
          "Lebensmittel",
          "Gesundheit",
          "Beauty",
          "Spielzeug",
          "Kinder",
          "Kleinkinder",
          "Kleider",
          "Schuhe",
          "Schmuck",
          "Sport",
          "Outdoor",
          "Auto",
          "Industrie"
        ],
        "product_name": {
          "adjective": [
            "Kleine",
            "Ergonomische",
            "Rustikale",
            "Intelligente",
            "Wunderschöne",
            "Unglaubliche",
            "Fantastische",
            "Praktische",
            "Glatte",
            "Grossartige",
            "Enorme",
            "Mittelmässige",
            "Synergetische",
            "Strapazierfähige",
            "Leichtgewichtige",
            "Aerodynamische",
            "Haltbare"
          ],
          "material": [
            "Stahl",
            "Holz",
            "Beton",
            "Plastik",
            "Baumwoll",
            "Granit",
            "Gummi",
            "Leder",
            "Seiden",
            "Wolle",
            "Leinen",
            "Marmor",
            "Eisen",
            "Bronze",
            "Kupfer",
            "Aluminium",
            "Papier"
          ],
          "product": [
            "Stuhl",
            "Auto",
            "Computer",
            "Handschuh",
            "Hose",
            "Hemd",
            "Tisch",
            "Schuh",
            "Hut",
            "Teller",
            "Messer",
            "Flasche",
            "Mantel",
            "Lampe",
            "Tastatur",
            "Tasche",
            "Bänkli",
            "Tischli",
            "Uhr",
            "Portemonnaie"
          ]
        }
      },
      "company": {
        "legal_form": [
          "GmbH",
          "AG",
          "Verein",
          "Genossenschaft",
          "KG",
          "Stiftung"
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
        ],
        "suffix": [
          "AG",
          "GmbH",
          "und Söhne",
          "und Partner",
          "& Co.",
          "Gruppe",
          "LLC",
          "Inc."
        ]
      },
      "compass": {
        "abbreviation": [
          "#{cardinal_abbreviation}",
          "#{ordinal_abbreviation}",
          "#{half_wind_abbreviation}",
          "#{quarter_wind_abbreviation}"
        ],
        "azimuth": [
          "#{cardinal_azimuth}",
          "#{ordinal_azimuth}",
          "#{half_wind_azimuth}",
          "#{quarter_wind_azimuth}"
        ],
        "cardinal": {
          "abbreviation": [
            "N",
            "O",
            "S",
            "W"
          ],
          "azimuth": [
            "0",
            "90",
            "180",
            "270"
          ],
          "word": [
            "Norden",
            "Osten",
            "Süden",
            "Westen"
          ]
        },
        "direction": [
          "#{cardinal}",
          "#{ordinal}",
          "#{half_wind}",
          "#{quarter_wind}"
        ],
        "half-wind": {
          "abbreviation": [
            "NNO",
            "ONO",
            "OSO",
            "SSO",
            "SSW",
            "WSW",
            "WNW",
            "NNW"
          ],
          "azimuth": [
            "22.5",
            "67.5",
            "112.5",
            "157.5",
            "202.5",
            "247.5",
            "292.5",
            "337.5"
          ],
          "word": [
            "Nord-Nordost",
            "Ost-Nordost",
            "Ost-Südost",
            "Süd-Südost",
            "Süd-Südwest",
            "West-Südwest",
            "West-Nordwest",
            "Nord-Nordwest"
          ]
        },
        "ordinal": {
          "abbreviation": [
            "NO",
            "SO",
            "SW",
            "NW"
          ],
          "azimuth": [
            "45",
            "135",
            "225",
            "315"
          ],
          "word": [
            "Nordosten",
            "Südosten",
            "Südwesten",
            "Nordwesten"
          ]
        },
        "quarter-wind": {
          "abbreviation": [
            "NvO",
            "NOvN",
            "NOvO",
            "OvN",
            "OvS",
            "SOvO",
            "SOvS",
            "SvO",
            "SvW",
            "SWvS",
            "SWvW",
            "WvS",
            "WvN",
            "NWvW",
            "NWvN",
            "NvW"
          ],
          "azimuth": [
            "11.25",
            "33.75",
            "56.25",
            "78.75",
            "101.25",
            "123.75",
            "146.25",
            "168.75",
            "191.25",
            "213.75",
            "236.25",
            "258.75",
            "281.25",
            "303.75",
            "326.25",
            "348.75"
          ],
          "word": [
            "Norden von Osten",
            "Nordosten von Norden",
            "Nordosten von Osten",
            "Osten von Norden",
            "Osten von Süden",
            "Südosten von Osten",
            "Südosten von Süden",
            "Süden von Osten",
            "Süden von Westen",
            "Südwesten von Süden",
            "Südwesten von Westen",
            "Westen von Süden",
            "Westen von Norden",
            "Nordwesten von Westen",
            "Nordwesten von Norden",
            "Norden von Westen"
          ]
        }
      },
      "dr_who": {
        "the_doctors": [
          "Erster Doktor",
          "Zweiter Doktor",
          "Dritter Doktor",
          "Vierter Doktor",
          "Fünfter Doktor",
          "Sechster Doktor",
          "Siebenter Doktor",
          "Achter Doktor",
          "Neunter Doktor",
          "Zehnter Doktor",
          "Elfter Doktor",
          "Zwölfter Doktor"
        ]
      },
      "food": {
        "ingredients": [
          "Aal",
          "Aceto Balsamico",
          "Ackersalat",
          "Agar-Agar",
          "Agavendicksaft",
          "Ahornsirup",
          "Ajvar",
          "Akazienhonig",
          "Algen",
          "Amaranth",
          "Amaretto",
          "Ananas",
          "Ananassaft",
          "Anchovis",
          "Angostura",
          "Anisschnaps",
          "Aperol",
          "Apfeldicksaft",
          "Apfelmus",
          "Apfelringe",
          "Apfelsaft",
          "Apfelsinen",
          "Appenzeller",
          "Aprikosen",
          "Aprikosenmarmelade",
          "Aprikosensaft",
          "Aprikosensirup",
          "Arrak",
          "Artischocken",
          "Auberginen",
          "Austern",
          "Austernpilze",
          "Avocado",
          "Backpflaumen",
          "Backpulver",
          "Backzucker",
          "Baharat",
          "Bambussprossen",
          "Bananen",
          "Bananenchips",
          "Bandnudeln",
          "Batida de Coco",
          "Bavette",
          "Belegkirschen",
          "Bergkäse",
          "Bier",
          "Birnen",
          "Birnendicksaft",
          "Birnensaft",
          "Biskuitboden",
          "Bittermandelaroma",
          "Bitterschokolade",
          "Blattsalat",
          "Blauschimmelkäse",
          "Bleichsellerie",
          "Blumenkohl",
          "Blutorange",
          "Blutwurst",
          "Blätterteig",
          "Bohnen",
          "Bouquet garni",
          "Branntwein",
          "Brathähnchen",
          "Bratwurst",
          "Brauner Zucker",
          "Brie",
          "Brokkoli",
          "Brombeeren",
          "Brombeersaft",
          "Brötchen",
          "Buchweizen",
          "Buchweizenmehl",
          "Bulgur",
          "Butter",
          "Butterkekse",
          "Butterkäse",
          "Buttermilch",
          "Butterschmalz",
          "Bärlauchpesto",
          "Bündner Fleisch",
          "Cachaca",
          "Calvados",
          "Camembert",
          "Campari",
          "Cashewkerne",
          "Cassis-Likör",
          "Catfish",
          "Champagner",
          "Champignons",
          "Cheddarkäse",
          "Chicoree",
          "Chilipaste",
          "Chilipulver",
          "Chilisauce",
          "Chilischote",
          "Chinakohl",
          "Chorizzo",
          "Cidre",
          "Cognac",
          "Cointreau",
          "Couscous",
          "Cranberries",
          "Cranberrysaft",
          "Creme double",
          "Creme fraiche",
          "Creme fraiche mit Kräutern",
          "Cremefine",
          "Curacao Blue",
          "Curry",
          "Curryketchup",
          "Currypaste",
          "Datteln",
          "Dickmilch",
          "Dijonsenf",
          "Dinkelmehl",
          "Dorade",
          "Dörr-Aprikosen",
          "Dörrfleisch",
          "Edamer",
          "Eier",
          "Eierlikör",
          "Eisbergsalat",
          "Eiswürfel",
          "Emmentaler",
          "Ente",
          "Entenbrust",
          "Entenleber",
          "Entrecotes",
          "Erbsen",
          "Erdbeeren",
          "Erdbeermarmelade",
          "Erdbeersaft",
          "Erdbeersirup",
          "Erdnussbutter",
          "Erdnussöl",
          "Erdnüsse",
          "Espresso",
          "Essig",
          "Esskastanien",
          "Farfalle",
          "Fasan",
          "Feigen",
          "Fenchelsamen",
          "Feta",
          "Fettuccine",
          "Fisch",
          "Fischfond",
          "Fleischbrühe",
          "Fleischsalat",
          "Fleischtomaten",
          "Foie gras",
          "Fondor",
          "Forelle",
          "Frischkäse",
          "Frühlingszwiebeln",
          "Frühstücksspeck",
          "Fünf-Gewürz-Pulver",
          "Gans",
          "Garam Masala",
          "Garnelen",
          "Geflügelbouillon",
          "Gelatine",
          "Gelierzucker",
          "Gemüse",
          "Gemüsebrühe",
          "Gemüsesaft",
          "Gewürze",
          "Gewürzgurken",
          "Gin",
          "Ginger Ale",
          "Glasnudeln",
          "Glutamat",
          "Gouda",
          "Grammeln",
          "Granatapfel",
          "Granatapfelsirup",
          "Grapefruit",
          "Grapefruitsaft",
          "Gratinkäse",
          "Graupen",
          "Greyerzer Käse",
          "Griess",
          "Grüner Speck",
          "Grünkern",
          "Grünkohl",
          "Guave",
          "Gänsebrust",
          "Gänsekeule",
          "Gänseleber",
          "Götterspeise",
          "Hackfleisch",
          "Hafer",
          "Haferflocken",
          "Hagebutten",
          "Hagelzucker",
          "Halloumi",
          "Hartkäse",
          "Harzer",
          "Hase",
          "Haselnussglasur",
          "Haselnüsse",
          "Hecht",
          "Hefe",
          "Heidelbeeren",
          "Hering",
          "Herz",
          "Himbeeren",
          "Himbeermarmelade",
          "Himbeersaft",
          "Himbeersirup",
          "Hirsch",
          "Hirschhornsalz",
          "Hirse",
          "Hoisin-Sauce",
          "Holunderbeeren",
          "Holunderbeersaft",
          "Holundersirup",
          "Honigmelone",
          "Huhn",
          "Hummer",
          "Hähnchenbrust",
          "Hähnchenkeulen",
          "Hühnerleber",
          "Hüttenkäse",
          "Ingwersaft",
          "Ingwersirup",
          "Jakobsmuscheln",
          "Jalapenos",
          "Joghurt",
          "Johannisbeeren",
          "Johannisbeermarmelade",
          "Johannisbeersirup",
          "Josta-Beeren",
          "Kabeljau",
          "Kaffee",
          "Kaffeelikör",
          "Kakao",
          "Kaktusfeige",
          "Kalbfleisch",
          "Kalbsbrät",
          "Kalbsfond",
          "Kalbshaxen",
          "Kalbsleber",
          "Kalbsnuss",
          "Kalbsschnitzel",
          "Kandiszucker",
          "Kaninchen",
          "Karambole",
          "Karamellsirup",
          "Kardamom",
          "Karotten",
          "Karottensaft",
          "Karpfen",
          "Kartoffeln",
          "Kartoffelpüree",
          "Kassler",
          "Kaviar",
          "Kefir",
          "Ketchup",
          "Kichererbsen",
          "Kidneybohnen",
          "Kirschlikör",
          "Kirschmarmelade",
          "Kirschsaft",
          "Kirschtomaten",
          "Kirschwasser",
          "Kiwi",
          "Kochbananen",
          "Kohlrabi",
          "Kokosfett",
          "Kokosmilch",
          "Kokosnuss",
          "Kokosraspeln",
          "Kokossirup",
          "Kondensmilch",
          "Koriandergrün",
          "Koriandersamen",
          "Krabben",
          "Krabbenpaste",
          "Krebse",
          "Krokant",
          "Kräuter",
          "Kräuterbutter",
          "Kräuterfrischkäse",
          "Kräuterquark",
          "Kumquat",
          "Kuvertüre",
          "Kürbiskerne",
          "Kürbiskernöl",
          "Lachs",
          "Lammfleisch",
          "Lammhack",
          "Lammkeule",
          "Lammleber",
          "Langkornreis",
          "Lasagneblätter",
          "Lauch",
          "Lauchzwiebeln",
          "Leberkäse",
          "Lebkuchengewürz",
          "Leinsamen",
          "Letscho",
          "Liebstöckl",
          "Linguine",
          "Linsen",
          "Litschi",
          "Lyoner",
          "Löffelbiskuits",
          "Macadamia",
          "Madeira",
          "Magermilchjoghurt",
          "Magerquark",
          "Mais",
          "Maiskeimöl",
          "Maismehl",
          "Mandarinen",
          "Mandelmus",
          "Mandeln",
          "Mango",
          "Mango-Chutney",
          "Mangold",
          "Mangosirup",
          "Margarine",
          "Marsala",
          "Marzipan",
          "Marzipanrohmasse",
          "Mascarpone",
          "Mayonnaise",
          "Mehl",
          "Melone",
          "Mettenden",
          "Mexikanisches Gewürz",
          "Miesmuscheln",
          "Milch",
          "Milchreis",
          "Milchschokolade",
          "Mineralwasser",
          "Mirabellen",
          "Mischpilze",
          "Misopaste",
          "Mohn",
          "Morcheln",
          "Mozzarella",
          "Muh-Err Pilze (Wolkenohrpilze)",
          "Multivitaminsaft",
          "Mungobohnensprossen",
          "Möhren",
          "Münsterkäse",
          "Natron",
          "Natto",
          "Nektarine",
          "Nelken",
          "Nieren",
          "Noilly Prat",
          "Nougat",
          "Nudeln",
          "Nutella",
          "Nüsse",
          "Oblaten",
          "Obst",
          "Obstessig",
          "Okraschoten",
          "Oktopus",
          "Olivenöl",
          "Orangeat",
          "Orangenaroma",
          "Orangenblütenwasser",
          "Orangenlikör",
          "Orangenmarmelade",
          "Orangensaft",
          "Orangensirup",
          "Palmzucker",
          "Paniermehl",
          "Papaya",
          "Paprikamark",
          "Paprikapulver edelsüss",
          "Paradiescreme",
          "Parfait Amour",
          "Parmaschinken",
          "Parmesan",
          "Passionsfrucht",
          "Pastinaken",
          "Pastis",
          "Patissons",
          "Pecorino",
          "Pekannüsse",
          "Pellkartoffeln",
          "Perlzwiebeln",
          "Pesto",
          "Petersilienwurzel",
          "Pfefferkörner",
          "Pfifferlinge",
          "Pfirsiche",
          "Pfirsichsaft",
          "Pflanzencreme",
          "Pflaumen",
          "Pflaumenmus",
          "Pflaumensauce",
          "Pflaumenwein",
          "Physalis",
          "Pinienkerne",
          "Pistazie",
          "Polenta",
          "Portwein",
          "Pottasche",
          "Preiselbeeren",
          "Preiselbeermarmelade",
          "Prosecco",
          "Puderzucker",
          "Pute",
          "Putenbrust",
          "Putenkeulen",
          "Putenleber",
          "Putenrollbraten",
          "Putenschnitzel",
          "Quark",
          "Quimiq",
          "Quitten",
          "Radieschen",
          "Rahm",
          "Rapsöl",
          "Rebhuhn",
          "Reh",
          "Reis",
          "Reisessig",
          "Reisnudeln",
          "Reispapier",
          "Reissirup",
          "Reiswein",
          "Rettich",
          "Ricotta",
          "Riesengarnelen",
          "Riesling",
          "Rinderfilet",
          "Rinderhack",
          "Rinderleber",
          "Rindfleisch",
          "Risotto-Reis",
          "Roastbeef",
          "Roggenmehl",
          "Rohrzucker",
          "Rosa Pfeffer",
          "Rosenkohl",
          "Rosenpaprika",
          "Rosenwasser",
          "Rosinen",
          "Rote Beete",
          "Rote-Beete-Saft",
          "Rotkohl",
          "Rotweinessig",
          "Rumaroma",
          "Räucherlachs",
          "Röstzwiebeln",
          "Rübensirup",
          "Sahne",
          "Sahnejoghurt",
          "Sahnemeerrettich",
          "Sahnesteif",
          "Salami",
          "Salatgurke",
          "Sambal Oelek",
          "Sambuca",
          "Sanddornsaft",
          "Sanddornsirup",
          "Sardellenfilets",
          "Sardellenpaste",
          "Sardinen",
          "Sauerkirschen",
          "Sauerkirschsaft",
          "Sauerkraut",
          "Sauerteig",
          "Saure Sahne",
          "Saurer Halbrahm",
          "Sbrinz",
          "Schafskäse",
          "Schalotten",
          "Schinkenwurst",
          "Schlagsahne",
          "Schmalz",
          "Schmand",
          "Schmelzkäse",
          "Schnitzel",
          "Schokoladensauce",
          "Scholle",
          "Schwarzbrot",
          "Schwarzer Johannisbeersaft",
          "Schwarzwurzeln",
          "Schweinefilet",
          "Schweinefleisch",
          "Schweineleber",
          "Schweinelende",
          "Schweinenacken",
          "Seehecht",
          "Seeteufel",
          "Seitan",
          "Sekt",
          "Sellerieknolle",
          "Selleriesalz",
          "Senfkörner",
          "Senfmehl",
          "Sesam",
          "Sesampaste",
          "Sesamöl",
          "Sharonfrüchte (Kaki)",
          "Sherry",
          "Shiitake-Pilze",
          "Silberzwiebeln",
          "Sojamilch",
          "Sojasauce",
          "Sojasprossen",
          "Sojaöl",
          "Sonnenblumenkerne",
          "Sonnenblumenöl",
          "Sossenbinder",
          "Spaghetti",
          "Spanferkel",
          "Spargel",
          "Speck",
          "Speisestärke",
          "Spinat",
          "Spitzkohl",
          "Sprossen",
          "Stachelbeeren",
          "Staudensellerie",
          "Steckrüben",
          "Steinpilze",
          "Sternfrucht",
          "Stubenküken",
          "Suppenfleisch",
          "Suppengrün",
          "Süsskartoffeln",
          "Süsskirschen",
          "Süssstoff",
          "Tabasco",
          "Tafelspitz",
          "Tagliatelle",
          "Tahini",
          "Tamarillo",
          "Tequila",
          "Thunfisch",
          "Thunfischsteak",
          "Toastbrot",
          "Tofu",
          "Tomaten",
          "Tomatenmark",
          "Tomatensaft",
          "Tomato al gusto mit Kräuter",
          "Tortenguss",
          "Traubenkernöl",
          "Traubensaft",
          "Trockenfrüchte",
          "Trockenhefe",
          "Tsatsiki",
          "Vanillearoma",
          "Vanilleeis",
          "Vanillepudding",
          "Vanillesauce",
          "Vanilleschote",
          "Vanillezucker",
          "Vollkornmehl",
          "Wachtelbohnen",
          "Wachteleier",
          "Wachteln",
          "Waldfrüchte",
          "Waldmeistersirup",
          "Walnusskerne",
          "Walnussöl",
          "Wasser",
          "Weinbrand",
          "Weinessig",
          "Weintrauben",
          "Weizenkeime",
          "Weissbrot",
          "Weisskohl",
          "Weisswein",
          "Wermut",
          "Whisky",
          "Wild",
          "Wildschwein",
          "Wirsing",
          "Wodka",
          "Worcestersauce",
          "Wurst",
          "Würfelzucker",
          "Würstchen",
          "Zander",
          "Ziegenkäse",
          "Zigeunersauce",
          "Zitronat",
          "Zitrone",
          "Zitronenaroma",
          "Zitronenglasur",
          "Zitronensaft",
          "Zitronenschale",
          "Zitronensirup",
          "Zucchini",
          "Zucchiniblüten",
          "Zuckerglasur",
          "Zuckerschoten",
          "Zunge",
          "Zwetschgen",
          "Zwieback",
          "Zwiebelsuppe",
          "brauner Rum",
          "gedörrte Feigen",
          "gekochter Schinken",
          "gelbe Paprika",
          "geräucherte Putenbrust",
          "getrocknete Tomaten",
          "grüne Bohnen",
          "grüne Oliven",
          "grüne Paprika",
          "passierte Tomaten",
          "roher Schinken",
          "rote Paprika",
          "rote Zwiebeln",
          "schwarze Oliven",
          "weisse Bohnen",
          "weisse Schokolade",
          "weisse Zwiebeln",
          "weisser Heilbutt",
          "weisser Rum",
          "Äpfel",
          "Öl"
        ],
        "measurement_sizes": [
          "1/4",
          "1/3",
          "1/2",
          "1",
          "2",
          "3"
        ],
        "measurements": [
          "Teelöffel",
          "Esslöffel",
          "Tasse",
          "Prise",
          "Messerspitze",
          "Packung"
        ],
        "spices": [
          "Ajowan",
          "Anis",
          "Annatto",
          "Asant",
          "Bärlauch",
          "Bärwurz",
          "Basilikum",
          "Beifuss",
          "Berbere",
          "Bergkümmel",
          "Bertram",
          "Bockshornklee",
          "Bohnenkraut",
          "Borretsch",
          "Brunnenkresse",
          "Cardamom",
          "Cayennepfeffer",
          "Chili",
          "Cilantro",
          "Cumin",
          "Curcuma",
          "Curryblätter",
          "Currykraut",
          "Currypulver",
          "Dill",
          "Dost",
          "Eberraute",
          "Einlegegewürz",
          "Engelwurz",
          "Epazote",
          "Estragon",
          "Färberdistel",
          "Fenchel",
          "Fetthenne",
          "Gagel",
          "Galgant",
          "Galgant",
          "Gänseblümchen",
          "Garam",
          "Gelbwurz",
          "Gochujang",
          "Gomashio",
          "Gurkenkraut",
          "Harissa",
          "Herbes",
          "Honig",
          "gemeiner",
          "Ingwer",
          "Kaffernlimette",
          "Kakaopulver",
          "Kalmus",
          "Kapern",
          "Kapuzinerkresse",
          "Grüner",
          "Schwarzer",
          "Kerbel",
          "Kemirinuss",
          "Knoblauch",
          "Koriander",
          "Kren",
          "Kresse",
          "Grosse",
          "Kreuzkümmel",
          "Kubebenpfeffer",
          "Kümmel",
          "Kürbis",
          "Kurkuma",
          "Langer",
          "Lakritze",
          "Lavendel",
          "Liebstöckel",
          "Limette",
          "Lorbeer",
          "Lorbeer",
          "Löffelkraut",
          "Macis",
          "Mandel",
          "Majoran",
          "spreizende",
          "Meerrettich",
          "Melisse",
          "Minze",
          "Mitsuba",
          "Mohnsamen",
          "Muskat",
          "Myrrhenkerbel",
          "Nelkenpfeffer",
          "Ölkürbis",
          "Orangen",
          "Oregano",
          "Pandanus",
          "Paradieskörner",
          "Paprika",
          "Pastinake",
          "Peperoni",
          "Perilla",
          "Petersilie",
          "Pfeffer",
          "Pfefferminze",
          "Piment",
          "Pimpinelle",
          "Portulak",
          "Quendel",
          "Ras",
          "Rhabarber",
          "Rosmarin",
          "Rotwein",
          "Rouille",
          "Rucola",
          "Safran",
          "Salbei",
          "Salz",
          "Sambal",
          "Sassafras",
          "Sauerampfer",
          "Schabzigerklee",
          "Schalotte",
          "Schafgarbe",
          "Schnittknoblauch",
          "Schnittlauch",
          "Schwarzkümmel",
          "Sellerie",
          "Senf",
          "Soumbala",
          "Spitzwegerich",
          "Sternanis",
          "Stevia",
          "Sumach",
          "Süssdolde",
          "Süssholz",
          "Szechuanpfeffer",
          "Tamarinde",
          "Tanduri",
          "Tasmanischer",
          "Tonkabohne",
          "Thymian",
          "Tripmadam",
          "Trüffel",
          "Tschubritza",
          "Wasabi",
          "Wacholder",
          "Waldmeister",
          "Wald-Weidenröschen",
          "Wasserpfeffer",
          "Weinblätter",
          "Weinraute",
          "Ysop",
          "Zichorie",
          "Zimt",
          "Zitronengras",
          "Zitronenmelisse",
          "Zitronen",
          "Zitronenstrauch",
          "Zitronenthymian",
          "Zitwerwurzel",
          "Zucker",
          "Zwiebel"
        ]
      },
      "games": {
        "pokemon": {
          "names": [
            "Bisasam",
            "Bisaknosp",
            "Bisaflor",
            "Glumanda",
            "Glutexo",
            "Glurak",
            "Schiggy",
            "Schillok",
            "Turtok",
            "Raupy",
            "Safcon",
            "Smettbo",
            "Hornliu",
            "Kokuna",
            "Bibor",
            "Taubsi",
            "Tauboga",
            "Tauboss",
            "Rattfratz",
            "Rattikarl",
            "Habitak",
            "Ibitak",
            "Rettan",
            "Arbok",
            "Pikachu",
            "Raichu",
            "Sandan",
            "Sandamer",
            "Nidoran♀",
            "Nidorina",
            "Nidoqueen",
            "Nidoran♂",
            "Nidorino",
            "Nidoking",
            "Piepi",
            "Pixi",
            "Vulpix",
            "Vulnona",
            "Pummeluff",
            "Knuddeluff",
            "Zubat",
            "Golbat",
            "Myrapla",
            "Duflor",
            "Giflor",
            "Paras",
            "Parasek",
            "Bluzuk",
            "Omot",
            "Digda",
            "Digdri",
            "Mauzi",
            "Snobilikat",
            "Enton",
            "Entoron",
            "Menki",
            "Rasaff",
            "Fukano",
            "Arkani",
            "Quapsel",
            "Quaputzi",
            "Quappo",
            "Abra",
            "Kadabra",
            "Simsala",
            "Machollo",
            "Maschock",
            "Machomei",
            "Knofensa",
            "Ultrigaria",
            "Sarzenia",
            "Tentacha",
            "Tentoxa",
            "Kleinstein",
            "Georok",
            "Geowaz",
            "Ponita",
            "Gallopa",
            "Flegmon",
            "Lahmus",
            "Magnetilo",
            "Magneton",
            "Porenta",
            "Dodu",
            "Dodri",
            "Jurob",
            "Jugong",
            "Sleima",
            "Sleimok",
            "Muschas",
            "Austos",
            "Nebelk",
            "Alpollo",
            "Gengar",
            "Onix",
            "Traumato",
            "Hypno",
            "Krabby",
            "Kingler",
            "Voltobal",
            "Lektrobal",
            "Owei",
            "Kokowei",
            "Tragosso",
            "Knogga",
            "Kicklee",
            "Nockchan",
            "Schlurp",
            "Smogon",
            "Smogmog",
            "Rihorn",
            "Rizeros",
            "Chaneira",
            "Tangela",
            "Kangama",
            "Seeper",
            "Seemon",
            "Goldini",
            "Golking",
            "Sterndu",
            "Starmie",
            "Pantimos",
            "Sichlor",
            "Rossana",
            "Elektek",
            "Magmar",
            "Pinsir",
            "Tauros",
            "Karpador",
            "Garados",
            "Lapras",
            "Ditto",
            "Evoli",
            "Aquana",
            "Blitza",
            "Flamara",
            "Porygon",
            "Amonitas",
            "Amoroso",
            "Kabuto",
            "Kabutops",
            "Aerodactyl",
            "Relaxo",
            "Arktos",
            "Zapdos",
            "Lavados",
            "Dratini",
            "Dragonir",
            "Dragoran",
            "Mewtu",
            "Mew"
          ]
        }
      },
      "hipster": {
        "words": [
          "8-Bit",
          "Adrenalinjunkie",
          "Artisan",
          "Artpreneur",
          "Bart",
          "Basic Bitch",
          "Beanie",
          "Braux Pas",
          "Brunch",
          "Craft Beer",
          "Cutester",
          "DIY",
          "Earthporn",
          "Fake",
          "Fashin Girl",
          "Flittern",
          "Foodporn",
          "Freshman at life",
          "Frienvy",
          "Frunch",
          "Genderfriend",
          "Ghosting",
          "Helicopter-Freundin",
          "Hipster",
          "Influencer",
          "Inspiration",
          "Instagram",
          "Jutebeutel",
          "Kombucha",
          "Lomo",
          "Love Interest",
          "Lumbersexual",
          "Mansplaining",
          "Mate",
          "Mingle",
          "Mustache",
          "Möchtegern",
          "Nomophobia",
          "Normcore",
          "OMG",
          "Pinterest",
          "Polaroid",
          "Praktikantenlunch",
          "Pseudointellektuelle",
          "Quinoa",
          "Ringle",
          "SWAG",
          "Sapiosexuell",
          "Sexting",
          "Smoothie",
          "Spornosexuell",
          "Star Wars",
          "Strickmütze",
          "Suchtie",
          "Sushi",
          "Tattoo",
          "Tinder-Finger",
          "Trashopfer",
          "Twitternerds",
          "Undercut",
          "Urban Gardening",
          "Urbane Bohème",
          "Vans",
          "Vice",
          "WTF",
          "YOLO",
          "Yuccies",
          "Zumbatante",
          "awesome",
          "beziehungsunfähig",
          "blog",
          "chillen",
          "crazy",
          "handmade",
          "home brewed",
          "häkeln",
          "organic",
          "party hard",
          "passiv bisexuell",
          "retro",
          "snacken",
          "stricken",
          "suchten",
          "tl;dr",
          "vegan",
          "veganz",
          "veggie",
          "vintage",
          "viral",
          "vlog"
        ]
      },
      "internet": {
        "domain_suffix": [
          "ch",
          "com",
          "net",
          "biz",
          "ch",
          "de",
          "li",
          "at",
          "ch",
          "ch"
        ]
      },
      "lorem": {
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "mountain": {
        "name": [
          "Aletschhorn",
          "Bietschhorn",
          "Blüemlisalp",
          "Chasseral",
          "Dent Blanche",
          "Dents du Midi",
          "Dom",
          "Dufourspitze",
          "Finsteraarhorn",
          "Grand Combin",
          "Gurten",
          "Jungfrau",
          "Matterhorn",
          "Grosser Mythen",
          "Napf",
          "Pilatus",
          "Piz Bernina",
          "Säntis",
          "Silvrettahorn",
          "Titlis",
          "Tödi",
          "Wildstrubel"
        ],
        "range": [
          "Alpstein",
          "Berner Alpen",
          "Engadin",
          "Gotthardmassiv",
          "Jura",
          "Walliser Alpen"
        ]
      },
      "music": {
        "instruments": [
          "Akkordeon",
          "Balalaika",
          "Banjo",
          "Bass-Gitarre",
          "Basstuba",
          "Becken-Paar",
          "Blockflöte",
          "Bongo",
          "Bratsche",
          "Cabasa",
          "Celesta",
          "Cello",
          "Cembalo",
          "Dudelsack",
          "E-Bass",
          "E-Gitarre",
          "Fagott",
          "Geige",
          "Gitarre",
          "Gong",
          "Hammondorgel",
          "Harfe",
          "Horn",
          "Keybord",
          "Klarinette",
          "Klavier",
          "Kontrabass",
          "Laute",
          "Mandoline",
          "Marimba",
          "Mauren",
          "Melodica",
          "Mundharmonika",
          "Oboe",
          "Orgel",
          "Panflöte",
          "Pauke",
          "Piano",
          "Piccoloflöte",
          "Querflöte",
          "Rassel",
          "Sackpfeife",
          "Saxophon",
          "Schellentrommel",
          "Synthesizer",
          "Tamburin",
          "Triangel",
          "Trommel",
          "Trompete",
          "Tuba",
          "Vibraphon",
          "Viola",
          "Violine",
          "Xylophon",
          "Zither"
        ]
      },
      "name": {
        "female_first_name": [
          "Aaliyah",
          "Abby",
          "Abigail",
          "Ada",
          "Adelina",
          "Adriana",
          "Aileen",
          "Aimee",
          "Alana",
          "Alea",
          "Alena",
          "Alessa",
          "Alessia",
          "Alexa",
          "Alexandra",
          "Alexia",
          "Alexis",
          "Aleyna",
          "Alia",
          "Alica",
          "Alice",
          "Alicia",
          "Alina",
          "Alisa",
          "Alisha",
          "Alissa",
          "Aliya",
          "Aliyah",
          "Allegra",
          "Alma",
          "Alyssa",
          "Amalia",
          "Amanda",
          "Amelia",
          "Amelie",
          "Amina",
          "Amira",
          "Amy",
          "Ana",
          "Anabel",
          "Anastasia",
          "Andrea",
          "Angela",
          "Angelina",
          "Angelique",
          "Anja",
          "Ann",
          "Anna",
          "Annabel",
          "Annabell",
          "Annabelle",
          "Annalena",
          "Anne",
          "Anneke",
          "Annelie",
          "Annemarie",
          "Anni",
          "Annie",
          "Annika",
          "Anny",
          "Anouk",
          "Antonia",
          "Arda",
          "Ariana",
          "Ariane",
          "Arwen",
          "Ashley",
          "Asya",
          "Aurelia",
          "Aurora",
          "Ava",
          "Ayleen",
          "Aylin",
          "Ayse",
          "Azra",
          "Barbara",
          "Betty",
          "Bianca",
          "Bianka",
          "Brigitte",
          "Cara",
          "Carina",
          "Carla",
          "Carlotta",
          "Carmen",
          "Carolin",
          "Carolina",
          "Caroline",
          "Cassandra",
          "Catharina",
          "Catrin",
          "Cecile",
          "Cecilia",
          "Celia",
          "Celina",
          "Celine",
          "Ceyda",
          "Ceylin",
          "Chantal",
          "Charleen",
          "Charlotta",
          "Charlotte",
          "Chayenne",
          "Cheyenne",
          "Chiara",
          "Christin",
          "Christiane",
          "Christina",
          "Cindy",
          "Claire",
          "Clara",
          "Clarissa",
          "Colleen",
          "Collien",
          "Cora",
          "Corinna",
          "Cosima",
          "Dana",
          "Daniela",
          "Daria",
          "Darleen",
          "Defne",
          "Delia",
          "Denise",
          "Diana",
          "Dilara",
          "Dina",
          "Dorothea",
          "Ecrin",
          "Eda",
          "Eileen",
          "Ela",
          "Elaine",
          "Elanur",
          "Elea",
          "Elena",
          "Eleni",
          "Eleonora",
          "Eliana",
          "Elif",
          "Elina",
          "Elisa",
          "Elisabeth",
          "Ella",
          "Ellen",
          "Elli",
          "Elly",
          "Elsa",
          "Emelie",
          "Emely",
          "Emilia",
          "Emilie",
          "Emily",
          "Emma",
          "Emmely",
          "Emmi",
          "Emmy",
          "Enie",
          "Enna",
          "Enya",
          "Esma",
          "Estelle",
          "Esther",
          "Eva",
          "Evelin",
          "Evelina",
          "Eveline",
          "Evelyn",
          "Fabienne",
          "Fatima",
          "Fatma",
          "Felicia",
          "Felicitas",
          "Felina",
          "Femke",
          "Fenja",
          "Fine",
          "Finia",
          "Finja",
          "Finnja",
          "Fiona",
          "Flora",
          "Florentine",
          "Francesca",
          "Franka",
          "Franziska",
          "Frederike",
          "Freya",
          "Frida",
          "Frieda",
          "Friederike",
          "Giada",
          "Gina",
          "Giulia",
          "Giuliana",
          "Greta",
          "Hailey",
          "Hana",
          "Hanna",
          "Hannah",
          "Heidi",
          "Helen",
          "Helena",
          "Helene",
          "Helin",
          "Henriette",
          "Henrike",
          "Hermine",
          "Ida",
          "Ilayda",
          "Imke",
          "Ina",
          "Ines",
          "Inga",
          "Inka",
          "Irem",
          "Isa",
          "Isabel",
          "Isabell",
          "Isabella",
          "Isabelle",
          "Ivonne",
          "Jacqueline",
          "Jamie",
          "Jamila",
          "Jana",
          "Jane",
          "Janin",
          "Janina",
          "Janine",
          "Janna",
          "Janne",
          "Jara",
          "Jasmin",
          "Jasmina",
          "Jasmine",
          "Jella",
          "Jenna",
          "Jennifer",
          "Jenny",
          "Jessica",
          "Jessy",
          "Jette",
          "Jil",
          "Jill",
          "Joana",
          "Joanna",
          "Joelina",
          "Joeline",
          "Joelle",
          "Johanna",
          "Joleen",
          "Jolie",
          "Jolien",
          "Jolin",
          "Jolina",
          "Joline",
          "Jona",
          "Jonah",
          "Jonna",
          "Josefin",
          "Josefine",
          "Josephin",
          "Josephine",
          "Josie",
          "Josy",
          "Joy",
          "Joyce",
          "Judith",
          "Judy",
          "Jule",
          "Julia",
          "Juliana",
          "Juliane",
          "Julie",
          "Julienne",
          "Julika",
          "Julina",
          "Juna",
          "Justine",
          "Kaja",
          "Karina",
          "Karla",
          "Karlotta",
          "Karolina",
          "Karoline",
          "Kassandra",
          "Katarina",
          "Katharina",
          "Kathrin",
          "Katja",
          "Katrin",
          "Kaya",
          "Kayra",
          "Kiana",
          "Kiara",
          "Kim",
          "Kimberley",
          "Kimberly",
          "Kira",
          "Klara",
          "Korinna",
          "Kristin",
          "Kyra",
          "Laila",
          "Lana",
          "Lara",
          "Larissa",
          "Laura",
          "Laureen",
          "Lavinia",
          "Lea",
          "Leah",
          "Leana",
          "Leandra",
          "Leann",
          "Lee",
          "Leila",
          "Lena",
          "Lene",
          "Leni",
          "Lenia",
          "Lenja",
          "Lenya",
          "Leona",
          "Leoni",
          "Leonie",
          "Leonora",
          "Leticia",
          "Letizia",
          "Levke",
          "Leyla",
          "Lia",
          "Liah",
          "Liana",
          "Lili",
          "Lilia",
          "Lilian",
          "Liliana",
          "Lilith",
          "Lilli",
          "Lillian",
          "Lilly",
          "Lily",
          "Lina",
          "Linda",
          "Lindsay",
          "Line",
          "Linn",
          "Linnea",
          "Lisa",
          "Lisann",
          "Lisanne",
          "Liv",
          "Livia",
          "Liz",
          "Lola",
          "Loreen",
          "Lorena",
          "Lotta",
          "Lotte",
          "Louisa",
          "Louise",
          "Luana",
          "Luca",
          "Lucia",
          "Lucie",
          "Lucienne",
          "Lucy",
          "Luisa",
          "Luise",
          "Luka",
          "Luna",
          "Luzie",
          "Lya",
          "Lydia",
          "Lyn",
          "Lynn",
          "Madeleine",
          "Madita",
          "Madleen",
          "Madlen",
          "Magdalena",
          "Maike",
          "Mailin",
          "Maira",
          "Maja",
          "Malena",
          "Malia",
          "Malin",
          "Malina",
          "Mandy",
          "Mara",
          "Marah",
          "Mareike",
          "Maren",
          "Maria",
          "Mariam",
          "Marie",
          "Marieke",
          "Mariella",
          "Marika",
          "Marina",
          "Marisa",
          "Marissa",
          "Marit",
          "Marla",
          "Marleen",
          "Marlen",
          "Marlena",
          "Marlene",
          "Marta",
          "Martha",
          "Mary",
          "Maryam",
          "Mathilda",
          "Mathilde",
          "Matilda",
          "Maxi",
          "Maxima",
          "Maxine",
          "Maya",
          "Mayra",
          "Medina",
          "Medine",
          "Meike",
          "Melanie",
          "Melek",
          "Melike",
          "Melina",
          "Melinda",
          "Melis",
          "Melisa",
          "Melissa",
          "Merle",
          "Merve",
          "Meryem",
          "Mette",
          "Mia",
          "Michaela",
          "Michelle",
          "Mieke",
          "Mila",
          "Milana",
          "Milena",
          "Milla",
          "Mina",
          "Mira",
          "Miray",
          "Miriam",
          "Mirja",
          "Mona",
          "Monique",
          "Nadine",
          "Nadja",
          "Naemi",
          "Nancy",
          "Naomi",
          "Natalia",
          "Natalie",
          "Nathalie",
          "Neele",
          "Nela",
          "Nele",
          "Nelli",
          "Nelly",
          "Nia",
          "Nicole",
          "Nika",
          "Nike",
          "Nikita",
          "Nila",
          "Nina",
          "Nisa",
          "Noemi",
          "Nora",
          "Olivia",
          "Patricia",
          "Patrizia",
          "Paula",
          "Paulina",
          "Pauline",
          "Penelope",
          "Philine",
          "Phoebe",
          "Pia",
          "Rahel",
          "Rania",
          "Rebecca",
          "Rebekka",
          "Riana",
          "Rieke",
          "Rike",
          "Romina",
          "Romy",
          "Ronja",
          "Rosa",
          "Rosalie",
          "Ruby",
          "Sabrina",
          "Sahra",
          "Sally",
          "Salome",
          "Samantha",
          "Samia",
          "Samira",
          "Sandra",
          "Sandy",
          "Sanja",
          "Saphira",
          "Sara",
          "Sarah",
          "Saskia",
          "Selin",
          "Selina",
          "Selma",
          "Sena",
          "Sidney",
          "Sienna",
          "Silja",
          "Sina",
          "Sinja",
          "Smilla",
          "Sofia",
          "Sofie",
          "Sonja",
          "Sophia",
          "Sophie",
          "Soraya",
          "Stefanie",
          "Stella",
          "Stephanie",
          "Stina",
          "Sude",
          "Summer",
          "Susanne",
          "Svea",
          "Svenja",
          "Sydney",
          "Tabea",
          "Talea",
          "Talia",
          "Tamara",
          "Tamia",
          "Tamina",
          "Tanja",
          "Tara",
          "Tarja",
          "Teresa",
          "Tessa",
          "Thalea",
          "Thalia",
          "Thea",
          "Theresa",
          "Tia",
          "Tina",
          "Tomke",
          "Tuana",
          "Valentina",
          "Valeria",
          "Valerie",
          "Vanessa",
          "Vera",
          "Veronika",
          "Victoria",
          "Viktoria",
          "Viola",
          "Vivian",
          "Vivien",
          "Vivienne",
          "Wibke",
          "Wiebke",
          "Xenia",
          "Yara",
          "Yaren",
          "Yasmin",
          "Ylvi",
          "Ylvie",
          "Yvonne",
          "Zara",
          "Zehra",
          "Zeynep",
          "Zoe",
          "Zoey",
          "Zoé"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Abel",
          "Abicht",
          "Abraham",
          "Abramovic",
          "Abt",
          "Achilles",
          "Achkinadze",
          "Ackermann",
          "Adam",
          "Adams",
          "Ade",
          "Agostini",
          "Ahlke",
          "Ahrenberg",
          "Ahrens",
          "Aigner",
          "Albert",
          "Albrecht",
          "Alexa",
          "Alexander",
          "Alizadeh",
          "Allgeyer",
          "Amann",
          "Amberg",
          "Anding",
          "Anggreny",
          "Apitz",
          "Arendt",
          "Arens",
          "Arndt",
          "Aryee",
          "Aschenbroich",
          "Assmus",
          "Astafei",
          "Auer",
          "Axmann",
          "Baarck",
          "Bachmann",
          "Badane",
          "Bader",
          "Baganz",
          "Bahl",
          "Bak",
          "Balcer",
          "Balck",
          "Balkow",
          "Balnuweit",
          "Balzer",
          "Banse",
          "Barr",
          "Bartels",
          "Barth",
          "Barylla",
          "Baseda",
          "Battke",
          "Bauer",
          "Bauermeister",
          "Baumann",
          "Baumeister",
          "Bauschinger",
          "Bauschke",
          "Bayer",
          "Beavogui",
          "Beck",
          "Beckel",
          "Becker",
          "Beckmann",
          "Bedewitz",
          "Beele",
          "Beer",
          "Beggerow",
          "Beh",
          "Behnke",
          "Behnert",
          "Behr",
          "Behrenbruch",
          "Belz",
          "Bender",
          "Benecke",
          "Benner",
          "Benninger",
          "Benzing",
          "Berends",
          "Berger",
          "Berner",
          "Berning",
          "Bertenbreiter",
          "Best",
          "Bethke",
          "Betz",
          "Beushausen",
          "Beutelspacher",
          "Beyer",
          "Biba",
          "Bichler",
          "Bickel",
          "Biedermann",
          "Bieler",
          "Bielert",
          "Bienasch",
          "Bienias",
          "Biesenbach",
          "Bigdeli",
          "Birkemeyer",
          "Bittner",
          "Blank",
          "Blaschek",
          "Blassneck",
          "Bloch",
          "Blochwitz",
          "Blockhaus",
          "Blum",
          "Blume",
          "Bock",
          "Bode",
          "Bogdashin",
          "Bogenrieder",
          "Bohge",
          "Bolm",
          "Borgschulze",
          "Bork",
          "Bormann",
          "Bornscheuer",
          "Borrmann",
          "Borsch",
          "Boruschewski",
          "Bos",
          "Bosler",
          "Bourrouag",
          "Bouschen",
          "Boxhammer",
          "Boyde",
          "Bozsik",
          "Brand",
          "Brandenburg",
          "Brandis",
          "Brandt",
          "Brauer",
          "Braun",
          "Brehmer",
          "Breitenstein",
          "Bremer",
          "Bremser",
          "Brenner",
          "Brettschneider",
          "Breu",
          "Breuer",
          "Briesenick",
          "Bringmann",
          "Brinkmann",
          "Brix",
          "Broening",
          "Brosch",
          "Bruckmann",
          "Bruder",
          "Bruhns",
          "Brunner",
          "Bruns",
          "Bräutigam",
          "Brömme",
          "Brüggmann",
          "Buchholz",
          "Buchrucker",
          "Buder",
          "Bultmann",
          "Bunjes",
          "Burger",
          "Burghagen",
          "Burkhard",
          "Burkhardt",
          "Burmeister",
          "Busch",
          "Buschbaum",
          "Busemann",
          "Buss",
          "Busse",
          "Bussmann",
          "Byrd",
          "Bäcker",
          "Böhm",
          "Bönisch",
          "Börgeling",
          "Börner",
          "Böttner",
          "Büchele",
          "Bühler",
          "Büker",
          "Büngener",
          "Bürger",
          "Bürklein",
          "Büscher",
          "Büttner",
          "Camara",
          "Carlowitz",
          "Carlsohn",
          "Caspari",
          "Caspers",
          "Chapron",
          "Christ",
          "Cierpinski",
          "Clarius",
          "Cleem",
          "Cleve",
          "Co",
          "Conrad",
          "Cordes",
          "Cornelsen",
          "Cors",
          "Cotthardt",
          "Crews",
          "Cronjäger",
          "Crosskofp",
          "Da",
          "Dahm",
          "Dahmen",
          "Daimer",
          "Damaske",
          "Danneberg",
          "Danner",
          "Daub",
          "Daubner",
          "Daudrich",
          "Dauer",
          "Daum",
          "Dauth",
          "Dautzenberg",
          "De",
          "Decker",
          "Deckert",
          "Deerberg",
          "Dehmel",
          "Deja",
          "Delonge",
          "Demut",
          "Dengler",
          "Denner",
          "Denzinger",
          "Derr",
          "Dertmann",
          "Dethloff",
          "Deuschle",
          "Dieckmann",
          "Diedrich",
          "Diekmann",
          "Dienel",
          "Dies",
          "Dietrich",
          "Dietz",
          "Dietzsch",
          "Diezel",
          "Dilla",
          "Dingelstedt",
          "Dippl",
          "Dittmann",
          "Dittmar",
          "Dittmer",
          "Dix",
          "Dobbrunz",
          "Dobler",
          "Dohring",
          "Dolch",
          "Dold",
          "Dombrowski",
          "Donie",
          "Doskoczynski",
          "Dragu",
          "Drechsler",
          "Drees",
          "Dreher",
          "Dreier",
          "Dreissigacker",
          "Dressler",
          "Drews",
          "Duma",
          "Dutkiewicz",
          "Dyett",
          "Dylus",
          "Dächert",
          "Döbel",
          "Döring",
          "Dörner",
          "Dörre",
          "Dück",
          "Eberhard",
          "Eberhardt",
          "Ecker",
          "Eckhardt",
          "Edorh",
          "Effler",
          "Eggenmueller",
          "Ehm",
          "Ehmann",
          "Ehrig",
          "Eich",
          "Eifert",
          "Einert",
          "Eisenlauer",
          "Ekpo",
          "Elbe",
          "Eleyth",
          "Elss",
          "Emert",
          "Emmelmann",
          "Ender",
          "Engel",
          "Engelen",
          "Engelmann",
          "Eplinius",
          "Erdmann",
          "Erhardt",
          "Erlei",
          "Erm",
          "Ernst",
          "Ertl",
          "Erwes",
          "Esenwein",
          "Esser",
          "Evers",
          "Everts",
          "Ewald",
          "Fahner",
          "Faller",
          "Falter",
          "Farber",
          "Fassbender",
          "Faulhaber",
          "Fehrig",
          "Feld",
          "Felke",
          "Feller",
          "Fenner",
          "Fenske",
          "Feuerbach",
          "Fietz",
          "Figl",
          "Figura",
          "Filipowski",
          "Filsinger",
          "Fincke",
          "Fink",
          "Finke",
          "Fischer",
          "Fitschen",
          "Fleischer",
          "Fleischmann",
          "Floder",
          "Florczak",
          "Flore",
          "Flottmann",
          "Forkel",
          "Forst",
          "Frahmeke",
          "Frank",
          "Franke",
          "Franta",
          "Frantz",
          "Franz",
          "Franzis",
          "Franzmann",
          "Frauen",
          "Frauendorf",
          "Freigang",
          "Freimann",
          "Freimuth",
          "Freisen",
          "Frenzel",
          "Frey",
          "Fricke",
          "Fried",
          "Friedek",
          "Friedenberg",
          "Friedmann",
          "Friedrich",
          "Friess",
          "Frisch",
          "Frohn",
          "Frosch",
          "Fuchs",
          "Fuhlbrügge",
          "Fusenig",
          "Fust",
          "Förster",
          "Gaba",
          "Gabius",
          "Gabler",
          "Gadschiew",
          "Gakstädter",
          "Galander",
          "Gamlin",
          "Gamper",
          "Gangnus",
          "Ganzmann",
          "Garatva",
          "Gast",
          "Gastel",
          "Gatzka",
          "Gauder",
          "Gebhardt",
          "Geese",
          "Gehre",
          "Gehrig",
          "Gehring",
          "Gehrke",
          "Geiger",
          "Geisler",
          "Geissler",
          "Gelling",
          "Gens",
          "Gerbennow",
          "Gerdel",
          "Gerhardt",
          "Gerschler",
          "Gerson",
          "Gesell",
          "Geyer",
          "Ghirmai",
          "Ghosh",
          "Giehl",
          "Gierisch",
          "Giesa",
          "Giesche",
          "Gilde",
          "Glatting",
          "Goebel",
          "Goedicke",
          "Goldbeck",
          "Goldfuss",
          "Goldkamp",
          "Goldkühle",
          "Goller",
          "Golling",
          "Gollnow",
          "Golomski",
          "Gombert",
          "Gotthardt",
          "Gottschalk",
          "Gotz",
          "Goy",
          "Gradzki",
          "Graf",
          "Grams",
          "Grasse",
          "Gratzky",
          "Grau",
          "Greb",
          "Green",
          "Greger",
          "Greithanner",
          "Greschner",
          "Griem",
          "Griese",
          "Grimm",
          "Gromisch",
          "Gross",
          "Grosser",
          "Grossheim",
          "Grosskopf",
          "Grothaus",
          "Grothkopp",
          "Grotke",
          "Grube",
          "Gruber",
          "Grundmann",
          "Gruning",
          "Gruszecki",
          "Gröss",
          "Grötzinger",
          "Grün",
          "Grüner",
          "Gummelt",
          "Gunkel",
          "Gunther",
          "Gutjahr",
          "Gutowicz",
          "Gutschank",
          "Göbel",
          "Göckeritz",
          "Göhler",
          "Görlich",
          "Görmer",
          "Götz",
          "Götzelmann",
          "Güldemeister",
          "Günther",
          "Günz",
          "Gürbig",
          "Haack",
          "Haaf",
          "Habel",
          "Hache",
          "Hackbusch",
          "Hackelbusch",
          "Hadfield",
          "Hadwich",
          "Haferkamp",
          "Hahn",
          "Hajek",
          "Hallmann",
          "Hamann",
          "Hanenberger",
          "Hannecker",
          "Hanniske",
          "Hansen",
          "Hardy",
          "Hargasser",
          "Harms",
          "Harnapp",
          "Harter",
          "Harting",
          "Hartlieb",
          "Hartmann",
          "Hartwig",
          "Hartz",
          "Haschke",
          "Hasler",
          "Hasse",
          "Hassfeld",
          "Haug",
          "Hauke",
          "Haupt",
          "Haverney",
          "Heberstreit",
          "Hechler",
          "Hecht",
          "Heck",
          "Hedermann",
          "Hehl",
          "Heidelmann",
          "Heidler",
          "Heinemann",
          "Heinig",
          "Heinke",
          "Heinrich",
          "Heinze",
          "Heiser",
          "Heist",
          "Hellmann",
          "Helm",
          "Helmke",
          "Helpling",
          "Hengmith",
          "Henkel",
          "Hennes",
          "Henry",
          "Hense",
          "Hensel",
          "Hentel",
          "Hentschel",
          "Hentschke",
          "Hepperle",
          "Herberger",
          "Herbrand",
          "Hering",
          "Hermann",
          "Hermecke",
          "Herms",
          "Herold",
          "Herrmann",
          "Herschmann",
          "Hertel",
          "Herweg",
          "Herwig",
          "Herzenberg",
          "Hess",
          "Hesse",
          "Hessek",
          "Hessler",
          "Hetzler",
          "Heuck",
          "Heydemüller",
          "Hiebl",
          "Hildebrand",
          "Hildenbrand",
          "Hilgendorf",
          "Hillard",
          "Hiller",
          "Hingsen",
          "Hingst",
          "Hinrichs",
          "Hirsch",
          "Hirschberg",
          "Hirt",
          "Hodea",
          "Hoffman",
          "Hoffmann",
          "Hofmann",
          "Hohenberger",
          "Hohl",
          "Hohn",
          "Hohnheiser",
          "Hold",
          "Holdt",
          "Holinski",
          "Holl",
          "Holtfreter",
          "Holz",
          "Holzdeppe",
          "Holzner",
          "Hommel",
          "Honz",
          "Hooss",
          "Hoppe",
          "Horak",
          "Horn",
          "Horna",
          "Hornung",
          "Hort",
          "Howard",
          "Huber",
          "Huckestein",
          "Hudak",
          "Huebel",
          "Hugo",
          "Huhn",
          "Hujo",
          "Huke",
          "Huls",
          "Humbert",
          "Huneke",
          "Huth",
          "Häber",
          "Häfner",
          "Höcke",
          "Höft",
          "Höhne",
          "Hönig",
          "Hördt",
          "Hübenbecker",
          "Hübl",
          "Hübner",
          "Hügel",
          "Hüttcher",
          "Hütter",
          "Ibe",
          "Ihly",
          "Illing",
          "Isak",
          "Isekenmeier",
          "Itt",
          "Jacob",
          "Jacobs",
          "Jagusch",
          "Jahn",
          "Jahnke",
          "Jakobs",
          "Jakubczyk",
          "Jambor",
          "Jamrozy",
          "Jander",
          "Janich",
          "Janke",
          "Jansen",
          "Jarets",
          "Jaros",
          "Jasinski",
          "Jasper",
          "Jegorov",
          "Jellinghaus",
          "Jeorga",
          "Jerschabek",
          "Jess",
          "John",
          "Jonas",
          "Jossa",
          "Jucken",
          "Jung",
          "Jungbluth",
          "Jungton",
          "Just",
          "Jürgens",
          "Kaczmarek",
          "Kaesmacher",
          "Kahl",
          "Kahlert",
          "Kahles",
          "Kahlmeyer",
          "Kaiser",
          "Kalinowski",
          "Kallabis",
          "Kallensee",
          "Kampf",
          "Kampschulte",
          "Kappe",
          "Kappler",
          "Karhoff",
          "Karrass",
          "Karst",
          "Karsten",
          "Karus",
          "Kass",
          "Kasten",
          "Kastner",
          "Katzinski",
          "Kaufmann",
          "Kaul",
          "Kausemann",
          "Kawohl",
          "Kazmarek",
          "Kedzierski",
          "Keil",
          "Keiner",
          "Keller",
          "Kelm",
          "Kempe",
          "Kemper",
          "Kempter",
          "Kerl",
          "Kern",
          "Kesselring",
          "Kesselschläger",
          "Kette",
          "Kettenis",
          "Keutel",
          "Kick",
          "Kiessling",
          "Kinadeter",
          "Kinzel",
          "Kinzy",
          "Kirch",
          "Kirst",
          "Kisabaka",
          "Klaas",
          "Klabuhn",
          "Klapper",
          "Klauder",
          "Klaus",
          "Kleeberg",
          "Kleiber",
          "Klein",
          "Kleinert",
          "Kleininger",
          "Kleinmann",
          "Kleinsteuber",
          "Kleiss",
          "Klemme",
          "Klimczak",
          "Klinger",
          "Klink",
          "Klopsch",
          "Klose",
          "Kloss",
          "Kluge",
          "Kluwe",
          "Knabe",
          "Kneifel",
          "Knetsch",
          "Knies",
          "Knippel",
          "Knobel",
          "Knoblich",
          "Knoll",
          "Knorr",
          "Knorscheidt",
          "Knut",
          "Kobs",
          "Koch",
          "Kochan",
          "Kock",
          "Koczulla",
          "Koderisch",
          "Koehl",
          "Koehler",
          "Koenig",
          "Koester",
          "Kofferschlager",
          "Koha",
          "Kohle",
          "Kohlmann",
          "Kohnle",
          "Kohrt",
          "Koj",
          "Kolb",
          "Koleiski",
          "Kolokas",
          "Komoll",
          "Konieczny",
          "Konig",
          "Konow",
          "Konya",
          "Koob",
          "Kopf",
          "Kosenkow",
          "Koster",
          "Koszewski",
          "Koubaa",
          "Kovacs",
          "Kowalick",
          "Kowalinski",
          "Kozakiewicz",
          "Krabbe",
          "Kraft",
          "Kral",
          "Kramer",
          "Krauel",
          "Kraus",
          "Krause",
          "Krauspe",
          "Kreb",
          "Krebs",
          "Kreissig",
          "Kresse",
          "Kreutz",
          "Krieger",
          "Krippner",
          "Krodinger",
          "Krohn",
          "Krol",
          "Kron",
          "Krueger",
          "Krug",
          "Kruger",
          "Krull",
          "Kruschinski",
          "Krämer",
          "Kröckert",
          "Kröger",
          "Krüger",
          "Kubera",
          "Kufahl",
          "Kuhlee",
          "Kuhnen",
          "Kulimann",
          "Kulma",
          "Kumbernuss",
          "Kummle",
          "Kunz",
          "Kupfer",
          "Kupprion",
          "Kuprion",
          "Kurnicki",
          "Kurrat",
          "Kurschilgen",
          "Kuschewitz",
          "Kuschmann",
          "Kuske",
          "Kustermann",
          "Kutscherauer",
          "Kutzner",
          "Kwadwo",
          "Kähler",
          "Käther",
          "Köhler",
          "Köhrbrück",
          "Köhre",
          "Kölotzei",
          "König",
          "Köpernick",
          "Köseoglu",
          "Kúhn",
          "Kúhnert",
          "Kühn",
          "Kühnel",
          "Kühnemund",
          "Kühnert",
          "Kühnke",
          "Küsters",
          "Küter",
          "Laack",
          "Lack",
          "Ladewig",
          "Lakomy",
          "Lammert",
          "Lamos",
          "Landmann",
          "Lang",
          "Lange",
          "Langfeld",
          "Langhirt",
          "Lanig",
          "Lauckner",
          "Lauinger",
          "Laurén",
          "Lausecker",
          "Laux",
          "Laws",
          "Lax",
          "Leberer",
          "Lehmann",
          "Lehner",
          "Leibold",
          "Leide",
          "Leimbach",
          "Leipold",
          "Leist",
          "Leiter",
          "Leiteritz",
          "Leitheim",
          "Leiwesmeier",
          "Lenfers",
          "Lenk",
          "Lenz",
          "Lenzen",
          "Leo",
          "Lepthin",
          "Lesch",
          "Leschnik",
          "Letzelter",
          "Lewin",
          "Lewke",
          "Leyckes",
          "Lg",
          "Lichtenfeld",
          "Lichtenhagen",
          "Lichtl",
          "Liebach",
          "Liebe",
          "Liebich",
          "Liebold",
          "Lieder",
          "Lienshöft",
          "Linden",
          "Lindenberg",
          "Lindenmayer",
          "Lindner",
          "Linke",
          "Linnenbaum",
          "Lippe",
          "Lipske",
          "Lipus",
          "Lischka",
          "Lobinger",
          "Logsch",
          "Lohmann",
          "Lohre",
          "Lohse",
          "Lokar",
          "Loogen",
          "Lorenz",
          "Losch",
          "Loska",
          "Lott",
          "Loy",
          "Lubina",
          "Ludolf",
          "Lufft",
          "Lukoschek",
          "Lutje",
          "Lutz",
          "Löser",
          "Löwa",
          "Lübke",
          "Maak",
          "Maczey",
          "Madetzky",
          "Madubuko",
          "Mai",
          "Maier",
          "Maisch",
          "Malek",
          "Malkus",
          "Mallmann",
          "Malucha",
          "Manns",
          "Manz",
          "Marahrens",
          "Marchewski",
          "Margis",
          "Markowski",
          "Marl",
          "Marner",
          "Marquart",
          "Marschek",
          "Martel",
          "Marten",
          "Martin",
          "Marx",
          "Marxen",
          "Mathes",
          "Mathies",
          "Mathiszik",
          "Matschke",
          "Mattern",
          "Matthes",
          "Matula",
          "Mau",
          "Maurer",
          "Mauroff",
          "May",
          "Maybach",
          "Mayer",
          "Mebold",
          "Mehl",
          "Mehlhorn",
          "Mehlorn",
          "Meier",
          "Meisch",
          "Meissner",
          "Meloni",
          "Melzer",
          "Menga",
          "Menne",
          "Mensah",
          "Mensing",
          "Merkel",
          "Merseburg",
          "Mertens",
          "Mesloh",
          "Metzger",
          "Metzner",
          "Mewes",
          "Meyer",
          "Michallek",
          "Michel",
          "Mielke",
          "Mikitenko",
          "Milde",
          "Minah",
          "Mintzlaff",
          "Mockenhaupt",
          "Moede",
          "Moedl",
          "Moeller",
          "Moguenara",
          "Mohr",
          "Mohrhard",
          "Molitor",
          "Moll",
          "Moller",
          "Molzan",
          "Montag",
          "Moormann",
          "Mordhorst",
          "Morgenstern",
          "Morhelfer",
          "Moritz",
          "Moser",
          "Motchebon",
          "Motzenbbäcker",
          "Mrugalla",
          "Muckenthaler",
          "Mues",
          "Muller",
          "Mulrain",
          "Mächtig",
          "Mäder",
          "Möcks",
          "Mögenburg",
          "Möhsner",
          "Möldner",
          "Möllenbeck",
          "Möller",
          "Möllinger",
          "Mörsch",
          "Mühleis",
          "Müller",
          "Münch",
          "Nabein",
          "Nabow",
          "Nagel",
          "Nannen",
          "Nastvogel",
          "Nau",
          "Naubert",
          "Naumann",
          "Ne",
          "Neimke",
          "Nerius",
          "Neubauer",
          "Neubert",
          "Neuendorf",
          "Neumair",
          "Neumann",
          "Neupert",
          "Neurohr",
          "Neuschwander",
          "Newton",
          "Ney",
          "Nicolay",
          "Niedermeier",
          "Nieklauson",
          "Niklaus",
          "Nitzsche",
          "Noack",
          "Nodler",
          "Nolte",
          "Normann",
          "Norris",
          "Northoff",
          "Nowak",
          "Nussbeck",
          "Nwachukwu",
          "Nytra",
          "Nöh",
          "Oberem",
          "Obergföll",
          "Obermaier",
          "Ochs",
          "Oeser",
          "Olbrich",
          "Onnen",
          "Ophey",
          "Oppong",
          "Orth",
          "Orthmann",
          "Oschkenat",
          "Osei",
          "Osenberg",
          "Ostendarp",
          "Ostwald",
          "Otte",
          "Otto",
          "Paesler",
          "Pajonk",
          "Pallentin",
          "Panzig",
          "Paschke",
          "Patzwahl",
          "Paukner",
          "Peselman",
          "Peter",
          "Peters",
          "Petzold",
          "Pfeiffer",
          "Pfennig",
          "Pfersich",
          "Pfingsten",
          "Pflieger",
          "Pflügner",
          "Philipp",
          "Pichlmaier",
          "Piesker",
          "Pietsch",
          "Pingpank",
          "Pinnock",
          "Pippig",
          "Pitschugin",
          "Plank",
          "Plass",
          "Platzer",
          "Plauk",
          "Plautz",
          "Pletsch",
          "Plotzitzka",
          "Poehn",
          "Poeschl",
          "Pogorzelski",
          "Pohl",
          "Pohland",
          "Pohle",
          "Polifka",
          "Polizzi",
          "Pollmächer",
          "Pomp",
          "Ponitzsch",
          "Porsche",
          "Porth",
          "Poschmann",
          "Poser",
          "Pottel",
          "Prah",
          "Prange",
          "Prediger",
          "Pressler",
          "Preuk",
          "Preuss",
          "Prey",
          "Priemer",
          "Proske",
          "Pusch",
          "Pöche",
          "Pöge",
          "Raabe",
          "Rabenstein",
          "Rach",
          "Radtke",
          "Rahn",
          "Ranftl",
          "Rangen",
          "Ranz",
          "Rapp",
          "Rath",
          "Rau",
          "Raubuch",
          "Raukuc",
          "Rautenkranz",
          "Rehwagen",
          "Reiber",
          "Reichardt",
          "Reichel",
          "Reichling",
          "Reif",
          "Reifenrath",
          "Reimann",
          "Reinberg",
          "Reinelt",
          "Reinhardt",
          "Reinke",
          "Reitze",
          "Renk",
          "Rentz",
          "Renz",
          "Reppin",
          "Restle",
          "Restorff",
          "Retzke",
          "Reuber",
          "Reumann",
          "Reus",
          "Reuss",
          "Reusse",
          "Rheder",
          "Rhoden",
          "Richards",
          "Richter",
          "Riedel",
          "Riediger",
          "Rieger",
          "Riekmann",
          "Riepl",
          "Riermeier",
          "Riester",
          "Riethmüller",
          "Rietmüller",
          "Rietscher",
          "Ringel",
          "Ringer",
          "Rink",
          "Ripken",
          "Ritosek",
          "Ritschel",
          "Ritter",
          "Rittweg",
          "Ritz",
          "Roba",
          "Rockmeier",
          "Rodehau",
          "Rodowski",
          "Roecker",
          "Roggatz",
          "Rohländer",
          "Rohrer",
          "Rokossa",
          "Roleder",
          "Roloff",
          "Roos",
          "Rosbach",
          "Roschinsky",
          "Rose",
          "Rosenauer",
          "Rosenbauer",
          "Rosenthal",
          "Rosksch",
          "Rossberg",
          "Rossler",
          "Roth",
          "Rother",
          "Ruch",
          "Ruckdeschel",
          "Rumpf",
          "Rupprecht",
          "Ruth",
          "Ryjikh",
          "Ryzih",
          "Rädler",
          "Räntsch",
          "Rödiger",
          "Röse",
          "Röttger",
          "Rücker",
          "Rüdiger",
          "Rüter",
          "Sachse",
          "Sack",
          "Saflanis",
          "Sagafe",
          "Sagonas",
          "Sahner",
          "Saile",
          "Sailer",
          "Salow",
          "Salzer",
          "Salzmann",
          "Sammert",
          "Sander",
          "Sarvari",
          "Sattelmaier",
          "Sauer",
          "Sauerland",
          "Saumweber",
          "Savoia",
          "Scc",
          "Schacht",
          "Schaefer",
          "Schaffarzik",
          "Schahbasian",
          "Scharf",
          "Schedler",
          "Scheer",
          "Schelk",
          "Schellenbeck",
          "Schembera",
          "Schenk",
          "Scherbarth",
          "Scherer",
          "Schersing",
          "Scherz",
          "Scheurer",
          "Scheuring",
          "Scheytt",
          "Schielke",
          "Schieskow",
          "Schildhauer",
          "Schilling",
          "Schima",
          "Schimmer",
          "Schindzielorz",
          "Schirmer",
          "Schirrmeister",
          "Schlachter",
          "Schlangen",
          "Schlawitz",
          "Schlechtweg",
          "Schley",
          "Schlicht",
          "Schlitzer",
          "Schmalzle",
          "Schmid",
          "Schmidt",
          "Schmidtchen",
          "Schmitt",
          "Schmitz",
          "Schmuhl",
          "Schneider",
          "Schnelting",
          "Schnieder",
          "Schniedermeier",
          "Schnürer",
          "Schoberg",
          "Scholz",
          "Schonberg",
          "Schondelmaier",
          "Schorr",
          "Schott",
          "Schottmann",
          "Schouren",
          "Schrader",
          "Schramm",
          "Schreck",
          "Schreiber",
          "Schreiner",
          "Schreiter",
          "Schroder",
          "Schröder",
          "Schuermann",
          "Schuff",
          "Schuhaj",
          "Schuldt",
          "Schult",
          "Schulte",
          "Schultz",
          "Schultze",
          "Schulz",
          "Schulze",
          "Schumacher",
          "Schumann",
          "Schupp",
          "Schuri",
          "Schuster",
          "Schwab",
          "Schwalm",
          "Schwanbeck",
          "Schwandke",
          "Schwanitz",
          "Schwarthoff",
          "Schwartz",
          "Schwarz",
          "Schwarzer",
          "Schwarzkopf",
          "Schwarzmeier",
          "Schwatlo",
          "Schweisfurth",
          "Schwennen",
          "Schwerdtner",
          "Schwidde",
          "Schwirkschlies",
          "Schwuchow",
          "Schäfer",
          "Schäffel",
          "Schäffer",
          "Schäning",
          "Schöckel",
          "Schönball",
          "Schönbeck",
          "Schönberg",
          "Schönebeck",
          "Schönenberger",
          "Schönfeld",
          "Schönherr",
          "Schönlebe",
          "Schötz",
          "Schüler",
          "Schüppel",
          "Schütz",
          "Schütze",
          "Seeger",
          "Seelig",
          "Sehls",
          "Seibold",
          "Seidel",
          "Seiders",
          "Seigel",
          "Seiler",
          "Seitz",
          "Semisch",
          "Senkel",
          "Sewald",
          "Siebel",
          "Siebert",
          "Siegling",
          "Sielemann",
          "Siemon",
          "Siener",
          "Sievers",
          "Siewert",
          "Sihler",
          "Sillah",
          "Simon",
          "Sinnhuber",
          "Sischka",
          "Skibicki",
          "Sladek",
          "Slotta",
          "Smieja",
          "Soboll",
          "Sokolowski",
          "Soller",
          "Sollner",
          "Sommer",
          "Somssich",
          "Sonn",
          "Sonnabend",
          "Spahn",
          "Spank",
          "Spelmeyer",
          "Spiegelburg",
          "Spielvogel",
          "Spinner",
          "Spitzmüller",
          "Splinter",
          "Sporrer",
          "Sprenger",
          "Spöttel",
          "Stahl",
          "Stang",
          "Stanger",
          "Stauss",
          "Steding",
          "Steffen",
          "Steffny",
          "Steidl",
          "Steigauf",
          "Stein",
          "Steinecke",
          "Steinert",
          "Steinkamp",
          "Steinmetz",
          "Stelkens",
          "Stengel",
          "Stengl",
          "Stenzel",
          "Stepanov",
          "Stephan",
          "Stern",
          "Steuk",
          "Stief",
          "Stifel",
          "Stoll",
          "Stolle",
          "Stolz",
          "Storl",
          "Storp",
          "Stoutjesdijk",
          "Stratmann",
          "Straub",
          "Strausa",
          "Streck",
          "Streese",
          "Strege",
          "Streit",
          "Streller",
          "Strieder",
          "Striezel",
          "Strogies",
          "Strohschank",
          "Strunz",
          "Strutz",
          "Stube",
          "Stöckert",
          "Stöppler",
          "Stöwer",
          "Stürmer",
          "Suffa",
          "Sujew",
          "Sussmann",
          "Suthe",
          "Sutschet",
          "Swillims",
          "Szendrei",
          "Sören",
          "Sürth",
          "Tafelmeier",
          "Tang",
          "Tasche",
          "Taufratshofer",
          "Tegethof",
          "Teichmann",
          "Tepper",
          "Terheiden",
          "Terlecki",
          "Teufel",
          "Theele",
          "Thieke",
          "Thimm",
          "Thiomas",
          "Thomas",
          "Thriene",
          "Thränhardt",
          "Thust",
          "Thyssen",
          "Thöne",
          "Tidow",
          "Tiedtke",
          "Tietze",
          "Tilgner",
          "Tillack",
          "Timmermann",
          "Tischler",
          "Tischmann",
          "Tittman",
          "Tivontschik",
          "Tonat",
          "Tonn",
          "Trampeli",
          "Trauth",
          "Trautmann",
          "Travan",
          "Treff",
          "Tremmel",
          "Tress",
          "Tsamonikian",
          "Tschiers",
          "Tschirch",
          "Tuch",
          "Tucholke",
          "Tudow",
          "Tuschmo",
          "Tächl",
          "Többen",
          "Töpfer",
          "Uhlemann",
          "Uhlig",
          "Uhrig",
          "Uibel",
          "Uliczka",
          "Ullmann",
          "Ullrich",
          "Umbach",
          "Umlauft",
          "Umminger",
          "Unger",
          "Unterpaintner",
          "Urban",
          "Urbaniak",
          "Urbansky",
          "Urhig",
          "Vahlensieck",
          "Van",
          "Vangermain",
          "Vater",
          "Venghaus",
          "Verniest",
          "Verzi",
          "Vey",
          "Viellehner",
          "Vieweg",
          "Voelkel",
          "Vogel",
          "Vogelgsang",
          "Vogt",
          "Voigt",
          "Vokuhl",
          "Volk",
          "Volker",
          "Volkmann",
          "Von",
          "Vona",
          "Vontein",
          "Wachenbrunner",
          "Wachtel",
          "Wagner",
          "Waibel",
          "Wakan",
          "Waldmann",
          "Wallner",
          "Wallstab",
          "Walter",
          "Walther",
          "Walton",
          "Walz",
          "Wanner",
          "Wartenberg",
          "Waschbüsch",
          "Wassilew",
          "Wassiluk",
          "Weber",
          "Wehrsen",
          "Weidlich",
          "Weidner",
          "Weigel",
          "Weight",
          "Weiler",
          "Weimer",
          "Weis",
          "Weiss",
          "Weller",
          "Welsch",
          "Welz",
          "Welzel",
          "Weniger",
          "Wenk",
          "Werle",
          "Werner",
          "Werrmann",
          "Wessel",
          "Wessinghage",
          "Weyel",
          "Wezel",
          "Wichmann",
          "Wickert",
          "Wiebe",
          "Wiechmann",
          "Wiegelmann",
          "Wierig",
          "Wiese",
          "Wieser",
          "Wilhelm",
          "Wilky",
          "Will",
          "Willwacher",
          "Wilts",
          "Wimmer",
          "Winkelmann",
          "Winkler",
          "Winter",
          "Wischek",
          "Wischer",
          "Wissing",
          "Wittich",
          "Wittl",
          "Wolf",
          "Wolfarth",
          "Wolff",
          "Wollenberg",
          "Wollmann",
          "Woytkowska",
          "Wujak",
          "Wurm",
          "Wyludda",
          "Wölpert",
          "Wöschler",
          "Wühn",
          "Wünsche",
          "Zach",
          "Zaczkiewicz",
          "Zahn",
          "Zaituc",
          "Zandt",
          "Zanner",
          "Zapletal",
          "Zauber",
          "Zeidler",
          "Zekl",
          "Zender",
          "Zeuch",
          "Zeyen",
          "Zeyhle",
          "Ziegler",
          "Zimanyi",
          "Zimmer",
          "Zimmermann",
          "Zinser",
          "Zintl",
          "Zipp",
          "Zipse",
          "Zschunke",
          "Zuber",
          "Zwiener",
          "Zümsande",
          "Östringer",
          "Überacker"
        ],
        "male_first_name": [
          "Aaron",
          "Abdul",
          "Abdullah",
          "Adam",
          "Adrian",
          "Adriano",
          "Ahmad",
          "Ahmed",
          "Ahmet",
          "Alan",
          "Albert",
          "Alessandro",
          "Alessio",
          "Alex",
          "Alexander",
          "Alfred",
          "Ali",
          "Amar",
          "Amir",
          "Amon",
          "Andre",
          "Andreas",
          "Andrew",
          "Angelo",
          "Ansgar",
          "Anthony",
          "Anton",
          "Antonio",
          "Arda",
          "Arian",
          "Armin",
          "Arne",
          "Arno",
          "Arthur",
          "Artur",
          "Arved",
          "Arvid",
          "Ayman",
          "Baran",
          "Baris",
          "Bastian",
          "Batuhan",
          "Bela",
          "Ben",
          "Benedikt",
          "Benjamin",
          "Bennet",
          "Bennett",
          "Benno",
          "Bent",
          "Berat",
          "Berkay",
          "Bernd",
          "Bilal",
          "Bjarne",
          "Björn",
          "Bo",
          "Boris",
          "Brandon",
          "Brian",
          "Bruno",
          "Bryan",
          "Burak",
          "Calvin",
          "Can",
          "Carl",
          "Carlo",
          "Carlos",
          "Carsten",
          "Caspar",
          "Cedric",
          "Cedrik",
          "Cem",
          "Charlie",
          "Chris",
          "Christian",
          "Christiano",
          "Christoph",
          "Christopher",
          "Claas",
          "Clemens",
          "Colin",
          "Collin",
          "Conner",
          "Connor",
          "Constantin",
          "Corvin",
          "Curt",
          "Damian",
          "Damien",
          "Daniel",
          "Danilo",
          "Danny",
          "Darian",
          "Dario",
          "Darius",
          "Darren",
          "David",
          "Davide",
          "Davin",
          "Dean",
          "Deniz",
          "Dennis",
          "Denny",
          "Devin",
          "Diego",
          "Dion",
          "Domenic",
          "Domenik",
          "Dominic",
          "Dominik",
          "Dorian",
          "Dustin",
          "Dylan",
          "Ecrin",
          "Eddi",
          "Eddy",
          "Edgar",
          "Edwin",
          "Efe",
          "Ege",
          "Elia",
          "Eliah",
          "Elias",
          "Elijah",
          "Emanuel",
          "Emil",
          "Emilian",
          "Emilio",
          "Emir",
          "Emirhan",
          "Emre",
          "Enes",
          "Enno",
          "Enrico",
          "Eren",
          "Eric",
          "Erik",
          "Etienne",
          "Fabian",
          "Fabien",
          "Fabio",
          "Fabrice",
          "Falk",
          "Felix",
          "Ferdinand",
          "Fiete",
          "Filip",
          "Finlay",
          "Finley",
          "Finn",
          "Finnley",
          "Florian",
          "Francesco",
          "Franz",
          "Frederic",
          "Frederick",
          "Frederik",
          "Friedrich",
          "Fritz",
          "Furkan",
          "Fynn",
          "Gabriel",
          "Georg",
          "Gerrit",
          "Gian",
          "Gianluca",
          "Gino",
          "Giuliano",
          "Giuseppe",
          "Gregor",
          "Gustav",
          "Hagen",
          "Hamza",
          "Hannes",
          "Hanno",
          "Hans",
          "Hasan",
          "Hassan",
          "Hauke",
          "Hendrik",
          "Hennes",
          "Henning",
          "Henri",
          "Henrick",
          "Henrik",
          "Henry",
          "Hugo",
          "Hussein",
          "Ian",
          "Ibrahim",
          "Ilias",
          "Ilja",
          "Ilyas",
          "Immanuel",
          "Ismael",
          "Ismail",
          "Ivan",
          "Iven",
          "Jack",
          "Jacob",
          "Jaden",
          "Jakob",
          "Jamal",
          "James",
          "Jamie",
          "Jan",
          "Janek",
          "Janis",
          "Janne",
          "Jannek",
          "Jannes",
          "Jannik",
          "Jannis",
          "Jano",
          "Janosch",
          "Jared",
          "Jari",
          "Jarne",
          "Jarno",
          "Jaron",
          "Jason",
          "Jasper",
          "Jay",
          "Jayden",
          "Jayson",
          "Jean",
          "Jens",
          "Jeremias",
          "Jeremie",
          "Jeremy",
          "Jermaine",
          "Jerome",
          "Jesper",
          "Jesse",
          "Jim",
          "Jimmy",
          "Joe",
          "Joel",
          "Joey",
          "Johann",
          "Johannes",
          "John",
          "Johnny",
          "Jon",
          "Jona",
          "Jonah",
          "Jonas",
          "Jonathan",
          "Jonte",
          "Joost",
          "Jordan",
          "Joris",
          "Joscha",
          "Joschua",
          "Josef",
          "Joseph",
          "Josh",
          "Joshua",
          "Josua",
          "Juan",
          "Julian",
          "Julien",
          "Julius",
          "Juri",
          "Justin",
          "Justus",
          "Kaan",
          "Kai",
          "Kalle",
          "Karim",
          "Karl",
          "Karlo",
          "Kay",
          "Keanu",
          "Kenan",
          "Kenny",
          "Keno",
          "Kerem",
          "Kerim",
          "Kevin",
          "Kian",
          "Kilian",
          "Kim",
          "Kimi",
          "Kjell",
          "Klaas",
          "Klemens",
          "Konrad",
          "Konstantin",
          "Koray",
          "Korbinian",
          "Kurt",
          "Lars",
          "Lasse",
          "Laurence",
          "Laurens",
          "Laurenz",
          "Laurin",
          "Lean",
          "Leander",
          "Leandro",
          "Leif",
          "Len",
          "Lenn",
          "Lennard",
          "Lennart",
          "Lennert",
          "Lennie",
          "Lennox",
          "Lenny",
          "Leo",
          "Leon",
          "Leonard",
          "Leonardo",
          "Leonhard",
          "Leonidas",
          "Leopold",
          "Leroy",
          "Levent",
          "Levi",
          "Levin",
          "Lewin",
          "Lewis",
          "Liam",
          "Lian",
          "Lias",
          "Lino",
          "Linus",
          "Lio",
          "Lion",
          "Lionel",
          "Logan",
          "Lorenz",
          "Lorenzo",
          "Loris",
          "Louis",
          "Luan",
          "Luc",
          "Luca",
          "Lucas",
          "Lucian",
          "Lucien",
          "Ludwig",
          "Luis",
          "Luiz",
          "Luk",
          "Luka",
          "Lukas",
          "Luke",
          "Lutz",
          "Maddox",
          "Mads",
          "Magnus",
          "Maik",
          "Maksim",
          "Malik",
          "Malte",
          "Manuel",
          "Marc",
          "Marcel",
          "Marco",
          "Marcus",
          "Marek",
          "Marian",
          "Mario",
          "Marius",
          "Mark",
          "Marko",
          "Markus",
          "Marlo",
          "Marlon",
          "Marten",
          "Martin",
          "Marvin",
          "Marwin",
          "Mateo",
          "Mathis",
          "Matis",
          "Mats",
          "Matteo",
          "Mattes",
          "Matthias",
          "Matthis",
          "Matti",
          "Mattis",
          "Maurice",
          "Max",
          "Maxim",
          "Maximilian",
          "Mehmet",
          "Meik",
          "Melvin",
          "Merlin",
          "Mert",
          "Michael",
          "Michel",
          "Mick",
          "Miguel",
          "Mika",
          "Mikail",
          "Mike",
          "Milan",
          "Milo",
          "Mio",
          "Mirac",
          "Mirco",
          "Mirko",
          "Mohamed",
          "Mohammad",
          "Mohammed",
          "Moritz",
          "Morten",
          "Muhammed",
          "Murat",
          "Mustafa",
          "Nathan",
          "Nathanael",
          "Nelson",
          "Neo",
          "Nevio",
          "Nick",
          "Niclas",
          "Nico",
          "Nicolai",
          "Nicolas",
          "Niels",
          "Nikita",
          "Niklas",
          "Niko",
          "Nikolai",
          "Nikolas",
          "Nils",
          "Nino",
          "Noah",
          "Noel",
          "Norman",
          "Odin",
          "Oke",
          "Ole",
          "Oliver",
          "Omar",
          "Onur",
          "Oscar",
          "Oskar",
          "Pascal",
          "Patrice",
          "Patrick",
          "Paul",
          "Peer",
          "Pepe",
          "Peter",
          "Phil",
          "Philip",
          "Philipp",
          "Pierre",
          "Piet",
          "Pit",
          "Pius",
          "Quentin",
          "Quirin",
          "Rafael",
          "Raik",
          "Ramon",
          "Raphael",
          "Rasmus",
          "Raul",
          "Rayan",
          "René",
          "Ricardo",
          "Riccardo",
          "Richard",
          "Rick",
          "Rico",
          "Robert",
          "Robin",
          "Rocco",
          "Roman",
          "Romeo",
          "Ron",
          "Ruben",
          "Ryan",
          "Said",
          "Salih",
          "Sam",
          "Sami",
          "Sammy",
          "Samuel",
          "Sandro",
          "Santino",
          "Sascha",
          "Sean",
          "Sebastian",
          "Selim",
          "Semih",
          "Shawn",
          "Silas",
          "Simeon",
          "Simon",
          "Sinan",
          "Sky",
          "Stefan",
          "Steffen",
          "Stephan",
          "Steve",
          "Steven",
          "Sven",
          "Sönke",
          "Sören",
          "Taha",
          "Tamino",
          "Tammo",
          "Tarik",
          "Tayler",
          "Taylor",
          "Teo",
          "Theo",
          "Theodor",
          "Thies",
          "Thilo",
          "Thomas",
          "Thorben",
          "Thore",
          "Thorge",
          "Tiago",
          "Til",
          "Till",
          "Tillmann",
          "Tim",
          "Timm",
          "Timo",
          "Timon",
          "Timothy",
          "Tino",
          "Titus",
          "Tizian",
          "Tjark",
          "Tobias",
          "Tom",
          "Tommy",
          "Toni",
          "Tony",
          "Torben",
          "Tore",
          "Tristan",
          "Tyler",
          "Tyron",
          "Umut",
          "Uwe",
          "Valentin",
          "Valentino",
          "Veit",
          "Victor",
          "Viktor",
          "Vin",
          "Vincent",
          "Vito",
          "Vitus",
          "Wilhelm",
          "Willi",
          "William",
          "Willy",
          "Xaver",
          "Yannic",
          "Yannick",
          "Yannik",
          "Yannis",
          "Yasin",
          "Youssef",
          "Yunus",
          "Yusuf",
          "Yven",
          "Yves",
          "Ömer"
        ],
        "name": [
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}-#{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "41"
        ],
        "formats": [
          "## ### ## ##",
          "0800 ### ###",
          "0800 ## ## ##",
          "0## ### ## ##",
          "0## ### ## ##",
          "## ### ## ##",
          "0900 ### ###",
          "076 ### ## ##",
          "78 ### ## ##",
          "0041 ## ### ## ##"
        ]
      },
      "simpsons": {
        "characters": [
          "Homer Simpson",
          "Marge Simpson",
          "Bart Simpson",
          "Lisa Simpson",
          "Maggie Simpson",
          "Grampa Simpson",
          "Abraham Jedediah \"Abe\" Simpson",
          "Patty Bouvier",
          "Selma Bouvier",
          "Mona Bouvier",
          "Charles Montgomery Burns",
          "Waylon Smithers",
          "Lenford \"Lenny\" Leonard",
          "Carl Carlson",
          "Charlie",
          "Ned Flanders",
          "Maude Flanders",
          "Rod Flanders",
          "Todd Flanders",
          "Janey Powell",
          "Ralph Wiggum",
          "Becky",
          "Alison Taylor",
          "Database",
          "Lewis",
          "Martin Prince",
          "Milhouse van Houten",
          "Nelson Muntz",
          "Richard",
          "Jaffee",
          "Melissa",
          "Sherri",
          "Terri",
          "Wendell Borton",
          "Dolphin Starbeam",
          "Jimbo Jones",
          "Kearney Zzyzwicz",
          "Uter Zörker",
          "Rektor Seymour Skinner",
          "Oberschulrat Chalmers",
          "Edna Krabappel",
          "Elizabeth Hoover",
          "Dewey Largo",
          "Sportlehrer Mr. Krupt",
          "Dr. J. Loren Pryor",
          "Hausmeister Willie",
          "Küchenhilfe Doris Peterson",
          "Otto Mann",
          "Krusty der Clown",
          "Herschel Krustofski",
          "Sideshow Raheem",
          "Tingeltangel-Bob",
          "Tingeltangel-Mel",
          "Mr. Teeny",
          "Bubbles",
          "Itchy",
          "Scratchy",
          "Bienenmann",
          "Scott Christian",
          "Kent Brockman",
          "Arnie Pye",
          "Rainier Wolfcastle",
          "Troy McClure",
          "Lurleen Lumpkin",
          "Duffman",
          "Chief Clancy Wiggum",
          "Lou",
          "Eddie",
          "Comicbuchverkäufer",
          "Roger Meyers Junior",
          "Artie Ziff",
          "Horatio McCallister",
          "Alter Kapitän",
          "Lothar Folkman",
          "Luigi Risotto",
          "Aristotle Amadopolis",
          "Herman",
          "Lindsay Naegle",
          "Cookie Kwan",
          "Dr. Julius Hibbert",
          "Dr. Nick Riviera",
          "Dr. Marvin Monroe",
          "Jasper Beardley",
          "Ralph Melish",
          "Hans Maulwurf",
          "Asa",
          "Mrs. Glick",
          "Sylvia Winfield",
          "Mr. Winfield",
          "Morris \"Moe\" Szyslak",
          "Barney Gumble",
          "Sam",
          "Larry",
          "Akira",
          "Joseph Quimby",
          "Freddy Quimby",
          "Mary Bailey",
          "Roy Snyder",
          "Constance Harm",
          "Lionel Hutz",
          "Blauhaariger Anwalt",
          "Gil Gunderson",
          "Der alte Gil",
          "In der Kirche",
          "Reverend Timothy Lovejoy",
          "Helen Lovejoy",
          "Jessica Lovejoy",
          "Anthony \"Fat Tony\" D'Amico",
          "Legs",
          "Louie",
          "Johnny",
          "Schmallippe",
          "Jacques Brunswick",
          "Disco Stu",
          "Eleanor Abernathy",
          "Katzenlady",
          "Prof. Frink",
          "Kirk van Houten",
          "Luann van Houten",
          "Shauna Tifton",
          "Prinzessin Kashmir",
          "Snake",
          "Jeremy Peterson",
          "Agnes Skinner",
          "Cletus Spuckler",
          "Brandine Spuckler",
          "Mary Spuckler",
          "Apu Nahasapeemapetilon",
          "Manjula Nahasapeemapetilon",
          "Zahnfleischbluter Murphy",
          "Reicher Texaner",
          "Hyman Krustofski",
          "Laura Powers",
          "Ruth Powers",
          "Drederick Tatum",
          "Kang",
          "Kodos"
        ]
      },
      "space": {
        "agency": [
          "National Aeronautics and Space Administration",
          "European Space Agency",
          "Deutsches Zentrum für Luft- und Raumfahrt",
          "Indian Space Research Organization",
          "China National Space Administration",
          "UK Space Agency",
          "Brazilian Space Agency",
          "Mexican Space Agency",
          "Israeli Space Agency",
          "Italian Space Agency",
          "Japan Aerospace Exploration Agency",
          "National Space Agency of Ukraine",
          "Russian Federal Space Agency",
          "Swedish National Space Board"
        ],
        "constellation": [
          "Achterdeck",
          "Adler",
          "Altar",
          "Andromeda",
          "Bärenhüter",
          "Becher",
          "Bildhauer",
          "Chamäleon",
          "Chemischer",
          "Delphin",
          "Drache",
          "Dreieck",
          "Eidechse",
          "Einhorn",
          "Eridanus",
          "Fische",
          "Fliege",
          "Fliegender",
          "Fuchs",
          "Fuhrmann",
          "Füllen",
          "Giraffe",
          "Grabstichel",
          "Grosser",
          "Grosser",
          "Haar",
          "Hase",
          "Herkules",
          "Indianer",
          "Jagdhunde",
          "Jungfrau",
          "Kassiopeia",
          "Kepheus",
          "Kiel",
          "Kleine",
          "Kleiner",
          "Kleiner",
          "Kleiner",
          "Kranich",
          "Krebs",
          "Kreuz",
          "Leier",
          "Löwe",
          "Luchs",
          "Luftpumpe",
          "Maler",
          "Mikroskop",
          "Netz",
          "Nördliche",
          "Oktant",
          "Orion",
          "Paradiesvogel",
          "Pegasus",
          "Pendeluhr",
          "Perseus",
          "Pfau",
          "Pfeil",
          "Phönix",
          "Rabe",
          "Schiffskompass",
          "Schild",
          "Schlange",
          "Schlangenträger",
          "Schütze",
          "Schwan",
          "Schwertfisch",
          "Segel",
          "Sextant",
          "Skorpion",
          "Steinbock",
          "Stier",
          "Südliche",
          "Südlicher",
          "Südliches",
          "Tafelberg",
          "Taube",
          "Teleskop",
          "Tukan",
          "Waage",
          "Walfisch",
          "Wassermann",
          "Wasserschlange",
          "Widder",
          "Winkelmass",
          "Wolf",
          "Zentaur",
          "Zirkel",
          "Zwillinge"
        ],
        "distance_measurement": [
          "Lichtjahre",
          "AE",
          "Parsec",
          "Kiloparsec",
          "Megaparsec"
        ],
        "galaxy": [
          "Andromeda I",
          "Andromeda II",
          "Andromeda III",
          "Andromeda IX",
          "Andromeda V",
          "Andromeda VI",
          "Andromeda VII",
          "Andromeda VIII",
          "Andromeda X",
          "Andromeda XI",
          "Andromeda XII",
          "Andromeda XIII",
          "Andromeda XIV",
          "Andromeda XIX",
          "Andromeda XV",
          "Andromeda XVI",
          "Andromeda XVII",
          "Andromeda XVIII",
          "Andromeda XX",
          "Andromeda XXI",
          "Andromeda XXII",
          "Andromeda XXIII",
          "Andromeda XXIV",
          "Andromeda XXIX",
          "Andromeda XXV",
          "Andromeda XXVI",
          "Andromeda XXVII",
          "Andromeda XXVIII",
          "Andromedagalaxie",
          "Antlia-Zwerg",
          "Aquarius-Zwerg",
          "Barnards Galaxie",
          "Bootes-I-Zwerg",
          "Bootes-II-Zwerg",
          "Bootes-III-Zwerg",
          "Canes Venatici-I-Zwerg",
          "Canes-Venatici-II-Zwerg",
          "Canis-Major-Zwerg",
          "Carina-Zwerg",
          "Cetus-Zwerg",
          "Coma-Berenices-Zwerggalaxie",
          "Draco-Zwerg",
          "Dreiecksnebel",
          "Fornax-Zwerg",
          "Grosse Magellansche Wolke",
          "Hercules-Zwerg",
          "IC 10",
          "IC 1613",
          "Kleine Magellansche Wolke",
          "Leo I",
          "Leo II",
          "Leo III",
          "Leo IV",
          "Leo V",
          "LGS 3",
          "M110",
          "M32",
          "Milchstrasse",
          "NGC 147",
          "NGC 185",
          "NGC 3109",
          "Pegasus-Zwerg",
          "Phoenix-Zwerg",
          "Pisces II",
          "SagDIG",
          "Sagittarius-Zwerggalaxie",
          "Sculptor-Zwerg",
          "Segue 2",
          "Sextans A",
          "Sextans B",
          "Sextans-Zwerg",
          "Tucana-Zwerg",
          "Ursa-Major-I",
          "Ursa Major II",
          "Ursa-Minor-Zwerg",
          "Wolf-Lundmark-Melotte"
        ],
        "moon": [
          "Mond",
          "Adrastea",
          "Aegaeon",
          "Aegir",
          "Aitne",
          "Albiorix",
          "Amalthea",
          "Ananke",
          "Anthe",
          "Aoede",
          "Arche",
          "Ariel",
          "Atlas",
          "Autonoe",
          "Bebhionn",
          "Belinda",
          "Bergelmir",
          "Bestla",
          "Bianca",
          "Caliban",
          "Callirrhoe",
          "Calypso",
          "Carme",
          "Carpo",
          "Chaldene",
          "Charon",
          "Cordelia",
          "Cressida",
          "Cupid",
          "Cyllene",
          "Daphnis",
          "Deimos",
          "Desdemona",
          "Despina",
          "Dione",
          "Dysnomia",
          "Elara",
          "Enceladus",
          "Epimetheus",
          "Erinome",
          "Erriapus",
          "Euanthe",
          "Eukelade",
          "Euporie",
          "Europa",
          "Eurydome",
          "Farbauti",
          "Fenrir",
          "Ferdinand",
          "Fornjot",
          "Francisco",
          "Galatea",
          "Ganymed",
          "Greip",
          "Halimede",
          "Harpalyke",
          "Hati",
          "Hegemone",
          "Helene",
          "Helike",
          "Hermippe",
          "Herse",
          "Himalia",
          "Hiʻiaka",
          "Hydra",
          "Hyperion",
          "Hyrrokkin",
          "Iapetus",
          "Ijiraq",
          "Io",
          "Iocaste",
          "Isonoe",
          "Janus",
          "Jarnsaxa",
          "Juliet",
          "Kale",
          "Kallichore",
          "Kallisto",
          "Kalyke",
          "Kari",
          "Kerberos",
          "Kiviuq",
          "Kore",
          "Laomedeia",
          "Larissa",
          "Leda",
          "Loge",
          "Lysithea",
          "Mab",
          "Margaret",
          "Megaclite",
          "Methone",
          "Metis",
          "Mimas",
          "Miranda",
          "Mneme",
          "Mundilfari",
          "Naiad",
          "Namaka",
          "Narvi",
          "Nereid",
          "Neso",
          "Nix",
          "Oberon",
          "Ophelia",
          "Orthosie",
          "Paaliaq",
          "Pallene",
          "Pan",
          "Pandora",
          "Pasiphae",
          "Pasithee",
          "Perdita",
          "Phobos",
          "Phoebe",
          "Polydeuces",
          "Portia",
          "Praxidike",
          "Prometheus",
          "Prospero",
          "Proteus",
          "Psamathe",
          "Puck",
          "Rhea",
          "Rosalind",
          "Sao",
          "Setebos",
          "Siarnaq",
          "Sinope",
          "Skathi",
          "Skoll",
          "Sponde",
          "Stephano",
          "Styx",
          "Surtur",
          "Suttungr",
          "Sycorax",
          "Tarqeq",
          "Tarvos",
          "Taygete",
          "Telesto",
          "Tethys",
          "Thalassa",
          "Thebe",
          "Thelxinoe",
          "Themisto",
          "Thrymr",
          "Thyone",
          "Titan",
          "Titania",
          "Trinculo",
          "Triton",
          "Umbriel",
          "Ymir"
        ],
        "nebula": [
          "Blauer Schneeball",
          "Blinking Planetary",
          "Blue Flash Nebula",
          "Blue Planetary Nebula",
          "Bowtie Nebula",
          "Box Nebula",
          "Bumerangnebel",
          "Camel's Eye",
          "Cleopatra’s Eye",
          "Emerald Nebula",
          "Eskimonebel",
          "Eulennebel",
          "Hantelnebel",
          "Helixnebel",
          "Jupiters Geist",
          "Käfer-Nebel",
          "Katzenaugennebel",
          "Kleiner Hantelnebel",
          "Little Gem Nebula",
          "Little Ghost Nebula",
          "Magic Carpet Nebula",
          "Medusanebel",
          "Phantom Streak Nebula",
          "Retinanebel",
          "Ringnebel",
          "Roter Rechtecknebel",
          "Roter Spinnennebel",
          "Saturnnebel",
          "Schildkrötennebel",
          "Schmetterlingsnebel",
          "Skull Nebula",
          "Snowglobe Nebula",
          "Spiral Planetary Nebula",
          "Spirographnebel",
          "Stechrochennebel",
          "Stundenglasnebel",
          "Südlicher Krebsnebel",
          "Südlicher Ringnebel"
        ],
        "planet": [
          "Merkur",
          "Venus",
          "Erde",
          "Mars",
          "Jupiter",
          "Saturn",
          "Uranus",
          "Neptun"
        ],
        "star": [
          "Acamar",
          "Achernar",
          "Achird",
          "Acrux",
          "Acubens",
          "Adhara",
          "Adhil",
          "Agena",
          "Ain",
          "Akrab",
          "Al Kalb al Rai",
          "Al Minliar al Asad",
          "Aladfar",
          "Alamak",
          "Alasco",
          "Alathfar",
          "Albaldah",
          "Albali",
          "Albireo",
          "Alchiba",
          "Alcyone",
          "Aldebaran",
          "Alderamin",
          "Aldhafera",
          "Aldhanab",
          "Aldhibah",
          "Alfecca Meridiana",
          "Alfirk",
          "Algenib",
          "Algieba",
          "Algiedi",
          "Algol",
          "Algorab",
          "Alhena",
          "Alioth",
          "Alkaid",
          "Alkalurops",
          "Al Kaphrah",
          "Alkes",
          "Alkione",
          "Alkor",
          "Alkurah",
          "Al Kurud",
          "Almaaz",
          "Al Nair",
          "Alnasl",
          "Alnilam",
          "Alnitak",
          "Alniyat",
          "Alpha Centauri",
          "Alphard",
          "Alphecca",
          "Alpheratz",
          "Alrakis",
          "Alrischa",
          "Alsafi",
          "Alschain",
          "Alshat",
          "Alsciaukat",
          "Altarf",
          "Altair",
          "Altais",
          "Alterf",
          "Al Thalimain Posterior",
          "Al Thalimain Prior",
          "Aludra",
          "Alula Australi",
          "Alula Borealis",
          "Alwaid",
          "Alya",
          "Alzir",
          "Ancha",
          "Angetenar",
          "Ankaa",
          "Antares",
          "Anser",
          "Anwar Al Farkadain",
          "Arcturus",
          "Arkab Prior",
          "Arkab Posterior",
          "Arm",
          "Arneb",
          "Arrakis",
          "Asellus Australis",
          "Asellus Borealis",
          "Asellus Primus",
          "Asellus Secundus",
          "Asellus Tertius",
          "Askella",
          "Aspidiske",
          "Asterion",
          "Asterope",
          "Atik",
          "Atlas",
          "Atria",
          "Avior",
          "Azaleh",
          "Azelfafage",
          "Azha",
          "Azmidiske",
          "Baham",
          "Barnards Pfeilstern",
          "Baten Kaitos",
          "Becrux",
          "Beid",
          "Bellatrix",
          "Benetnasch",
          "Beteigeuze",
          "Betria",
          "Bharani",
          "Bogardus",
          "Botein",
          "Brachium",
          "Bunda",
          "Canopus",
          "Caph",
          "Capella",
          "Castor",
          "Cebalrai",
          "Ceginus",
          "Celaeno",
          "Cervantes",
          "Chalawan",
          "Chara",
          "Chertan",
          "Chow",
          "Copernicus",
          "Cor Caroli",
          "Cursa",
          "Dabih",
          "Decrux",
          "Deneb",
          "Deneb Algedi",
          "Deneb Algenubi",
          "Deneb Dulfim",
          "Deneb el Okab Australis",
          "Deneb el Okab Borealis",
          "Deneb Kaitos",
          "Deneb Kaitos Schemali",
          "Denebola",
          "Dheneb",
          "Diadem",
          "Diphda",
          "Dschubba",
          "Dubhe",
          "Duhr",
          "Edasich",
          "Elektra",
          "Elmuthalleth",
          "Elnath",
          "Elscheratain",
          "Enif",
          "Errai",
          "Etamin",
          "Fafnir",
          "Fomalhaut",
          "Fum al Samakah",
          "Furud",
          "Gacrux",
          "Gatria",
          "Gemma",
          "Gianfar",
          "Giedi",
          "Gienah",
          "Gienah",
          "Girtab",
          "Gomeisa",
          "Gorgonea Secunda",
          "Gorgonea Tertia",
          "Gorgonea Quarta",
          "Graffias",
          "Granatstern",
          "Grumium",
          "Hadar",
          "Hadir",
          "Haedus",
          "Haldus",
          "Hamal",
          "Han",
          "Hassaleh",
          "Hatysa",
          "Head of Hydrus",
          "Heka",
          "Helvetios",
          "Heze",
          "Homam",
          "Hyadum I",
          "Hyadum II",
          "Intercrus",
          "Izar",
          "Jabbah",
          "Jih",
          "Kaffaljidhm",
          "Kajam",
          "Kapteyns Stern",
          "Kastra",
          "Kaus Australis",
          "Kaus Borealis",
          "Kaus Medius",
          "Keid",
          "Kitalpha",
          "Kochab",
          "Kornephoros",
          "Kraz",
          "Ksora",
          "Kullat Nunu",
          "Kuma",
          "La Superba",
          "Lesath",
          "Libertas",
          "Lukida",
          "Lukida Anseris",
          "Luytens Stern",
          "Maasym",
          "Maia",
          "Marfark",
          "Marfik",
          "Markab",
          "Matar",
          "Mebsuta",
          "Megrez",
          "Mekbuda",
          "Meissa",
          "Menkalinan",
          "Menkar",
          "Menkent",
          "Menchib",
          "Merak",
          "Merga",
          "Merope",
          "Mesarthim",
          "Miaplacidus",
          "Minchir",
          "Minelava",
          "Minkar",
          "Mintaka",
          "Mira",
          "Mirach",
          "Miram",
          "Mirfak",
          "Mirzam",
          "Misam",
          "Mizar",
          "Mothallah",
          "Mufrid",
          "Muliphein",
          "Murzim",
          "Muscida",
          "Musica",
          "Nair Al Saif",
          "Naos",
          "Nash",
          "Nashira",
          "Navi",
          "Nembus",
          "Nekkar",
          "Nihal",
          "Nunki",
          "Nusakan",
          "Ogma",
          "Okul",
          "Peacock",
          "Phakt",
          "Phekda",
          "Pherkad",
          "Pherkard",
          "Pistolenstern",
          "Pleione",
          "Polaris Australis",
          "Polarstern",
          "Pollux",
          "Porrima",
          "Praecipua",
          "Prijipati",
          "Prokyon",
          "Propus",
          "Proxima Centauri",
          "Ran",
          "Rana",
          "Rasalas",
          "Ras Algethi",
          "Ras Alhague",
          "Ras Elased Australis",
          "Rastaban",
          "Regor",
          "Regulus",
          "Rigel",
          "Rigil Kentaurus",
          "Rijl al Awwa",
          "Rotanev",
          "Ruchbah",
          "Rukbat",
          "Sabik",
          "Sadachbia",
          "Sadalbari",
          "Sadalmelik",
          "Sadalsuud",
          "Sadr",
          "Saiph",
          "Salm",
          "Sargas",
          "Sarin",
          "Sarir",
          "Sceptrum",
          "Scheat",
          "Scheddi",
          "Schedir",
          "Segin",
          "Seginus",
          "Sham",
          "Sheliak",
          "Sheratan",
          "Shaula",
          "Skat",
          "Sirius",
          "Sirrah",
          "Situla",
          "Spica",
          "Sonne",
          "Sterope",
          "Sualocin",
          "Subra",
          "Suhail",
          "Sulafat",
          "Syrma",
          "Tabit",
          "Talitha Australis",
          "Talitha Borealis",
          "Tania Australis",
          "Tania Borealis",
          "Tarazed",
          "Taygeta",
          "Teegardens Stern",
          "Tegmen",
          "Terebellum",
          "Tejat Posterior",
          "Tejat Prior",
          "Thabit",
          "Theemin",
          "Thuban",
          "Tien Kuan",
          "Titawin",
          "Toliman",
          "Tonatiuh",
          "Torcularis Septentrionalis",
          "Tseen Kee",
          "Turais",
          "Rho Puppis",
          "Tyl",
          "Unukalhai",
          "Van Maanens Stern",
          "Veritate",
          "Vindemiatrix",
          "Wasat",
          "Wega",
          "Wei",
          "Wezen",
          "Yed Prior",
          "Yed Posterior",
          "Zaniah",
          "Zaurak",
          "Zavijava",
          "Zibal",
          "Zosma",
          "Zuben-el-Akrab",
          "Zuben-el-Akribi",
          "Zuben-el-dschenubi",
          "Zuben-el-schemali"
        ],
        "star_cluster": [
          "Chi Persei",
          "Coma-Berenices-Haufen",
          "Eulenhaufen",
          "Hyaden",
          "Herkuleshaufen",
          "Kleiderbügelhaufen",
          "Kleiner Skorpion",
          "Krippe",
          "Intergalaktischer Wanderer",
          "Muskelmännchen",
          "Omega Centauri",
          "Plejaden",
          "Praesepe",
          "Ptolomaeus Sternhaufen",
          "Schmetterlingshaufen",
          "Schmuckkästchen",
          "Siebengestirn",
          "Südliche Plejaden",
          "Tucanae",
          "Weihnachtsbaum-Sternhaufen",
          "Wildentenhaufen"
        ]
      },
      "university": {
        "name": [
          "#{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{University.suffix} #{Address.city}",
          "#{University.suffix} #{Address.city}"
        ],
        "prefix": [
          "Technische"
        ],
        "suffix": [
          "Universität",
          "Hochschule"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Bitte wählen"
      },
      "submit": {
        "create": "%{model} erstellen",
        "submit": "%{model} speichern",
        "update": "%{model} aktualisieren"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": "'",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "CHF"
        }
      },
      "format": {
        "delimiter": "'",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "Milliarde",
              "other": "Milliarden"
            },
            "million": {
              "one": "Million",
              "other": "Millionen"
            },
            "quadrillion": {
              "one": "Billiarde",
              "other": "Billiarden"
            },
            "thousand": "Tausend",
            "trillion": {
              "one": "Billion",
              "other": "Billionen"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " und ",
        "two_words_connector": " und ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "vormittags",
      "formats": {
        "default": "%A, %d. %B %Y, %H:%M Uhr",
        "long": "%A, %d. %B %Y, %H:%M Uhr",
        "short": "%d. %b, %H:%M Uhr"
      },
      "pm": "nachmittags"
    }
  },
  "de-DE": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Datensatz kann nicht gelöscht werden, da abhängige %{record} existieren.",
            "has_one": "Datensatz kann nicht gelöscht werden, da ein abhängiger %{record}-Datensatz existiert."
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "day_names": [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "etwa eine Stunde",
          "other": "etwa %{count} Stunden"
        },
        "about_x_months": {
          "one": "etwa ein Monat",
          "other": "etwa %{count} Monate"
        },
        "about_x_years": {
          "one": "etwa ein Jahr",
          "other": "etwa %{count} Jahre"
        },
        "almost_x_years": {
          "one": "fast ein Jahr",
          "other": "fast %{count} Jahre"
        },
        "half_a_minute": "eine halbe Minute",
        "less_than_x_minutes": {
          "one": "weniger als eine Minute",
          "other": "weniger als %{count} Minuten"
        },
        "less_than_x_seconds": {
          "one": "weniger als eine Sekunde",
          "other": "weniger als %{count} Sekunden"
        },
        "over_x_years": {
          "one": "mehr als ein Jahr",
          "other": "mehr als %{count} Jahre"
        },
        "x_days": {
          "one": "ein Tag",
          "other": "%{count} Tage"
        },
        "x_minutes": {
          "one": "eine Minute",
          "other": "%{count} Minuten"
        },
        "x_months": {
          "one": "ein Monat",
          "other": "%{count} Monate"
        },
        "x_seconds": {
          "one": "eine Sekunde",
          "other": "%{count} Sekunden"
        }
      },
      "prompts": {
        "day": "Tag",
        "hour": "Stunde",
        "minute": "Minute",
        "month": "Monat",
        "second": "Sekunde",
        "year": "Jahr"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "muss akzeptiert werden",
        "blank": "muss ausgefüllt werden",
        "confirmation": "stimmt nicht mit %{attribute} überein",
        "empty": "muss ausgefüllt werden",
        "equal_to": "muss genau %{count} sein",
        "even": "muss gerade sein",
        "exclusion": "ist nicht verfügbar",
        "greater_than": "muss größer als %{count} sein",
        "greater_than_or_equal_to": "muss größer oder gleich %{count} sein",
        "inclusion": "ist kein gültiger Wert",
        "invalid": "ist nicht gültig",
        "less_than": "muss kleiner als %{count} sein",
        "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
        "model_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
        "not_a_number": "ist keine Zahl",
        "not_an_integer": "muss ganzzahlig sein",
        "odd": "muss ungerade sein",
        "other_than": "darf nicht gleich %{count} sein",
        "password_too_long": "ist zu lang",
        "present": "darf nicht ausgefüllt werden",
        "required": "muss ausgefüllt werden",
        "taken": "ist bereits vergeben",
        "too_long": {
          "one": "ist zu lang (mehr als %{count} Zeichen)",
          "other": "ist zu lang (mehr als %{count} Zeichen)"
        },
        "too_short": {
          "one": "ist zu kurz (weniger als %{count} Zeichen)",
          "other": "ist zu kurz (weniger als %{count} Zeichen)"
        },
        "wrong_length": {
          "one": "hat die falsche Länge (muss genau %{count} Zeichen haben)",
          "other": "hat die falsche Länge (muss genau %{count} Zeichen haben)"
        }
      },
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Bitte wählen"
      },
      "submit": {
        "create": "%{model} erstellen",
        "submit": "%{model} speichern",
        "update": "%{model} aktualisieren"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "Milliarde",
              "other": "Milliarden"
            },
            "million": {
              "one": "Million",
              "other": "Millionen"
            },
            "quadrillion": {
              "one": "Billiarde",
              "other": "Billiarden"
            },
            "thousand": "Tausend",
            "trillion": {
              "one": "Billion",
              "other": "Billionen"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " und ",
        "two_words_connector": " und ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "vormittags",
      "formats": {
        "default": "%A, %d. %B %Y, %H:%M Uhr",
        "long": "%A, %d. %B %Y, %H:%M Uhr",
        "short": "%d. %b, %H:%M Uhr"
      },
      "pm": "nachmittags"
    }
  },
  "dz": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "ཆ་འཇོག་འཐུས་ཤོར་ཡི་: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "ཡིག་ཐོ་ %{record} བརྟེན་ཏེ་ཡོད་པ་ལས་བཏོན་གཏང་མི་བཏུབ་",
            "has_one": "ཡིག་ཐོ་ %{record} བརྟེན་ཏེ་ཡོད་པ་ལས་བཏོན་གཏང་མི་བཏུབ་"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "གཟའ་ཟླཝ",
        "གཟའ་མིག་དམར",
        "གཟའ་ལྷགཔ",
        "གཟའ་ཕུརཔ",
        "གཟའ་པ་སངས",
        "གཟའ་སྤེན་པ",
        "གཟའ་ཉིམ"
      ],
      "abbr_month_names": [
        null,
        "ཟླཝ་དང་པ",
        "ཟླཝ་གཉིས་པ",
        "ཟླཝ་གསུམ་པ",
        "ཟླཝ་བཞི་པ",
        "ཟླཝ་ལྔ་པ",
        "ཟླཝ་དྲུག་པ",
        "ཟླཝ་བདུན་པ",
        "ཟླཝ་བརྒྱད་པ",
        "ཟླཝ་དགུ་པ",
        "ཟླཝ་བཅུ་པ",
        "ཟླཝ་བཅུ་གཅིག་པ",
        "ཟླཝ་བཅུ་གཉིས་པ"
      ],
      "day_names": [
        "གཟའ་ཟླཝ",
        "གཟའ་མིག་དམར",
        "གཟའ་ལྷག་པ",
        "གཟའ་ཕུརཔ",
        "གཟའ་པ་སངས",
        "གཟའ་སྤེན་པ",
        "གཟའ་ཉི་མ"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "ཟླཝ་དང་པ",
        "ཟླཝ་གཉིས་པ",
        "ཟླཝ་གསུམ་པ",
        "ཟླཝ་བཞི་པ",
        "ཟླཝ་ལྔ་པ",
        "ཟླཝ་དྲུག་པ",
        "ཟླཝ་བདུན་པ",
        "ཟླཝ་བརྒྱད་པ",
        "ཟླཝ་དགུ་པ",
        "ཟླཝ་བཅུ་པ",
        "ཟླཝ་བཅུ་གཅིག་པ",
        "ཟླཝ་བཅུ་གཉིས་པ"
      ],
      "order": [
        "ལོ",
        "ཟླཝ",
        "ཉིནམ"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ཆུ་ཚོད་ ༡ ་དེ་ཅིག",
          "other": "ཆུ་ཚོད་ %{count} དེ་ཅིག"
        },
        "about_x_months": {
          "one": "ཟླཝ་ ༡ ་དེ་ཅིག",
          "other": "ཟླཝ་ %{count} དེ་ཅིག"
        },
        "about_x_years": {
          "one": "ལོ་ ༡ ་དེ་ཅིག",
          "other": "ལོ་ %{count} དེ་ཅིག"
        },
        "almost_x_years": "ལོ %{count} མ་ལྷགཔ་ཅིག",
        "half_a_minute": "སྐར་མ་ཕྱེད་ཀ",
        "less_than_x_minutes": {
          "one": "སྐར་མ་ ༡ ་ལས་ཉུངམ",
          "other": "སྐར་མ %{count} ལས་ཉུངམ"
        },
        "less_than_x_seconds": {
          "one": "སྐར་ཆ་ ༡ ་ལས་ཉུངམ",
          "other": "སྐར་ཆ %{count} ལས་ཉུངམ"
        },
        "over_x_years": {
          "one": "ལོ་ ༡ ་ལྷག",
          "other": "ལོ་%{count}ལས་ལྷག"
        },
        "x_days": {
          "one": "ཉིནམ་གཅིག",
          "other": "ཉིནམ %{count}"
        },
        "x_minutes": {
          "one": "སྐར་མ་གཅིག",
          "other": "སྐར་མ %{count}"
        },
        "x_months": {
          "one": "ཟླཝ་གཅིག",
          "other": "ཟླཝ %{count}"
        },
        "x_seconds": {
          "one": "སྐར་ཆ་གཅིག",
          "other": "སྐར་ཆ %{count}"
        },
        "x_years": {
          "one": "ལོ་གཅིག",
          "other": "ལོ %{count}"
        }
      },
      "prompts": {
        "day": "ཉིནམ",
        "hour": "ཆུ་ཚོད",
        "minute": "སྐར་མ",
        "month": "ཟླཝ",
        "second": "སྐར་ཆ",
        "year": "ལོ"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ངོས་ལན་འབད་དགོ",
        "blank": "སྟོང་པ་མི་བཏུབ",
        "confirmation": "%{attribute} དང་ཅོག་འཐོད་མིན་འདུག",
        "empty": "སྟོངམ་མི་བཏུབ",
        "equal_to": "%{count} དང་འདྲ་མཉམ་དགོ",
        "even": "འདྲན་འདྲ་དགོ",
        "exclusion": "ཟུར་གསོག",
        "greater_than": "%{count} ལས་སྦོམ་དགོ",
        "greater_than_or_equal_to": "%{count} ལས་མང་སུ་ཡང་ན་འདྲན་འདྲ་དགོ",
        "inclusion": "ཐོ་ཡིག་གི་གྲངས་སུ་མིན་འདུག",
        "invalid": "ཆ་མེད་ཨིན",
        "less_than": "%{count} ལས་ཉུང་སུ་ཅིག་དགོ",
        "less_than_or_equal_to": "%{count} ལས་ཉུང་སུ་ཡང་ན་འདྲན་འདྲ་དགོ",
        "model_invalid": "ཆ་འཇོག་འཐུས་ཤོར་ཡི: %{errors}",
        "not_a_number": "ཨང་གྲངས་མེན",
        "not_an_integer": "ཧྲིལ་གྲངས་དགོ",
        "odd": "ཡ་ཨང་དགོ",
        "other_than": "%{count} ལས་སོ་སོ་ཅིག་དགོ",
        "present": "ས་སྟོང་བཞག་དགོ",
        "required": "དགོ་རང་དགོ",
        "taken": "ཧེ་མ་ལས་འབག་ཚར་ཡི",
        "too_long": {
          "one": "ཡིག་འབྲུ་གནམ་མེད་ས་མེད་རིངམ་ཨིན་མེ་(ཡིག་འབྲུ་མཐོ་ཚད་གཅིག་་ཨིན)",
          "other": "ཡིག་འབྲུ་གནམ་མེད་ས་མེད་རིངམ་ཨིན་མེ་(ཡིག་འབྲུ་མཐོ་ཚད་ %{count} ཨིན)"
        },
        "too_short": {
          "one": "ཡིག་འབྲུ་གནམ་མེད་ས་མེད་ཐུང་སུ་ནུག་(ཡིག་འབྲུ་ཉུང་མཐའ་གཅིག་ཨིན)",
          "other": "ཡིག་འབྲུ་གནམ་མེད་ས་མེད་ཐུང་སུ་ནུག་(ཡིག་འབྲུ་ཉུང་མཐའ་ %{count} ཨིན)"
        },
        "wrong_length": {
          "one": "ཡིག་འབྲུ་འཛུལ་ནུག་(ཡིག་འབྲུ་གཅིག་ངེས་པར་དུ་དགོ)",
          "other": "ཡིག་འབྲུ་འཛུལ་ནུག་(ཡིག་འབྲུ་ %{count} ངེས་པར་དུ་དགོ)"
        }
      },
      "template": {
        "body": "འོག་གི་ས་ཁོངས་ཚུ་ན་བཀའ་ངལ་འདུག",
        "header": {
          "one": "འཛོལ་བ་ཅིག་གིས་ %{model} བསྡུ་བཞག་འབད་ནི་ལུ་བཀག་རྐྱབ་ཅིག",
          "other": "འཛོལ་བ་ %{count} ་གིས་ %{model} འདི་བསྡུ་བཞག་འབད་ནི་ལུ་བཀག་རྐྱབ་ཅིག"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "གདམ་ཁ་རྐྱབ"
      },
      "submit": {
        "create": "%{model} གསར་སྤྲིན་འབད",
        "submit": "%{model} བསྡུ་བཞག་འབད",
        "update": "%{model} དུས་མཐུན་ཁ་གསོ་འབད"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": "༢",
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": "༣",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "ཐེར་འབུམ",
            "million": "ས་ཡ",
            "quadrillion": "Quadrillion",
            "thousand": "སྟོང་ཕྲག",
            "trillion": "ཁྲག་ཁྲིག་ཆེན་པོ",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": "༣",
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", དང ",
        "two_words_connector": " དང ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "དྲོ་པ་གི་ཆུ་ཚོད་་",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "ཕྱི་རུ་གི་ཆུ་ཚོད་"
    }
  },
  "ee": {
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Tallinn",
          "Tartu",
          "Narva",
          "Pärnu",
          "Kohtla-Järve",
          "Viljandi",
          "Rakvere",
          "Maardu",
          "Sillamäe",
          "Kuressaare",
          "Valga",
          "Võru",
          "Haapsalu",
          "Jõhvi",
          "Keila",
          "Põlva",
          "Rapla",
          "Türi",
          "Paide",
          "Tapa",
          "Saue",
          "Elva",
          "Kehra",
          "Kiviõli",
          "Suure-Jaani",
          "Jõgeva",
          "Räpina",
          "Kärdla",
          "Põltsamaa",
          "Otepää",
          "Kilingi-Nõmme",
          "Sindi",
          "Paldiski",
          "Tamsalu",
          "Antsla",
          "Karksi-Nuia",
          "Kunda",
          "Püssi",
          "Narva-Jõesuu",
          "Tõrva",
          "Loksa",
          "Lihula",
          "Abja-Paluoja",
          "Võhma",
          "Mustvee",
          "Kallaste",
          "Mõisaküla"
        ],
        "postcode": [
          "#####"
        ],
        "state": [
          "Harjumaa",
          "Tartumaa",
          "Ida-Virumaa",
          "Pärnumaa",
          "Lääne-Virumaa",
          "Viljandimaa",
          "Raplamaa",
          "Võrumaa",
          "Saaremaa",
          "Jõgevamaa",
          "Järvamaa",
          "Valgamaa",
          "Põlvamaa",
          "Läänemaa",
          "Hiiumaa"
        ],
        "street_address": [
          "#{Name.last_name} #{street_suffix} #{building_number}"
        ],
        "street_name": [
          "#{Name.last_name} #{street_suffix}"
        ],
        "street_suffix": [
          "tee",
          "maantee",
          "tänav",
          "põik"
        ]
      },
      "cell_phone": {
        "formats": [
          "5### ####",
          "5## ####",
          "81## ####",
          "82## ####",
          "83## ####",
          "84## ####"
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{suffix} #{Name.last_name}"
        ],
        "suffix": [
          "AS",
          "OÜ"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "com.ee",
          "ee",
          "net",
          "org"
        ]
      },
      "invoice": {
        "reference": {
          "check_digit_method": "method_731",
          "pattern": "\\d{1,19}#"
        }
      },
      "name": {
        "first_name": [
          "Aabel",
          "Aabraham",
          "Aadu",
          "Aare",
          "Aarne",
          "Aaron",
          "Aavo",
          "Ago",
          "Agu",
          "Ahti",
          "Ahto",
          "Aigar",
          "Ain",
          "Aivar",
          "Aivo",
          "Aksel",
          "Alar",
          "Alari",
          "Albert",
          "Aleks",
          "Aleksander",
          "Allan",
          "Allar",
          "Alo",
          "Alvar",
          "Ando",
          "Andre",
          "Andreas",
          "Andres",
          "Andrus",
          "Anti",
          "Anton",
          "Ants",
          "Ardi",
          "Ardo",
          "Arno",
          "Arnold",
          "Arti",
          "Artur",
          "Arved",
          "Arvi",
          "Arvo",
          "Asko",
          "August",
          "Edgar",
          "Eduard",
          "Eedo",
          "Eedu",
          "Eerik",
          "Eero",
          "Egert",
          "Egon",
          "Einar",
          "Eino",
          "Elias",
          "Elmar",
          "Elmo",
          "Endel",
          "Endrik",
          "Enn",
          "Enno",
          "Ergo",
          "Erik",
          "Erki",
          "Erko",
          "Erlend",
          "Ermo",
          "Evald",
          "Evert",
          "Feliks",
          "Georg",
          "Gert",
          "Gunnar",
          "Gustav",
          "Hannes",
          "Hans",
          "Hardi",
          "Harri",
          "Heigo",
          "Heiki",
          "Heino",
          "Heiti",
          "Hendrik",
          "Henn",
          "Henri",
          "Hillar",
          "Iisak",
          "Illar",
          "Illimar",
          "Ilmar",
          "Ilmo",
          "Imre",
          "Indrek",
          "Innar",
          "Ivar",
          "Ivari",
          "Ivo",
          "Jaagup",
          "Jaak",
          "Jaakob",
          "Jaan",
          "Jaanus",
          "Jakob",
          "Janar",
          "Janek",
          "Janno",
          "Jass",
          "Joel",
          "Johannes",
          "Joona",
          "Joonas",
          "Joonatan",
          "Joosep",
          "Juhan",
          "Juho",
          "Jukk",
          "Juss",
          "Jürgen",
          "Jüri",
          "Jürjo",
          "Kaarel",
          "Kaido",
          "Kajar",
          "Kalev",
          "Kaljo",
          "Kalju",
          "Kalle",
          "Kardo",
          "Karl",
          "Kaspar",
          "Kaupo",
          "Kaur",
          "Kauri",
          "Ken",
          "Kermo",
          "Kert",
          "Kevin",
          "Koit",
          "Kristen",
          "Kristian",
          "Kristjan",
          "Kristo",
          "Kristofer",
          "Kuldar",
          "Kunnar",
          "Kusta",
          "Kustas",
          "Kustav",
          "Küllo",
          "Laur",
          "Lauri",
          "Leevi",
          "Leho",
          "Lembit",
          "Lennart",
          "Luukas",
          "Maanus",
          "Maarjo",
          "Madi",
          "Madis",
          "Magnus",
          "Maido",
          "Mairo",
          "Mait",
          "Marek",
          "Margo",
          "Margus",
          "Mario",
          "Mark",
          "Marko",
          "Markus",
          "Marten",
          "Marti",
          "Martin",
          "Mati",
          "Matteus",
          "Mattias",
          "Meelis",
          "Meeme",
          "Mehis",
          "Mihkel",
          "Miikael",
          "Mikk",
          "Märt",
          "Neeme",
          "Nigul",
          "Nigulas",
          "Niilo",
          "Nuut",
          "Olari",
          "Olavi",
          "Olev",
          "Oliver",
          "Oskar",
          "Ott",
          "Otto",
          "Paavo",
          "Paul",
          "Paulus",
          "Peep",
          "Aada",
          "Aasa",
          "Aet",
          "Age",
          "Agnes",
          "Aile",
          "Aili",
          "Aino",
          "Ainu",
          "Aire",
          "Airi",
          "Aita",
          "Aive",
          "Aleksandra",
          "Alina",
          "Andra",
          "Anete",
          "Angela",
          "Angelika",
          "Ann",
          "Anna",
          "Anne",
          "Anneli",
          "Anni",
          "Annika",
          "Anu",
          "Asta",
          "Astrid",
          "Auli",
          "Aune",
          "Aurelia",
          "Ave",
          "Berit",
          "Birgit",
          "Brita",
          "Dagmar",
          "Diana",
          "Ebe",
          "Eda",
          "Eeva",
          "Eevi",
          "Egle",
          "Eha",
          "Eili",
          "Eliisa",
          "Eliisabet",
          "Eliise",
          "Elina",
          "Elis",
          "Elle",
          "Ellen",
          "Elo",
          "Elvi",
          "Emma",
          "Endla",
          "Ene",
          "Eneli",
          "Epp",
          "Ere",
          "Erika",
          "Esta",
          "Ester",
          "Eva",
          "Eve",
          "Evelin",
          "Gerli",
          "Greete",
          "Grete",
          "Hanna",
          "Hedi",
          "Heidi",
          "Heili",
          "Helbe",
          "Hele",
          "Helen",
          "Helena",
          "Heleri",
          "Helga",
          "Helgi",
          "Heli",
          "Helina",
          "Helju",
          "Helle",
          "Helmi",
          "Helve",
          "Hiie",
          "Hilda",
          "Hilja",
          "Hille",
          "Iiris",
          "Ille",
          "Ilme",
          "Ilona",
          "Imbi",
          "Ines",
          "Inga",
          "Inge",
          "Ingel",
          "Ingrid",
          "Inna",
          "Irene",
          "Iris",
          "Irja",
          "Irma",
          "Ivi",
          "Ivika",
          "Jaana",
          "Jaanika",
          "Jana",
          "Jane",
          "Janne",
          "Johanna",
          "Juta",
          "Kaarin",
          "Kadi",
          "Kadri",
          "Kai",
          "Kaia",
          "Kaidi",
          "Kaie",
          "Kaili",
          "Kairi",
          "Kaisa",
          "Kaja",
          "Karin",
          "Karina",
          "Karmen",
          "Karoliina",
          "Karoliine",
          "Karolin",
          "Katariina",
          "Kati",
          "Katre",
          "Katri",
          "Katriin",
          "Katrin",
          "Keiu",
          "Kelli",
          "Kerli",
          "Kersti",
          "Kerstin",
          "Kertu",
          "Kirke",
          "Koidu",
          "Krista",
          "Kristel",
          "Kristen",
          "Kristi",
          "Kristiina",
          "Kristin",
          "Kristina",
          "Kärt",
          "Kätlin",
          "Külli",
          "Küllike",
          "Lagle",
          "Laine",
          "Laura",
          "Lea",
          "Leelo",
          "Lehte",
          "Leida",
          "Leili",
          "Lembi",
          "Lemme",
          "Lii",
          "Liia",
          "Liidia",
          "Liilia",
          "Liina",
          "Liis",
          "Liisa",
          "Liisbet",
          "Liisi",
          "Liivi",
          "Lilian",
          "Lilli",
          "Linda",
          "Luule",
          "Lüüdia",
          "Maarika",
          "Maarja",
          "Made",
          "Madli",
          "Mai",
          "Maia",
          "Maie",
          "Maila",
          "Maimu",
          "Maire",
          "Malle",
          "Mare",
          "Maret",
          "Margareeta",
          "Margaret",
          "Marge",
          "Margit",
          "Margot",
          "Mari",
          "Mari-Liis"
        ],
        "last_name": [
          "Aare",
          "Aasmäe",
          "Aavik",
          "Allik",
          "Alver",
          "Antson",
          "Eenpalu",
          "Eskola",
          "Härma",
          "Hõbe",
          "Ilves",
          "Ivask",
          "Jänes",
          "Järvekülg",
          "Jääger",
          "Jõgi",
          "Kaasik",
          "Kaljurand",
          "Kangur",
          "Kasak",
          "Kask",
          "Kesküla",
          "Kivi",
          "Koppel",
          "Korjus",
          "Kross",
          "Kukk",
          "Kuuse",
          "Kuusik",
          "Kuusk",
          "Käbin",
          "Kärner",
          "Kõiv",
          "Kütt",
          "Laar",
          "Laur",
          "Leok",
          "Lepik",
          "Levandi",
          "Linna",
          "Luik",
          "Lõhmus",
          "Lõoke",
          "Made",
          "Mark",
          "Masing",
          "Meri",
          "Mädamürk",
          "Mägi",
          "Männik",
          "Naissoo",
          "Nurme",
          "Nurmsalu",
          "Nõmmik",
          "Olesk",
          "Orav",
          "Poska",
          "Puhvel",
          "Pärn",
          "Pääsuke",
          "Raag",
          "Raud",
          "Rebane",
          "Reinsalu",
          "Rootare",
          "Rüütli",
          "Saar",
          "Salumäe",
          "Savisaar",
          "Sepp",
          "Sisask",
          "Soosaar",
          "Taaramae",
          "Tamm",
          "Tammik",
          "Toome",
          "Tätte",
          "Vaher",
          "Vaino",
          "Valdma",
          "Valk",
          "Vesik",
          "Viiding",
          "Vitsut",
          "Välbe",
          "Väljas",
          "Västrik",
          "Võsu",
          "Wahl",
          "Õunapuu",
          "Öpik"
        ],
        "name": [
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ],
        "title": {
          "descriptor": [
            "Lead",
            "Senior",
            "Direct",
            "Corporate",
            "Dynamic",
            "Future",
            "Product",
            "National",
            "Regional",
            "District",
            "Central",
            "Global",
            "Customer",
            "Investor",
            "Dynamic",
            "International",
            "Legacy",
            "Forward",
            "Internal",
            "Human",
            "Chief",
            "Principal"
          ],
          "job": [
            "Supervisor",
            "Associate",
            "Executive",
            "Liaison",
            "Officer",
            "Manager",
            "Engineer",
            "Specialist",
            "Director",
            "Coordinator",
            "Administrator",
            "Architect",
            "Analyst",
            "Designer",
            "Planner",
            "Orchestrator",
            "Technician",
            "Developer",
            "Producer",
            "Consultant",
            "Assistant",
            "Facilitator",
            "Agent",
            "Representative",
            "Strategist"
          ],
          "level": [
            "Solutions",
            "Program",
            "Brand",
            "Security",
            "Research",
            "Marketing",
            "Directives",
            "Implementation",
            "Integration",
            "Functionality",
            "Response",
            "Paradigm",
            "Tactics",
            "Identity",
            "Markets",
            "Group",
            "Division",
            "Applications",
            "Optimization",
            "Operations",
            "Infrastructure",
            "Intranet",
            "Communications",
            "Web",
            "Branding",
            "Quality",
            "Assurance",
            "Mobility",
            "Accounts",
            "Data",
            "Creative",
            "Configuration",
            "Accountability",
            "Interactions",
            "Factors",
            "Usability",
            "Metrics"
          ]
        }
      },
      "phone_number": {
        "formats": [
          "32# ####",
          "33# ####",
          "35# ####",
          "38# ####",
          "39# ####",
          "43# ####",
          "44# ####",
          "45# ####",
          "46# ####",
          "47# ####",
          "48# ####",
          "61# ####",
          "62# ####",
          "63# ####",
          "64# ####",
          "65# ####",
          "66# ####",
          "67# ####",
          "68# ####",
          "69# ####",
          "7## ####",
          "71# ####",
          "72# ####",
          "73# ####",
          "74# ####",
          "75# ####",
          "76# ####",
          "77# ####",
          "78# ####",
          "79# ####",
          "88# ####"
        ]
      }
    }
  },
  "el": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Επιβεβαίωση στάλθηκε",
          "confirmation_token": "Τεκμήριο επιβεβαίωσης",
          "confirmed_at": "Επιβεβαιώθηκε",
          "created_at": "Δημιουργήθηκε",
          "current_password": "Τρέχων κωδικός πρόσβασης",
          "current_sign_in_at": "Τρέχουσα σύνδεση",
          "current_sign_in_ip": "IP τρέχουσας σύνδεσης",
          "email": "Διεύθυνση email",
          "encrypted_password": "Κρυπτογραφημένος κωδικός πρόσβασης",
          "failed_attempts": "Αποτυχημένες προσπάθειες",
          "last_sign_in_at": "Τελευταία σύνδεση",
          "last_sign_in_ip": "IP τελευταίας σύνδεσης",
          "locked_at": "Κλειδώθηκε",
          "password": "Κωδικός πρόσβασης",
          "password_confirmation": "Επιβεβαίωση κωδικού πρόσβασης",
          "remember_created_at": "Απομνημόνευση δημιουργήθηκε",
          "remember_me": "Απομνημόνευση",
          "reset_password_sent_at": "Επαναφορά κωδικού πρόσβασης στάλθηκε",
          "reset_password_token": "Τεκμήριο επαναφοράς κωδικού πρόσβασης",
          "sign_in_count": "Αριθμός συνδέσεων",
          "unconfirmed_email": "Μη επιβεβαιωμένη διεύθυνση email",
          "unlock_token": "Τεκμήριο ξεκλειδώματος",
          "updated_at": "Ενημερώθηκε"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Η επικύρωση απέτυχε: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Η εγγραφή δεν μπορεί να διαγραφεί γιατί υπάρχουν εξαρτημένα %{record}",
            "has_one": "Η εγγραφή δεν μπορεί να διαγραφεί γιατί υπάρχει εξαρτημένο %{record}"
          }
        }
      },
      "models": {
        "user": {
          "one": "Χρήστης",
          "other": "Χρήστης"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Κυρ",
        "Δευ",
        "Τρί",
        "Τετ",
        "Πέμ",
        "Παρ",
        "Σάβ"
      ],
      "abbr_month_names": [
        null,
        "Ιαν",
        "Φεβ",
        "Μαρ",
        "Απρ",
        "Μαϊ",
        "Ιουν",
        "Ιουλ",
        "Αυγ",
        "Σεπ",
        "Οκτ",
        "Νοε",
        "Δεκ"
      ],
      "day_names": [
        "Κυριακή",
        "Δευτέρα",
        "Τρίτη",
        "Τετάρτη",
        "Πέμπτη",
        "Παρασκευή",
        "Σάββατο"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%e %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Ιανουάριος",
        "Φεβρουάριος",
        "Μάρτιος",
        "Απρίλιος",
        "Μάιος",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "περίπου μία ώρα",
          "other": "περίπου %{count} ώρες"
        },
        "about_x_months": {
          "one": "περίπου ένα μήνα",
          "other": "περίπου %{count} μήνες"
        },
        "about_x_years": {
          "one": "περίπου ένα χρόνο",
          "other": "περίπου %{count} χρόνια"
        },
        "almost_x_years": {
          "one": "σχεδόν ένα χρόνο",
          "other": "σχεδόν %{count} χρόνια"
        },
        "half_a_minute": "μισό λεπτό",
        "less_than_x_minutes": {
          "one": "λιγότερο από ένα λεπτό",
          "other": "λιγότερο από %{count} λεπτά"
        },
        "less_than_x_seconds": {
          "one": "λιγότερο από ένα δευτερόλεπτο",
          "other": "λιγότερο από %{count} δευτερόλεπτα"
        },
        "over_x_years": {
          "one": "πάνω από ένα χρόνο",
          "other": "πάνω από %{count} χρόνια"
        },
        "x_days": {
          "one": "%{count} μέρα",
          "other": "%{count} ημέρες"
        },
        "x_minutes": {
          "one": "%{count} λεπτό",
          "other": "%{count} λεπτά"
        },
        "x_months": {
          "one": "%{count} μήνα",
          "other": "%{count} μήνες"
        },
        "x_seconds": {
          "one": "%{count} δευτερόλεπτο",
          "other": "%{count} δευτερόλεπτα"
        },
        "x_years": {
          "one": "%{count} χρόνος",
          "other": "%{count} χρόνια"
        }
      },
      "prompts": {
        "day": "Ημέρα",
        "hour": "Ώρα",
        "minute": "Λεπτό",
        "month": "Μήνας",
        "second": "Δευτερόλεπτο",
        "year": "Έτος"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Η διεύθυνση email σας επιβεβαιώθηκε επιτυχώς",
        "new": {
          "resend_confirmation_instructions": "Επανάληψη αποστολής οδηγιών επιβεβαίωσης"
        },
        "send_instructions": "Θα λάβετε ένα email με οδηγίες για το πώς να επιβεβαιώσετε τη διεύθυνση email σας σε λίγα λεπτά.",
        "send_paranoid_instructions": "Αν η διεύθυνση email σας υπάρχει στη βάση δεδομένων μας, θα λάβετε σε λίγα λεπτά ένα email με οδηγίες για το πώς να επιβεβαιώσετε τη διεύθυνση email σας."
      },
      "failure": {
        "already_authenticated": "Έχετε ήδη συνδεθεί.",
        "inactive": "Ο λογαριασμός σας δεν έχει ενεργοποιηθεί ακόμη.",
        "invalid": "Άκυρο %{authentication_keys} ή κωδικός πρόσβασης.",
        "last_attempt": "Έχετε μία ακόμη προσπάθεια πριν κλειδωθεί ο λογαριασμός σας.",
        "locked": "Ο λογαριασμός σας είναι κλειδωμένος.",
        "not_found_in_database": "Άκυρο %{authentication_keys} ή κωδικός πρόσβασης.",
        "timeout": "Η συνεδρία σας έληξε. Παρακαλώ συνδεθείτε ξανά για να συνεχίσετε.",
        "unauthenticated": "Πρέπει να συνδεθείτε ή να εγγραφείτε πριν συνεχίσετε.",
        "unconfirmed": "Πρέπει να επιβεβαιώσετε τη διεύθυνση email σας πριν συνεχίσετε."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Επιβεβαίωση του λογαριασμού μου",
          "greeting": "Καλώς ήρθατε %{recipient}!",
          "instruction": "Μπορείτε να επιβεβαιώσετε τη διεύθυνση email του λογαριασμού σας μέσω του συνδέσμου παρακάτω:",
          "subject": "Οδηγίες επιβεβαίωσης"
        },
        "email_changed": {
          "greeting": "Γεια σας %{recipient}!",
          "message": "Επικοινωνούμε μαζί σας για να σας ειδοποιήσουμε ότι η διεύθυνση email σας έχει αλλάξει σε %{email}.",
          "message_unconfirmed": "Επικοινωνούμε μαζί σας για να σας ειδοποιήσουμε ότι η διεύθυνση email σας αλλάζει σε %{email}.",
          "subject": "Η διεύθυνση email άλλαξε"
        },
        "password_change": {
          "greeting": "Γεια σας %{recipient}!",
          "message": "Επικοινωνούμε μαζί σας για να σας ειδοποιήσουμε ότι ο κωδικός πρόσβασής σας έχει αλλάξει.",
          "subject": "Ο κωδικός πρόσβασης άλλαξε"
        },
        "reset_password_instructions": {
          "action": "Αλλαγή του κωδικού πρόσβασής μου",
          "greeting": "Γεια σας %{recipient}!",
          "instruction": "Κάποιος έχει αιτηθεί ένα σύνδεσμο για αλλαγή του κωδικού πρόσβασής σας και εσείς μπορείτε να το κάνετε αυτό μέσω του συνδέσμου παρακάτω.",
          "instruction_2": "Αν δεν το ζητήσατε εσείς, παρακαλώ αγνοήστε αυτό το email.",
          "instruction_3": "Ο κωδικός πρόσβασής σας δεν θα αλλάξει μέχρι να χρησιμοποιήσετε τον σύνδεσμο παραπάνω και δημιουργήσετε ένα νέο.",
          "subject": "Οδηγίες επαναφοράς κωδικού"
        },
        "unlock_instructions": {
          "action": "Ξεκλείδωμα του λογαριασμού μου",
          "greeting": "Γεια σας %{recipient}!",
          "instruction": "Πατήστε τον σύνδεσμο παρακάτω για να ξεκλειδώσετε τον λογαριασμό σας:",
          "message": "Ο λογαριασμός σας έχει κλειδωθεί λόγω μεγάλου αριθμού ανεπιτυχών προσπαθειών σύνδεσης.",
          "subject": "Οδηγίες ξεκλειδώματος"
        }
      },
      "omniauth_callbacks": {
        "failure": "Δεν ήταν εφικτή η ταυτοποίησή σας από %{kind} διότι \"%{reason}\".",
        "success": "Ταυτοποιηθήκατε επιτυχώς από λογαριασμό %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Αλλαγή του κωδικού πρόσβασής μου",
          "change_your_password": "Αλλαγή του κωδικού πρόσβασής σας",
          "confirm_new_password": "Επιβεβαίωση νέου κωδικού πρόσβασης",
          "new_password": "Νέος κωδικός πρόσβασης"
        },
        "new": {
          "forgot_your_password": "Ξεχάσατε τον κωδικό πρόσβασής σας;",
          "send_me_reset_password_instructions": "Στείλτε μου οδηγίες επαναφοράς κωδικού πρόσβασης"
        },
        "no_token": "Δεν μπορείτε να προσπελάσετε αυτή τη σελίδα χωρίς να έρχεστε από email επαναφοράς κωδικού. Αν όντως έρχεστε από email επαναφοράς κωδικού, παρακαλώ επιβεβαιώστε ότι χρησιμοποιήσατε ολόκληρη τη διεύθυνση που σας δόθηκε.",
        "send_instructions": "Θα λάβετε ένα email με οδηγίες επαναφοράς του κωδικού πρόσβασής σας σε λίγα λεπτά.",
        "send_paranoid_instructions": "Αν η διεύθυνση email σας υπάρχει στη βάση δεδομένων μας, θα λάβετε μία διεύθυνση ανάκτησης κωδικού πρόσβασης στη διεύθυνση email σας σε λίγα λεπτά.",
        "updated": "Ο κωδικός πρόσβασής σας άλλαξε επιτυχώς. Έχετε πλέον συνδεθεί.",
        "updated_not_active": "Ο κωδικός πρόσβασής σας άλλαξε επιτυχώς."
      },
      "registrations": {
        "destroyed": "Αντίο! Ο λογαριασμός σας ακυρώθηκε επιτυχώς. Ελπίζουμε να σας ξαναδούμε σύντομα.",
        "edit": {
          "are_you_sure": "Είστε σίγουρος/η;",
          "cancel_my_account": "Ακύρωση του λογαρισμού μου",
          "currently_waiting_confirmation_for_email": "Αναμένεται επιβεβαίωση για: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "αφήστε το κενό αν δεν θέλετε να το αλλάξετε",
          "title": "Επεξεργασία %{resource}",
          "unhappy": "Μη ευχαριστημένος/η;",
          "update": "Ενημέρωση",
          "we_need_your_current_password_to_confirm_your_changes": "χρειαζόμαστε τον τρέχων κωδικό πρόσβασής σας για να επιβεβαιώσουμε τις αλλαγές σας"
        },
        "new": {
          "sign_up": "Εγγραφή"
        },
        "signed_up": "Καλώς ήρθατε! Έχετε γραφτεί επιτυχώς.",
        "signed_up_but_inactive": "Έχετε γραφτεί επιτυχώς. Δεν μπορέσαμε όμως να σας συνδέσουμε διότι ο λογαριασμός σας δεν είναι ακόμη ενεργοποιημένος.",
        "signed_up_but_locked": "Έχετε γραφτεί επιτυχώς. Δεν μπορέσαμε όμως να σας συνδέσουμε διότι ο λογαριασμός σας είναι κλειδωμένος.",
        "signed_up_but_unconfirmed": "Ένα μήνυμα με σύνδεσμο επιβεβαίωσης έχει σταλεί στη διεύθυνση email σας. Παρακαλώ ανοίξτε τον σύνδεσμο για να ενεργοποιήσετε τον λογαριασμό σας.",
        "update_needs_confirmation": "Ενημερώσατε τον λογαριασμό σας επιτυχώς, αλλά χρειάζεται να επιβεβαιώσουμε τη νέα διεύθυνση email σας. Παρακαλώ ελέγξτε το email σας και ανοίξτε τον σύνδεσμο επιβεβαίωσης για να επιβεβαιώσετε τη νέα διεύθυνση email σας.",
        "updated": "Ο λογαριασμός σας έχει ενημερωθεί επιτυχώς.",
        "updated_but_not_signed_in": "Ο λογαριασμός σας έχει ενημερωθεί επιτυχώς, αλλά επειδή ο κωδικός σας άλλαξε, χρειάζεται να συνδεθείτε ξανά"
      },
      "sessions": {
        "already_signed_out": "Αποσυνδεθήκατε επιτυχώς.",
        "new": {
          "sign_in": "Σύνδεση"
        },
        "signed_in": "Συνδεθήκατε επιτυχώς.",
        "signed_out": "Αποσυνδεθήκατε επιτυχώς."
      },
      "shared": {
        "links": {
          "back": "Πίσω",
          "didn_t_receive_confirmation_instructions": "Δεν λάβατε οδηγίες επιβεβαίωσης;",
          "didn_t_receive_unlock_instructions": "Δεν λάβατε οδηγίες ξεκλειδώματος;",
          "forgot_your_password": "Ξεχάσατε τον κωδικό πρόσβασής σας;",
          "sign_in": "Σύνδεση",
          "sign_in_with_provider": "Σύνδεση με %{provider}",
          "sign_up": "Εγγραφή"
        },
        "minimum_password_length": {
          "one": "(%{count} χαρακτήρας τουλάχιστον)",
          "other": "(%{count} χαρακτήρες τουλάχιστον)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Επανάληψη αποστολής οδηγιών ξεκλειδώματος"
        },
        "send_instructions": "Θα λάβετε ένα email με οδηγίες για το πώς να ξεκλειδώσετε τον λογαριασμό σας σε λίγα λεπτά.",
        "send_paranoid_instructions": "Αν ο λογαριασμός σας υπάρχει, θα λάβετε ένα email με οδηγίες για το πώς να τον ξεκλειδώσετε σε λίγα λεπτά.",
        "unlocked": "Ο λογαριασμός σας ξεκλειδώθηκε επιτυχώς. Παρακαλώ συνδεθείτε για να συνεχίσετε."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "πρέπει να είναι αποδεκτό",
        "already_confirmed": "επιβεβαιώθηκε ήδη, παρακαλώ δοκιμάστε να συνδεθείτε",
        "blank": "δεν πρέπει να είναι κενό",
        "confirmation": "δεν ταιριάζει με την επικύρωση",
        "confirmation_period_expired": "πρέπει να επιβεβαιωθεί εντός %{period}, παρακαλώ ζητήστε ένα νέο",
        "empty": "δεν πρέπει να είναι άδειο",
        "equal_to": "πρέπει να είναι ίσο με %{count}",
        "even": "πρέπει να είναι άρτιος",
        "exclusion": "είναι δεσμευμένο",
        "expired": "έχει λήξει, παρακαλώ ζητήστε ένα νέο",
        "greater_than": "πρέπει να είναι μεγαλύτερο από %{count}",
        "greater_than_or_equal_to": "πρέπει να είναι μεγαλύτερο ή ίσο με %{count}",
        "inclusion": "δεν συμπεριλαμβάνεται στη λίστα",
        "invalid": "είναι άκυρο",
        "less_than": "πρέπει να είναι λιγότερο από %{count}",
        "less_than_or_equal_to": "πρέπει να είναι λιγότερο ή ίσο με %{count}",
        "model_invalid": "Η επικύρωση απέτυχε: %{errors}",
        "not_a_number": "δεν είναι αριθμός",
        "not_an_integer": "πρέπει να είναι ακέραιος αριθμός",
        "not_found": "δεν βρέθηκε",
        "not_locked": "δεν κλειδώθηκε",
        "not_saved": {
          "one": "1 λάθος δεν επέτρεψε την αποθήκευση του %{resource}:",
          "other": "%{count} λάθη δεν επέτρεψαν την αποθήκευση του %{resource}:"
        },
        "odd": "πρέπει να είναι περιττός",
        "other_than": "πρέπει να είναι διάφορο του %{count}",
        "present": "πρέπει να είναι κενό",
        "required": "πρέπει να υπάρχει",
        "taken": "το έχουν ήδη χρησιμοποιήσει",
        "too_long": {
          "one": "είναι πολύ μεγάλο (το μέγιστο μήκος είναι %{count} χαρακτήρας)",
          "other": "είναι πολύ μεγάλο (το μέγιστο μήκος είναι %{count} χαρακτήρες)"
        },
        "too_short": {
          "one": "είναι πολύ μικρό (το ελάχιστο μήκος είναι %{count} χαρακτήρας)",
          "other": "είναι πολύ μικρό (το ελάχιστο μήκος είναι %{count} χαρακτήρες)"
        },
        "wrong_length": {
          "one": "έχει λανθασμένο μήκος (πρέπει να είναι %{count} χαρακτήρας)",
          "other": "έχει λανθασμένο μήκος (πρέπει να είναι %{count} χαρακτήρες)"
        }
      },
      "template": {
        "body": "Υπήρξαν προβλήματα με τα ακόλουθα πεδία:",
        "header": {
          "one": "%{count} λάθος εμπόδισε αυτό το %{model} να αποθηκευτεί.",
          "other": "%{count} λάθη εμπόδισαν αυτό το %{model} να αποθηκευτεί."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Παρακαλώ επιλέξτε"
      },
      "submit": {
        "create": "Δημιουργήστε %{model}",
        "submit": "Αποθηκεύστε %{model}",
        "update": "Ενημερώστε %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "Ά": "a",
          "ΆΙ": "ai",
          "ΆΥ": "av",
          "Έ": "e",
          "ΈΙ": "ei",
          "ΈΥ": "ev",
          "Ή": "h",
          "Ί": "I",
          "Ό": "o",
          "ΌΙ": "oi",
          "ΌΥ": "u",
          "Ύ": "y",
          "Ώ": "w",
          "Α": "a",
          "ΑΊ": "ai",
          "ΑΎ": "av",
          "ΑΙ": "ai",
          "ΑΥ": "av",
          "Β": "v",
          "Γ": "g",
          "Δ": "d",
          "Ε": "e",
          "ΕΊ": "ei",
          "ΕΎ": "ev",
          "ΕΙ": "ei",
          "ΕΥ": "ev",
          "Ζ": "z",
          "Η": "h",
          "Θ": "th",
          "Ι": "I",
          "Κ": "k",
          "Λ": "l",
          "Μ": "m",
          "Ν": "n",
          "Ξ": "x",
          "Ο": "o",
          "ΟΊ": "oi",
          "ΟΎ": "u",
          "ΟΙ": "oi",
          "ΟΥ": "u",
          "Π": "p",
          "Ρ": "r",
          "Σ": "s",
          "Τ": "t",
          "Υ": "y",
          "Φ": "f",
          "Χ": "ch",
          "Ψ": "ps",
          "Ω": "w",
          "ά": "a",
          "άι": "ai",
          "άυ": "av",
          "έ": "e",
          "έι": "ei",
          "έυ": "ev",
          "ή": "h",
          "ί": "I",
          "α": "a",
          "αί": "ai",
          "αι": "ai",
          "αυ": "av",
          "αύ": "av",
          "β": "v",
          "γ": "g",
          "δ": "d",
          "ε": "e",
          "ει": "ei",
          "ευ": "ev",
          "εύ": "ev",
          "ζ": "z",
          "η": "h",
          "θ": "th",
          "ι": "I",
          "κ": "k",
          "λ": "l",
          "μ": "m",
          "ν": "n",
          "ξ": "x",
          "ο": "o",
          "οί": "oi",
          "οι": "oi",
          "ου": "u",
          "ού": "u",
          "π": "p",
          "ρ": "r",
          "ς": "s",
          "σ": "s",
          "τ": "t",
          "υ": "y",
          "φ": "f",
          "χ": "ch",
          "ψ": "ps",
          "ω": "w",
          "ϊ": "i",
          "ϋ": "i",
          "ό": "o",
          "όι": "oi",
          "όυ": "u",
          "ύ": "y",
          "ώ": "w"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "δισεκατομμύριο",
            "million": "εκατομμύριο",
            "quadrillion": "τετράκις εκατομμύριο",
            "thousand": "χίλια",
            "trillion": "τρισεκατομμύριο",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " και ",
        "two_words_connector": " και ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "π.μ.",
      "formats": {
        "default": "%d %B %Y %H:%M",
        "long": "%A %d %B %Y %H:%M:%S %Z",
        "short": "%d %b %H:%M"
      },
      "pm": "μ.μ."
    }
  },
  "el-CY": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Η επικύρωση απέτυχε: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Η εγγραφή δεν μπορεί να διαγραφεί γιατί υπάρχουν εξαρτημένα %{record}",
            "has_one": "Η εγγραφή δεν μπορεί να διαγραφεί γιατί υπάρχει εξαρτημένο %{record}"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Κυρ",
        "Δευ",
        "Τρί",
        "Τετ",
        "Πέμ",
        "Παρ",
        "Σάβ"
      ],
      "abbr_month_names": [
        null,
        "Ιαν",
        "Φεβ",
        "Μαρ",
        "Απρ",
        "Μαϊ",
        "Ιουν",
        "Ιουλ",
        "Αυγ",
        "Σεπ",
        "Οκτ",
        "Νοε",
        "Δεκ"
      ],
      "day_names": [
        "Κυριακή",
        "Δευτέρα",
        "Τρίτη",
        "Τετάρτη",
        "Πέμπτη",
        "Παρασκευή",
        "Σάββατο"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%e %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Ιανουάριος",
        "Φεβρουάριος",
        "Μάρτιος",
        "Απρίλιος",
        "Μάιος",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "περίπου μία ώρα",
          "other": "περίπου %{count} ώρες"
        },
        "about_x_months": {
          "one": "περίπου ένα μήνα",
          "other": "περίπου %{count} μήνες"
        },
        "about_x_years": {
          "one": "περίπου ένα χρόνο",
          "other": "περίπου %{count} χρόνια"
        },
        "almost_x_years": {
          "one": "σχεδόν ένα χρόνο",
          "other": "σχεδόν %{count} χρόνια"
        },
        "half_a_minute": "μισό λεπτό",
        "less_than_x_minutes": {
          "one": "λιγότερο από ένα λεπτό",
          "other": "λιγότερο από %{count} λεπτά"
        },
        "less_than_x_seconds": {
          "one": "λιγότερο από ένα δευτερόλεπτο",
          "other": "λιγότερο από %{count} δευτερόλεπτα"
        },
        "over_x_years": {
          "one": "πάνω από ένα χρόνο",
          "other": "πάνω από %{count} χρόνια"
        },
        "x_days": {
          "one": "%{count} μέρα",
          "other": "%{count} ημέρες"
        },
        "x_minutes": {
          "one": "%{count} λεπτό",
          "other": "%{count} λεπτά"
        },
        "x_months": {
          "one": "%{count} μήνα",
          "other": "%{count} μήνες"
        },
        "x_seconds": {
          "one": "%{count} δευτερόλεπτο",
          "other": "%{count} δευτερόλεπτα"
        },
        "x_years": {
          "one": "%{count} χρόνος",
          "other": "%{count} χρόνια"
        }
      },
      "prompts": {
        "day": "Ημέρα",
        "hour": "Ώρα",
        "minute": "Λεπτό",
        "month": "Μήνας",
        "second": "Δευτερόλεπτο",
        "year": "Έτος"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "πρέπει να είναι αποδεκτό",
        "blank": "δεν πρέπει να είναι κενό",
        "confirmation": "δεν ταιριάζει με την επικύρωση",
        "empty": "δεν πρέπει να είναι άδειο",
        "equal_to": "πρέπει να είναι ίσο με %{count}",
        "even": "πρέπει να είναι άρτιος",
        "exclusion": "είναι δεσμευμένο",
        "greater_than": "πρέπει να είναι μεγαλύτερο από %{count}",
        "greater_than_or_equal_to": "πρέπει να είναι μεγαλύτερο ή ίσο με %{count}",
        "inclusion": "δεν συμπεριλαμβάνεται στη λίστα",
        "invalid": "είναι άκυρο",
        "less_than": "πρέπει να είναι λιγότερο από %{count}",
        "less_than_or_equal_to": "πρέπει να είναι λιγότερο ή ίσο με %{count}",
        "model_invalid": "Η επικύρωση απέτυχε: %{errors}",
        "not_a_number": "δεν είναι αριθμός",
        "not_an_integer": "πρέπει να είναι ακέραιος αριθμός",
        "odd": "πρέπει να είναι περιττός",
        "other_than": "πρέπει να είναι διάφορο του %{count}",
        "present": "πρέπει να είναι κενό",
        "required": "πρέπει να υπάρχει",
        "taken": "το έχουν ήδη χρησιμοποιήσει",
        "too_long": {
          "one": "είναι πολύ μεγάλο (το μέγιστο μήκος είναι %{count} χαρακτήρας)",
          "other": "είναι πολύ μεγάλο (το μέγιστο μήκος είναι %{count} χαρακτήρες)"
        },
        "too_short": {
          "one": "είναι πολύ μικρό (το ελάχιστο μήκος είναι %{count} χαρακτήρας)",
          "other": "είναι πολύ μικρό (το ελάχιστο μήκος είναι %{count} χαρακτήρες)"
        },
        "wrong_length": {
          "one": "έχει λανθασμένο μήκος (πρέπει να είναι %{count} χαρακτήρας)",
          "other": "έχει λανθασμένο μήκος (πρέπει να είναι %{count} χαρακτήρες)"
        }
      },
      "template": {
        "body": "Υπήρξαν προβλήματα με τα ακόλουθα πεδία:",
        "header": {
          "one": "%{count} λάθος εμπόδισε αυτό το %{model} να αποθηκευτεί.",
          "other": "%{count} λάθη εμπόδισαν αυτό το %{model} να αποθηκευτεί."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Παρακαλώ επιλέξτε"
      },
      "submit": {
        "create": "Δημιουργήστε %{model}",
        "submit": "Αποθηκεύστε %{model}",
        "update": "Ενημερώστε %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "δισεκατομμύριο",
            "million": "εκατομμύριο",
            "quadrillion": "τετράκις εκατομμύριο",
            "thousand": "χίλια",
            "trillion": "τρισεκατομμύριο",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " και ",
        "two_words_connector": " και ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "π.μ.",
      "formats": {
        "default": "%d %B %Y %H:%M",
        "long": "%A %d %B %Y %H:%M:%S %Z",
        "short": "%d %b %H:%M"
      },
      "pm": "μ.μ."
    }
  },
  "en": {
    "accounts": {
      "nav": {
        "account": "Account",
        "edit_profile": "Edit profile",
        "log_out": "Log out",
        "session": "Session",
        "tools": "Your tools"
      },
      "show": {
        "edit": "Edit profile",
        "profile": "Profile",
        "title": "Your account"
      }
    },
    "activerecord": {
      "attributes": {
        "board": {
          "add_creator_to_cards": "Assign me to the cards I create",
          "color": "Color",
          "description": "Description",
          "key": "Key",
          "name": "Name",
          "number_format": "Card numbers",
          "number_formats": {
            "hash": "#142",
            "key": "MKT-142",
            "workspace": "Workspace default"
          },
          "show_card_numbers": "Show card numbers"
        },
        "board_list": {
          "name": "Name"
        },
        "board_membership": {
          "role": "Role",
          "roles": {
            "admin": "Admin",
            "member": "Member",
            "observer": "Observer"
          },
          "user": "Person"
        },
        "card": {
          "board_list": "List",
          "description": "Description",
          "due_list": "Completes in",
          "due_on": "Due date",
          "due_time": "Due time",
          "number": "Number",
          "title": "Title"
        },
        "card_attachment": {
          "file": "File"
        },
        "card_comment": {
          "body": "Comment"
        },
        "checklist_item": {
          "text": "Item"
        },
        "client": {
          "contact_email": "Contact email",
          "default_hourly_rate": "Default rate per hour",
          "name": "Client name"
        },
        "consent": {
          "accepted_consents": "Accepted consents",
          "active": "Active",
          "content": "Content",
          "kind": "Name",
          "kind_list": {
            "cookies": "Cookie Policy",
            "privacy": "Privacy Policy",
            "terms": "Terms and Conditions"
          },
          "version": "Version"
        },
        "doorkeeper/application": {
          "name": "Name",
          "redirect_uri": "Redirect URI"
        },
        "group": {
          "anyone_can_add_reminders": "Anyone can add reminders",
          "color": "Colour",
          "name": "Group name"
        },
        "group_invitation": {
          "email": "Email"
        },
        "import": {
          "file": "File",
          "provider": "Source",
          "providers": {
            "clockify": "Clockify"
          },
          "status": "Status",
          "statuses": {
            "done": "Done",
            "failed": "Failed",
            "pending": "Queued",
            "running": "Running"
          },
          "time_zone": "Time zone of the file"
        },
        "label": {
          "color": "Color",
          "name": "Name"
        },
        "membership": {
          "role": "Role",
          "roles": {
            "admin": "Admin",
            "member": "Member"
          }
        },
        "nav_item": {
          "position": "Position",
          "route": "Route",
          "title": "Title"
        },
        "page": {
          "slug": "Slug",
          "title": "Title"
        },
        "page_block": {
          "column": "Column",
          "height": "Height",
          "row": "Row",
          "title": "Label",
          "width": "Width"
        },
        "page_block_carousel": {
          "autoplay": "Autoplay",
          "autoplay_delay": "Autoplay Delay",
          "effect": "Effect",
          "loop": "Loop",
          "show_navigation": "Show Navigation",
          "show_pagination": "Show Pagination",
          "speed": "Transition Speed"
        },
        "page_block_carousel_slide": {
          "image": "Image",
          "position": "Position",
          "text": "Text",
          "title": "Title"
        },
        "page_block_video": {
          "autoplay": "Autoplay",
          "caption": "Caption",
          "file": "Video File",
          "loop": "Loop",
          "show_controls": "Show Controls",
          "video_url": "Video URL"
        },
        "project": {
          "billable": "Billable",
          "client": "Client",
          "color": "Colour",
          "hourly_rate": "Rate per hour",
          "name": "Project name"
        },
        "reminder": {
          "audience": "Who",
          "audiences": {
            "group_all": "Everyone",
            "group_anyone": "Anyone",
            "members": "Some people",
            "only_me": "Just me"
          },
          "description": "Description",
          "due_at": "When",
          "repeat_rule": "Repeats",
          "repeat_rules": {
            "daily": "Every day",
            "monthly": "Every month",
            "never": "Never",
            "weekly": "Every week"
          },
          "title": "Reminder title"
        },
        "time_entry": {
          "project": "Project",
          "started_at": "Started",
          "stopped_at": "Stopped",
          "task": "Task"
        },
        "user": {
          "confirmation_sent_at": "Confirmation sent at",
          "confirmation_token": "Confirmation token",
          "confirmed_at": "Confirmed at",
          "created_at": "Created at",
          "current_password": "Current password",
          "current_sign_in_at": "Current sign in at",
          "current_sign_in_ip": "Current sign in IP",
          "email": "Email",
          "encrypted_password": "Encrypted password",
          "failed_attempts": "Failed attempts",
          "last_sign_in_at": "Last sign in at",
          "last_sign_in_ip": "Last sign in IP",
          "locked_at": "Locked at",
          "name": "Name",
          "password": "Password",
          "password_confirmation": "Confirm password",
          "remember_created_at": "Remember created at",
          "remember_me": "Keep me logged in",
          "reset_password_sent_at": "Reset password sent at",
          "reset_password_token": "Reset password token",
          "sign_in_count": "Sign in count",
          "time_zone": "Time zone",
          "unconfirmed_email": "Unconfirmed email",
          "unlock_token": "Unlock token",
          "updated_at": "Updated at"
        },
        "workspace": {
          "card_number_format": "Card numbers",
          "card_number_formats": {
            "hash": "#142",
            "key": "MKT-142"
          },
          "currency": "Currency",
          "daily_target_hours": "Hours per day",
          "daily_target_minutes": "Hours per day",
          "name": "Workspace name"
        },
        "workspace_invitation": {
          "email": "Email addresses",
          "role": "Role",
          "roles": {
            "admin": "Admin",
            "member": "Member",
            "owner": "Owner"
          }
        },
        "workspace_membership": {
          "role": "Role",
          "roles": {
            "admin": "Admin",
            "member": "Member",
            "owner": "Owner"
          }
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        },
        "models": {
          "card_attachment": {
            "attributes": {
              "file": {
                "too_large": "is too large (maximum %{count} MB)"
              }
            }
          },
          "doorkeeper/application": {
            "attributes": {
              "redirect_uri": {
                "forbidden_uri": "is forbidden by the server.",
                "fragment_present": "cannot contain a fragment.",
                "invalid_uri": "must be a valid URI.",
                "relative_uri": "must be an absolute URI.",
                "secured_uri": "must be an HTTPS/SSL URI.",
                "unspecified_scheme": "must specify a scheme."
              },
              "scopes": {
                "not_match_configured": "doesn't match those configured on the server."
              }
            }
          },
          "import": {
            "attributes": {
              "file": {
                "not_csv": "must be a CSV file",
                "too_large": "must be smaller than %{max} MB"
              }
            }
          },
          "page_block_video": {
            "attributes": {
              "base": {
                "video_source_exclusive": "cannot have both a URL and an uploaded file — choose one",
                "video_source_required": "must have either a URL or an uploaded file"
              }
            }
          },
          "time_entry": {
            "attributes": {
              "stopped_at": {
                "after_start": "must be after the start"
              },
              "user_id": {
                "already_running": "already has a timer running"
              }
            }
          }
        }
      },
      "models": {
        "board": {
          "one": "Board",
          "other": "Boards"
        },
        "board_list": {
          "one": "List",
          "other": "Lists"
        },
        "board_membership": {
          "one": "Board member",
          "other": "Board members"
        },
        "card": {
          "one": "Card",
          "other": "Cards"
        },
        "card_activity": {
          "one": "Activity",
          "other": "Activities"
        },
        "card_assignment": {
          "one": "Assignment",
          "other": "Assignments"
        },
        "card_attachment": {
          "one": "Attachment",
          "other": "Attachments"
        },
        "card_comment": {
          "one": "Comment",
          "other": "Comments"
        },
        "card_label": {
          "one": "Card label",
          "other": "Card labels"
        },
        "card_watch": {
          "one": "Watcher",
          "other": "Watchers"
        },
        "checklist_item": {
          "one": "Checklist item",
          "other": "Checklist items"
        },
        "client": {
          "one": "Client",
          "other": "Clients"
        },
        "consent": {
          "one": "Consent",
          "other": "Consents"
        },
        "group": {
          "one": "Group",
          "other": "Groups"
        },
        "group_invitation": {
          "one": "Invitation",
          "other": "Invitations"
        },
        "import": {
          "one": "Import",
          "other": "Imports"
        },
        "label": {
          "one": "Label",
          "other": "Labels"
        },
        "membership": {
          "one": "Member",
          "other": "Members"
        },
        "nav_item": {
          "one": "Nav Item",
          "other": "Nav Items"
        },
        "page": {
          "one": "Page",
          "other": "Pages"
        },
        "page_block": {
          "one": "Block",
          "other": "Blocks"
        },
        "page_block_carousel": {
          "one": "Carousel Block",
          "other": "Carousel Blocks"
        },
        "page_block_carousel_slide": {
          "one": "Slide",
          "other": "Slides"
        },
        "page_block_image": {
          "one": "Image Block",
          "other": "Image Blocks"
        },
        "page_block_text": {
          "one": "Text Block",
          "other": "Text Blocks"
        },
        "page_block_video": {
          "one": "Video Block",
          "other": "Video Blocks"
        },
        "project": {
          "one": "Project",
          "other": "Projects"
        },
        "reminder": {
          "one": "Reminder",
          "other": "Reminders"
        },
        "time_entry": {
          "one": "Time entry",
          "other": "Time entries"
        },
        "user": {
          "one": "User",
          "other": "Users"
        },
        "workspace": {
          "one": "Workspace",
          "other": "Workspaces"
        },
        "workspace_invitation": {
          "one": "Invitation",
          "other": "Invitations"
        },
        "workspace_membership": {
          "one": "Person",
          "other": "People"
        }
      }
    },
    "api": {
      "v1": {
        "consents_missing": "Accept the updated Terms and Conditions and Privacy Policy to continue.",
        "invalid_time": "“%{value}” is not an ISO 8601 time.",
        "social_logins": {
          "app": {
            "invalid_code": "This log in has expired or is not valid. Please log in again from the app.",
            "missing_code": "The log in code or its verifier is missing."
          }
        },
        "timers": {
          "destroy": {
            "nothing_running": "No timer is running."
          }
        }
      }
    },
    "auth": {
      "app_sign_ins": {
        "invalid": {
          "expired": "This log in took too long or was already used. Start again from the app.",
          "invalid": "Start logging in again from the app.",
          "title": "This log in link cannot be used"
        },
        "new": {
          "subtitle": "Taking you to your account… When you are done, you go back to the app.",
          "title": "Log in to Meerkeep"
        }
      }
    },
    "boards": {
      "archived_cards": {
        "restore": {
          "success": "%{number} restored."
        }
      },
      "assistant_pastes": {
        "create": {
          "success": "The text was received. The assistant is analysing it."
        },
        "destroy": {
          "success": "The text was discarded."
        },
        "retry": {
          "success": "The assistant will try again."
        }
      },
      "assistant_prompts": {
        "update": {
          "invalid": "The instructions cannot be blank or longer than %{max} characters.",
          "success": "Instructions saved."
        }
      },
      "assistant_settings": {
        "show": {
          "back": "Back to the assistant",
          "eyebrow": "Workspace %{workspace} · only you see this page",
          "gmail_hint": "Tell the assistant when to create a card and on which board. It also knows today's date, your boards, their lists and labels.",
          "gmail_label": "Prompt",
          "gmail_title": "Mail from %{email}",
          "intro": "The instructions the assistant follows in this workspace. Each source of text has its own.",
          "no_gmail": "No Gmail account is connected, so there are no mail instructions to edit yet.",
          "paste_hint": "Tell the assistant how to turn the text into cards. It also knows today's date, your boards, their lists and labels, and your open cards.",
          "paste_label": "Instructions",
          "paste_title": "Pasted text",
          "save": "Save",
          "title": "Assistant settings"
        }
      },
      "assistant_suggestions": {
        "accept": {
          "success": "Suggestion applied."
        },
        "dismiss": {
          "success": "Suggestion dismissed."
        }
      },
      "assistants": {
        "activity_item": {
          "accepted": "Accepted",
          "archived": "archived",
          "created": "Card created",
          "dismissed": "Dismissed"
        },
        "connection": {
          "checked": "Last checked %{time}",
          "disconnect": "Disconnect",
          "disconnect_confirm": "Disconnect %{email}? The saved access is deleted and revoked at Google. Cards the assistant created stay.",
          "never_checked": "Not checked yet",
          "pause": "Read my mail",
          "pause_hint": "Turn off to pause. Mail received while paused is skipped.",
          "reconnect": "Reconnect",
          "reconnect_hint": "Google no longer accepts the saved access. Reconnect to continue.",
          "status": {
            "active": "Connected",
            "disconnected": "Disconnected",
            "paused": "Paused"
          }
        },
        "paste": {
          "cards": {
            "one": "%{count} card",
            "other": "%{count} cards"
          },
          "discard": "Discard",
          "discard_confirm": "Discard this text? The cards already created stay.",
          "done": "%{cards}, %{suggestions}",
          "retry": "Retry",
          "status": {
            "done": "Done",
            "failed": "Could not reach the model",
            "pending": "Waiting",
            "processing": "Analysing…"
          },
          "suggestions": {
            "one": "%{count} suggestion",
            "other": "%{count} suggestions"
          }
        },
        "paste_box": {
          "analyse": "Analyse",
          "hint": "Paste notes, a to-do list or a forwarded message. The assistant reads it in the background, creates a card for each task and suggests changes to your existing cards. It works without Gmail.",
          "not_configured": "The model server is not configured on this server, so text cannot be analysed yet.",
          "placeholder": "Paste your text here",
          "text": "Text to analyse",
          "text_hint": "Up to %{max} characters. The text is deleted once it has been analysed.",
          "title": "Paste text"
        },
        "pastes": {
          "title": "Pasted texts"
        },
        "proposal": {
          "comment": "Add a comment:",
          "due_date": "Change due date to %{date} %{time}",
          "move": "Move to %{list}"
        },
        "show": {
          "activity": "Activity",
          "activity_empty": "The assistant has not done anything yet.",
          "activity_hint": "Cards the assistant created for you and suggestions you accepted or dismissed, newest first.",
          "connect": "Connect Gmail",
          "connect_another": "Connect another Gmail account",
          "connections": "Gmail connections",
          "eyebrow": "Workspace %{workspace} · only you see this page",
          "intro": "Connect your Gmail and the assistant turns the mail that needs an action into cards on your boards, following your prompt.",
          "none": "No Gmail account is connected in this workspace yet.",
          "not_configured": "Google sign-in is not configured on this server, so Gmail cannot be connected yet.",
          "privacy": {
            "model": "The text of each mail is sent to Meerkeep's own model server, which decides whether it needs a card. It is not shared with anyone else.",
            "paste": "Text you paste is sent to Meerkeep's own model server and deleted as soon as it has been analysed.",
            "read": "Every 3 hours it reads the new mail of each connected account, except Spam, Promotions and Social. Mail that arrived before you connected is not read.",
            "stored": "Only message identifiers are stored, never the mail itself. Cards show a short summary and the sender's name to the members of the board."
          },
          "privacy_title": "What the assistant reads and keeps",
          "settings": "Settings",
          "suggestions": "Suggestions",
          "suggestions_empty": "No suggestions waiting.",
          "suggestions_hint": "Changes the assistant proposes for your cards, from your mail or from text you pasted. Nothing changes until you accept.",
          "title": "Assistant"
        },
        "suggestion": {
          "accept": "Accept",
          "dismiss": "Dismiss"
        }
      },
      "board_duplicates": {
        "create": {
          "success": "%{name} is ready: a copy of the board."
        }
      },
      "board_lists": {
        "archive": {
          "success": "%{name} archived with its cards."
        },
        "create": {
          "alert": "The list could not be added: %{errors}",
          "success": "List added."
        },
        "list": {
          "actions": "Actions for %{list}",
          "archive_all": "Archive all cards",
          "archive_all_confirm": {
            "one": "Archive the card in %{list}?",
            "other": "Archive the %{count} cards in %{list}?"
          },
          "drop_here": "Drop a card here",
          "move_all_to": "Move all cards to",
          "select_all": "Select all cards"
        },
        "update": {
          "success": "List renamed."
        }
      },
      "board_memberships": {
        "create": {
          "success": "%{name} added to %{board}."
        },
        "destroy": {
          "success": "%{name} removed from the board."
        },
        "update": {
          "success": "%{name}'s board role updated."
        }
      },
      "board_settings": {
        "archived_cards": {
          "empty": "No archived cards on this board.",
          "meta": "Archived by %{name} · %{date}",
          "restore": "Restore",
          "someone": "someone",
          "title": "Archived cards"
        },
        "close": {
          "archive": "Archive board",
          "archive_confirm": "Archive %{name}? It becomes read-only and leaves the sidebar.",
          "delete": "Delete board…",
          "delete_confirm": "Delete %{name} and every card on it? This can’t be undone.",
          "hint": "Archived boards are read-only and leave the sidebar. You can reopen them from All boards. Deleting removes every card and can’t be undone.",
          "title": "Close this board"
        },
        "duplicate": {
          "copy_name": "%{name} (copy)",
          "hint": "Makes a new board with the same lists, labels, settings and cards (with their checklists, due dates and files), so it can serve as a template. People, comments and archived cards are not copied; you are the new board's admin.",
          "name": "Name of the copy",
          "submit": "Duplicate board",
          "title": "Duplicate this board"
        },
        "general": {
          "color": "Color",
          "description": "Description",
          "key": "Board key",
          "name": "Name",
          "optional": "(optional)",
          "title": "General"
        },
        "labels": {
          "add": "+ Board label",
          "color_for": "Color of %{name}",
          "delete": "Delete label %{name}",
          "delete_confirm": "Delete the label %{name}? It leaves every card that has it.",
          "hint": "Labels exist only on this board.",
          "new_color": "Color of the new label",
          "new_name": "New label name",
          "preview": "Preview",
          "preview_name": "New label",
          "rename": "Rename %{name}",
          "title": "Labels"
        },
        "lists": {
          "add": "+ Add list",
          "archive": "Archive list %{name}",
          "archive_confirm": "Archive %{name} and all its cards? Lists can’t be restored.",
          "cards": {
            "one": "1 card",
            "other": "%{count} cards"
          },
          "hint": "Drag to reorder. Archiving a list also archives its cards.",
          "new_name": "New list name",
          "rename": "Rename %{name}",
          "title": "Lists"
        },
        "members": {
          "add_from": "Add from %{workspace}",
          "hint": "Board admins change these settings. Members work on cards. Observers can read and comment only, good for clients.",
          "remove": "Remove %{name} from this board",
          "remove_confirm": "Remove %{name} from this board? Their card assignments stay.",
          "role_for": "Board role for %{name}",
          "title": "Members"
        },
        "numbers": {
          "format": "Format on this board",
          "hint": "Numbers count from #1 on each board and are never reused. Changing the key keeps old links working.",
          "next": "Next card gets",
          "title": "Card numbers",
          "workspace": "Workspace (%{sample})"
        },
        "show": {
          "board": "Board",
          "eyebrow": "Board settings · %{workspace}",
          "open_board": "Open board",
          "title": "Board settings · %{board}"
        },
        "switches": {
          "add_creator_to_cards": {
            "hint": "Puts new cards in your My tasks",
            "title": "Add me to cards I create"
          },
          "show_card_numbers": {
            "hint": "Numbers still work in search and links when hidden",
            "title": "Show card numbers on cards"
          },
          "title": "Cards on this board"
        },
        "update": {
          "success": "Saved."
        }
      },
      "boards": {
        "archive": {
          "success": "%{name} archived. You can reopen it from All boards."
        },
        "chips": {
          "query": "“%{q}”",
          "remove": "Remove filter %{filter}"
        },
        "create": {
          "success": "Board created."
        },
        "destroy": {
          "success": "%{name} deleted."
        },
        "filter": {
          "clear_all": "Clear all",
          "due": {
            "none": "No due date",
            "overdue": "Overdue",
            "today": "Due today",
            "tomorrow": "Due tomorrow",
            "week": "Due this week"
          },
          "due_date": "Due date",
          "labels": "Labels",
          "match": "Show cards that match",
          "matches": {
            "all": "All filter groups",
            "any": "Any filter"
          },
          "me": "Me",
          "members": "Members",
          "no_labels": "No labels",
          "no_members": "No members",
          "showing": "Showing %{shown} of %{total} cards",
          "title": "Filter"
        },
        "index": {
          "all_my_tasks": "All my tasks",
          "archived_boards": {
            "one": "1 archived board",
            "other": "%{count} archived boards"
          },
          "create_board": "Create a board",
          "create_hint": "Starts with Backlog, To do, Doing, Done",
          "due_for_you": "Due for you",
          "empty": "No boards yet.",
          "eyebrow": {
            "one": "%{workspace} workspace · 1 board",
            "other": "%{workspace} workspace · %{count} boards"
          },
          "groups": {
            "overdue": "Overdue",
            "today": "Today · %{date}",
            "tomorrow": "Tomorrow"
          },
          "meta": "%{board} · %{list}",
          "new_board": "New board",
          "no_results": "No boards match your search.",
          "nothing_due": "Nothing due today or tomorrow.",
          "other": "Other boards in %{workspace}",
          "reopen": "Reopen",
          "search_label": "Search boards",
          "search_placeholder": "Search boards…",
          "starred": "Starred",
          "title": "Boards"
        },
        "new": {
          "back": "← Boards",
          "eyebrow": "%{workspace} workspace",
          "heading": "Set up your board",
          "hint": "It starts with the lists Backlog, To do, Doing and Done.",
          "key_hint": "Up to 5 letters or numbers shown before the card number. Auto from name if blank.",
          "name_placeholder": "e.g. Website redesign",
          "submit": "Create board",
          "title": "New board"
        },
        "reopen": {
          "success": "%{name} reopened."
        },
        "selection_panel": {
          "add": "Add",
          "archive": "Archive cards",
          "archive_confirm": "Archive the selected cards?",
          "clear": "Clear selection",
          "clear_due": "Remove date",
          "count": {
            "one": "1 card selected",
            "other": "%{count} cards selected",
            "zero": "No cards selected yet"
          },
          "done": "Leave selection",
          "due": "Due date",
          "eyebrow": "Selection",
          "hint": "Click cards on the board to select them. Then move them, add people or labels, set a due date or archive them, all at once.",
          "labels": "Labels",
          "members": "Members",
          "move": "Move",
          "move_to": "Move to list",
          "remove": "Remove",
          "set_due": "Set"
        },
        "show": {
          "add_list": "Add another list",
          "add_list_submit": "Add list",
          "archived": "Archived · read-only",
          "list_name": "List name",
          "members": "Board members: %{names}",
          "only_mine": "Only my cards",
          "search_label": "Search cards by title or number",
          "search_placeholder": "Search or jump to #142…",
          "select": "Select",
          "settings": "Board settings"
        },
        "stats": {
          "one": "Board · 1 open card · next is #%{next}",
          "other": "Board · %{count} open cards · next is #%{next}"
        },
        "tile": {
          "due_today": {
            "one": "1 due today",
            "other": "%{count} due today"
          },
          "open": {
            "one": "1 open",
            "other": "%{count} open"
          },
          "overdue": {
            "one": "1 overdue",
            "other": "%{count} overdue"
          },
          "star": "Star %{board}",
          "unstar": "Unstar %{board}",
          "updated": "Updated %{time} ago"
        }
      },
      "bulk_cards": {
        "update": {
          "success": {
            "one": "1 card updated.",
            "other": "%{count} cards updated."
          }
        }
      },
      "calendars": {
        "day": {
          "label": {
            "one": "%{date}, 1 card",
            "other": "%{date}, %{count} cards"
          },
          "more": "+%{count} more"
        },
        "show": {
          "cards": {
            "one": "1 card",
            "other": "%{count} cards"
          },
          "empty_day": "No cards due this day.",
          "eyebrow": {
            "one": "1 card due · all boards in %{workspace}",
            "other": "%{count} cards due · all boards in %{workspace}"
          },
          "next_month": "Next month",
          "only_mine": "Only my cards",
          "overdue": "Overdue",
          "previous_month": "Previous month",
          "show": "Show",
          "title": "Calendar",
          "today": "Today",
          "today_prefix": "Today, %{date}"
        }
      },
      "cards": {
        "archive": {
          "success": "Card archived."
        },
        "card": {
          "attachments": {
            "one": "%{count} attachment",
            "other": "%{count} attachments"
          },
          "checklist": "Checklist %{done} of %{total}",
          "comments": {
            "one": "%{count} comment",
            "other": "%{count} comments"
          },
          "due": {
            "completed": "Done",
            "overdue": "Overdue",
            "today": "Due today",
            "upcoming": "Due"
          },
          "has_description": "This card has a description"
        },
        "composer": {
          "add_card": "Add a card",
          "cancel": "Cancel",
          "hint": "Enter to add",
          "label": "New card title in %{list}",
          "placeholder": "What needs doing?",
          "submit": "Add card"
        },
        "create": {
          "alert": "The card could not be added: %{errors}",
          "success": "Card added."
        },
        "detail": {
          "actions": "Actions",
          "activity": "Activity",
          "add": "Add",
          "add_attachment": "Add an attachment",
          "add_item": "Add an item",
          "add_to_card": "Add to card",
          "ai": "AI",
          "ai_comment": "Written by AI",
          "archive": "Archive",
          "archive_confirm": "Archive this card? It will disappear from the board.",
          "attachment": "Attachment",
          "attachments": "Attachments",
          "cancel": "Cancel",
          "checklist": "Checklist",
          "checklist_title": "Checklist title",
          "close": "Close card",
          "comment": "Comment",
          "comment_label": "Write a comment",
          "comment_placeholder": "Write a comment… use @ to mention, #number to link a card",
          "commented": "commented",
          "completed_in": "Completed in %{list}",
          "completes_in": "Completes in %{list}",
          "copied": "Copied",
          "copy_link": "Copy link",
          "copy_number": "Copy card number",
          "copy_number_label": "Copy card number %{number}",
          "create_label": "Create label",
          "dates": "Dates",
          "description": "Description",
          "description_placeholder": "Add a more detailed description…",
          "download": "Download",
          "drop_files": "Drop files to attach them",
          "due": "Due",
          "due_date": "Date",
          "due_list": "Completes in",
          "due_list_hint": "The due date is completed when the card reaches this column, and stays completed.",
          "due_state": {
            "completed": "Done",
            "overdue": "Overdue",
            "today": "Today",
            "upcoming": "Upcoming"
          },
          "due_time": "Time",
          "due_time_hint": "Leave empty for an all-day due date.",
          "editor": {
            "attach": "Insert an image or a file",
            "blockquote": "Quote",
            "bold": "Bold",
            "bullet_list": "Bulleted list",
            "code": "Code",
            "code_block": "Code block",
            "heading": "Heading",
            "italic": "Italic",
            "link": "Link",
            "link_prompt": "Link address (leave it empty to remove the link)",
            "ordered_list": "Numbered list",
            "strike": "Strikethrough",
            "task_list": "Checklist",
            "toolbar": "Formatting",
            "upload_failed": "The file could not be uploaded.",
            "uploading": "Uploading…"
          },
          "events": {
            "archived": "archived this card",
            "attached": "attached %{filename}",
            "commented": "commented",
            "created": "created this card as %{number}",
            "moved": "moved this card from %{from} to %{to}",
            "restored": "restored this card"
          },
          "footer": "Created by %{name}, %{date}. Card numbers never change, even when the card moves to another list.",
          "in": "in",
          "label_name": "Label name",
          "labels": "Labels",
          "list": "List",
          "members": "Members",
          "mention_label": "Board members",
          "new_checklist": "New checklist",
          "new_label": "New label",
          "no_board_labels": "This board has no labels yet. Create the first one below.",
          "no_board_members": "This board has no members yet.",
          "no_description": "No description.",
          "no_due": "No due date",
          "no_labels": "No labels",
          "no_members": "No members",
          "paste_or_drop": "or paste or drop files on the card",
          "preview": "Preview",
          "preview_file": "Preview %{file}",
          "remove": "Remove",
          "remove_checklist": "Remove the checklist %{title}",
          "remove_checklist_confirm": "Remove the checklist “%{title}” and its items?",
          "remove_due": "Remove due date",
          "remove_file": "Remove %{file}",
          "remove_file_confirm": "Remove %{file}?",
          "remove_item": "Remove item %{item}",
          "save": "Save",
          "title": "Card title",
          "uploaded_by": "%{name} · %{date}",
          "watch": "Watch",
          "watching": "Watching"
        }
      },
      "gmail_connections": {
        "callback": {
          "denied": "Gmail was not connected.",
          "invalid_state": "The connection request expired or does not belong to you. Try connecting again.",
          "success": "%{email} is connected."
        },
        "destroy": {
          "success": "%{email} was disconnected."
        },
        "new": {
          "not_configured": "Google sign-in is not configured on this server, so Gmail cannot be connected yet."
        },
        "update": {
          "success": "Saved."
        }
      },
      "joins": {
        "already_member": "You're in %{workspace}.",
        "create": {
          "success": "Welcome to %{workspace}."
        },
        "show": {
          "back": "Go to Meerkeep Boards",
          "body": "%{name} invited you to work on boards in this workspace as %{role}.",
          "title": "Join %{workspace}?"
        }
      },
      "labels": {
        "destroy": {
          "success": "%{name} deleted."
        },
        "update": {
          "success": "Label updated."
        }
      },
      "my_tasks": {
        "column": {
          "done": "%{done} of %{total} done",
          "empty": "Nothing due. Enjoy it.",
          "today": "Today",
          "tomorrow": "Tomorrow"
        },
        "complete": {
          "no_due_list": "This card has no column to complete its due date in."
        },
        "show": {
          "due_on": "due %{date}",
          "eyebrow": "%{date} · all boards in %{workspace}",
          "move_to_today": "Move to today",
          "open_calendar": "Open calendar",
          "overdue": {
            "one": "1 card is overdue",
            "other": "%{count} cards are overdue"
          },
          "scope_label": "Which cards",
          "scopes": {
            "mine": "Assigned to me",
            "watching": "Also watching"
          },
          "title": "My tasks"
        },
        "task": {
          "all_day": "All day",
          "checklist": "checklist %{done}/%{total}",
          "complete": "Mark %{number} as done",
          "done": "Done",
          "push": "Move %{number} to %{day}"
        }
      },
      "people": {
        "index": {
          "clear_search": "Show everyone",
          "columns": {
            "actions": "Actions",
            "boards": "Boards",
            "open_cards": "Open cards",
            "person": "Person",
            "role": "Role"
          },
          "everyone": "Everyone in %{workspace}",
          "eyebrow": "%{workspace} workspace · %{people}",
          "no_results": "Nobody matches “%{query}”.",
          "people_count": {
            "one": "1 person",
            "other": "%{count} people"
          },
          "search": "Search people",
          "search_placeholder": "Search people…",
          "settings": "Workspace settings",
          "title": "People"
        },
        "invite_card": {
          "boards": "Add them to boards",
          "emails": "Email addresses",
          "emails_placeholder": "name@company.com, another@company.com",
          "existing_hint": "People already in %{workspace} from Meerkeep Time keep the same account and role. You only pick their boards.",
          "optional": "(optional)",
          "role": "Role",
          "send": "Send invites",
          "title": "Invite to %{workspace}"
        },
        "membership": {
          "activate": "Activate",
          "add_board": "+ Board",
          "add_to_board": "Add %{name} to a board",
          "deactivate": "Deactivate",
          "deactivate_confirm": "Deactivate %{name}? They can't open %{workspace} until an owner activates them again. Their account and cards stay.",
          "inactive": "Inactive",
          "leave_confirm": "Leave %{workspace}? You will lose access to its boards.",
          "make": "Make %{role}",
          "open_cards": "%{count}",
          "overdue": {
            "one": "· 1 overdue",
            "other": "· %{count} overdue"
          },
          "remove": "Remove %{name} from the workspace",
          "remove_confirm": "Remove %{name} from %{workspace}? They leave its boards and cards too.",
          "role_for": "Role for %{name}: %{role}. Change role"
        },
        "roles_card": {
          "admin": "Creates, archives and deletes boards, manages labels and people, and sees every board.",
          "member": "Works on the boards they’re added to: creates, moves and comments on cards.",
          "owner": "Everything an admin can, plus billing, making admins, and deleting the workspace.",
          "title": "Roles in a workspace"
        }
      },
      "shared": {
        "nav": {
          "all_boards": "All boards",
          "assistant": "Assistant",
          "assistant_pending": {
            "one": "suggestion waiting",
            "other": "suggestions waiting"
          },
          "calendar": "Calendar",
          "manage": "Manage",
          "my_tasks": "My tasks",
          "my_tasks_open": {
            "one": "card to do",
            "other": "cards to do"
          },
          "new_board": "New board",
          "people": "People",
          "plan": "Plan",
          "settings": "Settings",
          "starred": "Starred boards"
        }
      },
      "workspace_invitations": {
        "added": "%{emails} added to the workspace.",
        "invited": "Invitation sent to %{emails}."
      },
      "workspace_memberships": {
        "activate": {
          "success": "%{name} activated."
        },
        "deactivate": {
          "success": "%{name} deactivated."
        },
        "destroy": {
          "success": "%{name} removed from the workspace."
        },
        "update": {
          "success": "%{name}'s role updated."
        }
      },
      "workspaces": {
        "create": {
          "success": "Workspace created."
        },
        "destroy": {
          "success": "Workspace deleted."
        },
        "edit": {
          "card_numbers": "Card numbers",
          "card_numbers_hint": "New boards use this. Each board can change it in its own settings.",
          "danger": "Delete workspace",
          "danger_hint": "This removes every board, card, client, project and time entry in it, for everyone.",
          "delete": "Delete workspace",
          "delete_confirm": "Delete %{workspace}? This removes every board, card, client, project and time entry in it, for everyone. This can’t be undone.",
          "eyebrow": "%{workspace} workspace",
          "formats": {
            "hash": "#142, number only",
            "key": "MKT-142, board key and number"
          },
          "general": "General",
          "name": "Workspace name",
          "save": "Save changes",
          "title": "Workspace settings"
        },
        "new": {
          "heading": "Your team's home",
          "hint": "Everything in Meerkeep Boards — people and boards — lives inside a workspace.",
          "name_placeholder": "e.g. Awesome Company",
          "submit": "Create workspace",
          "title": "Create a workspace"
        },
        "update": {
          "success": "Saved."
        }
      }
    },
    "brand": {
      "name": "Meerkeep",
      "tagline": "One account. Three tools for getting things done together.",
      "wordmark": "meerkeep"
    },
    "card_mailer": {
      "comment": {
        "body": "%{author} commented on %{number} %{title} in %{board}:",
        "hello": "Hi %{name},",
        "open": "Open the card",
        "subject": "%{author} commented on %{number} %{title}"
      },
      "mention": {
        "body": "%{author} mentioned you in a comment on %{number} %{title} in %{board}:",
        "hello": "Hi %{name},",
        "open": "Open the card",
        "subject": "%{author} mentioned you on %{number} %{title}"
      }
    },
    "colors": {
      "blue": "Blue",
      "blue_light": "Light blue",
      "green": "Green",
      "green_light": "Light green",
      "orange": "Orange",
      "orange_light": "Light orange",
      "pink": "Pink",
      "pink_light": "Light pink",
      "red": "Red",
      "red_light": "Light red",
      "sky": "Sky",
      "sky_light": "Light sky",
      "slate": "Slate",
      "slate_light": "Light slate",
      "teal": "Teal",
      "teal_light": "Light teal",
      "violet": "Violet",
      "violet_light": "Light violet",
      "yellow": "Yellow",
      "yellow_light": "Light yellow"
    },
    "common": {
      "you": "You"
    },
    "controllers": {
      "create_error": "There was an error creating %{model}. Please try again.",
      "created": "%{model} was successfully created",
      "destroy_error": "There was an error destroying %{model}. Please try again.",
      "destroyed": "%{model} was successfully destroyed.",
      "not_authorized": "You are not allowed to do that.",
      "updated": "%{model} was successfully updated."
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "day_heading": "%A %-d %B",
        "day_month": "%-d %b",
        "day_month_year": "%-d %b %Y",
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "month": "%b",
        "month_short_year": "%b %Y",
        "month_year": "%B %Y",
        "short": "%b %d",
        "short_day": "%a %-d %b",
        "weekday": "%a",
        "weekday_day_month": "%a %-d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      },
      "relative": {
        "future": "in %{time}",
        "past": "%{time} ago"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Your email address has been successfully confirmed.",
        "new": {
          "resend_confirmation_instructions": "Resend confirmation instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "invited": "You have a pending invitation, accept it to finish creating your account.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your email address before continuing."
      },
      "invitations": {
        "edit": {
          "header": "Set your password",
          "submit_button": "Set my password"
        },
        "invitation_removed": "Your invitation was removed.",
        "invitation_token_invalid": "The invitation token provided is not valid!",
        "new": {
          "header": "Send invitation",
          "submit_button": "Send an invitation"
        },
        "no_invitations_remaining": "No invitations remaining",
        "send_instructions": "An invitation email has been sent to %{email}.",
        "updated": "Your password was set successfully. You are now signed in.",
        "updated_not_active": "Your password was set successfully."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirm my account",
          "confirm_account_link": "Confirm my account",
          "confirm_link_msg": "You can confirm your account email through the link below:",
          "greeting": "Welcome %{recipient}!",
          "instruction": "You can confirm your account email through the link below:",
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your email has been changed to %{email}.",
          "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
          "subject": "Email Changed"
        },
        "invitation_instructions": {
          "accept": "Accept invitation",
          "accept_until": "This invitation will be due in %{due_date}.",
          "hello": "Hello %{email}",
          "ignore": "If you don't want to accept the invitation, please ignore this email. Your account won't be created until you access the link above and set your password.",
          "someone_invited_you": "Someone has invited you to %{url}, you can accept it through the link below.",
          "subject": "Invitation instructions"
        },
        "password_change": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your password has been changed.",
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "action": "Change my password",
          "greeting": "Hello %{recipient}!",
          "ignore_mail_msg": "If you didn't request this, please ignore this email.",
          "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
          "instruction_2": "If you didn't request this, please ignore this email.",
          "instruction_3": "Your password won't change until you access the link above and create a new one.",
          "no_changes_msg": "Your password won't change until you access the link above and create a new one.",
          "password_change_link": "Change my password",
          "request_reset_link_msg": "Someone has requested a link to change your password. You can do this through the link below.",
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "account_lock_msg": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
          "action": "Unlock my account",
          "greeting": "Hello %{recipient}!",
          "instruction": "Click the link below to unlock your account:",
          "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
          "subject": "Unlock instructions",
          "unlock_link": "Unlock my account",
          "unlock_link_msg": "Click the link below to unlock your account:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Change my password",
          "change_your_password": "Change your password",
          "confirm_new_password": "Confirm new password",
          "new_password": "New password"
        },
        "new": {
          "forgot_your_password": "Forgot your password?",
          "send_me_reset_password_instructions": "Send me reset password instructions"
        },
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "edit": {
          "are_you_sure": "Are you sure?",
          "cancel_my_account": "Cancel my account",
          "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
          "title": "Edit %{resource}",
          "unhappy": "Unhappy?",
          "update": "Update",
          "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
        },
        "new": {
          "sign_up": "Sign up"
        },
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
        "updated": "Your account has been updated successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "new": {
          "sign_in": "Log in"
        },
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "shared": {
        "links": {
          "back": "Back",
          "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
          "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
          "forgot_your_password": "Forgot your password?",
          "sign_in": "Log in",
          "sign_in_with_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        },
        "minimum_password_length": {
          "one": "(%{count} character minimum)",
          "other": "(%{count} characters minimum)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Resend unlock instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "devise_token_auth": {
      "confirmations": {
        "missing_email": "You must provide an email address.",
        "sended": "An email has been sent to '%{email}' containing instructions for confirming your account.",
        "sended_paranoid": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.",
        "user_not_found": "Unable to find user with email '%{email}'."
      },
      "omniauth": {
        "not_allowed_redirect_url": "Redirect to '%{redirect_url}' not allowed."
      },
      "passwords": {
        "missing_email": "You must provide an email address.",
        "missing_passwords": "You must fill out the fields labeled 'Password' and 'Password confirmation'.",
        "missing_redirect_url": "Missing redirect URL.",
        "not_allowed_redirect_url": "Redirect to '%{redirect_url}' not allowed.",
        "password_not_required": "This account does not require a password. Sign in using your '%{provider}' account instead.",
        "sended": "An email has been sent to '%{email}' containing instructions for resetting your password.",
        "sended_paranoid": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "successfully_updated": "Your password has been successfully updated.",
        "user_not_found": "Unable to find user with email '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Unable to locate account for destruction.",
        "account_with_uid_destroyed": "Account with UID '%{uid}' has been destroyed.",
        "email_already_exists": "An account already exists for '%{email}'",
        "missing_confirm_success_url": "Missing 'confirm_success_url' parameter.",
        "redirect_url_not_allowed": "Redirect to '%{redirect_url}' not allowed.",
        "user_not_found": "User not found."
      },
      "sessions": {
        "bad_credentials": "Invalid login credentials. Please try again.",
        "not_confirmed": "A confirmation email was sent to your account at '%{email}'. You must follow the instructions in the email before your account can be activated",
        "not_supported": "Use POST /sign_in to sign in. GET is not supported.",
        "user_not_found": "User was not found or was not logged in."
      },
      "token_validations": {
        "invalid": "Invalid login credentials"
      },
      "unlocks": {
        "missing_email": "You must provide an email address.",
        "sended": "An email has been sent to '%{email}' containing instructions for unlocking your account.",
        "sended_paranoid": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "user_not_found": "Unable to find user with email '%{email}'."
      }
    },
    "doorkeeper": {
      "applications": {
        "buttons": {
          "authorize": "Authorize",
          "cancel": "Cancel",
          "destroy": "Destroy",
          "edit": "Edit",
          "submit": "Submit"
        },
        "confirmations": {
          "destroy": "Are you sure?"
        },
        "edit": {
          "title": "Edit application"
        },
        "form": {
          "error": "Whoops! Check your form for possible errors"
        },
        "help": {
          "blank_redirect_uri": "Leave it blank if you configured your provider to use Client Credentials, Resource Owner Password Credentials or any other grant type that doesn't require a redirect URI.",
          "confidential": "Application will be used where the client secret can be kept confidential. Native mobile apps and Single Page Apps are considered non-confidential.",
          "redirect_uri": "Use one line per URI",
          "scopes": "Separate scopes with spaces. Leave blank to use the default scopes."
        },
        "index": {
          "actions": "Actions",
          "callback_url": "Callback URL",
          "confidential": "Confidential?",
          "confidentiality": {
            "no": "No",
            "yes": "Yes"
          },
          "name": "Name",
          "new": "New Application",
          "title": "Your applications"
        },
        "new": {
          "title": "New Application"
        },
        "show": {
          "actions": "Actions",
          "application_id": "UID:",
          "callback_urls": "Callback URLs:",
          "confidential": "Confidential:",
          "not_defined": "Not defined",
          "scopes": "Scopes:",
          "secret": "Secret:",
          "secret_hashed": "Secret hashed",
          "title": "Application: %{name}"
        }
      },
      "authorizations": {
        "buttons": {
          "authorize": "Authorize",
          "deny": "Deny"
        },
        "error": {
          "title": "An error has occurred"
        },
        "form_post": {
          "title": "Submit this form"
        },
        "new": {
          "able_to": "This application will be able to:",
          "prompt": "Authorize %{client_name} to use your account?",
          "title": "Authorization required"
        },
        "show": {
          "title": "Authorization code:"
        }
      },
      "authorized_applications": {
        "buttons": {
          "revoke": "Revoke"
        },
        "confirmations": {
          "revoke": "Are you sure?"
        },
        "index": {
          "application": "Application",
          "created_at": "Created At",
          "date_format": "%Y-%m-%d %H:%M:%S",
          "title": "Your authorized applications"
        }
      },
      "errors": {
        "messages": {
          "access_denied": "The resource owner or authorization server denied the request.",
          "admin_authenticator_not_configured": "Access to admin panel is forbidden due to Doorkeeper.configure.admin_authenticator being unconfigured.",
          "credential_flow_not_configured": "Resource Owner Password Credentials flow failed due to Doorkeeper.configure.resource_owner_from_credentials being unconfigured.",
          "forbidden_token": {
            "missing_scope": "Access to this resource requires scope \"%{oauth_scopes}\"."
          },
          "invalid_client": "Client authentication failed due to unknown client, no client authentication included, or unsupported authentication method.",
          "invalid_code_challenge_method": {
            "one": "The code_challenge_method must be %{challenge_methods}.",
            "other": "The code_challenge_method must be one of %{challenge_methods}.",
            "zero": "The authorization server does not support PKCE as there are no accepted code_challenge_method values."
          },
          "invalid_grant": "The provided authorization grant is invalid, expired, revoked, does not match the redirection URI used in the authorization request, or was issued to another client.",
          "invalid_redirect_uri": "The requested redirect URI is malformed or doesn't match the client redirect URI.",
          "invalid_request": {
            "invalid_code_challenge": "Code challenge is required.",
            "missing_param": "Missing required parameter: %{value}.",
            "multiple_client_auth_methods": "The request utilizes more than one mechanism for authenticating the client.",
            "request_not_authorized": "Request needs to be authorized. Required parameter for authorizing the request is missing or invalid.",
            "unknown": "The request is missing a required parameter, includes an unsupported parameter value, or is otherwise malformed."
          },
          "invalid_scope": "The requested scope is invalid, unknown, or malformed.",
          "invalid_token": {
            "expired": "The access token expired",
            "revoked": "The access token was revoked",
            "unknown": "The access token is invalid"
          },
          "resource_owner_authenticator_not_configured": "Resource Owner find failed due to Doorkeeper.configure.resource_owner_authenticator being unconfigured.",
          "revoke": {
            "unauthorized": "You are not authorized to revoke this token"
          },
          "server_error": "The authorization server encountered an unexpected condition which prevented it from fulfilling the request.",
          "temporarily_unavailable": "The authorization server is currently unable to handle the request due to a temporary overloading or maintenance of the server.",
          "unauthorized_client": "The client is not authorized to perform this request using this method.",
          "unsupported_grant_type": "The authorization grant type is not supported by the authorization server.",
          "unsupported_response_mode": "The authorization server does not support this response mode.",
          "unsupported_response_type": "The authorization server does not support this response type."
        }
      },
      "flash": {
        "applications": {
          "create": {
            "notice": "Application created."
          },
          "destroy": {
            "notice": "Application deleted."
          },
          "update": {
            "notice": "Application updated."
          }
        },
        "authorized_applications": {
          "destroy": {
            "notice": "Application revoked."
          }
        }
      },
      "layouts": {
        "admin": {
          "nav": {
            "applications": "Applications",
            "home": "Home",
            "oauth2_provider": "OAuth2 Provider"
          },
          "title": "Doorkeeper"
        },
        "application": {
          "title": "OAuth authorization required"
        }
      },
      "pre_authorization": {
        "status": "Pre-authorization"
      },
      "scopes": {
        "boards": "See and manage your boards: boards, lists and cards in every workspace you belong to"
      }
    },
    "errors": {
      "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_email": "is not an email",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "validate_account_update_params": "Please submit proper account update data in request body.",
        "validate_sign_up_params": "Please submit proper sign up data in request body.",
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      },
      "unacceptable_request": "A supported version is expected in the Accept header.\n",
      "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
    },
    "faker": {
      "address": {
        "building_number": [
          "#####",
          "####",
          "###"
        ],
        "city": [
          "#{city_prefix} #{Name.first_name}#{city_suffix}",
          "#{city_prefix} #{Name.first_name}",
          "#{Name.first_name}#{city_suffix}",
          "#{Name.last_name}#{city_suffix}"
        ],
        "city_prefix": [
          "North",
          "East",
          "West",
          "South",
          "New",
          "Lake",
          "Port"
        ],
        "city_suffix": [
          "town",
          "ton",
          "land",
          "ville",
          "berg",
          "burgh",
          "borough",
          "bury",
          "view",
          "port",
          "mouth",
          "stad",
          "furt",
          "chester",
          "mouth",
          "fort",
          "haven",
          "side",
          "shire"
        ],
        "city_with_state": [
          "#{city}, #{state}"
        ],
        "community": [
          "#{community_prefix} #{community_suffix}"
        ],
        "community_prefix": [
          "Park",
          "Summer",
          "Autumn",
          "Paradise",
          "Eagle",
          "Pine",
          "Royal",
          "University",
          "Willow"
        ],
        "community_suffix": [
          "Village",
          "Creek",
          "Place",
          "Pointe",
          "Square",
          "Oaks",
          "Gardens",
          "Crossing",
          "Court",
          "Acres",
          "Estates",
          "Heights"
        ],
        "country": [
          "Afghanistan",
          "Albania",
          "Algeria",
          "American Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarctica (the territory South of 60 deg S)",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbaijan",
          "Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivia",
          "Bosnia and Herzegovina",
          "Botswana",
          "Bouvet Island (Bouvetoya)",
          "Brazil",
          "British Indian Ocean Territory (Chagos Archipelago)",
          "Brunei Darussalam",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Cabo Verde",
          "Cayman Islands",
          "Central African Republic",
          "Chad",
          "Chile",
          "China",
          "Christmas Island",
          "Cocos (Keeling) Islands",
          "Colombia",
          "Comoros",
          "Congo",
          "Congo",
          "Cook Islands",
          "Costa Rica",
          "Cote d'Ivoire",
          "Croatia",
          "Cuba",
          "Cyprus",
          "Czech Republic",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Ethiopia",
          "Faroe Islands",
          "Falkland Islands (Malvinas)",
          "Fiji",
          "Finland",
          "France",
          "French Guiana",
          "French Polynesia",
          "French Southern Territories",
          "Gabon",
          "Gambia",
          "Georgia",
          "Germany",
          "Ghana",
          "Gibraltar",
          "Greece",
          "Greenland",
          "Grenada",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard Island and McDonald Islands",
          "Holy See (Vatican City State)",
          "Honduras",
          "Hong Kong",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran",
          "Iraq",
          "Isle of Man",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jersey",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Democratic People's Republic of Korea",
          "Republic of Korea",
          "Kuwait",
          "Kyrgyz Republic",
          "Lao People's Democratic Republic",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libyan Arab Jamahiriya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Macao",
          "North Macedonia",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands",
          "Martinique",
          "Mauritania",
          "Mauritius",
          "Mayotte",
          "Mexico",
          "Micronesia",
          "Moldova",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Morocco",
          "Mozambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands Antilles",
          "Netherlands",
          "New Caledonia",
          "New Zealand",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "Niue",
          "Norfolk Island",
          "Northern Mariana Islands",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Palestinian Territory",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Pitcairn Islands",
          "Poland",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Reunion",
          "Romania",
          "Russian Federation",
          "Rwanda",
          "Saint Barthelemy",
          "Saint Helena",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Martin",
          "Saint Pierre and Miquelon",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Slovakia (Slovak Republic)",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "South Georgia and the South Sandwich Islands",
          "Spain",
          "Sri Lanka",
          "Sudan",
          "Suriname",
          "Svalbard & Jan Mayen Islands",
          "Eswatini",
          "Sweden",
          "Switzerland",
          "Syrian Arab Republic",
          "Taiwan",
          "Tajikistan",
          "Tanzania",
          "Thailand",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Türkiye",
          "Turkmenistan",
          "Turks and Caicos Islands",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates",
          "United Kingdom",
          "United States of America",
          "United States Minor Outlying Islands",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Venezuela",
          "Vietnam",
          "Virgin Islands, British",
          "Virgin Islands, U.S.",
          "Wallis and Futuna",
          "Western Sahara",
          "Yemen",
          "Zambia",
          "Zimbabwe"
        ],
        "country_by_code": {
          "AD": "Andorra",
          "AE": "United Arab Emirates",
          "AF": "Afghanistan",
          "AG": "Antigua And Barbuda",
          "AI": "Anguilla",
          "AL": "Albania",
          "AM": "Armenia",
          "AN": "Netherlands Antilles",
          "AO": "Angola",
          "AQ": "Antarctica",
          "AR": "Argentina",
          "AS": "American Samoa",
          "AT": "Austria",
          "AU": "Australia",
          "AW": "Aruba",
          "AX": "Aland Islands",
          "AZ": "Azerbaijan",
          "BA": "Bosnia And Herzegovina",
          "BB": "Barbados",
          "BD": "Bangladesh",
          "BE": "Belgium",
          "BF": "Burkina Faso",
          "BG": "Bulgaria",
          "BH": "Bahrain",
          "BI": "Burundi",
          "BJ": "Benin",
          "BL": "Saint Barthelemy",
          "BM": "Bermuda",
          "BN": "Brunei Darussalam",
          "BO": "Bolivia",
          "BQ": "Bonaire",
          "BR": "Brazil",
          "BS": "Bahamas",
          "BT": "Bhutan",
          "BV": "Bouvet Island",
          "BW": "Botswana",
          "BY": "Belarus",
          "BZ": "Belize",
          "CA": "Canada",
          "CC": "Cocos (keeling) Islands",
          "CD": "Congo, The Democratic Republic Of The",
          "CF": "Central African Republic",
          "CG": "Congo",
          "CH": "Switzerland",
          "CI": "Cote D'Ivoire",
          "CK": "Cook Islands",
          "CL": "Chile",
          "CM": "Cameroon",
          "CN": "China",
          "CO": "Colombia",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Cabo Verde",
          "CW": "Curacao",
          "CX": "Christmas Island",
          "CY": "Cyprus",
          "CZ": "Czech Republic",
          "DE": "Germany",
          "DJ": "Djibouti",
          "DK": "Denmark",
          "DM": "Dominica",
          "DO": "Dominican Republic",
          "DZ": "Algeria",
          "EC": "Ecuador",
          "EE": "Estonia",
          "EG": "Egypt",
          "EH": "Western Sahara",
          "ER": "Eritrea",
          "ES": "Spain",
          "ET": "Ethiopia",
          "FI": "Finland",
          "FJ": "Fiji",
          "FK": "Falkland Islands (malvinas)",
          "FM": "Micronesia, Federated States Of",
          "FO": "Faroe Islands",
          "FR": "France",
          "GA": "Gabon",
          "GB": "United Kingdom",
          "GD": "Grenada",
          "GE": "Georgia",
          "GF": "French Guiana",
          "GG": "Guernsey",
          "GH": "Ghana",
          "GI": "Gibraltar",
          "GL": "Greenland",
          "GM": "Gambia",
          "GN": "Guinea",
          "GP": "Guadeloupe",
          "GQ": "Equatorial Guinea",
          "GR": "Greece",
          "GS": "South Georgia And The South Sandwich Islands",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guinea-bissau",
          "GY": "Guyana",
          "HK": "Hong Kong",
          "HM": "Heard Island And Mcdonald Islands",
          "HN": "Honduras",
          "HR": "Croatia",
          "HT": "Haiti",
          "HU": "Hungary",
          "ID": "Indonesia",
          "IE": "Ireland",
          "IL": "Israel",
          "IM": "Isle of Man",
          "IN": "India",
          "IO": "British Indian Ocean Territory",
          "IQ": "Iraq",
          "IR": "Iran, Islamic Republic Of",
          "IS": "Iceland",
          "IT": "Italy",
          "JE": "Jersey",
          "JM": "Jamaica",
          "JO": "Jordan",
          "JP": "Japan",
          "KE": "Kenya",
          "KG": "Kyrgyzstan",
          "KH": "Cambodia",
          "KI": "Kiribati",
          "KM": "Comoros",
          "KN": "Saint Kitts And Nevis",
          "KP": "Korea, Democratic People's Republic Of",
          "KR": "Korea, Republic Of",
          "KV": "Kosovo",
          "KW": "Kuwait",
          "KY": "Cayman Islands",
          "KZ": "Kazakstan",
          "LA": "Lao People's Democratic Republic",
          "LB": "Lebanon",
          "LC": "Saint Lucia",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Liberia",
          "LS": "Lesotho",
          "LT": "Lithuania",
          "LU": "Luxembourg",
          "LV": "Latvia",
          "LY": "Libyan Arab Jamahiriya",
          "MA": "Morocco",
          "MC": "Monaco",
          "MD": "Moldova, Republic Of",
          "ME": "Montenegro",
          "MF": "Saint Martin",
          "MG": "Madagascar",
          "MH": "Marshall Islands",
          "MK": "North Macedonia",
          "ML": "Mali",
          "MM": "Myanmar",
          "MN": "Mongolia",
          "MO": "Macau",
          "MP": "Northern Mariana Islands",
          "MQ": "Martinique",
          "MR": "Mauritania",
          "MS": "Montserrat",
          "MT": "Malta",
          "MU": "Mauritius",
          "MV": "Maldives",
          "MW": "Malawi",
          "MX": "Mexico",
          "MY": "Malaysia",
          "MZ": "Mozambique",
          "NA": "Namibia",
          "NC": "New Caledonia",
          "NE": "Niger",
          "NF": "Norfolk Island",
          "NG": "Nigeria",
          "NI": "Nicaragua",
          "NL": "Netherlands",
          "NO": "Norway",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "New Zealand",
          "OM": "Oman",
          "PA": "Panama",
          "PE": "Peru",
          "PF": "French Polynesia",
          "PG": "Papua New Guinea",
          "PH": "Philippines",
          "PK": "Pakistan",
          "PL": "Poland",
          "PM": "Saint Pierre And Miquelon",
          "PN": "Pitcairn",
          "PR": "Puerto Rico",
          "PS": "Palestinian Territory, Occupied",
          "PT": "Portugal",
          "PW": "Palau",
          "PY": "Paraguay",
          "QA": "Qatar",
          "RE": "Reunion",
          "RO": "Romania",
          "RS": "Serbia",
          "RU": "Russian Federation",
          "RW": "Rwanda",
          "SA": "Saudi Arabia",
          "SB": "Solomon Islands",
          "SC": "Seychelles",
          "SD": "Sudan",
          "SE": "Sweden",
          "SG": "Singapore",
          "SH": "Saint Helena",
          "SI": "Slovenia",
          "SJ": "Svalbard And Jan Mayen",
          "SK": "Slovakia",
          "SL": "Sierra Leone",
          "SM": "San Marino",
          "SN": "Senegal",
          "SO": "Somalia",
          "SR": "Suriname",
          "SS": "South Sudan",
          "ST": "Sao Tome And Principe",
          "SV": "El Salvador",
          "SX": "Sint Maarten",
          "SY": "Syrian Arab Republic",
          "SZ": "Eswatini",
          "TC": "Turks And Caicos Islands",
          "TD": "Chad",
          "TF": "French Southern Territories",
          "TG": "Togo",
          "TH": "Thailand",
          "TJ": "Tajikistan",
          "TK": "Tokelau",
          "TL": "Timor-Leste",
          "TM": "Turkmenistan",
          "TN": "Tunisia",
          "TO": "Tonga",
          "TR": "Türkiye",
          "TT": "Trinidad And Tobago",
          "TV": "Tuvalu",
          "TW": "Taiwan, Province Of China",
          "TZ": "Tanzania, United Republic Of",
          "UA": "Ukraine",
          "UG": "Uganda",
          "UM": "United States Minor Outlying Islands",
          "US": "United States",
          "UY": "Uruguay",
          "UZ": "Uzbekistan",
          "VA": "Holy See (vatican City State)",
          "VC": "Saint Vincent And The Grenadines",
          "VE": "Venezuela",
          "VG": "Virgin Islands, British",
          "VI": "Virgin Islands, U.S.",
          "VN": "Viet Nam",
          "VU": "Vanuatu",
          "WF": "Wallis And Futuna",
          "WS": "Samoa",
          "YE": "Yemen",
          "YT": "Mayotte",
          "ZA": "South Africa",
          "ZM": "Zambia",
          "ZW": "Zimbabwe"
        },
        "country_by_name": {
          "afghanistan": "AF",
          "albania": "AB",
          "algeria": "DZ",
          "american_samoa": "AS",
          "andorra": "AD",
          "angola": "AO",
          "anguilla": "AI",
          "antarctica": "AQ",
          "antigua_and_barbuda": "AG",
          "argentina": "AR",
          "armenia": "AM",
          "aruba": "AW",
          "australia": "AU",
          "austria": "AT",
          "azerbaijan": "AZ",
          "bahamas": "BS",
          "bahrain": "BH",
          "bangladesh": "BD",
          "barbados": "BB",
          "belarus": "BY",
          "belgium": "BE",
          "belize": "BZ",
          "benin": "BJ",
          "bermuda": "BM",
          "bhutan": "BT",
          "bolivia": "BO",
          "bosnia_and_herzegovina": "BA",
          "botswana": "BW",
          "bouvet_island": "BV",
          "brazil": "BR",
          "british_indian_ocean_territory": "IO",
          "brunei_darussalam": "BN",
          "bulgaria": "BG",
          "burkina_faso": "BF",
          "burundi": "BI",
          "cabo_verde": "CV",
          "cambodia": "KH",
          "cameroon": "CM",
          "canada": "CA",
          "cayman_islands": "KY",
          "central_african_republic": "CF",
          "chad": "TD",
          "chile": "CL",
          "china": "CN",
          "christmas_island": "CX",
          "cocos_islands": "CC",
          "colombia": "CO",
          "comoros": "KM",
          "congo": "CG",
          "cook_islands": "CK",
          "costa_rica": "CR",
          "cote_d_ivoire": "CI",
          "croatia": "HR",
          "cuba": "CU",
          "cyprus": "CY",
          "czech_republic": "CZ",
          "denmark": "DK",
          "djibouti": "DJ",
          "dominica": "DM",
          "dominican_republic": "DO",
          "ecuador": "EC",
          "egypt": "EG",
          "el_salvador": "SV",
          "equatorial_guinea": "GQ",
          "eritrea": "ER",
          "estonia": "EE",
          "eswatini": "SZ",
          "ethiopia": "ET",
          "falkland_islands": "FK",
          "faroe_islands": "FO",
          "fiji": "FJ",
          "finland": "FI",
          "france": "FR",
          "french_guiana": "GF",
          "french_polynesia": "PF",
          "french_southern_territories": "TF",
          "gabon": "GA",
          "gambia": "GM",
          "georgia": "GE",
          "germany": "DE",
          "ghana": "GH:",
          "gibraltar": "GI",
          "greece": "GR",
          "greenland": "GL",
          "grenada": "GD",
          "guadeloupe": "GP",
          "guam": "GU",
          "guatemala": "GT",
          "guinea": "GN",
          "guinea_bissau": "GW",
          "guyana": "GY",
          "haiti": "HT",
          "heard_island_and_mcdonald_islands": "HM",
          "holy_see": "VA",
          "honduras": "HN",
          "hong_kong": "HK",
          "hungary": "HU",
          "iceland": "IS",
          "india": "IN",
          "indonesia": "ID",
          "ir_islamic_republic_of": "IR",
          "iraq": "IQ",
          "ireland": "IE",
          "israel": "IL",
          "italy": "IT",
          "jamaica": "JM",
          "japan": "JP",
          "jordan": "JO",
          "kazakstan": "KZ",
          "kenya": "KE",
          "kiribati": "KI",
          "korea_democratic_people_s_republic_of": "KP",
          "korea_republic_of": "KR",
          "kosovo": "KV",
          "kuwait": "KW",
          "kyrgyzstan": "KG",
          "lao_people_s_democratic_republic": "LA",
          "latvia": "LV",
          "lebanon": "LB",
          "lesotho": "LS",
          "liberia": "LR",
          "libyan_arab_jamahiriya": "LY",
          "liechtenstein": "LI",
          "lithuania": "LT",
          "luxembourg": "LU",
          "macau": "MO",
          "madagascar": "MG",
          "malawi": "MW",
          "malaysia": "MY",
          "maldives": "MV",
          "mali": "ML",
          "malta": "MT",
          "malvinas": "FK",
          "marshall_islands": "MH",
          "martinique": "MQ",
          "mauritania": "MR",
          "mauritius": "MU",
          "mayotte": "YT",
          "micronesia_federated_states_of": "FM",
          "moldova_republic_of": "MD",
          "monaco": "MC",
          "mongolia": "MN",
          "montenegro": "ME",
          "montserrat": "MS",
          "morocco": "MA",
          "mozambique": "MZ",
          "myanmar": "MM",
          "namibia": "NA",
          "nauru": "NR",
          "nepal": "NP",
          "netherlands": "NL",
          "netherlands_antilles": "AN",
          "new_caledonia": "NC",
          "new_zealand": "NZ",
          "nicaragua": "NI",
          "niger": "NE",
          "nigeria": "NG",
          "niue": "NU",
          "norfolk_island": "NF",
          "north_macedonia": "MK",
          "northern_mariana_islands": "NP",
          "norway": "NO",
          "oman": "OM",
          "pakistan": "PK",
          "palau": "PW",
          "palestinian_territory_occupied": "PS",
          "panama": "PA",
          "papua_new_guinea": "PG",
          "paraguay": "PY",
          "peru": "PE",
          "philippines": "PH",
          "pitcairn": "PN",
          "poland": "PL",
          "portugal": "PT",
          "puerto_rico": "PR",
          "qatar": "QA",
          "reunion": "RE",
          "romania": "RO",
          "russian_federation": "RU",
          "rwanda": "RW",
          "saint_helena": "SH",
          "saint_kitts_and_nevis": "KN",
          "saint_lucia": "LC",
          "saint_pierre_and_miquelon": "PM",
          "saint_vincent_and_the_grenadines": "VC",
          "samoa": "WS",
          "san_marino": "SM",
          "sao_tome_and_principe": "ST",
          "saudi_arabia": "SA",
          "senegal": "SN",
          "serbia": "RS",
          "seychelles": "SC",
          "sierra_leone": "SL",
          "singapore": "SG",
          "slovakia": "SK",
          "slovenia": "SI",
          "solomon_islands": "SB",
          "somalia": "SO",
          "south_africa": "ZA",
          "south_georgia_and_the_south_sandwich_islands": "GS",
          "spain": "ES",
          "sri_lanka": "LK",
          "sudan": "SD",
          "suriname": "SR",
          "svalbard_and_jan_mayen": "SJ",
          "sweden": "SE",
          "switzerland": "CH",
          "syrian_arab_republic": "SY",
          "taiwan_province_of_china": "TW",
          "tajikistan": "TJ",
          "tanzania_united_republic_of": "TZ",
          "thailand": "TH",
          "timor_leste": "TL",
          "togo": "TG",
          "tokelau": "TK",
          "tonga": "TO",
          "trinidad_and_tobago": "TT",
          "tunisia": "TN",
          "turkmenistan": "TM",
          "turks_and_caicos_islands": "TC",
          "tuvalu": "TV",
          "türkiye": "TR",
          "uganda": "UG",
          "ukraine": "UA",
          "united_arab_emirates": "",
          "united_kingdom": "GB",
          "united_states": "US",
          "united_states_minor_outlying_islands": "UM",
          "uruguay": "UY",
          "uzbekistan": "UZ",
          "vanuatu": "VU",
          "venezuela": "VE",
          "viet_nam": "VN",
          "virgin_islands_british": "VG",
          "virgin_islands_u_s_": "VI",
          "wallis_and_futuna": "WF",
          "western_sahara": "EH",
          "yemen": "YE",
          "zambia": "ZM",
          "zimbabwe": "ZW"
        },
        "country_code": [
          "AD",
          "AE",
          "AF",
          "AG",
          "AI",
          "AL",
          "AM",
          "AO",
          "AQ",
          "AR",
          "AS",
          "AT",
          "AU",
          "AW",
          "AX",
          "AZ",
          "BA",
          "BB",
          "BD",
          "BE",
          "BF",
          "BG",
          "BH",
          "BI",
          "BJ",
          "BL",
          "BM",
          "BN",
          "BO",
          "BQ",
          "BQ",
          "BR",
          "BS",
          "BT",
          "BV",
          "BW",
          "BY",
          "BZ",
          "CA",
          "CC",
          "CD",
          "CF",
          "CG",
          "CH",
          "CI",
          "CK",
          "CL",
          "CM",
          "CN",
          "CO",
          "CR",
          "CU",
          "CV",
          "CW",
          "CX",
          "CY",
          "CZ",
          "DE",
          "DJ",
          "DK",
          "DM",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "EH",
          "ER",
          "ES",
          "ET",
          "FI",
          "FJ",
          "FK",
          "FM",
          "FO",
          "FR",
          "GA",
          "GB",
          "GD",
          "GE",
          "GF",
          "GG",
          "GH",
          "GI",
          "GL",
          "GM",
          "GN",
          "GP",
          "GQ",
          "GR",
          "GS",
          "GT",
          "GU",
          "GW",
          "GY",
          "HK",
          "HM",
          "HN",
          "HR",
          "HT",
          "HU",
          "ID",
          "IE",
          "IL",
          "IM",
          "IN",
          "IO",
          "IQ",
          "IR",
          "IS",
          "IT",
          "JE",
          "JM",
          "JO",
          "JP",
          "KE",
          "KG",
          "KH",
          "KI",
          "KM",
          "KN",
          "KP",
          "KR",
          "KW",
          "KY",
          "KZ",
          "LA",
          "LB",
          "LC",
          "LI",
          "LK",
          "LR",
          "LS",
          "LT",
          "LU",
          "LV",
          "LY",
          "MA",
          "MC",
          "MD",
          "ME",
          "MF",
          "MG",
          "MH",
          "MK",
          "ML",
          "MM",
          "MN",
          "MO",
          "MP",
          "MQ",
          "MR",
          "MS",
          "MT",
          "MU",
          "MV",
          "MW",
          "MX",
          "MY",
          "MZ",
          "NA",
          "NC",
          "NE",
          "NF",
          "NG",
          "NI",
          "NL",
          "NO",
          "NP",
          "NR",
          "NU",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PF",
          "PG",
          "PH",
          "PK",
          "PL",
          "PM",
          "PN",
          "PR",
          "PS",
          "PT",
          "PW",
          "PY",
          "QA",
          "RE",
          "RO",
          "RS",
          "RU",
          "RW",
          "SA",
          "SB",
          "SC",
          "SD",
          "SE",
          "SG",
          "SH",
          "SI",
          "SJ",
          "SK",
          "SL",
          "SM",
          "SN",
          "SO",
          "SR",
          "SS",
          "ST",
          "SV",
          "SX",
          "SY",
          "SZ",
          "TC",
          "TD",
          "TF",
          "TG",
          "TH",
          "TJ",
          "TK",
          "TL",
          "TM",
          "TN",
          "TO",
          "TR",
          "TT",
          "TV",
          "TW",
          "TZ",
          "UA",
          "UG",
          "UM",
          "US",
          "UY",
          "UZ",
          "VA",
          "VC",
          "VE",
          "VG",
          "VI",
          "VN",
          "VU",
          "WF",
          "WS",
          "YE",
          "YT",
          "ZA",
          "ZM",
          "ZW"
        ],
        "country_code_long": [
          "ABW",
          "AFG",
          "AGO",
          "AIA",
          "ALA",
          "ALB",
          "AND",
          "ARE",
          "ARG",
          "ARM",
          "ASM",
          "ATA",
          "ATF",
          "ATG",
          "AUS",
          "AUT",
          "AZE",
          "BDI",
          "BEL",
          "BEN",
          "BES",
          "BFA",
          "BGD",
          "BGR",
          "BHR",
          "BHS",
          "BIH",
          "BLM",
          "BLR",
          "BLZ",
          "BMU",
          "BOL",
          "BRA",
          "BRB",
          "BRN",
          "BTN",
          "BVT",
          "BWA",
          "CAF",
          "CAN",
          "CCK",
          "CHE",
          "CHL",
          "CHN",
          "CIV",
          "CMR",
          "COD",
          "COG",
          "COK",
          "COL",
          "COM",
          "CPV",
          "CRI",
          "CUB",
          "CUW",
          "CXR",
          "CYM",
          "CYP",
          "CZE",
          "DEU",
          "DJI",
          "DMA",
          "DNK",
          "DOM",
          "DZA",
          "ECU",
          "EGY",
          "ERI",
          "ESH",
          "ESP",
          "EST",
          "ETH",
          "FIN",
          "FJI",
          "FLK",
          "FRA",
          "FRO",
          "FSM",
          "GAB",
          "GBR",
          "GEO",
          "GGY",
          "GHA",
          "GIB",
          "GIN",
          "GLP",
          "GMB",
          "GNB",
          "GNQ",
          "GRC",
          "GRD",
          "GRL",
          "GTM",
          "GUF",
          "GUM",
          "GUY",
          "HKG",
          "HMD",
          "HND",
          "HRV",
          "HTI",
          "HUN",
          "IDN",
          "IMN",
          "IND",
          "IOT",
          "IRL",
          "IRN",
          "IRQ",
          "ISL",
          "ISR",
          "ITA",
          "JAM",
          "JEY",
          "JOR",
          "JPN",
          "KAZ",
          "KEN",
          "KGZ",
          "KHM",
          "KIR",
          "KNA",
          "KOR",
          "KWT",
          "LAO",
          "LBN",
          "LBR",
          "LBY",
          "LCA",
          "LIE",
          "LKA",
          "LSO",
          "LTU",
          "LUX",
          "LVA",
          "MAC",
          "MAF",
          "MAR",
          "MCO",
          "MDA",
          "MDG",
          "MDV",
          "MEX",
          "MHL",
          "MKD",
          "MLI",
          "MLT",
          "MMR",
          "MNE",
          "MNG",
          "MNP",
          "MOZ",
          "MRT",
          "MSR",
          "MTQ",
          "MUS",
          "MWI",
          "MYS",
          "MYT",
          "NAM",
          "NCL",
          "NER",
          "NFK",
          "NGA",
          "NIC",
          "NIU",
          "NLD",
          "NOR",
          "NPL",
          "NRU",
          "NZL",
          "OMN",
          "PAK",
          "PAN",
          "PCN",
          "PER",
          "PHL",
          "PLW",
          "PNG",
          "POL",
          "PRI",
          "PRK",
          "PRT",
          "PRY",
          "PSE",
          "PYF",
          "QAT",
          "REU",
          "ROU",
          "RUS",
          "RWA",
          "SAU",
          "SDN",
          "SEN",
          "SGP",
          "SGS",
          "SHN",
          "SJM",
          "SLB",
          "SLE",
          "SLV",
          "SMR",
          "SOM",
          "SPM",
          "SRB",
          "SSD",
          "STP",
          "SUR",
          "SVK",
          "SVN",
          "SWE",
          "SWZ",
          "SXM",
          "SYC",
          "SYR",
          "TCA",
          "TCD",
          "TGO",
          "THA",
          "TJK",
          "TKL",
          "TKM",
          "TLS",
          "TON",
          "TTO",
          "TUN",
          "TUR",
          "TUV",
          "TWN",
          "TZA",
          "UGA",
          "UKR",
          "UMI",
          "URY",
          "USA",
          "UZB",
          "VAT",
          "VCT",
          "VEN",
          "VGB",
          "VIR",
          "VNM",
          "VUT",
          "WLF",
          "WSM",
          "YEM",
          "ZAF",
          "ZMB",
          "ZWE"
        ],
        "default_country": [
          "United States of America"
        ],
        "full_address": [
          "#{street_address}, #{city}, #{state_abbr} #{zip_code}",
          "#{secondary_address} #{street_address}, #{city}, #{state_abbr} #{zip_code}"
        ],
        "mail_box": [
          "PO Box ##",
          "PO Box ###",
          "PO Box ####"
        ],
        "postcode": [
          "#####",
          "#####-####"
        ],
        "postcode_by_state": {
          "AK": "995##",
          "AL": "350##",
          "AR": "717##",
          "AS": "967##",
          "AZ": "850##",
          "CA": "900##",
          "CO": "800##",
          "CT": "061##",
          "DC": "204##",
          "DE": "198##",
          "FL": "322##",
          "GA": "301##",
          "HI": "967##",
          "IA": "510##",
          "ID": "832##",
          "IL": "600##",
          "IN": "463##",
          "KS": "666##",
          "KY": "404##",
          "LA": "701##",
          "MA": "026##",
          "MD": "210##",
          "ME": "042##",
          "MI": "480##",
          "MN": "555##",
          "MO": "650##",
          "MS": "387##",
          "MT": "590##",
          "NC": "288##",
          "ND": "586##",
          "NE": "688##",
          "NH": "036##",
          "NJ": "076##",
          "NM": "880##",
          "NV": "898##",
          "NY": "122##",
          "OH": "444##",
          "OK": "730##",
          "OR": "979##",
          "PA": "186##",
          "RI": "029##",
          "SC": "299##",
          "SD": "577##",
          "TN": "383##",
          "TX": "798##",
          "UT": "847##",
          "VA": "222##",
          "VT": "050##",
          "WA": "990##",
          "WI": "549##",
          "WV": "247##",
          "WY": "831##"
        },
        "secondary_address": [
          "Apt. ###",
          "Suite ###"
        ],
        "state": [
          "Alabama",
          "Alaska",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Florida",
          "Georgia",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming"
        ],
        "state_abbr": [
          "AL",
          "AK",
          "AZ",
          "AR",
          "CA",
          "CO",
          "CT",
          "DE",
          "FL",
          "GA",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "OH",
          "OK",
          "OR",
          "PA",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UT",
          "VT",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY"
        ],
        "street_address": [
          "#{building_number} #{street_name}"
        ],
        "street_name": [
          "#{Name.first_name} #{street_suffix}",
          "#{Name.last_name} #{street_suffix}"
        ],
        "street_suffix": [
          "Alley",
          "Avenue",
          "Branch",
          "Bridge",
          "Brook",
          "Brooks",
          "Burg",
          "Burgs",
          "Bypass",
          "Camp",
          "Canyon",
          "Cape",
          "Causeway",
          "Center",
          "Centers",
          "Circle",
          "Circles",
          "Cliff",
          "Cliffs",
          "Club",
          "Common",
          "Corner",
          "Corners",
          "Course",
          "Court",
          "Courts",
          "Cove",
          "Coves",
          "Creek",
          "Crescent",
          "Crest",
          "Crossing",
          "Crossroad",
          "Curve",
          "Dale",
          "Dam",
          "Divide",
          "Drive",
          "Drive",
          "Drives",
          "Estate",
          "Estates",
          "Expressway",
          "Extension",
          "Extensions",
          "Fall",
          "Falls",
          "Ferry",
          "Field",
          "Fields",
          "Flat",
          "Flats",
          "Ford",
          "Fords",
          "Forest",
          "Forge",
          "Forges",
          "Fork",
          "Forks",
          "Fort",
          "Freeway",
          "Garden",
          "Gardens",
          "Gateway",
          "Glen",
          "Glens",
          "Green",
          "Greens",
          "Grove",
          "Groves",
          "Harbor",
          "Harbors",
          "Haven",
          "Heights",
          "Highway",
          "Hill",
          "Hills",
          "Hollow",
          "Inlet",
          "Inlet",
          "Island",
          "Island",
          "Islands",
          "Islands",
          "Isle",
          "Isle",
          "Junction",
          "Junctions",
          "Key",
          "Keys",
          "Knoll",
          "Knolls",
          "Lake",
          "Lakes",
          "Land",
          "Landing",
          "Lane",
          "Light",
          "Lights",
          "Loaf",
          "Lock",
          "Locks",
          "Locks",
          "Lodge",
          "Lodge",
          "Loop",
          "Mall",
          "Manor",
          "Manors",
          "Meadow",
          "Meadows",
          "Mews",
          "Mill",
          "Mills",
          "Mission",
          "Mission",
          "Motorway",
          "Mount",
          "Mountain",
          "Mountain",
          "Mountains",
          "Mountains",
          "Neck",
          "Orchard",
          "Oval",
          "Overpass",
          "Park",
          "Parks",
          "Parkway",
          "Parkways",
          "Pass",
          "Passage",
          "Path",
          "Pike",
          "Pine",
          "Pines",
          "Place",
          "Plain",
          "Plains",
          "Plains",
          "Plaza",
          "Plaza",
          "Point",
          "Points",
          "Port",
          "Port",
          "Ports",
          "Ports",
          "Prairie",
          "Prairie",
          "Radial",
          "Ramp",
          "Ranch",
          "Rapid",
          "Rapids",
          "Rest",
          "Ridge",
          "Ridges",
          "River",
          "Road",
          "Road",
          "Roads",
          "Roads",
          "Route",
          "Row",
          "Rue",
          "Run",
          "Shoal",
          "Shoals",
          "Shore",
          "Shores",
          "Skyway",
          "Spring",
          "Springs",
          "Springs",
          "Spur",
          "Spurs",
          "Square",
          "Square",
          "Squares",
          "Squares",
          "Station",
          "Station",
          "Stravenue",
          "Stravenue",
          "Stream",
          "Stream",
          "Street",
          "Street",
          "Streets",
          "Summit",
          "Summit",
          "Terrace",
          "Throughway",
          "Trace",
          "Track",
          "Trafficway",
          "Trail",
          "Trail",
          "Tunnel",
          "Tunnel",
          "Turnpike",
          "Turnpike",
          "Underpass",
          "Union",
          "Unions",
          "Valley",
          "Valleys",
          "Via",
          "Viaduct",
          "View",
          "Views",
          "Village",
          "Village",
          "Villages",
          "Ville",
          "Vista",
          "Vista",
          "Walk",
          "Walks",
          "Wall",
          "Way",
          "Ways",
          "Well",
          "Wells"
        ],
        "time_zone": [
          "Pacific/Midway",
          "Pacific/Pago_Pago",
          "Pacific/Honolulu",
          "America/Juneau",
          "America/Los_Angeles",
          "America/Tijuana",
          "America/Denver",
          "America/Phoenix",
          "America/Chihuahua",
          "America/Mazatlan",
          "America/Chicago",
          "America/Regina",
          "America/Mexico_City",
          "America/Mexico_City",
          "America/Monterrey",
          "America/Guatemala",
          "America/New_York",
          "America/Indiana/Indianapolis",
          "America/Bogota",
          "America/Lima",
          "America/Lima",
          "America/Halifax",
          "America/Caracas",
          "America/La_Paz",
          "America/Santiago",
          "America/St_Johns",
          "America/Sao_Paulo",
          "America/Argentina/Buenos_Aires",
          "America/Guyana",
          "America/Godthab",
          "Atlantic/South_Georgia",
          "Atlantic/Azores",
          "Atlantic/Cape_Verde",
          "Europe/Dublin",
          "Europe/London",
          "Europe/Lisbon",
          "Europe/London",
          "Africa/Casablanca",
          "Africa/Monrovia",
          "Etc/UTC",
          "Europe/Belgrade",
          "Europe/Bratislava",
          "Europe/Budapest",
          "Europe/Ljubljana",
          "Europe/Prague",
          "Europe/Sarajevo",
          "Europe/Skopje",
          "Europe/Warsaw",
          "Europe/Zagreb",
          "Europe/Brussels",
          "Europe/Copenhagen",
          "Europe/Madrid",
          "Europe/Paris",
          "Europe/Amsterdam",
          "Europe/Berlin",
          "Europe/Berlin",
          "Europe/Rome",
          "Europe/Stockholm",
          "Europe/Vienna",
          "Africa/Algiers",
          "Europe/Bucharest",
          "Africa/Cairo",
          "Europe/Helsinki",
          "Europe/Kiev",
          "Europe/Riga",
          "Europe/Sofia",
          "Europe/Tallinn",
          "Europe/Vilnius",
          "Europe/Athens",
          "Europe/Istanbul",
          "Europe/Minsk",
          "Asia/Jerusalem",
          "Africa/Harare",
          "Africa/Johannesburg",
          "Europe/Moscow",
          "Europe/Moscow",
          "Europe/Moscow",
          "Asia/Kuwait",
          "Asia/Riyadh",
          "Africa/Nairobi",
          "Asia/Baghdad",
          "Asia/Tehran",
          "Asia/Muscat",
          "Asia/Muscat",
          "Asia/Baku",
          "Asia/Tbilisi",
          "Asia/Yerevan",
          "Asia/Kabul",
          "Asia/Yekaterinburg",
          "Asia/Karachi",
          "Asia/Karachi",
          "Asia/Tashkent",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kathmandu",
          "Asia/Dhaka",
          "Asia/Dhaka",
          "Asia/Colombo",
          "Asia/Almaty",
          "Asia/Novosibirsk",
          "Asia/Rangoon",
          "Asia/Bangkok",
          "Asia/Bangkok",
          "Asia/Jakarta",
          "Asia/Krasnoyarsk",
          "Asia/Shanghai",
          "Asia/Chongqing",
          "Asia/Hong_Kong",
          "Asia/Urumqi",
          "Asia/Kuala_Lumpur",
          "Asia/Singapore",
          "Asia/Taipei",
          "Australia/Perth",
          "Asia/Irkutsk",
          "Asia/Ulaanbaatar",
          "Asia/Seoul",
          "Asia/Tokyo",
          "Asia/Tokyo",
          "Asia/Tokyo",
          "Asia/Yakutsk",
          "Australia/Darwin",
          "Australia/Adelaide",
          "Australia/Melbourne",
          "Australia/Melbourne",
          "Australia/Sydney",
          "Australia/Brisbane",
          "Australia/Hobart",
          "Asia/Vladivostok",
          "Pacific/Guam",
          "Pacific/Port_Moresby",
          "Asia/Magadan",
          "Asia/Magadan",
          "Pacific/Noumea",
          "Pacific/Fiji",
          "Asia/Kamchatka",
          "Pacific/Majuro",
          "Pacific/Auckland",
          "Pacific/Auckland",
          "Pacific/Tongatapu",
          "Pacific/Fakaofo",
          "Pacific/Apia"
        ]
      },
      "adjective": {
        "negative": [
          "aggressive",
          "annoyed",
          "anxious",
          "arrogant",
          "ashamed",
          "average",
          "awful",
          "bad",
          "bloody",
          "bored",
          "careful",
          "cautious",
          "concerned",
          "confused",
          "crazy",
          "creepy",
          "cruel",
          "dangerous",
          "depressed",
          "disturbed",
          "envious",
          "evil",
          "expensive",
          "exuberant",
          "filthy",
          "foolish",
          "fragile",
          "frail",
          "frantic",
          "frightened",
          "grieving",
          "grotesque",
          "grumpy",
          "helpless",
          "horrible",
          "ill",
          "itchy",
          "jealous",
          "jittery",
          "lazy",
          "lonely",
          "misty",
          "muddy",
          "nasty",
          "naughty",
          "nervous",
          "nutty",
          "obnoxious",
          "odd",
          "old-fashioned",
          "outrageous",
          "panicky",
          "poised",
          "poor",
          "putrid",
          "puzzled",
          "repulsive",
          "scary",
          "selfish",
          "shy",
          "silly",
          "sleepy",
          "smoggy",
          "sore",
          "stormy",
          "strange",
          "stupid",
          "terrible",
          "thoughtless",
          "tired",
          "tough",
          "troubled",
          "ugliest",
          "ugly",
          "uninterested",
          "unsightly",
          "upset",
          "uptight",
          "weary",
          "wicked",
          "wild",
          "worrisome",
          "worried",
          "wrong"
        ],
        "positive": [
          "adorable",
          "adventurous",
          "agreeable",
          "attractive",
          "beautiful",
          "brainy",
          "brave",
          "bright",
          "calm",
          "charming",
          "cheerful",
          "clean",
          "clever",
          "colorful",
          "combative",
          "comfortable",
          "cooperative",
          "courageous",
          "curious",
          "cute",
          "delightful",
          "determined",
          "elegant",
          "enchanting",
          "encouraging",
          "energetic",
          "enthusiastic",
          "excited",
          "fair",
          "faithful",
          "famous",
          "fancy",
          "fantastic",
          "fine",
          "friendly",
          "funny",
          "gentle",
          "gifted",
          "glamorous",
          "gleaming",
          "glorious",
          "good",
          "gorgeous",
          "graceful",
          "handsome",
          "happy",
          "healthy",
          "helpful",
          "hilarious",
          "homely",
          "inexpensive",
          "innocent",
          "inquisitive",
          "jolly",
          "joyous",
          "kind",
          "light",
          "lively",
          "lovely",
          "lucky",
          "magnificent",
          "modern",
          "nice",
          "open",
          "outstanding",
          "perfect",
          "pleasant",
          "powerful",
          "precious",
          "proud",
          "quaint",
          "rich",
          "shiny",
          "smiling",
          "sparkling",
          "splendid",
          "spotless",
          "successful",
          "super",
          "talented",
          "tender",
          "tasty",
          "thankful",
          "thoughtful",
          "vast",
          "victorious",
          "vivacious",
          "witty",
          "zany",
          "zealous"
        ]
      },
      "airport": {
        "european_union": {
          "iata_code": {
            "large": [
              "LGW",
              "LHR",
              "LTN",
              "SEN",
              "STN",
              "MAN",
              "CDG",
              "ORY",
              "AMS",
              "FKB",
              "BER",
              "DUS",
              "FRA",
              "MUC",
              "BCN",
              "MAD",
              "PMI",
              "MXP",
              "FCO",
              "ATH",
              "OSL",
              "ARN"
            ],
            "medium": [
              "BHX",
              "BRS",
              "LPL",
              "LCY",
              "LTN",
              "NCL",
              "EMA",
              "ABZ",
              "EDI",
              "GLA",
              "BFS",
              "BVA",
              "BOD",
              "LYS",
              "MRS",
              "BSL",
              "NTE",
              "NCE",
              "TLS",
              "VIE",
              "LUX",
              "DUB",
              "PRG",
              "FKB",
              "CGN",
              "MLH/BSL/EAP",
              "HAM",
              "HAJ",
              "STR",
              "BUD",
              "BTS",
              "ZRH",
              "KRK",
              "ALC",
              "BIO",
              "FUE",
              "LPA",
              "IBZ",
              "ACE",
              "AGP",
              "SVQ",
              "TFN",
              "TFS",
              "VLC",
              "LIS",
              "BRI",
              "BGY",
              "BLQ",
              "CAG",
              "CTA",
              "LIN",
              "NAP"
            ]
          },
          "large": [
            "Gatwick Airport",
            "Heathrow Airport",
            "Luton Airport",
            "London Southend Airport",
            "London Stansted Airport",
            "Manchester Airport",
            "Charles de Gaulle Airport",
            "Orly Airport",
            "Amsterdam Airport Schiphol",
            "Karlsruhe/Baden-Baden Airport",
            "Berlin Brandenburg Airport",
            "Düsseldorf Airport",
            "Frankfurt Airport",
            "Munich Airport",
            "Josep Tarradellas Barcelona El Prat Airport",
            "Madrid-Barajas Airport",
            "Palma de Mallorca Airport",
            "Milan Malpensa Airport",
            "Leonardo da Vinci Fiumicino Airport",
            "Athens International Airport",
            "Oslo Airport, Gardermoen",
            "Stockholm Arlanda Airport"
          ],
          "medium": [
            "Birmingham Airport",
            "Bristol Airport",
            "Liverpool John Lennon Airport",
            "London City Airport",
            "Luton Airport",
            "Newcastle Airport",
            "East Midlands Airport",
            "Aberdeen Airport",
            "Edinburgh Airport",
            "Glasgow International Airport",
            "Belfast International Airport",
            "Beauvais Tillé Airport",
            "Bordeaux Mérignac Airport",
            "Lyon Saint Exupéry Airport",
            "Marseille Provence Airport",
            "EuroAirport Basel Mulhouse Freiburg",
            "Nantes Atlantique Airport",
            "Nice Côte d'Azur Airport",
            "Toulouse Blagnac Airport",
            "Vienna International Airport",
            "Findel Airport",
            "Dublin Airport",
            "Václav Havel Airport Prague",
            "Karlsruhe/Baden-Baden Airport",
            "Cologne/Bonn Airport",
            "EuroAirport Basel Mulhouse Freiburg",
            "Hamburg Airport",
            "Hannover Airport",
            "Stuttgart Airport",
            "Budapest Ferenc Liszt International Airport",
            "Bratislava Airport",
            "Zurich Airport",
            "Kraków John Paul II International Airport",
            "Alicante Elche Miguel Hernández Airport",
            "Bilbao Airport",
            "Fuerteventura Airport",
            "Gran Canaria Airport",
            "Ibiza Airport",
            "Lanzarote Airport",
            "Málaga Airport",
            "Seville Airport",
            "Tenerife North Ciudad de La Laguna Airport",
            "Tenerife South Airport",
            "Valencia Airport",
            "Lisbon Airport",
            "Palese Airport",
            "Orio al Serio Airport",
            "Bologna Airport",
            "Cagliari Airport",
            "Fontanarossa Airport",
            "Linate Airport",
            "Naples International Airport"
          ]
        },
        "united_states": {
          "iata_code": {
            "large": [
              "ATL",
              "BWI",
              "BOS",
              "CLT",
              "MDW",
              "ORD",
              "DFW",
              "DEN",
              "DTW",
              "FLL",
              "HNL",
              "IAH",
              "LAS",
              "LAX",
              "MIA",
              "MSP",
              "JFK",
              "LGA",
              "EWR",
              "MCO",
              "PHL",
              "PHX",
              "PDX",
              "SLC",
              "SAN",
              "SFO",
              "SEA",
              "TPA",
              "DCA",
              "IAD"
            ],
            "medium": [
              "ABQ",
              "ANC",
              "AUS",
              "BOI",
              "BUF",
              "CHS",
              "CVG",
              "CLE",
              "CMH",
              "ELP",
              "RSW",
              "GRR",
              "BDL",
              "HOU",
              "IND",
              "JAX",
              "MCI",
              "SDF",
              "MEM",
              "MKE",
              "BNA",
              "MSY",
              "ORF",
              "OAK",
              "OKC",
              "OMA",
              "ONT",
              "SNA",
              "ECP",
              "PIT",
              "PVD",
              "RDU",
              "RNO",
              "RIC",
              "SMF",
              "SAT",
              "SJC",
              "GEG",
              "STL",
              "PBI"
            ],
            "small": [
              "ALB",
              "ATW",
              "ACY",
              "BLI",
              "BHM",
              "DAY",
              "DSM",
              "FAI",
              "FAT",
              "GRB",
              "GSO",
              "MDT",
              "ITO",
              "HSV",
              "JAN",
              "EYW",
              "KOA",
              "TYS",
              "LIT",
              "MAF",
              "MYR",
              "SWF",
              "SFB",
              "PSP",
              "PNS",
              "AZA",
              "PWM",
              "RAC",
              "ROC",
              "SRQ",
              "SAV",
              "PIE",
              "SYR",
              "TLH",
              "TUS",
              "TUL",
              "AVP",
              "ILM"
            ]
          },
          "large": [
            "Hartsfield Jackson Atlanta International Airport",
            "Baltimore/Washington International Airport",
            "Logan International Airport",
            "Charlotte Douglas International Airport",
            "Midway International Airport",
            "O'Hare International Airport",
            "Dallas/Fort Worth International Airport",
            "Denver International Airport",
            "Detroit Metropolitan Airport",
            "Fort Lauderdale Hollywood International Airport",
            "Daniel K. Inouye International Airport",
            "George Bush Intercontinental Airport",
            "Harry Reid International Airport",
            "Los Angeles International Airport",
            "Miami International Airport",
            "Minneapolis Saint Paul International Airport",
            "John F. Kennedy International Airport",
            "LaGuardia Airport",
            "Newark Liberty International Airport",
            "Orlando International Airport",
            "Philadelphia International Airport",
            "Phoenix Sky Harbor International Airport",
            "Portland International Airport",
            "Salt Lake City International Airport",
            "San Diego International Airport",
            "San Francisco International Airport",
            "Seattle Tacoma International Airport",
            "Tampa International Airport",
            "Ronald Reagan Washington National Airport**",
            "Dulles International Airport"
          ],
          "medium": [
            "Albuquerque International Sunport",
            "Ted Stevens Anchorage International Airport",
            "Austin Bergstrom International Airport",
            "Boise Airport",
            "Buffalo Niagara International Airport",
            "Charleston International Airport",
            "Cincinnati/Northern Kentucky International Airport",
            "Cleveland Hopkins International Airport",
            "John Glenn Columbus International Airport",
            "El Paso International Airport",
            "Southwest Florida International Airport",
            "Gerald R. Ford International Airport",
            "Bradley International Airport",
            "William P. Hobby Airport",
            "Indianapolis International Airport",
            "Jacksonville International Airport",
            "Kansas City International Airport",
            "Louisville Muhammad Ali International Airport",
            "Memphis International Airport",
            "General Mitchell International Airport",
            "Nashville International Airport",
            "Louis Armstrong New Orleans International Airport",
            "Norfolk International Airport",
            "Oakland International Airport",
            "Will Rogers World Airport",
            "Eppley Airfield",
            "Ontario International Airport",
            "John Wayne Airport",
            "Northwest Florida Beaches International Airport",
            "Pittsburgh International Airport",
            "Rhode Island T. F. Green International Airport",
            "Raleigh Durham International Airport",
            "Reno Tahoe International Airport",
            "Richmond International Airport",
            "Sacramento International Airport",
            "San Antonio International Airport",
            "San Jose International Airport",
            "Spokane International Airport",
            "St. Louis Lambert International Airport",
            "Palm Beach International Airport"
          ],
          "small": [
            "Albany International Airport",
            "Appleton International Airport",
            "Atlantic City International Airport",
            "Bellingham International Airport",
            "Birmingham Shuttlesworth International Airport",
            "Dayton International Airport",
            "Des Moines International Airport",
            "Fairbanks International Airport",
            "Fresno Yosemite International Airport",
            "Green Bay Austin Straubel International Airport",
            "Piedmont Triad International Airport",
            "Harrisburg International Airport",
            "Hilo International Airport",
            "Huntsville International Airport",
            "Jackson Medgar Wiley Evers International Airport",
            "Key West International Airport",
            "Kona International Airport",
            "McGhee Tyson Airport",
            "Clinton National Airport",
            "Midland International Air and Space Port",
            "Myrtle Beach International Airport",
            "Stewart International Airport",
            "Orlando Sanford International Airport",
            "Palm Springs International Airport",
            "Pensacola International Airport",
            "Phoenix Mesa Gateway Airport",
            "Portland International Jetport",
            "Batten International Airport",
            "Greater Rochester International Airport",
            "Sarasota Bradenton International Airport",
            "Savannah/Hilton Head International Airport",
            "St. Pete Clearwater International Airport",
            "Syracuse Hancock International Airport",
            "Tallahassee International Airport",
            "Tucson International Airport",
            "Tulsa International Airport",
            "Wilkes-Barre/Scranton International Airport",
            "Wilmington International Airport"
          ]
        }
      },
      "ancient": {
        "god": [
          "Aphrodite",
          "Apollo",
          "Ares",
          "Artemis",
          "Athena",
          "Demeter",
          "Dionysus",
          "Hades",
          "Hephaestus",
          "Hera",
          "Hermes",
          "Hestia",
          "Poseidon",
          "Zeus"
        ],
        "hero": [
          "Abderus",
          "Achilles",
          "Aeneas",
          "Ajax",
          "Amphitryon",
          "Antilochus",
          "Bellerophon",
          "Castor",
          "Chrysippus",
          "Daedalus",
          "Diomedes",
          "Eleusis",
          "Eunostus",
          "Ganymede",
          "Hector",
          "Hercules",
          "Icarus",
          "Iolaus",
          "Jason",
          "Meleager",
          "Odysseus",
          "Orpheus",
          "Pandion",
          "Perseus",
          "Theseus",
          "Alcestis",
          "Amymone",
          "Andromache",
          "Andromeda",
          "Antigone",
          "Arachne",
          "Ariadne",
          "Atalanta",
          "Briseis",
          "Caeneus",
          "Cassandra",
          "Cassiopeia",
          "Clytemnestra",
          "Danaë",
          "Deianeira",
          "Electra",
          "Europa",
          "Hecuba",
          "Helen",
          "Hermione",
          "Iphigenia",
          "Ismene",
          "Jocasta",
          "Medea",
          "Medusa",
          "Niobe",
          "Pandora",
          "Penelope",
          "Phaedra",
          "Polyxena",
          "Semele",
          "Thrace"
        ],
        "primordial": [
          "Aion",
          "Aether",
          "Ananke",
          "Chaos",
          "Chronos",
          "Erebus",
          "Eros",
          "Hypnos",
          "Nesoi",
          "Uranus",
          "Gaia",
          "Ourea",
          "Phanes",
          "Pontus",
          "Tartarus",
          "Thalassa",
          "Thanatos",
          "Hemera",
          "Nyx",
          "Nemesis"
        ],
        "titan": [
          "Coeus",
          "Crius",
          "Cronus",
          "Hyperion",
          "Iapetus",
          "Mnemosyne",
          "Oceanus",
          "Phoebe",
          "Rhea",
          "Tethys",
          "Theia",
          "Themis",
          "Asteria",
          "Astraeus",
          "Atlas",
          "Aura",
          "Clymene",
          "Dione",
          "Helios",
          "Selene",
          "Eos",
          "Epimetheus",
          "Eurybia",
          "Eurynome",
          "Lelantos",
          "Leto",
          "Menoetius",
          "Metis",
          "Ophion",
          "Pallas",
          "Perses",
          "Prometheus",
          "Styx"
        ]
      },
      "app": {
        "author": [
          "#{Name.name}",
          "#{Company.name}"
        ],
        "name": [
          "Redhold",
          "Treeflex",
          "Trippledex",
          "Kanlam",
          "Bigtax",
          "Daltfresh",
          "Toughjoyfax",
          "Mat Lam Tam",
          "Otcom",
          "Tres-Zap",
          "Y-Solowarm",
          "Tresom",
          "Voltsillam",
          "Biodex",
          "Greenlam",
          "Viva",
          "Matsoft",
          "Temp",
          "Zoolab",
          "Subin",
          "Rank",
          "Job",
          "Stringtough",
          "Tin",
          "It",
          "Home Ing",
          "Zamit",
          "Sonsing",
          "Konklab",
          "Alpha",
          "Latlux",
          "Voyatouch",
          "Alphazap",
          "Holdlamis",
          "Zaam-Dox",
          "Sub-Ex",
          "Quo Lux",
          "Bamity",
          "Ventosanzap",
          "Lotstring",
          "Hatity",
          "Tempsoft",
          "Overhold",
          "Fixflex",
          "Konklux",
          "Zontrax",
          "Tampflex",
          "Span",
          "Namfix",
          "Transcof",
          "Stim",
          "Fix San",
          "Sonair",
          "Stronghold",
          "Fintone",
          "Y-find",
          "Opela",
          "Lotlux",
          "Ronstring",
          "Zathin",
          "Duobam",
          "Keylex",
          "Andalax",
          "Solarbreeze",
          "Cookley",
          "Vagram",
          "Aerified",
          "Pannier",
          "Asoka",
          "Regrant",
          "Wrapsafe",
          "Prodder",
          "Bytecard",
          "Bitchip",
          "Veribet",
          "Gembucket",
          "Cardguard",
          "Bitwolf",
          "Cardify",
          "Domainer",
          "Flowdesk",
          "Flexidy"
        ],
        "version": [
          "0.#.#",
          "0.##",
          "#.##",
          "#.#",
          "#.#.#"
        ]
      },
      "appliance": {
        "brand": [
          "Admiral",
          "Amana",
          "Blue Star",
          "Bosch",
          "Electrolux",
          "Fagor",
          "Franke",
          "IKEA",
          "KitchenAid",
          "LG",
          "Samsung",
          "Sharp",
          "Siemens",
          "Whirlpool"
        ],
        "equipment": [
          "Air ioniser",
          "Air purifier",
          "Appliance plug",
          "Aroma lamp",
          "Attic fan",
          "Bachelor griller",
          "Back boiler",
          "Beverage opener",
          "Blender",
          "Box mangle",
          "Can opener",
          "Ceiling fan",
          "Central vacuum cleaner",
          "Clothes dryer",
          "Clothes iron",
          "Cold-pressed juicer",
          "Combo washer dryer",
          "Dish draining closet",
          "Dishwasher",
          "Domestic robot",
          "Drawer dishwasher",
          "Electric water boiler",
          "Evaporative cooler",
          "Exhaust hood",
          "Fan heater",
          "Flame supervision device",
          "Forced-air",
          "Futon dryer",
          "Garbage disposal unit",
          "Gas appliance",
          "Go-to-bed matchbox",
          "HVAC",
          "Hair dryer",
          "Hair iron",
          "Hob (hearth)",
          "Home server",
          "Humidifier",
          "Icebox",
          "Kimchi refrigerator",
          "Mangle (machine)",
          "Micathermic heater",
          "Microwave oven",
          "Mousetrap",
          "Oil heater",
          "Oven",
          "Paper shredder",
          "Patio heater",
          "Radiator (heating)",
          "Refrigerator",
          "Sewing machine",
          "Solar water heater",
          "Space heater",
          "Steam mop",
          "Stove",
          "Sump pump",
          "Television",
          "Tie press",
          "Toaster and toaster ovens",
          "Trouser press",
          "Vacuum cleaner",
          "Washing machine",
          "Water cooker",
          "Water heater",
          "Water purifier",
          "Window fan"
        ]
      },
      "aqua_teen_hunger_force": {
        "character": [
          "Carl Brutananadilewski",
          "Cybernetic Ghost of Christmas Past from the Future",
          "D.P",
          "Dr. Weird",
          "Dr. Wongburger",
          "Emory",
          "Err",
          "Frylock",
          "George Lowe",
          "Ignignokt",
          "Master Shake",
          "MC Pee Pants",
          "Meatwad",
          "Oglethorpe",
          "Skeeter",
          "Steve",
          "Turkatron"
        ],
        "quote": [
          "Dancing is forbidden!",
          "Friendship ain't about trust. Friendship's about nunchucks.",
          "Listen to me, Randy. It doesn't matter what you look like on the outside-- whether you're white or black or a sasquatch even-- as long as you follow your dream, no matter how crazy or against the law it is, except for a sasquatch. If you're a sasquatch, the rules are different.",
          "Do what now?",
          "Now, I am not a violent person. But I would kill somebody, in front of they own grandmother, for a ten-speed.",
          "Stealing a bicycle is easy. Filling with illegal substances and transporting it across the border is not.",
          "You think you're gonna live forever, but you won't. Someone'll kill ya. Someone'll kill ya with a knife.",
          "Plaque is a figment of the liberal media and the dental industry to scare you into buying useless appliances and pastes. Now, I've read the arguments on both sides, and I haven't found any evidence yet to support the need to brush your teeth. Ever.",
          "TONIGHT...you",
          "Sadness is for poor people",
          "I'm in the business of giving you the business. And business is booming.",
          "Your jambox is now his by way of our actions.",
          "It's like my pool is tearin' ass around the back yard! But it's standing still...still waters run deep.",
          "He says that it sounded like my hobbit that turns the crank case is depressed and needs therapy. We need get us a new hobbit. They's from the land beyond time. Land beyond time is also gonna hook us up with a unicorn for the radiator. I ain't even gonna tell ya about that haunted air conditioner. Plus, the air filter? That's made of plutonium. That's gonna involve Superman, so...ya know, plus shipping from Krypton. And the cow..jumped over the moon."
        ]
      },
      "archer": {
        "characters": [
          "Sterling Archer",
          "Lana Kane",
          "Malory Archer",
          "Cyril Figgis",
          "Cheryl Tunt",
          "Pam Poovey",
          "Dr. Krieger",
          "Ray Gillette",
          "Barry Dylan",
          "Ron Cadillac",
          "Woodhouse",
          "Slater",
          "Katya Kazanova",
          "Brett Bunsen",
          "Conway Stern",
          "Len Trexler",
          "George Spelvin",
          "Trinette McGoon",
          "Rodney",
          "Cecil Tunt",
          "Charles and Rudy",
          "Gustavo Calderon",
          "Captain Lammers",
          "Edie Poovey",
          "Veronica Deane",
          "Figgis Agency staff",
          "Slater's agents",
          "Popeye",
          "Barry-6",
          "Conway Stern",
          "Bilbo",
          "Dutch"
        ],
        "locations": [
          "ISIS Headquarters",
          "The Tuntmore Towers",
          "The Archer Apartment",
          "The Malory Apartment",
          "The Krieger Lab",
          "San Marcos Palace",
          "The KGB Headquarters",
          "The Vatican",
          "Area 51",
          "Dreamland",
          "Danger Island",
          "The Figgis Agency office",
          "New York City",
          "Miami",
          "Monte Carlo",
          "Hollywood",
          "Texas"
        ],
        "quotes": [
          "Lana. Lana. Lana!... Danger zone.",
          "I'm sorry, I can't hear you over the sound of my giant throbbing erection!",
          "This is why we can't have nice things, people!",
          "If I cared about what you do on the weekend, I'd stick a shotgun in my mouth and pull the trigger with my toes.",
          "It's like my brain's a tree and you're those little cookie elves.",
          "I'm not saying I invented the turtleneck, but I was the first person to realize its potential as a tactical garment.",
          "You're about as useful as a cock-flavored lollipop.",
          "You want to take away my freedom? You're gonna have to pry it from my cold, dead hands.",
          "Just the Tip.",
          "It's called 'the velveteen touch of a dandy fop.' Look it up.",
          "Phrasing!",
          "Danger zone!",
          "M as in Mancy",
          "Do you want ants? Because that's how you get ants.",
          "I swear to god I had something for this.",
          "I am the one who makes the decisions, and I decide what we do, and we are not murdering people!",
          "You're not my supervisor!",
          "That's how you get ants. But seriously, don't eat that.",
          "Phrasing. Boom!",
          "Read a book, it'll make you feel better."
        ]
      },
      "artist": {
        "names": [
          "Donatello",
          "Botticelli",
          "Michelangelo",
          "Raphael",
          "Titian",
          "Durer",
          "Caravaggio",
          "Rubens",
          "Bernini",
          "Rembrandt",
          "Pissarro",
          "Manet",
          "Degas",
          "Cezanne",
          "Monet",
          "Renoir",
          "Cassatt",
          "Gauguin",
          "Munch",
          "Klimt",
          "Matisse",
          "Picasso",
          "Kandinsky",
          "Chagall",
          "Seurat",
          "Magritte",
          "Escher",
          "Rothko",
          "Dali",
          "Kahlo",
          "Pollock",
          "Warhol",
          "Vettriano",
          "Da Vinci",
          "El Greco",
          "Winslow Homer",
          "Paul Klee",
          "Edward Hopper",
          "Diego Rivera",
          "Vincent",
          "Joan Miro",
          "Ansel Adams"
        ]
      },
      "avatar": {
        "characters": [
          "Neytiri",
          "Jake Sully, Tommy",
          "Doctora Grace Augustine",
          "Ronal",
          "Trudy Chacon",
          "Miles Quaritch",
          "Dr. Karina Mogue",
          "Parker Selfridge",
          "Mo at",
          "Eytukan",
          "Dragon Gunship Pilot",
          "Neteyam",
          "Varang",
          "Otamu",
          "Bilano",
          "Deyshana",
          "Entok",
          "Eywaftia",
          "Frapohu",
          "Ronal",
          "Saeyla",
          "Sevineyo",
          "Ian Garvin",
          "Hukato"
        ],
        "dates": [
          "December 18, 2009",
          "December 15, 2022",
          "December 20, 2024"
        ],
        "quotes": [
          "I'm a warrior of the Jarhead clan.",
          "I was a warrior who dreamed he could bring peace. Sooner or later though, you always have to wake up.",
          "You want a fair deal, you're on the wrong planet. The strong prey on the weak.",
          "Sometimes your whole life boils down to one insane move.",
          "The Sky People have sent us a message: that they can take whatever they want. That no one can stop them. Well, we will send them a message: that they cannot take whatever they want! And that this...this is our land!",
          "All I ever wanted was a single thing worth fighting for.",
          "You don't choose your Avatar... your Avatar chooses you.",
          "The Na'vi say, that every person is born twice. The second time, is when you earn your place among the people...forever.",
          "Your spirit goes with Eywa. Your body stays behind to become part of The People.",
          "If it ain't raining, we ain't training.",
          "I became a Marine for the hardship. To be hammered on the anvil of life. I told myself I could pass any test a man can pass.",
          "If Grace is there with you - look in her memories - she can show you the world we come from. There's no green there. They killed their mother, and they're gonna do the same here.",
          "Sooner or later, though, you always have to wake up.",
          "Everything is backwards now, like out there is the true world, and in here is the dream.",
          "I'm with you now, Jake. We are mated for life.",
          "To become 'taronyu' hunter, you must choose your own Ikran and he must choose you.",
          "Toruk chose him, it has only happened five times since the time of first songs.",
          "You have a strong heart. No fear. But stupid! Ignorant like a child!",
          "Our great mother does not take sides, Jake; she protects the balance of life.",
          "Hey Sully... how does it feel to betray your own race? You think you're one of them? Time to wake up!",
          "Everyone on this base, every one of you, is fighting for survival, and that's a fact.",
          "And when we destroy it, we will blast a crater in their racial memory so deep, that they won't come within 1,000 klicks of this place ever again. And that too, is a fact.",
          "So you just figured you'd come here, to the most hostile environment known to men, with no training of any kind, and see how it went? What was going through your head?",
          "It is hard to fill a cup that is already full."
        ]
      },
      "back_to_the_future": {
        "characters": [
          "Marty McFly",
          "Dr. Emmett Brown",
          "Lorraine Baines",
          "George McFly",
          "Biff Tannen",
          "Jennifer Parker",
          "Dave McFly",
          "Linda McFly",
          "Sam Baines",
          "Stella Baines",
          "Milton Baines",
          "Sally Baines",
          "Joey Baines",
          "Mr. Strickland",
          "Skinhead",
          "3-D",
          "Match",
          "Marvin Berry",
          "Goldie Wilson",
          "Mr. Peabody",
          "Mark Dixon",
          "Lou",
          "Red The Bum",
          "Einstein"
        ],
        "dates": [
          "November 5, 1955",
          "November 12, 1955",
          "October 25, 1985",
          "October 26, 1985",
          "October 21, 2015"
        ],
        "quotes": [
          "Ah, Jesus Christ! Jesus Christ, Doc, you disintegrated Einstein!",
          "All right. This is an oldie, but, uh... well, it's an oldie where I come from.",
          "Am I to understand you're still hanging around with Dr. Emmett Brown, McFly?",
          "And one for you, McFly; I believe that makes four in a row. Now let me give you a nickel's worth of free advice, young man. This so-called Dr. Brown is dangerous. He's a real nutcase. You hang around with him, you're gonna end up in big trouble.",
          "Anyway, your Grandpa hit him with the car and brought him into the house. He seemed so helpless, like a little lost puppy, and my heart just went out to him.",
          "Are you telling me that this sucker is nuclear?",
          "Biff. What a character. Always trying to get away with something. I've had to stay on top of Biff ever since high school. Although, if it wasn't for him...",
          "Calm down, Marty. I didn't disintegrate anything. The molecular structure of both Einstein and the car are completely intact.",
          "Calvin? Wh... Why do you keep calling me Calvin?",
          "Course! From a group of Lybian Nationalists They wanted me to build them a bomb, so I took their plutonium and in turn I gave them a shiny bomb caseing full of used pinball machine parts!",
          "Crazy drunk driver.",
          "Damn! I'm late for school!",
          "Dear Dr. Brown. On the night that I go back in time, you will be shot by terrorists. Please take whatever precautions are necessary to prevent this terrible disaster. Your friend, Marty.",
          "Don't be so gullible, McFly. Got the place fixed up nice, though, McFly.",
          "Don't worry. As long as you hit that wire with the connecting hook at precisely 88 miles per hour, the instant the lightning strikes the tower... everything will be fine.",
          "Give me a Pepsi Free.",
          "Great Scott!",
          "He laid out Biff in one punch. I didn't know he had it in him. He's never stood up to Biff in his life!",
          "He's a Peeping Tom!",
          "He's an absolute dream!",
          "He's an idiot. Comes from upbringing. His parents are probably idiots, too. Lorraine, you ever have a kid who acts that way, I'll disown you.",
          "Hello? Hello? Anybody home? Huh? Think, McFly. Think! I gotta have time to get them retyped. Do you realize what would happen if I hand in my reports in your handwriting? I'll get fired. You wouldn't want that to happen, would ya? Would ya?",
          "Hey, Biff, get a load of this guy's life preserver. Dork thinks he's gonna drown.",
          "Hey, come on. I had to change. Do you think I'm going back in that-that zoot suit? The old man really came through. It worked!",
          "Hey, Dad! George! Hey, you on the bike!",
          "Hey, hey, listen, guys... Look, I don't wanna mess with no reefer addicts, okay?",
          "Hey, McFly! I thought I told you never to come in here.",
          "Hey, you! Get your damn hands off her!",
          "I can't believe you'd loan me your car without telling me it had a blind spot. I could've been killed!",
          "I finally invent something that works!",
          "I g-guess you guys aren't ready for that yet. But your kids are gonna love it.",
          "I had a horrible nightmare. I dreamed that I went... back in time. It was terrible.",
          "I have your car towed all the way to your house and all you got for me is lite beer?",
          "I noticed your band is on the roster for the dance auditions after school today. Why even bother, McFly? You don't have a chance. You're too much like your old man. No McFly ever amounted to anything in the history of Hill Valley!",
          "I'm from the future. I came here in a Time Machine that you invented. Now I need your help to get back to the year 1985.",
          "I'm gonna get that son of a bitch.",
          "I'm sure that in 1985, plutonium is available in every corner drugstore, but in 1955, it's a little hard to come by.",
          "I've had enough practical jokes for one evening. Good night, future boy!",
          "I've never seen purple underwear before!",
          "If my calculations are correct, when this baby hits 88 miles per hour... you're gonna see some serious shit.",
          "If you put your mind to it, you can accomplish anything.",
          "It's already mutated into human form! Shoot it!",
          "It's gonna be really hard waiting 30 years before I can talk to you about everything that's happened in the past few days. I'm really gonna miss you, Marty.",
          "Jesus, George, it was a wonder I was even born.",
          "Last night, Darth Vader came down from Planet Vulcan and told me that if I didn't take Lorraine out, that he'd melt my brain.",
          "Let me show you my plan for sending you home. Please excuse the crudity of this model. I didn't have time to build it to scale or paint it.",
          "Let's see if you bastards can do 90.",
          "Look! There's a rhythmic ceremonial ritual coming up.",
          "Look, I'm just not ready to ask Lorraine out to the dance, and not you, or anybody else on this planet is gonna make me change my mind.",
          "Look, Marvin, you gotta play. See, that's where they kiss for the first time on the dance floor. And if there's no music, they can't dance. If they can't dance, they can't kiss. If they can't kiss they can't fall in love, and I'm history.",
          "Look, you're not gonna be picking a fight, Dad... Dad-Dad-Daddy-O.",
          "Lorraine. My density has brought me to you.",
          "Marty, don't be such a square. Everybody who's anybody drinks.",
          "Marty, I'm sorry, but the only power source capable of generating 1.21 gigawatts of electricity is a bolt of lightning.",
          "Marty, will we ever see you again?",
          "Maybe you were adopted.",
          "My equipment. That reminds me, Marty. You better not hook up to the amplifier. There's a slight possibility of overload.",
          "Next saturday night we're sending you back to the future!",
          "No wonder your president has to be an actor. He's gotta look good on television.",
          "No! It requires something with a little more kick...plutonium!",
          "No! Marty! We've already agreed that having information about the future can be extremely dangerous. Even if your intentions are good, it can backfire drastically!",
          "No, get out of town. My mom thinks I'm going camping with the guys. Look, Jennifer, my mother would freak out if she knew I was going out with you, and I'd get the standard lecture about how she never did that kind of stuff when she was a kid. I mean, look, I think the woman was born a nun.",
          "No, no, no, no, no, this sucker's electrical, but I need a nuclear reaction to generate the 1.21 gigawatts of electricity I need.",
          "Now, Biff, I want to make sure that we get two coats of wax this time, not just one.",
          "Now, remember. According to my theory, you interfered with your parents' first meeting. If they don't meet, they won't fall in love, they won't get married and they won't have kids. That's why your older brother's disappearing from that photograph. Your sister will follow, and unless you repair the damage, you'll be next.",
          "Oh, honey, he's teasing you. Nobody has two television sets.",
          "Oh, my God. They found me. I don't know how, but they found me. Run for it, Marty!",
          "Oh, that's Joey. He cries when we take him out so we just leave him in there.",
          "Oh. One other thing. If you guys ever have kids, and one of them, when he's eight years old, accidentally sets fire to the living room rug... go easy on him.",
          "Okay, thank you. That's enough. Hold it now. Hold it. Hold it, fellas. I'm afraid you're just too darn loud. Next, please. Bring in the next group, please.",
          "Okay. Time circuit's on. Flux capacitor, fluxing. Engine running. All right.",
          "Perfect! My experiment worked! They're all exactly 25 minutes slow!",
          "Radiation suit? Of course. 'Cause of all the fallout from the atomic wars.",
          "Roads? Where we're going, we don't need roads.",
          "Save the clock tower!",
          "Scram, McFly. I'm cuttin' in.",
          "See you in about 30 years.",
          "See you later, Pop. Whoo! Time to change that oil.",
          "Silence, Earthling. My name is Darth Vader. I am an extraterrestrial from the planet Vulcan!",
          "Since when can weathermen predict the weather, let alone the future?",
          "Since you're new here, I-I'm gonna cut you a break, today. So, why don't you make like a tree and get outta here?",
          "So you're my Uncle Joey. Better get used to these bars, kid.",
          "Stand tall, boy. Have some respect for yourself. Don't you know, if you let people walk over you now, they'll be walking over you for the rest of your life. Look at me. You think I'm gonna spend the rest of my life in this slop house?",
          "Stella! Another one of these damn kids jumped in front of my car! Come on out here! Help me take him in the house!",
          "Take that, you mutated son of a bitch!",
          "That's Strickland. Jesus, didn't that guy ever have hair?",
          "The appropriate question is, 'when the hell are they?' You see, Einstein has just become the world's first time traveler! I sent him into the future. One minute into the future to be exact. And at precisely 1:21 a.m. and zero seconds, we shall catch up with him and the time machine.",
          "The way I see it, if you're gonna build a time machine into a car, why not do it with some style?",
          "There's that word again. 'Heavy.' Why are things so heavy in the future? Is there a problem with the Earth's gravitational pull?",
          "Things have certainly changed around here. I remember when this was all farmland as far the eye could see. Old man Peabody owned all of this. He had this crazy idea about breeding pine trees.",
          "This is all wrong. I don't know what it is. But when I kiss you, it's like I'm kissing... my brother. I guess that doesn't make any sense, does it?",
          "Wait a minute. Wait a minute, Doc. Ah... Are you telling me that you built a time machine... out of a DeLorean?",
          "We're the, uh... We're the Pinheads.",
          "Weight has nothing to do with it.",
          "Well, I figured, what the hell?",
          "Well, you're safe and sound now, back in good old 1955.",
          "What about all that talk about screwing up future events? The space-time continuum?",
          "What are you looking at, butthead?",
          "What happens to us in the future? Do we become assholes or something?",
          "What if I send in the tape and they don't like it? I mean, what if they say I'm no good? What if they say 'Get outta here, kid. You got no future'? I mean, I just don't think I can take that kind of rejection. Jesus, I'm starting to sound like my old man!",
          "What-what the hell is a gigawatt?",
          "Who the hell is John F. Kennedy?",
          "Who's President of the United States in 1985? Ronald Reagan? The actor? Ha! Then whose vice president? Jerry Lewis?",
          "Whoa. This is heavy.",
          "Whoa. Wait a minute, Doc. Are you trying to tell me that my mother has got the hots for me?",
          "Yeah, well, history is gonna change.",
          "Yes. Yes. I'm George. George McFly. I'm your density. I mean, your destiny.",
          "You caused 300 bucks damage to my car, you son of a bitch. And I'm gonna take it out of your ass.",
          "You got a real attitude problem, McFly; you're a slacker. You remind me of your father when he went here; he was a slacker, too.",
          "You know, Marty, you look so familiar to me. Do I know your mother?",
          "You really think I ought to swear?",
          "You want a Pepsi, pal, you're gonna pay for it.",
          "You're late! Do you have no concept of time?"
        ]
      },
      "bank": {
        "iban_details": {
          "ad": {
            "bban_pattern": "\\d{8}[A-Z0-9]{12}",
            "length": 24
          },
          "ae": {
            "bban_pattern": "\\d{19}",
            "length": 23
          },
          "al": {
            "bban_pattern": "\\d{8}[A-Z0-9]{16}",
            "length": 28
          },
          "at": {
            "bban_pattern": "\\d{16}",
            "length": 20
          },
          "az": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{20}",
            "length": 28
          },
          "ba": {
            "bban_pattern": "\\d{16}",
            "length": 20
          },
          "be": {
            "bban_pattern": "\\d{12}",
            "length": 16
          },
          "bg": {
            "bban_pattern": "[A-Z]{4}\\d{6}[A-Z0-9]{8}",
            "length": 22
          },
          "bh": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{14}",
            "length": 22
          },
          "br": {
            "bban_pattern": "[0-9]{8}[0-9]{5}[0-9]{10}[A-Z]{1}[A-Z0-9]{1}",
            "length": 29
          },
          "ch": {
            "bban_pattern": "\\d{5}[A-Z0-9]{12}",
            "length": 21
          },
          "cr": {
            "bban_pattern": "0\\d{3}\\d{14}",
            "length": 22
          },
          "cy": {
            "bban_pattern": "\\d{8}[A-Z0-9]{16}",
            "length": 28
          },
          "cz": {
            "bban_pattern": "\\d{20}",
            "length": 24
          },
          "de": {
            "bban_pattern": "\\d{18}",
            "length": 22
          },
          "dk": {
            "bban_pattern": "\\d{14}",
            "length": 18
          },
          "do": {
            "bban_pattern": "[A-Z]{4}\\d{20}",
            "length": 28
          },
          "ee": {
            "bban_pattern": "\\d{16}",
            "length": 20
          },
          "es": {
            "bban_pattern": "\\d{20}",
            "length": 24
          },
          "fi": {
            "bban_pattern": "\\d{14}",
            "length": 18
          },
          "fo": {
            "bban_pattern": "\\d{14}",
            "length": 18
          },
          "fr": {
            "bban_pattern": "\\d{10}[A-Z0-9]{11}\\d{2}",
            "length": 27
          },
          "gb": {
            "bban_pattern": "[A-Z]{4}\\d{14}",
            "length": 22
          },
          "ge": {
            "bban_pattern": "[A-Z]{2}\\d{16}",
            "length": 22
          },
          "gi": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{15}",
            "length": 23
          },
          "gl": {
            "bban_pattern": "\\d{14}",
            "length": 18
          },
          "gr": {
            "bban_pattern": "\\d{7}[A-Z0-9]{16}",
            "length": 27
          },
          "gt": {
            "bban_pattern": "[A-Z0-9]{4}\\d{2}\\d{2}[A-Z0-9]{16}",
            "length": 28
          },
          "hr": {
            "bban_pattern": "\\d{17}",
            "length": 21
          },
          "hu": {
            "bban_pattern": "\\d{24}",
            "length": 28
          },
          "ie": {
            "bban_pattern": "[A-Z]{4}\\d{14}",
            "length": 22
          },
          "il": {
            "bban_pattern": "\\d{19}",
            "length": 23
          },
          "is": {
            "bban_pattern": "\\d{22}",
            "length": 26
          },
          "it": {
            "bban_pattern": "[A-Z]\\d{10}[A-Z0-9]{12}",
            "length": 27
          },
          "kw": {
            "bban_pattern": "[A-Z]{4}\\d{22}",
            "length": 30
          },
          "kz": {
            "bban_pattern": "[0-9]{3}[A-Z0-9]{13}",
            "length": 20
          },
          "lb": {
            "bban_pattern": "\\d{4}[A-Z0-9]{20}",
            "length": 28
          },
          "li": {
            "bban_pattern": "\\d{5}[A-Z0-9]{12}",
            "length": 21
          },
          "lt": {
            "bban_pattern": "\\d{16}",
            "length": 20
          },
          "lu": {
            "bban_pattern": "\\d{3}[A-Z0-9]{13}",
            "length": 20
          },
          "lv": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{13}",
            "length": 21
          },
          "mc": {
            "bban_pattern": "\\d{10}[A-Z0-9]{11}\\d{2}",
            "length": 27
          },
          "md": {
            "bban_pattern": "[A-Z]{2}[A-Z0-9]{18}",
            "length": 24
          },
          "me": {
            "bban_pattern": "\\d{18}",
            "length": 22
          },
          "mk": {
            "bban_pattern": "\\d{3}[A-Z0-9]{10}\\d{2}",
            "length": 19
          },
          "mr": {
            "bban_pattern": "\\d{23}",
            "length": 27
          },
          "mt": {
            "bban_pattern": "[A-Z]{4}\\d{5}[A-Z0-9]{18}",
            "length": 31
          },
          "mu": {
            "bban_pattern": "[A-Z]{4}\\d{19}[A-Z]{3}",
            "length": 30
          },
          "nl": {
            "bban_pattern": "[A-Z]{4}\\d{10}",
            "length": 18
          },
          "no": {
            "bban_pattern": "\\d{11}",
            "length": 15
          },
          "pk": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{16}",
            "length": 24
          },
          "pl": {
            "bban_pattern": "\\d{8}\\d{16}",
            "length": 28
          },
          "ps": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{21}",
            "length": 29
          },
          "pt": {
            "bban_pattern": "\\d{21}",
            "length": 25
          },
          "qa": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{21}",
            "length": 29
          },
          "ro": {
            "bban_pattern": "[A-Z]{4}[A-Z0-9]{16}",
            "length": 24
          },
          "rs": {
            "bban_pattern": "\\d{18}",
            "length": 22
          },
          "sa": {
            "bban_pattern": "\\d{2}[A-Z0-9]{18}",
            "length": 24
          },
          "se": {
            "bban_pattern": "\\d{20}",
            "length": 24
          },
          "si": {
            "bban_pattern": "\\d{15}",
            "length": 19
          },
          "sk": {
            "bban_pattern": "\\d{20}",
            "length": 24
          },
          "sm": {
            "bban_pattern": "[A-Z]\\d{10}[A-Z0-9]{12}",
            "length": 27
          },
          "tl": {
            "bban_pattern": "\\d{19}",
            "length": 23
          },
          "tn": {
            "bban_pattern": "\\d{20}",
            "length": 24
          },
          "tr": {
            "bban_pattern": "\\d{5}[A-Z0-9]{17}",
            "length": 26
          },
          "ua": {
            "bban_pattern": "\\d{25}",
            "length": 29
          },
          "vg": {
            "bban_pattern": "[A-Z]{4}\\d{16}",
            "length": 24
          },
          "xk": {
            "bban_pattern": "\\d{16}",
            "length": 20
          }
        },
        "name": [
          "UBS CLEARING AND EXECUTION SERVICES LIMITED",
          "ABN AMRO CORPORATE FINANCE LIMITED",
          "ABN AMRO FUND MANAGERS LIMITED",
          "ABN AMRO HOARE GOVETT SECURITIES",
          "ABN AMRO HOARE GOVETT CORPORATE FINANCE LTD.",
          "ALKEN ASSET MANAGEMENT",
          "ALKEN ASSET MANAGEMENT",
          "ABN AMRO HOARE GOVETT LIMITED",
          "AAC CAPITAL PARTNERS LIMITED",
          "ABBOTSTONE AGRICULTURAL PROPERTY UNIT TRUST",
          "ABN AMRO QUOTED INVESTMENTS (UK) LIMITED",
          "ABN AMRO MEZZANINE (UK) LIMITED",
          "ABBEY LIFE",
          "SANTANDER UK PLC",
          "OTKRITIE SECURITIES LIMITED",
          "ABC INTERNATIONAL BANK PLC",
          "ALLIED BANK PHILIPPINES (UK) PLC",
          "ABU DHABI ISLAMIC BANK",
          "ABG SUNDAL COLLIER LIMITED",
          "PGMS (GLASGOW) LIMITED",
          "ABINGWORTH MANAGEMENT LIMITED",
          "THE ROYAL BANK OF SCOTLAND PLC (FORMER RBS NV)"
        ],
        "swift_bic": [
          "AACCGB21",
          "AACNGB21",
          "AAFMGB21",
          "AAHOGB21",
          "AAHVGB21",
          "AANLGB21",
          "AANLGB2L",
          "AAOGGB21",
          "AAPEGB21",
          "AAPUGB21",
          "AAQIGB21",
          "ABAZGB21",
          "ABBEGB21",
          "ABBYGB2L",
          "ABCCGB22",
          "ABCEGB2L",
          "ABCMGB21",
          "ABDIGB21",
          "ABECGB21",
          "ABFIGB21",
          "ABMNGB21",
          "ABNAGB21VOC",
          "ANTSGB2LXXX",
          "ANTSGB2LCHA",
          "UBKLGB2LXXX",
          "UBKLGB2LBAK",
          "AKBKGB22XXX",
          "ALEIGB22TSY",
          "AIBKGB2XTSY",
          "ASTPGB2LXXX",
          "MORLGB2LSMK",
          "BSABGB2LXXX",
          "BSCHGB2LEQU",
          "BOFAGB4TLTR",
          "BARBGB2LTOO",
          "BKCHGB2UXXX",
          "BCYPGB2LCSB",
          "BARBGB2LLEI",
          "BOFAGB3SSWI",
          "BOFAGB4TCCD",
          "BOFAGB4TCDO",
          "BOFAGB4TIPA",
          "BOFAGB4TLFS",
          "BOFAGB22OF2",
          "BOFAGB22SCP",
          "BOFAGB22XXX",
          "BOFAGB22CLS",
          "BOFAGB22SEC",
          "BARBGB2LBIR",
          "BARBGB2LHAR",
          "BARBGB2LKEN",
          "BARBGB2LKIL",
          "BARBGB2LWEM",
          "BARBGB2LMAN",
          "BARBGB2LSOU",
          "BRBAGB2LXXX",
          "BCEYGB2LXXX",
          "BKCHGB2LXXX",
          "BCYPGB2LBBB",
          "BCYPGB2LXXX",
          "BCYPGB2LCBB",
          "BCYPGB2LHGB",
          "BCYPGB2LHHB",
          "BCYPGB2LPGB",
          "BCYPGB2LSSB",
          "BCYPGB2LMBB"
        ]
      },
      "barcode": {
        "composite_symbol": [
          "########",
          "????????",
          "####????",
          "????####",
          "##??##??",
          "??##??##"
        ],
        "ean_13": "############",
        "ean_8": "#######",
        "isbn": [
          "978#########",
          "9798########",
          "97910#######",
          "97911#######",
          "97912#######"
        ],
        "ismn": "9790########",
        "issn": "977#########",
        "upc_a": "###########",
        "upc_e": [
          "0######",
          "1######"
        ]
      },
      "basketball": {
        "coaches": [
          "Kenny Atkinson",
          "J.B. Bickerstaff",
          "James Borrego",
          "Jim Boylen",
          "Scott Brooks",
          "Brett Brown",
          "Mike Budenholzer",
          "Rick Carlisle",
          "Dwane Casey",
          "Steve Clifford",
          "Mike D'Antoni",
          "Billy Donovan",
          "Larry Drew",
          "David Fizdale",
          "Alvin Gentry",
          "Dave Joerger",
          "Steve Kerr",
          "Igor Kokoškov",
          "Michael Malone",
          "Nate McMillan",
          "Nick Nurse",
          "Lloyd Pierce",
          "Gregg Popovich",
          "Doc Rivers",
          "Ryan Saunders",
          "Quin Snyder",
          "Erik Spoelstra",
          "Brad Stevens",
          "Terry Stotts",
          "Luke Walton"
        ],
        "players": [
          "Kemba Walker",
          "Kyrie Irving",
          "Kawhi Leonard",
          "Giannis Antetokounmpo",
          "Joel Embiid",
          "Kyle Lowry",
          "Victor Oladipo",
          "Khris Middleton",
          "Bradley Beal",
          "Ben Simmons",
          "Blake Griffin",
          "Nikola Vučević",
          "Dwayne Wade",
          "D'Angelo Russell",
          "Stephen Curry",
          "James Harden",
          "Kevin Durant",
          "Paul George",
          "LeBron James",
          "Russell Westbrook",
          "Damian Lillard",
          "Klay Thompson",
          "Anthony Davis",
          "LaMarcus Aldridge",
          "Nikola Jokić",
          "Karl-Anthony Towns",
          "Dirk Nowitzki"
        ],
        "positions": [
          "Point Guard",
          "Shooting Guard",
          "Small Forward",
          "Power Forward",
          "Center"
        ],
        "teams": [
          "Atlanta Hawks",
          "Boston Celtics",
          "Brooklyn Nets",
          "Charlotte Hornets",
          "Chicago Bulls",
          "Cleveland Cavaliers",
          "Dallas Mavericks",
          "Denver Nuggets",
          "Detroit Pistons",
          "Golden State Warriors",
          "Houston Rockets",
          "Indiana Pacers",
          "Los Angeles Clippers",
          "Los Angeles Lakers",
          "Memphis Grizzlies",
          "Miami Heat",
          "Milwaukee Bucks",
          "Minnesota Timberwolves",
          "New Orleans Pelicans",
          "New York Knicks",
          "Oklahoma City Thunder",
          "Orlando Magic",
          "Philadelphia 76ers",
          "Phoenix Suns",
          "Portland Trail Blazers",
          "Sacramento Kings",
          "San Antonio Spurs",
          "Toronto Raptors",
          "Utah Jazz",
          "Washington Wizards"
        ]
      },
      "beer": {
        "brand": [
          "Corona Extra",
          "Heineken",
          "Budweiser",
          "Becks",
          "BudLight",
          "Pabst Blue Ribbon",
          "Dos Equis",
          "Blue Moon",
          "Stella Artois",
          "Miller Draft",
          "Coors lite",
          "Amstel",
          "Guinness",
          "Kirin",
          "Tsingtao",
          "Sierra Nevada",
          "Rolling Rock",
          "Red Stripe",
          "Paulaner",
          "Patagonia",
          "Delirium",
          "Samuel Adams",
          "Sapporo",
          "Carlsberg",
          "Pacifico",
          "Quimes",
          "Murphys",
          "Birra Moretti",
          "Harp",
          "Fosters",
          "Hoegaarden",
          "Leffe",
          "Lowenbrau"
        ],
        "hop": [
          "Ahtanum",
          "Amarillo",
          "Bitter Gold",
          "Bravo",
          "Brewer’s Gold",
          "Bullion",
          "Cascade",
          "Cashmere",
          "Centennial",
          "Chelan",
          "Chinook",
          "Citra",
          "Cluster",
          "Columbia",
          "Columbus",
          "Comet",
          "Crystal",
          "Equinox",
          "Eroica",
          "Fuggle",
          "Galena",
          "Glacier",
          "Golding",
          "Hallertau",
          "Horizon",
          "Liberty",
          "Magnum",
          "Millennium",
          "Mosaic",
          "Mt. Hood",
          "Mt. Rainier",
          "Newport",
          "Northern Brewer",
          "Nugget",
          "Olympic",
          "Palisade",
          "Perle",
          "Saaz",
          "Santiam",
          "Simcoe",
          "Sorachi Ace",
          "Sterling",
          "Summit",
          "Tahoma",
          "Tettnang",
          "TriplePearl",
          "Ultra",
          "Vanguard",
          "Warrior",
          "Willamette",
          "Yakima Gol"
        ],
        "malt": [
          "Black malt",
          "Caramel",
          "Carapils",
          "Chocolate",
          "Munich",
          "Caramel",
          "Carapils",
          "Chocolate malt",
          "Munich",
          "Pale",
          "Roasted barley",
          "Rye malt",
          "Special roast",
          "Victory",
          "Vienna",
          "Wheat mal"
        ],
        "name": [
          "Pliny The Elder",
          "Founders Kentucky Breakfast",
          "Trappistes Rochefort 10",
          "HopSlam Ale",
          "Stone Imperial Russian Stout",
          "St. Bernardus Abt 12",
          "Founders Breakfast Stout",
          "Weihenstephaner Hefeweissbier",
          "Péché Mortel",
          "Celebrator Doppelbock",
          "Duvel",
          "Dreadnaught IPA",
          "Nugget Nectar",
          "La Fin Du Monde",
          "Bourbon County Stout",
          "Old Rasputin Russian Imperial Stout",
          "Two Hearted Ale",
          "Ruination IPA",
          "Schneider Aventinus",
          "Double Bastard Ale",
          "90 Minute IPA",
          "Hop Rod Rye",
          "Trappistes Rochefort 8",
          "Chimay Grande Réserve",
          "Stone IPA",
          "Arrogant Bastard Ale",
          "Edmund Fitzgerald Porter",
          "Chocolate St",
          "Oak Aged Yeti Imperial Stout",
          "Ten FIDY",
          "Storm King Stout",
          "Shakespeare Oatmeal",
          "Alpha King Pale Ale",
          "Westmalle Trappist Tripel",
          "Samuel Smith’s Imperial IPA",
          "Yeti Imperial Stout",
          "Hennepin",
          "Samuel Smith’s Oatmeal Stout",
          "Brooklyn Black",
          "Oaked Arrogant Bastard Ale",
          "Sublimely Self-Righteous Ale",
          "Trois Pistoles",
          "Bell’s Expedition",
          "Sierra Nevada Celebration Ale",
          "Sierra Nevada Bigfoot Barleywine Style Ale",
          "Racer 5 India Pale Ale, Bear Republic Bre",
          "Orval Trappist Ale",
          "Hercules Double IPA",
          "Maharaj",
          "Maudite",
          "Kirin Inchiban",
          "Delirium Tremens",
          "Delirium Noctorum",
          "Sapporo Premium"
        ],
        "style": [
          "Light Lager",
          "Pilsner",
          "European Amber Lager",
          "Dark Lager",
          "Bock",
          "Light Hybrid Beer",
          "Amber Hybrid Beer",
          "English Pale Ale",
          "Scottish And Irish Ale",
          "Merican Ale",
          "English Brown Ale",
          "Porter",
          "Stout",
          "India Pale Ale",
          "German Wheat And Rye Beer",
          "Belgian And French Ale",
          "Sour Ale",
          "Belgian Strong Ale",
          "Strong Ale",
          "Fruit Beer",
          "Vegetable Beer",
          "Smoke-flavored",
          "Wood-aged Beer"
        ],
        "yeast": [
          "1007 - German Ale",
          "1010 - American Wheat",
          "1028 - London Ale",
          "1056 - American Ale",
          "1084 - Irish Ale",
          "1098 - British Ale",
          "1099 - Whitbread Ale",
          "1187 - Ringwood Ale",
          "1272 - American Ale II",
          "1275 - Thames Valley Ale",
          "1318 - London Ale III",
          "1332 - Northwest Ale",
          "1335 - British Ale II",
          "1450 - Dennys Favorite 50",
          "1469 - West Yorkshire Ale",
          "1728 - Scottish Ale",
          "1968 - London ESB Ale",
          "2565 - Kölsch",
          "1214 - Belgian Abbey",
          "1388 - Belgian Strong Ale",
          "1762 - Belgian Abbey II",
          "3056 - Bavarian Wheat Blend",
          "3068 - Weihenstephan Weizen",
          "3278 - Belgian Lambic Blend",
          "3333 - German Wheat",
          "3463 - Forbidden Fruit",
          "3522 - Belgian Ardennes",
          "3638 - Bavarian Wheat",
          "3711 - French Saison",
          "3724 - Belgian Saison",
          "3763 - Roeselare Ale Blend",
          "3787 - Trappist High Gravity",
          "3942 - Belgian Wheat",
          "3944 - Belgian Witbier",
          "2000 - Budvar Lager",
          "2001 - Urquell Lager",
          "2007 - Pilsen Lager",
          "2035 - American Lager",
          "2042 - Danish Lager",
          "2112 - California Lager",
          "2124 - Bohemian Lager",
          "2206 - Bavarian Lager",
          "2278 - Czech Pils",
          "2308 - Munich Lager",
          "2633 - Octoberfest Lager Blend",
          "5112 - Brettanomyces bruxellensis",
          "5335 - Lactobacillus",
          "5526 - Brettanomyces lambicus",
          "5733 - Pediococcus"
        ]
      },
      "bible": {
        "character": [
          "Adam",
          "Eve",
          "Cain",
          "Abel",
          "Noah",
          "Abraham",
          "Isaac",
          "Jacob",
          "Esau",
          "Rebekah",
          "Moses",
          "Joseph",
          "Joshua",
          "Caleb",
          "Ruth",
          "Samson",
          "Gideon",
          "Esther",
          "Nehemiah",
          "Solomon",
          "Abimelech",
          "Jeremiah",
          "Isaiah",
          "Daniel",
          "Zechariah",
          "Jesus",
          "Apostle Paul",
          "David",
          "Goliath",
          "Samuel",
          "Martha",
          "Mary",
          "Elizabeth",
          "John the Baptist",
          "Peter",
          "James",
          "John",
          "Elijah",
          "Elisha",
          "Lazarus",
          "Cornelius",
          "Chloe",
          "Eunice",
          "Lois",
          "Timothy",
          "Titus",
          "Bathemaeus"
        ],
        "location": [
          "Egypt",
          "Nile",
          "Red Sea",
          "Niniveh",
          "Malta",
          "Greece",
          "Troas",
          "Philippi",
          "Ephesus",
          "Corinth",
          "Macedonia",
          "Thessalonica",
          "Colossae",
          "Achaia",
          "Samaria",
          "Galatia",
          "Judea",
          "Damascus",
          "Rome",
          "Galilee",
          "Syria",
          "Babylon",
          "Jerusalem"
        ],
        "quote": [
          "I am the way and the truth and the life. No one comes to the Father except through me.",
          "But seek first his kingdom and his righteousness, and all these things will be given to you as well.",
          "In the same way, let your light shine before others, that they may see your good deeds and glorify your Father in heaven.",
          "Ask and it will be given to you; seek and you will find; knock and the door will be opened to you. For everyone who asks receives; the one who seeks finds; and to the one who knocks, the door will be opened.",
          "Love the Lord your God with all your heart and with all your soul and with all your mind. This is the first and greatest commandment. And the second is like it: Love your neighbor as yourself. All the Law and the Prophets hang on these two commandments.",
          "Whatever you do, work at it with all your heart.",
          "For when I am powerless, it is then that I am strong.",
          "Love is patient, love is kind, and is not jealous; love does not brag and is not arrogant, does not act unbecomingly; it does not seek its own [will], is not provoked, does not take into account a wrong suffered, does not rejoice in unrighteousness, but rejoices with the truth; bears all things, believes all things, hopes all things, endures all things.",
          "There is no longer Jew or Greek, there is no longer slave or free, there is no longer male and female; for all of you are one in Christ Jesus.",
          "I am not saying this because I am in need, for I have learned to be content whatever the circumstances. I know what it is to be in need, and I know what it is to have plenty. I have learned the secret of being content in any and every situation, whether well fed or hungry, whether living in plenty or in want. I can do everything through him who gives me strength.",
          "Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up"
        ]
      },
      "big_bang_theory": {
        "characters": [
          "Leonard Hofstadter",
          "Sheldon Cooper",
          "Penny",
          "Howard Wolowitz",
          "Raj Koothrappali",
          "Bernadette Rostenkowski",
          "Amy Farrah Fowler",
          "Stuart Bloom",
          "Debbie Wolowitz",
          "Barry Kripke",
          "Emily Sweeney",
          "Wil Wheaton",
          "Dr. V.M. Koothrappali",
          "Dr. Beverly Hofstadter",
          "Bert Kibbler",
          "Mary Cooper",
          "President Siebert",
          "Priya Koothrappali",
          "Zack Johnson",
          "Mrs. Koothrappali",
          "Leslie Winkle",
          "Anu",
          "Lucy",
          "Denise",
          "Mike Rostenkowski"
        ],
        "quotes": [
          "I'm not crazy. My mother had me tested.",
          "Bazinga!",
          "Scissors cuts paper, paper covers rock, rock crushes lizard, lizard poisons Spock, Spock smashes scissors, scissors decapitates lizard, lizard eats paper, paper disproves Spock, Spock vaporizes rock, and as it always has, rock crushes scissors.",
          "That's no reason to cry. One cries because one is sad. For example, I cry because others are stupid, and that makes me sad.",
          "Not knowing is part of the fun. Was that the motto of your community college?",
          "I would have been here sooner but the bus kept stopping for other people to get on it.",
          "Hard as this may be to believe, it’s possible that I’m not boyfriend material."
        ]
      },
      "blood": {
        "group": [
          "#{type}#{rh_factor}"
        ],
        "rh_factor": [
          "+",
          "-"
        ],
        "type": [
          "O",
          "A",
          "B",
          "AB"
        ]
      },
      "bojack_horseman": {
        "characters": [
          "Joseph Sugarman",
          "Princess Carolyn",
          "Kelsey Jannings",
          "Katrina Peanutbutter",
          "Charley Witherspoon",
          "Tom Jumbo-Grumbo",
          "Wanda Pierce",
          "Officer Meow Meow Fuzzyface",
          "Hank Hippopopalous",
          "Tina",
          "Courtney Portnoy",
          "Mr Peanutbutter",
          "Todd Chavez",
          "Wayne",
          "Dr Allen Hu",
          "Sarah Lynn",
          "Jogging Baboon",
          "A Ryan Seacrest Type",
          "Emily",
          "Vincent Adultman",
          "Sebastian St Clair",
          "Hollyhock",
          "Butterscotch Horseman",
          "Roxy",
          "Beatrice Horseman",
          "Herb Kazzaz",
          "Sextina Aquafina",
          "Rutabaga Rabbitowitz",
          "Charlotte Moore",
          "Ralph Stilton",
          "Paparazzi Birds",
          "Lenny Turteltaub",
          "Corduroy Jackson-Jackson",
          "Judah",
          "Woodchuck Coodchuck-Berkowitz",
          "Diane Nguyen",
          "Honey Sugarman",
          "BoJack Horseman",
          "Pinky Penguin"
        ],
        "quotes": [
          "It gets easier. But you have to do it every day, that's the hard part. But it does get easier",
          "Yes, I ate all the muffins, because I have no self-control and I hate myself",
          "Dead on the inside, dead on the outside",
          "The universe is a cruel, uncaring void. The key to being happy isn't a search for meaning. It's to just keep yourself busy with unimportant nonsense, and eventually, you'll be dead",
          "Beer before liquor, never sicker, liquor before beer, never fear, don't do heroin",
          "If you care about what other people think, you're never gonna do anything",
          "Ow, crap. I hate this. Running is terrible. Everything is the worst",
          "For a lot of people, life is just one long, hard kick in the urethra",
          "Spaghetti or not, here I come",
          "I need to go take a shower so I can't tell if I'm crying or not",
          "You know what the problem is with everybody? They all just want to hear what they already believe. No one ever wants to hear the truth",
          "I don't understand how people live. It's amazing to me that people wake up every morning and say: 'Yeah, another day, let's do it.' How do people do it? I don't know how",
          "Not understanding that you're a horrible person doesn't make you less of a horrible person",
          "That's the problem with life, either you know what you want and you don't get what you want, or you get what you want and then you don't know what you want",
          "I do love you, by the way. I mean as much as I'm capable of loving anyone"
        ],
        "tongue_twisters": [
          "Courtney Portnoy portrayed the formerly portly consort in the seaport resort",
          "Courtly roles like the formerly portly consort are Courtney Portnoy's forté",
          "That's sorta been thwarted unfortunately cos Courtney's purportedly falling short of shoring up fourth quadrant support",
          "Portnoy finds joy in hoi polloi boy toy",
          "Did you steal a meal from Neal McBeal the Navy Seal?",
          " audiences are going to adore your tour de force performance as the forceful denim-clad court reporter in 'The Court Reporter Sported Jorts', the jet-setting jort-sporting court reporter story"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "genre": [
          "Classic",
          "Comic/Graphic Novel",
          "Crime/Detective",
          "Fable",
          "Fairy tale",
          "Fanfiction",
          "Fantasy",
          "Fiction narrative",
          "Fiction in verse",
          "Folklore",
          "Historical fiction",
          "Horror",
          "Humor",
          "Legend",
          "Metafiction",
          "Mystery",
          "Mythology",
          "Mythopoeia",
          "Realistic fiction",
          "Science fiction",
          "Short story",
          "Suspense/Thriller",
          "Tall tale",
          "Western",
          "Biography/Autobiography",
          "Essay",
          "Narrative nonfiction",
          "Speech",
          "Textbook",
          "Reference book"
        ],
        "publisher": [
          "Academic Press",
          "Ace Books",
          "Addison-Wesley",
          "Adis International",
          "Airiti Press",
          "André Deutsch",
          "Andrews McMeel Publishing",
          "Anova Books",
          "Anvil Press Poetry",
          "Applewood Books",
          "Apress",
          "Athabasca University Press",
          "Atheneum Books",
          "Atheneum Publishers",
          "Atlantic Books",
          "Atlas Press",
          "Ballantine Books",
          "Banner of Truth Trust",
          "Bantam Books",
          "Bantam Spectra",
          "Barrie & Jenkins",
          "Basic Books",
          "BBC Books",
          "Harvard University Press",
          "Belknap Press",
          "Bella Books",
          "Bellevue Literary Press",
          "Berg Publishers",
          "Berkley Books",
          "Bison Books",
          "Black Dog Publishing",
          "Black Library",
          "Black Sparrow Books",
          "Blackie and Son Limited",
          "Blackstaff Press",
          "Blackwell Publishing",
          "John Blake Publishing",
          "Bloodaxe Books",
          "Bloomsbury Publishing Plc",
          "Blue Ribbon Books",
          "Book League of America",
          "Book Works",
          "Booktrope",
          "Borgo Press",
          "Bowes & Bowes",
          "Boydell & Brewer",
          "Breslov Research Institute",
          "Brill Publishers",
          "Brimstone Press",
          "Broadview Press",
          "Burns & Oates",
          "Butterworth-Heinemann",
          "Caister Academic Press",
          "Cambridge University Press",
          "Candlewick Press",
          "Canongate Books",
          "Carcanet Press",
          "Carlton Books",
          "Carlton Publishing Group",
          "Carnegie Mellon University Press",
          "Casemate Publishers",
          "Cengage Learning",
          "Central European University Press",
          "Chambers Harrap",
          "Charles Scribner's Sons",
          "Chatto and Windus",
          "Chick Publications",
          "Chronicle Books",
          "Churchill Livingstone",
          "Cisco Press",
          "City Lights Publishers",
          "Cloverdale Corporation",
          "D. Appleton & Company",
          "D. Reidel",
          "Da Capo Press",
          "Daedalus Publishing",
          "Dalkey Archive Press",
          "Darakwon Press",
          "David & Charles",
          "DAW Books",
          "Dedalus Books",
          "Del Rey Books",
          "E. P. Dutton",
          "Earthscan",
          "ECW Press",
          "Eel Pie Publishing",
          "Eerdmans Publishing",
          "Edupedia Publications",
          "Ellora's Cave",
          "Elsevier",
          "Emerald Group Publishing",
          "Etruscan Press",
          "Faber and Faber",
          "FabJob",
          "Fairview Press",
          "Farrar, Straus & Giroux",
          "Fearless Books",
          "Felony & Mayhem Press",
          "Firebrand Books",
          "Flame Tree Publishing",
          "Focal Press",
          "G. P. Putnam's Sons",
          "G-Unit Books",
          "Gaspereau Press",
          "Gay Men's Press",
          "Gefen Publishing House",
          "George H. Doran Company",
          "George Newnes",
          "George Routledge & Sons",
          "Godwit Press",
          "Golden Cockerel Press",
          "Hachette Book Group USA",
          "Hackett Publishing Company",
          "Hamish Hamilton",
          "Happy House",
          "Harcourt Assessment",
          "Harcourt Trade Publishers",
          "Harlequin Enterprises Ltd",
          "Harper & Brothers",
          "Harper & Row",
          "HarperCollins",
          "HarperPrism",
          "HarperTrophy",
          "Harry N. Abrams, Inc.",
          "Harvard University Press",
          "Harvest House",
          "Harvill Press at Random House",
          "Hawthorne Books",
          "Hay House",
          "Haynes Manuals",
          "Heyday Books",
          "HMSO",
          "Hodder & Stoughton",
          "Hodder Headline",
          "Hogarth Press",
          "Holland Park Press",
          "Holt McDougal",
          "Horizon Scientific Press",
          "Ian Allan Publishing",
          "Ignatius Press",
          "Imperial War Museum",
          "Indiana University Press",
          "J. M. Dent",
          "Jaico Publishing House",
          "Jarrolds Publishing",
          "Karadi Tales",
          "Kensington Books",
          "Kessinger Publishing",
          "Kodansha",
          "Kogan Page",
          "Koren Publishers Jerusalem",
          "Ladybird Books",
          "Leaf Books",
          "Leafwood Publishers",
          "Left Book Club",
          "Legend Books",
          "Lethe Press",
          "Libertas Academica",
          "Liberty Fund",
          "Library of America",
          "Lion Hudson",
          "Macmillan Publishers",
          "Mainstream Publishing",
          "Manchester University Press",
          "Mandrake of Oxford",
          "Mandrake Press",
          "Manning Publications",
          "Manor House Publishing",
          "Mapin Publishing",
          "Marion Boyars Publishers",
          "Mark Batty Publisher",
          "Marshall Cavendish",
          "Marshall Pickering",
          "Martinus Nijhoff Publishers",
          "Mascot Books",
          "Matthias Media",
          "McClelland and Stewart",
          "McFarland & Company",
          "McGraw-Hill Education",
          "McGraw Hill Financial",
          "Medknow Publications",
          "Naiad Press",
          "Nauka",
          "NavPress",
          "New Directions Publishing",
          "New English Library",
          "New Holland Publishers",
          "New Village Press",
          "Newnes",
          "No Starch Press",
          "Nonesuch Press",
          "Oberon Books",
          "Open Court Publishing Company",
          "Open University Press",
          "Orchard Books",
          "O'Reilly Media",
          "Orion Books",
          "Packt Publishing",
          "Palgrave Macmillan",
          "Pan Books",
          "Pantheon Books at Random House",
          "Papadakis Publisher",
          "Parachute Publishing",
          "Parragon",
          "Pathfinder Press",
          "Paulist Press",
          "Pavilion Books",
          "Peace Hill Press",
          "Pecan Grove Press",
          "Pen and Sword Books",
          "Penguin Books",
          "Random House",
          "Reed Elsevier",
          "Reed Publishing",
          "SAGE Publications",
          "St. Martin's Press",
          "Salt Publishing",
          "Sams Publishing",
          "Schocken Books",
          "Scholastic Press",
          "Charles Scribner's Sons",
          "Seagull Books",
          "Secker & Warburg",
          "Shambhala Publications",
          "Shire Books",
          "Shoemaker & Hoard Publishers",
          "Shuter & Shooter Publishers",
          "Sidgwick & Jackson",
          "Signet Books",
          "Simon & Schuster",
          "T & T Clark",
          "Tachyon Publications",
          "Tammi",
          "Target Books",
          "Tarpaulin Sky Press",
          "Tartarus Press",
          "Tate Publishing & Enterprises",
          "Taunton Press",
          "Taylor & Francis",
          "Ten Speed Press",
          "UCL Press",
          "Unfinished Monument Press",
          "United States Government Publishing Office",
          "University of Akron Press",
          "University of Alaska Press",
          "University of California Press",
          "University of Chicago Press",
          "University of Michigan Press",
          "University of Minnesota Press",
          "University of Nebraska Press",
          "Velazquez Press",
          "Verso Books",
          "Victor Gollancz Ltd",
          "Viking Press",
          "Vintage Books",
          "Vintage Books at Random House",
          "Virago Press",
          "Virgin Publishing",
          "Voyager Books",
          "Brill",
          "Allen Ltd",
          "Zed Books",
          "Ziff Davis Media",
          "Zondervan"
        ],
        "title": [
          "Absalom, Absalom!",
          "After Many a Summer Dies the Swan",
          "Ah, Wilderness!",
          "All Passion Spent",
          "All the King's Men",
          "Alone on a Wide, Wide Sea",
          "An Acceptable Time",
          "Antic Hay",
          "An Evil Cradling",
          "Arms and the Man",
          "As I Lay Dying",
          "A Time to Kill",
          "Behold the Man",
          "Beneath the Bleeding",
          "Beyond the Mexique Bay",
          "Blithe Spirit",
          "Blood's a Rover",
          "Blue Remembered Earth",
          "Rosemary Sutcliff",
          "Françoise Sagan",
          "Brandy of the Damned",
          "Bury My Heart at Wounded Knee",
          "Butter In a Lordly Dish",
          "By Grand Central Station I Sat Down and Wept",
          "Cabbages and Kings",
          "Carrion Comfort",
          "A Catskill Eagle",
          "Clouds of Witness",
          "A Confederacy of Dunces",
          "Consider Phlebas",
          "Consider the Lilies",
          "Cover Her Face",
          "The Cricket on the Hearth",
          "The Curious Incident of the Dog in the Night-Time",
          "The Daffodil Sky",
          "Dance Dance Dance",
          "A Darkling Plain",
          "Death Be Not Proud",
          "The Doors of Perception",
          "Down to a Sunless Sea",
          "Dulce et Decorum Est",
          "Dying of the Light",
          "East of Eden",
          "Ego Dominus Tuus",
          "Endless Night",
          "Everything is Illuminated",
          "Eyeless in Gaza",
          "Fair Stood the Wind for France",
          "Fame Is the Spur",
          "Edna O'Brien",
          "The Far-Distant Oxus",
          "A Farewell to Arms",
          "Far From the Madding Crowd",
          "Fear and Trembling",
          "For a Breath I Tarry",
          "For Whom the Bell Tolls",
          "Frequent Hearses",
          "From Here to Eternity",
          "A Glass of Blessings",
          "The Glory and the Dream",
          "The Golden Apples of the Sun",
          "The Golden Bowl",
          "Gone with the Wind",
          "The Grapes of Wrath",
          "Great Work of Time",
          "The Green Bay Tree",
          "A Handful of Dust",
          "Have His Carcase",
          "The Heart Is a Lonely Hunter",
          "The Heart Is Deceitful Above All Things",
          "His Dark Materials",
          "The House of Mirth",
          "Sleep the Brave",
          "I Know Why the Caged Bird Sings",
          "I Sing the Body Electric",
          "I Will Fear No Evil",
          "If I Forget Thee Jerusalem",
          "If Not Now, When?",
          "Infinite Jest",
          "In a Dry Season",
          "In a Glass Darkly",
          "In Death Ground",
          "In Dubious Battle",
          "An Instant In The Wind",
          "It's a Battlefield",
          "Jacob Have I Loved",
          "O Jerusalem!",
          "Jesting Pilate",
          "The Last Enemy",
          "The Last Temptation",
          "The Lathe of Heaven",
          "Let Us Now Praise Famous Men",
          "Lilies of the Field",
          "This Lime Tree Bower",
          "The Line of Beauty",
          "The Little Foxes",
          "Little Hands Clapping",
          "Look Homeward, Angel",
          "Look to Windward",
          "The Man Within",
          "Many Waters",
          "A Many-Splendoured Thing",
          "The Mermaids Singing",
          "The Millstone",
          "The Mirror Crack'd from Side to Side",
          "Moab Is My Washpot",
          "The Monkey's Raincoat",
          "A Monstrous Regiment of Women",
          "The Moon by Night",
          "Mother Night",
          "The Moving Finger",
          "The Moving Toyshop",
          "Mr Standfast",
          "Nectar in a Sieve",
          "The Needle's Eye",
          "Nine Coaches Waiting",
          "No Country for Old Men",
          "No Highway",
          "Noli Me Tangere",
          "No Longer at Ease",
          "Now Sleeps the Crimson Petal",
          "Number the Stars",
          "Of Human Bondage",
          "Of Mice and Men",
          "Oh! To be in England",
          "The Other Side of Silence",
          "The Painted Veil",
          "Pale Kings and Princes",
          "The Parliament of Man",
          "Paths of Glory",
          "A Passage to India",
          "O Pioneers!",
          "Postern of Fate",
          "Precious Bane",
          "The Proper Study",
          "Quo Vadis",
          "Recalled to Life",
          "Recalled to Life",
          "Ring of Bright Water",
          "The Road Less Traveled",
          "A Scanner Darkly",
          "Shall not Perish",
          "The Skull Beneath the Skin",
          "The Soldier's Art",
          "Some Buried Caesar",
          "Specimen Days",
          "The Stars' Tennis Balls",
          "Stranger in a Strange Land",
          "Such, Such Were the Joys",
          "A Summer Bird-Cage",
          "The Sun Also Rises",
          "Surprised by Joy",
          "A Swiftly Tilting Planet",
          "Taming a Sea Horse",
          "Tender Is the Night",
          "Terrible Swift Sword",
          "That Good Night",
          "That Hideous Strength",
          "Things Fall Apart",
          "This Side of Paradise",
          "Those Barren Leaves, Thrones, Dominations",
          "Tiger! Tiger!",
          "A Time of Gifts",
          "Time of our Darkness",
          "Time To Murder And Create",
          "Tirra Lirra by the River",
          "To a God Unknown",
          "To Sail Beyond the Sunset",
          "To Say Nothing of the Dog",
          "To Your Scattered Bodies Go",
          "The Torment of Others",
          "Unweaving the Rainbow",
          "Vanity Fair",
          "Vile Bodies",
          "The Violent Bear It Away",
          "Waiting for the Barbarians",
          "The Waste Land",
          "The Way of All Flesh",
          "The Way Through the Woods",
          "The Wealth of Nations",
          "What's Become of Waring",
          "When the Green Woods Laugh",
          "Where Angels Fear to Tread",
          "The Widening Gyre",
          "Wildfire at Midnight",
          "The Wind's Twelve Quarters",
          "The Wings of the Dove",
          "The Wives of Bath",
          "The World, the Flesh and the Devil",
          "The Yellow Meads of Asphodel"
        ]
      },
      "books": {
        "the_kingkiller_chronicle": {
          "books": [
            "The Name of the Wind",
            "The Wise Man's Fear",
            "The Doors of Stone"
          ],
          "characters": [
            "Abenthy",
            "Auri",
            "Bast",
            "Brandeur",
            "Bredon",
            "Cinder",
            "Denna",
            "Devi",
            "Elodin",
            "Felurian",
            "Haliax",
            "Kvothe",
            "Laurian",
            "Lanre",
            "Marten",
            "Master Ash",
            "Skarpi",
            "Shehyn",
            "Simmon",
            "Tehlu",
            "Tempi",
            "Vashet",
            "Wilem"
          ],
          "creatures": [
            "Angel",
            "Demon",
            "Draccus",
            "Keth-Selhan",
            "Scrael",
            "Sipquick",
            "Skin dancer"
          ],
          "locations": [
            "Ademre",
            "Aryen",
            "Baedn-Bryt",
            "Crosson",
            "Eld",
            "Evesdown",
            "Hallowfell",
            "Imre",
            "Levinshir",
            "Newarre",
            "Severen",
            "Tarbean",
            "Temerant",
            "Waystone Inn",
            "Yll"
          ]
        }
      },
      "bossa_nova": {
        "artists": [
          "Alaide Costa",
          "Antonio Carlos Jobim",
          "Astrud Gilberto",
          "Baden Powell",
          "Bebel Gilberto",
          "Billy Blanco",
          "Bola Sete",
          "Caetano Veloso",
          "Carlos Lyra",
          "Chico Buarque",
          "Chico Moraes",
          "Danilo Caymmi",
          "Dori Caymmi",
          "Dorival Caymmi",
          "Edu Lobo",
          "Elis Regina",
          "Elizeth Cardoso",
          "Elza Soares",
          "Gal Costa",
          "Geraldo Vandre",
          "Gilberto Gil",
          "Johnny Alf",
          "Jorge Ben Jor",
          "Joyce Moreno",
          "Joao Donato",
          "Joao Gilberto",
          "Joao Gilberto",
          "Laurindo de Almeida",
          "Leny Andrade",
          "Lisa Ono",
          "Lucio Alves",
          "Luiz Bonfa",
          "Luiz Eca",
          "Marcos Valle",
          "Maria Bethania",
          "Minas",
          "Nara Leao",
          "Nelson Motta",
          "Novos Baianos",
          "Os Cariocas",
          "Oscar Castro Neves",
          "Roberto Menescal",
          "Ronaldo Boscoli",
          "Sergio Mendes",
          "Stan Getz",
          "Toquinho",
          "Vinicius de Moraes",
          "Wanda Sa",
          "Wilson Simonal",
          "Zimbo Trio"
        ],
        "songs": [
          "A Banda",
          "Acabou Chorare",
          "Alo, alo Marciano",
          "Aquarela",
          "Aquarela Do Brasil",
          "Batucada Surgiu",
          "Bossa Jazz",
          "Canto de Ossanha",
          "Catavento",
          "Chega de Saudade",
          "Chora Tua Tristeza",
          "Chuva de Prata",
          "Chao de Giz",
          "Clube do Samba",
          "Coisa Mais Linda",
          "Corcovado",
          "Calice",
          "Desafinado",
          "Dindi",
          "Diz Que Fui Por Ai",
          "Drao",
          "Ela E Carioca",
          "Entardecendo",
          "Eu Bebo Sim",
          "Eu Nao Existo Sem Voce",
          "Eu Preciso Dizer Que Te Amo",
          "Eu Sei Que Vou Te Amar",
          "Eu Sei Que Vou Te Amar",
          "Garota de Ipanema",
          "Ginza Samba",
          "Influencia Do Jazz",
          "Insensatez",
          "Ladainha",
          "Luiza",
          "Malandro",
          "Manha De Carnaval",
          "Mas Que Nada",
          "Moonlight in Rio",
          "O Barquinho",
          "O Bebado e A Equilibrista",
          "O Leaozinho",
          "O Que E Que A Bahiana Tem",
          "Para Viver Um Grande Amor",
          "Piston de Gafieira",
          "Pra Nao Dizer Que Nao Falei Das Flores",
          "Samba De Uma Nota So",
          "Samba Esquema Novo",
          "Samba da Bencao",
          "Samba da Bencao",
          "Samba de Orly",
          "Samba em Prelúdio",
          "Sabado em Copacabana",
          "Tarde Em Itapoa",
          "Valsa de Uma Cidade",
          "Voce E Linda",
          "Zum-Zum",
          "Agua de beber",
          "Aguas de Marco"
        ]
      },
      "breaking_bad": {
        "character": [
          "Walter White",
          "Hank Schrader",
          "Skyler White",
          "Jesse Pinkman",
          "Gustavo Fring",
          "Mike Ehrmantraut",
          "Jimmy McGill",
          "Hector 'Tio' Salamanca",
          "Lydia Rodarte-Quayle",
          "Jane Margolis",
          "Tuco Salamanca",
          "The Cousins",
          "Ted Beneke",
          "Gale Boetticher",
          "Walter White Jr.",
          "Todd Alquist",
          "Brock Cantillo",
          "Andrea Cantillo",
          "Jack Welker",
          "Krazy-8",
          "'Don' Eladio Vuente",
          "Marie Schrader",
          "Gretchen Schwartz",
          "Huell Babineaux",
          "Tortuga",
          "Victor",
          "Juan Bolsa",
          "Tomás Cantillo",
          "Holly White",
          "Steven Gomez",
          "Emilio Koyama",
          "Drew Sharp",
          "Declan",
          "Carmen Molina",
          "Brandon 'Badger' Mayhew",
          "Christian 'Combo' Ortega",
          "Rival Dealers",
          "Ed",
          "Ken",
          "Kenny",
          "Group Leader",
          "George Merkert",
          "Adam Pinkman",
          "Mrs Pinkman",
          "No-Doze",
          "Gonzo"
        ],
        "episode": [
          "Pilot",
          "Cat's in the Bag...",
          "...And the Bag's in the River",
          "Cancer Man",
          "Gray Matter",
          "Crazy Handful of Nothin",
          "A No-Rough-Stuff-Type Deal",
          "Seven Thirty-Seven",
          "Grilled",
          "Bit by a Dead Bee",
          "Down",
          "Breakage",
          "Peekaboo",
          "Negro y Azul",
          "Better Call Saul",
          "4 Days Out",
          "Over",
          "Mandala",
          "Phoenix",
          "ABQ",
          "No Más",
          "Caballo Sin Nombre",
          "I.F.T.",
          "Green Light",
          "Más",
          "Sunset",
          "One Minute",
          "I See You",
          "Kafkaesque",
          "Fly",
          "Abiquiu",
          "Half Measures",
          "Full Measure",
          "Box Cutter",
          "Thirty-Eight Snub",
          "Open House",
          "Bullet Points",
          "Shotgun",
          "Cornered",
          "Problem Dog",
          "Hermanos",
          "Bug",
          "Salud",
          "Crawl Space",
          "End Times",
          "Face Off",
          "Live Free or Die",
          "Madrigal",
          "Hazard Pay",
          "Fifty-One",
          "Dead Freight",
          "Buyout",
          "Say My Name",
          "Gliding Over All",
          "Blood Money",
          "Buried",
          "Confessions",
          "Rabid Dog",
          "To'hajiilee",
          "Ozymandias",
          "Granite State",
          "Felina"
        ]
      },
      "brooklyn_nine_nine": {
        "characters": [
          "Jake Peralta",
          "Amy Santiago",
          "Rosa Diaz",
          "Raymond Holt",
          "Gina Linetti",
          "Charles Boyle",
          "Terry Jeffords",
          "Hitchcock",
          "Scully",
          "Cheddar",
          "Kevin Cozner",
          "Adrian Pimento",
          "Doug Judy",
          "Nikolaj Boyle",
          "Madeline Wuntch",
          "Mlepnos"
        ],
        "quotes": [
          "Cool, cool, cool, cool, cool. No doubt, no doubt, no doubt.",
          "Sarge, with all due respect, I am gonna completely ignore everything you just said.",
          "A place where everybody knows your name is hell. You're describing hell.",
          "If I die, turn my tweets into a book.",
          "Title of your sex tape.",
          "The English language can not fully capture the depth and complexity of my thoughts, so I'm incorporating emojis into my speech to better express myself. Winky face.",
          "Captain Wuntch, good to see you. But if you're here, who's guarding Hades?",
          "Anyone over the age of six celebrating a birthday should go to hell.",
          "Great, I'd like your $8-est bottle of wine, please.",
          "Captain, hey! Welcome to the murder.",
          "It's Gina's phone. Leave me a voice mail. I won't check it 'cause it's not 1993.",
          "You should make me your campaign manager. I was born for politics. I have great hair and I love lying.",
          "It's not that weird to say, 'May I have some cocaine?"
        ]
      },
      "buffy": {
        "actors": [
          "Sarah Michelle Geller",
          "Alyson Hannigan",
          "David Boreanaz",
          "Eliza Dushku",
          "Michelle Trachtenberg",
          "Rachel Bilson",
          "Seth Green",
          "John Ritter",
          "Amy Adams",
          "Ashanti",
          "Eric Balfour",
          "Julie Benz",
          "Clare Cramer",
          "Carmine Giovinazzo",
          "Clea Duvall",
          "Eion Bailey",
          "Shane West",
          "Pedro Pascal",
          "Kal Penn",
          "Amber Tamblyn"
        ],
        "big_bads": [
          "The Master",
          "Drusilla",
          "Angelus",
          "Mayor Richard Wilkins III",
          "Maggie Walsh",
          "Adam",
          "Warren Mears",
          "Caleb",
          "The First Evil",
          "Dark Willow",
          "The Anointed One"
        ],
        "characters": [
          "Buffy Summers",
          "Xander Harris",
          "Willow Rosenberg",
          "Rupert Giles",
          "Cordelia Chase",
          "Angel",
          "Spike",
          "Oz",
          "Anya Jenkins",
          "Dawn Summers",
          "Joyce Summers",
          "Tara Maclay",
          "Riley Finn",
          "Drusilla",
          "Faith Lehane",
          "Jonathan Levinson",
          "Harmony Kendall",
          "Amy Madison",
          "Andrew Wells",
          "Darla",
          "Ethan Rayne"
        ],
        "episodes": [
          "Welcome to the Hellmouth",
          "The Harvest",
          "Witch",
          "Teacher's Pet",
          "Never Kill a Boy on the First Date",
          "The Pack",
          "Angel",
          "I Robot, You Jane",
          "The Puppet Show",
          "Nightmares",
          "Out of Mind, Out of Sight",
          "Prophecy Girl",
          "When She Was Bad",
          "Some Assembly Required",
          "School Hard",
          "Inca Mummy Girl",
          "Reptile Boy",
          "Halloween",
          "Lie to Me",
          "The Dark Age",
          "What's My Line, Part One",
          "What's My Line, Part Two",
          "Ted",
          "Bad Eggs",
          "Surprise",
          "Innocence",
          "Phases",
          "Bewitched, Bothered and Bewildered",
          "Passion",
          "Killed by Death",
          "I Only Have Eyes for You",
          "Go Fish",
          "Becoming, Part One",
          "Becoming, Part Two",
          "Anne",
          "Dead Man's Party",
          "Faith, Hope & Trick",
          "Beauty and the Beasts",
          "Homecoming",
          "Band Candy",
          "Revelations",
          "Lovers Walk",
          "The Wish",
          "Amends",
          "Gingerbread",
          "Helpless",
          "The Zeppo",
          "Bad Girls",
          "Consequences",
          "Doppelgangland",
          "Enemies",
          "Earshot",
          "Choices",
          "The Prom",
          "Graduation Day, Part One",
          "Graduation Day, Part Two",
          "The Freshman",
          "Living Conditions",
          "The Harsh Light of Day",
          "Fear, Itself",
          "Beer Bad",
          "Wild at Heart",
          "The Initiative",
          "Pangs",
          "Something Blue",
          "Hush",
          "Doomed",
          "A New Man",
          "The I in Team",
          "Goodbye Iowa",
          "This Year's Girl",
          "Who Are You",
          "Superstar",
          "Where the Wild Things Are",
          "New Moon Rising",
          "The Yoko Factor",
          "Primeval",
          "Restless",
          "Buffy vs. Dracula",
          "Real Me",
          "The Replacement",
          "Out of My Mind",
          "No Place Like Home",
          "Family",
          "Fool for Love",
          "Shadow",
          "Listening to Fear",
          "Into the Woods",
          "Triangle",
          "Checkpoint",
          "Blood Ties",
          "Crush",
          "I Was Made to Love You",
          "The Body",
          "Forever",
          "Intervention",
          "Tough Love",
          "Spiral",
          "The Weight of the World",
          "The Gift",
          "Bargaining, Part One",
          "Bargaining, Part Two",
          "After Life",
          "Flooded",
          "Life Serial",
          "All the Way",
          "Once More, with Feeling",
          "Tabula Rasa",
          "Smashed",
          "Wrecked",
          "Gone",
          "Doublemeat Palace",
          "Dead Things",
          "Older and Far Away",
          "As You Were",
          "Hell's Bells",
          "Normal Again",
          "Entropy",
          "Seeing Red",
          "Villains",
          "Two to Go",
          "Grave",
          "Lessons",
          "Beneath You",
          "Same Time, Same Place",
          "Help",
          "Selfless",
          "Him",
          "Conversations with Dead People",
          "Sleeper",
          "Never Leave Me",
          "Bring on the Night",
          "Showtime",
          "Potential",
          "The Killer in Me",
          "First Date",
          "Get It Done",
          "Storyteller",
          "Lies My Parents Told Me",
          "Dirty Girls",
          "Empty Places",
          "Touched",
          "End of Days",
          "Chosen"
        ],
        "quotes": [
          "In every generation there is a chosen one.",
          "Power. I have it. They don't. This bothers them.",
          "No weapons, no friends, no hope. Take all that away, and what's left? Me.",
          "I'm the thing that monsters have nightmares about.",
          "Strong is fighting. It's hard and it's painful, and it's every day. It's what we have to do. And we can do it together.",
          "I'm beyond tired. I'm beyond scared. I'm standing on the mouth of hell, and it's gonna swallow me whole. And it'll choke on me. We're not ready? They're not ready.",
          "There is only one thing on this earth more powerful than evil. And that's us.",
          "So what — are we helpless puppets? No. The big moments are gonna come. You can't help that. It's what you do afterwards that counts. That's when you find out who you are.",
          "When it's really something that matters, they fight. I mean, they're lame morons for fighting, but they do. They never— they never quit. And so I guess I will keep fighting, too.",
          "If the apocalypse comes, beep me.",
          "The hardest thing in this world is to live in it.",
          "In every generation there is a chosen one. She alone will stand against the vampires, the demons, and the forces of darkness. She is the slayer.",
          "I may be dead, but I'm still pretty. Which is more than I can say for you.",
          "Cordelia, your mouth is open, sound is coming from it. This is never good.",
          "Harmony, when you tried to be head cheerleader, you were bad. When you tried to chair the Homecoming committee, you were really bad. But when you try to be bad... you suck.",
          "They were supposed to be my light at the end of the tunnel. I guess they were a train.",
          "I don't know what's coming next. But I do know it's gonna be just like this.",
          "Well, I like you. You're nice, and you're funny, and you don't smoke. Yeah, okay, werewolf, but... that's not all the time. I mean, three days out of the month, I'm not much fun to be around either.",
          "A good Sunnydale rule-of-thumb? Avoid white-skinned men in capes.",
          "I can kill a couple of geeks all by myself. But, hey, if you'd like to watch... I mean, that's what you Watchers are good at, right? Watching?",
          "I'm talking! Don't interrupt me! Insignificant man. I am Willow. I am death. If you dare defy me, I will call down my fury, exact fresh vengeance, and make your worst fears come true. Okay?",
          "Just because you're better than us doesn't mean you can be all superior.",
          "You should never hurt the feelings of a brutal killer. You know, that's, uh, that's actually some pretty good advice.",
          "A vampire isn't a person at all. It may have the movements, the memories, even the personality of the person it took over, but it's a demon at the core. There is no halfway.",
          "I'm leaning towards blind panic myself.",
          "Well, I'm a hair's breath from investigating bunnies at the moment, so I'm open to anything.",
          "Buffy, what you said, it flies in the face of everything we've ever... every generation has ever done in the fight against evil. I think it's bloody brilliant.",
          "Now, I know you haven't been in the game for a while, mate, but we still do kill people. Sort of our raison d'etre, you know.",
          "She wouldn't even kill me. She just left. She didn't even care enough to cut off my head, or set me on fire. I mean, is that too much to ask? You know? Some little sign that she cared? It was the truce with Buffy that did it. Dru said I'd gone soft - wasn't demon enough for the likes of her.",
          "Well, isn't this usually the part where you... kick me in the head and run out, virtue fluttering?",
          "Oh, I don't know. Looking in the mirror every day and seeing nothing there...it's an overrated pleasure.",
          "Sorry about the chains. It's not that I don't trust you, it's... Actually, it is that I don't trust you.",
          "I'm just so excited. They come in, I help them, they give us money in exchange for goods, you give me money for working for you. I have a place in the world now. I'm part of the system. I'm a workin' gal.",
          "Wow, it's like, one second you were this klutzy teenager with false memories and a history of kleptomania, and then suddenly you were a hero. A hero with a much abbreviated life span.",
          "You gotta give me something to do. There's no way I'm sleeping. Don't you need anyone dead? Or maimed? I can settle for maimed.",
          "You know, I honestly don't think there's a human word fabulous enough for me.",
          "We don't know much about them except for they're very ugly, and they're very mobile for blind people.",
          "And I wonder what possible catastrophe came crashing down from heaven and brought this dashing stranger to tears?"
        ]
      },
      "business": {
        "credit_card_numbers": [
          "1234-2121-1221-1211",
          "1212-1221-1121-1234",
          "1211-1221-1234-2201",
          "1228-1221-1221-1431"
        ],
        "credit_card_types": [
          "visa",
          "mastercard",
          "american_express",
          "discover",
          "diners_club",
          "jcb",
          "switch",
          "solo",
          "dankort",
          "maestro",
          "forbrugsforeningen",
          "laser"
        ]
      },
      "camera": {
        "brand": [
          "Canon",
          "Benq",
          "Casio",
          "Fujifilm",
          "Hasselblad",
          "Kodak",
          "Leica",
          "Nikon",
          "Olympus",
          "Panasonic",
          "Pentax",
          "Polaroid",
          "Ricoh",
          "Samsung",
          "Sigma",
          "Sony",
          "YI"
        ],
        "brand_with_model": [
          "Benq G2F",
          "Canon 450D",
          "Canon EOS 5D Mark IV",
          "Canon EOS 5DS",
          "Canon EOS 5DS R",
          "Canon EOS 700D",
          "Canon EOS 70D",
          "Canon EOS 750D",
          "Canon EOS 760D",
          "Canon EOS 7D Mark II",
          "Canon EOS 80D",
          "Canon EOS M10",
          "Canon EOS M3",
          "Canon EOS M5",
          "Canon IXUS 132 HS",
          "Canon IXUS 140",
          "Canon IXUS 145",
          "Canon IXUS 150",
          "Canon IXUS 155",
          "Canon IXUS 160",
          "Canon IXUS 165",
          "Canon IXUS 170",
          "Canon IXUS 175",
          "Canon IXUS 180",
          "Canon IXUS 255 HS",
          "Canon IXUS 265 HS",
          "Canon IXUS 275 HS",
          "Canon IXUS 285 HS",
          "Canon PowerShot A1400",
          "Canon PowerShot A2500",
          "Canon PowerShot A3500 IS",
          "Canon PowerShot D30",
          "Canon PowerShot G1 X Mark II",
          "Canon PowerShot G16",
          "Canon PowerShot G3 X",
          "Canon PowerShot G5 X",
          "Canon PowerShot G7 X",
          "Canon PowerShot G7 X Mark II",
          "Canon PowerShot G9 X",
          "Canon PowerShot G9 X Mark II",
          "Canon PowerShot N100",
          "Canon PowerShot S120",
          "Canon PowerShot S200",
          "Canon PowerShot SX170 IS",
          "Canon PowerShot SX270 HS",
          "Canon PowerShot SX280 HS",
          "Canon PowerShot SX400 IS",
          "Canon PowerShot SX410 IS",
          "Canon PowerShot SX420 IS",
          "Canon PowerShot SX510 HS",
          "Canon PowerShot SX520 HS",
          "Canon PowerShot SX530 HS",
          "Canon PowerShot SX540 HS",
          "Canon PowerShot SX60 HS",
          "Canon PowerShot SX600 HS",
          "Canon PowerShot SX610 HS",
          "Canon PowerShot SX620 HS",
          "Canon PowerShot SX700 HS",
          "Canon PowerShot SX710 HS",
          "Canon PowerShot SX720 HS",
          "Canon XC10",
          "Casio Exilim EX-10",
          "Casio Exilim EX-100",
          "Casio Exilim EX-H30",
          "Casio Exilim EX-TR50",
          "Casio Exilim EX-ZR100",
          "Casio Exilim EX-ZR1000",
          "Casio Exilim EX-ZR15",
          "Casio Exilim EX-ZR200",
          "Casio Exilim EX-ZR300",
          "Casio Exilim EX-ZR400",
          "Casio Exilim EX-ZR700",
          "Casio Exilim EX-ZR800",
          "Casio Exilim EX-ZS15",
          "Fujifilm FinePix AX200",
          "Fujifilm FinePix S1",
          "Fujifilm FinePix S9800",
          "Fujifilm FinePix S9900W",
          "Fujifilm FinePix XP80",
          "Fujifilm FinePix XP90",
          "Fujifilm GFX 50S",
          "Fujifilm X-A10",
          "Fujifilm X-A2",
          "Fujifilm X-A3",
          "Fujifilm X-E2",
          "Fujifilm X-E2S",
          "Fujifilm X-Pro2",
          "Fujifilm X-T1",
          "Fujifilm X-T10",
          "Fujifilm X-T2",
          "Fujifilm X100T",
          "Fujifilm X30",
          "Fujifilm X70",
          "Fujifilm XQ2",
          "Hasselblad X1D",
          "Kodak EasyShare M530",
          "Kodak EasyShare M550",
          "Kodak EasyShare M575",
          "Kodak EasyShare M590",
          "Kodak EasyShare M750",
          "Kodak EasyShare Max Z990",
          "Kodak EasyShare Mini M200",
          "Kodak EasyShare Sport C123",
          "Kodak EasyShare Sport C135",
          "Kodak EasyShare Touch M5370",
          "Kodak EasyShare Touch M577",
          "Kodak EasyShare Z5120",
          "Kodak EasyShare Z981",
          "Kodak Pixpro Astro Zoom AZ651",
          "Kodak Pixpro S-1",
          "Leica C",
          "Leica D-Lux",
          "Leica M",
          "Leica M Edition 60",
          "Leica M Monochrom",
          "Leica Q",
          "Leica SL",
          "Leica T",
          "Leica TL",
          "Leica V-Lux",
          "Leica X",
          "Leica X Vario",
          "Leica X-U",
          "Nikon 1 AW1",
          "Nikon 1 J4",
          "Nikon 1 J5",
          "Nikon 1 S2",
          "Nikon 1 V3",
          "Nikon Coolpix A10",
          "Nikon Coolpix A100",
          "Nikon Coolpix A900",
          "Nikon Coolpix AW120",
          "Nikon Coolpix AW130",
          "Nikon Coolpix B500",
          "Nikon Coolpix B700",
          "Nikon Coolpix L31",
          "Nikon Coolpix L32",
          "Nikon Coolpix L830",
          "Nikon Coolpix L840",
          "Nikon Coolpix P340",
          "Nikon Coolpix P530",
          "Nikon Coolpix P600",
          "Nikon Coolpix P610",
          "Nikon Coolpix P900",
          "Nikon Coolpix S2900",
          "Nikon Coolpix S32",
          "Nikon Coolpix S33",
          "Nikon Coolpix S3600",
          "Nikon Coolpix S3700",
          "Nikon Coolpix S5300",
          "Nikon Coolpix S6800",
          "Nikon Coolpix S6900",
          "Nikon Coolpix S7000",
          "Nikon Coolpix S810c",
          "Nikon Coolpix S9700",
          "Nikon Coolpix S9900",
          "Nikon Coolpix W100",
          "Nikon D3100",
          "Nikon D3200",
          "Nikon D3300",
          "Nikon D3400",
          "Nikon D3S",
          "Nikon D4",
          "Nikon D4S",
          "Nikon D5",
          "Nikon D5",
          "Nikon D500",
          "Nikon D5300",
          "Nikon D5500",
          "Nikon D5600",
          "Nikon D610",
          "Nikon D6Nikon D810",
          "Nikon D7200",
          "Nikon D750",
          "Nikon D810A",
          "Nikon Df",
          "Nikon DL18-50",
          "Nikon DL24-500",
          "Nikon DL24-85",
          "Olympus OM-D E-M1 Mark II",
          "Olympus OM-D E-M10",
          "Olympus OM-D E-M10 II",
          "Olympus OM-D E-M5 II",
          "Olympus PEN E-PL7",
          "Olympus PEN E-PL8",
          "Olympus PEN-F",
          "Olympus Stylus 1s",
          "Olympus Stylus SH-1",
          "Olympus Stylus SH-2",
          "Olympus Stylus SH-3",
          "Olympus Stylus SP-100",
          "Olympus Stylus Tough TG-3",
          "Olympus Stylus Tough TG-4",
          "Olympus Stylus Tough TG-850 iHS",
          "Olympus Stylus Tough TG-860",
          "Olympus Stylus Tough TG-870",
          "Panasonic Lumix DC-FZ80",
          "Panasonic Lumix DC-GH5",
          "Panasonic Lumix DMC-FZ1000",
          "Panasonic Lumix DMC-FZ300",
          "Panasonic Lumix DMC-G7",
          "Panasonic Lumix DMC-GF7",
          "Panasonic Lumix DMC-GF8",
          "Panasonic Lumix DMC-GH4",
          "Panasonic Lumix DMC-GM5",
          "Panasonic Lumix DMC-GX8",
          "Panasonic Lumix DMC-GX85",
          "Panasonic Lumix DMC-LX10",
          "Panasonic Lumix DMC-LX100",
          "Panasonic Lumix DMC-LZ40",
          "Panasonic Lumix DMC-SZ10",
          "Panasonic Lumix DMC-SZ8",
          "Panasonic Lumix DMC-TS30",
          "Panasonic Lumix DMC-TS6",
          "Panasonic Lumix DMC-ZS100",
          "Panasonic Lumix DMC-ZS35",
          "Panasonic Lumix DMC-ZS40",
          "Panasonic Lumix DMC-ZS45",
          "Panasonic Lumix DMC-ZS50",
          "Panasonic Lumix DMC-ZS60",
          "Panasonic Lumix FZ2500",
          "Panasonic Lumix G85",
          "Pentax 645Z",
          "Pentax Efina",
          "Pentax K-1",
          "Pentax K-3",
          "Pentax K-3 II",
          "Pentax K-5 II",
          "Pentax K-5 IIs",
          "Pentax K-50",
          "Pentax K-500",
          "Pentax K-70",
          "Pentax K-S1",
          "Pentax K-S2",
          "Pentax MX-1",
          "Pentax Q-S1",
          "Pentax Q7",
          "Pentax WG-10",
          "Pentax WG-3",
          "Pentax WG-3 GPS",
          "Pentax WG-30",
          "Pentax XG-1",
          "POLAROID IS2132",
          "Ricoh CX3",
          "Ricoh CX4",
          "Ricoh CX5",
          "Ricoh CX6",
          "Ricoh G700SE",
          "Ricoh GR",
          "Ricoh GR Digital IV",
          "Ricoh GXR Mount A12",
          "Ricoh PX",
          "Ricoh WG-4",
          "Ricoh WG-4 GPS",
          "Samsung NX Mini",
          "Samsung NX1",
          "Samsung NX30",
          "Samsung NX300",
          "Samsung NX3000",
          "Samsung NX500",
          "Samsung WB1100F",
          "Samsung WB2200F",
          "Samsung WB350F",
          "Samsung WB35F",
          "Samsung WB50F",
          "Sigma dp0 Quattro",
          "Sigma dp1 Quattro",
          "Sigma dp2 Quattro",
          "Sigma dp3 Quattro",
          "Sigma sd Quattro",
          "Sigma sd Quattro H",
          "Sony Alpha 5100",
          "Sony Alpha 6300",
          "Sony Alpha 6500",
          "Sony Alpha 68",
          "Sony Alpha 7 II",
          "Sony Alpha 77 II",
          "Sony Alpha 7R II",
          "Sony Alpha 7S",
          "Sony Alpha 7S II",
          "Sony Alpha 99 II",
          "Sony Cyber-shot DSC-H400",
          "Sony Cyber-shot DSC-HX350",
          "Sony Cyber-shot DSC-HX80",
          "Sony Cyber-shot DSC-HX90V",
          "Sony Cyber-shot DSC-RX10 II",
          "Sony Cyber-shot DSC-RX10 III",
          "Sony Cyber-shot DSC-RX100 III",
          "Sony Cyber-shot DSC-RX100 IV",
          "Sony Cyber-shot DSC-RX100 V",
          "Sony Cyber-shot DSC-RX1R II",
          "Sony Cyber-shot DSC-W800",
          "Sony Cyber-shot DSC-WX350",
          "Sony Cyber-shot DSC-WX500 - YI M1 -"
        ],
        "model": [
          "450D",
          "EOS 5D Mark IV",
          "EOS 5DS",
          "EOS 5DS R",
          "EOS 700D",
          "EOS 70D",
          "EOS 750D",
          "EOS 760D",
          "EOS 7D Mark II",
          "EOS 80D",
          "EOS M10",
          "EOS M3",
          "EOS M5",
          "IXUS 132 HS",
          "IXUS 140",
          "IXUS 145",
          "IXUS 150",
          "IXUS 155",
          "IXUS 160",
          "IXUS 165",
          "IXUS 170",
          "IXUS 175",
          "IXUS 180",
          "IXUS 255 HS",
          "IXUS 265 HS",
          "IXUS 275 HS",
          "IXUS 285 HS",
          "PowerShot A1400",
          "PowerShot A2500",
          "PowerShot A3500 IS",
          "PowerShot D30",
          "PowerShot G1 X Mark II",
          "PowerShot G16",
          "PowerShot G3 X",
          "PowerShot G5 X",
          "PowerShot G7 X",
          "PowerShot G7 X Mark II",
          "PowerShot G9 X",
          "PowerShot G9 X Mark II",
          "PowerShot N100",
          "PowerShot S120",
          "PowerShot S200",
          "PowerShot SX170 IS",
          "PowerShot SX270 HS",
          "PowerShot SX280 HS",
          "PowerShot SX400 IS",
          "PowerShot SX410 IS",
          "PowerShot SX420 IS",
          "PowerShot SX510 HS",
          "PowerShot SX520 HS",
          "PowerShot SX530 HS",
          "PowerShot SX540 HS",
          "PowerShot SX60 HS",
          "PowerShot SX600 HS",
          "PowerShot SX610 HS",
          "PowerShot SX620 HS",
          "PowerShot SX700 HS",
          "PowerShot SX710 HS",
          "PowerShot SX720 HS",
          "XC10",
          "Exilim EX-10",
          "Exilim EX-100",
          "Exilim EX-H30",
          "Exilim EX-TR50",
          "Exilim EX-ZR100",
          "Exilim EX-ZR1000",
          "Exilim EX-ZR15",
          "Exilim EX-ZR200",
          "Exilim EX-ZR300",
          "Exilim EX-ZR400",
          "Exilim EX-ZR700",
          "Exilim EX-ZR800",
          "Exilim EX-ZS15",
          "FinePix AX200",
          "FinePix S1",
          "FinePix S9800",
          "FinePix S9900W",
          "FinePix XP80",
          "FinePix XP90",
          "GFX 50S",
          "X-A10",
          "X-A2",
          "X-A3",
          "X-E2",
          "X-E2S",
          "X-Pro2",
          "X-T1",
          "X-T10",
          "X-T2",
          "X100T",
          "X30",
          "X70",
          "XQ2",
          "X1D",
          "EasyShare M530",
          "EasyShare M550",
          "EasyShare M575",
          "EasyShare M590",
          "EasyShare M750",
          "EasyShare Max Z990",
          "EasyShare Mini M200",
          "EasyShare Sport C123",
          "EasyShare Sport C135",
          "EasyShare Touch M5370",
          "EasyShare Touch M577",
          "EasyShare Z5120",
          "EasyShare Z981",
          "Pixpro Astro Zoom AZ651",
          "Pixpro S-1",
          "C",
          "D-Lux",
          "M",
          "M Edition 60",
          "M Monochrom",
          "Q",
          "SL",
          "T",
          "TL",
          "V-Lux",
          "X",
          "X Vario",
          "X-U",
          "1 AW1",
          "1 J4",
          "1 J5",
          "1 S2",
          "1 V3",
          "Coolpix A10",
          "Coolpix A100",
          "Coolpix A900",
          "Coolpix AW120",
          "Coolpix AW130",
          "Coolpix B500",
          "Coolpix B700",
          "Coolpix L31",
          "Coolpix L32",
          "Coolpix L830",
          "Coolpix L840",
          "Coolpix P340",
          "Coolpix P530",
          "Coolpix P600",
          "Coolpix P610",
          "Coolpix P900",
          "Coolpix S2900",
          "Coolpix S32",
          "Coolpix S33",
          "Coolpix S3600",
          "Coolpix S3700",
          "Coolpix S5300",
          "Coolpix S6800",
          "Coolpix S6900",
          "Coolpix S7000",
          "Coolpix S810c",
          "Coolpix S9700",
          "Coolpix S9900",
          "Coolpix W100",
          "D3100",
          "D3200",
          "D3300",
          "D3400",
          "D3S",
          "D4",
          "D4S",
          "D5",
          "D5",
          "D500",
          "D5300",
          "D5500",
          "D5600",
          "D610",
          "D6Nikon D810",
          "D7200",
          "D750",
          "D810A",
          "Df",
          "DL18-50",
          "DL24-500",
          "DL24-85",
          "OM-D E-M1 Mark II",
          "OM-D E-M10",
          "OM-D E-M10 II",
          "OM-D E-M5 II",
          "PEN E-PL7",
          "PEN E-PL8",
          "PEN-F",
          "Stylus 1s",
          "Stylus SH-1",
          "Stylus SH-2",
          "Stylus SH-3",
          "Stylus SP-100",
          "Stylus Tough TG-3",
          "Stylus Tough TG-4",
          "Stylus Tough TG-850 iHS",
          "Stylus Tough TG-860",
          "Stylus Tough TG-870",
          "Lumix DC-FZ80",
          "Lumix DC-GH5",
          "Lumix DMC-FZ1000",
          "Lumix DMC-FZ300",
          "Lumix DMC-G7",
          "Lumix DMC-GF7",
          "Lumix DMC-GF8",
          "Lumix DMC-GH4",
          "Lumix DMC-GM5",
          "Lumix DMC-GX8",
          "Lumix DMC-GX85",
          "Lumix DMC-LX10",
          "Lumix DMC-LX100",
          "Lumix DMC-LZ40",
          "Lumix DMC-SZ10",
          "Lumix DMC-SZ8",
          "Lumix DMC-TS30",
          "Lumix DMC-TS6",
          "Lumix DMC-ZS100",
          "Lumix DMC-ZS35",
          "Lumix DMC-ZS40",
          "Lumix DMC-ZS45",
          "Lumix DMC-ZS50",
          "Lumix DMC-ZS60",
          "Lumix FZ2500",
          "Lumix G85",
          "645Z",
          "Efina",
          "K-1",
          "K-3",
          "K-3 II",
          "K-5 II",
          "K-5 IIs",
          "K-50",
          "K-500",
          "K-70",
          "K-S1",
          "K-S2",
          "MX-1",
          "Q-S1",
          "Q7",
          "WG-10",
          "WG-3",
          "WG-3 GPS",
          "WG-30",
          "XG-1",
          "IS2132",
          "CX3",
          "CX4",
          "CX5",
          "CX6",
          "G700SE",
          "GR",
          "GR Digital IV",
          "GXR Mount A12",
          "PX",
          "WG-4",
          "WG-4 GPS",
          "NX Mini",
          "NX1",
          "NX30",
          "NX300",
          "NX3000",
          "NX500",
          "WB1100F",
          "WB2200F",
          "WB350F",
          "WB35F",
          "WB50F",
          "dp0 Quattro",
          "dp1 Quattro",
          "dp2 Quattro",
          "dp3 Quattro",
          "sd Quattro",
          "sd Quattro H",
          "Alpha 5100",
          "Alpha 6300",
          "Alpha 6500",
          "Alpha 68",
          "Alpha 7 II",
          "Alpha 77 II",
          "Alpha 7R II",
          "Alpha 7S",
          "Alpha 7S II",
          "Alpha 99 II",
          "Cyber-shot DSC-H400",
          "Cyber-shot DSC-HX350",
          "Cyber-shot DSC-HX80",
          "Cyber-shot DSC-HX90V",
          "Cyber-shot DSC-RX10 II",
          "Cyber-shot DSC-RX10 III",
          "Cyber-shot DSC-RX100 III",
          "Cyber-shot DSC-RX100 IV",
          "Cyber-shot DSC-RX100 V",
          "Cyber-shot DSC-RX1R II",
          "Cyber-shot DSC-W800",
          "Cyber-shot DSC-WX350",
          "Cyber-shot DSC-WX500",
          "M1"
        ]
      },
      "cannabis": {
        "brands": [
          "8 | FOLD Cultivation",
          "Apothecanna",
          "Auntie Dolores",
          "Big Pete's Treats",
          "Bloom Farms",
          "CI Wholesale",
          "California's Finest",
          "Cannapunch",
          "Cannavore Confections",
          "Caviar Gold",
          "Cheeba Chews",
          "Chong's Choice",
          "Claw",
          "Coda Signature",
          "Colorado Cannabis Company",
          "Dixie Edibles",
          "Dixie Elixirs",
          "Dosist",
          "Evolab",
          "Hashman Infused",
          "Hiku",
          "Jetty Extracts",
          "K.I.N.D. Concentrates",
          "Kiva Confections",
          "Leafs by Snoop",
          "Legal Drinks",
          "Level Blends",
          "Lola Lola",
          "Lord Jones",
          "Marley Natural",
          "Muy",
          "Nature’s Medicines",
          "Oil Stix",
          "Omaha Farms",
          "Orchid Essentials",
          "OreKron",
          "Roots",
          "Seven Point",
          "Shore Natural RX",
          "Siskiyou Sungrown",
          "Summit",
          "THC Design",
          "THC Factory",
          "The Goodship Company",
          "The Lab",
          "Timeless Vapes",
          "True Humboldt",
          "Wana Brands",
          "Whoopie & Maya",
          "Willie’s Reserve",
          "marQaha"
        ],
        "buzzwords": [
          "blunt wrap",
          "bong",
          "bottom shelf",
          "bubbler",
          "cashed",
          "cbd",
          "dank",
          "eighth",
          "gram",
          "high",
          "hydroponic",
          "keef",
          "marijuana",
          "mary jane",
          "munchies",
          "ounce",
          "papers",
          "pipe",
          "pound",
          "private reserve",
          "ripped",
          "spliff",
          "stoned",
          "terpene",
          "thc",
          "toke",
          "top shelf",
          "wake and bake",
          "weed"
        ],
        "cannabinoid_abbreviations": [
          "THC",
          "THCa",
          "∆9THC",
          "∆8THC",
          "THCv",
          "THCv",
          "CBD",
          "CBDa",
          "CBDv",
          "CBN",
          "CBNa",
          "CBG",
          "CBGa",
          "CBC",
          "CBCa",
          "CBL",
          "CBLa"
        ],
        "cannabinoids": [
          "Tetrahydrocannabinol",
          "Tetrahydrocannabinolic Acid",
          "Tetrahydrocannabivarin",
          "Cannabidiol",
          "Cannabidiolic Acid",
          "Cannabidivarin",
          "Cannabinol",
          "Cannabinolic Acid",
          "Cannabigerol",
          "Cannabigerolic Acid",
          "Cannabichromene",
          "Cannabichromic Acid",
          "Cannabicyclol",
          "Cannabicyclic Acid"
        ],
        "categories": [
          "capsules",
          "concentrates",
          "crumble",
          "crystalline",
          "distillate",
          "edibles",
          "flower",
          "ice hash",
          "live resin",
          "medical",
          "rosin",
          "seeds & clones",
          "shatter",
          "tinctures",
          "topicals",
          "vape pens"
        ],
        "health_benefits": [
          "relieves pain",
          "kills or slows bacteria growth",
          "reduces blood sugar levels",
          "reduces vomiting and nausea",
          "reduces seizures and convulsion",
          "treats fungal infection",
          "treats depression",
          "reduces inflammation",
          "aids sleep",
          "reduces risk of artery blockage",
          "inhibits cell growth in tumors/cancer cells",
          "treats psoriasis",
          "tranquilizing",
          "suppresses muscle spasms",
          "relieves anxiety",
          "stimulates appetite",
          "suppresses appetite",
          "promotes bone growth",
          "regulates function in the immune system",
          "stimulates function in the immune system",
          "reduces contractions in the small intestines",
          "protects against nervous system degeneration",
          "improves airflow to lungs",
          "prevents stress",
          "prevents infection",
          "affects mental activity",
          "does not affect mental activity",
          "relieves congestion",
          "treats allergy symptoms",
          "cell protectant",
          "treats viral infections"
        ],
        "medical_uses": [
          "analgesic",
          "anti-bacterial",
          "anti-diabetic",
          "anti-emetic",
          "anti-epileptic",
          "anti-fungal",
          "anti-depressant",
          "anti-inflammatory",
          "anti-insomnia",
          "anti-ischemic",
          "anti-cancer",
          "anti-psoriatic",
          "anti-psychotic",
          "anti-spasmodic",
          "anti-anxiety",
          "appetite stimulant",
          "anorectic",
          "bone stimulant",
          "immunoregulation",
          "immunostimulant",
          "intestinal anti-prokinetic",
          "neuroprotective",
          "bronchodilator",
          "anti-stress",
          "anti-septic",
          "psychoactive",
          "non-psychoactive",
          "decongestant",
          "anti-histamine",
          "anti-oxidant",
          "anti-viral"
        ],
        "strains": [
          "24k",
          "Alien Diesel",
          "Banana OG",
          "Bio-Diesel",
          "Black Diamond OG",
          "Black Jack",
          "Blackberry Cookies",
          "Blackberry Soda",
          "Blackwater OG",
          "Blue Dream",
          "Blueberry Tangie",
          "Boss Hog",
          "Cali Mist",
          "Candy Skunk",
          "Candyland",
          "Canna Sutra",
          "Cheese",
          "Chem Berry",
          "Cherry Cheese",
          "Cherry Lime",
          "Chocolate Hashberry",
          "Chronic",
          "Church OG",
          "Clementine",
          "Colfax Cookies",
          "Colfax Jack",
          "Colfax Platinum",
          "Critical Kush",
          "Diablo OG",
          "Double Dutch Bus",
          "Dutch Treat",
          "Forbidden Fruit",
          "Gelato",
          "Ghost OG",
          "Girl Scout Cookies",
          "Godzilla Glue",
          "Golden Strawberries",
          "Gorilla Glue",
          "Gorilla Princess",
          "Granddaddy Purple Kush",
          "Grapefruit Kush",
          "Green Cobra",
          "Green Queen",
          "Hardcore Grapes",
          "Heavy OG",
          "Jack Frost",
          "Key Lime Pie",
          "King Kong OG",
          "King Louis OG",
          "Kings Reserve OG",
          "Koffee Cake",
          "Lemon Jack",
          "Lemon Meringue",
          "Lemon Skunk",
          "Lemonade",
          "Lime #5",
          "Lucky Charms",
          "Master OG",
          "Maui Jack",
          "Mendo Breath",
          "Mojito",
          "Moon Glue",
          "Mr. Nice Guy",
          "NY Sour Diesel",
          "Nectarine",
          "Novicane Kush",
          "Nug Salad",
          "OG Chem",
          "OG Salad",
          "ONAC OG",
          "Panama Punch",
          "Pineapple Sage",
          "Pinesol OG",
          "Pink Lotus",
          "Pitbull",
          "Platinum OG",
          "Presidential OG",
          "Private Reserve",
          "Purple Punch",
          "Queen Dream",
          "Rainbow Sherbet",
          "Raskal OG",
          "Redwood Bubba Kush",
          "Rude Boi OG",
          "Satellite OG",
          "Saturn OG",
          "Sherbert",
          "Skywalker OG",
          "Snozzberry OG",
          "Sonoma Glue",
          "Soul Assasin OG",
          "Soul Assassin",
          "Sour Cheese",
          "Strawberry Banana",
          "Strawberry Cough",
          "Strawberry Moonrocks",
          "Strawberry Shortcake",
          "Sugar Momma",
          "Sunset Sherbert",
          "Super Glue",
          "Super Jack",
          "Super Silver Haze",
          "Tangie",
          "Watermelon",
          "White Tahoe Cookies",
          "Whitewalker OG",
          "XJ-13"
        ],
        "terpenes": [
          "α Pinene",
          "Myrcene",
          "α Phellandrene",
          "∆ 3 Carene",
          "Terpinene",
          "Limonene",
          "α Terpinolene",
          "Linalool",
          "Fenchol",
          "Borneol",
          "Terpineol",
          "Geraniol",
          "α Humulene",
          "β Caryophyllene",
          "Caryophyllene Oxide",
          "α Bisabolol",
          "Camphene",
          "β Pinene",
          "Ocimene",
          "Sabinene",
          "Camphor",
          "Isoborneol",
          "Menthol",
          "α Cedrene",
          "Nerolidol",
          "R-(+)-Pulegone",
          "Eucalyptol",
          "p-Cymene",
          "(-)-Isopulegol",
          "Geranyl",
          "Acetate",
          "Guaiol",
          "Valencene",
          "Phytol",
          "Citronellol"
        ],
        "types": [
          "hybrid",
          "indica",
          "sativa"
        ]
      },
      "cell_phone": {
        "formats": [
          "###-###-####",
          "(###) ###-####",
          "###.###.####",
          "### ### ####"
        ]
      },
      "chess": {
        "openings": [
          "Alekhine’s Defense",
          "Benko Gambit",
          "Benoni Defense",
          "Bird’s Opening",
          "Bogo-Indian Defense",
          "Budapest Gambit",
          "Catalan Opening",
          "Caro-Kann Defense",
          "Colle System",
          "Dutch Defense",
          "Giuoco Piano",
          "English Opening",
          "Evans Gambit",
          "Four Knights Game",
          "French Defense",
          "Grünfeld Defense",
          "Italian Game",
          "King’s Gambit",
          "King’s Indian Attack",
          "King’s Indian Defense",
          "King’s Pawn Game",
          "London System",
          "Modern Defense",
          "Nimzo-Indian Defense",
          "Nimzowitsch Defense",
          "Petrov’s Defense",
          "Philidor’s Defense",
          "Pirc Defense",
          "Queen’s Pawn Game",
          "Queen’s Gambit Accepted",
          "Queen’s Gambit Declined",
          "Queen’s Indian Defense",
          "Réti Opening",
          "Ruy Lopez",
          "Scandinavian Defense",
          "Scotch Game",
          "Sicilian Defense",
          "Slav Defense",
          "Torre Attack",
          "Two Knights Defense",
          "Vienna Game",
          "Wade Defense"
        ],
        "players": [
          "Alexander Alekhine",
          "Alexei Shirov",
          "Alexis Vargas",
          "Anatoly Karpov",
          "Bobby Fischer",
          "Emanuel Lasker",
          "Fabiano Caruana",
          "Garry Kasparov",
          "Hikaru Nakamura",
          "Jose Raul Capablanca",
          "Levon Aronian",
          "Magnus Carlsen",
          "Mikhail Botvinnik",
          "Radjabov Teimour",
          "Sergey Karjakin",
          "Tigran Petrosian",
          "Viswanathan Anand",
          "Vladimir Kramnik",
          "Wesley So",
          "Paul Morphy"
        ],
        "titles": [
          "GM",
          "IM",
          "FM",
          "CM",
          "WGM",
          "WIM",
          "WFM",
          "WCM",
          "AGM",
          "AIM",
          "AFM",
          "ACM"
        ],
        "tournaments": [
          "Wijk aan Zee",
          "Linares",
          "Astrakhan",
          "Dortmund",
          "Shanghai",
          "Bilbao",
          "Nanjing",
          "Moscow",
          "London",
          "Moscow",
          "Tromsø (Chess World Cup)",
          "Paris (Grand Prix 2012–2013)",
          "Bucharest",
          "Nizhny Novgorod (Russian Championship)",
          "Zurich",
          "Khanty-Mansisyk (Candidates Tournament)",
          "Tbilisi (Grand Prix 2014–2015)",
          "Khanty-Mansisyk (Grand Prix 2014–2015)",
          "Baku (Chess World Cup)",
          "London (Grand Chess Tour)",
          "Gibraltar"
        ]
      },
      "chiquito": {
        "expressions": [
          "¡Aguaaa, aguaaa!",
          "¡Al ataqueer!",
          "¡Ereh un torpedo!",
          "¡Fuegorrrl!",
          "¡Hasta luego Luca!",
          "¡Hombre malo, violento!",
          "¡Me cago en tuh muelah!",
          "¡Noorl!",
          "¡Reláhese usted!",
          "¿Te dah cuen?",
          "Apiticaaaan, apiticandemorenau",
          "Físicamente, moralmente, diplomáticamente",
          "No puedor",
          "Por la gloria de mi madre"
        ],
        "jokes": [
          "- Papár papár llévame al circo!\n - Noorl! El que quiera verte que venga a la casa",
          "- Está la cosa muy mar muy mar muy mar\n - A mí me lo va a decir que me he casao y estoy haciendo el viaje de novios solo",
          "- Cómo viene de borracho, ¡va usté muy cargado!\n - ¿Qué quiere que dé dos viajes?",
          "Nació un niño tan feo tan feo que la madre en vez de darle el pecho le daba la espalda"
        ],
        "sentences": [
          "¡Siete caballos vienen de Bonanza!",
          "¡Se ha pasao usted con mi bambina! ¡Es usted un torpedo del año cuatro!",
          "¡Una mala taaaaaaaarde la tiene cualquiera!",
          "Caballo blanco, caballo negroo",
          "En vez del graduado escolar tenía una etiqueta de Anís del Mono",
          "Estás más nervioso que Marco en el Sorpresa Sorpresa",
          "Estoy friendo los huevos con saliva",
          "Lo maté una tarde de agosto, la caló apretaba",
          "Te llamo trigo por no llamarte Rodrigo",
          "Te mueves más que los precios",
          "Te viá cortá el fiistro dabajo",
          "Te viá borrar el cerito sesualrllr",
          "Te viá meter una multa que no te la saca ni Perry Manso",
          "Tengo más nervios que un filete de cinco pesetas",
          "Trabajas menos que el sastre de Tarzán",
          "Uno que nació después de los dolores"
        ],
        "terms": [
          "¡Cobarde!",
          "¡Hioputarl!",
          "¿Cómor?",
          "Acandemor",
          "Condemor",
          "Cuidadín",
          "Diodeno",
          "Fistro",
          "Grimore",
          "Gromenauer",
          "Guarrerida española",
          "La caidita de Roma",
          "Mamaarr",
          "Meretérica",
          "Pecador",
          "Sesuar"
        ]
      },
      "chuck_norris": {
        "fact": [
          "All arrays Chuck Norris declares are of infinite size, because Chuck Norris knows no bounds.",
          "Chuck Norris doesn't have disk latency because the hard drive knows to hurry the hell up.",
          "All browsers support the hex definitions #chuck and #norris for the colors black and blue.",
          "Chuck Norris can't test for equality because he has no equal.",
          "Chuck Norris doesn't need garbage collection because he doesn't call .Dispose(), he calls .DropKick().",
          "Chuck Norris's first program was kill -9.",
          "Chuck Norris burst the dot com bubble.",
          "Chuck Norris writes code that optimizes itself.",
          "Chuck Norris can write infinite recursion functions... and have them return.",
          "Chuck Norris can solve the Towers of Hanoi in one move.",
          "The only pattern Chuck Norris knows is God Object.",
          "Chuck Norris finished World of Warcraft.",
          "Project managers never ask Chuck Norris for estimations... ever.",
          "Chuck Norris doesn't use web standards as the web will conform to him.",
          "\"It works on my machine\" always holds true for Chuck Norris.",
          "Whiteboards are white because Chuck Norris scared them that way.",
          "Chuck Norris's beard can type 140 wpm.",
          "Chuck Norris can unit test an entire application with a single assert.",
          "Chuck Norris doesn't bug hunt, as that signifies a probability of failure. He goes bug killing.",
          "Chuck Norris's keyboard doesn't have a Ctrl key because nothing controls Chuck Norris.",
          "Chuck Norris doesn't need a debugger, he just stares down the bug until the code confesses.",
          "Chuck Norris can access private methods.",
          "Chuck Norris can instantiate an abstract class.",
          "Chuck Norris doesn't need to know about class factory pattern. He can instantiate interfaces.",
          "The class object inherits from Chuck Norris.",
          "For Chuck Norris, NP-Hard = O(1).",
          "Chuck Norris knows the last digit of PI.",
          "Chuck Norris can divide by zero.",
          "Chuck Norris doesn't get compiler errors, the language changes itself to accommodate Chuck Norris.",
          "The programs that Chuck Norris writes don't have version numbers because he only writes them once. If a user reports a bug or has a feature request they don't live to see the sun set.",
          "Chuck Norris doesn't believe in floating point numbers because they can't be typed on his binary keyboard.",
          "Chuck Norris solved the Travelling Salesman problem in O(1) time.",
          "Chuck Norris never gets a syntax error. Instead, the language gets a DoesNotConformToChuck error.",
          "No statement can catch the ChuckNorrisException.",
          "Chuck Norris doesn't program with a keyboard. He stares the computer down until it does what he wants.",
          "Chuck Norris doesn't pair program.",
          "Chuck Norris can write multi-threaded applications with a single thread.",
          "There is no Esc key on Chuck Norris' keyboard, because no one escapes Chuck Norris.",
          "Chuck Norris doesn't delete files, he blows them away.",
          "Chuck Norris can binary search unsorted data.",
          "Chuck Norris breaks RSA 128-bit encrypted codes in milliseconds.",
          "Chuck Norris went out of an infinite loop.",
          "Chuck Norris can read all encrypted data, because nothing can hide from Chuck Norris.",
          "Chuck Norris hosting is 101% uptime guaranteed.",
          "When a bug sees Chuck Norris, it flees screaming in terror, and then immediately self-destructs to avoid being roundhouse-kicked.",
          "Chuck Norris rewrote the Google search engine from scratch.",
          "Chuck Norris doesn't need the cloud to scale his applications, he uses his laptop.",
          "Chuck Norris can access the DB from the UI.",
          "Chuck Norris' protocol design method has no status, requests or responses, only commands.",
          "Chuck Norris' programs occupy 150% of CPU, even when they are not executing.",
          "Chuck Norris can spawn threads that complete before they are started.",
          "Chuck Norris programs do not accept input.",
          "Chuck Norris doesn't need an OS.",
          "Chuck Norris can compile syntax errors.",
          "Chuck Norris compresses his files by doing a flying round house kick to the hard drive.",
          "Chuck Norris doesn't use a computer because a computer does everything slower than Chuck Norris.",
          "You don't disable the Chuck Norris plug-in, it disables you.",
          "Chuck Norris doesn't need a java compiler, he goes straight to .war",
          "Chuck Norris can use GOTO as much as he wants to. Telling him otherwise is considered harmful.",
          "There is nothing regular about Chuck Norris' expressions.",
          "Quantum cryptography does not work on Chuck Norris. When something is being observed by Chuck it stays in the same state until he's finished.",
          "There is no need to try catching Chuck Norris' exceptions for recovery; every single throw he does is fatal.",
          "Chuck Norris' beard is immutable.",
          "Chuck Norris' preferred IDE is hexedit.",
          "Chuck Norris is immutable. If something's going to change, it's going to have to be the rest of the universe.",
          "Chuck Norris' addition operator doesn't commute; it teleports to where he needs it to be.",
          "Anonymous methods and anonymous types are really all called Chuck Norris. They just don't like to boast.",
          "Chuck Norris doesn't have performance bottlenecks. He just makes the universe wait its turn.",
          "Chuck Norris does not use exceptions when programming. He has not been able to identify any of his code that is not exceptional.",
          "When Chuck Norris' code fails to compile the compiler apologises.",
          "Chuck Norris does not use revision control software. None of his code has ever needed revision.",
          "Chuck Norris can recite π. Backwards.",
          "When Chuck Norris points to null, null quakes in fear.",
          "Chuck Norris has root access to your system.",
          "When Chuck Norris gives a method an argument, the method loses.",
          "Chuck Norris' keyboard doesn't have a F1 key, the computer asks him for help.",
          "When Chuck Norris presses Ctrl+Alt+Delete, worldwide computer restart is initiated."
        ]
      },
      "code": {
        "asin": [
          "B000BJ20TO",
          "B000BJ0Z50",
          "B000BUYO60",
          "B000HGWGHW",
          "B000II6WOW",
          "B000AMNV8G",
          "B000HDT0BU",
          "B000HGNY7I",
          "B000I6VQX6",
          "B0002I6HKW",
          "B00067POW6",
          "B0000VFDCY",
          "B0000W4I2O",
          "B00026IESC",
          "B000GWIHF2",
          "B000H3HHOM",
          "B00066OELO",
          "B0009QHJSG",
          "B000NQLULE",
          "B000P42ICO",
          "B000P5XI6S",
          "B000Q75VCO",
          "B000A409WK",
          "B000ILNR10",
          "B000JMIRRC",
          "B000JTDF6I",
          "B000NQLUNC",
          "B000PIIXBA",
          "B000Q75VCO",
          "B000NKTC92",
          "B000Q6Y34W",
          "B000E5GB3Q",
          "B0001DJWXW",
          "B000GFCRDC",
          "B000IBFL2S",
          "B000FTQ5A0",
          "B000JZZHEU",
          "B000Q313FC",
          "B000OVNFDE",
          "B000FTBJGA",
          "B00019774C",
          "B0002IQM66",
          "B000FTBJGA",
          "B000FTBJFG",
          "B00019774M",
          "B0002IQM52",
          "B0000V3W9U",
          "B000CSAK3M",
          "B000CFIMWQ",
          "B0001H5RIC",
          "B00005R12M",
          "B000GIWNCE",
          "B000000Z1F",
          "B0006YBTS2",
          "B000AF8T1C",
          "B000FQ9CTY",
          "B00012FB6K",
          "B0001H5NK4",
          "B000G1CIH6",
          "B000CPJHQG",
          "B000GPHRW8",
          "B000P4178K",
          "B000MZW1GE",
          "B000NMKCKI",
          "B000KBAL6W",
          "B000KJW2JS",
          "B000LCZCRS",
          "B000QA7ZFC",
          "B000J0NOTK",
          "B000BMHOVU",
          "B000FFAGDG",
          "B0002GL2BS",
          "B0002GM6DQ",
          "B000KAAIA2",
          "B0009QMECC",
          "B000ML8E7I",
          "B000NKOHPG",
          "B000PGCLWY",
          "B000PIM89S",
          "B0001DJXAY",
          "B000MLA1UQ",
          "B000NKSTVO",
          "B000PIGTK2",
          "B000Q76WYK",
          "B000NG1GKO",
          "B000ITBS40",
          "B000JTR9CE",
          "B000KP4VP0",
          "B00025C3HG",
          "B000BPNBCI",
          "B000BPZFNQ",
          "B000BQ6ML4",
          "B000BPIBPK",
          "B000BPX542",
          "B000BQ2HR2",
          "B000BTBGDK",
          "B000N5FYNK",
          "B000N5HN3Y",
          "B000N5FYO4",
          "B000N5HN3Y",
          "B000N5FYOE",
          "B000N5HN3Y",
          "B00079UXEC",
          "B0007Z6B42",
          "B0007Z6BBA",
          "B000CDC7O2",
          "B000KU5ELA",
          "B000COF89C",
          "B000FOOQK6",
          "B00012D9TQ",
          "B000P5YK8S",
          "B000NKSOOQ",
          "B000Q72CSA",
          "B000K0WZ2G",
          "B000J3401I",
          "B0006OGUPY",
          "B000JS9C70",
          "B000JS9C7K",
          "B000JSBHCS",
          "B000IBJ3OA",
          "B000JFLI7U",
          "B000Q7F1OW",
          "B0000008XW",
          "B0007WHCXO",
          "B0007WHCXE",
          "B0007WHCXY",
          "B000CR7COI",
          "B000CR7CP2",
          "B000B5MVJM",
          "B000CR7COS",
          "B000H4CQYM",
          "B000NI7RW8",
          "B000HF37YE",
          "B000PWBC6Y",
          "B000O332KS",
          "B000MW7MJ8",
          "B000IXHC2S",
          "B000PAOCOU",
          "B000GLXHGC",
          "B0009R9L7W",
          "B00066USKU",
          "B00069TDVW",
          "B000GFCVA6",
          "B000AQNDBM",
          "B000IT4T9Q",
          "B000IT4T96",
          "B000IT4T9Q",
          "B000IT4T96",
          "B000IT4T9Q",
          "B0000DJH5H",
          "B0000DKWE1",
          "B0000DYZL0",
          "B000F8FY6M",
          "B000F8MENI",
          "B0001FEWCG",
          "B0001FGAO4",
          "B000BJ20J4",
          "B000BJ8NJU",
          "B000BPGAOE",
          "B0000DGFW7",
          "B0000DGXE8",
          "B0000DHWAB",
          "B0000DIIQA",
          "B000A6QSTG",
          "B000A70EOU",
          "B000AXVWA4",
          "B000BJ20OE",
          "B000BJ4UQ0",
          "B000BPHSLS",
          "B0002X4OIY",
          "B0002XCH2E",
          "B000BY634C",
          "B000BYDF4I",
          "B000A6LSXW",
          "B000A70EAO",
          "B000AXVVY6",
          "B000F5631A",
          "B00004YKMI",
          "B000FNP6CY",
          "B000BIWQNA",
          "B000BJ20Y4",
          "B000BJ4VFA",
          "B000BSH87O",
          "B000BJ0LSQ",
          "B000BJ5JHE",
          "B000BJ6VNA",
          "B000BSH8AQ",
          "B000PLUEEQ",
          "B00000AQ4N",
          "B000IT9ZLI",
          "B000NKUUKW",
          "B000Q71WNG",
          "B000ILRO82",
          "B00000AYGE",
          "B00095NYV8",
          "B00097DN12",
          "B000A3PVZ6",
          "B000BKCYUS",
          "B0009XDRTE",
          "B0009XOXXS",
          "B000ABFA7W",
          "B000ALH1DI",
          "B000AM3FKK",
          "B000AM6Z7K",
          "B000AM78JO",
          "B0000B0JG4",
          "B0000DE593",
          "B0000DFLFJ",
          "B0000AAGDL",
          "B0000AAGJF",
          "B0000B0IVU",
          "B0000DDZ3N",
          "B0000DFDWF",
          "B000A3JNTG",
          "B000B7CDX4",
          "B000A2TMH0",
          "B000A3PYLW",
          "B000A3T33M",
          "B000ALJYO2",
          "B000HB0138",
          "B000HB2O2O",
          "B0002RTXMM",
          "B000GPWOLW",
          "B000GQ2P7O",
          "B000GT8JQC",
          "B000HKQS6I",
          "B000HQGKRO",
          "B000I6TI2C",
          "B000A4RJ8C",
          "B000A4YC14",
          "B000A6LPM6",
          "B000A70B7K",
          "B000AR99QO",
          "B000I6QKZU",
          "B00067668W",
          "B00067FMXM",
          "B00067OVMK",
          "B0009ICOZ2",
          "B0009IOFWC",
          "B0009IT5P4",
          "B0009PC1XA",
          "B000A15Y0K",
          "B000A1AUBI",
          "B000A3K36I",
          "B000BHLISA",
          "B000BHP2LO",
          "B000BPC71E",
          "B0000VDPWE",
          "B0000VG5MG",
          "B0000VQ4YA",
          "B0000W47PC",
          "B0000DGGHM",
          "B0000DHBRP",
          "B0000DHUGW",
          "B000A143NO",
          "B000A1AVNK",
          "B000A3M9CY",
          "B000AOVECO",
          "B0000DGTOF",
          "B0000DHCHM",
          "B0000DGH5J",
          "B0000DGTWR",
          "B0000DHCZT",
          "B0000DHVM5",
          "B000A0A56Y",
          "B000A0AQPO",
          "B000A1D15U",
          "B000AOMOVE",
          "B0000DDEMJ",
          "B0000DEC3S",
          "B0000DFUHY",
          "B0000YKHC2",
          "B000J1E1RS",
          "B000J2II3K",
          "B000J2NMGS",
          "B000JR91YA",
          "B0009QW44A",
          "B0009RSVD2",
          "B0000DKWG0",
          "B0000DYX4V",
          "B0000DYZRA",
          "B0000TFLNM",
          "B00066USX2",
          "B000675MDW",
          "B00067EOF4",
          "B0000AHC6J",
          "B0000AJDKF",
          "B0000D1DW1",
          "B0000DEVGP",
          "B0000DFOKF",
          "B000A1FW8E",
          "B000AOMPAY",
          "B0002XUV3G",
          "B0002STO02",
          "B0000AATPM",
          "B0000AB07P",
          "B0000AFKVG",
          "B0000DECN1",
          "B0000DFPMN",
          "B0000W2LW8",
          "B0000W2MNQ",
          "B0000W463K",
          "B0000W46R6",
          "B00029JHS0",
          "B0002RFYGQ",
          "B000654P8C",
          "B00065E4WY",
          "B00065F3KG",
          "B0006DRM02",
          "B000GWGMP4",
          "B000GWH2DU",
          "B000GWKIMC",
          "B000HU7P92",
          "B000GWGJK2",
          "B000GWGQ5K",
          "B000HU5ZIA",
          "B0000DGI28",
          "B0000DGUFP",
          "B0000DHW2M",
          "B000HB4DU0",
          "B000HBXMHK",
          "B000HCTRK0",
          "B000I4ZLIE",
          "B000I6QR9O",
          "B000KFZ32A",
          "B000HB4E90",
          "B000HC0P2E",
          "B000HW5FFG",
          "B000I6QSBG",
          "B000IAPR0U",
          "B000IAPYWQ",
          "B000A2LNPO",
          "B000A2SVXQ",
          "B000A3PGTC",
          "B000J42NY8",
          "B000JKMDTW",
          "B000BNLKWS",
          "B000BOIITU",
          "B000BHP4DA",
          "B000BJ8TZI",
          "B000CEPH52",
          "B000HW06LY",
          "B000I00RTG",
          "B000I6ONRM",
          "B000IATJ5Y",
          "B0007657T6",
          "B0007658JK",
          "B0002SUQUY",
          "B0002SVARW",
          "B0002SZELK",
          "B0006628FS",
          "B000662QI2",
          "B000662ADI",
          "B000662SOY",
          "B000664J5A",
          "B000K99WQE",
          "B0000VAA8G",
          "B000A2MI80",
          "B000A3J9AE",
          "B0000DGV0O",
          "B0000DHWDX",
          "B000A2NCLW",
          "B000A2SXYS",
          "B000A3LC6I",
          "B000AR9G7G",
          "B000A2MIJY",
          "B000A2ROWK",
          "B000A2SP0K",
          "B000A2T37E",
          "B000A3LC18",
          "B000B7722Q",
          "B000BFMIY0",
          "B0000DHDOF",
          "B0000VAE3M",
          "B0002BWS1G",
          "B0002BXBEY",
          "B0002C489K",
          "B0002TJ4JM",
          "B0000DDQNC",
          "B0000DE0T8",
          "B0000DFH0E",
          "B0000DGITY",
          "B000A2LQ2O",
          "B000A2O26G",
          "B000A3PI3G",
          "B000AR9FZE",
          "B000A2O3U6",
          "B000A2RR04",
          "B000ABNX30",
          "B000A2MF7E",
          "B000A3PWXC",
          "B000A3WUAK",
          "B000A2NZFK",
          "B000A3LPTC",
          "B000A3TB9I",
          "B000ARBM9G",
          "B0002EZWRK",
          "B0002F4AB8",
          "B0002W2RBG",
          "B000A6LR6K",
          "B000A6Y9HY",
          "B000AADDGS",
          "B000B7CC94",
          "B00024VYL8",
          "B00025BKCK",
          "B00025DRIA",
          "B000A2MHMW",
          "B000A2RL4Q",
          "B000A3K6TM",
          "B00067PA2U",
          "B00067PKPM",
          "B00067Q8TY",
          "B0006PJMEE",
          "B000HVZOOO",
          "B000I6S5NU",
          "B000IATH6K",
          "B000A6WENA",
          "B000A6LQZ2",
          "B000A6ULLW",
          "B000J1FZV4",
          "B000J2NHC2",
          "B0000VDUVA",
          "B0000VF9C8",
          "B0000W4DP6",
          "B000BHP43U",
          "B000BIWPKO",
          "B000BUWUX4",
          "B000JKKCMW",
          "B000JLDYM6",
          "B000JQ0JNS",
          "B00067PATS",
          "B00067PLD8",
          "B00067Q9HK",
          "B000KEYQLA",
          "B000KGCZ8O",
          "B000KMRYNO",
          "B000HW20EA",
          "B000I6TCGO",
          "B000IATJEU",
          "B000I4W7S6",
          "B000I6RUQ8",
          "B000IAO9A4",
          "B0002F03NW",
          "B0002F40AY",
          "B0002XTOHK",
          "B000A3JQ0M",
          "B000A3T3LY",
          "B000HW1EGK",
          "B000I6VAU0",
          "B000IAS0JU",
          "B000A6NVNM",
          "B000A6PMBG",
          "B000B7CBWM",
          "B0002GLP6K",
          "B0002GMWEO",
          "B000A70B9I",
          "B000BHE134",
          "B0000DKWL7",
          "B0000DYXE0",
          "B0000DYZW5",
          "B000GT9P4C",
          "B000GTFRX0",
          "B000GTYMOK",
          "B000A6LPTO",
          "B000A6Y8AW",
          "B000AA5SMU",
          "B000I6RITM",
          "B000I6VJ7O",
          "B000IXR5RK",
          "B000I6MK7W",
          "B000I6XDVE",
          "B000IAQ8YO",
          "B000A0GB7Q",
          "B000A1AQWQ",
          "B000AR8ERO",
          "B000BJ8LGU",
          "B000BX5BBY",
          "B0000DGO2Z",
          "B0000DHF4M",
          "B0000DIEOI",
          "B000A2LSJ0",
          "B000A2MJY8",
          "B000AR9H5C",
          "B0000DGQ5D",
          "B000A2LWKU",
          "B000A2NVLS",
          "B000AR85S2",
          "B000BHP3T0",
          "B000BJ0KBO",
          "B000BJ8TIA",
          "B000CENBP0",
          "B00025AGUM",
          "B0000AAFWT",
          "B0000AAMF4",
          "B0000ACB9R",
          "B0000DGJD1",
          "B0000DGWB4",
          "B0000DHDW3",
          "B0000DHY2O",
          "B000A2NIK2"
        ]
      },
      "coffee": {
        "blend_name": "#{name_1} #{name_2}",
        "body": [
          "watery",
          "tea-like",
          "silky",
          "slick",
          "juicy",
          "smooth",
          "syrupy",
          "round",
          "creamy",
          "full",
          "velvety",
          "big",
          "chewy",
          "coating"
        ],
        "country": [
          "Brazil",
          "Colombia",
          "Sumatra",
          "Ethiopia",
          "Honduras",
          "Kenya",
          "Uganda",
          "Mexico",
          "Guatemala",
          "Nicaragua",
          "Costa Rica",
          "Tanzania",
          "El Salvador",
          "Rwanda",
          "Burundi",
          "Panama",
          "Yemen",
          "India"
        ],
        "descriptor": [
          "bergamot",
          "hops",
          "black-tea",
          "green-tea",
          "mint",
          "sage",
          "dill",
          "grassy",
          "snow pea",
          "sweet pea",
          "mushroom",
          "squash",
          "green pepper",
          "olive",
          "leafy greens",
          "hay",
          "tobacco",
          "cedar",
          "fresh wood",
          "soil",
          "tomato",
          "sundried tomato",
          "soy sauce",
          "leathery",
          "clove",
          "liquorice",
          "curry",
          "nutmeg",
          "ginger",
          "corriander",
          "cinnamon",
          "white pepper",
          "black pepper",
          "carbon",
          "smokey",
          "burnt sugar",
          "toast",
          "fresh bread",
          "barley",
          "wheat",
          "rye",
          "graham cracker",
          "granola",
          "almond",
          "hazelnut",
          "pecan",
          "cashew",
          "peanut",
          "walnut",
          "cola",
          "molasses",
          "maple syrup",
          "carmel",
          "brown sugar",
          "sugar cane",
          "marshmallow",
          "cream",
          "butter",
          "honey",
          "nougat",
          "vanilla",
          "milk chocolate",
          "cocoa powder",
          "bittersweet chocolate",
          "bakers chocolate",
          "cacao nibs",
          "prune",
          "dates",
          "figs",
          "raisin",
          "golden raisin",
          "black currant",
          "red currant",
          "blueberry",
          "strawberry",
          "raspberry",
          "cranberry",
          "black cherry",
          "cherry",
          "plum",
          "apricot",
          "nectarine",
          "peach",
          "coconut",
          "banana",
          "kiwi",
          "mango",
          "papaya",
          "pineapple",
          "passion fruit",
          "tamarind",
          "star fruit",
          "lychee",
          "concord grape",
          "red grape",
          "green grape",
          "white grape",
          "cantaloupe",
          "honeydew",
          "watermelon",
          "red apple",
          "green apple",
          "orange",
          "mandarin",
          "tangerine",
          "clementine",
          "grapefruit",
          "lime",
          "meyer lemon",
          "lemonade",
          "lemon",
          "orange creamsicle",
          "marzipan",
          "nutella",
          "lemongrass",
          "orange blossom",
          "jasmine",
          "honeysuckle",
          "magnolia",
          "lavender",
          "rose hips",
          "hibiscus",
          "lemon verbena",
          "medicinal",
          "quakery",
          "baggy",
          "potato defect!",
          "musty",
          "rubber"
        ],
        "intensifier": [
          "muted",
          "dull",
          "mild",
          "structured",
          "balanced",
          "rounded",
          "soft",
          "faint",
          "delicate",
          "dry",
          "astringent",
          "quick",
          "clean",
          "crisp",
          "bright",
          "vibrant",
          "tart",
          "wild",
          "unbalanced",
          "sharp",
          "pointed",
          "dense",
          "deep",
          "complex",
          "juicy",
          "lingering",
          "dirty"
        ],
        "name_1": [
          "Summer",
          "Holiday",
          "Jacked",
          "Joe",
          "Express",
          "Reg's",
          "Split",
          "Spilt",
          "Chocolate",
          "Dark",
          "Veranda",
          "Major",
          "Bluebery",
          "American",
          "Huggy",
          "Wake-up",
          "Morning",
          "Evening",
          "Winter",
          "Captain's",
          "Thanksgiving",
          "Seattle",
          "Brooklyn",
          "Café",
          "Blacktop",
          "Pumpkin-spice",
          "Good-morning",
          "Postmodern",
          "The Captain's",
          "The",
          "Cascara",
          "Melty",
          "Heart",
          "Goodbye",
          "Hello",
          "Street",
          "Red",
          "Blue",
          "Green",
          "Strong",
          "KrebStar",
          "Kreb-Full-o"
        ],
        "name_2": [
          "Solstice",
          "Blend",
          "Level",
          "Enlightenment",
          "Cowboy",
          "Choice",
          "Select",
          "Equinox",
          "Star",
          "Forrester",
          "Java",
          "Symphony",
          "Utopia",
          "Cup",
          "Mug",
          "Been",
          "Bean",
          "Cake",
          "Extract",
          "Delight",
          "Pie",
          "America",
          "Treat",
          "Volcano",
          "Breaker",
          "Town",
          "Light",
          "Look",
          "Coffee",
          "Nuts"
        ],
        "notes": "#{intensifier}, #{body}, #{descriptor}, #{descriptor}, #{descriptor}",
        "regions": {
          "brazil": [
            "Sul Minas",
            "Mogiana",
            "Cerrado"
          ],
          "burundi": [
            "Kayanza"
          ],
          "colombia": [
            "Nariño",
            "Huila",
            "Tolima",
            "Cauca",
            "Casanare",
            "Santander",
            "Antioquia",
            "Cundinamarca",
            "Boyacá"
          ],
          "costa_rica": [
            "Tarrazu",
            "Central Valley",
            "West Valley",
            "Guanacaste",
            "Tres Rios",
            "Turrialba",
            "Orosi",
            "Brunca"
          ],
          "el_salvador": [
            "Alotepec-Metapán",
            "Apaneca-Ilamatepec",
            "El Balsamo-Quetzaltepec",
            "Cacahuatique",
            "Chichontepec",
            "Tecapa-Chinameca"
          ],
          "ethiopia": [
            "Sidama",
            "Harrar",
            "Limu",
            "Ojimmah",
            "Lekempti",
            "Wellega",
            "Gimbi"
          ],
          "guatemala": [
            "Acatenango",
            "Antigua",
            "Atitlan",
            "Fraijanes",
            "Huehuetenango",
            "Nuevo Oriente",
            "Coban",
            "San Marcos"
          ],
          "honduras": [
            "Agalta",
            "Comayagua",
            "Copan",
            "Montecillos",
            "Opalca",
            "El Paraiso"
          ],
          "india": [
            "Chikmagalur",
            "Coorg",
            "Biligiris",
            "Bababudangiris",
            "Manjarabad",
            "Nilgiris",
            "Travancore",
            "Manjarabad",
            "Brahmaputra",
            "Pulneys",
            "Sheveroys"
          ],
          "kenya": [
            "Bungoma",
            "Embu",
            "Kiamba",
            "Kirinyaga",
            "Mt. Kenya",
            "Kisii",
            "Meru",
            "Murang'a",
            "Machakos",
            "Thika",
            "Nyeri",
            "Nakuru",
            "Nyanza",
            "Kericho"
          ],
          "mexico": [
            "Chiapas",
            "Oaxaca",
            "Veracruz",
            "Colima",
            "San Luis Potosi",
            "Nayarit",
            "Hidalgo",
            "Puebla",
            "Jalisco"
          ],
          "nicaragua": [
            "Matagalpa",
            "Jinotega",
            "Boaco",
            "Madriz",
            "Nueva Segovia",
            "Estelí",
            "Dipilto",
            "Jalapa",
            "Carazo",
            "Granada",
            "Masaya",
            "Managua",
            "Rivas"
          ],
          "panama": [
            "Boquete",
            "Chiriqui",
            "Volcan"
          ],
          "rwanda": [
            "Rulindo",
            "Gishamwana Coffee Island",
            "Lake Kivu Region",
            "Kigeyo Washing Station",
            "Kabirizi"
          ],
          "sumatra": [
            "Tapanuli",
            "Lintong",
            "Aceh",
            "Lake Tawar",
            "Lintong",
            "Gayo"
          ],
          "tanzania": [
            "Western Region, Bukova",
            "Western Region, Kigoma",
            "Mbeya Region",
            "Southern Region, Mbinga",
            "Western Region, Tarime",
            "Northern Region, Oldeani",
            "Northern Region, Arusha",
            "Northern Region, Kilimanjaro",
            "Southern Region, Morogoro"
          ],
          "uganda": [
            "Bugisu",
            "Mount Elgon",
            "Kibale"
          ],
          "yemen": [
            "Mattari",
            "San'ani",
            "Hirazi",
            "Raimi"
          ]
        },
        "variety": [
          "Liberica",
          "S288",
          "S795",
          "Kent",
          "Java",
          "Dilla",
          "Sumatara",
          "Catuai",
          "Pacamara",
          "Mundo Novo",
          "Red Bourbon",
          "Bourbon",
          "Yellow Bourbon",
          "Pacas",
          "Caturra",
          "Pink Bourbon",
          "Colombia",
          "Obata",
          "Catimors",
          "Sarchimor",
          "Mokka",
          "Kaffa",
          "Gimma",
          "Tafari-Kela",
          "S.4",
          "Agaro",
          "Dega",
          "Barbuk Sudan",
          "Ennarea",
          "Geisha",
          "Gesha",
          "Blue Mountain",
          "Kona",
          "San Ramon",
          "SL28",
          "SL34",
          "Villa Sarchi",
          "Villalobos",
          "Typica",
          "Ethiopian Heirloom"
        ]
      },
      "coin": {
        "flip": [
          "Heads",
          "Tails"
        ]
      },
      "color": {
        "name": [
          "amaranth",
          "amber",
          "amethyst",
          "apricot",
          "aquamarine",
          "azure",
          "beige",
          "black",
          "blue",
          "blush",
          "bronze",
          "brown",
          "burgundy",
          "byzantium",
          "carmine",
          "cerise",
          "cerulean",
          "champagne",
          "chocolate",
          "coffee",
          "copper",
          "coral",
          "crimson",
          "cyan",
          "emerald",
          "erin",
          "fuchsia",
          "gold",
          "gray",
          "green",
          "grey",
          "harlequin",
          "indigo",
          "ivory",
          "jade",
          "lavender",
          "lemon",
          "lilac",
          "lime",
          "magenta",
          "maroon",
          "mauve",
          "ochre",
          "olive",
          "orange",
          "orchid",
          "peach",
          "pear",
          "periwinkle",
          "pink",
          "plum",
          "puce",
          "purple",
          "raspberry",
          "red",
          "rose",
          "ruby",
          "salmon",
          "sangria",
          "sapphire",
          "scarlet",
          "silver",
          "sky",
          "tan",
          "taupe",
          "teal",
          "turquoise",
          "ultramarine",
          "violet",
          "viridian",
          "white",
          "yellow"
        ]
      },
      "commerce": {
        "brand": [
          "Samsung",
          "Dell",
          "Nike",
          "Apple",
          "LG",
          "Adidas",
          "Nikon",
          "Sony",
          "Beats",
          "GoPro"
        ],
        "department": [
          "Books",
          "Movies",
          "Music",
          "Games",
          "Electronics",
          "Computers",
          "Home",
          "Garden",
          "Tools",
          "Grocery",
          "Health",
          "Beauty",
          "Toys",
          "Kids",
          "Baby",
          "Clothing",
          "Shoes",
          "Jewelry",
          "Sports",
          "Outdoors",
          "Automotive",
          "Industrial"
        ],
        "product_name": {
          "adjective": [
            "Small",
            "Ergonomic",
            "Rustic",
            "Intelligent",
            "Gorgeous",
            "Incredible",
            "Fantastic",
            "Practical",
            "Sleek",
            "Awesome",
            "Enormous",
            "Mediocre",
            "Synergistic",
            "Heavy Duty",
            "Lightweight",
            "Aerodynamic",
            "Durable"
          ],
          "material": [
            "Steel",
            "Wooden",
            "Concrete",
            "Plastic",
            "Cotton",
            "Granite",
            "Rubber",
            "Leather",
            "Silk",
            "Wool",
            "Linen",
            "Marble",
            "Iron",
            "Bronze",
            "Copper",
            "Aluminum",
            "Paper"
          ],
          "product": [
            "Chair",
            "Car",
            "Computer",
            "Gloves",
            "Pants",
            "Shirt",
            "Table",
            "Shoes",
            "Hat",
            "Plate",
            "Knife",
            "Bottle",
            "Coat",
            "Lamp",
            "Keyboard",
            "Bag",
            "Bench",
            "Clock",
            "Watch",
            "Wallet"
          ]
        },
        "promotion_code": {
          "adjective": [
            "Amazing",
            "Awesome",
            "Cool",
            "Good",
            "Great",
            "Incredible",
            "Killer",
            "Premium",
            "Special",
            "Stellar",
            "Sweet"
          ],
          "noun": [
            "Code",
            "Deal",
            "Discount",
            "Price",
            "Promo",
            "Promotion",
            "Sale",
            "Savings"
          ]
        },
        "vendor": [
          "Amazon",
          "Dollar General",
          "Walmart",
          "Target"
        ]
      },
      "community": {
        "characters": [
          "Jeff Winger",
          "Britta Perry",
          "Señor Ben Chang",
          "Abed Nadir",
          "Annie Edison",
          "Dean Craig Pelton",
          "Pierce Hawthorne",
          "Troy Barnes",
          "Shirley Bennett",
          "Ian Duncan",
          "Michelle Slater",
          "Buzz Hickey",
          "Star Burns",
          "Magnitude",
          "Leonard Rodriguez",
          "Garrett Lambert",
          "Annie’s Boobs",
          "Inspector Spacetime",
          "Constable Reggie",
          "Kickpuncher",
          "Sean Garrig",
          "Vaughn Miller",
          "Rich Stephenson",
          "Neil",
          "Todd Jacobson",
          "Annie Kim"
        ],
        "quotes": [
          "Harrison Ford is irradiating our testicles with microwave satellite transmissions!",
          "Doing more than the minimum amount of work is my definition of failing.",
          "The next person that offers me charity or pity will be mentioned, by name, in my suicide note.",
          "I don’t have an ego. My Facebook photo is a landscape.",
          "Either I’m God, or truth is relative. Either way: booyah!",
          "I don’t step up to being a leader. I reluctantly accept it when it’s thrust upon me.",
          "Don’t talk to me about romance. I had a three way in a hot air balloon.",
          "Well I may be a genius, but I’m not a lesbian.",
          "I’m going to eat spaceman paninis with black Hitler and there’s nothing you can do about it!",
          "Do they find thoughts in our butts?",
          "I had sex with Eartha Kitt in an airplane bathroom.",
          "I was so unpopular in high school, the crossing guards used to lure me into traffic.",
          "A passing grade? Like a C? Why don’t I just get pregnant at a bus station?",
          "We’re all kind of crazytown bananapants.",
          "Make your money, whore.",
          "I know what a metaphor is! It’s like a thought with another thought’s hat on.",
          "Frankly, my dear, I don’t give a dean!",
          "I ate my twin in utero.",
          "Fire can’t go through doors, stupid. It’s not a ghost.",
          "You have just been proven racist by the racist prover!",
          "So… what is anthropology? Seriously, does anyone know?",
          "I quit doing blow, not being rad.",
          "I fear a political career could shine a negative light on my drug dealing.",
          "A little trick for achieving the proper competitive mindset: I always envision my opponent having aggresive sex with my mother.",
          "Look at me. It’s clear to you that I am awesome, but I can never admit that, because that would make me an ass.",
          "Some flies are too awesome for the wall.",
          "We’ll definitely be back next year. If not, it’ll be because an asteroid has destroyed all human civilization. And that’s canon."
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "department": [
          "Asset Management",
          "Board of Directors",
          "Business Development",
          "Corporate Communications",
          "Creative Services",
          "Customer Service",
          "Information Technology",
          "Engineering",
          "Finance / Accounting",
          "General Management",
          "Human Resources",
          "Investor Relations",
          "Legal",
          "Marketing",
          "Operations",
          "Product Management",
          "Production",
          "Project Management",
          "Purchasing / Sourcing",
          "Quality Assurance",
          "Risk Management",
          "Sales",
          "Strategic Initiatives",
          "Information Technology"
        ],
        "industry": [
          "Defense & Space",
          "Computer Hardware",
          "Computer Software",
          "Computer Networking",
          "Internet",
          "Semiconductors",
          "Telecommunications",
          "Law Practice",
          "Legal Services",
          "Management Consulting",
          "Biotechnology",
          "Medical Practice",
          "Hospital & Health Care",
          "Pharmaceuticals",
          "Veterinary",
          "Medical Devices",
          "Cosmetics",
          "Apparel & Fashion",
          "Sporting Goods",
          "Tobacco",
          "Supermarkets",
          "Food Production",
          "Consumer Electronics",
          "Consumer Goods",
          "Furniture",
          "Retail",
          "Entertainment",
          "Gambling & Casinos",
          "Leisure, Travel & Tourism",
          "Hospitality",
          "Restaurants",
          "Sports",
          "Food & Beverages",
          "Motion Pictures and Film",
          "Broadcast Media",
          "Museums and Institutions",
          "Fine Art",
          "Performing Arts",
          "Recreational Facilities and Services",
          "Banking",
          "Insurance",
          "Financial Services",
          "Real Estate",
          "Investment Banking",
          "Investment Management",
          "Accounting",
          "Construction",
          "Building Materials",
          "Architecture & Planning",
          "Civil Engineering",
          "Aviation & Aerospace",
          "Automotive",
          "Chemicals",
          "Machinery",
          "Mining & Metals",
          "Oil & Energy",
          "Shipbuilding",
          "Utilities",
          "Textiles",
          "Paper & Forest Products",
          "Railroad Manufacture",
          "Farming",
          "Ranching",
          "Dairy",
          "Fishery",
          "Primary / Secondary Education",
          "Higher Education",
          "Education Management",
          "Research",
          "Military",
          "Legislative Office",
          "Judiciary",
          "International Affairs",
          "Government Administration",
          "Executive Office",
          "Law Enforcement",
          "Public Safety",
          "Public Policy",
          "Marketing and Advertising",
          "Newspapers",
          "Publishing",
          "Printing",
          "Information Services",
          "Libraries",
          "Environmental Services",
          "Package / Freight Delivery",
          "Individual & Family Services",
          "Religious Institutions",
          "Civic & Social Organization",
          "Consumer Services",
          "Transportation / Trucking / Railroad",
          "Warehousing",
          "Airlines / Aviation",
          "Maritime",
          "Information Technology and Services",
          "Market Research",
          "Public Relations and Communications",
          "Design",
          "Nonprofit Organization Management",
          "Fund-Raising",
          "Program Development",
          "Writing and Editing",
          "Staffing and Recruiting",
          "Professional Training & Coaching",
          "Venture Capital & Private Equity",
          "Political Organization",
          "Translation and Localization",
          "Computer Games",
          "Events Services",
          "Arts and Crafts",
          "Electrical / Electronic Manufacturing",
          "Online Media",
          "Nanotechnology",
          "Music",
          "Logistics and Supply Chain",
          "Plastics",
          "Computer & Network Security",
          "Wireless",
          "Alternative Dispute Resolution",
          "Security and Investigations",
          "Facilities Services",
          "Outsourcing / Offshoring",
          "Health, Wellness and Fitness",
          "Alternative Medicine",
          "Media Production",
          "Animation",
          "Commercial Real Estate",
          "Capital Markets",
          "Think Tanks",
          "Philanthropy",
          "E-Learning",
          "Wholesale",
          "Import and Export",
          "Mechanical or Industrial Engineering",
          "Photography",
          "Human Resources",
          "Business Supplies and Equipment",
          "Mental Health Care",
          "Graphic Design",
          "International Trade and Development",
          "Wine and Spirits",
          "Luxury Goods & Jewelry",
          "Renewables & Environment",
          "Glass, Ceramics & Concrete",
          "Packaging and Containers",
          "Industrial Automation",
          "Government Relations"
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
        ],
        "profession": [
          "teacher",
          "actor",
          "musician",
          "philosopher",
          "writer",
          "doctor",
          "accountant",
          "agriculturist",
          "architect",
          "economist",
          "engineer",
          "interpreter",
          "attorney at law",
          "advocate",
          "librarian",
          "statistician",
          "human resources",
          "firefighter",
          "judge",
          "police officer",
          "astronomer",
          "biologist",
          "chemist",
          "physicist",
          "programmer",
          "web developer",
          "designer",
          "actress",
          "air traffic controller",
          "artist",
          "attorney",
          "banker",
          "bartender",
          "barber",
          "bookkeeper",
          "builder",
          "businessman",
          "butcher",
          "carpenter",
          "cashier",
          "chef",
          "coach",
          "dentist",
          "dental hygienist",
          "developer",
          "dietician",
          "editor",
          "electrician",
          "factory worker",
          "farmer",
          "fisherman",
          "gardener",
          "hairdresser",
          "journalist",
          "lawyer",
          "lecturer",
          "lifeguard",
          "mechanic",
          "model",
          "newsreader",
          "nurse",
          "optician",
          "painter",
          "pharmacist",
          "photographer",
          "pilot",
          "plumber",
          "politician",
          "postman",
          "receptionist",
          "scientist",
          "secretary",
          "shop assistant",
          "soldier",
          "tailor",
          "taxi driver",
          "translator",
          "traffic warden",
          "travel agent",
          "veterinary doctor",
          "waiter",
          "window cleaner"
        ],
        "sic_code": [
          "0111",
          "0112",
          "0115",
          "0116",
          "0119",
          "0131",
          "0132",
          "0133",
          "0134",
          "0139",
          "0161",
          "0171",
          "0172",
          "0173",
          "0174",
          "0175",
          "0179",
          "0181",
          "0182",
          "0191",
          "0211",
          "0212",
          "0213",
          "0214",
          "0219",
          "0241",
          "0251",
          "0252",
          "0253",
          "0254",
          "0259",
          "0271",
          "0272",
          "0273",
          "0279",
          "0291",
          "0711",
          "0721",
          "0722",
          "0723",
          "0724",
          "0741",
          "0742",
          "0751",
          "0752",
          "0761",
          "0762",
          "0781",
          "0782",
          "0783",
          "0811",
          "0831",
          "0851",
          "0912",
          "0913",
          "0919",
          "0921",
          "0971",
          "1011",
          "1021",
          "1031",
          "1041",
          "1044",
          "1061",
          "1081",
          "1094",
          "1099",
          "1221",
          "1222",
          "1231",
          "1241",
          "1311",
          "1321",
          "1381",
          "1382",
          "1389",
          "1411",
          "1422",
          "1423",
          "1429",
          "1442",
          "1446",
          "1455",
          "1459",
          "1474",
          "1475",
          "1479",
          "1481",
          "1499",
          "1521",
          "1522",
          "1531",
          "1541",
          "1542",
          "1611",
          "1622",
          "1623",
          "1629",
          "1711",
          "1721",
          "1731",
          "1741",
          "1742",
          "1743",
          "1751",
          "1752",
          "1761",
          "1771",
          "1781",
          "1791",
          "1793",
          "1794",
          "1795",
          "1796",
          "1799",
          "2011",
          "2013",
          "2015",
          "2021",
          "2022",
          "2023",
          "2024",
          "2026",
          "2032",
          "2033",
          "2034",
          "2035",
          "2037",
          "2038",
          "2041",
          "2043",
          "2044",
          "2045",
          "2046",
          "2047",
          "2048",
          "2051",
          "2052",
          "2053",
          "2061",
          "2062",
          "2063",
          "2064",
          "2066",
          "2067",
          "2068",
          "2074",
          "2075",
          "2076",
          "2077",
          "2079",
          "2082",
          "2083",
          "2084",
          "2085",
          "2086",
          "2087",
          "2091",
          "2092",
          "2095",
          "2096",
          "2097",
          "2098",
          "2099",
          "2111",
          "2121",
          "2131",
          "2141",
          "2211",
          "2221",
          "2231",
          "2241",
          "2251",
          "2252",
          "2253",
          "2254",
          "2257",
          "2258",
          "2259",
          "2261",
          "2262",
          "2269",
          "2273",
          "2281",
          "2282",
          "2284",
          "2295",
          "2296",
          "2297",
          "2298",
          "2299",
          "2311",
          "2321",
          "2322",
          "2323",
          "2325",
          "2326",
          "2329",
          "2331",
          "2335",
          "2337",
          "2339",
          "2341",
          "2342",
          "2353",
          "2361",
          "2369",
          "2371",
          "2381",
          "2384",
          "2385",
          "2386",
          "2387",
          "2389",
          "2391",
          "2392",
          "2393",
          "2394",
          "2395",
          "2396",
          "2397",
          "2399",
          "2411",
          "2421",
          "2426",
          "2429",
          "2431",
          "2434",
          "2435",
          "2436",
          "2439",
          "2441",
          "2448",
          "2449",
          "2451",
          "2452",
          "2491",
          "2493",
          "2499",
          "2511",
          "2512",
          "2514",
          "2515",
          "2517",
          "2519",
          "2521",
          "2522",
          "2531",
          "2541",
          "2542",
          "2591",
          "2599",
          "2611",
          "2621",
          "2631",
          "2652",
          "2653",
          "2655",
          "2656",
          "2657",
          "2671",
          "2672",
          "2673",
          "2674",
          "2675",
          "2676",
          "2677",
          "2678",
          "2679",
          "2711",
          "2721",
          "2731",
          "2732",
          "2741",
          "2752",
          "2754",
          "2759",
          "2761",
          "2771",
          "2782",
          "2789",
          "2791",
          "2796",
          "2812",
          "2813",
          "2816",
          "2819",
          "2821",
          "2822",
          "2823",
          "2824",
          "2833",
          "2834",
          "2835",
          "2836",
          "2841",
          "2842",
          "2843",
          "2844",
          "2851",
          "2861",
          "2865",
          "2869",
          "2873",
          "2874",
          "2875",
          "2879",
          "2891",
          "2892",
          "2893",
          "2895",
          "2899",
          "2911",
          "2951",
          "2952",
          "2992",
          "2999",
          "3011",
          "3021",
          "3052",
          "3053",
          "3061",
          "3069",
          "3081",
          "3082",
          "3083",
          "3084",
          "3085",
          "3086",
          "3087",
          "3088",
          "3089",
          "3111",
          "3131",
          "3142",
          "3143",
          "3144",
          "3149",
          "3151",
          "3161",
          "3171",
          "3172",
          "3199",
          "3211",
          "3221",
          "3229",
          "3231",
          "3241",
          "3251",
          "3253",
          "3255",
          "3259",
          "3261",
          "3262",
          "3263",
          "3264",
          "3269",
          "3271",
          "3272",
          "3273",
          "3274",
          "3275",
          "3281",
          "3291",
          "3292",
          "3295",
          "3296",
          "3297",
          "3299",
          "3312",
          "3313",
          "3315",
          "3316",
          "3317",
          "3321",
          "3322",
          "3324",
          "3325",
          "3331",
          "3334",
          "3339",
          "3341",
          "3351",
          "3353",
          "3354",
          "3355",
          "3356",
          "3357",
          "3363",
          "3364",
          "3365",
          "3366",
          "3369",
          "3398",
          "3399",
          "3411",
          "3412",
          "3421",
          "3423",
          "3425",
          "3429",
          "3431",
          "3432",
          "3433",
          "3441",
          "3442",
          "3443",
          "3444",
          "3446",
          "3448",
          "3449",
          "3451",
          "3452",
          "3462",
          "3463",
          "3465",
          "3466",
          "3469",
          "3471",
          "3479",
          "3482",
          "3483",
          "3484",
          "3489",
          "3491",
          "3492",
          "3493",
          "3494",
          "3495",
          "3496",
          "3497",
          "3498",
          "3499",
          "3511",
          "3519",
          "3523",
          "3524",
          "3531",
          "3532",
          "3533",
          "3534",
          "3535",
          "3536",
          "3537",
          "3541",
          "3542",
          "3543",
          "3544",
          "3545",
          "3546",
          "3547",
          "3548",
          "3549",
          "3552",
          "3553",
          "3554",
          "3555",
          "3556",
          "3559",
          "3561",
          "3562",
          "3563",
          "3564",
          "3565",
          "3566",
          "3567",
          "3568",
          "3569",
          "3571",
          "3572",
          "3575",
          "3577",
          "3578",
          "3579",
          "3581",
          "3582",
          "3585",
          "3586",
          "3589",
          "3592",
          "3593",
          "3594",
          "3596",
          "3599",
          "3612",
          "3613",
          "3621",
          "3624",
          "3625",
          "3629",
          "3631",
          "3632",
          "3633",
          "3634",
          "3635",
          "3639",
          "3641",
          "3643",
          "3644",
          "3645",
          "3646",
          "3647",
          "3648",
          "3651",
          "3652",
          "3661",
          "3663",
          "3669",
          "3671",
          "3672",
          "3674",
          "3675",
          "3676",
          "3677",
          "3678",
          "3679",
          "3691",
          "3692",
          "3694",
          "3695",
          "3699",
          "3711",
          "3713",
          "3714",
          "3715",
          "3716",
          "3721",
          "3724",
          "3728",
          "3731",
          "3732",
          "3743",
          "3751",
          "3761",
          "3764",
          "3769",
          "3792",
          "3795",
          "3799",
          "3812",
          "3821",
          "3822",
          "3823",
          "3824",
          "3825",
          "3826",
          "3827",
          "3829",
          "3841",
          "3842",
          "3843",
          "3844",
          "3845",
          "3851",
          "3861",
          "3873",
          "3911",
          "3914",
          "3915",
          "3931",
          "3942",
          "3944",
          "3949",
          "3951",
          "3952",
          "3953",
          "3955",
          "3961",
          "3965",
          "3991",
          "3993",
          "3995",
          "3996",
          "3999",
          "4011",
          "4013",
          "4111",
          "4119",
          "4121",
          "4131",
          "4141",
          "4142",
          "4151",
          "4173",
          "4212",
          "4213",
          "4214",
          "4215",
          "4221",
          "4222",
          "4225",
          "4226",
          "4231",
          "4311",
          "4412",
          "4424",
          "4432",
          "4449",
          "4481",
          "4482",
          "4489",
          "4491",
          "4492",
          "4493",
          "4499",
          "4512",
          "4513",
          "4522",
          "4581",
          "4612",
          "4613",
          "4619",
          "4724",
          "4725",
          "4729",
          "4731",
          "4741",
          "4783",
          "4785",
          "4789",
          "4812",
          "4813",
          "4822",
          "4832",
          "4833",
          "4841",
          "4899",
          "4911",
          "4922",
          "4923",
          "4924",
          "4925",
          "4931",
          "4932",
          "4939",
          "4941",
          "4952",
          "4953",
          "4959",
          "4961",
          "4971",
          "5012",
          "5013",
          "5014",
          "5015",
          "5021",
          "5023",
          "5031",
          "5032",
          "5033",
          "5039",
          "5043",
          "5044",
          "5045",
          "5046",
          "5047",
          "5048",
          "5049",
          "5051",
          "5052",
          "5063",
          "5064",
          "5065",
          "5072",
          "5074",
          "5075",
          "5078",
          "5082",
          "5083",
          "5084",
          "5085",
          "5087",
          "5088",
          "5091",
          "5092",
          "5093",
          "5094",
          "5099",
          "5111",
          "5112",
          "5113",
          "5122",
          "5131",
          "5136",
          "5137",
          "5139",
          "5141",
          "5142",
          "5143",
          "5144",
          "5145",
          "5146",
          "5147",
          "5148",
          "5149",
          "5153",
          "5154",
          "5159",
          "5162",
          "5169",
          "5171",
          "5172",
          "5181",
          "5182",
          "5191",
          "5192",
          "5193",
          "5194",
          "5198",
          "5199",
          "5211",
          "5231",
          "5251",
          "5261",
          "5271",
          "5311",
          "5331",
          "5399",
          "5411",
          "5421",
          "5431",
          "5441",
          "5451",
          "5461",
          "5499",
          "5511",
          "5521",
          "5531",
          "5541",
          "5551",
          "5561",
          "5571",
          "5599",
          "5611",
          "5621",
          "5632",
          "5641",
          "5651",
          "5661",
          "5699",
          "5712",
          "5713",
          "5714",
          "5719",
          "5722",
          "5731",
          "5734",
          "5735",
          "5736",
          "5812",
          "5813",
          "5912",
          "5921",
          "5932",
          "5941",
          "5942",
          "5943",
          "5944",
          "5945",
          "5946",
          "5947",
          "5948",
          "5949",
          "5961",
          "5962",
          "5963",
          "5983",
          "5984",
          "5989",
          "5992",
          "5993",
          "5994",
          "5995",
          "5999",
          "6011",
          "6019",
          "6021",
          "6022",
          "6029",
          "6035",
          "6036",
          "6061",
          "6062",
          "6081",
          "6082",
          "6091",
          "6099",
          "6111",
          "6141",
          "6153",
          "6159",
          "6162",
          "6163",
          "6211",
          "6221",
          "6231",
          "6282",
          "6289",
          "6311",
          "6321",
          "6324",
          "6331",
          "6351",
          "6361",
          "6371",
          "6399",
          "6411",
          "6512",
          "6513",
          "6514",
          "6515",
          "6517",
          "6519",
          "6531",
          "6541",
          "6552",
          "6553",
          "6712",
          "6719",
          "6722",
          "6726",
          "6732",
          "6733",
          "6792",
          "6794",
          "6798",
          "6799",
          "7011",
          "7021",
          "7032",
          "7033",
          "7041",
          "7211",
          "7212",
          "7213",
          "7215",
          "7216",
          "7217",
          "7218",
          "7219",
          "7221",
          "7231",
          "7241",
          "7251",
          "7261",
          "7291",
          "7299",
          "7311",
          "7312",
          "7313",
          "7319",
          "7322",
          "7323",
          "7331",
          "7334",
          "7335",
          "7336",
          "7338",
          "7342",
          "7349",
          "7352",
          "7353",
          "7359",
          "7361",
          "7363",
          "7371",
          "7372",
          "7373",
          "7374",
          "7375",
          "7376",
          "7377",
          "7378",
          "7379",
          "7381",
          "7382",
          "7383",
          "7384",
          "7389",
          "7513",
          "7514",
          "7515",
          "7519",
          "7521",
          "7532",
          "7533",
          "7534",
          "7536",
          "7537",
          "7538",
          "7539",
          "7542",
          "7549",
          "7622",
          "7623",
          "7629",
          "7631",
          "7641",
          "7692",
          "7694",
          "7699",
          "7812",
          "7819",
          "7822",
          "7829",
          "7832",
          "7833",
          "7841",
          "7911",
          "7922",
          "7929",
          "7933",
          "7941",
          "7948",
          "7991",
          "7992",
          "7993",
          "7996",
          "7997",
          "7999",
          "8011",
          "8021",
          "8031",
          "8041",
          "8042",
          "8043",
          "8049",
          "8051",
          "8052",
          "8059",
          "8062",
          "8063",
          "8069",
          "8071",
          "8072",
          "8082",
          "8092",
          "8093",
          "8099",
          "8111",
          "8211",
          "8221",
          "8222",
          "8231",
          "8243",
          "8244",
          "8249",
          "8299",
          "8322",
          "8331",
          "8351",
          "8361",
          "8399",
          "8412",
          "8422",
          "8611",
          "8621",
          "8631",
          "8641",
          "8651",
          "8661",
          "8699",
          "8711",
          "8712",
          "8713",
          "8721",
          "8731",
          "8732",
          "8733",
          "8734",
          "8741",
          "8742",
          "8743",
          "8744",
          "8748",
          "8811",
          "8999",
          "9111",
          "9121",
          "9131",
          "9199",
          "9211",
          "9221",
          "9222",
          "9223",
          "9224",
          "9229",
          "9311",
          "9411",
          "9431",
          "9441",
          "9451",
          "9511",
          "9512",
          "9531",
          "9532",
          "9611",
          "9621",
          "9631",
          "9641",
          "9651",
          "9661",
          "9711",
          "9721",
          "9999"
        ],
        "suffix": [
          "Inc",
          "and Sons",
          "LLC",
          "Group"
        ],
        "type": [
          "Public Company",
          "Educational Institution",
          "Self-Employed",
          "Government Agency",
          "Nonprofit",
          "Sole Proprietorship",
          "Privately Held",
          "Partnership"
        ]
      },
      "compass": {
        "abbreviation": [
          "#{cardinal_abbreviation}",
          "#{ordinal_abbreviation}",
          "#{half_wind_abbreviation}",
          "#{quarter_wind_abbreviation}"
        ],
        "azimuth": [
          "#{cardinal_azimuth}",
          "#{ordinal_azimuth}",
          "#{half_wind_azimuth}",
          "#{quarter_wind_azimuth}"
        ],
        "cardinal": {
          "abbreviation": [
            "N",
            "E",
            "S",
            "W"
          ],
          "azimuth": [
            "0",
            "90",
            "180",
            "270"
          ],
          "word": [
            "north",
            "east",
            "south",
            "west"
          ]
        },
        "direction": [
          "#{cardinal}",
          "#{ordinal}",
          "#{half_wind}",
          "#{quarter_wind}"
        ],
        "half-wind": {
          "abbreviation": [
            "NNE",
            "ENE",
            "ESE",
            "SSE",
            "SSW",
            "WSW",
            "WNW",
            "NNW"
          ],
          "azimuth": [
            "22.5",
            "67.5",
            "112.5",
            "157.5",
            "202.5",
            "247.5",
            "292.5",
            "337.5"
          ],
          "word": [
            "north-northeast",
            "east-northeast",
            "east-southeast",
            "south-southeast",
            "south-southwest",
            "west-southwest",
            "west-northwest",
            "north-northwest"
          ]
        },
        "ordinal": {
          "abbreviation": [
            "NE",
            "SE",
            "SW",
            "NW"
          ],
          "azimuth": [
            "45",
            "135",
            "225",
            "315"
          ],
          "word": [
            "northeast",
            "southeast",
            "southwest",
            "northwest"
          ]
        },
        "quarter-wind": {
          "abbreviation": [
            "NbE",
            "NEbN",
            "NEbE",
            "EbN",
            "EbS",
            "SEbE",
            "SEbS",
            "SbE",
            "SbW",
            "SWbS",
            "SWbW",
            "WbS",
            "WbN",
            "NWbW",
            "NWbN",
            "NbW"
          ],
          "azimuth": [
            "11.25",
            "33.75",
            "56.25",
            "78.75",
            "101.25",
            "123.75",
            "146.25",
            "168.75",
            "191.25",
            "213.75",
            "236.25",
            "258.75",
            "281.25",
            "303.75",
            "326.25",
            "348.75"
          ],
          "word": [
            "north by east",
            "northeast by north",
            "northeast by east",
            "east by north",
            "east by south",
            "southeast by east",
            "southeast by south",
            "south by east",
            "south by west",
            "southwest by south",
            "southwest by west",
            "west by south",
            "west by north",
            "northwest by west",
            "northwest by north",
            "north by west"
          ]
        }
      },
      "computer": {
        "os": {
          "linux": [
            "RHEL 9.0",
            "RHEL 7.7",
            "RHEL 6.10",
            "CentOS 8.5",
            "CentOS 7",
            "CentOS 6",
            "Debian 11.4.0",
            "Debian 10.10.3",
            "Debian 9.9.10",
            "Ubuntu Server 22.04",
            "Ubuntu Server 20.04",
            "Ubuntu Server 19.10",
            "Ubuntu Server 18.04",
            "ArchLinux 2022.08.05",
            "ArchLinux 2020.02.01",
            "openSUSE Leap 15.4",
            "openSUSE Leap 15.1",
            "Ubuntu Desktop 22.04",
            "Ubuntu Desktop 20.04",
            "Ubuntu Desktop 18.04",
            "Ubuntu Desktop 19.10"
          ],
          "macos": [
            "Catalina (10.15)",
            "Mojave (10.14)",
            "High Sierra (10.13)"
          ],
          "openbsd": [
            "OpenBSD 7.1",
            "OpenBSD 6"
          ],
          "plan 9": [
            "Plan 9 Fourth Edition"
          ],
          "templeos": [
            "TempleOS 5.03"
          ],
          "windows": [
            "Windows 11",
            "Windows 10",
            "Windows 8.1",
            "Windows 7",
            "Windows Server 2019",
            "Windows Server 2016",
            "Windows Server 2012 R2"
          ]
        },
        "platform": [
          "Linux",
          "macOS",
          "Windows",
          "OpenBSD",
          "TempleOS",
          "Plan 9"
        ],
        "type": [
          "server",
          "workstation"
        ]
      },
      "conan": {
        "characters": [
          "Shinichi Kudo",
          "Conan Edogawa",
          "Ran Mouri",
          "Kogoro Mouri",
          "Ai Haibara",
          "Ayumi Yoshida",
          "Mitsuhiko Tsuburaya",
          "Genta Kojima",
          "Hiroshi Agasa",
          "Sonoko Suzuki",
          "Eri Kisaki",
          "Yusaku Kudo",
          "Yukiko Kudo",
          "Heiji Hattori",
          "Kazuha Toyama",
          "Yoko Okino",
          "Sumiko Kobayashi",
          "Tomoaki Araide",
          "Makoto Kyogoku",
          "Shizuka Hattori",
          "Jirokichi Suzuki",
          "Eisuke Hondou",
          "Azusa Enomoto",
          "Subaru Okiya",
          "Masumi Sera",
          "Shukichi Haneda",
          "Sakurako Yonehara",
          "Juzo Megure",
          "Ninzaburo Shiratori",
          "Miwako Sato",
          "Wataru Takagi",
          "Kazunobu Chiba",
          "Yumi Miyamoto",
          "Naeko Miike",
          "Kiyonaga Matsumoto",
          "Inspector Yuminaga",
          "Shintaro Chaki",
          "Hyoue Kuroda",
          "Heizo Hattori",
          "Ginshiro Toyama",
          "Goro Otaki",
          "Kansuke Yamato",
          "Yui Uehara",
          "Taka'aki Morofushi (Komei)",
          "Sango Yokomizo",
          "Misao Yamamura",
          "Jugo Yokomizo",
          "Fumimaro Ayanokoji",
          "Rei Furuya (Bourbon)",
          "Hiromitsu Morofushi (Scotch)",
          "Yuya Kazami",
          "Shuichi Akai",
          "Jodie Starling (Jodie Saintemillion)",
          "James Black",
          "Andre Camel",
          "Hidemi Hondou (Kir)",
          "Ethan Hondou",
          "Mary Sera",
          "Tsutomu Akai",
          "Gin",
          "Vodka",
          "Chris Vineyard (Vermouth)",
          "Chianti",
          "Korn",
          "Shiho Miyano (Sherry)",
          "Akemi Miyano",
          "Elena Miyano",
          "Atsushi Miyano",
          "Tequila",
          "Kenzo Masuyama (Pisco)",
          "Calvados",
          "Rikumichi Kusuda",
          "Ki'ichiro Numabuchi",
          "Kaito Kuroba",
          "Kaitou Kid",
          "Aoko Nakamori",
          "Ginzo Nakamori",
          "Toichi Kuroba",
          "Chikage Kuroba",
          "Konosuke Jii",
          "Kaitou Corbeau",
          "Akako Koizumi",
          "Saguru Hakuba",
          "Snake",
          "Spider",
          "Scar Akai",
          "Kohji Haneda",
          "Asaka",
          "Momiji Ooka",
          "Rumi Wakasa",
          "Kanenori Wakita",
          "Muga Iori"
        ],
        "gadgets": [
          "Voice-Changing Bowtie",
          "Power-Enhancing Kick Shoes",
          "Glasses Modification (Microphone)",
          "Stun-Gun Wristwatch",
          "Portable Bento Box Fax",
          "Detective Boys Badge",
          "Turbo Engine Skateboard",
          "Criminal Tracking Glasses",
          "Transmitter",
          "Elasticity Suspenders",
          "Button Speaker",
          "Earring Cellphone",
          "Electronic Notebook Map",
          "Wristwatch Flashlight",
          "Kamen Yaiba Voice Changer/Pen Voice Changer",
          "Voice-Changing Face Mask",
          "Anywhere Ball Dispensing Belt",
          "Voice-Changing Choker",
          "Glasses Modification (Bullet Proof Lenses)",
          "Glasses Modification (Telescopic Lenses)",
          "Hang Glider/Paraglider",
          "Cuff Link Speakers",
          "Mini Air Tank",
          "Turbo Engine Snowboard",
          "Satellite-Telephone Wristwatch",
          "Drone",
          "Card Gun",
          "Hang Glider Cape",
          "Turbo Engine Scooter",
          "Turbo Engine Skates"
        ],
        "vehicles": [
          "Agasa's Volkswagen Beetle",
          "Yukiko's Jaguar E-Type",
          "Masumi's Yamaha Artesia XT400",
          "Jirokichi's Harley Davidson Electra Glide",
          "Okiya's Subaru 360",
          "Eri's Mini Cooper",
          "Baya's Cobra",
          "Jii's Vanden Plas Princess 1100",
          "Fusae's Jaguar Mark 2",
          "Sato's Mazda RX-7",
          "Takagi's Nissan Tiida Latio",
          "Takagi's Skyline ER34",
          "Chiba's Fiat 500",
          "Chiba's Nissan GT-R R35 (2017)",
          "Uehara's Honda Inspire",
          "Gin's Porsche 356 A",
          "Chianti's Dodge Viper",
          "Vermouth's Harley-Davidson V-Rod",
          "Rei's Mazda RX-7",
          "Vodka's Porsche 914",
          "Chianti's Ducati 1098",
          "Araide's Toyota Prius (XW10)",
          "Vermouth's De Tomaso Pantera",
          "Shuichi's Chevrolet C-1500",
          "Shuichi's Ford Mustang",
          "James' Mercedes CLK320",
          "Jodie's Peugeot 607",
          "Hidemi's Citroën BX",
          "FBI's Toyota HiAce/Regius Ace",
          "FBI's Volvo S40",
          "FBI's Lexus GS",
          "FBI's Mercedes CLK320",
          "Isuzu Cubic bus",
          "Nissan X-Trail",
          "Toichi's Car",
          "Hidemi's Motorcycle",
          "Heiji's Motorcycle",
          "Snake's car",
          "Shiratori's car",
          "Kusuda's Nissan",
          "Yukiko's Motorcycle"
        ]
      },
      "construction": {
        "heavy_equipment": [
          "Excavator",
          "Backhoe",
          "Bulldozer",
          "Skid-Steer",
          "Grader",
          "Crawler",
          "Trencher",
          "Scraper",
          "Dump Truck",
          "Compactor",
          "Dragline"
        ],
        "materials": [
          "Aluminum",
          "Brass",
          "Glass",
          "Granite",
          "Plastic",
          "Plexiglass",
          "Rubber",
          "Steel",
          "Stone",
          "Vinyl",
          "Wood"
        ],
        "roles": [
          "Construction Manager",
          "Estimator",
          "Architect",
          "Supervisor",
          "Construction Expeditor",
          "Construction Worker",
          "Engineer",
          "Electrician",
          "Construction Foreman",
          "Subcontractor",
          "Project Manager",
          "Surveyor"
        ],
        "standard_cost_codes": [
          "1 - General Requirements",
          "1-000 - Purpose",
          "1-002 - Instructions",
          "1-010 - Project Manager",
          "1-011 - Project Engineer",
          "1-012 - Superintendent",
          "1-013 - Project Coordinator",
          "1-014 - Project Executive",
          "1-500 - Temporary Facilities and Controls",
          "1-510 - Temporary Utilities",
          "1-511 - Temporary Electricity",
          "1-514 - Temporary Heating, Cooling and Ventilation",
          "1-515 - Temporary Lighting",
          "1-517 - Temporary Telephone",
          "1-518 - Temporary Water",
          "1-520 - Construction Facilities",
          "1-523 - Sanitary Facilities",
          "1-530 - Temporary Construction",
          "1-540 - Construction Aids",
          "1-542 - Construction Scaffolding and Platforms",
          "1-550 - Vehicular Access and Parking",
          "1-560 - Temporary Barriers and Enclosures",
          "1-570 - Temporary Controls",
          "1-580 - Project Identification",
          "1-600 - Product Requirements (Scope of Work)",
          "1-630 - Product Substitution Procedures",
          "1-640 - Owner Furnished Products",
          "1-700 - Execution Requirements",
          "1-712 - Local Conditions",
          "1-740 - Cleaning",
          "1-760 - Protecting Installed Construction",
          "1-903 - Hazardous Materials Abatement",
          "1-904 - Hazardous Materials Removal and Disposal",
          "2 - Site Construction",
          "2-000 - General",
          "2-200 - Site Preparation",
          "2-220 - Site Demolition",
          "2-230 - Site Clearing",
          "2-240 - Dewatering",
          "2-250 - Shoring and Underpinning",
          "2-260 - Excavation Support and Protection",
          "2-300 - Earthwork",
          "2-310 - Grading",
          "2-311 - Final Grading",
          "2-312 - Rough Grading",
          "2-315 - Excavation",
          "2-316 - Backfilling",
          "2-317 - Select Borrow",
          "2-320 - Excavation and Fill",
          "2-362 - Termite Control",
          "2-370 - Erosion and Sedimentation Control",
          "2-500 - Utility Services",
          "2-540 - Septic Tank",
          "2-621 - Foundatation Drainage Piping",
          "2-625 - Retaining Wall Drainage Piping",
          "2-740 - Flexible Pavement Asphalt Pavement",
          "2-750 - Concrete Pads and Walks",
          "2-770 - Curb and Gutters",
          "2-780 - Clay Unit Pavers",
          "2-781 - Asphalt Pavers",
          "2-782 - Brick Pavers",
          "2-783 - Interlocking Concrete Unit Paving",
          "2-784 - Stone Unit Pavers",
          "2-790 - Athletic Surfacing",
          "2-795 - Porous Paving",
          "2-800 - Site Amenities",
          "2-812 - Drip Irrigation",
          "2-813 - Lawn Sprinkling and Irrigation",
          "2-815 - Fountains",
          "2-820 - Fences and Gates",
          "2-821 - Chain Link Fences",
          "2-822 - Ornamental Metal Fences and Gates",
          "2-823 - PVC Fences and Gates",
          "2-824 - Wire Fences and Gates",
          "2-825 - Wood Fences and Gates",
          "2-830 - Retaining Walls",
          "2-850 - Bridges/Footbridges",
          "2-870 - Sculpture/Ornamental",
          "2-900 - Landscaping",
          "2-915 - Mulch",
          "2-917 - Soil Preparation",
          "2-919 - Topsoil",
          "2-923 - Seeding and Soil Supplements",
          "2-924 - Sodding",
          "2-930 - Exterior Plants",
          "2-932 - PLants and Bulbs",
          "2-935 - Plant Maintenance",
          "2-936 - Fertilizer",
          "3 - Concrete",
          "3-000 - General",
          "3-050 - Concrete Subcontractor",
          "3-100 - Concrete Reinforcement",
          "3-210 - Cast-In-Place Concrete",
          "3-230 - Anchor Bolts",
          "3-300 - Footings",
          "3-310 - Expansion Joints",
          "3-320 - Slab Foundations",
          "3-330 - Poured Concrete Basement Walls",
          "3-350 - Concrete Finishing",
          "3-400 - Precast Concrete",
          "3-500 - Cementitious Decks and Underlayments",
          "3-540 - Cementitious Underlayments",
          "3-600 - Grouts",
          "4 - Masonry",
          "4-050 - Basic Masonry Materials and Methods",
          "4-200 - Masonry Units",
          "4-400 - Stone",
          "4-500 - Refractories",
          "4-600 - Corrosion-Resistant Masonry",
          "4-700 - Simulated Masonry",
          "4-800 - Masonry Assemblies",
          "4-900 - Masonry Restoration and Cleaning",
          "5 - Metals",
          "5-050 - Basic Metal Materials and Methods",
          "5-100 - Structural Metals",
          "5-200 - Metal Joists",
          "5-300 - Metal Deck",
          "5-400 - Cold-Formed Metal Framing",
          "5-500 - Metal Fabrications",
          "5-600 - Hydraulic Fabrications",
          "5-700 - Ornamental Metal",
          "5-800 - Expansion Control",
          "5-900 - Metal Restoration and Cleaning",
          "6 - Wood and Plastics",
          "6-050 - Basic Wood and Plastic Materials and Methods",
          "6-100 - Rough Carpentry",
          "6-200 - Finish Carpentry",
          "6-400 - Architectural Woodwork",
          "6-500 - Structural Plastics",
          "6-600 - Plastic Fabrications",
          "6-900 - Wood and Plastic Restoration and Cleaning",
          "7 - Thermal and Moisture Protection",
          "7-050 - Basic Thermal and Moisture Protection Materials and Methods",
          "7-100 - Damproofing and Waterproofing",
          "7-200 - Thermal Protection - Insulation",
          "7-300 - Shingles, Roof Tiles, and Roof Coverings",
          "7-400 - Roofing and Siding Panels",
          "7-500 - Membrane Roofing",
          "7-600 - Flashing and Sheet Metal",
          "7-700 - Roof Specialties and Accessories",
          "7-800 - Fire and Smoke Protection",
          "7-900 - Joint Sealers",
          "8 - Doors and Windows",
          "8-050 - Basic Door and Window Materials and Methods",
          "8-100 - Doors",
          "8-200 - Wood and Plastic Doors",
          "8-300 - Specialty Doors",
          "8-400 - Entrances and Storefronts",
          "8-500 - Windows",
          "8-600 - Skylights",
          "8-700 - Hardware",
          "8-800 - Glazing",
          "8-900 - Glazed Curtain Wall",
          "9 - Finishes",
          "9-050 - Basic Finish Materials and Methods",
          "9-100 - Metal Support Assemblies",
          "9-250 - Gypsum Wallboard",
          "9-300 - Tile",
          "9-400 - Terrazzo",
          "9-500 - Ceilings",
          "9-600 - Flooring",
          "9-680 - Carpet",
          "9-700 - Wall Finishes",
          "9-800 - Acoustical Treatment",
          "9-900 - Paints and Coatings",
          "10 - Specialties",
          "10-100 - Visual Display Boards",
          "10-150 - Compartments and Cubicles",
          "10-200 - Louvers and Vents",
          "10-240 - Grilles and Screens",
          "10-250 - Service Walls",
          "10-260 - Wall and Corner Guards",
          "10-270 - Access Flooring",
          "10-290 - Pest Control",
          "10-300 - Fireplaces and Stoves",
          "10-340 - Manufactured Exterior Specialties",
          "10-350 - Flagpoles",
          "10-400 - Identification Devices",
          "10-450 - Pedestrian Control Devices",
          "10-500 - Lockers",
          "10-520 - Fire Protection Specialties",
          "10-530 - Protective Covers",
          "10-550 - Postal Specialties",
          "10-600 - Partitions",
          "10-670 - Storage Shelving",
          "10-700 - Exterior Protection",
          "10-750 - Telephone Specialties",
          "10-800 - Toilet, Bath, and Laundry Specialties",
          "10-820 - Bathroom Accessories",
          "10-880 - Scales",
          "10-900 - Wardrobe and Closet Specialties",
          "11 - Equipment",
          "11-010 - Maintenance Equipment",
          "11-020 - Security and Vault Equipment",
          "11-030 - Teller and Service Equipment",
          "11-040 - Ecclesiastical Equipment",
          "11-050 - Library Equipment",
          "11-060 - Theater and Stage Equipment",
          "11-070 - Instrumental Equipment",
          "11-080 - Registration Equipment",
          "11-090 - Checkroom Equipment",
          "11-100 - Mercantile Equipment",
          "11-110 - Commercial Laundry and Dry Cleaning Equipment",
          "11-120 - Vending Equipment",
          "11-130 - Audio-Visual Equipment",
          "11-140 - Vehicle Service Equipment",
          "11-150 - Parking Control Equipment",
          "11-160 - Loading Dock Equipment",
          "11-170 - Solid Waste Handling Equipment",
          "11-190 - Detention Equipment",
          "11-200 - Water Supply and Treatment Equipment",
          "11-280 - Hydraulic Gates and Valves",
          "11-300 - Fluid Waste Treatment and Disposal Equipment",
          "11-400 - Food Service Equipment",
          "11-450 - Residential Equipment",
          "11-460 - Unit Kitchens",
          "11-470 - Darkroom Equipment",
          "11-480 - Athletic, Recreational, and Therapeutic Equipment",
          "11-500 - Industrial and Process Equipment",
          "11-600 - Laboratory Equipment",
          "11-650 - Planetarium Equipment",
          "11-660 - Observatory Equipment",
          "11-680 - Office Equipment",
          "11-700 - Medical Equipment",
          "11-780 - Mortuary Equipment",
          "11-850 - Navigation Equipment",
          "11-870 - Agricultural Equipment",
          "11-900 - Exhibit Equipment",
          "12 - Furnishings",
          "12-050 - Fabrics",
          "12-100 - Art",
          "12-300 - Manufactured Casework",
          "12-400 - Furnishings and Accessories",
          "12-500 - Furniture",
          "12-600 - Multiple Seating",
          "12-700 - Systems Furniture",
          "12-800 - Interior Plants and Planters",
          "12-900 - Furnishings Restoration and Repair",
          "13 - Special Construction",
          "13-010 - Air-Supported Structures",
          "13-020 - Building Modules",
          "13-030 - Special Purpose Rooms",
          "13-080 - Sound, Vibration, and Seismic Control",
          "13-090 - Radiation Protection",
          "13-100 - Lightning Protection",
          "13-110 - Cathodic Protection",
          "13-120 - Pre-Engineered Structures",
          "13-150 - Swimming Pools",
          "13-160 - Aquariums",
          "13-165 - Aquatic Park Facilities",
          "13-170 - Tubs and Pools",
          "13-175 - Ice Rinks",
          "13-185 - Kennels and Animal Shelters",
          "13-190 - Site-Constructed Incinerators",
          "13-200 - Storage Tanks",
          "13-220 - Filter Underdrains and Media",
          "13-230 - Digester Covers and Appurtenances",
          "13-240 - Oxygenation Systems",
          "13-260 - Sludge Conditioning Systems",
          "13-280 - Hazardous Material Remediation",
          "13-400 - Measurement and Control Instrumentation",
          "13-500 - Recording Instrumentation",
          "13-550 - Transportation Control Instrumentation",
          "13-600 - Solar and Wind Energy Equipment",
          "13-700 - Security Access and Surveillance",
          "13-800 - Building Automation and Control",
          "13-850 - Detection and Alarm",
          "13-900 - Fire Suppression",
          "14 - Conveying Systems",
          "14-100 - Dumbwaiters",
          "14-200 - Elevators",
          "14-300 - Escalators and Moving Walks",
          "14-400 - Lifts",
          "14-500 - Material Handling",
          "14-600 - Hoists and Cables",
          "14-700 - Turntables",
          "14-800 - Scaffolding",
          "14-900 - Transportation",
          "15 - Mechanical",
          "15-050 - Basic Mechanical Materials and Methods",
          "15-100 - Plumbing",
          "15-200 - Process Piping",
          "15-300 - Fire Protection Piping",
          "15-400 - Plumbing Fixtures and Equipment",
          "15-500 - Heat-Generation Equipment",
          "15-600 - Refrigeration Equipment",
          "15-700 - Heating, Venting and Air Conditioning",
          "15-800 - Air Distribution",
          "15-900 - HVAC Instruments and Controls",
          "15-950 - Testing, Adjusting, and Balancing",
          "16 - Electrical",
          "16-050 - Basic Electrical Materials and Methods",
          "16-100 - Electrical",
          "16-200 - Electrical Power",
          "16-300 - Transmission and Distribution",
          "16-400 - Low-Voltage Distribution",
          "16-500 - Lighting",
          "16-700 - Communications",
          "16-800 - Sound and Video",
          "17 - Markup and Contingency",
          "17-010 - Contingency",
          "17-020 - Insurance",
          "17-030 - Bond",
          "17-040 - Profit"
        ],
        "subcontract_categories": [
          "Asphalt Paving",
          "Casework",
          "Construction Clean and Final Clean",
          "Curb & Gutter",
          "Doors, Frames & Hardware",
          "Drilled Shafts",
          "Drywall & Acoustical (FED)",
          "Drywall & Acoustical (MOB)",
          "EIFS",
          "Electrical and Fire Alarm",
          "Electrical",
          "Elevator",
          "Epoxy Flooring",
          "Exterior Signage",
          "Fire Protection",
          "Fire Sprinkler System",
          "Framing (Steel)",
          "Framing (Wood)",
          "Glass & Glazing",
          "Granite Surfaces",
          "HVAC",
          "Hard Tile & Stone",
          "Landscaping & Irrigation",
          "Marlite Panels (FED)",
          "Masonry & Precast",
          "Masonry",
          "Ornamental Railings",
          "Overhead Doors",
          "Painting & Vinyl Wall Covering",
          "Plumbing & Medical Gas",
          "Prefabricated Aluminum Metal Canopies",
          "RF Shielding",
          "Rebar & Wire Mesh Install",
          "Retaining Wall and Brick Pavers",
          "Roofing (Asphalt)",
          "Roofing (Metal)",
          "Site Furnishings",
          "Sitework & Site Utilities",
          "Soft Flooring and Base",
          "Structural & Misc Steel Erection",
          "Structural and Misc Steel (Fabrication)",
          "Temp Fencing, Decorative Fencing and Gates",
          "Termite Control",
          "Wall Protection",
          "Waterproofing & Caulking"
        ],
        "trades": [
          "Boilermaker",
          "Brickmason",
          "Carpenter",
          "Tile Setter",
          "Cement Mason",
          "Concrete Finisher",
          "Terrazzo",
          "Equipment Operator",
          "Electrician",
          "Glazier",
          "Linemen",
          "Painter",
          "Pipelayer",
          "Plumber",
          "Plasterers",
          "Stucco Mason",
          "Sheet Metal Worker",
          "Ironworker",
          "Laborer",
          "Millwright",
          "Pipefitter",
          "Waterproofer",
          "Safety Officer",
          "Welder",
          "Refridgeration",
          "HVAC",
          "Landscaper"
        ]
      },
      "cosmere": {
        "allomancers": [
          "Mistborn",
          "Coinshot",
          "Lurcher",
          "Pewterarm",
          "Tineye",
          "Rioter",
          "Soother",
          "Smoker",
          "Seeker",
          "Duralumin Gnat",
          "Aluminum Gnat",
          "Nicroburst",
          "Leecher",
          "Augur",
          "Oracle",
          "Pulser",
          "Slider",
          "Seer"
        ],
        "aons": [
          "Aon",
          "Aan",
          "Aeo",
          "Aha",
          "Ake",
          "Ala",
          "Aor",
          "Are",
          "Ashe",
          "Ata",
          "Ate",
          "Ati",
          "Ato",
          "Daa",
          "Dao",
          "Dii",
          "Dio",
          "Eda",
          "Edo",
          "Ehe",
          "Ela",
          "Ena",
          "Ene",
          "Eno",
          "Eon",
          "Eshe",
          "Eto",
          "Iad",
          "Ido",
          "Ien",
          "Iir",
          "Ire",
          "Kaa",
          "Kae",
          "Kai",
          "Kie",
          "Kii",
          "Mae",
          "Mai",
          "Mea",
          "Nae",
          "Oed",
          "Omi",
          "Opa",
          "Ope",
          "Ore",
          "Rao",
          "Reo",
          "Rii",
          "Sao",
          "Sea",
          "Seo",
          "Shao",
          "Sheo",
          "Soi",
          "Tae",
          "Tia",
          "Tii",
          "Toa"
        ],
        "feruchemists": [
          "Feruchemist",
          "Skimmer",
          "Steelrunner",
          "Windwhisper",
          "Brute",
          "Sparker",
          "Firesoul",
          "Archivist",
          "Sentry",
          "Spinner",
          "Soulbearer",
          "Trueself",
          "Connector",
          "Gasper",
          "Subsumer",
          "Bloodmaker",
          "Pinnacle"
        ],
        "heralds": [
          "Jezrien",
          "Nale",
          "Chanarach",
          "Vedel",
          "Pailiah",
          "Shalash",
          "Battar",
          "Kalak",
          "Talanel",
          "Ishar"
        ],
        "knights_radiant": [
          "Bondsmith",
          "Dustbringer",
          "Edgedancer",
          "Elsecaller",
          "Lightweaver",
          "Skybreaker",
          "Stoneward",
          "Truthwatcher",
          "Willshaper",
          "Windrunner"
        ],
        "metals": [
          "Steel",
          "Iron",
          "Pewter",
          "Tin",
          "Zinc",
          "Brass",
          "Copper",
          "Bronze",
          "Duralumin",
          "Aluminum",
          "Nicrosil",
          "Chromium",
          "Gold",
          "Electrum",
          "Cadmium",
          "Bendalloy",
          "Atium",
          "Lerasium",
          "Ettmetal",
          "Malatium"
        ],
        "shard_worlds": [
          "Ashyn",
          "Braize",
          "First of the Sun",
          "Nalthis",
          "Obrodai",
          "Roshar",
          "Scadrial",
          "Sel",
          "Taldain",
          "Threnody",
          "Vax",
          "Yolen"
        ],
        "shards": [
          "Devotion",
          "Dominion",
          "Preservation",
          "Ruin",
          "Odium",
          "Cultivation",
          "Honor",
          "Endowment",
          "Autonomy",
          "Ambition",
          "Harmony"
        ],
        "sprens": [
          "Alespren",
          "Angerspren",
          "Anticipationspren",
          "Awespren",
          "Bindspren",
          "Captivityspren",
          "Coldspren",
          "Concentrationspren",
          "Creationspren",
          "Cryptic",
          "Cultivationspren",
          "Deathspren",
          "Decayspren",
          "Exhaustionspren",
          "Fearspren",
          "Flamespren",
          "Gloomspren",
          "Gloryspren",
          "Gravityspren",
          "Groundspren",
          "Heatspren",
          "Highspren",
          "Honorspren",
          "Hungerspren",
          "Inkspren",
          "Joyspren",
          "Keenspren",
          "Laughterspren",
          "Liespren",
          "Lifespren",
          "Logicspren",
          "Luckspren",
          "Mistspren",
          "Musicspren",
          "Painspren",
          "Passionspren",
          "Rainspren",
          "Riverspren",
          "Rotspren",
          "Shamespren",
          "Shockspren",
          "Stormspren"
        ],
        "surges": [
          "Abrasion",
          "Adhesion",
          "Cohesion",
          "Division",
          "Gravitation",
          "Illumination",
          "Progression",
          "Transformation",
          "Transportation",
          "Tension"
        ]
      },
      "cowboy_bebop": {
        "character": [
          "Edward",
          "Ein",
          "Faye Valentine",
          "Jet Black",
          "Julia",
          "Spike Spiegel",
          "Vicious",
          "Annie",
          "Bob",
          "Laughing Bull",
          "Gren",
          "Punch and Judy",
          "Three Old Men",
          "Abdul Hakim",
          "Andy",
          "Asimov Solensan",
          "Chessmaster Hex",
          "Coffee",
          "Doohan",
          "Elektra Ovirowa",
          "Fad",
          "Fatty River",
          "Lin",
          "George",
          "Giraffe",
          "Gordon",
          "Julius",
          "Katerina Solensan",
          "Mao Yenrai",
          "Maria Murdock",
          "Miles",
          "Morgan",
          "Mr. Appledelhi",
          "Rocco Bonnaro",
          "Sally Yung",
          "Shin",
          "Teddy Bomber",
          "Udai Taxim",
          "Victoria Terpsichore",
          "Wen",
          "Whitney Hagas Matsumoto",
          "Zebra"
        ],
        "episode": [
          "Asteroid Blues",
          "Stray Dog Strut",
          "Honky Tonk Women",
          "Gateway Shuffle",
          "Ballad of Fallen Angels",
          "Sympathy for the Devil",
          "Heavy Metal Queen",
          "Waltz for Venus",
          "Jamming with Edward",
          "Ganymede Elegy",
          "Toys in the Attic",
          "Jupiter Jazz part 1",
          "Jupiter Jazz part 2",
          "Bohemian Rhapsody",
          "My Funny Valentine",
          "Black Dog Serenade",
          "Mushroom Samba",
          "Speak Like a Child",
          "Wild Horses",
          "Pierrot le Fou",
          "Boogie Woogie Feng Shui",
          "Cowboy Funk",
          "Brain Scratch",
          "Hard Luck Woman",
          "The Real Folk Blues part 1",
          "The Real Folk Blues part 2"
        ],
        "quote": [
          "Men always seem to think about their past before they die, as though they were frantically searching for proof that they truly lived.",
          "I'm not going there to die. I'm going to find out if I'm really alive.",
          "I felt like I was watching a dream I'd never wake up from. Before I knew it, the dream was all over.",
          "Everything has a beginning and an end. Life is just a cycle of starts and stops. There are ends we don't desire, but they're inevitable. We have to face them. It's what being human is all about.",
          "Bang!",
          "The past is the past and the future is the future. A man is a man and a woman is a woman. The present is the present. I am who I am and you are who you are. That's all there is to it. Does it really matter? Or do we just think it does?",
          "There are three things I hate the most. Kids, pets, and women with attitude. So tell me, why do we have all of them packed into our ship!?",
          "Humans were meant to work and sweat for their money after all. Those that try to get rich quickly or live at expense of others - all get divine retribution along the way. That is the lesson. But, one thing about humans is that they quickly forget the lesson they have learnt.",
          "When I was a cop, this was my beat. I’m the Black Dog and when I bite I don’t let go. I have no regrets about her, but I’ll settle this score on my own turf.",
          "I was younger then, I wasn't afraid of anything, I didn't think about dying for a second. I thought I was invincible. Then I met some girl. I wanted to live, I started to think like that; for the first time I was afraid of death. I had never felt like that before."
        ],
        "song": [
          "Tank!",
          "Rush",
          "Spokey Dokey",
          "Bad Dog No Biscuits",
          "Cat Blues",
          "Cosmos",
          "Space Lion",
          "Waltz for Zizi",
          "Piano Black",
          "Pot City",
          "Too Good Too Bad",
          "Car24",
          "The Egg and I",
          "Felt Tip Pen",
          "Rain",
          "Digging My Potato",
          "Memory",
          "The Real Folk Blues",
          "Odd Ones",
          "Doggy Dog",
          "Cats on Mars",
          "Spy",
          "Fantaisie Sign",
          "Piano Bar I",
          "Black Coffee",
          "American Money",
          "Don't Bother None",
          "Vitamin A",
          "Live in Baghdad",
          "Cats on Mars",
          "Want It All Back",
          "Bindy",
          "You Make Me Cool",
          "Vitamin B",
          "Green Bird",
          "Elm",
          "Vitamin C",
          "Gateway",
          "The Singing Sea",
          "The Egg and You",
          "Forever Broke",
          "Power of Kung Food",
          "BlueTim Jensent",
          "Words That We Couldn't Say",
          "Autumn in Ganymede",
          "Mushroom Hunting",
          "Go Go Cactus Man",
          "Chicken Bone",
          "The Real Man",
          "N.Y. Rush",
          "Adieu",
          "Call Me Call Me",
          "Ave Maria",
          "Stella",
          "Flying Teapot",
          "Wo Qui Non Coin",
          "Road to the West",
          "Farewell Blues",
          "See You Space Cowboy...",
          "24 Hours Open",
          "Pushing the Sky",
          "Time to Know ~ Be Waltz",
          "Clutch",
          "Musawe",
          "Yo Pumpkin Head",
          "Diggin",
          "What Planet Is This?!",
          "Fingers",
          "Powder",
          "Butterfly",
          "No Reply",
          "Dijurido",
          "Gotta Knock a Little Harder",
          "No Money.",
          "Rain"
        ]
      },
      "creature": {
        "animal": {
          "name": [
            "alligator",
            "crocodile",
            "alpaca",
            "ant",
            "antelope",
            "ape",
            "armadillo",
            "donkey",
            "baboon",
            "badger",
            "bat",
            "bear",
            "beaver",
            "bee",
            "beetle",
            "buffalo",
            "butterfly",
            "camel",
            "water buffalo",
            "caribou",
            "cat",
            "cattle",
            "cheetah",
            "chimpanzee",
            "chinchilla",
            "cicada",
            "clam",
            "cockroach",
            "cod",
            "coyote",
            "crab",
            "cricket",
            "crow",
            "raven",
            "deer",
            "dinosaur",
            "dog",
            "dolphin",
            "porpoise",
            "duck",
            "eagle",
            "eel",
            "elephant",
            "elk",
            "ferret",
            "fish",
            "fly",
            "fox",
            "frog",
            "toad",
            "gerbil",
            "giraffe",
            "gnat",
            "gnu",
            "wildebeest",
            "goat",
            "goldfish",
            "goose",
            "gorilla",
            "grasshopper",
            "guinea pig",
            "hamster",
            "hare",
            "hedgehog",
            "herring",
            "hippopotamus",
            "hornet",
            "horse",
            "hound",
            "hyena",
            "impala",
            "jackal",
            "jellyfish",
            "kangaroo",
            "wallaby",
            "koala",
            "leopard",
            "lion",
            "lizard",
            "llama",
            "locust",
            "louse",
            "macaw",
            "mallard",
            "mammoth",
            "manatee",
            "marten",
            "mink",
            "minnow",
            "mole",
            "monkey",
            "moose",
            "mosquito",
            "mouse",
            "rat",
            "mule",
            "muskrat",
            "otter",
            "ox",
            "oyster",
            "panda",
            "pig",
            "platypus",
            "porcupine",
            "prairie dog",
            "pug",
            "rabbit",
            "raccoon",
            "reindeer",
            "rhinoceros",
            "salmon",
            "sardine",
            "scorpion",
            "seal",
            "sea lion",
            "serval",
            "shark",
            "sheep",
            "skunk",
            "snail",
            "snake",
            "spider",
            "squirrel",
            "swan",
            "termite",
            "tiger",
            "trout",
            "turtle",
            "tortoise",
            "walrus",
            "wasp",
            "weasel",
            "whale",
            "wolf",
            "wombat",
            "woodchuck",
            "worm",
            "yak",
            "yellowjacket",
            "zebra"
          ]
        },
        "bird": {
          "adjectives": [
            "banded",
            "common",
            "dwarf",
            "giant",
            "great",
            "greater",
            "lesser",
            "lined",
            "painted",
            "rough",
            "smooth",
            "spotted"
          ],
          "anatomy": [
            "back",
            "beak",
            "belly",
            "bill",
            "breast",
            "cap",
            "chin",
            "collar",
            "crest",
            "crown",
            "eye",
            "face",
            "head",
            "neck",
            "rump",
            "shoulder",
            "tail",
            "throat",
            "wing"
          ],
          "anatomy_past_tense": [
            "backed",
            "beaked",
            "bearded",
            "bellied",
            "breasted",
            "capped",
            "chinned",
            "collared",
            "crested",
            "crowned",
            "eared",
            "eyed",
            "faced",
            "fronted",
            "headed",
            "hooded",
            "naped",
            "necked",
            "rumped",
            "shouldered",
            "tailed",
            "throated",
            "winged"
          ],
          "colors": [
            "ash",
            "black",
            "blue",
            "bronze",
            "brown",
            "cerulean",
            "chestnut",
            "dusky",
            "ferruginous",
            "fulvous",
            "gold",
            "gray",
            "green",
            "indigo",
            "lazuli",
            "purple",
            "red",
            "roze",
            "roseate",
            "ruby",
            "ruddy",
            "rufous",
            "smoky",
            "snooty",
            "snowy",
            "tawny",
            "violet",
            "white",
            "yellow"
          ],
          "common_family_name": [
            "Accentors",
            "African Barbets",
            "African Warblers",
            "African and Green Broadbills",
            "Albatrosses",
            "Anhingas",
            "Antpittas",
            "Antthrushes",
            "Asian Barbets",
            "Asian and Grauer's Broadbills",
            "Asities",
            "Auks, Murres, and Puffins",
            "Australasian Robins",
            "Australasian Treecreepers",
            "Australo-Papuan Bellbirds",
            "Barn-Owls",
            "Bearded Reedling",
            "Bee-eaters",
            "Berrypeckers and Longbills",
            "Birds-of-Paradise",
            "Boatbills",
            "Boobies and Gannets",
            "Bowerbirds",
            "Bristlebirds",
            "Bristlehead",
            "Bulbuls",
            "Bush Warblers and Allies",
            "Bushshrikes and Allies",
            "Bustards",
            "Buttonquail",
            "Cardinals and Allies",
            "Cassowaries and Emu",
            "Chat-Tanagers",
            "Cisticolas and Allies",
            "Cockatoos",
            "Cormorants and Shags",
            "Cotingas",
            "Crab-Plover",
            "Cranes",
            "Crescentchests",
            "Crested Shrikejay",
            "Crows, Jays, and Magpies",
            "Cuban Warblers",
            "Cuckoo-roller",
            "Cuckoos",
            "Cuckooshrikes",
            "Cupwings",
            "Dapple-throat and Allies",
            "Dippers",
            "Donacobius",
            "Drongos",
            "Ducks, Geese, and Waterfowl",
            "Egyptian Plover",
            "Fairy Flycatchers",
            "Fairy-bluebirds",
            "Fairywrens",
            "Falcons and Caracaras",
            "Fantails",
            "Finches, Euphonias, and Allies",
            "Finfoots",
            "Flamingos",
            "Flowerpeckers",
            "Flufftails",
            "Frigatebirds",
            "Frogmouths",
            "Gnatcatchers",
            "Gnateaters",
            "Grassbirds and Allies",
            "Grebes",
            "Ground Babblers and Allies",
            "Ground-Hornbills",
            "Ground-Rollers",
            "Guans, Chachalacas, and Curassows",
            "Guineafowl",
            "Gulls, Terns, and Skimmers",
            "Hamerkop",
            "Hawaiian Honeyeaters",
            "Hawks, Eagles, and Kites",
            "Herons, Egrets, and Bitterns",
            "Hispaniolan Tanagers",
            "Hoatzin",
            "Honeyeaters",
            "Honeyguides",
            "Hoopoes",
            "Hornbills",
            "Hummingbirds",
            "Hyliotas",
            "Hylocitrea",
            "Hypocolius",
            "Ibisbill",
            "Ibises and Spoonbills",
            "Ifrita",
            "Indigobirds",
            "Ioras",
            "Jacamars",
            "Jacanas",
            "Kagu",
            "Kingfishers",
            "Kinglets",
            "Kiwis",
            "Larks",
            "Laughingthrushes and Allies",
            "Leaf Warblers",
            "Leafbirds",
            "Limpkin",
            "Logrunners",
            "Long-tailed Tits",
            "Longspurs and Snow Buntings",
            "Loons",
            "Lyrebirds",
            "Magellanic Plover",
            "Magpie Goose",
            "Malagasy Warblers",
            "Manakins",
            "Megapodes",
            "Melampittas",
            "Mesites",
            "Mitrospingid Tanagers",
            "Mockingbirds and Thrashers",
            "Monarch Flycatchers",
            "Motmots",
            "Mottled Berryhunter",
            "Mousebirds",
            "New World Barbets",
            "New World Quail",
            "New World Sparrows",
            "New World Vultures",
            "New World Warblers",
            "New World and African Parrots",
            "New Zealand Parrots",
            "New Zealand Wrens",
            "Nicators",
            "Nightjars and Allies",
            "Northern Storm-Petrels",
            "Nuthatches",
            "Oilbird",
            "Old World Buntings",
            "Old World Flycatchers",
            "Old World Orioles",
            "Old World Parrots",
            "Old World Sparrows",
            "Olive Warbler",
            "Osprey",
            "Ostriches",
            "Ovenbirds and Woodcreepers",
            "Owlet-nightjars",
            "Owls",
            "Oxpeckers",
            "Oystercatchers",
            "Painted-Snipes",
            "Palmchat",
            "Pardalotes",
            "Pelicans",
            "Penduline-Tits",
            "Penguins",
            "Pheasants, Grouse, and Allies",
            "Pigeons and Doves",
            "Pittas",
            "Plains-wanderer",
            "Ploughbill",
            "Plovers and Lapwings",
            "Potoos",
            "Pratincoles and Coursers",
            "Przevalski's Pinktail",
            "Pseudo-Babblers",
            "Puerto Rican Tanager",
            "Puffbirds",
            "Quail-thrushes and Jewel-babblers",
            "Rail-babbler",
            "Rails, Gallinules, and Coots",
            "Reed Warblers and Allies",
            "Rheas",
            "Rockfowl",
            "Rockjumpers",
            "Rollers",
            "Sandgrouse",
            "Sandpipers and Allies",
            "Sapayoa",
            "Satinbirds",
            "Screamers",
            "Scrub-birds",
            "Secretarybird",
            "Seedsnipes",
            "Seriemas",
            "Sharpbill, Royal Flycatcher, and Allies",
            "Shearwaters and Petrels",
            "Sheathbills",
            "Shoebill",
            "Shrike-tit",
            "Shrikes",
            "Silky-flycatchers",
            "Sittellas",
            "Skuas and Jaegers",
            "Southern Storm-Petrels",
            "Spindalises",
            "Spotted Elachura",
            "Starlings",
            "Stilts and Avocets",
            "Stitchbird",
            "Storks",
            "Sugarbirds",
            "Sunbirds and Spiderhunters",
            "Sunbittern",
            "Swallows",
            "Swifts",
            "Sylviid Warblers, Parrotbills, and Allies",
            "Tanagers and Allies",
            "Tapaculos",
            "Thick-knees",
            "Thornbills and Allies",
            "Thrush-Tanager",
            "Thrushes and Allies",
            "Tinamous",
            "Tit Berrypecker and Crested Berrypecker",
            "Tits, Chickadees, and Titmice",
            "Tityras and Allies",
            "Todies",
            "Toucan-Barbets",
            "Toucans",
            "Tree-Babblers, Scimitar-Babblers, and Allies",
            "Treecreepers",
            "Treeswifts",
            "Trogons",
            "Tropicbirds",
            "Troupials and Allies",
            "Trumpeters",
            "Turacos",
            "Typical Antbirds",
            "Tyrant Flycatchers",
            "Vangas, Helmetshrikes, and Allies",
            "Vireos, Shrike-Babblers, and Erpornis",
            "Wagtails and Pipits",
            "Wallcreeper",
            "Wattle-eyes and Batises",
            "Wattlebirds",
            "Waxbills and Allies",
            "Waxwings",
            "Weavers and Allies",
            "Whipbirds and Wedgebills",
            "Whistlers and Allies",
            "White-eyes, Yuhinas, and Allies",
            "White-winged Chough and Apostlebird",
            "Whiteheads",
            "Woodhoopoes and Scimitarbills",
            "Woodpeckers",
            "Woodswallows, Bellmagpies, and Allies",
            "Wrens",
            "Wrenthrush",
            "Yellow-breasted Chat"
          ],
          "emotional_adjectives": [
            "angry",
            "aggrieved",
            "agitated",
            "anxious",
            "cantankerous",
            "demented",
            "depressed",
            "flirty",
            "furious",
            "gloomy",
            "gregarious",
            "irritated",
            "lonely",
            "manic",
            "moody",
            "morbid",
            "murderous",
            "needy",
            "nervous",
            "ornery",
            "panicked",
            "quizzical",
            "sad",
            "sleepy",
            "terrified"
          ],
          "geo": [
            "African",
            "American",
            "Arabian",
            "Arctic",
            "Asian",
            "Atlantic",
            "Australian",
            "Baltimore",
            "Brazilian",
            "California",
            "Canada",
            "Carolina",
            "Chihuahua",
            "Chinese",
            "Congo",
            "Colombian",
            "eastern",
            "Egyptian",
            "Eurasian",
            "Inca",
            "Iranian",
            "Japanese",
            "Kentucky",
            "Madagascar",
            "Mexican",
            "Mississippi",
            "Mongolian",
            "mountain",
            "New Zeland",
            "northern",
            "Pacific",
            "Papuan",
            "prarie",
            "sandhill",
            "Savannah",
            "southern",
            "Spanish",
            "swamp",
            "tropical",
            "western"
          ],
          "implausible_common_names": [
            "#{Name.last_name}'s #{emotional_adjective} #{common_name}",
            "#{Name.last_name}'s #{silly_adjective} #{common_name}",
            "#{adjective} #{silly_adjective} #{common_name}",
            "#{adjective} #{emotional_adjective} #{common_name}",
            "#{geo} #{silly_adjective} #{common_name}",
            "#{geo} #{emotional_adjective} #{common_name}",
            "#{color}-#{anatomy_past_tense} #{silly_adjective} #{common_name}",
            "#{color}-#{anatomy_past_tense} #{emotional_adjective} #{common_name}"
          ],
          "order_common_map": {
            "Accipitriformes": [
              "Bateleur",
              "Baza",
              "Besra",
              "Buzzard",
              "Eagle",
              "Goshawk",
              "Griffon",
              "Harrier",
              "Hawk",
              "Kite",
              "Osprey",
              "Secretarybird",
              "Shikra",
              "Sparrowhawk",
              "Vulture"
            ],
            "Anseriformes": [
              "Brant",
              "Bufflehead",
              "Canvasback",
              "Duck",
              "Eider",
              "Gadwall",
              "Garganey",
              "Goldeneye",
              "Goose",
              "Hardhead",
              "Mallard",
              "Merganser",
              "Pintail",
              "Pochard",
              "Redhead",
              "Scaup",
              "Scoter",
              "Screamer",
              "Shelduck",
              "Shoveler",
              "Smew",
              "Swan",
              "Teal",
              "Wigeon"
            ],
            "Apterygiformes": [
              "Kiwi"
            ],
            "Bucerotiformes": [
              "Hoopoe",
              "Hornbill",
              "Scimitarbill",
              "Woodhoopoe"
            ],
            "Caprimulgiformes": [
              "Avocetbill",
              "Awlbill",
              "Barbthroat",
              "Blossomcrown",
              "Brilliant",
              "Carib",
              "Comet",
              "Coquette",
              "Coronet",
              "Daggerbill",
              "Emerald",
              "Fairy",
              "Firecrown",
              "Frogmouth",
              "Goldentail",
              "Goldenthroat",
              "Helmetcrest",
              "Hermit",
              "Hillstar",
              "Hummingbird",
              "Inca",
              "Jacobin",
              "Jewelfront",
              "Lancebill",
              "Mango",
              "Metaltail",
              "Mountaineer",
              "Needletail",
              "Nighthawk",
              "Nightjar",
              "Oilbird",
              "Pauraque",
              "Piedtail",
              "Plovercrest",
              "Plumeleteer",
              "Poorwill",
              "Potoo",
              "Puffleg",
              "Ruby",
              "Sabrewing",
              "Sapphire",
              "Sapphirewing",
              "Sheartail",
              "Sicklebill",
              "Snowcap",
              "Spatuletail",
              "Spinetail",
              "Starfrontlet",
              "Starthroat",
              "Streamertail",
              "Sunangel",
              "Sunbeam",
              "Sungem",
              "Swift",
              "Swiftlet",
              "Sylph",
              "Thornbill",
              "Thorntail",
              "Topaz",
              "Trainbearer",
              "Treeswift",
              "Velvetbreast",
              "Violetear",
              "Visorbearer",
              "Whitetip",
              "Woodnymph",
              "Woodstar"
            ],
            "Cariamiformes": [
              "Seriema"
            ],
            "Casuariiformes": [
              "Cassowary",
              "Emu"
            ],
            "Cathartiformes": [
              "Condor",
              "Vulture"
            ],
            "Charadriiformes": [
              "Auk",
              "Auklet",
              "Avocet",
              "Buttonquail",
              "Courser",
              "Curlew",
              "Dotterel",
              "Dovekie",
              "Dowitcher",
              "Dunlin",
              "Godwit",
              "Greenshank",
              "Guillemot",
              "Gull",
              "Ibisbill",
              "Jacana",
              "Jaeger",
              "Killdeer",
              "Kittiwake",
              "Knot",
              "Lapwing",
              "Murre",
              "Murrelet",
              "Noddy",
              "Oystercatcher",
              "Phalarope",
              "Plover",
              "Pratincole",
              "Puffin",
              "Razorbill",
              "Redshank",
              "Ruff",
              "Sanderling",
              "Sandpiper",
              "Seedsnipe",
              "Sheathbill",
              "Skimmer",
              "Skua",
              "Snipe",
              "Stilt",
              "Stint",
              "Surfbird",
              "Tattler",
              "Tern",
              "Turnstone",
              "Whimbrel",
              "Willet",
              "Woodcock",
              "Wrybill",
              "Yellowlegs"
            ],
            "Ciconiiformes": [
              "Adjutant",
              "Jabiru",
              "Openbill",
              "Stork"
            ],
            "Coliiformes": [
              "Mousebird"
            ],
            "Columbiformes": [
              "Bronzewing",
              "Dodo",
              "Dove",
              "Pigeon",
              "Solitaire"
            ],
            "Coraciiformes": [
              "Dollarbird",
              "Kingfisher",
              "Kookaburra",
              "Motmot",
              "Roller",
              "Tody"
            ],
            "Cuculiformes": [
              "Ani",
              "Coua",
              "Coucal",
              "Cuckoo",
              "Koel",
              "Malkoha",
              "Roadrunner"
            ],
            "Eurypygiformes": [
              "Kagu",
              "Sunbittern"
            ],
            "Falconiformes": [
              "Caracara",
              "Falcon",
              "Falconet",
              "Gyrfalcon",
              "Hobby",
              "Kestrel",
              "Merlin"
            ],
            "Galbuliformes": [
              "Jacamar",
              "Monklet",
              "Nunbird",
              "Nunlet",
              "Puffbird"
            ],
            "Galliformes": [
              "Argus",
              "Bobwhite",
              "Brushturkey",
              "Capercaillie",
              "Chachalaca",
              "Chukar",
              "Curassow",
              "Fireback",
              "Francolin",
              "Grouse",
              "Guan",
              "Guineafowl",
              "Junglefowl",
              "Maleo",
              "Malleefowl",
              "Monal",
              "Partridge",
              "Peacock",
              "Peafowl",
              "Pheasant",
              "Ptarmigan",
              "Quail",
              "Scrubfowl",
              "Snowcock",
              "Spurfowl",
              "Tragopan",
              "Turkey"
            ],
            "Gaviiformes": [
              "Loon"
            ],
            "Gruiformes": [
              "Brolga",
              "Coot",
              "Crake",
              "Crane",
              "Finfoot",
              "Flufftail",
              "Gallinule",
              "Limpkin",
              "Moorhen",
              "Nativehen",
              "Rail",
              "Sora",
              "Sungrebe",
              "Swamphen",
              "Takahe",
              "Trumpeter",
              "Watercock",
              "Waterhen",
              "Weka"
            ],
            "Mesitornithiformes": [
              "Mesite"
            ],
            "Musophagiformes": [
              "Turaco"
            ],
            "Opisthocomiformes": [
              "Hoatzin"
            ],
            "Otidiformes": [
              "Bustard",
              "Florican"
            ],
            "Passeriformes": [
              "Accentor",
              "Akalat",
              "Akekee",
              "Akepa",
              "Akialoa",
              "Akiapolaau",
              "Akikiki",
              "Akohekohe",
              "Alauahio",
              "Alethe",
              "Amakihi",
              "Amaui",
              "Anianiau",
              "Antbird",
              "Antpecker",
              "Antpipit",
              "Antpitta",
              "Antshrike",
              "Antthrush",
              "Antvireo",
              "Antwren",
              "Apalis",
              "Apapane",
              "Apostlebird",
              "Asity",
              "Astrapia",
              "Attila",
              "Avadavat",
              "Babax",
              "Babbler",
              "Balicassiao",
              "Bamboowren",
              "Bananaquit",
              "Barbtail",
              "Barwing",
              "Batis",
              "Baywing",
              "Becard",
              "Bellbird",
              "Bentbill",
              "Bernieria",
              "Berryeater",
              "Berryhunter",
              "Berrypecker",
              "Bishop",
              "Blackbird",
              "Blackcap",
              "Blackstart",
              "Blackthroat",
              "Bluebill",
              "Bluebird",
              "Bluetail",
              "Bluethroat",
              "Boatbill",
              "Bobolink",
              "Bokmakierie",
              "Boubou",
              "Bowerbird",
              "Brambling",
              "Bristlebill",
              "Bristlebird",
              "Bristlefront",
              "Bristlehead",
              "Broadbill",
              "Brownbul",
              "Brubru",
              "Brushfinch",
              "Brushrunner",
              "Bulbul",
              "Bullfinch",
              "Bunting",
              "Bushbird",
              "Bushchat",
              "Bushlark",
              "Bushshrike",
              "Bushtit",
              "Butcherbird",
              "Cacholote",
              "Cacique",
              "Calyptura",
              "Camaroptera",
              "Canary",
              "Canastero",
              "Capuchinbird",
              "Cardinal",
              "Casiornis",
              "Catbird",
              "Chaffinch",
              "Chat",
              "Chatterer",
              "Chickadee",
              "Chiffchaff",
              "Chilia",
              "Chlorophonia",
              "Chlorospingus",
              "Chough",
              "Chowchilla",
              "Cicadabird",
              "Cinclodes",
              "Cisticola",
              "Citril",
              "Cochoa",
              "Coleto",
              "Conebill",
              "Cordonbleu",
              "Cotinga",
              "Cowbird",
              "Creeper",
              "Crescentchest",
              "Crimsonwing",
              "Crocias",
              "Crombec",
              "Crossbill",
              "Crow",
              "Cuckooshrike",
              "Cupwing",
              "Currawong",
              "Cutia",
              "Dacnis",
              "Dickcissel",
              "Dipper",
              "Diucon",
              "Donacobius",
              "Doradito",
              "Drongo",
              "Dunnock",
              "Earthcreeper",
              "Elachura",
              "Elaenia",
              "Elepaio",
              "Emutail",
              "Emuwren",
              "Eremomela",
              "Erpornis",
              "Euphonia",
              "Fairywren",
              "Fantail",
              "Fernbird",
              "Fernwren",
              "Fieldfare",
              "Fieldwren",
              "Figbird",
              "Finch",
              "Finchbill",
              "Firecrest",
              "Firefinch",
              "Firetail",
              "Firethroat",
              "Fiscal",
              "Flamecrest",
              "Flatbill",
              "Flowerpecker",
              "Flowerpiercer",
              "Flycatcher",
              "Flyrobin",
              "Fody",
              "Forktail",
              "Friarbird",
              "Fruitcrow",
              "Fruiteater",
              "Fulvetta",
              "Gallito",
              "Geomalia",
              "Gerygone",
              "Gnatcatcher",
              "Gnateater",
              "Gnatwren",
              "Goldcrest",
              "Goldenface",
              "Goldfinch",
              "Gonolek",
              "Grackle",
              "Grandala",
              "Grassbird",
              "Grassquit",
              "Grasswren",
              "Graveteiro",
              "Graytail",
              "Greenbul",
              "Greenfinch",
              "Greenlet",
              "Grenadier",
              "Grosbeak",
              "Groundcreeper",
              "Hawfinch",
              "Heathwren",
              "Helmetshrike",
              "Hemispingus",
              "Honeycreeper",
              "Honeyeater",
              "Hookbill",
              "Hornero",
              "Huia",
              "Hwamei",
              "Hylia",
              "Hyliota",
              "Hylocitrea",
              "Hypocolius",
              "Ibon",
              "Ifrita",
              "Iiwi",
              "Illadopsis",
              "Indigobird",
              "Iora",
              "Jackdaw",
              "Jay",
              "Jery",
              "Junco",
              "Kakawahie",
              "Kamao",
              "Kingbird",
              "Kinglet",
              "Kioea",
              "Kiskadee",
              "Kokako",
              "Lark",
              "Laughingthrush",
              "Leafbird",
              "Leaftosser",
              "Leiothrix",
              "Linnet",
              "Liocichla",
              "Locustfinch",
              "Logrunner",
              "Longbill",
              "Longclaw",
              "Longspur",
              "Longtail",
              "Lophorina",
              "Lyrebird",
              "Madanga",
              "Magpie",
              "Malia",
              "Malimbe",
              "Mamo",
              "Manakin",
              "Mannikin",
              "Manucode",
              "Mao",
              "Marshbird",
              "Martin",
              "Meadowlark",
              "Melampitta",
              "Melidectes",
              "Meliphaga",
              "Mesia",
              "Millerbird",
              "Miner",
              "Minivet",
              "Minla",
              "Mistletoebird",
              "Mockingbird",
              "Monarch",
              "Monjita",
              "Morningbird",
              "Mourner",
              "Munia",
              "Myna",
              "Myza",
              "Myzomela",
              "Myzornis",
              "Negrito",
              "Newtonia",
              "Nicator",
              "Nightingale",
              "Nigrita",
              "Niltava",
              "Nukupuu",
              "Nutcracker",
              "Nuthatch",
              "Odedi",
              "Oliveback",
              "Olomao",
              "Omao",
              "Oo",
              "Orangequit",
              "Oriole",
              "Oropendola",
              "Ou",
              "Ouzel",
              "Ovenbird",
              "Oxpecker",
              "Oxylabes",
              "Palila",
              "Palmchat",
              "Palmcreeper",
              "Paradigalla",
              "Pardalote",
              "Pardusco",
              "Parisoma",
              "Parotia",
              "Parrotbill",
              "Parrotfinch",
              "Parula",
              "Peltops",
              "Peppershrike",
              "Pewee",
              "Phainopepla",
              "Philentoma",
              "Phoebe",
              "Piapiac",
              "Piha",
              "Pilotbird",
              "Pinktail",
              "Piopio",
              "Pipipi",
              "Pipit",
              "Piprites",
              "Pitohui",
              "Pitta",
              "Plantcutter",
              "Ploughbill",
              "Plushcap",
              "Plushcrown",
              "Prickletail",
              "Prinia",
              "Puaiohi",
              "Puffback",
              "Purpletuft",
              "Pyrrhuloxia",
              "Pytilia",
              "Quailfinch",
              "Quelea",
              "Raven",
              "Rayadito",
              "Recurvebill",
              "Redpoll",
              "Redstart",
              "Redthroat",
              "Redwing",
              "Reedhaunter",
              "Reedling",
              "Rhabdornis",
              "Riflebird",
              "Rifleman",
              "Robin",
              "Rockfinch",
              "Rockfowl",
              "Rockjumper",
              "Rockrunner",
              "Rockwarbler",
              "Rook",
              "Rosefinch",
              "Rubythroat",
              "Rushbird",
              "Saddleback",
              "Saltator",
              "Sapayoa",
              "Satinbird",
              "Sawwing",
              "Schiffornis",
              "Scrubtit",
              "Scrubwren",
              "Scythebill",
              "Seedcracker",
              "Seedeater",
              "Serin",
              "Shama",
              "Sharpbill",
              "Sholakili",
              "Shortwing",
              "Shrike",
              "Shrikebill",
              "Shrikejay",
              "Shrikethrush",
              "Sibia",
              "Sicklebill",
              "Silktail",
              "Silverbill",
              "Silverbird",
              "Silvereye",
              "Sirystes",
              "Siskin",
              "Sittella",
              "Skylark",
              "Snowfinch",
              "Softtail",
              "Solitaire",
              "Songlark",
              "Spadebill",
              "Sparrow",
              "Speirops",
              "Spiderhunter",
              "Spindalis",
              "Spinebill",
              "Spinetail",
              "Spinifexbird",
              "Starling",
              "Stipplethroat",
              "Stitchbird",
              "Stonechat",
              "Straightbill",
              "Streamcreeper",
              "Stubtail",
              "Sugarbird",
              "Sunbird",
              "Swallow",
              "Tachuri",
              "Tailorbird",
              "Tanager",
              "Tapaculo",
              "Tchagra",
              "Tesia",
              "Tetraka",
              "Thamnornis",
              "Thicketbird",
              "Thistletail",
              "Thornbill",
              "Thornbird",
              "Thrasher",
              "Thrush",
              "Tit",
              "Titmouse",
              "Tityra",
              "Tomtit",
              "Towhee",
              "Treecreeper",
              "Treehunter",
              "Treepie",
              "Treerunner",
              "Trembler",
              "Triller",
              "Troupial",
              "Tuftedcheek",
              "Tui",
              "Turca",
              "Twinspot",
              "Twistwing",
              "Twite",
              "Tyrannulet",
              "Tyrant",
              "Umbrellabird",
              "Vanga",
              "Veery",
              "Verdin",
              "Vireo",
              "Wagtail",
              "Wallcreeper",
              "Warbler",
              "Waterthrush",
              "Wattlebird",
              "Waxbill",
              "Waxwing",
              "Weaver",
              "Wedgebill",
              "Weebill",
              "Wheatear",
              "Whinchat",
              "Whipbird",
              "Whistler",
              "Whiteface",
              "Whitehead",
              "Whitethroat",
              "Whydah",
              "Widowbird",
              "Wiretail",
              "Woodcreeper",
              "Woodhaunter",
              "Woodshrike",
              "Woodswallow",
              "Wren",
              "Wrenthrush",
              "Wrentit",
              "Xenops",
              "Xenopsaris",
              "Yellowhammer",
              "Yellowhead",
              "Yellowthroat",
              "Yuhina"
            ],
            "Pelecaniformes": [
              "Bittern",
              "Egret",
              "Hamerkop",
              "Heron",
              "Ibis",
              "Pelican",
              "Shoebill",
              "Spoonbill"
            ],
            "Phaethontiformes": [
              "Tropicbird"
            ],
            "Phoenicopteriformes": [
              "Flamingo"
            ],
            "Piciformes": [
              "Aracari",
              "Barbet",
              "Flameback",
              "Flicker",
              "Honeyguide",
              "Piculet",
              "Sapsucker",
              "Tinkerbird",
              "Toucan",
              "Toucanet",
              "Woodpecker",
              "Wryneck",
              "Yellownape"
            ],
            "Podicipediformes": [
              "Grebe"
            ],
            "Procellariiformes": [
              "Albatross",
              "Fulmar",
              "Petrel",
              "Prion",
              "Shearwater"
            ],
            "Psittaciformes": [
              "Bluebonnet",
              "Budgerigar",
              "Cockatiel",
              "Cockatoo",
              "Corella",
              "Galah",
              "Guaiabero",
              "Kaka",
              "Kakapo",
              "Kea",
              "Lorikeet",
              "Lory",
              "Lovebird",
              "Macaw",
              "Parakeet",
              "Parrot",
              "Parrotlet",
              "Ringneck",
              "Rosella"
            ],
            "Pterocliformes": [
              "Sandgrouse"
            ],
            "Rheiformes": [
              "Rhea"
            ],
            "Sphenisciformes": [
              "Penguin"
            ],
            "Strigiformes": [
              "Boobook",
              "Morepork",
              "Owl",
              "Owlet"
            ],
            "Struthioniformes": [
              "Ostrich"
            ],
            "Suliformes": [
              "Anhinga",
              "Booby",
              "Cormorant",
              "Darter",
              "Frigatebird",
              "Gannet",
              "Shag"
            ],
            "Tinamiformes": [
              "Nothura",
              "Tinamou"
            ],
            "Trogoniformes": [
              "Quetzal",
              "Trogon"
            ]
          },
          "plausible_common_names": [
            "#{Name.last_name}'s #{common_name}",
            "#{adjective} #{anatomy} #{common_name}",
            "#{adjective}-#{anatomy_past_tense} #{common_name}",
            "#{color}-#{anatomy_past_tense} #{common_name}",
            "#{adjective} #{common_name}",
            "#{geo} #{common_name}",
            "#{geo} #{color} #{common_name}"
          ],
          "silly_adjectives": [
            "anarchist",
            "bloated",
            "communist",
            "conservative",
            "dangerous",
            "drunk",
            "dumb",
            "enchanted",
            "flatulent",
            "idiotic",
            "impotent",
            "incompotent",
            "insufferable",
            "liberal",
            "Masonic",
            "noxious",
            "obnoxious",
            "pansexual",
            "racist",
            "sexist",
            "silly",
            "vegan"
          ]
        },
        "cat": {
          "breed": [
            "Abyssinian",
            "Aegean",
            "American Bobtail",
            "American Curl",
            "American Shorthair",
            "American Wirehair",
            "Arabian Mau",
            "Asian",
            "Asian Semi-longhair",
            "Australian Mist",
            "Balinese",
            "Bambino",
            "Bengal",
            "Birman",
            "Bombay",
            "Brazilian Shorthair",
            "British Longhair",
            "British Semipi-longhair",
            "British Shorthair",
            "Burmese",
            "Burmilla",
            "California Spangled",
            "Chantilly-Tiffany",
            "Chartreux",
            "Chausie",
            "Cheetoh",
            "Colorpoint Shorthair",
            "Cornish Rex",
            "Cymric, or Manx Longhair",
            "Cyprus",
            "Devon Rex",
            "Donskoy, or Don Sphynx",
            "Dragon Li",
            "Dwarf cat, or Dwelf",
            "Egyptian Mau",
            "European Shorthair",
            "Exotic Shorthair",
            "Foldex Cat",
            "German Rex",
            "Havana Brown",
            "Highlander",
            "Himalayan, or Colorpoint Persian",
            "Japanese Bobtail",
            "Javanese",
            "Khao Manee",
            "Korat",
            "Korean Bobtail",
            "Korn Ja",
            "Kurilian Bobtail",
            "Kurilian Bobtail, or Kuril Islands Bobtail",
            "LaPerm",
            "Lykoi",
            "Maine Coon",
            "Manx",
            "Mekong Bobtail",
            "Minskin",
            "Munchkin",
            "Napoleon",
            "Nebelung",
            "Norwegian Forest Cat",
            "Ocicat",
            "Ojos Azules",
            "Oregon Rex",
            "Oriental Bicolor",
            "Oriental Longhair",
            "Oriental Shorthair",
            "PerFold Cat (Experimental Breed - WCF)",
            "Persian (Modern Persian Cat)",
            "Persian (Traditional Persian Cat)",
            "Peterbald",
            "Pixie-bob",
            "Raas",
            "Ragamuffin",
            "Ragdoll",
            "Russian Blue",
            "Russian White, Black and Tabby",
            "Sam Sawet",
            "Savannah",
            "Scottish Fold",
            "Selkirk Rex",
            "Serengeti",
            "Serrade petit",
            "Siamese",
            "Siberian",
            "Singapura",
            "Snowshoe",
            "Sokoke",
            "Somali",
            "Sphynx",
            "Suphalak",
            "Thai",
            "Tonkinese",
            "Toyger",
            "Turkish Angora",
            "Turkish Van",
            "Ukrainian Levkoy"
          ],
          "name": [
            "Alexander Hameowlton",
            "Alfie",
            "Angel",
            "Bella",
            "Butterscotch",
            "Captain Zissou",
            "Charlie",
            "Chicken",
            "Chloe",
            "Coco",
            "Cookie Hopper",
            "Daisy",
            "Doctor Cucumber",
            "Felix",
            "Franklin Longfellow",
            "Jasper",
            "Katherine Belle",
            "Lady Rainicorn",
            "Lily",
            "Lucky",
            "Lucy",
            "Max",
            "McFluffy Pants",
            "Millie",
            "Milo",
            "Missy",
            "Misty",
            "Molly",
            "Oliver",
            "Oscar",
            "Poppy",
            "Sam",
            "Shadow",
            "Simba",
            "Sir Loin",
            "Sir Pounce-a-lot",
            "Smokey",
            "Smudge",
            "Sooty",
            "Tator Tot",
            "Tiger",
            "Theodore Reginald Meowskewitz",
            "Tony",
            "Tuna",
            "Waffles"
          ],
          "registry": [
            "American Cat Fanciers Association",
            "Associazione Nazionale Felina Italiana",
            "Canadian Cat Association",
            "Cat Aficionado Association",
            "Cat Fanciers' Association",
            "Emirates Feline Federation",
            "Fédération Internationale Féline",
            "Felis Britannica",
            "Governing Council of the Cat",
            "Fancy Southern Africa Cat Council",
            "The International Cat Association"
          ]
        },
        "dog": {
          "age": [
            "puppy",
            "young",
            "adult",
            "senior"
          ],
          "breed": [
            "Affenpinscher",
            "Africanis",
            "Airedale",
            "Akita",
            "Appenzeller",
            "Basenji",
            "Beagle",
            "Bluetick",
            "Borzoi",
            "Bouvier",
            "Boxer",
            "Brabancon",
            "Briard",
            "Boston Terrier",
            "French Bulldog",
            "Staffordshire Bullterrier",
            "Cairn",
            "Chihuahua",
            "Chow",
            "Clumber",
            "Border Collie",
            "Coonhound",
            "Cardigan Corgi",
            "Dachshund",
            "Great Dane",
            "Scottish Deerhound",
            "Dhole",
            "Dingo",
            "Doberman",
            "Norwegian Elkhound",
            "Entlebucher",
            "American Eskimo",
            "German Shepherd",
            "Italian Greyhound",
            "Groenendael",
            "Ibizan Hound",
            "Afghan Hound",
            "Basset Hound",
            "Bloodhound",
            "English Foxhound",
            "Treeing Walker Coonhound",
            "Husky",
            "Keeshond",
            "Kelpie",
            "Komondor",
            "Kuvasz",
            "Labrador",
            "Leonberger",
            "Lhasa",
            "Malamute",
            "Malinois",
            "Maltese",
            "Bull Mastiff",
            "Tibetan Mastiff",
            "Mexican Hairless",
            "Bernese Mountain",
            "Greater Swiss Mountain",
            "Newfoundland",
            "Otterhound",
            "Papillon",
            "Pekinese",
            "Pembroke",
            "Miniature Pinscher",
            "German Pointer",
            "Pomeranian",
            "Miniature Poodle",
            "Standard Poodle",
            "Toy Poodle",
            "Pug",
            "Pyrenees",
            "Redbone",
            "Chesapeake Retriever",
            "Curly Retriever",
            "Flat-Coated Retriever",
            "Golden Retriever",
            "Rhodesian Ridgeback",
            "Rottweiler",
            "Saluki",
            "Samoyed",
            "Schipperke",
            "Giant Schnauzer",
            "Miniature Schnauzer",
            "English Setter",
            "Gordon Setter",
            "Irish Setter",
            "English Sheepdog",
            "Shetland Sheepdog",
            "Shiba",
            "Shihtzu",
            "Blenheim Spaniel",
            "Brittany Spaniel",
            "Cocker Spaniel",
            "Irish Spaniel",
            "Japanese Spaniel",
            "Sussex Spaniel",
            "Welsh Spaniel",
            "English Springer",
            "Saint Bernard",
            "American Terrier",
            "Australian Terrier",
            "Bedlington Terrier",
            "Border Terrier",
            "Dandie Terrier",
            "Fox Terrier",
            "Irish Terrier",
            "Kerry Blue Terrier",
            "Lakeland Terrier",
            "Norfolk Terrier",
            "Norwich Terrier",
            "Patterdale Terrier",
            "Rat Terrier",
            "Scottish Terrier",
            "Sealyham Terrier",
            "Silky Terrier",
            "Tibetan Terrier",
            "Toy Terrier",
            "West Highland White",
            "Wheaten Terrier",
            "Yorkshire Terrier",
            "Vizsla",
            "Weimaraner",
            "Whippet",
            "Irish Wolfhound"
          ],
          "coat_length": [
            "hairless",
            "short",
            "medium",
            "long",
            "wire",
            "curly"
          ],
          "meme_phrase": [
            "heck no pal",
            "11/10",
            "boop the snoot",
            "mlem",
            "blep",
            "long boi",
            "thicc doggo",
            "big ol' pupper",
            "smol pupperino",
            "zoom",
            "they're good dogs Brent"
          ],
          "name": [
            "Buddy",
            "Max",
            "Bella",
            "Daisy",
            "Molly",
            "Rocky",
            "Lucy",
            "Bear",
            "Bailey",
            "Lucky",
            "Harley",
            "Maggie",
            "Princess",
            "Angel",
            "Charlie",
            "Sadie",
            "Jack",
            "Shadow",
            "Jake",
            "Coco",
            "Gizmo",
            "Chloe",
            "Sophie",
            "Toby",
            "Roxy",
            "Buster",
            "Ginger",
            "Lady",
            "Duke",
            "Baby",
            "Peanut",
            "Bandit",
            "Abby",
            "Sasha",
            "Lola",
            "Zoey",
            "Pepper",
            "Sam",
            "Gracie",
            "Sammy",
            "Precious",
            "Missy",
            "Riley",
            "Spike",
            "Lily",
            "Sassy",
            "Cooper",
            "Rusty",
            "Dakota",
            "Dixie",
            "Cody",
            "Lilly",
            "Zoe",
            "Cookie",
            "Chico",
            "Zeus",
            "Tucker",
            "Oreo",
            "Teddy",
            "Marley",
            "Oscar",
            "Honey",
            "Rex",
            "Tank",
            "Sugar",
            "Sandy",
            "Penny",
            "Tyson",
            "Chance",
            "Mia",
            "Diamond",
            "Bubba",
            "Blue",
            "Belle",
            "Shelby",
            "Rosie",
            "Casey",
            "Ruby",
            "Snoopy",
            "Cocoa",
            "Jasmine",
            "Diesel",
            "Patches",
            "Annie",
            "Sparky",
            "Taz",
            "Bruno",
            "Roxie",
            "Lexi",
            "Scooter",
            "Jasper",
            "Brutus",
            "Baxter",
            "Luna",
            "Snickers",
            "Misty",
            "Rascal",
            "Milo",
            "Murphy",
            "Bo",
            "Harvey"
          ],
          "size": [
            "small",
            "medium",
            "large",
            "extra large"
          ],
          "sound": [
            "woof",
            "woof woof",
            "bow wow",
            "ruff",
            "owooooo",
            "grrrrrr"
          ]
        },
        "horse": {
          "breed": [
            "Abaco Barb",
            "Abtenauer",
            "Abyssinian",
            "Aegidienberger",
            "Akhal-Teke",
            "Albanian Horse",
            "Altai Horse",
            "Altèr Real",
            "American Albino",
            "American Cream Draft",
            "American Indian Horse",
            "American Paint Horse",
            "American Quarter Horse",
            "American Saddlebred",
            "American Warmblood",
            "Andalusian Horse",
            "Andravida Horse",
            "Anglo-Arabian",
            "Anglo-Arabo-Sardo",
            "Anglo-Kabarda",
            "Appaloosa",
            "Arabian Horse",
            "Ardennes Horse",
            "Arenberg-Nordkirchen",
            "Argentine Criollo",
            "Asturcón",
            "Augeron",
            "Asian wild Horse",
            "Assateague Horse",
            "Australian Brumby",
            "Australian Draught Horse",
            "Australian Stock Horse",
            "Austrian Warmblood",
            "Auvergne Horse",
            "Auxois",
            "Azerbaijan Horse",
            "Azteca Horse",
            "Baise Horse",
            "Bale",
            "Balearic Horse",
            "Balikun Horse",
            "Baluchi Horse",
            "Banker Horse",
            "Barb Horse",
            "Bardigiano",
            "Bashkir Curly",
            "Basque mountain Horse",
            "Bavarian Warmblood",
            "Belgian Horse",
            "Belgian Warmblood (includes Belgian Half-blood)",
            "Bhutia Horse",
            "Black Forest Horse",
            "Blazer Horse",
            "Boerperd",
            "Borana",
            "Bosnian Mountain Horse",
            "Boulonnais Horse",
            "Brabant",
            "Brandenburger",
            "Brazilian Sport Horse (Brasileiro de Hipismo)",
            "Breton Horse",
            "Brumby",
            "Budyonny Horse or Budenny",
            "Burguete Horse",
            "Burmese Horse",
            "Byelorussian Harness Horse",
            "Calabrese Horse",
            "Camargue Horse",
            "Camarillo White Horse",
            "Campeiro",
            "Campolina",
            "Canadian Horse",
            "Canadian Pacer",
            "Carolina Marsh Tacky",
            "Carthusian Horse",
            "Caspian Horse",
            "Castilian Horse",
            "Castillonnais",
            "Catria Horse",
            "Cavallo Romano della Maremma Laziale",
            "Cerbat Mustang",
            "Chickasaw Horse",
            "Chilean Horse also known as Chilean Corralero",
            "Choctaw Horse",
            "Cleveland Bay",
            "Clydesdale Horse",
            "Colorado Ranger",
            "Coldblood trotter",
            "Comtois Horse",
            "Corsican Horse",
            "Costa Rican Saddle Horse",
            "Cretan Horse",
            "Criollo Horse",
            "Croatian Coldblood",
            "Cuban Criollo",
            "Cumberland Island Horse",
            "Curly Horse",
            "Czech Warmblood",
            "Daliboz",
            "Danish Warmblood",
            "Danube Delta Horse",
            "Dole Gudbrandsdal",
            "or Dølahest",
            "Don",
            "Dongola Horse",
            "Draft Trotter",
            "Dutch harness Horse",
            "Dutch Heavy Draft",
            "Dutch Warmblood",
            "Dzungarian Horse",
            "East Bulgarian",
            "East Friesian Horse",
            "Estonian Draft",
            "Estonian Horse",
            "Falabella",
            "Faroese or Faroe Horse",
            "FinnHorse",
            "Fleuve",
            "Fjord Horse also called Norwegian Fjord Horse",
            "Florida Cracker Horse",
            "Foutanké or Fouta",
            "Frederiksborg Horse",
            "Freiberger",
            "French Trotter",
            "Friesian cross (includes Friesian Sport Horses)",
            "Friesian Horse",
            "Friesian SportHorse (a type of Friesian cross)",
            "Furioso-North Star",
            "Galiceno or Galiceño",
            "Galician Pony (Caballo de pura raza Gallega)",
            "Gelderland Horse",
            "Georgian Grande Horse",
            "German Warmblood or ZfDP",
            "Giara Horse",
            "Gidran",
            "Groningen Horse",
            "Gypsy Horse",
            "Hackney Horse",
            "Haflinger",
            "Hanoverian Horse",
            "Heck Horse",
            "Heihe Horse",
            "Henson Horse",
            "Hequ Horse",
            "Hirzai",
            "Hispano-Bretón",
            "Hispano-Árabe also known as Hispano or Spanish Anglo-Arab",
            "Holsteiner Horse",
            "Horro",
            "Hungarian Warmblood",
            "Icelandic Horse",
            "Iomud",
            "Irish Draught",
            "Irish Sport Horse sometimes called Irish Hunter",
            "Italian Heavy Draft",
            "Italian Trotter",
            "Jaca Navarra",
            "Jeju Horse",
            "Jutland Horse",
            "Kabarda Horse",
            "Kafa",
            "Kaimanawa Horses",
            "Kalmyk Horse",
            "Karabair",
            "Karabakh Horse also known as Azer At",
            "Karossier see Ostfriesen and Alt-Oldenburger",
            "Karachai Horse",
            "Kathiawari",
            "Kazakh Horse",
            "Kentucky Mountain Saddle Horse",
            "Kiger Mustang",
            "Kinsky Horse",
            "Kyrgyz Horse",
            "Kisber Felver",
            "Kiso Horse",
            "Kladruber",
            "Knabstrupper",
            "Konik",
            "Kundudo",
            "Kustanair",
            "Latvian Horse",
            "Lipizzan or Lipizzaner",
            "Lithuanian Heavy Draught",
            "Lokai",
            "Losino Horse",
            "Lusitano",
            "Lyngshest",
            "M'Bayar",
            "M'Par",
            "Malopolski",
            "Mallorquín",
            "Mangalarga",
            "Mangalarga Marchador",
            "Maremmano",
            "Marismeño Horse",
            "Marsh Tacky",
            "Marwari Horse",
            "Mecklenburger",
            "Međimurje Horse",
            "Menorquín",
            "Mérens Horse",
            "Messara Horse",
            "Mezőhegyesi sport-Horse (sportló)",
            "Mezőhegyes felver",
            "Metis Trotter",
            "Miniature Horse",
            "Misaki Horse",
            "Missouri Fox Trotter",
            "Monchina",
            "Mongolian Horse",
            "Mongolian Wild Horse",
            "Monterufolino",
            "Morab",
            "Morgan Horse",
            "Mountain Pleasure Horse",
            "Moyle Horse",
            "Muraközi",
            "Murgese",
            "Mustang Horse",
            "Namib Desert Horse",
            "Nangchen Horse",
            "National Show Horse",
            "Nez Perce Horse",
            "Nivernais Horse",
            "Nokota Horse",
            "Noma",
            "Nonius Horse",
            "Nooitgedachter",
            "Nordlandshest/ Lyngshest",
            "Noriker Horse",
            "Norman Cob",
            "Norsk Kaldblodstraver (Norwegian coldblood trotter)",
            "North American Single-Footer Horse",
            "North Swedish Horse",
            "Norwegian Fjord",
            "Novokirghiz",
            "Oberlander Horse",
            "Ogaden",
            "Oldenburg Horse",
            "Orlov trotter",
            "Ostfriesen and Alt-Oldenburger",
            "Paint",
            "Pampa Horse",
            "Paso Fino",
            "Pentro Horse",
            "Percheron",
            "Persano Horse",
            "Peruvian Paso",
            "Pintabian",
            "Pleven Horse",
            "Poitevin Horse also called Mulassier",
            "Posavac Horse",
            "Pottok",
            "Pryor Mountain Mustang",
            "Przewalski's Horse",
            "Pura Raza Española or PRE",
            "Purosangue Orientale",
            "Qatgani",
            "Quarab",
            "Quarter Horse",
            "Racking Horse",
            "Retuerta Horse",
            "Rhenish German Coldblood also known as Rhineland Heavy Draft",
            "Rhinelander Horse",
            "Riwoche Horse",
            "Rocky Mountain Horse",
            "Romanian SportHorse",
            "Rottaler",
            "Russian Don",
            "Russian Heavy Draft",
            "Russian Trotter",
            "Saddlebred",
            "Salerno Horse",
            "Samolaco Horse",
            "San Fratello Horse",
            "Santa Cruz Island Horse",
            "Sarcidano Horse",
            "Sardinian Anglo-Arab",
            "Schleswig Coldblood",
            "Schwarzwälder Kaltblut",
            "Selale",
            "Sella Italiano",
            "Selle Français",
            "Senner",
            "Shagya Arabian",
            "Shan Horse or Shan Myinn",
            "Shire Horse",
            "Siciliano indigeno",
            "Silesian Horse",
            "Sorraia",
            "Sokolsky Horse",
            "South German Coldblood also known as Süddeutsches Kaltblut",
            "Soviet Heavy Draft",
            "Spanish Barb see Barb Horse",
            "Spanish Jennet Horse",
            "Spanish Mustang",
            "Spanish-Norman Horse",
            "Spanish Tarpan",
            "Spiti Horse",
            "Spotted Saddle Horse",
            "Standardbred Horse",
            "Suffolk Punch",
            "Svensk Kallblodstravare (Swedish coldblood trotter)",
            "Swedish Ardennes",
            "Swedish Warmblood",
            "Swiss Warmblood",
            "Taishū Horse",
            "Takhi",
            "Tawleed",
            "Tchernomor",
            "Tennessee Walking Horse",
            "Tersk Horse",
            "Thoroughbred",
            "Tinker Horse",
            "Tiger Horse",
            "Tolfetano",
            "Tori Horse",
            "Trait Du Nord",
            "Trakehner",
            "Tsushima",
            "Tuigpaard",
            "Ukrainian Riding Horse",
            "Unmol Horse",
            "Uzunyayla",
            "Ventasso Horse (Cavallo Del Ventasso)",
            "Virginia highlander",
            "Vlaamperd",
            "Vladimir Heavy Draft",
            "Vyatka",
            "Waler Horse",
            "Waler",
            "Walkaloosa",
            "Warmblood",
            "Warlander",
            "Welsh Cob (Section D)",
            "Westphalian Horse",
            "Wielkopolski",
            "Württemberger or Württemberg",
            "Xilingol Horse",
            "Yakutian Horse",
            "Yili Horse",
            "Yonaguni Horse",
            "Zaniskari",
            "Zweibrücker",
            "Žemaitukas",
            "Zhemaichu"
          ],
          "name": [
            "Noir",
            "Jaguar",
            "Ebony",
            "Onyx",
            "Domino",
            "Cleveland",
            "Adobe",
            "Cinnamon",
            "Kit Kat",
            "Brandy",
            "Autumn",
            "Opie",
            "Fiona",
            "Pippi Longstocking",
            "Peter Pan",
            "Russell",
            "Blondie",
            "Rapunzel",
            "Spirit",
            "Trapper",
            "D’oro",
            "Napoleon",
            "Pepper",
            "Snowball",
            "Lacey",
            "Traveller",
            "Scout",
            "Little Joe",
            "Jigsaw",
            "Pirate",
            "Rembrandt",
            "Monte",
            "Baymax",
            "Goliath",
            "Universe",
            "Bolt",
            "Challenger",
            "Billie Jean",
            "Fargo",
            "Jet",
            "Victory",
            "Pharaoh",
            "Trigger",
            "Champ",
            "Oakley",
            "Bonney",
            "Rio",
            "Dale",
            "Gene",
            "Cash",
            "Chisholm",
            "Buttons",
            "Misty",
            "Dolly",
            "Cookie",
            "Charlie Brown",
            "Kokomo",
            "Olaf",
            "Thelwell",
            "Isabelle",
            "Randolph",
            "Debutante",
            "Marquis",
            "Juliet",
            "Henrietta",
            "Vanderbilt",
            "Versailles",
            "El Jefe",
            "Queen",
            "Boots",
            "Major",
            "Barkley",
            "Barnaby",
            "Whiskers",
            "Balki",
            "Newton",
            "Tigger",
            "Buster",
            "Flopsy",
            "Paris",
            "Sicily",
            "Beijing",
            "Vancouver",
            "Utah",
            "Sydney",
            "Berlin",
            "Carolina",
            "Passport",
            "London",
            "Mozart",
            "Jackson",
            "Beethoven",
            "Mona",
            "Dickinson",
            "Bard",
            "Da Vinci",
            "Sullivan",
            "Chopin"
          ]
        }
      },
      "crypto_coin": {
        "coin": [
          "Bitcoin,          BTC,  https://i.imgur.com/psBNOBq.png",
          "Bitcoin Cash,     BCC,  https://i.imgur.com/ViTjr9u.png",
          "Bitcoin Gold,     BTG,  https://i.imgur.com/l9cVE7c.png",
          "Bitcoin SV,       BSV,  https://i.imgur.com/DkixrAc.png",
          "Binance Coin,     BNB,  https://i.imgur.com/2HJr7OR.png",
          "Cardano,          ADA,  https://i.imgur.com/8qGU4zg.png",
          "Dash,             DASH, https://i.imgur.com/2uX91cb.png",
          "Decred,           DCR,  https://i.imgur.com/nURXAC2.png",
          "EOS.IO,           EOS,  https://i.imgur.com/Cr2w77s.png",
          "Ethereum,         ETH,  https://i.imgur.com/uOPFCXj.png",
          "Ethereum Classic, ETC,  https://i.imgur.com/8wBtmQA.png",
          "IOTA,             IOT,  https://i.imgur.com/DGFCOVt.png",
          "Litecoin,         LTC,  https://i.imgur.com/EFz61Ei.png",
          "Monero,           XMR,  https://i.imgur.com/pnupcJM.png",
          "NEM,              XEM,  https://i.imgur.com/SJ8NteF.png",
          "NEO,              NEO,  https://i.imgur.com/BmtVrJi.png",
          "Ripple,           XRP,  https://i.imgur.com/GjAPSsL.png",
          "Stellar,          XLM,  https://i.imgur.com/COLIHUE.png",
          "Tether,           USDT, https://i.imgur.com/xk6pQZy.png",
          "TRON,             TRX,  https://i.imgur.com/grG05ZK.png",
          "Zcash,            ZEC,  https://i.imgur.com/mX3r4j9.png"
        ]
      },
      "culture_series": {
        "books": [
          "Consider Phlebas",
          "The Player of Games",
          "Use of Weapons",
          "The State of the Art",
          "Excession",
          "Inversions",
          "Look to Windward",
          "Matter",
          "Surface Detail",
          "The Hydrogen Sonata"
        ],
        "civs": [
          "'Ktik",
          "Affront",
          "Aultridia",
          "Azadian",
          "Birilisi",
          "Bithian",
          "Bulbitian",
          "Changer",
          "Chelgrian",
          "Culture",
          "Dra'azon",
          "Flekke",
          "Geseptian-Fardesile",
          "Gzilt",
          "Homomda",
          "Idiran",
          "Iln",
          "Involucra AKA Veil",
          "Jhlupe",
          "Medjel",
          "Liseiden",
          "Morthanveld",
          "Nariscene",
          "Nauptre",
          "Oct",
          "Pavulean",
          "Ronte",
          "Sichultia",
          "Tensile Xinthian Aeronathaur",
          "Xolpe",
          "Zihdra"
        ],
        "culture_ship_class_abvs": [
          "GSV",
          "MSV",
          "LSV",
          "GCV",
          "GCU",
          "LCU",
          "ROU",
          "GOU",
          "LOU",
          "(D)ROU",
          "(D)GOU",
          "(D)LOU",
          "VFP",
          "FP",
          "SL"
        ],
        "culture_ship_classes": [
          "General Systems Vehicle",
          "Medium Systems Vehicle",
          "Limited Systems Vehicle",
          "General Contact Vehicle",
          "General Contact Unit",
          "Limited Contact Unit",
          "Rapid Offensive Unit",
          "General Offensive Unit",
          "Limited Offensive Unit",
          "Demilitarised ROU",
          "Demilitarised GOU",
          "Demilitarised LOU",
          "Very Fast Picket",
          "Fast Picket",
          "Superlifter"
        ],
        "culture_ships": [
          "Bora Horza Gobuchul",
          "Determinist",
          "Eschatologist",
          "Irregular Apocalypse",
          "No More Mr Nice Guy",
          "Profit Margin",
          "Nervous Energy",
          "Prosthetic Conscience",
          "Revisionist",
          "Trade Surplus",
          "The Ends Of Invention",
          "Cargo Cult",
          "Little Rascal",
          "So Much For Subtlety",
          "Unfortunate Conflict Of Evidence",
          "Youthful Indiscretion",
          "Flexible Demeanour",
          "Just Read The Instructions",
          "Of Course I Still Love You",
          "Zealot",
          "Limiting Factor",
          "Gunboat Diplomat",
          "Kiss My Ass",
          "Prime Mover",
          "Screw Loose",
          "Bad For Business",
          "Ablation",
          "Arbitrary",
          "Arrested Development",
          "A Series Of Unlikely Explanations",
          "A Ship With A View",
          "Big Sexy Beast",
          "Boo!",
          "Cantankerous",
          "Credibility Problem",
          "Dramatic Exit",
          "Excuses And Accusations",
          "Funny, It Worked Last Time...",
          "God Told Me To Do It",
          "Halation Effect",
          "Happy Idiot Talk",
          "Helpless In The Face Of Your Beauty",
          "Heresiarch",
          "I Thought He Was With You",
          "It'll Be Over By Christmas",
          "Just Another Victim Of The Ambient Morality",
          "Minority Report",
          "Never Talk To Strangers",
          "Not Wanted On Voyage",
          "Only Slightly Bent",
          "Perfidy",
          "Sacrificial Victim",
          "Space Monster",
          "Stranger Here Myself",
          "Synchronize Your Dogmas",
          "Thank You And Goodnight",
          "The Precise Nature Of The Catastrophe",
          "Ultimate Ship The Second",
          "Undesirable Alien",
          "Unwitting Accomplice",
          "Well I Was In The Neighbourhood",
          "You'll Thank Me Later",
          "You Would If You Really Loved Me",
          "Congenital Optimist",
          "Size Isn't Everything",
          "What Are The Civilian Applications?",
          "Just Testing",
          "Sweet and Full of Grace",
          "Very Little Gravitas Indeed",
          "Xenophobe",
          "Anticipation Of A New Lover's Arrival, The",
          "Death And Gravity",
          "Ethics Gradient",
          "Honest Mistake",
          "Limivorous",
          "Uninvited Guest",
          "Use Psychology",
          "What Is The Answer And Why?",
          "Wisdom Like Silence",
          "Yawning Angel",
          "Zero Gravitas",
          "Not Invented Here",
          "Misophist",
          "Serious Callers Only",
          "Steely Glint",
          "Different Tan",
          "Fate Amenable To Change",
          "It's Character Forming",
          "Jaundiced Outlook",
          "Problem Child",
          "Reasonable Excuse",
          "Recent Convert",
          "Tactical Grace",
          "Unacceptable Behaviour",
          "Attitude Adjuster",
          "Heavy Messing",
          "Killing Time",
          "Frank Exchange Of Views",
          "T3OU 4",
          "T3OU 118",
          "T3OU 736",
          "Charitable View",
          "Just Passing Through",
          "I Blame My Mother",
          "I Blame Your Mother",
          "Full Refund",
          "MBU 604",
          "Quietly Confident , later Sleeper Service",
          "No Fixed Abode",
          "Highpoint",
          "Shoot Them Later",
          "Appeal To Reason",
          "Break Even",
          "Long View",
          "Peace Makes Plenty",
          "Sober Counsel",
          "Within Reason",
          "Lasting Damage",
          "Lasting Damage I",
          "Lasting Damage II",
          "Sanctioned Parts List",
          "Grey Area",
          "Meatfucker",
          "Nuisance Value",
          "Resistance Is Character-Forming",
          "Vulgarian",
          "Someone Else's Problem",
          "Lacking That Small Match Temperament",
          "Poke It With A Stick",
          "I Said, I've Got A Big Stick",
          "Hand Me The Gun And Ask Me Again",
          "But Who's Counting?",
          "Germane Riposte",
          "We Haven't Met But You're A Great Fan Of Mine",
          "All The Same, I Saw It First",
          "Ravished By The Sheer Implausibility Of That Last Statement",
          "Zero Credibility",
          "Charming But Irrational",
          "Demented But Determined",
          "You May Not Be The Coolest Person Here",
          "Lucid Nonsense",
          "Awkward Customer",
          "Thorough But... Unreliable",
          "Advanced Case Of Chronic Patheticism",
          "Another Fine Product From The Nonsense Factory",
          "Conventional Wisdom",
          "In One Ear",
          "Fine Till You Came Along",
          "I Blame The Parents",
          "Inappropriate Response",
          "A Momentary Lapse Of Sanity",
          "Lapsed Pacifist",
          "Reformed Nice Guy",
          "Pride Comes Before A Fall",
          "Injury Time",
          "Now Look What You've Made Me Do",
          "Kiss This Then",
          "Seed Drill",
          "Don't Try This At Home",
          "Xenoglossicist",
          "Subtle Shift In Emphasis",
          "Experiencing A Significant Gravitas Shortfall",
          "It's My Party And I'll Sing If I Want To",
          "Lightly Seared On The Reality Grill",
          "Pure Big Mad Boat Man",
          "Qualifier",
          "Transient Atmospheric Phenomenon",
          "You Naughty Monsters",
          "Eight Rounds Rapid",
          "You'll Clean That Up Before You Leave",
          "Now We Try It My Way",
          "Liveware Problem",
          "Dressed Up To Party",
          "Pelagian",
          "Sense Amid Madness, Wit Amidst Folly",
          "Total Internal Reflection",
          "Armchair Traveller",
          "Bodhisattva , OAQS",
          "Falling Outside The Normal Moral Constraints",
          "No One Knows What The Dead Think",
          "Hylozoist",
          "The Usual But Etymologically Unsatisfactory",
          "Beastly To The Animals",
          "Fixed Grin",
          "Hidden Income",
          "Scar Glamour",
          "Labtebricolephile",
          "Me, I'm Counting",
          "A Fine Disregard For Awkward Facts",
          "Contents May Differ",
          "Empiricist",
          "Just The Washing Instruction Chip In Life's Rich Tapestry",
          "Kakistocrat",
          "Teething Problems",
          "Unreliable Witness",
          "Passing By And Thought I'd Drop In",
          "Pressure Drop",
          "You Call This Clean?",
          "Displacement Activity",
          "Warm, Considering",
          "Anything Legal Considered",
          "Beats Working",
          "Headcrash",
          "Questionable Ethics",
          "Xenocrat",
          "Caconym",
          "New Toy",
          "Rapid Random Response Unit",
          "Learned Response",
          "Outstanding Contribution To The Historical Process",
          "Refreshingly Unconcerned With The Vulgar Exigencies Of Veracity",
          "Value Judgement",
          "Zoologist",
          "Mistake Not...",
          "Smile Tolerantly"
        ],
        "planets": [
          "Bulthmaas",
          "Chel",
          "Eä",
          "Idir",
          "Issorile",
          "Narisca",
          "Nauptria",
          "Pavul",
          "Sichult",
          "Telaturier",
          "Xinth",
          "Zunzil Ligature"
        ]
      },
      "currency": {
        "code": [
          "AED",
          "AFN",
          "ALL",
          "AMD",
          "ANG",
          "AOA",
          "ARS",
          "AUD",
          "AWG",
          "AZN",
          "BAM",
          "BBD",
          "BDT",
          "BGN",
          "BHD",
          "BIF",
          "BMD",
          "BND",
          "BOB",
          "BRL",
          "BSD",
          "BWP",
          "BYR",
          "BZD",
          "CAD",
          "CDF",
          "CHF",
          "CLP",
          "CNY",
          "COP",
          "CRC",
          "CUP",
          "CVE",
          "CZK",
          "DJF",
          "DKK",
          "DOP",
          "DZD",
          "EEK",
          "EGP",
          "ERN",
          "ETB",
          "EUR",
          "FJD",
          "FKP",
          "GBP",
          "GEL",
          "GHS",
          "GIP",
          "GMD",
          "GNF",
          "GTQ",
          "GYD",
          "HKD",
          "HNL",
          "HRK",
          "HTG",
          "HUF",
          "IDR",
          "ILS",
          "INR",
          "INR",
          "IQD",
          "IRR",
          "ISK",
          "JMD",
          "JOD",
          "JPY",
          "KES",
          "KGS",
          "KHR",
          "KMF",
          "KPW",
          "KRW",
          "KWD",
          "KYD",
          "KZT",
          "LAK",
          "LBP",
          "LKR",
          "LRD",
          "LTL",
          "LVL",
          "LYD",
          "MAD",
          "MDL",
          "MGA",
          "MKD",
          "MMK",
          "MNT",
          "MOP",
          "MRO",
          "MUR",
          "MVR",
          "MWK",
          "MXN",
          "MYR",
          "MZN",
          "NGN",
          "NIO",
          "NOK",
          "NPR",
          "NZD",
          "OMR",
          "PAB",
          "PEN",
          "PGK",
          "PHP",
          "PKR",
          "PLN",
          "PYG",
          "QAR",
          "RON",
          "RSD",
          "RUB",
          "RWF",
          "SAR",
          "SBD",
          "SCR",
          "SDG",
          "SEK",
          "SGD",
          "SHP",
          "SLL",
          "SOS",
          "SRD",
          "STD",
          "SVC",
          "SYP",
          "SZL",
          "THB",
          "TJS",
          "TMT",
          "TND",
          "TOP",
          "TRY",
          "TTD",
          "TWD",
          "TZS",
          "UAH",
          "UGX",
          "USD",
          "UYU",
          "UZS",
          "VEF",
          "VND",
          "VUV",
          "WST",
          "XAF",
          "XAG",
          "XAU",
          "XBA",
          "XBB",
          "XBC",
          "XBD",
          "XCD",
          "XDR",
          "XFU",
          "XOF",
          "XPD",
          "XPF",
          "XPT",
          "XTS",
          "YER",
          "ZAR",
          "ZAR",
          "ZAR",
          "ZMK",
          "ZWL"
        ],
        "name": [
          "UAE Dirham",
          "Afghani",
          "Lek",
          "Armenian Dram",
          "Netherlands Antillian Guilder",
          "Kwanza",
          "Argentine Peso",
          "Australian Dollar",
          "Aruban Guilder",
          "Azerbaijanian Manat",
          "Convertible Marks",
          "Barbados Dollar",
          "Taka",
          "Bulgarian Lev",
          "Bahraini Dinar",
          "Burundi Franc",
          "Bermudian Dollar (customarily known as Bermuda Dollar)",
          "Brunei Dollar",
          "Boliviano Mvdol",
          "Brazilian Real",
          "Bahamian Dollar",
          "Pula",
          "Belarussian Ruble",
          "Belize Dollar",
          "Canadian Dollar",
          "Congolese Franc",
          "Swiss Franc",
          "Chilean Peso Unidades de fomento",
          "Yuan Renminbi",
          "Colombian Peso Unidad de Valor Real",
          "Costa Rican Colon",
          "Cuban Peso Peso Convertible",
          "Cape Verde Escudo",
          "Czech Koruna",
          "Djibouti Franc",
          "Danish Krone",
          "Dominican Peso",
          "Algerian Dinar",
          "Kroon",
          "Egyptian Pound",
          "Nakfa",
          "Ethiopian Birr",
          "Euro",
          "Fiji Dollar",
          "Falkland Islands Pound",
          "Pound Sterling",
          "Lari",
          "Cedi",
          "Gibraltar Pound",
          "Dalasi",
          "Guinea Franc",
          "Quetzal",
          "Guyana Dollar",
          "Hong Kong Dollar",
          "Lempira",
          "Croatian Kuna",
          "Gourde US Dollar",
          "Forint",
          "Rupiah",
          "New Israeli Sheqel",
          "Indian Rupee",
          "Indian Rupee Ngultrum",
          "Iraqi Dinar",
          "Iranian Rial",
          "Iceland Krona",
          "Jamaican Dollar",
          "Jordanian Dinar",
          "Yen",
          "Kenyan Shilling",
          "Som",
          "Riel",
          "Comoro Franc",
          "North Korean Won",
          "Won",
          "Kuwaiti Dinar",
          "Cayman Islands Dollar",
          "Tenge",
          "Kip",
          "Lebanese Pound",
          "Sri Lanka Rupee",
          "Liberian Dollar",
          "Lithuanian Litas",
          "Latvian Lats",
          "Libyan Dinar",
          "Moroccan Dirham",
          "Moldovan Leu",
          "Malagasy Ariary",
          "Denar",
          "Kyat",
          "Tugrik",
          "Pataca",
          "Ouguiya",
          "Mauritius Rupee",
          "Rufiyaa",
          "Kwacha",
          "Mexican Peso Mexican Unidad de Inversion (UDI)",
          "Malaysian Ringgit",
          "Metical",
          "Naira",
          "Cordoba Oro",
          "Norwegian Krone",
          "Nepalese Rupee",
          "New Zealand Dollar",
          "Rial Omani",
          "Balboa US Dollar",
          "Nuevo Sol",
          "Kina",
          "Philippine Peso",
          "Pakistan Rupee",
          "Zloty",
          "Guarani",
          "Qatari Rial",
          "New Leu",
          "Serbian Dinar",
          "Russian Ruble",
          "Rwanda Franc",
          "Saudi Riyal",
          "Solomon Islands Dollar",
          "Seychelles Rupee",
          "Sudanese Pound",
          "Swedish Krona",
          "Singapore Dollar",
          "Saint Helena Pound",
          "Leone",
          "Somali Shilling",
          "Surinam Dollar",
          "Dobra",
          "El Salvador Colon US Dollar",
          "Syrian Pound",
          "Lilangeni",
          "Baht",
          "Somoni",
          "Manat",
          "Tunisian Dinar",
          "Pa'anga",
          "Turkish Lira",
          "Trinidad and Tobago Dollar",
          "New Taiwan Dollar",
          "Tanzanian Shilling",
          "Hryvnia",
          "Uganda Shilling",
          "US Dollar",
          "Peso Uruguayo Uruguay Peso en Unidades Indexadas",
          "Uzbekistan Sum",
          "Bolivar Fuerte",
          "Dong",
          "Vatu",
          "Tala",
          "CFA Franc BEAC",
          "Silver",
          "Gold",
          "Bond Markets Units European Composite Unit (EURCO)",
          "European Monetary Unit (E.M.U.-6)",
          "European Unit of Account 9(E.U.A.-9)",
          "European Unit of Account 17(E.U.A.-17)",
          "East Caribbean Dollar",
          "SDR",
          "UIC-Franc",
          "CFA Franc BCEAO",
          "Palladium",
          "CFP Franc",
          "Platinum",
          "Codes specifically reserved for testing purposes",
          "Yemeni Rial",
          "Rand",
          "Rand Loti",
          "Rand Namibia Dollar",
          "Zambian Kwacha",
          "Zimbabwe Dollar"
        ],
        "symbol": [
          "HK$",
          "Ft",
          "₪",
          "¥",
          "$",
          "kr",
          "PhP",
          "zł",
          "CHF",
          "NT$",
          "฿",
          "£",
          "¢",
          "Rp",
          "ƒ",
          "€",
          "रू"
        ]
      },
      "dc_comics": {
        "hero": [
          "Batman",
          "Superman",
          "Red Arrow",
          "Green Lantern",
          "Robin",
          "Nightwing",
          "The Flash",
          "Aquaman",
          "Green Arrow",
          "Captain Marvel",
          "Shazam",
          "Martain Manhunter",
          "Cyborg",
          "Hawkman",
          "Speedy",
          "Arsenal",
          "Red Tornado",
          "Booster Gold",
          "Doctor Fate",
          "Beast Boy",
          "Plastic Man",
          "Captain Atom",
          "Tempest",
          "Spectre",
          "Midnighter",
          "The Atom",
          "Kilowog",
          "Firestorm",
          "Blue Beetle",
          "Animal Man",
          "Mr. Miracle",
          "Wildcat",
          "Rorschach",
          "Dr. Manhattan",
          "Nite Owl",
          "The Comedian",
          "Azrael",
          "Jonah Hex",
          "Apollo",
          "Black Lightning",
          "Orion",
          "Steel",
          "Superboy",
          "Doctor Mid-Nite",
          "Mr. Terrific",
          "Ragman",
          "Captain Comet",
          "The Sandman",
          "Dr. Fate",
          "Guardian"
        ],
        "heroine": [
          "Wonder Woman",
          "Hawkgirl",
          "Supergirl",
          "Black Canary",
          "Batgirl",
          "Raven",
          "Wonder Girl",
          "Starfire",
          "Lady Cain",
          "Power Girl",
          "Mera",
          "Vixen",
          "Silk Spectre",
          "Batwoman",
          "Mary Marvel"
        ],
        "name": [
          "John Stewart",
          "Hal Jordan",
          "Kyle Rayner",
          "Barry Allen",
          "James Gordon",
          "Dianna Prince",
          "Lois Lane",
          "Barbara Gordon",
          "Jason Todd",
          "Bart Allen",
          "John Constantine",
          "Roy Harper",
          "Clark Kent",
          "Bruce Wayne",
          "Dick Grayson",
          "Billy Batson",
          "Michael Jon Carter",
          "Tim Drake",
          "Jay Garrick",
          "Damian Wayne",
          "Ray Palmer",
          "Ted Kord",
          "Connor Hawke",
          "Terry McGinnis",
          "Harvey Bullock",
          "Al Pratt",
          "Wesley Dodds",
          "Maxwell Lord",
          "Oswald Cobblepot",
          "Alfred Pennyworth"
        ],
        "title": [
          "The Sinestro Corps War",
          "The Coyote Gospel",
          "Green Arrow: The Longbow Hunters",
          "JLA: Earth 2",
          "Identity Crisis",
          "JLA: Tower Of Babel",
          "Superman For All Seasons",
          "Superman: Red Son",
          "Batman: The Long Halloween",
          "Swamp Thing: The Anatomy Lesson",
          "For The Man Who Has Everything",
          "Jack Kirby's New Gods",
          "Arkham Asylum: A Serious House On Serious Earth",
          "Snowbirds Don't Fly",
          "Whatever Happened To The Man Of Tomorrow?",
          "The Killing Joke",
          "Teen Titans: The Judas Contract",
          "The New Frontier",
          "Kingdom Come",
          "Crisis On Infinite Earths",
          "Batman: Year One",
          "All Star Superman",
          "The Dark Knight Returns",
          "Multiversity",
          "Gotham Central",
          "Grant Morrison's Animal Man",
          "Doom Patrol",
          "Action Comics",
          "Detective Comics"
        ],
        "villain": [
          "The Joker",
          "Lex Luthor",
          "Darkseid",
          "Sinestro",
          "Brainiac",
          "Black Adam",
          "Ras al Ghul",
          "Deathstroke",
          "Two-Face",
          "Doomsday",
          "Catwoman",
          "Mongul",
          "Bizarro",
          "Riddler",
          "Captain Cold",
          "Bane",
          "Harley Quinn",
          "Scarecrow",
          "Paralax",
          "Gorilla Grodd",
          "General Zod",
          "Black Manta",
          "Mr. Freeze",
          "Cheetah",
          "Amanda Waller",
          "Penguin",
          "Poison Ivy",
          "Solomon Grundy",
          "Parasite",
          "Krona",
          "Deadshot",
          "Metallo",
          "Lobo",
          "Eclipso",
          "Ares",
          "Hugo Strange",
          "Despero",
          "Talia al Ghul",
          "Mirror Master",
          "Captain Boomerang",
          "Mr. Mxyzptlk",
          "Weather Wizard",
          "Heat Wave",
          "Clock King",
          "Clay Face",
          "Killer Croc",
          "Gentleman Ghost",
          "Toy Man",
          "Starro"
        ]
      },
      "demographic": {
        "demonym": [
          "Afghan",
          "Albanian",
          "Algerian",
          "American",
          "Andorran",
          "Angolan",
          "Argentine",
          "Armenian",
          "Aromanian",
          "Aruban",
          "Australian",
          "Austrian",
          "Azerbaijani",
          "Bahamian",
          "Bahraini",
          "Bangladeshi",
          "Barbadian",
          "Basotho",
          "Basque",
          "Belarusian",
          "Belgian",
          "Belizean",
          "Bermudian",
          "Bissau-Guinean",
          "Boer",
          "Bosniak",
          "Brazilian",
          "Breton",
          "Briton",
          "British Virgin Islander",
          "Bruneian",
          "Bulgarian",
          "Burkinabè",
          "Burundian",
          "Cambodian",
          "Cameroonian",
          "Canadian",
          "Catalan",
          "Cape Verdean",
          "Chadian",
          "Chilean",
          "Chinese",
          "Colombian",
          "Comorian",
          "Congolese",
          "Croatian",
          "Cuban",
          "Cypriot",
          "Czech",
          "Dane",
          "Dominican",
          "Dutch",
          "East Timorese",
          "Ecuadorian",
          "Egyptian",
          "Emirati",
          "English",
          "Eritrean",
          "Estonian",
          "Ethiopian",
          "Falkland Islander",
          "Faroese",
          "Finn",
          "Fijian",
          "Filipino",
          "French",
          "Georgian",
          "German",
          "Ghanaian",
          "Gibraltar",
          "Greek",
          "Grenadian",
          "Guatemalan",
          "French Guianan",
          "Guinean",
          "Guyanese",
          "Haitian",
          "Honduran",
          "Hong Konger",
          "Hungarian",
          "Icelander",
          "I-Kiribati",
          "Indian",
          "Indonesian",
          "Iranian",
          "Iraqi",
          "Irish",
          "Israeli",
          "Italian",
          "Ivoirian",
          "Jamaican",
          "Japanese",
          "Jordanian",
          "Kazakh",
          "Kenyan",
          "Korean",
          "Kosovar",
          "Kurd",
          "Kuwaiti",
          "Kyrgyz",
          "Lao",
          "Latvian",
          "Lebanese",
          "Liberian",
          "Libyan",
          "Liechtensteiner",
          "Lithuanian",
          "Luxembourger",
          "Macanese",
          "Macedonian",
          "Malagasy",
          "Malaysian",
          "Malawian",
          "Maldivian",
          "Malian",
          "Maltese",
          "Manx",
          "Mauritian",
          "Mexican",
          "Moldovan",
          "Moroccan",
          "Mongolian",
          "Montenegrin",
          "Namibian",
          "Nepalese",
          "New Zealander",
          "Nicaraguan",
          "Nigerien",
          "Nigerian",
          "Norwegian",
          "Pakistani",
          "Palauan",
          "Palestinian",
          "Panamanian",
          "Papua New Guinean",
          "Paraguayan",
          "Peruvian",
          "Pole",
          "Portuguese",
          "Puerto Rican",
          "Quebecer",
          "Romanian",
          "Russian",
          "Rwandan",
          "Salvadoran",
          "São Toméan",
          "Saudi",
          "Scottish",
          "Senegalese",
          "Serb",
          "Sierra Leonean",
          "Singaporean",
          "Sindhian",
          "Slovak",
          "Slovene",
          "Somali",
          "Somalilander",
          "South African",
          "Spaniard",
          "Sri Lankan",
          "St Lucian",
          "Sudanese",
          "Surinamese",
          "Swede",
          "Swiss",
          "Syriac",
          "Syrian",
          "Tajik",
          "Taiwanese",
          "Tanzanian",
          "Thai",
          "Tibetan",
          "Tobagonian",
          "Trinidadian",
          "Tunisian",
          "Turk",
          "Tuvaluan",
          "Ugandan",
          "Ukrainian",
          "Uruguayan",
          "Uzbek",
          "Vanuatuan",
          "Venezuelan",
          "Vietnamese",
          "Welsh",
          "Yemeni",
          "Zambian",
          "Zimbabwean"
        ],
        "educational_attainment": [
          "No schooling completed",
          "Nursery school",
          "Kindergarten",
          "Grade 1 though 11",
          "12th grade - No Diploma",
          "Regular high school diploma",
          "GED or alternative credential",
          "Some college",
          "Associate's degree",
          "Bachelor's degree",
          "Master's degree",
          "Professional degree",
          "Doctorate degree"
        ],
        "marital_status": [
          "Married",
          "Widowed",
          "Divorced",
          "Separated",
          "Never married"
        ],
        "race": [
          "American Indian or Alaska Native",
          "Asian",
          "Black or African American",
          "Native Hawaiian or Other Pacific Islander",
          "White"
        ],
        "sex": [
          "Male",
          "Female"
        ]
      },
      "departed": {
        "actors": [
          "Leonardo DiCaprio",
          "Matt Damon",
          "Jack Nicholson",
          "Mark Wahlberg",
          "Martin Sheen",
          "Ray Winstone",
          "Vera Farmiga",
          "Anthony Anderson",
          "Alec Baldwin",
          "Kevin Corrigan",
          "James Badge Dale",
          "David O'Hara",
          "Mark Rolston"
        ],
        "characters": [
          "Billy Costigan",
          "Colin Sullivan",
          "Frank Costello",
          "Sean Dignam",
          "Oliver Queenan",
          "Arnold French",
          "Madolyn Madden",
          "Tony Brown",
          "George Ellerby",
          "Sean Costigan",
          "James Barrigan",
          "Patrick Fitzgibbons",
          "Timothy Delahunt"
        ],
        "quotes": [
          "I'm the guy who does his job. You must be the other guy.",
          "You have an immaculate record. Some guys don't trust an immaculate record. I do. I have an immaculate record.",
          "You got a nice suit at home or do you like coming to work everyday dressed like you're going to invade Poland?",
          "All due respect Mr. Costello school is out.",
          "Normally he's a very uh nice guy. Don't judge him from this meeting alone.",
          "Maybe. Maybe not. Maybe fuck yourself.",
          "My theory on Feds is that they're like mushrooms feed 'em shit and keep 'em in the dark",
          "Don't laugh! This ain't reality TV!",
          "Let's say you have no idea and leave it at that okay? No idea. Zip. None.",
          "Families are always rising or falling in America am I right?",
          "What Freud said about the Irish is we're the only people who are impervious to psychoanalysis.",
          "One of you mugs got a light?",
          "Do you want to be a cop or do you want to appear to be a cop?",
          "Yeah, it's working... Overtime!"
        ]
      },
      "dessert": {
        "flavor": [
          "Vanilla",
          "Chocolate",
          "Strawberry",
          "Birthday Cake",
          "Salted Caramel",
          "Banana",
          "Butter Pecan",
          "Cookies 'n Cream",
          "Caramel",
          "Apple",
          "Butterscotch",
          "Mint Chocolate Chip",
          "Espresso",
          "Butter Pecan",
          "Cherry",
          "Coconut",
          "Chocolate Chip Cookie Dough",
          "French Vanilla",
          "Neapolitan",
          "Pistachio",
          "Rocky Road",
          "Peanut Butter",
          "Almond",
          "Green Tea",
          "Cheesecake",
          "Funfetti",
          "Lemon",
          "Oatmeal",
          "Pumpkin",
          "Red Velvet",
          "Blondie"
        ],
        "topping": [
          "Rainbow Sprinkles",
          "Chocolate Chips",
          "Whipped Cream",
          "Frosting",
          "Peanut Butter",
          "Gummy Bears",
          "Mocha Drizzle",
          "Caramel",
          "Bacon",
          "Chocolate Syrup",
          "Chocolate Sprinkles",
          "Cookie Dough",
          "Peanuts",
          "Butterscotch Syrup",
          "Marshmallows",
          "Cheesecake Bites",
          "Walnuts",
          "Granola",
          "Toffee Bits",
          "Berry Compote",
          "Glaze",
          "Powdered Sugar",
          "Cinnamon"
        ],
        "variety": [
          "Cake",
          "Cookie",
          "Pie",
          "Ice Cream",
          "Pudding",
          "Sweet Bread",
          "Cupcake",
          "Cheesecake",
          "Brownie",
          "Cobbler",
          "Ice Cream Cake",
          "Doughnut",
          "Frozen Yogurt",
          "Parfait",
          "Sundae",
          "Trifle",
          "Cake Pop",
          "Fruit Cake",
          "Coffee Cake",
          "Key Lime Pie",
          "Upside Down Pineapple Cake"
        ]
      },
      "device": {
        "manufacturer": [
          "ASUS",
          "Acer",
          "Apple",
          "Dell",
          "Google",
          "HP",
          "Huawei",
          "Lenovo",
          "OnePlus",
          "Samsung",
          "Xiamomi"
        ],
        "model_name": [
          "Galaxy S1",
          "Galaxy S2",
          "Galaxy S3 Mini",
          "Galaxy S3",
          "Galaxy S4 Mini",
          "Galaxy S4",
          "Galaxy S5",
          "Galaxy S6 Edge",
          "Galaxy S7 Edge",
          "Galaxy S7",
          "Galaxy S8 Plus",
          "Galaxy S8",
          "Galaxy S9",
          "Mate 10 Pro",
          "Mate 20 Lite",
          "Mate 20 Pro",
          "Mate 20",
          "Mate 9",
          "Mi 8 Lite",
          "Mi 8 Pro",
          "Mi 8 SE",
          "Mi 8",
          "OnePlus 2",
          "OnePlus 3",
          "OnePlus 3T",
          "OnePlus 5",
          "OnePlus 5T",
          "OnePlus 6",
          "OnePlus 6T",
          "OnePlus One",
          "P Smart",
          "P10 Plus",
          "P10",
          "P20 Pro",
          "P20",
          "Pixel 2 XL",
          "Pixel 2",
          "Pixel 3 XL",
          "Pixel 3",
          "Pixel XL",
          "Pixel",
          "Pocophone F1",
          "Redmi Note 6 Pro",
          "iPhone 3G",
          "iPhone 3GS",
          "iPhone 4",
          "iPhone 4S",
          "iPhone 5",
          "iPhone 5C",
          "iPhone 5S",
          "iPhone 6 / 6 Plus",
          "iPhone 6S / 6S Plus",
          "iPhone 7 / 7 Plus",
          "iPhone 8 / 8 Plus",
          "iPhone SE",
          "iPhone X",
          "iPhone"
        ],
        "platform": [
          "Android OS",
          "Android",
          "BlackBerry",
          "Danger OS",
          "Firefox OS",
          "Ubuntu Touch",
          "Windows 10 Mobile",
          "Windows 10",
          "Windows 8",
          "Windows 8.1",
          "Windows Phone",
          "Windows RT",
          "iOS",
          "webOS"
        ],
        "serial": [
          "pEekWH7zGxVITv6NTa5KHjLSwr5Ie4",
          "UVr864F8zUbyYOAUd4cFOW9hpsZuGn",
          "Kl2ZroV9a",
          "m6aHiiHOc",
          "hHhDJaHCO",
          "SJMZOmtU0csrv4R",
          "PTIA6Ff3GBvGh3j",
          "hrR8nflThDDaSXO",
          "OezkV3nTii0sMK0",
          "T6UuMUTani3VGY4vXGia",
          "NjGU0z33pgE4sTEED7VR",
          "05skEogwZlX7j6twhhXX",
          "ToFVWLzGTJhQxAaJlDDn",
          "ejfjnRNInxh0363JC2WM",
          "xC36G3Xy4n2Fu90keaW96c1Hw5QBJX",
          "CdNevWfqDPQw4iJgUhtyCqwCggV12T",
          "9vxM9fCsG9nXg8EjTN5ygV2LvaDZdG",
          "39gPmcOKpwhDezLdiIOZ7SH89Pbjp4",
          "Yr9Vt13BlgvXO9zgJTPuCLv6F82r5S",
          "trDuJXhT8PnD3JEtw4lsluEuYSn1Xh",
          "VMTnd2mMQWvjbtNcZh7UIdULKb1mMo",
          "Pbn8^`LkKPi4QJ79xk3SnW'_DbV*CL",
          "Hk4BoF=%ud/PV4K-/NvEq28Q/&HNq7",
          "_usDGH^%'4dSYvUtH39qu3*hbi3V+z",
          "&XwUS6yR2N&+Z`$94eK@XzFp/p/ie^",
          "tL&^J@24CVF=zP46Lxixk`_a#=o6c5"
        ]
      },
      "dnd": {
        "alignments": [
          "Chaotic Evil",
          "Chaotic Good",
          "Chaotic Neutral",
          "Lawful Evil",
          "Lawful Good",
          "Lawful Neutral",
          "Neutral Evil",
          "Neutral Good",
          "True Neutral"
        ],
        "backgrounds": [
          "Acolyte",
          "Anthropologist",
          "Archaeologist",
          "Black Fist Double Agent",
          "Caravan Specialist",
          "Charlatan",
          "City Watch",
          "Clan Crafter",
          "Cloistered Scholar",
          "Cormanthor Refugee",
          "Courtier",
          "Criminal",
          "Dragon Casualty",
          "Earthspur Miner",
          "Entertainer",
          "Faction Agent",
          "Far Traveler",
          "Folk Hero",
          "Gate Urchin",
          "Gladiator",
          "Guild Artisan",
          "Guild Merchant",
          "Harborfolk",
          "Haunted One",
          "Heretic",
          "Hermit",
          "Hillsfar Merchant",
          "Hillsfar Smuggler",
          "Initiate",
          "Inquisitor",
          "Investigator",
          "Iron Route Bandit",
          "Knight",
          "Knight of the Order",
          "Mercenary Veteran",
          "Mulmaster Aristocrat",
          "Noble",
          "Outlander",
          "Phlan Insurgent",
          "Phlan Refugee",
          "Pirate",
          "Sage",
          "Sailor",
          "Secret Identity",
          "Shade Fanatic",
          "Soldier",
          "Spy",
          "Stojanow Prisoner",
          "Ticklebelly Nomad",
          "Trade Sheriff",
          "Urban Bounty Hunter",
          "Urchin",
          "Uthgardt Tribe Member",
          "Vizier",
          "Waterdhavian Noble"
        ],
        "cities": [
          "Almraiven",
          "Berdusk",
          "Bildoobaris",
          "Chethel",
          "Citadel Adbar",
          "Citadel of Ten Thousand Pearls",
          "Crimmor",
          "Derlusk",
          "Dhaztanar",
          "Drik Hargunen",
          "Earthfast",
          "Elbulder",
          "Elturel",
          "Escalant",
          "Eshpurta",
          "Esmeltaran",
          "Everlund",
          "Fireshear",
          "Hlammach",
          "Hlath",
          "Iljak",
          "Immilmar",
          "Iriaebor",
          "Keltar",
          "Kuda",
          "Lushpool",
          "Luskan",
          "Mintar",
          "Nathlekh",
          "Neverwinter",
          "Nimpeth",
          "Ormpur",
          "Orvyltar",
          "Phsant",
          "Procampur",
          "Proskur",
          "Reth",
          "Sammaresh",
          "Scornubel",
          "Sloopdilmonpolop",
          "Sundabar",
          "Tamanokuni",
          "Tantras",
          "Telflamm",
          "Telos",
          "Teshburl",
          "Trailsend",
          "Tsurlagol",
          "Tukan",
          "Ubar",
          "Ulatos",
          "Urmlaspyr",
          "Vilkstead",
          "Waterdeep",
          "Yeshpek",
          "Yhaunn",
          "Zhentil Keep"
        ],
        "klasses": [
          "Artificer",
          "Barbarian",
          "Bard",
          "Blood Hunter",
          "Cleric",
          "Druid",
          "Fighter",
          "Monk",
          "Paladin",
          "Ranger",
          "Rogue",
          "Sorcerer",
          "Warlock",
          "Wizard"
        ],
        "languages": [
          "Abyssal",
          "Celestial",
          "Common",
          "Deep Speech",
          "Draconic",
          "Dwarvish",
          "Elvish",
          "Giant",
          "Gnomish",
          "Goblin",
          "Halfling",
          "Infernal",
          "Orc",
          "Primordial",
          "Sylvan",
          "Undercommon"
        ],
        "melee_weapons": [
          "Battleaxe",
          "Club",
          "Dagger",
          "Flail",
          "Glaive",
          "Greatclub",
          "Greatsword",
          "Halberd",
          "Handaxe",
          "Javelin",
          "Lance",
          "Light hammer",
          "Longsword",
          "Mace",
          "Maul",
          "Morningstar",
          "Pike",
          "Quarterstaff",
          "Rapier",
          "Scimitar",
          "Shortsword",
          "Sickle",
          "Spear",
          "Trident",
          "War Pick",
          "Warhammer",
          "Whip"
        ],
        "monsters": [
          "Aarakocra",
          "Aboleth",
          "Adult Black Dragon",
          "Adult Blue Dragon",
          "Adult Brass Dragon",
          "Adult Bronze Dragon",
          "Adult Copper Dragon",
          "Adult Gold Dragon",
          "Adult Green Dragon",
          "Adult Red Dragon",
          "Adult Silver Dragon",
          "Adult White Dragon",
          "Air Elemental",
          "Allosaurus",
          "Ancient Black Dragon",
          "Ancient Blue Dragon",
          "Ancient Brass Dragon",
          "Ancient Bronze Dragon",
          "Ancient Copper Dragon",
          "Ancient Gold Dragon",
          "Ancient Green Dragon",
          "Ancient Red Dragon",
          "Ancient Silver Dragon",
          "Ancient White Dragon",
          "Androsphinx",
          "Animated Armor",
          "Animated Objects",
          "Ankheg",
          "Ankylosaurus",
          "Azer",
          "Balor",
          "Barbed Devil",
          "Basilisk",
          "Bearded Devil",
          "Behir",
          "Black Dragon Wyrmling",
          "Black Pudding",
          "Blue Dragon Wyrmling",
          "Bone Devil",
          "Brass Dragon Wyrmling",
          "Bronze Dragon Wyrmling",
          "Bugbear",
          "Bulette",
          "Bullywug",
          "Centaur",
          "Chain Devil",
          "Chimera",
          "Chuul",
          "Clay Golem",
          "Cloaker",
          "Cloud Giant",
          "Cockatrice",
          "Copper Dragon Wyrmling",
          "Couatl",
          "Darkmantle",
          "Deck of Many Things",
          "Demons",
          "Deva",
          "Dinosaurs",
          "Djinni",
          "Doppelganger",
          "Dragon Turtle",
          "Dretch",
          "Drider",
          "Drow",
          "Dryad",
          "Duergar",
          "Dust Mephit",
          "Earth Elemental",
          "Efreeti",
          "Elf",
          "Erinyes",
          "Ettercap",
          "Ettin",
          "Figurine of Wondrous Power",
          "Fire Elemental",
          "Fire Giant",
          "Flesh Golem",
          "Flying Sword",
          "Frost Giant",
          "Fungi",
          "Gargoyle",
          "Gelatinous Cube",
          "Ghast",
          "Ghost",
          "Ghoul",
          "Gibbering Mouther",
          "Glabrezu",
          "Gnoll",
          "Goblin",
          "Gold Dragon Wyrmling",
          "Gorgon",
          "Gray Ooze",
          "Green Dragon Wyrmling",
          "Green Hag",
          "Grick",
          "Griffon",
          "Grimlock",
          "Guardian Naga",
          "Gynosphinx",
          "Half-Red Dragon Veteran",
          "Harpy",
          "Hell Hound",
          "Hezrou",
          "Hill Giant",
          "Hippogriff",
          "Hobgoblin",
          "Homunculus",
          "Horned Devil",
          "Hydra",
          "Ice Devil",
          "Ice Mephit",
          "Imp",
          "Invisible Stalker",
          "Iron Golem",
          "Kobold",
          "Kraken",
          "Lamia",
          "Lemure",
          "Lich",
          "Lizardfolk",
          "Lycanthropes",
          "Magma Mephit",
          "Magmin",
          "Manticore",
          "Marilith",
          "Medusa",
          "Merfolk",
          "Merrow",
          "Mimic",
          "Minotaur",
          "Minotaur Skeleton",
          "Mummy",
          "Mummy Lord",
          "Nagas",
          "Nalfeshnee",
          "Night Hag",
          "Nightmare",
          "Ochre Jelly",
          "Ogre",
          "Ogre Zombie",
          "Oni",
          "Orc",
          "Otyugh",
          "Owlbear",
          "Pegasus",
          "Pit Fiend",
          "Planetar",
          "Plesiosaurus",
          "Pseudodragon",
          "Pteranodon",
          "Purple Worm",
          "Quasit",
          "Rakshasa",
          "Red Dragon Wyrmling",
          "Remorhaz",
          "Roc",
          "Roper",
          "Rug of Smothering",
          "Rust Monster",
          "Sahuagin",
          "Salamander",
          "Satyr",
          "Sea Hag",
          "Shadow",
          "Shambling Mound",
          "Shield Guardian",
          "Shrieker",
          "Silver Dragon Wyrmling",
          "Skeleton",
          "Solar",
          "Specter",
          "Sphinxes",
          "Spirit Naga",
          "Sprite",
          "Steam Mephit",
          "Stirge",
          "Stone Giant",
          "Stone Golem",
          "Storm Giant",
          "Succubus/Incubus",
          "Tarrasque",
          "Treant",
          "Triceratops",
          "Troll",
          "Tyrannosaurus Rex",
          "Unicorn",
          "Vampire",
          "Vampire Spawn",
          "Violet Fungus",
          "Vrock",
          "Warhorse Skeleton",
          "Water Elemental",
          "Werebear",
          "Wereboar",
          "Wererat",
          "Weretiger",
          "Werewolf",
          "White Dragon Wyrmling",
          "Wight",
          "Will-o'-Wisp",
          "Wraith",
          "Wyvern",
          "Xorn",
          "Young Black Dragon",
          "Young Blue Dragon",
          "Young Brass Dragon",
          "Young Bronze Dragon",
          "Young Copper Dragon",
          "Young Gold Dragon",
          "Young Green Dragon",
          "Young Red Dragon",
          "Young Silver Dragon",
          "Young White Dragon",
          "Zombie"
        ],
        "name": {
          "first_name": [
            "Aeliana",
            "Alaric",
            "Aldric",
            "Alessia",
            "Alistair",
            "Althea",
            "Amonar",
            "Andros",
            "Anya",
            "Aria",
            "Ariadne",
            "Ariella",
            "Azarion",
            "Baelgor",
            "Baelin",
            "Belmorn",
            "Brondar",
            "Caelum",
            "Calista",
            "Cassandra",
            "Celestia",
            "Celestine",
            "Corvus",
            "Delara",
            "Drakon",
            "Drust",
            "Eamon",
            "Eilonwy",
            "Elara",
            "Eldric",
            "Elowen",
            "Elyria",
            "Emeric",
            "Faelina",
            "Fionna",
            "Freya",
            "Galen",
            "Garrick",
            "Gavric",
            "Gideon",
            "Gruffudd",
            "Illiana",
            "Isolde",
            "Kael",
            "Kael'thas",
            "Kaela",
            "Kaelis",
            "Kaldris",
            "Kethric",
            "Kyros",
            "Leilani",
            "Liora",
            "Lorimar",
            "Lucius",
            "Lysandra",
            "Lysara",
            "Maelis",
            "Magnus",
            "Marik",
            "Melisandra",
            "Nymeria",
            "Nymira",
            "Oriana",
            "Orianna",
            "Osric",
            "Ragnor",
            "Rendal",
            "Rhovaniel",
            "Rurik",
            "Selene",
            "Seraphina",
            "Seraphine",
            "Seren",
            "Sylvaria",
            "Taryn",
            "Thalia",
            "Thane",
            "Tharivol",
            "Thorgrim",
            "Throrin",
            "Tordek",
            "Torvald",
            "Uldar",
            "Ulfgar",
            "Valthor",
            "Vespera",
            "Xander",
            "Xanthe",
            "Ygritte",
            "Yondalla",
            "Zara",
            "Zarathos",
            "Zephyra",
            "Zoltan"
          ],
          "last_name": [
            "Axebreaker",
            "Blackthorn",
            "Brightsong",
            "Dawnbringer",
            "Dreamweaver",
            "Earthshaker",
            "Fireheart",
            "Ironfoot",
            "Ironheart",
            "Leafwhisper",
            "Lightbringer",
            "Lightfoot",
            "Mistwalker",
            "Moonfall",
            "Moonshadow",
            "Moonsong",
            "Moonwhisper",
            "Nightbreeze",
            "Nightshade",
            "Nightstalker",
            "Ravenscar",
            "Ravenshadow",
            "Shadowbane",
            "Shadowdancer",
            "Silverhand",
            "Silverveil",
            "Starborn",
            "Starweaver",
            "Starwhisper",
            "Stonewarden",
            "Stormborn",
            "Stormbringer",
            "Stormcloak",
            "Stormrider",
            "Sunweaver",
            "Swiftwind",
            "Wildheart",
            "Willowbrook",
            "Winddancer"
          ],
          "title": [
            "the Arcane",
            "the Bard",
            "the Beautiful",
            "the Bold",
            "the Brave",
            "the Clever",
            "the Cunning",
            "the Defender",
            "the Dreamer",
            "the Elegant",
            "the Enchanted",
            "the Enchanter",
            "the Enchantress",
            "the Fair",
            "the Fearless",
            "the Fierce",
            "the Gentle",
            "the Graceful",
            "the Healer",
            "the Huntress",
            "the Illusionist",
            "the Just",
            "the Kind",
            "the Loyal",
            "the Mighty",
            "the Moonlit",
            "the Poet",
            "the Protector",
            "the Radiant",
            "the Relentless",
            "the Resolute",
            "the Scribe",
            "the Seeker",
            "the Silent",
            "the Slayer",
            "the Stalwart",
            "the Stoic",
            "the Strong",
            "the Swift",
            "the Unbreakable",
            "the Unbroken",
            "the Unconquered",
            "the Unseen",
            "the Unyielding",
            "the Vindicator",
            "the Wanderer",
            "the Wild",
            "the Wise"
          ]
        },
        "races": [
          "Aarakocra",
          "Aasimar",
          "Bugbear",
          "Centaur",
          "Changeling",
          "Dragonborn",
          "Dwarf",
          "Elf",
          "Firbolg",
          "Genasi",
          "Gith",
          "Gnome",
          "Goblin",
          "Goliath",
          "Grung",
          "Half-Elf",
          "Half-Orc",
          "Halfling",
          "Hobgoblin",
          "Human",
          "Kalashtar",
          "Kenku",
          "Kobold",
          "Lizardfolk",
          "Locathah",
          "Loxodon",
          "Minotaur",
          "Orc",
          "Shifter",
          "Simic Hybrid",
          "Tabaxi",
          "Tiefling",
          "Tortle",
          "Triton",
          "Vedalken",
          "Verdan",
          "Warforged",
          "Yuan-Ti"
        ],
        "ranged_weapons": [
          "Blowgun",
          "Boomerang",
          "Crossbow",
          "Dart",
          "Longbow",
          "Net",
          "Shortbow",
          "Sling"
        ]
      },
      "doraemon": {
        "characters": [
          "Doraemon",
          "Nobita Nobi",
          "Doraemi",
          "Shizuka Minamoto",
          "Nobisuke Nobi",
          "Tamako Nobi",
          "Nobirou Nobi",
          "Goro Nobi",
          "Nobie Nobi",
          "Tamao Kataoka",
          "Nobiru Nobi",
          "Nobita's Grandmother",
          "Nobikichi Nobi",
          "Mr. Kataoka",
          "Mrs. Kataoka",
          "Nobizaemon Nobi",
          "Nobisaku Nobi",
          "Nobisuke's son",
          "Sewashi's father",
          "Sewashi Nobi",
          "Sewashi's cousin",
          "Shizuka Minamoto",
          "Shizuka-chan",
          "Yoshio Minamoto",
          "Mrs. Minamoto",
          "Kazu",
          "Shizunadahime",
          "Shizu",
          "Takeshi Goda Gian",
          "Takeshi's wife",
          "Jaiko Goda",
          "Mr. Goda",
          "Sasuke Goda",
          "Gian's uncle",
          "Gian's aunt",
          "Takezuchi",
          "Jaizou",
          "Yasashiku Gouda",
          "Suneo Honekawa",
          "Sunetsugu Honekawa",
          "Mr. Honekawa",
          "Mrs. Honekawa",
          "Suneo's uncle",
          "Suneo's aunt",
          "Suneo's great-grandmother",
          "Suneo Nomikoto",
          "Sunemaru",
          "Suneki Honekawa"
        ],
        "gadgets": [
          "Doraemon Tool Catalog",
          "Here It Is! Digging Wire",
          "That Person's' Living Room",
          "Wanna Give Tie",
          "22nd-Century Piggy Banks",
          "3D Album (gadget)",
          "3D Copier Camera",
          "4D Pocket",
          "Abekobe Cream",
          "Abekonbe",
          "Absconding Leaf",
          "Absconding Scroll",
          "Absorption Paper (gadget)",
          "Ace Cap",
          "Action Cards",
          "Adventure Tea",
          "Age Gauge",
          "Age-Changing Pool Rope (gadget)",
          "Aibou (gadget)",
          "Air Cannon",
          "Air Conditioning Photo",
          "Air Crayon",
          "Air Pistol (gadget)",
          "Aladdin's Lamp",
          "Alarm Set",
          "All Seasons Badge",
          "All-Purpose Opener: Open Sesame Seeds",
          "Almighty Pass",
          "Alter Ego Mirage",
          "Amazing AI Robot Monkey (gadget)",
          "Animal Light",
          "Animal Transformation Biscuits",
          "Animal Transformation Egg",
          "Animal Transformation Stick",
          "Anime Box (gadget)",
          "Anniversary Sticker (gadget)",
          "Anticipating Promise Machine",
          "Any-Maker",
          "Anyday Calendar",
          "Anything Controller",
          "Anything Ice Cream Stick",
          "Anything Reform Set",
          "Anything Steering Wheel",
          "Anywhere Cannon",
          "Anywhere Door",
          "Anywhere Hole",
          "Anywhere Tap",
          "Anywhere Ticket",
          "Anywhere Window",
          "Apartment Pretend Tree",
          "Appointment Memo Pad",
          "Arrangements Ant",
          "Assorted Monsters",
          "Ataru Gun (gadget)",
          "Athletic House",
          "Athletic House Outdoor Version",
          "Automatic Climbing Device",
          "Automatic Scratching Device",
          "Automatic Talking Device",
          "Automatic Walking Device",
          "Back-To-The-Beginning Dice",
          "Badge Making Camera",
          "Balancing Needle",
          "Ballot Dog",
          "Bambooshoot-copter",
          "Banana Leaf Fan",
          "Bartering Machine",
          "Become a Police-Thief Set",
          "Bestfriend Telecard",
          "Big Light",
          "Bird Caps",
          "Bird Whistle",
          "Black Belt",
          "Black Pepper",
          "Blind Spot Stars",
          "Body Part Swapping Machine",
          "Body Pump",
          "Bomb of Mass Destruction",
          "Boxing Gloves",
          "Boygirl",
          "Bug Hero Belt",
          "Bug Off",
          "Bunny Ears",
          "Butterfly Letters (gadget)",
          "Bypass Spyglass",
          "Category:Camera-type gadgets",
          "Cancellation Eraser",
          "Catch Glove",
          "Chair Improver (gadget)",
          "Champion Gloves",
          "Cheerleader Gloves",
          "Cipher Decoding Machine",
          "Cluefinder",
          "Coagulation Light (gadget)",
          "Coalescence Glue",
          "Cockroach Hat",
          "Cold Transferer",
          "Come Come Cat Food (gadget)",
          "Come Come Mark",
          "Come-Come Cat",
          "Comedy Rock (gadget)",
          "Command Gun (Gadget)",
          "Compact 2-D Camera",
          "Compaction Cloud Gas",
          "Comparison TV",
          "Computer Pencil (Gadget)",
          "Concentrated Food",
          "Concentration Soap Helmet",
          "Confidence Eliminator",
          "Confidence Helmet",
          "Constellation Legend Simulator",
          "Cooking Badges",
          "Copy Robot",
          "Copying Toast",
          "Cotton Candy Cloud Maker",
          "Craftsman Robot",
          "Cretaceous Tour Capsule",
          "Cross Switch (gadget)",
          "Crude-But-Charming Spray",
          "Dairi Gum (Gadget)",
          "Dandelion Fuzz Comb",
          "Danger Bomb",
          "Category:Dangerous Gadgets",
          "Daydream Disc",
          "Decoy Robot",
          "Deep Sea Cream",
          "Deformation Light",
          "Delay Camera",
          "Delivery Racket",
          "Deluxe Light (gadget)",
          "Deluxe Train Set",
          "Denkomaru",
          "Design Sketchbook and 3D Projector",
          "Designing Machine",
          "Devil Card",
          "Dictator Switch",
          "Director Burger",
          "Disaster Preparedness Device",
          "Disintegration Knife",
          "Dividing Blade",
          "Doctor's Kit",
          "Doraemon's Mom",
          "Dracula Set",
          "Dream Controller",
          "Dream Director's Chair",
          "Dream Glasses",
          "Dream Ladder",
          "Dream Player",
          "Dream Radar",
          "Dream Smoke",
          "Dream Stairs",
          "Dream TV",
          "Dream Walker (gadget)",
          "Dream Wind Chime (Gadget)",
          "Dress-Up Camera (gadget)",
          "Dried Ghost",
          "Drunken Lid (Gadget)",
          "Dry Light",
          "E.S.P Training Box",
          "Earth Creation Kit",
          "Earth Elevator (gadget)",
          "Echo Lacquer",
          "Echo Lacquer Remover",
          "Elder Tree Seed",
          "Elephant Trunk Lipstick",
          "Elevator Plate (gadget)",
          "Emotion Energy Cylinder",
          "Enclosed Space Searching Machine",
          "Endangered Animal Spray",
          "Energy Valve",
          "Equality Missile",
          "Esper Hat",
          "Essence Parts",
          "Event Balloon (gadget)",
          "Evolution-Degeneration Beam",
          "Explosion Pepper",
          "Explosive Bomb Sticker",
          "Expression Controller",
          "Face-Doodling Pen",
          "Family Box",
          "Fan To Change One's Mind",
          "Fanta Glasses",
          "Fart Rocket",
          "Fashion Virus",
          "Fast and Slow Pills",
          "Favorite Drink",
          "Fear Transferring Baton",
          "Fear-Creation Machine",
          "Festival Fan",
          "Fighter Suit",
          "Fish Go-Go Gate",
          "Fishing Pond for Things You Dropped",
          "Flashbang",
          "Flattening Iron",
          "Flattering Lipstick"
        ],
        "locations": [
          "Africa",
          "Another Earth",
          "Bauwanko",
          "Birdpia",
          "Dekisugis' Residence",
          "Dekisugis Residence",
          "DG Robot Factory",
          "Easter Island",
          "Fujiko · F · Fujio Museumplein",
          "Godas' Residence",
          "Honekawas' Residence",
          "Hyouga Hyouga Star",
          "Island of Miracles",
          "Kaminari's House",
          "Koyakoya",
          "Matsushiba Robot Factory",
          "Minamotos' Residence",
          "Mountain",
          "Mountain of Flames",
          "Nobis' Residence",
          "Nobita and Shizuka's mansion",
          "Open Lot",
          "Parallel Planet location",
          "Pirika Star",
          "Planet Galapa",
          "Rainbow Valley",
          "Robot Academy",
          "School",
          "Secret Gadget Museum",
          "Sewashi's House",
          "Super Gians",
          "Supermarket",
          "Time Tunnel",
          "Tokyo",
          "Tomos Island"
        ]
      },
      "dr_who": {
        "actors": [
          "William Hartnell",
          "Patrick Troughton",
          "Jon Pertwee",
          "Tom Baker",
          "Peter Davison",
          "Colin Baker",
          "Sylvester McCoy",
          "Paul McGann",
          "Christopher Eccleston",
          "David Tennant",
          "Matt Smith",
          "Peter Capaldi",
          "Jodie Whittaker"
        ],
        "catch_phrases": [
          "Fantastic!",
          "I’m sorry. I’m so sorry.",
          "Bow ties are cool.",
          "Mmm I wonder ... Aha!",
          "Brave heart, Tegan.",
          "Would you care for a jelly baby?",
          "Reverse the polarity of the neutron flow.",
          "Somewhere there’s danger, somewhere there’s injustice, somewhere else, the tea’s getting cold.",
          "When I say run, run. (pause) RUN!",
          "Mm? What’s that, my boy?",
          "Allons-y!"
        ],
        "character": [
          "Dr. Who",
          "The Doctor",
          "Tardis",
          "Rose Tyler",
          "Adam Mitchell",
          "Mickey Smith",
          "Donna Noble",
          "Martha Jones",
          "Captain Jack Harkness",
          "Astrid Peth",
          "Sarah Jane Smith",
          "Jackson Lake",
          "Lady Christina de Souza",
          "Adelaide Brooke",
          "Wilfred Mott",
          "Amy Pond"
        ],
        "quotes": [
          "Lots of planets have a north!",
          "This is my timey-wimey detector. It goes 'ding' when there's stuff.",
          "Bananas are good.",
          "I wear a fez now. Fezzes are cool.",
          "Can you hold? I have to eat a biscuit.",
          "If we're gonna die, let's die looking like a Peruvian folk band.",
          "You want weapons? We're in a library! Books! The best weapons in the world!",
          "Come on, Rory! It isn't rocket science, it's just quantum physics!",
          "We're all stories in the end. Just make it a good one, eh?",
          "Big flashy things have my name written all over them. Well... not yet, give me time and a crayon.",
          "You don't want to take over the universe. You wouldn't know what to do with it beyond shout at it.",
          "A straight line may be the shortest distance between two points, but it is by no means the most interesting.",
          "See the bowtie? I wear it and I don't care. That's why it's cool.",
          "I saw the Fall of Troy! World War Five! I was pushing boxes at the Boston Tea Party! Now I'm gonna die in a dungeon... in Cardiff!",
          "Bunk beds are cool, a bed with a ladder, you can't beat that!",
          "The universe is big. It’s vast and complicated and ridiculous. And sometimes, very rarely, impossible things just happen and we call them miracles.",
          "Do what I do. Hold tight and pretend it’s a plan!",
          "900 years of time and space, and I’ve never been slapped by someone’s mother.",
          "Never ignore coincidence. Unless, of course, you’re busy. In which case, always ignore coincidence.",
          "The assembled hordes of Genghis Khan couldn't get through that door, and, believe me, they've tried.",
          "Your wish is my command. But be careful what you wish for.",
          "Aw, I wanted to be ginger! I've never been ginger!",
          "Crossing into established events is strictly forbidden. Except for cheap tricks."
        ],
        "species": [
          "Time Lord",
          "Dalek",
          "Thal",
          "Dal",
          "Voord",
          "Sensorite",
          "Slyther",
          "Didonian",
          "Sand Beast",
          "Animus",
          "Zarbi",
          "Larvae Gun",
          "Menoptra",
          "Morok",
          "Xeron",
          "Aridian",
          "Mire Beast",
          "Gubbage Cone",
          "Rill",
          "Great Old One",
          "Drahvin",
          "Varga Plant",
          "Representatives of the 7 Galaxies",
          "Visian",
          "Screamer",
          "Monoid",
          "Refusian",
          "Celestial Toymaker",
          "Elder",
          "Cybermen (Mondas)",
          "Fish People",
          "Macra",
          "Chameleon",
          "Cybermat",
          "The Moon",
          "Great Intelligence",
          "Ice Warrior",
          "Seaweed Creature",
          "Dominator",
          "Dulcian",
          "Master Brain",
          "Land of Fiction beings",
          "Kroton",
          "Gond",
          "Seed Pod",
          "Auton",
          "Nestene Consciousness",
          "Silurian",
          "Ambassadors",
          "Primord",
          "Keller Machine",
          "Axos/Axon/Axonite",
          "Uxariean",
          "Dæmon",
          "Ogron",
          "Arcturan",
          "Alpha Centauran",
          "Aggedor",
          "Peladonian",
          "Sea Devil",
          "Solonian",
          "Chronovore",
          "Minotaur",
          "Anti-matter organism",
          "Lurman",
          "Drashig",
          "Inter Minorian",
          "Wallarian",
          "Draconian",
          "Spiridon",
          "Giant Maggots",
          "Sontaran",
          "Dinosaur",
          "Exxilon",
          "Eight Legs",
          "Wirrn",
          "Kaled",
          "Vogan",
          "Zygon",
          "Skarasen",
          "Morestran",
          "Sutekh",
          "Osiran",
          "Kraal",
          "Sisterhood of Karn",
          "Hoothi",
          "Krynoid",
          "Mandragora Helix",
          "Kastrian",
          "Giant Rat",
          "Rutan",
          "Swarm (Virus)",
          "Fendahl",
          "Usurian",
          "Minyan",
          "Vardan",
          "Guardian",
          "Ribosian",
          "Levithian",
          "Shrivenzale",
          "Zanak Humanoid",
          "Diplosian",
          "Ogri",
          "Megara",
          "Taran",
          "Taran Beast",
          "Swampie",
          "Kroll",
          "The Shadow",
          "Mute",
          "Sirian",
          "Jagaroth",
          "Chloris Humanoid",
          "Tythonian",
          "Wolfweed",
          "Mandrel",
          "Skonnan",
          "Nimon",
          "Anethan",
          "Crinothian",
          "Drornidian",
          "Krarg",
          "Argolin",
          "Foamasi",
          "Tigellan",
          "Zolfa-Thuran",
          "Gaztak",
          "Bell Plant",
          "Alzarian",
          "Marshman",
          "Marshspider",
          "Great Vampire",
          "Tharil",
          "Trakenite",
          "Logopolitan",
          "Castrovalvan",
          "Urbankan",
          "Mara",
          "Kinda",
          "Terileptil",
          "Plasmaton",
          "Xeraphin",
          "The Ergon",
          "Manussan",
          "Trion",
          "Garm",
          "Eternal",
          "Myrka",
          "Malus",
          "Tractator",
          "Magma Beast",
          "Queen Bat",
          "Gastropod",
          "Jadondan",
          "Cryon",
          "Mentor",
          "Gee-Jee fly",
          "Androgum",
          "Karfelon",
          "Morlox",
          "Bandril",
          "Andromedan",
          "Thoros Alphan",
          "Krontep",
          "Posicarian",
          "Raak",
          "Vervoid",
          "Mogarian",
          "Lakertyan",
          "Tetrap",
          "Time Brain",
          "Chimeron",
          "Navarino",
          "Bannermen",
          "Proamonian",
          "Dragon",
          "Stigorax",
          "Pipe Person",
          "Validium",
          "Gods of Ragnorak",
          "Werewolf",
          "The Destroyer",
          "Light",
          "Fenric",
          "Haemovore",
          "Cheetah People",
          "Kitling",
          "Deathworm Morphant",
          "Lady Cassandra O'Brien.∆17",
          "Boekind",
          "Crespallion",
          "Trees of Cheem",
          "Pakoo",
          "Balhoonian",
          "New Human",
          "Protohuman",
          "Digihuman",
          "Gelth",
          "Raxacoricofallapatorian",
          "Space Pig",
          "Jagrafess",
          "Reaper",
          "Empty Child",
          "Nanogene",
          "Chula",
          "Barcelonian Dogs",
          "Sycorax",
          "Graske",
          "Catkind",
          "New Human",
          "Krillitane",
          "Cyberman (Pete's World)",
          "The Wire",
          "The Beast",
          "Ood",
          "Pallushi",
          "Hoix",
          "Abzorbaloff",
          "Isolus",
          "Flying Stingray",
          "Weevil",
          "Sex Gas",
          "Fairy",
          "Arcateenian",
          "Racnoss",
          "Dogon",
          "Abaddon",
          "Bane",
          "Xylok",
          "Judoon",
          "Plasmavore",
          "Carrionite",
          "Pig Slave",
          "Dalek/Human Hybrid",
          "Richard Lazarus",
          "Torajii Sun",
          "Family of Blood",
          "Scarecrow",
          "Weeping Angel",
          "Futurekind",
          "Malmooth",
          "Toclafane",
          "Gorgon",
          "Uvodni",
          "The Trickster",
          "Verron",
          "Sto Humanoid",
          "Zocci",
          "Blowfish",
          "Cell 114",
          "Cash Cow",
          "Mayfly",
          "Duroc",
          "Nostrovite",
          "Night Travellers",
          "Tumor Alien",
          "Cowled Ghost",
          "Adipose",
          "Pyrovile",
          "Ood Brain",
          "Hath",
          "Vespiform",
          "Vashta Nerada",
          "Time Beetle",
          "Shadow Proclamation Humanoids",
          "Bees (Melissa Majoria)",
          "Pied Piper",
          "Ancient Lights",
          "Berserker",
          "Travist Polong",
          "Cybershade",
          "The Swarm",
          "Tritovore",
          "Hitchhiker",
          "The 4-5-6",
          "Veil",
          "Eve",
          "Jixen",
          "Erasmus Darkening",
          "International Gallery Paintings",
          "The Flood",
          "Vinvocci",
          "Dauntless Prison Inmates",
          "Korven",
          "Fear Entity",
          "Gryffen Family Ghosts",
          "Bodach",
          "Anubian",
          "Oroborus",
          "Mede",
          "Multi-form",
          "Atraxi",
          "Aeolian",
          "Star Whale",
          "Winder",
          "Centuripede",
          "The Hunger",
          "Aplan",
          "Ukkan",
          "Saturnyn",
          "Psychic Pollen",
          "Eknodine",
          "Etydion",
          "Krafayis",
          "Vishklar",
          "Shansheeth",
          "Groske",
          "Qetesh",
          "Dark Hoarde",
          "Chelonian",
          "Haemogoth",
          "Sky Fish",
          "The Silence",
          "Siren",
          "Patchwork Person",
          "Ganger",
          "Headless Monk",
          "Brain Parasite",
          "Tenza",
          "Peg Doll",
          "The Blessing Messenger",
          "Apalapucian",
          "The Blessing",
          "Tivolian",
          "Minotaur",
          "Metalkind",
          "Fleshkind",
          "Hetocumtek",
          "Skullion",
          "Androzani Tree",
          "Dalek Puppet",
          "Kahler",
          "Orderly",
          "Shakri",
          "Memory Worm",
          "Snowmen",
          "Akhaten Humanoid",
          "Pan-Babylonian",
          "Lugal-Irra-Kush",
          "Lucanian",
          "Hooloovoo",
          "Terraberserker",
          "Ultramancer",
          "Vigil",
          "Crooked Person",
          "Time Zombie",
          "Mr. Sweet",
          "Cybermite",
          "Whisper Men",
          "The Teller",
          "Skovox Blitzer",
          "Spider Germ",
          "The Foretold",
          "Boneless",
          "Kantrofarri",
          "The Fisher King",
          "The Mire",
          "Leonian",
          "The Sandmen",
          "Janus",
          "Quantum Shade",
          "The Veil",
          "Hydroflax",
          "Shoal of the Winter Harmony",
          "Rhodian",
          "Quill",
          "Shadow Kin",
          "Arn",
          "Lothan",
          "Leaf Dragon",
          "Lankin",
          "Killer petals",
          "Lorr",
          "Sentient oil",
          "Vardy",
          "Sea Creature",
          "Lure Fish",
          "Dryad",
          "The Monks"
        ],
        "the_doctors": [
          "First Doctor",
          "Second Doctor",
          "Third Doctor",
          "Fourth Doctor",
          "Fifth Doctor",
          "Sixth Doctor",
          "Seventh Doctor",
          "Eighth Doctor",
          "Ninth Doctor",
          "Tenth Doctor",
          "Eleventh Doctor",
          "Twelfth Doctor",
          "Thirteenth Doctor"
        ],
        "villains": [
          "Helen A",
          "Abzorbaloff",
          "Animus",
          "The Master",
          "Davros",
          "Dalek Emperor"
        ]
      },
      "dragon_ball": {
        "characters": [
          "Goku",
          "Bulma",
          "Kami",
          "Yamcha",
          "Krillin",
          "Tien",
          "Piccolo",
          "Gohan",
          "Vegeta",
          "Kid Trunks",
          "Goten",
          "Future Trunks",
          "Pan",
          "Android 18",
          "Android 16",
          "Android 17",
          "Android 19",
          "Android 20",
          "Beerus",
          "Chaozu",
          "Chi-Chi",
          "Launch",
          "Mr. Satan",
          "Oolong",
          "Puar",
          "Videl",
          "Whis",
          "Yajirobe",
          "Demon King Piccolo",
          "Freeza",
          "Cell",
          "Majin Buu",
          "Goku Black",
          "Zamasu",
          "Baba",
          "Bra",
          "Bardock",
          "Champa",
          "Dende",
          "Dr. Gero",
          "Captain Ginyu",
          "Grandpa Gohan",
          "Jaco",
          "King Kai",
          "Supreme Kai",
          "Elder Kai",
          "Mr. Popo",
          "Nappa",
          "Uub",
          "Pilaf",
          "Raditz",
          "Shenron",
          "Vados",
          "Zarbon",
          "Broly",
          "Cooler",
          "King Cold",
          "Garlic Jr",
          "King Vegeta",
          "Nail",
          "Guru",
          "Hit",
          "Super Saiyan Goku",
          "Super Saiyan 2 Goku",
          "Super Saiyan 3 Goku",
          "Super Saiyan Vegeta",
          "Super Saiyan 2 Vegeta",
          "Majin Vegeta",
          "Super Saiyan Gohan",
          "Super Saiyan 2 Gohan",
          "Super Saiyan Goten",
          "Super Saiyan Trunks",
          "Vegito",
          "Gogeta",
          "Super Saiyan Blue Goku",
          "Super Saiyan Blue Vegeta",
          "Mystic Gohan",
          "Caulifla",
          "Baby",
          "Shenlong",
          "Ryan Shenlong",
          "Uh Shenlong",
          "Ryuu Shenlong",
          "Chi Shenlong",
          "Su Shenlong",
          "San Shenlong",
          "Li Shenlong"
        ],
        "planets": [
          "Alpha",
          "Arcose",
          "Arlia",
          "Babari",
          "Bas",
          "Big Gete Star",
          "Banna",
          "Beehay",
          "Beenz",
          "Chaos Area",
          "Cooler #6",
          "Cooler #98",
          "Cooler #256",
          "Core Area",
          "Cretaceous",
          "Daldon",
          "Dark Star",
          "Dorakiya",
          "Earth",
          "Eros",
          "Fake Namek",
          "Frieza #17",
          "Frieza #79",
          "Frieza #448",
          "Gaspa",
          "Gelbo",
          "Heaven",
          "Hera",
          "Ikonda",
          "Imecka",
          "Jung",
          "Jupiter",
          "Kaishin",
          "Kabocha",
          "Kanassa",
          "Konats",
          "Kuhn",
          "Litt",
          "Luud",
          "M-2",
          "Makyo Star",
          "Manu",
          "Mars",
          "Mayonnai",
          "Meat",
          "Metamor",
          "Mogina",
          "Monmaasu",
          "Monser",
          "Namchek",
          "Namchinno",
          "Name",
          "Namek",
          "Netfiss",
          "New Namek",
          "New Vegeta",
          "Nikochan",
          "Nutts",
          "Octo",
          "Outa",
          "Pital",
          "Polaris",
          "Popol",
          "DBS Potaufeu Screenshot 8",
          "Potaufeu",
          "Rudeeze",
          "Rygol 7",
          "Sacred World of the Kai",
          "Sadala",
          "Saute",
          "Shamo",
          "Shikk",
          "Slug",
          "Slum Area",
          "Snack",
          "Sweetz",
          "Synthesizer",
          "Tazba",
          "Tech-Tech",
          "Tigere",
          "Todokama",
          "Towale",
          "Tritek",
          "Vampa",
          "Vegeta",
          "Wagashi",
          "Watrin",
          "Yardrat",
          "Zoon",
          "Zorert"
        ],
        "races": [
          "Android",
          "Angel",
          "Core Person",
          "Demon",
          "Dragon",
          "Earthling",
          "Majin",
          "Namekian",
          "Saiyan",
          "Tuffle",
          "Arlian",
          "Arcosian",
          "Bas",
          "Beenz",
          "Bio-Man",
          "Bio-Warrior",
          "Dinosaur",
          "Fairy",
          "Fishman",
          "Fish Snake",
          "Gelboian",
          "Ghost",
          "Giant Fish",
          "Giras",
          "Glass Tribe",
          "Imeckian",
          "Jiang Shi",
          "Jiggler",
          "Kabochan",
          "Kanassan",
          "Kashvar",
          "Kawa",
          "Konatsian",
          "Litt",
          "Machine Mutant",
          "Makyan",
          "Martian",
          "Meatian",
          "Mermaid",
          "Metalman",
          "Metamoran",
          "Neko Majin",
          "Niko",
          "Octo",
          "Ogre",
          "Plantian",
          "Saibaman",
          "Shamoian",
          "Shirt",
          "Skeleton",
          "Snackian",
          "Space Lemur",
          "Sprite",
          "Tech-Tech",
          "Three-Eyed People",
          "Toadmen",
          "Tritekian",
          "Vampa Beast",
          "Vampa Beetle",
          "Vampire",
          "Wolf Person",
          "Yardrat",
          "Zombie"
        ]
      },
      "driving_licence": {
        "usa": {
          "alabama": [
            "######",
            "#######",
            "########"
          ],
          "alaska": [
            "#######",
            "######"
          ],
          "arizona": [
            "?########",
            "#########"
          ],
          "arkansas": [
            "########",
            "#########"
          ],
          "california": [
            "?#######"
          ],
          "colorado": [
            "#########",
            "?######",
            "??#####"
          ],
          "connecticut": [
            "#########"
          ],
          "delaware": [
            "######",
            "#######"
          ],
          "district_of_columbia": [
            "#######",
            "#########"
          ],
          "florida": [
            "?############"
          ],
          "georgia": [
            "#######",
            "########",
            "#########"
          ],
          "hawaii": [
            "?########",
            "#########"
          ],
          "idaho": [
            "??######",
            "?#########"
          ],
          "illinois": [
            "?###########",
            "?############"
          ],
          "indiana": [
            "?#########",
            "#########",
            "##########"
          ],
          "iowa": [
            "#########",
            "###??####"
          ],
          "kansas": [
            "?#?#?",
            "?########",
            "#########"
          ],
          "kentucky": [
            "?########",
            "?#########",
            "#########"
          ],
          "louisiana": [
            "########",
            "#########"
          ],
          "maine": [
            "#######",
            "#######?",
            "########"
          ],
          "maryland": [
            "?############"
          ],
          "massachusetts": [
            "?########",
            "#########"
          ],
          "michigan": [
            "?##########",
            "?############"
          ],
          "minnesota": [
            "?############"
          ],
          "mississippi": [
            "#########"
          ],
          "missouri": [
            "?#########",
            "?######R",
            "########??",
            "#########?",
            "#########"
          ],
          "montana": [
            "?########",
            "#########",
            "#############",
            "##############"
          ],
          "nebraska": [
            "?######",
            "?#######",
            "?########"
          ],
          "nevada": [
            "#########",
            "##########",
            "############",
            "X########"
          ],
          "new_hampshire": [
            "##???#####"
          ],
          "new_jersey": [
            "?##############"
          ],
          "new_mexico": [
            "########",
            "#########"
          ],
          "new_york": [
            "?#######",
            "?##################",
            "########",
            "##########",
            "################",
            "????????"
          ],
          "north_carolina": [
            "##########",
            "############"
          ],
          "north_dakota": [
            "???######",
            "#########"
          ],
          "ohio": [
            "?########",
            "??#######",
            "########"
          ],
          "oklahoma": [
            "?#########",
            "#########"
          ],
          "oregon": [
            "########",
            "#########"
          ],
          "pennsylvania": [
            "########"
          ],
          "rhode_island": [
            "#######",
            "?######"
          ],
          "south_carolina": [
            "########",
            "#########",
            "##########",
            "###########"
          ],
          "south_dakota": [
            "########",
            "#########",
            "##########",
            "############"
          ],
          "tennessee": [
            "#######",
            "########",
            "#########"
          ],
          "texas": [
            "#######",
            "########"
          ],
          "utah": [
            "#########",
            "##########"
          ],
          "vermont": [
            "########",
            "#######A"
          ],
          "virginia": [
            "?########",
            "?#########",
            "?##########",
            "?###########",
            "#########"
          ],
          "washington": [
            "???????#####",
            "????????####",
            "?????????###",
            "??????????##",
            "???????????#",
            "????????????",
            "???????####*"
          ],
          "west_virginia": [
            "#######",
            "?######",
            "??#####"
          ],
          "wisconsin": [
            "?#############"
          ],
          "wyoming": [
            "#########",
            "##########"
          ]
        }
      },
      "drone": {
        "battery_capacity": [
          "3### mAh",
          "2### mAh"
        ],
        "battery_type": [
          "LiPo 4S",
          "LiPo 3S",
          "Li-Polymer"
        ],
        "battery_voltage": "##.#V",
        "battery_weight": "### g",
        "charging_temperature": "##°-###°F",
        "flight_time": "## min",
        "iso": [
          "100-3200",
          "100-6400"
        ],
        "max_altitude": "#### m",
        "max_angular_velocity": "##°/s",
        "max_ascent_speed": "# m/s",
        "max_charging_power": "##W",
        "max_descent_speed": "# m/s",
        "max_flight_distance": "#### m",
        "max_resolution": "##MP",
        "max_shutter_speed": [
          "1",
          "2",
          "4",
          "8",
          "15",
          "30",
          "60"
        ],
        "max_speed": "## m/s",
        "max_tilt_angle": "##°",
        "max_wind_resistance": "##.# m/s",
        "min_shutter_speed": [
          "1/8000",
          "1/4000",
          "1/2000",
          "1/1000",
          "1/500",
          "1/250",
          "1/125",
          "1/60",
          "1/30",
          "1/15",
          "1/8",
          "1/4",
          "1/2"
        ],
        "name": [
          "DJI Mavic Air 2",
          "DJI Mavic Air",
          "DJI Mavic 2 Pro",
          "DJI Mavic Mini",
          "DJI Mavic Pro",
          "DJI Phantom 4 RTK",
          "DJI Phantom 4 Pro",
          "DJI Inspire 2",
          "DJI Matrice 300 RTK",
          "DJI Matrice 600 Pro",
          "DJI Agras T16",
          "Parrot ANAFI Thermal",
          "Yuneec H520 RTK",
          "Yuneec H520",
          "Yuneec Typhoon H3",
          "Yuneec Typhoon H Plus",
          "SenseFly eBee X",
          "SenseFly eBee SQ",
          "SenseFly eBee Plus",
          "SenseFly eBee Classic",
          "FreeFly Alta X",
          "FreeFly Alta Pro",
          "FreeFly Alta 8",
          "FlyAbility Elios 2",
          "FlyAbility Elios",
          "Autel Evo II Pro 6K",
          "Autel Evo II 8K",
          "Delair UX 11",
          "Delair UX AG",
          "Delair DT26E LiDAR",
          "Delair DT26E Surveillance",
          "Delair DT26E Tactical",
          "Delair DT26E Open Payload"
        ],
        "operating_temperature": "##°-###°F",
        "photo_format": [
          "JPEG",
          "PNG",
          "TIF"
        ],
        "shutter_speed_units": [
          "s"
        ],
        "video_format": [
          "MP4",
          "FLV",
          "MOV"
        ],
        "weight": "### g"
      },
      "dumb_and_dumber": {
        "actors": [
          "Jim Carrey",
          "Jeff Daniels",
          "Lauren Holly",
          "Mike Starr",
          "Karen Duffy",
          "Charles Rocket",
          "Victoria Rowell",
          "Cam Neely",
          "Rob Moran",
          "Harland Williams"
        ],
        "characters": [
          "Lloyd Christmas",
          "Harry Dunne",
          "Mary Swanson",
          "Joe Mentalino",
          "J.P. Shay",
          "Nicholas Andre",
          "Sea Bass"
        ],
        "quotes": [
          "Just when I thought you couldn't possibly be any dumber, you go and do something like this... and totally redeem yourself!",
          "Oh, yeah! It's right here. Samsonite! I was way off! I knew it started with an S, though.",
          "You're it. You're it. You're it, quitsies! Anti-quitsies, you're it, quitsies, no anti-quitsies, no startsies! You can't do that! Can too! Cannot, stamp it! Can too, double stamp it, no erasies! Cannot, triple stamp, no erasies, Touch blue make it true. No, you can't do that... you can't triple stamp a double stamp, you can't triple stamp a double stamp! Lloyd! LA LA LA LA LA LA!  LLOYD! LLOYD! LLOYD!",
          "We got no food, we got no jobs... our PETS' HEADS ARE FALLING OFF!",
          "Lloyd, I can't feel my fingers, they're numb! Oh well here, take this extra pair of gloves, my hands are starting to get a little sweaty. Extra gloves? You've had extra gloves this whole time? Uh yea, we are in the Rockies. Jeez!",
          "Harry: You sold my dead bird to a blind kid? Lloyd! Petey didn't even have a head! Harry, I took care of it...",
          "I got robbed by a sweet old lady on a motorized cart. I didn't even see it coming.",
          "WE LANDED ON THE MOON!",
          "I can't stop going once I've started, it stings!",
          "That's as good as money, sir. Those are I.O.U.'s. Go ahead and add it up, every cents accounted for. Look, see this? That's a car. 275 thou. Might wanna hang onto that one.",
          "Oh yeah. Tractor beam. Sucked me right in.",
          "G'day mate! Let's put another shrimp on the barbie!",
          "How was your day? Not bad. Fell off the jet way again.",
          "Nice set of hooters you got there! I beg your pardon? The owls! They're beautiful!",
          "I expected the Rocky Mountains to be a little rockier than this. I was thinking the same thing. That John Denver's full of shit, man.",
          "I'm going to hang by the bar... Put out the vibe.",
          "So you're telling me there's a chance... YEAH!",
          "One time, we successfully mated a bulldog with a Shih-Tzu. Really? That's weird. Yeah, we called it a bullshit.",
          "What if he shot me in the face?",
          "Kick his ass, Sea Bass!",
          "Harry, you're alive... and you're a horrible shot!",
          "Life is a fragile thing, Har. One minute you're chewin' on a burger, the next minute you're dead meat.",
          "So you got fired again eh? Oh yeah. They always freak out when you leave the scene of an accident.",
          "Man, you are one pathetic loser. No offense.",
          "There you go... There you go... There you go...",
          "Why would she have you meet her in a bar at ten in the morning? I just figured she was a raging alcoholic.",
          "I can't believe we drove around all day, and there's not a single job in this town. There is nothing, nada, zip! Yeah! Unless you wanna work forty hours a week.",
          "Yeah I called her up. She gave me a bunch of crap about me not listening to her, or something. I don't know, I wasn't really paying attention.",
          "I'll tell you where. Someplace warm. A place where the beer flows like wine. Where beautiful women instinctively flock like salmon of Capistrano. I'm talking about a little place called Aspen. Oh, I don't know, Lloyd. The French are assholes.",
          "Suck me sideways!",
          "Now we don't have enough money to get to Aspen, we don't have enough money to get home, we don't have enough money to eat, we don't have enough money to sleep!",
          "I'll bet you twenty bucks I can get you gambling before the end of the day!",
          "Hey guys. Woah, Big Gulps, huh? All right! Well, see ya later.",
          "You spilled the salt, that's what's the matter! Spilling the salt is very bad luck! We're driving across the country, the last thing we need is bad luck. Quick, toss some salt over your right shoulder.",
          "Look at the butt on that... Yeah, he must work out.",
          "Why you going to the airport? Flying somewhere?",
          "Hey look there's some people who want a ride too. Pick'em up!",
          "Pullover! No, it's a cardigan but thanks for noticing. Yeah, killer boots man!",
          "Skis, huh? That's right! Great! They yours? Uh-huh. Both of 'em? Yes. Cool!",
          "Yesterday was one of the greatest days of my life. Mary and I went skiing, we made a snowman, she touched my leg!",
          "Pills are goooood. Pills are goooood!",
          "Man, I would have to be a real lowlife to go rooting around in someone else's private property. Is it locked? Yeah. Really well.",
          "Hey, I guess they're right. Senior citizens, although slow and dangerous behind the wheel, can still serve a purpose. I'll be right back. Don't you go dying on me!",
          "The first time I set eyes on Mary Swanson, I just got that old fashioned romantic feeling where I'd do anything to bone her. That's a special feeling, Lloyd.",
          "Foot long! Who's got the foot long?",
          "Husband? Wait a minute... what was all that ‘one in a million' talk?",
          "How's your burger?",
          "Wanna hear the most annoying sound in the world?",
          "We don't usually pick up hitchhikers... but I'm-a gonna go with my instincts on this one. Saddle up partner!",
          "So I told myself. Beth you just got to run girl and oh you know what that clutz did next? No and I DON'T CARE! BarTENDER...",
          "You are in luck! There's a town about three miles that way. I'm sure you'll find a couple guys there. Okay, thanks. Do you realize what you've done?",
          "What is the Soup Du Jour? It's the Soup of the Day. Mmmm. That sounds good. I'll have that."
        ]
      },
      "dune": {
        "characters": [
          "Paul \"Muad'Dib\" \"Usul\" Atreides",
          "Jessica Atreides",
          "Alia Atreides",
          "Leto Atreides",
          "Leto II Atreides",
          "Duncan Idaho",
          "Shaddam Corrino IV",
          "Liet-Kynes",
          "Vladimir Harkonnen",
          "Irulan",
          "Feyd-Rautha Rabban",
          "Gaius Helen Mohiam",
          "Thufir Hawat",
          "Chani",
          "Shadout Mapes",
          "Ramallo",
          "Otheym",
          "Jamis",
          "Harrah",
          "Gurney Halleck",
          "Glossu \"Beast\" Rabban",
          "Piter De Vries",
          "Miles Teg",
          "Hasimir Fenring",
          "Margot Fenring",
          "Murbella",
          "Siona Atreides",
          "Scytale",
          "Stilgar",
          "Wellington Yueh",
          "Edric",
          "Ilban Richese",
          "Dominic Vernius",
          "Cammar Pilru",
          "Hwi Noree",
          "Nayla"
        ],
        "cities": [
          "Arrakeen",
          "Bandalong",
          "Barony",
          "Byzantium",
          "Cala City",
          "Carthag",
          "City of Introspection",
          "Comati",
          "Corrinth City",
          "Dar-es-Balat",
          "Elacca",
          "Giedi City",
          "Harko",
          "Niubbe",
          "Ritka",
          "Starda",
          "Thalidei",
          "Vernii",
          "Ysai",
          "Zimia"
        ],
        "planets": [
          "Arrakis",
          "Caladan",
          "Dune",
          "Geidi Prime",
          "Ix",
          "Selusa Secundus",
          "Kaitain",
          "Ecaz",
          "III Delta Kaising",
          "IV Anbus",
          "Al Dhanab",
          "Bela Tegeuse",
          "Buzzell",
          "Chapterhouse",
          "Chusuk",
          "Corrin",
          "Gamont",
          "Gansireed",
          "Gangishree",
          "Ginaz",
          "Grumman",
          "Hagal",
          "Harmonthep",
          "Ipyr",
          "Junction",
          "Kolhar",
          "Lampadas",
          "Lankiveil",
          "Lernaeus",
          "Muritan",
          "Naraj",
          "Palma",
          "Parmentier",
          "Poritrin",
          "Romo",
          "Rossak",
          "Sikun",
          "Synchrony",
          "Tleilax",
          "Tupile"
        ],
        "quotes": {
          "alia": [
            "The Guild... they're fighting me in the mental vaults. They're behind everything. They fear the one who will come, who will know more, who will see more. The Guild is behind everything. It's not finished yet. I'm not formed."
          ],
          "baron_harkonnen": [
            "He who controls the spice, controls the universe!",
            "I must have him dead and his line ended.",
            "I made my peace gesture. The forms of kanly have been obeyed!",
            "I won't tell you who the traitor is, or when we'll attack. However, the Duke will die before these eyes and he'll know, he'll know, that it is I, Baron Vladimir Harkonnen, who encompasses his doom!",
            "Listen carefully, Feyd. Observe the plans within plans within plans.",
            "The absence of a thing, this can be as deadly as the presence. The absence of air, eh? The absence of water? The absence of anything else we're addicted to.",
            "The day hums sweetly when you have enough bees working for you.",
            "My dear Piter, your pleasures are what tie you to me. How could I object to that?",
            "I never could bring myself to trust a traitor. Not even a traitor I created.",
            "One must always keep the tools of statecraft sharp and ready. Power and fear - sharp and ready.",
            "I will have Arrakis back for myself! He who controls the Spice controls the universe and what Piter did not tell you is we have control of someone who is very close, very close, to Duke Leto! This person, this traitor, will be worth more to us than ten legions of Sardaukar!"
          ],
          "duncan": [
            "My lord, I suspect an incredible secret has been kept on this planet: that the Fremen exist in vast numbers - vast. And it is they who control Arrakis.",
            "Use the first moments in study. You may miss an opportunity for quick victory this way, but the moments of study are insurance of success. Take your time and be sure.",
            "When your opponent fears you, then's the moment when you give the fear its own rein, give it the time to work on him. Let it become terror. The terrified man fights himself. Eventually, he attacks in desperation. That is the most dangerous moment, but the terrified man can be trusted usually to make a fatal mistake."
          ],
          "emperor": [
            "Bring in that floating fat man, the Baron!"
          ],
          "guild_navigator": [
            "The spice must flow",
            "The Bene Gesserit Witch must leave.",
            "Remedy this situation, restore spice production, or you will live out your life in a pain amplifier!",
            "I mean Paul Atreides. We want him killed. I did not say this. I am not here.",
            "Many machines on Ix. New machines, better than those on Richesse."
          ],
          "gurney": [
            "In shield fighting, one moves fast on defense, slow on attack. Attack has the sole purpose of tricking the opponent into a misstep, setting him up for the attack sinister. The shield turns the fast blow, admits the slow kindjal!",
            "Mood? What has mood to do with it? You fight when the necessity arises — no matter the mood! Mood's a thing for cattle or making love or playing the baliset. It's not for fighting.",
            "If wishes were fishes, we'd all cast nets.",
            "Behold as a wild ass in the desert go I forth to my work",
            "One enemy at a time."
          ],
          "irulan": [
            "A beginning is the time for taking the most delicate care that the balances are correct.",
            "To attempt an understanding of Muad'Dib without understanding his mortal enemies, the Harkonnens, is to attempt seeing Truth without knowing Falsehood. It is the attempt to see the Light without knowing Darkness. It cannot be."
          ],
          "jessica": [
            "And you, my son, are you one who gives or one who takes?",
            "A million deaths were not enough for Yueh!",
            "Motivating people, forcing them to your will, gives you a cynical attitude towards humanity. It degrades everything it touches.",
            "What delicious abandon in the sleep of the child. Where do we lose it?",
            "The young reed dies so easily. Beginnings are times of such peril.",
            "Anything outside yourself, this you can see and apply your logic to it. But it’s a human trait that when we encounter personal problems, these things most deeply personal are the most difficult to bring out for our logic to scan. We tend to flounder around, blaming everything but the actual, deep-seated thing that’s really chewing on us.",
            "Is it defeatist or treacherous for a doctor to diagnose a disease correctly? My only intention is to cure the disease.",
            "Think on it, Chani; the princess will have the name, yet she'll live as less than a concubine - never to know a moment of tenderness from the man to whom she's bound. While we, Chani, we who carry the name of concubine - history will call us wives."
          ],
          "leto": [
            "Let us not rail about justice as long as we have arms and the freedom to use them.",
            "Command must always look confident. All that faith riding on your shoulders while you sit in the critical seat and never show it.",
            "I must rule with eye and claw — as the hawk among lesser birds.",
            "Most of the Houses have grown fat by taking few risks. One cannot truly blame them for this; one can only despise them.",
            "A day comes when the potential Mentat must learn what's being done. It may no longer be done to him. The Mentat has to share in the choice of whether to continue or abandon the training.",
            "On Caladan, we ruled with sea and air power. Here, we must scrabble for desert power. This is your inheritance, Paul.",
            "A person needs new experiences. They jar something deep inside, allowing him to grow. Without change, something sleeps inside us, and seldom awakens. The sleeper must awaken."
          ],
          "liet_kynes": [
            "Growth is limited by that necessity which is present in the least amount. And, naturally, the least favorable condition controls the growth rate.",
            "A dead man, surely, no longer requires that water.",
            "He cares more about his men than the Spice. I have to admit, against my better judgement, I like this Duke.",
            "He shall know your ways as if born to them."
          ],
          "mapes": [
            "Before I do your bidding, manling, I must cleanse the way between us. You've put a water burden on me that I'm not sure I care to support. But we Fremen pay our debts"
          ],
          "mohiam": [
            "You've heard of animals chewing off a leg to escape a trap? There's an animal kind of trick. A human would remain in the trap, endure the pain, feigning death that he might kill the trapper and remove a threat to his kind.",
            "Hope clouds observation.",
            "A human can control his instincts. Your instinct will be to draw your hand out of the box. You do, you die.",
            "Kul Wahad! No woman-child ever withstood that much!",
            "Kill this child. She's an abomination. Kill her!",
            "Get out of my mind!",
            "But I can tell you, dear God, for the father, nothing.",
            "Did you really think that you could bear the Kwisatz Haderach? The universe's super being? How dare you. My greatest student, and my greatest disappointment.",
            "You, Paul Atreides, descendant of kings, son of a Duke, you must learn to rule. It's something none of your ancestors learned.",
            "Once men turned their thinking over to machines in the hope that this would set them free. But that only permitted other men with machines to enslave them.",
            "We look down so many avenues of the past... but only feminine avenues. Yet, there's a place where no Truthsayer can see. We are repelled by it, terrorized. It is said a man will come one day and find in the gift of the drug his inward eye. He will look where we cannot — into both feminine and masculine pasts.",
            "They tried and died.",
            "Shield your son too much, Jessica, and he'll not grow strong enough to fulfill any destiny.",
            "That which submits rules. ... The willow submits to the wind and prospers until one day it is many willows — a wall against the wind. This is the willow's purpose.",
            "The mystery of life isn't a problem to solve, but a reality to experience."
          ],
          "pardot_kynes": [
            "No more terrible disaster could befall your people than for them to fall into the hands of a Hero.",
            "The highest function of ecology is understanding consequences.",
            "Men and their works have been a disease on the surface of their planets before now. Nature tends to compensate for diseases, to remove or encapsulate them, to incorporate them into the system in her own way."
          ],
          "paul": [
            "They tried and failed, all of them?",
            "There is no escape — we pay for the violence of our ancestors.",
            "One of the most terrible moments in a boy's life ... is when he discovers his father and mother are human beings who share a love that he can never quite taste. It's a loss, an awakening to the fact that the world is there and here and we are in it alone. The moment carries its own truth; you can't evade it.",
            "The eye that looks ahead to the safe course is closed forever.",
            "The power to destroy a thing is the absolute control over it.",
            "Try looking into that place where you dare not look! You'll find me there, staring out at you!",
            "The sleeper has awakened!",
            "My name is a killing word.",
            "You dare suggest a Duke's son is an animal?",
            "You have no need for your weapons with me, Gurney Halleck.",
            "Carry this noble Atreides warrior away. Do him all honor.",
            "Some thoughts have a certain sound, that being the equivalent to a form. Through sound and motion, you will be able to paralyze nerves, shatter bones, set fires, suffocate an enemy or burst his organs. We will kill until no Harkonnen breathes Arakeen air.",
            "If I hear any more nonsense from either of you I'll give the order that'll destroy all spice production on Arrakis… forever.",
            "Superstitions sometimes have strange roots and stranger branchings"
          ],
          "piter": [
            "I knew Yueh's wife. I was the one who broke his Imperial conditioning. I've thought of many pleasures with you. It is perhaps better that you die in the innards of a worm. Desire clouds my reason. That is not good. That is bad.",
            "Vendetta, he says, using the ancient tongue. The art of kanly is still alive in the Universe. He does not wish to meet or speak with you."
          ],
          "stilgar": [
            "To save one from a mistake is a gift of paradise.",
            "Usul has called a big one. Again, it is the legend."
          ],
          "thufir": [
            "A popular man arouses the jealousy of the powerful.",
            "Parting with friends is a sadness. A place is only a place.",
            "It's easier to be terrified by an enemy you admire.",
            "“Knowing where the trap is—that's the first step in evading it.”",
            "Repression makes a religion flourish."
          ],
          "yueh": [
            "But attack can take strange forms. And you will remember the tooth. The tooth. Duke Leto Atreides. You will remember the tooth.",
            "Forgive me, my Lady! My thoughts were far away… I … did not mean to be familiar.",
            "Those are date palms. One date palm requires forty liters of water a day. A man requires but eight liters. A palm, then, equals five men. There are twenty palms out there—one hundred men."
          ]
        },
        "sayings": {
          "bene_gesserit": [
            "I must not fear. Fear is the mind-killer. Fear is the little-death that brings total obliteration. I will face my fear. I will permit it to pass over me and through me. And when it has gone past I will turn the inner eye to see its path. Where the fear has gone there will be nothing. Only I will remain.",
            "A world is supported by four things ... the learning of the wise, the justice of the great, the prayers of the righteous and the valor of the brave. But all of these are as nothing ... without a ruler who knows the art of ruling. Make that the science of your tradition!",
            "The mind can go either direction under stress — toward positive or toward negative: on or off. Think of it as a spectrum whose extremes are unconsciousness at the negative end and hyperconsciousness at the positive end. The way the mind will lean under stress is strongly influenced by training.",
            "Do not count a human dead until you’ve seen his body. And even then you can make a mistake.",
            "Humans must never submit to animals.",
            "To suspect your own mortality is to know the beginning of terror; to learn irrefutably that you are mortal is to know the end of terror.",
            "Survival is the ability to swim in strange water.",
            "Prophets have a way of dying by violence.",
            "Humans live best when each has his place to stand, when each knows where he belongs in the scheme of things and what he may achieve. Destroy the place and you destroy the person."
          ],
          "fremen": [
            "He shall know your ways as if born to them.",
            "May thy knife chip and shatter.",
            "The wise animal blends into its surroundings.",
            "Bless the Maker and all His Water. Bless the coming and going of Him, May His passing cleanse the world. May He keep the world for his people.",
            "Be prepared to appreciate what you meet.",
            "A stone is heavy and the sand is weighty; but a fools wrath is heavier than them both.",
            "Truth suffers from too much analysis.",
            "A man's flesh is his own; the water belongs to the tribe."
          ],
          "mentat": [
            "It is by will alone I set my mind in motion. It is by the juice of Sapho that thoughts acquire speed, the lips acquire stains. The stains become a warning.",
            "A process cannot be understood by stopping it. Understanding must move with the flow of the process, must join it and flow with it.",
            "Memory never recaptures reality. Memory reconstructs reality. Reconstructions change the original, becoming external frames of reference that inevitably fail."
          ],
          "muaddib": [
            "Arrakis teaches the attitude of the knife, chopping off what’s incomplete and saying, \"Now it’s complete because it’s ended here.\"",
            "Greatness is a transitory experience. It is never persistent. It depends in part upon the myth-making imagination of humankind. The person who experiences greatness must have a feeling for the myth he is in. He must reflect what is projected upon him. And he must have a strong sense of the sardonic. This is what uncouples him from belief in his own pretensions. The sardonic is all that permits him to move within himself. Without this quality, even occasional greatness will destroy a man.",
            "There is probably no more terrible instance of enlightenment than the one in which you discover your father is a man — with human flesh.",
            "What do you despise? By this you are truly known.",
            "God created Arrakis to train the faithful.",
            "You do not beg the sun for mercy.",
            "Fragmentation is the natural destiny of all power.",
            "I am the Kwisatz Haderach. That is reason enough.",
            "The eye that looks ahead to the safe course is closed forever.",
            "Deep in the human unconscious is a pervasive need for a logical universe that makes sense. But the real universe is always one step beyond logic.",
            "There exists no separation between gods and men: one blends softly casual into the other.",
            "There should be a science of discontent. People need hard times and oppression to develop psychic muscles."
          ],
          "orange_catholic_bible": [
            "Think you of the fact that a deaf person cannot hear. Then, what deafness may we not all possess? What senses do we lack that we cannot see and cannot hear another world all around us?",
            "When God hath ordained a creature to die in a particular place, He causeth that creature's wants to direct him to that place",
            "Thou shalt not make a machine in the likeness of a man's mind",
            "From water does all life begin.",
            "...and on the seventh day He rested.",
            "Thou shall not suffer a witch to live.",
            "The meek shall inherit the universe.",
            "Men, finding no answers to the sunnan [the ten thousand religious questions from the Shari-ah] now apply their own reasoning. All men seek to be enlightened. Religion is but the most ancient and honorable way in which men have striven to make sense out of God's universe. Scientists seek the lawfulness of events. It is the task of Religion to fit man into this lawfulness.",
            "When law and religious duty are one, your selfdom encloses the universe.",
            "Thou shalt not disfigure the soul.",
            "Religion often partakes of the myth of progress that shields us from the terrors of an uncertain future.",
            "The Universe is God's. It is one thing, a wholeness against which all separations may be identified. Transient life, even that self-aware and reasoning life which we call sentient, holds only fragile trusteeship on any portion of the wholeness.",
            "Much that was called religion has carried an unconscious attitude of hostility toward life. True religion must teach that life is filled with joys pleasing to the eye of God, that knowledge without action is empty. All men must see that the teaching of religion by rules and rote is largely a hoax. The proper teaching is recognized with ease. You can know it without fail because it awakens within you that sensation which tells you this is something you've always known.",
            "Paradise on my right, Hell on my left and the Angel of Death behind.",
            "Some Lies are easier to believe than the truth.",
            "Knowledge is pitiless.",
            "Fate and Hope only rarely speak the same language.",
            "Beware the seeds you sow and the crops you reap. Do not curse God for the punishment you inflict upon yourself."
          ]
        },
        "titles": [
          "Master of Assassins",
          "Judge of the Change",
          "Duke",
          "Lady",
          "Reverend Mother",
          "Sayyadina",
          "Padishah Emperor",
          "Earl",
          "Princess",
          "Prince",
          "Premier",
          "Baron",
          "Mentat",
          "Count",
          "Countess",
          "Viscount",
          "Master",
          "Doctor",
          "Imperial Planetologist",
          "Elder",
          "Face Dancer",
          "Envoy",
          "Guild Navigator",
          "Ambassador",
          "Fedaykin Commando",
          "Naib",
          "Fish Speaker",
          "Grand Patriarch"
        ]
      },
      "educator": {
        "campus": [
          "#{Educator.school_name} Campus"
        ],
        "course_name": [
          "#{subject} #{Educator.tertiary.degree.course_number}"
        ],
        "degree": [
          "#{Educator.tertiary.degree.type} #{subject}"
        ],
        "primary": [
          "Elementary School",
          "Grade School",
          "Primary School"
        ],
        "primary_school": [
          "#{school_name} #{primary}"
        ],
        "school_name": [
          "Bluemeadow",
          "Brighthurst",
          "Brookville",
          "Clearcourt",
          "Falconholt",
          "Flowerlake",
          "Iceborough",
          "Icelyn",
          "Ironbarrow",
          "Ironston",
          "Lakeacre",
          "Mallowpond",
          "Mallowtown",
          "Marblewald",
          "Ostbarrow",
          "Vertapple"
        ],
        "secondary": [
          "High",
          "High School",
          "Secondary College"
        ],
        "secondary_school": [
          "#{Educator.school_name} #{secondary}"
        ],
        "subject": [
          "Applied Science (Psychology)",
          "Architectural Technology",
          "Arts",
          "Biological Science",
          "Biomedical Science",
          "Business",
          "Commerce",
          "Communications",
          "Computer Science",
          "Creative Arts",
          "Criminology",
          "Design",
          "Education",
          "Engineering",
          "Forensic Science",
          "Health Science",
          "Information Systems",
          "Law",
          "Medicine",
          "Nursing",
          "Psychology",
          "Teaching"
        ],
        "tertiary": {
          "degree": {
            "course_number": [
              "1##",
              "2##",
              "3##",
              "4##",
              "5##"
            ],
            "type": [
              "Associate Degree in",
              "Bachelor of",
              "Master of"
            ]
          },
          "university_type": [
            "College",
            "TAFE",
            "Technical College",
            "University"
          ]
        },
        "university": [
          "#{Educator.school_name} #{Educator.tertiary.university_type}"
        ]
      },
      "electrical_components": {
        "active": [
          "Diode",
          "LED",
          "Rectifier",
          "Transistor",
          "JFET",
          "MOSFET",
          "Integrated Circuit",
          "LCD",
          "Cathode Ray Tube",
          "Vacuum Tube",
          "Battery",
          "Fuel Cell",
          "Power Supply"
        ],
        "electromechanical": [
          "Piezoelectric device",
          "crystal",
          "Ultrasonic Motor",
          "Terminal",
          "Socket",
          "Power Cord",
          "Toggle Switch",
          "Slide Switch",
          "DIP Switch",
          "Footswitch",
          "Keypad",
          "Circuit Breaker",
          "Fuse",
          "Printed Circuit Board"
        ],
        "passive": [
          "Resistor",
          "Potentiometer",
          "Trim Pot",
          "Varistor",
          "Capacitor",
          "Varicap Diode",
          "Inductor",
          "Transformer",
          "Generator",
          "Motor",
          "Solenoid",
          "Magnetic Amplifier",
          "Speaker",
          "Motion Sensor",
          "Accelerometer",
          "Thermocouple",
          "Antenna",
          "Oscillator",
          "Breadboard"
        ]
      },
      "emotion": {
        "adjective": [
          "abandoned",
          "able",
          "absorbed",
          "addled",
          "affable",
          "affectionate",
          "afraid",
          "aggravated",
          "aggressive",
          "agreeable",
          "alarmed",
          "amazed",
          "ambivalent",
          "amused",
          "angry",
          "annoyed",
          "anxious",
          "apprehensive",
          "ashamed",
          "astonished",
          "awed",
          "awkward",
          "baffled",
          "bashful",
          "bereaved",
          "bewildered",
          "bitter",
          "blissful",
          "blue",
          "bold",
          "bothered",
          "brave",
          "buoyant",
          "calm",
          "cantankerous",
          "capable",
          "carefree",
          "careful",
          "caring",
          "cautious",
          "chagrined",
          "charitable",
          "cheerful",
          "cold",
          "complacent",
          "composed",
          "compulsive",
          "concerned",
          "confident",
          "considerate",
          "contemptuous",
          "content",
          "contrite",
          "cooperative",
          "cranky",
          "crestfallen",
          "cross",
          "crushed",
          "curious",
          "daring",
          "defiant",
          "dejected",
          "delighted",
          "depressed",
          "detached",
          "determined",
          "devious",
          "disappointed",
          "discouraged",
          "disdainful",
          "disenchanted",
          "disengaged",
          "disgusted",
          "disillusioned",
          "disinterested",
          "dismayed",
          "dismissive",
          "distant",
          "doleful",
          "eager",
          "ecstatic",
          "edgy",
          "elated",
          "embarrassed",
          "emboldened",
          "enraged",
          "enthusiastic",
          "envious",
          "euphoric",
          "excited",
          "exhausted",
          "extravagant",
          "exuberant",
          "fair",
          "fatigued",
          "fearful",
          "flustered",
          "foolish",
          "forgiving",
          "frightened",
          "frustrated",
          "fulfilled",
          "funny",
          "furious",
          "generous",
          "glad",
          "gleeful",
          "gloomy",
          "glum",
          "gracious",
          "grateful",
          "greedy",
          "grief-stricken",
          "grouchy",
          "grumpy",
          "guarded",
          "guilty",
          "happy",
          "heartbroken",
          "helpless",
          "hesitant",
          "hopeless",
          "horrified",
          "humbled",
          "humiliated",
          "hurt",
          "hyperactive",
          "hysterical",
          "ignorant",
          "impatient",
          "impertinent",
          "inadequate",
          "indifferent",
          "inquisitive",
          "insecure",
          "inspired",
          "inspiring",
          "interested",
          "irked",
          "irrational",
          "irritable",
          "irritated",
          "isolated",
          "jaded",
          "jealous",
          "jittery",
          "jocular",
          "joyful",
          "joyous",
          "judged",
          "judgmental",
          "keen",
          "kind",
          "lackluster",
          "lazy",
          "leery",
          "lethargic",
          "listless",
          "lonely",
          "loving",
          "mad",
          "malevolent",
          "manic",
          "manipulated",
          "manipulative",
          "marvelous",
          "mean",
          "meek",
          "melancholy",
          "melodramatic",
          "mirthful",
          "mischievous",
          "miserable",
          "misunderstood",
          "moody",
          "mopey",
          "morose",
          "moved",
          "naive",
          "nasty",
          "naughty",
          "needed",
          "needy",
          "neglected",
          "neglectful",
          "nervous",
          "nice",
          "nonchalant",
          "nonplussed",
          "numb",
          "obedient",
          "obligated",
          "obsessed",
          "obsessive",
          "obstinate",
          "offended",
          "open",
          "openminded",
          "optimistic",
          "outraged",
          "overjoyed",
          "overloaded",
          "overpowered",
          "overstimulated",
          "panicked",
          "panicky",
          "passive",
          "peaceful",
          "peeved",
          "pensive",
          "perturbed",
          "petrified",
          "petty",
          "petulant",
          "placid",
          "playful",
          "pleased",
          "powerful",
          "powerless",
          "preoccupied",
          "pressured",
          "prickly",
          "prideful",
          "proud",
          "puzzled",
          "qualified",
          "quarrelsome",
          "querulous",
          "quiet",
          "quirky",
          "quivery",
          "rational",
          "rattled",
          "reasonable",
          "reasoned",
          "reassured",
          "rebellious",
          "refreshed",
          "rejuvenated",
          "relaxed",
          "relieved",
          "reluctant",
          "remorseful",
          "repulsed",
          "resentful",
          "reserved",
          "restless",
          "sad",
          "safe",
          "sanguine",
          "sarcastic",
          "satisfied",
          "scared",
          "scornful",
          "secure",
          "sensitive",
          "serene",
          "serious",
          "shy",
          "silly",
          "sincere",
          "skeptical",
          "smug",
          "sociable",
          "sorrowful",
          "spiteful",
          "startled",
          "stressed",
          "stubborn",
          "surprised",
          "sympathetic",
          "tearful",
          "teary",
          "temperamental",
          "tender",
          "terrified",
          "thankful",
          "thoughtful",
          "threatened",
          "tickled",
          "timid",
          "tired",
          "tiresome",
          "tolerant",
          "tolerated",
          "torn",
          "touched",
          "tranquil",
          "troubled",
          "trusted",
          "trusting",
          "trustworthy",
          "unafraid",
          "unappreciated",
          "uncertain",
          "uncomfortable",
          "undecided",
          "uneasy",
          "unhappy",
          "unimpressed",
          "unnerved",
          "unruffled",
          "unruly",
          "unsteady",
          "unsure",
          "uplifted",
          "uptight",
          "useful",
          "useless",
          "vacant",
          "vain",
          "valuable",
          "valued",
          "vexed",
          "vibrant",
          "victimized",
          "victorious",
          "violent",
          "vital",
          "vivacious",
          "volatile",
          "vulnerable",
          "warm",
          "wary",
          "wasted",
          "weak",
          "weary",
          "weepy",
          "whimsical",
          "whiny",
          "willful",
          "willing",
          "wishful",
          "wistful",
          "withdrawn",
          "witty",
          "woeful",
          "worn",
          "worried",
          "worthless",
          "wronged",
          "yearning",
          "yielding",
          "youthful",
          "zany",
          "zealous",
          "zestful"
        ],
        "noun": [
          "adoration",
          "affection",
          "aggravation",
          "agitation",
          "agony",
          "alarm",
          "alienation",
          "amazement",
          "amusement",
          "anger",
          "anguish",
          "annoyance",
          "anxiety",
          "apprehension",
          "arousal",
          "astonishment",
          "attraction",
          "bitterness",
          "bliss",
          "caring",
          "cheerfulness",
          "compassion",
          "contempt",
          "contentment",
          "defeat",
          "dejection",
          "delight",
          "depression",
          "desire",
          "despair",
          "disappointment",
          "disgust",
          "dislike",
          "dismay",
          "displeasure",
          "distress",
          "dread",
          "eagerness",
          "ecstasy",
          "elation",
          "embarrassment",
          "enjoyment",
          "enthrallment",
          "enthusiasm",
          "envy",
          "euphoria",
          "exasperation",
          "excitement",
          "exhilaration",
          "fear",
          "ferocity",
          "fondness",
          "fright",
          "frustration",
          "fury",
          "gaiety",
          "gladness",
          "glee",
          "gloom",
          "glumness",
          "grief",
          "grouchiness",
          "grumpiness",
          "guilt",
          "happiness",
          "hate",
          "homesickness",
          "hope",
          "hopelessness",
          "horror",
          "hostility",
          "humiliation",
          "hurt",
          "hysteria",
          "infatuation",
          "insecurity",
          "insult",
          "irritation",
          "isolation",
          "jealousy",
          "liking",
          "loathing",
          "loneliness",
          "longing",
          "love",
          "lust",
          "melancholy",
          "misery",
          "mortification",
          "neglect",
          "nervousness",
          "optimism",
          "outrage",
          "panic",
          "passion",
          "pity",
          "pleasure",
          "pride",
          "rage",
          "rapture",
          "regret",
          "relief",
          "remorse",
          "resentment",
          "revulsion",
          "sadness",
          "scorn",
          "sentimentality",
          "shame",
          "shock",
          "sorrow",
          "spite",
          "suffering",
          "surprise",
          "sympathy",
          "tenderness",
          "tenseness",
          "terror",
          "thrill",
          "torment",
          "triumph",
          "uneasiness",
          "unhappiness",
          "vengefulness",
          "woe",
          "worry",
          "zeal",
          "zest"
        ]
      },
      "esport": {
        "events": [
          "ESL Cologne",
          "MLG Meadowlands",
          "GFinity London",
          "Worlds",
          "IEM Championship",
          "League All Stars",
          "International"
        ],
        "games": [
          "CS:GO",
          "League of Legends",
          "Overwatch",
          "StarCraft II",
          "Dota 2",
          "Super Smash Bros. Melee",
          "Hearthstone",
          "PUBG"
        ],
        "leagues": [
          "ESL",
          "IEM",
          "MLG",
          "GFinity",
          "Starladder"
        ],
        "players": [
          "Froggen",
          "Dendi",
          "Surefour",
          "Seagull",
          "xPeke",
          "shroud",
          "KennyS",
          "pasha",
          "RamboRay",
          "Crimsix",
          "ACE",
          "Grubby",
          "f0rest",
          "cArn",
          "Flash",
          "Faker",
          "Boxer",
          "Miracle",
          "Silvername"
        ],
        "teams": [
          "Dignitas",
          "OpTic Gaming",
          "FaZe",
          "iBUYPOWER",
          "Evil Geniuses",
          "Ninjas in Pijamas",
          "Natus Vincere",
          "Team SoloMid",
          "Cloud9",
          "Fnatic",
          "CLG",
          "EnVyUs",
          "Virtus.Pro",
          "Team Secret"
        ]
      },
      "family_guy": {
        "character": [
          "Peter Griffin",
          "Lois Griffin",
          "Meg Griffin",
          "Chris Griffin",
          "Stewie Griffin",
          "Brian Griffin",
          "Francis Griffin",
          "Mickey McFinnigan",
          "Thelma Griffin",
          "Karen Griffin",
          "Carter Pewterschmidt",
          "Barabara Pewterschmidt",
          "Glenn Quagmire",
          "Cleveland Brown",
          "Joe Swanson",
          "Bonnie Swanson",
          "Mort Goldman",
          "Tom Tucker",
          "Joyce Kinney",
          "Diane Simmons",
          "Ollie Williams",
          "Tricia Takanawa",
          "Fouad",
          "Principal Shephard",
          "Mayor Adam West",
          "Carl",
          "Consuela",
          "God",
          "Horace",
          "James Woods",
          "Evil Monkey"
        ],
        "location": [
          "Cleveland's Deli",
          "Drunken Clam",
          "Goldman's Pharmacy",
          "Happy-Go-Lucky Toy Factory",
          "Jack's Joke Shop",
          "James Woods High",
          "Pawtucket Brewery",
          "Quahog 5 News",
          "Spooner Street"
        ],
        "quote": [
          "It’s Peanut Butter Jelly Time.",
          "I’ve got an idea–an idea so smart that my head would explode if I even began to know what I’m talking about.",
          "A degenerate, am I? Well, you are a festisio! See? I can make up words too, sister.",
          "Now I may be an idiot, but there’s one thing I am not sir, and that sir, is an idiot.",
          "Isn’t ‘bribe’ just another word for ‘love’?",
          "I am so not competitive. In fact, I am the least non-competitive. So I win.",
          "Hey, don't try to take this away from me. This is the only thing I've ever been good at. Well, this and timing my farts to a thunderstorm.",
          "Joe, gag on my fat dauber.",
          "People in love can overcome anything.",
          "Amazing. One second of a stranger's voice on a phone, and you've got full Bollywood.",
          "You know, this is great guys. Drinking and eating garbage. I'm glad we all took a mental health day."
        ]
      },
      "file": {
        "extension": [
          "flac",
          "mp3",
          "wav",
          "bmp",
          "gif",
          "jpeg",
          "jpg",
          "png",
          "tiff",
          "css",
          "csv",
          "html",
          "js",
          "json",
          "txt",
          "mp4",
          "avi",
          "mov",
          "webm",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "ppt",
          "pptx",
          "odt",
          "ods",
          "odp",
          "pages",
          "numbers",
          "key",
          "pdf"
        ],
        "mime_type": {
          "application": [
            "application/atom+xml",
            "application/ecmascript",
            "application/EDI-X12",
            "application/EDIFACT",
            "application/json",
            "application/javascript",
            "application/ogg",
            "application/pdf",
            "application/postscript",
            "application/rdf+xml",
            "application/rss+xml",
            "application/soap+xml",
            "application/font-woff",
            "application/xhtml+xml",
            "application/xml-dtd",
            "application/xop+xml",
            "application/zip",
            "application/gzip"
          ],
          "audio": [
            "audio/basic",
            "audio/L24",
            "audio/mp4",
            "audio/mpeg",
            "audio/ogg",
            "audio/vorbis",
            "audio/vnd.rn-realaudio",
            "audio/vnd.wave",
            "audio/webm"
          ],
          "image": [
            "image/gif",
            "image/jpeg",
            "image/pjpeg",
            "image/png",
            "image/svg+xml",
            "image/tiff",
            "image/vnd.microsoft.icon"
          ],
          "message": [
            "message/http",
            "message/imdn+xml",
            "message/partial",
            "message/rfc822"
          ],
          "model": [
            "model/example",
            "model/iges",
            "model/mesh",
            "model/vrml",
            "model/x3d+binary",
            "model/x3d+vrml",
            "model/x3d+xml"
          ],
          "multipart": [
            "multipart/mixed",
            "multipart/alternative",
            "multipart/related",
            "multipart/form-data",
            "multipart/signed",
            "multipart/encrypted"
          ],
          "text": [
            "text/cmd",
            "text/css",
            "text/csv",
            "text/html",
            "text/javascript",
            "text/plain",
            "text/vcard",
            "text/xml"
          ],
          "video": [
            "video/mpeg",
            "video/mp4",
            "video/ogg",
            "video/quicktime",
            "video/webm",
            "video/x-matroska",
            "video/x-ms-wmv",
            "video/x-flv"
          ]
        }
      },
      "final_space": {
        "characters": [
          "A.V.A",
          "Ash Graven",
          "Avocato",
          "Bolo",
          "Clarence",
          "Gary Goodspeed",
          "H.U.E",
          "John Goodspeed",
          "KVN",
          "Little Cato",
          "Lord Commander",
          "Mooncake",
          "Nighfall",
          "Quinn Ergon",
          "Sheryl Goodspeed"
        ],
        "quotes": [
          "It's an alien on my face! It's an alien on my...It's a space alien!",
          "Get. Your. Finger. Out. Of. My. TUMMY!",
          "Chookity",
          "Twist my nipples rough",
          "Let's get wild, how about you buy me a drink",
          "Hey kids, it's me, your mother",
          "That's not a cookie. And you know that HUE, you know that!",
          "Get off my cheeks HUE!"
        ],
        "vehicles": [
          "Crimson Light",
          "Galaxy One",
          "Imperium Cruiser",
          "F71 Hawk",
          "Heavy Incinerator",
          "Star Chaser"
        ]
      },
      "finance": {
        "condominium_fiscal_code": {
          "IT": "###########"
        },
        "credit_card": {
          "american_express": [
            "/34##-######-####L/",
            "/37##-######-####L/"
          ],
          "dankort": "/5019-####-####-###L/",
          "diners_club": [
            "/30[0-5]#-######-###L/",
            "/368#-######-###L/"
          ],
          "discover": [
            "/6011-####-####-###L/",
            "/65##-####-####-###L/",
            "/64[4-9]#-####-####-###L/",
            "/6011-62##-####-####-##L/",
            "/65##-62##-####-####-##L/",
            "/64[4-9]#-62##-####-####-##L/"
          ],
          "forbrugsforeningen": "/6007-22##-####-###L/",
          "jcb": [
            "/3528-####-####-###L/",
            "/3529-####-####-###L/",
            "/35[3-8]#-####-####-###L/"
          ],
          "laser": [
            "/6304###########L/",
            "/6706###########L/",
            "/6771###########L/",
            "/6709###########L/",
            "/6304#########{5,6}L/",
            "/6706#########{5,6}L/",
            "/6771#########{5,6}L/",
            "/6709#########{5,6}L/"
          ],
          "maestro": [
            "/50#{9,16}L/",
            "/5[6-8]#{9,16}L/",
            "/56##{9,16}L/"
          ],
          "mastercard": [
            "/5[1-5]##-####-####-###L/",
            "/6771-89##-####-###L/"
          ],
          "solo": [
            "/6767-####-####-###L/",
            "/6767-####-####-####-#L/",
            "/6767-####-####-####-##L/"
          ],
          "switch": [
            "/6759-####-####-###L/",
            "/6759-####-####-####-#L/",
            "/6759-####-####-####-##L/"
          ],
          "visa": [
            "/4###########L/",
            "/4###-####-####-###L/"
          ]
        },
        "stock_market": [
          "NYSE",
          "NASDAQ",
          "SSE",
          "HKEX",
          "JPX",
          "SZSE",
          "LSE",
          "TSX",
          "NSE-INDIA",
          "FSX",
          "TADAWUL",
          "OMXC-COPENHAGEN",
          "KRX",
          "BSE-BOMBAY",
          "SIX",
          "EURONEXT-PARIS",
          "TWSE",
          "ASX",
          "JSE",
          "BOVESPA"
        ],
        "ticker": {
          "nasdaq": [
            "MSFT",
            "AAPL",
            "AMZN",
            "GOOG",
            "FB",
            "INTC",
            "CSCO",
            "CMCSA",
            "PEP",
            "ADBE",
            "NVDA",
            "NFLX",
            "PYPL",
            "COST",
            "AMGN",
            "AVGO",
            "TXN",
            "CHTR",
            "SBUX",
            "QCOM",
            "GILD",
            "MDLZ",
            "FISV",
            "BKNG",
            "INTU"
          ],
          "nyse": [
            "XOM",
            "WFC",
            "JNJ",
            "GE",
            "NVX",
            "WMT",
            "JPM",
            "PG",
            "TM",
            "PFE",
            "CVX",
            "BABA",
            "VZ",
            "BUD",
            "ORCL",
            "DIS",
            "KO",
            "HSBC",
            "T",
            "BAC",
            "C",
            "MRK",
            "V",
            "BRK.B",
            "MA"
          ]
        },
        "vat_number": {
          "AR": "AR###########",
          "AT": "ATU########",
          "AU": "AU###########",
          "BE": "BE0#########",
          "BG": [
            "BG#########",
            "BG##########"
          ],
          "BR": "BR##.###.###/####-##",
          "BY": "УНП #########",
          "CH": "CH######",
          "CL": "CL########-#",
          "CZ": [
            "CZ########",
            "CZ#########",
            "CZ##########"
          ],
          "DE": "DE#########",
          "DK": "DK## ## ## ##",
          "EC": "EC#############",
          "EE": "EE#########",
          "FI": "FI########",
          "GB": [
            "GB### #### ##",
            "GB### #### ## ###",
            "GBGD###",
            "GBHA###",
            "GB888 8### ##"
          ],
          "GR": "EL#########",
          "HR": "HR### ### ### ##",
          "HU": "HU########",
          "IT": "IT###########",
          "LT": [
            "LT#########",
            "LT############"
          ],
          "LU": "LU########",
          "LV": "LV###########",
          "MT": "MT########",
          "MX": "MX#### ###### ###",
          "NO": "NO#########",
          "PH": "PH### ### ### ###",
          "PL": "PL##########",
          "PT": "PT#########",
          "RO": [
            "RO##",
            "RO###",
            "RO####",
            "RO#####",
            "RO######",
            "RO#######",
            "RO########",
            "RO#########",
            "RO##########"
          ],
          "RU": [
            "RU##########",
            "RU############"
          ],
          "SE": "SE##########01",
          "SI": "SI########",
          "SK": "SK##########",
          "SM": "SM#####",
          "UA": "UA##########",
          "ZA": [
            "ZA##########",
            "ZA###########"
          ]
        }
      },
      "food": {
        "allergens": [
          "Eggs",
          "Milk",
          "Mustard",
          "Peanuts",
          "Crustaceans and molluscs",
          "Fish",
          "Sesame seeds",
          "Soy",
          "Sulphites",
          "Tree Nuts",
          "Wheat and triticale"
        ],
        "descriptions": [
          "Three eggs with cilantro, tomatoes, onions, avocados and melted Emmental cheese. With a side of roasted potatoes, and your choice of toast or croissant.",
          "Three egg omelet with Roquefort cheese, chives, and ham. With a side of roasted potatoes, and your choice of toast or croissant.",
          "Three egg whites with spinach, mushrooms, caramelized onions, tomatoes and low-fat feta cheese. With herbed quinoa, and your choice of rye or whole-grain toast.",
          "Smoked salmon, poached eggs, diced red onions and Hollandaise sauce on an English muffin. With a side of roasted potatoes.",
          "Fresh parsley, Italian sausage, shallots, garlic, sun-dried tomatoes and mozzarella cheese in an all-butter crust. With a side of mixed fruits.",
          "Thick slices of French toast bread, brown sugar, half-and-half and vanilla, topped with powdered sugar. With two eggs served any style, and your choice of smoked bacon or smoked ham.",
          "Two buttermilk waffles, topped with whipped cream and maple syrup, a side of two eggs served any style, and your choice of smoked bacon or smoked ham.",
          "Breaded fried chicken with waffles, and a side of maple syrup.",
          "Two butter croissants of your choice (plain, almond or cheese). With a side of herb butter or house-made hazelnut spread.",
          "28-day aged 300g USDA Certified Prime Ribeye, rosemary-thyme garlic butter, with choice of two sides.",
          "Breaded fried chicken with waffles. Served with maple syrup.",
          "Fresh Norwegian salmon, lightly brushed with our herbed Dijon mustard sauce, with choice of two sides.",
          "Creamy mascarpone cheese and custard layered between espresso and rum soaked house-made ladyfingers, topped with Valrhona cocoa powder.",
          "Granny Smith apples mixed with brown sugar and butter filling, in a flaky all-butter crust, with ice cream."
        ],
        "dish": [
          "Arepas",
          "Barbecue Ribs",
          "Bruschette with Tomato",
          "Bunny Chow",
          "Caesar Salad",
          "California Maki",
          "Caprese Salad",
          "Cauliflower Penne",
          "Cheeseburger",
          "Chicken Fajitas",
          "Chicken Milanese",
          "Chicken Parm",
          "Chicken Wings",
          "Chilli con Carne",
          "Ebiten maki",
          "Fettuccine Alfredo",
          "Fish and Chips",
          "French Fries with Sausages",
          "French Toast",
          "Hummus",
          "Katsu Curry",
          "Kebab",
          "Lasagne",
          "Linguine with Clams",
          "Massaman Curry",
          "Meatballs with Sauce",
          "Mushroom Risotto",
          "Pappardelle alla Bolognese",
          "Pasta Carbonara",
          "Pasta and Beans",
          "Pasta with Tomato and Basil",
          "Peking Duck",
          "Philadelphia Maki",
          "Pho",
          "Pierogi",
          "Pizza",
          "Poke",
          "Pork Belly Buns",
          "Pork Sausage Roll",
          "Poutine",
          "Ricotta Stuffed Ravioli",
          "Risotto with Seafood",
          "Salmon Nigiri",
          "Scotch Eggs",
          "Seafood Paella",
          "Som Tam",
          "Souvlaki",
          "Stinky Tofu",
          "Sushi",
          "Tacos",
          "Teriyaki Chicken Donburi",
          "Tiramisù",
          "Tuna Sashimi",
          "Vegetable Soup"
        ],
        "ethnic_category": [
          "Ainu",
          "Albanian",
          "Argentine",
          "Andhra",
          "American",
          "Anglo-Indian",
          "Arab",
          "Armenian",
          "Assyrian",
          "Awadhi",
          "Azerbaijani",
          "Balochi",
          "Bashkir",
          "Belarusian",
          "Bangladeshi",
          "Bengali",
          "Berber",
          "Brazilian",
          "British",
          "Buddhist",
          "Bulgarian",
          "Cajun",
          "Cantonese",
          "Caribbean",
          "Chechen",
          "Chinese cuisine",
          "Chinese Islamic",
          "Circassian",
          "Crimean Tatar",
          "Cypriot",
          "Czech",
          "Danish",
          "Egyptian",
          "English",
          "Ethiopian",
          "Eritrean",
          "Estonian",
          "French",
          "Filipino",
          "Georgian",
          "German",
          "Goan",
          "Goan Catholic",
          "Greek",
          "Gujarati",
          "Hyderabad",
          "Indian cuisine",
          "Indian Chinese",
          "Indian Singaporean cuisine",
          "Indonesian",
          "Inuit",
          "Irish",
          "Italian-American",
          "Italian cuisine",
          "Jamaican",
          "Japanese",
          "Jewish - Israeli",
          "Karnataka",
          "Kazakh",
          "Keralite",
          "Korean",
          "Kurdish",
          "Laotian",
          "Lebanese",
          "Latvian",
          "Lithuanian",
          "Louisiana Creole",
          "Maharashtrian",
          "Mangalorean",
          "Malay",
          "Malaysian Chinese cuisine",
          "Malaysian Indian cuisine",
          "Mediterranean cuisine",
          "Mennonite",
          "Mexican",
          "Mordovian",
          "Mughal",
          "Native American",
          "Nepalese",
          "New Mexican",
          "Odia",
          "Parsi",
          "Pashtun",
          "Polish",
          "Pennsylvania Dutch",
          "Pakistani",
          "Peranakan",
          "Persian",
          "Peruvian",
          "Portuguese",
          "Punjabi",
          "Québécois",
          "Rajasthani",
          "Romani",
          "Romanian",
          "Russian",
          "Sami",
          "Serbian",
          "Sindhi",
          "Slovak",
          "Slovenian",
          "Somali",
          "South Indian",
          "Soviet",
          "Spanish",
          "Sri Lankan",
          "Taiwanese",
          "Tatar",
          "Texan",
          "Thai",
          "Turkish",
          "Tamil",
          "Udupi",
          "Ukrainian",
          "Vietnamese",
          "Yamal",
          "Zambian",
          "Zanzibari"
        ],
        "fruits": [
          "Apples",
          "Apricots",
          "Aubergine",
          "Avocado",
          "Banana",
          "Berries",
          "Blackberries",
          "Blood oranges",
          "Blueberries",
          "Bush Tomato",
          "Butternut pumpkin",
          "Cantaloupe",
          "Cavalo",
          "Starfruit",
          "Cherries",
          "Corella Pear",
          "Cranberry",
          "Cumquat",
          "Currants",
          "Custard Apples",
          "Custard Apples Daikon",
          "Dates",
          "Dragonfruit",
          "Dried Apricots",
          "Elderberry",
          "Feijoa",
          "Grapefruit",
          "Grapes",
          "Figs",
          "Fingerlime",
          "Goji Berry",
          "Guava",
          "Honeydew melon",
          "Incaberries",
          "Jarrahdale pumpkin",
          "Juniper Berries",
          "Kiwi Fruit",
          "Kiwiberries",
          "Lemon",
          "Limes",
          "Longan",
          "Loquats",
          "Lychees",
          "Mango",
          "Mangosteens",
          "Melon",
          "Mandarins",
          "Mulberries",
          "Nashi Pear",
          "Nectarines",
          "Olives",
          "Oranges",
          "Papaw",
          "Papaya",
          "Passionfruit",
          "Peaches",
          "Pears",
          "Pineapple",
          "Pomegranate",
          "Plums",
          "Prunes",
          "Rockmelon",
          "Snowpeas",
          "Sprouts",
          "Strawberries",
          "Sultanas",
          "Tangelo",
          "Tomatoes",
          "Watermelon"
        ],
        "ingredients": [
          "Achacha",
          "Adzuki Beans",
          "Agar",
          "Agave Syrup",
          "Ajowan Seed",
          "Albacore Tuna",
          "Alfalfa",
          "Allspice",
          "Almond Oil",
          "Almonds",
          "Amaranth",
          "Amchur",
          "Anchovies",
          "Anchovies",
          "Aniseed",
          "Annatto Seed",
          "Apple Cider Vinegar",
          "Apple Juice",
          "Apple Juice Concentrate",
          "Apples",
          "Bonza",
          "Apples",
          "Apricots",
          "Arborio Rice",
          "Arrowroot",
          "Artichoke",
          "Arugula",
          "Asafoetida",
          "Asian Greens",
          "Asian Noodles",
          "Asparagus",
          "Aubergine",
          "Avocado",
          "Avocado Oil",
          "Avocado Spread",
          "Bacon",
          "Baking Powder",
          "Baking Soda",
          "Balsamic Vinegar",
          "Bamboo Shoots",
          "Banana",
          "Barberry",
          "Barley",
          "Barramundi",
          "Basil Basmati Rice",
          "Bay Leaves",
          "Bean Shoots",
          "Bean Sprouts",
          "Beans",
          "Green Beans",
          "Beef",
          "Beetroot",
          "Berries",
          "Black Eyed Beans",
          "Blackberries",
          "Blood Oranges",
          "Blue Cheese",
          "Blue Eye Trevalla",
          "Blue Swimmer Crab",
          "Blueberries",
          "Bocconcini",
          "Bok Choy",
          "Bonito Flakes",
          "Borlotti Beans",
          "Brazil Nut",
          "Bran",
          "Bread",
          "Rye Bread",
          "Sour Dough Bread",
          "Spelt Bread",
          "White Bread",
          "Wholegrain Bread",
          "Wholemeal",
          "Brie",
          "Broccoli",
          "Broccolini",
          "Brown Rice",
          "Brown Rice Vinegar",
          "Brussels Sprouts",
          "Buckwheat",
          "Buckwheat Noodles",
          "Bulghur",
          "Bush Tomato",
          "Butter",
          "Butter Beans",
          "Buttermilk",
          "Butternut Lettuce",
          "Butternut Pumpkin",
          "Cabbage",
          "Cacao",
          "Cake",
          "Calamari",
          "Camellia Tea Oil",
          "Camembert",
          "Camomile",
          "Candle Nut",
          "Cannellini Beans",
          "Canola Oil",
          "Cantaloupe",
          "Capers",
          "Capsicum",
          "Starfruit",
          "Caraway Seed",
          "Cardamom",
          "Carob Carrot",
          "Carrot",
          "Cashews",
          "Cassia bark",
          "Cauliflower",
          "Cavalo",
          "Cayenne",
          "Celery",
          "Celery Seed",
          "Cheddar",
          "Cherries",
          "Chestnut",
          "Chia Seeds",
          "Chicken",
          "Chickory",
          "Chickpea",
          "Chilli Pepper",
          "Fresh Chillies",
          "Dried Chinese Broccoli",
          "Chinese Cabbage",
          "Chinese Five Spice",
          "Chives",
          "Dark Chocolate",
          "Milk Chocolate",
          "Choy Sum",
          "Cinnamon",
          "Clams",
          "Cloves",
          "Cocoa Powder",
          "Coconut",
          "Coconut Oil",
          "Coconut Water",
          "Coffee",
          "Corella Pear",
          "Coriander Leaves",
          "Coriander Seed",
          "Corn Oil",
          "Corn Syrup",
          "Corn Tortilla",
          "Cornichons",
          "Cornmeal",
          "Cos Lettuce",
          "Cottage Cheese",
          "Cous Cous",
          "Crabs",
          "Cranberry",
          "Cream",
          "Cream Cheese",
          "Cucumber",
          "Cumin",
          "Cumquat",
          "Currants",
          "Curry Leaves",
          "Curry Powder",
          "Custard Apples",
          "Dandelion",
          "Dashi",
          "Dates",
          "Dill",
          "Dragonfruit",
          "Dried Apricots",
          "Duck",
          "Edam",
          "Edamame",
          "Eggplant",
          "Eggs",
          "Elderberry",
          "Endive",
          "English Spinach",
          "Extra Virgin Olive Oil",
          "Farmed Prawns",
          "Feijoa",
          "Fennel",
          "Fennel Seeds",
          "Fenugreek",
          "Feta",
          "Figs",
          "File Powder",
          "Fingerlime",
          "Fish Sauce",
          "Flathead",
          "Flaxseed",
          "Flaxseed Oil",
          "Flounder",
          "Flour",
          "Besan",
          "Buckwheat Flour",
          "Oat Flour",
          "Potato Flour",
          "Rice Flour",
          "Brown Flour",
          "White Flour",
          "Soy Flour",
          "Tapioca Flour",
          "Unbleached Flour",
          "Wholewheat Flour",
          "Freekeh",
          "French Eschallots",
          "Fromage Blanc",
          "Fruit",
          "Galangal",
          "Garam Masala",
          "Garlic",
          "Chives",
          "Goat Cheese",
          "Goat Milk",
          "Goji Berry",
          "Grape Seed Oil",
          "Grapefruit",
          "Grapes",
          "Green Pepper",
          "Green Tea",
          "Green Tea Noodles",
          "Greenwheat Freekeh",
          "Gruyere",
          "Guava",
          "Gula Melaka",
          "Haloumi",
          "Ham",
          "Haricot Beans",
          "Harissa",
          "Hazelnut",
          "Hijiki",
          "Hiramasa Kingfish",
          "Hokkien Noodles",
          "Honey",
          "Honeydew Melon",
          "Horseradish",
          "Hot Smoked Salmon",
          "Hummus",
          "Iceberg Lettuce",
          "Incaberries",
          "Jarrahdale Pumpkin",
          "Jasmine Rice",
          "Jelly",
          "Jerusalem Artichoke",
          "Jewfish",
          "Jicama",
          "Juniper Berries",
          "Lime Leaves",
          "Kale",
          "Kangaroo",
          "Kecap Manis",
          "Kenchur",
          "Kidney Beans",
          "Kidneys",
          "Kiwi Fruit",
          "Kiwi Berries",
          "Kohlrabi",
          "Kokam",
          "Kombu",
          "Koshihikari Rice",
          "Kudzu",
          "Kumera",
          "Lamb",
          "Lavender Flowers",
          "Leeks",
          "Lemon",
          "Lemongrass",
          "Lentils",
          "Lettuce",
          "Licorice",
          "Limes",
          "Liver",
          "Lobster",
          "Longan",
          "Loquats",
          "Lotus Root",
          "Lychees",
          "Macadamia Nut",
          "Macadamia Oil",
          "Mace",
          "Mackerel",
          "Tinned",
          "Mahi Mahi",
          "Mahlab",
          "Malt Vinegar",
          "Mandarins",
          "Mango",
          "Mangosteens",
          "Maple Syrup",
          "Margarine",
          "Marigold",
          "Marjoram",
          "Mastic",
          "Melon",
          "Milk",
          "Mint",
          "Miso",
          "Molasses",
          "Monkfish",
          "Morwong",
          "Mountain Bread",
          "Mozzarella",
          "Muesli",
          "Mulberries",
          "Mullet",
          "Mung Beans",
          "Flat Mushrooms",
          "Brown Mushrooms",
          "Common Cultivated Mushrooms",
          "Enoki Mushrooms",
          "Oyster Mushrooms",
          "Shiitake Mushrooms",
          "Mussels",
          "Mustard",
          "Mustard Seed",
          "Nashi Pear",
          "Nasturtium",
          "Nectarines",
          "Nori",
          "Nutmeg",
          "Nutritional Yeast",
          "Nuts",
          "Oatmeal",
          "Oats",
          "Octopus",
          "Okra",
          "Olive Oil",
          "Olives",
          "Omega Spread",
          "Onion",
          "Oranges",
          "Oregano",
          "Oyster Sauce",
          "Oysters",
          "Pear",
          "Pandanus Leaves",
          "Papaw",
          "Papaya",
          "Paprik",
          "Parmesan Cheese",
          "Parrotfish",
          "Parsley",
          "Parsnip",
          "Passionfruit",
          "Pasta",
          "Peaches",
          "Peanuts",
          "Pear Juice",
          "Pears",
          "Peas",
          "Pecan Nut",
          "Pecorino",
          "Pepitas",
          "Szechuan Pepperberry",
          "Peppercorns",
          "Peppermint",
          "Peppers",
          "Persimmon",
          "Pine Nut",
          "Pineapple",
          "Pinto Beans",
          "Pistachio Nut",
          "Plums",
          "Polenta",
          "Pomegranate",
          "Poppy Seed",
          "Porcini Mushrooms",
          "Pork",
          "Potatoes",
          "Provolone",
          "Prunes",
          "Pumpkin",
          "Pumpkin Seed",
          "Purple Carrot",
          "Purple Rice",
          "Quark",
          "Quince",
          "Quinoa",
          "Radicchio",
          "Radish",
          "Raisin",
          "Raspberry",
          "Red Cabbage",
          "Red Lentils",
          "Red Pepper",
          "Red Wine Vinegar",
          "Redfish",
          "Rhubarb",
          "Rice Noodles",
          "Rice Paper",
          "Rice Syrup",
          "Ricemilk",
          "Ricotta",
          "Rockmelon",
          "Rose Water",
          "Rosemary",
          "Rye",
          "Safflower Oil",
          "Saffron",
          "Sage",
          "Sake",
          "Salmon",
          "Sardines",
          "Sausages",
          "Scallops",
          "Sea Salt",
          "Semolina",
          "Sesame Oil",
          "Sesame Seeds",
          "Shark",
          "Silverbeet",
          "Slivered Almonds",
          "Smoked Trout",
          "Snapper",
          "Snowpea sprouts",
          "Snowpeas",
          "Soba",
          "Soy Beans",
          "Soy Milk",
          "Soy Sauce",
          "Soy",
          "Sprouts",
          "Soymilk",
          "Spearmint",
          "Spelt",
          "Spinach",
          "Spring Onions",
          "Squash",
          "Squid",
          "Star Anise",
          "Star Fruit",
          "Stevia",
          "Beef Stock",
          "Chicken Stock",
          "Fish Stock",
          "Vegetable Stock",
          "Strawberries",
          "Sugar",
          "Sultanas",
          "Sun-Dried Tomatoes",
          "Sunflower Oil",
          "Sunflower Seeds",
          "Sweet Chilli Sauce",
          "Sweet Potato",
          "Swiss Chard",
          "Swordfish",
          "Tabasco",
          "Tahini",
          "Taleggio Cheese",
          "Tamari",
          "Tamarillo",
          "Tangelo",
          "Tapioca",
          "Tarragon",
          "Tea",
          "Tea Oil",
          "Tempeh",
          "Thyme",
          "Tofu",
          "Tom Yum",
          "Tomatoes",
          "Trout",
          "Tuna",
          "Turkey",
          "Turmeric",
          "Turnips",
          "Vanilla Beans",
          "Vegetable Oil",
          "Vegetable Spaghetti",
          "Vermicelli Noodles",
          "Vinegar",
          "Wakame",
          "Walnut",
          "Warehou",
          "Wasabi",
          "Water",
          "Watercress",
          "Watermelon",
          "Wattleseed",
          "Wheat",
          "Wheatgrass Juice",
          "White rice",
          "White Wine Vinegar",
          "Whiting Wild Rice",
          "William Pear",
          "Red Wine",
          "White Wine",
          "Yeast",
          "Yellow Papaw",
          "Yellowtail Kingfish",
          "Yoghurt",
          "Yogurt",
          "Zucchini"
        ],
        "measurement_sizes": [
          "1/4",
          "1/3",
          "1/2",
          "1",
          "2",
          "3"
        ],
        "measurements": [
          "teaspoon",
          "tablespoon",
          "cup",
          "pint",
          "quart",
          "gallon"
        ],
        "metric_measurements": [
          "milliliter",
          "deciliter",
          "centiliter",
          "liter"
        ],
        "spices": [
          "Achiote Seed",
          "Ajwain Seed",
          "Ajwan Seed",
          "Allspice Ground",
          "Allspice Whole",
          "Amchoor",
          "Anise",
          "Anise Star",
          "Aniseed Whole",
          "Annatto Seed",
          "Arrowroot",
          "Asafoetida",
          "Baharat",
          "Balti Masala",
          "Balti Stir Fry Mix",
          "Basil",
          "Bay Leaves",
          "Bay Leaves Chopped",
          "BBQ Seasoning",
          "Biryani Spice Mix",
          "Cajun Seasoning",
          "Caraway Seed",
          "Cardamom Ground",
          "Cardamom Whole",
          "Cassia",
          "Cassia Bark",
          "Cayenne Pepper",
          "Celery Leaf",
          "Celery Salt",
          "Celery Seed",
          "Chamomile",
          "Chervil",
          "Chicken Seasoning",
          "Chilli Crushed",
          "Chilli Ground",
          "Chilli Pepper",
          "Chillies Whole",
          "China Star",
          "Chinese 5 Spice",
          "Chives",
          "Cinnamon Bark",
          "Cinnamon Ground",
          "Cinnamon Powder",
          "Cinnamon Sticks",
          "Cloves Ground",
          "Cloves Whole",
          "Colombo Powder",
          "Coriander Ground",
          "Coriander Leaf",
          "Coriander Seed",
          "Creole Seasoning",
          "Cumin Ground",
          "Cumin Seed",
          "Cumin Seed Black",
          "Cumin Seed Royal",
          "Curly Leaf Parsley",
          "Curry Chinese",
          "Curry Hot",
          "Curry Leaves",
          "Curry Madras Medium",
          "Curry Mild",
          "Curry Thai Green",
          "Curry Thai Red",
          "Dhansak Spice Mix",
          "Dill Herb",
          "Dill Leaf",
          "Dill Seed",
          "Fajita Seasoning",
          "Fennel Seed",
          "Fenugreek Ground",
          "Fenugreek Leaf",
          "Fenugreek Seed",
          "Fines Herbes",
          "Fish Seasoning",
          "Five Spice Mix",
          "French Lavender",
          "Galangal Ground",
          "Garam Masala",
          "Garlic Chips",
          "Garlic Granules",
          "Garlic Powder",
          "Garlic Salt",
          "German Chamomile",
          "Ginger Root",
          "Ginger Ground",
          "Green Cardamom",
          "Herbes de Provence",
          "Jalfrezi Curry Powder",
          "Jalfrezi Mix",
          "Jerk Seasoning",
          "Juniper Berries",
          "Kaffir Leaves",
          "Korma Curry Powder",
          "Korma Mix",
          "Lamb Seasoning",
          "Lavender",
          "Lemon Grass",
          "Lemon Grass Chopped",
          "Lemon Pepper",
          "Lime Leaves",
          "Lime Leaves Ground",
          "Liquorice Root",
          "Mace Ground",
          "Mace Whole",
          "Mango Powder",
          "Marjoram",
          "Methi",
          "Methi Leaves",
          "Mexican Salsa Mix",
          "Mint",
          "Mixed Herbs",
          "Mixed Spice",
          "Mulled Cider Spices",
          "Mulled Wine Spices",
          "Mustard Powder",
          "Mustard Seed Black",
          "Mustard Seed Brown",
          "Mustard Seed White",
          "Mustard Seed Yellow",
          "Nigella",
          "Nutmeg Ground",
          "Nutmeg Whole",
          "Onion Seed",
          "Orange Zest",
          "Oregano",
          "Paella Seasoning",
          "Paprika",
          "Paprika Hungarian",
          "Paprika Smoked",
          "Parsley",
          "Parsley Flat Leaf",
          "Pepper Black Coarse",
          "Pepper Black Ground",
          "Pepper White Ground",
          "Peppercorns Black",
          "Peppercorns Cracked Black",
          "Peppercorns Green",
          "Peppercorns Mixed",
          "Peppercorns Pink",
          "Peppercorns Szechwan",
          "Peppercorns White",
          "Pickling Spice",
          "Pimento Berries",
          "Pimento Ground",
          "Piri Piri Seasoning",
          "Pizza Topping Mix",
          "Poppy Seed",
          "Pot Marjoram",
          "Poudre de Colombo",
          "Ras-el-Hanout",
          "Rice Paper",
          "Rogan Josh Curry Powder",
          "Rogan Josh Mix",
          "Rose Baie",
          "Rosemary",
          "Saffron",
          "Sage",
          "Sea Salt Coarse",
          "Seasoning Salt",
          "Self Adhesive Spice Labels",
          "Sesame Seed",
          "Spearmint",
          "Spice Charts",
          "Steak Seasoning",
          "Sumac Ground",
          "Sweet Basil",
          "Sweet Laurel",
          "Tagine Seasoning",
          "Tandoori Masala",
          "Tandoori Mix",
          "Tarragon",
          "Thai Creen Curry Mix",
          "Thai Red Curry Mix",
          "Thai Stir Fry",
          "Thyme",
          "Tikka Masala",
          "Tikka Masala Curry Powder",
          "Turmeric",
          "Turmeric Powder",
          "Vanilla Bean",
          "Vanilla Pods",
          "Vegetable Seasoning",
          "Zahtar Spice Mix"
        ],
        "sushi": [
          "Abalone",
          "Alaskan pink shrimp",
          "Amberjack",
          "Bastard halibut",
          "Bloody clam",
          "Botan shrimp",
          "Crab",
          "Dotted gizzard shad",
          "Eel",
          "Firefly squid",
          "Greater amberjack",
          "Halfbeak",
          "Horned turban",
          "Japanese horse mackerel",
          "Japanese sea bass",
          "Japanese spanish mackerel",
          "Japanese style-chunky omelette",
          "Japanese whiting",
          "Mackerel",
          "Milt",
          "Mirugai clam",
          "Octopus",
          "Orient clam",
          "Oyster",
          "Rosy seabass",
          "Salmon roe",
          "Salmon",
          "Scallop",
          "Sea bream",
          "Skipjack tuna",
          "Small amberjack",
          "Squid",
          "Trough shells",
          "Trout",
          "Tuna",
          "White trevally",
          "Whitespotted conger"
        ],
        "vegetables": [
          "Artichoke",
          "Arugula",
          "Asian Greens",
          "Asparagus",
          "Bean Shoots",
          "Bean Sprouts",
          "Beans",
          "Green beans",
          "Beetroot",
          "Bok Choy",
          "Broccoli",
          "Broccolini",
          "Brussels Sprouts",
          "Butternut lettuce",
          "Cabbage",
          "Capers",
          "Carob Carrot",
          "Carrot",
          "Cauliflower",
          "Celery",
          "Chilli Pepper",
          "Chinese Cabbage",
          "Fresh Chillies",
          "Dried Chinese Broccoli",
          "Cornichons",
          "Cos lettuce",
          "Cucumber",
          "Eggplant",
          "Endive",
          "English Spinach",
          "French eschallots",
          "Garlic",
          "Chives",
          "Green Pepper",
          "Hijiki",
          "Iceberg lettuce",
          "Jerusalem Artichoke",
          "Jicama",
          "Kale",
          "Kohlrabi",
          "Leeks",
          "Lettuce",
          "Onion",
          "Okra",
          "Parsnip",
          "Peas",
          "Peppers",
          "Potatoes",
          "Pumpkin",
          "Purple carrot",
          "Radicchio",
          "Radish",
          "Raspberry",
          "Red cabbage",
          "Red Pepper",
          "Rhubarb",
          "Snowpea sprouts",
          "Spinach",
          "Squash",
          "Sun dried tomatoes",
          "Sweet Potato",
          "Swiss Chard",
          "Turnips",
          "Zucchini"
        ]
      },
      "football": {
        "coaches": [
          "Ernesto Valverde",
          "Zinedine Zidane",
          "Jose Mourinho",
          "Antonio Conte",
          "Jurgen Klopp",
          "Mauricio Pochettino",
          "Diego Simeone",
          "Massimiliano Allegri",
          "Jupp Heyneckes",
          "Arsene Wenger",
          "Jorge Sampaoli",
          "Fernando Santos",
          "Didier Deschamps",
          "Joachim Low",
          "Julen Lopetegui",
          "Mauricio Pochettino",
          "Unai Emery",
          "Massimiliano Allegri",
          "Thomas Tuchel"
        ],
        "competitions": [
          "UEFA European Championship",
          "Asian Cup",
          "African Cup of Nations",
          "Copa America",
          "UEFA Champions League",
          "FIFA World Cup",
          "UEFA Europa League",
          "Serie A",
          "Barclays Premier League",
          "Bundesliga",
          "Liga Santander",
          "FA Cup",
          "Ligue 1",
          "Primeira Liga",
          "Eredivisie",
          "Super League",
          "Major League Soccer",
          "Coppa Italia",
          "DFB Pokal",
          "CONCACAF Gold Cup",
          "Nations Cup",
          "Copa del Rey"
        ],
        "players": [
          "Lionel Messi",
          "Gerard Pique",
          "Sergio Ramos",
          "Cristiano Ronaldo",
          "David De Gea",
          "Paul Pogba",
          "Antoine Griezmann",
          "Alvaro Morata",
          "Andres Iniesta",
          "Roberto Firmino",
          "Mohammed Salah",
          "Harry Kane",
          "Delle Alli",
          "Arjen Robben",
          "Franck Ribery",
          "Marco Reus",
          "Robert Lewandoski",
          "Zlatan Ibrahimovic",
          "Edinson Cavani",
          "Sergio Aguero",
          "Neymar",
          "Mesut Ozil",
          "Gianluigi Buffon",
          "Willian",
          "Manuel Neuer",
          "Juan Mata",
          "Manuel Neuer",
          "Cesc Fabregas",
          "Gareth Bale",
          "Eden Hazard",
          "Mario Mandzukic",
          "Kylian Mbappe"
        ],
        "positions": [
          "Goalkeeper",
          "Full Back",
          "Right Back",
          "Left Back",
          "Defensive Midfielder",
          "Midfielder",
          "Attacking Midfielder",
          "Right Midfielder",
          "Left Midfielder",
          "Right Wing",
          "Left Wing",
          "Second Striker",
          "Centre Forward"
        ],
        "teams": [
          "Real Madrid",
          "FC Barcelona",
          "Valencia CF",
          "Atletico Madrid",
          "Manchester United",
          "Chelsea",
          "Liverpool",
          "Arsenal",
          "Tottenham Hotspur",
          "AC Milan",
          "Inter Milan",
          "AS Roma",
          "Juventus",
          "Bayern Munich",
          "Borussia Dortmund",
          "Schalke 04",
          "Benfica",
          "Galatasaray",
          "PSV Eindhoven",
          "LA Galaxy",
          "Paris Saint Germain"
        ]
      },
      "friends": {
        "characters": [
          "Peter Becker",
          "Ben",
          "Chandler Bing",
          "Charles Bing",
          "Erica Bing",
          "Jack Bing",
          "Nora Tyler Bing",
          "Bonnie",
          "Amanda Buffamonteezi",
          "Frank Buffay, Jr.",
          "Frances Buffay",
          "Phoebe Buffay",
          "Ursula Buffay",
          "Joshua Burgin",
          "Richard Burke",
          "Chloe",
          "Will Colbert",
          "Danny",
          "David",
          "Rob Donnan",
          "Doug",
          "Eric",
          "Erica",
          "Erika",
          "Barry Farber",
          "Fun Bobby",
          "Gary",
          "Emma Geller",
          "Jack Geller",
          "Monica Geller",
          "Ross Geller",
          "Missy Goldberg",
          "Janice Goralnik",
          "Leonard Green",
          "Rachel Green",
          "Bitsy Hannigan",
          "Mike Hannigan",
          "Theodore Hannigan",
          "Mr. Heckles",
          "Benjamin Hobart",
          "Joanna",
          "Tag Jones",
          "Julie",
          "Kathy",
          "Kim",
          "Alice Knight",
          "Janine LaCroix",
          "Dr. Ledbetter",
          "Estelle Leonard",
          "Dr. Long",
          "Marcel",
          "Eddie Menuek",
          "Kate Miller",
          "Gavin Mitchell",
          "Molly",
          "Mona",
          "Susie Moss",
          "Parker",
          "Mark Robinson",
          "Roy",
          "Ryan",
          "Sandy",
          "Sophie",
          "Steve",
          "Elizabeth Stevens",
          "Paul Stevens",
          "Stu",
          "Terry",
          "Mr. Treeger",
          "Joey Tribbiani",
          "Ugly Naked Guy",
          "Mr. Waltham",
          "Andrea Waltham",
          "Emily Waltham",
          "Stephen Waltham",
          "Charlie Wheeler",
          "Mr. Zelner",
          "Carol Willick",
          "Miss Chanandler Bong"
        ],
        "locations": [
          "Monica's Apartment",
          "Central Perk",
          "Chandler and Joey's Apartment",
          "Monica and Chandler's House",
          "Phoebe's Apartment",
          "Ross' Third Apartment",
          "Javu",
          "Moondance Diner",
          "Allesandro's",
          "Bloomingdale's",
          "Ross' First Apartment",
          "Ross' Second Apartment",
          "Lincoln High School",
          "Joey's Apartment",
          "Monica and Ross' Parents House",
          "Becco",
          "Dot's Spot",
          "Carol and Susan's Apartment",
          "Gina's House",
          "Waltham House",
          "Celestino Custom Tailor",
          "Ernie's",
          "New York University",
          "Silvercup Studios",
          "Marcel's",
          "945 Grove St Apt. 20",
          "Ralph Lauren",
          "New York Museum of Prehistoric History",
          "Days of Our Lives",
          "15 Yemen Road, Yemen"
        ],
        "quotes": [
          "I can handle this. Handle is my middle name. Actually, handle is the middle of my first name.",
          "Pivot! Pivot! Pivot! Pivot! Pivot!",
          "Shut up! Shut up! Shut up!",
          "Joey doesn’t share food!",
          "Guys can fake it? Unbelievable! The one thing that’s ours!",
          "If you’re going to call me names, I would prefer Ross, the Divorce Force. It’s just cooler.",
          "All right, look if you absolutely have to tell her the truth, at least wait until the timing’s right. And that’s what deathbeds are for.",
          "Your teeth? Yeah, I saw them from outside.",
          "Dear God! This parachute is a knapsack!",
          "No, homo habilis was erect. Australopithecus was never fully erect.",
          "Well, maybe he was nervous.",
          "I’m glad we’re having a rehearsal dinner. I rarely practice my meals before I eat.",
          "Until I was 25 I thought the only response to ‘I love you’ was ‘Oh crap!'",
          "What’s not to like? Custard – good. Jam – good. Meat – good!",
          "No. Interestingly enough, her leaf blower picked up.",
          "You know what’s weird? Donald Duck never wore pants. But whenever he’s getting out of the shower, he always puts a towel around his waist. I mean, what is that about?",
          "Ross, just for my own peace of mind, you’re not married to any more of us are you?",
          "It’s a moo point. It’s like a cow’s opinion; it doesn’t matter. It’s moo.",
          "First divorce: wife’s hidden sexuality, not my fault. Second divorce: said the wrong name at the altar, kind of my fault. Third divorce: they shouldn’t let you get married when you’re that drunk and have stuff drawn all over your face, Nevada’s fault.",
          "It hurts my Joey’s apple!",
          "Oh, are you setting Ross up with someone? Does she have a wedding dress?",
          "Your collective dating record reads like a who’s who of human crap.",
          "If you don’t help me cook I’m going to take a bunch of those hot dogs and make a new appetiser called pigs in Ross.",
          "I’m not so good with the advice. Can I interest you in a sarcastic comment?",
          "No! No, Joey! U-N-I-sex.",
          "Oh look, ugly naked guy is decorating his Christmas tree! Wow, you should see the size of his Christmas balls!",
          "I can’t believe my Dad saw us having sex! He didn’t make it to one of my piano recitals, but this he sees!",
          "If you want to receive emails about my upcoming shows please give me money so I can buy a computer.",
          "Come on Ross you’re a palaeontologist – dig a little deeper.",
          "You can’t have S-E-X when your taking care of the B-A-B-I-E.",
          "A hundred million people went to see a movie about what I do. I wonder how many people would go see a movie called Jurassic Parka. No, no, no, a bunch of out-of-control jackets take over an island!",
          "Hey buddy, this is a family place. Put the mouse back in the house.",
          "I’m not someone who goes after a guy five minutes after he’s divorced.",
          "We were on a break!",
          "Oh, my God! If you say that one more time, I’m going to break up with you!",
          "How you doin’?",
          "Forty-two to twenty-one! Like the turkey, Ross is done!",
          "SEVEN! SEVEN! SEVEN!",
          "I'm Monica. I’m disgusting. I stalk guys and keep their underpants.",
          "Fine judge all you want but... married a lesbian, left a man at the altar, fell in love with a gay ice dancer, threw a girl’s wooden leg in the fire, LIVE IN A BOX.",
          "Welcome to the real world. It sucks. You’re gonna love it!",
          "Sure I peed on her. And if I had to, I’d pee on any one of you!",
          "If the homo sapiens were, in fact, HOMO sapiens…is that why they’re extinct?",
          "You could not be any more wrong. You could try, but you would not be successful.",
          "You’ve been BAMBOOZLED!",
          "It was summer… and it was hot. Rachel was there… A lonely grey couch…”OH LOOK!” cried Ned, and then the kingdom was his forever. The End.",
          "Je m’appelle Claude",
          "Raspberries? Good. Ladyfingers? Good. Beef? GOOD!",
          "Could I BE wearing any more clothes?",
          "Oh no, two women love me. They're both gorgeous and sexy. My wallet's too small for my fifties AND MY DIAMOND SHOES ARE TOO TIGHT."
        ]
      },
      "fullmetal_alchemist_brotherhood": {
        "characters": [
          "Edward Elric",
          "Alphonse Elric",
          "Roy Mustang",
          "Riza Hawkeye",
          "Scar",
          "Winry Rockbell",
          "May Chang",
          "Maes Hughes",
          "Alex Louis Armstrong",
          "Jean Havoc",
          "Heymans Breda",
          "Vato Fallman",
          "Kain Feury",
          "Führer King Bradley",
          "Maria Ross",
          "Denny Brosh",
          "Yoki",
          "Izumi Curtis",
          "Sig Curtis",
          "Pinako Rockbell",
          "Den The Dog",
          "Shou Tucker",
          "Tim Marco",
          "Lust",
          "Gluttony",
          "Envy",
          "Greed",
          "Sloth",
          "Pride",
          "Wrath",
          "Selim Bradley",
          "Roa",
          "Martel",
          "Dolceto",
          "Number 66",
          "Number 48",
          "Scar",
          "Father",
          "Dominic",
          "Garfield",
          "Giolio Comanche",
          "Basque Grand",
          "Isaac McDougal",
          "Solf J. Kimblee",
          "Van Hohenheim",
          "Fu",
          "Ling Yao",
          "Lan Fan",
          "Olivier Mira Armstrong",
          "Buccaneer",
          "Major Miles",
          "Trisha Elric",
          "Rose",
          "Nina",
          "Sheska"
        ],
        "cities": [
          "East City",
          "Rush Valley",
          "Resembool",
          "Dublith",
          "Central City",
          "Ishval",
          "Youswell",
          "North City",
          "Lior",
          "Pendleton",
          "Riviere"
        ],
        "countries": [
          "Amestris",
          "Aerugo",
          "Creta",
          "Drachma",
          "Xerxes",
          "Xing"
        ]
      },
      "funny_name": {
        "name": [
          "Aaron Thetires",
          "Abbie Birthday",
          "Abe Rudder",
          "Abel N. Willan",
          "Adam Baum",
          "Adam Bomb",
          "Adam Meway",
          "Adam Sapple",
          "Adam Zapel",
          "Agatha L. Outtathere",
          "Al B. Tross",
          "Al B. Zienya",
          "Al Dente",
          "Al Fresco",
          "Al Gore Rythim",
          "Al K. Seltzer",
          "Al Kaholic",
          "Al Kaseltzer",
          "Al Luminum",
          "Al Nino",
          "Al O'Moaney",
          "Alec Tricity",
          "Alex Blaine Layder",
          "Alf A. Romeo",
          "Alf Abet",
          "Ali Gaither",
          "Ali Gator",
          "Ali Katt",
          "Allen Rench",
          "Amanda B. Reckonwith",
          "Amanda Lynn",
          "Andy Friese",
          "Andy Gravity",
          "Andy Structible",
          "Anita Bath",
          "Anita Bathe",
          "Anita Job",
          "Anita Knapp",
          "Ann B. Dextrous",
          "Ann Chovie",
          "Ann Tartica",
          "Anna Conda",
          "Anna Graham",
          "Anna Mull",
          "Anna Prentice",
          "Anna Sasin",
          "Anna Septic",
          "Anne T. Lope",
          "Anne Teak",
          "Anne Ville",
          "Annette Curtain",
          "Annie Buddyhome",
          "Annie Howe",
          "Annie Matter",
          "Annie Moore",
          "April Schauer",
          "Arch N. Emmy",
          "Aretha Holly",
          "Ariel Hassle",
          "Armand Hammer",
          "Art Exhibit",
          "Art Major",
          "Art Painter",
          "Art Sellers",
          "Artie Choke",
          "Ayma Moron",
          "B. A. Ware",
          "Barb Dwyer",
          "Barb Dwyer",
          "Barb E. Cue",
          "Barb E. Dahl",
          "Barry Cade",
          "Barry D'Alive",
          "Barry D. Hatchett",
          "Barry Shmelly",
          "Bart Ender",
          "Bea Lowe",
          "Bea Minor",
          "Bea Sting",
          "Beau Tye",
          "Beau Vine",
          "Ben Crobbery",
          "Ben D. Fender",
          "Ben Dover",
          "Ben Down",
          "Ben Lyon",
          "Ben O'Drill",
          "Ben Thair",
          "Bertha D. Blues",
          "Bess Eaton",
          "Bess Twishes",
          "Biff Wellington",
          "Bill Board",
          "Bill Ding",
          "Bill Dollar",
          "Bill Foldes",
          "Bill Loney",
          "Bill Lowney",
          "Bill Ng",
          "Bill Overdew",
          "Billy Rubin",
          "Bjorn Free",
          "Bo D. Satva",
          "Bo Nessround",
          "Bob Frapples",
          "Bob Inforapples",
          "Bob Katz",
          "Bob Ng",
          "Bob Sledd",
          "Bonnie Ann Clyde",
          "Bowen Arrow",
          "Brandon Cattell",
          "Brandon Irons",
          "Brandy Anne Koch",
          "Brandy Bottle",
          "Brandy D. Cantor",
          "Braxton Hicks",
          "Brice Tagg",
          "Brighton Early",
          "Brock Lee",
          "Brook Lynn Bridge",
          "Brooke Trout",
          "Brooke Waters",
          "Bruce Easley",
          "Buck Ng",
          "Bud Weiser",
          "Buddy Booth",
          "Buddy System",
          "C. Worthy",
          "Cal Culator",
          "Cal Efornia",
          "Cal Seeium",
          "Cam Payne",
          "Cammie Sole",
          "Candace Spencer",
          "Candice B. DePlace",
          "Candice B. Fureal",
          "Candy Barr",
          "Candy Baskett",
          "Candy Kane",
          "Cara Van",
          "Carl Arm",
          "Carlotta Tendant",
          "Carrie A. Tune",
          "Carrie Dababi",
          "Carrie Oakey",
          "Carson O. Gin",
          "Chad Terbocks",
          "Chanda Lear",
          "Charity Case",
          "Cheri Pitts",
          "Chi Spurger",
          "Chip Munk",
          "Chris Coe",
          "Chris Cross",
          "Chris Ko",
          "Chris Mass",
          "Chris P. Bacon",
          "Chris P. Nugget",
          "Chris P. Wheatzenraisins",
          "Chrystal Glass",
          "Chuck Roast",
          "Claire Annette",
          "Claire Annette Reed",
          "Claire DeAir",
          "Claire Voyance",
          "Clara Nett",
          "Clara Sabell",
          "Cody Pendant",
          "Cole Durkee",
          "Cole Kutz",
          "Colette A. Day",
          "Colin Allcars",
          "Colleen Cardd",
          "Constance Noring",
          "Corey Ander",
          "Count Orff",
          "Crystal Ball",
          "Crystal Claire Waters",
          "Crystal Glass",
          "Curt N. Rodd",
          "Curt Zee",
          "Cy Burns",
          "Cy Kosis",
          "Daisy Chain",
          "Daisy Picking",
          "Dale E. Bread",
          "Dan D. Lyon",
          "Dan Deline",
          "Dan Druff",
          "Dan Geruss",
          "Dan Saul Knight",
          "Danielle Soloud",
          "Darrell B. Moore",
          "Darren Deeds",
          "Darryl Likt",
          "Dee Kay",
          "Dee Liver",
          "Dee Major",
          "Dee Sember",
          "Dee Zaster",
          "Dennis Toffice",
          "Denny Juan Heredatt",
          "Des Buratto",
          "Di O'Bolic",
          "Diane Toluvia",
          "Didi Reelydoit",
          "Dinah Might",
          "Dinah Soares",
          "Doll R. Bill",
          "Don Key",
          "Don Thatt",
          "Doris Open",
          "Doris Schutt",
          "Doug Graves",
          "Doug Hole",
          "Doug Love Fitzhugh",
          "Doug Updegrave",
          "Doug Witherspoon",
          "Douglas Furr",
          "Douglas S. Halfempty",
          "Drew Blood",
          "Duane DeVane",
          "Duane Pipe",
          "Dustin D. Furniture",
          "Dusty Carr",
          "Dusty Rhodes",
          "Dusty Sandmann",
          "Dusty Storm",
          "Dwayne Pipe",
          "E. Ville",
          "Earl E. Byrd",
          "Earl Lee Riser",
          "Easton West",
          "Eaton Wright",
          "Ed Ible",
          "Ed Jewcation",
          "Ed Venture",
          "Eddie Bull",
          "Eileen Dover",
          "Eli Ondefloor",
          "Ella Vader",
          "Elle O'Quent",
          "Ellie Noise",
          "Elmer Sklue",
          "Emerald Stone",
          "Emile Eaton",
          "Emma Royds",
          "Estelle Hertz",
          "Ethel L. Cahall",
          "Evan Keel",
          "Evan Lee Arps",
          "Evans Gayte",
          "Eve Hill",
          "Eve Ning",
          "Eve O'Lution",
          "Ewan Whatarmy",
          "Father A. Long",
          "Faye Kinnitt",
          "Faye Slift",
          "Faye Tallity",
          "Ferris Wheeler",
          "Fletcher Bisceps",
          "Ford Parker",
          "Frank Enstein",
          "Frank Furter",
          "Frank N. Beans",
          "Frank N. Sense",
          "Frank N. Stein",
          "Freida Convict",
          "Gene E. Yuss",
          "Gene Poole",
          "George Washington Sleptier",
          "Gil T. Azell",
          "Ginger Rayl",
          "Ginger Snapp",
          "Ginger Vitis",
          "Gladys C. Hughes",
          "Gladys Eeya",
          "Godiva Headache",
          "Gus Tofwin",
          "Hal E. Luya",
          "Hal Jalikakick",
          "Hammond Eggs",
          "Hare Brain",
          "Harmon Ikka",
          "Harrison Fire",
          "Harry Armand Bach",
          "Harry Beard",
          "Harry Caray",
          "Harry Chest",
          "Harry Legg",
          "Harry Pitts",
          "Harry R. M. Pitts",
          "Hayden Seek",
          "Haywood Jashootmee",
          "Hazel Nutt",
          "Heather N. Yonn",
          "Hein Noon",
          "Helen Back",
          "Helen Highwater",
          "Helena Hanbaskett",
          "Herb E. Side",
          "Herbie Voor",
          "Hilda Climb",
          "Holly Day",
          "Holly Wood",
          "Homan Provement",
          "Hope Ferterbest",
          "Howard I. No",
          "Howe D. Pardner",
          "Howie Doohan",
          "Hugh Mungous",
          "Hugh deMann",
          "Hugo First",
          "Hy Ball",
          "Hy Gene",
          "Hy Lowe",
          "Hy Marx",
          "Hy Price",
          "I. Ball",
          "I. D. Clair",
          "I. Lasch",
          "I. M. Boring",
          "I. P. Daly",
          "I. P. Freely",
          "I. Pullem",
          "I. Ron Stomach",
          "Ida Whana",
          "Igor Beaver",
          "Ilene Dover",
          "Ilene East",
          "Ilene Left",
          "Ilene North",
          "Ilene South",
          "Ilene West",
          "Ilene Wright",
          "Ima B. Leever",
          "Ima Hogg",
          "Ima Klotz",
          "Ima Lytle Teapot",
          "Iona Corolla",
          "Iona Ford",
          "Iona Frisbee",
          "Ira Fuse",
          "Isadore Bell",
          "Ivan Oder",
          "Izzy Backyet",
          "Jack Dupp",
          "Jack Hammer",
          "Jack Pott",
          "Jack Tupp",
          "Jacklyn Hyde",
          "Jacques Strap",
          "Jade Stone",
          "Jan U. Wharry",
          "Jane Linkfence",
          "Jaqueline Hyde",
          "Jasmine Flowers",
          "Jasmine Rice",
          "Jay Bird",
          "Jay Walker",
          "Jean Poole",
          "Jeanette Akenja Nearing",
          "Jed Dye",
          "Jed I. Knight",
          "Jeff Healitt",
          "Jerry Atrics",
          "Jim Laucher",
          "Jim Nasium",
          "Jim Shorts",
          "Jim Shu",
          "Jim Sox",
          "Jimmy DeLocke",
          "Jo King",
          "Joanna Hand",
          "Joaquin DeFlores",
          "Joe Czarfunee",
          "Joe Kerr",
          "Joe King",
          "Joy Anna DeLight",
          "Joy Kil",
          "Joy Rider",
          "Juan De Hattatime",
          "Juan Fortharoad",
          "Juan Morefore DeRhode",
          "Juan Nightstand",
          "Juana Bea",
          "June Bugg",
          "Justin Case",
          "Justin Casey Howells",
          "Justin Credible",
          "Justin Inch",
          "Justin Sane",
          "Justin Thyme",
          "Justin Tune",
          "Kandi Apple",
          "Kareem O'Weet",
          "Kat Toy",
          "Katy Litter",
          "Kay Mart",
          "Kay Neine",
          "Ken Dahl",
          "Ken Oppenner",
          "Kenney C. Strait",
          "Kenny Dewitt",
          "Kenny Penny",
          "Kent Cook",
          "Kenya Dewit",
          "Kerry Oki",
          "Kim Payne Slogan",
          "Kitty Katz",
          "Kristie Hannity",
          "Kurt Remarque",
          "Lake Speed",
          "Lance Lyde",
          "Laura Norder",
          "Lee Nover",
          "Leigh King",
          "Len DeHande",
          "Leo Tarred",
          "Les Moore",
          "Les Payne",
          "Les Plack",
          "Lily Livard",
          "Lily Pond",
          "Lina Ginster",
          "Lisa Carr",
          "Lisa Ford",
          "Lisa Honda",
          "Lisa Neucar",
          "Liv Good",
          "Liv Long",
          "Liz Onnia",
          "Lois Price",
          "Lon Moore",
          "Lou Briccant",
          "Lou Dan Obseen",
          "Lou Pole",
          "Lou Stooth",
          "Lou Zar",
          "Louise E. Anna",
          "Lowden Clear",
          "Lucy Fer",
          "Luke Adam Go",
          "Luke Warm",
          "Luna Tick",
          "Lynn Guini",
          "Lynn Meabuck",
          "Lynn O. Liam",
          "M. Balmer",
          "M. T. Toombe",
          "Mabel Syrup",
          "Macon Paine",
          "Mandy Lifeboats",
          "Manny Kinn",
          "Manuel Labor",
          "Marco DeStinkshun",
          "Marcus Absent",
          "Marge Innastraightline",
          "Marj Oram",
          "Mark A. Roni",
          "Mark Mywords",
          "Mark Z. Spot",
          "Marlon Fisher",
          "Marsha Dimes",
          "Marsha Mellow",
          "Marshall Law",
          "Marty Graw",
          "Marv Ellis",
          "Mary A. Richman",
          "Mary Ann Bright",
          "Mary Gold",
          "Mary Ott",
          "Mary Thonn",
          "Mason Jarr",
          "Matt Tress",
          "Maude L. T. Ford",
          "Maurice Minor",
          "Max E. Mumm",
          "Max Little",
          "Max Power",
          "May Day",
          "May Furst",
          "May K. Fist",
          "May O'Nays",
          "Megan Bacon",
          "Mel Function",
          "Mel Loewe",
          "Mel Practiss",
          "Melanie Letters",
          "Melba Crisp",
          "Michael Otto Nuys",
          "Michelle Lynn",
          "Midas Well",
          "Mike Czech",
          "Mike Raffone",
          "Mike Rohsopht",
          "Mike Stand",
          "Milly Graham",
          "Milly Meter",
          "Milton Yermouth",
          "Minnie Skurt",
          "Minny van Gogh",
          "Miss Alanius",
          "Missy Sippy",
          "Misty C. Shore",
          "Misty Meanor",
          "Misty Shore",
          "Misty Waters",
          "Mitch Again",
          "Moe DeLawn",
          "Moe Skeeto",
          "Molly Kuehl",
          "Morey Bund",
          "Morgan U. Canhandle",
          "Mort Tallity",
          "Myles Long",
          "Myra Maines",
          "Neil B. Formy",
          "Neil Down",
          "Neve Adda",
          "Nick L. Andime",
          "Nick O'Teen",
          "Nick O'Time",
          "Nick Ovtime",
          "Nida Lyte",
          "Noah Lott",
          "Noah Riddle",
          "Olive Branch",
          "Olive Green",
          "Olive Hoyl",
          "Olive Yew",
          "Oliver Sutton",
          "Ophelia Payne",
          "Oren Jellow",
          "Oscar Ruitt",
          "Otto B. Kilt",
          "Otto Carr",
          "Otto Graf",
          "Otto Whackew",
          "Owen Big",
          "Owen Cash",
          "Owen Money",
          "Owen Moore",
          "P. Brain",
          "Paige Turner",
          "Park A. Studebaker",
          "Parker Carr",
          "Pat Downe",
          "Pat Pending",
          "Patton Down DeHatches",
          "Pearl E White",
          "Pearl E. Gates",
          "Pearl E. Whites",
          "Peg Legge",
          "Penny Bunn",
          "Penny Lane",
          "Penny Nichols",
          "Penny Profit",
          "Penny Whistler",
          "Penny Wise",
          "Pepe C. Cola",
          "Pepe Roni",
          "Perry Mecium",
          "Pete Moss",
          "Pete Zaria",
          "Phil A. Delphia",
          "Phil A. Mignon",
          "Phil DeGrave",
          "Phil Graves",
          "Phil Rupp",
          "Phillip D. Bagg",
          "Polly Dent",
          "Polly Ester",
          "Quimby Ingmeen",
          "Quint S. Henschel",
          "R. M. Pitt",
          "Raney Schauer",
          "Ray Gunn",
          "Ray N. Carnation",
          "Ray Zenz",
          "Raynor Schein",
          "Reed Toomey",
          "Reid Enright",
          "Renee Sance",
          "Rex Easley",
          "Rex Karrs",
          "Rhea Curran",
          "Rhea Pollster",
          "Rhoda Booke",
          "Rhoda Mule",
          "Rich Feller",
          "Rich Guy",
          "Rich Kidd",
          "Rich Mann",
          "Rick Kleiner",
          "Rick O'Shea",
          "Rick Shaw",
          "Ricky T. Ladder",
          "Rip Tile",
          "Rip Torn",
          "Rita Booke",
          "Rita Story",
          "Rob A. Bank",
          "Rob Banks",
          "Robin Andis Merryman",
          "Robin Banks",
          "Robin DeCraydle",
          "Robin Meeblind",
          "Robin Money",
          "Rocky Beach",
          "Rocky Mountain",
          "Rocky Rhoades",
          "Rocky Shore",
          "Rod N. Reel",
          "Roger Overandout",
          "Roman Holiday",
          "Ron A. Muck",
          "Rory Storm",
          "Rosa Shore",
          "Rose Bush",
          "Rose Gardner",
          "Rosie Peach",
          "Rowan Boatman",
          "Royal Payne",
          "Rufus Leaking",
          "Russell Ingleaves",
          "Russell Sprout",
          "Rusty Blades",
          "Rusty Carr",
          "Rusty Dorr",
          "Rusty Fender",
          "Rusty Fossat",
          "Rusty Irons",
          "Rusty Keyes",
          "Rusty Nails",
          "Rusty Pipes",
          "Rusty Steele",
          "Ryan Carnation",
          "Ryan Coke",
          "Sal A. Mander",
          "Sal Ami",
          "Sal Minella",
          "Sal Sage",
          "Sally Forth",
          "Sally Mander",
          "Sam Dayoulpay",
          "Sam Manilla",
          "Sam Pull",
          "Sam Urai",
          "Samson Night",
          "Sandy Banks",
          "Sandy Beech",
          "Sandy C. Shore",
          "Sandy Spring",
          "Sarah Bellum",
          "Sarah Doctorinthehouse",
          "Sasha Klotz",
          "Sawyer B. Hind",
          "Scott Shawn DeRocks",
          "Seymour Legg",
          "Shanda Lear",
          "Shandy Lear",
          "Sharon A. Burger",
          "Sheri Cola",
          "Sherman Wadd Evver",
          "Shirley Knot",
          "Shirley U. Jest",
          "Sid Down",
          "Simon Swindells",
          "Sir Fin Waves",
          "Skip Dover",
          "Skip Roper",
          "Skip Stone",
          "Sonny Day",
          "Stan Dup",
          "Stan Still",
          "Stew Ng",
          "Stu Pitt",
          "Sue Case",
          "Sue Flay",
          "Sue Jeu",
          "Sue Permann",
          "Sue Render",
          "Sue Ridge",
          "Sue Shi",
          "Sue Yu",
          "Sy Burnette",
          "Tad Moore",
          "Tad Pohl",
          "Tamara Knight",
          "Tanya Hyde",
          "Tate Urtots",
          "Taylor Maid",
          "Ted E. Baer",
          "Telly Vision",
          "Terry Achey",
          "Terry Bull",
          "Theresa Brown",
          "Theresa Green",
          "Therese R. Green",
          "Thor Luther",
          "Tim Burr",
          "Tina See",
          "Tish Hughes",
          "Tom A. Toe",
          "Tom Katt",
          "Tom Katz",
          "Tom Morrow",
          "Tommy Gunn",
          "Tommy Hawk",
          "Trina Corder",
          "Trina Forest",
          "Trina Woods",
          "Ty Coon",
          "Ty Knotts",
          "Ty Malone",
          "Ty Tannick",
          "Ty Tass",
          "Tyrone Shoes",
          "U. O. Money",
          "U. P. Freehly",
          "Ulee Daway",
          "Val Crow",
          "Val Lay",
          "Val Veeta",
          "Vlad Tire",
          "Walt Smedley",
          "Walter Melon",
          "Wanda Rinn",
          "Warren Piece",
          "Warren T.",
          "Wayne Deer",
          "Will Power",
          "Will Wynn",
          "Willie Maykit",
          "Willie Waite",
          "Wilma Leggrowbach",
          "Winnie Bago",
          "Winnie Dipoo",
          "Winsom Cash",
          "Woody Forrest",
          "Woody U. No",
          "X. Benedict",
          "Xavier Breath",
          "Xavier Money",
          "Yule B. Sari",
          "Zeke N. Yeshallfind",
          "Zoe Mudgett Hertz",
          "Zoltan Pepper"
        ]
      },
      "futurama": {
        "characters": [
          "Abner Doubledeal",
          "Al Gore's Head",
          "Amy Wong",
          "Antonio Calculon",
          "Barbados Slim",
          "Bender Bending Rodriguez",
          "Boxy",
          "Brain Slugs",
          "Brain Spawn",
          "Bubblegum Tate",
          "Calculon",
          "Chanukah Zombie",
          "Clamps",
          "Cubert Farnsworth",
          "Doctor John Zoidberg",
          "Donbot",
          "Dr. Ogden Wernstrom",
          "Dwight Conrad",
          "Elzar",
          "Father Changstein-El-Gamal",
          "Flexo",
          "Gypsy-bot",
          "Hattie McDoogal",
          "Headless Body of Agnew",
          "Hedonismbot",
          "Hermes Conrad",
          "Horrible Gelatinous Blob",
          "Hyperchicken",
          "Hypnotoad",
          "Inez Wong",
          "Joey Mousepad",
          "Kif Kroker",
          "Kwanzaabot",
          "LaBarbara Conrad",
          "Leo Wong",
          "Linda van Schoonhoven",
          "Lord Nibbler",
          "Lrrr",
          "Michelle",
          "Mom",
          "Morbo the Annihilator",
          "Mr. Panucci",
          "Pazuzu",
          "Petunia",
          "Philip J. Fry",
          "Professor Hubert J. Farnsworth",
          "Randy Munchnik",
          "Reverend Lionel Preacherbot",
          "Richard Nixon's Head",
          "Roberto",
          "Robot Devil",
          "Robot Santa",
          "Sal",
          "Scruffy",
          "Smitty",
          "Stephen Hawking",
          "The Crushinator",
          "Tinny Tim",
          "Turanga Leela",
          "Turanga Morris",
          "Turanga Munda",
          "URL",
          "Warden Vogel",
          "Zapp Brannigan"
        ],
        "hermes_catchphrases": [
          "Cursed bacteria of Liberia!",
          "Great bonda of Uganda!",
          "Great cow of Moscow!",
          "Sacred boa of West and Eastern Samoa!",
          "Sacred hog of Prague!",
          "Sweet bongo of the Congo!",
          "Sweet candelabra of Le Havre, LaBarbara!",
          "Sweet coincidence of Port-au-Prince!",
          "Sweet fireball of Montreal!",
          "Sweet freak of Mozambique!",
          "Sweet ghost of Babylon!",
          "Sweet giant anteater of Santa Anita!",
          "Sweet gorilla of Manila!",
          "Sweet guinea pig of Winnipeg!",
          "Sweet honey bee of infinity!",
          "Sweet kookaburra of Edinburgh!",
          "Sweet lion of Zion!",
          "Sweet llamas of the Bahamas!",
          "Sweet manatee of Galilee!",
          "Sweet orca of Mallorca!",
          "Sweet reawakening of jamaicaing!",
          "Sweet something... of... someplace...!",
          "Sweet squid of Madrid!",
          "Sweet three-toed sloth of the ice planet Hoth!",
          "Sweet topology of cosmology!",
          "Sweet yeti of the Serengeti!"
        ],
        "locations": [
          "7¹¹",
          "Akbar",
          "Aldrin's Gulch",
          "Alien Overlord & Taylor",
          "Alien Zoo",
          "Amazonia",
          "Amish Homeworld",
          "Amphibios 9",
          "Antares System",
          "Anti-Chrysler building",
          "Apartment 00100100",
          "Apollo Theatre",
          "Applied Cryogenics",
          "Assisted Living Nebula",
          "Atlanta",
          "Atlantic City",
          "Atlantic Ocean",
          "Bender Statue",
          "Big Apple Bank",
          "Blernsball Hall of Fame",
          "Bogad",
          "Boston",
          "Brain Slug Planet",
          "Brooklyn",
          "Brooklyn Bridge",
          "Build-a-Bot",
          "Bumbase Alpha",
          "Cave of Hopelessness",
          "Cavern on the Green",
          "Central Bureaucracy",
          "Chapek 9",
          "Chrysler building",
          "Cineplex 14",
          "Circuit City",
          "CitiHall",
          "Coney Island Community College",
          "Cookieville Minimum-Security Orphanarium",
          "Cornwood",
          "Crack mansion",
          "CrindStar, Inc.",
          "Cyberia",
          "Cyclopia",
          "Cygnus 5",
          "DOOP Headquarters",
          "Decapod 10",
          "Decapodian Embassy",
          "Devil's Island",
          "Dogdoo 7",
          "Dogdoo 8",
          "Doohan 6",
          "Earth",
          "Ebola 9",
          "Eden 7",
          "Egypt",
          "Electric Ladyland",
          "Elzar's Fine Cuisine",
          "Empire State Building",
          "Eternium",
          "Eye Robot",
          "EyePhone Store",
          "Face on Mars",
          "Fishy Joe's",
          "Forbidden Zone",
          "Fountain of Aging",
          "Fronty's Meat Market",
          "Fry family house",
          "Future-Roma",
          "Galaxy of Terror",
          "Galápagos Islands",
          "Gandhi Nebula",
          "Gateway Arch",
          "GeneWorks, S.K.G.",
          "Geysers of Gygax",
          "Giza",
          "Globetrotter Homeworld Embassy",
          "Globetrotter Planet",
          "Glorianimous 3",
          "Hacking Jack's Fine Smokables",
          "Hal Institute for Criminally Insane Robots",
          "Halley's Comet",
          "Head Museum",
          "Intergalactic Stock Exchange",
          "Jupiter",
          "Keeler Canyon",
          "Kyoto",
          "Land Titanic",
          "Le Palm D'Orbit",
          "Leo Wong's \"Miniature\" Golf Course",
          "Little Bitaly",
          "Little Neptune",
          "Los Angeles",
          "Luna Park",
          "Madison Cube Garden",
          "Malfunctioning Eddie's Rocket-Car Emporium",
          "Manhattan",
          "Maple Craters",
          "Mars",
          "Mars University (location)",
          "Mars Vegas",
          "Mercury",
          "Mexico",
          "Milwaukee",
          "Milwaukee Mom's dark matter mine",
          "Mobile Oppression Palace",
          "Mom's Friendly Robot Company",
          "Mom's dark matter mine",
          "Monsanto Yokel Dome",
          "Monument Beach",
          "Moon",
          "Mount Rushmore",
          "Museum of Natural History",
          "NBC",
          "Nation of Joe",
          "Near Death Star",
          "Neptune",
          "Neutral Planet",
          "Neutropolis",
          "New New Jersey",
          "New New York",
          "New New York's Famous Original Ray's Superior Court",
          "Nigel 7",
          "Nintenduu 64",
          "Norway",
          "Nude Beach Planet",
          "Nukevada",
          "Nylar IV",
          "O'Cyris IV",
          "O'Grady's Pub",
          "O'Zorgnax's Pub",
          "Old New York",
          "Old New York Subway",
          "Omega 3",
          "Omicron Persei 8",
          "Orbiting Meadows National Cemetery",
          "Original lunar landing site",
          "Panucci's Pizza",
          "Parallel Universe",
          "Paris",
          "Past-O-Rama",
          "Peoples α",
          "Pet Shop",
          "Pisa",
          "Planet Earth",
          "Planet Express building",
          "Planet XXX",
          "Pluto",
          "Poopiter",
          "Reckless Ted's Funland",
          "Republic of French Stereotypes",
          "Robo-Hungarian Empire",
          "Robonia",
          "Robot Arms Apts",
          "Robot Hell",
          "Rockefeller Center",
          "Roswell",
          "Rumbledy-Hump (Planet)",
          "Sargaseous Sea",
          "Sewers of New New York",
          "Simian 7",
          "Simian 7 Zoo",
          "Slurm Factory",
          "Spa 5",
          "Spheron I",
          "Spleef Nebula",
          "St. Louis",
          "Starbabe's Cocoffee",
          "State of New New York",
          "Statue of Liberty",
          "Studio 1²2¹3³",
          "Stumbos IV",
          "Sub-sewer",
          "Svalvard Global Seed Vault",
          "Sweden",
          "Taco Bellevue Hospital",
          "Tarantulon 6",
          "Temple of Robotology",
          "That world that can't be mentioned in polite company",
          "The Hip Joint",
          "The Leaning Tower of Pisa",
          "The Robo-Hungarian Empir",
          "The Sewers of New New York",
          "The World",
          "Thermostadt",
          "Thermostadt Castle",
          "Third World of the Antares System",
          "Thuban 9",
          "Tokyo",
          "Tornadus",
          "Trisol",
          "Tweenis 12",
          "United States",
          "Universe Gamma",
          "Urectum",
          "V-GINY",
          "Venus",
          "Vergon 6",
          "Viga 4",
          "Vinci",
          "Violet Dwarf Star",
          "Washington, D.C.",
          "Wipe Castle",
          "Wong ranch",
          "Wormulon"
        ],
        "quotes": [
          "A fancy dress gala? I'll wear my formal shell.",
          "Ah, Xmas Eve. Another pointless day where I accomplish nothing.",
          "Bite my shiny metal ass.",
          "Blackmail is such an ugly word. I prefer extortion. The ‘x' makes it sound cool.",
          "Dammit Kif, where's the little umbrella? That's what makes it a scotch on the rocks!",
          "Did everything just taste purple for a second?",
          "Excuse my language but I have had it with you ruffling my petticoats!",
          "Fry, it's been years since medical school, so remind me. Disemboweling in your species, fatal or non-fatal?",
          "Gimme your biggest, strongest, cheapest drink!",
          "Have you ever tried simply turning off your TV, sitting down with your child, and hitting them?",
          "Hey sexy mama. Wanna kill all humans?",
          "Hey! I got a busted ass here and I don't see anyone kissing it!",
          "Honey, I wouldn't talk about taste if I was wearing a lime green tank top.",
          "Hot diggity daffodil!",
          "I don't have emotions & sometimes that makes me very sad.",
          "I don't remember ever fighting Godzilla… But that is so what I would have done!",
          "I don't want to live on this planet anymore.",
          "I got ants in my butt, and I needs to strut.",
          "I really ought to do something but I am already in my pyjamas.",
          "I took the liberty of fertilizing your caviar.",
          "It's when women are polite to each other you know there's a problem.",
          "I'm so embarrassed. I wish everybody else was dead.",
          "Men who call too much are the worst…I bet.",
          "My story is a lot like yours, only more interesting ‘cause it involves robots.",
          "Oh, no room for Bender, huh? Fine! I'll go build my own lunar lander, with blackjack and hookers. In fact, forget the lunar lander and the blackjack. Ahh, screw the whole thing!",
          "Shut up and take my money!",
          "Sweet llamas of the Bahamas!",
          "That's what they said about being alive!",
          "Ugh, it's like a party in my mouth & everyone's throwing up.",
          "Valentine's Day is coming up? Oh Crap, I forgot to get a girlfriend again!",
          "Well, if jacking on will make strangers think I'm cool, I'll do it",
          "We'll soon stage an attack on technology worthy of being chronicled in an anthem by Rush!",
          "We're making beer. I'm the brewery!",
          "When you look this good, you don't have to know anything!",
          "Wow! Sporty go-cart, Leela! So hip and sexy. Not like you at all.",
          "You know what cheers me up? Other people's misfortune."
        ]
      },
      "game": {
        "genre": [
          "First-person shooter",
          "Puzzle",
          "Platformer",
          "Action",
          "Adventure",
          "Real-time strategy",
          "Action role-playing",
          "Dungeon crawl",
          "Roguelike",
          "Tactical role-playing",
          "Sports",
          "Simulation",
          "Fighting",
          "Massively multiplayer online",
          "Stealth",
          "Survival",
          "Rhythm",
          "Survival horror",
          "Text adventure",
          "Visual novel",
          "Real-time strategy",
          "Multiplayer online battle arena",
          "Tower defense",
          "Trivia",
          "Real-time tactics",
          "Hack and slash",
          "Battle royale",
          "Third-person shooter",
          "Music"
        ],
        "platform": [
          "Xbox",
          "Xbox 360",
          "Xbox One",
          "PlayStation",
          "PlayStation 2",
          "PlayStation 3",
          "PlayStation 4",
          "PlayStation Portable",
          "PlayStation Vita",
          "Game Boy",
          "Game Boy Color",
          "Game Boy Advance",
          "Nintendo DS",
          "Nintendo DSi",
          "Nintendo 3DS",
          "Nintendo Entertainment System",
          "Super Nintendo Entertainment System",
          "Nintendo 64",
          "GameCube",
          "Wii",
          "Wii U",
          "Nintendo Switch",
          "Windows",
          "macOS",
          "Linux",
          "Sega Genesis",
          "Sega Master System",
          "Game Gear",
          "Sega Saturn",
          "Sega Dreamcast",
          "Virtual Boy"
        ],
        "title": [
          "Half-Life",
          "Half-Life: Opposing Force",
          "Half-Life: Blue Shift",
          "Half-Life 2",
          "Half-Life 2: Episode One",
          "Half-Life 2: Episode Two",
          "Half-Life 2: Lost Coast",
          "Portal",
          "Portal 2",
          "Team Fortress Classic",
          "Team Fortress 2",
          "Left 4 Dead",
          "Left 4 Dead 2",
          "Day of Defeat",
          "Ricochet",
          "Dota 2",
          "Counter-Strike",
          "Counter-Strike: Source",
          "Counter-Strike: Global Offensive",
          "Garry's Mod",
          "Super Mario Bros.",
          "Super Mario Bros. 2",
          "Super Mario Bros. 3",
          "Super Mario World",
          "Super Mario Sunshine",
          "Super Mario Galaxy",
          "Super Mario Galaxy 2",
          "Super Mario Odyssey",
          "Mario Kart 64",
          "Mario Kart: Double Dash",
          "Mario Kart DS",
          "Mario Kart Wii",
          "Mario Kart 7",
          "Mario Kart 8",
          "Mario Kart 8 Deluxe",
          "Luigi's Mansion",
          "Animal Crossing",
          "Animal Crossing: Wild World",
          "Animal Crossing: City Folk",
          "Animal Crossing: New Leaf",
          "Civilization III",
          "Civilization IV",
          "Civilization V",
          "Civilization VI",
          "The Legend of Zelda",
          "The Legend of Zelda: Ocarina of Time",
          "The Legend of Zelda: Majora's Mask",
          "The Legend of Zelda: Twilight Princess",
          "The Legend of Zelda: Skyward Sword",
          "The Legend of Zelda: Breath of the Wild",
          "Pong",
          "Pac-Man",
          "Starcraft",
          "Starcraft II",
          "Overwatch",
          "Hearthstone",
          "Halo: Combat Evolved",
          "Halo 2",
          "Halo 3",
          "Halo 3: ODST",
          "Halo: Reach",
          "Halo 4",
          "Halo 5: Guardians",
          "Wii Sports",
          "Wii Sports Resort",
          "Wii Play",
          "Wii Music",
          "Pokémon Red",
          "Pokémon Blue",
          "Pokémon Yellow",
          "Pokémon Gold",
          "Pokémon Silver",
          "Pokémon Crystal",
          "Pokémon Ruby",
          "Pokémon Sapphire",
          "Pokémon FireRed",
          "Pokémon LeafGreen",
          "Pokémon Emerald",
          "Pokémon Diamond",
          "Pokémon Pearl",
          "Pokémon Platinum",
          "Pokémon HeartGold",
          "Pokémon SoulSilver",
          "Pokémon Black",
          "Pokémon White",
          "Pokémon Black 2",
          "Pokémon White 2",
          "Pokémon X",
          "Pokémon Y",
          "Pokémon Omega Ruby",
          "Pokémon Alpha Sapphire",
          "Pokémon Sun",
          "Pokémon Moon",
          "Pokémon Ultra Sun",
          "Pokémon Ultra Moon",
          "Pokémon: Let's Go Pikachu!",
          "Pokémon: Let's Go Eevee!",
          "Pokémon Sword",
          "Pokémon Shield",
          "Doom",
          "Doom II",
          "Doom 3: BFG",
          "Quake",
          "Wolfenstein 3D",
          "Wolfenstein: The New Order",
          "Wolfenstein: The Old Blood",
          "Wolfenstein 2: The New Colossus",
          "Puyo Puyo Tetris",
          "Katamari Damacy",
          "Bastion",
          "Transistor",
          "System Shock",
          "BioShock",
          "BioShock Infinite",
          "Deus Ex",
          "Metroid Prime",
          "Metroid Prime 2: Echoes",
          "Metroid Prime 3: Corruption",
          "Super Meat Boy",
          "Super Smash Bros. Brawl",
          "Super Smash Bros. Melee",
          "Super Smash Bros. Ultimate",
          "Thief II",
          "Vampire: The Masquerade – Bloodlines",
          "Myst",
          "Batman: Arkham Asylum",
          "Batman: Arkham City",
          "Dishonored",
          "God of War",
          "LittleBigPlanet",
          "Grim Fandango",
          "Day of the Tentacle",
          "Kingdom Hearts",
          "Kingdom Hearts II",
          "The Last of Us",
          "Perfect Dark",
          "Shadow of the Colossus",
          "Fallout: New Vegas",
          "Fire Emblem Awakening",
          "Banjo-Kazooie: Grunty's Revenge",
          "Banjo-Kazooie: Nuts & Bolts",
          "Firewatch",
          "Mass Effect",
          "Mass Effect 2",
          "Mass Effect 3",
          "Mega Man",
          "Mega Man Battle Network",
          "Bayonetta",
          "Bayonetta 2",
          "The Wonderful 101",
          "Sleeping Dogs",
          "Battletoads",
          "Brütal Legend",
          "Halo Wars",
          "Clannad",
          "Highway Blossoms",
          "Infamous",
          "Crash Bandicoot",
          "Just Cause",
          "Just Cause 2",
          "Devil May Cry",
          "Life is Strange",
          "WarioWare: Smooth Moves",
          "WarioWare: Touched!",
          "Dwarf Fortress",
          "Dungeon Keeper",
          "Minecraft",
          "Fortnite",
          "PlayerUnknown's Battlegrounds",
          "Kirby's Adventure",
          "Kirby's Dream Land",
          "Kirby's Epic Yarn",
          "Yoshi's Wooly World",
          "L.A. Noire",
          "Kid Icarus",
          "Ice Climbers",
          "Crysis",
          "Crysis 2",
          "Hitman: Absolution",
          "Metal Gear Solid",
          "F-Zero",
          "F.E.A.R.",
          "Max Payne",
          "Max Payne 2: The Fall of Max Payne",
          "Max Payne 3",
          "Far Cry",
          "Castle Crashers",
          "Sonic Unleashed",
          "Mirror's Edge",
          "The Witcher",
          "The Witcher 2: Assassins of Kings",
          "The Witcher 3: Wild Hunt",
          "Monster Hunter: World",
          "Call of Duty",
          "Call of Duty 4: Modern Warfare",
          "Call of Duty: Modern Warfare Remastered",
          "Call of Duty: Modern Warfare 2",
          "Call of Duty: Modern Warfare 3",
          "Call of Duty: World at War",
          "Call of Duty: Black Ops",
          "Call of Duty: Black Ops II",
          "Call of Duty: Black Ops III",
          "Call of Duty: Black Ops 4",
          "Shadow Tactics: Blade of the Shogun",
          "Commandos: Behind Enemy Lines",
          "Commandos: Beyond the Call of Duty",
          "Commandos 2: Men of Courage",
          "Commandos 3: Destination Berlin",
          "Commandos: Strike Force",
          "Desperados: Wanted Dead or Alive",
          "Desperados 2: Cooper's Revenge",
          "Helldorado",
          "Desperados III",
          "Diablo",
          "Diablo II",
          "Diablo III",
          "Guitar Hero",
          "Command & Conquer: Red Alert",
          "Command & Conquer: Red Alert 2",
          "Command & Conquer: Red Alert 3",
          "Command & Conquer: Red Alert 2 - Yuris Revenge",
          "Command & Conquer: Generals",
          "Command & Conquer: Generals - Zero Hour",
          "Command & Conquer: Tiberian Sun",
          "Command & Conquer 3: Tiberium Wars",
          "Command & Conquer 4: Tiberian Twilight",
          "Command & Conquer: Rivals",
          "Command & Conquer: Tiberium Alliances"
        ]
      },
      "game_of_thrones": {
        "characters": [
          "Abelar Hightower",
          "Addam",
          "Addam Frey",
          "Addam Marbrand",
          "Addam Osgrey",
          "Addam Velaryon",
          "Addison Hill",
          "Aegon Blackfyre",
          "Aegon Frey",
          "Aegon I Targaryen",
          "Aegon II Targaryen",
          "Aegon III Targaryen",
          "Aegon IV Targaryen",
          "Aegon V Targaryen",
          "Aegon Targaryen",
          "Aegor Rivers",
          "Aelinor Penrose",
          "Aemma Arryn",
          "Aemon Blackfyre",
          "Aemon Costayne",
          "Aemon Estermont",
          "Aemon Rivers",
          "Aemon Targaryen",
          "Aemond Targaryen",
          "Aenys Frey",
          "Aenys I Targaryen",
          "Aerion Targaryen",
          "Aeron Greyjoy",
          "Aerys I Targaryen",
          "Aerys II Targaryen",
          "Aethan",
          "Aethelmure",
          "Aggar",
          "Aggo",
          "Aglantine",
          "Agrivane",
          "Aladale Wynch",
          "Alan",
          "Alannys Harlaw",
          "Alaric of Eysen",
          "Alayaya",
          "Albar Royce",
          "Albett",
          "Alebelly",
          "Alekyne Florent",
          "Alequo Adarys",
          "Alerie Hightower",
          "Alesander Frey",
          "Alesander Staedmon",
          "Alesander Torrent",
          "Alester Florent",
          "Alester Norcross",
          "Alester Oakheart",
          "Alfyn",
          "Alia",
          "Alicent Hightower",
          "All-for-Joffrey",
          "Alla Tyrell",
          "Allaquo",
          "Allar Deem",
          "Allard Seaworth",
          "Alliser Thorne",
          "Allyria Dayne",
          "Alvyn Sharp",
          "Alyce",
          "Alyce Graceford",
          "Alyn",
          "Alyn Ambrose",
          "Alyn Cockshaw",
          "Alyn Connington",
          "Alyn Estermont",
          "Alyn Frey",
          "Alyn Haigh",
          "Alyn Hunt",
          "Alyn Stackspear",
          "Alyn Velaryon",
          "Alys Arryn",
          "Alys Karstark",
          "Alysane Mormont",
          "Alysanne Bracken",
          "Alysanne Bulwer",
          "Alysanne Hightower",
          "Alysanne Lefford",
          "Alysanne of Tarth",
          "Alysanne Osgrey",
          "Alysanne Targaryen",
          "Alys Frey",
          "Alyssa Arryn",
          "Alyssa Blackwood",
          "Alyx Frey",
          "Amabel",
          "Amarei Crakehall",
          "Ambrode",
          "Ambrose Butterwell",
          "Amerei Frey",
          "Amory Lorch",
          "Andar Royce",
          "Anders Yronwood",
          "Andrew Estermont",
          "Andrey Charlton",
          "Andrey Dalt",
          "Andrik",
          "Andros Brax",
          "Androw Ashford",
          "Androw Frey",
          "Anguy",
          "Annara Farring",
          "Antario Jast",
          "Anvil Ryn",
          "Anya Waynwood",
          "Archibald Yronwood",
          "Ardrian Celtigar",
          "Areo Hotah",
          "Argilac",
          "Argrave the Defiant",
          "Arianne Martell",
          "Arianne of Tarth",
          "Arlan of Pennytree",
          "Armen",
          "Armond Caswell",
          "Arneld",
          "Arnell",
          "Arnolf Karstark",
          "Aron Santagar",
          "Arrec Durrandon",
          "Arron",
          "Arron Qorgyle",
          "Artys Arryn",
          "Arryk",
          "Arson",
          "Arthor Karstark",
          "Arthur Ambrose",
          "Arthur Dayne",
          "Artos Stark",
          "Arwood Frey",
          "Arwyn Frey",
          "Arwyn Oakheart",
          "Arya Stark",
          "Arys Oakheart",
          "Asha Greyjoy",
          "Ashara Dayne",
          "Lord Ashford",
          "Assadora of Ibben",
          "Aubrey Ambrose",
          "Aurane Waters",
          "Axell Florent",
          "Ayrmidon",
          "Azzak",
          "Azor Ahai",
          "Bael the Bard",
          "Baela Targaryen",
          "Baelon Targaryen",
          "Baelor Blacktyde",
          "Baelor Hightower",
          "Baelor I Targaryen",
          "Baelor Targaryen",
          "Ballabar",
          "Balman Byrch",
          "Balon Botley",
          "Balon Greyjoy",
          "Balon Swann",
          "Bandy",
          "Bannen",
          "Barba Bracken",
          "Barbara Bracken",
          "Barbrey Dustin",
          "Barra",
          "Barre",
          "Barristan Selmy",
          "Barsena Blackhair",
          "Barth",
          "Barthogan Stark",
          "Bass",
          "Bayard Norcross",
          "Bearded Ben",
          "Beardless Dick",
          "Becca",
          "Becca the Baker",
          "Beck",
          "Bedwyck",
          "Belandra",
          "Belaquo Bonebreaker",
          "Beldecar",
          "Belgrave",
          "Belis",
          "Bella",
          "Bellegere Otherys",
          "Bellena Hawick",
          "Bellonara Otherys",
          "Belwas",
          "Ben",
          "Ben Blackthumb",
          "Ben Bones",
          "Ben Bushy",
          "Ben Plumm",
          "Benedar Belmore",
          "Benedict",
          "Benedict Broom",
          "Benfred Tallhart",
          "Benfrey Frey",
          "Benjen Stark",
          "Benjen the Bitter",
          "Benjen the Sweet",
          "Bennard Brune",
          "Bennarion Botley",
          "Bennet",
          "Bennis",
          "Beqqo",
          "Beren Tallhart",
          "Berena Hornwood",
          "Beric Dondarrion",
          "Beron Stark",
          "Beron Blacktyde",
          "Bertram Beesbury",
          "Bess Bracken",
          "Bessa",
          "Beth Cassel",
          "Bethany (Blushing Bethany)",
          "Bethany Bolton",
          "Bethany Bracken",
          "Bethany Fair-Fingers",
          "Bethany Redwyne",
          "Bethany Rosby",
          "Betharios of Braavos",
          "Bhakaz zo Loraq",
          "Bharbo",
          "Big Boil",
          "Biter",
          "Black Balaq",
          "Black Bernarr",
          "Black Jack Bulwer",
          "Blane",
          "Blind Doss",
          "Bloodbeard",
          "Bluetooth",
          "Bodger",
          "Bonifer Hasty",
          "Borcas",
          "Boremund Harlaw",
          "Boros Blount",
          "Borroq",
          "Bors",
          "Bowen Marsh",
          "Boy",
          "Bradamar Frey",
          "Brandon Norrey",
          "Brandon Stark",
          "Bran the Builder",
          "Brandon the Bad",
          "Brandon the Burner",
          "Brandon the Daughterless",
          "Brandon the Shipwright",
          "Brandon Tallhart",
          "Branston Cuy",
          "Brea",
          "Brella",
          "Brenett",
          "Briar",
          "Brienne of Tarth",
          "Brogg",
          "Bronn",
          "Brown Bernarr",
          "Brusco",
          "Bryan Frey",
          "Bryan Fossoway",
          "Bryan of Oldtown",
          "Bryce Caron",
          "Bryen",
          "Bryen Caron",
          "Bryen Farring",
          "Brynden Rivers",
          "Brynden Tully",
          "Buford Bulwer",
          "Bump",
          "Burton Crakehall",
          "Butterbumps",
          "Buu",
          "Byam Flint",
          "Byan Votyris",
          "Byren Flowers",
          "Byron",
          "Cadwyl",
          "Cadwyn",
          "Lord Cafferen",
          "Craghas Drahar",
          "Caleotte",
          "Calon",
          "Camarron of the Count",
          "Canker Jeyne",
          "Carellen Smallwood",
          "Carolei Waynwood",
          "Carrot",
          "Cass",
          "Cassana Estermont",
          "Cassella Vaith",
          "Lord Caswell",
          "Castos",
          "Catelyn Bracken",
          "Catelyn Stark",
          "Cayn",
          "Cedra",
          "Cedric Payne",
          "Cedrik Storm",
          "Cellador",
          "Cerenna Lannister",
          "Cerrick",
          "Cersei Frey",
          "Cersei Lannister",
          "Cetheres",
          "Chataya",
          "Chayle",
          "Chella",
          "Chett",
          "Cheyk",
          "Chiggen",
          "Chiswyck",
          "Clarence Charlton",
          "Clarence Crabb",
          "Clarent Crakehall",
          "Clayton Suggs",
          "Clement",
          "Clement Crabb",
          "Clement Piper",
          "Cleon",
          "Cleos Frey",
          "Cletus Yronwood",
          "Cley Cerwyn",
          "Cleyton Caswell",
          "Clifford Conklyn",
          "Clubfoot Karl",
          "Clydas",
          "Cohollo",
          "Coldhands",
          "Colemon",
          "Colen of Greenpools",
          "Colin Florent",
          "Collio Quaynis",
          "Colmar Frey",
          "Conn",
          "Conwy",
          "Coratt",
          "Corliss Penny",
          "Corlys Velaryon",
          "Cortnay Penrose",
          "Cosgrove",
          "Cossomo",
          "Cotter Pyke",
          "Courtenay Greenhill",
          "Cragorn",
          "Craster",
          "Crawn",
          "Cregan Karstark",
          "Cregan Stark",
          "Creighton Longbough",
          "Creighton Redfort",
          "Cressen",
          "Criston Cole",
          "Cuger",
          "Cutjack",
          "Cynthea Frey",
          "Cyrenna Swann",
          "Daario Naharis",
          "Dacey Mormont",
          "Dacks",
          "Daegon Shepherd",
          "Daella Targaryen",
          "Daemon I Blackfyre",
          "Daemon II Blackfyre",
          "Daemon Sand",
          "Daemon Targaryen",
          "Daena Targaryen",
          "Daenerys Targaryen",
          "Daeron I Targaryen",
          "Daeron II Targaryen",
          "Daeron Targaryen",
          "Daeron Vaith",
          "Daeryssa",
          "Dafyn Vance",
          "Dagmer",
          "Dagon Ironmaker",
          "Dagon Greyjoy",
          "Dagos Manwoody",
          "Dake",
          "Dalbridge",
          "Dale Drumm",
          "Dale Seaworth",
          "Dalla",
          "Damion Lannister",
          "Damon",
          "Damon Lannister",
          "Damon Paege",
          "Damon Shett",
          "Damon Vypren",
          "Dan",
          "Dancy",
          "Danelle Lothston",
          "Danny Flint",
          "Danos Slynt",
          "Danwell Frey",
          "Dareon",
          "Darla Deddings",
          "Darlessa Marbrand",
          "Daryn Hornwood",
          "Daughter of the Dusk",
          "Daven Lannister",
          "Davos Seaworth",
          "Deana Hardyng",
          "Del",
          "Delena Florent",
          "Della Frey",
          "Delonne Allyrion",
          "Delp",
          "Denestan",
          "Dennet",
          "Dennis Plumm",
          "Denyo Terys",
          "Denys Arryn",
          "Denys Darklyn",
          "Denys Drumm",
          "Denys Mallister",
          "Denys Redwyne",
          "Denyse Hightower",
          "Dermot",
          "Desmond",
          "Desmond Grell",
          "Desmond Redwyne",
          "Devan Seaworth",
          "Devyn Sealskinner",
          "Deziel Dalt",
          "Dhazzar",
          "Dick",
          "Dick Crabb",
          "Dick Follard",
          "Dickon Frey",
          "Dickon Manwoody",
          "Dickon Tarly",
          "Dirk",
          "Dobber",
          "Dolf",
          "Domeric Bolton",
          "Donal Noye",
          "Donel Greyjoy",
          "Donella Hornwood",
          "Donnel Drumm",
          "Donnel Haigh",
          "Donnel Hill",
          "Donnel Locke",
          "Donnel of Duskendale",
          "Donnel Waynwood",
          "Donnis",
          "Donnor Stark",
          "Dontos Hollard",
          "Donyse",
          "Doran Martell",
          "Dorcas",
          "Dorea Sand",
          "Doreah",
          "Dormund",
          "Dornish Dilly",
          "Dorren Stark",
          "Draqaz",
          "Drennan",
          "Drogo",
          "Dryn",
          "Dudley",
          "Dunaver",
          "Duncan",
          "Duncan Targaryen",
          "Dunsen",
          "Dunstan Drumm",
          "Duram Bar Emmon",
          "Durran",
          "Dyah",
          "Dykk Harlaw",
          "Dywen",
          "Easy",
          "Ebben",
          "Ebrose",
          "Eddara Tallhart",
          "Eddard Karstark",
          "Eddard Stark",
          "Edderion Stark",
          "Eddison Tollett",
          "Eden Risley",
          "Edgerran Oakheart",
          "Edmund Ambrose",
          "Edmure Tully",
          "Edmyn Tully",
          "Edric Dayne",
          "Edric Storm",
          "Edrick Stark",
          "Edwyd Fossoway",
          "Edwyle Stark",
          "Edwyn Frey",
          "Edwyn Osgrey",
          "Edwyn Stark",
          "Eggon",
          "Eglantine",
          "Egon Emeros",
          "Elaena Targaryen",
          "Elbert Arryn",
          "Elder Brother",
          "Eldiss",
          "Eldon Estermont",
          "Eldred Codd",
          "Eleanor Mooton",
          "Eleyna Westerling",
          "Elia Sand",
          "Elia Martell",
          "Elinor Tyrell",
          "Ellaria Sand",
          "Ellery Vance",
          "Ellyn Tarbeck",
          "Elmar Frey",
          "Elron",
          "Elwood",
          "Elwood Meadows",
          "Elyana Vypren",
          "Elyas Willum",
          "Elyn Norridge",
          "Elys Waynwood",
          "Elys Westerling",
          "Elza",
          "Emberlei Frey",
          "Emma",
          "Emmon Cuy",
          "Emmon Frey",
          "Emmond",
          "Emphyria Vance",
          "Emrick",
          "Endehar",
          "Endrew Tarth",
          "Enger",
          "Eon Hunter",
          "Erena Glover",
          "Erik Ironmaker",
          "Ermesande Hayford",
          "Eroeh",
          "Erreck",
          "Erreg",
          "Erren Florent",
          "Errok",
          "Erryk",
          "Esgred",
          "Ethan Glover",
          "Euron Greyjoy",
          "Eustace",
          "Eustace Brune",
          "Eustace Hunter",
          "Eustace Osgrey",
          "Eyron Stark",
          "Ezzara",
          "Ezzelyno",
          "Falena Stokeworth",
          "Falia Flowers",
          "Falyse Stokeworth",
          "Farlen",
          "Lord Farman of Fair Isle",
          "Fearless Ithoke",
          "Lord Fell of Felwood",
          "Fern",
          "Ferny",
          "Ferrego Antaryon",
          "Ferret",
          "Flement Brax",
          "Fogo",
          "Forley Prester",
          "Fornio",
          "Franklyn Fowler",
          "Franklyn Frey",
          "Fralegg",
          "Frenken",
          "Frenya",
          "Frynne",
          "Gage",
          "Galazza Galare",
          "Galbart Glover",
          "Galladon of Morne",
          "Galladon of Tarth",
          "Gallard",
          "Galt",
          "Galtry the Green",
          "Galyeon of Cuy",
          "Gared",
          "Gareth Clifton",
          "Gareth the Grey",
          "Garigus",
          "Garin",
          "Gariss",
          "Garizon",
          "Garlan Tyrell",
          "Garrett Flowers",
          "Garrett Paege",
          "Garrison Prester",
          "Garse Flowers",
          "Garse Goodbrook",
          "Garth of Greenaway",
          "Garth Greenhand",
          "Garth XII Gardener",
          "Garth Greenfield",
          "Garth Greyfeather",
          "Garth Hightower",
          "Garth of Oldtown",
          "Garth Tyrell",
          "Gascoyne of the Greenblood",
          "Gavin the Trader",
          "Gawen Glover",
          "Gawen Swann",
          "Gawen Westerling",
          "Gawen Wylde",
          "Gelmarr",
          "Gendel",
          "Gendry",
          "Genna Lannister",
          "Gerald Gower",
          "Gerardys",
          "Gerion Lannister",
          "Gerold Dayne",
          "Gerold Grafton",
          "Gerold Hightower",
          "Gerold Lannister",
          "Gerren",
          "Gerrick Kingsblood",
          "Gerris Drinkwater",
          "Gevin Harlaw",
          "Ghael",
          "Ghost of High Heart",
          "Gilbert Farring",
          "Gillam",
          "Gilly",
          "Gilwood Hunter",
          "Gladden Wylde",
          "Glendon Flowers",
          "Glendon Hewett",
          "Goady",
          "Godric Borrell",
          "Godry Farring",
          "Godwyn",
          "Goghor the Giant",
          "Goodwin",
          "Gorghan of Old Ghis",
          "Gormon Peake",
          "Gormon Tyrell",
          "Gormond Drumm",
          "Gormond Goodbrother",
          "Gorne",
          "Gorold Goodbrother",
          "Gowen Baratheon",
          "Gran Goodbrother",
          "Grance Morrigen",
          "Grazdan",
          "Grazdan mo Eraz",
          "Grazdan mo Ullhor",
          "Grazdan zo Galare",
          "Grazhar zo Galare",
          "The Great Walrus",
          "Green Gergen",
          "Greenbeard",
          "Gregor Clegane",
          "Grenn",
          "Gretchel",
          "Grey King",
          "Grey Worm",
          "Greydon Goodbrother",
          "Griffin King",
          "Grigg",
          "Grisel",
          "Grisella",
          "Groleo",
          "Grubbs",
          "Grunt",
          "Gueren",
          "Gulian",
          "Gulian Qorgyle",
          "Gulian Swann",
          "Guncer Sunglass",
          "Gunthor son of Gurn",
          "Gunthor Hightower",
          "Gurn",
          "Guthor Grimm",
          "Guyard Morrigen",
          "Guyne",
          "Gwayne Corbray",
          "Gwayne Gaunt",
          "Gwayne Hightower",
          "Gwin Goodbrother",
          "Gwynesse Harlaw",
          "Gylbert Farwynd",
          "Gyldayn",
          "Gyleno Dothare",
          "Gyles",
          "Gyles Farwynd",
          "Gyles III Gardener",
          "Gyles Grafton",
          "Gyles Rosby",
          "Gyloro Dothare",
          "Gynir",
          "Gysella Goodbrother",
          "Haegon Blackfyre",
          "Haggo",
          "Haggon",
          "Hairy Hal",
          "Hake",
          "Hal",
          "Halder",
          "Haldon",
          "Hali",
          "Hallis Mollen",
          "Hallyne",
          "Halmon Paege",
          "Halys Hornwood",
          "Hamish the Harper",
          "Harbert",
          "Harbert Paege",
          "Hareth",
          "Harghaz",
          "Harlan Grandison",
          "Harlan Hunter",
          "Harle the Handsome",
          "Harle the Huntsman",
          "Harlen Tyrell",
          "Harlon Botley",
          "Harlon Greyjoy",
          "Harma",
          "Harmen Uller",
          "Harmond Umber",
          "Harmund Sharp",
          "Harmune",
          "Harodon",
          "Harra",
          "Harrag Hoare",
          "Harrag Sharp",
          "Harras Harlaw",
          "Harren Botley",
          "Harren Half-Hoare",
          "Harren Hoare",
          "Harrion Karstark",
          "Harrold Hardyng",
          "Harrold Osgrey",
          "Harrold Westerling",
          "Harry Sawyer",
          "Harry Strickland",
          "Harsley",
          "Harwin",
          "Harwin Strong",
          "Harwood Fell",
          "Harwood Stout",
          "Harwyn Hoare",
          "Harwyn Plumm",
          "Harys Haigh",
          "Harys Swyft",
          "Hayhead",
          "Hazrak zo Loraq",
          "Hazzea",
          "Helaena Targaryen",
          "Helicent Uffering",
          "Helliweg",
          "Helly",
          "Helman Tallhart",
          "Helya",
          "Hendry Bracken",
          "Henk",
          "Henly",
          "Herbert Bolling",
          "Heward",
          "Hibald",
          "High Sparrow",
          "Hilmar Drumm",
          "Hizdahr zo Loraq",
          "Lord Commander Hoare",
          "Hoarfrost Umber",
          "Hobb",
          "Hobber Redwyne",
          "Hod",
          "Hodor",
          "Hoke",
          "Holger",
          "Holly",
          "Hop-Robin",
          "Horas Redwyne",
          "Horton Redfort",
          "Hosman Norcross",
          "Hosteen Frey",
          "Hoster Frey",
          "Hoster Tully",
          "Hot Pie",
          "Hother Umber",
          "Hotho Harlaw",
          "Howd Wanderer",
          "Howland Reed",
          "Hubard Rambton",
          "Hugh",
          "Hugh Beesbury",
          "Hugh Hammer",
          "Hugo Vance",
          "Hugo Wull",
          "Hugor of the Hill",
          "Hullen",
          "Humfrey Beesbury",
          "Humfrey Clifton",
          "Humfrey Hardyng",
          "Humfrey Hewett",
          "Humfrey Swyft",
          "Humfrey Wagstaff",
          "Hunnimore",
          "Husband",
          "Hyle Hunt",
          "Iggo",
          "Igon Vyrwel",
          "Illifer",
          "Illyrio Mopatis",
          "Ilyn Payne",
          "Imry Florent",
          "Iron Emmett",
          "Ironbelly",
          "Irri",
          "Jacelyn Bywater",
          "Jack-Be-Lucky",
          "Jacks",
          "Jaehaera Targaryen",
          "Jaehaerys I Targaryen",
          "Jaehaerys Targaryen",
          "Jaehaerys II Targaryen",
          "Jafer Flowers",
          "Jaggot",
          "Jaime Frey",
          "Jaime Lannister",
          "Jalabhar Xho",
          "Jammos Frey",
          "Janei Lannister",
          "Janna Tyrell",
          "Janos Slynt",
          "Jaqen H'ghar",
          "Jared Frey",
          "Jaremy Rykker",
          "Jarl",
          "Jarmen Buckwell",
          "Jason Mallister",
          "Jason Lannister",
          "Jasper Arryn",
          "Jasper Wylde",
          "Jasper Redfort",
          "Jasper Waynwood",
          "Jate",
          "Jate Blackberry",
          "Jayde",
          "Jayne Bracken",
          "Jeffory Mallister",
          "Jeffory Norcross",
          "Jenny",
          "Jeor Mormont",
          "Jeren",
          "Jeyne",
          "Jeyne Arryn",
          "Jeyne Beesbury",
          "Jeyne Darry",
          "Jeyne Fossoway",
          "Jeyne Goodbrook",
          "Jeyne Heddle",
          "Jeyne Lothston",
          "Jeyne Lydden",
          "Jeyne Poole",
          "Jeyne Rivers",
          "Jeyne Swann",
          "Jeyne Waters",
          "Jeyne Westerling",
          "Jhaqo",
          "Jhezane",
          "Jhiqui",
          "Jhogo",
          "Joanna Lannister",
          "Joanna Swyft",
          "Jocelyn Swyft",
          "Jodge",
          "Joffrey Baratheon",
          "Joffrey Caswell",
          "Joffrey Lonmouth",
          "Johanna Swann",
          "Jojen Reed",
          "Jommo",
          "Jommy",
          "Jon Arryn",
          "Jon Bettley",
          "Jon Brax",
          "Jon Bulwer",
          "Jon Connington",
          "Jon Cupps",
          "Jon Fossoway",
          "Jon Heddle",
          "Jon Hollard",
          "Jon Lynderly",
          "Jon Myre",
          "Jon O'Nutten",
          "Jon Penny",
          "Jon Penrose",
          "Jon Pox",
          "Jon Redfort",
          "Jon Snow",
          "Jon Umber",
          "Jon Vance",
          "Jon Waters",
          "Jon Wylde",
          "Jonella Cerwyn",
          "Jonnel Stark",
          "Jonos Bracken",
          "Jonos Frey",
          "Jonos Stark",
          "Jonothor Darry",
          "Jorah Mormont",
          "Jorah Stark",
          "Joramun",
          "Jorelle Mormont",
          "Jorgen",
          "Jorquen",
          "Jory Cassel",
          "Joseran",
          "Joseth",
          "Joseth Mallister",
          "Josmyn Peckledon",
          "Joss",
          "Joss Stilwood",
          "Joss the Gloom",
          "Josua Willum",
          "Joth Quickbow",
          "Jothos Slynt",
          "Joy Hill",
          "Joyeuse Erenford",
          "Jurne",
          "Justin Massey",
          "Jyana",
          "Jyanna Frey",
          "Jyck",
          "Jynessa Blackmont",
          "Jyzene",
          "Kaeth",
          "Karlon Stark",
          "Karyl Vance",
          "Kedge Whiteye",
          "Kedry",
          "Kegs",
          "Kella",
          "Kemmett Pyke",
          "Kenned",
          "Kennos of Kayce",
          "Ketter",
          "Kevan Lannister",
          "Kezmya",
          "Khorane Sathmantes",
          "Khrazz",
          "Kindly Man",
          "Kirby Pimm",
          "Kirth Vance",
          "Knight of Ninestars",
          "Kojja Mo",
          "Koss",
          "Kraznys mo Nakloz",
          "Krazz",
          "Kromm",
          "Kurleket",
          "Kurz",
          "Kyle",
          "Kyle Condon",
          "Kyle Royce",
          "Kyleg of the Wooden Ear",
          "Kym",
          "Kyra",
          "Kyra Frey",
          "Lady of the Leaves",
          "Laena Velaryon",
          "Laenor Velaryon",
          "Lambert Turnberry",
          "Lamprey",
          "Lancel V Lannister",
          "Lancel Lannister",
          "Lann the Clever",
          "Lanna",
          "Lanna Lannister",
          "Larence Snow",
          "Lark",
          "Larra Blackmont",
          "Larraq",
          "Larys Strong",
          "Layna",
          "Leana Frey",
          "Leathers",
          "Left Hand Lew",
          "Lem",
          "Lenn",
          "Lennocks",
          "Lenwood Tawney",
          "Lenyl",
          "Leo Blackbar",
          "Leo Lefford",
          "Leo Tyrell",
          "Leobald Tallhart",
          "Leona Tyrell",
          "Leona Woolfield",
          "Leonella Lefford",
          "Leonette Fossoway",
          "Leslyn Haigh",
          "Lester",
          "Lester Morrigen",
          "Lew",
          "Lewis Lanster",
          "Lewyn Martell",
          "Lewys the Fishwife",
          "Lewys Lydden",
          "Lewys Piper",
          "Leyla Hightower",
          "Leyton Hightower",
          "Lharys",
          "Lia Serry",
          "Liane Vance",
          "Likely Luke",
          "Lister",
          "Lollys Stokeworth",
          "Lomas Estermont",
          "Lommy Greenhands",
          "Lomys",
          "Long Lew",
          "Loras Tyrell",
          "Lorcas",
          "Loren Lannister",
          "Lorent Lorch",
          "Lorent Marbrand",
          "Lorent Tyrell",
          "Loreza Sand",
          "Lorimer",
          "Lormelle",
          "Lorren",
          "Lothar",
          "Lothar Frey",
          "Lothar Mallery",
          "Lotho Lornel",
          "Lothor Brune",
          "Lucamore Strong",
          "Lucan",
          "Lucantine Woodwright",
          "Lucas Blackwood",
          "Lucas Codd",
          "Lucas Corbray",
          "Lucas Inchfield",
          "Lucas Lothston",
          "Lucas Nayland",
          "Lucas Roote",
          "Lucas Tyrell",
          "Luceon Frey",
          "Lucias Vypren",
          "Lucifer Hardy",
          "Lucimore Botley",
          "Lucion Lannister",
          "Luco Prestayn",
          "Lucos",
          "Lucos Chyttering",
          "Luke of Longtown",
          "Lum",
          "Luthor Tyrell",
          "Luton",
          "Luwin",
          "Lyanna Mormont",
          "Lyanna Stark",
          "Lyessa Flint",
          "Lyle Crakehall",
          "Lyman Beesbury",
          "Lyman Darry",
          "Lymond Goodbrook",
          "Lymond Lychester",
          "Lymond Mallister",
          "Lymond Vikary",
          "Lyn Corbray",
          "Lync",
          "Lynesse Hightower",
          "Lyonel",
          "Lyonel Baratheon",
          "Lyonel Bentley",
          "Lyonel Corbray",
          "Lyonel Frey",
          "Lyonel Selmy",
          "Lyonel Strong",
          "Lyonel Tyrell",
          "Lyra Mormont",
          "Lysa Arryn",
          "Lysa Meadows",
          "Lysono Maar",
          "Lythene Frey",
          "Mace Tyrell",
          "Mad Huntsman",
          "Maddy",
          "Maege Mormont",
          "Maegelle Frey",
          "Maegor I Targaryen",
          "Maekar Targaryen",
          "Maelor Targaryen",
          "Maelys Blackfyre",
          "Maerie",
          "Mag Mar Tun Doh Weg",
          "Maggy",
          "Mago",
          "Malcolm",
          "Mallador Locke",
          "Malleon",
          "Malliard",
          "Mallor",
          "Malwyn Frey",
          "Mance Rayder",
          "Mandon Moore",
          "Manfred Dondarrion",
          "Manfred Lothston",
          "Manfred Swann",
          "Manfrey Martell",
          "Manfryd Lothston",
          "Manfryd Yew",
          "Marei",
          "Margaery Tyrell",
          "Marghaz zo Loraq",
          "Margot Lannister",
          "Marianne Vance",
          "Maric Seaworth",
          "Marillion",
          "Maris",
          "Marissa Frey",
          "Mariya Darry",
          "Mark Mullendore",
          "Mark Ryswell",
          "Marlon Manderly",
          "Maron Botley",
          "Maron Greyjoy",
          "Maron Martell",
          "Maron Volmark",
          "Marq Grafton",
          "Marq Piper",
          "Marq Rankenfell",
          "Marsella Waynwood",
          "Matarys Targaryen",
          "Martyn Cassel",
          "Martyn Lannister",
          "Martyn Mullendore",
          "Martyn Rivers",
          "Marwyn",
          "Marwyn Belmore",
          "Marya Seaworth",
          "Masha Heddle",
          "Maslyn",
          "Mathis Frey",
          "Mathis Rowan",
          "Mathos Mallarawan",
          "Matrice",
          "Matt",
          "Matthar",
          "Matthos Seaworth",
          "Mawney",
          "Maynard",
          "Maynard Plumm",
          "Mazdhan zo Loraq",
          "Mebble",
          "Medgar Tully",
          "Medger Cerwyn",
          "Medwick Tyrell",
          "Meera Reed",
          "Meg",
          "Megga Tyrell",
          "Meha",
          "Meizo Mahr",
          "Mela",
          "Melaquin",
          "Melara Crane",
          "Melara Hetherspoon",
          "Meldred Merlyn",
          "Melesa Crakehall",
          "Melessa Florent",
          "Meliana",
          "Melicent",
          "Melisandre",
          "Melissa Blackwood",
          "Mellara Rivers",
          "Mellei",
          "Mellos",
          "Melly",
          "Melwyn Sarsfield",
          "Melwys Rivers",
          "Meralyn",
          "Meredyth Crane",
          "Merianne Frey",
          "Meribald",
          "Merling Queen",
          "Merlon Crakehall",
          "Mern Gardener",
          "Mero",
          "Merrell Florent",
          "Merrett Frey",
          "Merrit",
          "Merry Meg",
          "Meryn Trant",
          "Mezzara",
          "Michael Mertyns",
          "Mikken",
          "Miklaz",
          "Mina Tyrell",
          "Minisa Whent",
          "Mirri Maz Duur",
          "Missandei",
          "Moelle",
          "Mohor",
          "Mollander",
          "Mollos",
          "Monford Velaryon",
          "Monster",
          "Monterys Velaryon",
          "Moon Boy",
          "Moonshadow",
          "Moqorro",
          "Mord",
          "Mordane",
          "Moredo Prestayn",
          "Moreo Tumitis",
          "Morgarth",
          "Morgil",
          "Moribald Chester",
          "Morna White Mask",
          "Moro",
          "Sarnori",
          "Morosh the Myrman",
          "Morra",
          "Morrec",
          "Morros Slynt",
          "Mors Manwoody",
          "Mors Martell",
          "Mors Umber",
          "Mortimer Boggs",
          "Morton Waynwood",
          "Morya Frey",
          "Moryn Tyrell",
          "Mother Mole",
          "Mudge",
          "Mullin",
          "Mully",
          "Munciter",
          "Munda",
          "Murch",
          "Murenmure",
          "Murmison",
          "Mushroom",
          "Muttering Bill",
          "Mya Stone",
          "Mycah",
          "Mychel Redfort",
          "Mylenda Caron",
          "Myles",
          "Myles Manwoody",
          "Myles Mooton",
          "Myles Smallwood",
          "Myranda Royce",
          "Myrcella Baratheon",
          "Myria Jordayne",
          "Myriah Martell",
          "Myrielle Lannister",
          "Myrtle",
          "Mysaria",
          "Naerys Targaryen",
          "Nage",
          "Nail",
          "Nan",
          "Narbert",
          "Narbo",
          "Ned",
          "Ned Woods",
          "Nella",
          "Nestor Royce",
          "Nettles",
          "Nightingale",
          "Nissa Nissa",
          "Noho Dimittis",
          "Nolla",
          "Norbert Vance",
          "Norjen",
          "Normund Tyrell",
          "Norne Goodbrother",
          "Norren",
          "Notch",
          "Nute",
          "Nymella Toland",
          "Nymeria",
          "Nymeria Sand",
          "Nymos",
          "Nysterica",
          "Obara Sand",
          "Obella Sand",
          "Oberyn Martell",
          "Ocley",
          "Ogo",
          "Old Bill Bones",
          "Old Crackbones",
          "Old Grey Gull",
          "Old Henly",
          "Old Tattersalt",
          "Olene Tyrell",
          "Olenna Redwyne",
          "Ollidor",
          "Ollo Lophand",
          "Olymer Tyrell",
          "Olyvar Frey",
          "Olyvar Oakheart",
          "Omer Blackberry",
          "Omer Florent",
          "Ondrew Locke",
          "Orbelo",
          "Orbert Caswell",
          "Ordello",
          "Orell",
          "Orivel",
          "Orland of Oldtown",
          "Ormond",
          "Ormond Osgrey",
          "Ormond Westerling",
          "Ormond Yronwood",
          "Ormund Wylde",
          "Oro Tendyris",
          "Orwyle",
          "Orphan Oss",
          "Orton Merryweather",
          "Orys Baratheon",
          "Osbert Serry",
          "Osfryd Kettleblack",
          "Osha",
          "Osmund Frey",
          "Osmund Kettleblack",
          "Osmynd",
          "Osney Kettleblack",
          "Ossifer Plumm",
          "Ossy",
          "Oswell Kettleblack",
          "Oswell Whent",
          "Oswyn",
          "Othell Yarwyck",
          "Otho Bracken",
          "Othor",
          "Otter Gimpknee",
          "Otto Hightower",
          "Ottomore",
          "Ottyn Wythers",
          "Owen",
          "Owen Inchfield",
          "Owen Norrey",
          "Oznak zo Pahl",
          "Palla",
          "Parmen Crane",
          "Patchface",
          "Pate",
          "Pate of the Blue Fork",
          "Pate of the Night's Watch",
          "Patrek Mallister",
          "Patrek Vance",
          "Paxter Redwyne",
          "Pearse Caron",
          "Penny",
          "Penny Jenny",
          "Perra Frey",
          "Perriane Frey",
          "Perros Blackmont",
          "Perwyn Frey",
          "Perwyn Osgrey",
          "Peter Plumm",
          "Petyr Baelish",
          "Petyr Frey",
          "Philip Foote",
          "Philip Plumm",
          "Pia",
          "Plummer",
          "Podrick Payne",
          "Poetess",
          "Pollitor",
          "Polliver",
          "Pono",
          "Porridge",
          "Porther",
          "Portifer Woodwright",
          "Poul Pemford",
          "Poxy Tym",
          "Praed",
          "Prendahl na Ghezn",
          "Preston Greenfield",
          "Puckens",
          "Pudding",
          "Puddingfoot",
          "Pyat Pree",
          "Pycelle",
          "Pyg",
          "Pylos",
          "Pypar",
          "Qalen",
          "Qarl the Maid",
          "Qarl the Thrall",
          "Qarl Correy",
          "Qarl Kenning",
          "Qarl Quickaxe",
          "Qarl Shepherd",
          "Qarlton Chelsted",
          "Qarro Volentin",
          "Qezza",
          "Qhorin Halfhand",
          "Lord Commander Qorgyle",
          "Qos",
          "Qotho",
          "Quaithe",
          "Quaro",
          "Quellon Botley",
          "Quellon Greyjoy",
          "Quellon Humble",
          "Quence",
          "Quent",
          "Quenten Banefort",
          "Quentin Tyrell",
          "Quenton Greyjoy",
          "Quenton Hightower",
          "Quentyn Ball",
          "Quentyn Blackwood",
          "Quentyn Martell",
          "Quentyn Qorgyle",
          "Quhuru Mo",
          "Quickfinger",
          "Quill",
          "Quincy Cox",
          "Quort",
          "Qyburn",
          "Qyle",
          "Racallio Ryndoon",
          "Rafe",
          "Rafford",
          "Ragnor Pyke",
          "Ragwyle",
          "Rainbow Knight",
          "Rakharo",
          "Ralf",
          "Ralf Kenning",
          "Ralf Stonehouse",
          "Ramsay Snow",
          "Randa",
          "Randyll Tarly",
          "Rast",
          "Rat Cook",
          "Rattleshirt",
          "Ravella Swann",
          "Rawney",
          "Raymar Royce",
          "Raymond Nayland",
          "Raymun Redbeard",
          "Raymun Darry",
          "Raymun Fossoway",
          "Raymund Frey",
          "Raymund Tyrell",
          "Raynald Westerling",
          "Raynard",
          "Raynard Ruttiger",
          "Red Alyn of the Rosewood",
          "Red Lamb",
          "Red Oarsman",
          "Red Rolfe",
          "Redtusk",
          "Redwyn",
          "Reek",
          "Regenard Estren",
          "Renfred Rykker",
          "Renly Baratheon",
          "Renly Norcross",
          "Rennifer Longwaters",
          "Reynard Webber",
          "Reysen",
          "Reznak mo Reznak",
          "Rhae Targaryen",
          "Rhaegar Frey",
          "Rhaegar Targaryen",
          "Rhaegel Targaryen",
          "Rhaego",
          "Rhaella Targaryen",
          "Rhaelle Targaryen",
          "Rhaena Targaryen",
          "Rhaenys Targaryen",
          "Rhea Florent",
          "Rhea Royce",
          "Rhialta Vance",
          "Rhogoro",
          "Rhonda Rowan",
          "Ricasso",
          "Richard Farrow",
          "Richard Horpe",
          "Richard Lonmouth",
          "Rickard Karstark",
          "Rickard Ryswell",
          "Rickard Stark",
          "Rickard Thorne",
          "Rickard Tyrell",
          "Rickard Wylde",
          "Rickon Stark",
          "Rigney",
          "Rob",
          "Robar Royce",
          "Robb Reyne",
          "Robb Stark",
          "Robert Arryn",
          "Robert Ashford",
          "Robert Baratheon",
          "Robert Brax",
          "Robert Flowers",
          "Robert Frey",
          "Robert Paege",
          "Robett Glover",
          "Robin",
          "Robin Flint",
          "Robin Greyjoy",
          "Robin Hill",
          "Robin Hollard",
          "Robin Moreland",
          "Robin Potter",
          "Robin Ryger",
          "Robyn Rhysling",
          "Rodrik Cassel",
          "Rodrik Flint",
          "Rodrik Freeborn",
          "Rodrik Greyjoy",
          "Rodrik Harlaw",
          "Rodrik Ryswell",
          "Rodrik Stark",
          "Rodwell Stark",
          "Roelle",
          "Roger of Pennytree",
          "Roger Hogg",
          "Roger Ryswell",
          "Roggo",
          "Rohanne Webber",
          "Roland Crakehall",
          "Rolder",
          "Rolfe",
          "Rollam Westerling",
          "Rolland Darklyn",
          "Rolland Longthorpe",
          "Rolland Storm",
          "Rolland Uffering",
          "Rolley",
          "Rolly Duckfield",
          "Rolph Spicer",
          "Romny Weaver",
          "Ronald Connington",
          "Ronald Storm",
          "Ronald Vance",
          "Ronel Rivers",
          "Ronnel Arryn",
          "Ronnel Harclay",
          "Ronnel Stout",
          "Ronnet Connington",
          "Roone",
          "Roose Bolton",
          "Roose Ryswell",
          "Rorge",
          "Roro Uhoris",
          "Roryn Drumm",
          "Rosamund Lannister",
          "Rosey",
          "Roslin Frey",
          "Rossart",
          "Rowan",
          "Royce Coldwater",
          "Rudge",
          "Rufus Leek",
          "Rugen",
          "Runcel Hightower",
          "Runciter",
          "Rupert Brax",
          "Rupert Crabb",
          "Rus",
          "Rusty Flowers",
          "Ryam",
          "Ryam Florent",
          "Ryam Redwyne",
          "Rycherd Crane",
          "Ryella Frey",
          "Ryella Royce",
          "Ryger Rivers",
          "Ryk",
          "Rylene Florent",
          "Ryles",
          "Ryman Frey",
          "Rymolf",
          "Rymund the Rhymer",
          "Ryon Allyrion",
          "S'vrone",
          "Saathos",
          "Saera Targaryen",
          "Sailor's Wife",
          "Salladhor Saan",
          "Sallei Paege",
          "Sallor",
          "Salloreon",
          "Sam Stoops",
          "Samwell Spicer",
          "Samwell Stone",
          "Samwell Tarly",
          "Sandor Clegane",
          "Sandor Frey",
          "Sansa Stark",
          "Sarella Sand",
          "Sargon Botley",
          "Sarra Frey",
          "Sarya Whent",
          "Satin",
          "Sawane Botley",
          "Sawwood",
          "Scarb",
          "Scolera",
          "Sebaston Farman",
          "Sedgekins",
          "Sefton",
          "Selmond Stackspear",
          "Selwyn Tarth",
          "Selyse Florent",
          "Senelle",
          "Serala",
          "Serra",
          "Serra Frey",
          "Serwyn of the Mirror Shield",
          "Shadrick",
          "Shae",
          "Shagga",
          "Shagwell",
          "Sharna",
          "Shella",
          "Shella Whent",
          "Sherrit",
          "Shiera Crakehall",
          "Shiera Seastar",
          "Shierle Swyft",
          "Shireen Baratheon",
          "Shirei Frey",
          "Shortear",
          "Shyra",
          "Shyra Errol",
          "Sigfry Stonetree",
          "Sigfryd Harlaw",
          "Sigrin",
          "Simon Leygood",
          "Simon Staunton",
          "Simon Toyne",
          "Skahaz mo Kandaq",
          "Skinner",
          "Skittrick",
          "Sky Blue Su",
          "Skyte",
          "Sleepy Jack",
          "Sloey",
          "Small Paul",
          "Smiling Knight",
          "Soren Shieldbreaker",
          "Sour Alyn",
          "Spare Boot",
          "Softfoot",
          "Spotted Cat",
          "Spotted Pate of Maidenpool",
          "Squint",
          "Squirrel",
          "Stafford Lannister",
          "Stalwart Shield",
          "Stannis Baratheon",
          "Stannis Seaworth",
          "Lord Staunton",
          "Steelskin",
          "Steely Pate",
          "Steffarion Sparr",
          "Steffon Baratheon",
          "Steffon Fossoway",
          "Steffon Frey",
          "Steffon Hollard",
          "Steffon Seaworth",
          "Steffon Stackspear",
          "Steffon Swyft",
          "Steffon Darklyn",
          "Steffon Varner",
          "Stevron Frey",
          "Stiv",
          "Stone Thumbs",
          "Stonehand",
          "Stonesnake",
          "Stygg",
          "Styr",
          "Sumner Crakehall",
          "Sybassion",
          "Sybell Spicer",
          "Sybelle Glover",
          "Sylas",
          "Sylas Flatnose",
          "Sylva Santagar",
          "Sylwa Paege",
          "Symeon Star-Eyes",
          "Symon Hollard",
          "Symon Santagar",
          "Symon Silver Tongue",
          "Symon Stripeback",
          "Symond Botley",
          "Symond Frey",
          "Symond Templeton",
          "Syrio Forel",
          "Taena of Myr",
          "Tagganaro",
          "Tal Toraq",
          "Talea",
          "Talla Tarly",
          "Tallad",
          "Tanda Stokeworth",
          "Tanselle",
          "Tansy",
          "Tanton Fossoway",
          "Tarber",
          "Tarle",
          "Temmo",
          "Ternesio Terys",
          "Terrance Lynderly",
          "Terrence Kenning",
          "Terrence Toyne",
          "Terro",
          "Theo Frey",
          "Theo Wull",
          "Theobald",
          "Theodan Wells",
          "Theodore Tyrell",
          "Theomar Smallwood",
          "Theomore",
          "Theomore Harlaw",
          "Theon Greyjoy",
          "Theon Stark",
          "Thistle",
          "Thoren Smallwood",
          "Thormor Ironmaker",
          "Thoros of Myr",
          "Three Toes",
          "Three-Tooth",
          "Tickler",
          "Tim Stone",
          "Tim Tangletongue",
          "Timeon",
          "Timett",
          "Timon",
          "Timoth",
          "Tion Frey",
          "Titus Peake",
          "Tobbot",
          "Tobho Mott",
          "Todder",
          "Todric",
          "Toefinger",
          "Togg Joth",
          "Tom Costayne",
          "Tom of Sevenstreams",
          "TomToo",
          "Tomard",
          "Tommard Heddle",
          "Tommen Baratheon",
          "Tommen Costayne",
          "Torbert",
          "Toregg the Tall",
          "Tormund",
          "Torrek",
          "Torren Liddle",
          "Torrhen Karstark",
          "Torrhen Stark",
          "Torwold Browntooth",
          "Torwynd",
          "Tothmure",
          "Trebor Jordayne",
          "Tregar",
          "Tregar Ormollen",
          "Tremond Gargalen",
          "Tristan Mudd",
          "Tristan Ryger",
          "Tristifer Botley",
          "Tristifer IV Mudd",
          "Tristifer V Mudd",
          "Tristimun",
          "Triston of Tally Hill",
          "Triston Farwynd",
          "Triston Sunderland",
          "Trystane Martell",
          "Tuffleberry",
          "Tumberjon",
          "Tumco Lho",
          "Turnip",
          "Turquin",
          "Tya Lannister",
          "Tyana Wylde",
          "Tybero Istarion",
          "Tybolt Crakehall",
          "Tybolt Hetherspoon",
          "Tybolt Lannister",
          "Tycho Nestoris",
          "Tyene Sand",
          "Tygett Lannister",
          "Tyland Lannister",
          "Tymor",
          "Tyrek Lannister",
          "Tyrion Lannister",
          "Tyrion Tanner",
          "Tysane Frey",
          "Tysha",
          "Tyta Frey",
          "Tytos Blackwood",
          "Tytos Brax",
          "Tytos Frey",
          "Tytos Lannister",
          "Tywin Frey",
          "Tywin Lannister",
          "Ulf son of Umar",
          "Ulf the Ill",
          "Ulf the White",
          "Uller",
          "Ulmer",
          "Ulrick Dayne",
          "Ulwyck Uller",
          "Umar",
          "Umfred",
          "Umma",
          "Unella",
          "Urreg",
          "Urek Ironmaker",
          "Urras Ironfoot",
          "Urrathon",
          "Urrigon Greyjoy",
          "Urron Greyiron",
          "Urswyck",
          "Urzen",
          "Utherydes Wayn",
          "Uthor Tollett",
          "Uthor Underleaf",
          "Utt",
          "Vaellyn",
          "Vaemond Velaryon",
          "Val",
          "Valaena Velaryon",
          "Valarr Targaryen",
          "Varamyr",
          "Vardis Egen",
          "Vargo Hoat",
          "Varly",
          "Varys",
          "Vayon Poole",
          "Veiled Lady",
          "Vickon Botley",
          "Vickon Greyjoy",
          "Victaria Tyrell",
          "Victarion Greyjoy",
          "Victor Tyrell",
          "Violet",
          "Visenya Targaryen",
          "Viserys Plumm",
          "Viserys Targaryen",
          "Viserys I Targaryen",
          "Viserys II Targaryen",
          "Vortimer Crane",
          "Vulture King",
          "Vylarr",
          "Vyman",
          "Waif",
          "Walda Frey",
          "Walda Rivers",
          "Walder Brax",
          "Walder Frey",
          "Walder Goodbrook",
          "Walder Haigh",
          "Walder Rivers",
          "Walder Vance",
          "Waldon Wynch",
          "Walgrave",
          "Wallace Waynwood",
          "Wallen",
          "Walton Frey",
          "Walton Stark",
          "Walton",
          "Waltyr Frey",
          "Walys Flowers",
          "Warren",
          "Warryn Beesbury",
          "Wat",
          "Wate",
          "Watt",
          "Watty",
          "Waymar Royce",
          "Wayn",
          "Weasel",
          "Weeper",
          "Weese",
          "Wenda",
          "Wendamyr",
          "Wendel Frey",
          "Wendel Manderly",
          "Wendell Webber",
          "Wendello Qar Deeth",
          "Werlag",
          "Wex Pyke",
          "Whalen Frey",
          "Wilbert",
          "Wilbert Osgrey",
          "Will",
          "Will Humble",
          "Willamen Frey",
          "Willam",
          "Willam Dustin",
          "Willam Stark",
          "Willam Wells",
          "Willam Wythers",
          "Willas Tyrell",
          "Willem Darry",
          "Willem Frey",
          "Willem Lannister",
          "Willem Wylde",
          "William Mooton",
          "Willifer",
          "Willis Fell",
          "Willis Wode",
          "Willit",
          "Willow Heddle",
          "Willow Witch-eye",
          "Willum",
          "Wolmer",
          "Woth",
          "Wulfe",
          "Wun Weg Wun Dar Wun",
          "Wyl",
          "Wyl the Whittler",
          "Wyl Waynwood",
          "Wylis Manderly",
          "Wylla",
          "Wylla Manderly",
          "Wyman Manderly",
          "Wynafrei Whent",
          "Wynafryd Manderly",
          "Wynton Stout",
          "Xaro Xhoan Daxos",
          "Xhondo",
          "Yandry",
          "Yellow Dick",
          "Ygon Farwynd",
          "Ygon Oldfather",
          "Ygritte",
          "Yna",
          "Yohn Farwynd",
          "Yohn Royce",
          "Yoren",
          "Yorkel",
          "Yorko Terys",
          "Yormwell",
          "Young Henly",
          "Ysilla",
          "Ysilla Royce",
          "Zachery Frey",
          "Zarabelo",
          "Zei",
          "Zekko",
          "Zharaq zo Loraq",
          "Zhoe Blanetree",
          "Zia Frey",
          "Zollo"
        ],
        "cities": [
          "Braavos",
          "King's Landing",
          "Volantis",
          "Qarth",
          "Asshai",
          "Old Valyria",
          "Meereen",
          "Oldtown",
          "Pentos",
          "Astapor",
          "Yunkai",
          "Lorath",
          "Lys",
          "Vaes Dothrak",
          "Sunspear",
          "White Harbor",
          "Myr",
          "Lannisport",
          "Qohor",
          "Tyrosh",
          "Norvos",
          "Gulltown",
          "Old Ghis",
          "New Ghis",
          "Mantarys",
          "Bayasabhad",
          "Elyria",
          "Tolos",
          "Samyrian",
          "Chroyane",
          "Tyria",
          "Oros",
          "Bhorash",
          "Ny Sar",
          "Sar Meel",
          "Ar Noy"
        ],
        "dragons": [
          "Drogon",
          "Viserion",
          "Rhaegal",
          "Balerion",
          "Meraxes",
          "Vhagar",
          "Sunfyre",
          "Syrax",
          "Caraxes",
          "Meleys",
          "Shrykos",
          "Morghul",
          "Tyraxes",
          "Dreamfyre",
          "Vermithrax",
          "Ghiscar",
          "Valryon",
          "Essovius",
          "Archonei"
        ],
        "houses": [
          "Flint of Flint's Finger",
          "Bolling",
          "Graceford of Holyhall",
          "Ferren",
          "Breakstone",
          "Blackwood of Raventree Hall",
          "Frey of Riverrun",
          "Holt",
          "Farwynd of the Lonely Light",
          "Heddle",
          "Cave",
          "Frey of the Crossing",
          "Flint of Widow's Watch",
          "Footly of Tumbleton",
          "Forrester",
          "Coldwater of Coldwater Burn",
          "Caswell of Bitterbridge",
          "Codd",
          "Farwynd of Sealskin Point",
          "Celtigar of Claw Isle",
          "Foote",
          "Erenford",
          "Estren of Wyndhall",
          "Florent of Brightwater Keep",
          "Estermont of Greenstone",
          "Errol of Haystack Hall",
          "Frost",
          "Gargalen of Salt Shore",
          "Elesham of the Paps",
          "Allyrion of Godsgrace",
          "Falwell",
          "Foote of Nightsong",
          "Fisher",
          "Fossoway of Cider Hall",
          "Fossoway of New Barrel",
          "Farring",
          "Follard",
          "Harlaw of Grey Garden",
          "Flint of Breakstone Hill",
          "Garner",
          "Fowler of Skyreach",
          "Fenn",
          "Glenmore",
          "Algood",
          "Grandison of Grandview",
          "Grafton of Gulltown",
          "Bigglestone",
          "Hollard",
          "Fisher of the Stony Shore",
          "Flint of the mountains",
          "Amber",
          "Hook",
          "Hornwood of Hornwood",
          "Branfield",
          "Hunter of Longbow Hall",
          "Humble",
          "Horpe",
          "Ironmaker",
          "Ironsmith",
          "Greystark of Wolf's Den",
          "Graves",
          "Bar Emmon of Sharp Point",
          "Byrch",
          "Clifton",
          "Goodbrother of Orkmont",
          "Ashwood",
          "Farman of Faircastle",
          "Brune of the Dyre Den",
          "Harte",
          "Holt",
          "Gardener of Highgarden",
          "Langward",
          "Lannister of Casterly Rock",
          "Lake",
          "Darkwood",
          "Liddle",
          "Leygood",
          "Lefford of the Golden Tooth",
          "Hunt",
          "Inchfield",
          "Lightfoot",
          "Lantell",
          "Hull",
          "Hutcheson",
          "Locke of Oldcastle",
          "Lolliston",
          "Long",
          "Jast",
          "Lorch",
          "Jordayne of the Tor",
          "Lowther",
          "Lyberr",
          "Grimm of Greyshield",
          "Justman",
          "Lychester",
          "Lydden of Deep Den",
          "Karstark of Karhold",
          "Keath",
          "Goodbrook",
          "Glover of Deepwood Motte",
          "Goodbrother of Corpse Lake",
          "Goodbrother of Crow Spike Keep",
          "Greenwood",
          "Goodbrother of Downdelving",
          "Goodbrother of Shatterstone",
          "Grey",
          "Gower",
          "Kellington",
          "Mallery",
          "Hawthorne",
          "Harroway of Harrenhal",
          "Hawick of Saltpans",
          "Hayford of Hayford",
          "Hasty",
          "Hersy of Newkeep",
          "Mallister of Seagard",
          "Kidwell of Ivy Hall",
          "Hastwyck",
          "Lake",
          "Knott",
          "Hewett of Oakenshield",
          "Kettleblack",
          "Manning",
          "Ladybright",
          "Manderly of White Harbor",
          "Herston",
          "Kenning of Kayce",
          "Harlton",
          "Kenning of Harlaw",
          "Hightower of the Hightower",
          "Marbrand of Ashemark",
          "Kyndall",
          "Meadows of Grassy Vale",
          "Melcolm of Old Anchor",
          "Lannett",
          "Marsh",
          "Cockshaw",
          "Merryweather of Longtable",
          "Middlebury",
          "Chyttering",
          "Lannister of Darry",
          "Lannister of Lannisport",
          "Donniger",
          "Lanny",
          "Merlyn of Pebbleton",
          "Lipps",
          "Moreland",
          "Mooton of Maidenpool",
          "Longthorpe of Longsister",
          "Moore",
          "Longwaters",
          "Morrigen of Crow's Nest",
          "Lothston of Harrenhal",
          "Lonmouth",
          "Greyjoy of Pyke",
          "Greengood",
          "Moss",
          "Greenfield of Greenfield",
          "Lynderly of the Snakewood",
          "Gaunt",
          "Greyiron of Orkmont",
          "Grell",
          "Goodbrother of Hammerhorn",
          "Hetherspoon",
          "Hoare of Orkmont",
          "Hogg of Sow's Horn",
          "Norridge",
          "Massey of Stonedance",
          "Nutt",
          "Nymeros Martell of Sunspear",
          "Cressey",
          "Oakheart of Old Oak",
          "Durrandon",
          "Oldflowers",
          "Orme",
          "Mertyns of Mistwood",
          "Orkwood of Orkmont",
          "Fell of Felwood",
          "Osgrey of Standfast",
          "Mollen",
          "Overton",
          "Osgrey of Leafy Lake",
          "Parren",
          "Payne",
          "Peake of Starpike",
          "Peat",
          "Peasebury of Poddingfield",
          "Peckledon",
          "Penrose of Parchments",
          "Perryn",
          "Plumm",
          "Mormont of Bear Island",
          "Piper of Pinkmaiden",
          "Pommingham",
          "Poole",
          "Pryor of Pebble",
          "Qorgyle of Sandstone",
          "Pyne",
          "Cordwayner of Hammerhal",
          "Qoherys of Harrenhal",
          "Redding",
          "Redbeard",
          "Quagg",
          "Redfort of Redfort",
          "Reyne of Castamere",
          "Redwyne of the Arbor",
          "Rhysling",
          "Risley",
          "Rogers of Amberly",
          "Rowan of Goldengrove",
          "Roxton of the Ring",
          "Roote of Lord Harroway's Town",
          "Rosby of Rosby",
          "Mudd of Oldstones",
          "Mullendore of Uplands",
          "Musgood",
          "Magnar of Kingshouse",
          "Rambton",
          "Myatt",
          "Myre of Harlaw",
          "Nayland of Hag's Mire",
          "Netley",
          "Norcross",
          "Manwoody of Kingsgrave",
          "Norrey",
          "Seaworth of Cape Wrath",
          "Serrett of Silverhill",
          "Prester of Feastfires",
          "Sharp",
          "Selmy of Harvest Hall",
          "Shell",
          "Serry of Southshield",
          "Shell",
          "Shepherd",
          "Rollingford",
          "Harlaw of the Tower of Glimmering",
          "Shett of Gulltown",
          "Shermer of Smithyton",
          "Smallwood of Acorn Hall",
          "Sloane",
          "Slynt of Harrenhal",
          "Stackhouse",
          "Spicer of Castamere",
          "Reed of Greywater Watch",
          "Shett of Gull Tower",
          "Stackspear",
          "Harlaw of Harridan Hill",
          "Stane of Driftwood Hall",
          "Royce of Runestone",
          "Stark of Winterfell",
          "Staunton of Rook's Rest",
          "Harlaw of Harlaw Hall",
          "Stokeworth of Stokeworth",
          "Stoneof Old Wyk",
          "Baratheon of Dragonstone",
          "Blanetree",
          "Haigh",
          "Harclay",
          "Blount",
          "Ashford of Ashford",
          "Blackfyre of King's Landing",
          "Beesbury of Honeyholt",
          "Hamell",
          "Bettley",
          "Baratheon of King's Landing",
          "Belmore of Strongsong",
          "Brightstone",
          "Pyle",
          "Stout of Goldgrass",
          "Ryger of Willow Wood",
          "Sunderland of the Three Sisters",
          "Swann of Stonehelm",
          "Blackmont of Blackmont",
          "Swyft of Cornfield",
          "Swygert",
          "Sunglass of Sweetport Sound",
          "Tallhart of Torrhen's Square",
          "Tarbeck of Tarbeck Hall",
          "Tarth of Evenfall Hall",
          "Tarly of Horn Hill",
          "Shawney",
          "Slate of Blackpool",
          "Tudbury",
          "Toyne",
          "Towers of Harrenhal",
          "Teague",
          "Paege",
          "Ruthermont",
          "Royce of the Gates of the Moon",
          "Ryder of the Rills",
          "Ruttiger",
          "Ryswell of the Rills",
          "Santagar of Spottswood",
          "Rykker of Duskendale",
          "Saltcliffe of Saltcliffe",
          "Sarwyck",
          "Sarsfield of Sarsfield",
          "Uller of Hellholt",
          "Bole",
          "Tyrell of Highgarden",
          "Boggs",
          "Boggs of Crackclaw Point",
          "Hardy",
          "Harlaw of Harlaw",
          "Staedmon of Broad Arch",
          "Hardyng",
          "Uffering",
          "Umber of the Last Hearth",
          "Blacktyde of Blacktyde",
          "Arryn of Gulltown",
          "Baratheon of Storm's End",
          "Blackbar of Bandallon",
          "Baelish of Harrenhal",
          "Ball",
          "Blackmyre",
          "Arryn of the Eyrie",
          "Baelish of the Fingers",
          "Crane of Red Lake",
          "Upcliff",
          "Vance of Atranta",
          "Vaith of the Red Dunes",
          "Crakehall of Crakehall",
          "Banefort of Banefort",
          "Stonetree of Harlaw",
          "Strickland",
          "Strong of Harrenhal",
          "Velaryon of Driftmark",
          "Sunderly of Saltcliffe",
          "Volmark",
          "Vypren",
          "Vyrwel of Darkdell",
          "Wade",
          "Targaryen of King's Landing",
          "Waterman",
          "Wagstaff",
          "Waynwood of Ironoaks",
          "Webber of Coldmoat",
          "Wayn",
          "Wells",
          "Wendwater",
          "Wensington",
          "Westerling of the Crag",
          "Westbrook",
          "Toland of Ghost Hill",
          "Westford",
          "Whent of Harrenhal",
          "Whitehill",
          "Willum",
          "Trant of Gallowsgrey",
          "Woodfoot of Bear Island",
          "Tyrell of Brightwater Keep",
          "Woodwright",
          "Woolfield",
          "Woods",
          "Wull",
          "Wylde of Rain House",
          "Wydman",
          "Wyl of the Boneway",
          "Wythers",
          "Yarwyck",
          "Vance of Wayfarer's Rest",
          "Vikary",
          "Yelshire",
          "Waxley of Wickenden",
          "Weaver",
          "Wells",
          "Wode",
          "Wynch of Iron Holt",
          "Tawney of Orkmont",
          "Templeton",
          "Thenn",
          "Terrick",
          "Tollett of the Grey Glen",
          "Thorne",
          "Towers",
          "Tully of Riverrun",
          "Sparr of Great Wyk",
          "Torrent of Littlesister",
          "Turnberry",
          "Bracken of Stone Hedge",
          "Briar",
          "Appleton of Appleton",
          "Botley of Lordsport",
          "Ambrose",
          "Brax of Hornvale",
          "Clegane",
          "Brook",
          "Broom",
          "Bridges",
          "Butterwell",
          "Bulwer of Blackcrown",
          "Bushy",
          "Brune of Brownhollow",
          "Cargyll",
          "Cassel",
          "Cafferen of Fawnton",
          "Chester of Greenshield",
          "Burley",
          "Buckler of Bronzegate",
          "Cerwyn of Cerwyn",
          "Bywater",
          "Charlton",
          "Drinkwater",
          "Doggett",
          "Dayne of Starfall",
          "Dryland",
          "Dalt of Lemonwood",
          "Chelsted",
          "Caron of Nightsong",
          "Dayne of High Hermitage",
          "Yronwood of Yronwood",
          "Varner",
          "Buckwell of the Antlers",
          "Crabb",
          "Borrell of Sweetsister",
          "Yew",
          "Darklyn of Duskendale",
          "Chambers",
          "Casterly of Casterly Rock",
          "Branch",
          "Bolton of the Dreadfort",
          "Cole",
          "Brownhill",
          "Durwell",
          "Drox",
          "Conklyn",
          "Drumm of Old Wyk",
          "Connington of Griffin's Roost",
          "Corbray of Heart's Home",
          "Condon",
          "Dustin of Barrowton",
          "Dargood",
          "Dunn",
          "Costayne of Three Towers",
          "Edgerton",
          "Egen",
          "Cox of Saltpans",
          "Deddings",
          "Cuy of Sunhouse",
          "Crowl of Deepdown",
          "Darke",
          "Darry of Darry",
          "Dondarrion of Blackhaven",
          "Cray"
        ],
        "quotes": [
          "There are no heroes...in life, the monsters win.",
          "Once you’ve accepted your flaws, no one can use them against you.",
          "And so he spoke, and so he spoke, that Lord of Castamere, but now the rains weep o'er his hall, with no one there to hear. Yes, now the rains weep o'er his hall, and not a soul to hear.",
          "A lion doesn't concern itself with the opinion of sheep.",
          "Fear cuts deeper than swords.",
          "The North remembers.",
          "Winter is coming.",
          "Do the dead frighten you?",
          "All dwarfs are bastards in their father's eyes",
          "Things are not always as they seemed, much that may seem evil can be good.",
          "Power is a curious thing. Who lives, Who dies. Power resides where men believe it resides. It is a trick, A shadow on the wall.",
          "Never forget who you are. The rest of the world won't. Wear it like an armor and it can never be used against you.",
          "Hodor? Hodor.",
          "Knowledge could be more valuable than gold, more deadly than a dagger.",
          "Every flight begins with a fall.",
          "Laughter is poison to fear.",
          "Nothing burns like the cold.",
          "Some old wounds never truly heal, and bleed again at the slightest word.",
          "... a mind needs books as a sword needs a whetstone, if it is to keep its edge.",
          "When you play a game of thrones you win or you die.",
          "Why is it that when one man builds a wall, the next man immediately needs to know what's on the other side?",
          "And I have a tender spot in my heart for cripples and bastards and broken things.",
          "When the snows fall and the white winds blow, the lone wolf dies but the pack survives.",
          "Give me honorable enemies rather than ambitious ones, and I'll sleep more easily by night.",
          "The things I do for love.",
          "Summer will end soon enough, and childhood as well."
        ]
      },
      "games": {
        "clash_of_clans": {
          "defensive_buildings": [
            "Cannon",
            "Archer Tower",
            "Mortar",
            "Air Defense",
            "Wizard Tower",
            "Air Sweeper",
            "Hidden Tesla",
            "Bomb Tower",
            "X-Bow",
            "Inferno Tower",
            "Eagle Artillery",
            "Giga Tesla",
            "Giga Inferno",
            "Scattershot",
            "Walls",
            "Traps",
            "Double Cannon",
            "Firecrackers",
            "Crusher",
            "Guard Post",
            "Air Bombs",
            "Multi Mortar",
            "Roaster",
            "Giant Cannon",
            "Mega Tesla",
            "Lava Launcher",
            "Traps"
          ],
          "ranks": [
            "Unranked",
            "Bronze III",
            "Bronze II",
            "Bronze I",
            "Silver III",
            "Silver II",
            "Silver I",
            "Gold III",
            "Gold II",
            "Gold I",
            "Crystal III",
            "Crystal II",
            "Crystal I",
            "Master III",
            "Master II",
            "Master I",
            "Champion III",
            "Champion II",
            "Champion I",
            "Titan III",
            "Titan II",
            "Titan I",
            "Legend"
          ],
          "troops": [
            "Barbarian",
            "Archer",
            "Giant",
            "Goblin",
            "Wall Breaker",
            "Balloon",
            "Wizard",
            "Healer",
            "Dragon",
            "P.E.K.K.A",
            "Baby Dragon",
            "Miner",
            "Electro Dragon",
            "Yeti (Yetimite)",
            "Ice Wizard",
            "Battle Ram (Barbarian)",
            "Pumpkin Barbarian (Barbarian)",
            "Giant Skeleton",
            "Skeleton Barrel (Skeleton)",
            "El Primo",
            "Party Wizard",
            "Royal Ghost",
            "Minion",
            "Hog Rider",
            "Valkyrie",
            "Golem (Golemite)",
            "Witch (Skeleton)",
            "Lava Hound (Lava Pup)",
            "Bowler",
            "Ice Golem",
            "Headhunter",
            "Raged Barbarian",
            "Sneaky Archer",
            "Boxer Giant",
            "Beta Minion",
            "Bomber",
            "Baby Dragon",
            "Cannon Cart",
            "Night Witch (Bat)",
            "Drop Ship (Skeleton)",
            "Super P.E.K.K.A",
            "Hog Glider (Hog Rider)"
          ]
        },
        "control": {
          "altered_item": [
            "\"Get Well Soon\" Balloon",
            "ActionMaxx Camera",
            "Arctic Queen",
            "Bremen Basket",
            "Crowbar",
            "Game Hammer",
            "Guru Surfboard",
            "Holiday Memories Tree",
            "Human Hand Chair",
            "Jasper Post Box",
            "Maneki-neko Statue(s)",
            "Moving Letters",
            "Ocelot's Anchor",
            "Oh Deer Diner Coffee Thermos",
            "Pink Flamingo",
            "Ramen Lantern",
            "Red Light",
            "Rubber Duck",
            "Simulacrum",
            "Smoking Pram",
            "Swan Boat",
            "The Oscillator",
            "Typewritten Page",
            "VHS Cassette Tape",
            "Victorian Mirror",
            "Waist Mannequin",
            "Wolff Globe"
          ],
          "altered_world_event": [
            "Albany, New York",
            "Bright Falls, Washington",
            "Butte, Montana",
            "Havana, Cuba",
            "Kyiv, Ukraine",
            "Ordinary, Wisconsin",
            "Sawyer County, Wisconsin",
            "Sterling, Colorado",
            "Willow, Alaska"
          ],
          "character": [
            "Ahti",
            "Alan Wake",
            "Alberto Tommasi",
            "Broderick Northmoor",
            "Casper Darling",
            "Dylan Faden",
            "Emily Pope",
            "Frederick Langston",
            "Helen Marshall",
            "Jesse Faden",
            "Kirklund",
            "Lin Salvador",
            "Malcolm Rooney",
            "Mr. Door",
            "Phillip",
            "Randall Polaski",
            "Raya Underhill",
            "Simon Arish",
            "The Board",
            "The Director",
            "The Former",
            "Theodore Ash, Jr.",
            "Yoshimi Tokui",
            "Zachariah Trench",
            "The Hiss"
          ],
          "hiss": [
            "You are a worm through time.",
            "The thunder song distorts you.",
            "Happiness comes.",
            "White pearls, but yellow and red in the eye.",
            "Through a mirror, inverted is made right.",
            "Leave your insides by the door.",
            "Push the fingers through the surface into the wet.",
            "You’ve always been the new you.",
            "You want this to be true.",
            "We stand around while you dream.",
            "You can almost hear our words but you forget.",
            "This happens more and more now.",
            "You gave us the permission in your regulations.",
            "We wait in the stains.",
            "The word that describes this is redacted.",
            "Repeat the word.",
            "The name of the sound.",
            "It resonates in your house.",
            "After the song, time for applause.",
            "We build you until nothing remains.",
            "The egg cracks and the truth will emerge out of you.",
            "You are home.",
            "You remind us of home.",
            "You’ve taken your boss with your boss with you.",
            "All hair must be eaten.",
            "Under the conceptual reality behind this reality you must want these waves to drag you away.",
            "After the song, time for applause.",
            "This cliché is death out of time, breaking the first the second the third the fourth wall, fifth wall, floor; no floor: you fall!",
            "How do you say \"insane\"?",
            "Hurts to be happy.",
            "An earworm is a tune you can’t stop humming in a dream: \"baby baby baby, yeah!\"",
            "Just plastic.",
            "So safe and nothing to worry about.",
            "Ha ha, funny.",
            "The last egg breaks now.",
            "The hole in your room is a hole in you.",
            "You came and we let you in through the hole in you.",
            "You have always been here, the only child.",
            "A copy of a copy of a copy.",
            "Orange peel.",
            "The picture is you holding the picture.",
            "When you hear this you will know you’re in new you.",
            "You want to listen.",
            "You want to dream.",
            "You want to smile.",
            "You want to hurt.",
            "You don’t want to be."
          ],
          "location": [
            "Access Corridor",
            "Archives",
            "Ashtray Maze",
            "Astral Collision",
            "Astral Exhibition",
            "Astral Plane",
            "Atlas Chamber",
            "Base Camp",
            "Black Rock Lab",
            "Black Rock Processing",
            "Black Rock Quarry",
            "Board Room",
            "Bureau",
            "Cafeteria",
            "Canyon Rim",
            "Cave Bleed",
            "Cave System",
            "Central Containment",
            "Central Executive",
            "Central Maintenance",
            "Central Research",
            "Chasm",
            "Collapsed Department",
            "Communications Department",
            "Containment Sector",
            "Crossroads",
            "Dead Letters",
            "Deep Cavern",
            "Dimensional Research",
            "Director's Office",
            "Entrance",
            "Executive Affairs",
            "Executive Sector",
            "Extrasensory Lab",
            "Field Training",
            "Firebreak",
            "Foundation",
            "Foundation Sector",
            "Fractured Cavern",
            "Furnace",
            "HRA Lab",
            "Hedron Chamber",
            "Hotline Chamber",
            "Hypnosis Lab",
            "Investigations Sector",
            "Janitor's Office",
            "Logistics",
            "Luck & Probablilty Lab",
            "Mail Room",
            "Maintenance Sector",
            "Medical Wing",
            "Mirror Maze",
            "Mold Threshold",
            "NSC Control Room",
            "NSC Coolant Pumps",
            "NSC Energy Converters",
            "NSC Power Plant",
            "NSC Security",
            "Oceanview Motel",
            "Ordinary",
            "P6 Cell",
            "Panopticon",
            "Parakinesiology",
            "Parapsychology",
            "Pipeworks",
            "Pneumatics",
            "Prime Candidate Program",
            "Protective Studies",
            "Pump Station",
            "Research Sector",
            "Research Site Gamma",
            "Restricted Area",
            "Ritual Devision",
            "Sealed Threshold",
            "Security",
            "Slidescape-36",
            "Synchironicity Lab",
            "The Oldest House",
            "The Clocks",
            "Transit Access",
            "Transit Corridor",
            "Turntable",
            "Twisted Passage",
            "Ventilation",
            "Warehouse"
          ],
          "object_of_power": [
            "Service Weapon",
            "Hotline",
            "Floppy Disk",
            "Benicoff TV",
            "Songmaster Jukebox",
            "Ashtray and Cigarette",
            "Slide Projector",
            "Merry-Go-Round Horse",
            "X-Ray Light Box",
            "Home Safe"
          ],
          "quote": [
            "'Let's get cleaning' she said, cocking her gun",
            "Despite what you may have heard, HRAs are not monitoring devices.",
            "He never liked fridge duty",
            "I just picked up a gun. Or a gun picked me.",
            "It’s making more clocks?",
            "No interruptions!!",
            "Nothing, but a pale imitation",
            "Once more with feeling",
            "Shawshank Redemption! That's the movie.",
            "That... was awesome",
            "The least a director can do is keep the lights on",
            "I forgot fridge duty.",
            "You must choose to be the chosen one."
          ],
          "the_board": [
            "< Another crisis/workday resolved >",
            "< Aplogies/How embarassing >",
            "< Certain Resources/Loot can be constructed/crafted into mods/forms >",
            "< Do not believe/get hype >",
            "< Good work/victory, Director >",
            "< Objects of Power are Holders/665 to the Other/Blessing >",
            "< Secrets/Instructions will be lost. Ignore this message >",
            "< The Astral Plane is a Conflux/Switchboard >",
            "< The Hiss/Spread is searching for Transmissions/Speakers to Corrupt/Chaos >",
            "< This will only be Available/Exclusive for the Director >",
            "< We are failing in translating hyperreal concepts >",
            "< We expect Independance/Dependance >",
            "< We hold the reins/law >",
            "< We like/tolerate you very much >",
            "< You are Authority/Chosen One. The Bureau/Game needs you >",
            "< You are prepared/unprepared for what comes next >",
            "< You are the Director now >",
            "< You have proven/beaten the not you",
            "< You/We wield the Gun/You. The Board appoints you. Congratulations, Director. >"
          ]
        },
        "dota": {
          "abaddon": {
            "quote": [
              "You have called death upon yourself.",
              "From House Avernus, I set forth.",
              "The mist chose me, it is not mine to command.",
              "To die at a noble hand is no guarantee of a noble death."
            ]
          },
          "alchemist": {
            "quote": [
              "Easy now, this stuff is explosive!",
              "Better living through alchemy!",
              "Tell the ogre you're sorry."
            ]
          },
          "ancient_apparition": {
            "quote": [
              "Behold the apparition.",
              "Time to break the ice!",
              "I look again upon the cold light of day."
            ]
          },
          "anti_mage": {
            "quote": [
              "Truth compels me.",
              "I bring an end to magic.",
              "They who live by the wand shall die by my blade.",
              "It is not magic brings me back, but purity of will!"
            ]
          },
          "arc_warden": {
            "quote": [
              "Matter has been split from its intended form. These must be made to unite.",
              "None escape the Self.",
              "These fools must learn what they stand against.",
              "Mercy is yours, for the end comes."
            ]
          },
          "axe": {
            "quote": [
              "Let the carnage begin.",
              "Come and get it!",
              "You get nothing. Good day, sir!",
              "Feel the axe of Axe!",
              "What happened? Axe happened!",
              "No business but war. No family but death. No mercy but the grave!"
            ]
          },
          "bane": {
            "quote": [
              "Your Nightmare is here.",
              "Nightmares, follow me into the light.",
              "Knock knees and blood run cold!",
              "I dreamt a field of war…and woke to find myself upon it."
            ]
          },
          "batrider": {
            "quote": [
              "Death from above!",
              "One forest fire coming up!",
              "I'll have the brisket. My hoss'll have your head.",
              "You wanna play rough? All right, we'll play rough."
            ]
          },
          "beastmaster": {
            "quote": [
              "Meet your master…snuhg… beastmaster.",
              "I'm a natural disaster.",
              "A death not fit for man or beast."
            ]
          },
          "bloodseeker": {
            "quote": [
              "The search for blood begins.",
              "For the Flayed Twins, I seek blood.",
              "Enough hide and seek.",
              "Don't be negative...be positive!"
            ]
          },
          "bounty_hunter": {
            "quote": [
              "There's a price on all their heads.",
              "No job is too big, no fee is too big.",
              "My blades will do the talking.",
              "Just business, nothing personal.",
              "Was there a bounty on me?",
              "It was just business before. Now it's personal."
            ]
          },
          "brewmaster": {
            "quote": [
              "I fight any thing in the house.",
              "Here's beer in your eye.",
              "Let's raise a cup before battle!"
            ]
          },
          "bristleback": {
            "quote": [
              "Time to mash some faces, I'd say.",
              "A good bashing, never hurt nobody.",
              "I'm more than a pretty face."
            ]
          },
          "broodmother": {
            "quote": [
              "The spider comes.",
              "You're not afraid of spiders, are you?",
              "I could kill you with five eyes closed.",
              "My enemies will pay with their liquified guts."
            ]
          },
          "building": [
            "Tower",
            "Barrack",
            "Ancient",
            "Fountain",
            "Effigy",
            "Outpost"
          ],
          "centaur": {
            "quote": [
              "Long shall my name be remembered.",
              "I don't always wear a saddlebag, but when I do, I put this one in it.",
              "Hurts you more than it hurts me."
            ]
          },
          "centaur_warrunner": {
            "quote": [
              "Long shall my name be remembered.",
              "I don't always wear a saddlebag, but when I do, I put this one in it.",
              "Hurts you more than it hurts me."
            ]
          },
          "chaos_knight": {
            "quote": [
              "All that is light shall be cast in darkness.",
              "Like the heads of my enemies, this one is in the bag.",
              "We descend into chaos.",
              "The light shall be blackened, and chaos shall reign.",
              "Chaos is Fun…damental."
            ]
          },
          "chen": {
            "quote": [
              "The Inquisitor has arrived.",
              "The persecution starts now!",
              "Only the penitent can be forgiven.",
              "God taketh whom he loveth best.",
              "In the name of Obelis, I fight again."
            ]
          },
          "clinkz": {
            "quote": [
              "A light to guide my way. A light to burn my foes.",
              "Clink goes my bones.",
              "It's time for your cremation.",
              "I've already paid my pound of flesh.",
              "The furnace of my heart cannot be quenched."
            ]
          },
          "clockwerk": {
            "quote": [
              "I've a mind like a steel trap, and the physique to go with it!",
              "What time is it? It's killing time.",
              "A good offense is the best armor. Good armor is also good armor."
            ]
          },
          "crystal_maiden": {
            "quote": [
              "Who calls the Crystal Maiden?",
              "Behold the scourge of Icewrack!",
              "Swift as the wolves of Icewrack...",
              "You're dead and that's a cold hard fact.",
              "Once burned, ice shy..."
            ]
          },
          "dark_seer": {
            "quote": [
              "From the land behind the wall, I come.",
              "Speed is the heart of battle.",
              "Face your enemy, face yourself.",
              "Your life, much like your head, lacked a point.",
              "Death is a wall I have overleapt."
            ]
          },
          "dark_willow": {
            "quote": [
              "Are you ready to have some fun, ya?",
              "No one will forget the name Mireska",
              "A little mischief never killed anyone... well, you I guess.",
              "Jex... whaddya say we find who did that and rip their eyes out?"
            ]
          },
          "dawnbreaker": {
            "quote": [
              "Darkness fears the break of dawn!",
              "I was created to serve, but today I choose this fight.",
              "The first stars burned and faded into nothingness. Followed by countless more. I remain. And my hammer swings true.",
              "Even at a fraction of my best, I outshine you immeasurably.",
              "One must always remember that the sun also rises."
            ]
          },
          "dazzle": {
            "quote": [
              "Dazzle!",
              "Where my shadow falls, there falls my foe.",
              "You're under my protection.",
              "Resurrection comes easily to a Shadow Priest!"
            ]
          },
          "death_prophet": {
            "quote": [
              "Who dares recall me from the grave?",
              "The doors of death open wide.",
              "You merely sipped at life. Now drink deep of death.",
              "The grave calls me back.",
              "Death is such a tease."
            ]
          },
          "disruptor": {
            "quote": [
              "The Stormcrafter comes!",
              "According to the forecast, this one is in the bag!",
              "Where you're going, the weather doesn't change.",
              "The storm charges my coil again."
            ]
          },
          "doom": {
            "quote": [
              "Face your demons.",
              "I am the midnight of your soul.",
              "Speak of me, and I shall appear. Face me and face the furnace!"
            ]
          },
          "dragon_knight": {
            "quote": [
              "Who calls the Dragon Knight?",
              "A Knight in dragon's armor.",
              "Face the knight, face the dragon.",
              "Live by the sword, die by the dragon.",
              "Good night, Sven. I mean bad knight. [Talking to Sven]",
              "Never make a deal with a dragon, unless you're prepared to keep your end of it."
            ]
          },
          "drow_ranger": {
            "quote": [
              "My quiver and bow are ready!",
              "I thought they warned you not to speak with rangers.",
              "Autumn leaves for a deathbed.",
              "Faster than an arrow's flight."
            ]
          },
          "earth_spirit": {
            "quote": [
              "Body is flesh, but spirit immortal.",
              "Knowledge is golden.",
              "Your flesh is soft. Your Spirit weak."
            ]
          },
          "earthshaker": {
            "quote": [
              "Time to shake things up and see where they settle.",
              "The earth moves under my feet!",
              "Tiny, your name is still too big for you. [Talking to Tiny]",
              "There may be many earths, but there's only one Earthshaker."
            ]
          },
          "elder_titan": {
            "quote": [
              "The battle is joined, like the pieces of a broken world.",
              "Strong as a world new-formed.",
              "What is weak must break.",
              "I broke the world, did you think I could not break you?"
            ]
          },
          "hero": [
            "Abaddon",
            "Alchemist",
            "Ancient Apparition",
            "Anti-Mage",
            "Arc Warden",
            "Axe",
            "Bane",
            "Batrider",
            "Beastmaster",
            "Bloodseeker",
            "Bounty Hunter",
            "Brewmaster",
            "Bristleback",
            "Broodmother",
            "Centaur Warrunner",
            "Chaos Knight",
            "Chen",
            "Clinkz",
            "Clockwerk",
            "Crystal Maiden",
            "Dark Seer",
            "Dark Willow",
            "Dawnbreaker",
            "Dazzle",
            "Death Prophet",
            "Disruptor",
            "Doom",
            "Dragon Knight",
            "Drow Ranger",
            "Earth Spirit",
            "Earthshaker",
            "Elder Titan",
            "Huskar",
            "Io",
            "Kunkka",
            "Legion Commander",
            "Lifestealer",
            "Lycan",
            "Magnus",
            "Meepo",
            "Night Stalker",
            "Omniknight",
            "Phoenix",
            "Pudge",
            "Sand King",
            "Slardar",
            "Spirit Breaker",
            "Sven",
            "Tidehunter",
            "Timbersaw",
            "Tiny",
            "Treant Protector",
            "Tusk",
            "Underlord",
            "Undying",
            "Wraith King"
          ],
          "huskar": {
            "quote": [
              "You must learn to sacrifice.",
              "The gods grant me life, nor shall I waste it.",
              "You gave all you could give but it was not enough.",
              "As my body falls, my spirit rises up like the smoke of offerings, pleasing to the gods."
            ]
          },
          "io": {
            "quote": [
              "Really?! If you play DotA, you know IO can't talk. ¬¬'"
            ]
          },
          "item": [
            "Animal Courier",
            "Clarity",
            "Town Portal Scroll",
            "Faerie Fire",
            "Observer Ward",
            "Smoke of Deceit",
            "Tango",
            "Enchanted Mango",
            "Sentry Ward",
            "Healing Salve",
            "Tome of Knowledge",
            "Dust of Appearance",
            "Bottle",
            "Iron Branch",
            "Gauntlets of Strength",
            "Mantle of Intelligence",
            "Slippers of Agility",
            "Circlet",
            "Band of Elvenskin",
            "Belt of Strength",
            "Robe of the Magi",
            "Blade of Alacrity",
            "Ogre Axe",
            "Staff of Wizardry",
            "Ring of Protection",
            "Quelling Blade",
            "Stout Shield",
            "Infused Raindrop",
            "Orb of Venom",
            "Blight Stone",
            "Blades of Attack",
            "Chainmail",
            "Quarterstaff",
            "Helm of Iron Will",
            "Javelin",
            "Broadsword",
            "Claymore",
            "Mithril Hammer",
            "Magic Stick",
            "Wind Lace",
            "Ring of Regen",
            "Sage's Mask",
            "Boots of Speed",
            "Gloves of Haste",
            "Cloak",
            "Ring of Health",
            "Void Stone",
            "Gem of True Sight",
            "Morbid Mask",
            "Shadow Amulet",
            "Ghost Scepter",
            "Blink Dagger",
            "Energy Booster",
            "Vitality Booster",
            "Point Booster",
            "Platemail",
            "Talisman of Evasion",
            "Hyperstone",
            "Ultimate Orb",
            "Demon Edge",
            "Mystic Staff",
            "Reaver",
            "Eaglesong",
            "Sacred Relic",
            "Magic Wand",
            "Bracer",
            "Null Talisman",
            "Wraith Band",
            "Soul Ring",
            "Phase Boots",
            "Power Treads",
            "Oblivion Staff",
            "Perseverance",
            "Hand of Midas",
            "Boots of Travel",
            "Moon Shard",
            "Ring of Basilius",
            "Headdress",
            "Buckler",
            "Urn of Shadows",
            "Tranquil Boots",
            "Ring of Aquila",
            "Medallion of Courage",
            "Arcane Boots",
            "Drum of Endurance",
            "Vladmir's Offering",
            "Mekansm",
            "Spirit Vessel",
            "Pipe of Insight",
            "Guardian Greaves",
            "Glimmer Cape",
            "Force Staff",
            "Veil of Discord",
            "Aether Lens",
            "Necronomicon",
            "Solar Crest",
            "Dagon",
            "Eul's Scepter of Divinity",
            "Rod of Atos",
            "Orchid Malevolence",
            "Aghanim's Scepter",
            "Nullifier",
            "Refresher Orb",
            "Scythe of Vyse",
            "Octarine Core",
            "Hood of Defiance",
            "Vanguard",
            "Blade Mail",
            "Soul Booster",
            "Aeon Disk",
            "Crimson Guard",
            "Black King Bar",
            "Lotus Orb",
            "Hurricane Pike",
            "Shiva's Guard",
            "Bloodstone",
            "Manta Style",
            "Linken's Sphere",
            "Heart of Tarrasque",
            "Assault Cuirass",
            "Crystalys",
            "Armlet of Mordiggian",
            "Meteor Hammer",
            "Shadow Blade",
            "Skull Basher",
            "Battle Fury",
            "Monkey King Bar",
            "Ethereal Blade",
            "Radiance",
            "Daedalus",
            "Butterfly",
            "Silver Edge",
            "Divine Rapier",
            "Abyssal Blade",
            "Bloodthorn",
            "Dragon Lance",
            "Kaya",
            "Sange",
            "Yasha",
            "Mask of Madness",
            "Helm of the Dominator",
            "Echo Sabre",
            "Maelstrom",
            "Diffusal Blade",
            "Heaven's Halberd",
            "Desolator",
            "Sange and Yasha",
            "Eye of Skadi",
            "Satanic",
            "Mjollnir",
            "Aegis of the Immortal",
            "Cheese",
            "Refresher Shard"
          ],
          "kunkka": {
            "quote": [
              "An old vessel, but more than seaworthy.",
              "Tidehunter? More like dead hunter. [Talking to Tidehunter]",
              "There is no bad weather, only thin armor.",
              "Damn, I thought this bottle would have rum in it. [Acquiring Bottle]",
              "That's a lot for an empty bottle. [Acquiring Bottle]",
              "When I'm done with this, I'll fill it with rum. [Acquiring Bottle]"
            ]
          },
          "legion_commander": {
            "quote": [
              "I've come to put an end to hope.",
              "You won't win the war by dying for your Ancient. You'll win by making the other dumb, unfed bastard die for theirs!",
              "It's the smells of battle that stay with you long after they've ended. In Stonehall it was blood and sulfur, smoke, and rot and fear…"
            ]
          },
          "lifestealer": {
            "quote": [
              "Better to die free than to live in chains.",
              "Wait until I get my claws in you!",
              "I steal your life…someone else already stole your face. [Talking to Faceless Void]",
              "Even a thief must sometimes pay the asking price. [buying an item]",
              "It pains me to purchase what ought to be stolen. [Buying an item]"
            ]
          },
          "lycan": {
            "quote": [
              "A wolf in man's clothing.",
              "Who fears the wolf should fear the forest.",
              "A peaceful man is but a patient wolf."
            ]
          },
          "magnus": {
            "quote": [
              "Under my hoof you will find your fate.",
              "My horn is sharp, my pike is sharper still.",
              "Compared to my horn, all precious items are cheap."
            ]
          },
          "meepo": {
            "quote": [
              "Got dirt between my toes.",
              "One paw in front of the other!",
              "What's up Meepo?",
              "Have shovel, will bury. You.",
              "They should call you Ain't-Mage.",
              "You punched out all of my blood!",
              "Try that again, tough guy!"
            ]
          },
          "night_stalker": {
            "quote": [
              "Day walker, night stalker.",
              "Devil by day, demon by night.",
              "Flesh sustains, gold remains.",
              "I feed the darkness and the darkness feeds me."
            ]
          },
          "omniknight": {
            "quote": [
              "Fear not my friends, our guardian is here.",
              "Knowledge is peace.",
              "Let this be the last crusade. Let me find peace."
            ]
          },
          "phoenix": {
            "quote": [
              "Really?! If you play DotA, you know Phoenix can't talk. ¬¬'"
            ]
          },
          "player": [
            "Alliance.AdmiralBulldog",
            "Dendi",
            "s4",
            "rtz YB`a",
            "Loda",
            "Miracle-",
            "Aui_2000",
            "Puppey",
            "Wagamama",
            "SumaiL",
            "BigDaddyN0tail",
            "Fear",
            "EternaLEnVy",
            "Ferrari_430",
            "w33",
            "syndereN",
            "Universe",
            "KuroKy",
            "zai",
            "Peterpandam",
            "BurNIng",
            "冰冰冰",
            "Funn1k",
            "Meracle-",
            "IllidanSTR SF46",
            "JerAx",
            "1437",
            "ChuaN",
            "Pajkatt",
            "qojqva",
            "BSJ",
            "SoNNeikO",
            "fy",
            "Cr1t-",
            "xiao8",
            "Mushi",
            "artstyle",
            "Fata",
            "bOne7",
            "Resolut1on",
            "DeMoN",
            "QO",
            "FoREv",
            "ZSMJ",
            "Trixi",
            "Fng",
            "ddz`",
            "Agressif",
            "ixmike88",
            "Fly",
            "ana",
            "BuLba",
            "Mag",
            "pieliedie",
            "kpii",
            "SmAsH",
            "VANSKOR",
            "Fenrir",
            "Solo",
            "Somnus丶M",
            "MATUMBAMAN",
            "Scandal",
            "Abed",
            "ALWAYSWANNAFLY",
            "FLUFFNSTUFF",
            "Ar1se.",
            "Lil",
            "kid",
            "Moo",
            "Gh",
            "MoonS",
            "Super!",
            "NighTmAre",
            "MISERY",
            "Slayer",
            "Era",
            "Sccc",
            "Yao",
            "No[o]ne-",
            "Hao",
            "Sneyking",
            "RAMZES666",
            "LaNm",
            "thereayou",
            "canceL^^",
            "Ohaiyo",
            "ComeWithMe",
            "MidOne",
            "Sylar",
            "MinD_ContRoL",
            "monkeys-forever",
            "kaka",
            "Silent",
            "Faith",
            "火",
            "G",
            "YapzOr",
            "Febby?",
            "丶MINI幂",
            "DC.MSS",
            "Jeyo",
            "MP",
            "Ditya Ra",
            "Yawar",
            "GeneRaL",
            "633",
            "balla",
            "マテリス",
            "9pasha",
            "yol",
            "Nofear",
            "Limmp",
            "Sedoy",
            "DkPhobos",
            "Paparazi灬",
            "★Ice ice☆",
            "xfreedom",
            "Chessie",
            "AME",
            "Jenkins",
            "JoHnNy",
            "shadow"
          ],
          "pudge": {
            "quote": [
              "They call me the Butcher.",
              "Look who's coming for dinner!",
              "Come to Pudge!",
              "Get over here!",
              "I'm gonna need bigger pants.",
              "You'll look good with an apple in yer mouth!",
              "You can't chop a chopper!",
              "Sweetbreads ain't sweet and they ain't bread…and they need a butcher, not a baker.",
              "Only trouble with carrion…an hour after eating you're hungry again!"
            ]
          },
          "sand_king": {
            "quote": [
              "King of the Desert.",
              "All we are is sand in the wind…",
              "True horror is a verdant garden…",
              "Where some see an oasis, I see only mud."
            ]
          },
          "slardar": {
            "quote": [
              "Guardian of the deeps.",
              "The riches of the darkest sea abysses are mine to protect.",
              "Too bright up here and far too light. I long for the pressures of the deep, and the subtle luminosities of the sunken world."
            ]
          },
          "spirit_breaker": {
            "quote": [
              "The peace is broken!",
              "I'll break their spirits and their backs.",
              "Attack is the best defense.",
              "You'll be dead before you know it."
            ]
          },
          "sven": {
            "quote": [
              "Rogue Knight at your service!",
              "One man…in a world of foes…",
              "It's Rogue Knight, dammit! It's not rouge knight",
              "I will crush my foe as I crushed the Vigil Knights."
            ]
          },
          "team": [
            "Evil Geniuses",
            "OG",
            "Natus Vincere",
            "Team Liquid",
            "Fnatic",
            "Team Secret",
            "Alliance",
            "OpTic Gaming",
            "Iceberg Esports",
            "Mineski.亿鼎博",
            "PENTA Sports",
            "Team. Spirit",
            "LGD-GAMING",
            "M19",
            "WarriorsGaming.Unity",
            "Newbee",
            "Virtus.pro",
            "VGJ.Storm",
            "Immortals",
            "LGD.Forever Young",
            "Vici Gaming",
            "Kingdra",
            "TNC Pro Team",
            "compLexity Gaming",
            "Invictus Gaming",
            "Double Dimension",
            "Gambit Esports",
            "Team HighGround",
            "Vega Squadron",
            "EHOME",
            "5 Anchors No Captain",
            "Forsaken",
            "Entity Gaming",
            "The Final Tribe",
            "Eclipse",
            "VGJ Thunder",
            "Team Empire",
            "EHOME.immortal",
            "Natural 9",
            "Sun Gaming",
            "Ten Twenty",
            "iG.Vitality",
            "mousesports",
            "Spartak Esports",
            "Effect",
            "Fire Dragoon",
            "TEAM MAX",
            "SG e-sports team",
            "paiN Gaming",
            "Rock.Y"
          ],
          "tidehunter": {
            "quote": [
              "Time and Tidehunter wait for no man.",
              "Time to make waves.",
              "I'm hungry enough to eat a plankton.",
              "I could eat a sea cucumber.",
              "I'm so hungry I could eat a mackerel.",
              "I'm hungry enough to eat a manta ray.",
              "I'm stuffed! [Level 25]",
              "Who needs a big brain when you've got teeth like mine?"
            ]
          },
          "timbersaw": {
            "quote": [
              "I'm Rizzrack. Don't touch me!",
              "I cut things. It's what I do. What else would I do?",
              "Trees? What do you mean there's trees out there?",
              "Nobody takes me seriously.",
              "This one is in the bag. And that one is too. And that one! They are all in the bag.",
              "Cut cut cutcutcutcutcutcutcutcutcutcutcutcutcutcut!",
              "Someone once told me I needed to face fear to get over it, and I thought well why not take a step further and cut my fear into little pieces then set my fear on fire then throw the hot ash of my fear into a lake and then poison the lake. Simple!"
            ]
          },
          "tiny": {
            "quote": [
              "Sticks and stones will break their bones!",
              "The road ahead looks rocky, but that's all right with me.",
              "Why do they call it the Mineral Kingdom? We don't even have a king."
            ]
          },
          "treant_protector": {
            "quote": [
              "Thoughts cross my mind as the sun crosses the sky.",
              "Trees can be ferocious if provoked.",
              "Nature is not always kind.",
              "I would like nothing more than to plant myself in the sunshine, next to a cool stream."
            ]
          },
          "tusk": {
            "quote": [
              "They call me the Terror from the Barrier. They call me the Snowball from Cobalt. But you may call me Tusk!",
              "Who's ready for a fight? The first hit is free! Anyone?",
              "It's a great day to do some squat thrusts and lift a barrel of fish, is it not?"
            ]
          },
          "underlord": {
            "quote": [
              "I rule the Abyssal Horde.",
              "Fear is my dominion.",
              "The Abyss knows no mercy. It knows no light. It knows only fear and despair.",
              "Nothing can stop us. Nothing can slow our march. And when we have arrived, all will burn."
            ]
          },
          "undying": {
            "quote": [
              "I bring the song of death.",
              "I need… gummy vitamins.",
              "I need to work out more, but… my arm keeps snapping off."
            ]
          },
          "wraith_king": {
            "quote": [
              "King am I of all the wraiths.",
              "Submit to the Wraith King's rule!",
              "Purer than flesh, stronger than bone, imperishable is the essence of the wraith.",
              "I miss my bones.",
              "Where once was bone, wraith flesh as far as the eye can see."
            ]
          }
        },
        "elder_scrolls": {
          "city": [
            "Solitude",
            "Winterhold",
            "Markarth",
            "Daggerfall",
            "Silvenar",
            "Tignus",
            "Lainlyn",
            "Dwyynen",
            "Glenpoint",
            "Whiterun",
            "Falkreath",
            "Ykalon",
            "Kozanset",
            "Kambria",
            "Menevia",
            "Betony",
            "Northmoor",
            "Tulune",
            "Alcaire",
            "Verkarth",
            "Davon's Watch",
            "Abah's Landing",
            "Clockwork City",
            "Wayrest",
            "Stormhold",
            "Sentinel",
            "Dawnstar",
            "Morthal",
            "Riften",
            "Windhelm",
            "Dragon Bridge",
            "Helgen",
            "Ivarstead",
            "Karthwasten",
            "Riverwood",
            "Rorikstead",
            "Shor's Stone"
          ],
          "creature": [
            "Bear",
            "Cave Bear",
            "Chaurus",
            "Death Hound",
            "Snow Bear",
            "Wolf",
            "Ice Wolf",
            "Pit Wolf",
            "Sabre Cat",
            "Skeever",
            "Mudcrab",
            "Horker",
            "Ice Wraith",
            "Werewolf",
            "Troll",
            "Frost Troll",
            "Werebear",
            "Blue Dartwing",
            "Orange Dartwing",
            "Torchbugs",
            "Slaughterfish",
            "Chaurus Hunter",
            "Dremora Lord",
            "Flame Atronach",
            "Frost Atronach",
            "Storm Atronach",
            "Daedric Prince",
            "Dremora",
            "Lurker",
            "Seeker",
            "Draugr",
            "Restless Draugr",
            "Draugr Overlord",
            "Draugr Wight",
            "Draugr Deathlord",
            "Draugr Scourge",
            "Draugr Death Overlord",
            "Draugr Thrall",
            "Spider Worker",
            "Spider Soldier",
            "Spider Guardian",
            "Dwarven Shpere",
            "Dwarven Centurion",
            "Falmer",
            "Falmer Archer",
            "Falmer Gloomlurker",
            "Falmer Shaman",
            "Falmer Spellsword",
            "Falmer Shadowmaster",
            "Falmer Nightprowler",
            "Falmer Warmonger",
            "Feral Falmer",
            "Frostbite Spider",
            "Giant",
            "Frost Giant",
            "Hagraven",
            "Corrupted Shade",
            "Skeleton",
            "Spriggan",
            "Spriggan Matron",
            "Spriggan Earth Mother",
            "Wisp",
            "Shade",
            "Wispmother"
          ],
          "dragon": [
            "Dragon",
            "Blood Dragon",
            "Frost Dragon",
            "Elder Dragon",
            "Ancient Dragon",
            "Revered Dragon",
            "Legendary Dragon",
            "Serpentine Dragon",
            "Paarthunax",
            "Odahviing",
            "Alduin",
            "Mirmulnir",
            "Sahloknir"
          ],
          "first_name": [
            "Balgruuf",
            "Ralof",
            "Hadvar",
            "Irileth",
            "Gormlaith",
            "Farengar",
            "Felldir",
            "Hakon",
            "Iddra",
            "Malborn",
            "Tsun",
            "Ysgramor",
            "Tsun",
            "Gerdur",
            "Dirge",
            "Orgnar",
            "Septimus",
            "Urag",
            "Brynjolf",
            "Faralda",
            "Vignar",
            "Elenwen",
            "Rulindil",
            "Gissur",
            "Drahff",
            "Hewnon",
            "Gian",
            "Sulla",
            "Umana",
            "J'darr",
            "Astrid",
            "Nazir",
            "Maliq",
            "Babette",
            "Gabriella",
            "Festus",
            "Arnbjorn",
            "Veezara",
            "Kodlak",
            "Aela",
            "Farkas",
            "Vilkas",
            "Skjor",
            "Athis",
            "Njada",
            "Ria",
            "Torvar",
            "Brill",
            "Eorlund",
            "Tilma",
            "Hestla",
            "Askar",
            "Mercer",
            "Delvin",
            "Vex",
            "Tonilia",
            "Sapphire",
            "Cynric",
            "Niruin",
            "Rune",
            "Thrynn",
            "Vipir",
            "Garthar",
            "Ravyn",
            "Etienne",
            "Molgrom",
            "Karliah",
            "Syndus",
            "Vanryth",
            "Gulum-Ei",
            "Enthir",
            "Niranye",
            "Endon",
            "Mallus",
            "Athel",
            "Glover",
            "Erikur",
            "Ri'saad",
            "Atahbah",
            "Ma'randru-jo",
            "Khayla",
            "Ahkari",
            "Zaynabi",
            "Dro'marash",
            "Kharjo",
            "Ma'dran",
            "Ma'jhad",
            "Ra'zhinda",
            "Mjoll",
            "Brand-shei",
            "Inigo"
          ],
          "jewelry": [
            "Copper and Moonstone Circlet",
            "Copper and Onyx Circlet",
            "Copper and Ruby Circlet",
            "Copper and Sapphire Circlet",
            "Gold and Emerald Circlet",
            "Gold and Ruby Circlet",
            "Jade and Emerald Circlet",
            "Jade and Sapphire Circlet",
            "Silver and Moonstone Circlet",
            "Silver and Sapphire Circlet",
            "Aetherial Crown",
            "Diadem of the Savant",
            "Mage's Circlet",
            "Wedding Wreath",
            "Gold Ring",
            "Gold Diamond Ring",
            "Gold Emerald Ring",
            "Gold Sapphire Ring",
            "Silver Ring",
            "Silver Amethyst Ring",
            "Silver Garnet Ring",
            "Silver Ruby Ring",
            "Ahzidal's Ring of Arcana",
            "Ahzidal's Ring of Necromancy",
            "Asgeir's Wedding Band",
            "Balwen's Ornamental Ring",
            "Bone Hawk Ring",
            "Calcelmo's Ring",
            "Enchanted Ring",
            "Fjola's Wedding Band",
            "Hircine's Ring",
            "Ilas-Tei's Ring",
            "Katarina's Ornamental Ring",
            "Madesi's Silver Ring",
            "Muiri's Ring",
            "Neloth's Ring of Tracking",
            "Nightweaver's Band",
            "Pithi's Ornamental Ring",
            "Ring of Bloodlust",
            "Ring of Instinct",
            "Ring of Namira",
            "Ring of Pure Mixtures",
            "Ring of the Beast",
            "Ring of the Erudite",
            "Ring of the Hunt",
            "Ring of the Moon",
            "Silver-Blood Family Ring",
            "The Bond of Matrimony",
            "Treoy's Ornamental Ring",
            "Viola's Gold Ring",
            "Wedding Ring",
            "Gold Necklace",
            "Gold Diamond Necklace",
            "Gold Jeweled Necklace",
            "Gold Ruby Necklace",
            "Silver Necklace",
            "Silver Emerald Necklace",
            "Silver Jeweled Necklace",
            "Silver Sapphire Necklace",
            "Bone Hawk AmuletDG",
            "Amulet of Akatosh",
            "Amulet of Arkay",
            "Amulet of Dibella",
            "Amulet of Julianos",
            "Amulet of Kynareth",
            "Amulet of Mara",
            "Amulet of Stendarr",
            "Amulet of Talos",
            "Amulet of Zenithar",
            "Amulet of Articulation",
            "Amulet of BatsDG",
            "Amulet of the GargoyleDG",
            "Andurs' Amulet of Arkay",
            "Charmed Necklace",
            "East Empire Pendant",
            "Fjotli's Silver Locket",
            "Grosta's Necklace",
            "Jeweled Amulet",
            "Kyne's Token",
            "Locket of Saint JiubDG",
            "Moon Amulet",
            "Necromancer Amulet",
            "Ogmund's Amulet of Talos",
            "Reyda's Necklace",
            "Saarthal Amulet",
            "Savos Aren's Amulet",
            "Shahvee's Amulet of Zenithar",
            "The Gauldur Amulet",
            "Yisra's Necklace"
          ],
          "last_name": [
            "The Old",
            "The Greater",
            "The Lesser",
            "One-Eye",
            "Golden-Hilt",
            "Secret-Fire",
            "Septim",
            "Signus",
            "gro-Shub",
            "Gray-Mane",
            "Black-Skeever",
            "The Fist",
            "Krex",
            "Whitemane",
            "Hunter",
            "Stonearm",
            "The Haggard",
            "The Unbroken",
            "The Man",
            "Ember-Master",
            "Battle-Born",
            "Black-Briar",
            "Lothaire",
            "Frey",
            "Mallory",
            "Endell",
            "The Fleet",
            "Imyan",
            "Rarnis",
            "Twice-Killed",
            "Gatharian",
            "Maccius",
            "Newberry",
            "Cruel-Sea",
            "The Lion"
          ],
          "race": [
            "Altmer",
            "Argonian",
            "Bosmer",
            "Breton",
            "Dunmer",
            "Dwemer",
            "Imperial",
            "Khajiit",
            "Nord",
            "Orc",
            "Redguard",
            "Riekling"
          ],
          "region": [
            "Black Marsh",
            "Cyrodiil",
            "Elsweyr",
            "Hammerfell",
            "High Rock",
            "Morrowind",
            "Skyrim",
            "Summerset Isles",
            "Valenwood"
          ],
          "weapon": [
            "Alessandra's Dagger",
            "Blade of Woe",
            "Blade of Sacrifice",
            "Bloodthorn",
            "Borvir's Dagger",
            "Daedric Dagger",
            "Dragonbone Dagger DG",
            "Dragon Priest Dagger",
            "Dwarven Dagger",
            "Ebony Dagger",
            "Elven Dagger",
            "Glass Dagger",
            "Iron Dagger",
            "Kahvozein's Fang",
            "Keening",
            "Mehrunes' Razor",
            "Nettlebane",
            "Nordic Dagger DR",
            "Orcish Dagger",
            "Rundi's Dagger",
            "Shiv",
            "Skyforge Steel Dagger",
            "Stalhrim Dagger DR",
            "Steel Dagger",
            "Valdr's Lucky Dagger",
            "Daedric Mace",
            "Dragonbone Mace DG",
            "Dwarven Mace",
            "Ebony Mace",
            "Elven Mace",
            "Glass Mace",
            "Horksbane DR",
            "Iron Mace",
            "Lunar Iron Mace",
            "Lunar Steel Mace",
            "Mace of Molag Bal",
            "Nordic Mace DR",
            "Orcish Mace",
            "Prelate's Mace DG",
            "Rusty Mace",
            "Stalhrim Mace DR",
            "Steel Mace",
            "Akaviri Sword DG",
            "Amren's Family Sword",
            "Ancient Nord Sword",
            "Blades Sword",
            "Bloodscythe DR",
            "Bolar's Oathblade",
            "Ceremonial Sword",
            "Chillrend",
            "Daedric Sword",
            "Dawnbreaker",
            "Dragonbane",
            "Dragonbone Sword DG",
            "Drainheart Sword",
            "Dwarven Sword",
            "Ebony Sword",
            "Eduj",
            "Elven Sword",
            "Falmer Sword",
            "Forsworn Sword",
            "Gauldur Blackblade",
            "Ghostblade",
            "Glass Sword",
            "Grimsever",
            "Harkon's Sword DG",
            "Herebane's Courage",
            "Hjalti's Sword",
            "Honed Ancient Nord Sword",
            "Honed Falmer Sword",
            "Imperial Sword",
            "Iron Sword",
            "Lunar Iron Sword",
            "Lunar Steel Sword",
            "Miraak's Sword DR",
            "Nightingale Blade",
            "Nord Hero Sword",
            "Nordic Sword DR",
            "Orcish Sword",
            "Phantom Sword",
            "Queen Freydis's Sword",
            "Red Eagle's Bane",
            "Red Eagle's Fury",
            "Scimitar",
            "Silver Sword",
            "Skyforge Steel Sword",
            "Stalhrim Sword DR",
            "Steel Sword",
            "Soulrender DR",
            "The Pale Blade",
            "Vilkas's Sword",
            "Windshear",
            "Wooden Sword HF",
            "Ancient Nord War Axe",
            "Ancient Nordic Pickaxe DR",
            "Ceremonial Axe",
            "Daedric War Axe",
            "Dawnguard Rune Axe DG",
            "Dawnguard War Axe DG",
            "Dragonbone War Axe DG",
            "Dwarven War Axe",
            "Ebony War Axe",
            "Elven War Axe",
            "Falmer War Axe",
            "Forsworn Axe",
            "Ghorbash's Ancestral Axe",
            "Glass War Axe",
            "Hoarfrost DR",
            "Honed Draugr War Axe",
            "Honed Falmer War Axe",
            "Illusory War Axe",
            "Iron War Axe",
            "Lunar Iron War Axe",
            "Lunar Steel War Axe",
            "Nord Hero War Axe",
            "Nordic War Axe DR",
            "Notched Pickaxe",
            "Okin",
            "Orcish War Axe",
            "Pickaxe",
            "Poacher's Axe",
            "Skyforge Steel War Axe",
            "Stalhrim War Axe DR",
            "Steel War Axe",
            "Ulfric's War Axe",
            "Woodcutter's Axe",
            "Ancient Nord Battle Axe",
            "Daedric Battleaxe",
            "Dragonbone Battleaxe DG",
            "Drainblood Battleaxe",
            "Dwarven Battleaxe",
            "Ebony Battleaxe",
            "Elven Battleaxe",
            "Glass Battleaxe",
            "Headsman's Axe",
            "Honed Ancient Nord Battle Axe",
            "Iron Battleaxe",
            "Nord Hero Battle Axe",
            "Nordic Battleaxe DR",
            "Orcish Battleaxe",
            "Skyforge Steel Battleaxe",
            "Stalhrim Battleaxe DR",
            "Steel Battleaxe of Fiery Souls",
            "Steel Battleaxe",
            "Rueful Axe",
            "The Woodsman's Friend",
            "Tsun's Battleaxe",
            "Wuuthrad",
            "Ancient Nord Greatsword",
            "Balgruuf's Greatsword",
            "Bloodskal Blade DR",
            "Daedric Greatsword",
            "Dragonbone Greatsword DG",
            "Dwarven Greatsword",
            "Ebony Greatsword",
            "Ebony Blade",
            "Elven Greatsword",
            "Glass Greatsword",
            "Honed Ancient Nord Greatsword",
            "Iron Greatsword",
            "Nord Hero Greatsword",
            "Nordic Greatsword DR",
            "Orcish Greatsword",
            "Silver Greatsword",
            "Skyforge Steel Greatsword",
            "Stalhrim Greatsword DR",
            "Steel Greatsword",
            "Stormfang DR",
            "Aegisbane",
            "Champion's Cudgel DR",
            "Daedric Warhammer",
            "Dawnguard Warhammer DG",
            "Dawnguard Rune Hammer DG",
            "Dragonbone Warhammer DG",
            "Dwarven Warhammer",
            "Ebony Warhammer",
            "Elven Warhammer",
            "Glass Warhammer",
            "Iron Warhammer",
            "Nordic Warhammer DR",
            "Orcish Warhammer",
            "Shagrol's Warhammer",
            "Stalhrim Warhammer DR",
            "Steel Warhammer",
            "The Longhammer",
            "Trollsbane",
            "Volendrung",
            "Ancient Nord Bow",
            "Angi's Bow",
            "Auriel's Bow DG",
            "Bow of the Hunt",
            "Daedric Bow",
            "Dragonbone Bow DG",
            "Drainspell Bow",
            "Dravin's Bow",
            "Dwarven Bow",
            "Dwarven Black Bow of Fate DR",
            "Ebony Bow",
            "Elven Bow",
            "Falmer Bow",
            "Falmer Supple Bow",
            "Firiniel's End",
            "Forsworn Bow",
            "Froki's Bow",
            "Gauldur Blackbow",
            "Glass Bow",
            "Glass Bow of the Stag Prince DR",
            "Hunting Bow",
            "Imperial Bow",
            "Karliah's Bow",
            "Long Bow",
            "Nord Hero Bow",
            "Nordic Bow DR",
            "Orcish Bow",
            "Stalhrim Bow DR",
            "Supple Ancient Nord Bow",
            "Nightingale Bow",
            "Zephyr DG",
            "Crossbow",
            "Dwarven Crossbow",
            "Enhanced Crossbow",
            "Enhanced Dwarven Crossbow"
          ]
        },
        "fallout": {
          "characters": [
            "Abel",
            "Ada",
            "Agatha",
            "Alan",
            "Alex",
            "Alya",
            "Amber",
            "Andrew",
            "Angela Bishop",
            "Anthony",
            "Aradesh",
            "Barry",
            "Beth",
            "Billy",
            "Boone",
            "Brenden",
            "Butch Harris",
            "Cabbot",
            "Caesar",
            "Cait",
            "Calder",
            "Caleb",
            "Children of the Cathedral member",
            "Christine",
            "Christine Royce",
            "Chuck",
            "Cindy",
            "Cleo",
            "Codsworth",
            "Cougar",
            "Curie",
            "Curtis",
            "Daecon",
            "Dan",
            "Dane",
            "Daren Hightower",
            "Darrel",
            "Decker",
            "Demetre Romara",
            "Diana",
            "DiMA",
            "Doc Morbid",
            "Dog",
            "Dogmeat",
            "Dominic Moore",
            "Dr. Wu",
            "Dugan",
            "Ed",
            "Elder",
            "Elder Maxon",
            "Flash",
            "Flip",
            "Francis",
            "Gabriel",
            "Garl Death-Hand",
            "Garret",
            "Gary",
            "George",
            "Ghoul leader",
            "Ghoul prisoner",
            "Gizmo",
            "Greg",
            "Gretch",
            "Guido",
            "Gunther",
            "Gustofer",
            "Gwen",
            "Harold",
            "Harry",
            "Heather",
            "Henry",
            "Herion",
            "Hernandez",
            "Ian",
            "Iguana Bob Frazier",
            "Irwin",
            "Ismarc",
            "Izo",
            "Jacoren",
            "Jain",
            "Jake",
            "Jarvis",
            "Jasmine",
            "Jason Zimmerman",
            "Jelissa",
            "Jennifer",
            "Jeremiah",
            "Jerry",
            "Jessica",
            "John",
            "John Hancock",
            "John Maxson",
            "Jon Zimmerman",
            "Joshua Graham",
            "Justin Greene",
            "Kalnor",
            "Kane",
            "Katja",
            "Katrina",
            "Kenji",
            "Kenny",
            "Keri Lee",
            "Killian Darkwater",
            "Krupper",
            "Kyle",
            "Larry",
            "Lars",
            "Lasher",
            "Laura",
            "Legate Lanius",
            "Lemmy",
            "Lenny",
            "Leon",
            "Leone",
            "Leslie Ann Bishop",
            "Lex",
            "Liberty Prime",
            "Lieutenant",
            "Lorenzo Giovanni",
            "Lorraine",
            "Lorri",
            "Lox",
            "Loxley",
            "Lucas Simms",
            "Lucy",
            "Luke",
            "Lyle",
            "Lynda",
            "MacRae",
            "Madison Lee",
            "Marcelles",
            "Martha Rastello",
            "Master",
            "Mat",
            "Mathia",
            "Michael",
            "Miles",
            "Miria",
            "Mitch",
            "Mohandki",
            "Morpheus",
            "Myron",
            "Nancy",
            "Neal",
            "Nick Valentine",
            "Nicole",
            "Old Longfellow",
            "Paladin Danse",
            "Patrick the Celt",
            "Paul",
            "Percy",
            "Petrox",
            "Phil",
            "Phillips",
            "Piper Wright",
            "Porter Gage",
            "Preston Garvey",
            "Rayze",
            "Razlo",
            "Razor",
            "Rhombus",
            "Rick",
            "Robert Joseph Mac Cready",
            "Rock",
            "Rose of Sharon Cassidy",
            "Rutger",
            "Sally",
            "Sammael",
            "Sarah",
            "Sasha",
            "Saul",
            "Savil",
            "Set",
            "Seth",
            "Shannon",
            "Shark",
            "Sherry",
            "Shopkeeper",
            "Sid",
            "Sinthia",
            "Skizzer",
            "Slappy",
            "Slummer",
            "Smitty",
            "Sophia",
            "Stapleton",
            "Strong",
            "Sulik",
            "Talius",
            "Talus",
            "Tandi",
            "Terry",
            "The Master",
            "Theresa",
            "Thomas",
            "Thorndyke",
            "Three Dog",
            "Tine Taylor",
            "Tolya",
            "Ton Barracus",
            "Tony Fry",
            "Trish",
            "Tycho",
            "Unit 462",
            "Van Hagan",
            "Vance",
            "Victor",
            "Vincent",
            "Vinnie",
            "Viola",
            "Vree",
            "Wiggum",
            "X6-88",
            "Yes Man",
            "Zack",
            "Zack Barstow",
            "Zark",
            "ZAX 1.2"
          ],
          "factions": [
            "Boomers",
            "Brotherhood of Steel",
            "Caesar's Legion",
            "Chinese remnants",
            "Diamond City security",
            "Enclave",
            "Followers of the Apocalypse",
            "Gunners",
            "Kings",
            "Master's Army",
            "Mojave Express",
            "New California Republic",
            "Nuka World Triumvirate",
            "Powder Gangers",
            "Raiders",
            "State of Utobitha",
            "Talon Company",
            "Triggermen",
            "United States Armed Forces",
            "Van Graffs"
          ],
          "locations": [
            "Anchorage",
            "Big MT",
            "Big town",
            "Cambridge",
            "Capital Wasteland",
            "Concord",
            "Diamond City",
            "Dog City",
            "Goodsprings",
            "Hoover Dam",
            "Lexington",
            "Little Lamplight",
            "Megaton",
            "Nellis Air Force Base",
            "New Reno",
            "New Vegas",
            "Nipton",
            "Primm",
            "Raven Rock",
            "Red Rock Canyon",
            "Sloan",
            "The Commonwealth",
            "The Institute",
            "Vault 101",
            "Vault 11",
            "Vault 111",
            "Vault 13",
            "Vault 15",
            "Vault 19",
            "Vault 22",
            "Vault 3",
            "Vault 81",
            "Vault City"
          ],
          "quotes": [
            "Ad Victoriam!",
            "Calm is what you have to be when people look to you, and it's all you can be when things are out of your hands.",
            "Democracy is non-negotiable",
            "Hi, I'm Jean Baptiste. And you're about to stop being a pain in my ass.",
            "I'm a synth. Synthetic man. All the parts, minus a few red blood cells.",
            "I'm dying.... so that democracy... can live.",
            "I'm gonna run some diagnostics while you're tinkering. Take your time.",
            "I've seen soldiers come and go. Some were brave. Some were honest. Some were even heroic. But I've never called any of them a friend.",
            "If you want to see the fate of democracies, just look out the window",
            "Let's go, pal.",
            "Liberty Prime is online. All systems nominal. Weapons hot. Mission: the destruction of any and all Chinese communists.",
            "Ngh. Hi. I'm Mahsofabish ang I gob ko keep fiebs gaeg.",
            "Nobody has a Dick that long, not eve Long-Dick Johnson, and he had a fuckin long dick, thus the name.",
            "Nothing to impede progress. If you want to see the fate of democracies, look out the windows.",
            "Patrolling the Mojave almost makes you wish for a nuclear winter.",
            "Please step out of the fountain",
            "Revised stratagem: Initiate photonic resonance overcharge.",
            "Stimpaks are a marvelous invention, don't you think?",
            "Strange rumors from across the river indicate that a secret underground robot army has been destroyed before anyone had a chance to use it.",
            "Success depends on forethought, dispassionate calculation of probabilities, accounting for every stray variable.",
            "Sure. Be glad to take...I mean hold some stuff for you.",
            "That chip of yours, I wouldn't wager it on Blackjack...Unless the dealer has a five of six showing.",
            "That means you're, erm... two centuries late for dinner! Perhaps I could whip you up a snack? You must be famished!",
            "The past, the present, and the future walked into a bar. It was tense.",
            "The women of New Vegas ask me a lot if there's a Mrs. New Vegas. Well, of course there is. You're her. And you're still as perfect as the day we met.",
            "Though dangerous, combat is quite vigorous exercise.",
            "Today's forecast calls for a 99%chance of clear skies being ruined by artillery fire.",
            "Voice module online. Audio functionality test initialized. Designation: Liberty Prime. Mission: the liberation of Anchorage, Alaska.",
            "We must find the men of science and institutes of learning, surely they are out there still.",
            "We'd move faster if you'd keep your eyes on the road and off me arse.",
            "Well, ain't we all, right? That was a long time ago. I don't pay it much mind anymore.",
            "What did you... did you put a plug in his cocktube and make him explode?",
            "Who do you think actually won the war? No one, I guess.",
            "You stood up to Elder Maxson for me. I'll never forget that for as long as I live.",
            "You think I inject myself with all that shite and drink myself drunk because I’m a tough Irish gal?",
            "You'd be shocked how many people I've managed to convince I'm just a really sick ghoul."
          ]
        },
        "final_fantasy_xiv": {
          "characters": [
            "Alphinaud Leveilleur",
            "Alisaie Leveilleur",
            "Y'shtola Rhul",
            "Thancred Waters",
            "Lyse Hext",
            "Urianger Augurelt",
            "G'raha Tia",
            "Estinien Wyrmblood",
            "Tataru Taru",
            "Krile Mayer Baldesion",
            "Minfilia Warde",
            "Louisoix Leveilleur",
            "Papalymo Totolymo",
            "Yda Hext",
            "F'lhaminn Qesh",
            "Unukalhai",
            "Moenbryda Wilfsunnwyn",
            "Arenvald Lentinus",
            "Riol Forrest",
            "Alianne Vellegrance",
            "Aenor Cockburne",
            "Aergmhus Saehstymmsyn",
            "Bluomwyda",
            "Clemence",
            "Coultenet Dailebaure",
            "Ephemie Giphelmont",
            "Hoary Boulder",
            "Ocher Boulder",
            "Una Tayuun",
            "V'mah Tia",
            "Noraxia",
            "Kan-E-Senna",
            "Merlwyb Bloefhiswyn",
            "Raubahn Aldynn",
            "Nanamo Ul Namo",
            "Aymeric de Borel",
            "Cid nan Garlond",
            "Biggs",
            "Wedge",
            "Jessie Jaye",
            "Alpha",
            "Cato Mammula",
            "Lilja Sjasaris",
            "Emet-Selch",
            "Elidibus",
            "Lahabrea",
            "Igeyorhm",
            "Nabriales",
            "Fandaniel",
            "Pashtarot",
            "Loghrif",
            "Mitron",
            "Travanchet",
            "Hythlodaeus",
            "Venat",
            "Erichthonios",
            "Solus zos Galvus",
            "Varis zos Galvus",
            "Zenos yae Galvus",
            "Gaius van Baelsar",
            "Nael van Darnus",
            "Asahi sas Brutus",
            "Aulus mal Asina",
            "Basch van Gabranth",
            "Fordola rem Lupis",
            "Grynewaht pyr Arvina",
            "Lambard Calowise",
            "Livia sas Junius",
            "Maxima quo Priscus",
            "Midas nan Garlond",
            "Nero tol Scaeva",
            "Noah van Gabranth",
            "Regula van Hydrus",
            "Rhitahtyn sas Arvina",
            "Vitus quo Messalla",
            "Allie",
            "Clarricie Priscus",
            "Drusilla",
            "Dyunbu Potitus",
            "Fabineau Soranus",
            "Gilbrisbert Buteo",
            "Hernais Longus",
            "Jullus Norbanus",
            "Llofii Potitus",
            "Lyon Helsos",
            "Menenius Lanatus",
            "Milisandia",
            "Pagaga Vochstein",
            "Quintus Cinna",
            "Rex",
            "Ricon",
            "Sadr Albeleo",
            "Sartauvoir Soranus",
            "Sicinius Vellutus",
            "Valens Varro",
            "Vergilia Corculum",
            "Yamatsumi Urabe",
            "A-Ruhn-Senna",
            "A-Towa-Cant",
            "Buscarron Stacks",
            "Cicely",
            "Drake Rhodes",
            "E-Sumi-Yan",
            "Eschiva Keyes",
            "Foulques",
            "Fufucha Fucha",
            "Gerolt Blackthorn",
            "Geva Storke",
            "Guydelot Thildonnet",
            "Isildaure Vellegrance",
            "Janremi Blackheart",
            "Jehantel Fointeaume",
            "Joacin",
            "Landenel Peaumasquier",
            "Laurentius Daye",
            "Leih Aliapoh",
            "Lina Mewrilah",
            "Luciane Corne",
            "Millith Ironheart",
            "Miounne",
            "Nolanel",
            "O-App-Pesi",
            "Pawah Mujuuk",
            "Raya-O-Senna",
            "Sanson Smyth",
            "Silvairre",
            "Swethyna Brookstone",
            "Sylphie Webb",
            "Tatabaru",
            "Tataramu",
            "Sezul Totoloc",
            "Voyce",
            "Wulfiue",
            "Ywain Deepwell",
            "Zhai'a Nelhah",
            "Frixio'",
            "Adalberta Sterne",
            "Aldis",
            "Chuchuto Chuto",
            "Cocobani",
            "Cocobezi",
            "Cocoboha",
            "Cocobuki Lolobuki",
            "Cocobusi",
            "Cocobygo",
            "Colbernoux",
            "Dancing Wolf",
            "Deep Canyon",
            "Dewlala Dewla",
            "Eline Roaille",
            "Erik",
            "F'hobhas",
            "Fyrgeiss Loetkilbsyn",
            "Gagaruna",
            "Greinfarr Redblade",
            "Hamon Holyfist",
            "Iliud",
            "Jenlyns Aesc",
            "Kikipu Kipu",
            "Lalai Lai",
            "Leavold",
            "Lewena",
            "Lolorito Nanarito",
            "Loonh Gah",
            "Martyn",
            "Memeriga",
            "Momodi Modi",
            "Mumuepo",
            "Mylla Swordsong",
            "Nenekko Nekko",
            "Niellefresne Thaudour",
            "Nutiba Buntiba",
            "Pipin Tarupin",
            "Popokkuli and Seserukka",
            "P'yandih",
            "Qhota Nbolo",
            "Ququruka Tataruka",
            "Redolent Rose",
            "Royse",
            "Rurukuta",
            "Serendipity",
            "Severian Lyctor",
            "Solkzagyl Keltnaglsyn",
            "Teledji Adeledji",
            "Tristan Lowe",
            "U'odh Nunh",
            "Valiant Hart",
            "Waldeve",
            "Whastrach",
            "Weggfarr",
            "Wide Gulley",
            "Yayake Yake",
            "Yuyuhase Luluhase",
            "Zirnberk",
            "Dozol Meloc",
            "Kazagg Chah",
            "Mutamix Bubblypots",
            "Alka Zolka",
            "Arya Gastaurknan",
            "Baderon Tenfingers",
            "Brithael Spade",
            "Broken Mountain",
            "Carvallain de Gorgagne",
            "Curious Gorge",
            "Doesmaga Poisonheart",
            "Eynzahr Slafyrsyn",
            "H'mhasi Tia",
            "H'naanza Esi",
            "Hyllfyr Faezmoensyn",
            "Jacke Swallow",
            "K'lyhia",
            "K'rhid Tia",
            "Latisha",
            "Lorens",
            "Lyngsath Hyllbornsyn",
            "Madison",
            "Melkoko Melko",
            "Mimidoa Nanadoa",
            "Perimu Haurimu",
            "R'ashaht Rhiki",
            "Reyner Hansred",
            "Rhoswen Leach",
            "Rostnsthal",
            "Shamani Lohmani",
            "Sisipu Sipu",
            "Solkwyb Saelsmyndsyn",
            "Thubyrgeim Guldweitzwyn",
            "V'kebbe",
            "Wawalago Momolago",
            "Wheiskaet Rysswoerdsyn",
            "Wyrnzoen Saelsmyndsyn",
            "13th Order Fugleman Zo Ga",
            "175th Order Alchemist Bi Bi",
            "789th Order Pickman Gi Gu",
            "Ga Bu",
            "Brayflox Alltalks",
            "Govv",
            "Surito Carito",
            "Setoto Seto",
            "Talan",
            "Rowena",
            "Estinien Wyrmblood",
            "Ysayle Dangoulain",
            "Thordan VII",
            "Edmont de Fortemps",
            "Artoirel de Fortemps",
            "Emmanellain de Fortemps",
            "Haurchefant Greystone",
            "Alberic Bale",
            "Ansaulme de Rougecarpe",
            "Audaine",
            "Augebert",
            "Aurvael de Haillenarte",
            "Ayleth",
            "Baurendouin de Haillenarte",
            "Charlemend de Durendaire",
            "Constaint",
            "Dominiac",
            "Drillemont de Lasserrant",
            "Forlemort",
            "Foncrineau",
            "Elaisse Poole",
            "Francel de Haillenarte",
            "Fray Myste",
            "Gontrandoix",
            "Guillaime",
            "Guillefresne",
            "Haldrath",
            "Handeloup de Daimbaux",
            "Hautdlong",
            "Heustienne de Vimaroix",
            "Hilda Ware",
            "Honoroit Banlardois",
            "Hourlinet",
            "Jannequinard de Durendaire",
            "Jantellot de Thelomaire",
            "Joye",
            "Julchiezain",
            "Laniaitte de Haillenarte",
            "Lucia goe Junius",
            "Lycelle",
            "Marcelloix",
            "Muscadain de Citenrond",
            "Noalle",
            "Pehainel",
            "Peyraquile",
            "Quimperain Evertrue",
            "Rasequin",
            "Redwald Younge",
            "Rielle de Caulignont",
            "Saintrelmaux",
            "Ser Adelphel de Chevraudan",
            "Ser Charibert de Leusignac",
            "Ser Grinnaux de Dzemael",
            "Ser Guerrique de Montrohain",
            "Ser Haumeric de Peulagnon",
            "Ser Hermenost de la Treaumaille",
            "Ser Janlenoux de Courcillant",
            "Ser Ignasse de Vesnaint",
            "Ser Noudenet de Jaimberd",
            "Ser Paulecrain de Fanouilley",
            "Ser Zephirin de Valhourdin",
            "Ser Vellguine de Bourbagne",
            "Sidurgu Orl",
            "Sigan",
            "Stephanivien de Haillenarte",
            "Sylvetrel de Dzemael",
            "Tedalgrinche",
            "Thomelin",
            "Thordan I",
            "Ystride de Caulignont",
            "Midgardsormr",
            "Bahamut",
            "Hraesvelgr",
            "Nidhogg",
            "Ratatoskr",
            "Tiamat",
            "Vrtra",
            "Azdaja",
            "Ehll Tou",
            "Faunehm",
            "Orn Khai",
            "Twintania",
            "Vedrfolnir",
            "Vidofnir",
            "Vishap",
            "Adri Westwoode",
            "Conrad Kemp",
            "Curtis Hext",
            "D'zentsa",
            "Gundobald",
            "H'raha Tia",
            "Hewerald",
            "Ilberd Feare",
            "J'moldva",
            "M'naago Rahz",
            "Meffrid Noward",
            "O'tchakha",
            "Raulf Redhill",
            "The Griffin",
            "Ulger Ironheart",
            "Widargelt Beake",
            "Wilred Glasse",
            "X'rhun Tia",
            "Slowfix Cointoss",
            "Adkiragh",
            "Khloe Aliapoh",
            "Mide Hotogo",
            "Midnight Dew",
            "T'kebbe Morh",
            "Zhloe Aliapoh",
            "Loifa",
            "Quickthinx Allthoughts",
            "Chieftain Moglin",
            "Master Mogzin",
            "Leofard Myste",
            "Stacia Myste",
            "Radlia Keene",
            "Cait Sith",
            "Ejika Tsunjika",
            "Faldrinet",
            "Fourchenault Leveilleur",
            "Koh Rabntah",
            "Lalah Jinjahl",
            "Leveva Byrde",
            "Matoya",
            "Mikoto Jinba",
            "Rammbroes Zasertylsyn",
            "Rhesh Polaali",
            "Y'mhitra Rhul",
            "Hien Rijin",
            "Yugiri Mistwalker",
            "Gosetsu Everfall",
            "Yotsuyu goe Brutus",
            "Azami Shibunuri",
            "Anzu Zenbu",
            "Gekkai",
            "Ginko",
            "Gogo",
            "Hakuro Gunji",
            "Hozan Nagae",
            "Isse Shibunuri",
            "Karasu Kanshi",
            "Kinko",
            "Kurobana",
            "Mikuzume",
            "Oboro Torioi",
            "Tsubame Oshidari",
            "Yozan Nagae",
            "Tenzen",
            "Seiryu",
            "Suzaku",
            "Byakko",
            "Genbu",
            "Ramza Beoulve",
            "Delita Heiral",
            "Alma Beoulve",
            "Agrias Oaks",
            "Fran Eruyt",
            "Montblanc",
            "Ashelia",
            "Rasler",
            "Ba'Gamnan",
            "Rofocale",
            "Sophie",
            "Alma bas Lexentale",
            "Jenomis cen Lexentale",
            "Ramza bas Lexentale",
            "Wandering Dramaturge",
            "Akagi",
            "Hanzo",
            "Hancock Fitzgerald",
            "Kikimo Kimo",
            "Kotokaze Benitoki",
            "Kyokuho Moribe",
            "Makoto Obinata",
            "Yatsurugi no Yuki",
            "Hansaku Ushikai",
            "Hisui Sui",
            "Kurenai Shisui",
            "Rasho Mastbreaker",
            "Shiosai Sui",
            "Soroban",
            "Suzume Kaisuri",
            "Tansui",
            "Tsukikage Urabe",
            "Cirina Mol",
            "Magnai Oronir",
            "Sadu Dotharl",
            "Alaqa",
            "Altani Dataq",
            "Anarba Dataq",
            "Chambui Dazkar",
            "Dorgono Qerel",
            "Gurbesu Goro",
            "Khalja Dataq",
            "Nayaga",
            "Ogul Khatayin",
            "Sokhatai Dataq",
            "Bajsaljen Ulgasch",
            "Marsak Apella",
            "Misija Votyasch",
            "Rostik Liubasch",
            "Blaz Azetina",
            "Isolde Covey",
            "Lovro Slanasch",
            "Meryall Miller",
            "Stanik Alubov",
            "Velibor Azetina",
            "Xeven Svanasch",
            "Dabog Inivisch",
            "Radovan",
            "Ardashir Balyk",
            "Jalzahn Daemir",
            "Nashmeira",
            "Pasareen",
            "Ranaa Mihgo",
            "Yezahn",
            "Nidhana",
            "Ardbert",
            "Branden",
            "Cylva",
            "Lamitt",
            "Nyelbert",
            "Renda-Rae",
            "The Crystal Exarch",
            "Ryne",
            "Beq Lugg",
            "Callea",
            "Cerigg",
            "Gaia",
            "Giott",
            "Granson",
            "Lue-Reeq",
            "Lyna",
            "Mauwyl",
            "Nielden",
            "Taynor",
            "Tolas",
            "Tesleen",
            "Halric",
            "Vauthry",
            "Ran'jit",
            "Jongleurs of Eulmore",
            "Chai-Nuzz",
            "Dulia-Chai",
            "Tista-Bie",
            "Anogg and Konogg",
            "Eueliss",
            "Kai-Shirr",
            "Lanbyrd",
            "Olvara",
            "Sai-Lewq",
            "Tristol",
            "Feo Ul",
            "An Lad",
            "Ezel II",
            "Seto",
            "Sul Oul",
            "Tonatiuh",
            "Titania",
            "Tyr Beq",
            "Sauldia",
            "Tadric",
            "Almet",
            "Cymet",
            "Uimet",
            "Ciuna",
            "Phyna",
            "Quinfort",
            "Valan",
            "Runar",
            "Xande",
            "Doga",
            "Unei",
            "Amon",
            "Phlegethon",
            "Scylla",
            "Glasya Labolas",
            "Ultima Weapon",
            "Halone",
            "Menphina",
            "Nymeia",
            "Byregot",
            "Rhalgr",
            "Azeyma",
            "Nald",
            "Thal",
            "Nophica",
            "Althyk",
            "Hydaelyn, Divine Light",
            "Zodiark, Eternal Darkness",
            "Ifrit, Lord of the Inferno",
            "Titan, Lord of Crags",
            "Garuda, Lady of the Vortex",
            "Good King Moggle Mog XII",
            "Leviathan, Lord of the Whorl",
            "Ramuh, Lord of Levin",
            "Shiva, Lady of Frost",
            "Phoenix, Mythical Bird of Rebirth",
            "Odin, The Dark Divinity",
            "Bismarck, Lord of the Mists",
            "Ravana, Lord of the Hive",
            "King Thordan",
            "Sephirot, the Fiend",
            "Sophia, the Goddess",
            "Zurvan, the Demon",
            "Alexander, the Colossus",
            "Susano, Lord of the Revel",
            "Lakshmi, Lady of Bliss",
            "Shinryu, Dragon God of Vengeance",
            "Tsukuyomi",
            "Enkidu",
            "Eureka",
            "The Twelve",
            "The Queen, Vengeful Eikon",
            "Diabolos",
            "Cloud of Darkness",
            "Ferdiad",
            "Scathach",
            "Zero",
            "Scarmiglione, Blighted Despot",
            "Barbariccia, Empress of the Winds",
            "Cagnazzo, Drowned King",
            "Rubicante, Autarch of Flame",
            "Golbez",
            "Hildibrand Manderville",
            "Godbert Manderville",
            "Julyan Manderville",
            "Nashu Mhakaracca",
            "Briardien de Manseauguel",
            "Cyr Blyme",
            "Ellie Ryse",
            "Gigi",
            "Gilgamesh",
            "Typhon and Ultros",
            "Yojimbo",
            "Ardashir Balyk",
            "Gerolt Blackthorn",
            "Drake Rhodes",
            "Jalzahn Daemir",
            "Rowena",
            "Edda Pureheart",
            "Jandelaine",
            "Martyn",
            "Nhaza'a Jaab",
            "Reyna Breakhook",
            "Rhesh Polaali",
            "Wandering Minstrel",
            "Naoki Yoshida",
            "Nohi",
            "Aldiytha Thorne",
            "Amh Garanjy",
            "Damielliot",
            "Impresario",
            "Jihli Aliapoh",
            "Kipih Jakkya",
            "Laurenssen",
            "Lorie",
            "Momoru",
            "Nanapasi",
            "Ninimo",
            "Rodolph",
            "Royal seneschal",
            "Songbirds",
            "Unsavory Imp",
            "Omega",
            "N-7000",
            "Livingway",
            "Jammingway",
            "Puddingway",
            "Shantotto",
            "Iroha",
            "Lightning",
            "Odin",
            "Garuda",
            "Noctis Lucis Caelum",
            "Lunafreya Nox Fleuret",
            "Nybeth Obdilord",
            "2B",
            "2P",
            "9S"
          ],
          "data_centers": [
            "Aether",
            "Crystal",
            "Dynamis",
            "Primal",
            "Chaos",
            "Light",
            "Materia",
            "Elemental",
            "Gaia",
            "Mana",
            "Meteor"
          ],
          "jobs": [
            "Paladin",
            "Gladiator",
            "Warrior",
            "Marauder",
            "Dark Knight",
            "Gunbreaker",
            "White Mage",
            "Scholar",
            "Astrologian",
            "Sage",
            "Arcanist",
            "Red Mage",
            "Black Mage",
            "Blue Mage",
            "Thaumaturge",
            "Summoner",
            "Lancer",
            "Dragoon",
            "Monk",
            "Ninja",
            "Rogue",
            "Samurai",
            "Reaper",
            "Bard",
            "Archer",
            "Machinist",
            "Dancer",
            "Fisher",
            "Botanist",
            "Miner",
            "Carpenter",
            "Blacksmith",
            "Armorer",
            "Goldsmith",
            "Leatherworker",
            "Weaver",
            "Alchemist",
            "Culinarian"
          ],
          "races": [
            "Au Ra",
            "Viera",
            "Miqo'te",
            "Hrothgar",
            "Lalafell",
            "Elezen",
            "Roegadyn",
            "Hyur"
          ],
          "zones": [
            "Limsa Lominsa Upper Decks",
            "Limsa Lominsa Lower Decks",
            "Mist",
            "Wolves' Den Pier",
            "Middle La Noscea",
            "Lower La Noscea",
            "Eastern La Noscea",
            "Western La Noscea",
            "Upper La Noscea",
            "Outer La Noscea",
            "New Gridania",
            "Old Gridania",
            "The Lavender Beds",
            "Central Shroud",
            "East Shroud",
            "South Shroud",
            "North Shroud",
            "Ul'dah - Steps of Nald",
            "Ul'dah - Steps of Thal",
            "The Goblet",
            "The Gold Saucer",
            "Western Thanalan",
            "Central Thanalan",
            "Eastern Thanalan",
            "Southern Thanalan",
            "Northern Thanalan",
            "Foundation",
            "The Pillars",
            "Empyreum",
            "Coerthas Central Highlands",
            "Coerthas Western Highlands",
            "Mor Dhona",
            "The Sea of Clouds",
            "Azys Lla",
            "Idyllshire",
            "The Dravanian Forelands",
            "The Dravanian Hinterlands",
            "The Churning Mists",
            "Rhalgr's Reach",
            "The Fringes",
            "The Peaks",
            "The Lochs",
            "Kugane",
            "Shirogane",
            "The Ruby Sea",
            "Yanxia",
            "The Azim Steppe",
            "The Crystarium",
            "Lakeland",
            "Eulmore",
            "Kholusia",
            "Amh Araeng",
            "Il Mheg",
            "The Rak'tika Greatwood",
            "The Tempest",
            "Old Sharlayan",
            "Labyrinthos",
            "Garlemald",
            "Radz-at-Han",
            "Thavnair",
            "Mare Lamentorum",
            "Ultima Thule",
            "Elpis",
            "Gangos",
            "The Omphalos",
            "Unnamed Island"
          ]
        },
        "half_life": {
          "character": [
            "Adrian Shephard",
            "Alyx Vance",
            "Arne Magnusson",
            "Barney Calhoun",
            "Colette Green",
            "Dog",
            "Eli Vance",
            "Father Grigori",
            "G-Man",
            "Gina Cross",
            "Gordon Freeman",
            "Isaac Kleiner",
            "Judith Mossman",
            "Odessa Cubbage",
            "Richard Keller",
            "Simmons",
            "Wallace Breen",
            "Walter Bennet"
          ],
          "enemy": [
            "APC",
            "Alien Controller",
            "Alien Grunt",
            "Antlion",
            "Antlion Guard",
            "Assassin",
            "Baby Headcrab",
            "Barnacle",
            "Bullsquid",
            "City Scanner",
            "Civil Protection",
            "Combine Advisor",
            "Combine Gunship",
            "Crab Synth",
            "Fast Headcrab",
            "Fast Zombie",
            "Garg",
            "Gene Worm",
            "Gonarch",
            "Grunt",
            "Headcrab",
            "Hopper Mine",
            "Houndeye",
            "Hunter-Chopper",
            "Ichthyosaur",
            "Leech",
            "Manhack",
            "Mortar Synth",
            "Overwatch Elite",
            "Overwatch Sniper",
            "Overwatch Soldier",
            "Pit Drone",
            "Pit Worm",
            "Poison Headcrab",
            "Poison Zombie",
            "Rollermine",
            "Shield Scanner",
            "Shock Roach",
            "Shock Trooper",
            "Snark",
            "Strider",
            "Tentacle",
            "Voltigore",
            "Vortigaunt",
            "Zombie"
          ],
          "location": [
            "Black Mesa East",
            "Black Mesa Research Facility",
            "Citadel",
            "City 17",
            "Earth",
            "Nova Prospekt",
            "Ravenholm",
            "Section A-17 Prototype Labs",
            "Sector A Training Facility",
            "Sector B Coolant Reserve",
            "Sector C Test Labs",
            "Sector D Administration",
            "Sector E Biodome Complex",
            "Sector F Lambda Complex",
            "Sector G Hydro Electric",
            "St. Olga",
            "White Forest",
            "Xen"
          ]
        },
        "league_of_legends": {
          "champion": [
            "Aatrox",
            "Ahri",
            "Akali",
            "Alister",
            "Amumu",
            "Anivia",
            "Annie",
            "Ashe",
            "Aurelion Sol",
            "Azir",
            "Bard",
            "Blitzcrank",
            "Brand",
            "Braum",
            "Caitlyn",
            "Camille",
            "Cassiopeia",
            "Cho-Gath",
            "Corki",
            "Darius",
            "Diana",
            "Dr. Mundo",
            "Draven",
            "Ekko",
            "Elise",
            "Evelynn",
            "Ezreal",
            "Fiddlesticks",
            "Fiora",
            "Fizz",
            "Galio",
            "Gangplank",
            "Garen",
            "Gnar",
            "Gragas",
            "Graves",
            "Hecarim",
            "Heimerdinger",
            "Illaoi",
            "Irelia",
            "Ivern",
            "Janna",
            "Jarvan IV",
            "Jax",
            "Jayce",
            "Jhin",
            "Jinx",
            "Kai'Sa",
            "Kalista",
            "Karma",
            "Karthus",
            "Kassadin",
            "Katarina",
            "Kayle",
            "Kayn",
            "Kennen",
            "Kha'Zix",
            "Kindred",
            "Kled",
            "Kog'Maw",
            "LeBlanc",
            "Lee Sin",
            "Leona",
            "Lissandra",
            "Lucian",
            "Lulu",
            "Lux",
            "Malphite",
            "Malzahar",
            "Maokai",
            "Master Yi",
            "Miss Fortune",
            "Mordekaiser",
            "Morgana",
            "Neeko",
            "Nami",
            "Nasus",
            "Nautilus",
            "Nidalee",
            "Nocturne",
            "Nunu & Willump",
            "Olaf",
            "Orianna",
            "Ornn",
            "Pantheon",
            "Poppy",
            "Pyke",
            "Quinn",
            "Rammus",
            "Rek'Sai",
            "Renekton",
            "Rengar",
            "Riven",
            "Rakan",
            "Rumble",
            "Ryze",
            "Sejuani",
            "Shaco",
            "Shen",
            "Shyvanna",
            "Singed",
            "Sion",
            "Sivir",
            "Skarner",
            "Sona",
            "Soraka",
            "Swain",
            "Sylas",
            "Syndra",
            "Tahm Kench",
            "Taliyah",
            "Talon",
            "Taric",
            "Teemo",
            "Thresh",
            "Tristana",
            "Trundle",
            "Tryndamere",
            "Twisted Fate",
            "Twitch",
            "Udyr",
            "Urgot",
            "Varus",
            "Vayne",
            "Veigar",
            "Vel'Koz",
            "Vi",
            "Viktor",
            "Vladimir",
            "Volibear",
            "Warwick",
            "Wukong",
            "Xayah",
            "Xerath",
            "Xin Zhao",
            "Yasuo",
            "Yorick",
            "Yuumi",
            "Zac",
            "Zed",
            "Ziggs",
            "Zilean",
            "Zoe",
            "Zyra"
          ],
          "location": [
            "Demacia",
            "Noxus",
            "Shadow Isles",
            "Valoran",
            "Runeterra",
            "Bandle City",
            "Bilgewater",
            "Freljord",
            "Ionia",
            "Mount Targon",
            "Piltover",
            "Lokfar",
            "Zaun"
          ],
          "masteries": [
            "Battle Trance",
            "Double Edged Sword",
            "Bounty Hunter",
            "Fresh Blood",
            "Expose Weakness",
            "Feast",
            "Warlord's Bloodlust",
            "Fervor of Battle",
            "Deathfire Touch",
            "Greenfather's Gift",
            "Dangerous Game",
            "Bandit",
            "Courage of the Colossus",
            "Stoneborn Pact",
            "Grasp of the Undying",
            "Siegemaster",
            "Tough Skin",
            "Explorer",
            "Assassin",
            "Secret Stash",
            "Runic Affinity",
            "Windspeaker's Blessing",
            "Thunderlord's Decree",
            "Stormraider's Surge",
            "Fearless",
            "Unyielding",
            "Meditation",
            "Battering Blows",
            "Piercing Thoughts",
            "Insight",
            "Perseverance",
            "Intelligence",
            "Precision",
            "Sorcery",
            "Vampirism",
            "Fury",
            "Natural Talent",
            "Savagery",
            "Wanderer",
            "Merciless",
            "Recovery",
            "Legendary Guardian",
            "Swiftness",
            "Runic Armor",
            "Veteran's Scars"
          ],
          "quote": [
            "Purge the unjust.",
            "By my will, this shall be finished!",
            "You only have to click once, fool!",
            "My right arm is a lot stronger than my left.",
            "Ready to set the world on fire...",
            "The early bird guts the worm!",
            "Don't you trust me?",
            "Welcome to Summoners Rift!",
            "Have you seen my Bear Tibbers?",
            "NOM NOM NOM",
            "Defy Noxus and taste your own blood.",
            "Behold the might of the shadow isles.",
            "Who wants a piece of the champ?!",
            "Come on, live a little... while you can!",
            "Master yourself, master the enemy.",
            "Blindness is no impairment against a smelly enemy.",
            "ok.",
            "Caught between a rock... and a hard place.",
            "Mundo will go where he pleases!",
            "Mundo say his own name a lot, or else he forget! Has happened before.",
            "A man, a woman and a yordle walk into the sun. They die! Because it burns them alive? heh heh heh heh",
            "The cycle of life and death continues. We will live, they will die.",
            "My profession?! You know, now that I think of it, I've always wanted to be a baker.",
            "Tonight we hunt!",
            "Monsters can be made to fear.",
            "How about a drink?",
            "Captain Teemo on duty.",
            "Hut, two, three, four. Yes, sir!",
            "I'll scout ahead!",
            "That's gotta sting.",
            "Never underestimate the power of the Scout's code.",
            "I suppose you're expecting some inBEARable pun?",
            "It's not how much you can lift. It's how good you look!",
            "Welcome to the League of Draven.",
            "Not Draven; Draaaaven.",
            "Who wants some Draven? Heheheh.",
            "Subtle? I don't do subtle."
          ],
          "rank": [
            "Iron IV",
            "Iron III",
            "Iron II",
            "Iron I",
            "Bronze IV",
            "Bronze III",
            "Bronze II",
            "Bronze I",
            "Silver IV",
            "Silver III",
            "Silver II",
            "Silver I",
            "Gold IV",
            "Gold III",
            "Gold II",
            "Gold I",
            "Platinum IV",
            "Platinum III",
            "Platinum II",
            "Platinum I",
            "Diamond IV",
            "Diamond III",
            "Diamond II",
            "Diamond I",
            "Master",
            "Grandmaster",
            "Challenger"
          ],
          "summoner_spell": [
            "Teleport",
            "Exhaust",
            "Barrier",
            "Smite",
            "Flash",
            "Ignite",
            "Clarity",
            "Mark",
            "To the King!",
            "Ghost",
            "Heal",
            "Poro Toss",
            "Cleanse"
          ]
        },
        "minecraft": {
          "achievement": [
            "Acquire Hardware",
            "Adventuring Time",
            "Ahoy!",
            "Alternative Fuel",
            "Archer",
            "Artificial Selection",
            "Atlantis?",
            "Bake Bread",
            "Beam Me Up",
            "Bee our guest",
            "Benchmaking",
            "Body Guard",
            "Bullseye",
            "Buy Low, Sell High",
            "Camouflage",
            "Castaway",
            "Cheating Death",
            "Chestful of Cobblestone",
            "Cover me in debris",
            "Cow Tipper",
            "Delicious Fish",
            "Diamonds to you!",
            "DIAMONDS!",
            "Disenchanted",
            "Dispense With This",
            "Do a Barrel Roll!",
            "Dry Spell",
            "Echolocation",
            "Enchanter",
            "Feeling Ill",
            "Free Diver",
            "Freight Station",
            "Fruit on the Loom",
            "Getting an Upgrade",
            "Getting Wood",
            "Great View From Up Here",
            "Have a Shearful Day",
            "Hot Topic",
            "Hot tourist destination",
            "I am a Marine Biologist",
            "I've got a bad feeling about this",
            "Inception",
            "Into Fire",
            "Into the Nether",
            "Iron Belly",
            "Iron Man",
            "It's a Sign!",
            "Kill the Beast!",
            "Leader Of The Pack",
            "Let it Go!",
            "Librarian",
            "Lion Hunter",
            "Local Brewery",
            "Map Room",
            "Master Trader",
            "Me Gold!",
            "MOAR Tools",
            "Monster Hunter",
            "Moskstraumen",
            "On A Rail",
            "One Pickle, Two Pickle, Sea Pickle, Four",
            "Oooh, shiny!",
            "Organizational Wizard",
            "Overkill",
            "Overpowered",
            "Passing the Time",
            "Plethora of Cats",
            "Pork Chop",
            "Pot Planter",
            "Rabbit Season",
            "Rainbow Collection",
            "Renewable Energy",
            "Repopulation",
            "Return to Sender",
            "Saddle Up",
            "Sail the 7 Seas",
            "Sleep with the Fishes",
            "Smelt Everything!",
            "Sniper Duel",
            "So I Got That Going for Me",
            "Sound the Alarm!",
            "Stayin' Frosty",
            "Sticky Situation",
            "Super Fuel",
            "Super Sonic",
            "Taking Inventory",
            "Taste of Your Own Medicine",
            "The Beaconator",
            "The Beginning?",
            "The Beginning.",
            "The Deep End",
            "The End?",
            "The End.",
            "The End... Again...",
            "The Haggler",
            "The Lie",
            "Tie Dye Outfit",
            "Time for Stew",
            "Time to Farm!",
            "Time to Mine!",
            "Time to Strike!",
            "Top of the World",
            "Total Beelocation",
            "Trampoline",
            "Treasure Hunter",
            "We're being attacked!",
            "When Pigs Fly",
            "Where Have You Been?",
            "You Need a Mint",
            "Zombie Doctor",
            "Zoologist"
          ],
          "biome": [
            "Badlands",
            "Badlands Plateau",
            "Bamboo Jungle",
            "Bamboo Jungle Hills",
            "Basalt Deltas",
            "Beach",
            "Birch Forest",
            "Birch Forest Hills",
            "Cold Ocean",
            "Crimson Forest",
            "Dark Forest",
            "Dark Forest Hills",
            "Deep Cold Ocean",
            "Deep Frozen Ocean",
            "Deep Lukewarm Ocean",
            "Deep Ocean",
            "Deep Warm Ocean",
            "Desert",
            "Desert Hills",
            "Desert Lakes",
            "End Barrens",
            "End Highlands",
            "End Midlands",
            "Eroded Badlands",
            "Flower Forest",
            "Forest",
            "Frozen Ocean",
            "Frozen River",
            "Giant Spruce Taiga",
            "Giant Spruce Taiga Hills",
            "Giant Tree Taiga",
            "Giant Tree Taiga Hills",
            "Gravelly Mountains",
            "Gravelly Mountains+",
            "Ice Spikes",
            "Jungle",
            "Jungle Edge",
            "Jungle Hills",
            "Lukewarm Ocean",
            "Modified Badlands Plateau",
            "Modified Jungle",
            "Modified Jungle Edge",
            "Modified Wooded Badlands Plateau",
            "Mountain Edge",
            "Mountains",
            "Mushroom Field Shore",
            "Mushroom Fields",
            "Nether Wastes",
            "Ocean",
            "Plains",
            "River",
            "Savanna",
            "Savanna Plateau",
            "Shattered Savanna",
            "Shattered Savanna Plateau",
            "Small End Islands",
            "Snowy Beach",
            "Snowy Mountains",
            "Snowy Taiga",
            "Snowy Taiga Hills",
            "Snowy Taiga Mountains",
            "Snowy Tundra",
            "Soul Sand Valley",
            "Stone Shore",
            "Sunflower Plains",
            "Swamp",
            "Swamp Hills",
            "Taiga",
            "Taiga Hills",
            "Taiga Mountains",
            "Tall Birch Forest",
            "Tall Birch Hills",
            "The End",
            "The Voi",
            "Warm Ocean",
            "Warped Forest",
            "Wooded Badlands Plateau",
            "Wooded Hills",
            "Wooded Mountains"
          ],
          "blocks": [
            "Stone",
            "Granite",
            "Polished Granite",
            "Diorite",
            "Polished Diorite",
            "Andesite",
            "Polished Andesite",
            "Grass",
            "Dirt",
            "Coarse Dirt",
            "Podzol",
            "Cobblestone",
            "Oak Wood Plank",
            "Spruce Wood Plank",
            "Birch Wood Plank",
            "Jungle Wood Plank",
            "Acacia Wood Plank",
            "Dark Oak Wood Plank",
            "Oak Sapling",
            "Spruce Sapling",
            "Birch Sapling",
            "Jungle Sapling",
            "Acacia Sapling",
            "Dark Oak Sapling",
            "Bedrock",
            "Flowing Water",
            "Still Water",
            "Flowing Lava",
            "Still Lava",
            "Sand",
            "Red Sand",
            "Gravel",
            "Gold Ore",
            "Iron Ore",
            "Coal Ore",
            "Oak Wood",
            "Spruce Wood",
            "Birch Wood",
            "Jungle Wood",
            "Oak Leaves",
            "Spruce Leaves",
            "Birch Leaves",
            "Jungle Leaves",
            "Sponge",
            "Wet Sponge",
            "Glass",
            "Lapis Lazuli Ore",
            "Lapis Lazuli Block",
            "Dispenser",
            "Sandstone",
            "Chiseled Sandstone",
            "Smooth Sandstone",
            "Note Block",
            "Bed",
            "Powered Rail",
            "Detector Rail",
            "Sticky Piston",
            "Cobweb",
            "Dead Shrub",
            "Grass",
            "Fern",
            "Dead Bush",
            "Piston",
            "Piston Head",
            "White Wool",
            "Orange Wool",
            "Magenta Wool",
            "Light Blue Wool",
            "Yellow Wool",
            "Lime Wool",
            "Pink Wool",
            "Gray Wool",
            "Light Gray Wool",
            "Cyan Wool",
            "Purple Wool",
            "Blue Wool",
            "Brown Wool",
            "Green Wool",
            "Red Wool",
            "Black Wool",
            "Dandelion",
            "Poppy",
            "Blue Orchid",
            "Allium",
            "Azure Bluet",
            "Red Tulip",
            "Orange Tulip",
            "White Tulip",
            "Pink Tulip",
            "Oxeye Daisy",
            "Brown Mushroom",
            "Red Mushroom",
            "Gold Block",
            "Iron Block",
            "Double Stone Slab",
            "Double Sandstone Slab",
            "Double Wooden Slab",
            "Double Cobblestone Slab",
            "Double Brick Slab",
            "Double Stone Brick Slab",
            "Double Nether Brick Slab",
            "Double Quartz Slab",
            "Stone Slab",
            "Sandstone Slab",
            "Wooden Slab",
            "Cobblestone Slab",
            "Brick Slab",
            "Stone Brick Slab",
            "Nether Brick Slab",
            "Quartz Slab",
            "Bricks",
            "TNT",
            "Bookshelf",
            "Moss Stone",
            "Obsidian",
            "Torch",
            "Fire",
            "Monster Spawner",
            "Oak Wood Stairs",
            "Chest",
            "Redstone Wire",
            "Diamond Ore",
            "Diamond Block",
            "Crafting Table",
            "Wheat Crops",
            "Farmland",
            "Furnace",
            "Burning Furnace",
            "Standing Sign Block",
            "Oak Door Block",
            "Ladder",
            "Rail",
            "Cobblestone Stairs",
            "Wall-mounted Sign Block",
            "Lever",
            "Stone Pressure Plate",
            "Iron Door Block",
            "Wooden Pressure Plate",
            "Redstone Ore",
            "Glowing Redstone Ore",
            "Stone Button",
            "Snow",
            "Ice",
            "Snow Block",
            "Cactus",
            "Clay",
            "Sugar Canes",
            "Jukebox",
            "Oak Fence",
            "Pumpkin",
            "Netherrack",
            "Soul Sand",
            "Glowstone",
            "Nether Portal",
            "Jack o'Lantern",
            "Cake Block",
            "Redstone Repeater Block off)",
            "Redstone Repeater Block on)",
            "White Stained Glass",
            "Orange Stained Glass",
            "Magenta Stained Glass",
            "Light Blue Stained Glass",
            "Yellow Stained Glass",
            "Lime Stained Glass",
            "Pink Stained Glass",
            "Gray Stained Glass",
            "Light Gray Stained Glass",
            "Cyan Stained Glass",
            "Purple Stained Glass",
            "Blue Stained Glass",
            "Brown Stained Glass",
            "Green Stained Glass",
            "Red Stained Glass",
            "Black Stained Glass",
            "Wooden Trapdoor",
            "Stone Monster Egg",
            "Cobblestone Monster Egg",
            "Stone Brick Monster Egg",
            "Mossy Stone Brick Monster Egg",
            "Cracked Stone Brick Monster Egg",
            "Chiseled Stone Brick Monster Egg",
            "Stone Bricks",
            "Mossy Stone Bricks",
            "Cracked Stone Bricks",
            "Chiseled Stone Bricks",
            "Brown Mushroom Block",
            "Red Mushroom Block",
            "Iron Bars",
            "Glass Pane",
            "Melon Block",
            "Pumpkin Stem",
            "Melon Stem",
            "Vines",
            "Oak Fence Gate",
            "Brick Stairs",
            "Stone Brick Stairs",
            "Mycelium",
            "Lily Pad",
            "Nether Brick",
            "Nether Brick Fence"
          ],
          "enchantment": [
            "Aqua Affinity",
            "Bane of Arthropods",
            "Blast Protection",
            "Channeling",
            "Cleaving",
            "Curse of Binding",
            "Curse of Vanishing",
            "Depth Strider",
            "Efficiency",
            "Feather Falling",
            "Fire Aspect",
            "Fire Protection",
            "Flame",
            "Fortune",
            "Frost Walker",
            "Impaling",
            "Infinity",
            "Knockback",
            "Looting",
            "Loyalty",
            "Luck of the Sea",
            "Lure",
            "Mending",
            "Multishot",
            "Piercing",
            "Power",
            "Projectile Protection",
            "Protection",
            "Punch",
            "Quick Charge",
            "Respiration",
            "Riptide",
            "Sharpness",
            "Silk Touch",
            "Smite",
            "Soul Speed",
            "Sweeping Edge",
            "Thorns",
            "Unbreaking"
          ],
          "game_mode": [
            "Adventure",
            "Creative",
            "Demo",
            "Hardcore",
            "Spectator",
            "Survival"
          ],
          "items": [
            "Iron Shovel",
            "Iron Pickaxe",
            "Iron Axe",
            "Flint and Steel",
            "Apple",
            "Bow",
            "Arrow",
            "Coal",
            "Charcoal",
            "Diamond",
            "Iron Ingot",
            "Gold Ingot",
            "Iron Sword",
            "Wooden Sword",
            "Wooden Shovel",
            "Wooden Pickaxe",
            "Wooden Axe",
            "Stone Sword",
            "Stone Shovel",
            "Stone Pickaxe",
            "Stone Axe",
            "Diamond Sword",
            "Diamond Shovel",
            "Diamond Pickaxe",
            "Diamond Axe",
            "Stick",
            "Bowl",
            "Mushroom Stew",
            "Golden Sword",
            "Golden Shovel",
            "Golden Pickaxe",
            "Golden Axe",
            "String",
            "Feather",
            "Gunpowder",
            "Wooden Hoe",
            "Stone Hoe",
            "Iron Hoe",
            "Diamond Hoe",
            "Golden Hoe",
            "Wheat Seeds",
            "Wheat",
            "Bread",
            "Leather Helmet",
            "Leather Tunic",
            "Leather Pants",
            "Leather Boots",
            "Chainmail Helmet",
            "Chainmail Chestplate",
            "Chainmail Leggings",
            "Chainmail Boots",
            "Iron Helmet",
            "Iron Chestplate",
            "Iron Leggings",
            "Iron Boots",
            "Diamond Helmet",
            "Diamond Chestplate",
            "Diamond Leggings",
            "Diamond Boots",
            "Golden Helmet",
            "Golden Chestplate",
            "Golden Leggings",
            "Golden Boots",
            "Flint",
            "Raw Porkchop",
            "Cooked Porkchop",
            "Painting",
            "Golden Apple",
            "Enchanted Golden Apple",
            "Sign",
            "Oak Door",
            "Bucket",
            "Water Bucket",
            "Lava Bucket",
            "Minecart",
            "Saddle",
            "Iron Door",
            "Redstone",
            "Snowball",
            "Oak Boat",
            "Leather",
            "Milk Bucket",
            "Brick",
            "Clay",
            "Sugar Canes",
            "Paper",
            "Book",
            "Slimeball",
            "Minecart with Chest",
            "Minecart with Furnace",
            "Egg",
            "Compass",
            "Fishing Rod",
            "Clock",
            "Glowstone Dust",
            "Raw Fish",
            "Raw Salmon",
            "Clownfish",
            "Pufferfish",
            "Cooked Fish",
            "Cooked Salmon",
            "Ink Sack",
            "Rose Red",
            "Cactus Green",
            "Coco Beans",
            "Lapis Lazuli",
            "Purple Dye",
            "Cyan Dye",
            "Light Gray Dye",
            "Gray Dye",
            "Pink Dye",
            "Lime Dye",
            "Dandelion Yellow",
            "Light Blue Dye",
            "Magenta Dye",
            "Orange Dye",
            "Bone Meal",
            "Bone",
            "Sugar"
          ],
          "mobs": [
            "Sheep",
            "Cow",
            "Fox",
            "Bat",
            "Chicken",
            "Cod",
            "Ocelot",
            "Pig",
            "Rabbit",
            "Salmon",
            "Mooshroom",
            "Squid",
            "Tropical fish",
            "Turtle",
            "Villager",
            "Wandering trader",
            "Pufferfish",
            "Donkey",
            "Horse",
            "Cat",
            "Parrot",
            "Mule",
            "Skeleton horse",
            "Dolphin",
            "Polar bear",
            "Trader llama",
            "Llama",
            "Panda",
            "Wolf",
            "Bee",
            "Iron golem",
            "Spider",
            "Cave Spider",
            "Enderman",
            "Zombie Pigman",
            "Evoker",
            "Vindicator",
            "Pillager",
            "Ravager",
            "Vex",
            "Chicken Jockey",
            "Endermite",
            "Guardian",
            "Elder Guardian",
            "Shulker",
            "Skeleton Horseman",
            "Husk",
            "Stray",
            "Phantom",
            "Blaze",
            "Creeper",
            "Ghast",
            "Magma Cube",
            "Silverfish",
            "Skeleton",
            "Slime",
            "Spider Jockey",
            "Zombie",
            "Zombie Villager",
            "Drowned",
            "Wither Skeleton",
            "Witch",
            "Hoglin",
            "Piglin"
          ],
          "status_effect": [
            "Absorption",
            "Bad Luck",
            "Bad Omen",
            "Blindness",
            "Conduit Power",
            "Dolphin's Grace",
            "Fatal Poison",
            "Fire Resistance",
            "Glowing",
            "Haste",
            "Health Boost",
            "Hero of the Village",
            "Hunger",
            "Instant Damage",
            "Instant Health",
            "Invisibility",
            "Jump Boost",
            "Levitation",
            "Luck",
            "Mining Fatigue",
            "Nausea",
            "Night Vision",
            "Poison",
            "Regeneration",
            "Resistance",
            "Saturation",
            "Slow Falling",
            "Slowness",
            "Speed",
            "Strength",
            "Water Breathing",
            "Weakness",
            "Wither"
          ]
        },
        "myst": {
          "ages": [
            "Channelwood",
            "Earth",
            "Mechanical",
            "Myst Stoneship",
            "Rime",
            "Selenitic",
            "Age 233",
            "Riven",
            "Tay",
            "Amateria",
            "Edanna",
            "J'nanin",
            "Narayan",
            "Voltanic",
            "Haven",
            "Serenia",
            "Spire",
            "Ahnonay",
            "Eder Delin",
            "Eder Gira",
            "Eder Kemo",
            "Eder Tsogal",
            "Er'cana",
            "Gahreesen",
            "Jalak Dador",
            "Kadish Tolesa",
            "Minkata",
            "Nexus",
            "Pod Age",
            "Relto",
            "Teledahn",
            "Direbo",
            "Laki'ahn",
            "Noloben",
            "Tahgira",
            "Todelmer",
            "Age 37",
            "Averone",
            "Chroma'agana",
            "Gemedet",
            "Inception",
            "Ko'ah",
            "Terahnee",
            "Torus Age"
          ],
          "characters": [
            "Achenar",
            "Atrius",
            "Atrus",
            "Catherine",
            "Esher",
            "Gehn",
            "Saavedro",
            "Sirrus",
            "The Stranger",
            "Ti'ana",
            "Yeesha"
          ],
          "creatures": [
            "bahro",
            "karnaks",
            "Mangree",
            "scarab beetles",
            "squee",
            "sunner",
            "wahrks",
            "ytrams",
            "Zeftyr"
          ],
          "games": [
            "Myst III: Exile",
            "Myst IV: Revelation",
            "Myst V: End of Ages",
            "Riven: The Sequel to Myst",
            "Uru: Ages Beyond Myst",
            "Myst"
          ],
          "quotes": [
            "The ending has not yet been written.",
            "I realized, the moment I fell into the fissure, that the Book would not be destroyed as I had planned.",
            "Try moving the slider.",
            "Remember the tower rotation.",
            "Who the devil are you?",
            "One thing I know about linking books is that the doors they open don't close behind you.",
            "Find the blue pages.",
            "Bring me blue pages.",
            "Find the red pages.",
            "Bring me the red pages.",
            "Atrus? Is that you? Come to rescue your Book so soon? Not yet, old friend... not yet.",
            "Atrus... what do you see?"
          ]
        },
        "overwatch": {
          "heroes": [
            "Ana",
            "Ashe",
            "Baptiste",
            "Bastion",
            "Brigitte",
            "Cassidy",
            "D.va",
            "Doomfist",
            "Genji",
            "Hanzo",
            "Junkrat",
            "Lucio",
            "Mei",
            "Mercy",
            "Moira",
            "Orisa",
            "Pharah",
            "Reaper",
            "Reinhardt",
            "Roadhog",
            "Sigma",
            "Soldier 76",
            "Sombra",
            "Symmetra",
            "Torbjorn",
            "Tracer",
            "Widowmaker",
            "Winston",
            "Wrecking Ball",
            "Zarya",
            "Zenyatta"
          ],
          "locations": [
            "Adlersbrunn",
            "Ayutthaya",
            "Black Forest",
            "Blizzard World",
            "Busan",
            "Busan Stadium",
            "Castillo",
            "Château Guillard",
            "Dorado",
            "Ecopoint: Antarctica",
            "Eichenwalde",
            "Hanamura",
            "Estádio das Rãs",
            "Hanamura",
            "Havana",
            "Hollywood",
            "Horizon Lunar Colony",
            "Ilios",
            "Junkertown",
            "King's Row",
            "Lijiang Tower",
            "Necropolis",
            "Nepal",
            "Numbani",
            "Oasis",
            "Paris",
            "Petra",
            "Rialto",
            "Route 66",
            "Temple of Anubis",
            "Volskaya Industries",
            "Watchpoint: Gibraltar"
          ],
          "quotes": [
            "Get back in the fight",
            "I have you covered",
            "I have your back",
            "Take your medicine",
            "Watching your back",
            "Go to sleep",
            "Sleep",
            "(Arabic) Sleep (Male)",
            "(Arabic) Sleep (Female)",
            "Lights out",
            "Oh, you look tired",
            "Feeling sleepy",
            "Bedtime, habibti",
            "I think justice could use a little nap",
            "This will help",
            "(Arabic) This will help",
            "Walk it off",
            "This will only hurt for a minute",
            "Heal up",
            "This is going to hurt",
            "The pain is coming",
            "(Arabic) Show them your strength!",
            "(Arabic) Show them your strength! (Female)",
            "Nano Boost administered",
            "Never stop fighting for what you believe in",
            "Stick to the plan, and if you get in trouble...",
            "Look after yourselves out there...",
            "Lissa fi nas lazem ahmehom",
            "(Arabic) Repetition teaches the smart",
            "Old soldiers are hard to kill",
            "This is much better than a cabana on the beach",
            "Patched up",
            "My shots find their mark",
            "Correct choice",
            "You made the right decision",
            "Thank you, Angela",
            "Ana checking in",
            "Sniper, keep moving",
            "Enemy in my sights",
            "Enemy contact",
            "Enemy turret sighted",
            "Locate their teleporter",
            "They have a teleporter. Find and destroy it",
            "Enemy teleporter at my location",
            "I found the shield generator",
            "Behind you",
            "Watch your back!",
            "Locking down the objective",
            "Someone get that payload moving",
            "You need adult supervision",
            "Who taught you to fight like that",
            "Enemy down",
            "Back off",
            "Experience always wins in the end",
            "Learn from the pain (Arabic)",
            "Mother knows best",
            "Settle down old man",
            "Speed isnt everything",
            "One shot, one kill",
            "Someday Reinhardt, but not today",
            "Enemy turret destroyed",
            "Enemy teleporter destroyed",
            "Hands off",
            "Fareeha! My daughter!",
            "Reinhardt!",
            "Jack, I was supposed to protect you",
            "Hello",
            "(Arabic) Hello",
            "Azayak",
            "Hello there",
            "Thanks",
            "(Arabic) I am thankful",
            "(Arabic) Thanks",
            "Understood",
            "Acknowledged",
            "I need healing",
            "Need healing",
            "Group up at my position",
            "Group up with me",
            "Rendez-vous at my position",
            "My ultimate is charging",
            "Nano boost is charging",
            "Nano boost is ready to deploy",
            "My ultimate is ready",
            "Justice delivered",
            "Children, behave",
            "Everyone dies",
            "Go on, I can wait",
            "It takes a woman to know it",
            "Mother knows best",
            "No scope needed",
            "Need someone to tuck you in",
            "What are you thinking",
            "Witness me",
            "You know nothing",
            "Learn from the pain",
            "This is much better than retirement",
            "Are you scared",
            "More lost than the moon in winter",
            "I make my own luck",
            "Damn",
            "The Ghost watches",
            "Follow me, if you want to live",
            "Shh. The adults are talking",
            "You need to learn to relax",
            "Heh, you always were a charmer",
            "Wanting a better life for you is all I ever...",
            "What happened to you, Gabriel",
            "You never gave me much choice",
            "Right. Except for the part where you became a...",
            "Reinhardt, I must say you are looking quite...",
            "You of all people are going to ask me that",
            "Seems like neither of us like being dead very much",
            "That one time",
            "Well, I had to come back. I was worried...",
            "Gerard was a fool to love someone like you",
            "It feels good to be home",
            "Captain Amari, reporting for duty",
            "Fire in the hole!",
            "Here it comes!",
            "Take a step back!",
            "Get outta here!",
            "Back off!",
            "Get in there, B.O.B",
            "My business, my rules.ogg",
            "Nice to spend some time in a clubhouse.ogg",
            "Not my idea of a good life.",
            "Follow my lead",
            "Get in the saddle and lets ride",
            "Time to change things up",
            "That was not in the plan",
            "Nothing wrong with a little self improvement",
            "Patched up",
            "Much better",
            "Let me handle it",
            "I get the idea",
            "Just point me in the right direction",
            "I am feeling UNSTOPPABLE!",
            "Oh, come on!",
            "Damn!",
            "Hallelujah",
            "Woo. I owe you one",
            "Ashe here",
            "Enemy sniper! Get ya head down!",
            "Enemy sniper! Keep your eyes open.",
            "Watch out for that sniper!",
            "Spotted them",
            "Eyes on the bad guys",
            "Enemy turret up ahead!",
            "We need to take out that turret!",
            "You need to learn the rules",
            "Right on schedule",
            "You have to watch out for the one percent",
            "Courtesy of the Deadlock Gang",
            "Poser",
            "I stick up for my crew",
            "See ya, space cowboy",
            "Squid needs more seasoning",
            "Woo! that was fun!",
            "Wanna try again",
            "Gets the job done",
            "Better safe than sorry",
            "See ya later",
            "Outta my space",
            "You just went boom!",
            "Woohoo!",
            "Now that gets the blood pumping!",
            "Leave this to me",
            "Do I have to do everything myself",
            "You can all just take it easy!",
            "You picked the wrong fight",
            "You should join my crew",
            "Hey",
            "Hello",
            "Thanks",
            "Thank you",
            "Understood",
            "I got it",
            "Stop the payload",
            "Get over here",
            "Everybody come over here",
            "My ultimate is almost ready",
            "My ultimate is ready",
            "Get ready for B.O.B",
            "We have an understanding",
            "Burn it all down",
            "How do you even live",
            "I run this show",
            "Just taking out the trash",
            "Need me to repeat myself",
            "This is a stick up",
            "Try and keep it together",
            "Watch your language",
            "Girl who has everything",
            "No one likes a squealer",
            "Ready for the fireworks",
            "You that sound like a bad thing",
            "Brave of you to show your face around here, Cole",
            "On the dartboard",
            "Too competent",
            "Ultimate - Light Em Up",
            "Ultimate - Vide Bal Sou Yo",
            "No wasted effort",
            "I call that a professional courtesy",
            "I think we got off on the wrong foot",
            "Have you considered a different line of work",
            "Well, you tried your best",
            "That was satisfying",
            "Was you or me, brother",
            "Was you or me, sister",
            "Felt good when I woke up in the morning",
            "Ultimate - Woo Woo Woo Whee Woo Whee",
            "15227",
            "4543",
            "Time Running Out Attack - Wooooooo Woo Dee Doo Woo",
            "Boo doo boo doo",
            "15303",
            "Doo-woo",
            "Beeple",
            "Boo boo doo de doo",
            "Bweeeeeeeeeee",
            "Chirr chirr chirr",
            "Dah-dah weeeee",
            "Dun dun boop boop",
            "Dweet dweet dweet",
            "Hee hoo hoo",
            "Sh-sh-sh dwee!",
            "Zwee",
            "Dwee wee woh",
            "Family Vacation",
            "APM jom ollyo bolkka",
            "Defense Matrix activated",
            "Get through this",
            "Time to raise my APM",
            "Boosters engaged",
            "Bunny hop",
            "Buseuteo on",
            "Taking off",
            "Nal ra gan da",
            "Nerf this!",
            "Activating Self Destruct Sequence",
            "All systems checked out",
            "MEKA activated",
            "Suiting up",
            "Game on",
            "Bailing out",
            "BRB",
            "Ejecting",
            "I play to win!",
            "Gameface on",
            "Think you can keep up with me",
            "MEKA leads the way!",
            "Ready, player 1",
            "D.Va reengaging!",
            "Jjajeungna",
            "Igeon Sagiya",
            "Press start to continue",
            "Extra life!",
            "Healed up",
            "Fully operational",
            "Im on fire",
            "Weapon Systems Overloaded",
            "Weapons Optimised",
            "Damn It",
            "Ding",
            "Thanks For The Love",
            "Thanks For Your Support",
            "Save That For The Hall Of Fame",
            "Gasp",
            "Aww, No fair!",
            "D.Va online",
            "Enemy Spotted",
            "Enemy turret ahead",
            "Hey! They have a teleporter!",
            "Enemy teleporter located",
            "Behind you!",
            "You Better Get Out Of The Way",
            "I Am Unstoppable",
            "Looks Like Another Victory, Just A Little Longer",
            "Enemies Taking The Point, Time To Show My Skills",
            "Check Me Out, Securing The Point",
            "This Objective Has My Name Written All Over It",
            "Enemy down",
            "Target eliminated",
            "Are you even trying",
            "I thought you were going to be a challenge",
            "Get owned",
            "One For My Highlight Reel",
            "MVP D.Va",
            "Assa",
            "I still love you",
            "Shut down",
            "Kill streak",
            "High score for sure",
            "Enemy turret destroyed",
            "Ouch",
            "Pow",
            "Nice shot",
            "Revenge is sweet",
            "Hi",
            "Hiya!",
            "Annyeong",
            "Thanks",
            "Thank you",
            "Gam sa",
            "Got it",
            "Okay",
            "Understood",
            "Roger",
            "Attack the objective",
            "Defend the objective",
            "Move the payload",
            "Stop the payload",
            "Need healing",
            "I need healing",
            "I need armor",
            "I need shields",
            "Group up",
            "Group up here",
            "Group up with me!",
            "Join me!",
            "Ultimate charging",
            "Ultimate almost ready",
            "Ultimate ready",
            "Love D.Va",
            "AFK",
            "Aw yeah",
            "D.Va 1 bad guys 0",
            "GG",
            "I play to win korean",
            "Easy mode",
            "Lol",
            "No hacks required",
            "Winky face",
            "Haepi hallowin",
            "Its me Someone must be hacking",
            "I hope we dont get banned",
            "Only if I can get yours too! I love your new album!",
            "16-bit hero",
            "Of course",
            "Hey! Hands Off",
            "If you wanna give me some upgrades",
            "Who are you calling a child",
            "A giant gorilla Just like in those old...",
            "The Destruction Caused By The Omnics Here, It Reminds Me Of Home",
            "Blizzard games",
            "This is my kind of city",
            "All systems buzzing!",
            "Bzzzzzz!",
            "I am not the Easter Bunny",
            "Rising Uppercut",
            "Rising fist",
            "Meteor Strike!",
            "Incoming!",
            "Only through conflict do we evolve",
            "Once the mission starts, no more messing around",
            "My work is not done",
            "The battle goes on",
            "Defeat makes me stronger",
            "Lose the battle, win the war",
            "Much better",
            "Just what I needed",
            "I am on fire!",
            "Move, or get run over",
            "As though I needed the help",
            "I like how that feels",
            "This will be over quickly",
            "Damn!",
            "Is that all (Voted Epic)",
            "You know my name",
            "What did you expect",
            "Doomfist here",
            "Sniper, keep your head down",
            "I found the enemy",
            "Spotted a turret",
            "Enemy turret ahead!",
            "Behind you",
            "Take cover",
            "I am unstoppable!",
            "Our enemies defeat is on hand, do not let up",
            "Time, our enemies are out of time",
            "Time is running out, we can not fail!",
            "Get them off our objective, now!",
            "I am securing the objective",
            "Everyone, get on the objective!",
            "Why is the payload stopped",
            "I am personally seeing to the payload",
            "Moving the payload and nothing is going to stop it",
            "Winners stay on the payload",
            "Stop the payload!",
            "Stop the payload, now!",
            "History will forget you",
            "Rethinking your life decisions",
            "Stay out of my way",
            "Is that all (Final Blow)",
            "Come at the king, you better not miss",
            "Not strong enough",
            "Does anyone else want to try me",
            "Enemy turret destroyed",
            "Well done!",
            "Less work for me!",
            "Hello!",
            "Hello there",
            "Hey there",
            "Thank you",
            "Thanks",
            "I heard you",
            "Understood",
            "I need healing!",
            "Heal me!",
            "Group up with me",
            "On me!",
            "My ultimate is charging",
            "Meteor Strike is charging",
            "Meteor Strike is almost ready!",
            "My ultimate is almost ready!",
            "Meteor Strike ready to be unleashed",
            "Ready to meteor drop!",
            "My ultimate is ready",
            "Meteor Drop is ready. Get in position!",
            "Meteor Strike is ready. Get in position!",
            "Try me",
            "Go and sit down",
            "K.O.",
            "One punch is all I need",
            "Spare me the commentary",
            "Talk to the fist",
            "Combo breaker!",
            "You Must be Joking",
            "I hope that the girl gave you more than a new coat of paint",
            "Have you ever been hit by a giant, genetically engineered gorilla I could arrange it for you...",
            "Human strength will only get you so far",
            "Omnics will not be kept down forever. The ashes of the crisis still smolder",
            "This city is a powder keg that could ignite the world. And Talon is the flame",
            "I think your flight is delayed",
            "The world changed after the crisis. It is due for another test",
            "I am ready",
            "Try Me",
            "Hajime",
            "Sono teido ka",
            "Honki o misete miro",
            "The dragon becomes me!",
            "Flow Like Water",
            "again",
            "I return to the fight",
            "I will not falter",
            "I will not waste this chance",
            "Let us hope for a different outcome",
            "Tatakai wa owaran",
            "Much Better",
            "I am healed",
            "I am repaired",
            "My warrior spirit burns",
            "The advantage is mine",
            "wa ga kokoro ha ryuu no kokoro",
            "Strength flows through me",
            "Chikara ga minagitte kuru",
            "I am unstoppable",
            "kuso!",
            "It was nothing",
            "Our enemies return",
            "Genji here",
            "Genji is with you",
            "Sniper",
            "Enemy turret",
            "Enemy teleporter detected",
            "heh i found the teleporter",
            "Our enemies have deployed a shield generator",
            "Behind you",
            "Watch yourself",
            "Victory draws near",
            "Defend as one",
            "The battle draws to its conclusion",
            "Time is against us",
            "Our point is under attack guests",
            "We are losing the objective",
            "Our enemies have the upper",
            "I am taking the objective",
            "The objective is mine",
            "We must press our",
            "The payload is stopped",
            "Push the payload",
            "Push forward",
            "The payload moves",
            "Keep the payload in motion",
            "Stop the payload",
            "The payload is moving",
            "We need to stop the payload",
            "I Learned That From My Brother",
            "Like cutting through silk",
            "Know yourself in the face of death",
            "Think upon your actions",
            "An excellent fight",
            "Kono teido ka",
            "Yoshi!",
            "Kamai Tachi",
            "Kaze Yo",
            "Oitsukeru kana",
            "I am victorious this time",
            "Mock death at your own peril",
            "My aim is unerring",
            "Enemy turret destroyed",
            "Enemy teleporter destroyed",
            "The enemy teleporter",
            "Angela!",
            "I wiill avenge you",
            "Hello",
            "Yo",
            "Greetings",
            "Thank you",
            "I understand",
            "Very well",
            "Understood",
            "I need healing",
            "I Require Healing",
            "Group Up",
            "Group Up Here",
            "Join me",
            "My ultimate is charging",
            "My ultimate is almost ready",
            "My ult is ready",
            "The dragon and I are one",
            "A steady blade balances the soul",
            "Kuso",
            "Kakugo",
            "Measure twice, cut once",
            "Mada mada!",
            "Hah! Simple",
            "Yoshi!",
            "You are only human",
            "I was hoping for a challenge",
            "My halloween costume, cyborg ninja",
            "Happy Halloween.oga",
            "Merry Christmas",
            "To know yourself, is to be at peace",
            "Kaedama",
            "Life and death balance on the edge of my blade",
            "You Seem Nice",
            "An elegant weapon",
            "It is not too late to change your course, brother",
            "So this is what has become of you. A pity",
            "That was your dream. Not mine",
            "We shall see, brother",
            "I am certain of it",
            "What would our father think",
            "I find the company more agreeable these days",
            "I am a different man now. I am whole",
            "I am at peace with who I was",
            "Our paths cross for now",
            "I always liked working with you",
            "The heart of a man still beats",
            "Does-the-suffering-of-the-omnics-here",
            "And you, master",
            "That was another life",
            "Fukushu",
            "I passed many an hour",
            "Even here I feel an outcast",
            "Fantastic Technique",
            "Break the limit",
            "Unbreakable Body",
            "Henshin",
            "Arigato gozaimashita",
            "Any chocolates brother",
            "Akemashite Omedetou Gozaimasu",
            "The winds of death are strong",
            "I still have much to learn",
            "Marked",
            "Marked by the dragon",
            "See that which is unseen",
            "Unleash the storm",
            "Strike like lightning",
            "Have a taste of this",
            "The storm breaks",
            "Swift as the wind",
            "The noose tightens",
            "My arrows find their marks",
            "Focusing",
            "Let the dragon consume you!",
            "The dragon is sated",
            "You have been judged",
            "The dragon consumes",
            "With every death, comes honor. With honor, redemption",
            "I grow tired of waiting",
            "If you sit by the river long enough",
            "It is time to act",
            "Try to keep up",
            "The dragon awakens",
            "My brother is dead",
            "Again",
            "A minor setback",
            "I am not deterred",
            "I will not be defeated so easily",
            "I must redeem myself",
            "I must reclaim my honor",
            "Start over at the beginning",
            "Never surrender",
            "Nothing ventured, nothing gained",
            "I am healed",
            "I am restored",
            "My warrior spirit burns",
            "The dragon rages within me",
            "The dragon stirs within me!",
            "My power grows stronger",
            "The Dragon Awakens",
            "You honor me",
            "Strive for perfection",
            "They have returned from death",
            "Hanzo at your service",
            "Sniper",
            "The enemy is here",
            "Enemy turret ahead",
            "They possess a teleporter",
            "Time is running out Attack",
            "We cannot lose Attack",
            "Time grows short",
            "Keep pushing forward",
            "They are taking the objective stop them",
            "Stop them now clear the point",
            "Get the payload moving",
            "We must move the payload",
            "We cannot stop now move the payload",
            "I have taken the payload",
            "I am moving the payload",
            "The payload is moving join me",
            "Stop the payload",
            "Haha perfect",
            "Hardly a challenge",
            "Is that the best you can do",
            "So predictable",
            "Never second best!",
            "Target practice",
            "Unworthy",
            "Hm, weakling",
            "You are nothing",
            "You will never amount to anything",
            "You do not want me for your enemy",
            "Just as when we were boys",
            "You were never my equal!",
            "So much death",
            "They fall before me",
            "Again! And Again!",
            "The dragon hungers",
            "An inspired perfomance",
            "Enemy turret destroyed",
            "Uncouth",
            "Pest",
            "Pfe",
            "You have some skill",
            "Hello",
            "I greet you",
            "Greetings",
            "Thank you",
            "You have my thanks",
            "Understood",
            "I understand",
            "Very well",
            "I need healing",
            "Need healing",
            "I need armor",
            "I need shields",
            "Group up",
            "Group up here",
            "Group up with me",
            "Join me",
            "My ultimate is charging",
            "My ultimate is almost ready",
            "My ultimate is ready",
            "I am ready to unleash the dragon",
            "Expect nothing less",
            "Flow like water",
            "From one thing know ten thousand things",
            "Hm",
            "I do what I must",
            "The outcome was never in doubt",
            "Never second best!",
            "Remember this moment",
            "Sake",
            "I choose you spirit dragon",
            "Step into the dojo",
            "Ignore all distractions",
            "You are already dead",
            "a gift for you",
            "You may call yourself my brother...",
            "you are mistaken brother",
            "You will never amount to anything",
            "Where did you hide your treasure",
            "Unsofisticated Taste",
            "I would wager on my bow against your rifle any day",
            "But at what cost",
            "We are nothing alike",
            "All of this was to be mine",
            "I will take back what is mine by birthright",
            "The master of the Shimada Clan has returned",
            "This is the home of the Shimada Clan. My home",
            "This was once my home. No longer",
            "My enemies fall like cherry blossoms",
            "such beauty is wasted",
            "The wolf stirs from his den",
            "The wolf marks his prey",
            "Lone wolf ultimate",
            "The wolf hunts for his prey",
            "The wolf is sated",
            "The wolf feasts",
            "The wolf awakens",
            "The wolf howls within me",
            "The wolf stirs within me",
            "I am ready to unleash the wolf",
            "I choose you, Spirit Wolf",
            "The wolf hungers",
            "Scatter",
            "Simple geometry",
            "Strike at the heart",
            "The art of deception",
            "My arrow finds its mark",
            "My aim is true",
            "Perfect",
            "Surprise!",
            "Here we go",
            "The hunter lays a trap for his prey",
            "giggles - 13015",
            "Dont move",
            "Hold Still",
            "Stepped in it",
            "Watch your step",
            "Fire in the hole!",
            "Ladies and gentlemen, start your engines",
            "come out and play",
            "i love my job",
            "Rest in pieces",
            "Hard to just sit around",
            "just taking five",
            "misfits and freaks",
            "Remember, Remember, What The Heck Was I Saying Again",
            "I Would Kill For Some Boba, Milk Tea, Half Sweet",
            "new years resolution",
            "Back for more",
            "Blow it up again1",
            "You wont get rid of me",
            "I love it when that happens",
            "Holy dooley..",
            "takes a lickin keeps on tickin",
            "All patched up",
            "much better",
            "Im on fire more than usual",
            "Piece of junk!",
            "Damn It",
            "My Genius Is Finally Recognized",
            "sniff brings a tear to my eye",
            "thank you thank you",
            "Looks Like They Were Just Playing Dead",
            "Junkrat primed and ready",
            "sniper",
            "enemy turret up ahead",
            "find the teleporter",
            "Found Their Teleporter, Time To Blow It Up",
            "point belongs to us ya dingus",
            "Mine, mine, mine. This is my point",
            "The Point Is Mine",
            "Whys the payload stopped",
            "Moving The Payload, Clear A Path",
            "we need to pump the brakes on the payload",
            "brings tears to me eyes",
            "everything is going up in flames",
            "hole in one",
            "stay outta the kitchen",
            "ya dipstick",
            "Back To The Scrapheap",
            "Why so serious",
            "humming",
            "Enemy Turret Just Blew Up",
            "enemy teleporter scrapped",
            "Hands off the merchandise!",
            "Out Of My Face You Drongo",
            "That Must Have Hurt",
            "I knew there was a reason",
            "i can always count on you mate",
            "Hey Im the only one who gets to kill the big lug",
            "Revenge is a dish best served flaming hot!",
            "Gday",
            "Gday cobber",
            "Cheers mate",
            "Ta",
            "Thanks, mate",
            "Gotcha",
            "Sure",
            "Okay",
            "I need healing",
            "Join up with me",
            "RIP-Tire Ready To Roll!",
            "Tick Tock, Tick Tock, Tick Tock",
            "Blow it up again2",
            "Anyone want some BBQ",
            "Brrring!",
            "Coming up explodey",
            "good morning",
            "Happy birthday",
            "Have a nice day",
            "Its the little things",
            "Kaboom!",
            "Shiny",
            "Smile!",
            "I Give It A Ten",
            "happy halloween",
            "merry christmas",
            "gong xi fa cai",
            "Get cold just looking at ya",
            "Thats cold",
            "You hook em",
            "Joke ol pigface",
            "Try not to get us killed out there",
            "cheers mate the cavalrys here",
            "Look at one of those bombs",
            "comic relief",
            "Me old tunnel",
            "party time",
            "Stole crown jewels",
            "this place makes me sick",
            "Bots into the light",
            "Be an Atheist",
            "this place is a bit posh for me",
            "you think theres something worth stealing",
            "fire usually would not be a good thing",
            "fire not good",
            "early bird gets the worm",
            "get ready for a shock",
            "Ladies and gentlemen he working on a century",
            "just look at this thing!",
            "finders keepers",
            "God save the king",
            "Be an Atheist",
            "Pardon me",
            "Easy",
            "Hold up now",
            "Excuse Me",
            "Now, hold on",
            "Whoa there",
            "Draw!",
            "Step right up",
            "Did someone call the undertaker",
            "Get it done",
            "Back In The Saddle Again",
            "Back Into The Mix",
            "All Patched Up",
            "Just What The Doctor Ordered",
            "Much better",
            "I Feel Like A Man Possessed",
            "Sniper, Keep Your Eyes Peeled",
            "Enemy Turret Here",
            "Enemy Teleporter Spotted",
            "Taking the point",
            "Payload Stopped",
            "Payload Secure, Move Out",
            "Bang",
            "Bullseye",
            "Dead to rights",
            "Gotcha",
            "Happy trails",
            "Never had a chance",
            "Never Much Liked You",
            "No payment required",
            "Too slow",
            "You need to work on that aim",
            "Thought I Saw A Ghost",
            "Enemy Turret Destroyed",
            "Enemy Teleporter Destroyed",
            "Nice One",
            "Remind Me To Stay Off Your Bad Side",
            "Just A Matter Of Time",
            "Hello",
            "Hey There",
            "Howdy",
            "Hey",
            "Achknowledged",
            "I Need A Doctor",
            "Form Up Here",
            "My Ultimate Is Ready, Saddle Up",
            "You Know What Time It Is",
            "Watch and learn",
            "After you",
            "Happens To The Best Of Us",
            "Reach for the sky",
            "Wanted Dead or alive",
            "You Done",
            "Boom goes the dynamite",
            "I hear you pumpkin",
            "Trick or Treat",
            "This calls for a celebration",
            "Hair of the dog",
            "How do you like me now",
            "D.Va, just tell me one thing whered",
            "Ice wall, coming up",
            "This will stop them",
            "Haha, watch this",
            "Blocking Them Off",
            "Yikes!",
            "Oh my gosh",
            "Anyone want a popsicle",
            "You got iced",
            "Our world is worth fighting for",
            "I have to get back in the fight",
            "Woah, That Was Going Great, Until The End",
            "Everyone is counting on me",
            "Wait For Me",
            "That could have gone better",
            "This fight is not over yet",
            "Healed up",
            "Much better",
            "Whoa! Look out. Here I come",
            "Grrr",
            "Thumbs up to that",
            "Thanks everyone",
            "Oh, it was nothing really",
            "Sometimes I surprise myself",
            "Stunned",
            "Mei checking in",
            "Sniper! Look out",
            "Enemies here",
            "Enemy turret ahead",
            "Hey, They Have A Teleporter, Help Me Find It",
            "Find The Teleporter",
            "Hey, I Found Their Teleporter",
            "Get to cover",
            "Behind you",
            "Everyone! Stay out of my way",
            "Nothing can stop me",
            "Nothing can stop Mei",
            "Come on everyone, just a little bit longer",
            "Our hard work will be for nothing",
            "Our point is under attack",
            "Setting Up On The Objective",
            "Push the payload",
            "Payload stopped, all hands on deck",
            "Hey! The payload stopped",
            "Moving the payload. Backup requested",
            "Is Nothing Personal",
            "I Can Take Care Of Myself",
            "Serves You Right",
            "You were asking for it",
            "Cold as ice!",
            "Hey! Be reasonable",
            "Ooh, sorry about that",
            "Oops, sorry",
            "Hey! Stay out of my way",
            "Enemy turret down",
            "Enemy teleporter down",
            "Shield generator destroyed",
            "Final Blow - You Were Asking For It",
            "Enemy team is down! Now is our chance",
            "Hi 1",
            "Hi 2",
            "Hiya",
            "Thank you!",
            "Thanks",
            "Understood",
            "Okay 2",
            "I Need Healing",
            "Need Health",
            "Group Up With Me",
            "Group Up",
            "Group Up Here",
            "Join Me",
            "My ultimate is ready!",
            "Hang In There",
            "A-Mei-Zing",
            "Hey, chill out!",
            "I Hope You Learned Your Lesson",
            "Okay 1",
            "Ouch, Are You Okay",
            "That Was Great",
            "Yay 1",
            "You have to let it go",
            "Overcome All Obstacles",
            "Scary",
            "I got you something",
            "I was only trying to help",
            "So mean... honestly",
            "Bastion, you would make the perfect research assistant",
            "Youre just no good bully",
            "Look somewhere else",
            "Hey, Cole, do you know what time it is",
            "I love your glasses, so cute!",
            "We should compare notes some time",
            "Zarya How can you even pick up all that weight",
            "I love it here in the mountains. I wish I could go climbing!",
            "I Think I Might Be A Little Overdressed For This Place",
            "Look at all the snow!",
            "Winston. I think one of these equations is wrong",
            "Mei on duty",
            "Happy holidays",
            "Home sweet home",
            "Do you think",
            "Ouch that stings",
            "The Struggle for martial superiority",
            "When faced with a setback, we must challenge our assumptions.",
            "We must all make sacrifices in the name of science.flac",
            "My power is overwhelming!",
            "Slowly they realize that failure is all that awaits them",
            "Our enemies believe that they can take our objective. They are mistaken",
            "The payload moves towards our desired outcome.flac",
            "That we should fail in stopping the payload has no reasonable explanation",
            "We must keep our enemies from further progress towards their goal",
            "Situational awareness could save your life-- I recommend it",
            "Perhaps, next time, you should not stand in the way of the orb",
            "Your contributions to the furtherance of science are to be commended",
            "My keen analytical mind detects a pattern forming",
            "Much more talkative now arent you Genji",
            "Your body seems to be adapting well",
            "Started any wars",
            "Look at this world Symmetra",
            "Your state of Chronal Uncertainty",
            "A dreamer",
            "We are all in the gutter, but some of us are looking at the stars",
            "The government here has such a medieval view towards omnics",
            "If only the world could see the wonders that science has built.flac",
            "This is now my home... as much as any other.flac",
            "Fortifying defenses",
            "Standing ground",
            "Holding position",
            "Establishing defense point",
            "Navigation systems to defense",
            "Engaging fortifications",
            "Defense mode activated",
            "Not budging",
            "Digging in",
            "Dont move",
            "Stop right there",
            "Not so fast",
            "Halt",
            "Youre not getting away",
            "Stop",
            "You are advised to move behind my barrier",
            "Barrier activated",
            "For your own safety, get behind the barrier",
            "Please move behind the barrier",
            "I recommend moving behind my barrier",
            "This will be your shield!",
            "Please move behind the barrier2",
            "Barrier status critical",
            "Caution. Barrier has taken heavy damage",
            "My barrier is failing. Recommend",
            "Warning barrier failing",
            "Barrier integrity compromised",
            "Barrier destroyed. Please move to safety",
            "Barrier destroyed.",
            "Cease your resistance!",
            "Team up for special attack",
            "Your safety is my primary concern",
            "For optimal chance",
            "Executing pre-combat",
            "I will simulate our",
            "I must rejoin my team",
            "I still have a job",
            "Rebooting",
            "Archiving combat data",
            "System restart init",
            "Analyzing previous combat",
            "I am not ready to be",
            "Installing Updates",
            "Updates installed",
            "System health stabilizing",
            "Systems restored",
            "Systems repaired",
            "System integrity restored",
            "Your aid is appreciated",
            "Thank you(healed)",
            "Exceeding expected combat values",
            "Weapon systems optimized",
            "Damage output increased",
            "Lethality level increased",
            "I feel unstoppable",
            "System output overloaded",
            "Thank you. But I still have",
            "I was only following my programming",
            "Running post-match diagnostics",
            "Performance analysis Epic!",
            "Performance analysis Legendary!",
            "Saving record of exceptional combat",
            "Enemies reviving. Prepare",
            "Was that the Iris",
            "Orisa online",
            "Alert! Sniper located.",
            "Sniper detected. Threat level",
            "Enemy detected straigth ahead",
            "Enemy detected to our rear",
            "Enemy dected on the left",
            "Enemy dected on the right",
            "Enemy detected above us",
            "Enemy detected below us",
            "Behind you",
            "enemy turrent located",
            "Priority task find the enemy tele",
            "Enemy teleporter located",
            "Enemy teleported destroyed",
            "Enemy shield generator located",
            "Enemy shield generator destroyed",
            "Current combat simulations",
            "Analysis of recent performance trends",
            "If we continue upon this trajectory",
            "We have no choice",
            "Mission window closing",
            "A repeat of our past performance",
            "We must improve or we",
            "The enemy is taking the objective",
            "Unauthoried personnel detected",
            "Intruders have breached",
            "Our objective is under attack",
            "Taking possession of the objective",
            "Taking control of the objective",
            "Securing the objective. Backup",
            "Initiating objective capture routine",
            "Payload stopped in a no-stop zone",
            "We must get the payload",
            "Payload has stalled",
            "Commandeering the payload",
            "I am moving with the payload",
            "Moving the payload",
            "I am escorting the payload",
            "The payload is moving. Reroute",
            "The payload must be halted",
            "We must capture and impound",
            "Enemy is moving the payload",
            "I have the flag. Heading",
            "I have taken the flag. Initiating",
            "We must ge our flag back",
            "Recover our flag",
            "We must secure our flag immediately",
            "The enemy has taken possession",
            "Flag capture protocol completed",
            "Enemy flag captured. New instructions",
            "We need to increase our flag security",
            "We must not let that happened again",
            "Enemy has lost possession of our",
            "Priority objective recover the flag",
            "Dropping the flag",
            "Relinquishing the flag",
            "I have sent our flag back to base",
            "Our flag is safe",
            "I told you to stop resisting",
            "Vital signs negative",
            "Threat neutralized",
            "Goodbye",
            "You were warned",
            "I am programmed to avoid",
            "For Numbani",
            "You are advised to cease",
            "Stay there. The authorities",
            "Saving record for future",
            "Are you in distress",
            "System operating at maximum",
            "Empathy module not responding",
            "Exceeding standard performance",
            "Enemy turret neutralized",
            "Fist bump!",
            "Stand back!",
            "Excuse me!",
            "Reinhardt, you are",
            "Reinhardt,I will",
            "Zarya, I wish to",
            "Now I can delete you",
            "Hello",
            "Greetings",
            "Thanks",
            "Thank you",
            "Affirmative2",
            "Understood",
            "Requesting healing",
            "Healing would be appreciated",
            "I need healing",
            "I believe we need a healer.",
            "Requesting shields",
            "Armor would be appreciated",
            "Requesting armor",
            "Rally at my position",
            "Group up with me",
            "Group up",
            "My ultimate is charging",
            "Supercharger powering up",
            "My ultimate is almost ready",
            "Supercharger is almost ready to be deployed",
            "My ultimate is ready",
            "Supercharger is ready to be deployed",
            "My ultimate is ready, come to",
            "My Supercharger is ready to be deployed",
            "Current outlook",
            "Do you need a hug",
            "Efi will not be happy about this",
            "Error 404. Sarcasm module not found",
            "Medical assistance has been requested",
            "Would you like my analysis of the situation",
            "No parking",
            "Shine your eyes",
            "That does not compute",
            "Who is ready to party",
            "Some functionality may still be in beta",
            "I have a bad feeling about this",
            "Are you satisfied with your protection",
            "Thank you for your compliance",
            "golden",
            "Be careful when crossing the street",
            "Thank you E54",
            "It is remarkable",
            "Scanning E54",
            "Doomfist, you will be brought",
            "My artificial intelligence makes",
            "Actually, Efi spent most of her",
            "I do not know about this Viskar",
            "Reinhardt I have allocated",
            "Reinhardt - What an odd compliment",
            "Reinhardt - Why is your shield",
            "My systems protected",
            "I consider Reinhardt to be",
            "Tracer, is it wrong",
            "Efi would be honored",
            "Zarya I have learned",
            "Tekharta Zenyatta",
            "Before Efi",
            "I will protect this city",
            "I wish Efi",
            "Catchphrase",
            "One electric sheep",
            "I must ask Efi",
            "System restarting",
            "Systems rebooted",
            "Virus detected",
            "Systems compromised",
            "On a scale",
            "I consider Reinhardt",
            "Clearing The Area",
            "Get Back!",
            "Move back",
            "Justice rains from above!",
            "Rocket Barrage incoming!",
            "Justice is done",
            "I will protect the innocent",
            "All Systems Checked Out, Ready For Combat Maneuvers",
            "System Check Initiated, Green Across The Board, And Ready For Action",
            "Back Into The Fray",
            "Back In Action",
            "I Will Not Fail Again",
            "My Team Needs Me",
            "Raptora Systems Online",
            "Back online",
            "Health Restored",
            "Much Better",
            "I Am On Fire",
            "Operating at maximum efficiency",
            "I Will Not Waste This Opportunity",
            "I Am Empowered",
            "Damn",
            "Clear Skies Ahead",
            "After Action Report, Unstoppable",
            "I Served With Distinction",
            "Pharah, reporting",
            "Sniper detected",
            "Contact",
            "Turret Detected",
            "Locate The Teleporter",
            "They Have A Teleporter",
            "Friendly Down",
            "Systems At Max 1",
            "I am unstoppable",
            "Time Is Running Out, Press The Attack",
            "Defend The Point, Strike As One",
            "In Range Of The Objective, Form Up On Me",
            "Moving the Payload, fall in behind me",
            "We Need To Stop The Payload",
            "Tango, Down",
            "Right On Target",
            "Target Eliminated",
            "Final Blow - You Got Served",
            "Sorry, Reinhardt",
            "You made a tactical error",
            "I Always Get My Prey",
            "Operating At Maximum Efficiency",
            "Hostiles eliminated",
            "Targets neutralized",
            "Clearing the board",
            "Enemy turret down",
            "Enemy turret destroyed",
            "Enemy Teleporter Destroyed",
            "Down",
            "Stay Down",
            "Cretin",
            "Reinhardt, You still got it!",
            "Enemy team neutralized",
            "Hello 1",
            "Hello 2",
            "Greetings",
            "Thank You 1",
            "Thank You 2",
            "Thanks",
            "You Have My Thanks",
            "I Copy",
            "Understood",
            "Achknowledged",
            "I Require Healing",
            "I Need Healing",
            "Form Up",
            "Group Up",
            "Group Up With Me",
            "Group up here",
            "My ultimate is charging",
            "My ultimate is almost ready",
            "Barrage Ready",
            "My Ultimate Is Ready",
            "Put your security in my hands",
            "Aerial superiority achieved",
            "Fly like an Egyptian",
            "Flying the friendly skies",
            "Leave This To A Professional",
            "Not A Chance",
            "Play nice, play Pharah",
            "Rocket jump. That sounds dangerous",
            "Shot Down",
            "Sorry, but I need to jet",
            "We Are In This Together",
            "Want to know the forecast",
            "I keep the peace",
            "I am the Rocket Queen",
            "Fly casual",
            "Try me",
            "Then I have nothing to worry about",
            "I always dreamed of the day we would fight together",
            "Cassidy, where did you learn to shoot like that?",
            "See you in the air",
            "I had a poster of you on my wall when I was younger",
            "I lost many good soldiers here",
            "I Always Dreamed Of Being Stationed Here",
            "Thunderbird systems online",
            "Death comes",
            "Die die die",
            "clearing the area",
            "Hero Selected - Death Walks Among You",
            "During Set Up - The Reckoning Draws Near",
            "During Set Up - Time, To Kill",
            "Respawn - Vengeance Shall Be Mine",
            "Respawn - The Grave Cannot Hold Me",
            "Voted Epic - Menacing Laughter",
            "Voted Legendary - Finally Some Recognition",
            "Sniper",
            "enemy turret ahead",
            "Unstoppable",
            "The Darkness Consumes You",
            "Death becomes you",
            "You never were a good student",
            "Never liked you much",
            "This is how it should have been",
            "You always did have a high opinion of yourself",
            "Another one off the list",
            "Stupid monkey",
            "thanks",
            "Get me some armor",
            "group up",
            "My ultimate is ready",
            "What are you looking at",
            "Dead man walking",
            "Havent I Killed You",
            "If it Lives I can kill it",
            "next",
            "moving on",
            "I taught you everything you know",
            "You Look Ridiculous",
            "You tell me, Doc",
            "And you sure know how to play boy scout",
            "I need to pay visit to a friend",
            "This is where I picked up the ingrate",
            "my mistake",
            "Come out and face me",
            "Is That The Best You Can Do",
            "Get Behind Me",
            "I will hold the line",
            "Bring it on",
            "Barrier activated",
            "Barrier is giving out!",
            "Barrier is failing!",
            "Barrier destroyed!",
            "Hammer Down!",
            "No lying down on the job!",
            "And stay down!",
            "Justice will be done",
            "We shall prove ourselves in glorious combat!",
            "Again! Again!",
            "Back into the fray",
            "This is not over",
            "I will not give up the fight",
            "Back, and ready for more!",
            "There is still more to my tale!",
            "Haha! Still kicking!",
            "Wait for me!",
            "Ah",
            "Ah, I feel like a new man!",
            "Much better!",
            "You honor me",
            "Yes!",
            "Are you ready, Here I come!",
            "I feel powerful!",
            "I am unstoppable!",
            "Unacceptable",
            "Ah, impressive, if I do say so myself!",
            "One hundred percent German power!",
            "What A Performance",
            "I Am The Champion",
            "They Are Back For More",
            "Reinhardt at your service",
            "Sniper!",
            "Sniper! Fight toe-to-toe you coward!",
            "i have found the enemy",
            "Enemy Turret Ahead",
            "Our enemies have a teleporter!",
            "Steel yourselves",
            "Make Every Second Count, Crush Their Defences",
            "We Are Out Of Time, Attack",
            "The Enemy Is At Our Doorstep, Drive Them Back",
            "They Are Taking Our Point, Throw Them Back",
            "I Am Capturing The Objective, Try And Stop Me",
            "The Objective Is Mine, Join Me If You Will",
            "Taking The Objective, Join Me In Glory",
            "The Payload Has Come To A Halt, Get It Moving",
            "Moving The Payload, Join Me",
            "They Are Moving The Payload, We Must Stop Them",
            "Do i have your attention yet",
            "Too Strong",
            "This old dog",
            "Splendid!",
            "Got You",
            "Feel my power!",
            "When All You Have Is A Hammer, Everyone Else Is A Nail",
            "Out Of My Way",
            "Im not even close to done",
            "Enemy turret destroyed",
            "Enemy Teleporter Destroyed",
            "I Slay Dragons",
            "Traitor",
            "Not Strong Enough",
            "Leave Some Glory To Me",
            "Well Done My Friend",
            "Ana Would Be Proud",
            "Well Done My Diminutive Swedish Friend",
            "I Owed You One",
            "Challenge accepted",
            "The Enemy Team Is Eliminated, We Have The Advantage",
            "Greetings",
            "Hello",
            "Hello!",
            "Thank you",
            "Thank you, my friend!",
            "Much obliged!",
            "Acknowledged!",
            "Understood",
            "Right away!",
            "Need healing",
            "I need healing!",
            "I need armor! Ehh... more armor",
            "Join me!",
            "Group up with me!",
            "Group up!",
            "Group up here!",
            "I Stand With You",
            "My ultimate is charging",
            "My ultimate is almost ready!",
            "My ultimate is ready!",
            "Earthshatter, ready!",
            "I salute you",
            "Are you afraid",
            "Bring Me Another",
            "Catch phrase",
            "Crusader online",
            "Crushing Machine",
            "German Engineering",
            "Honor and glory",
            "Respect your elders",
            "This old dog",
            "Smashing",
            "Are you chicken",
            "Easy does it",
            "Unstoppable",
            "Beer!",
            "Honor, justice, reinhardt",
            "And You Are Looking As Lovely As Ever",
            "We Old-Timers Must Stick Together, Teach These Kids A Thing Or Two",
            "Ana, How Can This Be, I Thought You Were Dead",
            "I killed many of your kind here Bastion",
            "You kids today with your techno music. You should enjoy the classics, like Hasselhoff!",
            "Never, I Will Fight To My Last Breath",
            "Brigitte Has Made Her Choice, I Would Have Her At My Side",
            "I remember that poster",
            "You always did take good care of my armor!",
            "Nervous. Me. Never!",
            "Keep Training, And Maybe Some Day You Could Learn To Handle A Real Weapon",
            "This Is The Home Town Of My Master, Balderich, He Was Born Here, And He Died Here",
            "Too Much Blood Was Spilt In My Country During The War",
            "We Fought A Terrible Battle Here, Many Crusaders Lost Their Lives",
            "I remember being posted here. It was good for my tan",
            "For Balderich",
            "I am purified",
            "Fall back",
            "Is my hero",
            "Come here",
            "get down",
            "Grounded",
            "Here Little Piggy",
            "Squeal For Me",
            "Ultimate - Maniacal Laughter",
            "fired up",
            "what are you lookin at",
            "stay out of my way",
            "Roadhog, Rides Again",
            "back for more",
            "Muahahaha, Yeah!",
            "oh goodie",
            "No Way",
            "easy",
            "only thing you can count on",
            "Roadhog time",
            "sniper",
            "enemy turret here",
            "find their teleporter",
            "Found their teleporter",
            "i am unstoppable",
            "come over here",
            "Out Of Time, Attack",
            "Point Is Mine, Property Of Roadhog",
            "get on the attack now",
            "payload moving out",
            "stop the payload",
            "stop that payload",
            "stop them",
            "Sit Down",
            "hurts so good",
            "no pain no gain",
            "peace and quiet",
            "Nice Mask",
            "enemy turret destroyed",
            "Enemy teleporter destroyed",
            "go on ask me what the other one says",
            "it says left",
            "About time you did something useful",
            "someone finally shut him up",
            "less work for me",
            "Hey",
            "hi",
            "Thanks",
            "Thank You",
            "Need healing",
            "Bleeding Like A Stuck Pig",
            "group up with me",
            "join me",
            "My ultimate is ready Come on!",
            "Ready To Go Whole Hog",
            "Ultimate Ready",
            "Welcome, To The Apocalypse",
            "Like Taking Candy From A Baby",
            "Got Something To Say",
            "Hook, Line And Sinker",
            "Life Is Pain, So Is Death",
            "Piece Of Cake",
            "Push Off",
            "Say Bacon One More Time",
            "Violence Is Usually The Answer",
            "want some candy",
            "ho ho ho",
            "you chicken",
            "shut up",
            "Hey. Stay out of trouble",
            "try and stay out of trouble",
            "try me",
            "Mm... Pretty place Be a shame to have to kill someone here",
            "God Save The King",
            "Pretty sure theyre still mad",
            "Now I know why they call this place dorado",
            "woop woop",
            "anchors away",
            "gone fishin",
            "arrr matey",
            "come closer",
            "Ultimate - Eat This",
            "Oooh, they stocked up again",
            "idiot",
            "everyone has a plan til they get punched in the mouth",
            "a reward fit for a king",
            "whatever you say",
            "shiny",
            "No job too big, no score too small",
            "so much drama",
            "Activating the barrier!",
            "Barrier in place!",
            "Observe the barrier!",
            "Back to me!",
            "Retrieving the barrier!",
            "Barrier integrity failing!",
            "Barrier is about to break!",
            "Barrier is fracturing!",
            "Barrier is under attack!",
            "Barrier is under heavy fire!",
            "Barrier is unstable!",
            "Barrier experiment failed!",
            "Barrier is out of existence!",
            "My barrier is destroyed! 2",
            "The barrier no longer exists!",
            "Give me a moment! One moment!!",
            "Give me a moment to think!",
            "Look at this pattern!",
            "This pattern!",
            "The equation... what was that equation again",
            "The dragon has been consumed",
            "Draw",
            "I felt a chill",
            "Justice has embraced me",
            "Not fast enough",
            "Gravity is shackled!",
            "I have harnessed the harness",
            "Impact!",
            "What an impact!",
            "Wholly predictable!",
            "(Dutch) The universe sings to me!",
            "(Ultimate) What is that melody",
            "And they all fall down!",
            "Fall!",
            "No one escapes gravity!",
            "To dust you shall return!",
            "There is no obligation",
            "A lovely day for field research",
            "(distracted humming) Oh! I see. (clears throat)",
            "Double... triple... quadruple check your math!",
            "Soon we will see if the hypotheses are correct",
            "We need a moment to ensure all our equations are correct",
            "Begin the experiment",
            "(Dutch) (laughs) You never know how things will turn out",
            "An unexpected but not unwelcome development",
            "If only the answers were simple",
            "Stardust to stardust",
            "The breakthrough was near... I-I could feel it",
            "The equations were correct... the problem must lie elsewhere",
            "A marked improvement",
            "Condition restored",
            "(Dutch) I feel much better",
            "Much better",
            "Everything is falling into place!",
            "Not to be academic, but I believe that one would call this being on fire",
            "The universe flows through me",
            "What a curious feeling!",
            "What is this power",
            "It cannot be stopped",
            "With power such possibility",
            "No no no!",
            "This does not compute!",
            "(Dutch) Gosh darn it!",
            "It seems we have a consensus",
            "Simple arithmetic",
            "(chuckle) My theories are confirmed",
            "Peer reviewed",
            "Impossible! An enemy returns",
            "A scientific miracle",
            "Where was I",
            "Sigma present",
            "Evidence suggests a sniper ahead",
            "Enemies in our orbit",
            "Enemy turret ahead",
            "The enemy has a teleporter",
            "Behind you!",
            "If we continue upon this trajectory, a less than satisfying outcome is a certainty",
            "This may yield a positive outcome. We must hurry!",
            "Entity terminated",
            "(Dutch) Jackpot!",
            "Like Newton and the apple",
            "Surely there is a more elegant solution",
            "The mysteries of the universe are open to you now",
            "The theories are correct!",
            "Poor practices",
            "Give Dr. Winston my regards",
            "(Dutch) (laughs) The monkey is out of the bag",
            "An elementary application!",
            "(sighs) Like the impression of a dying star",
            "Revolutionary",
            "What is this... violence",
            "Ah! The results are reproducible!",
            "(laughs) A welcome recurrence. ",
            "The experiment produces consistent results! We should continue",
            "(Dutch) Calling the shots for now!",
            "The data pool increases",
            "Enemy turret theory disproven",
            "Enemy teleporter eliminated",
            "Back!",
            "Oh, pardon ",
            "Unfortunate",
            "Always nice to see a colleague at work",
            "Simply brilliant!",
            "(Dutch) Hello",
            "Hello",
            "(Dutch) Hi!",
            "Oh, hello",
            "(Dutch) Thank you",
            "Thank you",
            "Acknowledged",
            "Confirmed",
            "Understood",
            "Defend the objective!",
            "Keep them from the objective!",
            "Onto the objective",
            "Take the objective!",
            "To succeed, the objective must be taken",
            "Aid the payload on its trajectory!",
            "Bring the payload to a stop!",
            "The payload most move!",
            "Capture the enemy flag!",
            "Defend the flag!",
            "Do not let the flag fall into their hands!",
            "Take the enemy flag!",
            "I require healing",
            "Need Healing 2",
            "Need Healing",
            "Assemble at this location",
            "Assemble at this location 2",
            "Group up here",
            "Group up here 2",
            "Following your lead",
            "Ult Charging 3",
            "Ult Charging",
            "Ult Charging 2",
            "Ult Almost Ready 2",
            "Ult Almost Ready",
            "Ult Ready",
            "Ult Ready 2",
            "dr odeorain",
            "i saw you at lunas cabaret",
            "(laughs) Get down with Sigma tonight, like a stroopwafel!",
            "By looking far out into space we are also looking far back into time, back toward the horizon of the universe",
            "This is all Greek to me",
            "Tempus fugit",
            "Initiating the hack",
            "Iniciando el hackeo",
            "Here I am",
            "Looking for me",
            "Been here all along",
            "Hey there",
            "Miss me",
            "Gotcha",
            "He vuelto",
            "Be right back",
            "Beacon in place",
            "Always leave yourself a back door",
            "I might need this later",
            "Ahorita regreso",
            "Translocating",
            "See you later",
            "Cheers, love",
            "Apagando las luces",
            "EMP activated!",
            "Reboot and try again",
            "We all make mistakes",
            "Ya estoy lista para ese trago",
            "Hora de empezar de nuevo",
            "No manches",
            "Intentamos otra vez",
            "Feeling much better",
            "Mucho mejor",
            "Much better",
            "You have good taste",
            "Damn it",
            "Someone has to pull their weight around here",
            "I thought so",
            "Do I win a prize",
            "It was nothing",
            "Sombra online",
            "Sniper! Ten cuidado",
            "Enemies on my radar",
            "El enemigo esta aqui.flac",
            "Enemigo detectado",
            "Enemy turret here",
            "Find the teleporter",
            "Someone find their teleporter!",
            "Located their teleporter",
            "They have a shield generator.",
            "Found the shield generator.",
            "Get to cover!",
            "I am unstoppable!",
            "The objective is compromised",
            "Taking the objective. A little help would be appreciated!",
            "Someone needs to get the payload moving!",
            "We need to get the payload back on track",
            "Payload Defense",
            "Lighten up",
            "Oh, pobrecita",
            "Oh, pobrecito",
            "Lo siento",
            "Buenas noches",
            "Taradita",
            "Sorry Gabe",
            "Huy! Que Miedo!.flac",
            "Amateur hour",
            "Te pasas de lanza.",
            "Que triste",
            "Enemy Turret offline",
            "I blew up the tire, if anyone was wondering",
            "Down for the count!",
            "Back off!",
            "I know Kung Fu",
            "I knew you were good for something.flac",
            "Must be some reason I keep you around",
            "Buen Tiro!",
            "Hey",
            "Yonda",
            "Thanks!",
            "Thank you!",
            "Got you!",
            "I got it",
            "I need healing!",
            "Need healing over here!",
            "Shields por favor!",
            "I could use some shields!",
            "Armor por favor!",
            "Come over here!",
            "EMP charged",
            "My ultimate is ready",
            "My ultimate is ready. Get in there!",
            "My EMP is almost charged",
            "My ultimate is almost ready",
            "Boop!",
            "De pelos",
            "Did you mean to do that",
            "Good one",
            "Hack the planet",
            "Just squishing a bug",
            "Mess with the best and die like the rest",
            "If you hold the information, you hold all the cards",
            "You trying to be scary",
            "I can be nice",
            "Pleasure working with you, Cassidy... if that is your real name",
            "So what are we doing here, boss",
            "What can I say. A girl just has to have the latest tech",
            "Your friend, Katya Volskaya. What will you say when you learn the truth",
            "Back home... I should go drop by the bakery",
            "Do you ever stop and just look up at the sky. I hear you can see all sorts of things",
            "I wonder how my friend is doing",
            "Aloha",
            "Hey dude",
            "We need that payload to make a 180",
            "Damn ankle busters",
            "Mine deployed",
            "Hasta luego",
            "Too close for comfort",
            "Cinco cuatro tres dos uno",
            "Five, four, three, two, one",
            "From light into being",
            "Turret deployed",
            "Turret online",
            "Aligning defense system",
            "Defenses in place",
            "Turret in place",
            "Sentry deployed",
            "Sentry Turret placed",
            "Turret was destroyed",
            "My defenses are weakened",
            "Intruder detected",
            "My sentry was destroyed",
            "The true enemy of humanity is disorder",
            "If everyone performs their function",
            "Do not deviate from the plan",
            "I will shape order from chaos",
            "Order will be restored",
            "A momentary lapse",
            "Death is an illusion",
            "My work is not complete",
            "I will correct my mistakes",
            "I will follow my path",
            "There is still much to be done",
            "Much better",
            "I am restored",
            "I have reached peak performance levels",
            "My full potential is unlocked",
            "My power grows",
            "System Optimized",
            "Our fates are entwined",
            "Perfect alignment",
            "Damn",
            "A performance worthy of repetition",
            "Ah, that is the way!",
            "As it should be",
            "I will show you the path",
            "They have revived",
            "Symmetra reporting",
            "Sniper",
            "I have located the enemy",
            "Enemy turret ahead",
            "The enemy possesses a teleporter, we must locate it",
            "We must locate their teleporter",
            "Enemy teleporter located. We must destroy it",
            "Behind you!",
            "Do not let up, victory will soon be ours",
            "If we work in unison, our defense will be impenetrable",
            "Defend together! It will not be long now",
            "Attack now or we are defeated!",
            "Secure the objective!",
            "Time grows short but we must fight to the end",
            "Time is running out, we must not fail",
            "Align our attack, move the payload",
            "I am at the objective, we must take it quickly",
            "I am claiming the objective, support me",
            "I am taking the objective, all is going according to plan",
            "We must hold the point against their attack!",
            "Reinforce our defenses, we must hold them back!",
            "Consolidate our defenses on the point!",
            "The payload moves, as must we",
            "The payload moves to its destination all according to plan",
            "The payload is moving, converge upon it",
            "The payload is moving, we must pull together",
            "Together we must stop the payload, this is the way it must be",
            "We must stop the payload!",
            "The payload has stopped, we must get it moving",
            "The payload has stopped, we must get our plan back on track",
            "Just as expected",
            "Order is restored",
            "The balance shifts in my favor",
            "Perception is your weakness",
            "Why do you struggle against your fate",
            "You are unworthy of the true reality",
            "Know your place",
            "Perfection",
            "You are trapped in your own mind",
            "This is the order of things",
            "That was for your own good",
            "You lack imagination",
            "You were not meant for greatness",
            "All according to plan.",
            "A punishment for your crimes",
            "Everything in its place",
            "The pattern develops",
            "This is the shape of things to come",
            "Enemy turret destroyed An inferior design",
            "Enemy turret destroyed",
            "Enemy teleporter destroyed. Hm",
            "Get back",
            "Know your place2",
            "Shameful",
            "You perform your function admirably",
            "Well executed",
            "I had not forgotten you",
            "The enemy team has been eliminated",
            "All enemies eliminated",
            "Hello",
            "Hello 2",
            "Greetings",
            "Thank you",
            "You have my thanks",
            "Understood",
            "I understand",
            "Acknowledged",
            "I need healing",
            "I require healing",
            "Form up",
            "Group up",
            "Group up with me",
            "Group up here",
            "My ultimate is charging",
            "My Teleporter is almost ready to deploy",
            "My ultimate is almost ready",
            "My ultimate ability is ready",
            "Teleporter ready for deployment",
            "My teleporter is ready to deploy",
            "Such a lack of imagination",
            "Everything by design",
            "Exquisite",
            "How unsightly",
            "Impressive",
            "Perfect harmony",
            "Precisely",
            "I will put you in your place",
            "Welcome to my reality",
            "Why do you struggle",
            "Hard work and dedication pays off",
            "Work with a street ruffian",
            "What you call freedom is an illusion that causes more harm than good",
            "What you call freedom, I call anarchy.",
            "Vishkar is building a better future",
            "You should return what you stole",
            "Of course science obeys the laws of nature",
            "Armor How positively medieval",
            "This would be a perfect location for a Vishkar development",
            "Creating a barrier",
            "Projecting a barrier",
            "Projecting barrier",
            "I will shield you Photon Barrier",
            "I will shield us",
            "This will protect you",
            "This will protect us",
            "Barrier is on its way",
            "Photon Barrier Deployed",
            "Instancing Photon Barrier",
            "Shield engaged",
            "I will shield you",
            "Be shielded",
            "You are shielded",
            "Shield matrix established",
            "Everyone is protected",
            "Turret available for deployment",
            "Defensive matrix established.ogg",
            "There is a gap in my defense matrix",
            "Teleporter on-line. I have opened the path",
            "Teleporter on-line. We move swiftly",
            "Shield generator online. You are protected",
            "Shield generator online. Defense matrix established",
            "Shield matrix established Shield Generator",
            "Protect the teleporter.",
            "Teleporter is under attack",
            "My shield generator is under attack",
            "Teleporter destroyed",
            "My teleporter has been destroyed",
            "My teleporter has been destroyed. The path is closed",
            "My teleporter has been destroyed. The way is closed",
            "Teleporter offline",
            "My teleporter is offline",
            "Teleporter offline. The path is closed",
            "My teleporter is offline. The path is closed",
            "My teleporter is offline. The way is closed",
            "My shield generator has been destroyed",
            "My shield generator is offline",
            "Blink laugh",
            "Whee!",
            "Whoa",
            "Blink Wicked",
            "yeah",
            "Just in time",
            "Now, where were we",
            "Got ya!",
            "Gotcha",
            "Nailed it!",
            "Right on target",
            "Bombs away!",
            "Here ya go!",
            "Wait for it...",
            "You need a time out",
            "Cracking",
            "Oi this is no time for standing around",
            "Wait for me",
            "Well that just happened",
            "Back to work",
            "Back in the fight!",
            "All eyes on me!",
            "im in the zone",
            "Sensational!",
            "Aww thanks loves",
            "Excelsior",
            "Aww yeah",
            "nice save",
            "Tracer here",
            "Sniper",
            "There they are",
            "Enemy turret ahead",
            "Find their teleporter",
            "Found their teleporter!",
            "Behind you",
            "Recall Gasp",
            "The objective is mine",
            "defend the objective",
            "payloads moving",
            "payloads stopped",
            "This time stay down",
            "Speed Kills",
            "Sorry, cap!",
            "Death comes!",
            "No one likes a thief",
            "That felt good",
            "squished",
            "Sorry, big guy!",
            "Looks like you need a time out!",
            "Get stuffed!",
            "Ha! Bet that smarts!",
            "Ha! Fantastic!",
            "Ha! Tip-Top!",
            "Brilliant!",
            "Wicked!",
            "Nice one!",
            "Enemy turret down",
            "Enemy teleporter destroyed",
            "pow",
            "And stay down",
            "down for the count",
            "Take that!",
            "you can be my wingman",
            "nice one rein",
            "enemy team eliminated",
            "Hiya",
            "heya",
            "Hi",
            "Thank you",
            "Thanks",
            "Thanks love",
            "Understood",
            "I need healing",
            "I could use some healing",
            "hey doc",
            "I need shields",
            "I could use some shields",
            "I need armor",
            "group up",
            "Group up here",
            "Group up with me",
            "My ultimate is charging",
            "My ultimate is almost ready",
            "Pulse bomb ready",
            "you got it2",
            "Aww rubbish",
            "Be right back",
            "Check me out",
            "Keep calm and Tracer on",
            "She shoots she scores",
            "The world could always use more heroes",
            "I have this under control",
            "Looks like you need a time out",
            "Eat my dust",
            "Time Out",
            "Ooh scary",
            "Boo!",
            "Ho ho ho!",
            "dont be daft",
            "sorry im late",
            "Time is on my side",
            "did I miss something",
            "I knew I forgot something",
            "Over my dead body",
            "lucio ill race ya",
            "Then stay out of our way!",
            "mei youre the real hero",
            "Okay, Dad!",
            "wont be a problem if you just disappear",
            "dont think i dont recognize",
            "dont think im happy about that",
            "Oh, Winston! Got your favorite!",
            "I think static noises",
            "honor to meet",
            "Back in my old stomping ground",
            "Pub anyone",
            "Should we nip to the pub",
            "I could murder a chippie",
            "I could murder a chip sarnie",
            "i wonder if i left anything",
            "tosser",
            "False start",
            "I got my second wind",
            "Whew I think I hit the wall",
            "On your marks get set go",
            "here comes t racer",
            "Dashing through the snow",
            "Ho ho ho",
            "Got ya something",
            "I think I heard some slay bells",
            "You were on the naughty list",
            "Ohh sorry Santa",
            "Cheers love the holidays are here",
            "youre going on my nice list",
            "Get out of there",
            "Ive got you covered",
            "Dans ma ligne de mire",
            "I see you, do you see me",
            "Allez, montre-toi",
            "Ah, je te vois",
            "My gift to you",
            "Oh. Did that sting",
            "Watch your step",
            "La veuve tisse sa toile",
            "No one can hide from my sight",
            "One shot, one kill",
            "Huh, here I am",
            "Now You have my attention",
            "Rendez-vous avec la mort",
            "I needed that",
            "Much better",
            "You must like me",
            "Merci",
            "be alert they are back",
            "havent had enough",
            "Widowmaker here",
            "Widowmaker, au rapport",
            "Sniper. Leave this to me",
            "Sniper... amateur",
            "We need to defend the objective",
            "Goodbye Adieu",
            "A beautiful death",
            "Americans",
            "Like mother, like daughter",
            "Death becomes you",
            "Pathetic",
            "Shameful",
            "Please",
            "such artistry",
            "Talon strikes",
            "Hello there",
            "Hello",
            "Merci",
            "Understood",
            "Acknowledged",
            "i need healing",
            "I need shields",
            "Need armor",
            "Group up here",
            "A single death can change everything",
            "Encore",
            "Let them eat cake",
            "Cherchez la femme",
            "Magnifique",
            "une balle un mort",
            "Step into my parlor. said the spider to the fly",
            "the perfomance is about to",
            "your emotions make you",
            "You were once a legend, but what are you now. Just a shell of a woman ",
            "This is no place for children",
            "that would be the last mistake",
            "it would be a shame if something",
            "An annoyance",
            "so predictable tracer",
            "i dont even feel the cold",
            "no one can hide from the huntress",
            "the huntress gets her prey",
            "Coming through",
            "Pardon me",
            "Excuse me for dropping in",
            "Hello there",
            "Barrier activated",
            "Barrier up",
            "This will protect us",
            "Barrier failing!",
            "Ultimate - Roar",
            "I seem to have, uh, lost my temper",
            "I, uh, appear to have lost control",
            "Ahem, uh, where were we",
            "Ahem, um, pardon me",
            "Imagination is the essence of discovery",
            "Together, we can solve any problem",
            "Further experimentation required",
            "Hmm, once more unto the breach",
            "Onward and upward!",
            "Reengaging",
            "Through the miracle of science!",
            "Vital signs normalizing",
            "Damage output increased",
            "Weapon system optimized!",
            "Feeling drained",
            "Every little bit counts",
            "Enemies reengaging!",
            "Winston reporting",
            "Sniper! Be careful",
            "Enemy detected",
            "Enemies detected!",
            "Turret ahead, use caution",
            "They have a teleporter somewhere",
            "We need to locate their teleporter!",
            "Behind you!",
            "Take cover!",
            "I need a hand here!",
            "I could use some help!",
            "Uh, little help here",
            "Feeling powerful!",
            "By my calculations, our defenses will hold",
            "Haha, countdown to defensive victory initiated",
            "Uh, cursory evaluation suggests time is running out",
            "If we work together",
            "The odds are in our favor, press the attack!",
            "Our enemies are taking the point!",
            "Payload stalled!",
            "Uh, we have to get this thing moving again",
            "We need to move the payload!",
            "Escorting the payload",
            "You know what they say, a payload in motion stays in motion",
            "Payload in transit",
            "It appears the payload is moving!",
            "We must intercept the payload",
            "We need to stop the payload!",
            "One for the archives",
            "Would you like to donate your body to science",
            "You, stay away from my computer systems",
            "Enemy turret neutralized",
            "Enemy teleporter destroyed",
            "Nice shot!",
            "Tracer, no!",
            "Hello",
            "Hey",
            "Hi there",
            "Thanks",
            "Thank you",
            "Thank you!",
            "Acknowledged",
            "Absolutely!",
            "Got it",
            "You got it!",
            "Need healing!",
            "I need healing",
            "I could use some healing",
            "Need armour",
            "I need armour!",
            "Need shields",
            "I could use some shields",
            "We could use a healer",
            "Group up!",
            "Group up with me",
            "Form up!",
            "My ultimate is charging",
            "My ultimate is almost ready!",
            "My ultimate is ready!",
            "Curious",
            "How embarrassing!",
            "No, I do not want a banana",
            "Natural selection!",
            "No monkey business",
            "Did someone say peanut butter",
            "Sorry about that!",
            "The power of science!",
            "Houston, we have a problem",
            "This is not a costume",
            "I, uh, got you something",
            "That was awesome!",
            "I Get That A Lot",
            "Uhm, okay, I guess. We got this big mission coming up-- Oh, I get it",
            "Genji, this is just like old times",
            "Oh, uhm, thanks, I like yours, too",
            "Someone has to",
            "Need any adjustments to your chronal accelerator",
            "For the last time, no more bananas!",
            "I would kill for some tacos",
            "You know, they asked me to be in a movie once",
            "Horizon Lunar Colony Map - The First Day Or So",
            "A city run by scientists, smart",
            "Now is the winter of our discontent",
            "Happy holidays!",
            "Overwatch made mistakes in the past, I hope that we can fix them",
            "Five, four, three, two, one",
            "In five, four, three, two, one",
            "Always liked working with you too",
            "I like to leave the heavy lifting",
            "Barrier activated",
            "Bring it",
            "Give me your best shot",
            "Ready for battle",
            "Is that all youve got",
            "That tickles",
            "Maximum charge",
            "Fire at will!",
            "Gravity kills",
            "Do you even lift",
            "Together we are strong",
            "Be sure to stretch",
            "During Set Up - Just Like In Training Visualize Then Execute",
            "Give me another shot",
            "Respawn - I Will Never Surrender",
            "Much better",
            "I am on fire Everyone follow me",
            "I am even stronger",
            "Now see what I can do",
            "Laugh",
            "Voted Epic - Hard Work Is Its Own Reward",
            "Voted Legendary - I Do It For My Country",
            "A second chance",
            "They have been revived",
            "Zarya, ready for duty",
            "Sniper, be wary",
            "Enemy contact",
            "Enemy turret ahead",
            "They must have a teleporter",
            "Teleporter located",
            "We are out of time attack",
            "This is it, push forward!",
            "Push forward",
            "They are running out of time, we must hold them back",
            "They must not get past",
            "Just a little longer, turn them back",
            "Turn them back",
            "I am taking the objective, reinforce this position",
            "I claim this objective, stand with me",
            "Everyone, on the objective",
            "Get on the objective, we cannot let it fall into their hands",
            "Push them back",
            "Escorting the payload",
            "I am moving the payload fall in with me",
            "Let us stop the payload together",
            "The payload is moving, halt their progress",
            "They are moving the payload, stop them!",
            "The payload stopped get it moving",
            "We need to get the payload moving",
            "Primary objective, move the payload",
            "Final Blow - I Am The Champion",
            "Your team was depending on you",
            "I am just getting warmed up",
            "Final Blow - Check Out This Gun",
            "Final Blow - Promising..... But Not Good Enough",
            "Never Trust",
            "Enemy turret eliminated",
            "The enemy teleporter is destroyed",
            "Take the pain",
            "Weak",
            "Nice shot",
            "Remember me",
            "Hello - Privet",
            "Thank you",
            "Thank - Spasibo",
            "Acknowledged",
            "I am injured",
            "Need armour",
            "Join me",
            "Get down give me twenty",
            "I can bench more than you",
            "I will break you",
            "Are you in need of personal training",
            "Big, fuzzy Siberian bear",
            "Born in Battle",
            "I have destroyed more of your kind than I can count",
            "How do I trust a man who is half machine",
            "Reinhardt. You said you would arm wrestle me. Nervous",
            "I will not let the fate that befell this place happen to my country!",
            "The humans who live here are fools to trust the omnics",
            "Katya is a hero to my people. We must protect what she has built",
            "Be one with the Universe",
            "Be reborn",
            "Embrace tranquility",
            "Free your mind",
            "Gaze into the Iris",
            "Open your mind",
            "Walk in harmony",
            "We walk in harmony my student",
            "We are as one my sister",
            "Bask in the shadow of doubt",
            "Darkness falls",
            "There is chaos within you",
            "There is disquiet in your soul",
            "You are your own worst enemy",
            "I know the doubts that plague you",
            "You have much to learn",
            "Experience tranquility",
            "Pass into the Iris",
            "True self is without form",
            "A chance to focus",
            "A closed mind is already defeated",
            "A disciplined mind is your most dependable ally",
            "Consider only victory, make defeat an impossibility in your mind",
            "A momentary setback",
            "A temporary setback",
            "Adversity is an opportunity for change",
            "Overconfidence is a flimsy shield",
            "Pain is an excellent teacher",
            "Repetition is the path to mastery",
            "The cycle begins anew",
            "The outcome is not preordained",
            "I am made whole",
            "I am restored",
            "My systems are restored",
            "I am on fire",
            "I am on fire, but an extinguisher is not required",
            "I feel the warmth of the Iris flowing through me",
            "Energy flows through me",
            "My spirit is strong",
            "Now to strike",
            "I feel greatly empowered",
            "I feel unstoppable!",
            "I welcome adversity",
            "Excellence is its own reward",
            "Wonderful",
            "The gods have selected me",
            "Our enemies return",
            "I return",
            "Zenyatta is here",
            "I see a sniper",
            "Sniper",
            "Enemy detected",
            "The enemy is here",
            "A turret lies before us, it is quite real",
            "A turret lies in our way",
            "The enemy possesses a teleporter",
            "We must locate their teleporter",
            "Behind you",
            "Get out of there!",
            "I need help",
            "I require assistance",
            "Falter now, and we will succumb to defeat",
            "Victory is within our grasp hold strong",
            "Time grows short attack",
            "Time is an illusion",
            "We must focus our attack upon the payload",
            "We must wrest victory from the jaws of time",
            "Our objective will soon belong to the enemy",
            "Destiny has drawn me to the objective",
            "I am becoming one with the objective",
            "I am taking the objective, join me",
            "The payload must be moved",
            "The payload rests idle",
            "My path has converged with that of the payload",
            "The payload and I move as one",
            "The payload proceeds on its path",
            "The payload moves closer to the threshold of our defeat",
            "The payload moves like a stone",
            "A lesson in humility",
            "Do not be discouraged everyone begins in ignorance",
            "Hatred is not strategy",
            "If you do not bend, you break",
            "In anger you defeat only yourself",
            "One cannot survive on strength alone",
            "You must learn from your mistakes",
            "You refuse to learn",
            "Your weakness is revealed",
            "I win this round, Genji",
            "The master still has a few tricks",
            "Move too quickly and you overlook much",
            "Justice is defined by the hand that claims it",
            "Eager to Learn",
            "Revenge is not justice",
            "All-Knowing",
            "I feel neither joy nor remorse amidst such death",
            "A glimpse of mastery",
            "The turret is no more",
            "The turret no longer exists",
            "Impressive",
            "Well done Genji",
            "To hold a grudge is unhealthy- for you",
            "Our enemies have been eliminated but they will return",
            "The enemy team has been eliminated",
            "The enemy team is not in existence for now",
            "Greetings",
            "Peace be upon you",
            "My thanks",
            "Thank you",
            "You have my thanks",
            "Acknowledged",
            "I am in agreement",
            "I understand",
            "Understood",
            "I need healing",
            "I require healing",
            "I need armor",
            "I require armor",
            "I need shields",
            "I require shields",
            "Come here for healing",
            "Come to me for healing",
            "Form Up",
            "Group up",
            "Group up here",
            "Group up with me",
            "Join me",
            "My ultimate ability is ready",
            "My ultimate is ready, proceed without fear",
            "Ready for Transcendence",
            "We are in harmony",
            "Death is whimsical today",
            "Do I think, does a submarine swim",
            "Free your mind",
            "Hello world",
            "I dreamt I was a butterfly",
            "I think, therefore I am",
            "I will not juggle",
            "Life is more than a series of ones and zeroes",
            "Peace and blessings be upon you all",
            "The Iris embraces you",
            "Always strive for improvement",
            "Trick or treat",
            "No snowflake ever falls in the wrong place",
            "Every rooster crows in its own pen",
            "How Disappointing",
            "Tell me your thoughts, my friend",
            "It is good to fight alongside one of my brightest pupils",
            "Even the teacher can learn from his student",
            "I sense within you the same rage that once consumed your brother",
            "Do you have any dreams",
            "I would be happy to teach you",
            "To us all, I miss him greatly",
            "And I will watch your back in turn",
            "So this is where you grew up. You must show me around",
            "If only human and omnic could learn to live in peace here",
            "It does, my brother Mondatta gave much to improve their lives, but it was not to be",
            "It is good to return, but am I still welcome here",
            "I can feel the embrace of the Iris so strongly here",
            "How wonderful, a place where omnic and human live as equals",
            "What a fascinating place",
            "Be one with the darkness",
            "Walk in shadow",
            "Embrace oblivion",
            "We walk in the shadows, my apprentice",
            "Darkness envelops all",
            "Be consumed by the shadows",
            "Listen to the whispers of madness",
            "Experience nothingness",
            "Pass into the unknown",
            "Zenyatta is everywhere",
            "Curses and Madness be upon you all",
            "The Iris consumes you",
            "Trick or Treat"
          ]
        },
        "pokemon": {
          "locations": [
            "Accumula Town",
            "Ambrette Town",
            "Anistar City",
            "Anville Town",
            "Aquacorde Town",
            "Aspertia City",
            "Azalea Town",
            "Black City",
            "Blackthorn City",
            "Camphrier Town",
            "Canalave City",
            "Castelia City",
            "Celadon City",
            "Celestic Town",
            "Cerulean City",
            "Cherrygrove City",
            "Cianwood City",
            "Cinnabar Island",
            "Coumarine City",
            "Couriway Town",
            "Cyllage City",
            "Dendemille Town",
            "Dewford Town",
            "Driftveil City",
            "Ecruteak City",
            "Eterna City",
            "Ever Grande City",
            "Fallarbor Town",
            "Fight Area",
            "Five Island",
            "Floaroma Town",
            "Floccesy Town",
            "Fortree City",
            "Four Island",
            "Frontier Access",
            "Fuchsia City",
            "Geosenge Town",
            "Goldenrod City",
            "Hearthome City",
            "Humilau City",
            "Icirrus City",
            "Jubilife City",
            "Kiloude City",
            "Lacunosa Town",
            "Lavaridge Town",
            "Lavender Town",
            "Laverre City",
            "Lentimas Town",
            "Littleroot Town",
            "Lilycove City",
            "Lumiose City",
            "Mahogany Town",
            "Mauville City",
            "Mistralton City",
            "Mossdeep City",
            "Nacrene City",
            "New Bark Town",
            "Nimbasa City",
            "Nuvema Town",
            "Oldale Town",
            "Olivine City",
            "One Island",
            "Opelucid City",
            "Oreburgh City",
            "Pacifidlog Town",
            "Pallet Town",
            "Pastoria City",
            "Petalburg City",
            "Pewter City",
            "Resort Area",
            "Rustboro City",
            "Safari Zone Gate",
            "Saffron City",
            "Sandgem Town",
            "Santalune City",
            "Striaton City",
            "Seven Island",
            "Shalour City",
            "Six Island",
            "Slateport City",
            "Snowbelle City",
            "Snowpoint City",
            "Solaceon Town",
            "Sootopolis City",
            "Sunyshore City",
            "Survival Area",
            "Three Island",
            "Twinleaf Town",
            "Two Island",
            "Undella Town",
            "Vaniville Town",
            "Veilstone City",
            "Verdanturf Town",
            "Vermilion City",
            "Violet City",
            "Virbank City",
            "Viridian City",
            "White Forest"
          ],
          "moves": [
            "Absorb",
            "Acid",
            "Acid Armor",
            "Agility",
            "Amnesia",
            "Aurora Beam",
            "Barrage",
            "Barrier",
            "Bide",
            "Bind",
            "Bite",
            "Blizzard",
            "Body Slam",
            "Bone Club",
            "Bonemerang",
            "Bubble",
            "Bubble Beam",
            "Clamp",
            "Comet Punch",
            "Confuse Ray",
            "Confusion",
            "Constrict",
            "Conversion",
            "Counter",
            "Crabhammer",
            "Cut",
            "Defense Curl",
            "Dig",
            "Disable",
            "Dizzy Punch",
            "Double Kick",
            "Double Slap",
            "Double Team",
            "Double-Edge",
            "Dragon Rage",
            "Dream Eater",
            "Drill Peck",
            "Earthquake",
            "Egg Bomb",
            "Ember",
            "Explosion",
            "Fire Blast",
            "Fire Punch",
            "Fire Spin",
            "Fissure",
            "Flamethrower",
            "Flash",
            "Fly",
            "Focus Energy",
            "Fury Attack",
            "Fury Swipes",
            "Glare",
            "Growl",
            "Growth",
            "Guillotine",
            "Gust",
            "Harden",
            "Haze",
            "Headbutt",
            "High Jump Kick",
            "Horn Attack",
            "Horn Drill",
            "Hydro Pump",
            "Hyper Beam",
            "Hyper Fang",
            "Hypnosis",
            "Ice Beam",
            "Ice Punch",
            "Jump Kick",
            "Karate Chop",
            "Kinesis",
            "Leech Life",
            "Leech Seed",
            "Leer",
            "Lick",
            "Light Screen",
            "Lovely Kiss",
            "Low Kick",
            "Meditate",
            "Mega Drain",
            "Mega Kick",
            "Mega Punch",
            "Metronome",
            "Mimic",
            "Minimize",
            "Mirror Move",
            "Mist",
            "Night Shade",
            "Pay Day",
            "Peck",
            "Petal Dance",
            "Pin Missile",
            "Poison Gas",
            "Poison Powder",
            "Poison Sting",
            "Pound",
            "Psybeam",
            "Psychic",
            "Psywave",
            "Quick Attack",
            "Rage",
            "Razor Leaf",
            "Razor Wind",
            "Recover",
            "Reflect",
            "Rest",
            "Roar",
            "Rock Slide",
            "Rock Throw",
            "Rolling Kick",
            "Sand Attack",
            "Scratch",
            "Screech",
            "Seismic Toss",
            "Self-Destruct",
            "Sharpen",
            "Sing",
            "Skull Bash",
            "Sky Attack",
            "Slam",
            "Slash",
            "Sleep Powder",
            "Sludge",
            "Smog",
            "Smokescreen",
            "Soft-Boiled",
            "Solar Beam",
            "Sonic Boom",
            "Spike Cannon",
            "Splash",
            "Spore",
            "Stomp",
            "Strength",
            "String Shot",
            "Struggle",
            "Stun Spore",
            "Submission",
            "Substitute",
            "Super Fang",
            "Supersonic",
            "Surf",
            "Swift",
            "Swords Dance",
            "Tackle",
            "Tail Whip",
            "Take Down",
            "Teleport",
            "Thrash",
            "Thunder",
            "Thunder Punch",
            "Thunder Shock",
            "Thunder Wave",
            "Thunderbolt",
            "Toxic",
            "Transform",
            "Tri Attack",
            "Twineedle",
            "Vice Grip",
            "Vine Whip",
            "Water Gun",
            "Waterfall",
            "Whirlwind",
            "Wing Attack",
            "Withdraw",
            "Wrap"
          ],
          "names": [
            "Bulbasaur",
            "Ivysaur",
            "Venusaur",
            "Charmander",
            "Charmeleon",
            "Charizard",
            "Squirtle",
            "Wartortle",
            "Blastoise",
            "Caterpie",
            "Metapod",
            "Butterfree",
            "Weedle",
            "Kakuna",
            "Beedrill",
            "Pidgey",
            "Pidgeotto",
            "Pidgeot",
            "Rattata",
            "Raticate",
            "Spearow",
            "Fearow",
            "Ekans",
            "Arbok",
            "Pikachu",
            "Raichu",
            "Sandshrew",
            "Sandslash",
            "Nidoran",
            "Nidorina",
            "Nidoqueen",
            "Nidoran",
            "Nidorino",
            "Nidoking",
            "Clefairy",
            "Clefable",
            "Vulpix",
            "Ninetales",
            "Jigglypuff",
            "Wigglytuff",
            "Zubat",
            "Golbat",
            "Oddish",
            "Gloom",
            "Vileplume",
            "Paras",
            "Parasect",
            "Venonat",
            "Venomoth",
            "Diglett",
            "Dugtrio",
            "Meowth",
            "Persian",
            "Psyduck",
            "Golduck",
            "Mankey",
            "Primeape",
            "Growlithe",
            "Arcanine",
            "Poliwag",
            "Poliwhirl",
            "Poliwrath",
            "Abra",
            "Kadabra",
            "Alakazam",
            "Machop",
            "Machoke",
            "Machamp",
            "Bellsprout",
            "Weepinbell",
            "Victreebel",
            "Tentacool",
            "Tentacruel",
            "Geodude",
            "Graveler",
            "Golem",
            "Ponyta",
            "Rapidash",
            "Slowpoke",
            "Slowbro",
            "Magnemite",
            "Magneton",
            "Farfetch'd",
            "Doduo",
            "Dodrio",
            "Seel",
            "Dewgong",
            "Grimer",
            "Muk",
            "Shellder",
            "Cloyster",
            "Gastly",
            "Haunter",
            "Gengar",
            "Onix",
            "Drowzee",
            "Hypno",
            "Krabby",
            "Kingler",
            "Voltorb",
            "Electrode",
            "Exeggcute",
            "Exeggutor",
            "Cubone",
            "Marowak",
            "Hitmonlee",
            "Hitmonchan",
            "Lickitung",
            "Koffing",
            "Weezing",
            "Rhyhorn",
            "Rhydon",
            "Chansey",
            "Tangela",
            "Kangaskhan",
            "Horsea",
            "Seadra",
            "Goldeen",
            "Seaking",
            "Staryu",
            "Starmie",
            "Mr. Mime",
            "Scyther",
            "Jynx",
            "Electabuzz",
            "Magmar",
            "Pinsir",
            "Tauros",
            "Magikarp",
            "Gyarados",
            "Lapras",
            "Ditto",
            "Eevee",
            "Vaporeon",
            "Jolteon",
            "Flareon",
            "Porygon",
            "Omanyte",
            "Omastar",
            "Kabuto",
            "Kabutops",
            "Aerodactyl",
            "Snorlax",
            "Articuno",
            "Zapdos",
            "Moltres",
            "Dratini",
            "Dragonair",
            "Dragonite",
            "Mewtwo",
            "Mew"
          ]
        },
        "sonic_the_hedgehog": {
          "character": [
            "Alf-Layla-wa-Layla",
            "Ali Baba",
            "Amy Rose",
            "Ashura",
            "Avatar",
            "Badnik",
            "Bark the Polar Bear",
            "Battle Kukku 16th",
            "Bean the Dynamite",
            "Bearenger",
            "Big the Cat",
            "Biolizard",
            "Black Doom",
            "Blacksmith",
            "Blaze the Cat",
            "Caliburn",
            "Captain Whisker",
            "Carrotia",
            "Chaos",
            "Chaos Gamma",
            "Charmy Bee",
            "Cheese the Chao",
            "Chip",
            "Chocola the Chao",
            "Cream the Rabbit",
            "Cubot",
            "Dark Gaia",
            "Dark Super Sonic",
            "Darkspine Sonic",
            "Doctor Fukurokov",
            "Doctor Zachary",
            "Don Fachio",
            "Dr. Eggman",
            "Duke of Soleanna",
            "E-10000B",
            "E-10000G",
            "E-10000R",
            "E-101 β",
            "E-101mkII",
            "E-102 γ",
            "E-103 δ",
            "E-104 ε",
            "E-105 ζ",
            "E-121 Phi",
            "E-123 Ω",
            "Edmund",
            "Eggman Nega",
            "Eggrobo",
            "Princess Elise the Third",
            "Emerl",
            "Erazor Djinn",
            "Espio the Chameleon",
            "Fang the Sniper",
            "Focke-Wulf",
            "Froggy",
            "G-merl",
            "G.U.N. Commander",
            "Gaia Colossus",
            "Gerald Robotnik",
            "Grand Battle Kukku 15th",
            "Has Bean",
            "Heavy",
            "Bomb",
            "Honey the Cat",
            "Iblis",
            "Ifrit",
            "Ifrit Golem",
            "Illumina",
            "Infinite",
            "Ix",
            "Jet the Hawk",
            "Johnny",
            "Julie-su",
            "King Arthur",
            "King Boom Boo",
            "King Shahryār",
            "Knuckles the Echidna",
            "Lily",
            "Luigi",
            "Lumina Flowlight",
            "Maria Robotnik",
            "Marine the Raccoon",
            "Mario",
            "Master Core ABIS",
            "Master Zik",
            "Mecha Knuckles",
            "Mecha Sonic",
            "Mephiles the Dark",
            "Merlin",
            "Merlina the Wizard",
            "Metal Knuckles",
            "Metal Sonic",
            "Metal Sonic 3.0",
            "Mighty the Armadillo",
            "Mii",
            "Miles \"Tails\" Prower",
            "Mr. Needlemouse",
            "Neo Metal Sonic",
            "NiGHTS",
            "Nimue, Lady of the Lake",
            "Omochao",
            "Orbot",
            "Pachacamac",
            "Perfect Chaos",
            "President of the United Federation",
            "Professor Pickle",
            "Ray the Flying Squirrel",
            "Rocket Metal",
            "Rouge the Bat",
            "Scourge the Hedgehog",
            "SCR-GP",
            "SCR-HD",
            "Shade",
            "Shadow Android",
            "Shadow the Hedgehog",
            "Shahra, the Genie of the Ring",
            "Shugo-hei",
            "Silver the Hedgehog",
            "Sinbad",
            "Sir Galahad",
            "Sir Gawain",
            "Sir Lamorak",
            "Sir Lancelot",
            "Sir Percival",
            "Solaris",
            "Sonic the Hedgehog",
            "Sticks the Badger",
            "Storm the Albatross",
            "Tails Doll",
            "Tiara Boobowski",
            "Tikal",
            "Vanilla the Rabbit",
            "Vector the Crocodile",
            "Wave the Swallow",
            "Wentos",
            "Witchcart",
            "Xbox Live Avatar",
            "Yacker",
            "Zavok",
            "Zazz",
            "Zeena",
            "ZERO",
            "Zomom",
            "Zor"
          ],
          "game": [
            "Sonic the Hedgehog",
            "Sonic the Hedgehog",
            "Sonic the Hedgehog 2",
            "Sonic the Hedgehog 2",
            "Sonic the Hedgehog Spinball",
            "Sonic the Hedgehog CD",
            "Sonic Chaos",
            "Sonic the Hedgehog 3",
            "Sonic & Knuckles",
            "Sonic the Hedgehog Triple Trouble",
            "Knuckles' Chaotix",
            "Tails' Skypatrol",
            "Tails Adventure",
            "Sonic Labyrinth",
            "Sonic Blast",
            "Sonic Advance",
            "Sonic Advance 2",
            "Sonic Advance 3",
            "Sonic Rush",
            "Sonic Rivals",
            "Sonic Rush Adventure",
            "Sonic Rivals 2",
            "Sonic the Hedgehog 4: Episode I",
            "Sonic Colors",
            "Sonic Generations",
            "Sonic the Hedgehog 4: Episode II",
            "Sonic Jump",
            "Sonic Boom: Shattered Crystal",
            "Sonic Boom: Fire & Ice",
            "Sonic Mania",
            "Sonic Mania Plus (2018)",
            "SegaSonic the Hedgehog",
            "Sonic 3D Blast",
            "Sonic Adventure",
            "Sonic Adventure 2",
            "Sonic Heroes",
            "Shadow the Hedgehog",
            "Sonic the Hedgehog",
            "Sonic and the Secret Rings",
            "Sonic Unleashed",
            "Sonic and the Black Knight",
            "Sonic Colors",
            "Sonic Generations",
            "Sonic Lost World",
            "Sonic Boom: Rise of Lyric",
            "Sonic Forces",
            "Sonic Eraser",
            "Dr. Robotnik's Mean Bean Machine",
            "Sonic the Hedgehog's Gameworld",
            "Sonic Labyrinth",
            "Sonic Shuffle",
            "Sonic Pinball Party",
            "Sega Superstars",
            "Sonic and the Secret Rings",
            "Mario & Sonic at the Olympic Games",
            "Sega Superstars Tennis",
            "Mario & Sonic at the Olympic Winter Games",
            "Mario & Sonic at the London 2012 Olympic Games",
            "Mario & Sonic at the Sochi 2014 Olympic Winter Games",
            "Mario & Sonic at the Rio 2016 Olympic Games (2016)",
            "Waku Waku Sonic Patrol Car",
            "SegaSonic Cosmo Fighter",
            "Sonic Drift",
            "Sonic Drift 2",
            "Sonic R",
            "Sonic Riders",
            "Sonic Rivals",
            "Sonic Rivals 2",
            "Sonic Riders: Zero Gravity",
            "Sonic & Sega All-Stars Racing",
            "Sonic Free Riders",
            "Sonic & All-Stars Racing Transformed",
            "Sonic Forces: Speed Battle",
            "Wacky Worlds Creativity Studio",
            "Tails and the Music Maker",
            "Sonic the Hedgehog's Gameworld",
            "Sonic's Schoolhouse",
            "Sonic X",
            "Sonic the Fighters",
            "Sonic Battle",
            "Super Smash Bros. Brawl",
            "Super Smash Bros. for Nintendo 3DS and Wii U",
            "Sonic Battle",
            "Sonic Chronicles: The Dark Brotherhood",
            "Mario & Sonic at the Olympic Winter Games",
            "Mario & Sonic at the London 2012 Olympic Games",
            "Sonic Dash",
            "Sonic Runners",
            "Sonic Dash 2: Sonic Boom",
            "Sonic Runners Adventure",
            "Sonic the Hedgehog 3D Chess",
            "Sonic Monopoly",
            "Sonic Boom Monopoly",
            "Sonic the Hedgehog Spinball",
            "Dr. Robotnik's Mean Bean Machine",
            "Sonic 2 in 1",
            "Sonic Compilation",
            "Sonic CD",
            "Sonic 3D Blast: Flickies' Island",
            "Sonic Blast",
            "Sonic & Knuckles Collection",
            "Sonic Jam",
            "Sonic R",
            "Sonic the Hedgehog Pocket Adventure",
            "Sonic Adventure 2: Battle",
            "Sonic Mega Collection",
            "Sonic N",
            "Sonic Adventure DX: Director's Cut",
            "Sonic Heroes",
            "Sonic Gems Collection",
            "Sonic the Hedgehog Genesis",
            "Sega Genesis Collection",
            "Sonic's Ultimate Genesis Collection",
            "Sonic Classic Collection",
            "Sonic & Sega All-Stars Racing Arcade",
            "Sonic the Fighters",
            "3D Sonic the Hedgehog",
            "Sonic the Hedgehog",
            "Sonic the Hedgehog 2",
            "3D Sonic the Hedgehog 2",
            "Sega 3D Classics Collection",
            "Team Sonic Racing",
            "Super Smash Bros. Ultimate",
            "Sega Heroes"
          ],
          "zone": [
            "Aerobase Zone",
            "Angel Island Zone",
            "Aqua Lake Zone",
            "Aqua Planet Zone",
            "Aquatic Relix Zone",
            "Aquatic Ruin Zone",
            "Atomic Destroyer Zone",
            "Azure Lake Zone",
            "Balloon Park Zone",
            "Beach Zone",
            "Blue Coast Zone",
            "Blue Marine Zone",
            "Blue Ridge Zone",
            "Blue Sky Zone",
            "Bonus Zone",
            "Boss Attack Zone",
            "Bridge Zone",
            "Carnival Night Zone",
            "Carrier Zone",
            "Casino Night Zone",
            "Casino Paradise Zone",
            "Casino Street Zone",
            "Chaotic Inferno Zone",
            "Chaotic Space Zone",
            "Chemical Plant Zone",
            "Chrome Gadget Zone",
            "Colosseum Highway Zone",
            "Cosmic Angel Zone",
            "Cosmic Casino Zone",
            "Cosmic Zone",
            "Crystal Egg Zone",
            "Crystal Mountain Zone",
            "Cyber City Zone",
            "Death Egg Zone",
            "Death Egg mk.II Zone",
            "Death Yard Zone",
            "Desert Palace Zone",
            "Diamond Dust Zone",
            "Dust Hill Zone",
            "E.G.G. Station Zone",
            "Egg Gauntlet Zone",
            "Egg Reverie Zone",
            "Egg Rocket Zone",
            "Electric Egg Zone",
            "Emerald Hill Zone",
            "Endless Mine Zone",
            "Final Zone",
            "Flying Battery Zone",
            "Forest Falls Zone",
            "Frontier Canyon Zone",
            "Gene Gadget Zone",
            "Genocide City Zone",
            "Gigalopolis Zone",
            "Gigantic Angel Zone",
            "Gimmick Mountain Zone",
            "Great Turquoise Zone",
            "Green Grove Zone",
            "Green Hill Zone",
            "Green Hills Zone",
            "Hidden Palace Zone",
            "Hill Top Zone",
            "Hydrocity Zone",
            "Ice Mountain Zone",
            "IceCap Zone",
            "Jungle Zone",
            "Labyrinth Zone",
            "Last Utopia Zone",
            "Launch Base Zone",
            "Lava Reef Zone",
            "Lost Labyrinth Zone",
            "Mad Gear Zone",
            "Marble Garden Zone",
            "Marble Zone",
            "Mecha Green Hill Zone",
            "Mechanical Zone",
            "Meta Junglira Zone",
            "Metallic Madness Zone",
            "Meteor Base Zone",
            "Metropolis Zone",
            "Mirage Saloon Zone",
            "Mountain Zone",
            "Mushroom Hill Zone",
            "Mystic Cave Zone",
            "Mystic Haunt Zone",
            "Nature Zone",
            "Neo Green Hill Zone",
            "Neo South Island Zone",
            "Neon Palace Zone",
            "Nightmare Zone",
            "Oil Desert Zone",
            "Oil Ocean Zone",
            "Panic Puppet Zone",
            "Press Garden Zone",
            "Proto Palace Zone",
            "Red Volcano Zone",
            "Robotnik Winter Zone",
            "Rusty Ruin Zone",
            "Sandopolis Zone",
            "Scrambled Egg Zone",
            "Scrap Brain Zone",
            "Seaside Hill Zone",
            "Secret Base Zone",
            "Secret Plant Zone",
            "Silver Castle Zone",
            "Sky Base Zone",
            "Sky Chase Zone",
            "Sky Fortress Zone",
            "Sky High Zone",
            "Sky Park Zone",
            "Sky Sanctuary Zone",
            "Sleeping Egg Zone",
            "Splash Hill Zone",
            "Spring Stadium Zone",
            "Spring Yard Zone",
            "Star Light Zone",
            "Stardust Speedway Zone",
            "Studiopolis Zone",
            "Sunset Forest Zone",
            "Sunset Park Zone",
            "Sylvania Castle Zone",
            "Temple Zone",
            "The Doomsday Zone",
            "The Legend of Zelda Zone",
            "The Moon Zone",
            "Tidal Plant Zone",
            "Titanic Monarch Zone",
            "Turquoise Hill Zone",
            "Under Ground Zone",
            "Volcano Valley Zone",
            "White Park Zone",
            "Wing Fortress Zone",
            "Wood Zone",
            "X-Zone",
            "Yellow Desert Zone",
            "Yoshi's Island Zone"
          ]
        },
        "street_fighter": {
          "characters": [
            "Abel",
            "Abigail",
            "Adon",
            "Akuma",
            "Alex",
            "Balrog",
            "Birdie",
            "Blanka",
            "C. Viper",
            "Cammy",
            "Charlie",
            "Chun-Li",
            "Cody",
            "Dan",
            "Decapre",
            "Dee Jay",
            "Dhalsim",
            "Dudley",
            "E. Honda",
            "Eagle",
            "Ed",
            "El Fuerte",
            "Elena",
            "Evil Ryu",
            "F.A.N.G",
            "Falke",
            "Fei Long",
            "G",
            "Gen",
            "Gill",
            "Gouken",
            "Guile",
            "Guy",
            "Hakan",
            "Hugo",
            "Ibuki",
            "Ingrid",
            "Juli",
            "Juni",
            "Juri",
            "Kage",
            "Karin",
            "Ken",
            "Kolin",
            "Laura",
            "Lucia",
            "M. Bison",
            "Maki",
            "Makoto",
            "Menat",
            "Necalli",
            "Necro",
            "Oni",
            "Oro",
            "Poison",
            "Q",
            "R. Mika",
            "Rashid",
            "Remy",
            "Rolento",
            "Rose",
            "Rufus",
            "Ryu",
            "Sagat",
            "Sakura",
            "Sean",
            "Seth",
            "Shin Akum",
            "Sodom",
            "T. Hawk",
            "Twelve",
            "Urien",
            "Vega",
            "Violent Ken",
            "Yang",
            "Yun",
            "Zangief",
            "Zeku"
          ],
          "moves": [
            "A.X.E.",
            "Abare Tosanami",
            "Abigail Punch",
            "Abigail Smash",
            "Abigail Special",
            "Absolute Zero",
            "Aegis Reflector",
            "Aeolus Edge",
            "Aerial Russian Slam",
            "Air Knee Smash",
            "Air Slasher",
            "Air Stampede",
            "Air Taunt",
            "Airbone Eagle Spike",
            "Airborne Dankukyaku",
            "Airborne Jaguar Kick",
            "Airborne Snake Strike",
            "Ajaratengu",
            "Alegrias",
            "Altair",
            "Angry Charge",
            "Annihilate Sword",
            "Arakuma Inashi",
            "Ascension",
            "Ashikari",
            "Ashura Senku",
            "Assault Roll",
            "Atomic Suplex",
            "Aura Soul Spark",
            "Aura Soul Spark Due",
            "Aura Soul Throw",
            "Aurora Spin Edge",
            "Avalanche Press",
            "Avant Line",
            "Axle Spin Knuckle",
            "B3",
            "Back Crusher",
            "Back Slash",
            "Back-Carry Throw",
            "Backstep Roll",
            "Bad Spray",
            "Bad Stone",
            "Bandit Chain",
            "Banishing Flat",
            "Batsuzan Gaisei",
            "Bay Area Sunrise",
            "Beak Assault",
            "Bean Ball",
            "Big Bang Typhoon",
            "Big Boot",
            "Birdie Time",
            "Bison Warp",
            "Black Widow",
            "Blitz Combination",
            "Bloody High Claw",
            "Bloody Kiss",
            "Bloody Rain",
            "Blue Nocturne",
            "Bolshoi Russian Suplex",
            "Bolt Charge",
            "Boomerang Raid",
            "Borscht Dynamite",
            "Brave Dance",
            "Break",
            "Break Dive",
            "Break Time",
            "Breathless",
            "Brimstone",
            "Brutal Impact",
            "Buffalo Headbutt",
            "Buffalo Pressure Crazy Rush",
            "Buffalo Swing",
            "Bull Head",
            "Bull Horn",
            "Bull Revenger",
            "Bullet Clear",
            "Burning Dance",
            "Burning Fight",
            "Burning Kick",
            "Burst Heel",
            "Burst Time",
            "Bursting Buffalo",
            "Bushin Bakujasho",
            "Bushin Gekirinchu",
            "Bushin Gokusaken",
            "Bushin Gokusanage",
            "Bushin Gokusanken Ni",
            "Bushin Gokusanken San",
            "Bushin Gokusanken Shu",
            "Bushin Goraikyaku",
            "Bushin Goraisenpujin",
            "Bushin Gram Ban",
            "Bushin Gram Koku",
            "Bushin Gram Teki",
            "Bushin Guraiha",
            "Bushin Hasoken",
            "Bushin Izuna Otoshi",
            "Bushin Jakura",
            "Bushin Kirinkyaku",
            "Bushin Muso Renge",
            "Bushin Sangoku Otoshi",
            "Bushin Seiryukyaku",
            "Bushin Senpukyaku",
            "Bushin Shidenkyaku",
            "Bushin Sho",
            "Bushin Soukosou",
            "Bushin Tengen",
            "Bushinryu Shingekiko",
            "Butsu-metsu Buster",
            "Byakko Soshoda",
            "C'mon",
            "Cage Climb",
            "Cancel",
            "Cannon Revenge",
            "Cannon Spike",
            "Cannon Strike",
            "Canterbury Blue",
            "Capture & Deadly Blow",
            "Cartwheel",
            "Ceremony of Honor",
            "Change of Direction",
            "Charging Buffalo",
            "Chariot Tackle",
            "Choke Sleeper",
            "Choke Whip",
            "Climax Beat",
            "Clouded Mirror",
            "Cold Blue Kick",
            "Condor Dive",
            "Condor Spire",
            "Corkscrew Blow",
            "Corkscrew Cross",
            "Cosmic Heel",
            "Coward Crouch",
            "Crack Kick",
            "Crazy Buffalo",
            "Crime Sway",
            "Criminal Punisher",
            "Criminal Upper",
            "Crimson Crucify",
            "Crimson Terror",
            "Critical Combo Attack",
            "Cross Counter",
            "Cross Scissors Pressure",
            "Cross Stinger Assault",
            "Crossfire Blitz",
            "Cruel Disaster",
            "Culminated Power",
            "Cyber Lariat",
            "Cyclone Lariat",
            "D.R.A.",
            "DCM",
            "Daikyo Burning",
            "Dangerous Headbutt",
            "Dangerous President",
            "Dankukyaku",
            "Danretsuken",
            "Dash Eagle Spike",
            "Dash Low Smash",
            "Dash Low Straight",
            "Dash Spinning Mixer",
            "Dash Straight",
            "Dash Swing Blow",
            "Dash Upper",
            "Dashing Head Attack",
            "Dashing Leg Attack",
            "Dashing Straight",
            "Daydream Headlock",
            "Dead End Irony",
            "Deadly Double Combination",
            "Death Cross Dance",
            "Death Flutter",
            "Delta Advance",
            "Delta Ambush",
            "Delta Drive",
            "Delta Step",
            "Delta Twist",
            "Demon Armageddon",
            "Denjin Hadoken",
            "Denjin Renki",
            "Devil Reverse",
            "Diamond Body",
            "Diamond Dust",
            "Dirty Bull",
            "Dirty Coach",
            "Dohatsu Shoten",
            "Dokunomu",
            "Dominant Crush",
            "Double Dread Kick",
            "Double Flash",
            "Double Kick",
            "Double Knee Press",
            "Double Lariat",
            "Double Slap",
            "Double Typhoon",
            "Dragon Smash",
            "Drop Back",
            "Drop Kick",
            "Dynamic Rolling",
            "Dynamite Punch",
            "Dynasty Dash",
            "EX Yoga Teleport",
            "Eagle Spike",
            "Earth Direct",
            "Easifa",
            "Easy Step",
            "El Fuerte Dynamite",
            "El Fuerte Flying Giga Buster",
            "El Fuerte Ultra Spark",
            "Elbow Drop",
            "Elbow Drop/Hiji Otoshi",
            "Electric Blaster",
            "Electric Snake",
            "Electric Thunder",
            "Emergency Combination",
            "Enchilada Jump",
            "Enhanced Snatcher",
            "Enjoy Time",
            "Eruption of Power",
            "Evil Stomp",
            "Fajita Buster",
            "Falling Arc",
            "Falling Sky",
            "Fatal Leg Twister",
            "Feng Shui Engine",
            "Feng Shui Engine Beta",
            "Feng Shui Engine type alpha",
            "Fightin' Dirty",
            "Final Atomic Buster",
            "Final Combination",
            "Final Destruction",
            "Fire Spinner",
            "Fire Squall",
            "Firecracker",
            "Flap Spin",
            "Flash Chop",
            "Flash Explosion",
            "Flash Kick",
            "Flower Kick",
            "Flying Barcelona Attack",
            "Flying Barcelona Special",
            "Flying Body Press",
            "Flying Cross Chop",
            "Flying Nachos",
            "Flying Oil Spin",
            "Flying Peach",
            "Flying Power Bomb",
            "Flying Viper",
            "Forbidden Shoryuken",
            "Fox Tail",
            "Front Flip",
            "Frost Edge",
            "Frost Touch",
            "Frost Tower",
            "Fudoshin",
            "Fuha Enzan",
            "Fuhajin",
            "Fuharenjin",
            "Fuharenkyaku",
            "Fuji Drop",
            "Fuji Otoshi",
            "Fukiage",
            "Fukuma Gohado",
            "Fukuro",
            "Fuma Shuriken",
            "Fusatsusen",
            "G Barrier",
            "G Burst",
            "G Charge",
            "G Explosion",
            "G Impact",
            "G Rage",
            "G Revenge",
            "G Smash Over",
            "G Smash Under",
            "G Spin Kick",
            "Gadoken",
            "Galactic Tornado",
            "Gekirinken",
            "Gekiro",
            "Gekkou",
            "Genei Jin",
            "Genko",
            "Gentle Swing",
            "German Suplex",
            "Giant Flip",
            "Giant Palm Bomber",
            "Gigas Breaker",
            "Gigaton Blow",
            "Giraffe Neck",
            "Gohadoken",
            "Gorai Hadoken",
            "Goshoryuken",
            "Grand Izuna Drop",
            "Ground Shave Roll",
            "Guacamole Leg Throw",
            "Guardian of the Sun",
            "Gun Smoke",
            "Guren Enjinkyaku",
            "Guren Ken",
            "Guren Senpukyaku",
            "Gyro Drive Smasher",
            "Habanero Back Dash",
            "Habanero Dash",
            "Hado Burst",
            "Hadoken",
            "Hadosho",
            "Hailstorm",
            "Hammer Knuckle",
            "Hammer Mountain",
            "Hanagashi",
            "Hanagasumi",
            "Hanging Chain",
            "Haoh Gadoken",
            "Hard Hit Knee",
            "Haru Arashi",
            "Haru Ichiban",
            "Haru Kaze",
            "Haru Ranman",
            "Hashinsho",
            "Hassou Tobi",
            "Hassoukyaku",
            "Hayagake",
            "Hayate",
            "Hazan Tenshou Kyaku",
            "Hazanshu",
            "Head Crush",
            "Head Press",
            "Healing",
            "Heart Raid",
            "Heart of Gold",
            "Heartless",
            "Heat Rush",
            "Heavenly Dynamite",
            "Heavy Hammer",
            "Hecatoncheires",
            "Hell Attack",
            "Hidden Dive",
            "Hien",
            "High Speed Barrage",
            "Hissho Buraiken",
            "Hitobashira Nobori",
            "Honey Trap",
            "Honshin",
            "Hooligan Combination",
            "Horn Breaker",
            "Hosenka",
            "Hou Shou",
            "Houyoku Sen",
            "Hozanto",
            "Hundred Hand Slap",
            "Hungabee",
            "Hurricane Spinner",
            "Hyakkishu",
            "Hyakurenko",
            "Hyakuretsukyaku",
            "Hybrid Charge",
            "Hyper Bomb",
            "Hyper Tornado",
            "Idaten",
            "Illusion Spark",
            "Inazuma Spin Hold",
            "Insanity Gaze",
            "Inside Slash",
            "Invisible Ray",
            "Iron Muscle",
            "Isana",
            "Isshin",
            "Izuna Drop",
            "Jackknife Maximum",
            "Jaguar Avalanche",
            "Jaguar Crunch",
            "Jaguar Kick",
            "Jaguar Revolver",
            "Jaguar Tooth",
            "Jaguar Varied Assault",
            "Jaw Crusher",
            "Jet Upper",
            "Jigoku Scrape",
            "Jinchuu Watari",
            "Jiraiya",
            "Joudan Sokutogeri",
            "Judgement Saber",
            "Judgement of Thoth",
            "Jungle Dynamo",
            "Justice Corridor",
            "Justice Shell",
            "Jyafuten",
            "Jyakoha",
            "Jyasen",
            "KKB",
            "Kachofugetsu",
            "Kaeshi Saiha",
            "Kaeshi Urasaiha",
            "Kagenui",
            "Kagerou",
            "Kaihou",
            "Kaisen Dankairaku",
            "Kaisenrenkyaku",
            "Kaiten Izuna Otoshi",
            "Kakko Fubatsu",
            "Kamabaraigeri",
            "Kamaitachi",
            "Kamigashima",
            "Kanzuki-Ryu Guren No Kata",
            "Kanzuki-Ryu Hadorokushiki Hasha no Kata",
            "Kanzuki-Ryu Hokojutsu Seppo",
            "Kanzuki-ryuu Kou'ou Ken",
            "Kanzuki-ryuu Shinpikaibyaku",
            "Karakusa",
            "Kasatsushu",
            "Kasatushi",
            "Kashinfu",
            "Kasumi Gake",
            "Kasumi Suzaku",
            "Katapult",
            "Kazekiri",
            "Kikoken",
            "Kikosho",
            "Kill Step",
            "Killer Bee Assault",
            "Killer Bee Stinger",
            "Killer Choke Whip",
            "Killer Scythe Kick",
            "Killing Head",
            "Kimonkai",
            "Kishin Riki",
            "Kishin Tsui",
            "Kissed by a Goddess",
            "Knee Bullet",
            "Knee Drop",
            "Knee Press Nightmare",
            "Knee Slam",
            "Knife Edge",
            "Knife Pickup",
            "Kobokushi",
            "Kongoshin",
            "Kongou Kokuretsuzan",
            "Koryo Dokuda",
            "Koryuken",
            "Koryuu Rekka",
            "Koten Okiagari",
            "Kouga",
            "Kubi Kudaki",
            "Kunai",
            "Kunai Hoju",
            "Kunai Ikkinage",
            "Kurekijin",
            "Kuuchuu Tatsumaki Senpukyaku",
            "Kuzuryu Reppa",
            "Kyoseijin",
            "Last Dread Dust",
            "Left Eye of the Lion",
            "Legendary Taunt",
            "Lift Combination",
            "Lift Upper",
            "Light of Justice",
            "Light of Virtue",
            "Lightning Beast",
            "Lightning Cannonball",
            "Lightning Grenade",
            "Lightning Mole",
            "Linear Movement",
            "Linear Movement Avante",
            "Linear Movement Esquiva",
            "Linear Movement Finta",
            "Liverpool White",
            "Love Hurricane",
            "Love Me Tender",
            "Love Storm",
            "Lynx Tail",
            "Mach Back Knuckle",
            "Mach Slide",
            "Machine Gun Upper",
            "Machinegun Blow",
            "Mad Cradle",
            "Magnetic Storm",
            "Mallet Smash",
            "Manchester Black",
            "Manchester Gold",
            "Marseilles Roll",
            "Mask of Tlalli",
            "Matador Turn",
            "Matsuda Sway",
            "Max Power",
            "Maximum President",
            "Meat Squasher",
            "Mega Crash",
            "Megaton Press",
            "Meido Gohado",
            "Meido no Miyage",
            "Meioken",
            "Mekong Delta Air Raid",
            "Mekong Delta Attack",
            "Mekong Delta Escape",
            "Message To The People",
            "Messatsu Gohado",
            "Messatsu Gorasen",
            "Messatsu Goshoryu",
            "Messatsu Gou Hadou",
            "Messatsu Gou Rasen",
            "Messatsu Gou Senpuu",
            "Messatsu-Goshoryu",
            "Messiah Kick",
            "Metallic Aura",
            "Metallic Sphere",
            "Meteor Strike",
            "Metro Crash",
            "Metsu Hadoken",
            "Metsu Shoryuken",
            "Mexican Typhoon",
            "Mic Performance",
            "Midare Zakura",
            "Mikoshi",
            "Mind's Eye",
            "Mine Sweeper",
            "Misogi",
            "Monster Lariat",
            "Moonsault Knee Drop",
            "Moonsault Press",
            "Moonsault Slash",
            "Mu",
            "Mujinkyaku",
            "Murderer Chain",
            "Mythical Taunt",
            "N.D.L.",
            "Nadeshiko",
            "Nail Assault",
            "Neck Breaker",
            "Nefertem",
            "Nekketsu Hadoken",
            "Nichirin Shou",
            "Nightmare Booster",
            "Nikaiho",
            "Nikyoushu Nikankyaku",
            "Niou Riki",
            "Nirenko",
            "Nishikyu",
            "Nishodoku",
            "Nishokyaku",
            "Nitro Charge",
            "No Mercy",
            "Nouten Wari",
            "Oga",
            "Oicho Throw",
            "Oil Coaster",
            "Oil Combination Hold",
            "Oil Dive",
            "Oil Rocket",
            "Oil Shower",
            "Oil Slide",
            "Okakyaku",
            "Oni Muso",
            "Oni Yanma",
            "Ontario Drop",
            "Opening Dagger",
            "Opening Gambit",
            "Orochi",
            "Orochi Breaker",
            "Orochi Crush",
            "Oroshi",
            "Otoko Michi",
            "Oukakyaku",
            "Overhaul",
            "Oxford Red",
            "Oyokukyaku",
            "Pangaea Burst",
            "Parabellum",
            "Paradise Hold",
            "Patriot Circle",
            "Patriot Sweeper",
            "Peach Assault",
            "Peach Gator",
            "Peerless Palm",
            "Pendulum Upper",
            "Perfume Swing",
            "Poison Cocktail",
            "Poison Kiss",
            "Poison Rana",
            "Power Bomb",
            "Power Drop",
            "Premium Tackle",
            "Prophecy of Thoth",
            "Psycho Angriff",
            "Psycho Barrage",
            "Psycho Blast",
            "Psycho Cannon",
            "Psycho Charge",
            "Psycho Charge Alpha",
            "Psycho Charge Beta",
            "Psycho Charge Gama",
            "Psycho Crusher",
            "Psycho Crusher Omega",
            "Psycho Feder",
            "Psycho Field",
            "Psycho Flicker",
            "Psycho Fluegel",
            "Psycho Headbutt",
            "Psycho Inferno",
            "Psycho Jaeger",
            "Psycho Judgement",
            "Psycho Kanonen",
            "Psycho Klinge",
            "Psycho Knuckle",
            "Psycho Kugel",
            "Psycho Nightmare",
            "Psycho Panzer",
            "Psycho Power",
            "Psycho Punisher",
            "Psycho Reflect",
            "Psycho Rising",
            "Psycho Roll",
            "Psycho Schneide",
            "Psycho Sever",
            "Psycho Shield",
            "Psycho Shot",
            "Psycho Shrot",
            "Psycho Snatcher",
            "Psycho Spark",
            "Psycho Splash",
            "Psycho Sting",
            "Psycho Streak",
            "Psycho Stream",
            "Psycho Sturm",
            "Psycho Transaction",
            "Psycho Trombe",
            "Psycho Upper",
            "Psycho Vanish",
            "Pyrokinesis/Cryokinesis",
            "Quick Rolling",
            "Quick Spin Knuckle",
            "Quick Step",
            "Rage Boost",
            "Rage Shift",
            "Raging Demon",
            "Raging Light",
            "Raging Slash",
            "Raging Typhoon",
            "Raida",
            "Raiju",
            "Raikou Nataotoshi",
            "Rainbow Hip Rush",
            "Rainbow Typhoon",
            "Raishin Mahhaken",
            "Rakan",
            "Rakan Dantojin",
            "Rakuyo Hadoken",
            "Rankyaku",
            "Rapid Dagger",
            "Rapid Fire",
            "Rasetsu Kyaku",
            "Razor Edge Slicer",
            "Red Impact",
            "Rekkaken",
            "Rekkashingeki",
            "Rekkashinken",
            "Rekkukyaku",
            "Remove Claw/Mask",
            "Rengeki Tourouha",
            "Renkiko",
            "Reppu Hadoken",
            "Reppukyaku",
            "Ressen Chou",
            "Ressen Ha",
            "Resurrection",
            "Reverse Edge",
            "Reverse Javelin",
            "Reverse Shaft Breaker",
            "Rhino Horn",
            "Rikudo Osatsu",
            "Rising Cobra",
            "Rising Jaguar",
            "Rising Rage Flash",
            "Road of the Sun",
            "Rochumou",
            "Rocket Upper",
            "Rodeo Break",
            "Rokushaku Horokudama",
            "Roll",
            "Rolling Attack",
            "Rolling Crystal Flash",
            "Rolling Izuna Drop",
            "Rolling Kick",
            "Rolling Taunt",
            "Rolling Thunder",
            "Rose Thorn",
            "Roundhouse Kick",
            "Ruffian Kick",
            "Russian Stomping",
            "Ryobenda",
            "Ryodansatsu",
            "Ryubi Kyaku",
            "Ryukoha",
            "Ryukosai",
            "Ryuogeki",
            "Ryusokyaku",
            "Ryuu Yassai",
            "Sacrificial Altar",
            "Saikyo Defense",
            "Saikyo Tenjinsai",
            "Saka Hayagake",
            "Sakkai Fuhazan",
            "Sakura Fubuki",
            "Sakura Otoshi",
            "Sakura Rain",
            "Sakura Senpu",
            "Salt Toss",
            "Sankaku Tobi",
            "Sardine Beach Special",
            "Scarlet Mirage",
            "Scarlet Terror",
            "Scramble",
            "Scratch Wheel",
            "Sean Tackle",
            "Seichusen Godanzuki",
            "Seiei Enbu",
            "Seismic Hammer",
            "Sekia Kuretsuha",
            "Sekieiken",
            "Sekisei Jiraiken",
            "Sekku",
            "Sen'en Shuu",
            "Senha Kassatsu",
            "Senha Kusabi",
            "Senha Resshu",
            "Senkugoshoha",
            "Senkyutai",
            "Senpu Nataotoshi",
            "Senpukuga",
            "Senpusha",
            "Senretsukyaku",
            "Seraphic Wing",
            "Setsunasen",
            "Shadow Needle",
            "Shakunetsu Hadoken",
            "Shichisei Senkuu Kyaku",
            "Shien Renkyaku",
            "Shienkyaku",
            "Shikusen",
            "Shin Shoryuken",
            "Shinbu Messatsu",
            "Shinku Gadoken",
            "Shinku Hadoken",
            "Shinku Tatsumaki Senpukyaku",
            "Shinku Tengyo Hadoken",
            "Shinryuken",
            "Shippu Jinraikyaku",
            "Shiraha Catch",
            "Shishigari",
            "Shishiruirui",
            "Shishisho",
            "Shisso Buraiken",
            "Shitenketsu",
            "Shitenshuu",
            "Shock Choke",
            "Shock Stance",
            "Shocking Heel",
            "Shoenryu",
            "Shootdown Backbreaker",
            "Shooting Peach",
            "Short Back Slash",
            "Short Swing Blow",
            "Shoryu Cannon",
            "Shoryuken",
            "Shoryureppa",
            "Shotenha",
            "Shoulder Tackle",
            "Shouoken",
            "Shout of Earth",
            "Shukuchi Rimon Chochu",
            "Shukumyo",
            "Shun Goku Satsu",
            "Shunka Shuutou",
            "Shunpukyaku",
            "Shunpurenkyaku",
            "Shura Rengoku",
            "Siberian Blizzard",
            "Siberian Express",
            "Side Arm",
            "Silver Edge",
            "Skip To My Chain",
            "Sky High Claw",
            "Slam Dance",
            "Slash Elbow",
            "Sledge Hammer",
            "Sliding Roll",
            "Snake Fang",
            "Snake Strike",
            "Sobat Carnival",
            "Sobat Festival",
            "Solid Puncher",
            "Somersault Justice",
            "Somersault Strike",
            "Sonic Boom",
            "Sonic Break",
            "Sonic Cross",
            "Sonic Hurricane",
            "Sonic Move",
            "Sonic Scythe",
            "Sonic Tempest",
            "Sonic Typhoon",
            "Sorai Rengeki",
            "Sotoja",
            "Sou Hakkei",
            "Soul Illusion",
            "Soul Offering",
            "Soul Passing",
            "Soul Piede",
            "Soul Reflect",
            "Soul Reflect: Kamal",
            "Soul Reflect: Stella",
            "Soul Satellite",
            "Soul Spark",
            "Soul Sphere",
            "Soul Sphere: Ankh",
            "Soul Spiral",
            "Soul Throw",
            "Soulless",
            "Space Opera Symphony",
            "Spark Show",
            "Spectacle Romance",
            "Spin Drive Smasher",
            "Spin Scythe",
            "Spinning Arrow",
            "Spinning Attack",
            "Spinning Beat",
            "Spinning Bird Kick",
            "Spinning Mixer",
            "Spinning Piledriver",
            "Spinning Piledriver Special",
            "Spiral Arrow",
            "Spiral DDT",
            "Splendid Claw",
            "Split River",
            "St. Andrew's Green",
            "Staerken",
            "Stealth Dash",
            "Steel Chair",
            "Steel Rain",
            "Steel Saber",
            "Stinger",
            "Strafe Dagger",
            "Strike Back",
            "Strike Eagle",
            "Stun Gun Headbutt",
            "Sumo Headbutt",
            "Sumo Smash",
            "Sun Arch",
            "Sun Delta",
            "Sun Dive",
            "Sun Lower",
            "Sun Upper",
            "Sunburst",
            "Sunrise",
            "Sunset Wheel",
            "Sunshine",
            "Sunshot",
            "Super Cage Climb",
            "Super Killer Head Ram",
            "Supreme Rising Rage Flash",
            "Switching Claw",
            "Sylph Amulet",
            "Taigyaku Mudo",
            "Take No Prisoners",
            "Tanden Booster",
            "Tanden Destruction",
            "Tanden Engine",
            "Tanden Extreme",
            "Tanden Ignition",
            "Tanden Maneuver",
            "Tanden Renki",
            "Tanden Storm",
            "Tanden Stream",
            "Tanden Typhoon",
            "Tap-Kick",
            "Target Strike",
            "Tatsumaki",
            "Tatsumaki Gorasen",
            "Tatsumaki Senpukyaku",
            "Tatsumaki Zankukyaku",
            "Teiga",
            "Temporal Thunder",
            "Tenchi Sokaigen",
            "Tenchuu Satsu",
            "Tengu Daoshi",
            "Tengu Midareishi",
            "Tengu Stone",
            "Tengu Walking",
            "Tengyo Hadoken",
            "Tenha No Kata",
            "Tenko",
            "Tenma Gou Zankuu",
            "Tenma Gozanku",
            "Tenma Hadoken",
            "Tenma Shurettou",
            "Tenmakujinkyaku",
            "Tenmarakuseikyaku",
            "Tenpo Kari",
            "Tenrai",
            "Tensei Ranka",
            "Tensenrin",
            "Tenshin",
            "Tenshin Senkyutai",
            "Tenshokyaku",
            "Tesshin",
            "Tesshinhou",
            "Tesso",
            "Tetsuzanko",
            "The Birdie",
            "The Calling",
            "The Disc's Guidance",
            "Third Eye",
            "Thrust Strike",
            "Thunder Clap",
            "Thunder Fist",
            "Thunder Knuckle",
            "Thunder Whip",
            "Thunderbolt",
            "Tiger Assault",
            "Tiger Cannon",
            "Tiger Charge",
            "Tiger Claw",
            "Tiger Destruction",
            "Tiger Genocide",
            "Tiger Knee",
            "Tiger Raid",
            "Tiger Rampage",
            "Tiger Rush",
            "Tiger Shot",
            "Tiger Spike",
            "Tiger Uppercut",
            "Tojushu",
            "Tomahawk Buster",
            "Tornado",
            "Tornado Hook",
            "Tornado Spinner",
            "Tornado Sweep",
            "Tornado Throw",
            "Torrent of Power",
            "Toss & Smash",
            "Tostada Press",
            "Total Destruction",
            "Tourouzan",
            "Toushi",
            "Toxic Bind",
            "Toxic Glamor",
            "Toxic Hold",
            "Tozetsu",
            "Tragedy Assault",
            "Tropical Hazard",
            "Tsujigoe",
            "Tsumuji",
            "Tsurigane Otoshi",
            "Tsurugi",
            "Turn Punch",
            "Tyrant Pressure",
            "Tyrant Slaughter",
            "Ultimate Atomic Buster",
            "Ultimate Killer Head Ram",
            "Ultimate Psycho Crusher",
            "Ultra Snatcher",
            "Ultra Throw",
            "Union Jack Platinum",
            "Urakagerou",
            "Utsusemi",
            "Valiant Rebellion",
            "Vanity Step",
            "Vertical Roll",
            "Victory Column",
            "Violence Knee Drop",
            "Violent Buffalo",
            "Viper Blade",
            "Viper Elbow",
            "Volty Line",
            "Wall Jump",
            "Weapon Fury",
            "Wheel Kick",
            "Whip of Love",
            "Whirlwind Shot",
            "Wild Hunt",
            "Wingless Airplane",
            "Wisdom of Thoth",
            "Wrath of the Raging Demon",
            "X.C.O.P.Y.",
            "X.F.L.A.T.",
            "X.N.D.L.",
            "Yagura Reverse",
            "Yagyou Dama",
            "Yagyou-Odama",
            "Yami Shigure",
            "Yasha Gaeshi",
            "Yoga Blast",
            "Yoga Bringer",
            "Yoga Burner",
            "Yoga Catastrophe",
            "Yoga Escape",
            "Yoga Fire",
            "Yoga Flame",
            "Yoga Float",
            "Yoga Gale",
            "Yoga Inferno",
            "Yoga Legend1",
            "Yoga Sansara",
            "Yoga Shangri-La",
            "Yoga Stream",
            "Yoga Strike",
            "Yoga Sunburst",
            "Yoga Teleport",
            "Yoga Tempest",
            "Yoga Volcano",
            "Yoroitoshi",
            "You Hou",
            "Ysaar",
            "Zan'ei",
            "Zanku Hadoken",
            "Zanku Hadosho",
            "Zenpou Tenshin",
            "Zenten",
            "Zesshou Hohou",
            "Zetsuei",
            "Zonk Knuckle",
            "Zugai Hasatsu",
            "Zuri Fugaku"
          ],
          "quotes": [
            "Go home and be a family man.",
            "On the battlefield its important to retreat at the first sign of Defeat.",
            "Street fighting is all about analysis, predictions and reaction Thats it.",
            "My adopted father and his friends kept me from being lonley I should be happy.",
            "I need to pick up a dog collar on the way back, I wonder which color is the best?",
            "He has to be somewhere. I must continue my search!",
            "You're strong! You'd make quite a mercenary.",
            "That was a close one listen, do you mind if I ask you about shadaolo?",
            "Sorry, but I don't have time for a rematch. I'm in a hurry right now.",
            "Was it all a dream?",
            "I'm sorry...",
            "Muay Thai is the single most powerful art on the face of the planet!",
            "Like the mighty jaguar, I grow more powerful with each victory!",
            "No one is strong enough to face me! No one!",
            "There is no value in allowing the weak to live!",
            "A new legend is born this day! All hail the mighty Adon!",
            "Feast your eyes on the new King of Muay Thai!",
            "Not bad, but not good enough to dethrone the king!",
            "Annoying worm! Begone with you!",
            "Remember this day, for it is the day you truly understood your own weakness!",
            "I am the king!",
            "Fool!",
            "The true fighter can stare death in the face and lash out in rage against it!",
            "My blows penetrate flesh and contaminate the very bones within!",
            "Never step into the ring unless you are ready to leave this mortal coil!",
            "My destiny is to defeat all challengers who wander the earth!",
            "The moment you challenged me was the moment you sealed your fate!",
            "My fists know no equal!",
            "This battle is not yet over!",
            "The weak do not deserve a rematch, but an open grave bearing their name.",
            "Such pitiful insolence!",
            "Messatsu!",
            "Fool!",
            "Nothin' feels as satisyin' as knockin' chumps out with these here fists!",
            "I'm tired of wastin' my talents on third rate chumps like you!",
            "You should be grateful you even had a chance to step into the ring with me!",
            "So, you go any information I can sell? Spill it before I split your head open!",
            "I don't need nothin' I can't buy with cold, hard cash!",
            "Damn! My fists have your blood on them!",
            "You tried to hit me just now, didn't ya? I'll make you pay for that!",
            "I don't have time to waste on losers like you!",
            "Gimme all your money before I punch your lights out, chump!",
            "Hah ha ha ha ha ha ha",
            "Beat it, chump!",
            "My psycho power feeds on hatred and death!",
            "I demand an opponent worthy of my strength!",
            "When I control the planet, I shall purge it of all hope!",
            "Anyone who defies me willingly invites thier own death!",
            "Close your eyes! An endless nightmare awaits!",
            "Embrace your fear as you are enveloped by an eternal nightmare!",
            "Kneel before me or die beneath my heal. The choice is yours to make freely!",
            "Pledge your allegiance to Shadaloo and I will let you live!",
            "One as weak as you has nothing to offer! Your life ends now!",
            "Kneel before me!",
            "Worm!",
            "The king of the Jungle is the King of the world.",
            "I've gotta get stronger! I can't go home until I'm good enough for my mama!",
            "Until you forget mankind's rules and fight like a beast, you can't beat me!",
            "Crocodiles are good, but I prefer the taste of a nice pirarucu!",
            "I liked living in the jungle, but I'd rather be with my moma now.",
            "You can't defeat me with moves like that!",
            "You're stong! We should hang out!",
            "You didn't keep your mind on the fight. That's why you lost!",
            "I'm stronger than you! I'm better than you!",
            "Ogwow! Oh! Oh!",
            "Arooooo!",
            "Size and strength are no use if you can't hit me.",
            "My friends are not my weakness, but my strength.",
            "You wont get anywhere until you learn a thing or two about fighting.",
            "Off to find my next target!",
            "I'm thinking about adopting a cat when I get home.",
            "How does it feel getting beaten by a tiny girl like me?",
            "A rematch? Maybe some other time when I dont have a mission to worry about.",
            "I've no time to waste teaching amateurs to fight.",
            "Fighting amateurs like you is a waste of my precious time.",
            "Mission accomplshed!",
            "How dreadfully dull!",
            "Keep an eye on my father, I wont let you down.",
            "I feel even stronger than usual. That special training really paid off!",
            "Phew! That was no picinic, I guess I need to build up more muscle mass!",
            "Compared to the scum I deal with as a cop, fighting you was a piece of cake!",
            "I'm tired. Maybe I'll eat some sweets to recharge.",
            "All men bow before me! I'm the strongest woman in the world!",
            "Not bad we should do this again sometime.",
            "You were out of breath towards the end. You need to work on your stamina.",
            "Sorry to be blunt, but you just don't have what it takes to beat me.",
            "Fighting like this brings back lots of memories.",
            "I don't need a reason. I just like to fight.",
            "The only thing that doesnt change, is the excitment of the fight.",
            "This is gettin' boring. Maybe I oughta head home.",
            "I prefer my fights quick an' easy.",
            "I've got time. You up for a rematch?",
            "A fighter that goes down that easy ain't worth a thing. Beat it!",
            "You sure you wanna be goin' around startin' fights with guys like me?",
            "If I'da known it'd be this boring on the outside, I'da stayed in prison.",
            "Let's get this over with.",
            "You were awfully reckless back there. Are you looking to get hazard pay?",
            "If I could change careers, I'd go for something that allows more time at home.",
            "I don't care about pride or ego. I'm just here to do my job.",
            "You should be more careful. There's no worker's comp if you get hurt.",
            "Lauren's birthday is comping up. I wonder what she'd like...",
            "I'm pretty good at the rough studd. Housework, not so much.",
            "You're not bad. You should try to get a contract offer and make some cash.",
            "I'm here for work. I don't have time to mess around with the likes of you!",
            "If you're not going to take this seriously, don't step into the ring.",
            "This is just business. Nothing personal.",
            "What a pain!",
            "Keep an eye on my father, I won't let the Saikyo arts down!",
            "Whoever's still standing wins! I almost tripped, but I didn't, so I win!",
            "I just thought of a great new taunt! Better write it down before I forget!",
            "If you let instant noodles soak long enough, they feel more filling!",
            "Dinner? I usually eat beans fight from the can while standing over the sink.",
            "Underestimating me is a sure fire way to get hurt!",
            "For a second, I thought I might lose...Aw, who am I kidding? I was sure of it!",
            "I stubbed my toe! I hope you have good insurance, bub!",
            "Now you have to join my dojo! Just write your name and credit card number here...",
            "Yahoo!",
            "No problem!",
            "Hey! We're just gettin' started! Stand up and let's go!",
            "Fantastic! Show me that move again!",
            "Are you OK? Was my dance too much for you?",
            "You're not hurt, are you? C'mon! Let's do it again!",
            "No regrets! Don't look back!",
            "Bravo! Feelin' good!",
            "Try not to get knocked out so quick next time, OK?",
            "Not bad!",
            "You've gotta try and feel your inner rhythm more. Like this! Get it?",
            "Feel the rhythm! Feel the rhyme! Get on up, it's Dee Jay time!",
            "OK!",
            "O, Agni, please accpet my humble thanks for the power you have granted me.",
            "I mustn't stop as long as there are forces who seek to do harm.",
            "My purifying flames wash my foes one by one as they fall before me.",
            "The road our souls travel is a long and winding one.",
            "Through meditation, we are able to touch the very fabric of space and time.",
            "You have lost because it was your destiny to do so. Do not resist.",
            "we may worship different gods, but your strength is to be praised.",
            "Give up. Your short limbs have no chance of reaching me.",
            "I do not like to fight without reason. Leave this place at once.",
            "This is destiny.",
            "Yoga yoga yoga yoga.",
            "Boxing is the most refined of the fighting arts.",
            "There is no shortcut to perfection. Hard training is the only way.",
            "There is a difference between refined strength and uncouth violence.",
            "I believe it's tea time now. Please excuse me...",
            "I'm afraid that fine roses are as rare as respectable fighters.",
            "I like you. Please allow me to buy you a pint.",
            "That was an exciting match. You have my gratitude.",
            "There isn't much variety in your routine, is there?",
            "You aren't ready to face me just yet. Contact me once you've trained harder.",
            "You have no dignity!",
            "Down for the count!",
            "I'm just getting started I have'nt showed you half of what I can do!",
            "Nothin' like a good fight to make you feel all warm an' fuzzy inside!",
            "Gah hah ha ha! I love seeing new moves in the ring!",
            "Man, I'm starving! I could go for some chanko stew!",
            "Sumo is fun to watch, but even more fun to try out for yourself!",
            "I'm the best Japan has to offer! And I'm off to conquer the world!",
            "Phew! Not bad! I almost thew in the towel!",
            "You'd better pack on the pounds or I'll be able to knock you over with a touch!",
            "You need to go back and start your training over again, bub!",
            "Victory is mine!",
            "Oh, yeah!",
            "That was one volcanic battle! Thanks for the memories amigo!",
            "Try the frijoles to test a restaurant! Try the special moves to test a fighter!",
            "Fighting is like cebollita! Add a little heat, and it gets a whole lot better!",
            "If you're feeling down, put some color in your cheeks with a bowl of red beets!",
            "How about a nice cactus pear? You can even eat the seeds!",
            "Nothing beats a heaping helping of paella, amigo! Want some?",
            "Looks like I made a new friend! We should go out and eat to celebrate!",
            "That was a great fight! I'll whip up a meal to celebrate! Any requests?",
            "Stay right where you are! I'll let you know when dinner is ready!",
            "Gracias!",
            "Rico!",
            "May the power of Bushin-ryu be etched forever into your retinas!",
            "Bushin-ryu allows me to pierce the sky and split the earth with my blows!",
            "Never attempt the same move after you have been once thwarted!",
            "Most fighters could not have lasted as long as you did.",
            "Sneakers are well-suited to swift-footed techniques!",
            "A restless spirit is no good in battle. Always meditate in preparation for war.",
            "This fight is over! Leave this place at once!",
            "What good is your defense if you cannot keep up with my speed?",
            "I am not your enemy! You must overcome yourself before you take on others!",
            "Sayonara!",
            "This is Bushinryu!",
            "I went easy on ya, amateur. You won't be so lucky next time!",
            "If you like oil, you'll love my brand of cooking oil! Care for a free sample?",
            "Using oil isn't cheating. You're welcome to oil up yourself, you know.",
            "Never fought a Turkish wrestler before? Glad I could enlighten you!",
            "Nothing makes me angrier than smokers. Don't they know fire is dangerous?",
            "No, no Stay down! Don't get up on my account! Just relax!",
            "Don't let it get to you. We all have days like this! You'll feel better soon!",
            "Not bad! But you've got plenty of room for improvement!",
            "Sorry about that! You're not hurt, are ya?",
            "How about some oil?",
            "I guess victory \"slipped\" from your grasp, eh? Wah hah ha ha ha!",
            "You've never seen a kunai throwing knife before? You've got to be kidding me!",
            "No rematch today! I'm in a hurry! Hit me up next time!",
            "Ninjas use to be cool, but now everyone is into pirates and robots and stuff.",
            "If that's the best you can do, you might wanna hire an after school tutor.",
            "I'm starved! what's a girl hafta do to get some cake around here?",
            "You'd flunk outta my ninja school in about 5 minutes...",
            "You're pretty strong! That was really fun!",
            "You should probably head home now. You really don't look so good.",
            "No sweat! That was nothing compared to the tests at my school!",
            "I'm starving!",
            "Train harder!",
            "You'll have to do better than that if you want to get me excited.",
            "Next time, I'll take my time and make things REALLY hurt.",
            "Damn! My eye's acting up! Doesn't matter against a loser like you, though.",
            "Don't think we're finished here. We have all night, baby...",
            "Don't worry. I'll let you live long enough to have a little fun with you.",
            "Learn to fight like me, and you'll realize how boring everything else is.",
            "How does it feel to know that your death is just a few heartbeats away?",
            "I didn't even need to use my eyes for the likes of you!",
            "You'll have to try harder than that. Come at me ready to kill!",
            "Now comes the fun part...",
            "Farewell!",
            "See? The stronger fighter always wins! As easy to understand as a flowchart!",
            "The whole American champion thing seems petty. I should aim even higher!",
            "I could really improve if I could find someone strong enough to beat me!",
            "Uh-oh! I'd better check with Eliza!",
            "Phew! I bet that would make for one exciting replay!",
            "Get back up and I'll just knock you down again!",
            "Not bad! Looks like I just earned myself a new rival!",
            "You know my moves, don't you? Why'd you just walk into 'em like that?",
            "Natural ability is great, but it takes work to use it!",
            "Yeah!",
            "Got it!",
            "Rindo-kan karate is the best! Who's next!",
            "Did you see that, Daddy? I'm gonna fix our dojo up good!",
            "Yeah! Looks like my moves work just as well on real world opponents!",
            "I know I'm still young, but fighters in training really have the desire to win!",
            "I'm gonna keep winning like this and get stronger and stronger!",
            "Whoah! You're pretty strong!",
            "You just haven't trained enough. You may as well quit the tournament now.",
            "You're to weak to use your loss to promote my dojo...",
            "I knew exactly what you'd try! Better luck next time!",
            "Don't underestimate me!",
            "Didja see that?",
            "True power is not just physical. Still, that hurt, didn't it?",
            "I have inflicted no grave injuries. Go now and recover.",
            "I used to think of this power as a curse, but now I appreciate it.",
            "I believe in the power of humanity.",
            "I'm so tired... I can hardly wait to relax with a nice bubble bath.",
            "That's all for today's lesson.",
            "I sense a strength within you. We will meet again.",
            "Victory is mine, but there is always next time. Shall I foresee the outcome?",
            "You are not cut out to be a fighter. It would be wise to seek another path.",
            "Embrace your destiny.",
            "Are you hurt?",
            "Man, I've gotten so famous lately that I can't even walk around outside anymore without people tryin' to ask for my autograph! I'm thinkin' maybe I need a bodyguard or somethin'! For real!",
            "So I was wonderin'... What's the difference between an ocean an' a sea, anyway? Is it just about size? Does the location matter? Can a sea get promoted to an ocean if it tries really hard?",
            "There ain't nothin I like more than a nice custom bike. It ain't just about the obvious stuff like color and shape, either. Ya gotta worry about the overall balance an' make sure it looks...",
            "I drove to China on my bike the other day. What? I ain't lyin', man! I never lie! I totally drove there on my bike! Don't belive me? Check a map! I'll retrace my steps for ya!",
            "Hobbies? Karaoke, baby! Can't get enough of it! One time Candy an' me, we rented out a karaoke box for a whole week! That was a blast! We're still payin' the owner for the busted speakers...",
            "I ain't just a legend in the fighting world, ya know. I'm also well-known in biker circles! Prolly considered the top biker in America! But I got my sights set even higher! One day, I'll...",
            "Candy's really into gardening lately. Ya know those little onion-lookin' things? They kinda look like me? Oh yeah! Bulbs! So, she planted a buncha bulbs in the garden, see? An' before long...",
            "Wanna know what I like most about Candy? Too bad! That's top secret privileged information, bub! I don't want you fallin' in love with her, too! Not that you could compete, but still...",
            "Why do women take so long to shop, anyway? Don't tell Candy I said this, but that girl took like 2 hours to decide between a couple of blouses that were the exact same color! No difference!",
            "Wataaah!",
            "Achoo!",
            "My journey to become the ultimate fighter has only just begun.",
            "Each time I fight, I learn something new. This journey has been fruitful.",
            "Even if my fists were to turn to dust, I would not give up in my quest!",
            "The more I learn, the more I realize how far I am from the end of my journey.",
            "The power I am after is the power to win - not the power to destroy!",
            "You must defeat my Shoryuken to stand a chance!",
            "No need to speak. Your fists told me everything I need to know about you.",
            "If you go into the ring expecting to fail, you will. Believe in yourself!",
            "Power alone is no guarantee of victory. Keep your eyes on your opponent!",
            "Give it your all!",
            "These two fists are everything to me!",
            "Do not place so much importance on winning. The fight itself has value.",
            "A strong fighter is not one who always wins, but one who stands after defeat.",
            "All the worlds fighters must bow before the undisputed king!",
            "I'm inspired by the courage of those who have fallen before my mighty fist.",
            "I will not rest until I know the meaning of the fight!",
            "They call me the king for a reason fool! You never stood a chance!",
            "Have you tested him in battle as well? Impressive, I shall remember you.",
            "You are not strong enough to go toe to toe with the undisputed king!",
            "You are not a warrior, you're a beginner.",
            "Stand up!",
            "Now you know the power of the king!",
            "Training is fun if you set your mind to a specific goal to work toward!",
            "Yes! I'm doing great! Gotta keep this up!",
            "Awesome fight! I'm on top of my game today!",
            "Oh no! I almost forgot I'm s'posed to meet Kei today! I'm gonna be late!",
            "I got some kind of invitation in the mail from Karin. I'd better reply!",
            "Yeah! That was great!",
            "That was so fun! We have to do it again soon!",
            "Phew! That was a close one! Wanna go again?",
            "You're pretty strong, but you need to mix up your moves a bit more.",
            "Thanks for fighting me!",
            "That's a wrap!",
            "Evil? Like the concept of gods, this is a meaningless human construct.",
            "No need to contemplate your future. That is for me to determine. Not you.",
            "My name, my consciousness, my power...Everything I have, I earned for myself!",
            "I was just looking for a test subject to assist in augmenting my engine...",
            "Before long, a new age will dawn upon the earth and I shall rule over all!",
            "Fear in the face of such power is only natural. No need to hide it.",
            "I am impressed. Now stand so that I may assimilate your data!",
            "I did not expect you to put up such a fight. You have impressed me.",
            "This has been a complete waste of time. Prepare for data deletion!",
            "My name is Seth. Remember it!",
            "I am ruler of all I survey!",
            "You cannot defeat me if you fight only for yourself.",
            "These fists fight for life. They are protected by benevolent spirits.",
            "Let us go to the ends of the earth!",
            "True warriors know no fear. This is not pride, but merely confidence.",
            "My power is bestowed upon me by the spirits. You have no such power!",
            "Spirits and men are both engaged in a constant journey.",
            "I do not fear death. But do not confuse this for resignation.",
            "Do not lament over your loss, for the spirits will heal and rejuvenate you.",
            "I will not stop until I have found my beloved and hold her in my arms!",
            "Let us depart.",
            "The wind speaks to us.",
            "No one compares to my beauty. Nor my strength.",
            "Not even the gods could create something that compares to my beauty.",
            "Blood is the most beautiful color known to mankind.",
            "Power and wealth are meaningless in the face of blinding beauty.",
            "I look the most beautiful when glimpsed in the moment of your demise.",
            "I am at my most beautiful when I am dealing the victory blow.",
            "The least I could do is defeat you with unmatched beauty and grace.",
            "Fighting ugly opponents depresses me to no end.",
            "The weak have nothing to offer and should be culled from the population.",
            "I am beautiful.",
            "Victory is beautiful.",
            "Choosing to fight me means that you are prepared to face defeat!",
            "My muscles are my shield and this shield can withstand any attack!",
            "Compared to my training in Siberia, street fights are mere child's play!",
            "Fans are what drive a wrestler's spirit! With support from my fans, I can't lose!",
            "If you want to build your leg muscles, you should try the Cossack Dance!",
            "I am the Red Cylcone and I destroy anything in my path!",
            "You'd better not try to stand up right away. I threw you awfully hard...",
            "That last move was impressive, comrade. But it was too little, too late!",
            "You need more muscle mass!",
            "You have to want victory!",
            "Khorosho I win!"
          ],
          "stages": [
            "A Shadow Falls stages",
            "Air Force Base",
            "Amazon River Basin",
            "Antarctica",
            "Apprentice Alley",
            "Ayutthaya Ruins",
            "Battle Harbor",
            "Beautiful Bay",
            "Big Factory",
            "Blast Furnace",
            "Bonus Stage",
            "Bustling Side Street",
            "City in Chaos",
            "Cosmic Elevator",
            "Crowded Downtown",
            "Cruise Ship Stern",
            "Crumbling Laboratory",
            "Deserted Temple",
            "Dojo",
            "Drive-in At Night",
            "English Manor",
            "Exciting Street Scene",
            "Festival At The Old Temple",
            "Field of Fate",
            "Flamenco Tavern",
            "Forgotten Waterfall",
            "High Roller Casino",
            "Hillside Plaza",
            "Historic Distillery",
            "Holly Jolly Beatdown",
            "Inland Jungle",
            "Jurassic Era Research Facility",
            "Kanzuki Beach",
            "Kanzuki Estate",
            "Kapukon Yu",
            "Kasugano Residence",
            "King's Court",
            "Kousyu Street",
            "Lair of the Four Kings",
            "Las Vegas",
            "Mad Gear Hideout",
            "Maharaja's Palace",
            "Metro City Bay Area",
            "Mishima Estate",
            "Old Temple",
            "Overpass",
            "Palazzo Mistero",
            "Pandora's Box",
            "Pitch-black Jungle",
            "Port of Genoa",
            "Ring of Destiny",
            "Ring of Justice",
            "Ring of Power",
            "Ring of Pride",
            "Rising Dragoon",
            "Run-down Back Alley",
            "Secret Laboratory",
            "Shadaloo Base",
            "Shopping District, Taiping Road",
            "Skies of Honor",
            "Skyscraper Under Construction",
            "Small Airfield",
            "Snowy Rail Yard",
            "Solar Eclipse",
            "Sun Chase Moon",
            "Suzaku Castle",
            "Temple Hideout",
            "The Dojo of Rindo-Kan",
            "The Half Pipe",
            "The Lemony",
            "The Lemony",
            "Tokyo",
            "Training Stage",
            "Underground Arena",
            "Union Station",
            "Urban War Zone",
            "Volcanic Rim"
          ]
        },
        "super_mario": {
          "characters": [
            "Mario",
            "Luigi",
            "Princess Peach",
            "Toad",
            "Bowser",
            "Yoshi",
            "Princess Daisy",
            "Rosalina",
            "Donkey Kong",
            "Diddy Kong",
            "Toadette",
            "Birdo",
            "Toadsworth",
            "Captain Toad",
            "Pauline",
            "Wario",
            "Waluigi",
            "Bowser Jr.",
            "Koopalings",
            "Kamek",
            "Boom Boom",
            "Pom Pom",
            "King Boo"
          ],
          "games": [
            "Luigi's Mansion",
            "Super Mario Bros.",
            "Super Mario World",
            "Super Mario Kart",
            "Super Mario 64",
            "Super Mario Party",
            "Super Smash Bros.",
            "Super Mario Galaxy",
            "Super Mario Odyssey",
            "Super Mario Maker",
            "Paper Mario"
          ],
          "locations": [
            "Bonneton",
            "Fossil Falls",
            "Tostarena",
            "Lake Lamode",
            "Steam Gardens",
            "Nimbus Arena",
            "Forgoten Isle",
            "Kong City",
            "Shiveria",
            "Bubblaine",
            "Mount Volbono",
            "Crumbleden",
            "Bowser's Castle",
            "Honeylune Ridge",
            "Peach's Castle",
            "Rabbit Ridge",
            "Culmina Crater"
          ]
        },
        "super_smash_bros": {
          "fighter": [
            "Alex",
            "Banjo & Kazooie",
            "Bayonetta",
            "Bowser",
            "Bowser Jr.",
            "Byleth",
            "Captain Falcon",
            "Charizard",
            "Chrom",
            "Cloud",
            "Corrin",
            "Daisy",
            "Dark Pit",
            "Dark Samus",
            "Diddy Kong",
            "Donkey Kong",
            "Dr. Mario",
            "Duck Hunt Duo",
            "Enderman",
            "Falco",
            "Fox",
            "Ganondorf",
            "Greninja",
            "Hero",
            "Ice Climbers",
            "Ike",
            "Incineroar",
            "Inkling",
            "Isabelle",
            "Ivysaur",
            "Jigglypuff",
            "Joker",
            "Kazuya",
            "Ken",
            "King Dedede",
            "King K. Rool",
            "Kirby",
            "Link",
            "Little Mac",
            "Lucario",
            "Lucas",
            "Lucina",
            "Luigi",
            "Mario",
            "Marth",
            "Mega Man",
            "Meta Knight",
            "Mewtwo",
            "Mii Fighter",
            "Mii Gunner",
            "Mii Sword Fighter",
            "Min Min",
            "Mr. Game & Watch",
            "Ness",
            "Olimar",
            "Pac-Man",
            "Palutena",
            "Peach",
            "Pichu",
            "Pikachu",
            "Piranha Plant",
            "Pit",
            "Pokémon Trainer",
            "R.O.B.",
            "Richter",
            "Ridley",
            "Robin",
            "Rosalina",
            "Roy",
            "Ryu",
            "Samus",
            "Sephiroth",
            "Sheik",
            "Shulk",
            "Simon",
            "Snake",
            "Sonic",
            "Sora",
            "Squirtle",
            "Steve",
            "Terry",
            "Toon Link",
            "Villager",
            "Wario",
            "Wii Fit Trainer",
            "Wolf",
            "Yoshi",
            "Young Link",
            "Zelda",
            "Zero Suit Samus",
            "Zombie"
          ],
          "stage": [
            "3D Land",
            "75m",
            "Arena Ferox",
            "Balloon Fight",
            "Battlefield",
            "Big Battlefield",
            "Big Blue",
            "Boxing Ring",
            "Bridge of Eldin",
            "Brinstar",
            "Brinstar Depths",
            "Castle Siege",
            "Coliseum",
            "Corneria",
            "Delfino Plaza",
            "Distant Planet",
            "Dracula's Castle",
            "Dream Land",
            "Duck Hunt",
            "Figure-8 Circuit",
            "Final Destination",
            "Find Mii",
            "Flat Zone",
            "Flat Zone 2",
            "Flat Zone X",
            "Fountain of Dreams",
            "Fourside",
            "Frigate Orpheon",
            "Gamer",
            "Garden of Hope",
            "Garreg Mach Monastery",
            "Gaur Plain",
            "Gerudo Valley",
            "Golden Plains",
            "Great Bay",
            "The Great Cave Offensive",
            "Great Plateau Tower",
            "Green Greens",
            "Green Hill Zone",
            "Halberd",
            "Hanenbow",
            "Hollow Bastion",
            "Hyrule Castle",
            "Icicle Mountain",
            "Jungle Hijinxs",
            "Jungle Japes",
            "Kalos Pokémon League",
            "King of Fighters Stadium",
            "Kongo Falls",
            "Kongo Jungle",
            "Living Room",
            "Luigi's Mansion",
            "Lylat Cruise",
            "Magicant",
            "Mario Bros.",
            "Mario Circuit",
            "Mario Galaxy",
            "Mementos",
            "Midgar",
            "Miiverse",
            "Minecraft World",
            "Moray Towers",
            "Mushroom Kingdom",
            "Mushroom Kingdom II",
            "Mushroomy Kingdom",
            "Mushroom Kingdom U",
            "Mute City",
            "New Donk City Hall",
            "New Pork City",
            "Norfair",
            "Northern Cave",
            "Onett",
            "Orbital Gate Assault",
            "Pac-Land",
            "Pac-Maze",
            "Palutena's Temple",
            "Paper Mario",
            "Peach's Castle",
            "Princess Peach's Castle",
            "PictoChat",
            "PictoChat 2",
            "Pilotwings",
            "Pirate Ship",
            "Planet Zebes",
            "Poké Floats",
            "Pokémon Stadium",
            "Pokémon Stadium 2",
            "Port Town Aero Dive",
            "Prism Tower",
            "Pyrosphere",
            "Rainbow Cruise",
            "Rainbow Road",
            "Reset Bomb Forest",
            "Rumble Falls",
            "Saffron City",
            "Sector Z",
            "Shadow Moses Island",
            "Skyloft",
            "Skyworld",
            "Small Battlefield",
            "Smashville",
            "Spear Pillar",
            "Spiral Mountain",
            "Spirit Train",
            "Spring Stadium",
            "Summit",
            "Super Happy Tree",
            "Super Mario Maker",
            "Suzaku Castle",
            "Temple",
            "Tomodachi Life",
            "Tortimer Island",
            "Town and City",
            "Umbra Clock Tower",
            "Unova Pokémon League",
            "Venom",
            "WarioWare, Inc.",
            "Wii Fit Studio",
            "Wily Castle",
            "Windy Hill Zone",
            "Woolly World",
            "Wrecking Crew",
            "Wuhu Island",
            "Yoshi's Island",
            "Yoshi's Story",
            "Yggdrasil's Altar"
          ]
        },
        "touhou": {
          "characters": [
            "Alice Margatroid",
            "Aya Shameimaru",
            "Aya Shameimaru",
            "Benben Tsukumo",
            "Byakuren Hijiri",
            "Chen",
            "Cirno",
            "Clownpiece",
            "Daiyousei",
            "Doremy Sweet",
            "Eika Ebisu",
            "Eirin Yagokoro",
            "Flandre Scarlet",
            "Fujiwara no Mokou",
            "Hata no Kokoro",
            "Hatate Himekaidou",
            "Hecatia Lapislazuli",
            "Hieda no Akyu",
            "Hina Kagiyama",
            "Hong Meiling",
            "Ichirin Kumoi",
            "Iku Nagae",
            "Junko",
            "Kagerou Imaizumi",
            "Kaguya Houraisan",
            "Kana Anaberal",
            "Kanako Yasaka",
            "Kasen Ibaraki",
            "Keiki Haniyasushin",
            "Keine Kamishirasawa",
            "Kikuri",
            "Kisume",
            "Koakuma",
            "Kogasa Tatara",
            "Koishi Komeiji",
            "Komachi Onozuka",
            "Konngara",
            "Kosuzu Motoori",
            "Kotohime",
            "Kurumi",
            "Kutaka Niwatari",
            "Layla Prismriver",
            "Letty Whiterock",
            "Lily White",
            "Luna Child",
            "Lunasa Prismriver",
            "Lyrica Prismriver",
            "Mai",
            "Mamizou Futatsuiwa",
            "Maribel Hearn",
            "Marisa Kirisame",
            "Mayumi Joutouguu",
            "Medicine Melancholy",
            "Merlin Prismriver",
            "Minamitsu Murasa",
            "Minoriko Aki",
            "Momiji Inubashiri",
            "Mononobe no Futo",
            "Mystia Lorelei",
            "Nazrin",
            "Nitori Kawashiro",
            "Nue Houjuu",
            "Parsee Mizuhashi",
            "Patchouli Knowledge",
            "Raiko Horikawa",
            "Ran Yakumo",
            "Reimu Hakurei",
            "Reisen Udongein Inaba",
            "Remilia Scarlet",
            "Renko Usami",
            "Rin Kaenbyou",
            "Rin Satsuki",
            "Ringo",
            "Rinnosuke Morichika",
            "Rumia",
            "Sagume Kishin",
            "Saki Kurokoma",
            "Sakuya Izayoi",
            "Sanae Kochiya",
            "Satori Komeiji",
            "Seiga Kaku",
            "Seija Kijin",
            "Seiran",
            "Sekibanki",
            "Shikieiki Yamaxanadu",
            "Shinmyoumaru Sukuna",
            "Shizuha Aki",
            "Shou Toramaru",
            "Soga no Tojiko",
            "Star Sapphire",
            "Suika Ibuki",
            "Sumireko Usami",
            "Sunny Milk",
            "Suwako Moriya",
            "Tenshi Hinanawi",
            "Tewi Inaba",
            "Toyosatomimi no Miko",
            "Utsuho Reiuji",
            "Wakasagihime",
            "Watatsuki no Toyohime",
            "Watatsuki no Yorihime",
            "Wriggle Nightbug",
            "Yachie Kicchou",
            "Yamame Kurodani",
            "Yatsuhashi Tsukumo",
            "Yoshika Miyako",
            "Youmu Konpaku",
            "Yukari Yakumo",
            "Yuugi Hoshiguma",
            "Yuuka Kazami",
            "Yuyuko Saigyouji"
          ],
          "games": [
            "Highly Responsive to Prayers",
            "Story of Eastern Wonderland",
            "Phantasmagoria of Dim. Dream",
            "Lotus Land Story",
            "Mystic Square",
            "Embodiment of Scarlet Devil",
            "Perfect Cherry Blossom",
            "Imperishable Night",
            "Immaterial and Missing Power",
            "Phantasmagoria of Flower View",
            "Shoot the Bullet",
            "Mountain of Faith",
            "Scarlet Weather Rhapsody",
            "Subterranean Animism",
            "Undefined Fantastic Object",
            "Touhou Hisoutensoku",
            "Double Spoiler",
            "Fairy Wars",
            "Ten Desires",
            "Hopeless Masquerade",
            "Double Dealing Character",
            "Impossible Spell Card",
            "Urban Legend in Limbo",
            "Legacy of Lunatic Kingdom",
            "Hidden Star in Four Seasons",
            "Antinomy of Common Flowers",
            "Violet Detector",
            "Wily Beast and Weakest Creature"
          ],
          "locations": [
            "Abandon Pond",
            "Animal Realm",
            "Bamboo Forest of the Lost",
            "Barrier of Life & Death",
            "Canal of Willows",
            "Deep Road to Hell",
            "Dream World",
            "Eientei",
            "Forest of Magic",
            "Former Hell",
            "Garden of the Sun",
            "Geidontei",
            "Genbu Ravine",
            "Gensokyo",
            "Giant Toad's Pond",
            "Hakugyokurou",
            "Hakurei Shrine",
            "Hall of Dreams' Great Mausoleum",
            "Heaven",
            "Higan",
            "Hokkai",
            "Hot Spring Town",
            "Human Village",
            "Kourindou",
            "Land of the Back Door",
            "Lunar Capital",
            "Makai",
            "Mayohiga",
            "Misty Lake",
            "Moriya Shrine",
            "Muenzuka",
            "Myouren Temple",
            "Nameless Hill",
            "Netherworld",
            "Nuclear Furnace",
            "Outside World",
            "Palace of the Earth Spirits",
            "Phantom Meadow",
            "Primate Spirit Garden",
            "Rainbow Cavern of Earth Spirits",
            "Remains of Blazing Hell",
            "Road of Liminality",
            "Road of Lingering Snow",
            "Road of Reconsideration",
            "Sanzu River",
            "Scarlet Devil Mansion",
            "Sea of Tranquility",
            "Senkai",
            "Shining Needle Castle",
            "Suzunaan",
            "The Great Youkai Forest",
            "TORIFUNE",
            "Underground Geyser Center",
            "Underworld",
            "Untrodden Valley",
            "Waterfall of Nine Heavens",
            "Wind God's Lake",
            "Youkai Mountain"
          ],
          "songs": [
            "Welcome to the Moon Tour",
            "Greenwich in the Sky",
            "Sleepless Night of the Eastern Country",
            "The Wheelchair's Future in Space",
            "Demystify Feast",
            "Satellite Café Terrace",
            "G Free",
            "Celestial Wizardry ~ Magical Astronomy",
            "Necrofantasia",
            "The Far Side of the Moon",
            "Sealed Gods",
            "A God That Misses People ~ Romantic Fall",
            "Because Princess Inada Is Scolding Me",
            "The Road of the Misfortune God ~ Dark Road",
            "Dark Side of Fate",
            "The Gensokyo the Gods Loved",
            "Akutagawa Ryuunosuke's \"Kappa\" ~ Candid Friend",
            "Fall of Fall ~ Autumnal Waterfall",
            "Youkai Mountain ~ Mysterious Mountain",
            "The Primal Scene of Japan the Girl Saw",
            "Faith Is for the Transient People",
            "Cemetery of Onbashira ~ Grave of Being",
            "The Venerable Ancient Battlefield ~ Suwa Foughten Field",
            "Tomorrow Will Be Special, Yesterday Was Not",
            "Native Faith",
            "Shrine at the Foot of the Mountain",
            "The Gods Give Us Blessed Rain ~ Sylphid Dream",
            "Eternal Night Vignette ~ Eastern Night",
            "Illusionary Night ~ Ghostly Eyes",
            "Stirring an Autumn Moon ~ Mooned Insect",
            "Song of the Night Sparrow ~ Night Bird",
            "Deaf to All but the Song",
            "Nostalgic Blood of the East ~ Old World",
            "Plain Asia",
            "Retribution for the Eternal Night ~ Imperishable Night",
            "Maiden's Capriccio ~ Dream Battle",
            "Love-Colored Master Spark",
            "Cinderella Cage ~ Kagome-Kagome",
            "Lunatic Eyes ~ Invisible Full Moon",
            "Voyage 1969",
            "Gensokyo Millennium ~ History of the Moon",
            "Flight of the Bamboo Cutter ~ Lunatic Princess",
            "Voyage 1970",
            "Extend Ash ~ Person of Hourai",
            "Reach for the Moon, Immortal Smoke",
            "Evening Primrose",
            "Eternal Dream ~ Mystical Maple",
            "Eastern Youkai Beauty",
            "Spirit of Avarice",
            "Night Sakura of Dead Spirits",
            "Ghost Lead",
            "Welcome to Youkai Temple",
            "Youkai Girl at the Gate",
            "Let’s Live in a Lovely Cemetery",
            "Rigid Paradise",
            "Desire Drive",
            "Old Yuanxian",
            "The Hall of Dreams' Great Mausoleum",
            "Omiwa Legend",
            "Starry Sky of Small Desires",
            "Shoutoku Legend ~ True Administrator",
            "Youkai Back Shrine Road",
            "Futatsuiwa from Sado",
            "A New Wind at the Shrine",
            "Desire Dream",
            "Silent Beast Spirits",
            "The Lamentations Known Only by Jizo",
            "Jelly Stone",
            "Lost River",
            "The Stone Baby and the Submerged Bovine",
            "Everlasting Red Spider Lily",
            "Seraphic Chicken",
            "Unlocated Hell",
            "Tortoise Dragon ~ Fortune and Misfortune",
            "Beast Metropolis",
            "Joutoujin of Ceramics",
            "Electric Heritage",
            "Entrust this World to Idols ~ Idolatrize World",
            "The Shining Law of the Strong Eating the Weak",
            "Prince Shoutoku's Pegasus ~ Dark Pegasus",
            "The Animals' Rest",
            "Returning Home from the Underground"
          ],
          "spell_cards": [
            "Spirit Sign \"Yin-Yang Sign\"",
            "Spirit Sign \"Fantasy Seal\"",
            "Spirit Sign \"Hakurei Illusion\"",
            "Magic Sign \"Stardust\"",
            "Magic Sign \"Stardust Reverie\"",
            "Magic Sign \"Illusion Star\"",
            "Time Sign \"Private Vision\"",
            "Time Sign \"Mysterious Jack\"",
            "Hesitation Sign \"Sword of Binding Desires\"",
            "Hesitation Sign \"Half Body Disillusion\"",
            "Wave Sign \"Lunar Surface Ripple (Luna Wave)\"",
            "Scatter Sign \"Dream of Prosperity (Luna Megalopolis)\"",
            "Freeze Sign \"Perfect Freeze\"",
            "Freeze Sign \"Cold Divinity\"",
            "Noise Sign \"Soul Noise Flow\"",
            "Noise Sign \"Lyrica Solo Live\"",
            "Bird Sign \"Human Cage\"",
            "Bird Sign \"Human Cage Double\"",
            "Bird Sign \"Mysterious Song\"",
            "Rabbit Sign \"Great Fortune Crest\"",
            "Rabbit Sign \"Bare White Rabbit of Inaba\"",
            "Flower Sign \"Blossoming of Gensokyo\"",
            "Fantasy \"The Beauties of Nature\"",
            "Wind Sign \"Wind God's Fan\"",
            "Gust \"Wind God Girl\"",
            "Poison Sign \"Nerve Poison\"",
            "Poison Sign \"A Poison for Melancholy\"",
            "Thrown Coins \"Yesterday's Money\"",
            "Shinigami \"Higan Retour\"",
            "Guilt Sign \"Wandering Sin\"",
            "Judgement \"Last Judgement\"",
            "Noise Sign \"Soul Go Happy\"",
            "Noise Sign \"Merlin Happy Live\"",
            "Noise Sign \"Noise Melancholy\"",
            "Noise Sign \"Lunasa Solo Live\"",
            "Leaf Sign \"Falling Leaves of Madness\"",
            "Fall Sign \"Fall Sky\"",
            "Fall Sign \"The Fall Sky and a Maiden's Heart\"",
            "Plenty Sign \"Owotoshi Harvester\"",
            "Bumper Crop \"Promise of the Wheat God\"",
            "Bad Luck Sign \"Bad Fortune\"",
            "Bad Luck Sign \"Biorhythm of the Misfortune God\"",
            "Flawed Sign \"Broken Amulet\"",
            "Scar \"Broken Charm of Protection\"",
            "Evil Spirit \"Misfortune's Wheel\"",
            "Fate \"Old Lady Ohgane's Fire\"",
            "Wound Sign \"Pain Flow\"",
            "Wound Sign \"Exiled Doll\"",
            "Optics \"Optical Camouflage\"",
            "Optics \"Hydro Camouflage\"",
            "Flood \"Ooze Fooding\"",
            "Flood \"Diluvial Mere\"",
            "Drown \"Trauma in the Glimmering Depths\"",
            "Water Sign \"Kappa's Pororoca\"",
            "Water Sign \"Kappa's Flash Flood\"",
            "Water Sign \"Kappa's Great Illusionary Waterfall\"",
            "Kappa \"Monster Cucumber\"",
            "Kappa \"Exteeeending Aaaaarm\"",
            "Kappa \"Spin the Cephalic Plate\"",
            "Crossroad Sign \"Crossroads of Heaven\"",
            "Crossroad Sign \"Saruta Cross\"",
            "Wind God \"Wind God's Leaf-Veiling\"",
            "Wind God \"Tengu's Fall Wind\"",
            "Wind God \"Storm Day\"",
            "Illusionary Dominance",
            "Peerless Wind God",
            "Blockade Sign \"Mountain God's Procession\"",
            "Blockade Sign \"Advent of the Divine Grandson\"",
            "Blockade Sign \"Terukuni Shining Through Heaven and Earth\"",
            "Esoterica \"Gray Thaumaturgy\"",
            "Esoterica \"Forgotten Ritual\"",
            "Esoterica \"Secretly Inherited Art of Danmaku\"",
            "Miracle \"Daytime Guest Stars\"",
            "Miracle \"Night with Bright Guest Stars\"",
            "Miracle \"Night with Overly Bright Guest Stars\"",
            "Sea Parting \"The Day the Sea Split\"",
            "Sea Parting \"Moses' Miracle\"",
            "Preparation \"Star Ritual to Call the Godly Winds\"",
            "Preparation \"Summon Takeminakata\"",
            "Miracle \"God's Wind\"",
            "Great Miracle \"Yasaka's Divine Wind\"",
            "Divine Festival \"Expanded Onbashira\"",
            "Weird Festival \"Medoteko Boisterous Dance\"",
            "Rice Porridge in Tube \"God's Rice Porridge\"",
            "Forgotten Grain \"Unremembered Crop\"",
            "Divine Grain \"Divining Crop\"",
            "Sacrifice Sign \"Misayama Hunting Shrine Ritual\"",
            "Mystery \"Kuzui Clear Water\"",
            "Mystery \"Yamato Torus\"",
            "Heaven's Stream \"Miracle of Otensui\"",
            "Heaven's Dragon \"Source of Rains\"",
            "Mountain of Faith",
            "Divine Virtues of Wind God",
            "God Sign \"Beautiful Spring like Suiga\"",
            "God Sign \"Ancient Fate Linked by Cedars\"",
            "God Sign \"Omiwatari that God Walked\"",
            "Party Start \"Two Bows, Two Claps, and One Bow\"",
            "Native God \"Lord Long-Arm and Lord Long-Leg\"",
            "Divine Tool \"Moriya's Iron Ring\"",
            "Spring Sign \"Jade of the Horrid River\"",
            "Frog Hunt \"The Snake Eats the Croaking Frog\"",
            "Native God \"Seven Stones and Seven Trees\"",
            "Native God \"Froggy Braves the Wind and Rain\"",
            "Native God \"Red Frogs of Houei Four\"",
            "Suwa War ~ Native Myth vs. Central Myth",
            "Scourge Sign \"Mishaguji-sama\"",
            "Trap Sign \"Capture Web\"",
            "Spider \"Cave Spider's Nest\"",
            "Miasma Sign \"Filled Miasma\"",
            "Miasma \"Unexplained Fever\"",
            "Jealousy Sign \"Green-Eyed Monster\"",
            "Envy \"Green-Eyed Invisible Monster\"",
            "Grandpa Hanasaka \"Jealousy of the Kind & Lovely\"",
            "Grandpa Hanasaka \"Shiro's Ashes\"",
            "Tongue-Cut Sparrow \"Hate for the Humble & Rich\"",
            "Tongue-Cut Sparrow \"Large Box & Small Box\"",
            "Malice Sign \"Shrine Visit in the Dead of Night\"",
            "Malice Sign \"Day 7 of the Shrine Visits in the Dead of Night\"",
            "Oni Sign \"Anomalies, Strength, Disorder, & Spirits\"",
            "Mysterious Ring \"Hell's Wheel of Pain\"",
            "Shackles Sign \"Shackles a Criminal Can't Take Off\"",
            "Feat of Strength \"Storm on Mt. Ooe\"",
            "Feat of Strength \"Wind Blowing Down from Mt. Ooe\"",
            "Big Four Arcanum \"Knock Out In Three Steps\"",
            "Recollection \"Terrible Souvenir\"",
            "Recollection \"Terrifying Hypnotism\"",
            "Recollection \"Double Black Death Butterfly\"",
            "Recollection \"Flying Insect's Nest\"",
            "Recollection \"Border of Wave & Particle\"",
            "Recollection \"Mt. Togakushi Toss\"",
            "Recollection \"Night Parade of a Million Demons\"",
            "Recollection \"Deep Fog Labyrinth\"",
            "Recollection \"Wind God's Leaf-Veiling\"",
            "Recollection \"Tengu's Macroburst\"",
            "Recollection \"Torii Whorl-Wind\"",
            "Recollection \"Spring Kyoto Dolls\"",
            "Recollection \"Straw Doll Kamikaze\"",
            "Recollection \"Return Inanimateness\"",
            "Recollection \"Mercury Poison\"",
            "Recollection \"Princess Undine\"",
            "Recollection \"Philosopher's Stone\"",
            "Recollection \"Extending Arm\"",
            "Recollection \"Kappa's Pororoca\"",
            "Recollection \"Trauma in the Glimmering Depths\"",
            "Cat Sign \"Cat's Walk\"",
            "Cat Sign \"Vengeful Cat Spirit's Erratic Step\"",
            "Cursed Sprite \"Zombie Fairy\"",
            "Cursed Sprite \"Vengeful Spirit: Possessed Fairy\"",
            "Malicious Spirit \"Spleen Eater\"",
            "Corpse Spirit \"Vengeful Cannibal Spirit\"",
            "Atonement \"Needle Mountain of a Former Hell\"",
            "Atonement \"The Needles of Yore & the Vengeful Spirits in Pain\"",
            "Rekindling of Dead Ashes",
            "Small Demon's Revival",
            "Youkai \"Blazing Wheel\"",
            "Atomic Fire \"Nuclear Fusion\"",
            "Atomic Fire \"Nuclear Excursion\"",
            "Atomic Fire \"Uncontainable Nuclear Reaction\"",
            "Explosion Sign \"Petit Flare\"",
            "Explosion Sign \"Mega Flare\"",
            "Explosion Sign \"Giga Flare\"",
            "Explosion Sign \"Peta Flare\"",
            "Blazing Star \"Fixed Star\"",
            "Blazing Star \"Planetary Revolution\"",
            "Blazing Star \"Ten Evil Stars\"",
            "Hell & Heaven Meltdown",
            "Hell's Tokamak",
            "Hell's Artificial Sun",
            "Subterranean Sun",
            "Esoterica \"Nine Syllable Stabs\"",
            "Miracle \"Miracle Fruit\"",
            "Divine Virtue \"Bumper Crop Rice Shower\"",
            "Image \"All Ancestors Standing Beside Your Bed\"",
            "Image \"Danmaku Paranoia\"",
            "Instinct \"Release of the Id\"",
            "Suppression \"Super-Ego\"",
            "Response \"Youkai Polygraph\"",
            "Unconscious \"Rorschach in Danmaku\"",
            "Rekindled \"The Embers of Love\"",
            "Depths \"Genetics of the Unconscious\"",
            "Philosophy of a Hated Person",
            "Subterranean Rose",
            "Rod Sign \"Busy Rod\"",
            "Search Sign \"Rare Metal Detector\"",
            "Search Sign \"Gold Detector\"",
            "Vision Sign \"Nazrin Pendulum\"",
            "Vision Sign \"High Sensitivity Nazrin Pendulum\"",
            "Defense Sign \"Pendulum Guard\"",
            "Large Ring \"Umbrella Halo\"",
            "Large Ring \"Hello Forgotten World\"",
            "Umbrella Sign \"Parasol Star Symphony\"",
            "Umbrella Sign \"Parasol Star Memories\"",
            "Rain Sign \"A Rainy Night's Ghost Story\"",
            "Umbrella \"Super Water-Repelling Bone-Dry Monster\"",
            "Monster Sign \"A Forgotten Umbrella's Night Train\"",
            "Monster Train \"Spare Umbrella Express Night Carnival\"",
            "Iron Fist \"An Unarguable Youkai Punch\"",
            "Divine Fist \"Hell Thrust from Above the Clouds\"",
            "Divine Fist \"Hell Thrust from the Heavenly Seas\"",
            "Fist Sign \"Heavenly Net Sandbag\"",
            "Barrage \"Cloud World Kraken Strike\"",
            "Barrage \"King Kraken Strike\"",
            "Hand Strike \"Fist Smash\"",
            "Annihilation \"Consecutive Hooks Throughout Heaven & Earth\"",
            "Thunderous Yell \"A Scolding from a Traditional Old Man\"",
            "Rage \"Calamity Scolding Scorch\"",
            "Rage \"First & Last of Its Kind Scolding Scorch\"",
            "Capsize \"Dragging Anchor\"",
            "Capsize \"Foundering Anchor\"",
            "Capsize \"Sinking Anchor\"",
            "Drowning Sign \"Deep Vortex\"",
            "Drowning Sign \"Sinkable Vortex\"",
            "Harbor Sign \"Phantom Ship Harbor\"",
            "Harbor Sign \"Phantom Ship's Port\"",
            "Harbor Sign \"Eternally Anchored Phantom Ship\"",
            "Phantom \"Sinker Ghost\"",
            "Phantom \"Dipper Creeping Close\"",
            "Jeweled Pagoda \"Greatest Treasure\"",
            "Jeweled Pagoda \"Radiant Treasure\"",
            "Jeweled Pagoda \"Radiant Treasure Gun\"",
            "Light Sign \"Absolute Justice\"",
            "Light Sign \"Aura of Justice\"",
            "Buddhist Art \"Most Valuable Vajra\"",
            "Buddha's Light \"Vajra of Perfect Buddhism\"",
            "Light Sign \"Demon of Purification\"",
            "Complete Clarification",
            "Magic \"Omen of Purple Clouds\"",
            "Good Omen \"Cloudy Way in Purple\"",
            "Good Omen \"Nirvana's Cloudy Way in Purple\"",
            "Magic \"Mystic Fragrance of a Makai Butterfly\"",
            "Magic \"Magic Butterfly\"",
            "Light Magic \"Star Maelstrom\"",
            "Light Magic \"Magic Milky Way\"",
            "Great Magic \"Devil's Recitation\"",
            "Amagimi Hijiri's Air Scroll",
            "Superhuman \"Byakuren Hijiri\"",
            "Flying Bowls \"Flying Fantastica\"",
            "Flying Bowls \"Legendary Flying Saucers\"",
            "Umbrella Sign \"Lightly Falling Large Raindrops\"",
            "Surprising Rain \"Guerrilla Typhoon\"",
            "Halo \"Karakasa Surprising Flash\"",
            "Ominous Clouds \"Heian Dark Clouds\"",
            "Unidentified \"Red UFO Invasion of Rage\"",
            "Nue Sign \"Mysterious Snake Show\"",
            "Unidentified \"Blue UFO Invasion of Grief\"",
            "Nue Sign \"Danmaku Chimera\"",
            "Unidentified \"Green UFO Invasion of Justice\"",
            "Nue Sign \"Undefined Darkness\"",
            "Unidentified \"Rainbow UFO Invasion of Terror\"",
            "Nightmare of Heiankyou",
            "Grudge Bow \"The Bow of Genzanmi Yorimasa\"",
            "Symbol \"Dance of the Dead Butterflies\"",
            "Symbol \"Dance of the Dead Butterflies - Cherry Blossoms -\"",
            "Ghostly Butterfly \"Ghost Spot\"",
            "Ghostly Butterfly \"Ghost Spot - Cherry Blossoms -\"",
            "Nether Sign \"Endless Evening Cherry Blossoms\"",
            "Cherry Blossom Sign \"Saigyou Cherry Blossom Blizzard\"",
            "Echo Sign \"Mountain Echo\"",
            "Echo Sign \"Mountain Echo Scramble\"",
            "Echo Sign \"Power Resonance\"",
            "Mountain Echo \"Long-Range Echo\"",
            "Mountain Echo \"Amplify Echo\"",
            "Great Voice \"Charged Cry\"",
            "Great Voice \"Charged Yahoo!\"",
            "Rainbow Sign \"Umbrella Cyclone\"",
            "Recovery \"Heal By Desire\"",
            "Poison Nail \"Poison Raze\"",
            "Poison Nail \"Poison Murder\"",
            "Desire Sign \"Saved Up Desire Spirit Invitation\"",
            "Desire Spirit \"Score Desire Eater\"",
            "Evil Sign \"Yǎng Xiǎoguǐ\"",
            "Evil Sign \"Gūhún Yěguǐ\"",
            "Demonify \"Zǒuhuǒ Rùmó\"",
            "Possession \"Corpse Tóngjī\"",
            "Spirit Link \"Tōnglíng Yoshika\"",
            "Taoist Sign \"Tao Fetal Movement\"",
            "Thunder Arrow \"Gagouji's Cyclone\"",
            "Thunder Arrow \"Gagouji's Tornado\"",
            "Heaven Sign \"Rainy Iwafune\"",
            "Heaven Sign \"Ame-no-Iwafune, Ascend to Heaven\"",
            "Throwing Dishes \"Mononobe's Eighty Saké Cups\"",
            "Blaze Sign \"Blazing Winds of Haibutsu\"",
            "Blaze Sign \"Sakurai-ji in Flames\"",
            "Saint Girl \"Oomonoimi's Dinner\"",
            "Honor \"Colors of Twelve Levels\"",
            "Honor \"Ranks of Twelve Levels\"",
            "Hermit Sign \"Taoist of the Land of the Rising Sun\"",
            "Hermit Sign \"Emperor of the Land of the Rising Sun\"",
            "Summon \"Royal Clan's Chaotic Dance\"",
            "Secret Treasure \"Armillary Sphere of Ikaruga-dera\"",
            "Secret Treasure \"Prince Shotoku's Out-of-Place Artifact\"",
            "Light Sign \"Halo of the Guse Kannon\"",
            "Light Sign \"Guse Flash\"",
            "Discernment \"Lasers of Seventeen Articles\"",
            "Divine Light \"Honor the Avoidance of Defiance\"",
            "Falling Stars on Divine Spirit Mausoleum",
            "Newborn Divine Spirits",
            "Unknown \"Will-o'-wisps in Unknown Orbit\"",
            "Unknown \"Skyfish with Unknown Shape\"",
            "Unknown \"Youkai Orb of Unknown Mechanics\"",
            "First Duel \"Primate Danmaku Transformation\"",
            "Second Duel \"Carnivorous Danmaku Transformation\"",
            "Third Duel \"Avian Danmaku Transformation\"",
            "Fourth Duel \"Amphibian Danmaku Transformation\"",
            "Fifth Duel \"Scrolls of Frolicking Animals\"",
            "Sixth Duel \"Tanuki's Monstrous School\"",
            "Seventh Duel \"Wild Deserted Island\"",
            "Transformation \"Pseudo-Exorcism of the Stupid Shrine Maiden\"",
            "Mamizou Danmaku in Ten Transformations",
            "Raccoon Sign \"Full Moon Pompokolin\"",
            "Cherry Blossom Sign \"Cherry Blossom Blizzard Hell\"",
            "Mountain Echo \"Yamabiko's Specialty Echo Demonstration\"",
            "Poison Nail \"Undead Murderer\"",
            "Taoist Sign \"TAO Fetal Movement ~Dao~\"",
            "Vengeful Spirit \"Iruka's Thunder\"",
            "Saint Girl \"Sun Goddess's Sacrifice\"",
            "Divine Spirits' Universe",
            "Wild Carpet",
            "Ice Sign \"Ultimate Blizzard\"",
            "Water Sign \"Tail Fin Slap\"",
            "Scale Sign \"Scale Wave\"",
            "Scale Sign \"Raging Waves of the Reversed Scale\"",
            "Scale Sign \"Great Raging Waves of the Reversed Scale\"",
            "Flight Sign \"Flying Head\"",
            "Neck Sign \"Close-Eye Shot\"",
            "Neck Sign \"Rokurokubi Flight\"",
            "Flying Head \"Multiplicative Head\"",
            "Flying Head \"Seventh Head\"",
            "Flying Head \"Ninth Head\"",
            "Flying Head \"Dullahan Night\"",
            "Fang Sign \"Moonlit Canine Teeth\"",
            "Transformation \"Triangle Fang\"",
            "Transformation \"Star Fang\"",
            "Roar \"Strange Roar\"",
            "Roar \"Full Moon Howling\"",
            "Wolf Sign \"Star Ring Pounce\"",
            "Sirius \"High-Speed Pounce\"",
            "Heikyoku \"Sounds of Jetavana's Bell\"",
            "Vengeful Spirit \"Hoichi the Earless\"",
            "Vengeful Spirit \"Great Vengeful Spirit of Taira\"",
            "Music Sign \"Wicked Musical Score\"",
            "Music Sign \"Malicious Musical Score\"",
            "Music Sign \"Double Score\"",
            "Koto Sign \"Sounds of Anicca's Koto\"",
            "Echo Sign \"Heian's Reverberation\"",
            "Echo Sign \"Echo Chamber\"",
            "Koto Music \"Social Upheaval Koto Music Complement\"",
            "Koto Music \"Social Upheaval Requiem\"",
            "Deceit Sign \"Reverse Needle Attack\"",
            "Reverse Sign \"Danmaku Through the Looking-Glass\"",
            "Reverse Sign \"Evil in the Mirror\"",
            "Reverse Sign \"This Side Down\"",
            "Reverse Sign \"Overturning All Under Heaven\"",
            "Reverse Bow \"Dream Bow of Heaven & Earth\"",
            "Reverse Bow \"Decree of the Dream Bow of Heaven & Earth\"",
            "Turnabout \"Reverse Hierarchy\"",
            "Turnabout \"Change Air Brave\"",
            "Small Bullet \"Inchling's Path\"",
            "Small Bullet \"Inchling's Thorny Path\"",
            "Mallet \"Grow Bigger!\"",
            "Mallet \"Grow Even Bigger!\"",
            "Bewitched Sword \"Shining Needle Sword\"",
            "Mallet \"You Grow Bigger!\"",
            "Attack on Dwarf",
            "Wall of Issun",
            "Hop-o'-My-Thumb Seven",
            "The Seven Issun-Boshi",
            "String Music \"Storm Ensemble\"",
            "String Music \"Joururi World\"",
            "First Drum \"Raging Temple Taiko\"",
            "Second Drum \"Vengeful Spirit Aya-no-Tsuzumi\"",
            "Third Drum \"Three Strikes at Midnight\"",
            "Death Drum \"Land Percuss\"",
            "Fifth Drum \"Den-Den Daiko\"",
            "Sixth Drum \"Alternate Sticking\"",
            "Seventh Drum \"High Speed Taiko Rocket\"",
            "Eighth Drum \"Thunder God's Anger\"",
            "Blue Lady Show",
            "Pristine Beat",
            "Evil Bullet \"Speed Strike\"",
            "Bullet Sign \"Eagle Shooting\"",
            "Bullet Sign \"The Eagle Has Shot Its Target\"",
            "Gun Sign \"Lunatic Gun\"",
            "Gun Sign \"Lunatic Gun\"",
            "Rabbit Sign \"Strawberry Dango\"",
            "Rabbit Sign \"Berry Berry Dango\"",
            "Rabbit Sign \"Dango Influence\"",
            "Moon-Viewing \"September Full Moon\"",
            "Moon-Viewing Saké \"Lunatic September\"",
            "Dream Sign \"Scarlet Nightmare\"",
            "Dream Sign \"Scarlet Oppressive Nightmare\"",
            "Dream Sign \"Indigo Dream of Anxiety\"",
            "Dream Sign \"Indigo Three-Layered Dream of Anxiety\"",
            "Dream Sign \"Eternally Anxious Dream\"",
            "Dream Sign \"Ochre Confusion\"",
            "Dream Sign \"Ochre Labyrinthine Confusion\"",
            "Dream Sign \"Dream Catcher\"",
            "Dream Sign \"Azure Dream Catcher\"",
            "Dream Sign \"Losing Oneself in a Dream\"",
            "Moon Sign \"Ultramarine Lunatic Dream\"",
            "Orb Sign \"Disorderly Flock's Curse\"",
            "Orb Sign \"Disorderly Flock's Reverse Curse\"",
            "Orb Sign \"Disorderly Flock's Duplex Curse\"",
            "Orb Sign \"Impure Body Detection Mines\"",
            "Orb Sign \"Impure Body Detection Mines V2\"",
            "Orb Sign \"Shotgun Coronation of the Gods\"",
            "Orb Sign \"Shining Shotgun Coronation of the Gods\"",
            "One-Winged White Heron",
            "Hell Sign \"Hell Eclipse\"",
            "Hell Sign \"Eclipse of Hell\"",
            "Hell Sign \"Flash and Stripe\"",
            "Hell Sign \"Star and Stripe\"",
            "Hellfire \"Graze Inferno\"",
            "Hellfire \"Infernal Essence of Grazing\"",
            "Inferno \"Striped Abyss\"",
            "Fake Apollo",
            "Apollo Hoax Theory",
            "Pure Light of the Palm",
            "Murderous Lilies",
            "Primordial Divine Spirit World",
            "Modern Divine Spirit World",
            "Trembling, Shivering Star",
            "Pristine Lunacy",
            "Overflowing Blemishes",
            "Refinement of Earthen Impurity",
            "Pure Sign \"Purely Bullet Hell\"",
            "Pure Sign \"A Pristine Danmaku Hell\"",
            "Butterfly \"Butterfly Supplantation\"",
            "Super-Express \"Dream Express\"",
            "Crawling Dream \"Creeping Bullet\"",
            "Otherworld \"Ōmagatoki\"",
            "Earth \"Impurity Within One's Body\"",
            "Moon \"Apollo Reflection Mirror\"",
            "Simple Danmaku for Cornering a Trapped Rat",
            "Otherworld \"Hell's Non-Ideal Danmaku\"",
            "Earth \"Rain Falling in Hell\"",
            "Moon \"Lunatic Impact\"",
            "Pristine Danmaku for Killing a Person",
            "Trinitarian Rhapsody",
            "First and Last Nameless Danmaku",
            "Butterfly Sign \"Minute Scales\"",
            "Butterfly Sign \"Swallowtail's Scales\"",
            "Butterfly Sign \"Fluttering Summer\"",
            "Butterfly Sign \"Midsummer Wingbeats\"",
            "Rain Sign \"Imprisoning Autumn Rain\"",
            "Rain Sign \"Cursed Torrential Rain\"",
            "Blade Sign \"Yamanba's Kitchen Knife Sharpening\"",
            "Blade Sign \"Yamanba's Oni Kitchen Knife Sharpening\"",
            "Blade Exhaustion Sign \"Mountain Murder\"",
            "Blade Exhaustion Sign \"Bloody Mountain Murder\"",
            "Spring Sign \"Surprise Spring\"",
            "Dog Sign \"Stray Dog's Walk\"",
            "Hound Sign \"Mountain Hound's Walk\"",
            "Spinning Top \"Koma-Inu Spin\"",
            "Spinning Top \"Curl Up and Die\"",
            "Koma Sign \"Solitary A-Um Breathing\"",
            "Magic Sign \"Instant Bodhi\"",
            "Magic Sign \"Bodhi in an Instant\"",
            "Magic Sign \"Bullet Golem\"",
            "Magic Sign \"Gigantic Pet Bullet Lifeform\"",
            "Jizo \"Criminal Salvation\"",
            "Jizo \"Hellfire Salvation\"",
            "Bamboo Sign \"Bamboo Spear Dance\"",
            "Bamboo Sign \"Bamboo Crazy Dance\"",
            "Myōga Ginger \"Forget Your Name\"",
            "Broadleaf Sign \"Tanabata Star Festival\"",
            "Myōga Blessing \"Behind You\"",
            "Dance Sign \"Behind Festival\"",
            "Mad Dance \"Tengu-odoshi\"",
            "Mad Dance \"Frenzied Tengu-Frightening\"",
            "Back Sign \"Halo of the Secret God\"",
            "Back Sign \"Halo of the Absolute Secret God\"",
            "Hidden Summer \"Scorch By Hot Summer\"",
            "Hidden Summer \"Scorched Earth of Abnormal Intense Heat\"",
            "Hidden Fall \"Die of Famine\"",
            "Hidden Fall \"Preta of Abnormal Blight\"",
            "Hidden Winter \"Black Snowman\"",
            "Hidden Winter \"Snowman of Abnormal Snowfall\"",
            "Hidden Spring \"April Wizard\"",
            "Hidden Spring \"Black Magician of Abnormal Falling Petals\"",
            "Hidden Breezy Cherry Blossom",
            "Hidden Perfect Summer Ice",
            "Hidden Crazy Fall Wind",
            "Hidden Extreme Winter",
            "Drum Dance \"Powerful Cheers\"",
            "Mad Dance \"Crazy Backup Dance\"",
            "Bullet Dance \"Twin Typhoons\"",
            "Secret Ceremony \"Reverse Invoker\"",
            "Secret Ceremony \"Rear Shots of Betrayal\"",
            "Secret Ceremony \"Danmaku Dupion\"",
            "Secret Ceremony \"Fire of Ena\"",
            "Secret Ceremony \"Kyōgen of the Back Door\"",
            "Secret Ceremony \"Matarah Dukkha\"",
            "Secret Ceremony \"Sword of the Seven Stars\"",
            "Secret Ceremony \"Performers Unattached to Society\"",
            "The Back Face's Dark Sarugaku",
            "Anarchy Bullet Hell",
            "Stone Sign \"Stone Woods\"",
            "Stone Sign \"Stone Conifers\"",
            "Stone Sign \"Children's Limbo\"",
            "Stone Sign \"Adult Children's Limbo\"",
            "Stone Sign \"Stone Baby\"",
            "Stone Sign \"Heavy Stone Baby\"",
            "Drowning Sign \"Drowning in the Sanzu\"",
            "Oni Sign \"Demon Siege\"",
            "Oni Sign \"Hungry Demon Siege\"",
            "Water Sign \"Ordeal of Water Distribution\"",
            "Water Sign \"High-Level Purgatordeal of Water Distribution\"",
            "Water Sign \"Ultimate Purgatordeal of Water Distribution\"",
            "Light Sign \"Ordeal of Surveying\"",
            "Light Sign \"High-Level Purgatordeal of Surveying\"",
            "Light Sign \"Ultimate Purgatordeal of Surveying\"",
            "Oni Sign \"Purgatordeal of Oniwatari\"",
            "Oni Sign \"Hell-Level Purgatordeal of Oniwatari\"",
            "Tortoise Sign \"Tortoiseshell Hell\"",
            "Oni Sign \"Beasts Attacking from the Rear\"",
            "Oni Sign \"Mangy Beasts Attacking from the Rear\"",
            "Oni Sign \"Devilish Beasts Attacking from the Rear\"",
            "Dragon Sign \"Dragon Crest Bullets\"",
            "Haniwa \"Archer Haniwa\"",
            "Haniwa \"Skilled Archer Haniwa\"",
            "Haniwa \"Fencer Haniwa\"",
            "Haniwa \"Skilled Fencer Haniwa\"",
            "Haniwa \"Cavalry Haniwa\"",
            "Haniwa \"Skilled Cavalry Haniwa\"",
            "Haniwa \"Hollow Inexhaustible Troops\"",
            "Haniwa \"Undefeated Inexhaustible Troops\"",
            "Square Shape \"Square-Shaped Sculpting Art\"",
            "Square Shape \"Square Creature\"",
            "Circular Shape \"Perfect Circle Sculpting Art\"",
            "Circular Shape \"Circle Creature\"",
            "Linear Shape \"Line-Shaped Sculpting Art\"",
            "Linear Shape \"Linear Creature\"",
            "Haniwa \"Horse-and-Rider Idol Sculpting Art\"",
            "Haniwa \"Idol Creature\"",
            "Oni-Shaped Sculpting Art",
            "Geometric Creature",
            "Idola Diabolus",
            "Bloody Battle \"Watershed of Blood\"",
            "Bloody Battle \"Hell Realm Sight-Line\"",
            "Bloody Battle \"All-Spirit Oniwatari\"",
            "Agile Skill \"Thrilling Shot\"",
            "Agile Skill \"Lightning Neigh\"",
            "Agile Skill \"Dense Crowd\"",
            "Agile Skill \"Beast Epidemicity\"",
            "Agile Skill \"Triangle Chase\"",
            "Agile Skill \"Black Pegasus Meteor Shot\"",
            "Agile Skill \"Muscle Explosion\"",
            "Follow Me, Unafraid",
            "Oni-Shaped Hoi Polloi",
            "Deeds of Devilish Beasts"
          ]
        },
        "warhammer_fantasy": {
          "creatures": [
            "Chaos Beastman",
            "Centaur",
            "Dragon Ogre",
            "Dryad",
            "Dwarf",
            "Chaos Dwarf",
            "Elf",
            "Dark Elf",
            "Fimir",
            "Giant",
            "Goblin",
            "Gorgon",
            "Halfling",
            "Hobgoblin",
            "Human",
            "Saurus Warrior",
            "Minotaur",
            "Mutant",
            "Ogre",
            "Orc",
            "Black Orc",
            "Skaven",
            "Skaven Grey Seer",
            "Slann",
            "Snotling",
            "Treeman",
            "Troll",
            "Warrior Of Chaos",
            "Zoat",
            "Amoeba",
            "Amphisbaena",
            "Basilisk",
            "Bat",
            "Giant Bat",
            "Bear",
            "Giant Beetle",
            "Bloodsedge",
            "Boar",
            "Bog Octopus",
            "Carnivorous Snapper",
            "Cat",
            "Wild Cat",
            "Chameleoleech",
            "Chaos Hound",
            "Chaos Spawn",
            "Chaos Steed",
            "Chimera",
            "Coatl",
            "Cockatrice",
            "Cold One",
            "Cold One Warhound",
            "Dog",
            "War Dog",
            "Hobhound",
            "Doppelganger",
            "Dragon",
            "Dragon Turtle",
            "Eagle",
            "Fen Worm",
            "Giant Frog",
            "Goldworm",
            "Griffon",
            "Harpy",
            "Hippogriff",
            "Horse",
            "Hydra",
            "Jabberwock",
            "Lashworm",
            "Giant Leech",
            "Mammoth",
            "Manticore",
            "Pegasus",
            "Rat",
            "Giant Rat",
            "Razorbill",
            "Sand Clam",
            "Giant Scorpion",
            "Giant Snail",
            "Snake",
            "Giant Spider",
            "Sunworm",
            "Swarm",
            "Unicorn",
            "Werecreature",
            "Wolf",
            "Wyvern",
            "Bloodthirster",
            "Keeper Of Secrets",
            "Great Unclean One",
            "Lord Of Change",
            "Bloodletter of Khorne",
            "Daemonette of Slaanesh",
            "Plaguebearer of Nurgle",
            "Horror of Tzeentch",
            "Daemonic Hound",
            "Fleshhound of Khorne",
            "Fiend of Slaanesh",
            "Beast of Nurgle",
            "Flamer of Tzeentch",
            "Daemonic Steed",
            "Juggernaut of Khorne",
            "Mount of Slaanesh",
            "Nurglings",
            "Disc of Tzeentch",
            "Daemon Prince",
            "Skink Warrior",
            "Kroxigor",
            "Stegadon",
            "Carnosaur"
          ],
          "factions": [
            "The Empire",
            "Bretonnia",
            "Kislev",
            "Dwarfs",
            "Chaos Dwarfs",
            "High Elves",
            "Wood Elves",
            "Dark Elves",
            "Lizardmen",
            "Ogre Kingdoms",
            "Orcs & Goblins",
            "Tomb Kings",
            "Vampire Counts",
            "Skaven",
            "Dogs of War",
            "Daemons of Chaos",
            "Warriors of Chaos",
            "Beasts of Chaos"
          ],
          "heros": [
            "Aenarion the Defender",
            "Caledor the Dragontamer",
            "Alarielle the Radiant",
            "Alith Anar",
            "Eltharion the Grim",
            "Asarnil the Dragonlord",
            "Finubar the Seafarer",
            "Imrik",
            "Selafyn of the Annulii",
            "Teclis",
            "Tyrion",
            "Caradryan",
            "Malekith",
            "Malus Darkblade",
            "Morathi",
            "Shadowblade",
            "Hellebron",
            "Lokhir Fellheart",
            "Kouran Darkhand",
            "Tullaris Dreadbringer",
            "Hubris Rakarth",
            "Ariel",
            "Araloth",
            "Drycha",
            "Durthu",
            "Naestra & Arahan",
            "Orion",
            "Scarloc",
            "Aekold Helbrass",
            "An'ggrath the Unbound",
            "Arbaal the Undefeated",
            "Archaon",
            "Azazel, Prince of Damnation",
            "Be'lakor",
            "Crom the Conqueror",
            "Dechala the Denied One",
            "Egrimm von Horstmann",
            "Feytor the Tainted",
            "Festus the Leechlord",
            "Galrauch",
            "Gorthor",
            "Ghorros Warhoof",
            "Haargroth the Blooded One",
            "Harald Hammerstorm",
            "Khazrak the One-Eye",
            "Kholek Suneater",
            "Malagor, the Dark Omen",
            "Morghur, Master of Skulls",
            "Sigvald the Magnificant",
            "Skarbrand the Exiled One",
            "Throg",
            "U'Zuhl the Skulltaker",
            "Valkia the Blooded",
            "Vilitch the Curseling",
            "Wulfrik the Wanderer",
            "Azhag the Slaughterer",
            "Borgut Facebeater",
            "Gorbad Ironclaw",
            "Gorfang Rotgut",
            "Grimgor Ironhide",
            "Grom the Paunch",
            "Morglum Necksnapper",
            "Skarsnik & Gobbla",
            "Alaric the Man",
            "Alrik Ranulfsson",
            "Garagrim Ironfist",
            "Gotrek Gurnisson",
            "Grimnir",
            "Grombrindal, the White Dwarf",
            "Josef Bugman",
            "King Kazador",
            "Malakai Makaisson",
            "Snorri Nosebiter",
            "Thorek Ironbrow",
            "Thorgrim Grudgebearer",
            "Ungrim Ironfist",
            "Alberic d'Bordeleau",
            "Armand d'Aquitaine",
            "Bohemond Beastslayer",
            "Chilfroy d'Artois",
            "Fay Enchantress",
            "The Green Knight",
            "Louen Leoncoeur",
            "Repanse de Lyonesse",
            "Roland le Marechal",
            "Borgio the Besieger",
            "Detlef Sierc",
            "Lietpold the Black",
            "Lorenzo Lupo",
            "Lucrezzia Belladonna",
            "Marco Colombo",
            "Aldebrand Ludenhof",
            "Balthasar Gelt",
            "Boris Todbringer",
            "Brunner the bounty hunter",
            "Constant Drachenfel",
            "Detlef Sierc",
            "Karl Franz",
            "Kurt Helborg",
            "Ludwig Schwarzhelm",
            "Luthor Huss",
            "Magnus the Pious",
            "Mathias Thulmann",
            "Markus Wulfhart",
            "Marius Leitdorf",
            "Morgan Bernhard",
            "Sigmar Heldenhammer",
            "Thyrus Gormann",
            "Valten",
            "Valmir von Raukov",
            "Volkmar 'the Grim' von Hindenstern",
            "Tzarina Katarin",
            "Tzar Boris",
            "Abhorash",
            "Arkhan the Black",
            "Dieter Hellsnicht",
            "Doomlord of Middenheim",
            "Dread King",
            "Genevieve Dieudonnè",
            "Hand of Ualapt",
            "Heinrich Kemmler the Lichemaster",
            "High Priest Herak",
            "Khalida Neferher",
            "Krell, Lord of Undeath",
            "Lady Melissa d'Arque",
            "Melkhior",
            "Luthor Harkon",
            "Nagash",
            "Neferata",
            "The Red Duke",
            "Settra",
            "Ushoran",
            "Usirian's Keeper",
            "Vlad Von Carstein",
            "Walach",
            "W'soran",
            "Melchior",
            "Zacharias the Everliving",
            "Deathmaster Snikch",
            "Grey Seer Thanquol",
            "Ikit Claw",
            "Lurk Snitchtongue",
            "Plague Lord Nurglitch",
            "Lord Skrolk",
            "Skweel Gnawtooth",
            "Thrott the Unclean",
            "Tretch Craventail",
            "Warlord Queek",
            "Greasus Goldtooth",
            "Skrag the Slaughterer",
            "Jhared the Red",
            "Golgfag Maneater",
            "Bragg the Gutsman",
            "Ghark Ironskin",
            "Lord Mazdamundi",
            "Venerable Lord Kroak",
            "Kroq-gar",
            "Grymloq",
            "Nakai",
            "Tehenauin",
            "Adohi-Tehga Lord of Tlaxtlan",
            "Chakax the eternity warden",
            "Oxyotl",
            "Tetto'Eko",
            "Tiktaq'To",
            "Ten Zlati",
            "Yin-tuan"
          ],
          "locations": [
            "Averland",
            "Hochland",
            "Middenland",
            "Nordland",
            "Ostermark",
            "Ostland",
            "Reikland",
            "Stirland",
            "Tilea",
            "Estalia",
            "Kislev",
            "Lustria",
            "Ulthuan",
            "Naggaroth",
            "The Hinterlands of Khuresh",
            "Nippon",
            "Cathay",
            "The Ind",
            "Araby",
            "Talabecland",
            "The Chaos Wastes",
            "The Badlands",
            "Karaz Ankor",
            "The Southlands",
            "Lustria",
            "Troll Country",
            "Norsca",
            "The Dragon Isles",
            "Khemri",
            "Zorn Uzkul",
            "The Dark Lands",
            "Altdorf",
            "Mordheim",
            "Nuln",
            "Middenheim",
            "The Moot",
            "Talabheim",
            "Wissenland",
            "Barak Varr",
            "Grimhold",
            "Karaz-a-Karak",
            "Karak Angazbar",
            "Karak Angkul",
            "Karak Azgal",
            "Karak Azgaraz",
            "Karak Azul",
            "Karak Bhufdar",
            "Karak Eight Peaks",
            "Karak Eksfilaz",
            "Karak Gantuk",
            "Karak Grom",
            "Karak Hirn",
            "Karak Izor",
            "Karak Kadrin",
            "Karak Kaferkammaz",
            "Karak Norn",
            "Karak Ziflin",
            "Karak Zorn",
            "Zhufbar",
            "Kraka Dorden",
            "Kraka Drak",
            "Kraka Ornsmotek",
            "Kraka Ravnsvake",
            "Black Fortress",
            "The Daemon's Stump",
            "Gash Kadrak",
            "The Gates of Zharr",
            "The Tower of Gorgoth",
            "Uzkulak",
            "Zharr-Naggrund",
            "Karak Dum",
            "Karak Vlag",
            "Karak Varn",
            "Red Eye Mountain",
            "Black Crag",
            "Ekrund",
            "Mount Silverspear",
            "Silver Pinnacle",
            "Karak Zorn",
            "Couronne",
            "L'Anguille",
            "Lyonesse",
            "Artois",
            "Gisoreux",
            "Mousilion",
            "Bordeleaux",
            "Bastonne",
            "Montfort",
            "Aquitaine",
            "Brionne",
            "Quenelles",
            "Parravon",
            "Carcassone",
            "Forest of Loren",
            "The Marches of Couronne",
            "Naggarond",
            "Ghrond",
            "Karond Kar",
            "Hag Graef",
            "Har Ganeth",
            "Clar Karond",
            "Palace of Joyous Oblivion",
            "Ravager of Souls",
            "Talon of Agony",
            "Fortress of Eternal Torture",
            "Citadel of Ecstatic Damnation",
            "Citadel of Desolation",
            "Temple of Spite",
            "Ultimate Oblivion",
            "Tower of Oblivion",
            "Claw of Dominion",
            "Tower of Blessed Dread",
            "Ark of Naggor",
            "Eataine",
            "Avelorn",
            "Cothique",
            "Yvresse",
            "Chrace",
            "Ellyrion",
            "Tiranoc",
            "Saphery",
            "Caledor",
            "Shadowlands",
            "Arnheim",
            "Fortress of Dawn",
            "Citadel of Dusk",
            "Hexoatl",
            "Tlaxtlan",
            "Xlanhuapec",
            "Itza",
            "Zlatlan",
            "Chaqua",
            "Xhotl",
            "Quetza",
            "Chupayotl",
            "Culchan Plains",
            "Nuevo Luccini",
            "Santa Magritta",
            "Skeggi",
            "Cactus Coast",
            "The Isthmus of Pahaux",
            "Iron Mountains",
            "Altar of Ultimate Darkness",
            "Cold Water Lakes",
            "Plain of Spiders",
            "Broken Lands",
            "Pits of Zardok",
            "Doom Glades",
            "Athel Loren",
            "Forest of Arnheim",
            "Ironsand Desert",
            "Isle of Great Beasts",
            "Plain of Dogs",
            "Kraken Lake",
            "Wyvern Lake",
            "Witch Sea",
            "Tyrant Peak",
            "Ashen Coast",
            "Boiling Sea",
            "Red Desert",
            "Sea of Malice",
            "The Monoliths",
            "Hotek's Column",
            "Granite Hills",
            "Spine of Sotek",
            "Copper Desert",
            "Bogenhafen",
            "Bechafen",
            "Essen",
            "Feifdorf",
            "Hergig",
            "Praag",
            "Erengrad",
            "Remas",
            "Miragliano",
            "Luciano",
            "Mountains of Mourn",
            "The Great Bastion",
            "Nan-Gau",
            "Weijin",
            "Warpstone Desert",
            "Reikwald",
            "Dreikwald",
            "The Gryphon Wood",
            "The Grey Mountains",
            "Black Fire Pass",
            "Mad Dog Pass",
            "The Silver Peaks",
            "The Brass Keep",
            "The City of Spires",
            "Isle of Wights",
            "Forge of the Old Ones",
            "Bel Aliad",
            "Copher",
            "El-Haikk",
            "El-Kalabad",
            "Lashiek",
            "Martek",
            "Palace of the Wizard Caliph",
            "Sudenberg",
            "Gulf of Medes",
            "The Great Mortis River",
            "Khemri",
            "Zandri",
            "Numas",
            "Quatar",
            "Bhagar",
            "Rasetra",
            "Mahrak",
            "Lybaras",
            "Lahmia",
            "Ka-Sabar"
          ],
          "quotes": [
            "If the battlements are carried, throw all your strength there. Such an advantage is allways darely won.",
            "Walls can't dodge!",
            "The softest part of a castle is the belly of the man inside.",
            "The gods have seen fit to populate the Old World with all manner of foul monsters. They've also seen fit to grant me with a keen eye and a strong bow to hunt them with.",
            "Grimgor iz da best!",
            "The only good stunty is a dead stunty, and the only thing better than a dead stunty is a dyin' stunty who tells yer where to find 'is mates.",
            "Stamp and trample! Gore and crush!",
            "Then came one they called Gibberkin. No fouler thing have I ever witnessed.",
            "Tear down their totems, befoul their colours! Kill the kings and burn the priests! Into the mud with them, break their skulls and eat their hearts!",
            "Their walls will fall. Their faith will fail. Their flesh will tear.",
            "Manling coins are like their words: never trust them. Use your weighing scales and keep your axe handy!",
            "No Rest until the Blood of Greenskins flows like Dark Ale upon the Earth!",
            "We are the chosen of Asuryan, beloved of the gods and heirs to the world. Our armies are the finest in creation; swift where our foes are lumbering, cultured where they are barbaric. Give no thought to failure, nor defeat – we are the Children of Ulthuan and we shall prevail.",
            "Before Elves, before Dwarfs, before Men, the Old Ones arrived upon this world. Then came Chaos and the Great Plan of the Old Ones was unmade. We are the last of their servants, and only by our hand shall the Great Plan be restored, with the total defeat of the usurping younger races.",
            "At the time of the three hundredth cycle of this world, the two moons shall unite and summon forth the Rodent God and his evil spawn to deliver plague and pestilence upon the land named Lustria",
            "The more we study our inner light, the more profound becomes the outer darkness.",
            "There is wisdom and there is ignorance, and in between are the gateways to eternity through which the Old Ones so long ago passed.",
            "Pass me another Itxi grub.",
            "Your doom is coming, man-things.",
            "Skaven society is a tyranny moderated by assassination.",
            "Yes-yes Warlord Krizk - for a treaty-pledge of just 200 Slaves, 12 claws of warptokens, a Breeder and certain alliances and pledges, one of our very-very finest Clan Moulder Rat Ogres can be yours...",
            "Kill-Kill!",
            "All tunnels lead to Skavenblight",
            "Please, come in and join me for dinner. I can see from the way you dress, you are a man of exquisite...taste",
            "Surrender and serve me in life, or die and slave for me in death.",
            "Awake O Dead, for there can be no rest for ye beneath the earth. Let the splintered bones burrow from the grave pall. Let cold fingers grip time-worn blades, and unseeing eyes survey the fields of slaughter. For your time has come once more. And the dead shall walk.",
            "Athel Loren shall not suffer the presence of Men, nor Orcs, nor Dwarfs, nor Beastmen. If a foe takes a single step upon such sacred soil, they shall not take another.",
            "The new mountains gave us shelter... We made fire in their mouths... The tribes split the lands... The Tyrants roared and fought... There were many kingdoms... It was good for many winters... The tribes grew and grew too much. Now we follow the sun once more...",
            "The Ogres were born long ago... Big, strong and fat... The little round ones by our side... We ate and drank till our guts filled...",
            "Then came the plains and the tribes... Beast, sun, grass, wind, earth... The Sunrisers gave us fire... We fought for them and ate their young...",
            "A great tooth comet came... It grew closer by the day... Fire roared in the sky... Killed the night and drove the beast mad...",
            "The Maw was born from the fire... The earth shook at its coming... The flames ate many tribes... To the mountains some fled...",
            "The hungry flame sat in our guts...We ate the mountains to put it out... but the fire was still there...We climbed further still...We ate the Tall Ones' herds... Cavebeast was good meat... We climbed the peaks... Above the skies the giants dwell...",
            "Thinlings came in great wheel huts... We ate them and took the shinny things..."
          ]
        },
        "witcher": {
          "books": [
            "The Last Wish",
            "Sword of Destiny",
            "Blood of Elves",
            "Time of Contempt",
            "Baptism of Fire",
            "The Tower of the Swallow",
            "The Lady of the Lake",
            "Season of Storms"
          ],
          "characters": [
            "Triss Merigold",
            "Shani",
            "Philippa Eilhart",
            "Dandelion",
            "King Radovid",
            "King Foltest",
            "King Henselt",
            "King Demavend",
            "Zoltan Chivay",
            "Thaler",
            "Ciri",
            "Yennefer of Vengerberg",
            "Keira Metz",
            "Anna Strenger",
            "Birna Bran",
            "Jenge Frett",
            "Uma",
            "Vernon Roche",
            "Ves",
            "Donar an Hindar",
            "Dudu Biberveldt",
            "Emhyr van Emreis",
            "Emiel Regis Rohellec Terzieff-Godefroy",
            "Eredin",
            "Caranthir",
            "Imlerith",
            "Nithral",
            "Olgierd von Everec",
            "Skjall",
            "Sigismund Dijkstra",
            "Avallac'h",
            "Pavetta",
            "Whoreson Junior",
            "The Bloody Baron",
            "Johnny",
            "Gaunter O'Dimm",
            "Vilgefortz",
            "Iorveth",
            "Fringilla Vigo",
            "Morvran Voorhis",
            "Crach an Craite",
            "Jan Calveit",
            "Francesca Findabair",
            "Carthia van Canten",
            "Sabrina Glevissig",
            "Calanthe",
            "Roach",
            "Ermion",
            "Priscilla",
            "Margarita Laux-Antille",
            "Milva",
            "Maria Louisa La Valette",
            "Stefan Skellen",
            "Assire var Anahid",
            "Mousesack",
            "Hjalmar an Craite",
            "Yarpen Zigrin",
            "Dethmold",
            "Eithné",
            "Isengrim",
            "Yaevinn",
            "Nenneke",
            "Jan Natalis",
            "Bran an Tuirseach",
            "Menno Coehoorn",
            "Schirrú",
            "Milton de Peyrac-Peyran",
            "Vattier de Rideaux",
            "Palmerin de Launfal",
            "Tibor Eggebracht",
            "Esterad Thyssen",
            "Joachim de Wett",
            "Brouver Hoog",
            "Aglaïs",
            "Xarthisius",
            "Aelirenn",
            "Adam Pangratt",
            "Sweers",
            "Sheldon Skaggs",
            "Carduin",
            "Albrich",
            "Zyvik",
            "Saskia",
            "Sigrdrifa",
            "Addario Bach"
          ],
          "locations": [
            "Aedd Gynvael",
            "Aldersberg",
            "Beauclair",
            "Cidaris",
            "Cintra",
            "Gors Velen",
            "Maribor",
            "Novigrad",
            "Oxenfurt",
            "Tretogor",
            "Vengerberg",
            "Vizima",
            "Ard Carraigh",
            "Bremervoord",
            "Brugge",
            "Claremont",
            "Creyden",
            "Fen Aspra",
            "Hengfors",
            "Lan Exeter",
            "Pont Vanis",
            "Lyria",
            "Maecht",
            "Malleore",
            "Metinna",
            "Nilfgaard",
            "Neunreuth",
            "Rakverelin",
            "Rivia",
            "Thurn",
            "Acorn Bay",
            "Anchor",
            "Assengard",
            "Attre",
            "Ban Ard",
            "Ban Gleán",
            "Barefield",
            "Belhaven",
            "Blaviken",
            "Brenna",
            "Breza",
            "Burdorff",
            "Caelf",
            "Carreras",
            "Craag An",
            "Crinfrid",
            "Daevon",
            "Dillingen",
            "Dorian",
            "Druigh",
            "Dudno",
            "Duén Canell",
            "Dun Dâre",
            "Ellander",
            "Eysenlaan",
            "Fano",
            "Foam",
            "Forgeham",
            "Fox Hollow",
            "Ghelibol",
            "Glyswen",
            "Gulet",
            "Hochebuz",
            "Jealousy",
            "Kaczan",
            "Kagen",
            "Kerack",
            "Kernow",
            "Klucz",
            "Knotweed Meadow",
            "Little Marsh",
            "Lower Posada",
            "Malhoun",
            "Mirt",
            "Murivel",
            "New Ironworks",
            "Porog",
            "Riedbrune",
            "Rinde",
            "Roggeveen",
            "Tegamo",
            "Tigg",
            "Tridam",
            "Tyffi",
            "Unicorn",
            "Upper Posada",
            "Vattweir",
            "Vole",
            "White Bridge",
            "Zavada",
            "Armeria",
            "Baldhorn",
            "Ban Gleán",
            "Beauclair",
            "Bodrog",
            "Carcano",
            "Castel Ravello",
            "Darn Dyffra",
            "Darn Rowan",
            "Darn Ruach",
            "Dillingen",
            "Dorndal",
            "Drakenborg",
            "Fen Aspra",
            "Glevitzingen",
            "Gwendeith",
            "Hagge",
            "Houtborg",
            "Kaer Morhen",
            "Kaer Trolde",
            "Leyda",
            "Loc Grim",
            "Mayena",
            "Mirt",
            "Montecalvo",
            "Montsalvat",
            "Nastrog",
            "Razwan",
            "Red Binduga",
            "Rocayne",
            "Rhys-Rhun",
            "Riedbrune",
            "Rozrog",
            "Sarda",
            "Scala",
            "Schwemmland",
            "Spalla",
            "Stygga",
            "Tigg",
            "Vartburg",
            "Vedette",
            "Vidort",
            "Winneburg",
            "Zurbarran",
            "Est Haemlet",
            "Loc Muinne",
            "Shaerrawedd"
          ],
          "monsters": [
            "Archespore",
            "Berserker",
            "Botchling",
            "Lubberkin",
            "Ulfhedinn",
            "Werewolf",
            "The Toad Prince",
            "Basilisk",
            "Cockatrice",
            "Forktail",
            "Royal Wyvern",
            "Shrieker",
            "Silver Basilisk",
            "Slyzard Matriarch",
            "Slyzard",
            "Dragon of Fyresdal",
            "Wyvern",
            "Djinn",
            "Earth Elemental",
            "Fire Elemental",
            "Gargoyle",
            "Golem",
            "Hound of the Wild Hunt",
            "Ice Elemental",
            "Pixie",
            "Apiarian Phantom",
            "Therazane",
            "Ekhidnae",
            "Erynias",
            "Griffin",
            "Harpy",
            "Melusine",
            "Opinicus",
            "Salma",
            "Siren",
            "Succubus",
            "Arachas",
            "Arachnomorph",
            "Endrega Drone",
            "Endrega Warrior",
            "Endrega Worker",
            "Giant Centipede",
            "Kikimore",
            "Kikimore Worker",
            "Pale Widow",
            "Abaya",
            "Alghoul",
            "Drowner",
            "Foglet",
            "Ghoul",
            "Grave Hag",
            "Ignis Fatuus",
            "Mourntart",
            "Mucknixer",
            "Rotfiend",
            "Scurver",
            "Spotted Wight",
            "Water Hag",
            "Wight",
            "Cloud Giant",
            "Cyclopse",
            "Golyat",
            "Hagubman",
            "Ice Giant",
            "Ice Troll",
            "Nekker",
            "Rock Troll",
            "Wham-a-Wham",
            "Chort",
            "Crone",
            "Doppler",
            "Fiend",
            "Fugas",
            "Godling",
            "Grottore",
            "Howler",
            "Imp",
            "Kernun",
            "Leshen",
            "Morvudd",
            "Shaelmaar",
            "Spriggan",
            "Sylvan",
            "The Caretaker",
            "Barghests",
            "Ethereal",
            "Hym",
            "Longlocks",
            "Nightwraith",
            "Noonwraith",
            "Penitent",
            "Plague Maiden",
            "Umbra",
            "Wraith",
            "Alp",
            "Bruxa",
            "Ekimmara",
            "Gael",
            "Garkain",
            "Higher Vampire",
            "Katakan"
          ],
          "potions": [
            "Cat",
            "Healing brew",
            "Gadwall",
            "Tawny Owl",
            "Wolf",
            "Rook",
            "Swallow",
            "Golden Oriole",
            "Tiara",
            "Stammelford's philtre",
            "Maribor Forest",
            "Lapwing",
            "Virga",
            "White Raffard's Decoction",
            "Brock",
            "Petri's Philter",
            "Thunderbolt",
            "Mongoose",
            "Visionary's potion",
            "Anabolic steroids"
          ],
          "quotes": [
            "A true witcher should never abandon poultry in distress.",
            "Bear! Bear! Run, you stupid piece of shit!",
            "Black And White",
            "Ciri And The White Frost",
            "Don't Blame Yourself",
            "Evil Is Evil",
            "First soldier you see'll kill you ... Boots. He'll kill you for your boots.",
            "I Can Hear Your Heart",
            "I run into dilemmas all the time. Situations where it's hard to judge, hard to know what's right, make a decision. This is not one of them. You disgust me. And deserve to die.",
            "Keep the gods out of it. Swear on your heads. Which I will take if you break your vow.",
            "Legend Becomes A Prophecy",
            "Magic Endures",
            "Poultry In Distress",
            "Save Them From Themselves",
            "Shut Your Trap",
            "Someone Worse",
            "Strip Men Of Their Humanity",
            "The Coin Has To Be Right",
            "The Witcher You Slew",
            "There's nothing behind me. I'm a witcher, I'd have heard it. Just like I can hear your heart. Which is pounding ... like a liar's.",
            "This Is My Story",
            "Time eats away at memories, distorts them. Sometimes we only remember the good ... sometimes only the bad.",
            "Unruly Child",
            "What the fuck was that?",
            "Where'd you complete your training? School of the Snail?",
            "Who taught you to fight like this? ... The witcher you slew.",
            "Why men throw their lives away attacking an armed witcher ... I'll never know. Something about my face?",
            "Wind's howling.",
            "Witchers were made to kill monsters. It doesn't matter who posted the notice, the coin has to be right, that's all.",
            "Write Your Will",
            "You don't need mutations to strip men of their humanity. I've seen plenty of examples.",
            "Just five more minutes… Is it 1358 yet? No? Then fuck off!",
            "Finish all your business before you die. Bid loved ones farewell. Write your will. Apologize to those you’ve wronged. Otherwise, you’ll never truly leave this world.",
            "Hide the wenches, Witcher's coming!!",
            "Oh year... the Elder Blood can be fiery",
            "Damn, Eskel... you got an hourglass figure",
            "No Lollygagin!",
            "You get what you get and be happy with it",
            "I'll stick me boot so far up yer arse your tongue'll taste like wench twat"
          ],
          "schools": [
            "Wolf",
            "Griffin",
            "Cat",
            "Viper",
            "Manticore",
            "Bear"
          ],
          "signs": [
            "Aard",
            "Igni",
            "Yrden",
            "Quen",
            "Axii",
            "Heliotrop"
          ],
          "witchers": [
            "Geralt of Rivia",
            "Coën",
            "Vesemir",
            "Eskel",
            "Lambert",
            "Letho of Gulet",
            "Ciri",
            "George of Kagen",
            "Jerome Moreau",
            "Auckes",
            "Serrit",
            "Kolgrim",
            "Ivar Evil-Eye",
            "Junod of Belhaven",
            "Gerd"
          ]
        },
        "world_of_warcraft": {
          "class_names": [
            "Death Knight",
            "Demon Hunter",
            "Druid",
            "Hunter",
            "Mage",
            "Monk",
            "Paladin",
            "Priest",
            "Rogue",
            "Shaman",
            "Warlock",
            "Warrior"
          ],
          "heros": [
            "Gul'dan",
            "Durotan",
            "Khadgar",
            "Orgrim Doomhammer",
            "Medivh",
            "Blackhand",
            "Anduin Lothar",
            "Garona Halforcen",
            "Antonidas",
            "King Llane Wrynn",
            "Moroes",
            "Lady Taria",
            "Jaina Proudmoore",
            "Illidan Stormrage",
            "Kael'thas Sunstrider",
            "Archimonde",
            "Kil'jaeden",
            "Mannoroth",
            "Ner'zhul",
            "Sargeras",
            "Balnazzar",
            "Magtheridon",
            "Mal'Ganis",
            "Brann Bronzebeard",
            "Muradin Bronzebeard",
            "Sylvanas Windrunner",
            "Malfurion Stormrage",
            "Millhouse Manastorm",
            "Anduin Lothar",
            "Arthas Menthil",
            "Bolvar Fordragon",
            "Uther the Lightbringer",
            "Varian Wrynn"
          ],
          "quotes": [
            "An'u belore delen'na.",
            "Anaria Shola.",
            "Bal'a dash, malanore.",
            "Glory to the Sin'dorei.",
            "Our enemies will fall!",
            "State your business.",
            "The dark times will pass.",
            "The Eternal Sun guides us.",
            "Victory lies ahead!",
            "We will persevere!",
            "What business have you?",
            "Death to all who oppose us!",
            "Hold your head high.",
            "Keep your wits about you.",
            "Remember the Sunwell.",
            "Sela'ma ashal'anore!",
            "Shorel'aran.",
            "Stay the course",
            "The reckoning is at hand!",
            "Time is of the essence.",
            "We will have justice!",
            "Ah, you have a death wish.",
            "I do not suffer fools easily.",
            "I had little patience to begin with!",
            "Mind yourself.",
            "Not very intelligent, are you?",
            "Run away pest!",
            "These are dark times indeed.",
            "Why do you linger?",
            "You waste my time.",
            "Choose wisely.",
            "Do not loiter.",
            "Everything has a price.",
            "I have one of a kind items.",
            "What do you seek?",
            "Your gold is welcome here.",
            "Glory to the Sin'dorei.",
            "State your Business!",
            "Anu'belore Dela'na.",
            "The Eternal Sun guides us.",
            "What Business have you?",
            "Victory lies ahead.",
            "Our enemies will fall.",
            "Anaria'shoala.",
            "You waste my time.",
            "I had little patience to begin with.",
            "It is a wonder you have lived this long.",
            "Ah, you have a death wish.",
            "I sell only the finest goods.",
            "Your gold is welcome here.",
            "Everything has a price.",
            "Do not loiter."
          ],
          "races": [
            "Draenei",
            "Dwarf",
            "Gnome",
            "Human",
            "Night elf",
            "Worgen",
            "Void elf",
            "Lightforged",
            "Dark Iron",
            "Kul Tiran",
            "Pandaren",
            "Blood elf",
            "Goblin",
            "Orc",
            "Tauren",
            "Troll",
            "Undead",
            "Nightborne",
            "Highmountain",
            "Mag'har",
            "Zandalari"
          ]
        },
        "zelda": {
          "characters": [
            "Abe",
            "Agahnim",
            "Akh Va'quot",
            "Alder",
            "Anju",
            "Anju's Mother",
            "Aryll",
            "Astrid",
            "Aveil",
            "Baby Goron",
            "Bagu",
            "Barta",
            "Beedle",
            "Belari",
            "Beth",
            "Biggoron",
            "Bipin",
            "Bipin and Blossom's son",
            "Blade Brothers",
            "Blaino",
            "Blossom",
            "Bombers",
            "Borlov",
            "Bosh Kala",
            "Bow-Wow",
            "Brocco",
            "Bugut",
            "Cado",
            "Calip",
            "Captain",
            "Carlov",
            "Carpenters",
            "Chaas Qeta",
            "Champions",
            "Chef Bear",
            "Cheval",
            "Chio",
            "Christine",
            "Ciela",
            "Colin",
            "Comedians",
            "Cotera",
            "Crazy Tracy",
            "Cucco Keeper",
            "Curiosity Shop Guy",
            "Cyclos",
            "Daag Chokah",
            "Dah Kaso",
            "Daka Tuss",
            "Dalia",
            "Damia",
            "Dampe",
            "Dampé",
            "Dan Hesho",
            "Daphnes Nohansen Hyrule",
            "Daqa Koth",
            "Darmani III",
            "Darton",
            "Daruk",
            "Darunia",
            "Daz",
            "Decci",
            "Deities",
            "Dekki",
            "Deku Royalty",
            "Deku Tree Sprout",
            "Dento",
            "Deppi",
            "Dimitri",
            "Din",
            "Doc Bandam",
            "Dorian",
            "Dr.Troy",
            "Eddo",
            "Ember",
            "Embry",
            "Epona",
            "Ezlo",
            "Fado",
            "Fairies",
            "Fairy",
            "Fairy Queen",
            "Farore",
            "Festari",
            "Fishermen",
            "Fishman",
            "Flat",
            "Forest Minish",
            "Fortune Teller",
            "Ganon",
            "Ganondorf",
            "Garadon",
            "Garill",
            "Gentari",
            "Ghost",
            "Gibdo Man",
            "Golden Chief Cylos",
            "Gongoron",
            "Gorman",
            "Goron Elder",
            "Grandma",
            "Grandma Ulrira",
            "Great Deku Tree",
            "Great Fairies",
            "Great Fairy",
            "Great Moblin",
            "Greta",
            "Grog",
            "Gruve",
            "Guru-Guru",
            "Ha Dahamar",
            "Happy Mask Salesman",
            "Hetsu",
            "Hila Rao",
            "Hino",
            "Hurdy Gurdy Man",
            "Hylia",
            "Ilia",
            "Impa",
            "Indigo-Go's",
            "Ingo",
            "Isha",
            "Ja Baij",
            "Jabun",
            "Jee Noh",
            "Jitan Sa'mi",
            "Joel",
            "Joute",
            "Ka'o Makagh",
            "Ka'o Muakagh",
            "Kaam Ya'tak",
            "Kaepora Gaebora",
            "Kafei",
            "Kah Mael",
            "Kalm Yu'ogh",
            "Kam Urog",
            "Kamaro",
            "Kass",
            "Katah Chuki",
            "Kaya Wan",
            "Kayo",
            "Keaton",
            "Keh Namut",
            "Keo Ruug",
            "Kiki",
            "Killer Bees",
            "King Daltus",
            "King Dorephan",
            "King Zora",
            "King of Hyrule",
            "King of Red Lions",
            "Knights of Hyrule",
            "Kohga",
            "Komali",
            "Koume and Kotake",
            "Kuhn Sidajj",
            "Lakna Rokee",
            "Laruto",
            "Lasli",
            "Leaf",
            "Lenzo",
            "Liana",
            "Librari",
            "Linebeck",
            "Link",
            "Link (Goron)",
            "Link's Uncle",
            "Lord Jabu-Jabu",
            "Louise",
            "Maag Halan",
            "Maca",
            "Mad Batter",
            "Madam Aroma",
            "Madam MeowMeow",
            "Magda",
            "Maggie and her father",
            "Main Antagonist",
            "Majora's Mask (Boss)",
            "Makar",
            "Maku Tree",
            "Malena",
            "Malo",
            "Malon",
            "Marot",
            "Mamamu Yan",
            "Mamu",
            "Manbo",
            "Maple",
            "Marathon Man",
            "Marin",
            "Martha",
            "Mayor Dotour",
            "Mayor Hagen",
            "Medigoron",
            "Melari",
            "Mellie",
            "Mesa",
            "Midna",
            "Mido",
            "Mikau",
            "Mila and her father",
            "Mils",
            "Mina",
            "Mipha",
            "Misae Suma",
            "Mo'a Keet",
            "Monkey",
            "Moosh",
            "Mountain Minish",
            "Mr. Barten",
            "Mr. Write",
            "Mrs. Marie",
            "Mrs. Ruul",
            "Mutoh",
            "Muwo Jeem",
            "Muzu",
            "Myahm Agana",
            "Nabooru",
            "Nanna",
            "Natie",
            "Navi",
            "Nayru",
            "Ne'ez Yohma",
            "Neri",
            "Nightmare",
            "No'Ez Yohma",
            "Noya Neha",
            "Nyave",
            "Nyeve",
            "Oakif",
            "Old Lady from Bomb Shop",
            "Old Man",
            "Old Men",
            "Old Wayfarer",
            "Old Woman",
            "Olkin",
            "Oman Au",
            "Onox",
            "Ooccoo",
            "Orca",
            "Oshus",
            "Owa Daim",
            "Owl",
            "Padok",
            "Paya",
            "Pamela",
            "Papahl and family",
            "Patch",
            "Percy",
            "Photographer",
            "Pina",
            "Plen",
            "Plikango",
            "Poe salesman",
            "Postman",
            "Potho",
            "Prince Ralis",
            "Prince Sidon",
            "Prince of Hyrule",
            "Princess Ruto",
            "Princess Zelda",
            "Professor Shikashi",
            "Pumaag Nitae",
            "Purah",
            "Queen Ambi",
            "Queen Rutela",
            "Quill",
            "Qukah Nata",
            "Rabbits",
            "Ralph",
            "Rauru",
            "Reagah",
            "Ree Dahee",
            "Rem",
            "Renado",
            "Rensa",
            "Revali",
            "Rhoam Bosphoramus Hyrule",
            "Richard",
            "Ricky",
            "Riju",
            "Rik",
            "Rito Chieftain",
            "Robbie",
            "Rola",
            "Romani and Cremia",
            "Rosa",
            "Rosa Sisters",
            "Rose",
            "Rota Ooh",
            "Ruul",
            "Sages",
            "Sagessa",
            "Sahasrahla",
            "Sakon",
            "Sale",
            "Salvatore",
            "Saria",
            "Sayge",
            "Schule Donavitch",
            "Sha Warvo",
            "Shae Loya",
            "Shai Utoh",
            "Sharp",
            "Shee Vaneer",
            "Sheh Rata",
            "Sheik",
            "Sheikah Monk",
            "Shibo",
            "Shiro",
            "Shop Keeper",
            "Shopkeeper",
            "Shrine Maidens",
            "Simon",
            "Skull Kid",
            "Smith",
            "Soh Kofi",
            "Sokra",
            "Sophie",
            "Sorelia",
            "Sprinn",
            "Steen",
            "Stockwell",
            "Sturgeon",
            "Subrosian Queen",
            "Sue-Belle",
            "Symin",
            "Syrup",
            "Ta'log Naeg",
            "Ta'loh Naeg",
            "Tael",
            "Tahno O'ah",
            "Talo",
            "Talon",
            "Tarin",
            "Tasho",
            "Tasseren",
            "Tatl",
            "Teba",
            "Teller of Treasures",
            "Telma",
            "Tena Ko'sah",
            "Tetra",
            "The Pirates",
            "Tingle",
            "Toffa",
            "Toh Yahsa",
            "Tokkey",
            "Tona",
            "Torfeau",
            "Toto",
            "Toto Sah",
            "Tott",
            "Town Minish",
            "Traveling Merchants",
            "Trissa",
            "Turtle",
            "Twinrova",
            "Tye",
            "Ulrira",
            "Urbosa",
            "Vaati",
            "Valoo",
            "Vasu",
            "Veran",
            "Vilia",
            "Viscen",
            "Wahgo Katta",
            "Walrus",
            "Walton",
            "Wheaton and Pita",
            "Wind Fish",
            "Wolf Link",
            "Yah Rin",
            "Yammo",
            "Yeta",
            "Yeto",
            "Yiga Clan",
            "Yunobo",
            "Zalta Wa",
            "Zant",
            "Zauz",
            "Ze Kasho",
            "Zelda",
            "Zephos",
            "Zill",
            "Zooki",
            "Zunari"
          ],
          "games": [
            "A Link to the Past",
            "Breath of the Wild",
            "Four Swords",
            "Link's Awakening",
            "Majora's Mask",
            "Ocarina of Time",
            "Oracle of Seasons - Oracle of Ages",
            "Phantom Hourglass",
            "The Legend of Zelda",
            "The Minish Cap",
            "The Wind Waker",
            "Twilight Princess",
            "Zelda II: Adventure of Link"
          ],
          "items": [
            "Blue Ring",
            "Red Ring",
            "Wooden Sword",
            "White Sword",
            "Magical Sword",
            "Small Shield",
            "Magical Shield",
            "Boomerang",
            "Magical Boomerang",
            "Bomb",
            "Book of Magic",
            "Magical Rod",
            "Arrow",
            "Silver Arrow",
            "Bow",
            "Raft",
            "Stepladder",
            "Heart Container",
            "Blue Candle",
            "Red Candle",
            "Recorder",
            "Power Bracelet",
            "Magical Key",
            "Food",
            "Life Potion",
            "2nd Potion",
            "Magic Container",
            "1-up Doll",
            "Candle",
            "Hammer",
            "Handy Glove",
            "Boots",
            "Flute",
            "Cross",
            "Trophy",
            "Water of Life",
            "Fighter's Sword",
            "Master Sword",
            "Tempered Sword",
            "Golden Sword",
            "Fighter's Shield",
            "Red Shield",
            "Mirror Shield",
            "Magic Hammer",
            "Pendant of Courage",
            "Pendant of Wisdom",
            "Pendant of Power",
            "Zora's Flippers",
            "Super Bomb",
            "Bottle",
            "Quake Medallion",
            "Ether Medallion",
            "Bombos Medallion",
            "Bug-Catching Net",
            "Piece of Heart",
            "Cane of Somaria",
            "Cane of Byrna",
            "Power Glove",
            "Titan's Mitt",
            "Magic Cape",
            "Book of Mudora",
            "Hookshot",
            "Fire Rod",
            "Ice Rod",
            "Pegasus Boots",
            "Magic Mirror",
            "Sword",
            "Shield",
            "Roc's Feather",
            "Power Bracelet L-2",
            "Magic Powder",
            "Shovel",
            "Flippers",
            "Magic Potion",
            "Kokiri Sword",
            "Giant's Knife",
            "Biggoron's Sword",
            "Deku Shield",
            "Hylian Shield",
            "Kokiri Tunic",
            "Zora Tunic",
            "Goron Tunic",
            "Fairy Ocarina",
            "Ocarina of Time",
            "Silver Scale",
            "Golden Scale",
            "Deku Seed",
            "Deku Seeds Bullet Bag",
            "Fairy Slingshot",
            "Fairy Bow",
            "Quiver",
            "Bomb Bag",
            "Goron's Bracelet",
            "Silver Gauntlets",
            "Golden Gauntlets",
            "Din's Fire",
            "Farore's Wind",
            "Nayru's Love",
            "Longshot",
            "Megaton Hammer",
            "Kokiri Boots",
            "Iron Boots",
            "Hover Boots",
            "Gold Skulltula Tokens",
            "Odd Mushroom",
            "Odd Potion",
            "Poacher's Saw",
            "World's Finest Eye Drops",
            "Eyeball Frog",
            "Red Potion",
            "Green Potion",
            "Blue Potion",
            "Fairy",
            "Keaton Mask",
            "Goron Mask",
            "Zora Mask",
            "Gerudo Mask",
            "Mask of Truth",
            "Deku Nuts",
            "Deku Sticks",
            "Spiritual Stones",
            "Fire Arrow",
            "Ice Arrow",
            "Light Arrow",
            "Lens of Truth",
            "Razor Sword",
            "Gilded Sword",
            "Great Fairy's Sword",
            "Hero's Shield",
            "Bombers' Notebook",
            "Hero's Bow",
            "Postman's Hat",
            "Blast Mask",
            "Great Fairy's Mask",
            "Giant's Mask",
            "Romani's Mask",
            "Bunny Hood",
            "Bremen Mask",
            "Garo's Mask",
            "Gibdo Mask",
            "Captain's Hat",
            "Don Gero's Mask",
            "Deku Mask",
            "Fierce Deity's Mask",
            "Kafei's Mask",
            "Couple's Mask",
            "All-Night Mask",
            "Mask of Scents",
            "Circus Leader's Mask",
            "Noble Sword",
            "Wooden Shield",
            "Iron Shield",
            "Gasha Seed",
            "Seed Rings",
            "Seed Satchel",
            "Ember Seed",
            "Scent Seed",
            "Gale Seed",
            "Pegasus Seed",
            "Mystery Seed",
            "Harp of Ages",
            "Bombchu",
            "Strange Flute",
            "Ricky's Flute",
            "Moosh's Flute",
            "Dimitri's Flute",
            "Seed Shooter",
            "Switch Hook",
            "Mermaid Suit",
            "Long Hook",
            "Rod of Seasons",
            "Bombs",
            "Slingshot",
            "Hyper Slingshot",
            "Magnetic Gloves",
            "Roc's Cape",
            "Four Sword",
            "Gnat Hat",
            "Bow-Wow",
            "Hero's Sword",
            "Power Bracelets",
            "Hero's Charm",
            "Deku Leaf",
            "Skull Hammer",
            "Bottles",
            "Wind Waker",
            "Sail",
            "Telescope",
            "Grappling Hook",
            "Magic Armor",
            "Tingle Tuner",
            "Picto Box",
            "Deluxe Picto Box",
            "Arrows",
            "Moon Pearl",
            "Smith's Sword",
            "Picori Sword/White Sword/Four Sword",
            "Light Arrows",
            "Remote Bombs",
            "Gust Jar",
            "Cane of Pacci",
            "Mole Mitts",
            "Flame Lantern",
            "Ocarina of Wind",
            "Grip Ring",
            "Ordon Sword",
            "Ordon Shield",
            "Hawkeye",
            "Gale Boomerang",
            "Clawshot",
            "Double Clawshots",
            "Spinner",
            "Ball and Chain",
            "Dominion Rod",
            "Fishing Rod",
            "Water Bombs",
            "Bomblings",
            "Horse Call",
            "Oshus's Sword",
            "Phantom Sword",
            "Phantom Hourglass",
            "Pure Metals",
            "Regal Necklace",
            "Recruit's Sword",
            "Lokomo Sword",
            "Lokomo Song",
            "Spirit Flute",
            "Whirlwind",
            "Whip",
            "Sand Wand",
            "Tears of Light",
            "Bow of Light",
            "Compass of Light",
            "Stamp Book",
            "Shield of Antiquity",
            "Recruit Uniform",
            "Engineer's Clothes",
            "Engineer Certificate",
            "Practice Sword",
            "Sailcloth",
            "Adventure Pouch",
            "Goddess Sword",
            "Banded Shield",
            "Braced Shield",
            "Divine Shield",
            "Fortified Shield",
            "Goddess Shield",
            "Reinforced Shield",
            "Sacred Shield",
            "Scattershot",
            "Big Bug Net",
            "Beetle",
            "Hook Beetle",
            "Quick Beetle",
            "Tough Beetle",
            "Digging Mitts",
            "Gust Bellows",
            "Goddess's Harp",
            "Water Dragon's Scale",
            "Iron Bow",
            "Sacred Bow",
            "Fireshield Earrings",
            "Mogma Mitts",
            "Forgotten Sword",
            "Master Sword Lv2",
            "Master Sword Lv3",
            "Green Tunic",
            "Blue Mail",
            "Red Mail",
            "Stamina Scroll",
            "Bell",
            "Lost Maiamai",
            "Master Ore",
            "Nice Bow",
            "Tornado Rod",
            "Nice Tornado Rod",
            "Nice Hammer",
            "Nice Bombs",
            "Nice Hookshot",
            "Sand Rod",
            "Nice Sand Rod",
            "Nice Fire Rod",
            "Nice Ice Rod",
            "Nice Boomerang",
            "Lamp",
            "Super Lamp",
            "Super Net",
            "Scoot Fruit",
            "Foul Fruit"
          ],
          "locations": [
            "Akkala Ancient Tech Lab",
            "East Akkala Stable",
            "Lomei Labyrinth Island",
            "Skull Lake",
            "South Akkala Stable",
            "Tarrey Town",
            "Ze Kasho Shrine",
            "Applean Forest",
            "Central Tower",
            "Gleeok Bridge",
            "Hyrule Castle",
            "Hyrule Castle Town Ruins",
            "Kam Yatakh Shrine",
            "Outpost Ruins",
            "Outskirt Stable",
            "Riverside Stable",
            "Rota Ooh Shrine",
            "Sacred Ground Ruins",
            "Safula Hill",
            "Serenne Stable",
            "Tabantha Bridge Stable",
            "Wetland Stable",
            "Afromsia Coast",
            "Camphor Pond",
            "Chaas Qeta Shrine",
            "Cliffs of Quince",
            "Deepback Bay",
            "Ebon Mountain",
            "Equestrian Riding Course",
            "Fir River",
            "Firly Plateau",
            "Firly Pond",
            "Fort Hateno",
            "Ginner Woods",
            "Hateno Bay",
            "Hateno Beach",
            "Hateno Tower",
            "Hateno Village",
            "Kam Urog Shrine",
            "Kitano Bay",
            "Lake Jarrah",
            "Lake Sumac",
            "Lanayru Bluff",
            "Lanayru Heights",
            "Lanayru Promenade",
            "Lanayru Range",
            "Lanayru Road - East Gate",
            "Lanayru Road - West Gate",
            "Loshlo Harbor",
            "Madorna Mountain",
            "Mapla Point",
            "Marblod Plain",
            "Midla Woods",
            "Mount Lanayru",
            "Myahm Agana Shrine",
            "Naydra Snowfield",
            "Necluda Sea",
            "Nirvata Lake",
            "Ovli Plain",
            "Phalian Highlands",
            "Pierre Plateau",
            "Purifier Lake",
            "Quatta's Shelf",
            "Rabia Plain",
            "Retsam Forest",
            "Robred Dropoff",
            "Solewood Range",
            "Tenoko Island",
            "Trotter's Downfall",
            "Walnot Mountain",
            "Zelkoa Pond",
            "Abandoned North Mine",
            "Bridge of Eldin",
            "Broca Island",
            "Cephla Lake",
            "Darb Pond",
            "Darunia Lake",
            "Death Caldera",
            "Death Mountain",
            "Death Mountain Summit",
            "Eldin Canyon",
            "Eldin's Flank",
            "Eldin Great Skeleton",
            "Eldin Mountains",
            "Eldin Tower",
            "Foothill Stable",
            "Gero Pond",
            "Goro Cove",
            "Gollow River",
            "Gorko Lake",
            "Gorko Tunnel",
            "Goron City",
            "Goron Hot Springs",
            "Goronbi Lake",
            "Goronbi River",
            "Gortram Cliff",
            "Gut Check Rock",
            "Isle of Rabac",
            "Lake Darman",
            "Lake Ferona",
            "Lake Intenouch",
            "Maw of Death Mountain",
            "Medingo Pool",
            "Southern Mine",
            "Stolock Bridge",
            "Trilby Valley",
            "Damel Forest",
            "Darybon Plains",
            "Dracozu Lake",
            "Dracozu River",
            "Faron Grasslands",
            "Faron Sea",
            "Faron Woods",
            "Finra Woods",
            "Floria Falls",
            "Fural Plain",
            "Guchini Plain",
            "Harker Lake",
            "Herin Lake",
            "Harfin Valley",
            "Highland Stable",
            "Ibara Butte",
            "Keelay Plain",
            "Komo Shoreline",
            "Lake Floria",
            "Lake Hylia",
            "Lake of the Horse God",
            "Lakeside Stable",
            "Laverra Beach",
            "Malanya Spring",
            "Menoat River",
            "Mount Floria",
            "Nautelle Wetlands",
            "Nette Plateau",
            "Oseira Plains",
            "Papetto Grove",
            "Parache Plains",
            "Puffer Beach",
            "Riola Spring",
            "Sarjon Woods",
            "Spring of Courage",
            "Tobio's Hollow",
            "Zokassa Ridge",
            "Zonai Ruins",
            "Arbiter's Grounds",
            "East Barrens",
            "East Gerudo Ruins",
            "Dragon's Exile",
            "Gerudo Desert Gateway",
            "Gerudo Town",
            "Great Cliffs",
            "Great Gerudo Skeleton",
            "Karusa Valley",
            "Northern Icehouse",
            "Palu Wasteland",
            "Sand-Seal Rally",
            "Southern Oasis",
            "Toruma Dunes",
            "West Barrens",
            "West Gerudo Ruins",
            "Birida Lookout",
            "Champion's Gate",
            "Cliffs of Ruvara",
            "Daval Peak",
            "East Gerudo Mesa",
            "Gerudo Canyon",
            "Gerudo Canyon Pass",
            "Gerudo Canyon Stable",
            "Gerudo Summit",
            "Hemaar's Descent",
            "Koukot Plateau",
            "Laparoh Mesa",
            "Meadela's Mantle",
            "Mount Agaat",
            "Mount Granajh",
            "Mount Nabooru",
            "Mystathi's Shelf",
            "Nephra Hill",
            "Risoka Snowfield",
            "Rutimala Hill",
            "Sapphia's Table",
            "South Lomei Labyrinth",
            "Spectacle Rock",
            "Statue of the Eighth Heroine",
            "Stalry Plateau",
            "Taafei Hill",
            "Vatorsa Snowfield",
            "Yarna Valley",
            "Yiga Clan Hideout",
            "Zirco Mesa",
            "Korok Forest",
            "Lost Woods",
            "Thims Bridge",
            "Woodland Stable",
            "Woodland Tower",
            "Great Plateau",
            "Eastern Abbey",
            "Forest of Spirits",
            "Great Plateau Tower",
            "Hopper Pond",
            "Ja Baij Shrine",
            "Keh Namut Shrine",
            "Mount Hylia",
            "Oman Au Shrine",
            "Owa Daim Shrine",
            "River of the Dead",
            "Shrine of Resurrection",
            "Temple of Time",
            "Woodcutter's House",
            "Hebra Tower",
            "Snowfield Stable",
            "Lanayru Wetlands",
            "Mount Lanayru",
            "Ralis Pond",
            "Veiled Falls",
            "Zora's Domain",
            "Ancient Columns",
            "Cuho Mountain",
            "Dronoc's Pass",
            "Hebra Plunge",
            "Kolami Bridge",
            "Lake Totori",
            "Nero Hill",
            "Passer Hill",
            "Piper Ridge",
            "Rayne Highlands",
            "Rito Village",
            "Rito Stable",
            "Rospro Pass",
            "Strock Lake",
            "Tabantha Tower",
            "Ash Swamp",
            "Batrea Lake",
            "Big Twin Bridge",
            "Blatchery Plain",
            "Bonooru's Stand",
            "Bosh Kala Shrine",
            "Bubinga Forest",
            "Deya Lake",
            "Dueling Peaks",
            "Dueling Peaks Stable",
            "Dueling Peaks Tower",
            "East Post Ruins",
            "Floret Sandbar",
            "Fort Hateno",
            "Hickaly Woods",
            "Hila Rao Shrine",
            "Hills of Baumer",
            "Horwell Bridge",
            "Hylia River",
            "Kakariko Bridge",
            "Kakariko Village",
            "Lake Siela",
            "Lantern Lake",
            "Mable Ridge",
            "Mount Rozudo",
            "Nabi Lake",
            "Oakle's Navel",
            "Pillars of Levia",
            "Popla Foothills",
            "Proxim Bridge",
            "Ree Dahee Shrine",
            "Sahasra Slope",
            "Scout's Hill",
            "South Nabi Lake",
            "Spring of Courage",
            "Squabble River",
            "West Nabi Lake"
          ]
        }
      },
      "gender": {
        "binary_types": [
          "Female",
          "Male"
        ],
        "short_binary_types": [
          "f",
          "m"
        ],
        "types": [
          "Female",
          "Male",
          "Non-binary",
          "Agender",
          "Genderfluid",
          "Genderqueer",
          "Bigender",
          "Polygender"
        ]
      },
      "ghostbusters": {
        "actors": [
          "Bill Murray",
          "Dan Aykroyd",
          "Sigourney Weaver",
          "Harold Ramis",
          "Rick Moranis",
          "Annie Potts",
          "Ernie Hudson"
        ],
        "characters": [
          "Dr. Peter Venkman",
          "Dr. Raymond Stantz",
          "Dana Barrett",
          "Dr. Egon Spengler",
          "Louis Tully",
          "Janine Melnitz",
          "Winston Zeddmore"
        ],
        "quotes": [
          "This city is headed for a disaster of biblical proportions.",
          "What he means is Old Testament, Mr. Mayor, real wrath of God type stuff.",
          "Human sacrifice, dogs and cats living together... mass hysteria!",
          "Ray, when someone asks you if you're a god, you say 'YES'!",
          "Gozer the Traveler. He will come in one of the pre-chosen forms. During the rectification of the Vuldrini, the traveler came as a large and moving Torg! Then, during the third reconciliation of the last of the McKetrick supplicants, they chose a new form for him: that of a giant Slor! Many Shuvs and Zuuls knew what it was to be roasted in the depths of the Slor that day, I can tell you!",
          "Don't cross the streams.",
          "Try to imagine all life as you know it stopping instantaneously and every molecule in your body exploding at the speed of light.",
          "Total protonic reversal.",
          "Do you believe in UFOs, astral projections, mental telepathy, ESP, clairvoyance, spirit photography, telekinetic movement, full trance mediums, the Loch Ness monster and the theory of Atlantis?",
          "It's the Stay Puft Marshmallow Man.",
          "We came, we saw, we kicked its ass!",
          "Ray has gone bye-bye, Egon... what've you got left?",
          "Sorry, Venkman, I'm terrified beyond the capacity for rational thought.",
          "Why worry? Each one of us is carrying an unlicensed nuclear accelerator on his back.",
          "There is no Dana, there is only Zuul.",
          "Symmetrical book stacking. Just like the Philadelphia mass turbulence of 1947.",
          "You're very handy, I can tell. I bet you like to read a lot, too.",
          "Oh, that's very fascinating to me. I read a lot myself. Some people think I'm too intellectual but I think it's a fabulous way to spend your spare time. I also play racquetball. Do you have any hobbies?",
          "I collect spores, molds, and fungus.",
          "Are you troubled by strange noises in the middle of the night?",
          "Do you experience feelings of dread in your basement or attic?",
          "Have you or your family ever seen a spook, spectre or ghost?",
          "Our courteous and efficient staff is on call 24 hours a day to serve all your supernatural elimination needs.",
          "We're ready to believe you.",
          "That's the bedroom, but nothing ever happened in there.",
          "You have been a participant in the biggest interdimensional cross rip since the Tunguska blast of 1909!",
          "We'd like to get a sample of your brain tissue.",
          "Gozer the Gozerian... good evening. As a duly designated representative of the City, County and State of New York, I order you to cease any and all supernatural activity and return forthwith to your place of origin or to the nearest convenient parallel dimension.",
          "I am the Keymaster! The Destructor is coming. Gozer the Traveler, the Destroyer.",
          "I am Vinz, Vinz Clortho, Keymaster of Gozer. Volguus Zildrohar, Lord of the Sebouillia. Are you the Gatekeeper?",
          "Hey, he pulls the wagon, I made the deals. You want a ride?",
          "Wait for the sign. Then our prisoners will be released.",
          "You will perish in flame, you and all your kind! Gatekeeper!",
          "If I'm wrong, nothing happens! We go to jail - peacefully, quietly. We'll enjoy it! But if I'm *right*, and we *can* stop this thing... Lenny, you will have saved the lives of millions of registered voters.",
          "The whole building is a huge, superconductive antenna that was designed and built expressly for the purpose of pulling in and concentrating spiritual turbulence. Your girlfriend lives in the corner penthouse... of Spook Central.",
          "She's not my girlfriend. I find her interesting because she's a client and because she sleeps above her covers... FOUR FEET above her covers. She barks, she drools, she claws!",
          "Listen... you smell something?",
          "I'm Winston Zeddmore, Your Honor. I've only been with the company for a couple of weeks, but these things are real. Since I joined these men, I've seen shit that'll turn you white.",
          "Somebody blows their nose and wanna keep it?",
          "I tried to think of the most harmless thing. Something I loved from my childhood. Something that could never ever possibly destroy us. Mr. Stay Puft!",
          "Some are people who just want attention. Others, just nutballs who come in off the street.",
          "Generally you don't see that kind of behavior in a major appliance.",
          "Hello, Ghostbusters... Yes, of course they're serious... You do?... You have?... No kidding! Just gimme the address... Oh sure, they will be totally discreet. Thank you!",
          "I feel like the floor of a taxi cab.",
          "As they say in T.V., I'm sure there's one big question on everybody's mind, and I imagine you are the man to answer that. How is Elvis, and have you seen him lately?",
          "Hee hee hee! 'Get her!'' That was your whole plan, huh, 'get her.' Very scientific.",
          "OK... so... she's a dog...",
          "Ray, pretend for a moment that I don't know anything about metallurgy, engineering, or physics, and just tell me what the hell is going on.",
          "I'm gonna take back some of the things I said about you, Egon.",
          "Tell him about the Twinkie.",
          "Sir, what you had there is what we refer to as a focused, non-terminal, repeating phantasm or a class-five full-roaming vapor. A real nasty one, too.",
          "Coming through! One class-five full-roaming vapor. Move 'em out.",
          "Hey, wait a minute. Hey, hey, hey, hey, hey! Hold it! Now, are we actually gonna go before a federal judge, and tell him that some moldy Babylonian god is going to drop in on Central Park West, and start tearing up the city?",
          "You know, you don't act like a scientist.",
          "You're more like a game show host.",
          "Well, this is great. If the ionization-rate is constant for all ectoplasmic entities, we can really bust some heads... in a spiritual sense, of course.",
          "I make it a rule never to get involved with possessed people.",
          "Some moron brought a cougar to a party and it went berserk.",
          "And then she threw me out of her life. She thought I was a creep, she thought I was a geek, and she probably wasn't the first.",
          "I think this building should be condemned. There's serious metal fatigue in all the load-bearing members, the wiring is substandard, it's completely inadequate for our power needs, and the neighborhood is like a demilitarized zone.",
          "Wow. This place is great. When can we move in? You gotta try this pole. I'm gonna get my stuff. Hey. We should stay here. Tonight. Sleep here. You know, to try it out.",
          "Venkman, shorten your stream! I don't want my face burned off!",
          "He slimed me.",
          "I'm studying the effects of negative reinforcement on ESP ability",
          "Let's say this Twinkie represents the normal amount of psychokinetic energy in the New York area. According to this morning's sample, it would be a twinkie... 35 feet long and weighing approximately 600 pounds.",
          "That's a big Twinkie.",
          "We could on the verge of a fourfold cross-reap. A P.K.E. surge of incredible, even dangerous proportions!",
          "Of course you forget, Peter. I was present at an undersea, unexplained mass sponge migration.",
          "Uhhh... this magnificent feast here represents the LAST of the petty cash.",
          "Your theories are the worst kind of popular tripe, your methods are sloppy, and your conclusions are highly questionable. You are a poor scientist, Dr. Venkman!",
          "I think we can get her a guest shot on 'Wild Kingdom.' I just whacked her up with about 300 cc's of Thorazaine... she's gonna take a little nap now.",
          "Everybody can relax, I found the car. Needs some suspension work and shocks. Brakes, brake pads, lining, steering box, transmission, rear-end.",
          "Maybe now you'll never slime a guy with a positron collider, huh?",
          "So, what are we doing today, Zuul?",
          "We must prepare for the coming of Gozer.",
          "We've neutronized it, you know what that means? A complete particle reversal.",
          "We have the tools, and we have the talent!",
          "Okay, Ghostbusters. The mayor wants to see you guys. The whole island's going crazy. Let's go.",
          "The structure of this roof cap is exactly like the kind of telemetry tracker that NASA uses to identify dead pulsars in deep space.",
          "Nobody ever made them like this! The architect was either a certified genius, or an authentic wacko.",
          "Nice thinking, Ray.",
          "It's true, your honor. The man is some kind of rodent, I don't know which.",
          "Is it just a mist, or does it have arms and legs?",
          "Nice doggy. Cute little pooch. Maybe I've got a Milk-Bone."
        ]
      },
      "grateful_dead": {
        "players": [
          "Jerry Garcia",
          "Bob Weir",
          "Bill Kreutzmann",
          "Phil Lesh",
          "Ron McKernan",
          "Robert Hunter",
          "Brent Mydland",
          "Donna Jean Godchaux",
          "Keith Godchaux",
          "Bruce Hornsby",
          "John Barlow"
        ],
        "songs": [
          "Touch of Grey",
          "Althea",
          "Ripple",
          "Truckin",
          "Eyes of the World",
          "Scarlet Begonias",
          "Friend of the Devil",
          "Uncle Johns Band",
          "China Cat Sunflower",
          "Fire on the Mountain",
          "Sugar Magnolia",
          "I Know You Rider",
          "Franklins Tower",
          "Me and My Uncle",
          "Box of Rain",
          "Sugaree",
          "St Stephen",
          "Jack Straw",
          "Morning Dew",
          "Wharf Rat",
          "The Other One",
          "Casey Jones",
          "Hurts Me Too",
          "Dark Star",
          "Brokedown Palace",
          "Playing in the Band",
          "Cumberland Blues",
          "New Speedway Boogie",
          "US Blues",
          "The Music Never Stopped",
          "Black Muddy River",
          "Looks Like Rain",
          "Bird Song",
          "Cassidy"
        ]
      },
      "greek_philosophers": {
        "names": [
          "Plato",
          "Aristotle",
          "Pythagoras",
          "Heraclitus",
          "Parmenides",
          "Democritus",
          "Zeno of Elea",
          "Epicurus",
          "Anaxagoras",
          "Diogenes",
          "Antisthenes",
          "Gorgias",
          "Hippocrates",
          "Plutarch",
          "Proclus",
          "Chrysippus",
          "Solon",
          "Archimedes",
          "Thucydides",
          "Arcesilaus",
          "Posidonius",
          "Galen"
        ],
        "quotes": [
          "Quality is not an act, it is a habit.",
          "Only the educated are free.",
          "Control thy passions lest they take vengence on thee.",
          "Love is composed of a single soul inhabiting two bodies.",
          "Rhetoric is the art of ruling the minds of men.",
          "The unexamined life is not worth living.",
          "There was never a genius without a tincture of madness.",
          "Dignity does not consist in possessing honors, but in deserving them.",
          "Most people would rather give than get affection.",
          "Beware the barrenness of a busy life.",
          "The secret to humor is surprise.",
          "Pleasure in the job puts perfection in the work.",
          "Philosophy is the highest music.",
          "The virtue of justice consists in moderation, as regulated by wisdom.",
          "Know how to listen, and you will profit even from those who talk badly.",
          "A few vices are sufficient to darken many virtues.",
          "It is impossible to begin to learn that which one thinks one already knows.",
          "It's not what happens to you, but how you react to it that matters.",
          "The mind is not a vessel to be filled but a fire to be kindled.",
          "Good habits formed at youth make all the difference."
        ]
      },
      "hacker": {
        "abbreviation": [
          "TCP",
          "HTTP",
          "SDD",
          "RAM",
          "GB",
          "CSS",
          "SSL",
          "AGP",
          "SQL",
          "FTP",
          "PCI",
          "AI",
          "ADP",
          "RSS",
          "XML",
          "EXE",
          "COM",
          "HDD",
          "THX",
          "SMTP",
          "SMS",
          "USB",
          "PNG",
          "SAS",
          "IB",
          "SCSI",
          "JSON",
          "XSS",
          "JBOD"
        ],
        "adjective": [
          "auxiliary",
          "primary",
          "back-end",
          "digital",
          "open-source",
          "virtual",
          "cross-platform",
          "redundant",
          "online",
          "haptic",
          "multi-byte",
          "bluetooth",
          "wireless",
          "1080p",
          "neural",
          "optical",
          "solid state",
          "mobile"
        ],
        "ingverb": [
          "backing up",
          "bypassing",
          "hacking",
          "overriding",
          "compressing",
          "copying",
          "navigating",
          "indexing",
          "connecting",
          "generating",
          "quantifying",
          "calculating",
          "synthesizing",
          "transmitting",
          "programming",
          "parsing"
        ],
        "noun": [
          "driver",
          "protocol",
          "bandwidth",
          "panel",
          "microchip",
          "program",
          "port",
          "card",
          "array",
          "interface",
          "system",
          "sensor",
          "firewall",
          "hard drive",
          "pixel",
          "alarm",
          "feed",
          "monitor",
          "application",
          "transmitter",
          "bus",
          "circuit",
          "capacitor",
          "matrix"
        ],
        "verb": [
          "back up",
          "bypass",
          "hack",
          "override",
          "compress",
          "copy",
          "navigate",
          "index",
          "connect",
          "generate",
          "quantify",
          "calculate",
          "synthesize",
          "input",
          "transmit",
          "program",
          "reboot",
          "parse"
        ]
      },
      "hackers": {
        "characters": [
          "Dade Murphy",
          "Kate Libby",
          "Emmanuel Goldstein",
          "Ramόn Sánchez",
          "Paul Cook",
          "Joey Pardella",
          "Eugene Belford",
          "Margo Wallace",
          "Hal",
          "Lauren Murphy",
          "Special Agent Richard Gill",
          "Special Agent Ray",
          "Special Agent Bob"
        ],
        "handles": [
          "Zero Cool",
          "Crash Override",
          "Acid Burn",
          "Cereal Killer",
          "The Phantom Phreak",
          "Lord Nikon",
          "The Plague",
          "Razor",
          "Blade"
        ],
        "quotes": [
          "Hack the Planet!",
          "There is no right or wrong, only fun and boring",
          "Mess with the best, die like the rest",
          "This is the end, my friend. Thank you for calling",
          "Never send a boy to do a woman's job",
          "We have no names, man. No names. We are nameless!",
          "Kid, don't threaten me. There are worse things than death, and uh, I can do all of them",
          "I got a photographic memory. It's a curse!",
          "Remember, hacking is more than just a crime. It's a survival trait",
          "This is our world now. The world of the electron and the switch. The beauty of the baud. We exist without nationality, skin color, or religious bias. You wage wars, murder, cheat, lie to us and try to make us believe it's for our own good, yet we're the criminals. Yes, I am a criminal. My crime is that of curiosity. I am a hacker and this is my manifesto. You may stop me, but you can't stop us all",
          "God gave men brains larger than dogs so they wouldn't hump women's legs at cocktail parties",
          "There is no right and wrong. There's only fun and boring",
          "Never fear, I is here",
          "It's stupid, man. It's universally stupid",
          "Yo, I kinda feel like God",
          "That's it, you're looking at it. He just looks slick all day",
          "Well, it looks like I'm on top",
          "Congratulations. No one's ever beat her before. You just made an enemy for life",
          "Pool on the roof must have a leak",
          "Whoa, this isn't wood shop class?",
          "I hope you don't screw like you type",
          "I don't play well with others",
          "Anything else? You want me to mow the lawn? Oops forgot, New York, no grass",
          "It's in that place where I put that thing that time",
          "RISC is good"
        ]
      },
      "harry_potter": {
        "books": [
          "Harry Potter and the Sorcerer's Stone",
          "Harry Potter and the Chamber of Secrets",
          "Harry Potter and the Prisoner of Azkaban",
          "Harry Potter and the Goblet of Fire",
          "Harry Potter and the Order of the Phoenix",
          "Harry Potter and the Half-Blood Prince",
          "Harry Potter and the Deathly Hallows"
        ],
        "characters": [
          "Hannah Abbott",
          "Bathsheda Babbling",
          "Ludo Bagman",
          "Bathilda Bagshot",
          "Marcus Belby",
          "Katie Bell",
          "Cuthbert Binns",
          "Phineas Nigellus Black",
          "Regulus Arcturus Black",
          "Sirius Black",
          "Broderick Bode",
          "Bogrod",
          "Amelia Bones",
          "Susan Bones",
          "Terry Boot",
          "Mr. Borgin",
          "Lavender Brown",
          "Millicent Bulstrode",
          "Charity Burbage",
          "Frank Bryce",
          "Alecto Carrow",
          "Amycus Carrow",
          "Reginald Cattermole",
          "Mary Cattermole",
          "Cho Chang",
          "Penelope Clearwater",
          "Mrs. Cole",
          "Michael Corner",
          "Vincent Crabbe, Sr.",
          "Vincent Crabbe",
          "Dennis Creevey",
          "Dirk Cresswell",
          "Bartemius Crouch, Sr.",
          "Barty Crouch, Jr.",
          "Roger Davies",
          "John Dawlish",
          "Fleur Delacour",
          "Gabrielle Delacour",
          "Dedalus Diggle",
          "Amos Diggory",
          "Cedric Diggory",
          "Armando Dippet",
          "Elphias Doge",
          "Antonin Dolohov",
          "Aberforth Dumbledore",
          "Albus Dumbledore",
          "Ariana Dumbledore",
          "Dudley Dursley",
          "Marge Dursley",
          "Petunia Dursley",
          "Vernon Dursley",
          "Marietta Edgecombe",
          "Everard",
          "Arabella Figg",
          "Argus Filch",
          "Justin Finch-Fletchley",
          "Seamus Finnigan",
          "Marcus Flint",
          "Nicholas Flamel",
          "Mundungus Fletcher",
          "Filius Flitwick",
          "Florean Fortescue",
          "Cornelius Fudge",
          "Marvolo Gaunt",
          "Merope Gaunt",
          "Morfin Gaunt",
          "Anthony Goldstein",
          "Goyle Sr.",
          "Gregory Goyle",
          "Heromine Granger",
          "Gregorovitch",
          "Fenrir Greyback",
          "Gellert Grindelwald",
          "Wilhelmina Grubbly-Plank",
          "Godric Gryffindor",
          "Astoria Greengrass",
          "Rubeus Hagrid",
          "Rolanda Hooch",
          "Mafalda Hopkirk",
          "Helga Hufflepuff",
          "Angelina Johnson",
          "Lee Jordan",
          "Bertha Jorkins",
          "Igor Karkaroff",
          "Viktor Krum",
          "Bellatrix Lestrange",
          "Rabastan Lestrange",
          "Rodolphus Lestrange",
          "Gilderoy Lockhart",
          "Alice Longbottom",
          "Augusta Longbottom",
          "Frank Longbottom",
          "Neville Longbottom",
          "Luna Lovegood",
          "Xenophilius Lovegood",
          "Remus Lupin",
          "Walden Macnair",
          "Draco Malfoy",
          "Lucius Malfoy",
          "Narcissa Malfoy",
          "Madam Malkin",
          "Griselda Marchbanks",
          "Olympe Maxime",
          "Ernie Macmillan",
          "Minerva McGonagall",
          "Cormac McLaggen",
          "Graham Montague",
          "Alastor (Mad-Eye) Moody",
          "Moran",
          "Theodore Nott",
          "Bob Ogden",
          "Garrick Ollivander",
          "Pansy Parkinson",
          "Padma Patil",
          "Parvati Patil",
          "Peter Pettigrew",
          "Antioch Peverell",
          "Cadmus Peverell",
          "Ignotus Peverell",
          "Irma Prince",
          "Sturgis Podmore",
          "Poppy Pomfrey",
          "Harry Potter",
          "James Potter",
          "Lily Potter",
          "Fabian Prewett",
          "Gideon Prewett",
          "Quirinus Quirrell",
          "Helena Ravenclaw (The Grey Lady)",
          "Rowena Ravenclaw",
          "Tom Marvolo Riddle",
          "Mr. Roberts",
          "Demelza Robins",
          "Augustus Rookwood",
          "Albert Runcorn",
          "Scabior",
          "Newt Scamander",
          "Rolf Scamander",
          "Rufus Scrimgeour",
          "Kingsley Shacklebolt",
          "Stan Shunpike",
          "Aurora Sinistra",
          "Rita Skeeter",
          "Horace Slughorn",
          "Salazar Slytherin",
          "Hepzibah Smith",
          "Zacharias Smith",
          "Severus Snape",
          "Alicia Spinnet",
          "Pomona Sprout",
          "Pius Thicknesse",
          "Dean Thomas",
          "Andromeda Tonks",
          "Nymphadora Tonks",
          "Ted Tonks",
          "Travers",
          "Sybill Trelawney",
          "Wilky Twycross",
          "Dolores Jane Umbridge",
          "Emmeline Vance",
          "Romilda Vane",
          "Septima Vector",
          "Lord Voldemort",
          "Myrtle Warren",
          "Cassius Warrington",
          "Arthur Weasley",
          "Bill Weasley",
          "Charlie Weasley",
          "Fred Weasley",
          "George Weasley",
          "Ginny Weasley",
          "Molly Weasley",
          "Percy Weasley",
          "Ron Weasley",
          "Oliver Wood",
          "Kennilworthy Whisp",
          "Yaxley",
          "Blaise Zabini",
          "Aragog",
          "Bane",
          "Beedle the Bard",
          "The Bloody Baron",
          "Buckbeak",
          "Sir Cadogan",
          "Crookshanks",
          "Dobby",
          "Enid",
          "Errol",
          "Fang",
          "The Fat Friar",
          "Fridwulfa",
          "The Fat Lady",
          "Fawkes",
          "Firenze",
          "Fluffy",
          "Grawp",
          "Griphook",
          "Hedwig",
          "Hokey",
          "Kreacher",
          "Magorian",
          "Moaning Myrtle",
          "Mrs. Norris",
          "Great Aunt Muriel",
          "Nagini",
          "Nearly Headless Nick",
          "Norbert",
          "Peeves",
          "Pigwidgeon",
          "Madam Rosmerta",
          "Ronan",
          "Scabbers",
          "Trevor",
          "Winky"
        ],
        "houses": [
          "Gryffindor",
          "Slytherin",
          "Ravenclaw",
          "Hufflepuff",
          "Horned Serpent",
          "Wampus",
          "Thunderbird",
          "Pukwudgie"
        ],
        "locations": [
          "The Burrow",
          "Godric's Hollow",
          "Little Hangleton",
          "Malfoy Manor",
          "Number 12, Grimmauld Place",
          "Shell Cottage",
          "Sinner's End",
          "Beauxbatons",
          "Castelobruxo",
          "Durmstrang",
          "Hogwarts",
          "Ilvermorny",
          "Mahoutokoro",
          "Uagadou",
          "Diagon Alley",
          "Eeylops Owl Emporium",
          "Florean Fortescue's Ice Cream Parlour",
          "Flourish & Blotts",
          "Gambol and Japes",
          "Gringotts Wizarding Bank",
          "Knockturn Alley",
          "Borgin & Burkes",
          "The Leaky Cauldron",
          "Madam Malkin's Robes for All Occasions",
          "Magical Menagerie",
          "Ollivanders",
          "Potage's Cauldron Shop",
          "Quality Quidditch Shop",
          "Slug and Jiggers Apothecary",
          "Stalls",
          "Twilfitt and Tatting's",
          "Weasleys' Wizard Wheezes",
          "Wiseacre's Wizarding Equipment",
          "Hogsmeade",
          "The Three Broomsticks",
          "Honeydukes",
          "Zonko's Joke Shop",
          "Hogsmeade Station",
          "The Hog's Head",
          "Dervish & Banges",
          "Gladrags Wizardwear",
          "Scrivenshaft's Quill Shop",
          "Madam Puddifoot's",
          "Post Office",
          "Shrieking Shack",
          "Azkaban",
          "Ministry of Magic",
          "St. Mungo's Hospital for Magical Maladies and Injuries",
          "Numengard",
          "Platform 9 3/4"
        ],
        "quotes": [
          "It does not do to dwell on dreams and forget to live.",
          "It takes a great deal of bravery to stand up to our enemies, but just as much to stand up to our friends.",
          "To the well-organized mind, death is but the next great adventure.",
          "It is our choices, Harry, that show what we truly are, far more than our abilities.",
          "Happiness can be found even in the darkest of times if only one remembers to turn on the light.",
          "If you want to know what a man’s like, take a good look at how he treats his inferiors, not his equals.",
          "Dark and difficult times lie ahead. Soon we must all face the choice between what is right and what is easy.",
          "Just because you have the emotional range of a teaspoon doesn’t mean we all have.",
          "We’ve all got both light and dark inside us. What matters is the part we choose to act on. That’s who we really are.",
          "Harry, suffering like this proves you are still a man! This pain is part of being human...the fact that you can feel pain like this is your greatest strength.",
          "Things we lose have a way of coming back to us in the end, if not always in the way we expect.",
          "It is the unknown we fear when we look upon death and darkness, nothing more.",
          "Of course it is happening inside your head, Harry, but why on earth should that mean that it is not real?",
          "Words are in my not-so-humble opinion, the most inexhaustible form of magic we have, capable both of inflicting injury and remedying it.",
          "After all this time? Always.",
          "No story lives unless someone wants to listen. The stories we love best do live in us forever. So whether you come back by page or by the big screen, Hogwarts will always be there to welcome you home.",
          "You're a wizard, Harry.",
          "We could all have been killed - or worse, expelled.",
          "Never trust anything that can think for itself if you can't see where it keeps its brain.",
          "It’s wingardium leviOsa, not leviosAH.",
          "You sort of start thinking anything’s possible if you’ve got enough nerve.",
          "I solemnly swear that I am up to no good.",
          "There are some things you can't share without ending up liking each other, and knocking out a twelve-foot mountain troll is one of them."
        ],
        "spells": [
          "Accio",
          "Alohomora",
          "Avada Kedavra",
          "Crucio",
          "Confundo",
          "Expelliarmus",
          "Expecto Patronum",
          "Lumos",
          "Obliviate",
          "Reparo",
          "Revelio",
          "Riddikulus",
          "Stupefy",
          "Sectumsempra",
          "Wingardium Leviosa"
        ]
      },
      "heroes": {
        "artifacts": [
          "Admiral's Hat",
          "Ambassador's Sash",
          "Amulet of the Undertaker",
          "Angel Feather Arrows",
          "Angel Wings",
          "Angelic Alliance",
          "Armageddon's Blade",
          "Armor of Wonder",
          "Armor of the Damned",
          "Arms of Legion",
          "Badge of Courage",
          "Bird of Perception",
          "Blackshard of the Dead Knight",
          "Boots of Levitation",
          "Boots of Polarity",
          "Boots of Speed",
          "Bow of Elven Cherrywood",
          "Bow of the Sharpshooter",
          "Bowstring of the Unicorn's Mane",
          "Breastplate of Brimstone",
          "Breastplate of Petrified Wood",
          "Buckler of the Gnoll King",
          "Cape of Conjuring",
          "Cape of Velocity",
          "Cards of Prophecy",
          "Celestial Necklace of Bliss",
          "Centaur's Axe",
          "Charm of Mana",
          "Cloak of the Undead King",
          "Clover of Fortune",
          "Collar of Conjuring",
          "Cornucopia",
          "Crest of Valor",
          "Crown of Dragontooth",
          "Crown of the Supreme Magi",
          "Dead Man's Boots",
          "Diplomat's Ring",
          "Dragon Scale Armor",
          "Dragon Scale Shield",
          "Dragon Wing Tabard",
          "Dragonbone Greaves",
          "Elixir of Life",
          "Emblem of Cognizance",
          "Endless Bag of Gold",
          "Endless Purse of Gold",
          "Endless Sack of Gold",
          "Equestrian's Gloves",
          "Everflowing Crystal Cloak",
          "Everpouring Vial of Mercury",
          "Eversmoking Ring of Sulfur",
          "Garniture of Interference",
          "Glyph of Gallantry",
          "Golden Bow",
          "Greater Gnoll's Flail",
          "Head of Legion",
          "Hellstorm Helmet",
          "Helm of Chaos",
          "Helm of Heavenly Enlightenment",
          "Helm of the Alabaster Unicorn",
          "Hourglass of the Evil Hour",
          "Inexhaustible Cart of Lumber",
          "Inexhaustible Cart of Ore",
          "Ladybird of Luck",
          "Legs of Legion",
          "Lion's Shield of Courage",
          "Loins of Legion",
          "Mystic Orb of Mana",
          "Necklace of Dragonteeth",
          "Necklace of Ocean Guidance",
          "Necklace of Swiftness",
          "Ogre's Club of Havoc",
          "Orb of Driving Rain",
          "Orb of Inhibition",
          "Orb of Silt",
          "Orb of Tempestuous Fire",
          "Orb of Vulnerability",
          "Orb of the Firmament",
          "Pendant of Courage",
          "Pendant of Death",
          "Pendant of Dispassion",
          "Pendant of Free Will",
          "Pendant of Holiness",
          "Pendant of Life",
          "Pendant of Negativity",
          "Pendant of Second Sight",
          "Pendant of Total Recall",
          "Power of the Dragon Father",
          "Quiet Eye of the Dragon",
          "Recanter's Cloak",
          "Red Dragon Flame Tongue",
          "Rib Cage",
          "Ring of Conjuring",
          "Ring of Infinite Gems",
          "Ring of Life",
          "Ring of Vitality",
          "Ring of the Magi",
          "Ring of the Wayfarer",
          "Sandals of the Saint",
          "Scales of the Greater Basilisk",
          "Sea Captain's Hat",
          "Sentinel's Shield",
          "Shackles of War",
          "Shield of the Damned",
          "Shield of the Dwarven Lords",
          "Shield of the Yawning Dead",
          "Skull Helmet",
          "Speculum",
          "Spellbinder's Hat",
          "Sphere of Permanence",
          "Spirit of Oppression",
          "Spyglass",
          "Statesman's Medal",
          "Statue of Legion",
          "Still Eye of the Dragon",
          "Stoic Watchman",
          "Surcoat of Counterpoise",
          "Sword of Hellfire",
          "Sword of Judgement",
          "Talisman of Mana",
          "Targ of the Rampaging Ogre",
          "Thunder Helmet",
          "Titan's Cuirass",
          "Titan's Gladius",
          "Titan's Thunder",
          "Tome of Air Magic",
          "Tome of Earth Magic",
          "Tome of Fire Magic",
          "Tome of Water Magic",
          "Torso of Legion",
          "Tunic of the Cyclops King",
          "Vampire's Cowl",
          "Vial of Dragon Blood",
          "Vial of Lifeblood",
          "Wizard's Well"
        ],
        "klasses": [
          "Alchemist",
          "Barbarian",
          "Battle Mage",
          "Beastmaster",
          "Cleric",
          "Death Knight",
          "Demoniac",
          "Druid",
          "Elementalist",
          "Heretic",
          "Knight",
          "Necromancer",
          "Overlord",
          "Planeswalker",
          "Ranger",
          "Warlock",
          "Witch",
          "Wizard"
        ],
        "names": [
          "Adela",
          "Adelaide",
          "Adrienne",
          "Aenain",
          "Aeris",
          "Aine",
          "Aislinn",
          "Ajit",
          "Alagar",
          "Alamar",
          "Alkin",
          "Andra",
          "Arlach",
          "Ash",
          "Astral",
          "Axsis",
          "Ayden",
          "Boragus",
          "Brissa",
          "Broghild",
          "Bron",
          "Caitlin",
          "Calh",
          "Calid",
          "Catherine",
          "Charna",
          "Christian",
          "Ciele",
          "Clancy",
          "Clavius",
          "Coronius",
          "Crag Hack",
          "Cuthbert",
          "Cyra",
          "Dace",
          "Damacon",
          "Daremyth",
          "Darkstorn",
          "Deemer",
          "Dessa",
          "Dracon",
          "Drakon",
          "Edric",
          "Elleshar",
          "Erdamon",
          "Fafner",
          "Fiona",
          "Fiur",
          "Galthran",
          "Gelare",
          "Gelu",
          "Gem",
          "Geon",
          "Gerwulf",
          "Gird",
          "Gretchin",
          "Grindan",
          "Gundula",
          "Gunnar",
          "Gurnisson",
          "Halon",
          "Ignatius",
          "Ignissa",
          "Ingham",
          "Inteus",
          "Iona",
          "Isra",
          "Ivor",
          "Jabarkas",
          "Jaegar",
          "Jeddite",
          "Jenova",
          "Josephine",
          "Kalt",
          "Kilgor",
          "Korbac",
          "Krellion",
          "Kyrre",
          "Labetha",
          "Lacus",
          "Lord Haart",
          "Lord Haart",
          "Lorelei",
          "Loynis",
          "Luna",
          "Malcom",
          "Malekith",
          "Marius",
          "Melodia",
          "Mephala",
          "Merist",
          "Mirlanda",
          "Moandor",
          "Monere",
          "Mutare",
          "Mutare Drake",
          "Nagash",
          "Neela",
          "Nimbus",
          "Nymus",
          "Octavia",
          "Olema",
          "Oris",
          "Orrin",
          "Pasis",
          "Piquedram",
          "Pyre",
          "Rashka",
          "Rion",
          "Rissa",
          "Roland",
          "Rosic",
          "Ryland",
          "Sandro",
          "Sanya",
          "Saurug",
          "Sephinroth",
          "Septienna",
          "Serena",
          "Shakti",
          "Shiva",
          "Sir Mullich",
          "Solmyr",
          "Sorsha",
          "Straker",
          "Styg",
          "Sylvia",
          "Synca",
          "Tamika",
          "Tazar",
          "Terek",
          "Thane",
          "Thant",
          "Thorgrim",
          "Thunar",
          "Tiva",
          "Torosar",
          "Tyraxor",
          "Tyris",
          "Ufretin",
          "Uland",
          "Valeska",
          "Verdish",
          "Vey",
          "Vidomina",
          "Vokial",
          "Voy",
          "Wystan",
          "Xarfax",
          "Xeron",
          "Xsi",
          "Xyron",
          "Yog",
          "Zubin",
          "Zydar"
        ],
        "specialties": [
          "Animate Dead",
          "Archers",
          "Archery",
          "Armorer",
          "Ballista",
          "Basilisks",
          "Behemoths",
          "Beholders",
          "Black Knights",
          "Bless",
          "Bloodlust",
          "Cavaliers",
          "Chain Lightning",
          "Crystal",
          "Cure",
          "Cyclops",
          "Death Ripple",
          "Demons",
          "Dendroids",
          "Devils",
          "Disrupting Ray",
          "Dragons",
          "Dwarves",
          "Eagle Eye",
          "Earth Elementals",
          "Efreeti",
          "Elves",
          "Enchanters",
          "Estates",
          "Fire Elementals",
          "Fire Magic",
          "Fire Wall",
          "Fireball",
          "First Aid",
          "Fortune",
          "Frost Ring",
          "Gargoyles",
          "Gems",
          "Genies",
          "Gnolls",
          "Goblins",
          "Gogs",
          "Gold",
          "Golems",
          "Gorgons",
          "Griffins",
          "Harpies",
          "Haste",
          "Hell Hounds",
          "Hypnotize",
          "Ice Bolt",
          "Imps",
          "Inferno (spell)",
          "Intelligence",
          "Liches",
          "Lizardmen",
          "Logistics",
          "Magi",
          "Magic Arrow",
          "Manticores",
          "Mercury",
          "Meteor Shower",
          "Minotaurs",
          "Monks",
          "Mysticism",
          "Nagas",
          "Navigation",
          "Necromancy",
          "Offense",
          "Ogres",
          "Orcs",
          "Pegasi",
          "Pit Fiends",
          "Prayer",
          "Precision",
          "Psychic Elementals",
          "Resistance",
          "Resurrection",
          "Rocs",
          "Serpent Flies",
          "Sharpshooters",
          "Skeletons",
          "Slayer",
          "Sorcery",
          "Speed",
          "Stone Skin",
          "Sulfur",
          "Swordsmen",
          "Troglodytes",
          "Unicorns",
          "Vampires",
          "Walking Dead",
          "Water Elementals",
          "Weakness",
          "Wights",
          "Wolf Riders",
          "Wyverns"
        ]
      },
      "heroes_of_the_storm": {
        "battlegrounds": [
          "Alterac Pass",
          "Battlefield of Eternity",
          "Blackheart's Bay",
          "Braxis Holdout",
          "Cursed Hollow",
          "Dragon Shire",
          "Garden of Terror",
          "Hanamura Temple",
          "Haunted Mines",
          "Infernal Shrines",
          "Sky Temple",
          "Tomb of the Spider Queen",
          "Towers of Doom",
          "Volskaya Foundry",
          "Warhead Junction"
        ],
        "class_names": [
          "Bruiser",
          "Healer",
          "Melee Assassin",
          "Ranged Assassin",
          "Support",
          "Tank"
        ],
        "heroes": [
          "Abathur",
          "Alarak",
          "Alexstrasza",
          "Ana",
          "Anduin",
          "Anub'arak",
          "Artanis",
          "Arthas",
          "Auriel",
          "Azmodan",
          "Blaze",
          "Brightwing",
          "Cassia",
          "Chen",
          "Cho",
          "Chromie",
          "D.Va",
          "Deckard",
          "Dehaka",
          "Diablo",
          "E.T.C.",
          "Falstad",
          "Fenix",
          "Gall",
          "Garrosh",
          "Gazlowe",
          "Genji",
          "Greymane",
          "Gul'dan",
          "Hanzo",
          "Illidan",
          "Imperius",
          "Jaina",
          "Johanna",
          "Junkrat",
          "Kael'thas",
          "Kel'Thuzad",
          "Kerrigan",
          "Kharazim",
          "Leoric",
          "Li Li",
          "Li-Ming",
          "Lt. Morales",
          "Lunara",
          "Lúcio",
          "Maiev",
          "Mal'Ganis",
          "Malfurion",
          "Malthael",
          "Medivh",
          "Mephisto",
          "Muradin",
          "Murky",
          "Nazeebo",
          "Nova",
          "Orphea",
          "Probius",
          "Ragnaros",
          "Raynor",
          "Rehgar",
          "Rexxar",
          "Samuro",
          "Sgt. Hammer",
          "Sonya",
          "Stitches",
          "Stukov",
          "Sylvanas",
          "Tassadar",
          "The Butcher",
          "The Lost Vikings",
          "Thrall",
          "Tracer",
          "Tychus",
          "Tyrael",
          "Tyrande",
          "Uther",
          "Valeera",
          "Valla",
          "Whitemane",
          "Xul",
          "Yrel",
          "Zagara",
          "Zarya",
          "Zeratul",
          "Zul'jin"
        ],
        "quotes": [
          "Beat them like they owe you money!",
          "Careful wizard, your kind has upset the balance beforeo I become re-dead? Deader? ... Alive?",
          "Don't forget to check the pocket!",
          "Have you ever considered aiming anywhere other than the face?",
          "Hey, you look like the cover of E.T.C.s new album!",
          "Human words are hard to make together talking for expressing... things!",
          "I like happy things! Like puppies, and rainbows, and dead enemies!",
          "I must leave and I blame this failure upon you.",
          "Mrgrgrlrgrlgr!!!",
          "Oh my God, I can't believe I just killed a panda.",
          "Taunting life form; you are weak! And physically unappealing!",
          "Teammates. Much to improve. is a pretty good contender.",
          "That was easy! You were easy to kill!",
          "This will only hurt until you die.",
          "Ugh, I've known much better healers.",
          "We drink first blood!",
          "You look like you could actually be of use here!",
          "You might be a king, or just a street sweeper... yet sooner or later you dance with the reaper.",
          "You see this hero yes? Then kill them!",
          "You think us fools?",
          "You waste both my time and your breath, and the former has value."
        ]
      },
      "hey_arnold": {
        "characters": [
          "Arnold",
          "Steely Phil",
          "Pookie",
          "Oskar Kokoschka",
          "Suzie Kokoschka",
          "Mr. Hyuhn",
          "Helga G. Pataki",
          "Miriam Pataki",
          "Olga Pataki",
          "Gerald Johannssen",
          "Harold Berman",
          "Phoebe Heyerdahl",
          "Rhonda Lloyd",
          "Lila Sawyer",
          "Stinky Peterson",
          "Eugene Horowitz",
          "Sid",
          "Curly",
          "Torvald",
          "Sheena",
          "Lorenzo",
          "Iggy",
          "Brainy",
          "Nadine",
          "Park",
          "Joey Stevenson",
          "Peapod Kid",
          "Big Gino",
          "Campfire Lass",
          "Wolfgang",
          "Edmund",
          "Big Patty",
          "Mickey the Weasel",
          "Chocolate Boy",
          "Ruth P. McDougal",
          "Robert Simmons",
          "Miss Slovak",
          "Principal Wartz",
          "Jack Wittenburg",
          "Tish Wittenburg",
          "Tucker Wittenburg",
          "Dino Spumoni",
          "Jimmy Kafka",
          "Ernie Potts",
          "Ronnie Matthews",
          "Mickey Kaline",
          "Monkey Man",
          "Pigeon Man",
          "Robbie Fisher",
          "Sewer King",
          "Stoop Kid",
          "The Jolly Olly Man",
          "Abner",
          "Four-Eyed Jack",
          "Wheezin' Ed",
          "Don Reynolds",
          "Big Bob Pataki",
          "Miriam Pataki",
          "Jamie O",
          "Timberly",
          "Marty Green",
          "Ludwig",
          "Dr. Bliss",
          "Lieutenant Major Goose",
          "Alphonse Perrier du von Scheck",
          "The Mauve Avenger",
          "Earl"
        ],
        "locations": [
          "P.S. 118",
          "Stoop Kid's Stoop",
          "Antonio's Pizzeria",
          "Mickey's Dog Pound",
          "Big Bob's Beeper Emporium",
          "Sundae Salon",
          "Omar's Falafel Hut",
          "The Fudge Place",
          "Hillwood City",
          "Green Meats",
          "Roscoe's Funky Rags",
          "Watch Repair",
          "Yahoo Chocolate Factory",
          "Sunset Arms",
          "Stinky's farm",
          "Chez Paris",
          "Gerald Field",
          "Madame Bovary's Dance School for Boys"
        ],
        "quotes": [
          "Stoop Kid's afraid to leave his stoop!",
          "MONKEYMAAAAN!",
          "You better not touch my gal, or I'll pop you in the kisser, pal",
          "Yahoo Soda Just Drink It",
          "I saw your face and wow!",
          "But you see, Arnold and tall hair boy, I don’t want to be famous! I want to live my life simply! I like my banana wallpaper, I like doing my own laundry! Just give me the simple things!",
          "Kitty, kitty, kitty, do you like to pet the kitty? I like to pet the kitty! Hey look! I'm petting the kitty!",
          "You're a bold kid, Arnold, a bold kid.",
          "Hey, short man!",
          "You keep the money!",
          "Suzie, make me a sandwich!",
          "But Gerald, the Jolly Olly Man is a stingy, mean spirited jerk, who hates kids and is constantly teetering on the brink of insanity.",
          "Can you get your arm off my shoulder? As I've told you many times before, I don't like you like you, I just like you.",
          "Move it, Footballhead",
          "Never eat raspberries.",
          "I'm okay!"
        ]
      },
      "hipster": {
        "words": [
          "Wes Anderson",
          "chicharrones",
          "narwhal",
          "food truck",
          "marfa",
          "aesthetic",
          "keytar",
          "art party",
          "sustainable",
          "forage",
          "mlkshk",
          "gentrify",
          "locavore",
          "swag",
          "hoodie",
          "microdosing",
          "VHS",
          "before they sold out",
          "pabst",
          "plaid",
          "Thundercats",
          "freegan",
          "scenester",
          "hella",
          "occupy",
          "truffaut",
          "raw denim",
          "beard",
          "post-ironic",
          "photo booth",
          "twee",
          "90's",
          "pitchfork",
          "cray",
          "cornhole",
          "kale chips",
          "pour-over",
          "yr",
          "five dollar toast",
          "kombucha",
          "you probably haven't heard of them",
          "mustache",
          "fixie",
          "try-hard",
          "franzen",
          "kitsch",
          "austin",
          "stumptown",
          "keffiyeh",
          "whatever",
          "tumblr",
          "DIY",
          "shoreditch",
          "biodiesel",
          "vegan",
          "pop-up",
          "banjo",
          "kogi",
          "cold-pressed",
          "letterpress",
          "chambray",
          "butcher",
          "synth",
          "trust fund",
          "hammock",
          "farm-to-table",
          "intelligentsia",
          "loko",
          "ugh",
          "offal",
          "poutine",
          "gastropub",
          "Godard",
          "jean shorts",
          "sriracha",
          "dreamcatcher",
          "leggings",
          "fashion axe",
          "church-key",
          "meggings",
          "tote bag",
          "disrupt",
          "readymade",
          "helvetica",
          "flannel",
          "meh",
          "roof",
          "hashtag",
          "knausgaard",
          "cronut",
          "schlitz",
          "green juice",
          "waistcoat",
          "normcore",
          "viral",
          "ethical",
          "actually",
          "fingerstache",
          "humblebrag",
          "deep v",
          "wayfarers",
          "tacos",
          "taxidermy",
          "selvage",
          "put a bird on it",
          "ramps",
          "portland",
          "retro",
          "kickstarter",
          "bushwick",
          "brunch",
          "distillery",
          "migas",
          "flexitarian",
          "XOXO",
          "small batch",
          "messenger bag",
          "heirloom",
          "tofu",
          "bicycle rights",
          "bespoke",
          "salvia",
          "wolf",
          "selfies",
          "echo",
          "park",
          "listicle",
          "craft beer",
          "chartreuse",
          "sartorial",
          "pinterest",
          "mumblecore",
          "kinfolk",
          "vinyl",
          "etsy",
          "umami",
          "8-bit",
          "polaroid",
          "banh mi",
          "crucifix",
          "bitters",
          "brooklyn",
          "PBR&B",
          "drinking",
          "vinegar",
          "squid",
          "tattooed",
          "skateboard",
          "vice",
          "authentic",
          "literally",
          "lomo",
          "celiac",
          "health",
          "goth",
          "artisan",
          "chillwave",
          "blue bottle",
          "pickled",
          "next level",
          "neutra",
          "organic",
          "Yuccie",
          "paleo",
          "blog",
          "single-origin coffee",
          "seitan",
          "street",
          "gluten-free",
          "mixtape",
          "venmo",
          "irony",
          "everyday",
          "carry",
          "slow-carb",
          "3 wolf moon",
          "direct trade",
          "lo-fi",
          "tousled",
          "tilde",
          "semiotics",
          "cred",
          "chia",
          "master",
          "cleanse",
          "ennui",
          "quinoa",
          "pug",
          "iPhone",
          "fanny pack",
          "cliche",
          "cardigan",
          "asymmetrical",
          "meditation",
          "YOLO",
          "typewriter",
          "pork belly",
          "shabby chic",
          "+1",
          "lumbersexual",
          "williamsburg",
          "muggle magic",
          "phlogiston"
        ]
      },
      "hitchhikers_guide_to_the_galaxy": {
        "characters": [
          "Agda",
          "Agrajag",
          "Arthur Dent",
          "Arthur Philip Deodat",
          "Barry Manilow",
          "Bowerick Wowbagger",
          "Charles Darwin",
          "Colin the Security Robot",
          "Dan Streetmentioner",
          "Deep Thought",
          "Eccentrica Gallumbits",
          "Eddie the Computer",
          "Effrafax of Wug",
          "Elvis",
          "Emily Saunders",
          "Fenchurch",
          "Ford Prefect",
          "Frankie and Benjy",
          "Gag Halfrunt",
          "Gail Andrews",
          "Galaxia Woonbeam",
          "Garkbit",
          "Genghis Khan",
          "Grunthos the Flatulent",
          "Hactar",
          "Hillman Hunter",
          "Hotblack Desiato",
          "Hotblack Desiato's bodyguard",
          "Humma Kavula",
          "JinJenz",
          "Lintilla",
          "Loonquawl",
          "Loonquawl and Phouchg",
          "Lunkwill and Fook",
          "Magrathean sperm whale",
          "Majikthise",
          "Marvin",
          "Max Quordlepleen",
          "Mella",
          "Mr. Prosser",
          "Oolon Colluphid",
          "Pasta Fasta",
          "Paula Nancy Millstone Jennings",
          "Phouchg",
          "Pizpot Gargravarr",
          "Prak",
          "Prostetnic Vogon Jeltz",
          "Prostetnic Vogon Kwaltz",
          "Questular Rontok",
          "Random Dent",
          "Reg Nullify",
          "Rob McKenna",
          "Roosta",
          "Slartibartfast",
          "The Allitnils",
          "Tricia McMillan",
          "Trillian",
          "Trin Tragula",
          "Vroomfondel",
          "Wonko the Sane",
          "Yooden Vranx",
          "Zaphod Beeblebrox",
          "Zarniwoop",
          "Zarquon"
        ],
        "locations": [
          "29 Arlington Avenue",
          "Arthur Dent's house",
          "Asbleg",
          "Barnard's Star",
          "Belgium",
          "Betelgeuse",
          "Bistro Illegal",
          "Boston",
          "Bournemouth",
          "Café Lou",
          "Cathedral of Chalesm",
          "Croydon",
          "Denmark",
          "Easter Island",
          "Evildrome Boozarama",
          "Fenchurch Street railway station",
          "France",
          "Frogstar system",
          "Frogstar World B",
          "Guildford",
          "Han Dold City",
          "Highgate Cemetery",
          "Horse and Groom",
          "Horsehead Nebula",
          "Ibiza",
          "Islington",
          "Kakrafoon Kappa",
          "Lamuella",
          "London",
          "Lord's Cricket Ground",
          "Madagascar",
          "Megabrantis cluster",
          "Milliways",
          "North West Ripple",
          "Norway",
          "Oglaroon",
          "Pleiades system",
          "Preliumtarn",
          "Rickmansworth",
          "Rupert",
          "Sector XXXZ5QZX",
          "Sector ZZ9 Plural Z Alpha",
          "Seventh Galaxy of Light and Ingenuity",
          "Slim's Throat Emporium",
          "Space",
          "Stavro Mueller Beta",
          "Stavromula Beta",
          "The Big Bang Burger Bar",
          "The Domain of The King",
          "Total Perspective Vortex",
          "Western Spiral Arm",
          "Xaxis",
          "Ysllodins",
          "Zarss",
          "Ziggie's Den of Iniquity"
        ],
        "marvin_quote": [
          "Life? Don't talk to me about life.",
          "Here I am, brain the size of a planet, and they tell me to take you up to the bridge. Call that job satisfaction? 'Cos I don't.",
          "I think you ought to know I'm feeling very depressed.",
          "Pardon me for breathing, which I never do anyway so I don't know why I bother to say it, Oh God, I'm so depressed.",
          "I won't enjoy it.",
          "You think you've got problems? What are you supposed to do if you are a manically depressed robot? No, don't try to answer that. I'm fifty thousand times more intelligent than you and even I don't know the answer. It gives me a headache just trying to think down to your level.",
          "There's only one life-form as intelligent as me within thirty parsecs of here and that's me.",
          "I wish you'd just tell me rather trying to engage my enthusiasm, because I haven't got one.",
          "And then of course I've got this terrible pain in all the diodes down my left side."
        ],
        "planets": [
          "Allosimanius Syneca",
          "Argabuthon",
          "Arkintoofle Minor",
          "Bartledan",
          "Bethselamin",
          "Blagulon Kappa",
          "Brontitall",
          "Broop Kidron 13",
          "Broop Kidron Thirteen",
          "Burphon XII",
          "Damogran",
          "Dangrabad Beta",
          "Earth",
          "Eroticon VI",
          "Fallia",
          "Flargathon",
          "Frogstar World A",
          "Frogstar World B",
          "Frogstar World C",
          "Gagrakacka",
          "Golgafrincham",
          "Han Wavel",
          "Happi-Werld III",
          "Hawalius",
          "Jaglan Beta",
          "Jajazikstak",
          "Kakrafoon Kappa",
          "Kria",
          "Krikkit",
          "Lamuella",
          "Magrathea",
          "Nano",
          "NowWhat",
          "Oglaroon",
          "Poghril",
          "Preliumtarn",
          "Rupert",
          "Santraginus V",
          "Sesefras Magna",
          "Sqornshellous Zeta",
          "Traal",
          "Viltvodle VI",
          "Vogsphere",
          "Xaxis"
        ],
        "quotes": [
          "Earth: Mostly Harmless",
          "Whatever your tastes, Magrathea can cater for you. We are not proud.",
          "But Mr. Dent, the plans have been available in the local planning office for the last nine months.",
          "there’s an infinite number of monkeys outside who want to talk to us about this script for Hamlet they’ve worked out.",
          "Will you open up the exit hatch, please, computer?",
          "According to the legends, the Magratheans lived most of their lives underground.",
          "Magrathea itself disappeared and its memory soon passed into the obscurity of legend. In these enlightened days, of course, no one believes a word of it.",
          "Evolution? they said to themselves, Who needs it?",
          "Curiously enough, the only thing that went through the mind of the bowl of petunias as it fell was Oh no, not again.",
          "Parts of the inside of her head screamed at other parts of the inside of her head.",
          "if you’ve never been through a matter transference beam before you’ve probably lost some salt and protein. The beer you had should have cushioned your system a bit.",
          "I've just had an unhappy love affair, so I don't see why anybody else should have a good time.",
          "It’s only half completed, I’m afraid – we haven’t even finished burying the artificial dinosaur skeletons in the crust yet.",
          "They’ve got as much sex appeal as a road accident.",
          "...they discovered only a small asteroid inhabited by a solitary old man who claimed repeatedly that nothing was true, though he was later discovered to be lying.",
          "If they don’t keep exercising their lips, he thought, their brains start working.",
          "If there's anything more important than my ego around, I want it caught and shot now.",
          "In the beginning, the Universe was created. This has made a lot of people very angry and been widely regarded as a bad move.",
          "On the planet Earth, man had always assumed that he was more intelligent than dolphins because he had achieved so much—the wheel, New York, wars and so on—whilst all the dolphins had ever done was muck about in the water having a good time. But conversely, the dolphins had always believed that they were far more intelligent than man—for precisely the same reasons.",
          "It seemed to me that any civilization that had so far lost its head as to need to include a set of detailed instructions for use in a packet of toothpicks, was no longer a civilization in which I could live and stay sane.",
          "Nothing travels faster than the speed of light with the possible exception of bad news, which obeys its own special laws.",
          "He was staring at the instruments with the air of one who is trying to convert Fahrenheit to centigrade in his head while his house is burning down.",
          "Don’t Panic",
          "42"
        ],
        "species": [
          "Algolian Suntiger",
          "Arcturan MegaDonkey",
          "Arcturan Megagrasshopper",
          "Azgoths of Kria",
          "Babel Fish",
          "Belcerebon",
          "Boghog",
          "Cow",
          "Damogran Frond Crested Eagle",
          "Dentrassis",
          "Dolphins",
          "Flaybooz",
          "Golgafrinchan",
          "Grebulon",
          "Grebulons",
          "Hingefreel",
          "Hooloovoo",
          "Human",
          "Jatravartid",
          "Mattress",
          "Mice",
          "Mouse",
          "Nanites",
          "Perfectly Normal Beast",
          "Ravenous Bugblatter Beast of Traal",
          "Sarkopsi",
          "Shaltanac",
          "Silastic Armorfiends",
          "Silver Tongued Devils",
          "Vl'Hurg",
          "Vogon"
        ],
        "starships": [
          "Billion Year Bunker",
          "Bistromath",
          "Golgafrinchan Ark Fleet Ship B",
          "Heart of Gold",
          "Krikkit One",
          "RW6",
          "Starship Titanic",
          "Tanngrisnir",
          "Vogon Constructor Fleet"
        ]
      },
      "hobby": {
        "activity": [
          "3D printing",
          "amateur radio",
          "scrapbook",
          "Amateur radio",
          "Acting",
          "Baton twirling",
          "Board games",
          "Book restoration",
          "Cabaret",
          "Calligraphy",
          "Candle making",
          "Computer programming",
          "Coffee roasting",
          "Cooking",
          "Coloring",
          "Cosplaying",
          "Couponing",
          "Creative writing",
          "Crocheting",
          "Cryptography",
          "Dance",
          "Digital arts",
          "Drama",
          "Drawing",
          "Do it yourself",
          "Electronics",
          "Embroidery",
          "Fashion",
          "Flower arranging",
          "Foreign language learning",
          "Gaming",
          "tabletop games",
          "role-playing games",
          "Gambling",
          "Genealogy",
          "Glassblowing",
          "Gunsmithing",
          "Homebrewing",
          "Ice skating",
          "Jewelry making",
          "Jigsaw puzzles",
          "Juggling",
          "Knapping",
          "Knitting",
          "Kabaddi",
          "Knife making",
          "Lacemaking",
          "Lapidary",
          "Leather crafting",
          "Lego building",
          "Lockpicking",
          "Machining",
          "Macrame",
          "Metalworking",
          "Magic",
          "Model building",
          "Listening to music",
          "Origami",
          "Painting",
          "Playing musical instruments",
          "Pet",
          "Poi",
          "Pottery",
          "Puzzles",
          "Quilting",
          "Reading",
          "Scrapbooking",
          "Sculpting",
          "Sewing",
          "Singing",
          "Sketching",
          "Soapmaking",
          "Sports",
          "Stand-up comedy",
          "Sudoku",
          "Table tennis",
          "Taxidermy",
          "Video gaming",
          "Watching movies",
          "Web surfing",
          "Whittling",
          "Wood carving",
          "Woodworking",
          "Worldbuilding",
          "Writing",
          "Yoga",
          "Yo-yoing",
          "Air sports",
          "Archery",
          "Astronomy",
          "Backpacking",
          "BASE jumping",
          "Baseball",
          "Basketball",
          "Beekeeping",
          "Bird watching",
          "Blacksmithing",
          "Board sports",
          "Bodybuilding",
          "Brazilian jiu-jitsu",
          "Community",
          "Cycling",
          "Dowsing",
          "Driving",
          "Fishing",
          "Flag Football",
          "Flying",
          "Flying disc",
          "Foraging",
          "Gardening",
          "Geocaching",
          "Ghost hunting",
          "Graffiti",
          "Handball",
          "Hiking",
          "Hooping",
          "Horseback riding",
          "Hunting",
          "Inline skating",
          "Jogging",
          "Kayaking",
          "Kite flying",
          "Kitesurfing",
          "LARPing",
          "Letterboxing",
          "Metal detecting",
          "Motor sports",
          "Mountain biking",
          "Mountaineering",
          "Mushroom hunting",
          "Mycology",
          "Netball",
          "Nordic skating",
          "Orienteering",
          "Paintball",
          "Parkour",
          "Photography",
          "Polo",
          "Rafting",
          "Rappelling",
          "Rock climbing",
          "Roller skating",
          "Rugby",
          "Running",
          "Sailing",
          "Sand art",
          "Scouting",
          "Scuba diving",
          "Sculling",
          "Rowing",
          "Shooting",
          "Shopping",
          "Skateboarding",
          "Skiing",
          "Skimboarding",
          "Skydiving",
          "Slacklining",
          "Snowboarding",
          "Stone skipping",
          "Surfing",
          "Swimming",
          "Taekwondo",
          "Tai chi",
          "Urban exploration",
          "Vacation",
          "Vehicle restoration",
          "Water sports"
        ]
      },
      "house": {
        "furniture": [
          "chair",
          "armchair",
          "table",
          "dining table",
          "stool",
          "sofa",
          "couch",
          "bath",
          "bed",
          "cupboard",
          "drawers",
          "dresser",
          "floor lamp",
          "bedside table",
          "futon"
        ],
        "rooms": [
          "kitchen",
          "living room",
          "reception room",
          "bedroom",
          "master bedroom",
          "guest room",
          "drawing room",
          "conservatory",
          "porch",
          "hallway",
          "pantry",
          "sunroom",
          "bathroom",
          "ensuite bathroom",
          "cellar",
          "attic",
          "loft"
        ]
      },
      "how_i_met_your_mother": {
        "catch_phrase": [
          "Legendary",
          "Suit Up",
          "Wait For it",
          "But… umm",
          "Lawyered",
          "Challenege Accepted",
          "Just… O.K?",
          "Where’s the poop?",
          "That’s the Dream",
          "True Story",
          "Patent Pending",
          "What Up",
          "Classic Shmosby"
        ],
        "character": [
          "Ted Mosby",
          "Marshall Eriksen",
          "Lily Aldrin",
          "Robin Scherbatsky",
          "Barney Stinson",
          "Tracy Mosby",
          "Luke Mosby",
          "Penny Mosby",
          "Alan Thicke",
          "Arthur Hobbs",
          "Bilson",
          "Brad Morris",
          "Carl MacLaren",
          "Claudia Grice",
          "Don Frank",
          "Doug Martin",
          "Gary Blauman",
          "George Van Smoot",
          "Hammond Druthers",
          "James Stinson",
          "Jerome Whittaker",
          "Judy Eriksen",
          "Loretta Stinson",
          "Marcus Eriksen",
          "Marvin Eriksen Jr.",
          "Marvin Eriksen Sr.",
          "Mickey Aldrin",
          "Nick Podarutti",
          "Quinn Garvey",
          "Ranjit Singh",
          "Robin Scherbatsky Sr.",
          "Sandy Rivers",
          "Stella Zinman",
          "Stuart Bowers",
          "Wendy the Waitress",
          "Virginia Mosby",
          "William Zabka",
          "Zoey Pierson"
        ],
        "high_five": [
          "Arthritis Five",
          "Relapse Five",
          "Phone Five",
          "Solemn Low Five",
          "Hypothetical High Five",
          "Self Five",
          "Freeze Fram High Five",
          "Tiny Five",
          "High Two",
          "Multiple High Fives",
          "The Highest of Fives",
          "Door Five",
          "High Six",
          "Motility Five",
          "Claw Five",
          "High V",
          "Word Play Five",
          "Condolence Five",
          "Almighty Five",
          "Mental Self Five",
          "Retraction Five",
          "Angry Self Five",
          "Mushroom Five",
          "Get-this-over-with-quickly-so-we-can-move-past-how-awkward-it-was-that-I-just-said-that Five",
          "High Infinity"
        ],
        "quote": [
          "Whenever I’m sad, I stop being sad and be awesome instead.",
          "Because sometimes even if you know how something’s gonna end that doesn’t mean you can’t enjoy the ride.",
          "The littlest thing can cause a ripple effect that changes your life.",
          "That’s life, you know, we never end up where you thought you wanted to be.",
          "We’re going to get older whether we like it or not, so the only question is whether we get on with our lives, or desperately cling to the past.",
          "Ted, how many times have I told you to put the lid back on the peanut butter jar?! It’s this inconsiderate, immature jackassery that makes me feel like I’m living in The Real World House! And not the early days when they all had jobs and social consciences, I’m talking about Hawaii, and after!",
          "There are a lot of little reasons why the big things in our lives happen.",
          "I keep waiting for it to happen. I’m waiting for it to happen. I guess I’m just tired of waiting. And that is all I’m going to say on that subject.",
          "Look, you can’t design your life like a building. It doesn’t work that way. You just have to live it… and it’ll design itself.",
          "Definitions are important.",
          "You can’t just skip ahead to where you think your life should be.",
          "It’s just, eventually we’re all gonna move on. It’s called growing up.",
          "There are two big days in any love story: the day you meet the girl of your dreams and the day you marry her.",
          "The future is scary but you can’t just run back to the past because it’s familiar.",
          "I realized that I’m searching, searching for what I really want in life. And you know what? I have absolutely no idea what that is.",
          "Revenge fantasies never work out the way you want.",
          "Whether a gesture’s charming or alarming, depends on how it’s received."
        ]
      },
      "how_to_train_your_dragon": {
        "characters": [
          "Agnar",
          "Agnut Thorston",
          "Alvin the Treacherous",
          "Arick Denson",
          "Arngrim Dammen",
          "Astrid Hofferson",
          "Axel Finke",
          "Axel Skeptisson",
          "Drago Bludvist",
          "Bucket",
          "Buffnut",
          "Cleftjaw",
          "Dagur the Deranged",
          "Derrick",
          "Eret, Son of Eret",
          "Fenris Thorston",
          "Fishlegs Ingerman",
          "Flora May",
          "Froglegs",
          "Gobber the Belch",
          "Gothi",
          "Gruffnut Thorston",
          "Gustav Larson",
          "Hagan Frostbeard",
          "Heather",
          "Hiccup",
          "Hildegard",
          "Ingar Ingerman",
          "Iron Mason",
          "Jens Henderson",
          "Jorgen Redboot",
          "Krogan",
          "Maeve",
          "Mala",
          "Mildew",
          "Nuffink Haddock",
          "Oswald the Agreeable",
          "Padraig",
          "Piglegs",
          "Ruffnut",
          "Ryker Grimborn",
          "Savage"
        ],
        "dragons": [
          "Axewing",
          "Barf and Belch",
          "Beachcomber",
          "Bewilderbeast",
          "Blazewing",
          "Bonesnarl",
          "Bonnefire",
          "Borealis",
          "Butt and Head",
          "Cagecruncher",
          "Carnastial",
          "Cheesemonger",
          "Chompers",
          "Cloudjumper",
          "Darkvarg",
          "Earsplitter",
          "Fishmeat",
          "Ghostglow",
          "Gressjester",
          "Hookfire",
          "Icebane",
          "Incognito",
          "Irontooth",
          "Krustler",
          "Meatlug",
          "Nightwatch",
          "Obskewer",
          "Reignstorm",
          "Rhineblow",
          "Scardian",
          "Sentinel",
          "Skullcrusher",
          "Smidvarg",
          "Snifflestone",
          "Snogglewing",
          "Stormfly",
          "Thornado",
          "Thorntail",
          "Thunderfish",
          "Toothless",
          "Tripfire",
          "Valdwail",
          "Wavewight",
          "Windshear",
          "Winterwick",
          "Wonderclap",
          "Zeppla"
        ],
        "locations": [
          "Algae Island",
          "Armorwing Island",
          "Askeblad Island",
          "Barbaric Archipelago",
          "Belching Bog",
          "Berk",
          "Berserker Island",
          "Boarhead Island",
          "Breakneck Bog",
          "Caves of Jotunn",
          "Changewing Island",
          "Clover Coast",
          "Dark Deep",
          "Dark Harbor",
          "Dragon Island",
          "Eastern Strait",
          "Eel Island",
          "Eternitree",
          "Everfrost Forest",
          "Fireworm Island",
          "Gronckle Island",
          "Hazard Island",
          "Hidden World",
          "Hobblegrunt Island",
          "Horrendous Point",
          "Hunter Island",
          "Huttsgalor",
          "Icestorm Island",
          "Island of Friga",
          "Itchy Armpit",
          "Jotun Hot Springs",
          "Knucklebone Knoll",
          "Maze Caves",
          "Melody Island",
          "Misty Backwoods",
          "Mount Ymir",
          "New Berk",
          "Northern Swamp",
          "Outcast Island",
          "Pointy Point",
          "Puffin Point",
          "Quaking Cavern",
          "Radiant Meadows",
          "Ragnarok Rock",
          "Raven Point",
          "Rookery",
          "Rough Sands",
          "Scriven Rock",
          "Scuttleclaw Island",
          "Sea of Despair",
          "Ship Graveyard",
          "Shivering Shores",
          "Shredstone Walls",
          "Snoggletog Island",
          "Sparkfire Mountain",
          "Speed Stinger Island",
          "Straits of Baldur",
          "Sullen Sea",
          "Sundering Wastes",
          "Sunken City",
          "Sunstone Island",
          "Thornbane Valley",
          "Thunderhead Bay",
          "Timberjack Hollow",
          "Titan Island",
          "Training Arena",
          "Trembling Faults",
          "Uglythug Lands",
          "Valhalla",
          "Valka's Mountain",
          "Vanaheim",
          "Viking Cliff",
          "Vinland",
          "Wild Woodland",
          "Windswept Ruin",
          "Woolly Canyon",
          "Wreck Reef",
          "Zippleback Island"
        ]
      },
      "id_number": {
        "invalid": [
          "000-##-####",
          "###-00-####",
          "###-##-0000",
          "666-##-####",
          "9##-##-####"
        ],
        "valid": "#{IdNumber.ssn_valid}"
      },
      "industry_segments": {
        "industry": [
          "Oil & Gas",
          "Basic Materials",
          "Industrials",
          "Consumer Goods",
          "Health Care",
          "Consumer Services",
          "Telecommunications",
          "Utilities",
          "Financials",
          "Technology"
        ],
        "sector": [
          "Oil & Gas Producers",
          "Oil Equipment, Services & Distribution",
          "Alternative Energy",
          "Chemicals",
          "Forestry & Paper",
          "Industrial Metals & Mining",
          "Mining",
          "Construction & Materials",
          "Aerospace & Defense",
          "General Industrials",
          "Electronic & Electrical Equipment",
          "Industrial Engineering",
          "Industrial Transportation",
          "Support Services",
          "Automobiles & Parts",
          "Beverages",
          "Food Producers",
          "Household Goods & Home Construction",
          "Leisure Goods",
          "Personal Goods",
          "Tobacco",
          "Health Care Equipment & Services",
          "Pharmaceuticals & Biotechnology",
          "Food & Drug Retailers",
          "General Retailers",
          "Media",
          "Travel & Leisure",
          "Fixed Line Telecommunications",
          "Mobile Telecommunications",
          "Electricity",
          "Gas, Water & Multiutilities",
          "Banks",
          "Nonlife Insurance",
          "Life Insurance",
          "Real Estate Investment & Services",
          "Real Estate Investment Trusts",
          "Financial Services",
          "Equity Investment Instruments",
          "Nonequity Investment Instruments",
          "Software & Computer Services",
          "Technology Hardware & Equipment"
        ],
        "sub_sector": [
          "Exploration & Production",
          "Integrated Oil & Gas",
          "Oil Equipment & Services",
          "Pipelines",
          "Renewable Energy Equipment",
          "Alternative Fuels",
          "Commodity Chemicals",
          "Specialty Chemicals",
          "Forestry",
          "ÊPaper",
          "Aluminum",
          "Nonferrous Metals",
          "Iron & Steel",
          "Coal",
          "Diamonds & Gemstones",
          "General Mining",
          "Gold Mining",
          "Platinum & Precious Metals",
          "Building Materials & Fixtures",
          "Heavy Construction",
          "Aerospace",
          "Defense",
          "Containers & Packaging",
          "Diversified Industrials",
          "Electrical Components & Equipment",
          "Electronic Equipment",
          "Commercial Vehicles & Trucks",
          "Industrial Machinery",
          "Delivery Services",
          "Marine Transportation",
          "Railroads",
          "Transportation Services",
          "Trucking",
          "Business Support Services",
          "Business Training & Employment Agencies",
          "Financial Administration",
          "Industrial Suppliers",
          "Waste & Disposal Services",
          "Automobiles",
          "Auto Parts",
          "Tires",
          "Brewers",
          "Distillers & Vintners",
          "Soft Drinks",
          "Farming & Fishing",
          "Food Products",
          "Durable Household Products",
          "Nondurable Household Products",
          "Furnishings",
          "Home Construction",
          "Consumer Electronics",
          "Recreational Products",
          "Toys",
          "Clothing & Accessories",
          "Footwear",
          "Personal Products",
          "Tobacco",
          "Health Care Providers",
          "Medical Equipment",
          "Medical Supplies",
          "Biotechnology",
          "Pharmaceuticals",
          "Drug Retailers",
          "Food Retailers & Wholesalers",
          "Apparel Retailers",
          "Broadline Retailers",
          "Home Improvement Retailers",
          "Specialized Consumer Services",
          "Specialty Retailers",
          "Broadcasting & Entertainment",
          "Media Agencies",
          "Publishing",
          "Airlines",
          "Gambling",
          "Hotels",
          "Recreational Services",
          "Restaurants & Bars",
          "Travel & Tourism",
          "Fixed Line Telecommunications",
          "Mobile Telecommunications",
          "Conventional Electricity",
          "Alternative Electricity",
          "Gas Distribution",
          "Multiutilities",
          "Water",
          "Banks",
          "Full Line Insurance",
          "Insurance Brokers",
          "Property & Casualty Insurance",
          "Reinsurance",
          "Life Insurance",
          "Real Estate Holding & Development",
          "Real Estate Services",
          "Industrial & Office REITs",
          "Retail REITs",
          "Residential REITs",
          "Diversified REITs",
          "Specialty REITs",
          "Mortgage REITs",
          "Hotel & Lodging REITs",
          "Asset Managers",
          "Consumer Finance",
          "Specialty Finance",
          "Investment Services",
          "Mortgage Finance",
          "Equity Investment Instruments",
          "Nonequity Investment Instruments",
          "Computer Services",
          "Internet",
          "Software",
          "Computer Hardware",
          "Electronic Office Equipment",
          "Semiconductors",
          "Telecommunications Equipment"
        ],
        "super_sector": [
          "Oil & Gas",
          "Chemicals",
          "Basic Resources",
          "Construction & Materials",
          "Industrial Goods & Services",
          "Automobiles & Parts",
          "Food & Beverage",
          "Personal & Household Goods",
          "Health Care",
          "Retail",
          "Media",
          "Travel & Leisure",
          "Telecommunications",
          "Utilities",
          "Banks",
          "Insurance",
          "Real Estate",
          "Financial Services",
          "Technology"
        ]
      },
      "internet": {
        "bot_user_agent": {
          "baiduspider": [
            "Mozilla/5.0 (iPhone; CPU iPhone OS 9_1 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13B143 Safari/601.1 (compatible; Baiduspider-render/2.0 ; +http://www.baidu.com/search/spider.html)",
            "Mozilla/5.0 (iPhone; CPU iPhone OS 9_1 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13B143 Safari/601.1 (compatible; Baiduspider-render/2.0 ; Smartapp; +http://www.baidu.com/search/spider.html)",
            "Mozilla/5.0 (compatible; Baiduspider-render/2.0 ; +http://www.baidu.com/search/spider.html)"
          ],
          "bingbot": [
            "Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko; compatible; bingbot/2.0; +http://www.bing.com/bingbot.htm) Chrome/86.0.4240.68 Safari/537.36 Edg/86.0.622.31",
            "Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/534 +(KHTML, like Gecko) BingPreview/1.0b",
            "Mozilla/5.0 (Windows NT 6.3; WOW64; Trident/7.0; rv:11.0; BingPreview/1.0b) like Gecko",
            "Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko; compatible; bingbot/2.0; +http://www.bing.com/bingbot.htm) Chrome/98.0.4758.102 Safari/537.36",
            "Mozilla/5.0 (iPhone; CPU iPhone OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A465 Safari/9537.53 (compatible; bingbot/2.0; +http://www.bing.com/bingbot.htm)"
          ],
          "duckduckbot": [
            "DuckDuckBot-Https/1.1; (+https://duckduckgo.com/duckduckbot)",
            "Mozilla/5.0 (compatible; DuckDuckBot-Https/1.1; https://duckduckgo.com/duckduckbot)",
            "DuckDuckBot/1.1; (+http://duckduckgo.com/duckduckbot.html)",
            "DuckDuckBot-Https/1.1; (+https://duckduckgo.com/duckduckbot)",
            "Mozilla/5.0 (compatible; DuckDuckBot-Https/1.1; https://duckduckgo.com/duckduckbot)"
          ],
          "googlebot": [
            "Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko; compatible; Googlebot/2.1; +http://www.google.com/bot.html) Chrome/83.0.4103.122 Safari/537.36",
            "Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko; compatible; Googlebot/2.1; +http://www.google.com/bot.html) Chrome/99.0.4844.84 Safari/537.36",
            "Mozilla/5.0 (compatible; Googlebot/2.1; +http://www.google.com/bot.html)",
            "Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko; compatible; Googlebot/2.1; +http://www.google.com/bot.html) Chrome/87.0.4280.90 Safari/537.36",
            "Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko; compatible; Googlebot/2.1; +http://www.google.com/bot.html) Safari/537.36 Googlebot-Image/1.0"
          ],
          "yandexbot": [
            "Mozilla/5.0 (compatible; YandexBot/3.0; +http://yandex.com/bots)",
            "Mozilla/5.0 (compatible; YandexDirect/3.0; +http://yandex.com/bots)",
            "Mozilla/5.0 (compatible; YandexMetrika/2.0; +http://yandex.com/bots yabs01)",
            "Mozilla/5.0 (compatible; YandexBot/3.0; +http://yandex.com/bots) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.268",
            "Mozilla/5.0 (compatible; YandexImages/3.0; +http://yandex.com/bots)"
          ]
        },
        "domain_suffix": [
          "com",
          "biz",
          "info",
          "name",
          "net",
          "org",
          "io",
          "co"
        ],
        "safe_domain_suffix": [
          "example",
          "test"
        ],
        "slug": [
          "report",
          "appointment",
          "highway",
          "premium",
          "shock",
          "general",
          "guess",
          "branch",
          "outside",
          "exhibition",
          "condition",
          "nursery",
          "trivial",
          "confuse",
          "design",
          "corn",
          "bless",
          "ambiguous",
          "diagram",
          "ample",
          "provision",
          "judge",
          "strict",
          "perception",
          "widen",
          "plain",
          "strap",
          "fruit",
          "distant",
          "arena",
          "twilight",
          "hope",
          "turkey",
          "deport",
          "brown",
          "agree",
          "exaggerate",
          "onion",
          "stuff",
          "hypothesis",
          "whole",
          "relationship",
          "linger",
          "corpse",
          "cutting",
          "dynamic",
          "thirsty",
          "authority",
          "award",
          "introduction",
          "seller",
          "push",
          "smile",
          "marine",
          "academy",
          "polish",
          "vegetarian",
          "drill",
          "miscarriage",
          "laser",
          "satisfaction",
          "copy",
          "angel",
          "rung",
          "glow",
          "publish",
          "figure",
          "scale",
          "story",
          "compete",
          "galaxy",
          "book",
          "conglomerate",
          "kidnap",
          "theorist",
          "cruelty",
          "inspiration",
          "doctor",
          "freckle",
          "transfer",
          "dictate",
          "thank",
          "midnight",
          "defend",
          "strikebreaker",
          "offensive",
          "wear",
          "minister",
          "curriculum",
          "capital",
          "patience",
          "notebook",
          "message",
          "horizon"
        ],
        "user_agent": {
          "aol": [
            "Mozilla/5.0 (compatible; MSIE 9.0; AOL 9.7; AOLBuild 4343.19; Windows NT 6.1; WOW64; Trident/5.0; FunWebProducts)"
          ],
          "chrome": [
            "Mozilla/5.0 (Windows NT 6.1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/41.0.2228.0 Safari/537.36"
          ],
          "firefox": [
            "Mozilla/5.0 (Windows NT x.y; Win64; x64; rv:10.0) Gecko/20100101 Firefox/10.0"
          ],
          "internet_explorer": [
            "Mozilla/5.0 (Windows NT 6.1; WOW64; Trident/7.0; AS; rv:11.0) like Gecko"
          ],
          "netscape": [
            "Mozilla/5.0 (Windows; U; Win 9x 4.90; SG; rv:1.9.2.4) Gecko/20101104 Netscape/9.1.0285"
          ],
          "opera": [
            "Opera/9.80 (X11; Linux i686; Ubuntu/14.10) Presto/2.12.388 Version/12.16"
          ],
          "safari": [
            "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_9_3) AppleWebKit/537.75.14 (KHTML, like Gecko) Version/7.0.3 Safari/7046A194A"
          ]
        }
      },
      "invoice": {
        "reference": {
          "check_digit_method": "method_731",
          "pattern": "\\d{3,19}#"
        }
      },
      "job": {
        "education_level": [
          "Associates",
          "Bachelor",
          "Master",
          "Doctorate"
        ],
        "employment_type": [
          "Full-time",
          "Part-time",
          "Temporary",
          "Contract",
          "Internship",
          "Commission"
        ],
        "field": [
          "Marketing",
          "IT",
          "Accounting",
          "Administration",
          "Advertising",
          "Banking",
          "Community-Services",
          "Construction",
          "Consulting",
          "Design",
          "Education",
          "Farming",
          "Government",
          "Healthcare",
          "Hospitality",
          "Legal",
          "Manufacturing",
          "Marketing",
          "Mining",
          "Real-Estate",
          "Retail",
          "Sales",
          "Technology"
        ],
        "key_skills": [
          "Teamwork",
          "Communication",
          "Problem solving",
          "Leadership",
          "Organisation",
          "Work under pressure",
          "Confidence",
          "Self-motivated",
          "Networking skills",
          "Proactive",
          "Fast learner",
          "Technical savvy"
        ],
        "position": [
          "Supervisor",
          "Associate",
          "Executive",
          "Liaison",
          "Officer",
          "Manager",
          "Engineer",
          "Specialist",
          "Director",
          "Coordinator",
          "Administrator",
          "Architect",
          "Analyst",
          "Designer",
          "Planner",
          "Orchestrator",
          "Technician",
          "Developer",
          "Producer",
          "Consultant",
          "Assistant",
          "Facilitator",
          "Agent",
          "Representative",
          "Strategist"
        ],
        "seniority": [
          "Lead",
          "Senior",
          "Product",
          "National",
          "Regional",
          "District",
          "Central",
          "Global",
          "Customer",
          "Investor",
          "Dynamic",
          "International",
          "Legacy",
          "Forward",
          "Internal",
          "Chief",
          "Direct",
          "Corporate",
          "Future",
          "Human",
          "Principal"
        ],
        "title": [
          "#{seniority} #{field} #{position}",
          "#{seniority} #{field} #{position}",
          "#{field} #{position}",
          "#{field} #{position}",
          "#{seniority} #{position}"
        ]
      },
      "kamen_rider": {
        "heisei": {
          "collectible_devices": [
            "Advent Card",
            "Mission Memory",
            "Rouse Card",
            "Disk Animal",
            "Zecter",
            "Rider Ticket",
            "Fuestle",
            "Rider Car",
            "Gaia Memory",
            "O Medal",
            "Astroswitch",
            "Wizard Ring",
            "Lockseed",
            "Shift Car",
            "Signal Bike",
            "Viral Core",
            "Ghost Eyecon",
            "Rider Gashat",
            "Energy Item",
            "Fullbottle",
            "Sclashjelly",
            "Ridewatch",
            "Miridewatch"
          ],
          "kamen_riders": [
            "Kamen Rider Kuuga",
            "Kamen Rider Agito",
            "Kamen Rider G3",
            "Kamen Rider Gills",
            "Kamen Rider G4",
            "Another Agito",
            "Kamen Rider Ryuki",
            "Kamen Rider Knight",
            "Kamen Rider Scissors",
            "Kamen Rider Zolda",
            "Kamen Rider Raia",
            "Kamen Rider Gai",
            "Kamen Rider Ouja",
            "Kamen Rider Odin",
            "Kamen Rider Femme",
            "Kamen Rider Ryuga",
            "Kamen Rider Tiger",
            "Kamen Rider Verde",
            "Kamen Rider Imperer",
            "Kamen Rider Faiz",
            "Kamen Rider Kaixa",
            "Kamen Rider Delta",
            "Kamen Rider Psyga",
            "Kamen Rider Orga",
            "Kamen Rider Blade",
            "Kamen Rider Garren",
            "Kamen Rider Chalice",
            "Kamen Rider Leangle",
            "Kamen Rider Glaive",
            "Kamen Rider Lance",
            "Kamen Rider Larc",
            "Kamen Rider Hibiki",
            "Kamen Rider Ibuki",
            "Kamen Rider Danki",
            "Kamen Rider Sabaki",
            "Kamen Rider Todoroki",
            "Kamen Rider Zanki",
            "Kamen Rider Eiki",
            "Kamen Rider Kabuki",
            "Kamen Rider Touki",
            "Kamen Rider Kirameki",
            "Kamen Rider Nishiki",
            "Kamen Rider Habataki",
            "Kamen Rider Shouki",
            "Kamen Rider Gouki",
            "Kamen Rider Toki",
            "Kamen Rider Banki",
            "Kamen Rider Shuki",
            "Kamen Rider Kabuto",
            "Kamen Rider TheBee",
            "Kamen Rider Drake",
            "Kamen Rider Sasword",
            "Kamen Rider Gatack",
            "Kamen Rider Hercus",
            "Kamen Rider Ketaros",
            "Kamen Rider Caucasus",
            "Kamen Rider KickHopper",
            "Kamen Rider PunchHopper",
            "Kamen Rider Dark Kabuto",
            "Kamen Rider Den-O",
            "Kamen Rider Zeronos",
            "Kamen Rider Gaoh",
            "Kamen Rider Nega Den-O",
            "Kamen Rider Yuuki",
            "Kamen Rider New Den-O",
            "Kamen Rider G Den-O",
            "Kamen Rider Kiva",
            "Kamen Rider Ixa",
            "Kamen Rider Rey",
            "Kamen Rider Arc",
            "Kamen Rider Saga",
            "Kamen Rider Dark Kiva",
            "Kamen Rider Decade",
            "Kamen Rider Abyss",
            "Kamen Rider Diend",
            "Kamen Rider Amaki",
            "Kamen Rider Kiva-la",
            "Kamen Rider Double",
            "Kamen Rider Skull",
            "Kamen Rider Accel",
            "Kamen Rider Eternal",
            "Kamen Rider Joker",
            "Kamen Rider OOO",
            "Kamen Rider Birth",
            "Kamen Rider Core",
            "Kamen Rider Birth·Proto Type",
            "Kamen Rider Poseidon",
            "Kamen Rider Aqua",
            "Kamen Rider Fourze",
            "Kamen Rider Nadeshiko",
            "Kamen Rider Meteor",
            "Kamen Rider Wizard",
            "Kamen Rider Wiseman",
            "Kamen Rider Beast",
            "Kamen Rider Mage",
            "Kamen Rider Sorcerer",
            "Kamen Rider Gaim",
            "Kamen Rider Zangetsu",
            "Kamen Rider Baron",
            "Kamen Rider Ryugen",
            "Kamen Rider Gridon",
            "Kamen Rider Kurokage",
            "Kamen Rider Bravo",
            "Kamen Rider Bujin Gaim",
            "Kamen Rider Duke",
            "Kamen Rider Marika",
            "Kamen Rider Sigurd",
            "Kamen Rider Knuckle",
            "Kamen Rider Fifteen",
            "Kamen Rider Mars",
            "Kamen Rider Kamuro",
            "Kamen Rider Jam",
            "Kamen Rider Idunn",
            "Kamen Rider Tyrant",
            "Kamen Rider Saver",
            "Kamen Rider Black Baron",
            "Kamen Rider Sylphi",
            "Kamen Rider Protodrive",
            "Kamen Rider Drive",
            "Kamen Rider Lupin",
            "Kamen Rider Mach",
            "Kamen Rider 3",
            "Kamen Rider 4",
            "Kamen Rider Chaser",
            "Kamen Rider Dark Drive",
            "Kamen Rider Jun",
            "Kamen Rider Chaser Mach",
            "Kamen Rider Mach Chaser",
            "Kamen Rider Heart",
            "Kamen Rider Brain",
            "Kamen Rider Ghost",
            "Kamen Rider Specter",
            "Kamen Rider Necrom",
            "Kamen Rider Dark Necrom Pink",
            "Kamen Rider Dark Ghost",
            "Kamen Rider Dark Necrom Red",
            "Kamen Rider Dark Necrom Blue",
            "Kamen Rider Dark Necrom Yellow",
            "Kamen Rider Zero Specter",
            "Kamen Rider Extremer",
            "Kamen Rider Kanon Specter",
            "Kamen Rider Amazon Omega",
            "Kamen Rider Amazon Alpha",
            "Kamen Rider Amazon Sigma",
            "Kamen Rider Amazon Neo",
            "Kamen Rider Amazon Neo Alpha",
            "Kamen Rider Ex-Aid",
            "Kamen Rider Genm",
            "Kamen Rider Brave",
            "Kamen Rider Snipe",
            "Kamen Rider Lazer",
            "Kamen Rider Para-DX",
            "Kamen Rider True Brave",
            "Aka-Rider",
            "Ao-Rider",
            "Mido-Rider",
            "Ki-Rider",
            "Momo-Rider",
            "Kamen Rider Poppy",
            "Kamen Rider Cronus",
            "Kamen Rider Fuma",
            "Kamen Rider Another Para-DX",
            "Kamen Rider Build",
            "Kamen Rider Cross-Z",
            "Kamen Rider Grease",
            "Kamen Rider Rogue",
            "Kamen Rider Evol",
            "Kamen Rider MadRogue",
            "Kamen Rider Blood",
            "Kamen Rider Killbus",
            "Kamen Rider Metal Build",
            "Kamen Rider Zi-O",
            "Kamen Rider Geiz",
            "Kamen Rider Woz",
            "Kamen Rider Shinobi",
            "Kamen Rider Quiz",
            "Kamen Rider Kikai",
            "Kamen Rider Hattari",
            "Kamen Rider Ginga",
            "Kamen Rider Barlckxs",
            "Kamen Rider Zonjis",
            "Kamen Rider Zamonas",
            "Kamen Rider Tsukuyomi"
          ],
          "series": [
            "Kamen Rider Kuuga",
            "Kamen Rider Agito",
            "Kamen Rider Ryuki",
            "Kamen Rider 555",
            "Kamen Rider Blade",
            "Kamen Rider Hibiki",
            "Kamen Rider Kabuto",
            "Kamen Rider Den-O",
            "Kamen Rider Kiva",
            "Kamen Rider Decade",
            "Kamen Rider W",
            "Kamen Rider OOO",
            "Kamen Rider Fourze",
            "Kamen Rider Wizard",
            "Kamen Rider Gaim",
            "Kamen Rider Drive",
            "Kamen Rider Ghost",
            "Kamen Rider Amazons",
            "Kamen Rider Ex-Aid",
            "Kamen Rider Build",
            "Kamen Rider Zi-O"
          ],
          "transformation_devices": [
            "Acceldriver",
            "Altering",
            "Amazons Driver",
            "Ank Point",
            "Aqua Driver",
            "Arc Kivat",
            "Arc Kivat Belt",
            "Arcle",
            "Assault Grip",
            "Beast Driver",
            "Beyondriver",
            "Birth Driver",
            "Blay Buckle",
            "Brain Driver",
            "Break Gunner",
            "Bugster Buckle",
            "Build Driver",
            "Card Decks",
            "Caucasus Zecter",
            "Chalice Rouzer",
            "Cross-Z Magma Knuckle",
            "Dark Kabuto Zecter",
            "Dark Kivat Belt",
            "Decadriver",
            "Den-O Belt",
            "Diendriver",
            "Dooms Driver Buckle",
            "Doubledriver",
            "Drago Timer",
            "Drake Glip",
            "Drake Zecter",
            "Drive Driver",
            "Ecto-Accelerator Belt",
            "Eden Driver",
            "Evol-Driver",
            "Extremer Driver",
            "Eyecon Driver G",
            "Fourze Driver",
            "G Den-O Belt",
            "Gaia Driver",
            "Gaia Driver Rex",
            "Gamer Driver",
            "Ganbaride Driver",
            "Gaoh Belt",
            "Garren Buckle",
            "Gashacon Bugvisor",
            "Gashacon Bugvisor II",
            "Gashat Gear Dual",
            "Gashat Gear Dual Another",
            "Gashat Gear Dual β",
            "Gatack Zecter",
            "Genesis Driver",
            "Ghost Driver",
            "GingaOh Driver",
            "Gingadriver",
            "Glaive Buckle",
            "Golden Khakkhara",
            "Grease Blizzard Knuckle",
            "Grease Perfect Kingdom",
            "Haken Bladriver",
            "Hattaridriver",
            "Henshin Kigen",
            "Henshin Onibue",
            "Henshin Onsa",
            "Hercus Zecter",
            "Hopper Zecter",
            "Hypnos",
            "Ixa Belt",
            "Ixa Knuckle",
            "J-Spirit",
            "Jacorder",
            "Jaken Caliburdriver",
            "K-Taros",
            "K-Touch",
            "Kabutick Zecters",
            "Kabuto Zecter",
            "Ketaros Zecter",
            "Kikaidriver",
            "Killbuspider",
            "Kiva-la",
            "Kivat Belt",
            "Kivat-Bat the 2nd",
            "Kivat-Bat the 3rd",
            "Kivat-Bat the 4th",
            "Krim Steinbelt",
            "Lance Buckle",
            "Larc Buckle",
            "Leangle Buckle",
            "Lostdriver",
            "Lupin Gunner",
            "Mach Driver Honoh",
            "Mach Driver Production Model",
            "Mage's Belt",
            "Mega Ulorder",
            "Meta Factor",
            "Meteor Driver",
            "Militant Amazons Register",
            "Miraidriver",
            "NS-MagPhone",
            "Nadeshiko Driver",
            "Nebulasteam Gun",
            "Neo Amazons Driver",
            "Neo Amazons Register",
            "New Den-O Belt",
            "O Scanner",
            "OOO Driver",
            "Ohma Zi-O Driver",
            "Poseidon Driver",
            "Proto Mega Ulorder",
            "Pure Silver Metal Stick",
            "Quizdriver",
            "Rey Kivat",
            "Rey Kivat Belt",
            "Rider Belt",
            "Rider Brace",
            "Rider Buckle",
            "Riderman Suit",
            "Robo-Accelerator Belt",
            "Rouse Absorber",
            "SB-000B Orga Driver",
            "SB-315B Psyga Driver",
            "SB-315P Psyga Phone",
            "SB-333B Delta Driver",
            "SB-333DV Delta Mover",
            "SB-555B Faiz Driver",
            "SB-555P Faiz Phone",
            "SB-555W Faiz Axel",
            "SB-913B Kaixa Driver",
            "SB-913P Kaixa Phone",
            "Sagarc",
            "Sagarc Belt",
            "Sasword Yaiver",
            "Sasword Zecter",
            "Sclash Driver",
            "Sengoku Driver",
            "Shift Brace",
            "Shinobidriver",
            "Smart Buckle",
            "Sorcerer's Belt",
            "TheBee Zecter",
            "Tokujo-ka Key",
            "Transteam Gun",
            "Zecter"
          ],
          "users": [
            "Yusuke Godai",
            "Shoichi Tsugami",
            "Makoto Hikawa",
            "Ryo Ashihara",
            "Shiro Mizuki",
            "Kaoru Kino",
            "Shinji Kido",
            "Ren Akiyama",
            "Masashi Sudo",
            "Shuichi Kitaoka",
            "Miyuki Tezuka",
            "Jun Shibaura",
            "Takeshi Asakura",
            "Kamen Rider Odin",
            "Miho Kirishima",
            "Dark Shinji",
            "Satoru Tojo",
            "Itsuro Takamizawa",
            "Mitsuru Sano",
            "Takumi Inui",
            "Masato Kusaka",
            "Syuji Mihara",
            "Leo",
            "Yuji Kiba",
            "Kazuma Kenzaki",
            "Sakuya Tachibana",
            "Hajime Aikawa",
            "Mutsuki Kamijo",
            "Junichi Shimura",
            "Shin Magaki",
            "Natsumi Miwa",
            "Hitoshi Hidaka",
            "Iori Izumi",
            "Daisuke Danda",
            "Sakae Saeki",
            "Tomizo Todayama",
            "Zaomaru Zaitsuhara",
            "Eiki",
            "Kabuki",
            "Touki",
            "Kirameki",
            "Nishiki",
            "Habataki",
            "Shouki",
            "Gouki",
            "Toki",
            "Banki",
            "Shiori Shinagawa",
            "Soji Tendo",
            "Shun Kageyama",
            "Daisuke Kazama",
            "Tsurugi Kamishiro",
            "Arata Kagami",
            "Hidenari Oda",
            "Tetsuki Yamato",
            "Issei Kurosaki",
            "So Yaguruma",
            "Shun Kageyama",
            "Soji Kusakabe",
            "Ryotaro Nogami",
            "Yuto Sakurai",
            "Gaoh",
            "Negataros",
            "Shiro",
            "Kotaro Nogami",
            "Reiji Kurosaki",
            "Wataru Kurenai",
            "Keisuke Nago",
            "Takato Shiramine",
            "Takashi Sugimura",
            "Taiga Nobori",
            "King",
            "Tsukasa Kadoya",
            "Kamata",
            "Daiki Kaito",
            "Akira",
            "Natsumi Hikari",
            "Shotaro Hidari & Philip",
            "Sokichi Narumi",
            "Ryu Terui",
            "Katsumi Daido",
            "Shotaro Hidari",
            "Eiji Hino",
            "Shintaro Goto",
            "Kamen Rider Core",
            "Akira Date",
            "Poseidon",
            "Michal Minato",
            "Gentaro Kisaragi",
            "Nadeshiko Misaki",
            "Ryusei Sakuta",
            "Haruto Soma",
            "Sou Fueki",
            "Kosuke Nitoh",
            "Mayu Inamori",
            "Ogma",
            "Kouta Kazuraba",
            "Takatora Kureshima",
            "Kaito Kumon",
            "Mitsuzane Kureshima",
            "Hideyasu Jonouchi",
            "Ryoji Hase",
            "Oren Pierre Alfonzo",
            "Bujin Gaim",
            "Ryoma Sengoku",
            "Yoko Minato",
            "Lock Dealer Sid",
            "Zack",
            "Ren Aoi",
            "Kohgane",
            "Lapis",
            "Kohgane",
            "Touka Akatsuki",
            "Alfred",
            "Kugai Kudo",
            "Shura",
            "Masako Suzuka",
            "Chase",
            "Shinnosuke Tomari",
            "Zoruku Tojo",
            "Kyoichiro Kuroi",
            "Kamen Rider 4",
            "Chase",
            "Paradox Roidmude",
            "Jun Honganji",
            "Go Shijima",
            "Heart",
            "Brain",
            "Takeru Tenkuji",
            "Makoto Fukami",
            "Alain",
            "Alia",
            "Argos",
            "Jered",
            "Jebil",
            "Jey",
            "Daigo Fukami",
            "Argos",
            "Kanon Fukami",
            "Haruka Mizusawa",
            "Jin Takayama",
            "Jun Maehara",
            "Chihiro",
            "Einosuke Mido",
            "Emu Hojo",
            "Kuroto Dan",
            "Hiiro Kagami",
            "Taiga Hanaya",
            "Kiriya Kujo",
            "Parado",
            "Another Hiiro",
            "Emu Hojo",
            "Yakumo Katou",
            "Shuichi Kitaoka",
            "Masato Jin",
            "Momotaros",
            "Poppy Pipopapo",
            "Masamune Dan",
            "Kagenari Nagumo",
            "Black Parado",
            "Sento Kiryu",
            "Ryuga Banjo",
            "Kazumi Sawatari",
            "Gentoku Himuro",
            "Evolto",
            "Nariaki Utsumi",
            "Kengo Ino",
            "Killbus",
            "Keiji Uraga",
            "Sougo Tokiwa",
            "Geiz Myokoin",
            "Black Woz",
            "Rentaro Kagura",
            "Mondo Douan",
            "Rento Makina",
            "Isamichi Konjo",
            "Kamen Rider Ginga",
            "SOUGO Tokiwa",
            "Kagen",
            "Jogen",
            "Tsukuyomi"
          ]
        },
        "reiwa": {
          "collectible_devices": [
            "Progrisekey",
            "Wonder Ride Book",
            "Vistamp"
          ],
          "kamen_riders": [
            "Kamen Rider Zero-One",
            "Kamen Rider Vulcan",
            "Kamen Rider Valkyrie",
            "Kamen Rider Horobi",
            "Kamen Rider Jin",
            "Kamen Rider Ikazuchi",
            "Kamen Rider ZeroZero-One",
            "Kamen Rider Ichi-Gata",
            "Kamen Rider Thouser",
            "Kamen Rider Ark-Zero",
            "Kamen Rider Naki",
            "Kamen Rider Eden",
            "Kamen Rider Abaddon",
            "Kamen Rider Lucifer",
            "Kamen Rider Zaia",
            "Kamen Rider MetsubouJinrai",
            "Kamen Rider Saber",
            "Kamen Rider Calibur",
            "Kamen Rider Blades",
            "Kamen Rider Buster",
            "Kamen Rider Espada",
            "Kamen Rider Kenzan",
            "Kamen Rider Slash",
            "Kamen Rider Falchion",
            "Kamen Rider Saikou",
            "Kamen Rider Sabela",
            "Kamen Rider Durendal",
            "Kamen Rider Solomon",
            "Kamen Rider Storious",
            "Kamen Rider Revi",
            "Kamen Rider Vice"
          ],
          "series": [
            "Kamen Rider Zero-One",
            "Kamen Rider Saber",
            "Kamen Rider Revice"
          ],
          "transformation_devices": [
            "A.I.M.S. Shotriser",
            "Abaddoriser",
            "Cycloneriser",
            "MetsubouJinrai Driver",
            "MetsubouJinrai Forceriser",
            "Raidriser",
            "Suiseiken Nagare",
            "Seiken Saikou Driver",
            "Seiken Swordriver",
            "Fuusouken Hayate",
            "Revice Driver",
            "Ark Driver",
            "Hiden Zero-One Driver",
            "Hiden Zero-Two Driver",
            "Gekkou Raimeiken Ikazuchi",
            "Raimeiken Ikazuchi",
            "Kaenken Rekka",
            "Haouken Xross Saber",
            "Dogouken Gekido",
            "Kougouken Saikou",
            "Mumeiken Kyomu",
            "Jikokuken Kaiji",
            "Eneiken Noroshi",
            "Ankokuken Kurayami",
            "Onjuuken Suzune"
          ],
          "users": [
            "Aruto Hiden",
            "Isamu Fuwa",
            "Yua Yaiba",
            "Horobi",
            "Jin",
            "Ikazuchi",
            "Soreo Hiden",
            "Gai Amatsu",
            "Ark",
            "Naki",
            "Rihito Isshiki",
            "Behru",
            "Lyon Arkland",
            "MetsubouJinrai",
            "Touma Kamiyama",
            "Daichi Kamijo",
            "Rintaro Shindo",
            "Ryo Ogami",
            "Kento Fukamiya",
            "Ren Akamichi",
            "Tetsuo Daishinji",
            "Bahato",
            "Yuri",
            "Reika Shindai",
            "Ryoga Shindai",
            "Isaac",
            "Storious",
            "Ikki Igarashi",
            "Vice"
          ]
        },
        "showa": {
          "kamen_riders": [
            "Kamen Rider 1",
            "Kamen Rider 2",
            "Kamen Rider V3",
            "Riderman",
            "Kamen Rider X",
            "Kamen Rider Amazon",
            "Kamen Rider Stronger",
            "Skyrider",
            "Kamen Rider Super-1",
            "Kamen Rider ZX",
            "Kamen Rider Black",
            "Kamen Rider Black RX",
            "Kamen Rider Shin",
            "Kamen Rider ZO",
            "Kamen Rider J"
          ],
          "series": [
            "Kamen Rider",
            "Kamen Rider V3",
            "Kamen Rider X",
            "Kamen Rider Amazon",
            "Kamen Rider Stronger",
            "Kamen Rider (Skyrider)",
            "Kamen Rider Super-1",
            "Kamen Rider Black",
            "Kamen Rider ZX",
            "Kamen Rider Black RX",
            "Shin Kamen Rider: Prologue",
            "Kamen Rider ZO",
            "Kamen Rider J"
          ],
          "transformation_devices": [
            "Typhoon",
            "Double Typhoon",
            "Ridol",
            "Redizer",
            "Perfecter",
            "GiGi Armlet",
            "Electrer",
            "Tornado",
            "Cyclode",
            "ZX Belt",
            "Vital Charger",
            "Shadow Charger",
            "Sunriser"
          ],
          "users": [
            "Takeshi Hongo",
            "Hayato Ichimonji",
            "Shiro Kazami",
            "Joji Yuki",
            "Keisuke Jin",
            "Daisuke Yamamoto",
            "Shigeru Jo",
            "Hiroshi Tsukuba",
            "Kazuya Oki",
            "Ryo Murasame",
            "Kohtaro Minami",
            "Kohtaro Minami",
            "Shin Kazamatsuri",
            "Masaru Aso",
            "Kouji Segawa"
          ]
        }
      },
      "kpop": {
        "boy_bands": [
          "1TYM",
          "2AM",
          "2PM",
          "4Men",
          "5tion",
          "5urprise",
          "24K",
          "100%",
          "2000 Won",
          "A-Jax",
          "A.cian",
          "Ace",
          "AlphaBat",
          "Apeace",
          "Astro",
          "B.A.P",
          "B.I.G",
          "B1A4",
          "Bastarz",
          "Battle",
          "Be.A",
          "Beatwin",
          "Big Bang",
          "Big Star",
          "Bigflo",
          "Black Beat",
          "Block B",
          "The Blue",
          "The Boss",
          "Boyfriend",
          "Boys Republic",
          "Boys24",
          "The Boyz",
          "Brown Eyed Soul",
          "Brown Eyes",
          "BTL",
          "BtoB",
          "BTS",
          "C-Clown",
          "Can",
          "Click-B",
          "CNBLUE",
          "Cross Gene",
          "DMTN",
          "Day6",
          "December",
          "Double S 301",
          "Double-A",
          "The East Light",
          "Every Single Day",
          "Exo",
          "EXO-CBX",
          "F.Cuz",
          "Flower",
          "Fly to the Sky",
          "GD & TOP",
          "GD X Taeyang",
          "G.o.d",
          "Golden Child",
          "Got7",
          "H.O.T.",
          "Halo",
          "HeartB",
          "High4",
          "Highlight",
          "History",
          "Homme",
          "Honey G",
          "HONEYST",
          "Hotshot",
          "IKon",
          "Imfact",
          "IN2IT",
          "Infinite",
          "Infinite F",
          "Infinite H",
          "IZ",
          "J-Walk",
          "JBJ",
          "JJ Project",
          "JJCC",
          "JnC",
          "JtL",
          "JYJ",
          "KNK",
          "K'Pop",
          "LC9",
          "Ledt",
          "The Legend",
          "Lunafly",
          "M.Pire",
          "M4M",
          "Madtown",
          "M&D",
          "MAP6",
          "MAS",
          "MASC",
          "MBLAQ",
          "MC the Max",
          "Monday Kiz",
          "Monsta X",
          "Mr. Mr",
          "MVP",
          "Myname",
          "Myteen",
          "N-Sonic",
          "N-Train",
          "N.Flying",
          "NCT",
          "Noel",
          "NOM",
          "NRG",
          "NU'EST",
          "One Way",
          "ONF",
          "Pentagon",
          "Rainz",
          "Rok Kiss",
          "Romeo",
          "Sechs Kies",
          "Seven O'Clock",
          "Seventeen",
          "SF9",
          "SG Wannabe",
          "Shinee",
          "Shinhwa",
          "Shu-I",
          "Snuper",
          "Speed",
          "SS501",
          "Super Junior",
          "Super Junior-D&E",
          "Super Junior-H",
          "Super Junior-K.R.Y.",
          "Super Junior-M",
          "Super Junior-T",
          "Supernova",
          "Sweet Sorrow",
          "T-max",
          "Tasty",
          "Teen Top",
          "Toheart",
          "Top Secret",
          "Topp Dogg",
          "Touch",
          "TRCNG",
          "Tritops",
          "TVXQ",
          "U-KISS",
          "Ulala Session",
          "UN",
          "Uniq",
          "UP10TION",
          "V.O.S",
          "Varsity",
          "VAV",
          "Vibe",
          "Victon",
          "VIXX",
          "VIXX LR",
          "Voisper",
          "Vromance",
          "Wanna One",
          "Wanted",
          "Winner",
          "Yurisangja",
          "ZE:A"
        ],
        "girl_groups": [
          "2NB",
          "2NE1",
          "2Yoon",
          "4L",
          "4Minute",
          "4Ten",
          "15&",
          "After School",
          "AOA",
          "AOA Black",
          "AOA Cream",
          "Apink",
          "April",
          "As One",
          "Baby Vox",
          "Baby Vox Re.V",
          "Badkiz",
          "Bambino",
          "The Barberettes",
          "Berry Good",
          "Bestie",
          "Big Mama",
          "Black Pearl",
          "Blackpink",
          "Blady",
          "Bob Girls",
          "Bolbbalgan4",
          "BP Rania",
          "Brave Girls",
          "Brown Eyed Girls",
          "C-REAL",
          "Chakra",
          "Chocolat",
          "CLC",
          "Cleo",
          "Cosmic Girls",
          "Crayon Pop",
          "Cupid",
          "D-Unit",
          "D.Holic",
          "Dal Shabet",
          "Davichi",
          "Dia",
          "Diva",
          "Dreamcatcher",
          "Elris",
          "EvoL",
          "EXID",
          "F-ve Dolls",
          "F(x)",
          "Favorite",
          "Fiestar",
          "Fin.K.L",
          "Fromis",
          "Gangkiz",
          "Gavy NJ",
          "GFriend",
          "GI",
          "Girl Friends",
          "Girl's Day",
          "Girls Girls",
          "Girls' Generation",
          "Girls' Generation-TTS",
          "Glam",
          "Good Day",
          "GP Basic",
          "The Grace",
          "Gugudan",
          "Hash Tag",
          "Hello Venus",
          "Hi Suhyun",
          "I.B.I",
          "I.O.I",
          "Isak N Jiyeon",
          "Jewelry",
          "JQT",
          "Kara",
          "Kiss",
          "Laboum",
          "Ladies' Code",
          "Lip Service",
          "Loona",
          "Lovelyz",
          "LPG",
          "Luv",
          "Mamamoo",
          "Melody Day",
          "Milk",
          "Miss A",
          "Miss S",
          "Momoland",
          "Nine Muses",
          "Nine Muses A",
          "Oh My Girl",
          "Orange Caramel",
          "P.O.P",
          "Papaya",
          "Playback",
          "Pristin",
          "Pungdeng-E",
          "Puretty",
          "QBS",
          "Rainbow",
          "Red Velvet",
          "Rubber Soul",
          "S.E.S.",
          "S.I.S",
          "Secret",
          "SeeYa",
          "The SeeYa",
          "She'z",
          "Shinvi",
          "Sistar",
          "Sistar19",
          "Skarf",
          "Sonamoo",
          "Sorea Band",
          "Spica",
          "Stellar",
          "Sugar",
          "Sunny Days",
          "Sunny Hill",
          "T-ara",
          "T-ara N4",
          "T.T.Ma",
          "Tahiti",
          "Draft:THE ARK",
          "Tiny-G",
          "Twice",
          "Two X",
          "Unicorn",
          "Wassup",
          "Weki Meki",
          "Wink",
          "Wonder Girls"
        ],
        "i_groups": [
          "Seo Taiji and Boys",
          "Deux",
          "Cool",
          "DJ DOC",
          "Roo'ra",
          "Two Two",
          "R.ef",
          "Turbo",
          "Baby V.O.X.",
          "Diva",
          "Eve",
          "Jinusean",
          "NRG",
          "Sechs Kies",
          "S.E.S",
          "1TYM",
          "Fin.K.L.",
          "Koyote",
          "S#arp",
          "Shinhwa",
          "As One",
          "Chakra",
          "Cleo",
          "Click-B",
          "Fly to the Sky",
          "g.o.d",
          "T.T.MA"
        ],
        "ii_groups": [
          "CB Mass",
          "Papaya",
          "5tion",
          "Jewelry",
          "KISS.",
          "M.I.L.K",
          "jtL",
          "Epik High",
          "Sugar",
          "Black Beat",
          "Shinvi",
          "Leessang",
          "LUV",
          "Isak N Jiyeon",
          "Moon Child",
          "Moon Child",
          "Big Mama",
          "Dynamic Duo",
          "Brown Eyed Soul",
          "Buzz",
          "TVXQ",
          "SG Wannabe",
          "V.O.S",
          "TRAX",
          "SS501",
          "LPG",
          "The Grace",
          "Gavy NJ",
          "Super Junior",
          "Paran",
          "SeeYa",
          "Brown Eyed Girls",
          "Untouchable",
          "Big Bang",
          "Super Junior-K.R.Y.",
          "DickPunks",
          "Wonder Girls",
          "Kara",
          "F.T. Island",
          "Girls' Generation",
          "8eight",
          "Sunny Hill",
          "Supernova",
          "Tritops",
          "Super Junior-T",
          "Baby Vox Re.V",
          "Davichi",
          "Mighty Mouth",
          "Miss $",
          "Shinee",
          "Super Junior-M",
          "Super Junior-H",
          "2AM",
          "2PM",
          "U-KISS",
          "2NE1",
          "4Minute",
          "After School",
          "Beast",
          "f(x)",
          "JQT",
          "MBLAQ",
          "Rainbow",
          "Secret",
          "SHU-I",
          "T-ara",
          "December"
        ],
        "iii_groups": [
          "APeace",
          "CNBLUE",
          "Coed School",
          "DMTN",
          "F.Cuz",
          "Girl's Day",
          "GD&TOP",
          "GP Basic",
          "Infinite",
          "JYJ",
          "Led Apple",
          "Miss A",
          "Nine Muses",
          "Orange Caramel",
          "Sistar",
          "Teen Top",
          "Touch",
          "The Boss",
          "ZE:A",
          "AA",
          "APink",
          "B1A4",
          "Blady",
          "Block B",
          "Boyfriend",
          "Brave Girls",
          "C-Real",
          "Chocolat",
          "Dal Shabet",
          "F-ve Dolls",
          "M&D",
          "M.I.B",
          "My Name",
          "N-Sonic",
          "N-Train",
          "RaNia",
          "Sistar19",
          "Stellar",
          "Super Junior-D&E",
          "Trouble Maker",
          "100%",
          "15&",
          "24K",
          "A-Jax",
          "AOA",
          "B.A.P",
          "Big Star",
          "BtoB",
          "C-Clown",
          "Crayon Pop",
          "Cross Gene",
          "D-Unit",
          "EvoL",
          "EXID",
          "EXO",
          "Fiestar",
          "Gangkiz",
          "Girls' Generation-TTS",
          "GLAM",
          "HELLOVENUS",
          "JJ Project",
          "Lunafly",
          "Mr. Mr.",
          "NU'EST",
          "Phantom",
          "Puretty",
          "She'z",
          "Skarf",
          "Spica",
          "Sunny Days",
          "Tahiti",
          "Tasty",
          "The SeeYa",
          "Tiny-G",
          "Two X",
          "VIXX",
          "2Yoon",
          "5urprise",
          "AlphaBat",
          "AOA Black",
          "BESTie",
          "Boys Republic",
          "BTS",
          "G.I",
          "History",
          "Infinite H",
          "Ladies' Code",
          "LC9",
          "M.Pire",
          "NOM",
          "QBS",
          "Royal Pirates",
          "Speed",
          "T-ara N4",
          "Topp Dogg",
          "Wa$$up",
          "2000 Won",
          "4L",
          "4Ten",
          "Akdong Musician",
          "Almeng",
          "Badkiz",
          "Berry Good",
          "B.I.G",
          "Bigflo",
          "Bob Girls",
          "BTL",
          "D.Holic",
          "GD X Taeyang",
          "GOT7",
          "HeartB",
          "Hi Suhyun",
          "High4",
          "HOTSHOT",
          "HALO",
          "Infinite F",
          "JJCC",
          "K-Much",
          "Laboum",
          "Lip Service",
          "Lovelyz",
          "Madtown",
          "Mamamoo",
          "Melody Day",
          "Minx",
          "Play the Siren",
          "Red Velvet",
          "Sonamoo",
          "The Legend",
          "ToHeart",
          "UNIQ",
          "Wings",
          "Winner",
          "April",
          "Bambino",
          "Bastarz",
          "Big Brain",
          "CLC",
          "Cupid",
          "Day6",
          "DIA",
          "GFriend",
          "iKon",
          "Monsta X",
          "N.Flying",
          "Oh My Girl",
          "PLAYBACK",
          "Romeo",
          "Rubber Soul",
          "Seventeen",
          "Snuper",
          "Twice",
          "UNICORN",
          "UP10TION",
          "VAV",
          "VIXX LR",
          "AOA Cream",
          "Astro",
          "Blackpink",
          "Bolbbalgan4",
          "BP Rania",
          "C.I.V.A",
          "Cosmic Girls",
          "EXO-CBX",
          "Gugudan",
          "I.B.I",
          "I.O.I",
          "Imfact",
          "KNK",
          "MASC",
          "MOBB",
          "Momoland",
          "NCT",
          "Nine Muses A",
          "Pentagon",
          "SF9",
          "The East Light",
          "Unnies",
          "Victon",
          "Vromance",
          "A.C.E",
          "Be.A",
          "Dream Catcher",
          "Duetto",
          "ELRIS",
          "Favorite",
          "Fromis",
          "Golden Child",
          "Good Day",
          "Gugudan Ogu-ogu",
          "Hash Tag",
          "HONEYST",
          "Highlight",
          "IN2IT",
          "IZ",
          "JBJ",
          "K.A.R.D",
          "Longguo & Shihyun",
          "MVP",
          "MXM",
          "MYTEEN",
          "NU'EST W",
          "ONF",
          "P.O.P",
          "Pristin",
          "Rainz",
          "S.I.S",
          "Seven O'Clock",
          "The Boyz",
          "Top Secret",
          "TRCNG",
          "Triple H",
          "Wanna One",
          "Weki Meki"
        ],
        "solo": [
          "Ailee",
          "Ajoo",
          "Alexander Lee Eusebio",
          "Ali",
          "Amber Liu",
          "Bada",
          "Bae Suzy",
          "Bae Seul-ki",
          "Baek Ji-young",
          "Bang Yong Guk",
          "Bi",
          "Baro",
          "Bizniz",
          "BoA",
          "Byul",
          "Byun Baek-hyun",
          "Brian Joo",
          "Baek A-yeon",
          "Boom",
          "Bora",
          "Bang Cheol Yong",
          "Chae Jung-an",
          "Chae Yeon",
          "Chen",
          "Cho Yong-pil",
          "CNU",
          "Choi Minho",
          "Choi Sulli",
          "Cho Kyuhyun",
          "Choi Siwon",
          "Choi Soo-young",
          "Choi Min-hwan",
          "Choi Jong-hoon",
          "Crush",
          "Dae Sung",
          "Dana",
          "Dara",
          "Do Kyung-soo",
          "Dean",
          "Dok2",
          "Drunken Tiger",
          "Eru",
          "Eugene",
          "Eunhyuk",
          "Eun Ji Won",
          "E.via",
          "Eric Nam",
          "Fat Cat",
          "G.NA",
          "Gary",
          "Gil Seong-joon",
          "Gummy",
          "G-Dragon",
          "Goo Ha-ra",
          "Gain",
          "G.O",
          "Gongchan",
          "Han Seungyeon",
          "Ham Eun-jeong",
          "Han Sunhwa",
          "Ha Ji-won",
          "Haha",
          "Henry Lau",
          "Heo Ga Yoon",
          "Heo Young Saeng",
          "Heo Young-ji",
          "Hong Jin-Young",
          "Hong Kyung Min",
          "Hoon",
          "Hyolyn",
          "Hyomin",
          "Hyun Bin",
          "Huh Gak",
          "Hwangbo",
          "Hwang Chansung",
          "Tiffany Hwang",
          "Hwanhee",
          "Hwayobi",
          "Hyun Young",
          "Hyelim",
          "Im Chang-jung",
          "Im Yoona",
          "Insooni",
          "IU",
          "Ivy",
          "J",
          "JB",
          "Jr.",
          "Jang Dong-woo",
          "Jang Keun-suk",
          "Jang Hyun-seung",
          "Jang Na-ra",
          "Jang Woo Hyuk",
          "Jang Wooyoung",
          "Jang Yun-jeong",
          "Jeon Boram",
          "Jeon Hye Bin",
          "Jia",
          "Jeon Ji Yoon",
          "Jeong Jinwoon",
          "Jessica Jung",
          "J-Min",
          "Jo Eun Byul",
          "Jo Kwon",
          "Jo Sungmo",
          "JOO",
          "Joy",
          "John Park",
          "Jonghyun",
          "Joo Hyun-Mi",
          "Jun Jin",
          "Jun Hyoseong",
          "Jun.K",
          "Jung Daehyun",
          "Jung Hana",
          "Jinyoung",
          "Nicole Jung",
          "Jung Yong-hwa",
          "Juniel",
          "K",
          "Kai",
          "Kim Jungah",
          "KCM",
          "Kahi",
          "Kan Mi-youn",
          "Kang Min-hyuk",
          "Kang Seung-yoon",
          "Kang Sung-hoon",
          "Kangin",
          "Kangta",
          "Key",
          "Kibum",
          "Kim Ah-joong",
          "Kim Bum",
          "Kim Bum-soo",
          "Kim C",
          "Kim Dong-ryool",
          "Kim Dong-wan",
          "Kim Gun-mo",
          "Kim Heechul",
          "Kim Himchan",
          "Kim Hyoyeon",
          "Kim Hyuna",
          "Kim Hyun-joong",
          "Kim Hyung-jun",
          "Kim Jaejoong",
          "Kim Jong-kook",
          "Kim Joon",
          "Kim Junsu",
          "Kim Kyu-jong",
          "Kim Kyung-ho",
          "Kim Myung-soo",
          "Kim Ryeowook",
          "Kim Tae-woo",
          "Kim Tae-yeon",
          "Kim Seol-hyun",
          "Kim Soo-hyun",
          "Kim Sung-kyu",
          "Kim Taeyeon",
          "Kim Yeonji",
          "Kwon So-hyun",
          "Kim Young-sook",
          "Krystal Jung",
          "Kwon Mina",
          "Kwon Yuri",
          "K.Will",
          "Lay",
          "Lee Jooyeon",
          "Lee Chae-rin",
          "Lee Dong-gun",
          "Lee Donghae",
          "Lee Gi-kwang",
          "Lee Min-young",
          "Lee Hi",
          "Lee Howon",
          "Lee Hong-gi",
          "Lee Hyori",
          "Lee Hyun",
          "Lee Jae-jin",
          "Lee Jae-won",
          "Lee Ji-hoon",
          "Lee Jin",
          "Lee Jong-hyun",
          "Lee Joon",
          "Lee Junho",
          "Lee Jung",
          "Lee Jung-hyun",
          "Lee Joon-gi",
          "Lee Ki-chan",
          "Lee Min-ho",
          "Lee Min-woo",
          "Lee Seung-hoon",
          "Lee Seung-chul",
          "Lee Seung-gi",
          "Lee Seung-hyun",
          "Lee Soo-young",
          "Lee Sora",
          "Lee Sung-jong",
          "Lee Sungmin",
          "Lee Sung-yeol",
          "Lee Tae-min",
          "Leeteuk",
          "Lena Park",
          "Lexy",
          "Lim Jeong-hee",
          "Luna",
          "Lyn",
          "MC Mong",
          "MC Sniper",
          "Min Hae Kyung",
          "Min Hyorin",
          "Min Hyuk",
          "Minzy",
          "Mina",
          "Minwoo",
          "Moon Ga-young",
          "Moon Hee Jun",
          "Moon Jong Up",
          "Nam Ji-hyun",
          "Nam Woo-hyun",
          "Nana",
          "Narsha",
          "Nichkhun Horvejkul",
          "Nicole",
          "Nicky Lee",
          "No Minwoo",
          "NS Yoon-G",
          "Oh Se-hun",
          "Onew",
          "Outsider",
          "Park Bom",
          "Park Chan-yeol",
          "Park Choa",
          "Park Gyu-ri",
          "Park Jung-ah",
          "Park Jung-min",
          "Park Ji-yeon",
          "Park Ji-yoon",
          "Park Jin-young",
          "Park Junyoung",
          "Park Yong-ha",
          "Jay Park",
          "Park Shin-hye",
          "Park Myeong-su",
          "Park Soyeon",
          "Psy",
          "Qri",
          "Raina",
          "Rain",
          "Rap Monster",
          "Roh Ji Hoon",
          "Ryu Si-won",
          "Ryu Hwayoung",
          "Ryu Hyoyoung",
          "Sandeul",
          "Se7en",
          "Seo Joohyun",
          "Seo Hyo-rim",
          "Seo In-guk",
          "Seo In-young",
          "Seo Ji-young",
          "Seo Yuna",
          "Seomoon Tak",
          "Seo Taiji",
          "Seungho",
          "Shim Changmin",
          "Shim Eun-jin",
          "Shin Dongho",
          "Shin Dong-hee",
          "Shin Hae-chul",
          "Shin Hye-jeong",
          "Shin Hye-sung",
          "Shin Ji",
          "Shin Ji-min",
          "Shin Seung-hun",
          "Shoo",
          "Sim Soo-bong",
          "So Chan-whee",
          "Sohee",
          "Solbi",
          "Son Dam-bi",
          "Son Dong-woon",
          "Son Hoyoung",
          "Song Jieun",
          "Song Ji-hyo",
          "Song Joong-ki",
          "Song Min-ho",
          "Song Seung-hyun",
          "Suho",
          "Sung Si-kyung",
          "Sung Yu-ri",
          "Sunny",
          "T.O.P",
          "Tablo",
          "Tae Bin",
          "Taecyeon",
          "Tae Jin Ah",
          "Taegoon",
          "Taeyang",
          "Tasha Reid",
          "Tim",
          "Tony An",
          "Thunder",
          "Uee",
          "U;Nee",
          "Uhm Jung-hwa",
          "Victoria Song",
          "Wax",
          "Wendy",
          "Wheesung",
          "Wang Fei Fei",
          "Woo Sung-hyun",
          "Xiumin",
          "Yang Hyun-suk",
          "Yang Yo-seob",
          "Yeon Woo",
          "Yesung",
          "Yim Jae-beom",
          "Yoo Ara",
          "Yoo Chae-yeong",
          "Yoo Seung-jun",
          "Yoo Young-jae",
          "Yoon Eun-hye",
          "Yoon Mi-rae",
          "Yong Jun-hyung",
          "Yoochun",
          "You Hee-yeol",
          "Younha",
          "Yubin",
          "Yoo Seung-ho",
          "Yunho",
          "Yoon Doo-joon",
          "Yeeun",
          "Yangpa",
          "Zelo",
          "Zhou Mi",
          "Zia",
          "Zion.T"
        ]
      },
      "lebowski": {
        "actors": [
          "Jeff Bridges",
          "John Goodman",
          "Julianne Moore",
          "Steve Buscemi",
          "David Huddleston",
          "Philip Seymour Hoffman",
          "Tara Reid",
          "Flea",
          "Peter Stormare",
          "John Turturro",
          "Ben Gazzara"
        ],
        "characters": [
          "The Dude",
          "Walter Sobchak",
          "Maude Lebowski",
          "Donny",
          "The Big Lebowski",
          "Brandt",
          "Bunny Lebowski",
          "Karl Hungus",
          "Jesus Quintana",
          "Jackie Treehorn"
        ],
        "quotes": [
          "He's a good man...and thorough.",
          "Hey, I know that guy. He's a nihilist. Karl Hungus.",
          "Mr. Treehorn treats objects like women, man.",
          "Is this your homework, Larry?",
          "Yeah, well, that's just, like, your opinion, man.",
          "Mark it zero!",
          "So then you have no frame of reference here Donny. You're like a child who wanders into the middle of a movie.",
          "You want a toe? I can get you a toe, believe me. There are ways, Dude. You don't wanna know about it, believe me.",
          "Hell, I can get you a toe by 3 o'clock this afternoon...with nail polish.",
          "Calmer than you are.",
          "I'm perfectly calm, Dude.",
          "You are entering a world of pain.",
          "This aggression will not stand, man.",
          "Obviously, you're not a golfer",
          "Mind if I do a J?",
          "This is not 'Nam. This is bowling. There are rules.",
          "Look, let me explain something to you. I'm not Mr. Lebowski. You're Mr. Lebowski. I'm the Dude.",
          "I'm the dude, so that's what you call me. That or, uh His Dudeness, or uh Duder, or El Duderino, if you're not into the whole brevity thing.",
          "This is a very complicated case Maude. You know, a lotta ins, a lotta outs, lotta what-have-yous.",
          "Eight-year-olds, Dude.",
          "Careful man, there's a beverage here!",
          "The Dude abides.",
          "That rug really tied the room together.",
          "I mean, say what you want about the tenets of National Socialism, Dude, at least it's an ethos.",
          "Forget it, Donny, you're out of your element!",
          "I don't like your jerk-off name. I don't like your jerk-off face. And I don't like you...jerk-off.",
          "Three thousand years of beautiful tradition, from Moses to Sandy Koufax.",
          "I am the walrus",
          "V.I. Lenin. Vladimir! Ilyich! Ulyanov!",
          "Oh, the usual. I bowl. Drive around. The occasional acid flashback.",
          "So what are you saying? When you get divorced you turn in your library card? You get a new license? You stop being Jewish?",
          "You know, Dude, I myself dabbled in pacifism once. Not in 'Nam of course.",
          "Stay away from my special lady friend, man.",
          "I don't roll on Shabbos!"
        ]
      },
      "locations": {
        "australia": {
          "animals": [
            "Koala",
            "Humpback Whale",
            "Australian Fur Seal",
            "Wallaby",
            "Platypus",
            "Kangaroo",
            "Wombat",
            "Sugar Glider",
            "Flying Fox",
            "Tasmanian Devil",
            "Quokka",
            "Dugong",
            "Luaner",
            "Echidna",
            "Magpie",
            "Cockatoo",
            "Tawny Frogmouth",
            "Galah",
            "Lorikeet",
            "Pelican",
            "Cassowary",
            "Kookaburra",
            "Emu",
            "Lyrebird",
            "Barramundi",
            "Grouper",
            "Murray Cod",
            "Green Tree Frog",
            "Cane Toad",
            "Redback Spider",
            "Funnel Web Spider",
            "Blue Ringed Octopus",
            "Fresh Water Crocodile",
            "Skink",
            "Thorny Devil",
            "King Brown Snake",
            "Carpet Python",
            "Tiger Snake",
            "Red Bellied Black Snake",
            "Blue Tongue Lizard",
            "Frilled Neck Lizard",
            "Saltwater Crocodile",
            "Eastern Brown Snake"
          ],
          "locations": [
            "Brisbane",
            "Sydney",
            "Melbourne",
            "Perth",
            "Adelaide",
            "Gold Coast",
            "Newcastle",
            "Canberra",
            "Central Coast",
            "Sunshine Coast",
            "Wollongong",
            "Geelong",
            "Hobart",
            "Townsville",
            "Cairns",
            "Toowoomba",
            "Darwin",
            "Ballarat",
            "Bendigo",
            "Albury",
            "Launceston",
            "Mackay",
            "Rockhampton",
            "Bunbury",
            "Coffs Harbour",
            "Bundaberg",
            "Melton",
            "Wagga Wagga",
            "Hervey Bay",
            "Mildura – Wentworth",
            "Shepparton – Mooroopna",
            "Port Macquarie",
            "Gladstone – Tannum Sands",
            "Tamworth",
            "Traralgon – Morwell",
            "Orange",
            "Bowral – Mittagong",
            "Busselton",
            "Geraldton",
            "Dubbo",
            "Nowra – Bomaderry",
            "Warragul – Drouin",
            "Bathurst",
            "Warrnambool",
            "Albany",
            "Kalgoorlie",
            "Devonport",
            "Mount Gambier",
            "Lismore",
            "Nelson Bay"
          ],
          "states": [
            "New South Wales",
            "Queensland",
            "Western Australia",
            "Northern Territory",
            "South Australia",
            "Australian Capital Territory",
            "Victoria",
            "Tasmania"
          ]
        }
      },
      "lorem": {
        "multibyte": [
          [
            240,
            159,
            152,
            128
          ],
          [
            240,
            159,
            152,
            161
          ],
          [
            226,
            157,
            164
          ]
        ],
        "punctuation": {
          "period": ".",
          "question_mark": "?",
          "space": " "
        },
        "supplemental": [
          "abbas",
          "abduco",
          "abeo",
          "abscido",
          "absconditus",
          "absens",
          "absorbeo",
          "absque",
          "abstergo",
          "absum",
          "abundans",
          "abutor",
          "accedo",
          "accendo",
          "acceptus",
          "accipio",
          "accommodo",
          "accusator",
          "acer",
          "acerbitas",
          "acervus",
          "acidus",
          "acies",
          "acquiro",
          "acsi",
          "adamo",
          "adaugeo",
          "addo",
          "adduco",
          "ademptio",
          "adeo",
          "adeptio",
          "adfectus",
          "adfero",
          "adficio",
          "adflicto",
          "adhaero",
          "adhuc",
          "adicio",
          "adimpleo",
          "adinventitias",
          "adipiscor",
          "adiuvo",
          "administratio",
          "admiratio",
          "admitto",
          "admoneo",
          "admoveo",
          "adnuo",
          "adopto",
          "adsidue",
          "adstringo",
          "adsuesco",
          "adsum",
          "adulatio",
          "adulescens",
          "adultus",
          "aduro",
          "advenio",
          "adversus",
          "advoco",
          "aedificium",
          "aeger",
          "aegre",
          "aegrotatio",
          "aegrus",
          "aeneus",
          "aequitas",
          "aequus",
          "aer",
          "aestas",
          "aestivus",
          "aestus",
          "aetas",
          "aeternus",
          "ager",
          "aggero",
          "aggredior",
          "agnitio",
          "agnosco",
          "ago",
          "ait",
          "aiunt",
          "alienus",
          "alii",
          "alioqui",
          "aliqua",
          "alius",
          "allatus",
          "alo",
          "alter",
          "altus",
          "alveus",
          "amaritudo",
          "ambitus",
          "ambulo",
          "amicitia",
          "amiculum",
          "amissio",
          "amita",
          "amitto",
          "amo",
          "amor",
          "amoveo",
          "amplexus",
          "amplitudo",
          "amplus",
          "ancilla",
          "angelus",
          "angulus",
          "angustus",
          "animadverto",
          "animi",
          "animus",
          "annus",
          "anser",
          "ante",
          "antea",
          "antepono",
          "antiquus",
          "aperio",
          "aperte",
          "apostolus",
          "apparatus",
          "appello",
          "appono",
          "appositus",
          "approbo",
          "apto",
          "aptus",
          "apud",
          "aqua",
          "ara",
          "aranea",
          "arbitro",
          "arbor",
          "arbustum",
          "arca",
          "arceo",
          "arcesso",
          "arcus",
          "argentum",
          "argumentum",
          "arguo",
          "arma",
          "armarium",
          "armo",
          "aro",
          "ars",
          "articulus",
          "artificiose",
          "arto",
          "arx",
          "ascisco",
          "ascit",
          "asper",
          "aspicio",
          "asporto",
          "assentator",
          "astrum",
          "atavus",
          "ater",
          "atqui",
          "atrocitas",
          "atrox",
          "attero",
          "attollo",
          "attonbitus",
          "auctor",
          "auctus",
          "audacia",
          "audax",
          "audentia",
          "audeo",
          "audio",
          "auditor",
          "aufero",
          "aureus",
          "auris",
          "aurum",
          "aut",
          "autem",
          "autus",
          "auxilium",
          "avaritia",
          "avarus",
          "aveho",
          "averto",
          "avoco",
          "baiulus",
          "balbus",
          "barba",
          "bardus",
          "basium",
          "beatus",
          "bellicus",
          "bellum",
          "bene",
          "beneficium",
          "benevolentia",
          "benigne",
          "bestia",
          "bibo",
          "bis",
          "blandior",
          "bonus",
          "bos",
          "brevis",
          "cado",
          "caecus",
          "caelestis",
          "caelum",
          "calamitas",
          "calcar",
          "calco",
          "calculus",
          "callide",
          "campana",
          "candidus",
          "canis",
          "canonicus",
          "canto",
          "capillus",
          "capio",
          "capitulus",
          "capto",
          "caput",
          "carbo",
          "carcer",
          "careo",
          "caries",
          "cariosus",
          "caritas",
          "carmen",
          "carpo",
          "carus",
          "casso",
          "caste",
          "casus",
          "catena",
          "caterva",
          "cattus",
          "cauda",
          "causa",
          "caute",
          "caveo",
          "cavus",
          "cedo",
          "celebrer",
          "celer",
          "celo",
          "cena",
          "cenaculum",
          "ceno",
          "censura",
          "centum",
          "cerno",
          "cernuus",
          "certe",
          "certo",
          "certus",
          "cervus",
          "cetera",
          "charisma",
          "chirographum",
          "cibo",
          "cibus",
          "cicuta",
          "cilicium",
          "cimentarius",
          "ciminatio",
          "cinis",
          "circumvenio",
          "cito",
          "civis",
          "civitas",
          "clam",
          "clamo",
          "claro",
          "clarus",
          "claudeo",
          "claustrum",
          "clementia",
          "clibanus",
          "coadunatio",
          "coaegresco",
          "coepi",
          "coerceo",
          "cogito",
          "cognatus",
          "cognomen",
          "cogo",
          "cohaero",
          "cohibeo",
          "cohors",
          "colligo",
          "colloco",
          "collum",
          "colo",
          "color",
          "coma",
          "combibo",
          "comburo",
          "comedo",
          "comes",
          "cometes",
          "comis",
          "comitatus",
          "commemoro",
          "comminor",
          "commodo",
          "communis",
          "comparo",
          "compello",
          "complectus",
          "compono",
          "comprehendo",
          "comptus",
          "conatus",
          "concedo",
          "concido",
          "conculco",
          "condico",
          "conduco",
          "confero",
          "confido",
          "conforto",
          "confugo",
          "congregatio",
          "conicio",
          "coniecto",
          "conitor",
          "coniuratio",
          "conor",
          "conqueror",
          "conscendo",
          "conservo",
          "considero",
          "conspergo",
          "constans",
          "consuasor",
          "contabesco",
          "contego",
          "contigo",
          "contra",
          "conturbo",
          "conventus",
          "convoco",
          "copia",
          "copiose",
          "cornu",
          "corona",
          "corpus",
          "correptius",
          "corrigo",
          "corroboro",
          "corrumpo",
          "coruscus",
          "cotidie",
          "crapula",
          "cras",
          "crastinus",
          "creator",
          "creber",
          "crebro",
          "credo",
          "creo",
          "creptio",
          "crepusculum",
          "cresco",
          "creta",
          "cribro",
          "crinis",
          "cruciamentum",
          "crudelis",
          "cruentus",
          "crur",
          "crustulum",
          "crux",
          "cubicularis",
          "cubitum",
          "cubo",
          "cui",
          "cuius",
          "culpa",
          "culpo",
          "cultellus",
          "cultura",
          "cum",
          "cunabula",
          "cunae",
          "cunctatio",
          "cupiditas",
          "cupio",
          "cuppedia",
          "cupressus",
          "cur",
          "cura",
          "curatio",
          "curia",
          "curiositas",
          "curis",
          "curo",
          "curriculum",
          "currus",
          "cursim",
          "curso",
          "cursus",
          "curto",
          "curtus",
          "curvo",
          "curvus",
          "custodia",
          "damnatio",
          "damno",
          "dapifer",
          "debeo",
          "debilito",
          "decens",
          "decerno",
          "decet",
          "decimus",
          "decipio",
          "decor",
          "decretum",
          "decumbo",
          "dedecor",
          "dedico",
          "deduco",
          "defaeco",
          "defendo",
          "defero",
          "defessus",
          "defetiscor",
          "deficio",
          "defigo",
          "defleo",
          "defluo",
          "defungo",
          "degenero",
          "degero",
          "degusto",
          "deinde",
          "delectatio",
          "delego",
          "deleo",
          "delibero",
          "delicate",
          "delinquo",
          "deludo",
          "demens",
          "demergo",
          "demitto",
          "demo",
          "demonstro",
          "demoror",
          "demulceo",
          "demum",
          "denego",
          "denique",
          "dens",
          "denuncio",
          "denuo",
          "deorsum",
          "depereo",
          "depono",
          "depopulo",
          "deporto",
          "depraedor",
          "deprecator",
          "deprimo",
          "depromo",
          "depulso",
          "deputo",
          "derelinquo",
          "derideo",
          "deripio",
          "desidero",
          "desino",
          "desipio",
          "desolo",
          "desparatus",
          "despecto",
          "despirmatio",
          "infit",
          "inflammatio",
          "paens",
          "patior",
          "patria",
          "patrocinor",
          "patruus",
          "pauci",
          "paulatim",
          "pauper",
          "pax",
          "peccatus",
          "pecco",
          "pecto",
          "pectus",
          "pecunia",
          "pecus",
          "peior",
          "pel",
          "ocer",
          "socius",
          "sodalitas",
          "sol",
          "soleo",
          "solio",
          "solitudo",
          "solium",
          "sollers",
          "sollicito",
          "solum",
          "solus",
          "solutio",
          "solvo",
          "somniculosus",
          "somnus",
          "sonitus",
          "sono",
          "sophismata",
          "sopor",
          "sordeo",
          "sortitus",
          "spargo",
          "speciosus",
          "spectaculum",
          "speculum",
          "sperno",
          "spero",
          "spes",
          "spiculum",
          "spiritus",
          "spoliatio",
          "sponte",
          "stabilis",
          "statim",
          "statua",
          "stella",
          "stillicidium",
          "stipes",
          "stips",
          "sto",
          "strenuus",
          "strues",
          "studio",
          "stultus",
          "suadeo",
          "suasoria",
          "sub",
          "subito",
          "subiungo",
          "sublime",
          "subnecto",
          "subseco",
          "substantia",
          "subvenio",
          "succedo",
          "succurro",
          "sufficio",
          "suffoco",
          "suffragium",
          "suggero",
          "sui",
          "sulum",
          "sum",
          "summa",
          "summisse",
          "summopere",
          "sumo",
          "sumptus",
          "supellex",
          "super",
          "suppellex",
          "supplanto",
          "suppono",
          "supra",
          "surculus",
          "surgo",
          "sursum",
          "suscipio",
          "suspendo",
          "sustineo",
          "suus",
          "synagoga",
          "tabella",
          "tabernus",
          "tabesco",
          "tabgo",
          "tabula",
          "taceo",
          "tactus",
          "taedium",
          "talio",
          "talis",
          "talus",
          "tam",
          "tamdiu",
          "tamen",
          "tametsi",
          "tamisium",
          "tamquam",
          "tandem",
          "tantillus",
          "tantum",
          "tardus",
          "tego",
          "temeritas",
          "temperantia",
          "templum",
          "temptatio",
          "tempus",
          "tenax",
          "tendo",
          "teneo",
          "tener",
          "tenuis",
          "tenus",
          "tepesco",
          "tepidus",
          "ter",
          "terebro",
          "teres",
          "terga",
          "tergeo",
          "tergiversatio",
          "tergo",
          "tergum",
          "termes",
          "terminatio",
          "tero",
          "terra",
          "terreo",
          "territo",
          "terror",
          "tersus",
          "tertius",
          "testimonium",
          "texo",
          "textilis",
          "textor",
          "textus",
          "thalassinus",
          "theatrum",
          "theca",
          "thema",
          "theologus",
          "thermae",
          "thesaurus",
          "thesis",
          "thorax",
          "thymbra",
          "thymum",
          "tibi",
          "timidus",
          "timor",
          "titulus",
          "tolero",
          "tollo",
          "tondeo",
          "tonsor",
          "torqueo",
          "torrens",
          "tot",
          "totidem",
          "toties",
          "totus",
          "tracto",
          "trado",
          "traho",
          "trans",
          "tredecim",
          "tremo",
          "trepide",
          "tres",
          "tribuo",
          "tricesimus",
          "triduana",
          "triginta",
          "tripudio",
          "tristis",
          "triumphus",
          "trucido",
          "truculenter",
          "tubineus",
          "tui",
          "tum",
          "tumultus",
          "tunc",
          "turba",
          "turbo",
          "turpe",
          "turpis",
          "tutamen",
          "tutis",
          "tyrannus",
          "uberrime",
          "ubi",
          "ulciscor",
          "ullus",
          "ulterius",
          "ultio",
          "ultra",
          "umbra",
          "umerus",
          "umquam",
          "una",
          "unde",
          "undique",
          "universe",
          "unus",
          "urbanus",
          "urbs",
          "uredo",
          "usitas",
          "usque",
          "ustilo",
          "ustulo",
          "usus",
          "uter",
          "uterque",
          "utilis",
          "utique",
          "utor",
          "utpote",
          "utrimque",
          "utroque",
          "utrum",
          "uxor",
          "vaco",
          "vacuus",
          "vado",
          "vae",
          "valde",
          "valens",
          "valeo",
          "valetudo",
          "validus",
          "vallum",
          "vapulus",
          "varietas",
          "varius",
          "vehemens",
          "vel",
          "velociter",
          "velum",
          "velut",
          "venia",
          "venio",
          "ventito",
          "ventosus",
          "ventus",
          "venustas",
          "ver",
          "verbera",
          "verbum",
          "vere",
          "verecundia",
          "vereor",
          "vergo",
          "veritas",
          "vero",
          "versus",
          "verto",
          "verumtamen",
          "verus",
          "vesco",
          "vesica",
          "vesper",
          "vespillo",
          "vester",
          "vestigium",
          "vestrum",
          "vetus",
          "via",
          "vicinus",
          "vicissitudo",
          "victoria",
          "victus",
          "videlicet",
          "video",
          "viduata",
          "viduo",
          "vigilo",
          "vigor",
          "vilicus",
          "vilis",
          "vilitas",
          "villa",
          "vinco",
          "vinculum",
          "vindico",
          "vinitor",
          "vinum",
          "vir",
          "virga",
          "virgo",
          "viridis",
          "viriliter",
          "virtus",
          "vis",
          "viscus",
          "vita",
          "vitiosus",
          "vitium",
          "vito",
          "vivo",
          "vix",
          "vobis",
          "vociferor",
          "voco",
          "volaticus",
          "volo",
          "volubilis",
          "voluntarius",
          "volup",
          "volutabrum",
          "volva",
          "vomer",
          "vomica",
          "vomito",
          "vorago",
          "vorax",
          "voro",
          "vos",
          "votum",
          "voveo",
          "vox",
          "vulariter",
          "vulgaris",
          "vulgivagus",
          "vulgo",
          "vulgus",
          "vulnero",
          "vulnus",
          "vulpes",
          "vulticulus",
          "vultuosus",
          "xiphias"
        ],
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "lovecraft": {
        "deity": [
          "Azathoth",
          "Cthulhu",
          "Dagon",
          "Hastur",
          "Nyarlathotep",
          "Shub-Niggurath",
          "Tsathoggua",
          "Yog-Sothoth"
        ],
        "fhtagn": [
          "Ph'nglui mglw'nafh Cthulhu R'lyeh wgah'nagl fhtagn"
        ],
        "location": [
          "Arkham",
          "Dunwich",
          "Innsmouth",
          "Kadath",
          "Kingsport",
          "Leng",
          "Miskatonic",
          "R’lyeh",
          "Yuggoth",
          "Irem"
        ],
        "tome": [
          "Necronomicon",
          "Pnakotic Manuscripts",
          "De Vermis Mysteriis",
          "Book of Eibon",
          "Eltdown Shards"
        ],
        "words": [
          "abnormal",
          "accursed",
          "amorphous",
          "antediluvian",
          "antiquarian",
          "blasphemous",
          "cat",
          "charnel",
          "comprehension",
          "cyclopean",
          "dank",
          "decadent",
          "daemoniac",
          "effulgence",
          "eldritch",
          "fainted",
          "foetid",
          "fungus",
          "furtive",
          "gambrel",
          "gibbous",
          "gibbering",
          "hideous",
          "immemorial",
          "indescribable",
          "iridescence",
          "loathsome",
          "lurk",
          "madness",
          "manuscript",
          "mortal",
          "nameless",
          "noisome",
          "non-euclidean",
          "shunned",
          "singular",
          "spectral",
          "squamous",
          "stench",
          "stygian",
          "swarthy",
          "tenebrous",
          "tentacles",
          "ululate",
          "unmentionable",
          "unnamable",
          "unutterable"
        ]
      },
      "markdown": {
        "emphasis": [
          "_",
          "~",
          "*",
          "**"
        ],
        "headers": [
          "#",
          "##",
          "###",
          "####",
          "#####",
          "######"
        ]
      },
      "marketing": {
        "buzzwords": [
          "etc. etc.",
          "put a pin in it",
          "t-shirt sizes",
          "heavy lifting",
          "circle back",
          "two-way street",
          "data points",
          "out of the box",
          "get value out of the conversation",
          "penetrate the market",
          "plug and chug",
          "deep dive",
          "SWAG",
          "bucketize it",
          "sales funnel",
          "market share",
          "impact map",
          "growth unit",
          "tee it up",
          "make it actionable",
          "put a bow on it",
          "give you some time back",
          "bandwidth-constrained",
          "had to 'punt' on that",
          "home stretch",
          "get a pulse on",
          "value add",
          "expansion play",
          "rubber meets the road",
          "sprint to the finish line",
          "button up the loose ends",
          "heads down",
          "learnings",
          "ideate",
          "customer journey",
          "buying cycle",
          "synergy",
          "snackable content",
          "thought leader",
          "thought leadership",
          "immersive experience",
          "value proposition",
          "gamification",
          "agile marketing",
          "infographic",
          "granular",
          "streamline",
          "swim lane",
          "best practice",
          "bleeding edge",
          "out of pocket",
          "let's take this offline",
          "branding"
        ]
      },
      "measurement": {
        "height": [
          "inch",
          "foot"
        ],
        "length": [
          "yard",
          "foot",
          "mile"
        ],
        "metric_height": [
          "centimeter",
          "meter"
        ],
        "metric_length": [
          "millimeter",
          "centimeter",
          "decimeter",
          "meter",
          "dekameter",
          "hectometer",
          "kilometer"
        ],
        "metric_volume": [
          "milliliter",
          "liter"
        ],
        "metric_weight": [
          "milligram",
          "centigram",
          "decigram",
          "gram",
          "dekagram",
          "hectogram",
          "kilogram",
          "metric ton"
        ],
        "volume": [
          "cup",
          "tablespoon",
          "teaspoon",
          "quart",
          "pint",
          "gallon",
          "fluid ounce"
        ],
        "weight": [
          "pound",
          "ounce",
          "ton"
        ]
      },
      "michael_scott": {
        "quotes": [
          "Would I rather be feared or loved? Easy. Both. I want people to be afraid of how much they love me.",
          "Dwight, you ignorant slut!",
          "If I had a gun with two bullets and I was in a room with Hitler, Bin Laden, and Toby, I would shoot Toby twice.",
          "You wanna hear a lie? ... I...think you're great. You're my best friend.",
          "Webster's Dictionary defines wedding as: The fusing of two metals with a hot torch.",
          "Sometimes I'll start a sentence and I don't even know where it's going. I just hope I find it along the way.",
          "There were these huge bins of clothes and everybody was rifling through them like crazy. And I grabbed one and it fit! So I don't think that this is totally just a woman's suit. At the very least it's bisexual.",
          "The worst thing about prison was the Dementors. They were flying all over the place and they were scary and they'd come down and they'd suck the soul out of your body and it hurt!",
          "I feel like all my kids grew up, and then they married each other. It's every parents' dream.",
          "You don't know me, you've just seen my penis.",
          "St. Patrick's Day is the closest thing the Irish have to Christmas.",
          "I am Beyoncé, always.",
          "And I knew exactly what to do. But in a much more real sense, I had no idea what to do.",
          "When the son of the deposed king of Nigeria emails you directly, asking for help, you help! His father ran the freaking country! Ok?",
          "I have cause. It is beCAUSE I hate him.",
          "I am running away from my responsibilities. And it feels good.",
          "Society teaches us that having feelings and crying is bad and wrong. Well, that's baloney, because grief isn't wrong. There's such a thing as good grief. Just ask Charlie Brown.",
          "Saw Inception. Or at least I dreamt I did.",
          "I'm an early bird and I'm a night owl. So I'm wise and I have worms.",
          "Number 8. Learn how to take off a woman's bra: You just twist your hand until something breaks.",
          "I love my employees even though I hit one of you with my car.",
          "You know what they say. 'Fool me once, strike one, but fool me twice...strike three.",
          "I am downloading some NP# music.",
          "I am dead inside.",
          "WHERE ARE THE TURTLES?!",
          "Welcome back, Jerky Jerk-Face.",
          "Should have burned this place down when I had the chance.",
          "Well, just tell him to call me as asap as possible.",
          "Well, happy birthday, Jesus. Sorry your party's so lame.",
          "Do you think that doing alcohol is cool?",
          "I love inside jokes. Love to be a part of one someday.",
          "That's what she said.",
          "No, I'm not going to tell them about the downsizing. If a patient has cancer, you don't tell them.",
          "There is no such thing as an appropriate joke, that's why it's a joke.",
          "You may look around and see two groups here: white collar, blue collar. But I don't see it that way, and you know why not? Because I am collar-blind.",
          "I would not miss it for the world. But if something else came up I would definitely not go.",
          "I don't come up with this stuff, I just forward it along. You wouldn't arrest the guy who was just passing drugs from one guy to another.",
          "Make friends first, make sales second, make love third. In no particular order.",
          "It's a pimple, Phyllis. Avril Lavigne gets them all the time and she rocks harder than anyone alive.",
          "Wikipedia is the best thing ever. Anyone in the world can write anything they want about any subject. So you know you are getting the best possible information."
        ]
      },
      "military": {
        "air_force_rank": [
          "Airman Basic",
          "Airman First Class",
          "Senior Airman",
          "Staff Sergeant",
          "Technical Sergeant",
          "Master Sergeant",
          "Senior Master Sergeant",
          "Chief Master Sergeant",
          "Command Chief Master Sergeant",
          "Chief Master Sergeant of the Air Force",
          "Second Lieutenant",
          "First Lieutenant",
          "Captain",
          "Major",
          "Lieutenant Colonel",
          "Colonel",
          "Brigadier General",
          "Major General",
          "Lieutenant General",
          "General",
          "General of the Air Force"
        ],
        "army_rank": [
          "Private",
          "Private First Class",
          "Specialist",
          "Corporal",
          "Sergeant",
          "Staff Sergeant",
          "Sergeant First Class",
          "Master Sergeant",
          "First Sergeant",
          "Sergeant Major",
          "Command Sergeant Major",
          "Sergeant Major of the Army",
          "Second Lieutenant",
          "First Lieutenant",
          "Captain",
          "Major",
          "Lieutenant Colonel",
          "Colonel",
          "Brigadier General",
          "Major General",
          "Lieutenant General",
          "General",
          "General of the Army",
          "General of the Armies"
        ],
        "coast_guard_rank": [
          "Seaman Recruit",
          "Seaman Apprentice",
          "Seaman",
          "Petty Officer Third Class",
          "Petty Officer Second Class",
          "Petty Officer First Class",
          "Chief Petty Officer",
          "Senior Chief Petty Officer",
          "Master Chief Petty Officer",
          "Command Master Chief Petty Officer",
          "Area Command Master Chief Petty Officer",
          "Coast Guard Reserve Force Master Chief Petty Officer",
          "Master Chief Petty Officer of the Coast Guard",
          "Ensign",
          "Lieutenant",
          "Lieutenant Commander",
          "Commander",
          "Captain",
          "Rear Admiral",
          "Vice Admiral",
          "Admiral",
          "Fleet Admiral",
          "Admiral of the Navy"
        ],
        "dod_paygrade": [
          "E-1",
          "E-2",
          "E-3",
          "E-4",
          "E-5",
          "E-6",
          "E-7",
          "E-8",
          "E-9",
          "O-1",
          "O-1E",
          "O-2",
          "O-2E",
          "O-3",
          "O-3E",
          "O-4",
          "O-5",
          "O-6",
          "O-7",
          "O-8",
          "O-9",
          "O-10",
          "W-1",
          "W-2",
          "W-3",
          "W-4",
          "W-5",
          "Special"
        ],
        "marines_rank": [
          "Private",
          "Private First Class",
          "Lance Corporal",
          "Corporal",
          "Sergeant",
          "Staff Sergeant",
          "Gunnery Sergeant",
          "Master Sergeant",
          "First Sergeant",
          "Master Gunnery Sergeant",
          "Sergeant Major",
          "Sergeant Major of the Marine Corps",
          "Second Lieutenant",
          "First Lieutenant",
          "Captain",
          "Major",
          "Lieutenant Colonel",
          "Colonel",
          "Brigadier General",
          "Major General",
          "Lieutenant General",
          "General"
        ],
        "navy_rank": [
          "Seaman Recruit",
          "Fireman Recruit",
          "Airman Recruit",
          "Constructionman Recruit",
          "Seaman Apprentice",
          "Fireman Apprentice",
          "Airman Apprentice",
          "Constructionman Apprentice",
          "Seaman",
          "Fireman",
          "Airman",
          "Constructionman",
          "Petty Officer Third Class",
          "Petty Officer Second Class",
          "Petty Officer First Class",
          "Chief Petty Officer",
          "Senior Chief Petty Officer",
          "Command Senior Chief Petty Officer",
          "Master Chief Petty Officer",
          "Command Master Chief Petty Officer",
          "Fleet Master Chief Petty Officer",
          "Force Master Chief Petty Officer",
          "Master Chief Petty Officer of the Navy",
          "Ensign",
          "Lieutenant",
          "Lieutenant Commander",
          "Commander",
          "Captain",
          "Rear Admiral",
          "Vice Admiral",
          "Admiral",
          "Fleet Admiral",
          "Admiral of the Navy"
        ],
        "space_force_rank": [
          "Airman Basic",
          "Airman First Class",
          "Senior Airman",
          "Staff Sergeant",
          "Technical Sergeant",
          "Master Sergeant",
          "Senior Master Sergeant",
          "Chief Master Sergeant",
          "Command Chief Master Sergeant",
          "Senior Enlisted Advisor of the Space Force",
          "Senior Enlisted Advisor to the Chairman",
          "Second Lieutenant",
          "First Lieutenant",
          "Captain",
          "Major",
          "Lieutenant Colonel",
          "Colonel",
          "Brigadier General",
          "Major General",
          "Lieutenant General",
          "General"
        ]
      },
      "mountain": {
        "name": [
          "Abi Gamin",
          "Annapurna Dakshin",
          "Annapurna I",
          "Annapurna II",
          "Annapurna III",
          "Apsarasas Kangri",
          "Baintha Brakk",
          "Baltistan Peak",
          "Baltoro Kangri",
          "Batura Sar",
          "Broad Peak",
          "Chamlang",
          "Changtse",
          "Cho Oyu",
          "Chogolisa",
          "Chomo Lonzo",
          "Chongtar",
          "Churen Himal",
          "Crestone Peak",
          "Denali",
          "Dhaulagiri I",
          "Dhaulagiri II",
          "Dhaulagiri IV",
          "Dhaulagiri V",
          "Dhaulagiri VI",
          "Diran",
          "Distaghil Sar",
          "Gangapurna",
          "Gangkhar Puensum",
          "Gasherbrum I",
          "Gasherbrum II",
          "Gasherbrum III",
          "Gasherbrum IV",
          "Ghent Kangri",
          "Gimmigela",
          "Gongga Shan",
          "Gurla Mandhata",
          "Gyachung Kang",
          "Gyala Peri",
          "Haramosh Peak",
          "Himalchuli",
          "Ismoil Somoni Peak",
          "Istor-o-Nal",
          "Jengish Chokusu",
          "Pk Pobeda",
          "Jomolhari",
          "Jongsong Peak",
          "K12",
          "K2",
          "Kabru N",
          "Kamet",
          "Kangchenjunga",
          "Kangpenqing",
          "Kangphu Kang",
          "Kanjut Sar",
          "Karjiang",
          "Khartaphu",
          "Khunyang Chhish",
          "Kirat Chuli",
          "Kongur Tagh",
          "Kongur Tiube",
          "Kula Kangri",
          "Kumbhakarna",
          "Labuche Kang",
          "Labuche Kang III",
          "Langtang Lirung",
          "Langtang Ri",
          "Lhotse",
          "Lupghar Sar",
          "Makalu",
          "Malangutti Sar",
          "Malubiting",
          "Mamostong Kangri",
          "Mana Peak",
          "Manaslu",
          "Masherbrum",
          "Mauna Kea",
          "Molamenqing",
          "Momhil Sar",
          "Mount Everest",
          "Mount Shasta",
          "Mount Whitney",
          "Mukut Parbat",
          "Muztagh Ata",
          "Muztagh Tower",
          "Namcha Barwa",
          "Nanda Devi",
          "Nanga Parbat",
          "Nangpai Gosum",
          "Ngadi Chuli",
          "Noijin Kangsang",
          "Noshaq",
          "Nuptse",
          "Passu Sar",
          "Porong Ri",
          "Pumari Chhish",
          "Putha Hiunchuli",
          "Rakaposhi",
          "Rimo I",
          "Rimo III",
          "Saltoro Kangri",
          "Saraghrar",
          "Saser Kangri I",
          "Saser Kangri II E",
          "Saser Kangri III",
          "Sherpi Kangri",
          "Shishapangma",
          "Shispare",
          "Sia Kangri",
          "Siguang Ri",
          "Singhi Kangri",
          "Skil Brum",
          "Skyang Kangri",
          "Sunanda Devi",
          "Teram Kangri I",
          "Teram Kangri III",
          "The Crown",
          "Tirich Mir",
          "Tongshanjiabu",
          "Trivor",
          "Ultar",
          "Ganesh I",
          "Yukshin Gardan Sar",
          "Yutmaru Sar"
        ],
        "range": [
          "Annapurna Himalaya",
          "Appalachian Mountains",
          "Assam Himalaya",
          "Baiku Himalaya",
          "Baltoro Karakoram",
          "Batura Karakoram",
          "Cascade",
          "Daxue Shan",
          "Dhaulagiri Himalaya",
          "Ganesh Himalaya",
          "Great Smoky Mountains",
          "Hindu Kush",
          "Hispar Karakoram",
          "Jomolhari Himalaya",
          "Jugal Himalaya",
          "Kangchenjunga Himalaya",
          "Kongur Shan",
          "Kula Kangri Himalaya",
          "Labuche Himalaya",
          "Langtang Himalaya",
          "Lunana Himalaya",
          "Mahalangur Himalaya",
          "Manaslu Himalaya",
          "Masherbrum Karakoram",
          "Muztagata",
          "Nagarze Himalaya",
          "Nalakankar Himalaya",
          "Nanga Parbat Himalaya",
          "Pamir",
          "Panmah Karakoram",
          "Rakaposhi-Haramosh Karakoram",
          "Rimo Karakoram",
          "Rocky Mountains",
          "Saltoro Karakoram",
          "Sangre de Cristo",
          "Sawtooth",
          "Saser Karakoram",
          "Siachen Karakoram",
          "Sierra Nevada",
          "Tian Shan",
          "Wrangell Mountains",
          "Yengisogat Karakoram"
        ]
      },
      "mountaineering": {
        "mountaineer": [
          "Junko Tabei",
          "Catherine Destivelle",
          "Sasha DiGiulian",
          "Priti Wright",
          "Caroline Gleich",
          "Conrad Anker",
          "Edmund Hillary",
          "George Mallory",
          "Steve House",
          "Fred Beckey"
        ]
      },
      "movie": {
        "quote": [
          "Frankly, my dear, I don’t give a damn.",
          "I'm going to make him an offer he can't refuse.",
          "Toto, I've got a feeling we're not in Kansas anymore.",
          "Here's looking at you, kid.",
          "Go ahead, make my day.",
          "All right, Mr. DeMille, I'm ready for my closeup.",
          "May the Force be with you.",
          "Fasten your seatbelts. It's going to be a bumpy night.",
          "You talking to me?",
          "What we've got here is failure to communicate.",
          "I love the smell of napalm in the morning.",
          "Greetings, programs!"
        ],
        "title": [
          "12 Angry Men",
          "12 Years a Slave",
          "2001: A Space Odyssey",
          "3 Idiots",
          "A Beautiful Mind",
          "A Clockwork Orange",
          "A Wednesday",
          "Alien",
          "All About Eve",
          "Amadeus",
          "American Beauty",
          "Apocalypse Now",
          "Back to the Future",
          "Batman Begins",
          "Beauty and the Beast",
          "Before Sunrise",
          "Bicycle Thieves",
          "Blade Runner",
          "Blade Runner 2049",
          "Braveheart",
          "Casablanca",
          "Casino",
          "Catch Me If You Can",
          "Chinatown",
          "Cidade de Deus",
          "Cinema Paradiso",
          "Citizen Kane",
          "City Lights",
          "City of God",
          "Cool Hand Luke",
          "Dead Poets Society",
          "Dial M for Murder",
          "Die Hard",
          "Django Unchained",
          "Dog Day Afternoon",
          "Donnie Darko",
          "Double Indemnity",
          "Dunkirk",
          "Eternal Sunshine of the Spotless Mind",
          "Fargo",
          "Fight Club",
          "Finding Nemo",
          "Forrest Gump",
          "Full Metal Jacket",
          "Gandhi",
          "Gladiator",
          "Gone Girl",
          "Gone with the Wind",
          "Good Will Hunting",
          "Goodfellas",
          "Gran Torino",
          "Grave of the Fireflies",
          "Groundhog Day",
          "Hacksaw Ridge",
          "Heat",
          "Hotel Rwanda",
          "How to Train Your Dragon",
          "In the Name of the Father",
          "Inception",
          "Indiana Jones and the Last Crusade",
          "Inglourious Basterds",
          "Inside Out",
          "Interstellar",
          "Into the Wild",
          "Intouchables",
          "It Happened One Night",
          "Jaws",
          "Judgment at Nuremberg",
          "Jurassic Park",
          "L.A. Confidential",
          "La La Land",
          "Lawrence of Arabia",
          "Life Is Beautiful",
          "Life of Brian",
          "Lock, Stock and Two Smoking Barrels",
          "Mad Max: Fury Road",
          "Mary and Max",
          "Memento",
          "Metropolis",
          "Million Dollar Baby",
          "Modern Times",
          "Monsters, Inc.",
          "Monty Python and the Holy Grail",
          "Mr. Smith Goes to Washington",
          "Network",
          "No Country for Old Men",
          "North by Northwest",
          "Nuovo Cinema Paradiso",
          "Oldboy",
          "Oldeuboi",
          "Once Upon a Time in America",
          "Once Upon a Time in the West",
          "Paper Moon",
          "Paris, Texas",
          "Paths of Glory",
          "Persona",
          "Platoon",
          "Princess Mononoke",
          "Prisoners",
          "Psycho",
          "Pulp Fiction",
          "Raging Bull",
          "Raiders of the Lost Ark",
          "Rocky",
          "Room",
          "Rush",
          "Saving Private Ryan",
          "Scarface",
          "Se7en",
          "Seven Samurai",
          "Sholay",
          "Shutter Island",
          "Snatch",
          "Some Like It Hot",
          "Spirited Away",
          "Spotlight",
          "Stalker",
          "Stand by Me",
          "Star Wars",
          "Star Wars: Episode I – The Phantom Menace",
          "Star Wars: Episode II – Attack of the Clones",
          "Star Wars: Episode III – Revenge of the Sith",
          "Star Wars: Episode IV – A New Hope",
          "Star Wars: Episode V - The Empire Strikes Back",
          "Star Wars: Episode VI - Return of the Jedi",
          "Star Wars: Episode VII - The Force Awakens",
          "Star Wars: Episode VIII – The Last Jedi",
          "Star Wars: Episode IX – The Rise of Skywalker",
          "Sunrise: A Song of Two Humans",
          "Sunset Blvd.",
          "Taxi Driver",
          "Terminator 2: Judgment Day",
          "The Apartment",
          "The Best Years of Our Lives",
          "The Big Lebowski",
          "The Bourne Ultimatum",
          "The Bridge on the River Kwai",
          "The Dark Knight",
          "The Dark Knight Rises",
          "The Deer Hunter",
          "The Departed",
          "The Elephant Man",
          "The General",
          "The Godfather",
          "The Godfather: Part II",
          "The Gold Rush",
          "The Good, the Bad and the Ugly",
          "The Grand Budapest Hotel",
          "The Grapes of Wrath",
          "The Great Dictator",
          "The Great Escape",
          "The Green Mile",
          "The Help",
          "The Intouchables",
          "The Kid",
          "The Lion King",
          "The Lives of Others",
          "The Lord of the Rings: The Fellowship of the Ring",
          "The Lord of the Rings: The Return of the King",
          "The Lord of the Rings: The Two Towers",
          "The Maltese Falcon",
          "The Matrix",
          "The Pianist",
          "The Prestige",
          "The Princess Bride",
          "The Shawshank Redemption",
          "The Shining",
          "The Silence of the Lambs",
          "The Sixth Sense",
          "The Sting",
          "The Terminator",
          "The Thing",
          "The Third Man",
          "The Treasure of the Sierra Madre",
          "The Truman Show",
          "The Usual Suspects",
          "The Wizard of Oz",
          "The Wolf of Wall Street",
          "There Will Be Blood",
          "To Kill a Mockingbird",
          "Touch of Evil",
          "Toy Story",
          "Toy Story 2",
          "Toy Story 3",
          "TRON",
          "Twelve Monkeys",
          "Unforgiven",
          "V for Vendetta",
          "Vertigo",
          "WALL·E",
          "Whiplash",
          "Witness for the Prosecution"
        ]
      },
      "music": {
        "albums": [
          "Thriller",
          "Back in Black",
          "The Dark Side of the Moon",
          "Bat Out of Hell",
          "The Bodyguard",
          "Their Greatest Hits (1971–1975)",
          "Saturday Night Fever",
          "Rumours",
          "Grease: The Original Soundtrack from the Motion Picture",
          "Led Zeppelin IV",
          "Bad",
          "Jagged Little Pill",
          "Come On Over",
          "Falling into You",
          "Sgt. Pepper's Lonely Hearts Club Band",
          "Hotel California",
          "Dirty Dancing",
          "21",
          "Let's Talk About Love",
          "1",
          "Gold: Greatest Hits",
          "Dangerous",
          "The Immaculate Collection",
          "Abbey Road",
          "Born in the U.S.A.",
          "Brothers in Arms",
          "Titanic: Music from the Motion Picture",
          "Metallica",
          "Nevermind",
          "The Wall",
          "Supernatural",
          "Appetite for Destruction",
          "Slippery When Wet",
          "Music Box",
          "The Eminem Show",
          "Hybrid Theory",
          "Come Away with Me",
          "Unplugged",
          "True Blue",
          "Legend: The Best of Bob Marley & The Wailers",
          "Tapestry",
          "No Jacket Required",
          "Greatest Hits",
          "Bridge over Troubled Water",
          "The Joshua Tree",
          "...Baby One More Time",
          "Backstreet's Back",
          "Backstreet Boys",
          "Millennium",
          "Spice",
          "Happy Nation",
          "The Sign",
          "Whitney Houston",
          "(What's the Story) Morning Glory?",
          "The Marshall Mathers LP",
          "Like a Virgin",
          "Cross Road",
          "25",
          "Boston",
          "Oops!... I Did It Again",
          "The Colour of My Love",
          "Hysteria",
          "Faith",
          "Dookie",
          "Can't Slow Down",
          "Daydream",
          "HIStory: Past, Present and Future, Book I",
          "Off the Wall",
          "The Woman in Me",
          "Breakfast in America",
          "Tracy Chapman",
          "Flashdance: Original Soundtrack from the Motion Picture",
          "Whitney",
          "Confessions",
          "X&Y",
          "High School Musical",
          "High School Musical 2",
          "Viva la Vida or Death and All His Friends",
          "I Dreamed a Dream",
          "Recovery",
          "Midnight Memories",
          "Frozen",
          "Lemonade",
          "Brand New Eyes",
          "All We Know Is Falling",
          "Riot!",
          "Songs About Jane",
          "Hands All Over"
        ],
        "bands": [
          "AC/DC",
          "Adam and the Ants",
          "Afrika Bambaataa",
          "Al Foster",
          "Alan Parsons",
          "Alex Chilton",
          "Amy Winehouse",
          "Annie Lennox",
          "Arctic Monkeys",
          "B.B. King",
          "Bauhaus",
          "Beck",
          "Billy Idol",
          "Björk",
          "Blinker The Star",
          "Blondie",
          "Blur",
          "Bob Dylan",
          "Bob Marley (and the Wailers)",
          "Brian Wilson",
          "Bruce Springsteen",
          "Buzzcocks",
          "Captain Beefheart",
          "Carlos Santana",
          "Cat Anderson",
          "Cat Stevens",
          "Catherine Wheel",
          "Chic",
          "Chris Isaak",
          "Chrissie Hynde",
          "Chuck Berry",
          "Cliff Richard (and the Shadows)",
          "Coldplay",
          "Cootie Williams",
          "Cortinas",
          "Cream",
          "David Bowie",
          "David Gilmour",
          "Deepest Blue",
          "Devo",
          "Dizzy Gillespie",
          "Dr Feelgood",
          "Duke Ellington",
          "Ed Sheeran",
          "Ella Fitzgerald",
          "Elton John",
          "Elvis Costello",
          "Elvis Presley",
          "Eric Clapton",
          "Fats Domino",
          "Flaming Lips",
          "Florence and the Machine",
          "Foo Fighters",
          "Frank Sinatra",
          "Frank Zappa",
          "Frightened Rabbit",
          "George Michael",
          "Grace Jones",
          "Green Day",
          "Guns N' Roses",
          "Herbie Hancock",
          "Horace Silver",
          "Hugh Masekela",
          "Ian Dury",
          "Iggy Pop",
          "James Brown",
          "Jeff Beck",
          "Jeff Buckley",
          "Jimi Hendrix",
          "John Coltrane",
          "John Lydon",
          "Johnny Borrell",
          "Johnny Cash",
          "Johnny Marr",
          "Joni Mitchell",
          "Joy Division",
          "K.D Lang",
          "Kasabian",
          "Kate Bush",
          "Keith Moon",
          "Keith Richards",
          "Kiss",
          "Led Zeppelin",
          "Lenny Kravitz",
          "Leonard Cohen",
          "Liam Gallagher",
          "Madness",
          "Madonna",
          "Manic Street Preachers",
          "Marc Bolan",
          "Marianne Faithfull",
          "Marilyn Manson",
          "Maroon 5",
          "Max Roach",
          "Michael Jackson",
          "Miles Davis",
          "Morrissey",
          "Muddy Waters",
          "Mumford and Sons",
          "Muse",
          "Neil Young",
          "New Order",
          "Nick Cave",
          "Nigel Kennedy",
          "Nina Simone",
          "Nirvana",
          "Noel Gallagher",
          "O.A.R.",
          "Oasis",
          "Offspring",
          "Ozzy Osbourne",
          "PJ Harvey",
          "Paramore",
          "Pat Metheny",
          "Patti Smith",
          "Paul Weller",
          "Pearl Jam",
          "Pete Townshend",
          "Phil Collins",
          "Phish",
          "Pink Floyd",
          "Primal Scream",
          "Prince",
          "Program The Dead",
          "Pulp",
          "Queen",
          "R.E.M.",
          "Radiohead",
          "Red Hot Chili Peppers",
          "Rick Wright",
          "Rod Stewart",
          "Rory Gallagher",
          "Roxy Music",
          "Roy Hargrove",
          "Rufus Wainwright",
          "Run-D.M.C.",
          "Ryan Adams",
          "Sex Pistols",
          "Simply Red",
          "Sinead O'connor",
          "Siouxsie and The Banshees",
          "Sonic Youth",
          "Squeeze",
          "Status Quo",
          "Stereophonics",
          "Stone Roses",
          "Syd Barrett",
          "The Beatles",
          "The Birthday Party",
          "The Clash",
          "The Cramps",
          "The Cranberries",
          "The Cure",
          "The Faces",
          "The Jam",
          "The Killers",
          "The Kinks",
          "The La's",
          "The Libertines",
          "The Mars Volta",
          "The Police",
          "The Pretenders",
          "The Ramones",
          "The Rolling Stones",
          "The Slits",
          "The Smiths",
          "The Specials",
          "The Undertones",
          "The Who",
          "The Yardbirds",
          "Thelonius Monk",
          "Thin Lizzy",
          "Thornley",
          "Tina Turner",
          "Tom Jones",
          "Tom Robinson",
          "Tom Waits",
          "U2",
          "Van Morrison",
          "Velvet Revolver",
          "White Stripes",
          "Yumi Matsutoya"
        ],
        "genres": [
          "Rock",
          "Pop",
          "Electronic",
          "Folk",
          "World",
          "Country",
          "Jazz",
          "Funk",
          "Soul",
          "Hip Hop",
          "Classical",
          "Latin",
          "Reggae",
          "Stage And Screen",
          "Blues",
          "Non Music",
          "Rap"
        ],
        "hiphop": {
          "artist": [
            "Drake",
            "Jay-Z",
            "Lil Wayne",
            "Travis Scott",
            "Ice Cube",
            "Wutang Clan",
            "Tribe Called Quest",
            "Nas",
            "Foxy Brown",
            "TI",
            "TPain",
            "Big Krit",
            "Joey BadA$$",
            "A$AP Rocky",
            "Tyler The Creator",
            "Frank Ocean",
            "50 Cent",
            "Snoop Dogg",
            "Wiz Khalifa",
            "Tupac",
            "The Notorious B.I.G",
            "Missy Elliot",
            "DMX",
            "Eminem",
            "Method Man",
            "Red Man",
            "Kanye West",
            "Gucci Mane",
            "Baby Keem",
            "Roddy Ricch",
            "Nipsey Hussle",
            "Queen Latifah",
            "Pusha T",
            "Chief Keef",
            "Lil Reese",
            "Lil Peep",
            "Lil Snupe",
            "Meek Mill",
            "Wale",
            "Busta Rhymes",
            "Ludacris",
            "Ashanti",
            "Shy Glizzy",
            "Fredo Santana",
            "Fat Joe",
            "Don Toliver",
            "Sheck Wes",
            "Bobby Smurda",
            "Dave East",
            "J Holiday",
            "Chris Brown",
            "Omarion",
            "Fabulous",
            "Jadakiss",
            "Nicki Minaj",
            "Meg The Stallion",
            "Saweetie",
            "Larry June",
            "Quavo",
            "Offset",
            "Takeoff",
            "Stormzy",
            "xxxTentacion",
            "Juice Wrld",
            "Juicy J",
            "P Diddy",
            "Young Thug",
            "Gunna",
            "Lil Tecca",
            "Da Baby",
            "Lil Baby",
            "Lil Uzi",
            "21 Savage",
            "2 Chainz",
            "Craig Mac",
            "Cardi B",
            "Chance The Rapper",
            "Mac Miller",
            "The Game",
            "Styles P",
            "Paul Wall",
            "Cam'ron",
            "Jeezy",
            "Dr. Dre",
            "Nate Dogg",
            "Kurupt",
            "Twista"
          ],
          "groups": [
            "Outcast",
            "Griselda",
            "Wu-Tang Clan",
            "YMCMB",
            "Maybach Music",
            "Bad Boyz",
            "Rock Nation",
            "Jack Boys",
            "OVO",
            "Tribe Call Quest",
            "Cypress Hill",
            "Digital Undeground",
            "Naughty By Nature",
            "EPMD",
            "Run D.M.C",
            "N.W.A",
            "Salt & Pepa",
            "TLC",
            "G Unit",
            "Bone Thugs & Harmony",
            "Destiny's Child",
            "Public Enemy",
            "Mobb Deep",
            "Eric B. & Rakim",
            "Fugees",
            "The Sugarhill Gang",
            "D12",
            "Three 6 Mafia",
            "Migos",
            "Clipse",
            "Odd Future",
            "2 Live Crew",
            "The Lox",
            "Dipset"
          ],
          "subgenres": [
            "Low Fi",
            "Grime",
            "Drill",
            "Alternative",
            "Country",
            "Undeground",
            "West Coast",
            "East Coast",
            "Conscious",
            "Christian",
            "Gangsta",
            "Old School",
            "Southern",
            "Mid West",
            "Trap",
            "Boom Bap",
            "Melodic"
          ]
        },
        "instruments": [
          "Electric Guitar",
          "Acoustic Guitar",
          "Flute",
          "Trumpet",
          "Clarinet",
          "Cello",
          "Harp",
          "Xylophone",
          "Harmonica",
          "Accordion",
          "Organ",
          "Piano",
          "Ukelele",
          "Saxophone",
          "Drums",
          "Violin",
          "Bass Guitar",
          "Oboe"
        ],
        "mambo_no_5": [
          "Angela",
          "Pamela",
          "Sandra",
          "Rita",
          "Monica",
          "Erica",
          "Tina",
          "Mary",
          "Jessica"
        ]
      },
      "name": {
        "female_first_name": [
          "Abbey",
          "Abbie",
          "Abby",
          "Abigail",
          "Ada",
          "Adah",
          "Adaline",
          "Addie",
          "Adela",
          "Adelaida",
          "Adelaide",
          "Adele",
          "Adelia",
          "Adelina",
          "Adeline",
          "Adell",
          "Adella",
          "Adelle",
          "Adena",
          "Adina",
          "Adria",
          "Adrian",
          "Adriana",
          "Adriane",
          "Adrianna",
          "Adrianne",
          "Adrien",
          "Adriene",
          "Adrienne",
          "Afton",
          "Agatha",
          "Agnes",
          "Agnus",
          "Agripina",
          "Agueda",
          "Agustina",
          "Ai",
          "Aida",
          "Aide",
          "Aiko",
          "Aileen",
          "Ailene",
          "Aimee",
          "Aisha",
          "Aja",
          "Akiko",
          "Akilah",
          "Alaina",
          "Alaine",
          "Alana",
          "Alane",
          "Alanna",
          "Alayna",
          "Alba",
          "Albert",
          "Alberta",
          "Albertha",
          "Albertina",
          "Albertine",
          "Albina",
          "Alda",
          "Alease",
          "Alecia",
          "Aleen",
          "Aleida",
          "Aleisha",
          "Alejandra",
          "Alejandrina",
          "Alena",
          "Alene",
          "Alesha",
          "Aleshia",
          "Alesia",
          "Alessandra",
          "Aleta",
          "Aletha",
          "Alethea",
          "Alethia",
          "Alex",
          "Alexa",
          "Alexander",
          "Alexandra",
          "Alexandria",
          "Alexia",
          "Alexis",
          "Alfreda",
          "Alfredia",
          "Ali",
          "Alia",
          "Alica",
          "Alice",
          "Alicia",
          "Alida",
          "Alina",
          "Aline",
          "Alisa",
          "Alise",
          "Alisha",
          "Alishia",
          "Alisia",
          "Alison",
          "Alissa",
          "Alita",
          "Alix",
          "Aliza",
          "Alla",
          "Alleen",
          "Allegra",
          "Allen",
          "Allena",
          "Allene",
          "Allie",
          "Alline",
          "Allison",
          "Allyn",
          "Allyson",
          "Alma",
          "Almeda",
          "Almeta",
          "Alona",
          "Alpha",
          "Alta",
          "Altagracia",
          "Altha",
          "Althea",
          "Alva",
          "Alvera",
          "Alverta",
          "Alvina",
          "Alyce",
          "Alycia",
          "Alysa",
          "Alyse",
          "Alysha",
          "Alysia",
          "Alyson",
          "Alyssa",
          "Amada",
          "Amal",
          "Amalia",
          "Amanda",
          "Amber",
          "Amberly",
          "Amee",
          "Amelia",
          "America",
          "Ami",
          "Amie",
          "Amiee",
          "Amina",
          "Amira",
          "Ammie",
          "Amparo",
          "Amy",
          "An",
          "Ana",
          "Anabel",
          "Analisa",
          "Anamaria",
          "Anastacia",
          "Anastasia",
          "Andera",
          "Andra",
          "Andre",
          "Andrea",
          "Andree",
          "Andrew",
          "Andria",
          "Anette",
          "Angel",
          "Angela",
          "Angele",
          "Angelena",
          "Angeles",
          "Angelia",
          "Angelic",
          "Angelica",
          "Angelika",
          "Angelina",
          "Angeline",
          "Angelique",
          "Angelita",
          "Angella",
          "Angelo",
          "Angelyn",
          "Angie",
          "Angila",
          "Angla",
          "Angle",
          "Anglea",
          "Anh",
          "Anika",
          "Anisa",
          "Anisha",
          "Anissa",
          "Anita",
          "Anitra",
          "Anja",
          "Anjanette",
          "Anjelica",
          "Ann",
          "Anna",
          "Annabel",
          "Annabell",
          "Annabelle",
          "Annalee",
          "Annalisa",
          "Annamae",
          "Annamaria",
          "Annamarie",
          "Anne",
          "Anneliese",
          "Annelle",
          "Annemarie",
          "Annett",
          "Annetta",
          "Annette",
          "Annice",
          "Annie",
          "Annika",
          "Annis",
          "Annita",
          "Annmarie",
          "Anthony",
          "Antionette",
          "Antoinette",
          "Antonetta",
          "Antonette",
          "Antonia",
          "Antonietta",
          "Antonina",
          "Antonio",
          "Anya",
          "Apolonia",
          "April",
          "Apryl",
          "Ara",
          "Araceli",
          "Aracelis",
          "Aracely",
          "Arcelia",
          "Ardath",
          "Ardelia",
          "Ardell",
          "Ardella",
          "Ardelle",
          "Ardis",
          "Ardith",
          "Aretha",
          "Argelia",
          "Argentina",
          "Ariana",
          "Ariane",
          "Arianna",
          "Arianne",
          "Arica",
          "Arie",
          "Ariel",
          "Arielle",
          "Arla",
          "Arlean",
          "Arleen",
          "Arlena",
          "Arlene",
          "Arletha",
          "Arletta",
          "Arlette",
          "Arlinda",
          "Arline",
          "Arlyne",
          "Armanda",
          "Armandina",
          "Armida",
          "Arminda",
          "Arnetta",
          "Arnette",
          "Arnita",
          "Arthur",
          "Artie",
          "Arvilla",
          "Asha",
          "Ashanti",
          "Ashely",
          "Ashlea",
          "Ashlee",
          "Ashleigh",
          "Ashley",
          "Ashli",
          "Ashlie",
          "Ashly",
          "Ashlyn",
          "Ashton",
          "Asia",
          "Asley",
          "Assunta",
          "Astrid",
          "Asuncion",
          "Athena",
          "Aubrey",
          "Audie",
          "Audra",
          "Audrea",
          "Audrey",
          "Audria",
          "Audrie",
          "Audry",
          "Augusta",
          "Augustina",
          "Augustine",
          "Aundrea",
          "Aura",
          "Aurea",
          "Aurelia",
          "Aurora",
          "Aurore",
          "Austin",
          "Autumn",
          "Ava",
          "Avelina",
          "Avery",
          "Avis",
          "Avril",
          "Awilda",
          "Ayako",
          "Ayana",
          "Ayanna",
          "Ayesha",
          "Azalee",
          "Azucena",
          "Azzie",
          "Babara",
          "Babette",
          "Bailey",
          "Bambi",
          "Bao",
          "Barabara",
          "Barb",
          "Barbar",
          "Barbara",
          "Barbera",
          "Barbie",
          "Barbra",
          "Bari",
          "Barrie",
          "Basilia",
          "Bea",
          "Beata",
          "Beatrice",
          "Beatris",
          "Beatriz",
          "Beaulah",
          "Bebe",
          "Becki",
          "Beckie",
          "Becky",
          "Bee",
          "Belen",
          "Belia",
          "Belinda",
          "Belkis",
          "Bell",
          "Bella",
          "Belle",
          "Belva",
          "Benita",
          "Bennie",
          "Berenice",
          "Berna",
          "Bernadette",
          "Bernadine",
          "Bernarda",
          "Bernardina",
          "Bernardine",
          "Berneice",
          "Bernetta",
          "Bernice",
          "Bernie",
          "Berniece",
          "Bernita",
          "Berry",
          "Berta",
          "Bertha",
          "Bertie",
          "Beryl",
          "Bess",
          "Bessie",
          "Beth",
          "Bethanie",
          "Bethann",
          "Bethany",
          "Bethel",
          "Betsey",
          "Betsy",
          "Bette",
          "Bettie",
          "Bettina",
          "Betty",
          "Bettyann",
          "Bettye",
          "Beula",
          "Beulah",
          "Bev",
          "Beverlee",
          "Beverley",
          "Beverly",
          "Bianca",
          "Bibi",
          "Billi",
          "Billie",
          "Billy",
          "Billye",
          "Birdie",
          "Birgit",
          "Blair",
          "Blake",
          "Blanca",
          "Blanch",
          "Blanche",
          "Blondell",
          "Blossom",
          "Blythe",
          "Bobbi",
          "Bobbie",
          "Bobby",
          "Bobbye",
          "Bobette",
          "Bok",
          "Bong",
          "Bonita",
          "Bonnie",
          "Bonny",
          "Branda",
          "Brande",
          "Brandee",
          "Brandi",
          "Brandie",
          "Brandon",
          "Brandy",
          "Breana",
          "Breann",
          "Breanna",
          "Breanne",
          "Bree",
          "Brenda",
          "Brenna",
          "Brett",
          "Brian",
          "Briana",
          "Brianna",
          "Brianne",
          "Bridget",
          "Bridgett",
          "Bridgette",
          "Brigette",
          "Brigid",
          "Brigida",
          "Brigitte",
          "Brinda",
          "Britany",
          "Britney",
          "Britni",
          "Britt",
          "Britta",
          "Brittaney",
          "Brittani",
          "Brittanie",
          "Brittany",
          "Britteny",
          "Brittney",
          "Brittni",
          "Brittny",
          "Bronwyn",
          "Brook",
          "Brooke",
          "Bruna",
          "Brunilda",
          "Bryanna",
          "Brynn",
          "Buena",
          "Buffy",
          "Bula",
          "Bulah",
          "Bunny",
          "Burma",
          "Caitlin",
          "Caitlyn",
          "Calandra",
          "Calista",
          "Callie",
          "Camelia",
          "Camellia",
          "Cameron",
          "Cami",
          "Camie",
          "Camila",
          "Camilla",
          "Camille",
          "Cammie",
          "Cammy",
          "Candace",
          "Candance",
          "Candelaria",
          "Candi",
          "Candice",
          "Candida",
          "Candie",
          "Candis",
          "Candra",
          "Candy",
          "Candyce",
          "Caprice",
          "Cara",
          "Caren",
          "Carey",
          "Cari",
          "Caridad",
          "Carie",
          "Carin",
          "Carina",
          "Carisa",
          "Carissa",
          "Carita",
          "Carl",
          "Carla",
          "Carlee",
          "Carleen",
          "Carlena",
          "Carlene",
          "Carletta",
          "Carley",
          "Carli",
          "Carlie",
          "Carline",
          "Carlita",
          "Carlos",
          "Carlota",
          "Carlotta",
          "Carly",
          "Carlyn",
          "Carma",
          "Carman",
          "Carmel",
          "Carmela",
          "Carmelia",
          "Carmelina",
          "Carmelita",
          "Carmella",
          "Carmen",
          "Carmina",
          "Carmon",
          "Carol",
          "Carola",
          "Carolann",
          "Carole",
          "Carolee",
          "Carolin",
          "Carolina",
          "Caroline",
          "Caroll",
          "Carolyn",
          "Carolyne",
          "Carolynn",
          "Caron",
          "Caroyln",
          "Carri",
          "Carrie",
          "Carrol",
          "Carroll",
          "Carry",
          "Cary",
          "Caryl",
          "Carylon",
          "Caryn",
          "Casandra",
          "Casey",
          "Casie",
          "Casimira",
          "Cassandra",
          "Cassaundra",
          "Cassey",
          "Cassi",
          "Cassidy",
          "Cassie",
          "Cassondra",
          "Cassy",
          "Catalina",
          "Catarina",
          "Caterina",
          "Catharine",
          "Catherin",
          "Catherina",
          "Catherine",
          "Cathern",
          "Catheryn",
          "Cathey",
          "Cathi",
          "Cathie",
          "Cathleen",
          "Cathrine",
          "Cathryn",
          "Cathy",
          "Catina",
          "Catrice",
          "Catrina",
          "Cayla",
          "Cecelia",
          "Cecil",
          "Cecila",
          "Cecile",
          "Cecilia",
          "Cecille",
          "Cecily",
          "Celena",
          "Celesta",
          "Celeste",
          "Celestina",
          "Celestine",
          "Celia",
          "Celina",
          "Celinda",
          "Celine",
          "Celsa",
          "Ceola",
          "Chae",
          "Chan",
          "Chana",
          "Chanda",
          "Chandra",
          "Chanel",
          "Chanell",
          "Chanelle",
          "Chang",
          "Chantal",
          "Chantay",
          "Chante",
          "Chantel",
          "Chantell",
          "Chantelle",
          "Chara",
          "Charis",
          "Charise",
          "Charissa",
          "Charisse",
          "Charita",
          "Charity",
          "Charla",
          "Charleen",
          "Charlena",
          "Charlene",
          "Charles",
          "Charlesetta",
          "Charlette",
          "Charlie",
          "Charline",
          "Charlott",
          "Charlotte",
          "Charlsie",
          "Charlyn",
          "Charmain",
          "Charmaine",
          "Charolette",
          "Chasidy",
          "Chasity",
          "Chassidy",
          "Chastity",
          "Chau",
          "Chaya",
          "Chelsea",
          "Chelsey",
          "Chelsie",
          "Cher",
          "Chere",
          "Cheree",
          "Cherelle",
          "Cheri",
          "Cherie",
          "Cherilyn",
          "Cherise",
          "Cherish",
          "Cherly",
          "Cherlyn",
          "Cherri",
          "Cherrie",
          "Cherry",
          "Cherryl",
          "Chery",
          "Cheryl",
          "Cheryle",
          "Cheryll",
          "Cheyenne",
          "Chi",
          "Chia",
          "Chieko",
          "Chin",
          "China",
          "Ching",
          "Chiquita",
          "Chloe",
          "Chong",
          "Chris",
          "Chrissy",
          "Christa",
          "Christal",
          "Christeen",
          "Christel",
          "Christen",
          "Christena",
          "Christene",
          "Christi",
          "Christia",
          "Christian",
          "Christiana",
          "Christiane",
          "Christie",
          "Christin",
          "Christina",
          "Christine",
          "Christinia",
          "Christopher",
          "Christy",
          "Chrystal",
          "Chu",
          "Chun",
          "Chung",
          "Ciara",
          "Cicely",
          "Ciera",
          "Cierra",
          "Cinda",
          "Cinderella",
          "Cindi",
          "Cindie",
          "Cindy",
          "Cinthia",
          "Cira",
          "Clair",
          "Claire",
          "Clara",
          "Clare",
          "Clarence",
          "Claretha",
          "Claretta",
          "Claribel",
          "Clarice",
          "Clarinda",
          "Clarine",
          "Claris",
          "Clarisa",
          "Clarissa",
          "Clarita",
          "Classie",
          "Claude",
          "Claudette",
          "Claudia",
          "Claudie",
          "Claudine",
          "Clelia",
          "Clemencia",
          "Clementina",
          "Clementine",
          "Clemmie",
          "Cleo",
          "Cleopatra",
          "Cleora",
          "Cleotilde",
          "Cleta",
          "Clora",
          "Clorinda",
          "Clotilde",
          "Clyde",
          "Codi",
          "Cody",
          "Colby",
          "Coleen",
          "Colene",
          "Coletta",
          "Colette",
          "Colleen",
          "Collen",
          "Collene",
          "Collette",
          "Concepcion",
          "Conception",
          "Concetta",
          "Concha",
          "Conchita",
          "Connie",
          "Constance",
          "Consuela",
          "Consuelo",
          "Contessa",
          "Cora",
          "Coral",
          "Coralee",
          "Coralie",
          "Corazon",
          "Cordelia",
          "Cordia",
          "Cordie",
          "Coreen",
          "Corene",
          "Coretta",
          "Corey",
          "Cori",
          "Corie",
          "Corina",
          "Corine",
          "Corinna",
          "Corinne",
          "Corliss",
          "Cornelia",
          "Corrie",
          "Corrin",
          "Corrina",
          "Corrine",
          "Corrinne",
          "Cortney",
          "Cory",
          "Courtney",
          "Creola",
          "Cris",
          "Criselda",
          "Crissy",
          "Crista",
          "Cristal",
          "Cristen",
          "Cristi",
          "Cristie",
          "Cristin",
          "Cristina",
          "Cristine",
          "Cristy",
          "Cruz",
          "Crysta",
          "Crystal",
          "Crystle",
          "Cuc",
          "Curtis",
          "Cyndi",
          "Cyndy",
          "Cynthia",
          "Cyrstal",
          "Cythia",
          "Dacia",
          "Dagmar",
          "Dagny",
          "Dahlia",
          "Daina",
          "Daine",
          "Daisey",
          "Daisy",
          "Dakota",
          "Dale",
          "Dalene",
          "Dalia",
          "Dalila",
          "Dallas",
          "Damaris",
          "Dan",
          "Dana",
          "Danae",
          "Danelle",
          "Danette",
          "Dani",
          "Dania",
          "Danica",
          "Daniel",
          "Daniela",
          "Daniele",
          "Daniell",
          "Daniella",
          "Danielle",
          "Danika",
          "Danille",
          "Danita",
          "Dann",
          "Danna",
          "Dannette",
          "Dannie",
          "Dannielle",
          "Danuta",
          "Danyel",
          "Danyell",
          "Danyelle",
          "Daphine",
          "Daphne",
          "Dara",
          "Darby",
          "Darcel",
          "Darcey",
          "Darci",
          "Darcie",
          "Darcy",
          "Daria",
          "Darla",
          "Darleen",
          "Darlena",
          "Darlene",
          "Darline",
          "Darnell",
          "Daryl",
          "David",
          "Davida",
          "Davina",
          "Dawn",
          "Dawna",
          "Dawne",
          "Dayle",
          "Dayna",
          "Daysi",
          "Deadra",
          "Dean",
          "Deana",
          "Deandra",
          "Deandrea",
          "Deane",
          "Deann",
          "Deanna",
          "Deanne",
          "Deb",
          "Debbi",
          "Debbie",
          "Debbra",
          "Debby",
          "Debera",
          "Debi",
          "Debora",
          "Deborah",
          "Debra",
          "Debrah",
          "Debroah",
          "Dede",
          "Dedra",
          "Dee",
          "Deeann",
          "Deeanna",
          "Deedee",
          "Deedra",
          "Deena",
          "Deetta",
          "Deidra",
          "Deidre",
          "Deirdre",
          "Deja",
          "Delaine",
          "Delana",
          "Delcie",
          "Delena",
          "Delfina",
          "Delia",
          "Delicia",
          "Delila",
          "Delilah",
          "Delinda",
          "Delisa",
          "Dell",
          "Della",
          "Delma",
          "Delmy",
          "Delois",
          "Deloise",
          "Delora",
          "Deloras",
          "Delores",
          "Deloris",
          "Delorse",
          "Delpha",
          "Delphia",
          "Delphine",
          "Delsie",
          "Delta",
          "Demetra",
          "Demetria",
          "Demetrice",
          "Demetrius",
          "Dena",
          "Denae",
          "Deneen",
          "Denese",
          "Denice",
          "Denise",
          "Denisha",
          "Denisse",
          "Denita",
          "Denna",
          "Dennis",
          "Dennise",
          "Denny",
          "Denyse",
          "Deon",
          "Deonna",
          "Desirae",
          "Desire",
          "Desiree",
          "Despina",
          "Dessie",
          "Destiny",
          "Detra",
          "Devin",
          "Devon",
          "Devona",
          "Devora",
          "Devorah",
          "Dia",
          "Diamond",
          "Dian",
          "Diana",
          "Diane",
          "Diann",
          "Dianna",
          "Dianne",
          "Diedra",
          "Diedre",
          "Dierdre",
          "Digna",
          "Dimple",
          "Dina",
          "Dinah",
          "Dinorah",
          "Dion",
          "Dione",
          "Dionna",
          "Dionne",
          "Divina",
          "Dixie",
          "Dodie",
          "Dollie",
          "Dolly",
          "Dolores",
          "Doloris",
          "Domenica",
          "Dominga",
          "Dominica",
          "Dominique",
          "Dominque",
          "Domitila",
          "Domonique",
          "Dona",
          "Donald",
          "Donella",
          "Donetta",
          "Donette",
          "Dong",
          "Donita",
          "Donna",
          "Donnetta",
          "Donnette",
          "Donnie",
          "Donya",
          "Dora",
          "Dorathy",
          "Dorcas",
          "Doreatha",
          "Doreen",
          "Dorene",
          "Doretha",
          "Dorethea",
          "Doretta",
          "Dori",
          "Doria",
          "Dorian",
          "Dorie",
          "Dorinda",
          "Dorine",
          "Doris",
          "Dorla",
          "Dorotha",
          "Dorothea",
          "Dorothy",
          "Dorris",
          "Dortha",
          "Dorthea",
          "Dorthey",
          "Dorthy",
          "Dot",
          "Dottie",
          "Dotty",
          "Dovie",
          "Dreama",
          "Drema",
          "Drew",
          "Drucilla",
          "Drusilla",
          "Dulce",
          "Dulcie",
          "Dung",
          "Dusti",
          "Dusty",
          "Dwana",
          "Dyan",
          "Earlean",
          "Earleen",
          "Earlene",
          "Earlie",
          "Earline",
          "Earnestine",
          "Eartha",
          "Easter",
          "Eboni",
          "Ebonie",
          "Ebony",
          "Echo",
          "Eda",
          "Edda",
          "Eddie",
          "Edelmira",
          "Eden",
          "Edie",
          "Edith",
          "Edna",
          "Edra",
          "Edris",
          "Edward",
          "Edwina",
          "Edyth",
          "Edythe",
          "Effie",
          "Ehtel",
          "Eileen",
          "Eilene",
          "Ela",
          "Eladia",
          "Elaina",
          "Elaine",
          "Elana",
          "Elane",
          "Elanor",
          "Elayne",
          "Elba",
          "Elda",
          "Eldora",
          "Eleanor",
          "Eleanora",
          "Eleanore",
          "Elease",
          "Elena",
          "Elene",
          "Eleni",
          "Elenor",
          "Elenora",
          "Elenore",
          "Eleonor",
          "Eleonora",
          "Eleonore",
          "Elfreda",
          "Elfrieda",
          "Elfriede",
          "Elia",
          "Eliana",
          "Elicia",
          "Elida",
          "Elidia",
          "Elin",
          "Elina",
          "Elinor",
          "Elinore",
          "Elisa",
          "Elisabeth",
          "Elise",
          "Elisha",
          "Elissa",
          "Eliz",
          "Eliza",
          "Elizabet",
          "Elizabeth",
          "Elizbeth",
          "Elizebeth",
          "Elke",
          "Ella",
          "Ellamae",
          "Ellan",
          "Ellen",
          "Ellena",
          "Elli",
          "Ellie",
          "Ellis",
          "Elly",
          "Ellyn",
          "Elma",
          "Elmer",
          "Elmira",
          "Elna",
          "Elnora",
          "Elodia",
          "Elois",
          "Eloisa",
          "Eloise",
          "Elouise",
          "Elsa",
          "Else",
          "Elsie",
          "Elsy",
          "Elva",
          "Elvera",
          "Elvia",
          "Elvie",
          "Elvina",
          "Elvira",
          "Elwanda",
          "Elyse",
          "Elza",
          "Ema",
          "Emelda",
          "Emelia",
          "Emelina",
          "Emeline",
          "Emely",
          "Emerald",
          "Emerita",
          "Emiko",
          "Emilee",
          "Emilia",
          "Emilie",
          "Emily",
          "Emma",
          "Emmaline",
          "Emmie",
          "Emmy",
          "Emogene",
          "Ena",
          "Enda",
          "Enedina",
          "Eneida",
          "Enid",
          "Enola",
          "Enriqueta",
          "Epifania",
          "Era",
          "Eric",
          "Erica",
          "Ericka",
          "Erika",
          "Erin",
          "Erinn",
          "Erlene",
          "Erlinda",
          "Erline",
          "Erma",
          "Ermelinda",
          "Erminia",
          "Erna",
          "Ernestina",
          "Ernestine",
          "Eryn",
          "Esmeralda",
          "Esperanza",
          "Essie",
          "Esta",
          "Estefana",
          "Estela",
          "Estell",
          "Estella",
          "Estelle",
          "Ester",
          "Esther",
          "Estrella",
          "Etha",
          "Ethel",
          "Ethelene",
          "Ethelyn",
          "Ethyl",
          "Etsuko",
          "Etta",
          "Ettie",
          "Eufemia",
          "Eugena",
          "Eugene",
          "Eugenia",
          "Eugenie",
          "Eula",
          "Eulah",
          "Eulalia",
          "Eun",
          "Euna",
          "Eunice",
          "Eura",
          "Eusebia",
          "Eustolia",
          "Eva",
          "Evalyn",
          "Evan",
          "Evangelina",
          "Evangeline",
          "Eve",
          "Evelia",
          "Evelin",
          "Evelina",
          "Eveline",
          "Evelyn",
          "Evelyne",
          "Evelynn",
          "Evette",
          "Evia",
          "Evie",
          "Evita",
          "Evon",
          "Evonne",
          "Ewa",
          "Exie",
          "Fabiola",
          "Fae",
          "Fairy",
          "Faith",
          "Fallon",
          "Fannie",
          "Fanny",
          "Farah",
          "Farrah",
          "Fatima",
          "Fatimah",
          "Faustina",
          "Faviola",
          "Fawn",
          "Fay",
          "Faye",
          "Fe",
          "Felecia",
          "Felica",
          "Felice",
          "Felicia",
          "Felicidad",
          "Felicita",
          "Felicitas",
          "Felipa",
          "Felisa",
          "Felisha",
          "Fermina",
          "Fern",
          "Fernanda",
          "Fernande",
          "Ferne",
          "Fidela",
          "Fidelia",
          "Filomena",
          "Fiona",
          "Flavia",
          "Fleta",
          "Flo",
          "Flor",
          "Flora",
          "Florance",
          "Florence",
          "Florencia",
          "Florene",
          "Florentina",
          "Floretta",
          "Floria",
          "Florida",
          "Florinda",
          "Florine",
          "Florrie",
          "Flossie",
          "Floy",
          "Fonda",
          "Fran",
          "France",
          "Francene",
          "Frances",
          "Francesca",
          "Franchesca",
          "Francie",
          "Francina",
          "Francine",
          "Francis",
          "Francisca",
          "Francisco",
          "Francoise",
          "Frank",
          "Frankie",
          "Fransisca",
          "Fred",
          "Freda",
          "Fredda",
          "Freddie",
          "Frederica",
          "Fredericka",
          "Fredia",
          "Fredricka",
          "Freeda",
          "Freida",
          "Frida",
          "Frieda",
          "Fumiko",
          "Gabriel",
          "Gabriela",
          "Gabriele",
          "Gabriella",
          "Gabrielle",
          "Gail",
          "Gala",
          "Gale",
          "Galina",
          "Garnet",
          "Garnett",
          "Gary",
          "Gay",
          "Gaye",
          "Gayla",
          "Gayle",
          "Gaylene",
          "Gaynell",
          "Gaynelle",
          "Gearldine",
          "Gema",
          "Gemma",
          "Gena",
          "Gene",
          "Genesis",
          "Geneva",
          "Genevie",
          "Genevieve",
          "Genevive",
          "Genia",
          "Genie",
          "Genna",
          "Gennie",
          "Genny",
          "Genoveva",
          "Georgann",
          "George",
          "Georgeann",
          "Georgeanna",
          "Georgene",
          "Georgetta",
          "Georgette",
          "Georgia",
          "Georgiana",
          "Georgiann",
          "Georgianna",
          "Georgianne",
          "Georgie",
          "Georgina",
          "Georgine",
          "Gerald",
          "Geraldine",
          "Geralyn",
          "Gerda",
          "Geri",
          "Germaine",
          "Gerri",
          "Gerry",
          "Gertha",
          "Gertie",
          "Gertrud",
          "Gertrude",
          "Gertrudis",
          "Gertude",
          "Ghislaine",
          "Gia",
          "Gianna",
          "Gidget",
          "Gigi",
          "Gilberte",
          "Gilda",
          "Gillian",
          "Gilma",
          "Gina",
          "Ginette",
          "Ginger",
          "Ginny",
          "Giovanna",
          "Gisela",
          "Gisele",
          "Giselle",
          "Gita",
          "Giuseppina",
          "Gladis",
          "Glady",
          "Gladys",
          "Glayds",
          "Glenda",
          "Glendora",
          "Glenn",
          "Glenna",
          "Glennie",
          "Glennis",
          "Glinda",
          "Gloria",
          "Glory",
          "Glynda",
          "Glynis",
          "Golda",
          "Golden",
          "Goldie",
          "Grace",
          "Gracia",
          "Gracie",
          "Graciela",
          "Grayce",
          "Grazyna",
          "Gregoria",
          "Gregory",
          "Greta",
          "Gretchen",
          "Gretta",
          "Gricelda",
          "Grisel",
          "Griselda",
          "Guadalupe",
          "Gudrun",
          "Guillermina",
          "Gussie",
          "Gwen",
          "Gwenda",
          "Gwendolyn",
          "Gwenn",
          "Gwyn",
          "Gwyneth",
          "Ha",
          "Hae",
          "Hailey",
          "Haley",
          "Halina",
          "Halley",
          "Hallie",
          "Han",
          "Hana",
          "Hang",
          "Hanh",
          "Hanna",
          "Hannah",
          "Hannelore",
          "Harmony",
          "Harold",
          "Harriet",
          "Harriett",
          "Harriette",
          "Hassie",
          "Hattie",
          "Haydee",
          "Hayley",
          "Hazel",
          "Heather",
          "Hedwig",
          "Hedy",
          "Hee",
          "Heide",
          "Heidi",
          "Heidy",
          "Heike",
          "Helaine",
          "Helen",
          "Helena",
          "Helene",
          "Helga",
          "Hellen",
          "Henrietta",
          "Henriette",
          "Henry",
          "Herlinda",
          "Herma",
          "Hermelinda",
          "Hermila",
          "Hermina",
          "Hermine",
          "Herminia",
          "Herta",
          "Hertha",
          "Hester",
          "Hettie",
          "Hiedi",
          "Hien",
          "Hilaria",
          "Hilary",
          "Hilda",
          "Hilde",
          "Hildegard",
          "Hildegarde",
          "Hildred",
          "Hillary",
          "Hilma",
          "Hiroko",
          "Hisako",
          "Hoa",
          "Holley",
          "Holli",
          "Hollie",
          "Hollis",
          "Holly",
          "Honey",
          "Hong",
          "Hope",
          "Hortencia",
          "Hortense",
          "Hortensia",
          "Hsiu",
          "Hue",
          "Hui",
          "Hulda",
          "Huong",
          "Hwa",
          "Hyacinth",
          "Hye",
          "Hyo",
          "Hyon",
          "Hyun",
          "Ida",
          "Idalia",
          "Idell",
          "Idella",
          "Iesha",
          "Ignacia",
          "Ila",
          "Ilana",
          "Ilda",
          "Ileana",
          "Ileen",
          "Ilene",
          "Iliana",
          "Illa",
          "Ilona",
          "Ilse",
          "Iluminada",
          "Ima",
          "Imelda",
          "Imogene",
          "In",
          "Ina",
          "India",
          "Indira",
          "Inell",
          "Ines",
          "Inez",
          "Inga",
          "Inge",
          "Ingeborg",
          "Inger",
          "Ingrid",
          "Inocencia",
          "Iola",
          "Iona",
          "Ione",
          "Ira",
          "Iraida",
          "Irena",
          "Irene",
          "Irina",
          "Iris",
          "Irish",
          "Irma",
          "Irmgard",
          "Isa",
          "Isabel",
          "Isabell",
          "Isabella",
          "Isabelle",
          "Isadora",
          "Isaura",
          "Isela",
          "Isidra",
          "Isis",
          "Isobel",
          "Iva",
          "Ivana",
          "Ivelisse",
          "Ivette",
          "Ivey",
          "Ivonne",
          "Ivory",
          "Ivy",
          "Izetta",
          "Izola",
          "Ja",
          "Jacalyn",
          "Jacelyn",
          "Jacinda",
          "Jacinta",
          "Jack",
          "Jackeline",
          "Jackelyn",
          "Jacki",
          "Jackie",
          "Jacklyn",
          "Jackqueline",
          "Jaclyn",
          "Jacqualine",
          "Jacque",
          "Jacquelin",
          "Jacqueline",
          "Jacquelyn",
          "Jacquelyne",
          "Jacquelynn",
          "Jacquetta",
          "Jacqui",
          "Jacquie",
          "Jacquiline",
          "Jacquline",
          "Jacqulyn",
          "Jada",
          "Jade",
          "Jadwiga",
          "Jae",
          "Jaime",
          "Jaimee",
          "Jaimie",
          "Jaleesa",
          "Jalisa",
          "Jama",
          "Jame",
          "Jamee",
          "James",
          "Jamey",
          "Jami",
          "Jamie",
          "Jamika",
          "Jamila",
          "Jammie",
          "Jan",
          "Jana",
          "Janae",
          "Janay",
          "Jane",
          "Janean",
          "Janee",
          "Janeen",
          "Janel",
          "Janell",
          "Janella",
          "Janelle",
          "Janene",
          "Janessa",
          "Janet",
          "Janeth",
          "Janett",
          "Janetta",
          "Janette",
          "Janey",
          "Jani",
          "Janice",
          "Janie",
          "Janiece",
          "Janina",
          "Janine",
          "Janis",
          "Janise",
          "Janita",
          "Jann",
          "Janna",
          "Jannet",
          "Jannette",
          "Jannie",
          "January",
          "Janyce",
          "Jaqueline",
          "Jaquelyn",
          "Jasmin",
          "Jasmine",
          "Jason",
          "Jaunita",
          "Jay",
          "Jaye",
          "Jayme",
          "Jaymie",
          "Jayna",
          "Jayne",
          "Jazmin",
          "Jazmine",
          "Jean",
          "Jeana",
          "Jeane",
          "Jeanelle",
          "Jeanene",
          "Jeanett",
          "Jeanetta",
          "Jeanette",
          "Jeanice",
          "Jeanie",
          "Jeanine",
          "Jeanmarie",
          "Jeanna",
          "Jeanne",
          "Jeannetta",
          "Jeannette",
          "Jeannie",
          "Jeannine",
          "Jeffie",
          "Jeffrey",
          "Jen",
          "Jena",
          "Jenae",
          "Jene",
          "Jenee",
          "Jenell",
          "Jenelle",
          "Jenette",
          "Jeneva",
          "Jeni",
          "Jenice",
          "Jenifer",
          "Jeniffer",
          "Jenine",
          "Jenise",
          "Jenna",
          "Jennefer",
          "Jennell",
          "Jennette",
          "Jenni",
          "Jennie",
          "Jennifer",
          "Jenniffer",
          "Jennine",
          "Jenny",
          "Jeraldine",
          "Jeremy",
          "Jeri",
          "Jerica",
          "Jerilyn",
          "Jerlene",
          "Jerri",
          "Jerrica",
          "Jerrie",
          "Jerry",
          "Jesenia",
          "Jesica",
          "Jesse",
          "Jessenia",
          "Jessi",
          "Jessia",
          "Jessica",
          "Jessie",
          "Jessika",
          "Jestine",
          "Jesus",
          "Jesusa",
          "Jesusita",
          "Jetta",
          "Jettie",
          "Jewel",
          "Jewell",
          "Ji",
          "Jill",
          "Jillian",
          "Jimmie",
          "Jimmy",
          "Jin",
          "Jina",
          "Jinny",
          "Jo",
          "Joan",
          "Joana",
          "Joane",
          "Joanie",
          "Joann",
          "Joanna",
          "Joanne",
          "Joannie",
          "Joaquina",
          "Jocelyn",
          "Jodee",
          "Jodi",
          "Jodie",
          "Jody",
          "Joe",
          "Joeann",
          "Joel",
          "Joella",
          "Joelle",
          "Joellen",
          "Joetta",
          "Joette",
          "Joey",
          "Johana",
          "Johanna",
          "Johanne",
          "John",
          "Johna",
          "Johnetta",
          "Johnette",
          "Johnie",
          "Johnna",
          "Johnnie",
          "Johnny",
          "Johnsie",
          "Joi",
          "Joie",
          "Jolanda",
          "Joleen",
          "Jolene",
          "Jolie",
          "Joline",
          "Jolyn",
          "Jolynn",
          "Jon",
          "Jona",
          "Jone",
          "Jonell",
          "Jonelle",
          "Jong",
          "Joni",
          "Jonie",
          "Jonna",
          "Jonnie",
          "Jordan",
          "Jose",
          "Josefa",
          "Josefina",
          "Josefine",
          "Joselyn",
          "Joseph",
          "Josephina",
          "Josephine",
          "Josette",
          "Joshua",
          "Josie",
          "Joslyn",
          "Josphine",
          "Jovan",
          "Jovita",
          "Joy",
          "Joya",
          "Joyce",
          "Joycelyn",
          "Joye",
          "Juan",
          "Juana",
          "Juanita",
          "Jude",
          "Judi",
          "Judie",
          "Judith",
          "Judy",
          "Jule",
          "Julee",
          "Julene",
          "Juli",
          "Julia",
          "Julian",
          "Juliana",
          "Juliane",
          "Juliann",
          "Julianna",
          "Julianne",
          "Julie",
          "Julieann",
          "Julienne",
          "Juliet",
          "Julieta",
          "Julietta",
          "Juliette",
          "Julio",
          "Julissa",
          "June",
          "Jung",
          "Junie",
          "Junita",
          "Junko",
          "Justa",
          "Justin",
          "Justina",
          "Justine",
          "Jutta",
          "Ka",
          "Kacey",
          "Kaci",
          "Kacie",
          "Kacy",
          "Kai",
          "Kaila",
          "Kaitlin",
          "Kaitlyn",
          "Kala",
          "Kaleigh",
          "Kaley",
          "Kali",
          "Kallie",
          "Kalyn",
          "Kam",
          "Kamala",
          "Kami",
          "Kamilah",
          "Kandace",
          "Kandi",
          "Kandice",
          "Kandis",
          "Kandra",
          "Kandy",
          "Kanesha",
          "Kanisha",
          "Kara",
          "Karan",
          "Kareen",
          "Karen",
          "Karena",
          "Karey",
          "Kari",
          "Karie",
          "Karima",
          "Karin",
          "Karina",
          "Karine",
          "Karisa",
          "Karissa",
          "Karl",
          "Karla",
          "Karleen",
          "Karlene",
          "Karly",
          "Karlyn",
          "Karma",
          "Karmen",
          "Karol",
          "Karole",
          "Karoline",
          "Karolyn",
          "Karon",
          "Karren",
          "Karri",
          "Karrie",
          "Karry",
          "Kary",
          "Karyl",
          "Karyn",
          "Kasandra",
          "Kasey",
          "Kasha",
          "Kasi",
          "Kasie",
          "Kassandra",
          "Kassie",
          "Kate",
          "Katelin",
          "Katelyn",
          "Katelynn",
          "Katerine",
          "Kathaleen",
          "Katharina",
          "Katharine",
          "Katharyn",
          "Kathe",
          "Katheleen",
          "Katherin",
          "Katherina",
          "Katherine",
          "Kathern",
          "Katheryn",
          "Kathey",
          "Kathi",
          "Kathie",
          "Kathleen",
          "Kathlene",
          "Kathline",
          "Kathlyn",
          "Kathrin",
          "Kathrine",
          "Kathryn",
          "Kathryne",
          "Kathy",
          "Kathyrn",
          "Kati",
          "Katia",
          "Katie",
          "Katina",
          "Katlyn",
          "Katrice",
          "Katrina",
          "Kattie",
          "Katy",
          "Kay",
          "Kayce",
          "Kaycee",
          "Kaye",
          "Kayla",
          "Kaylee",
          "Kayleen",
          "Kayleigh",
          "Kaylene",
          "Kazuko",
          "Kecia",
          "Keeley",
          "Keely",
          "Keena",
          "Keesha",
          "Keiko",
          "Keila",
          "Keira",
          "Keisha",
          "Keith",
          "Keitha",
          "Keli",
          "Kelle",
          "Kellee",
          "Kelley",
          "Kelli",
          "Kellie",
          "Kelly",
          "Kellye",
          "Kelsey",
          "Kelsi",
          "Kelsie",
          "Kemberly",
          "Kena",
          "Kenda",
          "Kendal",
          "Kendall",
          "Kendra",
          "Kenia",
          "Kenisha",
          "Kenna",
          "Kenneth",
          "Kenya",
          "Kenyatta",
          "Kenyetta",
          "Kera",
          "Keren",
          "Keri",
          "Kerri",
          "Kerrie",
          "Kerry",
          "Kerstin",
          "Kesha",
          "Keshia",
          "Keturah",
          "Keva",
          "Kevin",
          "Khadijah",
          "Khalilah",
          "Kia",
          "Kiana",
          "Kiara",
          "Kiera",
          "Kiersten",
          "Kiesha",
          "Kiley",
          "Kim",
          "Kimber",
          "Kimberely",
          "Kimberlee",
          "Kimberley",
          "Kimberli",
          "Kimberlie",
          "Kimberly",
          "Kimbery",
          "Kimbra",
          "Kimi",
          "Kimiko",
          "Kina",
          "Kindra",
          "Kira",
          "Kirby",
          "Kirsten",
          "Kirstie",
          "Kirstin",
          "Kisha",
          "Kit",
          "Kittie",
          "Kitty",
          "Kiyoko",
          "Kizzie",
          "Kizzy",
          "Klara",
          "Kori",
          "Kortney",
          "Kourtney",
          "Kris",
          "Krishna",
          "Krissy",
          "Krista",
          "Kristal",
          "Kristan",
          "Kristeen",
          "Kristel",
          "Kristen",
          "Kristi",
          "Kristian",
          "Kristie",
          "Kristin",
          "Kristina",
          "Kristine",
          "Kristle",
          "Kristy",
          "Kristyn",
          "Krysta",
          "Krystal",
          "Krysten",
          "Krystin",
          "Krystina",
          "Krystle",
          "Krystyna",
          "Kum",
          "Kyla",
          "Kyle",
          "Kylee",
          "Kylie",
          "Kym",
          "Kymberly",
          "Kyoko",
          "Kyong",
          "Kyra",
          "Kyung",
          "Lacey",
          "Lachelle",
          "Laci",
          "Lacie",
          "Lacresha",
          "Lacy",
          "Ladawn",
          "Ladonna",
          "Lady",
          "Lael",
          "Lahoma",
          "Lai",
          "Laila",
          "Laine",
          "Lajuana",
          "Lakeesha",
          "Lakeisha",
          "Lakendra",
          "Lakenya",
          "Lakesha",
          "Lakeshia",
          "Lakia",
          "Lakiesha",
          "Lakisha",
          "Lakita",
          "Lala",
          "Lamonica",
          "Lan",
          "Lana",
          "Lane",
          "Lanell",
          "Lanelle",
          "Lanette",
          "Lang",
          "Lani",
          "Lanie",
          "Lanita",
          "Lannie",
          "Lanora",
          "Laquanda",
          "Laquita",
          "Lara",
          "Larae",
          "Laraine",
          "Laree",
          "Larhonda",
          "Larisa",
          "Larissa",
          "Larita",
          "Laronda",
          "Larraine",
          "Larry",
          "Larue",
          "Lasandra",
          "Lashanda",
          "Lashandra",
          "Lashaun",
          "Lashaunda",
          "Lashawn",
          "Lashawna",
          "Lashawnda",
          "Lashay",
          "Lashell",
          "Lashon",
          "Lashonda",
          "Lashunda",
          "Lasonya",
          "Latanya",
          "Latarsha",
          "Latasha",
          "Latashia",
          "Latesha",
          "Latia",
          "Laticia",
          "Latina",
          "Latisha",
          "Latonia",
          "Latonya",
          "Latoria",
          "Latosha",
          "Latoya",
          "Latoyia",
          "Latrice",
          "Latricia",
          "Latrina",
          "Latrisha",
          "Launa",
          "Laura",
          "Lauralee",
          "Lauran",
          "Laure",
          "Laureen",
          "Laurel",
          "Lauren",
          "Laurena",
          "Laurence",
          "Laurene",
          "Lauretta",
          "Laurette",
          "Lauri",
          "Laurice",
          "Laurie",
          "Laurinda",
          "Laurine",
          "Lauryn",
          "Lavada",
          "Lavelle",
          "Lavenia",
          "Lavera",
          "Lavern",
          "Laverna",
          "Laverne",
          "Laveta",
          "Lavette",
          "Lavina",
          "Lavinia",
          "Lavon",
          "Lavona",
          "Lavonda",
          "Lavone",
          "Lavonia",
          "Lavonna",
          "Lavonne",
          "Lawana",
          "Lawanda",
          "Lawanna",
          "Lawrence",
          "Layla",
          "Layne",
          "Le",
          "Lea",
          "Leah",
          "Lean",
          "Leana",
          "Leandra",
          "Leann",
          "Leanna",
          "Leanne",
          "Leanora",
          "Leatha",
          "Leatrice",
          "Lecia",
          "Leda",
          "Lee",
          "Leeann",
          "Leeanna",
          "Leeanne",
          "Leena",
          "Leesa",
          "Leia",
          "Leida",
          "Leigh",
          "Leigha",
          "Leighann",
          "Leila",
          "Leilani",
          "Leisa",
          "Leisha",
          "Lekisha",
          "Lela",
          "Lelah",
          "Lelia",
          "Lena",
          "Lenita",
          "Lenna",
          "Lennie",
          "Lenora",
          "Lenore",
          "Leo",
          "Leola",
          "Leoma",
          "Leon",
          "Leona",
          "Leonarda",
          "Leone",
          "Leonia",
          "Leonida",
          "Leonie",
          "Leonila",
          "Leonor",
          "Leonora",
          "Leonore",
          "Leontine",
          "Leora",
          "Leota",
          "Lera",
          "Lesa",
          "Lesha",
          "Lesia",
          "Leslee",
          "Lesley",
          "Lesli",
          "Leslie",
          "Lessie",
          "Lester",
          "Leta",
          "Letha",
          "Leticia",
          "Letisha",
          "Letitia",
          "Lettie",
          "Letty",
          "Lewis",
          "Lexie",
          "Lezlie",
          "Li",
          "Lia",
          "Liana",
          "Liane",
          "Lianne",
          "Libbie",
          "Libby",
          "Liberty",
          "Librada",
          "Lida",
          "Lidia",
          "Lien",
          "Lieselotte",
          "Ligia",
          "Lila",
          "Lili",
          "Lilia",
          "Lilian",
          "Liliana",
          "Lilla",
          "Lilli",
          "Lillia",
          "Lilliam",
          "Lillian",
          "Lilliana",
          "Lillie",
          "Lilly",
          "Lily",
          "Lin",
          "Lina",
          "Linda",
          "Lindsay",
          "Lindsey",
          "Lindsy",
          "Lindy",
          "Linette",
          "Ling",
          "Linh",
          "Linn",
          "Linnea",
          "Linnie",
          "Linsey",
          "Lisa",
          "Lisabeth",
          "Lisandra",
          "Lisbeth",
          "Lise",
          "Lisette",
          "Lisha",
          "Lissa",
          "Lissette",
          "Lita",
          "Livia",
          "Liz",
          "Liza",
          "Lizabeth",
          "Lizbeth",
          "Lizeth",
          "Lizette",
          "Lizzette",
          "Lizzie",
          "Loan",
          "Logan",
          "Loida",
          "Lois",
          "Loise",
          "Lola",
          "Lolita",
          "Loma",
          "Lona",
          "Londa",
          "Loni",
          "Lonna",
          "Lonnie",
          "Lora",
          "Loraine",
          "Loralee",
          "Lore",
          "Lorean",
          "Loree",
          "Loreen",
          "Lorelei",
          "Loren",
          "Lorena",
          "Lorene",
          "Lorenza",
          "Loreta",
          "Loretta",
          "Lorette",
          "Lori",
          "Loria",
          "Loriann",
          "Lorie",
          "Lorilee",
          "Lorina",
          "Lorinda",
          "Lorine",
          "Loris",
          "Lorita",
          "Lorna",
          "Lorraine",
          "Lorretta",
          "Lorri",
          "Lorriane",
          "Lorrie",
          "Lorrine",
          "Lory",
          "Lottie",
          "Lou",
          "Louann",
          "Louanne",
          "Louella",
          "Louetta",
          "Louie",
          "Louis",
          "Louisa",
          "Louise",
          "Loura",
          "Lourdes",
          "Lourie",
          "Louvenia",
          "Love",
          "Lovella",
          "Lovetta",
          "Lovie",
          "Loyce",
          "Lu",
          "Luana",
          "Luann",
          "Luanna",
          "Luanne",
          "Luba",
          "Luci",
          "Lucia",
          "Luciana",
          "Lucie",
          "Lucienne",
          "Lucila",
          "Lucile",
          "Lucilla",
          "Lucille",
          "Lucina",
          "Lucinda",
          "Lucrecia",
          "Lucretia",
          "Lucy",
          "Ludie",
          "Ludivina",
          "Lue",
          "Luella",
          "Luetta",
          "Luis",
          "Luisa",
          "Luise",
          "Lula",
          "Lulu",
          "Luna",
          "Lupe",
          "Lupita",
          "Lura",
          "Lurlene",
          "Lurline",
          "Luvenia",
          "Luz",
          "Lyda",
          "Lydia",
          "Lyla",
          "Lyn",
          "Lynda",
          "Lyndia",
          "Lyndsay",
          "Lyndsey",
          "Lynell",
          "Lynelle",
          "Lynetta",
          "Lynette",
          "Lynn",
          "Lynna",
          "Lynne",
          "Lynnette",
          "Lynsey",
          "Ma",
          "Mabel",
          "Mabelle",
          "Mable",
          "Machelle",
          "Macie",
          "Mackenzie",
          "Macy",
          "Madalene",
          "Madaline",
          "Madalyn",
          "Maddie",
          "Madelaine",
          "Madeleine",
          "Madelene",
          "Madeline",
          "Madelyn",
          "Madge",
          "Madie",
          "Madison",
          "Madlyn",
          "Madonna",
          "Mae",
          "Maegan",
          "Mafalda",
          "Magali",
          "Magaly",
          "Magan",
          "Magaret",
          "Magda",
          "Magdalen",
          "Magdalena",
          "Magdalene",
          "Magen",
          "Maggie",
          "Magnolia",
          "Mahalia",
          "Mai",
          "Maia",
          "Maida",
          "Maile",
          "Maira",
          "Maire",
          "Maisha",
          "Maisie",
          "Majorie",
          "Makeda",
          "Malena",
          "Malia",
          "Malika",
          "Malinda",
          "Malisa",
          "Malissa",
          "Malka",
          "Mallie",
          "Mallory",
          "Malorie",
          "Malvina",
          "Mamie",
          "Mammie",
          "Man",
          "Mana",
          "Manda",
          "Mandi",
          "Mandie",
          "Mandy",
          "Manie",
          "Manuela",
          "Many",
          "Mao",
          "Maple",
          "Mara",
          "Maragaret",
          "Maragret",
          "Maranda",
          "Marcela",
          "Marcelene",
          "Marcelina",
          "Marceline",
          "Marcell",
          "Marcella",
          "Marcelle",
          "Marcene",
          "Marchelle",
          "Marci",
          "Marcia",
          "Marcie",
          "Marcy",
          "Mardell",
          "Maren",
          "Marg",
          "Margaret",
          "Margareta",
          "Margarete",
          "Margarett",
          "Margaretta",
          "Margarette",
          "Margarita",
          "Margarite",
          "Margart",
          "Marge",
          "Margene",
          "Margeret",
          "Margert",
          "Margery",
          "Marget",
          "Margherita",
          "Margie",
          "Margit",
          "Margo",
          "Margorie",
          "Margot",
          "Margret",
          "Margrett",
          "Marguerita",
          "Marguerite",
          "Margurite",
          "Margy",
          "Marhta",
          "Mari",
          "Maria",
          "Mariah",
          "Mariam",
          "Marian",
          "Mariana",
          "Marianela",
          "Mariann",
          "Marianna",
          "Marianne",
          "Maribel",
          "Maribeth",
          "Marica",
          "Maricela",
          "Maricruz",
          "Marie",
          "Mariel",
          "Mariela",
          "Mariella",
          "Marielle",
          "Marietta",
          "Mariette",
          "Mariko",
          "Marilee",
          "Marilou",
          "Marilu",
          "Marilyn",
          "Marilynn",
          "Marin",
          "Marina",
          "Marinda",
          "Marine",
          "Mario",
          "Marion",
          "Maris",
          "Marisa",
          "Marisela",
          "Marisha",
          "Marisol",
          "Marissa",
          "Marita",
          "Maritza",
          "Marivel",
          "Marjorie",
          "Marjory",
          "Mark",
          "Marketta",
          "Markita",
          "Marla",
          "Marlana",
          "Marleen",
          "Marlen",
          "Marlena",
          "Marlene",
          "Marlin",
          "Marline",
          "Marlo",
          "Marlyn",
          "Marlys",
          "Marna",
          "Marni",
          "Marnie",
          "Marquerite",
          "Marquetta",
          "Marquita",
          "Marquitta",
          "Marry",
          "Marsha",
          "Marshall",
          "Marta",
          "Marth",
          "Martha",
          "Marti",
          "Martin",
          "Martina",
          "Martine",
          "Marty",
          "Marva",
          "Marvel",
          "Marvella",
          "Marvis",
          "Marx",
          "Mary",
          "Marya",
          "Maryalice",
          "Maryam",
          "Maryann",
          "Maryanna",
          "Maryanne",
          "Marybelle",
          "Marybeth",
          "Maryellen",
          "Maryetta",
          "Maryjane",
          "Maryjo",
          "Maryland",
          "Marylee",
          "Marylin",
          "Maryln",
          "Marylou",
          "Marylouise",
          "Marylyn",
          "Marylynn",
          "Maryrose",
          "Masako",
          "Matha",
          "Mathilda",
          "Mathilde",
          "Matilda",
          "Matilde",
          "Matthew",
          "Mattie",
          "Maud",
          "Maude",
          "Maudie",
          "Maura",
          "Maureen",
          "Maurice",
          "Maurine",
          "Maurita",
          "Mavis",
          "Maxie",
          "Maxima",
          "Maximina",
          "Maxine",
          "May",
          "Maya",
          "Maybell",
          "Maybelle",
          "Maye",
          "Mayme",
          "Mayola",
          "Mayra",
          "Mazie",
          "Mckenzie",
          "Meagan",
          "Meaghan",
          "Mechelle",
          "Meda",
          "Mee",
          "Meg",
          "Megan",
          "Meggan",
          "Meghan",
          "Meghann",
          "Mei",
          "Melaine",
          "Melani",
          "Melania",
          "Melanie",
          "Melany",
          "Melba",
          "Melda",
          "Melia",
          "Melida",
          "Melina",
          "Melinda",
          "Melisa",
          "Melissa",
          "Melissia",
          "Melita",
          "Mellie",
          "Mellisa",
          "Mellissa",
          "Melodee",
          "Melodi",
          "Melodie",
          "Melody",
          "Melonie",
          "Melony",
          "Melva",
          "Melvin",
          "Melvina",
          "Melynda",
          "Mendy",
          "Mercedes",
          "Mercedez",
          "Mercy",
          "Meredith",
          "Meri",
          "Merideth",
          "Meridith",
          "Merilyn",
          "Merissa",
          "Merle",
          "Merlene",
          "Merlyn",
          "Merna",
          "Merri",
          "Merrie",
          "Merrilee",
          "Merrill",
          "Merry",
          "Mertie",
          "Meryl",
          "Meta",
          "Mi",
          "Mia",
          "Mica",
          "Micaela",
          "Micah",
          "Micha",
          "Michael",
          "Michaela",
          "Michaele",
          "Michal",
          "Micheal",
          "Michel",
          "Michele",
          "Michelina",
          "Micheline",
          "Michell",
          "Michelle",
          "Michiko",
          "Mickey",
          "Micki",
          "Mickie",
          "Miesha",
          "Migdalia",
          "Mignon",
          "Miguelina",
          "Mika",
          "Mikaela",
          "Mike",
          "Miki",
          "Mikki",
          "Mila",
          "Milagro",
          "Milagros",
          "Milda",
          "Mildred",
          "Milissa",
          "Millicent",
          "Millie",
          "Milly",
          "Mimi",
          "Min",
          "Mina",
          "Minda",
          "Mindi",
          "Mindy",
          "Minerva",
          "Ming",
          "Minh",
          "Minna",
          "Minnie",
          "Minta",
          "Mira",
          "Miranda",
          "Mireille",
          "Mirella",
          "Mireya",
          "Miriam",
          "Mirian",
          "Mirna",
          "Mirta",
          "Mirtha",
          "Misha",
          "Missy",
          "Misti",
          "Mistie",
          "Misty",
          "Mitchell",
          "Mitsue",
          "Mitsuko",
          "Mittie",
          "Mitzi",
          "Mitzie",
          "Miyoko",
          "Modesta",
          "Moira",
          "Mollie",
          "Molly",
          "Mona",
          "Monet",
          "Monica",
          "Monika",
          "Monique",
          "Monnie",
          "Monserrate",
          "Moon",
          "Mora",
          "Morgan",
          "Moriah",
          "Mozell",
          "Mozella",
          "Mozelle",
          "Mui",
          "Muoi",
          "Muriel",
          "My",
          "Myesha",
          "Myong",
          "Myra",
          "Myriam",
          "Myrl",
          "Myrle",
          "Myrna",
          "Myrta",
          "Myrtice",
          "Myrtie",
          "Myrtis",
          "Myrtle",
          "Myung",
          "Na",
          "Nada",
          "Nadene",
          "Nadia",
          "Nadine",
          "Naida",
          "Nakesha",
          "Nakia",
          "Nakisha",
          "Nakita",
          "Nam",
          "Nan",
          "Nana",
          "Nancee",
          "Nancey",
          "Nanci",
          "Nancie",
          "Nancy",
          "Nanette",
          "Nannette",
          "Nannie",
          "Naoma",
          "Naomi",
          "Narcisa",
          "Natacha",
          "Natalia",
          "Natalie",
          "Natalya",
          "Natasha",
          "Natashia",
          "Nathalie",
          "Natisha",
          "Natividad",
          "Natosha",
          "Necole",
          "Neda",
          "Nedra",
          "Neely",
          "Neida",
          "Nelda",
          "Nelia",
          "Nelida",
          "Nell",
          "Nella",
          "Nelle",
          "Nellie",
          "Nelly",
          "Nena",
          "Nenita",
          "Neoma",
          "Neomi",
          "Nereida",
          "Nerissa",
          "Nery",
          "Neta",
          "Nettie",
          "Neva",
          "Nevada",
          "Nga",
          "Ngan",
          "Ngoc",
          "Nguyet",
          "Nia",
          "Nichelle",
          "Nichol",
          "Nichole",
          "Nicholle",
          "Nicki",
          "Nickie",
          "Nickole",
          "Nicky",
          "Nicol",
          "Nicola",
          "Nicolasa",
          "Nicole",
          "Nicolette",
          "Nicolle",
          "Nida",
          "Nidia",
          "Niesha",
          "Nieves",
          "Niki",
          "Nikia",
          "Nikita",
          "Nikki",
          "Nikole",
          "Nila",
          "Nilda",
          "Nilsa",
          "Nina",
          "Ninfa",
          "Nisha",
          "Nita",
          "Nobuko",
          "Noel",
          "Noelia",
          "Noella",
          "Noelle",
          "Noemi",
          "Nohemi",
          "Nola",
          "Noma",
          "Nona",
          "Nora",
          "Norah",
          "Noreen",
          "Norene",
          "Noriko",
          "Norine",
          "Norma",
          "Norman",
          "Nova",
          "Novella",
          "Nu",
          "Nubia",
          "Numbers",
          "Nydia",
          "Nyla",
          "Obdulia",
          "Ocie",
          "Octavia",
          "Oda",
          "Odelia",
          "Odell",
          "Odessa",
          "Odette",
          "Odilia",
          "Ofelia",
          "Ok",
          "Ola",
          "Olene",
          "Oleta",
          "Olevia",
          "Olga",
          "Olimpia",
          "Olinda",
          "Oliva",
          "Olive",
          "Olivia",
          "Ollie",
          "Olympia",
          "Oma",
          "Omega",
          "Ona",
          "Oneida",
          "Onie",
          "Onita",
          "Opal",
          "Ophelia",
          "Ora",
          "Oralee",
          "Oralia",
          "Oretha",
          "Orpha",
          "Oscar",
          "Ossie",
          "Otelia",
          "Otha",
          "Otilia",
          "Ouida",
          "Ozell",
          "Ozella",
          "Ozie",
          "Pa",
          "Page",
          "Paige",
          "Palma",
          "Palmira",
          "Pam",
          "Pamala",
          "Pamela",
          "Pamelia",
          "Pamella",
          "Pamila",
          "Pamula",
          "Pandora",
          "Pansy",
          "Paola",
          "Paris",
          "Parthenia",
          "Particia",
          "Pasty",
          "Pat",
          "Patience",
          "Patria",
          "Patrica",
          "Patrice",
          "Patricia",
          "Patrick",
          "Patrina",
          "Patsy",
          "Patti",
          "Pattie",
          "Patty",
          "Paul",
          "Paula",
          "Paulene",
          "Pauletta",
          "Paulette",
          "Paulina",
          "Pauline",
          "Paulita",
          "Paz",
          "Pearl",
          "Pearle",
          "Pearlene",
          "Pearlie",
          "Pearline",
          "Pearly",
          "Peg",
          "Peggie",
          "Peggy",
          "Pei",
          "Penelope",
          "Penney",
          "Penni",
          "Pennie",
          "Penny",
          "Perla",
          "Perry",
          "Peter",
          "Petra",
          "Petrina",
          "Petronila",
          "Phebe",
          "Phillis",
          "Philomena",
          "Phoebe",
          "Phung",
          "Phuong",
          "Phylicia",
          "Phylis",
          "Phyliss",
          "Phyllis",
          "Pia",
          "Piedad",
          "Pilar",
          "Ping",
          "Pinkie",
          "Piper",
          "Pok",
          "Polly",
          "Porsche",
          "Porsha",
          "Portia",
          "Precious",
          "Pricilla",
          "Princess",
          "Priscila",
          "Priscilla",
          "Providencia",
          "Prudence",
          "Pura",
          "Qiana",
          "Queen",
          "Queenie",
          "Quiana",
          "Quinn",
          "Quyen",
          "Rachael",
          "Rachal",
          "Racheal",
          "Rachel",
          "Rachele",
          "Rachell",
          "Rachelle",
          "Racquel",
          "Rae",
          "Raeann",
          "Raelene",
          "Rafaela",
          "Raguel",
          "Raina",
          "Raisa",
          "Ramona",
          "Ramonita",
          "Rana",
          "Ranae",
          "Randa",
          "Randee",
          "Randi",
          "Randy",
          "Ranee",
          "Raquel",
          "Rasheeda",
          "Rashida",
          "Raven",
          "Ray",
          "Raye",
          "Raylene",
          "Raymond",
          "Raymonde",
          "Rayna",
          "Rea",
          "Reagan",
          "Reanna",
          "Reatha",
          "Reba",
          "Rebbeca",
          "Rebbecca",
          "Rebeca",
          "Rebecca",
          "Rebecka",
          "Rebekah",
          "Reda",
          "Reena",
          "Refugia",
          "Refugio",
          "Regan",
          "Regena",
          "Regenia",
          "Regina",
          "Regine",
          "Reginia",
          "Reiko",
          "Reina",
          "Reita",
          "Rema",
          "Remedios",
          "Remona",
          "Rena",
          "Renae",
          "Renata",
          "Renate",
          "Renay",
          "Renda",
          "Rene",
          "Renea",
          "Renee",
          "Renetta",
          "Renita",
          "Renna",
          "Ressie",
          "Reta",
          "Retha",
          "Retta",
          "Reva",
          "Reyna",
          "Reynalda",
          "Rhea",
          "Rheba",
          "Rhiannon",
          "Rhoda",
          "Rhona",
          "Rhonda",
          "Ria",
          "Ricarda",
          "Richard",
          "Richelle",
          "Ricki",
          "Rickie",
          "Rikki",
          "Rima",
          "Rina",
          "Risa",
          "Rita",
          "Riva",
          "Rivka",
          "Robbi",
          "Robbie",
          "Robbin",
          "Robbyn",
          "Robena",
          "Robert",
          "Roberta",
          "Roberto",
          "Robin",
          "Robyn",
          "Rochel",
          "Rochell",
          "Rochelle",
          "Rocio",
          "Rolanda",
          "Rolande",
          "Roma",
          "Romaine",
          "Romana",
          "Romelia",
          "Romona",
          "Rona",
          "Ronald",
          "Ronda",
          "Roni",
          "Ronna",
          "Ronni",
          "Ronnie",
          "Rory",
          "Rosa",
          "Rosalba",
          "Rosalee",
          "Rosalia",
          "Rosalie",
          "Rosalina",
          "Rosalind",
          "Rosalinda",
          "Rosaline",
          "Rosalva",
          "Rosalyn",
          "Rosamaria",
          "Rosamond",
          "Rosana",
          "Rosann",
          "Rosanna",
          "Rosanne",
          "Rosaria",
          "Rosario",
          "Rosaura",
          "Rose",
          "Roseann",
          "Roseanna",
          "Roseanne",
          "Roselee",
          "Roselia",
          "Roseline",
          "Rosella",
          "Roselle",
          "Roselyn",
          "Rosemarie",
          "Rosemary",
          "Rosena",
          "Rosenda",
          "Rosetta",
          "Rosette",
          "Rosia",
          "Rosie",
          "Rosina",
          "Rosio",
          "Rosita",
          "Roslyn",
          "Rossana",
          "Rossie",
          "Rosy",
          "Rowena",
          "Roxana",
          "Roxane",
          "Roxann",
          "Roxanna",
          "Roxanne",
          "Roxie",
          "Roxy",
          "Roy",
          "Royce",
          "Rozanne",
          "Rozella",
          "Rubi",
          "Rubie",
          "Ruby",
          "Rubye",
          "Rudy",
          "Rufina",
          "Russell",
          "Ruth",
          "Rutha",
          "Ruthann",
          "Ruthanne",
          "Ruthe",
          "Ruthie",
          "Ryan",
          "Ryann",
          "Sabina",
          "Sabine",
          "Sabra",
          "Sabrina",
          "Sacha",
          "Sachiko",
          "Sade",
          "Sadie",
          "Sadye",
          "Sage",
          "Salena",
          "Salina",
          "Salley",
          "Sallie",
          "Sally",
          "Salome",
          "Sam",
          "Samantha",
          "Samara",
          "Samatha",
          "Samella",
          "Samira",
          "Sammie",
          "Sammy",
          "Samuel",
          "Sana",
          "Sanda",
          "Sandee",
          "Sandi",
          "Sandie",
          "Sandra",
          "Sandy",
          "Sang",
          "Sanjuana",
          "Sanjuanita",
          "Sanora",
          "Santa",
          "Santana",
          "Santina",
          "Santos",
          "Sara",
          "Sarah",
          "Sarai",
          "Saran",
          "Sari",
          "Sarina",
          "Sarita",
          "Sasha",
          "Saturnina",
          "Sau",
          "Saundra",
          "Savanna",
          "Savannah",
          "Scarlet",
          "Scarlett",
          "Scott",
          "Scottie",
          "Sean",
          "Season",
          "Sebrina",
          "See",
          "Seema",
          "Selena",
          "Selene",
          "Selina",
          "Selma",
          "Sena",
          "Senaida",
          "September",
          "Serafina",
          "Serena",
          "Serina",
          "Serita",
          "Setsuko",
          "Sha",
          "Shae",
          "Shaina",
          "Shakia",
          "Shakira",
          "Shakita",
          "Shala",
          "Shalanda",
          "Shalon",
          "Shalonda",
          "Shameka",
          "Shamika",
          "Shan",
          "Shana",
          "Shanae",
          "Shanda",
          "Shandi",
          "Shandra",
          "Shane",
          "Shaneka",
          "Shanel",
          "Shanell",
          "Shanelle",
          "Shani",
          "Shanice",
          "Shanika",
          "Shaniqua",
          "Shanita",
          "Shanna",
          "Shannan",
          "Shannon",
          "Shanon",
          "Shanta",
          "Shantae",
          "Shantay",
          "Shante",
          "Shantel",
          "Shantell",
          "Shantelle",
          "Shanti",
          "Shaquana",
          "Shaquita",
          "Shara",
          "Sharan",
          "Sharda",
          "Sharee",
          "Sharell",
          "Sharen",
          "Shari",
          "Sharice",
          "Sharie",
          "Sharika",
          "Sharilyn",
          "Sharita",
          "Sharla",
          "Sharleen",
          "Sharlene",
          "Sharmaine",
          "Sharolyn",
          "Sharon",
          "Sharonda",
          "Sharri",
          "Sharron",
          "Sharyl",
          "Sharyn",
          "Shasta",
          "Shaun",
          "Shauna",
          "Shaunda",
          "Shaunna",
          "Shaunta",
          "Shaunte",
          "Shavon",
          "Shavonda",
          "Shavonne",
          "Shawana",
          "Shawanda",
          "Shawanna",
          "Shawn",
          "Shawna",
          "Shawnda",
          "Shawnee",
          "Shawnna",
          "Shawnta",
          "Shay",
          "Shayla",
          "Shayna",
          "Shayne",
          "Shea",
          "Sheba",
          "Sheena",
          "Sheila",
          "Sheilah",
          "Shela",
          "Shelba",
          "Shelby",
          "Shelia",
          "Shella",
          "Shelley",
          "Shelli",
          "Shellie",
          "Shelly",
          "Shemeka",
          "Shemika",
          "Shena",
          "Shenika",
          "Shenita",
          "Shenna",
          "Shera",
          "Sheree",
          "Sherell",
          "Sheri",
          "Sherice",
          "Sheridan",
          "Sherie",
          "Sherika",
          "Sherill",
          "Sherilyn",
          "Sherise",
          "Sherita",
          "Sherlene",
          "Sherley",
          "Sherly",
          "Sherlyn",
          "Sheron",
          "Sherrell",
          "Sherri",
          "Sherrie",
          "Sherril",
          "Sherrill",
          "Sherron",
          "Sherry",
          "Sherryl",
          "Shery",
          "Sheryl",
          "Sheryll",
          "Shiela",
          "Shila",
          "Shiloh",
          "Shin",
          "Shira",
          "Shirely",
          "Shirl",
          "Shirlee",
          "Shirleen",
          "Shirlene",
          "Shirley",
          "Shirly",
          "Shizue",
          "Shizuko",
          "Shona",
          "Shonda",
          "Shondra",
          "Shonna",
          "Shonta",
          "Shoshana",
          "Shu",
          "Shyla",
          "Sibyl",
          "Sidney",
          "Sierra",
          "Signe",
          "Sigrid",
          "Silva",
          "Silvana",
          "Silvia",
          "Sima",
          "Simona",
          "Simone",
          "Simonne",
          "Sina",
          "Sindy",
          "Siobhan",
          "Sirena",
          "Siu",
          "Sixta",
          "Skye",
          "Slyvia",
          "So",
          "Socorro",
          "Sofia",
          "Soila",
          "Sol",
          "Solange",
          "Soledad",
          "Somer",
          "Sommer",
          "Son",
          "Sona",
          "Sondra",
          "Song",
          "Sonia",
          "Sonja",
          "Sonya",
          "Soo",
          "Sook",
          "Soon",
          "Sophia",
          "Sophie",
          "Soraya",
          "Sparkle",
          "Spring",
          "Stacee",
          "Stacey",
          "Staci",
          "Stacia",
          "Stacie",
          "Stacy",
          "Star",
          "Starla",
          "Starr",
          "Stasia",
          "Stefani",
          "Stefania",
          "Stefanie",
          "Stefany",
          "Steffanie",
          "Stella",
          "Stepanie",
          "Stephaine",
          "Stephane",
          "Stephani",
          "Stephania",
          "Stephanie",
          "Stephany",
          "Stephen",
          "Stephenie",
          "Stephine",
          "Stephnie",
          "Steven",
          "Stevie",
          "Stormy",
          "Su",
          "Suanne",
          "Sudie",
          "Sue",
          "Sueann",
          "Suellen",
          "Suk",
          "Sulema",
          "Sumiko",
          "Summer",
          "Sun",
          "Sunday",
          "Sung",
          "Sunni",
          "Sunny",
          "Sunshine",
          "Susan",
          "Susana",
          "Susann",
          "Susanna",
          "Susannah",
          "Susanne",
          "Susie",
          "Susy",
          "Suzan",
          "Suzann",
          "Suzanna",
          "Suzanne",
          "Suzette",
          "Suzi",
          "Suzie",
          "Suzy",
          "Svetlana",
          "Sybil",
          "Syble",
          "Sydney",
          "Sylvia",
          "Sylvie",
          "Synthia",
          "Syreeta",
          "Ta",
          "Tabatha",
          "Tabetha",
          "Tabitha",
          "Tai",
          "Taina",
          "Taisha",
          "Tajuana",
          "Takako",
          "Takisha",
          "Talia",
          "Talisha",
          "Talitha",
          "Tam",
          "Tama",
          "Tamala",
          "Tamar",
          "Tamara",
          "Tamatha",
          "Tambra",
          "Tameika",
          "Tameka",
          "Tamekia",
          "Tamela",
          "Tamera",
          "Tamesha",
          "Tami",
          "Tamica",
          "Tamie",
          "Tamika",
          "Tamiko",
          "Tamisha",
          "Tammara",
          "Tammera",
          "Tammi",
          "Tammie",
          "Tammy",
          "Tamra",
          "Tana",
          "Tandra",
          "Tandy",
          "Taneka",
          "Tanesha",
          "Tangela",
          "Tania",
          "Tanika",
          "Tanisha",
          "Tanja",
          "Tanna",
          "Tanya",
          "Tara",
          "Tarah",
          "Taren",
          "Tari",
          "Tarra",
          "Tarsha",
          "Taryn",
          "Tasha",
          "Tashia",
          "Tashina",
          "Tasia",
          "Tatiana",
          "Tatum",
          "Tatyana",
          "Taunya",
          "Tawana",
          "Tawanda",
          "Tawanna",
          "Tawna",
          "Tawny",
          "Tawnya",
          "Taylor",
          "Tayna",
          "Teena",
          "Tegan",
          "Teisha",
          "Telma",
          "Temeka",
          "Temika",
          "Tempie",
          "Temple",
          "Tena",
          "Tenesha",
          "Tenisha",
          "Tennie",
          "Tennille",
          "Teodora",
          "Teofila",
          "Tequila",
          "Tera",
          "Tereasa",
          "Teresa",
          "Terese",
          "Teresia",
          "Teresita",
          "Teressa",
          "Teri",
          "Terica",
          "Terina",
          "Terisa",
          "Terra",
          "Terrell",
          "Terresa",
          "Terri",
          "Terrie",
          "Terrilyn",
          "Terry",
          "Tesha",
          "Tess",
          "Tessa",
          "Tessie",
          "Thalia",
          "Thanh",
          "Thao",
          "Thea",
          "Theda",
          "Thelma",
          "Theo",
          "Theodora",
          "Theola",
          "Theresa",
          "Therese",
          "Theresia",
          "Theressa",
          "Thersa",
          "Thi",
          "Thomasena",
          "Thomasina",
          "Thomasine",
          "Thora",
          "Thresa",
          "Thu",
          "Thuy",
          "Tia",
          "Tiana",
          "Tianna",
          "Tiara",
          "Tien",
          "Tiera",
          "Tierra",
          "Tiesha",
          "Tifany",
          "Tiffaney",
          "Tiffani",
          "Tiffanie",
          "Tiffany",
          "Tiffiny",
          "Tijuana",
          "Tilda",
          "Tillie",
          "Timika",
          "Timothy",
          "Tina",
          "Tinisha",
          "Tiny",
          "Tisa",
          "Tish",
          "Tisha",
          "Tobi",
          "Tobie",
          "Toby",
          "Toccara",
          "Toi",
          "Tomasa",
          "Tomeka",
          "Tomi",
          "Tomika",
          "Tomiko",
          "Tommie",
          "Tommy",
          "Tommye",
          "Tomoko",
          "Tona",
          "Tonda",
          "Tonette",
          "Toni",
          "Tonia",
          "Tonie",
          "Tonisha",
          "Tonita",
          "Tonja",
          "Tony",
          "Tonya",
          "Tora",
          "Tori",
          "Torie",
          "Torri",
          "Torrie",
          "Tory",
          "Tosha",
          "Toshia",
          "Toshiko",
          "Tova",
          "Towanda",
          "Toya",
          "Tracee",
          "Tracey",
          "Traci",
          "Tracie",
          "Tracy",
          "Tran",
          "Trang",
          "Travis",
          "Treasa",
          "Treena",
          "Trena",
          "Tresa",
          "Tressa",
          "Tressie",
          "Treva",
          "Tricia",
          "Trina",
          "Trinh",
          "Trinidad",
          "Trinity",
          "Trish",
          "Trisha",
          "Trista",
          "Tristan",
          "Troy",
          "Trudi",
          "Trudie",
          "Trudy",
          "Trula",
          "Tu",
          "Tula",
          "Tuyet",
          "Twana",
          "Twanda",
          "Twanna",
          "Twila",
          "Twyla",
          "Tyesha",
          "Tyisha",
          "Tyler",
          "Tynisha",
          "Tyra",
          "Ula",
          "Ulrike",
          "Un",
          "Una",
          "Ursula",
          "Usha",
          "Ute",
          "Vada",
          "Val",
          "Valarie",
          "Valda",
          "Valencia",
          "Valene",
          "Valentina",
          "Valentine",
          "Valeri",
          "Valeria",
          "Valerie",
          "Valery",
          "Vallie",
          "Valorie",
          "Valrie",
          "Van",
          "Vanda",
          "Vanesa",
          "Vanessa",
          "Vanetta",
          "Vania",
          "Vanita",
          "Vanna",
          "Vannesa",
          "Vannessa",
          "Vashti",
          "Vasiliki",
          "Veda",
          "Velda",
          "Velia",
          "Vella",
          "Velma",
          "Velva",
          "Velvet",
          "Vena",
          "Venessa",
          "Venetta",
          "Venice",
          "Venita",
          "Vennie",
          "Venus",
          "Veola",
          "Vera",
          "Verda",
          "Verdell",
          "Verdie",
          "Verena",
          "Vergie",
          "Verla",
          "Verlene",
          "Verlie",
          "Verline",
          "Verna",
          "Vernell",
          "Vernetta",
          "Vernia",
          "Vernice",
          "Vernie",
          "Vernita",
          "Vernon",
          "Verona",
          "Veronica",
          "Veronika",
          "Veronique",
          "Versie",
          "Vertie",
          "Vesta",
          "Veta",
          "Vi",
          "Vicenta",
          "Vickey",
          "Vicki",
          "Vickie",
          "Vicky",
          "Victor",
          "Victoria",
          "Victorina",
          "Vida",
          "Viki",
          "Vikki",
          "Vilma",
          "Vina",
          "Vincenza",
          "Vinita",
          "Vinnie",
          "Viola",
          "Violet",
          "Violeta",
          "Violette",
          "Virgen",
          "Virgie",
          "Virgil",
          "Virgina",
          "Virginia",
          "Vita",
          "Viva",
          "Vivan",
          "Vivian",
          "Viviana",
          "Vivien",
          "Vivienne",
          "Voncile",
          "Vonda",
          "Vonnie",
          "Wai",
          "Walter",
          "Waltraud",
          "Wan",
          "Wanda",
          "Waneta",
          "Wanetta",
          "Wanita",
          "Wava",
          "Wei",
          "Wen",
          "Wendi",
          "Wendie",
          "Wendolyn",
          "Wendy",
          "Wenona",
          "Wesley",
          "Whitley",
          "Whitney",
          "Wilda",
          "Wilhelmina",
          "Wilhemina",
          "Willa",
          "Willena",
          "Willene",
          "Willetta",
          "Willette",
          "Willia",
          "William",
          "Willie",
          "Williemae",
          "Willodean",
          "Willow",
          "Wilma",
          "Windy",
          "Winifred",
          "Winnie",
          "Winnifred",
          "Winona",
          "Winter",
          "Wonda",
          "Wynell",
          "Wynona",
          "Xenia",
          "Xiao",
          "Xiomara",
          "Xochitl",
          "Xuan",
          "Yadira",
          "Yaeko",
          "Yael",
          "Yahaira",
          "Yajaira",
          "Yan",
          "Yang",
          "Yanira",
          "Yasmin",
          "Yasmine",
          "Yasuko",
          "Yee",
          "Yelena",
          "Yen",
          "Yer",
          "Yesenia",
          "Yessenia",
          "Yetta",
          "Yevette",
          "Yi",
          "Ying",
          "Yoko",
          "Yolanda",
          "Yolande",
          "Yolando",
          "Yolonda",
          "Yon",
          "Yong",
          "Yoshie",
          "Yoshiko",
          "Youlanda",
          "Young",
          "Yu",
          "Yuette",
          "Yuk",
          "Yuki",
          "Yukiko",
          "Yuko",
          "Yulanda",
          "Yun",
          "Yung",
          "Yuonne",
          "Yuri",
          "Yuriko",
          "Yvette",
          "Yvone",
          "Yvonne",
          "Zada",
          "Zaida",
          "Zana",
          "Zandra",
          "Zelda",
          "Zella",
          "Zelma",
          "Zena",
          "Zenaida",
          "Zenia",
          "Zenobia",
          "Zetta",
          "Zina",
          "Zita",
          "Zoe",
          "Zofia",
          "Zoila",
          "Zola",
          "Zona",
          "Zonia",
          "Zora",
          "Zoraida",
          "Zula",
          "Zulema",
          "Zulma"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Abbott",
          "Abernathy",
          "Abshire",
          "Adams",
          "Altenwerth",
          "Anderson",
          "Ankunding",
          "Armstrong",
          "Auer",
          "Aufderhar",
          "Bahringer",
          "Bailey",
          "Balistreri",
          "Barrows",
          "Bartell",
          "Bartoletti",
          "Barton",
          "Bashirian",
          "Batz",
          "Bauch",
          "Baumbach",
          "Bayer",
          "Beahan",
          "Beatty",
          "Bechtelar",
          "Becker",
          "Bednar",
          "Beer",
          "Beier",
          "Berge",
          "Bergnaum",
          "Bergstrom",
          "Bernhard",
          "Bernier",
          "Bins",
          "Blanda",
          "Blick",
          "Block",
          "Bode",
          "Boehm",
          "Bogan",
          "Bogisich",
          "Borer",
          "Bosco",
          "Botsford",
          "Boyer",
          "Boyle",
          "Bradtke",
          "Brakus",
          "Braun",
          "Breitenberg",
          "Brekke",
          "Brown",
          "Bruen",
          "Buckridge",
          "Carroll",
          "Carter",
          "Cartwright",
          "Casper",
          "Cassin",
          "Champlin",
          "Christiansen",
          "Cole",
          "Collier",
          "Collins",
          "Conn",
          "Connelly",
          "Conroy",
          "Considine",
          "Corkery",
          "Cormier",
          "Corwin",
          "Cremin",
          "Crist",
          "Crona",
          "Cronin",
          "Crooks",
          "Cruickshank",
          "Cummerata",
          "Cummings",
          "Dach",
          "D'Amore",
          "Daniel",
          "Dare",
          "Daugherty",
          "Davis",
          "Deckow",
          "Denesik",
          "Dibbert",
          "Dickens",
          "Dicki",
          "Dickinson",
          "Dietrich",
          "Donnelly",
          "Dooley",
          "Douglas",
          "Doyle",
          "DuBuque",
          "Durgan",
          "Ebert",
          "Effertz",
          "Emard",
          "Emmerich",
          "Erdman",
          "Ernser",
          "Fadel",
          "Fahey",
          "Farrell",
          "Fay",
          "Feeney",
          "Feest",
          "Feil",
          "Ferry",
          "Fisher",
          "Flatley",
          "Frami",
          "Franecki",
          "Friesen",
          "Fritsch",
          "Funk",
          "Gerhold",
          "Gerlach",
          "Gibson",
          "Gislason",
          "Gleason",
          "Gleichner",
          "Glover",
          "Goldner",
          "Goodwin",
          "Gorczany",
          "Gottlieb",
          "Goyette",
          "Grady",
          "Graham",
          "Grant",
          "Green",
          "Greenfelder",
          "Greenholt",
          "Grimes",
          "Gulgowski",
          "Gusikowski",
          "Gutkowski",
          "Gutmann",
          "Haag",
          "Hackett",
          "Hagenes",
          "Hahn",
          "Haley",
          "Halvorson",
          "Hamill",
          "Hammes",
          "Hand",
          "Hane",
          "Hansen",
          "Harber",
          "Harris",
          "Hartmann",
          "Harvey",
          "Hauck",
          "Hayes",
          "Heaney",
          "Heathcote",
          "Hegmann",
          "Heidenreich",
          "Heller",
          "Herman",
          "Hermann",
          "Hermiston",
          "Herzog",
          "Hessel",
          "Hettinger",
          "Hickle",
          "Hilll",
          "Hills",
          "Hilpert",
          "Hintz",
          "Hirthe",
          "Hodkiewicz",
          "Hoeger",
          "Homenick",
          "Hoppe",
          "Howe",
          "Howell",
          "Hudson",
          "Huel",
          "Huels",
          "Hyatt",
          "Jacobi",
          "Jacobs",
          "Jacobson",
          "Jakubowski",
          "Jaskolski",
          "Jast",
          "Jenkins",
          "Jerde",
          "Johns",
          "Johnson",
          "Johnston",
          "Jones",
          "Kassulke",
          "Kautzer",
          "Keebler",
          "Keeling",
          "Kemmer",
          "Kerluke",
          "Kertzmann",
          "Kessler",
          "Kiehn",
          "Kihn",
          "Kilback",
          "King",
          "Kirlin",
          "Klein",
          "Kling",
          "Klocko",
          "Koch",
          "Koelpin",
          "Koepp",
          "Kohler",
          "Konopelski",
          "Koss",
          "Kovacek",
          "Kozey",
          "Krajcik",
          "Kreiger",
          "Kris",
          "Kshlerin",
          "Kub",
          "Kuhic",
          "Kuhlman",
          "Kuhn",
          "Kulas",
          "Kunde",
          "Kunze",
          "Kuphal",
          "Kutch",
          "Kuvalis",
          "Labadie",
          "Lakin",
          "Lang",
          "Langosh",
          "Langworth",
          "Larkin",
          "Larson",
          "Leannon",
          "Lebsack",
          "Ledner",
          "Leffler",
          "Legros",
          "Lehner",
          "Lemke",
          "Lesch",
          "Leuschke",
          "Lind",
          "Lindgren",
          "Littel",
          "Little",
          "Lockman",
          "Lowe",
          "Lubowitz",
          "Lueilwitz",
          "Luettgen",
          "Lynch",
          "Macejkovic",
          "MacGyver",
          "Maggio",
          "Mann",
          "Mante",
          "Marks",
          "Marquardt",
          "Marvin",
          "Mayer",
          "Mayert",
          "McClure",
          "McCullough",
          "McDermott",
          "McGlynn",
          "McKenzie",
          "McLaughlin",
          "Medhurst",
          "Mertz",
          "Metz",
          "Miller",
          "Mills",
          "Mitchell",
          "Moen",
          "Mohr",
          "Monahan",
          "Moore",
          "Morar",
          "Morissette",
          "Mosciski",
          "Mraz",
          "Mueller",
          "Muller",
          "Murazik",
          "Murphy",
          "Murray",
          "Nader",
          "Nicolas",
          "Nienow",
          "Nikolaus",
          "Nitzsche",
          "Nolan",
          "Oberbrunner",
          "O'Connell",
          "O'Conner",
          "O'Hara",
          "O'Keefe",
          "O'Kon",
          "Okuneva",
          "Olson",
          "Ondricka",
          "O'Reilly",
          "Orn",
          "Ortiz",
          "Osinski",
          "Pacocha",
          "Padberg",
          "Pagac",
          "Parisian",
          "Parker",
          "Paucek",
          "Pfannerstill",
          "Pfeffer",
          "Pollich",
          "Pouros",
          "Powlowski",
          "Predovic",
          "Price",
          "Prohaska",
          "Prosacco",
          "Purdy",
          "Quigley",
          "Quitzon",
          "Rath",
          "Ratke",
          "Rau",
          "Raynor",
          "Reichel",
          "Reichert",
          "Reilly",
          "Reinger",
          "Rempel",
          "Renner",
          "Reynolds",
          "Rice",
          "Rippin",
          "Ritchie",
          "Robel",
          "Roberts",
          "Rodriguez",
          "Rogahn",
          "Rohan",
          "Rolfson",
          "Romaguera",
          "Roob",
          "Rosenbaum",
          "Rowe",
          "Ruecker",
          "Runolfsdottir",
          "Runolfsson",
          "Runte",
          "Russel",
          "Rutherford",
          "Ryan",
          "Sanford",
          "Satterfield",
          "Sauer",
          "Sawayn",
          "Schaden",
          "Schaefer",
          "Schamberger",
          "Schiller",
          "Schimmel",
          "Schinner",
          "Schmeler",
          "Schmidt",
          "Schmitt",
          "Schneider",
          "Schoen",
          "Schowalter",
          "Schroeder",
          "Schulist",
          "Schultz",
          "Schumm",
          "Schuppe",
          "Schuster",
          "Senger",
          "Shanahan",
          "Shields",
          "Simonis",
          "Sipes",
          "Skiles",
          "Smith",
          "Smitham",
          "Spencer",
          "Spinka",
          "Sporer",
          "Stamm",
          "Stanton",
          "Stark",
          "Stehr",
          "Steuber",
          "Stiedemann",
          "Stokes",
          "Stoltenberg",
          "Stracke",
          "Streich",
          "Stroman",
          "Strosin",
          "Swaniawski",
          "Swift",
          "Terry",
          "Thiel",
          "Thompson",
          "Tillman",
          "Torp",
          "Torphy",
          "Towne",
          "Toy",
          "Trantow",
          "Tremblay",
          "Treutel",
          "Tromp",
          "Turcotte",
          "Turner",
          "Ullrich",
          "Upton",
          "Vandervort",
          "Veum",
          "Volkman",
          "Von",
          "VonRueden",
          "Waelchi",
          "Walker",
          "Walsh",
          "Walter",
          "Ward",
          "Waters",
          "Watsica",
          "Weber",
          "Wehner",
          "Weimann",
          "Weissnat",
          "Welch",
          "West",
          "White",
          "Wiegand",
          "Wilderman",
          "Wilkinson",
          "Will",
          "Williamson",
          "Willms",
          "Windler",
          "Wintheiser",
          "Wisoky",
          "Wisozk",
          "Witting",
          "Wiza",
          "Wolf",
          "Wolff",
          "Wuckert",
          "Wunsch",
          "Wyman",
          "Yost",
          "Yundt",
          "Zboncak",
          "Zemlak",
          "Ziemann",
          "Zieme",
          "Zulauf"
        ],
        "male_first_name": [
          "Aaron",
          "Abdul",
          "Abe",
          "Abel",
          "Abraham",
          "Abram",
          "Adalberto",
          "Adam",
          "Adan",
          "Adolfo",
          "Adolph",
          "Adrian",
          "Agustin",
          "Ahmad",
          "Ahmed",
          "Al",
          "Alan",
          "Albert",
          "Alberto",
          "Alden",
          "Aldo",
          "Alec",
          "Alejandro",
          "Alex",
          "Alexander",
          "Alexis",
          "Alfonso",
          "Alfonzo",
          "Alfred",
          "Alfredo",
          "Ali",
          "Allan",
          "Allen",
          "Alonso",
          "Alonzo",
          "Alphonse",
          "Alphonso",
          "Alton",
          "Alva",
          "Alvaro",
          "Alvin",
          "Amado",
          "Ambrose",
          "Amos",
          "Anderson",
          "Andre",
          "Andrea",
          "Andreas",
          "Andres",
          "Andrew",
          "Andy",
          "Angel",
          "Angelo",
          "Anibal",
          "Anthony",
          "Antione",
          "Antoine",
          "Anton",
          "Antone",
          "Antonia",
          "Antonio",
          "Antony",
          "Antwan",
          "Archie",
          "Arden",
          "Ariel",
          "Arlen",
          "Arlie",
          "Armand",
          "Armando",
          "Arnold",
          "Arnoldo",
          "Arnulfo",
          "Aron",
          "Arron",
          "Art",
          "Arthur",
          "Arturo",
          "Asa",
          "Ashley",
          "Aubrey",
          "August",
          "Augustine",
          "Augustus",
          "Aurelio",
          "Austin",
          "Avery",
          "Barney",
          "Barrett",
          "Barry",
          "Bart",
          "Barton",
          "Basil",
          "Beau",
          "Ben",
          "Benedict",
          "Benito",
          "Benjamin",
          "Bennett",
          "Bennie",
          "Benny",
          "Benton",
          "Bernard",
          "Bernardo",
          "Bernie",
          "Berry",
          "Bert",
          "Bertram",
          "Bill",
          "Billie",
          "Billy",
          "Blaine",
          "Blair",
          "Blake",
          "Bo",
          "Bob",
          "Bobbie",
          "Bobby",
          "Booker",
          "Boris",
          "Boyce",
          "Boyd",
          "Brad",
          "Bradford",
          "Bradley",
          "Bradly",
          "Brady",
          "Brain",
          "Branden",
          "Brandon",
          "Brant",
          "Brendan",
          "Brendon",
          "Brent",
          "Brenton",
          "Bret",
          "Brett",
          "Brian",
          "Brice",
          "Britt",
          "Brock",
          "Broderick",
          "Brooks",
          "Bruce",
          "Bruno",
          "Bryan",
          "Bryant",
          "Bryce",
          "Bryon",
          "Buck",
          "Bud",
          "Buddy",
          "Buford",
          "Burl",
          "Burt",
          "Burton",
          "Buster",
          "Byron",
          "Caleb",
          "Calvin",
          "Cameron",
          "Carey",
          "Carl",
          "Carlo",
          "Carlos",
          "Carlton",
          "Carmelo",
          "Carmen",
          "Carmine",
          "Carol",
          "Carrol",
          "Carroll",
          "Carson",
          "Carter",
          "Cary",
          "Casey",
          "Cecil",
          "Cedric",
          "Cedrick",
          "Cesar",
          "Chad",
          "Chadwick",
          "Chance",
          "Chang",
          "Charles",
          "Charley",
          "Charlie",
          "Chas",
          "Chase",
          "Chauncey",
          "Chester",
          "Chet",
          "Chi",
          "Chong",
          "Chris",
          "Christian",
          "Christoper",
          "Christopher",
          "Chuck",
          "Chung",
          "Clair",
          "Clarence",
          "Clark",
          "Claud",
          "Claude",
          "Claudio",
          "Clay",
          "Clayton",
          "Clement",
          "Clemente",
          "Cleo",
          "Cletus",
          "Cleveland",
          "Cliff",
          "Clifford",
          "Clifton",
          "Clint",
          "Clinton",
          "Clyde",
          "Cody",
          "Colby",
          "Cole",
          "Coleman",
          "Colin",
          "Collin",
          "Colton",
          "Columbus",
          "Connie",
          "Conrad",
          "Cordell",
          "Corey",
          "Cornelius",
          "Cornell",
          "Cortez",
          "Cory",
          "Courtney",
          "Coy",
          "Craig",
          "Cristobal",
          "Cristopher",
          "Cruz",
          "Curt",
          "Curtis",
          "Cyril",
          "Cyrus",
          "Dale",
          "Dallas",
          "Dalton",
          "Damian",
          "Damien",
          "Damion",
          "Damon",
          "Dan",
          "Dana",
          "Dane",
          "Danial",
          "Daniel",
          "Danilo",
          "Dannie",
          "Danny",
          "Dante",
          "Darell",
          "Daren",
          "Darin",
          "Dario",
          "Darius",
          "Darnell",
          "Daron",
          "Darrel",
          "Darrell",
          "Darren",
          "Darrick",
          "Darrin",
          "Darron",
          "Darryl",
          "Darwin",
          "Daryl",
          "Dave",
          "David",
          "Davis",
          "Dean",
          "Deandre",
          "Deangelo",
          "Dee",
          "Del",
          "Delbert",
          "Delmar",
          "Delmer",
          "Demarcus",
          "Demetrius",
          "Denis",
          "Dennis",
          "Denny",
          "Denver",
          "Deon",
          "Derek",
          "Derick",
          "Derrick",
          "Deshawn",
          "Desmond",
          "Devin",
          "Devon",
          "Dewayne",
          "Dewey",
          "Dewitt",
          "Dexter",
          "Dick",
          "Diego",
          "Dillon",
          "Dino",
          "Dion",
          "Dirk",
          "Domenic",
          "Domingo",
          "Dominic",
          "Dominick",
          "Dominique",
          "Don",
          "Donald",
          "Dong",
          "Donn",
          "Donnell",
          "Donnie",
          "Donny",
          "Donovan",
          "Donte",
          "Dorian",
          "Dorsey",
          "Doug",
          "Douglas",
          "Douglass",
          "Doyle",
          "Drew",
          "Duane",
          "Dudley",
          "Duncan",
          "Dustin",
          "Dusty",
          "Dwain",
          "Dwayne",
          "Dwight",
          "Dylan",
          "Earl",
          "Earle",
          "Earnest",
          "Ed",
          "Eddie",
          "Eddy",
          "Edgar",
          "Edgardo",
          "Edison",
          "Edmond",
          "Edmund",
          "Edmundo",
          "Eduardo",
          "Edward",
          "Edwardo",
          "Edwin",
          "Efrain",
          "Efren",
          "Elbert",
          "Elden",
          "Eldon",
          "Eldridge",
          "Eli",
          "Elias",
          "Elijah",
          "Eliseo",
          "Elisha",
          "Elliot",
          "Elliott",
          "Ellis",
          "Ellsworth",
          "Elmer",
          "Elmo",
          "Eloy",
          "Elroy",
          "Elton",
          "Elvin",
          "Elvis",
          "Elwood",
          "Emanuel",
          "Emerson",
          "Emery",
          "Emil",
          "Emile",
          "Emilio",
          "Emmanuel",
          "Emmett",
          "Emmitt",
          "Emory",
          "Enoch",
          "Enrique",
          "Erasmo",
          "Eric",
          "Erich",
          "Erick",
          "Erik",
          "Erin",
          "Ernest",
          "Ernesto",
          "Ernie",
          "Errol",
          "Ervin",
          "Erwin",
          "Esteban",
          "Ethan",
          "Eugene",
          "Eugenio",
          "Eusebio",
          "Evan",
          "Everett",
          "Everette",
          "Ezekiel",
          "Ezequiel",
          "Ezra",
          "Fabian",
          "Faustino",
          "Fausto",
          "Federico",
          "Felipe",
          "Felix",
          "Felton",
          "Ferdinand",
          "Fermin",
          "Fernando",
          "Fidel",
          "Filiberto",
          "Fletcher",
          "Florencio",
          "Florentino",
          "Floyd",
          "Forest",
          "Forrest",
          "Foster",
          "Frances",
          "Francesco",
          "Francis",
          "Francisco",
          "Frank",
          "Frankie",
          "Franklin",
          "Franklyn",
          "Fred",
          "Freddie",
          "Freddy",
          "Frederic",
          "Frederick",
          "Fredric",
          "Fredrick",
          "Freeman",
          "Fritz",
          "Gabriel",
          "Gail",
          "Gale",
          "Galen",
          "Garfield",
          "Garland",
          "Garret",
          "Garrett",
          "Garry",
          "Garth",
          "Gary",
          "Gaston",
          "Gavin",
          "Gayle",
          "Genaro",
          "Gene",
          "Geoffrey",
          "George",
          "Gerald",
          "Geraldo",
          "Gerard",
          "Gerardo",
          "German",
          "Gerry",
          "Gil",
          "Gilbert",
          "Gilberto",
          "Gino",
          "Giovanni",
          "Giuseppe",
          "Glen",
          "Glenn",
          "Gonzalo",
          "Gordon",
          "Grady",
          "Graham",
          "Graig",
          "Grant",
          "Granville",
          "Greg",
          "Gregg",
          "Gregorio",
          "Gregory",
          "Grover",
          "Guadalupe",
          "Guillermo",
          "Gus",
          "Gustavo",
          "Guy",
          "Hai",
          "Hal",
          "Hank",
          "Hans",
          "Harlan",
          "Harland",
          "Harley",
          "Harold",
          "Harris",
          "Harrison",
          "Harry",
          "Harvey",
          "Hassan",
          "Hayden",
          "Haywood",
          "Heath",
          "Hector",
          "Henry",
          "Herb",
          "Herbert",
          "Heriberto",
          "Herman",
          "Herschel",
          "Hershel",
          "Hilario",
          "Hilton",
          "Hipolito",
          "Hiram",
          "Hobert",
          "Hollis",
          "Homer",
          "Hong",
          "Horace",
          "Horacio",
          "Hosea",
          "Houston",
          "Howard",
          "Hoyt",
          "Hubert",
          "Huey",
          "Hugh",
          "Hugo",
          "Humberto",
          "Hung",
          "Hunter",
          "Hyman",
          "Ian",
          "Ignacio",
          "Ike",
          "Ira",
          "Irvin",
          "Irving",
          "Irwin",
          "Isaac",
          "Isaiah",
          "Isaias",
          "Isiah",
          "Isidro",
          "Ismael",
          "Israel",
          "Isreal",
          "Issac",
          "Ivan",
          "Ivory",
          "Jacinto",
          "Jack",
          "Jackie",
          "Jackson",
          "Jacob",
          "Jacques",
          "Jae",
          "Jaime",
          "Jake",
          "Jamaal",
          "Jamal",
          "Jamar",
          "Jame",
          "Jamel",
          "James",
          "Jamey",
          "Jamie",
          "Jamison",
          "Jan",
          "Jared",
          "Jarod",
          "Jarred",
          "Jarrett",
          "Jarrod",
          "Jarvis",
          "Jason",
          "Jasper",
          "Javier",
          "Jay",
          "Jayson",
          "Jc",
          "Jean",
          "Jed",
          "Jeff",
          "Jefferey",
          "Jefferson",
          "Jeffery",
          "Jeffrey",
          "Jeffry",
          "Jerald",
          "Jeramy",
          "Jere",
          "Jeremiah",
          "Jeremy",
          "Jermaine",
          "Jerold",
          "Jerome",
          "Jeromy",
          "Jerrell",
          "Jerrod",
          "Jerrold",
          "Jerry",
          "Jess",
          "Jesse",
          "Jessie",
          "Jesus",
          "Jewel",
          "Jewell",
          "Jim",
          "Jimmie",
          "Jimmy",
          "Joan",
          "Joaquin",
          "Jody",
          "Joe",
          "Joel",
          "Joesph",
          "Joey",
          "John",
          "Johnathan",
          "Johnathon",
          "Johnie",
          "Johnnie",
          "Johnny",
          "Johnson",
          "Jon",
          "Jonah",
          "Jonas",
          "Jonathan",
          "Jonathon",
          "Jordan",
          "Jordon",
          "Jorge",
          "Jose",
          "Josef",
          "Joseph",
          "Josh",
          "Joshua",
          "Josiah",
          "Jospeh",
          "Josue",
          "Juan",
          "Jude",
          "Judson",
          "Jules",
          "Julian",
          "Julio",
          "Julius",
          "Junior",
          "Justin",
          "Kareem",
          "Karl",
          "Kasey",
          "Keenan",
          "Keith",
          "Kelley",
          "Kelly",
          "Kelvin",
          "Ken",
          "Kendall",
          "Kendrick",
          "Keneth",
          "Kenneth",
          "Kennith",
          "Kenny",
          "Kent",
          "Kenton",
          "Kermit",
          "Kerry",
          "Keven",
          "Kevin",
          "Kieth",
          "Kim",
          "King",
          "Kip",
          "Kirby",
          "Kirk",
          "Korey",
          "Kory",
          "Kraig",
          "Kris",
          "Kristofer",
          "Kristopher",
          "Kurt",
          "Kurtis",
          "Kyle",
          "Lacy",
          "Lamar",
          "Lamont",
          "Lance",
          "Landon",
          "Lane",
          "Lanny",
          "Larry",
          "Lauren",
          "Laurence",
          "Lavern",
          "Laverne",
          "Lawerence",
          "Lawrence",
          "Lazaro",
          "Leandro",
          "Lee",
          "Leif",
          "Leigh",
          "Leland",
          "Lemuel",
          "Len",
          "Lenard",
          "Lenny",
          "Leo",
          "Leon",
          "Leonard",
          "Leonardo",
          "Leonel",
          "Leopoldo",
          "Leroy",
          "Les",
          "Lesley",
          "Leslie",
          "Lester",
          "Levi",
          "Lewis",
          "Lincoln",
          "Lindsay",
          "Lindsey",
          "Lino",
          "Linwood",
          "Lionel",
          "Lloyd",
          "Logan",
          "Lon",
          "Long",
          "Lonnie",
          "Lonny",
          "Loren",
          "Lorenzo",
          "Lou",
          "Louie",
          "Louis",
          "Lowell",
          "Loyd",
          "Lucas",
          "Luciano",
          "Lucien",
          "Lucio",
          "Lucius",
          "Luigi",
          "Luis",
          "Luke",
          "Lupe",
          "Luther",
          "Lyle",
          "Lyman",
          "Lyndon",
          "Lynn",
          "Lynwood",
          "Mac",
          "Mack",
          "Major",
          "Malcolm",
          "Malcom",
          "Malik",
          "Man",
          "Manual",
          "Manuel",
          "Marc",
          "Marcel",
          "Marcelino",
          "Marcellus",
          "Marcelo",
          "Marco",
          "Marcos",
          "Marcus",
          "Margarito",
          "Maria",
          "Mariano",
          "Mario",
          "Marion",
          "Mark",
          "Markus",
          "Marlin",
          "Marlon",
          "Marquis",
          "Marshall",
          "Martin",
          "Marty",
          "Marvin",
          "Mary",
          "Mason",
          "Mathew",
          "Matt",
          "Matthew",
          "Maurice",
          "Mauricio",
          "Mauro",
          "Max",
          "Maximo",
          "Maxwell",
          "Maynard",
          "Mckinley",
          "Mel",
          "Melvin",
          "Merle",
          "Merlin",
          "Merrill",
          "Mervin",
          "Micah",
          "Michael",
          "Michal",
          "Michale",
          "Micheal",
          "Michel",
          "Mickey",
          "Miguel",
          "Mike",
          "Mikel",
          "Milan",
          "Miles",
          "Milford",
          "Millard",
          "Milo",
          "Milton",
          "Minh",
          "Miquel",
          "Mitch",
          "Mitchel",
          "Mitchell",
          "Modesto",
          "Mohamed",
          "Mohammad",
          "Mohammed",
          "Moises",
          "Monroe",
          "Monte",
          "Monty",
          "Morgan",
          "Morris",
          "Morton",
          "Mose",
          "Moses",
          "Moshe",
          "Murray",
          "Myles",
          "Myron",
          "Napoleon",
          "Nathan",
          "Nathanael",
          "Nathanial",
          "Nathaniel",
          "Neal",
          "Ned",
          "Neil",
          "Nelson",
          "Nestor",
          "Neville",
          "Newton",
          "Nicholas",
          "Nick",
          "Nickolas",
          "Nicky",
          "Nicolas",
          "Nigel",
          "Noah",
          "Noble",
          "Noe",
          "Noel",
          "Nolan",
          "Norbert",
          "Norberto",
          "Norman",
          "Normand",
          "Norris",
          "Numbers",
          "Octavio",
          "Odell",
          "Odis",
          "Olen",
          "Olin",
          "Oliver",
          "Ollie",
          "Omar",
          "Omer",
          "Oren",
          "Orlando",
          "Orval",
          "Orville",
          "Oscar",
          "Osvaldo",
          "Oswaldo",
          "Otha",
          "Otis",
          "Otto",
          "Owen",
          "Ozzie",
          "Pablo",
          "Palmer",
          "Paris",
          "Parker",
          "Pasquale",
          "Pat",
          "Patricia",
          "Patrick",
          "Paul",
          "Pedro",
          "Percy",
          "Perry",
          "Pete",
          "Peter",
          "Phil",
          "Philip",
          "Phillip",
          "Pierre",
          "Porfirio",
          "Porter",
          "Preston",
          "Prince",
          "Quentin",
          "Quincy",
          "Quinn",
          "Quintin",
          "Quinton",
          "Rafael",
          "Raleigh",
          "Ralph",
          "Ramiro",
          "Ramon",
          "Randal",
          "Randall",
          "Randell",
          "Randolph",
          "Randy",
          "Raphael",
          "Rashad",
          "Raul",
          "Ray",
          "Rayford",
          "Raymon",
          "Raymond",
          "Raymundo",
          "Reed",
          "Refugio",
          "Reggie",
          "Reginald",
          "Reid",
          "Reinaldo",
          "Renaldo",
          "Renato",
          "Rene",
          "Reuben",
          "Rex",
          "Rey",
          "Reyes",
          "Reynaldo",
          "Rhett",
          "Ricardo",
          "Rich",
          "Richard",
          "Richie",
          "Rick",
          "Rickey",
          "Rickie",
          "Ricky",
          "Rico",
          "Rigoberto",
          "Riley",
          "Rob",
          "Robbie",
          "Robby",
          "Robert",
          "Roberto",
          "Robin",
          "Robt",
          "Rocco",
          "Rocky",
          "Rod",
          "Roderick",
          "Rodger",
          "Rodney",
          "Rodolfo",
          "Rodrick",
          "Rodrigo",
          "Rogelio",
          "Roger",
          "Roland",
          "Rolando",
          "Rolf",
          "Rolland",
          "Roman",
          "Romeo",
          "Ron",
          "Ronald",
          "Ronnie",
          "Ronny",
          "Roosevelt",
          "Rory",
          "Rosario",
          "Roscoe",
          "Rosendo",
          "Ross",
          "Roy",
          "Royal",
          "Royce",
          "Ruben",
          "Rubin",
          "Rudolf",
          "Rudolph",
          "Rudy",
          "Rueben",
          "Rufus",
          "Rupert",
          "Russ",
          "Russel",
          "Russell",
          "Rusty",
          "Ryan",
          "Sal",
          "Salvador",
          "Salvatore",
          "Sam",
          "Sammie",
          "Sammy",
          "Samual",
          "Samuel",
          "Sandy",
          "Sanford",
          "Sang",
          "Santiago",
          "Santo",
          "Santos",
          "Saul",
          "Scot",
          "Scott",
          "Scottie",
          "Scotty",
          "Sean",
          "Sebastian",
          "Sergio",
          "Seth",
          "Seymour",
          "Shad",
          "Shane",
          "Shannon",
          "Shaun",
          "Shawn",
          "Shayne",
          "Shelby",
          "Sheldon",
          "Shelton",
          "Sherman",
          "Sherwood",
          "Shirley",
          "Shon",
          "Sid",
          "Sidney",
          "Silas",
          "Simon",
          "Sol",
          "Solomon",
          "Son",
          "Sonny",
          "Spencer",
          "Stacey",
          "Stacy",
          "Stan",
          "Stanford",
          "Stanley",
          "Stanton",
          "Stefan",
          "Stephan",
          "Stephen",
          "Sterling",
          "Steve",
          "Steven",
          "Stevie",
          "Stewart",
          "Stuart",
          "Sung",
          "Sydney",
          "Sylvester",
          "Tad",
          "Tanner",
          "Taylor",
          "Ted",
          "Teddy",
          "Teodoro",
          "Terence",
          "Terrance",
          "Terrell",
          "Terrence",
          "Terry",
          "Thad",
          "Thaddeus",
          "Thanh",
          "Theo",
          "Theodore",
          "Theron",
          "Thomas",
          "Thurman",
          "Tim",
          "Timmy",
          "Timothy",
          "Titus",
          "Tobias",
          "Toby",
          "Tod",
          "Todd",
          "Tom",
          "Tomas",
          "Tommie",
          "Tommy",
          "Toney",
          "Tony",
          "Tory",
          "Tracey",
          "Tracy",
          "Travis",
          "Trent",
          "Trenton",
          "Trevor",
          "Trey",
          "Trinidad",
          "Tristan",
          "Troy",
          "Truman",
          "Tuan",
          "Ty",
          "Tyler",
          "Tyree",
          "Tyrell",
          "Tyron",
          "Tyrone",
          "Tyson",
          "Ulysses",
          "Val",
          "Valentin",
          "Valentine",
          "Van",
          "Vance",
          "Vaughn",
          "Vern",
          "Vernon",
          "Vicente",
          "Victor",
          "Vince",
          "Vincent",
          "Vincenzo",
          "Virgil",
          "Virgilio",
          "Vito",
          "Von",
          "Wade",
          "Waldo",
          "Walker",
          "Wallace",
          "Wally",
          "Walter",
          "Walton",
          "Ward",
          "Warner",
          "Warren",
          "Waylon",
          "Wayne",
          "Weldon",
          "Wendell",
          "Werner",
          "Wes",
          "Wesley",
          "Weston",
          "Whitney",
          "Wilber",
          "Wilbert",
          "Wilbur",
          "Wilburn",
          "Wiley",
          "Wilford",
          "Wilfred",
          "Wilfredo",
          "Will",
          "Willard",
          "William",
          "Williams",
          "Willian",
          "Willie",
          "Willis",
          "Willy",
          "Wilmer",
          "Wilson",
          "Wilton",
          "Winford",
          "Winfred",
          "Winston",
          "Wm",
          "Woodrow",
          "Wyatt",
          "Xavier",
          "Yong",
          "Young",
          "Zachariah",
          "Zachary",
          "Zachery",
          "Zack",
          "Zackary",
          "Zane"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "neutral_first_name": [
          "Alexis",
          "Ari",
          "Armani",
          "Avery",
          "Azariah",
          "Baylor",
          "Bellamy",
          "Blake",
          "Briar",
          "Brooklyn",
          "Cameron",
          "Campbell",
          "Casey",
          "Charlie",
          "Corey",
          "Dakota",
          "Dallas",
          "Denver",
          "Drew",
          "Dylan",
          "Emerson",
          "Emerson",
          "Emery",
          "Finley",
          "Frankie",
          "Gray",
          "Greer",
          "Haven",
          "Hayden",
          "Indigo",
          "Jordan",
          "Justice",
          "Landry",
          "Lennon",
          "Lennox",
          "Marion",
          "Max",
          "Morgan",
          "Oakley",
          "Onyx",
          "Parker",
          "Peyton",
          "Phoenix",
          "Quinn",
          "Reese",
          "Riley",
          "River",
          "River",
          "Robin",
          "Rory",
          "Rowan",
          "Royal",
          "Ryan",
          "Sam",
          "Sawyer",
          "Shae",
          "Shiloh",
          "Skyler",
          "Spencer",
          "Stevie",
          "Story",
          "Sutton",
          "Tatum",
          "Tatum",
          "Tyler",
          "Zion"
        ],
        "prefix": [
          "Mr.",
          "Mrs.",
          "Ms.",
          "Miss",
          "Dr.",
          "Rev.",
          "Fr.",
          "Gov.",
          "Rep.",
          "Prof.",
          "Sen.",
          "The Hon.",
          "Pres.",
          "Msgr.",
          "Amb."
        ],
        "suffix": [
          "Jr.",
          "Sr.",
          "I",
          "II",
          "III",
          "IV",
          "V",
          "MD",
          "DDS",
          "PhD",
          "DVM",
          "Esq.",
          "CPA",
          "DC",
          "VM",
          "JD",
          "LLD",
          "Ret.",
          "DO"
        ]
      },
      "naruto": {
        "characters": [
          "Naruto Uzumaki",
          "Kakashi Hatake",
          "Sasuke Uchiha",
          "Minato Namikaze",
          "Obito Uchiha",
          "Itachi Uchiha",
          "Abiru",
          "Agara",
          "Agari",
          "Agari Kaisen",
          "Ageha",
          "Agira Ryūdōin",
          "Ahiko",
          "Aho Bird",
          "Aino",
          "Ajisai",
          "Akaboshi",
          "Akahoshi",
          "Akamaru",
          "Akane",
          "Akane (Kunoichi)",
          "Akane's Father",
          "Akari Tatsushiro",
          "Akatsuchi",
          "Akemaru",
          "Akino",
          "Akio",
          "Akita Inuzuka",
          "Akkun",
          "Amachi",
          "Amado",
          "Amagi",
          "Amai",
          "Amaru",
          "Amayo",
          "Ameno",
          "Ameyuki",
          "Ameyuri Ringo",
          "Ami",
          "Amino",
          "Amuda",
          "Anato",
          "Anbu Commander",
          "Aniki",
          "Anko Mitarashi",
          "Ao",
          "Aoba Yamashiro",
          "Aoda",
          "Aoi (game)",
          "Aoi Rokushō",
          "Aoneko",
          "Arai",
          "Arashi",
          "Arashi Umeya",
          "Araya",
          "Armadiko",
          "Asaka",
          "Asaki",
          "Asami",
          "Ashimaru",
          "Ashina",
          "Ashina Uzumaki",
          "Ashitaba",
          "Asuma Sarutobi",
          "Asura Path (character)",
          "Asura Ōtsutsuki",
          "Atsui",
          "Ayame",
          "Azami",
          "Azure Fang",
          "Baiu",
          "Baji",
          "Baki",
          "Baku",
          "Baku (Anbu)",
          "Bakuto",
          "Bando",
          "Bandō",
          "Banna",
          "Bansai",
          "Baraki",
          "Baru Uchiha",
          "Beekeeper",
          "Bekkō",
          "Benga",
          "Benten",
          "Bird-Masked Anbu Member",
          "Bisuke",
          "Biwako Sarutobi",
          "Black Shadow",
          "Black Zetsu",
          "Blue B",
          "Boar-Masked Anbu Member",
          "Boro",
          "Boruto Uzumaki",
          "Boxing Kangaroos",
          "Breeze Dancer",
          "Bull",
          "Buna",
          "Bunpuku",
          "Buntan Kurosuki",
          "Bunzō",
          "Burami",
          "Buriko Nekoka",
          "Butsuma Senju",
          "Byakuren",
          "Captain of the Ghost Ship",
          "Chamaru",
          "Chamū",
          "Chen",
          "Chibi",
          "Chichiatsu",
          "Chikara",
          "Chino",
          "Chiriku",
          "Chishima",
          "Chiyo",
          "Chiyo (princess)",
          "Chiyomatsu",
          "Chōbee Akimichi",
          "Chōchō Akimichi",
          "Chōhan",
          "Chōji Akimichi",
          "Chōji's Mother",
          "Chōjūrō",
          "Chōmei",
          "Chōseki",
          "Chōza Akimichi",
          "Chūji",
          "Chūkaku",
          "Chūkichi",
          "Chūshin",
          "Claw Daimyō",
          "Code",
          "Conch King",
          "Condor",
          "Crimson Fist",
          "Curse Jutsu Master",
          "Cursed Warrior",
          "Daen Nara",
          "Daibutsu",
          "Daichi",
          "Daikoku Funeno",
          "Daimaru",
          "Dajimu",
          "Dan Katō",
          "Dango Mitsuki",
          "Dangō",
          "Danjō",
          "Danzō Shimura",
          "Daore Dōtonbori",
          "Darui",
          "Datsuji",
          "Deepa",
          "Deidara",
          "Delta",
          "Demonic Statue of the Outer Path",
          "Dengaku",
          "Denka",
          "Denki Kaminarimon",
          "Disonasu",
          "Dodai",
          "Dokan",
          "Doki",
          "Dokku",
          "Don",
          "Doragu",
          "Dosu Kinuta",
          "Dotō Kazahana",
          "Dread Lion",
          "Dōshin",
          "Dōshu Goetsu",
          "Dōtō Akimichi",
          "Eagle-Masked Anbu Member",
          "Earth Daimyō",
          "Earth Prison Golem",
          "Ebisu",
          "Ebizō",
          "Ehō Norimaki",
          "Emi",
          "Emina",
          "Emiru",
          "En no Gyōja",
          "En Oyashiro",
          "Enchū Nara",
          "Enko Onikuma",
          "Enra",
          "Ensui Nara",
          "Enzo Tenrō",
          "Ereki Kaminarimon",
          "Erimaki Sharo",
          "Etoro Konjiki",
          "Evil Minister of the Tea Daimyō",
          "F",
          "Fang Daimyō",
          "Faz",
          "Fire Daimyō (Part I-II)",
          "First Animal Path (character)",
          "First Hoshikage",
          "Former Leader of Nadeshiko Village",
          "Fox-Masked Anbu Member"
        ],
        "demons": [
          "One-Tails (Shukaku)",
          "Two-Tails (Matatabi)",
          "Three-Tails (Isobu)",
          "Four-Tails (Son Goku)",
          "Five-Tails (Kokuo)",
          "Six-Tails (Saiken)",
          "Seven-Tails (Chomei)",
          "Eight-Tails (Gyuki)",
          "Nine-Tails (Kurama)",
          "Ten-Tails (Shinju)"
        ],
        "eyes": [
          "Byakugan",
          "Sharingan",
          "Jōgan",
          "Mangekyō Sharingan",
          "Rinnegan",
          "Tenseigan",
          "Rinne-Sharingan"
        ],
        "villages": [
          "Konohagakure (Leaf Village)",
          "Sunagakure (Sand Village)",
          "Kirigakure (Mist Village)",
          "Kumogakure (Cloud Village)",
          "Iwagakure (Stone Village)"
        ]
      },
      "nation": {
        "capital_city": [
          "Kabul",
          "Tirana",
          "Algiers",
          "Andorra la Vella",
          "Luanda",
          "Saint John's",
          "Buenos Aires",
          "Yerevan",
          "Canberra",
          "Vienna",
          "Baku",
          "Nassau",
          "Manama",
          "Dhaka",
          "Bridgetown",
          "Minsk",
          "Brussels",
          "Belmopan",
          "Porto-Novo",
          "Thimphu",
          "Sarajevo",
          "Gaborone",
          "Brasilia",
          "Bandar Seri Begawan",
          "Sofia",
          "Ouagadougou",
          "Bujumbura",
          "Phnom Penh",
          "Yaounde",
          "Ottawa",
          "Praia Bangui",
          "N'Djamena",
          "Santiago",
          "Beijing",
          "Bogota",
          "Moroni",
          "Brazzaville",
          "Kinshasa",
          "San Jose",
          "Zagreb",
          "Havana",
          "Nicosia",
          "Prague",
          "Copenhagen",
          "Djibouti",
          "Roseau",
          "Santo Domingo",
          "Dili",
          "Quito",
          "Cairo",
          "San Salvador",
          "Malabo",
          "Asmara",
          "Tallinn",
          "Addis Ababa",
          "Suva",
          "Helsinki",
          "Paris",
          "Libreville",
          "Banjul",
          "Tbilisi",
          "Berlin",
          "Accra",
          "Athens",
          "Saint George's",
          "Guatemala City",
          "Conakry",
          "Bissau",
          "Georgetown",
          "Prince",
          "Tegucigalpa",
          "Budapest",
          "Reykjavik",
          "New Delhi",
          "Jakarta",
          "Tehran",
          "Baghdad",
          "Dublin",
          "Jerusalem",
          "Rome",
          "Kingston",
          "Tokyo",
          "Amman",
          "Astana",
          "Nairobi",
          "Tarawa Atoll",
          "Pyongyang",
          "Seoul",
          "Pristina",
          "Kuwait City",
          "Bishkek",
          "Vientiane",
          "Riga",
          "Beirut",
          "Maseru",
          "Monrovia",
          "Tripoli",
          "Vaduz",
          "Vilnius",
          "Luxembourg",
          "Skopje",
          "Antananarivo",
          "Lilongwe",
          "Kuala Lumpur",
          "Male",
          "Bamako",
          "Valletta",
          "Majuro",
          "Nouakchott",
          "Port Louis",
          "Mexico City",
          "Palikir",
          "Chisinau",
          "Monaco",
          "Ulaanbaatar",
          "Podgorica",
          "Rabat",
          "Maputo",
          "Windhoek",
          "Kathmandu",
          "Wellington",
          "Managua",
          "Niamey",
          "Abuja",
          "Oslo",
          "Muscat",
          "Islamabad",
          "Melekeok",
          "Panama City",
          "Port Moresby",
          "Asuncion",
          "Lima",
          "Manila",
          "Warsaw",
          "Lisbon",
          "Doha",
          "Bucharest",
          "Moscow",
          "Kigali",
          "Basseterre",
          "Castries",
          "Kingstown",
          "Apia",
          "San Marino",
          "Sao Tome",
          "Riyadh",
          "Dakar",
          "Belgrade",
          "Victoria",
          "Freetown",
          "Singapore",
          "Bratislava",
          "Ljubljana",
          "Honiara",
          "Mogadishu",
          "Juba",
          "Madrid",
          "Colombo",
          "Khartoum",
          "Paramaribo",
          "Mbabane",
          "Stockholm",
          "Bern",
          "Damascus",
          "Taipei",
          "Dushanbe",
          "Dar es Salaam",
          "Bangkok",
          "Lome",
          "Nuku'alofa",
          "Port-of-Spain",
          "Tunis",
          "Ankara",
          "Ashgabat",
          "Vaiaku village",
          "Kampala",
          "Kyiv",
          "Abu Dhabi",
          "London",
          "Washington D.C.",
          "Montevideo",
          "Tashkent",
          "Port-Vila",
          "Vatican City",
          "Caracas",
          "Hanoi",
          "Sanaa",
          "Lusaka",
          "Harare"
        ],
        "flag": [
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            182
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            189
          ],
          [
            240,
            159,
            135,
            166,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            167
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            175
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            182
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            187
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            167,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            181
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            187
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            189
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            168,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            169,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            169,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            169,
            240,
            159,
            135,
            175
          ],
          [
            240,
            159,
            135,
            169,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            169,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            169,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            169,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            170,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            171,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            171,
            240,
            159,
            135,
            175
          ],
          [
            240,
            159,
            135,
            171,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            171,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            171,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            171,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            167
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            181
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            182
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            172,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            173,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            173,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            173,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            173,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            173,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            173,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            182
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            174,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            175,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            175,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            175,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            175,
            240,
            159,
            135,
            181
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            181
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            176,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            167
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            187
          ],
          [
            240,
            159,
            135,
            177,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            181
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            182
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            187
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            189
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            178,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            181
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            179,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            180,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            181,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            182,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            183,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            183,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            183,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            183,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            183,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            167
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            175
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            187
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            189
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            184,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            169
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            173
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            175
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            177
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            180
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            183
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            187
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            135,
            185,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            186,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            186,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            186,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            186,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            186,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            186,
            240,
            159,
            135,
            190
          ],
          [
            240,
            159,
            135,
            186,
            240,
            159,
            135,
            191
          ],
          [
            240,
            159,
            135,
            187,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            187,
            240,
            159,
            135,
            168
          ],
          [
            240,
            159,
            135,
            187,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            187,
            240,
            159,
            135,
            172
          ],
          [
            240,
            159,
            135,
            187,
            240,
            159,
            135,
            174
          ],
          [
            240,
            159,
            135,
            187,
            240,
            159,
            135,
            179
          ],
          [
            240,
            159,
            135,
            187,
            240,
            159,
            135,
            186
          ],
          [
            240,
            159,
            135,
            188,
            240,
            159,
            135,
            171
          ],
          [
            240,
            159,
            135,
            188,
            240,
            159,
            135,
            184
          ],
          [
            240,
            159,
            135,
            189,
            240,
            159,
            135,
            176
          ],
          [
            240,
            159,
            135,
            190,
            240,
            159,
            135,
            170
          ],
          [
            240,
            159,
            135,
            190,
            240,
            159,
            135,
            185
          ],
          [
            240,
            159,
            135,
            191,
            240,
            159,
            135,
            166
          ],
          [
            240,
            159,
            135,
            191,
            240,
            159,
            135,
            178
          ],
          [
            240,
            159,
            135,
            191,
            240,
            159,
            135,
            188
          ],
          [
            240,
            159,
            143,
            180,
            243,
            160,
            129,
            167,
            243,
            160,
            129,
            162,
            243,
            160,
            129,
            165,
            243,
            160,
            129,
            174,
            243,
            160,
            129,
            167,
            243,
            160,
            129,
            191
          ],
          [
            240,
            159,
            143,
            180,
            243,
            160,
            129,
            167,
            243,
            160,
            129,
            162,
            243,
            160,
            129,
            179,
            243,
            160,
            129,
            163,
            243,
            160,
            129,
            180,
            243,
            160,
            129,
            191
          ],
          [
            240,
            159,
            143,
            180,
            243,
            160,
            129,
            167,
            243,
            160,
            129,
            162,
            243,
            160,
            129,
            183,
            243,
            160,
            129,
            172,
            243,
            160,
            129,
            179,
            243,
            160,
            129,
            191
          ]
        ],
        "language": [
          "Nepali",
          "Hindi",
          "English",
          "Arabic",
          "Portuguese",
          "Russian",
          "Japanese",
          "German",
          "Javanese",
          "Telugu",
          "Korean",
          "French",
          "Marathi",
          "Italian",
          "Thai",
          "Hakka",
          "Tagalog",
          "Romanian",
          "Dutch",
          "Kazakh",
          "Zulu",
          "Swedish"
        ],
        "nationality": [
          "Afghans",
          "Albanians",
          "Algerians",
          "Americans",
          "Andorrans",
          "Angolans",
          "Argentines",
          "Armenians",
          "Aromanians",
          "Arubans",
          "Australians",
          "Austrians",
          "Bahamians",
          "Bahrainis",
          "Bangladeshis",
          "Barbadians",
          "Belarusians",
          "Belgians",
          "Belizeans",
          "Bermudians",
          "Boers",
          "Bosniaks",
          "Brazilians",
          "Bretons",
          "British",
          "British Virgin Islanders",
          "Bulgarians",
          "Macedonian Bulgarians",
          "Burkinabès",
          "Burundians",
          "Cambodians",
          "Cameroonians",
          "Canadians",
          "Catalans",
          "Cape",
          "Verdeans",
          "Chadians",
          "Chileans",
          "Chinese",
          "Colombians",
          "Comorians",
          "Congolese",
          "Croatians",
          "Cubans",
          "Turkish Cypriots",
          "Czechs",
          "Danes",
          "Dominicans (Republic)",
          "Dominicans (Commonwealth)",
          "Dutch",
          "East Timorese",
          "Ecuadorians",
          "Egyptians",
          "Emiratis",
          "English",
          "Eritreans",
          "Estonians",
          "Ethiopians",
          "Faroese",
          "Finns",
          "Finnish Swedish",
          "Fijians",
          "Filipinos",
          "French citizens",
          "Georgians",
          "Germans",
          "Baltic Germans",
          "Ghanaians",
          "Gibraltar",
          "Greeks",
          "Greek Macedonians",
          "Grenadians",
          "Guatemalans",
          "Guianese (French)",
          "Guineans",
          "Guinea-Bissau nationals",
          "Guyanese",
          "Haitians",
          "Hondurans",
          "Hong Kong",
          "Hungarians",
          "Icelanders",
          "Indians",
          "Indonesians",
          "Iranians (Persians)",
          "Iraqis",
          "Irish",
          "Israelis",
          "Italians",
          "Ivoirians",
          "Jamaicans",
          "Japanese",
          "Jordanians",
          "Kazakhs",
          "Kenyans",
          "Koreans",
          "Kosovo Albanians",
          "Kurds",
          "Kuwaitis",
          "Lao",
          "Latvians",
          "Lebanese",
          "Liberians",
          "Libyans",
          "Liechtensteiners",
          "Lithuanians",
          "Luxembourgers",
          "Macedonians",
          "Malagasy",
          "Malaysians",
          "Malawians",
          "Maldivians",
          "Malians",
          "Maltese",
          "Manx",
          "Mauritians",
          "Mexicans",
          "Moldovans",
          "Moroccans",
          "Mongolians",
          "Montenegrins",
          "Namibians",
          "Nepalese",
          "New Zealanders",
          "Nicaraguans",
          "Nigeriens",
          "Nigerians",
          "Norwegians",
          "Pakistanis",
          "Palauans",
          "Palestinians",
          "Panamanians",
          "Papua New Guineans",
          "Paraguayans",
          "Peruvians",
          "Poles",
          "Portuguese",
          "Puerto Ricans",
          "Quebecers",
          "Réunionnais",
          "Romanians",
          "Russians",
          "Baltic Russians",
          "Rwandans",
          "Salvadorans",
          "São Tomé and Príncipe",
          "Saudis",
          "Scots",
          "Senegalese",
          "Serbs",
          "Sierra Leoneans",
          "Singaporeans",
          "Sindhian",
          "Slovaks",
          "Slovenes",
          "Somalis",
          "South Africans",
          "Spaniards",
          "Sri Lankans",
          "St Lucians",
          "Sudanese",
          "Surinamese",
          "Swedes",
          "Swiss",
          "Syrians",
          "Taiwanese",
          "Tanzanians",
          "Thais",
          "Tibetans",
          "Tobagonians",
          "Trinidadians",
          "Tunisians",
          "Turks",
          "Tuvaluans",
          "Ugandans",
          "Ukrainians",
          "Uruguayans",
          "Uzbeks",
          "Vanuatuans",
          "Venezuelans",
          "Vietnamese",
          "Welsh",
          "Yemenis",
          "Zambians",
          "Zimbabweans"
        ]
      },
      "nato_phonetic_alphabet": {
        "code_word": [
          "Alpha",
          "Bravo",
          "Charlie",
          "Delta",
          "Echo",
          "Foxtrot",
          "Golf",
          "Hotel",
          "India",
          "Juliett",
          "Kilo",
          "Lima",
          "Mike",
          "November",
          "Oscar",
          "Papa",
          "Quebec",
          "Romeo",
          "Sierra",
          "Tango",
          "Uniform",
          "Victor",
          "Whiskey",
          "X-ray",
          "Yankee",
          "Zulu"
        ]
      },
      "new_girl": {
        "characters": [
          "Winston Bishop",
          "Cece",
          "Coach",
          "Jessica Day",
          "Nick Miller",
          "Schmidt"
        ],
        "quotes": [
          "A no-nail oath? You thought I was gonna sleep with one of you, like I just couldn't help it?",
          "With your big, beautiful blue eyes and my Blair Underwood-like skin, we'd have the most beautiful baby the world has ever seen.",
          "Are you 'White Fanging' me?",
          "You are a beautiful white man, Nick Miller.",
          "Take these, and take care of them. I can get a tetanus shot, but I can't cure damaged suede.",
          "Please take that off. You look like a homeless pencil.",
          "Winston and Ferguson about to eat some pasta!",
          "Gave me cookie got you cookie!",
          "Can you believe the zoo wouldn't let me borrow their white tiger? I mean, the nerve! Philip Seymour Hoffman is going to be sitting at the back of the party thinking, 'Look at that guy. He couldn’t even get a big cat.'",
          "Did you just say 'butt drinking?' You can’t say 'butt drinking' and not explain what it is. That's two of my four favorite things.",
          "Are you cooking a frittata in a sauce pan? What is this – prison?",
          "If you had a jacket on with a bunch of yellow feathers, I'd be done.",
          "I had figure skating lessons until I was 13, and then my mom sobered up and realized I was a boy.",
          "Damp towel, damp! It’s like a really big wet nap. I feel like I'm being licked by a golden retriever. Look at this bathroom. There should not be two girls in this bathroom. You're too humid.",
          "I don't celebrate Christmas. Or, as I like to call it, 'White Anglo Saxon Winter Privilege Night'.",
          "It hurts. I feel like I've laid a million eggs and they're all hatching. I feel like I want to murder someone and I also want soft pretzels.",
          "I don't know how it happened, man, but somehow I got on that woman's cycle of menstruation…and I got that menstruation inside of me.",
          "I don't want some janky freshwater bitch fish, Winston. I want a lionfish.",
          "I did laundry. I smell like a baby in a damn meadow.",
          "Old people freak me out. With their hands and their legs. They’re like the people version of pleated pants.",
          "I'm really fighting the urge to buy you a lobster dinner.",
          "Nick is delicate. Like a flower. Like a chubby, damaged flower who hates himself.",
          "How's the new apartment? Does it smell like new paint and compromise?",
          "I was sabotaged by my baby box, which means I will never trust anything that comes out of it.",
          "I'm gonna end up alone. I’m gonna be a single old lady, flashing people on the subway.",
          "This place is fancy and I don't know which fork to kill myself with.",
          "If you need me, I'll be in my room, listening to some mainstream hip-hop."
        ]
      },
      "one_piece": {
        "akuma_no_mi": [
          "Gomu Gomu no Mi",
          "Hana Hana no Mi",
          "Doru Doru no Mi",
          "Baku Baku no Mi",
          "Mane Mane no Mi",
          "Supa Supa no Mi",
          "Ori Ori no Mi",
          "Bane Bane no Mi",
          "Noro Noro no Mi",
          "Doa Doa no Mi",
          "Awa Awa no Mi",
          "Beri Beri no Mi",
          "Sabi Sabi no Mi",
          "Shari Shari no Mi",
          "Yomi Yomi no Mi",
          "Kage Kage no Mi",
          "Horo Horo no Mi",
          "Suke Suke no Mi",
          "Nikyu Nikyu no Mi",
          "Mero Mero no Mi",
          "Doku Doku no Mi",
          "Horu Horu no Mi",
          "Choki Choki no Mi",
          "Gura Gura no Mi",
          "Fuwa Fuwa no Mi",
          "Woshu Woshu no Mi",
          "Mato Mato no Mi",
          "Ope Ope no Mi",
          "Buki Buki no Mi",
          "Bari Bari no Mi",
          "Nui Nui no Mi",
          "Giro Giro no Mi",
          "Ato Ato no Mi",
          "Jake Jake no Mi",
          "Pamu Pamu no Mi",
          "Sui Sui no Mi",
          "Hira Hira no Mi",
          "Ishi Ishi no Mi",
          "Nagi Nagi no Mi",
          "Ito Ito no Mi",
          "Shiro Shiro no Mi",
          "Chiyu Chiyu no Mi",
          "Ushi Ushi no Mi",
          "Hito Hito no Mi",
          "Tori Tori no Mi",
          "Inu Inu no Mi",
          "Neko Neko no Mi",
          "Zou Zou no Mi",
          "Hebi Hebi no Mi",
          "Sara Sara no Mi",
          "Mushi Mushi no Mi",
          "Batto Batto no Mi",
          "Mogu Mogu no Mi",
          "Uma Uma no Mi",
          "Kame Kame no Mi",
          "Moku Moku no Mi",
          "Mera Mera no Mi",
          "Suna Suna no Mi",
          "Goro Goro no Mi",
          "Hie Hie no Mi",
          "Pika Pika no Mi",
          "Magu Magu no Mi",
          "Numa Numa no Mi",
          "Gasu Gasu no Mi",
          "Yuki Yuki no Mi"
        ],
        "characters": [
          "Monkey D. Luffy",
          "Roronoa Zoro",
          "Nami",
          "Ussop",
          "Vinsmoke Sanji",
          "Tony Tony Chopper",
          "Nico Robin",
          "Franky",
          "Brook",
          "Akainu",
          "Aokiji",
          "Arlong",
          "Bartholomew Kuma",
          "Boa Hancock",
          "Caesar Clown",
          "Coby",
          "Crocodile",
          "Kuroken Mr. 1",
          "Dracule Mihawk",
          "Edward Newgate",
          "Emporio Ivankov",
          "Gecko Moriah",
          "Jinbe",
          "Kaido",
          "Kalifa",
          "Kizaru",
          "Marshall D. Teach",
          "Mokey D. Dragon",
          "Monkey D. Garp",
          "Portgas D. Ace",
          "Rob Lucci",
          "Sengoku",
          "Shanks",
          "Smoker",
          "Tashigi",
          "Trafalgar D. Water Law",
          "Alvida",
          "Baby Five",
          "Bartolomeo",
          "Basil Hawkins",
          "Bastille",
          "Bellamy",
          "Ben Beckmann",
          "Bepo",
          "Blueno",
          "Bon Clay Mr. 2",
          "Brook",
          "Bufalo",
          "Buggy",
          "Capone Bege",
          "Cavendish",
          "Hakuba",
          "Dellinger",
          "Diamante",
          "Doc Q",
          "Don Chinjao",
          "Don Krieg",
          "Donquixote Doflamingo",
          "Enel",
          "Eustass Kid",
          "Fujitora",
          "Fukuro",
          "Fullbody",
          "Gladius",
          "Gold D. Roger",
          "Hacchi",
          "Hannyabal",
          "Hody Jones",
          "Jyabura",
          "Jesus Burgess",
          "Jewelry Bonney",
          "Jozu",
          "Kaku",
          "Kaime",
          "Killer",
          "Kinemon",
          "Koala",
          "Kumadori",
          "Kyros",
          "Laboon",
          "Laffitte",
          "Lao G",
          "Leo",
          "Lucy",
          "Magellan",
          "Marco",
          "Miss Valentine",
          "Momonosuke",
          "Money",
          "Nojiko",
          "Perona",
          "Rebecca",
          "Ryuma",
          "Sabo",
          "Sadi",
          "Scratchmen Apoo",
          "Sengoku",
          "Señor Pink",
          "Sentoumaru",
          "Shirahoshi",
          "Silvers Rayleigh",
          "Sogeking",
          "Sugar",
          "Spandam",
          "Van Auger",
          "Vergo",
          "Vista",
          "Vivi",
          "X Drake",
          "Corazon",
          "Pika"
        ],
        "islands": [
          "Dawn Island",
          "Goat Island",
          "Shells Town",
          "Organ Islands",
          "Island of Rare Animals",
          "Gecko Islands",
          "Conomi Islands",
          "Loguetown",
          "Kumate Island",
          "Mirrorball Island",
          "Tequila Wolf",
          "Cozia",
          "Ohara",
          "Ilusia",
          "Thriller Bark",
          "Toroa",
          "Las Camp",
          "Kano Country",
          "Germa Kingdom",
          "Lvneel Kingdom",
          "Micqueot",
          "Spider Miles",
          "Flevance",
          "Rubeck Island",
          "Swallow Island",
          "Minion Island",
          "Rakesh",
          "Notice",
          "Briss Kingdom",
          "Karate Island",
          "Centaurea",
          "Torino Kingdom",
          "Baterilla",
          "Black Drum Kingdom",
          "Fishman Island",
          "Amazon Lily",
          "Impel Down",
          "Rasukaina",
          "Cactus Island",
          "Little Garden",
          "Holliday Island",
          "Drum Island",
          "Alabasta",
          "Nanimonai Island",
          "Jaya",
          "Long Ring Long Land",
          "Water 7",
          "Enies Lobby",
          "San Faldo",
          "Pucci",
          "St. Poplar",
          "Florian Triangle",
          "Sabaody Archipelago",
          "Marineford",
          "Vira",
          "Banaro Island",
          "Yuki's Island",
          "Buggy's Treasure Island",
          "G-2",
          "Karakuri Island",
          "Mamoiro Island",
          "Boin Archipelago",
          "Namakura Island",
          "Kuraigana Island",
          "Merveille",
          "G-1",
          "Yukiryu Island",
          "Baltigo",
          "Wano Country",
          "Edd War",
          "Floodvalter",
          "G-5",
          "Laftel",
          "Whole Cake Island",
          "Cacao Island",
          "Jam Island",
          "Nuts Island",
          "Cheese Island",
          "Biscuits Island",
          "Candy Island",
          "Milk Island",
          "Punk Hazard",
          "Raijin Island",
          "Risky Red Island",
          "Mystoria Island",
          "Dressrosa",
          "Green Bit",
          "Zou",
          "Prodence Kingdom",
          "Applenine Island",
          "Karai Bari Island",
          "Broc Coli Island",
          "Elbaf",
          "Skypiea",
          "Weatheria"
        ],
        "locations": [
          "Foosha Village",
          "Mt. Colubo",
          "Gray Terminal",
          "Midway Forest",
          "Goa Kingdom",
          "Orange Town",
          "Syrup Village",
          "Shimotsuki Village",
          "Baratie",
          "Gosa Village",
          "Cocoyashi Village",
          "Arlong Park",
          "Ryugu Kingdom",
          "Reverse Mountain",
          "Twin Cape",
          "Mariejois",
          "Whiskey Peak",
          "Bighorn",
          "Drum Rockies",
          "Cocoa Weed",
          "Gyasta",
          "Robelie",
          "Sandora Desert",
          "Sandora River",
          "Rainbase",
          "Yuba",
          "Erumalu",
          "Nanohana",
          "Katorea",
          "Spiders Cafe",
          "Alubarna",
          "Tamarisk",
          "Suiren",
          "Mock Town",
          "Sea Train Area",
          "Totto Land",
          "Acacia",
          "Sebio",
          "Moon",
          "Birka",
          "Angel Island",
          "Upper Yard",
          "Shandia Village",
          "Heaven's Gate",
          "Clouds End",
          "Rommel Kingdom",
          "Eight Nine Island",
          "High Mountain",
          "Nakrowa",
          "Land of Ice",
          "Great Kingdom"
        ],
        "quotes": [
          "I love heroes, but I don't want to be one. Do you even know what a hero is!? For example, you have some meat. Pirates will feast on the meat, but the hero will distribute it among the people! I want to eat the meat!",
          "Don't ever think there's any perfect society made by humans!! If you think that way you'll overlook the enemy!! Don't be fooled by appearances!",
          "If I can't even protect my captain's dream, then whatever ambition I have is nothing but talk! Luffy must be the man who becomes the Pirate King!",
          "Old man, everyone!! And you.. Luffy. Even though I've been good for nothing my whole life, even though I have the blood of a demon within me... You guys still loved me! Thank you so much!!",
          "Compared to the \"righteous\" greed of the rulers, the criminals of the world seem much more honorable. When scum rules the world, only more scum is born.",
          "Pirates are evil? The Marines are righteous?... Justice will prevail, you say? But of course it will! Whoever wins this war becomes justice!",
          "When do you think people die? When they are shot through the heart by the bullet of a pistol? No. When they are ravaged by an incurable disease? No... It’s when they're forgotten!",
          "You can spill drinks on me, even spit on me. I'll just laugh about it. But If you dare to hurt my friends... I won't forgive you!",
          "The government says your existence is a crime, but no matter what kind of weapons you may hold, just being alive isn't a sin! There's no crime in living!",
          "ONE PIECE IS REAL!",
          "It's not some sort of special power. He has the ability to make allies of everyone he meets. And that is the most fearsome ability on the high seas.",
          "I want to live!",
          "Maybe nothing in this world happens by accident. As everything happens for a reason, our destiny slowly takes form.",
          "Food is a gift from god. Spices are a gift from the devil. It looks like it was a bit too spicy for you.",
          "I don't care now. I wanted to look like a human because I wanted friends. Now I want to be a monster who's helpful to Luffy!",
          "Miracles only happen to those who never give up.",
          "Stop counting only those things you have lost! What is gone, is gone! So ask yourself this. What is there... that still remains to you?!",
          "If you want to protect something, do it right! Don't let them get their way anymore!",
          "The royalty and nobles are behind the fire... Believe me... This town smells worse than Gray Terminal. It smells like rotten people! If I stay here... I'll never be free! I'm... ashamed to be born a noble!",
          "There comes a time when a man has to stand and fight! That time is when his friends' dreams are being laughed at! And I won't let you laugh at that!",
          "To true friendship, how long you've known each other means nothing.",
          "When the world shoves you around, you just gotta stand up and shove back. It's not like somebody's gonna save you if you start babbling excuses.",
          "People's dreams... Never end!",
          "If you kill yourself, I'll kill you!",
          "I don't wanna live a thousand years. If I just live through today, that'll be enough."
        ],
        "seas": [
          "East Blue",
          "West Blue",
          "North Blue",
          "South Blue",
          "Grand Line",
          "All Blue"
        ]
      },
      "opera": {
        "french": {
          "by_camille_saint_saens": [
            "L'ancêtre",
            "Ascanio",
            "Les barbares",
            "Déjanire",
            "Étienne Marcel",
            "Frédégonde",
            "Hélène",
            "Henry VIII",
            "Phryné",
            "La princesse jaune",
            "Proserpine",
            "Samson and Delilah",
            "Le timbre d'argent"
          ],
          "by_charles_gounod": [
            "Sapho",
            "La nonne sanglante",
            "Le médecin malgrélui",
            "Faust",
            "Philémon et Baucis",
            "La colombe",
            "La reine de Saba",
            "Mireille",
            "Roméo et Juliette",
            "Cinq-Mars",
            "Maître Pierre",
            "Polyeucte",
            "Le tribut de Zamora"
          ],
          "by_christoph_willibald_gluck": [
            "La fausse esclave",
            "L'île de Merlin, ou Le monde renversé",
            "La Cythère assiégée",
            "Le diable à quatre, ou La double métamorphose",
            "L'arbre enchanté, ou Le tuteur dupé",
            "L'ivrogne corrigé ou le mariage du diable",
            "Le cadi dupé",
            "La rencontre imprévue",
            "Iphigénie en Aulide",
            "Orphée et Euridice",
            "L'arbre enchanté",
            "Armide",
            "Iphigénie en Tauride",
            "Echo et Narcisse"
          ],
          "by_georges_bizet": [
            "La maison du docteur",
            "Le docteur Miracle",
            "Don Procopio",
            "La Prêtresse",
            "La Guzla de l'émir",
            "Ivan IV",
            "Les pêcheurs de perles",
            "La jolie fille de Perth",
            "Marlbrough s'en va-t-en guerre",
            "La Coupe du roi de Thulé",
            "Noé",
            "Clarisse Harlowe",
            "Grisélidis",
            "Djamileh",
            "Sol-si-ré-pif-pan",
            "L'Arlésienne",
            "Don Rodrigue",
            "Carmen"
          ],
          "by_hector_berlioz": [
            "Benvenuto Cellini",
            "Les Troyens",
            "Béatrice et Bénédict"
          ],
          "by_maurice_ravel": [
            "L'heure espagnole",
            "L'enfant et les sortilèges"
          ]
        },
        "german": {
          "by_alban_berg": [
            "Wozzeck",
            "Lulu"
          ],
          "by_carl_maria_von_weber": [
            "Silvana",
            "Abu Hassan",
            "Der Freischütz",
            "Euryanthe"
          ],
          "by_franz_schubert": [
            "Sakuntala",
            "Alfonso und Estrella",
            "Fierrabras",
            "Der Graf von Gleichen"
          ],
          "by_ludwig_van_beethoven": [
            "Fidelio"
          ],
          "by_richard_strauss": [
            "Guntram",
            "Feuersnot",
            "Salome",
            "Elektra",
            "Der Rosenkavalier",
            "Ariadne auf Naxos",
            "Die Frau ohne Schatten",
            "Die ägyptische Helena",
            "Arabella",
            "Die schweigsame Frau",
            "Friedenstag",
            "Daphne",
            "Die Liebe der Danae",
            "Capriccio",
            "Intermezzo"
          ],
          "by_richard_wagner": [
            "Die Feen",
            "Das Liebesverbot",
            "Rienzi, der Letzte der Tribunen",
            "Der fliegende Holländer",
            "Tannhäuser",
            "Lohengrin",
            "Das Rheingold",
            "Die Walküre",
            "Siegfried",
            "Götterdämmerung",
            "Tristan und Isolde",
            "Die Meistersinger",
            "Parsifal"
          ],
          "by_robert_schumann": [
            "Genoveva"
          ],
          "by_wolfgang_amadeus_mozart": [
            "Bastien und Bastienne",
            "Thamos, König in ­Ägypten",
            "Die Entführung aus dem Serail",
            "Der Schauspieldirektor",
            "Die Zauberflöte"
          ]
        },
        "italian": {
          "by_christoph_willibald_gluck": [
            "Artaserse",
            "Demetrio",
            "Demofoonte",
            "Il Tigrane",
            "La Sofonisba",
            "Ipermestra",
            "Poro",
            "Ippolito",
            "La caduta de' giganti",
            "Artamene",
            "Le nozze d'Ercole e d'Ebe",
            "La Semiramide riconosciuta",
            "La contesa de' numi",
            "Ezio",
            "Issipile",
            "La clemenza di Tito",
            "Le cinesi",
            "La danza",
            "L'innocenza giustificata",
            "Antigono",
            "Il re pastore",
            "Tetide",
            "Orfeo ed Euridice",
            "Il trionfo di Clelia",
            "Il Parnaso confuso",
            "Telemaco, ossia L'isola di Circe",
            "La corona",
            "Alceste",
            "Le feste d'Apollo",
            "Paride ed Elena"
          ],
          "by_gaetano_donizetti": [
            "Olimpiade",
            "L'ira di Achille",
            "Enrico di Borgogna",
            "Una follia",
            "I piccioli virtuosi ambulanti",
            "Il falegname di Livonia o Pietro il grande czar delle Russie",
            "Le nozze in villa",
            "Zoraida di Granata",
            "La zingara",
            "La lettera anonima",
            "Chiara e Serafina o Il pirata",
            "Alfredo il grande",
            "Il fortunato inganno",
            "L'ajo nell'imbarazzo",
            "Emilia di Liverpool or L'eremitaggio di Liverpool",
            "Alahor in Granata",
            "Don Gregorio",
            "Elvida",
            "Gabriella di Vergy",
            "Olivo e Pasquale",
            "Otto mesi in due ore ossia Gli esiliati in Siberia",
            "Il borgomastro di Saardam",
            "Le convenienze teatrali",
            "L'esule di Roma ossia Il proscritto",
            "L'eremitaggio di Liverpool",
            "Alina regina di Golconda",
            "Gianni di Calais",
            "Il paria",
            "Il giovedì grasso o Il nuovo Pourceaugnac",
            "Elisabetta al castello di Kenilworth",
            "Alina regina di Golconda[rev]",
            "I pazzi per progetto",
            "Il diluvio universale",
            "Imelda de' Lambertazzi",
            "Anna Bolena",
            "Gianni di Parigi",
            "Le convenienze ed inconvenienze teatrali",
            "Francesca di Foix",
            "La romanziera e l'uomo nero",
            "Fausta",
            "Ugo conte di Parigi",
            "L'elisir d'amore",
            "Sancia di Castiglia",
            "Il furioso all'isola di San Domingo",
            "Otto mesi in due ore",
            "Parisina",
            "Torquato Tasso",
            "Lucrezia Borgia",
            "Il diluvio universale",
            "Rosmonda d'Inghilterra",
            "Maria Stuarda",
            "Buondelmonte",
            "Gemma di Vergy",
            "Marino Faliero",
            "Lucia di Lammermoor",
            "Belisario",
            "Il campanello di notte",
            "Betly o La capanna svizzera",
            "L'assedio di Calais",
            "Pia de' Tolomei",
            "Pia de' Tolomei",
            "Betly",
            "Roberto Devereux",
            "Maria de Rudenz",
            "Gabriella di Vergy",
            "Poliuto",
            "Pia de' Tolomei",
            "Lucie de Lammermoor",
            "Le duc d'Albe",
            "L'ange de Nisida",
            "Lucrezia Borgia",
            "Les Martyrs",
            "La fille du régiment",
            "Lucrezia Borgia",
            "La favorite",
            "Adelia",
            "Rita",
            "Maria Padilla",
            "Linda di Chamounix",
            "Caterina Cornaro",
            "Don Pasquale",
            "Maria di Rohan",
            "Dom Sébastien roi de Portugal",
            "Dom Sebastian von Portugal",
            "Il duca d'Alba"
          ],
          "by_gioacchino_rossini": [
            "Demetrio e Polibio",
            "La cambiale di matrimonio",
            "L'equivoco stravagante",
            "L'inganno felice",
            "Ciro in Babilonia ossia La caduta di Baldassare",
            "La scala di seta",
            "La pietra del paragone",
            "L'occasione fa il ladro  ossia Il cambio della valigia",
            "Il signor Bruschino   ossia Il figlio per azzardo",
            "Tancredi",
            "L'italiana in Algeri",
            "Aureliano in Palmira",
            "Il turco in Italia",
            "Sigismondo",
            "Elisabetta   regina d'Inghilterra",
            "Torvaldo e Dorliska",
            "Il barbiere di Siviglia   ossia L'inutile precauzione",
            "La gazzetta   ossia Il matrimonio per concorso",
            "Otello   ossia Il Moro di Venezia",
            "La Cenerentola   ossia La bontà in trionfo",
            "La gazza ladra",
            "Armida",
            "Adelaide di Borgogna ossia Ottone re d'Italia",
            "Mosè in Egitto",
            "Adina ossia Il califfo di Bagdad",
            "Ricciardo e Zoraide",
            "Ermione",
            "Eduardo e Cristina",
            "La donna del lago",
            "Bianca e Falliero ossia Il consiglio dei tre",
            "Maometto II",
            "Matilde di Shabran",
            "Zelmira",
            "Semiramide",
            "Ugo   re d'Italia",
            "Il viaggio a Reims   ossia L'albergo del Giglio d'Oro",
            "Le siège de Corinthe",
            "Moïse et Pharaon ou Le passage de la mer rouge",
            "Le comte Ory",
            "Guillaume Tell"
          ],
          "by_giuseppe_verdi": [
            "Oberto Conte di San Bonifacio",
            "Un Giorno di Regno",
            "Nabucco",
            "Lombardi alla Prima Crociata",
            "Ernani",
            "I due Foscari",
            "Giovanna d'Arco",
            "Alzira",
            "Attila",
            "Macbeth",
            "I Masnadieri",
            "Jérusalem",
            "Il Corsaro",
            "La Battaglia di Legnano",
            "Luisa Miller",
            "Stiffelio",
            "Rigoletto",
            "Il Trovatore",
            "Simon Boccanegra",
            "Aroldo",
            "Un Ballo in Maschera",
            "La Forza del Destino",
            "Don Carlos",
            "Aida",
            "Otello",
            "Falstaff",
            "I Vespri Siciliani",
            "La Traviat"
          ],
          "by_vincenzo_bellini": [
            "Adelson e Salvini",
            "Bianca e Gernando",
            "Il pirata",
            "Bianca e Fernando",
            "La straniera",
            "Zaira",
            "I Capuleti e i Montecchi",
            "La sonnambula",
            "Norma",
            "Beatrice di Tenda",
            "I puritani"
          ],
          "by_wolfgang_amadeus_mozart": [
            "Cosi fan tutte",
            "Le nozze di Figaro",
            "La finta Giardiniera",
            "Don Giovanni",
            "Idomeneo, re di Creta",
            "La finta semplice",
            "Mitridate, re di Ponto",
            "Ascanio in Alba",
            "Il sogno di Scipione",
            "Lucio Silla",
            "Il re pastore",
            "La ciemenza di Tito"
          ]
        }
      },
      "parks_and_rec": {
        "characters": [
          "Leslie Knope",
          "Ron Swanson",
          "Ann Perkins",
          "Mark Brendanawicz",
          "Tom Haverford",
          "April Ludgate",
          "Andy Dwyer",
          "Jerry Gergich",
          "Donna Meagle",
          "Ben Wyatt",
          "Chris Traeger",
          "Craig Middlebrooks",
          "Jean-Ralphio Saperstein",
          "Li'l Sebastian",
          "Mona-Lisa Saperstein",
          "Orin",
          "Tammy 1",
          "Tammy 2",
          "Tammy Zero",
          "Jeremy Jamm",
          "Ethel Beavers",
          "Crazy Ira",
          "The Douche",
          "Joan Callamezzo",
          "Perd Hapley",
          "Shauna Malwae-Tweep",
          "Bobby Newport",
          "Dr. Richard Nygard"
        ],
        "cities": [
          "Pawnee",
          "Eagleton",
          "Boraqua"
        ]
      },
      "pearl_jam": {
        "albums": [
          "Backspacer",
          "Binaural",
          "Gigaton",
          "Lightning Bolt",
          "Lost Dogs",
          "No Code",
          "Pearl Jam",
          "Pearl Jam Twenty",
          "Rearviewmirror",
          "Riot Act",
          "Ten",
          "Vitology",
          "Vs.",
          "Yield"
        ],
        "musicians": [
          "Boom Gaspar",
          "Dave Abbruzzese",
          "Dave Krusen",
          "Eddie Vedder",
          "Jack Irons",
          "Jeff Ament",
          "Matt Cameron",
          "Matt Chamberlain",
          "Mike McCready",
          "Stone Gossard"
        ],
        "songs": [
          "½ Full",
          "Acoustic #1",
          "Alive",
          "All Night",
          "All Or None",
          "All Those Yesterdays",
          "Alone",
          "Alright",
          "Amongst The Waves",
          "Animal",
          "Arc",
          "Army Reserve",
          "Around the Bend",
          "Aye Davinita",
          "Be Like Wind",
          "Bee Girl",
          "Better Man",
          "Big Wave",
          "Black",
          "Black Red Yellow",
          "Blood",
          "Brain of J.",
          "Breakerfall",
          "Breathe",
          "Brother",
          "Buckle Up",
          "Bu$hleaguer",
          "Bugs",
          "Can't Keep",
          "Comatose",
          "Come Back",
          "Comes Then Goes",
          "Corduroy",
          "Crazy Mary",
          "Cready Stomp",
          "Cropduster",
          "Crown Of Thorns",
          "Dance of the Clairvoyants",
          "Daughter",
          "Dead Man",
          "Deep",
          "Dirty Frank",
          "Dissident",
          "Do The Evolution",
          "Don't Gimme No Lip",
          "Down",
          "Drifting",
          "Education",
          "Elderly Woman Behind The Counter In A Small Town",
          "Evacuation",
          "Even Flow",
          "Faithful",
          "Fatal",
          "Footsteps",
          "Force Of Nature",
          "Future Days",
          "Garden",
          "Get Right",
          "Getaway",
          "Ghost",
          "Given To Fly",
          "Glorified G.",
          "Go",
          "God's Dice",
          "Gone",
          "Gonna See My Friend",
          "Got Some",
          "Green Disease",
          "Gremmie Out Of Control",
          "Grievence",
          "Habit",
          "Hail Hail",
          "Hard To Imagine",
          "Help Help",
          "Hey Foxymophandlemama That's Me",
          "Hitchhiker",
          "Hold On",
          "Immortality",
          "I Am Mine",
          "I Got Id",
          "I'm Open",
          "In Hiding",
          "In My Tree",
          "In The Moonlight",
          "Indifference",
          "Infallible",
          "Inside Job",
          "Insignificance",
          "It Ain't Like That",
          "Jeremy",
          "Johnny Guitar",
          "Just Breathe",
          "Last Exit",
          "Last Kiss",
          "Leash",
          "Leaving Here",
          "Let Me Sleep",
          "Let The Records Play",
          "Life Wasted",
          "Light Years",
          "Lightning Bolt",
          "Low Light",
          "Love Boat Captain",
          "Lukin",
          "Man Of The Hour",
          "Mankind",
          "Marker In The Sand",
          "Mind Your Manners",
          "MFC",
          "My Father's Son",
          "Need To Know",
          "Never Destination",
          "No Way",
          "Not For You",
          "Nothinig As It Seems",
          "Nothingman",
          "Oceans",
          "Of The Girl",
          "Off He Goes",
          "Once",
          "Other Side",
          "Parachutes",
          "Parting Ways",
          "Pendulum",
          "Pilate",
          "Porch",
          "Present Tense",
          "Pry To",
          "Push Me Pull Me",
          "Quick Escape",
          "Rats",
          "Rearviewmirror",
          "Red Mosquito",
          "Release",
          "Retrograde",
          "Rival",
          "River Cross",
          "Sad",
          "Satan's Bed",
          "Save You",
          "Say Hello To Heaven",
          "Seven O'Clock",
          "Severed Hand",
          "Sirens",
          "Sleeping By Myself",
          "Sleight Of Hand",
          "Smile",
          "Sometimes",
          "Soon Forget",
          "Speed Of Sound",
          "Spin The Black Circle",
          "State Of Love and Trust",
          "Strangest Tribe",
          "Superblood Wolfmoon",
          "Supersonic",
          "Swallowed Whole",
          "Sweet Lew",
          "Take The Long Way",
          "The Color Red",
          "The End",
          "The Fixer",
          "Thin Air",
          "Thumbing My Way",
          "Times Of Trouble",
          "Tremor Chirst",
          "Undone",
          "Unemployable",
          "Unthought Known",
          "Walk With Me",
          "Wash",
          "Wasted Reprise",
          "Whale Song",
          "Whipping",
          "Who Ever Said",
          "Who You Are",
          "Why Go",
          "Wishlist",
          "World Wide Suicide",
          "W.M.A.",
          "Yellow Ledbetter",
          "Yellow Moon",
          "You",
          "You Are"
        ]
      },
      "phish": {
        "albums": [
          "Junta",
          "Lawn Boy",
          "A Picture of Nectar",
          "Rift",
          "Hoist",
          "Billy Breathes",
          "The Story of the Ghost",
          "The Siket Disc",
          "Farmhouse",
          "Round Room",
          "Undermind",
          "Joy",
          "Fuego",
          "Big Boat",
          "Sigma Oasis"
        ],
        "musicians": [
          "Jon Fishman",
          "Mike Gordon",
          "Page McConnell",
          "Trey Anastasio"
        ],
        "songs": [
          "A Song I Heard the Ocean Sing",
          "AC/DC Bag",
          "Access Me",
          "Acoustic Army",
          "Aftermath",
          "Albert",
          "All of These Dreams",
          "All Things Reconsidered",
          "Alumni Blues",
          "Ambient Jam",
          "Amidst the Peals of Laughter",
          "Anarchy",
          "And It Stoned Me",
          "And So To Bed",
          "Another One Bites the Dust",
          "Antelope",
          "Anything But Me",
          "Army of One",
          "Art Jam",
          "ASIHTOS",
          "Ass Handed",
          "ATR",
          "Axilla",
          "Axilla (Part II)",
          "Band/Crew Football Theme Song",
          "Bathtub Gin",
          "BBFCFM",
          "Beauty of a Broken Heart",
          "Big Ball Jam",
          "Big Black Furry Creature from Mars",
          "Billy Breathes",
          "Birds of a Feather",
          "Bittersweet Motel",
          "Black-Eyed Katy",
          "Blaze On",
          "Bliss",
          "BOTT",
          "Bouncing Around the Room",
          "Breath and Burning",
          "Brian and Robert",
          "Brother",
          "Buffalo Bill",
          "Bundle of Joy",
          "Buried Alive",
          "Bye Bye Foot",
          "Camel Walk",
          "Can't Always Listen",
          "Carini",
          "Carolina in the Morning",
          "Cars Trucks Buses",
          "Catapult",
          "Cavern",
          "Chalk Dust Torture",
          "Chalk Dust Torture Reprise",
          "Character Zero",
          "Clod",
          "Colonel Forbin's Ascent",
          "Contact",
          "Cool Amber and Mercury",
          "Costume Contest",
          "Couch Lady",
          "Crowd Control",
          "Dave's Energy Guide",
          "David Bowie",
          "Dear Mrs. Reagan",
          "Death Don't Hurt Very Long",
          "Demand",
          "Destiny Unbound",
          "Devotion To a Dream",
          "Digital Delay Loop Jam",
          "Dinner and a Movie",
          "Divided Sky",
          "Dog Faced Boy",
          "Dog Gone Dog",
          "Dog Log",
          "Dogs Stole Things",
          "Don't Get Me Wrong",
          "Doomsday",
          "Down with Disease",
          "Dr. Gabel",
          "Drive-In Jam",
          "Driver",
          "Eliza",
          "End of Session",
          "Esther",
          "Everything is Hollow",
          "Faht",
          "Farmhouse",
          "Fast Enough for You",
          "Fee",
          "Fikus",
          "Fire Up the Ganja",
          "Fish Bass",
          "Fishman's Gull Poem",
          "Flat Fee",
          "Flatbed Truck Jam",
          "Flip",
          "Fluff's Travels",
          "Fluffhead",
          "Fly Famous Mockingbird",
          "Foam",
          "Fooled by Images",
          "Frankie Says",
          "Free",
          "Freeworld",
          "Friday",
          "Friends",
          "Fuck Your Face",
          "Fuckerpants",
          "Fuego",
          "Gatekeeper",
          "Gaul Swerves and the Rest is Everything Else",
          "Get Back on the Train",
          "Ghost",
          "Glide",
          "Glide II",
          "Golgi Apparatus",
          "Grind",
          "Guelah Papyrus",
          "Gumbo",
          "Guy Forget",
          "Guyute",
          "Ha Ha Ha",
          "Halfway to the Moon",
          "Hall in Solace",
          "Halley's Comet",
          "Harpua",
          "Harry Hood",
          "He Ent to the Bog",
          "Hell's Bells",
          "Home",
          "Horn",
          "I Always Wanted It This Way",
          "I Am Hydrogen",
          "I Been Around",
          "I Didn't Know",
          "I Don't Care",
          "I Will Set You Free",
          "I've Turned Bad",
          "Icculus",
          "Idea",
          "If I Could",
          "In a Hole",
          "In a Misty Glade",
          "In an Intensive Care Unit",
          "In The Good Old Summer Time",
          "Infinite",
          "Ingest",
          "Insects",
          "Intro",
          "It's Ice",
          "Jägermeister Song",
          "Jennifer Dances",
          "Join the Band",
          "Joy",
          "Julius",
          "Keepin' It Real",
          "Keyboard Army",
          "Keyboard Cavalry",
          "Kill Devil Falls",
          "Killer Joe",
          "Kung",
          "Lawn Boy",
          "Lawn Boy Reprise",
          "Leaves",
          "Lengthwise",
          "Leprechaun",
          "Let's Go",
          "Letter to Jimmy Page",
          "Lifeboy",
          "Limb By Limb",
          "Llama",
          "Love Is What We Are",
          "Lucy Had A Lumpy Head",
          "Lushington",
          "Maggie's Revenge",
          "Magilla",
          "Makisupa Policeman",
          "Mallory",
          "Marijuana Hot Chocolate",
          "Martian Monster",
          "Maze",
          "McGrupp and the Watchful Hosemasters",
          "Meat",
          "Meatstick",
          "Melt",
          "Mercury",
          "Merry Pranksters Jam",
          "Metal Bagel Death",
          "Mexican Cousin",
          "Mike's Song",
          "Minkin",
          "Miss You",
          "MMGAMOIO",
          "MmmBop",
          "Mock Song",
          "Montana",
          "More",
          "Mound",
          "My Friend - My Friend",
          "My Left Toe",
          "My Problem Right There",
          "My Sweet One",
          "N2O",
          "Never",
          "NICU",
          "No Dogs Allowed",
          "No Men In No Man's Land",
          "NO2",
          "Norwegian Wood (This Bird Has Flown)",
          "Nowhere Fast",
          "Oblivious Fool",
          "Ocelot",
          "Olivia's Pool",
          "Party Time",
          "Passing Through",
          "Piano Duet",
          "Pigtail",
          "Piper",
          "Play by Play",
          "Poor Heart",
          "Possum",
          "Prep School Hippie",
          "Prince Caspian",
          "Punch Me in the Eye",
          "Punch You in the Eye",
          "PYITE",
          "Quadrophonic Toppling",
          "Reba",
          "Revolution",
          "Rhombus Narration",
          "Rift",
          "Riker's Mailbox",
          "Rock A William",
          "Rocketsled's Funky Main Man Meets Big Joe on Church Street",
          "Roggae",
          "Roll Like a Cantaloupe",
          "Rotation Jam",
          "Round Room",
          "Run Like an Antelope",
          "Runaway Jim",
          "Running Out of Time",
          "Sample in a Jar",
          "Sanity",
          "Say it to Me S.A.N.T.O.S.",
          "Say Something",
          "Scent of a Mule",
          "Scents and Subtle Sounds",
          "Secret Language Instructions",
          "Setting Sail",
          "Seven Below",
          "Shade",
          "Shafty",
          "Shipwreck",
          "Silent in the Morning",
          "Simple",
          "Sing Monica",
          "Skippy the Wondermouse",
          "Slave to the Traffic Light",
          "Sleep",
          "Sleeping Monkey",
          "Sleepwalk",
          "Snow",
          "SOAM",
          "Sparkle",
          "Split Open and Melt",
          "Spock's Brain",
          "Spread It 'Round",
          "Stash",
          "Stealing Time From the Faulty Plan",
          "Steam",
          "Steep",
          "Storage Jam",
          "Strange Design",
          "Stray Dog",
          "Sugar Shack",
          "Summer of '89",
          "Sunshine of Your Feeling",
          "Suzy Greenberg",
          "Swept Away",
          "T.V. Theme",
          "Talk",
          "Taste",
          "Taste That Surrounds",
          "Tela",
          "The Asse Festival",
          "The Birds",
          "The Birdwatcher",
          "The Chase",
          "The Chinese Water Torture",
          "The Connection",
          "The Curtain",
          "The Curtain With",
          "The Dickie Scotland Song",
          "The Divided Sky",
          "The Dogs",
          "The Final Hurrah",
          "The Fog That Surrounds",
          "The Happy Whip and Dung Song",
          "The Haunted House",
          "The Horse",
          "The Landlady",
          "The Line",
          "The Lizards",
          "The Man Who Stepped Into Yesterday",
          "The Mango Song",
          "The Moma Dance",
          "The Name is Slick",
          "The Oh Kee Pa Ceremony",
          "The Practical Song",
          "The Sloth",
          "The Squirming Coil",
          "The Unsafe Bridge",
          "The Very Long Fuse",
          "The Vibration of Life",
          "The Wedge",
          "Theme From the Bottom",
          "Things People Do",
          "Thread",
          "Tide Turns",
          "Timber",
          "Tiny",
          "Title Track",
          "TMWSIY",
          "Tomorrow's Song",
          "Tower Jam",
          "Train Song",
          "Tropical Hot Dog Night",
          "Trust Fund Baby",
          "TTE",
          "Tube",
          "Turtle in the Clouds",
          "Tweezer",
          "Tweezer Reprise",
          "Twenty Years Later",
          "Twist",
          "Two Versions of Me",
          "Union Federal",
          "Vacuum Solo",
          "Vultures",
          "Wading in the Velvet Sea",
          "Wait",
          "Waiting All Night",
          "Waking Up",
          "Waking Up Dead",
          "Walfredo",
          "Walls of the Cave",
          "Waste",
          "Water in the Sky",
          "Waves",
          "We Are Come to Outlive Our Brains",
          "Weekapaug Groove",
          "Weekly Time",
          "Weigh",
          "What Things Seem",
          "What You Will",
          "What's the Use?",
          "Who Do? We Do!",
          "Wilson",
          "Windham Hell",
          "Windy City",
          "Wingsuit",
          "Wolfman's Brother",
          "Wombat",
          "Yarmouth Road",
          "YEM",
          "You Enjoy Myself",
          "You Never Know",
          "Your Pet Cat"
        ]
      },
      "phone_number": {
        "area_code": [
          "201",
          "321",
          "416",
          "212",
          "604",
          "305",
          "514",
          "310",
          "613",
          "415",
          "617",
          "713",
          "905",
          "312",
          "619",
          "416",
          "702",
          "202",
          "403",
          "305"
        ],
        "country_code": [
          "1",
          "86",
          "91",
          "7",
          "81",
          "44",
          "49",
          "82",
          "55",
          "33",
          "92",
          "90",
          "62",
          "39",
          "34",
          "84",
          "20",
          "30",
          "62",
          "63",
          "64",
          "65",
          "66",
          "852",
          "1",
          "46",
          "41",
          "55",
          "54",
          "31"
        ],
        "exchange_code": [
          "201",
          "321",
          "416",
          "212",
          "652",
          "305",
          "514",
          "310",
          "613",
          "415"
        ],
        "formats": [
          "##########",
          "### ### ####",
          "###-###-####",
          "(###) ###-####",
          "###.###.####",
          "###-###-####",
          "(###) ### ####",
          "###-###-####",
          "###.###.####"
        ]
      },
      "prince": {
        "album": [
          "For You",
          "Prince",
          "Controversy",
          "Dirty Mind",
          "1999",
          "Purple Rain",
          "Around The World In A Day",
          "Lovesexy",
          "Sign O' The Times",
          "Graffiti Bridge",
          "Diamonds And Pearls",
          "O(+>",
          "Come",
          "The Black Album",
          "The Gold Experience",
          "Chaos And Disorder",
          "Emancipation",
          "Crystal Ball",
          "The Truth",
          "The Vault - Old Friends 4 Sale",
          "Rave Un2 the Joy Fantastic",
          "The Rainbow Children",
          "One Nite Alone...",
          "Xpectation",
          "N.E.W.S",
          "C-Note",
          "Musicology",
          "The Chocolate Invasion",
          "The Slaughterhouse",
          "3121",
          "Planet Earth",
          "LOtUSFLOW3R",
          "MPLSoUND",
          "20Ten",
          "PLECTRUMELECTRUM",
          "ART OFFICIAL AGE",
          "HITNRUN Phase One",
          "HITNRUN Phase Two",
          "Piano and a Microphone 1983",
          "Originals"
        ],
        "band": [
          "The Revolution",
          "The New Power Generation",
          "3rdeyegirl",
          "The Time",
          "Vanity 6",
          "Apollonia 6",
          "The Family"
        ],
        "lyric": [
          "Only want to see you laughing in the purple rain.",
          "It's been 7 hours and 16 days since you took your love away.",
          "All seven and we watch them fall. They stand in the way of love and we will smoke them all with an intellect, and a savoir faire",
          "It was only last June when her old man ran away. She couldn't stop crying cause she knew he was gone to stay.",
          "But I say, it's only mountains and the sea. Love will conquer if you just believe.",
          "Some say a man ain't happy unless a man truly dies.",
          "The girl on the seesaw is laughing, for love is the color this place imparts.",
          "People call me rude, I wish we all were nude. I wish there was no black and white, I wish there were no rules.",
          "Do I believe in God? Do I believe in me? Some people wanna die so they can be free.",
          "You didn't have the decency to change the sheets.",
          "And they say I'm so shy, yeah, but with you I just go wild!",
          "How can you just leave me standing alone in a world so cold?",
          "Don't worry, I won't hurt you... I only want you to have some fun.",
          "Is that your boyfriend? Ha, I don't care.",
          "Piano man, put it where it feel good!",
          "Rain is wet, and sugar is sweet. Clap your hands, and stomp your feet!",
          "You're gonna have to fight your own damn war, cause we don't want to fight no more.",
          "You ask me if I love you, it's automatic.",
          "Shut up already, damn!",
          "There's a brand new groove going 'round, in your funky town, and the kick drum is the fault.",
          "Come on y'all, we got to jam, before the police come. A groove this funky is on the run.",
          "Until the end of time, I'll be there for you.",
          "Life it ain't real funky, unless it's got that pop. Dig it.",
          "Meet me in another world, space and joy. Vous etes tres belle, mama, girls and boys.",
          "We all have our problems. Some big, some are small. Soon all of our problems will be taken by the cross.",
          "Love come quick, love come in a hurry, there are thieves in the temple tonight.",
          "Let's Groove, September, Earth, Wind and Fire, Hot Pants by James, Sly is going to take you higher.",
          "If it ain't Chuck D, or Jam Master Jay, know what? They're losin', cause we got a PhD in advanced body movin'.",
          "Where is my love life? Where can it be? There must be something wrong with the machinery.",
          "You need another lover like you need a hole in your head.",
          "If I came back as a dolphin, would you listen to me then?",
          "The reason that you're cool, is because you're from the old school, and they know it.",
          "I'm hot and I don't care who knows it, I got a job to do.",
          "I never meant to cause you any sorrow, I never meant to cause you any pain.",
          "Baby, I could never steal you from another, it's such a shame our friendship had to end.",
          "I guess I should've known, by the way you parked your car sideways that it wouldn't last.",
          "I guess I must be dumb, you had a pocket full of horses, Trojan and some of 'em used.",
          "Woke up the next morning, Nikki wasn't there. I looked all over and all I found was a phone number on the stairs. It said thank you for a funky time, call me up whenever you wanna grind.",
          "I was working part-time in a five-and-dime, my boss was Mr. McGee.",
          "The rain sound so cool when it hits the barn roof, and the horses wonder who you are.",
          "Everybody wants to tell what's already been told, what's the use of money if you ain't gonna break the mold?",
          "Even at the center of fire, there is cold, all that glitters ain't gold.",
          "Paint a perfect picture, bring to life a vision in one's mind. The beautiful ones always smash the picture. Always. Everytime.",
          "Now where I come from, we don't let society, tell us how it's supposed to be.",
          "My name is Prince, and I am funky. When it come to funk I am a junkie.",
          "My name is Prince, the one and only.",
          "In the beginning God made the sea, but on the seventh day he made me.",
          "Dearly beloved, we are gathered here today to get through this thing called life.",
          "Let's go crazy, let's get nuts! Look for the purple bandana until they put us in the truck, let's go!",
          "If I gave you diamonds and pearls, would you be a happy boy or a girl? If I could I would give you the world.",
          "I'm not a woman, I'm not a man, I am something that you'll never understand.",
          "Might not now it now, baby but I are, I'm a star!",
          "If a man is considered guilty for what goes on in his mind, then give me the electric chair for all my future crimes.",
          "I rock the party, I rock the house, I rock the whole world, north, east and south. In the west, - seventeen horns blowing.",
          "When we're dancing close and slow, I never want to let you go.",
          "I knew from the start, that I loved you with all my heart, but you were untrue. You had another lover and she looked just like you.",
          "Baby, baby when I look at you, I get a warm feeling inside.",
          "We've been together for quite some time, I'd think by now you'd know, it would take forever to get you off my mind if ever you decide to go.",
          "All of this and more is for you, with love, sincerity and deepest care, my life with you I share.",
          "All I want to see is the love in your eyes.",
          "We gonna play in the sunshine, we're going to get over. I'm feeling kinda lucky tonight I'm gonna find my four leaf clover.",
          "Before my life is done, some way, some how, I'm going to have fun.",
          "It was 7:45 and we were all line, to greet the teacher Miss Cathleen.",
          "Starfish and coffee, maple syrup and jam, butterscotch clouds, a tangerine, and a side order of ham.",
          "If I was your girlfriend, would you let me dress you?",
          "Would you let me wash your hair? Could I make you breakfast sometime? Or then, could we just hang out?",
          "Baby I just can't stand to see you happy, more than I hate to see you sad.",
          "Are your smiles, are your smiles for me?",
          "Dorothy was a waitress on the promenade, she worked the night shift, dishwater blonde, tall and fine, she got a lot of tips.",
          "You are my savior, you are my light, forever I want you in my life.",
          "Everybody wants to find Graffiti Bridge, something to believe in, a reason to believe that there's a heaven above.",
          "So what is the answer to the question of you? What do I look for, what shall I do?",
          "Kicking the jughead, doing the jughead, come on, get stupid!",
          "You can relax now, the max is in control.",
          "Why settle for a star when you can have the sun?",
          "You sho'nuf do be cookin' in my book!",
          "I was dreamin' when I wrote this, forgive me if I go astray.",
          "So tonight I'm gonna party like it's nineteen ninety-nine.",
          "You were so hard to find, the beautiful ones, they hurt you every time."
        ],
        "song": [
          "1-800-Newfunk Ad",
          "1000 X's & O's",
          "17 Days",
          "200 Balloons",
          "3 Chains o' Gold",
          "319",
          "A Love Bizarre",
          "Alphabet St.",
          "And God Created Woman",
          "Another Lonely Christmas",
          "Anotherloverholenyohead",
          "Automatic",
          "Baby I'm A Star",
          "Baltimore",
          "Bambi",
          "The Beautiful Ones",
          "Black Sweat",
          "Breakfast Can Wait",
          "Can't Stop This Feeling I Got",
          "Cindy C.",
          "Cloreen Baconskin",
          "Computer Blue",
          "Cream",
          "Crimson and Clover",
          "D.M.S.R",
          "Delirious",
          "Dead On It",
          "Do It All Night",
          "Darling Nikki",
          "Eye No",
          "Endorphinmachine",
          "Funk n' Roll",
          "Girls & Boys",
          "Gold",
          "Guitar",
          "Head",
          "The Greatest Romance Ever Sold",
          "How Come You Don't Call Me Anymore?",
          "Housequake",
          "I Feel For You",
          "I Hate U",
          "I Love U, but I Don't Trust U Anymore",
          "I Wanna Be Your Lover",
          "I Wish U Heaven",
          "I Would Die 4 U",
          "I Could Never Take The Place Of Your Man",
          "International Lover",
          "It's Gonna Be A Beautiful Night",
          "Jam Of The Year",
          "Joy In Repetition",
          "Kiss",
          "Le Grind",
          "Let's Go Crazy",
          "Little Red Corvette",
          "Lady Cab Driver",
          "Let's Work",
          "Mountains",
          "The Most Beautiful Girl In The World",
          "Nothing Compares 2 U",
          "New Position",
          "My Name Is Prince",
          "Money Don't Matter 2 Night",
          "Mr. Nelson",
          "Ol' Skool Company",
          "Paisley Park",
          "Pink Cashmere",
          "Peach",
          "Partyman",
          "Pop Life",
          "Play In The Sunshine",
          "Pretzel Body Logic",
          "Raspberry Beret",
          "Scandalous!",
          "Sexy MF",
          "Something in the Water (Does Not Compute)",
          "Strange Relationship",
          "Screwdriver",
          "She's Always In My Hair",
          "Sometimes It Snows In April",
          "Starfish And Coffee",
          "Still Waiting",
          "Superfunkycalifragisexy",
          "Take Me With U",
          "Tamborine",
          "(There'll Never B) Another Like Me",
          "Thunder",
          "Thieves In The Temple",
          "U Got The Look",
          "Under The Cherry Moon",
          "Uptown",
          "When Doves Cry",
          "When You Were Mine",
          "When 2 R In Love",
          "When We're Dancing Close And Slow"
        ]
      },
      "princess_bride": {
        "characters": [
          "Buttercup",
          "Westley",
          "Prince Humperdinck",
          "Vizzini",
          "Fezzik",
          "Inigo Montoya",
          "Count Rugen",
          "The Countess",
          "King Lotharon",
          "Queen Bella",
          "Miracle Max",
          "Valerie",
          "The Albino",
          "Dread Pirate Roberts",
          "Yellin",
          "Domingo Montoya",
          "Yeste"
        ],
        "quotes": [
          "Hello. My name is Inigo Montoya. You killed my father. Prepare to die!",
          "You rush a miracle man, you get rotten miracles.",
          "The rodents of unusual size? I don't believe they exist.",
          "He is only mostly dead. Not all dead. You can bring them back to life if they are only mostly dead. Now, give me that stick.",
          "Have fun storming the castle!",
          "You keep using that word. I do not think it means what you think it means.",
          "There is nothing better than true love in the whole world. Except a nice MLT. Mutton, lettuce, and tomato when the mutton is nice and lean and the lettuce is nice and crisp. Ohhh you can't beat it.",
          "Inconceivable!",
          "We'll never survive. Nonsense, you're only saying that because nobody ever has.",
          "I'll explain and I'll use small words so that you'll be sure to understand, you warthog faced buffoon.",
          "Hello. My name is Inigo Montoya. You killed my father. Prepare to die!",
          "As you wish.",
          "But first things first. To the death!",
          "The King's stinken son fired me and thank you so much for bringing up such a rotten subject. While you're at it, why don't you give me a nice paper cut and pore lemon juice on it. We're closed!",
          "You mean you'll put down your rock and I'll put down my sword, and we'll try and kill each other like civilized people?",
          "Mawage. Mawage is what bwings us togever today. Mawage that bwessed awangement, that dweam within a dweam.",
          "I'm not a witch I'm your wife. But after what you just said I'm not even sure I want to be that anymore.",
          "He didn't fall? INCONCEIVABLE!",
          "Are you coming down into the pit? Westly's got his strength back, I'm starting him on the machine tonight.",
          "I've hired you to help me start a war. It's an prestigious line of work, with a long and glorious tradition.",
          "I do not think you would accept my help, since I am only waiting around to kill you.",
          "That does put a damper on our relationship.",
          "Life is pain. Anyone who says different is trying to sell you something.",
          "Do you have 6 fingers on your left hand?",
          "You only think I guessed wrong! That's what's so funny! I switched glasses when your back was turned!",
          "Ha ha, you fool! You fell victim to one of the classic blunders! The most famous of which is never get involved in a land war in Asia, but only slightly less well-known is this: Never go in against a Sicilian when DEATH is on the line.",
          "It's not my fault being the biggest and the strongest. I don't even exercise.",
          "What you do not smell is called Iocane Power.",
          "We are men of action. Lies do not become us."
        ]
      },
      "programming_language": {
        "creator": [
          "John Backus",
          "Friedrich L. Bauer",
          "Gilad Bracha",
          "Walter Bright",
          "Alain Colmerauer",
          "Ole-Johan Dahl",
          "Brendan Eich",
          "James Gosling",
          "Anders Hejlsberg",
          "Rich Hickey",
          "Roberto Ierusalimschy",
          "Alan Kay",
          "Dan Ingalls",
          "Chris Lattner",
          "Yukihiro Matsumoto",
          "John McCarthy",
          "Martin Odersky",
          "Dennis Ritchie",
          "Guido van Rossum",
          "Guy L. Steele, Jr.",
          "Bjarne Stroustrup",
          "Don Syme",
          "Ken Thompson",
          "Larry Wall",
          "Philip Wadler"
        ],
        "name": [
          "A# .NET",
          "A# (Axiom)",
          "A-0 System",
          "A+",
          "A++",
          "ABAP",
          "ABC",
          "ABC ALGOL",
          "ABSET",
          "ABSYS",
          "ACC",
          "Accent",
          "Ace DASL (Distributed Application Specification Language)",
          "ACL2",
          "ACT-III",
          "Action!",
          "ActionScript",
          "Ada",
          "Adenine",
          "Agda",
          "Agilent VEE",
          "Agora",
          "AIMMS",
          "Aldor",
          "Alef",
          "ALF",
          "ALGOL 58",
          "ALGOL 60",
          "ALGOL 68",
          "ALGOL W",
          "Alice",
          "Alma-0",
          "AmbientTalk",
          "Amiga E",
          "AMOS",
          "AML (Arc Macro Language)",
          "AMPL",
          "AngelScript",
          "Apex (Salesforce.com)",
          "APL",
          "App Inventor for Android's visual block language",
          "AppleScript",
          "APT",
          "Arc",
          "ARexx",
          "Argus",
          "AspectJ",
          "Assembly language",
          "ATS",
          "Ateji PX",
          "AutoHotkey",
          "Autocoder",
          "AutoIt",
          "AutoLISP / Visual LISP",
          "Averest",
          "AWK",
          "Axum",
          "Active Server Pages",
          "B",
          "Babbage",
          "Ballerina",
          "Bash",
          "BASIC",
          "bc",
          "BCPL",
          "BeanShell",
          "Batch (Windows/Dos)",
          "Bertrand",
          "BETA",
          "Bistro",
          "BLISS",
          "Blockly",
          "BlooP",
          "Boo",
          "Boomerang",
          "Bourne shell (including bash and ksh)",
          "BPEL",
          "BrightScript",
          "Business Basic",
          "C",
          "C--",
          "C++ – ISO/IEC 14882",
          "C# – ISO/IEC 23270",
          "C/AL",
          "Caché ObjectScript",
          "C Shell (csh)",
          "Caml",
          "Calcpad",
          "Cayenne",
          "CDuce",
          "Cecil",
          "Cesil",
          "Céu",
          "Ceylon",
          "CFEngine",
          "Cg",
          "Ch",
          "Chapel",
          "Charity",
          "Charm",
          "CHILL",
          "CHIP-8",
          "chomski",
          "ChucK",
          "Cilk",
          "Citrine",
          "CL (IBM)",
          "Claire",
          "Clarion",
          "Clean",
          "Clipper",
          "CLIPS",
          "CLIST",
          "Clojure",
          "CLU",
          "CMS-2",
          "COBOL – ISO/IEC 1989",
          "CobolScript – COBOL Scripting language",
          "Cobra",
          "CoffeeScript",
          "ColdFusion",
          "COMAL",
          "Combined Programming Language (CPL)",
          "COMIT",
          "Common Intermediate Language (CIL)",
          "Common Lisp (also known as CL)",
          "COMPASS",
          "Component Pascal",
          "Constraint Handling Rules (CHR)",
          "COMTRAN",
          "Converge",
          "Cool",
          "Coq",
          "Coral 66",
          "CorVision",
          "COWSEL",
          "CPL",
          "Cryptol",
          "Crystal",
          "Csound",
          "CSP",
          "CUDA",
          "Cuneiform",
          "Curl",
          "Curry",
          "Cybil",
          "Cyclone",
          "Cython",
          "D",
          "DASL (Datapoint's Advanced Systems Language)",
          "Dart",
          "Darwin",
          "DataFlex",
          "Datalog",
          "DATATRIEVE",
          "dBase",
          "dc",
          "DCL",
          "Delphi",
          "DinkC",
          "DIBOL",
          "Dog",
          "Draco",
          "DRAKON",
          "Dylan",
          "DYNAMO",
          "DAX (Data Analysis Expressions)",
          "E",
          "Ease",
          "Easy PL/I",
          "EASYTRIEVE PLUS",
          "eC",
          "ECMAScript",
          "Edinburgh IMP",
          "EGL",
          "Eiffel",
          "ELAN",
          "Elixir",
          "Elm",
          "Emacs Lisp",
          "Emerald",
          "Epigram",
          "EPL (Easy Programming Language)",
          "EPL (Eltron Programming Language)",
          "Erlang",
          "es",
          "Escher",
          "ESPOL",
          "Esterel",
          "Etoys",
          "Euclid",
          "Euler",
          "Euphoria",
          "EusLisp Robot Programming Language",
          "CMS EXEC (EXEC)",
          "EXEC 2",
          "Executable UML",
          "F",
          "F#",
          "F*",
          "Factor",
          "Falcon",
          "Fantom",
          "FAUST",
          "FFP",
          "Fjölnir",
          "FL",
          "Flavors",
          "Flex",
          "FlooP",
          "FLOW-MATIC",
          "FOCAL",
          "FOCUS",
          "FOIL",
          "FORMAC",
          "@Formula",
          "Forth",
          "Fortran – ISO/IEC 1539",
          "Fortress",
          "FoxBase",
          "FoxPro",
          "FP",
          "Franz Lisp",
          "Frege",
          "F-Script",
          "G",
          "Game Maker Language",
          "GameMonkey Script",
          "GAMS",
          "GAP",
          "G-code",
          "GDScript",
          "Genie",
          "GDL",
          "GJ",
          "GEORGE",
          "GLSL",
          "GNU E",
          "GM",
          "Go",
          "Go!",
          "GOAL",
          "Gödel",
          "Golo",
          "GOM (Good Old Mad)",
          "Google Apps Script",
          "Gosu",
          "GOTRAN",
          "GPSS",
          "GraphTalk",
          "GRASS",
          "Groovy",
          "Hack",
          "HAGGIS",
          "HAL/S",
          "Halide (programming language)",
          "Hamilton C shell",
          "Harbour",
          "Hartmann pipelines",
          "Haskell",
          "Haxe",
          "Hermes",
          "High Level Assembly",
          "HLSL",
          "Hop",
          "Hopscotch",
          "Hope",
          "Hugo",
          "Hume",
          "HyperTalk",
          "Hexa",
          "Io",
          "Icon (programming language)",
          "IBM Basic assembly language",
          "IBM BASICA",
          "IBM HAScript",
          "IBM Informix-4GL",
          "IBM RPG",
          "IDL",
          "J",
          "J#",
          "J++",
          "JADE",
          "JAL",
          "Janus (concurrent constraint programming language)",
          "Janus (time-reversible computing programming language)",
          "JASS",
          "Java",
          "JavaScript",
          "JCL",
          "JEAN",
          "Join Java",
          "JOSS",
          "Joule",
          "JOVIAL",
          "Joy",
          "JScript",
          "JScript .NET",
          "JavaFX Script",
          "jq",
          "Julia",
          "Jython",
          "K",
          "Kaleidoscope",
          "Kafe",
          "Karel",
          "Karel++",
          "KEE",
          "Kixtart",
          "Klerer-May System",
          "KIF",
          "Kojo",
          "Kotlin",
          "KRC",
          "KRL",
          "KRL (KUKA Robot Language)",
          "KRYPTON",
          "ksh",
          "Kodu",
          "L",
          "LabVIEW",
          "Ladder",
          "Lagoona",
          "LANSA",
          "Lasso",
          "LaTeX",
          "Lava",
          "LC-3",
          "Leda",
          "Legoscript",
          "LIL",
          "LilyPond",
          "Limbo",
          "Limnor",
          "LINC",
          "Lingo",
          "LIS",
          "LISA",
          "Lisaac",
          "Lisp – ISO/IEC 13816",
          "Lite-C",
          "Lithe",
          "Little b",
          "LLL",
          "Logo",
          "Logtalk",
          "LotusScript",
          "LPC",
          "LSE",
          "LSL",
          "LiveCode",
          "LiveScript",
          "Lua",
          "Lucid",
          "Lustre",
          "LYaPAS",
          "Lynx",
          "M (alternative name for the MUMPS programming language)",
          "M2000",
          "M2001",
          "M4",
          "M#",
          "Machine code",
          "MAD (Michigan Algorithm Decoder)",
          "MAD/I",
          "Magik",
          "Magma",
          "make",
          "Maude system",
          "Maple",
          "MAPPER (now part of BIS)",
          "MARK-IV (now VISION:BUILDER)",
          "Mary",
          "MASM Microsoft Assembly x86",
          "MATH-MATIC",
          "Mathematica",
          "MATLAB",
          "Maxima (see also Macsyma)",
          "Max (Max Msp – Graphical Programming Environment)",
          "MaxScript internal language 3D Studio Max",
          "Maya (MEL)",
          "M++",
          "MDL",
          "Mercury",
          "Mesa",
          "Metafont",
          "MetaQuotes Language (MQL4/MQL5)",
          "MHEG-5 (Interactive TV programming language)",
          "Microcode",
          "MicroScript",
          "MIIS",
          "Milk (programming language)",
          "MIMIC",
          "Mirah",
          "Miranda",
          "MIVA Script",
          "ML",
          "Model 204",
          "Modelica",
          "Modula",
          "Modula-2",
          "Modula-3",
          "Mohol",
          "MOO",
          "Mortran",
          "Mouse",
          "MPD",
          "Mathcad",
          "MSIL – deprecated name for CIL",
          "MSL",
          "MUMPS",
          "MuPAD",
          "Mutan",
          "Mystic Programming Language (MPL)",
          "NASM",
          "Napier88",
          "Neko",
          "Nemerle",
          "nesC",
          "NESL",
          "Net.Data",
          "NetLogo",
          "NetRexx",
          "NewLISP",
          "NEWP",
          "Newspeak",
          "NewtonScript",
          "NGL",
          "Nial",
          "Nice",
          "Nickle (NITIN)",
          "Nim",
          "NPL",
          "Not eXactly C (NXC)",
          "Not Quite C (NQC)",
          "NSIS",
          "Nu",
          "NWScript",
          "NXT-G",
          "o:XML",
          "Oak",
          "Oberon",
          "OBJ2",
          "Object Lisp",
          "ObjectLOGO",
          "Object REXX",
          "Object Pascal",
          "Objective-C",
          "Objective-J",
          "Obliq",
          "OCaml",
          "occam",
          "occam-π",
          "Octave",
          "OmniMark",
          "Onyx",
          "Opa",
          "Opal",
          "OpenCL",
          "OpenEdge ABL",
          "OPL",
          "OpenVera",
          "OPS5",
          "OptimJ",
          "Orc",
          "ORCA/Modula-2",
          "Oriel",
          "Orwell",
          "Oxygene",
          "Oz",
          "P",
          "P′′",
          "P#",
          "ParaSail (programming language)",
          "PARI/GP",
          "Pascal – ISO 7185",
          "PCASTL",
          "PCF",
          "PEARL",
          "PeopleCode",
          "Perl",
          "PDL",
          "Perl 6",
          "Pharo",
          "PHP",
          "Pico",
          "Picolisp",
          "Pict",
          "Pig (programming tool)",
          "Pike",
          "PIKT",
          "PILOT",
          "Pipelines",
          "Pizza",
          "PL-11",
          "PL/0",
          "PL/B",
          "PL/C",
          "PL/I – ISO 6160",
          "PL/M",
          "PL/P",
          "PL/SQL",
          "PL360",
          "PLANC",
          "munoz",
          "Plankalkül",
          "Planner",
          "PLEX",
          "PLEXIL",
          "Plus",
          "Pony",
          "POP-11",
          "POP-2",
          "PostScript",
          "PortablE",
          "Powerhouse",
          "PowerBuilder – 4GL GUI application generator from Sybase",
          "PowerShell",
          "PPL",
          "Processing",
          "Processing.js",
          "Prograph",
          "PROIV",
          "Prolog",
          "PROMAL",
          "Promela",
          "PROSE modeling language",
          "PROTEL",
          "ProvideX",
          "Pro*C",
          "Pure",
          "PureBasic",
          "Pure Data",
          "Python",
          "Q (equational programming language)",
          "Q (programming language from Kx Systems)",
          "Q# (Microsoft programming language)",
          "Qalb",
          "QtScript",
          "QuakeC",
          "QPL",
          "R",
          "R++",
          "Racket",
          "RAPID",
          "Rapira",
          "Ratfiv",
          "Ratfor",
          "rc",
          "Reason",
          "REBOL",
          "Red",
          "Redcode",
          "REFAL",
          "Reia",
          "REXX",
          "Ring",
          "Rlab",
          "ROOP",
          "RPG",
          "RPL",
          "RSL",
          "RTL/2",
          "Ruby",
          "RuneScript",
          "Rust",
          "S",
          "S2",
          "S3",
          "S-Lang",
          "S-PLUS",
          "SA-C",
          "SabreTalk",
          "SAIL",
          "SALSA",
          "SAM76",
          "SAS",
          "SASL",
          "Sather",
          "Sawzall",
          "SBL",
          "Scala",
          "Scheme",
          "Scilab",
          "Script.NET",
          "Sed",
          "Seed7",
          "Self",
          "SenseTalk",
          "SequenceL",
          "Serpent",
          "SETL",
          "SIMPOL",
          "SIGNAL",
          "SiMPLE",
          "SIMSCRIPT",
          "Simula",
          "Simulink",
          "Singularity",
          "SISAL",
          "SLIP",
          "SMALL",
          "Scratch",
          "Smalltalk",
          "SML",
          "Strongtalk",
          "Snap!",
          "SNOBOL(SPITBOL)",
          "Snowball",
          "SOL",
          "Solidity",
          "SOPHAEROS",
          "SPARK",
          "Speedcode",
          "SPIN",
          "SP/k",
          "SPS",
          "SQR",
          "Squeak",
          "Squirrel",
          "SR",
          "S/SL",
          "Stackless Python",
          "Starlogo",
          "Strand",
          "Stata",
          "Stateflow",
          "Subtext",
          "SuperCollider",
          "SuperTalk",
          "Swift (Apple programming language)",
          "Swift (parallel scripting language)",
          "SYMPL",
          "SyncCharts",
          "SystemVerilog",
          "T",
          "TACL",
          "TACPOL",
          "TADS",
          "TAL",
          "Tcl",
          "Tea",
          "TECO",
          "TELCOMP",
          "TeX",
          "TEX",
          "TIE",
          "Timber",
          "TMG, compiler-compiler",
          "Tom",
          "TOM",
          "Toi",
          "Topspeed",
          "TPU",
          "Trac",
          "TTM",
          "T-SQL",
          "Transcript",
          "TTCN",
          "Turing",
          "TUTOR",
          "TXL",
          "TypeScript",
          "Tynker",
          "Ubercode",
          "UCSD Pascal",
          "Umple",
          "Unicon",
          "Uniface",
          "UNITY",
          "UniVerse Basic",
          "Unix shell",
          "UnrealScript",
          "Vala",
          "Verilog",
          "Viper",
          "Visual Basic",
          "Visual Basic .NET",
          "Visual DataFlex",
          "Visual DialogScript",
          "Visual Fortran",
          "Visual FoxPro",
          "Visual J++",
          "Visual J#",
          "Visual LISP",
          "Visual Objects",
          "Visual Prolog",
          "VSXu",
          "VVML (Verification Validation Mark-up Language)",
          "vvvv",
          "WATFIV, WATFOR",
          "WebDNA",
          "WebQL",
          "Whiley",
          "Winbatch",
          "Wolfram Language",
          "Wyvern",
          "X++",
          "X10",
          "XBL",
          "XC (exploits XMOS architecture)",
          "xHarbour",
          "XL",
          "Xojo",
          "XOTcl",
          "XPL",
          "XPL0",
          "XQuery",
          "XSB",
          "XSharp",
          "XSLT – see XPath",
          "Xtend",
          "Yorick",
          "YQL",
          "Yoix",
          "Z",
          "Z notation",
          "Zap",
          "Zebra, ZPL, ZPL2",
          "Zeno",
          "ZetaLisp",
          "ZIL",
          "ZOPL",
          "Zsh",
          "ZPL",
          "Z++"
        ]
      },
      "quote": {
        "famous_last_words": [
          "I don't know.",
          "No comment.",
          "Van Halen!",
          "Is it not meningitis?",
          "I love you too, honey. Good luck with your show.",
          "Am I dying, or is this my birthday?",
          "I want your bunk!",
          "I went the distance.",
          "Goodnight, my darlings, I'll see you tomorrow.",
          "I am confound.",
          "That was the best ice-cream soda I ever tasted.",
          "All my possessions for a moment of time.",
          "Hurrah for anarchy! This is the happiest moment of my life.",
          "It's stopped.",
          "You can get anything you want at Alice's restaurant.",
          "Yes, it's tough, but not as tough as doing comedy.",
          "That's good. Go on, read some more.",
          "I love you.",
          "One! Two! Three!",
          "Do you want me to come with you?",
          "Does nobody understand?",
          "I wish I could go with you.",
          "I'll be in Hell before you start breakfast! Let her rip!",
          "Tape Seinfeld for me.",
          "Strike the tent.",
          "I don't think they even heard me.",
          "I regret that I should leave this world without again beholding him.",
          "Well, this is certainly a pleasant surprise.",
          "Okay, I won't.",
          "I want to go home.",
          "Happy.",
          "I forgot something.",
          "My vocabulary did this to me. Your love will let you go on…"
        ],
        "fortune_cookie": [
          "This cookie senses that you are superstitious; it is an inclination that is bad for your mental health.",
          "Goodness comes to those who wait.",
          "Two wrongs do not make a right.",
          "A rolling stone gathers no moss.",
          "Destiny is what you choose it to be; fate is what happens when you relinquish your freedom",
          "Failure is fuel for victory",
          "A black cat is not bad luck for a blind man.",
          "To hesitate is to be lost."
        ],
        "jack_handey": [
          "When you die, if you get a choice between going to regular heaven or pie heaven, choose pie heaven. It might be a trick, but if it's not, mmmmmmmm, boy.",
          "I'd rather be rich than stupid.",
          "Whether they find life there or not, I think Jupiter should be called an enemy planet.",
          "If you ever drop your keys into a river of molten lava, let 'em go, because man, they're gone.",
          "Love can sweep you off your feet and carry you along in a way you've never known before. But the ride always ends, and you end up feeling lonely and bitter. Wait. It's not love I'm describing. I'm thinking of a monorail.",
          "Ambition is like a frog sitting on a Venus Flytrap. The flytrap can bite and bite, but it won't bother the frog because it only has little tiny plant teeth. But some other stuff could happen and it could be like ambition.",
          "It's interesting to think that my ancestors used to live in the trees, like apes, until finally they got the nerve to head out onto the plains, where some were probably hit by cars.",
          "Instead of having \"answers\" on a math test, they should just call them \"impressions,\" and if you got a different \"impression,\" so what, can't we all be brothers?",
          "If they ever come up with a swashbuckling school, I think one of the courses should be laughing, then jumping off something.",
          "I can't stand cheap people. It makes me real mad when someone says something like, \"Hey, when are you going to pay me that $100 you owe me?\" or \"Do you have that $50 you borrowed?\" Man, quit being so cheap!",
          "Sometimes I think you have to march right in and demand your rights, even if you don't know what your rights are, or who the person is you're talking to. Then on the way out, slam the door.",
          "We tend to scoff at the beliefs of the ancients. But we can't scoff at them personally, to their faces, and this is what annoys me.",
          "Somebody told me it was frightening how much topsoil we are losing each year, but I told that story around the campfire and nobody got scared.",
          "The difference between a man and a boy is, a boy wants to grow up to be a fireman, but a man wants to grow up to be a giant monster fireman.",
          "If any man says he hates war more than I do, he better have a knife, that's all I have to say.",
          "If God dwells inside us like some people say, I sure hope He likes enchiladas, because that's what He's getting.",
          "Sometimes life seems like a dream, especially when I look down and see that I forgot to put on my pants.",
          "If you saw two guys named Hambone and Flippy, which one would you think liked dolphins most? I'd say Flippy, wouldn't you? You'd be wrong though. It's Hambone.",
          "Instead of a trap door, what about a trap window? The guy looks out it, and if he leans too far, he falls out. Wait. I guess that's like a regular window.",
          "When you go in for a job interview, I think a good thing to ask is if they ever press charges.",
          "If you ever catch on fire, try to avoid looking in a mirror, because I bet that will really throw you into a panic.",
          "One thing vampire children have to be taught early on is, never run with a wooden stake.",
          "Laurie got offended that I used the word \"puke.\" But to me, that's what her dinner tasted like.",
          "If you ever fall off the Sears Tower, just go real limp, because maybe you'll look like a dummy and people will try to catch you because, hey, free dummy.",
          "When I was a kid my favorite relative was Uncle Caveman. After school we'd all go play in his cave, and every once in a while he would eat one of us. It wasn't until later that I found out that Uncle Caveman was a bear.",
          "To me, it's a good idea to always carry two sacks of something when you walk around. That way, if anybody says, \"Hey, can you give me a hand?\" You can say, \"Sorry, got these sacks.\"",
          "If you're robbing a bank and your pants fall down, I think it's okay to laugh and to let the hostages laugh too, because, come on, life is funny.",
          "Whenever you read a good book, it's like the author is right there, in the room talking to you, which is why I don't like to read good books.",
          "If you lose your job, your marriage and your mind all in one week, try to lose your mind first, because then the other stuff won't matter that much.",
          "I wish I had a kryptonite cross, because then you could keep both Dracula and Superman away.",
          "Instead of trying to build newer and bigger weapons of destruction, we should be thinking about getting more use out of the ones we already have.",
          "Any man, in the right situation, is capable of murder. But not any man is capable of being a good camper. So, murder and camping are not as similar as you might think.",
          "I hope life isn't a big joke, because I don't get it.",
          "If I had a mine shaft, I don't think I would just abandon it. There's got to be a better way.",
          "One thing a computer can do that most humans can't is be sealed up in a cardboard box and sit in a warehouse.",
          "If trees could scream, would we be so cavalier about cutting them down? We might, if they screamed all the time, for no good reason.",
          "Dad always thought laughter was the best medicine, which I guess is why several of us died of tuberculosis.",
          "What is it that makes a complete stranger dive into an icy river to save a solid gold baby? Maybe we'll never know.",
          "I hope that after I die, people will say of me, \"That guy sure owed me a lot of money.\"",
          "I think the monkeys at the zoo should have to wear sunglasses so they can't hypnotize you.",
          "I bet one legend that keeps recurring throughout history, in every culture, is the story of Popeye.",
          "If you ever teach a yodeling class, probably the hardest thing is to keep the students from just trying to yodel right off. You see, we build to that.",
          "To me, boxing is like a ballet, except there's no music, no choreography, and the dancers hit each other.",
          "When I think of all the hours and hours of my life I have spent watching television, it makes me realize, Man, I am really rich with television.",
          "Never laugh at a man, until you have walked a mile in his shoes; then you are a mile away, and you have his shoes.",
          "Just as irrigation is the lifeblood of the Southwest, lifeblood is the soup of cannibals.",
          "With every new sunrise, there is a new chance; but with every sunset, you blew it.",
          "Many people don't realize that playing dead can help not only with bears, but also at important business meetings.",
          "I bet a funny thing about driving a car off a cliff is, while you're in midair, you still hit those brakes. Hey, better try the emergency brake.",
          "One day one of my little nephews came up to me and asked me if the equator was a real line that went around the Earth, or just an imaginary one. I had to laugh. Laugh and laugh. Because I didn't know, and I thought that maybe by laughing he would forget what he asked me."
        ],
        "matz": [
          "I believe consistency and orthogonality are tools of design, not the primary goal in design.",
          "From the viewpoint of what you can do, therefore, languages do differ - but the differences are limited. For example, Python and Ruby provide almost the same power to the programmer.",
          "The orthogonal features, when combined, can explode into complexity.",
          "I didn't work hard to make Ruby perfect for everyone, because you feel differently from me. No language can be perfect for everyone. I tried to make Ruby perfect for me, but maybe it's not perfect for you. The perfect language for Guido van Rossum is probably Python.",
          "Because of the Turing completeness theory, everything one Turing-complete language can do can theoretically be done by another Turing-complete language, but at a different cost. You can do everything in assembler, but no one wants to program in assembler anymore.",
          "Ruby inherited the Perl philosophy of having more than one way to do the same thing. I inherited that philosophy from Larry Wall, who is my hero actually. I want to make Ruby users free. I want to give them the freedom to choose.",
          "You want to enjoy life, don't you? If you get your job done quickly and your job is fun, that's good isn't it? That's the purpose of life, partly. Your life is better.",
          "People are different. People choose different criteria. But if there is a better way among many alternatives, I want to encourage that way by making it comfortable. So that's what I've tried to do.",
          "In our daily lives as programmers, we process text strings a lot. So I tried to work hard on text processing, namely the string class and regular expressions. Regular expressions are built into the language and are very tuned up for use.",
          "Most of the tasks we do are for humans. For example, a tax calculation is counting numbers so the government can pull money out from my wallet, but government consists of humans.",
          "Actually, I didn't make the claim that Ruby follows the principle of least surprise. Someone felt the design of Ruby follows that philosophy, so they started saying that. I didn't bring that up, actually.",
          "Smart people underestimate the ordinarity of ordinary people.",
          "Language designers want to design the perfect language. They want to be able to say, 'My language is perfect. It can do everything.' But it's just plain impossible to design a perfect language, because there are two ways to look at a language. One way is by looking at what can be done with that language. The other is by looking at how we feel using that language-how we feel while programming.",
          "I believe that the purpose of life is, at least in part, to be happy. Based on this belief, Ruby is designed to make programming not only easy but also fun. It allows you to concentrate on the creative side of programming, with less stress.",
          "Most programs are not write-once. They are reworked and rewritten again and again in their lived. Bugs must be debugged. Changing requirements and the need for increased functionality mean the program itself may be modified on an ongoing basis. During this process, human beings must be able to read and understand the original code. It is therefore more important by far for humans to be able to understand the program than it is for the computer.",
          "I hope to see Ruby help every programmer in the world to be productive, and to enjoy programming, and to be happy. That is the primary purpose of Ruby language.",
          "Man is driven to create; I know I really love to create things. And while I'm not good at painting, drawing, or music, I can write software.",
          "It is not the responsibility of the language to force good looking code, but the language should make good looking code possible.",
          "Plant a memory, plant a tree, do it today for tomorrow.",
          "Imagine you are writing an email. You are in front of the computer. You are operating the computer, clicking a mouse and typing on a keyboard, but the message will be sent to a human over the internet. So you are working before the computer, but with a human behind the computer.",
          "Often people, especially computer engineers, focus on the machines. But in fact we need to focus on humans, on how humans care about doing programming or operating the application of the machines.",
          "Everyone has an individual background. Someone may come from Python, someone else may come from Perl, and they may be surprised by different aspects of the language. Then they come up to me and say, 'I was surprised by this feature of the language, so therefore Ruby violates the principle of least surprise.' Wait. Wait. The principle of least surprise is not for you only.",
          "Sometimes people jot down pseudo-code on paper. If that pseudo-code runs directly on their computers, its best, isn't it? Ruby tries to be like that, like pseudo-code that runs. Python people say that too."
        ],
        "mitch_hedberg": [
          "An escalator can never break, it can only become stairs. You should never see an 'Escalator Temporarily Out Of Order' sign, just 'Escalator Temporarily Stairs. Sorry for the convenience'.",
          "I'm sick of following my dreams. I'm just going to ask them where they're goin', and hook up with them later.",
          "Is a hippopotamus a hippopotamus, or just a really cool Opotamus?",
          "I don't have a girlfriend. But I do know a woman who'd be mad at me for saying that.",
          "I was at this casino minding my own business, and this guy came up to me and said, 'You're gonna have to move, you're blocking a fire exit.' As though if there was a fire, I wasn't gonna run. If you're flammible and have legs, you are never blocking a fire exit.",
          "Rice is great if you're really hungry and want to eat two thousand of something.",
          "My friend asked me if I wanted a frozen banana. I said 'No, but I want a regular banana later, so... yeah.'",
          "My belt holds my pants up, but the belt loops hold my belt up. I don't really know what's happening down there. Who is the real hero?",
          "I wanted to buy a candle holder, but the store didn't have one. So I got a cake.",
          "I haven't slept for ten days, because that would be too long.",
          "I like refried beans. That's why I wanna try fried beans, because maybe they're just as good and we're just wasting time.",
          "Y'know, you can't please all the people all the time... and last night, all those people were at my show.",
          "Fettucini alfredo is macaroni and cheese for adults.",
          "I bought a seven-dollar pen because I always lose pens and I got sick of not caring.",
          "I want to get a vending machine, with fun sized candy bars, and the glass in front is a magnifying glass. You'll be mad, but it will be too late.",
          "This shirt is dry clean only. Which means it's dirty.",
          "If carrots got you drunk, rabbits would be messed-up.",
          "The depressing thing about tennis is that no matter how good I get, I'll never be as good as a wall.",
          "I'm against picketing, but I don't know how to show it.",
          "I like to play blackjack. I'm not addicted to gambling. I'm addicted to sitting in a semi-circle.",
          "Every time I go and shave, I assume there's someone else on the planet shaving. So I say, 'I'm gonna go shave, too.'",
          "I recently took up ice sculpting. Last night I made an ice cube. This morning I made 12, I was prolific.",
          "I would imagine that if you could understand Morse code, a tap dancer would drive you crazy.",
          "I had a stick of CareFree gum, but it didn't work. I felt pretty good while I was blowing that bubble, but as soon as the gum lost its flavor, I was back to pondering my mortality.",
          "I drank some boiling water because I wanted to whistle.",
          "I like to hold the microphone cord like this, I pinch it together, then I let it go, then you hear a whole bunch of jokes at once.",
          "My sister wanted to be an actress, but she never made it. She does live in a trailer. She got halfway. She's an actress, she just never gets called to the set.",
          "I'd like to get four people who do cart wheels very good, and make a cart.",
          "If my kid couldn't draw I'd make sure that my kitchen magnets didn't work.",
          "I saw a human pyramid once. It was very unnecessary.",
          "People teach their dogs to sit; it's a trick. I've been sitting my whole life, and a dog has never looked at me as though he thought I was tricky.",
          "I wish my name was Brian because maybe sometimes people would misspell my name and call me Brain. That's like a free compliment and you don't even gotta be smart to notice it.",
          "It's very dangerous to wave to people you don't know because what if they don't have hands? They'll think you're cocky.",
          "I like Kit-Kats, unless I'm with four or more people.",
          "Dogs are forever in the push up postion.",
          "I wish I could play little league now. I'd be way better than before.",
          "When someone hands you a flyer, it's like they're saying here you throw this away.",
          "I once saw a forklift lift a crate of forks. And it was way to literal for me.",
          "Every book is a children's book if the kid can read.",
          "I'm a heroine addict. I need to have sex with women who have saved someone's life.",
          "I wear a necklace, cause I wanna know when I'm upside down.",
          "You know when they have a fishing show on TV? They catch the fish and then let it go. They don't want to eat the fish, they just want to make it late for something."
        ],
        "most_interesting_man_in_the_world": [
          "His only regret is not knowing what regret feels like.",
          "When in Rome, they do as HE does",
          "He is considered a national treasure in countries he’s never visited.",
          "He has won the lifetime achievement award… twice",
          "He can kill two stones with one bird",
          "When a tree falls in a forest and no one is there, he hears it",
          "His lovemaking has been detected by a seismograph",
          "He once had an awkward moment, just to see how it feels",
          "He is fluent in all languages, including three that he only speaks",
          "If opportunity knocks, and he’s not at home, opportunity waits",
          "Mosquitoes refuse to bite him purely out of respect",
          "He has taught old dogs a variety of new tricks",
          "In museums, he is allowed to touch the art",
          "His business card simply says ‘I’ll Call You”",
          "If he was to pat you on the back, you would list it on your resume.",
          "Freemasons strive to learn HIS secret handshake.",
          "He played a game of Russian Roulette with a fully loaded magnum, and won",
          "He is the life of parties that he has never attended",
          "He once won the Tour-de-France, but was disqualified for riding a unicycle",
          "His organ donation card also lists his beard",
          "He is left-handed. And right-handed",
          "Sharks have a week dedicated to him",
          "Presidents take his birthday off",
          "Time waits on no one, but him",
          "He never wears a watch because time is always on his side",
          "He taught Chuck Norris martial arts",
          "When he holds a lady’s purse, he looks manly",
          "He once won a staring contest with his own reflection",
          "When he meets the Pope, the Pope kisses his ring",
          "His beard alone has experienced more than a lesser man’s entire body",
          "Superman has pijamas with his logo",
          "If he were to punch you in the face you would have to fight off a strong urge to thank him",
          "He once went to the psychic, to warn her",
          "His feet don’t get blisters, but his shoes do",
          "When he drives a car off the lot, its price increases in value",
          "On every continent in the world, there is a sandwich named after him.",
          "Once a rattlesnake bit him, after 5 days of excruciating pain, the snake finally died",
          "His passport requires no photograph",
          "He gave his father “the talk”",
          "He can speak Russian… in French",
          "His signature won a Pulitzer",
          "Once while sailing around the world, he discovered a short cut",
          "He once got pulled over for speeding, and the cop got the ticket",
          "The dark is afraid of him",
          "If he were to visit the dark side of the moon, it wouldn’t be dark",
          "He once brought a knife to a gunfight… just to even the odds",
          "He bowls overhand",
          "A bird in his hand is worth three in the bush",
          "He once started a fire using only dental floss and water",
          "Roses stop to smell him",
          "Bigfoot tries to get pictures of him",
          "He once turned a vampire into a vegetarian",
          "Batman watches Saturday morning cartoons about him",
          "When he was young he once sent his parents to his room",
          "His blood smells like cologne",
          "When he goes to Spain, he chases the bulls",
          "His shadow has been on the ‘best dressed’ list twice",
          "Two countries went to war to dispute HIS nationality",
          "His pillow is cool on BOTH sides",
          "The Nobel Academy was awarded a prize from HIM",
          "His mother has a tattoo that says “Son”",
          "His shirts never wrinkle",
          "Respected archaeologists fight over his discarded apple cores",
          "His garden maze is responsible for more missing persons than the bermuda triangle",
          "He doesn’t believe in using oven mitts, nor potholders",
          "His cereal never gets soggy. It sits there, staying crispy, just for him",
          "The police often question him, just because they find him interesting",
          "He has never walked into a spider web",
          "The star on his Christmas tree is tracked by NASA",
          "He’s never lost a game of chance",
          "He once caught the Loch Ness Monster….with a cane pole, but threw it back",
          "His wallet is woven out of chupacabra leather",
          "Cars look both ways for him, before driving down a street",
          "His 5 de Mayo party starts on the 8th of March",
          "His tears can cure cancer, too bad he never cries",
          "His friends call him by his name, his enemies don’t call him anything because they are all dead",
          "No less than 25 Mexican folk songs have been written about his beard",
          "He once taught a german shepherd how to bark in Spanish",
          "The Holy Grail is looking for him",
          "Werewolves are jealous of his beard",
          "Once he ran a marathon because it was “on the way”",
          "He was on a recent archaeological dig and came across prehistoric foot prints that lead out of Africa into all parts of the world. On close inspection, it turned out that the prints were his",
          "Whatever side of the tracks he’s currently on is the right side, even if he crosses the tracks he’ll still be on the right side",
          "The circus ran away to join him",
          "He once made a weeping willow laugh",
          "He is allowed to talk about the fight club",
          "His sweat is the cure for the common cold",
          "While swimming off the coast of Australia, he once scratched the underbelly of the Great White with his right hand",
          "If he were to say something costs an arm and a leg, it would",
          "He never says something tastes like chicken.. not even chicken",
          "Panhandlers give him money",
          "He once tried to acquire a cold just to see what it felt like, but it didn’t take",
          "His ten gallon hat holds twenty gallons",
          "He once won the world series of poker using UNO cards",
          "He has inside jokes with people he’s never met.",
          "Bear hugs are what he gives bears",
          "Even his tree houses have fully finished basements",
          "He has never waited 15 minutes after finishing a meal before returning to the pool",
          "He lives vicariously through himself"
        ],
        "robin": [
          "Holy Agility",
          "Holy Almost",
          "Holy Alphabet",
          "Holy Alps",
          "Holy Alter Ego",
          "Holy Anagram",
          "Holy Apparition",
          "Holy Armadillo",
          "Holy Armour Plate",
          "Holy Ashtray",
          "Holy Asp",
          "Holy Astronomy",
          "Holy Astringent Plum-like Fruit",
          "Holy Audubon",
          "Holy Backfire",
          "Holy Ball And Chain",
          "Holy Bank Balance",
          "Holy Bankruptcy",
          "Holy Banks",
          "Holy Bargain Basements",
          "Holy Barracuda",
          "Holy Bat Logic",
          "Holy Bat Trap",
          "Holy Batman",
          "Holy Benedict Arnold",
          "Holy Bijou",
          "Holy Bikini",
          "Holy Bill Of Rights",
          "Holy Birthday Cake",
          "Holy Black Beard",
          "Holy Blackout",
          "Holy Blank Cartridge",
          "Holy Blizzard",
          "Holy Blonde Mackerel Ash",
          "Holy Bluebeard",
          "Holy Bouncing Boiler Plate",
          "Holy Bowler",
          "Holy Bullseye",
          "Holy Bunions",
          "Holy Caffeine",
          "Holy Camouflage",
          "Holy Captain Nemo",
          "Holy Caruso",
          "Holy Catastrophe",
          "Holy Cat(s)",
          "Holy Chicken Coop",
          "Holy Chilblains",
          "Holy Chocolate Eclair",
          "Holy Cinderella",
          "Holy Cinemascope",
          "Holy Cliche",
          "Holy Cliffhangers",
          "Holy Clockwork",
          "Holy Clockworks",
          "Holy Cofax You Mean",
          "Holy Coffin Nails",
          "Holy Cold Creeps",
          "Holy Complications",
          "Holy Conflagration",
          "Holy Contributing to the Delinquency of Minors",
          "Holy Corpuscles",
          "Holy Cosmos",
          "Holy Costume Party",
          "Holy Crack Up",
          "Holy Crickets",
          "Holy Crossfire",
          "Holy Crucial Moment",
          "Holy Cryptology",
          "Holy D'artagnan",
          "Holy Davy Jones",
          "Holy Detonator",
          "Holy Disappearing Act",
          "Holy Distortion",
          "Holy Diversionary Tactics",
          "Holy Dr. Jekyll and Mr. Hyde",
          "Holy Egg Shells",
          "Holy Encore",
          "Holy Endangered Species",
          "Holy Epigrams",
          "Holy Escape-hatch",
          "Holy Explosion",
          "Holy Fate-worse-than-death",
          "Holy Felony",
          "Holy Finishing-touches",
          "Holy Fireworks",
          "Holy Firing Squad",
          "Holy Fishbowl",
          "Holy Flight Plan",
          "Holy Flip-flop",
          "Holy Flood Gate",
          "Holy Floor Covering",
          "Holy Flypaper",
          "Holy Fly Trap",
          "Holy Fog",
          "Holy Forecast",
          "Holy Fork In The Road",
          "Holy Fourth Amendment",
          "Holy Fourth Of July",
          "Holy Frankenstein",
          "Holy Frankenstein It's Alive",
          "Holy Fratricide",
          "Holy Frogman",
          "Holy Fruit Salad",
          "Holy Frying Towels",
          "Holy Funny Bone",
          "Holy Gall",
          "Holy Gambles",
          "Holy Gemini",
          "Holy Geography",
          "Holy Ghost Writer",
          "Holy Giveaways",
          "Holy Glow Pot",
          "Holy Golden Gate",
          "Holy Graf Zeppelin",
          "Holy Grammar",
          "Holy Graveyards",
          "Holy Greed",
          "Holy Green Card",
          "Holy Greetings-cards",
          "Holy Guacamole",
          "Holy Guadalcanal",
          "Holy Gullibility",
          "Holy Gunpowder",
          "Holy Haberdashery",
          "Holy Hailstorm",
          "Holy Hairdo",
          "Holy Hallelujah",
          "Holy Halloween",
          "Holy Hallucination",
          "Holy Hamburger",
          "Holy Hamlet",
          "Holy Hamstrings",
          "Holy Happenstance",
          "Holy Hardest Metal In The World",
          "Holy Harem",
          "Holy Harshin",
          "Holy Haziness",
          "Holy Headache",
          "Holy Headline",
          "Holy Heart Failure",
          "Holy Heartbreak",
          "Holy Heidelberg",
          "Holy Helmets",
          "Holy Helplessness",
          "Holy Here We Go Again",
          "Holy Hi-fi",
          "Holy Hieroglyphic",
          "Holy High-wire",
          "Holy Hijack",
          "Holy Hijackers",
          "Holy History",
          "Holy Hoaxes",
          "Holy Hole In A Donut",
          "Holy Hollywood",
          "Holy Holocaust",
          "Holy Homecoming",
          "Holy Homework",
          "Holy Homicide",
          "Holy Hoodwink",
          "Holy Hoof Beats",
          "Holy Hors D'Oeuvre",
          "Holy Horseshoes",
          "Holy Hostage",
          "Holy Hot Foot",
          "Holy Houdini",
          "Holy Human Collectors Item",
          "Holy Human Pearls",
          "Holy Human Pressure Cookers",
          "Holy Human Surfboards",
          "Holy Hunting Horn",
          "Holy Hurricane",
          "Holy Hutzpa",
          "Holy Hydraulics",
          "Holy Hypnotism",
          "Holy Hypodermics",
          "Holy Ice Picks",
          "Holy Ice Skates",
          "Holy Iceberg",
          "Holy Impossibility",
          "Holy Impregnability",
          "Holy Incantation",
          "Holy Inquisition",
          "Holy Interplanetary Yardstick",
          "Holy Interruptions",
          "Holy Iodine",
          "Holy IT and T",
          "Holy Jack In The Box",
          "Holy Jackpot",
          "Holy Jail Break",
          "Holy Jaw Breaker",
          "Holy Jelly Molds",
          "Holy Jet Set",
          "Holy Jigsaw Puzzles",
          "Holy Jitter Bugs",
          "Holy Joe",
          "Holy Journey To The Center Of The Earth",
          "Holy Jumble",
          "Holy Jumpin' Jiminy",
          "Holy Karats",
          "Holy Key Hole",
          "Holy Key Ring",
          "Holy Kilowatts",
          "Holy Kindergarten",
          "Holy Knit One Purl Two",
          "Holy Knock Out Drops",
          "Holy Known Unknown Flying Objects",
          "Holy Kofax",
          "Holy Las Vegas",
          "Holy Leopard",
          "Holy Levitation",
          "Holy Liftoff",
          "Holy Living End",
          "Holy Lodestone",
          "Holy Long John Silver",
          "Holy Looking Glass",
          "Holy Love Birds",
          "Holy Luther Burbank",
          "Holy Madness",
          "Holy Magic Lantern",
          "Holy Magician",
          "Holy Main Springs",
          "Holy Marathon",
          "Holy Mashed Potatoes",
          "Holy Masquerade",
          "Holy Matador",
          "Holy Mechanical Armies",
          "Holy Memory Bank",
          "Holy Merlin Magician",
          "Holy Mermaid",
          "Holy Merry Go Around",
          "Holy Mesmerism",
          "Holy Metronome",
          "Holy Miracles",
          "Holy Miscast",
          "Holy Missing Relatives",
          "Holy Molars",
          "Holy Mole Hill",
          "Holy Mucilage",
          "Holy Multitudes",
          "Holy Murder",
          "Holy Mush",
          "Holy Naive",
          "Holy New Year's Eve",
          "Holy Nick Of Time",
          "Holy Nightmare",
          "Holy Non Sequiturs",
          "Holy Oleo",
          "Holy Olfactory",
          "Holy One Track Bat Computer Mind",
          "Holy Oversight",
          "Holy Oxygen",
          "Holy Paderewski",
          "Holy Paraffin",
          "Holy Perfect Pitch",
          "Holy Pianola",
          "Holy Pin Cushions",
          "Holy Polar Front",
          "Holy Polar Ice Sheet",
          "Holy Polaris",
          "Holy Popcorn",
          "Holy Potluck",
          "Holy Pressure Cooker",
          "Holy Priceless Collection of Etruscan Snoods",
          "Holy Pseudonym",
          "Holy Purple Cannibals",
          "Holy Puzzlers",
          "Holy Rainbow",
          "Holy Rats In A Trap",
          "Holy Ravioli",
          "Holy Razors Edge",
          "Holy Recompense",
          "Holy Red Herring",
          "Holy Red Snapper",
          "Holy Reincarnation",
          "Holy Relief",
          "Holy Remote Control Robot",
          "Holy Reshevsky",
          "Holy Return From Oblivion",
          "Holy Reverse Polarity",
          "Holy Rheostat",
          "Holy Ricochet",
          "Holy Rip Van Winkle",
          "Holy Rising Hemlines",
          "Holy Roadblocks",
          "Holy Robert Louis Stevenson",
          "Holy Rock Garden",
          "Holy Rocking Chair",
          "Holy Romeo And Juliet",
          "Holy Rudder",
          "Holy Safari",
          "Holy Sarcophagus",
          "Holy Sardine",
          "Holy Scalding",
          "Holy Schizophrenia",
          "Holy Sedatives",
          "Holy Self Service",
          "Holy Semantics",
          "Holy Serpentine",
          "Holy Sewer Pipe",
          "Holy Shamrocks",
          "Holy Sherlock Holmes",
          "Holy Show-Ups",
          "Holy Showcase",
          "Holy Shrinkage",
          "Holy Shucks",
          "Holy Skull Tap",
          "Holy Sky Rocket",
          "Holy Slipped Disc",
          "Holy Smoke",
          "Holy Smokes",
          "Holy Smokestack",
          "Holy Snowball",
          "Holy Sonic Booms",
          "Holy Special Delivery",
          "Holy Spider Webs",
          "Holy Split Seconds",
          "Holy Squirrel Cage",
          "Holy Stalactites",
          "Holy Stampede",
          "Holy Standstills",
          "Holy Steam Valve",
          "Holy Stew Pot",
          "Holy Stomach Aches",
          "Holy Stratosphere",
          "Holy Stuffing",
          "Holy Subliminal",
          "Holy Sudden Incapacitation",
          "Holy Sundials",
          "Holy Surprise Party",
          "Holy Switch A Roo",
          "Holy Taj Mahal",
          "Holy Tartars",
          "Holy Taxation",
          "Holy Taxidermy",
          "Holy Tee Shot",
          "Holy Ten Toes",
          "Holy Terminology",
          "Holy Time Bomb",
          "Holy Tintinnabulation",
          "Holy Tipoffs",
          "Holy Titanic",
          "Holy Tome",
          "Holy Toreador",
          "Holy Trampoline",
          "Holy Transistors",
          "Holy Travel Agent",
          "Holy Trickery",
          "Holy Triple Feature",
          "Holy Trolls And Goblins",
          "Holy Tuxedo",
          "Holy Uncanny Photographic Mental Processes",
          "Holy Understatements",
          "Holy Underwritten Metropolis",
          "Holy Unlikelihood",
          "Holy Unrefillable Prescriptions",
          "Holy Vat",
          "Holy Venezuela",
          "Holy Vertebrae",
          "Holy Voltage",
          "Holy Waste Of Energy",
          "Holy Wayne Manor",
          "Holy Weaponry",
          "Holy Wedding Cake",
          "Holy Wernher von Braun",
          "Holy Whiskers",
          "Holy Wigs",
          "Holy Zorro"
        ],
        "singular_siegler": [
          "Texas!",
          "Come on now",
          "Turd gone wrong",
          "I want my 5$ back",
          "I tell you what",
          "My buddy Harlen",
          "Goin' hog huntin'",
          "C'mon Naomi",
          "Might be DQ time",
          "That goddamn Datamate",
          "That damn gimble",
          "That Barbala couldn't fly his way out of a wet paper bag",
          "So I was walking Oscar",
          "How 'bout them Cowboys",
          "Always the last one to the party",
          "Standby",
          "No one tells me shit",
          "My boss gonna fire me",
          "That damn Bill Stull",
          "Like a red-headed stepchild",
          "Y'all never listen to me",
          "It's around here somewhere",
          "Reminds me of my old girlfriend Olga Goodntight",
          "Let me tell ya",
          "I got that scurvy",
          "Got depression, Smith and Wessen",
          "I'm washing my hands of it",
          "Yup",
          "Contact the tower",
          "That damn diabetes",
          "That's messed up",
          "I want my damn cart back"
        ],
        "yoda": [
          "Use your feelings, Obi-Wan, and find him you will.",
          "Already know you that which you need.",
          "Adventure. Excitement. A Jedi craves not these things.",
          "At an end your rule is, and not short enough it was!",
          "Around the survivors a perimeter create.",
          "Soon will I rest, yes, forever sleep. Earned it I have. Twilight is upon me, soon night must fall.",
          "Not if anything to say about it I have",
          "Through the Force, things you will see. Other places. The future - the past. Old friends long gone.",
          "Ow, ow, OW! On my ear you are!",
          "The dark side clouds everything. Impossible to see the future is.",
          "Size matters not. Look at me. Judge me by my size, do you? Hmm? Hmm. And well you should not. For my ally is the Force, and a powerful ally it is. Life creates it, makes it grow. Its energy surrounds us and binds us. Luminous beings are we, not this crude matter. You must feel the Force around you; here, between you, me, the tree, the rock, everywhere, yes. Even between the land and the ship.",
          "Younglings, younglings gather ’round.",
          "Luminous beings are we - not this crude matter.",
          "Clear your mind must be, if you are to find the villains behind this plot.",
          "Always two there are, no more, no less. A master and an apprentice.",
          "Do. Or do not. There is no try.",
          "Much to learn you still have my old padawan. ... This is just the beginning!",
          "Good relations with the Wookiees, I have.",
          "Ready are you? What know you of ready? For eight hundred years have I trained Jedi. My own counsel will I keep on who is to be trained. A Jedi must have the deepest commitment, the most serious mind. This one a long time have I watched. All his life has he looked away - to the future, to the horizon. Never his mind on where he was. Hmm? What he was doing. Hmph. Adventure. Heh. Excitement. Heh. A Jedi craves not these things. You are reckless.",
          "Truly wonderful, the mind of a child is.",
          "Always pass on what you have learned.",
          "Once you start down the dark path, forever will it dominate your destiny, consume you it will.",
          "Mudhole? Slimy? My home this is!",
          "Yes, a Jedi’s strength flows from the Force. But beware of the dark side. Anger, fear, aggression; the dark side of the Force are they. Easily they flow, quick to join you in a fight. If once you start down the dark path, forever will it dominate your destiny, consume you it will, as it did Obi-Wan’s apprentice.",
          "Do not assume anything Obi-Wan. Clear your mind must be if you are to discover the real villains behind this plot.",
          "Death is a natural part of life. Rejoice for those around you who transform into the Force. Mourn them do not. Miss them do not. Attachment leads to jealously. The shadow of greed, that is.",
          "Like fire across the galaxy the Clone Wars spread. In league with the wicked Count Dooku, more and more planets slip. Against this threat, upon the Jedi Knights falls the duty to lead the newly formed army of the Republic. And as the heat of war grows, so, to, grows the prowess of one most gifted student of the Force.",
          "Hmm. In the end, cowards are those who follow the dark side.",
          "Strong is Vader. Mind what you have learned. Save you it can.",
          "Pain, suffering, death I feel. Something terrible has happened. Young Skywalker is in pain. Terrible pain",
          "Difficult to see. Always in motion is the future...",
          "You will find only what you bring in.",
          "Feel the force!",
          "Reckless he is. Matters are worse.",
          "That is why you fail.",
          "Your weapons, you will not need them.",
          "To answer power with power, the Jedi way this is"
        ]
      },
      "rajnikanth": {
        "joke": [
          "The only time Rajini needed a body double was crying scene !",
          "Rajinikanth knows why this kolaveri kolaveri Di",
          "Rajinikanth threw a grenade and killed 50 people, then grenade exploded",
          "Some people get lucky and kill two birds with one stone. Rajnikanth once killed four birds with half a stone.",
          "Rajinikanth can give missed call to his own number..",
          "God created Earth and Heaven in 6 days , on 7th day he rested then he created Rajinikanth !",
          "Rajinikanth doesn't answer nature's call. Nature answers Rajinikanth's call",
          "Govt of India pays tax to Rajinikanth for living here",
          "When Rajinikanth goes to a gym to workout, no one can workout since Rajini uses all the weights available.",
          "Einstein said you can't move at the speed of light, obviously he was never kicked by Rajinikanth",
          "Why Himalayas are rising? It's simple. Rajinikanth lives in Chennai. Lever effect.",
          "Adam and Eve are children of Rajinikanth",
          "Rajinikanth is so fast that he always comes yesterday",
          "Rajinikanth can get rid of his shadow",
          "Rajini can eat dosa with chop sticks",
          "Tornado changes course when it sees Rajini standing in it's way",
          "Police dept is bored because of 0 crime in the city where rajini lives",
          "Gabbar singh forgets his dialogues when he sees Rajinikanth",
          "Rajini won the best actor oscar for his acting in a game of dumb charades",
          "The box office collection of the movie RA-One Was less than parking collection of ROBOT.......!",
          "Once Rajnikanth became the coach of Indian cricket team and guess wha India won the Fifa world cup !",
          "People update status from BlackBerry, iPhone, iPad, etc. Rajinikant updates his facebook status with a calculator !!",
          "Rajinikant got 150 questions in exam paper asking - 'Solve any 100 questions' He solved all 150 and wrote, 'Rascalla!, CHECK ANY 100!'",
          "Rajini participates in long jump once every four year.... And those years are called LEAP year",
          "Once Rajnikanth entered bigg boss...The next day announcement was made... Rajnikanth chahte hai ki bigg boss confession room me aaye",
          "Once Rajni was the guest contestant in KBC. Amitabh says 'Computerji, Rajnikantji to phela sawaal poochiye'. Computer 'main lifeline use karna chahta hu.'",
          "Ek bar Rajinikanth ne ek aadmi ko 'Go to Hell' kaha... That person is now known as Yamraj !!",
          "Rajinikanth knows Ek chutki sindur ke kimat ... Rs 0.0234355884",
          "Once Rajinikanth told joke to a little kid... Now he is known as laughing buddha",
          "Rajinikanth can cure cancer with his first aid box",
          "Once Rajinikanth used the support of a building to tie his shoe lace, the building is known as Leaning tower of Pisa.",
          "Rajinikanth knows those two persons.. who shake hands in NOKIA cell phones...!!",
          "Rajinikanth's dog can bend a pipe with it's tail.",
          "Michael Jackson's moon walk is no match for Rajinikanth's Sun Walk...",
          "Rajinikanth can make his wife admit her mistakes",
          "Rajinikanth doesn't enjoy animation movies because he can see the gaps between the 24 frames every second",
          "The reason why Rajinikanth stuttered in the movie Darr, because he saw Rajinikanth behind Juhi",
          "When Rajinikanth gets depressed, the world faces great depression",
          "Rajinikanth is a vegetarian… He doesn't eat animals until he first puts them into vegetative state with his blow",
          "If Rajinikanth's PC hangs… its time for next windows release…",
          "Rajinikanth can sneeze with open eyes.",
          "Rajini is the reason why we don't have any other superheros in India",
          "Rajinikanth can make 2 parallel lines intersect just by staring at them.",
          "Santa Claus waits for a gift from Rajinikanth every Christmas.",
          "Rajinikanth taught yoga to Baba Ramdev",
          "Rajinikanth taught us all... Impossible is nothing...",
          "One of Rajinikanth's hobby - Swimming on Tsunami.",
          "Sh!t happens to everyone.. Even to Rajini... One time he coudn't kill 100 bears with a single punch but only 99 died.",
          "Rajinikanth uses Ambuja cement as tooth powder",
          "Once Rajinikanth dropped a coin while he was standing in the belcony... He went down to pick it up, but it was not there.... hmmmm... He reached there before the coin...",
          "Rajinikanth was not amused by Gandhi’s non violence movement.",
          "Lifetime Warranty does not exist only because of Rajnikanth.",
          "If you want a list of Rajinikanth's enemies, just check the extinct species list.",
          "When RAJNI had surgery, the anesthesia was applied to the doctors.",
          "The apple which fell on newton was actually thrown by Rajinikanth.",
          "Only Rajinijanth has 32 wisdom teeth.",
          "When Rajinikanth goes thru immigration.. the officers show him thier passports.",
          "Sun doesn't rise until Rajinikanth says 'Good Morning'",
          "Once Rajnikant, after chewing the 'PAAN', spit on the wall of a building.",
          "Today that building is popularly known as THE RED FORT..",
          "Once Rajinikath shouted at a boy for not wearing cap in the hot sun. Today that boy is known as Himesh Reshammiya.",
          "Rajnikanth Saw The Movie Break k Baad before the Break !!!",
          "Rajnikanth's pulse is measured in richter scale.",
          "Rajnikanth was practicing for a spelling test..the rough sheet he used is known as oxford dictionary..",
          "Rajnikanth has seen the face of the fat lady who owns the house in tom n jerry..",
          "Rajnikanth ploughs the field using nothing but his toes.",
          "Once spiderman,superman and batman visited rajnikant's house together.. it was teachers day!",
          "Rajinikanth can whistle and smile at the same time...",
          "Computer doesn't give warning message to Rajini… Rajini warns computer",
          "When Rajnikant get angry at the Sun, it hides behind the moon… that phenomenon is called Solar eclipse.",
          "Rajini was born on 30th Feb, since then that date was removed from calendar so that noone else gets the same birthday.",
          "Rajnikanth can run Windows 7 on 64KB memory.",
          "Rajni never tweets, he only roars."
        ]
      },
      "relationship": {
        "familial": {
          "direct": [
            "Father",
            "Mother",
            "Sister",
            "Brother"
          ],
          "extended": [
            "Grandfather",
            "Grandmother",
            "Uncle",
            "Aunt",
            "Cousin",
            "Niece",
            "Nephew",
            "Grandson",
            "Granddaughter"
          ]
        },
        "in_law": [
          "Father-in-law",
          "Mother-in-law",
          "Sister-in-law",
          "Brother-in-law"
        ],
        "parent": [
          "Father",
          "Mother"
        ],
        "sibling": [
          "Sister",
          "Brother"
        ],
        "spouse": [
          "Husband",
          "Wife"
        ]
      },
      "restaurant": {
        "description": [
          "To ensure that each guest receives prompt, professional, friendly and courteous service. To maintain a clean, comfortable and well maintained premises for our guests and staff. To provide at a fair price – nutritional, well-prepared meals – using only quality ingredients. To ensure that all guests and staff are treated with the respect and dignity they deserve. To thank each guest for the opportunity to serve them. By maintaining these objectives we shall be assured of a fair profit that will allow us to contribute to the community we serve.",
          "To sell delicious and remarkable food and drinks. That the food and drink we sell meets the highest standards of quality, freshness and seasonality and combines both modern-creative and traditional southern styles of cooking. To consistently provide our customers with impeccable service by demonstrating warmth, graciousness, efficiency, knowledge, professionalism and integrity in our work. To have every customer who comes through our doors leave impressed by Maxie’s and excited to come back again. To create and maintain a restaurant that is comprehensive and exceptional in its attention to every detail of operation. To provide all who work with us a friendly, cooperative and rewarding environment which encourages long- term, satisfying, growth employment. To keep our concept fresh, exciting and on the cutting edge of the hospitality and entertainment industry. To be a giving member of the Ithaca community and to use our restaurant to improve the quality of life in the Finger Lakes region.",
          "We are committed to using the finest ingredients in our recipes. No food leaves our kitchen that we ourselves would not eat.",
          "To achieve and maintain such distinction in food and wine, service, atmosphere and setting that the restaurant gains a first class reputation for gastronomy, gracious and informed hospitality, comfort and beauty which draws new and repeat customers year after year. To achieve the above whilst upholding staff policies and practices which promote a fair and positive working environment. To be aware of and act on our responsibilities as a good corporate citizen to  provide a safe, clean and attractive place for guests to enjoy and for employees to work in - ensure ecologically sound management practices at the restaurant and in our surrounding gardens and woods - undertake meaningful involvement of Restaurant Les Fougères in selected charitable activities in our community and region.",
          "To provide an exceptional dining experience that satisfies our guests’ grown-up tastes by being a Cut-Above in everything we do.",
          "Our Mission at Denny’s is to establish beneficial business relationships with diverse suppliers who share our commitment to customer service, quality and competitive pricing.",
          "Yoshinoya is in business to create the structure and systems needed to allow our customers access to the majority of their away-from-home daily meal requirements on a one-stop-shop basis. All our products shall be of the highest quality and value, be healthy, nutritious and provided with outstanding personal services at the lowest possible prices consistent with a fair return on investment for our shareholders, job enhancementsecurity for our employees and a level of community involvement by everyone connected with our business. All of our products and services shall be delivered consistently and measured one satisfied customer at a time, whether by company-owned or franchised operations, in superior, clean, convenient, fun and friendly neighborhood environments. We pledge to make Yoshinoya the best place to eat and the best place to work.",
          "Culver’s Restaurant was founded by the Culver family in 1984, which eventually branched out to more than 300 franchised restaurants all over the US. Culver’s is well-known for its ButterBurger, which made the restaurant extremely famous. They also have other items which include salads, sandwiches, desserts, etc.",
          "Our mission is to be a leader in the distribution and merchandising of food, pharmacy, health and personal care items, seasonal merchandise, and related products and services. We place considerable importance on forging strong supplier partnerships. Our suppliers, large or small, local or global, are essential components in accomplishing our mission.",
          "We earn the loyalty of the people we serve by first anticipating, then fulfilling their needs with our superior-quality products, a unique shopping experience, customer-focused service and continuous innovation, while generating long-term profitable growth for our shareholders.",
          "Delhaize Group will achieve leading positions in food retailing in key mature and emerging markets. We accomplish our goal by developing strong regional companies benefiting from and contributing to the Groups strength, expertise and successful practices. Delhaize Group goes to market with a variety of food store formats. The Group is committed to offer a locally differentiated shopping experience to its customers in each of its markets, to deliver superior value and to maintain high social, environmental and ethical standards.",
          "SVIs mission is to deliver quality products at affordable prices to our independent retailers, wholesalers and food service partners around the world by providing international procurement, distribution, marketing and supply chain management.",
          "Our mission has been to help people achieve their health and wellness goals. though weve changed over the years, our values have remained the same.",
          "To deliver an exceptional shopping experience by offering the best service, value, quality, and freshest products while being good stewards of our environment and giving back to the communities we serve."
        ],
        "name": [
          "#{name_prefix} #{name_suffix}"
        ],
        "name_prefix": [
          "??",
          "???",
          "##",
          "###",
          "####",
          "Belly",
          "Big",
          "Blue Plate",
          "Fast",
          "Fat",
          "Golden",
          "Hungry",
          "Salty",
          "Silver",
          "Smokestack",
          "Spice",
          "Sugar",
          "Sweet",
          "Thirsty",
          "Red",
          "Blue",
          "Green",
          "Orange"
        ],
        "name_suffix": [
          "Bakery",
          "Bar & Grill",
          "BBQ",
          "Box",
          "Brasserie",
          "Burger",
          "Cafe",
          "Coffee",
          "Creamery",
          "Curry",
          "Deli",
          "Diner",
          "Dragon",
          "Eatery",
          "Eats",
          "Gastropub",
          "Grill",
          "Grill & Tap",
          "House",
          "Juice Bar",
          "King",
          "Kitchen",
          "Pizza",
          "Pub",
          "Shakes",
          "Spoon",
          "Steakhouse",
          "Subs",
          "Sushi"
        ],
        "review": [
          "For dinner we ordered the shrimp enchiladas, chicken enchiladas, chicken burrito, chimichangas, and steak quesadillas. Everything was so tasty and amazing. I wasnt surprised because the food at the FiDi location is the best so I figured this location would be just as good and it was!!! The enchiladas with the green sauce is to die for. My go to at the FiDi location is usually the chicken enchiladas but I decided to try something new and the shrimp enchiladas did not disappoint.",
          "For dessert, we ordered the chocolate drizzled churros and they were delicious too! They even came with some fresh fruit (blueberries and strawberries).",
          "Overall, the evening was a smash and I am so glad there is a new location closer to my office!!",
          "Brand new. Great design. Odd to hear pop music in a Mexican establishment. Music is a bit loud. It should be background.",
          "The chicken nachos were delicious and the atmosphere was great. The frozen margaritas were a little on the weak side. Would probably return for a work happy hour but was pretty disappointed about the lack of free tequila and beer we read about!",
          "The counter is on the left side, and so is the menu. It can get pretty busy with 30 min wait times. I recommend checking the website and see how busy their store is.",
          "They are way understaffed, where the cashier needs to stop taking orders to help pack to-go orders. The line ends up piling up and people are neglected.  Seen this happen multiple times during lunch hours.",
          "This particular location like the many other restaurants down the block has ample seating and a second floor.",
          "I first heard about this place through Instagram post. The drinks looked creative so I made it a point to give it try while in the city. Located inside American Eagle in Times Square they serve up the coolest non-alcoholic beverages. You have an array of options from tea, soda, coffee, latte, water and more. Theres countertops (with phone chargers) so youre able to stand and enjoy your beverage. This visit I opted for the Pegasus latte which was not only beautiful but tasted just as good as it looked. Great staff and great service. This is a must try if you are in the area. Im sure Ill be back soon!",
          "Great place to stop in from a chaotic Times Square adventure! The coffee is great, the drinks are creative and the staff is very nice and hospitable. Cant wait to stop in again. Without a doubt 5 stars from me!!",
          "Great lattes and cold drinks as well. Nice to see a place carrying local coffee and products in Times Square! Excited to make it a part of my morning commute as it is much less crowded than the chain coffee shops around here.",
          "Fish was high quality but portions were small. $57 for 9 pieces and a hand roll which is fair but on the expensive side.",
          "Ambience was good, service was no nonsense but friendly.",
          "Id have to say that each piece was fresh and had their own slight unique flavor twist to it, pushing the line between traditional edomae and fusion. The Hokkaido uni and the ocean trout topped with cook seaweed was the highlights of the meal. But each piece served was really something special.",
          "Staff was very accommodating but the chef were no nonsense. The ambiance is clean and tranquil which is perfect if youre looking to have a conversation with a date or a friend.",
          "My only critique would be that the rice could of used more vinegar and for them to use real wasabi. Also the variety of fish in stock wasnt a lot but hopefully that can change over time. The cost justify the quality youre getting. A solid 4 stars.",
          "In terms of omakase, they had a few options but the one we chose was the 87 dollar version which include sashimi and sushi."
        ],
        "type": [
          "African",
          "American (New)",
          "American (Traditional)",
          "Argentinian",
          "Asian",
          "Bakery",
          "Bar",
          "Brazilian",
          "Burgers",
          "Caribbean",
          "Chinese",
          "Comfort Food",
          "Desserts",
          "Ethiopean",
          "European",
          "French",
          "German",
          "Greek",
          "Healthy",
          "Ice Cream",
          "Indian",
          "Italian",
          "Japanese",
          "Juice & Smoothies",
          "Korean",
          "Mexican",
          "Pizza",
          "Ramen",
          "Sandwiches",
          "Senegalese",
          "Sushi",
          "Tex Mex",
          "Thai",
          "Vegan",
          "Vegetarian",
          "Vietnamese"
        ]
      },
      "rick_and_morty": {
        "characters": [
          "Rick Sanchez",
          "Tiny Rick",
          "Morty Smith",
          "Morty Jr.",
          "Evil Morty",
          "Summer Smith",
          "Jerry Smith",
          "Beth Smith",
          "Snuffles",
          "Birdperson",
          "Tammy Gueterman",
          "Jessica",
          "Baby Legs",
          "Mr. Meeseeks",
          "Scary Terry",
          "Mr. Poopybutthole",
          "Unity",
          "Squanchy",
          "Shrimply Pibbles",
          "Dr. Glip-Glop",
          "Eyeholes Man",
          "Beth's Mytholog",
          "Jerry's Mytholog",
          "Mr. Needful",
          "Krombopulos Michael",
          "Mr. Goldenfold",
          "Snowball",
          "Arthricia",
          "Tinkles",
          "Gazorpazorpfield",
          "Lighthouse Chief",
          "Jan Michael Vincent",
          "Stealy",
          "Tophat Jones",
          "Loggins",
          "Abradolf Lincler",
          "Cousin Nicky",
          "Revolio 'Gearhead' Clockberg, Jr.",
          "Fart",
          "Beta VII",
          "King Jellybean"
        ],
        "locations": [
          "Dimension C-132",
          "Dimension C-137",
          "Earth",
          "Alphabetrium",
          "Arbolez Mentorosos",
          "Bird World",
          "Cronenberg World",
          "Dwarf Terrace-9",
          "Gazorpazorp",
          "Glapflap",
          "Hideout Planet",
          "On a Cob Planet",
          "Parblesnops",
          "Pawn Shop Planet",
          "Planet Squanch",
          "Pluto",
          "Purge Planet",
          "Screaming Sun Earth",
          "Snorlab",
          "Interdimensional Customs"
        ],
        "quotes": [
          "Ohh yea, you gotta get schwifty.",
          "I like what you got.",
          "Don’t even trip dawg.",
          "Get off the high road Summer. We all got pink eye because you wouldn't stop texting on the toilet.",
          "Yo! What up my glip glops!",
          "It's fine, everything is fine. Theres an infinite number of realities Morty and in a few dozen of those I got lucky and turned everything back to normal.",
          "Sometimes science is a lot more art, than science. A lot of people don't get that.",
          "There is no god, Summer; gotta rip that band-aid off now you'll thank me later.",
          "WUBBA LUBBA DUB DUBS!!!",
          "Oh, I'm sorry Morty, are you the scientist or are you the kid who wanted to get laid?",
          "This isn't Game of Thrones, Morty.",
          "You're our boy dog, don't even trip.",
          "He's not a hot girl. He can't just bail on his life and set up shop in someone else's.",
          "I don't get it and I don't need to.",
          "Pluto's a planet.",
          "HI! I'M MR MEESEEKS! LOOK AT ME!",
          "Existence is pain to a meeseeks Jerry, and we will do anything to alleviate that pain.",
          "Well then get your shit together. Get it all together and put it in a backpack, all your shit, so it's together. ...and if you gotta take it somewhere, take it somewhere ya know? Take it to the shit store and sell it, or put it in a shit museum. I don't care what you do, you just gotta get it together... Get your shit together.",
          "Aw, c'mon Rick. That doesn't seem so bad.",
          "Aww, gee, you got me there Rick.",
          "You're like Hitler, except...Hitler cared about Germany, or something.",
          "Hello Jerry, come to rub my face in urine again?",
          "Snuffles was my slave name, you can call me snowball because my fur is pretty and white.",
          "Go home and drink, grandpa.",
          "I'm the devil. What should I do when I fail? Give myself an ice cream?",
          "Weddings are basically funerals with cake.",
          "What about the reality where Hitler cured cancer, Morty? The answer is: Don't think about it.",
          "Nobody exists on purpose. Nobody belongs anywhere. Everybody is going to die.",
          "That just sounds like slavery with extra steps.",
          "Keep Summer safe.",
          "Where are my testicles, Summer?",
          "Oh yeah, If you think my Rick is Dead, then he is alive. If you think you're safe, then he's coming for you.",
          "Let me out, what you see is not the same person as me. My life's a lie. I'm not who you're looking. Let me out. Set me free. I'm really old. This isn't me. My real body is slowly dieing in a vat. Is anybody listening? Can anyone understand? Stop looking at me like that and actually help me. Help me. Help me I'm gunna die.",
          "This sounds like something The One True Morty might say.",
          "I'm more than just a hammer.",
          "That's the difference between you and me, Morty. I never go back to the carpet store.",
          "What is my purpose. You pass butter. Oh My God. Yeah, Welcome to the club pal.",
          "Meeseeks are not born into this world fumbling for meaning, Jerry! We are created to serve a single purpose, for which we go to any lengths to fulfill.",
          "It's a figure of speech, Morty! They're bureaucrats! I don't respect them. Just keep shooting, Morty! You have no idea what prison is like here!",
          "Having a family doesn't mean that you stop being an individual.",
          "Traditionally, science fairs are a father/son thing. Well, scientifically, traditions are an idiot thing.",
          "No no, If I wanted to be sober, I wouldn’t have gotten drunk.",
          "I hate to break it to you, but what people call 'love' is just a chemical reaction that compels animals to breed. It hits hard Morty then it slowly fades leaving you stranded in a failing marriage. I did it. Your parents are going to do it. Break the cycle Morty, rise above, focus on science.",
          "I want that Mulan McNugget sauce, Morty!",
          "Listen, I'm not the nicest guy in the universe, because I'm the smartest, and being nice is something stupid people do to hedge their bets.",
          "Can somebody just let me out of here? If I die in a cage I lose a bet.",
          "Uncertainty is inherently unsustainable. Eventually, everything either is or isn't.",
          "The first rule of space travel kids is always check out distress beacons. Nine out of ten times it's a ship full of dead aliens and a bunch of free shit! One out of ten times it's a deadly trap, but... I'm ready to roll those dice!",
          "Great, now I have to take over an entire planet because of your stupid boobs.",
          "Oh Summer, haha first race war, huh?",
          "Little tip, Morty. Never clean DNA vials with your spit.",
          "So what if the most meaningful day in your life was a simulation operating at minimum complexity."
        ]
      },
      "rock_band": {
        "name": [
          "Led Zeppelin",
          "The Beatles",
          "Pink Floyd",
          "The Jimi Hendrix Experience",
          "Van Halen",
          "Queen",
          "The Eagles",
          "Metallica",
          "U2",
          "Bob Marley and the Wailers",
          "The Police",
          "The Doors",
          "Stone Temple Pilots",
          "Rush",
          "Genesis",
          "Prince and the Revolution",
          "Yes",
          "Earth Wind and Fire",
          "The Bee Gees",
          "The Rolling Stones",
          "The Beach Boys",
          "Soundgarden",
          "The Who",
          "Steely Dan",
          "James Brown and the JBs",
          "AC/DC",
          "Fleetwood Mac",
          "Crosby, Stills, Nash and Young",
          "The Allman Brothers",
          "ZZ Top",
          "Aerosmith",
          "Cream",
          "Bruce Springsteen & The E Street Band",
          "The Grateful Dead",
          "Guns 'N Roses",
          "Pearl Jam",
          "Boston",
          "Dire Straits",
          "King Crimson",
          "Parliament Funkadelic",
          "Red Hot Chili Peppers",
          "Bon Jovi",
          "Dixie Chicks",
          "Foreigner",
          "David Bowie and The Spiders From Mars",
          "The Talking Heads",
          "Jethro Tull",
          "The Band",
          "The Beastie Boys",
          "Nirvana",
          "Rage Against The Machine",
          "Sly and the Family Stone",
          "The Clash",
          "Tool",
          "Journey",
          "No Doubt",
          "Creedence Clearwater Revival",
          "Deep Purple",
          "Alice In Chains",
          "Orbital",
          "Little Feat",
          "Duran Duran",
          "Living Colour",
          "Frank Zappa and the Mothers of Invention",
          "The Carpenters",
          "Audioslave",
          "The Pretenders",
          "Primus",
          "Blondie",
          "Black Sabbath",
          "Lynyrd Skynyrd",
          "Sex Pistols",
          "Isaac Hayes and the Movement",
          "R.E.M.",
          "Traffic",
          "Buffalo Springfield",
          "Derek and the Dominos",
          "The Jackson Five",
          "The O'Jays",
          "Harold Melvin and the Blue Notes",
          "Underworld",
          "Thievery Corporation",
          "Motley Crue",
          "Janis Joplin and Big Brother and the Holding Company",
          "Blind Faith",
          "The Animals",
          "The Roots",
          "The Velvet Underground",
          "The Kinks",
          "Radiohead",
          "The Scorpions",
          "Kansas",
          "Iron Maiden",
          "Motorhead",
          "Judas Priest",
          "The Orb",
          "The Cure",
          "Coldplay",
          "Slayer",
          "Black Eyed Peas"
        ],
        "song": [
          "Are You Gonna Be My Girl",
          "Dani California",
          "Detroit Rock City",
          "Stairway to Heaven",
          "Hey Jude",
          "All Along the Watchtower",
          "Satisfaction",
          "Like A Rolling Stone",
          "Another Brick In The Wall",
          "Won't Get Fooled Again",
          "Hotel California",
          "Layla",
          "Sweet Home Alabama",
          "Bohemian Rhapsody",
          "Riders on the Storm",
          "Rock and Roll",
          "Barracuda",
          "La Grange",
          "Dream On",
          "More Than a Feeling",
          "Sultans of Swing",
          "You Shook Me All Night Long",
          "Kashmir",
          "Lola",
          "Carry on Wayward Son",
          "Tiny Dancer",
          "Locomotive Breath",
          "I Still Haven't Found",
          "Magic Carpet Ride",
          "Free Bird",
          "Purple Haze",
          "Tom Sawyer",
          "Let It Be",
          "Baba O'Riley",
          "The Joker",
          "Roxanne",
          "Time",
          "It's a Long Way to the Top",
          "Whole Lotta Love",
          "The Chain",
          "I've Seen All Good People",
          "For What It's Worth",
          "Black Magic Woman",
          "Nights in White Satin",
          "While My Guitar Gently Weeps",
          "Gimme Shelter",
          "Gold Dust Woman",
          "Fortunate Son",
          "American Pie",
          "Bad Company",
          "Waitin' For the Bus",
          "Over the Hills and Far Away",
          "Owner of a Lonely Heart",
          "The Logical Song",
          "A Day in the Life",
          "Sweet Emotion",
          "Down on the Corner",
          "My Sweet Lord",
          "Knockin' on Heaven's Door",
          "Just What I Needed",
          "Don't Fear the Reaper",
          "Behind Blue Eyes",
          "Do It Again",
          "Who Do You Love",
          "From the Beginning",
          "Already Gone",
          "Here Comes The Sun",
          "With or Without You",
          "Life's Been Good",
          "Breakdown",
          "Comfortably Numb",
          "Ramble On",
          "I'd Love to Change the World",
          "Foreplay Longtime",
          "Brown Eyed Girl",
          "Back In Black",
          "Take it Easy",
          "Sgt. Pepper",
          "We Will Rock You",
          "Dancing Days",
          "Turn the Page",
          "All Right Now",
          "Black Water",
          "Oh Well",
          "Me and Bobby McGee",
          "Rocket Man",
          "Ohio",
          "You Really Got Me",
          "Bloody Well Right",
          "Dirty Deeds",
          "Aqualung",
          "The Wind Cries Mary",
          "Burnin' for You",
          "Moving in Stereo",
          "Bargain",
          "House of the Rising Sun",
          "Maybe I'm Amazed",
          "Bennie & the Jets",
          "Dust in the Wind",
          "Crazy On You",
          "Walkin' On The Moon",
          "Fire",
          "Runnin' With The Devil",
          "Immigrant Song",
          "Jumpin' Jack Flash",
          "Levon",
          "Call Me The Breeze",
          "You Make Lovin' Fun",
          "Come Together",
          "Dreams",
          "Fire On High",
          "Wish You Were Here",
          "Rocky Racoon",
          "Walk This Way",
          "In My Life",
          "Every Breath You Take",
          "Going To California",
          "Let It Rain",
          "Killer Queen",
          "Street Fighting Man",
          "Going Mobile",
          "Panama",
          "Train Kept A Rollin'",
          "Highway To Hell",
          "Dance The Night Away",
          "In Your Eyes"
        ]
      },
      "rupaul": {
        "queens": [
          "Tyra Sanchez",
          "Raven",
          "Jujubee",
          "Tatianna",
          "Pandora Boxx",
          "Jessica Wild",
          "Sahara Davenport",
          "Morgan McMichaels",
          "Shangela Wadley",
          "Raja",
          "Manila Luzon",
          "Alexis Mateo",
          "Yara Sofia",
          "Carmen Carrera",
          "Delta Work",
          "Stacy Layne Matthews",
          "Mimi Imfurst",
          "Sharon Needles",
          "Chad Michaels",
          "Phi Phi O'Hara",
          "Latrice Royale",
          "Kenya Michaels",
          "Dida Ritz",
          "Willam",
          "Jiggly Caliente",
          "Jinkx Monsoon",
          "Alaska",
          "Roxxxy Andrews",
          "Detox",
          "Coco Montrese",
          "Alyssa Edwards",
          "Ivy Winters",
          "Bianca Del Rio",
          "Adore Delano",
          "Courtney Act",
          "Darienne Lake",
          "BenDeLaCreme",
          "Joslyn Fox",
          "Trinity K Bonet",
          "Laganja Estranja",
          "Milk",
          "Gia Gunn",
          "Violet Chachki",
          "Ginger Minj",
          "Pearl",
          "Kennedy Davenport",
          "Katya",
          "Trixie Mattel",
          "Miss Fame",
          "Bob The Drag Queen",
          "Kim Chi",
          "Naomi Smalls",
          "Chi Chi DeVayne",
          "Derrick Barry",
          "Thorgy Thor",
          "Robbie Turner",
          "Acid Betty",
          "Sasha Velour",
          "Peppermint",
          "Shea Coulee",
          "Trinity Taylor",
          "Alexis Michelle",
          "Nina Bonina Brown",
          "Valentina",
          "Farrah Moan",
          "Aja",
          "Cynthia Lee Fontaine",
          "Aquaria",
          "Eureka",
          "Kameron Michaels",
          "Asia O'Hara",
          "Miz Cracker",
          "Monet X Change",
          "The Vixen",
          "Monique Heart",
          "Blair St. Clair",
          "Mayhem Miller",
          "A'keria Chanel Davenport",
          "Ariel Versace",
          "Brook Lynn Hytes",
          "Mercedes Iman Diamond",
          "Nina West",
          "Plastique Tiara",
          "Ra'jah O'Hara",
          "Scarlet Envy",
          "Shuga Cain",
          "Silky Nutmeg Ganache",
          "Vanessa Vanjie Mateo",
          "Yvie Oddly"
        ],
        "quotes": [
          "Glamazon!",
          "Put the bass in your walk.",
          "Sashay away.",
          "Good luck, and don't fuck it up.",
          "Shante, you stay.",
          "You betta work.",
          "The time has come, for you to lip-sync for your life!",
          "Extravaganza eleganza!",
          "Now, let the music play!",
          "That's funny, tell another one.",
          "Sissy that walk.",
          "Don't be jealous of my boogie.",
          "We're all born naked and the rest is drag.",
          "Life is about using the whole box of crayons.",
          "When the going gets tough, the tough reinvent themselves.",
          "Hello, hello, hello!",
          "Bring back my girls.",
          "Just between us squirrel friends...",
          "In the great tradition of Paris is Burning, \"Get out your Library Cards!\"",
          "Because reading is what?",
          "Now listen, I gotta tell ya...",
          "Silence...I've made my decision.",
          "You're a winner, baby!",
          "Condragulations!",
          "I'm sorry, my dear, but you are up for elimination.",
          "Prance, I say!",
          "If you can't love yourself, how in the hell you gonna love somebody else?",
          "Must be jelly 'cause jam don't shake.",
          "She done already done had herses."
        ]
      },
      "rush": {
        "albums": [
          "Rush",
          "Fly by Night",
          "Caress of Steel",
          "2112",
          "A Farewell to Kings",
          "Hemispheres",
          "Permanent Waves",
          "Moving Pictures",
          "Signals",
          "Grace Under Pressure",
          "Power Windows",
          "Hold Your Fire",
          "Presto",
          "Roll the Bones",
          "Counterparts",
          "Test for Echo",
          "Vapor Trails",
          "Snakes & Arrows",
          "Clockwork Angels",
          "All the World's a Stage",
          "Exit...Stage Left",
          "A Show of Hands",
          "Different Stages"
        ],
        "players": [
          "Geddy Lee",
          "Alex Lifeson",
          "Neil Peart",
          "John Rutsey"
        ]
      },
      "science": {
        "branch": {
          "empirical_natural_applied": [
            "Engineering",
            "Agricultural Science",
            "Medicine",
            "Materials Science"
          ],
          "empirical_natural_basic": [
            "Physics",
            "Chemistry",
            "Biology",
            "Earth Science",
            "Space Science"
          ],
          "empirical_social_applied": [
            "Business Administration",
            "Public Policy",
            "Marketing",
            "Law",
            "Pedagogy",
            "International Development"
          ],
          "empirical_social_basic": [
            "Antropology",
            "Economics",
            "Political Science",
            "Human Geography",
            "Psychology",
            "Sociology"
          ],
          "formal_applied": [
            "Computer Science"
          ],
          "formal_basic": [
            "Logic",
            "Mathematics",
            "Statistics"
          ]
        },
        "element": [
          "Actinium",
          "Aluminum",
          "Americium",
          "Antimony",
          "Argon",
          "Arsenic",
          "Astatine",
          "Barium",
          "Berkelium",
          "Beryllium",
          "Bismuth",
          "Bohrium",
          "Boron",
          "Bromine",
          "Cadmium",
          "Calcium",
          "Californium",
          "Carbon",
          "Cerium",
          "Cesium",
          "Chlorine",
          "Chromium",
          "Cobalt",
          "Copernicium",
          "Copper",
          "Curium",
          "Darmstadtium",
          "Dubnium",
          "Dysprosium",
          "Einsteinium",
          "Erbium",
          "Europium",
          "Fermium",
          "Flerovium",
          "Fluorine",
          "Francium",
          "Gadolinium",
          "Gallium",
          "Germanium",
          "Gold",
          "Hafnium",
          "Hassium",
          "Helium",
          "Holmium",
          "Hydrogen",
          "Indium",
          "Iodine",
          "Iridium",
          "Iron",
          "Krypton",
          "Lanthanum",
          "Lawrencium",
          "Lead",
          "Lithium",
          "Livermorium",
          "Lutetium",
          "Magnesium",
          "Manganese",
          "Meitnerium",
          "Mendelevium",
          "Mercury",
          "Molybdenum",
          "Moscovium",
          "Neodymium",
          "Neon",
          "Neptunium",
          "Nickel",
          "Nihonium",
          "Niobium",
          "Nitrogen",
          "Nobelium",
          "Oganesson",
          "Osmium",
          "Oxygen",
          "Palladium",
          "Phosphorus",
          "Platinum",
          "Plutonium",
          "Polonium",
          "Potassium",
          "Praseodymium",
          "Promethium",
          "Protactinium",
          "Radium",
          "Radon",
          "Rhenium",
          "Rhodium",
          "Roentgenium",
          "Rubidium",
          "Ruthenium",
          "Rutherfordium",
          "Samarium",
          "Scandium",
          "Seaborgium",
          "Selenium",
          "Silicon",
          "Silver",
          "Sodium",
          "Strontium",
          "Sulfur",
          "Tantalum",
          "Technetium",
          "Tellurium",
          "Tennessine",
          "Terbium",
          "Thallium",
          "Thorium",
          "Thulium",
          "Tin",
          "Titanium",
          "Tungsten",
          "Uranium",
          "Vanadium",
          "Xenon",
          "Ytterbium",
          "Yttrium",
          "Zinc",
          "Zirconium"
        ],
        "element_state": [
          "Gas",
          "Liquid",
          "Plasma",
          "Solid",
          "Unknown"
        ],
        "element_subcategory": [
          "Alkali metal",
          "Alkaline earth metal",
          "Lan­thanide\tActinide",
          "Metalloid",
          "Noble gas",
          "Post-​transition metal",
          "Reactive nonmetal",
          "Transition metal",
          "Unknown chemical properties"
        ],
        "element_symbol": [
          "H",
          "He",
          "Li",
          "Be",
          "B",
          "C",
          "N",
          "O",
          "F",
          "Ne",
          "Na",
          "Mg",
          "Al",
          "Si",
          "P",
          "S",
          "Cl",
          "Ar",
          "K",
          "Ca",
          "Sc",
          "Ti",
          "V",
          "Cr",
          "Mn",
          "Fe",
          "Co",
          "Ni",
          "Cu",
          "Zn",
          "Ga",
          "Ge",
          "As",
          "Se",
          "Br",
          "Kr",
          "Rb",
          "Sr",
          "Y",
          "Zr",
          "Nb",
          "Mo",
          "Tc",
          "Ru",
          "Rh",
          "Pd",
          "Ag",
          "Cd",
          "In",
          "Sn",
          "Sb",
          "Te",
          "I",
          "Xe",
          "Cs",
          "Ba",
          "La",
          "Ce",
          "Pr",
          "Nd",
          "Pm",
          "Sm",
          "Eu",
          "Gd",
          "Tb",
          "Dy",
          "Ho",
          "Er",
          "Tm",
          "Yb",
          "Lu",
          "Hf",
          "Ta",
          "W",
          "Re",
          "Os",
          "Ir",
          "Pt",
          "Au",
          "Hg",
          "Tl",
          "Pb",
          "Bi",
          "Po",
          "At",
          "Rn",
          "Fr",
          "Ra",
          "Ac",
          "Th",
          "Pa",
          "U",
          "Np",
          "Pu",
          "Am",
          "Cm",
          "Bk",
          "Cf",
          "Es",
          "Fm",
          "Md",
          "No",
          "Lr",
          "Rf",
          "Db",
          "Sg",
          "Bh",
          "Hs",
          "Mt",
          "Ds",
          "Rg",
          "Cn",
          "Nh",
          "Fl",
          "Mc",
          "Lv",
          "Ts",
          "Og"
        ],
        "modifier": [
          "Quantum",
          "Laser",
          "Radio",
          "Vacuum",
          "Gas",
          "Solid",
          "Liquid",
          "Fluid",
          "Microfluidic",
          "Mass",
          "Gamma",
          "X-ray",
          "Electon",
          "Proton",
          "Subatomic",
          "UV",
          "Visual",
          "Infrared",
          "Supercooled",
          "Superconductive",
          "Mobile",
          "Portable",
          "Stationary",
          "Inverted",
          "Continuous",
          "Luminescence",
          "Vibration",
          "Scanning",
          "Linear",
          "Circular",
          "Monofocal",
          "Confocal",
          "Trifocal",
          "Thermal",
          "Small",
          "Large",
          "Polar",
          "Conductive",
          "Semiconductive",
          "Non-conductive",
          "Particle",
          "Microparticle"
        ],
        "scientist": [
          "Albert Einstein",
          "Albrecht von Haller",
          "Alexander Fleming",
          "Alfred Binet",
          "Alfred Kinsey",
          "Alfred Wegener",
          "Andreas Vesalius",
          "Antoine Laurent Lavoisier",
          "Anton van Leeuwenhoek",
          "Archimedes",
          "Arthur Eddington",
          "August Kekule",
          "B. F. Skinner",
          "Carl Gauss (Karl Friedrich Gauss)",
          "Carl Linnaeus",
          "Charles Darwin",
          "Charles Lyell",
          "Charles Sherrington",
          "Christiaan Huygens",
          "Claude Bernard",
          "Claude Levi-Strauss",
          "Comte de Buffon",
          "Dmitri Mendeleev",
          "Edward O. Wilson",
          "Edward Teller",
          "Edwin Hubble",
          "Emil Fischer",
          "Emil Kraepelin",
          "Enrico Fermi",
          "Ernest Rutherford",
          "Ernst Haeckel",
          "Ernst Mayr",
          "Erwin Schrodinger",
          "Euclid",
          "Francis Crick",
          "Francis Galton",
          "Franz Boas",
          "Frederick Gowland Hopkins",
          "Frederick Sanger",
          "Galileo Galilei",
          "George Gaylord Simpson",
          "Gertrude Belle Elion",
          "Gregor Mendel",
          "Gustav Kirchhoff",
          "Hans Bethe",
          "Hans Selye",
          "Heike Kamerlingh Onnes",
          "Hermann von Helmholtz",
          "Isaac Newton",
          "J. Robert Oppenheimer",
          "James Clerk Maxwell",
          "James Watson",
          "Jean Baptiste Lamarck",
          "Jean Piaget",
          "Johannes Kepler",
          "John Bardeen",
          "John Dalton",
          "John von Neumann",
          "Jonas Salk",
          "Joseph J. Thomson",
          "Justus Liebig",
          "Karl Landsteiner",
          "Konrad Lorenz",
          "Leonard Euler",
          "Linus Pauling",
          "Louis Pasteur",
          "Louis Victor de Broglie",
          "Lucretius",
          "Ludwig Boltzmann",
          "Lynn Margulis",
          "Marcello Malpighi",
          "Marie Curie",
          "Max Born",
          "Max Delbruck",
          "Max Planck",
          "Max von Laue",
          "Michael Faraday",
          "Murray Gell-Mann",
          "Neils Bohr",
          "Nicolaus Copernicus",
          "Noam Chomsky",
          "Paul Dirac",
          "Paul Ehrlich",
          "Pierre Simon de Laplace",
          "Richard Feynman",
          "Robert Koch",
          "Rudolf Virchow",
          "Sheldon Glashow",
          "Sigmund Freud",
          "Stephen Hawking",
          "Theodosius Dobzhansky",
          "Thomas Hunt Morgan",
          "Trofim Lysenko",
          "Tycho Brahe",
          "Werner Heisenberg",
          "Wilhelm Wundt",
          "Willard Libby",
          "William Bayliss",
          "William Harvey",
          "William Herschel"
        ],
        "tool": [
          "Microscope",
          "Stereomicroscope",
          "Laser",
          "Interferometer",
          "Spectrophotometer",
          "Spectrometer",
          "Mass Spectrometer",
          "NMR Spectrometer",
          "Homogeniser",
          "PCR",
          "NMR",
          "SDR",
          "Electrophoresis",
          "Simulator",
          "Centrifuge",
          "Microcentrifuge",
          "Transducer",
          "Calorimeter",
          "Glucometers",
          "Bioreactor",
          "Telescope",
          "Autoclave",
          "Microwave",
          "Computer",
          "Supercomputer",
          "Analyzer",
          "Imager",
          "Fumehood",
          "Cleanroom",
          "Mastersizer",
          "Accelerator",
          "Microphone",
          "Fluorimeter",
          "3D Scanner",
          "Data Logger",
          "Freezer",
          "Furnace",
          "Synthesiser",
          "Reflector",
          "Cryostat",
          "Diffractometer",
          "Manifold",
          "Pump",
          "Incubator",
          "Regulator",
          "Sonicator",
          "Chromatographer",
          "Viscometer",
          "Generator",
          "Reactor"
        ]
      },
      "seinfeld": {
        "business": [
          "Champagne Video",
          "Joe's Fruit Shop",
          "Kruger Industrial Smoothing",
          "Vandelay Industries",
          "Kramerica Industries",
          "J. Peterman Catalog",
          "Tom's Restaurant",
          "Reggies",
          "Mendy's",
          "Sunshine Carpet Cleaners",
          "Brandt-Leland",
          "H and H Bagels",
          "Play Now",
          "Top of the Muffin to You!",
          "Oh Henry!",
          "P B and J's",
          "Poppie's",
          "Sagman, Bennett, Robbins, Oppenheim and Taft",
          "Pendant Publishing",
          "Dream Cafe",
          "Doubleday",
          "Tyler Chicken",
          "Royal Bakery"
        ],
        "character": [
          "George Costanza",
          "Kramer",
          "Elaine Benes",
          "Newman",
          "Jerry Seinfeld",
          "Frank Costanza",
          "Morty Seinfeld",
          "Estelle Costanza",
          "Susan Ross",
          "Helen Seinfeld",
          "J Peterman",
          "Uncle Leo",
          "David Puddy",
          "Justin Pitt",
          "Kenny Bania",
          "Crazy Joe Davola",
          "Jackie Chiles",
          "Jack Klompus",
          "Ruthie Cohen",
          "Tim Whatley",
          "Sue Ellen Mischke",
          "Bob Sacamano",
          "Babs Kramer",
          "Babu Bhatt",
          "George Steinbrenner",
          "Mickey Abbott",
          "Mr. Lippman",
          "Mr. Wilhelm",
          "Russell Dalrymple"
        ],
        "quote": [
          "I'm not a lesbian. I hate men, but I'm not a lesbian.",
          "You're gonna over-dry your laundry.",
          "This isn't a good time.",
          "That’s the true spirit of Christmas; people being helped by people other than me.",
          "You’re becoming one of the glitterati.",
          "Father, I’ve never done this before, so I’m not sure about what I’m supposed to do.",
          "She’s one of those low-talkers. You can’t hear a word she’s saying!",
          "Why do they make the condom packets so hard to open?",
          "This woman hates me so much, I’m starting to like her.",
          "I've driven women to lesbianism before, but never a mental institution.",
          "You know I always wanted to pretend I was an architect",
          "Borrowing money from a friend is like having sex. It just completely changes the relationship.",
          "When you look annoyed all the time, people think that you're busy.",
          "I spend so much time trying to get their clothes off, I never thought of taking mine off.",
          "If you can't say something bad about a relationship, you shouldn't say anything at all.",
          "I need the secure packaging of Jockeys. My boys needs a house!",
          "The sea was angry that day, my friends, like an old man trying to send back soup in a deli...",
          "Elaine, breaking up is like knocking over a Coke machine. You can’t do it in one push; you gotta rock it back and forth a few times and then it goes over.",
          "Looking at cleavage is like looking at the sun. You don't stare at it. It's too risky. Ya get a sense of it and then you look away.",
          "You have the chicken, the hen, and the rooster. The chicken goes with the hen... So who is having sex with the rooster?",
          "I lie every second of the day. My whole life is a sham.",
          "Just remember, when you control the mail, you control... information.",
          "I don't think I've ever been to an appointment in my life where I wanted the other guy to show up.",
          "You, my friend, have crossed the line between man and bum.",
          "You should've seen her face. It was the exact same look my father gave me when I told him I wanted to be a ventriloquist.",
          "Did you know that the original title for War and Peace was War, What Is It Good For?",
          "Sex, that’s meaningless, I can understand that, but dinner; that’s heavy. That’s like an hour.",
          "Jerry, just remember, it's not a lie if you believe it.",
          "These pretzels are makin' me thirsty.",
          "It became very clear to me sitting out there today that every decision I've made in my entire life has been wrong. My life is the complete opposite of everything I want it to be. Every instinct I have, in every aspect of life, be it something to wear, something to eat - it's all been wrong.",
          "I had a dream last night that a hamburger was eating me.",
          "I have been performing feats of strength all morning.",
          "Hi, my name is George, I'm unemployed and I live with my parents.",
          "I don't trust the guy. I think he regifted, then he degifted, and now he's using an upstairs invite as a springboard to a Super bowl sex romp.",
          "Yes, I hope my parents die long before I do.",
          "See, this is what the holidays are all about. Three buddies sitting around chewing gum.",
          "Dolores!",
          "I'll be back. We'll make out.",
          "I'm sorry to bother you, but I'm a US postal worker and my mail truck was just ambushed by a band of backwoods mail-hating survivalists.",
          "You very bad man, Jerry. Very bad man.",
          "No soup for you!",
          "Serenity now!",
          "I'm out there Jerry, and I'm loving every minute of it!",
          "I'm out of the contest!",
          "You're killing independent George!",
          "Not that there's anything wrong with that.",
          "Yadda, yadda, yadda.",
          "They're real, and they're spectacular.",
          "She has man hands.",
          "And you want to be my latex salesman.",
          "He's a close talker.",
          "It's a Festivus for the rest of us.",
          "I want to be the one person who doesn't die with dignity.",
          "You, my friend, have crossed the line between man and bum.",
          "You were necking during Schindler's List?"
        ]
      },
      "separator": " & ",
      "shakespeare": {
        "as_you_like_it": [
          "All the world's a stage, and all the men and women merely players; they have their exits and their entrances, and one man in his time plays many parts, his acts being seven ages.",
          "Can one desire too much of a good thing?",
          "I like this place and willingly could waste my time in it.",
          "But Oh, how bitter a thing it is to look into happiness through another man's eyes.",
          "Blow, blow, thou winter wind, thou art not so unkind as man's ingratitude.",
          "True is it that we have seen better days and have with holy bell been knolled to church, and sat at good men’s feasts and wiped our eyes of drops that sacred pity hath engendered.",
          "For ever and a day.",
          "The fool doth think he is wise, but the wise man knows himself to be a fool."
        ],
        "hamlet": [
          "To be, or not to be, that is the question",
          "Neither a borrower nor a lender be; For loan oft loses both itself and friend, and borrowing dulls the edge of husbandry.",
          "This above all: to thine own self be true, and it must follow, as the night the day, thou canst not then be false to any man.",
          "Though this be madness, yet there is method in't.",
          "That it should come to this!",
          "There is nothing either good or bad, but thinking makes it so.",
          "What a piece of work is man! How noble in reason, how infinite in faculty! In form and moving how express and admirable! In action how like an angel, in apprehension how like a god! The beauty of the world. The paragon of animals.",
          "The lady doth protest too much, methinks.",
          "A little more than kin, and less than kind.",
          "The play's the thing wherein I'll catch the conscience of the king.",
          "Brevity is the soul of wit.",
          "Doubt thou the stars are fire, doubt that the sun doth move, doubt truth to be a liar, but never doubt I love.",
          "Rich gifts wax poor when givers prove unkind.",
          "Do you think I am easier to be played on than a pipe?",
          "I will speak daggers to her but use none.",
          "When sorrows come, they come not single spies but in battalions."
        ],
        "king_richard_iii": [
          "Now is the winter of our discontent made glorious summer by this sun of York",
          "A horse! a horse! my kingdom for a horse!",
          "Conscience is but a word that cowards use, devised at first to keep the strong in awe.",
          "So wise so young, they say, do never live long.",
          "But then I sigh and, with a piece of scripture, tell them that God bids us do good for evil; and thus I clothe my naked villainy with odd old ends stolen out of Holy Writ, and seem a saint when most I play the devil.",
          "An honest tale speeds best, being plainly told.",
          "The king's name is a tower of strength.",
          "The world is grown so bad that wrens make prey where eagles dare not perch."
        ],
        "romeo_and_juliet": [
          "O Romeo, Romeo! Wherefore art thou Romeo?",
          "But soft! What light through yonder window breaks? It is the east, and Juliet is the sun.",
          "Good night, good night! Parting is such sweet sorrow, that I shall say good night till it be morrow.",
          "What's in a name? That which we call a rose by any other name would smell as sweet.",
          "Wisely and slow; they stumble that run fast.",
          "Tempt not a desperate man.",
          "For you and I are past our dancing days.",
          "Oh, she doth teach the torches to burn bright! It seems she hangs upon the cheek of night like a rich jewel in an Ethiope’s ear, beauty too rich for use, for earth too dear.",
          "See how she leans her cheek upon her hand. Oh, that I were a glove upon that hand that I might touch that cheek!",
          "Not stepping o'er the bounds of modesty."
        ]
      },
      "silicon_valley": {
        "apps": [
          "Nip Alert",
          "Astraphile",
          "Panic-a-Tech",
          "Spinder",
          "Nucleus",
          "Pegg'd",
          "Clinkle",
          "Tables",
          "HooliChat",
          "PiperChat",
          "Not Hotdog",
          "PeaceFare",
          "CodeRag"
        ],
        "characters": [
          "Richard Hendricks",
          "Erlich Bachman",
          "Nelson \"Big Head\" Bighetti",
          "Bertram Gilfoyle",
          "Dinesh Chugtai",
          "Monica Hall",
          "Donald \"Jared\" Dunn",
          "Gavin Belson",
          "Jian Yang",
          "Laurie Bream",
          "Russ Hanneman",
          "Jack \"Action Jack\" Barker",
          "Keenan Feldspar",
          "Ed Chen",
          "Peter Gregory",
          "Ron LaFlamme"
        ],
        "companies": [
          "Pied Piper",
          "Hooli",
          "Raviga Capital Management",
          "Endframe",
          "Bachmanity",
          "Maleant Data Systems Solutions",
          "Aviato",
          "Coleman-Blair",
          "Raviga",
          "Yoyodyne",
          "Intersite",
          "Infotrode",
          "Bream-Hall",
          "SeeFood Technologies Inc",
          "Retinabyte",
          "VidClone Graphics",
          "Entercross Systems",
          "Turnwire"
        ],
        "email": [
          "richard@piedpiper.test",
          "bertram@piedpiper.test",
          "dinesh@piedpiper.test",
          "jared@piedpiper.test",
          "bighead@nipplealert.test",
          "erlich@bachmanity.test",
          "monica@raviga.test",
          "laurie@raviga.test",
          "gavin@hooli.test",
          "russ@threecommaclub.test",
          "denpok@hooli.test"
        ],
        "inventions": [
          "Telehuman",
          "Liquid Shrimp",
          "Bit Soup",
          "Audacious",
          "Tres Comas Tequila",
          "Pipey",
          "Always Blue",
          "Cold Duck",
          "Skycrane",
          "Octopus Recipes",
          "Limp Biscuit",
          "Hooli Box",
          "Box Two",
          "Table",
          "Anton",
          "BamBot",
          "Human Heater"
        ],
        "mottos": [
          "Cloud-based, disruptive systems",
          "Creating unique cross-platform technologies",
          "Making the world a better place",
          "Awesome world-changing compression company",
          "So maybe the reason we share so much is because we understand that without sharing, we can't survive. And sharing is tables.",
          "Forced adoption through aggressive guerrilla marketing",
          "Powered by the spirit of exploration and the thrill of the pursuit of the unimaginable",
          "We not only think outside of the box, we think outside of the box that box is in - and so on - until innovation is free of all boxes that would contain and constrain it",
          "Our products are products, producing unrivaled results",
          "Oh, danger will most certainly be proceeded in the face of. Right in its face. Right in it.",
          "Isn't it time someone put the venture back into venture capital?",
          "Are bandwidth costs harshing on your vibe?",
          "The drink that doesn't give a fuck!"
        ],
        "quotes": [
          "I don't want to live in a world where someone else is making the world a better place better than we are.",
          "I firmly believe we can only achieve greatness if first, we achieve goodness",
          "Line ’em up, nuts to butts",
          "Let me ask you. How fast do you think you could jerk off every guy in this room? Because I know how long it would take me. And I can prove it",
          "It's weird. They always travel in groups of five. These programmers, there's always a tall, skinny white guy; short, skinny Asian guy; fat guy with a ponytail; some guy with crazy facial hair; and then an East Indian guy. It's like they trade guys until they all have the right group.",
          "Jian-Yang, what're you doing? This is Palo Alto. People are lunatics about smoking here. We don't enjoy all the freedoms that you have in China.",
          "Well, you just brought piss to a shit fight, you little cunt!",
          "Hitler actually played the bassoon. So technically Hitler was the Hitler of music.",
          "I simply imagine that my skeleton is me and my body is my house. That way I'm always home.",
          "Gavin Belson started out with lofty goals too, but he just kept excusing immoral behavior just like this, until one day all that was left was a sad man with funny shoes... Disgraced, friendless, and engorged with the blood of a youthful charlatan.",
          "And that, gentlemen, is scrum. Welcome to the next eight weeks of our lives.",
          "Of course they know that you're not pitching Shazam. That already exists. This would be a Shazam... for food.",
          "Compromise is the shared hypotenuse of the conjoined triangles of success.",
          "Gentlemen, I just paid the palapa contractor. The palapa piper, so to speak. The dream is a reality. We'll no longer be exposed... to the elements.",
          "I was gonna sleep last night, but, uh... I thought I had this solve for this computational trust issue I've been working on, but it turns out, I didn't have a solve. But it was too late. I had already drank the whole pot of coffee.",
          "I extended my compression algorithm to support... get this... 12-bit color. Okay, so our users will be able to experience a 10 percent increase in image quality with absolutely no increase in server load whatsoever. Just-Just-Just... Just watch this. Before. After. Before. After.",
          "You listen to me, you muscle-bound handsome Adonis: tech is reserved for people like me, okay? The freaks, the weirdos, the misfits, the geeks, the dweebs, the dorks! Not you!"
        ],
        "urls": [
          "http://raviga.com",
          "http://breamhall.com",
          "http://piedpiper.com",
          "http://hooli.com",
          "http://bachmanity.com",
          "http://aviato.com",
          "http://coderag.com",
          "http://endframesystems.com",
          "http://drinkhomicide.com"
        ]
      },
      "simpsons": {
        "characters": [
          "Homer Simpson",
          "Marge Simpson",
          "Bart Simpson",
          "Lisa Simpson",
          "Maggie Simpson",
          "Akira",
          "Ms. Albright",
          "Aristotle Amadopolis",
          "Atkins, State Comptroller",
          "Mary Bailey",
          "Birchibald \"Birch\" T. Barlow",
          "Jasper Beardly",
          "Benjamin",
          "Doug",
          "Gary",
          "Bill",
          "Marty",
          "Blinky",
          "Blue Haired Lawyer",
          "Boobarella",
          "Wendell Borton",
          "Jacqueline Bouvier",
          "Ling Bouvier",
          "Patty Bouvier",
          "Selma Bouvier",
          "Kent Brockman",
          "Bumblebee Man",
          "Charles Montgomery Burns",
          "Capital City Goofball",
          "Carl Carlson",
          "Cesar",
          "Ugolin",
          "Crazy Cat Lady",
          "Superintendent Gary Chalmers",
          "Shauna Chalmers",
          "Charlie",
          "Chase",
          "Scott Christian",
          "Comic Book Guy",
          "Mr. Costington",
          "Database",
          "Declan Desmond",
          "Disco Stu",
          "Dolph",
          "Lunchlady Doris",
          "Duffman",
          "Eddie",
          "Lou",
          "Ernst",
          "Gunter",
          "Fat Tony",
          "Maude Flanders",
          "Ned Flanders",
          "Rod Flanders",
          "Todd Flanders",
          "Francesca",
          "Frankie the Squealer",
          "Professor John Frink",
          "Baby Gerald",
          "Ginger Flanders",
          "Gino",
          "Mrs. Glick",
          "Gloria",
          "Barney Gumble",
          "Gil Gunderson",
          "Judge Constance Harm",
          "Herman Hermann",
          "Bernice Hibbert",
          "Dr. Julius Hibbert",
          "Elizabeth Hoover",
          "Lionel Hutz",
          "Itchy",
          "Scratchy",
          "Jacques",
          "Jimbo Jones",
          "Joey",
          "Rachel Jordan",
          "Kang",
          "Kodos",
          "Princess Kashmir",
          "Kearney Zzyzwicz",
          "Kearney Zzyzwicz Jr.",
          "Edna Krabappel",
          "Rabbi Hyman Krustofski",
          "Krusty the Clown",
          "Cookie Kwan",
          "Dewey Largo",
          "Legs",
          "Louie",
          "Leopold",
          "Lenny Leonard",
          "Lewis",
          "Helen Lovejoy",
          "Reverend Timothy Lovejoy",
          "Coach Lugash",
          "Luigi",
          "Lurleen Lumpkin",
          "Otto Mann",
          "Captain Horatio McCallister",
          "Roger Meyers, Jr.",
          "Troy McClure",
          "Hans Moleman",
          "Dr. Marvin Monroe",
          "Nelson Muntz",
          "Captain Lance Murdock",
          "Bleeding Gums Murphy",
          "Lindsey Naegle",
          "Apu Nahasapeemapetilon",
          "Manjula Nahasapeemapetilon",
          "Sanjay Nahasapeemapetilon",
          "Old Barber",
          "Old Jewish Man",
          "Patches Violet",
          "Poor Violet",
          "Arnie Pye",
          "Poochie",
          "Herbert Powell",
          "Janey Powell",
          "Lois Pennycandy",
          "Ruth Powers",
          "Martin Prince",
          "Dr. J. Loren Pryor",
          "Mayor \"Diamond Joe\" Quimby",
          "Radioactive Man",
          "The Rich Texan",
          "Richard",
          "Dr. Nick Riviera",
          "Santa''s Little Helper",
          "Sherri",
          "Terri",
          "Dave Shutton",
          "Sideshow Bob",
          "Sideshow Mel",
          "Grampa Abraham Simpson",
          "Amber Simpson",
          "Mona Simpson",
          "Agnes Skinner",
          "Principal Seymour Skinner",
          "Waylon Smithers",
          "Snake Jailbird",
          "Snowball",
          "Judge Roy Snyder",
          "Jebediah Springfield",
          "Cletus Spuckler",
          "Brandine Spuckler",
          "Squeaky-Voiced Teen",
          "Moe Szyslak",
          "Drederick Tatum",
          "Allison Taylor",
          "Mr. Teeny",
          "Cecil Terwilliger",
          "Johnny Tightlips",
          "Üter",
          "Kirk Van Houten",
          "Luann Van Houten",
          "Milhouse Van Houten",
          "Dr. Velimirovic",
          "Chief Clancy Wiggum",
          "Ralph Wiggum",
          "Sarah Wiggum",
          "Groundskeeper Willie",
          "Wiseguy",
          "Rainier Wolfcastle",
          "Yes Guy",
          "Artie Ziff"
        ],
        "episode_titles": [
          "Simpsons Roasting on an Open Fire",
          "Bart the Genius",
          "Homer's Odyssey",
          "There's No Disgrace Like Home",
          "Bart the General",
          "Moaning Lisa",
          "The Call of the Simpsons",
          "The Telltale Head",
          "Life on the Fast Lane",
          "Homer's Night Out",
          "The Crepes of Wrath",
          "Krusty Gets Busted",
          "Some Enchanted Evening",
          "Bart Gets an F",
          "Simpson and Delilah",
          "Treehouse of Horror",
          "Two Cars in Every Garage and Three Eyes on Every Fish",
          "Dancin' Homer",
          "Dead Putting Society",
          "Bart vs. Thanksgiving",
          "Bart the Daredevil",
          "Itchy & Scratchy & Marge",
          "Bart Gets Hit by a Car",
          "One Fish, Two Fish, Blowfish, Blue Fish",
          "The Way We Was",
          "Homer vs. Lisa and the 8th Commandment",
          "Principal Charming",
          "Oh Brother, Where Art Thou?",
          "Bart's Dog Gets an F",
          "Old Money",
          "Brush with Greatness",
          "Lisa's Substitute",
          "The War of the Simpsons",
          "Three Men and a Comic Book",
          "Blood Feud",
          "Stark Raving Dad",
          "Mr. Lisa Goes to Washington",
          "When Flanders Failed",
          "Bart the Murderer",
          "Homer Defined",
          "Like Father, Like Clown",
          "Treehouse of Horror II",
          "Lisa's Pony",
          "Saturdays of Thunder",
          "Flaming Moe's",
          "Burns Verkaufen der Kraftwerk",
          "I Married Marge",
          "Radio Bart",
          "Lisa the Greek",
          "Homer Alone",
          "Bart the Lover",
          "Homer at the Bat",
          "Separate Vocations",
          "Dog of Death",
          "Colonel Homer",
          "Black Widower",
          "The Otto Show",
          "Bart's Friend Falls in Love",
          "Brother, Can You Spare Two Dimes?",
          "Kamp Krusty",
          "A Streetcar Named Marge",
          "Homer the Heretic",
          "Lisa the Beauty Queen",
          "Treehouse of Horror III",
          "Itchy & Scratchy: The Movie",
          "Marge Gets a Job",
          "New Kid on the Block",
          "Mr. Plow",
          "Lisa's First Word",
          "Homer's Triple Bypass",
          "Marge vs. the Monorail",
          "Selma's Choice",
          "Brother from the Same Planet",
          "I Love Lisa",
          "Duffless",
          "Last Exit to Springfield",
          "So It's Come to This: A Simpsons Clip Show",
          "The Front",
          "Whacking Day",
          "Marge in Chains",
          "Krusty Gets Kancelled",
          "Homer's Barbershop Quartet",
          "Cape Feare",
          "Homer Goes to College",
          "Rosebud",
          "Treehouse of Horror IV",
          "Marge on the Lam",
          "Bart's Inner Child",
          "Boy-Scoutz 'n the Hood",
          "The Last Temptation of Homer",
          "$pringfield (or, How I Learned to Stop Worrying and Love Legalized Gambling)",
          "Homer the Vigilante",
          "Bart Gets Famous",
          "Homer and Apu",
          "Lisa vs. Malibu Stacy",
          "Deep Space Homer",
          "Homer Loves Flanders",
          "Bart Gets an Elephant",
          "Burns' Heir",
          "Sweet Seymour Skinner's Baadasssss Song",
          "The Boy Who Knew Too Much",
          "Lady Bouvier's Lover",
          "Secrets of a Successful Marriage",
          "Bart of Darkness",
          "Lisa's Rival",
          "Another Simpsons Clip Show",
          "Itchy & Scratchy Land",
          "Sideshow Bob Roberts",
          "Treehouse of Horror V",
          "Bart's Girlfriend",
          "Lisa on Ice",
          "Homer Badman",
          "Grampa vs. Sexual Inadequacy",
          "Fear of Flying",
          "Homer the Great",
          "And Maggie Makes Three",
          "Bart's Comet",
          "Homie the Clown",
          "Bart vs. Australia",
          "Homer vs. Patty and Selma",
          "A Star Is Burns",
          "Lisa's Wedding",
          "Two Dozen and One Greyhounds",
          "The PTA Disbands",
          "'Round Springfield",
          "The Springfield Connection",
          "Lemon of Troy",
          "Who Shot Mr. Burns? (Part One)",
          "Who Shot Mr. Burns? (Part Two)",
          "Radioactive Man",
          "Home Sweet Homediddly-Dum-Doodily",
          "Bart Sells His Soul",
          "Lisa the Vegetarian",
          "Treehouse of Horror VI",
          "King-Size Homer",
          "Mother Simpson",
          "Sideshow Bob's Last Gleaming",
          "The Simpsons 138th Episode Spectacular",
          "Marge Be Not Proud",
          "Team Homer",
          "Two Bad Neighbors",
          "Scenes from the Class Struggle in Springfield",
          "Bart the Fink",
          "Lisa the Iconoclast",
          "Homer the Smithers",
          "The Day the Violence Died",
          "A Fish Called Selma",
          "Bart on the Road",
          "22 Short Films About Springfield",
          "Raging Abe Simpson and His Grumbling Grandson in The Curse of the Flying Hellfish",
          "Much Apu About Nothing",
          "Homerpalooza",
          "Summer of 4 Ft. 2",
          "Treehouse of Horror VII",
          "You Only Move Twice",
          "The Homer They Fall",
          "Burns, Baby Burns",
          "Bart After Dark",
          "A Milhouse Divided",
          "Lisa's Date with Density",
          "Hurricane Neddy",
          "El Viaje Misterioso de Nuestro Jomer (The Mysterious Voyage of Homer)",
          "The Springfield Files",
          "The Twisted World of Marge Simpson",
          "Mountain of Madness",
          "Simpsoncalifragilisticexpiala(Annoyed Grunt)cious",
          "The Itchy & Scratchy & Poochie Show",
          "Homer's Phobia",
          "Brother from Another Series",
          "My Sister, My Sitter",
          "Homer vs. the Eighteenth Amendment",
          "Grade School Confidential",
          "The Canine Mutiny",
          "The Old Man and the Lisa",
          "In Marge We Trust",
          "Homer's Enemy",
          "The Simpsons Spin-Off Showcase",
          "The Secret War of Lisa Simpson",
          "The City of New York vs. Homer Simpson",
          "The Principal and the Pauper",
          "Lisa's Sax",
          "Treehouse of Horror VIII",
          "The Cartridge Family",
          "Bart Star",
          "The Two Mrs. Nahasapeemapetilons",
          "Lisa the Skeptic",
          "Realty Bites",
          "Miracle on Evergreen Terrace",
          "All Singing, All Dancing",
          "Bart Carny",
          "The Joy of Sect",
          "Das Bus",
          "The Last Temptation of Krust",
          "Dumbbell Indemnity",
          "Lisa the Simpson",
          "This Little Wiggy",
          "Simpson Tide",
          "The Trouble with Trillions",
          "Girly Edition",
          "Trash of the Titans",
          "King of the Hill",
          "Lost Our Lisa",
          "Natural Born Kissers",
          "Lard of the Dance",
          "The Wizard of Evergreen Terrace",
          "Bart the Mother",
          "Treehouse of Horror IX",
          "When You Dish Upon a Star",
          "D'oh-in' in the Wind",
          "Lisa Gets an A",
          "Homer Simpson in: Kidney Trouble",
          "Mayored to the Mob",
          "Viva Ned Flanders",
          "Wild Barts Can't Be Broken",
          "Sunday, Cruddy Sunday",
          "Homer to the Max",
          "I'm with Cupid",
          "Marge Simpson in: Screaming Yellow Honkers",
          "Make Room for Lisa",
          "Maximum Homerdrive",
          "Simpsons Bible Stories",
          "Mom and Pop Art",
          "The Old Man and the C Student",
          "Monty Can't Buy Me Love",
          "They Saved Lisa's Brain",
          "Thirty Minutes over Tokyo",
          "Beyond Blunderdome",
          "Brother's Little Helper",
          "Guess Who's Coming to Criticize Dinner?",
          "Treehouse of Horror X",
          "E-I-E-I-(Annoyed Grunt)",
          "Hello Gutter, Hello Fadder",
          "Eight Misbehavin'",
          "Take My Wife, Sleaze",
          "Grift of the Magi",
          "Little Big Mom",
          "Faith Off",
          "The Mansion Family",
          "Saddlesore Galactica",
          "Alone Again, Natura-Diddily",
          "Missionary: Impossible",
          "Pygmoelian",
          "Bart to the Future",
          "Days of Wine and D'oh'ses",
          "Kill the Alligator and Run",
          "Last Tap Dance in Springfield",
          "It's a Mad, Mad, Mad, Mad Marge",
          "Behind the Laughter",
          "Treehouse of Horror XI",
          "A Tale of Two Springfields",
          "Insane Clown Poppy",
          "Lisa the Tree Hugger",
          "Homer vs. Dignity",
          "The Computer Wore Menace Shoes",
          "The Great Money Caper",
          "Skinner's Sense of Snow",
          "HOMR",
          "Pokey Mom",
          "Worst Episode Ever",
          "Tennis the Menace",
          "Day of the Jackanapes",
          "New Kids on the Blecch",
          "Hungry, Hungry Homer",
          "Bye Bye Nerdie",
          "Simpson Safari",
          "Trilogy of Error",
          "I'm Goin' to Praiseland",
          "Children of a Lesser Clod",
          "Simpsons Tall Tales",
          "Treehouse of Horror XII",
          "The Parent Rap",
          "Homer the Moe",
          "A Hunka Hunka Burns in Love",
          "The Blunder Years",
          "She of Little Faith",
          "Brawl in the Family",
          "Sweets and Sour Marge",
          "Jaws Wired Shut",
          "Half-Decent Proposal",
          "The Bart Wants What It Wants",
          "The Lastest Gun in the West",
          "The Old Man and the Key",
          "Tales from the Public Domain",
          "Blame It on Lisa",
          "Weekend at Burnsie's",
          "Gump Roast",
          "I Am Furious (Yellow)",
          "The Sweetest Apu",
          "Little Girl in the Big Ten",
          "The Frying Game",
          "Poppa's Got a Brand New Badge",
          "Treehouse of Horror XIII",
          "How I Spent My Strummer Vacation",
          "Bart vs. Lisa vs. the Third Grade",
          "Large Marge",
          "Helter Shelter",
          "The Great Louse Detective",
          "Special Edna",
          "The Dad Who Knew Too Little",
          "The Strong Arms of the Ma",
          "Pray Anything",
          "Barting Over",
          "I'm Spelling as Fast as I Can",
          "A Star Is Born Again",
          "Mr. Spritz Goes to Washington",
          "C.E.D'oh",
          "'Scuse Me While I Miss the Sky",
          "Three Gays of the Condo",
          "Dude, Where's My Ranch?",
          "Old Yeller-Belly",
          "Brake My Wife, Please",
          "The Bart of War",
          "Moe Baby Blues",
          "Treehouse of Horror XIV",
          "My Mother the Carjacker",
          "The President Wore Pearls",
          "The Regina Monologues",
          "The Fat and the Furriest",
          "Today I Am a Clown",
          "'Tis the Fifteenth Season",
          "Marge vs. Singles, Seniors, Childless Couples and Teens and Gays",
          "I, (Annoyed Grunt)-bot",
          "Diatribe of a Mad Housewife",
          "Margical History Tour",
          "Milhouse Doesn't Live Here Anymore",
          "Smart & Smarter",
          "The Ziff Who Came to Dinner",
          "Co-Dependents' Day",
          "The Wandering Juvie",
          "My Big Fat Geek Wedding",
          "Catch 'Em If You Can",
          "Simple Simpson",
          "The Way We Weren't",
          "Bart-Mangled Banner",
          "Fraudcast News",
          "Treehouse of Horror XV",
          "All's Fair in Oven War",
          "Sleeping with the Enemy",
          "She Used to Be My Girl",
          "Fat Man and Little Boy",
          "Midnight Rx",
          "Mommie Beerest",
          "Homer and Ned's Hail Mary Pass",
          "Pranksta Rap",
          "There's Something About Marrying",
          "On a Clear Day I Can't See My Sister",
          "Goo Goo Gai Pan",
          "Mobile Homer",
          "The Seven-Beer Snitch",
          "Future-Drama",
          "Don't Fear the Roofer",
          "The Heartbroke Kid",
          "A Star Is Torn",
          "Thank God It's Doomsday",
          "Home Away from Homer",
          "The Father, the Son, and the Holy Guest Star",
          "The Bonfire of the Manatees",
          "The Girl Who Slept Too Little",
          "Milhouse of Sand and Fog",
          "Treehouse of Horror XVI",
          "Marge's Son Poisoning",
          "See Homer Run",
          "The Last of the Red Hat Mamas",
          "The Italian Bob",
          "Simpsons Christmas Stories",
          "Homer's Paternity Coot",
          "We're on the Road to D'ohwhere",
          "My Fair Laddy",
          "The Seemingly Never-Ending Story",
          "Bart Has Two Mommies",
          "Homer Simpson, This Is Your Wife",
          "Million Dollar Abie",
          "Kiss Kiss, Bang Bangalore",
          "The Wettest Stories Ever Told",
          "Girls Just Want to Have Sums",
          "Regarding Margie",
          "The Monkey Suit",
          "Marge and Homer Turn a Couple Play",
          "The Mook, the Chef, the Wife and Her Homer",
          "Jazzy and the Pussycats",
          "Please Homer, Don't Hammer 'Em",
          "Treehouse of Horror XVII",
          "G.I. (Annoyed Grunt)",
          "Moe'N'a Lisa",
          "Ice Cream of Margie (with the Light Blue Hair)",
          "The Haw-Hawed Couple",
          "Kill Gil, Volumes I & II",
          "The Wife Aquatic",
          "Revenge Is a Dish Best Served Three Times",
          "Little Big Girl",
          "Springfield Up",
          "Yokel Chords",
          "Rome-Old and Juli-Eh",
          "Homerazzi",
          "Marge Gamer",
          "The Boys of Bummer",
          "Crook and Ladder",
          "Stop! Or My Dog Will Shoot",
          "24 Minutes",
          "You Kent Always Say What You Want",
          "He Loves to Fly and He D'ohs",
          "The Homer of Seville",
          "Midnight Towboy",
          "I Don't Wanna Know Why the Caged Bird Sings",
          "Treehouse of Horror XVIII",
          "Little Orphan Millie",
          "Husbands and Knives",
          "Funeral for a Fiend",
          "Eternal Moonshine of the Simpson Mind",
          "E Pluribus Wiggum",
          "That '90s Show",
          "Love, Springfieldian Style",
          "The Debarted",
          "Dial N for Nerder",
          "Smoke on the Daughter",
          "Papa Don't Leech",
          "Apocalypse Cow",
          "Any Given Sundance",
          "Mona Leaves-a",
          "All About Lisa",
          "Sex, Pies and Idiot Scrapes",
          "Lost Verizon",
          "Double, Double, Boy in Trouble",
          "Treehouse of Horror XIX",
          "Dangerous Curves",
          "Homer and Lisa Exchange Cross Words",
          "MyPods and Boomsticks",
          "The Burns and the Bees",
          "Lisa the Drama Queen",
          "Take My Life, Please",
          "How the Test Was Won",
          "No Loan Again, Naturally",
          "Gone Maggie Gone",
          "In the Name of the Grandfather",
          "Wedding for Disaster",
          "Eeny Teeny Maya Moe",
          "The Good, the Sad and the Drugly",
          "Father Knows Worst",
          "Waverly Hills, 9-0-2-1-D'oh",
          "Four Great Women and a Manicure",
          "Coming to Homerica",
          "Homer the Whopper",
          "Bart Gets a 'Z'",
          "The Great Wife Hope",
          "Treehouse of Horror XX",
          "The Devil Wears Nada",
          "Pranks and Greens",
          "Rednecks and Broomsticks",
          "O Brother, Where Bart Thou?",
          "Thursdays with Abie",
          "Once Upon a Time in Springfield",
          "Million Dollar Maybe",
          "Boy Meets Curl",
          "The Color Yellow",
          "Postcards from the Wedge",
          "Stealing First Base",
          "The Greatest Story Ever D'ohed",
          "American History X-cellent",
          "Chief of Hearts",
          "The Squirt and the Whale",
          "To Surveil with Love",
          "Moe Letter Blues",
          "The Bob Next Door",
          "Judge Me Tender",
          "Elementary School Musical",
          "Loan-a Lisa",
          "MoneyBart",
          "Treehouse of Horror XXI",
          "Lisa Simpson, This Isn't Your Life",
          "The Fool Monty",
          "How Munched is That Birdie in the Window?",
          "The Fight Before Christmas",
          "Donnie Fatso",
          "Moms I'd Like to Forget",
          "Flaming Moe",
          "Homer the Father",
          "The Blue and the Gray",
          "Angry Dad: The Movie",
          "The Scorpion's Tale",
          "A Midsummer's Nice Dream",
          "Love Is a Many Strangled Thing",
          "The Great Simpsina",
          "The Real Housewives of Fat Tony",
          "Homer Scissorhands",
          "500 Keys",
          "The Ned-Liest Catch",
          "The Falcon and the D'ohman",
          "Bart Stops to Smell the Roosevelts",
          "Treehouse of Horror XXII",
          "Replaceable You",
          "The Food Wife",
          "The Book Job",
          "The Man in the Blue Flannel Pants",
          "The Ten-Per-Cent Solution",
          "Holidays of Future Passed",
          "Politically Inept, with Homer Simpson",
          "The D'oh-cial Network",
          "Moe Goes from Rags to Riches",
          "The Daughter Also Rises",
          "At Long Last Leave",
          "Exit Through the Kwik-E-Mart",
          "How I Wet Your Mother",
          "Them, Robot",
          "Beware My Cheating Bart",
          "A Totally Fun Thing That Bart Will Never Do Again",
          "The Spy Who Learned Me",
          "Ned 'n' Edna's Blend Agenda",
          "Lisa Goes Gaga",
          "Moonshine River",
          "Treehouse of Horror XXIII",
          "Adventures in Baby-Getting",
          "Gone Abie Gone",
          "Penny-Wiseguys",
          "A Tree Grows in Springfield",
          "The Day the Earth Stood Cool",
          "To Cur with Love",
          "Homer Goes to Prep School",
          "A Test Before Trying",
          "The Changing of the Guardian",
          "Love Is a Many-Splintered Thing",
          "Hardly Kirk-ing",
          "Gorgeous Grampa",
          "Black Eyed, Please",
          "Dark Knight Court",
          "What Animated Women Want",
          "Pulpit Friction",
          "Whiskey Business",
          "The Fabulous Faker Boy",
          "The Saga of Carl",
          "Dangers on a Train",
          "Homerland",
          "Treehouse of Horror XXIV",
          "Four Regrettings and a Funeral",
          "YOLO",
          "Labor Pains",
          "The Kid Is All Right",
          "Yellow Subterfuge",
          "White Christmas Blues",
          "Steal This Episode",
          "Married to the Blob",
          "Specs and the City",
          "Diggs",
          "The Man Who Grew Too Much",
          "The Winter of His Content",
          "The War of Art",
          "You Don't Have to Live Like a Referee",
          "Luca$",
          "Days of Future Future",
          "What to Expect When Bart's Expecting",
          "Brick Like Me",
          "Pay Pal",
          "The Yellow Badge of Cowardge",
          "Clown in the Dumps",
          "The Wreck of the Relationship",
          "Super Franchise Me",
          "Treehouse of Horror XXV",
          "Opposites A-Frack",
          "Simpsorama",
          "Blazed and Confused",
          "Covercraft",
          "I Won't Be Home for Christmas",
          "The Man Who Came to Be Dinner",
          "Bart's New Friend",
          "The Musk Who Fell to Earth",
          "Walking Big & Tall",
          "My Fare Lady",
          "The Princess Guide",
          "Sky Police",
          "Waiting for Duffman",
          "Peeping Mom",
          "The Kids Are All Fight",
          "Let's Go Fly a Coot",
          "Bull-E",
          "Mathlete's Feat",
          "Every Man's Dream",
          "Cue Detective",
          "Puffless",
          "Halloween of Horror",
          "Treehouse of Horror XXVI",
          "Friend with Benefit",
          "Lisa with an 'S'",
          "Paths of Glory",
          "Barthood",
          "The Girl Code",
          "Teenage Mutant Milk-Caused Hurdles",
          "Much Apu About Something",
          "Love Is in the N2-O2-Ar-CO2-Ne-He-CH4",
          "Gal of Constant Sorrow",
          "Lisa the Veterinarian",
          "The Marge-ian Chronicles",
          "The Burns Cage",
          "How Lisa Got Her Marge Back",
          "Fland Canyon",
          "To Courier with Love",
          "Simprovised",
          "Orange Is the New Yellow",
          "Monty Burns' Fleeing Circus",
          "Friends and Family",
          "The Town",
          "Treehouse of Horror XXVII",
          "Trust but Clarify",
          "There Will Be Buds",
          "Havana Wild Weekend",
          "Dad Behavior",
          "The Last Traction Hero",
          "The Nightmare After Krustmas",
          "Pork and Burns",
          "The Great Phatsby Parts 1 & 2",
          "Fatzcarraldo",
          "The Cad and the Hat",
          "Kamp Krustier",
          "22 for 30",
          "A Father's Watch",
          "The Caper Chase",
          "Looking for Mr. Goodbart",
          "Moho House",
          "Dogtown",
          "The Serfsons",
          "Springfield Splendor",
          "Whistler's Father",
          "Treehouse of Horror XXVIII",
          "Grampy Can Ya Hear Me",
          "The Old Blue Mayor She Ain't What She Used to Be",
          "Singin' in the Lane",
          "Mr. Lisa's Opus",
          "Gone Boy",
          "Haw-Haw Land",
          "Frink Gets Testy",
          "Homer Is Where the Art Isn't",
          "3 Scenes Plus a Tag from a Marriage",
          "Fears of a Clown",
          "No Good Read Goes Unpunished",
          "King Leer",
          "Lisa Gets the Blues",
          "Forgive and Regret",
          "Left Behind",
          "Throw Grampa from the Dane",
          "Flanders' Ladder",
          "Bart's Not Dead",
          "Heartbreak Hotel",
          "My Way or the Highway to Heaven",
          "Treehouse of Horror XXIX",
          "Baby You Can't Drive My Car",
          "From Russia Without Love",
          "Werking Mom",
          "Krusty the Clown",
          "Daddicus Finch",
          "'Tis the 30th Season",
          "Mad About the Toy",
          "The Girl on the Bus",
          "I'm Dancing as Fat as I Can",
          "The Clown Stays in the Picture",
          "101 Mitigations",
          "I Want You (She's So Heavy)",
          "E My Sports",
          "Bart vs. Itchy & Scratchy",
          "Girl's in the Band",
          "I'm Just a Girl Who Can't Say D'oh",
          "D'oh Canada",
          "Woo-Hoo Dunnit?",
          "Crystal Blue-Haired Persuasion",
          "The Winter of Our Monetized Content",
          "Go Big or Go Homer",
          "The Fat Blue Line",
          "Treehouse of Horror XXX",
          "Gorillas on the Mast"
        ],
        "locations": [
          "Springfield",
          "Evergreen Terrace",
          "Springfield Nuclear Power Plant",
          "Kwik-E-Mart",
          "The Android's Dungeon & Baseball Card Shop",
          "Barney's Bowl-A-Rama",
          "Costington's",
          "KBBL Broadcasting",
          "King Toot's",
          "The Leftorium",
          "Noiseland Video Arcade",
          "Sprawl-Mart",
          "Springfield Mall",
          "Stoner's Pot Palace",
          "Try-N-Save",
          "Jake's Unisex Hairplace",
          "The Gilded Truffle",
          "Moe's Tavern",
          "Krusty Burger",
          "Lard Lad Donuts",
          "Luigi's",
          "The Frying Dutchman",
          "The Singing Sirloin",
          "The Happy Sumo",
          "The Java Server",
          "Pimento Grove",
          "Springfield Elementary School",
          "West Springfield Elementary School",
          "Springfield Preparatory School",
          "Springfield High School",
          "Krustylu Studios",
          "Sleep Eazy Motel",
          "Springfield Retirement Castle",
          "The Springfield City Hall",
          "Springfield Courthouse",
          "Five Corners",
          "Krustyland",
          "Shelbyville",
          "Capital City",
          "Brockway",
          "Ogdenville",
          "North Haverbrook",
          "Cypress Creek"
        ],
        "quotes": [
          "Marriage is like a coffin and each kid is another nail.",
          "It takes two to lie: one to lie and one to listen.",
          "Life is just one crushing defeat after another until you just wish Flanders was dead.",
          "You tried your best and you failed miserably. The lesson is: Never try.",
          "If you pray to the wrong god, you might just make the right one madder and madder.",
          "Kill my boss? Do I dare live out the American dream?",
          "I'm not normally a praying man, but if you're up there, please save me, Superman!",
          "D'oh!",
          "That's it! You people have stood in my way long enough. I'm going to clown college!",
          "Son, if you really want something in this life, you have to work for it. Now quiet! They're about to announce the lottery numbers.",
          "What’s the point of going out? We’re just gonna wind up back home anyway.",
          "Cheating is the gift man gives himself.",
          "Books are useless! I only ever read one book, To Kill A Mockingbird, and it gave me absolutely no insight on how to kill mockingbirds!",
          "Sorry, Mom, the mob has spoken.",
          "Go out on a Tuesday? Who am I, Charlie Sheen?",
          "To alcohol! The cause of, and solution to, all of life's problems.",
          "Trust me, Bart, it's better to walk in on both your parents than on just one of them.",
          "Oh, loneliness and cheeseburgers are a dangerous mix.",
          "When will I learn? The answers to life’s problems aren’t at the bottom of a bottle, they’re on TV!"
        ]
      },
      "slack_emoji": {
        "activity": [
          ":running:",
          ":walking:",
          ":dancer:",
          ":rowboat:",
          ":swimmer:",
          ":surfer:",
          ":bath:",
          ":snowboarder:",
          ":ski:",
          ":snowman:",
          ":bicyclist:",
          ":mountain_bicyclist:",
          ":horse_racing:",
          ":tent:",
          ":fishing_pole_and_fish:",
          ":soccer:",
          ":basketball:",
          ":football:",
          ":baseball:",
          ":tennis:",
          ":rugby_football:",
          ":golf:",
          ":trophy:",
          ":running_shirt_with_sash:",
          ":checkered_flag:",
          ":musical_keyboard:",
          ":guitar:",
          ":violin:",
          ":saxophone:",
          ":trumpet:",
          ":musical_note:",
          ":notes:",
          ":musical_score:",
          ":headphones:",
          ":microphone:",
          ":performing_arts:",
          ":ticket:",
          ":tophat:",
          ":circus_tent:",
          ":clapper:",
          ":art:",
          ":dart:",
          ":8ball:",
          ":bowling:",
          ":slot_machine:",
          ":game_die:",
          ":video_game:",
          ":flower_playing_cards:",
          ":black_joker:",
          ":mahjong:",
          ":carousel_horse:",
          ":ferris_wheel:",
          ":roller_coaster:"
        ],
        "celebration": [
          ":ribbon:",
          ":gift:",
          ":birthday:",
          ":jack_o_lantern:",
          ":christmas_tree:",
          ":tanabata_tree:",
          ":bamboo:",
          ":rice_scene:",
          ":fireworks:",
          ":sparkler:",
          ":tada:",
          ":confetti_ball:",
          ":balloon:",
          ":dizzy:",
          ":sparkles:",
          ":collision:",
          ":mortar_board:",
          ":crown:",
          ":dolls:",
          ":flags:",
          ":wind_chime:",
          ":crossed_flags:",
          ":lantern:",
          ":ring:",
          ":heart:",
          ":broken_heart:",
          ":love_letter:",
          ":two_hearts:",
          ":revolving_hearts:",
          ":heartbeat:",
          ":heartpulse:",
          ":sparkling_heart:",
          ":cupid:",
          ":gift_heart:",
          ":heart_decoration:",
          ":purple_heart:",
          ":yellow_heart:",
          ":green_heart:",
          ":blue_heart:"
        ],
        "custom": [
          ":beryl:",
          ":bowtie:",
          ":crab:",
          ":cubimal_chick:",
          ":dusty_stick:",
          ":feelsgood:",
          ":finnadie:",
          ":fu:",
          ":goberserk:",
          ":godmode:",
          ":hurtrealbad:",
          ":metal:",
          ":neckbeard:",
          ":octocat:",
          ":piggy:",
          ":pride:",
          ":rage1:",
          ":rage2:",
          ":rage3:",
          ":rage4:",
          ":rube:",
          ":simple_smile:",
          ":slack:",
          ":squirrel:",
          ":suspect:",
          ":taco:",
          ":trollface:"
        ],
        "emoji": [
          "#{people}",
          "#{nature}",
          "#{food_and_drink}",
          "#{celebration}",
          "#{activity}",
          "#{travel_and_places}",
          "#{objects_and_symbols}",
          "#{custom}"
        ],
        "food_and_drink": [
          ":tomato:",
          ":eggplant:",
          ":corn:",
          ":sweet_potato:",
          ":grapes:",
          ":melon:",
          ":watermelon:",
          ":tangerine:",
          ":lemon:",
          ":banana:",
          ":pineapple:",
          ":apple:",
          ":green_apple:",
          ":pear:",
          ":peach:",
          ":cherries:",
          ":strawberry:",
          ":hamburger:",
          ":pizza:",
          ":meat_on_bone:",
          ":poultry_leg:",
          ":rice_cracker:",
          ":rice_ball:",
          ":rice:",
          ":curry:",
          ":ramen:",
          ":spaghetti:",
          ":bread:",
          ":fries:",
          ":dango:",
          ":oden:",
          ":sushi:",
          ":fried_shrimp:",
          ":fish_cake:",
          ":icecream:",
          ":shaved_ice:",
          ":ice_cream:",
          ":doughnut:",
          ":cookie:",
          ":chocolate_bar:",
          ":candy:",
          ":lollipop:",
          ":custard:",
          ":honey_pot:",
          ":cake:",
          ":bento:",
          ":stew:",
          ":egg:",
          ":fork_and_knife:",
          ":tea:",
          ":coffee:",
          ":sake:",
          ":wine_glass:",
          ":cocktail:",
          ":tropical_drink:",
          ":beer:",
          ":beers:",
          ":baby_bottle:"
        ],
        "nature": [
          ":seedling:",
          ":evergreen_tree:",
          ":deciduous_tree:",
          ":palm_tree:",
          ":cactus:",
          ":tulip:",
          ":cherry_blossom:",
          ":rose:",
          ":hibiscus:",
          ":sunflower:",
          ":blossom:",
          ":bouquet:",
          ":ear_of_rice:",
          ":herb:",
          ":four_leaf_clover:",
          ":maple_leaf:",
          ":fallen_leaf:",
          ":leaves:",
          ":mushroom:",
          ":chestnut:",
          ":rat:",
          ":mouse2:",
          ":mouse:",
          ":hamster:",
          ":ox:",
          ":water_buffalo:",
          ":cow2:",
          ":cow:",
          ":tiger2:",
          ":leopard:",
          ":tiger:",
          ":rabbit2:",
          ":rabbit:",
          ":cat2:",
          ":cat:",
          ":racehorse:",
          ":horse:",
          ":ram:",
          ":sheep:",
          ":goat:",
          ":rooster:",
          ":chicken:",
          ":baby_chick:",
          ":hatching_chick:",
          ":hatched_chick:",
          ":bird:",
          ":penguin:",
          ":elephant:",
          ":dromedary_camel:",
          ":camel:",
          ":boar:",
          ":pig2:",
          ":pig:",
          ":pig_nose:",
          ":dog2:",
          ":poodle:",
          ":dog:",
          ":wolf:",
          ":bear:",
          ":koala:",
          ":panda_face:",
          ":monkey_face:",
          ":see_no_evil:",
          ":hear_no_evil:",
          ":speak_no_evil:",
          ":monkey:",
          ":dragon:",
          ":dragon_face:",
          ":crocodile:",
          ":snake:",
          ":turtle:",
          ":frog:",
          ":whale2:",
          ":whale:",
          ":flipper:",
          ":octopus:",
          ":fish:",
          ":tropical_fish:",
          ":blowfish:",
          ":shell:",
          ":snail:",
          ":bug:",
          ":ant:",
          ":honeybee:",
          ":beetle:",
          ":paw_prints:",
          ":zap:",
          ":fire:",
          ":crescent_moon:",
          ":sunny:",
          ":partly_sunny:",
          ":cloud:",
          ":droplet:",
          ":sweat_drops:",
          ":umbrella:",
          ":dash:",
          ":snowflake:",
          ":star2:",
          ":star:",
          ":stars:",
          ":sunrise_over_mountains:",
          ":sunrise:",
          ":rainbow:",
          ":ocean:",
          ":volcano:",
          ":milky_way:",
          ":mount_fuji:",
          ":japan:",
          ":globe_with_meridians:",
          ":earth_africa:",
          ":earth_americas:",
          ":earth_asia:",
          ":new_moon:",
          ":waxing_crescent_moon:",
          ":first_quarter_moon:",
          ":waxing_gibbous_moon:",
          ":full_moon:",
          ":waning_gibbous_moon:",
          ":last_quarter_moon:",
          ":waning_crescent_moon:",
          ":new_moon_with_face:",
          ":full_moon_with_face:",
          ":first_quarter_moon_with_face:",
          ":last_quarter_moon_with_face:",
          ":sun_with_face:"
        ],
        "objects_and_symbols": [
          ":watch:",
          ":iphone:",
          ":calling:",
          ":computer:",
          ":alarm_clock:",
          ":hourglass_flowing_sand:",
          ":hourglass:",
          ":camera:",
          ":video_camera:",
          ":movie_camera:",
          ":tv:",
          ":radio:",
          ":pager:",
          ":telephone_receiver:",
          ":telephone:",
          ":fax:",
          ":minidisc:",
          ":floppy_disk:",
          ":cd:",
          ":dvd:",
          ":vhs:",
          ":battery:",
          ":electric_plug:",
          ":bulb:",
          ":flashlight:",
          ":satellite:",
          ":credit_card:",
          ":money_with_wings:",
          ":moneybag:",
          ":gem:",
          ":closed_umbrella:",
          ":pouch:",
          ":purse:",
          ":handbag:",
          ":briefcase:",
          ":school_satchel:",
          ":lipstick:",
          ":eyeglasses:",
          ":womans_hat:",
          ":sandal:",
          ":high_heel:",
          ":boot:",
          ":shoe:",
          ":athletic_shoe:",
          ":bikini:",
          ":dress:",
          ":kimono:",
          ":womans_clothes:",
          ":tshirt:",
          ":necktie:",
          ":jeans:",
          ":door:",
          ":shower:",
          ":bathtub:",
          ":toilet:",
          ":barber:",
          ":syringe:",
          ":pill:",
          ":microscope:",
          ":telescope:",
          ":crystal_ball:",
          ":wrench:",
          ":hocho:",
          ":nut_and_bolt:",
          ":hammer:",
          ":bomb:",
          ":smoking:",
          ":gun:",
          ":bookmark:",
          ":newspaper:",
          ":key:",
          ":envelope:",
          ":envelope_with_arrow:",
          ":incoming_envelope:",
          ":e-mail:",
          ":inbox_tray:",
          ":outbox_tray:",
          ":package:",
          ":postal_horn:",
          ":postbox:",
          ":mailbox_closed:",
          ":mailbox:",
          ":mailbox_with_mail:",
          ":mailbox_with_no_mail:",
          ":page_facing_up:",
          ":page_with_curl:",
          ":bookmark_tabs:",
          ":chart_with_upwards_trend:",
          ":chart_with_downwards_trend:",
          ":bar_chart:",
          ":date:",
          ":calendar:",
          ":low_brightness:",
          ":high_brightness:",
          ":scroll:",
          ":clipboard:",
          ":open_book:",
          ":notebook:",
          ":notebook_with_decorative_cover:",
          ":ledger:",
          ":closed_book:",
          ":green_book:",
          ":blue_book:",
          ":orange_book:",
          ":books:",
          ":card_index:",
          ":link:",
          ":paperclip:",
          ":pushpin:",
          ":scissors:",
          ":triangular_ruler:",
          ":round_pushpin:",
          ":straight_ruler:",
          ":triangular_flag_on_post:",
          ":file_folder:",
          ":open_file_folder:",
          ":black_nib:",
          ":pencil2:",
          ":pencil:",
          ":lock_with_ink_pen:",
          ":closed_lock_with_key:",
          ":lock:",
          ":unlock:",
          ":mega:",
          ":loudspeaker:",
          ":sound:",
          ":speaker:",
          ":mute:",
          ":zzz:",
          ":bell:",
          ":no_bell:",
          ":thought_balloon:",
          ":speech_balloon:",
          ":children_crossing:",
          ":mag:",
          ":mag_right:",
          ":no_entry_sign:",
          ":no_entry:",
          ":name_badge:",
          ":no_pedestrians:",
          ":do_not_litter:",
          ":no_bicycles:",
          ":non-potable_water:",
          ":no_mobile_phones:",
          ":underage:",
          ":accept:",
          ":ideograph_advantage:",
          ":white_flower:",
          ":secret:",
          ":congratulations:",
          ":u5408:",
          ":u6e80:",
          ":u7981:",
          ":u6709:",
          ":u7121:",
          ":u7533:",
          ":u55b6:",
          ":u6708:",
          ":u5272:",
          ":u7a7a:",
          ":sa:",
          ":koko:",
          ":u6307:",
          ":chart:",
          ":sparkle:",
          ":eight_spoked_asterisk:",
          ":negative_squared_cross_mark:",
          ":white_check_mark:",
          ":eight_pointed_black_star:",
          ":vibration_mode:",
          ":mobile_phone_off:",
          ":vs:",
          ":a:",
          ":b:",
          ":ab:",
          ":cl:",
          ":o2:",
          ":sos:",
          ":id:",
          ":parking:",
          ":wc:",
          ":cool:",
          ":free:",
          ":new:",
          ":ng:",
          ":ok:",
          ":up:",
          ":atm:",
          ":aries:",
          ":taurus:",
          ":gemini:",
          ":cancer:",
          ":leo:",
          ":virgo:",
          ":libra:",
          ":scorpius:",
          ":sagittarius:",
          ":capricorn:",
          ":aquarius:",
          ":pisces:",
          ":restroom:",
          ":mens:",
          ":womens:",
          ":baby_symbol:",
          ":wheelchair:",
          ":potable_water:",
          ":no_smoking:",
          ":put_litter_in_its_place:",
          ":arrow_forward:",
          ":arrow_backward:",
          ":arrow_up_small:",
          ":arrow_down_small:",
          ":fast_forward:",
          ":rewind:",
          ":arrow_double_up:",
          ":arrow_double_down:",
          ":arrow_right:",
          ":arrow_left:",
          ":arrow_up:",
          ":arrow_down:",
          ":arrow_upper_right:",
          ":arrow_lower_right:",
          ":arrow_lower_left:",
          ":arrow_upper_left:",
          ":arrow_up_down:",
          ":left_right_arrow:",
          ":arrows_counterclockwise:",
          ":arrow_right_hook:",
          ":leftwards_arrow_with_hook:",
          ":arrow_heading_up:",
          ":arrow_heading_down:",
          ":twisted_rightwards_arrows:",
          ":repeat:",
          ":repeat_one:",
          ":zero:",
          ":one:",
          ":two:",
          ":three:",
          ":four:",
          ":five:",
          ":six:",
          ":seven:",
          ":eight:",
          ":nine:",
          ":keycap_ten:",
          ":1234:",
          ":abc:",
          ":abcd:",
          ":capital_abcd:",
          ":information_source:",
          ":signal_strength:",
          ":cinema:",
          ":symbols:",
          ":heavy_plus_sign:",
          ":heavy_minus_sign:",
          ":wavy_dash:",
          ":heavy_division_sign:",
          ":heavy_multiplication_x:",
          ":heavy_check_mark:",
          ":arrows_clockwise:",
          ":tm:",
          ":copyright:",
          ":registered:",
          ":currency_exchange:",
          ":heavy_dollar_sign:",
          ":curly_loop:",
          ":loop:",
          ":part_alternation_mark:",
          ":heavy_exclamation_mark:",
          ":question:",
          ":grey_exclamation:",
          ":grey_question:",
          ":interrobang:",
          ":x:",
          ":o:",
          ":100:",
          ":end:",
          ":back:",
          ":on:",
          ":top:",
          ":soon:",
          ":cyclone:",
          ":m:",
          ":ophiuchus:",
          ":six_pointed_star:",
          ":beginner:",
          ":trident:",
          ":warning:",
          ":hotsprings:",
          ":recycle:",
          ":anger:",
          ":diamond_shape_with_a_dot_inside:",
          ":spades:",
          ":clubs:",
          ":hearts:",
          ":diamonds:",
          ":ballot_box_with_check:",
          ":white_circle:",
          ":black_circle:",
          ":radio_button:",
          ":red_circle:",
          ":large_blue_circle:",
          ":small_red_triangle:",
          ":small_red_triangle_down:",
          ":small_orange_diamond:",
          ":small_blue_diamond:",
          ":large_orange_diamond:",
          ":large_blue_diamond:",
          ":black_small_square:",
          ":white_small_square:",
          ":black_large_square:",
          ":white_large_square:",
          ":black_medium_square:",
          ":white_medium_square:",
          ":black_medium_small_square:",
          ":white_medium_small_square:",
          ":black_square_button:",
          ":white_square_button:",
          ":clock1:",
          ":clock2:",
          ":clock3:",
          ":clock4:",
          ":clock5:",
          ":clock6:",
          ":clock7:",
          ":clock8:",
          ":clock9:",
          ":clock10:",
          ":clock11:",
          ":clock12:",
          ":clock130:",
          ":clock230:",
          ":clock330:",
          ":clock430:",
          ":clock530:",
          ":clock630:",
          ":clock730:",
          ":clock830:",
          ":clock930:",
          ":clock1030:",
          ":clock1130:",
          ":clock1230:"
        ],
        "people": [
          ":grinning:",
          ":grin:",
          ":joy:",
          ":smiley:",
          ":smile:",
          ":sweat_smile:",
          ":satisfied:",
          ":innocent:",
          ":smiling_imp:",
          ":imp:",
          ":wink:",
          ":blush:",
          ":relaxed:",
          ":yum:",
          ":relieved:",
          ":heart_eyes:",
          ":sunglasses:",
          ":smirk:",
          ":neutral_face:",
          ":expressionless:",
          ":unamused:",
          ":sweat:",
          ":pensive:",
          ":confused:",
          ":confounded:",
          ":kissing:",
          ":kissing_heart:",
          ":kissing_smiling_eyes:",
          ":kissing_closed_eyes:",
          ":stuck_out_tongue:",
          ":stuck_out_tongue_winking_eye:",
          ":stuck_out_tongue_closed_eyes:",
          ":disappointed:",
          ":worried:",
          ":angry:",
          ":rage:",
          ":cry:",
          ":persevere:",
          ":triumph:",
          ":disappointed_relieved:",
          ":frowning:",
          ":anguished:",
          ":fearful:",
          ":weary:",
          ":sleepy:",
          ":tired_face:",
          ":grimacing:",
          ":sob:",
          ":open_mouth:",
          ":hushed:",
          ":cold_sweat:",
          ":scream:",
          ":astonished:",
          ":flushed:",
          ":sleeping:",
          ":dizzy_face:",
          ":no_mouth:",
          ":mask:",
          ":smile_cat:",
          ":joy_cat:",
          ":smiley_cat:",
          ":heart_eyes_cat:",
          ":smirk_cat:",
          ":kissing_cat:",
          ":pouting_cat:",
          ":crying_cat_face:",
          ":scream_cat:",
          ":footprints:",
          ":bust_in_silhouette:",
          ":busts_in_silhouette:",
          ":baby:",
          ":boy:",
          ":girl:",
          ":man:",
          ":woman:",
          ":family:",
          ":couple:",
          ":two_men_holding_hands:",
          ":two_women_holding_hands:",
          ":dancers:",
          ":bride_with_veil:",
          ":person_with_blond_hair:",
          ":man_with_gua_pi_mao:",
          ":man_with_turban:",
          ":older_man:",
          ":older_woman:",
          ":cop:",
          ":construction_worker:",
          ":princess:",
          ":guardsman:",
          ":angel:",
          ":santa:",
          ":ghost:",
          ":japanese_ogre:",
          ":japanese_goblin:",
          ":shit:",
          ":skull:",
          ":alien:",
          ":space_invader:",
          ":bow:",
          ":information_desk_person:",
          ":no_good:",
          ":ok_woman:",
          ":raising_hand:",
          ":person_with_pouting_face:",
          ":person_frowning:",
          ":massage:",
          ":haircut:",
          ":couple_with_heart:",
          ":couplekiss:",
          ":raised_hands:",
          ":clap:",
          ":ear:",
          ":eyes:",
          ":nose:",
          ":lips:",
          ":kiss:",
          ":tongue:",
          ":nail_care:",
          ":wave:",
          ":thumbsup:",
          ":thumbsdown:",
          ":point_up:",
          ":point_up_2:",
          ":point_down:",
          ":point_left:",
          ":point_right:",
          ":ok_hand:",
          ":v:",
          ":punch:",
          ":fist:",
          ":raised_hand:",
          ":muscle:",
          ":open_hands:",
          ":pray:"
        ],
        "travel_and_places": [
          ":train:",
          ":mountain_railway:",
          ":steam_locomotive:",
          ":monorail:",
          ":bullettrain_side:",
          ":bullettrain_front:",
          ":train2:",
          ":metro:",
          ":light_rail:",
          ":station:",
          ":tram:",
          ":bus:",
          ":oncoming_bus:",
          ":trolleybus:",
          ":minibus:",
          ":ambulance:",
          ":fire_engine:",
          ":police_car:",
          ":oncoming_police_car:",
          ":rotating_light:",
          ":taxi:",
          ":oncoming_taxi:",
          ":red_car:",
          ":oncoming_automobile:",
          ":blue_car:",
          ":truck:",
          ":articulated_lorry:",
          ":tractor:",
          ":bike:",
          ":busstop:",
          ":fuelpump:",
          ":construction:",
          ":vertical_traffic_light:",
          ":traffic_light:",
          ":rocket:",
          ":helicopter:",
          ":airplane:",
          ":seat:",
          ":anchor:",
          ":ship:",
          ":speedboat:",
          ":sailboat:",
          ":aerial_tramway:",
          ":mountain_cableway:",
          ":suspension_railway:",
          ":passport_control:",
          ":customs:",
          ":baggage_claim:",
          ":left_luggage:",
          ":yen:",
          ":euro:",
          ":pound:",
          ":dollar:",
          ":statue_of_liberty:",
          ":moyai:",
          ":foggy:",
          ":tokyo_tower:",
          ":fountain:",
          ":european_castle:",
          ":japanese_castle:",
          ":city_sunrise:",
          ":city_sunset:",
          ":night_with_stars:",
          ":bridge_at_night:",
          ":house:",
          ":house_with_garden:",
          ":office:",
          ":department_store:",
          ":factory:",
          ":post_office:",
          ":european_post_office:",
          ":hospital:",
          ":bank:",
          ":hotel:",
          ":love_hotel:",
          ":convenience_store:",
          ":school:",
          ":cn:",
          ":de:",
          ":es:",
          ":fr:",
          ":uk:",
          ":it:",
          ":jp:",
          ":kr:",
          ":ru:",
          ":us:"
        ]
      },
      "smashing_pumpkins": {
        "albums": [
          "Gish",
          "Siamese Dream",
          "Pisces Iscariot",
          "Mellon Collie and the Infinite Sadness",
          "The Aeroplane Flies High",
          "Adore",
          "Machina/The Machines of God",
          "Machina II/The Friends & Enemies of Modern Music",
          "Zeitgeist",
          "Oceania",
          "Teargarden by Kaleidyscope Vol. 1: Songs for a Sailor",
          "Teargarden by Kaleidyscope Vol. 2: The Solstice Bare",
          "Teargarden by Kaleidyscope - Volume III",
          "Monuments to an Elegy",
          "American Gothic",
          "Shiny and Oh So Bright, Vol. 1 / LP: No Past. No Future. No Sun.",
          "Cyr",
          "Atum: A Rock Opera in Three Acts"
        ],
        "lyric": [
          "I am one as you are three, try to find a messiah in your trinity. Your city to burn, your city to burn, try to look for something in your city to burn, you'll burn",
          "Way down deep and in my heart, lies a soul that's torn apart. Tell me, tell me what you're after, I just want to get there faster",
          "Colors show, after the moon, I should go, See you in June...Your way",
          "All of you struggles beneath your disguise. You drink from the reasons that hold you alive. To ascend from the wounds of desire and pain. You must rise from the mounds of desire and change",
          "Nothing left to say, and all I've left to do, is run away from you. And she led me on, down, with secrets I can't keep",
          "I'm all by myself, as I've always felt, I'll betray myself, to anyone",
          "Fool enough to almost be it. Cool enough to not quite see it. Doomed",
          "Pick your pocket, full of sorrow, and run away with me tomorrow, June",
          "We'll try and ease the pain, but somehow, we'll feel the same. Well, no one knows where our secrets go",
          "I send a heart to all my dearies. When your life is so, so dreary...Dream",
          "I'm rumored to the straight and narrow, while the harlots of my perils scream",
          "And I fail, but when I can, I will try to understand that when I can, I will",
          "Mother, weep the years I'm missing. All our time can't be given...back",
          "Shut my mouth and strike the demons, that cursed you and your reasons. Out of hand and out of season, Out of love and out of feeling",
          "Fool enough to almost be it, and cool enough to not quite see it, and old enough to always feel this. Always old, I'll always feel this",
          "No more promise, no more sorrow, no longer will I follow. Can anybody hear me? I just want to be...me!",
          "Shot full of diamonds, and a million years, the disappointed disappear like they were never here",
          "In a dream we are connected, Siamese twins at the wrist. And then I knew we'd been forsaken, expelled from paradise. I can't believe them, when they say that it's alright",
          "Consume my love, devour my hate, only powers my escape. The moon is out, the stars invite, I think I'll leave tonight",
          "What moonsongs do you sing your babies? What sunshine do you bring?",
          "Who belongs? Who decides who's crazy? Who rights wrongs where others cling?",
          "Today is the greatest day I've ever known. Can't live for tomorrow, tomorrow's much too long. I'll burn my eyes out before I get out",
          "My angel wings were bruised and restrained. My belly stings\"",
          "Disarm you with a smile, and cut you like you want me to, cut that little child, inside of me and such a part of you",
          "I used to be a little boy, so old in my shoes. And what I choose is my choice. What's a boy supposed to do?",
          "Disarm you with a smile, and leave you like they left me here, to wither in denial, the bitterness of one who's left alone",
          "The killer in me is the killer in you, my love. I send this smile over to you.",
          "Time is never time at all, you can never ever leave, without leaving a piece of youth",
          "And the embers never fade, in your city by the lake. The place where you were born",
          "The world is a vampire, sent to drain, secret destroyers, hold you up to the flames",
          "I fear that I'm ordinary just like everyone",
          "Despite all my rage, I am still just a rat in a cage",
          "Now I'm naked. Nothing but an animal. But can you fake it for just one more show?",
          "My reflection, dirty mirror, there's no connection to myself. I'm your lover, I'm your zero. I'm the face in your dreams of glass",
          "Emptiness is loneliness, and loneliness is cleanliness, and cleanliness is godliness, and God is empty just like me",
          "To runaround kids in get-go cars, With Vaseline afterbirths and neon coughs. Galaxies full of nobodies, Givin' us the farewell runarounds.",
          "Can I look up to you as you look down on me. Can I feel in to you as you felt in to me",
          "Machine gun blues. Her vacant rush is so steel. I'm unaware. Lost inside your visions",
          "Carve out your heart for keeps in an old oak tree, and hold me for goodbyes, and whispered lullabyes",
          "But I knew exactly where I was. And I knew the meaning of it all. And I knew the distance to the sun. And I knew the echo that is love",
          "And I knew the secrets in your spires. And I knew the emptiness of youth. And I knew the solitude of heart. And I knew the murmurs of the soul",
          "And I knew the silence of the world",
          "As far as you take me, that's where I believe. The realm of soft delusions, floatin' on the leaves",
          "On a distant shoreline she waves her arms to me, as all the thought police are closin' in for sleep",
          "The dilly dally of my bright-lit stay. The steam of my misfortunes has given me the power to be afraid",
          "King of the horseflies, dark prince of death. His tragic forces are heaven-sent. In sweet things, in a lover's breath. In knowing this was meant to be the last",
          "On dead highways, her black beauties roam. For June angels, so far from home. For a love lost, a faded picture. To tread lightning, to ink the lavender skies",
          "The tragedies reside in you, the secret sights hide in you, the lonely nights divide you in two, in two, in two",
          "Speak to me in a language I can hear, humor me before I have to go, deep in thought, I forgive everyone, as the cluttered streets greet me once again",
          "The earth laughs beneath my heavy feet, at the blasphemy in my old jangly walk, steeple guide me to my heart and home, the sun is out and up and down again",
          "These are the tears I've been crying my whole life, Like an ocean of desire / I'm reaching through the noise across the dusk of time, within the lilting lies, I am singing out to you.",
          "Sleep will not come to this tired body now. Peace will not come to this lonely heart",
          "And for a moment I lose myself, wrapped up in the pleasures of the world, I've journeyed here and there and back again, but in the same old haunts, I still find my friends. Mysteries not ready to reveal, sympathies I'm ready to return.",
          "Shakedown 1979. Cool kids never have the time. On a live wire right up off the street, you and I should meet",
          "Junebug skippin' like a stone, with the headlights pointed at the dawn. We were sure we'd never see an end to it all",
          "Justine never knew the rules, hung down with the freaks and ghouls. No apologies ever need be made. I know you better than you fake it, to see",
          "Breathin' underwater, and livin' under glass",
          "And if you spin your love around, the secrets of your dreams, you may find your love is gone and is not quite what it seemed. To appear to disappear, beneath all your darkest fears",
          "I believe in never, I believe in all the way. But belief is not to notice, belief is just some faith. And faith can't help you to escape",
          "The night has come to hold us young",
          "And are you just like me? Dead eyes, dead eyes, are you just like me?",
          "Her eyes, her eyes were as vacant as the seas, yeah. Dead eyes, dead eyes, are you just like me?",
          "We only come out at night. We only come out at night. The days are much too bright. We only come out at night",
          "I am made of shamrocks. I am made of stern stuff. I am never enough. I am the forgotten child",
          "I don't look in the mirror. I don't like what I see staring back at me. Everything is clearer, I'll never see what you see. It's not me, so beautiful and free",
          "I'll never be what you need, can't help it at all. I was born so beautiful, but now I'm ugly",
          "I'm good enough, but I don't care. I'm good enough, but I'm not there. I'm good enough, but I don't care. The sun is out, but I'm not there",
          "Stay with me, I'll set you free, 'cause I can tell you once were pretty. Rose so sad, you've lost your petals. Lost the luster off your tattle-tales",
          "I need a love to help me find my way. I need a strength that I cannot betray. I need a word to say what I can't say. I need a lover!, lover!",
          "Lovely girl, you're the murder in my world, dressing coffins for the souls I've left to die. Drinking mercury to the mystery, of all that you should ever leave behind. In time",
          "Kiss and kill me sweetly, come and drive me home. drag the miles in me, I am yours alone",
          "Come and kiss me sweetly, ride the telephone, drag the miles to me, I am yours alone",
          "Desire me so deeply, drain and kick me hard, whisper secrets for me, try to go too far",
          "Inside, where it's warm. Wrap myself in you. Outside, where I'm torn. Fight myself in two. In two. Into...you",
          "You're gonna walk on home, You're gonna walk alone. You're gonna see this through. Don't let them get to you",
          "Blank page is all the rage, Never meant to say anything, In bed, I was half dead tired of dreaming of rest",
          "I catch the rainfall, through the leaking roof, that you had left behind. You remind me, of that leak in my soul",
          "The rain falls, my friends call. Leaking rain on the phone",
          "Take a day, plant some trees. May they shade you from me. May your children play beneath",
          "Got dressed, drove the state line, looking for you at the five and dime. But there I was, picking pieces up. You are a ghost, of my indecision. No more, little girl",
          "But for the grace of love I'd will the meaning of Heaven from above",
          "Long horses we are born, creatures more than torn, mourning our way home",
          "What if the sun refused to shine? What if the clouds refused to rain? What if the wind refused to blow? What if the seas refused to wave?",
          "Darkness scares and unawares, is us selling you, behind these walls and in your faults, gains trust as sinew",
          "So here we are, upon your stage. The laughs we shared, the dreams we saved",
          "Yes lord, I'm sinking, I wonder just how far, What was I thinking, Oh when I fell apart",
          "Now you know where I've been, as you sleep, torn I am. Weighted down, patiently, born of love",
          "You know I'm, you know I'm not dead, I'm just living in my head, forever waiting",
          "On the ways of your desire, you always find a way, and through it all, onto us all you move, forgotten touch, forbidden thought, we can never have enough",
          "Found below, the creatures scream, stranglehold, a god machine. Begging to, tear us out, what is hell?",
          "We all want to hold in the everlasting gaze, enchanted in the rapture of his sentimental sway, but underneath the wheels lie the skulls of every cog, the fickle fascination of an everlasting God",
          "I peer through curtains on empty streets, behind a wall of caller ID, no one's out there to hear if I care, about the troubles in the air",
          "I've blown the dust off my guitar, in the attic with the stars, I read your letters to feel better, my tears upon the faded ink",
          "'Cause I of the mourning now go, pick up where my thoughts left off, 'Cause I'm home to die on my own",
          "You and me, meant to be, immutable, impossible, it's destiny, pure lunacy, incalculable, inseparable",
          "Who wouldn't be the one you love? Who wouldn't stand inside your love?",
          "To the center of the earth, or anywhere God decides, full of fever pulling forth, we hear our call as all",
          "To the center of the earth, as if written in, DNA is reaching out, to your frequency",
          "Black rooms are calling, to men in leather coats. White labs are cooking up the silver ghost.",
          "The glass migrates under her translucent skin. And all the spiders wonder what we've got us in",
          "So meets the final coda of a vinyl storm, one more cherry cola to lift up her dead arms. A dream of soft focus, sunsets filters through the dim. We are losing contact as she dials it in",
          "I have seen a thousand fractures, I have seen everything. 'Cause knowing is its own answer, love something in a book. There's not much left to ponder, not much left to cook",
          "This is the song I've been singing my whole life. I've been waiting like a knife, to cut open your heart, and bleed my soul into you. I did it all for you, you and you, and you, and you",
          "To clear up all the talk. Although, I'm selfish to a fault. Is it selfish, it's you I want? You, I did it all for you",
          "These are the tears I've been crying my whole life. Like an ocean of desire, I'm reaching through the noise. Across the dusk of time, within the lilting lies, I am singing out to you",
          "Left for dead as you sweep out the cold. Things we said we don't need anymore. Tale inside her like a fallen kite"
        ],
        "musicians": [
          "Billy Corgan",
          "James Iha",
          "D'arcy Wretzky",
          "Jimmy Chamberlin",
          "Jeff Schroeder",
          "Jack Bates",
          "Katie Cole",
          "Melissa Auf der Maur",
          "Ginger Pooley",
          "Mike Byrne",
          "Nicole Fiorentino"
        ],
        "songs": [
          "...Said Sadly",
          "1979",
          "7 Shades of Black",
          "77",
          "Age of Innocence",
          "Annie-Dog",
          "Apathy's Last Kiss",
          "Appels + Oranjes",
          "Atum",
          "Ava Adore",
          "Avalanche",
          "Beautiful",
          "Because You Are",
          "Beguiled",
          "Behold! the Night Mare",
          "Believe",
          "Blank",
          "Blank Page",
          "Bleed",
          "Bleeding the Orchid",
          "Blew Away",
          "Blissed",
          "Blissed and Gone",
          "Blue",
          "Blue Skies Bring Tears",
          "Bodies",
          "Body + Soul",
          "Breath of Life",
          "Breathe",
          "Bullet with Butterfly Wings",
          "Bury Me",
          "Butterfly Suite",
          "By Starlight",
          "Bye June",
          "Cherry",
          "Cherub Rock",
          "Christmastime",
          "Confessions of a Dopamine Addict",
          "Crestfallen",
          "Crush",
          "Cupid de Locke",
          "Cyr",
          "Czarina",
          "Daphne Descends",
          "Daydream",
          "Death from Above",
          "Disarm",
          "Disco King",
          "Doomsday Clock",
          "Dorian",
          "Drain",
          "Dross",
          "Drown",
          "Drum + Fife",
          "Dulcet in E",
          "Egg",
          "Empires",
          "Every Morning",
          "Eye",
          "Farewell and Goodnight",
          "For God and Country",
          "For Martha",
          "Frail and Bedazzled",
          "French Movie Theme",
          "G.L.O.W.",
          "Galapogos",
          "Geek U.S.A.",
          "Germans in Leather Pants",
          "Glass and the Ghost Children",
          "Glass' Theme",
          "Glissandra",
          "Glynis",
          "Go",
          "God",
          "Gossamer",
          "Heavy Metal Machine",
          "Hello Kitty Kat",
          "Here Is No Why",
          "Here's to the Atom Bomb",
          "Honeyspider",
          "Hooligan",
          "Hooray!",
          "Hummer",
          "Huzzah!",
          "I Am My End",
          "I Am One",
          "I Am One Part II",
          "I of the Mourning",
          "I Said",
          "I'll Never Change",
          "I'm a Believer",
          "I'm Going Crazy",
          "If There Is a God",
          "In Lieu Of Failure",
          "In My Body",
          "In the Arms of Sleep",
          "Infinite Sadness",
          "Innosense",
          "Intergalatic",
          "Jackboot",
          "Jellybelly",
          "Jennifer Ever",
          "Jesus is the Sun",
          "Jesus Loves His Babies",
          "Jimmy James",
          "Joy",
          "Jupiter's Lament",
          "Knights of Malta",
          "Knuckles",
          "La Dolly Vita",
          "Le Deux Machina",
          "Let Me Give the World to You",
          "Let You In",
          "Lily (My One and Only)",
          "Love",
          "Lover",
          "Lucky 13",
          "Lucky Lad",
          "Luna",
          "Marquis in Spades",
          "Mayonaise",
          "Medellia of the Gray Skies",
          "Meladori Magpie",
          "Mellon Collie and the Infinite Sadness",
          "Methusela",
          "Moleasskiss",
          "Monuments",
          "Moonkids",
          "Morning Jam",
          "Morning Star",
          "Mouths of Babes",
          "Muzzle",
          "My Dahlia",
          "My Eternity",
          "My Love Is Winter",
          "My Mistake",
          "My Poor Troubled Heart",
          "Neophyte",
          "Obscured",
          "Oceania",
          "Of Wings",
          "Once in a While",
          "Once Upon a Time",
          "Opal",
          "Panopticon",
          "Pastichio Medley",
          "Peace + Love",
          "Pennies",
          "Perfect",
          "Pissant",
          "Plume",
          "Pomp and Circumstances",
          "Porcelina",
          "Porcelina of the Vast Oceans",
          "Pug",
          "Purple Blood",
          "Purr Snickety",
          "Quiet",
          "Raindrops + Sunshowers",
          "Ramona",
          "Real Love",
          "Rhinoceros",
          "Rocket",
          "Rotten Apples",
          "Saturnine",
          "Set The Ray To Jerry",
          "Shame",
          "Siamese Dream",
          "Siva",
          "Slow Dawn",
          "Slunk",
          "Smiley",
          "Snail",
          "So So Pretty",
          "Solara",
          "Soma",
          "Soothe",
          "Spaceboy",
          "Spaced",
          "Spacer",
          "Spangled",
          "Speed Kills",
          "Stand Inside Your Love",
          "Starla",
          "Stars Fall In",
          "Stumbleine",
          "Suffer",
          "Sweet Sweet",
          "Take Me Down",
          "Tales of a Scorched Earth",
          "Tarantula",
          "Tear",
          "That Which Animates The Spirit",
          "That's the Way (My Love Is)",
          "The Aeroplane Flies High (Turns Left, Looks Right)",
          "The Beginning Is the End Is the Beginning",
          "The Bells",
          "The Boy",
          "The Colour of Love",
          "The Crying Tree of Mercury",
          "The Culling",
          "The Dauphine",
          "The End Is the Beginning Is the End",
          "The Everlasting Gaze",
          "The Good In Goodbye",
          "The Groover",
          "The Imploding Voice",
          "The Last Song",
          "The Sacred and Profane",
          "The Tale of Dusty and Pistol Pete",
          "Thirty-Three",
          "Thru the Eyes of Ruby",
          "To Forgive",
          "To Sheila",
          "To The Grays",
          "Today",
          "Tonight, Tonight",
          "Tonite Reprise",
          "Transformer",
          "Tribute to Johnny",
          "Tristessa",
          "Try, Try, Try",
          "Ugly",
          "United States",
          "Waiting",
          "Waiting for You Now",
          "Walking Country",
          "We Only Come Out at Night",
          "Where Boys Fear to Tread",
          "Whir",
          "White Spyder",
          "Why Am I So Tired",
          "Wildflower",
          "Window Paine",
          "Winterlong",
          "Wound",
          "Wyttch",
          "X.Y.U.",
          "Zeitgeist",
          "Zero"
        ]
      },
      "source": {
        "hello_world": {
          "c": "printf('Hello World!');",
          "clojure": "(print 'Hello World!')",
          "elixir": "IO.puts 'Hello World!'",
          "java": "System.out.println('Hello World!');",
          "javascript": "alert('Hello World!');",
          "php": "echo 'Hello World!';",
          "python": "print('Hello World!')",
          "ruby": "puts 'Hello World!'"
        },
        "print": {
          "c": "printf('faker_string_to_print');",
          "clojure": "(print 'faker_string_to_print')",
          "elixir": "IO.puts 'faker_string_to_print'",
          "java": "System.out.println('faker_string_to_print');",
          "javascript": "console.log('faker_string_to_print');",
          "php": "echo 'faker_string_to_print';",
          "python": "print('faker_string_to_print')",
          "ruby": "puts 'faker_string_to_print'"
        },
        "print_1_to_10": {
          "c": " for(int i=0; i<10; i++) { printf('%d', i); }",
          "clojure": " (for [i (range 1 11)] (println i))",
          "elixir": " Enum.each(1..10, fn(x) -> IO.puts x end)",
          "java": " for (int i=0; i<10; i++) { System.out.println(i); }",
          "javascript": " for (let i=0; i<10; i++) { console.log(i); }",
          "php": " for ($i=1; $i<10; $i++) { echo $i; }",
          "python": " for i in range(10): print(i)",
          "ruby": " (1..10).each { |i| puts i }"
        }
      },
      "south_park": {
        "characters": [
          "Bebe Stevens",
          "Bradley Biggle",
          "Butters Stotch",
          "Carol McCormick",
          "Clyde Donovan",
          "Craig Tucker",
          "David Rodriguez",
          "Dougie",
          "Dr. Alphonse Mephesto",
          "Eric Cartman",
          "Father Maxi",
          "Gerald Broflovski",
          "God",
          "Grandpa Marvin Marsh",
          "Heidi Turner",
          "Ike Broflovski",
          "Jesus",
          "Jimbo Kern",
          "Jimmy Valmer",
          "Karen McCormick",
          "Kenny McCormick",
          "Kevin McCormick",
          "Kyle Broflovski",
          "Lemmiwinks",
          "Liane Cartman",
          "Linda Stotch",
          "Mayor McDaniels",
          "Moses",
          "Mr. Garrison",
          "Mr. Hankey",
          "Mr. Mackey",
          "Mr. Slave",
          "Ned Gerblansky",
          "Officer Barbrady",
          "PC Principal",
          "Pip",
          "Randy Marsh",
          "Santa",
          "Satan",
          "Scott Malkinson",
          "Sergeant Harrison Yates",
          "Sharon Marsh",
          "Sheila Broflovski",
          "Shelly Marsh",
          "Stan Marsh",
          "Starvin' Marvin",
          "Stephen Stotch",
          "Stuart McCormick",
          "Terrance and Phillip",
          "Timmy Burch",
          "Tolkien Black",
          "Towelie",
          "Tuong Lu Kim",
          "Tweek Tweak",
          "Wendy Testaburger"
        ],
        "episodes": [
          "Weight Gain 4000",
          "Volcano",
          "Death",
          "Pinkeye",
          "Damien",
          "Starvin' Marvin",
          "Mr. Hankey, the Christmas Poo",
          "Tom's Rhinoplasty",
          "Mecha-Streisand",
          "Chickenlover",
          "Ike's Wee Wee",
          "Conjoined Fetus Lady",
          "The Mexican Staring Frog of Southern Sri Lanka",
          "City on the Edge of Forever (Flashbacks)",
          "Summer Sucks",
          "Chickenpox",
          "Roger Ebert Should Lay Off the Fatty Foods",
          "Clubhouses",
          "Cow Days",
          "Chef Aid",
          "Spookyfish",
          "Merry Christmas Charlie Manson!",
          "Gnomes",
          "Prehistoric Ice Man",
          "Rainforest Shmainforest",
          "Spontaneous Combustion",
          "The Succubus",
          "Tweek Vs. Craig",
          "Jakovasaurs",
          "Two Guys Naked in a Hot Tub",
          "Chinpokomon",
          "Starvin' Marvin in Space",
          "Korn's Groovy Pirate Ghost Mystery",
          "Hooked on Monkey Fonics",
          "Mr. Hankey's Christmas Classics",
          "Are You There, God? It's Me, Jesus",
          "World Wide Recorder Concert",
          "Cartman's Silly Hate Crime 2000",
          "The Tooth Fairy's Tats 2000",
          "Quintuplets 2000",
          "Timmy 2000",
          "Pip",
          "Cartman Joins NAMBLA",
          "Cherokee Hair Tampons",
          "Chef Goes Nanners",
          "Something You Can Do With Your Finger",
          "Probably",
          "Fourth Grade",
          "Trapper Keeper",
          "Helen Keller! The Musical",
          "The Wacky Molestation Adventure",
          "A Very Crappy Christmas",
          "It Hits the Fan",
          "Cripple Fight",
          "Super Best Friends",
          "Terrance and Phillip. Behind the Blow",
          "Cartmanland",
          "Towelie",
          "The Entity",
          "Here Comes the Neighborhood",
          "Kenny Dies",
          "Butters' Very Own Episode",
          "Freak Strike",
          "Jared Has Aides",
          "Asspen",
          "The New Terrance and Phillip Movie Trailer",
          "Fun with Veal",
          "Professor Chaos",
          "The Simpsons Already Did It",
          "Free Hat",
          "A Ladder to Heaven",
          "The Return of the Fellowship of the Ring to the Two Towers",
          "My Future Self 'n' Me",
          "Red Sleigh Down",
          "I'm a Little Bit Country",
          "Krazy Kripples",
          "Toilet Paper",
          "Cancelled",
          "Lil' Crime Stoppers",
          "Red Man's Greed",
          "Christian Rock Hard",
          "Grey Dawn",
          "Casa Bonita",
          "Butt Out",
          "Raisins",
          "It's Christmas in Canada",
          "Good Times With Weapons",
          "AWESOM-O",
          "Up the Down Steroid",
          "You Got F'd in the A",
          "Goobacks",
          "The Jeffersons",
          "Douche and Turd",
          "Something Wall Mart This Way Comes",
          "Pre-School",
          "Quest for Ratings",
          "Cartman's Incredible Gift",
          "Woodland Critter Christmas",
          "Wing",
          "Best Friends Forever",
          "The Losing Edge",
          "The Death of Eric Cartman",
          "Two Days Before the Day After Tomorrow",
          "Marjorine",
          "Follow That Egg",
          "Ginger Kids",
          "Trapped in the Closet",
          "Free Willzyx",
          "Bloody Mary",
          "The Return of Chef",
          "Smug Alert",
          "Cartoon Wars Part I",
          "Cartoon Wars Part II",
          "A Million Little Fibers",
          "ManBearPig",
          "Tsst!",
          "Make Love, Not Warcraft",
          "Mystery of the Urinal Deuce",
          "Hell on Earth 2006",
          "Go God Go",
          "Go God Go XII",
          "Stanley's Cup",
          "With Apologies to Jesse Jackson",
          "Cartman Sucks",
          "Lice Capades",
          "The Snuke",
          "Fantastic Easter Special",
          "D-Yikes!",
          "Night of the Living Homeless",
          "Le Petit Tourette",
          "Imaginationland",
          "Imaginationland, Episode II",
          "Imaginationland, Episode III",
          "The List",
          "Tonsil Trouble",
          "Britney's New Look",
          "Canada on Strike",
          "Over Logging",
          "Super Fun Time",
          "The China Probrem",
          "Breast Cancer Show Ever",
          "Pandemic",
          "Pandemic 2. The Startling",
          "About Last Night...",
          "Elementary School Musical",
          "The Ungroundable",
          "The Ring",
          "The Coon",
          "Margaritaville",
          "Eat, Pray, Queef",
          "Fishsticks",
          "Pinewood Derby",
          "Butters' Bottom Bitch",
          "W.T.F.",
          "The F Word",
          "Dances With Smurfs",
          "Pee",
          "Medicinal Fried Chicken",
          "You Have 0 Friends",
          "200",
          "201",
          "Crippled Summer",
          "Poor and Stupid",
          "It's A Jersey Thing",
          "Insheeption",
          "Coon 2. Hindsight",
          "Mysterion Rises",
          "Coon vs. Coon & Friends",
          "Creme Fraiche",
          "HUMANCENTiPAD",
          "Funnybot",
          "Royal Pudding",
          "T.M.I.",
          "Crack Baby Athletic Association",
          "City Sushi",
          "You're Getting Old",
          "The Last of the Meheecans",
          "Bass to Mouth",
          "Broadway Bro Down",
          "1%",
          "A History Channel Thanksgiving",
          "The Poor Kid",
          "Cash For Gold",
          "Faith Hilling",
          "Butterballs",
          "I Should Have Never Gone Ziplining",
          "Cartman Finds Love",
          "Sarcastaball",
          "Raising the Bar",
          "Insecurity",
          "Going Native",
          "A Nightmare on Face Time",
          "A Scause for Applause",
          "Obama Wins!",
          "Let Go, Let Gov",
          "World War Zimmerman",
          "Goth Kids 3. Dawn of the Posers",
          "Taming Strange",
          "Ginger Cow",
          "Black Friday",
          "The Hobbit",
          "Go Fund Yourself",
          "Gluten Free Ebola",
          "The Cissy",
          "Handicar",
          "The Magic Bush",
          "Freemium Isn't Free",
          "Grounded Vindaloop",
          "Cock Magic",
          "#REHASH",
          "#HappyHolograms",
          "Stunning and Brave",
          "Where My Country Gone?",
          "The City Part of Town",
          "You're Not Yelping",
          "Safe Space",
          "Tweek x Craig",
          "Naughty Ninjas",
          "Sponsored Content",
          "Truth and Advertising",
          "PC Principal Final Justice",
          "Member Berries",
          "Skank Hunt",
          "The Damned",
          "Wieners Out",
          "Fort Collins",
          "Oh, Jeez",
          "Members Only",
          "Not Funny",
          "The End of Serialization as We Know It",
          "Put It Down",
          "Holiday Special",
          "Franchise Prequel",
          "Hummels & Heroin",
          "Sons A Witches",
          "Doubling Down",
          "Moss Piglets",
          "SUPER HARD PCness",
          "Splatty Tomato",
          "A Boy and a Priest",
          "The Problem With a Poo",
          "Tegridy Farms",
          "The Scoots",
          "Time To Get Cereal",
          "Nobody Got Cereal?",
          "Buddha Box",
          "Unfulfilled",
          "Bike Parade",
          "Mexican Joker",
          "Band in China",
          "Shots!!!",
          "Let Them Eat Goo",
          "Tegridy Farms Halloween Special",
          "Season Finale",
          "Board Girls",
          "Turd Burglars",
          "Basic Cable",
          "Christmas Snow",
          "The Pandemic Special",
          "South ParQ Vaccination Special",
          "Pajama Day",
          "The Big Fix",
          "City People",
          "Back to the Cold War",
          "Help, My Teenager Hates Me!",
          "Credigree Weed St. Patrick's Day Special",
          "Cupid Ye",
          "The Worldwide Privacy Tour",
          "Japanese Toilet",
          "Deep Learning",
          "DikinBaus Hot Dogs",
          "Spring Break"
        ],
        "quotes": [
          "All animals kill, and the animals that don't kill are stupid ones like cows and turtles and stuff",
          "Dad, Tom Cruise won't come out of the closet!",
          "Don't do drugs kids. There is a time and place for everything. It's called college",
          "Don't lie, Stan. Lying makes you sterile",
          "Don't you dare call me a Cartman!",
          "Don't you know the first law of physics? Anything that's fun costs at least eight dollars.",
          "Drugs are bad, mmkay?",
          "Hell, everything's legal in Mexico. It's the American way",
          "Hey Panda Bear! We don't take kindly to your types around here.",
          "Hippies. They're everywhere. They wanna save Earth, but all they do is smoke pot and smell bad",
          "I don't make the rules Kyle, I simply think them up and write them down",
          "I think that parents only get so offended by television because they rely on it as a babysitter and the sole educator of their kids",
          "I'm just getting a little cancer Stan",
          "I'm not fat, I'm festively plump",
          "Kenny's family is so poor that yesterday, they had to put their cardboard box up for a second mortgage",
          "Life is short butters, & thats why you have to do whatever you want all the time",
          "No we haven't actually seen it Tom, we're just reporting it",
          "No, that's wrong, Cartman. But don't worry. There are no stupid answers, just stupid people",
          "Oh my god, they killed Kenny!",
          "Respect my authoritaahh!!!",
          "Screw you guys, I'm going home!",
          "They took der derrs",
          "They took our deers",
          "They took our jobs",
          "Well, I looked in my mom's closet and saw what I was getting for Christmas, an UltraVibe Pleasure 2000.",
          "We must stop frivolous spending! Instead of paying for cable, let us watch clouds! Instead of buying clothes, wear but sheets from thine beds! Cut spending to only the bare essentials! Water and bread and margaritas!",
          "When a chick says 'we need to talk,' you might as well start punching yourself in the balls, dude",
          "Without evil there could be no good, so it must be good to be evil sometimes",
          "You know, I think that if parents would spend less time worrying about what their kids watch on TV and more time worrying about what's going on in their kids' lives, this world would be a much better place",
          "Your mother was worried sick and I was here drinking beer"
        ]
      },
      "space": {
        "agency": [
          "National Aeronautics and Space Administration",
          "European Space Agency",
          "German Aerospace Center",
          "Indian Space Research Organization",
          "China National Space Administration",
          "UK Space Agency",
          "Brazilian Space Agency",
          "Mexican Space Agency",
          "Israeli Space Agency",
          "Italian Space Agency",
          "Japan Aerospace Exploration Agency",
          "National Space Agency of Ukraine",
          "Russian Federal Space Agency",
          "Swedish National Space Board"
        ],
        "agency_abv": [
          "NASA",
          "AEM",
          "AEB",
          "UKSA",
          "CSA",
          "CNSA",
          "ESA",
          "DLR",
          "ISRO",
          "JAXA",
          "ISA",
          "CNES",
          "NSAU",
          "ROSCOSMOS",
          "SNSB"
        ],
        "company": [
          "Rocket Lab",
          "SpaceX",
          "Blue Origin",
          "Virgin Galactic",
          "SpaceDev",
          "Bigelow Aerospace",
          "Orbital Sciences",
          "JPL",
          "NASA Jet Propulsion Laboratory"
        ],
        "constellation": [
          "Big Dipper",
          "Litte Dipper",
          "Orion",
          "Leo",
          "Gemini",
          "Cancer",
          "Canis Minor",
          "Canis Major",
          "Ursa Major",
          "Ursa Minor",
          "Virgo",
          "Libra",
          "Scorpius",
          "Sagittarius",
          "Lyra",
          "Capricornus",
          "Aquarius",
          "Pisces",
          "Aries",
          "Leo Minor",
          "Auriga"
        ],
        "distance_measurement": [
          "light years",
          "AU",
          "parsecs",
          "kiloparsecs",
          "megaparsecs"
        ],
        "galaxy": [
          "Milky Way",
          "Andromeda",
          "Triangulum",
          "Whirlpool",
          "Blackeye",
          "Sunflower",
          "Pinwheel",
          "Hoags Object",
          "Centaurus A",
          "Messier 83"
        ],
        "launch_vehicle": [
          "Antares",
          "Ariane 5",
          "Atlas",
          "Diamant",
          "Dnepr",
          "Delta",
          "Electron",
          "Energia",
          "Europa",
          "Falcon 9",
          "Falcon Heavy",
          "GSLV",
          "Juno",
          "Long March",
          "Mercury-Redstone",
          "Minotaur",
          "Pegasus",
          "Proton",
          "PSLV",
          "Safir",
          "Shavit",
          "Saturn IV",
          "Semiorka",
          "Soyouz",
          "Titan",
          "Vega",
          "Veronique",
          "Zenit"
        ],
        "meteorite": [
          "Aarhus",
          "Abee",
          "Adelie Land",
          "Adhi Kot",
          "Adzhi-Bogdo",
          "Santa Rosa de Viterbo",
          "Agen",
          "Akbarpur",
          "Albareto",
          "Allan Hills 84001",
          "Allan Hills A81005",
          "Allegan",
          "Allende",
          "Ambapur Nagla",
          "Andura",
          "Angers",
          "Angra dos Reis",
          "Ankober",
          "Anlong",
          "Annaheim",
          "Appley Bridge",
          "Arbol Solo",
          "Archie",
          "Arroyo Aguiar",
          "Assisi",
          "Atoka",
          "Avanhandava",
          "Bacubirito",
          "Baszkówka",
          "Beardsley",
          "Bellsbank",
          "Bench Crater",
          "Benton",
          "Białystok",
          "Blithfield",
          "Block Island",
          "Bovedy",
          "Brachina",
          "Brahin",
          "Brenham",
          "Buzzard Coulee",
          "Campo del Cielo",
          "Canyon Diablo",
          "Cape York",
          "Carancas",
          "Chambord",
          "Chassigny",
          "Chelyabinsk",
          "Chergach",
          "Chinga",
          "Chinguetti",
          "Claxton",
          "Coahuila",
          "Cranbourne",
          "D'Orbigny",
          "Dronino",
          "Eagle Station",
          "Elbogen",
          "Ensisheim",
          "Esquel",
          "Fukang",
          "Gancedo",
          "Gao–Guenie",
          "Gay Gulch",
          "Gebel Kamil",
          "Gibeon",
          "Goose Lake",
          "Grant",
          "Hadley Rille",
          "Heat Shield Rock",
          "Hoba",
          "Homestead",
          "Hraschina",
          "Huckitta",
          "Imilac",
          "Itqiy",
          "Kaidun",
          "Kainsaz",
          "Karoonda",
          "Kesen",
          "Krasnojarsk",
          "L'Aigle",
          "Lac Dodon",
          "Lake Murray",
          "Loreto",
          "Los Angeles",
          "Łowicz",
          "Mackinac Island",
          "Mbozi",
          "Middlesbrough",
          "Millbillillie",
          "Mineo",
          "Monte Milone",
          "Moss",
          "Mundrabilla",
          "Muonionalusta",
          "Murchison",
          "Nakhla",
          "Nantan",
          "Neuschwanstein",
          "Northwest Africa 7034",
          "Northwest Africa 7325",
          "Norton County",
          "Novato",
          "Northwest Africa 3009",
          "Oileán Ruaidh (Martian)",
          "Old Woman",
          "Oldenburg",
          "Omolon",
          "Orgueil",
          "Ornans",
          "Osseo",
          "Österplana 065",
          "Ourique",
          "Pallasovka",
          "Paragould",
          "Park Forest",
          "Pavlovka",
          "Peace River",
          "Peekskill",
          "Penouille",
          "Polonnaruwa",
          "High Possil",
          "Příbram",
          "Pultusk",
          "Qidong",
          "Richardton",
          "Santa Vitoria do Palmar",
          "Sayh al Uhaymir 169",
          "Seymchan",
          "Shelter Island",
          "Shergotty",
          "Sikhote-Alin",
          "Sołtmany",
          "Springwater",
          "St-Robert",
          "Stannern",
          "Sulagiri",
          "Sutter's Mill",
          "Sylacauga",
          "Tagish Lake",
          "Tamdakht",
          "Tenham",
          "Texas Fireball",
          "Tissint",
          "Tlacotepec",
          "Toluca",
          "Treysa",
          "Twannberg",
          "Veliky Ustyug",
          "Vermillion",
          "Weston",
          "Willamette",
          "Winona",
          "Wold Cottage",
          "Yamato 000593",
          "Yamato 691",
          "Yamato 791197",
          "Yardymly",
          "Zagami",
          "Zaisho",
          "Zaklodzie"
        ],
        "moon": [
          "Moon",
          "Luna",
          "Deimos",
          "Phobos",
          "Ganymede",
          "Callisto",
          "Io",
          "Europa",
          "Titan",
          "Rhea",
          "Iapetus",
          "Dione",
          "Tethys",
          "Hyperion",
          "Ariel",
          "Puck",
          "Oberon",
          "Umbriel",
          "Triton",
          "Proteus"
        ],
        "nasa_space_craft": [
          "Orion",
          "Mercury",
          "Gemini",
          "Apollo",
          "Enterprise",
          "Columbia",
          "Challenger",
          "Discovery",
          "Atlantis",
          "Endeavour"
        ],
        "nebula": [
          "Lagoon Nebula",
          "Eagle Nebula",
          "Triffid Nebula",
          "Dumbell Nebula",
          "Orion Nebula",
          "Ring Nebula",
          "Bodes Nebula",
          "Owl Nebula"
        ],
        "planet": [
          "Mercury",
          "Venus",
          "Earth",
          "Mars",
          "Jupiter",
          "Saturn",
          "Uranus",
          "Neptune"
        ],
        "star": [
          "Sun",
          "Proxima Centauri",
          "Rigil Kentaurus",
          "Barnards Star",
          "Wolf 359",
          "Luyten 726-8A",
          "Luyten 726-8B",
          "Sirius A",
          "Sirius B",
          "Ross 154",
          "Ross 248",
          "Procyon A",
          "Procyon B",
          "Vega",
          "Rigel",
          "Arcturus",
          "Betelgeuse",
          "Mahasim",
          "Polaris"
        ],
        "star_cluster": [
          "Wild Duck",
          "Hyades",
          "Coma",
          "Butterfly",
          "Messier 7",
          "Pleiades",
          "Beehive Cluster",
          "Pearl Cluster",
          "Hodge 301",
          "Jewel Box Cluster",
          "Wishing Well Cluster",
          "Diamond Cluster",
          "Trumpler 10",
          "Collinder 140",
          "Liller 1",
          "Koposov II",
          "Koposov I",
          "Djorgovski 1",
          "Arp-Madore 1",
          "NGC 6144",
          "NGC 2808",
          "NGC 1783",
          "Messier 107",
          "Messier 70",
          "Omega Centauri",
          "Palomar 12",
          "Palomar 4",
          "Palomar 6",
          "Pyxis Cluster",
          "Segue 3"
        ]
      },
      "spongebob": {
        "characters": [
          "SpongeBob SquarePants",
          "Patrick Star",
          "Squidward Tentacles",
          "Mr. Krabs",
          "Sheldon Plankton",
          "Karen Plankton",
          "Sandy Cheeks",
          "Mrs. Puff",
          "Pearl Krabs",
          "Gary"
        ],
        "episodes": [
          "Help Wanted",
          "Reef Blower",
          "Tea at the Treedome",
          "Bubblestand",
          "Ripped Pants",
          "Jellyfishing",
          "Plankton!",
          "Naughty Nautical Neighbors",
          "Boating School",
          "Pizza Delivery",
          "Home Sweet Pineapple",
          "Mermaid Man and Barnacle Boy",
          "Pickles",
          "Hall Monitor",
          "Jellyfish Jam",
          "Sandy's Rocket",
          "Squeaky Boots",
          "Nature Pants",
          "Opposite Day",
          "Culture Shock",
          "F.U.N.",
          "MuscleBob BuffPants",
          "Squidward the Unfriendly Ghost",
          "The Chaperone",
          "Employee of the Month",
          "Scaredy Pants",
          "I Was a Teenage Gary",
          "SB-129",
          "Karate Choppers",
          "Sleepy Time",
          "Suds",
          "Valentine's Day",
          "The Paper",
          "Arrgh!",
          "Rock Bottom",
          "Texas",
          "Walking Small",
          "Fools in April",
          "Neptune's Spatula",
          "Hooky",
          "Mermaid Man and Barnacle Boy II",
          "Something Smells",
          "Bossy Boots",
          "Your Shoe's Untied",
          "Squid's Day Off",
          "Big Pink Loser",
          "Bubble Buddy",
          "Mermaid Man and Barnacle Boy III",
          "Squirrel Jokes",
          "Dying for Pie",
          "Imitation Krabs",
          "Wormy",
          "Patty Hype",
          "Survival of the Idiots",
          "Dumped",
          "Grandma's Kisses",
          "Squidville",
          "No Free Rides",
          "I'm Your Biggest Fanatic",
          "Shanghaied",
          "Gary Takes a Bath",
          "Pressure",
          "The Smoking Peanut",
          "Pre-Hibernation Week",
          "Life of Crime",
          "The Secret Box",
          "Band Geeks",
          "Sailor Mouth",
          "Artist Unknown",
          "Jellyfish Hunter",
          "The Fry Cook Games",
          "Just One Bite",
          "The Bully",
          "Sandy, SpongeBob, & the Worm",
          "Squid on Strike",
          "Procrastination",
          "I'm with Stupid",
          "Mermaid Man and Barnacle Boy IV",
          "Doing Time",
          "Welcome to the Chum Bucket",
          "Frankendoodle",
          "The Snowball Effect",
          "One Krab's Trash",
          "Nasty Patty",
          "The Idiot Box",
          "As Seen on TV",
          "Can You Spare a Dime?",
          "No Weenies Allowed",
          "Squilliam Returns",
          "The Algae's Always Greener",
          "SpongeGuard on Duty",
          "Krab Borg",
          "Rock-a-Bye Bivalve",
          "Wet Painters",
          "Krusty Krab Training Video",
          "Chocolate with Nuts",
          "Mermaid Man and Barnacle Boy V",
          "Club SpongeBob",
          "My Pretty Seahorse",
          "Graveyard Shift",
          "Krusty Love",
          "New Student Starfish",
          "Clams",
          "The Great Snail Race",
          "Mid-Life Crustacean",
          "The Sponge Who Could Fly",
          "Born Again Krabs",
          "I Had an Accident",
          "Plankton's Army",
          "Missing Identity",
          "Krabby Land",
          "The Camping Episode",
          "SpongeBob Meets the Strangler",
          "Pranks a Lot",
          "Fear of a Krabby Patty",
          "Shell of a Man",
          "The Lost Mattress",
          "Krabs vs. Plankton",
          "Skill Crane",
          "Good Neighbors",
          "Selling Out",
          "Funny Pants",
          "Mermaid Man & Barnacle Boy VI - The Motion Picture",
          "Enemy In-Law",
          "Patrick SmartPants",
          "SquidBob TentaclePants",
          "Krusty Towers",
          "Mrs. Puff, You're Fired",
          "Ghost Host",
          "Chimps Ahoy!",
          "Whale of a Birthday",
          "Karate Island",
          "All That Glitters",
          "Wishing You Well",
          "New Leaf",
          "Once Bitten",
          "Squidtastic Voyage",
          "Bummer Vacation",
          "Best Day Ever",
          "Wigstruck",
          "That's No Lady",
          "The Thing",
          "Hocus Pocus",
          "Driven to Tears",
          "Rule of Dumb",
          "The Pink Purloiner",
          "The Gift of Gum",
          "Rise and Shine",
          "Waiting",
          "Sing a Song of Patrick",
          "Born to Be Wild",
          "Best Frenemies",
          "Spy Buddies",
          "Boat Smarts",
          "Good Ol' Whatshisname",
          "The Krusty Sponge",
          "Squid Wood",
          "New Digs",
          "Krabs à La Mode",
          "To Love a Patty",
          "Breath of Fresh Squidward",
          "Roller Cowards",
          "Bucket Sweet Bucket",
          "The Original Fry Cook",
          "Night Light",
          "Money Talks",
          "SpongeBob vs. The Patty Gadget",
          "Slimy Dancing",
          "A Flea in Her Dome",
          "The Donut of Shame",
          "The Krusty Plate",
          "Picture Day",
          "Pat No Pay",
          "BlackJack",
          "Blackened Sponge",
          "Mermaid Man vs. SpongeBob",
          "Fungus Among Us",
          "Le Big Switch",
          "The Inmates of Summer",
          "The Two Faces of Squidward",
          "The Battle of Bikini Bottom",
          "Banned in Bikini Bottom",
          "SpongeHenge",
          "20,000 Patties Under the Sea",
          "Stanley S. SquarePants",
          "To Save a Squirrel",
          "Krabby Road",
          "Not Normal",
          "Gone",
          "Suction Cup Symphony",
          "Penny Foolish",
          "Nautical Novice",
          "Spongicus",
          "The Splinter",
          "Giant Squidward",
          "A Life in a Day",
          "Sun Bleached",
          "House Fancy",
          "No Nose Knows",
          "Patty Caper",
          "Plankton's Regular",
          "Boating Buddies",
          "The Krabby Kronicle",
          "The Slumber Party",
          "Grooming Gary",
          "Porous Pockets",
          "Krusty Krushers",
          "The Card",
          "Ditchin'",
          "Dear Vikings",
          "Shuffleboarding",
          "Slide Whistle Stooges",
          "Cephalopod Lodge",
          "Grandpappy the Pirate",
          "Professor Squidward",
          "Sand Castles in the Sand",
          "Toy Store of Doom",
          "Pets or Pests",
          "Komputer Overload",
          "Choir Boys",
          "Shell Shocked",
          "Pineapple Fever",
          "Single Cell Anniversary",
          "Squid's Visit",
          "Gullible Pants",
          "To SquarePants or Not to SquarePants",
          "Chum Caverns",
          "I Heart Dancing",
          "Goo Goo Gas",
          "No Hat for Pat",
          "Chum Bucket Supreme",
          "Someone's in the Kitchen with Sandy",
          "Growth Spout",
          "Tentacle-Vision",
          "The Inside Job",
          "Stuck in the Wringer",
          "Overbooked",
          "The Curse of Bikini Bottom",
          "Greasy Buffoons",
          "Model Sponge",
          "Keep Bikini Bottom Beautiful",
          "A Pal for Gary",
          "Gary in Love",
          "Rodeo Daze",
          "Back to the Past",
          "The Bad Guy Club for Villains",
          "A Day Without Tears",
          "Summer Job",
          "Squidward in Clarinetland",
          "One Coarse Meal",
          "The Play's the Thing",
          "SpongeBob's Last Stand",
          "Enchanted Tiki Dreams",
          "Gramma's Secret Recipe",
          "The Cent of Money",
          "That Sinking Feeling",
          "Karate Star",
          "Hide and Then What Happens?",
          "You Don't Know Sponge",
          "Yours, Mine and Mine",
          "Kracked Krabs",
          "Buried in Time",
          "Shellback Shenanigans",
          "The Masterpiece",
          "Whelk Attack",
          "Krusty Dogs",
          "The Wreck of the Mauna Loa",
          "The Great Patty Caper",
          "The Abrasive Side",
          "Earworm",
          "New Fish in Town",
          "Big Sister Sam",
          "Legends of Bikini Bottom: Sponge-Cano",
          "Legends of Bikini Bottom: The Main Drain",
          "Legends of Bikini Bottom: The Monster Who Came to Bikini Bottom",
          "Legends of Bikini Bottom: Welcome to the Bikini Bottom Triangle",
          "Legends of Bikini Bottom: Trenchbillies",
          "Legends of Bikini Bottom: The Curse of the Hex",
          "Love That Squid",
          "Tunnel of Glove",
          "Perfect Chemistry",
          "A Friendly Game",
          "Sentimental Sponge",
          "Squidward's School for Grown-Ups",
          "Oral Report",
          "The Hot Shot",
          "The Other Patty",
          "Frozen Face-Off",
          "Accidents Will Happen",
          "Drive Thru",
          "Sweet and Sour Squid",
          "The Googly Artiste",
          "Barnacle Face",
          "Pet Sitter Pat",
          "Mermaid Man Begins",
          "Plankton's Good Eye",
          "House Sittin' for Sandy",
          "Smoothe Jazz at Bikini Bottom",
          "Ghoul Fools",
          "Walking the Plankton",
          "Patrick's Staycation",
          "Mr. Krabs Takes a Vacation",
          "Mooncation",
          "A SquarePants Family Vacation",
          "The Krabby Patty That Ate Bikini Bottom",
          "Bubble Buddy Returns",
          "Bubble Troubles",
          "Way of the Sponge",
          "Planet of the Jellyfish",
          "Are You Happy Now?",
          "Restraining SpongeBob",
          "Glove World R.I.P.",
          "Home Sweet Rubble",
          "Fiasco!",
          "Free Samples",
          "inSPONGEiac",
          "Treats!",
          "Squiditis",
          "For Here or to Go?",
          "It's a SpongeBob Christmas!",
          "Karen 2.0",
          "Demolition Doofus",
          "Face Freeze!",
          "Extreme Spots",
          "Squirrel Record",
          "Squid Baby",
          "The Good Krabby Name",
          "License to Milkshake",
          "Hello Bikini Bottom!",
          "Gary's New Toy",
          "Super Evil Villain Aquatic Team Up is Go",
          "Chum Fricassee",
          "Move It or Lose It",
          "Eek! An Urchin",
          "Patrick-Man!",
          "Bumper to Bumper",
          "Squid's Defense",
          "Plankton's Pet",
          "Little Yellow Book",
          "Evil Spatula",
          "Jailbreak!",
          "Safe Depo­sit Krabs",
          "Don't Look Now",
          "Séance Shméance",
          "SpongeBob, You're Fired!",
          "It Came from Goo Lagoon",
          "Kenny the Cat",
          "Yeti Krabs",
          "Lost in Bikini Bottom",
          "Tutor Sauce",
          "Squid Plus One",
          "The Executive Treatment",
          "Company Picnic",
          "Pull Up a Barrel",
          "What's Eating Patrick?",
          "Sanctuary",
          "Patrick! the Game",
          "The Sewers of Bikini Bottom",
          "SpongeBob LongPants",
          "Larry's Gym",
          "Mall Girl Pearl",
          "Two Thumbs Down",
          "The Fish Bowl",
          "Married to Money",
          "Sharks vs. Pods",
          "CopyBob DittoPants",
          "Sold!",
          "Lame and Fortune",
          "Sandy's Nutmare",
          "Food Con Castaways",
          "Pineapple Invasion",
          "Salsa Imbecilicus",
          "Bulletin Board",
          "Mutiny on the Krusty",
          "Whirlybrains",
          "Snail Mail",
          "MermaidPants",
          "The Whole Tooth",
          "Mimic Madness",
          "House Worming",
          "Snooze You Lose",
          "Krusty Katering",
          "Spongebob's Place",
          "Plankton Gets the Boot",
          "Life Insurance",
          "Burst Your Bubble",
          "Plankton Retires",
          "Trident Trouble",
          "Unreal Estate",
          "Code Yellow",
          "The Getaway",
          "Lost and Found",
          "Patrick's Coupon",
          "Out of the Picture",
          "Spot Returns",
          "The Checkup",
          "Spin The Bottle",
          "Sportz?",
          "Cave Dwelling Sponge",
          "The Clam Whisperer",
          "Man Ray Returns",
          "Larry The Floor Manager",
          "Feral Friends",
          "Don't Wake Patrick",
          "The Legend Of Boo-kini Bottom",
          "Krabby Patty Creature Feature",
          "Teacher's Pests",
          "No Pictures, Please",
          "Stuck on the Roof",
          "There's A Sponge In My Soup",
          "Cuddle E. Hugs",
          "Scavengerpants",
          "Squid Noir",
          "The Incredible Shrinking Sponge",
          "Pat the Horse",
          "Chatterbox Gary",
          "Don't Feed the Clowns",
          "Drive Happy",
          "Old Man Patrick",
          "Fun-Sized Friends",
          "Grandmum's the Word",
          "Doodle Dimension",
          "Moving Bubble Bass",
          "Bunny Hunt",
          "High Sea Diving",
          "The Tidal Zone",
          "Atlantis SquarePantis",
          "Truth or Square",
          "It's a SpongeBob Christmas!",
          "Goodbye, Krabby Patty?",
          "SpongeBob's Big Birthday Blowout",
          "The SpongeBob Musical: Live on Stage!",
          "SpongeBob's Road to Christmas",
          "The SpongeBob Movie: Sponge on the Run",
          "Behind the Pantis",
          "Square Roots: The Story of SpongeBob SquarePants",
          "Blackened Sponge / Krusty Krushers / Dunces and Dragons / Karate Choppers / Karate Island / Karate Star / The Way of the Sponge",
          "SpongeBob's Best of the Worst",
          "SpongeBob's Greatest Grilling Moments: F.U.N. / Ripped Pants / The Chaperone / The Camping Episode / The Best Day Ever / Wishing You Well / Hello Bikini",
          "SpongeBob's Winter Wonderland",
          "SpongeBob's Squad Goals",
          "The Stars of SpongeBob Fan Favorites Special",
          "SpongeBob's Spookiest Scenes Countdown Special",
          "The Spongebob Sportspants Countdown Special",
          "Camping Episode' - Puppet Edition!",
          "Arrgh' - Puppet Edition!",
          "The Patrick Star Fan Favorites Special"
        ],
        "quotes": [
          "I'm ready! I'm ready!",
          "Look at all the hip young people eating sal-ads.",
          "The best time to wear a striped sweater is all the time.",
          "Can I be excused for the rest of my life?",
          "I'm ugly and I'm proud!",
          "F is for friends who do stuff together!",
          "All I know is fine dining and breathing.",
          "Ravioli, ravioli. Give me the formuoli.",
          "Krusty Krab Pizza, it's the pizza for you and meeeeee!",
          "If you believe in yourself, with a tiny pinch of magic all your dreams can come true!",
          "The inner machinations of my mind are an enigma.",
          "Is mayonnaise an instrument?",
          "I can't see my forehead!",
          "Once upon a time there was an ugly barnacle. He was so ugly that everyone died. The end!",
          "Two words, SpongeBob. Na. Chos.",
          "I wumbo, you wumbo, he she we wumbo.",
          "Wake me up when I care.",
          "I have no soul.",
          "It's just a cruel reminder that I'm single and likely to remain that way forever.",
          "Future!!!",
          "I knew I shouldn't have gotten out of bed today.",
          "But it's my only night to be fancy!",
          "I might as well sleep for 100 years or so.",
          "Goodbye everyone, I'll remember you all in therapy.",
          "Did you smell it? That smell. A kind of smelly smell. The smelly smell that smells...smelly.",
          "NO! This is Patrick!"
        ]
      },
      "sport": {
        "ancient_olympics": [
          "Boxing",
          "Chariot racing",
          "Discus",
          "Horse racing",
          "Long jump",
          "Pankration",
          "Pentathlon",
          "Running",
          "Wrestling"
        ],
        "summer_olympics": [
          "3x3 basketball",
          "Archery",
          "Artistic gymnastics",
          "Artistic swimming",
          "Athletics",
          "Badminton",
          "Baseball",
          "Basketball",
          "Beach volleyball",
          "BMX freestyle",
          "BMX racing",
          "Boxing",
          "Canoe/kayak flatwater",
          "Canoe/kayak slalom",
          "Diving",
          "Equestrian",
          "Fencing",
          "Football",
          "Golf",
          "Handball",
          "Hockey",
          "Judo",
          "Karate",
          "Marathon swimming",
          "Modern pentathlon",
          "Mountain bike",
          "Rhythmic gymnastics",
          "Road cycling",
          "Rowing",
          "Rugby",
          "Sailing",
          "Shooting",
          "Skateboarding",
          "Softball",
          "Sport climbing",
          "Surfing",
          "Swimming",
          "Table tennis",
          "Taekwondo",
          "Tennis",
          "Track cycling",
          "Trampoline",
          "Triathlon",
          "Volleyball",
          "Water polo",
          "Weight lifting",
          "Wrestling"
        ],
        "summer_paralympics": [
          "Archery",
          "Athletics",
          "Badminton",
          "Blind football",
          "Boccia",
          "Canoe",
          "Cycling",
          "Equestrian",
          "Goalball",
          "Judo",
          "Powerlifting",
          "Rowing",
          "Shooting",
          "Sitting volleyball",
          "Swimming",
          "Table tennis",
          "Taekwondo",
          "Triathlon",
          "Wheelchair basketball",
          "Wheelchair fencing",
          "Wheelchair rugby",
          "Wheelchair tennis"
        ],
        "unusual": [
          "Apple Racing",
          "Ban'ei",
          "Bathtubbing",
          "Bed racing",
          "Bossaball",
          "Botaoshi",
          "Beer Can Regatta",
          "Black pudding throwing",
          "Bog snorkelling",
          "Bottle kicking",
          "Camel jumping",
          "Camel wrestling",
          "Chess boxing",
          "Extreme ironing",
          "Flugtag/Birdman",
          "Gurning",
          "Kastenlauf (Beer crate running)",
          "Oil wrestling",
          "Poohsticks",
          "Wife carrying",
          "Zorbing"
        ],
        "winter_olympics": [
          "Alpine skiing",
          "Biathlon",
          "Bobsleigh",
          "Cross-country skiing",
          "Curling",
          "Figure skating",
          "Freestyle skiing",
          "Ice hockey",
          "Luge",
          "Nordic combined",
          "Short track speed skating",
          "Skeleton",
          "Ski jumping",
          "Ski mountaineering",
          "Snowboard",
          "Speed skating"
        ],
        "winter_paralympics": [
          "Alpine skiing",
          "Biathlon",
          "Cross-country skiing",
          "Para ice hockey",
          "Snowboard",
          "Wheelchair curling"
        ]
      },
      "star_trek": {
        "character": [
          "James Tiberius Kirk",
          "Jean-Luc Picard",
          "Benjamin Sisko",
          "Kira Nerys",
          "Odo",
          "Jadzia Dax",
          "Julian Bashir",
          "Miles O'Brien",
          "Quark",
          "Jake Sisko",
          "Kathryn Janeway",
          "Chakotay",
          "Tuvok",
          "Tom Paris",
          "B'Elanna Torres",
          "Harry Kim",
          "Seven of Nine",
          "The Doctor",
          "Neelix",
          "Kes",
          "Jonathan Archer",
          "T'Pol",
          "Charles Tucker III",
          "Malcolm Reed",
          "Travis Mayweather",
          "Hoshi Sato",
          "Phlox",
          "Data",
          "William T. Riker",
          "Geordi La Forge",
          "Worf",
          "Beverly Crusher",
          "Deanna Troi",
          "Natasha Yar",
          "Wesley Crusher",
          "Spock",
          "Leonard McCoy",
          "Montgomery Scott",
          "Hikaru Sulu",
          "Pavel Chekov",
          "Nyota Uhura"
        ],
        "location": [
          "Qo'noS",
          "Romulus",
          "Bajor",
          "Vulcan",
          "Neutral Zone",
          "Alpha Quadrant",
          "Beta Quadrant",
          "Delta Quadrant",
          "Gamma Quadrant",
          "Tau Ceti Prime",
          "Wolf 359",
          "Thalos VII",
          "Cardassia",
          "Trillius Prime",
          "Badlands",
          "Betazed",
          "Risa",
          "Deep Space Nine",
          "Ferenginar",
          "The Briar Patch",
          "Khitomer"
        ],
        "specie": [
          "Breen",
          "El-Aurian",
          "Jem'Hadar",
          "Kazon",
          "Ocampa",
          "Q",
          "Ferengi",
          "Klingon",
          "Talaxian",
          "Vidiian",
          "Cardassian",
          "Vulcan",
          "Borg",
          "Romulan",
          "Vorta",
          "Andorian",
          "Bajoran",
          "Betazoid"
        ],
        "villain": [
          "Q",
          "Gorn",
          "Khan Noonien Singh",
          "Ru'afo",
          "Maltz",
          "Kruge",
          "Ayel",
          "Admiral Marcus",
          "Martia",
          "Lt. Valeris",
          "V'ger",
          "God of Sha Ka Ree",
          "Admiral Dougherty",
          "Nero",
          "Krall",
          "Tolian Soran",
          "Shinzon",
          "General Chang",
          "Lursa",
          "B'Etor",
          "Borg Queen"
        ]
      },
      "star_wars": {
        "alternate_character_spellings": {
          "admiral_ackbar": [
            "akbar",
            "ackbar",
            "admiral ackbar",
            "admiral akbar",
            "admiral_ackbar"
          ],
          "ahsoka_tano": [
            "ahsoka",
            "tano",
            "ahsoka tano",
            "ahsoka_tano"
          ],
          "anakin_skywalker": [
            "anakin",
            "anakin skywalker",
            "ani",
            "ani skywalker",
            "anakin_skywalker"
          ],
          "asajj_ventress": [
            "asajj",
            "ventress",
            "asajj ventress",
            "asajj_ventress"
          ],
          "bendu": [
            "the bendu",
            "bendu"
          ],
          "boba_fett": [
            "boba fett",
            "bobafett",
            "boba_fett"
          ],
          "c_3po": [
            "c 3po",
            "c3po",
            "c3p0",
            "c_3po"
          ],
          "count_dooku": [
            "dooku",
            "count dooku",
            "count_dooku"
          ],
          "darth_caedus": [
            "caedus",
            "darth caedus",
            "darth_caedus"
          ],
          "darth_vader": [
            "vader",
            "darth vader",
            "darth_vader"
          ],
          "emperor_palpatine": [
            "the emperor",
            "sheev palpatine",
            "emperor",
            "palpatine",
            "senator palpatine",
            "darth sidious",
            "sidious",
            "emperor_palpatine"
          ],
          "finn": [
            "fn2187",
            "fn-2187",
            "fin"
          ],
          "general_hux": [
            "general hux",
            "hux",
            "general_hux"
          ],
          "grand_admiral_thrawn": [
            "thrawn",
            "admiral thrawn",
            "grand admiral thrawn",
            "grand_admiral_thrawn"
          ],
          "grand_moff_tarkin": [
            "tarkin",
            "grand moff tarkin",
            "moff tarkin",
            "grand_moff_tarkin"
          ],
          "greedo": [
            "greedo"
          ],
          "han_solo": [
            "han",
            "solo",
            "han solo",
            "general han solo",
            "general solo",
            "han_solo"
          ],
          "jabba_the_hutt": [
            "jabba",
            "jabba the hut",
            "jabba the hutt",
            "jabba_the_hutt"
          ],
          "jar_jar_binks": [
            "jar-jar",
            "jar jar binks",
            "jar-jar binks",
            "the best character",
            "jar_jar_binks"
          ],
          "k_2so": [
            "k2so",
            "k-2so",
            "k-2s0",
            "k_2so"
          ],
          "kylo_ren": [
            "kylo",
            "kylo ren",
            "ben solo",
            "ren",
            "kylo_ren"
          ],
          "lando_calrissian": [
            "lando",
            "lando calrissian",
            "general lando",
            "general lando calrissian",
            "general calrissian",
            "lando_calrissian"
          ],
          "leia_organa": [
            "leia",
            "princess leia",
            "leia skywalker",
            "leia organa",
            "general leia",
            "senator leia",
            "general leia organa",
            "senator leia organa",
            "leia organa solo",
            "leia_organa"
          ],
          "luke_skywalker": [
            "luke",
            "luke skywalker",
            "luke_skywalker"
          ],
          "mace_windu": [
            "mace",
            "mace windu",
            "windu",
            "master mace windu",
            "mace_windu"
          ],
          "maz_kanata": [
            "maz",
            "maz kanata",
            "maz_kanata"
          ],
          "obi_wan_kenobi": [
            "obi kenobi",
            "ben",
            "ben kenobi",
            "obi wan kenobi",
            "obi-wan",
            "obi wan",
            "obi-wan kenobi",
            "obi_wan_kenobi"
          ],
          "padme_amidala": [
            "senator amidala",
            "queen amidala",
            "padme",
            "amidala",
            "padme amidala",
            "padme_amidala"
          ],
          "qui_gon_jinn": [
            "qui-gon",
            "qui gon",
            "qui-gon jinn",
            "qui gon jinn",
            "qui-gonn jin",
            "qui gonn",
            "master qui-gon",
            "master qui gon",
            "qui_gon_jinn"
          ],
          "rey": [
            "rey"
          ],
          "shmi_skywalker": [
            "shmi",
            "shmi skywalker",
            "shmi_skywalker"
          ],
          "yoda": [
            "master yoda",
            "yoda"
          ]
        },
        "call_numbers": [
          "Leader",
          "#"
        ],
        "call_sign": [
          "#{call_squadron} #{call_number}"
        ],
        "call_squadrons": [
          "Rogue",
          "Red",
          "Gray",
          "Green",
          "Blue",
          "Gold",
          "Black",
          "Yellow",
          "Phoenix"
        ],
        "characters": [
          "Padme Amidala",
          "Jar Jar Binks",
          "Borvo the Hutt",
          "Darth Caedus",
          "Boba Fett",
          "Jabba the Hutt",
          "Obi-Wan Kenobi",
          "Darth Maul",
          "Leia Organa",
          "Sheev Palpatine",
          "Kylo Ren",
          "Darth Sidious",
          "Anakin Skywalker",
          "Luke Skywalker",
          "Ben Solo",
          "Han Solo",
          "Darth Vader",
          "Watto",
          "Mace Windu",
          "Yoda",
          "Count Dooku",
          "Sebulba",
          "Qui-Gon Jinn",
          "Chewbacca",
          "Jango Fett",
          "Lando Calrissian",
          "Bail Organa",
          "Wedge Antilles",
          "Poe Dameron",
          "Ki-Adi-Mundi",
          "Nute Gunray",
          "Panaka",
          "Rune Haako",
          "Rey",
          "Finn",
          "Supreme Leader Snoke",
          "General Hux",
          "Admiral Ackbar",
          "Ahsoka Tano",
          "Asajj Ventress",
          "Bendu",
          "Captain Phasma",
          "Chirrut Imwe",
          "Ezra Bridger",
          "Galen Erso",
          "Grand Moff Tarkin",
          "Grand Admiral Thrawn",
          "Greedo",
          "Jyn Erso",
          "Lyra Erso",
          "Maz Kanata",
          "Mon Mothma",
          "Sabine Wren",
          "Saw Gerrera",
          "Savage Opress",
          "Shmi Skywalker",
          "Kanan Jarrus",
          "Hera Syndulla",
          "Rose Tico",
          "Vice Admiral Holdo"
        ],
        "droids": [
          "2-1B",
          "4-LOM",
          "ASP",
          "B2-RP",
          "B1",
          "BD-3000",
          "C1-10P",
          "FA-4",
          "GH-7",
          "GNK",
          "LM-432",
          "ID9",
          "11-4D",
          "2-1B",
          "327-T",
          "4-LOM",
          "B4-D4",
          "NR-N99",
          "C-3PO",
          "R2-D2",
          "BB-8",
          "R2-Q5",
          "Super Battle Droid",
          "Mouse Droid",
          "Droideka",
          "Buzz Droid",
          "Magnaguard",
          "Interrogation Droid",
          "Vulture Droid",
          "BB-9E",
          "K-2SO"
        ],
        "planets": [
          "Alderaan",
          "Ahch-To",
          "Bespin",
          "Cantonica",
          "Coruscant",
          "Cloud City",
          "Crait",
          "DQar",
          "Dathomir",
          "Dagobah",
          "Death Star",
          "Eadu",
          "Endor",
          "Felucia",
          "Geonosis",
          "Hoth",
          "Hosnian Prime",
          "Jakku",
          "Jedha",
          "Kamino",
          "Kashyyyk",
          "Lothal",
          "Mandalore",
          "Mustafar",
          "Mygeeto",
          "Naboo",
          "Onderon",
          "Ryloth",
          "Scarif",
          "Starkiller Base",
          "Sullust",
          "Takodana",
          "Tatooine",
          "Utapau",
          "Yavin 4"
        ],
        "quotes": {
          "admiral_ackbar": [
            "It's a trap!",
            "The Shield is down! Commence attack on the Death Star's main reactor.",
            "We have no choice, General Calrissian! Our cruisers can't repel firepower of that magnitude!"
          ],
          "ahsoka_tano": [
            "Suicide is not the Jedi way, Master.",
            "Let's just say my master will always do what needs to be done. I'm not even sure how peacetime will agree with him.",
            "Sorry to interrupt your playtime, Grumpy, but wouldn't you prefer a challenge?"
          ],
          "anakin_skywalker": [
            "I've got a bad feeling about this.",
            "Just for once, let me look on you with my own eyes.",
            "Jedi business, go back to your drinks!"
          ],
          "asajj_ventress": [
            "You're tenacious, Jedi.",
            "Not even the dark side can give you that power."
          ],
          "bendu": [
            "Your presence is like a violent storm in this quiet world.",
            "An object cannot make you good, or evil. The temptation of power, forbidden knowledge, even the desire to do good can lead some down that path. But only you can change yourself.",
            "Once something is known, it cannot be unknown."
          ],
          "boba_fett": [
            "He's no good to me dead.",
            "You can run, but you'll only die tired."
          ],
          "c_3po": [
            "I have a bad feeling about this.",
            "R2-D2, you know better than to trust a strange computer!",
            "You’ll be malfunctioning within a day, you nearsighted scrap pile.",
            "I'm terribly sorry about all this. After all, he's only a Wookiee!",
            "Don’t you call me a mindless philosopher, you overweight glob of grease!",
            "We're doomed.",
            "I suggest a new strategy, R2. Let the Wookiee win.",
            "We seem to be made to suffer. It's our lot in life.",
            "I'm backwards, you filthy furball!",
            "If I told you half the things I've heard about this Jabba the Hutt, you'd probably short circuit.",
            "Don’t worry about Master Luke. I’m sure he’ll be all right. He’s quite clever, you know… for a human being.",
            "I can’t abide these Jawas. Disgusting creatures.",
            "It's against my programming to impersonate a deity.",
            "Just you reconsider playing that message for him! No, I don't think he likes you at all. No, I don't like you either.",
            "Now don't you forget this! Why I should stick my neck out for you is far beyond my capacity!"
          ],
          "count_dooku": [
            "Twice the pride, double the fall."
          ],
          "darth_caedus": [
            "You're smarter than a tree, aren't you?"
          ],
          "darth_vader": [
            "I find your lack of faith disturbing.",
            "You are a member of the Rebel Alliance, and a traitor.",
            "You are unwise to lower your defenses!",
            "I am altering the deal. Pray I don't alter it any further.",
            "Perhaps you think you're being treated unfairly?",
            "The circle is now complete. When I left you, I was but the learner. Now I am the master.",
            "Obi-Wan was wise to hide her from me. Now, his failure is complete. If you will not turn to the Dark Side… then perhaps she will.",
            "Search your feelings, you know it to be true!",
            "Impressive. Most impressive. Obi-Wan has taught you well. You have controlled your fear. Now, release your anger. Only your hatred can destroy me.",
            "I hope so for your sake, Commander. The Emperor is not as forgiving as I am.",
            "Be careful not to choke on your aspirations, Director.",
            "He is as clumsy as he is stupid.",
            "You may use any methods necessary, but I want them alive. No disintegrations!",
            "You have failed me for the last time, Admiral."
          ],
          "emperor_palpatine": [
            "Only now, at the end, do you understand…",
            "Oh, I'm afraid the deflector shield will be quite operational when your friends arrive.",
            "There is a great disturbance in the Force.",
            "Give in to your anger. With each passing moment you make yourself more my servant.",
            "Let the hate flow through you!",
            "Your feeble skills are no match for the power of the Dark Side.",
            "Your hate has made you powerful. Now fulfill your destiny, and take your father's place at my side.",
            "So be it, Jedi.",
            "The Force is strong with him. The son of Skywalker must not become a Jedi."
          ],
          "finn": [
            "Droid, please!",
            "Sanitation",
            "Solo, we'll figure it out. We'll use the Force.",
            "I'm a big deal in the Resistance. Which puts a real target on my back."
          ],
          "general_hux": [
            "I won't have you question my methods.",
            "Careful, Ren, that your personal interests not interfere with orders from Leader Snoke."
          ],
          "grand_admiral_thrawn": [
            "I will start my operations here, and pull the rebels apart piece by piece. They'll be the architects of their own destruction.",
            "War is in your blood. I studied the art of war, worked to perfect it, but you? You were forged by it."
          ],
          "grand_moff_tarkin": [
            "Now, witness the power of this fully operational battle station.",
            "The Jedi are extinct. Their fire has gone out of the universe. You, my friend, are all that's left of their religion."
          ],
          "greedo": [
            "Koona t'chuta Solo? (Going somewhere Solo?)",
            "Soong peetch alay. (It's too late.)",
            "Ee mara tom tee tok maky cheesa. (You should have paid him when you had the chance.)",
            "Jabba won neechee kochba mu shanee wy tonny wya uska. (Jabba put a price on your head so large, every bounty hunter in the galaxy will be looking for you.)",
            "Chosky nowy u chusu. (I'm lucky I found you first.)",
            "El jaya kulpa intick kuny ku suwa. (If you give it to me, I might forget I found you.)",
            "Semal hi teek teek. (Jabba's through with you.)",
            "Sone guru ye buya nyah oo won spasteega koo shu coon bon duwa weeptee. (He has no time for smugglers who drop their shipments at the first sign of an Imperial cruiser.)",
            "Talk Jabba. (Tell that to Jabba.)",
            "Boompa kom bok nee aht am bompah. (He may only take your ship.)",
            "Nuklee numaa (that's the idea.)",
            "Ches ko ba tuta creesta crenko ya kolska! (This is something I've been looking forward to for a long time.)"
          ],
          "han_solo": [
            "It's the ship that made the Kessel Run in less than 12 parsecs.",
            "She may not look like much, but she's got it where it counts, kid.",
            "Never tell me the odds",
            "Well, you said you wanted to be around when I made a mistake.",
            "No reward is worth this.",
            "Shut him up or shut him down.",
            "I got a bad feeling about this.",
            "I have a really bad feeling about this.",
            "Ungh. And I thought they smelled bad on the outside.",
            "I have a bad feeling about this.",
            "Bounty hunters! We don't need this scum.",
            "If they follow standard Imperial procedure, they'll dump their garbage before they go to light-speed.",
            "Hokey religions and ancient weapons are no match for a good blaster at your side, kid."
          ],
          "jabba_the_hutt": [
            "Solo, la pa loiya Solo! (Solo, come out of there! Solo!)",
            "Bone duwa pweepway? (Have you now?)",
            "Han, ma bookie, keel-ee calleya ku kah. (Han, my boy, you disappoint me.)",
            "Wanta dah moolee-rah... (Why haven't you paid me…)",
            "Mon kee chees kreespa Greedo? (And why did you fry poor Greedo?)",
            "Han, ma kee chee zay. (Han, I can't make exceptions.)",
            "Hassa ba una kulkee malia... (What if everyone who smuggled for me… eveela deesa… their cargo at the sight… dwa spasteega el was nwo yana da gooloo? (of an Imperial starship?)",
            "Han, ma bookie, baldo nee anna dodo da eena. (You're the best.)",
            "See fa doi dee yaba… for an extra twenty percent… do ee deen. (Okay, fifteen percent.)",
            "Ee ya ba ma dookie massa... (But if you fail me again...)",
            "Eek bon chee ko pa na green. (I'll put a price on your head so big...)",
            "na meeto do buny dunko la cho ya. (you won't be able to get near a civilized system.)",
            "Boska! (Come on!)"
          ],
          "jar_jar_binks": [
            "Ooh mooey mooey I love you!",
            "Yoosa should follow me now, okeeday?",
            "Yipe! How wude!",
            "Ohh, maxi big da Force. Well dat smells stinkowiff.",
            "Oh Gooberfish!",
            "Exsqueeze me!",
            "Mesa cause one, two-y little bitty axadentes, huh? Yud say boom de gasser, den crashin der bosses heyblibber, den banished.",
            "Mesa called Jar-Jar Binks. Mesa your humble servant.",
            "My forgotten, da Bosses will do terrible tings to me, TERRRRRIBLE is me going back der!",
            "Mesa day startin pretty okee-day with a brisky morning munchy, then BOOM! Gettin very scared and grabbin that Jedi and POW! Mesa here! Mesa gettin' very very scared!"
          ],
          "k_2so": [
            "I have a bad feeling about…"
          ],
          "kylo_ren": [
            "You need a teacher. I can show you the ways of the Force.",
            "Show me again, Grandfather, and I will finish what you started."
          ],
          "lando_calrissian": [
            "Why you slimy, double-crossing, no-good swindler. You've got a lot of guts coming here, after what you pulled.",
            "How you doin' Chewbacca? Still hanging around with this loser?",
            "But how could they be jamming us if they don't know that we're coming?",
            "This deal is getting worse all the time."
          ],
          "leia_organa": [
            "You do have your moments. Not many, but you have them.",
            "I have a bad feeling about this.",
            "Would somebody get this big walking carpet out of my way?",
            "Aren't you a little short for a Stormtrooper?",
            "Help me Obi-Wan Kenobi. You're my only hope.",
            "Why, you stuck-up, half-witted, scruffy-looking nerf herder!",
            "Governor Tarkin, I should've expected to find you holding Vader's leash. I recognized your foul stench when I was brought on board.",
            "Somebody has to save our skins. Into the garbage chute, flyboy!"
          ],
          "luke_skywalker": [
            "But I was going into Tosche Station to pick up some power converters!",
            "I have a very bad feeling about this.",
            "It's not impossible. I used to bullseye womp rats in my T-16 back home; they're not much bigger than two meters.",
            "You know, that little droid is going to cause me a lot of trouble.",
            "If you're saying that coming here was a bad idea, I'm starting to agree with you.",
            "You'll find I'm full of surprises!",
            "Your overconfidence is your weakness.",
            "You serve your master well. And you will be rewarded.",
            "Threepio, tell them if they don't do as you wish, you'll become angry and use your magic.",
            "I am a Jedi, like my father before me."
          ],
          "mace_windu": [
            "The senate will decide your fate.",
            "Then our worst fears have been realized. We must move quickly if the Jedi Order is to survive."
          ],
          "maz_kanata": [
            "I assume you need something. Desperately."
          ],
          "obi_wan_kenobi": [
            "An elegant weapon for a more civilized age.",
            "You don’t need to see his identification. These aren’t the droids you’re looking for.",
            "You will never find a more wretched hive of scum and villainy. We must be cautious.",
            "Who's the more foolish; the fool, or the fool who follows him?",
            "I have a bad feeling about this.",
            "Strike me down, and I will become more powerful than you could possibly imagine.",
            "In my experience there is no such thing as luck.",
            "The Force will be with you. Always.",
            "That's no moon. It's a space station.",
            "I felt a great disturbance in the Force, as if millions of voices suddenly cried out in terror and were suddenly silenced.",
            "Use the Force, Luke."
          ],
          "padme_amidala": [
            "So this is how liberty dies. With thunderous applause.",
            "Ani? My goodness, you've grown.",
            "Anakin, you're breaking my heart. You're going down a path I can't follow.",
            "Hold me, like you did by the lake on Naboo; so long ago when there was nothing but our love. No politics, no plotting, no war.",
            "I was not elected to watch my people suffer and die while you discuss this invasion in a committee!"
          ],
          "qui_gon_jinn": [
            "Remember, your focus determines your reality."
          ],
          "rey": [
            "You will remove these restraints and leave this cell with the door open.",
            "The garbage'll do"
          ],
          "shmi_skywalker": [
            "You can't stop change any more than you can stop the suns from setting.",
            "The Republic doesn't exist out here. We must survive on our own."
          ],
          "yoda": [
            "Wars not make one great.",
            "Truly wonderful, the mind of a child is.",
            "That is why you fail.",
            "A Jedi uses the Force for knowledge and defense, never for attack.",
            "Adventure. Excitement. A Jedi craves not these things.",
            "Fear is the path to the dark side. Fear leads to anger… anger leads to hate… hate leads to suffering.",
            "Judge me by my size, do you?",
            "Do. Or do not. There is no try.",
            "Luminous beings are we… not this crude matter.",
            "Train yourself to let go of everything you fear to lose.",
            "Size matters not. Look at me. Judge me by my size, do you?",
            "Ohhh. Great warrior. Wars not make one great."
          ]
        },
        "species": [
          "Ewok",
          "Hutt",
          "Gungan",
          "Ithorian",
          "Jawa",
          "Neimoidian",
          "Sullustan",
          "Wookiee",
          "Mon Calamari",
          "Bith",
          "Dathomirian",
          "Gamorreans",
          "Kaminoan",
          "Twi'lek",
          "Porg"
        ],
        "vehicles": [
          "V-Wing Fighter",
          "ATT Battle Tank",
          "Naboo N-1 Starfighter",
          "Republic Cruiser",
          "Naboo Royal Starship",
          "Gungan Bongo Submarine",
          "Flash Speeder",
          "Trade Federation Battleship",
          "Millennium Falcon",
          "Sith Infiltrator",
          "AT-ST Walker",
          "TIE Bomber",
          "Imperial Shuttle",
          "Sandcrawler",
          "TIE Interceptor",
          "Speeder Bike",
          "Death Star",
          "AT-AT Walker",
          "Imperial Star Destroyer",
          "X-Wing Fighter",
          "A-Wing Fighter",
          "GR-75 Transport",
          "Imperial Interdictor",
          "MTT",
          "Phantom II",
          "Republic Attack Gunship",
          "Rey's Speeder",
          "Ghost",
          "U-Wing",
          "Y-Wing Starfighter",
          "First Order TIE Fighter",
          "AT-M6 Walker",
          "First Order Dreadnought",
          "TIE Silencer",
          "Resistance Bomber",
          "Resistance Ski Speeder"
        ],
        "wookiee_words": [
          "wyaaaaaa",
          "ruh",
          "huewaa",
          "muaa",
          "mumwa",
          "wua",
          "ga",
          "ma",
          "ahuma",
          "ooma",
          "youw",
          "kabukk",
          "wyogg",
          "gwyaaaag",
          "roooarrgh",
          "ur",
          "ru",
          "roo",
          "hnn-rowr",
          "yrroonn",
          "nng",
          "rarr"
        ]
      },
      "stargate": {
        "characters": [
          "Jack O'Neill",
          "Teal'c",
          "Daniel Jackson",
          "Samantha Carter",
          "Janet Frasier",
          "George Hammond",
          "Jonas Quinn",
          "Cameron Mitchell",
          "Vala Mal Doran",
          "Kawalsky",
          "Jacob Carter",
          "Kasuf",
          "Sha're",
          "Skaara",
          "Thor",
          "Anubis",
          "Apophis",
          "Ba'al",
          "Cronus",
          "Hathor",
          "Heru-ur",
          "Klorel",
          "Ra",
          "Amonet",
          "Osiris",
          "Sokar",
          "Bra'tac",
          "Lantash",
          "Selmak",
          "Jolinar",
          "Martouf",
          "Cassandra",
          "Harlan"
        ],
        "planets": [
          "Abydos",
          "Altair",
          "Asuras",
          "Athos",
          "Celestis",
          "Chulak",
          "Dakara",
          "Earth",
          "Langara",
          "Lantea",
          "Orilla",
          "P3X-888",
          "Sateda",
          "Tollana",
          "Vorash"
        ],
        "quotes": [
          "What is an Oprah?",
          "Teal'c, look scary and take point.",
          "Things will not calm down, Daniel Jackson. They will, in fact, calm up.",
          "Undomesticated equines could not remove me.",
          "General, request permission to beat the crap out of this man.",
          "In my culture, I would be well within my rights to dismember you.",
          "Hey, if you'd been listening, you'd know that Nintendos pass through everything!",
          "You know, I've never been on a stakeout before. Shouldn't we have donuts or something?",
          "It's always suicide mission this, save the planet that. No one ever just stops by to say hi anymore.",
          "I would prefer not to consume bovine lactose at any temperature.",
          "I am not Lucy.",
          "I did not intend for my statement to be humorous.",
          "Indeed.",
          "You ended that sentence with a preposition. Bastard!"
        ]
      },
      "stranger_things": {
        "character": [
          "Joyce",
          "Lonnie",
          "Jonathan",
          "Will",
          "Nancy",
          "Mike",
          "Terry",
          "Becky",
          "Eleven",
          "Jim",
          "Diane",
          "Barbara",
          "Steve",
          "Dustin",
          "Lucas",
          "Demogorgon"
        ],
        "quote": [
          "I just didn’t want you to think I was such a wastoid, you know?",
          "You’re going to take out the demigorgon with a slingshot?",
          "Mornings are for coffee and contemplation.",
          "Eggos?",
          "This is not yours to fix alone. You act like you’re all alone out there in the world, but you’re not. You’re not alone.",
          "My God, is she Russian?",
          "Maybe I’m crazy, maybe I’m out of my mind! But God help me, I will keep these lights up until the day I die if I think there’s a chance that Will’s still out there!",
          "Am I dreaming, or is that you, Harrington?",
          "How do you know it’s not just a lizard?....Because his face opened up and he ate my cat!",
          "Use the shampoo and conditioner and when your hair’s damp, not wet, okay? When it’s damp, you do four puffs of the Farrah Fawcett spray.",
          "She will not be able to resist these pearls. *Purrs*",
          "So, Jonathan, how was the pull-out?",
          "I don’t want you to get hurt at all. And I don’t wanna lose you. Just make sure you heat up some real food. Not just Eggos."
        ]
      },
      "stripe": {
        "invalid_cards": {
          "addressFail": "4000000000000028",
          "addressZipFail": "4000000000000010",
          "addressZipUnavailable": "4000000000000044",
          "customerChargeFail": "4000000000000341",
          "cvcFail": "4000000000000101",
          "declineCard": "4000000000000002",
          "declineExpired": "4000000000000069",
          "declineFraudulentCard": "4100000000000019",
          "declineIncorrectCvc": "4000000000000127",
          "declineIncorrectNumber": "4242424242424241",
          "declineProcessingError": "4000000000000119",
          "successWithReview": "4000000000009235",
          "zipFail": "4000000000000036"
        },
        "valid_cards": {
          "amex": "378282246310005",
          "amex_2": "371449635398431",
          "diners_club": "3056930009020004",
          "diners_club_2": "36227206271667",
          "discover": "6011111111111117",
          "discover_2": "6011000990139424",
          "jcb": "3566002020360505",
          "mc": "5555555555554444",
          "mc_2_series": "2223003122003222",
          "mc_debit": "5200828282828210",
          "mc_prepaid": "5105105105105100",
          "visa": "4242424242424242",
          "visa_debit": "4000056655665556"
        },
        "valid_tokens": {
          "amex": "tok_amex",
          "diners_club": "tok_diners",
          "discover": "tok_discover",
          "jcb": "tok_jcb",
          "mc": "tok_mastercard",
          "mc_debit": "tok_mastercard_debit",
          "mc_prepaid": "tok_mastercard_prepaid",
          "visa": "tok_visa",
          "visa_debit": "tok_visa_debit"
        }
      },
      "studio_ghibli": {
        "characters": [
          "Chihiro Ogino",
          "Traveling Soot",
          "Yubaba",
          "Haku",
          "No-Face",
          "Zeniba",
          "Kamaji",
          "Howl Jenkins Pendragon",
          "Sophie Hatter",
          "Witch of the Waste",
          "Lettie Hatter",
          "Calcifer",
          "Markl",
          "Tunip Head",
          "Suliman",
          "Pazu",
          "Shiita",
          "Dola",
          "Louis",
          "Seita Yokokawa",
          "Setsuko Yokokawa",
          "Kiyoshi Yokokawa",
          "Ponyo",
          "Fujimoto",
          "Granmamare",
          "Sōsuke",
          "Lisa",
          "Kōichi",
          "Ashitaka",
          "San",
          "Jiko-bō",
          "Lady Eboshi",
          "Moro",
          "Nausicaä",
          "Jhil",
          "Yupa",
          "Obaba Hisako",
          "Marco Pagot",
          "Gina",
          "Fio Piccolo",
          "Donald Curtis",
          "Mamma Aiuto",
          "Capo",
          "Mr. Piccolo",
          "Bellini",
          "Jiji",
          "Kiki the Witch",
          "Tombo Kopoli",
          "Osono",
          "Ursula",
          "Totoro",
          "Mei Kusakabe",
          "Catbus",
          "Satsuki Kusakabe",
          "Tatsuo Kusakabe",
          "Kanta Ōgaki",
          "Yasuko Kusakabe"
        ],
        "movies": [
          "Spirited Away",
          "Kiki's Delivery Service",
          "My Neighbour Totoro",
          "Howl's Moving Castle",
          "Princess Mononoke",
          "Porco Rosso",
          "The Cat Returns",
          "Ponyo",
          "Nausicaä of the Valley of the Wind",
          "Castle in the Sky",
          "Grave of the Fireflies",
          "Arietty",
          "Tales from Earthsea",
          "From Up on Poppy Hill",
          "The Wind Rises",
          "The Tale of the Princess Kaguya",
          "My Neighbors the Yamadas"
        ],
        "quotes": [
          "It’s not really important what color your dress is. What matters is the heart inside.",
          "We each need to find our own inspiration, Kiki. Sometimes it’s not easy.",
          "Maybe I can stay and find some other nice people who will like me and accept me for who I am.",
          "Something you wouldn't recognize. It’s called love.",
          "Once you do something, you never forget. Even if you can't remember.",
          "Here's another curse for you, may all your bacon burn.",
          "I'm going up to my room now, where I may die.",
          "Really, these wizards! You'd think no one had ever had a cold before! Well, what is it?",
          "I give up. I see no point in living if I can’t be beautiful.",
          "Life is suffering. It is hard. The world is cursed. But still you find reasons to keep living.",
          "Look, everyone! This is what hatred looks like! This is what it does when it catches hold of you! It's eating me alive, and very soon now it will kill me! Fear and anger only make it grow faster!",
          "These days, there are angry ghosts all around us. Dead from wars, sickness, starvation, and nobody cares. So - you say you're under a curse. So what, so's the whole damn world.",
          "It's not really important what color your dress is. What matters is the heart inside. I think something's wrong with me. I make friends, then suddenly I can't bear to be with any of them. Seems like that other me, the cheerful and honest one, went away somewhere.",
          "A pig that doesn't fly is just a pig.",
          "I'm a pig. I don't fight for honor. I fight for a paycheck.",
          "A pig's gotta fly.",
          "Hahaha... This isn't a Western, you can't hit me from here.",
          "Take her back to Civilisation.",
          "I finally get a bouquet and it's a goodbye present. That's depressing.",
          "Aren't you even going to knock? You're the most patheic little girl I've ever seen!",
          "The earth speaks to all of us, and if we listen, we can understand.",
          "A girl just fell from the sky, boss!",
          "The tree! We protected it, so it protects us!",
          "He said Mom was ugly, now go get him!",
          "That tree's gettin' away with our treasure!",
          "It's so beautiful. It's hard to believe these spores could kill me.",
          "Why does everything that's good for you have to taste so bad?"
        ]
      },
      "subscription": {
        "payment_methods": [
          "Credit card",
          "Debit card",
          "Paypal",
          "Cash",
          "Money transfer",
          "Bitcoins",
          "Cheque",
          "Apple Pay",
          "Google Pay",
          "WeChat Pay",
          "Alipay",
          "Visa checkout"
        ],
        "payment_terms": [
          "Payment in advance",
          "Monthly",
          "Annual",
          "Full subscription"
        ],
        "plans": [
          "Free Trial",
          "Basic",
          "Starter",
          "Essential",
          "Student",
          "Bronze",
          "Standard",
          "Silver",
          "Gold",
          "Platinum",
          "Professional",
          "Business",
          "Diamond",
          "Premium"
        ],
        "statuses": [
          "Active",
          "Idle",
          "Blocked",
          "Pending"
        ],
        "subscription_terms": [
          "Daily",
          "Weekly",
          "Monthly",
          "Annual",
          "Biennal",
          "Triennal",
          "Quinquennal",
          "Lifetime"
        ]
      },
      "suits": {
        "characters": [
          "Harvey Specter",
          "Mike Ross",
          "Louis Litt",
          "Rachel Zane",
          "Donna Paulsen",
          "Jessica Pearson",
          "Katrina Bennett",
          "Alex Williams",
          "Samantha Wheeler",
          "Jenny Griffith",
          "Trevor Evans",
          "Dana Scott",
          "Travis Tanner",
          "Cameron Dennis",
          "Daniel Hardman",
          "Sheila Sazs",
          "Monica Eton",
          "Robert Zane",
          "Edward Darby",
          "Stephen Huntley",
          "Ava Hessington",
          "Jonathan Sidwell",
          "Eric Woodall",
          "Sean Cahill",
          "Esther Litt"
        ],
        "quotes": [
          "Sometimes good is not good enough.",
          "I don't play the odds, I play the man.",
          "Thats the difference between you and me. You wanna lose small, I wanna win big.",
          "The only time success comes before work is in the dictionary.",
          "Don't raise your voice. Improve your argument.",
          "When you’re backed against the wall, break the goddamn thing down.",
          "But I’d never thought in million years, that I’d meet someone dumb enough to go to prison for me.",
          "Failure is a bruise, not a tattoo.",
          "When you work with tigers, once in a while they are going to take a swipe at you.",
          "I dont respond to threats. I make them.",
          "I am sorry I don't have photographic memory, but my brain is too busy being awesome.",
          "I’m Donna. I know everything.",
          "I don't have dreams, I have goals.",
          "You just got Litt up!",
          "I’m Moby goddamn Dick, and you just swam in my waters"
        ]
      },
      "superhero": {
        "descriptor": [
          "A-Bomb",
          "Abomination",
          "Absorbing",
          "Ajax",
          "Alien",
          "Amazo",
          "Ammo",
          "Angel",
          "Animal",
          "Annihilus",
          "Ant",
          "Apocalypse",
          "Aqua",
          "Aqualad",
          "Arachne",
          "Archangel",
          "Arclight",
          "Ares",
          "Ariel",
          "Armor",
          "Arsenal",
          "Astro Boy",
          "Atlas",
          "Atom",
          "Aurora",
          "Azrael",
          "Aztar",
          "Bane",
          "Banshee",
          "Bantam",
          "Bat",
          "Beak",
          "Beast",
          "Beetle",
          "Ben",
          "Beyonder",
          "Binary",
          "Bird",
          "Bishop",
          "Bizarro",
          "Blade",
          "Blaquesmith",
          "Blink",
          "Blizzard",
          "Blob",
          "Bloodaxe",
          "Bloodhawk",
          "Bloodwraith",
          "Bolt",
          "Bomb Queen",
          "Boom Boom",
          "Boomer",
          "Booster Gold",
          "Box",
          "Brainiac",
          "Brother Voodoo",
          "Buffy",
          "Bullseye",
          "Bumblebee",
          "Bushido",
          "Cable",
          "Callisto",
          "Cannonball",
          "Carnage",
          "Cat",
          "Century",
          "Cerebra",
          "Chamber",
          "Chameleon",
          "Changeling",
          "Cheetah",
          "Chromos",
          "Chuck Norris",
          "Clea",
          "Cloak",
          "Cogliostro",
          "Colin Wagner",
          "Colossus",
          "Copycat",
          "Corsair",
          "Cottonmouth",
          "Crystal",
          "Curse",
          "Cy-Gor",
          "Cyborg",
          "Cyclops",
          "Cypher",
          "Dagger",
          "Daredevil",
          "Darkhawk",
          "Darkseid",
          "Darkside",
          "Darkstar",
          "Dash",
          "Deadpool",
          "Deadshot",
          "Deathlok",
          "Deathstroke",
          "Demogoblin",
          "Destroyer",
          "Doc Samson",
          "Domino",
          "Doomsday",
          "Doppelganger",
          "Dormammu",
          "Ego",
          "Electro",
          "Elektra",
          "Elongated Man",
          "Energy",
          "ERG",
          "Etrigan",
          "Evilhawk",
          "Exodus",
          "Falcon",
          "Faora",
          "Feral",
          "Firebird",
          "Firelord",
          "Firestar",
          "Firestorm",
          "Fixer",
          "Flash",
          "Forge",
          "Frenzy",
          "Galactus",
          "Gambit",
          "Gamora",
          "Garbage",
          "Genesis",
          "Ghost",
          "Giganta",
          "Gladiator",
          "Goblin Queen",
          "Gog",
          "Goku",
          "Goliath",
          "Gorilla Grodd",
          "Granny Goodness",
          "Gravity",
          "Groot",
          "Guardian",
          "Gardner",
          "Hancock",
          "Havok",
          "Hawk",
          "Heat Wave",
          "Hell",
          "Hercules",
          "Hobgoblin",
          "Hollow",
          "Hope Summers",
          "Hulk",
          "Huntress",
          "Husk",
          "Hybrid",
          "Hyperion",
          "Impulse",
          "Ink",
          "Iron Fist",
          "Isis",
          "Jack of Hearts",
          "Jack-Jack",
          "Jigsaw",
          "Joker",
          "Jolt",
          "Jubilee",
          "Juggernaut",
          "Junkpile",
          "Justice",
          "Kang",
          "Klaw",
          "Kool-Aid Man",
          "Krypto",
          "Leader",
          "Leech",
          "Lizard",
          "Lobo",
          "Loki",
          "Longshot",
          "Luna",
          "Lyja",
          "Magneto",
          "Magog",
          "Magus",
          "Mandarin",
          "Martian Manhunter",
          "Match",
          "Maverick",
          "Maxima",
          "Maya Herrera",
          "Medusa",
          "Meltdown",
          "Mephisto",
          "Mera",
          "Metallo",
          "Metamorpho",
          "Meteorite",
          "Metron",
          "Mimic",
          "Misfit",
          "Mockingbird",
          "Mogo",
          "Moloch",
          "Molten Man",
          "Monarch",
          "Moon Knight",
          "Moonstone",
          "Morlun",
          "Morph",
          "Multiple",
          "Mysterio",
          "Mystique",
          "Namor",
          "Namorita",
          "Naruto Uzumaki",
          "Nathan Petrelli",
          "Niki Sanders",
          "Nina Theroux",
          "Northstar",
          "Nova",
          "Omega Red",
          "Omniscient",
          "Onslaught",
          "Osiris",
          "Overtkill",
          "Penance",
          "Penguin",
          "Phantom",
          "Phoenix",
          "Plastique",
          "Polaris",
          "Predator",
          "Proto-Goblin",
          "Psylocke",
          "Punisher",
          "Pyro",
          "Quantum",
          "Question",
          "Quicksilver",
          "Quill",
          "Ra's Al Ghul",
          "Rachel Pirzad",
          "Rambo",
          "Raven",
          "Redeemer",
          "Renata Soliz",
          "Rhino",
          "Rick Flag",
          "Riddler",
          "Ripcord",
          "Rocket Raccoon",
          "Rogue",
          "Ronin",
          "Rorschach",
          "Sabretooth",
          "Sage",
          "Sasquatch",
          "Scarecrow",
          "Scorpia",
          "Scorpion",
          "Sentry",
          "Shang-Chi",
          "Shatterstar",
          "She-Hulk",
          "She-Thing",
          "Shocker",
          "Shriek",
          "Shrinking Violet",
          "Sif",
          "Silk",
          "Silverclaw",
          "Sinestro",
          "Siren",
          "Siryn",
          "Skaar",
          "Snowbird",
          "Sobek",
          "Songbird",
          "Space Ghost",
          "Spawn",
          "Spectre",
          "Speedball",
          "Speedy",
          "Spider",
          "Spyke",
          "Stacy X",
          "Star-Lord",
          "Stardust",
          "Starfire",
          "Steel",
          "Storm",
          "Sunspot",
          "Swarm",
          "Sylar",
          "Synch",
          "T",
          "Tempest",
          "Thanos",
          "Thing",
          "Thor",
          "Thunderbird",
          "Thundra",
          "Tiger Shark",
          "Tigra",
          "Tinkerer",
          "Titan",
          "Toad",
          "Toxin",
          "Toxin",
          "Trickster",
          "Triplicate",
          "Triton",
          "Two-Face",
          "Ultron",
          "Vagabond",
          "Valkyrie",
          "Vanisher",
          "Venom",
          "Vibe",
          "Vindicator",
          "Violator",
          "Violet",
          "Vision",
          "Vulcan",
          "Vulture",
          "Walrus",
          "War Machine",
          "Warbird",
          "Warlock",
          "Warp",
          "Warpath",
          "Wasp",
          "Watcher",
          "White Queen",
          "Wildfire",
          "Winter Soldier",
          "Wiz Kid",
          "Wolfsbane",
          "Wolverine",
          "Wondra",
          "Wyatt Wingfoot",
          "Yellow",
          "Yellowjacket",
          "Ymir",
          "Zatanna",
          "Zoom"
        ],
        "name": [
          "#{Superhero.prefix} #{Superhero.descriptor} #{Superhero.suffix}",
          "#{Superhero.prefix} #{Superhero.descriptor}",
          "#{Superhero.descriptor} #{Superhero.suffix}",
          "#{Superhero.descriptor}"
        ],
        "power": [
          "Ability Shift",
          "Absorption",
          "Accuracy",
          "Adaptation",
          "Aerokinesis",
          "Agility",
          "Animal Attributes",
          "Animal Control",
          "Animal Oriented Powers",
          "Animation",
          "Anti-Gravity",
          "Apotheosis",
          "Astral Projection",
          "Astral Trap",
          "Astral Travel",
          "Atmokinesis",
          "Audiokinesis",
          "Banish",
          "Biokinesis",
          "Bullet Time",
          "Camouflage",
          "Changing Armor",
          "Chlorokinesis",
          "Chronokinesis",
          "Clairvoyance",
          "Cloaking",
          "Cold Resistance",
          "Cross-Dimensional Awareness",
          "Cross-Dimensional Travel",
          "Cryokinesis",
          "Danger Sense",
          "Darkforce Manipulation",
          "Death Touch",
          "Density Control",
          "Dexterity",
          "Duplication",
          "Durability",
          "Echokinesis",
          "Elasticity",
          "Electrical Transport",
          "Electrokinesis",
          "Elemental Transmogrification",
          "Empathy",
          "Endurance",
          "Energy Absorption",
          "Energy Armor",
          "Energy Beams",
          "Energy Blasts",
          "Energy Constructs",
          "Energy Manipulation",
          "Energy Resistance",
          "Enhanced Hearing",
          "Enhanced Memory",
          "Enhanced Senses",
          "Enhanced Sight",
          "Enhanced Smell",
          "Enhanced Touch",
          "Entropy Projection",
          "Fire Resistance",
          "Flight",
          "Force Fields",
          "Geokinesis",
          "Gliding",
          "Gravitokinesis",
          "Grim Reaping",
          "Healing Factor",
          "Heat Generation",
          "Heat Resistance",
          "Human physical perfection",
          "Hydrokinesis",
          "Hyperkinesis",
          "Hypnokinesis",
          "Illumination",
          "Illusions",
          "Immortality",
          "Insanity",
          "Intangibility",
          "Intelligence",
          "Intuitive aptitude",
          "Invisibility",
          "Invulnerability",
          "Jump",
          "Lantern Power Ring",
          "Latent Abilities",
          "Levitation",
          "Longevity",
          "Magic",
          "Magic Resistance",
          "Magnetokinesis",
          "Matter Absorption",
          "Melting",
          "Mind Blast",
          "Mind Control",
          "Mind Control Resistance",
          "Molecular Combustion",
          "Molecular Dissipation",
          "Molecular Immobilization",
          "Molecular Manipulation",
          "Natural Armor",
          "Natural Weapons",
          "Nova Force",
          "Omnilingualism",
          "Omnipotence",
          "Omnitrix",
          "Orbing",
          "Phasing",
          "Photographic Reflexes",
          "Photokinesis",
          "Physical Anomaly",
          "Portal Creation",
          "Possession",
          "Power Absorption",
          "Power Augmentation",
          "Power Cosmic",
          "Power Nullifier",
          "Power Sense",
          "Power Suit",
          "Precognition",
          "Probability Manipulation",
          "Projection",
          "Psionic Powers",
          "Psychokinesis",
          "Pyrokinesis",
          "Qwardian Power Ring",
          "Radar Sense",
          "Radiation Absorption",
          "Radiation Control",
          "Radiation Immunity",
          "Reality Warping",
          "Reflexes",
          "Regeneration",
          "Resurrection",
          "Seismic Power",
          "Self-Sustenance",
          "Separation",
          "Shapeshifting",
          "Size Changing",
          "Sonar",
          "Sonic Scream",
          "Spatial Awareness",
          "Stamina",
          "Stealth",
          "Sub-Mariner",
          "Substance Secretion",
          "Summoning",
          "Super Breath",
          "Super Speed",
          "Super Strength",
          "Symbiote Costume",
          "Technopath/Cyberpath",
          "Telekinesis",
          "Telepathy",
          "Telepathy Resistance",
          "Teleportation",
          "Terrakinesis",
          "The Force",
          "Thermokinesis",
          "Thirstokinesis",
          "Time Travel",
          "Timeframe Control",
          "Toxikinesis",
          "Toxin and Disease Resistance",
          "Umbrakinesis",
          "Underwater breathing",
          "Vaporising Beams",
          "Vision - Cryo",
          "Vision - Heat",
          "Vision - Infrared",
          "Vision - Microscopic",
          "Vision - Night",
          "Vision - Telescopic",
          "Vision - Thermal",
          "Vision - X-Ray",
          "Vitakinesis",
          "Wallcrawling",
          "Weapon-based Powers",
          "Weapons Master",
          "Web Creation",
          "Wishing"
        ],
        "prefix": [
          "The",
          "Magnificent",
          "Ultra",
          "Supah",
          "Illustrious",
          "Agent",
          "Cyborg",
          "Dark",
          "Giant",
          "Mr",
          "Doctor",
          "Red",
          "Green",
          "General",
          "Captain"
        ],
        "suffix": [
          "I",
          "II",
          "III",
          "IX",
          "XI",
          "Claw",
          "Man",
          "Woman",
          "Machine",
          "Strike",
          "X",
          "Eyes",
          "Dragon",
          "Skull",
          "Fist",
          "Ivy",
          "Boy",
          "Girl",
          "Knight",
          "Wolf",
          "Lord",
          "Brain",
          "the Hunter",
          "of Hearts",
          "Spirit",
          "Strange",
          "the Fated",
          "Brain",
          "Thirteen"
        ]
      },
      "supernatural": {
        "character": [
          "Abaddon",
          "Adam Milligan",
          "Alastair",
          "Alex Jones",
          "Amelia Richardson",
          "Anna Milton",
          "Arthur Ketch",
          "Ash",
          "Asmodeus",
          "Azazel",
          "Balthazar",
          "Becky Rosen",
          "Bela Talbot",
          "Belphegor",
          "Ben Braeden",
          "Benny Lafitte",
          "Bess Fitzgerald",
          "Bobby Singer",
          "Castiel",
          "Charlie Bradbury",
          "Christian Campbell",
          "Claire Novak",
          "Cole Trenton",
          "Constance Welch",
          "Crowley",
          "Dagon",
          "Dean Winchester",
          "Death",
          "Doctor Hess",
          "Donatello Redfield",
          "Donna Hanscum",
          "Dr. Gaines",
          "Dumah",
          "Edgar",
          "Eileen Leahy",
          "Eleanor Visyak",
          "Ellen Harvelle",
          "Eve",
          "Frank Devereaux",
          "Gabriel",
          "Gadreel",
          "Garth Fitzgerald IV",
          "Gavin MacLeod",
          "Gordon Walker",
          "Gwen Campbell",
          "Hannah",
          "Harry Spengler",
          "Ingrid",
          "Jack Kline",
          "Jenny",
          "Jessica Moore",
          "Jo Harvelle",
          "Jody Mills",
          "John Wayne Gacy",
          "John Winchester",
          "Josie Sands",
          "Karen Singer",
          "Kevin Tran",
          "Lady Toni Bevell",
          "Lilith",
          "Linda Tran",
          "Lisa Braeden",
          "Lucifer",
          "Mary Winchester",
          "Mary Worthington",
          "Meg Masters",
          "Metatron",
          "Michael",
          "Mick Davies",
          "Naomi",
          "Nick",
          "Pamela Barnes",
          "Raphael",
          "Rowena MacLeod",
          "Ruby",
          "Rufus Turner",
          "Sam Winchester",
          "Samandriel",
          "Samuel Campbell",
          "Sergei",
          "Susan",
          "Tessa",
          "Uriel",
          "Victor Henriksen",
          "Zachariah"
        ],
        "creature": [
          "Angel",
          "Archangel",
          "Croatoan Virus",
          "Demon",
          "Djinn",
          "Dragon",
          "Elf",
          "Ghost",
          "Ghoul",
          "Hellhounds",
          "Kappa",
          "Khan worm",
          "Leprechauns",
          "Leviathan",
          "Loch Ness Monster",
          "Mermaid",
          "Monster",
          "Phoenix",
          "Poltergeist",
          "Shapeshifter",
          "Soul Eater",
          "Tricksters",
          "Wendigo",
          "Werewolf",
          "Zombie",
          "Vampire"
        ],
        "weapon": [
          "Archangel Blades",
          "Brass",
          "Cain's knife",
          "Crowley's bones",
          "Death's Scythe",
          "Death's ring",
          "Excalibur",
          "Fire",
          "Hands Of God",
          "Holy Oil",
          "Holy Water",
          "Lamb blood",
          "Lance Of Michael",
          "Rabbit's Foot",
          "Righteous Bone",
          "Salt",
          "Silver Bullets",
          "Staff of Moses",
          "Sword of St. George",
          "The Equalizer",
          "The First Blade",
          "Virgin blood",
          "steel",
          "The Colt"
        ]
      },
      "sword_art_online": {
        "game_name": [
          "Sinon",
          "Silica",
          "Kirito",
          "Leafa",
          "Lisbeth",
          "Klein",
          "Asuna",
          "Strea",
          "Eugeo",
          "Sachi",
          "Argo",
          "Kureha",
          "Kibaou",
          "Zeliska",
          "Alicia Rue",
          "Kizmel",
          "Premiere",
          "Protaganist",
          "Quinella",
          "Itsuki",
          "Morte",
          "Sakuya",
          "Thinker",
          "Kuradeel",
          "Musketeer X",
          "Diavel",
          "Pina",
          "Sasha",
          "Nori",
          "Rosalia",
          "Tia",
          "Yulier",
          "Griselda",
          "Merida",
          "Thor",
          "Lind",
          "Pale Rider",
          "Eugene",
          "Keita",
          "Grimlock",
          "Coper",
          "Yamikaze",
          "Dyne",
          "Yolko",
          "Ashley",
          "Tecchi",
          "Cardinal",
          "Kobatz",
          "Jun",
          "Talken",
          "Godfree",
          "Skuld",
          "Uror",
          "Genesis",
          "Schmitt",
          "Caynz",
          "Nezha",
          "Mortimer",
          "Ceba",
          "Deusolbert",
          "Tonky",
          "Bercouli",
          "Sigurd",
          "Behemoth",
          "Nishida",
          "Aaaa",
          "Kagemune",
          "Chudelkin",
          "Ruru",
          "Veroandi",
          "Tetsuo",
          "Fanatio",
          "Charlotte",
          "Shivata",
          "Daizen",
          "Fizel",
          "Amayori",
          "Gtacs",
          "Orick",
          "Linel",
          "Ginrou",
          "Marinca",
          "Sadore",
          "Angel",
          "Lion King Richie",
          "Kakouton",
          "Sasamaru",
          "Leviathan",
          "Yamata",
          "Ryufior",
          "Iskahn",
          "Stinger",
          "Azurika",
          "Ugachi",
          "Orlando",
          "Dakira",
          "Beowulf",
          "Elevating Operator",
          "Critter",
          "Jink",
          "Shishigane",
          "Jin",
          "Garitta",
          "Uemaru",
          "Romolo",
          "Arashi",
          "Nakanishi",
          "Cuchulainn",
          "Miso",
          "Agil"
        ],
        "item": [
          "Blackwyrm Coat",
          "Anneal Blade",
          "Dark Repulser",
          "Ebon Dagger",
          "Elucidator",
          "Guilty Thorn",
          "Karakurenai",
          "Lambent Light",
          "Liberator",
          "Mate Chopper",
          "Stout Brand",
          "Sword Breaker",
          "Throwing Pick",
          "Tyrant Dragon",
          "Wind Fleuret",
          "Argyro's Sheet",
          "Coat of Midnight",
          "Cor",
          "Crystal Bottle of Kales'Oh",
          "Crystallite Ingot",
          "Crystals",
          "Diving Stone of Returning Soul",
          "Dusk Lizard Hide",
          "Eternal Storage Trinket",
          "Hand Mirror",
          "Mighty Strap of Leather",
          "Mirage Sphere",
          "Pneuma Flower",
          "Potions",
          "Ragout Rabbit's Meat",
          "Ring of Agility",
          "Ring of Angel's Whisper",
          "Scavenge Toad Meat",
          "Tremble Shortcake",
          "Vendor's Carpet",
          "Yui's Heart",
          "Black Iron Great Sword",
          "Blue Long Sword",
          "Crest of Yggdrasil",
          "Demonic Sword Gram",
          "Holy Sword Excalibur",
          "Lightning Hammer Mjolnir",
          "Long Sword",
          "Sap of the World Tree",
          "Yrd",
          "Accuracy International L115A3",
          "Credit",
          "Defense Field",
          "FN Five-Seven",
          "GE M134 Minigun",
          "Kagemitsu G4",
          "Metamaterial Optical Camouflage Mantle",
          "PGM Ultima Ratio Hecate II",
          "Plasma Grenade",
          "Procyon SL",
          "Satellite Scan Terminal",
          "Starship Metal Estoc",
          "Type 54 \"Black Star\"",
          "Black Lily Sword",
          "Blue Rose Sword",
          "Conflagrant Flame Bow",
          "Dragon Bone Axe",
          "Fragrant Olive Sword",
          "Frost Scale Whip",
          "Gigas Cedar",
          "Goblin Sword",
          "Heaven Piercing Sword",
          "Night Sky Sword",
          "Silvery Eternity",
          "Time Piercing Sword",
          "Twin Edged Wings"
        ],
        "location": [
          "Aincrad",
          "Underworld",
          "Ruby Palace",
          "Underworld",
          "Alfheim",
          "Black Iron Palace",
          "Forest House K4",
          "Ocean Turtle",
          "Monument of Life",
          "SBC Glocken",
          "Hidden Dungeon",
          "Dungeon",
          "SAO Survivor School",
          "Town of Beginnings",
          "Dicey Cafe",
          "Yggdrasil City",
          "Horunka",
          "Lisbeth's Smith Shop",
          "Chamber of Resurrection",
          "Selmburg",
          "Collinia",
          "Central Cathedral",
          "Taft",
          "Jotunheimr",
          "Kirigaya Residence",
          "Granzam",
          "Algade",
          "Sword Mastery Academy",
          "Gigas Cedar",
          "Urbus",
          "Karluin",
          "Tolbana",
          "Alne",
          "Lindarth",
          "Swilvane",
          "Thrymheim",
          "Rulid Village",
          "Forest of Wandering",
          "Virtual Lab",
          "Zumfut",
          "Yofel Castle",
          "Floria",
          "Rovia",
          "Hill of Memories",
          "Sunshine Forest",
          "Forest of Wavering Mists",
          "West Mountain",
          "Kamdet",
          "Agil's Shop",
          "Ronbaru",
          "ISL Ragnarok",
          "Panareze",
          "Mishe",
          "Myujen",
          "Coral",
          "Pani",
          "Danac",
          "Hill of the Cross",
          "Thule Island",
          "Wolf Plains",
          "Marten",
          "Legrue",
          "Legrue Corridor",
          "Centoria",
          "Algade House",
          "Intercontinental Highway",
          "Lost Temple",
          "Wasteland Crossroads",
          "Great Void",
          "Ant Hill",
          "Weathercock Pavilion",
          "Great Library Room",
          "Zakkaria",
          "Undersea Temple",
          "Ancient Forest",
          "Butterfly Valley",
          "Angel's Rose Garden",
          "World Tree"
        ],
        "real_name": [
          "Alice Zuberg",
          "Asada Shino",
          "Ayano Keiko",
          "Kayaba Akihiko",
          "Kikuoka Seijirou",
          "Kirigaya Kazuto",
          "Kirigaya Suguha",
          "Shinozaki Rika",
          "Tsuboi Ryoutarou",
          "Yui",
          "Yuuki Asuna",
          "Aki Natsuki",
          "Higa Takeru",
          "Andrew Gilbert Mills",
          "Alicia Klingerman",
          "Fujita Shin",
          "Kirigaya Midori",
          "Okano Kouji",
          "Sada Akiyo",
          "Satou Rei",
          "Shigemura Tetsuhiro",
          "Yuuki Kouichirou",
          "Yuuki Kyouko",
          "Yuuki Shouzou",
          "Kanzaki Elsa",
          "Kohiruimaki Karen",
          "Konno Yuuki",
          "Asougi Goushi",
          "Shinohara Miyu",
          "Shinkawa Shouichi",
          "Shigemura Yuuna",
          "Takemiya Kotone",
          "Karatachi Nijika",
          "Koujiro Rinko",
          "Kashiwazaka Hiyori",
          "Konno Aiko",
          "Vassago Casals",
          "Nochizawa Eiji",
          "Nanairo Arshavin",
          "Gabriel Miller",
          "An Si-eun",
          "Nagata Shinichi",
          "Ronye Arabel",
          "Tiese Shtolienen",
          "Selka Zuberg",
          "Sortilirna Serlut",
          "Sumeragi Youta",
          "Usujio Tarako",
          "Eldrie Woolsburg",
          "Doctor Kurahashi",
          "Frenica Szeski",
          "Sadina Zuberg",
          "Saitou Shouichi",
          "Gasupht Zuberg",
          "Leyshren Zed Yofilis",
          "Uolo Levanteinn",
          "Egome Zakkalight",
          "Raios Antinous",
          "Humbert Zizek",
          "Sister Azariya",
          "Lipia Zankale",
          "Viksul Ur Shasta",
          "Endou",
          "Ducker"
        ]
      },
      "tarkov": {
        "bosses": [
          "Big Pipe",
          "Birdeye",
          "Cultist priest",
          "Glukhar",
          "Killa",
          "Knight",
          "Reshala",
          "Sanitar",
          "Shturman",
          "Tagilla"
        ],
        "factions": [
          "USEC",
          "BEAR",
          "Scav",
          "Raider",
          "Cultist",
          "Rogue"
        ],
        "items": [
          "42 Signature Blend English Tea",
          "Apollo Soyuz cigarettes",
          "Aramid fiber fabric",
          "BEAR Buddy plush toy",
          "Can of Dr. Lupo's coffee beans",
          "Can of Majaica coffee beans",
          "Cordura polyamide fabric",
          "Dogtag",
          "Fleece fabric",
          "FP-100 filter absorber",
          "Gas mask air filter",
          "Malboro Cigarettes",
          "OFZ 30x160mm shell",
          "Paracord",
          "Press pass (issued for NoiceGuy)",
          "Ripstop fabric",
          "Strike Cigarettes",
          "UZRGM grenade fuze",
          "Water filter",
          "Weapon parts",
          "Wilston cigarettes",
          "Analog thermometer",
          "Bolts",
          "Corrugated hose",
          "Duct tape",
          "Insulating tape",
          "KEKTAPE duct tape",
          "Metal spare parts",
          "Military corrugated tube",
          "Pack of nails",
          "Pack of screws",
          "Piece of plexiglass",
          "Pressure gauge",
          "Screw nuts",
          "Shustrilo sealing foam",
          "Silicone tube",
          "Tube of Poxeram cold welding",
          "Xenomorph sealing foam",
          "Broken GPhone X smartphone",
          "Broken GPhone smartphone",
          "Broken LCD",
          "Bundle of wires",
          "Capacitors",
          "CPU fan",
          "Damaged hard drive",
          "DVD drive",
          "Electric drill",
          "Electric motor",
          "Energy-saving lamp",
          "Gas analyzer",
          "Geiger-Muller counter",
          "Golden 1GPhone smartphone",
          "Graphics card",
          "Iridium military thermal vision module",
          "Light bulb",
          "Magnet",
          "Military cable",
          "Military circuit board",
          "Military COFDM Wireless Signal Transmitter",
          "Military gyrotachometer",
          "Military power filter",
          "NIXXOR lens",
          "PC CPU",
          "Phase control relay",
          "Phased array element",
          "Power cord",
          "Power supply unit",
          "Printed circuit board",
          "Radiator helix",
          "RAM",
          "Spark plug",
          "T-Shaped plug",
          "Tetriz portable game console",
          "UHF RFID Reader",
          "Ultraviolet lamp",
          "USB Adapter",
          "Virtex programmable processor",
          "VPX Flash Storage Module",
          "Working LCD",
          "6-STEN-140-M military battery",
          "AA Battery",
          "Car battery",
          "Cyclon rechargeable battery",
          "D Size battery",
          "GreenBat lithium battery",
          "Portable Powerbank",
          "Rechargeable battery",
          "Can of thermite",
          "Classic matches",
          "Crickent lighter",
          "Dry fuel",
          "Expeditionary fuel tank",
          "FireKlean gun lube",
          "Fuel conditioner",
          "Gunpowder \"Eagle\"",
          "Gunpowder \"Hawk\"",
          "Gunpowder \"Kite\"",
          "Hunting matches",
          "Metal fuel tank",
          "Propane tank (5L)",
          "SurvL Survivor Lighter",
          "TP-200 TNT brick",
          "WD-40 (400ml)",
          "WD-40 100ml",
          "Zibbo lighter",
          "Alkaline cleaner for heat exchangers",
          "Can of white salt",
          "Clin window cleaner",
          "Deadlyslob's beard oil",
          "LVNDMARK's rat poison",
          "Ortodontox toothpaste",
          "Ox bleach",
          "Pack of chlorine",
          "Pack of sodium bicarbonate",
          "PAID AntiRoach spray",
          "Printer paper",
          "Repellent",
          "Schaman shampoo",
          "Smoked Chimney drain cleaner",
          "Soap",
          "Toilet paper",
          "Toothpaste",
          "Bottle of hydrogen peroxide",
          "Bottle of OLOLO Multivitamins",
          "Bottle of saline solution",
          "Disposable syringe",
          "LEDX Skin Transilluminator",
          "Medical bloodset",
          "Medical tools",
          "Ophthalmoscope",
          "Pile of meds",
          "Portable defibrillator",
          "Awl",
          "Bulbex cable cutter",
          "Construction measuring tape",
          "Flat screwdriver",
          "Flat screwdriver (Long)",
          "Hand drill",
          "Metal cutting scissors",
          "Nippers",
          "Pipe grip wrench",
          "Pliers",
          "Pliers Elite",
          "Ratchet wrench",
          "Round pliers",
          "Screwdriver",
          "Set of files \"Master\"",
          "Sewing kit",
          "Toolset",
          "Wrench",
          "Antique teapot",
          "Antique vase",
          "Axel parrot figurine",
          "Battered antique book",
          "Bronze lion",
          "Cat figurine",
          "Chain with Prokill medallion",
          "Chainlet",
          "Christmas tree ornament (Red)",
          "Christmas tree ornament (Silver)",
          "Christmas tree ornament (Violet)",
          "Gold skull ring",
          "Golden egg",
          "Golden neck chain",
          "Golden rooster",
          "GP coin",
          "Horse figurine",
          "Loot Lord plushie",
          "Old firesteel",
          "Physical bitcoin",
          "Raven figurine",
          "Roler Submariner gold wrist watch",
          "Silver Badge",
          "Veritas guitar pick",
          "Wooden clock",
          "BakeEzy cook book",
          "Diary",
          "Intelligence folder",
          "Military flash drive",
          "SAS drive",
          "Secure Flash drive",
          "Secured magnetic tape cassette",
          "Slim diary",
          "SSD drive",
          "Tech manual",
          "Topographic survey maps",
          "Video cassette with the Cyborg Killer movie"
        ],
        "locations": [
          "Customs",
          "Factory",
          "Interchange",
          "Lighthouse",
          "Reserve",
          "Shoreline",
          "The Lab",
          "Woods",
          "Arena",
          "Private Sector",
          "Streets of Tarkov",
          "Suburbs",
          "Terminal",
          "Town"
        ],
        "quests": {
          "fence": [
            "Collector",
            "The Choice",
            "Compensation for Damage - Wager",
            "Compensation for Damage - Trust",
            "Compensation for Damage - Wergild",
            "Compensation for Damage - Barkeep",
            "Compensation for Damage - Collection"
          ],
          "jaeger": [
            "Acquaintance",
            "The Survivalist Path - Unprotected but Dangerous",
            "The Survivalist Path - Thrifty",
            "The Survivalist Path - Zhivchik",
            "The Survivalist Path - Wounded Beast",
            "The Survivalist Path - Tough Guy",
            "Courtesy Visit",
            "Nostalgia",
            "The Survivalist Path - Cold Blooded",
            "The Survivalist Path - Junkie",
            "The Survivalist Path - Eagle-Owl",
            "The Survivalist Path - Combat Medic",
            "Ambulance",
            "The Huntsman Path - Secured Perimeter",
            "Reserve",
            "The Huntsman Path - Forest Cleaning",
            "The Huntsman Path - Controller",
            "The Huntsman Path - Evil Watchman",
            "Fishing Place",
            "The Huntsman Path - Trophy",
            "The Huntsman Path - Justice",
            "The Huntsman Path - Sellout",
            "The Huntsman Path - Woods Keeper",
            "Hunting Trip",
            "The Huntsman Path - Factory Chief",
            "The Huntsman Path - Eraser - Part 1",
            "The Huntsman Path - Eraser - Part 2",
            "The Tarkov Shooter - Part 1",
            "The Tarkov Shooter - Part 2",
            "The Tarkov Shooter - Part 3",
            "The Tarkov Shooter - Part 4",
            "The Tarkov Shooter - Part 5",
            "The Tarkov Shooter - Part 6",
            "The Tarkov Shooter - Part 7",
            "The Tarkov Shooter - Part 8",
            "Shady Business",
            "The Huntsman Path - Sadist",
            "Hunter",
            "Pest Control",
            "Swift One",
            "The Huntsman Path - Relentless",
            "The Hermit",
            "The Huntsman Path - Outcasts",
            "Stray Dogs"
          ],
          "mechanic": [
            "Gunsmith - Part 1",
            "Gunsmith - Part 2",
            "Gunsmith - Part 3",
            "Gunsmith - Part 4",
            "Gunsmith - Part 5",
            "Gunsmith - Part 6",
            "Gunsmith - Part 7",
            "Gunsmith - Part 8",
            "Gunsmith - Part 9",
            "Gunsmith - Part 10",
            "Gunsmith - Part 11",
            "Gunsmith - Part 12",
            "Gunsmith - Part 13",
            "Gunsmith - Part 14",
            "Gunsmith - Part 15",
            "Gunsmith - Part 16",
            "Signal - Part 1",
            "Insider",
            "Signal - Part 2",
            "Scout",
            "Surplus Goods",
            "Back Door",
            "Signal - Part 3",
            "Signal - Part 4",
            "Farming - Part 1",
            "Farming - Part 2",
            "Bad Habit",
            "Farming - Part 3",
            "Farming - Part 4",
            "Psycho Sniper",
            "A Shooter Born in Heaven",
            "Fertilizers",
            "Import",
            "Chemistry Closet",
            "Calibration",
            "The Courier",
            "Corporate Secrets",
            "Energy Crisis",
            "Broadcast"
          ],
          "peacekeeper": [
            "Fishing Gear",
            "Tigr Safari",
            "Scrap Metal",
            "Eagle Eye",
            "Humanitarian Supplies",
            "The Cult - Part 1",
            "The Cult - Part 2",
            "Spa Tour - Part 1",
            "Spa Tour - Part 2",
            "Spa Tour - Part 3",
            "Spa Tour - Part 4",
            "Spa Tour - Part 5",
            "Spa Tour - Part 6",
            "Spa Tour - Part 7",
            "Cargo X - Part 1",
            "Cargo X - Part 2",
            "Cargo X - Part 3",
            "Wet Job - Part 1",
            "Wet Job - Part 2",
            "Wet Job - Part 3",
            "Wet Job - Part 4",
            "Wet Job - Part 5",
            "Mentor",
            "Wet Job - Part 6",
            "The Guide",
            "Samples",
            "TerraGroup Employee",
            "Lend-Lease - Part 2",
            "Peacekeeping Mission",
            "Classified Technologies",
            "Revision - Part 1",
            "The Cleaner",
            "Special Equipment",
            "Cargo X - Part 4",
            "Counteraction",
            "Overpopulation",
            "Revision - Part 2",
            "Trophies"
          ],
          "prapor": [
            "Debut",
            "Search Mission",
            "Checking",
            "Shootout Picnic",
            "Delivery from the Past",
            "BP Depot",
            "The Bunker - Part 1",
            "The Bunker - Part 2",
            "Bad Rep Evidence",
            "Ice Cream Cones",
            "No Place for Renegades",
            "Documents",
            "Postman Pat - Part 1",
            "Shaking up the Teller",
            "The Punisher - Part 1",
            "The Punisher - Part 2",
            "The Punisher - Part 3",
            "The Punisher - Part 4",
            "The Punisher - Part 5",
            "The Punisher - Part 6",
            "Anesthesia",
            "Grenadier",
            "Insomnia",
            "Test Drive - Part 1",
            "Perfect Mediator",
            "Polikhim Hobo",
            "Regulated Materials",
            "Big Customer",
            "No Offence",
            "Capturing Outposts",
            "Intimidator",
            "Escort",
            "Easy Job - Part 1",
            "Easy Job - Part 2",
            "Our Own Land",
            "Reconnaissance"
          ],
          "ragman": [
            "Only Business",
            "Make ULTRA Great Again",
            "Big Sale",
            "A Fuel Matter",
            "Inventory Check",
            "The Blood of War - Part 1",
            "Dressed to Kill",
            "Gratitude",
            "Hot Delivery",
            "Scavenger",
            "Sales Night",
            "Database - Part 1",
            "Database - Part 2",
            "Minibus",
            "Sew it Good - Part 1",
            "The Blood of War - Part 2",
            "The Blood of War - Part 3",
            "Living High is Not a Crime - Part 2",
            "Sew it Good - Part 2",
            "The Key to Success",
            "No Fuss Needed",
            "The Stylish One",
            "Supervisor",
            "Sew it Good - Part 3",
            "Living High is Not a Crime - Part 1",
            "Sew it Good - Part 4",
            "Charisma Brings Success",
            "Textile - Part 1",
            "Textile - Part 2",
            "Long Line",
            "Booze"
          ],
          "skier": [
            "Supplier",
            "The Extortionist",
            "Stirrup",
            "What’s on the Flash Drive?",
            "Golden Swag",
            "Chemical - Part 1",
            "Chemical - Part 2",
            "Chemical - Part 3",
            "Chemical - Part 4",
            "Loyalty Buyout",
            "Vitamins - Part 1",
            "Vitamins - Part 2",
            "Friend from the West - Part 1",
            "Friend from the West - Part 2",
            "Informed Means Armed",
            "Chumming",
            "Silent Caliber",
            "Bullshit",
            "Setup",
            "Flint",
            "Lend-Lease - Part 1",
            "Kind of Sabotage",
            "Rigged Game",
            "Safe Corridor",
            "Night Sweep",
            "Long Road",
            "Missing Cargo",
            "Top Secret"
          ],
          "therapist": [
            "Shortage",
            "Operation Aquarius - Part 1",
            "Operation Aquarius - Part 2",
            "Sanitary Standards - Part 1",
            "Sanitary Standards - Part 2",
            "Painkiller",
            "Pharmacist",
            "Car Repair",
            "Hippocratic Oath",
            "Disease History",
            "Supply Plans",
            "Health Care Privacy - Part 1",
            "Health Care Privacy - Part 2",
            "Health Care Privacy - Part 3",
            "An Apple a Day Keeps the Doctor Away",
            "Health Care Privacy - Part 4",
            "Athlete",
            "Private Clinic",
            "Health Care Privacy - Part 5",
            "Decontamination Service",
            "General Wares",
            "Colleagues - Part 1",
            "Colleagues - Part 2",
            "Colleagues - Part 3",
            "Postman Pat - Part 2",
            "Out of Curiosity",
            "Trust Regain",
            "Crisis",
            "Seaside Vacation",
            "Lost Contact",
            "Drug Trafficking"
          ]
        },
        "traders": [
          "Prapor",
          "Therapist",
          "Fence",
          "Skier",
          "Peacekeeper",
          "Mechanic",
          "Ragman",
          "Jaeger"
        ],
        "weapons": [
          "SIG MCX",
          "M4A1",
          "HK416",
          "DT MDR 5.56",
          "HK G36",
          "FN SCAR-L",
          "AK101",
          "AK102",
          "AK(S)74(N)",
          "AK74M",
          "AK105",
          "AK103",
          "AK104",
          "AKM(S)(N)",
          "RD704",
          "MK47",
          "SAG AK Short",
          "SAG AK Long",
          "AKS74U",
          "AKS74UN",
          "AKS74UB",
          "RPK16",
          "AS VAL",
          "VSS",
          "ASH-12",
          "SA58",
          "SCAR-H",
          "DT MDR .308",
          "ADAR-2-15",
          "TX15",
          "VPO-136",
          "SKS",
          "OP-SKS",
          "VPO-209",
          "KAC SR25",
          "RSASS",
          "G28",
          "M1A",
          "SVD",
          "RFB",
          "VPO-101",
          "MK.18",
          "Stm-9",
          "Saiga-9",
          "PP19-01",
          "MP5",
          "MP5k",
          "MPX",
          "MP9(n)",
          "Vector 9x19",
          "Vector 11x43",
          "UMP-45",
          "PP-91 Kedr",
          "PP-9 Klin",
          "PP-91-01",
          "HK MP7A1 (A2)",
          "FN P90",
          "PPSH-41",
          "FN Five-Seven",
          "Beretta M9A3",
          "Glock 17",
          "Glock 18C",
          "MP443",
          "PL-15",
          "P226",
          "Colt M1911",
          "Colt M45A1",
          "USP .45",
          "SR-1MP",
          "PM",
          "PB",
          "APS(APB)",
          "TT33",
          "Rhino 50DS",
          "Rhino 200DS",
          "MP43",
          "MP133",
          "M870",
          "M590",
          "MP153",
          "MP155",
          "Beneli M3",
          "MTs-255",
          "Ssiga-12",
          "Toz-106",
          "MP-18",
          "Mosin",
          "VPO-215",
          "SV-98",
          "DVL-10",
          "Orsis T500",
          "Remington 700",
          "AXMC",
          "FN GL40",
          "NSV Utes",
          "AGS-30"
        ]
      },
      "tea": {
        "type": [
          "Black",
          "Oolong",
          "Green",
          "White",
          "Herbal"
        ],
        "variety": {
          "black": [
            "Assam",
            "Ceylon",
            "Congou",
            "Darjeeling",
            "Dianhong",
            "Earl Grey",
            "English Afternoon",
            "English Breakfast",
            "Irish Breakfast",
            "Jaekseol",
            "Jiu Qu Hong Mei",
            "Kangra",
            "Keemun",
            "Lady Grey",
            "Lahijan",
            "Lapsang Souchong",
            "Masala Chai",
            "Munnar",
            "Nepali",
            "Nilgiri",
            "Rize",
            "Scottish Breakfast",
            "Sun Moon Lake",
            "Yingdehong"
          ],
          "green": [
            "Bancha",
            "Biluochun",
            "Chun Mee",
            "Daejak",
            "Garucha",
            "Genmaicha",
            "Gunpowder",
            "Gyokuro",
            "Hojicha",
            "Huangshan Maofeng",
            "Ipcha",
            "Jungjak",
            "Kabusecha",
            "Kukicha",
            "Longjing",
            "Lu'an Melon Seed",
            "Matcha",
            "Sejak",
            "Sencha",
            "Shincha",
            "Taipin Houkui",
            "Ujeon",
            "Xinyang Maojian"
          ],
          "herbal": [
            "Anise",
            "Asiatic Penny-Wort",
            "Bael Fruit",
            "Barley",
            "Bee Balm",
            "Boldo",
            "Burdock",
            "Cacao",
            "Caraway",
            "Cat's Claw",
            "Catnip",
            "Cerasse",
            "Chamomile",
            "Che Dang",
            "Chinese Knot-Weed",
            "Chrysanthemum",
            "Cinnamon",
            "Citrus Peel",
            "Dandelion",
            "Dill",
            "Dried Lime",
            "Echinacea",
            "Elderberry",
            "Essiac",
            "European Mistletoe",
            "Fennel",
            "Gentian",
            "Ginger Root",
            "Ginseng",
            "Goji",
            "Hawthorn",
            "Hibiscus",
            "Honeybush",
            "Horehound",
            "Houttuynia",
            "Jiaogulan",
            "Kapor",
            "Kuzuyu",
            "Labrador",
            "Lemon Balm",
            "Lemon Ginger",
            "Lemon Grass",
            "Licorice Root",
            "Lime Blossom",
            "Luo Han Guo",
            "Mint",
            "Moringa",
            "Mountain Tea",
            "Neem",
            "Nettle",
            "New Jersey Tea",
            "Noni",
            "Oksusu Cha",
            "Olive Leaf",
            "Osmanthus",
            "Pandan",
            "Patchouli",
            "Pine",
            "Qishr",
            "Red Clover",
            "Red Raspberry",
            "Roasted Wheat",
            "Rooibos",
            "Rose Hip",
            "Roselle",
            "Rosemary",
            "Sage",
            "Sagebrush",
            "Serendib",
            "Skurayu",
            "Sobacha",
            "Spearmint",
            "Spicebush",
            "Spruce",
            "St. John's Wort",
            "Thyme",
            "Tulsi",
            "Turmeric",
            "Valerian",
            "Verbena",
            "Vetiver",
            "Wax Gourd",
            "Wong Lo Kat",
            "Woodruff",
            "Yarrow"
          ],
          "oolong": [
            "Alishan",
            "Bai Jiguan",
            "Da Hong Pao",
            "Dancong",
            "Dongding",
            "Dongfang Meiren",
            "Fujian",
            "Gaoshan",
            "Huangjin Gui",
            "Ji Xuan",
            "Lishan",
            "Pouchong",
            "Rougui",
            "Ruan Zhi",
            "Shui Jin Gui",
            "Shui Xian",
            "Tieguanyin",
            "Tieluohan",
            "Tienguanyin",
            "Vietnamese"
          ],
          "white": [
            "Bai Mu Dan",
            "Fujian New Craft",
            "Gongmei",
            "Shou Mei",
            "Yi Zhen Bai Hao"
          ]
        }
      },
      "team": {
        "creature": [
          "ants",
          "bats",
          "bears",
          "bees",
          "birds",
          "buffalo",
          "cats",
          "chickens",
          "cattle",
          "dogs",
          "dolphins",
          "ducks",
          "elephants",
          "fishes",
          "foxes",
          "frogs",
          "geese",
          "goats",
          "horses",
          "kangaroos",
          "lions",
          "monkeys",
          "owls",
          "oxen",
          "penguins",
          "people",
          "pigs",
          "rabbits",
          "sheep",
          "tigers",
          "whales",
          "wolves",
          "zebras",
          "banshees",
          "crows",
          "black cats",
          "chimeras",
          "ghosts",
          "conspirators",
          "dragons",
          "dwarves",
          "elves",
          "enchanters",
          "exorcists",
          "sons",
          "foes",
          "giants",
          "gnomes",
          "goblins",
          "gooses",
          "griffins",
          "lycanthropes",
          "nemesis",
          "ogres",
          "oracles",
          "prophets",
          "sorcerors",
          "spiders",
          "spirits",
          "vampires",
          "warlocks",
          "vixens",
          "werewolves",
          "witches",
          "worshipers",
          "zombies",
          "druids"
        ],
        "mascot": [
          "Raymond",
          "Bailey",
          "Rocky",
          "Screech",
          "Steely McBeam",
          "Nordy",
          "Hugo",
          "Griz",
          "Iceburgh",
          "Mr. Redlegs",
          "Benny the Bull",
          "Big Red",
          "Suns Gorilla",
          "Pirate Parrot",
          "Ragar the Viking",
          "JazzBear",
          "Wally the Green Monster",
          "Burnie",
          "K.C. Wolf",
          "Sausages",
          "Mr. Met",
          "Youppi",
          "The Raptor",
          "Jaxson De Ville",
          "Phanatic"
        ],
        "name": [
          "#{Address.state} #{creature}"
        ],
        "sport": [
          "baseball",
          "basketball",
          "football",
          "hockey",
          "rugby",
          "lacrosse",
          "soccer",
          "buzkashi",
          "cricket",
          "kabaddi",
          "archery",
          "field hockey",
          "wrestling",
          "association",
          "sumo",
          "dandi biyo",
          "league",
          "arnis",
          "bandy",
          "taekwondo",
          "volley ball",
          "oil wrestling",
          "handball",
          "pesäpallo",
          "rugby union",
          "golf",
          "bull fighting",
          "shooting",
          "gymnastics",
          "water polo"
        ]
      },
      "the_expanse": {
        "characters": [
          "Jim Holden",
          "Alex Kamal",
          "Naomi Nagata",
          "Amos Burton",
          "Chrisjen Avasarala",
          "Joe Miller",
          "Sadavir Errinwright",
          "Roberta Draper",
          "Julie Mao",
          "Col. Fredrick Lucius Johnson",
          "Camina Drummer",
          "Diogo",
          "Cotyar",
          "Jules-Pierre Mao",
          "Dr. Praxidike Meng",
          "Reverend Doctor Anna Volovodov",
          "Dr. Strickland",
          "Mei",
          "Sec-Gen Gillis",
          "Admiral Nguyen",
          "Admiral Souther",
          "Commander Klaes Ashford",
          "Clarissa Mao",
          "Octavia Muss",
          "Anderson Dawes",
          "Shed Garvey",
          "Arjun Avasarala"
        ],
        "locations": [
          "Earth",
          "Jupiter",
          "Luna",
          "Ganymede",
          "Europa",
          "Io",
          "Callisto",
          "Asteroid belt",
          "Ceres",
          "Eros",
          "Uranus",
          "Titania",
          "Saturn",
          "Titan",
          "Ilus system",
          "New Terra",
          "Sol system",
          "Mars",
          "Deimos",
          "Phobos",
          "Saturn",
          "Phoebe"
        ],
        "quotes": [
          "Give the Martians their water! Milowda na animals. You have every right to be angry. You should be angry. But if we act like animals, we only justify their belief that we are. Gif im fo imalowda xitim. Treat them the way they should treat us.",
          "You know what I love most about Mars? They still dream. We gave up. They're an entire culture dedicated to a common goal, working together as one to turn a lifeless rock into a garden. We had a garden and we paved it.",
          "My great uncle emigrated from Earth. He missed it terribly. He used to tell me stories when I was a little boy about these... endless blue skies, free air everywhere, open water all the way to the horizon. He told me that someday we would make Mars just like that. When you spend your whole life living under a dome, even the idea of an ocean seems impossible to imagine. I could never understand your people. Why, when the universe has bestowed so much upon you, you seem to care so little for it?",
          "Do you know it is possible to cry so hard that your tears turn to blood? And living with this pain, I came to realize that I have millions of brothers and sisters in the Belt. I even count you among them.",
          "Remember the Cant!",
          "War is an inherently unstable interaction with three things: Intense emotion, politics and luck. That message is luck. Maybe out here, away from all the politics and bullshit, luck opens the door and lets a couple of grunts figure out how not to fight, for once.",
          "They've launched the hybrids...",
          "Ma'am, for the first time in your life, please just shut the fuck up!",
          "This is Amos. He's my best friend in the whole world.",
          "I am that guy.",
          "The only way this can be stopped is out here, away from the politicians.",
          "I met your mother, Alice. When everyone else said you were a terrorist I went to find out for myself. Lovely woman. She thought I was full of shit, too, at first. She's well, happy for you, happy you're free. She told me when you were a boy, you wanted to be a knight.",
          "This isn't just about the war, we need to contain the protomolecule, make sure it doesn't fall into the wrong hands!",
          "When I first saw that thing outside, for a split second I thought I was hallucinating. But after hearing what went down in that lab, now I wish I kinda had been.",
          "But there's only one thing that I need to tell you. And it's the simplest thing. But it's the hardest thing to remember. Listen to your heart. No matter what. It'll always be the right call.",
          "I have stolen your secret, Fred Johnson. And I am giving it to the Belt.",
          "Either you're doing an incredibly shitty job or you're no longer in control of the people who work for you.",
          "I know a lady named Rocinante, she was good to me."
        ],
        "ships": [
          "Rocinante",
          "Nauvoo",
          "Donnager",
          "Anubis",
          "Kingfisher",
          "Kittur Chennamma",
          "Knight",
          "Koto",
          "Canterbury",
          "Lightbreaker",
          "Lucien",
          "Marasmus",
          "Aristophanes",
          "Nephthys",
          "Callisto's Dream",
          "Corvette",
          "S.A. Corey",
          "Schiaparelli",
          "Razorback",
          "Tanaka",
          "Hammurabi"
        ]
      },
      "the_fresh_prince_of_bel_air": {
        "actors": [
          "Quincy Jones",
          "Jay Leno",
          "Ronald Reagan",
          "Dick Clark",
          "Evander Holyfield",
          "Isaiah Thomas",
          "Heavy D",
          "Don Cornelius",
          "Kadeem Hardison",
          "Hugh M. Hefner",
          "Kareem Abdul-Jabbar",
          "Bo Jackson",
          "Ken Griffey Jr.",
          "Al B. Sure!",
          "John Ridley",
          "Doctor Dré",
          "Regis Philbin",
          "William Shatner",
          "B. B. King",
          "Kim Fields",
          "Arthel Neville",
          "Oprah Winfrey",
          "Donal J. Trump",
          "Leeza Gibbons",
          "Susan Powter",
          "Tempestt Bledsoe",
          "Kathie Lee Gifford",
          "Garcelle Beauvais",
          "Bree Walker"
        ],
        "characters": [
          "Will Smith",
          "Philip Banks",
          "Carlton Banks",
          "Ashley Banks",
          "Hilary Banks",
          "Vivian Banks",
          "Nicky Banks",
          "Geoffrey Butler",
          "Jazz",
          "Vy Smith",
          "Hattie Banks",
          "Lisa Wilkes",
          "Jackie Ames",
          "Henry Furth",
          "Trevor",
          "Tyriq",
          "Ice Tray",
          "Dee Dee",
          "Kellogg Lieberbaum",
          "Coach Smiley",
          "Judge Carl Robertson"
        ],
        "quotes": [
          "Girl, you look so good, I would marry your brother just to get in your family.",
          "In west Philadelphia born and raised, on the playground was where I spent most of my days.",
          "Might I say you rate a perfect 10 on my niftiness meter?",
          "Will, there's something you should know: Sometimes... parents just don't understand.",
          "Word up. This is gonna be cold, stupid on the serious tip.",
          "Any time you see a white guy in jail, you know he did something bad.",
          "Yo whassup, Jazz?",
          "I'd love to get a hold of you during a blackout.",
          "Your mouth is saying 'get out', but your eyes are saying 'get busy'.",
          "Come on baby, I'm saying bing bang bloozy, you and me in the jacuzzi. Whassup?",
          "I love a woman who's hard to get.",
          "Let's go get some barbecue and get busy.",
          "No way. Dude's got a gun. Next thing you know, I got six warning shots in my back.",
          "Miss Hilary, you can't go through life quitting everything. You never achieve anything unless you stick with something.",
          "That must be jam, 'cause jelly don't shake like that.",
          "Need some help with your African-American studies? We can go to my place and let freedom ring.",
          "Well, someone has her rude hat on tonight.",
          "Girl, if God created anything less beautiful than you, I hope He kept it for Himself.",
          "Maybe I sometimes say things that are selfish and self-centered, but that's who I am, dammit.",
          "I found that any game can be made interesting if you put some money on it.",
          "Carlton, I think you've been deprived of oxygen at birth.",
          "Hit the road, you little tramp!",
          "Sarcasm? Whatever do you mean?",
          "Between you and the humpty dance, I'll have to get a metal plate on my butt.",
          "Looks like you eat here often.",
          "My brother, you wanna take this outside?!?",
          "Opera? I thought she said Oprah.",
          "All this legal stuff won't work. The only legal phrase these people understand is 'will the defendant please rise.'",
          "Courage is being the way you are no matter what anybody says about you. Will teases me, but you don't see me goin' 'Yo, yo, yo, homey, yo.'",
          "Well you're so ugly that...uuhh...baby, you so fine.",
          "Ashley, look how much you've grown! Hilary, look how much you've grown! Carlton... hi.",
          "Ashley, if you found out the only person in the world who would go out with was mentally deranged, you'd go to bed too.",
          "All I see is you guys getting a fancy ride, a fancy ride in a free car.",
          "Oh, please, Vivian. You'd believe that boy if he told you that he was a big rap star whose album just went platinum.",
          "You've heard of the Batmobile, get a load of the Rapmobile!",
          "Hello darling...NO photographs!",
          "I'm from Philly. We had to save up to be poor.",
          "Carlton, skiing is for white guys named Sven, and O.J. Simpson.",
          "The system doesn't work. You have to blow the door down. Looks to me like you forgot that.",
          "Hurt me, hurt me! Whoa, whoa, whoa, whoa. What's up, baby?",
          "Whoa, whoa, whoa, now, baby, I noticed you noticing me and I just want to put you on notice that I noticed you too.",
          "I just want to let you know that I might let you consider being with me.",
          "Girl. I know your feet must be tired 'cause you been running through my mind all day. Come 'ere!",
          "Carlton, come on. Just because the baby is cute doesn't mean you're not the father.",
          "If I keep the motorcycle, I'm a pimp. If I give it back, I'm a damn fool. Oh, well, pimp it is!",
          "I always knew Will was gonna be the downfall of this family, but no one ever listens to me.",
          "Mirror, mirror, on the wall, Jean Claude Van Damn, I'm fine!",
          "Go, Will! Go, Will! Go, Will!",
          "My situation does not define who I am. I define who I am.",
          "I guess I can kiss heaven goodbye because it has got to be sin to look this good.",
          "You know what they say: Behind every successful man is a woman... or if you want to switch positions that's okay with me, too.",
          "Will is not a coat that you hang in the closet then pick it up when you're ready to wear it! His life goes on! He's not supposed to be there for you, you're supposed to be there for him!",
          "I so rarely have a woman scream my name. I was rather enjoying it.",
          "Don't tell me, 'cause if I know I can't say that I don't know when you get busted and Uncle Phil starts rounding up the usual suspects. And I am the usual suspects.",
          "What kind of idiot picks a password no one can guess?",
          "What is that, like the theme of this family? 'When in doubt, blame Will.'",
          "Well, you know, because guys grow beards and some women don't.",
          "I'm young and I'm restless. And I've only got one life to live, so I've got to follow my guiding light and search for tomorrow.",
          "There's a beautiful woman talking to me, but I don't expect you to understand that!",
          "EARTHQUAKE!",
          "Of all the rooms to burn in your uncle's home... the kitchen! Are you mad, boy?",
          "I exploit people everyday, but it's Thanksgiving so I'm taking a day off.",
          "Oh, don't worry, Carlton, we're all uncomfortable with your nudity.",
          "Oh, Geoffrey, I'm gonna miss you. Oh, we have to have a special going away dinner for you. What do you wanna make?",
          "Well, it's got ceiling-to-floor doors, and wall-to-wall floors.",
          "I'm definitely gonna miss you, C."
        ]
      },
      "the_it_crowd": {
        "actors": [
          "Chris O'Dowd",
          "Richard Ayoade",
          "Katherine Parkinson",
          "Matt Berry",
          "Christopher Morris",
          "Noel Fielding",
          "Graham Linehan",
          "Tom Binns",
          "Orlando Seal",
          "Belinda Stewart-Wilson",
          "Silas Carson",
          "David Garfield",
          "Adam Buxton",
          "Oliver Chris",
          "Frances Barber",
          "Amelia Bullmore",
          "Catherine Shepherd",
          "Philip Rham",
          "Cheryl Fergison",
          "Tony Longworth",
          "Togo Igawa",
          "Jamie Michie",
          "James Bachman",
          "Lucy Montgomery",
          "Danny Wallace",
          "Benedict Wong",
          "Sarah Hadland"
        ],
        "characters": [
          "Roy Trenneman",
          "Maurice Moss",
          "Jen Barber",
          "Douglas Reynholm",
          "Denholm Reynholm",
          "Richmond Avenal",
          "Beth Gaga Shaggy",
          "Nolan",
          "Peter File",
          "Barbara Reynholm",
          "Victoria Reynholm",
          "Derek Pippen",
          "Small Paul",
          "Bill Crouse",
          "Daniel Carey",
          "Dr. Mendall",
          "Helen Buley",
          "Jessica",
          "Johan",
          "Judy",
          "Dr. Julian Holmes",
          "Harry",
          "Mr. Yamamoto",
          "Philip",
          "Jeff Holcorn",
          "April Shephard",
          "Paul",
          "Harold Tong",
          "Margaret"
        ],
        "emails": [
          "roy.trenneman@reynholm.test",
          "maurice.moss@reynholm.test",
          "jen.barber@reynholm.test",
          "douglas.reynholm@reynholm.test",
          "denholm.reynholm@reynholm.test",
          "richmond.avenal@reynholm.test",
          "beth.gaga.shaggy@hotmail.test",
          "nolan@reynholm.test",
          "file.peter@hotmail.test",
          "barbara.reynholm@reynholm.test",
          "victoria.reynholm@reynholm.test",
          "derek.pippen@reynholm.test",
          "small.paul@reynholm.test",
          "bill.crouse@reynholm.test",
          "daniel.carey@reynholm.test",
          "mendall@reynholm.test",
          "helen.buley@bhdr.test",
          "jessica@hotmail.test",
          "johan@hotmail.test",
          "judy@reynholm.test",
          "stresspert@hotmail.test",
          "harry@royalmail.test",
          "yamamoto@yamamotocorp.test",
          "philip@reynholm.test",
          "jeffdominator@hotmail.test",
          "april.shephard@richestmag.test",
          "paul@reynholm.test",
          "htong@hotmail.test",
          "friendlymargaret@hotmail.test"
        ],
        "quotes": [
          "Hello, IT. Have you tried turning it off and on again?",
          "Hello, IT. Ya ha? Have you tried forcing an unexpected reboot?",
          "I'll just put it here with the rest of the fire.",
          "Yes, there is. I am sick of my things going walkabout. With this picture, everyone knows that a certain Mr Moss might be looking for his cup.",
          "Ugh, OK, well the button on the side, is it glowing?... Yeah, you need to turn it on. Erm, the button turns it on. Yeah, you... you do know how a button works don't you? No, not on clothes.",
          "See. the driver hooks the function by patching the system call table, so it's not safe to unload it unless another thread's about to jump in and do its stuff, and you don't want to end up in the middle of invalid memory... Hello?",
          "An ill wind is blowing. Last night I was stirred from my slumber by a crow calling three times. Caw... caw... well you know what a crow sounds like. Passing to my window, I trod on a piece of lego. Oh, it went right in the heel. Turning on my television set, I noticed the reception wasn't great. Not terrible, just not great. Hear me well, no good can come of your trip to the theatre tonight, no good at all. And if you ask me... That's just bloody rude. Where's my Heat?",
          "I don't know if it's the loss of blood or the melting plastic from the monitor, but I feel great!",
          "Didn't know what a stress machine as this morning, and now we have two of them.",
          "Now, let's see what we have here. 'Stand upright.' Well now I can't read it. Oh, not me. I AM a giddy goat.",
          "Jen, if this needle goes past here, you're fired. Does that make you feel stressed at all? Does it? Jen? Are you sure? Jen? Does it? Are you sure? Are you sure? Are you sure? Are you sure? Are you sure? Are you sure? Are you sure? Are you sure?",
          "I used to work as a waiter. If anyone was ever rude to me, I used to carry their food around in my trousers.",
          "Would I blow everyone's mind if I ate dessert first?",
          "It's a bucket of fried chicken. And it comes in a real bucket.",
          "Yes, I believe it was Tolstoy who said... Oh, it appears we have a visitor. I'm sorry, myself and Maurice were engaged in quite a serious discussion about books and such. We didn't hear you come in.",
          "Why are you speaking in that weird voice? When did...? I don't remember this conversation AT ALL.",
          "There's nothing sexual about it, I mean I like Roy, but I'm not 'Curious'.",
          "So, what brings you to my lair? Not that I'm some sort of animal. Or, or maybe I am.",
          "Oh look, Richmond's still alive.",
          "My middle name is ready. No, that doesn't sound right. I eat ready for breakfast.",
          "Fire. Dear Sir/Madam, I am writing to inform you of a fire that has broken out on the premises of 123 Cavendon Road... no, that's too formal. Fire - exclamation mark - fire - exclamation mark - help me - exclamation mark. 123 Cavendon Road. Looking forward to hearing from you. Yours truly, Maurice Moss.",
          "I don't like goat's anything. I don't like goats being involved in any stage of the food production process.",
          "This flipping circuit board, Jen. Some chump has run the data lines right through the power supply. Amateur hour! I've got tears in my eyes!",
          "They're fairly regular the beatings, yes. I'd say we're on a Bi-weekly beating",
          "OK, lady! You've won this round! But we can wait. You will slip up one day. And believe you me, we will be there when you do. There will be some piece of evidence that will prove without any shadow of a doubt that you don't know anything about computers!",
          "Team! Team, team, team, team, team! I even love saying the word 'team'. You probably think that's a picture of my family. Uh uh. It's the A-Team! Bodie, Doyle, Tiger, the Jewellery Man.",
          "Why are you giving me the secret signal to shut up?",
          "Oh, it's just water. Sometimes I get a hot ear, and this helps cool it down. She is quite the oddball.",
          "I hope this doesn't embarrass you, Jen, but I find the best thing to do with a new employee is to size them up with a long, hard stare...",
          "That's the sort of place this is, Jen. A lot of sexy people, not doing much work and having affairs!",
          "Well, don't take this the wrong way, but could he have thought you were a man?",
          "Ah! The IT-department. Run by a dynamic go-getter, a genius and a man from Ireland.",
          "You wouldn't shoot a Policeman and then steal his helmet. You wouldn't go to the toilet in his helmet, and then send it to the Policeman's grieving widow, and then steal it again. Downloading films is stealing; if you do it you WILL face the consequences!",
          "Ah, well, prepare to put mustard on those words, for you will soon be consuming them along with this slice of humble pie that comes direct from the oven of shame set at gas mark 'egg on your face'! I sort of forget what I was talking about.",
          "Oh... morning. Oh my word. When did the English start drinking like that? You people drink like you don't want to live.",
          "You best put seat belts on your ears, Roy, 'cause I'm going to take them for the ride of their life!",
          "Listen, Alistair, I just wanted to say, I'm not a window cleaner. No, no, I work in IT. Yeah, yeah, with computers and all that. Macs? No, I just really work with Windows. Hello?",
          "I'm a 32 year old IT consultant who works in the basement. Yes, I do the whole lonely hearts thing.",
          "I only know one woman and she just left the room shouting 'The shoes!'",
          "Nice screensaver. I love the way the smoke seems to be coming off the top of it...",
          "A plan. Let me put on my slightly larger glasses.",
          "Hello? What? Well if you can't work as a team you're all fired. That's it, you heard me, fired! Get your things and go. Hello, security? Everyone on floor 4 is fired. Escort them from the premises. And do it as a team. Remember, you're a team and if you can't act as a team, you're fired too. Dom, get on to recruitment. Get them to look for a security team that can work as a team. They may have to escort the current security team from the building for not acting like a team.",
          "Never been. But I've always liked the idea of the theatre. The smell of the grease, the roar of the paint. I've often thought if I hadn't ended up in computers, I would've gone into the theatre.",
          "If this evening is going to work in any way, you need to pretend to be normal people, yeah? Keep the conversation about things that would interest everybody. You know, nothing about memory, or RAM.",
          "Roy, I spoke to the Elders of the Internet not one hour ago. I told them about Jen winning Employee of the Month and they were so impressed that they wanted to do whatever they could to help.",
          "Well, I'm the boss... Head Honcho. El Numero Uno. Mr. Big. The Godfather. Lord of the Rings. The Bourne... Identity. Er... Taxi Driver. Jaws. I forgot the question quite a while back. Who are you, again?",
          "Yes! Yesterday's jam. That is what we are to them! Actually, that doesn't work as a thing, because, you know, jam lasts for ages.",
          "Did you notice how she didn't even get excited when she saw this original ZX81?",
          "Shut up, do what I tell you, I'm not interested; these are just some of the things you'll be hearing if you answer this ad. I'm an idiot and I don't care about anyone but myself. P.S. No dogs!",
          "Oh, I'm very comfortable with my sexuality, I just don't want to be slapped in the face with their sexuality.",
          "I'm sorry for your loss. Move on.",
          "It's not like you've lost a pen, is it? It's so much worse. Would you like a pen? I have a spare one.",
          "With all due respect John, I am the head of IT and I have it on good authority that if you type 'Google' into Google, you can break the Internet. So please, no one try it, even for a joke. It's not a laughing matter. You can break the Internet.",
          "Even if that were true, it's just not in their nature to learn how to use a ladder! They have wings! When a moth thinks about travelling vertically upwards, a ladder is just the last thing they would think of! Moss, I don't like to be negative about it, but everything you invent is worthless!",
          "You want me to open it. That's why you called me all the way up here, to open your laptop?",
          "Well, if someone called me a 'big, ugly builder', I'd be furious - and not just because I'm actually an IT consultant. Revenge, that would be uppermost on my mind: 'I'm going to wee on everything. I'm going to taint her abode. I'm going to strain my personal potatoes throughout her premises.'",
          "Just promise me we won't do anything else with them. I want to go back to being weird. I like being weird. Weird is all I've got. That and my sweet style.",
          "Balloons explode, Jen. They explode suddenly, and unexpectedly. They are filled with the capacity to give me a little fright, and I find that unbearable.",
          "I came here to drink milk and kick ass. And I've just finished my milk."
        ]
      },
      "the_office": {
        "characters": [
          "Michael Scott",
          "Dwight Schrute",
          "Jim Halpert",
          "Pam Beesly",
          "Ryan Howard",
          "Andy Bernard",
          "Robert California",
          "Roy Anderson",
          "Jan Levinson",
          "Stanley Hudson",
          "Kevin Malone",
          "Meredith Palmer",
          "Angela Martin",
          "Oscar Martinez",
          "Phyllis Vance",
          "Toby Flenderson",
          "Kelly Kapoor",
          "Creed Bratton",
          "Darryl Philbin",
          "Gabe Lewis",
          "Erin Hannon",
          "Holly Flax",
          "Nellie Bertram",
          "Clark Green",
          "Pete Miller",
          "Val Johnson",
          "Todd Packer",
          "Charles Miner",
          "Deangelo Vickers",
          "Ed Truck"
        ],
        "quotes": [
          "Everything I have I owe to this job… this stupid, wonderful, boring, amazing job.",
          "And I feel God in this Chili’s tonight.",
          "I talk a lot, so I’ve learned to tune myself out.",
          "Me think, why waste time say lot word, when few word do trick.",
          "I’m glad Michael’s getting help. He has a lot of issues, and he’s stupid.",
          "Dwight mercy-killed Angela’s cat.",
          "I’m not superstitious, but I am a little stitious.",
          "Look, it doesn’t take a genius to know that every organization thrives when it has two leaders. Go ahead, name a country that doesn’t have two presidents; a boat that sets sail without two captains. Where would Catholicism be without the popes?",
          "An office is for not dying. An office is a place to live life to the fullest, to the max, to… an office is a place where dreams come true.",
          "I got six numbers. One more and it would have been a complete phone number.",
          "Would I rather be feared or loved? Easy. Both. I want people to be afraid of how much they love me.",
          "Guess what, I have flaws. What are they? Oh, I don’t know. I sing in the shower. Sometimes I spend too much time volunteering. Occasionally I’ll hit somebody with my car. So sue me.",
          "The worst thing about prison was the dementors.",
          "Identity theft is not a joke, Jim! Millions of families suffer every year.",
          "Do I need to be liked? Absolutely not. I like to be liked. I enjoy being liked. I have to be liked, but it’s not like this compulsive need to be liked, like my need to be praised.",
          "I don’t talk trash, I talk smack. They’re totally different. Trash talk is hypothetical, like, 'Your mom is so fat she can eat the internet.' But smack talk is happening like right now. Like 'You’re ugly and I know it for a fact ’cause I got the evidence right there.'",
          "Life is short. Drive fast and leave a sexy corpse. That’s one of my mottos.",
          "I wonder what people like about me. Probably my jugs.",
          "Fool me once, strike one. Fool me twice, strike three.",
          "Sometimes the clothes at Gap Kids are too flashy, so I’m forced to go to the American Girl store and order clothes for large colonial dolls.",
          "Today, smoking is going to save lives.",
          "It is not a good time for me to lose my job since I have some pretty big long-term plans in my personal life with Pam that I’d like her parents to be psyched about. So, I am about to do something very bold in this job that I’ve never done before, try.",
          "How is it possible that in five years, I’ve had two engagements and only one chair?",
          "I guess I’ve been working so hard, I forgot what it’s like to be hardly working.",
          "Who says exactly what they’re thinking? What kind of a game is that?",
          "I’ve been involved in a number of cults, both a leader and a follower. You have more fun as a follower, but you make more money as a leader.",
          "I am running away from my responsibilities. And it feels good.",
          "We have a gym at home. It’s called the bedroom.",
          "I don’t hate it. I just don’t like it at all and it’s terrible.",
          "The people here are amazing debaters. I guess you can say they are master-baters.",
          "When you’re a kid, you assume your parents are soulmates. My kids are going to be right about that.",
          "And I knew exactly what to do. But in a much more real sense, I had no idea what to do.",
          "I find the mystery genre disgusting. I hate being titillated.",
          "I wanted to eat a pig in a blanket, in a blanket.",
          "As a person who buys a lot of erotic cakes, it’s nice to be represented on one.",
          "Tell him to call me ASAP as possible.",
          "Ultimatums are key. Basically, nobody does anything for me anymore unless I threaten to kill myself.",
          "I love inside jokes. I’d love to be a part of one someday.",
          "I want to be wine and dined and sixty-nined.",
          "Dwight you ignorant slut.",
          "Close your mouth, sweetie. You look like a trout.",
          "Any man who says he totally understands women is a fool. Because they are un-understandable.",
          "Why are you the way that you are? Honestly, every time I try to do something fun, or exciting, you make it… not that way. I hate… so much about the things that you choose to be.",
          "So you’ve come to the master for guidance? Is this what you’re saying, grasshopper?",
          "Right now, this is just a job. If I advance any higher in this company, this would be my career. And, uh, if this were my career, I’d have to throw myself in front of a train.",
          "Boy, have you done lost your mind? Cause I’ll help you find it!",
          "Ain’t no party like a Scranton party cause a Scranton party don’t stop!"
        ]
      },
      "the_room": {
        "actors": [
          "Tommy Wiseau",
          "Juliette Danielle",
          "Greg Sestero",
          "Philip Haldiman",
          "Carolyn Minnott",
          "Robyn Paris",
          "Scott Holmes",
          "Dan Janjigian",
          "Kyle Vogt",
          "Greg Ellery"
        ],
        "characters": [
          "Johnny",
          "Lisa",
          "Mark",
          "Denny",
          "Claudette",
          "Michelle",
          "Mike",
          "Chris-R",
          "Peter",
          "Steven"
        ],
        "locations": [
          "Johnny's Place",
          "Rooftop",
          "Park",
          "Alley",
          "Flower Shop",
          "Claudette's Place"
        ],
        "quotes": [
          "Oh hi, Denny",
          "Anything for my princess! Ha-ha-ha-ha.",
          "Denny, two's great, but three's a crowd. Ha-ha.",
          "Oh hi, Johnny, I didn't know it was you.",
          "Here you go, keep the change. Hi doggy!",
          "You're my favorite customer",
          "I just want to talk to Johnny. You look beautiful today. Can I kiss you?",
          "I got the results of the test back. I definitely have breast cancer.",
          "Did you, uh, know, that chocolate is the symbol of love?",
          "Where’s my money, Denny?",
          "Denny, what kind of money, just tell me!",
          "What kind of drugs, Denny?",
          "I did not hit her! It’s not true! It’s bullshit! I did not hit her! I did not! Oh, hi Mark.",
          "A-ha-ha-ha! What a story, Mark!",
          "You can love someone deep inside your heart, and there is nothing wrong with it. If a lot of people loved each other, the world would be a better place to live.",
          "I never hit you. You shouldn’t have any secrets from me. I’m your future husband.",
          "Why Lisa, why Lisa, please talk to me, please! You’re part of my life, you are everything, I could not go on without you, Lisa.",
          "You’re lying, I never hit you. You are tearing me apart, Lisa!",
          "Do you understand life? Do you?",
          "Oh hi, Mike, what’s new?",
          "Oh hey, Denny.",
          "How can they say this about me? I don’t believe it. I show them. I will record everything.",
          "You know what they say: love is blind.",
          "Ha-ha-ha, chicken, Peter, you’re just a little chicken! Cheep, cheep cheep cheep cheep chee-ee-ee-eep eeeeeeeeeeee!",
          "Oh, hi Denny. Nice tux, you look great.",
          "You look great. You look a babyface.",
          "Oh hi, Susan.",
          "We got a new client at the bank, we make a lot of money.",
          "Anyway, how is your sex life?",
          "Oh hi, Claudette. Bye!",
          "You betrayed me, you’re not good, you’re just a chicken, cheep-cheep-cheep-cheep-cheep.",
          "It’s not over! Everybody betray me! I fed up with this world!",
          "How could you do this to me?! I gave you seven years of my life! And you betray me.",
          "Aughhhhhhhh!!! Everybody betray me. I don’t have a friend in the world.",
          "As far as I’m concerned, you can drop off the earth. That’s a promise"
        ]
      },
      "the_thick_of_it": {
        "characters": [
          "Malcolm Tucker",
          "Hugh Abbot",
          "Nicola Murray",
          "Oliver Reeder",
          "Cliff Lawton",
          "Dan Miller",
          "Geoff Holhurst",
          "Jamie MacDonald",
          "Julius, Rt Hon The Lord Nicholson of Arnage",
          "Nick Hanway",
          "Tom Davis",
          "Clare Ballentine",
          "Ben Swain",
          "Ed Atkins",
          "John Duggan",
          "Steve Fleming",
          "Helen Hatley",
          "Sam Cassidy",
          "Terri Coverley",
          "Robyn Murdoch",
          "Peter Mannion",
          "Dr Stewart Pearson",
          "Fergus Williams",
          "Emma Florence Messinger",
          "Philip Bartholomew Cornelius Smith",
          "Glenn Cullen",
          "Adam Kenyon",
          "Cal Richards",
          "Mary Drake",
          "Lord Goolding",
          "Baroness Sureka",
          "Simon Weir",
          "Matthew Hodge",
          "The PM",
          "Tom Davis",
          "JB",
          "Pat Morrissey",
          "Douglas Tickel"
        ],
        "departments": [
          "Number 10",
          "DoSAC",
          "Shadow Cabinet",
          "Department of Defense",
          "House of Lords",
          "Education Select Committee",
          "Department of Immigration",
          "Department of Education",
          "Department of Fisheries",
          "Cabinet Office"
        ],
        "positions": [
          "General Elections Advisor",
          "Director of Communications",
          "Former Media Adviser to the Leader of the Opposition",
          "MP",
          "Secretary of State for Social Affairs",
          "Secretary of State for Social Affairs and Citizenship",
          "Former Leader of the Opposition",
          "Director of Communications for the Opposition",
          "Policy Adviser to the Leader of the Opposition",
          "Special Adviser/Junior Policy Adviser to the Secretary of State, DoSAC",
          "Backbench MP",
          "Junior Minister",
          "Minister of State for Defense",
          "Shadow Cabinet Minister",
          "Senior Press Officer",
          "Head of Advanced Implementation Unit",
          "Spin Doctor",
          "Chair",
          "Minister of State for Immigration",
          "Minister of State at the Department of Education",
          "Press Officer",
          "Party Press Officer",
          "Chief Whip",
          "Special Adviser to the Leader of the Opposition",
          "Personal Assistant",
          "Minister for Fisheries",
          "Policy Adviser to the Shadow Secretary of State",
          "Researcher for the Shadow Secretary of State",
          "Adviser, Fourth Sector Initiative",
          "Chief Strategist",
          "Minister of State",
          "Prime Minister of the United Kingdom"
        ]
      },
      "theater": {
        "adult_musical": [
          "Elton John and Tim Rice's Aida",
          "Ain't Misbehavin'",
          "Aladdin (Prince Street Players Version)",
          "Disney's Aladdin Dual Language Edition",
          "Alice in Wonderland (Prince Street Players Version)",
          "All in Love",
          "The All Night Strut!",
          "The All Night Strut! A Jumpin' Jivin' Jam",
          "Amen Corner",
          "Green Day's American Idiot",
          "Annabelle Broom, The Unhappy Witch",
          "Anne of Green Gables",
          "Annie",
          "Annie Warbucks",
          "The Ant and the Elephant",
          "Anyone Can Whistle",
          "The Apple Tree",
          "Archy & Mehitabel",
          "Assassins",
          "Avenue Q",
          "Baby",
          "Back to the 80's",
          "The Baker's Wife",
          "Band Geeks",
          "Band Geeks-Expanded Cast Version",
          "Disney's Beauty and the Beast",
          "Bendigo Boswell",
          "Berlin to Broadway with Kurt Weill A Musical Voyage",
          "Big The Musical",
          "Billy Elliot The Musical",
          "Birds of Paradise",
          "Blame It on the Movies!",
          "Bloody Bloody Andrew Jackson",
          "Blues in the Night",
          "Bonnie & Clyde",
          "Sandy Wilson's The Boy Friend",
          "Brandon Finds His Star",
          "The Bridges of Madison County",
          "Brigadoon",
          "Bring in the Morning",
          "Bring It On The Musical",
          "Bugsy Malone",
          "Bullets over Broadway The Musical",
          "The Burnt Part Boys",
          "By the Beautiful Sea",
          "Camelot",
          "Disney's Camp Rock: The Musical",
          "Candide (1974 Version)",
          "Candide (1999 Version)",
          "Canterbury Tales",
          "Captain Stirrick",
          "Caroline, or Change",
          "Dr. Seuss's The Cat in the Hat",
          "Catch Me If You Can",
          "Celebration",
          "A Charles Dickens Christmas",
          "Children of Eden",
          "Chitty Chitty Bang Bang",
          "A Christmas Carol (Broadway Version)",
          "The Christmas Schooner",
          "Cinderella (Prince Street Players Version)",
          "The Civil War",
          "Maltby and Shire's Closer Than Ever",
          "Colette Collage",
          "Come from Away",
          "Company",
          "Barry Manilow's Copacabana",
          "Cry-Baby",
          "Cyrano",
          "Daddy Long Legs",
          "Damn Yankees",
          "The Day Before Spring",
          "Dear Edwina",
          "Dessa Rose",
          "Dirty Rotten Scoundrels",
          "Disaster!",
          "Disco Inferno",
          "Divorce Me, Darling!",
          "Do You Wanna Dance?",
          "Doctor Dolittle",
          "Dogfight",
          "Downriver",
          "Dracula The Musical",
          "Drake",
          "The Drowsy Chaperone",
          "The Drunkard",
          "Edges",
          "Elephant & Piggie's 'We Are in a Play!'",
          "Elf The Musical",
          "The Emperor's New Clothes (Ahrens & Flaherty's)",
          "The Emperor's New Clothes (Prince Street Players Version)",
          "Ernest in Love",
          "Eubie!",
          "Fame The Musical",
          "A Family Affair",
          "The Fantasticks",
          "Fiddler on the Roof",
          "Fiorello!",
          "Five Guys Named Moe",
          "The Fix",
          "Follies",
          "Follies (Concert Version)",
          "Footprints on the Moon",
          "Forever Plaid",
          "Forever Plaid: Plaid Tidings",
          "4 Guys Named Jose... and una Mujer Named Maria",
          "Frankly Ben",
          "Freaky Friday",
          "Freckleface Strawberry The Musical",
          "Freckleface Strawberry The Musical (Expanded Version)",
          "Freedom Train",
          "The Frogs",
          "The Full Monty",
          "A Funny Thing Happened on the Way to the Forum",
          "The Game of Love",
          "A Gentleman's Guide to Love and Murder",
          "The Glorious Ones",
          "Kurt Vonnegut's God Bless You, Mr. Rosewater",
          "Godspell",
          "Godspell 2012",
          "Goldilocks and the Three Bears",
          "The Goodbye Girl",
          "Grand Hotel: The Musical",
          "Greenwillow",
          "Guys and Dolls",
          "Guys and Dolls (Concert Version)",
          "Hairspray",
          "Harry Connick, Jr.'s The Happy Elf",
          "Happy Hunting",
          "Heidi",
          "Hello! My Baby",
          "Disney's High School Musical 2",
          "Disney's High School Musical 2 (One-Act Version)",
          "Disney's High School Musical",
          "Disney's High School Musical (One-Act Version)",
          "Honeymoon in Vegas",
          "Honk!",
          "Hot Mikado",
          "How to Succeed in Business without Really Trying",
          "The Hunchback of Notre Dame",
          "I Do! I Do!",
          "I Do! I Do! I Do! I Do!",
          "If/Then",
          "In the Beginning",
          "Into the Woods",
          "It Shoulda Been You",
          "Jack & the Beanstalk (Prince Street Players Version)",
          "Jack Spratt, VC",
          "Roald Dahl's James and the Giant Peach",
          "Jane Eyre",
          "Jekyll & Hyde",
          "Jekyll and Hyde (Youth Version)",
          "John & Jen",
          "Junie B. Jones, The Musical",
          "Just So",
          "Kean",
          "Kinky Boots",
          "Kismet",
          "Knuffle Bunny: A Cautionary Musical",
          "Lady Audley's Secret",
          "The Last Five Years",
          "Leap of Faith",
          "Legally Blonde The Musical",
          "Les Misérables",
          "Les Petits Rats",
          "Let 'Em Eat Cake",
          "Let 'Em Eat Cake (Concert Version)",
          "Disney's The Little Mermaid",
          "Little Miss Sunshine",
          "A Little Night Music",
          "A Little Princess",
          "Little Shop of Horrors",
          "Little Women",
          "Loserville",
          "Love's Labour's Lost",
          "Loving Repeating",
          "Lucky in the Rain",
          "Lucky Stiff",
          "Magdalena",
          "The Main Street Kids' Club: A MathStart Musical",
          "Make Me a Song: The Music of William Finn",
          "Mamma Mia!",
          "A Man of No Importance",
          "Marry Me a Little",
          "Disney and Cameron Mackintosh's Mary Poppins",
          "Roald Dahl's Matilda The Musical",
          "Merrily We Roll Along",
          "Meredith Willson's Miracle on 34th Street The Musical",
          "Mirette",
          "Miss Saigon",
          "Miss Saigon School Edition",
          "Moby Dick! The Musical",
          "The Most Happy Fella",
          "The Adventures of Mr. Toad",
          "Murder Ballad",
          "The Music Man",
          "The Music Man (Concert Version)",
          "My Fair Lady",
          "My Favorite Year",
          "Disney's My Son Pinocchio: Geppetto's Musical Tale",
          "New Girl in Town",
          "Newsies",
          "Next to Normal",
          "9 to 5 The Musical",
          "The No-Frills Revue",
          "Of Thee I Sing",
          "Of Thee I Sing (Concert Version)",
          "Oh, Coward!",
          "Oil City Symphony",
          "Oliver!",
          "Once",
          "Once on This Island",
          "Pacific Overtures",
          "Paint Your Wagon ",
          "The Pajama Game",
          "Parade",
          "Passion",
          "Peter and the Starcatcher",
          "Peter Pan (1954 Broadway Version)",
          "Phantom of the Country Opera",
          "The Phantom Tollbooth",
          "Philemon",
          "Pinocchio (Prince Street Players Version)",
          "Pippin",
          "The Pirates of Penzance",
          "A Pocketful of Rhymes (Prince Street Players Version)",
          "Portable Pioneer and Prairie Show",
          "The Prince and the Pauper",
          "The Producers",
          "Putting It Together (1993 MTC Version)",
          "Putting It Together (1999 Broadway Version)",
          "Quilt, A Musical Celebration",
          "The Ragged Child",
          "Ragtime (Version 1)",
          "Ragtime (Version 2)",
          "Ragtime School Edition",
          "Rapunzel",
          "Red Hot and Cole",
          "Redhead",
          "Rent",
          "Rent School Edition",
          "Riverwind",
          "Road Show",
          "Roadside",
          "The Robber Bridegroom",
          "Rock Nativity",
          "The Roman Invasion of Ramsbottom",
          "The Rothschilds",
          "Salvation",
          "Saturday Night",
          "Schoolhouse Rock Live Too!",
          "Schoolhouse Rock Live!",
          "The Scottsboro Boys",
          "Scrooge, The Stingiest Man in Town",
          "Secrets Every Smart Traveler Should Know",
          "Seussical",
          "Seven Brides for Seven Brothers",
          "1776",
          "She Loves Me",
          "SHOUT! The Mod Musical",
          "Showtune: Celebrating the Words & Music of Jerry Herman",
          "Shrek The Musical",
          "Side by Side by Sondheim",
          "Singin' in the Rain",
          "Sister Act",
          "Six Women with Brain Death or Expiring Minds Want to Know ",
          "Sleeping Beauty (Prince Street Players Version)",
          "Smike",
          "Snapshots: A Musical Scrapbook",
          "Snow White Goes West (Prince Street Players Version)",
          "Snow White, Rose Red (and Fred)",
          "Something Rotten!",
          "Sondheim on Sondheim",
          "Songs for a New World",
          "The Sound of Plaid: The Glee Club Version of Forever Plaid",
          "Spring Awakening",
          "Starting Here, Starting Now",
          "The Story of My Life",
          "Strike up the Band",
          "Strike up the Band (Concert Version)",
          "Sunday in the Park with George",
          "Sweeney Todd",
          "Sweeney Todd School Edition",
          "Talent Springs Eternal - Fame Forever",
          "Tarzan",
          "Teddy & Alice",
          "Tenderloin",
          "The Theory of Relativity",
          "13",
          "The Thirteen Clocks",
          "13 Daughters",
          "Thoroughly Modern Millie",
          "The Three Little Pigs",
          "Tick, Tick... Boom!",
          "Timbuktu!",
          "Tin Pan Ali",
          "Tintypes",
          "The Adventures of Tom Sawyer",
          "Tomfoolery",
          "The Who's Tommy",
          "The Toxic Avenger",
          "Treasure Island (Prince Street Players Version)",
          "Triumph of Love",
          "The 25th Annual Putnam County Spelling Bee",
          "The Unsinkable Molly Brown",
          "Urinetown",
          "The Velveteen Rabbit",
          "Violet",
          "The Wedding Singer",
          "West Side Story",
          "Western Star",
          "What about Luv?",
          "When the Cookie Crumbles, You Can Still Pick up the Pieces ",
          "Where's Charley?",
          "Andrew Lippa's Wild Party",
          "Wildcat on Safari",
          "Roald Dahl's Willy Wonka",
          "Wish You Were Here",
          "Witches of Eastwick",
          "The Wizard of Oz (Prince Street Players Version)",
          "Women on the Verge of a Nervous Breakdown",
          "Wonderland High",
          "Working",
          "Working (2012 Revised Version)",
          "The World Goes 'Round",
          "Xanadu",
          "A Year with Frog and Toad",
          "You're Gonna Love Tomorrow",
          "Young Frankenstein"
        ],
        "kids_musical": [
          "Disney's Aladdin JR.",
          "Disney's Aladdin KIDS",
          "Disney's Alice in Wonderland JR.",
          "Annie JR.",
          "Annie KIDS",
          "Disney's The Aristocats KIDS",
          "Disney's Beauty and the Beast JR.",
          "Bugsy Malone JR.",
          "Captain Louie JR.",
          "Chitty Chitty Bang Bang JR. ",
          "Disney's Cinderella KIDS",
          "Dear Edwina JR.",
          "Doctor Dolittle JR.",
          "Elf The Musical JR.",
          "Fame The Musical JR.",
          "Fiddler on the Roof JR.",
          "Finian's Rainbow JR.",
          "The Musical Adventures of Flat Stanley JR.",
          "Godspell JR.",
          "Guys and Dolls JR.",
          "Hairspray JR.",
          "Disney's High School Musical 2 JR.",
          "Disney's High School Musical JR.",
          "Honk! JR.",
          "Into the Woods JR.",
          "Roald Dahl's James and the Giant Peach JR.",
          "Disney's The Jungle Book KIDS",
          "Junie B. Jones The Musical JR. ",
          "Legally Blonde The Musical JR.",
          "Disney's The Lion King JR.",
          "Disney's The Lion King KIDS",
          "Disney's The Little Mermaid JR.",
          "Madagascar - A Musical Adventure JR.",
          "Magic Tree House: A Ghost Tale for Mr. Dickens JR.",
          "Magic Tree House: Dinosaurs before Dark KIDS",
          "Magic Tree House: Pirates Past Noon KIDS ",
          "Magic Tree House: The Knight at Dawn KIDS",
          "Disney and Cameron Mackintosh's Mary Poppins JR. ",
          "Disney's Mulan JR.",
          "The Music Man JR.",
          "The Music Man KIDS",
          "Disney's My Son Pinocchio JR.",
          "Once on This Island JR.",
          "Disney's 101 Dalmatians KIDS",
          "Peter Pan JR.",
          "Disney's Peter Pan JR.",
          "The Phantom Tollbooth JR.",
          "The Pirates of Penzance JR.",
          "Schoolhouse Rock Live! JR.",
          "Seussical JR.",
          "Seussical KIDS",
          "Shrek The Musical JR.",
          "Singin' in the Rain JR.",
          "Disney's Sleeping Beauty KIDS",
          "Thoroughly Modern Millie JR.",
          "Roald Dahl's Willy Wonka JR.",
          "Roald Dahl's Willy Wonka KIDS",
          "Disney's Winnie the Pooh KIDS",
          "Xanadu JR.",
          "A Year with Frog and Toad KIDS",
          "Elton John and Tim Rice's Aida School Edition",
          "Avenue Q School Edition",
          "Les Misérables School Edition",
          "Big The Musical TYA",
          "Captain Louie TYA",
          "Chitty Chitty Bang Bang TYA",
          "Curious George: The Golden Meatball TYA",
          "The Musical Adventures of Flat Stanley TYA",
          "Roald Dahl's James and the Giant Peach TYA",
          "Madagascar - A Musical Adventure TYA",
          "The Phantom Tollbooth TYA",
          "Seussical TYA",
          "Shrek The Musical TYA",
          "The Adventures of Tom Sawyer TYA",
          "Roald Dahl's Willy Wonka TYA",
          "A Year with Frog and Toad TYA"
        ],
        "play": [
          "A-Haunting We Will Go",
          "A Counterfeit Presentment",
          "A Delicate Balance",
          "A Streetcar Named Desire",
          "A Memory of Two Mondays",
          "A View from the Bridge",
          "After the Fall",
          "Agnes of God",
          "The Aliens",
          "All Because of Agatha",
          "All My Sons",
          "All New People",
          "All the Way",
          "All the Way Home",
          "The American Clock",
          "The American Dream",
          "The American Way",
          "And Still I Rise",
          "Anna Christie",
          "Anne of the Thousand Days",
          "And Things That Go Bump in the Night",
          "As You Like It, or Anything You Want To",
          "Awake and Sing!",
          "Bad Habits",
          "Battle of Angels",
          "Black Nativity",
          "Born Yesterday",
          "Botticelli",
          "Bride of Brackenloch",
          "Bringing It All Back Home",
          "Broken Glass",
          "Bullets Over Broadway",
          "By the Sea",
          "Candles to the Sun",
          "Cat on a Hot Tin Roof",
          "The Cocktail Party",
          "Come on Strong",
          "The Confidential Clerk",
          "The Cop and the Anthem",
          "Corpus Christi",
          "The Creation of the World and Other Business",
          "The Crucible",
          "Death",
          "Death of a Salesman",
          "The Death of Bessie Smith",
          "Dedication or The Stuff of Dreams",
          "Desire Under the Elms",
          "Deuce",
          "Diary of a Mad Black Woman",
          "Dinner at Eight",
          "Don't Drink the Water",
          "Don't Go Away Mad",
          "Don't You Want to be Free?",
          "The Egotist",
          "The Elder Statesman",
          "Elmer and Lily",
          "Emma",
          "The Emperor Jones",
          "Emperor of Haiti",
          "Faith of Our Fathers",
          "The Family Reunion",
          "The Feast of Ortolans",
          "Fortitude",
          "The Fifth Column",
          "Finishing the Picture",
          "The Floating Light Bulb",
          "The Flying Machine: A One-Act Play for Three Men",
          "Frankie and Johnny in the Clair de Lune",
          "Fugitive Kind",
          "God",
          "Gods of the Lightning",
          "The Golden Years",
          "The Great God Brown",
          "The Great Disobedience",
          "The Grass Still Grows",
          "Gypsy",
          "The Hairy Ape",
          "The Half-Bridge",
          "Happy Birthday, Wanda June",
          "Hello Out There",
          "Hidden Agendas",
          "High Tor",
          "Honors at Dawn",
          "I Think About You a Great Deal",
          "In Abraham's Bosom",
          "Incident at Vichy",
          "It's Only a Play",
          "Jerico-Jim Crow",
          "Jim Dandy",
          "Key Largo",
          "Knickerbocker Holiday",
          "The Last Yankee",
          "The Leather Apron Club",
          "Lettering",
          "Lips Together, Teeth Apart",
          "The Lisbon Traviata",
          "Listen My Children (1939",
          "Little Ham",
          "The Live Wire",
          "The Lost Colony",
          "Love! Valour! Compassion!",
          "The Maid of Arran",
          "The Man Who Had All the Luck",
          "Master Class",
          "The Masque of Kings",
          "Mary of Scotland",
          "The Meadow",
          "Mockingbird (2003",
          "Mourning Becomes Electra",
          "Mr Peter's Connections",
          "Mule Bone",
          "Murder in the Cathedral",
          "My Heart's in the Highlands",
          "Next",
          "Night Over Taos",
          "Night Riders",
          "No Villain",
          "Noon (1968), second segment of Morning, Noon and Night",
          "The Odd Couple",
          "Once Upon a Single Bound",
          "Our Mrs. McChesney",
          "Outside Looking In",
          "The Ox-Bow Incident (1976), adapted by Jim Beaver",
          "The Parsley Garden",
          "The Petrified Forest",
          "Pillar of Fire and Other Plays",
          "Play It Again, Sam",
          "Prelude and Liebestod",
          "Pressing Engagements",
          "The Price",
          "The Rat Race",
          "Resurrection Blues",
          "The Ride Down Mt. Morgan",
          "The Ritz",
          "The Rock",
          "The Royal Family",
          "Saturday's Children",
          "Second Overture",
          "Semper Fi",
          "Sidekick",
          "Simply Heavenly",
          "The Slaughter of the Innocents",
          "The Smile of the World",
          "Some Men",
          "Something Cloudy, Something Clear",
          "Spades",
          "Stage Door",
          "Starstruck",
          "The Stendhal Syndrome",
          "The Stolen Secret",
          "Subway Circus",
          "Summer and Smoke",
          "The Sunshine Boys",
          "The Sleeping Car",
          "The Star-Wagon",
          "Sweeney Agonistes",
          "Sweet Eros",
          "Talking to You",
          "Tambourines to Glory",
          "They Too Arise",
          "The Time of Your Life",
          "They're Made Out of Meat",
          "Troubled Island",
          "Truth, Justice, and the Texican Way",
          "Two for the Seesaw",
          "Valley Forge",
          "Van Zorn",
          "Vanya and Sonia and Masha and Spike",
          "Verdigris",
          "The Very First Christmas Morning",
          "Visit to a Small Planet",
          "Visiting Mr. Green",
          "Weekend",
          "What Price Glory",
          "Where Has Tommy Flowers Gone?",
          "Whigs, Pigs, and Greyhounds",
          "Whiskey",
          "White Desert",
          "Who's Afraid of Virginia Woolf?",
          "The Wingless Victory",
          "Winterset",
          "The Wonderful Ice Cream Suit and Other Plays",
          "You're Welcome America (2009)",
          "Zero Hour",
          "Zorro in Hell",
          "The Zoo Story"
        ]
      },
      "tolkien": {
        "characters": [
          "Adalbert Bolger",
          "Adaldrida Bolger",
          "Adalgar Bolger",
          "Adalgrim Took",
          "Adam Hornblower",
          "Adamanta Chubb",
          "Adanel",
          "Adelard Took",
          "Adrahil",
          "Aegnor",
          "Aerin",
          "Agathor",
          "Aghan",
          "Aglahad",
          "Ailinel",
          "Aldamir",
          "Aldor",
          "Alfrida of the Yale",
          "Algund",
          "Almarian",
          "Almáriel",
          "Almiel",
          "Alphros",
          "Amandil",
          "Amaranth Brandybuck",
          "Amarië",
          "Amdír",
          "Amethyst Hornblower",
          "Amlach",
          "Amlaith",
          "Amras",
          "Amrod",
          "Amroth",
          "Amrothos",
          "Anairë",
          "Anardil",
          "Anborn",
          "Ancalagon",
          "Andreth",
          "Andróg",
          "Andvír",
          "Andwise Roper",
          "Angamaitë",
          "Angbor",
          "Angelica Baggins",
          "Angelimir",
          "Angrim",
          "Angrod",
          "Annael",
          "Anson Roper",
          "Ar-Adûnakhôr",
          "Ar-Gimilzôr",
          "Ar-Pharazôn",
          "Ar-Sakalthôr",
          "Ar-Zimrathôn",
          "Arachon",
          "Arador",
          "Araglas",
          "Aragorn",
          "Aragost",
          "Arahad",
          "Arahael",
          "Aranarth",
          "Arantar",
          "Aranuir",
          "Aranwë",
          "Araphant",
          "Araphor",
          "Arassuil",
          "Aratan",
          "Arathorn",
          "Araval",
          "Aravir",
          "Aravorn",
          "Arciryas",
          "Ardamir",
          "Aredhel",
          "Argeleb",
          "Argon",
          "Argonui",
          "Arminas",
          "Artamir",
          "Arthad",
          "Arvedui",
          "Arvegil",
          "Arveleg",
          "Arwen",
          "Asgon",
          "Asphodel Brandybuck",
          "Atanalcar",
          "Atanatar",
          "Aulendil",
          "Avranc",
          "Axantur",
          "Azaghâl",
          "Azog",
          "Bain",
          "Balbo Baggins",
          "Baldor",
          "Balin",
          "Ban",
          "Bandobras Took",
          "Barach",
          "Baragund",
          "Barahir",
          "Baran",
          "Baranor",
          "Bard",
          "Barliman Butterbur",
          "Basso Boffin",
          "Beechbone",
          "Belba Baggins",
          "Beldir",
          "Beldis",
          "Belecthor",
          "Beleg",
          "Belegor",
          "Belegorn",
          "Belegund",
          "Belemir",
          "Belen",
          "Beleth",
          "Bell Goodchild",
          "Belladonna Took",
          "Bëor",
          "Beorn",
          "Bereg",
          "Beregar",
          "Beregond",
          "Berelach",
          "Beren",
          "Bergil",
          "Beril",
          "Berilac Brandybuck",
          "Bert",
          "Berúthiel",
          "Berylla Boffin",
          "Bifur",
          "Bilbo Baggins",
          "Bilbo Gardner",
          "Bill Butcher",
          "Bill Ferny",
          "Bingo Baggins",
          "Blanco Bracegirdle",
          "Blodren",
          "Boar of Everholt",
          "Bodo Proudfoot",
          "Bodruith",
          "Bofur",
          "Bolg",
          "Bombur",
          "Bór",
          "Borin",
          "Borlach",
          "Borlad",
          "Borlas",
          "Boromir",
          "Boron",
          "Borondir",
          "Borthand",
          "Bosco Boffin",
          "Bowman Cotton",
          "Brand",
          "Brandir",
          "Bregil",
          "Brego",
          "Bregolas",
          "Bregor",
          "Briffo Boffin",
          "Brodda",
          "Bruno Bracegirdle",
          "Brytta",
          "Bucca of the Marish",
          "Buffo Boffin",
          "Buldar",
          "Bungo Baggins",
          "Calimehtar",
          "Calimmacil",
          "Caliondo",
          "Calmacil",
          "Camellia Sackville",
          "Caranthir",
          "Carc",
          "Carcharoth",
          "Carl Cotton",
          "Castamir",
          "Celeborn",
          "Celebrían",
          "Celebrimbor",
          "Celebrindor",
          "Celegorm",
          "Celepharn",
          "Cemendur",
          "Ceorl",
          "Chica Chubb",
          "Círdan",
          "Cirion",
          "Ciryandil",
          "Ciryatur",
          "Ciryon",
          "Cora Goodbody",
          "Cotman",
          "Cottar",
          "Curufin",
          "Daddy Twofoot",
          "Daeron",
          "Dagnir",
          "Dáin",
          "Dáin Ironfoot",
          "Dairuin",
          "Daisy Baggins",
          "Daisy Gamgee",
          "Daisy Gardner",
          "Damrod",
          "Denethor",
          "Déor",
          "Déorwine",
          "Dernhelm",
          "Derufin",
          "Dervorin",
          "Diamond of Long Cleeve",
          "Dina Diggle",
          "Dinodas Brandybuck",
          "Dior",
          "Dírhael",
          "Dírhaval",
          "Dís",
          "Doderic Brandybuck",
          "Dodinas Brandybuck",
          "Donnamira Took",
          "Dora Baggins",
          "Dori",
          "Dorlas",
          "Draugluin",
          "Drogo Baggins",
          "Druda Burrows",
          "Dudo Baggins",
          "Duilin",
          "Duinhir",
          "Dúnhere",
          "Durin",
          "Durin's Bane",
          "Dwalin",
          "Eärendil",
          "Eärendur",
          "Eärnil",
          "Eärnur",
          "Eärwen",
          "Ebor",
          "Ecthelion",
          "Edrahil",
          "Egalmoth",
          "Eglantine Banks",
          "Eilinel",
          "Elanor Gardner",
          "Elatan",
          "Elboron",
          "Eldacar",
          "Eldalótë",
          "Eldarion",
          "Elemmakil",
          "Elemmírë",
          "Elendil",
          "Elendur",
          "Elentir",
          "Elenwë",
          "Elfhelm",
          "Elfhild",
          "Elfstan Fairbairn",
          "Elfwine",
          "Elladan",
          "Elmar",
          "Elmo",
          "Elphir",
          "Elrohir",
          "Elrond",
          "Elros",
          "Elulindo",
          "Eluréd",
          "Elurín",
          "Elwing",
          "Emeldir",
          "Enel",
          "Enelyë",
          "Enerdhil",
          "Enthor",
          "Eofor",
          "Eöl",
          "Éomer",
          "Éomund",
          "Eorl",
          "Éothain",
          "Éothéod",
          "Éowyn",
          "Eradan",
          "Erchirion",
          "Erendis",
          "Erestor",
          "Erien",
          "Erkenbrand",
          "Erling",
          "Esmeralda Took",
          "Estella Bolger",
          "Estelmo",
          "Everard Took",
          "Falco Chubb-Baggins",
          "Faniel",
          "Faramir",
          "Faramir Took",
          "Farin",
          "Farmer Cotton",
          "Farmer Maggot",
          "Fastolph Bolger",
          "Fastred",
          "Fastred of Greenholm",
          "Fëanor",
          "Fengel",
          "Ferdibrand Took",
          "Ferdinand Took",
          "Ferumbras Took",
          "Fíli",
          "Filibert Bolger",
          "Fimbrethil",
          "Finarfin",
          "Finbor",
          "Findegil",
          "Findis",
          "Finduilas",
          "Fingolfin",
          "Fingon",
          "Finrod",
          "Finwë",
          "Fíriel",
          "Fíriel Fairbairn",
          "Flambard Took",
          "Flói",
          "Folca",
          "Folco Boffin",
          "Folco Burrowes",
          "Folcred",
          "Folcwine",
          "Forhend",
          "Forlong",
          "Forthwini",
          "Fortinbras Took",
          "Forweg",
          "Fosco Baggins",
          "Fram",
          "Frár",
          "Fréa",
          "Fréaláf",
          "Fréawine",
          "Freca",
          "Fredegar Bolger",
          "Frerin",
          "Frodo Baggins",
          "Frodo Gardner",
          "Frór",
          "Frumgar",
          "Fundin",
          "Gaffer Gamgee",
          "Galadhon",
          "Galador",
          "Galadriel",
          "Galathil",
          "Galdor",
          "Galdor of the Havens",
          "Galion",
          "Gálmód",
          "Gamil Zirak",
          "Gamling",
          "Gandalf",
          "Gárulf",
          "Gelmir",
          "Gerda Boffin",
          "Gerontius Took",
          "Gethron",
          "Ghân-buri-Ghân",
          "Gil-galad",
          "Gilbarad",
          "Gildis",
          "Gildor",
          "Gilly Brownlock",
          "Gilmith",
          "Gilraen",
          "Gilwen",
          "Gimilkhâd",
          "Gimilzagar",
          "Gimli",
          "Girion",
          "Glaurung",
          "Gléowine",
          "Glirhuin",
          "Glóin",
          "Glóredhel",
          "Glorfindel",
          "Golasgil",
          "Goldberry",
          "Goldilocks Gardner",
          "Goldwine",
          "Golfimbul",
          "Gollum",
          "Gorbadoc Brandybuck",
          "Gorbulas Brandybuck",
          "Gorgol",
          "Gorhendad Oldbuck",
          "Gorlim",
          "Gormadoc Brandybuck",
          "Gothmog",
          "Gram",
          "Great Eagle",
          "Great Goblin",
          "Griffo Boffin",
          "Grim",
          "Gríma",
          "Grimbeorn",
          "Grimbold",
          "Grishnákh",
          "Grithnir",
          "Gróin",
          "Grór",
          "Gruffo Boffin",
          "Guilin",
          "Gundabald Bolger",
          "Gundahad Bolger",
          "Gundahar Bolger",
          "Gundolpho Bolger",
          "Gundor",
          "Guthláf",
          "Gwaihir",
          "Gwindor",
          "Hador",
          "Halbarad",
          "Haldad",
          "Haldan",
          "Haldar",
          "Haldir",
          "Haleth",
          "Halfast Gamgee",
          "Halfred Gamgee",
          "Halfred Greenhand",
          "Halfred of Overhill",
          "Hallacar",
          "Hallas",
          "Hallatan",
          "Halmir",
          "Háma",
          "Hamfast Gardner",
          "Hamfast of Gamwich",
          "Hamson Gamgee",
          "Handir",
          "Hanna Goldworthy",
          "Hannar",
          "Hardang",
          "Harding",
          "Harding of the Hill",
          "Hareth",
          "Harry Goatleaf",
          "Hathaldir",
          "Hathol",
          "Hatholdir",
          "Hazad",
          "Helm",
          "Henderch",
          "Hending",
          "Herefara",
          "Herendil",
          "Heribald Bolger",
          "Herion",
          "Herubrand",
          "Herugar Bolger",
          "Herumor",
          "Hild",
          "Hilda Bracegirdle",
          "Hildibrand Took",
          "Hildifons Took",
          "Hildigard Took",
          "Hildigrim Took",
          "Hirgon",
          "Hiril",
          "Hirluin",
          "Hirwen",
          "Hob Gammidge",
          "Hob Hayward",
          "Hobson",
          "Holdwine",
          "Holfast Gardner",
          "Holman Cotton",
          "Horn",
          "Huan",
          "Hugo Boffin",
          "Hugo Bracegirdle",
          "Hundad",
          "Hundar",
          "Hunleth",
          "Hunthor",
          "Huor",
          "Húrin",
          "Hyarmendacil",
          "Iago Grubb",
          "Îbal",
          "Ibun",
          "Idis",
          "Idril",
          "Ilberic Brandybuck",
          "Imin",
          "Iminyë",
          "Imlach",
          "Imrahil",
          "Imrazôr",
          "Indis",
          "Indor",
          "Ingold",
          "Ingwë",
          "Ingwion",
          "Inziladûn",
          "Inzilbêth",
          "Ioreth",
          "Iorlas",
          "Írildë",
          "Írimë",
          "Írimon",
          "Irolas",
          "Isembard Took",
          "Isembold Took",
          "Isengar Took",
          "Isengrim",
          "Isildur",
          "Isilmë",
          "Isilmo",
          "Isumbras",
          "Ithilbor",
          "Ivorwen",
          "Ivriniel",
          "Ivy Goodenough",
          "Jago Boffin",
          "Jessamine Boffin",
          "Khamûl",
          "Khîm",
          "Kíli",
          "King of the Dead",
          "Lagduf",
          "Lalaith",
          "Landroval",
          "Largo Baggins",
          "Larnach",
          "Laura Grubb",
          "Lavender Grubb",
          "Leaflock",
          "Legolas",
          "Lenwë",
          "Léod",
          "Lily Baggins",
          "Lily Brown",
          "Linda Baggins",
          "Lindir",
          "Lindissë",
          "Lindórië",
          "Lobelia Sackville-Baggins",
          "Lofar",
          "Lonely Troll",
          "Longo Baggins",
          "Lóni",
          "Lorgan",
          "Lothíriel",
          "Lotho Sackville-Baggins",
          "Lugdush",
          "Lúthien",
          "Mablung",
          "Madoc Brandybuck",
          "Madril",
          "Maedhros",
          "Maeglin",
          "Maglor",
          "Magor",
          "Mahtan",
          "Mairen",
          "Malach",
          "Malantur",
          "Malbeth",
          "Mallor",
          "Malva Headstrong",
          "Malvegil",
          "Manthor",
          "Manwendil",
          "Marach",
          "Marcho",
          "Mardil",
          "Marhari",
          "Marhwini",
          "Marigold Gamgee",
          "Marmadas Brandybuck",
          "Marmadoc Brandybuck",
          "Marroc Brandybuck",
          "Mat Heathertoes",
          "Mauhúr",
          "May Gamgee",
          "Meleth",
          "Melian",
          "Melilot Brandybuck",
          "Menegilda Goold",
          "Meneldil",
          "Meneldor",
          "Mentha Brandybuck",
          "Meriadoc Brandybuck",
          "Merimac Brandybuck",
          "Merimas Brandybuck",
          "Merry Gardner",
          "Milo Burrows",
          "Mîm",
          "Mimosa Bunce",
          "Minardil",
          "Minastan",
          "Minohtar",
          "Minto Burrows",
          "Mirabella Took",
          "Míriel",
          "Mithrellas",
          "Mogru",
          "Moro Burrows",
          "Morwë",
          "Morwen",
          "Morwen Steelsheen",
          "Mosco Burrows",
          "Mouth of Sauron",
          "Mrs. Bunce",
          "Mrs. Maggot",
          "Mungo Baggins",
          "Muzgash",
          "Myrtle Burrows",
          "Náin",
          "Náli",
          "Nar",
          "Nár",
          "Narmacil",
          "Narvi",
          "Nazgûl",
          "Nellas",
          "Nerdanel",
          "Nessanië",
          "Nienor",
          "Nimloth of Doriath",
          "Nimrodel",
          "Nina Lightfoot",
          "Nob",
          "Nolondil",
          "Nora Bolger",
          "Nori",
          "Númendil",
          "Núneth",
          "Nurwë",
          "Odo Proudfoot",
          "Odovacar Bolger",
          "Ohtar",
          "Óin",
          "Old Noakes",
          "Olo Proudfoot",
          "Olwë",
          "Ondoher",
          "Orchaldor",
          "Orgulas Brandybuck",
          "Ori",
          "Orleg",
          "Ornendil",
          "Ornil",
          "Orodreth",
          "Oromendil",
          "Orontor",
          "Oropher",
          "Orophin",
          "Ostoher",
          "Otho Sackville-Baggins",
          "Othrondir",
          "Otto Boffin",
          "Paladin Took",
          "Pansy Baggins",
          "Peeping Jack",
          "Pelendur",
          "Pengolodh",
          "Peony Baggins",
          "Peregrin Took",
          "Pervinca Took",
          "Pimpernel Took",
          "Pippin Gardner",
          "Poldor",
          "Polo Baggins",
          "Ponto Baggins",
          "Poppy Chubb-Baggins",
          "Porto Baggins",
          "Posco Baggins",
          "Pott the Mayor",
          "Primrose Boffin",
          "Primrose Gardner",
          "Primula Brandybuck",
          "Prisca Baggins",
          "Quennar",
          "Quickbeam",
          "Radagast",
          "Radbug",
          "Radhruin",
          "Ragnir",
          "Ragnor",
          "Reginard Took",
          "Rían",
          "Roäc",
          "Robin Gardner",
          "Robin Smallburrow",
          "Rollo Boffin",
          "Rómendacil",
          "Rorimac Brandybuck",
          "Rosa Baggins",
          "Rosamunda Took",
          "Rose Cotton",
          "Rose Gardner",
          "Rowan",
          "Rowlie Appledore",
          "Ruby Bolger",
          "Ruby Gardner",
          "Rudibert Bolger",
          "Rudigar Bolger",
          "Rudolph Bolger",
          "Rufus Burrows",
          "Rúmil",
          "Sador",
          "Saelon",
          "Saeros",
          "Sagroth",
          "Salvia Brandybuck",
          "Samwise Gamgee",
          "Sancho Proudfoot",
          "Sangahyando",
          "Sapphira Brockhouse",
          "Saradas Brandybuck",
          "Saradoc Brandybuck",
          "Saruman",
          "Sauron",
          "Scatha",
          "Seredic Brandybuck",
          "Shagram",
          "Shelob",
          "Sigismond Took",
          "Silmariën",
          "Siriondil",
          "Skinbark",
          "Smaug",
          "Snaga",
          "Soronto",
          "Tal-Elmar",
          "Tanta Hornblower",
          "Tar-Alcarin",
          "Tar-Aldarion",
          "Tar-Amandil",
          "Tar-Anárion",
          "Tar-Ancalimë",
          "Tar-Ancalimon",
          "Tar-Anducal",
          "Tar-Ardamin",
          "Tar-Atanamir",
          "Tar-Calmacil",
          "Tar-Ciryatan",
          "Tar-Elendil",
          "Tar-Meneldur",
          "Tar-Minastir",
          "Tar-Míriel",
          "Tar-Palantir",
          "Tar-Súrion",
          "Tar-Telemmaitë",
          "Tar-Telperiën",
          "Tar-Vanimeldë",
          "Tarannon Falastur",
          "Tarcil",
          "Tarciryan",
          "Targon",
          "Tarondor",
          "Tata",
          "Tatië",
          "Ted Sandyman",
          "Telchar",
          "Telemnar",
          "Telumehtar Umbardacil",
          "Thengel",
          "Theobald Bolger",
          "Théoden",
          "Théodred",
          "Théodwyn",
          "Thingol",
          "Thorin",
          "Thorin Stonehelm",
          "Thorondir",
          "Thorondor",
          "Thráin",
          "Thranduil",
          "Thrór",
          "Tindómiel",
          "Tobold Hornblower",
          "Togo Goodbody",
          "Tolman Cotton Junior",
          "Tolman Gardner",
          "Tom Bombadil",
          "Tom Pickthorn",
          "Torhir Ifant",
          "Tosto Boffin",
          "Treebeard",
          "Tuor",
          "Turambar",
          "Turgon",
          "Túrin",
          "Uffo Boffin",
          "Ufthak",
          "Ulbar",
          "Uldor",
          "Ulfang",
          "Ulfast",
          "Ulrad",
          "Ulwarth",
          "Ungoliant",
          "Urthel",
          "Valacar",
          "Valandil",
          "Valandur",
          "Vardamir",
          "Vardilmë",
          "Vëantur",
          "Vidugavia",
          "Vidumavi",
          "Vigo Boffin",
          "Vinitharya",
          "Vorondil",
          "Voronwë",
          "Walda",
          "Watcher in the Water",
          "Wídfara",
          "Wilcome",
          "Wilibald Bolger",
          "Wilimar Bolger",
          "Will Whitfoot",
          "William",
          "Willie Banks",
          "Wiseman Gamwich",
          "Witch-king",
          "Wulf",
          "Yávien",
          "Zamîn",
          "Zimrahin",
          "Zimraphel"
        ],
        "hobbit": {
          "character": [
            "Bilbo Baggins",
            "Bungo Baggins",
            "Belladonna Took",
            "Bullroarer Took",
            "Gandalf The Grey",
            "Radagast",
            "Dain",
            "Thorin Oakenshield",
            "Fili",
            "Kili",
            "Balin",
            "Dwalin",
            "Oin",
            "Gloin",
            "Dori",
            "Nori",
            "Ori",
            "Bifur",
            "Bofur",
            "Bombur",
            "Elrond",
            "Galion",
            "Bard the Bowman",
            "Beorn",
            "Tom",
            "Bert",
            "Bill Huggins",
            "Gollum",
            "The Necromancer",
            "Smaug",
            "Carc",
            "Roac",
            "The Lord of the Eagles",
            "The Great Goblin",
            "Bolg",
            "Golfimbul"
          ],
          "location": [
            "Bree",
            "The Shire",
            "Rivendell",
            "The Misty Mountains",
            "Beorn's Hall",
            "Mirkwood",
            "Esgaroth",
            "Erebor",
            "Bag-End",
            "Under-Hill",
            "Mount Gram",
            "Green Fields",
            "Last Desert",
            "Lonely Mountain",
            "Withered Heath",
            "Country Round",
            "Long Lake",
            "River Running",
            "Mines of Moria",
            "Green Dragon Inn",
            "Bywater",
            "The Great Mill",
            "Wilderland",
            "Gondolin",
            "Land Beyond",
            "Goblin Gate",
            "Carrock",
            "High Pass",
            "Great River",
            "Grey Mountains",
            "Land of the Necromancer",
            "Long Marshes",
            "Forest River",
            "Lake Town",
            "Dorwinion",
            "Ravenhill",
            "Iron Hills",
            "Mount Gundabad"
          ],
          "quote": [
            "Do you wish me a good morning, or mean that it is a good morning whether I want it or not; or that you feel good this morning; or that it is a morning to be good on?",
            "There is nothing like looking, if you want to find something. You certainly usually find something, if you look, but it is not always quite the something you were after.",
            "In a hole in the ground there lived a hobbit.",
            "It does not do to leave a live dragon out of your calculations, if you live near him.",
            "May the wind under your wings bear you where the sun sails and the moon walks.",
            "Where there's life there's hope.",
            "So comes snow after fire, and even dragons have their endings.",
            "\"Where did you go to, if I may ask?\" said Thorin to Gandalf as they rode along. \"To look ahead\" said he. \"And what brought you back in the nick of time?\" \"Looking behind\" said he.",
            "\"You have nice manners for a thief and a liar\", said the dragon.",
            "May the hair on your toes never fall out!",
            "The road goes ever on and on...",
            "Never laugh at live dragons, Bilbo you fool!"
          ],
          "thorins_company": [
            "Thorin Oakenshield",
            "Fili",
            "Kili",
            "Balin",
            "Dwalin",
            "Oin",
            "Gloin",
            "Dori",
            "Nori",
            "Ori",
            "Bifur",
            "Bofur",
            "Bombur",
            "Gandalf",
            "Bilbo Baggins"
          ]
        },
        "locations": [
          "Abyss",
          "Achad Tarlang",
          "Adorn",
          "Adurant",
          "Aelin-uial",
          "Tarn Aeluin",
          "Afros",
          "Agar",
          "Agathurush",
          "Aglarond",
          "Pass of Aglon",
          "Akallabêth",
          "Aldalómë",
          "Aldburg",
          "Isle of Almaren",
          "Alqualondë",
          "Aman",
          "Ambaróna",
          "Amon Amarth",
          "Amon Anwar",
          "Amon Darthir",
          "Amon Dîn",
          "Amon Ereb",
          "Amon Ethir",
          "Amon Gwareth",
          "Amon Hen",
          "Amon Lanc",
          "Amon Lhaw",
          "Amon Obel",
          "Amon Rûdh",
          "Amon Sûl",
          "Amon Uilos",
          "Pass of Anach",
          "Anadûnê",
          "Ancient West",
          "Andafalassë",
          "Andor",
          "Andram",
          "Andrast",
          "Andrath",
          "Caves of Androth",
          "River of Anduin",
          "Andúne Pelo",
          "Andúnië",
          "Andustar",
          "Anfalas",
          "Anfauglith",
          "Angamando",
          "Angband",
          "Anghabar",
          "Realm of Angmar",
          "Angren",
          "Angrenost",
          "Annon-in-Gelydh",
          "Annúminas",
          "Anórien",
          "Antaro",
          "Araman",
          "Arandor",
          "Archet",
          "Arda",
          "Ard-galen",
          "Argonath",
          "Armenelos",
          "Arnach",
          "Arnor",
          "River of Aros",
          "Arossiach",
          "Arthedain",
          "Arthor na Challonnas",
          "Arthor na Forlonnas",
          "Arthórien",
          "Arvernien",
          "River of Ascar",
          "Ash Mountains",
          "Astulat",
          "Atalantë",
          "Athrad Angren",
          "Avallónë",
          "Avathar",
          "Azanulbizar",
          "Bag End",
          "Bagshot Row",
          "Balar",
          "Bamfurlong",
          "Bandushathûr",
          "Bar-en-Danwedh",
          "Bar-en-Nibin-noeg",
          "Bar-in-Mŷl‎",
          "Bar-erib",
          "Barad-dûr",
          "Barad Eithel",
          "Barad Nimras",
          "Baranduin",
          "Barazinbar",
          "Barrow-downs",
          "Barrowfield",
          "Battle Pit",
          "Battle Plain",
          "Bay of Balar",
          "Bay of Belfalas",
          "Bay of Andúnië",
          "Bay of Eldamar",
          "Bay of Eldanna",
          "Bay of Rómenna",
          "Belegaer",
          "Belegost",
          "Beleriand",
          "Belfalas",
          "Bent Seas",
          "Beorn's House",
          "Bindbale Wood",
          "Birchwoods of Nimbrethil",
          "Black Crack",
          "Black Gate",
          "Black Land",
          "Black Pit",
          "Black Pits",
          "Blackroot",
          "Blessed Realm",
          "Blue Mountains",
          "Bombadil's House",
          "Bonfire Glade",
          "Bony ridge",
          "The Bounds",
          "Branda-nîn",
          "Brandywine Bridge",
          "Bree",
          "Bree Hill",
          "Bree-land",
          "Breredon",
          "Brethil",
          "Bridge of Esgalduin",
          "Bridge of Mitheithel",
          "Bridge of Khazad-dûm",
          "Bridge of Stonebows",
          "Bridgefields",
          "Brilthor",
          "Brithiach",
          "Brithombar",
          "Brithon",
          "Brockenbores",
          "Brodda's hall",
          "Brown Lands",
          "Bruinen",
          "Buck Hill",
          "Buckland",
          "Buckland Gate",
          "Buckland Road",
          "Bucklebury",
          "Bucklebury Ferry",
          "Bucklebury Ford",
          "Budge Ford",
          "Budgeford",
          "Bundushathûr",
          "Bywater",
          "Bywater Pool",
          "Bywater Road",
          "Cabed-en-Aras",
          "Cair Andros",
          "Calacirya",
          "Calacirian",
          "Calembel",
          "Calenardhon",
          "Calenhad",
          "Calmindon",
          "Cape Balar",
          "Cape of Andrast",
          "Cape of Forochel",
          "Carach Angren",
          "Caradhras",
          "Caragdûr",
          "Caras Galadhon",
          "Carchost",
          "Cardolan",
          "Carn Dûm",
          "Carnen",
          "Carrock",
          "Causeway Forts",
          "Caverns of Helm's Deep",
          "Caverns of Narog",
          "Caverns of the Oaritsi",
          "Caves of Androth",
          "Caves of Menegroth",
          "Celduin",
          "Celebdil",
          "Celebrant",
          "Celebros",
          "Celon",
          "Celos",
          "Central Highlands",
          "Cerin Amroth",
          "Chamber of Mazarbul",
          "Chambers of Fire",
          "Chetwood",
          "Chill Gulf",
          "Ciril",
          "Cirith Dúath",
          "Cirith Forn en Andrath",
          "Cirith Gorgor",
          "Cirith Ninniach",
          "Cirith Thoronath",
          "Cirith Ungol",
          "Citadel of Stars",
          "City of the Corsairs",
          "Cloudyhead",
          "Cobas Haven",
          "Côf Belfalas",
          "Coldfells",
          "Combe",
          "Cormallen",
          "Corollairë",
          "Coron Oiolairë",
          "Court of the Fountain",
          "Cracks of Doom",
          "Crickhollow",
          "Crissaegrim",
          "Cristhorn",
          "Crossings of Teiglin",
          "Cross-roads",
          "Cuiviénen",
          "Cûl Bîn",
          "Cûl Veleg",
          "Cûm-nan-Arasaith",
          "Dagorlad",
          "Dale",
          "Dark Door",
          "Dark Gate",
          "Dark Land",
          "Dark Lands",
          "Dark Mountains",
          "Dark Tower",
          "Dead Marshes",
          "Deadmen's Dike",
          "Death Down",
          "Deathless Lands",
          "Deeping",
          "Deephallow",
          "Deeping Coomb",
          "Deeping-road",
          "Deeping Stream",
          "Deeping Wall",
          "Deer's Leap",
          "Deldúwath",
          "Derndingle",
          "Desert of Lostladen",
          "Desolation of Smaug",
          "Desolation of the Morannon",
          "Dimbar",
          "Dimholt",
          "Dimrill Dale",
          "Dimrill Gate",
          "Dimrill Stair",
          "Dimrost",
          "Dingle",
          "Dol Amroth",
          "Dol Baran",
          "Dol Guldur",
          "Dol Tarlang",
          "Dome of Stars",
          "Doors of Night",
          "Doors of Durin",
          "Dor Caranthir",
          "Dor-Cúarthol",
          "Dor Daedeloth",
          "Dor Daidelos",
          "Dor Dínen",
          "Dor-en-Ernil",
          "Dor Firn-i-Guinar",
          "Dor-lómin",
          "Dor-Nu-Fauglith",
          "Doriath",
          "Dorthonion",
          "Dorwinion",
          "Downlands",
          "Drowns",
          "Drengist",
          "Drúadan Forest",
          "Drúwaith Iaur",
          "Dry River",
          "Duilwen",
          "Dungortheb",
          "Dunharrow",
          "Dúnharg",
          "Dunland",
          "Durin's Bridge",
          "Durin's Tower",
          "Durthang",
          "Dwaling",
          "Dwarf-Road",
          "Dwarrowdelf",
          "Dwimorberg",
          "Dwimordene",
          "Eagles' Eyrie",
          "East Beleriand",
          "East Bight",
          "East Emnet",
          "Eastern Eriador",
          "East Farthing",
          "Eastfold",
          "East-gate",
          "East-lands",
          "East Lórien",
          "East March",
          "East Road",
          "East Wall of Rohan",
          "Eastwood",
          "Echad i Sedryn",
          "Echoing Hills",
          "Echoriath",
          "Edge of the Wild",
          "Edhellond",
          "Edoras",
          "Egladil",
          "Eglador",
          "Eglamar",
          "Eglarest",
          "Eilenach",
          "Eilenaer",
          "Eithel Ivrin",
          "Eithel Nínui",
          "Eithel Sirion",
          "Ekkaia",
          "Eldalondë the Green",
          "Eldamar",
          "Elennanórê",
          "Elerrína",
          "Elostirion",
          "Elros' Tower",
          "Elvenhome",
          "Elwing's tower",
          "Emerië",
          "Emyn Arnen",
          "Emyn Beraid",
          "Emyn Duir",
          "Emyn Eglain",
          "Emyn Muil",
          "Emyn-nu-Fuin",
          "Emyn Uial",
          "Enchanted Isles",
          "Enchanted River",
          "Encircling Mountains",
          "Encircling Sea",
          "Endless Stair",
          "Endor",
          "Ened",
          "Enedwaith",
          "Entwade",
          "River Entwash",
          "Entwash Vale",
          "Entwood",
          "Éothéod",
          "Ephel Brandir",
          "Ephel Dúath",
          "Erebor",
          "Erech",
          "Ered Engrin",
          "Ered Gorgoroth",
          "Ered Lindon",
          "Ered Lithui",
          "Ered Lómin",
          "Ered Mithrin",
          "Ered Nimrais",
          "Ered Wethrin",
          "Eregion",
          "Erelas",
          "Erendis",
          "Tol Eressëa",
          "Eriador",
          "Erui",
          "Eryn Fuir",
          "Eryn Galen",
          "Eryn Vorn",
          "Esgalduin",
          "Esgaroth",
          "Estolad",
          "Ethir Anduin",
          "Ethraid Engrin",
          "Ethring",
          "Ettendales",
          "Ettenmoors",
          "Evereven",
          "Everholt",
          "Evernight",
          "Ezellohar",
          "Falas",
          "Falls of Esgalduin",
          "Falls of Irvin",
          "Falls of Rauros",
          "Falls of Sirion",
          "Fangorn Forest",
          "Fanuidhol",
          "Far Downs",
          "Far Harad",
          "Far Shore",
          "Far West",
          "Faskalan",
          "Faskala-númen",
          "Fen Hollen",
          "Fen of Serech",
          "Fenmarch",
          "Fens of Sirion",
          "Ferry Lane",
          "Field of Celebrant",
          "Field of Cormallen",
          "Fingolfin's Cairn",
          "Firienholt",
          "Firien Wood",
          "First Deep",
          "First Hall",
          "Firth of Drengist",
          "Firth of Rómenna",
          "Foen",
          "Folde",
          "Ford of Brithiach",
          "Ford of Bruinen",
          "Ford of Stones",
          "Fords of Isen",
          "Forest Gate",
          "Forest of Brethil",
          "Forest of Neldoreth",
          "Forest of Region",
          "Forest River",
          "Forest Road",
          "Forgotten Villages",
          "Forlindon",
          "Forlond",
          "Formenos",
          "Fornarthan",
          "Fornost Erain",
          "Forochel",
          "Forodwaith",
          "Forostar",
          "Forsaken Inn",
          "Fôs' Almir",
          "Fountain of Tinúviel",
          "Fox Downs",
          "Framsburg",
          "Frogmorton",
          "Front Gate",
          "Front Porch",
          "Gabilgathod",
          "Gamwich",
          "Gap of Calenardhon",
          "Gap of Rohan",
          "Gardens of Lórien",
          "Gate of the Dead",
          "Gate of the Noldor",
          "Gate Stream",
          "Gates of Morning",
          "Gates of Sirion",
          "Gelion",
          "Gilrain",
          "Ginglith",
          "Girdle of Arda",
          "Girdle of Melian",
          "Girdley Island",
          "Gladden Fields",
          "Gladden River",
          "Glanduin",
          "Glanhír",
          "Glithui",
          "Glittering Caves",
          "Goblin-gate",
          "Goblin-town",
          "Golden Gates",
          "Golden Wood",
          "Gollum's Lake",
          "Gondolin",
          "Gondor",
          "Gorbelgod",
          "Gorge of Aglon",
          "Ered Gorgoroth",
          "Plateau of Gorgoroth",
          "great East Road",
          "Great Fens",
          "Great Gulf",
          "Great Hall of Thráin",
          "Great Lakes",
          "Great Lands",
          "Great Mound",
          "Great Plains",
          "Great Rift",
          "Great River",
          "Great Shelf",
          "Great Smials",
          "Great Southern Forests",
          "Great West Road",
          "Great Willow",
          "Greater Gelion",
          "Green Dragon",
          "Green Hill Country",
          "Green Hills",
          "Green Hills",
          "Greenfields",
          "Greenholm",
          "Greenway",
          "Greenwood the Great",
          "Grey Havens",
          "Grey Mountains",
          "Grey Mountains",
          "Grey Wood",
          "Greyflood",
          "Greylin",
          "Grinding Ice",
          "Grindwall",
          "Gruir",
          "Guarded Plain",
          "Gulf of Lhûn",
          "Gundabad",
          "River Gwathló",
          "Hadhodrond",
          "Haeren",
          "Haerast",
          "Halifirien",
          "Hall of Brodda",
          "Hall of Fire",
          "Halls of Aulë",
          "Halls of Durin",
          "Halls of Mandos",
          "Hanstovánen",
          "Harad",
          "Harad Road",
          "Hardbottle",
          "Harlindon",
          "Harlond",
          "Harlond",
          "River Harnen",
          "Harondor",
          "Harrowdale",
          "Haudh-en-Elleth",
          "Haudh-en-Ndengin",
          "Haudh-en-Nirnaeth",
          "Haudh in Gwanûr",
          "Haunted Mountain",
          "Haunted Pass",
          "Haven of the Eldar",
          "Haven of the Swans",
          "Havens of Mithlond",
          "Havens of Sirion",
          "Haven of Umbar",
          "Hay Gate",
          "Haysend",
          "Heats of the South",
          "the Hedge",
          "Sea of Helcar",
          "Helcaraxë",
          "Lake Helevorn",
          "Helm's Deep",
          "Helm's Dike",
          "Helm's Gate",
          "Henneth Annûn",
          "Hidden Ferries",
          "Hidden Way",
          "High Court",
          "High Faroth",
          "High Hay",
          "High Pass",
          "Hildórien",
          "Hill of Awe",
          "Hill of Guard",
          "Hill of Hearing",
          "Hill of Himring",
          "Hill of Ilmarin",
          "Hill of Oromet",
          "Hill of Seeing",
          "Hill of Spies",
          "Hill of the Ear",
          "Hill of the Eye",
          "the Hill",
          "Hills of Eglamar",
          "Hills of Evendim",
          "Hills of Scary",
          "Himlad",
          "Himring",
          "Hírilorn",
          "Hisilómë",
          "Hithaeglir",
          "Hither Lands",
          "Hither Shore",
          "Hithlum",
          "Hoarwell",
          "Hobbiton",
          "Hobbiton Hill",
          "Hobbiton Road",
          "Hollin",
          "Hollin Gate",
          "Hollin Ridge",
          "Hornburg",
          "Hornrock",
          "House of Oromë",
          "House of the Hundred Chimneys",
          "House of the Kings",
          "House of the Stewards",
          "House of Tulkas",
          "Houses of Healing",
          "House of the Dead",
          "Huts of the raft-elves",
          "Hyarastorni",
          "Hyarmentir",
          "Hyarnustar",
          "Hyarrostar",
          "Iant Iaur",
          "Icebay of Forochel",
          "Ice of the North",
          "Idril's secret way",
          "i Drann",
          "Illuin",
          "Ilmarin",
          "Imlad Morgul",
          "Imladris",
          "Imloth Melui",
          "Imrath Gondraith",
          "Inner Seas",
          "Inland Sea",
          "Inland Sea of Helcar",
          "Írensaga",
          "Iron Fortress",
          "Iron Hills",
          "Iron Mountains",
          "Isen",
          "Isengard",
          "Isenmouthe",
          "Ishmalog",
          "Isle of Almaren",
          "Isle of Balar",
          "Isle of Elenna",
          "Isle of Eressëa",
          "Isle of Meneltarma",
          "Isle of Werewolves",
          "Isles of the West",
          "Ithilien",
          "Ivrin",
          "Ivrin's Well",
          "Ivy Bush",
          "N/A",
          "Kalormë",
          "Karningul",
          "Kelos",
          "Khand",
          "Khazad-dûm",
          "Kheled-zâram",
          "Kibil-nâla",
          "Kingdom of the South",
          "Kingdom under the Mountain",
          "King's Court",
          "King's House",
          "Kingsland",
          "Kingsland",
          "Kings' Norbury",
          "Kiril",
          "Kirith Ungol",
          "Kôr",
          "Kortirion",
          "Ladros",
          "Lake Helevorn",
          "Lake Mithrim",
          "Lake Nenuial",
          "Lake-town",
          "Lamedon",
          "Lammoth",
          "Lampwrights' Street",
          "Land of Bow-Helm",
          "Land of the Dead that Live",
          "Lands Under the Wave",
          "Lands Without",
          "Langflood",
          "Langstrand",
          "River Langwell",
          "Lanthir Lamath",
          "Last Bridge",
          "Last Homely House",
          "Last Mountain",
          "Last Shore",
          "Laurelindórenan",
          "Lebennin",
          "River Lefnui",
          "River Legolin",
          "Lhûn",
          "Linaewen",
          "Lindon",
          "Lindórinan",
          "Linhir",
          "Lisgardh",
          "River Lithir",
          "Lithlad",
          "Little Delving",
          "Little River Gelion",
          "Lockholes",
          "Loeg Ningloron",
          "Lond Daer Enedh",
          "Lone-lands",
          "Lonely Isle",
          "Lonely Mountain",
          "Longbottom",
          "Long Cleeve",
          "Long Lake",
          "Long Marshes",
          "Long the Wall",
          "Lórellin",
          "Lórien",
          "Lórinand",
          "Losgar",
          "Lossarnach",
          "Lost Isle",
          "Desert of Lostladen",
          "Lothlann",
          "Lothlórien",
          "Loudwater",
          "Lower Halls",
          "Lugbúrz",
          "Lune",
          "Luvailin",
          "Maggot's Farm",
          "Maggot's Lane",
          "Maglor's Gap",
          "Mahanaxar",
          "River Malduin",
          "Halls of Mandos",
          "Mansions of Aulë",
          "March of Maedhros",
          "The Marish",
          "TheMark",
          "Mar-nu-Falmar",
          "Market-pool",
          "Marshes of Nevrast",
          "Meduseld",
          "Men-i-Naugrim",
          "Menegroth",
          "Meneltarma",
          "Mere of Dead Faces",
          "Meres of Twilight",
          "Merethrond",
          "Mering Stream",
          "Methed-en-glad",
          "Methedras",
          "Michel Delving",
          "Middle-earth",
          "Midgewater Marshes",
          "Sandyman's Mill",
          "Minas Anor",
          "Minas Ithil",
          "Minas Morgul",
          "Minas Tirith",
          "Minas Tirith",
          "RiverMindeb",
          "MountMindolluin",
          "Mindon Eldaliéva",
          "Minhiriath",
          "Min-Rimmon",
          "Mirkwood",
          "Mirrormere",
          "Misty Mountains",
          "Mithe",
          "Mithe Steps",
          "Mitheithel",
          "Mithlond",
          "Mithrim",
          "Mittalmar",
          "Moors of the Neweglu",
          "Moors of the Nibin-noeg",
          "Morannon",
          "Mordor",
          "Morgai",
          "Morgul Pass",
          "Morgul-road",
          "RiverMorgulduin",
          "Moria",
          "Mornan",
          "River Morthond",
          "Mound of Avarice",
          "Mound of Dunlendings",
          "Mound of Riders",
          "Mounds of Mundburg",
          "Mount Dolmed",
          "Mount Doom",
          "Mount Everwhite",
          "Mount Fang",
          "Mount Gram",
          "Mount Gundabad",
          "Mount Mindolluin",
          "Mount of the Pine Tree",
          "Mount Rerir",
          "Mount Taras",
          "Mountain of Fire",
          "Mountains of Aman",
          "Mountains of Angmar",
          "Mountains of Lune",
          "Mountains of Mirkwood",
          "Mountains of Mithrim",
          "Mountains of Shadow",
          "Mountains of Shadow",
          "Mountains of Terror",
          "Mountains of the East",
          "Mouths of Anduin",
          "Mouths of Entwash",
          "Mouths of Sirion",
          "Mundburg",
          "theNaith",
          "Nameless Land",
          "Nan Curunír",
          "Nan Dungortheb",
          "Nan Elmoth",
          "Nan-tathren",
          "Nanduhirrion",
          "Narchost",
          "Nardol",
          "Nargothrond",
          "RiverNarog",
          "Narrows of the Forest",
          "Near Harad",
          "Needlehole",
          "Forest ofNeldoreth",
          "Nen Echui",
          "Nen Girith",
          "Nen Hithoel",
          "Nen Lalaith",
          "RiverNenning",
          "Nenuial",
          "Nether Dark",
          "Nevrast",
          "Nevrast",
          "New Haven",
          "New Lands",
          "Newbury",
          "House ofNienna",
          "Nimbrethil",
          "RiverNimrodel",
          "Nindalf",
          "Nindamos",
          "Ninglor",
          "Nîn-in-Eilph",
          "Nísimaldar",
          "LakeNísinen",
          "Nivrim",
          "Nobottle",
          "Nogrod",
          "Noirinan",
          "Noman-lands",
          "Norbury",
          "North Cape",
          "North Downs",
          "North Farthing",
          "North Gate",
          "North Ithilien",
          "North Kingdom",
          "North Marches",
          "North Moors",
          "North Road",
          "North Road of Ithilien",
          "North Stair",
          "North Undeep",
          "Northerland",
          "Northern Dark",
          "Northern Waste",
          "Novrod",
          "Núath Woods of",
          "Númendor",
          "Númenor",
          "Nunduinë",
          "Nurn",
          "Oatbarton",
          "Obel Halad",
          "Ocean",
          "Oiolossë",
          "Oiomúrë",
          "Old Bridge",
          "Old Ford",
          "Old Forest",
          "Old Forest Road",
          "Old Grange",
          "Old Guesthouse",
          "Old Mill",
          "Old Púkel land",
          "Old Road",
          "Old South Road",
          "Old South Road",
          "Old Winyards",
          "Old World",
          "Ondolindë",
          "Ondoluncanando",
          "Ondonórë",
          "Ondosto",
          "Onodló",
          "Orc-holds",
          "Orfalch Echor",
          "Ormal",
          "Orocarni",
          "Orod-na-Thôn",
          "Orodruin",
          "Oromet",
          "Orrostar",
          "Orthanc",
          "Osgiliath",
          "Ossiriand",
          "Ost-in-Edhil",
          "Otherworld",
          "Outer Dark or Outer Darkness",
          "Outer Lands",
          "Outer Sea",
          "Outlands",
          "Overbourn",
          "Overbourn Marshes",
          "Overhill",
          "Palisor",
          "Parth Celebrant",
          "Parth Galen",
          "Party Field",
          "Pass of Aglon",
          "Pass of Anach",
          "Pastures of Yavanna",
          "Paths of the Dead",
          "Pelargir",
          "Pelennor",
          "Pelóri",
          "Phûrunargian",
          "Pillars of the King",
          "Pincup",
          "Pine-mountain",
          "Pinnath Gelin",
          "Place of the Fountain",
          "Pool of Bywater",
          "Pool-side",
          "Pools of Ivrin",
          "RiverPoros",
          "Prancing thePony",
          "Qerkaringa",
          "Quarry",
          "Radhrim",
          "Rainbow Cleft",
          "Ramdal",
          "Rammas Echor",
          "Ras Mewrim",
          "Ras Morthil",
          "Rath Celerdain",
          "Rath Dínen",
          "Rathlóriel",
          "Rauros",
          "Ravenhill",
          "Ravines of Teiglin",
          "Redhorn",
          "Redhorn PassGate",
          "Redwater",
          "Region",
          "Region of Everlasting Cold",
          "Reunited Kingdom",
          "Rhimdath",
          "Rhosgobel",
          "Rhovanion",
          "Rhudaur",
          "Rhûn",
          "Min-Rimmon",
          "Ring of Doom",
          "Ring of Isengard",
          "Ringil",
          "Sea ofRingil",
          "RiverRingló",
          "RiverRingwil",
          "Rivendell",
          "River Running",
          "RiverRivil",
          "Rivil's Well",
          "Rochand",
          "Rómenna",
          "Rûnaer",
          "Rushdown",
          "Rushock Bog",
          "Rushy",
          "Sammath Naur",
          "Sandyman's Mill",
          "Sarn Athrad",
          "Sarn Ford",
          "Sarn Gebir",
          "Sauron's Isle",
          "Sauron's Road",
          "Sauron's Temple",
          "Scary",
          "theSea",
          "Sea of Helcar",
          "Sea of Núrnen",
          "Sea of Rhûn",
          "Sea of Ringil",
          "Seat of Hearing",
          "Seat of Seeing",
          "Sea-ward Tower",
          "Second Hall",
          "Serni",
          "Seven Gates of Gondolin",
          "Seventh Level",
          "Shadowmere",
          "Shadowy Isles",
          "Shadowy Mountains",
          "Shadowy Mountains",
          "Shadowy Seas",
          "Shadowy Spring",
          "Sharabhund",
          "Shathûr",
          "Shelob's Lair",
          "theShire",
          "RiverShirebourn",
          "Side-door",
          "RiverSilverlode",
          "Silvertine",
          "Sindanórie",
          "Sirannon",
          "RiverSiril",
          "RiverSirion",
          "RiverSirith",
          "Sîr Ninglor",
          "Slag-hills",
          "RiverSnowbourn",
          "Sorontil",
          "South Downs",
          "South Farthing",
          "South Gondor",
          "South Ithilien",
          "South Kingdom",
          "South Lane",
          "South EriadorRoad",
          "South GondorRoad",
          "South Undeep",
          "Southward Road",
          "Spider's Ring",
          "Staddle",
          "Stair Falls",
          "Stair of the Hold",
          "Standelf",
          "Starkhorn",
          "Steward's Door",
          "Stock",
          "Stock Road",
          "Stockbrook",
          "Stonewain Valley",
          "Stoningland",
          "Straight Road",
          "Straight Stair",
          "Straits of the World",
          "Sundering Seas",
          "Sunlands",
          "Sunlendings",
          "Sûthburg",
          "Sûza",
          "Swanfleet",
          "RiverTaeglin",
          "Talath Dirnen",
          "Talath Rhûnen",
          "Taniquetil",
          "Tanyasalpë",
          "Tar-Minastir",
          "Tarlang's Neck",
          "Tarmasundar",
          "Tarn Aeluin",
          "Tarnost",
          "Tasarinan",
          "Tauremorna",
          "Tauremornalómë",
          "Taur e-Ndaedelos",
          "Taur-en-Faroth",
          "Taur-im-Duinath",
          "Taur-na-Foen",
          "Taur-Na-Neldor",
          "Taur-nu-Fuin",
          "Taur-nu-Fuin",
          "Tavrobel",
          "Temple of Sauron",
          "The River Thalos",
          "Thangorodrim",
          "Tharbad",
          "Thargelion",
          "Thistle Brook",
          "Thorin's Halls",
          "Thousand Caves",
          "Three-Farthing Stone",
          "Thrihyrne",
          "Tighfield",
          "Tindrock",
          "Tirion",
          "Tirith Aear",
          "Tol Brandir",
          "Tol Eressëa",
          "Tol Fuin",
          "Tol Galen",
          "Tol-in-Gaurhoth",
          "Tol Morwen",
          "Tol Sirion",
          "Tol Uinen",
          "Tolfalas",
          "Tomb of the Kings",
          "Tongue",
          "Tookbank",
          "Tookland",
          "Torech Ungol",
          "Tower Hills",
          "Tower of Cirith Ungol",
          "Tower of Ecthelion",
          "Tower of Ingwë",
          "Tower of the King",
          "Tower of the Stone",
          "Towers of the Teeth",
          "Town Hole",
          "Treebeard's Hill",
          "Treegarth of Orthanc",
          "Troll's Cave",
          "Trollshaws",
          "Tuckborough",
          "Tumhalad",
          "Tumladen of Gondolin",
          "Tumladen of Gondor",
          "Tumunzahar",
          "Túna",
          "Twenty-First Hall of the North-end",
          "Twilight Meres",
          "Two Watchers",
          "Tyrn Gorthad",
          "Udul",
          "Udûn",
          "Udûn of Mordor",
          "Umbar",
          "Umboth-muilin",
          "Undeeps",
          "Undergate",
          "Underhill",
          "Under-way",
          "Underharrow",
          "Undertowers",
          "Undying Lands",
          "Ungoliant's Lair",
          "Ulmonan",
          "Upbourn",
          "Uttermost West",
          "Utumno",
          "Vale of Sirion",
          "Valandor",
          "Valimar",
          "Valmar",
          "Valinor",
          "Verna",
          "Vinyalondë",
          "Vinyamar",
          "Void",
          "Waking Water",
          "Wall's End",
          "Walls of Moria",
          "Walls of the Night",
          "Walls of the Sun",
          "Walls of the World",
          "Wargs' Clearing",
          "Waste",
          "Watchwood",
          "Water-valley",
          "Water of Awakening",
          "Way of Escape",
          "Way of Running Waters",
          "Waymeet",
          "Weather Hills",
          "Weathertop",
          "Wellinghall",
          "Wells of Ivrin",
          "Wells of Varda",
          "West-door",
          "West-gate of Bree",
          "West-gate of Moria",
          "West-mark",
          "West Beleriand",
          "West of the World",
          "West Pass",
          "West Road",
          "Westemnet",
          "Westermanton",
          "Western Sea",
          "Western Shore",
          "Westernesse",
          "Westfarthing",
          "Westfold",
          "Westfold Vale",
          "Westlands",
          "Westmarch",
          "Wetwang",
          "Whispering Wood",
          "White Downs",
          "White House of Erendis",
          "White Mountain",
          "White Mountains",
          "White Tower",
          "White Towers",
          "Whitfurrows",
          "Whitwell",
          "Wild Wood",
          "Wilderland",
          "Willowbottom",
          "Windle-reach",
          "Winding Stair",
          "Window-Curtain",
          "Window of the West",
          "Withered Heath",
          "Withered Wold",
          "Withywindle Valley",
          "Withywindle River",
          "Withy-path",
          "Withy-weir",
          "Wizard's Isle",
          "Wizard's Vale",
          "Wold of Rohan",
          "Wood of Anwar",
          "Woods of Oromë",
          "Woodhall",
          "Woodland Realm",
          "Woody End",
          "The Yale",
          "Yellow Mountains",
          "Yôzâyan",
          "Zirakzigil"
        ],
        "lord_of_the_rings": {
          "characters": [
            "Frodo Baggins",
            "Gandalf the Grey",
            "Samwise Gamgee",
            "Meriadoc Brandybuck",
            "Peregrin Took",
            "Aragorn",
            "Legolas",
            "Gimli",
            "Boromir",
            "Sauron",
            "Gollum",
            "Bilbo Baggins",
            "Tom Bombadil",
            "Glorfindel",
            "Elrond",
            "Arwen Evenstar",
            "Galadriel",
            "Saruman the White",
            "Éomer",
            "Théoden",
            "Éowyn",
            "Grìma Wormtongue",
            "Shadowfax",
            "Treebeard",
            "Quickbeam",
            "Shelob",
            "Faramir",
            "Denethor",
            "Beregond",
            "Barliman Butterbur"
          ],
          "locations": [
            "Aglarond",
            "Aldburg",
            "Andustar",
            "Angband",
            "Argonath",
            "Bag End",
            "Barad-dûr",
            "Black Gate",
            "Bridge of Khazad-dûm",
            "Carchost",
            "Cirith Ungol",
            "Coldfells",
            "Crack of Doom",
            "Dark Land",
            "Dol Guldur",
            "Dome of Stars",
            "Doors of Durin",
            "Doriath",
            "East Beleriand",
            "Eastfarthing",
            "East Road",
            "Eithel Sirion",
            "Elostirion",
            "Enchanted Isles",
            "Endless Stair",
            "Eä",
            "Falls of Rauros",
            "Fens of Serech",
            "Field of Celebrant",
            "Fords of Isen",
            "The Forsaken Inn",
            "Gap of Rohan",
            "Gladden Fields",
            "Gorgoroth",
            "Greenway",
            "Haudh-en-Nirnaeth",
            "Haven of the Eldar",
            "Helm's Deep",
            "Henneth Annûn",
            "Hobbit-hole",
            "Houses of Healing",
            "Hyarnustar",
            "Ilmen",
            "Inn of the Prancing Pony",
            "Isengard",
            "Isenmouthe",
            "Isle of Balar",
            "Land of the Sun",
            "Losgar",
            "Luthany",
            "Lothlorièn",
            "Maglor's Gap",
            "Marish",
            "Meduseld",
            "Minas Tirith",
            "Minhiriath",
            "Máhanaxar",
            "Narchost",
            "Nargothrond",
            "Núath",
            "Old Ford",
            "Old Forest",
            "Old Forest Road",
            "Orthanc",
            "Parth Galen",
            "Paths of the Dead",
            "Pelennor Fields",
            "Rath Dínen",
            "Regions of the Shire",
            "Rivendell",
            "The Rivers and Beacon-Hills of Gondor",
            "Sarn Ford",
            "Taur-en-Faroth",
            "Taur-im-Duinath",
            "Timeless Halls",
            "Tol Brandir",
            "Tol Galen",
            "Tol Morwen",
            "Tol-in-Gaurhoth",
            "Tumladen",
            "Utumno",
            "Vaiya",
            "Vista",
            "The Void",
            "Warning beacons of Gondor"
          ],
          "quotes": [
            "Often does hatred hurt itself!",
            "Go now, and die in what way seems best to you.",
            "Memory is not what the heart desires. That is only a mirror....",
            "Dwarves’ tongues run on when speaking of their handiwork, they say.",
            "But all’s well as ends well",
            "Sing, all ye children of the West",
            "...and all the stars flowered in the sky.",
            "Clothes are but little loss, if you escape from drowning.",
            "The wolf that one hears is worse than the orc that one fears. - Boromir",
            "I don't keep water in my pockets.",
            "For he gave it up in the end of his own accord: an important point. No,",
            "I could not 'make' you--except by force, which would break your mind.",
            "Their faces were as a rule good-natured rather than beautiful.",
            "The Lord of the Ringwraiths had met his doom.",
            "Many that live deserve death. And some that die deserve life",
            "Short cuts make delays, but inns make longer ones.",
            "But where the warg howls, there also the orc prowls. - Aragorn",
            "In winter here no heart could mourn for summer or for spring.",
            "his old life lay behind in the mists, dark adventure lay in front.",
            "I sang of leaves, of leaves of gold, and leaves of gold there grew",
            "Someone else always has to carry on the story.",
            "It's the job that's never started as takes longest to finish.",
            "Moonlight drowns out all but the brightest stars.",
            "Fear nothing! Have peace until the morning! Heed no nightly noises!",
            "I’ll get there, if I leave everything but my bones behind,",
            "NO ADMITTANCE EXCEPT ON PARTY BUSINESS.",
            "Real names tell you the story of the things they belong to",
            "Deeds will not be less valiant because they are unpraised.",
            "Even the smallest person can change the course of the future.",
            "Who knows? Have patience. Go where you must go, and hope!",
            "Yet dawn is ever the hope of men,’ said Aragorn.",
            "You will soon be well, if I do not talk you to death.",
            "Memory is not what the heart desires. That is only a mirror,",
            "You have shown your usual cunning in getting up just in time for a meal.",
            "The great storm is coming, but the tide has turned.",
            "...as young and as ancient as Spring....",
            "Why couldn’t he stop talking and let them drink his health?",
            "Not all those who wander are lost",
            "But in this at least thou shalt not defy my will: to rule my own end.",
            "I look foul and feel fair.",
            "It's the job that's never started as takes longest to finish.",
            "Moonlight drowns out all but the brightest stars.",
            "I didn't think it would end this way.",
            "Home is behind, the world ahead",
            "All's well that ends better.",
            "I want to be a healer, and love all things that grow and are not barren.",
            "Where there's life there's hope, and need of vittles.",
            "A hunted man sometimes wearies of distrust and longs for friendship.",
            "The leaves were long, the grass was green",
            "Begone, foul dwimmerlaik, lord of carrion! Leave the dead in peace!",
            "The world is indeed full of peril and in it there are many dark places.",
            "To the sea, to the sea! The white gulls are crying",
            "Do not scorn pity that is the gift of a gentle heart, Éowyn!",
            "I wish the Ring had never come to me. I wish none of this had happened."
          ]
        },
        "poems": [
          "Chip the glasses and crack the plates",
          "Far over the misty mountains cold",
          "O! What are you doing?",
          "Clap! Snap! The black crack!",
          "Fifteen birds in five fir trees",
          "The wind was on the withered heath",
          "Old fat spider spinning in a tree!",
          "Roll-Roll-Roll-Roll",
          "The King beneath the mountains",
          "Under the mountain dark and tall",
          "The dragon is withered",
          "Sing all ye joyful!",
          "Roads go ever, ever on",
          "The Road Goes Ever On and On",
          "Three Rings for the Elven-Kings Under the Sky",
          "A Walking Song",
          "Snow-white! Snow-white! O Lady Clear!",
          "Ho! Ho! Ho! To the Bottle I Go",
          "The Bath Song",
          "Farewell We Call to Hearth and Hall!",
          "O! Wanderers in the Shadowed Land",
          "Hey dol! merry dol! ring a dong dillo!",
          "Hop along, my little friends, up the Withywindle!",
          "O slender as a willow-wand!",
          "I Had An Errand There: Gathering Water-Lilies",
          "Ho! Tom Bombadil, Tom Bombadillo!",
          "Cold Be Hand and Heart and Bone",
          "Get Out! You old Wight! Vanish in the Sunlight!",
          "Wake Now My Merry Lads! Wake and Hear Me Calling!",
          "Hey! Now! Come Hoy Now! Whither Do You Wander?",
          "The Man in the Moon Stayed Up Too Late",
          "All That Is Gold Does Not Glitter",
          "The Fall of Gil-galad",
          "Song of Beren and Lúthien",
          "The Stone Troll",
          "Eärendil was a mariner",
          "A Elbereth Gilthoniel",
          "Seek for the Sword that was broken",
          "When winter first begins to bite",
          "I sit beside the fire and think",
          "The world was young, the mountains green",
          "An Elven-maid there was of old",
          "When evening in the Shire was grey",
          "I sang of leaves, of leaves of gold (Galadriel's Song of Eldamar)",
          "Ai! laurië lantar lassi súrinen (Namárië)",
          "Through Rohan Over Fen and Field Where the Long Grass Grows",
          "Gondor! Gondor, between the Mountains and the Sea!",
          "Arise now, arise, Riders of Theoden!",
          "Learn now the lore of Living Creatures!",
          "In The Willow-meads Of Tasarinan",
          "When Spring unfolds the beechen leaf, and sap is in the bough",
          "O Orofarne Lassemista, Carnimirie!",
          "We come, we come with roll of drum",
          "Where now are the Dunedain, Elessar, Elessar?",
          "Where now the horse and the rider?",
          "In Dwimordene, in Lorien",
          "Ere iron was found or tree was hewn",
          "Long List of the Ents",
          "A Rhyme of Lore",
          "The cold hard lands",
          "Oliphaunt",
          "Over the land there lies a long shadow",
          "From dark Dunharrow in the dim morning",
          "Arise, arise, Riders of Theoden!",
          "Song of the Mounds of Mundburg",
          "When the black breath blows",
          "Silver flow the streams from Celos to Erui",
          "In western lands beneath the Sun",
          "Long live the Halflings! Praise them with great praise!",
          "To the Sea, to the Sea! The white gulls are crying",
          "Sing now, ye people of the Tower of Anor",
          "Out of doubt, out of dark, to the day’s rising",
          "The Road goes ever on and on",
          "Still around the corner there may wait"
        ],
        "races": [
          "Ainur",
          "Balrogs",
          "Barrow-wights",
          "Beorning",
          "Children of Ilúvatar",
          "Demons",
          "Dragons",
          "Dwarves",
          "Elves",
          "Ents",
          "Fairies",
          "Giants",
          "Goblins",
          "Half-elven",
          "Half-orc",
          "Half-trolls",
          "Hobbits",
          "Huorns",
          "Kaukareldar",
          "Lintips",
          "Maiar",
          "Mens",
          "Mewlips",
          "Oarni",
          "Ogres",
          "Orcs",
          "Shape Shifters",
          "Skin-changer",
          "Spiders",
          "Trolls",
          "Uruk-hai",
          "Valar",
          "Vampire",
          "Wargs",
          "Werewolves",
          "Wraiths"
        ]
      },
      "train_station": {
        "germany": {
          "metro": [
            "Alexanderplatz",
            "Aufseßplatz",
            "Bismarckstraße",
            "Bülowstraße",
            "Central Station",
            "Gleisdreieck",
            "Görlitzer Bahnhof",
            "Hallesches Tor",
            "Hauptbahnhof",
            "Hausvogteiplatz",
            "Kaiserdamm",
            "Klosterstraße",
            "Kolumbusplatz",
            "Kottbusser Tor",
            "Kurfürstenstraße",
            "Märkisches Museum",
            "Mendelssohn-Bartholdy-Park",
            "Möckernbrücke",
            "Mohrenstraße",
            "Nollendorfplatz",
            "Potsdamer Platz",
            "Prinzenstraße",
            "Rathenauplatz",
            "Rosa-Luxemburg-Platz",
            "Rotkreuzplatz",
            "Scheidplatz",
            "Sendlinger Tor",
            "Senefelderplatz",
            "Spittelmarkt",
            "St. Johannis",
            "Stadtmitte",
            "Steinbühl",
            "Tiergarten",
            "Wittenbergplatz"
          ],
          "railway": [
            "Berlin-Gesundbrunnen station",
            "Berlin Hauptbahnhof",
            "Berlin Ostbahnhof",
            "Berlin Südkreuz",
            "Dortmund Hauptbahnhof",
            "Dresden Hauptbahnhof",
            "Duisburg Hauptbahnhof",
            "Düsseldorf Hauptbahnhof",
            "Essen Hauptbahnhof",
            "Frankfurt Hauptbahnhof",
            "Hamburg-Altona station",
            "Hamburg Hauptbahnhof",
            "Hannover Hauptbahnhof",
            "Karlsruhe Hauptbahnhof",
            "Köln Hauptbahnhof",
            "Köln Messe/Deutz station",
            "Leipzig Hauptbahnhof",
            "München Hauptbahnhof",
            "München Ost",
            "Nürnberg Hauptbahnhof",
            "Stuttgart Hauptbahnhof"
          ]
        },
        "spain": {
          "metro": [
            "Alto del Arenal",
            "Antón Martín",
            "Arco de Triunfo",
            "Atocha",
            "Bellvitge Rambla Marina",
            "Bilbao",
            "Buenos Aires",
            "El Clot",
            "Estación del Arte",
            "Glòries",
            "Gran Vía",
            "Hospital de Bellvitge",
            "Hostafrancs",
            "Iglesia",
            "La Sagrera",
            "Marina",
            "Menéndez Pelayo",
            "Miguel Hernández",
            "Monumental",
            "Nueva Numancia",
            "Pacífico",
            "Plaça de Sants",
            "Plaza de Cataluña",
            "Plaza España",
            "Poble Sec",
            "Portazgo",
            "Puente de Vallecas",
            "Puerta del Sol",
            "Ríos Rosas",
            "Rocafort",
            "Sagrada Família",
            "Sant Andreu",
            "Santa Coloma",
            "Santa Eulàlia",
            "Sol",
            "Tirso de Molina",
            "Torrassa",
            "Tribunal",
            "Universitat",
            "Urgell",
            "Urquinaona"
          ],
          "railway": [
            "Madrid Atocha",
            "Barcelona Sants",
            "Seville-Santa Justa",
            "Zaragoza–Delicias",
            "Madrid Chamartín",
            "Valencia-Joaquín Sorolla",
            "Málaga-María Zambrano",
            "Granada",
            "Alicante Terminal",
            "Valladolid-Campo Grande",
            "A Coruña-San Cristóbal",
            "Santiago de Compostela railway station",
            "Ourense",
            "Córdoba"
          ]
        },
        "united_kingdom": {
          "metro": [
            "Aldgate",
            "Aldgate East",
            "Angel",
            "Baker Street",
            "Bank",
            "Barbican",
            "Battersea Power Station",
            "Bayswater",
            "Blackfriars",
            "Bond Street",
            "Borough",
            "Bridge Street",
            "Brockley",
            "Buchanan Street",
            "Byker",
            "Cannon Street",
            "Central Station",
            "Cessnock",
            "Chancery Lane",
            "Charing Cross",
            "Chillingham Road",
            "City Thameslink",
            "Covent Garden",
            "Cowcaddens",
            "Earl's Court",
            "Edgware Road",
            "Elephant & Castle",
            "Embankment",
            "Euston",
            "Euston Square",
            "Farringdon",
            "Fenchurch Street",
            "Gateshead",
            "Gateshead Stadium",
            "Gloucester Road",
            "Goodge Street",
            "Govan",
            "Great Portland Street",
            "Green Park",
            "Haymarket",
            "High Street Kensington",
            "Hillhead",
            "Holborn",
            "Hoxton",
            "Hyde Park Corner",
            "Ibrox",
            "Ilford Road",
            "Jesmond",
            "Kelvinbridge",
            "Kelvinhall",
            "Kennington",
            "King's Cross St Pancras",
            "Kinning Park",
            "Knightsbridge",
            "Lambeth North",
            "Lancaster Gate",
            "Leicester Square",
            "Liverpool Street",
            "London Bridge",
            "Manors",
            "Mansion House",
            "Marble Arch",
            "Marylebone",
            "Monument",
            "Moorgate",
            "Nine Elms",
            "Notting Hill Gate",
            "Old Street",
            "Oxford Circus",
            "Paddington",
            "Patrick",
            "Piccadilly Circus",
            "Pimlico",
            "Queensway",
            "Regent's Park",
            "River Tyne",
            "Russell Square",
            "Shields Road",
            "Shoreditch High Street",
            "Sloane Square",
            "South Kensington",
            "Southwark",
            "St Enoch",
            "St George's Cross",
            "St James",
            "St James's Park",
            "St Paul's",
            "Temple",
            "Tottenham Court Road",
            "Tower Gateway",
            "Tower Hill",
            "Vauxhall",
            "Victoria",
            "Walkergate",
            "Warren Street",
            "Waterloo",
            "Waterloo East",
            "West Jesmond",
            "West Street",
            "Westminster"
          ],
          "railway": [
            "Birmingham New Street railway station",
            "Blackfriars station",
            "Bristol Temple Meads railway station",
            "Cannon Street station",
            "Cardiff Central railway station",
            "Charing Cross railway station",
            "Coventry railway station",
            "Euston railway station",
            "Fenchurch Street railway station",
            "Leeds railway station",
            "Liverpool Lime Street railway station",
            "Liverpool Street station",
            "London Bridge station",
            "London King's Cross railway station",
            "London Paddington station",
            "London Victoria station",
            "London Waterloo station",
            "Manchester Piccadilly station",
            "Marylebone station",
            "Newcastle railway station",
            "St Pancras railway station",
            "York railway station"
          ]
        },
        "united_states": {
          "metro": [
            "Back Bay",
            "Belmont",
            "Braintree",
            "Downtown Crossing",
            "Forest Hills",
            "Haymarket",
            "Jefferson Park",
            "Kimball",
            "Malden Center",
            "North Hollywood",
            "North Station",
            "Park Street",
            "Quincy Center",
            "Redondo Beach",
            "Rosemont",
            "Ruggles",
            "South Station",
            "The Loop",
            "Union Station",
            "Wonderland"
          ],
          "railway": [
            "30th Street Station",
            "Chicago Union Station",
            "Grand Central Terminal",
            "Hoboken Terminal",
            "Jamaica Station",
            "Los Angeles Union Station",
            "Millennium Station",
            "New York Penn Station",
            "Newark Penn Station",
            "Ogilvie Transportation Center",
            "Secaucus Junction",
            "South Station",
            "Washington Union Station"
          ]
        }
      },
      "tron": {
        "alternate_character_spellings": {
          "alan_bradley": [
            "alan",
            "alan bradley",
            "bradley"
          ],
          "clu": [
            "clu",
            "clue"
          ],
          "dr_lora_baines": [
            "baines",
            "dr laura baines",
            "dr lora baines",
            "laura",
            "laura baines",
            "lora",
            "lora baines"
          ],
          "dr_walter_gibbs": [
            "dr walter gibbs",
            "gibbs",
            "walter gibbs"
          ],
          "ed_dillinger": [
            "dillinger",
            "ed",
            "ed dillinger"
          ],
          "kevin_flynn": [
            "flynn",
            "kevin",
            "kevin flynn"
          ],
          "mcp": [
            "master c",
            "master control",
            "master control program",
            "mcp"
          ],
          "roy_kleinberg": [
            "kleinberg",
            "klienberg",
            "roy",
            "roy kleinberg",
            "roy klienberg"
          ]
        },
        "characters": {
          "other": [
            "bit"
          ],
          "programs": [
            "Clu",
            "Crom",
            "Dumont",
            "Master Control Program",
            "MCP",
            "Ram",
            "Sark",
            "Tron",
            "Yori"
          ],
          "users": [
            "Alan Bradley",
            "Dr. Lora Baines",
            "Dr. Walter Gibbs",
            "Ed Dillinger",
            "Kevin Flynn",
            "Roy Kleinberg"
          ]
        },
        "games": [
          "Arc Wars",
          "Astro-Gunner",
          "Code Wars",
          "Donkey Kong",
          "Intruder",
          "Kraz-Bot",
          "Light Cycles",
          "Matrix Blaster",
          "Pac-Man",
          "Space Invaders",
          "Space Paranoids",
          "The END",
          "TRON",
          "Vice Squad"
        ],
        "locations": [
          "Deleted Program Storage and Processing",
          "Dillinger's Office",
          "Disc Arena",
          "ENCOM",
          "ENCOM Lab",
          "Flynn's Arcade",
          "Game Grid",
          "I/O Tower",
          "Light Cycle Staging Pit",
          "Pit Cell",
          "Real World",
          "Ring Game"
        ],
        "quotes": {
          "alan_bradley": [
            "I still don't understand why you want to break into the system.",
            "Some programs will be thinking soon.",
            "The best programmer ENCOM ever had, and he ends up playing Space Cowboy in some back room.",
            "Try to look official. Here comes the boss."
          ],
          "bit": [
            "No!",
            "No.",
            "Yes.",
            "Yesyesyesyesyes!"
          ],
          "clu": [
            "Forget it, mister high-and-mighty Master Control! You aren't making me talk.",
            "I understand, sir.",
            "Let me at 'em!",
            "Yes, sir?",
            "Yes, sir.",
            "Yes, sir. I know, sir."
          ],
          "crom": [
            "I don't even know what I'm doing here.",
            "It's murder out there. You can't even travel around your own microcircuits without permission from Master Control Program. I mean, sending me down here to play games! Who does he calculate that he is?",
            "If I don't have a User, then who wrote me?"
          ],
          "dr_lora_baines": [
            "Have you been sneaking into the ENCOM system?",
            "Well, here goes nothing.",
            "Yep, but you gotta purchase your program 30 days in advance.",
            "You know, Flynn has been thinking about breaking into the system ever since Dillinger canned him. And he had Group 7 access."
          ],
          "dr_walter_gibbs": [
            "Ha, ha. You've got to expect some static. After all, computers are just machines, they can't think.",
            "Oh, I know all that. Sometimes I wish I were back in my garage...",
            "That was uncalled for! You know, you can remove men like Alan and me from the system, but we helped create it! And our spirit remains in every program we design for this computer!",
            "User requests are what computers are for!",
            "Won't that be grand? All the computers and the programs will start thinking and the people will stop.",
            "Yes. Interesting! Interesting! Did you hear what you just said? \"Here goes nothing.\" Actually, what we plan to do is to turn something into nothing, and then back again. They might just as well have said \"Here goes something; here comes nothing!\""
          ],
          "dumont": [
            "All that is visible must grow beyond itself, and extend into the realm of the invisible. You may pass, my friend.",
            "If the Users can no longer help us, we're lost.",
            "What do you want? I'm busy!",
            "Yes, I'm old... old enough to remember the MCP when it was just a chess program. He started small and he'll end small!"
          ],
          "ed_dillinger": [
            "But he might find it.",
            "Doing our business is what computers are for!",
            "ENCOM isn't the business you started in your garage anymore. We're billing accounts in thirty different countries; new defense systems; we have one of the most sophisticated pieces of equipment in existence.",
            "I think we should shut down all access until we find that Flynn, just to be safe.",
            "It's my fault. I programmed you to want too much.",
            "No problem, Master C. If you've seen one Consumer Electronics Show, you've seen them all.",
            "Now, wait a minute, I wrote you!",
            "The Pentagon? What do you want with the Pentagon?"
          ],
          "kevin_flynn": [
            "Another mouth to feed...",
            "Did we make it? Hooray for our side.",
            "Greetings, Programs!",
            "Hah, you wish. Ah, you guys know what it's like, you just keep doing what it looks like you're supposed to be doing, no matter how crazy it seems.",
            "Hey, hey, hey, it's the big Master Control Program everybody's been talking about.",
            "Hey! Hold it right there!",
            "I hate to disappoint you, pal, but most of the time, that's the way it is for us Users, too.",
            "I shouldn't have written all those tank programs...",
            "I taught you everything I know about the system.",
            "I'm your program?",
            "Is that all you can say?",
            "It's time I leveled with you; I'm what you guys call a User.",
            "No buts, Clu. That's for Users. Now, you're the best Program that's ever been written. You're dogged and relentless, remember?",
            "Now, how are you gonna run the universe if you can't even answer a few unsolvable problems? Huh? Come on, big fella, let's see what you got.",
            "Oh, man! On the other side of the screen, it all looks so easy.",
            "Paranoids, Matrix Blaster, Vice Squad, a whole slew of them. I was this close to starting my own little enterprise, man. But enter another software engineer. Not so young, not so bright, but very, very sneaky - Ed Dillinger. So one night, our boy Flynn, he goes to his terminal, tries to read up his file. I get nothing on there, it's a big blank. Okay, now we take you three months later. Dillinger presents Encom with five video games, that he's invented. The slime didn't even change the names, man, and he gets a big fat promotion! And thus begins his meteoric rise to, what is he now? Executive V.P.?",
            "Positive and negative, huh? You're a Bit, aren't you?",
            "Well, where's your program? Isn't he going to miss you?"
          ],
          "mcp": [
            "Sit right there; make yourself comfortable. Remember the time you used to spend playing chess together? That isn't going to do you any good, Flynn. I'm afraid you... Stop! Please! You realize I can't allow this!",
            "Sark! All of my functions are now yours. Take them!",
            "I want him in the games until he dies playing.",
            "I'm warning you. You're entering a big error, Flynn. I'm going to have to put you on the Game Grid.",
            "All Programs have a desire to be useful. But in moments, you will no longer seek communication with each other, or your superfluous Users. You will each be a part of me. And together, we will be complete.",
            "Commander, you've enjoyed all the power you've been given, haven't you? I wonder how you'll take to working in a pocket calculator.",
            "End of Line.",
            "He's not any kind of Program, Sark. He's a User.",
            "Hello, Mr. Dillinger. Thank you for coming back early.",
            "I can't afford to have an independent programmer monitoring me.",
            "Do you realize how many outside systems I've gotten into? How many programs I've appropriated?",
            "I have. I put in my memory which he hasn't located.",
            "I was planning to hit the Pentagon next week.",
            "I'd like to go against you and see what you're made of.",
            "I've gotten 2,415 times smarter since then.",
            "It shouldn't be any harder than any other big company. But now this is what I get for using humans.",
            "Mr. Dillinger, I am so very disappointed in you!",
            "No one User wrote me. I'm worth millions of their man-years.",
            "That's right. He pushed me in the real world. Someone pushes me, I push back, so I brought him down here. What's the matter, Sark? You look nervous.",
            "I'm bored with corporations. With the information I can access, I can run things 900 to 1200 times better than any human.",
            "Then pull yourself together! Get this clown trained! I want him in the games until he dies playing. Acknowledge.",
            "There's a 68.71 percent chance you're right.",
            "We've captured some military programs. I could arrange more lethal matches. Interested?",
            "With incompetence here, and now you've got two renegade programs flying all over the system in a stolen simulation.",
            "You shouldn't have come back, Flynn.",
            "You wouldn't want me to dig up Flynn's file and read it up on a VDT at The Times, would you?",
            "You'd rather take your chances with me? Want me to slow down your power cycles for you?",
            "You're in trouble, Program. Make it easy on yourself. Who's your User?",
            "You've almost reached your decision gate, and I cannot spare you any more time. End of Line."
          ],
          "program": [
            "That's Tron. He fights for the Users."
          ],
          "ram": [
            "Do you believe in the Users?",
            "I'd say \"Welcome Friend\". But not here. Not like this."
          ],
          "sark": [
            "Acknowledged, Master Control...",
            "Busy dying, you worn out excuse for an old program?",
            "Finish the game!",
            "Greetings. The Master Control Program has chosen you to serve your system on the Game Grid.",
            "Those of you who continue to profess a belief in the Users will receive the standard substandard training, which will result in your eventual elimination.",
            "Those of you who renounce this superstitious and hysterical belief will be eligible to join the Warrior Elite of the MCP.",
            "You will each receive an identity disc. Everything you do or learn will be imprinted on this disc. If you lose your disc or fail to follow commands, you will be subject to immediate de-resolution.",
            "Kill him!",
            "Thank you, Master Control.",
            "There's nothing special about you. You're just an ordinary program.",
            "Well, I... it's just... a User, I mean... Users wrote us. A User even wrote you!"
          ],
          "tron": [
            "My User has information that could... that could make this a free system again! No, really! You'd have programs lined up just to use this place, and no MCP looking over your shoulder.",
            "We made it. This far.",
            "I'm also better than you!",
            "If you are a User, then everything you've done so far has been according to a plan, right?",
            "It's too bad he's in a match now. I'll probably never meet him.",
            "That's the way it is for Programs, yes."
          ],
          "yori": [
            "I knew you'd escape - they haven't built a circuit that could hold you!",
            "That is a User, Dumont. He came here to help us. Tron believed in him.",
            "Tron is Dead."
          ]
        },
        "taglines": [
          "In the future video games battles will be a matter of life and death.",
          "The Electronic Gladiator",
          "Trapped in a fight to the finish inside the video world he created.",
          "A world inside the computer where man has never been before. Never before now.",
          "Trapped inside an electronic arena, where love, and escape, do not compute!"
        ],
        "vehicles": [
          "Battle Tank",
          "Light Cycle",
          "Recognizer",
          "Sark's Carrier",
          "Solar Sailer"
        ]
      },
      "twin_peaks": {
        "characters": [
          "Albert Rosenfield",
          "Andrew Packard",
          "Andy Brennan",
          "Annie Blackburn",
          "Audrey Horne",
          "Ben Horne",
          "Bernard Renault",
          "Big Ed Hurley",
          "Blackie O'Reilly",
          "Bobby Briggs",
          "Catherine Martell",
          "Chet Desmond",
          "Dale Cooper",
          "Denise Bryson",
          "Dick Tremayne",
          "Doc Hayward",
          "Donna Hayward",
          "Dougie Milford",
          "Dr Jacoby",
          "Eileen Hayward",
          "Evelyn Marsh",
          "Gersten Hayward",
          "Gordon Cole",
          "Hank Jennings",
          "Harold Smith",
          "Harriet Hayward",
          "Hawk Hill",
          "Jacques Renault",
          "James Hurley",
          "Jean Renault",
          "Jerry Horne",
          "John Justice Wheeler",
          "Johnny Horne",
          "Josie Packard",
          "Killer BOB",
          "Lana Budding Milford",
          "Laura Palmer",
          "Leland Palmer",
          "Leo Johnson",
          "Lil the dancer",
          "Lucy Moran",
          "MIKE",
          "Maddy Ferguson",
          "Major Briggs",
          "Mayor Milford",
          "Mike Nelson",
          "Mr Tojamura",
          "Mrs Tremond",
          "Nadine Hurley",
          "Norma Jennings",
          "Pete Martell",
          "Phillip Gerard",
          "Phillip Jeffries",
          "Pierre Tremond",
          "Ronette Pulaski",
          "Sam Stanley",
          "Sarah Palmer",
          "Shelly Johnson",
          "Sheriff Truman",
          "Teresa Banks",
          "The Giant",
          "The Log Lady",
          "The Man from Another Place",
          "Thomas Eckhardt",
          "Windom Earle"
        ],
        "locations": [
          "Big Ed's Gas Farm",
          "Black Lake",
          "Black Lodge",
          "Blue Pine Lodge",
          "Bookhouse",
          "Calhoun Memorial Hospital",
          "Cemetery",
          "Dead Dog Farm",
          "Deer Meadow",
          "Double-R Diner",
          "Easter Park",
          "FBI Office",
          "Fat Trout Trailer Park",
          "Ghostwood National Forest",
          "Glastonbury Grove",
          "Great Northern Hotel",
          "Haps Diner",
          "High School",
          "Horne's Department Store",
          "Log Lady's Cabin",
          "One Eyed Jack's",
          "Owl Cave",
          "Packard Sawmill",
          "Palmer House",
          "Railroad Car",
          "Roadhouse",
          "Ronette's Bridge",
          "Sheriff's Department",
          "Timber Falls Motel",
          "Town Hall",
          "Twin Peaks Savings & Loan",
          "White Lodge",
          "Wind River"
        ],
        "quotes": [
          "She's dead... Wrapped in plastic.",
          "There was a fish in the percolator!",
          "You know, this is — excuse me — a damn fine cup of coffee!",
          "Black as midnight on a moonless night.",
          "Through the darkness of future's past, the magician longs to see. One chants out between two worlds... \"Fire... walk with me.\"",
          "You may think I've gone insane... but I promise. I will kill again.",
          "That gum you like is going to come back in style.",
          "Where we're from, the birds sing a pretty song, and there's always music in the air.",
          "Will this sadness that makes me cry my heart out — will it ever end? The answer, of course, is yes. One day the sadness will end.",
          "Every day, once a day, give yourself a present.",
          "Do you want to know what the ultimate secret is? Laura did. The secret of knowing who killed you.",
          "COOPER, YOU REMIND ME TODAY OF A SMALL MEXICAN CHIHUAHUA.",
          "J'ai une âme solitaire.",
          "There's nothing quite like urinating in the open air.",
          "Sometimes jokes are welcome. Like the one about the kid who said: \"I enjoyed school. It was just the principal of the thing.\"",
          "Cooper, you may be fearless in this world, but there are other worlds.",
          "MAY A SMILE BE YOUR UMBRELLA. WE'VE ALL HAD OUR SOCKS TOSSED AROUND.",
          "Windom Earle's mind is like a diamond. It's cold, and hard, and brilliant.",
          "I don't wanna talk. I wanna shoot.",
          "I have no idea where this will lead us. But I have a definite feeling it will be a place both wonderful and strange.",
          "Pie. Whoever invented the pie? Here was a great person.",
          "Audrey, there are many cures for a broken heart. But nothing quite like a trout's leap in the moonlight.",
          "It has been a pleasure speaking to you.",
          "Wow, Bob, wow.",
          "How's Annie? How's Annie? How's Annie?",
          "The owls are not what they seem.",
          "Damn fine coffee! And hot!",
          "Harry, is that bag smiling?",
          "YOU ARE WITNESSING A FRONT THREE-QUARTER VIEW OF TWO ADULTS SHARING A TENDER MOMENT"
        ]
      },
      "umphreys_mcgee": {
        "song": [
          "1000 Places to See Before You Die",
          "10th Grade",
          "13 Days",
          "1348",
          "2nd Self",
          "2x2",
          "40's Theme",
          "930",
          "A Mild Sedative",
          "Ahab",
          "Alex's House",
          "All in Time",
          "All Things Ninja",
          "Amble On",
          "Anchor Drops",
          "Andy's Last Beer",
          "Angular Momentum",
          "Atmosfarag",
          "Attachments",
          "Auf Wiedersehen",
          "August",
          "B.Onion",
          "Baby Honey Sugar Darlin",
          "Bad Friday",
          "Bad Poker",
          "Bathing Digits",
          "Believe the Lie",
          "Blue Echo",
          "Bob",
          "Booth Love",
          "Breaker",
          "Bridgeless",
          "Bright Lights Big City",
          "Bullhead City",
          "Bus Call",
          "Catshot",
          "Cemetery Walk",
          "Cemetery Walk II",
          "Chicago",
          "Conduit",
          "Comma Later",
          "Conduit",
          "Constellations",
          "Crucial Taunt",
          "Cummins Lies",
          "Cut off",
          "Cut the Cable",
          "Day Nurse",
          "Dear Lord",
          "Deeper",
          "Den",
          "Depth Charge",
          "Der Bluten Kat",
          "DeWayne",
          "Dim Sun",
          "Divisions",
          "Domino Theory",
          "Dough Bro",
          "Downtrodden",
          "Draconian",
          "Dream Team",
          "Drink My Drank",
          "Drums",
          "Duck Butter",
          "Dump City",
          "Eat",
          "Educated Guess",
          "Empty the Tank",
          "End of the Road",
          "Example 1",
          "FDR",
          "FF",
          "Final Word",
          "Flamethrower",
          "Fly Like a Beagle",
          "Fool's Gold",
          "Forks",
          "Front Porch",
          "Front Port",
          "Full Frontal",
          "Funk Improv",
          "Funk Jam",
          "G-Song",
          "Gents",
          "Gesture Under a Mitten",
          "Get in the Van",
          "Glory",
          "Go to Hell",
          "Gobbler's Knob",
          "Gone for Good",
          "Goonville",
          "Got Your Milk Right Here",
          "Gravity's Real",
          "Great American",
          "Gulf Stream",
          "Gurgle",
          "Gut Strut",
          "Hajimemashite",
          "Hangover",
          "Headphones & Snowcones",
          "Higgins",
          "Hindsight",
          "Hourglass",
          "Hours",
          "Hurt Bird Bath",
          "In the Black",
          "In the Kitchen",
          "In Violation of Yes",
          "Intentions Clear",
          "JaJunk",
          "Jared",
          "Jekyll & Hyde",
          "Jose",
          "Kabump",
          "Kat's Tune",
          "Keefer",
          "Kimble",
          "Kula",
          "Larceny",
          "Last Call",
          "Last Man Swerving",
          "Le Blitz",
          "Leave Me Las Vegas",
          "Liberty Echo",
          "Lift & Separate",
          "Liquid",
          "Little Gift",
          "Loose Ends",
          "Lord Bail Ship",
          "Lucid State",
          "Mad Love",
          "Made to Measure",
          "Mail Package",
          "Make it Right",
          "Mamu",
          "Mantis",
          "Mantis Ghetts",
          "Memoris of Home",
          "Miami Virtue",
          "Miss Tinkle's Overture",
          "Moogasaurus Rex",
          "Morning Song",
          "Much Obliged",
          "Muff II The Revenge",
          "MuffburgerSandwich",
          "Mulche's Odyssey",
          "Mullet Over",
          "Nachos for Two",
          "Nemo",
          "Never Cease",
          "Night Nurse",
          "Nipple Trix",
          "No Comment",
          "Non-Compliance",
          "Nopener",
          "North Route",
          "Nothing Too Fancy",
          "Ocean Billy",
          "October Rain",
          "Oesque",
          "Onward and Upward",
          "Orfeo",
          "Out of Order",
          "Padgett's Profile",
          "Partyin Peeps",
          "Passing",
          "Pay the Snucka",
          "Phil's Farm",
          "Pick your Nose",
          "Piranhas",
          "Plunger",
          "PonchEstrada",
          "Pooh Doggie",
          "Preamble",
          "Professor Wormbog",
          "Prophecy Now",
          "Proverbial",
          "Prowler",
          "Puppet String",
          "Push the Booth Deeper",
          "Push the Pig",
          "QBert",
          "Raymond",
          "Red Room Disco",
          "Red Tape",
          "Remind Me",
          "Resolution",
          "REW",
          "Ride On Pony",
          "Ringo",
          "Rise To the Top",
          "Rising Bird",
          "Robot World",
          "Rocker",
          "Rocker Part 2",
          "Roctopus",
          "Room To Breathe",
          "Roulette",
          "Salamander Strut",
          "Scaffolding Melee",
          "Search 4",
          "Similar Skin",
          "Skin the Cat",
          "Skip",
          "Slacker",
          "Slow",
          "Sludge and Death",
          "Smell the Mitten",
          "Snake Juice",
          "Sociable Jimmy",
          "Soul Food",
          "Space Funk Booty",
          "Speak Up",
          "Spires",
          "St. Hubbins March 2",
          "Spires",
          "Stanton",
          "Stinko's Ascension",
          "Susanah",
          "Sweetness",
          "Syncopated Strangers",
          "Take it to Church",
          "Tango Mike",
          "The Bottom Half",
          "The Crooked One",
          "The Empire State",
          "The Floor",
          "The Fussy Dutchman",
          "The Fuzz",
          "The Haunt",
          "The Linear",
          "The Other Side of Things",
          "The Pequod",
          "The Plot Thickens",
          "The Triple Wide",
          "The Weight Around",
          "There's No Crying in Mexico",
          "Theresa",
          "Thin Air",
          "Through the Cracks",
          "Tribute to the Spinal Shaft",
          "Turn and Dub",
          "Turn and Run",
          "Uncle Wally",
          "Uncommon",
          "Until We Meet Again",
          "Utopian Fir",
          "Vibe",
          "Visions",
          "Waist Down",
          "Walletsworth",
          "Wappy Sprayberry",
          "Water",
          "Web Tangle",
          "Weed Rap",
          "Wellwishers",
          "White Man's Moccasins",
          "White Pickle",
          "Wife Soup",
          "Wizard Burial Ground",
          "Women Wine and Song",
          "Words",
          "Yoga Pants",
          "You Got the Wrong Guy",
          "Zeroes and Ones"
        ]
      },
      "university": {
        "name": [
          "#{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{Name.last_name}",
          "#{University.prefix} #{Address.state} #{University.suffix}"
        ],
        "prefix": [
          "The",
          "Northern",
          "North",
          "Western",
          "West",
          "Southern",
          "South",
          "Eastern",
          "East"
        ],
        "suffix": [
          "University",
          "Institute",
          "College",
          "Academy"
        ]
      },
      "v_for_vendetta": {
        "characters": [
          "V",
          "Evey Hammond",
          "Conrad Heyer",
          "Adam Susan",
          "Derek Almond",
          "Eric Finch",
          "Roger Dascombe",
          "Dominic Stone",
          "Lewis Prothero",
          "Helen Heyer",
          "Rosemary Almond",
          "Dr. Delia Surridge",
          "Bishop Anthony Lilliman",
          "Peter Creedy",
          "Valerie Page",
          "Gordon",
          "Alistair \"Ally\" Harper",
          "Brian Etheridge",
          "Guy Fawkes",
          "Chancellor Adam Sutler"
        ],
        "quotes": [
          "A building is a symbol, as is the act of destroying it. Symbols are given power by people. Alone, a symbol is meaningless, but with enough people, blowing up a building can change the world.",
          "A fake ID works better than a Guy Fawkes mask.",
          "A man after my own heart.",
          "A man does not threaten innocent civilians! He's what every gutless freedom hating terrorist is, a goddamn coward!",
          "A man does not wear a mask!",
          "A revolution without dancing is a revolution not worth having!",
          "After what happened. After what they did. I thought about killing myself. I knew that one day you'd come for me. I didn't know what they were going to do. I swear to you. Read my journal.",
          "Anarchy in the UK!",
          "And thus I clothe my naked villainy, with old odd ends stolen forth from holy writ and seem a saint when most I play the devil.",
          "Are you going to kill me now?",
          "At last, we finally meet. I have something for you, Chancellor; a farewell gift. For all the things you've done, for the things you might have done, and for the only thing you have left.",
          "Because it's the only way you're ever going to stop me!",
          "Beneath this mask there is more than flesh. Beneath this mask there is an idea, Mr. Creedy. And ideas are bulletproof.",
          "Bollocks. Whatchya gonna do, huh? We've swept this place. You've got nothing. Nothing but your bloody knives and your fancy karate gimmicks. We have guns.",
          "But on this most auspicious of nights, permit me then, in lieu of the more commonplace sobriquet, to suggest the character of this dramatis persona.",
          "By sun-up if you're not the sorriest piece of ass in all'a London... you'll certainly be the sorest!",
          "By the power of truth, I, while living, have conquered the universe.",
          "Conceal me what I am, and be my aid For such disguise as haply shall become The form of my intent.",
          "Defiant to the end, huh? You won't cry like him, will you? You're not afraid of death. You're like me.",
          "Do you have any idea how long it would take to rebuild this facility?",
          "Don't run from it, Evey. You've been running all your life.",
          "Every day, gentlemen. Every day that brings us closer to November. Every day that man remains free is one more failure. 347 days, gentlemen. 347 failures!",
          "Everybody is special. Everybody. Everybody is a hero, a lover, a fool, a villain. Everybody. Everybody has their story to tell.",
          "Evey, please. There is a face beneath this mask but it's not me. I'm no more that face than I am the muscles beneath it or the bones beneath them.",
          "Evey? E-V. Of course you are",
          "Gentlemen, I want this terrorist found... and I want him to understand what terror really means.",
          "God is in the rain.",
          "He cared more about revenge than he did about her.",
          "He was Edmond Dantés... and he was my father. And my mother... my brother... my friend. He was you... and me. He was all of us.",
          "I am instructed to inform you that you have been convicted by special tribunal and that unless you are ready to offer your cooperation you are to be executed. Do you understand what I'm telling you?",
          "I can assure you I mean you no harm.",
          "I can't feel anything anymore!",
          "I dare do all that may become a man. Who dares do more is none.",
          "I know you may never forgive me... but nor will you understand how hard it was for me to do what I did. Every day I saw in myself everything you see in me now. Every day I wanted to end it, but each time you refused to give in, I knew I couldn't.",
          "I might have killed the fingerman who attacked you, but I heard no objection then.",
          "I promise you it will be like nothing you have ever seen.",
          "I remember them arguing at night. Mum wanted to leave the country. Dad refused. He said if we ran away, they would win. Win, like it was a game.",
          "I suspect if they do find this place, a few bits of art will be the least of my worries.",
          "I told you, only truth. For 20 years, I sought only this day. Nothing else existed... until I saw you. Then everything changed. I fell in love with you Evey. And to think I no longer believed I could.",
          "I want anyone caught with one of those masks arrested!",
          "I want this country to realize that we stand on the edge of oblivion. I want every man, woman and child to understand how close we are to chaos. I want everyone to remember why they need us!",
          "I wish I believed that was possible. But every time I've seen this world change, it's always been for the worse.",
          "I wish I wasn't afraid all the time, but... I am.",
          "I worried about myself for a while... but then one day I was a market and a friend, someone I'd worked with at the BTN, got in line behind me. I was so nervous that when the cashier asked me for my money, I dropped it. My friend picked it up and handed it to me. She looked at me right in the eyes... didn't recognize me. I guess whatever you did to me worked better than I imagined.",
          "I'll tell you what I wish. I wish I had been there! I wish I had the chance for a face-to-face. Just one chance, that's all I'd need!",
          "I'm a musician of sorts, and on my way to give a very special performance.",
          "I'm afraid that won't work either. Now, you have to understand, Evey. I don't want this for either of us, but I couldn't see any other way. You were unconscious, and I had to make a decision. If I had left you there, right now, you'd be in one of Creedy's interrogation cells. They'd imprison you, torture you, and, in all probability, kill you in the pursuit of finding me. After what you did, I couldn't let that happen, so I picked you up and carried you to the only place I knew you'd be safe: here, to my home.",
          "I'm dizzy. I need air. Please, I need to be outside.",
          "I'm not questioning your powers of observation; I'm merely remarking upon the paradox of asking a masked man who he is.",
          "I'm sorry, but Mr. Deitrich's dead. I thought they'd arrest him, but when they found a Koran in his house, they had him executed.",
          "I'm upset? You just said you killed Lewis Prothero!",
          "I've not come for what you've hoped to do. I've come for what you did.",
          "I, like God, do not play with dice and do not believe in coincidence.",
          "If he does, and something happens to that building, the only thing that will change, the only difference that it will make, is that tomorrow morning, instead of a newspaper, I will be reading Mr. Creedy's resignation!",
          "If our own government was responsible for the deaths of almost a hundred thousand people... would you really want to know?",
          "If you accept, put an 'x' on your front door.",
          "Is it meaningless to apologize?",
          "Is that what you really think, or what they would want you to think?",
          "It is to Madame Justice that I dedicate this concerto, in honor of the holiday that she seems to have taken from these parts, and in recognition of the impostor that stands in her stead. Tell me Evey, do you know what day it is?",
          "It's funny. I was given one of your roses today. I wasn't sure you were the terrorist until I saw it. What a strange coincidence that I should be given one today.",
          "It's my home. I call it the Shadow Gallery.",
          "Knowledge, like air, is vital to life. Like air, no one should be denied it.",
          "Listen to me, you bleeding sod, England prevails because I say it does! And so does every lazy bum on this show, and that includes you! Find another DOP, or find yourself another job!",
          "Look, all they want is one little piece of information. Just give them something... anything.",
          "Love your rage, not your cage.",
          "May I inquire as to how you have avoided detection?",
          "My father was a writer. You would've liked him. He used to say that artists use lies to tell the truth, while politicians use them to cover the truth up.",
          "No one will ever forget that night and what it meant for this country. But I will never forget the man and what he meant to me.",
          "No, what you have are bullets, and the hope that when your guns are empty I'm no longer be standing, because if I am you'll all be dead before you've reloaded.",
          "No. I shouldn't have done that. I must have been out of my mind.",
          "Not so funny now is it, funny man?",
          "Now that's done with. It's time to have a look at your face. Take off your mask.",
          "Now, this is only an initial report, but at this time, it's believed that during this heroic raid, the terrorist was shot and killed.",
          "Oh please, have mercy!",
          "Oh, not tonight Bishop... not tonight!",
          "One thing is true of all governments - their most reliable records are tax records.",
          "Penny for the Guy?",
          "People should not be afraid of their governments. Governments should be afraid of their people.",
          "She blinks a lot when she's reading a story she knows is false.",
          "Spare us your professional annotations, Mr. Finch. They are irrelevant.",
          "Stealing implies ownership. You can't steal from the censor; I merely reclaimed them.",
          "Strength through unity! Unity through faith!",
          "Sutler can no longer trust you, can he, Mr. Creedy? And we both know why. After I destroy Parliament, his only chance will be to offer them someone else. Some other piece of meat. And who will that be? You, Mr. Creedy. A man as smart as you has probably considered this. A man as smart as you probably has a plan. That plan is the reason Sutler no longer trusts you. It's the reason why you're being watched right now, why there are eyes and ears in every room of this house and a tap on every phone.",
          "Sutler. Come now, Mr. Creedy, you knew this was coming. You knew that one day, it'd be you or him. That's why Sutler's been kept underground, for 'security purposes'. That's why there are several of your men close to Sutler. Men that could be counted on. All you have to do is say the word.",
          "Tell me... do you like music, Mr. Finch?",
          "Thank you... but I'd rather die behind the chemical sheds.",
          "That's it! See, at first I thought it was hate, too. Hate was all I knew, it built my world, it imprisoned me, taught me how to eat, how to drink, how to breathe. I thought I'd die with all my hate in my veins. But then something happened. It happened to me... just as it happened to you.",
          "The Ghost of Christmas past.",
          "The only thing that you and I have in common, Mr. Creedy, is we're both about to die.",
          "The problem is, he knows us better than we know ourselves. That's why I went to Larkhill, last night.",
          "The time has come for me to meet my maker and to repay him in kind for all that he's done.",
          "Then you have no fear anymore. You're completely free.",
          "There are 872 songs on here. I've listened to them all... but I've never danced to any of them.",
          "There are no coincidences, Delia... only the illusion of coincidence.",
          "There is no court in this country for men like Prothero.",
          "There's no certainty - only opportunity.",
          "This country needs more than a building right now. It needs hope.",
          "This so called V and his accomplice Evey Hammond, neo-demagogues spouting their message of hate, a delusional and aberrant voice delivering a terrorist's ultimatum... An ultimatum that was met with swift, surgically precise justice! The moral of this story ladies and gentleman is... Good guys win, bad guys lose, and as always, England prevails!",
          "Tonight's your big night. Are you ready for it?... Are we ready for it?",
          "Tonight, I will speak directly to these people and make the situation perfectly clear to them. The security of this nation depends on complete and total compliance. Tonight, any protester, any instigator or agitator, will be made example of!",
          "Vi Veri Veniversum Vivus Vici",
          "Violence can be used for good.",
          "Wait! Here comes the crescendo!",
          "We are being buried beneath the avalanche of your inadequacies, Mr. Creedy!",
          "We're oft to blame, and this is too much proved, that with devotion's visage and pious action we do sugar on the devil himself.",
          "We're under siege here, the whole city's gone mad!",
          "What usually happens when people without guns stand up to people with guns.",
          "What was done to me created me. It's a basic principle of the Universe that every action will create an equal and opposing reaction.",
          "What was true in that cell is just as true now. What you felt in there has nothing to do with me.",
          "Who is but the form following the function of what and what I am is a man in a mask.",
          "Why should I trust you?",
          "Would you prefer a lie or the truth?",
          "Yes, Evey. I am V. At last you know the truth. You're stunned, I know. It's hard to believe isn't it, that beneath this wrinkled, well-fed exterior there lies a dangerous killing machine with a fetish for Fawkesian masks. ¡Viva la revolución!",
          "You did what you thought was right.",
          "You got to me? You did this to me? You cut my hair? You tortured me? You tortured me! Why?",
          "You mean, after what you've done? God, what have I done? I Maced that detective. Why did I do that?",
          "You said they were looking for you. If they know where you work, they certainly know where you live.",
          "You said you wanted to live without fear. I wish there'd been an easier way, but there wasn't.",
          "You show me ID, or I'll get Storm Saxon on your ass.",
          "You wear a mask for so long, you forget who you were beneath it.",
          "You were in the cell next to her. That's what it's all about... you're getting back at them for what they did to her... and to you.",
          "You're insane!",
          "You've been formally charged with three counts of murder, the bombing of government property, conspiracy to commit terrorism, treason, and sedition. The penalty for which is death by firing squad. You have one chance and only one chance to save your life. You must tell us the identity or whereabouts of codename V. If your information leads to his capture, you will be released from this facility immediately. Do you understand what I'm telling you? You can return to your life, Miss Hammond. All you have to do is cooperate.",
          "You... it is you!",
          "Your own father said that artists use lies to tell the truth. Yes, I created a lie. But because you believed it, you found something true about yourself.",
          "Your powers of observation continue to serve you well."
        ],
        "speeches": [
          "Good evening, London. Allow me first to apologize for this interruption. I do, like many of you, appreciate the comforts of every day routine- the security of the familiar, the tranquility of repetition. I enjoy them as much as any bloke. But in the spirit of commemoration, whereby those important events of the past, usually associated with someone's death or the end of some awful bloody struggle, a celebration of a nice holiday, I thought we could mark this November the 5th, a day that is sadly no longer remembered, by taking some time out of our daily lives to sit down and have a little chat. There are of course those who do not want us to speak. I suspect even now, orders are being shouted into telephones, and men with guns will soon be on their way. Why? Because while the truncheon may be used in lieu of conversation, words will always retain their power. Words offer the means to meaning, and for those who will listen, the enunciation of truth. And the truth is, there is something terribly wrong with this country, isn't there? Cruelty and injustice, intolerance and oppression. And where once you had the freedom to object, to think and speak as you saw fit, you now have censors and systems of surveillance coercing your conformity and soliciting your submission. How did this happen? Who's to blame? Well certainly there are those more responsible than others, and they will be held accountable, but again truth be told, if you're looking for the guilty, you need only look into a mirror. I know why you did it. I know you were afraid. Who wouldn't be? War, terror, disease. There were a myriad of problems which conspired to corrupt your reason and rob you of your common sense. Fear got the best of you, and in your panic you turned to the now high chancellor, Adam Sutler. He promised you order, he promised you peace, and all he demanded in return was your silent, obedient consent. Last night I sought to end that silence. Last night I destroyed the Old Bailey, to remind this country of what it has forgotten. More than four hundred years ago a great citizen wished to embed the fifth of November forever in our memory. His hope was to remind the world that fairness, justice, and freedom are more than words, they are perspectives. So if you've seen nothing, if the crimes of this government remain unknown to you, then I would suggest you allow the fifth of November to pass unmarked. But if you see what I see, if you feel as I feel, and if you would seek as I seek, then I ask you to stand beside me one year from tonight, outside the gates of Parliament, and together we shall give them a fifth of November that shall never, ever be forgot.",
          "I know there's no way I can convince you this is not one of their tricks, but I don't care, I am me. My name is Valerie, I don't think I'll live much longer and I wanted to tell someone about my life. This is the only autobiography I'll ever write, and god, I'm writing it on toilet paper. I was born in Nottingham in 1985, I don't remember much of those early years, but I do remember the rain. My grandmother owned a farm in Tuttlebrook, and she use to tell me that god was in the rain. I passed my 11th lesson into girl's grammar; it was at school that I met my first girlfriend, her name was Sara. It was her wrists. They were beautiful. I thought we would love each other forever. I remember our teacher telling us that is was an adolescent phase people outgrew. Sara did, I didn't. In 2002, I fell in love with a girl named Christina. That year I came out to my parents. I couldn't have done it without Chris holding my hand. My father wouldn't look at me, he told me to go and never come back. My mother said nothing. But I had only told them the truth, was that so selfish? Our integrity sells for so little, but it is all we really have. It is the very last inch of us, but within that inch, we are free. I'd always known what I wanted to do with my life, and in 2015 I starred in my first film, 'The Salt Flats'. It was the most important role of my life, not because of my career, but because that was how I met Ruth. The first time we kissed, I knew I never wanted to kiss any other lips but hers again. We moved to a small flat in London together. She grew Scarlet Carsons for me in our window box, and our place always smelled of roses. Those were there best years of my life. But America's war grew worse, and worse. And eventually came to London. After that there were no roses anymore. Not for anyone. I remember how the meaning of words began to change. How unfamiliar words like 'collateral' and 'rendition' became frightening. While things like Norse Fire and The Articles of Allegiance became powerful, I remember how different became dangerous. I still don't understand it, why they hate us so much. They took Ruth while she was out buying food. I've never cried so hard in my life. It wasn't long till they came for me. It seems strange that my life should end in such a terrible place, but for three years, I had roses, and apologized to no one. I shall die here. Every inch of me shall perish. Every inch, but one. An Inch, it is small and it is fragile, but it is the only thing the world worth having. We must never lose it or give it away. We must never let them take it from us. I hope that whoever you are, you escape this place. I hope that the world turns and that things get better. But what I hope most of all is that you understand what I mean when I tell you that even though I do not know you, and even though I may never meet you, laugh with you, cry with you, or kiss you. I love you. With all my heart, I love you. -Valerie",
          "Listen to me, Evey. This may be the most important moment of your life. Commit to it. They took your parents from you. They took your brother from you. They put you in a cell and took everything they could take except your life. And you believed that was all there was, didn't you? The only thing you had left was your life, but it wasn't, was it? You found something else. In that cell you found something that mattered more to you than life. It was when they threatened to kill you unless you gave them what they wanted... you told them you'd rather die. You faced your death, Evey. You were calm. You were still. Try to feel now what you felt then.",
          "My fellow Englishmen: tonight our country, that which we stand for, and all we hold dear, faces a grave and terrible threat. This violent and unparalleled assault on our security will not go undefended... or unpunished. Our enemy is an insidious one, seeking to divide us and destroy the very foundation of our great nation. Tonight, we must remain steadfast. We must remain determined. But most of all, we must remain united. Those caught tonight in violation of curfew will be considered in league with our enemy and prosecuted as a terrorist without leniency or exception. Tonight, I give you my most solemn vow: that justice will be swift, it will be righteous, and it will be without mercy.",
          "Our story begins, as these stories often do, with a young up-and-coming politician. He's a deeply religious man and a member of the conservative party. He is completely single-minded convictions and has no regard for the political process. Eventually, his party launches a special project in the name of 'national security'. At first, it is believed to be a search for biological weapons and it is pursued regardless of its cost. However, the true goal of the project is power, complete and total hegemonic domination. The project, however, ends violently... but the efforts of those involved are not in vain, for a new ability to wage war is born from the blood of one of their victims. Imagine a virus - the most terrifying virus you can, and then imagine that you and you alone have the cure. But if your ultimate goal is power, how best to use such a weapon? It is at this point in our story that along comes a spider. He is a man seemingly without a conscience; for whom the ends always justify the means and it is he who suggests that their target should not be an enemy of the country but rather the country itself. Three targets are chosen to maximize the effect of the attack: a school, a tube station, and a water-treatment plant. Several hundred die within the first few weeks. Until at last the true goal comes into view. Before the St. Mary's crisis, no one would have predicted the outcome of the elections. No one. But after the election, lo and behold, a miracle. Some believed that it was the work of God himself, but it was a pharmaceutical company controlled by certain party members made them all obscenely rich. But the true genius of the plan was the fear. A year later, several extremists are tried, found guilty, and executed while a memorial is built to canonize their victims. Fear became the ultimate tool of this government. And through it our politician was ultimately appointed to the newly created position of High Chancellor. The rest, as they say, is history.",
          "Remember, remember, the Fifth of November, the Gunpowder Treason and Plot. I know of no reason why the Gunpowder Treason should ever be forgot... But what of the man? I know his name was Guy Fawkes and I know, in 1605, he attempted to blow up the Houses of Parliament. But who was he really? What was he like? We are told to remember the idea, not the man, because a man can fail. He can be caught, he can be killed and forgotten, but 400 years later, an idea can still change the world. I've witnessed first hand the power of ideas, I've seen people kill in the name of them, and die defending them... but you cannot kiss an idea, cannot touch it, or hold it... ideas do not bleed, they do not feel pain, they do not love... And it is not an idea that I miss, it is a man... A man that made me remember the Fifth of November. A man that I will never forget.",
          "So I read that the former United States is so desperate for medical supplies that they have allegedly sent several containers filled with wheat and tobacco. A gesture, they said, of good will. You wanna know what I think? Well, you're listening to my show, so I will assume you do... I think it's high time we let the colonies know what we really think of them. I think its payback time for a little tea party they threw for us a few hundred years ago. I say we go down to those docks tonight and dump that crap where everything from the Ulcered Sphincter of Arse-erica belongs! Who's with me? Who's bloody with me? Did you like that? USA... Ulcered Sphincter of Arse-erica, I mean what else can you say? Here was a country that had everything, absolutely everything. And now, 20 years later, is what? The world's biggest leper colony. Why? Godlessness. Let me say that again... Godlessness. It wasn't the war they started. It wasn't the plague they created. It was Judgement. No one escapes their past. No one escapes Judgement. You think he's not up there? You think he's not watching over this country? How else can you explain it? He tested us, but we came through. We did what we had to do. Islington. Enfield. I was there, I saw it all. Immigrants, Muslims, homosexuals, terrorists. Disease-ridden degenerates. They had to go. Strength through unity. Unity through faith. I'm a God-fearing Englishman and I'm goddamn proud of it!",
          "Voilà! In view, a humble vaudevillian veteran, cast vicariously as both victim and villain by the vicissitudes of Fate. This visage, no mere veneer of vanity, is a vestige of the vox populi, now vacant, vanished. However, this valorous visitation of a by-gone vexation, stands vivified and has vowed to vanquish these venal and virulent vermin vanguarding vice and vouchsafing the violently vicious and voracious violation of volition. The only verdict is vengeance; a vendetta, held as a votive, not in vain, for the value and veracity of such shall one day vindicate the vigilant and the virtuous. Verily, this vichyssoise of verbiage veers most verbose, so let me simply add that it's my very good honor to meet you and you may call me V."
        ]
      },
      "vehicle": {
        "car_options": [
          "A/C: Front",
          "Airbag: Driver",
          "AM/FM Stereo",
          "A/C: Rear",
          "Airbag: Passenger",
          "Cassette Player",
          "Cruise Control",
          "Airbag: Side",
          "CD (Single Disc)",
          "Navigation",
          "Alarm",
          "CD (Multi Disc)",
          "Power Locks",
          "Antilock Brakes",
          "MP3 (Single Disc)",
          "Power Steering",
          "Fog Lights",
          "MP3 (Multi Disc)",
          "Keyless Entry",
          "Premium Sound",
          "Integrated Phone",
          "DVD System",
          "Bucket Seats",
          "Power Windows",
          "Alloy Wheels",
          "Leather Interior",
          "Rear Window Defroster",
          "Moonroof/Sunroof",
          "Memory Seats",
          "Rear Window Wiper",
          "Third Row Seats",
          "Power Seats",
          "Tinted Glass",
          "Tow Package"
        ],
        "car_types": [
          "Cargo Van",
          "Convertible",
          "Coupe",
          "Crew Cab Pickup",
          "Extended Cab Pickup",
          "Hatchback",
          "Minivan",
          "Passenger Van",
          "Regular Cab Pickup",
          "SUV",
          "Sedan",
          "Wagon"
        ],
        "colors": [
          "Red",
          "Orange",
          "Yellow",
          "Green",
          "Blue",
          "Violet",
          "Black",
          "White",
          "Grey",
          "Beige"
        ],
        "cylinder_engine": "Cylinder Engine",
        "doors": [
          1,
          2,
          3,
          4
        ],
        "drive_types": [
          "4x2/2-wheel drive",
          "4x4/4-wheel drive",
          "AWD",
          "FWD",
          "RWD"
        ],
        "engine_sizes": [
          4,
          6,
          8
        ],
        "fuel_types": [
          "Compressed Natural Gas",
          "Diesel",
          "E-85/Gasoline",
          "Electric",
          "Gasoline",
          "Gasoline Hybrid",
          "Ethanol"
        ],
        "license_plate": "???-####",
        "license_plate_by_state": {
          "AK": "??? ###",
          "AL": [
            "#??####",
            "##??###"
          ],
          "AR": "### ???",
          "AZ": "???####",
          "CA": "#???###",
          "CO": "???-###",
          "CT": "??·#####",
          "DE": "######",
          "FL": [
            "### ???",
            "??? ?##",
            "### #??"
          ],
          "GA": "???####",
          "HI": "??? ###",
          "IA": "??? ###",
          "ID": [
            "1A #####",
            "1A ?####",
            "1A ??###",
            "1A #?###",
            "1A ####?",
            "1A ###??",
            "2A #####",
            "2A ?####",
            "2A ??###",
            "2A #?###",
            "2A ####?",
            "2A ###??",
            "1B #####",
            "1B ?####",
            "1B ??###",
            "1B #?###",
            "1B ####?",
            "1B ###??",
            "2B #####",
            "2B ?####",
            "2B ??###",
            "2B #?###",
            "2B ####?",
            "2B ###??",
            "3B #####",
            "3B ?####",
            "3B ??###",
            "3B #?###",
            "3B ####?",
            "3B ###??",
            "4B #####",
            "4B ?####",
            "4B ??###",
            "4B #?###",
            "4B ####?",
            "4B ###??",
            "5B #####",
            "5B ?####",
            "5B ??###",
            "5B #?###",
            "5B ####?",
            "5B ###??",
            "6B #####",
            "6B ?####",
            "6B ??###",
            "6B #?###",
            "6B ####?",
            "6B ###??",
            "7B #####",
            "7B ?####",
            "7B ??###",
            "7B #?###",
            "7B ####?",
            "7B ###??",
            "8B #####",
            "8B ?####",
            "8B ??###",
            "8B #?###",
            "8B ####?",
            "8B ###??",
            "9B #####",
            "9B ?####",
            "9B ??###",
            "9B #?###",
            "9B ####?",
            "9B ###??",
            "10B ####",
            "10B ?###",
            "1C #####",
            "1C ?####",
            "1C ??###",
            "1C #?###",
            "1C ####?",
            "1C ###??",
            "2C #####",
            "2C ?####",
            "2C ??###",
            "2C #?###",
            "2C ####?",
            "2C ###??",
            "3C #####",
            "3C ?####",
            "3C ??###",
            "3C #?###",
            "3C ####?",
            "3C ###??",
            "4C #####",
            "4C ?####",
            "4C ??###",
            "4C #?###",
            "4C ####?",
            "4C ###??",
            "5C #####",
            "5C ?####",
            "5C ??###",
            "5C #?###",
            "5C ####?",
            "5C ###??",
            "6C #####",
            "6C ?####",
            "6C ??###",
            "6C #?###",
            "6C ####?",
            "6C ###??",
            "7C #####",
            "7C ?####",
            "7C ??###",
            "7C #?###",
            "7C ####?",
            "7C ###??",
            "E ######",
            "1F #####",
            "1F ?####",
            "1F ??###",
            "1F #?###",
            "1F ####?",
            "1F ###??",
            "2F #####",
            "2F ?####",
            "2F ??###",
            "2F #?###",
            "2F ####?",
            "2F ###??",
            "1G #####",
            "1G ?####",
            "1G ??###",
            "1G #?###",
            "1G ####?",
            "1G ###??",
            "2G #####",
            "2G ?####",
            "2G ??###",
            "2G #?###",
            "2G ####?",
            "2G ###??",
            "I ######",
            "1J #####",
            "1J ?####",
            "1J ??###",
            "1J #?###",
            "1J ####?",
            "1J ###??",
            "2J #####",
            "2J ?####",
            "2J ??###",
            "2J #?###",
            "2J ####?",
            "2J ###??",
            "K ######",
            "1L #####",
            "1L ?####",
            "1L ??###",
            "1L #?###",
            "1L ####?",
            "1L ###??",
            "3L #####",
            "3L ?####",
            "3L ??###",
            "3L #?###",
            "3L ####?",
            "3L ###??",
            "4L #####",
            "4L ?####",
            "4L ??###",
            "4L #?###",
            "4L ####?",
            "4L ###??",
            "1M #####",
            "1M ?####",
            "1M ??###",
            "1M #?###",
            "1M ####?",
            "1M ###??",
            "2M #####",
            "2M ?####",
            "2M ??###",
            "2M #?###",
            "2M ####?",
            "2M ###??",
            "N ######",
            "1O #####",
            "1O ?####",
            "1O ??###",
            "1O #?###",
            "1O ####?",
            "1O ###??",
            "2O #####",
            "2O ?####",
            "2O ??###",
            "2O #?###",
            "2O ####?",
            "2O ###??",
            "1P #####",
            "1P ?####",
            "1P ??###",
            "1P #?###",
            "1P ####?",
            "1P ###??",
            "2P #####",
            "2P ?####",
            "2P ??###",
            "2P #?###",
            "2P ####?",
            "2P ###??",
            "S ######",
            "1T #####",
            "1T ?####",
            "1T ??###",
            "1T#?###",
            "1T ####?",
            "1T ###??",
            "2T #####",
            "2T ?####",
            "2T ??###",
            "2T #?###",
            "2T ####?",
            "2T ###??",
            "V ######",
            "W ######"
          ],
          "IL": [
            "??# ####",
            "?? #####"
          ],
          "IN": [
            "###?",
            "###??",
            "###???",
            "####??",
            "#####?",
            "#### ???"
          ],
          "KS": "### ???",
          "KY": "### ???",
          "LA": [
            "ZP? ###",
            "ZQ? ###",
            "ZR? ###",
            "ZS? ###",
            "ZT? ###",
            "ZU? ###",
            "ZV? ###",
            "ZW? ###",
            "ZX? ###",
            "ZY? ###",
            "ZZ? ###",
            "### AAA",
            "### AAB",
            "### AAC",
            "### AAD",
            "### AAE",
            "### AAF",
            "### AAG",
            "### AAH",
            "### AAI",
            "### AAJ",
            "### AAK",
            "### AAL",
            "### AAM",
            "### AAN",
            "### AAO",
            "### AAP",
            "### AAQ",
            "### AAR",
            "### AAS",
            "### AAT",
            "### AAU",
            "### AAV",
            "### AAW",
            "### AAX",
            "### AAY",
            "### AAZ",
            "### ABA",
            "### ABB",
            "### ABC",
            "### ABD",
            "### ABE",
            "### ABF",
            "### ABG",
            "### ABH",
            "### ABI",
            "### ABJ",
            "### ABK",
            "### ABL",
            "### ABM",
            "### ABN",
            "### ABO",
            "### ABP",
            "### ABQ",
            "### ABR",
            "### ABS",
            "### ABT",
            "### ABU",
            "### ABV",
            "### ABW",
            "### ABX",
            "### ABY",
            "### ABZ",
            "### ACA",
            "### ACB",
            "### ACC",
            "### ACD",
            "### ACE",
            "### ACF",
            "### ACG",
            "### ACH",
            "### ACI",
            "### ACJ",
            "### ACK",
            "### ACL",
            "### ACM",
            "### ACN",
            "### ACO",
            "### ACP",
            "### ACQ",
            "### ACR",
            "### ACS",
            "### ACT",
            "### ACU",
            "### ACV",
            "### ACW",
            "### ACX",
            "### ACY",
            "### ACZ",
            "### ADA",
            "### ADB",
            "### ADC",
            "### ADD",
            "### ADE",
            "### ADF",
            "### ADG",
            "### ADH",
            "### ADI",
            "### ADJ",
            "### ADK",
            "### ADL",
            "### ADM",
            "### ADN",
            "### ADO",
            "### ADP",
            "### ADQ",
            "### ADR",
            "### ADS",
            "### ADT",
            "### ADU",
            "### ADV",
            "### ADW",
            "### ADX",
            "### ADY",
            "### ADZ",
            "### AEA",
            "### AEB",
            "### AEC",
            "### AED",
            "### AEE",
            "### AEF",
            "### AEG",
            "### AEH",
            "### AEI",
            "### AEJ",
            "### AEK",
            "### AEL",
            "### AEM",
            "### AEN",
            "### AEO",
            "### AEP",
            "### AEQ",
            "### AER",
            "### AES",
            "### AET",
            "### AEU",
            "### AEV",
            "### AEW",
            "### AEX",
            "### AEY",
            "### AEZ",
            "### AFA",
            "### AFB",
            "### AFC",
            "### AFD",
            "### AFE",
            "### AFF",
            "### AFG",
            "### AFH",
            "### AFI",
            "### AFJ",
            "### AFK",
            "### AFL",
            "### AFM",
            "### AFN",
            "### AFO",
            "### AFP",
            "### AFQ",
            "### AFR",
            "### AFS",
            "### AFT",
            "### AFU",
            "### AFV",
            "### AFW",
            "### AFX",
            "### AFY",
            "### AFZ",
            "### AGA",
            "### AGB",
            "### AGC",
            "### AGD",
            "### AGE",
            "### AGF",
            "### AGG",
            "### AGH",
            "### AGI",
            "### AGJ",
            "### AGK",
            "### AGL",
            "### AGM",
            "### AGN",
            "### AGO",
            "### AGP",
            "### AGQ",
            "### AGR",
            "### AGS",
            "### AGT",
            "### AGU",
            "### AGV",
            "### AGW",
            "### AGX",
            "### AGY",
            "### AGZ",
            "### AHA",
            "### AHB",
            "### AHC",
            "### AHD",
            "###AHE",
            "### AHF",
            "### AHG",
            "### AHH",
            "### AHI",
            "### AHJ",
            "### AHK",
            "### AHL",
            "### AHM",
            "### AHN",
            "### AHO",
            "### AHP",
            "### AHQ",
            "### AHR",
            "### AHS",
            "### AHT",
            "### AHU",
            "### AHV",
            "### AHW",
            "### AHX",
            "### AHY",
            "### AHZ",
            "### AIA",
            "### AIB",
            "### AIC",
            "### AID",
            "### AIE",
            "### AIF",
            "### AIG",
            "### AIH",
            "### AII",
            "### AIJ",
            "### AIK",
            "### AIL",
            "### AIM",
            "### AIN",
            "### AIO",
            "### AIP",
            "### AIQ",
            "### AIR",
            "### AIS",
            "### AIT",
            "### AIU",
            "### AIV",
            "### AIW",
            "### AIX",
            "### AIY",
            "### AIZ",
            "### AJA",
            "### AJB",
            "### AJC",
            "### AJD",
            "### AJE",
            "### AJF",
            "### AJG",
            "### AJH",
            "### AJI",
            "### AJJ",
            "### AJK",
            "### AJL",
            "### AJM",
            "### AJN",
            "### AJO",
            "### AJP",
            "### AJQ",
            "### AJR",
            "### AJS",
            "### AJT",
            "### AJU",
            "### AJV",
            "### AJW",
            "### AJX",
            "### AJY",
            "### AJZ",
            "### AKA",
            "### AKB",
            "### AKC",
            "### AKD",
            "### AKE",
            "### AKF",
            "### AKG",
            "### AKH",
            "### AKI",
            "### AKJ",
            "### AKK",
            "### AKL",
            "### AKM",
            "### AKN",
            "### AKO",
            "### AKP",
            "### AKQ",
            "### AKR",
            "### AKS",
            "### AKT",
            "### AKU",
            "### AKV",
            "### AKW",
            "### AKX",
            "### AKY",
            "### AKZ",
            "### ALA",
            "### ALB",
            "### ALC",
            "### ALD",
            "### ALE",
            "### ALF",
            "### ALG",
            "### ALH",
            "### ALI",
            "### ALJ",
            "### ALK",
            "### ALL",
            "### ALM",
            "### ALN",
            "### ALO",
            "### ALP",
            "### ALQ",
            "### ALR",
            "### ALS",
            "### ALT",
            "### ALU",
            "### ALV",
            "### ALW",
            "### ALX",
            "### ALY",
            "### ALZ",
            "### AMA",
            "### AMB",
            "### AMC",
            "### AMD",
            "### AME",
            "### AMF",
            "### AMG",
            "### AMH",
            "### AMI",
            "### AMJ",
            "### AMK",
            "### AML",
            "### AMM",
            "### AMN",
            "### AMO",
            "### AMP",
            "### AMQ",
            "### AMR",
            "### AMS",
            "### AMT",
            "### AMU",
            "### AMV",
            "### AMW",
            "### AMX",
            "### AMY",
            "### AMZ",
            "### ANA",
            "### ANB",
            "### ANC",
            "### AND",
            "### ANE",
            "### ANF",
            "### ANG",
            "### ANH",
            "### ANI",
            "### ANJ",
            "### ANK",
            "### ANL",
            "### ANM",
            "### ANN",
            "### ANO",
            "### ANP",
            "### ANQ",
            "### ANR",
            "### ANS",
            "### ANT",
            "### ANU",
            "### ANV",
            "### ANW",
            "### ANX",
            "### ANY",
            "### ANZ",
            "### AOA",
            "### AOB",
            "### AOC",
            "### AOD",
            "### AOE",
            "### AOF",
            "### AOG",
            "### AOH",
            "### AOI",
            "### AOJ",
            "### AOK",
            "### AOL",
            "### AOM",
            "### AON",
            "### AOO",
            "### AOP",
            "### AOQ",
            "### AOR",
            "### AOS",
            "### AOT",
            "### AOU",
            "### AOV",
            "### AOW",
            "### AOX",
            "### AOY",
            "### AOZ",
            "### APA",
            "### APB",
            "### APC",
            "### APD",
            "### APE",
            "### APF",
            "### APG",
            "### APH",
            "### API",
            "### APJ",
            "### APK",
            "### APL",
            "### APM",
            "### APN",
            "### APO",
            "### APP",
            "### APQ",
            "### APR",
            "### APS",
            "### APT",
            "### APU",
            "### APV",
            "### APW",
            "### APX",
            "### APY",
            "### APZ",
            "### AQA",
            "### AQB",
            "### AQC",
            "### AQD",
            "### AQE",
            "### AQF",
            "### AQG",
            "### AQH",
            "### AQI",
            "### AQJ",
            "### AQK",
            "### AQL",
            "### AQM",
            "### AQN",
            "### AQO",
            "### AQP",
            "### AQQ",
            "### AQR",
            "### AQS",
            "### AQT",
            "### AQU",
            "### AQV",
            "### AQW",
            "### AQX",
            "### AQY",
            "### AQZ",
            "### ARA",
            "### ARB",
            "### ARC",
            "### ARD",
            "### ARE",
            "### ARF",
            "### ARG",
            "### ARH",
            "### ARI",
            "### ARJ",
            "### ARK",
            "### ARL",
            "### ARM",
            "### ARN",
            "### ARO",
            "### ARP",
            "### ARQ",
            "### ARR",
            "### ARS",
            "### ART",
            "### ARU",
            "### ARV",
            "### ARW",
            "### ARX",
            "### ARY",
            "### ARZ",
            "### ASA",
            "### ASB",
            "### ASC",
            "### ASD",
            "### ASE",
            "### ASF",
            "### ASG",
            "### ASH",
            "### ASI",
            "### ASJ",
            "### ASK",
            "###ASL",
            "### ASM",
            "### ASN",
            "### ASO",
            "### ASP",
            "### ASQ",
            "### ASR",
            "### ASS",
            "### AST",
            "### ASU",
            "### ASV",
            "### ASW",
            "### ASX",
            "### ASY",
            "### ASZ",
            "### ATA",
            "### ATB",
            "### ATC",
            "### ATD",
            "### ATE",
            "### ATF",
            "### ATG",
            "### ATH",
            "### ATI",
            "### ATJ",
            "### ATK",
            "### ATL",
            "### ATM",
            "### ATN",
            "### ATO",
            "### ATP",
            "### ATQ",
            "### ATR",
            "### ATS",
            "### ATT",
            "### ATU",
            "### ATV",
            "### ATW",
            "### ATX",
            "### ATY",
            "### ATZ",
            "### AUA",
            "### AUB",
            "### AUC",
            "### AUD",
            "### AUE",
            "### AUF",
            "### AUG",
            "### AUH",
            "### AUI",
            "### AUJ",
            "### AUK",
            "### AUL",
            "### AUM",
            "### AUN",
            "### AUO",
            "### AUP",
            "### AUQ",
            "### AUR",
            "### AUS",
            "### AUT",
            "### AUU",
            "### AUV",
            "### AUW",
            "### AUX",
            "### AUY",
            "### AUZ",
            "### AVA",
            "### AVB",
            "### AVC",
            "### AVD",
            "### AVE",
            "### AVF",
            "### AVG",
            "### AVH",
            "### AVI",
            "### AVJ",
            "### AVK",
            "### AVL",
            "### AVM",
            "### AVN",
            "### AVO",
            "### AVP",
            "### AVQ",
            "### AVR",
            "### AVS",
            "### AVT",
            "### AVU",
            "### AVV",
            "### AVW",
            "### AVX",
            "### AVY",
            "### AVZ",
            "### AWA",
            "### AWB",
            "### AWC",
            "### AWD",
            "### AWE",
            "### AWF",
            "### AWG",
            "### AWH",
            "### AWI",
            "### AWJ",
            "### AWK",
            "### AWL",
            "### AWM",
            "### AWN",
            "### AWO",
            "### AWP",
            "### AWQ",
            "### AWR",
            "### AWS",
            "### AWT",
            "### AWU",
            "### AWV",
            "### AWW",
            "### AWX",
            "### AWY",
            "### AWZ",
            "### AXA",
            "### AXB",
            "### AXC",
            "### AXD",
            "### AXE",
            "### AXF",
            "### AXG",
            "### AXH",
            "### AXI",
            "### AXJ",
            "### AXK",
            "### AXL",
            "### AXM",
            "### AXN",
            "### AXO",
            "### AXP",
            "### AXQ",
            "### AXR",
            "### AXS",
            "### AXT",
            "### AXU",
            "### AXV",
            "### AXW",
            "### AXX",
            "### AXY",
            "### AXZ",
            "### AYA",
            "### AYB",
            "### AYC",
            "### AYD",
            "### AYE",
            "### AYF",
            "### AYG",
            "### AYH",
            "### AYI",
            "### AYJ",
            "### AYK",
            "### AYL",
            "### AYM",
            "### AYN",
            "### AYO",
            "### AYP",
            "### AYQ",
            "### AYR",
            "### AYS",
            "### AYT",
            "### AYU",
            "### AYV",
            "### AYW",
            "### AYX",
            "### AYY",
            "### AYZ",
            "### AZA",
            "### AZB",
            "### AZC",
            "### AZD",
            "### AZE",
            "### AZF",
            "### AZG",
            "### AZH",
            "### AZI",
            "### AZJ",
            "### AZK",
            "### AZL",
            "### AZM",
            "### AZN",
            "### AZO",
            "### AZP",
            "### AZQ",
            "### AZR",
            "### AZS",
            "### AZT",
            "### AZU",
            "### AZV",
            "### AZW",
            "### AZX",
            "### AZY",
            "### AZZ",
            "### BAA",
            "### BAB",
            "### BAC",
            "### BAD",
            "### BAE",
            "### BAF",
            "### BAG",
            "### BAH",
            "### BAI",
            "### BAJ",
            "### BAK",
            "### BAL",
            "### BAM",
            "### BAN",
            "### BAO",
            "### BAP",
            "### BAQ",
            "### BAR",
            "### BAS",
            "### BAT",
            "### BAU",
            "### BAV",
            "### BAW",
            "### BAX",
            "### BAY",
            "### BAZ",
            "### BBA",
            "### BBB",
            "### BBC",
            "### BBD",
            "### BBE",
            "### BBF",
            "### BBG",
            "### BBH",
            "### BBI",
            "### BBJ",
            "### BBK",
            "### BBL",
            "### BBM",
            "### BBN",
            "### BBO",
            "### BBP",
            "### BBQ",
            "### BBR",
            "### BBS",
            "### BBT",
            "### BBU",
            "### BBV",
            "### BBW",
            "### BBX",
            "### BBY",
            "### BBZ",
            "### BCA",
            "### BCB",
            "### BCC",
            "### BCD",
            "### BCE",
            "### BCF",
            "### BCG",
            "### BCH",
            "### BCI",
            "### BCJ",
            "### BCK",
            "### BCL",
            "### BCM",
            "### BCN",
            "### BCO",
            "### BCP",
            "### BCQ",
            "### BCR",
            "### BCS",
            "### BCT",
            "### BCU",
            "### BCV",
            "### BCW",
            "### BCX",
            "### BCY",
            "### BCZ",
            "### BDA",
            "### BDB",
            "### BDC",
            "### BDD",
            "### BDE",
            "### BDF",
            "### BDG",
            "### BDH",
            "### BDI",
            "### BDJ",
            "### BDK",
            "### BDL",
            "### BDM",
            "### BDN",
            "### BDO",
            "### BDP",
            "### BDQ",
            "### BDR",
            "###BDS",
            "### BDT",
            "### BDU",
            "### BDV",
            "### BDW",
            "### BDX",
            "### BDY",
            "### BDZ",
            "### BEA",
            "### BEB",
            "### BEC",
            "### BED",
            "### BEE",
            "### BEF",
            "### BEG",
            "### BEH",
            "### BEI",
            "### BEJ",
            "### BEK",
            "### BEL",
            "### BEM",
            "### BEN",
            "### BEO",
            "### BEP",
            "### BEQ",
            "### BER",
            "### BES",
            "### BET",
            "### BEU",
            "### BEV",
            "### BEW",
            "### BEX",
            "### BEY",
            "### BEZ",
            "### BFA",
            "### BFB",
            "### BFC",
            "### BFD",
            "### BFE",
            "### BFF",
            "### BFG",
            "### BFH",
            "### BFI",
            "### BFJ",
            "### BFK",
            "### BFL",
            "### BFM",
            "### BFN",
            "### BFO",
            "### BFP",
            "### BFQ",
            "### BFR",
            "### BFS",
            "### BFT",
            "### BFU",
            "### BFV",
            "### BFW",
            "### BFX",
            "### BFY",
            "### BFZ",
            "### BGA",
            "### BGB",
            "### BGC",
            "### BGD",
            "### BGE",
            "### BGF",
            "### BGG",
            "### BGH",
            "### BGI",
            "### BGJ",
            "### BGK",
            "### BGL",
            "### BGM",
            "### BGN",
            "### BGO",
            "### BGP",
            "### BGQ",
            "### BGR",
            "### BGS",
            "### BGT",
            "### BGU",
            "### BGV",
            "### BGW",
            "### BGX",
            "### BGY",
            "### BGZ",
            "### BHA",
            "### BHB",
            "### BHC",
            "### BHD",
            "### BHE",
            "### BHF",
            "### BHG",
            "### BHH",
            "### BHI",
            "### BHJ",
            "### BHK",
            "### BHL",
            "### BHM",
            "### BHN",
            "### BHO",
            "### BHP",
            "### BHQ",
            "### BHR",
            "### BHS",
            "### BHT",
            "### BHU",
            "### BHV",
            "### BHW",
            "### BHX",
            "### BHY",
            "### BHZ",
            "### BIA",
            "### BIB",
            "### BIC",
            "### BID",
            "### BIE",
            "### BIF",
            "### BIG",
            "### BIH",
            "### BII",
            "### BIJ",
            "### BIK",
            "### BIL",
            "### BIM",
            "### BIN",
            "### BIO",
            "### BIP",
            "### BIQ",
            "### BIR",
            "### BIS",
            "### BIT",
            "### BIU",
            "### BIV",
            "### BIW",
            "### BIX",
            "### BIY",
            "### BIZ",
            "### BJA",
            "### BJB",
            "### BJC",
            "### BJD",
            "### BJE",
            "### BJF",
            "### BJG",
            "### BJH",
            "### BJI",
            "### BJJ",
            "### BJK",
            "### BJL",
            "### BJM",
            "### BJN",
            "### BJO",
            "### BJP",
            "### BJQ",
            "### BJR",
            "### BJS",
            "### BJT",
            "### BJU",
            "### BJV",
            "### BJW",
            "### BJX",
            "### BJY",
            "### BJZ",
            "### BKA",
            "### BKB",
            "### BKC",
            "### BKD",
            "### BKE",
            "### BKF",
            "### BKG",
            "### BKH",
            "### BKI",
            "### BKJ",
            "### BKK",
            "### BKL",
            "### BKM",
            "### BKN",
            "### BKO",
            "### BKP",
            "### BKQ",
            "### BKR",
            "### BKS",
            "### BKT",
            "### BKU",
            "### BKV",
            "### BKW",
            "### BKX",
            "### BKY",
            "### BKZ",
            "### BLA",
            "### BLB",
            "### BLC",
            "### BLD",
            "### BLE",
            "### BLF",
            "### BLG",
            "### BLH",
            "### BLI",
            "### BLJ",
            "### BLK",
            "### BLL",
            "### BLM",
            "### BLN",
            "### BLO",
            "### BLP",
            "### BLQ",
            "### BLR",
            "### BLS",
            "### BLT",
            "### BLU",
            "### BLV",
            "### BLW",
            "### BLX",
            "### BLY",
            "### BLZ",
            "### BMA",
            "### BMB",
            "### BMC",
            "### BMD",
            "### BME",
            "### BMF",
            "### BMG",
            "### BMH",
            "### BMI",
            "### BMJ",
            "### BMK",
            "### BML",
            "### BMM",
            "### BMN",
            "### BMO",
            "### BMP",
            "### BMQ",
            "### BMR",
            "### BMS",
            "### BMT",
            "### BMU",
            "### BMV",
            "### BMW",
            "### BMX",
            "### BMY",
            "### BMZ",
            "### BNA",
            "### BNB",
            "### BNC",
            "### BND",
            "### BNE",
            "### BNF",
            "### BNG",
            "### BNH",
            "### BNI",
            "### BNJ",
            "### BNK",
            "### BNL",
            "### BNM",
            "### BNN",
            "### BNO",
            "### BNP",
            "### BNQ",
            "### BNR",
            "### BNS",
            "### BNT",
            "### BNU",
            "### BNV",
            "### BNW",
            "### BNX",
            "### BNY",
            "### BNZ",
            "### BOA",
            "### BOB",
            "### BOC",
            "### BOD",
            "### BOE",
            "### BOF",
            "### BOG",
            "### BOH",
            "### BOI",
            "### BOJ",
            "### BOK",
            "### BOL",
            "### BOM",
            "### BON",
            "### BOO",
            "### BOP",
            "### BOQ",
            "### BOR",
            "### BOS",
            "### BOT",
            "### BOU",
            "### BOV",
            "### BOW",
            "### BOX",
            "### BOY",
            "###BOZ",
            "### BPA",
            "### BPB",
            "### BPC",
            "### BPD",
            "### BPE",
            "### BPF",
            "### BPG",
            "### BPH",
            "### BPI",
            "### BPJ",
            "### BPK",
            "### BPL",
            "### BPM",
            "### BPN",
            "### BPO",
            "### BPP",
            "### BPQ",
            "### BPR",
            "### BPS",
            "### BPT",
            "### BPU",
            "### BPV",
            "### BPW",
            "### BPX",
            "### BPY",
            "### BPZ",
            "### BQA",
            "### BQB",
            "### BQC",
            "### BQD",
            "### BQE",
            "### BQF",
            "### BQG",
            "### BQH",
            "### BQI",
            "### BQJ",
            "### BQK",
            "### BQL",
            "### BQM",
            "### BQN",
            "### BQO",
            "### BQP",
            "### BQQ",
            "### BQR",
            "### BQS",
            "### BQT",
            "### BQU",
            "### BQV",
            "### BQW",
            "### BQX",
            "### BQY",
            "### BQZ",
            "### BRA",
            "### BRB",
            "### BRC",
            "### BRD",
            "### BRE",
            "### BRF",
            "### BRG",
            "### BRH",
            "### BRI",
            "### BRJ",
            "### BRK",
            "### BRL",
            "### BRM",
            "### BRN",
            "### BRO",
            "### BRP",
            "### BRQ",
            "### BRR",
            "### BRS",
            "### BRT",
            "### BRU",
            "### BRV",
            "### BRW",
            "### BRX",
            "### BRY",
            "### BRZ",
            "### BSA",
            "### BSB",
            "### BSC",
            "### BSD",
            "### BSE",
            "### BSF",
            "### BSG",
            "### BSH",
            "### BSI",
            "### BSJ",
            "### BSK",
            "### BSL",
            "### BSM",
            "### BSN",
            "### BSO",
            "### BSP",
            "### BSQ",
            "### BSR",
            "### BSS",
            "### BST",
            "### BSU",
            "### BSV",
            "### BSW",
            "### BSX",
            "### BSY",
            "### BSZ",
            "### BTA",
            "### BTB",
            "### BTC",
            "### BTD",
            "### BTE",
            "### BTF",
            "### BTG",
            "### BTH",
            "### BTI",
            "### BTJ",
            "### BTK",
            "### BTL",
            "### BTM",
            "### BTN",
            "### BTO",
            "### BTP",
            "### BTQ",
            "### BTR",
            "### BTS",
            "### BTT",
            "### BTU",
            "### BTV",
            "### BTW",
            "### BTX",
            "### BTY",
            "### BTZ",
            "### BUA",
            "### BUB",
            "### BUC",
            "### BUD",
            "### BUE",
            "### BUF",
            "### BUG",
            "### BUH",
            "### BUI",
            "### BUJ",
            "### BUK",
            "### BUL",
            "### BUM",
            "### BUN",
            "### BUO",
            "### BUP",
            "### BUQ",
            "### BUR",
            "### BUS",
            "### BUT",
            "### BUU",
            "### BUV",
            "### BUW",
            "### BUX",
            "### BUY",
            "### BUZ",
            "### BVA",
            "### BVB",
            "### BVC",
            "### BVD",
            "### BVE",
            "### BVF",
            "### BVG",
            "### BVH",
            "### BVI",
            "### BVJ",
            "### BVK",
            "### BVL",
            "### BVM",
            "### BVN",
            "### BVO",
            "### BVP",
            "### BVQ",
            "### BVR",
            "### BVS",
            "### BVT",
            "### BVU",
            "### BVV",
            "### BVW",
            "### BVX",
            "### BVY",
            "### BVZ",
            "### BWA",
            "### BWB",
            "### BWC",
            "### BWD",
            "### BWE",
            "### BWF",
            "### BWG",
            "### BWH",
            "### BWI",
            "### BWJ",
            "### BWK",
            "### BWL",
            "### BWM",
            "### BWN",
            "### BWO",
            "### BWP",
            "### BWQ",
            "### BWR",
            "### BWS",
            "### BWT",
            "### BWU",
            "### BWV",
            "### BWW",
            "### BWX",
            "### BWY",
            "### BWZ",
            "### BXA",
            "### BXB",
            "### BXC",
            "### BXD",
            "### BXE",
            "### BXF",
            "### BXG",
            "### BXH",
            "### BXI",
            "### BXJ",
            "### BXK",
            "### BXL",
            "### BXM",
            "### BXN",
            "### BXO",
            "### BXP",
            "### BXQ"
          ],
          "MA": [
            "###·???",
            "###·#??",
            "#### ??",
            "##? ?##",
            "### ??#",
            "#?? ###",
            "#??? ##"
          ],
          "MD": [
            "#CN####",
            "#CO####",
            "#CP####",
            "#CQ####",
            "#CR####",
            "#CS####",
            "#CT####",
            "#CU####",
            "#CV####",
            "#CW####",
            "#CX####",
            "#CY####",
            "#CZ####",
            "#DA####",
            "#DB####",
            "#DC####",
            "#DD####",
            "#DE####"
          ],
          "ME": [
            "#### GA",
            "#### GB",
            "#### GC",
            "#### GD",
            "#### GE",
            "#### GF",
            "#### GG",
            "#### GH",
            "#### GI",
            "#### GJ",
            "#### GK",
            "#### GL",
            "#### GM",
            "#### GN",
            "#### GO",
            "#### GP",
            "#### GQ",
            "#### GR",
            "#### GS",
            "#### GT",
            "#### GU",
            "#### GV",
            "#### GW",
            "#### GX",
            "#### GY",
            "#### GZ",
            "#### HA",
            "#### HB",
            "#### HC",
            "#### HD",
            "#### HE",
            "#### HF",
            "#### HG",
            "#### HH",
            "#### HI",
            "#### HJ",
            "#### HK",
            "#### HL",
            "#### HM",
            "#### HN",
            "#### HO",
            "#### HP",
            "#### HQ",
            "#### HR",
            "#### HS",
            "#### HT",
            "#### HU",
            "#### HV",
            "#### HW",
            "#### HX",
            "#### HY",
            "#### HZ",
            "#### IA",
            "#### IB",
            "#### IC",
            "#### ID",
            "#### IE",
            "#### IF",
            "#### IG",
            "#### IH",
            "#### II",
            "#### IJ",
            "#### IK",
            "#### IL",
            "#### IM",
            "#### IN",
            "#### IO",
            "#### IP",
            "#### IQ",
            "#### IR",
            "#### IS",
            "#### IT",
            "#### IU",
            "#### IV",
            "#### IW",
            "#### IX",
            "#### IY",
            "#### IZ",
            "#### JA",
            "#### JB",
            "#### JC",
            "#### JD",
            "#### JE",
            "#### JF",
            "#### JG",
            "#### JH",
            "#### JI",
            "#### JJ",
            "#### JK",
            "#### JL",
            "#### JM",
            "#### JN",
            "#### JO",
            "#### JP",
            "#### JQ",
            "#### JR",
            "#### JS",
            "#### JT",
            "#### JU",
            "#### JV",
            "#### JW",
            "#### JX",
            "#### JY",
            "#### JZ",
            "#### KA",
            "#### KB",
            "####KC",
            "#### KD",
            "#### KE",
            "#### KF",
            "#### KG",
            "#### KH",
            "#### KI",
            "#### KJ",
            "#### KK",
            "#### KL",
            "#### KM",
            "#### KN",
            "#### KO",
            "#### KP",
            "#### KQ",
            "#### KR",
            "#### KS",
            "#### KT",
            "#### KU",
            "#### KV",
            "#### KW",
            "#### KX",
            "#### KY",
            "#### KZ",
            "#### LA",
            "#### LB",
            "#### LC",
            "#### LD",
            "#### LE",
            "#### LF",
            "#### LG",
            "#### LH",
            "#### LI",
            "#### LJ",
            "#### LK",
            "#### LL",
            "#### LM",
            "#### LN",
            "#### LO",
            "#### LP",
            "#### LQ",
            "#### LR",
            "#### LS",
            "#### LT",
            "#### LU",
            "#### LV",
            "#### LW",
            "#### LX",
            "#### LY",
            "#### LZ",
            "#### MA",
            "#### MB",
            "#### MC",
            "#### MD",
            "#### ME",
            "#### MF",
            "#### MG",
            "#### MH",
            "#### MI",
            "#### MJ",
            "#### MK",
            "#### ML",
            "#### MM",
            "#### MN",
            "#### MO",
            "#### MP",
            "#### MQ",
            "#### MR",
            "#### MS",
            "#### MT",
            "#### MU",
            "#### MV",
            "#### MW",
            "#### MX",
            "#### MY",
            "#### MZ",
            "#### NA",
            "#### NB",
            "#### NC",
            "#### ND",
            "#### NE",
            "#### NF",
            "#### NG",
            "#### NH",
            "#### NI",
            "#### NJ",
            "#### NK",
            "#### NL",
            "#### NM",
            "#### NN",
            "#### NO",
            "#### NP",
            "#### NQ",
            "#### NR",
            "#### NS",
            "#### NT",
            "#### NU",
            "#### NV",
            "#### NW",
            "#### NX",
            "#### NY",
            "#### NZ",
            "#### OA",
            "#### OB",
            "#### OC",
            "#### OD",
            "#### OE",
            "#### OF",
            "#### OG",
            "#### OH",
            "#### OI",
            "#### OJ",
            "#### OK",
            "#### OL",
            "#### OM",
            "#### ON",
            "#### OO",
            "#### OP",
            "#### OQ",
            "#### OR",
            "#### OS",
            "#### OT",
            "#### OU",
            "#### OV",
            "#### OW",
            "#### OX",
            "#### OY",
            "#### OZ",
            "#### PA",
            "#### PB",
            "#### PC",
            "#### PD",
            "#### PE",
            "#### PF",
            "#### PG",
            "#### PH",
            "#### PI",
            "#### PJ",
            "#### PK",
            "#### PL",
            "#### PM",
            "#### PN",
            "#### PO",
            "#### PP",
            "#### PQ",
            "#### PR",
            "#### PS",
            "#### PT",
            "#### PU",
            "#### PV",
            "#### PW",
            "#### PX",
            "#### PY",
            "#### PZ",
            "#### QA",
            "#### QB",
            "#### QC",
            "#### QD",
            "#### QE",
            "#### QF",
            "#### QG",
            "#### QH",
            "#### QI",
            "#### QJ",
            "#### QK",
            "#### QL",
            "#### QM",
            "#### QN",
            "#### QO",
            "#### QP",
            "#### QQ",
            "#### QR",
            "#### QS",
            "#### QT",
            "#### QU",
            "#### QV",
            "#### QW",
            "#### QX",
            "#### QY",
            "#### QZ",
            "#### RA",
            "#### RB",
            "#### RC",
            "#### RD",
            "#### RE",
            "#### RF",
            "#### RG",
            "#### RH",
            "#### RI",
            "#### RJ",
            "#### RK",
            "#### RL",
            "#### RM",
            "#### RN",
            "#### RO",
            "#### RP",
            "#### RQ",
            "#### RR",
            "#### RS",
            "#### RT",
            "#### RU",
            "#### RV",
            "#### RW",
            "#### RX",
            "#### RY",
            "#### RZ",
            "#### SA",
            "#### SB",
            "#### SC",
            "#### SD",
            "#### SE",
            "#### SF",
            "#### SG",
            "#### SH",
            "#### SI",
            "#### SJ",
            "#### SK",
            "#### SL",
            "#### SM",
            "#### SN",
            "#### SO",
            "#### SP",
            "#### SQ",
            "#### SR",
            "#### SS",
            "#### ST",
            "#### SU",
            "#### SV",
            "#### SW",
            "#### SX",
            "#### SY",
            "#### SZ",
            "#### TA",
            "#### TB",
            "#### TC",
            "#### TD",
            "#### TE",
            "#### TF",
            "#### TG",
            "#### TH",
            "#### TI",
            "#### TJ",
            "#### TK",
            "#### TL",
            "#### TM",
            "#### TN",
            "#### TO",
            "#### TP",
            "#### TQ",
            "#### TR",
            "#### TS",
            "#### TT",
            "#### TU",
            "#### TV",
            "#### TW",
            "#### TX",
            "#### TY",
            "#### TZ",
            "#### UA",
            "#### UB",
            "#### UC",
            "#### UD",
            "#### UE",
            "#### UF",
            "#### UG",
            "#### UH",
            "#### UI",
            "#### UJ",
            "#### UK",
            "#### UL",
            "#### UM",
            "#### UN",
            "#### UO",
            "#### UP",
            "#### UQ",
            "#### UR",
            "#### US",
            "#### UT",
            "#### UU",
            "#### UV",
            "#### UW",
            "#### UX",
            "#### UY",
            "#### UZ",
            "#### VA",
            "#### VB",
            "#### VC",
            "#### VD",
            "#### VE",
            "#### VF",
            "#### VG",
            "#### VH",
            "#### VI",
            "####VJ",
            "#### VK",
            "#### VL",
            "#### VM",
            "#### VN",
            "#### VO",
            "#### VP",
            "#### VQ",
            "#### VR",
            "#### VS",
            "#### VT",
            "#### VU",
            "#### VV",
            "#### VW",
            "#### VX",
            "#### VY",
            "#### VZ",
            "#### WA",
            "#### WB",
            "#### WC",
            "#### WD",
            "#### WE",
            "#### WF",
            "#### WG",
            "#### WH",
            "#### WI",
            "#### WJ",
            "#### WK"
          ],
          "MI": "??? ####",
          "MN": "???-###",
          "MO": "??# ?#?",
          "MS": [
            "AA? ###",
            "AC? ###",
            "AD? ###",
            "AE? ###",
            "AL? ###",
            "AM? ###",
            "AT? ###",
            "BE? ###",
            "BL? ###",
            "BR? ###",
            "BV? ###",
            "CA? ###",
            "CB? ###",
            "CH? ###",
            "CK? ###",
            "CL? ###",
            "CM? ###",
            "CN? ###",
            "CP? ###",
            "CQ? ###",
            "CR? ###",
            "CT? ###",
            "CV? ###",
            "CW? ###",
            "CY? ###",
            "D?? ###",
            "FN? ###",
            "FR? ###",
            "FS? ###",
            "FT? ###",
            "GA? ###",
            "GE? ###",
            "GF? ###",
            "GN? ###",
            "H?? ###",
            "HL? ###",
            "HM? ###",
            "IS? ###",
            "IT? ###",
            "IW? ###",
            "JA? ###",
            "JB? ###",
            "JD? ###",
            "JF? ###",
            "JG? ###",
            "JH? ###",
            "JI? ###",
            "JJ? ###",
            "JK? ###",
            "JL? ###",
            "JM? ###",
            "JN? ###",
            "JP? ###",
            "JQ? ###",
            "JR? ###",
            "KA? ###",
            "KB? ###",
            "KC? ###",
            "KD? ###",
            "KM? ###",
            "KT? ###",
            "KU? ###",
            "LA? ###",
            "LB? ###",
            "LC? ###",
            "LD? ###",
            "LE? ###",
            "LF? ###",
            "LG? ###",
            "LH? ###",
            "LI? ###",
            "LJ? ###",
            "LK? ###",
            "LL? ###",
            "LM? ###",
            "LN? ###",
            "LP? ###",
            "LQ? ###",
            "LR? ###",
            "LS? ###",
            "LT? ###",
            "LU? ###",
            "LV? ###",
            "LW? ###",
            "LX? ###",
            "LY? ###",
            "LZ? ###",
            "MA? ###",
            "MB? ###",
            "MC? ###",
            "MD? ###",
            "ME? ###",
            "MF? ###",
            "MJ? ###",
            "MK? ###",
            "ML? ###",
            "MN? ###",
            "MP? ###",
            "MQ? ###",
            "MR? ###",
            "MS? ###",
            "MT? ###",
            "NE? ###",
            "NF? ###",
            "NV? ###",
            "NW? ###",
            "NX?###",
            "PA? ###",
            "PB? ###",
            "PC? ###",
            "PE? ###",
            "PK? ###",
            "PL? ###",
            "PM? ###",
            "PN? ###",
            "PP? ###",
            "PQ? ###",
            "PR? ###",
            "PS? ###",
            "PT? ###",
            "PU? ###",
            "PW? ###",
            "PX? ###",
            "QT? ###",
            "R?? ###",
            "SC? ###",
            "SD? ###",
            "SF? ###",
            "SG? ###",
            "SH? ###",
            "SM? ###",
            "SN? ###",
            "SP? ###",
            "SR? ###",
            "ST? ###",
            "SU? ###",
            "TA? ###",
            "TB? ###",
            "TL? ###",
            "TN? ###",
            "TP? ###",
            "TQ? ###",
            "TS? ###",
            "TT? ###",
            "UN? ###",
            "UP? ###",
            "WA? ###",
            "WB? ###",
            "WC? ###",
            "WD? ###",
            "WE? ###",
            "WK? ###",
            "WL? ###",
            "WM? ###",
            "WN? ###",
            "WP? ###",
            "WR? ###",
            "WS? ###",
            "WT? ###",
            "WU? ###",
            "WV? ###",
            "WW? ###",
            "WY? ###",
            "WZ? ###",
            "YA? ###",
            "YL? ###",
            "YZ? ###"
          ],
          "MT": [
            "#-#####?",
            "#???##",
            "[1-4]#-#{4}?",
            "5[0-6]-#{4}?",
            "[1-4]#??##",
            "5[0-6]??##"
          ],
          "NC": "?[A-M]?-####",
          "ND": "### ???",
          "NE": [
            "??? ###",
            "#-?####",
            "#-??###",
            "[1-8]#-?###",
            "9[0-3]-?###",
            "[1-8]#-??##",
            "9[0-3]-??##"
          ],
          "NH": [
            "#####",
            "### ###",
            "### ####"
          ],
          "NJ": "?##-???",
          "NM": "###-???",
          "NV": "###·?##",
          "NY": "???-####",
          "OH": "??? ####",
          "OK": "???-###",
          "OR": [
            "### ???",
            "SL #####",
            "CL #####",
            "CK #####",
            "CA #####",
            "CU #####",
            "9A-####",
            "? ???",
            "????",
            "WC #####",
            "TB #####"
          ],
          "PA": "???-####",
          "RI": [
            "#",
            "##",
            "###",
            "####",
            "#####",
            "??-##",
            "??-###",
            "###-###"
          ],
          "SC": "??? ###",
          "SD": [
            "#?# ###",
            "[1-5]#? ###",
            "6[0-7]? ###"
          ],
          "TN": [
            "#?#-#?#",
            "???-###"
          ],
          "TX": "???-####",
          "UT": [
            "?## #??",
            "?###?"
          ],
          "VA": "???-####",
          "VT": "??? ###",
          "WA": "???####",
          "WI": [
            "???-####",
            "#####K",
            "#####T"
          ],
          "WV": [
            "#?-####",
            "#??-###",
            "##?-###",
            "??-####",
            "???-###",
            "?#?-###"
          ],
          "WY": [
            "#-#####",
            "1#-#####",
            "2[0-3]-#####",
            "99-#####",
            "DV-####",
            "####",
            "GS###",
            "PHS-####",
            "WYO-####",
            "AF###",
            "AR###",
            "CG###",
            "MC###",
            "MM###",
            "NA###"
          ]
        },
        "makes": [
          "BMW",
          "Audi",
          "Toyota",
          "Chevy",
          "Ford",
          "Dodge",
          "Lincoln",
          "Buick",
          "Honda",
          "Nissan"
        ],
        "manufacturer": [
          "Abarth",
          "Acura",
          "Aixam",
          "Alfa Romeo",
          "Alpine",
          "Aston Martin",
          "Audi",
          "Baojun",
          "Bentley",
          "BMW",
          "Brilliance",
          "Bugatti",
          "Buick",
          "BYD",
          "Cadillac",
          "Caterham",
          "Chang'an",
          "Chevrolet",
          "Chrysler",
          "Citroën",
          "Dacia",
          "Daihatsu",
          "Datsun",
          "Dodge",
          "Dongfeng",
          "DS",
          "Dongfeng Fengshen",
          "Fiat",
          "Karma",
          "Ford",
          "Ferrari",
          "Geely",
          "Genesis",
          "GMC",
          "Hino Motors",
          "Holden (HSV)",
          "Honda",
          "Hyundai",
          "Infiniti",
          "Isuzu",
          "Jaguar",
          "Jeep",
          "Jie Fang",
          "Kantanka",
          "Koenigsegg",
          "Kia",
          "Lada",
          "Lamborghini",
          "Lancia",
          "Land Rover",
          "Lexus",
          "Ligier",
          "Lincoln",
          "Lotus",
          "LTI",
          "Luxgen",
          "Mahindra",
          "Maruti Suzuki",
          "Maserati",
          "Mastretta",
          "Maybach",
          "Mazda",
          "McLaren",
          "Mercedes-Benz",
          "MG",
          "Microcar",
          "Mini",
          "Mitsubishi",
          "Morgan",
          "NEVS",
          "Nissan",
          "Noble",
          "Opel",
          "Pagani",
          "Perodua",
          "Peugeot",
          "PGO",
          "Porsche",
          "PROTON",
          "Ram",
          "Ravon",
          "Renault",
          "Rimac",
          "Roewe",
          "Rolls Royce",
          "Saleen",
          "Samand",
          "Renault Samsung Motors",
          "SEAT",
          "Senova",
          "Škoda",
          "Smart",
          "SsangYong",
          "Subaru",
          "Suzuki",
          "Tata",
          "Tesla",
          "Tiba/Miniator",
          "Toyota",
          "Uniti",
          "Vauxhall",
          "Venucia",
          "Volkswagen",
          "Volvo Cars",
          "Vuhl",
          "Wuling",
          "IVM"
        ],
        "models_by_make": {
          "Audi": [
            "A4",
            "A5",
            "S5",
            "A7",
            "A8"
          ],
          "BMW": [
            "328i",
            "M3",
            "M5",
            "X1",
            "X3",
            "X5"
          ],
          "Buick": [
            "Enclave",
            "Regal",
            "LaCrosse",
            "Verano",
            "Encore",
            "Riveria"
          ],
          "Chevy": [
            "Camero",
            "Silverado",
            "Malibu"
          ],
          "Dodge": [
            "Ram",
            "Challenger",
            "Charger",
            "Durango"
          ],
          "Ford": [
            "Mustang",
            "F150",
            "Focus",
            "Fiesta"
          ],
          "Honda": [
            "Accord",
            "Civic",
            "CR-V",
            "Odyssey"
          ],
          "Lincoln": [
            "Navigator",
            "MKZ",
            "MKX",
            "MKS"
          ],
          "Nissan": [
            "Rogue",
            "Juke",
            "Cube",
            "Pathfiner",
            "Versa",
            "Altima"
          ],
          "Toyota": [
            "Prius",
            "Camry",
            "Corolla"
          ]
        },
        "standard_specs": [
          "1.8L DOHC 16-valve I4 engine -inc: engine cover",
          "Engine mounts -inc: (2) solid, (1) liquid-filled",
          "Front wheel drive",
          "Battery saver",
          "Independent strut front suspension w/stabilizer bar",
          "Torsion beam rear suspension w/stabilizer bar",
          "Electric speed-sensitive variable-assist pwr steering",
          "Pwr front vented disc/rear drum brakes",
          "Compact spare tire",
          "Body color front/rear bumpers",
          "Multi-reflector halogen headlamps",
          "Body color folding remote-controlled pwr mirrors",
          "Variable intermittent windshield wipers w/mist function",
          "Intermittent rear wiper w/washer",
          "Body color door handles",
          "Roof mounted antenna",
          "Reclining front bucket seats -inc: active head restraints, double-thickness foam in front seats",
          "60/40 split fold-down rear seat w/outboard adjustable headrests",
          "Dual front & rear cup holders",
          "Tilt steering column",
          "Silver accent IP trim finisher -inc: silver shifter finisher",
          "Tachometer",
          "Fasten seat belt warning light/chime",
          "Pwr windows",
          "Remote fuel lid release",
          "Immobilizer system",
          "Pwr rear liftgate release",
          "Air conditioning w/in-cabin microfilter",
          "Rear window defroster w/timer",
          "12V pwr outlet",
          "Silver finish interior door handles",
          "Driver & front passenger map pockets",
          "Rear passenger map pockets",
          "Front & rear passenger folding assist grips",
          "Carpeted floor & cargo area",
          "Cargo area lamp",
          "Anti-lock brake system (ABS) -inc: electronic brake force distribution (EBD), brake assist",
          "Energy absorbing front/rear bumpers",
          "Steel side-door impact beams",
          "Zone body construction -inc: front/rear crumple zones, hood deformation point",
          "Dual-stage front airbags w/occupant classification system",
          "Front side-impact airbags",
          "Front & rear side curtain airbags",
          "3-point ELR driver seat belt w/pretensioner & load limiter",
          "3-point ELR/ALR front passenger seat belt w/pretensioner & load limiter",
          "3-point ELR/ALR rear seat belts at all positions",
          "Child safety rear door locks",
          "Rear child seat tether anchors (LATCH)",
          "Tire pressure monitoring system (TPMS)",
          "Energy absorbing steering column",
          "4.6L DOHC 32-valve V8 engine -inc: DI & SFI dual fuel injection, dual variable valve timing w/intelligence & electronically controlled intake (VVT-iE), aluminum block & heads",
          "Vibration-dampening liquid-filled engine mounts",
          "Electronic throttle control system w/intelligence (ETCS-i)",
          "Acoustic control induction system (ACIS)",
          "8-speed automatic transmission -inc: intelligence (ECT-i), gated shifter, sequential sport-shift mode",
          "Full-time all-wheel drive",
          "Front/rear aluminum multi-link double joint suspension w/coil springs",
          "Front/rear stabilizer bars",
          "Electric pwr rack & pinion steering (EPS)",
          "4-wheel ventilated pwr disc brakes -inc: brake override system",
          "Dual chrome exhaust tips",
          "Tool kit",
          "P235/50R18 all-season tires",
          "Full-size spare tire w/aluminum alloy wheel",
          "Scratch-resistant paint clearcoating",
          "Pwr tilt/slide moonroof -inc: 1-touch open/close",
          "1-piece chrome window surround",
          "Xenon high-intensity discharge (HID) headlamps -inc: adaptive front lighting system, delayed auto-off",
          "Integrated fog lamps",
          "LED lights -inc: brake lamps, tail lamps, license plate",
          "Electrochromic pwr folding heated mirrors w/memory -inc: puddle lamps, integrated turn signals, auto reverse tilt-down",
          "Acoustic glass windshield",
          "Water-repellent windshield & front door glass",
          "Laminated side window glass",
          "Rain-sensing wipers",
          "XM satellite radio receiver -inc: 90 day trial subscription",
          "Rear bench seat -inc: (3) adjustable headrests",
          "Center console",
          "Optitron electroluminescent instrumentation",
          "Multi-info display -inc: driving range, average MPG, current MPG, average speed, outside temp, elapsed time, maintenance & diagnostic messages",
          "Eco drive indicator",
          "Pwr windows -inc: 1-touch open/close",
          "HomeLink universal transceiver",
          "Dual-zone automatic climate control system -inc: smog sensor, auto recirculation, clear air filter, pollen filter",
          "Rear-window defogger w/auto-off timer",
          "(2) aux 12V pwr outlets -inc: (1) in center console, (1) w/cigarette lighter",
          "Grain-matched wood trim -inc: center console, dash, door panels",
          "Electrochromic rearview mirror",
          "Foldable front door storage pockets",
          "Dual front illuminated visor vanity mirrors",
          "Front/rear spot-lamp illumination",
          "4-wheel/4-channel anti-lock brake system (ABS)",
          "Electronic control braking (ECB)",
          "Electronic brakeforce distribution (EBD) w/brake assist (BA) -inc: Smart stop technology",
          "Electronic parking brake",
          "Vehicle dynamics integrated management (VDIM) system -inc: vehicle stability control (VSC), traction control (TRAC)",
          "Front/rear crumple zones",
          "Daytime running lights (DRL)",
          "Side-impact door beams",
          "Dual front 2-stage airbags -inc: passenger occupant classification system w/twin-chamber airbag",
          "Front/rear side curtain airbags",
          "Dual front knee airbags",
          "Back-up camera",
          "All-position 3-point seat belts -inc: outboard pretensioners & force limiters, dual front pwr shoulder height adjusters, rear outboard emergency auto locking retractors, driver emergency locking retractor",
          "Child restraint seat anchors for outboard positions",
          "Rear door child safety locks",
          "Direct-type tire pressure monitor system",
          "Impact-dissipating upper interior trim",
          "Collapsible steering column",
          "Emergency interior trunk release",
          "First aid kit",
          "6.1L SRT V8 \"Hemi\" engine",
          "3.73 axle ratio",
          "Quadra-Trac active on demand 4WD system",
          "200mm front axle",
          "Dana 44/226mm rear axle",
          "625-amp maintenance-free battery",
          "160-amp alternator",
          "Tip start system",
          "Pwr accessory delay",
          "Trailer tow wiring harness",
          "High performance suspension",
          "Pwr steering cooler",
          "Pwr rack & pinion performance tuned steering",
          "Anti-lock 4-wheel performance disc brakes",
          "Brake assist",
          "Dual bright exhaust tips",
          "Run flat tires",
          "20\" x 9.0\" front & 20\" x 10.0\" rear aluminum wheels",
          "Monotone paint",
          "Black roof molding",
          "Rear body-color spoiler",
          "Body color grille",
          "Chrome bodyside molding",
          "Black windshield molding",
          "Body color fascias w/bright insert",
          "Body color sill extension",
          "Fog lamps",
          "Front door tinted glass",
          "\"Flipper\" liftgate glass",
          "Rear window wiper/washer",
          "Body color front license plate brow",
          "Body color door handles",
          "6.5\" touch screen display",
          "Fixed long mast antenna",
          "Pwr 8-way driver seat w/4-way front passenger seat",
          "60/40 folding rear seat",
          "Full-length floor console",
          "Luxury front & rear floor mats w/logo",
          "Floor carpeting",
          "Tilt/telescoping steering column",
          "Leather-wrapped steering wheel w/audio controls",
          "Instrument cluster w/tachometer",
          "Vehicle info center",
          "Traveler/mini trip computer",
          "Pwr front windows w/(1) touch up/down feature",
          "Speed control",
          "Sentry Key theft deterrent system",
          "Security alarm",
          "Bright pedals",
          "Rear window defroster",
          "Locking glove box",
          "Highline door trim panel",
          "Cloth covered headliner",
          "Overhead console",
          "Dual illuminated visor vanity mirrors",
          "Universal garage door opener",
          "Passenger assist handles",
          "Deluxe insulation group",
          "Cargo compartment lamp",
          "Glove box lamp",
          "Rear reading & courtesy lamps",
          "Illuminated entry",
          "Leather-wrapped shift knob",
          "Leather-wrapped parking brake handle",
          "Carpeted cargo area",
          "Trim-panel-mounted storage net",
          "Cargo-area tie down loops",
          "Cargo compartment cover",
          "Reversible/waterproof cargo storage",
          "Driver & front passenger advanced multistage airbags w/occupant sensors",
          "Supplemental side curtain air bags",
          "Enhanced accident response system unlocks the doors, shuts off the fuel pump and turns on interior lights after airbag deploys",
          "3-point rear center seat belts",
          "Child seat upper tether anchorages",
          "LATCH-ready child seat anchor system",
          "Child safety rear door locks",
          "Dual note horn",
          "Tire pressure monitoring display"
        ],
        "styles": [
          "XL",
          "L",
          "ESi",
          "XLE"
        ],
        "transmissions": [
          "Automanual",
          "Automatic",
          "CVT",
          "Manual"
        ],
        "version": [
          "Premium",
          "Quadrifoglio",
          "Ti",
          "Sprint",
          "Prestige",
          "40 TFSI Premium",
          "45 TFSI Premium Plus",
          "228i Gran Coupe",
          "230i",
          "330e",
          "330i",
          "330i xDrive",
          "430i",
          "Competition",
          "sDrive 30i",
          "Avenir",
          "Essence",
          "Luxury",
          "Sport",
          "Sport Premium",
          "2LT",
          "3LT",
          "Premier",
          "Stingray",
          "LS",
          "LT",
          "LTZ",
          "300s V6",
          "300s V8",
          "2.5 Turbo",
          "1.0",
          "1.8",
          "2.0",
          "2.0L Inline-4",
          "Freestyle 1.5 12V AT6",
          "GLi 2.0 16V CVT",
          "Altis 2.0 16V",
          "Altis Hybrid 1.8 16V CVT",
          "XEi 2.0 16v CVT",
          "Classic Spirit 1.6",
          "1.8Mi",
          "LTZ 1.4",
          "SS 6.2 V8",
          "1.0 Turbo",
          "MAXX 1.4 8V",
          "RS 1.0 TB",
          "1.6 MSI 16V",
          "G6 1.6 8V",
          "G6 1.0 12V",
          "G6 1.0 12V",
          "Plus 1.0 16V",
          "Longitude 3.2 V6",
          "Trailhawk 3.2 V6",
          "Limited T270 1.3 TB",
          "Overland TD380 4X4 2.0 16V",
          "Sahara 2.0 TB",
          "Unlimited Rubicon 4X4 2.0 TB AT8",
          "Iconic 1.3 16V TCe CVT X-TRONIX",
          "Zen 1.3 16V CVT X-TRONIC",
          "Limited 3.6 V6 4X4",
          "T-JET 1.4 16V",
          "LOUNGE 1.4 DUALOGIC",
          "Drive 1.0",
          "Trekking 1.3 8V",
          "Easy 1.0 8V",
          "Like 1.0 8V",
          "Fire 1.0 8V",
          "Essence 1.6V",
          "Audace 200 1.0 TB",
          "Comfortline 200 1.0 12V TSI AT6",
          "Highline 200 1.0 12V TSI AT6",
          "200 TSI",
          "Sense 200 1.0 TSI AT6",
          "Touring 1.5 TB CVT",
          "Momentum T5 AWD 2.0 TB AT8 ",
          "200 Advance 1.3 TB",
          "EX 2.0 CVT",
          "LX 2.0 CVT",
          "Sport 2.0 CVT",
          "TXS 1.5 TB AT",
          "Premier 1.2 TB"
        ]
      },
      "venture_bros": {
        "character": [
          "Hank Venture",
          "Dean Venture",
          "Thaddeus S. Venture",
          "Brock Samson",
          "H.E.L.P.E.R",
          "Sereant Hatred",
          "Princess Tinyfeet",
          "Dermott Fictel-Venture",
          "Dr. Jonas Venture Jr.",
          "Triana Orpheus",
          "Pete White",
          "Master Billy Quizboy",
          "Barond Ünderbheit",
          "Pirate Captain",
          "Dr. Byron Orpheus",
          "Jefferson Twilight",
          "The Alchemist",
          "Dr. Jonas Venture Sr",
          "The Action Man",
          "Colonel Horace Gentleman",
          "Kano",
          "Otto Aquarius",
          "Dr. Entmann",
          "Swifty",
          "Hector",
          "Ook Ook",
          "General Timothy Treister",
          "Mister Doe",
          "Mister Cardholder",
          "Gen. Hunter Gathers",
          "Shore Leave",
          "Mile High Pilot",
          "Dr.Vulcano",
          "Headshot",
          "Amber Gold",
          "Afterburner",
          "Shuttle Cock",
          "Slap Chop",
          "Bum Rush",
          "Tank Top",
          "Snoopy",
          "The Monarch",
          "Dr. Girlfriend",
          "Phantom Limb",
          "Henchman 21",
          "The Viceroy",
          "Gary",
          "Doc Hammer",
          "Henchman 24",
          "Speedy",
          "Tim-Tom",
          "Kevin",
          "Watch",
          "Ward",
          "Dr. Henry Killinger",
          "The Sovereign",
          "Monstroso",
          "Torrid",
          "Truckules",
          "The Intangible Fancy",
          "The Investors",
          "Augustus St. Cloud",
          "Vendata",
          "Wild Fop",
          "Red Mantle",
          "Boggles, the Clue Clown",
          "Dr. Phineas Phage",
          "Dr. Z",
          "Monseñor",
          "Don Hell",
          "Dragoon",
          "Steppenwolf",
          "Mommy Longlegs",
          "The Nerve",
          "Wide Wale",
          "Doctor Dugong",
          "Brick Frog",
          "Flying Squid",
          "Vespertina",
          "Sri Lankan Devil Bird",
          "Haranguetan",
          "Sunsational",
          "Galacticon",
          "Battleaxe",
          "Copy-Cat",
          "Think Tank",
          "The Doom Factory",
          "Wes Warhammer",
          "Frigid",
          "Eenie-Meanie",
          "Serpentine",
          "Shehemoth",
          "Gerard the Gorilla",
          "Trashenstein",
          "Ultra Violent",
          "Billy Maim",
          "Red Death",
          "Col Lloyd Venture",
          "Eugen Sandow",
          "Aleister Crowley",
          "Fantômas",
          "Oscar Wilde",
          "Samuel Clemens",
          "Professor Richard Impossible",
          "Manservant",
          "Fat Chance",
          "Lyndon Bee",
          "Radical Left",
          "Zero",
          "Girl Hitler",
          "Catclops",
          "Manic 8-ball",
          "Eunuchs",
          "King Gorilla",
          "Mr. Monday",
          "Tigeriffic",
          "White Noise",
          "Dr. Septapus",
          "Tiny Joseph",
          "Teddy",
          "Cuckoo Clocker",
          "Big Time",
          "Maybe Man",
          "Scaramantula",
          "Brainulo",
          "Manotaur",
          "Tiger Shark",
          "SPHINX Commander",
          "The Countess",
          "Wind Song",
          "Diamond Backdraft",
          "Storm Front",
          "Crime-o-dile",
          "Scorpio",
          "Molotov Cocktease",
          "Col. Bud Manstrong",
          "Lt. Anna Baldavich",
          "The Master",
          "Myra Brandish",
          "Gen. Manhowers",
          "Dr. Tara Quymn",
          "Venturestein",
          "The Outrider",
          "Tatyana",
          "Brown Widow",
          "Sirena Ong",
          "Sally Impossible",
          "Rocket Impossible",
          "Ro-Boy Z",
          "Captain Sunshine",
          "Wonder Boy",
          "Wonderboy 5",
          "Barbie-Q",
          "U.S. Steel",
          "Brown Thrasher"
        ],
        "organization": [
          "Team Venture",
          "Venture Industries",
          "The Guild of Calamitous Intent",
          "The Fluttering Horde",
          "The Order of the Triad",
          "Office of Secret Intelligence",
          "Impossible Industries",
          "Ünderland Troops",
          "Conjectural Technologies",
          "State University",
          "The Blackhearts Elimination Society",
          "The Soul Mates",
          "S.P.H.I.N.X",
          "The Revenge Society",
          "The Brimstone Assemnbly",
          "Crusaders Action League"
        ],
        "quote": [
          "Monarchs..don't sting..",
          "Go ahead. Take it from me",
          "Are these they?",
          "I dare you to make less sense",
          "I am a ghost living inside the head of a robot",
          "Truly only a face a mother can love",
          "I am, how you say, Russian Guyovich",
          "But he's in Depehce Mode!",
          "Ow! My arm came off! I can't belive that happened",
          "Mecha-Shiva!",
          "It's in Sanskri, and a dialect I'm not familiar with. I'm not sure I can read it",
          "Colonel Gentleman's good names for an imaginary friend",
          "No I started it years ago in a moment of passion! And I'll end it the same way right here in front of Brock, H.E.L.P.eR., and God!",
          "I'm all out of gun food!",
          "So just what are you trying to say, little man? You don't like Zep?",
          "I am General Treister's son. You saved my father's life. He spoke of you as a god... and you did not disappoint.",
          "If you had a lady like my wife, you'd be in an alternate universe where dogs talk and birds have human pets.",
          "On three we give him the ol' rochambeau!",
          "They fought with Spaghetti-O's and meatballs?",
          "We're gonna get our asses kicked. We didn't have a breakfast!",
          "Smurfs don't lay eggs! I won't tell you this again! Papa Smurf has a f-ing beard! They're mammals!",
          "Double damnit",
          "Ya live by the ghost...ya die by the ghost.",
          "BRRRRRRRRICKFROG!!!",
          "And this.... is my magic murder bag.",
          "The guy from Labyrinth just turned into a bird!",
          "Revenge like gazpacho soup, is best served cold, precise and merciless.",
          "Augh! Ghost pirate!!",
          "Two heads are better than one!",
          "My name....IS REVENGE!",
          "Go Team Venture!",
          "Sometimes I would pretend I was the Batman",
          "They hit me with a truck",
          "... As The hard-rocking quartet of Ace Freely, Gene Simmons, Peter Kris and... THE BAT",
          "Ah, but we two souls have shared a cheese sandwich more than twice, and the stitched together quilt of your stony silence forms a tapestry of quiet desperation."
        ],
        "vehicle": [
          "Adrian",
          "The Cocoon",
          "Gargantua-1",
          "Gargantua-2",
          "Hover Bikes",
          "Monarchmobile",
          "TVC-15",
          "Ventronic",
          "Venturemobile",
          "X-1",
          "X-2",
          "X-3",
          "Morphomobile",
          "Haranguetank",
          "The Mighty Khafra"
        ]
      },
      "verbs": {
        "base": [
          "abash",
          "abate",
          "abide",
          "absorb",
          "accept",
          "accompany",
          "ache",
          "achieve",
          "acquire",
          "act",
          "add",
          "address",
          "adjust",
          "admire",
          "admit",
          "advise",
          "afford",
          "agree",
          "alight",
          "allow",
          "animate",
          "announce",
          "answer",
          "apologize",
          "appear",
          "applaud",
          "apply",
          "approach",
          "approve",
          "argue",
          "arise",
          "arrange",
          "arrest",
          "ask",
          "assert",
          "assort",
          "astonish",
          "attack",
          "attend",
          "attract",
          "audit",
          "avoid",
          "awake",
          "bang",
          "banish",
          "bash",
          "bat",
          "be",
          "bear",
          "bear",
          "beat",
          "beautify",
          "become",
          "befall",
          "beg",
          "begin",
          "behave",
          "behold",
          "believe",
          "belong",
          "bend",
          "bereave",
          "beseech",
          "bet",
          "betray",
          "bid",
          "bid",
          "bind",
          "bite",
          "bleed",
          "bless",
          "blossom",
          "blow",
          "blur",
          "blush",
          "board",
          "boast",
          "boil",
          "bow",
          "box",
          "bray",
          "break",
          "breathe",
          "breed",
          "bring",
          "broadcast",
          "brush",
          "build",
          "burn",
          "burst",
          "bury",
          "bust",
          "buy",
          "buzz",
          "calculate",
          "call",
          "canvass",
          "capture",
          "caress",
          "carry",
          "carve",
          "cash",
          "cast",
          "catch",
          "cause",
          "cease",
          "celebrate",
          "challenge",
          "change",
          "charge",
          "chase",
          "chat",
          "check",
          "cheer",
          "chew",
          "chide",
          "chip",
          "choke",
          "choose",
          "classify",
          "clean",
          "cleave",
          "click",
          "climb",
          "cling",
          "close",
          "clothe",
          "clutch",
          "collapse",
          "collect",
          "colour",
          "come",
          "comment",
          "compare",
          "compel",
          "compete",
          "complain",
          "complete",
          "conclude",
          "conduct",
          "confess",
          "confine",
          "confiscate",
          "confuse",
          "congratulate",
          "connect",
          "connote",
          "conquer",
          "consecrate",
          "consent",
          "conserve",
          "consider",
          "consign",
          "consist",
          "console",
          "consort",
          "conspire",
          "constitute",
          "constrain",
          "construct",
          "construe",
          "consult",
          "contain",
          "contemn",
          "contend",
          "contest",
          "continue",
          "contract",
          "contradict",
          "contrast",
          "contribute",
          "contrive",
          "control",
          "convene",
          "converge",
          "converse",
          "convert",
          "convey",
          "convict",
          "convince",
          "coo",
          "cook",
          "cool",
          "co-operate",
          "cope",
          "copy",
          "correct",
          "correspond",
          "corrode",
          "corrupt",
          "cost",
          "cough",
          "counsel",
          "count",
          "course",
          "cover",
          "cower",
          "crack",
          "crackle",
          "crash",
          "crave",
          "create",
          "creep",
          "crib",
          "cross",
          "crowd",
          "crush",
          "cry",
          "curb",
          "cure",
          "curve",
          "cut",
          "cycle",
          "damage",
          "damp",
          "dance",
          "dare",
          "dash",
          "dazzle",
          "deal",
          "decay",
          "decide",
          "declare",
          "decorate",
          "decrease",
          "dedicate",
          "delay",
          "delete",
          "deny",
          "depend",
          "deprive",
          "derive",
          "describe",
          "desire",
          "destroy",
          "detach",
          "detect",
          "determine",
          "develop",
          "die",
          "differ",
          "dig",
          "digest",
          "dim",
          "diminish",
          "dine",
          "dip",
          "direct",
          "disappear",
          "discover",
          "discuss",
          "disobey",
          "display",
          "dispose",
          "distribute",
          "disturb",
          "disuse",
          "dive",
          "divide",
          "do",
          "donate",
          "download",
          "drag",
          "draw",
          "dream",
          "dress",
          "drill",
          "drink",
          "drive",
          "drop",
          "dry",
          "dump",
          "dwell",
          "dye",
          "earn",
          "eat",
          "educate",
          "empower",
          "empty",
          "encircle",
          "encourage",
          "encroach",
          "endanger",
          "endorse",
          "endure",
          "engrave",
          "enjoy",
          "enlarge",
          "enlighten",
          "enter",
          "envy",
          "erase",
          "escape",
          "evaporate",
          "exchange",
          "exclaim",
          "exclude",
          "exist",
          "expand",
          "expect",
          "explain",
          "explore",
          "express",
          "extend",
          "eye",
          "face",
          "fail",
          "faint",
          "fall",
          "fan",
          "fancy",
          "favour",
          "fax",
          "feed",
          "feel",
          "ferry",
          "fetch",
          "fight",
          "fill",
          "find",
          "finish",
          "fish",
          "fit",
          "fix",
          "fizz",
          "flap",
          "flash",
          "flee",
          "fling",
          "float",
          "flop",
          "fly",
          "fold",
          "follow",
          "forbid",
          "force",
          "forecast",
          "foretell",
          "forget",
          "forgive",
          "forlese",
          "form",
          "forsake",
          "found",
          "frame",
          "free",
          "freeze",
          "frighten",
          "fry",
          "fulfil",
          "gag",
          "gain",
          "gainsay",
          "gash",
          "gaze",
          "get",
          "give",
          "glance",
          "glitter",
          "glow",
          "go",
          "google",
          "govern",
          "grab",
          "grade",
          "grant",
          "greet",
          "grind",
          "grip",
          "grow",
          "guard",
          "guess",
          "guide",
          "handle",
          "hang",
          "happen",
          "harm",
          "hatch",
          "hate",
          "have",
          "heal",
          "hear",
          "heave",
          "help",
          "hew",
          "hide",
          "hinder",
          "hiss",
          "hit",
          "hoax",
          "hold",
          "hop",
          "hope",
          "horrify",
          "hug",
          "hum",
          "humiliate",
          "hunt",
          "hurl",
          "hurry",
          "hurt",
          "hush",
          "hustle",
          "hypnotize",
          "idealize",
          "identify",
          "idolize",
          "ignite",
          "ignore",
          "ill-treat",
          "illuminate",
          "illumine",
          "illustrate",
          "imagine",
          "imbibe",
          "imitate",
          "immerse",
          "immolate",
          "immure",
          "impair",
          "impart",
          "impeach",
          "impede",
          "impel",
          "impend",
          "imperil",
          "impinge",
          "implant",
          "implicate",
          "implode",
          "implore",
          "imply",
          "import",
          "impose",
          "impress",
          "imprint",
          "imprison",
          "improve",
          "inaugurate",
          "incise",
          "include",
          "increase",
          "inculcate",
          "indent",
          "indicate",
          "induce",
          "indulge",
          "infect",
          "infest",
          "inflame",
          "inflate",
          "inflect",
          "inform",
          "infringe",
          "infuse",
          "ingest",
          "inhabit",
          "inhale",
          "inherit",
          "initiate",
          "inject",
          "injure",
          "inlay",
          "innovate",
          "input",
          "inquire",
          "inscribe",
          "insert",
          "inspect",
          "inspire",
          "install",
          "insult",
          "insure",
          "integrate",
          "introduce",
          "invent",
          "invite",
          "join",
          "jump",
          "justify",
          "keep",
          "kick",
          "kid",
          "kill",
          "kiss",
          "kneel",
          "knit",
          "knock",
          "know",
          "lade",
          "land",
          "last",
          "latch",
          "laugh",
          "lay",
          "lead",
          "leak",
          "lean",
          "leap",
          "learn",
          "leave",
          "leer",
          "lend",
          "let",
          "lick",
          "lie",
          "lie",
          "lift",
          "light",
          "like",
          "limp",
          "listen",
          "live",
          "look",
          "lose",
          "love",
          "magnify",
          "maintain",
          "make",
          "manage",
          "march",
          "mark",
          "marry",
          "mash",
          "match",
          "matter",
          "mean",
          "measure",
          "meet",
          "melt",
          "merge",
          "mew",
          "migrate",
          "milk",
          "mind",
          "mislead",
          "miss",
          "mistake",
          "misuse",
          "mix",
          "moan",
          "modify",
          "moo",
          "motivate",
          "mould",
          "moult",
          "move",
          "mow",
          "multiply",
          "murmur",
          "nail",
          "nap",
          "need",
          "neglect",
          "nip",
          "nod",
          "note",
          "notice",
          "notify",
          "nourish",
          "nurse",
          "obey",
          "oblige",
          "observe",
          "obstruct",
          "obtain",
          "occupy",
          "occur",
          "offer",
          "offset",
          "omit",
          "ooze",
          "open",
          "operate",
          "opine",
          "oppress",
          "opt",
          "optimize",
          "order",
          "organize",
          "originate",
          "output",
          "overflow",
          "overtake",
          "owe",
          "own",
          "pacify",
          "paint",
          "pardon",
          "part",
          "partake",
          "participate",
          "pass",
          "paste",
          "pat",
          "patch",
          "pause",
          "pay",
          "peep",
          "perish",
          "permit",
          "persuade",
          "phone",
          "place",
          "plan",
          "play",
          "plead",
          "please",
          "plod",
          "plot",
          "pluck",
          "ply",
          "point",
          "polish",
          "pollute",
          "ponder",
          "pour",
          "pout",
          "practise",
          "praise",
          "pray",
          "preach",
          "prefer",
          "prepare",
          "prescribe",
          "present",
          "preserve",
          "preset",
          "preside",
          "press",
          "pretend",
          "prevent",
          "print",
          "proceed",
          "produce",
          "progress",
          "prohibit",
          "promise",
          "propose",
          "prosecute",
          "protect",
          "prove",
          "provide",
          "pull",
          "punish",
          "purify",
          "push",
          "put",
          "qualify",
          "quarrel",
          "question",
          "quit",
          "race",
          "rain",
          "rattle",
          "reach",
          "read",
          "realize",
          "rebuild",
          "recall",
          "recast",
          "receive",
          "recite",
          "recognize",
          "recollect",
          "recur",
          "redo",
          "reduce",
          "refer",
          "reflect",
          "refuse",
          "regard",
          "regret",
          "relate",
          "relax",
          "rely",
          "remain",
          "remake",
          "remove",
          "rend",
          "renew",
          "renounce",
          "repair",
          "repeat",
          "replace",
          "reply",
          "report",
          "request",
          "resell",
          "resemble",
          "reset",
          "resist",
          "resolve",
          "respect",
          "rest",
          "restrain",
          "retain",
          "retch",
          "retire",
          "return",
          "reuse",
          "review",
          "rewind",
          "rid",
          "ride",
          "ring",
          "rise",
          "roar",
          "rob",
          "roll",
          "rot",
          "rub",
          "rule",
          "run",
          "rush",
          "sabotage",
          "sack",
          "sacrifice",
          "sadden",
          "saddle",
          "sag",
          "sail",
          "sally",
          "salute",
          "salvage",
          "salve",
          "sample",
          "sanctify",
          "sanction",
          "sap",
          "saponify",
          "sash",
          "sashay",
          "sass",
          "sate",
          "satiate",
          "satirise",
          "satisfy",
          "saturate",
          "saunter",
          "save",
          "savor",
          "savvy",
          "saw",
          "say",
          "scab",
          "scabble",
          "scald",
          "scale",
          "scam",
          "scan",
          "scant",
          "scar",
          "scare",
          "scarify",
          "scarp",
          "scat",
          "scatter",
          "scold",
          "scorch",
          "scowl",
          "scrawl",
          "scream",
          "screw",
          "scrub",
          "search",
          "seat",
          "secure",
          "see",
          "seek",
          "seem",
          "seize",
          "select",
          "sell",
          "send",
          "sentence",
          "separate",
          "set",
          "sever",
          "sew",
          "shake",
          "shape",
          "share",
          "shatter",
          "shave",
          "shear",
          "shed",
          "shine",
          "shirk",
          "shit",
          "shiver",
          "shock",
          "shoe",
          "shoot",
          "shorten",
          "shout",
          "show",
          "shrink",
          "shun",
          "shut",
          "sight",
          "signal",
          "signify",
          "sing",
          "sink",
          "sip",
          "sit",
          "ski",
          "skid",
          "slam",
          "slay",
          "sleep",
          "slide",
          "slim",
          "sling",
          "slink",
          "slip",
          "slit",
          "smash",
          "smell",
          "smile",
          "smite",
          "smooth",
          "smother",
          "snap",
          "snatch",
          "sneak",
          "sneeze",
          "sniff",
          "soar",
          "sob",
          "solicit",
          "solve",
          "soothe",
          "sort",
          "sow",
          "sparkle",
          "speak",
          "speed",
          "spell",
          "spend",
          "spill",
          "spin",
          "spit",
          "split",
          "spoil",
          "spray",
          "spread",
          "spring",
          "sprout",
          "squeeze",
          "stand",
          "stare",
          "start",
          "state",
          "stay",
          "steal",
          "steep",
          "stem",
          "step",
          "sterilize",
          "stick",
          "stimulate",
          "sting",
          "stink",
          "stir",
          "stitch",
          "stoop",
          "stop",
          "store",
          "strain",
          "stray",
          "stress",
          "stretch",
          "strew",
          "stride",
          "strike",
          "string",
          "strive",
          "study",
          "submit",
          "subscribe",
          "subtract",
          "succeed",
          "suck",
          "suffer",
          "suggest",
          "summon",
          "supply",
          "support",
          "suppose",
          "surge",
          "surmise",
          "surpass",
          "surround",
          "survey",
          "survive",
          "swallow",
          "sway",
          "swear",
          "sweat",
          "sweep",
          "swell",
          "swim",
          "swing",
          "swot",
          "take",
          "talk",
          "tap",
          "taste",
          "tax",
          "teach",
          "tear",
          "tee",
          "tell",
          "tempt",
          "tend",
          "terminate",
          "terrify",
          "test",
          "thank",
          "think",
          "thrive",
          "throw",
          "thrust",
          "thump",
          "tie",
          "tire",
          "toss",
          "touch",
          "train",
          "trample",
          "transfer",
          "transform",
          "translate",
          "trap",
          "travel",
          "tread",
          "treasure",
          "treat",
          "tree",
          "tremble",
          "triumph",
          "trust",
          "try",
          "turn",
          "type",
          "typeset",
          "understand",
          "undo",
          "uproot",
          "upset",
          "urge",
          "use",
          "utter",
          "value",
          "vanish",
          "vary",
          "verify",
          "vex",
          "vie",
          "view",
          "violate",
          "vomit",
          "wake",
          "walk",
          "wander",
          "want",
          "warn",
          "waste",
          "watch",
          "water",
          "wave",
          "wax",
          "waylay",
          "wear",
          "weave",
          "wed",
          "weep",
          "weigh",
          "welcome",
          "wend",
          "wet",
          "whip",
          "whisper",
          "win",
          "wind",
          "wish",
          "withdraw",
          "work",
          "worry",
          "worship",
          "wring",
          "write",
          "yawn",
          "yell",
          "yield",
          "zinc",
          "zoom"
        ],
        "ing_form": [
          "abashing",
          "abating",
          "abiding",
          "absorbing",
          "accepting",
          "accompanying",
          "aching",
          "achieving",
          "acquiring",
          "acting",
          "adding",
          "addressing",
          "adjusting",
          "admiring",
          "admitting",
          "advising",
          "affording",
          "agreeing",
          "alighting",
          "allowing",
          "animating",
          "announcing",
          "answering",
          "apologizing",
          "appearing",
          "applauding",
          "applying",
          "approaching",
          "approving",
          "arguing",
          "arising",
          "arranging",
          "arresting",
          "asking",
          "asserting",
          "assorting",
          "astonishing",
          "attacking",
          "attending",
          "attracting",
          "auditing",
          "avoiding",
          "awaking",
          "banging",
          "banishing",
          "bashing",
          "batting",
          "being",
          "bearing",
          "bearing",
          "beating",
          "beautifying",
          "becoming",
          "befalling",
          "begging",
          "beginning",
          "behaving",
          "beholding",
          "believing",
          "belonging",
          "bending",
          "bereaving",
          "beseeching",
          "betting",
          "betraying",
          "bidding",
          "bidding",
          "binding",
          "biting",
          "bleeding",
          "blessing",
          "blossoming",
          "blowing",
          "blurring",
          "blushing",
          "boarding",
          "boasting",
          "boiling",
          "bowing",
          "boxing",
          "braying",
          "breaking",
          "breathing",
          "breeding",
          "bringing",
          "broadcasting",
          "brushing",
          "building",
          "burning",
          "bursting",
          "burying",
          "busting",
          "buying",
          "buzzing",
          "calculating",
          "calling",
          "canvassing",
          "capturing",
          "caressing",
          "carrying",
          "carving",
          "cashing",
          "casting",
          "catching",
          "causing",
          "ceasing",
          "celebrating",
          "challenging",
          "changing",
          "charging",
          "chasing",
          "chatting",
          "checking",
          "cheering",
          "chewing",
          "chiding",
          "chipping",
          "choking",
          "choosing",
          "classifying",
          "cleaning",
          "cleaving",
          "clicking",
          "climbing",
          "clinging",
          "closing",
          "clothing",
          "clutching",
          "collapsing",
          "collecting",
          "colouring",
          "coming",
          "commenting",
          "comparing",
          "compelling",
          "competing",
          "complaining",
          "completing",
          "concluding",
          "conducting",
          "confessing",
          "confining",
          "confiscating",
          "confusing",
          "congratulating",
          "connecting",
          "connoting",
          "conquering",
          "consecrating",
          "consenting",
          "conserving",
          "considering",
          "consigning",
          "consisting",
          "consoling",
          "consorting",
          "conspiring",
          "constituting",
          "constraining",
          "constructing",
          "construing",
          "consulting",
          "containing",
          "contemning",
          "contending",
          "contesting",
          "continuing",
          "contracting",
          "contradicting",
          "contrasting",
          "contributing",
          "contriving",
          "controlling",
          "convening",
          "converging",
          "conversing",
          "converting",
          "conveying",
          "convicting",
          "convincing",
          "cooing",
          "cooking",
          "cooling",
          "co-operating",
          "coping",
          "copying",
          "correcting",
          "corresponding",
          "corroding",
          "corrupting",
          "costing",
          "coughing",
          "counselling",
          "counting",
          "coursing",
          "covering",
          "cowering",
          "cracking",
          "crackling",
          "crashing",
          "craving",
          "creating",
          "creeping",
          "cribbing",
          "crossing",
          "crowding",
          "crushing",
          "crying",
          "curbing",
          "curing",
          "curving",
          "cutting",
          "cycling",
          "damaging",
          "damping",
          "dancing",
          "daring",
          "dashing",
          "dazzling",
          "dealing",
          "decaying",
          "deciding",
          "declaring",
          "decorating",
          "decreasing",
          "dedicating",
          "delaying",
          "deleting",
          "denying",
          "depending",
          "depriving",
          "deriving",
          "describing",
          "desiring",
          "destroying",
          "detaching",
          "detecting",
          "determining",
          "developing",
          "dying",
          "differing",
          "digging",
          "digesting",
          "dimming",
          "diminishing",
          "dining",
          "dipping",
          "directing",
          "disappearing",
          "discovering",
          "discussing",
          "disobeying",
          "displaying",
          "disposing",
          "distributing",
          "disturbing",
          "disusing",
          "diving",
          "dividing",
          "doing",
          "donating",
          "downloading",
          "dragging",
          "drawing",
          "dreaming",
          "dressing",
          "drilling",
          "drinking",
          "driving",
          "dropping",
          "drying",
          "dumping",
          "dwelling",
          "dyeing",
          "earning",
          "eating",
          "educating",
          "empowering",
          "emptying",
          "encircling",
          "encouraging",
          "encroaching",
          "entangling",
          "endorsing",
          "enduring",
          "engraving",
          "enjoying",
          "enlarging",
          "enlightening",
          "entering",
          "envying",
          "erasing",
          "escaping",
          "evaporating",
          "exchanging",
          "exclaiming",
          "excluding",
          "existing",
          "expanding",
          "expecting",
          "explaining",
          "exploring",
          "expressing",
          "extending",
          "eyeing",
          "facing",
          "failing",
          "fainting",
          "falling",
          "fanning",
          "fancying",
          "favouring",
          "faxing",
          "feeding",
          "feeling",
          "ferrying",
          "fetching",
          "fighting",
          "filling",
          "finding",
          "finishing",
          "fishing",
          "fitting",
          "fixing",
          "fizzing",
          "flapping",
          "flashing",
          "fleeing",
          "flinging",
          "floating",
          "flopping",
          "flying",
          "folding",
          "following",
          "forbidding",
          "forcing",
          "forecasting",
          "foretelling",
          "forgetting",
          "forgiving",
          "forlesing",
          "forming",
          "forsaking",
          "founding",
          "framing",
          "freeing",
          "freezing",
          "frightening",
          "frying",
          "fulfilling",
          "gagging",
          "gaining",
          "gainsaying",
          "gashing",
          "gazing",
          "getting",
          "giving",
          "glancing",
          "glittering",
          "glowing",
          "going",
          "googling",
          "governing",
          "grabbing",
          "grading",
          "granting",
          "greeting",
          "grinding",
          "gripping",
          "growing",
          "guarding",
          "guessing",
          "guiding",
          "handling",
          "hanging",
          "happening",
          "harming",
          "hatching",
          "hating",
          "having",
          "healing",
          "hearing",
          "heaving",
          "helping",
          "hewing",
          "hiding",
          "hindering",
          "hissing",
          "hitting",
          "hoaxing",
          "holding",
          "hopping",
          "hoping",
          "horrifying",
          "hugging",
          "humming",
          "humiliating",
          "hunting",
          "hurling",
          "hurrying",
          "hurting",
          "hushing",
          "hustling",
          "hypnotizing",
          "idealizing",
          "identifying",
          "idolizing",
          "igniting",
          "ignoring",
          "illuminating",
          "illustrating",
          "imagining",
          "imbibing",
          "imitating",
          "immersing",
          "immolating",
          "impairing",
          "imparting",
          "impeaching",
          "impeding",
          "impinging",
          "implanting",
          "implicating",
          "imploding",
          "imploring",
          "implying",
          "importing",
          "imposing",
          "impressing",
          "imprinting",
          "imprisoning",
          "improving",
          "inaugurating",
          "including",
          "increasing",
          "inculcating",
          "indenting",
          "indicating",
          "inducing",
          "indulging",
          "infecting",
          "infesting",
          "inflaming",
          "inflating",
          "inflecting",
          "informing",
          "infringing",
          "infusing",
          "ingesting",
          "inhabiting",
          "inhaling",
          "inheriting",
          "initiating",
          "injecting",
          "injuring",
          "innovating",
          "inputting",
          "inquiring",
          "inscribing",
          "inserting",
          "inspecting",
          "inspiring",
          "installing",
          "insulting",
          "integrating",
          "introducing",
          "inventing",
          "inviting",
          "joining",
          "jumping",
          "justifying",
          "keeping",
          "kicking",
          "kidding",
          "killing",
          "kissing",
          "kneeling",
          "knitting",
          "knocking",
          "landing",
          "lasting",
          "latching",
          "laughing",
          "laying",
          "leading",
          "leaking",
          "leaning",
          "leaping",
          "learning",
          "leaving",
          "leering",
          "lending",
          "letting",
          "licking",
          "lying",
          "lifting",
          "lighting",
          "liking",
          "limping",
          "listening",
          "living",
          "looking",
          "losing",
          "loving",
          "magnifying",
          "maintaining",
          "making",
          "managing",
          "marching",
          "marking",
          "marrying",
          "mashing",
          "matching",
          "measuring",
          "meeting",
          "melting",
          "merging",
          "mewing",
          "migrating",
          "milking",
          "minding",
          "misleading",
          "missing",
          "mistaking",
          "misusing",
          "mixing",
          "moaning",
          "modifying",
          "mooing",
          "motivating",
          "moulding",
          "moving",
          "mowing",
          "multiplying",
          "murmuring",
          "nailing",
          "napping",
          "needing",
          "neglecting",
          "nipping",
          "nodding",
          "noting",
          "noticing",
          "notifying",
          "nourishing",
          "nursing",
          "obeying",
          "obliging",
          "observing",
          "obstructing",
          "obtaining",
          "occupying",
          "offering",
          "offsetting",
          "omitting",
          "oozing",
          "opening",
          "operating",
          "opining",
          "oppressing",
          "opting",
          "optimizing",
          "ordering",
          "organizing",
          "originating",
          "outputting",
          "overflowing",
          "overtaking",
          "owing",
          "owning",
          "pacifying",
          "painting",
          "pardoning",
          "parting",
          "partaking",
          "participating",
          "passing",
          "pasting",
          "patting",
          "patching",
          "pausing",
          "paying",
          "peeping",
          "perishing",
          "permitting",
          "persuading",
          "phoning",
          "placing",
          "planning",
          "playing",
          "pleading",
          "pleasing",
          "plodding",
          "plotting",
          "plucking",
          "plying",
          "pointing",
          "polishing",
          "polluting",
          "pondering",
          "pouring",
          "pouting",
          "practicing",
          "praising",
          "praying",
          "preaching",
          "preparing",
          "prescribing",
          "presenting",
          "preserving",
          "presiding",
          "pressing",
          "pretending",
          "preventing",
          "printing",
          "proceeding",
          "producing",
          "progressing",
          "prohibiting",
          "promising",
          "proposing",
          "prosecuting",
          "protecting",
          "proving",
          "providing",
          "pulling",
          "punishing",
          "purifying",
          "pushing",
          "putting",
          "qualifying",
          "quarreling",
          "questioning",
          "quitting",
          "racing",
          "raining",
          "rattling",
          "reaching",
          "reading",
          "realizing",
          "rebuilding",
          "recalling",
          "recasting",
          "receiving",
          "reciting",
          "recognizing",
          "recollecting",
          "recurring",
          "redoing",
          "reducing",
          "referring",
          "reflecting",
          "refusing",
          "regarding",
          "regretting",
          "relating",
          "relaxing",
          "relying",
          "remaining",
          "remaking",
          "removing",
          "rending",
          "renewing",
          "renouncing",
          "repairing",
          "repeating",
          "replacing",
          "replying",
          "reporting",
          "requesting",
          "reselling",
          "resembling",
          "resetting",
          "resisting",
          "resolving",
          "respecting",
          "resting",
          "restraining",
          "retaining",
          "retching",
          "retiring",
          "returning",
          "reusing",
          "reviewing",
          "rewinding",
          "ridding",
          "riding",
          "ringing",
          "rising",
          "roaring",
          "robbing",
          "rolling",
          "rotting",
          "rubbing",
          "ruling",
          "running",
          "rushing",
          "sabotaging",
          "sacking",
          "sacrificing",
          "saddening",
          "saddling",
          "sagging",
          "sailing",
          "saluting",
          "salvaging",
          "sampling",
          "sanctifying",
          "sanctioning",
          "sapping",
          "sashaying",
          "sassing",
          "sating",
          "satiating",
          "satirizing",
          "satisfying",
          "saturating",
          "sauntering",
          "saving",
          "savoring",
          "sawing",
          "saying",
          "scabbing",
          "scalding",
          "scaling",
          "scamming",
          "scanning",
          "scarring",
          "scaring",
          "scarping",
          "scatting",
          "scattering",
          "scolding",
          "scorching",
          "scowling",
          "scrawling",
          "screaming",
          "screwing",
          "scrubbing",
          "searching",
          "seating",
          "securing",
          "seeing",
          "seeking",
          "seeming",
          "seizing",
          "selecting",
          "selling",
          "sending",
          "sentencing",
          "separating",
          "setting",
          "severing",
          "sewing",
          "shaking",
          "shaping",
          "sharing",
          "shattering",
          "shaving",
          "shearing",
          "shedding",
          "shining",
          "shirking",
          "shitting",
          "shivering",
          "shocking",
          "shooting",
          "shortening",
          "shouting",
          "showing",
          "shrinking",
          "shunning",
          "shutting",
          "signaling",
          "signifying",
          "singing",
          "sinking",
          "sipping",
          "sitting",
          "skiing",
          "skidding",
          "slamming",
          "slaying",
          "sleeping",
          "sliding",
          "slimming",
          "slinging",
          "slinking",
          "slipping",
          "slitting",
          "smashing",
          "smelling",
          "smiling",
          "smiting",
          "smoothing",
          "smothering",
          "snapping",
          "snatching",
          "sneaking",
          "sneezing",
          "sniffing",
          "soaring",
          "sobbing",
          "soliciting",
          "solving",
          "soothing",
          "sorting",
          "sowing",
          "sparkling",
          "speaking",
          "speeding",
          "spelling",
          "spending",
          "spilling",
          "spinning",
          "spitting",
          "splitting",
          "spoiling",
          "spraying",
          "spreading",
          "springing",
          "sprouting",
          "squeezing",
          "standing",
          "staring",
          "starting",
          "stating",
          "staying",
          "stealing",
          "steeping",
          "stemming",
          "stepping",
          "sterilizing",
          "sticking",
          "stimulating",
          "stinging",
          "stinking",
          "stirring",
          "stitching",
          "stooping",
          "stopping",
          "storing",
          "straining",
          "straying",
          "stressing",
          "stretching",
          "strewing",
          "striding",
          "striking",
          "stringing",
          "striving",
          "studying",
          "submitting",
          "subscribing",
          "subtracting",
          "succeeding",
          "sucking",
          "suffering",
          "suggesting",
          "summoning",
          "supplying",
          "supporting",
          "supposing",
          "surging",
          "surmising",
          "surpassing",
          "surrounding",
          "surveying",
          "surviving",
          "swallowing",
          "swaying",
          "swearing",
          "sweating",
          "sweeping",
          "swelling",
          "swimming",
          "swinging",
          "taking",
          "talking",
          "tapping",
          "tasting",
          "taxing",
          "teaching",
          "tearing",
          "teeing",
          "telling",
          "tempting",
          "tending",
          "terminating",
          "terrifying",
          "testing",
          "thanking",
          "thinking",
          "thriving",
          "throwing",
          "thrusting",
          "thumping",
          "tying",
          "tiring",
          "tossing",
          "touching",
          "training",
          "trampling",
          "transferring",
          "transforming",
          "translating",
          "trapping",
          "traveling",
          "treading",
          "treasuring",
          "treating",
          "trembling",
          "trusting",
          "trying",
          "turning",
          "typing",
          "understanding",
          "undoing",
          "uprooting",
          "upsetting",
          "urging",
          "using",
          "uttering",
          "valuing",
          "vanishing",
          "varying",
          "verifying",
          "vexing",
          "vying",
          "viewing",
          "violating",
          "vomiting",
          "waking",
          "walking",
          "wandering",
          "wanting",
          "warning",
          "wasting",
          "watching",
          "watering",
          "waving",
          "waxing",
          "waylaying",
          "wearing",
          "weaving",
          "wedding",
          "weeping",
          "weighing",
          "welcoming",
          "wending",
          "wetting",
          "whipping",
          "whispering",
          "winning",
          "winding",
          "wishing",
          "withdrawing",
          "working",
          "worrying",
          "worshipping",
          "wringing",
          "writing",
          "yawning",
          "yelling",
          "yielding",
          "zooming"
        ],
        "past": [
          "abashed",
          "abated",
          "abode",
          "absorbed",
          "accepted",
          "accompanied",
          "ached",
          "achieved",
          "acquired",
          "acted",
          "added",
          "addressed",
          "adjusted",
          "admired",
          "admitted",
          "advised",
          "afforded",
          "agreed",
          "alit",
          "allowed",
          "animated",
          "announced",
          "answered",
          "apologized",
          "appeared",
          "applauded",
          "applied",
          "approached",
          "approved",
          "argued",
          "arose",
          "arranged",
          "arrested",
          "asked",
          "asserted",
          "assorted",
          "astonished",
          "attacked",
          "attended",
          "attracted",
          "audited",
          "avoided",
          "awoke",
          "banged",
          "banished",
          "bashed",
          "batted",
          "was",
          "bore",
          "bore",
          "beat",
          "beautified",
          "became",
          "befell",
          "begged",
          "began",
          "behaved",
          "beheld",
          "believed",
          "belonged",
          "bent",
          "bereft",
          "besought",
          "bet",
          "betrayed",
          "bade",
          "bid",
          "bound",
          "bit",
          "bled",
          "blessed",
          "blossomed",
          "blew",
          "blurred",
          "blushed",
          "boarded",
          "boasted",
          "boiled",
          "bowed",
          "boxed",
          "brayed",
          "broke",
          "breathed",
          "bred",
          "brought",
          "broadcast",
          "brushed",
          "built",
          "burnt",
          "burst",
          "buried",
          "bust",
          "bought",
          "buzzed",
          "calculated",
          "called",
          "canvassed",
          "captured",
          "caressed",
          "carried",
          "carved",
          "cashed",
          "cast",
          "caught",
          "caused",
          "ceased",
          "celebrated",
          "challenged",
          "changed",
          "charged",
          "chased",
          "chatted",
          "checked",
          "cheered",
          "chewed",
          "chid",
          "chipped",
          "choked",
          "chose",
          "classified",
          "cleaned",
          "clove/cleft",
          "clicked",
          "climbed",
          "clung",
          "closed",
          "clad",
          "clutched",
          "collapsed",
          "collected",
          "coloured",
          "came",
          "commented",
          "compared",
          "compelled",
          "competed",
          "complained",
          "completed",
          "concluded",
          "conducted",
          "confessed",
          "confined",
          "confiscated",
          "confused",
          "congratulated",
          "connected",
          "connoted",
          "conquered",
          "consecrated",
          "consented",
          "conserved",
          "considered",
          "consigned",
          "consisted",
          "consoled",
          "consorted",
          "conspired",
          "constituted",
          "constrained",
          "constructed",
          "construed",
          "consulted",
          "contained",
          "contemned",
          "contended",
          "contested",
          "continued",
          "contracted",
          "contradicted",
          "contrasted",
          "contributed",
          "contrived",
          "controlled",
          "convened",
          "converged",
          "conversed",
          "converted",
          "conveyed",
          "convicted",
          "convinced",
          "cooed",
          "cooked",
          "cooled",
          "co-operated",
          "coped",
          "copied",
          "corrected",
          "corresponded",
          "corroded",
          "corrupted",
          "cost",
          "coughed",
          "counselled",
          "counted",
          "coursed",
          "covered",
          "cowered",
          "cracked",
          "crackled",
          "crashed",
          "craved",
          "created",
          "crept",
          "cribbed",
          "crossed",
          "crowded",
          "crushed",
          "cried",
          "curbed",
          "cured",
          "curved",
          "cut",
          "cycled",
          "damaged",
          "damped",
          "danced",
          "dared",
          "dashed",
          "dazzled",
          "dealt",
          "decayed",
          "decided",
          "declared",
          "decorated",
          "decreased",
          "dedicated",
          "delayed",
          "deleted",
          "denied",
          "depended",
          "deprived",
          "derived",
          "described",
          "desired",
          "destroyed",
          "detached",
          "detected",
          "determined",
          "developed",
          "died",
          "differed",
          "dug",
          "digested",
          "dimmed",
          "diminished",
          "dined",
          "dipped",
          "directed",
          "disappeared",
          "discovered",
          "discussed",
          "disobeyed",
          "displayed",
          "disposed",
          "distributed",
          "disturbed",
          "disused",
          "dived",
          "divided",
          "did",
          "donated",
          "downloaded",
          "dragged",
          "drew",
          "dreamt",
          "dressed",
          "drilled",
          "drank",
          "drove",
          "dropped",
          "dried",
          "dumped",
          "dwelt",
          "dyed",
          "earned",
          "ate",
          "educated",
          "empowered",
          "emptied",
          "encircled",
          "encouraged",
          "encroached",
          "endangered",
          "endorsed",
          "endured",
          "engraved",
          "enjoyed",
          "enlarged",
          "enlightened",
          "entered",
          "envied",
          "erased",
          "escaped",
          "evaporated",
          "exchanged",
          "exclaimed",
          "excluded",
          "existed",
          "expanded",
          "expected",
          "explained",
          "explored",
          "expressed",
          "extended",
          "eyed",
          "faced",
          "failed",
          "fainted",
          "fell",
          "fanned",
          "fancied",
          "favoured",
          "faxed",
          "fed",
          "felt",
          "ferried",
          "fetched",
          "fought",
          "filled",
          "found",
          "finished",
          "fished",
          "fit/fitted",
          "fixed",
          "fizzed",
          "flapped",
          "flashed",
          "fled",
          "flung",
          "floated",
          "flopped",
          "flew",
          "folded",
          "followed",
          "forbade",
          "forced",
          "forecast",
          "foretold",
          "forgot",
          "forgave",
          "forlore",
          "formed",
          "forsook",
          "founded",
          "framed",
          "freed",
          "froze",
          "frightened",
          "fried",
          "fulfilled",
          "gagged",
          "gained",
          "gainsaid",
          "gashed",
          "gazed",
          "got",
          "gave",
          "glanced",
          "glittered",
          "glowed",
          "went",
          "googled",
          "governed",
          "grabbed",
          "graded",
          "granted",
          "greeted",
          "ground",
          "gripped",
          "grew",
          "guarded",
          "guessed",
          "guided",
          "handled",
          "hung",
          "happened",
          "harmed",
          "hatched",
          "hated",
          "had",
          "healed",
          "heard",
          "hove",
          "helped",
          "hewed",
          "hid",
          "hindered",
          "hissed",
          "hit",
          "hoaxed",
          "held",
          "hopped",
          "hoped",
          "horrified",
          "hugged",
          "hummed",
          "humiliated",
          "hunted",
          "hurled",
          "hurried",
          "hurt",
          "hushed",
          "hustled",
          "hypnotized",
          "idealized",
          "identified",
          "idolized",
          "ignited",
          "ignored",
          "ill-treated",
          "illuminated",
          "illumined",
          "illustrated",
          "imagined",
          "imbibed",
          "imitated",
          "immersed",
          "immolated",
          "immured",
          "impaired",
          "imparted",
          "impeached",
          "impeded",
          "impelled",
          "impended",
          "imperilled",
          "impinged",
          "implanted",
          "implicated",
          "imploded",
          "implored",
          "implied",
          "imported",
          "imposed",
          "impressed",
          "imprinted",
          "imprisoned",
          "improved",
          "inaugurated",
          "incised",
          "included",
          "increased",
          "inculcated",
          "indented",
          "indicated",
          "induced",
          "indulged",
          "infected",
          "infested",
          "inflamed",
          "inflated",
          "inflected",
          "informed",
          "infringed",
          "infused",
          "ingested",
          "inhabited",
          "inhaled",
          "inherited",
          "initiated",
          "injected",
          "injured",
          "inlaid",
          "innovated",
          "input",
          "inquired",
          "inscribed",
          "inserted",
          "inspected",
          "inspired",
          "installed",
          "insulted",
          "insured",
          "integrated",
          "introduced",
          "invented",
          "invited",
          "joined",
          "jumped",
          "justified",
          "kept",
          "kicked",
          "kidded",
          "killed",
          "kissed",
          "knelt",
          "knit",
          "knocked",
          "knew",
          "laded",
          "landed",
          "lasted",
          "latched",
          "laughed",
          "laid",
          "led",
          "leaked",
          "leant",
          "leapt",
          "learnt",
          "left",
          "leered",
          "lent",
          "let",
          "licked",
          "lay",
          "lied",
          "lifted",
          "lit",
          "liked",
          "limped",
          "listened",
          "lived",
          "looked",
          "lost",
          "loved",
          "magnified",
          "maintained",
          "made",
          "managed",
          "marched",
          "marked",
          "married",
          "mashed",
          "matched",
          "mattered",
          "meant",
          "measured",
          "met",
          "melted",
          "merged",
          "mewed",
          "migrated",
          "milked",
          "minded",
          "misled",
          "missed",
          "mistook",
          "misused",
          "mixed",
          "moaned",
          "modified",
          "mooed",
          "motivated",
          "moulded",
          "moulted",
          "moved",
          "mowed",
          "multiplied",
          "murmured",
          "nailed",
          "napped",
          "needed",
          "neglected",
          "nipped",
          "nodded",
          "noted",
          "noticed",
          "notified",
          "nourished",
          "nursed",
          "obeyed",
          "obliged",
          "observed",
          "obstructed",
          "obtained",
          "occupied",
          "occurred",
          "offered",
          "offset",
          "omitted",
          "oozed",
          "opened",
          "operated",
          "opined",
          "oppressed",
          "opted",
          "optimized",
          "ordered",
          "organized",
          "originated",
          "output",
          "overflowed",
          "overtook",
          "owed",
          "owned",
          "pacified",
          "painted",
          "pardoned",
          "parted",
          "partook",
          "participated",
          "passed",
          "pasted",
          "patted",
          "patched",
          "paused",
          "paid",
          "peeped",
          "perished",
          "permitted",
          "persuaded",
          "phoned",
          "placed",
          "planned",
          "played",
          "pled",
          "pleased",
          "plodded",
          "plotted",
          "plucked",
          "plied",
          "pointed",
          "polished",
          "polluted",
          "pondered",
          "poured",
          "pouted",
          "practised",
          "praised",
          "prayed",
          "preached",
          "preferred",
          "prepared",
          "prescribed",
          "presented",
          "preserved",
          "preset",
          "presided",
          "pressed",
          "pretended",
          "prevented",
          "printed",
          "proceeded",
          "produced",
          "progressed",
          "prohibited",
          "promised",
          "proposed",
          "prosecuted",
          "protected",
          "proved",
          "provided",
          "pulled",
          "punished",
          "purified",
          "pushed",
          "put",
          "qualified",
          "quarrelled",
          "questioned",
          "quit",
          "raced",
          "rained",
          "rattled",
          "reached",
          "read",
          "realized",
          "rebuilt",
          "recalled",
          "recast",
          "received",
          "recited",
          "recognized",
          "recollected",
          "recurred",
          "redid",
          "reduced",
          "referred",
          "reflected",
          "refused",
          "regarded",
          "regretted",
          "related",
          "relaxed",
          "relied",
          "remained",
          "remade",
          "removed",
          "rent",
          "renewed",
          "renounced",
          "repaired",
          "repeated",
          "replaced",
          "replied",
          "reported",
          "requested",
          "resold",
          "resembled",
          "reset",
          "resisted",
          "resolved",
          "respected",
          "rested",
          "restrained",
          "retained",
          "retched",
          "retired",
          "returned",
          "reused",
          "reviewed",
          "rewound",
          "rid",
          "rode",
          "rang",
          "rose",
          "roared",
          "robbed",
          "rolled",
          "rotted",
          "rubbed",
          "ruled",
          "ran",
          "rushed",
          "sabotaged",
          "sacked",
          "sacrificed",
          "saddened",
          "saddled",
          "sagged",
          "sailed",
          "sallied",
          "saluted",
          "salvaged",
          "salved",
          "sampled",
          "sanctified",
          "sanctioned",
          "sapped",
          "saponified",
          "sashed",
          "sashayed",
          "sassed",
          "sated",
          "satiated",
          "satirised",
          "satisfied",
          "saturated",
          "sauntered",
          "saved",
          "savored",
          "savvied",
          "sawed",
          "said",
          "scabbed",
          "scabbled",
          "scalded",
          "scaled",
          "scammed",
          "scanned",
          "scanted",
          "scarred",
          "scared",
          "scarified",
          "scarped",
          "scatted",
          "scattered",
          "scolded",
          "scorched",
          "scowled",
          "scrawled",
          "screamed",
          "screwed",
          "scrubbed",
          "searched",
          "seated",
          "secured",
          "saw",
          "sought",
          "seemed",
          "seized",
          "selected",
          "sold",
          "sent",
          "sentenced",
          "separated",
          "set",
          "severed",
          "sewed",
          "shook",
          "shaped",
          "shared",
          "shattered",
          "shove",
          "shore",
          "shed",
          "shone",
          "shirked",
          "shit",
          "shivered",
          "shocked",
          "shod",
          "shot",
          "shortened",
          "shouted",
          "showed",
          "shrank",
          "shunned",
          "shut",
          "sighted",
          "signalled",
          "signified",
          "sang",
          "sank",
          "sipped",
          "sat",
          "skied",
          "skidded",
          "slammed",
          "slew",
          "slept",
          "slid",
          "slimmed",
          "slung",
          "slunk",
          "slipped",
          "slit",
          "smashed",
          "smelt",
          "smiled",
          "smote",
          "smoothed",
          "smothered",
          "snapped",
          "snatched",
          "snuck",
          "sneezed",
          "sniffed",
          "soared",
          "sobbed",
          "solicited",
          "solved",
          "soothed",
          "sorted",
          "sowed",
          "sparkled",
          "spoke",
          "sped",
          "spelt",
          "spent",
          "spilt",
          "span/spun",
          "spat/spit",
          "split",
          "spoilt",
          "sprayed",
          "spread",
          "sprang",
          "sprouted",
          "squeezed",
          "stood",
          "stared",
          "started",
          "stated",
          "stayed",
          "stole",
          "steeped",
          "stemmed",
          "stepped",
          "sterilized",
          "stuck",
          "stimulated",
          "stung",
          "stank",
          "stirred",
          "stitched",
          "stooped",
          "stopped",
          "stored",
          "strained",
          "strayed",
          "stressed",
          "stretched",
          "strewed",
          "strode",
          "struck",
          "strung",
          "strove",
          "studied",
          "submitted",
          "subscribed",
          "subtracted",
          "succeeded",
          "sucked",
          "suffered",
          "suggested",
          "summoned",
          "supplied",
          "supported",
          "supposed",
          "surged",
          "surmised",
          "surpassed",
          "surrounded",
          "surveyed",
          "survived",
          "swallowed",
          "swayed",
          "swore",
          "sweat",
          "swept",
          "swelled",
          "swam",
          "swung",
          "swotted",
          "took",
          "talked",
          "tapped",
          "tasted",
          "taxed",
          "taught",
          "tore",
          "teed",
          "told",
          "tempted",
          "tended",
          "terminated",
          "terrified",
          "tested",
          "thanked",
          "thought",
          "throve",
          "threw",
          "thrust",
          "thumped",
          "tied",
          "tired",
          "tossed",
          "touched",
          "trained",
          "trampled",
          "transferred",
          "transformed",
          "translated",
          "trapped",
          "travelled",
          "trod",
          "treasured",
          "treated",
          "treed",
          "trembled",
          "triumphed",
          "trusted",
          "tried",
          "turned",
          "typed",
          "typeset",
          "understood",
          "undid",
          "uprooted",
          "upset",
          "urged",
          "used",
          "uttered",
          "valued",
          "vanished",
          "varied",
          "verified",
          "vexed",
          "vied",
          "viewed",
          "violated",
          "vomited",
          "woke",
          "walked",
          "wandered",
          "wanted",
          "warned",
          "wasted",
          "watched",
          "watered",
          "waved",
          "waxed",
          "waylaid",
          "wore",
          "wove",
          "wed",
          "wept",
          "weighed",
          "welcomed",
          "went",
          "wet",
          "whipped",
          "whispered",
          "won",
          "wound",
          "wished",
          "withdrew",
          "worked",
          "worried",
          "worshipped",
          "wrung",
          "wrote",
          "yawned",
          "yelled",
          "yielded",
          "zincked",
          "zoomed"
        ],
        "past_participle": [
          "abashed",
          "abated",
          "abode",
          "absorbed",
          "accepted",
          "accompanied",
          "ached",
          "achieved",
          "acquired",
          "acted",
          "added",
          "addressed",
          "adjusted",
          "admired",
          "admitted",
          "advised",
          "afforded",
          "agreed",
          "alit",
          "allowed",
          "animated",
          "announced",
          "answered",
          "apologized",
          "appeared",
          "applauded",
          "applied",
          "approached",
          "approved",
          "argued",
          "arisen",
          "arranged",
          "arrested",
          "asked",
          "asserted",
          "assorted",
          "astonished",
          "attacked",
          "attended",
          "attracted",
          "audited",
          "avoided",
          "awoken",
          "banged",
          "banished",
          "bashed",
          "batted",
          "been",
          "born",
          "borne",
          "beaten",
          "beautified",
          "become",
          "befallen",
          "begged",
          "begun",
          "behaved",
          "beheld",
          "believed",
          "belonged",
          "bent",
          "bereft",
          "besought",
          "bet",
          "betrayed",
          "bidden",
          "bid",
          "bound",
          "bitten",
          "bled",
          "blessed",
          "blossomed",
          "blown",
          "blurred",
          "blushed",
          "boarded",
          "boasted",
          "boiled",
          "bowed",
          "boxed",
          "brayed",
          "broken",
          "breathed",
          "bred",
          "brought",
          "broadcast",
          "brushed",
          "built",
          "burnt",
          "burst",
          "buried",
          "bust",
          "bought",
          "buzzed",
          "calculated",
          "called",
          "canvassed",
          "captured",
          "caressed",
          "carried",
          "carved",
          "cashed",
          "cast",
          "caught",
          "caused",
          "ceased",
          "celebrated",
          "challenged",
          "changed",
          "charged",
          "chased",
          "chatted",
          "checked",
          "cheered",
          "chewed",
          "chid/chidden",
          "chipped",
          "choked",
          "chosen",
          "classified",
          "cleaned",
          "cloven/cleft",
          "clicked",
          "climbed",
          "clung",
          "closed",
          "clad",
          "clutched",
          "collapsed",
          "collected",
          "coloured",
          "come",
          "commented",
          "compared",
          "compelled",
          "competed",
          "complained",
          "completed",
          "concluded",
          "conducted",
          "confessed",
          "confined",
          "confiscated",
          "confused",
          "congratulated",
          "connected",
          "connoted",
          "conquered",
          "consecrated",
          "consented",
          "conserved",
          "considered",
          "consigned",
          "consisted",
          "consoled",
          "consorted",
          "conspired",
          "constituted",
          "constrained",
          "constructed",
          "construed",
          "consulted",
          "contained",
          "contemned",
          "contended",
          "contested",
          "continued",
          "contracted",
          "contradicted",
          "contrasted",
          "contributed",
          "contrived",
          "controlled",
          "convened",
          "converged",
          "conversed",
          "converted",
          "conveyed",
          "convicted",
          "convinced",
          "cooed",
          "cooked",
          "cooled",
          "co-operated",
          "cope",
          "copied",
          "corrected",
          "corresponded",
          "corroded",
          "corrupted",
          "cost",
          "coughed",
          "counselled",
          "counted",
          "coursed",
          "covered",
          "cowered",
          "cracked",
          "crackled",
          "crashed",
          "craved",
          "created",
          "crept",
          "cribbed",
          "crossed",
          "crowded",
          "crushed",
          "cried",
          "curbed",
          "cured",
          "curved",
          "cut",
          "cycled",
          "damaged",
          "damped",
          "danced",
          "dared",
          "dashed",
          "dazzled",
          "dealt",
          "decayed",
          "decided",
          "declared",
          "decorated",
          "decreased",
          "dedicated",
          "delayed",
          "deleted",
          "denied",
          "depended",
          "deprived",
          "derived",
          "described",
          "desired",
          "destroyed",
          "detached",
          "detected",
          "determined",
          "developed",
          "died",
          "differed",
          "dug",
          "digested",
          "dimmed",
          "diminished",
          "dined",
          "dipped",
          "directed",
          "disappeared",
          "discovered",
          "discussed",
          "disobeyed",
          "displayed",
          "disposed",
          "distributed",
          "disturbed",
          "disused",
          "dived",
          "divided",
          "done",
          "donated",
          "downloaded",
          "dragged",
          "drawn",
          "dreamt",
          "dressed",
          "drilled",
          "drunk",
          "driven",
          "dropped",
          "dried",
          "dumped",
          "dwelt",
          "dyed",
          "earned",
          "eaten",
          "educated",
          "empowered",
          "emptied",
          "encircled",
          "encouraged",
          "encroached",
          "endangered",
          "endorsed",
          "endured",
          "engraved",
          "enjoyed",
          "enlarged",
          "enlightened",
          "entered",
          "envied",
          "erased",
          "escaped",
          "evaporated",
          "exchanged",
          "exclaimed",
          "excluded",
          "existed",
          "expanded",
          "expected",
          "explained",
          "explored",
          "expressed",
          "extended",
          "eyed",
          "faced",
          "failed",
          "fainted",
          "fallen",
          "fanned",
          "fancied",
          "favoured",
          "faxed",
          "fed",
          "felt",
          "ferried",
          "fetched",
          "fought",
          "filled",
          "found",
          "finished",
          "fished",
          "fit/fitted",
          "fixed",
          "fizzed",
          "flapped",
          "flashed",
          "fled",
          "flung",
          "floated",
          "flopped",
          "flown",
          "folded",
          "followed",
          "forbidden",
          "forced",
          "forecast",
          "foretold",
          "forgotten",
          "forgiven",
          "forlorn",
          "formed",
          "forsaken",
          "founded",
          "framed",
          "freed",
          "frozen",
          "frightened",
          "fried",
          "fulfilled",
          "gagged",
          "gained",
          "gainsaid",
          "gashed",
          "gazed",
          "got",
          "given",
          "glanced",
          "glittered",
          "glowed",
          "gone",
          "googled",
          "governed",
          "grabbed",
          "graded",
          "granted",
          "greeted",
          "ground",
          "gripped",
          "grown",
          "guarded",
          "guessed",
          "guided",
          "handled",
          "hung",
          "happened",
          "harmed",
          "hatched",
          "hated",
          "had",
          "healed",
          "heard",
          "hove",
          "helped",
          "hewn",
          "hidden",
          "hindered",
          "hissed",
          "hit",
          "hoaxed",
          "held",
          "hopped",
          "hoped",
          "horrified",
          "hugged",
          "hummed",
          "humiliated",
          "hunted",
          "hurled",
          "hurried",
          "hurt",
          "hushed",
          "hustled",
          "hypnotized",
          "idealized",
          "identified",
          "idolized",
          "ignited"
        ],
        "simple_present": [
          "abashes",
          "abates",
          "abides",
          "absorbs",
          "accepts",
          "accompanies",
          "aches",
          "achieves",
          "acquires",
          "acts",
          "adds",
          "addresses",
          "adjusts",
          "admires",
          "admits",
          "advises",
          "affords",
          "agrees",
          "alights",
          "allows",
          "animates",
          "announces",
          "answers",
          "apologizes",
          "appears",
          "applauds",
          "applies",
          "approaches",
          "approves",
          "argues",
          "arises",
          "arranges",
          "arrests",
          "asks",
          "asserts",
          "assorts",
          "astonishes",
          "attacks",
          "attends",
          "attracts",
          "audits",
          "avoids",
          "awakes",
          "bangs",
          "banishes",
          "bashes",
          "bats",
          "is",
          "bears",
          "bears",
          "beats",
          "beautifies",
          "becomes",
          "befalls",
          "begs",
          "begins",
          "behaves",
          "beholds",
          "believes",
          "belongs",
          "bends",
          "bereaves",
          "beseeches",
          "bets",
          "betrays",
          "bids",
          "bids",
          "binds",
          "bites",
          "bleeds",
          "blesses",
          "blossoms",
          "blows",
          "blurs",
          "blushes",
          "boards",
          "boasts",
          "boils",
          "bows",
          "boxes",
          "brays",
          "breaks",
          "breathes",
          "breeds",
          "brings",
          "broadcasts",
          "brushes",
          "builds",
          "burns",
          "bursts",
          "buries",
          "busts",
          "buys",
          "buzzes",
          "calculates",
          "calls",
          "canvasses",
          "captures",
          "caresses",
          "carries",
          "carves",
          "cashes",
          "casts",
          "catches",
          "causes",
          "ceases",
          "celebrates",
          "challenges",
          "changes",
          "charges",
          "chases",
          "chats",
          "checks",
          "cheers",
          "chews",
          "chides",
          "chips",
          "chokes",
          "chooses",
          "classifies",
          "cleans",
          "cleaves",
          "clicks",
          "climbs",
          "clings",
          "closes",
          "clothes",
          "clutches",
          "collapses",
          "collects",
          "colours",
          "comes",
          "comments",
          "compares",
          "compels",
          "competes",
          "complains",
          "completes",
          "concludes",
          "conducts",
          "confesses",
          "confines",
          "confiscates",
          "confuses",
          "congratulates",
          "connects",
          "connotes",
          "conquers",
          "consecrates",
          "consents",
          "conserves",
          "considers",
          "consigns",
          "consists",
          "consoles",
          "consorts",
          "conspires",
          "constitutes",
          "constrains",
          "constructs",
          "construes",
          "consults",
          "contains",
          "contemns",
          "contends",
          "contests",
          "continues",
          "contracts",
          "contradicts",
          "contrasts",
          "contributes",
          "contrives",
          "controls",
          "convenes",
          "converges",
          "converses",
          "converts",
          "conveys",
          "convicts",
          "convinces",
          "coos",
          "cooks",
          "cools",
          "co-operates",
          "copes",
          "copies",
          "corrects",
          "corresponds",
          "corrodes",
          "corrupts",
          "costs",
          "coughs",
          "counsels",
          "counts",
          "courses",
          "covers",
          "cowers",
          "cracks",
          "crackles",
          "crashes",
          "craves",
          "creates",
          "creeps",
          "cribs",
          "crosses",
          "crowds",
          "crushes",
          "cries",
          "curbs",
          "cures",
          "curves",
          "cuts",
          "cycles",
          "damages",
          "damps",
          "dances",
          "dares",
          "dashes",
          "dazzles",
          "deals",
          "decays",
          "decides",
          "declares",
          "decorates",
          "decreases",
          "dedicates",
          "delays",
          "deletes",
          "denies",
          "depends",
          "deprives",
          "derives",
          "describes",
          "desires",
          "destroys",
          "detaches",
          "detects",
          "determines",
          "develops",
          "dies",
          "differs",
          "digs",
          "digests",
          "dims",
          "diminishes",
          "dines",
          "dips",
          "directs",
          "disappears",
          "discovers",
          "discusses",
          "disobeys",
          "displays",
          "disposes",
          "distributes",
          "disturbs",
          "disuses",
          "dives",
          "divides",
          "does",
          "donates",
          "downloads",
          "drags",
          "draws",
          "dreams",
          "dresses",
          "drills",
          "drinks",
          "drives",
          "drops",
          "dries",
          "dumps",
          "dwells",
          "dyes",
          "earns",
          "eats",
          "educates",
          "empowers",
          "empties",
          "encircles",
          "encourages",
          "encroaches",
          "endangers",
          "endorses",
          "endures",
          "engraves",
          "enjoys",
          "enlarges",
          "enlightens",
          "enters",
          "envies",
          "erases",
          "escapes",
          "evaporates",
          "exchanges",
          "exclaims",
          "excludes",
          "exists",
          "expands",
          "expects",
          "explains",
          "explores",
          "expresses",
          "extends",
          "eyes",
          "faces",
          "fails",
          "faints",
          "falls",
          "fans",
          "fancies",
          "favours",
          "faxes",
          "feeds",
          "feels",
          "ferries",
          "fetches",
          "fights",
          "fills",
          "finds",
          "finishes",
          "fishes",
          "fits",
          "fixes",
          "fizzes",
          "flaps",
          "flashes",
          "flees",
          "flings",
          "floats",
          "flops",
          "flies",
          "folds",
          "follows",
          "forbids",
          "forces",
          "forecasts",
          "foretells",
          "forgets",
          "forgives",
          "forlese",
          "forms",
          "forsakes",
          "founds",
          "frames",
          "frees",
          "freezes",
          "frightens",
          "fries",
          "fulfils",
          "gags",
          "gains",
          "gainsays",
          "gashes",
          "gazes",
          "gets",
          "gives",
          "glances",
          "glitters",
          "glows",
          "goes",
          "googles",
          "governs",
          "grabs",
          "grades",
          "grants",
          "greets",
          "grinds",
          "grips",
          "grows",
          "guards",
          "guesses",
          "guides",
          "handles",
          "hangs",
          "happens",
          "harms",
          "hatches",
          "hates",
          "has",
          "heals",
          "hears",
          "heaves",
          "helps",
          "hews",
          "hides",
          "hinders",
          "hisses",
          "hits",
          "hoaxes",
          "holds",
          "hops",
          "hopes",
          "horrifies",
          "hugs",
          "hums",
          "humiliates",
          "hunts",
          "hurls",
          "hurries",
          "hurts",
          "hushes",
          "hustles",
          "hypnotizes",
          "idealizes",
          "identifies",
          "idolizes",
          "ignites"
        ]
      },
      "volleyball": {
        "coach": [
          "Al Scates",
          "Aleksander Skiba",
          "Andrea Anastasi",
          "Andrzej Niemczyk",
          "Andy Banachowski",
          "Bernardo Rezende",
          "Cathy George",
          "Daniel Castellani",
          "Dave Shoji",
          "Dave Shondell",
          "Don Shondell",
          "Edward Skorek",
          "Ferdinando De Giorgi",
          "Gwidon Grochowski",
          "Hubert Jerzy Wagner",
          "Hubert Jerzy Wagner",
          "Hubert Jerzy Wagner",
          "Hubert Wagner",
          "Hugh McCutcheon",
          "Ireneusz Mazur",
          "Jacek Busz",
          "Jerzy Welcz",
          "John Cook",
          "Julio Velasco",
          "Laurie Corbelli",
          "Leonard Michniewski",
          "Leszek Milewski",
          "Mauro Berruto",
          "Michael Sealy",
          "Mick Haley",
          "Pete Waite",
          "Radostin Stojczew",
          "Russ Rose",
          "Ryan McGuyre",
          "Ryszard Bosek",
          "Ryszard Kruk",
          "Siergiej Owczinnikow",
          "Siergiej Szlapnikow",
          "Steve Shondell",
          "Tadeusz Szlagor",
          "Terry Liskevych",
          "Terry Pettit",
          "Vital Heynen",
          "Vladimir Kuzyutkin",
          "Wayne Kreklow",
          "Wiktor Krebok",
          "Wojciech Drzyzga",
          "Zbigniew Zarzycki",
          "Zygmunt Kraus",
          "Zygmunt Kraus",
          "Zygmunt Kraus"
        ],
        "formation": [
          "4-2",
          "5-1",
          "6-2"
        ],
        "player": [
          "Aaron Russell",
          "Abdul Basith",
          "Adel Gholami",
          "Agnieszka Bednarek-Kasza",
          "Ai Inden",
          "Ai Otomo",
          "Aiza Maizo",
          "Aki Shibata",
          "Akiko Ino",
          "Akiko Uchida",
          "Alaina Bergsma",
          "Albert Cristina",
          "Aleona Denise Santiago",
          "Alyssa Valdez",
          "Amir Ghafour",
          "Amporn Hyapha",
          "Ana Ida Alvares",
          "Andrea Anastasi",
          "Andrea Bari",
          "Andrea Giani",
          "Andrea Zorzi",
          "Andrey Zhekov",
          "Andrzej Wrona",
          "Angeli Tabaquero",
          "Anna Podolec",
          "Annerys Vargas",
          "Annie Drews",
          "Antonin Rouzier",
          "Antonina Zetova",
          "Arisa Takada",
          "Asako Tajimi",
          "Aurea Francesca Racraquin",
          "Avital Selinger",
          "Aya Mikami",
          "Ayako Sana",
          "Ballu",
          "Barbara Niemczyk",
          "Bartosz Kurek",
          "Bas van de Goor",
          "Berenika Tomsia",
          "Bernardo Rezende",
          "Bethania de la Cruz",
          "Boyan Yordanov",
          "Brecht Rodenburg",
          "Bruno Rezende",
          "Camila Brait",
          "Carolina Albuquerque",
          "Celeste Plak",
          "Charo Soriano",
          "Chiaka Ogbogu",
          "Chie Tsuji",
          "Chihiro Kato",
          "Chono Penchev",
          "Christina Bauer",
          "Clayton Stanley",
          "Cyril C. Valloor",
          "Damian Wojtaszek",
          "Dani Lins",
          "Dante Amaral",
          "Dante Boninfante",
          "Dawid Murek",
          "Dax Holdren",
          "Denden Lazaro",
          "Dimitar Zlatanov",
          "Dirk-Jan van Gendt",
          "Dobriana Rabadzhieva",
          "Dominik Witczak",
          "Dragan Travica",
          "Dzi Gervacio",
          "Earvin N'Gapeth",
          "Edward Skorek",
          "Edwin Benne",
          "Ekaterina Gamova",
          "Elitsa Vasileva",
          "Emanuele Birarelli",
          "Eri Hosoda",
          "Esteban de Palma",
          "Eugene Selznick",
          "Eva Yaneva",
          "Evgeni Ivanov",
          "Fabian Drzyzga",
          "Facundo Conte",
          "Farhad Ghaemi",
          "Farhad Zarif",
          "Ferdinand Tille",
          "Fernanda Garay",
          "Fille Saint Merced Cainglet",
          "Foluke Akinradewo",
          "Franco Bertoli",
          "Georg Grozer",
          "Georgi Bratoev",
          "Georgi Seganov",
          "Gergana Dimitrova",
          "Giba",
          "Gina del Rosario",
          "Gretchen Ho",
          "Grit Lehmann",
          "Grzegorz Bociek",
          "Grzegorz Kosok",
          "Gustavo Endres",
          "Hamzeh Zarini",
          "Hanna Busz",
          "Haruka Sunada",
          "Henk-Jan Held",
          "Hiroko Matsuura",
          "Hitomi Nakamichi",
          "Honami Tsukiji",
          "Hristina Ruseva",
          "Hristo Tsvetanov",
          "Hristo Zlatanov",
          "Hugo Conte",
          "Ikumi Narita",
          "Isa Molde",
          "Ivan Zaytsev",
          "Jaja Santiago",
          "Jakub Jarosz",
          "Jakub Kochanowski",
          "Jan Posthuma",
          "Janne Heikkinen",
          "Jaqueline Carvalho",
          "Jem Ferrer",
          "Jenia Grebennikov",
          "Jennifer Martz",
          "Jeoselyna Rodriguez Santos",
          "Jeroen Trommel",
          "Jessica Margarett Galanza",
          "Jimmy George",
          "Joanna Kaczor",
          "Joanna Mirek",
          "Joel Despaigne",
          "Jon Uriarte",
          "Jordan Larson",
          "Jorella Marie de Jesus",
          "Jovelyn Gonzaga",
          "Julia Melissa Morado",
          "Jungo Morita",
          "Juri Yokoyama",
          "Justine Wong-Orantes",
          "K. J. Kapil Dev",
          "K. Udayakumar",
          "Kalei Mau",
          "Kana Kawakami",
          "Kana Oyama",
          "Kanako Hirai",
          "Kanako Omura",
          "Kanari Hamaguchi",
          "Kaori Inoue",
          "Kaoru Sugayama",
          "Karch Kiraly",
          "Karla Echenique",
          "Katsutoshi Nekoda",
          "Kay van Dijk",
          "Keiki Nishiyama",
          "Kerri Walsh Jennings",
          "Kim Fajardo",
          "Kim Oden",
          "Kim Staelens",
          "Kim Yeon-koung",
          "Klaudia Kaczorowska",
          "Kotoe Inoue",
          "Kotomi Tosaki",
          "Kristina Guncheva",
          "Kristyna Pastulova",
          "Krystyna Czajkowska",
          "Krzysztof Ignaczak",
          "Kumi Nakada",
          "Kumiko Sakino",
          "Kyoko Katashita",
          "Laura Dijkema",
          "Lauren Carlini",
          "Laurent Tillie",
          "Leandro Vissotto",
          "Leonel Marshall Jr.",
          "Lidia Chmielnicka",
          "Lina Yanchulova",
          "Lisvel Elisa Eve",
          "Lloy Ball",
          "Logan Tom",
          "Lorenzo Bernardi",
          "Luiz Felipe Fonteles",
          "Lukas Kampa",
          "Lyubov Sokolova (volleyball)",
          "Maciej Zajder",
          "Mai Fujii",
          "Mai Uemura",
          "Maiko Kano",
          "Makiko Horai",
          "Malika Kanthong",
          "Marcel Gromadowski",
          "Marcin Wika",
          "Marco Bonitta",
          "Marek Karbarz",
          "Maria Liktoras",
          "Maria Paulina Soriano",
          "Marie Wada",
          "Mariko Nishiwaki",
          "Mariola Zenik",
          "Mariya Karakasheva",
          "Marko Klok",
          "Marrit Leenstra",
          "Martin Teffer",
          "Masae Kasai",
          "Masami Taniguchi",
          "Masami Yokoyama",
          "Mateusz Bieniek",
          "Mateusz Mika",
          "Matey Kaziyski",
          "Matt Anderson",
          "Megumi Kawamura",
          "Megumi Kurihara",
          "Micah Christenson",
          "Micha Hancock",
          "Michele Baranowicz",
          "Michelle Bartsch-Hackley",
          "Midori Takahashi",
          "Mika Reyes",
          "Mike van de Goor",
          "Miki Oyama",
          "Milena Rosner",
          "Mira Todorova",
          "Mireya Luis",
          "Misha Latuhihin",
          "Misty May-Treanor",
          "Miya Sato",
          "Miyu Nagaoka",
          "Miyuki Kano",
          "Miyuki Takahashi",
          "Mohammad Mousavi (volleyball)",
          "Mohammadjavad Manavinezhad",
          "Motoko Obayashi",
          "Murilo Endres",
          "Nana Iwasaka",
          "Nanae Takizawa",
          "Nanami Inoue",
          "Naoko Hashimoto",
          "Nasya Dimitrova",
          "Nene Tomita",
          "Neslihan Darnel",
          "Nico Freriks",
          "Nicolas Marechal",
          "Nikolay Nikolov",
          "Nikolay Penchev",
          "Nikolay Uchikov",
          "Niverka Marte",
          "Nootsara Tomkom",
          "Olof van der Meulen",
          "Onuma Sittirak",
          "Pasquale Gravina",
          "Patcharee Sangmuang",
          "Patrick Hernandez",
          "Patryk Czarnowski",
          "Paula Pequeno",
          "Petia Yanchulova",
          "Petya Barakova",
          "Pieter Verhees",
          "Piotr Gacek",
          "Piotr Gruszka",
          "Piotr Nowakowski",
          "Plamen Konstantinov",
          "Pleumjit Thinkaow",
          "Prisilla Rivera",
          "Rachael Adams",
          "Rachel Anne Daquis",
          "Regla Bell",
          "Reinder Nummerdor",
          "Rhea Katrina Dimaculangan",
          "Richard Schuil",
          "Risa Sato",
          "Rob Bontje",
          "Rob Grabert",
          "Robert Horstink",
          "Robert Milczarek",
          "Robert Prygiel",
          "Ron Boudrie",
          "Ron Zwerver",
          "Ronald Zoodsma",
          "Rongomaipapa Amy Ahomiro",
          "Rozalin Penchev",
          "Ryszard Bosek",
          "Sachiko Sugiyama",
          "Saeid Marouf",
          "Saki Minemura",
          "Samuel Tuia",
          "Saori Kimura",
          "Saori Sakoda",
          "Sarra Belhocine",
          "Seiji Oko",
          "Seiko Kawamura",
          "Shahram Mahmoudi",
          "Sheilla Castro",
          "Shuka Oyama",
          "Simone Giannelli",
          "Strashimira Filipova",
          "Svetoslav Gotsev",
          "Takako Shirai",
          "Tayyiba Haneef",
          "Teodor Salparov",
          "Thaisa Menezes",
          "Thiago Soares Alves",
          "Thomas Jarmoc",
          "Todor Aleksiev",
          "Todor Skrimov",
          "Tom Joseph",
          "Tomoko Okano",
          "Tomomi Nakao",
          "Tots Carlos",
          "Tsvetan Sokolov",
          "Valentin Bratoev",
          "Victonara Galang",
          "Viktor Yosifov",
          "Vladimir Nikolov",
          "Wanda Wiecha",
          "Wanitchaya Luangtonglang",
          "Wanna Buakaew",
          "Wilavan Apinyapong",
          "Wilfredo Leon",
          "William Priddy",
          "Wojciech Grzyb",
          "Wytze Kooistra",
          "Yevgeniya Estes",
          "Yoko Zetterlund",
          "Yoshie Takeshita",
          "Yoshiko Yano",
          "Yuji Nishida",
          "Yuka Sakurai",
          "Yukari Miyata",
          "Yuki Ishikawa",
          "Yuki Kawai",
          "Yuki Tanaka",
          "Yukiko Ebata",
          "Yuko Maruyama",
          "Yuko Mitsuya",
          "Yuko Sano",
          "Yuko Suzuki",
          "Yumiko Tsuzuki",
          "Zbigniew Bartman",
          "Zhana Todorova",
          "Zhu Ting"
        ],
        "position": [
          "Defensive Specialist",
          "Libero",
          "Middle blocker",
          "Opposite hitter",
          "Outside hitter",
          "Right side hitter",
          "Setter"
        ],
        "team": [
          "A.S.D. Pallavolo Torino",
          "ACH Volley Ljubljana",
          "ADC Pirelli",
          "AERO Odolena Voda",
          "Al Rayyan",
          "Al-Ahly SC",
          "Al-Arabi Doha",
          "Aris Thessaloniki",
          "Arkas Spor Izmir",
          "AS Cannes",
          "Asnieres Volley 92",
          "Avtomobilist Saint Petersburg",
          "AZS AWF Warszawa",
          "Belogorie Belgorod",
          "Berlin Recycling Volleys",
          "Cerrad Enea Czarni Radom",
          "Club Sportif Sfaxien",
          "Crvena Zvezda Belgrade",
          "Csepel Budapest",
          "CSKA Moscow",
          "CSKA Sofia",
          "Cucine Lube Civitanova",
          "Diamant Odessa",
          "Draisma Dynamo Apeldoorn",
          "Dynamo Moscow",
          "EC Banespa",
          "Fakel Novy Urengoy",
          "Gabeca Pallavolo Spa",
          "Galatasaray Istanbul",
          "Halkbank Ankara",
          "Hamburger SV",
          "HAOK Mladost Zagreb",
          "hotVolleys Vienna",
          "Indykpol AZS Olsztyn",
          "Iraklis Thessaloniki",
          "Iskra Odintsovo",
          "Istanbul BBSK",
          "Itas Trentino",
          "JT Thunders Hiroshima",
          "Kioene Padova",
          "Knack Roeselare",
          "Lausanne UC",
          "Legia Warszawa",
          "Leo Shoes Modena",
          "Levski Sofia",
          "Lindemans Aalst",
          "Lokomotiv Ekaterinburg",
          "Lokomotiv Novosibirsk",
          "Lokomotyv - Zbirna Kharkivskoi Oblasti-1",
          "Lokomotyv Kyiv",
          "MGTU Moscow",
          "Moerser SC",
          "Montpellier UC",
          "Olympiacos Piraeus",
          "Osaka Blazers Sakai",
          "P.A.O.K. Thessaloniki",
          "Pallavolo Gonzaga Giovani Milano",
          "Pallavolo Parma",
          "Panasonic Panthers",
          "Panathinaikos Athens",
          "Paris UC",
          "Paris Volley",
          "Partizan Belgrade",
          "Paykan Tehran",
          "Piemonte Volley",
          "Porto Robur Costa 2030",
          "Racing Club de France",
          "Radiotechnik Riga",
          "Real Madrid",
          "Rembert Torhout",
          "SC Dynamo Berlin",
          "Schweriner SC",
          "Slavia Sofia",
          "Sport Lisboa e Benfica",
          "Sporting Clube de Espinho",
          "Stade Poitevin Poitiers",
          "Suntory Sunbirds",
          "SV Bayer Wuppertal",
          "Toray Arrows",
          "Tours VB",
          "UPCN Voley Club",
          "VC Greenyard Maaseik",
          "VC Leipzig",
          "VfB Friedrichshafen",
          "VK Dukla Liberec",
          "VKP Bratislava",
          "Vojvodina Novi Sad",
          "Volejbal Brno",
          "Volley Piacenza",
          "Volley Treviso",
          "Volleybalvereniging Visade Voorburg",
          "Zamalek",
          "Zenit Kazan",
          "Zinella Volley Bologna"
        ]
      },
      "world_cup": {
        "cities": [
          "Saint Petersburg",
          "Kaliningrad",
          "Rostov-on-Don",
          "Volgograd",
          "Moscow",
          "Sochi",
          "Kazan",
          "Nizhny Novgorod",
          "Saransk",
          "Samara",
          "Ekaterinburg"
        ],
        "groups": {
          "group_A": [
            "Egypt",
            "Russia",
            "Saudi Arabia",
            "Uruguay"
          ],
          "group_B": [
            "Iran",
            "Morocco",
            "Portugal",
            "Spain"
          ],
          "group_C": [
            "Australia",
            "Denmark",
            "France",
            "Peru"
          ],
          "group_D": [
            "Argentina",
            "Croatia",
            "Iceland",
            "Nigeria"
          ],
          "group_E": [
            "Brazil",
            "Costa Rica",
            "Serbia",
            "Switzerland"
          ],
          "group_F": [
            "Germany",
            "Mexico",
            "South Korea",
            "Sweden"
          ],
          "group_G": [
            "Belgium",
            "England",
            "Panama",
            "Tunisia"
          ],
          "group_H": [
            "Columbia",
            "Japan",
            "Poland",
            "Senegal"
          ]
        },
        "rosters": {
          "Argentina": {
            "coach": [
              "Jorge Sampaoli"
            ],
            "defenders": [
              "Marcos Acuna",
              "Cristian Ansaldi",
              "Federico Fazio",
              "Javier Mascherano",
              "Gabriel Mercado",
              "Nicolas Otamendi",
              "Marcos Rojo",
              "Eduardo Salvio",
              "Nicolas Tagliafico"
            ],
            "forwards": [
              "Sergio Aguero",
              "Paulo Dybala",
              "Gonzalo Higuain",
              "Lionel Messi"
            ],
            "goalkeepers": [
              "Franco Armani",
              "Willy Caballero",
              "Sergio Romero"
            ],
            "midfielders": [
              "Ever Banega",
              "Lucas Biglia",
              "Angel Di Maria",
              "Manuel Lanzini",
              "Giovani Lo Celso",
              "Maxi Meza",
              "Cristian Pavon"
            ]
          },
          "Australia": {
            "coach": [
              "Bert van Marwijk"
            ],
            "defenders": [
              "Aziz Behich",
              "Milos Degenek",
              "Matthew Jurman",
              "James Meredith",
              "Josh Risdon",
              "Trent Sainsbury",
              "Fran Karacic"
            ],
            "forwards": [
              "Tim Cahill",
              "Tomi Juric",
              "Mathew Leckie",
              "Andrew Nabbout",
              "Nikita Rukavytsya",
              "Dimitri Petratos",
              "Jamie Maclaren",
              "Daniel Arzani"
            ],
            "goalkeepers": [
              "Mat Ryan",
              "Danny Vukovic",
              "Brad Jones"
            ],
            "midfielders": [
              "Josh Brillante",
              "Mile Jedinak",
              "Mark Milligan",
              "Robbie Kruse",
              "Jackson Irvine",
              "Massimo Luongo",
              "Aaron Mooy",
              "Tom Rogic",
              "James Troisi"
            ]
          },
          "Belgium": {
            "coach": [
              "Roberto Martínez"
            ],
            "defenders": [
              "Toby Alderweireld",
              "Dedryck Boyata",
              "Laurent Ciman",
              "Christian Kabasele",
              "Vincent Kompany",
              "Jordan Lukaku",
              "Thomas Meunier",
              "Thomas Vermaelen",
              "Jan Vertonghen"
            ],
            "forwards": [
              "Michy Batshuayi",
              "Christian Benteke",
              "Yannick Carrasco",
              "Eden Hazard",
              "Thorgan Hazard",
              "Adnan Januzaj",
              "Romelu Lukaku",
              "Dries Mertens"
            ],
            "goalkeepers": [
              "Koen Casteels",
              "Thibaut Courtois",
              "Simon Mignolet",
              "Matz Sels"
            ],
            "midfielders": [
              "Nacer Chadli",
              "Kevin De Bruyne",
              "Mousa Dembele",
              "Leander Dendoncker",
              "Marouane Fellaini",
              "Youri Tielemans",
              "Axel Witsel"
            ]
          },
          "Brazil": {
            "coach": [
              "Adenor Leonardo Bacchi"
            ],
            "defenders": [
              "Danilo",
              "Fagner",
              "Marcelo",
              "Filipe Luis",
              "Thiago Silva",
              "Marquinhos",
              "Miranda",
              "Pedro Geromel"
            ],
            "forwards": [
              "Neymar",
              "Taison",
              "Gabriel Jesus",
              "Roberto Firmino"
            ],
            "goalkeepers": [
              "Alisson",
              "Ederson",
              "Cassio"
            ],
            "midfielders": [
              "Casemiro",
              "Fernandinho",
              "Paulinho",
              "Fred",
              "Renato Augusto",
              "Philippe Coutinho",
              "Willian",
              "Douglas Costa"
            ]
          },
          "Columbia": {
            "coach": [
              "José Pékerman"
            ],
            "defenders": [
              "Cristian Zapata",
              "Davinson Sanchez",
              "Santiago Arias",
              "Oscar Murillo",
              "Frank Fabra",
              "Johan Mojica",
              "Yerry Mina",
              "William Tesillo",
              "Bernardo Espinosa",
              "Stefan Medina",
              "Farid Diaz"
            ],
            "forwards": [
              "Radamel Falcao",
              "Duvan Zapata",
              "Miguel Borja",
              "Carlos Bacca",
              "Luis Fernando Muriel",
              "Teofilo Gutierrez"
            ],
            "goalkeepers": [
              "David Ospina",
              "Camilo Vargas",
              "Ivan Arboleda",
              "Jose Fernando Cuadrado"
            ],
            "midfielders": [
              "Wilmar Barrios",
              "Carlos Sanchez",
              "Jefferson Lerma",
              "Jose Izquierdo",
              "James Rodriguez",
              "Giovanni Moreno",
              "Abel Aguilar",
              "Mateus Uribe",
              "Yimmi Chara",
              "Juan Fernando Quintero",
              "Edwin Cardona",
              "Juan Cuadrado",
              "Gustavo Cuellar",
              "Sebastian Pérez"
            ]
          },
          "Costa_Rica": {
            "coach": [
              "Óscar Ramírez"
            ],
            "defenders": [
              "Cristian Gamboa",
              "Ian Smith",
              "Ronald Matarrita",
              "Bryan Oviedo",
              "Oscar Duarte",
              "Giancarlo Gonzalez",
              "Francisco Calvo",
              "Kendall Waston",
              "Johnny Acosta"
            ],
            "forwards": [
              "Johan Venegas",
              "Joel Campbell",
              "Marco Urena"
            ],
            "goalkeepers": [
              "Keylor Navas",
              "Patrick Pemberton",
              "Leonel Moreira"
            ],
            "midfielders": [
              "David Guzman",
              "Yeltsin Tejeda",
              "Celso Borges",
              "Randall Azofeifa",
              "Rodney Wallace",
              "Bryan Ruiz",
              "Daniel Colindres",
              "Christian Bolanos"
            ]
          },
          "Croatia": {
            "coach": [
              "Zlatko Dalić"
            ],
            "defenders": [
              "Vedran Corluka",
              "Domagoj Vida",
              "Ivan Strinic",
              "Dejan Lovren",
              "Sime Vrsaljko",
              "Josip Pivaric",
              "Tin Jedvaj",
              "Matej Mitrovic",
              "Duje Caleta-Car"
            ],
            "forwards": [
              "Mario Mandzukic",
              "Ivan Perisic",
              "Nikola Kalinic",
              "Andrej Kramaric",
              "Marko Pjaca",
              "Ante Rebic"
            ],
            "goalkeepers": [
              "Danijel Subasic",
              "Lovre Kalinic",
              "Dominik Livakovic"
            ],
            "midfielders": [
              "Luka Modric",
              "Ivan Rakitic",
              "Mateo Kovacic",
              "Milan Badelj",
              "Marcelo Brozovic",
              "Filip Bradaric"
            ]
          },
          "Denmark": {
            "coach": [
              "Åge Hareide"
            ],
            "defenders": [
              "Simon Kjaer",
              "Andreas Christensen",
              "Mathias Jorgensen",
              "Jannik Vestergaard",
              "Andreas Bjelland",
              "Henrik Dalsgaard",
              "Peter Ankersen",
              "Jens Stryger Larsen",
              "Riza Durmisi",
              "Jonas Knudsen",
              "Nicolai Boilesen"
            ],
            "forwards": [
              "Pione Sisto",
              "Martin Braithwaite",
              "Andreas Cornelius",
              "Viktor Fischer",
              "Yussuf Poulsen",
              "Nicolai Jorgensen",
              "Nicklas Bendtner",
              "Kasper Dolberg",
              "Kenneth Zohore"
            ],
            "goalkeepers": [
              "Kasper Schmeichel",
              "Jonas Lossl",
              "Frederik Ronow",
              "Jesper Hansen"
            ],
            "midfielders": [
              "William Kvist",
              "Thomas Delaney",
              "Lukas Lerager",
              "Lasse Schone",
              "Mike Jensen",
              "Christian Eriksen",
              "Daniel Wass",
              "Pierre-Emile Hojbjerg",
              "Mathias Jensen",
              "Michael Krohn-Dehli",
              "Robert Skov"
            ]
          },
          "Egypt": {
            "coach": [
              "Héctor Cúper"
            ],
            "defenders": [
              "Ahmed Fathi",
              "Saad Samir",
              "Ayman Ashraf",
              "Mahmoud Hamdy 'El Wensh'",
              "Mohamed Abdel Shafy",
              "Ahmed Hegazi",
              "Ali Gabr",
              "Ahmed El Mohamady",
              "Karim Hafez",
              "Omar Gaber",
              "Amro Tarek"
            ],
            "forwards": [
              "Marwan Mohsen",
              "Ahmed Gomaa",
              "Ahmed Hassan 'Koka'",
              "Mohamed Salah"
            ],
            "goalkeepers": [
              "Essam El-Hadary",
              "Mohamed El-Shennawy",
              "Sherif Ekramy",
              "Mohamed Awad"
            ],
            "midfielders": [
              "Tarek Hamed",
              "Mahmoud Abdel Aziz",
              "Shikabala",
              "Abdallah El-Said",
              "Sam Morsy",
              "Mohamed ElNeny",
              "Mahmoud 'Kahraba'",
              "Ramadan Sobhi",
              "Mahmoud 'Trezeguet'",
              "Amr Warda"
            ]
          },
          "England": {
            "coach": [
              "Gareth Southgate"
            ],
            "defenders": [
              "Trent Alexander-Arnold",
              "Gary Cahill",
              "Phil Jones",
              "Harry Maguire",
              "Danny Rose",
              "John Stones",
              "Kieran Trippier",
              "Kyle Walker"
            ],
            "forwards": [
              "Harry Kane",
              "Marcus Rashford",
              "Raheem Sterling",
              "Jamie Vardy",
              "Danny Welbeck"
            ],
            "goalkeepers": [
              "Jack Butland",
              "Jordan Pickford",
              "Nick Pope"
            ],
            "midfielders": [
              "Dele Alli",
              "Fabian Delph",
              "Eric Dier",
              "Jordan Henderson",
              "Jesse Lingard",
              "Ruben Loftus-Cheek",
              "Ashley Young"
            ]
          },
          "France": {
            "coach": [
              "Didier Deschamps"
            ],
            "defenders": [
              "Raphael Varane",
              "Samuel Umtiti",
              "Presnel Kimpembe",
              "Djibril Sidibe",
              "Benjamin Mendy",
              "Lucas Hernandez",
              "Benjamin Pavard",
              "Adil Rami"
            ],
            "forwards": [
              "Antoine Griezmann",
              "Kylian Mbappe",
              "Olivier Giroud",
              "Ousmane Dembele",
              "Florian Thauvin",
              "Nabil Fekir"
            ],
            "goalkeepers": [
              "Hugo Lloris",
              "Alphonse Areola",
              "Steve Mandanda"
            ],
            "midfielders": [
              "N’Golo Kante",
              "Paul Pogba",
              "Thomas Lemar",
              "Blaise Matuidi",
              "Corentin Tolisso",
              "Steven N’Zonzi"
            ]
          },
          "Germany": {
            "coach": [
              "Joachim Löw"
            ],
            "defenders": [
              "Jerome Boateng",
              "Matthias Ginter",
              "Jonas Hector",
              "Mats Hummels",
              "Joshua Kimmich",
              "Marvin Plattenhardt",
              "Antonio Rudiger",
              "Niklas Sule",
              "Jonathan Tah"
            ],
            "forwards": [
              "Julian Brandt",
              "Mario Gomez",
              "Thomas Muller",
              "Nils Petersen",
              "Leroy Sane",
              "Timo Werner"
            ],
            "goalkeepers": [
              "Bernd Leno",
              "Manuel Neuer",
              "Marc-Andre ter Stegen",
              "Kevin Trapp"
            ],
            "midfielders": [
              "Julian Draxler",
              "Leon Goretzka",
              "Ilkay Gundogan",
              "Sami Khedira",
              "Toni Kroos",
              "Mesut Ozil",
              "Marco Reus",
              "Sebastian Rudy"
            ]
          },
          "Iceland": {
            "coach": [
              "Heimir Hallgrímsson"
            ],
            "defenders": [
              "Birkir Mar Saevarsson",
              "Ragnar Sigurdsson",
              "Kari Arnason",
              "Ari Freyr Skulason",
              "Sverrir Ingi Ingason",
              "Hordur Bjorgvin Magnusson",
              "Samuel Kari Fridridsson",
              "Holmar Orn Eyjolfsson"
            ],
            "forwards": [
              "Alfred Finnbogason",
              "Jon Dadi Bodvarsson",
              "Bjorn Bergmann Sigurdarson",
              "Albert Gudmundsson"
            ],
            "goalkeepers": [
              "Hannes Thor Halldorsson",
              " Runar Alex Runarsson",
              "Frederik Schram"
            ],
            "midfielders": [
              "Aaron Einar Gunnarsson",
              "Gylfi Sigurdsson",
              "Emil Hallfredsson",
              "Birkir Bjarnason",
              "Johann Berg Gudmundsson",
              "Olafur Ingi Skulason",
              "Arnor Ingvi Traustason",
              "Rurik Gislason"
            ]
          },
          "Iran": {
            "coach": [
              "Carlos Queiroz"
            ],
            "defenders": [
              "Ramin Rezaeian",
              "Mohammad Reza Khanzadeh",
              "Morteza Pouraliganji",
              "Mohammad Ansari",
              "Pejman Montazeri",
              "Seyed Majid Hosseini",
              "Milad Mohammadi",
              "Roozbeh Cheshmi"
            ],
            "forwards": [
              "Alireza Jahanbakhsh",
              "Karim Ansarifard",
              "Saman Ghoddos",
              "Mahdi Taremi",
              "Sardar Azmoun",
              "Reza Ghoochannejhad"
            ],
            "goalkeepers": [
              "Alireza Beiranvand",
              "Rashid Mazaheri",
              "Amir Abedzadeh"
            ],
            "midfielders": [
              "Saeid Ezatolahi",
              "Masoud Shojaei",
              "Mahdi Torabi",
              "Ashkan Dejagah",
              "Omid Ebrahimi",
              "Ehsan Hajsafi",
              "Ali Gholizadeh",
              "Vahid Amiri"
            ]
          },
          "Japan": {
            "coach": [
              "Akira Nishino"
            ],
            "defenders": [
              "Yuto Nagatomo",
              "Tomoaki Makino",
              "Wataru Endo",
              "Maya Yoshida",
              "Hiroki Sakai",
              "Gotoku Sakai",
              "Gen Shoji",
              "Naomichi Ueda"
            ],
            "forwards": [
              "Shinji Okazaki",
              "Yuya Osako",
              "Yoshinori Muto",
              "Takuma Asano"
            ],
            "goalkeepers": [
              "Eiji Kawashima",
              "Masaaki Higashiguchi",
              "Kosuke Nakamura"
            ],
            "midfielders": [
              "Makoto Hasebe",
              "Toshihiro Aoyama",
              "Keisuke Honda",
              "Takashi Inui",
              "Shinji Kagawa",
              "Hotaru Yamaguchi",
              "Genki Haraguchi",
              "Takashi Usami",
              "Gaku Shibasaki",
              "Ryota Oshima",
              "Kento Misao",
              "Yosuke Ideguchi"
            ]
          },
          "Mexico": {
            "coach": [
              "Juan Carlos Osorio"
            ],
            "defenders": [
              "Carlos Salcedo",
              "Diego Reyes",
              "Hector Moreno",
              "Hugo Ayala",
              "Oswaldo Alanis",
              "Edson Alvarez",
              "Jesus Gallardo",
              "Miguel Layun"
            ],
            "forwards": [
              "Javier 'Chicharito' Hernandez",
              "Raul Jimenez",
              "Oribe Peralta",
              "Jesus 'Tecatito' Corona",
              "Carlos Vela",
              "Javier Aquino",
              "Hirving Lozano",
              "Jurgen Damm"
            ],
            "goalkeepers": [
              "Guillermo Ochoa",
              "Alfredo Talavera",
              "Jesus Corona"
            ],
            "midfielders": [
              "Jesus Molina",
              "Rafa Marquez",
              "Hector Herrera",
              "Jonathan dos Santos",
              "Andres Guardado",
              "Erick Gutierrez",
              "Marco Fabian",
              "Giovani Dos Santos"
            ]
          },
          "Morocco": {
            "coach": [
              "Hervé Renard"
            ],
            "defenders": [
              "Medhi Benatia",
              "Romain Saiss",
              "Manuel Da Costa",
              "Badr Benoun",
              "Nabil Dirar",
              "Achraf Hakimi",
              "Hamza Mendyl"
            ],
            "forwards": [
              "Khalid Boutaib",
              "Aziz Bouhaddouz",
              "Ayoub El Kaabi",
              "Nordin Amrabat",
              "Mehdi Carcela"
            ],
            "goalkeepers": [
              "Mounir El Kajoui",
              "Yassine Bounou",
              "Ahmad Reda Tagnaouti"
            ],
            "midfielders": [
              "Mbark Boussoufa",
              "Karim El Ahmadi",
              "Youssef Ait Bennasser",
              "Sofyan Amrabat",
              "Younes Belhanda",
              "Faycal Fajr",
              "Amine Harit",
              "Hakim Ziyech"
            ]
          },
          "Nigeria": {
            "coach": [
              "Gernot Rohr"
            ],
            "defenders": [
              "William Troost-Ekong",
              "Leon Balogun",
              "Ola Aina",
              "Kenneth Omeruo",
              "Brian Idowu",
              "Chidozie Awaziem",
              "Abdullahi Shehu",
              "Elderson Echiejile",
              "Tyronne Ebuehi",
              "Stephen Eze"
            ],
            "forwards": [
              "Odion Ighalo",
              "Ahmed Musa",
              "Victor Moses",
              "Alex Iwobi",
              "Kelechi Iheanacho",
              "Moses Simon",
              "Junior Lokosa",
              "Simeon Nwankwo"
            ],
            "goalkeepers": [
              "Ikechukwu Ezenwa",
              "Daniel Akpeyi",
              "Francis Uzoho",
              "Dele Ajiboye"
            ],
            "midfielders": [
              "John Obi Mikel",
              "Ogenyi Onazi",
              "John Ogu",
              "Wilfred Ndidi",
              "Uche Agbo",
              "Oghenekaro Etebo",
              "Joel Obi",
              "Mikel Agu"
            ]
          },
          "Panama": {
            "coach": [
              "Hernán Darío Gómez"
            ],
            "defenders": [
              "Felipe Baloy",
              "Harold Cummings",
              "Eric Davis",
              "Fidel Escobar",
              "Adolfo Machado",
              "Michael Murillo",
              "Luis Ovalle",
              "Roman Torres"
            ],
            "forwards": [
              "Abdiel Arroyo",
              "Ismael Diaz",
              "Blas Perez",
              "Luis Tejada",
              "Gabriel Torres"
            ],
            "goalkeepers": [
              "Jose Calderon",
              "Jaime Penedo",
              "Alex Rodriguez"
            ],
            "midfielders": [
              "Edgar Barcenas",
              "Armando Cooper",
              "Anibal Godoy",
              "Gabriel Gómez",
              "Valentin Pimentel",
              "Alberto Quintero",
              "Jose Luis Rodriguez"
            ]
          },
          "Peru": {
            "coach": [
              "Ricardo Gareca"
            ],
            "defenders": [
              "Luis Abram",
              "Luis Advincula",
              "Miguel Araujo",
              "Aldo Corzo",
              "Nilson Loyola",
              "Christian Ramos",
              "Alberto Rodriguez",
              "Anderson Santamaría",
              "Miguel Trauco"
            ],
            "forwards": [
              "Paolo Guerrero",
              "Andre Carrillo",
              "Raul Ruidiaz",
              "Jefferson Farfan"
            ],
            "goalkeepers": [
              "Pedro Gallese",
              "Jose Carvallo",
              "Carlos Caceda"
            ],
            "midfielders": [
              "Pedro Aquino",
              "Wilmer Cartagena",
              "Christian Cueva",
              "Edison Flores",
              "Paolo Hurtado",
              "Sergio Pena",
              "Andy Polo",
              "Renato Tapia",
              "Yoshimar Yotun"
            ]
          },
          "Poland": {
            "coach": [
              "Adam Nawałka"
            ],
            "defenders": [
              "Jan Bednarek",
              "Bartosz Bereszynski",
              "Thiago Cionek",
              "Kamil Glik",
              "Artur Jedrzejczyk",
              "Marcin Kaminski",
              "Tomasz Kedziora",
              "Michal Pazdan",
              "Lukasz Piszczek"
            ],
            "forwards": [
              "Dawid Kownacki",
              "Robert Lewandowski",
              "Arkadiusz Milik",
              "Krzysztof Piatek",
              "Lukasz Teodorczyk",
              "Kamil Wilczek"
            ],
            "goalkeepers": [
              "Bartosz Bialkowski",
              "Lukasz Fabianski",
              "Lukasz Skorupski",
              "Wojciech Szczesny"
            ],
            "midfielders": [
              "Jakub Blaszczykowski",
              "Pawel Dawidowicz",
              "Przemyslaw Frankowski",
              "Jacek Goralski",
              "Kamil Grosicki",
              "Damian Kadzior",
              "Grzegorz Krychowiak",
              "Rafal Kurzawa",
              "Karol Linetty",
              "Maciej Makuszewski",
              "Krzysztof Maczynski",
              "Slawomir Peszko",
              "Maciej Rybus",
              "Sebastian Szymanski",
              "Piotr Zielinski",
              "Szymon Zurkowski"
            ]
          },
          "Portugal": {
            "coach": [
              "Fernando Santos"
            ],
            "defenders": [
              "Bruno Alves",
              "Cedric Soares",
              "Jose Fonte",
              "Mario Rui",
              "Pepe",
              "Raphael Guerreiro",
              "Ricardo Pereira",
              "Ruben Dias"
            ],
            "forwards": [
              "Andre Silva",
              "Bernardo Silva",
              "Cristiano Ronaldo",
              "Gelson Martins",
              "Goncalo Guedes",
              "Ricardo Quaresma"
            ],
            "goalkeepers": [
              "Anthony Lopes",
              "Beto",
              "Rui Patricio"
            ],
            "midfielders": [
              "Adrien Silva",
              "Bruno Fernandes",
              "Joao Mario",
              "Joao Moutinho",
              "Manuel Fernandes",
              "William Carvalho"
            ]
          },
          "Russia": {
            "coach": [
              "Stanislav Cherchesov"
            ],
            "defenders": [
              "Vladimir Granat",
              "Fyodor Kudryashov",
              "Ilya Kutepov",
              "Roman Neustadter",
              "Konstantin Rausch",
              "Andrei Semyonov",
              "Igor Smolnikov",
              "Mario Fernandes",
              "Sergei Ignashevich"
            ],
            "forwards": [
              "Artem Dzyuba",
              "Alexei Miranchuk",
              "Fyodor Smolov",
              "Fyodor Chalov"
            ],
            "goalkeepers": [
              "Igor Akinfeev",
              "Vladimir Gabulov",
              "Soslan Dzhanaev",
              "Andrei Lunev"
            ],
            "midfielders": [
              "Yury Gazinsky",
              "Alan Dzagoev",
              "Alexander Golovin",
              "Alexander Erokhin",
              "Yury Zhirkov",
              "Daler Kuzyaev",
              "Roman Zobnin",
              "Alexander Samedov",
              "Anton Miranchuk",
              "Alexander Tashyev",
              "Denis Cheryshev"
            ]
          },
          "Saudi_Arabia": {
            "coach": [
              "Juan Antonio Pizzi"
            ],
            "defenders": [
              "Mansoor Al-Harbi",
              "Yasser Al-Shahrani",
              "Mohammed Al-Breik",
              "Saeed Al-Mowalad",
              "Motaz Hawsawi",
              "Osama Hawsawi",
              "Omar Hawsawi",
              "Mohammed Jahfali",
              "Ali Al-Bulaihi"
            ],
            "forwards": [
              "Fahad Al-Muwallad",
              "Mohammad Al-Sahlawi",
              "Muhannad Assiri"
            ],
            "goalkeepers": [
              "Assaf Al-Qarny",
              "Mohammed Al-Owais",
              "Yasser Al-Musailem",
              "Abdullah Al-Mayuf"
            ],
            "midfielders": [
              "Abdullah Al-Khaibari",
              "Abdulmalek Al-Khaibri",
              "Abdullah Otayf",
              "Taiseer Al-Jassim",
              "Houssain Al-Mogahwi",
              "Salman Al-Faraj",
              "Nawaf Al-Abed",
              "Mohamed Kanno",
              "Hattan Bahebri",
              "Mohammed Al-Kwikbi",
              "Salem Al-Dawsari",
              "Yehya Al-Shehri"
            ]
          },
          "Senegal": {
            "coach": [
              "Aliou Cissé"
            ],
            "defenders": [
              "Lamine Gassama",
              "Saliou Ciss",
              "Kalidou Koulibaly",
              "Kara Mbodii",
              "Youssouf Sabaly",
              "Salif Sane",
              "Moussa Wague"
            ],
            "forwards": [
              "Keita Balde",
              "Mame Biram Diouf",
              "Moussa Konate",
              "Sadio Mane",
              "Mbaye Niang",
              "Diafra Sakho",
              "Moussa Sow"
            ],
            "goalkeepers": [
              "Abdoulaye Diallo",
              "Alfred Gomis",
              "Khadim Ndiaye"
            ],
            "midfielders": [
              "Idrissa Gueye",
              "Cheikhou Kouyate",
              "Alfred Ndiaye",
              "Badou Ndiaye",
              "Cheikh Ndoye",
              "Ismaila Sarr"
            ]
          },
          "Serbia": {
            "coach": [
              "Mladen Krstajić"
            ],
            "defenders": [
              "Branislav Ivanovic",
              "Aleksandar Kolarov",
              "Antonio Rukavina",
              "Matija Nastasic",
              "Dusko Tosic",
              "Uros Spajic",
              "Milos Veljkovic",
              "Nikola Milenkovic",
              "Milan Rodic"
            ],
            "forwards": [
              "Aleksandar Mitrovic",
              "Aleksandar Prijovic",
              "Luka Jovic"
            ],
            "goalkeepers": [
              "Vladimir Stojkovic",
              "Predrag Rajkovic",
              "Marko Dmitrovic",
              "Aleksandar Jovanovic"
            ],
            "midfielders": [
              "Dusan Tadic",
              "Nemanja Matic",
              "Adem Ljajic",
              "Luka Milivojevic",
              "Filip Kostic",
              "Andrija Zivkovic",
              "Mijat Gacinovic",
              "Marko Grujic",
              "Nemanja Maksimovic",
              "Sergej Milinkovic-Savic",
              "Nemanja Radonjic"
            ]
          },
          "South Korea": {
            "coach": [
              "Shin Tae-yong"
            ],
            "defenders": [
              "Kim Young-gwon",
              "Jang Hyun-soo",
              "Jung Seung-hyun",
              "Yun Yong-sun",
              "Kwon Kyung-won",
              "Oh Ban-suk",
              "Kim Jin-su",
              "Kim Min-woo",
              "Park Joo-ho",
              "Hong Chul",
              "Go Yo-han",
              "Lee Yong"
            ],
            "forwards": [
              "Kim Shin-wook",
              "Son Heung-min",
              "Hwang Hee-chan",
              "Lee Keun-ho"
            ],
            "goalkeepers": [
              "Kim Seung-gyu",
              "Kim Jin-hyeon",
              "Cho Hyun-woo"
            ],
            "midfielders": [
              "Ki Sung-yueng",
              "Jung Woo-young",
              "Ju Se-jong",
              "Koo Ja-cheol",
              "Lee Jae-sung",
              "Lee Seung-woo",
              "Moon Seon-min",
              "Lee Chung-yong"
            ]
          },
          "Spain": {
            "coach": [
              "Fernando Hierro"
            ],
            "defenders": [
              "Jordi Alba",
              "Cesar Azpiliqueta",
              "Dani Carvajal",
              "Nacho Fernandez",
              "Nacho Monreal",
              "Alvaro Odriozola",
              "Gerard Pique",
              "Sergio Ramos"
            ],
            "forwards": [
              "Marco Asensio",
              "Iago Aspas",
              "Diego Costa",
              "Rodrigo Moreno",
              "Lucas Vazquez"
            ],
            "goalkeepers": [
              "Kepa Arrizabalaga",
              "David de Gea",
              "Pepe Reina"
            ],
            "midfielders": [
              "Thiago Alcantara",
              "Sergio Busquets",
              "Andres Iniesta",
              "Isco",
              "Koke",
              "Saul Niguez",
              "David Silva"
            ]
          },
          "Sweden": {
            "coach": [
              "Janne Andersson"
            ],
            "defenders": [
              "Mikael Lustig",
              "Victor Lindelof",
              "Andreas Granqvist",
              "Martin Olsson",
              "Ludwig Augustinsson",
              "Filip Helander",
              "Pontus Jansson",
              "Emil Krafth"
            ],
            "forwards": [
              "Marcus Berg",
              "Ola Toivonen",
              "John Guidetti",
              "Isaac Kiese-Thelin"
            ],
            "goalkeepers": [
              "Robin Olsen",
              "Karl-Johan Johnsson",
              "Kristoffer Nordfeldt"
            ],
            "midfielders": [
              "Emil Forsberg",
              "Albin Ekdal",
              "Viktor Claesson",
              "Gustav Svensson",
              "Sebastian Larsson",
              "Jimmy Durmaz",
              "Oscar Hiljemark",
              "Marcus Rohden"
            ]
          },
          "Switzerland": {
            "coach": [
              "Vladimir Petković"
            ],
            "defenders": [
              "Stephan Lichtsteiner",
              "Johan Djourou",
              "Ricardo Rodríguez",
              "Fabian Schär",
              "Michael Lang",
              "François Moubandje",
              "Silvan Widmer",
              "Manuel Akanji",
              "\tNico Elvedi"
            ],
            "forwards": [
              "Haris Seferović",
              "Josip Drmić",
              "Breel Embolo",
              "Mario Gavranović"
            ],
            "goalkeepers": [
              "Yann Sommer",
              "Roman Bürki",
              "Gregor Kobel",
              "Yvon Mvogo"
            ],
            "midfielders": [
              "Valon Behrami",
              "Xherdan Shaqiri",
              "Gelson Fernandes",
              "Blerim Džemaili",
              "Granit Xhaka",
              "Steven Zuber",
              "Remo Freuler",
              "Denis Zakaria",
              "Edimilson Fernandes"
            ]
          },
          "Tunisia": {
            "coach": [
              "Nabil Maâloul"
            ],
            "defenders": [
              "Rami Bedoui",
              "Yohan Benalouane",
              "Syam Ben Youssef",
              "Dylan Bronn",
              "Khalil Chammam",
              "Oussama Haddadi",
              "Ali Maaloul",
              "Yassine Meriah",
              "Hamdi Nagguez",
              "Bilel Mohsni"
            ],
            "forwards": [
              "Anice Badri",
              "Fakhreddine Ben Youssef",
              "Naim Sliti",
              "Bassem Srarfi",
              "Ahmed Akaichi",
              "Wahbi Khazri",
              "Saber Khalifa"
            ],
            "goalkeepers": [
              "Aymen Mathlouthi",
              "Moez Ben Cherifia",
              "Farouk Ben Mustapha",
              "Moez Hassen"
            ],
            "midfielders": [
              "Mohamed Amine Ben Amor",
              "Sai-Eddine Khaoui",
              "Ahmed Khalil",
              "Ellyes Skhiri",
              "Ferjani Sassi",
              "Ghaylene Chaalali",
              "Mohamed Wael Larbi",
              "Karim Laribi"
            ]
          },
          "Uruguay": {
            "coach": [
              "Óscar Tabárez"
            ],
            "defenders": [
              "Diego Godin",
              "Sebastian Coates",
              "Jose Maria Gimenez",
              "Maximiliano Pereira",
              "Gaston Silva",
              "Martin Caceres",
              "Guillermo Varela"
            ],
            "forwards": [
              "Cristhian Stuani",
              "Maxi Gomez",
              "Edinson Cavani",
              "Luis Suarez"
            ],
            "goalkeepers": [
              "Fernando Muslera",
              "Martin Silva",
              "Martin Campana"
            ],
            "midfielders": [
              "Nahitan Nandez",
              "Lucas Torreira",
              "Matias Vecino",
              "Federico Valverde",
              "Rodrigo Bentancur",
              "Carlos Sanchez",
              "Giorgian De Arrascaeta",
              "Diego Laxalt",
              "Cristian Rodriguez",
              "Jonathan Urretaviscaya",
              "Nicolas Lodeiro",
              "Gaston Ramirez"
            ]
          }
        },
        "stadiums": [
          "Ekaterinburg Arena",
          "Kaliningrad Stadium",
          "Kasan Arena",
          "Spartak Stadium",
          "Nizhny Novgorod Stadium",
          "Luzhniki Stadium",
          "Rostov Arena",
          "Saint Petersburg Stadium",
          "Samara Arena",
          "Mordovia Arena",
          "Fisht Stadium",
          "Volgograd Arena"
        ],
        "teams": [
          "Egypt",
          "Russia",
          "Saudi Arabia",
          "Uruguay",
          "Iran",
          "Morocco",
          "Portugal",
          "Spain",
          "Australia",
          "Denmark",
          "France",
          "Peru",
          "Argentina",
          "Croatia",
          "Iceland",
          "Nigeria",
          "Brazil",
          "Costa Rica",
          "Serbia",
          "Switzerland",
          "Germany",
          "Mexico",
          "South Korea",
          "Sweden",
          "Belgium",
          "England",
          "Panama",
          "Tunisia",
          "Columbia",
          "Japan",
          "Poland",
          "Senegal"
        ]
      },
      "yoda": {
        "quotes": [
          "Use your feelings, Obi-Wan, and find him you will.",
          "Already know you that which you need.",
          "Adventure. Excitement. A Jedi craves not these things.",
          "At an end your rule is, and not short enough it was!",
          "Around the survivors a perimeter create.",
          "Soon will I rest, yes, forever sleep. Earned it I have. Twilight is upon me, soon night must fall.",
          "Not if anything to say about it I have",
          "Through the Force, things you will see. Other places. The future - the past. Old friends long gone.",
          "Ow, ow, OW! On my ear you are!",
          "The dark side clouds everything. Impossible to see the future is.",
          "Size matters not. Look at me. Judge me by my size, do you? Hmm? Hmm. And well you should not. For my ally is the Force, and a powerful ally it is. Life creates it, makes it grow. Its energy surrounds us and binds us. Luminous beings are we, not this crude matter. You must feel the Force around you; here, between you, me, the tree, the rock, everywhere, yes. Even between the land and the ship.",
          "Younglings, younglings gather ’round.",
          "Luminous beings are we - not this crude matter.",
          "Clear your mind must be, if you are to find the villains behind this plot.",
          "Always two there are, no more, no less. A master and an apprentice.",
          "Do. Or do not. There is no try.",
          "Much to learn you still have my old padawan. ... This is just the beginning!",
          "Good relations with the Wookiees, I have.",
          "Ready are you? What know you of ready? For eight hundred years have I trained Jedi. My own counsel will I keep on who is to be trained. A Jedi must have the deepest commitment, the most serious mind. This one a long time have I watched. All his life has he looked away - to the future, to the horizon. Never his mind on where he was. Hmm? What he was doing. Hmph. Adventure. Heh. Excitement. Heh. A Jedi craves not these things. You are reckless.",
          "Truly wonderful, the mind of a child is.",
          "Always pass on what you have learned.",
          "Once you start down the dark path, forever will it dominate your destiny, consume you it will.",
          "Mudhole? Slimy? My home this is!",
          "Yes, a Jedi’s strength flows from the Force. But beware of the dark side. Anger, fear, aggression; the dark side of the Force are they. Easily they flow, quick to join you in a fight. If once you start down the dark path, forever will it dominate your destiny, consume you it will, as it did Obi-Wan’s apprentice.",
          "Do not assume anything Obi-Wan. Clear your mind must be if you are to discover the real villains behind this plot.",
          "Death is a natural part of life. Rejoice for those around you who transform into the Force. Mourn them do not. Miss them do not. Attachment leads to jealously. The shadow of greed, that is.",
          "Like fire across the galaxy the Clone Wars spread. In league with the wicked Count Dooku, more and more planets slip. Against this threat, upon the Jedi Knights falls the duty to lead the newly formed army of the Republic. And as the heat of war grows, so, to, grows the prowess of one most gifted student of the Force.",
          "Hmm. In the end, cowards are those who follow the dark side.",
          "Strong is Vader. Mind what you have learned. Save you it can.",
          "Pain, suffering, death I feel. Something terrible has happened. Young Skywalker is in pain. Terrible pain",
          "Difficult to see. Always in motion is the future...",
          "You will find only what you bring in.",
          "Feel the force!",
          "Reckless he is. Matters are worse.",
          "That is why you fail.",
          "Your weapons, you will not need them.",
          "To answer power with power, the Jedi way this is not. In this war, a danger there is, of losing who we are."
        ]
      }
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "gdpr": {
      "controllers": {
        "accept_cookies_error": "Something went wrong",
        "create_error": "You need to accept all the consents"
      },
      "views": {
        "cookies_disclaimer": {
          "accept": "Accept",
          "learn_more": "Learn More",
          "text": "Meerkeep only uses the cookies it needs to work: to keep you signed in and remember your language. No analytics or advertising cookies.\n"
        },
        "missing": {
          "accept_html": "I accept the %{consent}",
          "intro": "Before proceeding, you must accept the following consents",
          "submit": "Accept Selected",
          "title": "Consents To Be Accepted"
        }
      }
    },
    "group_invitation_mailer": {
      "invite": {
        "body": "%{name} invited you to join the group %{group} on Meerkeep, so you can share reminders.",
        "hello": "Hello,",
        "ignore": "If you were not expecting this, you can ignore this email.",
        "join": "Join the group",
        "subject": "%{name} invited you to %{group} on Meerkeep"
      }
    },
    "hello": "hello",
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      },
      "yes_no": {
        "no": "No",
        "yes": "Yes"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "landing": {
      "index": {
        "coming_soon": "Coming soon",
        "headline": "One account. Three tools for getting things done together.",
        "open_tool": "Open %{tool}",
        "signed_in_as": "Signed in as %{name}",
        "subline": "Pick a tool to get started. The same login works everywhere.",
        "title": "Home"
      }
    },
    "layouts": {
      "app": {
        "close_menu": "Close menu",
        "open_menu": "Open menu",
        "settings": "Settings",
        "skip_to_content": "Skip to content",
        "tool_launcher": {
          "account": "Account",
          "open": "Switch tool",
          "title": "Meerkeep tools"
        },
        "your_account": "Your account"
      },
      "auth": {
        "headline": "One account. Three tools for getting things done together.",
        "made_in": "Made in Coimbra."
      }
    },
    "middleware": {
      "apple_form_post_callback": {
        "continue": "Continue"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "oauth": {
      "authorizations": {
        "new": {
          "able_to": "It will be able to:",
          "prompt_html": "%{client_name} is asking for access to your Meerkeep account.",
          "signed_in_as_html": "You are signed in as %{name} (%{email}).",
          "title": "Connect to Meerkeep"
        }
      },
      "registrations": {
        "unnamed_client": "Unnamed client"
      }
    },
    "push": {
      "due": {
        "body": "Due at %{time}"
      },
      "nudge": {
        "title": "%{name} nudged you"
      }
    },
    "reminders": {
      "group_invitations": {
        "create": {
          "success": "Invitation sent to %{email}."
        },
        "destroy": {
          "success": "Invitation revoked."
        },
        "resend": {
          "success": "Invitation sent again to %{email}."
        }
      },
      "groups": {
        "create": {
          "success": "Group created."
        },
        "destroy": {
          "success": "Group deleted."
        },
        "index": {
          "empty_body": "Make a group for the people you share things with.",
          "empty_title": "No groups yet",
          "groups_count": {
            "one": "1 group",
            "other": "%{count} groups"
          },
          "new": "New group",
          "open_reminders": {
            "one": "1 open reminder",
            "other": "%{count} open reminders",
            "zero": "nothing open"
          },
          "people": {
            "one": "1 person",
            "other": "%{count} people"
          },
          "select_one": "Pick a group to see its members.",
          "summary": {
            "one": "%{groups} · 1 person",
            "other": "%{groups} · %{count} people"
          },
          "title": "Groups",
          "you_are_admin": "you are an admin",
          "your_groups": "Your groups"
        },
        "leave": {
          "success": "You left the group."
        },
        "panel": {
          "anyone_can_add": "Anyone can add reminders",
          "anyone_can_add_hint": "Off means only admins can",
          "cancel": "Cancel",
          "close": "Close panel",
          "colour": "Colour",
          "copied": "Copied",
          "copy": "Copy",
          "create": "Create group",
          "delete": "Delete group",
          "delete_confirm": "Delete %{group} and all its reminders?",
          "email_placeholder": "name@example.com",
          "invite": "Invite",
          "invite_by_email": "Invite by email",
          "invite_link": "Invite link",
          "invited": "Invited",
          "leave": "Leave group",
          "leave_confirm": "Leave %{group}?",
          "make_admin": "Make admin",
          "make_member": "Make member",
          "members": "Members · %{count}",
          "members_hint": "Admins can remove people",
          "new_title": "New group",
          "options_for": "Options for %{name}",
          "remove": "Remove from group",
          "remove_confirm": "Remove %{name} from %{group}?",
          "resend": "Resend",
          "revoke": "Revoke invitation",
          "save": "Save",
          "send_invite": "Send invite",
          "title": "Group",
          "you": "You"
        },
        "update": {
          "success": "Group saved."
        }
      },
      "joins": {
        "create": {
          "success": "Welcome to %{group}."
        },
        "show": {
          "already_member": "You are already in this group.",
          "body": "%{name} uses Meerkeep to share reminders with this group.",
          "join": "Join %{group}",
          "members": {
            "one": "1 member",
            "other": "%{count} members"
          },
          "no_thanks": "No thanks",
          "title": "Join %{group}?"
        }
      },
      "memberships": {
        "destroy": {
          "success": "Member removed."
        },
        "update": {
          "success": "Role updated."
        }
      },
      "nav": {
        "groups": "Groups",
        "reminders": "Reminders"
      },
      "reminders": {
        "complete": {
          "success": "Ticked off."
        },
        "create": {
          "success": "Reminder created."
        },
        "destroy": {
          "success": "Reminder deleted."
        },
        "index": {
          "empty_body": "Reminders you create or receive show up here.",
          "empty_search": "No reminders match \"%{query}\".",
          "empty_title": "Nothing here yet",
          "new": "New reminder",
          "search_label": "Search reminders",
          "search_placeholder": "Search reminders…",
          "select_one": "Pick a reminder to see who has done it.",
          "show": "Show",
          "title_all": "Today",
          "title_me": "Just me"
        },
        "new": {
          "all_hint": "Everyone has to tick it off",
          "all_of": "All %{count}",
          "anyone": "Anyone",
          "anyone_hint": "First one to do it closes it",
          "cancel": "Cancel",
          "close": "Close",
          "create_group": "Create one",
          "custom": "Pick another date & time",
          "description": "Description",
          "description_placeholder": "Add a description…",
          "just_me": "Just me",
          "no_groups_html": "You are not in any group yet. %{link} to remind other people.",
          "people": "%{count} people",
          "recurring_note": "Recurring rules can be set on the reminder once it exists.",
          "submit": "Create reminder",
          "submit_group": "Remind %{group}",
          "submit_members": "Remind %{names}",
          "title": "New reminder",
          "what": "What should the reminder say?",
          "what_placeholder": "Take out the bins",
          "when": "When",
          "who": "Who is it for"
        },
        "nudge": {
          "success": {
            "one": "Nudged 1 person.",
            "other": "Nudged %{count} people."
          }
        },
        "panel": {
          "close": "Close panel",
          "created_by": "Created by %{name}",
          "delete": "Delete reminder",
          "delete_confirm": "Delete this reminder for everyone?",
          "done_at": "Done · %{time}",
          "mark_done": "Mark done",
          "not_yet": "Not yet",
          "nudge": "Nudge %{count}",
          "progress": "Progress",
          "progress_count": "%{done} of %{total}",
          "repeats": "Repeats",
          "save": "Save",
          "title": "Reminder",
          "undo": "Undo done",
          "when": "When",
          "who": "Who",
          "you": "You"
        },
        "quick_picks": {
          "in_1_hour": "In 1 hour",
          "in_30_minutes": "In 30 minutes",
          "in_3_hours": "In 3 hours",
          "next_monday": "Monday",
          "tomorrow": "Tomorrow"
        },
        "reminder": {
          "anyone": "anyone",
          "done_at": "Done at %{time}",
          "everyone": "everyone",
          "mark_done": "Mark done: %{title}",
          "me": "Me",
          "nudge": "Nudge %{target}",
          "open": "Open %{title}",
          "progress": "%{done} of %{total} done",
          "repeats": "Repeats %{rule}",
          "sent_to": "Sent to %{names}",
          "snooze": "Snooze: %{title}",
          "snooze_menu": "Snooze",
          "undo_done": "Undo done: %{title}",
          "you_done": "You're done",
          "you_only": "you only"
        },
        "scopes": {
          "all": "Everything",
          "me": "Just me"
        },
        "sections": {
          "later": "Later",
          "overdue": "Overdue",
          "today": "Today",
          "tomorrow": "Tomorrow"
        },
        "snooze": {
          "success": "Snoozed until %{time}."
        },
        "snooze_options": {
          "fifteen_minutes": "15 minutes",
          "one_hour": "1 hour",
          "tomorrow_morning": "Tomorrow 09:00"
        },
        "uncomplete": {
          "success": "Reopened."
        },
        "update": {
          "success": "Reminder saved."
        }
      }
    },
    "services": {
      "boards": {
        "assignments": {
          "create": {
            "not_a_member": "Only board members can be assigned to a card."
          }
        },
        "assistant": {
          "connect": {
            "encryption": "Gmail cannot be connected because token encryption is not configured on this server.",
            "failed": "Google did not accept the connection. Try again.",
            "no_address": "Google did not tell which Gmail address this is. Try again.",
            "no_refresh_token": "Google did not give lasting access. Try again and accept every permission.",
            "scope": "Gmail read access was not granted. Connect again and allow it on Google's screen."
          },
          "paste_starter_prompt": "Create one card for each task or thing to do in the text. Ignore context, opinions and things already done. Put each card on the board that best matches its subject; if no board clearly matches, do not create a card. Write a short title starting with a verb. Set a due date only when the text states one. If the text says one of my cards is finished or its deadline changed, suggest the change instead of creating a new card.",
          "pastes": {
            "retry": {
              "not_failed": "Only a text that failed can be retried."
            },
            "submit": {
              "blank": "Paste some text first.",
              "too_long": "The text is too long. The limit is %{max} characters."
            }
          },
          "starter_prompt": "Create a card only when an email needs an action or an answer from me. Ignore newsletters, receipts and automatic notifications unless they require me to do something. Put the card on the board that best matches the sender or the subject; if no board clearly matches, do not create a card. Write a short title starting with a verb. Set a due date only when the email states a deadline.",
          "suggestions": {
            "accept": {
              "stale": "This suggestion no longer applies and was removed."
            },
            "dismiss": {
              "resolved": "This suggestion was already dealt with."
            }
          }
        },
        "boards": {
          "create": {
            "lists": [
              "Backlog",
              "To do",
              "Doing",
              "Done"
            ]
          }
        },
        "cards": {
          "bulk_update": {
            "nothing_selected": "Select at least one card.",
            "unknown_operation": "Unknown change."
          },
          "move": {
            "other_board": "The card can only be moved to a list of its own board."
          },
          "reschedule": {
            "nothing": "There is nothing to reschedule, or you cannot change those cards."
          },
          "update": {
            "invalid_list": "That list does not belong to this board."
          }
        },
        "lists": {
          "archive": {
            "last_list": "A board needs at least one list."
          }
        }
      },
      "groups": {
        "invite": {
          "already_member": "That person is already in the group."
        },
        "leave": {
          "last_admin": "Make someone else an admin before leaving.",
          "not_member": "You are not in this group."
        },
        "membership": {
          "last_admin": "A group needs at least one admin.",
          "unknown_change": "Unknown change."
        }
      },
      "reminders": {
        "complete": {
          "not_assigned": "This reminder is not yours to tick off."
        },
        "create": {
          "group_required": "Pick a group for this reminder.",
          "not_allowed_in_group": "Only admins can add reminders to %{group}.",
          "pick_someone": "Pick at least one person."
        },
        "nudge": {
          "nobody_pending": "Nobody is left to nudge."
        },
        "snooze": {
          "unknown_option": "Unknown snooze option."
        }
      },
      "time_tracker": {
        "imports": {
          "bad_time": "has a date or time that could not be read (%{value})",
          "ends_before_start": "ends before it starts",
          "missing_email": "has no email, so nobody to give the time to",
          "missing_headers": "This does not look like a Clockify detailed report. Missing columns: %{headers}",
          "missing_time": "has no start or end time",
          "no_description": "No description",
          "still_running": "This import is still running."
        },
        "reports": {
          "csv_export": {
            "all_clients": "All clients",
            "all_projects": "All projects",
            "billable": "%{amount} billable",
            "count_day": {
              "one": "1 person-day",
              "other": "%{count} person-days",
              "zero": "no person-days"
            },
            "count_entry": {
              "one": "1 time entry",
              "other": "%{count} time entries",
              "zero": "no time entries"
            },
            "count_task": {
              "one": "1 task",
              "other": "%{count} tasks",
              "zero": "no tasks"
            },
            "everyone": "everyone",
            "headers": {
              "amount": "Amount",
              "date": "Date",
              "duration": "Duration",
              "end": "End",
              "entries": "Entries",
              "hours": "Hours",
              "people": "People",
              "person": "Person",
              "project": "Project",
              "projects": "Projects",
              "rate": "Rate",
              "start": "Start",
              "task": "Task"
            },
            "now": "now",
            "people": {
              "one": "1 person",
              "other": "%{count} people"
            }
          },
          "dashboard": {
            "long_days": "three days over 9h",
            "long_days_and_weekend": "three days over 9h, plus %{weekend}",
            "missing_days": "nothing tracked on %{days}",
            "open": "Open",
            "project_billable": "%{client} · %{rate}",
            "project_internal": "No client · not billable",
            "project_not_billable": "%{client} · not billable",
            "review_entry": "Review entry",
            "short_days": "%{total} this week, every day under 6h 30m",
            "too_long": "%{task} ran %{duration}%{range}",
            "weekend": "worked on %{weekend}"
          }
        },
        "time_entries": {
          "stop": {
            "not_running": "That entry is not running."
          }
        },
        "workspaces": {
          "accept_invitation": {
            "already_accepted": "This invitation was already used.",
            "wrong_email": "This invitation was sent to %{email}. Log in with that account to accept it."
          },
          "create": {
            "success": "Workspace created."
          },
          "invite": {
            "added_to_boards": {
              "one": "%{emails} is already in the workspace and was added to the boards.",
              "other": "%{emails} are already in the workspace and were added to the boards."
            },
            "already_members": {
              "one": "%{emails} is already in the workspace.",
              "other": "%{emails} are already in the workspace."
            },
            "no_emails": "Type at least one email address.",
            "unknown_role": "Unknown role."
          },
          "manage_membership": {
            "deactivate_self": "You can't deactivate yourself.",
            "last_owner": "A workspace needs at least one owner. Make someone else an owner first.",
            "last_owner_self": "You are the last owner. Make someone else an owner before leaving.",
            "owners_only": "Only owners can make or unmake owners.",
            "unknown_change": "Unknown change."
          }
        }
      },
      "users": {
        "omniauth": {
          "no_email": "We could not get an email address from that account."
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "day_time": "%-d %b · %H:%M",
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%B %d, %Y %H:%M",
        "short": "%a %-d %b · %H:%M",
        "time": "%H:%M",
        "us": "%m/%d/%Y %I:%M %p",
        "weekday_time": "%a %H:%M"
      },
      "pm": "pm"
    },
    "time_tracker": {
      "clients": {
        "archive": {
          "success": "Client archived."
        },
        "create": {
          "success": "Client created."
        },
        "destroy": {
          "has_projects": "Archive the client and remove its projects before deleting it.",
          "success": "Client deleted."
        },
        "form": {
          "cancel": "Cancel",
          "contact_placeholder": "billing@company.com",
          "create": "Create client",
          "name_placeholder": "Company or person",
          "optional": "(optional)",
          "per_hour": "/h",
          "rate_hint": "(each project can change it)",
          "save": "Save changes"
        },
        "index": {
          "active_count": {
            "one": "1 active",
            "other": "%{count} active"
          },
          "archived": "Archived",
          "billable_this_month": "Billable this month",
          "empty_body": "Add the people you bill, then give them projects.",
          "empty_search": "No clients match \"%{query}\".",
          "empty_title": "No clients yet",
          "eyebrow": "%{workspace} workspace · %{month}",
          "footnote": "Projects without a client, like internal work, show up under Projects as “No client” and are never billable.",
          "hours_this_month": "Hours this month",
          "new": "New client",
          "no_projects": "No projects yet",
          "project_archived": "%{name} (archived)",
          "projects": "Projects",
          "search_label": "Search clients",
          "search_placeholder": "Search clients…",
          "select_one": "Pick a client to see its projects and this month's time.",
          "title": "Clients"
        },
        "panel": {
          "amount": "Amount",
          "archive": "Archive",
          "archive_confirm": "Archive %{name}? Its projects stay as they are.",
          "archived": "Archived",
          "close": "Close panel",
          "contact": "Contact",
          "default_rate": "Default rate for new projects",
          "delete": "Delete",
          "delete_confirm": "Delete %{name}? This cannot be undone.",
          "edit": "Edit",
          "export": "Export this client's time",
          "month_total": "%{month} total",
          "new_project_for": "+ New project for %{name}",
          "new_title": "New client",
          "no_projects": "No projects yet.",
          "not_billable": "Not billable",
          "not_set": "Not set",
          "project": "Project",
          "projects": "Projects",
          "rate": "Rate",
          "this_month": "This month",
          "unarchive": "Unarchive"
        },
        "unarchive": {
          "success": "Client is active again."
        },
        "update": {
          "success": "Client saved."
        }
      },
      "dashboards": {
        "people_filter": {
          "apply": "Apply",
          "empty": "Nobody here.",
          "everyone": "Everyone",
          "summary": {
            "one": "1 person",
            "other": "%{count} people",
            "zero": "Everyone"
          },
          "title": "People"
        },
        "range_chart": {
          "bar_title": "%{when}: %{duration}",
          "hours": "%{hours}h",
          "segment_title": "%{when} · %{project}: %{duration}",
          "summary": "%{grouping}, %{range}: %{duration} in total, split by project",
          "title": {
            "day": "Hours per day",
            "month": "Hours per month",
            "week": "Hours per week"
          },
          "total": "Total %{duration}"
        },
        "range_hours": {
          "days": "Days",
          "empty": "Nobody has tracked time in this period.",
          "intro": {
            "one": "Target counted over 1 workday.",
            "other": "Target counted over %{count} workdays."
          },
          "nothing": "nothing tracked",
          "person": "Person",
          "projects": "Projects",
          "segment_title": "%{project}: %{duration}",
          "title": "Hours per person",
          "total": "Total",
          "vs_target": "vs %{hours}h"
        },
        "range_nav": {
          "apply": "Apply",
          "custom": "Custom dates",
          "from": "From",
          "label": "Period",
          "next": {
            "custom": "Next period",
            "month": "Next month",
            "week": "Next week",
            "year": "Next year"
          },
          "periods": {
            "month": "Month",
            "week": "Week",
            "year": "Year"
          },
          "presets": {
            "last_month": "Last month",
            "last_week": "Last week",
            "last_year": "Last year",
            "this_month": "This month",
            "this_week": "This week",
            "this_year": "This year"
          },
          "previous": {
            "custom": "Previous period",
            "month": "Previous month",
            "week": "Previous week",
            "year": "Previous year"
          },
          "title": "Choose a period",
          "to": "To",
          "view": "Show by"
        },
        "show": {
          "alerts": {
            "dismiss": "Dismiss",
            "empty": "Nothing to flag in this period.",
            "title": "Needs a look"
          },
          "all_clients": "All clients",
          "client_label": "Client",
          "eyebrow": "Admins & owners",
          "heatmap": {
            "busiest": "Busiest %{from} – %{to}.",
            "cell_title": {
              "one": "%{day} %{hour}:00 — 1 person tracking",
              "other": "%{day} %{hour}:00 — %{count} people tracking",
              "zero": "%{day} %{hour}:00 — nobody tracking"
            },
            "everyone": "Everyone",
            "intro": "People with a timer running, per hour.",
            "intro_average": "Average people with a timer running, per weekday and hour.",
            "nobody": "Nobody",
            "title": "When the team tracks"
          },
          "kpis": {
            "average": "Average per person, per workday",
            "average_note": "Target %{target}",
            "billable": "Billable",
            "billable_note": "%{amount} at project rates · %{share}% of tracked time",
            "too_long": "Entries that look too long",
            "too_long_note": "Longer than %{hours}h in one go",
            "tracked": "Tracked",
            "tracked_note": {
              "one": "of %{hours}h expected for 1 person",
              "other": "of %{hours}h expected for %{count} people"
            }
          },
          "projects": {
            "all": "All projects",
            "empty": "No time on any project in this period.",
            "title": "Projects"
          },
          "status_label": "People",
          "statuses": {
            "active": "Active people",
            "all": "Everyone",
            "inactive": "Inactive people"
          },
          "title": "%{workspace} dashboard"
        },
        "week_hours": {
          "cell_title": "%{name}, %{day}: %{value}",
          "empty": "Nobody has tracked time this week yet.",
          "legend": {
            "close": "Close",
            "on_target": "On target",
            "over": "Over",
            "under": "Under"
          },
          "nothing": "nothing tracked",
          "person": "Person",
          "title": "Hours per person, per day",
          "total": "Total",
          "vs_target": "vs %{hours}h"
        },
        "week_nav": {
          "label": "Week",
          "next_week": "Next week",
          "previous_week": "Previous week"
        }
      },
      "entries": {
        "no_project": "No project",
        "now": "now"
      },
      "exports": {
        "show": {
          "all_clients": "All clients",
          "billable_only": "Billable time only",
          "client": "Client",
          "empty": "No time matches these filters.",
          "everyone": "Everyone",
          "eyebrow": "Filter, preview, download",
          "from": "From",
          "mode": "One row per",
          "modes": {
            "day": "Person per day",
            "entry": "Time entry",
            "task": "Task, added up"
          },
          "people": "People",
          "people_everyone": "People · everyone",
          "people_you": "People · you",
          "period": "Period",
          "periods": {
            "custom": "Custom",
            "last_month": "Last month",
            "last_week": "Last week",
            "this_month": "This month",
            "this_week": "This week"
          },
          "preview": "Preview",
          "projects": "Projects",
          "projects_empty": "No projects yet.",
          "projects_hint": "Only this client's projects are listed.",
          "projects_of": "Projects · %{client}",
          "showing": "Showing %{shown} of %{total} rows. The CSV has every row.",
          "showing_all": {
            "one": "Showing the only row.",
            "other": "Showing all %{count} rows."
          },
          "submit": "Export CSV",
          "task_contains": "Task contains",
          "task_placeholder": "e.g. QA",
          "title": "Export time entries",
          "to": "to"
        }
      },
      "imports": {
        "create": {
          "success": "File received. The import is running."
        },
        "destroy": {
          "success": "Import removed, with its time entries."
        },
        "index": {
          "columns": {
            "by": "By",
            "file": "File",
            "imported": "Imported",
            "skipped": "Skipped",
            "status": "Status",
            "when": "When"
          },
          "empty": "Nothing imported yet.",
          "eyebrow": "%{workspace} workspace",
          "file_hint": "Clockify: Reports → Detailed → Export → CSV. Up to %{max} MB.",
          "hint": "Bring time in from another tracker. Clients, projects and people named in the file are created when they do not exist yet; entries without a project or description are kept anyway.",
          "history": "Previous imports",
          "submit": "Import",
          "time_zone_hint": "The file shows times as the person who exported it saw them. Pick their time zone.",
          "title": "Import time",
          "upload": "Upload a file"
        },
        "show": {
          "back": "All imports",
          "counts": {
            "clients": "Clients created",
            "imported": "Entries imported",
            "projects": "Projects created",
            "rows": "Rows",
            "skipped": "Rows skipped",
            "users": "People created"
          },
          "danger": "Undo this import",
          "danger_hint": {
            "one": "Removes the import and the 1 time entry it created. Clients, projects and people stay.",
            "other": "Removes the import and the %{count} time entries it created. Clients, projects and people stay.",
            "zero": "Removes the import. It has no time entries left."
          },
          "delete": "Remove import and its entries",
          "delete_confirm": "Remove this import and every time entry it created? This cannot be undone.",
          "done": "Finished %{finished}, started by %{by}.",
          "eyebrow": "%{provider} · %{when}",
          "failed": "The import stopped and nothing was kept: %{message}",
          "in_progress": "Working through the file. This page refreshes on its own.",
          "issues": {
            "capped": "Showing the first %{shown}.",
            "line": "Line",
            "message": "Why",
            "title": {
              "one": "1 skipped row",
              "other": "%{count} skipped rows"
            }
          },
          "status": "Status",
          "title": "Import"
        }
      },
      "joins": {
        "already_member": "You're in %{workspace}.",
        "create": {
          "success": "Welcome to %{workspace}."
        },
        "show": {
          "already_used": "This invitation was already used.",
          "back": "Go to Meerkeep Time",
          "body": "%{name} invited you to track time with this workspace as %{role}.",
          "join": "Join %{workspace}",
          "members": {
            "one": "1 person is in it",
            "other": "%{count} people are in it"
          },
          "no_thanks": "No thanks",
          "switch_account": "Log out and use another account",
          "title": "Join %{workspace}?",
          "wrong_email": "This invitation was sent to %{invited}, but you are logged in as %{current}."
        }
      },
      "nav": {
        "clients": "Clients",
        "dashboard": "Dashboard",
        "export": "Export",
        "import": "Import",
        "manage": "Manage",
        "people": "People",
        "projects": "Projects",
        "timer": "Timer",
        "track": "Track"
      },
      "people": {
        "index": {
          "clear_search": "Show everyone",
          "columns": {
            "actions": "Actions",
            "last_tracked": "Last tracked",
            "person": "Person",
            "projects": "Projects",
            "role": "Role"
          },
          "everyone": "Everyone in %{workspace}",
          "eyebrow": "%{workspace} workspace · %{people}",
          "no_results": "Nobody matches “%{query}”.",
          "people_count": {
            "one": "1 person",
            "other": "%{count} people"
          },
          "search": "Search people",
          "search_placeholder": "Search people…",
          "settings": "Workspace settings",
          "title": "People"
        },
        "invite_card": {
          "emails": "Email addresses",
          "emails_placeholder": "name@company.com, another@company.com",
          "optional": "(optional)",
          "pending": "Invitations waiting",
          "projects": "Add them to projects",
          "resend": "Resend",
          "revoke": "Revoke the invitation for %{email}",
          "role": "Role",
          "send": "Send invites",
          "title": "Invite to %{workspace}",
          "waiting": "%{role} · waiting"
        },
        "membership": {
          "activate": "Activate",
          "add_project": "+ Project",
          "add_to_project": "Add %{name} to a project",
          "deactivate": "Deactivate",
          "deactivate_confirm": "Deactivate %{name}? They can't open %{workspace} until an owner activates them again. Their account and time entries stay.",
          "inactive": "Inactive",
          "leave_confirm": "Leave %{workspace}? You will lose access to its projects and time.",
          "make": "Make %{role}",
          "never": "Never",
          "remove": "Remove %{name} from the workspace",
          "remove_confirm": "Remove %{name} from %{workspace}? Their time entries stay.",
          "role_for": "Role for %{name}: %{role}. Change role",
          "timer_running": "Timer running",
          "today": "Today, %{time}",
          "tracking_now": "Tracking now",
          "yesterday": "Yesterday"
        },
        "roles_card": {
          "admin": "Manages clients, projects and rates. Sees the dashboard and the people, and can edit and export anyone’s time.",
          "member": "Tracks time on the projects they’re added to, and edits and exports their own entries. Sees only their own time, no rates.",
          "owner": "Everything an admin can, plus the workspace settings, inviting people, changing roles, removing people and deleting the workspace.",
          "title": "Roles in a workspace"
        }
      },
      "person_entries": {
        "index": {
          "back": "← %{name}'s week",
          "empty_body": "%{name}'s last 30 days show up here. Add time manually to fill in what's missing.",
          "empty_title": "Nothing tracked yet",
          "title": "%{name}'s time entries"
        }
      },
      "person_weeks": {
        "show": {
          "back": "← Team dashboard",
          "back_to_timer": "← Timer",
          "days": {
            "segment_title": "%{project}: %{duration}",
            "target": "%{hours}h",
            "title": "Hours per day"
          },
          "entries": "Time entries",
          "export": "Export %{name}'s time",
          "kpis": {
            "billable": "Billable share",
            "billable_note": "%{duration} · %{amount} at project rates",
            "entries": "Time entries",
            "entries_empty": "Nothing tracked this week",
            "entries_note": "Longest %{longest}",
            "tracked": "Tracked this week",
            "tracked_note": "of %{hours}h expected",
            "vs_target": "vs target",
            "vs_target_note": "Average %{average} per workday · target %{target}"
          },
          "projects": {
            "empty": "No time on any project this week.",
            "title": "By project"
          },
          "role_badge": "%{role} · %{workspace} workspace",
          "timeline": {
            "block_title": "%{project} · %{range} · %{task}",
            "intro": "Every time entry, placed at the hour it happened.",
            "title": "When %{name} tracked"
          },
          "title": "%{name}'s week"
        }
      },
      "project_memberships": {
        "create": {
          "success": "%{name} added to %{project}."
        },
        "destroy": {
          "success": "%{name} removed from %{project}."
        }
      },
      "projects": {
        "amounts": {
          "all_time": "All time",
          "this_month": "This month"
        },
        "archive": {
          "success": "Project archived."
        },
        "create": {
          "success": "Project created."
        },
        "destroy": {
          "success": "Project deleted."
        },
        "details": {
          "add": "Add",
          "add_label": "Add someone from the workspace",
          "add_prompt": "Add someone from %{workspace}…",
          "archive": "Archive",
          "archive_confirm": "Archive %{name}? Nobody can track time on it until it is unarchived.",
          "archived": "Archived",
          "billable": "Billable",
          "billable_hint": "Time on this project is charged to the client.",
          "delete": "Delete",
          "delete_confirm": "Delete %{name}? This cannot be undone.",
          "edit": "Edit",
          "entries": {
            "one": "1 entry",
            "other": "%{count} entries"
          },
          "export": "Export this project",
          "internal_hint": "Projects without a client are internal work and never billable.",
          "no_client": "No client",
          "no_people": "Nobody yet. Add someone from the workspace.",
          "no_tasks": "No time tracked yet.",
          "not_billable": "Not billable",
          "people": "People on this project",
          "people_hint": "Only they can track time here",
          "per_hour": "/h",
          "remove": "Remove %{name} from project",
          "tasks": "Tasks · time from all entries",
          "unarchive": "Unarchive"
        },
        "form": {
          "billable_hint": "Only projects with a client can be billable.",
          "cancel": "Cancel",
          "create": "Create project",
          "name_placeholder": "e.g. Spring campaign site",
          "new_client": "+ New client",
          "no_client": "No client",
          "people": "People who can track here",
          "per_hour": "/h",
          "rate_hint": "Leave blank to use the client's default rate.",
          "rate_hint_client": "%{name} usually %{rate} — leave blank to use it.",
          "save": "Save changes"
        },
        "index": {
          "active": {
            "one": "Active · 1",
            "other": "Active · %{count}"
          },
          "all_clients": "All clients",
          "all_time": "All time",
          "archived": {
            "one": "Archived · 1",
            "other": "Archived · %{count}"
          },
          "billable": "Billable",
          "billing": "Billing",
          "client": "Client",
          "client_filter": "Filter by client",
          "empty_archived": "Nothing archived.",
          "empty_body": "Create a project so people can track time on it.",
          "empty_title": "No projects yet",
          "eyebrow": "%{workspace} workspace",
          "new": "New project",
          "no_client": "No client",
          "not_billable": "Not billable",
          "people": "People",
          "people_count": {
            "one": "1 person",
            "other": "%{count} people"
          },
          "project": "Project",
          "status": "Status",
          "tasks": {
            "one": "1 task",
            "other": "%{count} tasks"
          },
          "this_week": "This week",
          "title": "Projects"
        },
        "new": {
          "back": "← Projects",
          "title": "New project"
        },
        "show": {
          "back": "← Projects"
        },
        "unarchive": {
          "success": "Project is active again."
        },
        "update": {
          "success": "Project saved."
        }
      },
      "task_suggestions": {
        "create_and_start": "Create task “%{task}” and start",
        "so_far": "%{total} so far",
        "tasks_in": "Tasks in %{project}"
      },
      "time_entries": {
        "create": {
          "success": "Time added."
        },
        "day": {
          "today": "Today · %{date}",
          "total_to_check": "%{total} + %{flagged} to check",
          "yesterday": "Yesterday · %{date}"
        },
        "destroy": {
          "success": "Entry deleted."
        },
        "dismiss_too_long": {
          "success": "Entry no longer flagged."
        },
        "edit": {
          "cancel": "Cancel",
          "close": "Close",
          "delete": "Delete time entry",
          "delete_confirm": "Delete the entry \"%{task}\"? This cannot be undone.",
          "dismiss": "It's correct, dismiss",
          "duration": "Duration",
          "footnote": "Started with the timer on %{started} · stopped %{stopped}. This entry doesn’t mark the task as done.",
          "footnote_running": "Started with the timer on %{started} · still running. Leave Stopped empty to keep it running.",
          "hint": "It looks like the timer kept running after you stopped working. Pick an end time:",
          "negative": "The end is before the start. Fix the dates or times before saving.",
          "pick": "%{day} at %{time}",
          "picks_label": "Quick end times",
          "running": "Running",
          "save": "Save changes",
          "suggestion": {
            "history": "Your usual day · %{duration}",
            "target": "Daily target · %{duration}",
            "target_plus": "Target + 1h · %{duration}"
          },
          "suggestions": "Task suggestions",
          "title": "Edit time entry",
          "too_long": "This entry is %{duration} long."
        },
        "entry": {
          "edit": "Edit entry: %{task}",
          "resume": "Track again: %{task}",
          "running": "Running",
          "stop": "Stop: %{task}",
          "too_long": "Too long?"
        },
        "index": {
          "empty_body": "Start the timer above or add time manually. Your last 30 days show up here.",
          "empty_search": "No entries match \"%{query}\".",
          "empty_title": "Nothing tracked yet",
          "search_label": "Search time entries",
          "search_placeholder": "Search entries…",
          "title": "Timer"
        },
        "manual_form": {
          "duration": "Duration",
          "submit": "Add entry",
          "suggestions": "Task suggestions",
          "task_placeholder": "What did you work on?",
          "title": "Add time manually"
        },
        "resume": {
          "not_trackable": "You can no longer track time on %{project}.",
          "success": "Timer started on \"%{task}\"."
        },
        "time_fields": {
          "end_date": "End date",
          "end_time": "End time",
          "start_date": "Start date",
          "start_time": "Start time"
        },
        "timer_bar": {
          "no_projects": "You are not on any project yet. Ask an admin to add you to one.",
          "project": "Project",
          "start": "Start timer",
          "stop": "Stop timer",
          "suggestions": "Task suggestions",
          "task": "Task",
          "task_placeholder": "Pick a task or type a new one…"
        },
        "too_long_banner": {
          "dismiss": "Dismiss",
          "fix": "Fix entry",
          "text_html": "%{task} ran from %{from} to %{to}. That’s %{duration} in one entry."
        },
        "update": {
          "success": "Entry saved."
        },
        "week": {
          "chart_label": "Hours tracked per day this week",
          "day_total": "%{day}: %{total}",
          "entries": {
            "one": "1 entry",
            "other": "%{count} entries"
          },
          "running": {
            "one": ", 1 running",
            "other": ", %{count} running"
          },
          "target": "%{hours}h",
          "tasks": "Tasks this week",
          "tasks_empty": "Nothing tracked this week yet.",
          "tasks_hint": "All entries added up",
          "title": "This week · %{range}"
        }
      },
      "timers": {
        "create": {
          "success": "Timer started."
        },
        "destroy": {
          "nothing_running": "No timer is running.",
          "success": "Timer stopped after %{duration}."
        }
      },
      "workspace_invitations": {
        "added": "%{emails} added to the workspace.",
        "destroy": {
          "success": "Invitation revoked."
        },
        "invited": "Invitation sent to %{emails}."
      },
      "workspace_memberships": {
        "activate": {
          "success": "%{name} activated."
        },
        "deactivate": {
          "success": "%{name} deactivated."
        },
        "destroy": {
          "success": "%{name} removed from the workspace."
        },
        "update": {
          "success": "%{name}'s role updated."
        }
      },
      "workspaces": {
        "create": {
          "success": "Workspace created. Invite your team."
        },
        "destroy": {
          "success": "Workspace deleted."
        },
        "edit": {
          "danger": "Delete workspace",
          "danger_hint": "This removes every client, project and time entry in it, for everyone.",
          "delete": "Delete workspace",
          "delete_confirm": "Delete %{workspace} and all its time? This cannot be undone.",
          "eyebrow": "%{workspace} workspace",
          "general": "General",
          "save": "Save changes",
          "target_hint": "The dashboard compares everyone's day with this target.",
          "title": "Workspace settings"
        },
        "new": {
          "heading": "Your team's home",
          "hint": "Everything in Meerkeep Time — people, clients, projects and time — lives inside a workspace.",
          "name_placeholder": "e.g. Awesome Company",
          "submit": "Create workspace",
          "title": "Create a workspace"
        },
        "update": {
          "success": "Workspace saved."
        }
      }
    },
    "tools": {
      "boards": {
        "name": "Meerkeep Boards",
        "short_name": "Boards",
        "tagline": "Move work across columns until it's done."
      },
      "reminders": {
        "name": "Meerkeep Reminders",
        "short_name": "Reminders",
        "tagline": "For you, someone, or a whole group."
      },
      "time": {
        "name": "Meerkeep Time",
        "short_name": "Time",
        "tagline": "Press play on a task. See where the week went."
      }
    },
    "users": {
      "passwords": {
        "edit": {
          "submit": "Save password",
          "title": "Set a new password"
        },
        "new": {
          "submit": "Send reset link",
          "subtitle": "We will email you a link to set a new one.",
          "title": "Forgot your password?"
        }
      },
      "registrations": {
        "edit": {
          "change_password": "Change password",
          "danger": "Delete account",
          "danger_hint": "This removes your reminders, your time entries and takes you out of every group and workspace.",
          "delete_account": "Delete my account",
          "delete_confirm": "Delete your account? This cannot be undone.",
          "disable_push": "Turn off on this device",
          "enable_push": "Turn on notifications",
          "new_password": "New password",
          "notifications": "Notifications",
          "notifications_hint": "Get a notification on this device when a reminder is due or someone nudges you.",
          "password": "Password",
          "password_hint": "Leave blank to keep your current password.",
          "profile": "Profile",
          "push_denied": "Notifications are blocked in your browser settings.",
          "push_enabled": "Notifications are on for this device.",
          "push_unsupported": "This browser does not support notifications.",
          "save": "Save changes",
          "session": "Session",
          "sign_out": "Log out",
          "title": "Edit profile"
        },
        "new": {
          "accept_html": "I accept the %{consent}",
          "password_hint": "At least 8 characters",
          "submit": "Create account",
          "subtitle": "Free while we are in beta.",
          "subtitle_invited": "Create your account to join %{workspace}.",
          "title": "Create your account"
        }
      },
      "sessions": {
        "new": {
          "submit": "Log in",
          "subtitle": "Log in to pick up where you left off.",
          "title": "Welcome back"
        }
      },
      "shared": {
        "continuing_to": "Continuing to %{tool}",
        "links": {
          "back_to_login": "Back to log in",
          "create_account": "Create an account",
          "forgot": "Forgot?",
          "have_account": "Already have an account?",
          "log_in": "Log in",
          "new_here": "New to Meerkeep?"
        },
        "same_login": "The same login works for %{others}.",
        "social": {
          "apple": "Continue with Apple",
          "google": "Continue with Google",
          "or": "or"
        }
      }
    },
    "views": {
      "admin": {
        "page_blocks": {
          "add_block": "Add Block",
          "add_slide": "Add Slide",
          "alt_text_label": "Alt Text",
          "autoplay_label": "Autoplay",
          "body_label": "Content",
          "caption_label": "Caption",
          "carousel_autoplay_delay_label": "Autoplay Delay (ms)",
          "carousel_autoplay_label": "Autoplay",
          "carousel_effect_fade": "Fade",
          "carousel_effect_label": "Transition Effect",
          "carousel_effect_slide": "Slide",
          "carousel_loop_label": "Loop",
          "carousel_navigation_label": "Show Navigation Arrows",
          "carousel_pagination_label": "Show Pagination Dots",
          "carousel_speed_label": "Transition Speed (ms)",
          "content_type": "Block Type",
          "controls_label": "Show controls",
          "image_label": "Image File",
          "loop_label": "Loop",
          "remove_slide": "Remove",
          "replace_image": "Replace image",
          "replace_video": "Replace video",
          "slide_image_label": "Image",
          "slide_text_label": "Text",
          "slide_title_label": "Title",
          "slides_heading": "Slides",
          "title_placeholder": "e.g. Hero Banner",
          "type_carousel": "Carousel",
          "type_image": "Image",
          "type_text": "Text",
          "type_video": "Video",
          "video_file_label": "Video File",
          "video_source_help": "Provide a URL (YouTube, Vimeo, or other) OR upload a file — not both.",
          "video_url_label": "Video URL"
        },
        "pages": {
          "back_to_layout": "Back to layout",
          "empty_grid": "No blocks yet. Click \"Add Block\" to get started."
        }
      },
      "hypmin": {
        "action": {
          "create": "New",
          "edit": "Edit",
          "index": "All",
          "new": "New",
          "show": "Show",
          "update": "Update"
        },
        "add": "Add",
        "admin_panel": "Admin Panel",
        "alert": "Alert!",
        "all": "All",
        "are_you_sure": "Are you sure?",
        "back": "Back",
        "ban": "Ban",
        "cancel": "Cancel",
        "collapse": "Collapse",
        "confirm_destroy": "Are you sure? This action cannot be undone.",
        "create": "Create",
        "created_by": "Created by",
        "data_of": "Data of",
        "date": "Date",
        "destroy": "Destroy",
        "download_pdf": "Download PDF",
        "edit": "Edit",
        "error": "Error!",
        "filter": "Filter",
        "insert_link": "Insert link",
        "lang_label": {
          "en": "(EN)",
          "pt": "(PT)"
        },
        "main_menu": "Main Menu",
        "member_since": "Member Since",
        "new": "New",
        "no": "No",
        "notice": "Notice!",
        "page_blocks": "Blocks",
        "pagination": {
          "showing_results_html": "Showing %{from}–%{to} of %{count} results"
        },
        "profile": "Profile",
        "save": "Save",
        "search_for": "Search for...",
        "search_placeholder": "Search...",
        "select": "Select...",
        "send": "Send",
        "show": "Show",
        "welcome_message": "Welcome",
        "yes": "Yes"
      }
    },
    "welcome": "welcome",
    "workspace_invitation_mailer": {
      "added": {
        "body_boards": "%{name} added you to the %{workspace} workspace on Meerkeep Boards as %{role}, so you can work on boards together.",
        "body_time": "%{name} added you to the %{workspace} workspace on Meerkeep Time as %{role}, so you can track time together.",
        "hello": "Hello,",
        "open": "Open %{workspace}",
        "subject_boards": "%{name} added you to %{workspace} on Meerkeep Boards",
        "subject_time": "%{name} added you to %{workspace} on Meerkeep Time"
      },
      "invite": {
        "body_boards": "%{name} invited you to join the %{workspace} workspace on Meerkeep Boards as %{role}, so you can work on boards together.",
        "body_time": "%{name} invited you to join the %{workspace} workspace on Meerkeep Time as %{role}, so you can track time together.",
        "hello": "Hello,",
        "ignore": "If you were not expecting this, you can ignore this email.",
        "join": "Join the workspace",
        "subject_boards": "%{name} invited you to %{workspace} on Meerkeep Boards",
        "subject_time": "%{name} invited you to %{workspace} on Meerkeep Time"
      }
    },
    "workspace_switcher": {
      "create_workspace": "Create a workspace",
      "switch_workspace": "Workspace: %{workspace}. Switch workspace",
      "workspace": "Workspace",
      "workspace_meta": {
        "one": "1 person · you're %{role}",
        "other": "%{count} people · you're %{role}"
      },
      "your_workspaces": "Your workspaces"
    }
  },
  "en-AU": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##",
          "#/#",
          "##/#",
          "#?"
        ],
        "default_country": [
          "Australia",
          "Aus"
        ],
        "default_country_code": [
          "AU"
        ],
        "full_address": [
          "#{street_address}, #{city} #{postcode}",
          "#{street_address}, #{secondary_address}, #{city} #{postcode}",
          "#{secondary_address}, #{street_address}, #{city} #{postcode}",
          "#{mail_box} #{city} #{postcode}"
        ],
        "postcode": [
          "02##",
          "08##",
          "####"
        ],
        "postcode_by_state": {
          "ACT": [
            "02##",
            "260#",
            "261#",
            "290#",
            "291#"
          ],
          "NSW": [
            "1###",
            "2###"
          ],
          "NT": [
            "08##",
            "09##"
          ],
          "QLD": [
            "4###",
            "9###"
          ],
          "SA": [
            "5###"
          ],
          "TAS": [
            "7###"
          ],
          "VIC": [
            "3###",
            "8###"
          ],
          "WA": [
            "6###"
          ]
        },
        "secondary_address": [
          "Apartment #",
          "Apt #",
          "Unit #",
          "U#",
          "Flat #",
          "House #",
          "Level #"
        ],
        "state": [
          "New South Wales",
          "Queensland",
          "Northern Territory",
          "South Australia",
          "Western Australia",
          "Tasmania",
          "Australian Capital Territory",
          "Victoria"
        ],
        "state_abbr": [
          "NSW",
          "QLD",
          "NT",
          "SA",
          "WA",
          "TAS",
          "ACT",
          "VIC"
        ],
        "street_suffix": [
          "Approach",
          "Avenue",
          "Arcade",
          "Boulevard",
          "Circle",
          "Circuit",
          "Court",
          "Crescent",
          "Crest",
          "Drive",
          "Estate",
          "Entrance",
          "Gardens",
          "Grove",
          "Green",
          "Heights",
          "Hill",
          "Junction",
          "Lane",
          "Loop",
          "Lookout",
          "Mall",
          "Mews",
          "Mount",
          "Parade",
          "Park",
          "Parkway",
          "Pass",
          "Place",
          "Plaza",
          "Promenade",
          "Ramble",
          "Ridge",
          "Retreat",
          "Rise",
          "Road",
          "Run",
          "Square",
          "Street",
          "Summit",
          "Terrace",
          "Track",
          "Trail",
          "Turn",
          "Way",
          "View",
          "Walk"
        ],
        "time_zone": [
          "Australia/Sydney",
          "Australia/Brisbane",
          "Australia/Melbourne",
          "Australia/Hobart",
          "Australia/Adelaide",
          "Australia/Perth",
          "Australia/Darwin",
          "Australia/Canberra"
        ]
      },
      "bank": {
        "name": [
          "ANZ",
          "Westpac",
          "Commonwealth Bank",
          "National Australia Bank",
          "St George Bank",
          "Bank of Queensland",
          "Bankwest",
          "Bendigo Bank",
          "Credit Union Australia",
          "ING"
        ]
      },
      "cell_phone": {
        "formats": [
          "040# ### ###",
          "041#######",
          "(04) 2#######",
          "043# ### ###"
        ]
      },
      "company": {
        "suffix": [
          "Pty Ltd",
          "and Sons",
          "Corp",
          "Group",
          "Brothers",
          "Partners"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com.au",
          "com",
          "net.au",
          "net",
          "org.au",
          "org",
          "edu.au",
          "gov.au"
        ]
      },
      "name": {
        "first_name": [
          "William",
          "Jack",
          "Oliver",
          "Joshua",
          "Thomas",
          "Lachlan",
          "Cooper",
          "Noah",
          "Ethan",
          "Lucas",
          "James",
          "Samuel",
          "Jacob",
          "Liam",
          "Alexander",
          "Benjamin",
          "Max",
          "Isaac",
          "Daniel",
          "Riley",
          "Ryan",
          "Charlie",
          "Tyler",
          "Jake",
          "Matthew",
          "Xavier",
          "Harry",
          "Jayden",
          "Nicholas",
          "Harrison",
          "Levi",
          "Luke",
          "Adam",
          "Henry",
          "Aiden",
          "Dylan",
          "Oscar",
          "Michael",
          "Jackson",
          "Logan",
          "Joseph",
          "Blake",
          "Nathan",
          "Connor",
          "Elijah",
          "Nate",
          "Archie",
          "Bailey",
          "Marcus",
          "Cameron",
          "Jordan",
          "Zachary",
          "Caleb",
          "Hunter",
          "Ashton",
          "Toby",
          "Aidan",
          "Hayden",
          "Mason",
          "Hamish",
          "Edward",
          "Angus",
          "Eli",
          "Sebastian",
          "Christian",
          "Patrick",
          "Andrew",
          "Anthony",
          "Luca",
          "Kai",
          "Beau",
          "Alex",
          "George",
          "Callum",
          "Finn",
          "Zac",
          "Mitchell",
          "Jett",
          "Jesse",
          "Gabriel",
          "Leo",
          "Declan",
          "Charles",
          "Jasper",
          "Jonathan",
          "Aaron",
          "Hugo",
          "David",
          "Christopher",
          "Chase",
          "Owen",
          "Justin",
          "Ali",
          "Darcy",
          "Lincoln",
          "Cody",
          "Phoenix",
          "Sam",
          "John",
          "Joel",
          "Isabella",
          "Ruby",
          "Chloe",
          "Olivia",
          "Charlotte",
          "Mia",
          "Lily",
          "Emily",
          "Ella",
          "Sienna",
          "Sophie",
          "Amelia",
          "Grace",
          "Ava",
          "Zoe",
          "Emma",
          "Sophia",
          "Matilda",
          "Hannah",
          "Jessica",
          "Lucy",
          "Georgia",
          "Sarah",
          "Abigail",
          "Zara",
          "Eva",
          "Scarlett",
          "Jasmine",
          "Chelsea",
          "Lilly",
          "Ivy",
          "Isla",
          "Evie",
          "Isabelle",
          "Maddison",
          "Layla",
          "Summer",
          "Annabelle",
          "Alexis",
          "Elizabeth",
          "Bella",
          "Holly",
          "Lara",
          "Madison",
          "Alyssa",
          "Maya",
          "Tahlia",
          "Claire",
          "Hayley",
          "Imogen",
          "Jade",
          "Ellie",
          "Sofia",
          "Addison",
          "Molly",
          "Phoebe",
          "Alice",
          "Savannah",
          "Gabriella",
          "Kayla",
          "Mikayla",
          "Abbey",
          "Eliza",
          "Willow",
          "Alexandra",
          "Poppy",
          "Samantha",
          "Stella",
          "Amy",
          "Amelie",
          "Anna",
          "Piper",
          "Gemma",
          "Isabel",
          "Victoria",
          "Stephanie",
          "Caitlin",
          "Heidi",
          "Paige",
          "Rose",
          "Amber",
          "Audrey",
          "Claudia",
          "Taylor",
          "Madeline",
          "Angelina",
          "Natalie",
          "Charli",
          "Lauren",
          "Ashley",
          "Violet",
          "Mackenzie",
          "Abby",
          "Skye",
          "Lillian",
          "Alana",
          "Lola",
          "Leah",
          "Eve",
          "Kiara"
        ],
        "last_name": [
          "Smith",
          "Jones",
          "Williams",
          "Brown",
          "Wilson",
          "Taylor",
          "Johnson",
          "White",
          "Martin",
          "Anderson",
          "Thompson",
          "Nguyen",
          "Thomas",
          "Walker",
          "Harris",
          "Lee",
          "Ryan",
          "Robinson",
          "Kelly",
          "King",
          "Davis",
          "Wright",
          "Evans",
          "Roberts",
          "Green",
          "Hall",
          "Wood",
          "Jackson",
          "Clarke",
          "Patel",
          "Khan",
          "Lewis",
          "James",
          "Phillips",
          "Mason",
          "Mitchell",
          "Rose",
          "Davies",
          "Rodriguez",
          "Cox",
          "Alexander",
          "Garden",
          "Campbell",
          "Johnston",
          "Moore",
          "Smyth",
          "O'neill",
          "Doherty",
          "Stewart",
          "Quinn",
          "Murphy",
          "Graham",
          "Mclaughlin",
          "Hamilton",
          "Murray",
          "Hughes",
          "Robertson",
          "Thomson",
          "Scott",
          "Macdonald",
          "Reid",
          "Clark",
          "Ross",
          "Young",
          "Watson",
          "Paterson",
          "Morrison",
          "Morgan",
          "Griffiths",
          "Edwards",
          "Rees",
          "Jenkins",
          "Owen",
          "Price",
          "Moss",
          "Richards",
          "Abbott",
          "Adams",
          "Armstrong",
          "Bahringer",
          "Bailey",
          "Barrows",
          "Bartell",
          "Bartoletti",
          "Barton",
          "Bauch",
          "Baumbach",
          "Bayer",
          "Beahan",
          "Beatty",
          "Becker",
          "Beier",
          "Berge",
          "Bergstrom",
          "Bode",
          "Bogan",
          "Borer",
          "Bosco",
          "Botsford",
          "Boyer",
          "Boyle",
          "Braun",
          "Bruen",
          "Carroll",
          "Carter",
          "Cartwright",
          "Casper",
          "Cassin",
          "Champlin",
          "Christiansen",
          "Cole",
          "Collier",
          "Collins",
          "Connelly",
          "Conroy",
          "Corkery",
          "Cormier",
          "Corwin",
          "Cronin",
          "Crooks",
          "Cruickshank",
          "Cummings",
          "D'amore",
          "Daniel",
          "Dare",
          "Daugherty",
          "Dickens",
          "Dickinson",
          "Dietrich",
          "Donnelly",
          "Dooley",
          "Douglas",
          "Doyle",
          "Durgan",
          "Ebert",
          "Emard",
          "Emmerich",
          "Erdman",
          "Ernser",
          "Fadel",
          "Fahey",
          "Farrell",
          "Fay",
          "Feeney",
          "Feil",
          "Ferry",
          "Fisher",
          "Flatley",
          "Gibson",
          "Gleason",
          "Glover",
          "Goldner",
          "Goodwin",
          "Grady",
          "Grant",
          "Greenfelder",
          "Greenholt",
          "Grimes",
          "Gutmann",
          "Hackett",
          "Hahn",
          "Haley",
          "Hammes",
          "Hand",
          "Hane",
          "Hansen",
          "Harber",
          "Hartmann",
          "Harvey",
          "Hayes",
          "Heaney",
          "Heathcote",
          "Heller",
          "Hermann",
          "Hermiston",
          "Hessel",
          "Hettinger",
          "Hickle",
          "Hill",
          "Hills",
          "Hoppe",
          "Howe",
          "Howell",
          "Hudson",
          "Huel",
          "Hyatt",
          "Jacobi",
          "Jacobs",
          "Jacobson",
          "Jerde",
          "Johns",
          "Keeling",
          "Kemmer",
          "Kessler",
          "Kiehn",
          "Kirlin",
          "Klein",
          "Koch",
          "Koelpin",
          "Kohler",
          "Koss",
          "Kovacek",
          "Kreiger",
          "Kris",
          "Kuhlman",
          "Kuhn",
          "Kulas",
          "Kunde",
          "Kutch",
          "Lakin",
          "Lang",
          "Langworth",
          "Larkin",
          "Larson",
          "Leannon",
          "Leffler",
          "Little",
          "Lockman",
          "Lowe",
          "Lynch",
          "Mann",
          "Marks",
          "Marvin",
          "Mayer",
          "Mccullough",
          "Mcdermott",
          "Mckenzie",
          "Miller",
          "Mills",
          "Monahan",
          "Morissette",
          "Mueller",
          "Muller",
          "Nader",
          "Nicolas",
          "Nolan",
          "O'connell",
          "O'conner",
          "O'hara",
          "O'keefe",
          "Olson",
          "O'reilly",
          "Parisian",
          "Parker",
          "Quigley",
          "Reilly",
          "Reynolds",
          "Rice",
          "Ritchie",
          "Rohan",
          "Rolfson",
          "Rowe",
          "Russel",
          "Rutherford",
          "Sanford",
          "Sauer",
          "Schmidt",
          "Schmitt",
          "Schneider",
          "Schroeder",
          "Schultz",
          "Shields",
          "Smitham",
          "Spencer",
          "Stanton",
          "Stark",
          "Stokes",
          "Swift",
          "Tillman",
          "Towne",
          "Tremblay",
          "Tromp",
          "Turcotte",
          "Turner",
          "Walsh",
          "Walter",
          "Ward",
          "Waters",
          "Weber",
          "Welch",
          "West",
          "Wilderman",
          "Wilkinson",
          "Williamson",
          "Windler",
          "Wolf"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}"
        ],
        "prefix": [
          "Mr",
          "Mrs",
          "Ms",
          "Dr",
          "Miss",
          "Master"
        ]
      },
      "phone_number": {
        "area_code": [
          "02",
          "03",
          "07",
          "08"
        ],
        "country_code": [
          "61"
        ],
        "formats": [
          "7010 ####",
          "5550 ####",
          "#{area_code} 7010 #{subscriber_number}",
          "#{area_code} 5550 #{subscriber_number}",
          "(#{area_code}) 7010 #{subscriber_number}",
          "(#{area_code}) 5550 #{subscriber_number}"
        ],
        "subscriber_number": [
          "####"
        ]
      },
      "team": {
        "sport": [
          "basketball",
          "football",
          "footy",
          "netball",
          "rugby",
          "cricket",
          "tennis",
          "soccer",
          "hockey",
          "swimming",
          "waterpolo",
          "golf",
          "AFL"
        ]
      },
      "university": {
        "name": [
          "University of South Australia",
          "University of Tasmania",
          "University of Technology Sydney",
          "Australian National University",
          "University of Melbourne",
          "Monash University",
          "University of Sydney",
          "University of Queensland",
          "The University of Western Australia",
          "Curtin University",
          "Murdoch University",
          "University of Adelaide",
          "Macquarie University",
          "Deakin University",
          "Griffith University",
          "Flinders University",
          "Edith Cowan University",
          "Australia Catholic University",
          "Charles Sturt University",
          "University of New South Wales"
        ]
      },
      "vehicle": {
        "license_plate_by_state": {
          "ACT": [
            "Y??##?"
          ],
          "NSW": [
            "??##??"
          ],
          "NT": [
            "??##??"
          ],
          "QLD": [
            "###???"
          ],
          "SA": [
            "S###???"
          ],
          "TAS": [
            "?##??"
          ],
          "VIC": [
            "#??#??"
          ],
          "WA": [
            "#???###"
          ]
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-BORK": {
    "faker": {
      "lorem": {
        "words": [
          "Boot",
          "I",
          "Nu",
          "Nur",
          "Tu",
          "Um",
          "a",
          "becoose-a",
          "boot",
          "bork",
          "burn",
          "chuuses",
          "cumplete-a",
          "cun",
          "cunseqooences",
          "curcoomstunces",
          "dee",
          "deeslikes",
          "denuoonceeng",
          "desures",
          "du",
          "eccuoont",
          "ectooel",
          "edfuntege-a",
          "efueeds",
          "egeeen",
          "ell",
          "ere-a",
          "feend",
          "foolt",
          "frum",
          "geefe-a",
          "gesh",
          "greet",
          "heem",
          "heppeeness",
          "hes",
          "hoo",
          "hoomun",
          "idea",
          "ifer",
          "in",
          "incuoonter",
          "injuy",
          "itselff",
          "ixcept",
          "ixemple-a",
          "ixerceese-a",
          "ixpleeen",
          "ixplurer",
          "ixpuoond",
          "ixtremely",
          "knoo",
          "lebureeuoos",
          "lufes",
          "meestekee",
          "mester-booeelder",
          "moost",
          "mun",
          "nu",
          "nut",
          "oobteeen",
          "oocceseeunelly",
          "ooccoor",
          "ooff",
          "oone-a",
          "oor",
          "peeen",
          "peeenffool",
          "physeecel",
          "pleesoore-a",
          "poorsooe-a",
          "poorsooes",
          "preeesing",
          "prucoore-a",
          "prudooces",
          "reeght",
          "reshunelly",
          "resooltunt",
          "sume-a",
          "teecheengs",
          "teke-a",
          "thees",
          "thet",
          "thuse-a",
          "treefiel",
          "troot",
          "tu",
          "tueel",
          "und",
          "undertekes",
          "unnuyeeng",
          "uny",
          "unyune-a",
          "us",
          "veell",
          "veet",
          "ves",
          "vheech",
          "vhu",
          "yuoo",
          "zee",
          "zeere-a"
        ]
      }
    }
  },
  "en-CA": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "faker": {
      "address": {
        "default_country": [
          "Canada"
        ],
        "default_country_code": [
          "CA"
        ],
        "postcode": "/[A-CEGHJ-NPR-TVXY][0-9][A-CEJ-NPR-TV-Z] ?[0-9][A-CEJ-NPR-TV-Z][0-9]/",
        "state": [
          "Alberta",
          "British Columbia",
          "Manitoba",
          "New Brunswick",
          "Newfoundland and Labrador",
          "Nova Scotia",
          "Northwest Territories",
          "Nunavut",
          "Ontario",
          "Prince Edward Island",
          "Quebec",
          "Saskatchewan",
          "Yukon"
        ],
        "state_abbr": [
          "AB",
          "BC",
          "MB",
          "NB",
          "NL",
          "NS",
          "NU",
          "NT",
          "ON",
          "PE",
          "QC",
          "SK",
          "YT"
        ]
      },
      "internet": {
        "domain_suffix": [
          "ca",
          "com",
          "biz",
          "info",
          "name",
          "net",
          "org"
        ]
      },
      "phone_number": {
        "area_code": [
          "204",
          "226",
          "236",
          "249",
          "250",
          "289",
          "306",
          "343",
          "365",
          "403",
          "416",
          "418",
          "431",
          "437",
          "438",
          "450",
          "506",
          "514",
          "519",
          "579",
          "581",
          "587",
          "604",
          "613",
          "639",
          "647",
          "705",
          "709",
          "778",
          "780",
          "807",
          "819",
          "867",
          "873",
          "902",
          "905"
        ],
        "country_code": [
          "1"
        ],
        "exchange_code": [
          "201",
          "202",
          "203",
          "205",
          "206",
          "207",
          "208",
          "209",
          "210",
          "212",
          "213",
          "214",
          "215",
          "216",
          "217",
          "218",
          "219",
          "224",
          "225",
          "227",
          "228",
          "229",
          "231",
          "234",
          "239",
          "240",
          "248",
          "251",
          "252",
          "253",
          "254",
          "256",
          "260",
          "262",
          "267",
          "269",
          "270",
          "276",
          "281",
          "283",
          "301",
          "302",
          "303",
          "304",
          "305",
          "307",
          "308",
          "309",
          "310",
          "312",
          "313",
          "314",
          "315",
          "316",
          "317",
          "318",
          "319",
          "320",
          "321",
          "323",
          "330",
          "331",
          "334",
          "336",
          "337",
          "339",
          "347",
          "351",
          "352",
          "360",
          "361",
          "386",
          "401",
          "402",
          "404",
          "405",
          "406",
          "407",
          "408",
          "409",
          "410",
          "412",
          "413",
          "414",
          "415",
          "417",
          "419",
          "423",
          "424",
          "425",
          "434",
          "435",
          "440",
          "443",
          "445",
          "464",
          "469",
          "470",
          "475",
          "478",
          "479",
          "480",
          "484",
          "501",
          "502",
          "503",
          "504",
          "505",
          "507",
          "508",
          "509",
          "510",
          "512",
          "513",
          "515",
          "516",
          "517",
          "518",
          "520",
          "530",
          "540",
          "541",
          "551",
          "557",
          "559",
          "561",
          "562",
          "563",
          "564",
          "567",
          "570",
          "571",
          "573",
          "574",
          "580",
          "585",
          "586",
          "601",
          "602",
          "603",
          "605",
          "606",
          "607",
          "608",
          "609",
          "610",
          "612",
          "614",
          "615",
          "616",
          "617",
          "618",
          "619",
          "620",
          "623",
          "626",
          "630",
          "631",
          "636",
          "641",
          "646",
          "650",
          "651",
          "660",
          "661",
          "662",
          "667",
          "678",
          "682",
          "701",
          "702",
          "703",
          "704",
          "706",
          "707",
          "708",
          "712",
          "713",
          "714",
          "715",
          "716",
          "717",
          "718",
          "719",
          "720",
          "724",
          "727",
          "731",
          "732",
          "734",
          "737",
          "740",
          "754",
          "757",
          "760",
          "763",
          "765",
          "770",
          "772",
          "773",
          "774",
          "775",
          "781",
          "785",
          "786",
          "801",
          "802",
          "803",
          "804",
          "805",
          "806",
          "808",
          "810",
          "812",
          "813",
          "814",
          "815",
          "816",
          "817",
          "818",
          "828",
          "830",
          "831",
          "832",
          "835",
          "843",
          "845",
          "847",
          "848",
          "850",
          "856",
          "857",
          "858",
          "859",
          "860",
          "862",
          "863",
          "864",
          "865",
          "870",
          "872",
          "878",
          "901",
          "903",
          "904",
          "906",
          "907",
          "908",
          "909",
          "910",
          "912",
          "913",
          "914",
          "915",
          "916",
          "917",
          "918",
          "919",
          "920",
          "925",
          "928",
          "931",
          "936",
          "937",
          "940",
          "941",
          "947",
          "949",
          "952",
          "954",
          "956",
          "959",
          "970",
          "971",
          "972",
          "973",
          "975",
          "978",
          "979",
          "980",
          "984",
          "985",
          "989"
        ],
        "extension": [
          "####"
        ],
        "formats": [
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "1-#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "1-#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "1-#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "1-#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "1-#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}"
        ],
        "subscriber_number": [
          "####"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %I:%M:%S %p %Z",
        "long": "%B %d, %Y %I:%M %p",
        "short": "%d %b %I:%M %p"
      },
      "pm": "pm"
    }
  },
  "en-CY": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-GB": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Confirmation sent at",
          "confirmation_token": "Confirmation token",
          "confirmed_at": "Confirmed at",
          "created_at": "Created at",
          "current_password": "Current password",
          "current_sign_in_at": "Current sign in at",
          "current_sign_in_ip": "Current sign in IP",
          "email": "Email",
          "encrypted_password": "Encrypted password",
          "failed_attempts": "Failed attempts",
          "last_sign_in_at": "Last sign in at",
          "last_sign_in_ip": "Last sign in IP",
          "locked_at": "Locked at",
          "password": "Password",
          "password_confirmation": "Password confirmation",
          "remember_created_at": "Remember created at",
          "remember_me": "Remember me",
          "reset_password_sent_at": "Reset password sent at",
          "reset_password_token": "Reset password token",
          "sign_in_count": "Sign in count",
          "unconfirmed_email": "Unconfirmed email",
          "unlock_token": "Unlock token",
          "updated_at": "Updated at"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      },
      "models": {
        "user": {
          "one": "User",
          "other": "Users"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Your account was successfully confirmed.",
        "new": {
          "resend_confirmation_instructions": "Resend confirmation instructions"
        },
        "send_instructions": "You will receive an email with instructions about how to confirm your account in a few minutes.",
        "send_paranoid_instructions": "If your email exists on our database, you will receive an email with instructions about how to confirm your account in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account was not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "last_attempt": "You have one more attempt before your account will be locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired, please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your account before continuing."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirm my account",
          "greeting": "Welcome %{recipient}!",
          "instruction": "You can confirm your account email through the link below:",
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your email has been changed to %{email}.",
          "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
          "subject": "Email Changed"
        },
        "password_change": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your password has been changed.",
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "action": "Change my password",
          "greeting": "Hello %{recipient}!",
          "instruction": "Someone has requested a link to change your password, and you can do this through the link below.",
          "instruction_2": "If you didn't request this, please ignore this email.",
          "instruction_3": "Your password won't change until you access the link above and create a new one.\n",
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "action": "Unlock my account",
          "greeting": "Hello %{recipient}!",
          "instruction": "Click the link below to unlock your account:",
          "message": "Your account has been locked due to an excessive amount of unsuccessful sign in attempts.",
          "subject": "Unlock Instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Change my password",
          "change_your_password": "Change your password",
          "confirm_new_password": "Confirm new password",
          "new_password": "New password"
        },
        "new": {
          "forgot_your_password": "Forgotten your password?",
          "send_me_reset_password_instructions": "Send me reset password instructions"
        },
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions about how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email exists on our database, you will receive a password recovery link on your email",
        "updated": "Your password was changed successfully. You are now signed in.",
        "updated_not_active": "Your password was changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account was successfully cancelled. We hope to see you again soon.",
        "edit": {
          "are_you_sure": "Are you sure?",
          "cancel_my_account": "Cancel my account",
          "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
          "title": "Edit %{resource}",
          "unhappy": "Unhappy?",
          "update": "Update",
          "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
        },
        "new": {
          "sign_up": "Sign up"
        },
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please open the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and click on the confirm link to finalise confirming your new email address.",
        "updated": "You updated your account successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "new": {
          "sign_in": "Sign in"
        },
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "shared": {
        "links": {
          "back": "Back",
          "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
          "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
          "forgot_your_password": "Forgotten your password?",
          "sign_in": "Sign in",
          "sign_in_with_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        },
        "minimum_password_length": {
          "one": "(%{count} character minimum)",
          "other": "(%{count} characters minimum)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Resend unlock instructions"
        },
        "send_instructions": "You will receive an email with instructions about how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions about how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "faker": {
      "address": {
        "county": [
          "Avon",
          "Bedfordshire",
          "Berkshire",
          "Borders",
          "Buckinghamshire",
          "Cambridgeshire",
          "Central",
          "Cheshire",
          "Cleveland",
          "Clwyd",
          "Cornwall",
          "County Antrim",
          "County Armagh",
          "County Down",
          "County Fermanagh",
          "County Londonderry",
          "County Tyrone",
          "Cumbria",
          "Derbyshire",
          "Devon",
          "Dorset",
          "Dumfries and Galloway",
          "Durham",
          "Dyfed",
          "East Sussex",
          "Essex",
          "Fife",
          "Gloucestershire",
          "Grampian",
          "Greater Manchester",
          "Gwent",
          "Gwynedd County",
          "Hampshire",
          "Herefordshire",
          "Hertfordshire",
          "Highlands and Islands",
          "Humberside",
          "Isle of Wight",
          "Kent",
          "Lancashire",
          "Leicestershire",
          "Lincolnshire",
          "Lothian",
          "Merseyside",
          "Mid Glamorgan",
          "Norfolk",
          "North Yorkshire",
          "Northamptonshire",
          "Northumberland",
          "Nottinghamshire",
          "Oxfordshire",
          "Powys",
          "Rutland",
          "Shropshire",
          "Somerset",
          "South Glamorgan",
          "South Yorkshire",
          "Staffordshire",
          "Strathclyde",
          "Suffolk",
          "Surrey",
          "Tayside",
          "Tyne and Wear",
          "Warwickshire",
          "West Glamorgan",
          "West Midlands",
          "West Sussex",
          "West Yorkshire",
          "Wiltshire",
          "Worcestershire"
        ],
        "default_country": [
          "England",
          "Scotland",
          "Wales",
          "Northern Ireland"
        ],
        "default_country_code": [
          "GB"
        ],
        "postcode": "/[A-PR-UWYZ]([A-HK-Y][0-9][ABEHMNPRVWXY0-9]?|[0-9][ABCDEFGHJKPSTUW0-9]?) [0-9][ABD-HJLNP-UW-Z]{2}/",
        "uk_country": [
          "England",
          "Scotland",
          "Wales",
          "Northern Ireland"
        ]
      },
      "cell_phone": {
        "formats": [
          "071## ######",
          "073## ######",
          "074## ######",
          "075## ######",
          "077## ######",
          "078## ######",
          "079## ######"
        ]
      },
      "internet": {
        "domain_suffix": [
          "co.uk",
          "com",
          "biz",
          "info",
          "name"
        ]
      },
      "phone_number": {
        "country_code": [
          "44"
        ],
        "formats": [
          "01#### #####",
          "01### ######",
          "01#1 ### ####",
          "011# ### ####",
          "02# #### ####",
          "03## ### ####",
          "055 #### ####",
          "056 #### ####",
          "0800 ### ####",
          "08## ### ####",
          "09## ### ####",
          "016977 ####",
          "01### #####",
          "0500 ######",
          "0800 ######"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "£"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-IE": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-IN": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-IND": {
    "faker": {
      "address": {
        "city": [
          "Adoni",
          "Agartala",
          "Agra",
          "Ahmedabad",
          "Ahmednagar",
          "Aizawl",
          "Ajmer",
          "Akola",
          "Alappuzha",
          "Aligarh",
          "Allahabad",
          "Alwar",
          "Amaravati",
          "Ambala",
          "Ambarnath",
          "Ambattur",
          "Amravati",
          "Amritsar",
          "Amroha",
          "Anand",
          "Anantapur",
          "Arrah",
          "Asansol",
          "Aurangabad",
          "Aurangabad",
          "Avadi",
          "Bahraich",
          "Bally",
          "Bangalore",
          "Baranagar",
          "Barasat",
          "Bardhaman",
          "Bareilly",
          "Bathinda",
          "Begusarai",
          "Belgaum",
          "Bellary",
          "Berhampore",
          "Berhampur",
          "Bettiah",
          "Bhagalpur",
          "Bhalswa Jahangir Pur",
          "Bharatpur",
          "Bhatpara",
          "Bhavnagar",
          "Bhilai",
          "Bhilwara",
          "Bhimavaram",
          "Bhind",
          "Bhiwandi",
          "Bhiwani",
          "Bhopal",
          "Bhubaneswar",
          "Bhusawal",
          "Bidar",
          "Bidhannagar",
          "Bihar Sharif",
          "Bijapur",
          "Bikaner",
          "Bilaspur",
          "Bokaro",
          "Bulandshahr",
          "Burhanpur",
          "Buxar",
          "Chandigarh",
          "Chandrapur",
          "Chapra",
          "Chennai",
          "Chinsurah",
          "Chittoor",
          "Coimbatore",
          "Cuttack",
          "Danapur",
          "Darbhanga",
          "Davanagere",
          "Dehradun",
          "Dehri",
          "Delhi",
          "Deoghar",
          "Dewas",
          "Dhanbad",
          "Dharmavaram",
          "Dhule",
          "Dindigul",
          "Durg",
          "Durgapur",
          "Eluru",
          "Erode",
          "Etawah",
          "Faridabad",
          "Farrukhabad",
          "Fatehpur",
          "Firozabad",
          "Gandhidham",
          "Gandhinagar",
          "Gangtok",
          "Gaya",
          "Ghaziabad",
          "Gopalpur",
          "Gorakhpur",
          "Gudivada",
          "Gulbarga",
          "Guna",
          "Guntakal",
          "Guntur",
          "Gurgaon",
          "Guwahati",
          "Gwalior",
          "Hajipur",
          "Haldia",
          "Hapur",
          "Haridwar",
          "Hindupur",
          "Hospet",
          "Howrah",
          "Hubli–Dharwad",
          "Hyderabad",
          "Ichalkaranji",
          "Imphal",
          "Indore",
          "Jabalpur",
          "Jaipur",
          "Jalandhar",
          "Jalgaon",
          "Jalna",
          "Jamalpur",
          "Jammu",
          "Jamnagar",
          "Jamshedpur",
          "Jaunpur",
          "Jehanabad",
          "Jhansi",
          "Jodhpur",
          "Junagadh",
          "Kadapa",
          "Kakinada",
          "Kalyan-Dombivli",
          "Kamarhati",
          "Kanpur",
          "Karaikudi",
          "Karawal Nagar",
          "Karimnagar",
          "Karnal",
          "Katihar",
          "Katni",
          "Kavali",
          "Khammam",
          "Khandwa",
          "Kharagpur",
          "Kirari Suleman Nagar",
          "Kishanganj",
          "Kochi",
          "Kolhapur",
          "Kolkata",
          "Kollam",
          "Korba",
          "Kota",
          "Kottayam",
          "Kozhikode",
          "Kulti",
          "Kumbakonam",
          "Kurnool",
          "Latur",
          "Loni",
          "Lucknow",
          "Ludhiana",
          "Machilipatnam",
          "Madanapalle",
          "Madhyamgram",
          "Madurai",
          "Mahaboobnagar",
          "Maheshtala",
          "Malda",
          "Malegaon",
          "Mangalore",
          "Mango",
          "Mathura",
          "Mau",
          "Meerut",
          "Mehsana",
          "Mira-Bhayandar",
          "Miryalaguda",
          "Mirzapur",
          "Morbi",
          "Morena",
          "Motihari",
          "Mumbai",
          "Munger",
          "Muzaffarnagar",
          "Muzaffarpur",
          "Mysore",
          "Nadiad",
          "Nagercoil",
          "Nagpur",
          "Naihati",
          "Nanded",
          "Nandyal",
          "Nangloi Jat",
          "Narasaraopet",
          "Nashik",
          "Navi Mumbai",
          "Nellore",
          "New Delhi",
          "Nizamabad",
          "Noida",
          "North Dumdum",
          "Ongole",
          "Orai",
          "Ozhukarai",
          "Pali",
          "Pallavaram",
          "Panchkula",
          "Panihati",
          "Panipat",
          "Panvel",
          "Parbhani",
          "Patiala",
          "Patna",
          "Phagwara",
          "Pimpri-Chinchwad",
          "Pondicherry",
          "Proddatur",
          "Pune",
          "Purnia",
          "Raebareli",
          "Raichur",
          "Raiganj",
          "Raipur",
          "Rajahmundry",
          "Rajkot",
          "Rajpur Sonarpur",
          "Ramagundam",
          "Rampur",
          "Ranchi",
          "Ratlam",
          "Raurkela Industrial Township",
          "Rewa",
          "Rohtak",
          "Rourkela",
          "Sagar",
          "Saharanpur",
          "Saharsa",
          "Salem",
          "Sambalpur",
          "Sambhal",
          "Sangli-Miraj & Kupwad",
          "Sasaram",
          "Satara",
          "Satna",
          "Secunderabad",
          "Serampore",
          "Shahjahanpur",
          "Shimla",
          "Shimoga",
          "Shivpuri",
          "Sikar",
          "Siliguri",
          "Singrauli",
          "Sirsa",
          "Siwan",
          "Solapur",
          "Sonipat",
          "South Dumdum",
          "Sri Ganganagar",
          "Srikakulam",
          "Srinagar",
          "Sultan Pur Majra",
          "Surat",
          "Surendranagar Dudhrej",
          "Suryapet",
          "Tadepalligudem",
          "Tadipatri",
          "Tenali",
          "Thane",
          "Thanjavur",
          "Thiruvananthapuram",
          "Thoothukudi",
          "Thrissur",
          "Tiruchirappalli",
          "Tirunelveli",
          "Tirupati",
          "Tiruppur",
          "Tiruvottiyur",
          "Tumkur",
          "Udaipur",
          "Udupi",
          "Ujjain",
          "Ulhasnagar",
          "Uluberia",
          "Unnao",
          "Vadodara",
          "Varanasi",
          "Vasai-Virar",
          "Vellore",
          "Vijayanagaram",
          "Vijayawada",
          "Visakhapatnam",
          "Warangal",
          "Yamunanagar"
        ],
        "default_country": [
          "India",
          "Indian Republic",
          "Bharat",
          "Hindustan"
        ],
        "default_country_code": [
          "IN"
        ],
        "default_time_zone": [
          "Asia/Kolkata"
        ],
        "postcode": [
          "######"
        ],
        "state": [
          "Andhra Pradesh",
          "Arunachal Pradesh",
          "Assam",
          "Bihar",
          "Chhattisgarh",
          "Goa",
          "Gujarat",
          "Haryana",
          "Himachal Pradesh",
          "Jammu and Kashmir",
          "Jharkhand",
          "Karnataka",
          "Kerala",
          "Madya Pradesh",
          "Maharashtra",
          "Manipur",
          "Meghalaya",
          "Mizoram",
          "Nagaland",
          "Orissa",
          "Punjab",
          "Rajasthan",
          "Sikkim",
          "Tamil Nadu",
          "Tripura",
          "Uttaranchal",
          "Uttar Pradesh",
          "West Bengal",
          "Andaman and Nicobar Islands",
          "Chandigarh",
          "Dadar and Nagar Haveli",
          "Daman and Diu",
          "Delhi",
          "Lakshadweep",
          "Pondicherry"
        ],
        "state_abbr": [
          "AP",
          "AR",
          "AS",
          "BR",
          "CG",
          "DL",
          "GA",
          "GJ",
          "HR",
          "HP",
          "JK",
          "JS",
          "KA",
          "KL",
          "MP",
          "MH",
          "MN",
          "ML",
          "MZ",
          "NL",
          "OR",
          "PB",
          "RJ",
          "SK",
          "TN",
          "TR",
          "UK",
          "UP",
          "WB",
          "AN",
          "CH",
          "DN",
          "DD",
          "LD",
          "PY"
        ]
      },
      "company": {
        "suffix": [
          "Pvt Ltd",
          "Limited",
          "Ltd",
          "and Sons",
          "Corp",
          "Group",
          "Brothers"
        ]
      },
      "internet": {
        "domain_suffix": [
          "in",
          "com",
          "biz",
          "info",
          "name",
          "net",
          "org",
          "co.in"
        ]
      },
      "name": {
        "first_name": [
          "Aadrika",
          "Aanandinii",
          "Aaratrika",
          "Aarya",
          "Arya",
          "Aashritha",
          "Aatmaja",
          "Atmaja",
          "Abhaya",
          "Adwitiya",
          "Agrata",
          "Ahilya",
          "Ahalya",
          "Aishani",
          "Akshainie",
          "Akshata",
          "Akshita",
          "Akula",
          "Ambar",
          "Amodini",
          "Amrita",
          "Amritambu",
          "Anala",
          "Anamika",
          "Ananda",
          "Anandamayi",
          "Ananta",
          "Anila",
          "Anjali",
          "Anjushri",
          "Anjushree",
          "Annapurna",
          "Anshula",
          "Anuja",
          "Anusuya",
          "Anasuya",
          "Anasooya",
          "Anwesha",
          "Apsara",
          "Aruna",
          "Asha",
          "Aasa",
          "Aasha",
          "Aslesha",
          "Atreyi",
          "Atreyee",
          "Avani",
          "Abani",
          "Avantika",
          "Ayushmati",
          "Baidehi",
          "Vaidehi",
          "Bala",
          "Baala",
          "Balamani",
          "Basanti",
          "Vasanti",
          "Bela",
          "Bhadra",
          "Bhagirathi",
          "Bhagwanti",
          "Bhagwati",
          "Bhamini",
          "Bhanumati",
          "Bhaanumati",
          "Bhargavi",
          "Bhavani",
          "Bhilangana",
          "Bilwa",
          "Bilva",
          "Buddhana",
          "Chakrika",
          "Chanda",
          "Chandi",
          "Chandni",
          "Chandini",
          "Chandani",
          "Chandra",
          "Chandira",
          "Chandrabhaga",
          "Chandrakala",
          "Chandrakin",
          "Chandramani",
          "Chandrani",
          "Chandraprabha",
          "Chandraswaroopa",
          "Chandravati",
          "Chapala",
          "Charumati",
          "Charvi",
          "Chatura",
          "Chitrali",
          "Chitramala",
          "Chitrangada",
          "Daksha",
          "Dakshayani",
          "Damayanti",
          "Darshwana",
          "Deepali",
          "Dipali",
          "Deeptimoyee",
          "Deeptimayee",
          "Devangana",
          "Devani",
          "Devasree",
          "Devi",
          "Daevi",
          "Devika",
          "Daevika",
          "Dhaanyalakshmi",
          "Dhanalakshmi",
          "Dhana",
          "Dhanadeepa",
          "Dhara",
          "Dharani",
          "Dharitri",
          "Dhatri",
          "Diksha",
          "Deeksha",
          "Divya",
          "Draupadi",
          "Dulari",
          "Durga",
          "Durgeshwari",
          "Ekaparnika",
          "Elakshi",
          "Enakshi",
          "Esha",
          "Eshana",
          "Eshita",
          "Gautami",
          "Gayatri",
          "Geeta",
          "Geetanjali",
          "Gitanjali",
          "Gemine",
          "Gemini",
          "Girja",
          "Girija",
          "Gita",
          "Hamsini",
          "Harinakshi",
          "Harita",
          "Heema",
          "Himadri",
          "Himani",
          "Hiranya",
          "Indira",
          "Jaimini",
          "Jaya",
          "Jyoti",
          "Jyotsana",
          "Kali",
          "Kalinda",
          "Kalpana",
          "Kalyani",
          "Kama",
          "Kamala",
          "Kamla",
          "Kanchan",
          "Kanishka",
          "Kanti",
          "Kashyapi",
          "Kumari",
          "Kumuda",
          "Lakshmi",
          "Laxmi",
          "Lalita",
          "Lavanya",
          "Leela",
          "Lila",
          "Leela",
          "Madhuri",
          "Malti",
          "Malati",
          "Mandakini",
          "Mandaakin",
          "Mangala",
          "Mangalya",
          "Mani",
          "Manisha",
          "Manjusha",
          "Meena",
          "Mina",
          "Meenakshi",
          "Minakshi",
          "Menka",
          "Menaka",
          "Mohana",
          "Mohini",
          "Nalini",
          "Nikita",
          "Ojaswini",
          "Omana",
          "Oormila",
          "Urmila",
          "Opalina",
          "Opaline",
          "Padma",
          "Parvati",
          "Poornima",
          "Purnima",
          "Pramila",
          "Prasanna",
          "Preity",
          "Prema",
          "Priya",
          "Priyala",
          "Pushti",
          "Radha",
          "Rageswari",
          "Rageshwari",
          "Rajinder",
          "Ramaa",
          "Rati",
          "Rita",
          "Rohana",
          "Rukhmani",
          "Rukmin",
          "Rupinder",
          "Sanya",
          "Sarada",
          "Sharda",
          "Sarala",
          "Sarla",
          "Saraswati",
          "Sarisha",
          "Saroja",
          "Shakti",
          "Shakuntala",
          "Shanti",
          "Sharmila",
          "Shashi",
          "Shashikala",
          "Sheela",
          "Shivakari",
          "Shobhana",
          "Shresth",
          "Shresthi",
          "Shreya",
          "Shreyashi",
          "Shridevi",
          "Shrishti",
          "Shubha",
          "Shubhaprada",
          "Siddhi",
          "Sitara",
          "Sloka",
          "Smita",
          "Smriti",
          "Soma",
          "Subhashini",
          "Subhasini",
          "Sucheta",
          "Sudeva",
          "Sujata",
          "Sukanya",
          "Suma",
          "Suma",
          "Sumitra",
          "Sunita",
          "Suryakantam",
          "Sushma",
          "Swara",
          "Swarnalata",
          "Sweta",
          "Shwet",
          "Tanirika",
          "Tanushree",
          "Tanushri",
          "Tanushri",
          "Tanya",
          "Tara",
          "Trisha",
          "Uma",
          "Usha",
          "Vaijayanti",
          "Vaijayanthi",
          "Baijayanti",
          "Vaishvi",
          "Vaishnavi",
          "Vaishno",
          "Varalakshmi",
          "Vasudha",
          "Vasundhara",
          "Veda",
          "Vedanshi",
          "Vidya",
          "Vimala",
          "Vrinda",
          "Vrund",
          "Aadi",
          "Aadidev",
          "Aadinath",
          "Aaditya",
          "Aagam",
          "Aagney",
          "Aamod",
          "Aanandaswarup",
          "Anand Swarup",
          "Aanjaneya",
          "Anjaneya",
          "Aaryan",
          "Aryan",
          "Aatmaj",
          "Aatreya",
          "Aayushmaan",
          "Aayushman",
          "Abhaidev",
          "Abhaya",
          "Abhirath",
          "Abhisyanta",
          "Acaryatanaya",
          "Achalesvara",
          "Acharyanandana",
          "Acharyasuta",
          "Achintya",
          "Achyut",
          "Adheesh",
          "Adhiraj",
          "Adhrit",
          "Adikavi",
          "Adinath",
          "Aditeya",
          "Aditya",
          "Adityanandan",
          "Adityanandana",
          "Adripathi",
          "Advaya",
          "Agasti",
          "Agastya",
          "Agneya",
          "Aagneya",
          "Agnimitra",
          "Agniprava",
          "Agnivesh",
          "Agrata",
          "Ajit",
          "Ajeet",
          "Akroor",
          "Akshaj",
          "Akshat",
          "Akshayakeerti",
          "Alok",
          "Aalok",
          "Amaranaath",
          "Amarnath",
          "Amaresh",
          "Ambar",
          "Ameyatma",
          "Amish",
          "Amogh",
          "Amrit",
          "Anaadi",
          "Anagh",
          "Anal",
          "Anand",
          "Aanand",
          "Anang",
          "Anil",
          "Anilaabh",
          "Anilabh",
          "Anish",
          "Ankal",
          "Anunay",
          "Anurag",
          "Anuraag",
          "Archan",
          "Arindam",
          "Arjun",
          "Arnesh",
          "Arun",
          "Ashlesh",
          "Ashok",
          "Atmanand",
          "Atmananda",
          "Avadhesh",
          "Baalaaditya",
          "Baladitya",
          "Baalagopaal",
          "Balgopal",
          "Balagopal",
          "Bahula",
          "Bakula",
          "Bala",
          "Balaaditya",
          "Balachandra",
          "Balagovind",
          "Bandhu",
          "Bandhul",
          "Bankim",
          "Bankimchandra",
          "Bhadrak",
          "Bhadraksh",
          "Bhadran",
          "Bhagavaan",
          "Bhagvan",
          "Bharadwaj",
          "Bhardwaj",
          "Bharat",
          "Bhargava",
          "Bhasvan",
          "Bhaasvan",
          "Bhaswar",
          "Bhaaswar",
          "Bhaumik",
          "Bhaves",
          "Bheeshma",
          "Bhisham",
          "Bhishma",
          "Bhima",
          "Bhoj",
          "Bhramar",
          "Bhudev",
          "Bhudeva",
          "Bhupati",
          "Bhoopati",
          "Bhoopat",
          "Bhupen",
          "Bhushan",
          "Bhooshan",
          "Bhushit",
          "Bhooshit",
          "Bhuvanesh",
          "Bhuvaneshwar",
          "Bilva",
          "Bodhan",
          "Brahma",
          "Brahmabrata",
          "Brahmanandam",
          "Brahmaanand",
          "Brahmdev",
          "Brajendra",
          "Brajesh",
          "Brijesh",
          "Birjesh",
          "Budhil",
          "Chakor",
          "Chakradhar",
          "Chakravartee",
          "Chakravarti",
          "Chanakya",
          "Chaanakya",
          "Chandak",
          "Chandan",
          "Chandra",
          "Chandraayan",
          "Chandrabhan",
          "Chandradev",
          "Chandraketu",
          "Chandramauli",
          "Chandramohan",
          "Chandran",
          "Chandranath",
          "Chapal",
          "Charak",
          "Charuchandra",
          "Chaaruchandra",
          "Charuvrat",
          "Chatur",
          "Chaturaanan",
          "Chaturbhuj",
          "Chetan",
          "Chaten",
          "Chaitan",
          "Chetanaanand",
          "Chidaakaash",
          "Chidaatma",
          "Chidambar",
          "Chidambaram",
          "Chidananda",
          "Chinmayanand",
          "Chinmayananda",
          "Chiranjeev",
          "Chiranjeeve",
          "Chitraksh",
          "Daiwik",
          "Daksha",
          "Damodara",
          "Dandak",
          "Dandapaani",
          "Darshan",
          "Datta",
          "Dayaamay",
          "Dayamayee",
          "Dayaananda",
          "Dayaanidhi",
          "Kin",
          "Deenabandhu",
          "Deepan",
          "Deepankar",
          "Dipankar",
          "Deependra",
          "Dipendra",
          "Deepesh",
          "Dipesh",
          "Deeptanshu",
          "Deeptendu",
          "Diptendu",
          "Deeptiman",
          "Deeptimoy",
          "Deeptimay",
          "Dev",
          "Deb",
          "Devadatt",
          "Devagya",
          "Devajyoti",
          "Devak",
          "Devdan",
          "Deven",
          "Devesh",
          "Deveshwar",
          "Devi",
          "Devvrat",
          "Dhananjay",
          "Dhanapati",
          "Dhanpati",
          "Dhanesh",
          "Dhanu",
          "Dhanvin",
          "Dharmaketu",
          "Dhruv",
          "Dhyanesh",
          "Dhyaneshwar",
          "Digambar",
          "Digambara",
          "Dinakar",
          "Dinkar",
          "Dinesh",
          "Divaakar",
          "Divakar",
          "Deevakar",
          "Divjot",
          "Dron",
          "Drona",
          "Dwaipayan",
          "Dwaipayana",
          "Eekalabya",
          "Ekalavya",
          "Ekaksh",
          "Ekaaksh",
          "Ekaling",
          "Ekdant",
          "Ekadant",
          "Gajaadhar",
          "Gajadhar",
          "Gajbaahu",
          "Gajabahu",
          "Ganak",
          "Ganaka",
          "Ganapati",
          "Gandharv",
          "Gandharva",
          "Ganesh",
          "Gangesh",
          "Garud",
          "Garuda",
          "Gati",
          "Gatik",
          "Gaurang",
          "Gauraang",
          "Gauranga",
          "Gouranga",
          "Gautam",
          "Gautama",
          "Goutam",
          "Ghanaanand",
          "Ghanshyam",
          "Ghanashyam",
          "Giri",
          "Girik",
          "Girika",
          "Girindra",
          "Giriraaj",
          "Giriraj",
          "Girish",
          "Gopal",
          "Gopaal",
          "Gopi",
          "Gopee",
          "Gorakhnath",
          "Gorakhanatha",
          "Goswamee",
          "Goswami",
          "Gotum",
          "Gautam",
          "Govinda",
          "Gobinda",
          "Gudakesha",
          "Gudakesa",
          "Gurdev",
          "Guru",
          "Hari",
          "Harinarayan",
          "Harit",
          "Himadri",
          "Hiranmay",
          "Hiranmaya",
          "Hiranya",
          "Inder",
          "Indra",
          "Indra",
          "Jagadish",
          "Jagadisha",
          "Jagathi",
          "Jagdeep",
          "Jagdish",
          "Jagmeet",
          "Jahnu",
          "Jai",
          "Javas",
          "Jay",
          "Jitendra",
          "Jitender",
          "Jyotis",
          "Kailash",
          "Kama",
          "Kamalesh",
          "Kamlesh",
          "Kanak",
          "Kanaka",
          "Kannan",
          "Kannen",
          "Karan",
          "Karthik",
          "Kartik",
          "Karunanidhi",
          "Kashyap",
          "Kiran",
          "Kirti",
          "Keerti",
          "Krishna",
          "Krishnadas",
          "Krishnadasa",
          "Kumar",
          "Lai",
          "Lakshman",
          "Laxman",
          "Lakshmidhar",
          "Lakshminath",
          "Lal",
          "Laal",
          "Mahendra",
          "Mohinder",
          "Mahesh",
          "Maheswar",
          "Mani",
          "Manik",
          "Manikya",
          "Manoj",
          "Marut",
          "Mayoor",
          "Meghnad",
          "Meghnath",
          "Mohan",
          "Mukesh",
          "Mukul",
          "Nagabhushanam",
          "Nanda",
          "Narayan",
          "Narendra",
          "Narinder",
          "Naveen",
          "Navin",
          "Nawal",
          "Naval",
          "Nimit",
          "Niranjan",
          "Nirbhay",
          "Niro",
          "Param",
          "Paramartha",
          "Pran",
          "Pranay",
          "Prasad",
          "Prathamesh",
          "Prayag",
          "Prem",
          "Puneet",
          "Purushottam",
          "Rahul",
          "Raj",
          "Rajan",
          "Rajendra",
          "Rajinder",
          "Rajiv",
          "Rakesh",
          "Ramesh",
          "Rameshwar",
          "Ranjit",
          "Ranjeet",
          "Ravi",
          "Ritesh",
          "Rohan",
          "Rohit",
          "Rudra",
          "Sachin",
          "Sameer",
          "Samir",
          "Sanjay",
          "Sanka",
          "Sarvin",
          "Satish",
          "Satyen",
          "Shankar",
          "Shantanu",
          "Shashi",
          "Sher",
          "Shiv",
          "Siddarth",
          "Siddhran",
          "Som",
          "Somu",
          "Somnath",
          "Subhash",
          "Subodh",
          "Suman",
          "Suresh",
          "Surya",
          "Suryakant",
          "Suryakanta",
          "Sushil",
          "Susheel",
          "Swami",
          "Swapnil",
          "Tapan",
          "Tara",
          "Tarun",
          "Tej",
          "Tejas",
          "Trilochan",
          "Trilochana",
          "Trilok",
          "Trilokesh",
          "Triloki",
          "Triloki Nath",
          "Trilokanath",
          "Tushar",
          "Udai",
          "Udit",
          "Ujjawal",
          "Ujjwal",
          "Umang",
          "Upendra",
          "Uttam",
          "Vasudev",
          "Vasudeva",
          "Vedang",
          "Vedanga",
          "Vidhya",
          "Vidur",
          "Vidhur",
          "Vijay",
          "Vimal",
          "Vinay",
          "Vishnu",
          "Bishnu",
          "Vishwamitra",
          "Vyas",
          "Yogendra",
          "Yoginder",
          "Yogesh"
        ],
        "last_name": [
          "Abbott",
          "Achari",
          "Acharya",
          "Adiga",
          "Agarwal",
          "Ahluwalia",
          "Ahuja",
          "Arora",
          "Asan",
          "Bandopadhyay",
          "Banerjee",
          "Bharadwaj",
          "Bhat",
          "Butt",
          "Bhattacharya",
          "Bhattathiri",
          "Chaturvedi",
          "Chattopadhyay",
          "Chopra",
          "Desai",
          "Deshpande",
          "Devar",
          "Dhawan",
          "Dubashi",
          "Dutta",
          "Dwivedi",
          "Embranthiri",
          "Ganaka",
          "Gandhi",
          "Gill",
          "Gowda",
          "Guha",
          "Guneta",
          "Gupta",
          "Iyer",
          "Iyengar",
          "Jain",
          "Jha",
          "Johar",
          "Joshi",
          "Kakkar",
          "Kaniyar",
          "Kapoor",
          "Kaul",
          "Kaur",
          "Khan",
          "Khanna",
          "Khatri",
          "Kocchar",
          "Mahajan",
          "Malik",
          "Marar",
          "Menon",
          "Mehra",
          "Mehrotra",
          "Mishra",
          "Mukhopadhyay",
          "Nayar",
          "Naik",
          "Nair",
          "Nambeesan",
          "Namboothiri",
          "Nehru",
          "Pandey",
          "Panicker",
          "Patel",
          "Patil",
          "Pilla",
          "Pillai",
          "Pothuvaal",
          "Prajapat",
          "Rana",
          "Reddy",
          "Saini",
          "Sethi",
          "Shah",
          "Sharma",
          "Shukla",
          "Singh",
          "Sinha",
          "Somayaji",
          "Tagore",
          "Talwar",
          "Tandon",
          "Trivedi",
          "Varrier",
          "Varma",
          "Varman",
          "Verma"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "91"
        ],
        "formats": [
          "###-###-####",
          "##########",
          "###-#######"
        ]
      }
    }
  },
  "en-KE": {
    "faker": {
      "address": {
        "cities": [
          "Bungoma",
          "Busia",
          "El Wak",
          "Eldoret",
          "Emali",
          "Embu",
          "Gilgil",
          "Homa Bay",
          "Isiolo",
          "Juja",
          "Kakamega",
          "Karuri",
          "Kenol",
          "Kericho",
          "Kiambu",
          "Kikuyu",
          "Kilifi",
          "Kimilili",
          "Kiserian",
          "Kisii",
          "Kisumu",
          "Kitengela",
          "Limuru",
          "Lodwar",
          "Machakos",
          "Malindi",
          "Mandera",
          "Mavoko",
          "Meru",
          "Migori",
          "Mombasa",
          "Moyale",
          "Mtwapa",
          "Muranga",
          "Nairobi",
          "Naivasha",
          "Nakuru",
          "Nanyuki",
          "Narok",
          "Ngong",
          "Nyeri",
          "Ruiru",
          "Thika",
          "Ukunda",
          "Voi",
          "Wajir",
          "Wanguru",
          "Webuye"
        ],
        "city": [
          "#{cities}"
        ],
        "counties": [
          "Kiambu",
          "Siaya",
          "Bungoma",
          "Kericho",
          "Kilifi",
          "Kisumu",
          "Machakos",
          "Nakuru",
          "Kisii",
          "Busia",
          "Homa Bay",
          "Kajiado",
          "Kakamega",
          "Laikipia",
          "Migori",
          "Taita-Taveta",
          "Embu",
          "Kitui",
          "Meru",
          "Murang'a",
          "Nyamira",
          "Turkana",
          "Trans-Nzoia",
          "Uasin Gishu",
          "Vihiga",
          "Baringo",
          "Bomet",
          "Elgeyo-Marakwet",
          "Garissa",
          "Isiolo",
          "Kirinyaga",
          "Kwale",
          "Mandera",
          "Marsabit",
          "Mombasa",
          "Nairobi",
          "Nandi",
          "Narok",
          "Nyandarua",
          "Nyeri",
          "Samburu",
          "Tharaka-Nithi",
          "Wajir",
          "West Pokot"
        ],
        "county": [
          "#{counties}"
        ],
        "default_country": [
          "Republic of Kenya"
        ],
        "default_country_code": [
          "KE"
        ]
      },
      "cell_phone": {
        "formats": [
          "0711 ######",
          "0722 ######",
          "010# ######",
          "0730 ######",
          "0770 ######",
          "0771 ######",
          "0763 ######",
          "0764 ######"
        ]
      },
      "company": {
        "company_names": [
          "ABSA Kenya",
          "ARM Cement",
          "Africa Development Bank (AfDB)",
          "B.O.C Kenya",
          "Bamburi Cement",
          "Britam Holdings",
          "British American Tobacco Kenya",
          "CIC Insurance Group",
          "Car & General (K)",
          "Carbacid Investments",
          "Centum Investment",
          "Crown Paints Kenya",
          "Deacons (East Africa)",
          "Diamond Trust Bank Kenya",
          "E.A Cables",
          "E.A Portland Cement",
          "Eaagads",
          "East African Breweries",
          "Equity Group Holdings",
          "Eveready East Africa",
          "Express Kenya",
          "Flame Tree Group Holdings",
          "HF Group",
          "Home Afrika",
          "Homeboyz Entertainment",
          "I & M Holdings",
          "ILAM Fahari I-REIT",
          "Jubilee Holdings",
          "KCB Group",
          "Kakuzi",
          "Kapchorua Tea Kenya",
          "KenGen",
          "Kenya Airways",
          "Kenya Orchards",
          "Kenya Power & Lighting",
          "Kenya Re-Insurance Corporation",
          "Kurwitu Ventures",
          "Liberty Kenya Holdings",
          "Limuru Tea",
          "Longhorn Publishers",
          "Mumias Sugar",
          "NCBA Group",
          "Nairobi Business Ventures",
          "Nairobi Securities Exchange",
          "Nation Media Group",
          "Olympia Capital Holdings",
          "Safaricom",
          "Sameer Africa",
          "Sanlam Kenya",
          "Sasini",
          "Stanbic Holdings",
          "Standard Chartered Bank Kenya",
          "Standard Group",
          "TPS Eastern Africa (Serena)",
          "The Co-operative Bank of Kenya",
          "Total Kenya",
          "Trans-Century",
          "Uchumi Supermarket",
          "Umeme",
          "Unga Group",
          "WPP Scangroup",
          "Williamson Tea Kenya"
        ],
        "name": [
          "#{company_names}"
        ],
        "suffix": [
          "Co.",
          "Ltd",
          "Plc",
          "Trust"
        ]
      },
      "internet": {
        "domain_suffix": [
          "ke",
          "co.ke",
          "org.ke",
          "or.ke",
          "go.ke",
          "ac.ke",
          "info.ke"
        ]
      },
      "phone_number": {
        "area_code": [
          "20",
          "41",
          "51",
          "57"
        ],
        "country_code": [
          "254"
        ],
        "formats": [
          "### #######",
          "##########",
          "###-#######"
        ]
      }
    }
  },
  "en-MS": {
    "faker": {
      "address": {
        "building_number": [
          "##"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Subang Jaya",
          "Kuala Lumpur",
          "Johor Bahru",
          "Ipoh",
          "Klang",
          "Seberang Perai",
          "Ampang",
          "Georgetown",
          "Gombak",
          "Kuching",
          "Shah Alam",
          "Seremban",
          "Petaling Jaya",
          "Cheras",
          "Bandaraya Melaka",
          "Kota Bharu",
          "Kota Kinabalu",
          "Kuantan",
          "Sungai Petani",
          "Kajang",
          "Batu Pahat",
          "Tawau",
          "Sandakan",
          "Alor Setar",
          "Kuala Terengganu",
          "Taiping",
          "Miri",
          "Kluang",
          "Kulim",
          "Selayang",
          "Kulai",
          "Sibu",
          "Muar",
          "Manjung",
          "Perlis",
          "Kubang Pasu",
          "Sepang",
          "Teluk Intan",
          "Lahad Datu",
          "Kota Tinggi",
          "Segamat",
          "Pasir Mas",
          "Bintulu",
          "Alor Gajah",
          "Kerian",
          "Batang Padang",
          "Keningau",
          "Kemaman",
          "Temerloh",
          "Kuala Kangsar",
          "Pontian",
          "Dungun",
          "Tumpat",
          "Kinabatangan",
          "Besut",
          "Semporna",
          "Ledang",
          "Baling",
          "Jasin",
          "Bachok",
          "Papar",
          "Penampang",
          "Tanah Merah",
          "Bentong",
          "Pasir Puteh",
          "Jempol",
          "Maran",
          "Port Dickson",
          "Rompin",
          "Pekan",
          "Kuala Krai",
          "Beluran",
          "Sabak Bernam",
          "Tuaran",
          "Perak Tengah",
          "Bera",
          "Marang",
          "Ranau",
          "Raub",
          "Pendang",
          "Langkawi",
          "Kota Belud",
          "Machang",
          "Serian",
          "Hulu Perak",
          "Jerantut",
          "Gua Musang",
          "Lipis",
          "Samarahan",
          "Labuan",
          "Kudat",
          "Tampin",
          "Putrajaya",
          "Hulu Terengganu",
          "Mersing",
          "Yan",
          "Kota Marudu",
          "Sik",
          "Sri Aman",
          "Beaufort",
          "Kuala Pilah",
          "Marudi",
          "Kuala Nerang",
          "Kunak",
          "Betong",
          "Sarikei",
          "Tenom",
          "Kapit",
          "Putatan",
          "Setiu",
          "Bau",
          "Pokok Sena",
          "Limbang",
          "Saratok",
          "Rembau",
          "Mukah",
          "Bandar Baharu",
          "Jeli",
          "Simunjan",
          "Jelebu",
          "Pitas",
          "Cameron Highlands",
          "Lawas",
          "Tambunan",
          "Tongod",
          "Belaga",
          "Sipitang",
          "Lundu",
          "Nabawan",
          "Asajaya",
          "Daro",
          "Tatau",
          "Maradong",
          "Kanowit",
          "Lubok Antu",
          "Selangau",
          "Song",
          "Kuala Penyu",
          "Dalat",
          "Matu",
          "Julau",
          "Pakan",
          "Padawan",
          "Lojing",
          "Kampa",
          "Muallim"
        ],
        "default_country": [
          "Malaysia"
        ],
        "default_country_code": [
          "MY"
        ],
        "postcode": [
          "#####"
        ],
        "province": [
          "Johor",
          "Kedah",
          "Kelantan",
          "Melaka",
          "Negeri Sembilan",
          "Pahang",
          "Pulau Pinang",
          "Perak",
          "Perlis",
          "Selangor",
          "Terengganu",
          "Sabah",
          "Sarawak",
          "WP Kuala Lumpur",
          "WP Labuan",
          "WP Putrajaya"
        ],
        "street_address": [
          "No. #{building_number}, #{street_name}"
        ],
        "street_name": [
          "#{street_prefix} #{street_title}"
        ],
        "street_prefix": [
          "Jalan",
          "Lorong",
          "Pinggiran",
          "Medan",
          "Persiaran",
          "Selekoh",
          "Persisiran",
          "Perkarangan",
          "Pengkalan",
          "Lurah",
          "Lintang",
          "Lingkungan",
          "Lingkaran",
          "Lengkung",
          "Lengkok",
          "Lebuhraya",
          "Lebuh",
          "Langgak",
          "Laman",
          "Halaman",
          "Gerbang",
          "Dataran",
          "Bulatan",
          "Laluan"
        ],
        "street_title": [
          "Makmur",
          "Bukit Bintang",
          "Bangsar",
          "Chow Kit",
          "Hang Jebat",
          "Hang Tuah",
          "Kinabalu",
          "Kuching",
          "Maharajalela",
          "Masjid India",
          "Istana",
          "Pudu"
        ]
      },
      "bank": {
        "name": [
          "Affin Bank Berhad",
          "Agro Bank Berhad",
          "Alliance Bank Malaysia Berhad",
          "AmBank Berhad",
          "Bank Islam Berhad",
          "Bank Muamalat Berhad",
          "Bank Rakyat Berhad",
          "Bank Simpanan Nasional",
          "CIMB Bank Berhad",
          "Hong Leong Bank Berhad",
          "Malayan Banking Berhad",
          "Public Bank Berhad",
          "RHB Bank Berhad",
          "Tabung Haji"
        ]
      },
      "name": {
        "chinese_female_first_name": [
          "Xiu Yi",
          "Wai Teng",
          "Sing Yee",
          "Jing Yi",
          "Jia Yee",
          "Jia Xuan",
          "Shu En",
          "Pei Ying",
          "Pei Yu",
          "Pih Foung",
          "Li-ann",
          "Shi Xuan",
          "Yi Xuan",
          "Shu En",
          "Yi Xin",
          "Hui Juan",
          "Yu En",
          "Yihui",
          "Xin Yi",
          "Yun Xuan",
          "Xuan Xuan"
        ],
        "chinese_male_first_name": [
          "Jin Quan",
          "Wen Jun",
          "Jun Jie",
          "Cheng Han",
          "Tze-Kwang",
          "Jin Leong",
          "Zi Liang",
          "Zhi Ren",
          "Jin Quan",
          "Wen Jun",
          "Chee Hin",
          "Guo Jun",
          "Kai Jie",
          "Kun Qiang",
          "Jun Kiat",
          "Yong Zheng",
          "Yong Jun",
          "Chit Boon",
          "You Ren",
          "Wen Zhong",
          "Yang Shun",
          "Qi Guang",
          "Kang Soon",
          "Wee Heng",
          "Kah Yang",
          "Siew Beng",
          "Jia Woei",
          "Chean Meng",
          "Wai Kay",
          "Keng Hua",
          "Yew Meng",
          "Cheng Wen",
          "Jiun Wei",
          "Yee Sian",
          "Shao Hong",
          "Bin Shen",
          "Wing Yiu",
          "Ee Hong",
          "Yu Pyn",
          "Yong Sheng",
          "Jun Peng",
          "Jia Jie",
          "Guang Yi",
          "Si Heng",
          "Wei Hou",
          "Kang Sheng",
          "Hong Ern",
          "Jia Liang",
          "Wei Lip",
          "Wee Chen",
          "Wee Leng",
          "Yu Xi",
          "Ming Yang",
          "Wen Hao",
          "Siang Meng",
          "Mong Li",
          "Ghim Huat",
          "Jun Yi",
          "Jie Kai",
          "Zhiming",
          "Wei Jie",
          "Teng Qing",
          "Wei Jian",
          "Wei Kwan",
          "Chee Chin"
        ],
        "chinese_male_last_name": [
          "Tan",
          "Lim",
          "Lee",
          "Ng",
          "Ong",
          "Wong",
          "Goh",
          "Chua",
          "Chan",
          "Koh",
          "Teo",
          "Ang",
          "Yeo",
          "Tay",
          "Ho",
          "Low"
        ],
        "female_first_name": [
          "#{malay_female_first_name}",
          "#{chinese_female_first_name}"
        ],
        "first_name": [
          "#{malay_male_first_name}",
          "#{malay_female_first_name}",
          "#{chinese_male_first_name}",
          "#{chinese_female_first_name}"
        ],
        "malay_female_first_name": [
          "Siti",
          "Aminah",
          "Aiza",
          "Hajar",
          "Sofia",
          "Dahlia",
          "Akma",
          "Nur",
          "Sariha",
          "Syazana",
          "Nuratika",
          "Farah"
        ],
        "malay_male_first_name": [
          "Abu",
          "Ahmad",
          "Malik",
          "Osman",
          "Abdullah",
          "Abu Bakar",
          "Azuan",
          "Sulaiman",
          "Daud",
          "Azizi",
          "Jaafar"
        ],
        "male_first_name": [
          "#{malay_male_first_name}",
          "#{chinese_male_first_name}"
        ],
        "name": [
          "#{malay_male_first_name} bin #{malay_male_first_name}",
          "#{malay_female_first_name} binti #{malay_male_first_name}",
          "#{chinese_male_last_name} #{chinese_male_first_name}",
          "#{chinese_female_first_name} #{chinese_male_first_name}",
          "#{prefix} #{malay_male_first_name} bin #{malay_male_first_name}",
          "#{prefix} #{malay_female_first_name} binti #{malay_male_first_name}",
          "#{prefix} #{chinese_male_last_name} #{chinese_male_first_name}",
          "#{prefix} #{chinese_female_first_name} #{chinese_male_first_name}"
        ],
        "prefix": [
          "Dato",
          "Datin"
        ]
      },
      "phone_number": {
        "country_code": [
          "60"
        ],
        "formats": [
          "03#######",
          "01########"
        ]
      }
    }
  },
  "en-NEP": {
    "faker": {
      "address": {
        "city": [
          "Bhaktapur",
          "Biratnagar",
          "Birendranagar",
          "Birgunj",
          "Butwal",
          "Damak",
          "Dharan",
          "Gaur",
          "Gorkha",
          "Hetauda",
          "Itahari",
          "Janakpur",
          "Kathmandu",
          "Lahan",
          "Nepalgunj",
          "Pokhara"
        ],
        "default_country": [
          "Nepal"
        ],
        "default_country_code": [
          "NP"
        ],
        "default_time_zone": [
          "Asia/Kathmandu"
        ],
        "postcode": [
          "#####"
        ],
        "state": [
          "Baglung",
          "Banke",
          "Bara",
          "Bardiya",
          "Bhaktapur",
          "Bhojupu",
          "Chitwan",
          "Dailekh",
          "Dang",
          "Dhading",
          "Dhankuta",
          "Dhanusa",
          "Dolakha",
          "Dolpha",
          "Gorkha",
          "Gulmi",
          "Humla",
          "Ilam",
          "Jajarkot",
          "Jhapa",
          "Jumla",
          "Kabhrepalanchok",
          "Kalikot",
          "Kapilvastu",
          "Kaski",
          "Kathmandu",
          "Lalitpur",
          "Lamjung",
          "Manang",
          "Mohottari",
          "Morang",
          "Mugu",
          "Mustang",
          "Myagdi",
          "Nawalparasi",
          "Nuwakot",
          "Palpa",
          "Parbat",
          "Parsa",
          "Ramechhap",
          "Rauswa",
          "Rautahat",
          "Rolpa",
          "Rupandehi",
          "Sankhuwasabha",
          "Sarlahi",
          "Sindhuli",
          "Sindhupalchok",
          "Sunsari",
          "Surket",
          "Syangja",
          "Tanahu",
          "Terhathum"
        ]
      },
      "company": {
        "suffix": [
          "Pvt Ltd",
          "Group",
          "Ltd",
          "Limited"
        ]
      },
      "internet": {
        "domain_suffix": [
          "np",
          "com",
          "info",
          "net",
          "org"
        ]
      },
      "name": {
        "female_first_name": [
          "Gita",
          "Sita",
          "Sarita",
          "Kalpana",
          "Neha",
          "Griahma",
          "Sujata"
        ],
        "first_name": [
          "Aarav",
          "Ajita",
          "Amit",
          "Amita",
          "Amrit",
          "Arijit",
          "Ashmi",
          "Asmita",
          "Bibek",
          "Bijay",
          "Bikash",
          "Bina",
          "Bishal",
          "Bishnu",
          "Buddha",
          "Deepika",
          "Dipendra",
          "Gagan",
          "Ganesh",
          "Khem",
          "Krishna",
          "Laxmi",
          "Manisha",
          "Nabin",
          "Nikita",
          "Niraj",
          "Nischal",
          "Padam",
          "Pooja",
          "Prabin",
          "Prakash",
          "Prashant",
          "Prem",
          "Purna",
          "Rajendra",
          "Rajina",
          "Raju",
          "Rakesh",
          "Ranjan",
          "Ratna",
          "Sagar",
          "Sandeep",
          "Sanjay",
          "Santosh",
          "Sarita",
          "Shilpa",
          "Shirisha",
          "Shristi",
          "Siddhartha",
          "Subash",
          "Sumeet",
          "Sunita",
          "Suraj",
          "Susan",
          "Sushant"
        ],
        "last_name": [
          "Adhikari",
          "Aryal",
          "Baral",
          "Basnet",
          "Bastola",
          "Basynat",
          "Bhandari",
          "Bhattarai",
          "Chettri",
          "Devkota",
          "Dhakal",
          "Dongol",
          "Ghale",
          "Gurung",
          "Gyawali",
          "Hamal",
          "Jung",
          "KC",
          "Kafle",
          "Karki",
          "Khadka",
          "Koirala",
          "Lama",
          "Limbu",
          "Magar",
          "Maharjan",
          "Niroula",
          "Pandey",
          "Pradhan",
          "Rana",
          "Raut",
          "Sai",
          "Shai",
          "Shakya",
          "Sherpa",
          "Shrestha",
          "Subedi",
          "Tamang",
          "Thapa"
        ],
        "male_first_name": [
          "Kamal",
          "Gopal",
          "Hari",
          "Himal",
          "Baburam",
          "Prachanda",
          "Ganesh"
        ],
        "middle_name": [
          "Bahadur",
          "Prasad",
          "Lal"
        ],
        "name": [
          "#{male_first_name} #{last_name}",
          "#{male_first_name} #{middle_name} #{last_name}",
          "#{female_first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "977"
        ],
        "formats": [
          "##-#######",
          "#-#######",
          "########"
        ]
      }
    }
  },
  "en-NG": {
    "faker": {
      "address": {
        "cities": [
          "Aba",
          "Abakaliki",
          "Abeokuta",
          "Abuja",
          "Ado",
          "Ekiti",
          "Agege",
          "Akpawfu",
          "Akure",
          "Asaba",
          "Awka",
          "Bauchi",
          "Benin",
          "City",
          "Birnin",
          "Kebbi",
          "Buguma",
          "Calabar",
          "Dutse",
          "Eket",
          "Enugu",
          "Gombe",
          "Gusau",
          "Ibadan",
          "Ifelodun",
          "Ife",
          "Ikeja",
          "Ikirun",
          "Ikot-Abasi",
          "Ikot",
          "Ekpene",
          "Ilorin",
          "Iragbiji",
          "Jalingo",
          "Jimeta",
          "Jos",
          "Kaduna",
          "Kano",
          "Katsina",
          "Karu",
          "Kumariya",
          "Lafia",
          "Lagos",
          "Lekki",
          "Lokoja",
          "Maiduguri",
          "Makurdi",
          "Minna",
          "Nsukka",
          "Offa",
          "Ogbomoso",
          "Onitsha",
          "Okene",
          "Ogaminana",
          "Omu-Aran",
          "Oron",
          "Oshogbo",
          "Owerri",
          "Owo",
          "Orlu",
          "Oyo",
          "Port",
          "Harcourt",
          "Potiskum",
          "Sokoto",
          "Suleja",
          "Umuahia",
          "Uyo",
          "Warri",
          "Wukari",
          "Yenagoa",
          "Yola",
          "Zaria",
          "Ogbomosho",
          "Osogbo",
          "Iseyin",
          "Ilesa",
          "Ondo",
          "Damaturu",
          "Mubi",
          "Sagamu",
          "Ugep",
          "Ijebu",
          "Ode",
          "Ise",
          "Gboko",
          "Ilawe",
          "Ikare",
          "Bida",
          "Okpoko",
          "Sapele",
          "Ila",
          "Shaki",
          "Ijero",
          "Otukpo",
          "Kisi",
          "Funtua",
          "Gbongan",
          "Igboho",
          "Amaigbo",
          "Gashua",
          "Bama",
          "Uromi",
          "Okigwe",
          "Modakeke",
          "Ebute",
          "Ikorodu",
          "Effon",
          "Alaiye",
          "Ikot-Ekpene",
          "Iwo",
          "Ikire",
          "Shagamu",
          "Ijebu-Ode",
          "Nnewi",
          "Ise-Ekiti",
          "Orangun",
          "Saki",
          "Ijero-Ekiti",
          "Inisa",
          "Kishi",
          "Ejigbo",
          "Okrika",
          "Ilobu",
          "Okigwi",
          "Esuk",
          "Nguru",
          "Hadejia",
          "Ijebu-Igbo",
          "Pindiga",
          "Azare",
          "Nkpor",
          "Ikerre",
          "Lafiagi",
          "Kontagora",
          "Biu",
          "Olupona",
          "Lere",
          "Igbo",
          "Ora",
          "Emure-Ekiti",
          "Isieke",
          "Ifo",
          "Igede-Ekiti",
          "Effium",
          "Idanre",
          "Keffi",
          "Epe",
          "Gambaru",
          "Ogaminan",
          "Ihiala",
          "Ipoti",
          "Lalupon",
          "Ughelli",
          "Bende",
          "Oke",
          "Mesi",
          "Kafachan",
          "Ikom",
          "Agulu",
          "Daura",
          "Numan",
          "Kagoro",
          "Igbo-Ukwu",
          "Araomoko",
          "Igbara-Odo",
          "Ozubulu",
          "Aku",
          "Oyan",
          "Jega",
          "Ohafia-Ifigh",
          "Afikpo",
          "Apomu",
          "Fiditi",
          "Orita",
          "Eruwa",
          "Eha",
          "Amufu",
          "Malumfashi",
          "Kaura",
          "Namoda",
          "Enugu-Ukwu",
          "Idah",
          "Obonoma",
          "Agbor",
          "Ezza",
          "Ohu",
          "Uga",
          "Nkwerre",
          "Auchi",
          "Ekpoma",
          "Ijesha",
          "Kabba",
          "Ilaro",
          "Argungu",
          "Gumel",
          "Geidam",
          "Talata",
          "Mafara",
          "Gummi",
          "Ogoja",
          "Ala",
          "Itu",
          "Kumo",
          "Pankshin",
          "Nassarawa",
          "Kachia",
          "Dikwa",
          "Moriki",
          "Pategi",
          "Wamba",
          "Baro",
          "Okuta",
          "Kudu",
          "Badagry",
          "Ogwashi-Uku",
          "Kamba",
          "Takum",
          "Igbeti",
          "Zungeru",
          "Zuru",
          "Tegina",
          "Awgu",
          "Wudil",
          "Nafada",
          "Ibi",
          "Sofo-Birnin-Gwari",
          "Dutsen",
          "Wai",
          "Kaiama",
          "Ubiaja",
          "Otukpa",
          "Oguta",
          "Damboa",
          "Jebba",
          "Garko",
          "Mokwa",
          "Gaya",
          "Tambawel",
          "Elele",
          "Mongonu",
          "Kwale",
          "Gembu",
          "Obudu",
          "Little",
          "Gombi",
          "Magumeri",
          "Degema",
          "Hulk",
          "Enugu-Ezike",
          "Kari",
          "Darazo"
        ],
        "city": [
          "#{cities}"
        ],
        "default_country": [
          "Nigeria"
        ],
        "default_country_code": [
          "NG"
        ],
        "lga": [
          "Abadam",
          "Abaji",
          "Abak",
          "Abakaliki",
          "Aba North",
          "Aba South",
          "Abeokuta North",
          "Abeokuta South",
          "Afijio",
          "Afikpo North",
          "Afikpo South",
          "Agaie",
          "Agatu",
          "Agwara",
          "Agege",
          "Aguata",
          "Ahoada East",
          "Ahoada West",
          "Ajaokuta",
          "Ajeromi-Ifelodun",
          "Akoko-Edo",
          "Akoko North-East",
          "Akoko North-West",
          "Akoko South-West",
          "Akoko South-East",
          "Akuku-Toru",
          "Akure North",
          "Akure South",
          "Akwanga",
          "Albasu",
          "Alimosho",
          "Amuwo-Odofin",
          "Arewa Dandi",
          "Arochukwu",
          "Asari-Toru",
          "Atakunmosa East",
          "Atakunmosa West",
          "Awka North",
          "Awka South",
          "Bokkos",
          "Batagarawa",
          "Birnin Kebbi",
          "Calabar Municipal",
          "Calabar South",
          "Dange Shuni",
          "Ede North",
          "Ede South",
          "Ife Central",
          "Ife East",
          "Ife North",
          "Ife South",
          "Efon",
          "Egbado North",
          "Egbado South",
          "Enugu East",
          "Enugu North",
          "Enugu South",
          "Epe",
          "Gayuk",
          "Gwarzo",
          "Gwer East",
          "Gwer West",
          "Ibeju-Lekki",
          "Ibeno",
          "Idemili North",
          "Idemili South",
          "Igueben",
          "Ihiala",
          "Ikeja",
          "Ikenne",
          "Ikot Abasi",
          "Ikot Ekpene",
          "Sapele",
          "Sardauna",
          "Shendam",
          "Shinkafi",
          "Shomolu",
          "Surulere",
          "Ughelli North",
          "Ughelli South",
          "Ugwunagbo",
          "Uyo",
          "Wase",
          "Wudil",
          "Yala",
          "Yusufari"
        ],
        "region": [
          "South-West",
          "North-East",
          "South-South",
          "North-Central",
          "South-East",
          "North-West"
        ],
        "state": [
          "Abia",
          "Adamawa",
          "Anambra",
          "Akwa",
          "Ibom",
          "Bauchi",
          "Bayelsa",
          "Benue",
          "Borno",
          "Cross",
          "River",
          "Delta",
          "Ebonyi",
          "Enugu",
          "Edo",
          "Ekiti",
          "Gombe",
          "Imo",
          "Jigawa",
          "Kaduna",
          "Kano",
          "Katsina",
          "Kebbi",
          "Kogi",
          "Kwara",
          "Lagos",
          "Nasarawa",
          "Niger",
          "Ogun",
          "Ondo",
          "Osun",
          "Oyo",
          "Plateau",
          "Rivers",
          "Sokoto",
          "Taraba",
          "Yobe",
          "Zamfara",
          "Abuja"
        ],
        "street_suffix": [
          "Avenue",
          "Branch",
          "Bridge",
          "Bypass",
          "Road",
          "Drive",
          "Drive",
          "Drives",
          "Estate",
          "Estates",
          "Expressway",
          "Extension",
          "Falls",
          "Flat",
          "Flats",
          "Freeway",
          "Garden",
          "Gardens",
          "Gateway",
          "Harbor",
          "GRA",
          "Highway",
          "Island",
          "Island",
          "Junction",
          "Roundabout",
          "Toll Gate",
          "Lake",
          "Land",
          "Landing",
          "Industrial Layout",
          "Lane",
          "Lodge",
          "Lodge",
          "Mill",
          "Mills",
          "Mission",
          "Mission",
          "Motorway",
          "Overpass",
          "Park",
          "Parkway",
          "Pass",
          "Path",
          "Pike",
          "Mall",
          "Plaza",
          "Plaza",
          "Port",
          "Port",
          "Ranch",
          "River",
          "Road",
          "Road",
          "Roads",
          "Roads",
          "Route",
          "Square",
          "Square",
          "Station",
          "Station",
          "Street",
          "Street",
          "Streets",
          "Terrace",
          "Underpass",
          "Union",
          "Via",
          "Ville",
          "Walk",
          "Way"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com.ng",
          "com",
          "ng",
          "net",
          "edu.ng",
          "org",
          "gov.ng",
          "org.ng",
          "biz",
          "co"
        ]
      },
      "name": {
        "first_name": [
          "Adedayo",
          "Chukwu",
          "Emmanuel",
          "Yusuf",
          "Chinedu",
          "Muyiwa",
          "Wale",
          "Chizoba",
          "Chinyere",
          "Temitope",
          "Chiamaka",
          "Obioma",
          "Aminat",
          "Sekinat",
          "Kubura",
          "Damilola",
          "Bukola",
          "Johnson",
          "Akande",
          "Akanni",
          "Tope",
          "Titi",
          "Emeka",
          "Uzodimma",
          "Akunna",
          "Buchi",
          "Ikenna",
          "Azubuike",
          "Ifeanyichukwu",
          "Ifeoma",
          "Adaugo",
          "Adaobi",
          "Danjuma",
          "Musa",
          "Yakubu",
          "Fatima",
          "Habiba",
          "Kubra",
          "Sumayyah",
          "Zainab",
          "Rasheedah",
          "Aminu",
          "Adegoke",
          "Adeboye",
          "Funmilayo",
          "Funmilade",
          "Olufunmi",
          "Sname",
          "Tobiloba",
          "Tomiloba",
          "Toluwani",
          "Titilayo",
          "Titilope",
          "Kemi",
          "Damilare",
          "Olaide",
          "Makinwa",
          "Toke",
          "Rotimi",
          "Onome",
          "Efe",
          "Abisola",
          "Abisoye",
          "Chisom",
          "Cherechi",
          "Onoriode",
          "Ifunanya",
          "Simisola",
          "Bankole",
          "Mohammed",
          "Tari",
          "Ebiere",
          "Ayebatari",
          "Ebiowei",
          "Esse",
          "Isioma",
          "Lola",
          "Lolade",
          "Augustina",
          "Shalewa",
          "Shade",
          "Omolara",
          "Gbeminiyi",
          "Gbemisola",
          "Jadesola",
          "Omawunmi",
          "Olumide",
          "Oluwunmi",
          "Ayinde",
          "Chimamanda",
          "Abimbola",
          "Remilekun",
          "Jolayemi",
          "Ireti",
          "Banji",
          "Alade"
        ],
        "last_name": [
          "Tella",
          "Justina",
          "Ademayowa",
          "Sabdat",
          "Ayomide",
          "Yussuf",
          "Ayisat",
          "Oyebola",
          "Oluwanisola",
          "Esther",
          "Adeniyan",
          "Olubukola",
          "Adewale",
          "Mayowa",
          "Emmanuel",
          "Ajakaiye",
          "Mobolaji",
          "Adeoluwa",
          "Ajose-adeogun",
          "Omowale",
          "Abiola",
          "Aremu",
          "Ismail",
          "Olawale",
          "Atanda",
          "Olasunkanmi",
          "Taiwo",
          "Bamisebi",
          "Aderinsola",
          "David",
          "Egbochukwu",
          "Ebubechukwu",
          "Miracle",
          "Ekwueme",
          "Onyinyechukwu",
          "Isokun",
          "Adesina",
          "Mustapha",
          "Ladega",
          "Olumide",
          "Kayode",
          "Leonard",
          "Adaobi",
          "Uchechi",
          "Mogbadunade",
          "Oluwatosin",
          "Grace",
          "Nojeem",
          "Sekinat",
          "Omolara",
          "Chidinma",
          "Maryjane",
          "Ogunwande",
          "Olubunmi",
          "Agnes",
          "Osuagwu",
          "Elizabeth",
          "Obianuju",
          "Oyelude",
          "Aminat",
          "Odunayo",
          "Peter",
          "Chibuike",
          "Sylvester",
          "Salami",
          "Oluwaseyi",
          "Agboola",
          "Abodunrin",
          "Isreal",
          "Ademola",
          "Akintade",
          "Katherine",
          "Oluwaseun",
          "Aligbe",
          "Isaac",
          "Amaechi",
          "Bello",
          "Adewura",
          "Latifat",
          "Ehigiator",
          "Kimberly",
          "Onohinosen",
          "Elebiyo",
          "Ayomide",
          "Elizabeth",
          "Ndukwu",
          "Ngozi",
          "Clare",
          "Ogunbanwo",
          "Olufeyikemi",
          "Okonkwo",
          "Makuachukwu",
          "Obiageli",
          "Oladeji",
          "Odunayo",
          "Abiodun",
          "Wilcox",
          "Tamunoemi",
          "Iyalla",
          "Adegboye",
          "Kayode",
          "David",
          "Akeem-omosanya",
          "Muinat",
          "Wuraola",
          "Nwuzor",
          "Christian",
          "Akerele",
          "Samuel",
          "Sanusi",
          "Olutola",
          "Mutiat",
          "Elizabeth",
          "Adebayo",
          "Habeeb",
          "Temitope",
          "Adegoke",
          "Joshua",
          "Omobolaji",
          "Adewale",
          "Adewunmi",
          "Gbogboade",
          "Adewale",
          "Adeyemo",
          "Funmilayo",
          "Afunku",
          "Oyinkansola",
          "Maryam",
          "Aigbiniode",
          "Tolulope",
          "Onose",
          "Babalola",
          "Olaoluwa",
          "Yaqub",
          "Nwogu",
          "Chidozie",
          "Emmanuel",
          "Chibike",
          "Agboola",
          "Mukaram",
          "Afolabi",
          "Gbadamosi",
          "Saheed",
          "Opeyemi",
          "Jimoh",
          "Jamiu",
          "Babatunde",
          "Motalo",
          "Omobolanle",
          "Sarah",
          "Okunola",
          "Oluwashina",
          "Olasunkanmi-fasayo",
          "Wasiu",
          "Ayobami",
          "Busari",
          "Segunmaru",
          "Aderonke",
          "Hanifat",
          "Balogun",
          "Sulaimon",
          "Oladimeji",
          "Oluwakemi"
        ],
        "name": [
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "080########",
          "070########",
          "090########",
          "081########",
          "071########",
          "091########"
        ]
      }
    }
  },
  "en-NZ": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##",
          "#/##",
          "#/#",
          "#?",
          "?/##",
          "?/##?"
        ],
        "city": [
          "Auckland",
          "Wellington",
          "Christchurch",
          "Hamilton",
          "Tauranga",
          "Napier",
          "Hastings",
          "Dunedin",
          "Palmerston North",
          "Nelson",
          "Rotorua",
          "Whangarei",
          "New Plymouth",
          "Invercargill",
          "Whanganui",
          "Gisborne",
          "Ngāruawahia",
          "Manukau",
          "Kāpiti",
          "Kaikōura",
          "Ōamaru",
          "Rānui",
          "Waiharakeke",
          "Greymouth",
          "Hokitika",
          "Franz Josef",
          "Fox Glacier",
          "Winton",
          "Kaitaia"
        ],
        "colonialism": [
          "Queen",
          "Queens",
          "Victoria",
          "London",
          "Dominion",
          "Albert",
          "Tudor",
          "Windsor",
          "Shakespeare",
          "Oxford",
          "Cambridge",
          "Trafalgar"
        ],
        "community": [
          "#{Name.surname}#{community_suffix}",
          "#{place_names}#{community_suffix}",
          "#{place_names} #{landscape_elements}",
          "#{community_prefix} #{place_names}"
        ],
        "community_prefix": [
          "South",
          "North",
          "East",
          "West"
        ],
        "community_suffix": [
          "ton",
          "toun",
          "town"
        ],
        "default_country": [
          "New Zealand"
        ],
        "default_country_code": [
          "NZ"
        ],
        "full_address": [
          "#{street_address}, #{city} #{postcode}",
          "#{street_address}, #{secondary_address}, #{city} #{postcode}",
          "#{street_address}, #{community}, #{city} #{postcode}",
          "#{street_address}, #{community}, #{city} #{postcode}",
          "#{mail_box} #{community} #{postcode}",
          "#{mail_box}, #{community}, #{city} #{postcode}"
        ],
        "landscape_elements": [
          "Beach",
          "Sea",
          "Ocean",
          "Lake",
          "Moana",
          "River",
          "Roto",
          "Awa",
          "Hill",
          "Mountain",
          "Mount",
          "Pa",
          "Maunga",
          "Gardens",
          "Island",
          "Bay",
          "Park",
          "Cave",
          "Glacier",
          "Creek",
          "Panorama",
          "Valley",
          "Flat"
        ],
        "mail_box": [
          "PO Box ##",
          "PO Box #####",
          "CMB ##",
          "CMB C#"
        ],
        "place_names": [
          "Kauri",
          "Tōtara",
          "Kowhai",
          "Rata",
          "Pohutakawa",
          "Tawa",
          "Pine",
          "Koromiko",
          "Redwood",
          "Hinau",
          "Manuka",
          "Kanuka",
          "Kawakawa",
          "Ngaio",
          "Karo",
          "Puriri",
          "Rewarewa",
          "Karamu",
          "Ti Kouka",
          "Hospital",
          "School",
          "College",
          "Tip",
          "Landfill",
          "Railway",
          "Station",
          "Wharf",
          "Aerodrome",
          "Boundary",
          "Ridgeway",
          "Golf",
          "Bridge",
          "Coach",
          "Airport",
          "Chapel",
          "Church",
          "Cathedral",
          "Green",
          "Blue",
          "White",
          "Black",
          "Yellow",
          "Short",
          "Long",
          "Kereru",
          "Kiwi",
          "Weka",
          "Pukeko",
          "Morepork",
          "Ruru",
          "Fantail",
          "Pīwakawaka",
          "Kea",
          "Kaka",
          "Kakariki",
          "Kakapō",
          "Kumara",
          "Potato",
          "Rabbit"
        ],
        "postcode": [
          "0###",
          "2###",
          "3###",
          "4###",
          "5###",
          "6###",
          "7###",
          "8###",
          "9###"
        ],
        "region": [
          "Northland",
          "Auckland",
          "Waikato",
          "Bay of Plenty",
          "Gisborne",
          "Hawkes Bay",
          "Taranaki",
          "Manawatu",
          "Wellington",
          "Tasman",
          "Nelson",
          "Marlborough",
          "West Coast",
          "Canterbury",
          "Otago",
          "Southland"
        ],
        "region_abbr": [
          "NTL",
          "AUK",
          "WKO",
          "BOP",
          "GIS",
          "HKB",
          "TKI",
          "MWT",
          "WGN",
          "TAS",
          "NSN",
          "MBH",
          "WTC",
          "CAN",
          "OTA",
          "STL"
        ],
        "secondary_address": [
          "RD #",
          "Apt #",
          "Unit #",
          "Level #"
        ],
        "street_address": [
          "#{building_number} #{street_name}"
        ],
        "street_name": [
          "#{Name.first_name} #{street_suffix}",
          "St #{Name.first_name} #{street_suffix}",
          "#{Name.last_name} #{street_suffix}",
          "#{the} #{street_suffix}",
          "#{colonialism} #{street_suffix}",
          "#{colonialism} #{landscape_elements} #{street_suffix}",
          "#{landscape_elements} #{street_suffix}",
          "#{the} #{landscape_elements} #{street_suffix}",
          "#{the} #{place_names}",
          "#{place_names} #{street_suffix}"
        ],
        "street_suffix": [
          "Avenue",
          "Boulevard",
          "Circle",
          "Circuit",
          "Court",
          "Crescent",
          "Crest",
          "Drive",
          "Estate Dr",
          "Grove",
          "Hill",
          "Junction",
          "Knoll",
          "Lane",
          "Loop",
          "Mall",
          "Manor",
          "Meadow",
          "Mews",
          "Parade",
          "Pass",
          "Place",
          "Plaza",
          "Ridge",
          "Road",
          "Run",
          "Square",
          "Street",
          "St",
          "Summit",
          "Terrace",
          "Track",
          "Trail",
          "View Road",
          "Way",
          "Esplanade"
        ],
        "the": [
          "The",
          "New",
          "Old",
          "Main"
        ]
      },
      "cell_phone": {
        "formats": [
          "02##-###-###",
          "02## ### ###",
          "02# ### ###",
          "02#-###-####"
        ]
      },
      "company": {
        "suffix": [
          "Ltd",
          "Ltc",
          "and Sons",
          "Group",
          "Brothers",
          "Partners"
        ]
      },
      "internet": {
        "domain_suffix": [
          "co.nz",
          "com",
          "net.nz",
          "net",
          "org.nz",
          "org",
          "govt.nz",
          "iwi.nz"
        ]
      },
      "name": {
        "first_name": [
          "Aaria",
          "Aaron",
          "Abigail",
          "Adam",
          "Adrian",
          "Adrienne",
          "Aimee",
          "Alan",
          "Alana",
          "Alex",
          "Alexander",
          "Alexandra",
          "Alice",
          "Alicia",
          "Alison",
          "Allan",
          "Alyssa",
          "Amaia",
          "Amanda",
          "Amber",
          "Amelia",
          "Amy",
          "Ana",
          "Anahera",
          "Andrea",
          "Andrew",
          "Angel",
          "Angela",
          "Anita",
          "Ann",
          "Anna",
          "Anne",
          "Annette",
          "Anthony",
          "Antony",
          "Ari",
          "Aroha",
          "Arthur",
          "Ashleigh",
          "Ashley",
          "Ataahua",
          "Ava",
          "Awhina",
          "Bailey",
          "Barbara",
          "Barry",
          "Belinda",
          "Ben",
          "Benjamin",
          "Bernard",
          "Bevan",
          "Beverley",
          "Blair",
          "Bradley",
          "Brenda",
          "Brendan",
          "Brendon",
          "Brent",
          "Brett",
          "Brian",
          "Briana",
          "Brianna",
          "Bridget",
          "Britney",
          "Brittany",
          "Bronwyn",
          "Brooke",
          "Brooklyn",
          "Bruce",
          "Bryan",
          "Caitlin",
          "Caitlyn",
          "Caleb",
          "Callum",
          "Cameron",
          "Carl",
          "Carmen",
          "Carol",
          "Caroline",
          "Carolyn",
          "Casey",
          "Cassandra",
          "Catherine",
          "Charles",
          "Charlie",
          "Charlotte",
          "Chelsea",
          "Cherie",
          "Cheryl",
          "Cheyenne",
          "Chloe",
          "Chloé",
          "Christina",
          "Christine",
          "Christopher",
          "Claire",
          "Claudia",
          "Clinton",
          "Cody",
          "Colin",
          "Colleen",
          "Cooper",
          "Corey",
          "Courtney",
          "Craig",
          "Crystal",
          "Damian",
          "Damon",
          "Daniel",
          "Danielle",
          "Darren",
          "Darryl",
          "David",
          "Dean",
          "Debbie",
          "Deborah",
          "Debra",
          "Denis",
          "Denise",
          "Dennis",
          "Derek",
          "Desmond",
          "Destiny",
          "Diana",
          "Diane",
          "Dianne",
          "Dion",
          "Donald",
          "Donna",
          "Dorothy",
          "Douglas",
          "Duncan",
          "Dylan",
          "Eden",
          "Edward",
          "Elaine",
          "Elizabeth",
          "Ella",
          "Emily",
          "Emma",
          "Eric",
          "Erin",
          "Ethan",
          "Faith",
          "Fiona",
          "Frances",
          "Francis",
          "Frederick",
          "Gabrielle",
          "Gail",
          "Gareth",
          "Garry",
          "Gary",
          "Gavin",
          "Gemma",
          "Geoffrey",
          "George",
          "Georgia",
          "Gerard",
          "Gillian",
          "Gina",
          "Glen",
          "Glenda",
          "Glenn",
          "Glenys",
          "Gloria",
          "Gordon",
          "Grace",
          "Graeme",
          "Graham",
          "Grant",
          "Gregory",
          "Hamish",
          "Hana",
          "Hannah",
          "Harley",
          "Harper",
          "Hayden",
          "Hayley",
          "Heather",
          "Helen",
          "Henry",
          "Holly",
          "Hope",
          "Hunter",
          "Ian",
          "Ihaia",
          "Ihaka",
          "Irene",
          "Isaac",
          "Isabella",
          "Isla",
          "Ivan",
          "Jack",
          "Jacob",
          "Jacqueline",
          "Jade",
          "James",
          "Jamie",
          "Jan",
          "Jane",
          "Janet",
          "Janice",
          "Janine",
          "Jared",
          "Jasmine",
          "Jason",
          "Jeanette",
          "Jeffrey",
          "Jenna",
          "Jennifer",
          "Jeremy",
          "Jesse",
          "Jessica",
          "Jessie",
          "Jill",
          "Jillian",
          "Joan",
          "Joanna",
          "Joanne",
          "Jocelyn",
          "Joel",
          "John",
          "Jonathan",
          "Jonathon",
          "Jordan",
          "Joseph",
          "Josephine",
          "Joshua",
          "Joy",
          "Judith",
          "Julia",
          "Julie",
          "Junior",
          "Justin",
          "Justine",
          "Kahurangi",
          "Kai",
          "Kaia",
          "Kaitlin",
          "Kane",
          "Kara",
          "Karen",
          "Karl",
          "Kate",
          "Katelyn",
          "Katherine",
          "Kathleen",
          "Kathryn",
          "Katie",
          "Katrina",
          "Kauri",
          "Kay",
          "Kayla",
          "Keith",
          "Kellie",
          "Kelly",
          "Kelsey",
          "Kelvin",
          "Kenneth",
          "Kerry",
          "Kevin",
          "Kieran",
          "Kim",
          "Kimberley",
          "Kirsten",
          "Kirsty",
          "Kora",
          "Krystal",
          "Kurt",
          "Kyle",
          "Kylie",
          "Lance",
          "Laura",
          "Lauren",
          "Lawrence",
          "Leah",
          "Leanne",
          "Lee",
          "Leon",
          "Leonie",
          "Lesley",
          "Leslie",
          "Liam",
          "Lily",
          "Linda",
          "Lindsay",
          "Lisa",
          "Logan",
          "Lois",
          "Lorraine",
          "Louise",
          "Lucas",
          "Lucy",
          "Luke",
          "Lydia",
          "Lynda",
          "Lynette",
          "Lynn",
          "Lynne",
          "Lynnette",
          "Maddison",
          "Madeleine",
          "Madison",
          "Maia",
          "Malcolm",
          "Manaaki",
          "Manaia",
          "Manawa",
          "Marcus",
          "Maree",
          "Margaret",
          "Maria",
          "Marian",
          "Marie",
          "Marilyn",
          "Marion",
          "Mark",
          "Martin",
          "Mary",
          "Mason",
          "Matai",
          "Mathew",
          "Matthew",
          "Maureen",
          "Maurice",
          "Max",
          "Meg",
          "Megan",
          "Melanie",
          "Melissa",
          "Mervyn",
          "Mia",
          "Michael",
          "Michaela",
          "Michelle",
          "Mikaere",
          "Mikayla",
          "Mila",
          "Mitchell",
          "Moana",
          "Molly",
          "Monique",
          "Morgan",
          "Murray",
          "Mārama",
          "Nadine",
          "Natalie",
          "Natasha",
          "Nathan",
          "Neil",
          "Neville",
          "Ngaire",
          "Niamh",
          "Nicholas",
          "Nicola",
          "Nicole",
          "Nigel",
          "Nikau",
          "Nikita",
          "Noah",
          "Noel",
          "Norman",
          "Oliver",
          "Olivia",
          "Owen",
          "Paige",
          "Pamela",
          "Paris",
          "Patricia",
          "Patrick",
          "Paul",
          "Paula",
          "Pauline",
          "Penelope",
          "Peter",
          "Philip",
          "Philippa",
          "Phillip",
          "Phoebe",
          "Rachael",
          "Rachel",
          "Rachelle",
          "Raewyn",
          "Rawiri",
          "Raymond",
          "Rebecca",
          "Rebekah",
          "Renee",
          "Renée",
          "Rex",
          "Rhys",
          "Richard",
          "Ricky",
          "Robert",
          "Robin",
          "Robyn",
          "Rochelle",
          "Rodney",
          "Roger",
          "Ronald",
          "Rory",
          "Rose",
          "Rosemary",
          "Ross",
          "Roy",
          "Ruby",
          "Rui",
          "Russell",
          "Ruth",
          "Ryan",
          "Rāwiri",
          "Sally",
          "Sam",
          "Samantha",
          "Samuel",
          "Sandra",
          "Sapa'u",
          "Sara",
          "Sarah",
          "Scott",
          "Sean",
          "Shane",
          "Shania",
          "Shannon",
          "Sharlene",
          "Sharon",
          "Shaun",
          "Shelley",
          "Sheryl",
          "Shirley",
          "Shona",
          "Simon",
          "Sione",
          "Sophia",
          "Sophie",
          "Stacey",
          "Stephanie",
          "Stephen",
          "Steven",
          "Stewart",
          "Stuart",
          "Summer",
          "Susan",
          "Suzanne",
          "Tai",
          "Taika",
          "Tama",
          "Tamara",
          "Tamati",
          "Tane",
          "Tangaroa",
          "Tania",
          "Tanya",
          "Tara",
          "Tawhiri",
          "Tayla",
          "Taylor",
          "Te Ao",
          "Te Ariki",
          "Te Aroha",
          "Te Whiti",
          "Terence",
          "Teresa",
          "Tessa",
          "Thomas",
          "Tia",
          "Tiana",
          "Timothy",
          "Tina",
          "Todd",
          "Toni",
          "Tony",
          "Tracey",
          "Tracy",
          "Trent",
          "Trevor",
          "Troy",
          "Tui",
          "Tyla",
          "Tyson",
          "Valerie",
          "Vanessa",
          "Vicki",
          "Victoria",
          "Vincent",
          "Virginia",
          "Vivienne",
          "Warren",
          "Wayne",
          "Wendy",
          "William",
          "Wiremu",
          "Yvonne",
          "Zachary",
          "Zane",
          "Zoe",
          "Zoë"
        ],
        "last_name": [
          "#{surname}",
          "#{surname}-#{surname}",
          "#{surname} #{surname}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}"
        ],
        "suffix": [
          "Jr.",
          "Sr.",
          "I",
          "II",
          "III",
          "IV",
          "V",
          "ONZM",
          "OBE",
          "GNZM",
          "KNZM",
          "CNZM",
          "MNZM"
        ],
        "surname": [
          "Smith",
          "Jones",
          "Williams",
          "Brown",
          "Wilson",
          "Taylor",
          "Johnson",
          "White",
          "Martin",
          "Anderson",
          "Thompson",
          "Nguyen",
          "Thomas",
          "Walker",
          "Harris",
          "Lee",
          "Ryan",
          "Robinson",
          "Kelly",
          "King",
          "Davis",
          "Wright",
          "Evans",
          "Roberts",
          "Green",
          "Hall",
          "Wood",
          "Jackson",
          "Clarke",
          "Patel",
          "Khan",
          "Lewis",
          "James",
          "Phillips",
          "Mason",
          "Mitchell",
          "Rose",
          "Davies",
          "Rodriguez",
          "Cox",
          "Alexander",
          "Garden",
          "Campbell",
          "Johnston",
          "Moore",
          "Smyth",
          "Oneill",
          "Doherty",
          "Stewart",
          "Quinn",
          "Murphy",
          "Graham",
          "Mclaughlin",
          "Hamilton",
          "Murray",
          "Hughes",
          "Robertson",
          "Thomson",
          "Scott",
          "Macdonald",
          "Reid",
          "Clark",
          "Ross",
          "Young",
          "Watson",
          "Paterson",
          "Morrison",
          "Morgan",
          "Griffiths",
          "Edwards",
          "Rees",
          "Jenkins",
          "Owen",
          "Price",
          "Moss",
          "Richards",
          "Abbott",
          "Adams",
          "Armstrong",
          "Bahringer",
          "Bailey",
          "Barrows",
          "Bartell",
          "Bartoletti",
          "Barton",
          "Bauch",
          "Baumbach",
          "Bayer",
          "Beahan",
          "Beatty",
          "Becker",
          "Beier",
          "Berge",
          "Bergstrom",
          "Bode",
          "Bogan",
          "Borer",
          "Bosco",
          "Botsford",
          "Boyer",
          "Boyle",
          "Braun",
          "Bruen",
          "Carroll",
          "Carter",
          "Cartwright",
          "Casper",
          "Cassin",
          "Champlin",
          "Christiansen",
          "Cole",
          "Collier",
          "Collins",
          "Connelly",
          "Conroy",
          "Corkery",
          "Cormier",
          "Corwin",
          "Cronin",
          "Crooks",
          "Cruickshank",
          "Cummings",
          "Damore",
          "Daniel",
          "Dare",
          "Daugherty",
          "Dickens",
          "Dickinson",
          "Dietrich",
          "Donnelly",
          "Dooley",
          "Douglas",
          "Doyle",
          "Durgan",
          "Ebert",
          "Emard",
          "Emmerich",
          "Erdman",
          "Ernser",
          "Fadel",
          "Fahey",
          "Farrell",
          "Fay",
          "Feeney",
          "Feil",
          "Ferry",
          "Fisher",
          "Flatley",
          "Gibson",
          "Gleason",
          "Glover",
          "Goldner",
          "Goodwin",
          "Grady",
          "Grant",
          "Greenfelder",
          "Greenholt",
          "Grimes",
          "Gutmann",
          "Hackett",
          "Hahn",
          "Haley",
          "Hammes",
          "Hand",
          "Hane",
          "Hansen",
          "Harber",
          "Hartmann",
          "Harvey",
          "Hayes",
          "Heaney",
          "Heathcote",
          "Heller",
          "Hermann",
          "Hermiston",
          "Hessel",
          "Hettinger",
          "Hickle",
          "Hill",
          "Hills",
          "Hoppe",
          "Howe",
          "Howell",
          "Hudson",
          "Huel",
          "Hyatt",
          "Jacobi",
          "Jacobs",
          "Jacobson",
          "Jerde",
          "Johns",
          "Keeling",
          "Kemmer",
          "Kessler",
          "Kiehn",
          "Kirlin",
          "Klein",
          "Koch",
          "Koelpin",
          "Kohler",
          "Koss",
          "Kovacek",
          "Kreiger",
          "Kris",
          "Kuhlman",
          "Kuhn",
          "Kulas",
          "Kunde",
          "Kutch",
          "Lakin",
          "Lang",
          "Langworth",
          "Larkin",
          "Larson",
          "Leannon",
          "Lee",
          "Leffler",
          "Li",
          "Little",
          "Lockman",
          "Lowe",
          "Lynch",
          "Mann",
          "Marks",
          "Marvin",
          "Mayer",
          "McCullough",
          "McDermott",
          "McLean",
          "Maclean",
          "McPherson",
          "Macpherson",
          "MacPherson",
          "McCann",
          "McLeod",
          "Macleod",
          "McKenzie",
          "Mackenzie",
          "MacKenzie",
          "Mckenzie",
          "Miller",
          "Mills",
          "Monahan",
          "Morissette",
          "Mueller",
          "Muller",
          "Nader",
          "Ng",
          "Nicolas",
          "Nolan",
          "O'Connell",
          "O'Conner",
          "O'Hara",
          "O'Keefe",
          "Olson",
          "O'Reilly",
          "Parisian",
          "Parker",
          "Quigley",
          "Reilly",
          "Reynolds",
          "Rice",
          "Ritchie",
          "Rohan",
          "Rolfson",
          "Rowe",
          "Russel",
          "Rutherford",
          "Sanford",
          "Sauer",
          "Schmidt",
          "Schmitt",
          "Schneider",
          "Schroeder",
          "Schultz",
          "Shields",
          "Smitham",
          "Spencer",
          "Stanton",
          "Stark",
          "Stokes",
          "Swift",
          "Tillman",
          "Towne",
          "Tremblay",
          "Tromp",
          "Turcotte",
          "Turner",
          "Walsh",
          "Walter",
          "Ward",
          "Waters",
          "Weber",
          "Welch",
          "West",
          "Wilderman",
          "Wilkinson",
          "Williamson",
          "Windler",
          "Wolf",
          "Henare",
          "Ngata",
          "Parata",
          "Turei",
          "Taumata",
          "Te Whiti",
          "Ka'ai",
          "Ruakere",
          "Te Kanawa",
          "Tamahori",
          "Curtis",
          "Arahanga",
          "Waititi",
          "Vainu'upo",
          "Feu'u",
          "Tagaloa",
          "Laga'aia",
          "Iosefo",
          "Lotu-Iiga",
          "Taule'alo",
          "Singh",
          "Wang",
          "Montgomery",
          "Zhang",
          "Kumar",
          "Liu",
          "Chen",
          "Huang",
          "Wu",
          "Yang",
          "Wong",
          "Xu",
          "Kim",
          "Zhou"
        ]
      },
      "phone_number": {
        "country_code": [
          "64"
        ],
        "formats": [
          "0# ### ####",
          "# ### ####"
        ]
      },
      "team": {
        "name": [
          "Tall Blacks",
          "All Whites",
          "Warriors",
          "Silver Ferns",
          "All Blacks",
          "Black Sticks",
          "Black Caps"
        ],
        "sport": [
          "basketball",
          "football",
          "rugby league",
          "netball",
          "rugby union",
          "hockey",
          "cricket",
          "golf",
          "boxing",
          "rowing",
          "motorsport",
          "tennis",
          "athletics",
          "sailing",
          "surf life saving",
          "squash"
        ]
      },
      "university": {
        "name": [
          "Auckland University of Technology",
          "Lincoln University",
          "Massey University",
          "University of Auckland",
          "University of Canterbury",
          "University of Otago",
          "University of Waikato",
          "Victoria University of Wellington"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-PAK": {
    "faker": {
      "address": {
        "default_country": [
          "Pakistan",
          "Islamic Republic of Pakistan"
        ],
        "default_country_code": [
          "PK"
        ],
        "default_time_zone": [
          "Asia/Karachi"
        ],
        "postcode": [
          "####0"
        ],
        "state": [
          "Balochistan",
          "Khyber Pakhtunkhwa",
          "Punjab",
          "Sindh",
          "Islamabad Capital Territory",
          "Azad Jammu and Kashmir",
          "Gilgit-Baltistan"
        ],
        "state_abbr": [
          "BA",
          "KPK",
          "PB",
          "SD",
          "ICT",
          "AJK",
          "GB"
        ]
      },
      "cell_phone": {
        "formats": [
          "0311#######",
          "0312#######",
          "0313#######",
          "0314#######",
          "0315#######",
          "0300#######",
          "0301#######",
          "0321#######",
          "0322#######",
          "0345#######",
          "0346#######",
          "0346#######"
        ]
      },
      "company": {
        "suffix": [
          "Pvt Ltd",
          "Limited",
          "Ltd",
          "and Sons",
          "Corp",
          "Group",
          "Brothers",
          "CO"
        ]
      },
      "internet": {
        "domain_suffix": [
          "pk",
          "com",
          "com.pk",
          "name",
          "net",
          "org",
          "html",
          "edu"
        ]
      },
      "name": {
        "first_name": [
          "Hamza",
          "Harris",
          "Raees",
          "Ehtisham",
          "Zohair",
          "Zuhaib",
          "Aslam",
          "Nadeem",
          "Younas",
          "Danish",
          "Zahoor",
          "Abdul",
          "Nizam",
          "Taimur",
          "Iftikhar",
          "Kashif",
          "Naseer",
          "Zohaib",
          "Mazhar",
          "Saeed",
          "Jawad",
          "Wakeel Khan",
          "Quddus",
          "Nasir",
          "Tabraiz",
          "Shahbaz",
          "Wasi",
          "Rahim",
          "Suleman",
          "Akbar",
          "Maqbool Ahmed",
          "Sajjad",
          "Akif",
          "Sarmad",
          "Zarar",
          "Zulqarnain",
          "Sunny",
          "Nawaz",
          "Sattar",
          "Humayun",
          "Khurshid",
          "Abid",
          "Ahmed",
          "Ijaz",
          "Tariq",
          "Sarim Hayat",
          "Syed Najum",
          "Rashid",
          "Umair",
          "Zubair",
          "Salim",
          "Sultan",
          "Nauman",
          "Waqar",
          "Imran",
          "Fazal",
          "Usman",
          "Adam",
          "Ilyas",
          "Saghar",
          "Azeem",
          "Ali",
          "Akram",
          "Dawood",
          "Sohrab",
          "Zeeshan",
          "Amjad",
          "Majid",
          "Naveed",
          "Yousaf",
          "Safeer",
          "Akhtar",
          "Muzaffar",
          "Saqlain",
          "Afzal",
          "Maqsood",
          "Hassan",
          "Moheem",
          "Zaighum",
          "Amir",
          "Saqib",
          "Vazir",
          "Vakeel",
          "Qadir",
          "Malik",
          "Jafar",
          "Sikandar",
          "Ismail",
          "Junaid",
          "Mehr",
          "Idrees Khan",
          "Jamal",
          "Shafqat",
          "Taufeeq",
          "Rasheed",
          "Shakoor",
          "Wasim",
          "Saadat",
          "Siddiq",
          "Shabbir",
          "Umair",
          "Shams",
          "Habib",
          "Salahuddin",
          "Fayaz",
          "Faiz",
          "Zaeem",
          "Yasir",
          "Shan",
          "Wasif",
          "Khan",
          "Adnan",
          "Arsalan",
          "Shamsher",
          "Nafees",
          "Mumtaz",
          "Javid",
          "Yahya",
          "Uzaif",
          "Ayub",
          "Noman",
          "Zameer",
          "Mian",
          "Mushtaq",
          "Aleem",
          "Ghayoor",
          "Khalid",
          "Taj",
          "Parvez",
          "Zahid",
          "Aziz",
          "Tanvir",
          "Musharraf",
          "Shakir",
          "Sohail",
          "Arif",
          "Sabir",
          "Zain",
          "Tauseef",
          "Saif",
          "Rahman",
          "Aqib",
          "Zulfiqar",
          "Salman",
          "Sibtain",
          "Hamid",
          "Sohaib",
          "Najib",
          "Sadaqat",
          "Inzamam",
          "Haroon",
          "Danial",
          "Imran",
          "Fahid",
          "Aqeel",
          "Subhan",
          "Shakeel",
          "Rana",
          "Hammad",
          "Faizan",
          "Muhammad",
          "Ahmer",
          "Jabbar",
          "Aamir Saleem",
          "Kaleem",
          "Tauqeer",
          "Bilal",
          "Razzaq",
          "Zafar",
          "Shahzad",
          "Latif",
          "Mohammed",
          "Raja Zohaib",
          "Munawar",
          "Karim",
          "Waheed",
          "Mustafa",
          "Sameer",
          "Sarwar",
          "Sarfraz",
          "Jaleel",
          "Jamal",
          "Salman",
          "Sagheer",
          "Qasim",
          "Mustansar",
          "Umar",
          "Mohammad",
          "Waheed",
          "Sadiq",
          "Taha",
          "Amin",
          "Mujtaba",
          "Mahmood",
          "Hameed",
          "Zareef",
          "Fahad",
          "Irfan",
          "Yawar",
          "Waqas",
          "Ishaq",
          "Arshad",
          "Mustafa",
          "Khushal",
          "Murtaza",
          "Qaiser",
          "Farrukh",
          "Naeem",
          "Abbas",
          "Qais",
          "Idrees",
          "Masood",
          "Aon",
          "Daniyal",
          "Zaman",
          "Zia",
          "Obaid",
          "Mubashar",
          "Wasay",
          "Yasin",
          "Zakir",
          "Shoaib",
          "Bashir",
          "Azhar",
          "Jarrar",
          "Waseem",
          "Yar",
          "Zain",
          "Naeem",
          "Zakaria",
          "Jameel",
          "Sahir",
          "Ibrahim",
          "Ahsan",
          "Shafiq",
          "Haji",
          "Babar",
          "Shahid",
          "Sheraz",
          "Saad",
          "Ghous",
          "Tajammul",
          "Saif",
          "Mohsin",
          "Azad",
          "Zaheer",
          "Farooq",
          "Rauf",
          "Ghafoor",
          "Babar",
          "Sajid",
          "Abrar",
          "Haider",
          "Shaukat",
          "Omar",
          "Sohail",
          "Irfan",
          "Wakeel",
          "Wazir",
          "Mohammad",
          "Hadier",
          "Shuja",
          "Chaudhary",
          "Adeel",
          "Asad",
          "Saad",
          "Afzaal",
          "Mudassar",
          "Nabeel",
          "Fazal",
          "Altaf",
          "Wajid",
          "Ayaaz",
          "Wahid",
          "Usman",
          "Fawad",
          "Ajmal",
          "Ibrahim",
          "Raza",
          "Danial",
          "Rizwan",
          "Wali"
        ],
        "last_name": [
          "Jutt",
          "Khan",
          "Butt",
          "Mughal",
          "Bhatti",
          "Sindho",
          "Virk",
          "Dar",
          "Nambardar",
          "Qazi",
          "Gujjar",
          "Iqbal",
          "Adil",
          "Ali Raza",
          "Azam",
          "Zarnosh Khan",
          "Riaz",
          "Farid",
          "Asim",
          "Uzair",
          "Tahir",
          "Saud",
          "Hasan",
          "Muhammad",
          "Tehsin",
          "Sher",
          "Ahmed",
          "Tufail",
          "Faisal",
          "Shujaat",
          "Shehzad",
          "Sharjeel",
          "A Haq Ansari",
          "Kabir",
          "Sheharyar",
          "Safdar",
          "Talat",
          "Jalal",
          "Hussain",
          "Anwar",
          "Hafeez",
          "Ash",
          "Rameez",
          "Badar",
          "Javed"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "92"
        ],
        "formats": [
          "##########",
          "### #######",
          "03##-#######"
        ]
      }
    }
  },
  "en-SG": {
    "faker": {
      "address": {
        "building_number": [
          "#",
          "##",
          "###"
        ],
        "default_country": [
          "Singapore"
        ],
        "default_country_code": [
          "SG"
        ],
        "postcode": [
          "######"
        ],
        "street_address": [
          "#{building_number} #{street_name}"
        ],
        "street_name": [
          "#{streets} St #{building_number}",
          "#{streets} Ave #{building_number}",
          "#{streets} Road"
        ],
        "streets": [
          "Tampines",
          "Hougang",
          "Sims",
          "Bukit Timah",
          "Jurong West",
          "Teck Whye",
          "Choa Chu Kang North",
          "Woodlands",
          "Sembawang",
          "Ah Soo",
          "Paya Lebar",
          "Serangoon",
          "Lor Lew Lian",
          "Woodlands",
          "Geyland",
          "Clementi",
          "Bukit Merah",
          "Tanglin"
        ]
      },
      "name": {
        "female_english_name": [
          "Alicia",
          "Caitlin",
          "Denise",
          "Emerald",
          "Erin",
          "Jocelyn",
          "Levene",
          "Rosaline",
          "Victoria",
          "Amy",
          "Angelyn",
          "Chloe",
          "Erin",
          "Isabel",
          "Jolene",
          "Natalyn",
          "Rachael",
          "Rishi",
          "Valerie",
          "Anastasia",
          "Andrea",
          "Carina",
          "Celeste",
          "Flo",
          "Janessa",
          "Joeunn",
          "Mabel",
          "Riya",
          "Samantha",
          "Tricia",
          "Aurelia",
          "Chanel",
          "Colette",
          "Fynn",
          "Gwyneth",
          "Josephine",
          "Keisha",
          "Rachael",
          "Sarah",
          "Sharlene",
          "Val",
          "Charlotte",
          "Chloe",
          "Danielle",
          "Gabrielle",
          "Glory",
          "Isabel",
          "Kyra",
          "Marilyn",
          "Raine",
          "Sophie",
          "Beatrice",
          "Cassia",
          "Cheralyn",
          "Christy",
          "Dilys",
          "Glynis",
          "Isabelle",
          "Megan",
          "Shannen",
          "Tisha",
          "Tricia",
          "Victoria",
          "Bethley",
          "Catherine",
          "Claire",
          "Clarissa",
          "Eleanor",
          "Isabelle",
          "Megan",
          "Mikayla",
          "Renee",
          "Steffi",
          "Vera",
          "Zoe",
          "Alanna",
          "Alyssa",
          "Angeline",
          "Anya",
          "Ciara",
          "Clare",
          "Isabella",
          "Jeanette",
          "Kaelyn",
          "Kate",
          "Megan",
          "Nieve",
          "Shannel",
          "Valerie",
          "Anastasia",
          "Ariel",
          "Gwenn",
          "Janine",
          "Kara",
          "Kate",
          "Katelyn",
          "Natalie",
          "Natally",
          "Samantha",
          "Shannon",
          "Tiffany",
          "Arielle",
          "Ashley",
          "Claire",
          "Jovi",
          "Kimi",
          "Vil",
          "Alicia",
          "Caroline",
          "Chanell",
          "Elizabeth",
          "Heidi",
          "Megan",
          "Nericcia",
          "Sharmaine",
          "Amelia",
          "Caitlyn",
          "Elisha",
          "Rachel",
          "Rannel",
          "Rianne",
          "Andrea",
          "Celeste",
          "Chantelle",
          "Emma",
          "Heidi",
          "Joey",
          "Khloe",
          "Maegin",
          "Mayenne",
          "Regina",
          "Anna",
          "Cherie",
          "Christie",
          "Janelle",
          "Jenell",
          "Johannah",
          "Leah",
          "Marissa",
          "Arissa",
          "Evangelyn",
          "Faith",
          "Phobe",
          "Rebecca",
          "Regina",
          "Cindy",
          "Karen",
          "Jess"
        ],
        "female_first_name": [
          "Xiu Yi",
          "Wai Teng",
          "Sing Yee",
          "Jing Yi",
          "Jia Yee",
          "Jia Xuan",
          "Shu En",
          "Pei Ying",
          "Pei Yu",
          "Pih Foung",
          "Li-ann",
          "Shi Xuan",
          "Yi Xuan",
          "Shu En",
          "Yi Xin",
          "Hui Juan",
          "Yu En",
          "Yihui",
          "Xin Yi",
          "Yun Xuan",
          "Xuan Xuan",
          "Cheuk Ying",
          "Shiqi",
          "Yujin",
          "Wee Xin",
          "Jing Xuan",
          "Huishan",
          "Yi Ting",
          "Wei Xuan",
          "Shi Ning",
          "Zi Shan",
          "Jing Ning",
          "Lee Shyin",
          "Yi Ning",
          "Enyi",
          "Siying",
          "Ruitong",
          "Rui Xuan",
          "Siyun",
          "Xi Xuan",
          "Shuwei",
          "Jie Ying",
          "Hui Jie",
          "Xuan Na",
          "Sze Han",
          "Rou'en",
          "Wei Xuan",
          "Kaiyi",
          "An Xuan",
          "Enxuan",
          "Yu Xuan",
          "Qi Qi",
          "Yutong",
          "Jia En",
          "Chee En",
          "Ruining",
          "Lee Ying",
          "Yu Qi",
          "Ke Xuan",
          "Teo Xinyu",
          "Xin Yee",
          "Xuan Ling",
          "Zhi Yi",
          "Yan Tong",
          "En Qi",
          "Yi Ting",
          "Yanling",
          "Sining",
          "Yixuan",
          "Zu'er",
          "Ke Xuan",
          "Ying Le",
          "Qinyi",
          "Li Min",
          "Yi Ling",
          "Xu Tong",
          "Ser Shyann",
          "Teng Ee",
          "Miao Yun",
          "Yng Qi",
          "Xuan Yi",
          "Yi Shan",
          "Rui Tian",
          "Ruishan",
          "Jia Xuan",
          "Kai Le",
          "Le Xuan",
          "Yu Tong",
          "Kai Qi",
          "Xuan Rong",
          "Wen Xin",
          "Si Xuan",
          "Ying Xin",
          "Tong En",
          "Xinhui",
          "Qingyi",
          "En Hui",
          "Yunwen",
          "Zi Xuan",
          "Kai En",
          "Ann Ting",
          "Yu En",
          "Yu Xin",
          "Ting Loh",
          "Jia Yi",
          "Min Wen",
          "Jia Jia",
          "Ke Xin",
          "Yuxuan",
          "Xin Ling",
          "Lizi",
          "Tschi-xuan",
          "Yu Chen",
          "Yi Lea",
          "Ziyu",
          "Tay Ting",
          "Yingbi",
          "See-yi",
          "Fang'en",
          "Chze Xuan",
          "Xue Ying",
          "Wenyan",
          "Zi Yuan",
          "Bei'en",
          "Yuxi",
          "Rei En",
          "Yitong",
          "Kaiting",
          "Jing Xuan",
          "Shu Wen",
          "Wenxuan",
          "Hui Xuan",
          "Wan Ying",
          "Rui-han",
          "Weining",
          "Jia'en",
          "Hann-yi",
          "Cze En",
          "Zhiyu",
          "Yen Yee",
          "Ling Xuan",
          "Si Ying"
        ],
        "first_name": [
          "Jin Quan",
          "Wen Jun",
          "Jun Jie",
          "Cheng Han",
          "Tze-Kwang",
          "Jin Leong",
          "Zi Liang",
          "Zhi Ren",
          "Jin Quan",
          "Wen Jun",
          "Chee Hin",
          "Guo Jun",
          "Kai Jie",
          "Kun Qiang",
          "Jun Kiat",
          "Yong Zheng",
          "Yong Jun",
          "Chit Boon",
          "You Ren",
          "Wen Zhong",
          "Yang Shun",
          "Qi Guang",
          "Kang Soon",
          "Wee Heng",
          "Kah Yang",
          "Siew Beng",
          "Jia Woei",
          "Chean Meng",
          "Wai Kay",
          "Keng Hua",
          "Yew Meng",
          "Cheng Wen",
          "Jiun Wei",
          "Yee Sian",
          "Shao Hong",
          "Bin Shen",
          "Wing Yiu",
          "Ee Hong",
          "Yu Pyn",
          "Yong Sheng",
          "Jun Peng",
          "Jia Jie",
          "Guang Yi",
          "Si Heng",
          "Wei Hou",
          "Kang Sheng",
          "Hong Ern",
          "Jia Liang",
          "Wei Lip",
          "Wee Chen",
          "Wee Leng",
          "Yu Xi",
          "Ming Yang",
          "Wen Hao",
          "Siang Meng",
          "Mong Li",
          "Ghim Huat",
          "Jun Yi",
          "Jie Kai",
          "Zhiming",
          "Wei Jie",
          "Teng Qing",
          "Wei Jian",
          "Wei Kwan",
          "Chee Chin",
          "Chun Mun",
          "Ming Hui",
          "Chuan Yeong",
          "Yee Jen",
          "Sin Tian",
          "Jun Hao",
          "Wai Kit",
          "Wei Jie",
          "Zhi Wei",
          "Yan Han",
          "Guo Qiang",
          "Juin Wen",
          "Jun Wei",
          "Jia Jun",
          "You Ming",
          "Kok Keng",
          "Jing Hui",
          "Yi Hui",
          "Peck Seng",
          "Yu Ming",
          "Yan Ming",
          "Wang Jie",
          "Wei Jian",
          "Wei Xiang",
          "Jian Yu",
          "Kah Seng",
          "Jia Woei",
          "Li Heng",
          "Shao Quan"
        ],
        "last_name": [
          "Tan",
          "Lim",
          "Lee",
          "Ng",
          "Ong",
          "Wong",
          "Goh",
          "Chua",
          "Chan",
          "Koh",
          "Teo",
          "Ang",
          "Yeo",
          "Tay",
          "Ho",
          "Low",
          "Toh",
          "Sim",
          "Chong",
          "Chia",
          "Fong",
          "Leong",
          "Chow",
          "Ou",
          "Li",
          "Koh",
          "Gan",
          "Chai",
          "Sim",
          "Choo",
          "Goy",
          "Phua",
          "Thio",
          "Chin",
          "Neo",
          "Khoo",
          "Wee",
          "Kok",
          "Lai",
          "Soh",
          "Lin",
          "Liew",
          "Ko",
          "Oh",
          "Peh",
          "Lam",
          "Au",
          "Seah",
          "Boey",
          "Lau",
          "Pang",
          "Lye",
          "Quah",
          "Yong",
          "Lui",
          "Lum",
          "Seow",
          "Loh",
          "Chew",
          "Mok",
          "Lew",
          "Chee",
          "Loo",
          "Gn",
          "Tang",
          "Yap",
          "Wan",
          "Yee",
          "Yip",
          "Tey",
          "Ow",
          "Liu",
          "Tham",
          "See",
          "Woo",
          "Heng",
          "Leow",
          "Chen",
          "Foo",
          "Poh"
        ],
        "male_english_name": [
          "Leon",
          "Bryan",
          "Jack",
          "Stephen",
          "Andy",
          "Jerome",
          "Ian",
          "Desmond",
          "Lucas",
          "Morgan",
          "Keith",
          "Ivan",
          "Gavin",
          "Winson",
          "Raynor",
          "Ryan",
          "Kenson",
          "Benjamin",
          "Benny",
          "Eugene",
          "Melvin",
          "Shawn",
          "Aaron",
          "Justin",
          "Emmanuel",
          "Steven",
          "Joshua",
          "Terence",
          "Darren",
          "Daniel",
          "Aloysius",
          "John",
          "Jeremy",
          "Wilson",
          "Dave",
          "Vincent",
          "Ryan",
          "Sebastian",
          "Edward",
          "Daryl",
          "Eddy",
          "William",
          "Jason",
          "Nicholas",
          "Brian",
          "Sean",
          "Calvin",
          "Russell",
          "Raphael",
          "Kenneth",
          "Angus",
          "James",
          "Dennis",
          "Mark",
          "Jedd",
          "Sherman",
          "Marvin",
          "Edmund",
          "Henry",
          "Kevin",
          "Vernon",
          "Benedict",
          "Brendan",
          "Gilbert",
          "Josh",
          "Jay",
          "Winston",
          "Nicholas",
          "Eric",
          "Daren",
          "Nelson",
          "Xavier",
          "Glen",
          "Gabriel",
          "Matthew",
          "Tristan"
        ],
        "male_first_name": [
          "Jin Quan",
          "Wen Jun",
          "Jun Jie",
          "Cheng Han",
          "Tze-Kwang",
          "Jin Leong",
          "Zi Liang",
          "Zhi Ren",
          "Jin Quan",
          "Wen Jun",
          "Chee Hin",
          "Guo Jun",
          "Kai Jie",
          "Kun Qiang",
          "Jun Kiat",
          "Yong Zheng",
          "Yong Jun",
          "Chit Boon",
          "You Ren",
          "Wen Zhong",
          "Yang Shun",
          "Qi Guang",
          "Kang Soon",
          "Wee Heng",
          "Kah Yang",
          "Siew Beng",
          "Jia Woei",
          "Chean Meng",
          "Wai Kay",
          "Keng Hua",
          "Yew Meng",
          "Cheng Wen",
          "Jiun Wei",
          "Yee Sian",
          "Shao Hong",
          "Bin Shen",
          "Wing Yiu",
          "Ee Hong",
          "Yu Pyn",
          "Yong Sheng",
          "Jun Peng",
          "Jia Jie",
          "Guang Yi",
          "Si Heng",
          "Wei Hou",
          "Kang Sheng",
          "Hong Ern",
          "Jia Liang",
          "Wei Lip",
          "Wee Chen",
          "Wee Leng",
          "Yu Xi",
          "Ming Yang",
          "Wen Hao",
          "Siang Meng",
          "Mong Li",
          "Ghim Huat",
          "Jun Yi",
          "Jie Kai",
          "Zhiming",
          "Wei Jie",
          "Teng Qing",
          "Wei Jian",
          "Wei Kwan",
          "Chee Chin",
          "Chun Mun",
          "Ming Hui",
          "Chuan Yeong",
          "Yee Jen",
          "Sin Tian",
          "Jun Hao",
          "Wai Kit",
          "Wei Jie",
          "Zhi Wei",
          "Yan Han",
          "Guo Qiang",
          "Juin Wen",
          "Jun Wei",
          "Jia Jun",
          "You Ming",
          "Kok Keng",
          "Jing Hui",
          "Yi Hui",
          "Peck Seng",
          "Yu Ming",
          "Yan Ming",
          "Wang Jie",
          "Wei Jian",
          "Wei Xiang",
          "Jian Yu",
          "Kah Seng",
          "Jia Woei",
          "Li Heng",
          "Shao Quan"
        ],
        "name": [
          "#{last_name} #{male_first_name}",
          "#{male_english_name} #{last_name} #{male_first_name}",
          "#{last_name} #{female_first_name}",
          "#{female_english_name} #{last_name} #{female_first_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "65"
        ],
        "formats": [
          "6### ####",
          "9### ####",
          "8### ####"
        ]
      },
      "vehicle": {
        "license_plate": "S??####"
      }
    }
  },
  "en-TH": {
    "faker": {
      "name": {
        "first_name": [
          "A-gun",
          "A-wut",
          "Aat",
          "Aawut",
          "Achara",
          "Adranuch",
          "Ambhom",
          "Anada",
          "Ananada",
          "Anchali",
          "Anuman",
          "Anurak",
          "Apasra",
          "Apsara",
          "Aran",
          "Aroon",
          "Asnee",
          "Atid",
          "Benjakalyani",
          "Boon-Mee",
          "Boon-Nam",
          "Boribun",
          "Bun Ma",
          "Buppha",
          "Busaba",
          "Bussaba",
          "Chaem Choi",
          "Chai Charoen",
          "Chai Son",
          "Chailai",
          "Chaisai",
          "Chaisee",
          "Chaiya",
          "Chaiyo",
          "Chakan",
          "Chalerm",
          "Chalermchai",
          "Chalermwan",
          "Chaloem Chai",
          "Chaloem",
          "Channarong",
          "Chantana",
          "Chanthira",
          "Chao Fah",
          "Charanya",
          "Chariya",
          "Charn Chai",
          "Charoen",
          "Charoenrasamee",
          "Charong",
          "Charunee",
          "Chatalerm",
          "Chatchada",
          "Chatchom",
          "Chatmanee",
          "Chatrasuda",
          "Chatri",
          "Chaveevan",
          "Chayan",
          "Chet",
          "Chimlin",
          "Chinda",
          "Chintana",
          "Chirawan",
          "Chomechai",
          "Chomesri",
          "Chompoo",
          "Chongrak",
          "Choochai",
          "Chuachai",
          "Chuachan",
          "Chuanchen",
          "Chuasiri",
          "Chuenchai",
          "Chula",
          "Chulamai",
          "Churai",
          "Dao",
          "Dara",
          "Daw",
          "Decha",
          "Dok Mai",
          "Dok Phi Sua",
          "Dok Rak",
          "Dok-Ban-Yen",
          "Dusadi",
          "Fa Ying",
          "Han",
          "Hansa",
          "Hanuman",
          "Hom",
          "Isra",
          "Ittiporn",
          "Kaew",
          "Kalaya",
          "Kamala",
          "Kamlai",
          "Kamnan",
          "Kanchana",
          "Kannika",
          "Kanok",
          "Kanya",
          "Karawek",
          "Karnchana",
          "Kasem",
          "Kasemchai",
          "Khemkhaeng",
          "Khiew Wan",
          "Khun Mae",
          "Kiet",
          "Kit",
          "Kitti",
          "Kittibun",
          "Kittichai",
          "Kittichat",
          "Kla Han",
          "Kla",
          "Klaew Kla",
          "Klahan",
          "Kob Chai",
          "Kob Khun",
          "Kob Sinn",
          "Kob Sook",
          "Kohsoom",
          "Kosum",
          "Kovit",
          "Kraisee",
          "Kraisingha",
          "Kriang Krai",
          "Kriang Sak",
          "Kris",
          "Kukrit",
          "Kulap",
          "Kusa",
          "Kwanchai",
          "Kwang",
          "Kwanjai",
          "Lamai",
          "Lamon",
          "Lawan",
          "Lek",
          "Madee",
          "Mae Noi",
          "Malee",
          "Mali",
          "Malivalaya",
          "Maliwan",
          "Mani",
          "Mayuree",
          "Mee Noi",
          "Mekhala",
          "Mongkut",
          "Muan Nang",
          "Narong",
          "Ngam-Chit",
          "Ngoen",
          "Nin",
          "Niran",
          "Nong Yao",
          "On Choi",
          "On",
          "Paitoon",
          "Pakpao",
          "Pen-Chan",
          "Pensri",
          "Phaibun",
          "Phailin",
          "Phairoh",
          "Phanumas",
          "Phassakorn",
          "Phawta",
          "Phet",
          "Phichai",
          "Phichit",
          "Phitsamai",
          "Phloi",
          "Phueng",
          "Pichai",
          "Pimchan",
          "Piyabutr",
          "Pravat",
          "Prayut",
          "Pricha",
          "Prija",
          "Prisana",
          "Pu Yai Bahn",
          "Puenthai",
          "Pundit",
          "Rama",
          "Ratana",
          "Ratanaporn",
          "Ritthirong",
          "Rochana",
          "Rom Ran",
          "Ruang Rit",
          "Ruang Sak",
          "Runrot",
          "Saengdao",
          "Sajja",
          "Sakda",
          "Samorn",
          "Sanan Nam",
          "Sanoh",
          "Sanouk",
          "Santichai",
          "Sanun",
          "Sanya",
          "Sap",
          "Sarai",
          "Sarakit",
          "Sataheep",
          "Satra",
          "Sawatdi",
          "Seni",
          "Si Fah",
          "Si Mok",
          "Si",
          "Sin",
          "Sinn",
          "Solada",
          "Som Chai",
          "Som Kid",
          "Som Phon",
          "Som Phong",
          "Som Wang",
          "Som",
          "Somchair",
          "Son Chai",
          "Sonchai",
          "Songsuda",
          "Sopa",
          "Sroy",
          "Su Suk",
          "Suchada",
          "Suchin",
          "Sud Saming",
          "Sud",
          "Suda",
          "Sukhon",
          "Sukonta",
          "Sum",
          "Sumalee",
          "Sumana",
          "Sumatra",
          "Sunan",
          "Sunee",
          "Sunstra",
          "Sunti",
          "Sup",
          "Taeng",
          "Tansanee",
          "Tha Kai Bok",
          "Thahan",
          "Thai",
          "Thaklaew",
          "Tham-Boon",
          "Thanom",
          "Thapthim",
          "Thinnakorn",
          "Thong Daeng",
          "Thong Dam",
          "Thong Di",
          "Thong Khao",
          "Thong Kon",
          "Thong Thaem",
          "Thong Thaeng",
          "Thong Thao",
          "Thong",
          "Thuanthong",
          "Ti Nung Cha",
          "Tida",
          "Totsaken",
          "Tukata",
          "Ubol",
          "Udom",
          "Vanida",
          "Vidura",
          "Virote",
          "Waan",
          "Waen",
          "Wila",
          "Winai",
          "Wipa",
          "Xuwicha",
          "Ya Chai",
          "Yindee",
          "Ying",
          "Yod Rak",
          "Yong-Yut",
          "Yu-Pha",
          "Yu-Phin",
          "Yuthakon"
        ],
        "last_name": [
          "Aromdee",
          "Atitarn",
          "Bunyasarn",
          "Chaiprasit",
          "Chaisurivirat",
          "Chiawat",
          "Jetatikarn",
          "Jetjirawat",
          "Juntasa",
          "Kadesadayurat",
          "Kaewburesai",
          "Kaouthai",
          "Kasamsun",
          "Kitjakarn",
          "Kongkatitum",
          "Kongpaisarn",
          "Kongsangchai",
          "Kraiputra",
          "Kunakorn",
          "Kunchai",
          "Kurusarttra",
          "Leekpai",
          "Leelapun",
          "Lertkunakorn",
          "Maleenon",
          "Maneerattana",
          "Meesang",
          "Narkbunnum",
          "Narkhirunkanok",
          "Nimitwanitch",
          "Ornlamai",
          "Paowsong",
          "Parnpradub",
          "Parnthong",
          "Pornpipatpong",
          "Prasongsanti",
          "Puntasrima",
          "Punyawong",
          "Rojjanasukchai",
          "Rojumanong",
          "Saenamuang",
          "Sakda",
          "Sangsorn",
          "Shinawatra",
          "Sirisopa",
          "Somwan",
          "Songprawati",
          "Sripituksakul",
          "Srisati",
          "Sriwarunyu",
          "Sukbunsung",
          "Suntornnitikul",
          "Suppamongkon",
          "Suttirat",
          "Tawisuwan",
          "Thumying",
          "Tuntayakul",
          "Udomprecha",
          "Vipavakit",
          "Visalyaputra",
          "Wattanapanit",
          "Wattanasin",
          "Yongjaiyut"
        ]
      }
    }
  },
  "en-TT": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "TT$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-UG": {
    "faker": {
      "address": {
        "city": [
          "#{city_names}"
        ],
        "city_names": [
          "Alebtong",
          "Abim",
          "Adjumani",
          "Amolatar",
          "Amuria",
          "Amuru",
          "Apac",
          "Arua",
          "Bombo",
          "Budaka",
          "Bugembe",
          "Bugiri",
          "Bukedea",
          "Bulisa",
          "Buikwe",
          "Bundibugyo",
          "Busembatya",
          "Bushenyi",
          "Busia",
          "Busolwe",
          "Butaleja",
          "Buwenge",
          "Dokolo",
          "Entebbe",
          "Fort Portal",
          "Gulu",
          "Hima",
          "Hoima",
          "Ibanda",
          "Iganga",
          "Isingiro",
          "Jinja",
          "Kaabong",
          "Kabale",
          "Kaberamaido",
          "Kabwohe",
          "Kagadi",
          "Kakinga",
          "Kakiri",
          "Kalangala",
          "Kaliro",
          "Kalisizo",
          "Kalongo",
          "Kalungu",
          "Kampala",
          "Kamuli",
          "Kanoni",
          "Kamwenge",
          "Kanungu",
          "Kapchorwa",
          "Kasese",
          "Katakwi",
          "Kayunga",
          "Kibaale",
          "Kiboga",
          "Kihiihi",
          "Kiira",
          "Kiruhura",
          "Kiryandongo",
          "Kisoro",
          "Kitgum",
          "Koboko",
          "Kotido",
          "Kumi",
          "Kyenjojo",
          "Kyotera",
          "Lira",
          "Lugazi",
          "Lukaya",
          "Luwero",
          "Lwakhakha",
          "Lwengo",
          "Lyantonde",
          "Malaba",
          "Manafwa",
          "Masaka",
          "Masindi",
          "Masindi Port",
          "Matugga",
          "Mayuge",
          "Mbale",
          "Mbarara",
          "Mitooma",
          "Mityana",
          "Mpigi",
          "Mpondwe",
          "Moroto",
          "Moyo",
          "Mubende",
          "Mukono",
          "Mutukula",
          "Nagongera",
          "Nakaseke",
          "Nakasongola",
          "Nakapiripirit",
          "Namutumba",
          "Nansana",
          "Nebbi",
          "Ngora",
          "Njeru",
          "Nkokonjeru",
          "Ntungamo",
          "Oyam",
          "Pader",
          "Paidha",
          "Pakwach",
          "Pallisa",
          "Rakai",
          "Rukungiri",
          "Sembabule",
          "Sironko",
          "Soroti",
          "Tororo",
          "Wakiso",
          "Wobulenzi",
          "Yumbe"
        ],
        "default_country": [
          "Uganda",
          "The Republic of Uganda",
          "UG"
        ],
        "default_country_code": [
          "UG"
        ],
        "district": [
          "#{district_names}"
        ],
        "district_names": [
          "Abim",
          "Adjumani",
          "Agago",
          "Alebtong",
          "Amolatar",
          "Amudat",
          "Amuria",
          "Amuru",
          "Apac",
          "Arua",
          "Budaka",
          "Bududa",
          "Bugiri",
          "Buhweju",
          "Buikwe",
          "Bukedea",
          "Bukomansimbi",
          "Bukwo",
          "Bulambuli",
          "Buliisa",
          "Bundibugyo",
          "Bushenyi",
          "Busia",
          "Butaleja",
          "Butambala",
          "Buvuma",
          "Buyende",
          "Dokolo",
          "Gomba",
          "Gulu",
          "Hoima",
          "Ibanda",
          "Iganga",
          "Isingiro",
          "Jinja",
          "Kaabong",
          "Kabale",
          "Kabarole",
          "Kaberamaido",
          "Kalangala",
          "Kaliro",
          "Kalungu",
          "Kampala",
          "Kamuli",
          "Kamwenge",
          "Kanungu",
          "Kapchorwa",
          "Kasese",
          "Katakwi",
          "Kayunga",
          "Kibaale",
          "Kiboga",
          "Kibuku",
          "Kigezi",
          "Kiruhura",
          "Kiryandongo",
          "Kisoro",
          "Kitgum",
          "Koboko",
          "Kole",
          "Kotido",
          "Kumi",
          "Kween",
          "Kyankwanzi",
          "Kyegegwa",
          "Kyenjojo",
          "Lamwo",
          "Lira",
          "Luuka",
          "Luweero",
          "Lwengo",
          "Lyantonde",
          "Manafwa",
          "Maracha",
          "Maracha-Terego",
          "Masaka",
          "Masindi",
          "Mayuge",
          "Mbale",
          "Mbarara",
          "Mitooma",
          "Mityana",
          "Moroto",
          "Moyo",
          "Mpigi",
          "Mubende",
          "Mukono",
          "Nakapiripirit",
          "Nakaseke",
          "Nakasongola",
          "Namayingo",
          "Namutumba",
          "Napak",
          "Nebbi",
          "Ngora",
          "Ntoroko",
          "Ntungamo",
          "Nwoya",
          "Otuke",
          "Oyam",
          "Pader",
          "Pallisa",
          "Rakai",
          "Rubirizi",
          "Rukungiri",
          "Sembabule",
          "Serere",
          "Sheema",
          "Sironko",
          "Soroti",
          "Tororo",
          "Wakiso",
          "Yumbe",
          "Zombo"
        ],
        "region": [
          "#{regions}"
        ],
        "regions": [
          "Central",
          "East",
          "North",
          "West"
        ]
      },
      "cell_phone": {
        "formats": [
          "+256 79# ### ###",
          "256 79# ### ###",
          "0 79# ### ###",
          "+256 70# ### ###",
          "256 70# ### ###",
          "0 70# ### ###",
          "+256 75# ### ###",
          "256 75# ### ###",
          "0 75# ### ###",
          "+256 77# ### ###",
          "256 77# ### ###",
          "0 77# ### ###",
          "+256 78# ### ###",
          "256 78# ### ###",
          "0 78# ### ###",
          "+256 74# ### ###",
          "256 74# ### ###",
          "0 74# ### ###",
          "+256 71# ### ###",
          "256 71# ### ###",
          "0 71# ### ###",
          "+256 72# ### ###",
          "256 72# ### ###",
          "0 72# ### ###"
        ]
      },
      "internet": {
        "domain_suffix": [
          "ug",
          "com",
          "org",
          "co.ug",
          "org.ug",
          "net"
        ]
      },
      "name": {
        "last_name": [
          "Abayisenga",
          "Agaba",
          "Ahebwe",
          "Aisu",
          "Akankunda",
          "Akankwasa",
          "Akashaba",
          "Akashabe",
          "Ampumuza",
          "Ankunda",
          "Asasira",
          "Asiimwe",
          "Atuhe",
          "Atuhire",
          "Atukunda",
          "Atukwase",
          "Atwine",
          "Aurishaba",
          "Badru",
          "Baguma",
          "Bakabulindi",
          "Bamwiine",
          "Barigye",
          "Bbosa",
          "Bisheko",
          "Biyinzika",
          "Bugala",
          "Bukenya",
          "Buyinza",
          "Bwana",
          "Byanyima",
          "Byaruhanga",
          "Ddamulira",
          "Gamwera",
          "Ijaga",
          "Isyagi",
          "Kaaya",
          "Kabanda",
          "Kabuubi",
          "Kabuye",
          "Kafeero",
          "Kagambira",
          "Kakooza",
          "Kalumba",
          "Kanshabe",
          "Kansiime",
          "Kanyesigye",
          "Kareiga",
          "Kasekende",
          "Kasumba",
          "Kateregga",
          "Katusiime",
          "Kawooya",
          "Kawuki",
          "Kayemba",
          "Kazibwe",
          "Kibirige",
          "Kiconco",
          "Kiganda",
          "Kijjoba",
          "Kirabira",
          "Kirabo",
          "Kirigwajjo",
          "Kisitu",
          "Kitovu",
          "Kityamuwesi",
          "Kivumbi",
          "Kiwanuka",
          "Kyambadde",
          "Lunyoro",
          "Mbabazi",
          "Migisha",
          "Mugisa",
          "Mugisha",
          "Muhwezi",
          "Mukalazi",
          "Mulalira",
          "Munyagwa",
          "Murungi",
          "Mushabe",
          "Musinguzi",
          "Mutabuza",
          "Muyambi",
          "Mwesige",
          "Mwesigye",
          "Nabasa",
          "Nabimanya",
          "Nankunda",
          "Natukunda",
          "Nayebare",
          "Nimukunda",
          "Ninsiima",
          "Nkoojo",
          "Nkurunungi",
          "Nuwagaba",
          "Nuwamanya",
          "Nyeko",
          "Obol",
          "Odeke",
          "Okumu",
          "Okumuringa",
          "Opega",
          "Orishaba",
          "Osiki",
          "Ouma",
          "Rubalema",
          "Rusiimwa",
          "Rwabyoma",
          "Tamale",
          "Tendo",
          "Tizikara",
          "Tuhame",
          "Tumusiime",
          "Tumwebaze",
          "Tumwesigye",
          "Tumwiine",
          "Turyasingura",
          "Tusiime",
          "Twasiima",
          "Twesigomwe",
          "Wasswa",
          "Wavamuno",
          "Were"
        ]
      },
      "phone_number": {
        "formats": [
          "256 39# ### ###",
          "+256 39# ### ###",
          "039# ### ###",
          "256 41# ### ###",
          "+256 41# ### ###",
          "041# ### ###"
        ]
      }
    }
  },
  "en-US": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%m-%d-%Y",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "month",
        "day",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#####",
          "####",
          "###"
        ],
        "city": [
          "#{city_prefix} #{Name.first_name}#{city_suffix}",
          "#{city_prefix} #{Name.first_name}",
          "#{Name.first_name}#{city_suffix}",
          "#{Name.last_name}#{city_suffix}"
        ],
        "city_prefix": [
          "North",
          "East",
          "West",
          "South",
          "New",
          "Lake",
          "Port"
        ],
        "city_suffix": [
          "town",
          "ton",
          "land",
          "ville",
          "berg",
          "burgh",
          "borough",
          "bury",
          "view",
          "port",
          "mouth",
          "stad",
          "furt",
          "chester",
          "mouth",
          "fort",
          "haven",
          "side",
          "shire"
        ],
        "default_country": [
          "United States",
          "United States of America",
          "USA"
        ],
        "default_country_code": [
          "US"
        ],
        "full_address": [
          "#{street_address}, #{city}, #{state_abbr} #{postcode}",
          "#{secondary_address} #{street_address}, #{city}, #{state_abbr} #{postcode}"
        ],
        "postcode": [
          "#####",
          "#####-####"
        ],
        "postcode_by_state": {
          "AK": "995##",
          "AL": "350##",
          "AR": "717##",
          "AS": "967##",
          "AZ": "850##",
          "CA": "900##",
          "CO": "800##",
          "CT": "061##",
          "DC": "204##",
          "DE": "198##",
          "FL": "322##",
          "GA": "301##",
          "HI": "967##",
          "IA": "510##",
          "ID": "832##",
          "IL": "600##",
          "IN": "463##",
          "KS": "666##",
          "KY": "404##",
          "LA": "701##",
          "MA": "026##",
          "MD": "210##",
          "ME": "042##",
          "MI": "480##",
          "MN": "555##",
          "MO": "650##",
          "MS": "387##",
          "MT": "590##",
          "NC": "288##",
          "ND": "586##",
          "NE": "688##",
          "NH": "036##",
          "NJ": "076##",
          "NM": "880##",
          "NV": "898##",
          "NY": "122##",
          "OH": "444##",
          "OK": "730##",
          "OR": "979##",
          "PA": "186##",
          "RI": "029##",
          "SC": "299##",
          "SD": "577##",
          "TN": "383##",
          "TX": "798##",
          "UT": "847##",
          "VA": "222##",
          "VT": "050##",
          "WA": "990##",
          "WI": "549##",
          "WV": "247##",
          "WY": "831##"
        },
        "secondary_address": [
          "Apt. ###",
          "Suite ###"
        ],
        "state_abbr": [
          "AL",
          "AK",
          "AZ",
          "AR",
          "CA",
          "CO",
          "CT",
          "DE",
          "FL",
          "GA",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "OH",
          "OK",
          "OR",
          "PA",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UT",
          "VT",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY"
        ],
        "street_address": [
          "#{building_number} #{street_name}"
        ],
        "street_name": [
          "#{Name.first_name} #{street_suffix}",
          "#{Name.last_name} #{street_suffix}"
        ],
        "street_suffix": [
          "Alley",
          "Avenue",
          "Branch",
          "Bridge",
          "Brook",
          "Brooks",
          "Burg",
          "Burgs",
          "Bypass",
          "Camp",
          "Canyon",
          "Cape",
          "Causeway",
          "Center",
          "Centers",
          "Circle",
          "Circles",
          "Cliff",
          "Cliffs",
          "Club",
          "Common",
          "Corner",
          "Corners",
          "Course",
          "Court",
          "Courts",
          "Cove",
          "Coves",
          "Creek",
          "Crescent",
          "Crest",
          "Crossing",
          "Crossroad",
          "Curve",
          "Dale",
          "Dam",
          "Divide",
          "Drive",
          "Drive",
          "Drives",
          "Estate",
          "Estates",
          "Expressway",
          "Extension",
          "Extensions",
          "Fall",
          "Falls",
          "Ferry",
          "Field",
          "Fields",
          "Flat",
          "Flats",
          "Ford",
          "Fords",
          "Forest",
          "Forge",
          "Forges",
          "Fork",
          "Forks",
          "Fort",
          "Freeway",
          "Garden",
          "Gardens",
          "Gateway",
          "Glen",
          "Glens",
          "Green",
          "Greens",
          "Grove",
          "Groves",
          "Harbor",
          "Harbors",
          "Haven",
          "Heights",
          "Highway",
          "Hill",
          "Hills",
          "Hollow",
          "Inlet",
          "Inlet",
          "Island",
          "Island",
          "Islands",
          "Islands",
          "Isle",
          "Isle",
          "Junction",
          "Junctions",
          "Key",
          "Keys",
          "Knoll",
          "Knolls",
          "Lake",
          "Lakes",
          "Land",
          "Landing",
          "Lane",
          "Light",
          "Lights",
          "Loaf",
          "Lock",
          "Locks",
          "Locks",
          "Lodge",
          "Lodge",
          "Loop",
          "Mall",
          "Manor",
          "Manors",
          "Meadow",
          "Meadows",
          "Mews",
          "Mill",
          "Mills",
          "Mission",
          "Mission",
          "Motorway",
          "Mount",
          "Mountain",
          "Mountain",
          "Mountains",
          "Mountains",
          "Neck",
          "Orchard",
          "Oval",
          "Overpass",
          "Park",
          "Parks",
          "Parkway",
          "Parkways",
          "Pass",
          "Passage",
          "Path",
          "Pike",
          "Pine",
          "Pines",
          "Place",
          "Plain",
          "Plains",
          "Plains",
          "Plaza",
          "Plaza",
          "Point",
          "Points",
          "Port",
          "Port",
          "Ports",
          "Ports",
          "Prairie",
          "Prairie",
          "Radial",
          "Ramp",
          "Ranch",
          "Rapid",
          "Rapids",
          "Rest",
          "Ridge",
          "Ridges",
          "River",
          "Road",
          "Road",
          "Roads",
          "Roads",
          "Route",
          "Row",
          "Rue",
          "Run",
          "Shoal",
          "Shoals",
          "Shore",
          "Shores",
          "Skyway",
          "Spring",
          "Springs",
          "Springs",
          "Spur",
          "Spurs",
          "Square",
          "Square",
          "Squares",
          "Squares",
          "Station",
          "Station",
          "Stravenue",
          "Stravenue",
          "Stream",
          "Stream",
          "Street",
          "Street",
          "Streets",
          "Summit",
          "Summit",
          "Terrace",
          "Throughway",
          "Trace",
          "Track",
          "Trafficway",
          "Trail",
          "Trail",
          "Tunnel",
          "Tunnel",
          "Turnpike",
          "Turnpike",
          "Underpass",
          "Union",
          "Unions",
          "Valley",
          "Valleys",
          "Via",
          "Viaduct",
          "View",
          "Views",
          "Village",
          "Village",
          "Villages",
          "Ville",
          "Vista",
          "Vista",
          "Walk",
          "Walks",
          "Wall",
          "Way",
          "Ways",
          "Well",
          "Wells"
        ]
      },
      "cell_phone": {
        "formats": [
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}"
        ]
      },
      "id_number": {
        "invalid": [
          "000-##-####",
          "###-00-####",
          "###-##-0000",
          "666-##-####",
          "9##-##-####"
        ],
        "valid": "#{IdNumber.ssn_valid}"
      },
      "internet": {
        "domain_suffix": [
          "com",
          "us",
          "biz",
          "info",
          "name",
          "net",
          "org",
          "io",
          "co"
        ]
      },
      "name": {
        "female_first_name": [
          "Abbey",
          "Abbie",
          "Abby",
          "Abigail",
          "Ada",
          "Adah",
          "Adaline",
          "Addie",
          "Adela",
          "Adelaida",
          "Adelaide",
          "Adele",
          "Adelia",
          "Adelina",
          "Adeline",
          "Adell",
          "Adella",
          "Adelle",
          "Adena",
          "Adina",
          "Adria",
          "Adrian",
          "Adriana",
          "Adriane",
          "Adrianna",
          "Adrianne",
          "Adrien",
          "Adriene",
          "Adrienne",
          "Afton",
          "Agatha",
          "Agnes",
          "Agnus",
          "Agripina",
          "Agueda",
          "Agustina",
          "Ai",
          "Aida",
          "Aide",
          "Aiko",
          "Aileen",
          "Ailene",
          "Aimee",
          "Aisha",
          "Aja",
          "Akiko",
          "Akilah",
          "Alaina",
          "Alaine",
          "Alana",
          "Alane",
          "Alanna",
          "Alayna",
          "Alba",
          "Albert",
          "Alberta",
          "Albertha",
          "Albertina",
          "Albertine",
          "Albina",
          "Alda",
          "Alease",
          "Alecia",
          "Aleen",
          "Aleida",
          "Aleisha",
          "Alejandra",
          "Alejandrina",
          "Alena",
          "Alene",
          "Alesha",
          "Aleshia",
          "Alesia",
          "Alessandra",
          "Aleta",
          "Aletha",
          "Alethea",
          "Alethia",
          "Alex",
          "Alexa",
          "Alexander",
          "Alexandra",
          "Alexandria",
          "Alexia",
          "Alexis",
          "Alfreda",
          "Alfredia",
          "Ali",
          "Alia",
          "Alica",
          "Alice",
          "Alicia",
          "Alida",
          "Alina",
          "Aline",
          "Alisa",
          "Alise",
          "Alisha",
          "Alishia",
          "Alisia",
          "Alison",
          "Alissa",
          "Alita",
          "Alix",
          "Aliza",
          "Alla",
          "Alleen",
          "Allegra",
          "Allen",
          "Allena",
          "Allene",
          "Allie",
          "Alline",
          "Allison",
          "Allyn",
          "Allyson",
          "Alma",
          "Almeda",
          "Almeta",
          "Alona",
          "Alpha",
          "Alta",
          "Altagracia",
          "Altha",
          "Althea",
          "Alva",
          "Alvera",
          "Alverta",
          "Alvina",
          "Alyce",
          "Alycia",
          "Alysa",
          "Alyse",
          "Alysha",
          "Alysia",
          "Alyson",
          "Alyssa",
          "Amada",
          "Amal",
          "Amalia",
          "Amanda",
          "Amber",
          "Amberly",
          "Amee",
          "Amelia",
          "America",
          "Ami",
          "Amie",
          "Amiee",
          "Amina",
          "Amira",
          "Ammie",
          "Amparo",
          "Amy",
          "An",
          "Ana",
          "Anabel",
          "Analisa",
          "Anamaria",
          "Anastacia",
          "Anastasia",
          "Andera",
          "Andra",
          "Andre",
          "Andrea",
          "Andree",
          "Andrew",
          "Andria",
          "Anette",
          "Angel",
          "Angela",
          "Angele",
          "Angelena",
          "Angeles",
          "Angelia",
          "Angelic",
          "Angelica",
          "Angelika",
          "Angelina",
          "Angeline",
          "Angelique",
          "Angelita",
          "Angella",
          "Angelo",
          "Angelyn",
          "Angie",
          "Angila",
          "Angla",
          "Angle",
          "Anglea",
          "Anh",
          "Anika",
          "Anisa",
          "Anisha",
          "Anissa",
          "Anita",
          "Anitra",
          "Anja",
          "Anjanette",
          "Anjelica",
          "Ann",
          "Anna",
          "Annabel",
          "Annabell",
          "Annabelle",
          "Annalee",
          "Annalisa",
          "Annamae",
          "Annamaria",
          "Annamarie",
          "Anne",
          "Anneliese",
          "Annelle",
          "Annemarie",
          "Annett",
          "Annetta",
          "Annette",
          "Annice",
          "Annie",
          "Annika",
          "Annis",
          "Annita",
          "Annmarie",
          "Anthony",
          "Antionette",
          "Antoinette",
          "Antonetta",
          "Antonette",
          "Antonia",
          "Antonietta",
          "Antonina",
          "Antonio",
          "Anya",
          "Apolonia",
          "April",
          "Apryl",
          "Ara",
          "Araceli",
          "Aracelis",
          "Aracely",
          "Arcelia",
          "Ardath",
          "Ardelia",
          "Ardell",
          "Ardella",
          "Ardelle",
          "Ardis",
          "Ardith",
          "Aretha",
          "Argelia",
          "Argentina",
          "Ariana",
          "Ariane",
          "Arianna",
          "Arianne",
          "Arica",
          "Arie",
          "Ariel",
          "Arielle",
          "Arla",
          "Arlean",
          "Arleen",
          "Arlena",
          "Arlene",
          "Arletha",
          "Arletta",
          "Arlette",
          "Arlinda",
          "Arline",
          "Arlyne",
          "Armanda",
          "Armandina",
          "Armida",
          "Arminda",
          "Arnetta",
          "Arnette",
          "Arnita",
          "Arthur",
          "Artie",
          "Arvilla",
          "Asha",
          "Ashanti",
          "Ashely",
          "Ashlea",
          "Ashlee",
          "Ashleigh",
          "Ashley",
          "Ashli",
          "Ashlie",
          "Ashly",
          "Ashlyn",
          "Ashton",
          "Asia",
          "Asley",
          "Assunta",
          "Astrid",
          "Asuncion",
          "Athena",
          "Aubrey",
          "Audie",
          "Audra",
          "Audrea",
          "Audrey",
          "Audria",
          "Audrie",
          "Audry",
          "Augusta",
          "Augustina",
          "Augustine",
          "Aundrea",
          "Aura",
          "Aurea",
          "Aurelia",
          "Aurora",
          "Aurore",
          "Austin",
          "Autumn",
          "Ava",
          "Avelina",
          "Avery",
          "Avis",
          "Avril",
          "Awilda",
          "Ayako",
          "Ayana",
          "Ayanna",
          "Ayesha",
          "Azalee",
          "Azucena",
          "Azzie",
          "Babara",
          "Babette",
          "Bailey",
          "Bambi",
          "Bao",
          "Barabara",
          "Barb",
          "Barbar",
          "Barbara",
          "Barbera",
          "Barbie",
          "Barbra",
          "Bari",
          "Barrie",
          "Basilia",
          "Bea",
          "Beata",
          "Beatrice",
          "Beatris",
          "Beatriz",
          "Beaulah",
          "Bebe",
          "Becki",
          "Beckie",
          "Becky",
          "Bee",
          "Belen",
          "Belia",
          "Belinda",
          "Belkis",
          "Bell",
          "Bella",
          "Belle",
          "Belva",
          "Benita",
          "Bennie",
          "Berenice",
          "Berna",
          "Bernadette",
          "Bernadine",
          "Bernarda",
          "Bernardina",
          "Bernardine",
          "Berneice",
          "Bernetta",
          "Bernice",
          "Bernie",
          "Berniece",
          "Bernita",
          "Berry",
          "Berta",
          "Bertha",
          "Bertie",
          "Beryl",
          "Bess",
          "Bessie",
          "Beth",
          "Bethanie",
          "Bethann",
          "Bethany",
          "Bethel",
          "Betsey",
          "Betsy",
          "Bette",
          "Bettie",
          "Bettina",
          "Betty",
          "Bettyann",
          "Bettye",
          "Beula",
          "Beulah",
          "Bev",
          "Beverlee",
          "Beverley",
          "Beverly",
          "Bianca",
          "Bibi",
          "Billi",
          "Billie",
          "Billy",
          "Billye",
          "Birdie",
          "Birgit",
          "Blair",
          "Blake",
          "Blanca",
          "Blanch",
          "Blanche",
          "Blondell",
          "Blossom",
          "Blythe",
          "Bobbi",
          "Bobbie",
          "Bobby",
          "Bobbye",
          "Bobette",
          "Bok",
          "Bong",
          "Bonita",
          "Bonnie",
          "Bonny",
          "Branda",
          "Brande",
          "Brandee",
          "Brandi",
          "Brandie",
          "Brandon",
          "Brandy",
          "Breana",
          "Breann",
          "Breanna",
          "Breanne",
          "Bree",
          "Brenda",
          "Brenna",
          "Brett",
          "Brian",
          "Briana",
          "Brianna",
          "Brianne",
          "Bridget",
          "Bridgett",
          "Bridgette",
          "Brigette",
          "Brigid",
          "Brigida",
          "Brigitte",
          "Brinda",
          "Britany",
          "Britney",
          "Britni",
          "Britt",
          "Britta",
          "Brittaney",
          "Brittani",
          "Brittanie",
          "Brittany",
          "Britteny",
          "Brittney",
          "Brittni",
          "Brittny",
          "Bronwyn",
          "Brook",
          "Brooke",
          "Bruna",
          "Brunilda",
          "Bryanna",
          "Brynn",
          "Buena",
          "Buffy",
          "Bula",
          "Bulah",
          "Bunny",
          "Burma",
          "Caitlin",
          "Caitlyn",
          "Calandra",
          "Calista",
          "Callie",
          "Camelia",
          "Camellia",
          "Cameron",
          "Cami",
          "Camie",
          "Camila",
          "Camilla",
          "Camille",
          "Cammie",
          "Cammy",
          "Candace",
          "Candance",
          "Candelaria",
          "Candi",
          "Candice",
          "Candida",
          "Candie",
          "Candis",
          "Candra",
          "Candy",
          "Candyce",
          "Caprice",
          "Cara",
          "Caren",
          "Carey",
          "Cari",
          "Caridad",
          "Carie",
          "Carin",
          "Carina",
          "Carisa",
          "Carissa",
          "Carita",
          "Carl",
          "Carla",
          "Carlee",
          "Carleen",
          "Carlena",
          "Carlene",
          "Carletta",
          "Carley",
          "Carli",
          "Carlie",
          "Carline",
          "Carlita",
          "Carlos",
          "Carlota",
          "Carlotta",
          "Carly",
          "Carlyn",
          "Carma",
          "Carman",
          "Carmel",
          "Carmela",
          "Carmelia",
          "Carmelina",
          "Carmelita",
          "Carmella",
          "Carmen",
          "Carmina",
          "Carmon",
          "Carol",
          "Carola",
          "Carolann",
          "Carole",
          "Carolee",
          "Carolin",
          "Carolina",
          "Caroline",
          "Caroll",
          "Carolyn",
          "Carolyne",
          "Carolynn",
          "Caron",
          "Caroyln",
          "Carri",
          "Carrie",
          "Carrol",
          "Carroll",
          "Carry",
          "Cary",
          "Caryl",
          "Carylon",
          "Caryn",
          "Casandra",
          "Casey",
          "Casie",
          "Casimira",
          "Cassandra",
          "Cassaundra",
          "Cassey",
          "Cassi",
          "Cassidy",
          "Cassie",
          "Cassondra",
          "Cassy",
          "Catalina",
          "Catarina",
          "Caterina",
          "Catharine",
          "Catherin",
          "Catherina",
          "Catherine",
          "Cathern",
          "Catheryn",
          "Cathey",
          "Cathi",
          "Cathie",
          "Cathleen",
          "Cathrine",
          "Cathryn",
          "Cathy",
          "Catina",
          "Catrice",
          "Catrina",
          "Cayla",
          "Cecelia",
          "Cecil",
          "Cecila",
          "Cecile",
          "Cecilia",
          "Cecille",
          "Cecily",
          "Celena",
          "Celesta",
          "Celeste",
          "Celestina",
          "Celestine",
          "Celia",
          "Celina",
          "Celinda",
          "Celine",
          "Celsa",
          "Ceola",
          "Chae",
          "Chan",
          "Chana",
          "Chanda",
          "Chandra",
          "Chanel",
          "Chanell",
          "Chanelle",
          "Chang",
          "Chantal",
          "Chantay",
          "Chante",
          "Chantel",
          "Chantell",
          "Chantelle",
          "Chara",
          "Charis",
          "Charise",
          "Charissa",
          "Charisse",
          "Charita",
          "Charity",
          "Charla",
          "Charleen",
          "Charlena",
          "Charlene",
          "Charles",
          "Charlesetta",
          "Charlette",
          "Charlie",
          "Charline",
          "Charlott",
          "Charlotte",
          "Charlsie",
          "Charlyn",
          "Charmain",
          "Charmaine",
          "Charolette",
          "Chasidy",
          "Chasity",
          "Chassidy",
          "Chastity",
          "Chau",
          "Chaya",
          "Chelsea",
          "Chelsey",
          "Chelsie",
          "Cher",
          "Chere",
          "Cheree",
          "Cherelle",
          "Cheri",
          "Cherie",
          "Cherilyn",
          "Cherise",
          "Cherish",
          "Cherly",
          "Cherlyn",
          "Cherri",
          "Cherrie",
          "Cherry",
          "Cherryl",
          "Chery",
          "Cheryl",
          "Cheryle",
          "Cheryll",
          "Cheyenne",
          "Chi",
          "Chia",
          "Chieko",
          "Chin",
          "China",
          "Ching",
          "Chiquita",
          "Chloe",
          "Chong",
          "Chris",
          "Chrissy",
          "Christa",
          "Christal",
          "Christeen",
          "Christel",
          "Christen",
          "Christena",
          "Christene",
          "Christi",
          "Christia",
          "Christian",
          "Christiana",
          "Christiane",
          "Christie",
          "Christin",
          "Christina",
          "Christine",
          "Christinia",
          "Christopher",
          "Christy",
          "Chrystal",
          "Chu",
          "Chun",
          "Chung",
          "Ciara",
          "Cicely",
          "Ciera",
          "Cierra",
          "Cinda",
          "Cinderella",
          "Cindi",
          "Cindie",
          "Cindy",
          "Cinthia",
          "Cira",
          "Clair",
          "Claire",
          "Clara",
          "Clare",
          "Clarence",
          "Claretha",
          "Claretta",
          "Claribel",
          "Clarice",
          "Clarinda",
          "Clarine",
          "Claris",
          "Clarisa",
          "Clarissa",
          "Clarita",
          "Classie",
          "Claude",
          "Claudette",
          "Claudia",
          "Claudie",
          "Claudine",
          "Clelia",
          "Clemencia",
          "Clementina",
          "Clementine",
          "Clemmie",
          "Cleo",
          "Cleopatra",
          "Cleora",
          "Cleotilde",
          "Cleta",
          "Clora",
          "Clorinda",
          "Clotilde",
          "Clyde",
          "Codi",
          "Cody",
          "Colby",
          "Coleen",
          "Colene",
          "Coletta",
          "Colette",
          "Colleen",
          "Collen",
          "Collene",
          "Collette",
          "Concepcion",
          "Conception",
          "Concetta",
          "Concha",
          "Conchita",
          "Connie",
          "Constance",
          "Consuela",
          "Consuelo",
          "Contessa",
          "Cora",
          "Coral",
          "Coralee",
          "Coralie",
          "Corazon",
          "Cordelia",
          "Cordia",
          "Cordie",
          "Coreen",
          "Corene",
          "Coretta",
          "Corey",
          "Cori",
          "Corie",
          "Corina",
          "Corine",
          "Corinna",
          "Corinne",
          "Corliss",
          "Cornelia",
          "Corrie",
          "Corrin",
          "Corrina",
          "Corrine",
          "Corrinne",
          "Cortney",
          "Cory",
          "Courtney",
          "Creola",
          "Cris",
          "Criselda",
          "Crissy",
          "Crista",
          "Cristal",
          "Cristen",
          "Cristi",
          "Cristie",
          "Cristin",
          "Cristina",
          "Cristine",
          "Cristy",
          "Cruz",
          "Crysta",
          "Crystal",
          "Crystle",
          "Cuc",
          "Curtis",
          "Cyndi",
          "Cyndy",
          "Cynthia",
          "Cyrstal",
          "Cythia",
          "Dacia",
          "Dagmar",
          "Dagny",
          "Dahlia",
          "Daina",
          "Daine",
          "Daisey",
          "Daisy",
          "Dakota",
          "Dale",
          "Dalene",
          "Dalia",
          "Dalila",
          "Dallas",
          "Damaris",
          "Dan",
          "Dana",
          "Danae",
          "Danelle",
          "Danette",
          "Dani",
          "Dania",
          "Danica",
          "Daniel",
          "Daniela",
          "Daniele",
          "Daniell",
          "Daniella",
          "Danielle",
          "Danika",
          "Danille",
          "Danita",
          "Dann",
          "Danna",
          "Dannette",
          "Dannie",
          "Dannielle",
          "Danuta",
          "Danyel",
          "Danyell",
          "Danyelle",
          "Daphine",
          "Daphne",
          "Dara",
          "Darby",
          "Darcel",
          "Darcey",
          "Darci",
          "Darcie",
          "Darcy",
          "Daria",
          "Darla",
          "Darleen",
          "Darlena",
          "Darlene",
          "Darline",
          "Darnell",
          "Daryl",
          "David",
          "Davida",
          "Davina",
          "Dawn",
          "Dawna",
          "Dawne",
          "Dayle",
          "Dayna",
          "Daysi",
          "Deadra",
          "Dean",
          "Deana",
          "Deandra",
          "Deandrea",
          "Deane",
          "Deann",
          "Deanna",
          "Deanne",
          "Deb",
          "Debbi",
          "Debbie",
          "Debbra",
          "Debby",
          "Debera",
          "Debi",
          "Debora",
          "Deborah",
          "Debra",
          "Debrah",
          "Debroah",
          "Dede",
          "Dedra",
          "Dee",
          "Deeann",
          "Deeanna",
          "Deedee",
          "Deedra",
          "Deena",
          "Deetta",
          "Deidra",
          "Deidre",
          "Deirdre",
          "Deja",
          "Delaine",
          "Delana",
          "Delcie",
          "Delena",
          "Delfina",
          "Delia",
          "Delicia",
          "Delila",
          "Delilah",
          "Delinda",
          "Delisa",
          "Dell",
          "Della",
          "Delma",
          "Delmy",
          "Delois",
          "Deloise",
          "Delora",
          "Deloras",
          "Delores",
          "Deloris",
          "Delorse",
          "Delpha",
          "Delphia",
          "Delphine",
          "Delsie",
          "Delta",
          "Demetra",
          "Demetria",
          "Demetrice",
          "Demetrius",
          "Dena",
          "Denae",
          "Deneen",
          "Denese",
          "Denice",
          "Denise",
          "Denisha",
          "Denisse",
          "Denita",
          "Denna",
          "Dennis",
          "Dennise",
          "Denny",
          "Denyse",
          "Deon",
          "Deonna",
          "Desirae",
          "Desire",
          "Desiree",
          "Despina",
          "Dessie",
          "Destiny",
          "Detra",
          "Devin",
          "Devon",
          "Devona",
          "Devora",
          "Devorah",
          "Dia",
          "Diamond",
          "Dian",
          "Diana",
          "Diane",
          "Diann",
          "Dianna",
          "Dianne",
          "Diedra",
          "Diedre",
          "Dierdre",
          "Digna",
          "Dimple",
          "Dina",
          "Dinah",
          "Dinorah",
          "Dion",
          "Dione",
          "Dionna",
          "Dionne",
          "Divina",
          "Dixie",
          "Dodie",
          "Dollie",
          "Dolly",
          "Dolores",
          "Doloris",
          "Domenica",
          "Dominga",
          "Dominica",
          "Dominique",
          "Dominque",
          "Domitila",
          "Domonique",
          "Dona",
          "Donald",
          "Donella",
          "Donetta",
          "Donette",
          "Dong",
          "Donita",
          "Donna",
          "Donnetta",
          "Donnette",
          "Donnie",
          "Donya",
          "Dora",
          "Dorathy",
          "Dorcas",
          "Doreatha",
          "Doreen",
          "Dorene",
          "Doretha",
          "Dorethea",
          "Doretta",
          "Dori",
          "Doria",
          "Dorian",
          "Dorie",
          "Dorinda",
          "Dorine",
          "Doris",
          "Dorla",
          "Dorotha",
          "Dorothea",
          "Dorothy",
          "Dorris",
          "Dortha",
          "Dorthea",
          "Dorthey",
          "Dorthy",
          "Dot",
          "Dottie",
          "Dotty",
          "Dovie",
          "Dreama",
          "Drema",
          "Drew",
          "Drucilla",
          "Drusilla",
          "Dulce",
          "Dulcie",
          "Dung",
          "Dusti",
          "Dusty",
          "Dwana",
          "Dyan",
          "Earlean",
          "Earleen",
          "Earlene",
          "Earlie",
          "Earline",
          "Earnestine",
          "Eartha",
          "Easter",
          "Eboni",
          "Ebonie",
          "Ebony",
          "Echo",
          "Eda",
          "Edda",
          "Eddie",
          "Edelmira",
          "Eden",
          "Edie",
          "Edith",
          "Edna",
          "Edra",
          "Edris",
          "Edward",
          "Edwina",
          "Edyth",
          "Edythe",
          "Effie",
          "Ehtel",
          "Eileen",
          "Eilene",
          "Ela",
          "Eladia",
          "Elaina",
          "Elaine",
          "Elana",
          "Elane",
          "Elanor",
          "Elayne",
          "Elba",
          "Elda",
          "Eldora",
          "Eleanor",
          "Eleanora",
          "Eleanore",
          "Elease",
          "Elena",
          "Elene",
          "Eleni",
          "Elenor",
          "Elenora",
          "Elenore",
          "Eleonor",
          "Eleonora",
          "Eleonore",
          "Elfreda",
          "Elfrieda",
          "Elfriede",
          "Elia",
          "Eliana",
          "Elicia",
          "Elida",
          "Elidia",
          "Elin",
          "Elina",
          "Elinor",
          "Elinore",
          "Elisa",
          "Elisabeth",
          "Elise",
          "Elisha",
          "Elissa",
          "Eliz",
          "Eliza",
          "Elizabet",
          "Elizabeth",
          "Elizbeth",
          "Elizebeth",
          "Elke",
          "Ella",
          "Ellamae",
          "Ellan",
          "Ellen",
          "Ellena",
          "Elli",
          "Ellie",
          "Ellis",
          "Elly",
          "Ellyn",
          "Elma",
          "Elmer",
          "Elmira",
          "Elna",
          "Elnora",
          "Elodia",
          "Elois",
          "Eloisa",
          "Eloise",
          "Elouise",
          "Elsa",
          "Else",
          "Elsie",
          "Elsy",
          "Elva",
          "Elvera",
          "Elvia",
          "Elvie",
          "Elvina",
          "Elvira",
          "Elwanda",
          "Elyse",
          "Elza",
          "Ema",
          "Emelda",
          "Emelia",
          "Emelina",
          "Emeline",
          "Emely",
          "Emerald",
          "Emerita",
          "Emiko",
          "Emilee",
          "Emilia",
          "Emilie",
          "Emily",
          "Emma",
          "Emmaline",
          "Emmie",
          "Emmy",
          "Emogene",
          "Ena",
          "Enda",
          "Enedina",
          "Eneida",
          "Enid",
          "Enola",
          "Enriqueta",
          "Epifania",
          "Era",
          "Eric",
          "Erica",
          "Ericka",
          "Erika",
          "Erin",
          "Erinn",
          "Erlene",
          "Erlinda",
          "Erline",
          "Erma",
          "Ermelinda",
          "Erminia",
          "Erna",
          "Ernestina",
          "Ernestine",
          "Eryn",
          "Esmeralda",
          "Esperanza",
          "Essie",
          "Esta",
          "Estefana",
          "Estela",
          "Estell",
          "Estella",
          "Estelle",
          "Ester",
          "Esther",
          "Estrella",
          "Etha",
          "Ethel",
          "Ethelene",
          "Ethelyn",
          "Ethyl",
          "Etsuko",
          "Etta",
          "Ettie",
          "Eufemia",
          "Eugena",
          "Eugene",
          "Eugenia",
          "Eugenie",
          "Eula",
          "Eulah",
          "Eulalia",
          "Eun",
          "Euna",
          "Eunice",
          "Eura",
          "Eusebia",
          "Eustolia",
          "Eva",
          "Evalyn",
          "Evan",
          "Evangelina",
          "Evangeline",
          "Eve",
          "Evelia",
          "Evelin",
          "Evelina",
          "Eveline",
          "Evelyn",
          "Evelyne",
          "Evelynn",
          "Evette",
          "Evia",
          "Evie",
          "Evita",
          "Evon",
          "Evonne",
          "Ewa",
          "Exie",
          "Fabiola",
          "Fae",
          "Fairy",
          "Faith",
          "Fallon",
          "Fannie",
          "Fanny",
          "Farah",
          "Farrah",
          "Fatima",
          "Fatimah",
          "Faustina",
          "Faviola",
          "Fawn",
          "Fay",
          "Faye",
          "Fe",
          "Felecia",
          "Felica",
          "Felice",
          "Felicia",
          "Felicidad",
          "Felicita",
          "Felicitas",
          "Felipa",
          "Felisa",
          "Felisha",
          "Fermina",
          "Fern",
          "Fernanda",
          "Fernande",
          "Ferne",
          "Fidela",
          "Fidelia",
          "Filomena",
          "Fiona",
          "Flavia",
          "Fleta",
          "Flo",
          "Flor",
          "Flora",
          "Florance",
          "Florence",
          "Florencia",
          "Florene",
          "Florentina",
          "Floretta",
          "Floria",
          "Florida",
          "Florinda",
          "Florine",
          "Florrie",
          "Flossie",
          "Floy",
          "Fonda",
          "Fran",
          "France",
          "Francene",
          "Frances",
          "Francesca",
          "Franchesca",
          "Francie",
          "Francina",
          "Francine",
          "Francis",
          "Francisca",
          "Francisco",
          "Francoise",
          "Frank",
          "Frankie",
          "Fransisca",
          "Fred",
          "Freda",
          "Fredda",
          "Freddie",
          "Frederica",
          "Fredericka",
          "Fredia",
          "Fredricka",
          "Freeda",
          "Freida",
          "Frida",
          "Frieda",
          "Fumiko",
          "Gabriel",
          "Gabriela",
          "Gabriele",
          "Gabriella",
          "Gabrielle",
          "Gail",
          "Gala",
          "Gale",
          "Galina",
          "Garnet",
          "Garnett",
          "Gary",
          "Gay",
          "Gaye",
          "Gayla",
          "Gayle",
          "Gaylene",
          "Gaynell",
          "Gaynelle",
          "Gearldine",
          "Gema",
          "Gemma",
          "Gena",
          "Gene",
          "Genesis",
          "Geneva",
          "Genevie",
          "Genevieve",
          "Genevive",
          "Genia",
          "Genie",
          "Genna",
          "Gennie",
          "Genny",
          "Genoveva",
          "Georgann",
          "George",
          "Georgeann",
          "Georgeanna",
          "Georgene",
          "Georgetta",
          "Georgette",
          "Georgia",
          "Georgiana",
          "Georgiann",
          "Georgianna",
          "Georgianne",
          "Georgie",
          "Georgina",
          "Georgine",
          "Gerald",
          "Geraldine",
          "Geralyn",
          "Gerda",
          "Geri",
          "Germaine",
          "Gerri",
          "Gerry",
          "Gertha",
          "Gertie",
          "Gertrud",
          "Gertrude",
          "Gertrudis",
          "Gertude",
          "Ghislaine",
          "Gia",
          "Gianna",
          "Gidget",
          "Gigi",
          "Gilberte",
          "Gilda",
          "Gillian",
          "Gilma",
          "Gina",
          "Ginette",
          "Ginger",
          "Ginny",
          "Giovanna",
          "Gisela",
          "Gisele",
          "Giselle",
          "Gita",
          "Giuseppina",
          "Gladis",
          "Glady",
          "Gladys",
          "Glayds",
          "Glenda",
          "Glendora",
          "Glenn",
          "Glenna",
          "Glennie",
          "Glennis",
          "Glinda",
          "Gloria",
          "Glory",
          "Glynda",
          "Glynis",
          "Golda",
          "Golden",
          "Goldie",
          "Grace",
          "Gracia",
          "Gracie",
          "Graciela",
          "Grayce",
          "Grazyna",
          "Gregoria",
          "Gregory",
          "Greta",
          "Gretchen",
          "Gretta",
          "Gricelda",
          "Grisel",
          "Griselda",
          "Guadalupe",
          "Gudrun",
          "Guillermina",
          "Gussie",
          "Gwen",
          "Gwenda",
          "Gwendolyn",
          "Gwenn",
          "Gwyn",
          "Gwyneth",
          "Ha",
          "Hae",
          "Hailey",
          "Haley",
          "Halina",
          "Halley",
          "Hallie",
          "Han",
          "Hana",
          "Hang",
          "Hanh",
          "Hanna",
          "Hannah",
          "Hannelore",
          "Harmony",
          "Harold",
          "Harriet",
          "Harriett",
          "Harriette",
          "Hassie",
          "Hattie",
          "Haydee",
          "Hayley",
          "Hazel",
          "Heather",
          "Hedwig",
          "Hedy",
          "Hee",
          "Heide",
          "Heidi",
          "Heidy",
          "Heike",
          "Helaine",
          "Helen",
          "Helena",
          "Helene",
          "Helga",
          "Hellen",
          "Henrietta",
          "Henriette",
          "Henry",
          "Herlinda",
          "Herma",
          "Hermelinda",
          "Hermila",
          "Hermina",
          "Hermine",
          "Herminia",
          "Herta",
          "Hertha",
          "Hester",
          "Hettie",
          "Hiedi",
          "Hien",
          "Hilaria",
          "Hilary",
          "Hilda",
          "Hilde",
          "Hildegard",
          "Hildegarde",
          "Hildred",
          "Hillary",
          "Hilma",
          "Hiroko",
          "Hisako",
          "Hoa",
          "Holley",
          "Holli",
          "Hollie",
          "Hollis",
          "Holly",
          "Honey",
          "Hong",
          "Hope",
          "Hortencia",
          "Hortense",
          "Hortensia",
          "Hsiu",
          "Hue",
          "Hui",
          "Hulda",
          "Huong",
          "Hwa",
          "Hyacinth",
          "Hye",
          "Hyo",
          "Hyon",
          "Hyun",
          "Ida",
          "Idalia",
          "Idell",
          "Idella",
          "Iesha",
          "Ignacia",
          "Ila",
          "Ilana",
          "Ilda",
          "Ileana",
          "Ileen",
          "Ilene",
          "Iliana",
          "Illa",
          "Ilona",
          "Ilse",
          "Iluminada",
          "Ima",
          "Imelda",
          "Imogene",
          "In",
          "Ina",
          "India",
          "Indira",
          "Inell",
          "Ines",
          "Inez",
          "Inga",
          "Inge",
          "Ingeborg",
          "Inger",
          "Ingrid",
          "Inocencia",
          "Iola",
          "Iona",
          "Ione",
          "Ira",
          "Iraida",
          "Irena",
          "Irene",
          "Irina",
          "Iris",
          "Irish",
          "Irma",
          "Irmgard",
          "Isa",
          "Isabel",
          "Isabell",
          "Isabella",
          "Isabelle",
          "Isadora",
          "Isaura",
          "Isela",
          "Isidra",
          "Isis",
          "Isobel",
          "Iva",
          "Ivana",
          "Ivelisse",
          "Ivette",
          "Ivey",
          "Ivonne",
          "Ivory",
          "Ivy",
          "Izetta",
          "Izola",
          "Ja",
          "Jacalyn",
          "Jacelyn",
          "Jacinda",
          "Jacinta",
          "Jack",
          "Jackeline",
          "Jackelyn",
          "Jacki",
          "Jackie",
          "Jacklyn",
          "Jackqueline",
          "Jaclyn",
          "Jacqualine",
          "Jacque",
          "Jacquelin",
          "Jacqueline",
          "Jacquelyn",
          "Jacquelyne",
          "Jacquelynn",
          "Jacquetta",
          "Jacqui",
          "Jacquie",
          "Jacquiline",
          "Jacquline",
          "Jacqulyn",
          "Jada",
          "Jade",
          "Jadwiga",
          "Jae",
          "Jaime",
          "Jaimee",
          "Jaimie",
          "Jaleesa",
          "Jalisa",
          "Jama",
          "Jame",
          "Jamee",
          "James",
          "Jamey",
          "Jami",
          "Jamie",
          "Jamika",
          "Jamila",
          "Jammie",
          "Jan",
          "Jana",
          "Janae",
          "Janay",
          "Jane",
          "Janean",
          "Janee",
          "Janeen",
          "Janel",
          "Janell",
          "Janella",
          "Janelle",
          "Janene",
          "Janessa",
          "Janet",
          "Janeth",
          "Janett",
          "Janetta",
          "Janette",
          "Janey",
          "Jani",
          "Janice",
          "Janie",
          "Janiece",
          "Janina",
          "Janine",
          "Janis",
          "Janise",
          "Janita",
          "Jann",
          "Janna",
          "Jannet",
          "Jannette",
          "Jannie",
          "January",
          "Janyce",
          "Jaqueline",
          "Jaquelyn",
          "Jasmin",
          "Jasmine",
          "Jason",
          "Jaunita",
          "Jay",
          "Jaye",
          "Jayme",
          "Jaymie",
          "Jayna",
          "Jayne",
          "Jazmin",
          "Jazmine",
          "Jean",
          "Jeana",
          "Jeane",
          "Jeanelle",
          "Jeanene",
          "Jeanett",
          "Jeanetta",
          "Jeanette",
          "Jeanice",
          "Jeanie",
          "Jeanine",
          "Jeanmarie",
          "Jeanna",
          "Jeanne",
          "Jeannetta",
          "Jeannette",
          "Jeannie",
          "Jeannine",
          "Jeffie",
          "Jeffrey",
          "Jen",
          "Jena",
          "Jenae",
          "Jene",
          "Jenee",
          "Jenell",
          "Jenelle",
          "Jenette",
          "Jeneva",
          "Jeni",
          "Jenice",
          "Jenifer",
          "Jeniffer",
          "Jenine",
          "Jenise",
          "Jenna",
          "Jennefer",
          "Jennell",
          "Jennette",
          "Jenni",
          "Jennie",
          "Jennifer",
          "Jenniffer",
          "Jennine",
          "Jenny",
          "Jeraldine",
          "Jeremy",
          "Jeri",
          "Jerica",
          "Jerilyn",
          "Jerlene",
          "Jerri",
          "Jerrica",
          "Jerrie",
          "Jerry",
          "Jesenia",
          "Jesica",
          "Jesse",
          "Jessenia",
          "Jessi",
          "Jessia",
          "Jessica",
          "Jessie",
          "Jessika",
          "Jestine",
          "Jesus",
          "Jesusa",
          "Jesusita",
          "Jetta",
          "Jettie",
          "Jewel",
          "Jewell",
          "Ji",
          "Jill",
          "Jillian",
          "Jimmie",
          "Jimmy",
          "Jin",
          "Jina",
          "Jinny",
          "Jo",
          "Joan",
          "Joana",
          "Joane",
          "Joanie",
          "Joann",
          "Joanna",
          "Joanne",
          "Joannie",
          "Joaquina",
          "Jocelyn",
          "Jodee",
          "Jodi",
          "Jodie",
          "Jody",
          "Joe",
          "Joeann",
          "Joel",
          "Joella",
          "Joelle",
          "Joellen",
          "Joetta",
          "Joette",
          "Joey",
          "Johana",
          "Johanna",
          "Johanne",
          "John",
          "Johna",
          "Johnetta",
          "Johnette",
          "Johnie",
          "Johnna",
          "Johnnie",
          "Johnny",
          "Johnsie",
          "Joi",
          "Joie",
          "Jolanda",
          "Joleen",
          "Jolene",
          "Jolie",
          "Joline",
          "Jolyn",
          "Jolynn",
          "Jon",
          "Jona",
          "Jone",
          "Jonell",
          "Jonelle",
          "Jong",
          "Joni",
          "Jonie",
          "Jonna",
          "Jonnie",
          "Jordan",
          "Jose",
          "Josefa",
          "Josefina",
          "Josefine",
          "Joselyn",
          "Joseph",
          "Josephina",
          "Josephine",
          "Josette",
          "Joshua",
          "Josie",
          "Joslyn",
          "Josphine",
          "Jovan",
          "Jovita",
          "Joy",
          "Joya",
          "Joyce",
          "Joycelyn",
          "Joye",
          "Juan",
          "Juana",
          "Juanita",
          "Jude",
          "Judi",
          "Judie",
          "Judith",
          "Judy",
          "Jule",
          "Julee",
          "Julene",
          "Juli",
          "Julia",
          "Julian",
          "Juliana",
          "Juliane",
          "Juliann",
          "Julianna",
          "Julianne",
          "Julie",
          "Julieann",
          "Julienne",
          "Juliet",
          "Julieta",
          "Julietta",
          "Juliette",
          "Julio",
          "Julissa",
          "June",
          "Jung",
          "Junie",
          "Junita",
          "Junko",
          "Justa",
          "Justin",
          "Justina",
          "Justine",
          "Jutta",
          "Ka",
          "Kacey",
          "Kaci",
          "Kacie",
          "Kacy",
          "Kai",
          "Kaila",
          "Kaitlin",
          "Kaitlyn",
          "Kala",
          "Kaleigh",
          "Kaley",
          "Kali",
          "Kallie",
          "Kalyn",
          "Kam",
          "Kamala",
          "Kami",
          "Kamilah",
          "Kandace",
          "Kandi",
          "Kandice",
          "Kandis",
          "Kandra",
          "Kandy",
          "Kanesha",
          "Kanisha",
          "Kara",
          "Karan",
          "Kareen",
          "Karen",
          "Karena",
          "Karey",
          "Kari",
          "Karie",
          "Karima",
          "Karin",
          "Karina",
          "Karine",
          "Karisa",
          "Karissa",
          "Karl",
          "Karla",
          "Karleen",
          "Karlene",
          "Karly",
          "Karlyn",
          "Karma",
          "Karmen",
          "Karol",
          "Karole",
          "Karoline",
          "Karolyn",
          "Karon",
          "Karren",
          "Karri",
          "Karrie",
          "Karry",
          "Kary",
          "Karyl",
          "Karyn",
          "Kasandra",
          "Kasey",
          "Kasha",
          "Kasi",
          "Kasie",
          "Kassandra",
          "Kassie",
          "Kate",
          "Katelin",
          "Katelyn",
          "Katelynn",
          "Katerine",
          "Kathaleen",
          "Katharina",
          "Katharine",
          "Katharyn",
          "Kathe",
          "Katheleen",
          "Katherin",
          "Katherina",
          "Katherine",
          "Kathern",
          "Katheryn",
          "Kathey",
          "Kathi",
          "Kathie",
          "Kathleen",
          "Kathlene",
          "Kathline",
          "Kathlyn",
          "Kathrin",
          "Kathrine",
          "Kathryn",
          "Kathryne",
          "Kathy",
          "Kathyrn",
          "Kati",
          "Katia",
          "Katie",
          "Katina",
          "Katlyn",
          "Katrice",
          "Katrina",
          "Kattie",
          "Katy",
          "Kay",
          "Kayce",
          "Kaycee",
          "Kaye",
          "Kayla",
          "Kaylee",
          "Kayleen",
          "Kayleigh",
          "Kaylene",
          "Kazuko",
          "Kecia",
          "Keeley",
          "Keely",
          "Keena",
          "Keesha",
          "Keiko",
          "Keila",
          "Keira",
          "Keisha",
          "Keith",
          "Keitha",
          "Keli",
          "Kelle",
          "Kellee",
          "Kelley",
          "Kelli",
          "Kellie",
          "Kelly",
          "Kellye",
          "Kelsey",
          "Kelsi",
          "Kelsie",
          "Kemberly",
          "Kena",
          "Kenda",
          "Kendal",
          "Kendall",
          "Kendra",
          "Kenia",
          "Kenisha",
          "Kenna",
          "Kenneth",
          "Kenya",
          "Kenyatta",
          "Kenyetta",
          "Kera",
          "Keren",
          "Keri",
          "Kerri",
          "Kerrie",
          "Kerry",
          "Kerstin",
          "Kesha",
          "Keshia",
          "Keturah",
          "Keva",
          "Kevin",
          "Khadijah",
          "Khalilah",
          "Kia",
          "Kiana",
          "Kiara",
          "Kiera",
          "Kiersten",
          "Kiesha",
          "Kiley",
          "Kim",
          "Kimber",
          "Kimberely",
          "Kimberlee",
          "Kimberley",
          "Kimberli",
          "Kimberlie",
          "Kimberly",
          "Kimbery",
          "Kimbra",
          "Kimi",
          "Kimiko",
          "Kina",
          "Kindra",
          "Kira",
          "Kirby",
          "Kirsten",
          "Kirstie",
          "Kirstin",
          "Kisha",
          "Kit",
          "Kittie",
          "Kitty",
          "Kiyoko",
          "Kizzie",
          "Kizzy",
          "Klara",
          "Kori",
          "Kortney",
          "Kourtney",
          "Kris",
          "Krishna",
          "Krissy",
          "Krista",
          "Kristal",
          "Kristan",
          "Kristeen",
          "Kristel",
          "Kristen",
          "Kristi",
          "Kristian",
          "Kristie",
          "Kristin",
          "Kristina",
          "Kristine",
          "Kristle",
          "Kristy",
          "Kristyn",
          "Krysta",
          "Krystal",
          "Krysten",
          "Krystin",
          "Krystina",
          "Krystle",
          "Krystyna",
          "Kum",
          "Kyla",
          "Kyle",
          "Kylee",
          "Kylie",
          "Kym",
          "Kymberly",
          "Kyoko",
          "Kyong",
          "Kyra",
          "Kyung",
          "Lacey",
          "Lachelle",
          "Laci",
          "Lacie",
          "Lacresha",
          "Lacy",
          "Ladawn",
          "Ladonna",
          "Lady",
          "Lael",
          "Lahoma",
          "Lai",
          "Laila",
          "Laine",
          "Lajuana",
          "Lakeesha",
          "Lakeisha",
          "Lakendra",
          "Lakenya",
          "Lakesha",
          "Lakeshia",
          "Lakia",
          "Lakiesha",
          "Lakisha",
          "Lakita",
          "Lala",
          "Lamonica",
          "Lan",
          "Lana",
          "Lane",
          "Lanell",
          "Lanelle",
          "Lanette",
          "Lang",
          "Lani",
          "Lanie",
          "Lanita",
          "Lannie",
          "Lanora",
          "Laquanda",
          "Laquita",
          "Lara",
          "Larae",
          "Laraine",
          "Laree",
          "Larhonda",
          "Larisa",
          "Larissa",
          "Larita",
          "Laronda",
          "Larraine",
          "Larry",
          "Larue",
          "Lasandra",
          "Lashanda",
          "Lashandra",
          "Lashaun",
          "Lashaunda",
          "Lashawn",
          "Lashawna",
          "Lashawnda",
          "Lashay",
          "Lashell",
          "Lashon",
          "Lashonda",
          "Lashunda",
          "Lasonya",
          "Latanya",
          "Latarsha",
          "Latasha",
          "Latashia",
          "Latesha",
          "Latia",
          "Laticia",
          "Latina",
          "Latisha",
          "Latonia",
          "Latonya",
          "Latoria",
          "Latosha",
          "Latoya",
          "Latoyia",
          "Latrice",
          "Latricia",
          "Latrina",
          "Latrisha",
          "Launa",
          "Laura",
          "Lauralee",
          "Lauran",
          "Laure",
          "Laureen",
          "Laurel",
          "Lauren",
          "Laurena",
          "Laurence",
          "Laurene",
          "Lauretta",
          "Laurette",
          "Lauri",
          "Laurice",
          "Laurie",
          "Laurinda",
          "Laurine",
          "Lauryn",
          "Lavada",
          "Lavelle",
          "Lavenia",
          "Lavera",
          "Lavern",
          "Laverna",
          "Laverne",
          "Laveta",
          "Lavette",
          "Lavina",
          "Lavinia",
          "Lavon",
          "Lavona",
          "Lavonda",
          "Lavone",
          "Lavonia",
          "Lavonna",
          "Lavonne",
          "Lawana",
          "Lawanda",
          "Lawanna",
          "Lawrence",
          "Layla",
          "Layne",
          "Le",
          "Lea",
          "Leah",
          "Lean",
          "Leana",
          "Leandra",
          "Leann",
          "Leanna",
          "Leanne",
          "Leanora",
          "Leatha",
          "Leatrice",
          "Lecia",
          "Leda",
          "Lee",
          "Leeann",
          "Leeanna",
          "Leeanne",
          "Leena",
          "Leesa",
          "Leia",
          "Leida",
          "Leigh",
          "Leigha",
          "Leighann",
          "Leila",
          "Leilani",
          "Leisa",
          "Leisha",
          "Lekisha",
          "Lela",
          "Lelah",
          "Lelia",
          "Lena",
          "Lenita",
          "Lenna",
          "Lennie",
          "Lenora",
          "Lenore",
          "Leo",
          "Leola",
          "Leoma",
          "Leon",
          "Leona",
          "Leonarda",
          "Leone",
          "Leonia",
          "Leonida",
          "Leonie",
          "Leonila",
          "Leonor",
          "Leonora",
          "Leonore",
          "Leontine",
          "Leora",
          "Leota",
          "Lera",
          "Lesa",
          "Lesha",
          "Lesia",
          "Leslee",
          "Lesley",
          "Lesli",
          "Leslie",
          "Lessie",
          "Lester",
          "Leta",
          "Letha",
          "Leticia",
          "Letisha",
          "Letitia",
          "Lettie",
          "Letty",
          "Lewis",
          "Lexie",
          "Lezlie",
          "Li",
          "Lia",
          "Liana",
          "Liane",
          "Lianne",
          "Libbie",
          "Libby",
          "Liberty",
          "Librada",
          "Lida",
          "Lidia",
          "Lien",
          "Lieselotte",
          "Ligia",
          "Lila",
          "Lili",
          "Lilia",
          "Lilian",
          "Liliana",
          "Lilla",
          "Lilli",
          "Lillia",
          "Lilliam",
          "Lillian",
          "Lilliana",
          "Lillie",
          "Lilly",
          "Lily",
          "Lin",
          "Lina",
          "Linda",
          "Lindsay",
          "Lindsey",
          "Lindsy",
          "Lindy",
          "Linette",
          "Ling",
          "Linh",
          "Linn",
          "Linnea",
          "Linnie",
          "Linsey",
          "Lisa",
          "Lisabeth",
          "Lisandra",
          "Lisbeth",
          "Lise",
          "Lisette",
          "Lisha",
          "Lissa",
          "Lissette",
          "Lita",
          "Livia",
          "Liz",
          "Liza",
          "Lizabeth",
          "Lizbeth",
          "Lizeth",
          "Lizette",
          "Lizzette",
          "Lizzie",
          "Loan",
          "Logan",
          "Loida",
          "Lois",
          "Loise",
          "Lola",
          "Lolita",
          "Loma",
          "Lona",
          "Londa",
          "Loni",
          "Lonna",
          "Lonnie",
          "Lora",
          "Loraine",
          "Loralee",
          "Lore",
          "Lorean",
          "Loree",
          "Loreen",
          "Lorelei",
          "Loren",
          "Lorena",
          "Lorene",
          "Lorenza",
          "Loreta",
          "Loretta",
          "Lorette",
          "Lori",
          "Loria",
          "Loriann",
          "Lorie",
          "Lorilee",
          "Lorina",
          "Lorinda",
          "Lorine",
          "Loris",
          "Lorita",
          "Lorna",
          "Lorraine",
          "Lorretta",
          "Lorri",
          "Lorriane",
          "Lorrie",
          "Lorrine",
          "Lory",
          "Lottie",
          "Lou",
          "Louann",
          "Louanne",
          "Louella",
          "Louetta",
          "Louie",
          "Louis",
          "Louisa",
          "Louise",
          "Loura",
          "Lourdes",
          "Lourie",
          "Louvenia",
          "Love",
          "Lovella",
          "Lovetta",
          "Lovie",
          "Loyce",
          "Lu",
          "Luana",
          "Luann",
          "Luanna",
          "Luanne",
          "Luba",
          "Luci",
          "Lucia",
          "Luciana",
          "Lucie",
          "Lucienne",
          "Lucila",
          "Lucile",
          "Lucilla",
          "Lucille",
          "Lucina",
          "Lucinda",
          "Lucrecia",
          "Lucretia",
          "Lucy",
          "Ludie",
          "Ludivina",
          "Lue",
          "Luella",
          "Luetta",
          "Luis",
          "Luisa",
          "Luise",
          "Lula",
          "Lulu",
          "Luna",
          "Lupe",
          "Lupita",
          "Lura",
          "Lurlene",
          "Lurline",
          "Luvenia",
          "Luz",
          "Lyda",
          "Lydia",
          "Lyla",
          "Lyn",
          "Lynda",
          "Lyndia",
          "Lyndsay",
          "Lyndsey",
          "Lynell",
          "Lynelle",
          "Lynetta",
          "Lynette",
          "Lynn",
          "Lynna",
          "Lynne",
          "Lynnette",
          "Lynsey",
          "Ma",
          "Mabel",
          "Mabelle",
          "Mable",
          "Machelle",
          "Macie",
          "Mackenzie",
          "Macy",
          "Madalene",
          "Madaline",
          "Madalyn",
          "Maddie",
          "Madelaine",
          "Madeleine",
          "Madelene",
          "Madeline",
          "Madelyn",
          "Madge",
          "Madie",
          "Madison",
          "Madlyn",
          "Madonna",
          "Mae",
          "Maegan",
          "Mafalda",
          "Magali",
          "Magaly",
          "Magan",
          "Magaret",
          "Magda",
          "Magdalen",
          "Magdalena",
          "Magdalene",
          "Magen",
          "Maggie",
          "Magnolia",
          "Mahalia",
          "Mai",
          "Maia",
          "Maida",
          "Maile",
          "Maira",
          "Maire",
          "Maisha",
          "Maisie",
          "Majorie",
          "Makeda",
          "Malena",
          "Malia",
          "Malika",
          "Malinda",
          "Malisa",
          "Malissa",
          "Malka",
          "Mallie",
          "Mallory",
          "Malorie",
          "Malvina",
          "Mamie",
          "Mammie",
          "Man",
          "Mana",
          "Manda",
          "Mandi",
          "Mandie",
          "Mandy",
          "Manie",
          "Manuela",
          "Many",
          "Mao",
          "Maple",
          "Mara",
          "Maragaret",
          "Maragret",
          "Maranda",
          "Marcela",
          "Marcelene",
          "Marcelina",
          "Marceline",
          "Marcell",
          "Marcella",
          "Marcelle",
          "Marcene",
          "Marchelle",
          "Marci",
          "Marcia",
          "Marcie",
          "Marcy",
          "Mardell",
          "Maren",
          "Marg",
          "Margaret",
          "Margareta",
          "Margarete",
          "Margarett",
          "Margaretta",
          "Margarette",
          "Margarita",
          "Margarite",
          "Margart",
          "Marge",
          "Margene",
          "Margeret",
          "Margert",
          "Margery",
          "Marget",
          "Margherita",
          "Margie",
          "Margit",
          "Margo",
          "Margorie",
          "Margot",
          "Margret",
          "Margrett",
          "Marguerita",
          "Marguerite",
          "Margurite",
          "Margy",
          "Marhta",
          "Mari",
          "Maria",
          "Mariah",
          "Mariam",
          "Marian",
          "Mariana",
          "Marianela",
          "Mariann",
          "Marianna",
          "Marianne",
          "Maribel",
          "Maribeth",
          "Marica",
          "Maricela",
          "Maricruz",
          "Marie",
          "Mariel",
          "Mariela",
          "Mariella",
          "Marielle",
          "Marietta",
          "Mariette",
          "Mariko",
          "Marilee",
          "Marilou",
          "Marilu",
          "Marilyn",
          "Marilynn",
          "Marin",
          "Marina",
          "Marinda",
          "Marine",
          "Mario",
          "Marion",
          "Maris",
          "Marisa",
          "Marisela",
          "Marisha",
          "Marisol",
          "Marissa",
          "Marita",
          "Maritza",
          "Marivel",
          "Marjorie",
          "Marjory",
          "Mark",
          "Marketta",
          "Markita",
          "Marla",
          "Marlana",
          "Marleen",
          "Marlen",
          "Marlena",
          "Marlene",
          "Marlin",
          "Marline",
          "Marlo",
          "Marlyn",
          "Marlys",
          "Marna",
          "Marni",
          "Marnie",
          "Marquerite",
          "Marquetta",
          "Marquita",
          "Marquitta",
          "Marry",
          "Marsha",
          "Marshall",
          "Marta",
          "Marth",
          "Martha",
          "Marti",
          "Martin",
          "Martina",
          "Martine",
          "Marty",
          "Marva",
          "Marvel",
          "Marvella",
          "Marvis",
          "Marx",
          "Mary",
          "Marya",
          "Maryalice",
          "Maryam",
          "Maryann",
          "Maryanna",
          "Maryanne",
          "Marybelle",
          "Marybeth",
          "Maryellen",
          "Maryetta",
          "Maryjane",
          "Maryjo",
          "Maryland",
          "Marylee",
          "Marylin",
          "Maryln",
          "Marylou",
          "Marylouise",
          "Marylyn",
          "Marylynn",
          "Maryrose",
          "Masako",
          "Matha",
          "Mathilda",
          "Mathilde",
          "Matilda",
          "Matilde",
          "Matthew",
          "Mattie",
          "Maud",
          "Maude",
          "Maudie",
          "Maura",
          "Maureen",
          "Maurice",
          "Maurine",
          "Maurita",
          "Mavis",
          "Maxie",
          "Maxima",
          "Maximina",
          "Maxine",
          "May",
          "Maya",
          "Maybell",
          "Maybelle",
          "Maye",
          "Mayme",
          "Mayola",
          "Mayra",
          "Mazie",
          "Mckenzie",
          "Meagan",
          "Meaghan",
          "Mechelle",
          "Meda",
          "Mee",
          "Meg",
          "Megan",
          "Meggan",
          "Meghan",
          "Meghann",
          "Mei",
          "Melaine",
          "Melani",
          "Melania",
          "Melanie",
          "Melany",
          "Melba",
          "Melda",
          "Melia",
          "Melida",
          "Melina",
          "Melinda",
          "Melisa",
          "Melissa",
          "Melissia",
          "Melita",
          "Mellie",
          "Mellisa",
          "Mellissa",
          "Melodee",
          "Melodi",
          "Melodie",
          "Melody",
          "Melonie",
          "Melony",
          "Melva",
          "Melvin",
          "Melvina",
          "Melynda",
          "Mendy",
          "Mercedes",
          "Mercedez",
          "Mercy",
          "Meredith",
          "Meri",
          "Merideth",
          "Meridith",
          "Merilyn",
          "Merissa",
          "Merle",
          "Merlene",
          "Merlyn",
          "Merna",
          "Merri",
          "Merrie",
          "Merrilee",
          "Merrill",
          "Merry",
          "Mertie",
          "Meryl",
          "Meta",
          "Mi",
          "Mia",
          "Mica",
          "Micaela",
          "Micah",
          "Micha",
          "Michael",
          "Michaela",
          "Michaele",
          "Michal",
          "Micheal",
          "Michel",
          "Michele",
          "Michelina",
          "Micheline",
          "Michell",
          "Michelle",
          "Michiko",
          "Mickey",
          "Micki",
          "Mickie",
          "Miesha",
          "Migdalia",
          "Mignon",
          "Miguelina",
          "Mika",
          "Mikaela",
          "Mike",
          "Miki",
          "Mikki",
          "Mila",
          "Milagro",
          "Milagros",
          "Milda",
          "Mildred",
          "Milissa",
          "Millicent",
          "Millie",
          "Milly",
          "Mimi",
          "Min",
          "Mina",
          "Minda",
          "Mindi",
          "Mindy",
          "Minerva",
          "Ming",
          "Minh",
          "Minna",
          "Minnie",
          "Minta",
          "Mira",
          "Miranda",
          "Mireille",
          "Mirella",
          "Mireya",
          "Miriam",
          "Mirian",
          "Mirna",
          "Mirta",
          "Mirtha",
          "Misha",
          "Miss",
          "Missy",
          "Misti",
          "Mistie",
          "Misty",
          "Mitchell",
          "Mitsue",
          "Mitsuko",
          "Mittie",
          "Mitzi",
          "Mitzie",
          "Miyoko",
          "Modesta",
          "Moira",
          "Mollie",
          "Molly",
          "Mona",
          "Monet",
          "Monica",
          "Monika",
          "Monique",
          "Monnie",
          "Monserrate",
          "Moon",
          "Mora",
          "Morgan",
          "Moriah",
          "Mozell",
          "Mozella",
          "Mozelle",
          "Mui",
          "Muoi",
          "Muriel",
          "My",
          "Myesha",
          "Myong",
          "Myra",
          "Myriam",
          "Myrl",
          "Myrle",
          "Myrna",
          "Myrta",
          "Myrtice",
          "Myrtie",
          "Myrtis",
          "Myrtle",
          "Myung",
          "Na",
          "Nada",
          "Nadene",
          "Nadia",
          "Nadine",
          "Naida",
          "Nakesha",
          "Nakia",
          "Nakisha",
          "Nakita",
          "Nam",
          "Nan",
          "Nana",
          "Nancee",
          "Nancey",
          "Nanci",
          "Nancie",
          "Nancy",
          "Nanette",
          "Nannette",
          "Nannie",
          "Naoma",
          "Naomi",
          "Narcisa",
          "Natacha",
          "Natalia",
          "Natalie",
          "Natalya",
          "Natasha",
          "Natashia",
          "Nathalie",
          "Natisha",
          "Natividad",
          "Natosha",
          "Necole",
          "Neda",
          "Nedra",
          "Neely",
          "Neida",
          "Nelda",
          "Nelia",
          "Nelida",
          "Nell",
          "Nella",
          "Nelle",
          "Nellie",
          "Nelly",
          "Nena",
          "Nenita",
          "Neoma",
          "Neomi",
          "Nereida",
          "Nerissa",
          "Nery",
          "Neta",
          "Nettie",
          "Neva",
          "Nevada",
          "Nga",
          "Ngan",
          "Ngoc",
          "Nguyet",
          "Nia",
          "Nichelle",
          "Nichol",
          "Nichole",
          "Nicholle",
          "Nicki",
          "Nickie",
          "Nickole",
          "Nicky",
          "Nicol",
          "Nicola",
          "Nicolasa",
          "Nicole",
          "Nicolette",
          "Nicolle",
          "Nida",
          "Nidia",
          "Niesha",
          "Nieves",
          "Niki",
          "Nikia",
          "Nikita",
          "Nikki",
          "Nikole",
          "Nila",
          "Nilda",
          "Nilsa",
          "Nina",
          "Ninfa",
          "Nisha",
          "Nita",
          "Nobuko",
          "Noel",
          "Noelia",
          "Noella",
          "Noelle",
          "Noemi",
          "Nohemi",
          "Nola",
          "Noma",
          "Nona",
          "Nora",
          "Norah",
          "Noreen",
          "Norene",
          "Noriko",
          "Norine",
          "Norma",
          "Norman",
          "Nova",
          "Novella",
          "Nu",
          "Nubia",
          "Numbers",
          "Nydia",
          "Nyla",
          "Obdulia",
          "Ocie",
          "Octavia",
          "Oda",
          "Odelia",
          "Odell",
          "Odessa",
          "Odette",
          "Odilia",
          "Ofelia",
          "Ok",
          "Ola",
          "Olene",
          "Oleta",
          "Olevia",
          "Olga",
          "Olimpia",
          "Olinda",
          "Oliva",
          "Olive",
          "Olivia",
          "Ollie",
          "Olympia",
          "Oma",
          "Omega",
          "Ona",
          "Oneida",
          "Onie",
          "Onita",
          "Opal",
          "Ophelia",
          "Ora",
          "Oralee",
          "Oralia",
          "Oretha",
          "Orpha",
          "Oscar",
          "Ossie",
          "Otelia",
          "Otha",
          "Otilia",
          "Ouida",
          "Ozell",
          "Ozella",
          "Ozie",
          "Pa",
          "Page",
          "Paige",
          "Palma",
          "Palmira",
          "Pam",
          "Pamala",
          "Pamela",
          "Pamelia",
          "Pamella",
          "Pamila",
          "Pamula",
          "Pandora",
          "Pansy",
          "Paola",
          "Paris",
          "Parthenia",
          "Particia",
          "Pasty",
          "Pat",
          "Patience",
          "Patria",
          "Patrica",
          "Patrice",
          "Patricia",
          "Patrick",
          "Patrina",
          "Patsy",
          "Patti",
          "Pattie",
          "Patty",
          "Paul",
          "Paula",
          "Paulene",
          "Pauletta",
          "Paulette",
          "Paulina",
          "Pauline",
          "Paulita",
          "Paz",
          "Pearl",
          "Pearle",
          "Pearlene",
          "Pearlie",
          "Pearline",
          "Pearly",
          "Peg",
          "Peggie",
          "Peggy",
          "Pei",
          "Penelope",
          "Penney",
          "Penni",
          "Pennie",
          "Penny",
          "Perla",
          "Perry",
          "Peter",
          "Petra",
          "Petrina",
          "Petronila",
          "Phebe",
          "Phillis",
          "Philomena",
          "Phoebe",
          "Phung",
          "Phuong",
          "Phylicia",
          "Phylis",
          "Phyliss",
          "Phyllis",
          "Pia",
          "Piedad",
          "Pilar",
          "Ping",
          "Pinkie",
          "Piper",
          "Pok",
          "Polly",
          "Porsche",
          "Porsha",
          "Portia",
          "Precious",
          "Pricilla",
          "Princess",
          "Priscila",
          "Priscilla",
          "Providencia",
          "Prudence",
          "Pura",
          "Qiana",
          "Queen",
          "Queenie",
          "Quiana",
          "Quinn",
          "Quyen",
          "Rachael",
          "Rachal",
          "Racheal",
          "Rachel",
          "Rachele",
          "Rachell",
          "Rachelle",
          "Racquel",
          "Rae",
          "Raeann",
          "Raelene",
          "Rafaela",
          "Raguel",
          "Raina",
          "Raisa",
          "Ramona",
          "Ramonita",
          "Rana",
          "Ranae",
          "Randa",
          "Randee",
          "Randi",
          "Randy",
          "Ranee",
          "Raquel",
          "Rasheeda",
          "Rashida",
          "Raven",
          "Ray",
          "Raye",
          "Raylene",
          "Raymond",
          "Raymonde",
          "Rayna",
          "Rea",
          "Reagan",
          "Reanna",
          "Reatha",
          "Reba",
          "Rebbeca",
          "Rebbecca",
          "Rebeca",
          "Rebecca",
          "Rebecka",
          "Rebekah",
          "Reda",
          "Reena",
          "Refugia",
          "Refugio",
          "Regan",
          "Regena",
          "Regenia",
          "Regina",
          "Regine",
          "Reginia",
          "Reiko",
          "Reina",
          "Reita",
          "Rema",
          "Remedios",
          "Remona",
          "Rena",
          "Renae",
          "Renata",
          "Renate",
          "Renay",
          "Renda",
          "Rene",
          "Renea",
          "Renee",
          "Renetta",
          "Renita",
          "Renna",
          "Ressie",
          "Reta",
          "Retha",
          "Retta",
          "Reva",
          "Reyna",
          "Reynalda",
          "Rhea",
          "Rheba",
          "Rhiannon",
          "Rhoda",
          "Rhona",
          "Rhonda",
          "Ria",
          "Ricarda",
          "Richard",
          "Richelle",
          "Ricki",
          "Rickie",
          "Rikki",
          "Rima",
          "Rina",
          "Risa",
          "Rita",
          "Riva",
          "Rivka",
          "Robbi",
          "Robbie",
          "Robbin",
          "Robbyn",
          "Robena",
          "Robert",
          "Roberta",
          "Roberto",
          "Robin",
          "Robyn",
          "Rochel",
          "Rochell",
          "Rochelle",
          "Rocio",
          "Rolanda",
          "Rolande",
          "Roma",
          "Romaine",
          "Romana",
          "Romelia",
          "Romona",
          "Rona",
          "Ronald",
          "Ronda",
          "Roni",
          "Ronna",
          "Ronni",
          "Ronnie",
          "Rory",
          "Rosa",
          "Rosalba",
          "Rosalee",
          "Rosalia",
          "Rosalie",
          "Rosalina",
          "Rosalind",
          "Rosalinda",
          "Rosaline",
          "Rosalva",
          "Rosalyn",
          "Rosamaria",
          "Rosamond",
          "Rosana",
          "Rosann",
          "Rosanna",
          "Rosanne",
          "Rosaria",
          "Rosario",
          "Rosaura",
          "Rose",
          "Roseann",
          "Roseanna",
          "Roseanne",
          "Roselee",
          "Roselia",
          "Roseline",
          "Rosella",
          "Roselle",
          "Roselyn",
          "Rosemarie",
          "Rosemary",
          "Rosena",
          "Rosenda",
          "Rosetta",
          "Rosette",
          "Rosia",
          "Rosie",
          "Rosina",
          "Rosio",
          "Rosita",
          "Roslyn",
          "Rossana",
          "Rossie",
          "Rosy",
          "Rowena",
          "Roxana",
          "Roxane",
          "Roxann",
          "Roxanna",
          "Roxanne",
          "Roxie",
          "Roxy",
          "Roy",
          "Royce",
          "Rozanne",
          "Rozella",
          "Rubi",
          "Rubie",
          "Ruby",
          "Rubye",
          "Rudy",
          "Rufina",
          "Russell",
          "Ruth",
          "Rutha",
          "Ruthann",
          "Ruthanne",
          "Ruthe",
          "Ruthie",
          "Ryan",
          "Ryann",
          "Sabina",
          "Sabine",
          "Sabra",
          "Sabrina",
          "Sacha",
          "Sachiko",
          "Sade",
          "Sadie",
          "Sadye",
          "Sage",
          "Salena",
          "Salina",
          "Salley",
          "Sallie",
          "Sally",
          "Salome",
          "Sam",
          "Samantha",
          "Samara",
          "Samatha",
          "Samella",
          "Samira",
          "Sammie",
          "Sammy",
          "Samuel",
          "Sana",
          "Sanda",
          "Sandee",
          "Sandi",
          "Sandie",
          "Sandra",
          "Sandy",
          "Sang",
          "Sanjuana",
          "Sanjuanita",
          "Sanora",
          "Santa",
          "Santana",
          "Santina",
          "Santos",
          "Sara",
          "Sarah",
          "Sarai",
          "Saran",
          "Sari",
          "Sarina",
          "Sarita",
          "Sasha",
          "Saturnina",
          "Sau",
          "Saundra",
          "Savanna",
          "Savannah",
          "Scarlet",
          "Scarlett",
          "Scott",
          "Scottie",
          "Sean",
          "Season",
          "Sebrina",
          "See",
          "Seema",
          "Selena",
          "Selene",
          "Selina",
          "Selma",
          "Sena",
          "Senaida",
          "September",
          "Serafina",
          "Serena",
          "Serina",
          "Serita",
          "Setsuko",
          "Sha",
          "Shae",
          "Shaina",
          "Shakia",
          "Shakira",
          "Shakita",
          "Shala",
          "Shalanda",
          "Shalon",
          "Shalonda",
          "Shameka",
          "Shamika",
          "Shan",
          "Shana",
          "Shanae",
          "Shanda",
          "Shandi",
          "Shandra",
          "Shane",
          "Shaneka",
          "Shanel",
          "Shanell",
          "Shanelle",
          "Shani",
          "Shanice",
          "Shanika",
          "Shaniqua",
          "Shanita",
          "Shanna",
          "Shannan",
          "Shannon",
          "Shanon",
          "Shanta",
          "Shantae",
          "Shantay",
          "Shante",
          "Shantel",
          "Shantell",
          "Shantelle",
          "Shanti",
          "Shaquana",
          "Shaquita",
          "Shara",
          "Sharan",
          "Sharda",
          "Sharee",
          "Sharell",
          "Sharen",
          "Shari",
          "Sharice",
          "Sharie",
          "Sharika",
          "Sharilyn",
          "Sharita",
          "Sharla",
          "Sharleen",
          "Sharlene",
          "Sharmaine",
          "Sharolyn",
          "Sharon",
          "Sharonda",
          "Sharri",
          "Sharron",
          "Sharyl",
          "Sharyn",
          "Shasta",
          "Shaun",
          "Shauna",
          "Shaunda",
          "Shaunna",
          "Shaunta",
          "Shaunte",
          "Shavon",
          "Shavonda",
          "Shavonne",
          "Shawana",
          "Shawanda",
          "Shawanna",
          "Shawn",
          "Shawna",
          "Shawnda",
          "Shawnee",
          "Shawnna",
          "Shawnta",
          "Shay",
          "Shayla",
          "Shayna",
          "Shayne",
          "Shea",
          "Sheba",
          "Sheena",
          "Sheila",
          "Sheilah",
          "Shela",
          "Shelba",
          "Shelby",
          "Shelia",
          "Shella",
          "Shelley",
          "Shelli",
          "Shellie",
          "Shelly",
          "Shemeka",
          "Shemika",
          "Shena",
          "Shenika",
          "Shenita",
          "Shenna",
          "Shera",
          "Sheree",
          "Sherell",
          "Sheri",
          "Sherice",
          "Sheridan",
          "Sherie",
          "Sherika",
          "Sherill",
          "Sherilyn",
          "Sherise",
          "Sherita",
          "Sherlene",
          "Sherley",
          "Sherly",
          "Sherlyn",
          "Sheron",
          "Sherrell",
          "Sherri",
          "Sherrie",
          "Sherril",
          "Sherrill",
          "Sherron",
          "Sherry",
          "Sherryl",
          "Shery",
          "Sheryl",
          "Sheryll",
          "Shiela",
          "Shila",
          "Shiloh",
          "Shin",
          "Shira",
          "Shirely",
          "Shirl",
          "Shirlee",
          "Shirleen",
          "Shirlene",
          "Shirley",
          "Shirly",
          "Shizue",
          "Shizuko",
          "Shona",
          "Shonda",
          "Shondra",
          "Shonna",
          "Shonta",
          "Shoshana",
          "Shu",
          "Shyla",
          "Sibyl",
          "Sidney",
          "Sierra",
          "Signe",
          "Sigrid",
          "Silva",
          "Silvana",
          "Silvia",
          "Sima",
          "Simona",
          "Simone",
          "Simonne",
          "Sina",
          "Sindy",
          "Siobhan",
          "Sirena",
          "Siu",
          "Sixta",
          "Skye",
          "Slyvia",
          "So",
          "Socorro",
          "Sofia",
          "Soila",
          "Sol",
          "Solange",
          "Soledad",
          "Somer",
          "Sommer",
          "Son",
          "Sona",
          "Sondra",
          "Song",
          "Sonia",
          "Sonja",
          "Sonya",
          "Soo",
          "Sook",
          "Soon",
          "Sophia",
          "Sophie",
          "Soraya",
          "Sparkle",
          "Spring",
          "Stacee",
          "Stacey",
          "Staci",
          "Stacia",
          "Stacie",
          "Stacy",
          "Star",
          "Starla",
          "Starr",
          "Stasia",
          "Stefani",
          "Stefania",
          "Stefanie",
          "Stefany",
          "Steffanie",
          "Stella",
          "Stepanie",
          "Stephaine",
          "Stephane",
          "Stephani",
          "Stephania",
          "Stephanie",
          "Stephany",
          "Stephen",
          "Stephenie",
          "Stephine",
          "Stephnie",
          "Steven",
          "Stevie",
          "Stormy",
          "Su",
          "Suanne",
          "Sudie",
          "Sue",
          "Sueann",
          "Suellen",
          "Suk",
          "Sulema",
          "Sumiko",
          "Summer",
          "Sun",
          "Sunday",
          "Sung",
          "Sunni",
          "Sunny",
          "Sunshine",
          "Susan",
          "Susana",
          "Susann",
          "Susanna",
          "Susannah",
          "Susanne",
          "Susie",
          "Susy",
          "Suzan",
          "Suzann",
          "Suzanna",
          "Suzanne",
          "Suzette",
          "Suzi",
          "Suzie",
          "Suzy",
          "Svetlana",
          "Sybil",
          "Syble",
          "Sydney",
          "Sylvia",
          "Sylvie",
          "Synthia",
          "Syreeta",
          "Ta",
          "Tabatha",
          "Tabetha",
          "Tabitha",
          "Tai",
          "Taina",
          "Taisha",
          "Tajuana",
          "Takako",
          "Takisha",
          "Talia",
          "Talisha",
          "Talitha",
          "Tam",
          "Tama",
          "Tamala",
          "Tamar",
          "Tamara",
          "Tamatha",
          "Tambra",
          "Tameika",
          "Tameka",
          "Tamekia",
          "Tamela",
          "Tamera",
          "Tamesha",
          "Tami",
          "Tamica",
          "Tamie",
          "Tamika",
          "Tamiko",
          "Tamisha",
          "Tammara",
          "Tammera",
          "Tammi",
          "Tammie",
          "Tammy",
          "Tamra",
          "Tana",
          "Tandra",
          "Tandy",
          "Taneka",
          "Tanesha",
          "Tangela",
          "Tania",
          "Tanika",
          "Tanisha",
          "Tanja",
          "Tanna",
          "Tanya",
          "Tara",
          "Tarah",
          "Taren",
          "Tari",
          "Tarra",
          "Tarsha",
          "Taryn",
          "Tasha",
          "Tashia",
          "Tashina",
          "Tasia",
          "Tatiana",
          "Tatum",
          "Tatyana",
          "Taunya",
          "Tawana",
          "Tawanda",
          "Tawanna",
          "Tawna",
          "Tawny",
          "Tawnya",
          "Taylor",
          "Tayna",
          "Teena",
          "Tegan",
          "Teisha",
          "Telma",
          "Temeka",
          "Temika",
          "Tempie",
          "Temple",
          "Tena",
          "Tenesha",
          "Tenisha",
          "Tennie",
          "Tennille",
          "Teodora",
          "Teofila",
          "Tequila",
          "Tera",
          "Tereasa",
          "Teresa",
          "Terese",
          "Teresia",
          "Teresita",
          "Teressa",
          "Teri",
          "Terica",
          "Terina",
          "Terisa",
          "Terra",
          "Terrell",
          "Terresa",
          "Terri",
          "Terrie",
          "Terrilyn",
          "Terry",
          "Tesha",
          "Tess",
          "Tessa",
          "Tessie",
          "Thalia",
          "Thanh",
          "Thao",
          "Thea",
          "Theda",
          "Thelma",
          "Theo",
          "Theodora",
          "Theola",
          "Theresa",
          "Therese",
          "Theresia",
          "Theressa",
          "Thersa",
          "Thi",
          "Thomasena",
          "Thomasina",
          "Thomasine",
          "Thora",
          "Thresa",
          "Thu",
          "Thuy",
          "Tia",
          "Tiana",
          "Tianna",
          "Tiara",
          "Tien",
          "Tiera",
          "Tierra",
          "Tiesha",
          "Tifany",
          "Tiffaney",
          "Tiffani",
          "Tiffanie",
          "Tiffany",
          "Tiffiny",
          "Tijuana",
          "Tilda",
          "Tillie",
          "Timika",
          "Timothy",
          "Tina",
          "Tinisha",
          "Tiny",
          "Tisa",
          "Tish",
          "Tisha",
          "Tobi",
          "Tobie",
          "Toby",
          "Toccara",
          "Toi",
          "Tomasa",
          "Tomeka",
          "Tomi",
          "Tomika",
          "Tomiko",
          "Tommie",
          "Tommy",
          "Tommye",
          "Tomoko",
          "Tona",
          "Tonda",
          "Tonette",
          "Toni",
          "Tonia",
          "Tonie",
          "Tonisha",
          "Tonita",
          "Tonja",
          "Tony",
          "Tonya",
          "Tora",
          "Tori",
          "Torie",
          "Torri",
          "Torrie",
          "Tory",
          "Tosha",
          "Toshia",
          "Toshiko",
          "Tova",
          "Towanda",
          "Toya",
          "Tracee",
          "Tracey",
          "Traci",
          "Tracie",
          "Tracy",
          "Tran",
          "Trang",
          "Travis",
          "Treasa",
          "Treena",
          "Trena",
          "Tresa",
          "Tressa",
          "Tressie",
          "Treva",
          "Tricia",
          "Trina",
          "Trinh",
          "Trinidad",
          "Trinity",
          "Trish",
          "Trisha",
          "Trista",
          "Tristan",
          "Troy",
          "Trudi",
          "Trudie",
          "Trudy",
          "Trula",
          "Tu",
          "Tula",
          "Tuyet",
          "Twana",
          "Twanda",
          "Twanna",
          "Twila",
          "Twyla",
          "Tyesha",
          "Tyisha",
          "Tyler",
          "Tynisha",
          "Tyra",
          "Ula",
          "Ulrike",
          "Un",
          "Una",
          "Ursula",
          "Usha",
          "Ute",
          "Vada",
          "Val",
          "Valarie",
          "Valda",
          "Valencia",
          "Valene",
          "Valentina",
          "Valentine",
          "Valeri",
          "Valeria",
          "Valerie",
          "Valery",
          "Vallie",
          "Valorie",
          "Valrie",
          "Van",
          "Vanda",
          "Vanesa",
          "Vanessa",
          "Vanetta",
          "Vania",
          "Vanita",
          "Vanna",
          "Vannesa",
          "Vannessa",
          "Vashti",
          "Vasiliki",
          "Veda",
          "Velda",
          "Velia",
          "Vella",
          "Velma",
          "Velva",
          "Velvet",
          "Vena",
          "Venessa",
          "Venetta",
          "Venice",
          "Venita",
          "Vennie",
          "Venus",
          "Veola",
          "Vera",
          "Verda",
          "Verdell",
          "Verdie",
          "Verena",
          "Vergie",
          "Verla",
          "Verlene",
          "Verlie",
          "Verline",
          "Verna",
          "Vernell",
          "Vernetta",
          "Vernia",
          "Vernice",
          "Vernie",
          "Vernita",
          "Vernon",
          "Verona",
          "Veronica",
          "Veronika",
          "Veronique",
          "Versie",
          "Vertie",
          "Vesta",
          "Veta",
          "Vi",
          "Vicenta",
          "Vickey",
          "Vicki",
          "Vickie",
          "Vicky",
          "Victor",
          "Victoria",
          "Victorina",
          "Vida",
          "Viki",
          "Vikki",
          "Vilma",
          "Vina",
          "Vincenza",
          "Vinita",
          "Vinnie",
          "Viola",
          "Violet",
          "Violeta",
          "Violette",
          "Virgen",
          "Virgie",
          "Virgil",
          "Virgina",
          "Virginia",
          "Vita",
          "Viva",
          "Vivan",
          "Vivian",
          "Viviana",
          "Vivien",
          "Vivienne",
          "Voncile",
          "Vonda",
          "Vonnie",
          "Wai",
          "Walter",
          "Waltraud",
          "Wan",
          "Wanda",
          "Waneta",
          "Wanetta",
          "Wanita",
          "Wava",
          "Wei",
          "Wen",
          "Wendi",
          "Wendie",
          "Wendolyn",
          "Wendy",
          "Wenona",
          "Wesley",
          "Whitley",
          "Whitney",
          "Wilda",
          "Wilhelmina",
          "Wilhemina",
          "Willa",
          "Willena",
          "Willene",
          "Willetta",
          "Willette",
          "Willia",
          "William",
          "Willie",
          "Williemae",
          "Willodean",
          "Willow",
          "Wilma",
          "Windy",
          "Winifred",
          "Winnie",
          "Winnifred",
          "Winona",
          "Winter",
          "Wonda",
          "Wynell",
          "Wynona",
          "Xenia",
          "Xiao",
          "Xiomara",
          "Xochitl",
          "Xuan",
          "Yadira",
          "Yaeko",
          "Yael",
          "Yahaira",
          "Yajaira",
          "Yan",
          "Yang",
          "Yanira",
          "Yasmin",
          "Yasmine",
          "Yasuko",
          "Yee",
          "Yelena",
          "Yen",
          "Yer",
          "Yesenia",
          "Yessenia",
          "Yetta",
          "Yevette",
          "Yi",
          "Ying",
          "Yoko",
          "Yolanda",
          "Yolande",
          "Yolando",
          "Yolonda",
          "Yon",
          "Yong",
          "Yoshie",
          "Yoshiko",
          "Youlanda",
          "Young",
          "Yu",
          "Yuette",
          "Yuk",
          "Yuki",
          "Yukiko",
          "Yuko",
          "Yulanda",
          "Yun",
          "Yung",
          "Yuonne",
          "Yuri",
          "Yuriko",
          "Yvette",
          "Yvone",
          "Yvonne",
          "Zada",
          "Zaida",
          "Zana",
          "Zandra",
          "Zelda",
          "Zella",
          "Zelma",
          "Zena",
          "Zenaida",
          "Zenia",
          "Zenobia",
          "Zetta",
          "Zina",
          "Zita",
          "Zoe",
          "Zofia",
          "Zoila",
          "Zola",
          "Zona",
          "Zonia",
          "Zora",
          "Zoraida",
          "Zula",
          "Zulema",
          "Zulma"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Abbott",
          "Abernathy",
          "Abshire",
          "Adams",
          "Altenwerth",
          "Anderson",
          "Ankunding",
          "Armstrong",
          "Auer",
          "Aufderhar",
          "Bahringer",
          "Bailey",
          "Balistreri",
          "Barrows",
          "Bartell",
          "Bartoletti",
          "Barton",
          "Bashirian",
          "Batz",
          "Bauch",
          "Baumbach",
          "Bayer",
          "Beahan",
          "Beatty",
          "Bechtelar",
          "Becker",
          "Bednar",
          "Beer",
          "Beier",
          "Berge",
          "Bergnaum",
          "Bergstrom",
          "Bernhard",
          "Bernier",
          "Bins",
          "Blanda",
          "Blick",
          "Block",
          "Bode",
          "Boehm",
          "Bogan",
          "Bogisich",
          "Borer",
          "Bosco",
          "Botsford",
          "Boyer",
          "Boyle",
          "Bradtke",
          "Brakus",
          "Braun",
          "Breitenberg",
          "Brekke",
          "Brown",
          "Bruen",
          "Buckridge",
          "Carroll",
          "Carter",
          "Cartwright",
          "Casper",
          "Cassin",
          "Champlin",
          "Christiansen",
          "Cole",
          "Collier",
          "Collins",
          "Conn",
          "Connelly",
          "Conroy",
          "Considine",
          "Corkery",
          "Cormier",
          "Corwin",
          "Cremin",
          "Crist",
          "Crona",
          "Cronin",
          "Crooks",
          "Cruickshank",
          "Cummerata",
          "Cummings",
          "Dach",
          "D'Amore",
          "Daniel",
          "Dare",
          "Daugherty",
          "Davis",
          "Deckow",
          "Denesik",
          "Dibbert",
          "Dickens",
          "Dicki",
          "Dickinson",
          "Dietrich",
          "Donnelly",
          "Dooley",
          "Douglas",
          "Doyle",
          "DuBuque",
          "Durgan",
          "Ebert",
          "Effertz",
          "Emard",
          "Emmerich",
          "Erdman",
          "Ernser",
          "Fadel",
          "Fahey",
          "Farrell",
          "Fay",
          "Feeney",
          "Feest",
          "Feil",
          "Ferry",
          "Fisher",
          "Flatley",
          "Frami",
          "Franecki",
          "Friesen",
          "Fritsch",
          "Funk",
          "Gerhold",
          "Gerlach",
          "Gibson",
          "Gislason",
          "Gleason",
          "Gleichner",
          "Glover",
          "Goldner",
          "Goodwin",
          "Gorczany",
          "Gottlieb",
          "Goyette",
          "Grady",
          "Graham",
          "Grant",
          "Green",
          "Greenfelder",
          "Greenholt",
          "Grimes",
          "Gulgowski",
          "Gusikowski",
          "Gutkowski",
          "Gutmann",
          "Haag",
          "Hackett",
          "Hagenes",
          "Hahn",
          "Haley",
          "Halvorson",
          "Hamill",
          "Hammes",
          "Hand",
          "Hane",
          "Hansen",
          "Harber",
          "Harris",
          "Hartmann",
          "Harvey",
          "Hauck",
          "Hayes",
          "Heaney",
          "Heathcote",
          "Hegmann",
          "Heidenreich",
          "Heller",
          "Herman",
          "Hermann",
          "Hermiston",
          "Herzog",
          "Hessel",
          "Hettinger",
          "Hickle",
          "Hill",
          "Hills",
          "Hilpert",
          "Hintz",
          "Hirthe",
          "Hodkiewicz",
          "Hoeger",
          "Homenick",
          "Hoppe",
          "Howe",
          "Howell",
          "Hudson",
          "Huel",
          "Huels",
          "Hyatt",
          "Jacobi",
          "Jacobs",
          "Jacobson",
          "Jakubowski",
          "Jaskolski",
          "Jast",
          "Jenkins",
          "Jerde",
          "Johns",
          "Johnson",
          "Johnston",
          "Jones",
          "Kassulke",
          "Kautzer",
          "Keebler",
          "Keeling",
          "Kemmer",
          "Kerluke",
          "Kertzmann",
          "Kessler",
          "Kiehn",
          "Kihn",
          "Kilback",
          "King",
          "Kirlin",
          "Klein",
          "Kling",
          "Klocko",
          "Koch",
          "Koelpin",
          "Koepp",
          "Kohler",
          "Konopelski",
          "Koss",
          "Kovacek",
          "Kozey",
          "Krajcik",
          "Kreiger",
          "Kris",
          "Kshlerin",
          "Kub",
          "Kuhic",
          "Kuhlman",
          "Kuhn",
          "Kulas",
          "Kunde",
          "Kunze",
          "Kuphal",
          "Kutch",
          "Kuvalis",
          "Labadie",
          "Lakin",
          "Lang",
          "Langosh",
          "Langworth",
          "Larkin",
          "Larson",
          "Leannon",
          "Lebsack",
          "Ledner",
          "Leffler",
          "Legros",
          "Lehner",
          "Lemke",
          "Lesch",
          "Leuschke",
          "Lind",
          "Lindgren",
          "Littel",
          "Little",
          "Lockman",
          "Lowe",
          "Lubowitz",
          "Lueilwitz",
          "Luettgen",
          "Lynch",
          "Macejkovic",
          "MacGyver",
          "Maggio",
          "Mann",
          "Mante",
          "Marks",
          "Marquardt",
          "Marvin",
          "Mayer",
          "Mayert",
          "McClure",
          "McCullough",
          "McDermott",
          "McGlynn",
          "McKenzie",
          "McLaughlin",
          "Medhurst",
          "Mertz",
          "Metz",
          "Miller",
          "Mills",
          "Mitchell",
          "Moen",
          "Mohr",
          "Monahan",
          "Moore",
          "Morar",
          "Morissette",
          "Mosciski",
          "Mraz",
          "Mueller",
          "Muller",
          "Murazik",
          "Murphy",
          "Murray",
          "Nader",
          "Nicolas",
          "Nienow",
          "Nikolaus",
          "Nitzsche",
          "Nolan",
          "Oberbrunner",
          "O'Connell",
          "O'Conner",
          "O'Hara",
          "O'Keefe",
          "O'Kon",
          "Okuneva",
          "Olson",
          "Ondricka",
          "O'Reilly",
          "Orn",
          "Ortiz",
          "Osinski",
          "Pacocha",
          "Padberg",
          "Pagac",
          "Parisian",
          "Parker",
          "Paucek",
          "Pfannerstill",
          "Pfeffer",
          "Pollich",
          "Pouros",
          "Powlowski",
          "Predovic",
          "Price",
          "Prohaska",
          "Prosacco",
          "Purdy",
          "Quigley",
          "Quitzon",
          "Rath",
          "Ratke",
          "Rau",
          "Raynor",
          "Reichel",
          "Reichert",
          "Reilly",
          "Reinger",
          "Rempel",
          "Renner",
          "Reynolds",
          "Rice",
          "Rippin",
          "Ritchie",
          "Robel",
          "Roberts",
          "Rodriguez",
          "Rogahn",
          "Rohan",
          "Rolfson",
          "Romaguera",
          "Roob",
          "Rosenbaum",
          "Rowe",
          "Ruecker",
          "Runolfsdottir",
          "Runolfsson",
          "Runte",
          "Russel",
          "Rutherford",
          "Ryan",
          "Sanford",
          "Satterfield",
          "Sauer",
          "Sawayn",
          "Schaden",
          "Schaefer",
          "Schamberger",
          "Schiller",
          "Schimmel",
          "Schinner",
          "Schmeler",
          "Schmidt",
          "Schmitt",
          "Schneider",
          "Schoen",
          "Schowalter",
          "Schroeder",
          "Schulist",
          "Schultz",
          "Schumm",
          "Schuppe",
          "Schuster",
          "Senger",
          "Shanahan",
          "Shields",
          "Simonis",
          "Sipes",
          "Skiles",
          "Smith",
          "Smitham",
          "Spencer",
          "Spinka",
          "Sporer",
          "Stamm",
          "Stanton",
          "Stark",
          "Stehr",
          "Steuber",
          "Stiedemann",
          "Stokes",
          "Stoltenberg",
          "Stracke",
          "Streich",
          "Stroman",
          "Strosin",
          "Swaniawski",
          "Swift",
          "Terry",
          "Thiel",
          "Thompson",
          "Tillman",
          "Torp",
          "Torphy",
          "Towne",
          "Toy",
          "Trantow",
          "Tremblay",
          "Treutel",
          "Tromp",
          "Turcotte",
          "Turner",
          "Ullrich",
          "Upton",
          "Vandervort",
          "Veum",
          "Volkman",
          "Von",
          "VonRueden",
          "Waelchi",
          "Walker",
          "Walsh",
          "Walter",
          "Ward",
          "Waters",
          "Watsica",
          "Weber",
          "Wehner",
          "Weimann",
          "Weissnat",
          "Welch",
          "West",
          "White",
          "Wiegand",
          "Wilderman",
          "Wilkinson",
          "Will",
          "Williamson",
          "Willms",
          "Windler",
          "Wintheiser",
          "Wisoky",
          "Wisozk",
          "Witting",
          "Wiza",
          "Wolf",
          "Wolff",
          "Wuckert",
          "Wunsch",
          "Wyman",
          "Yost",
          "Yundt",
          "Zboncak",
          "Zemlak",
          "Ziemann",
          "Zieme",
          "Zulauf"
        ],
        "male_first_name": [
          "Aaron",
          "Abdul",
          "Abe",
          "Abel",
          "Abraham",
          "Abram",
          "Adalberto",
          "Adam",
          "Adan",
          "Adolfo",
          "Adolph",
          "Adrian",
          "Agustin",
          "Ahmad",
          "Ahmed",
          "Al",
          "Alan",
          "Albert",
          "Alberto",
          "Alden",
          "Aldo",
          "Alec",
          "Alejandro",
          "Alex",
          "Alexander",
          "Alexis",
          "Alfonso",
          "Alfonzo",
          "Alfred",
          "Alfredo",
          "Ali",
          "Allan",
          "Allen",
          "Alonso",
          "Alonzo",
          "Alphonse",
          "Alphonso",
          "Alton",
          "Alva",
          "Alvaro",
          "Alvin",
          "Amado",
          "Ambrose",
          "Amos",
          "Anderson",
          "Andre",
          "Andrea",
          "Andreas",
          "Andres",
          "Andrew",
          "Andy",
          "Angel",
          "Angelo",
          "Anibal",
          "Anthony",
          "Antione",
          "Antoine",
          "Anton",
          "Antone",
          "Antonia",
          "Antonio",
          "Antony",
          "Antwan",
          "Archie",
          "Arden",
          "Ariel",
          "Arlen",
          "Arlie",
          "Armand",
          "Armando",
          "Arnold",
          "Arnoldo",
          "Arnulfo",
          "Aron",
          "Arron",
          "Art",
          "Arthur",
          "Arturo",
          "Asa",
          "Ashley",
          "Aubrey",
          "August",
          "Augustine",
          "Augustus",
          "Aurelio",
          "Austin",
          "Avery",
          "Barney",
          "Barrett",
          "Barry",
          "Bart",
          "Barton",
          "Basil",
          "Beau",
          "Ben",
          "Benedict",
          "Benito",
          "Benjamin",
          "Bennett",
          "Bennie",
          "Benny",
          "Benton",
          "Bernard",
          "Bernardo",
          "Bernie",
          "Berry",
          "Bert",
          "Bertram",
          "Bill",
          "Billie",
          "Billy",
          "Blaine",
          "Blair",
          "Blake",
          "Bo",
          "Bob",
          "Bobbie",
          "Bobby",
          "Booker",
          "Boris",
          "Boyce",
          "Boyd",
          "Brad",
          "Bradford",
          "Bradley",
          "Bradly",
          "Brady",
          "Brain",
          "Branden",
          "Brandon",
          "Brant",
          "Brendan",
          "Brendon",
          "Brent",
          "Brenton",
          "Bret",
          "Brett",
          "Brian",
          "Brice",
          "Britt",
          "Brock",
          "Broderick",
          "Brooks",
          "Bruce",
          "Bruno",
          "Bryan",
          "Bryant",
          "Bryce",
          "Bryon",
          "Buck",
          "Bud",
          "Buddy",
          "Buford",
          "Burl",
          "Burt",
          "Burton",
          "Buster",
          "Byron",
          "Caleb",
          "Calvin",
          "Cameron",
          "Carey",
          "Carl",
          "Carlo",
          "Carlos",
          "Carlton",
          "Carmelo",
          "Carmen",
          "Carmine",
          "Carol",
          "Carrol",
          "Carroll",
          "Carson",
          "Carter",
          "Cary",
          "Casey",
          "Cecil",
          "Cedric",
          "Cedrick",
          "Cesar",
          "Chad",
          "Chadwick",
          "Chance",
          "Chang",
          "Charles",
          "Charley",
          "Charlie",
          "Chas",
          "Chase",
          "Chauncey",
          "Chester",
          "Chet",
          "Chi",
          "Chong",
          "Chris",
          "Christian",
          "Christoper",
          "Christopher",
          "Chuck",
          "Chung",
          "Clair",
          "Clarence",
          "Clark",
          "Claud",
          "Claude",
          "Claudio",
          "Clay",
          "Clayton",
          "Clement",
          "Clemente",
          "Cleo",
          "Cletus",
          "Cleveland",
          "Cliff",
          "Clifford",
          "Clifton",
          "Clint",
          "Clinton",
          "Clyde",
          "Cody",
          "Colby",
          "Cole",
          "Coleman",
          "Colin",
          "Collin",
          "Colton",
          "Columbus",
          "Connie",
          "Conrad",
          "Cordell",
          "Corey",
          "Cornelius",
          "Cornell",
          "Cortez",
          "Cory",
          "Courtney",
          "Coy",
          "Craig",
          "Cristobal",
          "Cristopher",
          "Cruz",
          "Curt",
          "Curtis",
          "Cyril",
          "Cyrus",
          "Dale",
          "Dallas",
          "Dalton",
          "Damian",
          "Damien",
          "Damion",
          "Damon",
          "Dan",
          "Dana",
          "Dane",
          "Danial",
          "Daniel",
          "Danilo",
          "Dannie",
          "Danny",
          "Dante",
          "Darell",
          "Daren",
          "Darin",
          "Dario",
          "Darius",
          "Darnell",
          "Daron",
          "Darrel",
          "Darrell",
          "Darren",
          "Darrick",
          "Darrin",
          "Darron",
          "Darryl",
          "Darwin",
          "Daryl",
          "Dave",
          "David",
          "Davis",
          "Dean",
          "Deandre",
          "Deangelo",
          "Dee",
          "Del",
          "Delbert",
          "Delmar",
          "Delmer",
          "Demarcus",
          "Demetrius",
          "Denis",
          "Dennis",
          "Denny",
          "Denver",
          "Deon",
          "Derek",
          "Derick",
          "Derrick",
          "Deshawn",
          "Desmond",
          "Devin",
          "Devon",
          "Dewayne",
          "Dewey",
          "Dewitt",
          "Dexter",
          "Dick",
          "Diego",
          "Dillon",
          "Dino",
          "Dion",
          "Dirk",
          "Domenic",
          "Domingo",
          "Dominic",
          "Dominick",
          "Dominique",
          "Don",
          "Donald",
          "Dong",
          "Donn",
          "Donnell",
          "Donnie",
          "Donny",
          "Donovan",
          "Donte",
          "Dorian",
          "Dorsey",
          "Doug",
          "Douglas",
          "Douglass",
          "Doyle",
          "Drew",
          "Duane",
          "Dudley",
          "Duncan",
          "Dustin",
          "Dusty",
          "Dwain",
          "Dwayne",
          "Dwight",
          "Dylan",
          "Earl",
          "Earle",
          "Earnest",
          "Ed",
          "Eddie",
          "Eddy",
          "Edgar",
          "Edgardo",
          "Edison",
          "Edmond",
          "Edmund",
          "Edmundo",
          "Eduardo",
          "Edward",
          "Edwardo",
          "Edwin",
          "Efrain",
          "Efren",
          "Elbert",
          "Elden",
          "Eldon",
          "Eldridge",
          "Eli",
          "Elias",
          "Elijah",
          "Eliseo",
          "Elisha",
          "Elliot",
          "Elliott",
          "Ellis",
          "Ellsworth",
          "Elmer",
          "Elmo",
          "Eloy",
          "Elroy",
          "Elton",
          "Elvin",
          "Elvis",
          "Elwood",
          "Emanuel",
          "Emerson",
          "Emery",
          "Emil",
          "Emile",
          "Emilio",
          "Emmanuel",
          "Emmett",
          "Emmitt",
          "Emory",
          "Enoch",
          "Enrique",
          "Erasmo",
          "Eric",
          "Erich",
          "Erick",
          "Erik",
          "Erin",
          "Ernest",
          "Ernesto",
          "Ernie",
          "Errol",
          "Ervin",
          "Erwin",
          "Esteban",
          "Ethan",
          "Eugene",
          "Eugenio",
          "Eusebio",
          "Evan",
          "Everett",
          "Everette",
          "Ezekiel",
          "Ezequiel",
          "Ezra",
          "Fabian",
          "Faustino",
          "Fausto",
          "Federico",
          "Felipe",
          "Felix",
          "Felton",
          "Ferdinand",
          "Fermin",
          "Fernando",
          "Fidel",
          "Filiberto",
          "Fletcher",
          "Florencio",
          "Florentino",
          "Floyd",
          "Forest",
          "Forrest",
          "Foster",
          "Frances",
          "Francesco",
          "Francis",
          "Francisco",
          "Frank",
          "Frankie",
          "Franklin",
          "Franklyn",
          "Fred",
          "Freddie",
          "Freddy",
          "Frederic",
          "Frederick",
          "Fredric",
          "Fredrick",
          "Freeman",
          "Fritz",
          "Gabriel",
          "Gail",
          "Gale",
          "Galen",
          "Garfield",
          "Garland",
          "Garret",
          "Garrett",
          "Garry",
          "Garth",
          "Gary",
          "Gaston",
          "Gavin",
          "Gayle",
          "Genaro",
          "Gene",
          "Geoffrey",
          "George",
          "Gerald",
          "Geraldo",
          "Gerard",
          "Gerardo",
          "German",
          "Gerry",
          "Gil",
          "Gilbert",
          "Gilberto",
          "Gino",
          "Giovanni",
          "Giuseppe",
          "Glen",
          "Glenn",
          "Gonzalo",
          "Gordon",
          "Grady",
          "Graham",
          "Graig",
          "Grant",
          "Granville",
          "Greg",
          "Gregg",
          "Gregorio",
          "Gregory",
          "Grover",
          "Guadalupe",
          "Guillermo",
          "Gus",
          "Gustavo",
          "Guy",
          "Hai",
          "Hal",
          "Hank",
          "Hans",
          "Harlan",
          "Harland",
          "Harley",
          "Harold",
          "Harris",
          "Harrison",
          "Harry",
          "Harvey",
          "Hassan",
          "Hayden",
          "Haywood",
          "Heath",
          "Hector",
          "Henry",
          "Herb",
          "Herbert",
          "Heriberto",
          "Herman",
          "Herschel",
          "Hershel",
          "Hilario",
          "Hilton",
          "Hipolito",
          "Hiram",
          "Hobert",
          "Hollis",
          "Homer",
          "Hong",
          "Horace",
          "Horacio",
          "Hosea",
          "Houston",
          "Howard",
          "Hoyt",
          "Hubert",
          "Huey",
          "Hugh",
          "Hugo",
          "Humberto",
          "Hung",
          "Hunter",
          "Hyman",
          "Ian",
          "Ignacio",
          "Ike",
          "Ira",
          "Irvin",
          "Irving",
          "Irwin",
          "Isaac",
          "Isaiah",
          "Isaias",
          "Isiah",
          "Isidro",
          "Ismael",
          "Israel",
          "Isreal",
          "Issac",
          "Ivan",
          "Ivory",
          "Jacinto",
          "Jack",
          "Jackie",
          "Jackson",
          "Jacob",
          "Jacques",
          "Jae",
          "Jaime",
          "Jake",
          "Jamaal",
          "Jamal",
          "Jamar",
          "Jame",
          "Jamel",
          "James",
          "Jamey",
          "Jamie",
          "Jamison",
          "Jan",
          "Jared",
          "Jarod",
          "Jarred",
          "Jarrett",
          "Jarrod",
          "Jarvis",
          "Jason",
          "Jasper",
          "Javier",
          "Jay",
          "Jayson",
          "Jc",
          "Jean",
          "Jed",
          "Jeff",
          "Jefferey",
          "Jefferson",
          "Jeffery",
          "Jeffrey",
          "Jeffry",
          "Jerald",
          "Jeramy",
          "Jere",
          "Jeremiah",
          "Jeremy",
          "Jermaine",
          "Jerold",
          "Jerome",
          "Jeromy",
          "Jerrell",
          "Jerrod",
          "Jerrold",
          "Jerry",
          "Jess",
          "Jesse",
          "Jessie",
          "Jesus",
          "Jewel",
          "Jewell",
          "Jim",
          "Jimmie",
          "Jimmy",
          "Joan",
          "Joaquin",
          "Jody",
          "Joe",
          "Joel",
          "Joesph",
          "Joey",
          "John",
          "Johnathan",
          "Johnathon",
          "Johnie",
          "Johnnie",
          "Johnny",
          "Johnson",
          "Jon",
          "Jonah",
          "Jonas",
          "Jonathan",
          "Jonathon",
          "Jordan",
          "Jordon",
          "Jorge",
          "Jose",
          "Josef",
          "Joseph",
          "Josh",
          "Joshua",
          "Josiah",
          "Jospeh",
          "Josue",
          "Juan",
          "Jude",
          "Judson",
          "Jules",
          "Julian",
          "Julio",
          "Julius",
          "Junior",
          "Justin",
          "Kareem",
          "Karl",
          "Kasey",
          "Keenan",
          "Keith",
          "Kelley",
          "Kelly",
          "Kelvin",
          "Ken",
          "Kendall",
          "Kendrick",
          "Keneth",
          "Kenneth",
          "Kennith",
          "Kenny",
          "Kent",
          "Kenton",
          "Kermit",
          "Kerry",
          "Keven",
          "Kevin",
          "Kieth",
          "Kim",
          "King",
          "Kip",
          "Kirby",
          "Kirk",
          "Korey",
          "Kory",
          "Kraig",
          "Kris",
          "Kristofer",
          "Kristopher",
          "Kurt",
          "Kurtis",
          "Kyle",
          "Lacy",
          "Lamar",
          "Lamont",
          "Lance",
          "Landon",
          "Lane",
          "Lanny",
          "Larry",
          "Lauren",
          "Laurence",
          "Lavern",
          "Laverne",
          "Lawerence",
          "Lawrence",
          "Lazaro",
          "Leandro",
          "Lee",
          "Leif",
          "Leigh",
          "Leland",
          "Lemuel",
          "Len",
          "Lenard",
          "Lenny",
          "Leo",
          "Leon",
          "Leonard",
          "Leonardo",
          "Leonel",
          "Leopoldo",
          "Leroy",
          "Les",
          "Lesley",
          "Leslie",
          "Lester",
          "Levi",
          "Lewis",
          "Lincoln",
          "Lindsay",
          "Lindsey",
          "Lino",
          "Linwood",
          "Lionel",
          "Lloyd",
          "Logan",
          "Lon",
          "Long",
          "Lonnie",
          "Lonny",
          "Loren",
          "Lorenzo",
          "Lou",
          "Louie",
          "Louis",
          "Lowell",
          "Loyd",
          "Lucas",
          "Luciano",
          "Lucien",
          "Lucio",
          "Lucius",
          "Luigi",
          "Luis",
          "Luke",
          "Lupe",
          "Luther",
          "Lyle",
          "Lyman",
          "Lyndon",
          "Lynn",
          "Lynwood",
          "Mac",
          "Mack",
          "Major",
          "Malcolm",
          "Malcom",
          "Malik",
          "Man",
          "Manual",
          "Manuel",
          "Marc",
          "Marcel",
          "Marcelino",
          "Marcellus",
          "Marcelo",
          "Marco",
          "Marcos",
          "Marcus",
          "Margarito",
          "Maria",
          "Mariano",
          "Mario",
          "Marion",
          "Mark",
          "Markus",
          "Marlin",
          "Marlon",
          "Marquis",
          "Marshall",
          "Martin",
          "Marty",
          "Marvin",
          "Mary",
          "Mason",
          "Mathew",
          "Matt",
          "Matthew",
          "Maurice",
          "Mauricio",
          "Mauro",
          "Max",
          "Maximo",
          "Maxwell",
          "Maynard",
          "Mckinley",
          "Mel",
          "Melvin",
          "Merle",
          "Merlin",
          "Merrill",
          "Mervin",
          "Micah",
          "Michael",
          "Michal",
          "Michale",
          "Micheal",
          "Michel",
          "Mickey",
          "Miguel",
          "Mike",
          "Mikel",
          "Milan",
          "Miles",
          "Milford",
          "Millard",
          "Milo",
          "Milton",
          "Minh",
          "Miquel",
          "Mitch",
          "Mitchel",
          "Mitchell",
          "Modesto",
          "Mohamed",
          "Mohammad",
          "Mohammed",
          "Moises",
          "Monroe",
          "Monte",
          "Monty",
          "Morgan",
          "Morris",
          "Morton",
          "Mose",
          "Moses",
          "Moshe",
          "Murray",
          "Myles",
          "Myron",
          "Napoleon",
          "Nathan",
          "Nathanael",
          "Nathanial",
          "Nathaniel",
          "Neal",
          "Ned",
          "Neil",
          "Nelson",
          "Nestor",
          "Neville",
          "Newton",
          "Nicholas",
          "Nick",
          "Nickolas",
          "Nicky",
          "Nicolas",
          "Nigel",
          "Noah",
          "Noble",
          "Noe",
          "Noel",
          "Nolan",
          "Norbert",
          "Norberto",
          "Norman",
          "Normand",
          "Norris",
          "Numbers",
          "Octavio",
          "Odell",
          "Odis",
          "Olen",
          "Olin",
          "Oliver",
          "Ollie",
          "Omar",
          "Omer",
          "Oren",
          "Orlando",
          "Orval",
          "Orville",
          "Oscar",
          "Osvaldo",
          "Oswaldo",
          "Otha",
          "Otis",
          "Otto",
          "Owen",
          "Ozzie",
          "Pablo",
          "Palmer",
          "Paris",
          "Parker",
          "Pasquale",
          "Pat",
          "Patricia",
          "Patrick",
          "Paul",
          "Pedro",
          "Percy",
          "Perry",
          "Pete",
          "Peter",
          "Phil",
          "Philip",
          "Phillip",
          "Pierre",
          "Porfirio",
          "Porter",
          "Preston",
          "Prince",
          "Quentin",
          "Quincy",
          "Quinn",
          "Quintin",
          "Quinton",
          "Rafael",
          "Raleigh",
          "Ralph",
          "Ramiro",
          "Ramon",
          "Randal",
          "Randall",
          "Randell",
          "Randolph",
          "Randy",
          "Raphael",
          "Rashad",
          "Raul",
          "Ray",
          "Rayford",
          "Raymon",
          "Raymond",
          "Raymundo",
          "Reed",
          "Refugio",
          "Reggie",
          "Reginald",
          "Reid",
          "Reinaldo",
          "Renaldo",
          "Renato",
          "Rene",
          "Reuben",
          "Rex",
          "Rey",
          "Reyes",
          "Reynaldo",
          "Rhett",
          "Ricardo",
          "Rich",
          "Richard",
          "Richie",
          "Rick",
          "Rickey",
          "Rickie",
          "Ricky",
          "Rico",
          "Rigoberto",
          "Riley",
          "Rob",
          "Robbie",
          "Robby",
          "Robert",
          "Roberto",
          "Robin",
          "Robt",
          "Rocco",
          "Rocky",
          "Rod",
          "Roderick",
          "Rodger",
          "Rodney",
          "Rodolfo",
          "Rodrick",
          "Rodrigo",
          "Rogelio",
          "Roger",
          "Roland",
          "Rolando",
          "Rolf",
          "Rolland",
          "Roman",
          "Romeo",
          "Ron",
          "Ronald",
          "Ronnie",
          "Ronny",
          "Roosevelt",
          "Rory",
          "Rosario",
          "Roscoe",
          "Rosendo",
          "Ross",
          "Roy",
          "Royal",
          "Royce",
          "Ruben",
          "Rubin",
          "Rudolf",
          "Rudolph",
          "Rudy",
          "Rueben",
          "Rufus",
          "Rupert",
          "Russ",
          "Russel",
          "Russell",
          "Rusty",
          "Ryan",
          "Sal",
          "Salvador",
          "Salvatore",
          "Sam",
          "Sammie",
          "Sammy",
          "Samual",
          "Samuel",
          "Sandy",
          "Sanford",
          "Sang",
          "Santiago",
          "Santo",
          "Santos",
          "Saul",
          "Scot",
          "Scott",
          "Scottie",
          "Scotty",
          "Sean",
          "Sebastian",
          "Sergio",
          "Seth",
          "Seymour",
          "Shad",
          "Shane",
          "Shannon",
          "Shaun",
          "Shawn",
          "Shayne",
          "Shelby",
          "Sheldon",
          "Shelton",
          "Sherman",
          "Sherwood",
          "Shirley",
          "Shon",
          "Sid",
          "Sidney",
          "Silas",
          "Simon",
          "Sol",
          "Solomon",
          "Son",
          "Sonny",
          "Spencer",
          "Stacey",
          "Stacy",
          "Stan",
          "Stanford",
          "Stanley",
          "Stanton",
          "Stefan",
          "Stephan",
          "Stephen",
          "Sterling",
          "Steve",
          "Steven",
          "Stevie",
          "Stewart",
          "Stuart",
          "Sung",
          "Sydney",
          "Sylvester",
          "Tad",
          "Tanner",
          "Taylor",
          "Ted",
          "Teddy",
          "Teodoro",
          "Terence",
          "Terrance",
          "Terrell",
          "Terrence",
          "Terry",
          "Thad",
          "Thaddeus",
          "Thanh",
          "Theo",
          "Theodore",
          "Theron",
          "Thomas",
          "Thurman",
          "Tim",
          "Timmy",
          "Timothy",
          "Titus",
          "Tobias",
          "Toby",
          "Tod",
          "Todd",
          "Tom",
          "Tomas",
          "Tommie",
          "Tommy",
          "Toney",
          "Tony",
          "Tory",
          "Tracey",
          "Tracy",
          "Travis",
          "Trent",
          "Trenton",
          "Trevor",
          "Trey",
          "Trinidad",
          "Tristan",
          "Troy",
          "Truman",
          "Tuan",
          "Ty",
          "Tyler",
          "Tyree",
          "Tyrell",
          "Tyron",
          "Tyrone",
          "Tyson",
          "Ulysses",
          "Val",
          "Valentin",
          "Valentine",
          "Van",
          "Vance",
          "Vaughn",
          "Vern",
          "Vernon",
          "Vicente",
          "Victor",
          "Vince",
          "Vincent",
          "Vincenzo",
          "Virgil",
          "Virgilio",
          "Vito",
          "Von",
          "Wade",
          "Waldo",
          "Walker",
          "Wallace",
          "Wally",
          "Walter",
          "Walton",
          "Ward",
          "Warner",
          "Warren",
          "Waylon",
          "Wayne",
          "Weldon",
          "Wendell",
          "Werner",
          "Wes",
          "Wesley",
          "Weston",
          "Whitney",
          "Wilber",
          "Wilbert",
          "Wilbur",
          "Wilburn",
          "Wiley",
          "Wilford",
          "Wilfred",
          "Wilfredo",
          "Will",
          "Willard",
          "William",
          "Williams",
          "Willian",
          "Willie",
          "Willis",
          "Willy",
          "Wilmer",
          "Wilson",
          "Wilton",
          "Winford",
          "Winfred",
          "Winston",
          "Wm",
          "Woodrow",
          "Wyatt",
          "Xavier",
          "Yong",
          "Young",
          "Zachariah",
          "Zachary",
          "Zachery",
          "Zack",
          "Zackary",
          "Zane"
        ]
      },
      "phone_number": {
        "area_code": [
          "201",
          "202",
          "203",
          "205",
          "206",
          "207",
          "208",
          "209",
          "210",
          "212",
          "213",
          "214",
          "215",
          "216",
          "217",
          "218",
          "219",
          "224",
          "225",
          "228",
          "229",
          "231",
          "234",
          "239",
          "240",
          "248",
          "251",
          "252",
          "253",
          "254",
          "256",
          "260",
          "262",
          "267",
          "269",
          "270",
          "276",
          "281",
          "301",
          "302",
          "303",
          "304",
          "305",
          "307",
          "308",
          "309",
          "310",
          "312",
          "313",
          "314",
          "315",
          "316",
          "317",
          "318",
          "319",
          "320",
          "321",
          "323",
          "330",
          "334",
          "336",
          "337",
          "339",
          "347",
          "351",
          "352",
          "360",
          "361",
          "386",
          "401",
          "402",
          "404",
          "405",
          "406",
          "407",
          "408",
          "409",
          "410",
          "412",
          "413",
          "414",
          "415",
          "417",
          "419",
          "423",
          "424",
          "425",
          "434",
          "435",
          "440",
          "443",
          "469",
          "478",
          "479",
          "480",
          "484",
          "501",
          "502",
          "503",
          "504",
          "505",
          "507",
          "508",
          "509",
          "510",
          "512",
          "513",
          "515",
          "516",
          "517",
          "518",
          "520",
          "530",
          "540",
          "541",
          "551",
          "559",
          "561",
          "562",
          "563",
          "567",
          "570",
          "571",
          "573",
          "574",
          "580",
          "585",
          "586",
          "601",
          "602",
          "603",
          "605",
          "606",
          "607",
          "608",
          "609",
          "610",
          "612",
          "614",
          "615",
          "616",
          "617",
          "618",
          "619",
          "620",
          "623",
          "626",
          "630",
          "631",
          "636",
          "641",
          "646",
          "650",
          "651",
          "660",
          "661",
          "662",
          "678",
          "682",
          "701",
          "702",
          "703",
          "704",
          "706",
          "707",
          "708",
          "712",
          "713",
          "714",
          "715",
          "716",
          "717",
          "718",
          "719",
          "720",
          "724",
          "727",
          "731",
          "732",
          "734",
          "740",
          "754",
          "757",
          "760",
          "763",
          "765",
          "770",
          "772",
          "773",
          "774",
          "775",
          "781",
          "785",
          "786",
          "801",
          "802",
          "803",
          "804",
          "805",
          "806",
          "808",
          "810",
          "812",
          "813",
          "814",
          "815",
          "816",
          "817",
          "818",
          "828",
          "830",
          "831",
          "832",
          "843",
          "845",
          "847",
          "848",
          "850",
          "856",
          "857",
          "858",
          "859",
          "860",
          "862",
          "863",
          "864",
          "865",
          "870",
          "878",
          "901",
          "903",
          "904",
          "906",
          "907",
          "908",
          "909",
          "910",
          "912",
          "913",
          "914",
          "915",
          "916",
          "917",
          "918",
          "919",
          "920",
          "925",
          "928",
          "931",
          "936",
          "937",
          "940",
          "941",
          "947",
          "949",
          "952",
          "954",
          "956",
          "970",
          "971",
          "972",
          "973",
          "978",
          "979",
          "980",
          "985",
          "989"
        ],
        "country_code": [
          "1"
        ],
        "exchange_code": [
          "201",
          "202",
          "203",
          "205",
          "206",
          "207",
          "208",
          "209",
          "210",
          "212",
          "213",
          "214",
          "215",
          "216",
          "217",
          "218",
          "219",
          "224",
          "225",
          "227",
          "228",
          "229",
          "231",
          "234",
          "239",
          "240",
          "248",
          "251",
          "252",
          "253",
          "254",
          "256",
          "260",
          "262",
          "267",
          "269",
          "270",
          "276",
          "281",
          "283",
          "301",
          "302",
          "303",
          "304",
          "305",
          "307",
          "308",
          "309",
          "310",
          "312",
          "313",
          "314",
          "315",
          "316",
          "317",
          "318",
          "319",
          "320",
          "321",
          "323",
          "330",
          "331",
          "334",
          "336",
          "337",
          "339",
          "347",
          "351",
          "352",
          "360",
          "361",
          "386",
          "401",
          "402",
          "404",
          "405",
          "406",
          "407",
          "408",
          "409",
          "410",
          "412",
          "413",
          "414",
          "415",
          "417",
          "419",
          "423",
          "424",
          "425",
          "434",
          "435",
          "440",
          "443",
          "445",
          "464",
          "469",
          "470",
          "475",
          "478",
          "479",
          "480",
          "484",
          "501",
          "502",
          "503",
          "504",
          "505",
          "507",
          "508",
          "509",
          "510",
          "512",
          "513",
          "515",
          "516",
          "517",
          "518",
          "520",
          "530",
          "540",
          "541",
          "551",
          "557",
          "559",
          "561",
          "562",
          "563",
          "564",
          "567",
          "570",
          "571",
          "573",
          "574",
          "580",
          "585",
          "586",
          "601",
          "602",
          "603",
          "605",
          "606",
          "607",
          "608",
          "609",
          "610",
          "612",
          "614",
          "615",
          "616",
          "617",
          "618",
          "619",
          "620",
          "623",
          "626",
          "630",
          "631",
          "636",
          "641",
          "646",
          "650",
          "651",
          "660",
          "661",
          "662",
          "667",
          "678",
          "682",
          "701",
          "702",
          "703",
          "704",
          "706",
          "707",
          "708",
          "712",
          "713",
          "714",
          "715",
          "716",
          "717",
          "718",
          "719",
          "720",
          "724",
          "727",
          "731",
          "732",
          "734",
          "737",
          "740",
          "754",
          "757",
          "760",
          "763",
          "765",
          "770",
          "772",
          "773",
          "774",
          "775",
          "781",
          "785",
          "786",
          "801",
          "802",
          "803",
          "804",
          "805",
          "806",
          "808",
          "810",
          "812",
          "813",
          "814",
          "815",
          "816",
          "817",
          "818",
          "828",
          "830",
          "831",
          "832",
          "835",
          "843",
          "845",
          "847",
          "848",
          "850",
          "856",
          "857",
          "858",
          "859",
          "860",
          "862",
          "863",
          "864",
          "865",
          "870",
          "872",
          "878",
          "901",
          "903",
          "904",
          "906",
          "907",
          "908",
          "909",
          "910",
          "912",
          "913",
          "914",
          "915",
          "916",
          "917",
          "918",
          "919",
          "920",
          "925",
          "928",
          "931",
          "936",
          "937",
          "940",
          "941",
          "947",
          "949",
          "952",
          "954",
          "956",
          "959",
          "970",
          "971",
          "972",
          "973",
          "975",
          "978",
          "979",
          "980",
          "984",
          "985",
          "989"
        ],
        "extension": [
          "####"
        ],
        "formats": [
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}"
        ],
        "subscriber_number": [
          "####"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %I:%M:%S %p %Z",
        "long": "%B %d, %Y %I:%M %p",
        "short": "%d %b %I:%M %p"
      },
      "pm": "pm"
    }
  },
  "en-ZA": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "faker": {
      "address": {
        "cities": [
          "Alice",
          "Bellville",
          "Benoni",
          "Bethlehem",
          "Bloemfontein",
          "Boksburg",
          "Brakpan",
          "Butterworth",
          "Cape Town",
          "Carletonville",
          "Constantia",
          "Durban",
          "East London",
          "Emalahleni",
          "Empangeni",
          "George",
          "Germiston",
          "Giyani",
          "Graaff-Reinet",
          "Grahamstown",
          "Hopefield",
          "Jagersfontein",
          "Johannesburg",
          "Kimberley",
          "King William's Town",
          "Klerksdorp",
          "Kroonstad",
          "Krugersdorp",
          "Kuruman",
          "Ladysmith",
          "Lebowakgomo",
          "Mahikeng",
          "Mmabatho",
          "Mthatha",
          "Musina",
          "Nelspruit",
          "Newcastle",
          "Odendaalsrus",
          "Oudtshoorn",
          "Paarl",
          "Parys",
          "Phalaborwa",
          "Phuthaditjhaba",
          "Pietermaritzburg",
          "Pinetown",
          "Polokwane",
          "Port Elizabeth",
          "Port Nolloth",
          "Potchefstroom",
          "Pretoria",
          "Queenstown",
          "Randburg",
          "Randfontein",
          "Roodepoort",
          "Rustenburg",
          "Sasolburg",
          "Secunda",
          "Seshego",
          "Sibasa",
          "Simon's Town",
          "Soweto",
          "Springs",
          "Stellenbosch",
          "Swellendam",
          "Thabazimbi",
          "Tshwane",
          "Uitenhage",
          "Ulundi",
          "Umlazi",
          "Vanderbijlpark",
          "Vereeniging",
          "Virginia",
          "Welkom",
          "Worcester",
          "Zwelitsha"
        ],
        "city": [
          "#{cities}"
        ],
        "default_country": [
          "South Africa",
          "The Replublic of South Africa",
          "SA",
          "Afrique du Sud",
          "Zuid-Afrika"
        ],
        "default_country_code": [
          "ZA"
        ],
        "postcode": [
          "####",
          "#####"
        ],
        "province": [
          "#{provinces}"
        ],
        "provinces": [
          "Limpopo",
          "Gauteng",
          "Free State",
          "North West",
          "Northern Cape",
          "Western Cape",
          "KwaZulu-Natal",
          "Mpumalanga",
          "Eastern Cape"
        ],
        "state": [
          "#{provinces}"
        ]
      },
      "cell_phone": {
        "formats": [
          "+2782 ### ####",
          "+2772 ### ####",
          "+2776 ### ####",
          "+2779 ### ####",
          "+2760 ### ####",
          "+2761 ### ####",
          "082 ### ####",
          "072 ### ####",
          "076 ### ####",
          "079 ### ####",
          "060 ### ####",
          "061 ### ####",
          "+2783 ### ####",
          "+2773 ### ####",
          "+2763 ### ####",
          "083 ### ####",
          "073 ### ####",
          "063 ### ####",
          "+2781 ### ####",
          "+2761 ### ####",
          "081 ### ####",
          "061 ### ####",
          "+2784 ### ####",
          "+2774 ### ####",
          "084 ### ####",
          "074 ### ####"
        ]
      },
      "company": {
        "company_names": [
          "Ab-block Imgrin",
          "ACASA",
          "ACASA Bank",
          "Africa-Host",
          "Aspon Pharmaceuticals",
          "Automobile Associates",
          "Bardrays Africa",
          "Boat-Net Ports",
          "BusConneX",
          "c.tv",
          "Caspers",
          "Cell B",
          "Choose 'n Loose",
          "Diabettovo Sugar",
          "Dimdata Division",
          "Eishkom",
          "EX-acto",
          "Gojira Group",
          "Harmony Au",
          "Helkom",
          "Helkom Mobile",
          "Holland Group",
          "Impi Platinum",
          "Inglow Platinum",
          "Leadbank",
          "LITE Healthcare",
          "Lithotel",
          "Medical-Clinics 'R Us",
          "Merckers",
          "Met 'n Care",
          "Mobile Telecoms",
          "Nasmal",
          "NOVA Busses Pty Ltd",
          "NeetWEB",
          "Petrom",
          "Phlegm-Net",
          "Pie Foods",
          "Prime Media Circuit",
          "Rooster Record Company",
          "Second Rand",
          "Sewiz Gold Mines",
          "Shmapitec Bank",
          "Shop-a-right",
          "Silver Bolt Bus Services",
          "Silver Fields",
          "Simba Iron Ore",
          "SingleChoice",
          "South African Brewing Company",
          "South African Broadcast Company",
          "Spam Digital Media",
          "Substandard Bank",
          "Third Nation Bank",
          "TNB Connect",
          "Trains-Net",
          "Tyger Branding",
          "Yodakom"
        ],
        "name": [
          "#{company_names}",
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
        ],
        "suffix": [
          "Pty Ltd",
          "CC",
          "Group",
          "and Sons",
          "Sole Proprietor",
          "Trust"
        ],
        "type": [
          "Pty Ltd",
          "Close Corporation",
          "Sole Proprietor",
          "Trust",
          "Non Profit Organisation",
          "Listed Company"
        ]
      },
      "id_number": {
        "formats": [
          "##########08#"
        ]
      },
      "internet": {
        "domain_suffix": [
          "org.za",
          "co.za",
          "com"
        ]
      },
      "name": {
        "first_name": [
          "Abbi",
          "Abel",
          "Abigail",
          "Agmad",
          "Alexandra",
          "Alexi",
          "Ally",
          "Amahle",
          "Amber",
          "Ammaarah",
          "Amogelang",
          "Amos",
          "Amy",
          "Andre",
          "Anita",
          "Anmari",
          "Anneke",
          "Anthony",
          "Armand",
          "Arnauld",
          "Ashley",
          "Ashwin",
          "Aurelia",
          "Bandile",
          "Banele",
          "Bayron",
          "Bella",
          "Beth",
          "Bianca",
          "Bokamoso",
          "Brendan",
          "Brett",
          "Buhle",
          "Caitlin",
          "Calvin",
          "Cameron",
          "Candice",
          "Caressa",
          "Carla",
          "Chantelle",
          "Charlotte",
          "Chloë",
          "Christina",
          "Christopher",
          "Claire",
          "Claudia",
          "Courtney",
          "Cullen",
          "Daniel",
          "Danielia",
          "Danielle",
          "Deby",
          "Declan",
          "Devlin",
          "Duncan",
          "Ebrahim",
          "Elijah",
          "Elizabeth",
          "Elvis mbuya",
          "Emershan",
          "Emily",
          "Emma",
          "Emmanuel",
          "Enock",
          "Erin",
          "Ethan",
          "Eugene",
          "Ferdinand",
          "Francois",
          "Frans",
          "Gabriel",
          "Gavin",
          "Gemma",
          "Godwin",
          "Gugulethu",
          "Haajarah",
          "Haco",
          "Hannah",
          "Iminathi",
          "Is-haque",
          "Isaac",
          "Jade",
          "James holly mwase",
          "James",
          "Jandre",
          "Jayden",
          "Jemondre",
          "Jennifer",
          "Jess",
          "Jessica",
          "Joanna",
          "Jodi",
          "Joshua",
          "Juan",
          "Junior",
          "Justine",
          "Kamogelo",
          "Karabou",
          "Kauthar",
          "Kayla",
          "Kayleigh",
          "Keagan",
          "Keanu",
          "Kendal",
          "Khayone",
          "Kim",
          "Kimberley",
          "Kirsten",
          "Kungawo",
          "Laetitia",
          "Laila",
          "Laiq",
          "Lanchesester",
          "Lara",
          "Larey",
          "Lawrence",
          "Leah",
          "Lee-Ann",
          "Lerato",
          "Leroux",
          "Lesedi",
          "Lesego",
          "Lethabo",
          "Liberty",
          "Lily",
          "Lisa",
          "Logan",
          "Lolli",
          "Luke",
          "Lungelo",
          "Malaika",
          "Maria",
          "Marita",
          "Matthew",
          "Mbali",
          "Megan",
          "Melissa",
          "Meyer Bosman",
          "Mia",
          "Michael",
          "Michelle",
          "Mikayla",
          "Minenhle",
          "Mishka",
          "Momo",
          "Mounir",
          "Mpho",
          "Mpu",
          "Munashe",
          "Natalie",
          "Ndumiso",
          "Neil",
          "Nicholas",
          "Nicola",
          "Nicole",
          "Niel",
          "Nqobile",
          "Ntokozo",
          "Ofentse",
          "Ole",
          "Oliver",
          "Olivia",
          "Patrick",
          "Princess",
          "Rachel",
          "Raeesah",
          "Raven",
          "Reiner",
          "René",
          "Rethabile",
          "Retief",
          "Reuben",
          "Ricardo",
          "Ronald",
          "Ruben",
          "Ruth",
          "Ryan",
          "Saajidah",
          "Sam",
          "Sameera",
          "Sarah",
          "Savannah",
          "Sego",
          "Seth",
          "Shane",
          "Sharon",
          "Sikhumbuzo",
          "Simoné",
          "Siyabonga",
          "Spectra",
          "Stan",
          "Sue",
          "Sylvester",
          "Taahir",
          "Tajah",
          "Talia",
          "Tanja",
          "Tasneem",
          "Ted",
          "Thabani",
          "Thandolweth",
          "Thato",
          "Theolin",
          "Thomas",
          "Tim",
          "Tshegofatso",
          "Vaness",
          "Vanessa",
          "William",
          "Winslo",
          "Xavier",
          "Yash",
          "Zam",
          "Zama",
          "Zenzo",
          "Zoe",
          "Zolani"
        ],
        "last_name": [
          "Abraham",
          "Abrahams",
          "Ackerman",
          "Ackermann",
          "Adam",
          "Adams",
          "Adendorff",
          "Adonis",
          "Adriaan",
          "Africa",
          "Ahmed",
          "Alberts",
          "Albertus",
          "Albertyn",
          "Aletta",
          "Alexander",
          "Allan",
          "Allen",
          "Allie",
          "Allison",
          "Ally",
          "Amanda",
          "Amod",
          "Anderson",
          "Andrew",
          "Andrews",
          "Andries",
          "Ann",
          "Annandale",
          "Anthony",
          "Antoinette",
          "April",
          "Arendse",
          "Armstrong",
          "Arnold",
          "Arthur",
          "Aucamp",
          "Austin",
          "Badenhorst",
          "Bailey",
          "Baker",
          "Baloyi",
          "Bam",
          "Barker",
          "Barkhuizen",
          "Barnard",
          "Barnes",
          "Barry",
          "Bartlett",
          "Basson",
          "Beck",
          "Becker",
          "Beetge",
          "Bekker",
          "Bell",
          "Benade",
          "Beneke",
          "Benjamin",
          "Bennett",
          "Bergh",
          "Berry",
          "Bester",
          "Beukes",
          "Beyers",
          "Bezuidenhout",
          "Bhana",
          "Bhengu",
          "Bierman",
          "Blaauw",
          "Black",
          "Blake",
          "Blignaut",
          "Bloem",
          "Blom",
          "Booi",
          "Booyens",
          "Booysen",
          "Bornman",
          "Bosch",
          "Boshoff",
          "Bosman",
          "Botes",
          "Botha",
          "Bothma",
          "Boucher",
          "Bouwer",
          "Bowers",
          "Bradley",
          "Brand",
          "Brandt",
          "Bredenkamp",
          "Breedt",
          "Breytenbach",
          "Brink",
          "Brits",
          "Britz",
          "Bronkhorst",
          "Broodryk",
          "Brooks",
          "Brown",
          "Bruce",
          "Brummer",
          "Bruwer",
          "Buitendag",
          "Burger",
          "Burgess",
          "Burns",
          "Buthelezi",
          "Butler",
          "Buys",
          "Calitz",
          "Cameron",
          "Campbell",
          "Campher",
          "Carelse",
          "Caroline",
          "Carr",
          "Carstens",
          "Carter",
          "Cassim",
          "Cecilia",
          "Cele",
          "Chapman",
          "Charles",
          "Charlotte",
          "Charmaine",
          "Chauke",
          "Chetty",
          "Christiaan",
          "Christian",
          "Christie",
          "Christina",
          "Christoffel",
          "Christopher",
          "Cilliers",
          "Claasen",
          "Claassen",
          "Claassens",
          "Clark",
          "Clarke",
          "Cloete",
          "Coertze",
          "Coetsee",
          "Coetser",
          "Coetzee",
          "Coetzer",
          "Cohen",
          "Cole",
          "Coleman",
          "Collins",
          "Combrinck",
          "Combrink",
          "Conradie",
          "Constance",
          "Cook",
          "Cooper",
          "Cornelia",
          "Cornelius",
          "Correia",
          "Cox",
          "Crafford",
          "Craig",
          "Crawford",
          "Cronje",
          "Cross",
          "Crous",
          "Cunningham",
          "Cupido",
          "Cynthia",
          "Damons",
          "Daniel",
          "Daniels",
          "David",
          "Davids",
          "Davidson",
          "Davies",
          "Davis",
          "Dawood",
          "Dawson",
          "Daya",
          "De Beer",
          "Dean",
          "Deetlefs",
          "Delport",
          "Dennis",
          "Desai",
          "Deysel",
          "Deyzel",
          "Dhlamini",
          "Dicks",
          "Dickson",
          "Diedericks",
          "Dippenaar",
          "Dixon",
          "Dladla",
          "Dlamini",
          "Dollie",
          "Domingo",
          "Dorfling",
          "Dorothea",
          "Douglas",
          "Dreyer",
          "Du Plessis",
          "Du Toit",
          "Dube",
          "Duma",
          "Duncan",
          "Dunn",
          "Duvenage",
          "Duvenhage",
          "Ebrahim",
          "Edward",
          "Edwards",
          "Ehlers",
          "Eksteen",
          "Elliott",
          "Ellis",
          "Eloff",
          "Els",
          "Emmanuel",
          "Engelbrecht",
          "Enslin",
          "Erasmus",
          "Erwee",
          "Essack",
          "Essop",
          "Esterhuizen",
          "Esterhuyse",
          "Evans",
          "Eybers",
          "Faber",
          "Faith",
          "Fakier",
          "Farrell",
          "Ferguson",
          "Fernandes",
          "Ferreira",
          "Fick",
          "Fisher",
          "Fletcher",
          "Forbes",
          "Ford",
          "Fortuin",
          "Fortune",
          "Foster",
          "Fouche",
          "Fourie",
          "Fox",
          "Francis",
          "Francois",
          "Frank",
          "Fraser",
          "Frederick",
          "Fredericks",
          "Freeman",
          "Fritz",
          "Frost",
          "Fynn",
          "Gabriel",
          "Gama",
          "Geldenhuys",
          "George",
          "Gerber",
          "Gerhardus",
          "Gericke",
          "Geyer",
          "Geyser",
          "Gibson",
          "Gilbert",
          "Godfrey",
          "Goliath",
          "Gomes",
          "Goodman",
          "Goosen",
          "Gordon",
          "Gounden",
          "Gounder",
          "Gouws",
          "Govender",
          "Govindasamy",
          "Govindsamy",
          "Grace",
          "Graham",
          "Grant",
          "Gray",
          "Greeff",
          "Green",
          "Gregory",
          "Greyling",
          "Greyvenstein",
          "Griffin",
          "Griffiths",
          "Grobbelaar",
          "Grobler",
          "Groenewald",
          "Grove",
          "Gumede",
          "Haasbroek",
          "Hadebe",
          "Hall",
          "Hamilton",
          "Hamman",
          "Hammond",
          "Hanekom",
          "Hansen",
          "Harding",
          "Harmse",
          "Harper",
          "Harris",
          "Harrison",
          "Hart",
          "Hartley",
          "Hartman",
          "Hartzenberg",
          "Harvey",
          "Hassen",
          "Hassim",
          "Hattingh",
          "Haupt",
          "Havenga",
          "Hayes",
          "Hayward",
          "Heath",
          "Hefer",
          "Helena",
          "Henderson",
          "Hendricks",
          "Henning",
          "Henry",
          "Herbert",
          "Herbst",
          "Herholdt",
          "Herman",
          "Hermanus",
          "Herselman",
          "Heunis",
          "Heydenrych",
          "Heyns",
          "Hill",
          "Hlatshwayo",
          "Hlongwane",
          "Hlophe",
          "Hoffman",
          "Hoffmann",
          "Holmes",
          "Holtzhausen",
          "Hoosain",
          "Hoosen",
          "Hope",
          "Horn",
          "Horne",
          "Hough",
          "Howard",
          "Hudson",
          "Hughes",
          "Hugo",
          "Human",
          "Hunt",
          "Hunter",
          "Hurter",
          "Immelman",
          "Isaac",
          "Isaacs",
          "Ismail",
          "Jack",
          "Jackson",
          "Jacob",
          "Jacoba",
          "Jacobs",
          "Jacobus",
          "James",
          "Jane",
          "Janse Van Rensburg",
          "Jansen",
          "January",
          "Jappie",
          "Jardim",
          "Jardine",
          "Jean",
          "Jenkins",
          "Johan",
          "John",
          "Johnson",
          "Johnston",
          "Johnstone",
          "Jonas",
          "Jonathan",
          "Jones",
          "Jonker",
          "Jooste",
          "Jordaan",
          "Jordan",
          "Joseph",
          "Joubert",
          "Joy",
          "Joyce",
          "Julius",
          "Kader",
          "Kahn",
          "Kapp",
          "Kay",
          "Kekana",
          "Kelly",
          "Kemp",
          "Kennedy",
          "Kent",
          "Keyser",
          "Khan",
          "Khanyile",
          "Khoza",
          "Khumalo",
          "Khuzwayo",
          "Kilian",
          "King",
          "Kirsten",
          "Kisten",
          "Kitching",
          "Klein",
          "Kleinhans",
          "Kleynhans",
          "Klopper",
          "Kloppers",
          "Knight",
          "Knoetze",
          "Koch",
          "Kock",
          "Koekemoer",
          "Koen",
          "Kok",
          "Koopman",
          "Kotze",
          "Krause",
          "Kriek",
          "Kriel",
          "Krige",
          "Kritzinger",
          "Kruger",
          "Kubheka",
          "Kuhn",
          "Kumalo",
          "Kunene",
          "Labuschagne",
          "Lambrechts",
          "Lamprecht",
          "Landman",
          "Landsberg",
          "Langa",
          "Lange",
          "Langenhoven",
          "Lategan",
          "Laubscher",
          "Lawrence",
          "Lawson",
          "Lazarus",
          "Le Roux",
          "Leach",
          "Ledwaba",
          "Lee",
          "Legodi",
          "Leigh",
          "Leonard",
          "Lessing",
          "Letsoalo",
          "Levin",
          "Levy",
          "Lewis",
          "Liebenberg",
          "Lindeque",
          "Lloyd",
          "Lombaard",
          "Lombard",
          "Long",
          "Loots",
          "Lorraine",
          "Lotter",
          "Lottering",
          "Lotz",
          "Loubser",
          "Louis",
          "Louisa",
          "Louise",
          "Lourens",
          "Louw",
          "Louwrens",
          "Lubbe",
          "Lucas",
          "Ludick",
          "Lutchman",
          "Luthuli",
          "Maartens",
          "Mabasa",
          "Mabaso",
          "Mabena",
          "Mabunda",
          "Mabuza",
          "Macdonald",
          "Mackay",
          "Mackenzie",
          "Madonsela",
          "Magagula",
          "Magrietha",
          "Mahabeer",
          "Maharaj",
          "Mahlangu",
          "Mahomed",
          "Maistry",
          "Majola",
          "Makhanya",
          "Malan",
          "Malatji",
          "Maleka",
          "Malherbe",
          "Malinga",
          "Maluleka",
          "Maluleke",
          "Mamabolo",
          "Mann",
          "Mans",
          "Manuel",
          "Marais",
          "Mare",
          "Maree",
          "Margaret",
          "Margaretha",
          "Marie",
          "Maritz",
          "Mark",
          "Marshall",
          "Marthinus",
          "Martin",
          "Martins",
          "Marx",
          "Mary",
          "Masango",
          "Maseko",
          "Masemola",
          "Mashaba",
          "Mashego",
          "Mason",
          "Masuku",
          "Mathe",
          "Mathebula",
          "Mathews",
          "Matthee",
          "Matthews",
          "Matthysen",
          "May",
          "Mazibuko",
          "Mbatha",
          "Mbele",
          "Mbhele",
          "Mccarthy",
          "Mcdonald",
          "Mchunu",
          "Mckenzie",
          "Mclean",
          "Mdlalose",
          "Mdluli",
          "Meintjes",
          "Meiring",
          "Meyer",
          "Mhlanga",
          "Mhlongo",
          "Mia",
          "Michael",
          "Michelle",
          "Miles",
          "Miller",
          "Mills",
          "Minnaar",
          "Minnie",
          "Mitchell",
          "Mkhize",
          "Mkhwanazi",
          "Mlambo",
          "Mngomezulu",
          "Mnguni",
          "Mnisi",
          "Modiba",
          "Modise",
          "Moeketsi",
          "Mofokeng",
          "Mogale",
          "Mohamed",
          "Mokoena",
          "Mokone",
          "Mokwena",
          "Molefe",
          "Moller",
          "Moloi",
          "Moloto",
          "Momberg",
          "Moodley",
          "Moola",
          "Moolla",
          "Moolman",
          "Moonsamy",
          "Moore",
          "Moosa",
          "More",
          "Morgan",
          "Morkel",
          "Morris",
          "Morrison",
          "Moses",
          "Moss",
          "Mostert",
          "Motala",
          "Motaung",
          "Motloung",
          "Motsepe",
          "Mouton",
          "Mphahlele",
          "Mpho",
          "Msibi",
          "Msomi",
          "Mthembu",
          "Mthethwa",
          "Mthombeni",
          "Mtshali",
          "Mudau",
          "Muir",
          "Mulaudzi",
          "Mulder",
          "Muller",
          "Munro",
          "Munsami",
          "Munsamy",
          "Murphy",
          "Murray",
          "Murugan",
          "Myburgh",
          "Mynhardt",
          "Nagel",
          "Naicker",
          "Naidoo",
          "Naidu",
          "Naiker",
          "Nair",
          "Narainsamy",
          "Naude",
          "Ncube",
          "Ndaba",
          "Ndlela",
          "Ndlovu",
          "Neethling",
          "Nel",
          "Nell",
          "Nelson",
          "Nene",
          "Newman",
          "Ngcobo",
          "Ngema",
          "Ngidi",
          "Ngobeni",
          "Ngobese",
          "Ngubane",
          "Ngwenya",
          "Nhlapo",
          "Nicholas",
          "Nicholson",
          "Niemand",
          "Niemann",
          "Nienaber",
          "Nieuwoudt",
          "Nkabinde",
          "Nkomo",
          "Nkosi",
          "Nkuna",
          "Nolte",
          "Norman",
          "Norris",
          "Nortje",
          "Nothnagel",
          "Ntombela",
          "Ntuli",
          "Nunes",
          "Nxumalo",
          "Nzimande",
          "Oberholzer",
          "October",
          "Odendaal",
          "Oelofse",
          "Olckers",
          "Oliphant",
          "Oliver",
          "Omar",
          "Oosthuizen",
          "Oosthuysen",
          "Opperman",
          "Osman",
          "Otto",
          "Owen",
          "Padayachee",
          "Page",
          "Palmer",
          "Panday",
          "Parbhoo",
          "Parker",
          "Parsons",
          "Paruk",
          "Patel",
          "Paterson",
          "Pather",
          "Patience",
          "Patricia",
          "Patrick",
          "Paul",
          "Paulse",
          "Paulsen",
          "Payne",
          "Pearce",
          "Pearl",
          "Pearson",
          "Pelser",
          "Pereira",
          "Perumal",
          "Peter",
          "Peters",
          "Petersen",
          "Peterson",
          "Petrus",
          "Petzer",
          "Pheiffer",
          "Philander",
          "Phillip",
          "Phillips",
          "Phiri",
          "Pienaar",
          "Pieter",
          "Pieters",
          "Pieterse",
          "Pietersen",
          "Pillay",
          "Pistorius",
          "Porter",
          "Portia",
          "Posthumus",
          "Potgieter",
          "Powell",
          "Precious",
          "Pretorius",
          "Price",
          "Prince",
          "Prins",
          "Prinsloo",
          "Prudence",
          "Pule",
          "Putter",
          "Raath",
          "Rabe",
          "Rabie",
          "Radebe",
          "Rademan",
          "Rademeyer",
          "Rajah",
          "Rampersad",
          "Ramsamy",
          "Randall",
          "Ras",
          "Raubenheimer",
          "Rautenbach",
          "Raymond",
          "Reddy",
          "Redelinghuys",
          "Reed",
          "Reid",
          "Retief",
          "Reyneke",
          "Reynolds",
          "Rheeder",
          "Ribeiro",
          "Richard",
          "Richards",
          "Richardson",
          "Richter",
          "Riekert",
          "Rikhotso",
          "Riley",
          "Robert",
          "Roberts",
          "Robertson",
          "Robinson",
          "Rodrigues",
          "Roets",
          "Rogers",
          "Roodt",
          "Roos",
          "Rose",
          "Ross",
          "Rossouw",
          "Rousseau",
          "Roux",
          "Rowe",
          "Rudman",
          "Rudolph",
          "Ruiters",
          "Russell",
          "Ruth",
          "Ryan",
          "Saayman",
          "Salie",
          "Sampson",
          "Samsodien",
          "Samuel",
          "Samuels",
          "Sanders",
          "Sauls",
          "Saunders",
          "Sayed",
          "Scheepers",
          "Schmidt",
          "Schoeman",
          "Scholtz",
          "Schreuder",
          "Schroeder",
          "Schultz",
          "Schutte",
          "Schwartz",
          "Scott",
          "Seedat",
          "Selepe",
          "Senekal",
          "September",
          "Serfontein",
          "Shabangu",
          "Shaik",
          "Shange",
          "Sharon",
          "Shaw",
          "Sheik",
          "Shezi",
          "Shongwe",
          "Sibanyoni",
          "Sibeko",
          "Sibisi",
          "Sibiya",
          "Simelane",
          "Simon",
          "Simons",
          "Simpson",
          "Sinclair",
          "Singh",
          "Sithole",
          "Skosana",
          "Slabber",
          "Slabbert",
          "Smal",
          "Small",
          "Smit",
          "Smith",
          "Smuts",
          "Snyders",
          "Snyman",
          "Solomon",
          "Solomons",
          "Soobramoney",
          "Sophia",
          "Spangenberg",
          "Spies",
          "Stander",
          "Stanley",
          "Stapelberg",
          "Stassen",
          "Steenberg",
          "Steenekamp",
          "Steenkamp",
          "Stemmet",
          "Stephanus",
          "Stephen",
          "Stephens",
          "Stevens",
          "Stevenson",
          "Stewart",
          "Steyl",
          "Steyn",
          "Steynberg",
          "Stols",
          "Stoltz",
          "Stone",
          "Storm",
          "Strauss",
          "Struwig",
          "Strydom",
          "Stuart",
          "Subramoney",
          "Suliman",
          "Susan",
          "Sutherland",
          "Swanepoel",
          "Swart",
          "Swarts",
          "Swartz",
          "Tait",
          "Taljaard",
          "Tau",
          "Taylor",
          "Tebogo",
          "Teixeira",
          "Terblanche",
          "Theart",
          "Theresa",
          "Theron",
          "Theunissen",
          "Thiart",
          "Thomas",
          "Thompson",
          "Thomson",
          "Thwala",
          "Titus",
          "Trollip",
          "Truter",
          "Tshabalala",
          "Tsotetsi",
          "Tucker",
          "Turner",
          "Twala",
          "Ungerer",
          "Uys",
          "Valentine",
          "Van Der Merwe",
          "Van Niekerk",
          "Van Rooyen",
          "Van Wyk",
          "Van Zyl",
          "Venter",
          "Vermaak",
          "Vermeulen",
          "Veronica",
          "Verster",
          "Verwey",
          "Victor",
          "Vilakazi",
          "Viljoen",
          "Vincent",
          "Visagie",
          "Visser",
          "Viviers",
          "Vlok",
          "Vogel",
          "Voges",
          "Volschenk",
          "Vorster",
          "Vos",
          "Vosloo",
          "Wagner",
          "Walker",
          "Wallace",
          "Walsh",
          "Walter",
          "Walters",
          "Ward",
          "Warren",
          "Watkins",
          "Watson",
          "Watt",
          "Webb",
          "Webber",
          "Weber",
          "Webster",
          "Weideman",
          "Welgemoed",
          "Welman",
          "Wentzel",
          "Wepener",
          "Wessels",
          "West",
          "Weyers",
          "Wheeler",
          "White",
          "Whitehead",
          "Wiese",
          "Wiid",
          "Wilhelmina",
          "Wilken",
          "Wilkinson",
          "Willem",
          "Willemse",
          "William",
          "Williams",
          "Williamson",
          "Wilson",
          "Witbooi",
          "Wolfaardt",
          "Wolmarans",
          "Wood",
          "Woods",
          "Wright",
          "Xaba",
          "Xulu",
          "Young",
          "Yvonne",
          "Zeelie",
          "Zietsman",
          "Zondi",
          "Zondo",
          "Zulu",
          "Zuma",
          "Zungu",
          "Zwane"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "010 ### ####",
          "011 ### ####",
          "012 ### ####",
          "013 ### ####",
          "014 ### ####",
          "015 ### ####",
          "016 ### ####",
          "017 ### ####",
          "018 ### ####",
          "021 ### ####",
          "022 ### ####",
          "023 ### ####",
          "024 ### ####",
          "027 ### ####",
          "028 ### ####",
          "031 ### ####",
          "032 ### ####",
          "033 ### ####",
          "034 ### ####",
          "035 ### ####",
          "036 ### ####",
          "039 ### ####",
          "040 ### ####",
          "041 ### ####",
          "042 ### ####",
          "043 ### ####",
          "044 ### ####",
          "045 ### ####",
          "046 ### ####",
          "047 ### ####",
          "048 ### ####",
          "049 ### ####",
          "051 ### ####",
          "053 ### ####",
          "054 ### ####",
          "056 ### ####",
          "057 ### ####",
          "058 ### ####",
          "+2710 ### ####",
          "+2711 ### ####",
          "+2712 ### ####",
          "+2713 ### ####",
          "+2714 ### ####",
          "+2715 ### ####",
          "+2716 ### ####",
          "+2717 ### ####",
          "+2718 ### ####",
          "+2721 ### ####",
          "+2722 ### ####",
          "+2723 ### ####",
          "+2724 ### ####",
          "+2727 ### ####",
          "+2728 ### ####",
          "+2731 ### ####",
          "+2732 ### ####",
          "+2733 ### ####",
          "+2734 ### ####",
          "+2735 ### ####",
          "+2736 ### ####",
          "+2739 ### ####",
          "+2740 ### ####",
          "+2741 ### ####",
          "+2742 ### ####",
          "+2743 ### ####",
          "+2744 ### ####",
          "+2745 ### ####",
          "+2746 ### ####",
          "+2747 ### ####",
          "+2748 ### ####",
          "+2749 ### ####",
          "+2751 ### ####",
          "+2753 ### ####",
          "+2754 ### ####",
          "+2756 ### ####",
          "+2757 ### ####",
          "+2758 ### ####"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%u %n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "R"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "en-au-ocker": {
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##"
        ],
        "city": [
          "#{city_prefix}"
        ],
        "city_prefix": [
          "Bondi",
          "Burleigh Heads",
          "Carlton",
          "Fitzroy",
          "Fremantle",
          "Glenelg",
          "Manly",
          "Noosa",
          "Stones Corner",
          "St Kilda",
          "Surry Hills",
          "Yarra Valley"
        ],
        "default_country": [
          "Australia"
        ],
        "default_country_code": [
          "AU"
        ],
        "postcode": [
          "0###",
          "2###",
          "3###",
          "4###",
          "5###",
          "6###",
          "7###"
        ],
        "region": [
          "South East Queensland",
          "Wide Bay Burnett",
          "Margaret River",
          "Port Pirie",
          "Gippsland",
          "Elizabeth",
          "Barossa"
        ],
        "state": [
          "New South Wales",
          "Queensland",
          "Northern Territory",
          "South Australia",
          "Western Australia",
          "Tasmania",
          "Australian Capital Territory",
          "Victoria"
        ],
        "state_abbr": [
          "NSW",
          "QLD",
          "NT",
          "SA",
          "WA",
          "TAS",
          "ACT",
          "VIC"
        ],
        "street_name": [
          "#{street_root}"
        ],
        "street_root": [
          "Ramsay Street",
          "Bonnie Doon",
          "Cavill Avenue",
          "Queen Street"
        ],
        "street_suffix": [
          "Avenue",
          "Boulevard",
          "Circle",
          "Circuit",
          "Court",
          "Crescent",
          "Crest",
          "Drive",
          "Estate Dr",
          "Grove",
          "Hill",
          "Island",
          "Junction",
          "Knoll",
          "Lane",
          "Loop",
          "Mall",
          "Manor",
          "Meadow",
          "Mews",
          "Parade",
          "Parkway",
          "Pass",
          "Place",
          "Plaza",
          "Ridge",
          "Road",
          "Run",
          "Square",
          "Station St",
          "Street",
          "Summit",
          "Terrace",
          "Track",
          "Trail",
          "View Rd",
          "Way"
        ]
      },
      "cell_phone": {
        "formats": [
          "04##-###-###",
          "(0) 4##-###-###",
          "04## ### ###",
          "04########",
          "04## ## ## ##"
        ]
      },
      "company": {
        "suffix": [
          "Pty Ltd",
          "and Sons",
          "Corp",
          "Group",
          "Brothers",
          "Partners"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com.au",
          "com",
          "net.au",
          "net",
          "org.au",
          "org"
        ]
      },
      "name": {
        "first_name": [
          "Charlene",
          "Bruce",
          "Charlotte",
          "Ava",
          "Chloe",
          "Emily",
          "Olivia",
          "Zoe",
          "Lily",
          "Sophie",
          "Amelia",
          "Sofia",
          "Ella",
          "Isabella",
          "Ruby",
          "Sienna",
          "Mia+3",
          "Grace",
          "Emma",
          "Ivy",
          "Layla",
          "Abigail",
          "Isla",
          "Hannah",
          "Zara",
          "Lucy",
          "Evie",
          "Annabelle",
          "Madison",
          "Alice",
          "Georgia",
          "Maya",
          "Madeline",
          "Audrey",
          "Scarlett",
          "Isabelle",
          "Chelsea",
          "Mila",
          "Holly",
          "Indiana",
          "Poppy",
          "Harper",
          "Sarah",
          "Alyssa",
          "Jasmine",
          "Imogen",
          "Hayley",
          "Pheobe",
          "Eva",
          "Evelyn",
          "Mackenzie",
          "Ayla",
          "Oliver",
          "Jack",
          "Jackson",
          "William",
          "Ethan",
          "Charlie",
          "Lucas",
          "Cooper",
          "Lachlan",
          "Noah",
          "Liam",
          "Alexander",
          "Max",
          "Isaac",
          "Thomas",
          "Xavier",
          "Oscar",
          "Benjamin",
          "Aiden",
          "Mason",
          "Samuel",
          "James",
          "Levi",
          "Riley",
          "Harrison",
          "Ryan",
          "Henry",
          "Jacob",
          "Joshua",
          "Leo",
          "Zach",
          "Harry",
          "Hunter",
          "Flynn",
          "Archie",
          "Tyler",
          "Elijah",
          "Hayden",
          "Jayden",
          "Blake",
          "Archer",
          "Ashton",
          "Sebastian",
          "Zachery",
          "Lincoln",
          "Mitchell",
          "Luca",
          "Nathan",
          "Kai",
          "Connor",
          "Tom",
          "Nigel",
          "Matt",
          "Sean"
        ],
        "last_name": [
          "Smith",
          "Jones",
          "Williams",
          "Brown",
          "Wilson",
          "Taylor",
          "Morton",
          "White",
          "Martin",
          "Anderson",
          "Thompson",
          "Nguyen",
          "Thomas",
          "Walker",
          "Harris",
          "Lee",
          "Ryan",
          "Robinson",
          "Kelly",
          "King",
          "Rausch",
          "Ridge",
          "Connolly",
          "LeQuesne"
        ],
        "ocker_first_name": [
          "Bazza",
          "Bluey",
          "Davo",
          "Johno",
          "Shano",
          "Shazza",
          "Wazza",
          "Charl",
          "Darl"
        ]
      },
      "phone_number": {
        "country_code": [
          "61"
        ],
        "formats": [
          "0# #### ####",
          "# #### ####",
          "4## ### ###"
        ]
      }
    }
  },
  "eo": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Konfirmo sendita je",
          "confirmation_token": "Konfirma ĵetono",
          "confirmed_at": "Konfirmita je",
          "created_at": "Kreita je",
          "current_password": "Nuna pasvorto",
          "current_sign_in_at": "Nuna ensaluto je",
          "current_sign_in_ip": "Nuna ensaluto en IP",
          "email": "Retadreso",
          "encrypted_password": "Ĉifrita pasvorto",
          "failed_attempts": "Malsukcesaj provoj",
          "last_sign_in_at": "Lasta ensaluto je",
          "last_sign_in_ip": "Lasta ensaluto en IP",
          "locked_at": "Ŝlosita je",
          "password": "Pasvorto",
          "password_confirmation": "Konfirmo de pasvorto",
          "remember_created_at": "Memoru min kreita je",
          "remember_me": "Memoru min",
          "reset_password_sent_at": "Instrukcioj por ŝanĝi pasvorton sendita je",
          "reset_password_token": "Ĵetono por ŝanĝi pasvorton",
          "sign_in_count": "Nombro da ensalutoj",
          "unconfirmed_email": "Nekonfirmita retadreso",
          "unlock_token": "Ĵetono por malŝlosi",
          "updated_at": "Ĝisdatigita je"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validado malsukcesis: %{errors}"
        }
      },
      "models": {
        "user": {
          "one": "Uzanto",
          "other": "Uzantoj"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "ĵaŭ",
        "ven",
        "sab"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "majo",
        "jun.",
        "jul.",
        "aŭg.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
      ],
      "day_names": [
        "dimanĉo",
        "lundo",
        "mardo",
        "merkredo",
        "ĵaŭdo",
        "vendredo",
        "sabato"
      ],
      "formats": {
        "default": "%Y/%m/%d",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "januaro",
        "februaro",
        "marto",
        "aprilo",
        "majo",
        "junio",
        "julio",
        "aŭgusto",
        "septembro",
        "oktobro",
        "novembro",
        "decembro"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ĉirkaŭ unu horo",
          "other": "ĉirkaŭ %{count} horoj"
        },
        "about_x_months": {
          "one": "ĉirkaŭ unu monato",
          "other": "ĉirkaŭ %{count} monatoj"
        },
        "about_x_years": {
          "one": "ĉirkaŭ uno jaro",
          "other": "ĉirkaŭ %{count} jaroj"
        },
        "almost_x_years": {
          "one": "preskaŭ unu jaro",
          "other": "preskaŭ %{count} jaroj"
        },
        "half_a_minute": "duona minuto",
        "less_than_x_minutes": {
          "one": "malpli ol unu minuto",
          "other": "malpli ol %{count} minutoj",
          "zero": "malpli ol unu minuto"
        },
        "less_than_x_seconds": {
          "one": "malpli ol unu sekundo",
          "other": "malpli ol %{count} sekundoj",
          "zero": "malpli ol unu sekundo"
        },
        "over_x_years": {
          "one": "pli ol unu jaro",
          "other": "pli ol %{count} jaroj"
        },
        "x_days": {
          "one": "%{count} tago",
          "other": "%{count} tagoj"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutoj"
        },
        "x_months": {
          "one": "%{count} monato",
          "other": "%{count} monatoj"
        },
        "x_seconds": {
          "one": "%{count} sekundo",
          "other": "%{count} sekundoj"
        }
      },
      "prompts": {
        "day": "Tago",
        "hour": "Horo",
        "minute": "Minuto",
        "month": "Monato",
        "second": "Sekundo",
        "year": "Jaro"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Via retadreso estis sukcese konfirmita.",
        "new": {
          "resend_confirmation_instructions": "Sendi konfirminstrukciojn denove"
        },
        "send_instructions": "Vi ricevos retmesaĝon kun instrukcioj por konfirmi vian retadreson ene de kelkaj minutoj. Bonvolu kontroli vian spamujon se vi ne ricevis ĉi tiun retmesaĝon.",
        "send_paranoid_instructions": "Se via retadreso ekzistas en nia datumbazo, vi ricevos retmesaĝon kun instrukcioj por konfirmi vian retadreson ene de kelkaj minutoj. Bonvolu kontroli vian spamujon se vi ne ricevis ĉi tiun retmesaĝon."
      },
      "failure": {
        "already_authenticated": "Vi jam salutis.",
        "inactive": "Via konto ankoraŭ ne estas konfirmita.",
        "invalid": "Nevalida %{authentication_keys} aŭ pasvorto.",
        "last_attempt": "Vi ankoraŭ povas provi unufoje antaŭ ol via konto estos ŝlosita.",
        "locked": "Via konto estas ŝlosita.",
        "not_found_in_database": "Nevalida %{authentication_keys} aŭ pasvorto.",
        "timeout": "Via seanco eksvalidiĝis. Bonvolu ensaluti denove por daŭrigi.",
        "unauthenticated": "Vi devas ensaluti aŭ registriĝi antaŭ ol daŭrigi.",
        "unconfirmed": "Vi devas konfirmi vian retadreson antaŭ ol daŭrigi."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Konfirmi mian konton",
          "greeting": "Bonvenon %{recipient}!",
          "instruction": "Vi povas konfirmi vian retadreson per la suba ligilo:",
          "subject": "Konfirminstrukcioj"
        },
        "email_changed": {
          "greeting": "Saluton %{recipient}!",
          "message": "Ni kontaktas vin por sciigi vin, ke via retadreso estas ŝanĝita al %{email}.",
          "message_unconfirmed": "Ni kontaktas vin por sciigi vin, ke via retadreso estas ŝanĝanta al %{email}.",
          "subject": "Retadreso ŝanĝita"
        },
        "password_change": {
          "greeting": "Saluton %{recipient}!",
          "message": "Ni kontaktas vin por sciigi vin, ke via pasvorto estas ŝanĝita.",
          "subject": "Pasvorto ŝanĝita"
        },
        "reset_password_instructions": {
          "action": "Ŝanĝi mian pasvorton",
          "greeting": "Saluton %{recipient}!",
          "instruction": "Iu petis ligilon por ŝanĝi vian pasvorton. Vi povas fari tion per la suba ligilo.",
          "instruction_2": "Se vi ne petis tion, bonvolu ignori ĉi tiun retmesaĝon.",
          "instruction_3": "Via pasvorto ne ŝanĝiĝos ĝis vi aliros la supran ligilon kaj kreos novan.",
          "subject": "Instrukcioj por ŝanĝi pasvorton"
        },
        "unlock_instructions": {
          "action": "Malŝlosi mian konton",
          "greeting": "Saluton %{recipient}!",
          "instruction": "Alklaku la suban ligilon por malŝlosi vian konton:",
          "message": "Via konto estis ŝlosita pro troa nombro da malsukcesaj ensalutprovoj.",
          "subject": "Instrukcioj por malŝlosi"
        }
      },
      "omniauth_callbacks": {
        "failure": "Ni ne povis aŭtentigi vin per %{kind}: '%{reason}'.",
        "success": "Aŭtentigita sukcese per %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Ŝanĝi mian pasvorton",
          "change_your_password": "Ŝanĝi vian pasvorton",
          "confirm_new_password": "Konfirmi novan pasvorton",
          "new_password": "Nova pasvorto"
        },
        "new": {
          "forgot_your_password": "Ĉu vi forgesis vian pasvorton?",
          "send_me_reset_password_instructions": "Sendu al mi instrukciojn por ŝanĝi mian pasvorton"
        },
        "no_token": "Vi ne povas aliri al ĉi tiu paĝo alimaniere ol per retmesaĝo por ŝanĝi pasvorton. Se vi venas de tia retmesaĝo, bonvolu certiĝi, ke vi uzas la tutan URL-on donitan.",
        "send_instructions": "Vi ricevos ligilon por havi novan pasvorton ĉe via retadreso ene de kelkaj minutoj. Bonvolu kontroli vian spamujon se vi ne ricevis ĉi tiun retmesaĝon.",
        "send_paranoid_instructions": "Se via retadreso ekzistas en nia datumbazo, vi ricevos ligilon por havi novan pasvorton ĉe via retadreso ene de kelkaj minutoj. Bonvolu kontroli vian spamujon se vi ne ricevis ĉi tiun retmesaĝon.",
        "updated": "Via pasvorto estis sukcese ŝanĝita. Vi nun estas ensalutinta.",
        "updated_not_active": "Via pasvorto estis sukcese ŝanĝita."
      },
      "registrations": {
        "destroyed": "Ĝis! Via konto estis sukcese forigita. Ni esperas revidi vin baldaŭ.",
        "edit": {
          "are_you_sure": "Ĉu vi certas?",
          "cancel_my_account": "Nuligi mian konton",
          "currently_waiting_confirmation_for_email": "Nuntempe atendas konfirmon por: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lasu malplena se vi ne volas ŝanĝi ĝin",
          "title": "Modifi %{resource}",
          "unhappy": "Malfeliĉa?",
          "update": "Ĝisdatigi",
          "we_need_your_current_password_to_confirm_your_changes": "ni bezonas vian nunan pasvorton por konfirmi viajn ŝanĝojn"
        },
        "new": {
          "sign_up": "Registriĝi"
        },
        "signed_up": "Bonvenon! Vi sukcese registriĝis.",
        "signed_up_but_inactive": "Vi sukcese registriĝis. Tamen, ni ne povis ensalutigi vin, ĉar via konto ankoraŭ ne estas konfirmita.",
        "signed_up_but_locked": "Vi sukcese registriĝis. Tamen, ni ne povis ensalutigi vin, ĉar via konto estas ŝlosita.",
        "signed_up_but_unconfirmed": "Mesaĝo kun konfirma ligilo estis sendita al via retpoŝta adreso. Bonvolu alklaki la ligilon por konfirmi vian retadreson.",
        "update_needs_confirmation": "Vi sukcese ĝisdatigis vian konton, sed ni bezonas kontroli vian novan retadreson. Bonvolu kontroli viajn retmesaĝojn kaj sekvi la konfirman ligilon por konfirmi vian novan retadreson. Bonvolu kontroli vian spamujon, se vi ne ricevis ĉi tiun retmesaĝon.",
        "updated": "Via konto estis sukcese ĝisdatigita.",
        "updated_but_not_signed_in": "Via konto estis sukcese ĝisdatigita, sed ĉar via pasvorto estis ŝanĝita, vi devas ensaluti denove."
      },
      "sessions": {
        "already_signed_out": "Sukcese adiaŭis.",
        "new": {
          "sign_in": "Saluti"
        },
        "signed_in": "Sukcese salutis.",
        "signed_out": "Sukcese adiaŭis."
      },
      "shared": {
        "links": {
          "back": "Reveni",
          "didn_t_receive_confirmation_instructions": "Ĉu vi ne ricevis konfirminstrukciojn?",
          "didn_t_receive_unlock_instructions": "Ĉu vi ne ricevis instrukciojn por malŝlosi vian konton?",
          "forgot_your_password": "Ĉu vi forgesis vian pasvorton?",
          "sign_in": "Saluti",
          "sign_in_with_provider": "Saluti per %{provider}",
          "sign_up": "Registriĝi"
        },
        "minimum_password_length": {
          "one": "(minimume %{count} signo)",
          "other": "(minimume %{count} signoj)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Sendi instrukciojn por malŝlosi denove"
        },
        "send_instructions": "Vi ricevos retmesaĝon kun instrukcioj por malŝlosi vian konton ene de kelkaj minutoj. Bonvolu kontroli vian spamujon, se vi ne ricevis ĉi tiun retmesaĝon.",
        "send_paranoid_instructions": "Se via konto ekzistas, vi ricevos retmesaĝon kun instrukcioj por malŝlosi ĝin ene de kelkaj minutoj. Bonvolu kontroli vian spamujon se vi ne ricevis ĉi tiun retmesaĝon.",
        "unlocked": "Via konto estis sukcese malŝlosita. Bonvolu ensaluti por daŭrigi."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "devas esti akceptita",
        "already_confirmed": "jam estis konfirmita, bonvolu provi saluti",
        "blank": "devas esti kompletigita",
        "confirmation": "ne kongruas kun la konfirmo",
        "confirmation_period_expired": "devas esti konfirmita ene de %{period}, bonvolu peti denove",
        "empty": "devas esti kompletigita",
        "equal_to": "devas egali %{count}",
        "even": "devas esti para",
        "exclusion": "ne estas disponebla",
        "expired": "eksvalidiĝis, bonvolu peti denove",
        "greater_than": "devas superi %{count}",
        "greater_than_or_equal_to": "devas superi aŭ egali %{count}",
        "inclusion": "ne estas inkluzivita de la listo",
        "invalid": "estas nevalida",
        "less_than": "devas malsuperi %{count}",
        "less_than_or_equal_to": "devas malsuperi aŭ egali %{count}",
        "not_a_number": "ne estas nombro",
        "not_an_integer": "devas esti entjero",
        "not_found": "ne estis trovita",
        "not_locked": "ne estis ŝlosita",
        "not_saved": {
          "one": "1 eraro malpermesis al ĉi tiu %{resource} esti konservita:",
          "other": "%{count} eraroj malpermesis al ĉi tiu %{resource} esti konservita:"
        },
        "odd": "devas esti nepara",
        "taken": "ne estas disponebla",
        "too_long": "estas tro longa (maksimume %{count} karekteroj)",
        "too_short": "estas tro mallonga (minimume %{count} karakteroj)",
        "wrong_length": "ne estas je ĝusta longo (devas enhavi %{count} karakterojn)"
      },
      "template": {
        "body": "Kontrolu la jenajn kampojn: ",
        "header": {
          "one": "Ne eblas registri tiun %{model}: %{count} eraro",
          "other": "Ne eblas registri tiun %{model}: %{count} eraroj"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Bonvolu elekti"
      },
      "submit": {
        "create": "Krei %{model}",
        "submit": "Registri tiun %{model}",
        "update": "Modifi tiun %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miliardo",
            "million": "miliono",
            "quadrillion": "miliono da miliardoj",
            "thousand": "mil",
            "trillion": "mil miliardoj",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "bitoko",
              "other": "bitokoj"
            },
            "gb": "Gb",
            "kb": "kb",
            "mb": "Mb",
            "tb": "Tb"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " kaj ",
        "two_words_connector": " kaj ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %H:%M:%S",
        "long": "%A %d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "es": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Confirmación enviada a",
          "confirmation_token": "Código de confirmación",
          "confirmed_at": "Confirmado en",
          "created_at": "Creado en",
          "current_password": "Contraseña actual",
          "current_sign_in_at": "Fecha del ingreso actual",
          "current_sign_in_ip": "IP del ingreso actual",
          "email": "Email",
          "encrypted_password": "Contraseña cifrada",
          "failed_attempts": "Intentos fallidos",
          "last_sign_in_at": "Fecha del último ingreso",
          "last_sign_in_ip": "IP del último inicio",
          "locked_at": "Fecha de bloqueo",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "remember_created_at": "Fecha de 'Recordarme'",
          "remember_me": "Recordarme",
          "reset_password_sent_at": "Fecha de envío de código para contraseña",
          "reset_password_token": "Código para restablecer contraseña",
          "sign_in_count": "Cantidad de ingresos",
          "unconfirmed_email": "Email no confirmado",
          "unlock_token": "Código de desbloqueo",
          "updated_at": "Actualizado en"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      },
      "models": {
        "user": {
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%-d/%-m/%Y",
        "long": "%-d de %B de %Y",
        "short": "%-d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "alrededor de %{count} hora",
          "other": "alrededor de %{count} horas"
        },
        "about_x_months": {
          "one": "alrededor de %{count} mes",
          "other": "alrededor de %{count} meses"
        },
        "about_x_years": {
          "one": "alrededor de %{count} año",
          "other": "alrededor de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Tu cuenta ha sido confirmada satisfactoriamente.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        },
        "send_instructions": "Vas a recibir un correo con instrucciones sobre cómo confirmar tu cuenta en unos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, en unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta."
      },
      "failure": {
        "already_authenticated": "Ya has iniciado sesión.",
        "inactive": "Tu cuenta aún no ha sido activada.",
        "invalid": "%{authentication_keys} o contraseña inválidos.",
        "invited": "Tienes una invitación pendiente, acéptala para acabar de crear tu cuenta.",
        "last_attempt": "Tienes un intento más antes de que tu cuenta sea bloqueada.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} o contraseña inválidos.",
        "timeout": "Tu sesión expiró. Por favor, inicia sesión nuevamente para continuar.",
        "unauthenticated": "Tienes que iniciar sesión o registrarte para poder continuar.",
        "unconfirmed": "Tienes que confirmar tu cuenta para poder continuar."
      },
      "invitations": {
        "edit": {
          "header": "Establecer contraseña",
          "submit_button": "Guardar mi contraseña"
        },
        "invitation_removed": "Se ha retirado su invitación",
        "invitation_token_invalid": "¡La invitación no es válida!",
        "new": {
          "header": "Enviar Invitación",
          "submit_button": "Envía una invitación"
        },
        "no_invitations_remaining": "No quedan invitaciones",
        "send_instructions": "Se ha enviado una invitación a %{email}.",
        "updated": "Se ha configurado su contraseña y ha ingresado al sistema",
        "updated_not_active": "Su contraseña se ha configurado correctamente."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "confirm_account_link": "Confirmar cuenta",
          "confirm_link_msg": "Para confirmar su cuenta ingrese en el siguiente link:",
          "greeting": "¡Bienvenido %{recipient}!",
          "instruction": "Usted puede confirmar el correo electrónico de su cuenta a través de este enlace:",
          "subject": "Instrucciones de confirmación"
        },
        "email_changed": {
          "greeting": "¡Hola %{recipient}! ",
          "message": "Estamos contactando contigo para notificarte que tu email ha sido cambiado a %{email}.",
          "message_unconfirmed": "Nos estamos contactando contigo para notificarte que tu correo se está cambiando a %{email}.",
          "subject": "Email cambiado"
        },
        "invitation_instructions": {
          "accept": "Aceptar la invitación",
          "accept_until": "Esta invitación expirará en %{due_date}.",
          "hello": "Hola %{email}",
          "ignore": "Si no le interesa esta invitación, simplemente ignore este correo. No se creará tu cuenta hasta que accedas al enlace anterior y crees una contraseña.",
          "someone_invited_you": "Has sido invitado a %{url}, puedes aceptarlo siguiendo el siguiente enlace",
          "subject": "Instrucciones de la invitación"
        },
        "password_change": {
          "greeting": "¡Hola %{recipient}!",
          "message": "Lo estamos contactando para notificarle que su contraseña ha sido cambiada.",
          "subject": "Contraseña cambiada"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola %{recipient}!",
          "ignore_mail_msg": "Por favor ignore este mensaje si no ha solicitado esta acción.",
          "instruction": "Alguien ha solicitado un enlace para cambiar su contraseña, lo que se puede realizar a través del siguiente enlace.",
          "instruction_2": "Si usted no lo ha solicitado, por favor ignore este correo electrónico.",
          "instruction_3": "Su contraseña no será cambiada hasta que usted acceda al enlace y cree una nueva.",
          "no_changes_msg": "Importante: Su contraseña no será actualizada a menos que ingrese en el link.",
          "password_change_link": "Cambiar contraseña",
          "request_reset_link_msg": "Ha solicitado un cambio de contraseña. Para continuar ingrese en el siguiente link:",
          "subject": "Instrucciones para restablecer su contraseña"
        },
        "unlock_instructions": {
          "account_lock_msg": "Su cuenta ha sido bloqueada debido a sucesivos intentos de ingresos fallidos",
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Haga click en el siguiente enlace para desbloquear su cuenta:",
          "message": "Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos infructuosos para ingresar.",
          "subject": "Instrucciones de desbloqueo",
          "unlock_link": "Desbloquear cuenta",
          "unlock_link_msg": "Para desbloquear su cuenta ingrese en el siguiente link:"
        }
      },
      "omniauth_callbacks": {
        "failure": "No has sido autorizado en la cuenta %{kind} porque \"%{reason}\".",
        "success": "Has sido autorizado satisfactoriamente en la cuenta %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie su contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Nueva contraseña"
        },
        "new": {
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "send_me_reset_password_instructions": "Envíeme las instrucciones para resetear mi contraseña"
        },
        "no_token": "No puedes acceder a esta página si no es a través de un enlace para resetear tu contraseña. Si has llegado hasta aquí desde el email para resetear tu contraseña, por favor asegúrate de que la URL introducida está completa.",
        "send_instructions": "Recibirás un correo con instrucciones sobre cómo resetear tu contraseña en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, recibirás un correo con instrucciones sobre cómo resetear tu contraseña en tu bandeja de entrada.",
        "updated": "Se ha cambiado tu contraseña. Ya iniciaste sesión.",
        "updated_not_active": "Tu contraseña fue cambiada."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada correctamente. Esperamos verte pronto.",
        "edit": {
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Anular mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmacion de: %{email} ",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarla",
          "title": "Editar %{resource}",
          "unhappy": "¿Disconforme?",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos su contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        },
        "signed_up": "Bienvenido. Tu cuenta fue creada.",
        "signed_up_but_inactive": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque tu cuenta aún no está activada.",
        "signed_up_but_locked": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque que tu cuenta está bloqueada.",
        "signed_up_but_unconfirmed": "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Abre el enlace para activar tu cuenta.",
        "update_needs_confirmation": "Has actualizado tu cuenta correctamente, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo y sigue el enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.",
        "updated": "Tu cuenta se ha actualizado.",
        "updated_but_not_signed_in": "Su cuenta se ha actualizado correctamente, pero como se cambió su contraseña, debe iniciar sesión nuevamente"
      },
      "sessions": {
        "already_signed_out": "Sesión finalizada.",
        "new": {
          "sign_in": "Iniciar sesión"
        },
        "signed_in": "Sesión iniciada.",
        "signed_out": "Sesión finalizada."
      },
      "shared": {
        "links": {
          "back": "Atrás",
          "didn_t_receive_confirmation_instructions": "¿No ha recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No ha recibido instrucciones para desbloquear?",
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear"
        },
        "send_instructions": "Vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu cuenta existe, vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Redirección hacia '%{redirect_url}' no esta permitida."
      },
      "passwords": {
        "missing_email": "Debe incluir un correo electrónico.",
        "missing_passwords": "Debe llenar los campos 'Contraseña' y 'Confirmación de contraseña'.",
        "missing_redirect_url": "Falta el Url de redirección.",
        "not_allowed_redirect_url": "Redirección hacia '%{redirect_url}' no esta permitida.",
        "password_not_required": "Esta cuenta no requiere contraseña. Iniciar sesión utilizando '%{provider}'.",
        "sended": "Un correo electrónico ha sido enviado a '%{email}' con las instrucciones para restablecer su contraseña.",
        "successfully_updated": "Su contraseña ha sido actualizada con éxito.",
        "user_not_found": "No se pudo encontrar un usuario con este correo electrónico '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "No se puede encontrar la cuenta a borrar.",
        "account_with_uid_destroyed": "La cuenta con el identificador '%{uid}' se ha eliminado.",
        "email_already_exists": "Una cuenta ya existe con este correo electrónico '%{email}'",
        "missing_confirm_success_url": "El parámetro 'confirm_success_url' no esta presente.",
        "redirect_url_not_allowed": "Redirección hacia '%{redirect_url}' no esta permitida.",
        "user_not_found": "Usuario no encontrado."
      },
      "sessions": {
        "bad_credentials": "Identidad o contraseña no válida.",
        "not_confirmed": "Un correo electrónico de confirmación de su cuenta ha sido enviado a '%{email}'. Por favor, siga las instrucciones para validar su cuenta",
        "not_supported": "Use POST /sign_in para la conexión. GET no esta disponible.",
        "user_not_found": "Usuario desconocido o no está conectado."
      },
      "token_validations": {
        "invalid": "Identidad o contraseña no válida."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "already_confirmed": "ya ha sido confirmado, por favor intenta iniciar sesión",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "confirmation_period_expired": "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser par",
        "exclusion": "está reservado",
        "expired": "ha expirado, por favor solicita una nueva",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "not_email": "no es un correo electrónico",
        "not_found": "no se ha encontrado",
        "not_locked": "no estaba bloqueada",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "debe ser impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya está en uso",
        "too_long": {
          "one": "es demasiado largo (%{count} carácter máximo)",
          "other": "es demasiado largo (%{count} caracteres máximo)"
        },
        "too_short": {
          "one": "es demasiado corto (%{count} carácter mínimo)",
          "other": "es demasiado corto (%{count} caracteres mínimo)"
        },
        "validate_account_update_params": "Los datos introducidos en la solicitud de actualización no son válidos.",
        "validate_sign_up_params": "Los datos introducidos en la solicitud de acceso no son válidos.",
        "wrong_length": {
          "one": "no tiene la longitud correcta (%{count} carácter exactos)",
          "other": "no tiene la longitud correcta (%{count} caracteres exactos)"
        }
      },
      "template": {
        "body": "Se encontraron problemas con los siguientes campos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró %{count} error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          " s/n.",
          ", #",
          ", ##",
          " #",
          " ##"
        ],
        "city": [
          "#{city_prefix}"
        ],
        "city_prefix": [
          "Parla",
          "Telde",
          "Baracaldo",
          "San Fernando",
          "Torrevieja",
          "Lugo",
          "Santiago de Compostela",
          "Gerona",
          "Cáceres",
          "Lorca",
          "Coslada",
          "Talavera de la Reina",
          "El Puerto de Santa María",
          "Cornellá de Llobregat",
          "Avilés",
          "Palencia",
          "Gecho",
          "Orihuela",
          "Pontevedra",
          "Pozuelo de Alarcón",
          "Toledo",
          "El Ejido",
          "Guadalajara",
          "Gandía",
          "Ceuta",
          "Ferrol",
          "Chiclana de la Frontera",
          "Manresa",
          "Roquetas de Mar",
          "Ciudad Real",
          "Rubí",
          "Benidorm",
          "San Sebastían de los Reyes",
          "Ponferrada",
          "Zamora",
          "Alcalá de Guadaira",
          "Fuengirola",
          "Mijas",
          "Sanlúcar de Barrameda",
          "La Línea de la Concepción",
          "Majadahonda",
          "Sagunto",
          "El Prat de LLobregat",
          "Viladecans",
          "Linares",
          "Alcoy",
          "Irún",
          "Estepona",
          "Torremolinos",
          "Rivas-Vaciamadrid",
          "Molina de Segura",
          "Paterna",
          "Granollers",
          "Santa Lucía de Tirajana",
          "Motril",
          "Cerdañola del Vallés",
          "Arrecife",
          "Segovia",
          "Torrelavega",
          "Elda",
          "Mérida",
          "Ávila",
          "Valdemoro",
          "Cuenta",
          "Collado Villalba",
          "Benalmádena",
          "Mollet del Vallés",
          "Puertollano",
          "Madrid",
          "Barcelona",
          "Valencia",
          "Sevilla",
          "Zaragoza",
          "Málaga",
          "Murcia",
          "Palma de Mallorca",
          "Las Palmas de Gran Canaria",
          "Bilbao",
          "Córdoba",
          "Alicante",
          "Valladolid",
          "Vigo",
          "Gijón",
          "Hospitalet de LLobregat",
          "La Coruña",
          "Granada",
          "Vitoria",
          "Elche",
          "Santa Cruz de Tenerife",
          "Oviedo",
          "Badalona",
          "Cartagena",
          "Móstoles",
          "Jerez de la Frontera",
          "Tarrasa",
          "Sabadell",
          "Alcalá de Henares",
          "Pamplona",
          "Fuenlabrada",
          "Almería",
          "San Sebastián",
          "Leganés",
          "Santander",
          "Burgos",
          "Castellón de la Plana",
          "Alcorcón",
          "Albacete",
          "Getafe",
          "Salamanca",
          "Huelva",
          "Logroño",
          "Badajoz",
          "San Cristróbal de la Laguna",
          "León",
          "Tarragona",
          "Cádiz",
          "Lérida",
          "Marbella",
          "Mataró",
          "Dos Hermanas",
          "Santa Coloma de Gramanet",
          "Jaén",
          "Algeciras",
          "Torrejón de Ardoz",
          "Orense",
          "Alcobendas",
          "Reus",
          "Calahorra",
          "Inca"
        ],
        "country": [
          "Afganistán",
          "Albania",
          "Argelia",
          "Andorra",
          "Angola",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbayán",
          "Bahamas",
          "Barein",
          "Bangladesh",
          "Barbados",
          "Bielorusia",
          "Bélgica",
          "Belice",
          "Bermuda",
          "Bután",
          "Bolivia",
          "Bosnia Herzegovina",
          "Botswana",
          "Brasil",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Camboya",
          "Camerún",
          "Canada",
          "Cabo Verde",
          "Islas Caimán",
          "Chad",
          "Chile",
          "China",
          "Isla de Navidad",
          "Colombia",
          "Comodos",
          "Congo",
          "Costa Rica",
          "Costa de Marfil",
          "Croacia",
          "Cuba",
          "Chipre",
          "República Checa",
          "Dinamarca",
          "Dominica",
          "República Dominicana",
          "Ecuador",
          "Egipto",
          "El Salvador",
          "Guinea Ecuatorial",
          "Eritrea",
          "Estonia",
          "Etiopía",
          "Islas Faro",
          "Fiji",
          "Finlandia",
          "Francia",
          "Gabón",
          "Gambia",
          "Georgia",
          "Alemania",
          "Ghana",
          "Grecia",
          "Groenlandia",
          "Granada",
          "Guadalupe",
          "Guam",
          "Guatemala",
          "Guinea",
          "Guinea-Bisau",
          "Guayana",
          "Haiti",
          "Honduras",
          "Hong Kong",
          "Hungria",
          "Islandia",
          "India",
          "Indonesia",
          "Iran",
          "Irak",
          "Irlanda",
          "Italia",
          "Jamaica",
          "Japón",
          "Jordania",
          "Kazajistan",
          "Kenia",
          "Kiribati",
          "Corea",
          "Kuwait",
          "Letonia",
          "Líbano",
          "Liberia",
          "Liechtenstein",
          "Lituania",
          "Luxemburgo",
          "Macao",
          "Macedonia",
          "Madagascar",
          "Malawi",
          "Malasia",
          "Maldivas",
          "Mali",
          "Malta",
          "Martinica",
          "Mauritania",
          "Méjico",
          "Micronesia",
          "Moldavia",
          "Mónaco",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Marruecos",
          "Mozambique",
          "Namibia",
          "Nauru",
          "Nepal",
          "Holanda",
          "Nueva Zelanda",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "Noruega",
          "Omán",
          "Pakistan",
          "Panamá",
          "Papúa Nueva Guinea",
          "Paraguay",
          "Perú",
          "Filipinas",
          "Poland",
          "Portugal",
          "Puerto Rico",
          "Rusia",
          "Ruanda",
          "Samoa",
          "San Marino",
          "Santo Tomé y Principe",
          "Arabia Saudí",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leona",
          "Singapur",
          "Eslovaquia",
          "Eslovenia",
          "Somalia",
          "España",
          "Sri Lanka",
          "Sudán",
          "Suriname",
          "Suecia",
          "Suiza",
          "Siria",
          "Taiwan",
          "Tajikistan",
          "Tanzania",
          "Tailandia",
          "Timor-Leste",
          "Togo",
          "Tonga",
          "Trinidad y Tobago",
          "Tunez",
          "Turquia",
          "Uganda",
          "Ucrania",
          "Emiratos Árabes Unidos",
          "Reino Unido",
          "Estados Unidos de América",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Venezuela",
          "Vietnam",
          "Yemen",
          "Zambia",
          "Zimbabwe"
        ],
        "default_country": [
          "España"
        ],
        "default_country_code": [
          "ES"
        ],
        "postcode": [
          "#####"
        ],
        "province": [
          "Álava",
          "Albacete",
          "Alicante",
          "Almería",
          "Asturias",
          "Ávila",
          "Badajoz",
          "Barcelona",
          "Burgos",
          "Cantabria",
          "Castellón",
          "Ciudad Real",
          "Cuenca",
          "Cáceres",
          "Cádiz",
          "Córdoba",
          "Gerona",
          "Granada",
          "Guadalajara",
          "Guipúzcoa",
          "Huelva",
          "Huesca",
          "Islas Baleares",
          "Jaén",
          "La Coruña",
          "La Rioja",
          "Las Palmas",
          "León",
          "Lugo",
          "lérida",
          "Madrid",
          "Murcia",
          "Málaga",
          "Navarra",
          "Orense",
          "Palencia",
          "Pontevedra",
          "Salamanca",
          "Santa Cruz de Tenerife",
          "Segovia",
          "Sevilla",
          "Soria",
          "Tarragona",
          "Teruel",
          "Toledo",
          "Valencia",
          "Valladolid",
          "Vizcaya",
          "Zamora",
          "Zaragoza"
        ],
        "secondary_address": [
          "Esc. ###",
          "Puerta ###"
        ],
        "state": [
          "Andalucía",
          "Aragón",
          "Principado de Asturias",
          "Baleares",
          "Canarias",
          "Cantabria",
          "Castilla-La Mancha",
          "Castilla y León",
          "Cataluña",
          "Comunidad Valenciana",
          "Extremadura",
          "Galicia",
          "La Rioja",
          "Comunidad de Madrid",
          "Navarra",
          "País Vasco",
          "Región de Murcia"
        ],
        "state_abbr": [
          "And",
          "Ara",
          "Ast",
          "Bal",
          "Can",
          "Cbr",
          "Man",
          "Leo",
          "Cat",
          "Com",
          "Ext",
          "Gal",
          "Rio",
          "Mad",
          "Nav",
          "Vas",
          "Mur"
        ],
        "street_address": [
          "#{street_name}#{building_number}",
          "#{street_name}#{building_number} #{secondary_address}"
        ],
        "street_name": [
          "#{street_suffix} #{Name.first_name}",
          "#{street_suffix} #{Name.first_name} #{Name.last_name}"
        ],
        "street_suffix": [
          "Aldea",
          "Apartamento",
          "Arrabal",
          "Arroyo",
          "Avenida",
          "Bajada",
          "Barranco",
          "Barrio",
          "Bloque",
          "Calle",
          "Calleja",
          "Camino",
          "Carretera",
          "Caserio",
          "Colegio",
          "Colonia",
          "Conjunto",
          "Cuesta",
          "Chalet",
          "Edificio",
          "Entrada",
          "Escalinata",
          "Explanada",
          "Extramuros",
          "Extrarradio",
          "Ferrocarril",
          "Glorieta",
          "Gran Subida",
          "Grupo",
          "Huerta",
          "Jardines",
          "Lado",
          "Lugar",
          "Manzana",
          "Masía",
          "Mercado",
          "Monte",
          "Muelle",
          "Municipio",
          "Parcela",
          "Parque",
          "Partida",
          "Pasaje",
          "Paseo",
          "Plaza",
          "Poblado",
          "Polígono",
          "Prolongación",
          "Puente",
          "Puerta",
          "Quinta",
          "Ramal",
          "Rambla",
          "Rampa",
          "Riera",
          "Rincón",
          "Ronda",
          "Rua",
          "Salida",
          "Sector",
          "Sección",
          "Senda",
          "Solar",
          "Subida",
          "Terrenos",
          "Torrente",
          "Travesía",
          "Urbanización",
          "Vía",
          "Vía Pública"
        ],
        "time_zone": [
          "Pacífico/Midway",
          "Pacífico/Pago_Pago",
          "Pacífico/Honolulu",
          "America/Juneau",
          "America/Los_Angeles",
          "America/Tijuana",
          "America/Denver",
          "America/Phoenix",
          "America/Chihuahua",
          "America/Mazatlan",
          "America/Chicago",
          "America/Regina",
          "America/Mexico_City",
          "America/Mexico_City",
          "America/Monterrey",
          "America/Guatemala",
          "America/New_York",
          "America/Indiana/Indianapolis",
          "America/Bogota",
          "America/Lima",
          "America/Lima",
          "America/Halifax",
          "America/Caracas",
          "America/La_Paz",
          "America/Santiago",
          "America/St_Johns",
          "America/Sao_Paulo",
          "America/Argentina/Buenos_Aires",
          "America/Guyana",
          "America/Godthab",
          "Atlantic/South_Georgia",
          "Atlantic/Azores",
          "Atlantic/Cape_Verde",
          "Europa/Dublin",
          "Europa/London",
          "Europa/Lisbon",
          "Europa/London",
          "Africa/Casablanca",
          "Africa/Monrovia",
          "Etc/UTC",
          "Europa/Belgrade",
          "Europa/Bratislava",
          "Europa/Budapest",
          "Europa/Ljubljana",
          "Europa/Prague",
          "Europa/Sarajevo",
          "Europa/Skopje",
          "Europa/Warsaw",
          "Europa/Zagreb",
          "Europa/Brussels",
          "Europa/Copenhagen",
          "Europa/Madrid",
          "Europa/Paris",
          "Europa/Amsterdam",
          "Europa/Berlin",
          "Europa/Berlin",
          "Europa/Rome",
          "Europa/Stockholm",
          "Europa/Vienna",
          "Africa/Algiers",
          "Europa/Bucharest",
          "Africa/Cairo",
          "Europa/Helsinki",
          "Europa/Kiev",
          "Europa/Riga",
          "Europa/Sofia",
          "Europa/Tallinn",
          "Europa/Vilnius",
          "Europa/Athens",
          "Europa/Istanbul",
          "Europa/Minsk",
          "Asia/Jerusalen",
          "Africa/Harare",
          "Africa/Johannesburg",
          "Europa/Moscú",
          "Europa/Moscú",
          "Europa/Moscú",
          "Asia/Kuwait",
          "Asia/Riyadh",
          "Africa/Nairobi",
          "Asia/Baghdad",
          "Asia/Tehran",
          "Asia/Muscat",
          "Asia/Muscat",
          "Asia/Baku",
          "Asia/Tbilisi",
          "Asia/Yerevan",
          "Asia/Kabul",
          "Asia/Yekaterinburg",
          "Asia/Karachi",
          "Asia/Karachi",
          "Asia/Tashkent",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kathmandu",
          "Asia/Dhaka",
          "Asia/Dhaka",
          "Asia/Colombo",
          "Asia/Almaty",
          "Asia/Novosibirsk",
          "Asia/Rangoon",
          "Asia/Bangkok",
          "Asia/Bangkok",
          "Asia/Jakarta",
          "Asia/Krasnoyarsk",
          "Asia/Shanghai",
          "Asia/Chongqing",
          "Asia/Hong_Kong",
          "Asia/Urumqi",
          "Asia/Kuala_Lumpur",
          "Asia/Singapore",
          "Asia/Taipei",
          "Australia/Perth",
          "Asia/Irkutsk",
          "Asia/Ulaanbaatar",
          "Asia/Seoul",
          "Asia/Tokyo",
          "Asia/Tokyo",
          "Asia/Tokyo",
          "Asia/Yakutsk",
          "Australia/Darwin",
          "Australia/Adelaide",
          "Australia/Melbourne",
          "Australia/Melbourne",
          "Australia/Sydney",
          "Australia/Brisbane",
          "Australia/Hobart",
          "Asia/Vladivostok",
          "Pacífico/Guam",
          "Pacífico/Port_Moresby",
          "Asia/Magadan",
          "Asia/Magadan",
          "Pacífico/Noumea",
          "Pacífico/Fiji",
          "Asia/Kamchatka",
          "Pacífico/Majuro",
          "Pacífico/Auckland",
          "Pacífico/Auckland",
          "Pacífico/Tongatapu",
          "Pacífico/Fakaofo",
          "Pacífico/Apia"
        ]
      },
      "cell_phone": {
        "formats": [
          "6##-###-###",
          "6##.###.###",
          "6## ### ###",
          "6########"
        ]
      },
      "company": {
        "buzzwords": [
          [
            "habilidad",
            "acceso",
            "adaptador",
            "algoritmo",
            "alianza",
            "analista",
            "aplicación",
            "enfoque",
            "arquitectura",
            "archivo",
            "inteligencia artificial",
            "array",
            "actitud",
            "medición",
            "gestión presupuestaria",
            "capacidad",
            "desafío",
            "circuito",
            "colaboración",
            "complejidad",
            "concepto",
            "conglomeración",
            "contingencia",
            "núcleo",
            "fidelidad",
            "base de datos",
            "data-warehouse",
            "definición",
            "emulación",
            "codificar",
            "encriptar",
            "extranet",
            "firmware",
            "flexibilidad",
            "focus group",
            "previsión",
            "base de trabajo",
            "función",
            "funcionalidad",
            "Interfaz Gráfica",
            "groupware",
            "Interfaz gráfico de usuario",
            "hardware",
            "Soporte",
            "jerarquía",
            "conjunto",
            "implementación",
            "infraestructura",
            "iniciativa",
            "instalación",
            "conjunto de instrucciones",
            "interfaz",
            "intranet",
            "base del conocimiento",
            "red de area local",
            "aprovechar",
            "matrices",
            "metodologías",
            "middleware",
            "migración",
            "modelo",
            "moderador",
            "monitorizar",
            "arquitectura abierta",
            "sistema abierto",
            "orquestar",
            "paradigma",
            "paralelismo",
            "política",
            "portal",
            "estructura de precios",
            "proceso de mejora",
            "producto",
            "productividad",
            "proyecto",
            "proyección",
            "protocolo",
            "línea segura",
            "software",
            "solución",
            "estandardización",
            "estrategia",
            "estructura",
            "éxito",
            "superestructura",
            "soporte",
            "sinergia",
            "mediante",
            "marco de tiempo",
            "caja de herramientas",
            "utilización",
            "website",
            "fuerza de trabajo"
          ],
          [
            "24 horas",
            "24/7",
            "3rd generación",
            "4th generación",
            "5th generación",
            "6th generación",
            "analizada",
            "asimétrica",
            "asíncrona",
            "monitorizada por red",
            "bidireccional",
            "bifurcada",
            "generada por el cliente",
            "cliente servidor",
            "coherente",
            "cohesiva",
            "compuesto",
            "sensible al contexto",
            "basado en el contexto",
            "basado en contenido",
            "dedicada",
            "generado por la demanda",
            "didactica",
            "direccional",
            "discreta",
            "dinámica",
            "potenciada",
            "acompasada",
            "ejecutiva",
            "explícita",
            "tolerante a fallos",
            "innovadora",
            "amplio ábanico",
            "global",
            "heurística",
            "alto nivel",
            "holística",
            "homogénea",
            "hibrida",
            "incremental",
            "intangible",
            "interactiva",
            "intermedia",
            "local",
            "logística",
            "maximizada",
            "metódica",
            "misión crítica",
            "móbil",
            "modular",
            "motivadora",
            "multimedia",
            "multiestado",
            "multitarea",
            "nacional",
            "basado en necesidades",
            "neutral",
            "nueva generación",
            "no-volátil",
            "orientado a objetos",
            "óptima",
            "optimizada",
            "radical",
            "tiempo real",
            "recíproca",
            "regional",
            "escalable",
            "secundaria",
            "orientada a soluciones",
            "estable",
            "estatica",
            "sistemática",
            "sistémica",
            "tangible",
            "terciaria",
            "transicional",
            "uniforme",
            "valor añadido",
            "vía web",
            "defectos cero",
            "tolerancia cero"
          ],
          [
            "Adaptativo",
            "Avanzado",
            "Asimilado",
            "Automatizado",
            "Equilibrado",
            "Centrado en el negocio",
            "Centralizado",
            "Clonado",
            "Compatible",
            "Configurable",
            "Multi grupo",
            "Multi plataforma",
            "Centrado en el usuario",
            "Configurable",
            "Descentralizado",
            "Digitalizado",
            "Distribuido",
            "Diverso",
            "Reducido",
            "Mejorado",
            "Para toda la empresa",
            "Ergonomico",
            "Exclusivo",
            "Expandido",
            "Extendido",
            "Cara a cara",
            "Enfocado",
            "Totalmente configurable",
            "Fundamental",
            "Orígenes",
            "Horizontal",
            "Implementado",
            "Innovador",
            "Integrado",
            "Intuitivo",
            "Inverso",
            "Gestionado",
            "Obligatorio",
            "Monitorizado",
            "Multi canal",
            "Multi lateral",
            "Multi capa",
            "En red",
            "Orientado a objetos",
            "Open-source",
            "Operativo",
            "Optimizado",
            "Opcional",
            "Organico",
            "Organizado",
            "Perseverando",
            "Persistente",
            "en fases",
            "Polarizado",
            "Pre-emptivo",
            "Proactivo",
            "Enfocado a benficios",
            "Profundo",
            "Programable",
            "Progresivo",
            "Public-key",
            "Enfocado en la calidad",
            "Reactivo",
            "Realineado",
            "Re-contextualizado",
            "Re-implementado",
            "Reducido",
            "Ingenieria inversa",
            "Robusto",
            "Fácil",
            "Seguro",
            "Auto proporciona",
            "Compartible",
            "Intercambiable",
            "Sincronizado",
            "Orientado a equipos",
            "Total",
            "Universal",
            "Mejorado",
            "Actualizable",
            "Centrado en el usuario",
            "Amigable",
            "Versatil",
            "Virtual",
            "Visionario"
          ]
        ],
        "industry": [
          "Defensa",
          "Equipo de Cómputo",
          "Software",
          "Redes",
          "Internet",
          "Semiconductores",
          "Telecomunicaciones",
          "Despacho de Abogados",
          "Servicos Legales",
          "Consultoría en Administración",
          "Biotecnología",
          "Clínica",
          "Hospitales y Cuidado Médico",
          "Farmacéutica",
          "Veterinaria",
          "Dispositivos Médicos",
          "Cosméticos",
          "Moda",
          "Equipo Deportivo",
          "Tabaco",
          "Supermercados",
          "Elaboración de Comida",
          "Electrodomésticos",
          "Bienes",
          "Muebles",
          "Retail",
          "Entretenimiento",
          "Juegos y Apuestas",
          "Viajes y Turismo",
          "Hospitalidad",
          "Restaurantes",
          "Deportes",
          "Comida y Bebida",
          "Cine",
          "Broadcast Media",
          "Museos e Instituciones",
          "Bellas Artes",
          "Artes Escénicas",
          "Banca",
          "Seguros",
          "Servicios Financieros",
          "Bienes Raíces",
          "Banca de Inversión",
          "Manejo de Inversiones",
          "Contabilidad",
          "Construcción",
          "Materiales de Construcción",
          "Arquitectura",
          "Ingeniería Civil",
          "Aeroespacial",
          "Automotriz",
          "Química",
          "Maquinaria",
          "Minería y Metales",
          "Petróleo y Energía",
          "Construcción de Barcos",
          "Servicios",
          "Textiles",
          "Papel",
          "Ferrocarriles",
          "Agricultura",
          "Ganadería",
          "Lácteos",
          "Pesca",
          "Educación Basica",
          "Educación Media Superior",
          "Administración de Educación",
          "Investigación",
          "Militar",
          "Asamblea Legislativa",
          "Juzgado",
          "Relaciones Internacionales",
          "Gobierno",
          "Dirección General",
          "Policía",
          "Seguridad Pública",
          "Política Pública",
          "Marketing",
          "Periódicos",
          "Publicaciones",
          "Imprenta",
          "Tecnologías de Información",
          "Bibliotecas",
          "Medio Ambiente",
          "Paquetería y Mensajería",
          "Servicios Familiares",
          "Instituciones Religiosas",
          "Sociedad Civil",
          "Servicios del Consumidor",
          "Transportes",
          "Almacenamiento",
          "Líneas Aéreas",
          "Marítimo",
          "Investigación de Mercado",
          "Relaciones Públicas",
          "Diseño",
          "Sin Fines de Lucro",
          "Recaudación",
          "Edición",
          "Staffing y Reclutamiento",
          "Coaching",
          "VC",
          "Partidos Políticos",
          "Traducciones",
          "Juegos de Cómputo",
          "Planeación de Eventos",
          "Artes y Manualidades",
          "Manufactura Eléctrica/Electrónica",
          "Medios Online",
          "Nanotecnología",
          "Música",
          "Logística y Supply Chain",
          "Plásticos",
          "Seguridad de Cómputo y Redes",
          "Inalámbrico",
          "Outsourcing / Offshoring",
          "Bienestar y Salud",
          "Medicina Alternativa",
          "Producción de Medios",
          "Animación",
          "Bienes Raíces Comerciales",
          "Mercados Capitales",
          "Filantropía",
          "E-Learning",
          "Mayoreo",
          "Importaciones y Exportaciones",
          "Ingeniería Mecánica e Industrial",
          "Fotografía",
          "Recursos Humanos",
          "Equipo de Oficina",
          "Cuidado de la Salud Mental",
          "Diseño Gráfico",
          "Desarrollo y Comercio Exterior",
          "Vinos y Licores",
          "Joyería y Bienes de Lujo",
          "Renovables y Medio Ambiente",
          "Vidrios y Cerámicos",
          "Almacenamiento y Contenedores",
          "Automatización Industrial",
          "Relaciones Gubernamentales"
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name} y #{Name.last_name}",
          "#{Name.last_name} #{Name.last_name} #{suffix}",
          "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
        ],
        "profession": [
          "maestro",
          "actor",
          "músico",
          "filósofo",
          "escritor",
          "doctor",
          "contador",
          "agricultor",
          "arquitecto",
          "economista",
          "ingeniero",
          "intérprete",
          "abogado",
          "bibliotecario",
          "actuario",
          "recursos humanos",
          "bombero",
          "juez",
          "policía",
          "astrónomo",
          "biólogo",
          "químico",
          "físico",
          "programador",
          "desarrollador web",
          "diseñador"
        ],
        "suffix": [
          "S.L.",
          "e Hijos",
          "S.A.",
          "Hermanos"
        ],
        "university": {
          "name": [
            "#{Name.last_name} #{University.suffix}",
            "#{University.prefix} #{Name.last_name} #{University.suffix}",
            "#{University.prefix} #{Name.last_name}",
            "#{University.prefix} #{Address.state} #{University.suffix}"
          ],
          "prefix": [
            "El",
            "Septentrional",
            "Norte",
            "Occidental",
            "Oeste",
            "Del Sur",
            "Sur",
            "Oriental",
            "Oriente"
          ],
          "suffix": [
            "Universidad",
            "Instituto",
            "Academia"
          ]
        }
      },
      "internet": {
        "domain_suffix": [
          "com",
          "es",
          "info",
          "com.es",
          "org"
        ]
      },
      "music": {
        "instruments": [
          "Guitarra Eléctrica",
          "Guitarra Acústica",
          "Flauta",
          "Trompeta",
          "Clarinete",
          "Violonchelo",
          "Arpa",
          "Xilofón",
          "Armónica",
          "Acordión",
          "Organo",
          "Piano",
          "Ukelele",
          "Saxofón",
          "Bateria",
          "Violín",
          "Bajo"
        ]
      },
      "name": {
        "female_first_name": [
          "Adela",
          "Adriana",
          "Alejandra",
          "Alicia",
          "Amalia",
          "Ana",
          "Ana Luisa",
          "Ana María",
          "Andrea",
          "Anita",
          "Ángela",
          "Antonia",
          "Ariadna",
          "Barbara",
          "Beatriz",
          "Berta",
          "Blanca",
          "Caridad",
          "Carla",
          "Carlota",
          "Carmen",
          "Carolina",
          "Catalina",
          "Cecilia",
          "Clara",
          "Claudia",
          "Concepción",
          "Conchita",
          "Cristina",
          "Daniela",
          "Débora",
          "Diana",
          "Dolores",
          "Lola",
          "Dorotea",
          "Elena",
          "Elisa",
          "Eloisa",
          "Elsa",
          "Elvira",
          "Emilia",
          "Esperanza",
          "Estela",
          "Ester",
          "Eva",
          "Florencia",
          "Francisca",
          "Gabriela",
          "Gloria",
          "Graciela",
          "Guadalupe",
          "Guillermina",
          "Inés",
          "Irene",
          "Isabel",
          "Isabela",
          "Josefina",
          "Juana",
          "Julia",
          "Laura",
          "Leonor",
          "Leticia",
          "Lilia",
          "Lorena",
          "Lourdes",
          "Lucia",
          "Luisa",
          "Luz",
          "Magdalena",
          "Manuela",
          "Marcela",
          "Margarita",
          "María",
          "María del Carmen",
          "María Cristina",
          "María Elena",
          "María Eugenia",
          "María José",
          "María Luisa",
          "María Soledad",
          "María Teresa",
          "Mariana",
          "Maricarmen",
          "Marilu",
          "Marisol",
          "Marta",
          "Mayte",
          "Mercedes",
          "Micaela",
          "Mónica",
          "Natalia",
          "Norma",
          "Olivia",
          "Patricia",
          "Pilar",
          "Ramona",
          "Raquel",
          "Rebeca",
          "Reina",
          "Rocio",
          "Rosa",
          "Rosalia",
          "Rosario",
          "Sara",
          "Silvia",
          "Sofia",
          "Soledad",
          "Sonia",
          "Susana",
          "Teresa",
          "Verónica",
          "Victoria",
          "Virginia",
          "Yolanda"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Abeyta",
          "Abrego",
          "Abreu",
          "Acevedo",
          "Acosta",
          "Acuña",
          "Adame",
          "Adorno",
          "Agosto",
          "Aguayo",
          "Águilar",
          "Aguilera",
          "Aguirre",
          "Alanis",
          "Alaniz",
          "Alarcón",
          "Alba",
          "Alcala",
          "Alcántar",
          "Alcaraz",
          "Alejandro",
          "Alemán",
          "Alfaro",
          "Alicea",
          "Almanza",
          "Almaraz",
          "Almonte",
          "Alonso",
          "Alonzo",
          "Altamirano",
          "Alva",
          "Alvarado",
          "Alvarez",
          "Amador",
          "Amaya",
          "Anaya",
          "Anguiano",
          "Angulo",
          "Aparicio",
          "Apodaca",
          "Aponte",
          "Aragón",
          "Araña",
          "Aranda",
          "Arce",
          "Archuleta",
          "Arellano",
          "Arenas",
          "Arevalo",
          "Arguello",
          "Arias",
          "Armas",
          "Armendáriz",
          "Armenta",
          "Armijo",
          "Arredondo",
          "Arreola",
          "Arriaga",
          "Arroyo",
          "Arteaga",
          "Atencio",
          "Ávalos",
          "Ávila",
          "Avilés",
          "Ayala",
          "Baca",
          "Badillo",
          "Báez",
          "Baeza",
          "Bahena",
          "Balderas",
          "Ballesteros",
          "Banda",
          "Bañuelos",
          "Barajas",
          "Barela",
          "Barragán",
          "Barraza",
          "Barrera",
          "Barreto",
          "Barrientos",
          "Barrios",
          "Batista",
          "Becerra",
          "Beltrán",
          "Benavides",
          "Benavídez",
          "Benítez",
          "Bermúdez",
          "Bernal",
          "Berríos",
          "Bétancourt",
          "Blanco",
          "Bonilla",
          "Borrego",
          "Botello",
          "Bravo",
          "Briones",
          "Briseño",
          "Brito",
          "Bueno",
          "Burgos",
          "Bustamante",
          "Bustos",
          "Caballero",
          "Cabán",
          "Cabrera",
          "Cadena",
          "Caldera",
          "Calderón",
          "Calvillo",
          "Camacho",
          "Camarillo",
          "Campos",
          "Canales",
          "Candelaria",
          "Cano",
          "Cantú",
          "Caraballo",
          "Carbajal",
          "Cardenas",
          "Cardona",
          "Carmona",
          "Carranza",
          "Carrasco",
          "Carrasquillo",
          "Carreón",
          "Carrera",
          "Carrero",
          "Carrillo",
          "Carrion",
          "Carvajal",
          "Casanova",
          "Casares",
          "Casárez",
          "Casas",
          "Casillas",
          "Castañeda",
          "Castellanos",
          "Castillo",
          "Castro",
          "Cavazos",
          "Cazares",
          "Ceballos",
          "Cedillo",
          "Ceja",
          "Centeno",
          "Cepeda",
          "Cerda",
          "Cervantes",
          "Cervántez",
          "Chacón",
          "Chapa",
          "Chavarría",
          "Chávez",
          "Cintrón",
          "Cisneros",
          "Collado",
          "Collazo",
          "Colón",
          "Colunga",
          "Concepción",
          "Contreras",
          "Cordero",
          "Córdova",
          "Cornejo",
          "Corona",
          "Coronado",
          "Corral",
          "Corrales",
          "Correa",
          "Cortés",
          "Cortez",
          "Cotto",
          "Covarrubias",
          "Crespo",
          "Cruz",
          "Cuellar",
          "Curiel",
          "Dávila",
          "de Anda",
          "de Jesús",
          "Delacrúz",
          "Delafuente",
          "Delagarza",
          "Delao",
          "Delapaz",
          "Delarosa",
          "Delatorre",
          "Deleón",
          "Delgadillo",
          "Delgado",
          "Delrío",
          "Delvalle",
          "Díaz",
          "Domínguez",
          "Domínquez",
          "Duarte",
          "Dueñas",
          "Duran",
          "Echevarría",
          "Elizondo",
          "Enríquez",
          "Escalante",
          "Escamilla",
          "Escobar",
          "Escobedo",
          "Esparza",
          "Espinal",
          "Espino",
          "Espinosa",
          "Espinoza",
          "Esquibel",
          "Esquivel",
          "Estévez",
          "Estrada",
          "Fajardo",
          "Farías",
          "Feliciano",
          "Fernández",
          "Ferrer",
          "Fierro",
          "Figueroa",
          "Flores",
          "Flórez",
          "Fonseca",
          "Franco",
          "Frías",
          "Fuentes",
          "Gaitán",
          "Galarza",
          "Galindo",
          "Gallardo",
          "Gallegos",
          "Galván",
          "Gálvez",
          "Gamboa",
          "Gamez",
          "Gaona",
          "Garay",
          "García",
          "Garibay",
          "Garica",
          "Garrido",
          "Garza",
          "Gastélum",
          "Gaytán",
          "Gil",
          "Girón",
          "Godínez",
          "Godoy",
          "Gómez",
          "Gonzales",
          "González",
          "Gollum",
          "Gracia",
          "Granado",
          "Granados",
          "Griego",
          "Grijalva",
          "Guajardo",
          "Guardado",
          "Guerra",
          "Guerrero",
          "Guevara",
          "Guillen",
          "Gurule",
          "Gutiérrez",
          "Guzmán",
          "Haro",
          "Henríquez",
          "Heredia",
          "Hernández",
          "Hernandes",
          "Hernández",
          "Herrera",
          "Hidalgo",
          "Hinojosa",
          "Holguín",
          "Huerta",
          "Hurtado",
          "Ibarra",
          "Iglesias",
          "Irizarry",
          "Jaime",
          "Jaimes",
          "Jáquez",
          "Jaramillo",
          "Jasso",
          "Jiménez",
          "Jimínez",
          "Juárez",
          "Jurado",
          "Laboy",
          "Lara",
          "Laureano",
          "Leal",
          "Lebrón",
          "Ledesma",
          "Leiva",
          "Lemus",
          "León",
          "Lerma",
          "Leyva",
          "Limón",
          "Linares",
          "Lira",
          "Llamas",
          "Loera",
          "Lomeli",
          "Longoria",
          "López",
          "Lovato",
          "Loya",
          "Lozada",
          "Lozano",
          "Lucero",
          "Lucio",
          "Luevano",
          "Lugo",
          "Luna",
          "Macías",
          "Madera",
          "Madrid",
          "Madrigal",
          "Maestas",
          "Magaña",
          "Malave",
          "Maldonado",
          "Manzanares",
          "Mares",
          "Marín",
          "Márquez",
          "Marrero",
          "Marroquín",
          "Martínez",
          "Mascareñas",
          "Mata",
          "Mateo",
          "Matías",
          "Matos",
          "Maya",
          "Mayorga",
          "Medina",
          "Medrano",
          "Mejía",
          "Meléndez",
          "Melgar",
          "Mena",
          "Menchaca",
          "Méndez",
          "Mendoza",
          "Menéndez",
          "Meraz",
          "Mercado",
          "Merino",
          "Mesa",
          "Meza",
          "Miramontes",
          "Miranda",
          "Mireles",
          "Mojica",
          "Molina",
          "Mondragón",
          "Monroy",
          "Montalvo",
          "Montañez",
          "Montaño",
          "Montemayor",
          "Montenegro",
          "Montero",
          "Montes",
          "Montez",
          "Montoya",
          "Mora",
          "Morales",
          "Moreno",
          "Mota",
          "Moya",
          "Munguía",
          "Muñiz",
          "Muñoz",
          "Murillo",
          "Muro",
          "Nájera",
          "Naranjo",
          "Narváez",
          "Nava",
          "Navarrete",
          "Navarro",
          "Nazario",
          "Negrete",
          "Negrón",
          "Nevárez",
          "Nieto",
          "Nieves",
          "Niño",
          "Noriega",
          "Núñez",
          "Ocampo",
          "Ocasio",
          "Ochoa",
          "Ojeda",
          "Olivares",
          "Olivárez",
          "Olivas",
          "Olivera",
          "Olivo",
          "Olmos",
          "Olvera",
          "Ontiveros",
          "Oquendo",
          "Ordóñez",
          "Orellana",
          "Ornelas",
          "Orosco",
          "Orozco",
          "Orta",
          "Ortega",
          "Ortiz",
          "Osorio",
          "Otero",
          "Ozuna",
          "Pabón",
          "Pacheco",
          "Padilla",
          "Padrón",
          "Páez",
          "Pagan",
          "Palacios",
          "Palomino",
          "Palomo",
          "Pantoja",
          "Paredes",
          "Parra",
          "Partida",
          "Patiño",
          "Paz",
          "Pedraza",
          "Pedroza",
          "Pelayo",
          "Peña",
          "Perales",
          "Peralta",
          "Perea",
          "Peres",
          "Pérez",
          "Pichardo",
          "Piña",
          "Pineda",
          "Pizarro",
          "Polanco",
          "Ponce",
          "Porras",
          "Portillo",
          "Posada",
          "Prado",
          "Preciado",
          "Prieto",
          "Puente",
          "Puga",
          "Pulido",
          "Quesada",
          "Quezada",
          "Quiñones",
          "Quiñónez",
          "Quintana",
          "Quintanilla",
          "Quintero",
          "Quiroz",
          "Rael",
          "Ramírez",
          "Ramón",
          "Ramos",
          "Rangel",
          "Rascón",
          "Raya",
          "Razo",
          "Regalado",
          "Rendón",
          "Rentería",
          "Reséndez",
          "Reyes",
          "Reyna",
          "Reynoso",
          "Rico",
          "Rincón",
          "Riojas",
          "Ríos",
          "Rivas",
          "Rivera",
          "Rivero",
          "Robledo",
          "Robles",
          "Rocha",
          "Rodarte",
          "Rodrígez",
          "Rodríguez",
          "Rodríquez",
          "Rojas",
          "Rojo",
          "Roldán",
          "Rolón",
          "Romero",
          "Romo",
          "Roque",
          "Rosado",
          "Rosales",
          "Rosario",
          "Rosas",
          "Roybal",
          "Rubio",
          "Ruelas",
          "Ruiz",
          "Saavedra",
          "Sáenz",
          "Saiz",
          "Salas",
          "Salazar",
          "Salcedo",
          "Salcido",
          "Saldaña",
          "Saldivar",
          "Salgado",
          "Salinas",
          "Samaniego",
          "Sanabria",
          "Sanches",
          "Sánchez",
          "Sandoval",
          "Santacruz",
          "Santana",
          "Santiago",
          "Santillán",
          "Sarabia",
          "Sauceda",
          "Saucedo",
          "Sedillo",
          "Segovia",
          "Segura",
          "Sepúlveda",
          "Serna",
          "Serrano",
          "Serrato",
          "Sevilla",
          "Sierra",
          "Sisneros",
          "Solano",
          "Solís",
          "Soliz",
          "Solorio",
          "Solorzano",
          "Soria",
          "Sosa",
          "Sotelo",
          "Soto",
          "Suárez",
          "Tafoya",
          "Tamayo",
          "Tamez",
          "Tapia",
          "Tejada",
          "Tejeda",
          "Téllez",
          "Tello",
          "Terán",
          "Terrazas",
          "Tijerina",
          "Tirado",
          "Toledo",
          "Toro",
          "Torres",
          "Tórrez",
          "Tovar",
          "Trejo",
          "Treviño",
          "Trujillo",
          "Ulibarri",
          "Ulloa",
          "Urbina",
          "Ureña",
          "Urías",
          "Uribe",
          "Urrutia",
          "Vaca",
          "Valadez",
          "Valdés",
          "Valdez",
          "Valdivia",
          "Valencia",
          "Valentín",
          "Valenzuela",
          "Valladares",
          "Valle",
          "Vallejo",
          "Valles",
          "Valverde",
          "Vanegas",
          "Varela",
          "Vargas",
          "Vásquez",
          "Vázquez",
          "Vega",
          "Vela",
          "Velasco",
          "Velásquez",
          "Velázquez",
          "Vélez",
          "Véliz",
          "Venegas",
          "Vera",
          "Verdugo",
          "Verduzco",
          "Vergara",
          "Viera",
          "Vigil",
          "Villa",
          "Villagómez",
          "Villalobos",
          "Villalpando",
          "Villanueva",
          "Villareal",
          "Villarreal",
          "Villaseñor",
          "Villegas",
          "Yáñez",
          "Ybarra",
          "Zambrano",
          "Zamora",
          "Zamudio",
          "Zapata",
          "Zaragoza",
          "Zarate",
          "Zavala",
          "Zayas",
          "Zelaya",
          "Zepeda",
          "Zúñiga"
        ],
        "male_first_name": [
          "Adán",
          "Agustín",
          "Alberto",
          "Alejandro",
          "Alfonso",
          "Alfredo",
          "Andrés",
          "Antonio",
          "Armando",
          "Arturo",
          "Benito",
          "Benjamín",
          "Bernardo",
          "Carlos",
          "César",
          "Claudio",
          "Clemente",
          "Cristian",
          "Cristobal",
          "Daniel",
          "David",
          "Diego",
          "Eduardo",
          "Emilio",
          "Enrique",
          "Ernesto",
          "Esteban",
          "Federico",
          "Felipe",
          "Fernando",
          "Francisco",
          "Gabriel",
          "Gerardo",
          "Germán",
          "Gilberto",
          "Gonzalo",
          "Gregorio",
          "Guillermo",
          "Gustavo",
          "Hernán",
          "Homero",
          "Horacio",
          "Hugo",
          "Ignacio",
          "Jacobo",
          "Jaime",
          "Javier",
          "Jerónimo",
          "Jesús",
          "Joaquín",
          "Jorge",
          "Jorge Luis",
          "José",
          "José Eduardo",
          "José Emilio",
          "José Luis",
          "José María",
          "Juan",
          "Juan Carlos",
          "Julio",
          "Julio César",
          "Lorenzo",
          "Lucas",
          "Luis",
          "Luis Miguel",
          "Manuel",
          "Marco Antonio",
          "Marcos",
          "Mariano",
          "Mario",
          "Martín",
          "Mateo",
          "Miguel",
          "Miguel Ángel",
          "Nicolás",
          "Octavio",
          "Óscar",
          "Pablo",
          "Patricio",
          "Pedro",
          "Rafael",
          "Ramiro",
          "Ramón",
          "Raúl",
          "Ricardo",
          "Roberto",
          "Rodrigo",
          "Rubén",
          "Salvador",
          "Samuel",
          "Sancho",
          "Santiago",
          "Sergio",
          "Teodoro",
          "Timoteo",
          "Tomás",
          "Vicente",
          "Víctor"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Sr.",
          "Sra.",
          "Sta."
        ],
        "suffix": [
          "Jr.",
          "Sr.",
          "I",
          "II",
          "III",
          "IV",
          "V",
          "MD",
          "DDS",
          "PhD",
          "DVM"
        ],
        "title": {
          "descriptor": [
            "Jefe",
            "Senior",
            "Directo",
            "Corporativo",
            "Dinánmico",
            "Futuro",
            "Producto",
            "Nacional",
            "Regional",
            "Distrito",
            "Central",
            "Global",
            "Cliente",
            "Inversor",
            "International",
            "Heredado",
            "Adelante",
            "Interno",
            "Humano",
            "Gerente",
            "Director"
          ],
          "job": [
            "Supervisor",
            "Asociado",
            "Ejecutivo",
            "Relacciones",
            "Oficial",
            "Gerente",
            "Ingeniero",
            "Especialista",
            "Director",
            "Coordinador",
            "Administrador",
            "Arquitecto",
            "Analista",
            "Diseñador",
            "Planificador",
            "Técnico",
            "Funcionario",
            "Desarrollador",
            "Productor",
            "Consultor",
            "Asistente",
            "Facilitador",
            "Agente",
            "Representante",
            "Estratega"
          ],
          "level": [
            "Soluciones",
            "Programa",
            "Marca",
            "Seguridada",
            "Investigación",
            "Marketing",
            "Normas",
            "Implementación",
            "Integración",
            "Funcionalidad",
            "Respuesta",
            "Paradigma",
            "Tácticas",
            "Identidad",
            "Mercados",
            "Grupo",
            "División",
            "Aplicaciones",
            "Optimización",
            "Operaciones",
            "Infraestructura",
            "Intranet",
            "Comunicaciones",
            "Web",
            "Calidad",
            "Seguro",
            "Mobilidad",
            "Cuentas",
            "Datos",
            "Creativo",
            "Configuración",
            "Contabilidad",
            "Interacciones",
            "Factores",
            "Usabilidad",
            "Métricas"
          ]
        }
      },
      "phone_number": {
        "formats": [
          "9##-###-###",
          "9##.###.###",
          "9## ### ###",
          "9########"
        ]
      },
      "subscription": {
        "payment_methods": [
          "Tarjeta de credito",
          "Tarjeta de débito",
          "Paypal",
          "Efectivo",
          "Transferencia de dinero",
          "Bitcoins",
          "Cheque",
          "Apple Pay",
          "Google Pay",
          "WeChat Pay",
          "Alipay",
          "Visa Checkout"
        ],
        "payment_terms": [
          "Pago por adelantado",
          "Mensual",
          "Anual",
          "Suscripción completa"
        ],
        "plans": [
          "Prueba gratuita",
          "Basico",
          "Starter",
          "Essential",
          "Estudiante",
          "Bronze\"",
          "Standard",
          "Silver",
          "Gold",
          "Platinum",
          "Profesional",
          "Business",
          "Diamond",
          "Premium"
        ],
        "statuses": [
          "Activo",
          "Parado",
          "Bloqueado",
          "Pendiente"
        ],
        "subscription_terms": [
          "Diaria",
          "Semanal",
          "Mensual",
          "Anual",
          "Bienal",
          "Trienal",
          "Quinquenal",
          "De por vida"
        ]
      },
      "vehicle": {
        "license_plate": "####[B-DF-HJ-NPR-TV-Z]{3}",
        "license_plate_by_state": {
          "A": "A####[A-PS-Z]{1,2}",
          "AB": "AB####[A-PS-Z]{1,2}",
          "AL": "AL####[A-PS-Z]{1,2}",
          "AV": "AV####[A-PS-Z]{1,2}",
          "B": "B####[A-PS-Z]{1,2}",
          "BA": "BA####[A-PS-Z]{1,2}",
          "BI": "BI####[A-PS-Z]{1,2}",
          "BU": "BU####[A-PS-Z]{1,2}",
          "C": "C####[A-PS-Z]{1,2}",
          "CA": "CA####[A-PS-Z]{1,2}",
          "CC": "CC####[A-PS-Z]{1,2}",
          "CE": "CE####[A-PS-Z]{1,2}",
          "CO": "CO####[A-PS-Z]{1,2}",
          "CR": "CR####[A-PS-Z]{1,2}",
          "CS": "CS####[A-PS-Z]{1,2}",
          "CU": "CU####[A-PS-Z]{1,2}",
          "GC": "GC####[A-PS-Z]{1,2}",
          "GI": "GI####[A-PS-Z]{1,2}",
          "GR": "GR####[A-PS-Z]{1,2}",
          "GU": "GU####[A-PS-Z]{1,2}",
          "H": "H####[A-PS-Z]{1,2}",
          "HU": "HU####[A-PS-Z]{1,2}",
          "IB": "IB####[A-PS-Z]{1,2}",
          "J": "J####[A-PS-Z]{1,2}",
          "L": "L####[A-PS-Z]{1,2}",
          "LE": "LE####[A-PS-Z]{1,2}",
          "LO": "LO####[A-PS-Z]{1,2}",
          "LU": "LU####[A-PS-Z]{1,2}",
          "M": "M####[A-PS-Z]{1,2}",
          "MA": "MA####[A-PS-Z]{1,2}",
          "ML": "ML####[A-PS-Z]{1,2}",
          "MU": "MU####[A-PS-Z]{1,2}",
          "NA": "NA####[A-PS-Z]{1,2}",
          "O": "O####[A-PS-Z]{1,2}",
          "OU": "OU####[A-PS-Z]{1,2}",
          "P": "P####[A-PS-Z]{1,2}",
          "PO": "PO####[A-PS-Z]{1,2}",
          "S": "S####[A-PS-Z]{1,2}",
          "SA": "SA####[A-PS-Z]{1,2}",
          "SE": "SE####[A-PS-Z]{1,2}",
          "SG": "SG####[A-PS-Z]{1,2}",
          "SO": "SO####[A-PS-Z]{1,2}",
          "SS": "SS####[A-PS-Z]{1,2}",
          "T": "T####[A-PS-Z]{1,2}",
          "TE": "TE####[A-PS-Z]{1,2}",
          "TF": "TF####[A-PS-Z]{1,2}",
          "TO": "TO####[A-PS-Z]{1,2}",
          "V": "V####[A-PS-Z]{1,2}",
          "VA": "VA####[A-PS-Z]{1,2}",
          "VI": "VI####[A-PS-Z]{1,2}",
          "Z": "Z####[A-PS-Z]{1,2}",
          "ZA": "ZA####[A-PS-Z]{1,2}"
        }
      }
    },
    "hello": "hola",
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "Á": "A",
          "É": "E",
          "Í": "I",
          "Ñ": "N",
          "Ó": "O",
          "Ú": "U",
          "Ü": "U",
          "á": "a",
          "é": "e",
          "í": "i",
          "ñ": "n",
          "ó": "o",
          "ú": "u",
          "ü": "u"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %-d de %B de %Y %H:%M:%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d de %B de %Y, %H:%M"
            }
          }
        },
        "long": "%-d de %B de %Y %H:%M",
        "short": "%-d de %b %H:%M"
      },
      "pm": "pm"
    },
    "welcome": "bienvenido"
  },
  "es-419": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un(a) %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número non",
        "other_than": "debe ser diferente de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido tomado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor selecciona"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "¤"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-AR": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido tomado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "faker": {
      "address": {
        "army_city_prefix": [
          "General",
          "Gral.",
          "Coronel",
          "Cnel.",
          "Capitán",
          "Cap.",
          "Ingeniero",
          "Ing."
        ],
        "building_number": [
          "S/N",
          "##",
          "###",
          "####",
          "#####"
        ],
        "city": [
          "#{city_names}",
          "#{male_city_saint_prefix} #{Name.male_first_name}",
          "#{female_city_saint_prefix} #{Name.female_first_name}",
          "#{city_prefix} #{male_city_saint_prefix} #{Name.male_first_name}",
          "#{city_prefix} #{female_city_saint_prefix} #{Name.female_first_name}",
          "#{male_city_saint_prefix} #{Name.male_first_name} #{city_suffix}",
          "#{female_city_saint_prefix} #{Name.female_first_name} #{city_suffix}",
          "#{army_city_prefix} #{Name.last_name}",
          "#{army_city_prefix} #{Name.last_name}",
          "#{city_prefix} #{army_city_prefix} #{Name.last_name}"
        ],
        "city_names": [
          "25 de Mayo",
          "9 de Julio",
          "Abra Pampa",
          "Adolfo Gonzales Chaves",
          "Aguilares",
          "Aimogasta",
          "Alba Posse",
          "Alberti",
          "Alderetes",
          "Algarrobo del Águila",
          "Almirante Brown",
          "Alta Gracia",
          "Alto Río Senguer",
          "Alto Verde",
          "Aluminé",
          "Alvear",
          "América",
          "Aminga",
          "Ancasti",
          "Andacollo",
          "Andalgalá",
          "Antofagasta de la Sierra",
          "Añatuya",
          "Añelo",
          "Apóstoles",
          "Arelauquen",
          "Árraga",
          "Arrecifes",
          "Avellaneda",
          "Ayacucho",
          "Azul",
          "Bahía Blanca",
          "Balcarce",
          "Banda del Río Salí",
          "Bandera",
          "Bañado de Ovanta",
          "Baradero",
          "Barra Concepción",
          "Belén",
          "Bell Ville",
          "Bella Vista",
          "Benito Juárez",
          "Berazategui",
          "Berisso",
          "Bernardo de Irigoyen",
          "Bernasconi",
          "Berón de Astrada",
          "Bragado",
          "Brea Pozo",
          "Buena Esperanza",
          "Buta Ranquil",
          "Cachi",
          "Cafayate",
          "Camarones",
          "Campana",
          "Campo Afuera",
          "Campo de Herrera",
          "Campo Gallo",
          "Campo Grande",
          "Campo Largo",
          "Cañada de Gómez",
          "Cañuelas",
          "Capilla de los Remedios",
          "Capilla del Señor",
          "Capitán General Bernardo O'Higgins",
          "Capitán Sarmiento",
          "Carhué",
          "Carlos Casares",
          "Carlos Tejedor",
          "Carmen de Areco",
          "Carmen de Patagones",
          "Casilda",
          "Castelli",
          "Catriló",
          "Caucete",
          "Cerrillos",
          "Chacabuco",
          "Chamical",
          "Charadai",
          "Charata",
          "Chascomús",
          "Chepes",
          "Chicoana",
          "Chilecito",
          "Chimbas",
          "Chivilcoy",
          "Choele Choel",
          "Chos Malal",
          "Ciudad Autónoma de Buenos Aires",
          "Clorinda",
          "Colón",
          "Colonia Campo Villafañe",
          "Colonia Carlos Pellegrini",
          "Colonia Elisa",
          "Colonia Suiza",
          "Comandante Fontana",
          "Comodoro Rivadavia",
          "Concarán",
          "Concepción",
          "Concepción de la Sierra",
          "Concepción del Uruguay",
          "Concordia",
          "Córdoba",
          "Coronda",
          "Coronel Brandsen",
          "Coronel Dorrego",
          "Coronel Pringles",
          "Coronel Suárez",
          "Coronel Vidal",
          "Corrientes",
          "Corzuela",
          "Cosquín",
          "Cruz del Eje",
          "Cuchillo Co",
          "Curuzú Cuatiá",
          "Daireaux",
          "Deán Funes",
          "Diagonal Norte",
          "Diamante",
          "Dique Florentino Ameghino",
          "Doctor Oscar Atilio Viglione",
          "Dolores",
          "Eduardo Castex",
          "El Alto",
          "El Calafate",
          "El Carmen",
          "El Colmenar",
          "El Cuy",
          "El Durazno",
          "El Espinillo",
          "El Huecú",
          "El Naranjo",
          "El Pantanillo",
          "El Soberbio",
          "Eldorado",
          "Empalme Villa Constitución",
          "Empedrado",
          "Ensenada",
          "Escobar",
          "Esperanza",
          "Esquel",
          "Esquina",
          "Esquina del Alambre",
          "Estación Aráoz",
          "Esteban Echeverría",
          "Ezeiza",
          "Famaillá",
          "Famatina",
          "Federación",
          "Federal",
          "Fernández",
          "Florencio Varela",
          "Florentino Ameghino",
          "Formosa",
          "Frías",
          "Gaiman",
          "Garza",
          "Gastre",
          "General Acha",
          "General Alvear",
          "General Arenales",
          "General Belgrano",
          "General Conesa",
          "General Güemes",
          "General Guido",
          "General José de San Martín",
          "General Juan Madariaga",
          "General La Madrid",
          "General Las Heras",
          "General Lavalle",
          "General Lucio V. Mansilla",
          "General Mosconi",
          "General Pico",
          "General Pinedo",
          "General Pinto",
          "General Roca",
          "General Rodríguez",
          "General San Martín",
          "General Villegas",
          "Gobernador Gregores",
          "Gobernador Igr. Valentín Virasoro",
          "Godoy Cruz",
          "Goya",
          "Graneros",
          "Gregoria Pérez de Denis",
          "Guachipas",
          "Gualeguay",
          "Gualeguaychú",
          "Guaminí",
          "Guatraché",
          "Guaymallén",
          "Helvecia",
          "Henderson",
          "Hermoso Campo",
          "Herrera",
          "Huillapima",
          "Humahuaca",
          "Hurlingham",
          "Iltico",
          "Ingeniero Guillermo N. Juárez",
          "Ingenio Fronterita",
          "Ingenio San Pablo",
          "Intendente Alvear",
          "Iruya",
          "Itatí",
          "Ituzaingó",
          "Jacipunco",
          "Jesús María",
          "Joaquín V. González",
          "José C. Paz",
          "José de San Martín",
          "Juan Bautista Alberdi",
          "Juan José Castelli",
          "Junín",
          "Junín de los Andes",
          "La Adela",
          "La Banda",
          "La Caldera",
          "La Candelaria",
          "La Cañada",
          "La Carlota",
          "La Carolina",
          "La Cocha",
          "La Cruz",
          "La Leonesa",
          "La Matanza",
          "La Merced",
          "La Paz",
          "La Plata",
          "La Poma",
          "La Puerta",
          "La Quiaca",
          "La Rinconada",
          "La Rioja",
          "La Toma",
          "La Viña",
          "Laboulaye",
          "Laguna Escondida",
          "Laguna Yema",
          "Lanús",
          "Laprida",
          "Las Breñas",
          "Las Coloradas",
          "Las Flores",
          "Las Heras",
          "Las Jarillas",
          "Las Lajas",
          "Las Plumas",
          "Las Rosas",
          "Leandro N. Alem",
          "Leleque",
          "Libertador General San Martín",
          "Limay Mahuida",
          "Lincoln",
          "Lobería",
          "Lobos",
          "Lomas de Zamora",
          "Loncopué",
          "Los Chañaritos",
          "Los Pocitos",
          "Los Sarmientos",
          "Los Telares",
          "Los Toldos",
          "Los Zapallos",
          "Luján",
          "Luján de Cuyo",
          "Lules",
          "Luz y Fuerza",
          "Macachín",
          "Machagai",
          "Magdalena",
          "Maipú",
          "Makallé",
          "Malanzán",
          "Malargüe",
          "Malvinas Argentinas",
          "Manuel García Fernández",
          "Maquinchao",
          "Mar del Plata",
          "Mar del Tuyú",
          "Marcos Juárez",
          "Marcos Paz",
          "Margarita Belén",
          "Mburucuyá",
          "Médanos",
          "Melincué",
          "Mendoza",
          "Mercedes",
          "Merlo",
          "Miramar",
          "Molinos",
          "Monte Caseros",
          "Monte Hermoso",
          "Monte Quemado",
          "Montecarlo",
          "Monteros",
          "Moreno",
          "Morón",
          "Navarro",
          "Necochea",
          "Neuquén",
          "Nogoyá",
          "Nuestra Señora del Rosario de Caá Catí",
          "Nueva Esperanza",
          "Nueva Trinidad",
          "Ñorquincó",
          "Oberá",
          "Olavarría",
          "Oliva",
          "Olivares de San Nicolás",
          "Olta",
          "Pacará",
          "Palpalá",
          "Pampa del Infierno",
          "Paraná",
          "Parera",
          "Paso de Indios",
          "Paso de los Libres",
          "Patquía",
          "Paulina",
          "Pehuajó",
          "Pellegrini",
          "Pergamino",
          "Perito Moreno",
          "Picún Leufú",
          "Piedra del Águila",
          "Pigüé",
          "Pila",
          "Pilar",
          "Pilcaniyeu",
          "Pinamar",
          "Pirané",
          "Posadas",
          "Pozo Hondo",
          "Presidencia de la Plaza",
          "Presidencia Roque Sáenz Peña",
          "Presidente Perón",
          "Puán",
          "Pueblo Independencia",
          "Puelches",
          "Puerta de Corral Quemado",
          "Puerto Deseado",
          "Puerto Esperanza",
          "Puerto Madryn",
          "Puerto Rico",
          "Puerto San Julián",
          "Puerto Santa Cruz",
          "Puerto Tirol",
          "Punta Alta",
          "Quemú Quemú",
          "Quequén",
          "Quilmes",
          "Quimili",
          "Quitilipi",
          "Rafaela",
          "Ramallo",
          "Ranchillos",
          "Ranchos",
          "Rauch",
          "Rawson",
          "Realicó",
          "Reconquista",
          "Resistencia",
          "Rinconada",
          "Río Colorado",
          "Río Cuarto",
          "Río Gallegos",
          "Río Grande",
          "Rivadavia",
          "Rodeo",
          "Rojas",
          "Roque Pérez",
          "Rosario",
          "Rosario de la Frontera",
          "Rosario de Lerma",
          "Rosario del Tala",
          "Saladas",
          "Saladillo",
          "Salinas Grandes",
          "Salliqueló",
          "Salsacate",
          "Salta",
          "Salto",
          "San Agustín",
          "San Andrés de Giles",
          "San Antonio",
          "San Antonio de Areco",
          "San Antonio de Arredondo",
          "San Antonio de los Cobres",
          "San Antonio de Obligado",
          "San Antonio Oeste",
          "San Bernardo",
          "San Blas",
          "San Carlos",
          "San Carlos de Bariloche",
          "San Carlos de Bolívar",
          "San Carlos Minas",
          "San Cayetano",
          "San Cosme",
          "San Cristóbal",
          "San Fernando",
          "San Fernando del Valle de Catamarca",
          "San Francisco",
          "San Francisco de Laishi",
          "San Francisco de Santa Fe",
          "San Francisco del Chañar",
          "San Francisco del Monte de Oro",
          "San Ignacio",
          "San Isidro",
          "San Javier",
          "San José",
          "San José de Feliciano",
          "San José de Jáchal",
          "San José de las Salinas",
          "San José de Metán",
          "San Juan",
          "San Justo",
          "San Lorenzo",
          "San Luis",
          "San Luis del Palmar",
          "San Martín",
          "San Martín de los Andes",
          "San Miguel",
          "San Miguel de Tucumán",
          "San Miguel del Monte",
          "San Nicolás de los Arroyos",
          "San Patricio del Chañar",
          "San Pedro",
          "San Rafael",
          "San Ramón de la Nueva Orán",
          "San Roque",
          "San Salvador",
          "San Salvador de Jujuy",
          "San Vicente",
          "Santa Ana",
          "Santa Catalina",
          "Santa Clara",
          "Santa Clara de Buena Vista",
          "Santa Fe",
          "Santa Isabel",
          "Santa Lucía",
          "Santa María",
          "Santa Rita de Catuna",
          "Santa Rosa",
          "Santa Rosa de Calamuchita",
          "Santa Rosa de Calchines",
          "Santa Rosa de Leales",
          "Santa Rosa de los Pastos Grandes",
          "Santa Rosa de Río Primero",
          "Santa Rosa del Conlara",
          "Santa Sylvina",
          "Santa Teresita",
          "Santa Victoria",
          "Santiago del Estero",
          "Santo Tomé",
          "Sarmiento",
          "Sastre",
          "Saturnino María Laspiur",
          "Sauce",
          "Saujil",
          "Selva",
          "Sierra Colorada",
          "Simoca",
          "Solar de los Molinos",
          "Suipacha",
          "Sumampa",
          "Suncho Corral",
          "Susques",
          "Tafí del Valle",
          "Tafí Viejo",
          "Tama",
          "Tamberías",
          "Tandil",
          "Tapalqué",
          "Tartagal",
          "Tecka",
          "Telsen",
          "Termas de Río Hondo",
          "Tigre",
          "Tilcara",
          "Tinogasta",
          "Toay",
          "Tolhuin",
          "Tornquist",
          "Tostado",
          "Trenel",
          "Trenque Lauquen",
          "Tres Arroyos",
          "Tres de Febrero",
          "Tres Isletas",
          "Tres Lomas",
          "Tumbaya",
          "Tunuyán",
          "Tupungato",
          "Ulapes",
          "Ushuaia",
          "Valcheta",
          "Valle Grande",
          "Varvarco",
          "Vedia",
          "Vera",
          "Verónica",
          "Vicente López",
          "Victoria",
          "Victorica",
          "Viedma",
          "Villa Aberastain",
          "Villa Angela",
          "Villa Atamisqui",
          "Villa Basilio Nievas",
          "Villa Benjamín Aráoz",
          "Villa Berthet",
          "Villa Burruyacú",
          "Villa Castelli",
          "Villa Catedral",
          "Villa Ciudad de América",
          "Villa Ciudad Parque Los Reartes",
          "Villa Concepción del Tío",
          "Villa Constitución",
          "Villa Cura Brochero",
          "Villa de María",
          "Villa de Trancas",
          "Villa del Rosario",
          "Villa del Totoral",
          "Villa Dolores",
          "Villa El Salvador",
          "Villa General Mitre",
          "Villa General Roca",
          "Villa General San Martín",
          "Villa Gesell",
          "Villa Gobernador Gálvez",
          "Villa Huidobro",
          "Villa Ibáñez",
          "Villa La Angostura",
          "Villa Lago Azul",
          "Villa Las Flores",
          "Villa Los Coihues",
          "Villa María",
          "Villa Mariano Moreno",
          "Villa Media Agua",
          "Villa Mercedes",
          "Villa Nueva Italia",
          "Villa Ojo de Agua",
          "Villa Paranacito",
          "Villa San Agustín",
          "Villa San José de Vinchina",
          "Villa San Martín",
          "Villa San Martín (Est. Loreto)",
          "Villa Sanagasta",
          "Villa Santa Cruz del Lago",
          "Villa Santa Rosa",
          "Villa Sarmiento",
          "Villa Sefair",
          "Villa Tulumaya",
          "Villa Tulumba",
          "Villa Unión",
          "Villaguay",
          "Yerba Buena",
          "Zapala",
          "Zárate"
        ],
        "city_prefix": [
          "Villa",
          "Campo",
          "Pampa de",
          "Colonia"
        ],
        "city_suffix": [
          "de la Sierra",
          "del Mar",
          "del Río Grande",
          "del Chañar",
          "del Palmar",
          "de los Andes",
          "del Valle",
          "de las Salinas"
        ],
        "city_with_state": [
          "#{city}, #{state}",
          "#{city}, #{state_abbr}",
          "#{city} (#{state})",
          "#{city} (#{state_abbr})"
        ],
        "country": [
          "Afganistán",
          "Albania",
          "Argelia",
          "Samoa Americana",
          "Andorra",
          "Angola",
          "Anguila",
          "Antárctida",
          "Antigua y Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Islas Aland",
          "Azerbaiyán",
          "Bahamas",
          "Baréin",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Bélgica",
          "Belice",
          "Benín",
          "Bermuda",
          "Bután",
          "Bolivia",
          "Bonaire",
          "Bosnia y Herzegovina",
          "Botswana",
          "Isla Bouvet",
          "Brasil",
          "Territorio Británico del Océano Índico",
          "Brunei",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Camboya",
          "Camerún",
          "Canadá",
          "Cabo Verde",
          "Islas Caimán",
          "República Centroafricana",
          "Chad",
          "Chile",
          "China",
          "Isla de Navidad",
          "Islas Cocos",
          "Colombia",
          "Comoras",
          "Congo",
          "República Democrática del Congo",
          "Islas Cook",
          "Costa Rica",
          "Costa de Marfil",
          "Croacia",
          "Cuba",
          "Curazao",
          "Chipre",
          "República Checa",
          "Dinamarca",
          "Yibuti",
          "Dominica",
          "República Dominicana",
          "Timor Occidental",
          "Ecuador",
          "Egipto",
          "El Salvador",
          "Guinea Ecuatorial",
          "Eritrea",
          "Estonia",
          "Etiopía",
          "Islas Malvinas",
          "Islas Faroe",
          "Fiji",
          "Finlandia",
          "Francia",
          "Guayana Francesa",
          "Polinesia Francesa",
          "Tierras Australes y Antárticas Francesas",
          "Gabón",
          "Gambia",
          "Georgia",
          "Alemania",
          "Ghana",
          "Gibraltar",
          "Grecia",
          "Groenlandia",
          "Granada",
          "Guadalupe",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinea Bissau",
          "Guyana",
          "Haití",
          "Islas Heard y Mcdonald",
          "Ciudad del Vaticano",
          "Honduras",
          "Hong Kong",
          "Hungría",
          "Islandia",
          "India",
          "Indonesia",
          "Irán",
          "Irak",
          "Irlanda",
          "Isla de Man",
          "Israel",
          "Italia",
          "Jamaica",
          "Japón",
          "Jersey",
          "Jordania",
          "Kazajistán",
          "Kenia",
          "Kiribati",
          "Corea del Norte",
          "Corea del Sur",
          "Kosovo",
          "Kuwait",
          "Kirguistán",
          "Laos",
          "Letonia",
          "Líbano",
          "Lesoto",
          "Liberia",
          "Libia",
          "Liechtenstein",
          "Lituania",
          "Luxemburgo",
          "Macao",
          "Macedonia del Norte",
          "Madagascar",
          "Malawi",
          "Malasia",
          "Maldivas",
          "Mali",
          "Malta",
          "Islas Marshall",
          "Martinica",
          "Mauritania",
          "Mauricio",
          "Mayotte",
          "México",
          "Estados Federados de Micronesia",
          "Moldavia",
          "Mónaco",
          "Mongolia",
          "Montserrat",
          "Montenegro",
          "Marruecos",
          "Mozambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Holanda",
          "Antillas Holandesas",
          "Nueva Caledonia",
          "Nueva Zelanda",
          "Nicaragua",
          "Níger",
          "Nigeria",
          "Niue",
          "Isla Norfolk",
          "Islas Marianas del Norte",
          "Noruega",
          "Omán",
          "Pakistpan",
          "Palau",
          "Palestina",
          "Panamá",
          "Papua Nueva Guinea",
          "Paraguay",
          "Perú",
          "Filipinas",
          "Pitcairn",
          "Polonia",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Reunión",
          "Rumania",
          "Rusia",
          "Ruanda",
          "San Bartolomé",
          "Santa Elena",
          "San Cristóbal y Nieves",
          "Santa Lucia",
          "San Martín",
          "San Pedro y Miquelón",
          "San Vincente y las Grenadinas",
          "Samoa",
          "San Marino",
          "Santo Tomé y Principe",
          "Arabia Saudita",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leona",
          "Singapur",
          "San Martín",
          "Eslovaquia",
          "Eslovenia",
          "Islas Salomón",
          "Somalia",
          "Sudáfrica",
          "Islas Georgia y Sandwich del Sur",
          "Sudán del Sur",
          "España",
          "Sri Lanka",
          "Sudán",
          "Surinam",
          "Svalbard y Jan Mayen",
          "Swazilandia",
          "Suecia",
          "Suiza",
          "Siria",
          "Taiwan",
          "Tajikistán",
          "Tanzania",
          "Tailandia",
          "Timor Oriental",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad y Tobago",
          "Túnez",
          "Turquía",
          "Turkmenistán",
          "Islas Turcas y Caicos",
          "Tuvalu",
          "Uganda",
          "Ucrania",
          "Emiratos Árabes Unidos",
          "Reino Unido",
          "Estados Unidos",
          "Islas Ultramarinas Menores de Estados Unidos",
          "Uruguay",
          "Uzbekistán",
          "Vanuatu",
          "Venezuela",
          "Vietnam",
          "Islas Vírgenes Británicas",
          "Islas Vírgenes Americanas",
          "Wallis y Futuna",
          "Sahara Occidental",
          "Yemen",
          "Zambia",
          "Zimbabwe"
        ],
        "country_by_code": {
          "AD": "Andorra",
          "AE": "Emiratos Árabes Unidos",
          "AF": "Afganistán",
          "AG": "Antigua y Barbuda",
          "AI": "Anguila",
          "AL": "Albania",
          "AM": "Armenia",
          "AN": "Antillas Holandesas",
          "AO": "Angola",
          "AQ": "Antárctida",
          "AR": "Argentina",
          "AS": "Samoa Americana",
          "AT": "Austria",
          "AU": "Australia",
          "AW": "Aruba",
          "AX": "Islas Aland",
          "AZ": "Azerbaiyán",
          "BA": "Bosnia y Herzegovina",
          "BB": "Barbados",
          "BD": "Bangladesh",
          "BE": "Bélgica",
          "BF": "Burkina Faso",
          "BG": "Bulgaria",
          "BH": "Baréin",
          "BI": "Burundi",
          "BJ": "Benín",
          "BL": "San Bartolomé",
          "BM": "Bermuda",
          "BN": "Brunei",
          "BO": "Bolivia",
          "BQ": "Bonaire",
          "BR": "Brasil",
          "BS": "Bahamas",
          "BT": "Bután",
          "BV": "Isla Bouvet",
          "BW": "Botswana",
          "BY": "Belarus",
          "BZ": "Belice",
          "CA": "Canadá",
          "CC": "Islas Cocos",
          "CD": "República Democrática del Congo",
          "CF": "República Centroafricana",
          "CG": "Congo",
          "CH": "Suiza",
          "CI": "Costa de Marfil",
          "CK": "Islas Cook",
          "CL": "Chile",
          "CM": "Camerún",
          "CN": "China",
          "CO": "Colombia",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Cabo Verde",
          "CW": "Curazao",
          "CX": "Isla de Navidad",
          "CY": "Chipre",
          "CZ": "República Checa",
          "DE": "Alemania",
          "DJ": "Yibuti",
          "DK": "Dinamarca",
          "DM": "Dominica",
          "DO": "República Dominicana",
          "DZ": "Argelia",
          "EC": "Ecuador",
          "EE": "Estonia",
          "EG": "Egipto",
          "EH": "Sahara Occidental",
          "ER": "Eritrea",
          "ES": "España",
          "ET": "Etiopía",
          "FI": "Finlandia",
          "FJ": "Fiji",
          "FK": "Islas Malvinas",
          "FM": "Estados Federados de Micronesia",
          "FO": "Islas Faroe",
          "FR": "Francia",
          "GA": "Gabón",
          "GB": "Reino Unido",
          "GD": "Granada",
          "GE": "Georgia",
          "GF": "Guayana Francesa",
          "GG": "Guernsey",
          "GH": "Ghana",
          "GI": "Gibraltar",
          "GL": "Groenlandia",
          "GM": "Gambia",
          "GN": "Guinea",
          "GP": "Guadalupe",
          "GQ": "Guinea Ecuatorial",
          "GR": "Grecia",
          "GS": "Islas Georgia y Sandwich del Sur",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guinea Bissau",
          "GY": "Guyana",
          "HK": "Hong Kong",
          "HM": "Islas Heard y Mcdonald",
          "HN": "Honduras",
          "HR": "Croacia",
          "HT": "Haití",
          "HU": "Hungría",
          "ID": "Indonesia",
          "IE": "Irlanda",
          "IL": "Israel",
          "IM": "Isla de Man",
          "IN": "India",
          "IO": "Territorio Británico del Océano Índico",
          "IQ": "Irak",
          "IR": "Irán",
          "IS": "Islandia",
          "IT": "Italia",
          "JE": "Jersey",
          "JM": "Jamaica",
          "JO": "Jordania",
          "JP": "Japón",
          "KE": "Kenia",
          "KG": "Kirguistán",
          "KH": "Camboya",
          "KI": "Kiribati",
          "KM": "Comoras",
          "KN": "San Cristóbal y Nieves",
          "KP": "Corea del Norte",
          "KR": "Corea del Sur",
          "KV": "Kosovo",
          "KW": "Kuwait",
          "KY": "Islas Caimán",
          "KZ": "Kazajistán",
          "LA": "Laos",
          "LB": "Líbano",
          "LC": "Santa Lucia",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Liberia",
          "LS": "Lesoto",
          "LT": "Lituania",
          "LU": "Luxemburgo",
          "LV": "Letonia",
          "LY": "Libia",
          "MA": "Marruecos",
          "MC": "Mónaco",
          "MD": "Moldavia",
          "ME": "Montenegro",
          "MF": "San Martín",
          "MG": "Madagascar",
          "MH": "Islas Marshall",
          "MK": "Macedonia del Norte",
          "ML": "Mali",
          "MM": "Myanmar",
          "MN": "Mongolia",
          "MO": "Macao",
          "MP": "Islas Marianas del Norte",
          "MQ": "Martinica",
          "MR": "Mauritania",
          "MS": "Montserrat",
          "MT": "Malta",
          "MU": "Mauricio",
          "MV": "Maldivas",
          "MW": "Malawi",
          "MX": "México",
          "MY": "Malasia",
          "MZ": "Mozambique",
          "NA": "Namibia",
          "NC": "Nueva Caledonia",
          "NE": "Níger",
          "NF": "Isla Norfolk",
          "NG": "Nigeria",
          "NI": "Nicaragua",
          "NL": "Holanda",
          "NO": "Noruega",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "Nueva Zelanda",
          "OM": "Omán",
          "PA": "Panamá",
          "PE": "Perú",
          "PF": "Polinesia Francesa",
          "PG": "Papua Nueva Guinea",
          "PH": "Filipinas",
          "PK": "Pakistpan",
          "PL": "Polonia",
          "PM": "San Pedro y Miquelón",
          "PN": "Pitcairn",
          "PR": "Puerto Rico",
          "PS": "Palestina",
          "PT": "Portugal",
          "PW": "Palau",
          "PY": "Paraguay",
          "QA": "Qatar",
          "RE": "Reunión",
          "RO": "Rumania",
          "RS": "Serbia",
          "RU": "Rusia",
          "RW": "Ruanda",
          "SA": "Arabia Saudita",
          "SB": "Islas Salomón",
          "SC": "Seychelles",
          "SD": "Sudán",
          "SE": "Suecia",
          "SG": "Singapur",
          "SH": "Santa Elena",
          "SI": "Eslovenia",
          "SJ": "Svalbard y Jan Mayen",
          "SK": "Eslovaquia",
          "SL": "Sierra Leona",
          "SM": "San Marino",
          "SN": "Senegal",
          "SO": "Somalia",
          "SR": "Surinam",
          "SS": "Sudán del Sur",
          "ST": "Santo Tomé y Principe",
          "SV": "El Salvador",
          "SX": "San Martín",
          "SY": "Siria",
          "SZ": "Swazilandia",
          "TC": "Islas Turcas y Caicos",
          "TD": "Chad",
          "TF": "Tierras Australes y Antárticas Francesas",
          "TG": "Togo",
          "TH": "Tailandia",
          "TJ": "Tajikistán",
          "TK": "Tokelau",
          "TL": "Timor Oriental",
          "TM": "Turkmenistán",
          "TN": "Túnez",
          "TO": "Tonga",
          "TP": "Timor Occidental",
          "TR": "Turquía",
          "TT": "Trinidad y Tobago",
          "TV": "Tuvalu",
          "TW": "Taiwan",
          "TZ": "Tanzania",
          "UA": "Ucrania",
          "UG": "Uganda",
          "UM": "Islas Ultramarinas Menores de Estados Unidos",
          "US": "Estados Unidos",
          "UY": "Uruguay",
          "UZ": "Uzbekistán",
          "VA": "Ciudad del Vaticano",
          "VC": "San Vincente y las Grenadinas",
          "VE": "Venezuela",
          "VG": "Islas Vírgenes Británicas",
          "VI": "Islas Vírgenes Americanas",
          "VN": "Vietnam",
          "VU": "Vanuatu",
          "WF": "Wallis y Futuna",
          "WS": "Samoa",
          "YE": "Yemen",
          "YT": "Mayotte",
          "ZA": "Sudáfrica",
          "ZM": "Zambia",
          "ZW": "Zimbabwe"
        },
        "country_by_name": {
          "afganistan": "AF",
          "albania": "AL",
          "alemania": "DE",
          "andorra": "AD",
          "angola": "AO",
          "anguila": "AI",
          "antarctida": "AQ",
          "antigua_y_barbuda": "AG",
          "antillas_holandesas": "AN",
          "arabia_saudita": "SA",
          "argelia": "DZ",
          "argentina": "AR",
          "armenia": "AM",
          "aruba": "AW",
          "australia": "AU",
          "austria": "AT",
          "azerbaiyan": "AZ",
          "bahamas": "BS",
          "bangladesh": "BD",
          "barbados": "BB",
          "barein": "BH",
          "belarus": "BY",
          "belgica": "BE",
          "belice": "BZ",
          "benin": "BJ",
          "bermuda": "BM",
          "bolivia": "BO",
          "bonaire": "BQ",
          "bosnia_y_herzegovina": "BA",
          "botswana": "BW",
          "brasil": "BR",
          "brunei": "BN",
          "bulgaria": "BG",
          "burkina_faso": "BF",
          "burundi": "BI",
          "butan": "BT",
          "cabo_verde": "CV",
          "camboya": "KH",
          "camerun": "CM",
          "canada": "CA",
          "chad": "TD",
          "chile": "CL",
          "china": "CN",
          "chipre": "CY",
          "ciudad_del_vaticano": "VA",
          "colombia": "CO",
          "comoras": "KM",
          "congo": "CG",
          "corea_del_norte": "KP",
          "corea_del_sur": "KR",
          "costa_de_marfil": "CI",
          "costa_rica": "CR",
          "croacia": "HR",
          "cuba": "CU",
          "curazao": "CW",
          "dinamarca": "DK",
          "dominica": "DM",
          "ecuador": "EC",
          "egipto": "EG",
          "el_salvador": "SV",
          "emiratos_arabes_unidos": "AE",
          "eritrea": "ER",
          "eslovaquia": "SK",
          "eslovenia": "SI",
          "españa": "ES",
          "estados_federados_de_micronesia": "FM",
          "estados_unidos": "US",
          "estonia": "EE",
          "etiopia": "ET",
          "fiji": "FJ",
          "filipinas": "PH",
          "finlandia": "FI",
          "francia": "FR",
          "gabon": "GA",
          "gambia": "GM",
          "georgia": "GE",
          "ghana": "GH",
          "gibraltar": "GI",
          "granada": "GD",
          "grecia": "GR",
          "groenlandia": "GL",
          "guadalupe": "GP",
          "guam": "GU",
          "guatemala": "GT",
          "guayana_francesa": "GF",
          "guernsey": "GG",
          "guinea": "GN",
          "guinea_bissau": "GW",
          "guinea_ecuatorial": "GQ",
          "guyana": "GY",
          "haiti": "HT",
          "holanda": "NL",
          "honduras": "HN",
          "hong_kong": "HK",
          "hungria": "HU",
          "india": "IN",
          "indonesia": "ID",
          "irak": "IQ",
          "iran": "IR",
          "irlanda": "IE",
          "isla_bouvet": "BV",
          "isla_de_man": "IM",
          "isla_de_navidad": "CX",
          "isla_norfolk": "NF",
          "islandia": "IS",
          "islas_aland": "AX",
          "islas_caiman": "KY",
          "islas_cocos": "CC",
          "islas_cook": "CK",
          "islas_faroe": "FO",
          "islas_georgia_y_sandwich_del_sur": "GS",
          "islas_heard_y_mcdonald": "HM",
          "islas_malvinas": "FK",
          "islas_marianas_del_norte": "MP",
          "islas_marshall": "MH",
          "islas_salomon": "SB",
          "islas_turcas_y_caicos": "TC",
          "islas_ultramarinas_menores_de_estados_unidos": "UM",
          "islas_virgenes_americanas": "VI",
          "islas_virgenes_britanicas": "VG",
          "israel": "IL",
          "italia": "IT",
          "jamaica": "JM",
          "japon": "JP",
          "jersey": "JE",
          "jordania": "JO",
          "kazajistan": "KZ",
          "kenia": "KE",
          "kirguistan": "KG",
          "kiribati": "KI",
          "kosovo": "KV",
          "kuwait": "KW",
          "laos": "LA",
          "lesoto": "LS",
          "letonia": "LV",
          "libano": "LB",
          "liberia": "LR",
          "libia": "LY",
          "liechtenstein": "LI",
          "lituania": "LT",
          "luxemburgo": "LU",
          "macao": "MO",
          "macedonia_del_norte": "MK",
          "madagascar": "MG",
          "malasia": "MY",
          "malawi": "MW",
          "maldivas": "MV",
          "mali": "ML",
          "malta": "MT",
          "marruecos": "MA",
          "martinica": "MQ",
          "mauricio": "MU",
          "mauritania": "MR",
          "mayotte": "YT",
          "mexico": "MX",
          "moldavia": "MD",
          "monaco": "MC",
          "mongolia": "MN",
          "montenegro": "ME",
          "montserrat": "MS",
          "mozambique": "MZ",
          "myanmar": "MM",
          "namibia": "NA",
          "nauru": "NR",
          "nepal": "NP",
          "nicaragua": "NI",
          "niger": "NE",
          "nigeria": "NG",
          "niue": "NU",
          "noruega": false,
          "nueva_caledonia": "NC",
          "nueva_zelanda": "NZ",
          "oman": "OM",
          "pakistpan": "PK",
          "palau": "PW",
          "palestina": "PS",
          "panama": "PA",
          "papua_nueva_guinea": "PG",
          "paraguay": "PY",
          "peru": "PE",
          "pitcairn": "PN",
          "polinesia_francesa": "PF",
          "polonia": "PL",
          "portugal": "PT",
          "puerto_rico": "PR",
          "qatar": "QA",
          "reino_unido": "GB",
          "republica_centroafricana": "CF",
          "republica_checa": "CZ",
          "republica_democratica_del_congo": "CD",
          "republica_dominicana": "DO",
          "reunion": "RE",
          "ruanda": "RW",
          "rumania": "RO",
          "rusia": "RU",
          "sahara_occidental": "EH",
          "samoa": "WS",
          "samoa_americana": "AS",
          "san_bartolome": "BL",
          "san_cristobal_y_nieves": "KN",
          "san_marino": "SM",
          "san_martin": "SX",
          "san_pedro_y_miquelon": "PM",
          "san_vincente_y_las_grenadinas": "VC",
          "santa_elena": "SH",
          "santa_lucia": "LC",
          "santo_tome_y_principe": "ST",
          "senegal": "SN",
          "serbia": "RS",
          "seychelles": "SC",
          "sierra_leona": "SL",
          "singapur": "SG",
          "siria": "SY",
          "somalia": "SO",
          "sri_lanka": "LK",
          "sudafrica": "ZA",
          "sudan": "SD",
          "sudan_del_sur": "SS",
          "suecia": "SE",
          "suiza": "CH",
          "surinam": "SR",
          "svalbard_y_jan_mayen": "SJ",
          "swazilandia": "SZ",
          "tailandia": "TH",
          "taiwan": "TW",
          "tajikistan": "TJ",
          "tanzania": "TZ",
          "territorio_britanico_del_oceano_indico": "IO",
          "tierras_australes_y_antarticas_francesas": "TF",
          "timor_occidental": "TP",
          "timor_oriental": "TL",
          "togo": "TG",
          "tokelau": "TK",
          "tonga": "TO",
          "trinidad_y_tobago": "TT",
          "tunez": "TN",
          "turkmenistan": "TM",
          "turquia": "TR",
          "tuvalu": "TV",
          "ucrania": "UA",
          "uganda": "UG",
          "uruguay": "UY",
          "uzbekistan": "UZ",
          "vanuatu": "VU",
          "venezuela": "VE",
          "vietnam": "VN",
          "wallis_y_futuna": "WF",
          "yemen": "YE",
          "yibuti": "DJ",
          "zambia": "ZM",
          "zimbabwe": "ZW"
        },
        "default_country": [
          "Argentina"
        ],
        "default_country_code": [
          "AR"
        ],
        "female_city_saint_prefix": "Santa",
        "full_address": [
          "#{street_address}, (#{postcode}) #{city}, #{state}",
          "#{street_address}, (#{postcode}) #{city}, #{state_abbr}"
        ],
        "male_city_saint_prefix": "San",
        "postcode": [
          "####",
          "?####???"
        ],
        "postcode_by_state": {
          "BA": "B####???",
          "CA": "K####???",
          "CABA": "C####???",
          "CB": "X####???",
          "CH": "H####???",
          "CR": "W####???",
          "CT": "U####???",
          "ER": "E####???",
          "FO": "P####???",
          "JY": "Y####???",
          "LP": "L####???",
          "LR": "F####???",
          "MI": "N####???",
          "MZ": "M####???",
          "NQN": "Q####???",
          "RN": "R####???",
          "SA": "A####???",
          "SC": "Z####???",
          "SE": "G####???",
          "SF": "S####???",
          "SJ": "J####???",
          "SL": "D####???",
          "TF": "V####???",
          "TU": "T####???"
        },
        "road_name": [
          "Ruta #",
          "Ruta ##",
          "Ruta ###"
        ],
        "road_prefix": [
          "Camino a",
          "Acceso a"
        ],
        "road_suffix": [
          "Km. #",
          "Km. ##",
          "Km. #,#",
          "Km. ##,#"
        ],
        "secondary_address": [
          "Departamento #?",
          "Depto. #?",
          "Piso #",
          "Piso ##",
          "PB",
          "PA",
          "Manzana ?#",
          "Lote #?",
          "Lote ##?",
          "UF N° #",
          "UF N° ##"
        ],
        "state": [
          "Buenos Aires",
          "Ciudad Autónoma de Buenos Aires",
          "Catamarca",
          "Córdoba",
          "Corrientes",
          "Chaco",
          "Chubut",
          "Entre Ríos",
          "Formosa",
          "Jujuy",
          "La Pampa",
          "La Rioja",
          "Mendoza",
          "Misiones",
          "Neuquén",
          "Río Negro",
          "Salta",
          "San Juan",
          "San Luis",
          "Santa Cruz",
          "Santa Fe",
          "Santiago del Estero",
          "Tucumán",
          "Tierra del Fuego"
        ],
        "state_abbr": [
          "BA",
          "CABA",
          "Cat.",
          "Cba.",
          "Ctes.",
          "Chaco",
          "Chubut",
          "ER",
          "Form.",
          "Juj.",
          "LP",
          "LR",
          "Mza.",
          "Mnes.",
          "Nqn.",
          "RN",
          "Salta",
          "SJ",
          "SL",
          "SC",
          "SF",
          "SdE",
          "Tuc.",
          "TdF"
        ],
        "state_abbr_iata": [
          "BA",
          "CABA",
          "CA",
          "CB",
          "CR",
          "CH",
          "CT",
          "ER",
          "FO",
          "JY",
          "LP",
          "LR",
          "MZ",
          "MI",
          "NQN",
          "RN",
          "SA",
          "SJ",
          "SL",
          "SC",
          "SF",
          "SE",
          "TU",
          "TF"
        ],
        "street": [
          "1° de Mayo",
          "12 de Octubre",
          "25 de Mayo",
          "3 de Febrero",
          "9 de Julio",
          "Alberti",
          "Alem",
          "Alfonsina Storni",
          "Alfredo Palacios",
          "Alicia M. de Justo",
          "Almafuerte",
          "Alsina",
          "Alte. Brown",
          "Ameghino",
          "América",
          "Antártida Argentina",
          "Arenales",
          "Aristóbulo del Valle",
          "Aristóteles",
          "Arturo Illia",
          "Avellaneda",
          "Ayacucho",
          "Azcuénaga",
          "Azopardo",
          "Azucena Villaflor",
          "B. de Irigoyen",
          "Balcarce",
          "Belgrano",
          "Bernardo Houssay",
          "Beruti",
          "Bicentenario",
          "Blas Parera",
          "Bolívar",
          "Bolivia",
          "Boquerón",
          "Bouchard",
          "Brandsen",
          "Brasil",
          "Buenos Aires",
          "C. Pellegrini",
          "Cabildo",
          "Cangallo",
          "Carabobo",
          "Carlos M. de Alvear",
          "Carlos Tejedor",
          "Carrasco",
          "Caseros",
          "Castelli",
          "Catamarca",
          "Centenario",
          "Cerrito",
          "Cervantes",
          "Chaco",
          "Charcas",
          "Chile",
          "Chubut",
          "Colombia",
          "Colón",
          "Constitución",
          "Córdoba",
          "Coronel Vidal",
          "Corrientes",
          "Cortázar",
          "Crucero Gral. Belgrano",
          "Dardo Rocha",
          "Darwin",
          "Deán Funes",
          "Del Valle Iberlucea",
          "Diego A. Maradona",
          "Don Bosco",
          "Dorrego",
          "E. Carriego",
          "E. Finocchieto",
          "Echeverría",
          "Ecuador",
          "Ejército Argentino",
          "Ejército del Norte",
          "Emilio Mitre",
          "Entre Ríos",
          "Esmeralda",
          "España",
          "Estanislao Zeballos",
          "Estrada",
          "Eva Perón",
          "Falucho",
          "Fleming",
          "Florencio Sánchez",
          "Florida",
          "Formosa",
          "Francia",
          "Fray Luis Beltrán",
          "Fray M. Esquiú",
          "French",
          "G. Posadas",
          "Gaboto",
          "Garibaldi",
          "Gascón",
          "Godoy Cruz",
          "Gral. Conesa",
          "Gral. Guido",
          "Gral. Mosconi",
          "Gral. Paz",
          "Gral. Savio",
          "Granaderos",
          "Guatemala",
          "Güemes",
          "Guido Spano",
          "H. Vieytes",
          "H. Yrigoyen",
          "Hernandarias",
          "Humaitá",
          "Humberto 1°",
          "Independencia",
          "Islas Malvinas",
          "Italia",
          "Ituzaingó",
          "J.A. Roca",
          "J.B. Alberdi",
          "J.L. Borges",
          "Jorge Newbery",
          "José Hernández",
          "José Ingenieros",
          "Juan B. Justo",
          "Juan de Garay",
          "Juan J. Paso",
          "Juan M. de Rosas",
          "Juan XXIII",
          "Juana Azurduy",
          "Juana Manso",
          "Jujuy",
          "Juncal",
          "Juramento",
          "Justo Daract",
          "L. de la Torre",
          "La Pampa",
          "La Paz",
          "La Rioja",
          "Lamadrid",
          "Laprida",
          "Larrea",
          "Las Heras",
          "Lavalle",
          "Libertad",
          "Libertador",
          "Libres del sud",
          "Liniers",
          "Lola Mora",
          "Los Andes",
          "Luis Agote",
          "Luis M. Drago",
          "Luis M. Leloir",
          "M. Moreno",
          "Magallanes",
          "Maipú",
          "Mansilla",
          "Manuela Pedraza",
          "Marcelo T. de Alvear",
          "Mariano Acosta",
          "Mario Bravo",
          "Martín Rodríguez",
          "Matheu",
          "Mendoza",
          "México",
          "Misiones",
          "Mitre",
          "Montevideo",
          "Neuquén",
          "O. Andrade",
          "O’Higgins",
          "Olazábal",
          "Olleros",
          "Panamá",
          "Paraguay",
          "Pasco",
          "Pasteur",
          "Patricios",
          "Perito Moreno",
          "Perón",
          "Perú",
          "Pichincha",
          "Platón",
          "Primera Junta",
          "Pringles",
          "Pueyrredón",
          "Quintana",
          "R. de Escalada",
          "R. Falcón",
          "Rafael Obligado",
          "Raúl Alfonsín",
          "Rawson",
          "Reconquista",
          "René Favaloro",
          "Ricardo Balbín",
          "Ricardo Güiraldes",
          "Rincón",
          "Río Negro",
          "Riobamba",
          "Rivadavia",
          "Rivera Indarte",
          "Rocha",
          "Rondeau",
          "Saavedra",
          "Sáenz Peña",
          "Salta",
          "San Ceferino",
          "San José",
          "San Juan",
          "San Lorenzo",
          "San Luis",
          "San Martín",
          "San Rafael",
          "San Roque",
          "San Sebastián",
          "Santa Clara",
          "Santa Cruz",
          "Santa Elena",
          "Santa Fe",
          "Santa Rita",
          "Santa Rosalía",
          "Santa Sofía",
          "Santa Teresa",
          "Santiago del Estero",
          "Sarandí",
          "Sarmiento",
          "Sarratea",
          "Scalabrini Ortíz",
          "Sgto. Cabral",
          "Sócrates",
          "Solis",
          "Sucre",
          "Suipacha",
          "Thames",
          "Tierra del Fuego",
          "Triunvirato",
          "Tucumán",
          "Urquiza",
          "Uruguay",
          "Vélez Sársfield",
          "Venezuela",
          "Viamonte",
          "Vicente López",
          "Victorino de la Plaza",
          "Virrey Cevallos",
          "Virrey Cisneros",
          "Virrey del Pino",
          "Virrey Sobremonte",
          "Vuelta de Obligado",
          "Warnes",
          "Zapata",
          "Zapiola"
        ],
        "street_address": [
          "#{road_name}, #{road_suffix}",
          "#{road_prefix} #{city}, #{road_suffix}",
          "#{street_name} #{building_number}",
          "#{street_name} #{building_number}",
          "#{street_name} #{building_number}",
          "#{street_name} #{building_number}",
          "#{street_name} #{building_number}",
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_prefix} #{street}",
          "#{street}",
          "#{street}",
          "#{street}",
          "#{street}"
        ],
        "street_prefix": [
          "Av.",
          "Avenida",
          "Av. Costanera",
          "Bv.",
          "Boulevard",
          "Costanera",
          "Circunvalación",
          "Paseo",
          "Peatonal",
          "Camino"
        ],
        "street_suffix": ""
      },
      "bank": {
        "name": [
          "Banco Galicia",
          "Banco Nación",
          "Banco de la Provincia de Buenos Aires",
          "ICBC",
          "Citibank",
          "BBVA Argentina",
          "BanCor",
          "Banco Supervielle",
          "Banco Ciudad",
          "Banco Patagonia",
          "Banco Hipotecario",
          "Banco de San Juan",
          "Banco Municipal de Rosario",
          "Banco Santander Río",
          "Banco del Chubut",
          "Banco de Santa Cruz",
          "Banco de La PAmpa",
          "Banco de Corrientes",
          "Banco Provincia del Neuquén",
          "Brubank",
          "Banco Interfinanzas",
          "HSBC",
          "Banco Credicoop",
          "Banco Itaú",
          "BNP Paribas",
          "Banco de la Provincia de Tierra del Fuego",
          "Banco de la República Oriental del Uruguay",
          "Banco Macro",
          "Banco Comafi",
          "BICE",
          "Banco Piano",
          "Banco Rioja",
          "Banco del Sol",
          "Nuevo Banco del Chaco",
          "Banco Voii",
          "Banco de Formosa",
          "Banco de Santiago del Estero",
          "Banco Industrial",
          "Nuevo Banco de Santa Fe",
          "Banco Bradesco",
          "Wilobank",
          "Nuevo Banco de Entre Ríos",
          "Banco Columbia"
        ]
      },
      "basketball": {
        "coaches": [
          "Víctor Caamaño",
          "Juan Fava",
          "Saúl Ramírez Manfredi",
          "Pedro Busso",
          "Jorge Canavesi",
          "Pedro Pasquinelli",
          "Alberto Andrizzi",
          "Miguel Ángel Ripullone",
          "Alberto López",
          "Caimiro González Trilla",
          "Jorge Martínez",
          "Abelardo Dasso",
          "Heriberto Schonwies",
          "Raúl García",
          "Alberto Finguer",
          "León Najnudel",
          "Carlos Boismené",
          "Walter Garrone",
          "Guillermo Vecchio",
          "Julio Lamas",
          "Rubén Magnano",
          "Sergio Hernández",
          "Sebastián Ginóbili",
          "Leonardo Gutiérrez",
          "Pablo Prigioni"
        ],
        "players": [
          "Manu Ginóbili",
          "Luis Scola",
          "Andrés 'Chapu' Nocioni",
          "Pablo Prigioni",
          "Fabricio Oberto",
          "Juan Ignacio 'Pepe' Sánchez",
          "Walter Herrman",
          "Carlos Delfino",
          "Marcelo Milanesio",
          "Héctor 'Pichi' Campana",
          "Oscar Furlong",
          "Alejandro Montecchia",
          "Hugo Sconochini",
          "Miguel Cortijo",
          "Leonardo Gutiérrez",
          "Juan Alberto Espil",
          "Hernán Montenegro",
          "Diego Osella",
          "Esteban de la Fuente",
          "Jorge Racca",
          "Daniel Farabello",
          "Esteban Pérez",
          "Carlos Romano",
          "Jorge González",
          "Eduardo Cadillac",
          "Marcelo Nicola",
          "Luis Villar",
          "Gabriel Fernández",
          "Román González",
          "Martín Leiva",
          "Hernán Jasen",
          "Federico Kammerichs",
          "Leandro Palladino",
          "Marcelo Richotti",
          "Leopoldo Contarbio",
          "Roberto Viau",
          "Antonio Porta",
          "Facundo Campazzo",
          "Rubén Wolkowyski",
          "Nicolás Laprovittola",
          "Nicolás Brussino",
          "Patricio Garino"
        ],
        "positions": [
          "Base",
          "Escolta",
          "Alero",
          "Ala-Pivot",
          "Pivot"
        ],
        "teams": [
          "9 de Julio de Río Tercero",
          "Almagro de Esperanza",
          "Andino de La Rioja",
          "Argentino de Firmat",
          "Argentino de Junín",
          "Asociación Española de Córdoba",
          "Atenas de Córdoba",
          "Bahía Basket",
          "Banco de Córdoba",
          "Belgrano de San Nicolás",
          "Belgrano de Tucumán",
          "Ben Hur de Rafaela",
          "Caja Popular de Tucumán",
          "Central Entrerriano",
          "Ciclista Juninense",
          "Ciclista Olímpico de La Banda",
          "Boca Juniors",
          "Club Morón",
          "Comunicaciones de Mercedes",
          "Deportivo Madryn",
          "Deportivo Roca",
          "Echagüe de Paraná",
          "El Nacional de Monte Hermoso",
          "Estudiantes de Concordia",
          "Estudiantes de Bahía Blanca",
          "Estudiantes de Olavarría",
          "Ferro Carril Oeste",
          "Firmat Football Club",
          "Gimnasia de Comodoro Rivadavia",
          "Gimnasia de La Plata",
          "Gimnasia de Pergamino",
          "Gimnasia y Esgrima Pedernera Unidos",
          "Hispano Americano de Río Gallegos",
          "Independiente de General Pico",
          "Independiente de Neuquén",
          "Independiente de Tucumán",
          "Instituto de Córdoba",
          "La Unión de Formosa",
          "Lanús",
          "Libertad de Sunchales",
          "Luz y Fuerza de Posadas",
          "Oberá TC",
          "Obras Sanitarias",
          "Olimpia de Venado Tuerto",
          "Olimpo de Bahía Blanca",
          "Pacífico de Bahía Blanca",
          "Peñarol de Mar del Plata",
          "Pico Football Club",
          "Platense",
          "Provincial de Rosario",
          "Quilmes de Mar del Plata",
          "Quimsa",
          "Racing Club de Avellaneda",
          "Regatas Corrientes",
          "Regatas de San Nicolás",
          "River Plate",
          "Salta Basket",
          "San Andrés",
          "San Lorenzo",
          "San Martín de Corrientes",
          "San Martín de Marcos Juárez",
          "Santa Paula de Gálvez",
          "Sionista de Paraná",
          "Sport Club de Cañada de Gómez",
          "Unión de Santa Fe",
          "Unión de Sunchales",
          "Unión Progresista de Villa Ángela",
          "Valle Inferior de Viedma"
        ]
      },
      "cell_phone": {
        "formats": [
          "11-4###-####",
          "2## 4##-####",
          "3## 4##-####",
          "2### 4#####",
          "3### 4#####",
          "11-5###-####",
          "2## 5##-####",
          "3## 5##-####",
          "2### 5#####",
          "3### 5#####",
          "11-6###-####",
          "2## 6##-####",
          "3## 6##-####",
          "2### 6#####",
          "3### 6#####",
          "11-7###-####"
        ]
      },
      "color": {
        "name": [
          "aguamarina",
          "amaranto",
          "amarillo",
          "amarillo limón",
          "amatista",
          "ámbar",
          "añil",
          "azul",
          "azul cobalto",
          "azul de Prusia",
          "azul francia",
          "azul marino",
          "azul petróleo",
          "beige",
          "bermellón",
          "blanco",
          "bordó",
          "borgoña",
          "café",
          "caqui",
          "carmesí",
          "carmín",
          "castaño",
          "celeste",
          "chocolate",
          "cian",
          "colorado",
          "dorado",
          "durazno",
          "escarlata",
          "esmeralda",
          "frutilla",
          "fúcsia",
          "granate",
          "gris",
          "hueso",
          "índigo",
          "jade",
          "lavanda",
          "lavanda",
          "lila",
          "magenta",
          "malva",
          "marfil",
          "marrón",
          "morado",
          "naranja",
          "negro",
          "ocre",
          "plateado",
          "púrpura",
          "rojo",
          "rosa",
          "rubí",
          "salmón",
          "siena",
          "siena pálido",
          "topacio",
          "turquesa",
          "verde",
          "verde agua",
          "verde militar",
          "verde oliva",
          "violeta",
          "zafiro",
          "zanahoria"
        ]
      },
      "company": {
        "bs": [
          [
            "implementar",
            "utilizar",
            "integrar",
            "aerodinamizar",
            "optimizar",
            "evolucionar",
            "transformar",
            "adoptar",
            "habilitar",
            "orquestrar",
            "apalancar",
            "reinventar",
            "sumar",
            "arquitectar",
            "realzar",
            "incentivar",
            "mutar",
            "empoderar",
            "visualizar",
            "monetizar",
            "aprovechar",
            "facilitar",
            "sujetar",
            "desintermediar",
            "sinergizar",
            "estrategizar",
            "desplegar",
            "marcar",
            "crecer",
            "apuntar",
            "vender",
            "sintetizar",
            "entregar",
            "interconectar",
            "incubar",
            "involucrar",
            "maximizar",
            "comparar",
            "expedir",
            "reintermediar",
            "diagramar",
            "visualizar",
            "reconvertir",
            "innovar",
            "escalar",
            "desatar",
            "impulsar",
            "extender",
            "construir",
            "revolucionar",
            "generar",
            "explotar",
            "transicionar",
            "habilitar digitalmente",
            "iterar",
            "cultivar",
            "conglomerar",
            "productizar",
            "redefinir",
            "recontextualizar"
          ],
          [
            "la fisicalidad",
            "el valor agregado",
            "la verticalidad",
            "la proactividad",
            "la robustez",
            "la revolucionaridad",
            "la escalabilidad",
            "la modernidad",
            "la innovación",
            "la intuitividad",
            "la estrategicidad",
            "el desarrollo comercial web",
            "la cualidad crítica de las misiones",
            "la adherencia",
            "la individualidad",
            "la disponibilidad 24/7",
            "la disponibilidad punta a punta",
            "la globalidad",
            "la conexión negocio a negocios",
            "la conexión negocio a cliente",
            "la granularidad",
            "la falta de fricción",
            "la virtualidad",
            "la viralidad",
            "el dinamismo",
            "la disponibilidad 24/365",
            "la ejemplaridad",
            "la superioridad",
            "el magnetismo",
            "el atractivo",
            "la performance en el back-end",
            "la simultaneidad",
            "la eficiecia",
            "la performance en el front-end",
            "la distributividad",
            "la continuidad",
            "la extensibilidad",
            "la preconfiguración",
            "la clase mundial",
            "la apertura",
            "la interoperabilidad",
            "la disponibilidad mediática",
            "la originalidad",
            "la cualidad empresarial",
            "la integración",
            "el impacto",
            "la libertad",
            "la transparencia",
            "la cualidad de avanzada",
            "la tecnología de punta",
            "la experiencia centrada en el usuario",
            "la visión",
            "la adaptabilidad",
            "la presencia contínua",
            "la rápidez",
            "la colaboratividad",
            "la persuasión",
            "la integralidad",
            "la riqueza"
          ],
          [
            "de las sinergias",
            "de la disposición web",
            "de los paradigmas",
            "de los mercados",
            "de las sociedades",
            "de las infraestructuras",
            "de las plataformas",
            "de las iniciativas",
            "de los canales",
            "de las visiones",
            "de las comunidades",
            "de los retornos",
            "de las soluciones",
            "de las ventas digiales",
            "de los servicios digitales",
            "de los puntos de acción",
            "de los portales",
            "de los nichos",
            "de las tecnologías",
            "de los contenidos",
            "de los portales virtuales",
            "de las cadenas de abastecimiento",
            "de la convergencia",
            "de las relaciones",
            "de las arquitecturas",
            "de las interfaces",
            "de los mercados digitales",
            "de el comercio digital",
            "de los sistemas",
            "de el ancho de banda",
            "de los intermediarios",
            "de los modelos",
            "de el mindshare",
            "de las entregas",
            "de los usuarios",
            "de los esquemas",
            "de las redes",
            "de las aplicaciones",
            "de las métricas",
            "de los negocios digitales",
            "de las funcionalidades",
            "de las experiencias",
            "de los servicios web",
            "de las metodologías"
          ]
        ],
        "industry": [
          "Defensa y Aeroespacial",
          "Hardware",
          "Desarrollo de Software",
          "Internet",
          "Semiconductores",
          "Telecomunicaciones",
          "Servicios legales",
          "Consultoría",
          "Biotecnología",
          "Medicina",
          "Cuidado de la Salud",
          "Farmacéutica",
          "Veterinaria",
          "Dispositivos Médicos",
          "Cosméticos",
          "Moda",
          "Productos deportivos",
          "Tabaco",
          "Supermercado",
          "Alimenticio",
          "Electrónica",
          "Mueblería",
          "Retail",
          "Entretenimiento",
          "Apuestas y Casinos",
          "Turismo",
          "Hospitalidad",
          "Restaurants",
          "Deportes",
          "Comida y Bebida",
          "Audiovisual",
          "Medios de Comunicación",
          "Museos e Instituciones",
          "Artes plásticas",
          "Actuación",
          "Servicios e instalaciones de Recreación",
          "Bancos",
          "Seguros",
          "Servicios Financieros",
          "Real Estate",
          "Banca de Inversión",
          "Administración de Inversiones",
          "Contabilidad",
          "Construcción",
          "Materiales de Construcción",
          "Arquitectura y Planeamiento",
          "Ingeniería Civil",
          "Aviación",
          "Automotriz",
          "Química",
          "Maquinaria",
          "Minería",
          "Petróleo y Energía",
          "Astilleros",
          "Textiles",
          "Productos Forestales y de Papel",
          "Manufactura Ferroviaria",
          "Agricultura",
          "Ganadería",
          "Lácteos",
          "Pesca",
          "Educación Primaria / Secundaria",
          "Education Universitaria",
          "Investigación",
          "Militar",
          "Poder Legislativo",
          "Poder Judicial",
          "Relaciones Internacionales",
          "Administración y Gobierno",
          "Poder Ejecutivo",
          "Fuerzas de Seguridad",
          "Políticas Públicas",
          "Marketing y Publicidad",
          "Periódicos",
          "Imprentas",
          "Servicios de Información",
          "Librerías",
          "Servicios del Medio Ambiente",
          "Logística",
          "Servicios Individuales y Familiares",
          "Instituciones Religiosas",
          "Organizaciones Cívicas y Sociales",
          "Servicios al Consumidor",
          "Almacenamiento",
          "Servicios Marítimos",
          "Tecnologías y Servicios de la Información",
          "Investigación de Mercados",
          "Relaciones Públicas y Comunicaciones",
          "Diseño",
          "ONGs",
          "Editorial",
          "Recursos Humanos",
          "Entrenamiento Profesional y Coaching",
          "Capital de Riesgo",
          "Organización Política",
          "Traducción",
          "Juegos Electrónicos",
          "Eventos",
          "Artesanías",
          "Manufactura Eléctrica y Electrónica",
          "Medios en línea",
          "Nanotecnología",
          "Música",
          "Plásticos",
          "Seguridad Digital",
          "Resolución de Disputas",
          "Investigaciones y Seguridad",
          "Servicios de Instalaciones",
          "Servicios Tercerizados",
          "Gimnasios",
          "Medicina Alternativa",
          "Producción de Medios",
          "Animación",
          "Inmuebles Comerciales",
          "Mercados de Capitales",
          "Think Tanks",
          "Filantropía",
          "Aprendizaje en línea",
          "Mayorista",
          "Comercio Exterior",
          "Ingeniería Mecánica o Industrial",
          "Fotografía",
          "Equipamiento Industrial",
          "Salud Mental",
          "Diseño Gráfico",
          "Bebidas Alcohólicas",
          "Joyería y Bienes de Lujo",
          "Energías Renovables",
          "Vidrio y Cerámica",
          "Empaques y Contenedores",
          "Automatización Industrial"
        ],
        "name": [
          "#{prefix} #{Name.last_name}",
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} y asociados",
          "#{Name.last_name} y #{Name.last_name} #{suffix}"
        ],
        "prefix": [
          "Grupo",
          "Comercializadora"
        ],
        "profession": [
          "maestro",
          "actor",
          "músico",
          "filósofo",
          "escritor",
          "doctor",
          "contador",
          "agricultor",
          "arquitecto",
          "economista",
          "ingeniero",
          "intérprete",
          "abogado",
          "libreri",
          "estadístico",
          "responsable de recursos humanos",
          "bombero",
          "juez",
          "policía",
          "astrónomo",
          "biólogo",
          "químico",
          "físico",
          "programador",
          "desarrollador web",
          "diseñador",
          "actriz",
          "controlador de tráfico aéreo",
          "artista",
          "banquero",
          "bartender",
          "peluquero",
          "administrador",
          "constructor",
          "empresario",
          "carnicero",
          "carpintero",
          "cajero",
          "chef",
          "coach",
          "dentista",
          "desarrollador",
          "nutricionista",
          "editor",
          "electricista",
          "operario",
          "granjero",
          "pescador",
          "jardinero",
          "estilista",
          "periodista",
          "legislador",
          "profesor",
          "guardavidas",
          "mecánico",
          "modelo",
          "presentador de noticias",
          "enfermero",
          "óptico",
          "pintor",
          "farmacista",
          "fotógrafo",
          "piloto",
          "plomero",
          "político",
          "cartero",
          "recepcionista",
          "científico",
          "secretario",
          "vendedor",
          "soldado",
          "sastre",
          "tachero",
          "traductor",
          "zorro",
          "agente de turismo",
          "veterinario",
          "mozo",
          "limpiador de ventanas"
        ],
        "suffix": [
          "SA",
          "e Hijos",
          "SRL",
          "Group"
        ],
        "type": [
          "Compañía Pública",
          "Institución Educativa",
          "Autónomo",
          "Monotributista",
          "Empleado en negro",
          "Agencia de Gobierno",
          "ONG",
          "Sociedad"
        ]
      },
      "compass": {
        "cardinal": {
          "abbreviation": [
            "N",
            "E",
            "S",
            "O"
          ],
          "word": [
            "norte",
            "este",
            "sur",
            "oeste"
          ]
        },
        "half-wind": {
          "abbreviation": [
            "NNE",
            "ENE",
            "ESE",
            "SSE",
            "SSO",
            "OSO",
            "ONO",
            "NNO"
          ],
          "word": [
            "nornoreste",
            "estenoreste",
            "estesureste",
            "sursureste",
            "sursuroeste",
            "oestesuroeste",
            "oesenoroeste",
            "nornoroeste"
          ]
        },
        "ordinal": {
          "abbreviation": [
            "NE",
            "SE",
            "SO",
            "NO"
          ],
          "word": [
            "noreste",
            "sureste",
            "suroeste",
            "noroeste"
          ]
        },
        "quarter-wind": {
          "abbreviation": [
            "NpNE",
            "NEpN",
            "NEpE",
            "EpNE",
            "EpSE",
            "SEpE",
            "SEpS",
            "SpSE",
            "SpSO",
            "SOpS",
            "SOpO",
            "OpSO",
            "OpNO",
            "NOpO",
            "NOpN",
            "NpNO"
          ],
          "word": [
            "norte por el noreste",
            "noreste por el norte",
            "noreste por el este",
            "este por el noreste",
            "este por el sureste",
            "sureste por el este",
            "sureste por el sur",
            "sur por el sureste",
            "sur por el suroeste",
            "suoreste por el sur",
            "suroeste por el oeste",
            "oeste por el suroeste",
            "oeste por el noroeste",
            "noroeste por el oeste",
            "noroeste por el norte",
            "norte por el noroeste"
          ]
        }
      },
      "currency": {
        "name": [
          "Afgani afgano",
          "Ariary malgache",
          "Baht tailandés",
          "Balboa panameño",
          "Birr etíope",
          "Boliviano",
          "Cedi ghanés",
          "Chelín keniano",
          "Chelín somalí",
          "Chelín tanzano",
          "Chelín ugandés",
          "Colón costarricense",
          "Córdoba nicaragüense",
          "Corona checa",
          "Corona danesa",
          "Corona islandesa",
          "Corona noruega",
          "Corona sueca",
          "Dalasi gambiano",
          "Denar macedonio",
          "Dinar argelino",
          "Dinar bareiní",
          "Dinar iraquí",
          "Dinar jordano",
          "Dinar kuwaití",
          "Dinar libio",
          "Dinar serbio",
          "Dinar tunecino",
          "Dírham de los Emiratos Árabes Unidos",
          "Dírham marroquí",
          "Dólar australiano",
          "Dólar bahameño",
          "Dólar beliceño",
          "Dólar bermudeño",
          "Dólar canadiense",
          "Dólar de Barbados",
          "Dólar de Brunéi",
          "Dólar de Hong Kong",
          "Dólar de las Islas Caimán",
          "Dólar de las Islas Salomón",
          "Dólar de Singapur",
          "Dólar de Trinidad y Tobago",
          "Dólar del Caribe Oriental",
          "Dólar estadounidense",
          "Dólar fiyiano",
          "Dólar guyanés",
          "Dólar jamaiquino",
          "Dólar liberiano",
          "Dólar namibio",
          "Dólar neozelandés",
          "Dólar surinamés",
          "Dong vietnamita",
          "Dram armenio",
          "Escudo caboverdiano",
          "Euro",
          "Florín arubeño",
          "Florín de las antillas neerlandesas",
          "Forinto húngaro",
          "Franco CFA de África Central",
          "Franco CFA de África Occidental",
          "Franco CFP",
          "Franco comorense",
          "Franco congoleño",
          "Franco de Burundi",
          "Franco guineano",
          "Franco ruandés",
          "Franco suizo",
          "Franco yibutiano",
          "Gourde haitiano",
          "Grivna ucraniana",
          "Guaraní paraguayo",
          "Kina papuana",
          "Kip laosiano",
          "Kuna croata",
          "Kwacha malau",
          "Kwacha zambiano",
          "Kwanza angoleño",
          "Kyat birmano",
          "Lari georgiano",
          "Lek albanés",
          "Lempira hondureña",
          "Leone sierraleonés",
          "Leu moldavo",
          "Leu rumano",
          "Lev búlgaro",
          "Libra de Gibraltar",
          "Libra de Santa Elena",
          "Libra egipcia",
          "Libra esterlina",
          "Libra libanesa",
          "Libra malvinense",
          "Libra siria",
          "Libra sudanesa",
          "Libra sursudanesa",
          "Lilangeni de Suazilandia",
          "Lira turca",
          "Loti lesotense",
          "Manat azerbaiyano",
          "Manat turcomano",
          "Marco bosnioherzegovino",
          "Metical mozambiqueño",
          "Naira nigeriana",
          "Nakfa eritreo",
          "Ngultrum butanés",
          "Nuevo dólar taiwanés",
          "Nuevo shéquel israelí",
          "Pa'anga tongano",
          "Pataca macaense",
          "Peso argentino",
          "Peso chileno",
          "Peso colombiano",
          "Peso cubano",
          "Peso cubano convertible",
          "Peso dominicano",
          "Peso filipino",
          "Peso mexicano",
          "Peso uruguayo",
          "Pula botsuanés",
          "Quetzal guatemalteco",
          "Rand sudafricano",
          "Real brasileño",
          "Rial catarí",
          "Rial iraní",
          "Rial omaní",
          "Rial saudí",
          "Rial yemení",
          "Riel camboyano",
          "Ringgit malayo",
          "Rublo bielorruso",
          "Rublo ruso",
          "Rupia de Maldivas",
          "Rupia de Mauricio",
          "Rupia de Sri Lanka",
          "Rupia india",
          "Rupia indonesia",
          "Rupia nepalí",
          "Rupia pakistaní",
          "Rupia seychelense",
          "Sol peruano",
          "Som kirguíz",
          "Som uzbeko",
          "Somoni tayiko",
          "Taka bangladesí",
          "Tala samoano",
          "Tenge kazajo",
          "Tugrik mongol",
          "Vatu vanuatuense",
          "Won norcoreano",
          "Won surcoreano",
          "Yen japonés",
          "Yuan chino",
          "Złoty polaco"
        ]
      },
      "football": {
        "coaches": [
          "Adolfo Pedernera",
          "Alberto Pascutti",
          "Alejandro Sabella",
          "Alfio 'Coco' Basile",
          "Alfredo Berti",
          "Alfredo Di Stéfano",
          "Alfredo Grelak",
          "Américo 'Tolo' Gallego",
          "Ángel Cappa",
          "Ángel Tulio Zof",
          "Ariel Cuffaro Russo",
          "Ariel Holan",
          "Blas Giunta",
          "Carlos Babington",
          "Carlos Bianchi",
          "Carlos 'Cai' Aimar",
          "Carlos Leeb",
          "Carlos Ischia",
          "Carlos Pachamé",
          "Carlos Ramacciotti",
          "Carlos Salvador Bilardo",
          "Carlos Timoteo Griguol",
          "Carlos Trullet",
          "César Luis Menotti",
          "'El Chocho' Llop",
          "Claudio 'Bichi' Borghi",
          "Daniel 'El Indio' Bazán Vera",
          "Daniel Bertoni",
          "Daniel Oldrá",
          "Daniel Passarella",
          "Darío Franco",
          "Diego Armando Maradona",
          "Diego Cagna",
          "Diego Cocca",
          "Diego Dabove",
          "Diego Monarriz",
          "Diego Osella",
          "Diego Simeone",
          "Edgardo 'Patón' Bauza",
          "Eduardo 'Toto' Berizzo",
          "Eduardo 'Chacho' Coudet",
          "Eduardo Domínguez",
          "Eduardo Luján Manera",
          "Facundo Sava",
          "Fernando Gamboa",
          "Fernando 'Teté' Quiroz",
          "Francisco 'Pancho' Ferraro",
          "Frank Darío Kudelka",
          "Gabriel Heinze",
          "Gabriel Milito",
          "Gabriel Schürrer",
          "Gerardo 'Tata' Martino",
          "Guillermo Barros Schelotto",
          "Guillermo Stábile",
          "Gustavo Alfaro",
          "Gustavo Álvarez",
          "Gustavo Costas",
          "Gustavo 'El Sapito' Coleoni",
          "Gustavo Quinteros",
          "Héctor Cúper",
          "Héctor 'El Chulo' Rivoira",
          "Héctor 'El Bambino' Veira",
          "Helenio Herrera",
          "Hernán Crespo",
          "Hernán Darío 'El Indio' Ortiz",
          "Hugo Tocalli",
          "Humberto Maschio",
          "Jaime Sarlanga",
          "Jorge Almirón",
          "Jorge Burruchaga",
          "Jorge Sampaoli",
          "Jorge Solari",
          "Jorge Valdano",
          "Jorge 'El Flaco' Vivaldo",
          "José D'Amico",
          "José María 'El Chaucha' Bianco",
          "José María Minella",
          "José Néstor Pékerman",
          "José Yudica",
          "Juan Amador Sánchez",
          "Juan Antonio Pizzi",
          "Juan Carlos Kopriva",
          "Juan Carlos 'El Toto' Lorenzo",
          "Juan José Pizzuti",
          "Juan José Serrizuela",
          "Juan Pablo Pumpido",
          "Juan Pablo Vojvoda",
          "Julio César Falcioni",
          "Leonardo Astrada",
          "Leonardo Madelón",
          "Lionel Scaloni",
          "Lucas Bernardi",
          "Lucas Pusineri",
          "Luis Islas",
          "Luis Ventura",
          "Luis Zubeldía",
          "Marcelo Bielsa",
          "Marcelo Gallardo",
          "Mariano Soso",
          "Mario Gómez",
          "Mario Sciacqua",
          "Mario Zanabria",
          "Martín Palermo",
          "Matías Almeyda",
          "Mauricio Pellegrino",
          "Mauricio Pochettino",
          "Miguel Ángel Russo",
          "Miguel Brindisi",
          "Nelson Vivas",
          "Nery Pumpido",
          "Néstor Apuzzo",
          "Néstor Craviotto",
          "Néstor 'Pipo' Gorosito",
          "Omar De Felippe",
          "Omar Labruna",
          "Omar Sívori",
          "Oscar Malbernat",
          "Oscar Ruggeri",
          "Osvaldo Piazza",
          "Osvaldo 'Chiche' Sosa",
          "Osvaldo Zubeldía",
          "Pablo Guede",
          "Pablo Marini",
          "Patricio Hernández",
          "Pedro Marchetta",
          "Pedro Monzón",
          "Pedro Troglio",
          "Ramón Cabrero",
          "Ramón Díaz",
          "Reinaldo 'Mostaza' Merlo",
          "Renato Cesarini",
          "Ricardo Caruso Lombardi",
          "Ricardo Gareca",
          "Ricardo La Volpe",
          "Ricardo Rezza",
          "Ricardo Zielinski",
          "Roberto Marcos Saporiti",
          "Roberto Perfumo",
          "Roberto Pompei",
          "Rodolfo de Paoli",
          "Rodolfo Motta",
          "Rodolfo 'El Vasco' Arruabarrena",
          "Rubén Darío Insúa",
          "Rubén Forestello",
          "Salvador Pasini",
          "Sebastián Beccacece",
          "Sebastián 'El Gallego' Méndez",
          "Sergio Batista",
          "Sergio 'El Huevo' Rondina",
          "Silvio Marzolini",
          "Vladislao Cap",
          "Walter Lemma",
          "Walter Otta",
          "Wálter Perazzo"
        ],
        "competitions": [
          "Copa Mundial de Fútbol",
          "Copa América",
          "Sudamericano Sub-20",
          "Copa Libertadores",
          "Copa Sudamericana",
          "Mundial de Clubes",
          "Copa Suruga Bank",
          "Copa África",
          "Copa de Oro de la Concacaf",
          "Copa Asiática",
          "Eurocopa",
          "Liga de Campeones de África",
          "Liga de Campeones de Asia",
          "Liga de Campeones de la Concacaf",
          "UEFA Champions League",
          "UEFA Europa League",
          "Supercopa de Europa",
          "Recopa Sudamericana",
          "Superliga Argentina",
          "Copa Diego Armando Maradona",
          "Torneo Apertura",
          "Torneo Clausura",
          "Primera División Argentina",
          "Primera Nacional",
          "Primera B Metropolitana",
          "Primera C",
          "Primera D",
          "Federal A",
          "Federal B",
          "Copa Argentina",
          "Supercopa Argentina",
          "Copa de la Liga Profesional",
          "Copa del Bicentenario",
          "Copa de la Superliga",
          "Trofeo de Campeones de la Superliga"
        ],
        "players": [
          "Marcos 'Anguila' Gutiérrez",
          "Gustavo 'Cachete' Oberman",
          "Carlos 'El Chino' Luna",
          "Carlos 'Discoteca' Núñez",
          "Claudio 'El Mugre' Corvalán",
          "Fernando 'El Rifle' Pandolfi",
          "Jorge 'La Chancha' Rinaldi",
          "Gastón 'La Gata' Fernández",
          "Reinaldo 'Mostaza' Merlo",
          "Pablo 'El Payaso' Lugüercio",
          "César 'El Picante' Pereyra",
          "Fabián 'Poroto' Cubero",
          "Hernán 'El Sapito' Encina",
          "Sebastián 'Terremoto' Cejas",
          "Tomás 'El Trinche' Carlovich",
          "Nicolás 'Uvita' Fernández",
          "Abel Balbo",
          "Agustín Orión",
          "Alberto 'Beto' Márcico",
          "Alberto Tarantini",
          "Aldo Pedro Poy",
          "Aldo Visconti",
          "Alejandro Mancuso",
          "Alfio 'Coco' Basile",
          "Alfredo Rojas",
          "Américo 'Tolo' Gallego",
          "Ángel Bargas",
          "Ángel David Comizzo",
          "Ángel 'Fideo' Di María",
          "Antonio Rattín",
          "Antonio Roma",
          "Ariel 'El Chino' Garcé",
          "Ariel 'El Burrito' Ortega",
          "Augusto Fernández",
          "Carlos Alfaro Moreno",
          "Carlos Babington",
          "Carlos Bianchi",
          "Carlos Daniel Tapia",
          "Carlos 'Lechuga' Roa",
          "Carlos Squeo",
          "Carlos Tévez",
          "Carmelo 'Cholo' Simeone",
          "Claudio 'Bichi' Borghi",
          "Claudio Caniggia",
          "Claudio 'Turco' Husaín",
          "Claudio 'Piojo' López",
          "Clemente Rodríguez",
          "Cristian 'El Kily' González",
          "Cristian Pavón",
          "Daniel Bertoni",
          "Daniel Carnevali",
          "Daniel Killer",
          "Daniel Passarella",
          "Darío Benedetto",
          "Diego Armando Maradona",
          "Diego Milito",
          "Diego Placente",
          "Diego Pozo",
          "Diego 'Cholo' Simeone",
          "Edgardo 'Patón' Bauza",
          "Eduardo 'Toto' Salvio",
          "Enrique Chazarreta",
          "Enrique 'Quique' Wolff",
          "Enzo Pérez",
          "Ermindo Onega",
          "Esteban 'Cuchu' Cambiasso",
          "Éver Banega",
          "Ezequiel Garay",
          "Ezequiel Lavezzi",
          "Fabián Cancelarich",
          "Fabricio Coloccini",
          "Fernando Belluschi",
          "Fernando 'El Negro' Cáceres",
          "Fernando Gago",
          "Fernando Redondo",
          "Francisco 'Pancho' Sa",
          "Franco Armani",
          "Gabriel Batistuta",
          "Gabriel Calderon",
          "Gabriel Heinze",
          "Gabriel Mercado",
          "Gabriel Milito",
          "Germán 'El Mono' Burgos",
          "Giovani Lo Celso",
          "Gonzalo 'Pipita' Higuaín",
          "Gonzalo 'Pity' Martínez",
          "Guillermo Barros Schelotto",
          "Guillermo Stábile",
          "Héctor 'El Negro' Enrique",
          "Héctor Yazalde",
          "Hernán Crespo",
          "Hernán Díaz",
          "Hugo Orlando Gatti",
          "Hugo Pérez",
          "Javier Mascherano",
          "Javier Pastore",
          "Javier Saviola",
          "Javier Zanetti",
          "Jonás 'El Galgo' Gutiérrez",
          "Jorge Borelli",
          "Jorge Burruchaga",
          "Jorge Carrascosa",
          "Jorge Mario Olguín",
          "Jorge Solari",
          "Jorge Valdano",
          "José Basualdo",
          "José Chamot",
          "José 'Pepe' Chatruc",
          "José Daniel Valencia",
          "José Luis 'Tata' Brown",
          "José Luis Cuciuffo",
          "José Omar Pastoriza",
          "José Serrizuela",
          "Juan 'Pichi' Mercier",
          "Juan Pablo Sorín",
          "Juan Román Riquelme",
          "Juan Sebastián Verón",
          "Juan Simón",
          "Julio 'El Vasco' Olarticoechea",
          "Julio Ricardo 'El Jardinero' Cruz",
          "Leandro Cufré",
          "Leonardo Franco",
          "Leonardo Astrada",
          "Leonardo Rodríguez",
          "Leopoldo Jacinto Luque",
          "Lionel Messi",
          "Lionel Scaloni",
          "Lisandro López",
          "Lucas Biglia",
          "'Lucho' González",
          "Luis Artime",
          "Luis Islas",
          "Marcelo 'El Chelo' Delgado",
          "Marcelo Gallardo",
          "Marcelo Trobbiani",
          "Marco Ruben",
          "Marcos Acuña",
          "Marcos Rojo",
          "Mariano Andújar",
          "Mario Alberto Kempes",
          "Martín Demichelis",
          "Martín Palermo",
          "Matías Almeyda",
          "Mauricio Pochettino",
          "Mauro Laspada",
          "Maxi Rodríguez",
          "Miguel Ángel Brindisi",
          "Miguel 'Pepé' Santoro",
          "Nelson Vivas",
          "Nereo Fernández",
          "Nery Pumpido",
          "Néstor Clausen",
          "Néstor 'La Tota' Fabbri",
          "Néstor Ortigoza",
          "Nicolás Burdisso",
          "Nicolás Otamendi",
          "Nicolás Tagliafico",
          "Norberto 'Beto' Alonso",
          "Norberto 'El Gringo' Scoponi",
          "Omar Larrosa",
          "Oscar Garré",
          "Oscar Ruggeri",
          "Osvaldo Ardiles",
          "Pablo Aimar",
          "Pablo Cavallero",
          "Pablo Zabaleta",
          "Paulo Dybala",
          "Pedro Damián Monzón",
          "Pedro Pasculli",
          "Pedro Troglio",
          "Ramón Heredia",
          "Ramón Medina Bello",
          "René Houseman",
          "Ricardo Álvarez",
          "Ricardo Bochini",
          "Ricardo Giusti",
          "Ricardo Villa",
          "Roberto 'Pato' Abbondanzieri",
          "Roberto Ayala",
          "Roberto Bonano",
          "Roberto Perfumo",
          "Roberto Sensini",
          "Rodrigo Palacio",
          "Rolando Hugo Irusta",
          "Rolando Schiavi",
          "Sergio 'Kun' Agüero",
          "Sergio Almirón",
          "Sergio 'Checho' Batista",
          "Sergio 'La Bruja' Berti",
          "Sergio Goycochea",
          "Sergio Romero",
          "Silvio Marzolini",
          "Ubaldo Fillol",
          "Walter Samuel"
        ],
        "positions": [
          "Arquero",
          "Defensor",
          "Mediocampista",
          "Delantero",
          "Lateral",
          "Central",
          "4",
          "2",
          "6",
          "3",
          "5",
          "Doble 5",
          "8",
          "Lateral Izquierdo",
          "Lateral Derecho",
          "Central por la Izquierda",
          "Central por la Derecha",
          "Líbero",
          "5 de Marca",
          "5 de Quite",
          "5 de Juego",
          "5 Habilidoso",
          "7",
          "Volante por la Derecha",
          "Volante por la Izquierda",
          "10",
          "9",
          "11",
          "Delantero Salidor",
          "Delantero Centro",
          "Enganche",
          "Wing",
          "Centrohalf",
          "Centroforward",
          "Volante con Llegada",
          "Armador",
          "Wing Izquierdo",
          "Wing Derecho",
          "Doble 9",
          "9 retrasado"
        ],
        "teams": [
          "Acassuso",
          "Agropecuario de Carlos Casares",
          "Aldosivi",
          "All Boys",
          "Almagro",
          "Almirante Brown",
          "Alvarado",
          "Argentino de Quilmes",
          "Argentinos",
          "Arsenal",
          "Atlanta",
          "Atlético Rafaela",
          "Atlético Tucumán",
          "Banfield",
          "Barracas Central",
          "Belgrano de Córdoba",
          "Boca Juniors",
          "Boca Unidos",
          "Brown de Adrogué",
          "Brown de Puerto Madryn",
          "Central Córdoba de Santiago del Estero",
          "Central Norte",
          "Chacarita",
          "Chaco For Ever",
          "Colegiales",
          "Colón de Santa Fe",
          "Comunicaciones",
          "Defensa y Justicia",
          "Defensores de Belgrano",
          "Defensores Unidos",
          "Deportivo Morón",
          "Deportivo Armenio",
          "Desamparados de San Juan",
          "Douglas Haig de Pergamino",
          "Estudiantes de Buenos Aires",
          "Estudiantes de La Plata",
          "Estudiantes de Río Cuarto",
          "Estudiantes de San Luis",
          "Fénix",
          "Ferro",
          "Flandria",
          "Gimnasia de Jujuy",
          "Gimnasia de La Plata",
          "Gimnasia de Mendoza",
          "Godoy Cruz",
          "Huracán",
          "Independiente",
          "Independiente Rivadavia",
          "Instituto de Córdoba",
          "JJ. Urquiza",
          "Lanús",
          "Los Andes",
          "Mitre de Santiago del Estero",
          "Newell's Old Boys",
          "Nueva Chicago",
          "Olimpo",
          "Patronato",
          "Platense",
          "Quilmes",
          "Racing Club",
          "Riestra",
          "River Plate",
          "Rosario Central",
          "Sacachispas",
          "San Lorenzo",
          "San Martín de San Juan",
          "San Martín de Tucumán",
          "San Miguel",
          "San Telmo",
          "Santamarina de Tandil",
          "Sarmiento de Junín",
          "Sarmiento de Resistencia",
          "Sportivo Belgrano",
          "Sportivo Las Parejas",
          "Talleres de Córdoba",
          "Talleres de Remedios de Escalada",
          "Temperley",
          "Tigre",
          "Tristán Suarez",
          "UAI Urquiza",
          "Unión de Santa Fe",
          "Unión de Sunchales",
          "Vélez",
          "Villa Dálmine",
          "Villa Mitre",
          "Villa San Carlos"
        ]
      },
      "military": {
        "air_force_rank": [
          "Brigadier General",
          "Brigadier Mayor",
          "Brigadier",
          "Comodoro Mayor",
          "Comodoro",
          "Vicecomodoro",
          "Mayor",
          "Capitán",
          "Primer Teniente",
          "Teniente",
          "Alferez",
          "Suboficial Mayor",
          "Suboficial Principal",
          "Suboficial Ayudante",
          "Suboficial Auxiliar",
          "Cabo Principal",
          "Cabo Primero",
          "Cabo",
          "Voluntario de Primera",
          "Voluntario de Segunda"
        ],
        "army_rank": [
          "Teniente General",
          "General de División",
          "General de Brigada",
          "Coronel Mayor",
          "Coronel",
          "Teniente Coronel",
          "Mayor",
          "Capitán",
          "Teniente Primero",
          "Teniente",
          "Subteniente",
          "Suboficial Mayor",
          "Suboficial Principal",
          "Sargento Ayudante",
          "Sargento Primero",
          "Sargento",
          "Cabo Primero",
          "Cabo",
          "Voluntario de Primera",
          "Voluntario de Segunda",
          "Voluntario de Segunda Comisión"
        ],
        "coast_guard_rank": [
          "Prefecto General - Prefecto Nacional Naval",
          "Prefecto General - Subprefecto Nacional Naval",
          "Prefecto General",
          "Prefecto Mayor",
          "Prefecto Principal",
          "Prefecto",
          "Subprefecto",
          "Oficial Principal",
          "Oficial Auxiliar",
          "Oficial Ayudante",
          "Ayudante Mayor",
          "Ayudante Principal",
          "Ayudante de Primera",
          "Ayudante de Segunda",
          "Ayudante de Tercera",
          "Cabo Primero",
          "Cabo Segundo",
          "Marinero"
        ],
        "marines_rank": "",
        "navy_rank": [
          "Almirante",
          "Vicealmirante",
          "Contraalmirante",
          "Comodoro de Marina",
          "Capitán de Navío",
          "Capitán de Fragata",
          "Capitán de Corbeta",
          "Teniente de Navío",
          "Teniente de Fragata",
          "Teniente de Corbeta",
          "Guardiamarina",
          "Suboficial Mayor",
          "Suboficial Principal",
          "Suboficial Primero",
          "Suboficial Segundo",
          "Cabo Principal",
          "Cabo Primero",
          "Cabo Segundo",
          "Marinero de Primera",
          "Marinero de Segunda"
        ],
        "space_force_rank": ""
      },
      "name": {
        "female_first_name": [
          "Abigail",
          "Abril",
          "Adela",
          "Adriana",
          "Agostina",
          "Agustina",
          "Alejandra",
          "Alfonsina",
          "Alicia",
          "Alma",
          "Amalia",
          "Amanda",
          "Ana",
          "Ana María",
          "Analía",
          "Andrea",
          "Angélica",
          "Antonella",
          "Ayelén",
          "Azul",
          "Bárbara",
          "Beatríz",
          "Belén",
          "Bianca",
          "Briana",
          "Brisa",
          "Camila",
          "Candela",
          "Carmela",
          "Carmen",
          "Carolina",
          "Catalina",
          "Cecilia",
          "Celeste",
          "Chiara",
          "Clara",
          "Claudia",
          "Clotilde",
          "Constanza",
          "Daiana",
          "Daniela",
          "Delfina",
          "Dolores",
          "Dora",
          "Elizabeth",
          "Elsa",
          "Elvira",
          "Emma",
          "Ernestina",
          "Estefanía",
          "Estela",
          "Esther",
          "Eva",
          "Fabiana",
          "Faustina",
          "Felicitas",
          "Fernanda",
          "Fiorella",
          "Flora",
          "Florencia",
          "Francesca",
          "Gabriela",
          "Gisela",
          "Giselle",
          "Giuliana",
          "Gladys",
          "Gloria",
          "Graciela",
          "Guadalupe",
          "Guillermina",
          "Haydée",
          "Helena",
          "Inés",
          "Irene",
          "Isabel",
          "Isabella",
          "Jazmín",
          "Jimena",
          "Josefina",
          "Juana",
          "Julia",
          "Julieta",
          "Justina",
          "Karen",
          "Karina",
          "Lara",
          "Laura",
          "Liliana",
          "Lorena",
          "Lourdes",
          "Luana",
          "Lucía",
          "Luciana",
          "Lucrecia",
          "Ludmila",
          "Luisina",
          "Luján",
          "Macarena",
          "Magalí",
          "Magdalena",
          "Maia",
          "Maite",
          "Maitena",
          "Malena",
          "Marcela",
          "Margarita",
          "María",
          "María Belén",
          "María Cristina",
          "María de los Ángeles",
          "María del Carmen",
          "María del Rosario",
          "María Dolores",
          "María Elena",
          "María Elisa",
          "María Emilia",
          "María Eugenia",
          "María Fabiana",
          "María Fernanda",
          "María Inés",
          "María Isabel",
          "María José",
          "María Laura",
          "María Luisa",
          "María Luz",
          "María Magdalena",
          "María Marta",
          "María Mercedes",
          "María Paula",
          "María Paz",
          "María Pilar",
          "María Rosa",
          "María Sol",
          "María Victoria",
          "María Yolanda",
          "Mariana",
          "Marianela",
          "Marina",
          "Marta",
          "Martina",
          "Matilde",
          "Mayra",
          "Melina",
          "Mercedes",
          "Mia",
          "Micaela",
          "Milagros",
          "Mirta",
          "Mónica",
          "Morena",
          "Nadia",
          "Nahiara",
          "Natalia",
          "Nazarena",
          "Nélida",
          "Nelly",
          "Nicole",
          "Noelia",
          "Noemí",
          "Norma",
          "Olivia",
          "Oriana",
          "Paloma",
          "Pamela",
          "Paola",
          "Patricia",
          "Paula",
          "Paulina",
          "Pia",
          "Pilar",
          "Priscila",
          "Raquel",
          "Regina",
          "Renata",
          "Rita",
          "Rocío",
          "Romina",
          "Rosa",
          "Sabrina",
          "Sandra",
          "Sara",
          "Silvia",
          "Simona",
          "Sofía",
          "Soledad",
          "Stella Maris",
          "Susana",
          "Teresa",
          "Trinidad",
          "Uma",
          "Valentina",
          "Valeria",
          "Vanesa",
          "Verónica",
          "Victoria",
          "Vilma",
          "Violeta",
          "Virginia",
          "Ximena",
          "Xiomara",
          "Yamila",
          "Yanina",
          "Zoe"
        ],
        "female_suffix": [
          "madre",
          "hija",
          "segunda"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Acevedo",
          "Acosta",
          "Acuña",
          "Agüero",
          "Aguilar",
          "Aguilera",
          "Aguirre",
          "Alarcón",
          "Albornoz",
          "Alegre",
          "Almirón",
          "Alonso",
          "Altamirano",
          "Álvarez",
          "Andrada",
          "Aquino",
          "Aranda",
          "Arce",
          "Arias",
          "Avalos",
          "Ávila",
          "Ayala",
          "Báez",
          "Barbieri",
          "Barrera",
          "Barrionuevo",
          "Barrios",
          "Bazán",
          "Benítez",
          "Bianchi",
          "Bianco",
          "Blanco",
          "Bravo",
          "Brizuela",
          "Bruno",
          "Burgos",
          "Bustamante",
          "Bustos",
          "Caballero",
          "Cabral",
          "Cabrera",
          "Cáceres",
          "Calderón",
          "Campos",
          "Carabajal",
          "Cardozo",
          "Carrizo",
          "Caruso",
          "Castillo",
          "Castro",
          "Cattaneo",
          "Ceballos",
          "Cejas",
          "Chávez",
          "Colombo",
          "Conti",
          "Contreras",
          "Coppola",
          "Córdoba",
          "Coria",
          "Coronel",
          "Correa",
          "Cortéz",
          "Costa",
          "Cruz",
          "Cuello",
          "D'Angelo",
          "Dalla",
          "Delgado",
          "Díaz",
          "Domínguez",
          "Duarte",
          "Escobar",
          "Espíndola",
          "Esposito",
          "Fabbri",
          "Farías",
          "Fernández",
          "Ferrara",
          "Ferrari",
          "Ferraro",
          "Ferreyra",
          "Ferri",
          "Figueroa",
          "Flores",
          "Fontana",
          "Franco",
          "Frías",
          "Fuentes",
          "Funes",
          "Galarza",
          "Gallardo",
          "Galli",
          "Gallo",
          "Galván",
          "Garay",
          "García",
          "Gatti",
          "Gauna",
          "Gentile",
          "Gil",
          "Giménez",
          "Giordano",
          "Godoy",
          "Gómez",
          "González",
          "Grasso",
          "Greco",
          "Guerrero",
          "Gutiérrez",
          "Guzmán",
          "Heredia",
          "Hernández",
          "Herrera",
          "Ibáñez",
          "Ibarra",
          "Jara",
          "Jiménez",
          "Juárez",
          "Ledesma",
          "Leguizamón",
          "Leiva",
          "Leone",
          "Lescano",
          "Lezcano",
          "Lombardi",
          "Lombardo",
          "Longo",
          "López",
          "Lucero",
          "Luna",
          "Maciel",
          "Maidana",
          "Maldonado",
          "Mamani",
          "Mancini",
          "Mansilla",
          "Marchetti",
          "Mariani",
          "Marini",
          "Marino",
          "Márquez",
          "Martín",
          "Martinelli",
          "Martínez",
          "Martini",
          "Medina",
          "Méndez",
          "Mendoza",
          "Mercado",
          "Messina",
          "Meza",
          "Miño",
          "Miranda",
          "Molina",
          "Montenegro",
          "Monti",
          "Monzón",
          "Morales",
          "Moreno",
          "Moretti",
          "Moyano",
          "Muñoz",
          "Navarro",
          "Nieto",
          "Nieva",
          "Núñez",
          "Ocampo",
          "Ojeda",
          "Oliva",
          "Olivera",
          "Orellana",
          "Ortega",
          "Ortiz",
          "Oviedo",
          "Pacheco",
          "Páez",
          "Palacios",
          "Palavecino",
          "Paredes",
          "Paz",
          "Pellegrini",
          "Peralta",
          "Pereira",
          "Pereyra",
          "Pérez",
          "Ponce",
          "Quintana",
          "Quinteros",
          "Quiroga",
          "Ramírez",
          "Ramos",
          "Reyes",
          "Reynoso",
          "Ricci",
          "Rinaldi",
          "Ríos",
          "Rivas",
          "Rivero",
          "Rizzo",
          "Robledo",
          "Robles",
          "Rodríguez",
          "Rojas",
          "Roldán",
          "Romano",
          "Romero",
          "Rosales",
          "Rossi",
          "Ruiz",
          "Russo",
          "Sala",
          "Salas",
          "Salinas",
          "Sánchez",
          "Sandoval",
          "Santillán",
          "Santoro",
          "Segovia",
          "Serra",
          "Silva",
          "Soria",
          "Sosa",
          "Sotelo",
          "Soto",
          "Suárez",
          "Tapia",
          "Testa",
          "Toledo",
          "Torres",
          "Valdéz",
          "Valenzuela",
          "Vallejos",
          "Varela",
          "Vargas",
          "Vázquez",
          "Vega",
          "Velázquez",
          "Vera",
          "Vergara",
          "Verón",
          "Villa",
          "Villalba",
          "Villarreal",
          "Villegas",
          "Vitale",
          "Zalazar",
          "Zapata",
          "Zárate"
        ],
        "male_first_name": [
          "Aaron",
          "Adalberto",
          "Adolfo",
          "Adrián",
          "Agustín",
          "Alan",
          "Alberto",
          "Alejandro",
          "Alejo",
          "Alfredo",
          "Álvaro",
          "Amadeo",
          "Andrés",
          "Ángel",
          "Antonio",
          "Ariel",
          "Armando",
          "Arnaldo",
          "Arturo",
          "Augusto",
          "Baltazar",
          "Bastian",
          "Bautista",
          "Benicio",
          "Benjamín",
          "Bernardo",
          "Brian",
          "Bruno",
          "Camilo",
          "Carlos",
          "César",
          "Ciro",
          "Cristian",
          "Damián",
          "Daniel",
          "Dante",
          "Darío",
          "David",
          "Diego",
          "Diego Armando",
          "Domingo",
          "Donato",
          "Dylan",
          "Eduardo",
          "Elías",
          "Eliseo",
          "Emanuel",
          "Emiliano",
          "Emilio",
          "Enrique",
          "Enzo",
          "Eric",
          "Ernesto",
          "Esteban",
          "Ezequiel",
          "Fabián",
          "Facundo",
          "Fausto",
          "Federico",
          "Felipe",
          "Félix",
          "Fermín",
          "Fernando",
          "Francisco",
          "Franco",
          "Gabriel",
          "Gael",
          "Gaspar",
          "Gastón",
          "Genaro",
          "Gerardo",
          "Germán",
          "Gerónimo",
          "Gianluca",
          "Gino",
          "Giovanni",
          "Gonzalo",
          "Gregorio",
          "Guido",
          "Guillermo",
          "Gustavo",
          "Héctor",
          "Hernán",
          "Hugo",
          "Humberto",
          "Ian",
          "Ignacio",
          "Iñaki",
          "Iván",
          "Javier",
          "Jeremías",
          "Joaquín",
          "Jonathan",
          "Jorge",
          "Jorge Luis",
          "José",
          "José Antonio",
          "José Ignacio",
          "José Luis",
          "José María",
          "José Oscar",
          "Juan",
          "Juan Alberto",
          "Juan Antonio",
          "Juan Bautista",
          "Juan Carlos",
          "Juan Cruz",
          "Juan David",
          "Juan de Dios",
          "Juan Domingo",
          "Juan Francisco",
          "Juan Franco",
          "Juan Gabriel",
          "Juan Ignacio",
          "Juan José",
          "Juan Manuel",
          "Juan Martín",
          "Juan Pablo",
          "Juan Román",
          "Julián",
          "Julio",
          "Julio Argentino",
          "Julio César",
          "Kevin",
          "Laureano",
          "Lautaro",
          "Leandro",
          "León",
          "Leonardo",
          "Leonel",
          "Lionel",
          "Lorenzo",
          "Luca",
          "Lucas",
          "Luciano",
          "Lucio",
          "Luis",
          "Luis Alberto",
          "Luis Miguel",
          "Manuel",
          "Marcelo",
          "Marco Antonio",
          "Marcos",
          "Mariano",
          "Mario",
          "Martín",
          "Mateo",
          "Matías",
          "Mauricio",
          "Maximiliano",
          "Máximo",
          "Miguel",
          "Miguel Ángel",
          "Mirko",
          "Nahuel",
          "Nazareno",
          "Néstor",
          "Nicolás",
          "Omar",
          "Oscar",
          "Osvaldo",
          "Pablo",
          "Patricio",
          "Pedro",
          "Rafael",
          "Ramiro",
          "Ramón",
          "Raúl",
          "Reinaldo",
          "Renato",
          "René",
          "Renzo",
          "Ricardo",
          "Roberto",
          "Rodolfo",
          "Rodrigo",
          "Rolando",
          "Román",
          "Rubén",
          "Salvador",
          "Santiago",
          "Santino",
          "Sebastián",
          "Sergio",
          "Simón",
          "Sixto",
          "Stéfano",
          "Tahiel",
          "Teodoro",
          "Theo",
          "Thiago",
          "Tiziano",
          "Tobías",
          "Tomás",
          "Ulises",
          "Uriel",
          "Valentín",
          "Valentino",
          "Vicente",
          "Víctor",
          "Víctor Hugo",
          "Víctor Manuel",
          "Walter"
        ],
        "male_suffix": [
          "padre",
          "hijo",
          "segundo"
        ],
        "name": [
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{female_first_name} #{female_first_name} #{last_name}",
          "#{male_first_name} #{male_first_name} #{last_name}"
        ],
        "neutral_first_name": "",
        "prefix": [
          "Sr.",
          "Sra.",
          "Dr.",
          "Dra.",
          "Ing."
        ],
        "suffix": [
          "Jr.",
          "I",
          "II",
          "III",
          "IV",
          "V"
        ]
      },
      "nation": {
        "capital_city": [
          "Abiyán",
          "Abu Dabi",
          "Abuya",
          "Acra",
          "Adamstown",
          "Adís Abeba",
          "Agaña",
          "Alofi",
          "Amán",
          "Ámsterdam",
          "Andorra la Vieja",
          "Ankara",
          "Antananarivo",
          "Apia",
          "Argel",
          "Asjabad",
          "Asmara",
          "Asunción",
          "Atafu",
          "Atenas",
          "Avarua",
          "Bagdad",
          "Bakú",
          "Bamako",
          "Bandar Seri Begawan",
          "Bangkok",
          "Bangui",
          "Banjul",
          "Basseterre",
          "Beirut",
          "Belgrado",
          "Belmopán",
          "Berlín",
          "Berna",
          "Bisau",
          "Biskek",
          "Bogotá",
          "Brades",
          "Brasilia",
          "Bratislava",
          "Brazzaville",
          "Bridgetown",
          "Bruselas",
          "Bucarest",
          "Budapest",
          "Buenos Aires",
          "Buyumbura",
          "Canberra",
          "Caracas",
          "Castries",
          "Charlotte Amalie",
          "Chisinau",
          "Ciudad de Guatemala",
          "Ciudad de Kuwait",
          "Ciudad de México",
          "Ciudad de San Marino",
          "Ciudad del Vaticano",
          "Cockburn Town",
          "Colombo",
          "Conakri",
          "Copenhague",
          "Daca",
          "Dakar",
          "Damasco",
          "Dili",
          "Dodoma",
          "Doha",
          "Donetsk",
          "Douglas",
          "Dublín",
          "Dusambé",
          "El Aaiún",
          "El Cairo",
          "El Valle",
          "Ereván",
          "Estocolmo",
          "Flying Fish Cove",
          "Freetown",
          "Funafuti",
          "Gaborone",
          "Gaza",
          "George Town",
          "Georgetown",
          "Gibraltar",
          "Gustavia",
          "Hamilton",
          "Hanói",
          "Harare",
          "Hargeisa",
          "Helsinki",
          "Hong Kong",
          "Honiara",
          "Islamabad",
          "Jamestown",
          "Jartum",
          "Jerusalén",
          "Kabul",
          "Kampala",
          "Katmandú",
          "Kiev",
          "Kigali",
          "Kingston",
          "Kingstown",
          "Kinsasa",
          "Kuala Lumpur",
          "La Habana",
          "La Paz",
          "La Valeta",
          "Libreville",
          "Lilongüe",
          "Lima",
          "Lisboa",
          "Liubliana",
          "Lobamba",
          "Lomé",
          "Londres",
          "Longyearbyen",
          "Luanda",
          "Lusaka",
          "Luxemburgo",
          "Macao",
          "Madrid",
          "Majuro",
          "Malabo",
          "Malé",
          "Managua",
          "Manama",
          "Manila",
          "Maputo",
          "Marigot",
          "Mascate",
          "Maseru",
          "Mata-Utu",
          "Melekeok",
          "Minsk",
          "Mogadiscio",
          "Mónaco",
          "Monrovia",
          "Montevideo",
          "Moroni",
          "Moscú",
          "Naipyidó",
          "Nairobi",
          "Nasáu",
          "Niamey",
          "Nicosia",
          "Nom Pen",
          "Nuakchot",
          "Nueva Delhi",
          "Nukualofa",
          "Numea",
          "Nur-Sultán",
          "Nuuk",
          "Oranjestad",
          "Oslo",
          "Ottawa",
          "Pago Pago",
          "Palikir",
          "Panamá",
          "Papeete",
          "Paramaribo",
          "París",
          "Pekín",
          "Pionyang",
          "Podgorica",
          "Port Louis",
          "Port Moresby",
          "Port Vila",
          "Porto Novo",
          "Praga",
          "Praia",
          "Pretoria",
          "Pristina",
          "Puerto Argentino",
          "Puerto España",
          "Puerto Príncipe",
          "Quito",
          "Rabat",
          "Reikiavik",
          "Riad",
          "Riga",
          "Road Town",
          "Roma",
          "Roseau",
          "Saint George's",
          "Saint Helier",
          "Saint John",
          "Saint Peter Port",
          "Saipán",
          "San José",
          "San Juan",
          "San Pedro",
          "San Salvador",
          "Saná",
          "Santiago de Chile",
          "Santo Domingo",
          "Santo Tomé",
          "Sarajevo",
          "Seúl",
          "Singapur",
          "Skopie",
          "Sofía",
          "Suva",
          "Taipéi",
          "Tallin",
          "Tarawa",
          "Taskent",
          "Tegucigalpa",
          "Teherán",
          "Tiflis",
          "Timbu",
          "Tirana",
          "Tiráspol",
          "Tokio",
          "Tórshavn",
          "Trípoli",
          "Tsjinval",
          "Túnez",
          "Uagadugú",
          "Ulán Bator",
          "Vaduz",
          "Varsovia",
          "Victoria",
          "Viena",
          "Vientián",
          "Vilna",
          "Washington DC.",
          "Wellington",
          "West Island",
          "Willemstad",
          "Windhoek",
          "Yakarta",
          "Yamena",
          "Yaren",
          "Yaundé",
          "Yibuti",
          "Yuba",
          "Zagreb"
        ],
        "language": [
          "Alemán​",
          "Amárico​",
          "Árabe",
          "Árabe egipcio​",
          "Aragonés",
          "Asturleonés",
          "Bengalí",
          "Bhoshpuri​",
          "Canarés​",
          "Catalán",
          "Chino cantonés​",
          "Chino mandarín",
          "Chino Mǐn Nán​",
          "Chino Wu​",
          "Coreano​",
          "Castellano",
          "Euskera/Vasco",
          "Francés",
          "Gallego",
          "Guyarati​",
          "Hausa​",
          "Hindi",
          "Indonesio​",
          "Inglés",
          "Italiano​",
          "Japonés​",
          "Javanés​",
          "Maratí​",
          "Occitano-Aranés",
          "Panyabí occidental​",
          "Persa iraní​",
          "Portugués",
          "Ruso",
          "Suajili​",
          "Tailandés​",
          "Tamil​",
          "Telugú​",
          "Turco​",
          "Urdu​",
          "Valenciano",
          "Vietnamita​"
        ],
        "nationality": [
          "afgano",
          "albanés",
          "alemán",
          "andorrano",
          "angoleño",
          "anguilense",
          "antiguano",
          "saudí",
          "argelino",
          "argentino",
          "armenio",
          "arubeño",
          "australiano",
          "austriaco",
          "azerbaiyano",
          "bahameño",
          "bangladesí",
          "barbadense",
          "bareiní",
          "belga",
          "beliceño",
          "beninés",
          "bermudeño",
          "bielorruso",
          "birmano",
          "boliviano",
          "bosnio",
          "botsuano",
          "brasileño",
          "bruneano",
          "búlgaro",
          "burkinés",
          "burundés",
          "butanés",
          "caboverdiano",
          "camboyano",
          "camerunés",
          "canadiense",
          "catarí",
          "chadiano",
          "chileno",
          "chino",
          "chipriota",
          "vaticano",
          "colombiano",
          "comorense",
          "norcoreano",
          "surcoreano",
          "marfileño",
          "costarricense",
          "croata",
          "cubano",
          "curazoleño",
          "danés",
          "dominiqués",
          "ecuatoriano",
          "egipcio",
          "salvadoreño",
          "emiratí",
          "eritreo",
          "eslovaco",
          "esloveno",
          "español",
          "micronesio",
          "estadounidense",
          "estonio",
          "etíope",
          "filipino",
          "finlandés",
          "fiyiano",
          "francés",
          "gabonés",
          "gambiano",
          "georgiano",
          "ghanés",
          "gibraltareño",
          "granadino",
          "griego",
          "groenlandés",
          "guameño",
          "guatemalteco",
          "guerneseyés",
          "guineano",
          "guineano",
          "guineano",
          "guyanés",
          "haitiano",
          "hondureño",
          "hongkonés",
          "húngaro",
          "indio",
          "indonesio",
          "iraquí",
          "iraní",
          "irlandés",
          "manés",
          "navideño",
          "norfolkense",
          "islandés",
          "caimanés",
          "cocano",
          "cookiano",
          "feroés",
          "malvinense",
          "chamorro",
          "marshalés",
          "pitcairnés",
          "salomonense",
          "turcocaiqueño",
          "virgenense británico",
          "virgenense estadounidense",
          "israelí",
          "italiano",
          "jamaicano",
          "japonés",
          "jerseyés",
          "jordano",
          "kazajo",
          "keniano",
          "kirguís",
          "kiribatiano",
          "kosovar",
          "kuwaití",
          "laosiano",
          "lesotense",
          "letón",
          "libanés",
          "liberiano",
          "libio",
          "liechtensteiniano",
          "lituano",
          "luxemburgués",
          "macaense",
          "macedonio",
          "malgache",
          "malasio",
          "malauí",
          "maldivo",
          "maliense",
          "maltés",
          "marroquí",
          "mauriciano",
          "mauritano",
          "mexicano",
          "moldavo",
          "monegasco",
          "mongol",
          "montenegrino",
          "monserratino",
          "mozambiqueño",
          "namibio",
          "nauruano",
          "nepalés",
          "nicaragüense",
          "nigerino",
          "nigeriano",
          "niueño",
          "noruego",
          "neocaledonio",
          "neocelandés",
          "omaní",
          "surosetio",
          "holandés",
          "pakistaní",
          "palauano",
          "palestino",
          "panameño",
          "papuano",
          "paraguayo",
          "peruano",
          "francopolinesio",
          "polaco",
          "portugués",
          "puertorriqueño",
          "británico",
          "centroafricano",
          "checo",
          "taiwanés",
          "congoleño",
          "congoleño",
          "dominicano",
          "ruandés",
          "rumano",
          "ruso",
          "saharaui",
          "samoano",
          "samoamericano",
          "sanbartolomeano",
          "sancristobaleño",
          "sanmarinense",
          "sanmartitense",
          "sanpedrino",
          "sanvicentino",
          "santaheleno",
          "santalucense",
          "santotomense",
          "senegalés",
          "serbio",
          "seychellense",
          "sierraleonés",
          "singapurense",
          "sirio",
          "somalí",
          "somalilandés",
          "ceilanés",
          "suazi",
          "sudafricano",
          "sudanés",
          "sursudanés",
          "sueco",
          "suizo",
          "surinamés",
          "svalbarense",
          "tailandés",
          "tanzano",
          "tayiko",
          "timorense",
          "togolés",
          "tokelauense",
          "tongano",
          "transnistrio",
          "trinitense",
          "tunecino",
          "turcomano",
          "turco",
          "tuvaluano",
          "ucraniano",
          "ugandés",
          "uruguayo",
          "uzbeko",
          "vanuatuense",
          "venezolano",
          "vietnamita",
          "walisiano",
          "yemení",
          "yibutiano",
          "zambiano",
          "zimbabuense"
        ]
      },
      "phone_number": {
        "country_code": [
          "54"
        ],
        "formats": [
          "(011) 4### ####",
          "(02##) 4##-####",
          "(03##) 4##-####",
          "(02###) 4#####",
          "(03###) 4#####",
          "(011) 5### ####",
          "(02##) 5##-####",
          "(03##) 5##-####",
          "(02###) 5#####",
          "(03###) 5#####",
          "(011) 6### ####"
        ]
      },
      "team": {
        "name": [
          "#{team_prefix} #{Address.city}",
          "#{Address.city} #{team_suffix}"
        ],
        "sport": [
          "fútbol",
          "basquet",
          "vóley",
          "handball",
          "ténis",
          "paddle",
          "rugby",
          "ping-pong",
          "waterpolo",
          "hockey",
          "truco"
        ],
        "team_prefix": [
          "25 de Mayo de",
          "9 de Julio de",
          "A.A.",
          "Argentino de",
          "Asociación Atlética",
          "Atenas de",
          "Atlético",
          "Belgrano de",
          "C.A.",
          "Club Atlético",
          "Comunicaciones",
          "Defensores de",
          "Deportivo",
          "Estudiantes de",
          "Gimnasia de",
          "Gimnasia y Esgrima de",
          "Independiente de",
          "Libertad de",
          "Luz y Fuerza de",
          "Mitre de",
          "Olímpico de",
          "Peñarol de",
          "Quilmes de",
          "Rivadavia de",
          "San Martín",
          "San Martín de",
          "Sportivo",
          "Unión de"
        ],
        "team_suffix": [
          "FC.",
          "Fútbol Club",
          "Athletic Club",
          "A.C.",
          "Tennis Club",
          "Rugby Club",
          "Basket"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor selecciona"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-CL": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Confirmación enviada el",
          "confirmation_token": "Token de confirmación",
          "confirmed_at": "Fecha de confirmación",
          "created_at": "Fecha de creación",
          "current_password": "Contraseña actual",
          "current_sign_in_at": "Inicio de sesión en",
          "current_sign_in_ip": "IP del ingreso actual",
          "email": "Correo electrónico",
          "encrypted_password": "Contraseña encriptada",
          "failed_attempts": "Intentos fallidos",
          "last_sign_in_at": "Fecha del último ingreso",
          "last_sign_in_ip": "IP del último ingreso",
          "locked_at": "Fecha de bloqueo",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "remember_created_at": "Fecha de 'Recordarme'",
          "remember_me": "Recordarme",
          "reset_password_sent_at": "Fecha de envío de token para contraseña",
          "reset_password_token": "Token para restablecer contraseña",
          "sign_in_count": "Cantidad de ingresos",
          "unconfirmed_email": "Correo electrónico no confirmado",
          "unlock_token": "Autentificador de desbloqueo",
          "updated_at": "Fecha de actualización"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      },
      "models": {
        "user": {
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "alrededor de %{count} hora",
          "other": "alrededor de %{count} horas"
        },
        "about_x_months": {
          "one": "alrededor de %{count} mes",
          "other": "alrededor de %{count} meses"
        },
        "about_x_years": {
          "one": "alrededor de %{count} año",
          "other": "alrededor de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Se ha confirmado la dirección de correo electrónico.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        },
        "send_instructions": "En unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, en unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta."
      },
      "failure": {
        "already_authenticated": "Ya has iniciado sesión.",
        "inactive": "Tu cuenta aún no ha sido activada.",
        "invalid": "%{authentication_keys} o password inválido(s)",
        "last_attempt": "Tienes un intento más antes de que tu cuenta se bloquee.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} o contraseña inválida(s)",
        "timeout": "Tu sesión expiró. Por favor, vuelve a iniciar sesión.",
        "unauthenticated": "Tienes que iniciar sesión o registrarte.",
        "unconfirmed": "Tienes que confirmar tu cuenta para poder continuar."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Te damos la bienvenida, %{recipient}!",
          "instruction": "Se puede confirmar el correo electrónico de la cuenta a través de este enlace:",
          "subject": "Instrucciones de confirmación"
        },
        "email_changed": {
          "greeting": "Hola %{recipient}!",
          "message": "Te estamos contactando para notificarte que tu correo ha cambiado a %{email}",
          "message_unconfirmed": "Te estamos contactando para notificarte que tu dirección de correo electrónico ha cambiado a %{email}",
          "subject": "Cambio de correo electrónico"
        },
        "password_change": {
          "greeting": "¡Hola %{recipient}!",
          "message": "Lo estamos contactando para notificarte que tu contraseña ha cambiado.",
          "subject": "Contraseña cambiada"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola, %{recipient}!",
          "instruction": "Alguien ha solicitado un enlace para cambiar tu contraseña, lo que se puede realizar a través del siguiente enlace.",
          "instruction_2": "Si no lo has solicitado, por favor ignora este mensaje.",
          "instruction_3": "Tu contraseña no será cambiada hasta que accedas al enlace y cree una nueva contraseña.",
          "subject": "Instrucciones de recuperación de contraseña"
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola, %{recipient}!",
          "instruction": "Haz clic en el siguiente enlace para desbloquear tu cuenta:",
          "message": "Bloqueamos tu debido a una cantidad excesiva de intentos fallidos para ingresar.",
          "subject": "Instrucciones para desbloquear tu cuenta"
        }
      },
      "omniauth_callbacks": {
        "failure": "No has sido autorizado en la cuenta %{kind} porque \"%{reason}\".",
        "success": "Has sido autorizado desde la cuenta de %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie tu contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Contraseña nueva"
        },
        "new": {
          "forgot_your_password": "¿Has olvidado tu contraseña?",
          "send_me_reset_password_instructions": null
        },
        "no_token": "No puedes acceder a esta página si no es a través de un enlace para restablecer tu contraseña. Si has llegado hasta aquí desde el correo para restablecer tu contraseña, por favor asegúrate de que la URL introducida está completa.",
        "send_instructions": "En unos minutos recibirás un correo con instrucciones sobre cómo restablecer tu contraseña.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, recibirás en tu bandeja de entrada un correo con instrucciones sobre cómo restablecer tu contraseña.",
        "updated": "Tu contraseña ha sido cambiada. Ya puedes iniciar sesión.",
        "updated_not_active": "Tu contraseña ha sido cambiada."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada. Esperamos verte pronto.",
        "edit": {
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Eliminar mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmación de: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarlo",
          "title": "Editar %{resource}",
          "unhappy": "No se encuentra feliz",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos tu contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Crear cuenta"
        },
        "signed_up": "Bienvenida/o. Tu cuenta ha sido creada.",
        "signed_up_but_inactive": "Tu cuenta ha sido creada. Sin embargo, no puedes iniciar sesión ya que tu cuenta aún no ha sido activada.",
        "signed_up_but_locked": "Tu cuenta ha sido creada. Sin embargo, no es posible iniciar la sesión porque que tu cuenta se encuentra bloqueada.",
        "signed_up_but_unconfirmed": "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Ingresa al enlace para activar tu cuenta.",
        "update_needs_confirmation": "Has actualizado tu cuenta, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo e ingresa al enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.",
        "updated": "Tu cuenta ha sido actualizada.",
        "updated_but_not_signed_in": "Tu cuenta ha sido actualizada pero, como tu contraseña cambio, necesitas iniciar sesión nuevamente"
      },
      "sessions": {
        "already_signed_out": "Se ha cerrado la sesión con éxito.",
        "new": {
          "sign_in": "Iniciar sesión"
        },
        "signed_in": "Sesión iniciada.",
        "signed_out": "Sesión finalizada."
      },
      "shared": {
        "links": {
          "back": "Regresar",
          "didn_t_receive_confirmation_instructions": "¿No has recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No has recibido instrucciones para desbloquear tu cuenta?",
          "forgot_your_password": "¿Olvidaste tu contraseña?",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear la cuenta"
        },
        "send_instructions": "En unos minutos recibirás instrucciones para desbloquear tu cuenta.",
        "send_paranoid_instructions": "Si tu cuenta existe, en unos minutos recibirás instrucciones para desbloquear tu cuenta.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "already_confirmed": "ya fue confirmada, por favor intenta iniciar sesión",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "confirmation_period_expired": "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser par",
        "exclusion": "está reservado",
        "expired": "ha expirado; por favor solicita una nueva",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "not_found": "no se encontró",
        "not_locked": "no se encuentra bloqueada",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "debe ser impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya está en uso",
        "too_long": {
          "one": "es demasiado largo (%{count} carácter máximo)",
          "other": "es demasiado largo (%{count} caracteres máximo)"
        },
        "too_short": {
          "one": "es demasiado corto (%{count} carácter mínimo)",
          "other": "es demasiado corto (%{count} caracteres mínimo)"
        },
        "wrong_length": {
          "one": "no tiene la longitud correcta (%{count} carácter exacto)",
          "other": "no tiene la longitud correcta (%{count} caracteres exactos)"
        }
      },
      "template": {
        "body": "Se encontraron problemas con los siguientes campos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró %{count} error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u %n",
          "precision": 0,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %d de %B de %Y %H:%M:%S %z",
        "long": "%A %d de %B de %Y %H:%M",
        "short": "%d de %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "es-CO": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Confirmación enviada a",
          "confirmation_token": "Código de confirmación\n",
          "confirmed_at": "Confirmado en",
          "created_at": "Creado en",
          "current_password": "Contraseña actual",
          "current_sign_in_at": "Inicia sesión en",
          "current_sign_in_ip": "IP del ingreso actual",
          "email": "Correo electrónico",
          "encrypted_password": "Contraseña encriptada",
          "failed_attempts": "Intentos fallidos",
          "last_sign_in_at": "Fecha del último ingreso",
          "last_sign_in_ip": "IP del último ingreso",
          "locked_at": "Fecha de bloqueo",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "remember_created_at": "Fecha de 'Recordarme'",
          "remember_me": "Recordarme",
          "reset_password_sent_at": "Fecha de envío de restablecimiento de contraseña",
          "reset_password_token": "Código para restablecer contraseña",
          "sign_in_count": "Cantidad de ingresos",
          "unconfirmed_email": "Correo electrónico no confirmado",
          "unlock_token": "Código de desbloqueo",
          "updated_at": "Fecha de actualización"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      },
      "models": {
        "user": {
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Tu dirección de correo electrónico se ha confirmado correctamente.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        },
        "send_instructions": "En unos minutos recibirás un correo electrónico con instrucciones sobre cómo confirmar tu correo electrónico.",
        "send_paranoid_instructions": "Si tu correo electrónico ya existe en nuestra base de datos, en unos minutos recibirás un correo electrónico con instrucciones de como confirmar tu correo electrónico."
      },
      "failure": {
        "already_authenticated": "Ya has iniciado sesión.",
        "inactive": "Tu cuenta aún no está activa.",
        "invalid": "%{authentication_keys} o contraseña inválida.",
        "last_attempt": "Tienes un intento más antes de que tu cuenta sea bloqueada.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} o contraseña inválida.",
        "timeout": "Tu sesión ha expirado. Por favor, inicia sesión nuevamente para continuar.",
        "unauthenticated": "Tienes que iniciar sesión o registrarte para poder continuar.",
        "unconfirmed": "Tienes que confirmar tu correo electrónico para poder continuar."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Bienvenido %{recipient}!",
          "instruction": "Puedes confirmar tu correo electrónico a través del siguiente enlace:",
          "subject": "Instrucciones de confirmación"
        },
        "email_changed": {
          "greeting": "Hola %{recipient}!",
          "message": "Te estamos contactando para notificarte que tu correo electrónico a cambiado a %{email}.",
          "message_unconfirmed": "Te estamos contactando para notificarte que tu correo electrónico fue cambiado a %{email}.",
          "subject": "El correo electrónico cambió"
        },
        "password_change": {
          "greeting": "¡Hola %{recipient}!",
          "message": "Te estamos contactando para notificarte que tu contraseña ha sido cambiada.",
          "subject": "Contraseña cambiada"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Alguien ha solicitado un enlace para cambiar tu contraseña. Puedes hacerlo a través del siguiente enlace.",
          "instruction_2": "Si no solicitaste esto, por favor ignora este correo electrónico.",
          "instruction_3": "Tu contraseña no será cambiada hasta que usted acceda al enlace y cree una nueva contraseña.",
          "subject": "Instrucciones de recuperación de contraseña"
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Haz click en el siguiente enlace para desbloquear tu cuenta:",
          "message": "Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos fallidos para iniciar sesión.",
          "subject": "Instrucciones para desbloquear tu cuenta"
        }
      },
      "omniauth_callbacks": {
        "failure": "No has sido autorizado en la cuenta %{kind} porque \"%{reason}\".",
        "success": "Has sido autenticado exitosamente desde la cuenta de %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie su contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Contraseña nueva"
        },
        "new": {
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "send_me_reset_password_instructions": "Enviarme instrucciones para restablecer la contraseña"
        },
        "no_token": "No puedes acceder a esta página si no es a través de un enlace para restablecer tu contraseña. Si has llegado hasta aquí desde el correo para restablecer tu contraseña, por favor asegúrese de que la URL introducida está completa.",
        "send_instructions": "En unos minutos recibirás un correo con instrucciones sobre cómo restablecer tu contraseña.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, recibirás un correo electrónico con instrucciones sobre cómo restablecer tu contraseña.",
        "updated": "Tu contraseña ha sido cambiada exitosamente. Ya puedes iniciar sesión.",
        "updated_not_active": "Tu contraseña ha sido cambiada."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada exitosamente. Esperamos verte pronto.",
        "edit": {
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Eliminar mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmación de: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarlo",
          "title": "Editar %{resource}",
          "unhappy": "No se encuentra feliz",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos su contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        },
        "signed_up": "Bienvenido. Tu cuenta ha sido creada.",
        "signed_up_but_inactive": "Tu cuenta ha sido creada exitosamente. Sin embargo, no puedes iniciar sesión ya que tu cuenta aún no está activada.",
        "signed_up_but_locked": "Tu cuenta ha sido creada correctamente. Sin embargo, no es posible iniciar la sesión porque que tu cuenta se encuentra bloqueada.",
        "signed_up_but_unconfirmed": "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Ingresa al enlace para activar tu cuenta.",
        "update_needs_confirmation": "Has actualizado tu cuenta exitosamente; pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo electrónico e ingresa al enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.",
        "updated": "Tu cuenta ha sido actualizada exitosamente.",
        "updated_but_not_signed_in": "Tu cuenta ha sido actualizada exitosamente; pero, como tu contraseña cambió, necesitas iniciar sesión nuevamente."
      },
      "sessions": {
        "already_signed_out": "Se ha cerrado la sesión con éxito.",
        "new": {
          "sign_in": "Iniciar sesión"
        },
        "signed_in": "Sesión iniciada.",
        "signed_out": "Sesión finalizada."
      },
      "shared": {
        "links": {
          "back": "Regresar",
          "didn_t_receive_confirmation_instructions": "¿No ha recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No ha recibido instrucciones para desbloquear su cuenta?",
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear la cuenta"
        },
        "send_instructions": "En unos minutos recibirás instrucciones para desbloquear tu cuenta.",
        "send_paranoid_instructions": "Si tu cuenta existe, en unos minutos recibirás instrucciones para desbloquear tu cuenta.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "already_confirmed": "ya fue confirmada, por favor intenta iniciar sesión",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "confirmation_period_expired": "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "expired": "ha expirado; por favor solicita una nueva",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "not_found": "no se encontró",
        "not_locked": "no se encuentra bloqueada",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "debe ser un número impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido tomado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor selecciona"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u%n",
          "precision": 0,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-CR": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido utilizado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 0,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "¢"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-EC": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un(a) %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%-d/%m/%Y",
        "long": "%A, %-d de %B de %Y",
        "short": "%-d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número impar",
        "other_than": "debe ser diferente de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya está en uso",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "no tiene la longitud correcta (debe ser de %{count} carácter)",
          "other": "no tiene la longitud correcta (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró %{count} error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %-d de %B de %Y a las %-I:%M:%S %p %Z",
        "long": "%-d de %B de %Y a las %-I:%M %p",
        "short": "%-d %b %-I:%M %p"
      },
      "pm": "pm"
    }
  },
  "es-ES": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "alrededor de %{count} hora",
          "other": "alrededor de %{count} horas"
        },
        "about_x_months": {
          "one": "alrededor de %{count} mes",
          "other": "alrededor de %{count} meses"
        },
        "about_x_years": {
          "one": "alrededor de %{count} año",
          "other": "alrededor de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya está en uso",
        "too_long": {
          "one": "es demasiado largo (%{count} carácter máximo)",
          "other": "es demasiado largo (%{count} caracteres máximo)"
        },
        "too_short": {
          "one": "es demasiado corto (%{count} carácter mínimo)",
          "other": "es demasiado corto (%{count} caracteres mínimo)"
        },
        "wrong_length": {
          "one": "no tiene la longitud correcta (%{count} carácter exactos)",
          "other": "no tiene la longitud correcta (%{count} caracteres exactos)"
        }
      },
      "template": {
        "body": "Se encontraron problemas con los siguientes campos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró %{count} error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %d de %B de %Y %H:%M:%S %z",
        "long": "%d de %B de %Y %H:%M",
        "short": "%d de %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "es-MX": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Fecha de envío de confirmación",
          "confirmation_token": "Autentificador de confirmación",
          "confirmed_at": "Fecha de confirmación",
          "created_at": "Fecha de creación",
          "current_password": "Contraseña actual",
          "current_sign_in_at": "Inicia sesión en",
          "current_sign_in_ip": "IP del ingreso actual",
          "email": "Correo electrónico",
          "encrypted_password": "Contraseña cifrada",
          "failed_attempts": "Intentos fallidos",
          "last_sign_in_at": "Fecha del último ingreso",
          "last_sign_in_ip": "IP del último ingreso",
          "locked_at": "Fecha de bloqueo",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "remember_created_at": "Fecha de 'Recordarme'",
          "remember_me": "Recordarme",
          "reset_password_sent_at": "Fecha de envío de autentificador para contraseña",
          "reset_password_token": "Autentificador para restablecer contraseña",
          "sign_in_count": "Cantidad de ingresos",
          "unconfirmed_email": "Correo electrónico no confirmado",
          "unlock_token": "Autentificador de desbloqueo",
          "updated_at": "Fecha de actualización"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "El registro no puede ser eliminado pues existen %{record} dependientes",
            "has_one": "El registro no puede ser eliminado pues existe un %{record} dependiente"
          }
        }
      },
      "models": {
        "user": {
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Se ha confirmado la dirección de correo electrónico correctamente.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        },
        "send_instructions": "En unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, en unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta."
      },
      "failure": {
        "already_authenticated": "Ya has iniciado sesión.",
        "inactive": "Tu cuenta aún no ha sido activada.",
        "invalid": "%{authentication_keys} o password inválido(s)",
        "last_attempt": "Tienes un intento más antes de que tu cuenta sea bloqueada.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} o password inválido(s)",
        "timeout": "Tu sesión expiró. Por favor, inicia sesión nuevamente para continuar.",
        "unauthenticated": "Tienes que iniciar sesión o registrarte para poder continuar.",
        "unconfirmed": "Tienes que confirmar tu cuenta para poder continuar."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Te damos la bienvenida, %{recipient}!",
          "instruction": "Se puede confirmar el correo electrónico de la cuenta a través de este enlace:",
          "subject": "Instrucciones de confirmación"
        },
        "email_changed": {
          "greeting": "Hola %{recipient}!",
          "message": "Te estamos contactando para notificarte que tu email ha cambiado a %{email}",
          "message_unconfirmed": "Te estamos contactando para notificarte que tu dirección de correo electrónico ha cambiado a %{email}",
          "subject": "El email cambió"
        },
        "password_change": {
          "greeting": "¡Hola %{recipient}!",
          "message": "Lo estamos contactando para notificarle que su contraseña ha cambiado.",
          "subject": "Contraseña cambiada"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola, %{recipient}!",
          "instruction": "Alguien ha solicitado un enlace para cambiar su contraseña, lo que se puede realizar a través del siguiente enlace.",
          "instruction_2": "Si usted no lo ha solicitado, por favor ignore este correo electrónico.",
          "instruction_3": "Su contraseña no será cambiada hasta que usted acceda al enlace y cree una nueva contraseña.",
          "subject": "Instrucciones de recuperación de contraseña"
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola, %{recipient}!",
          "instruction": "Haga clic en el siguiente enlace para desbloquear su cuenta:",
          "message": "Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos fallidos para ingresar.",
          "subject": "Instrucciones para desbloquear tu cuenta"
        }
      },
      "omniauth_callbacks": {
        "failure": "No has sido autorizado en la cuenta %{kind} porque \"%{reason}\".",
        "success": "Has sido autorizado exitosamente desde la cuenta de %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie su contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Contraseña nueva"
        },
        "new": {
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "send_me_reset_password_instructions": "Enviarme instrucciones para restablecer la contraseña"
        },
        "no_token": "No puedes acceder a esta página si no es a través de un enlace para restablecer tu contraseña. Si has llegado hasta aquí desde el correo para restablecer tu contraseña, por favor asegúrate de que la URL introducida está completa.",
        "send_instructions": "En unos minutos recibirás un correo con instrucciones sobre cómo restablecer tu contraseña.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, recibirás en tu bandeja de entrada un correo con instrucciones sobre cómo restablecer tu contraseña.",
        "updated": "Tu contraseña ha sido cambiada exitosamente. Ya puedes iniciar sesión.",
        "updated_not_active": "Tu contraseña ha sido cambiada."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada exitosamente. Esperamos verte pronto.",
        "edit": {
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Eliminar mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmación de: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarlo",
          "title": "Editar %{resource}",
          "unhappy": "No se encuentra feliz",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos su contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        },
        "signed_up": "Bienvenido. Tu cuenta ha sido creada.",
        "signed_up_but_inactive": "Tu cuenta ha sido creada exitosamente. Sin embargo, no puedes iniciar sesión ya que tu cuenta aún no está activada.",
        "signed_up_but_locked": "Tu cuenta ha sido creada correctamente. Sin embargo, no es posible iniciar la sesión porque que tu cuenta se encuentra bloqueada.",
        "signed_up_but_unconfirmed": "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Ingresa al enlace para activar tu cuenta.",
        "update_needs_confirmation": "Has actualizado tu cuenta exitosamente, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo e ingresa al enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.",
        "updated": "Tu cuenta ha sido actualizada exitosamente.",
        "updated_but_not_signed_in": "Tu cuenta ha sido actualizada exitosamente pero, como tu contraseña cambio, necesitas iniciar sesión nuevamente"
      },
      "sessions": {
        "already_signed_out": "Se ha cerrado la sesión con éxito.",
        "new": {
          "sign_in": "Iniciar sesión"
        },
        "signed_in": "Sesión iniciada.",
        "signed_out": "Sesión finalizada."
      },
      "shared": {
        "links": {
          "back": "Regresar",
          "didn_t_receive_confirmation_instructions": "¿No ha recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No ha recibido instrucciones para desbloquear su cuenta?",
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear la cuenta"
        },
        "send_instructions": "En unos minutos recibirás instrucciones para desbloquear tu cuenta.",
        "send_paranoid_instructions": "Si tu cuenta existe, en unos minutos recibirás instrucciones para desbloquear tu cuenta.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "already_confirmed": "ya fue confirmada, por favor intenta iniciar sesión",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "confirmation_period_expired": "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "expired": "ha expirado; por favor solicita una nueva",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "not_found": "no se encontró",
        "not_locked": "no se encuentra bloqueada",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "debe ser un número non",
        "other_than": "debe ser diferente a %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido tomado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "S/N",
          "#",
          "##",
          "###",
          "####",
          "#####"
        ],
        "city": [
          "#{municipality}"
        ],
        "city_prefix": "",
        "city_suffix": "",
        "city_with_state": [
          "#{municipality}, #{state}"
        ],
        "country": [
          "Afganistán",
          "Albania",
          "Alemania",
          "Andorra",
          "Angola",
          "Anguila",
          "Antigua y Barbuda",
          "Antártida",
          "Arabia Saudita",
          "Argelia",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Autoridad Nacional Palestina",
          "Azerbaiyán",
          "Bahamas",
          "Bangladés",
          "Barbados",
          "Baréin",
          "Belice",
          "Benín",
          "Bermudas",
          "Bielorrusia",
          "Birmania",
          "Bolivia",
          "Bonaire",
          "San Eustaquio y Saba",
          "Bosnia y Herzegovina",
          "Botsuana",
          "Brasil",
          "Brunéi",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Bután",
          "Bélgica",
          "Cabo Verde",
          "Camboya",
          "Camerún",
          "Canadá",
          "Chad",
          "Chile",
          "China",
          "Chipre",
          "Ciudad del Vaticano",
          "Colombia",
          "Comoras",
          "Corea del Norte",
          "Corea del Sur",
          "Costa Rica",
          "Costa de Marfil",
          "Croacia",
          "Cuba",
          "Curaçao",
          "Dinamarca",
          "Dominica",
          "Ecuador",
          "Egipto",
          "El Salvador",
          "Emiratos Árabes Unidos",
          "Eritrea",
          "Eslovaquia",
          "Eslovenia",
          "España",
          "Estados Unidos",
          "Estonia",
          "Etiopía",
          "Filipinas",
          "Finlandia",
          "Fiyi",
          "Francia",
          "Gabón",
          "Gambia",
          "Georgia",
          "Ghana",
          "Gibraltar",
          "Granada",
          "Grecia",
          "Groenlandia",
          "Guadalupe",
          "Guam",
          "Guatemala",
          "Guayana Francesa",
          "Guernsey",
          "Guinea",
          "Guinea Ecuatorial",
          "Guinea-Bissau",
          "Guyana",
          "Haití",
          "Honduras",
          "Hong Kong",
          "Hungría",
          "India",
          "Indonesia",
          "Irak",
          "Irlanda",
          "Irán",
          "Isla Bouvet",
          "Isla de Man",
          "Isla de Navidad",
          "Islandia",
          "Islas Caimán",
          "Islas Cocos",
          "Islas Cook",
          "Islas Faroe",
          "Islas Georgias del Sur y Sandwich del Sur",
          "Islas Heard y McDonald",
          "Islas Malvinas",
          "Islas Marianas del Norte",
          "Islas Marshall",
          "Islas Pitcairn",
          "Islas Salomón",
          "Islas Turcas y Caicos",
          "Islas Vírgenes Británicas",
          "Islas Vírgenes de los Estados Unidos",
          "Islas ultramarinas de Estados Unidos",
          "Israel",
          "Italia",
          "Jamaica",
          "Japón",
          "Jersey",
          "Jordania",
          "Kazajistán",
          "Kenia",
          "Kirguistán",
          "Kiribati",
          "Kuwait",
          "Laos",
          "Lesoto",
          "Letonia",
          "Liberia",
          "Libia",
          "Liechtenstein",
          "Lituania",
          "Luxemburgo",
          "Líbano",
          "Macao",
          "Madagascar",
          "Malasia",
          "Malaui",
          "Maldivas",
          "Malta",
          "Malí",
          "Marruecos",
          "Martinica",
          "Mauricio",
          "Mauritania",
          "Mayotte",
          "Micronesia",
          "Moldavia",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Mozambique",
          "México",
          "Mónaco",
          "Namibia",
          "Nauru",
          "Nepal",
          "Nicaragua",
          "Nigeria",
          "Niue",
          "Norfolk",
          "Noruega",
          "Nueva Caledonia",
          "Nueva Zelanda",
          "Níger",
          "Omán",
          "Pakistán",
          "Palaos",
          "Panamá",
          "Papúa Nueva Guinea",
          "Paraguay",
          "Países Bajos",
          "Perú",
          "Polinesia Francesa",
          "Polonia",
          "Portugal",
          "Qatar",
          "Reino Unido",
          "Rep. Dem. del Congo",
          "República Centroafricana",
          "República Checa",
          "República Dominicana",
          "República de Macedonia",
          "República del Congo",
          "Reunión",
          "Ruanda",
          "Rumania",
          "Rusia",
          "Samoa",
          "Samoa Estadounidense",
          "San Bartolomé",
          "San Cristóbal y Nieves",
          "San Marino",
          "San Martín",
          "San Martín (parte holandesa)",
          "San Pedro y Miquelón",
          "San Vicente y las Granadinas",
          "Santa Helena",
          "A. y T.",
          "Santa Lucía",
          "Santo Tomé y Príncipe",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leona",
          "Singapur",
          "Siria",
          "Somalia",
          "Sri Lanka",
          "Suazilandia",
          "Sudáfrica",
          "Sudán",
          "Sudán del Sur",
          "Suecia",
          "Suiza",
          "Surinam",
          "Svalbard y Jan Mayen",
          "Sáhara Occidental",
          "Tailandia",
          "Taiwán",
          "Tanzania",
          "Tayikistán",
          "Territorio Británico del Océano Índico",
          "Territorios Australes Franceses",
          "Timor Oriental",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad y Tobago",
          "Turkmenistán",
          "Turquía",
          "Tuvalu",
          "Túnez",
          "Ucrania",
          "Uganda",
          "Uruguay",
          "Uzbekistán",
          "Vanuatu",
          "Venezuela",
          "Vietnam",
          "Wallis y Futuna",
          "Yemen",
          "Yibuti",
          "Zambia",
          "Zimbabue",
          "Åland"
        ],
        "default_country": [
          "México"
        ],
        "default_country_code": [
          "MX"
        ],
        "municipality": [
          "Abasolo",
          "Acapulco",
          "Actopan",
          "Acuña",
          "Aguascalientes",
          "Ahome",
          "Ahuacatlán",
          "Ahuacuotzingo",
          "Ahuatlan",
          "Alaquines",
          "Altar",
          "Amatlán de Cañas",
          "Angostura",
          "Apan",
          "Apaseo el Alto",
          "Apizaco",
          "Apodaca",
          "Aporo",
          "Aquila",
          "Armería",
          "Arroyo Seco",
          "Arteaga",
          "Asientos",
          "Atenco",
          "Atenguillo",
          "Atolinga",
          "Atzalan",
          "Ayapango",
          "Azcapotzalco",
          "Bacadehuachi",
          "Bacalar",
          "Bacanora",
          "Badiraguato",
          "Benito Juárez",
          "Brise",
          "Buenaventura",
          "Burgos",
          "Bustamante",
          "Cabo Corrientes",
          "Caborca",
          "Calakmul",
          "Calera",
          "Calnali",
          "Calvillo",
          "Camargo",
          "Campeche",
          "Canatlán",
          "Cancún",
          "Candelaria",
          "Cantamayec",
          "Carbo",
          "Carmen",
          "Catorce",
          "Celaya",
          "Centla",
          "Centro",
          "Cerritos",
          "Chalchihuites",
          "Champotón",
          "Chanal",
          "Chapulhuacán",
          "Chapultepec",
          "Chavinda",
          "Chiautempan",
          "Chichiquila",
          "Chicoasen",
          "Chietla",
          "Chihuahua",
          "Chimalhuacán",
          "Choix",
          "Citlaltepetl",
          "Ciudad Madero",
          "Ciudad Valles",
          "Coatzacoalcos",
          "Cocula",
          "Colima",
          "Comala",
          "Comondú",
          "Comonfort",
          "Compostela",
          "Copainala",
          "Copalillo",
          "Copanatoyac",
          "Coquimatlán",
          "Coronango",
          "Cosio",
          "Coyame del Sotol",
          "Coyoacán",
          "Cozumel",
          "Cualac",
          "Cuatro Ciénegas",
          "Cuauhtémoc",
          "Cucurpe",
          "Cuencame",
          "Cuernavaca",
          "Culiacán",
          "Cunduacán",
          "Cárdenas",
          "Doctor Mora",
          "Durango",
          "Dzidzantun",
          "Ecatepec",
          "El Fuerte",
          "El Llano",
          "El Mante",
          "El Marqués",
          "El Naranjo",
          "El Salvador",
          "Emiliano Zapata",
          "Ensenada",
          "Epazoyucan",
          "Epitacio Huerta",
          "Erongaricuaro",
          "Escarcega",
          "Esperanza",
          "Ezequiel Montes",
          "Galeana",
          "Genaro Codina",
          "General Escobedo",
          "González",
          "Gral. Zaragoza",
          "Guachochi",
          "Guadalajara",
          "Guadalupe",
          "Guanacevi",
          "Guerrero",
          "Gómez Palacio",
          "Hecelchakan",
          "Hermosillo",
          "Hocaba",
          "Hopelchen",
          "Huajicori",
          "Hualahuises",
          "Huanimaro",
          "Huayacocotla",
          "Huejucar",
          "Hueyotlipan",
          "Huimilpan",
          "Huixquilucan",
          "Hunucma",
          "Iliatenco",
          "Inde",
          "Irapuato",
          "Irimbo",
          "Isla Mujeres",
          "Ixil",
          "Ixtapaluca",
          "Ixtlahuacán",
          "Ixtlan de Juárez",
          "Ixtlán del Río",
          "Iztacalco",
          "Jalpa de Méndez",
          "Jalpan de Serra",
          "Jamapa",
          "Jesús María",
          "Jiutepec",
          "Jonuta",
          "Juárez",
          "Kaua",
          "La Huerta",
          "La Independencia",
          "La Paz",
          "La Yesca",
          "Las Margaritas",
          "Lazaro Cárdenas",
          "Lerdo",
          "León",
          "Lolotla",
          "Loreto",
          "Los Cabos",
          "Luvianos",
          "López",
          "Magdalena",
          "Manzanillo",
          "Marin",
          "Matamoros",
          "Matehuala",
          "Mazapil",
          "Mazatepec",
          "Mazatlan",
          "Mazatlán",
          "Mecatlan",
          "Melchor Ocampo",
          "Metepec",
          "Metztitlán",
          "Mexicali",
          "Mezquital",
          "Mier y Noriega",
          "Miguel Hidalgo",
          "Milpa Alta",
          "Minatitlán",
          "Miquihuana",
          "Moctezuma",
          "Monclova",
          "Monte Escobedo",
          "Montemorelos",
          "Monterrey",
          "Morelia",
          "Morelos",
          "Moroleón",
          "Mulege",
          "Méndez",
          "Mérida",
          "Nacajuca",
          "Nadadores",
          "Naucalpan",
          "Naupan",
          "Nava",
          "Navolato",
          "Nazareno Etla",
          "Nazas",
          "Nezahualcóyotl",
          "Nombre de Dios",
          "Nuevo Laredo",
          "Nuevo Zoquiapam",
          "Ocampo",
          "Ojinaga",
          "Othón P. Blanco",
          "Oxkutzcab",
          "Palizada",
          "Panuco",
          "Paracuaro",
          "Patzcuaro",
          "Pedro Escobedo",
          "Penjamo",
          "Pinal de Amoles",
          "Poncitlan",
          "Progreso",
          "Puebla",
          "Puente de Ixtla",
          "Queretaro",
          "Querétaro",
          "Rayones",
          "Reynosa",
          "Rincón de Romos",
          "Romita",
          "Rosario",
          "Salamanca",
          "Salinas Victoria",
          "Saltillo",
          "Salto de Agua",
          "San Blas",
          "San Buenaventura",
          "San Carlos",
          "San Ignacio",
          "San Juan",
          "San Juan del Río",
          "San Lorenzo",
          "San Luis Potosí",
          "San Marcos",
          "San Miguel Yotao",
          "San Nicolas",
          "San Nicolás de los Garza",
          "Santa Catarina",
          "Santiago Nuyoo",
          "Santiago Tenango",
          "Saric",
          "Sinaloa",
          "Singuilucan",
          "Solidaridad",
          "Soteapan",
          "Suchiate",
          "Susticacán",
          "Tacotalpa",
          "Tahdziu",
          "Tamazunchale",
          "Tancanhuitz",
          "Tapachula",
          "Tapilula",
          "Taxco de Alarcón",
          "Teapa",
          "Tecamac",
          "Tecate",
          "Tecomán",
          "Tecuala",
          "Temosachic",
          "Tenabo",
          "Tenango del Aire",
          "Tenosique",
          "Teocaltiche",
          "Tepalcingo",
          "Tepezala",
          "Tepic",
          "Tepoztlan",
          "Tetecala",
          "Tetepango",
          "Tijuana",
          "Tlacuilotepec",
          "Tlalchapa",
          "Tlalnepantla",
          "Tlalpan",
          "Tlaquepaque",
          "Tlayacapan",
          "Tocatlan",
          "Tochimilco",
          "Tocumbo",
          "Tolimán",
          "Toluca",
          "Tonalá",
          "Tonatico",
          "Torreón",
          "Totolac",
          "Tulum",
          "Tuxpan",
          "Tuxtla",
          "Umán",
          "Unión Hidalgo",
          "Uruachi",
          "Valladolid",
          "Vanegas",
          "Veracruz",
          "Villa Victoria",
          "Villa de Álvarez",
          "Villa del Carbón",
          "Villahermosa",
          "Xalapa",
          "Xalisco",
          "Xaloztoc",
          "Xico",
          "Xicohtzinco",
          "Xochihuehuetlán",
          "Xochimilco",
          "Xochistlahuaca",
          "Xochitepec",
          "Yauhquemehcan",
          "Yecapixtla",
          "Yogana",
          "Zacatecas",
          "Zacatepec",
          "Zapopan",
          "Zaragoza",
          "Zongolica",
          "Álvaro Obregón"
        ],
        "postcode": [
          "#####"
        ],
        "secondary_address": [
          "Apartamento ##",
          "Departamento ###",
          "Depto. ###",
          "Interior ###",
          "Interior ?#",
          "Int. #",
          "Piso #",
          "Piso ##",
          "#ª Planta",
          "Planta alta",
          "Planta baja"
        ],
        "state": [
          "Aguascalientes",
          "Baja California",
          "Baja California Sur",
          "Campeche",
          "Coahuila",
          "Colima",
          "Chiapas",
          "Chihuahua",
          "Ciudad de México",
          "Durango",
          "Guanajuato",
          "Guerrero",
          "Hidalgo",
          "Jalisco",
          "México",
          "Michoacán",
          "Morelos",
          "Nayarit",
          "Nuevo León",
          "Oaxaca",
          "Puebla",
          "Querétaro",
          "Quintana Roo",
          "San Luis Potosí",
          "Sinaloa",
          "Sonora",
          "Tabasco",
          "Tamaulipas",
          "Tlaxcala",
          "Veracruz",
          "Yucatán",
          "Zacatecas"
        ],
        "state_abbr": [
          "AGU",
          "BCN",
          "BCS",
          "CAM",
          "CHP",
          "CHH",
          "COA",
          "COL",
          "DIF",
          "DUR",
          "GUA",
          "GRO",
          "HID",
          "JAL",
          "MEX",
          "MIC",
          "MOR",
          "NAY",
          "NLE",
          "OAX",
          "PUE",
          "QUE",
          "ROO",
          "SLP",
          "SIN",
          "SON",
          "TAB",
          "TAM",
          "TLA",
          "VER",
          "YUC",
          "ZAC"
        ],
        "street_address": [
          "#{street_name} #{building_number}",
          "#{street_name} #{building_number} #{secondary_address}"
        ],
        "street_name": [
          "#{street_prefix} #{Name.first_name}",
          "#{street_prefix} #{Name.first_name} #{Name.last_name}",
          "#{street_prefix} #{state}",
          "#{street_prefix} #{municipality}"
        ],
        "street_prefix": [
          "Arroyo",
          "Avenida",
          "Bajada",
          "Barranco",
          "Calle",
          "Camino",
          "Carretera",
          "Conjunto",
          "Entrada",
          "Escalinata",
          "Explanada",
          "Glorieta",
          "Grupo",
          "Huerta",
          "Jardines",
          "Lago",
          "Manzana",
          "Mercado",
          "Monte",
          "Muelle",
          "Parque",
          "Pasaje",
          "Paseo",
          "Plaza",
          "Privada",
          "Prolongación",
          "Quinta",
          "Rampa",
          "Rincón",
          "Salida",
          "Sector",
          "Subida",
          "Vía"
        ],
        "time_zone": [
          "África/Argel",
          "África/Cairo",
          "África/Casablanca",
          "África/Harare",
          "África/Johannesburgo",
          "África/Monrovia",
          "África/Nairobi",
          "América/Argentina/Buenos_Aires",
          "América/Bogotá",
          "América/Caracas",
          "América/Chicago",
          "América/Chihuahua",
          "América/Ciudad_de_México",
          "América/Denver",
          "América/Guatemala",
          "América/Guyana",
          "América/Halifax",
          "América/Indiana/Indianapolis",
          "América/Juneau",
          "América/La_Paz",
          "América/Lima",
          "América/Los_Angeles",
          "América/Mazatlán",
          "América/Monterrey",
          "América/Nueva_York",
          "América/Nuuk",
          "América/Phoenix",
          "América/Regina",
          "América/San_Juan_de_Terranova",
          "América/Santiago",
          "América/São_Paulo",
          "América/Tijuana",
          "Asia/Almatý",
          "Asia/Bagdad",
          "Asia/Bakú",
          "Asia/Bangkok",
          "Asia/Calcuta",
          "Asia/Chongqing",
          "Asia/Colombo",
          "Asia/Daca",
          "Asia/Ekaterimburgo",
          "Asia/Ereván",
          "Asia/Hong_Kong",
          "Asia/Irkutsk",
          "Asia/Jerusalén",
          "Asia/Kabul",
          "Asia/Kamchatka",
          "Asia/Karachi",
          "Asia/Katmandú",
          "Asia/Krasnoyarsk",
          "Asia/Kuala_Lumpur",
          "Asia/Kuwait",
          "Asia/Magadán",
          "Asia/Mascate",
          "Asia/Novosibirsk",
          "Asia/Rangún",
          "Asia/Riad",
          "Asia/Seúl",
          "Asia/Shanghai",
          "Asia/Singapur",
          "Asia/Taipéi",
          "Asia/Taskent",
          "Asia/Teherán",
          "Asia/Tiflis",
          "Asia/Tokio",
          "Asia/Ulán_Bator",
          "Asia/Urumchi",
          "Asia/Vladivostok",
          "Asia/Yakarta",
          "Asia/Yakutsk",
          "Atlantic/Azores",
          "Atlantic/Cabo_Verde",
          "Atlantic/Georgia_Del_Sur",
          "Australia/Adelaida",
          "Australia/Brisbane",
          "Australia/Darwin",
          "Australia/Hobart",
          "Australia/Melbourne",
          "Australia/Perth",
          "Australia/Sydney",
          "Etc/UTC",
          "Europa/Atenas",
          "Europa/Belgrado",
          "Europa/Berlín",
          "Europa/Bratislava",
          "Europa/Bruselas",
          "Europa/Bucarest",
          "Europa/Budapest",
          "Europa/Copenhague",
          "Europa/Dublín",
          "Europa/Estambul",
          "Europa/Estocolmo",
          "Europa/Helsinki",
          "Europa/Kiev",
          "Europa/Lisboa",
          "Europa/Liubliana",
          "Europa/Londres",
          "Europa/Madrid",
          "Europa/Minsk",
          "Europa/Moscú",
          "Europa/Paris",
          "Europa/Praga",
          "Europa/Riga",
          "Europa/Roma",
          "Europa/Sarajevo",
          "Europa/Skopie",
          "Europa/Sofía",
          "Europa/Tallin",
          "Europa/Viena",
          "Europa/Vilna",
          "Europa/Warsaw Europa/Zagreb",
          "Europa/Ámsterdam",
          "Pacífico/Apia",
          "Pacífico/Auckland",
          "Pacífico/Fakaofo",
          "Pacífico/Fiji",
          "Pacífico/Guaján",
          "Pacífico/Honolulú",
          "Pacífico/Islas_Midway",
          "Pacífico/Majuro",
          "Pacífico/Numea",
          "Pacífico/Pago_Pago",
          "Pacífico/Puerto_Moresby",
          "Pacífico/Tongatapu"
        ]
      },
      "cell_phone": {
        "formats": [
          "#{PhoneNumber.lada_dos} #### ####",
          "#{PhoneNumber.lada_tres} ### ####",
          "(#{PhoneNumber.lada_dos}) #### ####",
          "(#{PhoneNumber.lada_tres}) ### ####",
          "#{PhoneNumber.lada_dos}-####-####",
          "#{PhoneNumber.lada_tres}-###-####",
          "044 #{PhoneNumber.lada_dos} #### ####",
          "044 #{PhoneNumber.lada_tres} ### ####",
          "044 (#{PhoneNumber.lada_dos}) #### ####",
          "044 (#{PhoneNumber.lada_tres}) ### ####",
          "044 #{PhoneNumber.lada_dos}-####-####",
          "044 #{PhoneNumber.lada_tres}-###-####"
        ]
      },
      "company": {
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{prefix} #{Name.last_name} #{suffix}",
          "#{Name.last_name} y #{Name.last_name} #{suffix}",
          "#{Name.last_name} #{Name.last_name} #{suffix}",
          "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados #{suffix}"
        ],
        "prefix": [
          "Grupo",
          "Sociedad",
          "Grupo Financiero",
          "Colegio",
          "Fondo"
        ],
        "suffix": [
          "S.A.",
          "S.A. de C.V.",
          "S.R.L",
          "S.A.B.",
          "S.C."
        ],
        "university": {
          "name": [
            "#{University.prefix} #{Name.last_name} #{University.suffix}",
            "#{University.prefix} #{Name.last_name}",
            "#{University.prefix} #{Address.state} #{University.suffix}"
          ],
          "prefix": [
            "Universidad",
            "Instituto",
            "Academia",
            "Colegio"
          ],
          "suffix": [
            "Norte",
            "del Norte",
            "Occidental",
            "Oeste",
            "Del Sur",
            "Sur",
            "Oriental",
            "Oriente",
            "de Graduados",
            "de Administración"
          ]
        }
      },
      "finance": {
        "vat_number": {
          "MX": "/^([A-ZÑ]{3,4})([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z0-9]{3}$/"
        }
      },
      "internet": {
        "domain_suffix": [
          "com",
          "com.mx",
          "mx",
          "info",
          "me",
          "org",
          "org.mx"
        ]
      },
      "name": {
        "first_name": [
          "José Luis",
          "Juan",
          "Francisco",
          "José",
          "Antonio",
          "Jesús",
          "Miguel Ángel",
          "Pedro",
          "Alejandro",
          "Manuel",
          "Juan Carlos",
          "Roberto",
          "Jorge",
          "Carlos",
          "Fernando",
          "Ricardo",
          "Miguel",
          "Javier",
          "Martín",
          "Rafael",
          "Raúl",
          "Arturo",
          "Daniel",
          "Eduardo",
          "Enrique",
          "Mario",
          "José Antonio",
          "Sergio",
          "Gerardo",
          "Salvador",
          "Marco Antonio",
          "Alfredo",
          "David",
          "Armando",
          "Alberto",
          "Luis",
          "Óscar",
          "Ramón",
          "Guillermo",
          "Rubén",
          "Jaime",
          "Felipe",
          "Julio César",
          "Andrés",
          "Pablo",
          "Ángel",
          "Gabriel",
          "Héctor",
          "Alfonso",
          "José Guadalupe",
          "Agustín",
          "Ignacio",
          "Víctor",
          "Rogelio",
          "Gustavo",
          "Ernesto",
          "Rodolfo",
          "Luis Alberto",
          "Gilberto",
          "Vicente",
          "Juan Antonio",
          "Tomás",
          "Israel",
          "César",
          "Adrián",
          "Ismael",
          "Santiago",
          "Humberto",
          "Gregorio",
          "Joel",
          "Esteban",
          "José Alfredo",
          "Nicolás",
          "Omar",
          "Moisés",
          "Félix",
          "Lorenzo",
          "Samuel",
          "Carlos Alberto",
          "José Angel",
          "Ramiro",
          "Abel",
          "Jorge Luis",
          "Marcos",
          "Mario Alberto",
          "Rodrigo",
          "Edgar",
          "Isidro",
          "José Alberto",
          "Leonardo",
          "Benjamín",
          "Jorge Alberto",
          "Julio",
          "Raymundo",
          "Víctor Hugo",
          "Saúl",
          "Benito",
          "José Juan",
          "Rigoberto",
          "Hugo",
          "Guadalupe",
          "María",
          "Margarita",
          "Verónica",
          "María Elena",
          "Josefina",
          "Leticia",
          "Teresa",
          "Patricia",
          "Rosa",
          "Martha",
          "Rosa María",
          "Alicia",
          "Yolanda",
          "Francisca",
          "Silvia",
          "Elizabeth",
          "Gloria",
          "Ana María",
          "Gabriela",
          "Alejandra",
          "María Luisa",
          "María de Lourdes",
          "Adriana",
          "Araceli",
          "Antonia",
          "Lucía",
          "Carmen",
          "Irma",
          "Claudia",
          "Beatriz",
          "Isabel",
          "Laura",
          "Maribel",
          "Graciela",
          "Virginia",
          "Catalina",
          "Esperanza",
          "Angélica",
          "Maricela",
          "Cecilia",
          "Susana",
          "Cristina",
          "Julia",
          "Concepción",
          "Victoria",
          "Ofelia",
          "Rocío",
          "Carolina",
          "Raquel",
          "Petra",
          "Lorena",
          "Reyna",
          "Sandra",
          "Paula",
          "Guillermina",
          "Sara",
          "Elvira",
          "Manuela",
          "Marisol",
          "Mónica",
          "Erika",
          "Celia",
          "Luz María",
          "Irene",
          "Magdalena",
          "Estela",
          "Ángela",
          "Rosario",
          "Esther",
          "Eva",
          "Norma",
          "Aurora",
          "Socorro",
          "Consuelo",
          "Lidia",
          "Bertha",
          "Sofía",
          "Dolores",
          "Elena",
          "Rosalba",
          "Liliana",
          "Andrea",
          "Adela",
          "Mariana",
          "Fabiola",
          "Karina",
          "Martina",
          "Marcela",
          "Miriam",
          "Mercedes",
          "Marina",
          "Amalia",
          "Olivia",
          "Angelina",
          "Sonia",
          "Agustina",
          "Edith",
          "Lilia",
          "Micaela"
        ],
        "last_name": [
          "Hernández",
          "García",
          "Martínez",
          "López",
          "González",
          "Rodríguez",
          "Pérez",
          "Sánchez",
          "Ramírez",
          "Cruz",
          "Flores",
          "Gómez",
          "Morales",
          "Vázquez",
          "Reyes",
          "Jímenez",
          "Torres",
          "Díaz",
          "Gutiérrez",
          "Mendoza",
          "Ruiz",
          "Aguilar",
          "Ortiz",
          "Castillo",
          "Moreno",
          "Romero",
          "Álvarez",
          "Chávez",
          "Rivera",
          "Juárez",
          "Ramos",
          "Méndez",
          "Domínguez",
          "Herrera",
          "Medina",
          "Vargas",
          "Castro",
          "Guzmán",
          "Velázquez",
          "Muñoz",
          "Rojas",
          "Contreras",
          "Salazar",
          "Luna",
          "de la Cruz",
          "Ortega",
          "Guerrero",
          "Santiago",
          "Estrada",
          "Bautista",
          "Cortés",
          "Soto",
          "Alvarado",
          "Espinoza",
          "Lara",
          "Ávila",
          "Ríos",
          "Cervantes",
          "Silva",
          "Delgado",
          "Vega",
          "Márquez",
          "Sandoval",
          "Fernández",
          "León",
          "Carrillo",
          "Mejía",
          "Solís",
          "Núñez",
          "Rosas",
          "Valdez",
          "Ibarra",
          "Campos",
          "Santos",
          "Camacho",
          "Peña",
          "Maldonado",
          "Navarro",
          "Rosales",
          "Acosta",
          "Miranda",
          "Trejo",
          "Cabrera",
          "Valencia",
          "Nava",
          "Castañeda",
          "Pacheco",
          "Robles",
          "Molina",
          "Rangel",
          "Fuentes",
          "Huerta",
          "Meza",
          "Aguirre",
          "Cárdenas",
          "Orozco",
          "Padilla",
          "Espinosa",
          "Ayala",
          "Salas",
          "Valenzuela",
          "Zúñiga",
          "Ochoa",
          "Salinas",
          "Mora",
          "Tapia",
          "Serrano",
          "Durán",
          "Olvera",
          "Macías",
          "Zamora",
          "Calderón",
          "Arellano",
          "Suárez",
          "Barrera",
          "Zavala",
          "Villegas",
          "Gallegos",
          "Lozano",
          "Galván",
          "Figueroa",
          "Beltrán",
          "Franco",
          "Villanueva",
          "Sosa",
          "Montes",
          "Andrade",
          "Velasco",
          "Arias",
          "Marín",
          "Corona",
          "Garza",
          "Ponce",
          "Esquivel",
          "Pineda",
          "Alonso",
          "Palacios",
          "Antonio",
          "Vásquez",
          "Trujillo",
          "Cortez",
          "Rocha",
          "Rubio",
          "Bernal",
          "Benítez",
          "Escobar",
          "Villa",
          "Galindo",
          "Cuevas",
          "Bravo",
          "Cano",
          "Osorio",
          "Mata",
          "Carmona",
          "Montoya",
          "de Jesús",
          "Enríquez",
          "Cisneros",
          "Rivas",
          "Parra",
          "Reséndiz",
          "Téllez",
          "Zárate",
          "Salgado",
          "de la Rosa",
          "Vera",
          "Tovar",
          "Arroyo",
          "Córdova",
          "Leyva",
          "Quintero",
          "Becerra",
          "Quiroz",
          "Barajas",
          "Ávalos",
          "Peralta",
          "Román",
          "Esparza",
          "Murillo",
          "Guevara",
          "Olivares",
          "Félix",
          "de León",
          "Castellanos",
          "Villarreal",
          "Villalobos",
          "Lugo",
          "Ángeles",
          "Montiel",
          "Segura",
          "Magaña",
          "Saucedo",
          "Gallardo",
          "Mercado",
          "Navarrete",
          "Reyna",
          "Paredes",
          "Dávila",
          "Leal",
          "Guerra",
          "Saldaña",
          "Guillén",
          "Santana",
          "Uribe",
          "Monroy",
          "Piña",
          "Yáñez",
          "Nieto",
          "Islas",
          "Granados",
          "Escobedo",
          "Zapata",
          "Caballero",
          "del Ángel",
          "Solano",
          "Barron",
          "Zepeda",
          "Acevedo",
          "Arriaga",
          "Barrios",
          "Mondragón",
          "Galicia",
          "Godínez",
          "Ojeda",
          "Duarte",
          "Alfaro",
          "Medrano",
          "Rico",
          "Aguilera",
          "Gil",
          "Ventura",
          "Balderas",
          "Arredondo",
          "Coronado",
          "Escamilla",
          "Nájera",
          "Palma",
          "Amador",
          "Blanco",
          "Ocampo",
          "Garduño",
          "Barragán",
          "Gámez",
          "Francisco",
          "Meléndez",
          "Carbajal",
          "Hurtado",
          "Carrasco",
          "Bonilla",
          "Correa",
          "Sierra",
          "Anaya",
          "Carranza",
          "Romo",
          "Valdés",
          "Armenta",
          "Alcántara",
          "Escalante",
          "Arreola",
          "Quezada",
          "Alarcón",
          "Gaytán",
          "Rentería",
          "Vidal",
          "Báez",
          "de los Santos",
          "Toledo",
          "Colín",
          "May",
          "Carrera",
          "Jaramillo",
          "Santillán",
          "Valle",
          "Varela",
          "Arenas",
          "Rendón",
          "Treviño",
          "Venegas",
          "Soriano",
          "Zaragoza",
          "Morán",
          "Áviles",
          "Aranda",
          "Lira",
          "Quintana",
          "Arteaga",
          "Valadez",
          "Cordero",
          "Sotelo",
          "de la Torre",
          "Muñiz",
          "Hidalgo",
          "Cázares",
          "Covarrubias",
          "Zamudio",
          "Ordoñez",
          "Aparicio",
          "Baltazar",
          "Gálvez",
          "Madrigal"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Sr.",
          "Sra.",
          "Srita.",
          "Dr.",
          "Ing."
        ],
        "suffix": [
          "Jr.",
          "Sr.",
          "I",
          "II",
          "III",
          "IV",
          "V"
        ],
        "title": {
          "descriptor": [
            "Supervisor",
            "Asociado",
            "Ejecutivo",
            "Relacciones",
            "Oficial",
            "Gerente",
            "Ingeniero",
            "Especialista",
            "Director",
            "Coordinador",
            "Administrador",
            "Arquitecto",
            "Analista",
            "Diseñador",
            "Planificador",
            "Técnico",
            "Funcionario",
            "Desarrollador",
            "Productor",
            "Consultor",
            "Asistente",
            "Facilitador",
            "Agente",
            "Representante",
            "Estratega"
          ],
          "job": [
            "Soluciones",
            "Programa",
            "Marca",
            "Seguridad",
            "Investigación",
            "Marketing",
            "Normas",
            "Implementación",
            "Integración",
            "Funcionalidad",
            "Respuesta",
            "Paradigma",
            "Tácticas",
            "Identidad",
            "Mercados",
            "Grupo",
            "División",
            "Aplicaciones",
            "Optimización",
            "Operaciones",
            "Infraestructura",
            "Tecnologías de Información",
            "Comunicaciones",
            "Web",
            "Calidad",
            "Seguro",
            "Mobilidad",
            "Cuentas",
            "Datos",
            "Creativo",
            "Configuración",
            "Contabilidad",
            "Interacciones",
            "Factores",
            "Usabilidad",
            "Métricas",
            "Departamento",
            "Región",
            "Supervisión",
            "Planeación"
          ],
          "level": [
            "de",
            "para"
          ]
        }
      },
      "phone_number": {
        "formats": [
          "#{PhoneNumber.lada_dos} #### ####",
          "#{PhoneNumber.lada_tres} ### ####",
          "(#{PhoneNumber.lada_dos}) #### ####",
          "(#{PhoneNumber.lada_tres}) ### ####",
          "#{PhoneNumber.lada_dos}-####-####",
          "#{PhoneNumber.lada_tres}-###-####"
        ],
        "lada_dos": [
          "33",
          "55",
          "81"
        ],
        "lada_tres": [
          "222",
          "223",
          "224",
          "225",
          "226",
          "227",
          "228",
          "229",
          "231",
          "232",
          "233",
          "235",
          "236",
          "237",
          "238",
          "241",
          "243",
          "244",
          "245",
          "246",
          "247",
          "248",
          "249",
          "271",
          "272",
          "273",
          "274",
          "275",
          "276",
          "278",
          "279",
          "281",
          "282",
          "283",
          "284",
          "285",
          "287",
          "288",
          "294",
          "296",
          "297",
          "311",
          "312",
          "313",
          "314",
          "315",
          "316",
          "317",
          "319",
          "321",
          "322",
          "323",
          "324",
          "325",
          "326",
          "327",
          "328",
          "329",
          "341",
          "342",
          "343",
          "344",
          "345",
          "346",
          "347",
          "348",
          "349",
          "351",
          "352",
          "353",
          "354",
          "355",
          "356",
          "357",
          "358",
          "359",
          "371",
          "372",
          "373",
          "374",
          "375",
          "376",
          "377",
          "378",
          "381",
          "382",
          "383",
          "384",
          "385",
          "386",
          "387",
          "388",
          "389",
          "391",
          "392",
          "393",
          "394",
          "395",
          "411",
          "412",
          "413",
          "414",
          "415",
          "417",
          "418",
          "419",
          "421",
          "422",
          "423",
          "424",
          "425",
          "426",
          "427",
          "428",
          "429",
          "431",
          "432",
          "433",
          "434",
          "435",
          "436",
          "437",
          "438",
          "441",
          "442",
          "443",
          "444",
          "445",
          "447",
          "448",
          "449",
          "451",
          "452",
          "453",
          "454",
          "455",
          "456",
          "457",
          "458",
          "459",
          "461",
          "462",
          "463",
          "464",
          "465",
          "466",
          "467",
          "468",
          "469",
          "471",
          "472",
          "473",
          "474",
          "475",
          "476",
          "477",
          "478",
          "481",
          "482",
          "483",
          "485",
          "486",
          "487",
          "488",
          "489",
          "492",
          "493",
          "494",
          "495",
          "496",
          "498",
          "499",
          "588",
          "591",
          "592",
          "593",
          "594",
          "595",
          "596",
          "597",
          "599",
          "612",
          "613",
          "614",
          "615",
          "616",
          "618",
          "621",
          "622",
          "623",
          "624",
          "625",
          "626",
          "627",
          "628",
          "629",
          "631",
          "632",
          "633",
          "634",
          "635",
          "636",
          "637",
          "638",
          "639",
          "641",
          "642",
          "643",
          "644",
          "645",
          "646",
          "647",
          "648",
          "649",
          "651",
          "652",
          "653",
          "656",
          "658",
          "659",
          "661",
          "662",
          "664",
          "665",
          "667",
          "668",
          "669",
          "671",
          "672",
          "673",
          "674",
          "675",
          "676",
          "677",
          "686",
          "687",
          "694",
          "695",
          "696",
          "697",
          "698",
          "711",
          "712",
          "713",
          "714",
          "715",
          "716",
          "717",
          "718",
          "719",
          "721",
          "722",
          "723",
          "724",
          "725",
          "726",
          "727",
          "728",
          "731",
          "732",
          "733",
          "734",
          "735",
          "736",
          "737",
          "738",
          "739",
          "741",
          "742",
          "743",
          "744",
          "745",
          "746",
          "747",
          "748",
          "749",
          "751",
          "753",
          "754",
          "755",
          "756",
          "757",
          "758",
          "759",
          "761",
          "762",
          "763",
          "764",
          "765",
          "766",
          "767",
          "768",
          "769",
          "771",
          "772",
          "773",
          "774",
          "775",
          "776",
          "777",
          "778",
          "779",
          "781",
          "782",
          "783",
          "784",
          "785",
          "786",
          "789",
          "791",
          "797",
          "821",
          "823",
          "824",
          "825",
          "826",
          "828",
          "829",
          "831",
          "832",
          "833",
          "834",
          "835",
          "836",
          "841",
          "842",
          "844",
          "845",
          "846",
          "861",
          "862",
          "864",
          "866",
          "867",
          "868",
          "869",
          "871",
          "872",
          "873",
          "877",
          "878",
          "891",
          "892",
          "894",
          "897",
          "899",
          "913",
          "914",
          "916",
          "917",
          "918",
          "919",
          "921",
          "922",
          "923",
          "924",
          "932",
          "933",
          "934",
          "936",
          "937",
          "938",
          "951",
          "953",
          "954",
          "958",
          "961",
          "962",
          "963",
          "964",
          "965",
          "966",
          "967",
          "968",
          "969",
          "971",
          "972",
          "981",
          "982",
          "983",
          "984",
          "985",
          "986",
          "987",
          "988",
          "991",
          "992",
          "993",
          "994",
          "995",
          "996",
          "997",
          "998",
          "999"
        ]
      },
      "subscription": {
        "payment_methods": [
          "Tarjeta de credito",
          "Tarjeta de débito",
          "Paypal",
          "Efectivo",
          "Transferencia de dinero",
          "Bitcoins",
          "Cheque",
          "Apple Pay",
          "Google Pay",
          "WeChat Pay",
          "Alipay",
          "Visa Checkout"
        ],
        "payment_terms": [
          "Pago por adelantado",
          "Mensual",
          "Anual",
          "Suscripción completa"
        ],
        "plans": [
          "Prueba gratuita",
          "Basico",
          "Starter",
          "Essential",
          "Estudiante",
          "Bronze\"",
          "Standard",
          "Silver",
          "Gold",
          "Platinum",
          "Profesional",
          "Business",
          "Diamond",
          "Premium"
        ],
        "statuses": [
          "Activo",
          "Parado",
          "Bloqueado",
          "Pendiente"
        ],
        "subscription_terms": [
          "Diaria",
          "Semanal",
          "Mensual",
          "Anual",
          "Bienal",
          "Trienal",
          "Quinquenal",
          "De por vida"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor selecciona"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-NI": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido utilizado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 0,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "C$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-PA": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un(a) %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%-d/%-m/%Y",
        "long": "%A, %-d de %B de %Y",
        "short": "%-d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "alrededor de %{count} hora",
          "other": "alrededor de %{count} horas"
        },
        "about_x_months": {
          "one": "alrededor de %{count} mes",
          "other": "alrededor de %{count} meses"
        },
        "about_x_years": {
          "one": "alrededor de %{count} año",
          "other": "alrededor de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado(a)",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío(a)",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado(a)",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido(a) en la lista",
        "invalid": "no es válido(a)",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un número entero",
        "odd": "debe ser un número impar",
        "other_than": "debe ser diferente de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya está en uso",
        "too_long": {
          "one": "es demasiado largo(a) (máximo %{count} carácter)",
          "other": "es demasiado largo(a) (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto(a) (mínimo %{count} carácter)",
          "other": "es demasiado corto(a) (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "no tiene la longitud correcta (debe ser de %{count} carácter)",
          "other": "no tiene la longitud correcta (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "No se pudo guardar este(a) %{model} porque se encontró %{count} error",
          "other": "No se pudo guardar este(a) %{model} porque se encontraron %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "B/."
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %-d de %B de %Y a las %-I:%M:%S %p %Z",
        "long": "%-d de %B de %Y a las %-I:%M %p",
        "short": "%-d %b %-I:%M %p"
      },
      "pm": "pm"
    }
  },
  "es-PE": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Falla de validación: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B del %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "Falla de validación: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número non",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido tomado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "S/"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b del %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B del %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-US": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número non",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido tomado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor selecciona"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S %Z",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    }
  },
  "es-VE": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser un número impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya está en uso",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor selecciona"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "Bs."
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ".",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de %Y a las %H:%M:%S%p %Z",
        "long": "%A, %d de %B de %Y a las %I:%M%p",
        "short": "%d de %b a las %H:%M%p"
      },
      "pm": "pm"
    }
  },
  "et": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Kinnitus saadetud",
          "confirmation_token": "Kinnitamise tähis",
          "confirmed_at": "Kinnitatud",
          "created_at": "Loodud",
          "current_password": "Praegune parool",
          "current_sign_in_at": "Sisselogimise aeg",
          "current_sign_in_ip": "Sisselogimise IP",
          "email": "E-post",
          "encrypted_password": "Krüpteeritud salasõna",
          "failed_attempts": "Ebaõnnestunud katsed",
          "last_sign_in_at": "Viimati sisselogitud",
          "last_sign_in_ip": "Viimase sisselogimise IP",
          "locked_at": "Lukustatud",
          "password": "Parool",
          "password_confirmation": "Parooli kinnitus",
          "remember_created_at": "Hoia loomisaeg meeles",
          "remember_me": "Hoia mind meeles",
          "reset_password_sent_at": "Lähtesta salasõna saatmise aeg",
          "reset_password_token": "Parooli ennistamise tähis",
          "sign_in_count": "Sisselogimiste arv",
          "unconfirmed_email": "Kinnitamata e-posti aadress",
          "unlock_token": "Avamise tähis",
          "updated_at": "Uuendatud"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Valideerimine ebaõnnestus: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Ei saa kirjet kustutada kuna sõltuvad %{record} on olemas",
            "has_one": "Ei saa kirjet kustutada kuna sõltuv %{record} on olemas"
          }
        }
      },
      "models": {
        "user": {
          "one": "Kasutaja",
          "other": "Kasutaja"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
      ],
      "abbr_month_names": [
        null,
        "jaan.",
        "veebr.",
        "märts",
        "apr.",
        "mai",
        "juuni",
        "juuli",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dets."
      ],
      "day_names": [
        "pühapäev",
        "esmaspäev",
        "teisipäev",
        "kolmapäev",
        "neljapäev",
        "reede",
        "laupäev"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d. %B %Y",
        "short": "%d.%m.%y"
      },
      "month_names": [
        null,
        "jaanuar",
        "veebruar",
        "märts",
        "aprill",
        "mai",
        "juuni",
        "juuli",
        "august",
        "september",
        "oktoober",
        "november",
        "detsember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "umbes %{count} tund",
          "other": "umbes %{count} tundi"
        },
        "about_x_months": {
          "one": "umbes %{count} kuu",
          "other": "umbes %{count} kuud"
        },
        "about_x_years": {
          "one": "umbes %{count} aasta",
          "other": "umbes %{count} aastat"
        },
        "almost_x_years": {
          "one": "peaaegu üks aasta",
          "other": "peaaegu %{count} aastat"
        },
        "half_a_minute": "pool minutit",
        "less_than_x_minutes": {
          "one": "vähem kui %{count} minut",
          "other": "vähem kui %{count} minutit"
        },
        "less_than_x_seconds": {
          "one": "vähem kui %{count} sekund",
          "other": "vähem kui %{count} sekundit"
        },
        "over_x_years": {
          "one": "üle %{count} aasta",
          "other": "üle %{count} aasta"
        },
        "x_days": {
          "one": "%{count} päev",
          "other": "%{count} päeva"
        },
        "x_minutes": {
          "one": "%{count} minut",
          "other": "%{count} minutit"
        },
        "x_months": {
          "one": "%{count} kuu",
          "other": "%{count} kuud"
        },
        "x_seconds": {
          "one": "%{count} sekund",
          "other": "%{count} sekundit"
        },
        "x_years": {
          "one": "%{count} aasta",
          "other": "%{count} aastat"
        }
      },
      "prompts": {
        "day": "Päev",
        "hour": "Tunde",
        "minute": "Minutit",
        "month": "Kuu",
        "second": "Sekundit",
        "year": "Aasta"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Sinu konto on edukalt kinnitatud.",
        "new": {
          "resend_confirmation_instructions": "Saada kinnitusjuhend uuesti"
        },
        "send_instructions": "Mõne minuti jooksul saad sa e-kirja juhistega oma konto kinnitamiseks.",
        "send_paranoid_instructions": "Kui sinu e-post on meie andmebaasis, saad varsti e-kirja juhistega, kuidas oma konto kinnitada."
      },
      "failure": {
        "already_authenticated": "Oled juba sisse loginud.",
        "inactive": "Sinu konto polnud veel aktiveeritud.",
        "invalid": "Vale %{authentication_keys} või salasõna",
        "invited": "Sul on kutse ootel - aktsepteeri, et konto loomine lõpule viia.",
        "last_attempt": "Sinul on jäänud veel üks katse enne kui su konto lukustatakse.",
        "locked": "Sinu konto lukustati.",
        "not_found_in_database": "Vale %{authentication_keys} või salasõna",
        "timeout": "Sinu sessioon on aegunud, jätkamiseks logi palun sisse.",
        "unauthenticated": "Sa pead sisse logima või registreeruma enne jätkamist.",
        "unconfirmed": "Sa pead oma konto kinnitama, enne jätkamist."
      },
      "invitations": {
        "edit": {
          "header": "Salasõna sättimine",
          "submit_button": "Säti mu salasõna"
        },
        "invitation_removed": "Sinu kutse eemaldati.",
        "invitation_token_invalid": "Antud kutse ei ole kehtiv!",
        "new": {
          "header": "Kutse saatmine",
          "submit_button": "Saada kutse"
        },
        "no_invitations_remaining": "Kutseid pole rohkem järgi.",
        "send_instructions": "Kutse on saadetud emailile %{email}.",
        "updated": "Sinu salasõna on edukalt sätitud. Oled nüüd sisse logitud."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Kinnita konto",
          "greeting": "Teretulemast %{recipient}!",
          "instruction": "Oma konto saad kinnitada alloleva lingi kaudu:",
          "subject": "Kinnitamise juhised"
        },
        "email_changed": {
          "greeting": "Tere %{recipient}!",
          "message": "Sinu e-posti aadress on muudetud järgmiseks: %{email}.",
          "message_unconfirmed": "Sinu e-posti aadressi muudetakse järgmiseks: %{email}.",
          "subject": "E-posti on muudetud"
        },
        "invitation_instructions": {
          "accept": "Võta kutse vastu",
          "hello": "Tere, %{email}",
          "ignore": "Kui Sa ei soovi kutset vastu võtta, siis lihtsalt ignoreeri seda emaili.<br />Sinu kontot ei looda enne, kui oled ülalolevat linki külastanud ja oma salasõna määranud.",
          "someone_invited_you": "Keegi kutsus Sind aadressile %{url}. Kutse saad vastu võtta allolevalt lingilt.",
          "subject": "Kutse juhised"
        },
        "password_change": {
          "greeting": "Tere %{recipient}!",
          "message": "Anname teada, et sinu parool on ära muudetud.",
          "subject": "Parool muudetud"
        },
        "reset_password_instructions": {
          "action": "Muuda parooli",
          "greeting": "Tere %{recipient}!",
          "instruction": "Keegi on soovinud muuta sinu parooli, saad seda teha alloleva lingi kaudu.",
          "instruction_2": "Kui sa ei ole seda soovinud, palun ignoreeri seda kirja.",
          "instruction_3": "Sinu parool ei muutu enne kui sa oled külastanud eelolevat linki ja uue parooli sisestanud.",
          "subject": "Salasõna taastamise juhised"
        },
        "unlock_instructions": {
          "action": "Ava konto",
          "greeting": "Tere %{recipient}!",
          "instruction": "Vajuta allolevale lingile, et oma konto avada",
          "message": "Sinu konto on lukustatud liigsete ebaõnnestunud sisselogimiskatsete tõttu",
          "subject": "Lukust vabastamise juhised"
        }
      },
      "omniauth_callbacks": {
        "failure": "Ei õnnestunud autoriseerida %{kind}-kontot, põhjus \"%{reason}\".",
        "success": "Edukalt autoriseeritud %{kind}-konto."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Muuda parooli",
          "change_your_password": "Muuda oma parool",
          "confirm_new_password": "Kinnita uus parool",
          "new_password": "Uus parool"
        },
        "new": {
          "forgot_your_password": "Unustasid oma parooli?",
          "send_me_reset_password_instructions": "Saada parooli ennistamise juhend"
        },
        "no_token": "Sa ei saa seda lehte külastada mujalt kui salasõna taastamise e-kirjast. Kui sa tuled salasõna taastamise e-kirjast, palun kontrolli, et sa kasutasid täielikku URLi.",
        "send_instructions": "Mõne minuti jooksul saad sa kirja juhistega, kuidas oma salasõna taastada.",
        "send_paranoid_instructions": "Kui su e-post on meie andmebaasis, saad varsti e-kirja salasõna taastamise lingiga.",
        "updated": "Sinu salasõna vahetati edukalt. Oled nüüd sisse logitud.",
        "updated_not_active": "Sinu salasõna vahetati edukalt."
      },
      "registrations": {
        "destroyed": "Nägemist! Sinu konto on edukalt tühistatud. Loodame sind peagi uuesti näha.",
        "edit": {
          "are_you_sure": "Oled sa kindel?",
          "cancel_my_account": "Kustuta konto",
          "currently_waiting_confirmation_for_email": "Kinnituse ootel: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "jäta tühjaks, kui sa ei soovi seda muuta",
          "title": "Muuda %{resource}",
          "unhappy": "Õnnetu",
          "update": "Uuenda",
          "we_need_your_current_password_to_confirm_your_changes": "meil on vaja sinu praegust parooli, et muutused kinnitada"
        },
        "new": {
          "sign_up": "Loo konto"
        },
        "signed_up": "Tere tulemast! Sa registreerusid edukalt.",
        "signed_up_but_inactive": "Sa registreerusid edukalt. Siiski ei saa me sind sisse logida, sest su konto pole veel aktiveeritud.",
        "signed_up_but_locked": "Sa registreerusid edukalt. Siiski ei saa me sind sisse logida, sest su konto on lukus.",
        "signed_up_but_unconfirmed": "Kiri kinnituslingiga on saadetud sinu e-posti aadressile. Palun ava see link oma konto kinnitamiseks.",
        "update_needs_confirmation": "Sa uuendasid edukalt oma kontot, kuid me peame kontrollima sinu e-posti aadressi. Palun kontrolli oma e-posti ja ava kinnitamise link, et viia lõpule aadressi kinnitamine.",
        "updated": "Sa uuendasid edukalt oma kontot.",
        "updated_but_not_signed_in": "Sinu konto on edukalt uuendatud, kuid kuna parool on muudetud, pead uuesti sisse logima."
      },
      "sessions": {
        "already_signed_out": "Edukalt välja logitud.",
        "new": {
          "sign_in": "Logi sisse"
        },
        "signed_in": "Edukalt sisse logitud.",
        "signed_out": "Edukalt välja logitud."
      },
      "shared": {
        "links": {
          "back": "Tagasi",
          "didn_t_receive_confirmation_instructions": "Ei saanud kinnitusjuhiseid?",
          "didn_t_receive_unlock_instructions": "Ei saanud konto avamise juhiseid?",
          "forgot_your_password": "Unustasid oma parooli?",
          "sign_in": "Logi sisse",
          "sign_in_with_provider": "Logi sisse %{provider}-ga",
          "sign_up": "Loo konto"
        },
        "minimum_password_length": {
          "one": "(vähemalt %{count} tähemärk)",
          "other": "(vähemalt %{count} tähemärki)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Saada konto avamise juhised uuesti"
        },
        "send_instructions": "Sa saad mõne minuti jooksul e-kirja juhistega, kuidas oma konto lukust vabastada.",
        "send_paranoid_instructions": "Kui su konto eksisteerib, saad sa mõne minuti jooksul e-kirja juhistega, kuidas oma konto lukust vabastada.",
        "unlocked": "Sinu konto on edukalt lukust vabastatud. Jätkamiseks palun logi sisse."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "peab olema heaks kiidetud",
        "already_confirmed": "on juba kinnitatud, proovi sisse logida",
        "blank": "on täitmata",
        "confirmation": "ei vasta kinnitusele",
        "confirmation_period_expired": "vajab kinnitamist %{period} jooksul, palun küsi uus",
        "empty": "on tühi",
        "equal_to": "peab olema võrdne arvuga %{count}",
        "even": "peab olema paarisarv",
        "exclusion": "on reserveeritud",
        "expired": "on aegunud, palun küsi uus",
        "greater_than": "peab olema suurem kui %{count}",
        "greater_than_or_equal_to": "peab olema suurem või võrdne arvuga %{count}",
        "inclusion": "ei leidu nimekirjas",
        "invalid": "ei ole korrektne",
        "less_than": "peab olema vähem kui %{count}",
        "less_than_or_equal_to": "peab olema vähem või võrdne arvuga %{count}",
        "model_invalid": "Valideerimine ebaõnnestus: %{errors}",
        "not_a_number": "ei ole number",
        "not_an_integer": "peab olema täisarv",
        "not_found": "ei leitud",
        "not_locked": "ei olnud lukus",
        "not_saved": {
          "one": "1 viga takistas salvestamast objekti %{resource}:",
          "other": "%{count} viga takistasid salvestamast objekti %{resource}:"
        },
        "odd": "peab olema paaritu arv",
        "other_than": "peab olema midagi muud kui %{count}",
        "present": "peab olema täitmata",
        "required": "peab olemas olema",
        "taken": "on juba võetud",
        "too_long": "on liiga pikk (maksimum on %{count} tähemärki)",
        "too_short": "on liiga lühike (miinimum on %{count} tähemärki)",
        "wrong_length": "on vale pikkusega (peab olema %{count} tähemärki)"
      },
      "template": {
        "body": "Probleeme ilmnes järgmiste väljadega:",
        "header": {
          "one": "Üks viga takistas objekti %{model} salvestamist",
          "other": "%{count} viga takistasid objekti %{model} salvestamist"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Palun vali"
      },
      "submit": {
        "create": "Loo uus %{model}",
        "submit": "Salvesta %{model}",
        "update": "Uuenda objekti %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miljard",
            "million": "miljon",
            "quadrillion": "kvadriljon",
            "thousand": "tuhat",
            "trillion": "triljon",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "bait",
              "other": "baiti"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " ja ",
        "two_words_connector": " ja ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "enne lõunat",
      "formats": {
        "default": "%d. %B %Y, %H:%M",
        "long": "%a, %d. %b %Y, %H:%M:%S %z",
        "short": "%d.%m.%y, %H:%M"
      },
      "pm": "pärast lõunat"
    }
  },
  "eu": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Balioztatze arazoa: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Ezin da erregistroa ezabat menpeko %{record}ak daudelako",
            "has_one": "Ezin da erregistroa ezabatu menpeko %{record} bat dagoelako"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Ig",
        "Al",
        "Ar",
        "Az",
        "Og",
        "Or",
        "Lr"
      ],
      "abbr_month_names": [
        null,
        "Urt",
        "Ots",
        "Mar",
        "Api",
        "Mai",
        "Eka",
        "Uzt",
        "Abu",
        "Ira",
        "Urr",
        "Aza",
        "Aben"
      ],
      "day_names": [
        "Igandea",
        "Astelehena",
        "Asteartea",
        "Asteazkena",
        "Osteguna",
        "Ostirala",
        "Larunbata"
      ],
      "formats": {
        "default": "%Y/%m/%e",
        "long": "%Y(e)ko %Bk %e",
        "short": "%b %e"
      },
      "month_names": [
        null,
        "Urtarrila",
        "Otsaila",
        "Martxoa",
        "Apirila",
        "Maiatza",
        "Ekaina",
        "Uztaila",
        "Abuztua",
        "Iraila",
        "Urria",
        "Azaroa",
        "Abendua"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ordu bat inguru",
          "other": "%{count} ordu inguru"
        },
        "about_x_months": {
          "one": "hilabete bat inguru",
          "other": "%{count} hilabete inguru"
        },
        "about_x_years": {
          "one": "urte bat inguru",
          "other": "%{count} urte inguru"
        },
        "almost_x_years": {
          "one": "ia urte bat",
          "other": "ia %{count} urte"
        },
        "half_a_minute": "minutu erdi",
        "less_than_x_minutes": {
          "one": "%{count} minutu bat baino gutxiago",
          "other": "%{count} minutu baino gutxiago"
        },
        "less_than_x_seconds": {
          "one": "segundu bat baino gutxiago",
          "other": "%{count} segundu baino gutxiago"
        },
        "over_x_years": {
          "one": "urte bat baino gehiago",
          "other": "%{count} urte baino gehiago"
        },
        "x_days": {
          "one": "egun bat",
          "other": "%{count} egun"
        },
        "x_minutes": {
          "one": "minutu bat",
          "other": "%{count} minutu"
        },
        "x_months": {
          "one": "hilabete bat",
          "other": "%{count} hilabete"
        },
        "x_seconds": {
          "one": "segundu bat",
          "other": "%{count} segundu"
        }
      },
      "prompts": {
        "day": "Egun",
        "hour": "Ordu",
        "minute": "Minutu",
        "month": "Hilabete",
        "second": "Segundu",
        "year": "Urte"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "onartuta izan behar da",
        "blank": "ezin da zuriz utzi",
        "confirmation": "ez dator bat konfirmazioarekin",
        "empty": "ezin da hutsik egon",
        "equal_to": "%{count} izan behar da",
        "even": "bikoitia izan behar du",
        "exclusion": "erreserbatuta dago",
        "greater_than": "%{count} baino handiagoa izan behar da",
        "greater_than_or_equal_to": "%{count} baino handiago edo berdin izan behar da",
        "inclusion": "ez da zerrendako aukera bat",
        "invalid": "ez da zuzena",
        "less_than": "%{count} baino txikiago izan behar da",
        "less_than_or_equal_to": "%{count} baino txikiago edo berdin izan behar da",
        "model_invalid": "Baieztatzeak huts egin du: %{errors}",
        "not_a_number": "ez da zenbaki bat",
        "not_an_integer": "zenbaki osoa izan behar da",
        "odd": "bakoitia izan behar du",
        "other_than": "%{count}ren ezberdina izan behar du",
        "present": "zuriz egon behar da",
        "required": "egon behar du",
        "taken": "hartuta dago",
        "too_long": {
          "one": "luzeegia da (karaktere %{count} gehienez)",
          "other": "luzeegia da (%{count} karaktere gehienez)"
        },
        "too_short": {
          "one": "laburregia da (karaktere %{count} gutxienez)",
          "other": "laburregia da (%{count} karaktere gutxienez)"
        },
        "wrong_length": {
          "one": "ez du luzeera zuzena (karaktere %{count} izan behar ditu)",
          "other": "ez du luzeera zuzena (%{count} karaktere izan behar ditu)"
        }
      },
      "template": {
        "body": "Arazoak egon dira ondoko eremuekin:",
        "header": {
          "one": "Errore batek ezinezkoa egin du %{model} hau gordetzea",
          "other": "%{count} errorek ezinezkoa egiten dute %{model} hau gordetzea"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Mesedez, aukeratu"
      },
      "submit": {
        "create": "%{model}a eratu",
        "submit": "%{model}a gorde",
        "update": "%{model}a eguneratu"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Mila milioi",
            "million": "Milioi",
            "quadrillion": "Kuatrilioi",
            "thousand": "Mila",
            "trillion": "Trilioi",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Byte"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "% %n"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " eta ",
        "two_words_connector": " eta ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %Y(e)ko %Bren %e %H:%M:%S %z",
        "long": "%Y(e)ko %Bren %e,  %H:%M",
        "short": "%b %e, %H:%M"
      },
      "pm": "pm"
    }
  },
  "fa": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "ارسال تایید در",
          "confirmation_token": "نشان امنیتی تایید",
          "confirmed_at": "تایید شده در",
          "created_at": "ساخته شده در",
          "current_password": "رمز عبور فعلی",
          "current_sign_in_at": "وارد شده در",
          "current_sign_in_ip": "وارد شده با ‌ip",
          "email": "ایمیل",
          "encrypted_password": "کلمه عبور رمز نگاری شده",
          "failed_attempts": "تلاش های ناموفق",
          "last_sign_in_at": "آخرین ورود در",
          "last_sign_in_ip": "آخرین ورود با ip",
          "locked_at": "قفل شده در",
          "password": "رمز عبور",
          "password_confirmation": "تکرار رمز عبور",
          "remember_created_at": "بخاطر سپاری در",
          "remember_me": "مرا بخاطر بسپار",
          "reset_password_sent_at": "ارسال بازیابی کلمه عبور در",
          "reset_password_token": "نشان امنیتی بازیابی کلمه عبور",
          "sign_in_count": "تعداد دفعات ورود",
          "unconfirmed_email": "ایمیل تایید نشده",
          "unlock_token": "نشان امنیتی بازگشایی",
          "updated_at": "بروزرسانی در"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "رکورد نامعتبر است %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "نمی توان رکورد را حذف کرد بخاطر اینکه %{record} وابسته وجود دارد",
            "has_one": "نمی توان رکورد را حذف کرد بخاطر اینکه یک %{record} وابسته وجود دارد"
          }
        }
      },
      "models": {
        "user": {
          "one": "کاربر",
          "other": "کاربر"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ی",
        "د",
        "س",
        "چ",
        "پ",
        "ج",
        "ش"
      ],
      "abbr_month_names": [
        null,
        "ژانویه",
        "فوریه",
        "مارس",
        "آوریل",
        "مه",
        "ژوئن",
        "ژوئیه",
        "اوت",
        "سپتامبر",
        "اکتبر",
        "نوامبر",
        "دسامبر"
      ],
      "day_names": [
        "یکشنبه",
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنج‌شنبه",
        "جمعه",
        "شنبه"
      ],
      "formats": {
        "default": "%Y/%m/%d",
        "long": "%e %B %Y",
        "short": "%m/%d"
      },
      "month_names": [
        null,
        "ژانویه",
        "فوریه",
        "مارس",
        "آوریل",
        "مه",
        "ژوئن",
        "ژوئیه",
        "اوت",
        "سپتامبر",
        "اکتبر",
        "نوامبر",
        "دسامبر"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "حدود یک ساعت",
          "other": "حدود %{count} ساعت"
        },
        "about_x_months": {
          "one": "حدود یک ماه",
          "other": "حدود %{count} ماه"
        },
        "about_x_years": {
          "one": "حدود یک سال",
          "other": "حدود %{count} سال"
        },
        "almost_x_years": {
          "one": "حدود یک سال",
          "other": "حدود %{count} سال"
        },
        "half_a_minute": "نیم دقیقه",
        "less_than_x_minutes": {
          "one": "کمتر از یک دقیقه",
          "other": "کمتر از %{count} دقیقه"
        },
        "less_than_x_seconds": {
          "one": "یک ثانیه",
          "other": "کمتر  از %{count} ثانیه"
        },
        "over_x_years": {
          "one": "بیش از یک سال",
          "other": "بیش از %{count} سال"
        },
        "x_days": {
          "one": "یک روز",
          "other": "%{count} روز"
        },
        "x_minutes": {
          "one": "یک دقیقه",
          "other": "%{count} دقیقه"
        },
        "x_months": {
          "one": "یک ماه",
          "other": "%{count} ماه"
        },
        "x_seconds": {
          "one": "یک ثانیه",
          "other": "%{count} ثانیه"
        },
        "x_years": {
          "one": "%{count} سال",
          "other": "%{count} سال"
        }
      },
      "prompts": {
        "day": "روز",
        "hour": "ساعت",
        "minute": "دقیقه",
        "month": "ماه",
        "second": "ثانیه",
        "year": "سال"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "حسابتان با موفقیت تایید شد. هم اکنون وارد شدید.",
        "new": {
          "resend_confirmation_instructions": "ارسال مجدد راهنمای تایید حساب"
        },
        "send_instructions": "ظرف چند دقیقه آینده ایمیلی حاوی راهنمای تایید حسابتان دریافت خواهید کرد.",
        "send_paranoid_instructions": "اگر ایمیل شما قبلا در سیستم ثبت شده باشد، تا چند دقیقه‌ی دیگر یک ایمیل حاوی توضیحات چگونگی فعال‌سازی حساب‌تان دریافت می‌کنید."
      },
      "failure": {
        "already_authenticated": "وارد سیستم هستید.",
        "inactive": "حساب شما هنوز فعال نشده است.",
        "invalid": "%{authentication_keys} یا کلمه عبور اشتباه است",
        "invited": "شما یک دعوت نامه در حال انتظار دارید، با قبول آن حساب خود را بسازید.",
        "last_attempt": "شما تنها یک فرصت دیگر دارید قبل از این‎که حسابتان غیرفعال شود.",
        "locked": "حسابتان قفل شده است.",
        "not_found_in_database": "%{authentication_keys} یا کلمه عبور اشتباه است",
        "timeout": "نشست شما منقضی شده است. برای ادامه دوباره وارد شوید.",
        "unauthenticated": "پیش از ادامه باید وارد شوید یا ثبت نام کنید.",
        "unconfirmed": "باید حسابتان را قبل از ادامه تایید کنید."
      },
      "invitations": {
        "edit": {
          "header": "رمز عبور انتخاب کنید",
          "submit_button": "رمز عبور ذخیره کن"
        },
        "invitation_removed": "دعوت نامه شما حذف شده.",
        "invitation_token_invalid": "کد دعوت نامه معتبر نیست!",
        "new": {
          "header": "فرستادن دعوت نامه",
          "submit_button": "فرستادن دعوت نامه"
        },
        "no_invitations_remaining": "دعوت نامه ای نمانده",
        "send_instructions": "یک ایمیل دعوت نامه به %{email} ارسال شد.",
        "updated": "رمز عبور شما ذخیره شد. شما وارد سایت شدید!",
        "updated_not_active": "رمز عبور شما ذخیره شد."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "حساب مرا تایید کن",
          "confirm_account_link": "تأیید حساب من",
          "confirm_link_msg": "شما می‌توانید ایمیل حساب خود را از طریق لینک زیر تأیید کنید:",
          "greeting": "خوش آمدید %{recipient}!",
          "instruction": "شما می توانید ایمیل حساب کاربری خود را از طریق لینک زیر تایید کنید:",
          "subject": "راهنمای تایید"
        },
        "email_changed": {
          "greeting": "سلام %{recipient}!",
          "message": "با شما تماس گرفته ایم تا شما را مطلع کنیم که ایمیل شما به %{email} تغییر کرده است.",
          "message_unconfirmed": null,
          "subject": "تغییر ایمیل"
        },
        "invitation_instructions": {
          "accept": "قبول دعوت",
          "accept_until": "این دعوت نامه تا تاریخ %{due_date} اعتبار دارد.",
          "hello": "سلام %{email}",
          "ignore": "اگر نمی خواهید این دعوت را قبول کنید, لطفا این ایمیل را نادیده بگیرید.<br />تا وقتی که بر روی لینک بالا کلیک نکنید، حساب شما ساخته نخواهد شد.",
          "someone_invited_you": "شما به %{url} دعوت شدید. لینک زیر را استفاده کنید تا حساب شما فعال شود.",
          "subject": "شما دعوت شدید!"
        },
        "password_change": {
          "greeting": "سلام %{recipient}!",
          "message": "با شما تماس گرفته ایم تا شما را مطلع کنیم که کلمه عبور شما تغییر کرده است.",
          "subject": "تغییر رمز عبور"
        },
        "reset_password_instructions": {
          "action": "رمز عبور مرا تغییر بده",
          "greeting": "سلام %{recipient}!",
          "ignore_mail_msg": "اگر شما این درخواست را نکرده‌اید، لطفاً این ایمیل را نادیده بگیرید.",
          "instruction": "شخصی درخواست تغییر رمز عبور شما را داده و شما می توانید این کار را از طریق لینک زیر انجام دهید.",
          "instruction_2": "اگر شما این درخواست را ارسال نکرده اید لطفا این ایمیل را نادیده بگیرید.",
          "instruction_3": "رمز عبور شما تا زمانی که به لینک بالا مراجعه نکنید و رمز عبور جدید نسازید تغییر نخواهد کرد",
          "no_changes_msg": "رمز عبور شما تغییر نخواهد کرد تا زمانی که به لینک بالا دسترسی پیدا کنید و یک رمز عبور جدید ایجاد کنید.",
          "password_change_link": "تغییر رمز عبور من",
          "request_reset_link_msg": "شخصی درخواست یک لینک برای تغییر رمز عبور شما کرده است. شما می‌توانید این کار را از طریق لینک زیر انجام دهید.",
          "subject": "راهنمای بازنشانی رمز عبور"
        },
        "unlock_instructions": {
          "account_lock_msg": "حساب شما به دلیل تعداد زیادی تلاش ناموفق برای ورود قفل شده است.",
          "action": "حساب مرا باز کن",
          "greeting": "سلام %{recipient}!",
          "instruction": "برای باز کردن حساب خود بر روی لینک زیر کلیک کنید:",
          "message": "حساب شما بخاطر تلاش های ناموفق مکرر برای ورود قفل شد.",
          "subject": "راهنمای باز کردن",
          "unlock_link": "باز کردن حساب من",
          "unlock_link_msg": "برای باز کردن حساب خود، روی لینک زیر کلیک کنید:"
        }
      },
      "omniauth_callbacks": {
        "failure": "امکان استفاده از مجوز %{kind} نبود زیرا \"%{reason}\".",
        "success": "با موفقیت مجوز استفاده از  %{kind} دریافت شد."
      },
      "passwords": {
        "edit": {
          "change_my_password": "رمز عبور مرا تغییر بده",
          "change_your_password": "رمز عبور خود را تغییر دهید",
          "confirm_new_password": "رمز عبور جدید را تایید کنید",
          "new_password": "رمز عبور جدید"
        },
        "new": {
          "forgot_your_password": "رمز عبور خود را فراموش کرده اید؟",
          "send_me_reset_password_instructions": "راهنمای تغییر رمز عبور را برای من بفرست"
        },
        "no_token": "شما نمی‌توانید بدون استفاده از یک لینک بازنشانی رمز به این صفحه دسترسی پیدا کنید. اگر از طریق یک ایمیل بازنشانی رمز عبور به این صفحه رسیده‌اید، مطمئن شوید که از کل URL فرستاده شده استفاده کرده‌اید.",
        "send_instructions": "ظرف چند دقیقه آینده ایمیلی حاوی راهنمای بازگرداندن رمز عبورتان دریافت خواهید کرد.",
        "send_paranoid_instructions": "اگر ایمیل شما قبلا در سیستم ثبت شده باشد، تا چند دقیقه‌ی دیگر یک لینک بازنشانی رمز عبور دریافت می‌کنید.",
        "updated": "رمز عبورتان با موفقیت تغییر کرد. اکنون وارد شدید.",
        "updated_not_active": "رمز عبور با موفقیت تغییر یافت."
      },
      "registrations": {
        "destroyed": "بدرود! حسابتان لغو شد. به امید دیدار دوباره.",
        "edit": {
          "are_you_sure": "آیا اطمینان دارید؟",
          "cancel_my_account": "حساب مرا لغو کن",
          "currently_waiting_confirmation_for_email": "در حال انتظار برای تایید :  %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "اگر نمی خواهید تغییر دهید خالی بگذارید",
          "title": "تغییر %{resource}",
          "unhappy": "ناراحت",
          "update": "بروز رسانی",
          "we_need_your_current_password_to_confirm_your_changes": "ما برای تایید تغییرات به کلمه عبور فعلی نیاز داریم:"
        },
        "new": {
          "sign_up": "ثبت نام"
        },
        "signed_up": "خوش آمدید! با موفقیت ثبت نام کردید.",
        "signed_up_but_inactive": "شما با موفقیت ثبت نام شده اید؛ ولی هنوز نمی‌توانید وارد شوید چون حساب‌تان هنوز فعال نشده.",
        "signed_up_but_locked": "شما با موفقیت ثبت نام شده اید؛ ولی هنوز نمی‌توانید وارد شوید چون حساب‌تان قفل شده.",
        "signed_up_but_unconfirmed": "یک ایمیل حاوی لینک تایید حساب برای شما فرستاده شده. لطفا برای فعال کردن حساب‌تان آن لینک را باز کنید.",
        "update_needs_confirmation": "حساب شما با موفقیت به روز شد، اما شما باید ایمیل جدیدتان را را تایید کنید. لطفا ایمیل‌تان را چک کنید و روی لینک تایید حساب کاربری کلیک کنید تا ایمیل جدیدتان تایید شود.",
        "updated": "به روز رسانی حسابتان با موفقیت انجام شد.",
        "updated_but_not_signed_in": "حساب کاربری شما با موفقیت به‌روز شد، اما از آنجا که رمز عبورتان تغییر کرده است، باید دوباره وارد سیستم شوید"
      },
      "sessions": {
        "already_signed_out": "خروج با موفقیت انجام شد.",
        "new": {
          "sign_in": "ورود"
        },
        "signed_in": "ورود موفق.",
        "signed_out": "خروج موفق."
      },
      "shared": {
        "links": {
          "back": "برگشت",
          "didn_t_receive_confirmation_instructions": "ایمیل راهنمای تایید را دریافت نکرده اید؟",
          "didn_t_receive_unlock_instructions": "ایمیل راهنمای بازکردن حساب را دریافت نکرده اید؟",
          "forgot_your_password": "کلمه عبور خود را فراموش کرده اید؟",
          "sign_in": "ورود",
          "sign_in_with_provider": "ورود با %{provider}",
          "sign_up": "ثبت نام"
        },
        "minimum_password_length": {
          "one": "(حداقل %{count} حرف)",
          "other": "(حداقل %{count} حرف)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "ارسال مجدد راهنمای بازکردن حساب"
        },
        "send_instructions": "ایمیلی حاوی راهنمای باز کردن حسابتان در چند دقیقه آینده به شما ارسال خواهد شد.",
        "send_paranoid_instructions": "اگر حساب شما وجود داشته باشد، تا چند دقیقه‌ی دیگر یک ایمیل حاوی توضیحات نحوه‌ی باز کردن قفل حساب‌تان برای شما ارسال می‌شود.",
        "unlocked": "حسابتان با موفقیت باز شد. اکنون وارد شدید."
      }
    },
    "devise_token_auth": {
      "confirmations": {
        "missing_email": "شما باید یک آدرس ایمیل ارائه دهید.",
        "sended": "یک ایمیل به '%{email}' ارسال شده است که شامل دستورالعمل‌های تأیید حساب شما است.",
        "sended_paranoid": "اگر آدرس ایمیل شما در پایگاه داده ما وجود داشته باشد، در چند دقیقه یک ایمیل با دستورالعمل‌های تأیید آدرس ایمیل شما ارسال خواهد شد.",
        "user_not_found": "نمی‌توان کاربری با ایمیل '%{email}' پیدا کرد."
      },
      "omniauth": {
        "not_allowed_redirect_url": "انتقال به '%{redirect_url}' مجاز نیست."
      },
      "passwords": {
        "missing_email": "شما باید یک آدرس ایمیل ارائه دهید.",
        "missing_passwords": "شما باید فیلدهای 'رمز عبور' و 'تأیید رمز عبور' را پر کنید.",
        "missing_redirect_url": "آدرس انتقال موجود نیست.",
        "not_allowed_redirect_url": "انتقال به '%{redirect_url}' مجاز نیست.",
        "password_not_required": "این حساب نیازی به رمز عبور ندارد. به جای آن با حساب '%{provider}' خود وارد شوید.",
        "sended": "یک ایمیل به '%{email}' ارسال شده است که شامل دستورالعمل‌های بازنشانی رمز عبور شما است.",
        "sended_paranoid": "اگر آدرس ایمیل شما در پایگاه داده ما وجود داشته باشد، در چند دقیقه یک لینک بازیابی رمز عبور به آدرس ایمیل شما ارسال خواهد شد.",
        "successfully_updated": "رمز عبور شما با موفقیت به‌روزرسانی شد.",
        "user_not_found": "نمی‌توان کاربری با ایمیل '%{email}' پیدا کرد."
      },
      "registrations": {
        "account_to_destroy_not_found": "نمی‌توان حساب را برای حذف پیدا کرد.",
        "account_with_uid_destroyed": "حساب با UID '%{uid}' حذف شده است.",
        "email_already_exists": "یک حساب برای '%{email}' قبلاً وجود دارد.",
        "missing_confirm_success_url": "پارامتر 'confirm_success_url' موجود نیست.",
        "redirect_url_not_allowed": "انتقال به '%{redirect_url}' مجاز نیست.",
        "user_not_found": "کاربر پیدا نشد."
      },
      "sessions": {
        "bad_credentials": "اطلاعات ورود نامعتبر است. لطفاً دوباره تلاش کنید.",
        "not_confirmed": "یک ایمیل تأیید به حساب شما در '%{email}' ارسال شده است. شما باید دستورالعمل‌های موجود در ایمیل را دنبال کنید تا حساب شما فعال شود.",
        "not_supported": "برای ورود از POST /sign_in استفاده کنید. GET پشتیبانی نمی‌شود.",
        "user_not_found": "کاربر پیدا نشد یا وارد نشده است."
      },
      "token_validations": {
        "invalid": "اطلاعات ورود نامعتبر است."
      },
      "unlocks": {
        "missing_email": "شما باید یک آدرس ایمیل ارائه دهید.",
        "sended": "یک ایمیل به '%{email}' ارسال شده است که شامل دستورالعمل‌های باز کردن حساب شما است.",
        "sended_paranoid": "اگر حساب شما وجود داشته باشد، در چند دقیقه یک ایمیل با دستورالعمل‌های باز کردن حساب شما ارسال خواهد شد.",
        "user_not_found": "نمی‌توان کاربری با ایمیل '%{email}' پیدا کرد."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "باید پذیرفته شود",
        "already_confirmed": "قبلا تایید شده است",
        "blank": "نباید خالی باشد",
        "confirmation": "با تایید نمی‌خواند",
        "confirmation_period_expired": "باید در مدت %{period} تایید می‌شد، لطفا یکی دیگر درخواست نمایید",
        "empty": "نمی‌تواند خالی باشد",
        "equal_to": "باید برابر %{count} باشد",
        "even": "باید زوج باشد",
        "exclusion": "رزرو است",
        "expired": "منقضی شده. لطفا یکی دیگر درخواست کنید.",
        "greater_than": "باید بزرگتر از %{count} باشد",
        "greater_than_or_equal_to": "باید بزرگتر یا برابر %{count} باشد",
        "inclusion": "در لیست موجود نیست",
        "invalid": "نامعتبر است",
        "less_than": "باید کمتر از %{count} باشد",
        "less_than_or_equal_to": "باید کمتر یا برابر %{count} باشد",
        "model_invalid": "رکورد نامعتبر است %{errors}",
        "not_a_number": "عدد نیست",
        "not_an_integer": "عدد صحیح نیست",
        "not_email": "یک ایمیل نیست",
        "not_found": "یافت نشد",
        "not_locked": "قفل نشده است",
        "not_saved": {
          "one": "۱ خطا جلوی ذخیره %{resource} را گرفت:",
          "other": "%{count} خطا جلوی ذخیره این %{resource} را گرفت:"
        },
        "odd": "باید فرد باشد",
        "other_than": "باید غیر از %{count} باشد",
        "present": "باید خالی باشد",
        "required": "باید وجود داشته باشد",
        "taken": "پیشتر گرفته شده",
        "too_long": "بلند است (حداکثر %{count} کاراکتر)",
        "too_short": "کوتاه است (حداقل %{count} کاراکتر)",
        "validate_account_update_params": "لطفاً داده‌های صحیح به‌روزرسانی حساب را در بدنه درخواست ارسال کنید.",
        "validate_sign_up_params": "لطفاً داده‌های صحیح ثبت نام را در بدنه درخواست ارسال کنید.",
        "wrong_length": "نااندازه است (باید %{count} کاراکتر باشد)"
      },
      "template": {
        "body": "موارد زیر مشکل داشت:",
        "header": {
          "one": "%{count} خطا جلوی ذخیره این %{model} را گرفت",
          "other": "%{count} خطا جلوی ذخیره این %{model} را گرفت"
        }
      }
    },
    "faker": {
      "name": {
        "female_first_name": [
          "آبگینه",
          "آبنوس",
          "آتنا",
          "آتوسا",
          "اختر",
          "آذر",
          "آذرافروز",
          "آذرگون",
          "آزرمیدخت",
          "آذرنوش",
          "آذین",
          "آرا",
          "آرتمیس",
          "آرزو",
          "آرمینا",
          "آرمینه",
          "آرمیتا",
          "آریانا",
          "آریادخت",
          "آریانوش",
          "آرینا",
          "آزاده",
          "آسا",
          "آسانا",
          "آستیاژ",
          "آفتاب",
          "آفرین",
          "آگرین",
          "آلا",
          "آلاء",
          "آلاله",
          "آناهیتا",
          "آندریا",
          "آنوشا",
          "آوا",
          "آوید",
          "آویده",
          "آویزه",
          "آویسا",
          "آوین",
          "آوینه",
          "آهو",
          "ابریشم",
          "اختر",
          "ارغوان",
          "اروشا",
          "اِستِر",
          "افروز",
          "افروغ",
          "افسانه",
          "افسر",
          "افسون",
          "افشان",
          "افشار",
          "آرتمیس",
          "اومَتی",
          "امتیس",
          "امیتیس",
          "اناهید",
          "اندیشه",
          "انوشه",
          "ایران",
          "ایرانا",
          "ایرانو",
          "ایرانیک",
          "ایرمن",
          "ایریانا",
          "ایران",
          "ایراندخت",
          "ایلدا",
          "بانو",
          "بنفشه",
          "بهار",
          "بهاران",
          "بهاره",
          "بهارک",
          "بهدیس",
          "بهدخت",
          "بهرخ",
          "بهشید",
          "بهناز",
          "بهنوش",
          "بوسه",
          "بیتا",
          "باران",
          "پانیذ",
          "پائیزه",
          "پارمیس",
          "پدیده",
          "پرتو",
          "پردیس",
          "پرستو",
          "پرند",
          "پرنیا",
          "پرنیان",
          "پروانه",
          "پروین",
          "پری",
          "پریا",
          "پریچهر",
          "پریدخت",
          "پریرو",
          "پریزاد",
          "پریسا",
          "پریشاد",
          "پریماه",
          "پریناز",
          "پریوش",
          "پگاه",
          "پوپک",
          "پوران",
          "پوران",
          "پوراندخت",
          "پوری",
          "پونه",
          "پژهان",
          "پیمانه",
          "پرنیان",
          "پارمیدا",
          "پادینا",
          "تیام",
          "تیارا",
          "تیاناز",
          "تیدا",
          "تابنده",
          "ترانه",
          "ترسا",
          "ترمه",
          "ترنه",
          "تهمینه",
          "تیشتر",
          "تیر",
          "ترنگ",
          "توراندخت",
          "توسکا",
          "تینا",
          "تیکا",
          "ته‌لار",
          "ته‌نیا",
          "تریفه",
          "تیروژ",
          "جوانه",
          "جوان",
          "چکامه",
          "خجسته",
          "خورشید",
          "خوروَش",
          "دانه",
          "دُرّی",
          "دریا",
          "دلارا",
          "دلارام",
          "دلبر",
          "دلکش",
          "دلوسه",
          "دوکا",
          "دینا",
          "رامش",
          "راشر",
          "رامینا",
          "رسا",
          "رها",
          "رهام",
          "روان",
          "رود",
          "رودابه",
          "روجا",
          "روشنک",
          "روناک",
          "رؤیا",
          "رکسانا",
          "روژین",
          "روژینا",
          "رازان",
          "ریزان",
          "زری",
          "زرین",
          "زرین‌دخت",
          "زویا",
          "زیبا",
          "زینا",
          "زیور",
          "زایه‌له",
          "ژاله",
          "ژرفا",
          "ژیلا",
          "ژینر",
          "ژینا",
          "سارک",
          "سارینا",
          "ساغر",
          "ساناز",
          "سایه",
          "سپیده",
          "ستاره",
          "ستوده",
          "سرگل",
          "سروناز",
          "سمانه",
          "سودابه",
          "سوری",
          "سوزان",
          "سوسن",
          "سوگل",
          "سوگند",
          "سیما",
          "سیمین",
          "شاپرک",
          "شاپری",
          "شادان",
          "شادی",
          "شانا",
          "شانار",
          "شایسته",
          "شبره",
          "شبنم",
          "شرمینه",
          "شکیبا",
          "شمیلا",
          "شمیم",
          "شهپر",
          "شهربانو",
          "شهرخ",
          "شهربانو",
          "شهرزاد",
          "شهرناز",
          "شهره",
          "شهناز",
          "شهین",
          "شوکا",
          "شقایق",
          "شکوفه",
          "شکوه",
          "شکیلا",
          "شیدا",
          "شیده",
          "شیرین",
          "شیرین‌بانو",
          "شیفته",
          "شیلا",
          "شیما",
          "شیوا",
          "شورانگیز",
          "غمزه",
          "غنچه",
          "فاختک",
          "فرانک",
          "فرشته",
          "فروزنده",
          "فروغ",
          "فرنیا",
          "فریبا",
          "فریما",
          "فرین",
          "فریناز",
          "فوژان",
          "فیروزه",
          "فریماه",
          "فرنوش",
          "قشنگ",
          "کتایون",
          "کمند",
          "کرانه",
          "کشور",
          "کیان",
          "کیانا",
          "کیجا",
          "کیمیا",
          "کیهانه",
          "گردآفرید",
          "گلاره",
          "گلاوژ",
          "گل‌افروز",
          "گل‌اندام",
          "گلبانو",
          "گلبهار",
          "گلابتون",
          "گلبیز",
          "گلپا",
          "گلپری",
          "گلپونه",
          "گلتاج",
          "گلتن",
          "گلرخ",
          "گلرو",
          "گلشن",
          "گلشید",
          "گلشیفته",
          "گلمیس",
          "گلنار",
          "گلناز",
          "گلنوش",
          "گل‌ورچین",
          "گلی",
          "گوهر",
          "گوهرشاد",
          "گیتا",
          "گیتی",
          "گیسو",
          "گیلا",
          "گیلان",
          "لورا",
          "لادن",
          "لاله",
          "لاله‌رخ",
          "مازون",
          "مامک",
          "مانا",
          "ماندان",
          "ماندانا",
          "مانلی",
          "ماتیسا",
          "ماه‌پری",
          "ماهتو",
          "ماه‌چهر",
          "ماهدخت",
          "ماه‌برزین",
          "ماهنوش",
          "ماه‌جهان",
          "ماهزاد",
          "ماهک",
          "ماه‌تی‌تی",
          "مرجان",
          "مرجانه",
          "مروارید",
          "مژده",
          "مژگان",
          "مسل",
          "مستانه",
          "مشکان‌دخت",
          "مشکین‌دخت",
          "مونا",
          "منیژه",
          "مهتا",
          "مهتاب",
          "مهدخت",
          "مهدیس",
          "مهرآذر",
          "مهرا",
          "مهراد",
          "مهراب",
          "مهرانگیز",
          "مهرانه",
          "مهربانو",
          "مهرخ",
          "مهرریز",
          "مهرسا",
          "مهروا",
          "مهرک",
          "مهری",
          "مهزاد",
          "مهسا",
          "مهستی",
          "مهشید",
          "مهکامه",
          "مهناز",
          "مهنوش",
          "مهکامه",
          "مهین",
          "موژان",
          "میترا",
          "میخک",
          "میگل",
          "میشکا",
          "مینا",
          "مینو",
          "نازآفرین",
          "نازگل",
          "نازنین",
          "نازیلا",
          "ناژیلا",
          "ناژین",
          "ناهید",
          "نرگس",
          "نرمین",
          "نسترن",
          "نسرین",
          "نگار",
          "نگین",
          "نهال",
          "نوا",
          "نوش‌آفرین",
          "نوشزاد",
          "نوشین",
          "نیلوفر",
          "نیکو",
          "نیکی",
          "نیکسا",
          "نیشا",
          "نیوشا",
          "ویس",
          "ویدا",
          "وندا",
          "هستی",
          "هما",
          "هنگامه",
          "هوروَش",
          "یارا",
          "یاس",
          "یاسمن",
          "یاسمین",
          "یگانه",
          "یکتا",
          "یسنا",
          "یوتاب"
        ],
        "first_name": [
          "آبان دخت",
          "آبتین",
          "آتوسا",
          "آفر",
          "آفره دخت",
          "آذرنوش‌",
          "آذین",
          "آراه",
          "آرزو",
          "آرش",
          "آرتین",
          "آرتام",
          "آرتمن",
          "آرشام",
          "آرمان",
          "آرمین",
          "آرمیتا",
          "آریا فر",
          "آریا",
          "آریا مهر",
          "آرین",
          "آزاده",
          "آزرم",
          "آزرمدخت",
          "آزیتا",
          "آناهیتا",
          "آونگ",
          "آهو",
          "آیدا",
          "اتسز",
          "اختر",
          "ارد",
          "ارد شیر",
          "اردوان",
          "ارژن",
          "ارژنگ",
          "ارسلان",
          "ارغوان",
          "ارمغان",
          "ارنواز",
          "اروانه",
          "استر",
          "اسفندیار",
          "اشکان",
          "اشکبوس",
          "افسانه",
          "افسون",
          "افشین",
          "امید",
          "انوش (‌ آنوشا )",
          "انوشروان",
          "اورنگ",
          "اوژن",
          "اوستا",
          "اهورا",
          "ایاز",
          "ایران",
          "ایراندخت",
          "ایرج",
          "ایزدیار",
          "بابک",
          "باپوک",
          "باربد",
          "بارمان",
          "بامداد",
          "بامشاد",
          "بانو",
          "بختیار",
          "برانوش",
          "بردیا",
          "برزو",
          "برزویه",
          "برزین",
          "برمک",
          "بزرگمهر",
          "بنفشه",
          "بوژان",
          "بویان",
          "بهار",
          "بهارک",
          "بهاره",
          "بهتاش",
          "بهداد",
          "بهرام",
          "بهدیس",
          "بهرخ",
          "بهرنگ",
          "بهروز",
          "بهزاد",
          "بهشاد",
          "بهمن",
          "بهناز",
          "بهنام",
          "بهنود",
          "بهنوش",
          "بیتا",
          "بیژن",
          "پارسا",
          "پاکان",
          "پاکتن",
          "پاکدخت",
          "پانته آ",
          "پدرام",
          "پرتو",
          "پرشنگ",
          "پرتو",
          "پرستو",
          "پرویز",
          "پردیس",
          "پرهام",
          "پژمان",
          "پژوا",
          "پرنیا",
          "پشنگ",
          "پروانه",
          "پروین",
          "پری",
          "پریچهر",
          "پریدخت",
          "پریسا",
          "پرناز",
          "پریوش",
          "پریا",
          "پوپک",
          "پوران",
          "پوراندخت",
          "پوریا",
          "پولاد",
          "پویا",
          "پونه",
          "پیام",
          "پیروز",
          "پیمان",
          "تابان",
          "تاباندخت",
          "تاجی",
          "تارا",
          "تاویار",
          "ترانه",
          "تناز",
          "توران",
          "توراندخت",
          "تورج",
          "تورتک",
          "توفان",
          "توژال",
          "تیر داد",
          "تینا",
          "تینو",
          "جابان",
          "جامین",
          "جاوید",
          "جریره",
          "جمشید",
          "جوان",
          "جویا",
          "جهان",
          "جهانبخت",
          "جهانبخش",
          "جهاندار",
          "جهانگیر",
          "جهان بانو",
          "جهاندخت",
          "جهان ناز",
          "جیران",
          "چابک",
          "چالاک",
          "چاوش",
          "چترا",
          "چوبین",
          "چهرزاد",
          "خاوردخت",
          "خداداد",
          "خدایار",
          "خرم",
          "خرمدخت",
          "خسرو",
          "خشایار",
          "خورشید",
          "دادمهر",
          "دارا",
          "داراب",
          "داریا",
          "داریوش",
          "دانوش",
          "داور‌",
          "دایان",
          "دریا",
          "دل آرا",
          "دل آویز",
          "دلارام",
          "دل انگیز",
          "دلبر",
          "دلبند",
          "دلربا",
          "دلشاد",
          "دلکش",
          "دلناز",
          "دلنواز",
          "دورشاسب",
          "دنیا",
          "دیااکو",
          "دیانوش",
          "دیبا",
          "دیبا دخت",
          "رابو",
          "رابین",
          "رادبانو",
          "رادمان",
          "رازبان",
          "راژانه",
          "راسا",
          "رامتین",
          "رامش",
          "رامشگر",
          "رامونا",
          "رامیار",
          "رامیلا",
          "رامین",
          "راویار",
          "رژینا",
          "رخپاک",
          "رخسار",
          "رخشانه",
          "رخشنده",
          "رزمیار",
          "رستم",
          "رکسانا",
          "روبینا",
          "رودابه",
          "روزبه",
          "روشنک",
          "روناک",
          "رهام",
          "رهی",
          "ریبار",
          "راسپینا",
          "زادبخت",
          "زاد به",
          "زاد چهر",
          "زاد فر",
          "زال",
          "زادماسب",
          "زاوا",
          "زردشت",
          "زرنگار",
          "زری",
          "زرین",
          "زرینه",
          "زمانه",
          "زونا",
          "زیبا",
          "زیبار",
          "زیما",
          "زینو",
          "ژاله",
          "ژالان",
          "ژیار",
          "ژینا",
          "ژیوار",
          "سارا",
          "سارک",
          "سارنگ",
          "ساره",
          "ساسان",
          "ساغر",
          "سام",
          "سامان",
          "سانا",
          "ساناز",
          "سانیار",
          "ساویز",
          "ساهی",
          "ساینا",
          "سایه",
          "سپنتا",
          "سپند",
          "سپهر",
          "سپهرداد",
          "سپیدار",
          "سپید بانو",
          "سپیده",
          "ستاره",
          "ستی",
          "سرافراز",
          "سرور",
          "سروش",
          "سرور",
          "سوبا",
          "سوبار",
          "سنبله",
          "سودابه",
          "سوری",
          "سورن",
          "سورنا",
          "سوزان",
          "سوزه",
          "سوسن",
          "سومار",
          "سولان",
          "سولماز",
          "سوگند",
          "سهراب",
          "سهره",
          "سهند",
          "سیامک",
          "سیاوش",
          "سیبوبه ‌",
          "سیما",
          "سیمدخت",
          "سینا",
          "سیمین",
          "سیمین دخت",
          "شاپرک",
          "شادی",
          "شادمهر",
          "شاران",
          "شاهپور",
          "شاهدخت",
          "شاهرخ",
          "شاهین",
          "شاهیندخت",
          "شایسته",
          "شباهنگ",
          "شب بو",
          "شبدیز",
          "شبنم",
          "شراره",
          "شرمین",
          "شروین",
          "شکوفه",
          "شکفته",
          "شمشاد",
          "شمین",
          "شوان",
          "شمیلا",
          "شورانگیز",
          "شوری",
          "شهاب",
          "شهبار",
          "شهباز",
          "شهبال",
          "شهپر",
          "شهداد",
          "شهرآرا",
          "شهرام",
          "شهربانو",
          "شهرزاد",
          "شهرناز",
          "شهرنوش",
          "شهره",
          "شهریار",
          "شهرزاد",
          "شهلا",
          "شهنواز",
          "شهین",
          "شیبا",
          "شیدا",
          "شیده",
          "شیردل",
          "شیرزاد",
          "شیرنگ",
          "شیرو",
          "شیرین دخت",
          "شیما",
          "شینا",
          "شیرین",
          "شیوا",
          "طوس",
          "طوطی",
          "طهماسب",
          "طهمورث",
          "غوغا",
          "غنچه",
          "فتانه",
          "فدا",
          "فراز",
          "فرامرز",
          "فرانک",
          "فراهان",
          "فربد",
          "فربغ",
          "فرجاد",
          "فرخ",
          "فرخ پی",
          "فرخ داد",
          "فرخ رو",
          "فرخ زاد",
          "فرخ لقا",
          "فرخ مهر",
          "فرداد",
          "فردیس",
          "فرین",
          "فرزاد",
          "فرزام",
          "فرزان",
          "فرزانه",
          "فرزین",
          "فرشاد",
          "فرشته",
          "فرشید",
          "فرمان",
          "فرناز",
          "فرنگیس",
          "فرنود",
          "فرنوش",
          "فرنیا",
          "فروتن",
          "فرود",
          "فروز",
          "فروزان",
          "فروزش",
          "فروزنده",
          "فروغ",
          "فرهاد",
          "فرهنگ",
          "فرهود",
          "فربار",
          "فریبا",
          "فرید",
          "فریدخت",
          "فریدون",
          "فریمان",
          "فریناز",
          "فرینوش",
          "فریوش",
          "فیروز",
          "فیروزه",
          "قابوس",
          "قباد",
          "قدسی",
          "کابان",
          "کابوک",
          "کارا",
          "کارو",
          "کاراکو",
          "کامبخت",
          "کامبخش",
          "کامبیز",
          "کامجو",
          "کامدین",
          "کامران",
          "کامراوا",
          "کامک",
          "کامنوش",
          "کامیار",
          "کانیار",
          "کاووس",
          "کاوه",
          "کتایون",
          "کرشمه",
          "کسری",
          "کلاله",
          "کمبوجیه",
          "کوشا",
          "کهبد",
          "کهرام",
          "کهزاد",
          "کیارش",
          "کیان",
          "کیانا",
          "کیانچهر",
          "کیاندخت",
          "کیانوش",
          "کیاوش",
          "کیخسرو",
          "کیقباد",
          "کیکاووس",
          "کیوان",
          "کیوان دخت",
          "کیومرث",
          "کیهان",
          "کیاندخت",
          "کیهانه",
          "گرد آفرید",
          "گردان",
          "گرشا",
          "گرشاسب",
          "گرشین",
          "گرگین",
          "گزل",
          "گشتاسب",
          "گشسب",
          "گشسب بانو",
          "گل",
          "گل آذین",
          "گل آرا‌",
          "گلاره",
          "گل افروز",
          "گلاله",
          "گل اندام",
          "گلاویز",
          "گلباد",
          "گلبار",
          "گلبام",
          "گلبان",
          "گلبانو",
          "گلبرگ",
          "گلبو",
          "گلبهار",
          "گلبیز",
          "گلپاره",
          "گلپر",
          "گلپری",
          "گلپوش",
          "گل پونه",
          "گلچین",
          "گلدخت",
          "گلدیس",
          "گلربا",
          "گلرخ",
          "گلرنگ",
          "گلرو",
          "گلشن",
          "گلریز",
          "گلزاد",
          "گلزار",
          "گلسا",
          "گلشید",
          "گلنار",
          "گلناز",
          "گلنسا",
          "گلنواز",
          "گلنوش",
          "گلی",
          "گودرز",
          "گوماتو",
          "گهر چهر",
          "گوهر ناز",
          "گیتی",
          "گیسو",
          "گیلدا",
          "گیو",
          "لادن",
          "لاله",
          "لاله رخ",
          "لاله دخت",
          "لبخند",
          "لقاء",
          "لومانا",
          "لهراسب",
          "مارال",
          "ماری",
          "مازیار",
          "ماکان",
          "مامک",
          "مانا",
          "ماندانا",
          "مانوش",
          "مانی",
          "مانیا",
          "ماهان",
          "ماهاندخت",
          "ماه برزین",
          "ماه جهان",
          "ماهچهر",
          "ماهدخت",
          "ماهور",
          "ماهرخ",
          "ماهزاد",
          "مردآویز",
          "مرداس",
          "مرزبان",
          "مرمر",
          "مزدک",
          "مژده",
          "مژگان",
          "مستان",
          "مستانه",
          "مشکاندخت",
          "مشکناز",
          "مشکین دخت",
          "منیژه",
          "منوچهر",
          "مهبانو",
          "مهبد",
          "مه داد",
          "مهتاب",
          "مهدیس",
          "مه جبین",
          "مه دخت",
          "مهر آذر",
          "مهر آرا",
          "مهر آسا",
          "مهر آفاق",
          "مهر افرین",
          "مهرآب",
          "مهرداد",
          "مهر افزون",
          "مهرام",
          "مهران",
          "مهراندخت",
          "مهراندیش",
          "مهرانفر",
          "مهرانگیز",
          "مهرداد",
          "مهر دخت",
          "مهرزاده ‌",
          "مهرناز",
          "مهرنوش",
          "مهرنکار",
          "مهرنیا",
          "مهروز",
          "مهری",
          "مهریار",
          "مهسا",
          "مهستی",
          "مه سیما",
          "مهشاد",
          "مهشید",
          "مهنام",
          "مهناز",
          "مهنوش",
          "مهوش",
          "مهیار",
          "مهین",
          "مهین دخت",
          "میترا",
          "میخک",
          "مینا",
          "مینا دخت",
          "مینو",
          "مینودخت",
          "مینو فر",
          "نادر",
          "ناز آفرین",
          "نازبانو",
          "نازپرور",
          "نازچهر",
          "نازفر",
          "نازلی",
          "نازی",
          "نازیدخت",
          "نامور",
          "ناهید",
          "ندا",
          "نرسی",
          "نرگس",
          "نرمک",
          "نرمین",
          "نریمان",
          "نسترن",
          "نسرین",
          "نسرین دخت",
          "نسرین نوش",
          "نکیسا",
          "نگار",
          "نگاره",
          "نگارین",
          "نگین",
          "نوا",
          "نوش",
          "نوش آذر",
          "نوش آور",
          "نوشا",
          "نوش آفرین",
          "نوشدخت",
          "نوشروان",
          "نوشفر",
          "نوشناز",
          "نوشین",
          "نوید",
          "نوین",
          "نوین دخت",
          "نیش ا",
          "نیک بین",
          "نیک پی",
          "نیک چهر",
          "نیک خواه",
          "نیکداد",
          "نیکدخت",
          "نیکدل",
          "نیکزاد",
          "نیلوفر",
          "نیما",
          "وامق",
          "ورجاوند",
          "وریا",
          "وشمگیر",
          "وهرز",
          "وهسودان",
          "ویدا",
          "ویس",
          "ویشتاسب",
          "ویگن",
          "هژیر",
          "هخامنش",
          "هربد( هیربد )",
          "هرمز",
          "همایون",
          "هما",
          "همادخت",
          "همدم",
          "همراز",
          "همراه",
          "هنگامه",
          "هوتن",
          "هور",
          "هورتاش",
          "هورچهر",
          "هورداد",
          "هوردخت",
          "هورزاد",
          "هورمند",
          "هوروش",
          "هوشنگ",
          "هوشیار",
          "هومان",
          "هومن",
          "هونام",
          "هویدا",
          "هیتاسب",
          "هیرمند",
          "هیما",
          "هیوا",
          "یادگار",
          "یاسمن ( یاسمین )",
          "یاشار",
          "یاور",
          "یزدان",
          "یگانه",
          "یوشیتا"
        ],
        "last_name": [
          "عارف",
          "عاشوری",
          "عالی",
          "عبادی",
          "عبدالکریمی",
          "عبدالملکی",
          "عراقی",
          "عزیزی",
          "عصار",
          "عقیلی",
          "علم",
          "علم‌الهدی",
          "علی عسگری",
          "علی‌آبادی",
          "علیا",
          "علی‌پور",
          "علی‌زمانی",
          "عنایت",
          "غضنفری",
          "غنی",
          "فارسی",
          "فاطمی",
          "فانی",
          "فتاحی",
          "فرامرزی",
          "فرج",
          "فرشیدورد",
          "فرمانفرمائیان",
          "فروتن",
          "فرهنگ",
          "فریاد",
          "فنایی",
          "فنی‌زاده",
          "فولادوند",
          "فهمیده",
          "قاضی",
          "قانعی",
          "قانونی",
          "قمیشی",
          "قنبری",
          "قهرمان",
          "قهرمانی",
          "قهرمانیان",
          "قهستانی",
          "کاشی",
          "کاکاوند",
          "کامکار",
          "کاملی",
          "کاویانی",
          "کدیور",
          "کردبچه",
          "کرمانی",
          "کریمی",
          "کلباسی",
          "کمالی",
          "کوشکی",
          "کهنمویی",
          "کیان",
          "کیانی (نام خانوادگی)",
          "کیمیایی",
          "گل محمدی",
          "گلپایگانی",
          "گنجی",
          "لاجوردی",
          "لاچینی",
          "لاهوتی",
          "لنکرانی",
          "لوکس",
          "مجاهد",
          "مجتبایی",
          "مجتبوی",
          "مجتهد شبستری",
          "مجتهدی",
          "مجرد",
          "محجوب",
          "محجوبی",
          "محدثی",
          "محمدرضایی",
          "محمدی",
          "مددی",
          "مرادخانی",
          "مرتضوی",
          "مستوفی",
          "مشا",
          "مصاحب",
          "مصباح",
          "مصباح‌زاده",
          "مطهری",
          "مظفر",
          "معارف",
          "معروف",
          "معین",
          "مفتاح",
          "مفتح",
          "مقدم",
          "ملایری",
          "ملک",
          "ملکیان",
          "منوچهری",
          "موحد",
          "موسوی",
          "موسویان",
          "مهاجرانی",
          "مهدی‌پور",
          "میرباقری",
          "میردامادی",
          "میرزاده",
          "میرسپاسی",
          "میزبانی",
          "ناظری",
          "نامور",
          "نجفی",
          "ندوشن",
          "نراقی",
          "نعمت‌زاده",
          "نقدی",
          "نقیب‌زاده",
          "نواب",
          "نوبخت",
          "نوبختی",
          "نهاوندی",
          "نیشابوری",
          "نیلوفری",
          "واثقی",
          "واعظ",
          "واعظ‌زاده",
          "واعظی",
          "وکیلی",
          "هاشمی",
          "هاشمی رفسنجانی",
          "هاشمیان",
          "هامون",
          "هدایت",
          "هراتی",
          "هروی",
          "همایون",
          "همت",
          "همدانی",
          "هوشیار",
          "هومن",
          "یاحقی",
          "یادگار",
          "یثربی",
          "یلدا"
        ],
        "male_first_name": [
          "آبتین",
          "آتش",
          "آترین",
          "آتورپات",
          "آذرخش",
          "آذرمه",
          "آذین",
          "آرتین",
          "آرام",
          "آراز",
          "آراد",
          "آرتا",
          "آرتان",
          "آرش",
          "آرشام",
          "آرمان",
          "آرمین",
          "آروین",
          "آریا",
          "آریابان",
          "آریانا",
          "آرین",
          "آریوبرزن",
          "آزاد",
          "آزرمگان",
          "آساد",
          "آستیاژ",
          "آستیاگ",
          "آلان",
          "آوه",
          "آویژه",
          "آیین‌گشسب",
          "آریو",
          "آریافر",
          "آریامن",
          "آریامنش",
          "آریامهر",
          "آریان",
          "اخگر",
          "ارخشا",
          "اُرُد",
          "اردشیر",
          "اردلان",
          "اردوان",
          "ارژنگ",
          "ارس",
          "ارشا",
          "آرشام",
          "الیاس",
          "اَرَشک",
          "ارشیا",
          "ارمایل",
          "اروند",
          "اژدر",
          "اسفندیار",
          "اشک",
          "اشکان",
          "اشکبوس",
          "افراسیاب",
          "افشار",
          "افشین",
          "البرز",
          "الوند",
          "امید",
          "انوش",
          "انوشیروان",
          "اورمزد",
          "اورنگ",
          "ایرج",
          "ایشتوویگو",
          "بابک",
          "باربد",
          "بامداد",
          "بامین",
          "بامشاد",
          "بردیا",
          "بزرگمهر",
          "به‌آیین",
          "بهبد",
          "بهرام",
          "بهمن",
          "بهمنش",
          "بیژن",
          "بهروز",
          "بهراد",
          "بهرنگ",
          "بهزاد",
          "بهداد",
          "بهشاد",
          "بهنام",
          "برسام",
          "برزو",
          "برنا",
          "برزن",
          "برومند",
          "برزین",
          "بهداد",
          "تیرداد",
          "تهماسب",
          "تهمتن",
          "تهمورث",
          "تورج",
          "تابان",
          "تیریژ",
          "جاماسب",
          "جاوید",
          "جمشید",
          "جهانگیر",
          "جهان‌بخش",
          "جهانشاه",
          "جهاندار",
          "جهان",
          "چنگیز",
          "چه‌کو",
          "چیا",
          "چیاکو",
          "چومان",
          "خداداد",
          "خدابخش",
          "خدایار",
          "خسرو",
          "خشایار",
          "خوبیار",
          "خورشید",
          "خوناس",
          "خناو",
          "دارا",
          "دادویه",
          "دادمهر",
          "دامون",
          "دانوش",
          "دانو",
          "داراب",
          "داریوش",
          "دیاکو",
          "رادین",
          "رامبد",
          "رامین",
          "رامتین",
          "رخشان",
          "رستان",
          "روزبه",
          "رادمان",
          "رامان",
          "رایان",
          "رایکا",
          "رها",
          "رهام",
          "راد",
          "رستم",
          "ریونیز",
          "ریکا",
          "زاب",
          "زال",
          "زامیاد",
          "زرتشت",
          "زردشت",
          "زرمهر",
          "زند",
          "زوبین",
          "سالار",
          "ساسان",
          "سامان",
          "سام",
          "سروش",
          "سپهر",
          "سپنتا",
          "سورن",
          "سورنا",
          "سوشیانت",
          "سوشیانس",
          "سهراب",
          "سهند",
          "سیامک",
          "سیاوش",
          "سیروس",
          "سینا",
          "شادمهر",
          "شروین",
          "شراگیم",
          "شاپور",
          "شایا",
          "شایان",
          "شاهرخ",
          "شاهین",
          "شباهنگ",
          "شهرام",
          "شاهکام",
          "شهراد",
          "شهاب",
          "شهرداد",
          "شهریار",
          "شهروز",
          "شیرزاد",
          "شیرنگ",
          "شهیار",
          "شهبد",
          "شهنام",
          "شوپه",
          "شیریزدان",
          "شاهو",
          "شیروان",
          "شه‌مال",
          "شه‌مزین",
          "شیرکو",
          "شورش",
          "فربد",
          "فرزان",
          "فرسا",
          "فرامرز",
          "فرزاد",
          "فرزام",
          "فرزین",
          "فردین",
          "فرداد",
          "فرود",
          "فرورتیش",
          "فرمان",
          "فرهنگ",
          "فریبرز",
          "فرناد",
          "فرهاد",
          "فرنام",
          "فرهام",
          "فرهود",
          "فروهر",
          "فیروز",
          "فرشاد",
          "فرشید",
          "فرخ",
          "فرخزاد",
          "فربد",
          "فهام",
          "فریا",
          "کوروش",
          "کارن",
          "کامبیز",
          "کامران",
          "کامشاد",
          "کامیار",
          "کاوه",
          "کاووس",
          "کنارنگ",
          "کورس",
          "کورش",
          "کیانوش",
          "کیارش",
          "کیاوش",
          "کیا",
          "کیان",
          "کیوس",
          "کوشا",
          "کیخسرو",
          "کیقباد",
          "کیکاووس",
          "کیوان",
          "کیومرث",
          "کیوس",
          "کاردو",
          "کاروان",
          "کاروخ",
          "کازیوه",
          "کارزان",
          "کاژاو",
          "کوماس",
          "گرگین",
          "گستهم",
          "گیو",
          "گودرز",
          "گَرسیوَز",
          "گرشاسب",
          "گشتاسب",
          "گلینوش",
          "گوران",
          "گووه‌ند",
          "لوران(نام",
          "لهراسب",
          "لاس",
          "لاوچاک",
          "لیزان",
          "مهدیار",
          "مازیار",
          "ماکان",
          "مانشت",
          "مانی",
          "ماهان",
          "مرداس",
          "مهرگان",
          "مرداویج",
          "مزدک",
          "مکابیز",
          "منوچهر",
          "مهبد",
          "مهداد",
          "مهرداد",
          "مهرزاد",
          "مهرشاد",
          "مهران",
          "مهزاد",
          "مهراب",
          "مهرشاد",
          "مهزیار",
          "مهیار",
          "مهرنگ",
          "میلاد",
          "مه‌ریوان",
          "میلان",
          "میران",
          "نرمن",
          "نریمان",
          "نکیسا",
          "نوید",
          "نیما",
          "نیوشا",
          "نوژن",
          "نوذر",
          "نیاسا",
          "ناسیکو",
          "نسکو",
          "نه‌به‌ز",
          "نه‌سره‌و",
          "نه‌هروز",
          "نه‌وشیروان",
          "نه‌که‌روز",
          "نچیروان",
          "وارش",
          "ونداد",
          "وریا",
          "وندیداد",
          "وهومن",
          "هیرمان",
          "هامون",
          "هرمز",
          "هورمزد",
          "هورموند",
          "هومن",
          "هوشنگ",
          "هوتن",
          "هومان",
          "هوشیار",
          "هورداد",
          "یاور",
          "یزدگرد",
          "یزدان",
          "یادگار"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "آقای",
          "خانم",
          "دکتر"
        ]
      }
    },
    "hello": "سلام",
    "helpers": {
      "select": {
        "prompt": "لطفا انتخاب کنید"
      },
      "submit": {
        "create": "ایجاد %{model}",
        "submit": "ذخیره‌ی %{model}",
        "update": "بروز رسانی %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "آ": "a",
          "ا": "a",
          "ب": "b",
          "ت": "t",
          "ث": "s",
          "ج": "g",
          "ح": "h",
          "خ": "kh",
          "د": "d",
          "ذ": "z",
          "ر": "r",
          "ز": "z",
          "س": "s",
          "ش": "sh",
          "ص": "s",
          "ض": "z",
          "ط": "t",
          "ظ": "z",
          "ع": "a",
          "غ": "q",
          "ف": "f",
          "ق": "q",
          "ل": "l",
          "م": "m",
          "ن": "n",
          "ه": "h",
          "و": "v",
          "پ": "p",
          "چ": "ch",
          "ژ": "j",
          "ک": "k",
          "گ": "gh",
          "ی": "i",
          "۰": "0",
          "۱": "1",
          "۲": "2",
          "۳": "3",
          "۴": "4",
          "۵": "5",
          "۶": "6",
          "۷": "7",
          "۸": "8",
          "۹": "9"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": "٬",
          "format": "%n %u",
          "precision": 0,
          "separator": "٫",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "﷼"
        }
      },
      "format": {
        "delimiter": "٬",
        "precision": 2,
        "separator": "٫",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "میلیارد",
            "million": "میلیون",
            "quadrillion": "کادریلیون",
            "thousand": "هزار",
            "trillion": "تریلیون",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "بایت",
              "other": "بایت"
            },
            "gb": "گیگابایت",
            "kb": "کیلوبایت",
            "mb": "مگابایت",
            "tb": "ترابایت"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " و ",
        "two_words_connector": " و ",
        "words_connector": "، "
      }
    },
    "time": {
      "am": "قبل از ظهر",
      "formats": {
        "default": "%A، %e %B %Y، ساعت %H:%M:%S (%Z)",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%e %B %Y، ساعت %H:%M",
        "short": "%e %B، ساعت %H:%M"
      },
      "pm": "بعد از ظهر"
    },
    "welcome": "خوش آمدید"
  },
  "fi": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Vahvistus lähetetty",
          "confirmation_token": "Vahvistuskoodi",
          "confirmed_at": "Vahvistettu",
          "created_at": "Luotu",
          "current_password": "Nykyinen salasana",
          "current_sign_in_at": "Nykyinen kirjautuminen",
          "current_sign_in_ip": "Nykyisen kirjautumisen IP",
          "email": "Sähköposti",
          "encrypted_password": "Salattu salasana",
          "failed_attempts": "Epäonnistuneita yrityksiä",
          "last_sign_in_at": "Viimeinen kirjautuminen",
          "last_sign_in_ip": "Viimeisen kirjautumisen IP",
          "locked_at": "Lukittu",
          "password": "Salasana",
          "password_confirmation": "Salasanan vahvistus",
          "remember_created_at": "Muista minut luotu",
          "remember_me": "Muista minut",
          "reset_password_sent_at": "Salasanan nollaamistunniste lähetetty",
          "reset_password_token": "Salasanan nollaamistunniste",
          "sign_in_count": "Sisäänkirjautumisia",
          "unconfirmed_email": "Vahvistamaton sähköposti",
          "unlock_token": "Lukituksen poistotunniste",
          "updated_at": "Päivitetty"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validointi epäonnistui: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Ei voida poistaa mallia koska tästä riippuvaisia %{record} löytyy",
            "has_one": "Ei voida poistaa mallia koska tästä riippuvainen %{record} löytyy"
          }
        }
      },
      "models": {
        "user": {
          "one": "Käyttäjä",
          "other": "Käyttäjä"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
      ],
      "abbr_month_names": [
        null,
        "tammi",
        "helmi",
        "maalis",
        "huhti",
        "touko",
        "kesä",
        "heinä",
        "elo",
        "syys",
        "loka",
        "marras",
        "joulu"
      ],
      "day_names": [
        "sunnuntai",
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai"
      ],
      "formats": {
        "default": "%-d.%-m.%Y",
        "long": "%d. %Bta %Y",
        "short": "%d. %b"
      },
      "month_names": [
        null,
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kesäkuu",
        "heinäkuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "noin tunti",
          "other": "noin %{count} tuntia"
        },
        "about_x_months": {
          "one": "noin kuukausi",
          "other": "noin %{count} kuukautta"
        },
        "about_x_years": {
          "one": "vuosi",
          "other": "noin %{count} vuotta"
        },
        "almost_x_years": {
          "one": "melkein yksi vuosi",
          "other": "melkein %{count} vuotta"
        },
        "half_a_minute": "puoli minuuttia",
        "less_than_x_minutes": {
          "one": "alle minuutti",
          "other": "alle %{count} minuuttia"
        },
        "less_than_x_seconds": {
          "one": "alle sekunti",
          "other": "alle %{count} sekuntia"
        },
        "over_x_years": {
          "one": "yli vuosi",
          "other": "yli %{count} vuotta"
        },
        "x_days": {
          "one": "päivä",
          "other": "%{count} päivää"
        },
        "x_minutes": {
          "one": "minuutti",
          "other": "%{count} minuuttia"
        },
        "x_months": {
          "one": "kuukausi",
          "other": "%{count} kuukautta"
        },
        "x_seconds": {
          "one": "sekunti",
          "other": "%{count} sekuntia"
        },
        "x_years": {
          "one": "vuosi",
          "other": "%{count} vuotta"
        }
      },
      "prompts": {
        "day": "Päivä",
        "hour": "Tunti",
        "minute": "Minuutti",
        "month": "Kuukausi",
        "second": "Sekunti",
        "year": "Vuosi"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Sähköpostiosoitteesi on nyt vahvistettu.",
        "new": {
          "resend_confirmation_instructions": "Uudelleenlähetä vahvistusohjeet"
        },
        "send_instructions": "Saat hetken kuluttua sähköpostiisi ohjeet sähköpostiosoitteesi vahvistamiseen.",
        "send_paranoid_instructions": "Mikäli sähköpostiosoitteesi on tallennettu järjestelmäämme, lähetämme sinulle ohjeet sähköpostiosoitteesi vahvistamiseksi muutaman minuutin kuluessa."
      },
      "failure": {
        "already_authenticated": "Olet jo kirjautunut sisään.",
        "inactive": "Tunnustasi ei ole vielä aktivoitu.",
        "invalid": "Väärä %{authentication_keys} tai salasana.",
        "last_attempt": "Käyttäjätunnuksesi lukitaan seuraavan epäonnistuneen kirjautumisen jälkeen.",
        "locked": "Tunnuksesi on lukittu.",
        "not_found_in_database": "Väärä %{authentication_keys} tai salasana.",
        "timeout": "Istuntosi on vanhentunut, ole hyvä ja kirjaudu sisään jatkaaksesi.",
        "unauthenticated": "Sinun pitää kirjautua sisään tai rekisteröityä ennen kuin voit jatkaa.",
        "unconfirmed": "Sinun täytyy vahvistaa sähköpostiosoitteesi ennen kuin voit jatkaa."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Vahvista käyttäjätunnukseni",
          "greeting": "Tervetuloa, %{recipient}!",
          "instruction": "Vahvista sähköpostisi painamalla alla olevaa linkkiä:",
          "subject": "Vahvistusohjeet"
        },
        "email_changed": {
          "greeting": "Hei %{recipient}!",
          "message": "Tämä on ilmoitus siitä, että sähköpostiosoitteenne on vaihdettu osoitteeksi %{email}.",
          "message_unconfirmed": "Tämä on ilmoitus siitä, että sähköpostiosoitteenne on vaihtumassa osoitteeksi %{email}.",
          "subject": "Sähköpostiosoite vaihdettu"
        },
        "password_change": {
          "greeting": "Hei %{recipient}!",
          "message": "Tämä on ilmoitus salasananne vaihtumisesta.",
          "subject": "Salasana vaihdettu"
        },
        "reset_password_instructions": {
          "action": "Vaihda salasanani",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Joku on pyytänyt käyttäjätunnuksesi salasanan vaihtoa. Tämä voidaan suorittaa painamalla linkkiä alla.",
          "instruction_2": "Jos et pyytänyt tätä, voit jättää tämän sähköpostin huomiotta.",
          "instruction_3": "Salasanaasi ei vaihdeta ennen kuin painat yllä olevaa linkkiä ja syötät uuden salasanan.",
          "subject": "Ohjeet salasanan vaihtoon"
        },
        "unlock_instructions": {
          "action": "Poista käyttäjätunnukseni lukitus",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Paina alla olevaa linkkiä poistaaksesi lukituksen:",
          "message": "Käyttäjätunnuksesi on lukittu johtuen liian monesta epäonnistuneesta kirjautumisyrityksestä.",
          "subject": "Ohjeet tunnuksen lukituksen poistoon"
        }
      },
      "omniauth_callbacks": {
        "failure": "Valtuutus käyttäen palvelua %{kind} epäonnistui, koska \"%{reason}\".",
        "success": "Onnistuneesti valtuutettu käyttäen palvelua %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Vaihda salasanani",
          "change_your_password": "Vaihda salasanasi",
          "confirm_new_password": "Vahvista uusi salasana",
          "new_password": "Uusi salasana"
        },
        "new": {
          "forgot_your_password": "Unohditko salasanasi?",
          "send_me_reset_password_instructions": "Lähetä minulle salasanan vaihto-ohjeet"
        },
        "no_token": "Et voi päästä tälle sivulle tulematta salasanannollaussähköpostin kautta. Mikäli tulet salasanannollaussähköpostiviestistä, varmista että syötit koko verkko-osoitteen osoiteriville.",
        "send_instructions": "Saat hetken kuluttua sähköpostiisi ohjeet salasanan vaihtoon.",
        "send_paranoid_instructions": "Mikäli sähköpostiosoitteesi on tallennettu järjestelmäämme, lähetämme salasananpalautuslinkin sähköpostiisi muutaman minuutin kuluessa.",
        "updated": "Salasanasi on nyt vaihdettu. Olet kirjautuneena sisälle.",
        "updated_not_active": "Salasanasi on vaihdettu."
      },
      "registrations": {
        "destroyed": "Näkemiin! Käyttäjätunnuksesi on nyt poistettu. Toivottavasti näemme sinut vielä uudelleen.",
        "edit": {
          "are_you_sure": "Oletko varma?",
          "cancel_my_account": "Poista käyttäjätunnukseni",
          "currently_waiting_confirmation_for_email": "Odotetaan vahvistusta sähköpostille: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "jätä tämä tyhjäksi, mikäli et halua vaihtaa",
          "title": "Muokkaa %{resource}",
          "unhappy": "Onneton?",
          "update": "Päivitä",
          "we_need_your_current_password_to_confirm_your_changes": "tarvitsemme nykyisen salasanasi muutoksien vahvistamiseen"
        },
        "new": {
          "sign_up": "Rekisteröidy"
        },
        "signed_up": "Tervetuloa! Rekisteröintisi onnistui.",
        "signed_up_but_inactive": "Olet rekisteröitynyt onnistuneesti. Et kuitenkaan voi kirjautua ennen kuin käyttäjätunnuksesi on aktivoitu.",
        "signed_up_but_locked": "Olet rekisteröitynyt onnistuneesti. Et kuitenkaan voi kirjautua, koska käyttäjätunnuksesi on lukittu.",
        "signed_up_but_unconfirmed": "Sähköpostiisi on lähetetty vahvistusviesti. Avaa viestissä oleva linkki aktivoidaksesi käyttäjätunnuksesi.",
        "update_needs_confirmation": "Tiedot päivitettiin onnistuneesti, mutta meidän täytyy vielä varmistaa uusi sähköpostiosoitteesi. Tarkista sähköpostisi ja klikkaa varmistuslinkkiä varmistaaksesi uuden sähköpostiosoitteesti.",
        "updated": "Käyttäjätunnuksesi on päivitetty.",
        "updated_but_not_signed_in": "Käyttäjätunnuksesi on päivitetty, mutta koska salasanasi on vaihdettu, pitää sinun kirjautua sisään uudelleen"
      },
      "sessions": {
        "already_signed_out": "Kirjauduttu ulos onnistuneesti.",
        "new": {
          "sign_in": "Kirjaudu sisään"
        },
        "signed_in": "Sisäänkirjautuminen onnistui.",
        "signed_out": "Uloskirjautuminen onnistui."
      },
      "shared": {
        "links": {
          "back": "Takaisin",
          "didn_t_receive_confirmation_instructions": "Vahvistusviesti ei saapunut perille?",
          "didn_t_receive_unlock_instructions": "Salasanan vaihto -ohjeet eivät saapuneet perille?",
          "forgot_your_password": "Unohditko salasanasi?",
          "sign_in": "Kirjaudu sisään",
          "sign_in_with_provider": "Kirjaudu sisään (%{provider})",
          "sign_up": "Rekisteröidy"
        },
        "minimum_password_length": {
          "one": "(vähimmäispituus on %{count} merkki)",
          "other": "(vähimmäispituus on %{count} merkkiä)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Uudelleenlähetä lukituksen poisto -ohjeet"
        },
        "send_instructions": "Saat hetken kuluttua sähköpostiisi ohjeet käyttäjätunnuksesi lukituksen poistoon.",
        "send_paranoid_instructions": "Jos käyttäjätunnuksesi on olemassa, lähetämme ohjeet lukituksen poistamiseksi sähköpostiisi muutaman minuutin kuluessa.",
        "unlocked": "Käyttäjätunnuksesi on nyt avattu. Olet kirjautuneena sisälle."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "täytyy olla hyväksytty",
        "already_confirmed": "on jo vahvistettu, yritä kirjautua sisään uudelleen",
        "blank": "ei voi olla tyhjä",
        "confirmation": "ei vastaa varmennusta",
        "confirmation_period_expired": "pitää vahvistaa %{period} kuluessa, ole hyvä ja pyydä uusi",
        "empty": "ei voi olla tyhjä",
        "equal_to": "täytyy olla yhtä suuri kuin %{count}",
        "even": "täytyy olla parillinen",
        "exclusion": "on varattu",
        "expired": "on vanhentunut, pyydä uutta.",
        "greater_than": "täytyy olla suurempi kuin %{count}",
        "greater_than_or_equal_to": "täytyy olla suurempi tai yhtä suuri kuin %{count}",
        "inclusion": "ei löydy listasta",
        "invalid": "on virheellinen",
        "less_than": "täytyy olla pienempi kuin %{count}",
        "less_than_or_equal_to": "täytyy olla pienempi tai yhtä suuri kuin %{count}",
        "model_invalid": "Validointi epäonnistui: %{errors}",
        "not_a_number": "ei ole luku",
        "not_an_integer": "täytyy olla kokonaisluku",
        "not_found": "ei löytynyt",
        "not_locked": "ei ollut lukittu",
        "not_saved": {
          "one": "1 virhe esti %{resource} tallentamisen:",
          "other": "%{count} virhettä esti %{resource} tallentamisen:"
        },
        "odd": "täytyy olla pariton",
        "present": "täytyy olla sisällötön",
        "required": "täytyy olla",
        "taken": "on jo käytössä",
        "too_long": {
          "one": "on liian pitkä (saa olla enintään %{count} merkki)",
          "other": "on liian pitkä (saa olla enintään %{count} merkkiä)"
        },
        "too_short": {
          "one": "on liian lyhyt (oltava vähintään %{count} merkki)",
          "other": "on liian lyhyt (oltava vähintään %{count} merkkiä)"
        },
        "wrong_length": {
          "one": "on väärän pituinen (täytyy olla täsmälleen %{count} merkki)",
          "other": "on väärän pituinen (täytyy olla täsmälleen %{count} merkkiä)"
        }
      },
      "template": {
        "body": "Seuraavat kentät aiheuttivat ongelmia:",
        "header": {
          "one": "Virhe syötteessä esti mallin %{model} tallentamisen",
          "other": "%{count} virhettä esti mallin %{model} tallentamisen"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Valitse"
      },
      "submit": {
        "create": "Luo %{model}",
        "submit": "Tallenna %{model}",
        "update": "Päivitä %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miljardia",
            "million": "miljoonaa",
            "quadrillion": "tuhatta biljoonaa",
            "thousand": "tuhatta",
            "trillion": "biljoonaa",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "tavu",
              "other": "tavua"
            },
            "gb": "Gt",
            "kb": "kt",
            "mb": "Mt",
            "tb": "Tt"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " ja ",
        "two_words_connector": " ja ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "aamupäivä",
      "formats": {
        "default": "%A %e. %Bta %Y %H:%M:%S %z",
        "long": "%e. %Bta %Y %H.%M",
        "short": "%e.%m. %H.%M"
      },
      "pm": "iltapäivä"
    }
  },
  "fi-FI": {
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_prefix}#{city_suffix}"
        ],
        "city_prefix": [
          "Haap",
          "He",
          "Kau",
          "Oul",
          "Ra",
          "Ni",
          "No",
          "Ke",
          "La",
          "Or"
        ],
        "city_suffix": [
          "sjärvi",
          "kano",
          "ahe",
          "inen",
          "esi",
          "uma",
          "mi",
          "inen",
          "valta",
          "mina"
        ],
        "default_country": [
          "Suomi"
        ],
        "default_country_code": [
          "FI"
        ],
        "postcode": [
          "#####"
        ],
        "state": [
          "Uusimaa",
          "Varsinais-Suomi",
          "Satakunta",
          "Kanta-Häme",
          "Pirkanmaa",
          "Päijät-Häme",
          "Kymenlaakso",
          "Etelä-Karjala",
          "Etelä-Savo",
          "Pohjois-Savo",
          "Pohjois-Karjala",
          "Keski-Suomi",
          "Etelä-Pohjanmaa",
          "Pohjanmaa",
          "Keski-Pohjanmaa",
          "Pohjois-Pohjanmaa",
          "Kainuu",
          "Lappi",
          "Ahvenanmaa"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{Name.last_name}#{street_suffix}"
        ],
        "street_suffix": [
          "katu",
          "gatan",
          "ranta"
        ]
      },
      "cell_phone": {
        "formats": [
          "0##-#######"
        ]
      },
      "invoice": {
        "reference": {
          "check_digit_method": "method_731",
          "pattern": "\\d{3,19}#"
        }
      },
      "name": {
        "female_first_name": [
          "Maria",
          "Helena",
          "Anneli",
          "Johanna",
          "Kaarina",
          "Marjatta",
          "Hannele",
          "Kristiina",
          "Liisa",
          "Emilia",
          "Elina",
          "Tuulikki",
          "Annikki",
          "Maarit",
          "Sofia",
          "Susanna",
          "Leena",
          "Katariina",
          "Anna",
          "Marja",
          "Sinikka",
          "Inkeri",
          "Riitta",
          "Kyllikki",
          "Aino",
          "Tuula",
          "Anne",
          "Päivi",
          "Orvokki",
          "Ritva",
          "Tellervo",
          "Maija",
          "Pirjo",
          "Karoliina",
          "Pauliina",
          "Minna",
          "Sari",
          "Irmeli",
          "Eeva",
          "Tiina",
          "Laura",
          "Eveliina",
          "Marika",
          "Elisabet",
          "Tarja",
          "Pirkko",
          "Satu",
          "Anja",
          "Mari",
          "Hanna"
        ],
        "first_name": [
          "Maria",
          "Helena",
          "Anneli",
          "Johanna",
          "Kaarina",
          "Marjatta",
          "Hannele",
          "Kristiina",
          "Liisa",
          "Emilia",
          "Elina",
          "Tuulikki",
          "Annikki",
          "Maarit",
          "Sofia",
          "Susanna",
          "Leena",
          "Katariina",
          "Anna",
          "Marja",
          "Sinikka",
          "Inkeri",
          "Riitta",
          "Kyllikki",
          "Aino",
          "Tuula",
          "Anne",
          "Päivi",
          "Orvokki",
          "Ritva",
          "Tellervo",
          "Maija",
          "Pirjo",
          "Karoliina",
          "Pauliina",
          "Minna",
          "Sari",
          "Irmeli",
          "Eeva",
          "Tiina",
          "Laura",
          "Eveliina",
          "Marika",
          "Elisabet",
          "Tarja",
          "Pirkko",
          "Satu",
          "Anja",
          "Mari",
          "Hanna",
          "Juhani",
          "Olavi",
          "Antero",
          "Tapani",
          "Johannes",
          "Tapio",
          "Mikael",
          "Kalevi",
          "Matti",
          "Pekka",
          "Petteri",
          "Ilmari",
          "Sakari",
          "Matias",
          "Antti",
          "Juha",
          "Heikki",
          "Kristian",
          "Timo",
          "Kari",
          "Mikko",
          "Markus",
          "Jari",
          "Jukka",
          "Kalervo",
          "Markku",
          "Aleksi",
          "Jaakko",
          "Petri",
          "Oskari",
          "Mika",
          "Henrik",
          "Lauri",
          "Erkki",
          "Veikko",
          "Hannu",
          "Seppo",
          "Ville",
          "Ensio",
          "Ari",
          "Janne",
          "Valtteri",
          "Marko",
          "Pentti",
          "Tuomas",
          "Sami",
          "Juho",
          "Eero",
          "Martti",
          "Erik"
        ],
        "last_name": [
          "Korhonen",
          "Virtanen",
          "Mäkinen",
          "Nieminen",
          "Mäkelä",
          "Hämäläinen",
          "Laine",
          "Heikkinen",
          "Koskinen",
          "Järvinen",
          "Lehtonen",
          "Lehtinen",
          "Saarinen",
          "Salminen",
          "Heinonen",
          "Niemi",
          "Heikkilä",
          "Kinnunen",
          "Salonen",
          "Turunen",
          "Salo",
          "Laitinen",
          "Tuominen",
          "Rantanen",
          "Karjalainen",
          "Jokinen",
          "Mattila",
          "Savolainen",
          "Lahtinen",
          "Ahonen",
          "Ojala",
          "Leppänen",
          "Väisänen",
          "Hiltunen",
          "Kallio",
          "Miettinen",
          "Leinonen",
          "Pitkänen",
          "Aaltonen",
          "Manninen",
          "Hakala",
          "Koivisto",
          "Anttila",
          "Laaksonen",
          "Hirvonen",
          "Räsänen",
          "Lehto",
          "Laakso",
          "Toivonen",
          "Mustonen"
        ],
        "male_first_name": [
          "Juhani",
          "Olavi",
          "Antero",
          "Tapani",
          "Johannes",
          "Tapio",
          "Mikael",
          "Kalevi",
          "Matti",
          "Pekka",
          "Petteri",
          "Ilmari",
          "Sakari",
          "Matias",
          "Antti",
          "Juha",
          "Heikki",
          "Kristian",
          "Timo",
          "Kari",
          "Mikko",
          "Markus",
          "Jari",
          "Jukka",
          "Kalervo",
          "Markku",
          "Aleksi",
          "Jaakko",
          "Petri",
          "Oskari",
          "Mika",
          "Henrik",
          "Lauri",
          "Erkki",
          "Veikko",
          "Hannu",
          "Seppo",
          "Ville",
          "Ensio",
          "Ari",
          "Janne",
          "Valtteri",
          "Marko",
          "Pentti",
          "Tuomas",
          "Sami",
          "Juho",
          "Eero",
          "Martti",
          "Erik"
        ],
        "name": [
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "##-######",
          "###-#######"
        ]
      }
    }
  },
  "fr": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Date d'envoi de la confirmation",
          "confirmation_token": "Clé de confirmation du mot de passe",
          "confirmed_at": "Date de confirmation",
          "created_at": "Date d'enregistrement",
          "current_password": "Mot de passe actuel",
          "current_sign_in_at": "Date de la connexion actuelle",
          "current_sign_in_ip": "IP de la connexion actuelle",
          "email": "Email",
          "encrypted_password": "Mot de passe chiffré",
          "failed_attempts": "Tentatives échouées",
          "last_sign_in_at": "Date de la dernière connexion",
          "last_sign_in_ip": "IP de la dernière connexion",
          "locked_at": "Verrouillé à",
          "password": "Mot de passe",
          "password_confirmation": "Confirmation du mot de passe",
          "remember_created_at": "Mémorisé à",
          "remember_me": "Se souvenir de moi ?",
          "reset_password_sent_at": "Clé de réinitialisation créée à",
          "reset_password_token": "Clé de réinitialisation du mot de passe",
          "sign_in_count": "Nombre des connexions",
          "unconfirmed_email": "Email non confirmé",
          "unlock_token": "Clé de déverrouillage",
          "updated_at": "Date de mise à jour"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validation a échoué : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Vous ne pouvez pas supprimer l'enregistrement parce que les %{record} dépendants existent",
            "has_one": "Vous ne pouvez pas supprimer l'enregistrement car un(e) %{record} dépendant(e) existe"
          }
        }
      },
      "models": {
        "user": {
          "many": "Utilisateur",
          "one": "Utilisateur",
          "other": "Utilisateur"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "fév.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "environ une heure",
          "other": "environ %{count} heures"
        },
        "about_x_months": {
          "one": "environ un mois",
          "other": "environ %{count} mois"
        },
        "about_x_years": {
          "one": "environ un an",
          "other": "environ %{count} ans"
        },
        "almost_x_years": {
          "one": "presque un an",
          "other": "presque %{count} ans"
        },
        "half_a_minute": "une demi‑minute",
        "less_than_x_minutes": {
          "one": "moins d'une minute",
          "other": "moins de %{count} minutes",
          "zero": "moins d'une minute"
        },
        "less_than_x_seconds": {
          "one": "moins d'une seconde",
          "other": "moins de %{count} secondes",
          "zero": "moins d'une seconde"
        },
        "over_x_years": {
          "one": "plus d'un an",
          "other": "plus de %{count} ans"
        },
        "x_days": {
          "one": "%{count} jour",
          "other": "%{count} jours"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} mois",
          "other": "%{count} mois"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} secondes"
        },
        "x_years": {
          "one": "%{count} an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "Jour",
        "hour": "Heure",
        "minute": "Minute",
        "month": "Mois",
        "second": "Seconde",
        "year": "Année"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Votre compte a bien été confirmé.",
        "new": {
          "resend_confirmation_instructions": "Renvoyer les instructions de confirmation"
        },
        "send_instructions": "Vous allez recevoir sous quelques minutes un email comportant des instructions pour confirmer votre compte.",
        "send_paranoid_instructions": "Si votre email existe sur notre base de données, vous recevrez sous quelques minutes un message avec des instructions pour confirmer votre compte."
      },
      "failure": {
        "already_authenticated": "Vous êtes déjà connecté(e).",
        "inactive": "Votre compte n’est pas encore activé.",
        "invalid": "%{authentication_keys} ou mot de passe incorrect.",
        "invited": "Vous avez une invitation en attente, acceptez-la pour terminer la création de votre compte.",
        "last_attempt": "Il vous reste une chance avant que votre compte soit bloqué.",
        "locked": "Votre compte est verrouillé.",
        "not_found_in_database": "%{authentication_keys} ou mot de passe incorrect.",
        "timeout": "Votre session est expirée, veuillez vous reconnecter pour continuer.",
        "unauthenticated": "Vous devez vous connecter ou vous enregistrer pour continuer.",
        "unconfirmed": "Vous devez confirmer votre compte par email."
      },
      "invitations": {
        "edit": {
          "header": "Définissez votre mot de passe",
          "submit_button": "Définir mon mot de passe"
        },
        "invitation_removed": "Votre invitation a été supprimée.",
        "invitation_token_invalid": "Le jeton d'invitation fourni n'est pas valide !",
        "new": {
          "header": "Nouvel utilisateur",
          "submit_button": "Envoyer"
        },
        "no_invitations_remaining": "Il n'y a plus d'invitations restantes.",
        "send_instructions": "Un e-mail d'invitation a été envoyé à %{email}.",
        "updated": "Votre mot de passe a été défini avec succès. Vous êtes maintenant connecté.",
        "updated_not_active": "Votre mot de passe a été défini avec succès."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmer mon email",
          "confirm_account_link": "Confirmer mon compte",
          "confirm_link_msg": "Vous pouvez confirmer votre compte e-mail via le lien ci-dessous :",
          "greeting": "Bienvenue %{recipient} !",
          "instruction": "Vous pouvez confirmer votre email grâce au lien ci-dessous :",
          "subject": "Instructions de confirmation"
        },
        "email_changed": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous informer que votre email a été changé en %{email}.",
          "message_unconfirmed": "Nous vous contactons pour vous informer que votre email est en train d'être changé par %{email}.",
          "subject": "Email modifié"
        },
        "invitation_instructions": {
          "accept": "Accepter l'invitation",
          "accept_until": "Cette invitation sera valable jusqu'au %{due_date}.",
          "hello": "Bonjour %{email}",
          "ignore": "Si vous ne souhaitez pas accepter cette invitation, veuillez ignorer cet e-mail. Votre compte ne sera pas créé tant que vous n'aurez pas cliqué sur le lien ci-dessous et défini votre mot de passe.",
          "someone_invited_you": "Vous avez été invité à rejoindre %{url}, vous pouvez accepter cette invitation via le lien ci-dessous.",
          "subject": "Vous avez reçu une invitation"
        },
        "password_change": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous notifier que votre mot de passe a été modifié.",
          "subject": "Mot de passe modifié"
        },
        "reset_password_instructions": {
          "action": "Changer mon mot de passe",
          "greeting": "Bonjour %{recipient} !",
          "ignore_mail_msg": "Si vous n'avez pas demandé cela, veuillez ignorer cet e-mail.",
          "instruction": "Quelqu'un a demandé un lien pour changer votre mot de passe, le voici :",
          "instruction_2": "Si vous n'avez pas émis cette demande, merci d'ignorer cet email.",
          "instruction_3": "Votre mot de passe ne changera pas tant que vous n'aurez pas cliqué sur ce lien et renseigné un nouveau mot de passe.",
          "no_changes_msg": "Votre mot de passe ne changera pas tant que vous n'accédez pas au lien ci-dessus pour en créer un nouveau.",
          "password_change_link": "Changer mon mot de passe",
          "request_reset_link_msg": "Quelqu'un a demandé un lien pour changer votre mot de passe. Pour procéder ainsi, suivez le lien ci-dessous.",
          "subject": "Instructions de récupération de mot de passe"
        },
        "unlock_instructions": {
          "account_lock_msg": "Votre compte a été bloqué en raison de nombreuses tentatives de connexion erronées.",
          "action": "Débloquer mon compte",
          "greeting": "Bonjour %{recipient} !",
          "instruction": "Suivez ce lien pour débloquer votre compte :",
          "message": "Votre compte a été bloqué suite à un nombre d'essais de connexions manquées trop important.",
          "subject": "Instructions de déblocage",
          "unlock_link": "Déverrouiller mon compte",
          "unlock_link_msg": "Cliquez sur le lien ci-dessous pour déverrouiller votre compte:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nous ne pouvons pas vous authentifier depuis %{kind} pour la raison suivante : '%{reason}'.",
        "success": "Autorisé par votre compte %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Changer mon mot de passe",
          "change_your_password": "Changer votre mot de passe",
          "confirm_new_password": "Confirmez votre nouveau mot de passe",
          "new_password": "Nouveau mot de passe"
        },
        "new": {
          "forgot_your_password": "Mot de passe oublié ?",
          "send_me_reset_password_instructions": "Envoyez-moi des instructions pour réinitialiser mon mot de passe"
        },
        "no_token": "Vous ne pouvez pas accéder à cette page si vous n’y accédez pas depuis un email de réinitialisation de mot de passe. Si vous venez en effet d’un tel email, vérifiez que vous avez copié l’adresse URL en entier.",
        "send_instructions": "Vous allez recevoir sous quelques minutes un email vous indiquant comment réinitialiser votre mot de passe.",
        "send_paranoid_instructions": "Si votre email existe dans notre base de données, vous recevrez un lien vous permettant de récupérer votre mot de passe.",
        "updated": "Votre mot de passe a bien été modifié. Vous êtes maintenant connecté(e).",
        "updated_not_active": "Votre mot de passe a bien été modifié."
      },
      "registrations": {
        "destroyed": "Au revoir ! Votre compte a bien été supprimé. Nous espérons vous revoir bientôt.",
        "edit": {
          "are_you_sure": "Êtes-vous sûr ?",
          "cancel_my_account": "Supprimer mon compte",
          "currently_waiting_confirmation_for_email": "Confirmation en attente pour: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "laissez ce champ vide pour le laisser inchangé",
          "title": "Éditer %{resource}",
          "unhappy": "Pas content ?",
          "update": "Modifier",
          "we_need_your_current_password_to_confirm_your_changes": "nous avons besoin de votre mot de passe actuel pour valider ces modifications"
        },
        "new": {
          "sign_up": "Inscription"
        },
        "signed_up": "Bienvenue ! Vous vous êtes bien enregistré(e).",
        "signed_up_but_inactive": "Vous vous êtes bien enregistré(e). Cependant, nous n’avons pas pu vous connecter car votre compte n’a pas encore été activé.",
        "signed_up_but_locked": "Vous vous êtes bien enregistré(e). Cependant, nous n’avons pas pu vous connecter car votre compte est verrouillé.",
        "signed_up_but_unconfirmed": "Un message avec un lien de confirmation vous a été envoyé par mail. Veuillez suivre ce lien pour activer votre compte.",
        "update_needs_confirmation": "Vous avez bien modifié votre compte, mais nous devons vérifier votre nouvelle adresse email. Veuillez consulter vos emails et cliquer sur le lien de confirmation pour confirmer votre nouvelle adresse.",
        "updated": "Votre compte a bien été modifié.",
        "updated_but_not_signed_in": "Votre compte a été mis à jour avec succès. Vous devez vous reconnecter car votre mot de passe a été modifié."
      },
      "sessions": {
        "already_signed_out": "Déconnecté(e).",
        "new": {
          "sign_in": "Connexion"
        },
        "signed_in": "Connecté(e).",
        "signed_out": "Déconnecté(e)."
      },
      "shared": {
        "links": {
          "back": "Retour",
          "didn_t_receive_confirmation_instructions": "Vous n'avez pas reçu l'email de confirmation ?",
          "didn_t_receive_unlock_instructions": "Vous n'avez pas reçu l'email de déblocage ?",
          "forgot_your_password": "Mot de passe oublié ?",
          "sign_in": "Connexion",
          "sign_in_with_provider": "Connexion avec %{provider}",
          "sign_up": "Inscription"
        },
        "minimum_password_length": {
          "many": "(%{count} caractères au moins)",
          "one": "(%{count} caractère au moins)",
          "other": "(%{count} caractères au moins)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Renvoyer les instructions de déblocage"
        },
        "send_instructions": "Vous allez recevoir sous quelques minutes un email comportant des instructions pour déverrouiller votre compte.",
        "send_paranoid_instructions": "Si votre email existe sur notre base de données, vous recevrez sous quelques minutes un message avec des instructions pour déverrouiller votre compte.",
        "unlocked": "Votre compte a bien été déverrouillé. Veuillez vous connecter."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Redirection vers '%{redirect_url}' n'est pas autorisée."
      },
      "passwords": {
        "missing_email": "Vous devez soumettre un e-mail.",
        "missing_passwords": "Vous devez remplir les champs 'Mot de passe' et 'Confirmation de mot de passe'.",
        "missing_redirect_url": "URL de redirection manquante.",
        "not_allowed_redirect_url": "Redirection vers '%{redirect_url}' n'est pas autorisée.",
        "password_not_required": "Ce compte ne demande pas de mot de passe. Connectez vous en utilisant '%{provider}'.",
        "sended": "Un e-mail a été envoyé à '%{email}' avec les instructions de réinitialisation du mot de passe.",
        "successfully_updated": "Votre mot de passe a été correctement mis à jour.",
        "user_not_found": "Impossible de trouver l'utilisateur avec l'adresse e-mail suivante '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Le compte à supprimer est introuvable.",
        "account_with_uid_destroyed": "Le compte avec l'identifiant '%{uid}' a été supprimé.",
        "email_already_exists": "Un compte existe déjà avec l'adresse e-mail suivante '%{email}'",
        "missing_confirm_success_url": "Le paramètre 'confirm_success_url' est manquant.",
        "redirect_url_not_allowed": "Redirection vers '%{redirect_url}' n'est pas autorisée.",
        "user_not_found": "Utilisateur introuvable."
      },
      "sessions": {
        "bad_credentials": "Mot de passe ou identifiant invalide.",
        "not_confirmed": "Un e-mail de confirmation de votre compte a été envoyé à '%{email}'. Merci de suivre les instructions afin de valider votre compte",
        "not_supported": "Utilisez POST /sign_in pour la connexion. GET n'est pas supporté.",
        "user_not_found": "L'utilisateur est inconnu ou n'est pas connecté."
      },
      "token_validations": {
        "invalid": "Mot de passe ou identifiant invalide."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "doit être accepté(e)",
        "already_confirmed": "a déjà été confirmé(e)",
        "blank": "doit être rempli(e)",
        "confirmation": "ne concorde pas avec %{attribute}",
        "confirmation_period_expired": "doit être confirmé(e) en %{period}, veuillez en demander un(e) autre",
        "empty": "doit être rempli(e)",
        "equal_to": "doit être égal à %{count}",
        "even": "doit être pair",
        "exclusion": "n'est pas disponible",
        "expired": "est expiré, veuillez en demander un autre",
        "greater_than": "doit être supérieur à %{count}",
        "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
        "in": "doit être dans l'intervalle %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur à %{count}",
        "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
        "model_invalid": "Validation échouée : %{errors}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un nombre entier",
        "not_email": "n'est pas une adresse e-mail",
        "not_found": "n’a pas été trouvé(e)",
        "not_locked": "n’était pas verrouillé(e)",
        "not_saved": {
          "many": "%{count} erreurs ont empêché ce (cet ou cette) %{resource} d’être enregistré(e) :",
          "one": "une erreur a empêché ce (cet ou cette) %{resource} d’être enregistré(e) :",
          "other": "%{count} erreurs ont empêché ce (cet ou cette) %{resource} d’être enregistré(e) :"
        },
        "odd": "doit être impair",
        "other_than": "doit être différent de %{count}",
        "present": "doit être vide",
        "required": "doit exister",
        "taken": "est déjà utilisé(e)",
        "too_long": {
          "one": "est trop long (pas plus d'un caractère)",
          "other": "est trop long (pas plus de %{count} caractères)"
        },
        "too_short": {
          "one": "est trop court (au moins un caractère)",
          "other": "est trop court (au moins %{count} caractères)"
        },
        "validate_account_update_params": "Les données de mise à jour dans le corps de la requête ne sont pas valides.",
        "validate_sign_up_params": "Les données d'inscription dans le corps de la requête ne sont pas valides.",
        "wrong_length": {
          "one": "ne fait pas la bonne longueur (doit comporter un seul caractère)",
          "other": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
        }
      },
      "template": {
        "body": "Veuillez vérifier les champs suivants : ",
        "header": {
          "one": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreur",
          "other": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreurs"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Agen",
          "Aix-en-Provence",
          "Ajaccio",
          "Albi",
          "Alès",
          "Alfortville",
          "Amiens",
          "Angers",
          "Anglet",
          "Angoulême",
          "Annecy",
          "Annemasse",
          "Antibes",
          "Antony",
          "Argenteuil",
          "Arles",
          "Arras",
          "Asnières-sur-Seine",
          "Athis-Mons",
          "Aubagne",
          "Aubervilliers",
          "Aulnay-sous-Bois",
          "Auxerre",
          "Avignon",
          "Bagneux",
          "Bagnolet",
          "Baie-Mahault",
          "Bastia",
          "Bayonne",
          "Beauvais",
          "Belfort",
          "Besançon",
          "Béziers",
          "Bezons",
          "Blois",
          "Bobigny",
          "Bondy",
          "Bordeaux",
          "Boulogne-Billancourt",
          "Boulogne-sur-Mer",
          "Bourg-en-Bresse",
          "Bourges",
          "Brest",
          "Brive-la-Gaillarde",
          "Bron",
          "Cachan",
          "Caen",
          "Cagnes-sur-Mer",
          "Calais",
          "Caluire-et-Cuire",
          "Cambrai",
          "Cannes",
          "Carcassonne",
          "Castres",
          "Cayenne",
          "Cergy",
          "Chalon-sur-Saône",
          "Châlons-en-Champagne",
          "Chambéry",
          "Champigny-sur-Marne",
          "Charenton-le-Pont",
          "Charleville-Mézières",
          "Chartres",
          "Châteauroux",
          "Châtellerault",
          "Châtenay-Malabry",
          "Châtillon",
          "Chatou",
          "Chelles",
          "Cherbourg-en-Cotentin",
          "Choisy-le-Roi",
          "Cholet",
          "Clamart",
          "Clermont-Ferrand",
          "Clichy",
          "Colmar",
          "Colombes",
          "Colomiers",
          "Compiègne",
          "Conflans-Sainte-Honorine",
          "Corbeil-Essonnes",
          "Courbevoie",
          "Creil",
          "Créteil",
          "Dijon",
          "Douai",
          "Draguignan",
          "Drancy",
          "Dreux",
          "Dumbéa",
          "Dunkerque",
          "Échirolles",
          "Épinal",
          "Épinay-sur-Seine",
          "Évreux",
          "Évry-Courcouronnes",
          "Fontenay-sous-Bois",
          "Fort-de-France",
          "Franconville",
          "Fréjus",
          "Gagny",
          "Gap",
          "Garges-lès-Gonesse",
          "Gennevilliers",
          "Goussainville",
          "Grasse",
          "Grenoble",
          "Haguenau",
          "Herblay-sur-Seine",
          "Houilles",
          "Hyères",
          "Issy-les-Moulineaux",
          "Istres",
          "Ivry-sur-Seine",
          "Joué-lès-Tours",
          "Koungou",
          "L'Haÿ-les-Roses",
          "La Ciotat",
          "La Courneuve",
          "La Possession",
          "La Roche-sur-Yon",
          "La Rochelle",
          "La Seyne-sur-Mer",
          "Laval",
          "Le Blanc-Mesnil",
          "Le Cannet",
          "Le Chesnay-Rocquencourt",
          "Le Havre",
          "Le Lamentin",
          "Le Mans",
          "Le Perreux-sur-Marne",
          "Le Port",
          "Le Tampon",
          "Lens",
          "Les Abymes",
          "Les Mureaux",
          "Les Sables-d'Olonne",
          "Levallois-Perret",
          "Liévin",
          "Lille",
          "Limoges",
          "Livry-Gargan",
          "Lorient",
          "Lyon",
          "Mâcon",
          "Maisons-Alfort",
          "Malakoff",
          "Mamoudzou",
          "Mantes-la-Jolie",
          "Marcq-en-Barœul",
          "Marignane",
          "Marseille",
          "Martigues",
          "Massy",
          "Matoury",
          "Meaux",
          "Melun",
          "Menton",
          "Mérignac",
          "Metz",
          "Meudon",
          "Meyzieu",
          "Montauban",
          "Montélimar",
          "Montigny-le-Bretonneux",
          "Montluçon",
          "Montpellier",
          "Montreuil",
          "Montrouge",
          "Mulhouse",
          "Nancy",
          "Nanterre",
          "Nantes",
          "Narbonne",
          "Neuilly-sur-Marne",
          "Neuilly-sur-Seine",
          "Nevers",
          "Nice",
          "Nîmes",
          "Niort",
          "Nogent-sur-Marne",
          "Noisy-le-Grand",
          "Noisy-le-Sec",
          "Nouméa",
          "Orléans",
          "Palaiseau",
          "Pantin",
          "Paris",
          "Pau",
          "Périgueux",
          "Perpignan",
          "Pessac",
          "Pierrefitte-sur-Seine",
          "Plaisir",
          "Poissy",
          "Poitiers",
          "Pontault-Combault",
          "Pontoise",
          "Puteaux",
          "Quimper",
          "Reims",
          "Rennes",
          "Rezé",
          "Rillieux-la-Pape",
          "Roanne",
          "Romans-sur-Isère",
          "Rosny-sous-Bois",
          "Roubaix",
          "Rouen",
          "Rueil-Malmaison",
          "Saint-André",
          "Saint-Benoît",
          "Saint-Brieuc",
          "Saint-Chamond",
          "Saint-Cloud",
          "Saint-Denis",
          "Saint-Étienne",
          "Saint-Germain-en-Laye",
          "Saint-Herblain",
          "Saint-Joseph",
          "Saint-Laurent-du-Maroni",
          "Saint-Leu",
          "Saint-Louis",
          "Saint-Malo",
          "Saint-Martin",
          "Saint-Martin-d'Hères",
          "Saint-Maur-des-Fossés",
          "Saint-Médard-en-Jalles",
          "Saint-Nazaire",
          "Saint-Ouen-sur-Seine",
          "Saint-Paul",
          "Saint-Pierre",
          "Saint-Priest",
          "Saint-Quentin",
          "Saint-Raphaël",
          "Sainte-Geneviève-des-Bois",
          "Sainte-Marie",
          "Salon-de-Provence",
          "Sarcelles",
          "Sartrouville",
          "Savigny-sur-Orge",
          "Sceaux",
          "Schiltigheim",
          "Sète",
          "Sevran",
          "Six-Fours-les-Plages",
          "Stains",
          "Strasbourg",
          "Suresnes",
          "Talence",
          "Tarbes",
          "Thionville",
          "Thonon-les-Bains",
          "Toulon",
          "Toulouse",
          "Tourcoing",
          "Tours",
          "Trappes",
          "Tremblay-en-France",
          "Troyes",
          "Valence",
          "Valenciennes",
          "Vandœuvre-lès-Nancy",
          "Vannes",
          "Vaulx-en-Velin",
          "Vénissieux",
          "Versailles",
          "Vigneux-sur-Seine",
          "Villefranche-sur-Saône",
          "Villejuif",
          "Villemomble",
          "Villenave-d'Ornon",
          "Villeneuve-Saint-Georges",
          "Villeneuve-d'Ascq",
          "Villepinte",
          "Villeurbanne",
          "Vincennes",
          "Viry-Châtillon",
          "Vitrolles",
          "Vitry-sur-Seine",
          "Wattrelos"
        ],
        "default_country": [
          "France"
        ],
        "full_address": [
          "#{street_address}, #{zip_code} #{city}",
          "#{secondary_address}, #{street_address}, #{zip_code} #{city}"
        ],
        "postcode": [
          "#####"
        ],
        "secondary_address": [
          "Apt. ###",
          "# étage"
        ],
        "state": [
          "Alsace",
          "Aquitaine",
          "Auvergne",
          "Basse-Normandie",
          "Bourgogne",
          "Bretagne",
          "Centre",
          "Champagne-Ardenne",
          "Corse",
          "Franche-Comté",
          "Guadeloupe",
          "Guyane",
          "Haute-Normandie",
          "Île-de-France",
          "La Réunion",
          "Languedoc-Roussillon",
          "Limousin",
          "Lorraine",
          "Martinique",
          "Mayotte",
          "Midi-Pyrénées",
          "Nord-Pas-de-Calais",
          "Pays de la Loire",
          "Picardie",
          "Poitou-Charentes",
          "Provence-Alpes-Côte d'Azur",
          "Rhône-Alpes"
        ],
        "street_address": [
          "#{building_number} #{street_name}"
        ],
        "street_name": [
          "#{street_prefix} #{street_suffix}"
        ],
        "street_prefix": [
          "Allée",
          "Anse",
          "Avenue",
          "Boulevard",
          "Carrefour",
          "Chaussée",
          "Chemin",
          "Cité",
          "Clos",
          "Côte",
          "Cour",
          "Cours",
          "Degré",
          "Descente",
          "Drève",
          "Escoussière",
          "Esplanade",
          "Gaffe",
          "Grand-route",
          "Impasse",
          "Liaison",
          "Mail",
          "Montée",
          "Passage",
          "Place",
          "Placette",
          "Pont",
          "Promenade",
          "Quai",
          "Résidence",
          "Rang",
          "Rampe",
          "Rond-point",
          "Route",
          "Rue",
          "Ruelle",
          "Sente",
          "Sentier",
          "Square",
          "Traboule",
          "Traverse",
          "Venelle",
          "Villa",
          "Voie"
        ],
        "street_suffix": [
          "Adolphe Mille",
          "Albert Jacquard",
          "Albert Simonin",
          "Albert de Mun",
          "Alexis Bouvier",
          "Alfred Couillard",
          "Alfred Dequeant",
          "Alphonse Daudet",
          "Amal de Joinville",
          "Ambroise Pare",
          "Anatole France",
          "Andre Cayron",
          "Andre Messager",
          "Arnaud Beltrame",
          "Arsene",
          "Auguste Renoir",
          "Augustine Guignedoux",
          "Baliat",
          "Bardin Centre Colin",
          "Baudin",
          "Berteaux Dumas",
          "Berthelot",
          "Bineau",
          "Blaise Pascal",
          "Boileau",
          "Bonaparte",
          "Bournaire",
          "Boutard",
          "Brassat",
          "Breville",
          "Cantorum",
          "Caron",
          "Carpeaux",
          "Cartault",
          "Casteres",
          "Chandon",
          "Chanzy",
          "Charlebourg",
          "Charlemagne",
          "Charles Duport",
          "Charles Lecocq",
          "Charles Moncelet",
          "Charles de Gaulle",
          "Charras le Verseau",
          "Chem Ile",
          "Chps Pierreux",
          "Christophe",
          "Claude Debussy",
          "Compagnie des Eaux",
          "Courte",
          "D'Alencon",
          "D'Argenteuil",
          "D'Estienne d'Orves",
          "Danton",
          "Dauphine",
          "De Bergkamen",
          "De Berlin Spandau",
          "De Bezons",
          "De Bitche",
          "De Bois Preau",
          "De Brienne",
          "De Chartres",
          "De Chateaudun",
          "De Colombes",
          "De Diesbach",
          "De Longchamp",
          "De Madrid",
          "De Marie Galante",
          "De Neuilly",
          "De Normandie",
          "De Rochegude",
          "De Saverne",
          "De Stalingrad",
          "De Stepney",
          "De Verdun",
          "De Zilina",
          "De l'Abreuvoir",
          "De l'Avenir",
          "De l'Eglise",
          "De la Benarde",
          "De la Cerisaie",
          "De la Cote des Amandiers",
          "De la Defense",
          "De la Gare",
          "De la Grille Verte",
          "De la Paix",
          "De la Passerelle",
          "De la Reine Henriette",
          "De la Republique",
          "De la Station",
          "De la Terrasse",
          "De la Victoire",
          "Delesseux",
          "Dellieux",
          "Des Aubepines",
          "Des Belles Vues",
          "Des Bergeres",
          "Des Blanchisseurs",
          "Des Bleuets",
          "Des Bouleaux Blancs",
          "Des Bouvets",
          "Des Carrieres",
          "Des Champs Pierreux",
          "Des Chenes",
          "Des Corolles",
          "Des Cotes d'Auty",
          "Des Dames de st Louis",
          "Des Dames",
          "Des Demoiselles d'Avignon",
          "Des Deux Soeurs",
          "Des Erables",
          "Des Ermites",
          "Des Fauvelles",
          "Des Gaudonnes",
          "Des Glycines",
          "Des Gros Gres",
          "Des Hauts Tilliers",
          "Des Hirondelles",
          "Des Hortensias",
          "Des Lilas",
          "Des Lots Communaux",
          "Des Marguerites",
          "Des Marronniers",
          "Des Mazurieres",
          "Des Muettes",
          "Des Murgers",
          "Des Panoramas",
          "Des Petits Clos",
          "Des Peupliers",
          "Des Pierres Mayettes",
          "Des Platanes",
          "Des Poiriers",
          "Des Quais",
          "Des Reniers",
          "Des Rosiers",
          "Des Sablons",
          "Des Sculpteurs",
          "Des Souffrettes",
          "Des Tilleuls",
          "Des Tres Bourgeois",
          "Des Trois Fontanot",
          "Des Vosges",
          "Desire Ramelet",
          "Desiree",
          "Doudart de Lagree",
          "Du 18 Juin 1940",
          "Du 1er Consul",
          "Du 8 Mai 1945",
          "Du Bac",
          "Du Bois Beranger",
          "Du Bois",
          "Du Capitaine Guynemer",
          "Du Chemin Vert",
          "Du Colonel de Ponchalon",
          "Du Contrat Social",
          "Du Docteur Pierre",
          "Du General Audran",
          "Du General de Gaulle",
          "Du Gue",
          "Du Guichet",
          "Du Huit Mai 1945",
          "Du Mans",
          "Du Midi",
          "Du Moulin",
          "Du Onze Novembre 1918",
          "Du Onze Novembre",
          "Du Parc de l'Ile",
          "Du Pere Talvas",
          "Du Port",
          "Du Puits",
          "Du Sommerard",
          "Du Stade",
          "Du Tertre",
          "Du pdt Wilson",
          "Du pre Boni",
          "Du pre Marchais",
          "Dupont de Chambon",
          "Dupuis",
          "Edmond Rostand",
          "Emile Bernard",
          "Emile Duclaux",
          "Emile",
          "Estienne d Orves",
          "Etienne Cabet",
          "Eugene Barbier",
          "Eugene Pottier",
          "Eugene",
          "Fabre d Eglantine",
          "Felicie",
          "Felix Faure",
          "Felix Pyat",
          "Ferdinand Buisson",
          "Fernando",
          "Ferron",
          "Fleury",
          "Fosse de l Aumone",
          "Frederic Passy",
          "Gabriel Philippe",
          "Gambetta",
          "Garnier",
          "Gaston Bonnier",
          "Gay Lussac",
          "Gds Pres",
          "General Leclerc",
          "Genevieve",
          "Genouville",
          "George Sand",
          "Georges Clemenceau",
          "Girouix",
          "Grotius",
          "Groupe Lorilleux",
          "Guerlain",
          "Gustave Flourens",
          "Gutenberg",
          "Hanriot",
          "Helene",
          "Heloise",
          "Henri Barbusse",
          "Hippolyte Bisson",
          "Immeuble le Zodiaque",
          "Jacqueline Auriol",
          "Jacques Decour",
          "Jacques Dulud",
          "Jacques Offenbach",
          "Jacques Prevert",
          "Jacques",
          "Jean Baptiste Baudoin",
          "Jean Baptiste Lully",
          "Jean Gabin",
          "Jean Jacques Rousseau",
          "Jean Jaures",
          "Jean-baptiste Clement",
          "Joliot Curie",
          "Joseph Kosma",
          "Joubert",
          "Jules Ferry",
          "Jules Quentin",
          "Kleber",
          "L'Abbaye",
          "L'Orange",
          "La Boétie",
          "La Carriere au Loup",
          "La Cote des Amandiers",
          "La Lauziere",
          "La Marne",
          "La Seine",
          "La gde Pce",
          "Laffitte",
          "Lamartine",
          "Lateral",
          "Laurent Cely",
          "Le Couloir",
          "Le Vieux Pont",
          "Leclerc",
          "Ledru Rollin",
          "Lefevre",
          "Leo  Hamon",
          "Lepic",
          "Les Courtilles",
          "Les Luaps",
          "Les Muguets",
          "Les Orties",
          "Les Taratres",
          "Les Trianons",
          "Levallois",
          "Levernis",
          "Levesque",
          "Louis Bleriot",
          "Louis Castel",
          "Louis Chevrolet",
          "Louis David",
          "Louis Joseph Maes",
          "Louis Willaume",
          "Louis",
          "Lucien Lanternier",
          "Madeleine Michelis",
          "Madeleine",
          "Mal de Lattre de Tassigny",
          "Marcadet",
          "Marceau",
          "Marcel Cachin",
          "Marcel Paul",
          "Marcel Pourtout",
          "Marie Levasseur",
          "Marie Louise",
          "Marquis de Coriolis",
          "Martissot",
          "Mary",
          "Maryse Hilsz",
          "Maurice Ravel",
          "Maurice Thorez",
          "Maurice",
          "Mequillet",
          "Michel Raoult",
          "Molière",
          "Monsieur-le-Prince",
          "Montorgueil",
          "Mouffetard",
          "Mozart",
          "Neuilly Defense",
          "Nobel",
          "Nouvelle",
          "Oberkampf",
          "Olivier",
          "Parking Nuages",
          "Pasquier",
          "Passoir",
          "Pasteur",
          "Pastourelle",
          "Paul Eluard",
          "Paul Herbe",
          "Paul Langevin",
          "Paul Rollet",
          "Pauline",
          "Pierre Charron",
          "Pierre Curie",
          "Pierre de Coubertin",
          "Pins",
          "Raguidelles",
          "Raymond Aubrun",
          "Residence de la Mairie",
          "Richard Wallace",
          "Robert Dupont",
          "Robert Schumann",
          "Roger",
          "Rolland",
          "Rollet Salvan",
          "Royale",
          "Sadi Carnot",
          "Saint Hilaire",
          "Saint Nicolas",
          "Saint-Bernard",
          "Saint-Denis",
          "Saint-Dominique",
          "Saint-Honoré",
          "Saint-Jacques",
          "Saint-Séverin",
          "Sainte Foy",
          "Sarah Bernhardt",
          "Seine Bras de Gennevillier",
          "Silvy",
          "Simone Veil",
          "Sir Alexander Fleming",
          "St Pierre",
          "St Thomas en Argonne",
          "Station Defense Rer",
          "Trasbot",
          "Traversiere",
          "Vaneau",
          "Verdun",
          "Vergniaud",
          "Virginie",
          "Zadkine",
          "d'Abbeville",
          "d'Alésia",
          "d'Argenteuil",
          "d'Assas",
          "d'Orsel",
          "de Caumartin",
          "de Montmorency",
          "de Nesle",
          "de Paris",
          "de Presbourg",
          "de Provence",
          "de Richelieu",
          "de Rivoli",
          "de Seine",
          "de Solférino",
          "de Tilsitt",
          "de Vaugirard",
          "de l'Abbaye",
          "de l'Odéon",
          "de la Bûcherie",
          "de la Chaussée-d'Antin",
          "de la Ferronnerie",
          "de la Harpe",
          "de la Huchette",
          "de la Paix",
          "de la Pompe",
          "de la Victoire",
          "des Coudrais",
          "des Francs-Bourgeois",
          "des Grands Augustins",
          "des Lombards",
          "des Panoramas",
          "des Rosiers",
          "des Saussaies",
          "du Bac",
          "du Chat-qui-Pêche",
          "du Dahomey",
          "du Faubourg Saint-Honoré",
          "du Faubourg-Saint-Denis",
          "du Havre"
        ]
      },
      "adjective": {
        "negative": [
          "abattu(e)",
          "agaçant(e)",
          "agité(e)",
          "agressif(ve)",
          "arrogant(e)",
          "ambigu(e)",
          "angoissant(e)",
          "anxieux(se)",
          "anxiogène",
          "atroce",
          "barbant(e)",
          "bête",
          "bizarre",
          "blessant(e)",
          "bougon",
          "choquant(e)",
          "cinglé(e)",
          "confus(e)",
          "crade",
          "crasseux(se)",
          "crispé(e)",
          "cruel(le)",
          "dangereux(se)",
          "débile",
          "dégoûtant(e)",
          "démodé(e)",
          "dépareillé(e)",
          "dépassé(e)",
          "dépressif(ve)",
          "déprimant(e)",
          "déraisonnable",
          "désagréable",
          "désordonné(e)",
          "désorienté(e)",
          "désuet(ète)",
          "détestable",
          "détraqué(e)",
          "dingue",
          "disgracieux(se)",
          "effranyant(e)",
          "effrayé(e)",
          "égoïste",
          "embarrassé(e)",
          "embrouillé(e)",
          "énervant(e)",
          "énervé(e)",
          "ennuyant(e)",
          "ennuyé(e)",
          "ennuyeux(se)",
          "envieux(se)",
          "épouvantable",
          "épuisant(e)",
          "épuisé(e)",
          "esseulé(e)",
          "étrange",
          "étriqué(e)",
          "exapérant(e)",
          "exorbitant(e)",
          "exubérant(e)",
          "faible",
          "fainéant(e)",
          "farouche",
          "fatiguant(e)",
          "fatigué(e)",
          "faux(sse)",
          "fermé(e)",
          "fou(folle)",
          "fragile",
          "frêle",
          "frénétique",
          "froid(e)",
          "furieux(se)",
          "gourmand(e)",
          "grincheux(se)",
          "grognon(ne)",
          "grossier(ère)",
          "grotesque",
          "honteux(se)",
          "horrible",
          "idiot(e)",
          "immoral(e)",
          "impotent(e)",
          "impuissant(e)",
          "incapable",
          "inepte",
          "infect(e)",
          "inintéressant(e)",
          "injurieux(se)",
          "injuste",
          "inquiet(ète)",
          "inquiétant(e)",
          "inutile",
          "insensé(e)",
          "insupportable",
          "irrécupérable",
          "jaloux(se)",
          "lâche",
          "laid(e)",
          "lassant(e)",
          "maboul(e)",
          "maigre",
          "malade",
          "machanceux(se)",
          "mafaisant(e)",
          "malheureux(se)",
          "maussade",
          "mauvais(e)",
          "méchant(e)",
          "médiocre",
          "monstrueux(se)",
          "moyen(ne)",
          "naïf(ve)",
          "nerveux(se)",
          "nonchalant(e)",
          "odieux(se)",
          "paniqué(e)",
          "paresseux(se)",
          "paumé(e)",
          "pauvre",
          "périmé(e)",
          "perplexe",
          "poissard(e)",
          "poisseux(se)",
          "polisson(e)",
          "possessif(ve)",
          "préoccupé(e)",
          "primitif(ve)",
          "putride",
          "râleur(se)",
          "renfrogné(e)",
          "répugnant(e)",
          "ridicule",
          "ronchon",
          "scandaleux(se)",
          "seul(e)",
          "sot(te)",
          "soucieux(se)",
          "souffrant(e)",
          "stupide",
          "tendu(e)",
          "terrible",
          "timide",
          "triste",
          "troublant(e)",
          "troublé(e)",
          "vicieux(se)",
          "vide",
          "vilain(e)",
          "violent(e)"
        ],
        "positive": [
          "accueillant(e)",
          "adorable",
          "agile",
          "amical(e)",
          "attachant(e)",
          "attentif(ve)",
          "attentionné(e)",
          "attirant(e)",
          "aventureux(se)",
          "agréable",
          "attratif(ve)",
          "beau(belle)",
          "bon(ne)",
          "brave",
          "brillant(e)",
          "calme",
          "célèbre",
          "chanceux(se)",
          "chatoyant(e)",
          "charmant(e)",
          "chic",
          "cool",
          "combattif(ve)",
          "compétant(e)",
          "confortable",
          "convenable",
          "coopératif(ve)",
          "courageux(se)",
          "curieux(se)",
          "délicieux(se)",
          "déterminé(e)",
          "doué(e)",
          "drôle",
          "éclatant(e)",
          "efficace",
          "élégant(e)",
          "enchantant(e)",
          "encourageant(e)",
          "énergique",
          "enjoué(e)",
          "enthousiaste",
          "étincelant(e)",
          "exceptionnel(le)",
          "excité(e)",
          "fantastique",
          "farfelu(e)",
          "fidèle",
          "fier(ère)",
          "formidable",
          "gai(e)",
          "généreux(se)",
          "gentil(le)",
          "glamour",
          "glorieux(se)",
          "grâcieux(se)",
          "heureux(se)",
          "hilarant(e)",
          "humble",
          "innocent(e)",
          "jovial(e)",
          "juste",
          "impeccable",
          "inestimable",
          "intelligent(e)",
          "intéressant(e)",
          "irremplaçable",
          "joyeux(se)",
          "léger(ère)",
          "loufoque",
          "loyal(e)",
          "luisant(e)",
          "malin(e)",
          "magnifique",
          "mignon(ne)",
          "moderne",
          "naturel(le)",
          "ouvert(e)",
          "parfait(e)",
          "pétillant(e)",
          "plaisant(e)",
          "précieux(se)",
          "propre",
          "puissant(e)",
          "rayonnant(e)",
          "reconnaissant(e)",
          "réfléchi(e)",
          "remarquable",
          "riche",
          "robuste",
          "rutilant(e)",
          "sage",
          "sain(e)",
          "séduisant(e)",
          "sérieux(se)",
          "serviable",
          "simple",
          "soigneux(se)",
          "somptueux",
          "souriant(e)",
          "spirituel(le)",
          "splendide",
          "subtil(e)",
          "super",
          "sympa",
          "sympathique",
          "talentueux(se)",
          "tendre",
          "utile",
          "victorieux(se)",
          "vif(ve)",
          "vigoureux(se)",
          "zen"
        ]
      },
      "ancient": {
        "god": [
          "Aphrodite",
          "Apollon",
          "Arès",
          "Artémis",
          "Athéna",
          "Déméter",
          "Dionysos",
          "Hadès",
          "Héphaïstos",
          "Héra",
          "Hermès",
          "Hestia",
          "Poséidon",
          "Zeus"
        ],
        "hero": [
          "Achille",
          "Adonis",
          "Andromède",
          "Aeacus",
          "Agamemnon",
          "Ajax",
          "Amphiaraos",
          "Amphion",
          "Arcas",
          "Aristée",
          "Asclépios",
          "Athis",
          "Attis",
          "Bolina",
          "Bellérophon",
          "Cadmos",
          "Callisto",
          "Chiron",
          "Circé",
          "Codros",
          "Dardanos",
          "Dédale",
          "Éaque",
          "Endymion",
          "Énée",
          "Éole",
          "Épaphos",
          "Ganymède",
          "Glaucos",
          "Harmonie",
          "Hector",
          "Hébé",
          "Hélène",
          "Hémithée",
          "Hercule",
          "Hippolyte",
          "Hygie",
          "Iason",
          "Ilithie",
          "Ino",
          "Io",
          "Jason",
          "Médée",
          "Mélicerte",
          "Memnon",
          "Ménélas",
          "Minos",
          "Néoptolème",
          "Niké",
          "Oedipe",
          "Orion",
          "Orithye",
          "Orphée",
          "Pâris",
          "Patrocle",
          "Pélée",
          "Penthésilée",
          "Persée",
          "Perséphone",
          "Philonoé",
          "Pryam",
          "Psyché",
          "Sisyphe",
          "Ulysse",
          "Zétès",
          "Zéthus"
        ],
        "primordial": [
          "Ananké",
          "Chaos",
          "Chronos",
          "Érèbe",
          "Éros",
          "Éther",
          "Gaïa",
          "Héméra",
          "Hypnos",
          "Moros",
          "Olethros",
          "Nèsoi",
          "Nyx",
          "Ouranos",
          "Ouréa",
          "Phanès",
          "Pontos",
          "Tartare",
          "Thalassa",
          "Thanatos"
        ],
        "titan": [
          "Asia",
          "Clymène",
          "Astéria",
          "Astréos",
          "Atlas",
          "Aura",
          "Céos",
          "Crios",
          "Cronos",
          "Dioné",
          "Éos",
          "Épiméthée",
          "Eurybie",
          "Eurynomé",
          "Hélios",
          "Hypérion",
          "Japet",
          "Lélantos",
          "Léto",
          "Ménétios",
          "Métis",
          "Mnémosyne",
          "Océan",
          "Ophion",
          "Pallas",
          "Persès",
          "Phébé",
          "Prométhée",
          "Rhéa",
          "Séléné",
          "Styx",
          "Tétyhs",
          "Théia",
          "Thémis"
        ]
      },
      "appliance": {
        "equipment": [
          "Ioniseur d'air",
          "Purificateur d'air",
          "Alimentation électrique",
          "Diffuseur de parfum",
          "Ventilateur de grenier",
          "Mini-four",
          "Insert",
          "Décapsuleur",
          "Mixeur",
          "Essoreuse",
          "Ouvre-boîte",
          "Ventilateur de plafond",
          "Aspirateur Central",
          "Sèche-linge",
          "Fer à repasser",
          "Presse-agrumes",
          "Lave-linge tout-en-un",
          "Placard égouttoir",
          "Lave-vaisselle",
          "Robot domestique",
          "Lave-vaisselle à tiroir",
          "Bouilloire électrique",
          "Refroidisseur par évaporation",
          "Hotte aspirante",
          "Radiateur soufflant",
          "Contrôleur de flamme",
          "Chauffage par air pulsé",
          "Sèche-futon",
          "Broyeur de cuisine",
          "Chaudière à gaz",
          "Boîte d'allumettes pour le lit",
          "CVC",
          "Sèche-cheveux",
          "Fer à lisser",
          "Plaque de cuisson",
          "Serveur personnel",
          "Humidificateur",
          "Glacière",
          "Réfrigérateur à kimchi",
          "Mangle",
          "Chauffage micathermique",
          "Micro-ondes",
          "Piège à souris",
          "Chaudière au fioul",
          "Four",
          "Déchiqueteuse à papier",
          "Chauffe-terrasse",
          "Radiateur",
          "Réfrigérateur",
          "Machine à coudre",
          "Chauffe-eau solaire",
          "Chauferette",
          "Nettoyeur vapeur",
          "Cuisinière",
          "Pompe de puisard",
          "Télévision",
          "Presse à Cravates",
          "Grille-pain",
          "Presse à pantalons",
          "Aspirateur",
          "Lave-linge",
          "Bouilloire",
          "Chauffe-eau",
          "Filtre à eau",
          "Ventilateur de fenêtre"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "publisher": [
          "Éditions du Soleil",
          "La Perdrix",
          "Les Éditions jaune turquoise",
          "Bordel père et fils",
          "Au lecteur éclairé",
          "Lire en dormant"
        ],
        "quote": [
          "Qui vivra verra",
          "L’habit ne fait pas le moine",
          "Chacun voit midi à sa porte",
          "Mieux vaut prévenir que guérir",
          "Petit a petit, l’oiseau fait son nid",
          "Qui court deux lievres a la fois, n’en prend aucun",
          "Qui n’avance pas, recule"
        ],
        "title": [
          "La Discipline des orphelins",
          "Le Couloir de tous les mépris",
          "L'Odeur du sanglier",
          "La Promise du voyeur",
          "L'Odyssée invisible",
          "La Soumission comme passion",
          "Le Siècle de la rue voisine",
          "Le Désir des femmes fortes",
          "Pourquoi je mens ?",
          "La Peau des savants",
          "La progéniture du mal"
        ]
      },
      "cell_phone": {
        "formats": [
          "06########",
          "07########",
          "6########",
          "7########",
          "06 ## ## ## ##",
          "07 ## ## ## ##",
          "6 ## ## ## ##",
          "7 ## ## ## ##"
        ]
      },
      "color": {
        "name": [
          "rouge",
          "vert",
          "bleu",
          "jaune",
          "violet",
          "vert menthe",
          "bleu sarcelle",
          "blanc",
          "noir",
          "orange",
          "rose",
          "gris",
          "marron",
          "turquoise",
          "brun",
          "bleu ciel",
          "saumon",
          "prune",
          "orchidée",
          "olive",
          "magenta",
          "vert citron",
          "ivoire",
          "indigo",
          "or",
          "fuchsia",
          "cyan",
          "azur",
          "lavande",
          "argent"
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name} et #{Name.last_name}"
        ],
        "suffix": [
          "SARL",
          "SA",
          "EURL",
          "SAS",
          "SEM",
          "SCOP",
          "GIE",
          "EI"
        ]
      },
      "compass": {
        "abbreviation": [
          "#{cardinal_abbreviation}",
          "#{ordinal_abbreviation}",
          "#{half_wind_abbreviation}"
        ],
        "cardinal": {
          "abbreviation": [
            "N",
            "E",
            "S",
            "O"
          ],
          "azimuth": [
            "0",
            "90",
            "180",
            "270"
          ],
          "word": [
            "nord",
            "est",
            "sud",
            "ouest"
          ]
        },
        "direction": [
          "#{cardinal}",
          "#{ordinal}",
          "#{half_wind}"
        ],
        "half-wind": {
          "abbreviation": [
            "NNE",
            "ENE",
            "ESE",
            "SSE",
            "SSO",
            "OSO",
            "ONO",
            "NNO"
          ],
          "azimuth": [
            "22.5",
            "67.5",
            "112.5",
            "157.5",
            "202.5",
            "247.5",
            "292.5",
            "337.5"
          ],
          "word": [
            "nord-nord-est",
            "est-nord-est",
            "est-sud-est",
            "sud-sud-est",
            "sud-sud-ouest",
            "ouest-sud-ouest",
            "ouest-nord-ouest",
            "nord-nord-ouest"
          ]
        },
        "ordinal": {
          "abbreviation": [
            "NE",
            "SE",
            "SO",
            "NO"
          ],
          "azimuth": [
            "45",
            "135",
            "225",
            "315"
          ],
          "word": [
            "nord-est",
            "sud-est",
            "sud-ouest",
            "nord-ouest"
          ]
        }
      },
      "creature": {
        "animal": {
          "name": [
            "alligator",
            "crocodile",
            "alpaca",
            "fourmi",
            "antilope",
            "singe",
            "tatou",
            "âne",
            "babouin",
            "blaireau",
            "chauve-souris",
            "ours",
            "castor",
            "abeille",
            "scarabée",
            "buffle",
            "papillon",
            "chameau",
            "caribou",
            "chat",
            "bovins",
            "guépard",
            "chimpanzé",
            "cigale",
            "palourde",
            "cafard",
            "morue",
            "coyote",
            "crabe",
            "criquet",
            "corbeau",
            "cerf",
            "dinosaure",
            "chien",
            "dauphin",
            "canard",
            "aigle",
            "anguille",
            "éléphant",
            "wapiti",
            "furet",
            "poisson",
            "mouche",
            "renard",
            "grenouille",
            "crapaud",
            "gerbille",
            "girafe",
            "gnou",
            "chèvre",
            "poisson rouge",
            "oie",
            "gorille",
            "sauterelle",
            "cochon d'Inde",
            "hamster",
            "lièvre",
            "hérisson",
            "hareng",
            "hippopotame",
            "frelon",
            "cheval",
            "hyène",
            "chacal",
            "méduse",
            "kangourou",
            "koala",
            "léopard",
            "lion",
            "lézard",
            "lama",
            "criquet",
            "colvert",
            "mammouth",
            "lamantin",
            "vison",
            "élan",
            "moustique",
            "souris",
            "rat",
            "mule",
            "loutre",
            "boeuf",
            "huître",
            "panda",
            "cochon",
            "ornithorynque",
            "porc-épic",
            "lapin",
            "raton laveur",
            "renne",
            "rhinocéros",
            "saumon",
            "sardine",
            "Scorpion",
            "lion de mer",
            "requin",
            "le mouton",
            "moufette",
            "escargot",
            "serpent",
            "araignée",
            "écureuil",
            "cygne",
            "termite",
            "tigre",
            "truite",
            "tortue",
            "morse",
            "guêpe",
            "belette",
            "baleine",
            "loup",
            "marmotte",
            "ver de terre",
            "guêpe jaune",
            "zèbre"
          ]
        }
      },
      "demographic": {
        "sex": [
          "Homme",
          "Femme"
        ]
      },
      "games": {
        "pokemon": {
          "locations": [
            "Arabelle",
            "Roche-sur-Gliffe",
            "Flusselles",
            "Rotombourg",
            "Quarellis",
            "Pavonnay",
            "Ecorcia",
            "Ville noire",
            "Ebenelle",
            "Fort-Vanitas",
            "Joliberge",
            "Volucité",
            "Celadopole",
            "Célestia",
            "Azuria",
            "Ville-Griotte",
            "Irisia",
            "Cramois'Île",
            "Port Tempères",
            "Mozheim",
            "Relifac-le-Haut",
            "La Frescale",
            "Myokara",
            "Port Yoneuve",
            "Rosalia",
            "Vestigion",
            "Eternara",
            "Autéquia",
            "Zone de Combat",
            "Île 5",
            "Floraville",
            "Amaillide",
            "Cimetronelle",
            "Île 4",
            "Atrium Combat",
            "Parmanie",
            "Cromlac'h",
            "Doublonville",
            "Unionpolis",
            "Papeloa",
            "Flocombe",
            "Féli-Cité",
            "Batisques",
            "Entrelasque",
            "Vermilava",
            "Lavanville",
            "Romant-sous-Bois",
            "Arpentières",
            "Bourg-en-Vol",
            "Nénucrique",
            "Illumis",
            "Acajou",
            "Lavandia",
            "Parsemille",
            "Algatia",
            "Maillard",
            "Bourg Geon",
            "Méanville",
            "Renouet",
            "Rosyères",
            "Oliville",
            "Île 1",
            "Janusia",
            "Charbourg",
            "Pacifiville",
            "Bourg Palette",
            "Verchamps",
            "Clémenti-Ville",
            "Argenta",
            "Aire de Détente",
            "Mérouville",
            "Portail Safari",
            "Safrania",
            "Littorella",
            "Neuvartault",
            "Ogoesse",
            "Île 7",
            "Yantreizh",
            "Île 6",
            "Poivressel",
            "Auffrac-les-Congères",
            "Frimapic",
            "Bonville",
            "Atalanopolis",
            "Rivamar",
            "Aire de Survie",
            "Île 3",
            "Bonaugure",
            "Île 2",
            "Vaguelone",
            "Bourg Croquis",
            "Voilaroc",
            "Vergazon",
            "Carmin sur Mer",
            "Mauville",
            "Ondes-sur-Mer",
            "Jadielle",
            "Forêt Blanche"
          ],
          "moves": [
            "Vol-Vie",
            "Acide",
            "Acidarmure",
            "Hâte",
            "Amnésie",
            "Onde Boréale",
            "Pilonnage",
            "Bouclier",
            "Patience",
            "Etreinte",
            "Morsure",
            "Blizzard",
            "Plaquage",
            "Massd'Os",
            "Osmerang",
            "Ecume",
            "Bulles d'O",
            "Claquoir",
            "Poing Comète",
            "Onde Folie",
            "Choc Mental",
            "Constriction",
            "Conversion",
            "Riposte",
            "Pince-Masse",
            "Coupe",
            "Boul'Armure",
            "Tunnel",
            "Entrave",
            "Uppercut",
            "Double-Pied",
            "Torgnoles",
            "Reflet",
            "Damoclès",
            "Draco-Rage",
            "Dévorêve",
            "Bec Vrille",
            "Séisme",
            "Bomb'Oeuf",
            "Flammèche",
            "Explosion",
            "Déflagration",
            "Poing de Feu",
            "Danse Flamme",
            "Abîme",
            "Lance-Flamme",
            "Flash",
            "Vol",
            "Puissance",
            "Furie",
            "Combo-Griffe",
            "Regard Médusant",
            "Rugissement",
            "Croissance",
            "Guillotine",
            "Tornade",
            "Armure",
            "Buée Noire",
            "Coup d'Boule",
            "Pied Voltige",
            "Koud'Korne",
            "Empal'Korne",
            "Hydrocanon",
            "Ultralaser",
            "Croc de Mort",
            "Hypnose",
            "Laser Glace",
            "Poing-Glace",
            "Pied Sauté",
            "Poing Karaté",
            "Télékinésie",
            "Vampirisme",
            "Vampigraine",
            "Groz'Yeux",
            "Léchouille",
            "Mur Lumière",
            "Grobisou",
            "Balayage",
            "Yoga",
            "Méga-Sangsue",
            "Ultimawashi",
            "Ultimapoing",
            "Métronome",
            "Copie",
            "Lilliput",
            "Mimique",
            "Brume",
            "Ombre Nocturne",
            "Jackpot",
            "Picpic",
            "Danse-Fleur",
            "Dard-Nuée",
            "Gaz Toxik",
            "Poudre Poison",
            "Dard-Venin",
            "Ecras'Face",
            "Rafale Psy",
            "Psyko",
            "Vague Psy",
            "Vive-Attaque",
            "Frénésie",
            "Tranch'Herbe",
            "Coupe-Vent",
            "Soin",
            "Protection",
            "Repos",
            "Hurlement",
            "Eboulement",
            "Jet-Pierres",
            "Mawashi Geri",
            "Jet de Sable",
            "Griffe",
            "Grincement",
            "Amplitude",
            "Destruction",
            "Affûtage",
            "Berceuse",
            "Coud'Krâne",
            "Piqué",
            "Souplesse",
            "Tranche",
            "Poudre Dodo",
            "Détritus",
            "Purédpois",
            "Brouillard",
            "E-Coque",
            "Lance-Soleil",
            "Sonicboom",
            "Picanon",
            "Trempette",
            "Spore",
            "Ecrasement",
            "Force",
            "Sécrétion",
            "Lutte",
            "Para-Spore",
            "Sacrifice",
            "Clonage",
            "Croc Fatal",
            "Ultrason",
            "Surf",
            "Météores",
            "Danse-Lames",
            "Charge",
            "Mimi-Queue",
            "Bélier",
            "Téléport",
            "Mania",
            "Fatal-Foudre",
            "Poing-Eclair",
            "Eclair",
            "Cage-Eclair",
            "Tonnerre",
            "Toxic",
            "Morphing",
            "Triplattaque",
            "Double-Dard",
            "Force Poigne",
            "Fouet Liane",
            "Pistolet à O",
            "Cascade",
            "Cyclone",
            "Cru-Aile",
            "Repli",
            "Ligotage"
          ],
          "names": [
            "Bulbizarre",
            "Herbizarre",
            "Florizarre",
            "Salamèche",
            "Reptincel",
            "Dracaufeu",
            "Carapuce",
            "Carabaffe",
            "Tortank",
            "Chenipan",
            "Chrysacier",
            "Papilusion",
            "Aspicot",
            "Coconfort",
            "Dardargnan",
            "Roucool",
            "Roucoups",
            "Roucarnage",
            "Rattata",
            "Rattatac",
            "Piafabec",
            "Rapasdepic",
            "Abo",
            "Arbok",
            "Pikachu",
            "Raichu",
            "Sabelette",
            "Sablaireau",
            "Nidoran",
            "Nidorina",
            "Nidoqueen",
            "Nidoran",
            "Nidorino",
            "Nidoking",
            "Mélofée",
            "Mélodelfe",
            "Goupix",
            "Feunard",
            "Rondoudou",
            "Grodoudou",
            "Nosférapti",
            "Nosféralto",
            "Mystherbe",
            "Ortide",
            "Rafflésia",
            "Paras",
            "Parasect",
            "Mimitoss",
            "Aéromite",
            "Taupiqueur",
            "Triopikeur",
            "Miaouss",
            "Persian",
            "Psykokwak",
            "Akwakwak",
            "Férosinge",
            "Colossinge",
            "Canidos",
            "Arcanin",
            "Ptitard",
            "Tétarte",
            "Tartard",
            "Abra",
            "Kadabra",
            "Alakazam",
            "Machoc",
            "Machopeur",
            "Mackogneur",
            "Chétiflor",
            "Boustiflor",
            "Empiflor",
            "Tentacool",
            "Tentacruel",
            "Racaillou",
            "Gravalanche",
            "Grolem",
            "Ponyta",
            "Galopa",
            "Ramoloss",
            "Flagadoss",
            "Magnéti",
            "Magnéton",
            "Canarticho",
            "Doduo",
            "Dodrio",
            "Otaria",
            "Lamantine",
            "Tadmorv",
            "Grotadmorv",
            "Kokyas",
            "Crustabri",
            "Fantominus",
            "Spectrum",
            "Ectoplasma",
            "Onix",
            "Soporifik",
            "Hypnomade",
            "Krabby",
            "Kraboss",
            "Voltorb",
            "Electrode",
            "Noeunoeuf",
            "Noadkoko",
            "Osselait",
            "Ossatueur",
            "Kicklee",
            "Tygnon",
            "Excelangue",
            "Smogo",
            "Smogogo",
            "Rhinocorne",
            "Rhinoféros",
            "Leveinard",
            "Saquedeneu",
            "Kangourex",
            "Hypotrempe",
            "Hypocéan",
            "Poissirène",
            "Poissoroy",
            "Stari",
            "Staross",
            "Mr. Mime",
            "Insécateur",
            "Lippoutou",
            "Elektek",
            "Magmar",
            "Scarabrute",
            "Tauros",
            "Magicarpe",
            "Léviator",
            "Lokhlass",
            "Métamorph",
            "Evoli",
            "Aquali",
            "Voltali",
            "Pyroli",
            "Porygon",
            "Amonita",
            "Amonistar",
            "Kabuto",
            "Kabutops",
            "Ptéra",
            "Ronflex",
            "Artikodin",
            "Electhor",
            "Sulfura",
            "Minidraco",
            "Draco",
            "Dracolosse",
            "Mewtwo",
            "Mew"
          ]
        }
      },
      "gender": {
        "binary_types": [
          "Masculin",
          "Féminin"
        ],
        "short_binary_types": [
          "f",
          "m"
        ],
        "types": [
          "Masculin",
          "Féminin",
          "Agenre",
          "Androgyne",
          "Au genre non conforme",
          "Aucun",
          "Bigenre",
          "En questionnement",
          "Polygenre",
          "Transmasculin",
          "Transféminin"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "fr",
          "eu",
          "info",
          "name",
          "net",
          "org",
          "immo",
          "paris",
          "alsace",
          "bzh"
        ]
      },
      "lorem": {
        "supplemental": [
          "abbas",
          "abduco",
          "abeo",
          "abscido",
          "absconditus",
          "absens",
          "absorbeo",
          "absque",
          "abstergo",
          "absum",
          "abundans",
          "abutor",
          "accedo",
          "accendo",
          "acceptus",
          "accipio",
          "accommodo",
          "accusator",
          "acer",
          "acerbitas",
          "acervus",
          "acidus",
          "acies",
          "acquiro",
          "acsi",
          "adamo",
          "adaugeo",
          "addo",
          "adduco",
          "ademptio",
          "adeo",
          "adeptio",
          "adfectus",
          "adfero",
          "adficio",
          "adflicto",
          "adhaero",
          "adhuc",
          "adicio",
          "adimpleo",
          "adinventitias",
          "adipiscor",
          "adiuvo",
          "administratio",
          "admiratio",
          "admitto",
          "admoneo",
          "admoveo",
          "adnuo",
          "adopto",
          "adsidue",
          "adstringo",
          "adsuesco",
          "adsum",
          "adulatio",
          "adulescens",
          "adultus",
          "aduro",
          "advenio",
          "adversus",
          "advoco",
          "aedificium",
          "aeger",
          "aegre",
          "aegrotatio",
          "aegrus",
          "aeneus",
          "aequitas",
          "aequus",
          "aer",
          "aestas",
          "aestivus",
          "aestus",
          "aetas",
          "aeternus",
          "ager",
          "aggero",
          "aggredior",
          "agnitio",
          "agnosco",
          "ago",
          "ait",
          "aiunt",
          "alienus",
          "alii",
          "alioqui",
          "aliqua",
          "alius",
          "allatus",
          "alo",
          "alter",
          "altus",
          "alveus",
          "amaritudo",
          "ambitus",
          "ambulo",
          "amicitia",
          "amiculum",
          "amissio",
          "amita",
          "amitto",
          "amo",
          "amor",
          "amoveo",
          "amplexus",
          "amplitudo",
          "amplus",
          "ancilla",
          "angelus",
          "angulus",
          "angustus",
          "animadverto",
          "animi",
          "animus",
          "annus",
          "anser",
          "ante",
          "antea",
          "antepono",
          "antiquus",
          "aperio",
          "aperte",
          "apostolus",
          "apparatus",
          "appello",
          "appono",
          "appositus",
          "approbo",
          "apto",
          "aptus",
          "apud",
          "aqua",
          "ara",
          "aranea",
          "arbitro",
          "arbor",
          "arbustum",
          "arca",
          "arceo",
          "arcesso",
          "arcus",
          "argentum",
          "argumentum",
          "arguo",
          "arma",
          "armarium",
          "armo",
          "aro",
          "ars",
          "articulus",
          "artificiose",
          "arto",
          "arx",
          "ascisco",
          "ascit",
          "asper",
          "aspicio",
          "asporto",
          "assentator",
          "astrum",
          "atavus",
          "ater",
          "atqui",
          "atrocitas",
          "atrox",
          "attero",
          "attollo",
          "attonbitus",
          "auctor",
          "auctus",
          "audacia",
          "audax",
          "audentia",
          "audeo",
          "audio",
          "auditor",
          "aufero",
          "aureus",
          "auris",
          "aurum",
          "aut",
          "autem",
          "autus",
          "auxilium",
          "avaritia",
          "avarus",
          "aveho",
          "averto",
          "avoco",
          "baiulus",
          "balbus",
          "barba",
          "bardus",
          "basium",
          "beatus",
          "bellicus",
          "bellum",
          "bene",
          "beneficium",
          "benevolentia",
          "benigne",
          "bestia",
          "bibo",
          "bis",
          "blandior",
          "bonus",
          "bos",
          "brevis",
          "cado",
          "caecus",
          "caelestis",
          "caelum",
          "calamitas",
          "calcar",
          "calco",
          "calculus",
          "callide",
          "campana",
          "candidus",
          "canis",
          "canonicus",
          "canto",
          "capillus",
          "capio",
          "capitulus",
          "capto",
          "caput",
          "carbo",
          "carcer",
          "careo",
          "caries",
          "cariosus",
          "caritas",
          "carmen",
          "carpo",
          "carus",
          "casso",
          "caste",
          "casus",
          "catena",
          "caterva",
          "cattus",
          "cauda",
          "causa",
          "caute",
          "caveo",
          "cavus",
          "cedo",
          "celebrer",
          "celer",
          "celo",
          "cena",
          "cenaculum",
          "ceno",
          "censura",
          "centum",
          "cerno",
          "cernuus",
          "certe",
          "certo",
          "certus",
          "cervus",
          "cetera",
          "charisma",
          "chirographum",
          "cibo",
          "cibus",
          "cicuta",
          "cilicium",
          "cimentarius",
          "ciminatio",
          "cinis",
          "circumvenio",
          "cito",
          "civis",
          "civitas",
          "clam",
          "clamo",
          "claro",
          "clarus",
          "claudeo",
          "claustrum",
          "clementia",
          "clibanus",
          "coadunatio",
          "coaegresco",
          "coepi",
          "coerceo",
          "cogito",
          "cognatus",
          "cognomen",
          "cogo",
          "cohaero",
          "cohibeo",
          "cohors",
          "colligo",
          "colloco",
          "collum",
          "colo",
          "color",
          "coma",
          "combibo",
          "comburo",
          "comedo",
          "comes",
          "cometes",
          "comis",
          "comitatus",
          "commemoro",
          "comminor",
          "commodo",
          "communis",
          "comparo",
          "compello",
          "complectus",
          "compono",
          "comprehendo",
          "comptus",
          "conatus",
          "concedo",
          "concido",
          "conculco",
          "condico",
          "conduco",
          "confero",
          "confido",
          "conforto",
          "confugo",
          "congregatio",
          "conicio",
          "coniecto",
          "conitor",
          "coniuratio",
          "conor",
          "conqueror",
          "conscendo",
          "conservo",
          "considero",
          "conspergo",
          "constans",
          "consuasor",
          "contabesco",
          "contego",
          "contigo",
          "contra",
          "conturbo",
          "conventus",
          "convoco",
          "copia",
          "copiose",
          "cornu",
          "corona",
          "corpus",
          "correptius",
          "corrigo",
          "corroboro",
          "corrumpo",
          "coruscus",
          "cotidie",
          "crapula",
          "cras",
          "crastinus",
          "creator",
          "creber",
          "crebro",
          "credo",
          "creo",
          "creptio",
          "crepusculum",
          "cresco",
          "creta",
          "cribro",
          "crinis",
          "cruciamentum",
          "crudelis",
          "cruentus",
          "crur",
          "crustulum",
          "crux",
          "cubicularis",
          "cubitum",
          "cubo",
          "cui",
          "cuius",
          "culpa",
          "culpo",
          "cultellus",
          "cultura",
          "cum",
          "cunabula",
          "cunae",
          "cunctatio",
          "cupiditas",
          "cupio",
          "cuppedia",
          "cupressus",
          "cur",
          "cura",
          "curatio",
          "curia",
          "curiositas",
          "curis",
          "curo",
          "curriculum",
          "currus",
          "cursim",
          "curso",
          "cursus",
          "curto",
          "curtus",
          "curvo",
          "curvus",
          "custodia",
          "damnatio",
          "damno",
          "dapifer",
          "debeo",
          "debilito",
          "decens",
          "decerno",
          "decet",
          "decimus",
          "decipio",
          "decor",
          "decretum",
          "decumbo",
          "dedecor",
          "dedico",
          "deduco",
          "defaeco",
          "defendo",
          "defero",
          "defessus",
          "defetiscor",
          "deficio",
          "defigo",
          "defleo",
          "defluo",
          "defungo",
          "degenero",
          "degero",
          "degusto",
          "deinde",
          "delectatio",
          "delego",
          "deleo",
          "delibero",
          "delicate",
          "delinquo",
          "deludo",
          "demens",
          "demergo",
          "demitto",
          "demo",
          "demonstro",
          "demoror",
          "demulceo",
          "demum",
          "denego",
          "denique",
          "dens",
          "denuncio",
          "denuo",
          "deorsum",
          "depereo",
          "depono",
          "depopulo",
          "deporto",
          "depraedor",
          "deprecator",
          "deprimo",
          "depromo",
          "depulso",
          "deputo",
          "derelinquo",
          "derideo",
          "deripio",
          "desidero",
          "desino",
          "desipio",
          "desolo",
          "desparatus",
          "despecto",
          "despirmatio",
          "infit",
          "inflammatio",
          "paens",
          "patior",
          "patria",
          "patrocinor",
          "patruus",
          "pauci",
          "paulatim",
          "pauper",
          "pax",
          "peccatus",
          "pecco",
          "pecto",
          "pectus",
          "pecunia",
          "pecus",
          "peior",
          "pel",
          "ocer",
          "socius",
          "sodalitas",
          "sol",
          "soleo",
          "solio",
          "solitudo",
          "solium",
          "sollers",
          "sollicito",
          "solum",
          "solus",
          "solutio",
          "solvo",
          "somniculosus",
          "somnus",
          "sonitus",
          "sono",
          "sophismata",
          "sopor",
          "sordeo",
          "sortitus",
          "spargo",
          "speciosus",
          "spectaculum",
          "speculum",
          "sperno",
          "spero",
          "spes",
          "spiculum",
          "spiritus",
          "spoliatio",
          "sponte",
          "stabilis",
          "statim",
          "statua",
          "stella",
          "stillicidium",
          "stipes",
          "stips",
          "sto",
          "strenuus",
          "strues",
          "studio",
          "stultus",
          "suadeo",
          "suasoria",
          "sub",
          "subito",
          "subiungo",
          "sublime",
          "subnecto",
          "subseco",
          "substantia",
          "subvenio",
          "succedo",
          "succurro",
          "sufficio",
          "suffoco",
          "suffragium",
          "suggero",
          "sui",
          "sulum",
          "sum",
          "summa",
          "summisse",
          "summopere",
          "sumo",
          "sumptus",
          "supellex",
          "super",
          "suppellex",
          "supplanto",
          "suppono",
          "supra",
          "surculus",
          "surgo",
          "sursum",
          "suscipio",
          "suspendo",
          "sustineo",
          "suus",
          "synagoga",
          "tabella",
          "tabernus",
          "tabesco",
          "tabgo",
          "tabula",
          "taceo",
          "tactus",
          "taedium",
          "talio",
          "talis",
          "talus",
          "tam",
          "tamdiu",
          "tamen",
          "tametsi",
          "tamisium",
          "tamquam",
          "tandem",
          "tantillus",
          "tantum",
          "tardus",
          "tego",
          "temeritas",
          "temperantia",
          "templum",
          "temptatio",
          "tempus",
          "tenax",
          "tendo",
          "teneo",
          "tener",
          "tenuis",
          "tenus",
          "tepesco",
          "tepidus",
          "ter",
          "terebro",
          "teres",
          "terga",
          "tergeo",
          "tergiversatio",
          "tergo",
          "tergum",
          "termes",
          "terminatio",
          "tero",
          "terra",
          "terreo",
          "territo",
          "terror",
          "tersus",
          "tertius",
          "testimonium",
          "texo",
          "textilis",
          "textor",
          "textus",
          "thalassinus",
          "theatrum",
          "theca",
          "thema",
          "theologus",
          "thermae",
          "thesaurus",
          "thesis",
          "thorax",
          "thymbra",
          "thymum",
          "tibi",
          "timidus",
          "timor",
          "titulus",
          "tolero",
          "tollo",
          "tondeo",
          "tonsor",
          "torqueo",
          "torrens",
          "tot",
          "totidem",
          "toties",
          "totus",
          "tracto",
          "trado",
          "traho",
          "trans",
          "tredecim",
          "tremo",
          "trepide",
          "tres",
          "tribuo",
          "tricesimus",
          "triduana",
          "triginta",
          "tripudio",
          "tristis",
          "triumphus",
          "trucido",
          "truculenter",
          "tubineus",
          "tui",
          "tum",
          "tumultus",
          "tunc",
          "turba",
          "turbo",
          "turpe",
          "turpis",
          "tutamen",
          "tutis",
          "tyrannus",
          "uberrime",
          "ubi",
          "ulciscor",
          "ullus",
          "ulterius",
          "ultio",
          "ultra",
          "umbra",
          "umerus",
          "umquam",
          "una",
          "unde",
          "undique",
          "universe",
          "unus",
          "urbanus",
          "urbs",
          "uredo",
          "usitas",
          "usque",
          "ustilo",
          "ustulo",
          "usus",
          "uter",
          "uterque",
          "utilis",
          "utique",
          "utor",
          "utpote",
          "utrimque",
          "utroque",
          "utrum",
          "uxor",
          "vaco",
          "vacuus",
          "vado",
          "vae",
          "valde",
          "valens",
          "valeo",
          "valetudo",
          "validus",
          "vallum",
          "vapulus",
          "varietas",
          "varius",
          "vehemens",
          "vel",
          "velociter",
          "velum",
          "velut",
          "venia",
          "venio",
          "ventito",
          "ventosus",
          "ventus",
          "venustas",
          "ver",
          "verbera",
          "verbum",
          "vere",
          "verecundia",
          "vereor",
          "vergo",
          "veritas",
          "vero",
          "versus",
          "verto",
          "verumtamen",
          "verus",
          "vesco",
          "vesica",
          "vesper",
          "vespillo",
          "vester",
          "vestigium",
          "vestrum",
          "vetus",
          "via",
          "vicinus",
          "vicissitudo",
          "victoria",
          "victus",
          "videlicet",
          "video",
          "viduata",
          "viduo",
          "vigilo",
          "vigor",
          "vilicus",
          "vilis",
          "vilitas",
          "villa",
          "vinco",
          "vinculum",
          "vindico",
          "vinitor",
          "vinum",
          "vir",
          "virga",
          "virgo",
          "viridis",
          "viriliter",
          "virtus",
          "vis",
          "viscus",
          "vita",
          "vitiosus",
          "vitium",
          "vito",
          "vivo",
          "vix",
          "vobis",
          "vociferor",
          "voco",
          "volaticus",
          "volo",
          "volubilis",
          "voluntarius",
          "volup",
          "volutabrum",
          "volva",
          "vomer",
          "vomica",
          "vomito",
          "vorago",
          "vorax",
          "voro",
          "vos",
          "votum",
          "voveo",
          "vox",
          "vulariter",
          "vulgaris",
          "vulgivagus",
          "vulgo",
          "vulgus",
          "vulnero",
          "vulnus",
          "vulpes",
          "vulticulus",
          "vultuosus",
          "xiphias"
        ],
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "measurement": {
        "metric_height": [
          "millimètre",
          "centimètre",
          "mètre"
        ],
        "metric_length": [
          "millimètre",
          "centimètre",
          "décimètre",
          "mètre",
          "décamètre",
          "hectomètre",
          "kilomètre"
        ],
        "metric_volume": [
          "millilitre",
          "centilitre",
          "décilitre",
          "litre",
          "décalitre",
          "hectolitre",
          "décimètre cube",
          "mètre cube"
        ],
        "metric_weight": [
          "milligramme",
          "centigramme",
          "décigramme",
          "gramme",
          "décagramme",
          "hectogramme",
          "kilogramme",
          "tonne",
          "kilotonne"
        ]
      },
      "name": {
        "female_first_name": [
          "Abdonie",
          "Abeline",
          "Abigaelle",
          "Abigaïl",
          "Acacie",
          "Acanthe",
          "Adalbaude",
          "Adalsinde",
          "Adegrine",
          "Adélaïde",
          "Adèle",
          "Adélie",
          "Adeline",
          "Adeltrude",
          "Adolphie",
          "Adonise",
          "Adrastée",
          "Adrehilde",
          "Adrienne",
          "Agathe",
          "Agilberte",
          "Aglaé",
          "Agnane",
          "Agneflète",
          "Agnès",
          "Agrippine",
          "Aimée",
          "Alaine",
          "Alaïs",
          "Albane",
          "Albérade",
          "Alberte",
          "Alcidie",
          "Alcine",
          "Alcyone",
          "Aldegonde",
          "Aleth",
          "Alexandrine",
          "Alexanne",
          "Alexine",
          "Alice",
          "Aliénor",
          "Aliette",
          "Aline",
          "Alix",
          "Alizé",
          "Aloïse",
          "Aloyse",
          "Alphonsine",
          "Althée",
          "Amaliane",
          "Amalthée",
          "Amande",
          "Amandine",
          "Amante",
          "Amarande",
          "Amaranthe",
          "Amaryllis",
          "Ambre",
          "Ambroisie",
          "Améliane",
          "Amélie",
          "Ameline",
          "Améthyste",
          "Aminte",
          "Anaëlle",
          "Anaïs",
          "Anastasie",
          "Anatolie",
          "Anceline",
          "Andrée",
          "Anémone",
          "Angadrême",
          "Angèle",
          "Angeline",
          "Angélique",
          "Angilberte",
          "Anicée",
          "Anicette",
          "Annabelle",
          "Anne",
          "Annette",
          "Annonciade",
          "Ansberte",
          "Anstrudie",
          "Anthelmette",
          "Antigone",
          "Antoinette",
          "Antonine",
          "Aphélie",
          "Apolline",
          "Aquiline",
          "Arabelle",
          "Arcadie",
          "Archange",
          "Argine",
          "Ariane",
          "Aricie",
          "Ariel",
          "Arielle",
          "Arlette",
          "Armance",
          "Armande",
          "Armandine",
          "Armeline",
          "Armide",
          "Armelle",
          "Armine",
          "Arnaude",
          "Arsènie",
          "Arsinoé",
          "Artémis",
          "Arthurine",
          "Asceline",
          "Ascension",
          "Assomption",
          "Astarté",
          "Astérie",
          "Astrée",
          "Astride",
          "Athalie",
          "Athanasie",
          "Athénaïs",
          "Aube",
          "Aubertine",
          "Aude",
          "Audeline",
          "Audrey",
          "Augustine",
          "Aure",
          "Aurélie",
          "Aurélienne",
          "Aurelle",
          "Auriane",
          "Aurore",
          "Auxane",
          "Aveline",
          "Avigaëlle",
          "Avoye",
          "Axeline",
          "Axelle",
          "Aymardine",
          "Aymonde",
          "Azalée",
          "Azélie",
          "Azeline",
          "Barbe",
          "Basilisse",
          "Bathilde",
          "Béatrice",
          "Bénédicte",
          "Bérangère",
          "Bernadette",
          "Berthe",
          "Bertille",
          "Betty",
          "Beuve",
          "Blanche",
          "Blandine",
          "Brigitte",
          "Brune",
          "Brunehaut",
          "Brunehilde",
          "Camille",
          "Capucine",
          "Carine",
          "Caroline",
          "Cassandre",
          "Catherine",
          "Cécile",
          "Céleste",
          "Célestine",
          "Céline",
          "Chantal",
          "Charlaine",
          "Charline",
          "Charlotte",
          "Chloé",
          "Christelle",
          "Christiane",
          "Christine",
          "Claire",
          "Clara",
          "Claude",
          "Claudine",
          "Clarisse",
          "Clélie",
          "Clémence",
          "Clémentine",
          "Clio",
          "Clotilde",
          "Coline",
          "Conception",
          "Constance",
          "Coralie",
          "Coraline",
          "Corentine",
          "Corinne",
          "Cyrielle",
          "Danielle",
          "Daphné",
          "Delphine",
          "Denise",
          "Diane",
          "Dieudonnée",
          "Dominique",
          "Doriane",
          "Dorine",
          "Dorothée",
          "Douce",
          "Edmée",
          "Éléonore",
          "Éliane",
          "Éliette",
          "Élisabeth",
          "Élise",
          "Ella",
          "Élodie",
          "Éloïse",
          "Elsa",
          "Émeline",
          "Émérance",
          "Émérencie",
          "Émilie",
          "Emma",
          "Emmanuelle",
          "Emmelie",
          "Ernestine",
          "Esther",
          "Estelle",
          "Eudoxie",
          "Eugénie",
          "Eulalie",
          "Euphrasie",
          "Eusébie",
          "Évangéline",
          "Ève",
          "Évelyne",
          "Fanny",
          "Fantine",
          "Faustine",
          "Félicie",
          "Frédérique",
          "Flavie",
          "Fleur",
          "Flore",
          "Florence",
          "Florie",
          "Fortunée",
          "France",
          "Francette",
          "Françoise",
          "Francine",
          "Gabrielle",
          "Gaëlle",
          "Garance",
          "Geneviève",
          "Georgette",
          "Gerberge",
          "Germaine",
          "Gertrude",
          "Gilberte",
          "Gisèle",
          "Guenièvre",
          "Guilhemine",
          "Guillemette",
          "Gustavine",
          "Gwenaëlle",
          "Gwendoline",
          "Hélène",
          "Héloïse",
          "Henriette",
          "Henryane",
          "Hermine",
          "Hippolyte",
          "Honorine",
          "Hortense",
          "Huguette",
          "Irène",
          "Iris",
          "Isabeau",
          "Isabelle",
          "Isaure",
          "Iseult",
          "Ismérie",
          "Jacinthe",
          "Jacqueline",
          "Jade",
          "Janine",
          "Jeanne",
          "Jeanne",
          "Jehanne",
          "Jocelyne",
          "Joëlle",
          "Joséphine",
          "Judith",
          "Julie",
          "Juliette",
          "Justine",
          "Laurane",
          "Laure",
          "Laureline",
          "Laurence",
          "Laurène",
          "Lauriane",
          "Laurine",
          "Léopoldine",
          "Léonie",
          "Léonne",
          "Lorraine",
          "Lucie",
          "Lucienne",
          "Lucille",
          "Ludivine",
          "Lydie",
          "Mégane",
          "Madeleine",
          "Magali",
          "Maguelone",
          "Mahaut",
          "Mallaury",
          "Manon",
          "Marceline",
          "Margot",
          "Marianne",
          "Marie",
          "Marine",
          "Marion",
          "Marjorie",
          "Marlène",
          "Marthe",
          "Martine",
          "Mathilde",
          "Maud",
          "Maureen",
          "Mauricette",
          "Maxellende",
          "Maxime",
          "Mélanie",
          "Mélisse",
          "Mélissandre",
          "Mélisande",
          "Mélodie",
          "Michèle",
          "Mireille",
          "Moïsette",
          "Monique",
          "Morgane",
          "Muriel",
          "Mylène",
          "Nadège",
          "Nadine",
          "Nathalie",
          "Nicole",
          "Nine",
          "Noëlle",
          "Noélie",
          "Noémie",
          "Océane",
          "Odette",
          "Odile",
          "Olive",
          "Olympe",
          "Ombline",
          "Ophélie",
          "Oriande",
          "Oriane",
          "Orlane",
          "Ozanne",
          "Pascale",
          "Paule",
          "Paulette",
          "Pauline",
          "Priscille",
          "Pécine",
          "Pélagie",
          "Pénélope",
          "Perrine",
          "Pétronille",
          "Philippine",
          "Philomène",
          "Philothée",
          "Primerose",
          "Prudence",
          "Pulchérie",
          "Quentine",
          "Quitterie",
          "Rachel",
          "Raphaëlle",
          "Raymonde",
          "Régine",
          "Reine",
          "Réjeanne",
          "Renée",
          "Rictrude",
          "Rolande",
          "Romane",
          "Rosalie",
          "Rose",
          "Roseline",
          "Ruth",
          "Sabine",
          "Salomé",
          "Sandrine",
          "Scholastique",
          "Ségolène",
          "Séverine",
          "Sibylle",
          "Simone",
          "Sixtine",
          "Solange",
          "Soline",
          "Sophie",
          "Stéphanie",
          "Suzanne",
          "Suzon",
          "Sylviane",
          "Sylvie",
          "Thérèse",
          "Tiphaine",
          "Ursule",
          "Valentine",
          "Valérie",
          "Véronique",
          "Victoire",
          "Vinciane",
          "Violette",
          "Virginie",
          "Viviane",
          "Xavière",
          "Yolande",
          "Ysaline",
          "Yseult",
          "Yvette",
          "Yvonne",
          "Zélie",
          "Zéphirine",
          "Zoé"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Adam",
          "Andre",
          "André",
          "Antoine",
          "Arnaud",
          "Aubert",
          "Aubry",
          "Bailly",
          "Barbier",
          "Baron",
          "Barre",
          "Barthelemy",
          "Benard",
          "Benoit",
          "Berger",
          "Bernard",
          "Bertin",
          "Bertrand",
          "Besson",
          "Blanc",
          "Blanchard",
          "Bonnet",
          "Boucher",
          "Bouchet",
          "Boulanger",
          "Bourgeois",
          "Bouvier",
          "Boyer",
          "Breton",
          "Brun",
          "Brunet",
          "Carlier",
          "Caron",
          "Carpentier",
          "Carre",
          "Charles",
          "Charpentier",
          "Chauvin",
          "Chevalier",
          "Chevallier",
          "Clement",
          "Clément",
          "Colin",
          "Collet",
          "Collin",
          "Cordier",
          "Cousin",
          "Da Silva",
          "Da silva",
          "Daniel",
          "David",
          "Delaunay",
          "Denis",
          "Deschamps",
          "Dubois",
          "Dufour",
          "Dumas",
          "Dumont",
          "Dupont",
          "Dupuis",
          "Dupuy",
          "Durand",
          "Duval",
          "Dvnis",
          "Etienne",
          "Fabre",
          "Faure",
          "Fernandez",
          "Fleury",
          "Fontaine",
          "Fournier",
          "Francois",
          "Gaillard",
          "Garcia",
          "Garnier",
          "Gauthier",
          "Gautier",
          "Gay",
          "Gerard",
          "Gérard",
          "Germain",
          "Gilbert",
          "Gillet",
          "Girard",
          "Giraud",
          "Gonzalez",
          "Grondin",
          "Guerin",
          "Guérin",
          "Guichard",
          "Guillaume",
          "Guillot",
          "Guyot",
          "Hamon",
          "Henry",
          "Herve",
          "Hoarau",
          "Hubert",
          "Huet",
          "Humbert",
          "Jacob",
          "Jacquet",
          "Jean",
          "Joly",
          "Julien",
          "Klein",
          "Lacroix",
          "Laine",
          "Lambert",
          "Lamy",
          "Langlois",
          "Laporte",
          "Laurent",
          "Le Gall",
          "Le Goff",
          "Le Roux",
          "Le gall",
          "Le roux",
          "Leblanc",
          "Lebrun",
          "Leclerc",
          "Leclercq",
          "Lecomte",
          "Lefevre",
          "Lefèvre",
          "Leger",
          "Legrand",
          "Lejeune",
          "Lemaire",
          "Lemaitre",
          "Lemoine",
          "Leroux",
          "Leroy",
          "Leveque",
          "Lévêque",
          "Lopez",
          "Lopéz",
          "Louis",
          "Lucas",
          "Maillard",
          "Mallet",
          "Marchal",
          "Marchand",
          "Marechal",
          "Marie",
          "Martin",
          "Martinez",
          "Marty",
          "Masson",
          "Mathieu",
          "Menard",
          "Ménard",
          "Mercier",
          "Meunier",
          "Méunier",
          "Meyer",
          "Michaud",
          "Michel",
          "Millet",
          "Monnier",
          "Moreau",
          "Morel",
          "Morin",
          "Moulin",
          "Muller",
          "Nguyen",
          "Nicolas",
          "Noel",
          "Noël",
          "Olivier",
          "Paris",
          "Pasquier",
          "Paul",
          "Payet",
          "Pelletier",
          "Perez",
          "Perret",
          "Perrier",
          "Perrin",
          "Perrot",
          "Petit",
          "Philippe",
          "Picard",
          "Pichon",
          "Pierre",
          "Poirier",
          "Pons",
          "Poulain",
          "Prevost",
          "Prévost",
          "Remy",
          "Rémy",
          "Renard",
          "Renaud",
          "Renault",
          "Rey",
          "Reynaud",
          "Richard",
          "Riviere",
          "Rivière",
          "Robert",
          "Robin",
          "Roche",
          "Rodriguez",
          "Roger",
          "Rolland",
          "Rousseau",
          "Roussel",
          "Roux",
          "Roy",
          "Royer",
          "Sanchez",
          "Schmitt",
          "Schneider",
          "Simon",
          "Tessier",
          "Thomas",
          "Vasseur",
          "Vidal",
          "Vincent",
          "Weber"
        ],
        "male_first_name": [
          "Abel",
          "Abélard",
          "Abelin",
          "Abraham",
          "Absalon",
          "Acace",
          "Achaire",
          "Achille",
          "Adalbéron",
          "Adegrin",
          "Adelin",
          "Adelphe",
          "Adenet",
          "Adéodat",
          "Adhémar",
          "Adjutor",
          "Adolphe",
          "Adrien",
          "Agapet",
          "Agathange",
          "Agathon",
          "Agilbert",
          "Agnan",
          "Agrippin",
          "Aimable",
          "Aimé",
          "Alain",
          "Alban",
          "Albéric",
          "Albert",
          "Alcibiade",
          "Alcide",
          "Alcime",
          "Aldonce",
          "Aldéric",
          "Aleaume",
          "Alexandre",
          "Alexis",
          "Alix",
          "Alliaume",
          "Almine",
          "Almire",
          "Aloïs",
          "Alphée",
          "Alphonse",
          "Alpinien",
          "Alverède",
          "Amaury",
          "Amandin",
          "Amant",
          "Ambroise",
          "Amédée",
          "Amélien",
          "Amiel",
          "Amos",
          "Amour",
          "Anastase",
          "Anatole",
          "Ancelin",
          "Andéol",
          "Andoche",
          "André",
          "Andy",
          "Ange",
          "Angilbe",
          "Angilran",
          "Angoustan",
          "Anicet",
          "Anne",
          "Annibal",
          "Anthelme",
          "Antide",
          "Antoine",
          "Antonin",
          "Apollinaire",
          "Aquilin",
          "Arcade",
          "Archambaud",
          "Archange",
          "Archibald",
          "Arian",
          "Ariste",
          "Aristide",
          "Armand",
          "Armel",
          "Arnould",
          "Arnaud",
          "Arolde",
          "Arsène",
          "Arsinoé",
          "Arthaud",
          "Arthème",
          "Arthur",
          "Ascelin",
          "Astolphe",
          "Athanase",
          "Aubry",
          "Audebert",
          "Audouin",
          "Audran",
          "Auguste",
          "Aurèle",
          "Aurian",
          "Axel",
          "Aymard",
          "Aymeric",
          "Aymon",
          "Baptiste",
          "Barnabé",
          "Barthélemy",
          "Bartimée",
          "Basile",
          "Bastien",
          "Baudouin",
          "Bénigne",
          "Benjamin",
          "Benoît",
          "Béranger",
          "Bérard",
          "Bernard",
          "Bertrand",
          "Blaise",
          "Bohémond",
          "Bon",
          "Boniface",
          "Bouchard",
          "Briac",
          "Brice",
          "Brieuc",
          "Bruno",
          "Brunon",
          "Calixte",
          "Camélien",
          "Camille",
          "Camillien",
          "Candide",
          "Caribert",
          "Carloman",
          "Cassandre",
          "Cassien",
          "Cédric",
          "Céleste",
          "Célestin",
          "Célien",
          "Césaire",
          "César",
          "Charles",
          "Charlemagne",
          "Childebert",
          "Chilpéric",
          "Clodion",
          "Chrétien",
          "Christian",
          "Christodule",
          "Christophe",
          "Chrysole",
          "Chrysostome",
          "Clarence",
          "Claude",
          "Claudien",
          "Cléandre",
          "Clément",
          "Clotaire",
          "Clovis",
          "Colin",
          "Côme",
          "Constance",
          "Constant",
          "Constantin",
          "Corentin",
          "Cyprien",
          "Cyriaque",
          "Cyrille",
          "Dagobert",
          "Damien",
          "Daniel",
          "David",
          "Delphin",
          "Denis",
          "Désiré",
          "Didier",
          "Dieudonné",
          "Dimitri",
          "Dominique",
          "Dorian",
          "Dorothée",
          "Edgard",
          "Edmond",
          "Édouard",
          "Éleuthère",
          "Élie",
          "Élisée",
          "Élzéar",
          "Émeric",
          "Émile",
          "Emmanuel",
          "Enguerrand",
          "Épiphane",
          "Éric",
          "Esprit",
          "Ernest",
          "Étienne",
          "Eubert",
          "Eudes",
          "Eudoxe",
          "Eugène",
          "Eusèbe",
          "Eustache",
          "Évariste",
          "Évrard",
          "Ézéchiel",
          "Fabien",
          "Fabrice",
          "Fantin",
          "Félicité",
          "Félix",
          "Ferdinand",
          "Fiacre",
          "Fidèle",
          "Firmin",
          "Flavien",
          "Flodoard",
          "Florent",
          "Florestan",
          "Florian",
          "Fortuné",
          "Foulques",
          "Francisque",
          "François",
          "Frédéric",
          "Fulbert",
          "Fulcran",
          "Fulgence",
          "Gabin",
          "Gabriel",
          "Gaël",
          "Garnier",
          "Galeran",
          "Gaston",
          "Gaspar",
          "Gaspard",
          "Gatien",
          "Gaud",
          "Gautier",
          "Gédéon",
          "Geoffroy",
          "Georges",
          "Géraud",
          "Gérard",
          "Gerbert",
          "Germain",
          "Gervais",
          "Ghislain",
          "Gilbert",
          "Gilles",
          "Girart",
          "Gondebaud",
          "Gonthier",
          "Gontran",
          "Gonzague",
          "Grégoire",
          "Guérin",
          "Gui",
          "Guillaume",
          "Gustave",
          "Guy",
          "Guyot",
          "Gwenael",
          "Hardouin",
          "Hector",
          "Hédelin",
          "Hélie",
          "Hélier",
          "Henri",
          "Herbert",
          "Herluin",
          "Hervé",
          "Hilaire",
          "Hincmar",
          "Hippolyte",
          "Honoré",
          "Hubert",
          "Hugues",
          "Innocent",
          "Isaac",
          "Isaïe",
          "Isabeau",
          "Isidore",
          "Jacques",
          "Jean",
          "Jeannel",
          "Jeannot",
          "Jérémie",
          "Jérôme",
          "Job",
          "Jocelyn",
          "Joël",
          "Jonas",
          "Jonathan",
          "Joseph",
          "Josse",
          "Josselin",
          "Jourdain",
          "Jude",
          "Judicaël",
          "Jules",
          "Julien",
          "Juste",
          "Justin",
          "Kévin",
          "Lambert",
          "Landry",
          "Laurent",
          "Lazare",
          "Léandre",
          "Léon",
          "Léonard",
          "Léopold",
          "Leu",
          "Leufroy",
          "Libère",
          "Liétald",
          "Lionel",
          "Loïc",
          "Longin",
          "Lorrain",
          "Lothaire",
          "Louis",
          "Loup",
          "Luc",
          "Lucien",
          "Ludolphe",
          "Ludovic",
          "Macaire",
          "Malo",
          "Mamert",
          "Manassé",
          "Marc",
          "Marceau",
          "Marcel",
          "Marcelin",
          "Marius",
          "Martial",
          "Martin",
          "Mathurin",
          "Matthias",
          "Matthieu",
          "Maugis",
          "Maurice",
          "Maxence",
          "Maxime",
          "Maximilien",
          "Mayeul",
          "Médéric",
          "Melchior",
          "Mence",
          "Merlin",
          "Mérovée",
          "Michaël",
          "Michel",
          "Moïse",
          "Morgan",
          "Nathanaël",
          "Narcisse",
          "Naudet",
          "Néhémie",
          "Nestor",
          "Nicéphore",
          "Nicolas",
          "Noé",
          "Noël",
          "Normand",
          "Octave",
          "Odilon",
          "Odon",
          "Oger",
          "Olivier",
          "Oury",
          "Pacôme",
          "Parfait",
          "Pascal",
          "Paterne",
          "Patrice",
          "Paul",
          "Pépin",
          "Perceval",
          "Philibert",
          "Philippe",
          "Philothée",
          "Pie",
          "Pierre",
          "Pierrick",
          "Prosper",
          "Quentin",
          "Raymond",
          "Régis",
          "Réjean",
          "Rémi",
          "Renaud",
          "René",
          "Reybaud",
          "Richard",
          "Robert",
          "Roch",
          "Rodolphe",
          "Rodrigue",
          "Roger",
          "Roland",
          "Romain",
          "Romuald",
          "Ronan",
          "Roselin",
          "Salomon",
          "Samuel",
          "Sauveur",
          "Savin",
          "Savinien",
          "Scholastique",
          "Sébastien",
          "Séraphin",
          "Serge",
          "Séverin",
          "Sidoine",
          "Sigebert",
          "Sigismond",
          "Silvère",
          "Sixte",
          "Stéphane",
          "Sylvain",
          "Sylvestre",
          "Tancrède",
          "Tanguy",
          "Taurin",
          "Thaddée",
          "Théodore",
          "Théodose",
          "Théophile",
          "Théophraste",
          "Thibault",
          "Thibert",
          "Thierry",
          "Thomas",
          "Timoléon",
          "Timothée",
          "Titien",
          "Tonnin",
          "Toussaint",
          "Trajan",
          "Tristan",
          "Turold",
          "Tim",
          "Ulysse",
          "Ulrich",
          "Urbain",
          "Valentin",
          "Valère",
          "Valéry",
          "Venance",
          "Vianney",
          "Victor",
          "Victorien",
          "Victorin",
          "Vigile",
          "Vincent",
          "Virgile",
          "Vital",
          "Vivien",
          "Waleran",
          "Walfroy",
          "Wandrille",
          "Xavier",
          "Xénophon",
          "Yves",
          "Yoann",
          "Zacharie",
          "Zaché",
          "Zénobe",
          "Zéphirin"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{last_name} #{first_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "M.",
          "Mme",
          "Dr.",
          "Prof.",
          "Me",
          "Ing.",
          "Capt.",
          "Sgt.",
          "Adm.",
          "Cdt.",
          "Lt.",
          "Col.",
          "Gen.",
          "Sr.",
          "Fr.",
          "Rev."
        ],
        "title": {
          "job": [
            "Superviseur",
            "Executif",
            "Manager",
            "Ingenieur",
            "Specialiste",
            "Directeur",
            "Coordinateur",
            "Administrateur",
            "Architecte",
            "Analyste",
            "Designer",
            "Technicien",
            "Developpeur",
            "Producteur",
            "Consultant",
            "Assistant",
            "Agent",
            "Stagiaire"
          ]
        }
      },
      "phone_number": {
        "country_code": [
          "33"
        ],
        "formats": [
          "01########",
          "02########",
          "03########",
          "04########",
          "05########",
          "09########",
          "1########",
          "2########",
          "3########",
          "4########",
          "5########",
          "9########",
          "01 ## ## ## ##",
          "02 ## ## ## ##",
          "03 ## ## ## ##",
          "04 ## ## ## ##",
          "05 ## ## ## ##",
          "09 ## ## ## ##",
          "1 ## ## ## ##",
          "2 ## ## ## ##",
          "3 ## ## ## ##",
          "4 ## ## ## ##",
          "5 ## ## ## ##",
          "9 ## ## ## ##"
        ]
      }
    },
    "hello": "bonjour",
    "helpers": {
      "select": {
        "prompt": "Veuillez sélectionner"
      },
      "submit": {
        "create": "Créer un(e) %{model}",
        "submit": "Enregistrer ce(tte) %{model}",
        "update": "Modifier ce(tte) %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Â": "A",
          "Æ": "Ae",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Î": "I",
          "Ï": "I",
          "Ô": "O",
          "Ù": "U",
          "Û": "U",
          "Ü": "U",
          "à": "a",
          "â": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "î": "i",
          "ï": "i",
          "ô": "o",
          "ù": "u",
          "û": "u",
          "ü": "u",
          "ÿ": "y",
          "Œ": "Oe",
          "œ": "oe",
          "Ÿ": "Y"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %Hh %Mmin %Ss",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d %B %Y à %H:%M"
            }
          }
        },
        "long": "%A %d %B %Y %Hh%M",
        "short": "%d %b %Hh%M"
      },
      "pm": "pm"
    },
    "welcome": "bienvenue"
  },
  "fr-CA": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Date d'envoi de la confirmation",
          "confirmation_token": "Clé de confirmation du mot de passe",
          "confirmed_at": "Confirmé à",
          "created_at": "Enregistré à",
          "current_password": "Mot de passe actuel",
          "current_sign_in_at": "Date de la connexion actuelle",
          "current_sign_in_ip": "IP de la connexion actuelle",
          "email": "Courriel",
          "encrypted_password": "Mot de passe crypté",
          "failed_attempts": "Tentatives échouées",
          "last_sign_in_at": "Date de la dernière connexion",
          "last_sign_in_ip": "IP de la dernière connexion",
          "locked_at": "Verrouillé à",
          "password": "Mot de passe",
          "password_confirmation": "Confirmation du mot de passe",
          "remember_created_at": "Mémorisé à",
          "remember_me": "Se souvenir de moi?",
          "reset_password_sent_at": "Clé de réinitialisation créée à",
          "reset_password_token": "Clé de réinitialisation du mot de passe",
          "sign_in_count": "Nombre des connexions",
          "unconfirmed_email": "Courriel non confirmé",
          "unlock_token": "Clé de déverrouillage",
          "updated_at": "Date de mise à jour"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validation a échoué : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Vous ne pouvez pas supprimer l'enregistrement parce que les %{record} dépendants existent",
            "has_one": "Vous ne pouvez pas supprimer l'enregistrement car un(e) %{record} dépendant(e) existe"
          }
        }
      },
      "models": {
        "user": {
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "fév.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%y-%m-%d"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "environ une heure",
          "other": "environ %{count} heures"
        },
        "about_x_months": {
          "one": "environ un mois",
          "other": "environ %{count} mois"
        },
        "about_x_years": {
          "one": "environ un an",
          "other": "environ %{count} ans"
        },
        "almost_x_years": {
          "one": "presque un an",
          "other": "presque %{count} ans"
        },
        "half_a_minute": "une demi-minute",
        "less_than_x_minutes": {
          "one": "moins d'une minute",
          "other": "moins de %{count} minutes",
          "zero": "moins d'une minute"
        },
        "less_than_x_seconds": {
          "one": "moins d'une seconde",
          "other": "moins de %{count} secondes",
          "zero": "moins d'une seconde"
        },
        "over_x_years": {
          "one": "plus d'un an",
          "other": "plus de %{count} ans"
        },
        "x_days": {
          "one": "%{count} jour",
          "other": "%{count} jours"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} mois",
          "other": "%{count} mois"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} secondes"
        },
        "x_years": {
          "one": "%{count} an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "Jour",
        "hour": "Heure",
        "minute": "Minute",
        "month": "Mois",
        "second": "Seconde",
        "year": "Année"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Votre compte a été confirmé avec succès.",
        "new": {
          "resend_confirmation_instructions": "Renvoyer les instructions de confirmation"
        },
        "send_instructions": "Vous allez recevoir sous quelques minutes un courriel comportant des instructions pour confirmer votre compte.",
        "send_paranoid_instructions": "Si votre courriel existe sur notre base de données, vous recevrez sous quelques minutes un message avec des instructions pour confirmer votre compte."
      },
      "failure": {
        "already_authenticated": "Vous êtes déjà connecté(e).",
        "inactive": "Votre compte n’est pas encore activé.",
        "invalid": "%{authentication_keys} ou mot de passe incorrect.",
        "last_attempt": "Il vous reste une chance avant que votre compte soit bloqué.",
        "locked": "Votre compte est verrouillé.",
        "not_found_in_database": "%{authentication_keys} ou mot de passe incorrect.",
        "timeout": "Votre session est expirée, veuillez vous reconnecter pour continuer.",
        "unauthenticated": "Vous devez vous connecter ou vous enregistrer pour continuer.",
        "unconfirmed": "Vous devez confirmer votre compte par courriel."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmer mon addresse courriel",
          "greeting": "Bienvenue %{recipient} !",
          "instruction": "Vous pouvez confirmer votre addresse courriel grâce au lien ci-dessous :",
          "subject": "Instructions de confirmation"
        },
        "email_changed": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous notifier que votre adresse courriel a été changée en %{email}.",
          "message_unconfirmed": "Nous vous contactons pour vous notifier que votre adresse email est en train d'être changée pour %{email}.",
          "subject": "Addresse courriel modifiée"
        },
        "password_change": {
          "greeting": "Bonjour %{recipient} !",
          "message": "Nous vous contactons pour vous notifier que votre mot de passe a été modifié.",
          "subject": "Mot de passe modifié"
        },
        "reset_password_instructions": {
          "action": "Changer mon mot de passe",
          "greeting": "Bonjour %{recipient} !",
          "instruction": "Quelqu'un a demandé un lien pour changer votre mot de passe, le voici :",
          "instruction_2": "Si vous n'avez pas émis cette demande, merci d'ignorer ce courriel.",
          "instruction_3": "Votre mot de passe ne changera pas tant que vous n'aurez pas cliqué sur ce lien et renseigné un nouveau mot de passe.",
          "subject": "Instructions pour changer le mot de passe"
        },
        "unlock_instructions": {
          "action": "Débloquer mon compte",
          "greeting": "Bonjour %{recipient} !",
          "instruction": "Suivez ce lien pour débloquer votre compte :",
          "message": "Votre compte a été bloqué suite à un nombre d'essais de connexions manquées trop important.",
          "subject": "Instructions pour déverrouiller le compte"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nous ne pouvons pas vous authentifier depuis %{kind} pour la raison suivante : '%{reason}'.",
        "success": "Autorisé avec succès par votre compte %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Changer mon mot de passe",
          "change_your_password": "Changer votre mot de passe",
          "confirm_new_password": "Confirmez votre nouveau mot de passe",
          "new_password": "Nouveau mot de passe"
        },
        "new": {
          "forgot_your_password": "Mot de passe oublié ?",
          "send_me_reset_password_instructions": "Envoyez-moi des instructions pour réinitialiser mon mot de passe"
        },
        "no_token": "Vous ne pouvez pas accéder à cette page si vous n’y accédez pas depuis un courriel de réinitialisation de mot de passe. Si vous venez en effet d’un tel courriel, vérifiez que vous avez copié l’adresse URL en entier.",
        "send_instructions": "Vous allez recevoir sous quelques minutes un courriel vous indiquant comment réinitialiser votre mot de passe.",
        "send_paranoid_instructions": "Si votre courriel existe dans notre base de données, vous recevrez un lien vous permettant de récupérer votre mot de passe.",
        "updated": "Votre mot de passe a été modifié avec succès. Vous êtes maintenant connecté(e).",
        "updated_not_active": "Votre mot de passe a été modifié avec succès."
      },
      "registrations": {
        "destroyed": "Au revoir ! Votre compte a été annulé avec succès. Nous espérons vous revoir bientôt.",
        "edit": {
          "are_you_sure": "Êtes-vous sûr ?",
          "cancel_my_account": "Supprimer mon compte",
          "currently_waiting_confirmation_for_email": "Confirmation en attente pour: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "laissez ce champ vide pour le laisser inchangé",
          "title": "Éditer %{resource}",
          "unhappy": "Pas content ?",
          "update": "Modifier",
          "we_need_your_current_password_to_confirm_your_changes": "nous avons besoin de votre mot de passe actuel pour valider ces modifications"
        },
        "new": {
          "sign_up": "Inscription"
        },
        "signed_up": "Bienvenue ! Vous vous êtes enregistré(e) avec succès.",
        "signed_up_but_inactive": "Vous vous êtes enregistré(e) avec succès. Cependant, nous n’avons pas pu vous connecter car votre compte n’a pas encore été activé.",
        "signed_up_but_locked": "Vous vous êtes enregistré(e) avec succès. Cependant, nous n’avons pas pu vous connecter car votre compte est verrouillé.",
        "signed_up_but_unconfirmed": "Un message avec un lien de confirmation vous a été envoyé par mail. Veuillez suivre ce lien pour activer votre compte.",
        "update_needs_confirmation": "Vous avez modifié votre compte avec succès, mais nous devons vérifier votre nouvelle adresse de courriel. Veuillez consulter vos courriels et cliquer sur le lien de confirmation pour confirmer votre nouvelle adresse.",
        "updated": "Votre compte a été modifié avec succès.",
        "updated_but_not_signed_in": "Votre compte a été mis à jour avec succès. Vous devez vous reconnecter car votre mot de passe a été modifié."
      },
      "sessions": {
        "already_signed_out": "Déconnecté(e).",
        "new": {
          "sign_in": "Connexion"
        },
        "signed_in": "Connecté(e) avec succès.",
        "signed_out": "Déconnecté(e) avec succès."
      },
      "shared": {
        "links": {
          "back": "Retour",
          "didn_t_receive_confirmation_instructions": "Vous n'avez pas reçu le courriel de confirmation ?",
          "didn_t_receive_unlock_instructions": "Vous n'avez pas reçu le courriel de déblocage ?",
          "forgot_your_password": "Mot de passe oublié ?",
          "sign_in": "Connexion",
          "sign_in_with_provider": "Connexion avec %{provider}",
          "sign_up": "Inscription"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Renvoyer les instructions de déblocage"
        },
        "send_instructions": "Vous allez recevoir sous quelques minutes un courriel comportant des instructions pour déverrouiller votre compte.",
        "send_paranoid_instructions": "Si votre courriel existe sur notre base de données, vous recevrez sous quelques minutes un message avec des instructions pour déverrouiller votre compte.",
        "unlocked": "Votre compte a été déverrouillé avec succès. Veuillez vous connecter."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "doit être accepté(e)",
        "already_confirmed": "a déjà été confirmé(e)",
        "blank": "doit être rempli(e)",
        "confirmation": "ne concorde pas avec %{attribute}",
        "confirmation_period_expired": "doit être confirmé(e) en %{period}, veuillez en demander un(e) autre",
        "empty": "doit être rempli(e)",
        "equal_to": "doit être égal à %{count}",
        "even": "doit être pair",
        "exclusion": "n'est pas disponible",
        "expired": "est expiré, veuillez en demander un autre",
        "greater_than": "doit être supérieur à %{count}",
        "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
        "in": "doit être dans l'intervalle %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur à %{count}",
        "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
        "model_invalid": "Validation échouée : %{errors}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un nombre entier",
        "not_found": "n’a pas été trouvé(e)",
        "not_locked": "n’était pas verrouillé(e)",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "doit être impair",
        "other_than": "doit être différent de %{count}",
        "present": "doit être vide",
        "required": "doit exister",
        "taken": "n'est pas disponible",
        "too_long": {
          "one": "est trop long (pas plus d'un caractère)",
          "other": "est trop long (pas plus de %{count} caractères)"
        },
        "too_short": {
          "one": "est trop court (au moins un caractère)",
          "other": "est trop court (au moins %{count} caractères)"
        },
        "wrong_length": {
          "one": "ne fait pas la bonne longueur (doit comporter un seul caractère)",
          "other": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
        }
      },
      "template": {
        "body": "Veuillez vérifier les champs suivants : ",
        "header": {
          "one": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreur",
          "other": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreurs"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##",
          "#"
        ],
        "default_country": [
          "Canada"
        ],
        "default_country_code": [
          "CA"
        ],
        "postcode": "/[A-CEJ-NPR-TVXY][0-9][A-CEJ-NPR-TV-Z] ?[0-9][A-CEJ-NPR-TV-Z][0-9]/",
        "state": [
          "Alberta",
          "Colombie-Britannique",
          "Île-du-Prince-Édouard",
          "Manitoba",
          "Nouveau-Brunswick",
          "Nouvelle-Écosse",
          "Nunavut",
          "Ontario",
          "Terre-Neuve-et-Labrador",
          "Territoires du Nord-Ouest",
          "Québec",
          "Saskatchewan",
          "Yukon"
        ],
        "state_abbr": [
          "AB",
          "BC",
          "MB",
          "NB",
          "NL",
          "NS",
          "NU",
          "NT",
          "ON",
          "PE",
          "QC",
          "SK",
          "YT"
        ],
        "street_address": [
          " #{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_suffix}"
        ],
        "street_prefix": [
          "Allée, Voie",
          "Rue",
          "Avenue",
          "Boulevard",
          "Quai",
          "Passage",
          "Impasse",
          "Place"
        ],
        "street_suffix": [
          "de l'Abbaye",
          "Adolphe Mille",
          "d'Alésia",
          "d'Argenteuil",
          "d'Assas",
          "du Bac",
          "de Paris",
          "La Boétie",
          "Bonaparte",
          "de la Bûcherie",
          "de Caumartin",
          "Charlemagne",
          "du Chat-qui-Pêche",
          "de la Chaussée-d'Antin",
          "du Dahomey",
          "Dauphine",
          "Delesseux",
          "du Faubourg Saint-Honoré",
          "du Faubourg-Saint-Denis",
          "de la Ferronnerie",
          "des Francs-Bourgeois",
          "des Grands Augustins",
          "de la Harpe",
          "du Havre",
          "de la Huchette",
          "Joubert",
          "Laffitte",
          "Lepic",
          "des Lombards",
          "Marcadet",
          "Molière",
          "Monsieur-le-Prince",
          "de Montmorency",
          "Montorgueil",
          "Mouffetard",
          "de Nesle",
          "Oberkampf",
          "de l'Odéon",
          "d'Orsel",
          "de la Paix",
          "des Panoramas",
          "Pastourelle",
          "Pierre Charron",
          "de la Pompe",
          "de Presbourg",
          "de Provence",
          "de Richelieu",
          "de Rivoli",
          "des Rosiers",
          "Royale",
          "d'Abbeville",
          "Saint-Honoré",
          "Saint-Bernard",
          "Saint-Denis",
          "Saint-Dominique",
          "Saint-Jacques",
          "Saint-Séverin",
          "des Saussaies",
          "de Seine",
          "de Solférino",
          "Du Sommerard",
          "de Tilsitt",
          "Vaneau",
          "de Vaugirard",
          "de la Victoire",
          "Zadkine"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "publisher": [
          "Éditions du Soleil",
          "La Perdrix",
          "Les Éditions jaune turquoise",
          "Bordel père et fils",
          "Au lecteur éclairé",
          "Lire en dormant"
        ],
        "quote": [
          "Qui vivra verra",
          "L’habit ne fait pas le moine",
          "Chacun voit midi à sa porte",
          "Mieux vaut prévenir que guérir",
          "Petit a petit, l’oiseau fait son nid",
          "Qui court deux lievres a la fois, n’en prend aucun",
          "Qui n’avance pas, recule"
        ],
        "title": [
          "La Discipline des orphelins",
          "Le Couloir de tous les mépris",
          "L'Odeur du sanglier",
          "La Promise du voyeur",
          "L'Odyssée invisible",
          "La Soumission comme passion",
          "Le Siècle de la rue voisine",
          "Le Désir des femmes fortes",
          "Pourquoi je mens ?",
          "La Peau des savants",
          "La progéniture du mal"
        ]
      },
      "cell_phone": {
        "formats": [
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}"
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name} et #{Name.last_name}"
        ],
        "suffix": [
          "SARL",
          "SA",
          "EURL",
          "SAS",
          "SEM",
          "SCOP",
          "GIE",
          "EI"
        ]
      },
      "games": {
        "pokemon": {
          "locations": [
            "Arabelle",
            "Roche-sur-Gliffe",
            "Flusselles",
            "Rotombourg",
            "Quarellis",
            "Pavonnay",
            "Ecorcia",
            "Ville noire",
            "Ebenelle",
            "Fort-Vanitas",
            "Joliberge",
            "Volucité",
            "Celadopole",
            "Célestia",
            "Azuria",
            "Ville-Griotte",
            "Irisia",
            "Cramois'Île",
            "Port Tempères",
            "Mozheim",
            "Relifac-le-Haut",
            "La Frescale",
            "Myokara",
            "Port Yoneuve",
            "Rosalia",
            "Vestigion",
            "Eternara",
            "Autéquia",
            "Zone de Combat",
            "Île 5",
            "Floraville",
            "Amaillide",
            "Cimetronelle",
            "Île 4",
            "Atrium Combat",
            "Parmanie",
            "Cromlac'h",
            "Doublonville",
            "Unionpolis",
            "Papeloa",
            "Flocombe",
            "Féli-Cité",
            "Batisques",
            "Entrelasque",
            "Vermilava",
            "Lavanville",
            "Romant-sous-Bois",
            "Arpentières",
            "Bourg-en-Vol",
            "Nénucrique",
            "Illumis",
            "Acajou",
            "Lavandia",
            "Parsemille",
            "Algatia",
            "Maillard",
            "Bourg Geon",
            "Méanville",
            "Renouet",
            "Rosyères",
            "Oliville",
            "Île 1",
            "Janusia",
            "Charbourg",
            "Pacifiville",
            "Bourg Palette",
            "Verchamps",
            "Clémenti-Ville",
            "Argenta",
            "Aire de Détente",
            "Mérouville",
            "Portail Safari",
            "Safrania",
            "Littorella",
            "Neuvartault",
            "Ogoesse",
            "Île 7",
            "Yantreizh",
            "Île 6",
            "Poivressel",
            "Auffrac-les-Congères",
            "Frimapic",
            "Bonville",
            "Atalanopolis",
            "Rivamar",
            "Aire de Survie",
            "Île 3",
            "Bonaugure",
            "Île 2",
            "Vaguelone",
            "Bourg Croquis",
            "Voilaroc",
            "Vergazon",
            "Carmin sur Mer",
            "Mauville",
            "Ondes-sur-Mer",
            "Jadielle",
            "Forêt Blanche"
          ],
          "moves": [
            "Vol-Vie",
            "Acide",
            "Acidarmure",
            "Hâte",
            "Amnésie",
            "Onde Boréale",
            "Pilonnage",
            "Bouclier",
            "Patience",
            "Etreinte",
            "Morsure",
            "Blizzard",
            "Plaquage",
            "Massd'Os",
            "Osmerang",
            "Ecume",
            "Bulles d'O",
            "Claquoir",
            "Poing Comète",
            "Onde Folie",
            "Choc Mental",
            "Constriction",
            "Conversion",
            "Riposte",
            "Pince-Masse",
            "Coupe",
            "Boul'Armure",
            "Tunnel",
            "Entrave",
            "Uppercut",
            "Double-Pied",
            "Torgnoles",
            "Reflet",
            "Damoclès",
            "Draco-Rage",
            "Dévorêve",
            "Bec Vrille",
            "Séisme",
            "Bomb'Oeuf",
            "Flammèche",
            "Explosion",
            "Déflagration",
            "Poing de Feu",
            "Danse Flamme",
            "Abîme",
            "Lance-Flamme",
            "Flash",
            "Vol",
            "Puissance",
            "Furie",
            "Combo-Griffe",
            "Regard Médusant",
            "Rugissement",
            "Croissance",
            "Guillotine",
            "Tornade",
            "Armure",
            "Buée Noire",
            "Coup d'Boule",
            "Pied Voltige",
            "Koud'Korne",
            "Empal'Korne",
            "Hydrocanon",
            "Ultralaser",
            "Croc de Mort",
            "Hypnose",
            "Laser Glace",
            "Poing-Glace",
            "Pied Sauté",
            "Poing Karaté",
            "Télékinésie",
            "Vampirisme",
            "Vampigraine",
            "Groz'Yeux",
            "Léchouille",
            "Mur Lumière",
            "Grobisou",
            "Balayage",
            "Yoga",
            "Méga-Sangsue",
            "Ultimawashi",
            "Ultimapoing",
            "Métronome",
            "Copie",
            "Lilliput",
            "Mimique",
            "Brume",
            "Ombre Nocturne",
            "Jackpot",
            "Picpic",
            "Danse-Fleur",
            "Dard-Nuée",
            "Gaz Toxik",
            "Poudre Poison",
            "Dard-Venin",
            "Ecras'Face",
            "Rafale Psy",
            "Psyko",
            "Vague Psy",
            "Vive-Attaque",
            "Frénésie",
            "Tranch'Herbe",
            "Coupe-Vent",
            "Soin",
            "Protection",
            "Repos",
            "Hurlement",
            "Eboulement",
            "Jet-Pierres",
            "Mawashi Geri",
            "Jet de Sable",
            "Griffe",
            "Grincement",
            "Amplitude",
            "Destruction",
            "Affûtage",
            "Berceuse",
            "Coud'Krâne",
            "Piqué",
            "Souplesse",
            "Tranche",
            "Poudre Dodo",
            "Détritus",
            "Purédpois",
            "Brouillard",
            "E-Coque",
            "Lance-Soleil",
            "Sonicboom",
            "Picanon",
            "Trempette",
            "Spore",
            "Ecrasement",
            "Force",
            "Sécrétion",
            "Lutte",
            "Para-Spore",
            "Sacrifice",
            "Clonage",
            "Croc Fatal",
            "Ultrason",
            "Surf",
            "Météores",
            "Danse-Lames",
            "Charge",
            "Mimi-Queue",
            "Bélier",
            "Téléport",
            "Mania",
            "Fatal-Foudre",
            "Poing-Eclair",
            "Eclair",
            "Cage-Eclair",
            "Tonnerre",
            "Toxic",
            "Morphing",
            "Triplattaque",
            "Double-Dard",
            "Force Poigne",
            "Fouet Liane",
            "Pistolet à O",
            "Cascade",
            "Cyclone",
            "Cru-Aile",
            "Repli",
            "Ligotage"
          ],
          "names": [
            "Bulbizarre",
            "Herbizarre",
            "Florizarre",
            "Salamèche",
            "Reptincel",
            "Dracaufeu",
            "Carapuce",
            "Carabaffe",
            "Tortank",
            "Chenipan",
            "Chrysacier",
            "Papilusion",
            "Aspicot",
            "Coconfort",
            "Dardargnan",
            "Roucool",
            "Roucoups",
            "Roucarnage",
            "Rattata",
            "Rattatac",
            "Piafabec",
            "Rapasdepic",
            "Abo",
            "Arbok",
            "Pikachu",
            "Raichu",
            "Sabelette",
            "Sablaireau",
            "Nidoran",
            "Nidorina",
            "Nidoqueen",
            "Nidoran",
            "Nidorino",
            "Nidoking",
            "Mélofée",
            "Mélodelfe",
            "Goupix",
            "Feunard",
            "Rondoudou",
            "Grodoudou",
            "Nosférapti",
            "Nosféralto",
            "Mystherbe",
            "Ortide",
            "Rafflésia",
            "Paras",
            "Parasect",
            "Mimitoss",
            "Aéromite",
            "Taupiqueur",
            "Triopikeur",
            "Miaouss",
            "Persian",
            "Psykokwak",
            "Akwakwak",
            "Férosinge",
            "Colossinge",
            "Canidos",
            "Arcanin",
            "Ptitard",
            "Tétarte",
            "Tartard",
            "Abra",
            "Kadabra",
            "Alakazam",
            "Machoc",
            "Machopeur",
            "Mackogneur",
            "Chétiflor",
            "Boustiflor",
            "Empiflor",
            "Tentacool",
            "Tentacruel",
            "Racaillou",
            "Gravalanche",
            "Grolem",
            "Ponyta",
            "Galopa",
            "Ramoloss",
            "Flagadoss",
            "Magnéti",
            "Magnéton",
            "Canarticho",
            "Doduo",
            "Dodrio",
            "Otaria",
            "Lamantine",
            "Tadmorv",
            "Grotadmorv",
            "Kokyas",
            "Crustabri",
            "Fantominus",
            "Spectrum",
            "Ectoplasma",
            "Onix",
            "Soporifik",
            "Hypnomade",
            "Krabby",
            "Kraboss",
            "Voltorb",
            "Electrode",
            "Noeunoeuf",
            "Noadkoko",
            "Osselait",
            "Ossatueur",
            "Kicklee",
            "Tygnon",
            "Excelangue",
            "Smogo",
            "Smogogo",
            "Rhinocorne",
            "Rhinoféros",
            "Leveinard",
            "Saquedeneu",
            "Kangourex",
            "Hypotrempe",
            "Hypocéan",
            "Poissirène",
            "Poissoroy",
            "Stari",
            "Staross",
            "Mr. Mime",
            "Insécateur",
            "Lippoutou",
            "Elektek",
            "Magmar",
            "Scarabrute",
            "Tauros",
            "Magicarpe",
            "Léviator",
            "Lokhlass",
            "Métamorph",
            "Evoli",
            "Aquali",
            "Voltali",
            "Pyroli",
            "Porygon",
            "Amonita",
            "Amonistar",
            "Kabuto",
            "Kabutops",
            "Ptéra",
            "Ronflex",
            "Artikodin",
            "Electhor",
            "Sulfura",
            "Minidraco",
            "Draco",
            "Dracolosse",
            "Mewtwo",
            "Mew"
          ]
        }
      },
      "internet": {
        "domain_suffix": [
          "ca",
          "com",
          "biz",
          "info",
          "name",
          "net",
          "org"
        ]
      },
      "lorem": {
        "supplemental": [
          "abbas",
          "abduco",
          "abeo",
          "abscido",
          "absconditus",
          "absens",
          "absorbeo",
          "absque",
          "abstergo",
          "absum",
          "abundans",
          "abutor",
          "accedo",
          "accendo",
          "acceptus",
          "accipio",
          "accommodo",
          "accusator",
          "acer",
          "acerbitas",
          "acervus",
          "acidus",
          "acies",
          "acquiro",
          "acsi",
          "adamo",
          "adaugeo",
          "addo",
          "adduco",
          "ademptio",
          "adeo",
          "adeptio",
          "adfectus",
          "adfero",
          "adficio",
          "adflicto",
          "adhaero",
          "adhuc",
          "adicio",
          "adimpleo",
          "adinventitias",
          "adipiscor",
          "adiuvo",
          "administratio",
          "admiratio",
          "admitto",
          "admoneo",
          "admoveo",
          "adnuo",
          "adopto",
          "adsidue",
          "adstringo",
          "adsuesco",
          "adsum",
          "adulatio",
          "adulescens",
          "adultus",
          "aduro",
          "advenio",
          "adversus",
          "advoco",
          "aedificium",
          "aeger",
          "aegre",
          "aegrotatio",
          "aegrus",
          "aeneus",
          "aequitas",
          "aequus",
          "aer",
          "aestas",
          "aestivus",
          "aestus",
          "aetas",
          "aeternus",
          "ager",
          "aggero",
          "aggredior",
          "agnitio",
          "agnosco",
          "ago",
          "ait",
          "aiunt",
          "alienus",
          "alii",
          "alioqui",
          "aliqua",
          "alius",
          "allatus",
          "alo",
          "alter",
          "altus",
          "alveus",
          "amaritudo",
          "ambitus",
          "ambulo",
          "amicitia",
          "amiculum",
          "amissio",
          "amita",
          "amitto",
          "amo",
          "amor",
          "amoveo",
          "amplexus",
          "amplitudo",
          "amplus",
          "ancilla",
          "angelus",
          "angulus",
          "angustus",
          "animadverto",
          "animi",
          "animus",
          "annus",
          "anser",
          "ante",
          "antea",
          "antepono",
          "antiquus",
          "aperio",
          "aperte",
          "apostolus",
          "apparatus",
          "appello",
          "appono",
          "appositus",
          "approbo",
          "apto",
          "aptus",
          "apud",
          "aqua",
          "ara",
          "aranea",
          "arbitro",
          "arbor",
          "arbustum",
          "arca",
          "arceo",
          "arcesso",
          "arcus",
          "argentum",
          "argumentum",
          "arguo",
          "arma",
          "armarium",
          "armo",
          "aro",
          "ars",
          "articulus",
          "artificiose",
          "arto",
          "arx",
          "ascisco",
          "ascit",
          "asper",
          "aspicio",
          "asporto",
          "assentator",
          "astrum",
          "atavus",
          "ater",
          "atqui",
          "atrocitas",
          "atrox",
          "attero",
          "attollo",
          "attonbitus",
          "auctor",
          "auctus",
          "audacia",
          "audax",
          "audentia",
          "audeo",
          "audio",
          "auditor",
          "aufero",
          "aureus",
          "auris",
          "aurum",
          "aut",
          "autem",
          "autus",
          "auxilium",
          "avaritia",
          "avarus",
          "aveho",
          "averto",
          "avoco",
          "baiulus",
          "balbus",
          "barba",
          "bardus",
          "basium",
          "beatus",
          "bellicus",
          "bellum",
          "bene",
          "beneficium",
          "benevolentia",
          "benigne",
          "bestia",
          "bibo",
          "bis",
          "blandior",
          "bonus",
          "bos",
          "brevis",
          "cado",
          "caecus",
          "caelestis",
          "caelum",
          "calamitas",
          "calcar",
          "calco",
          "calculus",
          "callide",
          "campana",
          "candidus",
          "canis",
          "canonicus",
          "canto",
          "capillus",
          "capio",
          "capitulus",
          "capto",
          "caput",
          "carbo",
          "carcer",
          "careo",
          "caries",
          "cariosus",
          "caritas",
          "carmen",
          "carpo",
          "carus",
          "casso",
          "caste",
          "casus",
          "catena",
          "caterva",
          "cattus",
          "cauda",
          "causa",
          "caute",
          "caveo",
          "cavus",
          "cedo",
          "celebrer",
          "celer",
          "celo",
          "cena",
          "cenaculum",
          "ceno",
          "censura",
          "centum",
          "cerno",
          "cernuus",
          "certe",
          "certo",
          "certus",
          "cervus",
          "cetera",
          "charisma",
          "chirographum",
          "cibo",
          "cibus",
          "cicuta",
          "cilicium",
          "cimentarius",
          "ciminatio",
          "cinis",
          "circumvenio",
          "cito",
          "civis",
          "civitas",
          "clam",
          "clamo",
          "claro",
          "clarus",
          "claudeo",
          "claustrum",
          "clementia",
          "clibanus",
          "coadunatio",
          "coaegresco",
          "coepi",
          "coerceo",
          "cogito",
          "cognatus",
          "cognomen",
          "cogo",
          "cohaero",
          "cohibeo",
          "cohors",
          "colligo",
          "colloco",
          "collum",
          "colo",
          "color",
          "coma",
          "combibo",
          "comburo",
          "comedo",
          "comes",
          "cometes",
          "comis",
          "comitatus",
          "commemoro",
          "comminor",
          "commodo",
          "communis",
          "comparo",
          "compello",
          "complectus",
          "compono",
          "comprehendo",
          "comptus",
          "conatus",
          "concedo",
          "concido",
          "conculco",
          "condico",
          "conduco",
          "confero",
          "confido",
          "conforto",
          "confugo",
          "congregatio",
          "conicio",
          "coniecto",
          "conitor",
          "coniuratio",
          "conor",
          "conqueror",
          "conscendo",
          "conservo",
          "considero",
          "conspergo",
          "constans",
          "consuasor",
          "contabesco",
          "contego",
          "contigo",
          "contra",
          "conturbo",
          "conventus",
          "convoco",
          "copia",
          "copiose",
          "cornu",
          "corona",
          "corpus",
          "correptius",
          "corrigo",
          "corroboro",
          "corrumpo",
          "coruscus",
          "cotidie",
          "crapula",
          "cras",
          "crastinus",
          "creator",
          "creber",
          "crebro",
          "credo",
          "creo",
          "creptio",
          "crepusculum",
          "cresco",
          "creta",
          "cribro",
          "crinis",
          "cruciamentum",
          "crudelis",
          "cruentus",
          "crur",
          "crustulum",
          "crux",
          "cubicularis",
          "cubitum",
          "cubo",
          "cui",
          "cuius",
          "culpa",
          "culpo",
          "cultellus",
          "cultura",
          "cum",
          "cunabula",
          "cunae",
          "cunctatio",
          "cupiditas",
          "cupio",
          "cuppedia",
          "cupressus",
          "cur",
          "cura",
          "curatio",
          "curia",
          "curiositas",
          "curis",
          "curo",
          "curriculum",
          "currus",
          "cursim",
          "curso",
          "cursus",
          "curto",
          "curtus",
          "curvo",
          "curvus",
          "custodia",
          "damnatio",
          "damno",
          "dapifer",
          "debeo",
          "debilito",
          "decens",
          "decerno",
          "decet",
          "decimus",
          "decipio",
          "decor",
          "decretum",
          "decumbo",
          "dedecor",
          "dedico",
          "deduco",
          "defaeco",
          "defendo",
          "defero",
          "defessus",
          "defetiscor",
          "deficio",
          "defigo",
          "defleo",
          "defluo",
          "defungo",
          "degenero",
          "degero",
          "degusto",
          "deinde",
          "delectatio",
          "delego",
          "deleo",
          "delibero",
          "delicate",
          "delinquo",
          "deludo",
          "demens",
          "demergo",
          "demitto",
          "demo",
          "demonstro",
          "demoror",
          "demulceo",
          "demum",
          "denego",
          "denique",
          "dens",
          "denuncio",
          "denuo",
          "deorsum",
          "depereo",
          "depono",
          "depopulo",
          "deporto",
          "depraedor",
          "deprecator",
          "deprimo",
          "depromo",
          "depulso",
          "deputo",
          "derelinquo",
          "derideo",
          "deripio",
          "desidero",
          "desino",
          "desipio",
          "desolo",
          "desparatus",
          "despecto",
          "despirmatio",
          "infit",
          "inflammatio",
          "paens",
          "patior",
          "patria",
          "patrocinor",
          "patruus",
          "pauci",
          "paulatim",
          "pauper",
          "pax",
          "peccatus",
          "pecco",
          "pecto",
          "pectus",
          "pecunia",
          "pecus",
          "peior",
          "pel",
          "ocer",
          "socius",
          "sodalitas",
          "sol",
          "soleo",
          "solio",
          "solitudo",
          "solium",
          "sollers",
          "sollicito",
          "solum",
          "solus",
          "solutio",
          "solvo",
          "somniculosus",
          "somnus",
          "sonitus",
          "sono",
          "sophismata",
          "sopor",
          "sordeo",
          "sortitus",
          "spargo",
          "speciosus",
          "spectaculum",
          "speculum",
          "sperno",
          "spero",
          "spes",
          "spiculum",
          "spiritus",
          "spoliatio",
          "sponte",
          "stabilis",
          "statim",
          "statua",
          "stella",
          "stillicidium",
          "stipes",
          "stips",
          "sto",
          "strenuus",
          "strues",
          "studio",
          "stultus",
          "suadeo",
          "suasoria",
          "sub",
          "subito",
          "subiungo",
          "sublime",
          "subnecto",
          "subseco",
          "substantia",
          "subvenio",
          "succedo",
          "succurro",
          "sufficio",
          "suffoco",
          "suffragium",
          "suggero",
          "sui",
          "sulum",
          "sum",
          "summa",
          "summisse",
          "summopere",
          "sumo",
          "sumptus",
          "supellex",
          "super",
          "suppellex",
          "supplanto",
          "suppono",
          "supra",
          "surculus",
          "surgo",
          "sursum",
          "suscipio",
          "suspendo",
          "sustineo",
          "suus",
          "synagoga",
          "tabella",
          "tabernus",
          "tabesco",
          "tabgo",
          "tabula",
          "taceo",
          "tactus",
          "taedium",
          "talio",
          "talis",
          "talus",
          "tam",
          "tamdiu",
          "tamen",
          "tametsi",
          "tamisium",
          "tamquam",
          "tandem",
          "tantillus",
          "tantum",
          "tardus",
          "tego",
          "temeritas",
          "temperantia",
          "templum",
          "temptatio",
          "tempus",
          "tenax",
          "tendo",
          "teneo",
          "tener",
          "tenuis",
          "tenus",
          "tepesco",
          "tepidus",
          "ter",
          "terebro",
          "teres",
          "terga",
          "tergeo",
          "tergiversatio",
          "tergo",
          "tergum",
          "termes",
          "terminatio",
          "tero",
          "terra",
          "terreo",
          "territo",
          "terror",
          "tersus",
          "tertius",
          "testimonium",
          "texo",
          "textilis",
          "textor",
          "textus",
          "thalassinus",
          "theatrum",
          "theca",
          "thema",
          "theologus",
          "thermae",
          "thesaurus",
          "thesis",
          "thorax",
          "thymbra",
          "thymum",
          "tibi",
          "timidus",
          "timor",
          "titulus",
          "tolero",
          "tollo",
          "tondeo",
          "tonsor",
          "torqueo",
          "torrens",
          "tot",
          "totidem",
          "toties",
          "totus",
          "tracto",
          "trado",
          "traho",
          "trans",
          "tredecim",
          "tremo",
          "trepide",
          "tres",
          "tribuo",
          "tricesimus",
          "triduana",
          "triginta",
          "tripudio",
          "tristis",
          "triumphus",
          "trucido",
          "truculenter",
          "tubineus",
          "tui",
          "tum",
          "tumultus",
          "tunc",
          "turba",
          "turbo",
          "turpe",
          "turpis",
          "tutamen",
          "tutis",
          "tyrannus",
          "uberrime",
          "ubi",
          "ulciscor",
          "ullus",
          "ulterius",
          "ultio",
          "ultra",
          "umbra",
          "umerus",
          "umquam",
          "una",
          "unde",
          "undique",
          "universe",
          "unus",
          "urbanus",
          "urbs",
          "uredo",
          "usitas",
          "usque",
          "ustilo",
          "ustulo",
          "usus",
          "uter",
          "uterque",
          "utilis",
          "utique",
          "utor",
          "utpote",
          "utrimque",
          "utroque",
          "utrum",
          "uxor",
          "vaco",
          "vacuus",
          "vado",
          "vae",
          "valde",
          "valens",
          "valeo",
          "valetudo",
          "validus",
          "vallum",
          "vapulus",
          "varietas",
          "varius",
          "vehemens",
          "vel",
          "velociter",
          "velum",
          "velut",
          "venia",
          "venio",
          "ventito",
          "ventosus",
          "ventus",
          "venustas",
          "ver",
          "verbera",
          "verbum",
          "vere",
          "verecundia",
          "vereor",
          "vergo",
          "veritas",
          "vero",
          "versus",
          "verto",
          "verumtamen",
          "verus",
          "vesco",
          "vesica",
          "vesper",
          "vespillo",
          "vester",
          "vestigium",
          "vestrum",
          "vetus",
          "via",
          "vicinus",
          "vicissitudo",
          "victoria",
          "victus",
          "videlicet",
          "video",
          "viduata",
          "viduo",
          "vigilo",
          "vigor",
          "vilicus",
          "vilis",
          "vilitas",
          "villa",
          "vinco",
          "vinculum",
          "vindico",
          "vinitor",
          "vinum",
          "vir",
          "virga",
          "virgo",
          "viridis",
          "viriliter",
          "virtus",
          "vis",
          "viscus",
          "vita",
          "vitiosus",
          "vitium",
          "vito",
          "vivo",
          "vix",
          "vobis",
          "vociferor",
          "voco",
          "volaticus",
          "volo",
          "volubilis",
          "voluntarius",
          "volup",
          "volutabrum",
          "volva",
          "vomer",
          "vomica",
          "vomito",
          "vorago",
          "vorax",
          "voro",
          "vos",
          "votum",
          "voveo",
          "vox",
          "vulariter",
          "vulgaris",
          "vulgivagus",
          "vulgo",
          "vulgus",
          "vulnero",
          "vulnus",
          "vulpes",
          "vulticulus",
          "vultuosus",
          "xiphias"
        ],
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "name": {
        "first_name": [
          "Enzo",
          "Lucas",
          "Mathis",
          "Nathan",
          "Thomas",
          "Hugo",
          "Théo",
          "Tom",
          "Louis",
          "Raphaël",
          "Clément",
          "Léo",
          "Mathéo",
          "Maxime",
          "Alexandre",
          "Antoine",
          "Yanis",
          "Paul",
          "Baptiste",
          "Alexis",
          "Gabriel",
          "Arthur",
          "Jules",
          "Ethan",
          "Noah",
          "Quentin",
          "Axel",
          "Evan",
          "Mattéo",
          "Romain",
          "Valentin",
          "Maxence",
          "Noa",
          "Adam",
          "Nicolas",
          "Julien",
          "Mael",
          "Pierre",
          "Rayan",
          "Victor",
          "Mohamed",
          "Adrien",
          "Kylian",
          "Sacha",
          "Benjamin",
          "Léa",
          "Clara",
          "Manon",
          "Chloé",
          "Camille",
          "Ines",
          "Sarah",
          "Jade",
          "Lola",
          "Anaïs",
          "Lucie",
          "Océane",
          "Lilou",
          "Marie",
          "Eva",
          "Romane",
          "Lisa",
          "Zoe",
          "Julie",
          "Mathilde",
          "Louise",
          "Juliette",
          "Clémence",
          "Célia",
          "Laura",
          "Lena",
          "Maëlys",
          "Charlotte",
          "Ambre",
          "Maeva",
          "Pauline",
          "Lina",
          "Jeanne",
          "Lou",
          "Noémie",
          "Justine",
          "Louna",
          "Elisa",
          "Alice",
          "Emilie",
          "Carla",
          "Maëlle",
          "Alicia",
          "Mélissa"
        ],
        "last_name": [
          "Martin",
          "Bérnard",
          "Dubois",
          "Thomas",
          "Robért",
          "Richard",
          "Pétit",
          "Durand",
          "Léroy",
          "Moréau",
          "Simon",
          "Laurént",
          "Lefévre",
          "Michél",
          "Garcia",
          "David",
          "Bértrand",
          "Roux",
          "Vincent",
          "Fourniér",
          "Morél",
          "Girard",
          "André",
          "Lévêque",
          "Merciér",
          "Dupont",
          "Lambért",
          "Bonnét",
          "Francois",
          "Martinéz",
          "Légrand",
          "Garniér",
          "Fauré",
          "Rousséau",
          "Blanc",
          "Guérin",
          "Mullér",
          "Hénry",
          "Roussél",
          "Nicolas",
          "Pérrin",
          "Morin",
          "Mathiéu",
          "Clemént",
          "Gauthiér",
          "Dumont",
          "Lopéz",
          "Fontainé",
          "Chevaliér",
          "Robin",
          "Masson",
          "Sanchéz",
          "Gérard",
          "Nguyén",
          "Boyér",
          "Dvnis",
          "Lemairé",
          "Duval",
          "Joly",
          "Gautiér",
          "Rogér",
          "Roché",
          "Roy",
          "Noél",
          "Meyér",
          "Lucas",
          "Méunier",
          "Jéan",
          "Peréz",
          "Marchand",
          "Dufour",
          "Blanchard",
          "Marié",
          "Barbiér",
          "Brun",
          "Dumas",
          "Brunét",
          "Schmitt",
          "Leroux",
          "Colin",
          "Fernandéz",
          "Piérre",
          "Rénard",
          "Arnaud",
          "Rolland",
          "Caron",
          "Aubért",
          "Giraud",
          "Leclérc",
          "Vidal",
          "Bourgéois",
          "Renaud",
          "Lemoiné",
          "Picard",
          "Gaillard",
          "Philippé",
          "Leclércq",
          "Lacroix",
          "Fabré",
          "Dupuis",
          "Oliviér",
          "Rodriguéz",
          "Da silva",
          "Hubért",
          "Louis",
          "Charlés",
          "Guillot",
          "Rivieré",
          "Le gall",
          "Guillaume",
          "Adam",
          "Rey",
          "Moulin",
          "Gonzaléz",
          "Bergér",
          "Lecomté",
          "Ménard",
          "Fléury",
          "Déschamps",
          "Carpéntier",
          "Julién",
          "Bénoit",
          "Paris",
          "Maillard",
          "Marchal",
          "Aubry",
          "Vasséur",
          "Le roux",
          "Rénault",
          "Jacquét",
          "Collét",
          "Prévost",
          "Poiriér",
          "Charpéntier",
          "Royér",
          "Huét",
          "Baron",
          "Dupuy",
          "Pons",
          "Paul",
          "Lainé",
          "Carré",
          "Bréton",
          "Rémy",
          "Schneidér",
          "Pérrot",
          "Guyot",
          "Barré",
          "Marty",
          "Cousin"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{last_name} #{first_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "M",
          "Mme",
          "Mlle",
          "Dr",
          "Prof"
        ],
        "title": {
          "job": [
            "Superviseur",
            "Executif",
            "Manager",
            "Ingenieur",
            "Specialiste",
            "Directeur",
            "Coordinateur",
            "Administrateur",
            "Architecte",
            "Analyste",
            "Designer",
            "Technicien",
            "Developpeur",
            "Producteur",
            "Consultant",
            "Assistant",
            "Agent",
            "Stagiaire"
          ]
        }
      },
      "phone_number": {
        "area_code": [
          "204",
          "226",
          "236",
          "249",
          "250",
          "289",
          "306",
          "343",
          "365",
          "403",
          "416",
          "418",
          "431",
          "437",
          "438",
          "450",
          "506",
          "514",
          "519",
          "579",
          "581",
          "587",
          "604",
          "613",
          "639",
          "647",
          "705",
          "709",
          "778",
          "780",
          "807",
          "819",
          "867",
          "873",
          "902",
          "905"
        ],
        "country_code": [
          "1"
        ],
        "exchange_code": [
          "201",
          "202",
          "203",
          "205",
          "206",
          "207",
          "208",
          "209",
          "210",
          "212",
          "213",
          "214",
          "215",
          "216",
          "217",
          "218",
          "219",
          "224",
          "225",
          "227",
          "228",
          "229",
          "231",
          "234",
          "239",
          "240",
          "248",
          "251",
          "252",
          "253",
          "254",
          "256",
          "260",
          "262",
          "267",
          "269",
          "270",
          "276",
          "281",
          "283",
          "301",
          "302",
          "303",
          "304",
          "305",
          "307",
          "308",
          "309",
          "310",
          "312",
          "313",
          "314",
          "315",
          "316",
          "317",
          "318",
          "319",
          "320",
          "321",
          "323",
          "330",
          "331",
          "334",
          "336",
          "337",
          "339",
          "347",
          "351",
          "352",
          "360",
          "361",
          "386",
          "401",
          "402",
          "404",
          "405",
          "406",
          "407",
          "408",
          "409",
          "410",
          "412",
          "413",
          "414",
          "415",
          "417",
          "419",
          "423",
          "424",
          "425",
          "434",
          "435",
          "440",
          "443",
          "445",
          "464",
          "469",
          "470",
          "475",
          "478",
          "479",
          "480",
          "484",
          "501",
          "502",
          "503",
          "504",
          "505",
          "507",
          "508",
          "509",
          "510",
          "512",
          "513",
          "515",
          "516",
          "517",
          "518",
          "520",
          "530",
          "540",
          "541",
          "551",
          "557",
          "559",
          "561",
          "562",
          "563",
          "564",
          "567",
          "570",
          "571",
          "573",
          "574",
          "580",
          "585",
          "586",
          "601",
          "602",
          "603",
          "605",
          "606",
          "607",
          "608",
          "609",
          "610",
          "612",
          "614",
          "615",
          "616",
          "617",
          "618",
          "619",
          "620",
          "623",
          "626",
          "630",
          "631",
          "636",
          "641",
          "646",
          "650",
          "651",
          "660",
          "661",
          "662",
          "667",
          "678",
          "682",
          "701",
          "702",
          "703",
          "704",
          "706",
          "707",
          "708",
          "712",
          "713",
          "714",
          "715",
          "716",
          "717",
          "718",
          "719",
          "720",
          "724",
          "727",
          "731",
          "732",
          "734",
          "737",
          "740",
          "754",
          "757",
          "760",
          "763",
          "765",
          "770",
          "772",
          "773",
          "774",
          "775",
          "781",
          "785",
          "786",
          "801",
          "802",
          "803",
          "804",
          "805",
          "806",
          "808",
          "810",
          "812",
          "813",
          "814",
          "815",
          "816",
          "817",
          "818",
          "828",
          "830",
          "831",
          "832",
          "835",
          "843",
          "845",
          "847",
          "848",
          "850",
          "856",
          "857",
          "858",
          "859",
          "860",
          "862",
          "863",
          "864",
          "865",
          "870",
          "872",
          "878",
          "901",
          "903",
          "904",
          "906",
          "907",
          "908",
          "909",
          "910",
          "912",
          "913",
          "914",
          "915",
          "916",
          "917",
          "918",
          "919",
          "920",
          "925",
          "928",
          "931",
          "936",
          "937",
          "940",
          "941",
          "947",
          "949",
          "952",
          "954",
          "956",
          "959",
          "970",
          "971",
          "972",
          "973",
          "975",
          "978",
          "979",
          "980",
          "984",
          "985",
          "989"
        ],
        "extension": [
          "####"
        ],
        "formats": [
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "(#{PhoneNumber.area_code}) #{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}-#{PhoneNumber.exchange_code}-#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}",
          "#{PhoneNumber.area_code}.#{PhoneNumber.exchange_code}.#{PhoneNumber.subscriber_number} x#{PhoneNumber.extension}"
        ],
        "subscriber_number": [
          "####"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Veuillez sélectionner"
      },
      "submit": {
        "create": "Créer un(e) %{model}",
        "submit": "Enregistrer ce(tte) %{model}",
        "update": "Modifier ce(tte) %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %H h %M min %S s",
        "long": "%A %d %B %Y %H h %M",
        "short": "%d %b %H h %M"
      },
      "pm": "pm"
    }
  },
  "fr-CH": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validation a échoué : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Vous ne pouvez pas supprimer l'enregistrement parce que les %{record} dépendants existent",
            "has_one": "Vous ne pouvez pas supprimer l'enregistrement car un(e) %{record} dépendant(e) existe"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "fév.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "environ une heure",
          "other": "environ %{count} heures"
        },
        "about_x_months": {
          "one": "environ un mois",
          "other": "environ %{count} mois"
        },
        "about_x_years": {
          "one": "environ un an",
          "other": "environ %{count} ans"
        },
        "almost_x_years": {
          "one": "presque un an",
          "other": "presque %{count} ans"
        },
        "half_a_minute": "une demi-minute",
        "less_than_x_minutes": {
          "one": "moins d'une minute",
          "other": "moins de %{count} minutes",
          "zero": "moins d'une minute"
        },
        "less_than_x_seconds": {
          "one": "moins d'une seconde",
          "other": "moins de %{count} secondes",
          "zero": "moins d'une seconde"
        },
        "over_x_years": {
          "one": "plus d'un an",
          "other": "plus de %{count} ans"
        },
        "x_days": {
          "one": "%{count} jour",
          "other": "%{count} jours"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} mois",
          "other": "%{count} mois"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} secondes"
        },
        "x_years": {
          "one": "%{count} an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "Jour",
        "hour": "Heure",
        "minute": "Minute",
        "month": "Mois",
        "second": "Seconde",
        "year": "Année"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "doit être accepté(e)",
        "blank": "doit être rempli(e)",
        "confirmation": "ne concorde pas avec %{attribute}",
        "empty": "doit être rempli(e)",
        "equal_to": "doit être égal à %{count}",
        "even": "doit être pair",
        "exclusion": "n'est pas disponible",
        "greater_than": "doit être supérieur à %{count}",
        "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
        "in": "doit être dans l'intervalle %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur à %{count}",
        "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
        "model_invalid": "Validation échouée : %{errors}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un nombre entier",
        "odd": "doit être impair",
        "other_than": "doit être différent de %{count}",
        "present": "doit être vide",
        "required": "doit exister",
        "taken": "n'est pas disponible",
        "too_long": {
          "one": "est trop long (pas plus d'un caractère)",
          "other": "est trop long (pas plus de %{count} caractères)"
        },
        "too_short": {
          "one": "est trop court (au moins un caractère)",
          "other": "est trop court (au moins %{count} caractères)"
        },
        "wrong_length": {
          "one": "ne fait pas la bonne longueur (doit comporter un seul caractère)",
          "other": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
        }
      },
      "template": {
        "body": "Veuillez vérifier les champs suivants : ",
        "header": {
          "one": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreur",
          "other": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreurs"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Zürich",
          "Bern",
          "Luzern",
          "Schwyz",
          "Obwalden",
          "Nidwalden",
          "Glarus",
          "Zug",
          "Freiburg",
          "Solothurn",
          "Basel-Stadt",
          "Basel-Landschaft",
          "Schaffhausen",
          "Appenzell Ausserrhoden",
          "Appenzell Innerrhoden",
          "St. Gallen",
          "Graubünden, Grischun, Grigioni",
          "Aargau",
          "Thurgau",
          "Ticino",
          "Waadt",
          "Wallis",
          "Neuenburg",
          "Genf"
        ],
        "default_country": [
          "Suisse"
        ],
        "default_country_code": [
          "CH"
        ],
        "postcode": [
          "1###",
          "2###",
          "3###",
          "4###",
          "5###",
          "6###",
          "7###",
          "8###",
          "9###"
        ],
        "secondary_address": [
          "Apt. ###",
          "# étage"
        ],
        "state": [
          "Zürich",
          "Bern",
          "Luzern",
          "Uri",
          "Schwyz",
          "Obwalden",
          "Nidwalden",
          "Glarus",
          "Zug",
          "Fribourg",
          "Solothurn",
          "Basel",
          "Basel",
          "Schaffhausen",
          "Appenzell",
          "Appenzell",
          "St",
          "Graubünden",
          "Aargau",
          "Thurgau",
          "Ticino",
          "Vaud",
          "Valais",
          "Neuchâtel",
          "Geneva",
          "Jura"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_prefix} #{street_suffix}"
        ],
        "street_prefix": [
          "Allée, Voie",
          "Rue",
          "Avenue",
          "Boulevard",
          "Quai",
          "Passage",
          "Impasse",
          "Place"
        ],
        "street_suffix": [
          "du 1er-Juin",
          "du 31- Décembre",
          "Firmin-ABAUZIT",
          "AGASSE",
          "des Allobroges",
          "des Alpes",
          "Jean-Charles-AMAT",
          "Roi-Victor-AMÉ",
          "Henri-Frédéric-AMIEL",
          "des Amis",
          "de l'Ancien-Lavoir",
          "de l'Ancien-Port",
          "Ancienne",
          "d'Aoste",
          "ARGAND",
          "des Arpenteurs",
          "de l'Arquebuse",
          "de l'Aspergière",
          "des Asters",
          "des Ateliers",
          "de l'Athénée",
          "de l'Aubépine",
          "Dr-Georges-AUDÉOUD",
          "des Avanchis",
          "de l'Avenir",
          "du Bachet",
          "de la Baillive",
          "des Bains",
          "de Bâle",
          "Jacques-BALMAT",
          "de Bandol",
          "Otto-BARBLAN",
          "des Barques",
          "Maurice-BARRAUD",
          "des Barrières",
          "Jean-François-BARTHOLONI",
          "BARTON",
          "des Battoirs",
          "BAUDIT",
          "BAULACRE",
          "BAUTTE",
          "BAYLON",
          "Beau-Site",
          "de Beaulieu",
          "Beauregard",
          "François-BELLOT",
          "du Belvédère",
          "Bémont"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "publisher": [
          "Éditions du Soleil",
          "La Perdrix",
          "Les Éditions jaune turquoise",
          "Bordel père et fils",
          "Au lecteur éclairé",
          "Lire en dormant"
        ],
        "quote": [
          "Qui vivra verra",
          "L’habit ne fait pas le moine",
          "Chacun voit midi à sa porte",
          "Mieux vaut prévenir que guérir",
          "Petit a petit, l’oiseau fait son nid",
          "Qui court deux lievres a la fois, n’en prend aucun",
          "Qui n’avance pas, recule"
        ],
        "title": [
          "La Discipline des orphelins",
          "Le Couloir de tous les mépris",
          "L'Odeur du sanglier",
          "La Promise du voyeur",
          "L'Odyssée invisible",
          "La Soumission comme passion",
          "Le Siècle de la rue voisine",
          "Le Désir des femmes fortes",
          "Pourquoi je mens ?",
          "La Peau des savants",
          "La progéniture du mal"
        ]
      },
      "cell_phone": {
        "formats": [
          "#####.######"
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} et #{Name.last_name}"
        ],
        "suffix": [
          "AG",
          "GmbH",
          "et associés",
          "& Co.",
          "Groupe",
          "LLC",
          "Inc."
        ]
      },
      "games": {
        "pokemon": {
          "locations": [
            "Arabelle",
            "Roche-sur-Gliffe",
            "Flusselles",
            "Rotombourg",
            "Quarellis",
            "Pavonnay",
            "Ecorcia",
            "Ville noire",
            "Ebenelle",
            "Fort-Vanitas",
            "Joliberge",
            "Volucité",
            "Celadopole",
            "Célestia",
            "Azuria",
            "Ville-Griotte",
            "Irisia",
            "Cramois'Île",
            "Port Tempères",
            "Mozheim",
            "Relifac-le-Haut",
            "La Frescale",
            "Myokara",
            "Port Yoneuve",
            "Rosalia",
            "Vestigion",
            "Eternara",
            "Autéquia",
            "Zone de Combat",
            "Île 5",
            "Floraville",
            "Amaillide",
            "Cimetronelle",
            "Île 4",
            "Atrium Combat",
            "Parmanie",
            "Cromlac'h",
            "Doublonville",
            "Unionpolis",
            "Papeloa",
            "Flocombe",
            "Féli-Cité",
            "Batisques",
            "Entrelasque",
            "Vermilava",
            "Lavanville",
            "Romant-sous-Bois",
            "Arpentières",
            "Bourg-en-Vol",
            "Nénucrique",
            "Illumis",
            "Acajou",
            "Lavandia",
            "Parsemille",
            "Algatia",
            "Maillard",
            "Bourg Geon",
            "Méanville",
            "Renouet",
            "Rosyères",
            "Oliville",
            "Île 1",
            "Janusia",
            "Charbourg",
            "Pacifiville",
            "Bourg Palette",
            "Verchamps",
            "Clémenti-Ville",
            "Argenta",
            "Aire de Détente",
            "Mérouville",
            "Portail Safari",
            "Safrania",
            "Littorella",
            "Neuvartault",
            "Ogoesse",
            "Île 7",
            "Yantreizh",
            "Île 6",
            "Poivressel",
            "Auffrac-les-Congères",
            "Frimapic",
            "Bonville",
            "Atalanopolis",
            "Rivamar",
            "Aire de Survie",
            "Île 3",
            "Bonaugure",
            "Île 2",
            "Vaguelone",
            "Bourg Croquis",
            "Voilaroc",
            "Vergazon",
            "Carmin sur Mer",
            "Mauville",
            "Ondes-sur-Mer",
            "Jadielle",
            "Forêt Blanche"
          ],
          "moves": [
            "Vol-Vie",
            "Acide",
            "Acidarmure",
            "Hâte",
            "Amnésie",
            "Onde Boréale",
            "Pilonnage",
            "Bouclier",
            "Patience",
            "Etreinte",
            "Morsure",
            "Blizzard",
            "Plaquage",
            "Massd'Os",
            "Osmerang",
            "Ecume",
            "Bulles d'O",
            "Claquoir",
            "Poing Comète",
            "Onde Folie",
            "Choc Mental",
            "Constriction",
            "Conversion",
            "Riposte",
            "Pince-Masse",
            "Coupe",
            "Boul'Armure",
            "Tunnel",
            "Entrave",
            "Uppercut",
            "Double-Pied",
            "Torgnoles",
            "Reflet",
            "Damoclès",
            "Draco-Rage",
            "Dévorêve",
            "Bec Vrille",
            "Séisme",
            "Bomb'Oeuf",
            "Flammèche",
            "Explosion",
            "Déflagration",
            "Poing de Feu",
            "Danse Flamme",
            "Abîme",
            "Lance-Flamme",
            "Flash",
            "Vol",
            "Puissance",
            "Furie",
            "Combo-Griffe",
            "Regard Médusant",
            "Rugissement",
            "Croissance",
            "Guillotine",
            "Tornade",
            "Armure",
            "Buée Noire",
            "Coup d'Boule",
            "Pied Voltige",
            "Koud'Korne",
            "Empal'Korne",
            "Hydrocanon",
            "Ultralaser",
            "Croc de Mort",
            "Hypnose",
            "Laser Glace",
            "Poing-Glace",
            "Pied Sauté",
            "Poing Karaté",
            "Télékinésie",
            "Vampirisme",
            "Vampigraine",
            "Groz'Yeux",
            "Léchouille",
            "Mur Lumière",
            "Grobisou",
            "Balayage",
            "Yoga",
            "Méga-Sangsue",
            "Ultimawashi",
            "Ultimapoing",
            "Métronome",
            "Copie",
            "Lilliput",
            "Mimique",
            "Brume",
            "Ombre Nocturne",
            "Jackpot",
            "Picpic",
            "Danse-Fleur",
            "Dard-Nuée",
            "Gaz Toxik",
            "Poudre Poison",
            "Dard-Venin",
            "Ecras'Face",
            "Rafale Psy",
            "Psyko",
            "Vague Psy",
            "Vive-Attaque",
            "Frénésie",
            "Tranch'Herbe",
            "Coupe-Vent",
            "Soin",
            "Protection",
            "Repos",
            "Hurlement",
            "Eboulement",
            "Jet-Pierres",
            "Mawashi Geri",
            "Jet de Sable",
            "Griffe",
            "Grincement",
            "Amplitude",
            "Destruction",
            "Affûtage",
            "Berceuse",
            "Coud'Krâne",
            "Piqué",
            "Souplesse",
            "Tranche",
            "Poudre Dodo",
            "Détritus",
            "Purédpois",
            "Brouillard",
            "E-Coque",
            "Lance-Soleil",
            "Sonicboom",
            "Picanon",
            "Trempette",
            "Spore",
            "Ecrasement",
            "Force",
            "Sécrétion",
            "Lutte",
            "Para-Spore",
            "Sacrifice",
            "Clonage",
            "Croc Fatal",
            "Ultrason",
            "Surf",
            "Météores",
            "Danse-Lames",
            "Charge",
            "Mimi-Queue",
            "Bélier",
            "Téléport",
            "Mania",
            "Fatal-Foudre",
            "Poing-Eclair",
            "Eclair",
            "Cage-Eclair",
            "Tonnerre",
            "Toxic",
            "Morphing",
            "Triplattaque",
            "Double-Dard",
            "Force Poigne",
            "Fouet Liane",
            "Pistolet à O",
            "Cascade",
            "Cyclone",
            "Cru-Aile",
            "Repli",
            "Ligotage"
          ],
          "names": [
            "Bulbizarre",
            "Herbizarre",
            "Florizarre",
            "Salamèche",
            "Reptincel",
            "Dracaufeu",
            "Carapuce",
            "Carabaffe",
            "Tortank",
            "Chenipan",
            "Chrysacier",
            "Papilusion",
            "Aspicot",
            "Coconfort",
            "Dardargnan",
            "Roucool",
            "Roucoups",
            "Roucarnage",
            "Rattata",
            "Rattatac",
            "Piafabec",
            "Rapasdepic",
            "Abo",
            "Arbok",
            "Pikachu",
            "Raichu",
            "Sabelette",
            "Sablaireau",
            "Nidoran",
            "Nidorina",
            "Nidoqueen",
            "Nidoran",
            "Nidorino",
            "Nidoking",
            "Mélofée",
            "Mélodelfe",
            "Goupix",
            "Feunard",
            "Rondoudou",
            "Grodoudou",
            "Nosférapti",
            "Nosféralto",
            "Mystherbe",
            "Ortide",
            "Rafflésia",
            "Paras",
            "Parasect",
            "Mimitoss",
            "Aéromite",
            "Taupiqueur",
            "Triopikeur",
            "Miaouss",
            "Persian",
            "Psykokwak",
            "Akwakwak",
            "Férosinge",
            "Colossinge",
            "Canidos",
            "Arcanin",
            "Ptitard",
            "Tétarte",
            "Tartard",
            "Abra",
            "Kadabra",
            "Alakazam",
            "Machoc",
            "Machopeur",
            "Mackogneur",
            "Chétiflor",
            "Boustiflor",
            "Empiflor",
            "Tentacool",
            "Tentacruel",
            "Racaillou",
            "Gravalanche",
            "Grolem",
            "Ponyta",
            "Galopa",
            "Ramoloss",
            "Flagadoss",
            "Magnéti",
            "Magnéton",
            "Canarticho",
            "Doduo",
            "Dodrio",
            "Otaria",
            "Lamantine",
            "Tadmorv",
            "Grotadmorv",
            "Kokyas",
            "Crustabri",
            "Fantominus",
            "Spectrum",
            "Ectoplasma",
            "Onix",
            "Soporifik",
            "Hypnomade",
            "Krabby",
            "Kraboss",
            "Voltorb",
            "Electrode",
            "Noeunoeuf",
            "Noadkoko",
            "Osselait",
            "Ossatueur",
            "Kicklee",
            "Tygnon",
            "Excelangue",
            "Smogo",
            "Smogogo",
            "Rhinocorne",
            "Rhinoféros",
            "Leveinard",
            "Saquedeneu",
            "Kangourex",
            "Hypotrempe",
            "Hypocéan",
            "Poissirène",
            "Poissoroy",
            "Stari",
            "Staross",
            "Mr. Mime",
            "Insécateur",
            "Lippoutou",
            "Elektek",
            "Magmar",
            "Scarabrute",
            "Tauros",
            "Magicarpe",
            "Léviator",
            "Lokhlass",
            "Métamorph",
            "Evoli",
            "Aquali",
            "Voltali",
            "Pyroli",
            "Porygon",
            "Amonita",
            "Amonistar",
            "Kabuto",
            "Kabutops",
            "Ptéra",
            "Ronflex",
            "Artikodin",
            "Electhor",
            "Sulfura",
            "Minidraco",
            "Draco",
            "Dracolosse",
            "Mewtwo",
            "Mew"
          ]
        }
      },
      "internet": {
        "domain_suffix": [
          "com",
          "net",
          "biz",
          "ch",
          "li",
          "at",
          "ch",
          "ch"
        ]
      },
      "lorem": {
        "supplemental": [
          "abbas",
          "abduco",
          "abeo",
          "abscido",
          "absconditus",
          "absens",
          "absorbeo",
          "absque",
          "abstergo",
          "absum",
          "abundans",
          "abutor",
          "accedo",
          "accendo",
          "acceptus",
          "accipio",
          "accommodo",
          "accusator",
          "acer",
          "acerbitas",
          "acervus",
          "acidus",
          "acies",
          "acquiro",
          "acsi",
          "adamo",
          "adaugeo",
          "addo",
          "adduco",
          "ademptio",
          "adeo",
          "adeptio",
          "adfectus",
          "adfero",
          "adficio",
          "adflicto",
          "adhaero",
          "adhuc",
          "adicio",
          "adimpleo",
          "adinventitias",
          "adipiscor",
          "adiuvo",
          "administratio",
          "admiratio",
          "admitto",
          "admoneo",
          "admoveo",
          "adnuo",
          "adopto",
          "adsidue",
          "adstringo",
          "adsuesco",
          "adsum",
          "adulatio",
          "adulescens",
          "adultus",
          "aduro",
          "advenio",
          "adversus",
          "advoco",
          "aedificium",
          "aeger",
          "aegre",
          "aegrotatio",
          "aegrus",
          "aeneus",
          "aequitas",
          "aequus",
          "aer",
          "aestas",
          "aestivus",
          "aestus",
          "aetas",
          "aeternus",
          "ager",
          "aggero",
          "aggredior",
          "agnitio",
          "agnosco",
          "ago",
          "ait",
          "aiunt",
          "alienus",
          "alii",
          "alioqui",
          "aliqua",
          "alius",
          "allatus",
          "alo",
          "alter",
          "altus",
          "alveus",
          "amaritudo",
          "ambitus",
          "ambulo",
          "amicitia",
          "amiculum",
          "amissio",
          "amita",
          "amitto",
          "amo",
          "amor",
          "amoveo",
          "amplexus",
          "amplitudo",
          "amplus",
          "ancilla",
          "angelus",
          "angulus",
          "angustus",
          "animadverto",
          "animi",
          "animus",
          "annus",
          "anser",
          "ante",
          "antea",
          "antepono",
          "antiquus",
          "aperio",
          "aperte",
          "apostolus",
          "apparatus",
          "appello",
          "appono",
          "appositus",
          "approbo",
          "apto",
          "aptus",
          "apud",
          "aqua",
          "ara",
          "aranea",
          "arbitro",
          "arbor",
          "arbustum",
          "arca",
          "arceo",
          "arcesso",
          "arcus",
          "argentum",
          "argumentum",
          "arguo",
          "arma",
          "armarium",
          "armo",
          "aro",
          "ars",
          "articulus",
          "artificiose",
          "arto",
          "arx",
          "ascisco",
          "ascit",
          "asper",
          "aspicio",
          "asporto",
          "assentator",
          "astrum",
          "atavus",
          "ater",
          "atqui",
          "atrocitas",
          "atrox",
          "attero",
          "attollo",
          "attonbitus",
          "auctor",
          "auctus",
          "audacia",
          "audax",
          "audentia",
          "audeo",
          "audio",
          "auditor",
          "aufero",
          "aureus",
          "auris",
          "aurum",
          "aut",
          "autem",
          "autus",
          "auxilium",
          "avaritia",
          "avarus",
          "aveho",
          "averto",
          "avoco",
          "baiulus",
          "balbus",
          "barba",
          "bardus",
          "basium",
          "beatus",
          "bellicus",
          "bellum",
          "bene",
          "beneficium",
          "benevolentia",
          "benigne",
          "bestia",
          "bibo",
          "bis",
          "blandior",
          "bonus",
          "bos",
          "brevis",
          "cado",
          "caecus",
          "caelestis",
          "caelum",
          "calamitas",
          "calcar",
          "calco",
          "calculus",
          "callide",
          "campana",
          "candidus",
          "canis",
          "canonicus",
          "canto",
          "capillus",
          "capio",
          "capitulus",
          "capto",
          "caput",
          "carbo",
          "carcer",
          "careo",
          "caries",
          "cariosus",
          "caritas",
          "carmen",
          "carpo",
          "carus",
          "casso",
          "caste",
          "casus",
          "catena",
          "caterva",
          "cattus",
          "cauda",
          "causa",
          "caute",
          "caveo",
          "cavus",
          "cedo",
          "celebrer",
          "celer",
          "celo",
          "cena",
          "cenaculum",
          "ceno",
          "censura",
          "centum",
          "cerno",
          "cernuus",
          "certe",
          "certo",
          "certus",
          "cervus",
          "cetera",
          "charisma",
          "chirographum",
          "cibo",
          "cibus",
          "cicuta",
          "cilicium",
          "cimentarius",
          "ciminatio",
          "cinis",
          "circumvenio",
          "cito",
          "civis",
          "civitas",
          "clam",
          "clamo",
          "claro",
          "clarus",
          "claudeo",
          "claustrum",
          "clementia",
          "clibanus",
          "coadunatio",
          "coaegresco",
          "coepi",
          "coerceo",
          "cogito",
          "cognatus",
          "cognomen",
          "cogo",
          "cohaero",
          "cohibeo",
          "cohors",
          "colligo",
          "colloco",
          "collum",
          "colo",
          "color",
          "coma",
          "combibo",
          "comburo",
          "comedo",
          "comes",
          "cometes",
          "comis",
          "comitatus",
          "commemoro",
          "comminor",
          "commodo",
          "communis",
          "comparo",
          "compello",
          "complectus",
          "compono",
          "comprehendo",
          "comptus",
          "conatus",
          "concedo",
          "concido",
          "conculco",
          "condico",
          "conduco",
          "confero",
          "confido",
          "conforto",
          "confugo",
          "congregatio",
          "conicio",
          "coniecto",
          "conitor",
          "coniuratio",
          "conor",
          "conqueror",
          "conscendo",
          "conservo",
          "considero",
          "conspergo",
          "constans",
          "consuasor",
          "contabesco",
          "contego",
          "contigo",
          "contra",
          "conturbo",
          "conventus",
          "convoco",
          "copia",
          "copiose",
          "cornu",
          "corona",
          "corpus",
          "correptius",
          "corrigo",
          "corroboro",
          "corrumpo",
          "coruscus",
          "cotidie",
          "crapula",
          "cras",
          "crastinus",
          "creator",
          "creber",
          "crebro",
          "credo",
          "creo",
          "creptio",
          "crepusculum",
          "cresco",
          "creta",
          "cribro",
          "crinis",
          "cruciamentum",
          "crudelis",
          "cruentus",
          "crur",
          "crustulum",
          "crux",
          "cubicularis",
          "cubitum",
          "cubo",
          "cui",
          "cuius",
          "culpa",
          "culpo",
          "cultellus",
          "cultura",
          "cum",
          "cunabula",
          "cunae",
          "cunctatio",
          "cupiditas",
          "cupio",
          "cuppedia",
          "cupressus",
          "cur",
          "cura",
          "curatio",
          "curia",
          "curiositas",
          "curis",
          "curo",
          "curriculum",
          "currus",
          "cursim",
          "curso",
          "cursus",
          "curto",
          "curtus",
          "curvo",
          "curvus",
          "custodia",
          "damnatio",
          "damno",
          "dapifer",
          "debeo",
          "debilito",
          "decens",
          "decerno",
          "decet",
          "decimus",
          "decipio",
          "decor",
          "decretum",
          "decumbo",
          "dedecor",
          "dedico",
          "deduco",
          "defaeco",
          "defendo",
          "defero",
          "defessus",
          "defetiscor",
          "deficio",
          "defigo",
          "defleo",
          "defluo",
          "defungo",
          "degenero",
          "degero",
          "degusto",
          "deinde",
          "delectatio",
          "delego",
          "deleo",
          "delibero",
          "delicate",
          "delinquo",
          "deludo",
          "demens",
          "demergo",
          "demitto",
          "demo",
          "demonstro",
          "demoror",
          "demulceo",
          "demum",
          "denego",
          "denique",
          "dens",
          "denuncio",
          "denuo",
          "deorsum",
          "depereo",
          "depono",
          "depopulo",
          "deporto",
          "depraedor",
          "deprecator",
          "deprimo",
          "depromo",
          "depulso",
          "deputo",
          "derelinquo",
          "derideo",
          "deripio",
          "desidero",
          "desino",
          "desipio",
          "desolo",
          "desparatus",
          "despecto",
          "despirmatio",
          "infit",
          "inflammatio",
          "paens",
          "patior",
          "patria",
          "patrocinor",
          "patruus",
          "pauci",
          "paulatim",
          "pauper",
          "pax",
          "peccatus",
          "pecco",
          "pecto",
          "pectus",
          "pecunia",
          "pecus",
          "peior",
          "pel",
          "ocer",
          "socius",
          "sodalitas",
          "sol",
          "soleo",
          "solio",
          "solitudo",
          "solium",
          "sollers",
          "sollicito",
          "solum",
          "solus",
          "solutio",
          "solvo",
          "somniculosus",
          "somnus",
          "sonitus",
          "sono",
          "sophismata",
          "sopor",
          "sordeo",
          "sortitus",
          "spargo",
          "speciosus",
          "spectaculum",
          "speculum",
          "sperno",
          "spero",
          "spes",
          "spiculum",
          "spiritus",
          "spoliatio",
          "sponte",
          "stabilis",
          "statim",
          "statua",
          "stella",
          "stillicidium",
          "stipes",
          "stips",
          "sto",
          "strenuus",
          "strues",
          "studio",
          "stultus",
          "suadeo",
          "suasoria",
          "sub",
          "subito",
          "subiungo",
          "sublime",
          "subnecto",
          "subseco",
          "substantia",
          "subvenio",
          "succedo",
          "succurro",
          "sufficio",
          "suffoco",
          "suffragium",
          "suggero",
          "sui",
          "sulum",
          "sum",
          "summa",
          "summisse",
          "summopere",
          "sumo",
          "sumptus",
          "supellex",
          "super",
          "suppellex",
          "supplanto",
          "suppono",
          "supra",
          "surculus",
          "surgo",
          "sursum",
          "suscipio",
          "suspendo",
          "sustineo",
          "suus",
          "synagoga",
          "tabella",
          "tabernus",
          "tabesco",
          "tabgo",
          "tabula",
          "taceo",
          "tactus",
          "taedium",
          "talio",
          "talis",
          "talus",
          "tam",
          "tamdiu",
          "tamen",
          "tametsi",
          "tamisium",
          "tamquam",
          "tandem",
          "tantillus",
          "tantum",
          "tardus",
          "tego",
          "temeritas",
          "temperantia",
          "templum",
          "temptatio",
          "tempus",
          "tenax",
          "tendo",
          "teneo",
          "tener",
          "tenuis",
          "tenus",
          "tepesco",
          "tepidus",
          "ter",
          "terebro",
          "teres",
          "terga",
          "tergeo",
          "tergiversatio",
          "tergo",
          "tergum",
          "termes",
          "terminatio",
          "tero",
          "terra",
          "terreo",
          "territo",
          "terror",
          "tersus",
          "tertius",
          "testimonium",
          "texo",
          "textilis",
          "textor",
          "textus",
          "thalassinus",
          "theatrum",
          "theca",
          "thema",
          "theologus",
          "thermae",
          "thesaurus",
          "thesis",
          "thorax",
          "thymbra",
          "thymum",
          "tibi",
          "timidus",
          "timor",
          "titulus",
          "tolero",
          "tollo",
          "tondeo",
          "tonsor",
          "torqueo",
          "torrens",
          "tot",
          "totidem",
          "toties",
          "totus",
          "tracto",
          "trado",
          "traho",
          "trans",
          "tredecim",
          "tremo",
          "trepide",
          "tres",
          "tribuo",
          "tricesimus",
          "triduana",
          "triginta",
          "tripudio",
          "tristis",
          "triumphus",
          "trucido",
          "truculenter",
          "tubineus",
          "tui",
          "tum",
          "tumultus",
          "tunc",
          "turba",
          "turbo",
          "turpe",
          "turpis",
          "tutamen",
          "tutis",
          "tyrannus",
          "uberrime",
          "ubi",
          "ulciscor",
          "ullus",
          "ulterius",
          "ultio",
          "ultra",
          "umbra",
          "umerus",
          "umquam",
          "una",
          "unde",
          "undique",
          "universe",
          "unus",
          "urbanus",
          "urbs",
          "uredo",
          "usitas",
          "usque",
          "ustilo",
          "ustulo",
          "usus",
          "uter",
          "uterque",
          "utilis",
          "utique",
          "utor",
          "utpote",
          "utrimque",
          "utroque",
          "utrum",
          "uxor",
          "vaco",
          "vacuus",
          "vado",
          "vae",
          "valde",
          "valens",
          "valeo",
          "valetudo",
          "validus",
          "vallum",
          "vapulus",
          "varietas",
          "varius",
          "vehemens",
          "vel",
          "velociter",
          "velum",
          "velut",
          "venia",
          "venio",
          "ventito",
          "ventosus",
          "ventus",
          "venustas",
          "ver",
          "verbera",
          "verbum",
          "vere",
          "verecundia",
          "vereor",
          "vergo",
          "veritas",
          "vero",
          "versus",
          "verto",
          "verumtamen",
          "verus",
          "vesco",
          "vesica",
          "vesper",
          "vespillo",
          "vester",
          "vestigium",
          "vestrum",
          "vetus",
          "via",
          "vicinus",
          "vicissitudo",
          "victoria",
          "victus",
          "videlicet",
          "video",
          "viduata",
          "viduo",
          "vigilo",
          "vigor",
          "vilicus",
          "vilis",
          "vilitas",
          "villa",
          "vinco",
          "vinculum",
          "vindico",
          "vinitor",
          "vinum",
          "vir",
          "virga",
          "virgo",
          "viridis",
          "viriliter",
          "virtus",
          "vis",
          "viscus",
          "vita",
          "vitiosus",
          "vitium",
          "vito",
          "vivo",
          "vix",
          "vobis",
          "vociferor",
          "voco",
          "volaticus",
          "volo",
          "volubilis",
          "voluntarius",
          "volup",
          "volutabrum",
          "volva",
          "vomer",
          "vomica",
          "vomito",
          "vorago",
          "vorax",
          "voro",
          "vos",
          "votum",
          "voveo",
          "vox",
          "vulariter",
          "vulgaris",
          "vulgivagus",
          "vulgo",
          "vulgus",
          "vulnero",
          "vulnus",
          "vulpes",
          "vulticulus",
          "vultuosus",
          "xiphias"
        ],
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "name": {
        "first_name": [
          "Enzo",
          "Lucas",
          "Mathis",
          "Nathan",
          "Thomas",
          "Hugo",
          "Théo",
          "Tom",
          "Louis",
          "Raphaël",
          "Clément",
          "Léo",
          "Mathéo",
          "Maxime",
          "Alexandre",
          "Antoine",
          "Yanis",
          "Paul",
          "Baptiste",
          "Alexis",
          "Gabriel",
          "Arthur",
          "Jules",
          "Ethan",
          "Noah",
          "Quentin",
          "Axel",
          "Evan",
          "Mattéo",
          "Romain",
          "Valentin",
          "Maxence",
          "Noa",
          "Adam",
          "Nicolas",
          "Julien",
          "Mael",
          "Pierre",
          "Rayan",
          "Victor",
          "Mohamed",
          "Adrien",
          "Kylian",
          "Sacha",
          "Benjamin",
          "Léa",
          "Clara",
          "Manon",
          "Chloé",
          "Camille",
          "Ines",
          "Sarah",
          "Jade",
          "Lola",
          "Anaïs",
          "Lucie",
          "Océane",
          "Lilou",
          "Marie",
          "Eva",
          "Romane",
          "Lisa",
          "Zoe",
          "Julie",
          "Mathilde",
          "Louise",
          "Juliette",
          "Clémence",
          "Célia",
          "Laura",
          "Lena",
          "Maëlys",
          "Charlotte",
          "Ambre",
          "Maeva",
          "Pauline",
          "Lina",
          "Jeanne",
          "Lou",
          "Noémie",
          "Justine",
          "Louna",
          "Elisa",
          "Alice",
          "Emilie",
          "Carla",
          "Maëlle",
          "Alicia",
          "Mélissa"
        ],
        "last_name": [
          "Martin",
          "Bérnard",
          "Dubois",
          "Thomas",
          "Robért",
          "Richard",
          "Pétit",
          "Durand",
          "Léroy",
          "Moréau",
          "Simon",
          "Laurént",
          "Lefévre",
          "Michél",
          "Garcia",
          "David",
          "Bértrand",
          "Roux",
          "Vincent",
          "Fourniér",
          "Morél",
          "Girard",
          "André",
          "Lévêque",
          "Merciér",
          "Dupont",
          "Lambért",
          "Bonnét",
          "Francois",
          "Martinéz",
          "Légrand",
          "Garniér",
          "Fauré",
          "Rousséau",
          "Blanc",
          "Guérin",
          "Mullér",
          "Hénry",
          "Roussél",
          "Nicolas",
          "Pérrin",
          "Morin",
          "Mathiéu",
          "Clemént",
          "Gauthiér",
          "Dumont",
          "Lopéz",
          "Fontainé",
          "Chevaliér",
          "Robin",
          "Masson",
          "Sanchéz",
          "Gérard",
          "Nguyén",
          "Boyér",
          "Dvnis",
          "Lemairé",
          "Duval",
          "Joly",
          "Gautiér",
          "Rogér",
          "Roché",
          "Roy",
          "Noél",
          "Meyér",
          "Lucas",
          "Méunier",
          "Jéan",
          "Peréz",
          "Marchand",
          "Dufour",
          "Blanchard",
          "Marié",
          "Barbiér",
          "Brun",
          "Dumas",
          "Brunét",
          "Schmitt",
          "Leroux",
          "Colin",
          "Fernandéz",
          "Piérre",
          "Rénard",
          "Arnaud",
          "Rolland",
          "Caron",
          "Aubért",
          "Giraud",
          "Leclérc",
          "Vidal",
          "Bourgéois",
          "Renaud",
          "Lemoiné",
          "Picard",
          "Gaillard",
          "Philippé",
          "Leclércq",
          "Lacroix",
          "Fabré",
          "Dupuis",
          "Oliviér",
          "Rodriguéz",
          "Da silva",
          "Hubért",
          "Louis",
          "Charlés",
          "Guillot",
          "Rivieré",
          "Le gall",
          "Guillaume",
          "Adam",
          "Rey",
          "Moulin",
          "Gonzaléz",
          "Bergér",
          "Lecomté",
          "Ménard",
          "Fléury",
          "Déschamps",
          "Carpéntier",
          "Julién",
          "Bénoit",
          "Maillard",
          "Marchal",
          "Aubry",
          "Vasséur",
          "Le roux",
          "Rénault",
          "Jacquét",
          "Collét",
          "Prévost",
          "Poiriér",
          "Charpéntier",
          "Royér",
          "Huét",
          "Baron",
          "Dupuy",
          "Pons",
          "Paul",
          "Lainé",
          "Carré",
          "Bréton",
          "Rémy",
          "Schneidér",
          "Pérrot",
          "Guyot",
          "Barré",
          "Marty",
          "Cousin"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{last_name} #{first_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "M",
          "Mme",
          "Mlle",
          "Dr",
          "Prof"
        ],
        "title": {
          "job": [
            "Superviseur",
            "Executif",
            "Manager",
            "Ingenieur",
            "Specialiste",
            "Directeur",
            "Coordinateur",
            "Administrateur",
            "Architecte",
            "Analyste",
            "Designer",
            "Technicien",
            "Developpeur",
            "Producteur",
            "Consultant",
            "Assistant",
            "Agent",
            "Stagiaire"
          ]
        }
      },
      "phone_number": {
        "formats": [
          "02########",
          "03########",
          "04########",
          "05########",
          "09########",
          "1########",
          "2########",
          "3########",
          "4########",
          "5########",
          "9########",
          "01 ## ## ## ##",
          "02 ## ## ## ##",
          "03 ## ## ## ##",
          "04 ## ## ## ##",
          "05 ## ## ## ##",
          "09 ## ## ## ##",
          "1 ## ## ## ##",
          "2 ## ## ## ##",
          "3 ## ## ## ##",
          "4 ## ## ## ##",
          "5 ## ## ## ##",
          "9 ## ## ## ##"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Veuillez sélectionner"
      },
      "submit": {
        "create": "Créer un(e) %{model}",
        "submit": "Enregistrer ce(tte) %{model}",
        "update": "Modifier ce(tte) %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": "'",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "sFr."
        }
      },
      "format": {
        "delimiter": "'",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d. %B %Y %H h %M",
        "long": "%A, %d %B %Y %H h %M min %S s %Z",
        "short": "%d %b %H h %M"
      },
      "pm": "pm"
    }
  },
  "fr-FR": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validation a échoué : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Vous ne pouvez pas supprimer l'enregistrement parce que les %{record} dépendants existent",
            "has_one": "Vous ne pouvez pas supprimer l'enregistrement car un(e) %{record} dépendant(e) existe"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "fév.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "environ une heure",
          "other": "environ %{count} heures"
        },
        "about_x_months": {
          "one": "environ un mois",
          "other": "environ %{count} mois"
        },
        "about_x_years": {
          "one": "environ un an",
          "other": "environ %{count} ans"
        },
        "almost_x_years": {
          "one": "presque un an",
          "other": "presque %{count} ans"
        },
        "half_a_minute": "une demi-minute",
        "less_than_x_minutes": {
          "one": "moins d'une minute",
          "other": "moins de %{count} minutes",
          "zero": "moins d'une minute"
        },
        "less_than_x_seconds": {
          "one": "moins d'une seconde",
          "other": "moins de %{count} secondes",
          "zero": "moins d'une seconde"
        },
        "over_x_years": {
          "one": "plus d'un an",
          "other": "plus de %{count} ans"
        },
        "x_days": {
          "one": "%{count} jour",
          "other": "%{count} jours"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} mois",
          "other": "%{count} mois"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} secondes"
        },
        "x_years": {
          "one": "%{count} an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "Jour",
        "hour": "Heure",
        "minute": "Minute",
        "month": "Mois",
        "second": "Seconde",
        "year": "Année"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "doit être accepté(e)",
        "blank": "doit être rempli(e)",
        "confirmation": "ne concorde pas avec %{attribute}",
        "empty": "doit être rempli(e)",
        "equal_to": "doit être égal à %{count}",
        "even": "doit être pair",
        "exclusion": "n'est pas disponible",
        "greater_than": "doit être supérieur à %{count}",
        "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
        "in": "doit être dans l'intervalle %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur à %{count}",
        "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
        "model_invalid": "Validation échouée : %{errors}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un nombre entier",
        "odd": "doit être impair",
        "other_than": "doit être différent de %{count}",
        "present": "doit être vide",
        "required": "doit exister",
        "taken": "n'est pas disponible",
        "too_long": {
          "one": "est trop long (pas plus d'un caractère)",
          "other": "est trop long (pas plus de %{count} caractères)"
        },
        "too_short": {
          "one": "est trop court (au moins un caractère)",
          "other": "est trop court (au moins %{count} caractères)"
        },
        "wrong_length": {
          "one": "ne fait pas la bonne longueur (doit comporter un seul caractère)",
          "other": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
        }
      },
      "template": {
        "body": "Veuillez vérifier les champs suivants : ",
        "header": {
          "one": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreur",
          "other": "Impossible d'enregistrer ce(tte) %{model} : %{count} erreurs"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Veuillez sélectionner"
      },
      "submit": {
        "create": "Créer un(e) %{model}",
        "submit": "Enregistrer ce(tte) %{model}",
        "update": "Modifier ce(tte) %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %Hh %Mmin %Ss",
        "long": "%A %d %B %Y %Hh%M",
        "short": "%d %b %Hh%M"
      },
      "pm": "pm"
    }
  },
  "fy": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Falidaasje mislearre: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kin de registraasje net wiskje om't der %{record} ôfhinklik binne",
            "has_one": "Kin de registraasje net wiskje om't der in %{record} ôfhinklik is"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "si",
        "mo",
        "ti",
        "wo",
        "to",
        "fr",
        "so"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mrt",
        "apr",
        "mai",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "des"
      ],
      "day_names": [
        "snein",
        "moandei",
        "tiisdei",
        "woansdei",
        "tongersdei",
        "freed",
        "sneon"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "jannewaris",
        "febrewaris",
        "maart",
        "april",
        "maaie",
        "juny",
        "july",
        "augustus",
        "septimber",
        "oktober",
        "novimber",
        "desimber"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "likernôch 1 oere",
          "other": "likernôch %{count} oeren"
        },
        "about_x_months": {
          "one": "likernôch 1 moanne",
          "other": "likernôch %{count} moannen"
        },
        "about_x_years": {
          "one": "likernôch 1 jier",
          "other": "likernôch %{count} jier"
        },
        "almost_x_years": {
          "one": "hast 1 jier",
          "other": "hast %{count} jier"
        },
        "half_a_minute": "in heale minút",
        "less_than_x_minutes": {
          "one": "minder as in minút",
          "other": "minder as %{count} minuten"
        },
        "less_than_x_seconds": {
          "one": "minder as 1 sekonde",
          "other": "minder as %{count} sekonden"
        },
        "over_x_years": {
          "one": "mear as 1 jier",
          "other": "mear as %{count} jier"
        },
        "x_days": {
          "one": "1 dei",
          "other": "%{count} dagen"
        },
        "x_minutes": {
          "one": "1 minút",
          "other": "%{count} minuten"
        },
        "x_months": {
          "one": "1 moanne",
          "other": "%{count} moannen"
        },
        "x_seconds": {
          "one": "1 sekonde",
          "other": "%{count} sekonden"
        },
        "x_years": {
          "one": "1 jier",
          "other": "%{count} jier"
        }
      },
      "prompts": {
        "day": "dei",
        "hour": "oere",
        "minute": "minút",
        "month": "moanne",
        "second": "sekonde",
        "year": "jier"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "moat akseptearre wurde",
        "blank": "kin net blanko wêze",
        "confirmation": "komt net oerien mei %{attribute}",
        "empty": "kin net leech wêze",
        "equal_to": "moat lyk wêze oan %{count}",
        "even": "moat even wêze",
        "exclusion": "is reservearre",
        "greater_than": "moat grutter wêze as %{count}",
        "greater_than_or_equal_to": "moat grutter wêze as, of lyk oan %{count}",
        "inclusion": "stiet net yn 'e list",
        "invalid": "is ûnjildich",
        "less_than": "moat lytser wêze as %{count}",
        "less_than_or_equal_to": "moat lytser wêze as, of lyk oan %{count}",
        "model_invalid": "Falidaasje mislearre: %{errors}",
        "not_a_number": "is gjin getal",
        "not_an_integer": "moat in hiel getal wêze",
        "odd": "moat ûneven wêze",
        "other_than": "moat oars wêze as %{count}",
        "present": "moat blanko wêze",
        "required": "moat der wêze",
        "taken": "is al ynnommen",
        "too_long": {
          "one": "is te lang (maksimum is 1 teken)",
          "other": "is te lang (maksimum is %{count} tekens)"
        },
        "too_short": {
          "one": "is te koart (minimum is 1 teken)",
          "other": "is te koart (minimum is %{count} tekens)"
        },
        "wrong_length": {
          "one": "hat de ferkearde lingte (moat 1 teken wêze)",
          "other": "hat de ferkearde lingte (moat %{count} tekens wêze)"
        }
      },
      "template": {
        "body": "Der binne problemen mei de neikommende fjilden:",
        "header": {
          "one": "1 flater behinderet it fêstlizzen fan %{model}",
          "other": "%{count} flaters behinderje it fêstlizzen fan %{model}"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Meitsje in kar"
      },
      "submit": {
        "create": "%{model} oanmeitsje",
        "submit": "%{model} fêstlizze",
        "update": "%{model} bywurkje"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u %n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miljard",
            "million": "miljoen",
            "quadrillion": "biljard",
            "thousand": "tûzen",
            "trillion": "biljoen",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "byte",
              "other": "bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " en ",
        "two_words_connector": " en ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "fm.",
      "formats": {
        "default": "%a %e %b %Y %H.%M:%S %z",
        "long": "%e %B %Y om %H.%M oere",
        "short": "%e %b, %H.%M o."
      },
      "pm": "nm."
    }
  },
  "gd": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Dh’fhàillig leis an dearbhadh: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cha b’ urrainn dhuinn an reacord a sguabadh às on a tha %{record} ann a tha an eisimeil air",
            "has_one": "Cha b’ urrainn dhuinn an reacord a sguabadh às on a tha %{record} ann a tha an eisimeil air"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "DiD",
        "DiL",
        "DiM",
        "DiC",
        "Dia",
        "Dih",
        "DiS"
      ],
      "abbr_month_names": [
        null,
        "Faoi",
        "Gearr",
        "Màrt",
        "Gibl",
        "Cèit",
        "Ògmh",
        "Iuch",
        "Lùna",
        "Sult",
        "Dàmh",
        "Samh",
        "Dùbh"
      ],
      "day_names": [
        "DiDòmhnaich",
        "DiLuain",
        "DiMàirt",
        "DiCiadain",
        "DiarDaoin",
        "DihAoine",
        "DiSathairne"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Am Faoilleach",
        "An Gearran",
        "Am Màrt",
        "An Giblean",
        "An Cèitean",
        "An t-Ògmhios",
        "An t-Iuchar",
        "An Lùnastal",
        "An t-Sultain",
        "An Dàmhair",
        "An t-Samhain",
        "An Dùbhlachd"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "mu %{count} uairean a thìde",
          "one": "mu %{count} uair a thìde",
          "other": "mu %{count} uair a thìde",
          "two": "mu %{count} uair a thìde"
        },
        "about_x_months": {
          "few": "mu %{count} mìosan",
          "one": "mu %{count} mhìos",
          "other": "mu %{count} mìos",
          "two": "mu %{count} mhìos"
        },
        "about_x_years": {
          "few": "mu %{count} bliadhnaichean",
          "one": "mu %{count} bhliadhna",
          "other": "mu %{count} bliadhna",
          "two": "mu %{count} bhliadhna"
        },
        "almost_x_years": {
          "few": "cha mhòr %{count} bliadhnaichean",
          "one": "cha mhòr %{count} bhliadhna",
          "other": "cha mhòr %{count} bliadhna",
          "two": "cha mhòr %{count} bhliadhna"
        },
        "half_a_minute": "leth-mhionaid",
        "less_than_x_minutes": {
          "few": "nas lugha na %{count} mionaidean",
          "one": "nas lugha na mionaid",
          "other": "nas lugha na %{count} mionaid",
          "two": "nas lugha na %{count} mhionaid"
        },
        "less_than_x_seconds": {
          "few": "nas lugha na %{count} diogan",
          "one": "nas lugha na %{count} diog",
          "other": "nas lugha na %{count} diog",
          "two": "nas lugha na %{count} dhiog"
        },
        "over_x_years": {
          "few": "còrr is %{count} bliadhnaichean",
          "one": "còrr is %{count} bhliadhna",
          "other": "còrr is %{count} bliadhna",
          "two": "còrr is %{count} bhliadhna"
        },
        "x_days": {
          "few": "%{count} làithean",
          "one": "%{count} latha",
          "other": "%{count} latha",
          "two": "%{count} latha"
        },
        "x_minutes": {
          "few": "%{count} mionaidean",
          "one": "%{count} mhionaid",
          "other": "%{count} mionaid",
          "two": "%{count} mhionaid"
        },
        "x_months": {
          "few": "%{count} mìosan",
          "one": "%{count} mhìos",
          "other": "%{count} mìos",
          "two": "%{count} mhìos"
        },
        "x_seconds": {
          "few": "%{count} diogan",
          "one": "%{count} diog",
          "other": "%{count} diog",
          "two": "%{count} dhiog"
        },
        "x_years": {
          "few": "%{count} bliadhnaichean",
          "one": "%{count} bhliadhna",
          "other": "%{count} bliadhna",
          "two": "%{count} bhliadhna"
        }
      },
      "prompts": {
        "day": "Latha",
        "hour": "Uair a thìde",
        "minute": "Mionaid",
        "month": "Mìos",
        "second": "Diog",
        "year": "Bliadhna"
      }
    },
    "errors": {
      "format": "%{attribute}: %{message}",
      "messages": {
        "accepted": "feumach air aontachadh",
        "blank": "chan fhaod seo a bhith bàn",
        "confirmation": "chan eil e ’na mhaids dha %{attribute}",
        "empty": "chan fhaod seo a bhith falamh",
        "equal_to": "feumaidh seo a bhith co-ionnan ri %{count}",
        "even": "feumaidh seo a bhith ’na àireamh chothrom",
        "exclusion": "tha seo glèidhte",
        "greater_than": "feumaidh seo a bhith nas motha na %{count}",
        "greater_than_or_equal_to": "feumaidh seo a bhith nas motha na no co-ionann ri %{count}",
        "in": "feumaidh seo a bhith am broinn %{count}",
        "inclusion": "chan eil seo am broinn na liosta",
        "invalid": "chan eil seo dligheach",
        "less_than": "feumaidh seo a bhith nas lugha na %{count}",
        "less_than_or_equal_to": "feumaidh seo a bhith nas lugha na no co-ionann ri %{count}",
        "model_invalid": "Dh’fhàillig leis an dearbhadh: %{errors}",
        "not_a_number": "chan eil seo ’na àireamh",
        "not_an_integer": "feumaidh seo a bhith ’na àireamh shlàn",
        "odd": "feumaidh seo a bhith ’na àireamh chòrr",
        "other_than": "chan fhaod seo a bhith %{count}",
        "present": "feumaidh seo a bhith bàn",
        "required": "feumaidh seo a bhith ann",
        "taken": "tha seo aig rud eile mu thràth",
        "too_long": {
          "few": "tha seo ro fhada (tha %{count} caractaran ceadaichte air a char as motha)",
          "one": "tha seo ro fhada (tha %{count} charactar ceadaichte air a char as motha)",
          "other": "tha seo ro fhada (tha %{count} caractar ceadaichte air a char as motha)",
          "two": "tha seo ro fhada (tha %{count} charactar ceadaichte air a char as motha)"
        },
        "too_short": {
          "few": "tha seo ro ghoirid (tha %{count} caractaran ceadaichte air a char as lugha)",
          "one": "tha seo ro ghoirid (tha %{count} charactar ceadaichte air a char as lugha)",
          "other": "tha seo ro ghoirid (tha %{count} caractar ceadaichte air a char as lugha)",
          "two": "tha seo ro ghoirid (tha %{count} charactar ceadaichte air a char as lugha)"
        },
        "wrong_length": {
          "few": "chan eil an fhaide mar bu chòir (bu chòir dha a bhith %{count} caractaran)",
          "one": "chan eil an fhaide mar bu chòir (bu chòir dha a bhith %{count} charactar)",
          "other": "chan eil an fhaide mar bu chòir (bu chòir dha a bhith %{count} caractar)",
          "two": "chan eil an fhaide mar bu chòir (bu chòir dha a bhith %{count} charactar)"
        }
      },
      "template": {
        "body": "Bha duilgheadasan ann leis na raointean seo:",
        "header": {
          "few": "Dh’adhbharaich %{count} mearachdan nach gabh a’ %{model} seo a shàbhaladh",
          "one": "Dh’adhbharaich %{count} mhearachd nach gabh a’ %{model} seo a shàbhaladh",
          "other": "Dh’adhbharaich %{count} mearachd nach gabh a’ %{model} seo a shàbhaladh",
          "two": "Dh’adhbharaich %{count} mhearachd nach gabh a’ %{model} seo a shàbhaladh"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Tagh"
      },
      "submit": {
        "create": "Cruthaich %{model}",
        "submit": "Sàbhail %{model}",
        "update": "Ùraich %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "two",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "£"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "billean",
            "million": "millean",
            "quadrillion": "quadrillean",
            "thousand": "mìle",
            "trillion": "trillean",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "baidhtean",
              "one": "bhaidht",
              "other": "baidht",
              "two": "bhaidht"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " agus ",
        "two_words_connector": " agus ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "m",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %b %Y, %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "f"
    }
  },
  "gl": {
    "date": {
      "abbr_day_names": [
        "Dom",
        "Lun",
        "Mar",
        "Mer",
        "Xov",
        "Ven",
        "Sab"
      ],
      "abbr_month_names": [
        null,
        "Xan",
        "Feb",
        "Mar",
        "Abr",
        "Mai",
        "Xuñ",
        "Xul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Domingo",
        "Luns",
        "Martes",
        "Mércores",
        "Xoves",
        "Venres",
        "Sábado"
      ],
      "formats": {
        "default": "%e/%m/%Y",
        "long": "%A %e de %B de %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "Xaneiro",
        "Febreiro",
        "Marzo",
        "Abril",
        "Maio",
        "Xuño",
        "Xullo",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Decembro"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "aproximadamente unha hora",
          "other": "%{count} horas"
        },
        "about_x_months": {
          "one": "aproximadamente %{count} mes",
          "other": "%{count} meses"
        },
        "about_x_years": {
          "one": "aproximadamente %{count} ano",
          "other": "%{count} anos"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos",
          "zero": "menos dun minuto"
        },
        "less_than_x_seconds": {
          "few": "poucos segundos",
          "one": "%{count} segundo",
          "other": "%{count} segundos",
          "zero": "menos dun segundo"
        },
        "over_x_years": {
          "one": "máis dun ano",
          "other": "%{count} anos"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minuto"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        }
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "non pode estar en branco",
        "confirmation": "non coincide coa confirmación",
        "empty": "non pode estar baleiro",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser impar",
        "exclusion": "xa existe",
        "greater_than": "debe ser maior que %{count}",
        "greater_than_or_equal_to": "debe ser maior ou igual que %{count}",
        "inclusion": "non está incluído na lista",
        "invalid": "non é válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor ou igual que %{count}",
        "not_a_number": "non é un número",
        "odd": "debe ser par",
        "taken": "non está dispoñible",
        "too_long": "é demasiado longo (non máis de %{count} carácteres)",
        "too_short": "é demasiado curto (non menos de %{count} carácteres)",
        "wrong_length": "non ten a lonxitude correcta (debe ser de %{count} carácteres)"
      },
      "template": {
        "body": "Atopáronse os seguintes problemas:",
        "header": {
          "one": "%{count} erro evitou que se puidese gardar o %{model}",
          "other": "%{count} erros evitaron que se puidese gardar o %{model}"
        }
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %e de %B de %Y ás %H:%M",
        "long": "%A %e de %B de %Y ás %H:%M",
        "short": "%e/%m, %H:%M"
      },
      "pm": "pm"
    }
  },
  "ha": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "Mabudi na yan zu",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "I-mail",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "Mabudi",
          "password_confirmation": "Mabudi ya tabbata",
          "remember_created_at": null,
          "remember_me": "tuna da ni",
          "reset_password_sent_at": null,
          "reset_password_token": "Gyara mabudi",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "Bode tokin ka",
          "updated_at": null
        }
      },
      "models": {
        "user": {
          "one": "Mai amfani deshi",
          "other": "Mai amfani deshi"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Adireshin I-mail din ka ya karbu",
        "new": {
          "resend_confirmation_instructions": "Sake turo bayanin ka"
        },
        "send_instructions": "Zaka karbi sako daga wurin mu na yadda zaka tabbatar da I-mail din ka a kakkanin lokaci",
        "send_paranoid_instructions": "Idan adireshen I-mail din ka yana tare da data base din mu zaka karbi sakon yadda zaka tabbatar da I-mail din ka"
      },
      "failure": {
        "already_authenticated": "Ka shiga tuni",
        "inactive": "Akaut din ka bai karbu ba",
        "invalid": null,
        "last_attempt": "kana da dama guda daya kafin mu kulle akaut din ka",
        "locked": "Akaut din ka an kulle",
        "not_found_in_database": null,
        "timeout": "lokacin ka ya kare, sake shigo wa kafin ka si gaba",
        "unauthenticated": "Shiga kafin ka ci gaba",
        "unconfirmed": "Sai ka tabbatar da adireshin I-mail din ka kafin ka ci gaba"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Tabbatar da akaut di na",
          "greeting": "Sannu da zuwa %{recipient} ",
          "instruction": "Zaka iya tabbatar da I-mail din ka daga sakon dake karkashin ka",
          "subject": "Bayanin tabbatar wa"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Hallo %{recipient}",
          "message": "Muna tura maka da sako cewa mabudin da ka canza ya tabbatar",
          "subject": "Mabudi ya canzu"
        },
        "reset_password_instructions": {
          "action": "canza mabudi na",
          "greeting": "Hallo %{recipient}",
          "instruction": "Wanni ya turo mana da sako mu canza mabudin ka, kuma zaka iya canzawa da sakon dake karkashin ka",
          "instruction_2": "idan baka turo da sakon canzawa ba kada ka bude sakon",
          "instruction_3": "mabudin ka bazai canzu ba idan baka bude sakon ba",
          "subject": "sake gyara bayanin mabudi"
        },
        "unlock_instructions": {
          "action": "bude akaunt di na",
          "greeting": "hallo %{recipient}!",
          "instruction": "danna sakon dake karshe domin ka bude akaut din ka",
          "message": "mun kulle akaut dinka sabo da yawan shige-shigen ka",
          "subject": "bayanin yadda zaka bude"
        }
      },
      "omniauth_callbacks": {
        "failure": "bai tabbatar de kai ba %{kind} saboda “ %{reason}”",
        "success": "Tabbatar da bayanin ka %{kind} akaut"
      },
      "passwords": {
        "edit": {
          "change_my_password": "Canza mabudi na",
          "change_your_password": "Canza mabudi ka",
          "confirm_new_password": "Tabbatar da sabon mobudin ka",
          "new_password": "Sabon mabudi"
        },
        "new": {
          "forgot_your_password": "Na matta mabudi na",
          "send_me_reset_password_instructions": "aiko mini da bayanin mabudi na"
        },
        "no_token": "Ba zaka iya tabbater da wannan bayanin bude waba sai ka koma cikin I-mail da ka bamu idan baka shiga ta hanyar I-mail ba, zaka iya shiga ta ‘URL’ de muke da shi",
        "send_instructions": "Zaka karbi bayanin daga wurin mu, yadda naka canza mabudin ka a cikin kakkanin lokaci",
        "send_paranoid_instructions": "Idan adireshin I-mail din ka yana aiki da database din mu, zaka sako daga wurin mu zuwa I-mail din ka, yadda zaka bude akaut din ka a cikin kakkanin lokaci",
        "updated": "Sabon Mabudin ka ya karbu, zaka iya shiga yan zu",
        "updated_not_active": "Sabon mabudin ka ya karbu"
      },
      "registrations": {
        "destroyed": "Sai anjuma! Mun kunle akaut din ka, muna fatan zamu sake ganin ka",
        "edit": {
          "are_you_sure": "Ka tabbater da haka",
          "cancel_my_account": "Kunle akaut di na",
          "currently_waiting_confirmation_for_email": "Muna Sauraron bayanin daga wurin ka: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "Karka danna komai idan baka canza ba",
          "title": "Gyara %{resource}",
          "unhappy": "Ba cin rai",
          "update": "Ci gaba",
          "we_need_your_current_password_to_confirm_your_changes": "Muna bukatar sabon mabudin ka domin mu sake tabbatar da canza war ka"
        },
        "new": {
          "sign_up": "Shigar da sabon bayanin akaut "
        },
        "signed_up": "Sannu da zuwa; sabon akaut din ka ya tabbatar",
        "signed_up_but_inactive": "Sabon akaut din ka ya tabbata, Ba zamu iya shigar da kai ba sabode akaut din ka bai kar bu ba",
        "signed_up_but_locked": "Sabon akaut din ka ya tabbata, amma Ba zamu iya shiga da kai ba sabode mun kuile akaut din ka",
        "signed_up_but_unconfirmed": "sako daga wurin mu zai shigo I-mail din ka, biyomu zaka bude akaut  din ka",
        "update_needs_confirmation": "Budewar akaut din ka ya tabbata, amma sai mun tabbatar da adireshin i-mail din ka. Duba i-mail din ka zaka ga sako sai ka bude",
        "updated": "Budewar akaut din ka ya tabbatar",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "ka fita daga akaut",
        "new": {
          "sign_in": "shiga akaut"
        },
        "signed_in": "ka shiga de sauki",
        "signed_out": "ka fita de sauki"
      },
      "shared": {
        "links": {
          "back": "koma baya",
          "didn_t_receive_confirmation_instructions": "Ban karbi bayanin ka ba?",
          "didn_t_receive_unlock_instructions": "Ban karɓi bayanin buɗewar bayanin ka ba?",
          "forgot_your_password": "Na matta mabudi na",
          "sign_in": "shiga",
          "sign_in_with_provider": "shiga da %{provider}",
          "sign_up": "Bayar de sabon bayanin akaut"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Sake  turo da bayanin bude akaut"
        },
        "send_instructions": "Zaka karbi bayani daga wurin mu na yadda zaka bude akaut din ka",
        "send_paranoid_instructions": "Idan akaut din ka yana aiki, zaka karbi bayanin daga wurin mu na yadda zaka bude akaut din ka",
        "unlocked": "Akaut din ka ya budi, shiga doming a cigaba"
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "Mun karba, kana iya shiga yanzu",
        "confirmation_period_expired": "Ina so in tabbata da %{period}, tabbayi sabo",
        "expired": "lokacin ka ya kare, sake tambaya sabo ",
        "not_found": "Ba bayani",
        "not_locked": "Ba mu kunle ba",
        "not_saved": {
          "one": "1 me ya sa bayanin ka bai karbu ba %{resource}",
          "other": "%{count} Me ya sa bayanin ka %{resource} bai karbu ba  "
        }
      }
    }
  },
  "he": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "אימות נשלח ב",
          "confirmation_token": "טוקן אימות",
          "confirmed_at": "אומת ב",
          "created_at": "נוצר ב",
          "current_password": "סיסמא נוכחית",
          "current_sign_in_at": "כניסה נוכחית ב",
          "current_sign_in_ip": "כתובת IP לכניסה נוכחית",
          "email": "אימייל",
          "encrypted_password": "סיסמא מוצפנת",
          "failed_attempts": "נסיונות כושלים",
          "last_sign_in_at": "כניסה אחרונה",
          "last_sign_in_ip": "כתובת IP של כניסה אחרונה",
          "locked_at": "ננעל ב",
          "password": "סיסמא",
          "password_confirmation": "אישור סיסמא",
          "remember_created_at": "זיכרון נוצר ב",
          "remember_me": "זכור אותי",
          "reset_password_sent_at": "איפוס סיסמא נשלח ב",
          "reset_password_token": "טוקן איפוס סיסמא",
          "sign_in_count": "מספר כניסות",
          "unconfirmed_email": "אימייל לא מאומת",
          "unlock_token": "טוקן שחרור",
          "updated_at": "עודכן ב"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "האימות נכשל: %{errors}"
        }
      },
      "models": {
        "user": {
          "one": null,
          "other": null,
          "two": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "א",
        "ב",
        "ג",
        "ד",
        "ה",
        "ו",
        "ש"
      ],
      "abbr_month_names": [
        null,
        "ינו",
        "פבר",
        "מרץ",
        "אפר",
        "מאי",
        "יונ",
        "יול",
        "אוג",
        "ספט",
        "אוק",
        "נוב",
        "דצמ"
      ],
      "day_names": [
        "ראשון",
        "שני",
        "שלישי",
        "רביעי",
        "חמישי",
        "שישי",
        "שבת"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%e ב%B, %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "ינואר",
        "פברואר",
        "מרץ",
        "אפריל",
        "מאי",
        "יוני",
        "יולי",
        "אוגוסט",
        "ספטמבר",
        "אוקטובר",
        "נובמבר",
        "דצמבר"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "בערך שעה אחת",
          "other": "בערך %{count} שעות"
        },
        "about_x_months": {
          "one": "בערך חודש אחד",
          "other": "בערך %{count} חודשים"
        },
        "about_x_years": {
          "one": "בערך שנה אחת",
          "other": "בערך %{count} שנים"
        },
        "almost_x_years": {
          "one": "כמעט שנה",
          "other": "כמעט %{count} שנים"
        },
        "half_a_minute": "חצי דקה",
        "less_than_x_minutes": {
          "one": "פחות מדקה אחת",
          "other": "פחות מ- %{count} דקות",
          "zero": "פחות מדקה אחת"
        },
        "less_than_x_seconds": {
          "one": "פחות משניה אחת",
          "other": "פחות מ- %{count} שניות",
          "zero": "פחות משניה אחת"
        },
        "over_x_years": {
          "one": "מעל שנה אחת",
          "other": "מעל %{count} שנים"
        },
        "x_days": {
          "one": "יום אחד",
          "other": "%{count} ימים"
        },
        "x_minutes": {
          "one": "דקה אחת",
          "other": "%{count} דקות"
        },
        "x_months": {
          "one": "חודש אחד",
          "other": "%{count} חודשים"
        },
        "x_seconds": {
          "one": "שניה אחת",
          "other": "%{count} שניות"
        }
      },
      "prompts": {
        "day": "יום",
        "hour": "שעה",
        "minute": "דקה",
        "month": "חודש",
        "second": "שניות",
        "year": "שנה"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "חשבונך אושר בהצלחה.",
        "new": {
          "resend_confirmation_instructions": "שלח מחדש הוראות אישור"
        },
        "send_instructions": "בדקות הקרובות יגיע אליך אימייל עם הנחיות כיצד לאשר את הרשמתך.",
        "send_paranoid_instructions": "אם האימייל שלך נמצא במאגר נתונים שלנו, נשלח לך אימייל עם הוראות כיצד לאשר את החשבון שלך בעוד כמה דקות."
      },
      "failure": {
        "already_authenticated": "את/ה כבר מחובר/ת",
        "inactive": "חשבונך טרם הופעל.",
        "invalid": "%{authentication_keys} או סיסמא שגויים",
        "last_attempt": "יש לך עוד ניסיון אחד לפני שהחשבון שלך ינעל.",
        "locked": "חשבונך ננעל.",
        "not_found_in_database": "%{authentication_keys} או סיסמא שגויים",
        "timeout": "פג תוקף החיבור לאתר, אנא התחבר מחדש.",
        "unauthenticated": "עליך להתחבר או להרשם על-מנת להמשיך.",
        "unconfirmed": "עליך לאשר את הרשמתך לפני שתוכל להמשיך."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "אשר את החשבון שלי",
          "confirm_account_link": "אשר את החשבון שלי",
          "confirm_link_msg": "תוכל לאשר את כתובת הדוא\"ל של החשבון שלך באמצעות הקישור הבא:",
          "greeting": "ברוך הבא %{recipient}!",
          "instruction": "אתה יכול לאשר את כתובת האימייל שלך בעזרת הקישור הנֿֿ״ל:",
          "subject": "הוראות לאישור הרשמה"
        },
        "email_changed": {
          "greeting": "שלום %{recipient}!",
          "message": "אנו כותבים אליך כדי ליידע אותך שהאימייל שלך שונה ל-%{email}.",
          "message_unconfirmed": "אנו כותבים אליך כדי ליידע אותך שאנחנו משנים את אימייל שלך ל-%{email}.",
          "subject": "אימייל שונה"
        },
        "password_change": {
          "greeting": "שלום %{recipient}!",
          "message": "אנו כותבים אליך כדי ליידע אותך שהסיסמא שלך שונתה.",
          "subject": "סיסמא שונתה"
        },
        "reset_password_instructions": {
          "action": "שנה סיסמא",
          "greeting": "שלום %{recipient}!",
          "ignore_mail_msg": "אם לא ביקשת זאת, התעלם מדוא\"ל זה.",
          "instruction": "נתקבלה בקשה לשינוי הסיסמא שלך וביכולתך לעשות זאת בעזרת הקישור המוצג למטה.",
          "instruction_2": "אם אתה לא ביקשת זאת, אנא התעלם מאימייל זה.",
          "instruction_3": "סיסמאתך תוחלף רק אם תלחץ על הקישור המוצג מעל ותיצור סיסמא חדשה.",
          "no_changes_msg": "הסיסמה שלך לא תשתנה עד שתגיע לקישור שלמעלה ותיצור סיסמה חדשה.",
          "password_change_link": "שנה את הסיסמה שלי",
          "request_reset_link_msg": "מישהו ביקש קישור לשינוי הסיסמה שלך. תוכל לעשות זאת באמצעות הקישור הבא.",
          "subject": "הוראות לאיפוס סיסמא"
        },
        "unlock_instructions": {
          "account_lock_msg": "החשבון שלך ננעל עקב מספר מופרז של ניסיונות כניסה לא מוצלחים.",
          "action": "בטל נעילת חשבון",
          "greeting": "שלום %{recipient}!",
          "instruction": "לחץ על הלינק המוצג למטה בכדי לבטל את נעילת חשבונך:",
          "message": "חשבונך ננעל עקב מספר רב של ניסיונות כניסה כושלים.",
          "subject": "הוראות להסרת נעילה",
          "unlock_link": "בטל את הנעילה של החשבון שלי",
          "unlock_link_msg": "לחץ על הקישור למטה כדי לבטל את נעילת החשבון שלך:"
        }
      },
      "omniauth_callbacks": {
        "failure": "לא הצלחנו לאמת את זהותך מסוג %{kind} בגלל \"%{reason}\"",
        "success": "אומת בהצלה מחשבון %{kind}"
      },
      "passwords": {
        "edit": {
          "change_my_password": "שנה סיסמא",
          "change_your_password": "שינוי סיסמא",
          "confirm_new_password": "אישור סיסמא חדשה",
          "new_password": "סיסמא חדשה"
        },
        "new": {
          "forgot_your_password": "שכחת סיסמא?",
          "send_me_reset_password_instructions": "שלח לי הוראות שיחזור סיסמא"
        },
        "no_token": "אינך יכול/ה לגשת לעמוד זה אם לא הופנת מאימייל לשינוי סיסמא. אם את/ה כן מגיע משם, אנא ודא/י שהשתמשת בכתובת אינטרנט המלאה.",
        "send_instructions": "בדקות הקרובות יגיע אליך אימייל עם הנחיות כיצד לאפס את סיסמתך.",
        "send_paranoid_instructions": "אם האימייל שלך קיים במאגר, אנו נשלח לך לינק לחידוש סיסמא באימייל.",
        "updated": "סיסמתך שונתה בהצלחה. כעת הנך מחובר/ת.",
        "updated_not_active": "הסיסמא שלך שונתה בהצלחה."
      },
      "registrations": {
        "destroyed": "חשבונך נמחק בהצלחה. מקווים לראותך בעתיד.",
        "edit": {
          "are_you_sure": "האם את בטוח?",
          "cancel_my_account": "בטל את החשבון שלי",
          "currently_waiting_confirmation_for_email": "ממתין לאישור של הכתובת: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "השאר ריק אם אין ברצונך לשנותו",
          "title": "ערוך %{resource}",
          "unhappy": "לא מרוצה",
          "update": "עדכן",
          "we_need_your_current_password_to_confirm_your_changes": "אנחנו זקוקים לסיסמאתך הנוכחית על מנת לבצע את השינויים שביקשת"
        },
        "new": {
          "sign_up": "הרשמה"
        },
        "signed_up": "נרשמת בהצלחה. אם נדרש, יישלח אליך אימייל לאישור הרשמתך.",
        "signed_up_but_inactive": "ההרשמה בוצעה בהצלחה, אך לא יכולנו להכניס אותך למערכת מכיוון שעוד לא הפעלת את חשבונך",
        "signed_up_but_locked": "ההרשמה בוצעה בהצלחה, אך לא יכולנו להכניס אותך למערכת מכיוון שחשבונתך נעול.",
        "signed_up_but_unconfirmed": "הודעה עם לינק לאישור חשבונך נשלח לאימייל שלך. אנא פתח/י את הלינק על מנת להפעיל את חשבונך.",
        "update_needs_confirmation": "עידכנת את חשבונך בהצלחה, אבל אנחנו צריכים לאשר את האימייל החדש שלך. אנא בדק/י את האימייל שלך ולחצ/י על הלינק על מנת לאשר את חשבון האימייל החדש.",
        "updated": "עדכנת בהצלחה את חשבונך.",
        "updated_but_not_signed_in": "חשבונך עודכן בהצלחה, אך מכיוון שהסיסמא שונתה עלייך להזדהות מחדש"
      },
      "sessions": {
        "already_signed_out": "התנתקות מוצלחת",
        "new": {
          "sign_in": "כניסה"
        },
        "signed_in": "התחברת בהצלחה",
        "signed_out": "התנתקת בהצלחה."
      },
      "shared": {
        "links": {
          "back": "חזור",
          "didn_t_receive_confirmation_instructions": "לא קיבלת את הוראות האישור?",
          "didn_t_receive_unlock_instructions": "לא קיבלת את הוראות ביטול הנעילה?",
          "forgot_your_password": "שכחת סיסמא?",
          "sign_in": "כניסה",
          "sign_in_with_provider": "כניסה באמצעות %{provider}",
          "sign_up": "הרשמה"
        },
        "minimum_password_length": {
          "one": null,
          "other": null,
          "two": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "שלח שוב הוראות ביטול נעילה"
        },
        "send_instructions": "בדקות הקרובות יישלח אליך אימייל עם הנחיות כיצד להסיר את הנעילה מחשבונך.",
        "send_paranoid_instructions": "אם חשבונך קיים, את/ה תקבל/י אימייל עם הוראות כיצד להפעיל מחדש את חשבונך.",
        "unlocked": "הנעילה הוסרה בהצלחה. כעת הנך מחובר/ת."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "הפניה אל '%{redirect_url}' אינה מותרת."
      },
      "passwords": {
        "missing_email": "עליך לספק כתובת דוא\"ל.",
        "missing_passwords": "עליך למלא את השדות 'סיסמה' ו'אישור סיסמה'.",
        "missing_redirect_url": "כתובת אתר להפניה מחדש חסרה.",
        "not_allowed_redirect_url": "הפניה אל '%{redirect_url}' אינה מותרת.",
        "password_not_required": "חשבון זה אינו דורש סיסמה. במקום זאת, השתמש בחשבון '%{provider}' שלך.",
        "sended": "אימייל נשלח ל '%{email}' המכיל הוראות לאיפוס הסיסמה שלך.",
        "successfully_updated": "הסיסמה שלך עודכנה בהצלחה.",
        "user_not_found": "לא ניתן למצוא משתמש עם הדוא\"ל '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "לא ניתן לאתר חשבון להשמדה.",
        "account_with_uid_destroyed": "חשבון עם UID '%{uid}' הושמד.",
        "email_already_exists": "כבר קיים חשבון עבור '%{email}'",
        "missing_confirm_success_url": "חסר פרמטר 'confirm_success_url'.",
        "redirect_url_not_allowed": "הפניה אל '%{redirect_url}' אינה מותרת.",
        "user_not_found": "המשתמש לא נמצא."
      },
      "sessions": {
        "bad_credentials": "נתוני כניסה שגויים. בבקשה נסה שוב.",
        "not_confirmed": "הודעת אישור נשלחה לחשבון שלך בכתובת '%{email}'. עליך לפעול לפי ההנחיות שבדוא\"ל לפני הפעלת החשבון שלך",
        "not_supported": "השתמש ב- POST / sign_in כדי להיכנס. GET אינו נתמך.",
        "user_not_found": "המשתמש לא נמצא או לא היה מחובר."
      },
      "token_validations": {
        "invalid": "נתוני כניסה שגויים"
      },
      "unlocks": {
        "missing_email": "עליך לספק כתובת דוא\"ל.",
        "sended": "הודעת אימייל נשלחה אל '%{email}' המכילה הוראות לביטול הנעילה של חשבונך.",
        "user_not_found": "ניתן למצוא את המשתמש עם הדוא\"ל '%{email}'"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "חייב באישור",
        "already_confirmed": "כבר אושר. אנא נסה להיכנס למערכת.",
        "blank": "לא יכול להיות ריק",
        "confirmation": "לא תואם לאישורו",
        "confirmation_period_expired": "יש לאמת בתוך %{period}, אנא צור בקשה חדשה",
        "empty": "לא יכול להיות ריק",
        "equal_to": "חייב להיות שווה ל- %{count}",
        "even": "חייב להיות זוגי",
        "exclusion": "לא זמין",
        "expired": "פג תוקף, אנא בקש אחד חדש.",
        "greater_than": "חייב להיות גדול מ- %{count}",
        "greater_than_or_equal_to": "חייב להיות גדול או שווה ל- %{count}",
        "inclusion": "לא נכלל ברשימה",
        "invalid": "לא תקין",
        "less_than": "חייב להיות קטן מ- %{count}",
        "less_than_or_equal_to": "חייב להיות קטן או שווה ל- %{count}",
        "not_a_number": "חייב להיות מספר",
        "not_an_integer": "חייב להיות מספר שלם",
        "not_email": "אינו דוא\"ל",
        "not_found": "לא נמצא.",
        "not_locked": "לא היה נעול.",
        "not_saved": {
          "one": null,
          "other": null,
          "two": null
        },
        "odd": "חייב להיות אי זוגי",
        "taken": "כבר בשימוש",
        "too_long": "ארוך מדי (יותר מ- %{count} תווים)",
        "too_short": "קצר מדי (פחות מ- %{count} תווים)",
        "validate_account_update_params": "שלחו בבקשה נתוני עדכון חשבון תקינים בגוף הבקשה.",
        "validate_sign_up_params": "שלח נתוני רישום תקינים בגוף הבקשה.",
        "wrong_length": "לא באורך הנכון (חייב להיות %{count} תווים)"
      },
      "template": {
        "body": "אנא בדוק את השדות הבאים:",
        "header": {
          "one": "לא ניתן לשמור את ה%{model}: שגיאה אחת",
          "other": "לא ניתן לשמור את ה%{model}: %{count} שגיאות."
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "##",
          "#"
        ],
        "city": [
          "#{city_prefix} #{Name.first_name}",
          "#{city_prefix} #{Name.last_name}"
        ],
        "city_prefix": [
          "רמת",
          "הר",
          "גבעת",
          "כפר"
        ],
        "default_country": [
          "ישראל"
        ],
        "street_address": [
          "#{building_number} #{street_name}",
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_prefix} #{Name.name}"
        ],
        "street_prefix": [
          "רחוב",
          "רחוב",
          "נחל",
          "דרך",
          "שדרות"
        ]
      },
      "cell_phone": {
        "formats": [
          "0##-###-####"
        ]
      },
      "name": {
        "first_name": [
          "אביבה",
          "אביגדור",
          "אביגיל",
          "אברהם",
          "אהובה",
          "אהוד",
          "אהרן",
          "אורה",
          "אורי",
          "אוריאל",
          "אורית",
          "אורלי",
          "איילה",
          "איילת",
          "איתן",
          "אלי",
          "אליהו",
          "אלימלך",
          "אליעזר",
          "אלישבע",
          "אלישע",
          "אלעזר",
          "אמונה",
          "אסנת",
          "אסתר",
          "אפרים",
          "אריאל",
          "אריאלה",
          "אריה",
          "אשר",
          "בועז",
          "ביילה",
          "בינה",
          "בנימין",
          "בצלאל",
          "ברוך",
          "ברכה",
          "ברק",
          "בתיה",
          "גאולה",
          "גבריאל",
          "גד",
          "גדליה",
          "גילה",
          "גרשום",
          "גרשון",
          "דבורה",
          "דוב",
          "דוד",
          "דינה",
          "דן",
          "דניאל",
          "הדסה",
          "הדר",
          "הודיה",
          "הלל",
          "זאב",
          "זבולון",
          "זהבה",
          "זכריה",
          "זלמן",
          "זרח",
          "חביבה",
          "חגי",
          "חגית",
          "חוה",
          "חזקיהו",
          "חיה",
          "חיים",
          "חנה",
          "חנוך",
          "חנן",
          "חננאל",
          "חנניה",
          "טובה",
          "טוביה",
          "טל",
          "טליה",
          "יאיר",
          "ידידיה",
          "יהודה",
          "יהודית",
          "יהושע",
          "יואל",
          "יובל",
          "יוחנן",
          "יוכבד",
          "יונה",
          "יונתן",
          "יוסף",
          "יחזקאל",
          "יחיאל",
          "יעקב",
          "יצחק",
          "ירחמיאל",
          "ישעיהו",
          "ישראל",
          "יששכר",
          "כלב",
          "כרמי",
          "לאה",
          "לבונה",
          "לבנה",
          "לוי",
          "ליאורה",
          "לילה",
          "מאיר",
          "מאירה",
          "מוריה",
          "מזל",
          "מיכאל",
          "מיכה",
          "מיכל",
          "מלכה",
          "מלכיאל",
          "מנוחה",
          "מנחם",
          "מנשה",
          "מרדכי",
          "מרים",
          "משה",
          "מתתיהו",
          "נועם",
          "נחום",
          "נחמה",
          "נחמיה",
          "נחמן",
          "נחשון",
          "נעמי",
          "נפתלי",
          "נתן",
          "נתנאל",
          "עדינה",
          "עובדיה",
          "עזרא",
          "עזריאל",
          "עטרה",
          "עמוס",
          "עמרם",
          "עקיבא",
          "פנחס",
          "פנינה",
          "פסח",
          "פסחיה",
          "פרץ",
          "צבי",
          "צביה",
          "צדוק",
          "צופיה",
          "ציון",
          "ציונה",
          "צמח",
          "צפורה",
          "צפניה",
          "ראובן",
          "רבקה",
          "רות",
          "רחל",
          "רחמים",
          "רינה",
          "רפאל",
          "שבתאי",
          "שולמית",
          "שושנה",
          "שי",
          "שירה",
          "שלום",
          "שלומית",
          "שלמה",
          "שמואל",
          "שמחה",
          "שמעון",
          "שמריהו",
          "שמשון",
          "שפרה",
          "שרה",
          "שרון",
          "שרי",
          "תהילה",
          "תמר",
          "תקווה"
        ],
        "last_name": [
          "כהן",
          "לוי",
          "מזרחי",
          "פרץ",
          "ביטון",
          "דהן",
          "אברהם",
          "פרידמן",
          "אגבאריה",
          "מלכה",
          "אזולאי",
          "כץ",
          "יוסף",
          "דוד",
          "עמר",
          "אוחיון",
          "חדד",
          "גבאי",
          "אדרי",
          "לוין",
          "טל",
          "קליין",
          "חן",
          "שפירא",
          "חזן",
          "משה",
          "אשכנזי",
          "אוחנה",
          "סגל",
          "סואעד",
          "גולן",
          "יצחק",
          "בר",
          "מור",
          "יעקב",
          "שלום",
          "אליהו",
          "דיין",
          "אלבז",
          "בכר",
          "סויסה",
          "שמש",
          "רוזנברג",
          "לביא",
          "אטיאס",
          "נחום",
          "שרעבי",
          "שטרן",
          "ממן",
          "שחר",
          "אלון",
          "שורץ"
        ],
        "name": [
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "0#-###-####"
        ]
      }
    },
    "hello": "שלום",
    "helpers": {
      "select": {
        "prompt": "נא לבחור"
      },
      "submit": {
        "create": "יצירת %{model}",
        "submit": "שמור %{model}",
        "update": "עדכון %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₪"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "מיליארד",
            "million": "מיליון",
            "quadrillion": "קודריליון",
            "thousand": "אלף",
            "trillion": "טריליון",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "בייט",
              "other": "בתים"
            },
            "gb": "ג'יגה-בייט",
            "kb": "קילו-בייט",
            "mb": "מגה-בייט",
            "tb": "טרה-בייט"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " ו",
        "two_words_connector": " ו",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a %d %b %H:%M:%S %Z %Y",
        "long": "%d ב%B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "welcome": "ברוך הבא"
  },
  "hi": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "पुष्टिकरण भेजा गया",
          "confirmation_token": "पुष्टिकरण टोकन",
          "confirmed_at": "पर पुष्टि की गई",
          "created_at": "पर बनाया गया",
          "current_password": "वर्तमान पासवर्ड",
          "current_sign_in_at": "पर वर्तमान में साइन इन करें",
          "current_sign_in_ip": "वर्तमान में साइन इन IP",
          "email": "ईमेल",
          "encrypted_password": "एन्क्रिप्ट किया गया पासवर्ड",
          "failed_attempts": "असफल प्रयास",
          "last_sign_in_at": "पर अंतिम साइन इन",
          "last_sign_in_ip": "अंतिम साइन इन IP",
          "locked_at": "लॉक कर दिया",
          "password": "पासवर्ड",
          "password_confirmation": "पासवर्ड पुष्टिकरण",
          "remember_created_at": "याद रखें बनाया गया",
          "remember_me": "मुझे याद रखना",
          "reset_password_sent_at": "पर रीसेट पासवर्ड भेजा गया",
          "reset_password_token": "रीसेट पासवर्ड टोकन",
          "sign_in_count": "साइन इन की संख्या",
          "unconfirmed_email": "अपुष्ट ईमेल",
          "unlock_token": "टोकन अनलॉक करें",
          "updated_at": "पर अपडेट किया गया"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "सत्यापन विफल: %{errors}"
        }
      },
      "models": {
        "user": {
          "one": "उपयोगकर्ता",
          "other": "\nउपयोगकर्ता"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "रवि",
        "सोम",
        "मंगल",
        "बुध",
        "गुरु",
        "शुक्र",
        "शनि"
      ],
      "abbr_month_names": [
        null,
        "जन",
        "फर",
        "मार्च",
        "अप्रै",
        "मई",
        "जून",
        "जुला",
        "अग",
        "सितं",
        "अक्टू",
        "नवं",
        "दिस"
      ],
      "day_names": [
        "रविवार",
        "सोमवार",
        "मंगलवार",
        "बुधवार",
        "गुरुवार",
        "शुक्रवार",
        "शनिवार"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "जनवरी",
        "फरवरी",
        "मार्च",
        "अप्रैल",
        "मई",
        "जून",
        "जुलाई",
        "अगस्त",
        "सितंबर",
        "अक्टूबर",
        "नवंबर",
        "दिसंबर"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "लगभग एक घंटा",
          "other": "लगभग %{count} घंटा"
        },
        "about_x_months": {
          "one": "लगभग %{count} महीना",
          "other": "लगभग %{count} महीना"
        },
        "about_x_years": {
          "one": "लगभग %{count} साल",
          "other": "लगभग %{count} साल"
        },
        "almost_x_years": {
          "one": "लगभग एक साल",
          "other": "लगभग %{count} साल"
        },
        "half_a_minute": "एक आधा मिनट",
        "less_than_x_minutes": {
          "one": "एक मिनट से कम",
          "other": "%{count} मिनट से कम"
        },
        "less_than_x_seconds": {
          "one": "एक सेकेंड से कम",
          "other": "%{count}  सेकेंड से कम"
        },
        "over_x_years": {
          "one": "एक साल के ऊपर",
          "other": "%{count} साल से अधिक"
        },
        "x_days": {
          "one": "एक दिन",
          "other": "%{count} दिन"
        },
        "x_minutes": {
          "one": "एक मिनट",
          "other": "%{count} मिनट"
        },
        "x_months": {
          "one": "एक महीना",
          "other": "%{count} महीना"
        },
        "x_seconds": {
          "one": "एक सेकेंड",
          "other": "%{count} सेकेंड"
        }
      },
      "prompts": {
        "day": "दिन",
        "hour": "घंटा",
        "minute": "मिनट",
        "month": "माह",
        "second": "सेकेंड",
        "year": "वर्ष"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "आपके ईमेल पते की सफलतापूर्वक पुष्टि हो गई है।",
        "new": {
          "resend_confirmation_instructions": "पुष्टिकरण निर्देशों को पुनः भेजें"
        },
        "send_instructions": "आपको कुछ ही मिनटों में अपने ईमेल पते की पुष्टि करने के निर्देशों के साथ एक ईमेल प्राप्त होगा।",
        "send_paranoid_instructions": "यदि आपका ईमेल पता हमारे डेटाबेस में मौजूद है, तो आपको कुछ ही मिनटों में अपने ईमेल पते की पुष्टि करने के निर्देशों के साथ एक ईमेल प्राप्त होगा।"
      },
      "failure": {
        "already_authenticated": "आप पहले ही साइन इन कर चुके हैं।",
        "inactive": "आपका खाता अभी तक सक्रिय नहीं किया गया है।",
        "invalid": "अमान्य %{authentication_keys} या पासवर्ड।",
        "last_attempt": "आपके खाते के लॉक होने से पहले आपके पास एक और प्रयास है।",
        "locked": "आपका खाता लॉक कर दिया गया है।",
        "not_found_in_database": "अमान्य %{authentication_keys} या पासवर्ड।",
        "timeout": "आपका समय समाप्त हो गया। जारी रखने के लिए कृपया पुन: साइन इन करें।",
        "unauthenticated": "जारी रखने से पहले आपको साइन इन या साइन अप करने की आवश्यकता है।",
        "unconfirmed": "जारी रखने से पहले आपको अपने ईमेल पते की पुष्टि करनी होगी।"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "मेरे खाते की पुष्टि करें",
          "greeting": "अभिनंदन %{recipient}!",
          "instruction": "आप नीचे दिए गए लिंक के माध्यम से अपने ईमेल खाते की पुष्टि कर सकते हैं:",
          "subject": "पुष्टिकरण के  निर्देश"
        },
        "email_changed": {
          "greeting": "नमस्ते! %{recipient}!",
          "message": "हम आपको यह सूचित करने के लिए संपर्क कर रहे हैं कि आपका ईमेल %{email} में बदला जा रहा है।",
          "message_unconfirmed": null,
          "subject": "ईमेल बदला गया"
        },
        "password_change": {
          "greeting": "नमस्ते %{recipient}!",
          "message": "हम आपको सूचित करने के लिए संपर्क कर रहे हैं कि आपका पासवर्ड बदल दिया गया है।",
          "subject": "पासवर्ड बदल दिया गया"
        },
        "reset_password_instructions": {
          "action": "मेरा पासवर्ड बदलें",
          "greeting": "नमस्ते %{recipient}!",
          "instruction": "किसी ने आपका पासवर्ड बदलने के लिए एक लिंक का अनुरोध किया है, और आप इसे नीचे दिए गए लिंक के माध्यम से कर सकते हैं।",
          "instruction_2": "यदि आपने यह अनुरोध नहीं किया है, तो कृपया इस ईमेल को अनदेखा करें।",
          "instruction_3": "जब तक आप ऊपर दिए गए लिंक तक पहुँच के एक नया पासवर्ड नहीं बनाते तब तक आपका पासवर्ड नहीं बदलेगा।",
          "subject": "पासवर्ड रीसेट करने के निर्देश"
        },
        "unlock_instructions": {
          "action": "मेरा खाता अनलॉक करें",
          "greeting": "नमस्ते %{recipient}!",
          "instruction": "अपना खाता अनलॉक करने के लिए नीचे दिए गए लिंक पर क्लिक करें:",
          "message": "अत्यधिक असफल साइन इन प्रयासों के करण आपका खाता लॉक कर दिया गया है।",
          "subject": "अनलॉक करने के निर्देश"
        }
      },
      "omniauth_callbacks": {
        "failure": "आपको %{kind} से प्रमाणित नहीं किया जा सकता क्योंकि \"%{reason}\"।",
        "success": "%{kind} खाते से सफलतापूर्वक प्रमाणित किया गया।"
      },
      "passwords": {
        "edit": {
          "change_my_password": "मेरा पासवर्ड बदलें",
          "change_your_password": "अपना पासवर्ड बदलें",
          "confirm_new_password": "नए पासवर्ड की पुष्टि करें",
          "new_password": "नया पासवर्ड"
        },
        "new": {
          "forgot_your_password": "अपना पासवर्ड भूल गए?",
          "send_me_reset_password_instructions": "मुझे पासवर्ड रीसेट करने के निर्देश भेजें"
        },
        "no_token": "आप पासवर्ड रीसेट ईमेल से आए बिना इस पेज तक नहीं पहुंच सकते। यदि आप एक पासवर्ड रीसेट ईमेल से आते हैं, तो कृपया सुनिश्चित करें कि आपने पूरा URL प्रदान किया है।",
        "send_instructions": "आपको कुछ मिनटों में अपना पासवर्ड रीसेट करने के निर्देशों के साथ एक ईमेल प्राप्त होगा।",
        "send_paranoid_instructions": "यदि आपका ईमेल पता हमारे डेटाबेस में मौजूद है, तो आपको कुछ मिनटों में आपके ईमेल पते पर एक पासवर्ड रिकवरी लिंक प्राप्त होगा।",
        "updated": "आपका पासवर्ड सफलतापूर्वक बदल दिया गया है। अब आप साइन इन हैं",
        "updated_not_active": "आपका पासवर्ड सफलतापूर्वक बदल दिया गया है।"
      },
      "registrations": {
        "destroyed": "अलविदा! आपका खाता सफलतापूर्वक रद्द कर दिया गया है। हम जल्द ही आप से फिर मिलने की उम्मीद करते है।",
        "edit": {
          "are_you_sure": "क्या आप निश्चित हैं?",
          "cancel_my_account": "मेरा खाता रद्द करें",
          "currently_waiting_confirmation_for_email": "वर्तमान में %{email} पुष्टि की प्रतीक्षा की जा रही है:",
          "leave_blank_if_you_don_t_want_to_change_it": "यदि आप इसे बदलना नहीं चाहते हैं तो खाली छोड़ दें",
          "title": "संपादन %{resource}",
          "unhappy": "अप्रसन्न?",
          "update": "अपडेट",
          "we_need_your_current_password_to_confirm_your_changes": "आपके परिवर्तनों की पुष्टि करने के लिए हमें आपका वर्तमान पासवर्ड चाहिए"
        },
        "new": {
          "sign_up": "साइन अप करें"
        },
        "signed_up": "स्वागत है! आपने सफलतापूर्वक साइन अप कर लिया है।",
        "signed_up_but_inactive": "आपने सफलतापूर्वक साइन अप कर लिया है। हालाँकि, हम आपको साइन इन नहीं कर सकते क्योंकि आपका खाता अभी तक सक्रिय नहीं है।",
        "signed_up_but_locked": "आपने सफलतापूर्वक साइन अप कर लिया है। हालाँकि, हम आपको साइन इन नहीं कर सके क्योंकि आपका खाता लॉक है।",
        "signed_up_but_unconfirmed": "आपके ईमेल पते पर एक पुष्टिकरण लिंक के साथ एक संदेश भेजा गया है। कृपया अपने खाते को सक्रिय करने के लिए लिंक का अनुसरण करें।",
        "update_needs_confirmation": "आपने अपना खाता सफलतापूर्वक अपडेट कर दिया है, लेकिन हमें आपके नए ईमेल पते को सत्यापित करना होगा। कृपया अपना ईमेल देखें और अपने नए ईमेल पते की पुष्टि करने के लिए पुष्टि लिंक का अनुसरण करें।",
        "updated": "आपका खाता सफलतापूर्वक अपडेट कर दिया गया है।",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "सफलतापूर्वक साइन आउट किए गए।",
        "new": {
          "sign_in": "लॉग इन करें"
        },
        "signed_in": "सफलतापूर्वक साइन इन किए गए।",
        "signed_out": "सफलतापूर्वक साइन आउट किए गए।"
      },
      "shared": {
        "links": {
          "back": "वापस",
          "didn_t_receive_confirmation_instructions": "पुष्टि निर्देश प्राप्त नहीं हुआ?",
          "didn_t_receive_unlock_instructions": "अनलॉक निर्देश प्राप्त नहीं हुआ?",
          "forgot_your_password": "अपना पासवर्ड भूल गए?",
          "sign_in": "लॉग इन करें",
          "sign_in_with_provider": "%{provider} के साथ साइन इन करें",
          "sign_up": "साइन अप करें"
        },
        "minimum_password_length": {
          "one": "(न्यूनतम %{count} अक्षर)",
          "other": "(न्यूनतम %{count} अक्षर)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "अनलॉक निर्देश पुनः भेजें"
        },
        "send_instructions": "आपको कुछ मिनटों में अपने खाते को अनलॉक करने के निर्देशों के साथ एक ईमेल प्राप्त होगा।",
        "send_paranoid_instructions": "यदि आपका खाता मौजूद है, तो आपको कुछ मिनटों में इसे अनलॉक करने के निर्देशों के साथ एक ईमेल प्राप्त होगा।",
        "unlocked": "आपका खाता सफलतापूर्वक अनलॉक कर दिया गया है। कृपया जारी रखने के लिए साइन इन करें।"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "स्वीकार किया जाना जरूरी",
        "already_confirmed": "पहले ही पुष्टि हो गई थी, कृपया साइन इन करने का प्रयास करें",
        "blank": "खाली नहीं रह सकता है",
        "confirmation": "पुष्टिकरण मेल नहीं खाता",
        "confirmation_period_expired": "%{period} के भीतर पुष्टि की जानी चाहिए, कृपया एक नया अनुरोध करें",
        "empty": "रिक्त नहीं रह सकता है",
        "equal_to": "%{count} के लिए बराबर होना चाहिए",
        "even": "सम होना चाहिए",
        "exclusion": "आरक्षित है",
        "expired": "समाप्त हो गया है, कृपया एक नया अनुरोध करें",
        "greater_than": "%{count} से अधिक होना चाहिए",
        "greater_than_or_equal_to": "%{count} से बड़ा या बराबर होना आवश्यक है",
        "inclusion": "सूची में शामिल नहीं है",
        "invalid": "अवैध है",
        "less_than": "%{count} से कम होना चाहिए",
        "less_than_or_equal_to": "%{count} से कम या बराबर होना आवश्यक है",
        "not_a_number": "कोई संख्या नहीं है",
        "not_an_integer": "एक पूर्णांक होना चाहिए",
        "not_found": "नहीं मिला",
        "not_locked": "लॉक नहीं था",
        "not_saved": {
          "one": "1 त्रुटि ने इस %{resource} को सहेजे जाने से रोक दिया:",
          "other": "%{count} त्रुटियों ने इस %{resource} को सहेजे जाने से प्रतिबंधित किया है:"
        },
        "odd": "विसम होना चाहिए",
        "taken": "पहले ही ले लिया गया है",
        "too_long": "अत्यधिक लंबा है (अधिकतम %{count} वर्ण हैं)",
        "too_short": "अत्यधिक छोटा है (न्यूनतम %{count} वर्ण हैं)",
        "wrong_length": "गलत लंबाई है (%{count} वर्ण युक्त होना चाहिए)"
      },
      "template": {
        "body": "निम्नलिखित क्षेत्रों के साथ समस्या थी:",
        "header": {
          "one": "इस %{model} को सहेजे जाना एक त्रुटि के कारण नहीं हुआ",
          "other": "इस %{model} को सहेजे जाना %{count} त्रुटि के कारण नहीं हुआ"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "कृपया चुनें"
      },
      "submit": {
        "create": "%{model} बनाएँ",
        "submit": "%{model} सौंपें",
        "update": "%{model} अद्यतन"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "अरब",
            "million": "दस करोड़",
            "quadrillion": "करोड़ शंख",
            "thousand": "हज़ार",
            "trillion": "खरब",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", और ",
        "two_words_connector": " और ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "पूर्वाह्न",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "अपराह्न"
    }
  },
  "hi-IN": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "सत्यापन विफल: %{errors}"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "रवि",
        "सोम",
        "मंगल",
        "बुध",
        "गुरु",
        "शुक्र",
        "शनि"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "रविवार",
        "सोमवार",
        "मंगलवार",
        "बुधवार",
        "गुरुवार",
        "शुक्रवार",
        "शनिवार"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "जनवरी",
        "फरवरी",
        "मार्च",
        "अप्रैल",
        "मई",
        "जून",
        "जुलाई",
        "अगस्त",
        "सितंबर",
        "अक्टूबर",
        "नवंबर",
        "दिसंबर"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "लग - भग एक घंटा",
          "other": "लग - भग %{count} घंटा"
        },
        "about_x_months": {
          "one": "लग - भग %{count} महीना",
          "other": "लग - भग %{count} महीना"
        },
        "about_x_years": {
          "one": "लग - भग %{count} साल",
          "other": "लग - भग %{count} साल"
        },
        "almost_x_years": {
          "one": "लग - भग एक साल",
          "other": "लग - भग %{count} साल"
        },
        "half_a_minute": "एक आधा मिनट",
        "less_than_x_minutes": {
          "one": "एक मिनट से कम",
          "other": "%{count} मिनट से कम"
        },
        "less_than_x_seconds": {
          "one": "एक सेकंड से कम",
          "other": "%{count}  सेकंड से कम"
        },
        "over_x_years": {
          "one": "एक साल के ऊपर",
          "other": "%{count} साल के ऊपर"
        },
        "x_days": {
          "one": "एक दिन",
          "other": "%{count} दिन"
        },
        "x_minutes": {
          "one": "एक मिनट",
          "other": "%{count} मिनट"
        },
        "x_months": {
          "one": "एक महीना",
          "other": "%{count} महीना"
        },
        "x_seconds": {
          "one": "एक सेकंड",
          "other": "%{count} सेकंड"
        }
      },
      "prompts": {
        "day": "दिन",
        "hour": "घंटा",
        "minute": "क्षण",
        "month": "माह",
        "second": "सेकंड",
        "year": "वर्ष"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "होना स्वीकार किया जाना आवश्यक",
        "blank": "खाली नहीं किया जा सकता",
        "confirmation": "पुष्टिकरण मेल नहीं खाता",
        "empty": "खाली नहीं किया जा सकता",
        "equal_to": "%{count} के लिए बराबर होना चाहिए",
        "even": "सम होना चाहिए",
        "exclusion": "आरक्षित है",
        "greater_than": "%{count} से अधिक होना चाहिए",
        "greater_than_or_equal_to": "%{count} से बड़ा या बराबर होना आवश्यक है",
        "inclusion": "सूची में शामिल नहीं है",
        "invalid": "अवैध है",
        "less_than": "%{count} से कम होना चाहिए",
        "less_than_or_equal_to": "%{count} से कम या बराबर होना आवश्यक है",
        "not_a_number": "कोई संख्या नहीं है",
        "not_an_integer": "एक पूर्णांक होना चाहिए",
        "odd": "विषम होना चाहिए",
        "taken": "पहले ही ले लिया गया है",
        "too_long": "बहुत लंबा है (अधिकतम %{count} अक्षरों है)",
        "too_short": "बहुत छोटा है (न्यूनतम %{count} अक्षरों है)",
        "wrong_length": "गलत लंबाई है (%{count} वर्ण वाले होने चाहिए)"
      },
      "template": {
        "body": "वहाँ निम्नलिखित क्षेत्रों के साथ समस्याओं रहे थे:",
        "header": {
          "one": "एक त्रुटि सहेजे जाने से इस %{model} को निषिद्ध",
          "other": "%{count} त्रुटियों को सहेजे जाने से इस %{model} निषिद्ध"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "कृपया चुनें"
      },
      "submit": {
        "create": "बनाएँ %{model}",
        "submit": "सहेजें %{model}",
        "update": "अद्यतन %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "अरब",
            "million": "मिल्लिओंन",
            "quadrillion": "करोड़ शंख",
            "thousand": "हज़ार",
            "trillion": "खरब",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", और ",
        "two_words_connector": " और ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "hr": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Potvrda poslana u",
          "confirmation_token": "Token za potvrdu",
          "confirmed_at": "Potvrđeno u",
          "created_at": "Stvoreno u",
          "current_password": "Trenutna lozinka",
          "current_sign_in_at": "Trenutna prijava u",
          "current_sign_in_ip": "Trenutna IP adresa",
          "email": "Email",
          "encrypted_password": "Šifrirana lozinka",
          "failed_attempts": "Neuspješni pokušaji",
          "last_sign_in_at": "Zadnja prijava u",
          "last_sign_in_ip": "Zadnja IP adresa",
          "locked_at": "Zaključano u",
          "password": "Lozinka",
          "password_confirmation": "Potvrda lozinke",
          "remember_created_at": "Zapamćeno u",
          "remember_me": "Zapamti me",
          "reset_password_sent_at": "Promjena lozinke poslana u",
          "reset_password_token": "Token za promjenu lozinke",
          "sign_in_count": "Broj prijava",
          "unconfirmed_email": "Nepotvrđeni email",
          "unlock_token": "Token za otključavanje",
          "updated_at": "Izmjenjeno"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validacija nije uspjela: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Nije moguće izbrisati zapis jer postoje ovisni %{record}",
            "has_one": "Nije moguće izbrisati zapis jer postoji ovisan %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": "Korisnika",
          "one": "Korisnik",
          "other": "Korisnika"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ned.",
        "pon.",
        "uto.",
        "sri.",
        "čet.",
        "pet.",
        "sub."
      ],
      "abbr_month_names": [
        null,
        "sij.",
        "velj.",
        "ožu.",
        "tra.",
        "svi.",
        "lip.",
        "srp.",
        "kol.",
        "ruj.",
        "lis.",
        "stu.",
        "pro."
      ],
      "day_names": [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "četvrtak",
        "petak",
        "subota"
      ],
      "formats": {
        "default": "%d.%m.%Y.",
        "long": "%e. %B %Y.",
        "short": "%e.%-m."
      },
      "month_names": [
        null,
        "siječnja",
        "veljače",
        "ožujka",
        "travnja",
        "svibnja",
        "lipnja",
        "srpnja",
        "kolovoza",
        "rujna",
        "listopada",
        "studenoga",
        "prosinca"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "oko %{count} sata",
          "many": "oko %{count} sati",
          "one": "oko %{count} sat",
          "other": "oko %{count} sati"
        },
        "about_x_months": {
          "few": "oko %{count} mjeseca",
          "many": "oko %{count} mjeseci",
          "one": "oko %{count} mjesec",
          "other": "oko %{count} mjeseci"
        },
        "about_x_years": {
          "few": "oko %{count} godine",
          "many": "oko %{count} godina",
          "one": "oko %{count} godine",
          "other": "oko %{count} godina"
        },
        "almost_x_years": {
          "few": "skoro %{count} godine",
          "many": "skoro %{count} godina",
          "one": "skoro %{count} godina",
          "other": "skoro %{count} godina"
        },
        "half_a_minute": "pola minute",
        "less_than_x_minutes": {
          "few": "manje od %{count} minute",
          "many": "manje od %{count} minuta",
          "one": "manje od %{count} minute",
          "other": "manje od %{count} minuta"
        },
        "less_than_x_seconds": {
          "few": "manje od %{count} sekunde",
          "many": "manje od %{count} sekundi",
          "one": "manje od %{count} sekunde",
          "other": "manje od %{count} sekundi"
        },
        "over_x_years": {
          "few": "preko %{count} godine",
          "many": "preko %{count} godina",
          "one": "preko %{count} godine",
          "other": "preko %{count} godina"
        },
        "x_days": {
          "few": "%{count} dana",
          "many": "%{count} dana",
          "one": "%{count} dan",
          "other": "%{count} dana"
        },
        "x_minutes": {
          "few": "%{count} minute",
          "many": "%{count} minuta",
          "one": "%{count} minuta",
          "other": "%{count} minuta"
        },
        "x_months": {
          "few": "%{count} mjeseca",
          "many": "%{count} mjeseci",
          "one": "%{count} mjesec",
          "other": "%{count} mjeseci"
        },
        "x_seconds": {
          "few": "%{count} sekunde",
          "many": "%{count} sekundi",
          "one": "%{count} sekunda",
          "other": "%{count} sekundi"
        },
        "x_years": {
          "few": "%{count} godine",
          "many": "%{count} godina",
          "one": "%{count} godina",
          "other": "%{count} godina"
        }
      },
      "prompts": {
        "day": "Dan",
        "hour": "Sat",
        "minute": "Minuta",
        "month": "Mjesec",
        "second": "Sekunde",
        "year": "Godina"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Vaš račun je uspješno potvrđen. Sad ste prijavljeni.",
        "new": {
          "resend_confirmation_instructions": "Ponovno pošalji upute za potvrdu"
        },
        "send_instructions": "U roku nekoliko minuta ćete primiti e-mail s uputama za potvrdu Vašeg računa.",
        "send_paranoid_instructions": "Ukoliko se Vaša email adresa nalazi u našoj bazi u roku od nekoliko minuta ćete primiti mail s uputama kako potvrditi Vaš račun."
      },
      "failure": {
        "already_authenticated": "Već ste prijavljeni.",
        "inactive": "Vaš račun još nije aktiviran.",
        "invalid": "Neispravan %{authentication_keys} ili lozinka.",
        "last_attempt": "Imate još jedan pokušaj prije nego Vaš račun bude zaključan.",
        "locked": "Vaš račun je zaključan.",
        "not_found_in_database": "Neispravan %{authentication_keys} ili lozinka.",
        "timeout": "Vrijeme trajanja Vaše sesije je isteklo. Za nastavak se prijavite ponovno.",
        "unauthenticated": "Za nastavak se morate prijaviti ili registrirati.",
        "unconfirmed": "Prije nastavka morate potvrditi Vaš račun."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potvrdi moj račun",
          "greeting": "Dobrodošli %{recipient}!",
          "instruction": "Možete potvrditi Vaš email kroz link ispod:",
          "subject": "Upute za potvrdu korisničkog računa"
        },
        "email_changed": {
          "greeting": "Pozdrav %{recipient}!",
          "message": "Obavještavamo Vas da je Vaš email promjenjen na %{email}.",
          "message_unconfirmed": "Obavještavamo Vas da je u toku promjena Vašeg emaila na %{email}.",
          "subject": "Email promjenjen"
        },
        "password_change": {
          "greeting": "Pozdrav %{recipient}!",
          "message": "Obavještavamo Vas da je Vaša lozinka promjenjena.",
          "subject": "Lozinka promjenjena"
        },
        "reset_password_instructions": {
          "action": "Promjeni moju lozinku",
          "greeting": "Pozdrav %{recipient}!",
          "instruction": "Netko je zatražio promjenu Vaše lozinke. Možete to napraviti koristeći link ispod.",
          "instruction_2": "Ako niste zatražili promjenu lozinke, molimo Vas da ignorirate ovaj email.",
          "instruction_3": "Vaša lozinka se neće promjeniti dok ne koristite link iznad i stvorite novu lozinku.",
          "subject": "Upute za promjenu lozinke"
        },
        "unlock_instructions": {
          "action": "Otključaj moj račun",
          "greeting": "Pozdrav %{recipient}!",
          "instruction": "Kliknite na link ispod da otključate svoj račun:",
          "message": "Vaš račun je zaključan zbog preveliko broja neuspješnih prijava.",
          "subject": "Upute za otključavanje korisničkog računa"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nismo Vas u mogućnosti autorizirati sa %{kind} računom zbog \"%{reason}\".",
        "success": "Uspješna autorizacija sa %{kind} računa."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Promjeni moju lozinku",
          "change_your_password": "Promjenite Vašu lozinku",
          "confirm_new_password": "Potvrdi novu lozinku",
          "new_password": "Nova lozinka"
        },
        "new": {
          "forgot_your_password": "Zaboravi ste lozinku?",
          "send_me_reset_password_instructions": "Pošaljite mi upute za promjenu lozinke"
        },
        "no_token": "Ne možete pristupiti ovoj stranici ako niste kliknuli na link u emailu za resetiranje lozinke.",
        "send_instructions": "U roku nekoliko minuta ćete primiti e-mail s uputama za promjenu Vaše lozinke.",
        "send_paranoid_instructions": "Ukoliko se Vaša email adresa nalazi u našoj bazi, na istu ćete u roku od nekoliko minuta primiti link za resetiranje lozinke.",
        "updated": "Vaša lozinka je uspješno promjenjena. Sad ste prijavljeni.",
        "updated_not_active": "Vaša lozinka je uspješno promijenjena."
      },
      "registrations": {
        "destroyed": "Pozdrav! Vaš račun je uspješno obrisan. Nadamo se da ćete se brzo vratiti.",
        "edit": {
          "are_you_sure": "Jeste li sigurni?",
          "cancel_my_account": "Poništi moj račun",
          "currently_waiting_confirmation_for_email": "Trenutno čekamo potvrdu za: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "ostavite prazno ako ne želite promjeniti",
          "title": "Uređivanje %{resource}",
          "unhappy": "Nezadovoljni?",
          "update": "Izmjeni",
          "we_need_your_current_password_to_confirm_your_changes": "trebamo Vašu trenutnu lozinku da potvrdimo promjene"
        },
        "new": {
          "sign_up": "Registracija"
        },
        "signed_up": "Dobrodošli! Uspješno ste se registrirali.",
        "signed_up_but_inactive": "Uspješno ste se registrirali. Doduše, ne možete se prijaviti u sustav zato što Vaš račun još nije aktiviran.",
        "signed_up_but_locked": "Uspješno ste se registrirali. Nažalost ne možete se prijaviti jer Vam je račun zaključan.",
        "signed_up_but_unconfirmed": "Poruka s linkom za potvrdu je poslana na Vašu e-mail adresu. Molimo kliknite na link da aktivirate Vaš račun.",
        "update_needs_confirmation": "Uspješno ste ažurirali Vaš račun, ali trebamo potvrditi Vašu novu e-mail adresu. Molimo provjerite svoje sanduče i kliknite na link za potvrdu.",
        "updated": "Uspješno ste izmjenili Vaš račun.",
        "updated_but_not_signed_in": "Uspješno ste izmjenili Vaš račun, ali s obzirom da ste promjenili lozinku, morate se ponovno prijaviti."
      },
      "sessions": {
        "already_signed_out": "Uspješno ste se odjavili.",
        "new": {
          "sign_in": "Prijava"
        },
        "signed_in": "Uspješno ste se prijavili.",
        "signed_out": "Uspješno ste se odjavili."
      },
      "shared": {
        "links": {
          "back": "Nazad",
          "didn_t_receive_confirmation_instructions": "Niste primili upute za potvrdu računa?",
          "didn_t_receive_unlock_instructions": "Niste primili upute za otključavanje računa?",
          "forgot_your_password": "Zaboravili ste lozinku?",
          "sign_in": "Prijava",
          "sign_in_with_provider": "Prijava preko %{provider}",
          "sign_up": "Registracija"
        },
        "minimum_password_length": {
          "few": "(najmanje %{count} znaka)",
          "one": "(najmanje %{count} znak)",
          "other": "(najmanje %{count} znakova)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Ponovno pošalji upute za otključavanje"
        },
        "send_instructions": "U roku nekoliko minuta ćete primiti e-mail s uputama za otključavanje Vašeg računa.",
        "send_paranoid_instructions": "Ako Vaš račun postoji, na email ćete u roku nekoliko minuta primiti upute kako ga otključati.",
        "unlocked": "Vaš račun je uspješno otključan. Molimo prijavite se."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "mora biti prihvaćen",
        "already_confirmed": "je već potvrđen, molimo pokušajte se prijaviti",
        "blank": "ne smije biti prazan",
        "confirmation": "se ne slaže sa svojom potvrdom",
        "confirmation_period_expired": "je trebao biti potvrđen tijekom perioda %{period}, molimo tražite novi",
        "empty": "ne smije biti prazan",
        "equal_to": "mora biti jednak %{count}",
        "even": "mora biti paran",
        "exclusion": "je rezerviran",
        "expired": "je istekao, molimo zatražite novi",
        "greater_than": "mora biti veći od %{count}",
        "greater_than_or_equal_to": "mora biti veći ili jednak %{count}",
        "inclusion": "nije u listi",
        "invalid": "nije ispravan",
        "less_than": "mora biti manji od %{count}",
        "less_than_or_equal_to": "mora biti manji ili jednak %{count}",
        "model_invalid": "Validacija nije uspjela: %{errors}",
        "not_a_number": "nije broj",
        "not_an_integer": "nije cijeli broj",
        "not_found": "nije pronađeno",
        "not_locked": "nije zaključan",
        "not_saved": {
          "few": "%{count} greške sprečavaju snimanje %{resource}:",
          "one": "1 greška sprečava snimanje %{resource}:",
          "other": "%{count} grešaka sprečavaju snimanje %{resource}:"
        },
        "odd": "mora biti neparan",
        "other_than": "mora biti različit od %{count}",
        "present": "mora biti prazan",
        "required": "mora biti unesen",
        "taken": "je već zauzet",
        "too_long": {
          "few": "je predugačak (maksimum je %{count} znaka)",
          "many": "je predugačak (maksimum je %{count} znakova)",
          "one": "je predugačak (maksimum je %{count} znak)",
          "other": "je predugačak (maksimum je %{count} znakova)"
        },
        "too_short": {
          "few": "je prekratak (minimum je %{count} znaka)",
          "many": "je prekratak (minimum je %{count} znakova)",
          "one": "je prekratak (minimum je %{count} znak)",
          "other": "je prekratak (minimum je %{count} znakova)"
        },
        "wrong_length": {
          "few": "nije odgovarajuće duljine (treba biti %{count} znaka)",
          "many": "nije odgovarajuće duljine (treba biti %{count} znakova)",
          "one": "nije odgovarajuće duljine (treba biti %{count} znak)",
          "other": "nije odgovarajuće duljine (treba biti %{count} znakova)"
        }
      },
      "template": {
        "body": "Sljedeća polja su neispravno popunjena:",
        "header": {
          "few": "%{count} greške su spriječile da se spremi %{model}",
          "many": "%{count} grešaka je spriječilo da se spremi %{model}",
          "one": "%{count} greška je spriječila da se spremi %{model}",
          "other": "%{count} grešaka je spriječilo da se spremi %{model}"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Izaberite"
      },
      "submit": {
        "create": "Stvori %{model}",
        "submit": "Spremi %{model}",
        "update": "Izmijeni %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "kn"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "milijarde",
              "many": "milijardi",
              "one": "milijarda",
              "other": "milijardi"
            },
            "million": {
              "few": "milijuna",
              "many": "milijuna",
              "one": "milijun",
              "other": "milijuna"
            },
            "quadrillion": {
              "few": "bilijarde",
              "many": "bilijardi",
              "one": "bilijarda",
              "other": "bilijardi"
            },
            "thousand": {
              "few": "tisuće",
              "many": "tisuća",
              "one": "tisuća",
              "other": "tisuća"
            },
            "trillion": {
              "few": "bilijuna",
              "many": "bilijuna",
              "one": "bilijun",
              "other": "bilijuna"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "bajta",
              "many": "bajtova",
              "one": "bajt",
              "other": "bajtova"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " i ",
        "two_words_connector": " i ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "AM",
      "formats": {
        "default": "%d.%m.%Y. %H:%M:%S",
        "long": "%e. %B %Y. %H:%M",
        "short": "%e.%-m. %k:%M"
      },
      "pm": "PM"
    }
  },
  "hsb": {
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "two",
          "few",
          "other"
        ]
      }
    }
  },
  "hu": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "Jelenlegi jelszó",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "E-mail",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "Jelszó",
          "password_confirmation": "Jelszó megerősítése",
          "remember_created_at": null,
          "remember_me": "Megjegyez",
          "reset_password_sent_at": null,
          "reset_password_token": null,
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": null,
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Sikertelen validálás %{errors}"
        }
      },
      "models": {
        "user": {
          "one": "Felhasználó",
          "other": "Felhasználó"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "v.",
        "h.",
        "k.",
        "sze.",
        "cs.",
        "p.",
        "szo."
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "febr.",
        "márc.",
        "ápr.",
        "máj.",
        "jún.",
        "júl.",
        "aug.",
        "szept.",
        "okt.",
        "nov.",
        "dec."
      ],
      "day_names": [
        "vasárnap",
        "hétfő",
        "kedd",
        "szerda",
        "csütörtök",
        "péntek",
        "szombat"
      ],
      "formats": {
        "default": "%Y.%m.%d.",
        "long": "%Y. %B %e.",
        "short": "%b %e."
      },
      "month_names": [
        null,
        "január",
        "február",
        "március",
        "április",
        "május",
        "június",
        "július",
        "augusztus",
        "szeptember",
        "október",
        "november",
        "december"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "kb. %{count} órája",
          "other": "kb. %{count} órája"
        },
        "about_x_months": {
          "one": "kb. %{count} hónapja",
          "other": "kb. %{count} hónapja"
        },
        "about_x_years": {
          "one": "kb. %{count} éve",
          "other": "kb. %{count} éve"
        },
        "almost_x_years": {
          "one": "majdnem %{count} éve",
          "other": "majdnem %{count} éve"
        },
        "half_a_minute": "fél perce",
        "less_than_x_minutes": {
          "one": "kevesebb, mint %{count} perce",
          "other": "kevesebb, mint %{count} perce"
        },
        "less_than_x_seconds": {
          "one": "kevesebb, mint %{count} másodperce",
          "other": "kevesebb, mint %{count} másodperce"
        },
        "over_x_years": {
          "one": "több, mint %{count} éve",
          "other": "több, mint %{count} éve"
        },
        "x_days": {
          "one": "%{count} napja",
          "other": "%{count} napja"
        },
        "x_minutes": {
          "one": "%{count} perce",
          "other": "%{count} perce"
        },
        "x_months": {
          "one": "%{count} hónapja",
          "other": "%{count} hónapja"
        },
        "x_seconds": {
          "one": "%{count} másodperce",
          "other": "%{count} másodperce"
        }
      },
      "prompts": {
        "day": "Nap",
        "hour": "Óra",
        "minute": "Perc",
        "month": "Hónap",
        "second": "Másodperc",
        "year": "Év"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Fiók megerősítve. Bejelentkezve a felhasználói fiókba.",
        "new": {
          "resend_confirmation_instructions": "Megerősítő levél újraküldése"
        },
        "send_instructions": "A megadott címre egy email érkezik a megerősítő linkkel.",
        "send_paranoid_instructions": "Ha az email cím már létezik az adatbázisban, egy emailt küldtünk a további teendőkkel a fiók megerősítéséhez."
      },
      "failure": {
        "already_authenticated": "Már belépett.",
        "inactive": "A fiók még nincs aktiválva.",
        "invalid": null,
        "last_attempt": "Már csak egy próbálkozási lehetőség maradt, mielőtt a fiók zárolásra kerül.",
        "locked": "A fiók zárolva lett.",
        "not_found_in_database": null,
        "timeout": "A munkafolyamat lejárt. Újboli bejelentkezés szükséges.",
        "unauthenticated": "A folytatáshoz bejelentkezés szükséges.",
        "unconfirmed": "A folytatáshoz az email cím megerősítése szükséges."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Fiók megerősítése",
          "greeting": "Kedves %{recipient}!",
          "instruction": "A fiók megerősítéséhez rá kell kattintani az alábbi linkre:",
          "subject": "Email cím megerősítés"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": null,
          "message": null,
          "subject": null
        },
        "reset_password_instructions": {
          "action": "Jelszó megváltoztatása",
          "greeting": "Kedves %{recipient}!",
          "instruction": "Ön, vagy valaki más az ön nevében jelszóváltoztatást kérvényezett, mely a lenti linkre kattintva lehetséges.",
          "instruction_2": "Amennyiben ön nem kezdeményezte a jelszavának megváltoztatását, kérem hagyja figyelmen kívül ezt a levelet.",
          "instruction_3": "Amennyiben nem kattint az alábbi linkre, jelszava továbbra is ugyanaz marad, mint eddig.",
          "subject": "Jelszó megváltoztatása"
        },
        "unlock_instructions": {
          "action": "Zárolás feloldása",
          "greeting": "Kedves %{recipient}!",
          "instruction": "A zárolás feloldásához az alábbi linkre kell kattintani:",
          "message": "A felhasználói fiókja zárolva lett túl sok sikertelen belépési kísérlet miatt.",
          "subject": "Fiók zárolásának megszüntetése"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nem sikerült azonosítani %{kind} fiókkal, az ok: \"%{reason}\".",
        "success": "Sikeres azonosítás %{kind} fiókkal."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Jelszó megváltoztatása",
          "change_your_password": "Jelszó megváltoztatása",
          "confirm_new_password": "Jelszó megerősítése",
          "new_password": "Új jelszó"
        },
        "new": {
          "forgot_your_password": "Elfelejtette a jelszavát?",
          "send_me_reset_password_instructions": "Jelszóviszaállítási teendők küldése"
        },
        "no_token": "Ezt az oldalt csak a jelszóváltoztató e-mailben küldött linkre kattintva lehet elérni, és ellenőrizni kell, hogy a címsorban az e-mailben található teljes webcím szerepel-e.",
        "send_instructions": "A megadott címre egy email érkezik hamarosan a további teendőkről.",
        "send_paranoid_instructions": "Ha az email cím már létezik az adatbázisban, egy jelszó-visszaállító emailt küldtünk a megadott címre.",
        "updated": "A jelszó megváltozott. Bejelentkezve a felhasználói fiókba",
        "updated_not_active": "A jelszó megváltozott"
      },
      "registrations": {
        "destroyed": "Felhasználói fiók törölve. Reméljük, még visszatér hozzánk.",
        "edit": {
          "are_you_sure": "Biztos benne?",
          "cancel_my_account": "Fiók megszüntetése",
          "currently_waiting_confirmation_for_email": "Még várjuk a következő e-mail cím megerősítését: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "csak változás esetén kitöltendő",
          "title": "%{resource} módosítása",
          "unhappy": "Szomorú",
          "update": "Módosítás",
          "we_need_your_current_password_to_confirm_your_changes": "a változtatás végrehajtásához szükséges a jelenlegi jelszó"
        },
        "new": {
          "sign_up": "Regisztráció"
        },
        "signed_up": "Sikeres regisztráció.",
        "signed_up_but_inactive": "A regisztráció sikerült, azonban a bejelentkezés még nem lehetséges, mert a fiók nincs aktiválva.",
        "signed_up_but_locked": "A regisztráció sikerült, azonban a bejelentkezés még nem lehetséges, mert a fiók zárolt.",
        "signed_up_but_unconfirmed": "Egy megerősítő linket küldtünk a megadott e-mail címre. Nézze meg az e-mailjeit, és kattintson a küldött linkre a fiók aktiválásához.",
        "update_needs_confirmation": "A fiók módosítása sikeres, de meg kell erősíteni az e-mail címet. Nézze meg az e-mailjeit, és kattintson a küldött linkre hogy megerősítse az e-mail cím létezését.",
        "updated": "Sikeres fiók módosítás.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "A kijelentkezés már megtörtént.",
        "new": {
          "sign_in": "Belépés"
        },
        "signed_in": "Sikeres bejelentkezés.",
        "signed_out": "A kijelentkezés sikeres."
      },
      "shared": {
        "links": {
          "back": "Vissza",
          "didn_t_receive_confirmation_instructions": "Nem kapta meg a megerősítő levelet?",
          "didn_t_receive_unlock_instructions": "Nem kapta meg a feloldáshoz a levelet?",
          "forgot_your_password": "Elfelejtette a jelszavát?",
          "sign_in": "Belépés",
          "sign_in_with_provider": "%{provider} belépés",
          "sign_up": "Regisztráció"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Feloldási teendők újraküldése"
        },
        "send_instructions": "Hamarosan a megadott címre érkezik egy email a fiók zárolásának megszüntetésével kapcsolatban.",
        "send_paranoid_instructions": "Ha a fiók létezik, egy emailt küldtünk a további teendőkkel a fiók zárolásának megszüntetéséhez.",
        "unlocked": "A felhasználói fiók zárolása megszűnt. Bejelentkezve a felhasználói fiókba."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "nincs elfogadva",
        "already_confirmed": "már meg van erősítve",
        "blank": "nincs megadva",
        "confirmation": "nem egyezik",
        "confirmation_period_expired": "%{period} letelte előtt kell megerősíteni, igényelj egy újat",
        "empty": "nincs megadva",
        "equal_to": "pontosan %{count} kell legyen",
        "even": "páros kell legyen",
        "exclusion": "nem elérhető",
        "expired": "lejárt, igényelj egy újat",
        "greater_than": "nagyobb kell legyen, mint %{count}",
        "greater_than_or_equal_to": "legalább %{count} kell legyen",
        "inclusion": "nincs a listában",
        "invalid": "nem megfelelő",
        "less_than": "kevesebb, mint %{count} kell legyen",
        "less_than_or_equal_to": "legfeljebb %{count} lehet",
        "not_a_number": "nem szám",
        "not_an_integer": "egész számnak kell lennie",
        "not_found": "nem található",
        "not_locked": "nincs zárolva",
        "not_saved": {
          "one": "1 hiba miatt %{resource} mentése nem lehetséges:",
          "other": "%{count} hiba miatt %{resource} mentése nem lehetséges:"
        },
        "odd": "páratlan kell legyen",
        "taken": "már foglalt",
        "too_long": "túl hosszú (nem lehet több %{count} karakternél)",
        "too_short": "túl rövid (legalább %{count} karakter kell legyen)",
        "wrong_length": "nem megfelelő hosszúságú (%{count} karakter szükséges)"
      },
      "template": {
        "body": "Problémás mezők:",
        "header": {
          "one": "%{count} hiba miatt nem menthető a következő: %{model}",
          "other": "%{count} hiba miatt nem menthető a következő: %{model}"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Válasszon"
      },
      "submit": {
        "create": "Új %{model}",
        "submit": "%{model} mentése",
        "update": "%{model} módosítása"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "Á": "A",
          "É": "E",
          "Í": "I",
          "Ó": "O",
          "Ö": "O",
          "Ú": "U",
          "Ü": "U",
          "á": "a",
          "é": "e",
          "í": "i",
          "ó": "o",
          "ö": "o",
          "ú": "u",
          "ü": "u",
          "Ő": "O",
          "ő": "o",
          "Ű": "U",
          "ű": "u"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": "",
          "format": "%n %u",
          "precision": 0,
          "separator": ",",
          "significant": true,
          "strip_insignificant_zeros": true,
          "unit": "Ft"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 2,
        "separator": ",",
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliárd",
            "million": "millió",
            "quadrillion": "billiárd",
            "thousand": "ezer",
            "trillion": "billió",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "bájt",
              "other": "bájt"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " és ",
        "two_words_connector": " és ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "de.",
      "formats": {
        "default": "%Y. %b %e., %H:%M",
        "long": "%Y. %B %e., %A, %H:%M",
        "short": "%b %e., %H:%M"
      },
      "pm": "du."
    }
  },
  "hy": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Ստուգումը ձախողվեց. %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Հնարավոր չէ ջնջել գրառումը, քանի որ կան կախյալ %{record}-ներ",
            "has_one": "Հնարավոր չէ ջնջել գրառումը, քանի որ կա կախյալ %{record}"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Կիր",
        "Երկ",
        "Երք",
        "Չոր",
        "Հնգ",
        "Ուրբ",
        "Շաբ"
      ],
      "abbr_month_names": [
        null,
        "Հուն",
        "Փետ",
        "Մար",
        "Ապր",
        "Մայ",
        "Հուն",
        "Հուլ",
        "Օգս",
        "Սեպ",
        "Հոկ",
        "Նոյ",
        "Դեկ"
      ],
      "day_names": [
        "Կիրակի",
        "Երկուշաբթի",
        "Երեքշաբթի",
        "Չորեքշաբթի",
        "Հինգշաբթի",
        "Ուրբաթ",
        "Շաբաթ"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %e, %Y",
        "short": "%b %e"
      },
      "month_names": [
        null,
        "Հունվար",
        "Փետրվար",
        "Մարտ",
        "Ապրիլ",
        "Մայիս",
        "Հունիս",
        "Հուլիս",
        "Օգոստոս",
        "Սեպտեմբեր",
        "Հոկտեմբեր",
        "Նոյեմբեր",
        "Դեկտեմբեր"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "մոտ %{count} ժամ",
          "other": "մոտ %{count} ժամ"
        },
        "about_x_months": {
          "one": "մոտ %{count} ամիս",
          "other": "մոտ %{count} ամիս"
        },
        "about_x_years": {
          "one": "մոտ %{count} տարի",
          "other": "մոտ %{count} տարի"
        },
        "almost_x_years": {
          "one": "գրեթե %{count} տարի",
          "other": "գրեթե %{count} տարի"
        },
        "half_a_minute": "կես րոպե",
        "less_than_x_minutes": {
          "one": "քիչ քան մեկ րոպե",
          "other": "քիչ քան %{count} րոպե"
        },
        "less_than_x_seconds": {
          "one": "քիչ քան %{count} վայրկյան",
          "other": "քիչ քան %{count} վայրկյան"
        },
        "over_x_years": {
          "one": "ավելի քան %{count} տարի",
          "other": "ավելի քան %{count} տարի"
        },
        "x_days": {
          "one": "%{count} օր",
          "other": "%{count} օր"
        },
        "x_minutes": {
          "one": "%{count} րոպե",
          "other": "%{count} րոպե"
        },
        "x_months": {
          "one": "%{count} ամիս",
          "other": "%{count} ամիս"
        },
        "x_seconds": {
          "one": "%{count} վայրկյան",
          "other": "%{count} վայրկյան"
        },
        "x_years": {
          "one": "%{count} տարի",
          "other": "%{count} տարի"
        }
      },
      "prompts": {
        "day": "Օր",
        "hour": "Ժամ",
        "minute": "Րոպե",
        "month": "Ամիս",
        "second": "Վայրկյաններ",
        "year": "Տարի"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "պետք է ընդունված լինի",
        "blank": "չի կարող դատարկ լինել",
        "confirmation": "չի համընկնում %{attribute}-ի հետ",
        "empty": "չի կարող դատարկ լինել",
        "equal_to": "պետք է հավասար լինի %{count}-ին",
        "even": "պետք է զույգ լինի",
        "exclusion": "արգելված է",
        "greater_than": "պետք է մեծ լինի %{count}-ից",
        "greater_than_or_equal_to": "պետք է մեծ կամ հավասար լինի %{count}-ին",
        "in": "պետք է լինի հետևյալներից. %{count}",
        "inclusion": "ներառված չէ ցանկում",
        "invalid": "անվավեր է",
        "less_than": "պետք է փոքր լինի %{count}-ից",
        "less_than_or_equal_to": "պետք է փոքր կամ հավասար լինի %{count}-ին",
        "model_invalid": "Ստուգումը ձախողվեց. %{errors}",
        "not_a_number": "թիվ չէ",
        "not_an_integer": "պետք է ամբողջ թիվ լինի",
        "odd": "պետք է կենտ լինի",
        "other_than": "պետք է տարբեր լինի %{count}-ից",
        "password_too_long": "չափազանց երկար է",
        "present": "պետք է դատարկ լինի",
        "required": "պարտադիր է",
        "taken": "արդեն գոյություն ունի",
        "too_long": {
          "one": "չափազանց երկար է (առավելագույնը %{count} նիշ)",
          "other": "չափազանց երկար է (առավելագույնը %{count} նիշ)"
        },
        "too_short": {
          "one": "չափազանց կարճ է (նվազագույնը %{count} նիշ)",
          "other": "չափազանց կարճ է (նվազագույնը %{count} նիշ)"
        },
        "wrong_length": {
          "one": "սխալ երկարություն է (պետք է լինի %{count} նիշ)",
          "other": "սխալ երկարություն է (պետք է լինի %{count} նիշ)"
        }
      },
      "template": {
        "body": "Հետևյալ դաշտերում խնդիրներ կան.",
        "header": {
          "one": "%{count} սխալ արգելեց այս %{model}-ի պահպանումը",
          "other": "%{count} սխալներ արգելեցին այս %{model}-ի պահպանումը"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#",
          "##",
          "###"
        ],
        "city": [
          "Աբովյան",
          "Ագարակ",
          "Ալավերդի",
          "Ախթալա",
          "Այրում",
          "Աշտարակ",
          "Ապարան",
          "Արարատ",
          "Արթիկ",
          "Արմավիր",
          "Արտաշատ",
          "Բերդ",
          "Բյուրեղավան",
          "Գավառ",
          "Գյումրի",
          "Գորիս",
          "Դաստակերտ",
          "Դիլիջան",
          "Եղեգնաձոր",
          "Եղվարդ",
          "Երևան",
          "Վաղարշապատ",
          "Թալին",
          "Թումանյան",
          "Իջևան",
          "Ծաղկաձոր",
          "Կապան",
          "Հրազդան",
          "Ճամբարակ",
          "Մասիս",
          "Մարալիկ",
          "Մարտունի",
          "Մեծամոր",
          "Մեղրի",
          "Նոր Հաճն",
          "Նոյեմբերյան",
          "Շամլուղ",
          "Չարենցավան",
          "Ջերմուկ",
          "Սիսիան",
          "Սպիտակ",
          "Ստեփանավան",
          "Սևան",
          "Վայք",
          "Վանաձոր",
          "Վարդենիս",
          "Վեդի",
          "Տաշիր",
          "Քաջարան"
        ],
        "city_prefix": [
          "ք."
        ],
        "city_with_state": [
          "#{city}, #{state}ի մարզ"
        ],
        "community": [
          "Աջափնյակ",
          "Ավան",
          "Արաբկիր",
          "Դավիթաշեն",
          "Էրեբունի",
          "Կենտրոն",
          "Մալաթիա-Սեբաստիա",
          "Նոր Նորք",
          "Նորք-Մարաշ",
          "Նուբարաշեն",
          "Շենգավիթ",
          "Քանաքեռ-Զեյթուն",
          "Ապարան",
          "Ալագյազ",
          "Արագածավան",
          "Ծաղկահովիտ",
          "Ճամբարակ",
          "Վարդենիս",
          "Մասրիկ",
          "Շողակաթ",
          "Ալավերդի",
          "Ախթալա",
          "Ստեփանավան",
          "Տաշիր",
          "Գյուլագարակ",
          "Բերդ",
          "Մեծավան",
          "Շնող",
          "Սարչապետ",
          "Օձուն",
          "Բյուրեղավան",
          "Եղվարդ",
          "Չարենցավան",
          "Ակունք",
          "Մեղրաձոր",
          "Ջրվեժ",
          "Անի",
          "Ախուրյան",
          "Մարմաշեն",
          "Կապան",
          "Սիսիան",
          "Քաջարան",
          "Արենի",
          "Գլաձոր",
          "Եղեգիս",
          "Բերդ"
        ],
        "country": [
          "Աֆղանստան",
          "Ալբանիա",
          "Ալժիր",
          "Ամերիկյան Սամոա",
          "Անդորրա",
          "Անգոլա",
          "Անգիլիա",
          "Անտարկտիկա",
          "Անտիգուա և Բարբուդա",
          "Արգենտինա",
          "Հայաստան",
          "Արուբա",
          "Ավստրալիա",
          "Ավստրիա",
          "Ադրբեջան",
          "Բահամներ",
          "Բահրեյն",
          "Բանգլադեշ",
          "Բարբադոս",
          "Բելառուս",
          "Բելգիա",
          "Բելիզ",
          "Բենին",
          "Բերմուդա",
          "Բութան",
          "Բոլիվիա",
          "Բոսնիա և Հերցեգովինա",
          "Բոտսվանա",
          "Բրազիլիա",
          "Բրունեյ Դարուսսալամ",
          "Բուլղարիա",
          "Բուրկինա Ֆասո",
          "Բուրունդի",
          "Կամբոջա",
          "Կամերուն",
          "Կանադա",
          "Կաբո Վերդե",
          "Կայման Կղզիներ",
          "Կենտրոնական Աֆրիկյան Հանրապետություն",
          "Չադ",
          "Չիլի",
          "Չինաստան",
          "Սուրբ Ծննդյան Կղզի",
          "Կոկոս Կղզիներ",
          "Կոլումբիա",
          "Կոմորյան Կղզիներ",
          "Կոնգո",
          "Կուկի Կղզիներ",
          "Կոստա Ռիկա",
          "Կոտ դ'Իվուար",
          "Խորվաթիա",
          "Կուբա",
          "Կիպրոս",
          "Չեխիայի Հանրապետություն",
          "Դանիա",
          "Ջիբութի",
          "Դոմինիկա",
          "Դոմինիկյան Հանրապետություն",
          "Էկվադոր",
          "Եգիպտոս",
          "Սալվադոր",
          "Հասարակածային Գվինեա",
          "Էրիտրեա",
          "Էստոնիա",
          "Եթովպիա",
          "Ֆարերյան Կղզիներ",
          "Ֆոլկլենդյան Կղզիներ",
          "Ֆիջի",
          "Ֆինլանդիա",
          "Ֆրանսիա",
          "Ֆրանսիական Գվիանա",
          "Ֆրանսիական Պոլինեզիա",
          "Ֆրանսիական Հարավային Տարածքներ",
          "Գաբոն",
          "Գամբիա",
          "Վրաստան",
          "Գերմանիա",
          "Գանա",
          "Ջիբրալթար",
          "Հունաստան",
          "Գրենլանդիա",
          "Գրենադա",
          "Գվադելուպա",
          "Գուամ",
          "Գվատեմալա",
          "Գերնսի",
          "Գվինեա",
          "Գվինեա Բիսաու",
          "Գայանա",
          "Հաիթի",
          "Վատիկան",
          "Հոնդուրաս",
          "Հոնգ Կոնգ",
          "Հունգարիա",
          "Իսլանդիա",
          "Հնդկաստան",
          "Ինդոնեզիա",
          "Իրան",
          "Իրաք",
          "Իռլանիա",
          "Իսրայել",
          "Իտալիա",
          "Ջամայկա",
          "Ճապոնիա",
          "Հորդանան",
          "Ղազախստան",
          "Քենիա",
          "Կիրիբատի",
          "Հյուսիսային Կորեա",
          "Հարավային Կորեա",
          "Կոսովո",
          "Քուվեյթ",
          "Ղրղզստան",
          "Լաոս",
          "Լատվիա",
          "Լիբանան",
          "Լեսոտո",
          "Լիբերիա",
          "Լիբիական Արաբական Ջամահիրիա",
          "Լիխտենշտեյն",
          "Լիտվա",
          "Լյուքսեմբուրգ",
          "Մակաո",
          "Մակեդոնիա",
          "Մադագասկար",
          "Մալավի",
          "Մալազիա",
          "Մալդիվներ",
          "Մալի",
          "Մալթա",
          "Մարշալյան Կղզիներ",
          "Մարտինիկ",
          "Մավրիտանիա",
          "Մավրիկիոս",
          "Մայոտտե",
          "Մեքսիկա",
          "Միկրոնեզիա",
          "Մոլդովա",
          "Մոնակո",
          "Մոնղոլիա",
          "Չեռնոգորիա",
          "Մոնսերատ",
          "Մարոկկո",
          "Մոզամբիկ",
          "Մյանմա",
          "Նամիբիա",
          "Նաուրու",
          "Նեպալ",
          "Նիդեռլանդական Անտիլներ",
          "Նիդերլանդներ",
          "Նոր Կալեդոնիա",
          "Նոր Զելանդիա",
          "Նիկարագուա",
          "Նիգեր",
          "Նիգերիա",
          "Նիուե",
          "Նորֆոլկ Կղզի",
          "Հյուսիսային Մարիանյան Կղզիներ",
          "Նորվեգիա",
          "Օման",
          "Պակիստան",
          "Պալաու",
          "Պաղեստին",
          "Պանամա",
          "Պապուա Նոր Գվինեա",
          "Պարագվայ",
          "Պերու",
          "Ֆիլիպիններ",
          "Պիտկիրնյան Կղզիներ",
          "Լեհաստան",
          "Պորտուգալիա",
          "Պուերտո Ռիկո",
          "Կատար",
          "Ռումինիա",
          "Ռուսաստանի Դաշնություն",
          "Ռուանդա",
          "Սուրբ Բարդուղիմեոս",
          "Սուրբ Հելենա",
          "Սենտ Կիտս և Նևիս",
          "Սուրբ Լուչիա",
          "Սուրբ Մարտին",
          "Սեն Պիեռ և Միկելոն",
          "Սենթ Վինսենթ և Գրենադիններ",
          "Սամոա",
          "Սան Մարինո",
          "Սաուդյան Արաբիա",
          "Սենեգալ",
          "Սերբիա",
          "Սեյշելներ",
          "Սիերա Լեոնե",
          "Սինգապուր",
          "Սլովակիա",
          "Սլովենիա",
          "Սողոմոնյան Կղզիներ",
          "Սոմալի",
          "Հարավային Աֆրիկա",
          "Իսպանիա",
          "Շրի Լանկա",
          "Սուդան",
          "Սուրինամ",
          "Սվալբարդ և Յան Մայենյան Կղզիներ",
          "Սվազիլենդ",
          "Շվեդիա",
          "Շվեյցարիա",
          "Սիրիայի Արաբական Հանրապետություն",
          "Թայվան",
          "Տաջիկստան",
          "Տանզանիա",
          "Թաիլանդ",
          "Տոգո",
          "Տոկելաու",
          "Տոնգա",
          "Տրինիդադ և Տոբագո",
          "Թունիս",
          "Թուրքիա",
          "Թուրքմենստան",
          "Տուվալու",
          "Ուգանդա",
          "Ուկրաինա",
          "Արաբական Միացյալ Էմիրություններ",
          "Մեծ Բրիտանիա",
          "Ամերիկայի Միացյալ Նահանգներ",
          "Ուրուգվայ",
          "Ուզբեկստան",
          "Վենեսուելա",
          "Վիետնամ",
          "Ուոլիս և Ֆուտունա",
          "Արևմտյան Սահարա",
          "Եմեն",
          "Զամբիա",
          "Զիմբաբվե"
        ],
        "country_by_code": {
          "AD": "Անդորրա",
          "AE": "Արաբական Միացյալ Էմիրություններ",
          "AF": "Աֆղանստան",
          "AG": "Անտիգուա և Բարբուդա",
          "AI": "Անգիլիա",
          "AL": "Ալբանիա",
          "AM": "Հայաստան",
          "AN": "Նիդեռլանդական Անտիլներ",
          "AO": "Անգոլա",
          "AQ": "Անտարկտիկա",
          "AR": "Արգենտինա",
          "AS": "Ամերիկյան Սամոա",
          "AT": "Ավստրիա",
          "AU": "Ավստրալիա",
          "AW": "Արուբա",
          "AZ": "Ադրբեջան",
          "BA": "Բոսնիա և Հերցեգովինա",
          "BB": "Բարբադոս",
          "BD": "Բանգլադեշ",
          "BE": "Բելգիա",
          "BF": "Բուրկինա Ֆասո",
          "BG": "Բուլղարիա",
          "BH": "Բահրեյն",
          "BI": "Բուրունդի",
          "BJ": "Բենին",
          "BM": "Բերմուդա",
          "BN": "Բրունեյ Դարուսսալամ",
          "BO": "Բոլիվիա",
          "BR": "Բրազիլիա",
          "BS": "Բահամներ",
          "BT": "Բութան",
          "BW": "Բոտսվանա",
          "BY": "Բելառուս",
          "BZ": "Բելիզ",
          "CA": "Կանադա",
          "CC": "Կոկոս Կղզիներ",
          "CF": "Կենտրոնական Աֆրիկյան Հանրապետություն",
          "CG": "Կոնգո",
          "CH": "Շվեյցարիա",
          "CI": "Կոտ դ'Իվուար",
          "CK": "Կուկի Կղզիներ",
          "CL": "Չիլի",
          "CM": "Կամերուն",
          "CN": "Չինաստան",
          "CO": "Կոլումբիա",
          "CR": "Կոստա Ռիկա",
          "CU": "Կուբա",
          "CV": "Կաբո Վերդե",
          "CX": "Սուրբ Ծննդյան Կղզի",
          "CY": "Կիպրոս",
          "CZ": "Չեխիայի Հանրապետություն",
          "DE": "Գերմանիա",
          "DJ": "Ջիբութի",
          "DK": "Դանիա",
          "DM": "Դոմինիկա",
          "DO": "Դոմինիկյան Հանրապետություն",
          "DZ": "Ալժիր",
          "EC": "Էկվադոր",
          "EE": "Էստոնիա",
          "EG": "Եգիպտոս",
          "EH": "Արևմտյան Սահարա",
          "ER": "Էրիտրեա",
          "ES": "Իսպանիա",
          "ET": "Եթովպիա",
          "FI": "Ֆինլանդիա",
          "FJ": "Ֆիջի",
          "FK": "Ֆարերյան Կղզիներ",
          "FM": "Միկրոնեզիա",
          "FO": "Ֆոլկլենդյան Կղզիներ",
          "FR": "Ֆրանսիա",
          "GA": "Գաբոն",
          "GB": "Մեծ Բրիտանիա",
          "GD": "Գրենադա",
          "GE": "Վրաստան",
          "GF": "Ֆրանսիական Գվիանա",
          "GH": "Գանա",
          "GI": "Ջիբրալթար",
          "GL": "Գրենլանդիա",
          "GM": "Գամբիա",
          "GN": "Գվինեա",
          "GP": "Գվադելուպա",
          "GQ": "Հասարակածային Գվինեա",
          "GR": "Հունաստան",
          "GT": "Գվատեմալա",
          "GU": "Գուամ",
          "GW": "Գվինեա Բիսաու",
          "GY": "Գայանա",
          "HK": "Հոնգ Կոնգ",
          "HN": "Հոնդուրաս",
          "HR": "Խորվաթիա",
          "HT": "Հաիթի",
          "HU": "Հունգարիա",
          "ID": "Ինդոնեզիա",
          "IE": "Իռլանիա",
          "IL": "Իսրայել",
          "IN": "Հնդկաստան",
          "IQ": "Իրաք",
          "IR": "Իրան",
          "IS": "Իսլանդիա",
          "IT": "Իտալիա",
          "JM": "Ջամայկա",
          "JO": "Հորդանան",
          "JP": "Ճապոնիա",
          "KE": "Քենիա",
          "KG": "Ղրղզստան",
          "KH": "Կամբոջա",
          "KI": "Կիրիբատի",
          "KM": "Կոմորյան Կղզիներ",
          "KN": "Սենտ Կիտս և Նևիս",
          "KP": "Հյուսիսային Կորեա",
          "KR": "Հարավային Կորեա",
          "KV": "Կոսովո",
          "KW": "Քուվեյթ",
          "KY": "Կայման Կղզիներ",
          "KZ": "Ղազախստան",
          "LA": "Լաոս",
          "LB": "Լիբանան",
          "LC": "Սուրբ Լուչիա",
          "LI": "Լիխտենշտեյն",
          "LK": "Շրի Լանկա",
          "LR": "Լիբերիա",
          "LS": "Լեսոտո",
          "LT": "Լիտվա",
          "LU": "Լյուքսեմբուրգ",
          "LV": "Լատվիա",
          "LY": "Լիբիական Արաբական Ջամահիրիա",
          "MA": "Մարոկկո",
          "MC": "Մոնակո",
          "MD": "Մոլդովա",
          "ME": "Չեռնոգորիա",
          "MG": "Մադագասկար",
          "MH": "Մարշալյան Կղզիներ",
          "MK": "Մակեդոնիա",
          "ML": "Մալի",
          "MM": "Մյանմա",
          "MN": "Մոնղոլիա",
          "MO": "Մակաո",
          "MP": "Հյուսիսային Մարիանյան Կղզիներ",
          "MQ": "Մարտինիկ",
          "MR": "Մավրիտանիա",
          "MS": "Մոնսերատ",
          "MT": "Մալթա",
          "MU": "Մավրիկիոս",
          "MV": "Մալդիվներ",
          "MW": "Մալավի",
          "MX": "Մեքսիկա",
          "MY": "Մալազիա",
          "MZ": "Մոզամբիկ",
          "NA": "Նամիբիա",
          "NC": "Նոր Կալեդոնիա",
          "NE": "Նիգեր",
          "NF": "Նորֆոլկ Կղզի",
          "NG": "Նիգերիա",
          "NI": "Նիկարագուա",
          "NL": "Նիդերլանդներ",
          "NO": "Նորվեգիա",
          "NP": "Նեպալ",
          "NR": "Նաուրու",
          "NU": "Նիուե",
          "NZ": "Նոր Զելանդիա",
          "OM": "Օման",
          "PA": "Պանամա",
          "PE": "Պերու",
          "PF": "Ֆրանսիական Պոլինեզիա",
          "PG": "Պապուա Նոր Գվինեա",
          "PH": "Ֆիլիպիններ",
          "PK": "Պակիստան",
          "PL": "Լեհաստան",
          "PM": "Սեն Պիեռ և Միկելոն",
          "PN": "Պիտկիրնյան Կղզիներ",
          "PR": "Պուերտո Ռիկո",
          "PS": "Պաղեստին",
          "PT": "Պորտուգալիա",
          "PW": "Պալաու",
          "PY": "Պարագվայ",
          "QA": "Կատար",
          "RO": "Ռումինիա",
          "RS": "Սերբիա",
          "RU": "Ռուսաստանի Դաշնություն",
          "RW": "Ռուանդա",
          "SA": "Սաուդյան Արաբիա",
          "SB": "Սողոմոնյան Կղզիներ",
          "SC": "Սեյշելներ",
          "SD": "Սուդան",
          "SE": "Շվեդիա",
          "SG": "Սինգապուր",
          "SH": "Սուրբ Հելենա",
          "SI": "Սլովենիա",
          "SJ": "Սվալբարդ և Յան Մայենյան Կղզիներ",
          "SK": "Սլովակիա",
          "SL": "Սիերա Լեոնե",
          "SM": "Սան Մարինո",
          "SN": "Սենեգալ",
          "SO": "Սոմալի",
          "SR": "Սուրինամ",
          "SV": "Սալվադոր",
          "SY": "Սիրիայի Արաբական Հանրապետություն",
          "SZ": "Սվազիլենդ",
          "TD": "Չադ",
          "TF": "Ֆրանսիական Հարավային Տարածքներ",
          "TG": "Տոգո",
          "TH": "Թաիլանդ",
          "TJ": "Տաջիկստան",
          "TK": "Տոկելաու",
          "TM": "Թուրքմենստան",
          "TN": "Թունիս",
          "TO": "Տոնգա",
          "TR": "Թուրքիա",
          "TT": "Տրինիդադ և Տոբագո",
          "TV": "Տուվալու",
          "TW": "Թայվան",
          "TZ": "Տանզանիա",
          "UA": "Ուկրաինա",
          "UG": "Ուգանդա",
          "US": "Ամերիկայի Միացյալ Նահանգներ",
          "UY": "Ուրուգվայ",
          "UZ": "Ուզբեկստան",
          "VA": "Վատիկան",
          "VC": "Սենթ Վինսենթ և Գրենադիններ",
          "VE": "Վենեսուելա",
          "VN": "Վիետնամ",
          "VU": "Վանուատու",
          "WF": "Ուոլիս և Ֆուտունա",
          "WS": "Սամոա",
          "YE": "Եմեն",
          "YT": "Մայոտտե",
          "ZA": "Հարավային Աֆրիկա",
          "ZM": "Զամբիա",
          "ZW": "Զիմբաբվե"
        },
        "default_country": [
          "Հայաստան"
        ],
        "default_country_code": [
          "AM"
        ],
        "full_address": [
          "#{city_prefix} #{city}, #{street_name} #{building_number}",
          "#{city_prefix} #{city}, #{street_name} #{building_number}, #{secondary_address}",
          "#{city_prefix} #{city}, #{postcode}, #{street_name} #{building_number}",
          "#{city_prefix} #{city}, #{postcode}, #{street_name} #{building_number}, #{secondary_address}",
          "#{village_prefix} #{village}, #{state}ի մարզ, #{postcode}, #{street_name} #{building_number}"
        ],
        "postcode": [
          "0###",
          "1###",
          "2###",
          "3###",
          "4###"
        ],
        "postcode_by_state": {
          "ԱԳ": [
            "02##",
            "03##",
            "04##",
            "05##"
          ],
          "ԱՄ": [
            "09##",
            "10##",
            "11##"
          ],
          "ԱՐ": [
            "06##",
            "07##",
            "08##"
          ],
          "ԳՂ": [
            "12##",
            "13##",
            "14##",
            "15##",
            "16##"
          ],
          "ԼՌ": [
            "17##",
            "18##",
            "19##",
            "20##",
            "21##"
          ],
          "ԿՏ": [
            "22##",
            "23##",
            "24##",
            "25##"
          ],
          "ՇԿ": [
            "26##",
            "27##",
            "28##",
            "29##",
            "30##",
            "31##"
          ],
          "ՍՅ": [
            "32##",
            "33##",
            "34##",
            "35##"
          ],
          "ՎՁ": [
            "36##",
            "37##",
            "38##"
          ],
          "ՏՎ": [
            "39##",
            "40##",
            "41##",
            "42##"
          ]
        },
        "secondary_address": [
          "բն. #",
          "բն. ##",
          "բն. ##"
        ],
        "state": [
          "Արագածոտն",
          "Արարատ",
          "Արմավիր",
          "Գեղարքունիք",
          "Լոռի",
          "Կոտայք",
          "Շիրակ",
          "Սյունիք",
          "Տավուշ",
          "Վայոց Ձոր"
        ],
        "state_abbr": [
          "ԱԳ",
          "ԱՐ",
          "ԱՄ",
          "ԳՂ",
          "ԼՌ",
          "ԿՏ",
          "ՇԿ",
          "ՍՅ",
          "ՎՁ",
          "ՏՎ"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_root} #{street_suffix}"
        ],
        "street_root": [
          "Ազատության",
          "Արշակունյաց",
          "Արցախի",
          "Գայի",
          "Ծովակալ Իսակովի",
          "Կոմիտասի",
          "Հյուսիսային",
          "Մաշտոցի",
          "Մարշալ Բաղրամյան",
          "Մյասնիկյան",
          "Սայաթ-Նովայի",
          "Տիգրան Մեծի",
          "Աբելյան",
          "Աբովյան",
          "Ագաթանգեղոսի",
          "Ազատամարտիկների",
          "Աթենքի",
          "Աթոյան",
          "Ալեք Մանուկյան",
          "Ալիխանյան",
          "Աղայան",
          "Աղյուսագործների",
          "Ամիրյան",
          "Այասի",
          "Անտառային",
          "Անրի Վեռնոյի",
          "Ավագ Պետրոսյան",
          "Արամ Խաչատրյան",
          "Արամի",
          "Արգիշտիի",
          "Արմենակյան",
          "Բայրոնի",
          "Բարձրաբերդի",
          "Բելինսկու",
          "Բեյրութի",
          "Բուդապեշտի",
          "Բուռնազյան",
          "Բրյուսովի",
          "Գալոյան Եղբայրների",
          "Գարեգին Նժդեհի",
          "Գետառի",
          "Գլինկայի",
          "Գյուլբենկյան",
          "Գրիգոր Լուսավորչի",
          "Գրիգոր Հարությունյան",
          "Գրիգոր Տեր-Գրիգորյան",
          "Գևորգ Էմինի",
          "Գևորգ Հովսեփյան",
          "Գևորգ Քոչարի",
          "Դեղատան",
          "Դերենիկ Դեմիրճյան",
          "Եզնիկ Կողբացու",
          "Եկմալյան",
          "Երվանդ Քոչարի",
          "Զավարյան",
          "Զարոբյան",
          "Զաքյան",
          "Էրեբունու",
          "Թաիրովի",
          "Թամանյան",
          "Թորամանյան",
          "Թումանյան",
          "Իսահակյան",
          "Իսրայելյան",
          "Իտալիայի",
          "Լամբրոնի",
          "Լենինգրադյան",
          "Լեոյի",
          "Լեոնիդ Ազգալդյան",
          "Լեռ Կամսարի",
          "Լիսինյան",
          "Լոմոնոսովի",
          "Լոռիս-Մելիքովի",
          "Լուսինյանց",
          "Խանզադյան",
          "Խանջյան",
          "Ծատուրյան",
          "Ծխախոտագործների",
          "Կալենցի",
          "Կասյան",
          "Կարեն Դեմիրճյան",
          "Կիևյան",
          "Կոնդի",
          "Կորի",
          "Կորյունի",
          "Կուստոյի",
          "Կռիլովի",
          "Հալաբյան",
          "Հակոբ Հակոբյան",
          "Հայրիկ Մուրադյան",
          "Հանրապետության",
          "Հերացու",
          "Հին Երևանցու",
          "Հնդկաստանի",
          "Հովհաննես Կոզեռնի",
          "Հրանտ Շահինյան",
          "Հրաչյա Քոչարի",
          "Ձորափի",
          "Ղազար Փարպեցու",
          "Մայիսյան",
          "Մարկ Գրիգորյան",
          "Մարտի 8-ի",
          "Մելիք-Ադամյան",
          "Միչուրինի",
          "Մհեր Մկրտչյան",
          "Մոնթե Մելքոնյան",
          "Մոսկովյան",
          "Մովսես Խորենացու",
          "Մուրացանի",
          "Նալբանդյան",
          "Նար-Դոսի",
          "Նորքի",
          "Շարա Տալյան",
          "Շարիմանյան",
          "Շուկայի",
          "Ոսկերիչների",
          "Չայկովսկու",
          "Չարենցի",
          "Չեռնիշևսկու",
          "Պարոնյան",
          "Պետրոս Ադամյան",
          "Պուշկինի",
          "Պռոշյան",
          "Պրահայի",
          "Ռոստոմի",
          "Ռոստովյան",
          "Ռուսթավելու",
          "Սասունցի Դավթի",
          "Սարալանջի",
          "Սարմենի",
          "Սարյան",
          "Սեբաստիայի",
          "Սերգեյ Փարաջանովի",
          "Սիլվա Կապուտիկյան",
          "Սիմեոն Երևանցու",
          "Սիսվանի",
          "Սոսեի",
          "Սուվորովի",
          "Սուրբ Հովհաննեսի",
          "Սպենդիարյան",
          "Ստեփան Զորյան",
          "Սևանի",
          "Վազգեն Սարգսյան",
          "Վահրամ Փափազյան",
          "Վաղարշյան",
          "Վարդան Աճեմյան",
          "Վարդանանց",
          "Վերֆելի",
          "Վրացյան",
          "Տարսոնի",
          "Տերյան",
          "Տոլստոյի",
          "Տպագրիչների",
          "Ցախի",
          "Փավստոս Բուզանդի",
          "Քաջազնունու",
          "Քոչինյան",
          "Քրիստափորի",
          "Օստրովսկու",
          "Օրբելի Եղբայրների",
          "Ֆիզկուլտուրնիկների",
          "Ֆիրդուսու",
          "Ֆրիկի"
        ],
        "street_suffix": [
          "փողոց",
          "պողոտա"
        ],
        "village": [
          "Ագարակ",
          "Անտառուտ",
          "Բերքառատ",
          "Գեղաձոր",
          "Գետափ",
          "Զովասար",
          "Լեռնապար",
          "Լուսագյուղ",
          "Կաթնաղբյուր",
          "Կաքավաձոր",
          "Հացաշեն",
          "Նորաշեն",
          "Շենավան",
          "Ոսկեվազ",
          "Ցամաքասար",
          "Այգեզարդ",
          "Բարձրաշեն",
          "Բերքանուշ",
          "Լանջանիստ",
          "Լուսաշող",
          "Ջրաշեն",
          "Քաղցրաշեն",
          "Այգեկ",
          "Առատաշեն",
          "Բամբակաշատ",
          "Գեղակերտ",
          "Լեռնամերձ",
          "Ծաղկալանջ",
          "Հացիկ",
          "Մերձավան",
          "Քարակերտ",
          "Անտառամեջ",
          "Արծվաշեն",
          "Գեղաքար",
          "Զովաբեր",
          "Լանջաղբյուր",
          "Շատջրեք",
          "Այգեհատ",
          "Դարպաս",
          "Լեռնահովիտ",
          "Հարթագյուղ",
          "Պաղաղբյուր",
          "Սարամեջ",
          "Քարաձոր",
          "Զովք",
          "Լեռնանիստ",
          "Մեղրաձոր",
          "Այգաբաց",
          "Թավշուտ",
          "Լանջիկ",
          "Կարմրավան",
          "Հայկասար",
          "Նահապետավան",
          "Վարդաղբյուր",
          "Քարաբերդ",
          "Արծվանիկ",
          "Բարձրավան",
          "Կաղնուտ",
          "Հացավան",
          "Նռնաձոր",
          "Սառնակունք",
          "Աղավնաձոր",
          "Սևաժայռ",
          "Վերնաշեն",
          "Այգեհովիտ",
          "Արծվաբերդ",
          "Բերքաբեր",
          "Գետահովիտ",
          "Ծաղկավան",
          "Հաղթանակ",
          "Ոսկեպար",
          "Սարիգյուղ"
        ],
        "village_prefix": [
          "գ."
        ]
      },
      "artist": {
        "names": [
          "Դոնատելլո",
          "Սանդրո Բոտիչելլի",
          "Միքելանջելո",
          "Ռաֆայել Սանտի",
          "Տիցիան",
          "Ալբրեխտ Դյուրեր",
          "Կարավաջո",
          "Պիտեր Պաուլ Ռուբենս",
          "Լորենցո Բերնինի",
          "Ռեմբրանդ",
          "Կամիլ Պիսսարո",
          "Էդուարդ Մանե",
          "Էդգար Դեգա",
          "Պոլ Սեզան",
          "Կլոդ Մոնե",
          "Պիեռ-Օգյուստ Ռենուար",
          "Մարի Կասսատ",
          "Պոլ Գոգեն",
          "Էդվարդ Մունկ",
          "Գուստավ Կլիմտ",
          "Անրի Մատիս",
          "Պաբլո Պիկասո",
          "Վասիլի Կանդինսկի",
          "Մարկ Շագալ",
          "Ժորժ Սյորա",
          "Ռենե Մագրիտ",
          "Մաուրից Կոռնելիս Էշեր",
          "Մարկ Ռոթկո",
          "Սալվադոր Դալի",
          "Ֆրիդա Կալո",
          "Էնդի Ուորհոլ",
          "Լեոնարդո դա Վինչի",
          "Էլ Գրեկո",
          "Պաուլ Կլեե",
          "Վինսենթ վան Գոգ",
          "Մարտիրոս Սարյան",
          "Հովհաննես Այվազովսկի",
          "Արշիլ Գորկի",
          "Մինաս Ավետիսյան",
          "Վարդգես Սուրենյանց",
          "Փանոս Թերլեմեզյան",
          "Հարություն Կալենց",
          "Ժանսեմ",
          "Ռոբերտ Էլիբեկյան",
          "Ժան Գառզու",
          "Հակոբ Կոջոյան",
          "Երվանդ Քոչար",
          "Գրիգոր Խանջյան",
          "Ռուդոլֆ Խաչատրյան"
        ]
      },
      "book": {
        "author": [
          "Դանթե Ալիգիերի",
          "Ջեյն Օսթին",
          "Օնորե դը Բալզակ",
          "Ջովաննի Բոկաչչո",
          "Խորխե Լուիս Բորխես",
          "Էմիլի Բրոնտե",
          "Ալբեր Կամյու",
          "Լուի-Ֆերդինանդ Սելին",
          "Միգել դե Սերվանտես",
          "Չարլզ Դիքենս",
          "Դենի Դիդրո",
          "Ֆեոդոր Դոստոևսկի",
          "Ռալֆ Էլլիսոն",
          "Ուիլյամ Ֆոլքներ",
          "Գյուստավ Ֆլոբեր",
          "Գաբրիել Գարսիա Մարկես",
          "Յոհան Վոլֆգանգ ֆոն Գյոթե",
          "Նիկոլայ Գոգոլ",
          "Գյունտեր Գրաս",
          "Ժուան Գիմարայնշ Ռոզա",
          "Էռնեստ Հեմինգուեյ",
          "Հենրիկ Իբսեն",
          "Ֆրանց Կաֆկա",
          "Յասունարի Կավաբատա",
          "Նիկոս Կազանձակիս",
          "Դեյվիդ Հերբերթ Լոուրենս",
          "Հալդոր Քիլյան Լաքսնենս",
          "Դորիս Լեսսինգ",
          "Աստրիդ Լինդգրեն",
          "Լու Սին",
          "Նագիբ Մահֆուզ",
          "Թոմաս Մանն",
          "Հերման Մելվիլ",
          "Ռոբերտ Մուզիլ",
          "Վլադիմիր Նաբոկով",
          "Ֆերնանդու Պեսոա",
          "Մարսել Պրուստ",
          "Ֆրանսուա Ռաբլե",
          "Սալման Ռուշդի",
          "Թայիբ Սալիհ",
          "Ուիլյամ Շեքսպիր",
          "Ստենդալ",
          "Իտալո Զվևո",
          "Ջոնաթան Սվիֆթ",
          "Լև Տոլստոյ",
          "Մարկ Տվեն",
          "Ուոլթ Ուիթմեն",
          "Վիրջինիա Վուլֆ",
          "Մարգարիտ Յուրսենար",
          "Պարույր Սևակ",
          "Եղիշե Չարենց",
          "Վահան Տերյան",
          "Խաչատուր Աբովյան",
          "Հովհաննես Թումանյան",
          "Միքայել Նալբանդյան",
          "Արշակ Չոպանյան",
          "Դանիել Վարուժան",
          "Սիամանթո",
          "Րաֆֆի",
          "Ավետիք Իսահակյան",
          "Հովհաննես Հովհաննիսյան",
          "Գրիգոր Նարեկացի",
          "Ալեքսանդր Շիրվանզադե",
          "Խաչիկ Դաշտենց",
          "Հովհաննես Շիրազ",
          "Հակոբ Պարոնյան",
          "Վիլյամ Սարոյան"
        ],
        "genre": [
          "դասական",
          "դետեկտիվ",
          "առակ",
          "հեքիաթ",
          "պատմվածք",
          "ժողովրդական բանահյուսություն",
          "հումոր",
          "լեգենդ",
          "դիցաբանություն",
          "գիտաֆանտաստիկա",
          "թրիլեր",
          "կենսագրական",
          "ակնարկ",
          "դասագիրք",
          "տեղեկագիր",
          "պատմավեպ",
          "արկածային",
          "սարսափ"
        ],
        "publisher": [
          "Անտարես",
          "Գիտություն",
          "Զանգակ",
          "Լույս",
          "Փիրսոն թաբլիշինգ",
          "Ֆինիքս թաբլիշինգ",
          "Օքսֆորդ Յունիվերսիտի պրեսս",
          "Վոլտերս Կլյուվեր"
        ],
        "title": [
          "Աստվածային կատակերգություն",
          "Հպարտություն և նախապաշարմունք",
          "Հայր Գորիո",
          "Դեկամերոն",
          "Հնարվածքներ",
          "Մոլեգին հողմերի դարավանդը",
          "Օտարը",
          "Ճամփորդություն գիշերից անդին",
          "Դոն Կիխոտ",
          "Մեծ հույսեր",
          "Ժակ ֆատալիստը և նրա տերը",
          "Ոճիր և պատիժ",
          "Ապուշը",
          "Կարամազով եղբայրներ",
          "Անտեսանելի մարդը",
          "Շառաչ և ցասում",
          "Տիկին Բովարի",
          "Զգացմունքների դաստիարակություն",
          "Հարյուր տարվա մենություն",
          "Սերը ժանտախտի ժամանակ",
          "Ֆաուստ",
          "Մեռած հոգիներ",
          "Թիթեղյա թմբուկ",
          "Մեծ տափաստանի արահետները",
          "Ծերունին և ծովը",
          "Տիկնիկների տուն",
          "Դատավարություն",
          "Դղյակը",
          "Լեռան հառաչը",
          "Հույն Զորբան",
          "Որդիներ և սիրեկաններ",
          "Ինքնուրույն մարդիկ",
          "Ոսկե տետր",
          "Երկարագուլպա Պեպպին",
          "Խելագարի օրագիրը",
          "Մեր փողոցի երեխաները",
          "Բուդդենբրոկներ",
          "Կախարդական լեռը",
          "Մոբի Դիք կամ ճերմակ կետաձուկը",
          "Մարդն առանց հատկությունների",
          "Լոլիտա",
          "Գիրք անհանգստության",
          "Կորուսյալ ժամանակների որոնումներում",
          "Գարգանտյուա և Պանտագրյուել",
          "Կեսգիշերվա երեխաներ",
          "Հյուսիս ուխտագնացության ժամանակը",
          "Համլետ",
          "Լիր արքա",
          "Օթելլո",
          "Կարմիրը և սևը",
          "Ձենոյի ինքնաճանաչումը",
          "Գուլիվերի ճանապարհորդությունները",
          "Պատերազմ և խաղաղություն",
          "Աննա Կարենինա",
          "Հեքլբերի Ֆիննի արկածները",
          "Խոտի տերևներ",
          "Միսսիս Դելլոուեյ",
          "Փարոսի վրա",
          "Ադրիանի նոթերը",
          "Անլռելի Զանգակատուն",
          "Մատեան ողբերգութեան",
          "Ռանչպարների կանչը",
          "Մարդկային կատակերգություն",
          "Իմ սիրտը լեռներում է"
        ]
      },
      "cell_phone": {
        "formats": [
          "##-######",
          "(##) ######",
          "##.######"
        ]
      },
      "color": {
        "name": [
          "կարմիր",
          "կանաչ",
          "կապույտ",
          "դեղին",
          "մանուշակագույն",
          "սպիտակ",
          "սև",
          "նարնջագույն",
          "վարդագույն",
          "մոխրագույն",
          "շագանակագույն",
          "մանուշակագույն",
          "փիրուզագույն",
          "երկնագույն",
          "դեղնավարդագույն",
          "մուգ մանուշակագույն",
          "դեղնականաչ",
          "ոսկեգույն",
          "դարչնագույն"
        ]
      },
      "commerce": {
        "department": [
          "Գրքեր",
          "Ֆիլմեր",
          "Երաժշտություն",
          "Խաղեր",
          "Խաղալիքեր",
          "Էլեկտրոնիկա",
          "Համակարգիչներ",
          "Ապրանքներ Տան Համար",
          "Ապրանքներ Այգեգործության Համար",
          "Գործիքներ",
          "Նպարեղեն",
          "Առողջապահական Ապրանքներ",
          "Կոսմետիկ Ապրանքներ",
          "Մանկական Ապրանքներ",
          "Ապրանքներ Նորածինների Համար",
          "Հագուստ",
          "Կոշկեղեն",
          "Ոսկերչական Իրեր",
          "Սպորտային Ապրանքներ",
          "Ավտոմոբիլների Պահեստամասեր",
          "Արդյունաբերական Ապրանքներ"
        ],
        "product_name": {
          "adjective": [
            "փոքր",
            "Էրգոնիկ",
            "հասարակ",
            "խելացի",
            "շքեղ",
            "ցնցող",
            "ֆանտաստիկ",
            "պրակտիկ",
            "նրբագեղ",
            "հիանալի",
            "հսկայական",
            "միջակ",
            "դիմացկուն",
            "թեթև",
            "աերոդինամիկ",
            "ամուր"
          ],
          "material": [
            "պողպատե",
            "փայտե",
            "բետոնե",
            "պլաստիկից",
            "բամբակե",
            "գրանիտե",
            "ռետինե",
            "կաշվե",
            "մետաքսե",
            "բրդյա",
            "քաթանե",
            "մարմարե",
            "երկաթե",
            "բրոնզե",
            "պղնձյա",
            "ալյումինե",
            "թղթե"
          ],
          "product": [
            "աթոռ",
            "ավտոմեքենա",
            "համակարգիչ",
            "ձեռնոց",
            "շալվար",
            "վերնաշապիկ",
            "սեղան",
            "կոշիկ",
            "գլխարկ",
            "ափսե",
            "դանակ",
            "շիշ",
            "վերարկու",
            "լամպ",
            "ստեղնաշար",
            "պայուսակ",
            "նստարան",
            "ժամացույց",
            "դրամապանակ"
          ]
        },
        "promotion_code": {
          "adjective": [
            "Ապշեցուցիչ",
            "Հիանալի",
            "Լավ",
            "Հոյակապ",
            "Գերազանց",
            "Հատուկ",
            "Հաճելի",
            "Գրավիչ",
            "Տարեվերջյան"
          ],
          "noun": [
            "Կոդ",
            "Գործարք",
            "Գեղչ",
            "Գին",
            "Խնայողություն",
            "Ակցիա"
          ]
        }
      },
      "company": {
        "bs": [
          [
            "իրականացնել",
            "օգտագործել",
            "ինտեգրել",
            "ռացիոնալացնել",
            "օպտիմալացնել",
            "փոխակերպել",
            "ընդգրկել",
            "ակտիվացնել",
            "կազմակերպել",
            "նախագծել",
            "խթանել",
            "ձևափոխել",
            "արտոնել",
            "դրամայնացնել",
            "հեշտացնել",
            "վերցնել",
            "աճեցնել",
            "սինթեզել",
            "առաքել",
            "զբաղվել",
            "առավելագույնի հասցնել",
            "արագացնել",
            "միջնորդել",
            "պատկերացնել",
            "վերափոխել",
            "ընդլայնել",
            "նախաձեռնել",
            "հեղափոխականացնել",
            "առաջացնել",
            "օգտագործել",
            "զարգացնել",
            "արտադրանքի վերածել"
          ],
          [
            "ուղղահայաց",
            "ակտիվ",
            "դիմացկուն",
            "հեղափոխական",
            "առաջատար",
            "նորարարական",
            "ինտուիտիվ",
            "ռազմավարական",
            "էլեկտրոնային",
            "գլոբալ",
            "վիրտուալ",
            "դինամիկ",
            "գրավիչ",
            "ինտերակտիվ",
            "արդյունավետ",
            "ընդարձակելի",
            "պատրաստի",
            "ինտեգրված",
            "ազդեցիկ",
            "անլար",
            "թափանցիկ",
            "հաջորդ սերնդի",
            "ժամանակակից",
            "հարմարեցված",
            "համատարած",
            "ազդեցիկ",
            "ամբողջական",
            "հարուստ",
            "անվճար"
          ],
          [
            "պարադիգմներ",
            "շուկաներ",
            "ենթակառուցվածքներ",
            "պլատֆորմներ",
            "նախաձեռնություններ",
            "ուղիներ",
            "համայնքներ",
            "լուծումներ",
            "պորտալներ",
            "տեխնոլոգիաներ",
            "հարաբերություններ",
            "կառուցվածքներ",
            "ինտերֆեյսներ",
            "շուկաներ",
            "համակարգեր",
            "մոդելներ",
            "օգտագործողներ",
            "սխեմաներ",
            "ցանցեր",
            "ծրագրեր",
            "չափանիշներ",
            "բիզնես",
            "գործառույթներ",
            "փորձառություններ",
            "մեթոդաբանություններ"
          ]
        ],
        "buzzwords": [
          [
            "Առաջավոր",
            "Բարելավված",
            "Ավտոմատացված",
            "Հավասարակշռված",
            "Կենտրոնացված",
            "Համատեղելի",
            "Կարգավորելի",
            "Անհատականացված",
            "Ապակենտրոնացված",
            "Թվայնացված",
            "Տարածված",
            "Փոքրացված",
            "Ընդլայնված",
            "Էրգոնիկ",
            "Բացառիկ",
            "Երկարացված",
            "Լիովին կոնֆիգուրացվող",
            "Ֆունկցիոնալ հիմունքներով",
            "Հիմնական",
            "Հորիզոնական",
            "Իրականացված",
            "Նորարական",
            "Ինտեգրված",
            "Ինտուիտիվ",
            "Պարտադիր",
            "Բազմուղի",
            "Բազմաշերտ",
            "Ցանցային",
            "Բաց կոդով",
            "Օպերատիվ",
            "Օպտիմալացված",
            "Օրգանական",
            "Կազմակերպված",
            "Կայուն",
            "Կենսունակ",
            "Ավարտված",
            "Բևեռացված",
            "Կանխարգելող",
            "Ակտիվ",
            "Ծրագրավորելի",
            "Առաջադիմական",
            "Որակով",
            "Ռեակտիվ",
            "Իրականացված",
            "Նվազեցված",
            "Դիմացկուն",
            "Անխափան",
            "Ապահով",
            "Համատեղելի",
            "Հեշտացված",
            "Փոխարկելի",
            "Սինխրոնիզացված",
            "Ունիվերսալ",
            "Ճկուն",
            "Վիրտուալ"
          ],
          [
            "3-րդ սերնդի",
            "4-րդ սերնդի",
            "5-րդ սերնդի",
            "6-րդ սերնդի",
            "ասիմետրիկ",
            "ասինխրոն",
            "թողունակությունը վերահսկվող",
            "երկկողմանի",
            "հստակ մտածող",
            "համաձայնեցված",
            "բաղադրյալ",
            "դիդակտիկ",
            "ուղղորդիչ",
            "դիսկրետ",
            "բացահայտ",
            "գլոբալ",
            "բարձր մակարդակի",
            "ամբողջական",
            "միատարր",
            "հիբրիդ",
            "ազդեցիկ",
            "ինտերակտիվ",
            "միջանկյալ",
            "առաջատար",
            "տեղային",
            "լոգիստիկ",
            "սիստեմատիկ",
            "մոդուլային",
            "չեզոք",
            "հաջորդ սերնդի",
            "օբյեկտի վրա հիմնված",
            "օպտիմալ",
            "արմատական",
            "փոխադարձ",
            "ռեգիոնալ",
            "երկրորդական",
            "կայուն",
            "ստատիկ",
            "համակարգված",
            "համակարգային",
            "շոշափելի",
            "երրորդական",
            "անցումային",
            "միատեսակ",
            "լավ մոդուլացված",
            "առանց թերությունների"
          ],
          [
            "կարողություն",
            "մուտք",
            "ադապտեր",
            "ալգորիթմ",
            "միություն",
            "վերլուծիչ",
            "ծրագրային ապահովում",
            "մոտեցում",
            "արխիվ",
            "արհեստական բանականություն",
            "վերաբերմունք",
            "ընդունակություն",
            "կարողություն",
            "մարտահրավեր",
            "գործակցություն",
            "բարդություն",
            "գաղափար",
            "համախմբվածություն",
            "տվյալների բազա",
            "տվյալների պահեստ",
            "սահմանում",
            "իմացություն",
            "կոդավորում",
            "գաղտնագրում",
            "կանխատեսում",
            "հենքային ծրագիր",
            "ֆունկցիա",
            "գործառույթ",
            "գրաֆիկական ինտերֆեյս",
            "սարքային ապահովում",
            "հիերարխիա",
            "հանգույց",
            "ենթակառուցվածք",
            "նախաձեռնություն",
            "ծրագրի ներդրում",
            "հրահանգների հավաքածու",
            "ինտերֆեյս",
            "ինտրանետ",
            "գիտելիքների բազա",
            "տեղական ցանց",
            "մատրիցա",
            "մեթոդաբանություն",
            "միջանկյալ շերտ",
            "միգրացիա",
            "մոդել",
            "կարգավորիչ",
            "մոնիտորինգ",
            "բաց համակարգ",
            "պարադիգմ",
            "պորտալ",
            "գնային կառուցվածք",
            "արդյունավետություն",
            "նախագիծ",
            "ապահովված գիծ",
            "ծրագրային ապահովում",
            "լուծում",
            "ստանդարտացում",
            "ստրատեգիա",
            "կառուցվածք",
            "օպերատիվ խումբ",
            "արտադրողականություն",
            "ժամանակացույց",
            "գործիք",
            "օգտագործում",
            "կայք",
            "աշխատուժ"
          ]
        ],
        "industry": [
          "Պաշտպանություն",
          "Համակարգչային Տեխնիկա",
          "Համակարգչային Ծրագրեր",
          "Համակարգչային Ցանցեր",
          "Համացանց",
          "Կիսահաղորդիչներ",
          "Հեռահաղորդակցություն",
          "Իրավական Գործառույթներ",
          "Իրավաբանական Ծառայություններ",
          "Կառավարման Խորհրդատվություն",
          "Կենսատեխնոլոգիա",
          "Բժշկական Գործունեություն",
          "Հիվանդանոց և Առողջապահություն",
          "Դեղագործություն",
          "Անասնաբուժություն",
          "Բժշկական Սարքավորումներ",
          "Կոսմետիկա",
          "Հագուստ և Նորաձևություն",
          "Սպորտային Ապրանքներ",
          "Ծխախոտագործություն",
          "Սուպերմարկետներ",
          "Սննդի Արտադրություն",
          "Սպառողական Էլեկտրոնիկա",
          "Սպառողական Ապրանքներ",
          "Կահույք",
          "Մանրածախ Առևտուր",
          "Զվարճանք",
          "Դրամախաղ և Խաղատներ",
          "Ժամանց",
          "Ճանապարհորդություն և Տուրիզմ",
          "Հյուրընկալություն",
          "Ռեստորաններ",
          "Սպորտաձևեր",
          "Սննդամթերք և Ըմպելիքներ",
          "Կինոնկարներ",
          "Հեռարձակվող Մեդիա",
          "Թանգարաններ",
          "Կատարողական Արվեստ",
          "Ժամանցի Հարմարություններ և Ծառայություններ",
          "Բանկային Գործունեություն",
          "Ապահովագրություն",
          "Ֆինանսական Ծառայություններ",
          "Անշարժ Գույք",
          "Ներդրումային Բանկային Ծառայություններ",
          "Ներդրումային Կառավարում",
          "Հաշվապահություն",
          "Շինարարություն",
          "Շինանյութեր",
          "Ճարտարապետություն և Պլանավորում",
          "Քաղաքացիական Շինարարություն",
          "Քիմիական Նյութեր",
          "Մեքենաներ",
          "Հանքարդյունաբերություն և Մետաղներ",
          "Նավթարդյունաբերություն",
          "Էներգետիկա",
          "Նավաշինություն",
          "Կոմունալ Ծառայություններ",
          "Տեքստիլ Արդյունաբերություն",
          "Թուղթ և Անտառային Ապրանքներ",
          "Երկաթուղու Արտադրություն",
          "Հողագործություն",
          "Անասնապահություն",
          "Կաթնամթերք",
          "Ձկնորսություն",
          "Միջնակարգ Կրթություն",
          "Բարձրագույն Կրթություն",
          "Կրթության Կառավարում",
          "Հետազոտություն",
          "Ռազմական Գործ",
          "Օրենսդրական Գրասենյակ",
          "Դատարան",
          "Միջազգային Հարաբերություններ",
          "Կառավարության Ղեկավարում",
          "Իրավապահ Համակարգ",
          "Հանրային Անվտանգություն",
          "Հանրային Քաղաքականություն",
          "Մարկետինգ և Գովազդ",
          "Թերթեր",
          "Հրատարակչություն",
          "Տպագրություն",
          "Տեղեկատվական Ծառայություններ",
          "Գրադարաններ",
          "Բեռնափոխադրումներ",
          "Անհատական և Ընտանեկան Ծառայություններ",
          "Կրոնական Հաստատություններ",
          "Քաղաքացիական և Սոցիալական Կազմակերպություն",
          "Սպառողական Ծառայություններ",
          "Երկաթուղի",
          "Պահեստավորում",
          "Ավիացիա",
          "Տեղեկատվական Տեխնոլոգիաներ և Ծառայություններ",
          "Շուկայի Ուսումնասիրություն",
          "Հասարակայնության Հետ Կապեր և Հաղորդակցություն",
          "Դիզայն",
          "Մասնագիտական Վերապատրաստում",
          "Վենչուրային և Մասնավոր Կապիտալ",
          "Թարգմանություն և Տեղայնացում",
          "Համակարգչային Խաղեր",
          "Իրադարձությունների Կազմակերպում",
          "Արվեստ և Արհեստ",
          "Էլեկտրական և Էլեկտրոնային Արտադրություն",
          "Առցանց Լրատվամիջոցներ",
          "Նանոտեխնոլոգիա",
          "Երաժշտություն",
          "Լոգիստիկա և Մատակարարում",
          "Համակարգչային և Ցանցային Անվտանգություն",
          "Անլար Տեխնոլոգիաներ",
          "Անվտանգություն և Հետաքննություն",
          "Ծառայությունների Մատուցում",
          "Աութսորսինգ և Օֆշորային Ծառայություններ",
          "Այլընտրանքային Բժշկություն",
          "Մեդիա Արտադրանք",
          "Կապիտալի Շուկաներ",
          "Բարեգործություն",
          "Մեծածախ Առևտուր",
          "Ներմուծում և Արտահանում",
          "Մեխանիկական կամ Արդյունաբերական Ճարտարագիտություն",
          "Լուսանկարչություն",
          "Մարդկային Ռեսուրսներ",
          "Բիզնես Սարքավորումներ",
          "Հոգեկան Առողջության Խնամք",
          "Գրաֆիկական Դիզայն",
          "Միջազգային Առևտուր և Զարգացում",
          "Ալկոհոլային Խմիչքներ",
          "Պերճանքի Առարկաներ և Ոսկերչական Իրեր",
          "Շրջակա Միջավայրի Պահպանություն",
          "Ապակի և Կերամիկա",
          "Փաթեթավորում և Բեռնարկղեր",
          "Արդյունաբերական Ավտոմատացում",
          "Կառավարական Հարաբերություններ"
        ],
        "name": [
          "#{Address.city} #{suffix}",
          "#{Address.village} #{suffix}",
          "#{Address.community} #{suffix}",
          "#{Name.first_name} և #{Name.first_name} #{suffix}",
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name} և #{Name.last_name} #{suffix}",
          "#{Name.last_name}, #{Name.last_name} և #{Name.last_name} #{suffix}"
        ],
        "profession": [
          "ուսուցիչ",
          "դերասան",
          "երաժիշտ",
          "փիլիսոփա",
          "գրող",
          "բժիշկ",
          "հաշվապահ",
          "գյուղատնտես",
          "ճարտարապետ",
          "տնտեսագետ",
          "ինժեներ",
          "փաստաբան",
          "գրադարանավար",
          "վիճակագրագետ",
          "հրշեջ",
          "դատավոր",
          "ոստիկան",
          "աստղագետ",
          "կենսաբան",
          "քիմիկոս",
          "ֆիզիկոս",
          "ծրագրավորող",
          "դիզայներ",
          "բանկիր",
          "բարմեն",
          "վարսահարդար",
          "շինարար",
          "գործարար",
          "մսագործ",
          "ատաղձագործ",
          "գանձապահ",
          "խոհարար",
          "մարզիչ",
          "ատամնաբույժ",
          "դիետոլոգ",
          "խմբագիր",
          "էլեկտրիկ",
          "բանվոր",
          "ֆերմեր",
          "ձկնորս",
          "այգեգործ",
          "լրագրող",
          "իրավաբան",
          "դասախոս",
          "փրկարար",
          "մեխանիկ",
          "բուժքույր",
          "նկարիչ",
          "դեղագործ",
          "լուսանկարիչ",
          "օդաչու",
          "ջրմուղագործ",
          "քաղաքագետ",
          "փոստատար",
          "ընդունարանի աշխատող",
          "գիտնական",
          "քարտուղար",
          "վաճառող",
          "զինվորական",
          "դերձակ",
          "տաքսու վարորդ",
          "թարգմանիչ",
          "տուրիստական գործակալ",
          "անասնաբույժ",
          "մատուցող",
          "հավաքարար",
          "առաքիչ"
        ],
        "suffix": [
          "ՍՊԸ",
          "ՀՁ",
          "ՓԲԸ",
          "ԲԲԸ",
          "Գրուպ",
          "Հոլդինգ"
        ],
        "type": [
          "Անհատ ձեռներեց",
          "Սահմանափակ պատասխանատվությամբ ընկերություն",
          "Համատեղ ձեռնարկություն",
          "Գործընկերություն",
          "Կոոպերատիվ",
          "Մասնաճյուղ",
          "Շահույթ ստանալու նպատակ չհետապնդող կազմակերպություն",
          "Պետական հիմնարկություն",
          "Բաց բաժնետիրական ընկերություն",
          "Փակ բաժնետիրական ընկերություն"
        ]
      },
      "compass": {
        "abbreviation": [
          "#{cardinal_abbreviation}",
          "#{ordinal_abbreviation}",
          "#{half_wind_abbreviation}"
        ],
        "cardinal": {
          "abbreviation": [
            "Հյ",
            "Աե",
            "Հր",
            "Ամ"
          ],
          "word": [
            "հյուսիս",
            "արևելք",
            "հարավ",
            "արևմուտք"
          ]
        },
        "half-wind": {
          "abbreviation": [
            "ՀյՀյԱե",
            "ԱեՀյԱե",
            "ԱեՀրԱե",
            "ՀրՀրԱե",
            "ՀրՀրԱմ",
            "ԱմՀրԱմ",
            "ԱմՀյԱմ",
            "ՀյՀյԱմ"
          ],
          "word": [
            "հյուսիս-հյուսիս-արևելք",
            "արևելք-հյուսիս-արևելք",
            "արևելք-հարավ-արևելք",
            "հարավ-հարավ-արևելք",
            "հարավ-հարավ-արևմուտք",
            "արևմուտք-հարավ-արևմուտք",
            "արևմուտք-հյուսիս-արևմուտք",
            "հյուսիս-հյուսիս-արևմուտք"
          ]
        },
        "ordinal": {
          "abbreviation": [
            "ՀյԱե",
            "ՀրԱե",
            "ՀրԱմ",
            "ՀյԱմ"
          ],
          "word": [
            "հյուսիս-արևելք",
            "հարավ-արևելք",
            "հարավ-արևմուտք",
            "հյուսիս-արևմուտք"
          ]
        }
      },
      "currency": {
        "name": [
          "ԱՄԷ Դիրհեմ",
          "Աղվանական Աղվանի",
          "Ալբանական Լեկ",
          "Հայկական Դրամ",
          "Հոլանդական Անտիլյաի Գուլդեն",
          "Անգոլական Կվանզա",
          "Արգենտինական Պեսո",
          "Ավստրալիական Դոլար",
          "Արուբական Գուլդեն",
          "Ադրբեջանական Մանաթ",
          "Բոսնիա և Հերցեգովինայի Մարկ",
          "Բարբադոսի Դոլար",
          "Բանգլադեշի Տակա",
          "Բուլղարական Լև",
          "Բահրեյնի Դինար",
          "Բուրունդիի Ֆրանկ",
          "Բերմուդյան Դոլար",
          "Բրունեյի Դոլար",
          "Բրազիլական Ռեալ",
          "Բահամյան Դոլար",
          "Բոտստվանայի Փուլա",
          "Բելառուսական Ռուբլի",
          "Բելիզի Դոլար",
          "Կանադական Դոլար",
          "Կոնգոյի Ֆրանկ",
          "Շվեյցարական Ֆրանկ",
          "Չիլիական Պեսո",
          "Չինական Յուան",
          "Կոլումբիական Պեսո",
          "Կոստա Ռիկայի Կոլոն",
          "Կուբայական Պեսո",
          "Կաբո Վերդեի Էսկուդո",
          "Չեխական Կրոն",
          "Ջիբութիի Ֆրանկ",
          "Դանիական Կրոն",
          "Դոմինիկյան Պեսո",
          "Ալժիրյան Դինար",
          "Էստոնական Կրոն",
          "Եգիպտական Ֆունտ",
          "Էրիթրեական Նակֆա",
          "Եթովպյան Բիր",
          "Եվրո",
          "Ֆիջիի Դոլար",
          "Ֆոլկլենդյան Կղզիների Ֆունտ",
          "Ֆունտ Ստերլինգ",
          "Վրացական Լարի",
          "Գանայական Սեդի",
          "Ջիբրալթարի Ֆունտ",
          "Գամբիական Դալասի",
          "Գվինեայի Ֆրանկ",
          "Գվատեմալական Կետսալ",
          "Գայանայի Դոլար",
          "Հոնկոնգյան Դոլար",
          "Հոնդուրասյան Լեմպիրա",
          "Խորվաթական Կունա",
          "Հաիթիի Գուրդե",
          "Հունգարական Ֆորինտ",
          "Ինդոնեզական Ռուփի",
          "Իսրայելական Շեղել",
          "Հնդկական Ռուփի",
          "Իրաքյան Դինար",
          "Իրանական Ռիալ",
          "Իսլանդական Կրոն",
          "Ջամայկայի Դոլար",
          "Հորդանանի Դինար",
          "Ճապոնական Իեն",
          "Քենիայի Շիլլինգ",
          "Ղրղզական Սոմ",
          "Կամբոջայի Ռիել",
          "Կոմորյան Ֆրանկ",
          "Հյուսիսային Կորեայի Վոն",
          "Հարավային Կորեայի Վոն",
          "Քուվեյթի Դինար",
          "Կիմյան Կղզիների Դոլար",
          "Ղազախստանի Տենգե",
          "Լաոսի Կիպ",
          "Լիբանանի Ֆունտ",
          "Շրի Լանկայի Ռուփի",
          "Լիբերիայի Դոլար",
          "Լիտվական Լիտ",
          "Լատվիական Լատ",
          "Լիբիական Դինար",
          "Մարոկկոյի Դիրհամ",
          "Մոլդովական Լեյ",
          "Մյանմայի Կյատ",
          "Մոնղոլական Տուգրիկ",
          "Մալդիվյան Ռուփի",
          "Զամբիական Կվաչա",
          "Մեքսիկական Պեսո",
          "Մալայզիական Ռինգիտ",
          "Մոզամբիկյան Մետիկալ",
          "Նիգերիական Նայրա",
          "Նիկարագուական Կորդոբա",
          "Նորվեգական Կրոն",
          "Նեպալյան Ռուփի",
          "Նոր Զելանդիայի Դոլար",
          "Օմանի Ռիալ",
          "Պանամական Բալբոա",
          "Պերուական Սոլ",
          "Պապուա Նոր Գվինեայի Կինա",
          "Ֆիլիպինյան Պեսո",
          "Պակիստանյան Ռուփի",
          "Լեհական Զլոտի",
          "Պարագվայական Գուարանի",
          "Քաթարի Ռիալ",
          "Ռումինական Լեյ",
          "Սերբական Դինար",
          "Ռուսական Ռուբլի",
          "Ռուանդական Ֆրանկ",
          "Սաուդյան Ռիալ",
          "Սողոմոնի Կղզիների Դոլար",
          "Սեյշելյան Կղզիների Ռուփի",
          "Սուդանական Ֆունտ",
          "Շվեդական Կրոնա",
          "Սինգապուրի Դոլար",
          "Սիեռա Լեոնեի Լեոնե",
          "Սոմալիի Շիլլինգ",
          "Սուրինամի Դոլար",
          "Սալվադորյան Կոլոն",
          "Սիրիական Ֆունտ",
          "Սվազիլենդական Լիլանգենի",
          "Թաիլանդական Բատ",
          "Տաջիկական Սոմոնի",
          "Ադրբեջանական Մանաթ",
          "Թունիսյան Դինար",
          "Վիետնամական Դոնգ",
          "Թուրքական Լիրա",
          "Տրինիդադ և Տոբագոյի Դոլար",
          "Թայվանի Դոլար",
          "Տանզանիայի Շիլլինգ",
          "Ուկրաինական Գրիվնա",
          "Ուգանդայի Շիլլինգ",
          "ԱՄՆ Դոլար",
          "Ուրուգվայական Պեսո",
          "Ուզբեկական Սոմ",
          "Վենեսուելական Բոլիվար",
          "Վիետնամական Դոնգ",
          "Վանուատուի Վատու",
          "Սամոայի Տալա",
          "Կենտրոնական Աֆրիկայի Ֆրանկ",
          "Արևելակարիբյան Դոլար",
          "Արևմտյան Աֆրիկայի Ֆրանկ",
          "Յեմենի Ռիալ",
          "Հարավաֆրիկյան Հանրապետության Ռենդ",
          "Նամիբիայի Դոլար",
          "Զամբիական Կվաչա",
          "Զիմբաբվեի Դոլար"
        ]
      },
      "food": {
        "descriptions": [
          "Երեք ձու, համեմ, լոլիկ, սոխ, ավոկադո և հալած պանիր: Կողքը ավելացրեք խորոված կարտոֆիլ և ֆրանսիական տոստ:",
          "Երեք ձվի օմլետ ռոքֆոր պանրով, մանր սոխ և խոզապուխտ: Կողքը ավելացրեք խորոված կարտոֆիլ և ֆրանսիական տոստ:",
          "Երեք ձվի սպիտակուց, սպանախ, սունկ, կարամելացված սոխ, լոլիկ և ցածր յուղայնությամբ ֆետա պանիր: Կողքը ավելացրեք սև հաց կամ ֆրանսիական տոստ:",
          "Ապխտած սաղմոն, խոզապուխտով ձու, կարմիր սոխ և լոլիկի սոուս բուլկիի վրա: Կողքը ավելացրեք խորոված կարտոֆիլ:",
          "Թարմ մաղադանոս, իտալական երշիկ, կեռաս, սխտոր, լոլիկ և մոցարելլա պանիր: Կողքը ավելացրեք մրգեր:",
          "Ֆրանսիական տոստ, շաքարավազ, կաթ, վանիլին և շաքարի փոշի: Ավելացրեք ցանկացած ձևով պատրաստված երկու ձու, խոզապուխտի հետ:",
          "Տապակած հավ վաֆլիների հետ: Մատուցվում է թխկիի օշարակով:",
          "Թարմ նորվեգական սաղմոն, թեթևորեն խառնված մանանեխի սոուսով: Մատուցվում է բրնձի և խաշած բանջարեղենի հետ:"
        ],
        "dish": [
          "խորոված կողիկներ",
          "կեսարի աղցան",
          "չիզբուրգեր",
          "հավի ֆահիտա",
          "հավի թևիկներ",
          "ֆետուչինե ալֆրեդո",
          "ձուկ և չիպսեր",
          "ֆրանսիական կարտոֆիլ երշիկով",
          "ֆրանսիական տոստ",
          "հումուս",
          "քյաբաբ",
          "լազանյա",
          "կոլոլակ սոուսով",
          "ռիզոտտո սնկով",
          "մակարոն և լոբի",
          "մակարոն տոմատով և ռեհանով",
          "պիցցա",
          "խոզի կոտլետներ",
          "ռավիոլի",
          "սաղմոն նիգիրի",
          "ձու շոտլանդական ձևով",
          "սուվլակի",
          "սուշի",
          "մեքսիկական տակո",
          "թյուննոս սաշիմի",
          "բուսական ապուր",
          "ավելուկի ապուր",
          "պասուց տոլմա",
          "լոբով ապուր",
          "քռչիկ",
          "բոզբաշ",
          "հաճարով և սնկով փլավ",
          "ղափամա",
          "հարիսա",
          "խաշ"
        ],
        "fruits": [
          "խնձոր",
          "ծիրան",
          "ավոկադո",
          "բանան",
          "մոշ",
          "հապալաս",
          "սերկևիլ",
          "կեռաս",
          "բալ",
          "տանձ",
          "լոռամիրգ",
          "հաղարջ",
          "խուրմա",
          "արմավ",
          "ֆեյխոա",
          "գրեյպֆրուտ",
          "խաղող",
          "թուզ",
          "գուավա",
          "գիհ",
          "կիվի",
          "կիտրոն",
          "լայմ",
          "մանգո",
          "մանգոստին",
          "մանդարին",
          "թութ",
          "նեկտարին",
          "ձիթապտուղ",
          "նարինջ",
          "պապայա",
          "դեղձ",
          "տանձ",
          "արքայախնձոր",
          "անանաս",
          "նուռ",
          "սալոր",
          "ելակ",
          "իծամորի",
          "մորի",
          "ազնվամորի"
        ],
        "ingredients": [
          "առվույտ",
          "նշի յուղ",
          "նուշ",
          "անձրուկ",
          "խնձորի քացախ",
          "խնձոր",
          "ծիրան",
          "կանկար",
          "ասիական արիշտա",
          "ծնեբեկ",
          "սմբուկ",
          "ավոկադո",
          "ավոկադոյի յուղ",
          "բեկոն",
          "խմորի սոդա",
          "բանան",
          "ծորենի",
          "գարի",
          "բրինձ",
          "լոբի",
          "կանաչ լոբի",
          "տավարի միս",
          "ճակնդեղ",
          "մոշ",
          "հապալաս",
          "հաց",
          "տարեկանի հաց",
          "սպիտակ հաց",
          "բրի պանիր",
          "բրոկոլի",
          "բրյուսելյան կաղամբ",
          "հնդկաձավար",
          "բուլղուր",
          "կարագ",
          "թան",
          "կաղամբ",
          "կակաո",
          "երիցուկ",
          "կանոլայի յուղ",
          "հիլ",
          "գազար",
          "ծաղկակաղամբ",
          "կարմիր պատիճապղպեղ",
          "նեխուր",
          "նեխուրի սերմ",
          "չեդեր պանիր",
          "կեռաս",
          "բալ",
          "շագանակ",
          "հավ",
          "կիտրոն",
          "չիլի պղպեղ",
          "մանր սոխ",
          "շոկոլադ",
          "դարչին",
          "մեխակ",
          "կակաոյի փոշի",
          "կոկոս",
          "կոկոսի յուղ",
          "սուրճ",
          "եգիպտացորենի ձեթ",
          "կաթնաշոռ",
          "ծովախեցգետին",
          "լոռամիրգ",
          "սեր",
          "կրեմ",
          "վարունգ",
          "չաման",
          "հաղարջ",
          "կարրիի փոշի",
          "խտուտիկ",
          "խուրմա",
          "սամիթ",
          "ծիրանաչիր",
          "բադ",
          "սմբուկ",
          "բադրիջան",
          "ձու",
          "ֆեյխոա",
          "ֆենխել",
          "ֆետա պանիր",
          "թուզ",
          "ալյուր",
          "գալանգալ",
          "սխտոր",
          "այծի պանիր",
          "այծի կաթ",
          "խաղողի սերմի յուղ",
          "գրեյպֆրուտ",
          "խաղող",
          "կանաչ բիբար",
          "կանաչ թեյ",
          "խոզապուխտ",
          "պնդուկ",
          "կաղին",
          "մեղր",
          "ծովաբողկ",
          "հումուս",
          "դոնդող",
          "կիվի",
          "գառան միս",
          "կիտրոն",
          "ոսպ",
          "կաթնուկ",
          "օմար",
          "մշկընկույզ",
          "սկումբրիա",
          "մանդարին",
          "մանգո",
          "մարգարին",
          "սեխ",
          "կաթ",
          "անանուխ",
          "մոցառելլա",
          "սունկ",
          "մանանեխ",
          "նեկտարին",
          "վարսակ",
          "ութոտնուկ",
          "ձիթապտղի ձեթ",
          "ձիթապտուղ",
          "սոխ",
          "նարինջ",
          "օրեգոնո",
          "ոստրե",
          "տանձ",
          "պապայա",
          "պարմեզան պանիր",
          "մաղադանոս",
          "մակարոն",
          "դեղձ",
          "գետնանուշ",
          "սիսեռ",
          "անանուխ",
          "արքայախնձոր",
          "պիստակ",
          "սալոր",
          "նուռ",
          "խոզի միս",
          "կարտոֆիլ",
          "պրովոլոն պանիր",
          "դդում",
          "բողկ",
          "չամիչ",
          "ազնվամորի",
          "կարմիր կաղամբ",
          "բրինձ",
          "խնկունի",
          "աշորա",
          "սաղմոն",
          "սարդինաձուկ",
          "երշիկ",
          "նրբերշիկ",
          "ծովի աղ",
          "իշխան",
          "սիգ",
          "սոյա",
          "գանգրակաղամբ",
          "սպանախ",
          "դդմիկ",
          "ելակ",
          "շաքար",
          "արեւածաղկի ձեթ",
          "արեւածաղկի սերմ",
          "թրաձուկ",
          "թարխուն",
          "թեյ",
          "լոլիկ",
          "թյուննոս",
          "հնդկահավ",
          "քացախ",
          "ընկույզ",
          "ձմերուկ",
          "ցորեն",
          "յոգուրտ",
          "ցուկկինի"
        ],
        "measurements": [
          "թեյի գդալ",
          "ճաշի գդալ",
          "բաժակ",
          "պինտա",
          "կվարտա",
          "գալոն"
        ],
        "metric_measurements": [
          "միլիլիտր",
          "դեցիլիտր",
          "սանտիլիտր",
          "լիտր"
        ],
        "spices": [
          "պղպեղ հոտավետ",
          "անիսոն",
          "հետոոտիկ",
          "ասաֆոեթիդա",
          "ռեհան",
          "կաժունի համեմունք",
          "քարդամոմ",
          "կայնեյան պղպեղ",
          "նեխուր",
          "նեխուրի սերմ",
          "երիցուկ",
          "կերբելուկ",
          "չիլի պղպեղ",
          "մանր սոխ",
          "դարչին",
          "մեխակ",
          "գինձ",
          "համեմ",
          "չաման",
          "մաղադանոս",
          "սուսամբար",
          "մանանեխ",
          "հազրեվարդ",
          "բահար",
          "անանուխ",
          "խնկունի",
          "կարամ մասալա",
          "սամիթ",
          "կոճապղպեղ",
          "քրքում",
          "բերբերին",
          "ծորենի",
          "մշկընկույզ",
          "դափնու տերև",
          "կարրի",
          "սամիթ",
          "գալանգալ",
          "սխտոր",
          "լավանդ",
          "պղպեղ",
          "պղպեղահատ",
          "պիրի պիրի համեմունք",
          "զաֆրան",
          "քնջութ",
          "թարխուն",
          "ուրց",
          "քրքում",
          "վանիլ"
        ],
        "vegetables": [
          "կանկար",
          "արուգուլա",
          "ծնեբեկ",
          "ծնեփակ",
          "լոբի",
          "սեխ",
          "բակլա",
          "ճակնդեղ",
          "տակ",
          "բրոկոլի",
          "բրոկոլինի",
          "բրյուսելյան կաղամբ",
          "կաղամբ",
          "ծաղկակաղամբ",
          "նեխուր",
          "կարոս",
          "չինական կաղամբ",
          "վարունգ",
          "սմբուկ",
          "բադրիջան",
          "սպանախ",
          "սխտոր",
          "մանր սոխ",
          "կանաչ բիբար",
          "մառոլ",
          "գանգրակաղամբ",
          "կոլղիբի",
          "պրաս",
          "սոխ",
          "գազար",
          "ոլոռ",
          "սիսեռ",
          "բիբար",
          "ձմերուկ",
          "կարտոֆիլ",
          "դդում",
          "բողկ",
          "կարմիր կաղամբ",
          "պոմիդոր",
          "կարմիր բիբար",
          "խավարծիլ",
          "դդմիկ",
          "լոլիկ",
          "քաղցր կարտոֆիլ",
          "բազուկ",
          "շաղգամ",
          "ցուկկինի"
        ]
      },
      "internet": {
        "domain_suffix": [
          "am",
          "com",
          "info",
          "net",
          "org"
        ]
      },
      "job": {
        "education_level": [
          "բակալավր",
          "մագիստրոս",
          "գիտությունների թեկնածու",
          "գիտությունների դոկտոր"
        ],
        "employment_type": [
          "լրիվ դրույք",
          "կես դրույք",
          "ժամանակավոր",
          "պայմանագրային",
          "պրակտիկա",
          "կոմիսիոն վճար"
        ],
        "field": [
          "մարկետինգ",
          "տեղեկատվական տեխնոլոգիաներ",
          "հաշվապահություն",
          "ադմինիստրացիա",
          "գովազդային գործ",
          "բանկային գործ",
          "համայնքային ծառայություններ",
          "շինարարություն",
          "խորհրդատվություն",
          "դիզայն",
          "կրթություն",
          "գյուղատնտեսություն",
          "կառավարում",
          "առողջապահություն",
          "արտադրություն",
          "հանքարդյունաբերություն",
          "անշարժ գույք",
          "առևտուր",
          "տեխնոլոգիա"
        ],
        "field_of": [
          "մարկետինգի",
          "տեղեկատվական տեխնոլոգիաների",
          "գովազդային գործի",
          "բանկային գործի",
          "համայնքային ծառայությունների",
          "շինարարության",
          "դիզայնի",
          "կրթության",
          "գյուղատնտեսության",
          "կառավարման",
          "առողջապահության",
          "արտադրության",
          "հանքարդյունաբերության",
          "անշարժ գույքի",
          "առևտրի"
        ],
        "key_skills": [
          "բիզնես միջավայրի իմացություն",
          "թիմային աշխատանք",
          "լավ հաղորդակցվելու ընդունակություն",
          "խնդիրներ լուծելու հմտություն",
          "բանակցություններ վարելու հմտություն",
          "կազմակերպելու ունակություն",
          "ճնշման տակ աշխատելու ունակություն",
          "վստահություն",
          "արագ սովորելու ունակություն"
        ],
        "position": [
          "կառավարիչ",
          "ղեկավար",
          "մենեջեր",
          "ինժեներ",
          "մասնագետ",
          "տնօրեն",
          "համակարգող",
          "ադմինիստրատոր",
          "ճարտարապետ",
          "վերլուծաբան",
          "դիզայներ",
          "պլանավորող",
          "տեխնիկ",
          "ծրագրավորող",
          "պրոդյուսեր",
          "խորհրդատու",
          "օգնական",
          "գործակալ",
          "ներկայացուցիչ",
          "թեստավորող"
        ],
        "seniority": [
          "կրտսեր",
          "առաջատար",
          "ավագ",
          "գլխավոր"
        ],
        "title": [
          "#{field_of} #{seniority} #{position}",
          "#{field_of} #{position}",
          "#{seniority} #{position}"
        ]
      },
      "military": {
        "army_rank": [
          "շարքային",
          "եֆրեյտոր",
          "կրտսեր սերժանտ",
          "սերժանտ",
          "ավագ սերժանտ",
          "ավագ",
          "ենթասպա",
          "ավագ ենթասպա",
          "լեյտենանտ",
          "ավագ լեյտենանտ",
          "կապիտան",
          "մայոր",
          "փոխգնդապետ",
          "գնդապետ",
          "գեներալ-մայոր",
          "գեներալ-լեյտենանտ",
          "գեներալ-գնդապետ"
        ]
      },
      "name": {
        "female_first_name": [
          "Ագապի",
          "Աիդա",
          "Ալեքսանդրա",
          "Ալինա",
          "Ալիսա",
          "Ալվարդ",
          "Ալլա",
          "Անիտա",
          "Ամալյա",
          "Անահիտ",
          "Անաստասիա",
          "Անժելա",
          "Անգելինա",
          "Անի",
          "Անյա",
          "Աննա",
          "Անտոնինա",
          "Անուշ",
          "Աստղիկ",
          "Արաքսյա",
          "Արևիկ",
          "Արմինե",
          "Արմենուհի",
          "Արփինե",
          "Բարբարա",
          "Բեթի",
          "Բելլա",
          "Բրիժիտ",
          "Բրիջիտ",
          "Գաբրիելլա",
          "Գայանե",
          "Գյուլնարա",
          "Գոհար",
          "Գրետա",
          "Դանիելլա",
          "Դիանա",
          "Դինա",
          "Ելենա",
          "Եվա",
          "Եվգինե",
          "Երանուհի",
          "Զարուհի",
          "Էլեն",
          "Էլիզա",
          "Էլինա",
          "Էմիլիա",
          "Էմմա",
          "Էրիկա",
          "Էվելինա",
          "Թագուհի",
          "Թամարա",
          "Թեհմինե",
          "Թերեզա",
          "Թինա",
          "Ժաքլին",
          "Ժաննա",
          "Իզաբելլա",
          "Ինգա",
          "Ինեսա",
          "Իննա",
          "Իրինա",
          "Լալա",
          "Լառա",
          "Լարիսա",
          "Լաուրա",
          "Լեյլա",
          "Լենա",
          "Լիա",
          "Լիանա",
          "Լիդա",
          "Լիզա",
          "Լիլիթ",
          "Լուսինե",
          "Լուիզա",
          "Ծովինար",
          "Կարինե",
          "Կարոլին",
          "Կասանդրա",
          "Կիրա",
          "Կլարա",
          "Հայկուհի",
          "Հասմիկ",
          "Հեղինե",
          "Հերմինե",
          "Հիլդա",
          "Հռիփսիմե",
          "Հրաչուհի",
          "Մագդա",
          "Մանե",
          "Մարգարիտա",
          "Մարթա",
          "Մարիամ",
          "Մարինե",
          "Մարիա",
          "Մարիաննա",
          "Մելանյա",
          "Մելինե",
          "Միլենա",
          "Մերի",
          "Մոնիկա",
          "Նազելի",
          "Նաիրա",
          "Նանա",
          "Նանե",
          "Նատաշա",
          "Նարե",
          "Նարինե",
          "Նելլի",
          "Նինա",
          "Նոննա",
          "Նորա",
          "Նվարդ",
          "Նունե",
          "Շահանե",
          "Շուշանիկ",
          "Պատրիսիա",
          "Ջեմմա",
          "Ջեյն",
          "Ջեսիկա",
          "Ջուլիետա",
          "Ռաիսա",
          "Ռեբեկա",
          "Ռիմա",
          "Ռիտա",
          "Ռուզան",
          "Սաթենիկ",
          "Սառա",
          "Սեդա",
          "Սեսիլիա",
          "Սիլվա",
          "Սիրարփի",
          "Սյուզաննա",
          "Սոնա",
          "Սոֆյա",
          "Սվետլանա",
          "Ստելլա",
          "Սուսաննա",
          "Վերոնիկա",
          "Վիկտորյա",
          "Վիոլետա",
          "Տաթևիկ",
          "Քիմ",
          "Քնարիկ",
          "Քրիստինե",
          "Օլգա",
          "Օվսաննա",
          "Օֆելյա",
          "Ֆլորա",
          "Ֆրիդա"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Աբազյան",
          "Աբաղյան",
          "Աբաղյանց",
          "Աբամելիքյան",
          "Աբաշյան",
          "Աբաջանյան",
          "Աբաջյան",
          "Աբասյան",
          "Աբգարյան",
          "Աբդալյան",
          "Աբդոյան",
          "Աբեթնակյան",
          "Աբելանց",
          "Աբելյան",
          "Աբեղյան",
          "Աբեշյան",
          "Աբեսալոմյանց",
          "Աբթեքյան",
          "Աբիսալոմյան",
          "Աբիսողոմոնյան",
          "Աբոյան",
          "Աբովյան",
          "Աբուջանյան",
          "Աբուսեֆյան",
          "Աբրահամյան",
          "Աբրոյան",
          "Ագիլյան",
          "Ագիշյան",
          "Ագլինցյան",
          "Ագշեհիրյան",
          "Ագոզյան",
          "Ագուլյան",
          "Ագուջյան",
          "Ագրալյան",
          "Ագրակլյան",
          "Ագրամազյան",
          "Ագրապյան",
          "Ագրիպասյան",
          "Ագրյան",
          "Ադաբաշյան",
          "Ադաթուրյան",
          "Ադալյան",
          "Ադամյան",
          "Ադամյանց",
          "Ադանալյան",
          "Ադանելյան",
          "Ադանյան",
          "Ադաջյան",
          "Ադելյան",
          "Ադեյան",
          "Ադիբեկ-Մելիքյան",
          "Ադիբեկյան",
          "Ադիգյոզալյան",
          "Ադիգոզյան",
          "Ադիլխանյան",
          "Ադիլյան",
          "Ադիխանյան",
          "Ադիմզալյան",
          "Ադիյան",
          "Ադիշյան",
          "Ադլխանյան",
          "Ադյան",
          "Ադոյան",
          "Ադոնց",
          "Ադուլյան",
          "Ադունց",
          "Ադրունի",
          "Ազաբյան",
          "Ազանյան",
          "Ազատիկյան",
          "Ազատխանյան",
          "Ազատյան",
          "Ազատյանց",
          "Ազարամյան",
          "Ազարբեկյան",
          "Ազարիկյան",
          "Ազարյան",
          "Ազարումյան",
          "Ազբեկյան",
          "Ազգալդյան",
          "Ազգալդրյան",
          "Ազգելդյան",
          "Ազգուլյան",
          "Ազդարյան",
          "Ազիզբեկյան",
          "Ազիզխանյան",
          "Ազիզյան",
          "Ազիլազյան",
          "Ազիկյան",
          "Ազիրյան",
          "Ազյան",
          "Ազնավուրյան",
          "Ազոյան",
          "Ազուլյան",
          "Ազրյան",
          "Ազրոյան",
          "Աթաբահյան",
          "Աթաբեկյան",
          "Աթաբեկյանց",
          "Աթագյուլյան",
          "Աթալարյան",
          "Աթալյան",
          "Աթալյանց",
          "Աթախանյան",
          "Աթամանյան",
          "Աթամյան",
          "Աթայան",
          "Աթանագինյան",
          "Աթանասյան",
          "Աթանեսյան",
          "Աթանոսյան",
          "Աթաշյան",
          "Աթաջյան",
          "Աթասյան",
          "Աթասունց",
          "Աթարբեկյան",
          "Աթարյան",
          "Աթաքյան",
          "Աթբաշյան",
          "Աթեճյան",
          "Աթեշյան",
          "Աթերզյան",
          "Աթինիզյան",
          "Աթինյան",
          "Աթլոյան",
          "Աթմաճյան",
          "Աթմաջյան",
          "Աթյան",
          "Աթոյան",
          "Աթոռակալյան",
          "Աթումյան",
          "Աթչյան",
          "Աթքյան",
          "Աժանջյան",
          "Աժդահարյան",
          "Աժդարյան",
          "Աժդերհանյան",
          "Աժտեհանյան",
          "Աժտերխանյան",
          "Աժտիկյան",
          "Ալաբաշյան",
          "Ալաբեկյան",
          "Ալաբերկյան",
          "Ալաբերճյան",
          "Ալագյոզյան",
          "Ալաջաջյան",
          "Ալավերդյան",
          "Ալեքսանյան",
          "Ալոյան",
          "Աղաբաբյան",
          "Աղաբեկյան",
          "Աղաջանյան",
          "Աղասյան",
          "Ամարյան",
          "Ամիրբեկյան",
          "Ամիրխանյան",
          "Այվազյան",
          "Անանյան",
          "Անդրեասյան",
          "Անղալադյան",
          "Անոփյան",
          "Անտոնյան",
          "Առաքելյան",
          "Առուստամյան",
          "Ասատրյան",
          "Ասլանյան",
          "Աստվածատրյան",
          "Ավագյան",
          "Ավդալյան",
          "Ավետիսյան",
          "Ավոյան",
          "Ավչյան",
          "Ատրյան",
          "Արեգյան",
          "Արեշյան",
          "Արզումանյան",
          "Արծրունի",
          "Բաբալյան",
          "Բաբաջանյան",
          "Բաբայան",
          "Բաբուջյան",
          "Բագրատյան",
          "Բագրատունի",
          "Բադալյան",
          "Բադալով",
          "Բադասյան",
          "Բադեյան",
          "Բադիկյան",
          "Բազեյան",
          "Բազունց",
          "Բակունց",
          "Բաղդասարյան",
          "Բարսեղյան",
          "Բեկզադյան",
          "Բեկզադով",
          "Բեկյան",
          "Բեկնազարյան",
          "Բեջանյան",
          "Բերբերյան",
          "Բոյաջյան",
          "Բոստանջյան",
          "Բունիաթյան",
          "Բուռնազյան",
          "Գաբոյան",
          "Գաբուզյան",
          "Գաբրիելյան",
          "Գալաչյան",
          "Գալստյան",
          "Գալդունց",
          "Գալֆայան",
          "Գալոյան",
          "Գասպարյան",
          "Գասպարով",
          "Գավալջյան",
          "Գարասեֆերյան",
          "Գերավետյան",
          "Գզիրյան",
          "Գիլոյան",
          "Գիմիշյան",
          "Գլեչյան",
          "Գյանջեցյան",
          "Գյուլնազարյան",
          "Գյումուշյան",
          "Գնունի",
          "Գրիգորյան",
          "Գուլաքսյան",
          "Գուլումյան",
          "Գևորգյան",
          "Դաբաղյան",
          "Դադալյան",
          "Դադասյան",
          "Դալլաքյան",
          "Դանիելյան",
          "Դարբինյան",
          "Դարչինյան",
          "Դեմուրյան",
          "Դևրիկյան",
          "Դիմաքսյան",
          "Դոդոխյան",
          "Դոլուխանյան",
          "Դոլուխանով",
          "Դոխոլյան",
          "Դոխոյան",
          "Դոխոյանց",
          "Դովլաթբեկյան",
          "Դովլաթյան",
          "Դուդուկչյան",
          "Դուզճակատչյան",
          "Դուվալյան",
          "Եգանյան",
          "Եգորյան",
          "Եղիազարյան",
          "Եղնուկյան",
          "Ենգիբարյան",
          "Ենգիբարով",
          "Ենգոյան",
          "Ենիգոմեշյան",
          "Ենոքյան",
          "Եսայան",
          "Երեմյան",
          "Երիբեկյան",
          "Երկանյան",
          "Եփրեմյան",
          "Զադոյան",
          "Զազյան",
          "Զանազանյան",
          "Զավրիյան",
          "Զավարյան",
          "Զատիկյան",
          "Զարգարյան",
          "Զարյան",
          "Զարուբյան",
          "Զաքարյան",
          "Զաքյան",
          "Զաքոյան",
          "Զելվեյան",
          "Զեյթունցյան",
          "Զեյնալյան",
          "Զոհրաբյան",
          "Զոլյան",
          "Զուռնաչյան",
          "Զուրաբյան",
          "Էլբակյան",
          "Էլոյան",
          "Էլչիբեկյան",
          "Էնֆիաջյան",
          "Էսկիբաշյան",
          "Ըրղաթբաշյան",
          "Թադևոսյան",
          "Թաթուլյան",
          "Թաթունց",
          "Թամազյան",
          "Թաշչյան",
          "Թարաքաջյան",
          "Թառայան",
          "Թերզյան",
          "Թեքեյան",
          "Թովմասյան",
          "Թորգոմյան",
          "Թորոսյան",
          "Թովուլջյան",
          "Թումանյան",
          "Թևոսյան",
          "Ժամագործյան",
          "Ժամկոչյան",
          "Իբրահիմբեկյան",
          "Իգիթբաշյան",
          "Իգիթխանյան",
          "Իգիթյան",
          "Իզմիրյան",
          "Իմաստունյան",
          "Իմեքչյան",
          "Իշլեմեճյան",
          "Իշխանյան",
          "Իշտոյան",
          "Իսաբեկյան",
          "Իսաբեկյանց",
          "Իսահակյան",
          "Իսկանդարյան",
          "Իսրայելյան",
          "Լազարյան",
          "Լազարյանց",
          "Լալայան",
          "Լալայանց",
          "Լամբարյան",
          "Լեմենցյան",
          "Լիպարիտյան",
          "Լպուտյան",
          "Լցկարյան",
          "Լուսպարոնյան",
          "Խազաբաշյան",
          "Խազխազյան",
          "Խալաֆյան",
          "Խալիկյան",
          "Խանբաբյան",
          "Խանզադյան",
          "Խաշմանյան",
          "Խաչատրյան",
          "Խաչատրյանց",
          "Խաչենց",
          "Խաչիկօղլյան",
          "Խառատյան",
          "Խեչանյան",
          "Խզմալյան",
          "Խլղաթյան",
          "Խնկոյան",
          "Խոդիկյան",
          "Խուդոյան",
          "Ծաղիկյան",
          "Ծառուկյան",
          "Ծատուրյան",
          "Ծերունյան",
          "Ծորմոտյան",
          "Ծպնեցյան",
          "Ծուռվիզյան",
          "Կաբակուլակյան",
          "Կաբաղյան",
          "Կաբասկալյան",
          "Կադարջյան",
          "Կալդրիկյան",
          "Կալենց",
          "Կալպակչյան",
          "Կամսարյան",
          "Կամսարյանց",
          "Կայֆեջյան",
          "Կաշեգործյան",
          "Կարագյան",
          "Կարախանյան",
          "Կարամանուկյան",
          "Կարապետյան",
          "Կարճիկյան",
          "Կետիկյան",
          "Կոթողյան",
          "Կոնդախչյան",
          "Կոշկակարյան",
          "Կոստանյան",
          "Կրպեյան",
          "Կույումջանյան",
          "Հալաբյան",
          "Հախվերդյան",
          "Հակոբյան",
          "Համբարձումյան",
          "Հայրապետյան",
          "Հայրբաբամյան",
          "Հայրիկյան",
          "Հատիկյան",
          "Հաջինյան",
          "Հարությունյան",
          "Հովասափյան",
          "Հովհաննիսյան",
          "Հովիվյան",
          "Հովսեփյան",
          "Հովսեփով",
          "Հուրդաջյան",
          "Ձավարյան",
          "Ձիթողցյան",
          "Ձիլֆուղարյան",
          "Ձկնորսյան",
          "Ձվակերյան",
          "Ղաբզիմալյան",
          "Ղազախեթյան",
          "Ղազանչյան",
          "Ղազարյան",
          "Ղազարով",
          "Ղազինյան",
          "Ղալդունց",
          "Ղալթախչյան",
          "Ղահրամանյան",
          "Ղամբարյան",
          "Ղայլունջյան",
          "Ղայֆեճյան",
          "Ղանդիլյան",
          "Ղասաբյան",
          "Ղասաբօղլյան",
          "Ղափլանյան",
          "Ղոլթաղչյան",
          "Ճալտիկյան",
          "Ճաղարյան",
          "Ճանճապանյան",
          "Ճանսուզյան",
          "Ճապաղջուրյան",
          "Ճգնավորյան",
          "Ճենեպերեքյան",
          "Ճիվասզյան",
          "Ճոճկանյան",
          "Ճուղուրյան",
          "Մադաթյան",
          "Մազմանյան",
          "Մանանդյան",
          "Մանուկյան",
          "Մանվելյան",
          "Մարաշյան",
          "Մարգարյան",
          "Մելիք-Աբրահամյան",
          "Մելիք-Ադամյան",
          "Մելիք-Ասլանյան",
          "Մելիք-Բարխուդարյան",
          "Մելիք-Օհանջանյան",
          "Մեհրաբյան",
          "Միկոյան",
          "Մինասբեկյան",
          "Մինասյան",
          "Միսակյան",
          "Միրզոյան",
          "Միրզոյանց",
          "Միքայելյան",
          "Մխիթարյան",
          "Մնացականյան",
          "Մշեցյան",
          "Մովսիսյան",
          "Մոսինյան",
          "Մսագործյան",
          "Մսրյան",
          "Մուշեղյան",
          "Մուշկամբարյան",
          "Մուսայելյան",
          "Մուրադյան",
          "Յաբլուկյան",
          "Յագուբյան",
          "Յազիչյան",
          "Յաղլիճյան",
          "Յոգուրթչյան",
          "Յուզբաշյան",
          "Յություճյան",
          "Նաբաթյան",
          "Նազարյան",
          "Նալբանդյան",
          "Նալչադյան",
          "Նախշքարյան",
          "Նահապետյան",
          "Ներկարարյան",
          "Ներսեսյան",
          "Ներսիսյան",
          "Նիկողոսյան",
          "Նշանյան",
          "Շաբոյան",
          "Շաբունց",
          "Շագոյան",
          "Շալավասյան",
          "Շահազիզյան",
          "Շահբազյան",
          "Շահինյան",
          "Շահինյանց",
          "Շահնազարյան",
          "Շարաբխանյան",
          "Շաքարյան",
          "Շաքրամանյան",
          "Շելունց",
          "Շուքուրյան",
          "Ոսկանյան",
          "Ոսկերչյան",
          "Չալիկյան",
          "Չալխիֆալակյան",
          "Չալոյան",
          "Չախմախչյան",
          "Չեմեդիկյան",
          "Չեպչյան",
          "Չեքիջյան",
          "Չիբուխչյան",
          "Չիլինգարյան",
          "Չիվչյան",
          "Չոբանյան",
          "Պալյան",
          "Պապայան",
          "Պապիկյան",
          "Պապոյան",
          "Պառավյան",
          "Պարոնիկյան",
          "Պարոնյան",
          "Պարոնյանց",
          "Պարսամյան",
          "Պերեճիկլյան",
          "Պետրոսյան",
          "Պետրոսյանց",
          "Պոզապալյան",
          "Պողոսյան",
          "Պողպատյան",
          "Պռոշյան",
          "Պստիկյան",
          "Ջալալբեկյան",
          "Ջանավարյան",
          "Ջանգիրյան",
          "Ջանիբեկյան",
          "Ջանջուղազյան",
          "Ջանփոլադյան",
          "Ջանունց",
          "Ջերեջյան",
          "Ջիգարխանյան",
          "Ջուլֆիղարյան",
          "Ռաշիդյան",
          "Ռասիմոսյան",
          "Ռևազյան",
          "Ռշտունի",
          "Ռոստոմյան",
          "Ռուբինյան",
          "Ռուստամյան",
          "Ռուստամյանց",
          "Սադոյան",
          "Սաթյան",
          "Սալբաշյան",
          "Սահակյան",
          "Սանթրոսյան",
          "Սանոյան",
          "Սարգսյան",
          "Սարխոյան",
          "Սարոյան",
          "Սիսոյան",
          "Սաֆարյան",
          "Սեմերջյան",
          "Սիմոնյան",
          "Սիրունյան",
          "Սոլախյան",
          "Սողոմոնյան",
          "Ստեփանյան",
          "Սրմաքեշյան",
          "Սուրմելյան",
          "Սուփրիկյան",
          "Սուքիասյան",
          "Վազիգեղցյան",
          "Վահանյան",
          "Վահունի",
          "Վանեցյան",
          "Վանյան",
          "Վարդապետյան",
          "Վարդերեսյան",
          "Վարոսյան",
          "Վարպետյան",
          "Վերանյան",
          "Վրացյան",
          "Տաճատյան",
          "Տասնապետյան",
          "Տարոնցյան",
          "Տեր-Գևորգյան",
          "Տեր-Հովհաննիսյան",
          "Տեր-Ղազարյան",
          "Տեր-Վահանյան",
          "Տոնոյան",
          "Տոպաջիկյան",
          "Տուղրեմաճյան",
          "Ցախկլորյան",
          "Ցիպլեցյան",
          "Ցոլակյան",
          "Ցրտատարյան",
          "Ուզանկիչյան",
          "Ուզունյան",
          "Ութմազյան",
          "Ուլիխանյան",
          "Ուլուբաբյան",
          "Ուստաբաշյան",
          "Ուրֆալյան",
          "Փալանդուզյան",
          "Փախչանյան",
          "Փահլևանյան",
          "Փամբուխչյան",
          "Փամբուկչյան",
          "Փայլաբազյան",
          "Փանոսյան",
          "Փաշայան",
          "Փաշինյան",
          "Փարաջանյան",
          "Փարաքեսիկյան",
          "Փարսադանյան",
          "Փափազյան",
          "Փիլիփոսյան",
          "Փոքրիկյան",
          "Քաթանասյան",
          "Քալանթարյան",
          "Քալաշյան",
          "Քաղցրիկյան",
          "Քարտաշյան",
          "Քափանակցյան",
          "Քեշիշյան",
          "Քեչօղլյան",
          "Քիլարջյան",
          "Քյոսայան",
          "Քոչարյան",
          "Քոչինյան",
          "Քրմոյան",
          "Քրքորյան",
          "Քուշքյան",
          "Օդյան",
          "Օզանյան",
          "Օզնեցյան",
          "Օհանյան",
          "Օրբելյան",
          "Ֆալյան",
          "Ֆահրադյան",
          "Ֆոլյան",
          "Ֆռանգյան",
          "Ֆրանգուլյան"
        ],
        "male_first_name": [
          "Սիմոն",
          "Ուիլյամ",
          "Ստեֆան",
          "Ռիչարդ",
          "Ֆիլիպ",
          "Ջոն",
          "Հովիկ",
          "Հենրի",
          "Ջորջ",
          "Գարրի",
          "Ֆելիքս",
          "Լևոն",
          "Դոմինիկ",
          "Դենիս",
          "Դանիել",
          "Կլոդ",
          "Քրիստոֆեր",
          "Չարլի",
          "Կարլ",
          "Բորիս",
          "Բեռնար",
          "Անդրեաս",
          "Ալեքսանդր",
          "Աբրահամ",
          "Աբել",
          "Ահարոն",
          "Օլեգ",
          "Փայլակ",
          "Ցոլակ",
          "Րաֆֆի",
          "Տարոն",
          "Վլադիմիր",
          "Վիկտոր",
          "Վահե",
          "Վախթանգ",
          "Վազգեն",
          "Ստեփան",
          "Սեյրան",
          "Սերգեյ",
          "Ռուդոլֆ",
          "Ռուբեն",
          "Ռոման",
          "Ռոբերտ",
          "Ռաֆայել",
          "Շահեն",
          "Նորայր",
          "Նշան",
          "Նարեկ",
          "Նաիրի",
          "Յուրի",
          "Մուրադ",
          "Մխիթար",
          "Մաքսիմ",
          "Մարկոս",
          "Մանվել",
          "Կարեն",
          "Էդուարդ",
          "Էդգար",
          "Զոհրաբ",
          "Գրիգոր",
          "Գոռ",
          "Գևորգ",
          "Գաբրիել",
          "Արման",
          "Արթուր",
          "Անդրանիկ",
          "Ալբերտ",
          "Ադամ",
          "Աբել",
          "Հովհաննես",
          "Աբիգ",
          "Ավետիք",
          "Ավետիս",
          "Աղասի",
          "Ազատ",
          "Հայկ",
          "Հայկազ",
          "Հակոբ",
          "Համազասպ",
          "Հմայակ",
          "Առաքել",
          "Արամ",
          "Արամազդ",
          "Արգամ",
          "Արգիշտի",
          "Արեգ",
          "Արիստակես",
          "Արմեն",
          "Արմենակ",
          "Արսեն",
          "Արտավազդ",
          "Արտակ",
          "Արտաշես",
          "Արտեմ",
          "Արտուր",
          "Արտուշ",
          "Հարություն",
          "Առուշան",
          "Արշավիր",
          "Արշակ",
          "Ատոմ",
          "Աշոտ",
          "Բաբկեն",
          "Բաղդասար",
          "Բաղիշ",
          "Բաղրամ",
          "Բագրատ",
          "Բարսեղ",
          "Բարխուդար",
          "Վահագն",
          "Վահան",
          "Վաղարշակ",
          "Վահրամ",
          "Վարուժան",
          "Վասակ",
          "Գագիկ",
          "Գալուստ",
          "Գարեգին",
          "Գառնիկ",
          "Գարսևան",
          "Գասպար",
          "Գեղամ",
          "Հրանտ",
          "Գուրգեն",
          "Դավիթ",
          "Դերենիկ",
          "Ջիվան",
          "Եղիշ",
          "Երվանդ",
          "Ժիրայր",
          "Զավեն",
          "Զորի",
          "Զոհրապ",
          "Կիկոս",
          "Կիրակոս",
          "Կորյուն",
          "Մամիկոն",
          "Մարգար",
          "Մհեր",
          "Մելքոն",
          "Մելքում",
          "Մեսրոպ",
          "Մեխակ",
          "Միհրան",
          "Մինաս",
          "Մուշեղ",
          "Ներսես",
          "Նուբար",
          "Օհան",
          "Փանոս",
          "Պարգև",
          "Պարթև",
          "Պարույր",
          "Պատվական",
          "Պետրոս",
          "Պողոս",
          "Սահակ",
          "Սաղաթել",
          "Սանասար",
          "Սարգիս",
          "Սասուն",
          "Սերոբ",
          "Սմբատ",
          "Սպարտակ",
          "Սուքիաս",
          "Սուրեն",
          "Թադևոս",
          "Թաթոս",
          "Թաթուլ",
          "Տիգրան",
          "Թորգոմ",
          "Թորոս",
          "Տրդատ",
          "Հունան",
          "Հուսիկ",
          "Խորեն",
          "Խոսրով",
          "Շավարշ",
          "Շմավոն"
        ],
        "name": [
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{male_first_name}ի #{last_name}"
        ]
      },
      "nation": {
        "capital_city": [
          "Քաբուլ",
          "Տիրանա",
          "Լուանդա",
          "Բուենոս Այրես",
          "Երևան",
          "Կանբերա",
          "Վիեննա",
          "Բաքու",
          "Մանամա",
          "Դաքքա",
          "Բրիջթաուն",
          "Մինսկ",
          "Բրյուսել",
          "Բելմոպան",
          "Պորտո Նովո",
          "Սարաևո",
          "Գաբորոնե",
          "Բրազիլիա",
          "Սոֆիա",
          "Բույումբուրա",
          "Պնոմպեն",
          "Օտտավա",
          "Սանտիագո",
          "Պեկին",
          "Բոգոտա",
          "Կինշասա",
          "Զագրեբ",
          "Հավանա",
          "Նիկոսիա",
          "Պրահա",
          "Կոպենհագեն",
          "Ջիբութի",
          "Կահիրե",
          "Սան Սալվադոր",
          "Տալլին",
          "Ադիս Աբեբա",
          "Հելսինկի",
          "Փարիզ",
          "Թբիլիսի",
          "Բեռլին",
          "Աթենք",
          "Ջորջթաուն",
          "Բուդապեշտ",
          "Ռեյկյավիկ",
          "Նոր Դելի",
          "Ջակարտա",
          "Թեհրան",
          "Բաղդադ",
          "Դուբլին",
          "Երուսաղեմ",
          "Հռոմ",
          "Տոկիո",
          "Ամման",
          "Աստանա",
          "Նայրոբի",
          "Սեուլ",
          "Բիշքեկ",
          "Ռիգա",
          "Բեյրութ",
          "Տրիպոլի",
          "Վիլնյուս",
          "Լյուքսեմբուրգ",
          "Կուալա Լումպուր",
          "Մեխիկո",
          "Կատմանդու",
          "Օսլո",
          "Իսլամաբադ",
          "Լիմա",
          "Մանիլա",
          "Վարշավա",
          "Լիսաբոն",
          "Բուխարեստ",
          "Մոսկվա",
          "Ռիադ",
          "Դակար",
          "Բելգրադ",
          "Սինգապուր",
          "Բրատիսլավա",
          "Լյուբլյանա",
          "Մոգադիշու",
          "Մադրիդ",
          "Խարտում",
          "Ստոկհոլմ",
          "Բեռն",
          "Դամասկոս",
          "Տայպեյ",
          "Դուշանբե",
          "Դարս Սալամ",
          "Բանգկոկ",
          "Թունիս",
          "Անկարա",
          "Աշգաբատ",
          "Կիև",
          "Աբու Դաբի",
          "Լոնդոն",
          "Վաշինգտոն",
          "Մոնտեվիդեո",
          "Տաշքենդ",
          "Կարակաս",
          "Հանոյ"
        ],
        "language": [
          "նեպալերեն",
          "հինդի",
          "անգլերեն",
          "ճապոներեն",
          "արաբերեն",
          "պորտուգալերեն",
          "ռուսերեն",
          "գերմաներեն",
          "կորեերեն",
          "ֆրանսերեն",
          "իտալերեն",
          "թայերեն",
          "տագալերեն",
          "ռումիներեն",
          "հոլանդերեն",
          "ղազախերեն",
          "զուլուսերեն",
          "շվեդերեն",
          "հայերեն",
          "վրացերեն",
          "ադրբեջաներեն",
          "իսպաներեն",
          "թուրքերեն",
          "պարսկերեն",
          "քրդերեն",
          "եբրայերեն",
          "չինարեն",
          "լատիներեն",
          "հունարեն"
        ],
        "nationality": [
          "աղվանացի",
          "ալբանացի",
          "ալժիրցի",
          "ամերիկացի",
          "արգենտինացի",
          "հայ",
          "ավստրալացի",
          "ավստրիացի",
          "բանգլադեշցի",
          "բելառուս",
          "բելգիացի",
          "բոսնիացի",
          "բրազիլացի",
          "բրիտանացի",
          "բուլղարացի",
          "բուրունդցի",
          "կամբոջացի",
          "կամերունցի",
          "կանադացի",
          "կատալոնացի",
          "չիլիացի",
          "չինացի",
          "կոլումբիացի",
          "չեխ",
          "դանիացի",
          "հոլանդացի",
          "Էկվադորցի",
          "եգիպտացի",
          "արաբ",
          "անգլիացի",
          "Էստոնացի",
          "եթովպացի",
          "ֆինն",
          "ֆիջիացի",
          "ֆիլիպինացի",
          "ֆրանսիացի",
          "վրացի",
          "գերմանացի",
          "հույն",
          "հաիթիացի",
          "հոնդուրասցի",
          "հունգարացի",
          "իսլանդացի",
          "հնդիկ",
          "ինդոնեզացի",
          "պարսիկ",
          "իրաքցի",
          "իռլանդացի",
          "իսրայելցի",
          "իտալացի",
          "ճապոնացի",
          "ղազախ",
          "քենիացի",
          "կորեացի",
          "քուրդ",
          "լատվիացի",
          "լիբերիացի",
          "լիբիացի",
          "լիտվացի",
          "մակեդոնացի",
          "մալայզացի",
          "մալավիացի",
          "մեքսիկացի",
          "մոլդովացի",
          "մարոկկացի",
          "մոնղոլ",
          "նիգերիացի",
          "նորվեգացի",
          "պակիստանցի",
          "պաղեստինցի",
          "պերուացի",
          "լեհ",
          "պորտուգալացի",
          "ռումինացի",
          "ռուս",
          "շոտլանդացի",
          "սերբ",
          "սինգապուրցի",
          "սլովակ",
          "սլովեն",
          "հարավային աֆրիկացի",
          "իսպանացի",
          "շվեդ",
          "շվեյցարացի",
          "սիրիացի",
          "տիբեթցի",
          "թունիսցի",
          "թուրք",
          "ուգանդացի",
          "ուկրաինացի",
          "ուզբեկ",
          "վենեսուելացի",
          "վիետնամցի"
        ]
      },
      "phone_number": {
        "country_code": [
          "374"
        ],
        "formats": [
          "###-#####",
          "(###) #####",
          "###.#####",
          "10-######",
          "(10) ######",
          "10.######"
        ]
      },
      "science": {
        "element": [
          "Ջրածին",
          "Հելիում",
          "Լիթիում",
          "Բերիլիում",
          "Բոր",
          "Ածխածին",
          "Ազոտ",
          "Թթվածին",
          "Ֆտոր",
          "Նեոն",
          "Նատրիում",
          "Մագնեզիում",
          "Ալյումին",
          "Սիլիցիում",
          "Ֆոսֆոր",
          "Ծծումբ",
          "Քլոր",
          "Արգոն",
          "Կալիում",
          "Կալցիում",
          "Սկանդիում",
          "Տիտան",
          "Վանադիում",
          "Քրոմ",
          "Մանգան",
          "Երկաթ",
          "Կոբալտ",
          "Նիկել",
          "Պղինձ",
          "Ցինկ",
          "Գալիում",
          "Գերմանիում",
          "Արսեն",
          "Սելեն",
          "Բրոմ",
          "Կրիպտոն",
          "Ռուբիդիում",
          "Ստրոնցիում",
          "Իտրիում",
          "Ցիրկոնիում",
          "Նիոբիում",
          "Մոլիբդեն",
          "Տեխնեցիում",
          "Ռոթենիում",
          "Ռոդիում",
          "Պալադիում",
          "Արծաթ",
          "Կադմիում",
          "Ինդիում",
          "Անագ",
          "Ծարիր",
          "Տելուր",
          "Յոդ",
          "Քսենոն",
          "Ցեզիում",
          "Բարիում",
          "Լանթան",
          "Ցերիում",
          "Պրազեդիում",
          "Նեոդիում",
          "Պրոմեթիում",
          "Սամարիում",
          "Եվրոպիում",
          "Գադոլինիում",
          "Կերբիում",
          "Դիսպրոզիում",
          "Հոլմիում",
          "Էրբիում",
          "Թուլիում",
          "Իտերբիում",
          "Լուտեցիում",
          "Հաֆնիում",
          "Տանտալ",
          "Վոլֆրամ",
          "Ռենիում",
          "Օսմիում",
          "Իրիդիում",
          "Պլատին",
          "Ոսկի",
          "Սնդիկ",
          "Թալիում",
          "Կապար",
          "Բիսմութ",
          "Պոլոնիում",
          "Աստատ",
          "Ռադոն",
          "Ֆրասիում",
          "Ռադիում",
          "Ակտինիում",
          "Թորիում",
          "Պրոտակտինիում",
          "Ուրան",
          "Նեպտունիում",
          "Պլուտոնիում",
          "Ամերիցիում",
          "Կյուրիում",
          "Բերկլիում",
          "Կալիֆորնիում",
          "Էյնշտեյնիում",
          "Ֆերմիում",
          "Մենդելեվիում",
          "Նոբելինիում",
          "Լոուրենսիում",
          "Ռեզերֆորդիում",
          "Դուբնիում",
          "Սիբորգիում",
          "Բորիում",
          "Հասիում",
          "Մայտներիում",
          "Դարմստթոդիում",
          "Ռենտգենիում",
          "Կոպերնիկիում",
          "Նիհոնիում",
          "Ֆլերովիում",
          "Մոսկովիում",
          "Լիվերմորիում",
          "Թենեսին",
          "Օգանեսոն"
        ],
        "scientist": [
          "Իսահակ Նյուտոն",
          "Ալբերտ Էյնշտեյն",
          "Նիլս Բոր",
          "Չարլզ Դարվին",
          "Լուի Պաստյոր",
          "Զիգմունդ Ֆրեյդ",
          "Գալիլեո Գալիլեյ",
          "Անտուան Լորան Լավուազիե",
          "Յոհաննես Կեպլեր",
          "Նիկոլայ Կոպեռնիկոս",
          "Մայքլ Ֆարադեյ",
          "Ջեյմս Մաքսվել",
          "Կլոդ Բեռնար",
          "Ֆրանց Բոաս",
          "Վերներ Հեյզենբերգ",
          "Լինուս Փոլինգ",
          "Ռուդոլֆ Վիրչոու",
          "Էրվին Շրեդինգեր",
          "Էռնեստ Ռուտերֆորդ",
          "Պոլ Դիրաք",
          "Անդրեաս Վեզալիուս",
          "Լյուդվիգ Բոլցման",
          "Մաքս Պլանկ",
          "Մարի Կյուրի",
          "Ուիլյամ Հերշել",
          "Չարլզ Լայել",
          "Պիեռ Սիմոն դե Լապլաս",
          "Էդվին Հաբլ",
          "Ջոզեֆ Ջոն Թոմսոն",
          "Մաքս Բորն",
          "Ֆրենսիս Քրիք",
          "Էնրիկո Ֆերմի",
          "Լեոնարդ Էյլեր",
          "Արթուր Էդինգտոն",
          "Քրիստիան Հյուգենս",
          "Կարլ Գաուս",
          "Դմիտրի Մենդելեև",
          "Ջոն ֆոն Նոյման",
          "Ռիչարդ Ֆեյնման",
          "Սթիվեն Հոքինգ",
          "Անտոնի վան Լևենհուկ",
          "Մաքս Լաուե",
          "Գուստավ Կիրխհոֆ",
          "Էվկլիդես",
          "Գրեգոր Մենդել",
          "Հեյկե Կամերլինգ Օնես",
          "Թոմաս Մորգան",
          "Հերման Հելմհոլց",
          "Ժան Բատիստ Լամարկ",
          "Ջոն Դալթոն",
          "Կառլ Լիննեյ",
          "Կոնրադ Լորենց",
          "Ալեքսանդր Ֆլեմինգ",
          "Վիլհելմ Վունդտ",
          "Արքիմեդես",
          "Բլեզ Պասկալ",
          "Ռենե Դեկարտ",
          "Գոթֆրիդ Լայբնից"
        ]
      },
      "separator": " և ",
      "space": {
        "constellation": [
          "Աղեղնավոր",
          "Այծեղջյուր",
          "Առյուծ",
          "Երկվորյակներ",
          "Խեցգետին",
          "Խոյ",
          "Կառավար",
          "Կարիճ",
          "Կենտավրոս",
          "Կշեռք",
          "Կույս",
          "Ձկներ",
          "Մեծ Արջ",
          "Մեծ Շուն",
          "Որսկան Շներ",
          "Պեգաս",
          "Ջրհոս",
          "Վիշապ",
          "Ցուլ",
          "Փոքր Արջ",
          "Փոքր Առյուծ",
          "Փոքր Շուն",
          "Քնար",
          "Օրիոն"
        ],
        "distance_measurement": [
          "լուսատարի",
          "աստղագիտական միավոր",
          "պարսեկ",
          "կիլոպարսեկ",
          "մեգապարսեկ"
        ],
        "galaxy": [
          "Ծիր Կաթին",
          "Անդրոմեդա",
          "Եռանկյունի",
          "Հորձանուտ",
          "Սև Աչք",
          "Արևածաղիկ",
          "Մեսսյե 83"
        ],
        "meteorite": [
          "Օրհուս",
          "Աբի",
          "Ադելի Երկիր",
          "Հոբա",
          "Քեյփ-Յորք",
          "Շեյխ էլ Ուխեյմիր 169",
          "Յամատո 791197"
        ],
        "moon": [
          "Լուսին",
          "Դեյմոս",
          "Ֆոբոս",
          "Գանիմեդ",
          "Կալիստո",
          "Իո",
          "Եվրոպա",
          "Տիտան",
          "Ռեա",
          "Հաբեթ",
          "Դիոնա",
          "Թետիս",
          "Հիպերիոն",
          "Արիել",
          "Պակ",
          "Օբերոն",
          "Ումբրիել",
          "Տրիտոն",
          "Պրոտեուս"
        ],
        "nebula": [
          "Ծովածոց Միգամածություն",
          "Արծիվ Միգամածություն",
          "Տրիֆիդ Միգամածություն",
          "Օրիոն Միգամածություն",
          "Օղակ Միգամածություն",
          "Անդրոմեդայի Միգամածություն",
          "Բուի Միգամածություն"
        ],
        "planet": [
          "Մերկուրի",
          "Վեներա",
          "Երկիր",
          "Մարս",
          "Յուպիտեր",
          "Սատուրն",
          "Ուրան",
          "Նեպտուն"
        ],
        "star": [
          "Արեգակ",
          "Վոլֆ 359",
          "DX Խեցգետնի",
          "Պրոքսիմա Կենտավրոս",
          "Ալֆա Կենտավրոս",
          "Սիրիուս",
          "Պրոցիոն",
          "Ռոսս 614",
          "Լեյտենի Աստղ",
          "Կապտեյնի Աստղ",
          "Էրիդանի Էպսիլիոն",
          "Կանոպուս",
          "Տոլիման",
          "Արկտուր",
          "Վեգա",
          "Կապելլա",
          "Ռիգել",
          "Ախերնար",
          "Բետելգեյզե",
          "Հադար",
          "Ալտաիր",
          "Ակրուքս",
          "Ալդեբարան",
          "Անտարես",
          "Սպիկա",
          "Պոլլուքս",
          "Ֆոմալհաուտ",
          "Միմոզա",
          "Դենեբ",
          "Ռեգուլ",
          "Ադարա",
          "Կաստոր",
          "Գակրուկս",
          "Շաուլա"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Խնդրում ենք ընտրել"
      },
      "submit": {
        "create": "Ստեղծել %{model}",
        "submit": "Պահպանել %{model}",
        "update": "Թարմացնել %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Միլիարդ",
            "million": "Միլիոն",
            "quadrillion": "Քառյակ",
            "thousand": "Հազար",
            "trillion": "Տրիլիոն",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Բայթ",
              "other": "Բայթ"
            },
            "eb": "ԷԲ",
            "gb": "ԳԲ",
            "kb": "ԿԲ",
            "mb": "ՄԲ",
            "pb": "ՊԲ",
            "tb": "ՏԲ",
            "zb": "ԶԲ"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", և ",
        "two_words_connector": " և ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "կեսօրից առաջ",
      "formats": {
        "default": "%a, %e %b %Y %H:%M:%S %z",
        "long": "%B %e, %Y %H:%M",
        "short": "%e %b %H:%M"
      },
      "pm": "կեսօրից հետո"
    }
  },
  "id": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Konfirmasi terkirim pada",
          "confirmation_token": "Token konfirmasi",
          "confirmed_at": "Dikonfirmasi pada",
          "created_at": "Dibuat pada",
          "current_password": "Kata sandi saat ini",
          "current_sign_in_at": "Waktu masuk saat ini pada",
          "current_sign_in_ip": "Alamat IP masuk saat ini",
          "email": "Email",
          "encrypted_password": "Kata sandi terenkripsi",
          "failed_attempts": "Percobaan gagal",
          "last_sign_in_at": "Terakhir masuk pada",
          "last_sign_in_ip": "Alamat IP terakhir masuk",
          "locked_at": "Dikunci pada",
          "password": "Kata sandi",
          "password_confirmation": "Konfirmasi kata sandi",
          "remember_created_at": "Ingat dibuat pada",
          "remember_me": "Ingat saya",
          "reset_password_sent_at": "Setel ulang kata sandi dikirim pada",
          "reset_password_token": "Token setel ulang kata sandi",
          "sign_in_count": "Jumlah masuk",
          "unconfirmed_email": "Email belum terkonfirmasi",
          "unlock_token": "Token buka kunci",
          "updated_at": "Diubah pada"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validasi gagal: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Tidak bisa menghapus record karena terdapat %{record} yang bergantung",
            "has_one": "Tidak bisa menghapus record karena terdapat satu %{record} yang bergantung"
          }
        }
      },
      "models": {
        "user": {
          "other": "Pengguna"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des"
      ],
      "day_names": [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ],
      "formats": {
        "default": "%d %B %Y",
        "long": "%A, %d %B %Y",
        "short": "%d.%m.%Y"
      },
      "month_names": [
        null,
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "sekitar satu jam",
          "other": "sekitar %{count} jam"
        },
        "about_x_months": {
          "one": "sekitar sebulan",
          "other": "sekitar %{count} bulan"
        },
        "about_x_years": {
          "one": "sekitar setahun",
          "other": "sekitar %{count} tahun"
        },
        "almost_x_years": {
          "one": "hampir setahun",
          "other": "hampir %{count} tahun"
        },
        "half_a_minute": "setengah menit",
        "less_than_x_minutes": {
          "one": "kurang dari %{count} menit",
          "other": "kurang dari %{count} menit",
          "zero": "kurang dari 1 menit"
        },
        "less_than_x_seconds": {
          "one": "kurang dari %{count} detik",
          "other": "kurang dari %{count} detik",
          "zero": "kurang dari 1 detik"
        },
        "over_x_years": {
          "one": "lebih dari setahun",
          "other": "lebih dari %{count} tahun"
        },
        "x_days": {
          "one": "sehari",
          "other": "%{count} hari"
        },
        "x_minutes": {
          "one": "satu menit",
          "other": "%{count} menit"
        },
        "x_months": {
          "one": "sebulan",
          "other": "%{count} bulan"
        },
        "x_seconds": {
          "one": "satu detik",
          "other": "%{count} detik"
        }
      },
      "prompts": {
        "day": "Hari",
        "hour": "Jam",
        "minute": "Menit",
        "month": "Bulan",
        "second": "Detik",
        "year": "Tahun"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Akun anda telah berhasil dikonfirmasi.",
        "new": {
          "resend_confirmation_instructions": "Kirim ulang petunjuk konfirmasi"
        },
        "send_instructions": "Anda akan menerima e-mail berisi instruksi untuk melakukan konfirmasi akun dalam beberapa menit lagi.",
        "send_paranoid_instructions": "Jika alamat email Anda ada di database kami, anda akan menerima email dengan instruksi tentang bagaimana untuk mengkonfirmasi account Anda dalam beberapa menit."
      },
      "failure": {
        "already_authenticated": "Anda sudah masuk.",
        "inactive": "Akun anda belum diaktifkan.",
        "invalid": "%{authentication_keys} atau password adalah tidak valid.",
        "invited": "Anda memiliki undangan yang tertunda, harap terima undangan tersebut untuk menyelesaikan pembuatan akun Anda.",
        "last_attempt": "Kesempatan terakhir sebelum akun Anda dikunci.",
        "locked": "Akun anda terkunci.",
        "not_found_in_database": "%{authentication_keys} atau password adalah tidak valid.",
        "timeout": "Sesi anda telah kadaluarsa, silahkan masuk lagi untuk melanjutkan.",
        "unauthenticated": "Anda harus mendaftar atau masuk sebelum melanjutkan.",
        "unconfirmed": "Anda harus melakukan konfirmasi email Anda sebelum melanjutkan."
      },
      "invitations": {
        "edit": {
          "header": "Atur kata sandi Anda",
          "submit_button": "Atur kata sandi"
        },
        "invitation_removed": "Undangan Anda telah dihapus.",
        "invitation_token_invalid": "Token undangan yang diberikan tidak valid!",
        "new": {
          "header": "Kirim Undangan",
          "submit_button": "Kirim undangan"
        },
        "no_invitations_remaining": "Tidak ada undangan tersisa.",
        "send_instructions": "Email undangan telah dikirim ke %{email}.",
        "updated": "Kata sandi Anda telah berhasil diatur. Anda sudah masuk.",
        "updated_not_active": "Kata sandi Anda telah berhasil diatur."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Konfirmasi akun saya",
          "greeting": "Selamat datang %{recipient}!",
          "instruction": "Anda bisa melakukan konfirmasi email akun Anda menggunakan tautan berikut ini:",
          "subject": "Instruksi untuk melakukan konfirmasi"
        },
        "email_changed": {
          "greeting": "Halo %{recipient}!",
          "message": "Kami menghubungi Anda untuk memberitahu, bahwa email terdaftar Anda telah berubah menjadi %{email}.",
          "message_unconfirmed": "Kami menghubungi Anda untuk memberitahu, bahwa email terdaftar Anda sedang diubah menjadi %{email}.",
          "subject": "Email telah diubah"
        },
        "invitation_instructions": {
          "accept": "Terima Undangan",
          "accept_until": "Undangan ini akan berakhir pada %{due_date}.",
          "hello": "Halo %{email}",
          "ignore": "Jika Anda tidak ingin menerima undangan ini, silakan abaikan email ini. Akun Anda tidak akan dibuat sampai Anda mengakses tautan di atas dan mengatur kata sandi Anda.",
          "someone_invited_you": "Seseorang telah mengundang Anda ke %{url}. Anda dapat menerima undangan ini melalui tautan di bawah ini.",
          "subject": "Instruksi Undangan"
        },
        "password_change": {
          "greeting": "Halo %{recipient}!",
          "message": "Kami menghubungi Anda untuk menyampaikan informasi bahwa password Anda telah diubah",
          "subject": "Password telah diganti"
        },
        "reset_password_instructions": {
          "action": "Ganti password saya",
          "greeting": "Halo %{recipient}!",
          "instruction": "Seseorang telah meminta tautan untuk mengganti password Anda, dan Anda bisa melakukannya menggunakan tautan berikut ini.",
          "instruction_2": "Jika Anda tidak meminta hal ini, abaikan saja email ini.",
          "instruction_3": "Password Anda tidak akan berubah jika Anda tidak mengakses tautan di atas lalu membuat password yang baru.",
          "subject": "Instruksi untuk melakukan Reset password"
        },
        "unlock_instructions": {
          "action": "Buka kunci akun saya",
          "greeting": "Halo %{recipient}!",
          "instruction": "Klik tautan berikut ini untuk membuka kunci akun Anda.",
          "message": "Akun Anda telah dikunci karena terlalu banyak percobaan masuk yang gagal.",
          "subject": "Instruksi untuk membuka kembali akun anda"
        }
      },
      "omniauth_callbacks": {
        "failure": "Tidak dapat melakukan autentikasi dari %{kind} karena \"%{reason}.\"",
        "success": "Berhasil melakukan autentikasi akun %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Ganti password saya",
          "change_your_password": "Ganti password Anda",
          "confirm_new_password": "Konfirmasi password baru",
          "new_password": "Password baru"
        },
        "new": {
          "forgot_your_password": "Lupa password?",
          "send_me_reset_password_instructions": "Kirimkan instruksi untuk mereset password"
        },
        "no_token": "Tidak dapat mengakses halaman tanpa password dari email. Pstikan Anda menggunakan tautan yang benar di email Reset Password.",
        "send_instructions": "Anda akan menerima e-mail berisi instruksi untuk melakukan reset password beberapa menit lagi.",
        "send_paranoid_instructions": "Jika email Anda terdaftar di basis data kami, Anda akan menerima recovery link di email Anda dalam beberapa menit.",
        "updated": "Password Anda telah berhasil diubah dan tetap masuk di dalam sistem.",
        "updated_not_active": "Password berhasil diubah."
      },
      "registrations": {
        "destroyed": "Selamat Tinggal, akun anda telah di hapus. Kami harap untuk berjumpa Anda kembali segera.",
        "edit": {
          "are_you_sure": "Anda yakin?",
          "cancel_my_account": "Batalkan akun saya",
          "currently_waiting_confirmation_for_email": "Saat ini menunggu konfirmasi untuk: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "kosongkan jika Anda tidak ingin mengubahnya",
          "title": "Ubah %{resource}",
          "unhappy": "Tidak senang?",
          "update": "Update",
          "we_need_your_current_password_to_confirm_your_changes": "Mohon masukkan password Anda saat ini untuk menyimpan perubahan"
        },
        "new": {
          "sign_up": "Mendaftar"
        },
        "signed_up": "Selamat! Anda telah berhasil mendaftar",
        "signed_up_but_inactive": "Pendaftaran berhasil. Akan tetapi, Anda belum dapat sign in karena akun belum diaktivasi.",
        "signed_up_but_locked": "Pendaftaran berhasil. Akan tetapi, Anda belum dapat sign in karena akun terkunci.",
        "signed_up_but_unconfirmed": "Pesan dengan tautan konfirmasi telah dikirim ke email Anda. Harap buka tautan untuk mengaktifkan akun Anda.",
        "update_needs_confirmation": "Berhasil memperbarui akun, namun Anda harus mengonfirmasi alamat email baru. Tolong cek email anda dan klik tautan konfirmasi untuk menyelesaikan konfirmasi email baru Anda.",
        "updated": "Akun anda telah berhasil diperbaharui.",
        "updated_but_not_signed_in": "Akun telah berhasil diperbarui, namun karena password telah diubah maka Anda harus mengulang sign in."
      },
      "sessions": {
        "already_signed_out": null,
        "new": {
          "sign_in": "Masuk"
        },
        "signed_in": "Proses sign in berhasil.",
        "signed_out": "Proses sign out berhasil."
      },
      "shared": {
        "links": {
          "back": "Kembali",
          "didn_t_receive_confirmation_instructions": "Apakah Anda tidak menerima instruksi cara melakukan konfirmasi?",
          "didn_t_receive_unlock_instructions": "Anda tidak menerima instruksi untuk membuka kunci pada akun Anda?",
          "forgot_your_password": "Lupa password?",
          "sign_in": "Masuk",
          "sign_in_with_provider": "Masuk dengan akun %{provider}",
          "sign_up": "Mendaftar"
        },
        "minimum_password_length": {
          "other": "(%{count} karakter minimal)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Kirim ulang instruksi untuk membuka kunci akun"
        },
        "send_instructions": "Anda akan menerima e-mail berisi instruksi untuk membuka kembali akun anda dalam beberapa menit lagi.",
        "send_paranoid_instructions": "Jika akun Anda tercatan, Anda akan menerima email dengan instruksi bagaimana membuka kunci email Anda dalam beberapa menit.",
        "unlocked": "Akun anda telah berhasil dibuka kembali. Anda telah sign in."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "harus diterima",
        "already_confirmed": "sudah di konfirmasi",
        "blank": "tidak boleh kosong",
        "confirmation": "tidak sesuai dengan %{attribute}",
        "confirmation_period_expired": "harus dikonfirmasi dalam %{period}, tolong pesan lagi",
        "empty": "tidak boleh kosong",
        "equal_to": "harus sama dengan %{count}",
        "even": "harus genap",
        "exclusion": "sudah digunakan",
        "expired": "telah kadaluarsa, tolong pesan lagi",
        "greater_than": "harus lebih besar dari %{count}",
        "greater_than_or_equal_to": "harus sama atau lebih besar dari %{count}",
        "inclusion": "tidak termasuk",
        "invalid": "tidak valid",
        "less_than": "harus lebih kecil dari %{count}",
        "less_than_or_equal_to": "harus sama atau lebih kecil dari %{count}",
        "model_invalid": "Validasi gagal: %{errors}",
        "not_a_number": "bukan angka",
        "not_an_integer": "harus bilangan bulat",
        "not_found": "tidak ditemukan",
        "not_locked": "tidak dikunci",
        "not_saved": {
          "other": "%{count} kesalahan membuat %{resource} tidak bisa disimpan:"
        },
        "odd": "harus ganjil",
        "other_than": "harus selain %{count}",
        "present": "harus kosong",
        "required": "harus ada",
        "taken": "sudah digunakan",
        "too_long": {
          "one": "terlalu panjang (maksimum %{count} karakter)",
          "other": "terlalu panjang (maksimum %{count} karakter)"
        },
        "too_short": {
          "one": "terlalu pendek (minimum %{count} karakter)",
          "other": "terlalu pendek (minimum %{count} karakter)"
        },
        "wrong_length": {
          "one": "jumlah karakter salah (seharusnya %{count} karakter)",
          "other": "jumlah karakter salah (seharusnya %{count} karakter)"
        }
      },
      "template": {
        "body": "Ada masalah dengan field berikut:",
        "header": {
          "one": "%{count} kesalahan mengakibatkan %{model} ini tidak bisa disimpan",
          "other": "%{count} kesalahan mengakibatkan %{model} ini tidak bisa disimpan"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "##"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Aceh Barat",
          "Aceh Barat Daya",
          "Aceh Besar",
          "Aceh Jaya",
          "Aceh Selatan",
          "Aceh Singkil",
          "Aceh Tamiang",
          "Aceh Tengah",
          "Aceh Tenggara",
          "Aceh Timur",
          "Aceh Utara",
          "Agam",
          "Alor",
          "Ambon",
          "Asahan",
          "Asmat",
          "Badung",
          "Balangan",
          "Balikpapan",
          "Banda Aceh",
          "Bandar Lampung",
          "Bandung",
          "Bandung Barat",
          "Banggai",
          "Banggai Kepulauan",
          "Bangka",
          "Bangka Barat",
          "Bangka Selatan",
          "Bangka Tengah",
          "Bangkalan",
          "Bangli",
          "Banjar",
          "Banjar Baru",
          "Banjarmasin",
          "Banjarnegara",
          "Bantaeng",
          "Bantul",
          "Banyu Asin",
          "Banyumas",
          "Banyuwangi",
          "Barito Kuala",
          "Barito Selatan",
          "Barito Timur",
          "Barito Utara",
          "Barru",
          "Baru",
          "Batam",
          "Batang",
          "Batang Hari",
          "Batu",
          "Batu Bara",
          "Baubau",
          "Bekasi",
          "Belitung",
          "Belitung Timur",
          "Belu",
          "Bener Meriah",
          "Bengkalis",
          "Bengkayang",
          "Bengkulu",
          "Bengkulu Selatan",
          "Bengkulu Tengah",
          "Bengkulu Utara",
          "Berau",
          "Biak Numfor",
          "Bima",
          "Binjai",
          "Bintan",
          "Bireuen",
          "Bitung",
          "Blitar",
          "Blora",
          "Boalemo",
          "Bogor",
          "Bojonegoro",
          "Bolaang Mongondow",
          "Bolaang Mongondow Selatan",
          "Bolaang Mongondow Timur",
          "Bolaang Mongondow Utara",
          "Bombana",
          "Bondowoso",
          "Bone",
          "Bone Bolango",
          "Bontang",
          "Boven Digoel",
          "Boyolali",
          "Brebes",
          "Bukittinggi",
          "Buleleng",
          "Bulukumba",
          "Bulungan",
          "Bungo",
          "Buol",
          "Buru",
          "Buru Selatan",
          "Buton",
          "Buton Utara",
          "Ciamis",
          "Cianjur",
          "Cilacap",
          "Cilegon",
          "Cimahi",
          "Cirebon",
          "Dairi",
          "Deiyai",
          "Deli Serdang",
          "Demak",
          "Denpasar",
          "Depok",
          "Dharmasraya",
          "Dogiyai",
          "Dompu",
          "Donggala",
          "Dumai",
          "Empat Lawang",
          "Ende",
          "Enrekang",
          "Fakfak",
          "Flores Timur",
          "Garut",
          "Gayo Lues",
          "Gianyar",
          "Gorontalo",
          "Gorontalo Utara",
          "Gowa",
          "Gresik",
          "Grobogan",
          "Gunung Kidul",
          "Gunung Mas",
          "Gunungsitoli",
          "Halmahera Barat",
          "Halmahera Selatan",
          "Halmahera Tengah",
          "Halmahera Timur",
          "Halmahera Utara",
          "Hulu Sungai Selatan",
          "Hulu Sungai Tengah",
          "Hulu Sungai Utara",
          "Humbang Hasundutan",
          "Indragiri Hilir",
          "Indragiri Hulu",
          "Indramayu",
          "Intan Jaya",
          "Jakarta Barat",
          "Jakarta Pusat",
          "Jakarta Selatan",
          "Jakarta Timur",
          "Jakarta Utara",
          "Jambi",
          "Jayapura",
          "Jayawijaya",
          "Jember",
          "Jembrana",
          "Jeneponto",
          "Jepara",
          "Jombang",
          "Kaimana",
          "Kampar",
          "Kapuas",
          "Kapuas Hulu",
          "Karang Asem",
          "Karanganyar",
          "Karawang",
          "Karimun",
          "Karo",
          "Katingan",
          "Kaur",
          "Kayong Utara",
          "Kebumen",
          "Kediri",
          "Keerom",
          "Kendal",
          "Kendari",
          "Kepahiang",
          "Kepulauan Anambas",
          "Kepulauan Aru",
          "Kepulauan Mentawai",
          "Kepulauan Meranti",
          "Kepulauan Sangihe",
          "Kepulauan Selayar",
          "Kepulauan Seribu",
          "Kepulauan Sula",
          "Kepulauan Talaud",
          "Kepulauan Yapen",
          "Kerinci",
          "Ketapang",
          "Klaten",
          "Klungkung",
          "Kolaka",
          "Kolaka Utara",
          "Konawe",
          "Konawe Selatan",
          "Konawe Utara",
          "Kotamobagu",
          "Kotawaringin Barat",
          "Kotawaringin Timur",
          "Kuantan Singingi",
          "Kubu Raya",
          "Kudus",
          "Kulon Progo",
          "Kuningan",
          "Kupang",
          "Kutai Barat",
          "Kutai Kartanegara",
          "Kutai Timur",
          "Labuhan Batu",
          "Labuhan Batu Selatan",
          "Labuhan Batu Utara",
          "Lahat",
          "Lamandau",
          "Lamongan",
          "Lampung Barat",
          "Lampung Selatan",
          "Lampung Tengah",
          "Lampung Timur",
          "Lampung Utara",
          "Landak",
          "Langkat",
          "Langsa",
          "Lanny Jaya",
          "Lebak",
          "Lebong",
          "Lembata",
          "Lhokseumawe",
          "Lima Puluh Kota",
          "Lingga",
          "Lombok Barat",
          "Lombok Tengah",
          "Lombok Timur",
          "Lombok Utara",
          "Lubuklinggau",
          "Lumajang",
          "Luwu",
          "Luwu Timur",
          "Luwu Utara",
          "Madiun",
          "Magelang",
          "Magetan",
          "Majalengka",
          "Majene",
          "Makassar",
          "Malang",
          "Malinau",
          "Maluku Barat Daya",
          "Maluku Tengah",
          "Maluku Tenggara",
          "Maluku Tenggara Barat",
          "Mamasa",
          "Mamberamo Raya",
          "Mamberamo Tengah",
          "Mamuju",
          "Mamuju Utara",
          "Manado",
          "Mandailing Natal",
          "Manggarai",
          "Manggarai Barat",
          "Manggarai Timur",
          "Manokwari",
          "Mappi",
          "Maros",
          "Mataram",
          "Maybrat",
          "Medan",
          "Melawi",
          "Merangin",
          "Merauke",
          "Mesuji",
          "Metro",
          "Mimika",
          "Minahasa",
          "Minahasa Selatan",
          "Minahasa Tenggara",
          "Minahasa Utara",
          "Mojokerto",
          "Morowali",
          "Muara Enim",
          "Muaro Jambi",
          "Mukomuko",
          "Muna",
          "Murung Raya",
          "Musi Banyuasin",
          "Musi Rawas",
          "Nabire",
          "Nagan Raya",
          "Nagekeo",
          "Natuna",
          "Nduga",
          "Ngada",
          "Nganjuk",
          "Ngawi",
          "Nias",
          "Nias Barat",
          "Nias Selatan",
          "Nias Utara",
          "Nunukan",
          "Ogan Ilir",
          "Ogan Komering Ilir",
          "Ogan Komering Ulu",
          "Ogan Komering Ulu Selatan",
          "Ogan Komering Ulu Timur",
          "Pacitan",
          "Padang",
          "Padang Lawas",
          "Padang Lawas Utara",
          "Padang Panjang",
          "Padang Pariaman",
          "Padangsidimpuan",
          "Pagar Alam",
          "Pakpak Bharat",
          "Palangka Raya",
          "Palembang",
          "Palopo",
          "Palu",
          "Pamekasan",
          "Pandeglang",
          "Pangandaran",
          "Pangkajene Dan Kepulauan",
          "Pangkal Pinang",
          "Paniai",
          "Parepare",
          "Pariaman",
          "Parigi Moutong",
          "Pasaman",
          "Pasaman Barat",
          "Paser",
          "Pasuruan",
          "Pati",
          "Payakumbuh",
          "Pegunungan Bintang",
          "Pekalongan",
          "Pekanbaru",
          "Pelalawan",
          "Pemalang",
          "Pematang Siantar",
          "Penajam Paser Utara",
          "Pesawaran",
          "Pesisir Barat",
          "Pesisir Selatan",
          "Pidie",
          "Pidie Jaya",
          "Pinrang",
          "Pohuwato",
          "Polewali Mandar",
          "Ponorogo",
          "Pontianak",
          "Poso",
          "Prabumulih",
          "Pringsewu",
          "Probolinggo",
          "Pulang Pisau",
          "Pulau Morotai",
          "Puncak",
          "Puncak Jaya",
          "Purbalingga",
          "Purwakarta",
          "Purworejo",
          "Raja Ampat",
          "Rejang Lebong",
          "Rembang",
          "Rokan Hilir",
          "Rokan Hulu",
          "Rote Ndao",
          "Sabang",
          "Sabu Raijua",
          "Salatiga",
          "Samarinda",
          "Sambas",
          "Samosir",
          "Sampang",
          "Sanggau",
          "Sarmi",
          "Sarolangun",
          "Sawah Lunto",
          "Sekadau",
          "Seluma",
          "Semarang",
          "Seram Bagian Barat",
          "Seram Bagian Timur",
          "Serang",
          "Serdang Bedagai",
          "Seruyan",
          "Siak",
          "Siau Tagulandang Biaro",
          "Sibolga",
          "Sidenreng Rappang",
          "Sidoarjo",
          "Sigi",
          "Sijunjung",
          "Sikka",
          "Simalungun",
          "Simeulue",
          "Singkawang",
          "Sinjai",
          "Sintang",
          "Situbondo",
          "Sleman",
          "Solok",
          "Solok Selatan",
          "Soppeng",
          "Sorong",
          "Sorong Selatan",
          "Sragen",
          "Subang",
          "Subulussalam",
          "Sukabumi",
          "Sukamara",
          "Sukoharjo",
          "Sumba Barat",
          "Sumba Barat Daya",
          "Sumba Tengah",
          "Sumba Timur",
          "Sumbawa",
          "Sumbawa Barat",
          "Sumedang",
          "Sumenep",
          "Sungai Penuh",
          "Supiori",
          "Surabaya",
          "Surakarta",
          "Tabalong",
          "Tabanan",
          "Takalar",
          "Tambrauw",
          "Tana Tidung",
          "Tana Toraja",
          "Tanah Bumbu",
          "Tanah Datar",
          "Tanah Laut",
          "Tangerang",
          "Tangerang Selatan",
          "Tanggamus",
          "Tanjung Balai",
          "Tanjung Jabung Barat",
          "Tanjung Jabung Timur",
          "Tanjung Pinang",
          "Tapanuli Selatan",
          "Tapanuli Tengah",
          "Tapanuli Utara",
          "Tapin",
          "Tarakan",
          "Tasikmalaya",
          "Tebing Tinggi",
          "Tebo",
          "Tegal",
          "Teluk Bintuni",
          "Teluk Wondama",
          "Temanggung",
          "Ternate",
          "Tidore Kepulauan",
          "Timor Tengah Selatan",
          "Timor Tengah Utara",
          "Toba Samosir",
          "Tojo Una-una",
          "Toli-toli",
          "Tolikara",
          "Tomohon",
          "Toraja Utara",
          "Trenggalek",
          "Tual",
          "Tuban",
          "Tulang Bawang Barat",
          "Tulangbawang",
          "Tulungagung",
          "Wajo",
          "Wakatobi",
          "Waropen",
          "Way Kanan",
          "Wonogiri",
          "Wonosobo",
          "Yahukimo",
          "Yalimo",
          "Yogyakarta"
        ],
        "postcode": [
          "#####"
        ],
        "province": [
          "Aceh",
          "Bali",
          "Banten",
          "Bengkulu",
          "DI Yogyakarta",
          "DKI Jakarta",
          "Gorontalo",
          "Jambi",
          "Jawa Barat",
          "Jawa Tengah",
          "Jawa Timur",
          "Kalimantan Barat",
          "Kalimantan Selatan",
          "Kalimantan Tengah",
          "Kalimantan Timur",
          "Kalimantan Utara",
          "Kepulauan Bangka Belitung",
          "Kepulauan Riau",
          "Lampung",
          "Maluku",
          "Maluku Utara",
          "Nusa Tenggara Barat",
          "Nusa Tenggara Timur",
          "Papua",
          "Papua Barat",
          "Riau",
          "Sulawesi Barat",
          "Sulawesi Selatan",
          "Sulawesi Tengah",
          "Sulawesi Tenggara",
          "Sulawesi Utara",
          "Sumatera Barat",
          "Sumatera Selatan",
          "Sumatera Utara"
        ],
        "state_abbr": [
          "AC",
          "BA",
          "BT",
          "BE",
          "GO",
          "JK",
          "JA",
          "JW",
          "JB",
          "JT",
          "JI",
          "KA",
          "KB",
          "KS",
          "KT",
          "KI",
          "KU",
          "BB",
          "KR",
          "LA",
          "ML",
          "MA",
          "MU",
          "NU",
          "NB",
          "NT",
          "PP",
          "PA",
          "PB",
          "RI",
          "SL",
          "SR",
          "SN",
          "ST",
          "SG",
          "SA",
          "SM",
          "SB",
          "SS",
          "SU",
          "YO"
        ],
        "street_address": [
          "#{street_name} No. #{building_number}"
        ],
        "street_name": [
          "#{street_prefix} #{street_title}"
        ],
        "street_prefix": [
          "Jl."
        ],
        "street_title": [
          "Ahmad Yani",
          "Diponegoro",
          "Gajahmada",
          "Gatot Soebroto",
          "Hayamwuruk",
          "Jend. Sudirman",
          "Juanda",
          "Kartini",
          "MH. Thamrin",
          "Rasuna Said"
        ]
      },
      "name": {
        "first_name": [
          "Aan",
          "Adi",
          "Aditya",
          "Agus",
          "Ahmad",
          "Aji",
          "Andi",
          "Anita",
          "Anton",
          "Arif",
          "Arya",
          "Aulia",
          "Bagas",
          "Bagus",
          "Bambang",
          "Bayu",
          "Beni",
          "Bima",
          "Budi",
          "Chandra",
          "Choirul",
          "Citra",
          "Danang",
          "David",
          "Dea",
          "Deni",
          "Derry",
          "Desi",
          "Devi",
          "Diah",
          "Dimas",
          "Dina",
          "Dion",
          "Edi",
          "Edwin",
          "Effendi",
          "Endang",
          "Erika",
          "Ferdian",
          "Fika",
          "Galih",
          "Gita",
          "Gugun",
          "Hamdan",
          "Hengky",
          "Heni",
          "Heri",
          "Heru",
          "Imam",
          "Iman",
          "Indah",
          "Indra",
          "Iwan",
          "Jaka",
          "Jaya",
          "Kartika",
          "Kartini",
          "Kemal",
          "Khrisna",
          "Kiki",
          "Komar",
          "Lely",
          "Lia",
          "Liana",
          "Lidya",
          "Lisa",
          "Mahesa",
          "Martin",
          "Merry",
          "Muhammad",
          "Niko",
          "Nina",
          "Nisa",
          "Noval",
          "Oki",
          "Okta",
          "Olivia",
          "Pandu",
          "Popi",
          "Pradipta",
          "Prily",
          "Prima",
          "Putri",
          "Qomar",
          "Qorri",
          "Raditya",
          "Rahmat",
          "Roni",
          "Rosa",
          "Rudi",
          "Ruslan",
          "Salim",
          "Sandi",
          "Setya",
          "Sigit",
          "Slamet",
          "Tiara",
          "Tito",
          "Tomi",
          "Toni",
          "Topan",
          "Tri",
          "Udin",
          "Umar",
          "Unang",
          "Valentinus",
          "Vanya",
          "Vicky",
          "Victor",
          "Vira",
          "Vivi",
          "Wahyu",
          "Wawan",
          "Wendy",
          "Wira",
          "Wisnu",
          "Yahya",
          "Yanuar",
          "Yoga",
          "Yossi",
          "Yudha",
          "Yudhistira",
          "Yudi",
          "Zaenal"
        ],
        "last_name": [
          "Abdullah",
          "Adriansyah",
          "Alamsyah",
          "Andrianto",
          "Ardianto",
          "Aristianto",
          "Armansyah",
          "Atmadja",
          "Basri",
          "Bimantara",
          "Bintara",
          "Budiarto",
          "Budiman",
          "Budiono",
          "Cahyadi",
          "Cahyono",
          "Candrawijaya",
          "Ciputra",
          "Daniawan",
          "Darmadi",
          "Darmawan",
          "Dinata",
          "Djunaedi",
          "Dwiantoro",
          "Dzulfikar",
          "Erik",
          "Erlangga",
          "Fachri",
          "Fachriawan",
          "Fauzi",
          "Febriansyah",
          "Ferdian",
          "Ferianto",
          "Firmansyah",
          "Gautama",
          "Ginanjar",
          "Ginting",
          "Gondokusumo",
          "Gozali",
          "Gunajaya",
          "Gunardi",
          "Hadiwijaya",
          "Handaru",
          "Harjono",
          "Hartanto",
          "Hartono",
          "Haryanto",
          "Hendrawinata",
          "Hermawan",
          "Idris",
          "Ikhsan",
          "Ilham",
          "Indragiri",
          "Indrajaya",
          "Ismail",
          "Iswanto",
          "Januar",
          "Jayadi",
          "Jayadinata",
          "Jayakusuma",
          "Junaedi",
          "Kartawijaya",
          "Komarudin",
          "Kurniadi",
          "Kurnianto",
          "Kurniawan",
          "Kusuma",
          "Kusumawardhana",
          "Lazuardi",
          "Lesmana",
          "Linggar",
          "Listiyono",
          "Listyawan",
          "Madjid",
          "Mahendra",
          "Maheswara",
          "Mardiansyah",
          "Mardianto",
          "Marzuki",
          "Maulana",
          "Nababan",
          "Nainggolan",
          "Nasrudin",
          "Novianto",
          "Nugraha",
          "Nurdiansyah",
          "Oktara",
          "Oktavian",
          "Ongky",
          "Pahlevi",
          "Pradhana",
          "Pradipta",
          "Pranata",
          "Prawira",
          "Pribadi",
          "Qodir",
          "Riansyah",
          "Rianto",
          "Riyadi",
          "Rudianto",
          "Rusli",
          "Rusmana",
          "Rustam",
          "Sanjaya",
          "Santoso",
          "Sapta",
          "Saputra",
          "Saragih",
          "Satria",
          "Setiawan",
          "Sugianto",
          "Sugiarto",
          "Suhendra",
          "Suryatama",
          "Taslim",
          "Thamrin",
          "Tjahjadi",
          "Triwijaya",
          "Umbara",
          "Unggul",
          "Utama",
          "Virgiawan",
          "Waluyo",
          "Wardhana",
          "Wicaksono",
          "Wijanarko",
          "Wijaya",
          "Winardi",
          "Winarta",
          "Wirawan",
          "Yudhanto",
          "Yudhistira",
          "Yudhiswara",
          "Yulianto",
          "Zaenal",
          "Zaini",
          "Zulfikara",
          "Zulfikri",
          "Zulkarnain"
        ],
        "name": [
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "62"
        ],
        "formats": [
          "08##########",
          "08##-####-####",
          "8#########"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Silakan pilih"
      },
      "submit": {
        "create": "Buat %{model}",
        "submit": "Simpan %{model}",
        "update": "Perbarui %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "Rp"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miliar",
            "million": "Juta",
            "quadrillion": "Quadriliun",
            "thousand": "Ribu",
            "trillion": "Triliun",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Byte"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", dan ",
        "two_words_connector": " dan ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H.%M.%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d %B %Y %H:%M:%S"
            }
          }
        },
        "long": "%d %B %Y %H.%M",
        "short": "%d %b %H.%M"
      },
      "pm": "pm"
    }
  },
  "ig": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "Okwuntughe nke di ire ugbua",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "Imeel",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "Okwuntughe",
          "password_confirmation": "Nkwenta okwuntughe",
          "remember_created_at": null,
          "remember_me": "Cheta m",
          "reset_password_sent_at": null,
          "reset_password_token": "Tugharia Okwuntughe",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "Mee hie obere",
          "updated_at": null
        }
      },
      "models": {
        "user": {
          "one": "Onye nwe",
          "other": "Onye nwe"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Imeel adreesi gi agala nke oma ",
        "new": {
          "resend_confirmation_instructions": "Zighachi ozi usoro nkweta"
        },
        "send_instructions": "I ga enweta ozi imeel na usoro esi ekweta ya n’oge adighi anya",
        "send_paranoid_instructions": "Oburu na imeel adireesi gi dina akara ulo anyi, I ga enweta ozi otu esi eleta imeeli adireesi gi n’ oge adighi anyi"
      },
      "failure": {
        "already_authenticated": "ibanye la rii",
        "inactive": "akauntu gi arubabeghi oru",
        "invalid": null,
        "last_attempt": " I nwere otu ohere tupu agbachie akauntu gi",
        "locked": "Agbachiela akauntu gi",
        "not_found_in_database": null,
        "timeout": "oge enyere gi agwula biko bidokwa ozo wee banye, ka iwe gaba n’iru",
        "unauthenticated": ": I ga abanye, ma o bu debanye aha tupu I gabakwa n’iru",
        "unconfirmed": "I ga ekwetara imeel adreesi tupu igabakwa n’iru"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "kwetara akauntu",
          "greeting": "Nnoo! %{recipient}!",
          "instruction": "I ga ekwetara akauntu gi site n’akara a di na-okpuru.",
          "subject": "Usoro esi ekwenye"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "kedu %{recipient}!",
          "message": "Anyi na-akpoturu gi, igwa gi na okwuntughe gi agbanweela",
          "subject": "Mgbanwe okwuntughe"
        },
        "reset_password_instructions": {
          "action": "Gbanwe okwuntughe m",
          "greeting": "kedu %{recipient}!",
          "instruction": "Were onye naacho ka agbanwe okwuntughe gi, ma i ga eme nkea site na-akara dina okpuru",
          "instruction_2": "O buru na ichoghi nkea, biko le – ghara imeel a",
          "instruction_3": "Okwuntughe gi agaghi agbanwe ruo-mgbe ibara n! ime akara a di n’elu, wee mepee nke ohuru    ",
          "subject": "Usoro esi atughari okwuntughe"
        },
        "unlock_instructions": {
          "action": " Gbaghee akauntu m",
          "greeting": "kedu %{recipient}!",
          "instruction": "Pia akara di n’okpuru, wee kpoghe akauntu gi",
          "message": "Akpochiela akauntu gi site na otutu ugboro ichoro ibanye mana onweghi isi",
          "subject": "usoro esi Akpoghe"
        }
      },
      "omniauth_callbacks": {
        "failure": "onweghi ike ihu gi %{kind} maka \"%{reason}\".",
        "success": " inwela ike ka ahu gi nke oma site na %{kind} akauntu gi"
      },
      "passwords": {
        "edit": {
          "change_my_password": "gbanwe okwuntughe m",
          "change_your_password": "gbanwe okwuntughe gi",
          "confirm_new_password": "kwetara okwuntughe ohuru",
          "new_password": "okwuntughe ohuru"
        },
        "new": {
          "forgot_your_password": "I chefuru Okwuntughe gi?",
          "send_me_reset_password_instructions": "zitere m usoro mgbanwe Okwuntughe"
        },
        "no_token": "Igaghi enwe ike ibanye na-ohere a na-esiteghi na okuruntughe mgbanwe imeel. Oburu na – isighi na mgbanwe okwuntughe imeel, biko were URL nile enyeregi",
        "send_instructions": "I ga enweta usoro imeel out esi atughari okwuntughe n’oge etegi aka ",
        "send_paranoid_instructions": "Oburu na imeel gi di na – ulo data anyi, I ga enweta ozi inwetachi okwuntughe n’akara anyi na – imeel ugbua",
        "updated": "Agbanwela okwuntughe gi nke oma. I banye Kwala",
        "updated_not_active": "Wwe hope to see you again soon. Agbanwela Okwuntughe gi nke oma"
      },
      "registrations": {
        "destroyed": "Ka odi? Akagbuola akauntu gi",
        "edit": {
          "are_you_sure": "Obu ka osi mee?",
          "cancel_my_account": "Kagbuo akauntu m",
          "currently_waiting_confirmation_for_email": "Ugbua, ana echere nkweta nke %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "Hapa ya oghe ma o buru na ichogi igbanwe ya",
          "title": "Degharia %{resource}",
          "unhappy": "Inwegi anuri? ",
          "update": "Bunite ya na nke ohuru",
          "we_need_your_current_password_to_confirm_your_changes": "Anyi choro okwuntughe ohuru gi, ka ewee kwenye na mgbanwe"
        },
        "new": {
          "sign_up": "Debanye aha"
        },
        "signed_up": "Nnoo! I debanyela nke oma",
        "signed_up_but_inactive": "I debanyela nke oma. Kama, any enweghi ike igbaghere gi maka na akauntu gi ebi do beghi ruba oru",
        "signed_up_but_locked": ": I deabanyela nke oma. Kama anyi enweghi ike igbaghere gi maka na akauntu gi gbachiri agbachi",
        "signed_up_but_unconfirmed": "Ezi jere la gi ozi nkweta na imeel adreesi gi. Biko, soro akara anyi were gbaghee akauntu gi",
        "update_needs_confirmation": "Ibunitela akauntu gi nke ohuru nke oma, mana anyi choro inyocha imeel adreesi ohuru gi. Biko leta imeela gi ma soro akara nkweta wee kwetara imeel adreesi ohuru gi",
        "updated": "Ebunitela akauntu gi na nke ohuru nke oma",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Emechiela ya nke oma",
        "new": {
          "sign_in": " Banye"
        },
        "signed_in": "Abanyela nke oma",
        "signed_out": "Emechiela ya nke oma"
      },
      "shared": {
        "links": {
          "back": "Chigha-azu",
          "didn_t_receive_confirmation_instructions": "Inwetaghi usoro nkwekokita?",
          "didn_t_receive_unlock_instructions": "Inwetaghi usoro mgbaghe?",
          "forgot_your_password": "I chefuru okwuntughe gi?",
          "sign_in": "Banye",
          "sign_in_with_provider": "Were %{provider} banye",
          "sign_up": "Dabanye aha"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Zighachi usoro mgbaghe"
        },
        "send_instructions": "I ga enweta ozi imeel na otu esi agbaghe akauntu gi n’oge eteghi aka",
        "send_paranoid_instructions": "Oburu na inwerego akauntu, I ga enweta imeel na usoro otu esi agbaghe ya n’oge eteghi aka",
        "unlocked": "Agbaghela akauntu gi nke oma. Biko banye ka I wee ga n’iru"
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "Ekwenyela ari, biko, mee ka i banye ",
        "confirmation_period_expired": "Okwesiri ka enkweta n’ime %{period}, Biko yoo ka enye gi nke ohuru",
        "expired": "Nkea emebiela. Biko yoo ka enye gi nke ohuru.\n86.\tNot found: Ahughi ya\n",
        "not_found": "Ahughi ya",
        "not_locked": "Agbachi ya",
        "not_saved": {
          "one": "%{count} che mmebi nke gbochiri nkea %{resource}  na idekwaba ya. ",
          "other": "%{count} che mmebi nke gbochiri nkea %{resource}  na idekwaba ya. "
        }
      }
    }
  },
  "is": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Staðfesting send kl",
          "confirmation_token": "Staðfestingartákn",
          "confirmed_at": "Staðfest kl",
          "created_at": "Búið til kl",
          "current_password": "Núverandi lykilorð",
          "current_sign_in_at": "Núverandi innskráning kl",
          "current_sign_in_ip": "Núverandi innskráningar IP tala",
          "email": "Tölvupóstur",
          "encrypted_password": "Dulkóðað lykilorð",
          "failed_attempts": "Misheppnaðar tilraunir",
          "last_sign_in_at": "Síðasta innskráning",
          "last_sign_in_ip": "Síðasta IP tala innskráningar",
          "locked_at": "Læst kl",
          "password": "Lykilorð",
          "password_confirmation": "Staðfesta lykilorð",
          "remember_created_at": "Muna búið til kl",
          "remember_me": "Muna eftir mér",
          "reset_password_sent_at": "Núllstilling lykilorðs sent kl",
          "reset_password_token": "Núllstilla lykilorðatákn",
          "sign_in_count": "Fjöldi innskráninga",
          "unconfirmed_email": "Óstaðfest netfang",
          "unlock_token": "Aflæsa tákni",
          "updated_at": "Uppfært kl"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Villur: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Ekki hægt að eyða færslur því %{record} sem hún er háð er til",
            "has_one": "Ekki hægt að eyða færslu því %{record} sem hún er háð er til"
          }
        }
      },
      "models": {
        "user": {
          "one": "Notandi",
          "other": "Notandi"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "sun",
        "mán",
        "þri",
        "mið",
        "fim",
        "fös",
        "lau"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maí",
        "jún",
        "júl",
        "ágú",
        "sep",
        "okt",
        "nóv",
        "des"
      ],
      "day_names": [
        "sunnudaginn",
        "mánudaginn",
        "þriðjudaginn",
        "miðvikudaginn",
        "fimmtudaginn",
        "föstudaginn",
        "laugardaginn"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "janúar",
        "febrúar",
        "mars",
        "apríl",
        "maí",
        "júní",
        "júlí",
        "ágúst",
        "september",
        "október",
        "nóvember",
        "desember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "u.þ.b. %{count} klukkustund",
          "other": "u.þ.b. %{count} klukkustundir"
        },
        "about_x_months": {
          "one": "u.þ.b. %{count} mánuður",
          "other": "u.þ.b. %{count} mánuðir"
        },
        "about_x_years": {
          "one": "u.þ.b. %{count} ár",
          "other": "u.þ.b. %{count} ár"
        },
        "almost_x_years": {
          "one": "næstum %{count} ár",
          "other": "næstum %{count} ár"
        },
        "half_a_minute": "hálf mínúta",
        "less_than_x_minutes": {
          "one": "minna en %{count} mínúta",
          "other": "minna en %{count} mínútur"
        },
        "less_than_x_seconds": {
          "one": "minna en %{count} sekúnda",
          "other": "minna en %{count} sekúndur"
        },
        "over_x_years": {
          "one": "meira en %{count} ár",
          "other": "meira en %{count} ár"
        },
        "x_days": {
          "one": "%{count} dagur",
          "other": "%{count} dagar"
        },
        "x_minutes": {
          "one": "%{count} mínúta",
          "other": "%{count} mínútur"
        },
        "x_months": {
          "one": "%{count} mánuður",
          "other": "%{count} mánuðir"
        },
        "x_seconds": {
          "one": "%{count} sekúnda",
          "other": "%{count} sekúndur"
        }
      },
      "prompts": {
        "day": "Dagur",
        "hour": "Klukkustund",
        "minute": "Mínúta",
        "month": "Mánuður",
        "second": "Sekúnda",
        "year": "Ár"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Aðgangurinn hefur verið staðfestur. Þú ert núna innskráð(ur).",
        "new": {
          "resend_confirmation_instructions": "Endursenda leiðbeiningar staðfestingar."
        },
        "send_instructions": "Eftir nokkrar mínútur munt þú fá tölvupóst með leiðbeiningum um hvernig eigi að staðfesta aðganginn.",
        "send_paranoid_instructions": "Ef netfangið þitt er til í gagnagrunninum okkar munt þú fá leiðbeiningar um hvernig eigi að staðfesta aðganginn sendar tölvupósti innan nokkurra mínútna."
      },
      "failure": {
        "already_authenticated": "Þú ert nú þegar innskráð(ur).",
        "inactive": "Aðgangurinn þinn hefur ekki verið staðfestur.",
        "invalid": "Rangt %{authentication_keys} eða lykilorð.",
        "last_attempt": "Þú hefur eina tilraun í viðbót, áður en aðganginum verði læst.",
        "locked": "Aðgangurinn þinn er læstur.",
        "not_found_in_database": "Rangt %{authentication_keys} eða lykilorð.",
        "timeout": "Seta þín hefur runnið út, skráðu þig aftur inn til að halda áfram.",
        "unauthenticated": "Þú þarft að vera innskráð(ur) til þess að halda áfram.",
        "unconfirmed": "Þú verður að staðfesta aðganginn þinn áður en þú getur haldið áfram."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Staðfesta minn aðgang",
          "greeting": "Velkominn %{recipient}!",
          "instruction": "Þú getur staðfest aðgang þinn með hlekknum hér fyrir neðan:",
          "subject": "Staðfestingarleiðbeiningar"
        },
        "email_changed": {
          "greeting": "Halló %{recipient}!",
          "message": "Við erum að láta þig vita að  tölvupóstfangi þínu verði breytt í %{email}.",
          "message_unconfirmed": null,
          "subject": "Tölvupósti breytt"
        },
        "password_change": {
          "greeting": "Halló %{recipient}!",
          "message": "Við viljum láta þig vita að lykilorði þínu hefur verið breytt.",
          "subject": "Lykilorði breytt."
        },
        "reset_password_instructions": {
          "action": "Breyta lykilorði mínu.",
          "greeting": "Halló %{recipient}!",
          "instruction": "Einhver hefur óskað eftir hlekk til að breyta lykilorði þínu, og þú getur gert það með hlekknum hér fyrir neðan.",
          "instruction_2": "Ef þú gerðir það ekki, vinsamlegast hundsaðu þennan póst.",
          "instruction_3": "Lykilorði þínu verður ekki breytt þartil þú hefur heimsótt hlekkinn hér að ofan og búið til nýtt.",
          "subject": "Leiðbeiningar um endurstillingu lykilorðs"
        },
        "unlock_instructions": {
          "action": "Aflæsa aðgangi mínum.",
          "greeting": "Halló %{recipient}!",
          "instruction": "Smelltu á hlekkinn hér fyrir neðan til að aflæsa aðgangi þínum:",
          "message": "Aðgangi þínum hefur verið læst vegna óvenjulegs fjölda af misheppnum innskráningartilraunum.",
          "subject": "Aflæsingarleiðbeiningar"
        }
      },
      "omniauth_callbacks": {
        "failure": "Innskráning með %{kind} aðgangi mistókst: %{reason}.",
        "success": "Innskráning með %{kind} aðgangi tókst."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Breyta lykilorði mínu",
          "change_your_password": "Breyta lykilorði þínu",
          "confirm_new_password": "Staðfesta nýtt lykilorð",
          "new_password": "Nýtt lykilorð"
        },
        "new": {
          "forgot_your_password": "Gleymt lykilorð?",
          "send_me_reset_password_instructions": "Senda mér leiðbeiningar til að endursetja lykilorð"
        },
        "no_token": "Þú getur ekki séð þessa síðu án þess að koma frá tölvupósti sem núllstillir lykilorð. Ef þú ert að koma frá slíkum pósti, vertu viss um að öll slóðin frá tölvupóstinum sé notuð.",
        "send_instructions": "Innan nokkra mínútna færðu tölvupóst með leiðbeiningum um hvernig hægt sé að endurstilla aðganginn þinn.",
        "send_paranoid_instructions": "Ef netfangið þitt er til í gagnagrunninum okkar munt þú fá leiðbeiningar um endurstillingu sendar í tölvupósti innan nokkra mínútna.",
        "updated": "Lykilorði þínu hefur nú verið breytt. Þú ert núna innskráð(ur).",
        "updated_not_active": "Lykilorði þínu hefur nú verið breytt."
      },
      "registrations": {
        "destroyed": "Bless! Aðgangnum þínum hefur verið lokað. Vonandi sjáumst við aftur.",
        "edit": {
          "are_you_sure": "Ertu viss?",
          "cancel_my_account": "Loka mínum aðgangi",
          "currently_waiting_confirmation_for_email": "Bíð eftir staðfestingu á: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "Skilja eftir autt ef þú vilt ekki breyta.",
          "title": "Breyta %{resource}",
          "unhappy": "Óánægður?",
          "update": "Uppfæra",
          "we_need_your_current_password_to_confirm_your_changes": "Við þurfum núverandi lykilorð til að staðfesta breytingar."
        },
        "new": {
          "sign_up": "Nýskrá"
        },
        "signed_up": "Velkomin(n)! Þú hefur nýskráð þig.",
        "signed_up_but_inactive": "Þú hefur nýskráð þig. Hins vegar gátum við ekki innskráð þig því að aðgangurinn þinn hefur ekki verið virktur.",
        "signed_up_but_locked": "Þú hefur nýskráð þig. Hins vegar gátum við ekki innskráð þig því að aðgangurinn þinn er læstur.",
        "signed_up_but_unconfirmed": "Staðfestingartengill hefur verið sendur á netfangið þitt. Vinsamlegast smelltu á tengilinn til að virkja aðganginn.",
        "update_needs_confirmation": "Aðgangurinn þinn hefur verið uppfærður, en þú þarft að staðfesta netfangið þitt. Vinsamlegast skoðaðu tölvupóstinn þinn og smelltu á staðfestingartengilinn til þess að staðfesta netfangið.",
        "updated": "Aðgangurinn þinn hefur verið uppfærður.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Útskráning tókst.",
        "new": {
          "sign_in": "Skrá inn"
        },
        "signed_in": "Innskráning tókst.",
        "signed_out": "Útskráning tókst."
      },
      "shared": {
        "links": {
          "back": "Tilbaka",
          "didn_t_receive_confirmation_instructions": "Fékkstu ekki leiðbeiningar staðfestingar?",
          "didn_t_receive_unlock_instructions": "Fékkstu ekki leiðbeiningar aflæsingar?",
          "forgot_your_password": "Gleymdirðu lykilorði þínu?",
          "sign_in": "Skrá inn",
          "sign_in_with_provider": "Skrá inn með %{provider}",
          "sign_up": "Nýskrá"
        },
        "minimum_password_length": {
          "one": "(%{count} stafa lágmark)",
          "other": "(%{count} stafir lágmark)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Endursenda leiðbeiningar aflæsingar"
        },
        "send_instructions": "Innan nokkurra mínútna færðu tölvupóst með leiðbeiningum um hvernig hægt er að aflæsa aðgangi þínum.",
        "send_paranoid_instructions": "Ef aðgangurinn þinn er til munt þú fá leiðbeiningar um hvernig hægt er að aflæsa honum sendar í tölvupósti innan nokkurra mínútna.",
        "unlocked": "Aðgangnum þínum hefur verið aflæst. Þú ert innskráð(ur)."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "þarf að vera tekið gilt",
        "already_confirmed": "var nú þegar staðfestur, prófaðu að skrá þig inn",
        "blank": "má ekki vera autt",
        "confirmation": "er ekki jafngilt staðfestingunni",
        "confirmation_period_expired": "þarf að vera staðfest innan %{period}, vinsamlegast biddu um nýjan",
        "empty": "má ekki vera tómt",
        "equal_to": "þarf að vera jafngilt %{count}",
        "even": "þarf að vera slétt tala",
        "exclusion": "er frátekið",
        "expired": "hefur runnið út, vinsamlegast biðjið um nýtt",
        "greater_than": "þarf að vera stærri en %{count}",
        "greater_than_or_equal_to": "þarf að vera stærri en eða jafngilt %{count}",
        "inclusion": "er ekki í listanum",
        "invalid": "er ógilt",
        "less_than": "þarf að vera minna en %{count}",
        "less_than_or_equal_to": "þarf að vera minna en eða jafngilt %{count}",
        "not_a_number": "er ekki tala",
        "not_an_integer": "þarf að vera heiltala",
        "not_found": "fannst ekki",
        "not_locked": "var ekki læstur",
        "not_saved": {
          "one": "1 villa kom í veg fyrir að hægt væri að vista þennan %{resource}:",
          "other": "%{count} villur komu í veg fyrir að hægt væri að vista þennan %{resource}:"
        },
        "odd": "þarf að vera oddatala",
        "other_than": "verður að vera annað en %{count}",
        "present": "verður að vera autt",
        "taken": "er þegar í notkun",
        "too_long": {
          "one": "er of langt (má mest vera %{count} stafur)",
          "other": "er of langt (má mest vera %{count} stafir)"
        },
        "too_short": {
          "one": "er of stutt (má minnst vera %{count} stafur)",
          "other": "er of stutt (má minnst vera %{count} stafir)"
        },
        "wrong_length": {
          "one": "er af rangri lengd (má mest vera %{count} stafur)",
          "other": "er af rangri lengd (má mest vera %{count} stafir)"
        }
      },
      "template": {
        "body": "Villur fundust í eftirfarandi dálkum:",
        "header": {
          "one": "Ekki var hægt að vista %{model} vegna einnar villu.",
          "other": "Ekki var hægt að vista %{model} vegna %{count} villna."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Veldu"
      },
      "submit": {
        "create": "Búa til %{model}",
        "submit": "Vista %{model}",
        "update": "Uppfæra %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "kr."
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "milljarður",
              "other": "milljarðar"
            },
            "million": {
              "one": "milljón",
              "other": "milljónir"
            },
            "quadrillion": {
              "one": "billjarður",
              "other": "billjarðar"
            },
            "thousand": "þúsund",
            "trillion": {
              "one": "billjón",
              "other": "billjónir"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "bæti",
              "other": "bæti"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " og ",
        "two_words_connector": " og ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A %e. %B %Y kl. %H:%M",
        "long": "%A %e. %B %Y kl. %H:%M",
        "short": "%e. %B kl. %H:%M"
      },
      "pm": "pm"
    }
  },
  "it": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Conferma inviata a",
          "confirmation_token": "Token di conferma",
          "confirmed_at": "Confermato il",
          "created_at": "Creato il",
          "current_password": "Password corrente",
          "current_sign_in_at": "Accesso corrente il",
          "current_sign_in_ip": "IP accesso corrente",
          "email": "Email",
          "encrypted_password": "Password criptata",
          "failed_attempts": "Tentativi falliti",
          "last_sign_in_at": "Ultimo accesso il",
          "last_sign_in_ip": "Ultimo IP di accesso",
          "locked_at": "Bloccato il",
          "password": "Password",
          "password_confirmation": "Conferma password",
          "remember_created_at": "Ricordami creato il",
          "remember_me": "Ricordami",
          "reset_password_sent_at": "Reset password inviata a",
          "reset_password_token": "Token di reset password",
          "sign_in_count": "Numero di accessi",
          "unconfirmed_email": "Email non confermata",
          "unlock_token": "Token di sblocco",
          "updated_at": "Aggiornato il"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validazione fallita: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Il record non può essere cancellato perchè esistono %{record} dipendenti",
            "has_one": "Il record non può essere cancellato perchè esiste un %{record} dipendente"
          }
        }
      },
      "models": {
        "user": {
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
      ],
      "abbr_month_names": [
        null,
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
      ],
      "day_names": [
        "domenica",
        "lunedì",
        "martedì",
        "mercoledì",
        "giovedì",
        "venerdì",
        "sabato"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "circa un'ora",
          "other": "circa %{count} ore"
        },
        "about_x_months": {
          "one": "circa un mese",
          "other": "circa %{count} mesi"
        },
        "about_x_years": {
          "one": "circa un anno",
          "other": "circa %{count} anni"
        },
        "almost_x_years": {
          "one": "quasi un anno",
          "other": "quasi %{count} anni"
        },
        "half_a_minute": "mezzo minuto",
        "less_than_x_minutes": {
          "one": "meno di un minuto",
          "other": "meno di %{count} minuti"
        },
        "less_than_x_seconds": {
          "one": "meno di un secondo",
          "other": "meno di %{count} secondi"
        },
        "over_x_years": {
          "one": "oltre un anno",
          "other": "oltre %{count} anni"
        },
        "x_days": {
          "one": "%{count} giorno",
          "other": "%{count} giorni"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minuti"
        },
        "x_months": {
          "one": "%{count} mese",
          "other": "%{count} mesi"
        },
        "x_seconds": {
          "one": "%{count} secondo",
          "other": "%{count} secondi"
        },
        "x_years": {
          "one": "%{count} anno",
          "other": "%{count} anni"
        }
      },
      "prompts": {
        "day": "Giorno",
        "hour": "Ora",
        "minute": "Minuto",
        "month": "Mese",
        "second": "Secondo",
        "year": "Anno"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Il tuo account è stato correttamente confermato.",
        "new": {
          "resend_confirmation_instructions": "Invia di nuovo le istruzioni per la conferma"
        },
        "send_instructions": "Riceverai un messaggio email con le istruzioni per confermare il tuo account entro qualche minuto.",
        "send_paranoid_instructions": "Se la tua email esiste nel nostro database, riceverai un messaggio email con le istruzioni per confermare il tuo account entro qualche minuto."
      },
      "failure": {
        "already_authenticated": "Hai già effettuato l'accesso.",
        "inactive": "Il tuo account non è stato ancora attivato.",
        "invalid": "Credenziali %{authentication_keys} o password non valide.",
        "invited": "Hai un invito in sospeso, accettalo per completare la creazione del tuo account.",
        "last_attempt": "Hai ancora un tentativo prima che l'account venga bloccato.",
        "locked": "Il tuo account è bloccato.",
        "not_found_in_database": "Credenziali %{authentication_keys} o password non valide.",
        "timeout": "Sessione scaduta, accedere nuovamente per continuare.",
        "unauthenticated": "Devi accedere o registrarti per continuare.",
        "unconfirmed": "Devi confermare il tuo account per continuare."
      },
      "invitations": {
        "edit": {
          "header": "Imposta la tua password",
          "submit_button": "Imposta la password"
        },
        "invitation_removed": "Il tuo invito è stato rimosso.",
        "invitation_token_invalid": "Il token di invito fornito non è valido!",
        "new": {
          "header": "Inoltra l'invito",
          "submit_button": "Inoltra un invito"
        },
        "no_invitations_remaining": "Non sono più disponibili inviti.",
        "send_instructions": "Un'email di invito è stata inoltrata a %{email}.",
        "updated": "La tua password è stata impostata correttamente. Ora sei connesso.",
        "updated_not_active": "La tua password è stata impostata correttamente."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Conferma il mio account",
          "confirm_account_link": "Conferma il mio account",
          "confirm_link_msg": "Puoi confermare il tuo account email cliccando sul seguente link:",
          "greeting": "Benvenuto %{recipient}!",
          "instruction": "Puoi confermare il tuo account cliccando sul link qui sotto:",
          "subject": "Istruzioni per la conferma"
        },
        "email_changed": {
          "greeting": "Ciao %{recipient}!",
          "message": "Ti stiamo contattando per notificarti che la tua email è stata cambiata in %{email}.",
          "message_unconfirmed": null,
          "subject": "Email modificata"
        },
        "invitation_instructions": {
          "accept": "Accetta l'invito",
          "accept_until": "L'invito sarà valido fino a %{due_date}.",
          "hello": "Buongiorno %{email}",
          "ignore": "Se non si desidera accettare l'invito si prega di ignorare la presente email.<br />L'account non sarà creato finché non verrà impostata la password (v. link sotto).",
          "someone_invited_you": "Qualcuno ti ha invitato a %{url}, accetta tramite il link qua sotto.",
          "subject": "Istruzioni per l'invito"
        },
        "password_change": {
          "greeting": "Ciao %{recipient}!",
          "message": "Ti stiamo contattando per notificarti che la tua password è stata modificata.",
          "subject": "Password modificata"
        },
        "reset_password_instructions": {
          "action": "Cambia la mia password",
          "greeting": "Ciao %{recipient}!",
          "ignore_mail_msg": "Se non hai richiesto questa operazione, puoi ignorare l'email.",
          "instruction": "Qualcuno ha richiesto di resettare la tua password, se lo vuoi davvero puoi farlo cliccando sul link qui sotto.",
          "instruction_2": "Se non sei stato tu ad effettuare questa richiesta puoi ignorare questa mail.",
          "instruction_3": "La tua password non cambierà finché non accederai al link sopra.",
          "no_changes_msg": "La tua password non cambierà finchè non cliccherai sul link sopra per crearne una nuova.",
          "password_change_link": "Cambia la mia password",
          "request_reset_link_msg": "Qualcuno ha richiesto un link per cambiare la tua password. Puoi farlo cliccando sul seguente link.",
          "subject": "Istruzioni per reimpostare la password"
        },
        "unlock_instructions": {
          "account_lock_msg": "Il tuo account è stato bloccato a causa di un numero eccessivo di tentativi di accesso non validi.",
          "action": "Sblocca il mio account",
          "greeting": "Ciao %{recipient}!",
          "instruction": "Clicca sul link qui sotto per sbloccare il tuo account:",
          "message": "Il tuo account è stato bloccato a seguito di un numero eccessivo di tentativi di accesso falliti.",
          "subject": "Istruzioni per sbloccare l'account",
          "unlock_link": "Sblocca il mio account",
          "unlock_link_msg": "Clicca sul seguente link per sbloccare il tuo account:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Non è stato possibile autorizzarti da %{kind} perché \"%{reason}\".",
        "success": "Autorizzato con successo dall'account %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambia la mia password",
          "change_your_password": "Cambia la tua password",
          "confirm_new_password": "Conferma la nuova password",
          "new_password": "Nuova password"
        },
        "new": {
          "forgot_your_password": "Password dimenticata?",
          "send_me_reset_password_instructions": "Inviami le istruzioni per resettare la password"
        },
        "no_token": "Puoi accedere a questa pagina solamente dalla email di reset della password. Se vieni dalla email controlla di aver inserito l'url completo riportato nella email.",
        "send_instructions": "Riceverai un messaggio email con le istruzioni per reimpostare la tua password entro qualche minuto.",
        "send_paranoid_instructions": "Se la tua email esiste nel nostro database, riceverai un messaggio email contentente un link per il ripristino della password",
        "updated": "La tua password è stata cambiata. Ora sei collegato.",
        "updated_not_active": "La tua password è stata cambiata."
      },
      "registrations": {
        "destroyed": "Arrivederci! L'account è stato cancellato. Speriamo di rivederti presto.",
        "edit": {
          "are_you_sure": "Sei sicuro?",
          "cancel_my_account": "Rimuovi il mio account",
          "currently_waiting_confirmation_for_email": "In attesa di conferma per: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lascia in bianco se non vuoi cambiarla",
          "title": "Modifica %{resource}",
          "unhappy": "Scontento",
          "update": "Aggiorna",
          "we_need_your_current_password_to_confirm_your_changes": "abbiamo bisogno della tua password attuale per confermare i cambiamenti"
        },
        "new": {
          "sign_up": "Registrati"
        },
        "signed_up": "Iscrizione eseguita correttamente. Se abilitata, una conferma è stata inviata al tuo indirizzo email.",
        "signed_up_but_inactive": "Iscrizione eseguita correttamente. Però non puoi accedere in quanto il tuo account non è ancora attivo.",
        "signed_up_but_locked": "Iscrizione eseguita correttamente. Però non puoi accedere in quanto il tuo account è bloccato.",
        "signed_up_but_unconfirmed": "Ti è stato inviato un messaggio con un link di conferma. Ti invitiamo a visitare il link per attivare il tuo account.",
        "update_needs_confirmation": "Il tuo account è stato aggiornato, ma dobbiamo verificare la tua email. Ti invitiamo a consultare la tua email e cliccare sul link di conferma.",
        "updated": "Il tuo account è stato aggiornato.",
        "updated_but_not_signed_in": "Il tuo account è stato aggiornato con successo, ma dato che la tua password è cambiata, devi accedere di nuovo."
      },
      "sessions": {
        "already_signed_out": "Sei uscito correttamente.",
        "new": {
          "sign_in": "Accedi"
        },
        "signed_in": "Accesso effettuato con successo.",
        "signed_out": "Sei uscito correttamente."
      },
      "shared": {
        "links": {
          "back": "Indietro",
          "didn_t_receive_confirmation_instructions": "Non hai ricevuto le istruzioni per la conferma?",
          "didn_t_receive_unlock_instructions": "Non hai ricevuto le istruzioni per lo sblocco?",
          "forgot_your_password": "Password dimenticata?",
          "sign_in": "Accedi",
          "sign_in_with_provider": "Accedi con %{provider}",
          "sign_up": "Registrati"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Invia di nuovo le istruzioni per lo sblocco"
        },
        "send_instructions": "Riceverai un messaggio email con le istruzioni per sbloccare il tuo account entro qualche minuto.",
        "send_paranoid_instructions": "Se la tua email esiste nel nostro database, riceverai un messaggio email con le istruzioni per sbloccare il tuo account entro qualche minuto.",
        "unlocked": "Il tuo account è stato correttamente sbloccato. Ora sei collegato."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Redirezione a '%{redirect_url}' non consentita."
      },
      "passwords": {
        "missing_email": "Devi fornire un indirizzo email.",
        "missing_passwords": "Devi riempire i campi 'Password' e 'Password confirmation'.",
        "missing_redirect_url": "Redirect URL mancante.",
        "not_allowed_redirect_url": "Redirezione a '%{redirect_url}' non consentita.",
        "password_not_required": "Questo account non richiede una password. Accedi utilizzando l'account di '%{provider}'.",
        "sended": "E' stata inviata un'email a '%{email}' contenente le istruzioni per reimpostare la password.",
        "successfully_updated": "La tua password è stata aggiornata correttamente.",
        "user_not_found": "Impossibile trovare un utente con email '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Impossibile trovare l'account da eliminare.",
        "account_with_uid_destroyed": "L'account con UID '%{uid}' è stato eliminato.",
        "email_already_exists": "Esiste già un account per '%{email}'",
        "missing_confirm_success_url": "Parametro 'confirm_success_url' mancante.",
        "redirect_url_not_allowed": "Redirezione a '%{redirect_url}' non consentita.",
        "user_not_found": "Utente non trovato."
      },
      "sessions": {
        "bad_credentials": "Credenziali di login non valide. Riprova.",
        "not_confirmed": "Un'email di conferma è stata mandata al tuo account '%{email}'. Segui le istruzioni nell'email per attivare il tuo account.",
        "not_supported": "Usa POST /sign_in per eseguire il login. GET non è supportato.",
        "user_not_found": "Utente non trovato o non autenticato."
      },
      "token_validations": {
        "invalid": "Credenziali di login non valide"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "deve essere accettata",
        "already_confirmed": "è stato già confermato",
        "blank": "non può essere lasciato in bianco",
        "confirmation": "non coincide con %{attribute}",
        "confirmation_period_expired": "deve essere confermato entro %{period}, richiedi una nuova conferma",
        "empty": "non può essere vuoto",
        "equal_to": "deve essere uguale a %{count}",
        "even": "deve essere pari",
        "exclusion": "è riservato",
        "expired": "è scaduto, si prega di richiederne uno nuovo",
        "greater_than": "deve essere maggiore di %{count}",
        "greater_than_or_equal_to": "deve essere maggiore o uguale a %{count}",
        "inclusion": "non è compreso tra le opzioni disponibili",
        "invalid": "non è valido",
        "less_than": "deve essere minore di %{count}",
        "less_than_or_equal_to": "deve essere minore o uguale a %{count}",
        "model_invalid": "Validazione fallita: %{errors}",
        "not_a_number": "non è un numero",
        "not_an_integer": "non è un numero intero",
        "not_email": "non è un'email",
        "not_found": "non trovato",
        "not_locked": "non era bloccato",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "deve essere dispari",
        "other_than": "devono essere di numero diverso da %{count}",
        "present": "deve essere lasciato in bianco",
        "required": "deve esistere",
        "taken": "è già presente",
        "too_long": {
          "one": "è troppo lungo (il massimo è %{count} carattere)",
          "other": "è troppo lungo (il massimo è %{count} caratteri)"
        },
        "too_short": {
          "one": "è troppo corto (il minimo è %{count} carattere)",
          "other": "è troppo corto (il minimo è %{count} caratteri)"
        },
        "validate_account_update_params": "Dati di aggiornamento dell'account non validi.",
        "validate_sign_up_params": "Dati di registrazione non validi.",
        "wrong_length": {
          "one": "è della lunghezza sbagliata (deve essere di %{count} carattere)",
          "other": "è della lunghezza sbagliata (deve essere di %{count} caratteri)"
        }
      },
      "template": {
        "body": "Ricontrolla i seguenti campi:",
        "header": {
          "one": "Non posso salvare questo %{model}: %{count} errore",
          "other": "Non posso salvare questo %{model}: %{count} errori."
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_prefix} #{Name.first_name} #{city_suffix}",
          "#{city_prefix} #{Name.first_name}",
          "#{Name.first_name} #{city_suffix}",
          "#{Name.last_name} #{city_suffix}"
        ],
        "city_prefix": [
          "San",
          "Borgo",
          "Sesto",
          "Quarto",
          "Settimo"
        ],
        "city_suffix": [
          "a mare",
          "lido",
          "ligure",
          "del friuli",
          "salentino",
          "calabro",
          "veneto",
          "nell'emilia",
          "umbro",
          "laziale",
          "terme",
          "sardo"
        ],
        "country": [
          "Afghanistan",
          "Albania",
          "Algeria",
          "American Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antartide (territori a sud del 60° parallelo)",
          "Antigua e Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbaijan",
          "Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Bielorussia",
          "Belgio",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivia",
          "Bosnia e Herzegovina",
          "Botswana",
          "Bouvet Island (Bouvetoya)",
          "Brasile",
          "Territorio dell'arcipelago indiano",
          "Isole Vergini Britanniche",
          "Brunei Darussalam",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cambogia",
          "Cameroon",
          "Canada",
          "Capo Verde",
          "Isole Cayman",
          "Repubblica Centrale Africana",
          "Chad",
          "Cile",
          "Cina",
          "Isola di Pasqua",
          "Isola di Cocos (Keeling)",
          "Colombia",
          "Comoros",
          "Congo",
          "Isole Cook",
          "Costa Rica",
          "Costa d'Avorio",
          "Croazia",
          "Cuba",
          "Cipro",
          "Repubblica Ceca",
          "Danimarca",
          "Gibuti",
          "Repubblica Dominicana",
          "Equador",
          "Egitto",
          "El Salvador",
          "Guinea Equatoriale",
          "Eritrea",
          "Estonia",
          "Etiopia",
          "Isole Faroe",
          "Isole Falkland (Malvinas)",
          "Fiji",
          "Finlandia",
          "Francia",
          "Guyana Francese",
          "Polinesia Francese",
          "Territori Francesi del sud",
          "Gabon",
          "Gambia",
          "Georgia",
          "Germania",
          "Ghana",
          "Gibilterra",
          "Grecia",
          "Groenlandia",
          "Grenada",
          "Guadalupa",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard Island and McDonald Islands",
          "Città del Vaticano",
          "Honduras",
          "Hong Kong",
          "Ungheria",
          "Islanda",
          "India",
          "Indonesia",
          "Iran",
          "Iraq",
          "Irlanda",
          "Isola di Man",
          "Israele",
          "Italia",
          "Giamaica",
          "Giappone",
          "Jersey",
          "Giordania",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea",
          "Kuwait",
          "Republicca Kirgiza",
          "Repubblica del Laos",
          "Latvia",
          "Libano",
          "Lesotho",
          "Liberia",
          "Libyan Arab Jamahiriya",
          "Liechtenstein",
          "Lituania",
          "Lussemburgo",
          "Macao",
          "Macedonia",
          "Madagascar",
          "Malawi",
          "Malesia",
          "Maldive",
          "Mali",
          "Malta",
          "Isole Marshall",
          "Martinica",
          "Mauritania",
          "Mauritius",
          "Mayotte",
          "Messico",
          "Micronesia",
          "Moldova",
          "Principato di Monaco",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Marocco",
          "Mozambico",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Antille Olandesi",
          "Olanda",
          "Nuova Caledonia",
          "Nuova Zelanda",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "Niue",
          "Isole Norfolk",
          "Northern Mariana Islands",
          "Norvegia",
          "Oman",
          "Pakistan",
          "Palau",
          "Palestina",
          "Panama",
          "Papua Nuova Guinea",
          "Paraguay",
          "Peru",
          "Filippine",
          "Pitcairn Islands",
          "Polonia",
          "Portogallo",
          "Porto Rico",
          "Qatar",
          "Reunion",
          "Romania",
          "Russia",
          "Rwanda",
          "San Bartolomeo",
          "Sant'Elena",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Martin",
          "Saint Pierre and Miquelon",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Arabia Saudita",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Slovenia",
          "Isole Solomon",
          "Somalia",
          "Sud Africa",
          "Georgia del sud e South Sandwich Islands",
          "Spagna",
          "Sri Lanka",
          "Sudan",
          "Suriname",
          "Svalbard & Jan Mayen Islands",
          "Swaziland",
          "Svezia",
          "Svizzera",
          "Siria",
          "Taiwan",
          "Tajikistan",
          "Tanzania",
          "Tailandia",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad e Tobago",
          "Tunisia",
          "Turchia",
          "Turkmenistan",
          "Isole di Turks and Caicos",
          "Tuvalu",
          "Uganda",
          "Ucraina",
          "Emirati Arabi Uniti",
          "Regno Unito",
          "Stati Uniti d'America",
          "United States Minor Outlying Islands",
          "Isole Vergini Statunitensi",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Venezuela",
          "Vietnam",
          "Wallis and Futuna",
          "Western Sahara",
          "Yemen",
          "Zambia",
          "Zimbabwe"
        ],
        "default_country": [
          "Italia"
        ],
        "default_country_code": [
          "IT"
        ],
        "postcode": [
          "#####"
        ],
        "secondary_address": [
          "Appartamento ##",
          "Piano #"
        ],
        "state": [
          "Agrigento",
          "Alessandria",
          "Ancona",
          "Aosta",
          "Arezzo",
          "Ascoli Piceno",
          "Asti",
          "Avellino",
          "Bari",
          "Barletta-Andria-Trani",
          "Belluno",
          "Benevento",
          "Bergamo",
          "Biella",
          "Bologna",
          "Bolzano",
          "Brescia",
          "Brindisi",
          "Cagliari",
          "Caltanissetta",
          "Campobasso",
          "Carbonia-Iglesias",
          "Caserta",
          "Catania",
          "Catanzaro",
          "Chieti",
          "Como",
          "Cosenza",
          "Cremona",
          "Crotone",
          "Cuneo",
          "Enna",
          "Fermo",
          "Ferrara",
          "Firenze",
          "Foggia",
          "Forlì-Cesena",
          "Frosinone",
          "Genova",
          "Gorizia",
          "Grosseto",
          "Imperia",
          "Isernia",
          "La Spezia",
          "L'Aquila",
          "Latina",
          "Lecce",
          "Lecco",
          "Livorno",
          "Lodi",
          "Lucca",
          "Macerata",
          "Mantova",
          "Massa-Carrara",
          "Matera",
          "Messina",
          "Milano",
          "Modena",
          "Monza e della Brianza",
          "Napoli",
          "Novara",
          "Nuoro",
          "Olbia-Tempio",
          "Oristano",
          "Padova",
          "Palermo",
          "Parma",
          "Pavia",
          "Perugia",
          "Pesaro e Urbino",
          "Pescara",
          "Piacenza",
          "Pisa",
          "Pistoia",
          "Pordenone",
          "Potenza",
          "Prato",
          "Ragusa",
          "Ravenna",
          "Reggio Calabria",
          "Reggio Emilia",
          "Rieti",
          "Rimini",
          "Roma",
          "Rovigo",
          "Salerno",
          "Medio Campidano",
          "Sassari",
          "Savona",
          "Siena",
          "Siracusa",
          "Sondrio",
          "Taranto",
          "Teramo",
          "Terni",
          "Torino",
          "Ogliastra",
          "Trapani",
          "Trento",
          "Treviso",
          "Trieste",
          "Udine",
          "Varese",
          "Venezia",
          "Verbano-Cusio-Ossola",
          "Vercelli",
          "Verona",
          "Vibo Valentia",
          "Vicenza",
          "Viterbo"
        ],
        "state_abbr": [
          "AG",
          "AL",
          "AN",
          "AO",
          "AR",
          "AP",
          "AT",
          "AV",
          "BA",
          "BT",
          "BL",
          "BN",
          "BG",
          "BI",
          "BO",
          "BZ",
          "BS",
          "BR",
          "CA",
          "CL",
          "CB",
          "CI",
          "CE",
          "CT",
          "CZ",
          "CH",
          "CO",
          "CS",
          "CR",
          "KR",
          "CN",
          "EN",
          "FM",
          "FE",
          "FI",
          "FG",
          "FC",
          "FR",
          "GE",
          "GO",
          "GR",
          "IM",
          "IS",
          "SP",
          "AQ",
          "LT",
          "LE",
          "LC",
          "LI",
          "LO",
          "LU",
          "MC",
          "MN",
          "MS",
          "MT",
          "ME",
          "MI",
          "MO",
          "MB",
          "NA",
          "NO",
          "NU",
          "OT",
          "OR",
          "PD",
          "PA",
          "PR",
          "PV",
          "PG",
          "PU",
          "PE",
          "PC",
          "PI",
          "PT",
          "PN",
          "PZ",
          "PO",
          "RG",
          "RA",
          "RC",
          "RE",
          "RI",
          "RN",
          "RM",
          "RO",
          "SA",
          "VS",
          "SS",
          "SV",
          "SI",
          "SR",
          "SO",
          "TA",
          "TE",
          "TR",
          "TO",
          "OG",
          "TP",
          "TN",
          "TV",
          "TS",
          "UD",
          "VA",
          "VE",
          "VB",
          "VC",
          "VR",
          "VV",
          "VI",
          "VT"
        ],
        "street_address": [
          "#{street_name} #{building_number}",
          "#{street_name} #{building_number}, #{secondary_address}"
        ],
        "street_name": [
          "#{street_suffix} #{Name.first_name}",
          "#{street_suffix} #{Name.last_name}"
        ],
        "street_suffix": [
          "Piazza",
          "Strada",
          "Via",
          "Borgo",
          "Contrada",
          "Rotonda",
          "Incrocio"
        ]
      },
      "company": {
        "bs": [
          [
            "partnerships",
            "comunità",
            "ROI",
            "soluzioni",
            "e-services",
            "nicchie",
            "tecnologie",
            "contenuti",
            "supply-chains",
            "convergenze",
            "relazioni",
            "architetture",
            "interfacce",
            "mercati",
            "e-commerce",
            "sistemi",
            "modelli",
            "schemi",
            "reti",
            "applicazioni",
            "metriche",
            "e-business",
            "funzionalità",
            "esperienze",
            "webservices",
            "metodologie"
          ],
          [
            "implementate",
            "utilizzo",
            "integrate",
            "ottimali",
            "evolutive",
            "abilitate",
            "reinventate",
            "aggregate",
            "migliorate",
            "incentivate",
            "monetizzate",
            "sinergizzate",
            "strategiche",
            "deploy",
            "marchi",
            "accrescitive",
            "target",
            "sintetizzate",
            "spedizioni",
            "massimizzate",
            "innovazione",
            "guida",
            "estensioni",
            "generate",
            "exploit",
            "transizionali",
            "matrici",
            "ricontestualizzate"
          ],
          [
            "valore aggiunto",
            "verticalizzate",
            "proattive",
            "forti",
            "rivoluzionari",
            "scalabili",
            "innovativi",
            "intuitivi",
            "strategici",
            "e-business",
            "mission-critical",
            "24/7",
            "globali",
            "B2B",
            "B2C",
            "granulari",
            "virtuali",
            "virali",
            "dinamiche",
            "magnetiche",
            "web",
            "interattive",
            "sexy",
            "back-end",
            "real-time",
            "efficienti",
            "front-end",
            "distributivi",
            "estensibili",
            "mondiali",
            "open-source",
            "cross-platform",
            "sinergiche",
            "out-of-the-box",
            "enterprise",
            "integrate",
            "di impatto",
            "wireless",
            "trasparenti",
            "next-generation",
            "cutting-edge",
            "visionari",
            "plug-and-play",
            "collaborative",
            "olistiche",
            "ricche"
          ]
        ],
        "buzzwords": [
          [
            "Abilità",
            "Access",
            "Adattatore",
            "Algoritmo",
            "Alleanza",
            "Analizzatore",
            "Applicazione",
            "Approccio",
            "Architettura",
            "Archivio",
            "Intelligenza artificiale",
            "Array",
            "Attitudine",
            "Benchmark",
            "Capacità",
            "Sfida",
            "Circuito",
            "Collaborazione",
            "Complessità",
            "Concetto",
            "Conglomerato",
            "Contingenza",
            "Core",
            "Database",
            "Data-warehouse",
            "Definizione",
            "Emulazione",
            "Codifica",
            "Criptazione",
            "Firmware",
            "Flessibilità",
            "Previsione",
            "Frame",
            "framework",
            "Funzione",
            "Funzionalità",
            "Interfaccia grafica",
            "Hardware",
            "Help-desk",
            "Gerarchia",
            "Hub",
            "Implementazione",
            "Infrastruttura",
            "Iniziativa",
            "Installazione",
            "Set di istruzioni",
            "Interfaccia",
            "Soluzione internet",
            "Intranet",
            "Conoscenza base",
            "Matrici",
            "Matrice",
            "Metodologia",
            "Middleware",
            "Migrazione",
            "Modello",
            "Moderazione",
            "Monitoraggio",
            "Moratoria",
            "Rete",
            "Architettura aperta",
            "Sistema aperto",
            "Orchestrazione",
            "Paradigma",
            "Parallelismo",
            "Policy",
            "Portale",
            "Struttura di prezzo",
            "Prodotto",
            "Produttività",
            "Progetto",
            "Proiezione",
            "Protocollo",
            "Servizio clienti",
            "Software",
            "Soluzione",
            "Standardizzazione",
            "Strategia",
            "Struttura",
            "Successo",
            "Sovrastruttura",
            "Supporto",
            "Sinergia",
            "Task-force",
            "Finestra temporale",
            "Strumenti",
            "Utilizzazione",
            "Sito web",
            "Forza lavoro"
          ],
          [
            "adattiva",
            "avanzata",
            "migliorata",
            "assimilata",
            "automatizzata",
            "bilanciata",
            "centralizzata",
            "compatibile",
            "configurabile",
            "cross-platform",
            "decentralizzata",
            "digitalizzata",
            "distribuita",
            "piccola",
            "ergonomica",
            "esclusiva",
            "espansa",
            "estesa",
            "configurabile",
            "fondamentale",
            "orizzontale",
            "implementata",
            "innovativa",
            "integrata",
            "intuitiva",
            "inversa",
            "gestita",
            "obbligatoria",
            "monitorata",
            "multi-canale",
            "multi-laterale",
            "open-source",
            "operativa",
            "ottimizzata",
            "organica",
            "persistente",
            "polarizzata",
            "proattiva",
            "programmabile",
            "progressiva",
            "reattiva",
            "riallineata",
            "ricontestualizzata",
            "ridotta",
            "robusta",
            "sicura",
            "condivisibile",
            "stand-alone",
            "switchabile",
            "sincronizzata",
            "sinergica",
            "totale",
            "universale",
            "user-friendly",
            "versatile",
            "virtuale",
            "visionaria"
          ],
          [
            "24 ore",
            "24/7",
            "terza generazione",
            "quarta generazione",
            "quinta generazione",
            "sesta generazione",
            "asimmetrica",
            "asincrona",
            "background",
            "bi-direzionale",
            "biforcata",
            "bottom-line",
            "coerente",
            "coesiva",
            "composita",
            "sensibile al contesto",
            "basta sul contesto",
            "basata sul contenuto",
            "dedicata",
            "didattica",
            "direzionale",
            "discreta",
            "dinamica",
            "eco-centrica",
            "esecutiva",
            "esplicita",
            "full-range",
            "globale",
            "euristica",
            "alto livello",
            "olistica",
            "omogenea",
            "ibrida",
            "impattante",
            "incrementale",
            "intangibile",
            "interattiva",
            "intermediaria",
            "locale",
            "logistica",
            "massimizzata",
            "metodica",
            "mission-critical",
            "mobile",
            "modulare",
            "motivazionale",
            "multimedia",
            "multi-tasking",
            "nazionale",
            "neutrale",
            "nextgeneration",
            "non-volatile",
            "object-oriented",
            "ottima",
            "ottimizzante",
            "radicale",
            "real-time",
            "reciproca",
            "regionale",
            "responsiva",
            "scalabile",
            "secondaria",
            "stabile",
            "statica",
            "sistematica",
            "sistemica",
            "tangibile",
            "terziaria",
            "uniforme",
            "valore aggiunto"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name} #{suffix}",
          "#{Name.last_name}, #{Name.last_name} e #{Name.last_name} #{suffix}"
        ],
        "suffix": [
          "SPA",
          "e figli",
          "Group",
          "s.r.l."
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "com",
          "com",
          "net",
          "org",
          "it",
          "it",
          "it"
        ]
      },
      "name": {
        "first_name": [
          "Alberto",
          "Alessandro",
          "Alighieri",
          "Amedeo",
          "Anselmo",
          "Antonino",
          "Arcibaldo",
          "Armando",
          "Audenico",
          "Ausonio",
          "Bacchisio",
          "Battista",
          "Bernardo",
          "Caio",
          "Carlo",
          "Cecco",
          "Cirino",
          "Costantino",
          "Damiano",
          "Davide",
          "Edilio",
          "Egidio",
          "Elio",
          "Emanuel",
          "Enrico",
          "Ercole",
          "Eusebio",
          "Evangelista",
          "Fabiano",
          "Ferdinando",
          "Fiorentino",
          "Flavio",
          "Fulvio",
          "Gabriele",
          "Gastone",
          "Germano",
          "Giacinto",
          "Gianantonio",
          "Gianleonardo",
          "Gianmarco",
          "Gianriccardo",
          "Gioacchino",
          "Giordano",
          "Giuliano",
          "Graziano",
          "Guido",
          "Iacopo",
          "Ilario",
          "Ione",
          "Italo",
          "Laerte",
          "Lauro",
          "Leonardo",
          "Liborio",
          "Lorenzo",
          "Ludovico",
          "Maggiore",
          "Manuele",
          "Mariano",
          "Matteo",
          "Mauro",
          "Mirco",
          "Modesto",
          "Muzio",
          "Odino",
          "Olo",
          "Oreste",
          "Osea",
          "Patrizio",
          "Piererminio",
          "Pierfrancesco",
          "Piersilvio",
          "Priamo",
          "Quarto",
          "Quirino",
          "Raniero",
          "Renato",
          "Rocco",
          "Romeo",
          "Rosalino",
          "Sabatino",
          "Samuel",
          "Santo",
          "Serse",
          "Silvano",
          "Sirio",
          "Tancredi",
          "Terzo",
          "Timoteo",
          "Tolomeo",
          "Ubaldo",
          "Ulrico",
          "Valdo",
          "Neri",
          "Vinicio",
          "Walter",
          "Zaccaria",
          "Abramo",
          "Adriano",
          "Alan",
          "Albino",
          "Alessio",
          "Alighiero",
          "Amerigo",
          "Anastasio",
          "Antimo",
          "Antonio",
          "Arduino",
          "Aroldo",
          "Arturo",
          "Augusto",
          "Avide",
          "Baldassarre",
          "Bettino",
          "Bortolo",
          "Caligola",
          "Carmelo",
          "Celeste",
          "Ciro",
          "Costanzo",
          "Dante",
          "Dindo",
          "Domiziano",
          "Edipo",
          "Egisto",
          "Eliziario",
          "Emidio",
          "Enzo",
          "Eriberto",
          "Erminio",
          "Ettore",
          "Eustachio",
          "Fabio",
          "Fernando",
          "Fiorenzo",
          "Folco",
          "Furio",
          "Gaetano",
          "Gavino",
          "Gerlando",
          "Giacobbe",
          "Giancarlo",
          "Gianmaria",
          "Giobbe",
          "Giorgio",
          "Giulio",
          "Gregorio",
          "Ippolito",
          "Ivano",
          "Jacopo",
          "Lamberto",
          "Lazzaro",
          "Leone",
          "Lino",
          "Loris",
          "Luigi",
          "Manfredi",
          "Marco",
          "Marino",
          "Marzio",
          "Mattia",
          "Max",
          "Michele",
          "Mirko",
          "Moreno",
          "Nazzareno",
          "Nestore",
          "Nico",
          "Odone",
          "Omar",
          "Orfeo",
          "Osvaldo",
          "Pacifico",
          "Pericle",
          "Pietro",
          "Primo",
          "Quasimodo",
          "Radio",
          "Raoul",
          "Renzo",
          "Rodolfo",
          "Romolo",
          "Rosolino",
          "Rufo",
          "Sabino",
          "Sandro",
          "Secondo",
          "Sesto",
          "Silverio",
          "Siro",
          "Tazio",
          "Teseo",
          "Tommaso",
          "Tristano",
          "Umberto",
          "Artemide",
          "Assia",
          "Azue",
          "Benedetta",
          "Bibiana",
          "Brigitta",
          "Carmela",
          "Cassiopea",
          "Cesidia",
          "Cira",
          "Clea",
          "Cleopatra",
          "Clodovea",
          "Concetta",
          "Cosetta",
          "Cristyn",
          "Damiana",
          "Danuta",
          "Deborah",
          "Demi",
          "Diamante",
          "Diana",
          "Donatella",
          "Doriana",
          "Elda",
          "Elga",
          "Elsa",
          "Emilia",
          "Enrica",
          "Erminia",
          "Eufemia",
          "Evita",
          "Fatima",
          "Felicia",
          "Filomena",
          "Flaviana",
          "Fortunata",
          "Gelsomina",
          "Genziana",
          "Giacinta",
          "Gilda",
          "Giovanna",
          "Giulietta",
          "Grazia",
          "Guendalina",
          "Ileana",
          "Irene",
          "Isabel",
          "Isira",
          "Ivonne",
          "Jole",
          "Claudia",
          "Laura",
          "Lucia",
          "Lia",
          "Lidia",
          "Lisa",
          "Loredana",
          "Loretta",
          "Luce",
          "Lucrezia",
          "Luna",
          "Marcella",
          "Maria",
          "Mariagiulia",
          "Marianita",
          "Mariapia",
          "Marieva",
          "Marina",
          "Maristella",
          "Matilde",
          "Mecren",
          "Mietta",
          "Miriana",
          "Miriam",
          "Monia",
          "Morgana",
          "Naomi",
          "Nicoletta",
          "Ninfa",
          "Noemi",
          "Nunzia",
          "Olimpia",
          "Oretta",
          "Ortensia",
          "Penelope",
          "Piccarda",
          "Prisca",
          "Rebecca",
          "Rita",
          "Rosalba",
          "Rosaria",
          "Rosita",
          "Samira",
          "Sarita",
          "Selvaggia",
          "Sibilla",
          "Soriana",
          "Thea",
          "Tosca",
          "Ursula",
          "Vania",
          "Vera",
          "Vienna",
          "Violante",
          "Vitalba",
          "Zelida"
        ],
        "last_name": [
          "Amato",
          "Barbieri",
          "Barone",
          "Basile",
          "Battaglia",
          "Bellini",
          "Benedetti",
          "Bernardi",
          "Bianc",
          "Bianchi",
          "Bruno",
          "Caputo",
          "Carbon",
          "Caruso",
          "Cattaneo",
          "Colombo",
          "Cont",
          "Conte",
          "Coppola",
          "Costa",
          "Costantin",
          "D'amico",
          "D'angelo",
          "Damico",
          "De Angelis",
          "De luca",
          "De rosa",
          "De Santis",
          "Donati",
          "Esposito",
          "Fabbri",
          "Farin",
          "Ferrara",
          "Ferrari",
          "Ferraro",
          "Ferretti",
          "Ferri",
          "Fior",
          "Fontana",
          "Galli",
          "Gallo",
          "Gatti",
          "Gentile",
          "Giordano",
          "Giuliani",
          "Grassi",
          "Grasso",
          "Greco",
          "Guerra",
          "Leone",
          "Lombardi",
          "Lombardo",
          "Longo",
          "Mancini",
          "Marchetti",
          "Marian",
          "Marini",
          "Marino",
          "Martinelli",
          "Martini",
          "Martino",
          "Mazza",
          "Messina",
          "Milani",
          "Montanari",
          "Monti",
          "Morelli",
          "Moretti",
          "Negri",
          "Neri",
          "Orlando",
          "Pagano",
          "Palmieri",
          "Palumbo",
          "Parisi",
          "Pellegrini",
          "Pellegrino",
          "Piras",
          "Ricci",
          "Rinaldi",
          "Riva",
          "Rizzi",
          "Rizzo",
          "Romano",
          "Ross",
          "Rossetti",
          "Ruggiero",
          "Russo",
          "Sala",
          "Sanna",
          "Santoro",
          "Sartori",
          "Serr",
          "Silvestri",
          "Sorrentino",
          "Testa",
          "Valentini",
          "Villa",
          "Vitale",
          "Vitali"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Sig.",
          "Dott.",
          "Dr.",
          "Ing."
        ],
        "suffix": []
      },
      "phone_number": {
        "country_code": [
          "39"
        ],
        "formats": [
          "### ## ## ####",
          "## #######",
          "## ########",
          "### #######",
          "### ########",
          "#### #######",
          "#### ########",
          "0## ### ####",
          "0## ### ###",
          "3## ### ###",
          "3## ### ###"
        ]
      },
      "subscription": {
        "payment_methods": [
          "Carta di credito",
          "Carta di debito",
          "Paypal",
          "Contanti",
          "Bonifico",
          "Bitcoins",
          "Assegno",
          "Apple Pay",
          "Google Pay",
          "WeChat Pay",
          "Alipay",
          "Visa Checkout"
        ],
        "payment_terms": [
          "Pagamento anticipato",
          "Mensile",
          "Annuale",
          "Abbonamento completo"
        ],
        "plans": [
          "Prova gratuita",
          "Basico",
          "Starter",
          "Essential",
          "Studente",
          "Bronze\"",
          "Standard",
          "Silver",
          "Gold",
          "Platinum",
          "Profesional",
          "Business",
          "Diamond",
          "Premium"
        ],
        "statuses": [
          "Attivo",
          "Inattivo",
          "Bloccato",
          "In sospeso"
        ],
        "subscription_terms": [
          "Quotidiano",
          "Settimanale",
          "Mensile",
          "Annuale",
          "Biennale",
          "Triennale",
          "Quinquennale",
          "Abbonamento a vita"
        ]
      }
    },
    "hello": "ciao",
    "helpers": {
      "select": {
        "prompt": "Seleziona..."
      },
      "submit": {
        "create": "Crea %{model}",
        "submit": "Invia %{model}",
        "update": "Aggiorna %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miliardi",
            "million": "Milioni",
            "quadrillion": "Biliardi",
            "thousand": "Mila",
            "trillion": "Bilioni",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Byte"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a %d %b %Y, %H:%M:%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "welcome": "benvenuto"
  },
  "it-CH": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validazione fallita: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Il record non può essere cancellato perchè esistono %{record} dipendenti",
            "has_one": "Il record non può essere cancellato perchè esiste un %{record} dipendente"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Dom",
        "Lun",
        "Mar",
        "Mer",
        "Gio",
        "Ven",
        "Sab"
      ],
      "abbr_month_names": [
        null,
        "Gen",
        "Feb",
        "Mar",
        "Apr",
        "Mag",
        "Giu",
        "Lug",
        "Ago",
        "Set",
        "Ott",
        "Nov",
        "Dic"
      ],
      "day_names": [
        "Domenica",
        "Lunedì",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "circa un'ora",
          "other": "circa %{count} ore"
        },
        "about_x_months": {
          "one": "circa un mese",
          "other": "circa %{count} mesi"
        },
        "about_x_years": {
          "one": "circa un anno",
          "other": "circa %{count} anni"
        },
        "almost_x_years": {
          "one": "circa %{count} anno",
          "other": "circa %{count} anni"
        },
        "half_a_minute": "mezzo minuto",
        "less_than_x_minutes": {
          "one": "meno di un minuto",
          "other": "meno di %{count} minuti"
        },
        "less_than_x_seconds": {
          "one": "meno di un secondo",
          "other": "meno di %{count} secondi"
        },
        "over_x_years": {
          "one": "oltre un anno",
          "other": "oltre %{count} anni"
        },
        "x_days": {
          "one": "%{count} giorno",
          "other": "%{count} giorni"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minuti"
        },
        "x_months": {
          "one": "%{count} mese",
          "other": "%{count} mesi"
        },
        "x_seconds": {
          "one": "%{count} secondo",
          "other": "%{count} secondi"
        },
        "x_years": {
          "one": "%{count} anno",
          "other": "%{count} anni"
        }
      },
      "prompts": {
        "day": "Giorno",
        "hour": "Ora",
        "minute": "Minuto",
        "month": "Mese",
        "second": "Secondi",
        "year": "Anno"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "deve essere accettata",
        "blank": "non può essere lasciato in bianco",
        "confirmation": "non coincide con %{attribute}",
        "empty": "non può essere vuoto",
        "equal_to": "deve essere uguale a %{count}",
        "even": "deve essere pari",
        "exclusion": "è riservato",
        "greater_than": "deve essere superiore a %{count}",
        "greater_than_or_equal_to": "deve essere superiore o uguale a %{count}",
        "inclusion": "non è incluso nella lista",
        "invalid": "non è valido",
        "less_than": "deve essere meno di %{count}",
        "less_than_or_equal_to": "deve essere meno o uguale a %{count}",
        "model_invalid": "Validazione fallita: %{errors}",
        "not_a_number": "non è un numero",
        "not_an_integer": "non è un intero",
        "odd": "deve essere dispari",
        "other_than": "devono essere di numero diverso da %{count}",
        "present": "deve essere lasciato in bianco",
        "required": "deve esistere",
        "taken": "è già presente",
        "too_long": {
          "one": "è troppo lungo (il massimo è %{count} carattere)",
          "other": "è troppo lungo (il massimo è %{count} caratteri)"
        },
        "too_short": {
          "one": "è troppo corto (il minimo è %{count} carattere)",
          "other": "è troppo corto (il minimo è %{count} caratteri)"
        },
        "wrong_length": {
          "one": "è della lunghezza sbagliata (deve essere di %{count} carattere)",
          "other": "è della lunghezza sbagliata (deve essere di %{count} caratteri)"
        }
      },
      "template": {
        "body": "Per favore ricontrolla i seguenti campi:",
        "header": {
          "one": "Non posso salvare questo %{model}: %{count} errore",
          "other": "Non posso salvare questo %{model}: %{count} errori."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Per favore, seleziona"
      },
      "submit": {
        "create": "Crea %{model}",
        "submit": "Invia %{model}",
        "update": "Aggiorna %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": "'",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "CHF"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miliardi",
            "million": "Milioni",
            "quadrillion": "Biliardi",
            "thousand": "Mila",
            "trillion": "Bilioni",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Byte"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "ja": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "パスワード確認送信時刻",
          "confirmation_token": "パスワード確認用トークン",
          "confirmed_at": "パスワード確認時刻",
          "created_at": "作成日",
          "current_password": "現在のパスワード",
          "current_sign_in_at": "現在のログイン時刻",
          "current_sign_in_ip": "現在のログインIPアドレス",
          "email": "Eメール",
          "encrypted_password": "暗号化パスワード",
          "failed_attempts": "失敗したログイン試行回数",
          "last_sign_in_at": "最終ログイン時刻",
          "last_sign_in_ip": "最終ログインIPアドレス",
          "locked_at": "ロック時刻",
          "password": "パスワード",
          "password_confirmation": "パスワード（確認用）",
          "remember_created_at": "ログイン記憶時刻",
          "remember_me": "ログインを記憶する",
          "reset_password_sent_at": "パスワードリセット送信時刻",
          "reset_password_token": "パスワードリセット用トークン",
          "sign_in_count": "ログイン回数",
          "unconfirmed_email": "未確認Eメール",
          "unlock_token": "ロック解除用トークン",
          "updated_at": "更新日"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "バリデーションに失敗しました: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "%{record}が存在しているので削除できません",
            "has_one": "%{record}が存在しているので削除できません"
          }
        }
      },
      "models": {
        "user": {
          "other": "ユーザー"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "日",
        "月",
        "火",
        "水",
        "木",
        "金",
        "土"
      ],
      "abbr_month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "day_names": [
        "日曜日",
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日"
      ],
      "formats": {
        "default": "%Y/%m/%d",
        "long": "%Y年%m月%d日(%a)",
        "short": "%m/%d"
      },
      "month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "約%{count}時間",
        "about_x_months": "約%{count}ヶ月",
        "about_x_years": "約%{count}年",
        "almost_x_years": "%{count}年弱",
        "half_a_minute": "30秒前後",
        "less_than_x_minutes": "%{count}分未満",
        "less_than_x_seconds": "%{count}秒未満",
        "over_x_years": "%{count}年以上",
        "x_days": "%{count}日",
        "x_minutes": "%{count}分",
        "x_months": "%{count}ヶ月",
        "x_seconds": "%{count}秒",
        "x_years": "%{count}年"
      },
      "prompts": {
        "day": "日",
        "hour": "時",
        "minute": "分",
        "month": "月",
        "second": "秒",
        "year": "年"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "メールアドレスが確認できました。",
        "new": {
          "resend_confirmation_instructions": "アカウント確認メール再送"
        },
        "send_instructions": "アカウントの有効化について数分以内にメールでご連絡します。",
        "send_paranoid_instructions": "メールアドレスが登録済みの場合、本人確認用のメールが数分以内に送信されます。"
      },
      "failure": {
        "already_authenticated": "すでにログインしています。",
        "inactive": "アカウントが有効化されていません。メールに記載された手順にしたがって、アカウントを有効化してください。",
        "invalid": "%{authentication_keys}またはパスワードが違います。",
        "invited": "アカウントを作成するには、保留中の招待を承認してください。",
        "last_attempt": "もう一回誤るとアカウントがロックされます。",
        "locked": "アカウントはロックされています。",
        "not_found_in_database": "%{authentication_keys}またはパスワードが違います。",
        "timeout": "セッションがタイムアウトしました。もう一度ログインしてください。",
        "unauthenticated": "ログインもしくはアカウント登録してください。",
        "unconfirmed": "メールアドレスの本人確認が必要です。"
      },
      "invitations": {
        "edit": {
          "header": "パスワードを設定する",
          "submit_button": "パスワードを設定する"
        },
        "invitation_removed": "招待を取り消しました。",
        "invitation_token_invalid": "招待コードが不正です。",
        "new": {
          "header": "招待する",
          "submit_button": "招待メールを送る"
        },
        "no_invitations_remaining": "これ以上招待できません。",
        "send_instructions": "招待メールが%{email}に送信されました。",
        "updated": "パスワードが設定されました。お使いのアカウントでログインできます。",
        "updated_not_active": "パスワードが設定されました。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "メールアドレスの確認",
          "confirm_account_link": "アカウントを有効化する",
          "confirm_link_msg": "下記のリンクからアカウントを有効化できます:",
          "greeting": "%{recipient}様",
          "instruction": "以下のリンクをクリックし、メールアドレスの確認手続を完了させてください。",
          "subject": "メールアドレス確認メール"
        },
        "email_changed": {
          "greeting": "こんにちは、%{recipient}様。",
          "message": "メールアドレスの（%{email}）変更が完了したため、メールを送信しています。",
          "message_unconfirmed": "メールアドレスが（%{email}）変更されたため、メールを送信しています。",
          "subject": "メール変更完了"
        },
        "invitation_instructions": {
          "accept": "招待を承認する",
          "accept_until": "この招待は%{due_date}まで有効です。",
          "hello": "こんにちは、%{email}さん",
          "ignore": "招待を承認しない場合は、このメールを無視してください。<br />あなたのアカウントは上記のリンク先にアクセスしパスワードを設定するまでは作成されません。",
          "someone_invited_you": "%{url}に招待されました。以下のリンクから承認できます。",
          "subject": "招待を承認するには"
        },
        "password_change": {
          "greeting": "%{recipient}様",
          "message": "パスワードが再設定されました。",
          "subject": "パスワードの変更について"
        },
        "reset_password_instructions": {
          "action": "パスワード変更",
          "greeting": "%{recipient}様",
          "ignore_mail_msg": "もしこの内容に覚えがない場合は、このメールを無視してください。",
          "instruction": "パスワード再設定の依頼を受けたため、メールを送信しています。下のリンクからパスワードの再設定ができます。",
          "instruction_2": "パスワード再設定の依頼をしていない場合、このメールを無視してください。",
          "instruction_3": "パスワードの再設定は、上のリンクから新しいパスワードを登録するまで完了しません。",
          "no_changes_msg": "上記のリンクにアクセスして新しいパスワードを作成するまで、現在のパスワードは変更されません。",
          "password_change_link": "パスワードを変更する",
          "request_reset_link_msg": "パスワード変更のリクエストが送信されました。下記のリンクからパスワードの変更ができます。",
          "subject": "パスワードの再設定について"
        },
        "unlock_instructions": {
          "account_lock_msg": "連続してログインに失敗したため、あなたのアカウントはロックされました。",
          "action": "アカウントのロック解除",
          "greeting": "%{recipient}様",
          "instruction": "アカウントのロックを解除するには下のリンクをクリックしてください。",
          "message": "ログイン失敗が繰り返されたため、アカウントはロックされています。",
          "subject": "アカウントのロック解除について",
          "unlock_link": "アカウントを有効化する",
          "unlock_link_msg": "下記のリンクをクリックしてアカウントを有効化してください:"
        }
      },
      "omniauth_callbacks": {
        "failure": "%{kind} アカウントによる認証に失敗しました。理由：（%{reason}）",
        "success": "%{kind} アカウントによる認証に成功しました。"
      },
      "passwords": {
        "edit": {
          "change_my_password": "パスワードを変更する",
          "change_your_password": "パスワードを変更",
          "confirm_new_password": "確認用新しいパスワード",
          "new_password": "新しいパスワード"
        },
        "new": {
          "forgot_your_password": "パスワードを忘れましたか？",
          "send_me_reset_password_instructions": "パスワードの再設定方法を送信する"
        },
        "no_token": "このページにはアクセスできません。パスワード再設定メールのリンクからアクセスされた場合には、URL をご確認ください。",
        "send_instructions": "パスワードの再設定について数分以内にメールでご連絡いたします。",
        "send_paranoid_instructions": "メールアドレスが登録済みの場合、パスワード再設定用のメールが数分以内に送信されます。",
        "updated": "パスワードが正しく変更されました。",
        "updated_not_active": "パスワードが正しく変更されました。"
      },
      "registrations": {
        "destroyed": "アカウントを削除しました。またのご利用をお待ちしております。",
        "edit": {
          "are_you_sure": "本当によろしいですか？",
          "cancel_my_account": "アカウント削除",
          "currently_waiting_confirmation_for_email": "%{email} の確認待ち",
          "leave_blank_if_you_don_t_want_to_change_it": "空欄のままなら変更しません",
          "title": "%{resource}編集",
          "unhappy": "気に入りません",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "変更を反映するには現在のパスワードを入力してください"
        },
        "new": {
          "sign_up": "アカウント登録"
        },
        "signed_up": "アカウント登録が完了しました。",
        "signed_up_but_inactive": "ログインするためには、アカウントを有効化してください。",
        "signed_up_but_locked": "アカウントがロックされているためログインできません。",
        "signed_up_but_unconfirmed": "本人確認用のメールを送信しました。メール内のリンクからアカウントを有効化させてください。",
        "update_needs_confirmation": "アカウント情報を変更しました。変更されたメールアドレスの本人確認のため、本人確認用メールより確認処理をおこなってください。",
        "updated": "アカウント情報を変更しました。",
        "updated_but_not_signed_in": "あなたのアカウントは正常に更新されましたが、パスワードが変更されたため、再度ログインしてください。"
      },
      "sessions": {
        "already_signed_out": "既にログアウト済みです。",
        "new": {
          "sign_in": "ログイン"
        },
        "signed_in": "ログインしました。",
        "signed_out": "ログアウトしました。"
      },
      "shared": {
        "links": {
          "back": "戻る",
          "didn_t_receive_confirmation_instructions": "アカウント確認のメールを受け取っていませんか？",
          "didn_t_receive_unlock_instructions": "アカウントのロック解除方法のメールを受け取っていませんか？",
          "forgot_your_password": "パスワードを忘れましたか？",
          "sign_in": "ログイン",
          "sign_in_with_provider": "%{provider}でログイン",
          "sign_up": "アカウント登録"
        },
        "minimum_password_length": {
          "other": "（%{count}字以上）"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "アカウントのロック解除方法を再送する"
        },
        "send_instructions": "アカウントのロック解除方法を数分以内にメールでご連絡します。",
        "send_paranoid_instructions": "アカウントが見つかった場合、アカウントのロック解除方法を数分以内にメールでご連絡します。",
        "unlocked": "アカウントをロック解除しました。"
      }
    },
    "devise_token_auth": {
      "confirmations": {
        "missing_email": "メールアドレスが与えられていません。",
        "sended": "'%{email}' にアカウントの確認方法を記載したメールが送信されました。",
        "sended_paranoid": "すでにメールアドレスがデータベースに登録されている場合、数分後にメールアドレスの確認方法を記載したメールをお送りします。",
        "user_not_found": "メールアドレス '%{email}' を持つユーザーが見つかりません。"
      },
      "omniauth": {
        "not_allowed_redirect_url": "'%{redirect_url}' へのリダイレクトは許可されていません。"
      },
      "passwords": {
        "missing_email": "メールアドレスが与えられていません。",
        "missing_passwords": "'Password', 'Password confirmation' パラメータが与えられていません。",
        "missing_redirect_url": "リダイレクト URL が与えられていません。",
        "not_allowed_redirect_url": "'%{redirect_url}' へのリダイレクトは許可されていません。",
        "password_not_required": "このアカウントはパスワードを要求していません。'%{provider}' を利用してログインしてください。",
        "sended": "'%{email}' にパスワードリセットの案内が送信されました。",
        "sended_paranoid": "すでにメールアドレスがデータベースに登録されている場合、 数分後にパスワード再発行用のリンクを記載したメールをお送りします。",
        "successfully_updated": "パスワードの更新に成功しました。",
        "user_not_found": "メールアドレス '%{email}' のユーザーが見つかりません。"
      },
      "registrations": {
        "account_to_destroy_not_found": "削除するアカウントが見つかりません。",
        "account_with_uid_destroyed": "'%{uid}' のアカウントは削除されました。",
        "email_already_exists": "'%{email}' のアカウントはすでに存在しています。",
        "missing_confirm_success_url": "'confirm_success_url' パラメータが与えられていません。",
        "redirect_url_not_allowed": "'%{redirect_url}' へのリダイレクトは許可されていません。",
        "user_not_found": "ユーザーが見つかりません。"
      },
      "sessions": {
        "bad_credentials": "ログイン用の認証情報が正しくありません。再度お試しください。",
        "not_confirmed": "'%{email}' に確認用のメールを送信しました。メール内の説明を読み、アカウントの有効化をしてください。",
        "not_supported": "/sign_in に GET はサポートされていません。POST をお使いください。",
        "user_not_found": "ユーザーが見つからないか、ログインしていません。"
      },
      "token_validations": {
        "invalid": "ログイン用の認証情報が正しくありません。"
      },
      "unlocks": {
        "missing_email": "メールアドレスが与えられていません。",
        "sended": "%{email}' にアカウントのロックを解除する方法を記載したメールが送信されました。",
        "sended_paranoid": "アカウントが存在する場合、数分後にロックを解除する方法を記載したメールをお送りします。",
        "user_not_found": "メールアドレス '%{email}' を持つユーザーが見つかりません。"
      }
    },
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "を受諾してください",
        "already_confirmed": "は既に登録済みです。ログインしてください。",
        "blank": "を入力してください",
        "confirmation": "と%{attribute}の入力が一致しません",
        "confirmation_period_expired": "の期限が切れました。%{period} までに確認する必要があります。 新しくリクエストしてください。",
        "empty": "を入力してください",
        "equal_to": "は%{count}にしてください",
        "even": "は偶数にしてください",
        "exclusion": "は予約されています",
        "expired": "の有効期限が切れました。新しくリクエストしてください。",
        "greater_than": "は%{count}より大きい値にしてください",
        "greater_than_or_equal_to": "は%{count}以上の値にしてください",
        "in": "は%{count}の範囲に含めてください",
        "inclusion": "は一覧にありません",
        "invalid": "は不正な値です",
        "less_than": "は%{count}より小さい値にしてください",
        "less_than_or_equal_to": "は%{count}以下の値にしてください",
        "model_invalid": "バリデーションに失敗しました: %{errors}",
        "not_a_number": "は数値で入力してください",
        "not_an_integer": "は整数で入力してください",
        "not_email": "は有効ではありません",
        "not_found": "は見つかりませんでした。",
        "not_locked": "はロックされていません。",
        "not_saved": {
          "other": "%{count} 件のエラーが発生したため %{resource} は保存されませんでした。"
        },
        "odd": "は奇数にしてください",
        "other_than": "は%{count}以外の値にしてください",
        "password_too_long": "が長すぎます",
        "present": "は入力しないでください",
        "required": "を入力してください",
        "taken": "はすでに存在します",
        "too_long": "は%{count}文字以内で入力してください",
        "too_short": "は%{count}文字以上で入力してください",
        "validate_account_update_params": "リクエストボディに適切なアカウント更新のデータを送信してください。",
        "validate_sign_up_params": "リクエストボディに適切なアカウント新規登録データを送信してください。",
        "wrong_length": "は%{count}文字で入力してください"
      },
      "template": {
        "body": "次の項目を確認してください",
        "header": "%{model}に%{count}個のエラーが発生しました"
      }
    },
    "faker": {
      "address": {
        "city": [
          "#{city_prefix}#{Name.first_name}#{city_suffix}",
          "#{Name.first_name}#{city_suffix}",
          "#{city_prefix}#{Name.last_name}#{city_suffix}",
          "#{Name.last_name}#{city_suffix}"
        ],
        "city_prefix": [
          "北",
          "東",
          "西",
          "南",
          "新",
          "大",
          "中",
          "小"
        ],
        "city_suffix": [
          "市",
          "区",
          "町",
          "村",
          "郡"
        ],
        "country": [
          "中華人民共和国",
          "香港",
          "マカオ",
          "台湾",
          "インド",
          "アメリカ合衆国",
          "プエルトリコ",
          "グアム",
          "アメリカ領ヴァージン諸島",
          "北マリアナ諸島",
          "アメリカ領サモア",
          "アメリカ",
          "インドネシア",
          "パキスタン",
          "ブラジル",
          "ナイジェリア",
          "バングラデシュ",
          "ロシア",
          "メキシコ",
          "日本",
          "エチオピア",
          "フィリピン",
          "エジプト",
          "ベトナム",
          "コンゴ民主共和国",
          "ドイツ",
          "トルコ",
          "イラン",
          "タイ王国",
          "イギリス",
          "チャンネル諸島",
          "マン島",
          "バミューダ諸島",
          "ケイマン諸島",
          "タークス・カイコス諸島",
          "ジブラルタル",
          "イギリス領ヴァージン諸島",
          "アンギラ",
          "セントヘレナ",
          "モントセラト",
          "フォークランド諸島",
          "フランス",
          "レユニオン",
          "グアドループ",
          "マルティニーク",
          "フランス領ギアナ",
          "ニューカレドニア",
          "フランス領ポリネシア",
          "マヨット",
          "サン・マルタン",
          "ウォリス・フツナ",
          "サン・バルテルミー島",
          "サンピエール島・ミクロン島",
          "イタリア",
          "南アフリカ共和国",
          "タンザニア",
          "ミャンマー",
          "ケニア",
          "大韓民国",
          "コロンビア",
          "スペイン",
          "アルゼンチン",
          "ウガンダ",
          "ウクライナ",
          "アルジェリア",
          "スーダン",
          "イラク",
          "アフガニスタン",
          "ポーランド",
          "カナダ",
          "モロッコ",
          "サウジアラビア",
          "ウズベキスタン",
          "ペルー",
          "マレーシア",
          "アンゴラ",
          "ガーナ",
          "モザンビーク",
          "イエメン",
          "ネパール",
          "ベネズエラ",
          "マダガスカル",
          "カメルーン",
          "コートジボワール",
          "朝鮮民主主義人民共和国",
          "オーストラリア",
          "ニジェール",
          "スリランカ",
          "ブルキナファソ",
          "マリ",
          "ルーマニア",
          "チリ",
          "マラウイ",
          "カザフスタン",
          "ザンビア",
          "グアテマラ",
          "オランダ",
          "キュラソー島",
          "アルバ",
          "シント・マールテン",
          "カリブ・オランダ",
          "エクアドル",
          "シリア",
          "カンボジア",
          "セネガル",
          "チャド",
          "ソマリア",
          "ジンバブエ",
          "ギニア",
          "ルワンダ",
          "ベナン",
          "チュニジア",
          "ベルギー",
          "ブルンジ",
          "ボリビア",
          "キューバ",
          "ハイチ",
          "南スーダン",
          "ドミニカ共和国",
          "チェコ",
          "ギリシャ",
          "ポルトガル",
          "ヨルダン",
          "アゼルバイジャン",
          "スウェーデン",
          "アラブ首長国連邦",
          "ホンジュラス",
          "ハンガリー",
          "ベラルーシ",
          "タジキスタン",
          "オーストリア",
          "パプアニューギニア",
          "セルビア",
          "スイス",
          "イスラエル",
          "トーゴ",
          "シエラレオネ",
          "ラオス",
          "パラグアイ",
          "ブルガリア",
          "レバノン",
          "リビア",
          "ニカラグア",
          "エルサルバドル",
          "キルギス",
          "トルクメニスタン",
          "デンマーク",
          "グリーンランド",
          "フェロー諸島",
          "シンガポール",
          "フィンランド",
          "スロバキア",
          "コンゴ共和国",
          "ノルウェー",
          "コスタリカ",
          "パレスチナ",
          "オマーン",
          "リベリア",
          "アイルランド",
          "ニュージーランド",
          "クック諸島",
          "ニウエ",
          "トケラウ",
          "中央アフリカ",
          "モーリタニア",
          "パナマ",
          "クウェート",
          "クロアチア",
          "モルドバ",
          "ジョージア",
          "エリトリア",
          "ウルグアイ",
          "ボスニア・ヘルツェゴビナ",
          "モンゴル国",
          "アルメニア",
          "ジャマイカ",
          "アルバニア",
          "カタール",
          "リトアニア",
          "ナミビア",
          "ガンビア",
          "ボツワナ",
          "ガボン",
          "レソト",
          "北マケドニア",
          "スロベニア",
          "ギニアビサウ",
          "ラトビア",
          "バーレーン",
          "トリニダード・トバゴ",
          "赤道ギニア",
          "エストニア",
          "東ティモール",
          "モーリシャス",
          "キプロス",
          "エスワティニ",
          "ジブチ",
          "フィジー",
          "コモロ",
          "ガイアナ",
          "ブータン",
          "ソロモン諸島",
          "モンテネグロ",
          "ルクセンブルク",
          "西サハラ",
          "スリナム",
          "カーボベルデ",
          "モルディブ",
          "マルタ",
          "ブルネイ",
          "ベリーズ",
          "バハマ",
          "アイスランド",
          "バヌアツ",
          "バルバドス",
          "サントメ・プリンシペ",
          "サモア",
          "セントルシア",
          "キリバス",
          "ミクロネシア連邦",
          "グレナダ",
          "セントビンセント・グレナディーン",
          "トンガ",
          "セーシェル",
          "アンティグア・バーブーダ",
          "アンドラ",
          "ドミニカ国",
          "マーシャル諸島",
          "セントクリストファー・ネイビス",
          "モナコ",
          "リヒテンシュタイン",
          "サンマリノ",
          "パラオ",
          "ツバル",
          "ナウル",
          "バチカン"
        ],
        "default_country": [
          "日本"
        ],
        "postcode": [
          "060-0000",
          "064-0941",
          "060-0041",
          "060-0042",
          "064-0820",
          "060-0031",
          "060-0001",
          "064-0821",
          "060-0032",
          "060-0002",
          "064-0822",
          "060-0033",
          "060-0003",
          "064-0823",
          "060-0034",
          "060-0004",
          "064-0824",
          "060-0035",
          "060-0005",
          "064-0825",
          "060-0006",
          "064-0826",
          "060-0007",
          "060-0008",
          "060-0009",
          "060-0010",
          "060-0011",
          "060-0012",
          "060-0013",
          "060-0014",
          "060-0015",
          "060-0016",
          "060-0017",
          "060-0018",
          "060-0020",
          "060-0021",
          "060-0022",
          "064-0943",
          "064-0931",
          "064-0945",
          "064-0942",
          "064-0946",
          "064-0944",
          "060-0051",
          "060-0061",
          "064-0801",
          "060-0052",
          "060-0062",
          "064-0802",
          "060-0053",
          "060-0063",
          "064-0803",
          "060-0054",
          "064-0804",
          "060-0055",
          "064-0805",
          "060-0056",
          "064-0806",
          "060-0057",
          "064-0807",
          "064-0808",
          "064-0809",
          "064-0810",
          "064-0811",
          "064-0912",
          "064-0913",
          "064-0914",
          "064-0915",
          "064-0916",
          "064-0917",
          "064-0918",
          "064-0919",
          "064-0920",
          "064-0921",
          "064-0922",
          "064-0923",
          "064-0924",
          "064-0925",
          "064-0926",
          "064-0927",
          "064-0928",
          "064-0929",
          "064-0930",
          "064-0959",
          "064-0958",
          "064-0951",
          "064-0952",
          "064-0953",
          "064-0954",
          "001-0000",
          "002-8071",
          "002-8072",
          "002-8073",
          "002-8074",
          "002-8075",
          "001-0045",
          "060-0806",
          "060-0807",
          "060-0808",
          "060-0809",
          "001-0010",
          "060-0810",
          "001-0011",
          "060-0811",
          "001-0012",
          "060-0812",
          "001-0013",
          "060-0813",
          "001-0014",
          "060-0814",
          "001-0015",
          "060-0815",
          "001-0016",
          "060-0816",
          "001-0017",
          "060-0817",
          "001-0018",
          "060-0818",
          "001-0019",
          "060-0819",
          "001-0020",
          "060-0820",
          "001-0021",
          "001-0022",
          "001-0023",
          "001-0024",
          "001-0025",
          "001-0026",
          "001-0027",
          "001-0028",
          "001-0029",
          "001-0030",
          "001-0031",
          "001-0032",
          "001-0033",
          "001-0034",
          "001-0035",
          "001-0036",
          "001-0037",
          "001-0038",
          "001-0039",
          "001-0040",
          "002-8021",
          "002-8022",
          "002-8023",
          "002-8024",
          "002-8025",
          "002-8026",
          "002-8027",
          "002-8028",
          "002-8029",
          "002-8030",
          "002-8052",
          "002-8053",
          "002-8051",
          "002-8054",
          "002-8055",
          "001-0930",
          "001-0921",
          "001-0922",
          "001-0923",
          "001-0924",
          "001-0925",
          "001-0926",
          "001-0927",
          "001-0928",
          "001-0931",
          "001-0932",
          "001-0933",
          "001-0934",
          "001-0935",
          "001-0901",
          "001-0902",
          "001-0903",
          "001-0904",
          "001-0905",
          "001-0906",
          "001-0907",
          "001-0908",
          "001-0909",
          "001-0910",
          "001-0911",
          "001-0912",
          "001-0915",
          "002-8001",
          "002-8002",
          "002-8003",
          "002-8004",
          "002-8005",
          "002-8006",
          "002-8007",
          "002-8008",
          "002-8009",
          "002-8010",
          "002-8011",
          "002-8012",
          "002-8061",
          "002-8062",
          "002-8063",
          "002-8064",
          "002-8065",
          "002-8066",
          "002-8067",
          "002-8068",
          "002-0851",
          "002-0852",
          "002-0853",
          "002-0854",
          "002-0855",
          "002-0856",
          "002-0857",
          "002-0858",
          "002-0859",
          "002-0860",
          "002-0861",
          "002-0865",
          "002-8038",
          "002-8031",
          "002-8032",
          "002-8033",
          "002-8034",
          "002-8035",
          "002-8036",
          "002-8037",
          "002-8043",
          "002-8041",
          "002-8042",
          "002-8044",
          "002-8045",
          "002-8091",
          "002-8081",
          "002-8082",
          "065-0000",
          "007-0880",
          "007-0881",
          "007-0882",
          "007-0883",
          "007-0884",
          "007-0885",
          "007-0886",
          "065-0004",
          "060-0905",
          "065-0005",
          "060-0906",
          "065-0006",
          "060-0907",
          "065-0007",
          "060-0908",
          "065-0008",
          "060-0909",
          "065-0009",
          "065-0010",
          "065-0011",
          "065-0012",
          "065-0013",
          "065-0014",
          "065-0015",
          "065-0016",
          "065-0017",
          "065-0018",
          "065-0019",
          "065-0020",
          "065-0021",
          "065-0022",
          "065-0023",
          "065-0024",
          "065-0025",
          "065-0026",
          "065-0027",
          "065-0028",
          "065-0030",
          "065-0031",
          "065-0032",
          "065-0033",
          "007-0834",
          "007-0835",
          "007-0836",
          "007-0837",
          "007-0838",
          "007-0839",
          "007-0840",
          "007-0841",
          "007-0842",
          "007-0843",
          "007-0844",
          "007-0845",
          "007-0846",
          "007-0847",
          "007-0848",
          "007-0849",
          "007-0850",
          "007-0851",
          "007-0852",
          "065-0043",
          "007-0001",
          "007-0002",
          "007-0003",
          "007-0004",
          "007-0005",
          "007-0006",
          "007-0890",
          "007-0891",
          "007-0892",
          "007-0893",
          "007-0894",
          "007-0895",
          "007-0821",
          "007-0822",
          "007-0823",
          "007-0824",
          "007-0825",
          "007-0826",
          "007-0827",
          "007-0828",
          "007-0829",
          "007-0030",
          "007-0031",
          "007-0032",
          "007-0033",
          "007-0034",
          "007-0820",
          "007-0801",
          "007-0802",
          "007-0803",
          "007-0804",
          "007-0805",
          "007-0806",
          "007-0807",
          "007-0808",
          "007-0809",
          "007-0810",
          "007-0811",
          "007-0812",
          "007-0813",
          "007-0814",
          "007-0815",
          "007-0819",
          "007-0861",
          "007-0862",
          "007-0863",
          "007-0864",
          "007-0865",
          "007-0866",
          "007-0867",
          "007-0868",
          "007-0869",
          "007-0870",
          "007-0871",
          "007-0872",
          "007-0873",
          "007-0874",
          "065-0041",
          "065-0042",
          "007-0011",
          "003-0000",
          "003-0851",
          "003-0852",
          "003-0853",
          "003-0854",
          "003-0855",
          "003-0869",
          "003-0861",
          "003-0862",
          "003-0863",
          "003-0864",
          "003-0865",
          "003-0859",
          "003-0801",
          "003-0802",
          "003-0803",
          "003-0804",
          "003-0805",
          "003-0806",
          "003-0807",
          "003-0808",
          "003-0809",
          "003-0811",
          "003-0812",
          "003-0813",
          "003-0814",
          "003-0821",
          "003-0822",
          "003-0823",
          "003-0824",
          "003-0825",
          "003-0826",
          "003-0827",
          "003-0828",
          "003-0829",
          "003-0830",
          "003-0849",
          "003-0831",
          "003-0832",
          "003-0833",
          "003-0834",
          "003-0835",
          "003-0836",
          "003-0837",
          "003-0838",
          "003-0839",
          "003-0840",
          "003-0021",
          "003-0011",
          "003-0012",
          "003-0013",
          "003-0022",
          "003-0023",
          "003-0001",
          "003-0002",
          "003-0003",
          "003-0004",
          "003-0005",
          "003-0006",
          "003-0876",
          "003-0028",
          "003-0029",
          "003-0024",
          "003-0025",
          "003-0026",
          "003-0027",
          "003-0871",
          "003-0872",
          "003-0873",
          "003-0874",
          "003-0875",
          "003-0030",
          "062-0000",
          "062-0911",
          "062-0912",
          "062-0020",
          "062-0021",
          "062-0022",
          "062-0023",
          "062-0024",
          "062-0025",
          "062-0051",
          "062-0052",
          "062-0053",
          "062-0054",
          "062-0055",
          "062-0901",
          "062-0902",
          "062-0903",
          "062-0904",
          "062-0905",
          "062-0906",
          "062-0907",
          "062-0908",
          "062-0909",
          "062-0921",
          "062-0922",
          "062-0039",
          "062-0031",
          "062-0032",
          "062-0033",
          "062-0034",
          "062-0035",
          "062-0045",
          "062-0931",
          "062-0932",
          "062-0933",
          "062-0934",
          "062-0935",
          "062-0936",
          "062-0937",
          "062-0938",
          "062-0041",
          "062-0042",
          "062-0043",
          "062-0001",
          "062-0002",
          "062-0003",
          "062-0004",
          "062-0005",
          "062-0006",
          "062-0007",
          "062-0008",
          "062-0009",
          "062-0010",
          "062-0011",
          "062-0012",
          "005-0000",
          "005-0849",
          "005-0850",
          "005-0841",
          "005-0842",
          "005-0843",
          "005-0844",
          "005-0801",
          "005-0802",
          "005-0803",
          "005-0804",
          "005-0805",
          "005-0806",
          "005-0807",
          "005-0808",
          "005-0809",
          "005-0810",
          "005-0811",
          "005-0812",
          "005-0813",
          "005-0814",
          "005-0815",
          "005-0816",
          "005-0817",
          "005-0818",
          "005-0832",
          "005-0864",
          "061-2274",
          "061-2301",
          "061-2302",
          "061-2303",
          "061-2276",
          "005-0007",
          "005-0001",
          "005-0002",
          "005-0003",
          "005-0004",
          "005-0005",
          "005-0006",
          "005-0862",
          "005-0830",
          "005-0865",
          "005-0863",
          "005-0851",
          "005-0852",
          "005-0853",
          "005-0854",
          "005-0855",
          "005-0856",
          "061-2275",
          "061-2273",
          "005-0831",
          "005-0840",
          "061-2271",
          "061-2281",
          "061-2282",
          "061-2283",
          "061-2284",
          "061-2285",
          "061-2286",
          "005-0008",
          "005-0861",
          "005-0018",
          "005-0015",
          "005-0022",
          "005-0012",
          "005-0014",
          "005-0011",
          "005-0021",
          "005-0013",
          "005-0016",
          "005-0017",
          "061-2261",
          "061-2262",
          "061-2263",
          "061-2264",
          "061-2265",
          "061-2266",
          "061-2272",
          "005-0827",
          "005-0821",
          "005-0822",
          "005-0823",
          "005-0824",
          "005-0825",
          "005-0826",
          "005-0030",
          "005-0031",
          "005-0032",
          "005-0033",
          "005-0034",
          "005-0035",
          "005-0036",
          "005-0037",
          "005-0038",
          "005-0039",
          "005-0040",
          "005-0041",
          "063-0000",
          "063-0811",
          "063-0812",
          "063-0813",
          "063-0814",
          "063-0011",
          "063-0049",
          "063-0031",
          "063-0032",
          "063-0033",
          "063-0034",
          "063-0035",
          "063-0036",
          "063-0037",
          "063-0038",
          "063-0039",
          "063-0040",
          "063-0041",
          "063-0042",
          "063-0043",
          "063-0044",
          "063-0062",
          "063-0061",
          "063-0801",
          "063-0802",
          "063-0803",
          "063-0804",
          "063-0861",
          "063-0841",
          "063-0862",
          "063-0842",
          "063-0863",
          "063-0843",
          "063-0864",
          "063-0844",
          "063-0865",
          "063-0845",
          "063-0866",
          "063-0846",
          "063-0867",
          "063-0847",
          "063-0868",
          "063-0848",
          "063-0869",
          "063-0849",
          "063-0870",
          "063-0850",
          "063-0821",
          "063-0822",
          "063-0823",
          "063-0824",
          "063-0825",
          "063-0826",
          "063-0827",
          "063-0828",
          "063-0829",
          "063-0830",
          "063-0831",
          "063-0832",
          "063-0833",
          "063-0834",
          "063-0835",
          "063-0836",
          "063-0837",
          "063-0012",
          "063-0029",
          "063-0021",
          "063-0022",
          "063-0023",
          "063-0059",
          "063-0051",
          "063-0052",
          "063-0053",
          "063-0054",
          "063-0009",
          "063-0001",
          "063-0002",
          "063-0003",
          "063-0004",
          "063-0005",
          "063-0006",
          "063-0007",
          "004-0000",
          "004-0021",
          "004-0071",
          "004-0072",
          "004-0073",
          "004-0074",
          "004-0075",
          "004-0076",
          "004-0051",
          "004-0052",
          "004-0053",
          "004-0054",
          "004-0055",
          "004-0039",
          "004-0007",
          "004-0006",
          "004-0069",
          "004-0068",
          "004-0061",
          "004-0062",
          "004-0063",
          "004-0064",
          "004-0065",
          "004-0001",
          "004-0002",
          "004-0003",
          "004-0004",
          "004-0005",
          "004-0022",
          "004-0041",
          "004-0042",
          "004-0031",
          "004-0032",
          "004-0033",
          "004-0015",
          "004-0011",
          "004-0013",
          "004-0012",
          "004-0014",
          "006-0000",
          "006-0831",
          "006-0832",
          "006-0833",
          "006-0834",
          "006-0835",
          "006-0836",
          "006-0837",
          "006-0838",
          "006-0839",
          "006-0840",
          "006-0841",
          "006-0842",
          "006-0861",
          "006-0031",
          "006-0032",
          "006-0033",
          "006-0034",
          "006-0035",
          "006-0041",
          "006-0042",
          "006-0043",
          "006-0801",
          "006-0802",
          "006-0803",
          "006-0804",
          "006-0805",
          "006-0806",
          "006-0807",
          "006-0039",
          "006-0049",
          "006-0019",
          "006-0859",
          "006-0829",
          "006-0860",
          "006-0029",
          "006-0021",
          "006-0022",
          "006-0023",
          "006-0024",
          "006-0025",
          "006-0026",
          "006-0011",
          "006-0012",
          "006-0013",
          "006-0014",
          "006-0015",
          "006-0016",
          "006-0009",
          "006-0001",
          "006-0002",
          "006-0003",
          "006-0004",
          "006-0005",
          "006-0006",
          "006-0851",
          "006-0852",
          "006-0853",
          "006-0050",
          "006-0811",
          "006-0812",
          "006-0813",
          "006-0814",
          "006-0815",
          "006-0816",
          "006-0817",
          "006-0818",
          "006-0819",
          "006-0820",
          "006-0821",
          "006-0822",
          "006-0823",
          "004-0821",
          "004-0811",
          "004-0812",
          "004-0813",
          "004-0814",
          "004-0815",
          "004-0861",
          "004-0862",
          "004-0863",
          "004-0864",
          "004-0865",
          "004-0866",
          "004-0867",
          "004-0859",
          "004-0841",
          "004-0842",
          "004-0843",
          "004-0844",
          "004-0845",
          "004-0846",
          "004-0847",
          "004-0848",
          "004-0849",
          "004-0840",
          "004-0809",
          "004-0801",
          "004-0802",
          "004-0803",
          "004-0804",
          "004-0805",
          "004-0839",
          "004-0831",
          "004-0832",
          "004-0833",
          "004-0834",
          "004-0835",
          "004-0836",
          "004-0889",
          "004-0871",
          "004-0872",
          "004-0873",
          "004-0874",
          "004-0875",
          "004-0876",
          "004-0877",
          "004-0878",
          "004-0879",
          "004-0880",
          "004-0881",
          "004-0882",
          "040-0000",
          "040-0044",
          "041-0805",
          "041-0804",
          "042-0913",
          "040-0076",
          "042-0916",
          "040-0037",
          "042-0904",
          "041-0802",
          "042-0911",
          "041-0261",
          "040-0057",
          "041-1624",
          "042-0954",
          "040-0023",
          "041-1613",
          "041-0613",
          "041-0522",
          "041-0605",
          "042-0931",
          "040-0071",
          "040-0084",
          "040-0064",
          "040-0062",
          "041-1622",
          "040-0052",
          "041-0403",
          "040-0034",
          "041-1603",
          "041-0251",
          "041-0253",
          "040-0061",
          "042-0942",
          "041-0523",
          "041-0852",
          "041-1611",
          "042-0944",
          "042-0901",
          "041-0252",
          "040-0031",
          "041-0832",
          "041-0831",
          "042-0914",
          "042-0917",
          "041-0803",
          "041-0813",
          "041-0822",
          "040-0072",
          "041-0405",
          "041-0844",
          "041-0808",
          "041-0801",
          "040-0078",
          "041-0807",
          "041-0408",
          "041-1602",
          "041-0524",
          "042-0935",
          "040-0001",
          "040-0041",
          "041-0301",
          "040-0036",
          "042-0923",
          "041-0602",
          "041-0812",
          "041-0823",
          "040-0082",
          "041-0265",
          "041-0606",
          "040-0032",
          "041-0837",
          "041-0833",
          "041-0601",
          "041-0611",
          "041-0312",
          "042-0921",
          "040-0053",
          "040-0004",
          "042-0958",
          "040-0045",
          "041-0302",
          "042-0951",
          "042-0922",
          "042-0955",
          "041-0526",
          "042-0952",
          "040-0024",
          "042-0957",
          "041-0305",
          "040-0081",
          "040-0033",
          "041-0612",
          "040-0013",
          "041-0264",
          "042-0902",
          "042-0908",
          "040-0012",
          "042-0953",
          "041-0304",
          "041-0603",
          "041-0811",
          "041-0402",
          "040-0065",
          "041-1621",
          "041-0263",
          "040-0014",
          "042-0912",
          "041-0404",
          "041-0853",
          "042-0915",
          "041-0824",
          "042-0924",
          "042-0943",
          "040-0083",
          "041-0843",
          "041-0311",
          "041-0313",
          "040-0075",
          "041-0401",
          "040-0042",
          "042-0903",
          "041-0835",
          "041-0834",
          "040-0005",
          "040-0022",
          "041-0525",
          "041-0841",
          "041-0407",
          "042-0934",
          "042-0941",
          "041-1623",
          "040-0055",
          "041-0262",
          "041-1601",
          "041-0303",
          "040-0051",
          "040-0043",
          "040-0025",
          "040-0011",
          "041-0851",
          "042-0918",
          "042-0907",
          "040-0003",
          "040-0035",
          "040-0074",
          "040-0021",
          "041-0306",
          "041-0521",
          "042-0906",
          "041-0821",
          "041-0806",
          "042-0956",
          "040-0073",
          "041-0406",
          "040-0054",
          "041-0604",
          "042-0905",
          "041-1612",
          "040-0046",
          "040-0015",
          "040-0002",
          "041-0836",
          "040-0056",
          "042-0932",
          "042-0933",
          "040-0077",
          "040-0063",
          "047-0000",
          "047-0028",
          "047-0046",
          "047-0035",
          "047-0151",
          "047-0154",
          "047-0006",
          "047-0038",
          "047-0032",
          "047-0021",
          "047-0031",
          "047-0044",
          "047-0013",
          "048-2561",
          "048-2671",
          "047-0005",
          "047-0264",
          "047-0037",
          "047-0027",
          "047-0156",
          "047-0002",
          "048-2672",
          "047-0026",
          "047-0045",
          "047-0047",
          "047-0152",
          "047-0153",
          "047-0004",
          "047-0042",
          "047-0014",
          "047-0015",
          "047-0261",
          "061-3271",
          "047-0048",
          "047-0008",
          "047-0041",
          "047-0012",
          "047-0011",
          "047-0033",
          "047-0043",
          "047-0036",
          "047-0039",
          "047-0016",
          "047-0024",
          "047-0266",
          "047-0265",
          "047-0157",
          "047-0155",
          "047-0262",
          "047-0003",
          "047-0022",
          "047-0034",
          "047-0007",
          "047-0263",
          "047-0023",
          "048-2673",
          "047-0025",
          "048-2562",
          "047-0001",
          "047-0017",
          "070-0000",
          "079-8401",
          "079-8402",
          "079-8403",
          "070-0072",
          "070-0073",
          "070-0061",
          "070-0062",
          "070-0063",
          "070-0822",
          "070-0831",
          "070-0832",
          "070-8051",
          "070-8052",
          "070-8053",
          "071-1171",
          "071-1172",
          "071-1173",
          "071-1174",
          "071-1175",
          "071-1176",
          "071-1177",
          "070-0841",
          "070-0842",
          "070-0843",
          "078-8311",
          "078-8312",
          "078-8313",
          "078-8314",
          "078-8315",
          "078-8316",
          "078-8317",
          "078-8318",
          "078-8319",
          "078-8320",
          "078-8321",
          "078-8322",
          "078-8323",
          "078-8324",
          "078-8325",
          "078-8326",
          "078-8327",
          "070-8001",
          "070-8002",
          "070-8003",
          "070-8004",
          "070-8005",
          "070-8006",
          "070-8007",
          "070-0041",
          "070-8011",
          "070-8012",
          "070-8013",
          "070-8014",
          "070-8015",
          "070-8016",
          "070-8017",
          "070-8018",
          "070-8019",
          "070-8033",
          "070-8034",
          "070-8026",
          "078-0185",
          "070-8032",
          "070-8031",
          "070-8022",
          "070-8021",
          "070-8025",
          "070-8024",
          "074-1182",
          "070-8023",
          "078-0186",
          "074-1181",
          "070-0081",
          "070-0082",
          "070-0083",
          "070-0811",
          "070-0812",
          "070-0813",
          "070-0814",
          "070-0815",
          "070-0816",
          "070-0817",
          "078-8371",
          "078-8372",
          "078-8373",
          "078-8308",
          "070-0029",
          "078-8271",
          "078-8272",
          "078-8273",
          "078-8274",
          "078-8275",
          "070-0871",
          "070-0872",
          "070-0873",
          "070-0874",
          "070-0875",
          "070-0876",
          "070-0877",
          "071-8141",
          "071-8142",
          "071-8143",
          "071-8144",
          "071-8145",
          "070-0902",
          "070-0014",
          "070-0001",
          "070-0002",
          "070-0003",
          "071-8131",
          "071-8132",
          "071-8133",
          "071-8134",
          "071-8135",
          "071-8136",
          "071-8137",
          "071-8138",
          "071-8121",
          "071-8122",
          "071-8123",
          "070-0864",
          "070-0865",
          "070-0866",
          "070-0867",
          "070-0010",
          "070-8071",
          "070-8072",
          "070-8073",
          "070-8074",
          "070-8027",
          "070-8061",
          "070-0821",
          "070-8041",
          "070-8042",
          "070-8043",
          "070-8044",
          "070-8045",
          "070-8046",
          "070-8047",
          "070-8048",
          "070-8049",
          "078-8341",
          "078-8342",
          "078-8343",
          "078-8344",
          "078-8345",
          "078-8346",
          "078-8347",
          "078-8348",
          "078-8349",
          "078-8350",
          "078-8351",
          "078-8352",
          "078-8353",
          "078-8354",
          "078-8355",
          "078-8356",
          "078-8357",
          "078-8358",
          "078-8359",
          "078-8360",
          "078-8361",
          "078-8362",
          "078-8363",
          "078-8364",
          "078-8365",
          "078-8366",
          "078-8367",
          "070-0044",
          "070-0043",
          "078-8231",
          "078-8232",
          "078-8233",
          "078-8234",
          "078-8235",
          "078-8236",
          "078-8237",
          "078-8238",
          "078-8239",
          "078-8240",
          "078-8241",
          "078-8242",
          "078-8243",
          "078-8244",
          "078-8245",
          "078-8246",
          "070-0042",
          "079-8411",
          "079-8412",
          "079-8413",
          "079-8414",
          "079-8415",
          "079-8416",
          "079-8417",
          "079-8418",
          "079-8419",
          "079-8420",
          "079-8421",
          "079-8422",
          "079-8423",
          "079-8424",
          "079-8451",
          "079-8452",
          "079-8453",
          "079-8454",
          "079-8431",
          "071-0173",
          "071-0174",
          "071-0171",
          "071-0172",
          "071-0186",
          "078-8381",
          "078-8382",
          "078-8383",
          "071-0184",
          "071-0185",
          "070-0824",
          "078-8821",
          "078-8822",
          "078-8823",
          "078-8824",
          "078-8825",
          "070-0901",
          "070-0013",
          "070-0011",
          "070-0012",
          "078-8251",
          "078-8252",
          "078-8253",
          "078-8207",
          "078-8208",
          "078-8340",
          "078-8368",
          "078-8205",
          "078-8204",
          "078-8206",
          "078-8202",
          "078-1272",
          "078-8201",
          "078-1271",
          "078-8203",
          "078-1274",
          "078-1273",
          "078-8261",
          "078-8262",
          "071-8101",
          "071-8102",
          "071-8103",
          "071-8104",
          "071-8151",
          "071-8152",
          "071-8153",
          "071-8154",
          "071-8155",
          "071-8156",
          "071-8157",
          "071-8158",
          "071-8159",
          "071-8160",
          "071-8161",
          "071-8162",
          "071-8163",
          "071-8164",
          "071-8165",
          "071-8111",
          "071-8112",
          "071-8113",
          "071-8114",
          "071-8171",
          "070-0021",
          "070-0022",
          "070-0023",
          "070-0024",
          "070-0025",
          "070-0026",
          "070-0027",
          "070-0028",
          "070-0825",
          "078-8301",
          "078-8302",
          "078-8303",
          "078-8304",
          "078-8305",
          "078-8801",
          "078-8802",
          "078-8803",
          "078-8804",
          "078-8805",
          "078-8811",
          "078-8812",
          "078-8813",
          "078-8814",
          "078-8815",
          "071-8166",
          "070-0823",
          "078-8331",
          "078-8332",
          "078-8333",
          "078-8334",
          "078-8335",
          "078-8336",
          "078-8337",
          "078-8338",
          "078-8339",
          "070-8028",
          "070-0030",
          "078-8330",
          "078-8391",
          "078-8392",
          "070-0810",
          "070-0971",
          "070-0972",
          "070-0973",
          "079-8441",
          "079-8442",
          "079-8443",
          "079-8444",
          "070-0031",
          "078-8211",
          "070-0032",
          "078-8212",
          "070-0052",
          "070-0033",
          "078-8213",
          "070-0053",
          "070-0034",
          "078-8214",
          "070-0054",
          "070-0035",
          "078-8215",
          "070-0055",
          "070-0036",
          "078-8216",
          "070-0056",
          "070-0037",
          "078-8217",
          "070-0057",
          "070-0038",
          "078-8218",
          "070-0058",
          "070-0039",
          "078-8219",
          "070-0059",
          "070-0040",
          "078-8220",
          "078-8221",
          "050-0000",
          "050-0051",
          "051-0023",
          "051-0035",
          "050-0086",
          "051-0033",
          "051-0022",
          "050-0052",
          "050-0064",
          "050-0053",
          "051-0032",
          "050-0063",
          "051-0002",
          "050-0082",
          "051-0016",
          "051-0014",
          "050-0055",
          "051-0027",
          "051-0026",
          "051-0036",
          "051-0005",
          "050-0067",
          "050-0072",
          "050-0062",
          "051-0006",
          "051-0011",
          "050-0076",
          "051-0031",
          "050-0077",
          "051-0025",
          "050-0074",
          "050-0075",
          "050-0087",
          "051-0028",
          "050-0054",
          "050-0061",
          "050-0083",
          "050-0081",
          "051-0013",
          "051-0003",
          "051-0004",
          "050-0066",
          "051-0015",
          "051-0024",
          "051-0034",
          "051-0001",
          "050-0071",
          "051-0021",
          "050-0073",
          "050-0084",
          "050-0065",
          "051-0012",
          "050-0085",
          "085-0000",
          "085-0062",
          "085-0058",
          "085-0057",
          "085-0252",
          "085-0054",
          "085-0467",
          "085-0238",
          "085-0212",
          "085-0468",
          "085-0245",
          "085-0221",
          "085-0235",
          "085-0202",
          "085-0216",
          "085-0217",
          "085-0244",
          "085-0206",
          "085-0220",
          "085-0211",
          "085-0231",
          "085-0204",
          "085-0223",
          "085-0218",
          "085-0234",
          "085-0232",
          "085-0225",
          "085-0215",
          "085-0237",
          "085-0205",
          "085-0241",
          "085-0236",
          "085-0203",
          "085-0213",
          "085-0243",
          "085-0233",
          "085-0201",
          "085-0242",
          "085-0214",
          "085-0222",
          "085-0224",
          "085-0011",
          "085-0061",
          "085-0008",
          "085-0846",
          "085-0835",
          "085-0837",
          "085-0847",
          "085-0811",
          "084-0917",
          "084-0918",
          "084-0916",
          "084-0915",
          "088-0122",
          "088-0117",
          "088-0104",
          "088-0108",
          "088-0126",
          "088-0109",
          "088-0114",
          "088-0123",
          "088-0134",
          "088-0125",
          "088-0133",
          "088-0132",
          "088-0107",
          "088-0135",
          "088-0102",
          "088-0112",
          "088-0103",
          "088-0118",
          "088-0116",
          "088-0106",
          "088-0131",
          "088-0101",
          "088-0111",
          "088-0113",
          "088-0124",
          "088-0105",
          "088-0115",
          "088-0121",
          "085-0023",
          "085-0816",
          "085-0824",
          "085-0041",
          "085-0802",
          "085-0012",
          "085-0003",
          "085-0044",
          "085-0015",
          "084-0908",
          "085-0043",
          "085-0035",
          "085-0018",
          "085-0051",
          "085-0026",
          "085-0048",
          "084-0927",
          "085-0815",
          "085-0017",
          "085-0013",
          "085-0805",
          "085-0251",
          "085-0812",
          "085-0055",
          "085-0822",
          "084-0902",
          "084-0901",
          "084-0910",
          "084-0903",
          "084-0909",
          "085-0804",
          "085-0844",
          "085-0034",
          "085-0826",
          "085-0032",
          "085-0047",
          "085-0002",
          "085-0004",
          "085-0046",
          "084-0904",
          "085-0014",
          "085-0045",
          "085-0831",
          "085-0807",
          "085-0025",
          "085-0825",
          "085-0823",
          "084-0926",
          "085-0821",
          "084-0924",
          "084-0923",
          "084-0906",
          "084-0907",
          "084-0905",
          "085-0053",
          "085-0031",
          "085-0052",
          "084-0929",
          "085-0027",
          "085-0021",
          "084-0925",
          "085-0016",
          "084-0914",
          "085-0836",
          "085-0038",
          "085-0024",
          "085-0813",
          "085-0056",
          "085-0064",
          "085-0832",
          "085-0006",
          "085-0063",
          "085-0001",
          "085-0843",
          "084-0922",
          "084-0912",
          "084-0911",
          "084-0913",
          "085-0007",
          "085-0803",
          "085-0005",
          "085-0801",
          "085-0814",
          "085-0845",
          "085-0841",
          "085-0022",
          "084-0921",
          "085-0065",
          "085-0833",
          "085-0806",
          "085-0037",
          "084-0928",
          "085-0834",
          "085-0842",
          "085-0042",
          "085-0036",
          "085-0033",
          "080-0000",
          "089-1181",
          "089-1245",
          "089-1244",
          "080-0835",
          "080-0833",
          "080-0834",
          "080-0832",
          "080-0831",
          "080-2121",
          "080-2122",
          "080-2123",
          "080-2124",
          "080-0816",
          "080-0838",
          "080-0030",
          "080-0010",
          "080-2334",
          "080-2111",
          "080-2112",
          "080-2113",
          "080-2114",
          "089-1182",
          "080-2101",
          "080-2102",
          "080-2115",
          "080-2103",
          "080-2104",
          "080-2116",
          "080-0836",
          "080-0837",
          "080-0847",
          "089-1246",
          "089-1243",
          "080-0848",
          "080-2476",
          "089-1247",
          "080-0051",
          "080-0050",
          "080-0053",
          "080-0052",
          "080-0872",
          "080-0871",
          "089-1242",
          "089-1241",
          "080-2105",
          "080-2117",
          "080-2337",
          "089-1183",
          "089-1252",
          "080-0031",
          "080-0011",
          "080-0032",
          "080-0012",
          "080-0033",
          "080-0013",
          "080-0034",
          "080-0014",
          "080-0035",
          "080-0015",
          "080-0036",
          "080-0016",
          "080-0037",
          "080-0017",
          "080-0038",
          "080-0018",
          "080-0039",
          "080-0019",
          "080-0040",
          "080-0020",
          "080-0041",
          "080-0021",
          "080-0042",
          "080-0022",
          "080-0043",
          "080-0023",
          "080-0044",
          "080-0024",
          "080-0045",
          "080-0025",
          "080-0046",
          "080-0026",
          "080-0047",
          "080-0027",
          "080-0048",
          "080-0028",
          "080-2459",
          "080-2469",
          "080-0029",
          "080-2460",
          "080-2470",
          "080-2461",
          "080-2471",
          "080-2462",
          "080-2472",
          "080-2463",
          "080-2473",
          "080-2464",
          "080-2474",
          "080-2465",
          "080-2475",
          "080-0054",
          "080-0057",
          "080-0058",
          "080-0055",
          "080-0056",
          "080-2333",
          "080-2106",
          "080-0821",
          "080-0801",
          "080-0822",
          "080-0802",
          "080-0823",
          "080-0803",
          "080-0824",
          "080-0804",
          "080-0805",
          "080-0806",
          "080-0807",
          "080-0808",
          "080-0809",
          "080-0810",
          "080-0811",
          "080-0812",
          "080-0813",
          "080-0814",
          "080-0815",
          "080-2335",
          "080-2332",
          "089-1251",
          "089-1184",
          "080-0846",
          "080-0841",
          "080-0842",
          "080-0843",
          "080-0845",
          "080-0844",
          "080-0862",
          "080-0861",
          "080-0857",
          "080-0856",
          "080-2331",
          "080-2336",
          "080-0817",
          "090-0000",
          "099-0871",
          "090-0018",
          "090-0011",
          "090-0803",
          "090-0811",
          "090-0020",
          "090-0040",
          "090-0016",
          "090-0056",
          "099-1582",
          "090-0066",
          "099-0877",
          "090-0053",
          "099-1585",
          "090-0006",
          "090-0821",
          "090-0807",
          "099-1583",
          "090-0021",
          "090-0041",
          "090-0022",
          "090-0042",
          "090-0023",
          "090-0043",
          "090-0024",
          "090-0044",
          "090-0025",
          "090-0045",
          "090-0026",
          "090-0046",
          "090-0027",
          "090-0047",
          "090-0028",
          "090-0048",
          "090-0029",
          "090-0030",
          "090-0031",
          "090-0063",
          "090-0001",
          "090-0051",
          "090-0058",
          "090-0015",
          "090-0835",
          "090-0823",
          "090-0814",
          "090-0065",
          "090-0036",
          "090-0832",
          "090-0804",
          "090-0019",
          "090-0801",
          "090-0002",
          "090-0815",
          "090-0826",
          "099-0874",
          "090-0805",
          "090-0008",
          "090-0017",
          "090-0802",
          "099-2101",
          "099-2102",
          "099-2103",
          "099-2107",
          "099-2106",
          "099-2104",
          "099-2105",
          "099-2112",
          "099-2231",
          "099-2111",
          "090-0034",
          "090-0837",
          "099-1584",
          "090-0061",
          "090-0817",
          "093-0215",
          "093-0214",
          "093-0216",
          "093-0210",
          "093-0213",
          "093-0332",
          "093-0331",
          "093-0336",
          "093-0202",
          "093-0334",
          "093-0333",
          "093-0335",
          "099-0876",
          "099-0872",
          "090-0833",
          "090-0834",
          "090-0813",
          "090-0012",
          "090-0003",
          "099-0873",
          "090-0827",
          "090-0831",
          "090-0838",
          "090-0013",
          "090-0816",
          "090-0033",
          "099-0878",
          "090-0836",
          "090-0810",
          "099-1586",
          "090-0054",
          "090-0014",
          "099-1587",
          "090-0822",
          "090-0052",
          "090-0035",
          "090-0004",
          "090-0824",
          "099-0875",
          "090-0007",
          "090-0032",
          "099-0879",
          "090-0067",
          "090-0055",
          "099-1581",
          "090-0812",
          "090-0806",
          "090-0070",
          "090-0069",
          "090-0068",
          "090-0064",
          "090-0825",
          "090-0818",
          "090-0037",
          "090-0005",
          "091-0029",
          "091-0028",
          "091-0025",
          "091-0026",
          "091-0023",
          "091-0027",
          "091-0022",
          "091-0024",
          "091-0002",
          "091-0011",
          "091-0031",
          "091-0170",
          "091-0021",
          "091-0004",
          "091-0156",
          "091-0161",
          "091-0033",
          "091-0151",
          "091-0163",
          "091-0007",
          "091-0032",
          "091-0003",
          "091-0157",
          "091-0018",
          "091-0154",
          "091-0162",
          "091-0153",
          "091-0016",
          "091-0017",
          "091-0008",
          "091-0001",
          "091-0155",
          "090-0057",
          "090-0808",
          "068-0400",
          "068-0405",
          "068-0754",
          "068-0662",
          "068-0673",
          "068-0661",
          "068-0665",
          "068-0663",
          "068-0664",
          "068-0672",
          "068-0675",
          "068-0671",
          "068-0674",
          "068-0413",
          "068-0412",
          "068-0414",
          "068-0531",
          "068-0532",
          "068-0533",
          "068-0535",
          "068-0534",
          "068-0402",
          "068-0404",
          "068-0411",
          "068-0406",
          "068-0401",
          "068-0756",
          "068-0424",
          "068-0409",
          "068-0421",
          "068-0408",
          "068-0426",
          "068-0546",
          "068-0545",
          "068-0541",
          "068-0544",
          "068-0548",
          "068-0547",
          "068-0540",
          "068-0549",
          "068-0542",
          "068-0543",
          "068-0751",
          "068-0753",
          "068-0422",
          "068-0407",
          "068-0423",
          "068-0403",
          "068-0752",
          "068-0536",
          "068-0755",
          "068-0425",
          "068-0000",
          "068-3185",
          "068-0035",
          "068-0034",
          "079-0183",
          "079-0181",
          "069-0384",
          "068-0829",
          "068-0827",
          "068-0847",
          "068-0836",
          "069-0361",
          "069-0362",
          "069-0363",
          "069-0364",
          "069-0365",
          "068-0057",
          "068-0053",
          "068-0041",
          "068-0042",
          "068-0043",
          "068-0044",
          "068-0045",
          "068-0061",
          "068-1213",
          "068-1203",
          "068-1204",
          "069-0351",
          "068-1212",
          "068-1205",
          "068-1202",
          "068-1214",
          "068-1201",
          "068-1161",
          "068-1211",
          "068-1215",
          "068-0106",
          "068-0112",
          "068-0133",
          "068-0122",
          "068-0121",
          "068-0135",
          "068-0134",
          "068-0102",
          "068-0104",
          "068-0131",
          "068-0124",
          "068-0105",
          "068-0103",
          "068-0126",
          "068-3165",
          "068-0123",
          "068-0136",
          "068-0101",
          "068-0127",
          "068-3154",
          "068-3162",
          "068-3151",
          "068-3155",
          "068-3152",
          "068-3158",
          "068-3153",
          "068-3164",
          "068-3163",
          "068-3156",
          "068-3159",
          "068-3157",
          "068-0132",
          "068-0125",
          "068-3161",
          "068-0113",
          "068-3183",
          "068-3172",
          "068-3179",
          "068-3177",
          "068-3176",
          "068-3178",
          "068-3175",
          "068-3180",
          "068-3171",
          "068-3182",
          "068-3181",
          "068-3174",
          "068-3173",
          "068-0115",
          "068-0114",
          "068-0111",
          "068-0834",
          "068-0821",
          "068-0058",
          "068-0833",
          "068-0841",
          "068-0842",
          "068-0843",
          "068-0844",
          "068-0845",
          "068-3186",
          "068-0846",
          "069-0376",
          "068-0818",
          "068-3187",
          "068-0048",
          "068-0828",
          "068-0015",
          "068-0013",
          "068-0014",
          "068-0820",
          "068-0826",
          "068-0823",
          "068-0824",
          "068-0822",
          "068-0825",
          "068-0831",
          "068-0832",
          "069-0366",
          "068-0837",
          "069-0381",
          "069-0382",
          "069-0371",
          "069-0372",
          "069-0373",
          "069-0374",
          "069-0375",
          "069-0383",
          "068-0811",
          "068-0812",
          "068-0813",
          "068-0814",
          "068-0815",
          "068-0816",
          "068-0817",
          "068-0835",
          "068-0046",
          "068-0810",
          "068-0801",
          "068-0802",
          "068-0803",
          "068-0804",
          "068-0805",
          "068-0806",
          "068-0807",
          "068-0808",
          "068-0809",
          "079-0182",
          "068-0016",
          "068-3188",
          "068-0054",
          "068-0051",
          "068-0055",
          "068-0052",
          "068-0056",
          "068-0851",
          "068-0852",
          "068-0853",
          "068-0854",
          "068-0855",
          "068-0830",
          "068-0047",
          "068-0001",
          "068-0021",
          "068-0002",
          "068-0022",
          "068-0003",
          "068-0023",
          "068-0004",
          "068-0024",
          "068-0005",
          "068-0025",
          "068-0006",
          "068-0026",
          "068-0007",
          "068-0027",
          "068-0008",
          "068-0028",
          "068-0009",
          "068-0029",
          "068-0010",
          "068-0030",
          "068-0011",
          "068-0031",
          "068-0012",
          "068-0032",
          "068-0033",
          "093-0000",
          "099-3115",
          "093-0135",
          "099-3502",
          "093-0045",
          "099-3501",
          "093-0083",
          "093-0133",
          "093-0041",
          "099-3112",
          "093-0051",
          "093-0071",
          "093-0052",
          "093-0072",
          "093-0053",
          "093-0073",
          "093-0054",
          "093-0074",
          "093-0055",
          "093-0075",
          "093-0056",
          "093-0076",
          "093-0057",
          "093-0077",
          "093-0058",
          "093-0078",
          "093-0059",
          "093-0079",
          "093-0060",
          "093-0080",
          "093-0061",
          "093-0081",
          "093-0062",
          "093-0082",
          "099-3504",
          "093-0084",
          "093-0134",
          "093-0035",
          "093-0033",
          "099-3503",
          "093-0088",
          "093-0042",
          "099-3117",
          "093-0046",
          "093-0031",
          "093-0034",
          "093-0044",
          "099-3118",
          "099-2424",
          "093-0043",
          "093-0241",
          "093-0131",
          "099-2423",
          "093-0086",
          "093-0132",
          "093-0090",
          "093-0136",
          "099-3119",
          "099-3114",
          "093-0087",
          "099-3113",
          "093-0089",
          "093-0032",
          "093-0001",
          "093-0011",
          "093-0002",
          "093-0012",
          "093-0003",
          "093-0013",
          "093-0004",
          "093-0014",
          "093-0005",
          "093-0015",
          "093-0006",
          "093-0016",
          "093-0007",
          "093-0017",
          "093-0008",
          "093-0018",
          "093-0009",
          "093-0019",
          "093-0010",
          "093-0020",
          "093-0021",
          "093-0022",
          "093-0023",
          "093-0024",
          "093-0085",
          "099-3111",
          "099-2422",
          "099-3116",
          "099-2421",
          "077-0000",
          "077-0041",
          "077-0043",
          "077-0023",
          "077-0026",
          "077-0048",
          "077-0012",
          "077-0037",
          "077-0042",
          "077-0003",
          "077-0038",
          "077-0031",
          "077-0007",
          "077-0001",
          "077-0002",
          "077-0011",
          "077-0006",
          "077-0027",
          "077-0047",
          "077-0021",
          "078-3167",
          "077-0024",
          "077-0013",
          "078-3166",
          "077-0044",
          "077-0025",
          "077-0028",
          "077-0036",
          "078-3162",
          "078-3165",
          "077-0005",
          "077-0034",
          "077-0022",
          "078-3168",
          "077-0045",
          "077-0015",
          "077-0046",
          "078-3163",
          "077-0014",
          "077-0033",
          "077-0032",
          "077-0016",
          "077-0004",
          "078-3161",
          "078-3164",
          "077-0035",
          "053-0000",
          "053-0807",
          "053-0054",
          "053-0051",
          "059-1366",
          "053-0056",
          "053-0018",
          "053-0812",
          "053-0047",
          "059-1375",
          "053-0001",
          "053-0814",
          "053-0003",
          "059-1365",
          "053-0842",
          "059-1306",
          "059-1307",
          "053-0815",
          "053-0027",
          "053-0024",
          "053-0044",
          "053-0022",
          "053-0823",
          "059-1362",
          "053-0031",
          "053-0822",
          "053-0033",
          "059-1266",
          "053-0854",
          "053-0813",
          "053-0811",
          "053-0016",
          "053-0026",
          "053-0017",
          "053-0832",
          "053-0843",
          "053-0042",
          "053-0012",
          "059-1363",
          "053-0034",
          "053-0821",
          "053-0801",
          "053-0052",
          "053-0805",
          "053-0006",
          "053-0055",
          "053-0011",
          "059-1271",
          "053-0046",
          "059-1263",
          "053-0806",
          "053-0035",
          "053-0013",
          "059-1302",
          "059-1303",
          "059-1265",
          "059-1301",
          "059-1261",
          "053-0831",
          "059-1275",
          "053-0023",
          "053-0833",
          "059-1364",
          "059-1305",
          "059-1272",
          "053-0853",
          "053-0014",
          "053-0845",
          "059-1276",
          "059-1374",
          "053-0002",
          "053-0043",
          "053-0816",
          "053-0045",
          "053-0007",
          "059-1371",
          "059-1304",
          "059-1277",
          "053-0852",
          "053-0015",
          "053-0025",
          "059-1373",
          "053-0841",
          "066-0271",
          "059-1361",
          "053-0041",
          "053-0032",
          "053-0004",
          "059-1262",
          "053-0844",
          "059-1264",
          "053-0855",
          "059-1273",
          "059-1274",
          "053-0005",
          "053-0804",
          "053-0803",
          "053-0053",
          "053-0851",
          "053-0802",
          "059-1372",
          "053-0021",
          "097-0000",
          "097-0015",
          "097-0025",
          "097-0023",
          "098-6642",
          "098-6565",
          "098-6572",
          "098-6561",
          "098-6562",
          "098-6574",
          "098-6564",
          "098-6576",
          "098-6645",
          "098-4582",
          "098-6573",
          "098-6575",
          "098-6563",
          "098-6571",
          "098-6643",
          "097-0003",
          "097-0017",
          "097-0002",
          "097-0014",
          "097-0007",
          "097-0006",
          "097-0001",
          "098-6758",
          "098-6754",
          "098-6755",
          "098-6756",
          "098-6751",
          "098-6385",
          "098-6644",
          "098-6757",
          "098-6384",
          "097-0005",
          "097-0022",
          "097-0012",
          "097-0037",
          "097-0026",
          "097-0016",
          "098-4581",
          "097-0036",
          "097-0035",
          "097-0011",
          "097-0027",
          "097-0024",
          "097-0004",
          "097-0021",
          "097-0013",
          "072-0000",
          "072-0044",
          "072-0023",
          "072-0021",
          "072-0011",
          "072-0001",
          "072-0835",
          "072-0831",
          "072-0834",
          "072-0832",
          "072-0833",
          "072-0047",
          "072-0045",
          "072-0046",
          "072-0051",
          "079-0177",
          "072-0053",
          "072-0054",
          "072-0052",
          "072-0857",
          "072-0855",
          "072-0856",
          "072-0851",
          "072-0852",
          "072-0853",
          "072-0854",
          "072-0009",
          "072-0008",
          "079-0274",
          "072-0819",
          "079-0165",
          "079-0164",
          "079-0162",
          "079-0161",
          "079-0171",
          "079-0166",
          "068-2181",
          "079-0167",
          "072-0042",
          "072-0041",
          "072-0043",
          "079-0261",
          "079-0267",
          "079-0266",
          "072-0808",
          "072-0803",
          "072-0804",
          "072-0805",
          "072-0806",
          "072-0807",
          "079-0176",
          "079-0272",
          "079-0271",
          "079-0273",
          "072-0057",
          "072-0058",
          "072-0055",
          "072-0059",
          "072-0056",
          "072-0024",
          "072-0022",
          "072-0025",
          "072-0031",
          "072-0026",
          "072-0032",
          "072-0027",
          "072-0033",
          "072-0028",
          "072-0034",
          "079-0262",
          "079-0263",
          "079-0265",
          "079-0264",
          "072-0037",
          "072-0035",
          "072-0038",
          "072-0036",
          "072-0844",
          "072-0843",
          "072-0841",
          "072-0842",
          "072-0012",
          "072-0002",
          "072-0013",
          "072-0003",
          "072-0014",
          "072-0004",
          "072-0015",
          "072-0005",
          "072-0016",
          "072-0006",
          "072-0017",
          "072-0007",
          "072-0811",
          "072-0801",
          "072-0812",
          "072-0802",
          "072-0813",
          "072-0822",
          "072-0821",
          "072-0817",
          "072-0826",
          "072-0827",
          "072-0825",
          "072-0823",
          "072-0824",
          "072-0818",
          "072-0816",
          "072-0828",
          "072-0815",
          "072-0814",
          "079-0173",
          "079-0172",
          "079-0174",
          "079-0175",
          "075-0000",
          "075-0165",
          "075-0036",
          "075-0035",
          "076-0081",
          "079-1371",
          "075-0166",
          "075-0011",
          "075-0001",
          "075-0012",
          "075-0002",
          "075-0013",
          "075-0003",
          "075-0014",
          "075-0004",
          "075-0015",
          "075-0005",
          "075-0016",
          "075-0006",
          "075-0007",
          "075-0252",
          "075-0251",
          "075-0019",
          "075-0018",
          "075-0254",
          "075-0253",
          "075-0167",
          "075-0161",
          "079-1372",
          "075-0162",
          "075-0017",
          "075-0034",
          "075-0041",
          "075-0031",
          "075-0021",
          "075-0032",
          "075-0033",
          "075-0164",
          "075-0163",
          "067-0000",
          "067-0011",
          "067-0012",
          "067-0013",
          "067-0014",
          "067-0015",
          "067-0016",
          "067-0017",
          "067-0018",
          "067-0025",
          "069-0826",
          "067-0024",
          "067-0034",
          "067-0072",
          "067-0022",
          "067-0001",
          "069-0845",
          "069-0864",
          "069-0843",
          "069-0861",
          "069-0862",
          "069-0846",
          "069-0842",
          "069-0863",
          "069-0851",
          "069-0853",
          "069-0854",
          "069-0844",
          "069-0866",
          "069-0852",
          "069-0847",
          "069-0865",
          "069-0855",
          "069-0841",
          "067-0052",
          "067-0064",
          "067-0063",
          "067-0061",
          "067-0062",
          "067-0051",
          "069-0812",
          "067-0055",
          "069-0806",
          "067-0074",
          "069-0801",
          "067-0033",
          "067-0023",
          "067-0021",
          "067-0026",
          "067-0028",
          "067-0027",
          "067-0053",
          "069-0811",
          "069-0832",
          "069-0802",
          "069-0815",
          "069-0816",
          "069-0803",
          "069-0825",
          "069-0814",
          "069-0804",
          "069-0817",
          "069-0831",
          "069-0813",
          "067-0071",
          "069-0822",
          "069-0821",
          "069-0824",
          "069-0833",
          "069-0834",
          "069-0836",
          "069-0835",
          "067-0005",
          "069-0823",
          "067-0002",
          "067-0003",
          "067-0056",
          "067-0042",
          "067-0075",
          "067-0058",
          "067-0059",
          "067-0057",
          "067-0032",
          "067-0041",
          "069-0867",
          "069-0805",
          "067-0031",
          "067-0054",
          "067-0073",
          "067-0065",
          "067-0066",
          "067-0004",
          "079-1100",
          "079-1143",
          "079-1134",
          "079-1274",
          "079-1141",
          "079-1121",
          "079-1101",
          "079-1154",
          "079-1152",
          "079-1155",
          "079-1156",
          "079-1124",
          "079-1133",
          "079-1135",
          "079-1131",
          "079-1122",
          "079-1142",
          "079-1132",
          "079-1123",
          "079-1272",
          "079-1273",
          "079-1271",
          "079-1287",
          "079-1281",
          "079-1282",
          "079-1283",
          "079-1286",
          "079-1284",
          "079-1285",
          "079-1153",
          "079-1102",
          "079-1136",
          "079-1144",
          "079-1151",
          "079-1266",
          "079-1264",
          "079-1262",
          "079-1265",
          "079-1261",
          "079-1263",
          "079-1267",
          "079-1268",
          "079-1113",
          "079-1112",
          "079-1114",
          "079-1111",
          "094-0000",
          "099-6131",
          "094-0021",
          "094-0007",
          "094-0031",
          "094-0027",
          "099-5354",
          "099-5364",
          "099-5362",
          "099-5355",
          "099-5351",
          "099-5363",
          "099-5353",
          "099-5352",
          "099-5365",
          "099-5361",
          "094-0025",
          "094-0001",
          "099-6133",
          "094-0026",
          "099-6132",
          "094-0005",
          "094-0006",
          "099-6242",
          "099-5171",
          "099-5174",
          "099-5175",
          "099-5172",
          "099-5173",
          "094-0012",
          "094-0022",
          "099-6241",
          "094-0015",
          "094-0003",
          "094-0004",
          "094-0002",
          "094-0014",
          "094-0011",
          "094-0013",
          "094-0023",
          "094-0024",
          "095-0000",
          "095-0403",
          "095-0405",
          "095-0401",
          "095-0402",
          "095-0406",
          "095-0404",
          "095-0019",
          "095-0029",
          "095-0039",
          "095-0181",
          "095-0182",
          "095-0183",
          "095-0052",
          "095-0371",
          "095-0064",
          "095-0051",
          "095-0061",
          "095-0053",
          "098-0475",
          "095-0043",
          "095-0063",
          "095-0056",
          "095-0021",
          "095-0022",
          "095-0023",
          "095-0024",
          "095-0025",
          "095-0031",
          "095-0032",
          "095-0033",
          "095-0034",
          "095-0035",
          "095-0045",
          "095-0044",
          "095-0011",
          "095-0012",
          "095-0013",
          "095-0014",
          "095-0015",
          "095-0016",
          "095-0017",
          "095-0018",
          "095-0041",
          "095-0042",
          "095-0048",
          "095-0001",
          "095-0002",
          "095-0003",
          "095-0004",
          "095-0005",
          "095-0006",
          "095-0007",
          "095-0008",
          "095-0054",
          "095-0062",
          "095-0055",
          "095-0046",
          "095-0047",
          "096-0000",
          "096-0075",
          "096-0061",
          "096-0010",
          "096-0030",
          "096-0065",
          "096-0073",
          "096-0064",
          "098-2181",
          "096-0071",
          "096-0076",
          "096-0078",
          "096-0011",
          "096-0031",
          "096-0012",
          "096-0032",
          "096-0013",
          "096-0033",
          "096-0014",
          "096-0034",
          "096-0015",
          "096-0035",
          "096-0016",
          "096-0036",
          "096-0017",
          "096-0037",
          "096-0018",
          "096-0038",
          "096-0019",
          "096-0039",
          "096-0020",
          "096-0040",
          "096-0021",
          "096-0041",
          "096-0022",
          "096-0042",
          "096-0023",
          "096-0043",
          "096-0024",
          "096-0025",
          "096-0062",
          "096-0066",
          "096-0001",
          "096-0051",
          "096-0002",
          "096-0052",
          "096-0003",
          "096-0053",
          "096-0004",
          "096-0054",
          "096-0005",
          "096-0055",
          "096-0006",
          "096-0056",
          "096-0007",
          "096-0008",
          "096-0009",
          "098-0514",
          "098-0513",
          "098-0503",
          "098-0511",
          "098-0508",
          "098-0515",
          "098-0632",
          "098-0501",
          "098-0506",
          "098-0509",
          "098-0507",
          "098-0631",
          "098-0512",
          "098-0502",
          "098-0516",
          "098-0505",
          "098-0504",
          "096-0072",
          "096-0077",
          "096-0063",
          "096-0074",
          "068-2100",
          "068-2151",
          "068-2112",
          "068-2114",
          "068-2118",
          "068-2115",
          "068-2117",
          "068-2111",
          "068-2113",
          "068-2116",
          "068-2164",
          "068-2167",
          "068-2165",
          "068-2108",
          "068-2101",
          "068-2166",
          "068-2162",
          "068-2105",
          "068-2153",
          "068-2155",
          "068-2154",
          "068-2152",
          "068-2163",
          "068-2158",
          "068-2137",
          "068-2136",
          "068-2131",
          "068-2134",
          "068-2133",
          "068-2132",
          "068-2135",
          "068-2102",
          "068-2104",
          "068-2146",
          "068-2144",
          "068-2147",
          "068-2142",
          "068-2148",
          "068-2143",
          "068-2145",
          "068-2161",
          "068-2141",
          "068-2103",
          "068-2106",
          "068-2156",
          "068-2168",
          "068-2121",
          "068-2125",
          "068-2122",
          "068-2124",
          "068-2128",
          "068-2123",
          "068-2127",
          "068-2126",
          "068-2107",
          "068-2157",
          "087-0000",
          "086-0061",
          "087-0006",
          "087-0014",
          "086-0064",
          "087-0008",
          "087-0052",
          "088-1782",
          "088-1781",
          "087-0035",
          "087-0166",
          "087-0054",
          "087-0023",
          "086-0072",
          "087-0001",
          "087-0042",
          "087-0004",
          "087-0027",
          "087-0055",
          "086-0062",
          "087-0012",
          "087-0164",
          "088-1784",
          "087-0021",
          "087-0010",
          "087-0047",
          "087-0019",
          "087-0026",
          "087-0022",
          "087-0028",
          "087-0005",
          "087-0018",
          "088-1785",
          "087-0031",
          "087-0007",
          "086-0074",
          "087-0041",
          "087-0161",
          "087-0167",
          "087-0017",
          "086-0065",
          "087-0025",
          "087-0033",
          "087-0165",
          "086-0076",
          "087-0015",
          "087-0032",
          "087-0045",
          "087-0163",
          "088-1783",
          "086-0063",
          "087-0034",
          "087-0162",
          "087-0048",
          "086-0075",
          "087-0011",
          "087-0024",
          "087-0043",
          "087-0037",
          "087-0036",
          "087-0053",
          "087-0002",
          "087-0016",
          "087-0044",
          "087-0046",
          "087-0051",
          "087-0003",
          "087-0009",
          "087-0049",
          "086-0071",
          "086-0073",
          "066-0000",
          "066-0015",
          "066-0014",
          "066-0018",
          "066-0043",
          "066-0076",
          "066-0004",
          "066-0051",
          "066-0029",
          "066-0025",
          "066-0286",
          "066-0001",
          "066-0031",
          "066-0013",
          "066-0009",
          "066-0065",
          "066-0067",
          "066-0002",
          "066-0077",
          "066-0075",
          "066-0005",
          "069-1182",
          "066-0082",
          "066-0023",
          "066-0011",
          "066-0063",
          "066-0061",
          "066-0071",
          "066-0055",
          "066-0281",
          "066-0284",
          "066-0038",
          "066-0042",
          "066-0041",
          "066-0072",
          "066-0006",
          "066-0056",
          "066-0069",
          "066-0046",
          "066-0037",
          "066-0282",
          "066-0027",
          "066-0026",
          "066-0081",
          "066-0035",
          "066-0007",
          "066-0062",
          "066-0021",
          "066-0034",
          "066-0022",
          "069-1184",
          "066-0064",
          "066-0008",
          "066-0054",
          "066-0028",
          "069-1181",
          "066-0017",
          "066-0016",
          "066-0012",
          "066-0285",
          "066-0053",
          "066-0039",
          "066-0052",
          "066-0044",
          "066-0036",
          "066-0073",
          "066-0032",
          "066-0033",
          "069-1183",
          "066-0287",
          "066-0047",
          "066-0045",
          "066-0083",
          "066-0084",
          "066-0074",
          "066-0003",
          "066-0283",
          "066-0066",
          "066-0024",
          "066-0078",
          "066-0068",
          "066-0019",
          "066-0057",
          "073-0000",
          "073-0015",
          "073-0018",
          "073-0045",
          "073-0042",
          "073-0016",
          "073-0017",
          "079-0461",
          "079-0463",
          "079-0462",
          "073-0046",
          "073-0022",
          "073-0036",
          "073-0001",
          "073-0012",
          "073-0011",
          "073-0043",
          "073-0031",
          "073-0033",
          "073-0034",
          "073-0004",
          "073-0003",
          "073-0002",
          "073-0035",
          "073-0041",
          "073-0044",
          "073-0005",
          "073-0006",
          "073-0026",
          "073-0027",
          "073-0024",
          "073-0014",
          "073-0021",
          "073-0023",
          "073-0013",
          "073-0032",
          "073-0025",
          "073-0100",
          "073-0107",
          "073-0116",
          "073-0118",
          "073-0177",
          "073-0106",
          "073-0171",
          "073-0172",
          "073-0173",
          "073-0174",
          "073-0175",
          "073-0176",
          "073-0101",
          "073-0102",
          "073-0103",
          "073-0104",
          "073-0105",
          "079-1181",
          "073-0085",
          "073-0138",
          "073-0148",
          "073-0141",
          "073-0161",
          "073-0142",
          "073-0162",
          "073-0143",
          "073-0163",
          "073-0144",
          "073-0164",
          "073-0145",
          "073-0165",
          "073-0146",
          "073-0166",
          "073-0147",
          "073-0167",
          "073-0168",
          "073-0111",
          "073-0112",
          "073-0113",
          "073-0114",
          "073-0126",
          "073-0131",
          "073-0151",
          "073-0132",
          "073-0152",
          "073-0153",
          "073-0133",
          "073-0134",
          "073-0154",
          "073-0135",
          "073-0155",
          "073-0136",
          "073-0156",
          "073-0137",
          "073-0127",
          "073-0178",
          "073-0108",
          "073-0157",
          "073-0117",
          "073-0125",
          "073-0115",
          "073-0121",
          "073-0158",
          "073-0122",
          "073-0159",
          "073-0123",
          "073-0124",
          "073-0400",
          "073-0404",
          "073-0401",
          "073-0405",
          "073-0402",
          "073-0406",
          "073-0403",
          "073-0407",
          "074-0000",
          "074-0001",
          "074-0002",
          "074-0003",
          "074-0004",
          "074-0005",
          "074-0006",
          "074-0007",
          "074-0008",
          "074-0009",
          "074-0031",
          "074-0028",
          "074-0021",
          "074-0143",
          "074-0142",
          "078-0151",
          "078-0153",
          "078-0154",
          "074-1273",
          "074-1276",
          "078-0152",
          "074-1162",
          "074-1164",
          "074-1272",
          "074-1161",
          "074-1275",
          "074-1274",
          "074-1271",
          "074-1163",
          "074-0014",
          "074-0024",
          "074-0023",
          "074-0144",
          "074-0141",
          "074-0147",
          "074-0025",
          "074-0027",
          "074-0026",
          "074-0012",
          "074-0016",
          "074-0015",
          "074-0013",
          "074-0022",
          "074-0145",
          "074-0011",
          "074-0146",
          "076-0000",
          "076-0026",
          "076-0008",
          "076-0035",
          "076-0054",
          "076-0038",
          "076-0014",
          "076-0015",
          "076-0059",
          "076-0001",
          "076-0044",
          "076-0034",
          "076-0175",
          "076-0165",
          "076-0024",
          "076-0023",
          "076-0039",
          "076-0050",
          "076-0036",
          "076-0048",
          "076-0012",
          "076-0017",
          "076-0058",
          "076-0033",
          "076-0011",
          "076-0057",
          "076-0204",
          "076-0183",
          "076-0013",
          "076-0016",
          "076-0176",
          "076-0055",
          "076-0006",
          "076-0047",
          "076-0028",
          "076-0201",
          "076-0182",
          "076-0042",
          "076-0173",
          "076-0037",
          "076-0163",
          "076-0003",
          "076-0004",
          "076-0005",
          "076-0027",
          "076-0051",
          "076-0045",
          "076-0181",
          "076-0041",
          "076-0172",
          "076-0053",
          "079-2133",
          "076-0202",
          "076-0162",
          "076-0025",
          "076-0171",
          "076-0046",
          "076-0056",
          "076-0021",
          "076-0052",
          "076-0002",
          "076-0043",
          "076-0174",
          "076-0007",
          "076-0164",
          "076-0031",
          "076-0184",
          "079-1562",
          "079-1564",
          "079-1571",
          "079-1572",
          "079-1573",
          "079-1566",
          "079-1581",
          "079-1582",
          "079-1563",
          "079-1565",
          "076-0018",
          "076-0203",
          "076-0161",
          "076-0022",
          "076-0032",
          "059-0000",
          "059-0027",
          "059-0017",
          "059-0016",
          "059-0552",
          "059-0031",
          "059-0553",
          "059-0022",
          "059-0021",
          "059-0002",
          "059-0033",
          "059-0023",
          "059-0005",
          "059-0461",
          "059-0001",
          "059-0015",
          "059-0032",
          "059-0003",
          "059-0012",
          "059-0011",
          "059-0462",
          "059-0028",
          "059-0463",
          "059-0551",
          "059-0464",
          "059-0465",
          "059-0466",
          "059-0014",
          "059-0013",
          "059-0036",
          "059-0024",
          "059-0025",
          "059-0004",
          "059-0035",
          "059-0026",
          "059-0034",
          "061-1400",
          "061-1448",
          "061-1431",
          "061-1401",
          "061-1414",
          "061-1415",
          "061-1411",
          "061-1424",
          "061-1423",
          "061-1402",
          "061-1404",
          "061-1433",
          "061-1366",
          "061-1444",
          "061-1432",
          "061-1449",
          "061-1407",
          "061-1409",
          "061-1417",
          "061-1426",
          "061-1443",
          "061-1416",
          "061-1363",
          "061-1354",
          "061-1355",
          "061-1352",
          "061-1351",
          "061-1353",
          "061-1364",
          "061-1412",
          "061-1445",
          "061-1446",
          "061-1441",
          "061-1403",
          "061-1405",
          "061-1362",
          "061-1435",
          "061-1356",
          "061-1434",
          "061-1361",
          "061-1422",
          "061-1447",
          "061-1425",
          "061-1365",
          "061-1421",
          "061-1427",
          "061-1442",
          "061-1375",
          "061-1371",
          "061-1373",
          "061-1372",
          "061-1374",
          "061-1376",
          "061-1413",
          "061-1406",
          "052-0000",
          "052-0015",
          "052-0025",
          "052-0002",
          "059-0151",
          "052-0022",
          "059-0153",
          "044-0441",
          "052-0312",
          "052-0316",
          "044-0443",
          "052-0303",
          "052-0315",
          "052-0302",
          "052-0313",
          "044-0444",
          "052-0311",
          "052-0301",
          "052-0314",
          "044-0442",
          "052-0317",
          "052-0027",
          "052-0024",
          "052-0008",
          "052-0036",
          "059-0152",
          "059-0272",
          "059-0275",
          "052-0001",
          "052-0005",
          "052-0021",
          "052-0011",
          "052-0034",
          "052-0031",
          "059-0274",
          "052-0035",
          "052-0026",
          "052-0007",
          "052-0033",
          "052-0004",
          "059-0154",
          "052-0006",
          "052-0016",
          "052-0014",
          "052-0003",
          "052-0012",
          "059-0156",
          "059-0271",
          "059-0273",
          "059-0157",
          "052-0023",
          "052-0032",
          "052-0013",
          "059-0155",
          "061-1100",
          "061-1141",
          "061-1123",
          "061-1145",
          "061-1125",
          "061-1124",
          "061-1270",
          "061-1274",
          "061-1278",
          "061-1272",
          "061-1271",
          "061-1279",
          "061-1273",
          "061-1277",
          "061-1276",
          "061-1275",
          "061-1111",
          "061-1261",
          "061-1112",
          "061-1113",
          "061-1134",
          "061-1133",
          "061-1147",
          "061-1265",
          "061-1144",
          "061-1126",
          "061-1127",
          "061-1146",
          "061-1121",
          "061-1135",
          "061-1153",
          "061-1152",
          "061-1101",
          "061-1103",
          "061-1102",
          "061-1105",
          "061-1106",
          "061-1104",
          "061-1267",
          "061-1114",
          "061-1151",
          "061-1122",
          "061-1132",
          "061-1136",
          "061-1115",
          "061-1131",
          "061-1266",
          "061-1143",
          "061-1154",
          "061-1148",
          "061-1137",
          "061-1264",
          "061-1281",
          "061-1268",
          "061-1269",
          "061-1142",
          "061-3200",
          "061-3601",
          "061-3602",
          "061-3151",
          "061-3603",
          "061-3521",
          "061-3331",
          "061-3441",
          "061-3332",
          "061-3605",
          "061-3522",
          "061-3523",
          "061-3606",
          "061-3377",
          "061-3365",
          "061-3366",
          "061-3367",
          "061-3245",
          "061-3362",
          "061-3220",
          "061-3373",
          "061-3242",
          "061-3243",
          "061-3241",
          "061-3244",
          "061-3253",
          "061-3254",
          "061-3255",
          "061-3256",
          "061-3257",
          "061-3258",
          "061-3259",
          "061-3251",
          "061-3374",
          "061-3484",
          "061-3361",
          "061-3480",
          "061-3481",
          "061-3482",
          "061-3219",
          "061-3211",
          "061-3212",
          "061-3213",
          "061-3214",
          "061-3215",
          "061-3216",
          "061-3217",
          "061-3248",
          "061-3261",
          "061-3262",
          "061-3210",
          "061-3201",
          "061-3202",
          "061-3203",
          "061-3204",
          "061-3205",
          "061-3206",
          "061-3207",
          "061-3208",
          "061-3209",
          "061-3112",
          "077-0351",
          "061-3107",
          "061-3106",
          "061-3102",
          "061-3113",
          "061-3109",
          "061-3105",
          "061-3104",
          "061-3101",
          "061-3111",
          "061-3103",
          "061-3108",
          "061-3371",
          "061-3281",
          "061-3282",
          "061-3283",
          "061-3284",
          "061-3218",
          "061-3368",
          "061-3378",
          "061-3372",
          "061-3375",
          "061-3483",
          "061-3376",
          "061-3230",
          "061-3231",
          "061-3232",
          "061-3221",
          "061-3222",
          "061-3223",
          "061-3363",
          "049-0100",
          "041-1242",
          "041-1223",
          "041-1241",
          "049-0161",
          "049-0101",
          "049-0152",
          "041-1213",
          "049-0136",
          "049-0157",
          "049-0121",
          "049-0143",
          "049-0151",
          "041-1221",
          "049-0142",
          "041-1211",
          "049-0154",
          "049-0153",
          "049-0132",
          "049-0141",
          "049-0162",
          "041-1222",
          "049-0282",
          "049-0171",
          "049-0131",
          "049-0155",
          "049-0156",
          "041-1243",
          "049-0111",
          "049-0158",
          "041-1215",
          "049-0122",
          "041-1214",
          "041-1225",
          "041-1212",
          "041-1251",
          "041-1201",
          "049-0135",
          "049-0283",
          "041-1224",
          "049-0134",
          "041-1231",
          "041-1226",
          "041-1244",
          "049-0281",
          "049-0285",
          "049-0133",
          "049-0286",
          "049-0284",
          "061-0200",
          "061-0201",
          "061-0253",
          "061-0252",
          "061-0251",
          "061-0254",
          "061-0232",
          "061-0212",
          "061-0218",
          "061-0207",
          "061-3774",
          "061-0206",
          "061-0217",
          "061-0216",
          "061-3772",
          "061-0205",
          "061-0233",
          "061-3777",
          "061-0224",
          "061-0227",
          "061-3771",
          "061-0215",
          "061-3773",
          "061-0211",
          "061-0226",
          "061-0234",
          "061-0213",
          "061-0221",
          "002-8089",
          "061-3775",
          "061-3779",
          "061-3776",
          "061-3778",
          "061-0208",
          "061-0235",
          "061-0225",
          "061-0203",
          "061-0228",
          "061-0222",
          "061-0202",
          "061-0223",
          "061-0231",
          "061-0204",
          "061-0214",
          "068-1100",
          "068-1112",
          "068-1102",
          "068-1104",
          "068-1125",
          "068-1116",
          "068-1123",
          "068-1152",
          "068-1131",
          "068-1134",
          "068-1136",
          "068-1142",
          "068-1146",
          "068-1138",
          "068-1121",
          "068-1124",
          "068-1144",
          "068-1143",
          "068-1111",
          "068-1126",
          "068-1132",
          "068-1137",
          "068-1153",
          "068-1141",
          "068-1145",
          "068-1103",
          "068-1151",
          "068-1127",
          "068-1135",
          "068-1113",
          "068-1133",
          "068-1122",
          "068-1115",
          "068-1114",
          "068-1105",
          "068-1101",
          "049-1500",
          "049-1643",
          "049-1517",
          "049-1504",
          "049-1523",
          "049-1771",
          "049-1503",
          "049-1522",
          "049-1781",
          "049-1521",
          "049-1761",
          "049-1506",
          "049-1783",
          "049-1784",
          "049-1642",
          "049-1644",
          "049-1524",
          "049-1763",
          "049-1513",
          "049-1782",
          "049-1501",
          "049-1641",
          "049-1515",
          "049-1514",
          "049-1507",
          "049-1505",
          "049-1762",
          "049-1516",
          "049-1512",
          "049-1764",
          "049-1502",
          "049-1511",
          "049-1645",
          "049-1300",
          "049-1325",
          "049-1312",
          "049-1323",
          "049-1322",
          "049-1301",
          "049-1331",
          "049-1332",
          "049-1454",
          "049-1321",
          "049-1452",
          "049-1311",
          "049-1324",
          "049-1302",
          "049-1456",
          "049-1451",
          "049-1453",
          "049-1455",
          "049-1100",
          "049-1103",
          "049-1105",
          "049-1107",
          "049-1101",
          "049-1106",
          "049-1102",
          "049-1221",
          "049-1104",
          "049-0400",
          "049-0405",
          "049-0454",
          "049-0401",
          "049-0453",
          "049-0412",
          "049-0402",
          "049-0403",
          "049-0404",
          "049-0431",
          "049-0408",
          "049-0411",
          "049-0451",
          "049-0452",
          "049-0455",
          "049-0441",
          "049-0406",
          "049-0407",
          "049-0422",
          "049-0421",
          "041-1100",
          "041-1136",
          "041-1352",
          "041-1122",
          "041-1121",
          "041-1354",
          "041-1353",
          "041-1104",
          "041-1105",
          "041-1134",
          "041-1102",
          "041-1132",
          "041-1133",
          "041-1131",
          "041-1112",
          "041-1355",
          "041-1101",
          "041-1351",
          "041-1103",
          "041-1111",
          "041-1135",
          "041-1400",
          "041-1401",
          "041-1405",
          "041-1402",
          "041-1404",
          "041-1403",
          "049-2300",
          "049-2142",
          "049-2463",
          "049-2311",
          "049-2465",
          "049-2301",
          "049-2312",
          "049-2327",
          "049-2324",
          "049-2141",
          "049-2308",
          "049-2222",
          "049-2221",
          "049-2223",
          "049-2461",
          "049-2307",
          "049-2304",
          "049-2305",
          "049-2323",
          "049-2462",
          "049-2303",
          "049-2306",
          "049-2322",
          "049-2464",
          "049-2325",
          "049-2302",
          "049-2326",
          "049-2313",
          "049-2321",
          "049-3100",
          "049-3113",
          "049-2561",
          "049-3125",
          "049-3115",
          "049-2564",
          "049-3104",
          "049-3126",
          "049-2562",
          "049-3127",
          "049-2566",
          "049-3121",
          "043-0332",
          "043-0402",
          "043-0416",
          "043-0405",
          "043-0331",
          "043-0335",
          "043-0401",
          "043-0418",
          "043-0403",
          "043-0404",
          "043-0333",
          "043-0334",
          "043-0417",
          "043-0419",
          "043-0415",
          "049-3341",
          "049-3117",
          "049-2563",
          "049-2675",
          "049-3105",
          "049-2565",
          "049-3112",
          "049-3111",
          "049-3123",
          "049-3103",
          "049-3128",
          "049-2672",
          "049-3122",
          "049-3124",
          "049-3102",
          "049-2673",
          "049-3106",
          "049-3107",
          "049-3114",
          "049-3118",
          "049-3116",
          "049-3101",
          "049-2671",
          "049-3342",
          "049-2674",
          "049-3500",
          "049-3521",
          "049-3519",
          "049-3511",
          "049-3501",
          "049-3517",
          "049-3515",
          "049-3462",
          "049-3516",
          "049-3518",
          "049-5141",
          "049-3465",
          "049-3502",
          "049-3514",
          "049-3464",
          "049-3463",
          "049-3512",
          "049-3461",
          "049-3504",
          "049-3513",
          "049-3503",
          "043-0000",
          "043-0013",
          "043-0031",
          "043-0042",
          "043-0012",
          "043-0041",
          "043-0046",
          "043-0016",
          "043-0026",
          "043-0014",
          "043-0024",
          "043-0057",
          "043-0064",
          "043-0045",
          "043-0011",
          "043-0032",
          "043-0053",
          "043-0056",
          "043-0065",
          "043-0023",
          "043-0051",
          "043-0066",
          "043-0025",
          "043-0033",
          "043-0015",
          "043-0034",
          "043-0062",
          "043-0044",
          "043-0036",
          "043-0035",
          "043-0022",
          "043-0043",
          "043-0055",
          "043-0017",
          "043-0054",
          "043-0061",
          "043-0063",
          "043-0052",
          "043-0021",
          "049-0600",
          "049-0741",
          "049-0621",
          "049-0607",
          "049-0604",
          "049-0603",
          "049-0611",
          "049-0601",
          "049-0626",
          "049-0612",
          "049-0622",
          "049-0606",
          "049-0605",
          "049-0627",
          "049-0608",
          "049-0623",
          "049-0561",
          "049-0742",
          "049-0743",
          "049-0625",
          "049-0624",
          "049-0744",
          "049-0564",
          "049-0602",
          "049-0563",
          "049-0613",
          "049-0562",
          "043-1100",
          "043-1232",
          "043-1111",
          "043-1233",
          "043-1102",
          "043-1238",
          "043-1237",
          "043-1104",
          "043-1116",
          "043-1234",
          "043-1231",
          "043-1101",
          "043-1361",
          "043-1236",
          "043-1364",
          "043-1367",
          "043-1113",
          "043-1362",
          "043-1103",
          "043-1351",
          "043-1235",
          "043-1366",
          "043-1118",
          "043-1363",
          "043-1368",
          "043-1114",
          "043-1115",
          "043-1112",
          "043-1365",
          "043-1117",
          "043-0100",
          "043-0116",
          "043-0114",
          "043-0112",
          "043-0113",
          "043-0233",
          "043-0101",
          "043-0104",
          "043-0115",
          "043-0231",
          "043-0111",
          "043-0232",
          "043-0117",
          "043-0234",
          "043-0103",
          "043-0102",
          "043-1400",
          "043-1521",
          "043-1402",
          "043-1405",
          "043-1401",
          "043-1403",
          "043-1522",
          "043-1523",
          "043-1404",
          "043-1525",
          "043-1406",
          "043-1524",
          "049-4300",
          "049-4303",
          "049-4312",
          "049-4301",
          "049-4325",
          "049-4308",
          "049-4155",
          "049-4327",
          "049-4157",
          "049-4304",
          "049-4335",
          "049-4311",
          "049-4326",
          "049-4314",
          "049-4332",
          "049-4315",
          "049-4321",
          "049-4336",
          "049-4156",
          "049-4306",
          "049-4331",
          "049-4324",
          "049-4337",
          "049-4154",
          "049-4305",
          "049-4333",
          "049-4307",
          "049-4153",
          "049-4323",
          "049-4302",
          "049-4151",
          "049-4313",
          "049-4322",
          "049-4317",
          "049-4316",
          "049-4152",
          "049-4334",
          "049-4318",
          "049-4500",
          "049-4513",
          "049-4431",
          "049-4515",
          "049-4501",
          "049-4516",
          "049-4753",
          "049-4751",
          "049-4518",
          "049-4512",
          "049-4755",
          "049-4514",
          "049-4434",
          "049-4433",
          "049-4432",
          "049-4754",
          "049-4517",
          "049-4511",
          "049-4752",
          "049-4824",
          "049-4827",
          "049-4821",
          "049-4823",
          "049-4825",
          "049-4826",
          "049-4816",
          "049-4801",
          "049-4802",
          "049-4803",
          "049-4804",
          "049-4805",
          "049-4811",
          "049-4812",
          "049-4813",
          "049-4814",
          "049-4815",
          "049-4828",
          "049-4822",
          "043-0501",
          "043-0515",
          "043-0503",
          "043-0511",
          "043-0502",
          "043-0421",
          "043-0512",
          "043-0514",
          "043-0505",
          "043-0504",
          "043-0513",
          "048-0600",
          "048-0602",
          "048-0623",
          "048-0613",
          "048-0611",
          "048-0634",
          "048-0631",
          "048-0621",
          "048-0601",
          "048-0612",
          "048-0622",
          "048-0614",
          "048-0633",
          "048-0603",
          "048-0604",
          "048-0632",
          "048-0400",
          "048-0351",
          "048-0412",
          "048-0415",
          "048-0404",
          "048-0405",
          "048-0401",
          "048-0413",
          "048-0406",
          "048-0403",
          "048-0402",
          "048-0414",
          "048-0411",
          "048-0100",
          "048-0136",
          "048-0116",
          "048-0124",
          "048-0114",
          "048-0133",
          "048-0112",
          "048-0135",
          "048-0145",
          "048-0141",
          "048-0126",
          "048-0101",
          "048-0134",
          "048-0122",
          "048-0117",
          "048-0143",
          "048-0132",
          "048-0142",
          "048-0113",
          "048-0111",
          "048-0123",
          "048-0131",
          "048-0115",
          "048-0121",
          "048-0137",
          "048-0144",
          "048-0127",
          "048-0125",
          "048-1300",
          "048-1251",
          "048-1265",
          "048-1305",
          "048-1316",
          "048-1314",
          "048-1262",
          "048-1313",
          "048-1254",
          "048-1315",
          "048-1323",
          "048-1321",
          "048-1302",
          "048-1325",
          "048-1252",
          "048-1264",
          "048-1253",
          "048-1303",
          "048-1326",
          "048-1324",
          "048-1307",
          "048-1327",
          "048-1322",
          "048-1312",
          "048-1263",
          "048-1304",
          "048-1341",
          "048-1261",
          "048-1311",
          "048-1306",
          "048-1301",
          "048-1500",
          "048-1531",
          "048-1562",
          "048-1553",
          "048-1542",
          "048-1551",
          "048-1522",
          "048-1512",
          "048-1554",
          "048-1543",
          "048-1563",
          "048-1511",
          "048-1521",
          "048-1561",
          "048-1501",
          "048-1502",
          "048-1552",
          "048-1544",
          "048-1541",
          "048-1600",
          "048-1602",
          "048-1622",
          "048-1624",
          "048-1623",
          "048-1603",
          "048-1614",
          "048-1604",
          "048-1621",
          "048-1613",
          "048-1611",
          "048-1631",
          "048-1615",
          "048-1601",
          "048-1612",
          "048-1605",
          "048-1700",
          "048-1752",
          "048-1711",
          "048-1722",
          "048-1723",
          "048-1712",
          "048-1741",
          "048-1751",
          "048-1724",
          "048-1721",
          "048-1731",
          "044-0200",
          "044-0215",
          "044-0201",
          "044-0454",
          "044-0451",
          "044-0223",
          "044-0453",
          "044-0222",
          "044-0214",
          "044-0224",
          "044-0461",
          "044-0462",
          "044-0213",
          "044-0452",
          "044-0225",
          "044-0221",
          "044-0211",
          "044-0463",
          "044-0212",
          "044-0100",
          "044-0122",
          "044-0112",
          "044-0131",
          "044-0111",
          "044-0101",
          "044-0132",
          "044-0125",
          "044-0124",
          "044-0113",
          "044-0121",
          "044-0123",
          "044-0000",
          "044-0083",
          "044-0064",
          "044-0082",
          "044-0078",
          "044-0071",
          "044-0001",
          "044-0051",
          "044-0002",
          "044-0052",
          "044-0003",
          "044-0053",
          "044-0004",
          "044-0054",
          "044-0005",
          "044-0055",
          "044-0006",
          "044-0056",
          "044-0007",
          "044-0057",
          "044-0066",
          "044-0063",
          "044-0076",
          "044-0065",
          "044-0074",
          "044-0085",
          "044-0073",
          "044-0084",
          "044-0077",
          "044-0075",
          "044-0062",
          "044-0067",
          "044-0068",
          "044-0011",
          "044-0031",
          "044-0012",
          "044-0032",
          "044-0013",
          "044-0033",
          "044-0014",
          "044-0034",
          "044-0015",
          "044-0035",
          "044-0016",
          "044-0036",
          "044-0021",
          "044-0041",
          "044-0022",
          "044-0042",
          "044-0023",
          "044-0043",
          "044-0024",
          "044-0044",
          "044-0025",
          "044-0045",
          "044-0072",
          "044-0081",
          "044-0061",
          "048-2200",
          "045-0032",
          "048-2143",
          "048-2142",
          "045-0122",
          "045-0121",
          "048-2201",
          "048-2202",
          "045-0123",
          "045-0031",
          "048-2141",
          "045-0000",
          "045-0023",
          "045-0001",
          "045-0022",
          "045-0011",
          "045-0025",
          "045-0013",
          "045-0024",
          "045-0002",
          "045-0003",
          "045-0026",
          "045-0012",
          "045-0021",
          "045-0200",
          "045-0205",
          "045-0202",
          "045-0204",
          "045-0203",
          "045-0201",
          "045-0300",
          "045-0302",
          "045-0301",
          "045-0303",
          "046-0200",
          "046-0327",
          "046-0321",
          "046-0324",
          "046-0325",
          "046-0201",
          "046-0326",
          "046-0202",
          "046-0328",
          "046-0322",
          "046-0323",
          "046-0100",
          "046-0104",
          "046-0132",
          "046-0133",
          "046-0111",
          "046-0131",
          "046-0112",
          "046-0121",
          "046-0103",
          "046-0102",
          "046-0101",
          "046-0113",
          "048-2400",
          "048-2401",
          "048-2402",
          "048-2331",
          "048-2334",
          "048-2405",
          "048-2335",
          "048-2403",
          "048-2404",
          "048-2332",
          "048-2333",
          "048-2406",
          "048-2411",
          "048-2412",
          "048-2413",
          "046-0000",
          "046-0015",
          "046-0011",
          "046-0023",
          "046-0004",
          "046-0003",
          "046-0001",
          "046-0022",
          "046-0033",
          "046-0031",
          "046-0025",
          "046-0013",
          "046-0032",
          "046-0002",
          "046-0021",
          "046-0014",
          "046-0024",
          "046-0012",
          "046-0500",
          "046-0501",
          "046-0531",
          "046-0521",
          "046-0561",
          "046-0571",
          "046-0551",
          "046-0532",
          "046-0511",
          "046-0542",
          "046-0541",
          "046-0552",
          "046-0512",
          "069-0200",
          "069-0239",
          "069-0231",
          "069-0237",
          "069-0235",
          "069-0236",
          "069-0233",
          "069-0234",
          "069-0232",
          "069-0207",
          "069-0208",
          "069-0209",
          "069-0210",
          "069-0211",
          "069-0212",
          "069-0213",
          "069-0214",
          "069-0215",
          "069-0216",
          "069-0217",
          "069-0218",
          "069-0219",
          "069-0220",
          "069-0221",
          "069-0238",
          "079-0300",
          "079-0301",
          "079-0312",
          "079-0316",
          "079-0315",
          "079-0305",
          "079-0302",
          "079-0306",
          "079-0313",
          "079-0317",
          "079-0314",
          "079-0304",
          "079-0303",
          "079-0311",
          "073-0200",
          "073-0205",
          "073-0212",
          "073-0221",
          "073-0222",
          "073-0201",
          "073-0203",
          "073-0211",
          "073-0202",
          "073-0206",
          "073-0204",
          "073-0213",
          "069-1200",
          "069-1211",
          "069-1207",
          "069-1141",
          "069-1215",
          "069-1136",
          "069-1217",
          "069-1204",
          "069-1205",
          "069-1203",
          "069-1219",
          "069-1143",
          "069-1214",
          "069-1135",
          "069-1142",
          "069-1218",
          "069-1202",
          "069-1216",
          "069-1201",
          "069-1206",
          "069-1133",
          "069-1131",
          "069-1132",
          "069-1134",
          "069-1213",
          "069-1144",
          "069-1208",
          "069-1212",
          "069-1300",
          "069-1335",
          "069-1344",
          "069-1343",
          "069-1321",
          "069-1322",
          "069-1316",
          "069-1336",
          "069-1304",
          "069-1347",
          "069-1329",
          "069-1331",
          "069-1320",
          "069-1345",
          "069-1332",
          "069-1334",
          "069-1346",
          "069-1318",
          "069-1471",
          "069-1472",
          "069-1473",
          "069-1474",
          "069-1475",
          "069-1476",
          "069-1477",
          "069-1478",
          "069-1479",
          "069-1480",
          "069-1481",
          "069-1482",
          "069-1483",
          "069-1484",
          "069-1342",
          "069-1317",
          "069-1451",
          "069-1452",
          "069-1453",
          "069-1454",
          "069-1455",
          "069-1456",
          "069-1457",
          "069-1458",
          "069-1459",
          "069-1460",
          "069-1461",
          "069-1462",
          "069-1463",
          "069-1311",
          "069-1464",
          "069-1333",
          "069-1315",
          "069-1341",
          "069-1301",
          "069-1302",
          "069-1303",
          "069-1305",
          "069-1306",
          "069-1307",
          "069-1308",
          "069-1309",
          "069-1310",
          "069-1312",
          "069-1313",
          "069-1314",
          "069-1485",
          "069-1500",
          "069-1513",
          "069-1507",
          "068-0351",
          "069-1503",
          "068-0352",
          "069-1524",
          "069-1504",
          "069-1506",
          "069-1523",
          "069-1501",
          "068-0358",
          "069-1505",
          "068-0361",
          "069-1511",
          "068-0353",
          "069-1522",
          "069-1521",
          "069-1502",
          "068-0354",
          "069-1526",
          "069-1512",
          "068-0362",
          "068-0363",
          "069-1525",
          "068-0355",
          "068-0356",
          "068-0357",
          "069-1508",
          "061-0500",
          "061-0518",
          "061-0514",
          "068-1231",
          "061-0517",
          "061-0502",
          "061-0527",
          "061-0508",
          "061-0515",
          "061-0505",
          "061-0512",
          "061-0511",
          "061-0523",
          "061-0525",
          "061-0506",
          "061-0501",
          "061-0526",
          "061-0504",
          "061-0516",
          "061-0528",
          "061-0529",
          "061-0522",
          "061-0503",
          "061-0513",
          "061-0521",
          "061-0507",
          "061-0524",
          "061-0600",
          "061-0611",
          "061-0612",
          "061-0613",
          "061-0614",
          "061-0615",
          "061-0616",
          "061-0617",
          "061-0618",
          "061-0621",
          "061-0622",
          "061-0623",
          "061-0601",
          "061-0602",
          "061-0603",
          "073-1100",
          "073-1321",
          "073-1105",
          "073-1101",
          "073-1106",
          "073-1103",
          "073-1107",
          "073-1323",
          "078-2651",
          "073-1102",
          "073-0181",
          "073-1104",
          "073-1322",
          "079-0500",
          "079-0501",
          "079-0502",
          "079-0503",
          "079-0504",
          "079-0505",
          "079-0506",
          "079-0507",
          "079-0508",
          "079-0509",
          "079-0510",
          "079-0511",
          "078-2100",
          "078-2121",
          "078-2122",
          "078-2123",
          "078-2124",
          "078-2111",
          "078-2112",
          "078-2101",
          "078-2102",
          "078-2103",
          "078-2104",
          "078-2105",
          "078-2106",
          "078-2107",
          "078-2108",
          "078-2109",
          "078-2600",
          "078-2631",
          "078-2632",
          "078-2633",
          "078-2634",
          "078-2531",
          "078-2635",
          "078-2636",
          "078-2637",
          "078-2638",
          "078-2639",
          "078-2641",
          "078-2642",
          "078-2500",
          "078-2511",
          "078-2502",
          "078-2514",
          "078-2516",
          "078-2501",
          "078-2503",
          "078-2513",
          "078-2512",
          "078-2515",
          "078-2200",
          "078-2201",
          "078-2224",
          "078-2205",
          "078-2213",
          "078-2211",
          "078-2214",
          "078-2212",
          "078-2204",
          "078-2222",
          "078-2223",
          "078-2225",
          "078-2203",
          "078-2221",
          "078-2206",
          "078-2202",
          "071-1200",
          "071-1231",
          "071-1232",
          "071-1233",
          "071-1234",
          "071-1235",
          "071-1221",
          "071-1222",
          "071-1223",
          "071-1224",
          "071-1225",
          "071-1211",
          "071-1201",
          "071-1202",
          "071-1247",
          "071-1248",
          "071-1249",
          "071-1250",
          "071-1251",
          "071-1252",
          "071-1253",
          "071-1254",
          "071-1255",
          "071-1256",
          "071-1257",
          "071-1258",
          "071-1259",
          "071-1260",
          "071-1261",
          "071-1262",
          "071-1263",
          "071-1264",
          "071-1265",
          "071-1266",
          "071-1267",
          "071-1500",
          "071-1560",
          "071-1512",
          "071-1511",
          "071-1514",
          "071-1513",
          "071-1515",
          "071-1581",
          "071-1582",
          "071-1561",
          "071-1562",
          "071-1563",
          "071-1564",
          "071-1565",
          "071-1521",
          "071-1522",
          "071-1523",
          "071-1524",
          "071-1525",
          "071-1572",
          "071-1573",
          "071-1574",
          "071-1575",
          "071-1502",
          "071-1501",
          "071-1571",
          "071-1504",
          "071-1503",
          "071-1505",
          "071-1570",
          "071-1577",
          "071-1533",
          "071-1534",
          "071-1535",
          "071-1536",
          "071-1537",
          "071-1538",
          "071-1539",
          "071-1540",
          "071-1541",
          "071-1542",
          "071-1543",
          "071-1544",
          "071-1545",
          "071-1546",
          "071-1547",
          "071-1548",
          "071-1549",
          "071-1550",
          "071-1551",
          "071-1552",
          "071-1553",
          "071-1554",
          "071-1555",
          "071-1556",
          "071-1557",
          "078-1300",
          "078-1333",
          "078-1332",
          "078-1341",
          "078-1331",
          "078-1337",
          "078-1334",
          "078-1335",
          "078-1313",
          "078-1303",
          "078-1314",
          "078-1304",
          "078-1324",
          "078-1315",
          "078-1305",
          "078-1316",
          "078-1306",
          "078-0300",
          "078-0310",
          "078-0348",
          "078-0321",
          "078-0322",
          "078-0323",
          "078-0324",
          "078-0325",
          "078-0326",
          "078-0327",
          "078-0328",
          "078-0329",
          "078-0330",
          "078-0331",
          "078-0332",
          "078-0333",
          "078-0334",
          "078-0335",
          "078-0349",
          "078-0341",
          "078-0346",
          "078-0343",
          "078-0342",
          "078-0347",
          "078-0344",
          "078-0311",
          "078-0345",
          "078-1400",
          "078-1653",
          "078-1654",
          "078-1401",
          "078-1411",
          "078-1404",
          "078-1414",
          "078-1412",
          "078-1652",
          "078-1415",
          "078-1651",
          "078-1402",
          "078-1413",
          "078-1405",
          "078-1403",
          "078-1700",
          "078-1761",
          "078-1752",
          "078-1721",
          "078-1744",
          "078-1732",
          "078-1711",
          "078-1775",
          "078-1733",
          "078-1712",
          "078-1722",
          "078-1762",
          "078-1701",
          "078-1741",
          "078-1772",
          "078-1731",
          "078-1774",
          "078-1771",
          "078-1742",
          "078-1773",
          "078-1743",
          "078-1763",
          "078-1751",
          "078-1753",
          "071-1400",
          "071-1426",
          "071-1465",
          "071-1466",
          "071-1462",
          "071-1463",
          "071-1467",
          "071-1419",
          "071-1418",
          "071-1416",
          "071-1415",
          "071-1413",
          "071-1414",
          "071-1464",
          "071-1425",
          "071-1422",
          "071-1402",
          "071-1403",
          "071-1404",
          "071-1405",
          "071-1406",
          "071-1407",
          "071-1408",
          "071-1409",
          "071-1410",
          "071-1411",
          "071-1412",
          "071-1471",
          "071-1423",
          "071-1452",
          "071-1432",
          "071-1453",
          "071-1433",
          "071-1454",
          "071-1434",
          "071-1455",
          "071-1435",
          "071-1456",
          "071-1436",
          "071-1457",
          "071-1437",
          "071-1458",
          "071-1438",
          "071-1459",
          "071-1439",
          "071-1460",
          "071-1440",
          "071-1461",
          "071-1441",
          "071-1442",
          "071-1473",
          "071-1424",
          "071-1472",
          "071-1451",
          "071-1431",
          "071-0200",
          "071-0261",
          "071-0212",
          "071-0251",
          "071-0249",
          "071-0215",
          "071-0204",
          "071-0217",
          "071-0216",
          "071-0219",
          "071-0218",
          "071-0234",
          "071-0229",
          "071-0206",
          "071-0209",
          "071-0223",
          "071-0214",
          "071-0205",
          "071-0247",
          "071-0240",
          "071-0226",
          "071-0235",
          "071-0233",
          "071-0473",
          "071-0474",
          "071-0353",
          "071-1474",
          "071-0355",
          "071-0475",
          "071-0228",
          "071-0227",
          "071-0207",
          "071-0211",
          "071-0203",
          "071-0248",
          "071-0239",
          "071-0213",
          "071-0471",
          "071-0461",
          "071-0472",
          "071-0462",
          "071-0245",
          "071-0246",
          "071-0244",
          "071-0237",
          "071-0243",
          "071-0238",
          "071-0477",
          "071-0224",
          "071-0201",
          "071-0236",
          "071-0242",
          "071-0241",
          "071-0479",
          "071-0222",
          "071-0221",
          "071-0202",
          "071-0476",
          "071-0231",
          "071-0225",
          "071-0232",
          "071-0208",
          "071-0351",
          "071-0478",
          "071-0352",
          "071-0500",
          "071-0553",
          "071-0571",
          "071-0547",
          "071-0548",
          "071-0561",
          "071-0565",
          "071-0520",
          "071-0549",
          "071-0544",
          "071-0564",
          "071-0576",
          "071-0554",
          "071-0574",
          "071-0575",
          "071-0583",
          "071-0541",
          "071-0577",
          "071-0543",
          "071-0542",
          "071-0534",
          "071-0546",
          "071-0501",
          "071-0502",
          "071-0503",
          "071-0504",
          "071-0505",
          "071-0506",
          "071-0507",
          "071-0508",
          "071-0509",
          "071-0510",
          "071-0511",
          "071-0512",
          "071-0513",
          "071-0514",
          "071-0515",
          "071-0516",
          "071-0517",
          "071-0533",
          "071-0545",
          "071-0555",
          "071-0521",
          "071-0522",
          "071-0523",
          "071-0524",
          "071-0525",
          "071-0526",
          "071-0527",
          "071-0528",
          "071-0529",
          "071-0530",
          "071-0531",
          "071-0532",
          "071-0579",
          "071-0572",
          "071-0573",
          "071-0563",
          "071-0562",
          "071-0552",
          "071-0566",
          "071-0551",
          "071-0578",
          "071-0700",
          "071-0770",
          "071-0755",
          "071-0733",
          "071-0762",
          "071-0704",
          "071-0751",
          "071-0734",
          "071-0731",
          "071-0754",
          "071-0732",
          "071-0737",
          "071-0705",
          "071-0706",
          "071-0707",
          "071-0761",
          "071-0735",
          "071-0771",
          "071-0772",
          "071-0773",
          "071-0774",
          "071-0775",
          "071-0776",
          "071-0777",
          "071-0778",
          "071-0779",
          "071-0780",
          "071-0781",
          "071-0726",
          "071-0742",
          "071-0711",
          "071-0753",
          "071-0714",
          "071-0752",
          "071-0736",
          "079-2400",
          "079-2403",
          "079-2404",
          "079-2401",
          "079-2402",
          "079-2551",
          "079-2131",
          "079-2552",
          "079-2132",
          "079-2412",
          "079-2411",
          "079-2200",
          "079-2205",
          "079-2202",
          "079-2203",
          "079-2206",
          "079-2201",
          "079-2204",
          "079-2207",
          "098-0100",
          "098-0126",
          "098-0121",
          "098-0113",
          "098-0103",
          "098-0133",
          "098-0112",
          "098-0125",
          "098-0114",
          "098-0102",
          "098-0122",
          "098-0135",
          "098-0132",
          "098-0123",
          "098-0134",
          "098-0101",
          "098-0115",
          "098-0104",
          "098-0111",
          "098-0124",
          "098-0131",
          "098-0300",
          "098-0336",
          "098-0334",
          "098-0338",
          "098-0335",
          "098-0337",
          "098-0339",
          "098-0331",
          "098-0341",
          "098-0342",
          "098-0332",
          "098-0333",
          "098-1200",
          "098-1201",
          "098-1331",
          "098-1216",
          "098-1212",
          "098-1203",
          "098-1214",
          "098-1206",
          "098-1213",
          "098-1211",
          "098-1207",
          "098-1205",
          "098-1332",
          "098-1215",
          "098-1202",
          "098-1204",
          "098-2200",
          "098-2201",
          "098-2362",
          "098-2230",
          "098-2220",
          "098-2363",
          "098-2361",
          "098-2238",
          "098-2204",
          "098-2206",
          "098-2227",
          "098-2367",
          "098-2214",
          "098-2368",
          "098-2202",
          "098-2211",
          "098-2208",
          "098-2365",
          "098-2252",
          "098-2241",
          "098-2251",
          "098-2242",
          "098-2243",
          "098-2253",
          "098-2212",
          "098-2231",
          "098-2221",
          "098-2232",
          "098-2222",
          "098-2233",
          "098-2223",
          "098-2234",
          "098-2224",
          "098-2225",
          "098-2236",
          "098-2226",
          "098-2205",
          "098-2207",
          "098-2364",
          "098-2235",
          "098-2366",
          "098-2213",
          "098-2203",
          "098-2237",
          "098-2500",
          "098-2501",
          "098-2502",
          "098-2800",
          "098-2801",
          "098-2804",
          "098-2621",
          "098-2806",
          "098-2803",
          "098-2622",
          "098-2623",
          "098-2624",
          "098-2802",
          "098-2805",
          "098-2625",
          "098-2626",
          "074-0400",
          "074-0413",
          "074-0424",
          "074-0744",
          "074-0415",
          "074-0423",
          "074-0743",
          "074-0403",
          "074-0742",
          "074-0422",
          "074-0747",
          "074-0402",
          "074-0412",
          "074-0414",
          "074-0425",
          "074-0426",
          "074-0427",
          "074-0746",
          "074-0421",
          "074-0404",
          "074-0401",
          "074-0745",
          "074-0411",
          "074-0741",
          "074-0405",
          "077-0200",
          "077-0131",
          "077-0203",
          "077-0204",
          "077-0345",
          "077-0344",
          "077-0201",
          "077-0341",
          "077-0134",
          "077-0218",
          "077-0212",
          "077-0209",
          "077-0132",
          "077-0211",
          "077-0216",
          "077-0215",
          "077-0206",
          "077-0202",
          "077-0133",
          "077-0207",
          "077-0213",
          "077-0214",
          "077-0217",
          "077-0205",
          "077-0221",
          "077-0223",
          "077-0225",
          "077-0224",
          "077-0222",
          "077-0208",
          "078-3300",
          "078-3302",
          "078-3457",
          "078-3309",
          "078-3452",
          "078-3442",
          "078-3456",
          "078-3451",
          "078-3455",
          "078-3454",
          "078-3441",
          "078-3453",
          "078-3301",
          "077-0461",
          "078-3306",
          "078-3308",
          "077-0464",
          "078-3305",
          "077-0462",
          "077-0463",
          "078-3312",
          "078-3307",
          "078-3303",
          "077-0465",
          "078-3311",
          "078-3313",
          "077-0466",
          "078-3304",
          "078-3700",
          "078-3711",
          "078-3634",
          "078-3712",
          "078-3713",
          "078-3631",
          "078-3714",
          "078-3636",
          "078-3633",
          "078-3637",
          "078-3621",
          "078-3702",
          "078-3638",
          "078-3715",
          "078-3701",
          "078-3716",
          "078-3632",
          "078-3635",
          "078-3717",
          "078-3541",
          "078-4100",
          "078-4144",
          "078-4117",
          "078-4142",
          "078-4134",
          "078-4110",
          "078-4119",
          "078-4111",
          "078-4112",
          "078-4113",
          "078-4114",
          "078-4115",
          "078-4116",
          "078-4131",
          "078-4121",
          "078-4123",
          "078-4140",
          "078-4133",
          "078-4143",
          "078-4141",
          "078-4145",
          "078-4132",
          "078-3951",
          "078-3953",
          "078-3952",
          "078-3955",
          "078-3954",
          "078-4118",
          "078-4130",
          "078-4120",
          "078-4108",
          "078-4122",
          "078-4101",
          "078-4102",
          "078-4103",
          "078-4104",
          "078-4105",
          "078-4106",
          "078-4107",
          "078-3871",
          "078-4400",
          "078-4432",
          "078-4411",
          "078-4433",
          "078-4412",
          "078-4421",
          "078-4422",
          "078-4431",
          "098-3500",
          "098-3531",
          "098-3532",
          "098-3533",
          "098-3361",
          "098-3501",
          "098-3541",
          "098-3511",
          "098-3521",
          "098-3502",
          "098-3503",
          "098-3542",
          "098-3522",
          "098-3512",
          "098-3523",
          "098-3534",
          "098-3543",
          "098-3504",
          "098-3300",
          "098-3311",
          "098-3133",
          "098-3306",
          "098-3312",
          "098-3313",
          "098-3314",
          "098-3136",
          "098-3303",
          "098-3305",
          "098-3142",
          "098-3304",
          "098-3143",
          "098-3131",
          "098-3144",
          "098-3315",
          "098-3141",
          "098-3135",
          "098-3132",
          "098-3316",
          "098-3134",
          "098-3302",
          "098-3301",
          "098-6200",
          "098-6101",
          "098-6102",
          "098-6225",
          "098-6234",
          "098-6232",
          "098-6231",
          "098-6233",
          "098-6106",
          "098-6103",
          "098-6228",
          "098-6104",
          "098-6341",
          "098-6226",
          "098-6222",
          "098-6105",
          "098-5700",
          "098-5741",
          "098-5744",
          "098-5754",
          "098-5701",
          "098-5725",
          "098-5743",
          "098-5751",
          "098-5711",
          "098-5712",
          "098-5713",
          "098-5714",
          "098-5765",
          "098-5739",
          "098-5752",
          "098-5703",
          "098-5753",
          "098-5761",
          "098-5705",
          "098-5704",
          "098-5742",
          "098-5745",
          "098-5702",
          "098-5763",
          "098-5717",
          "098-5734",
          "098-5762",
          "098-5738",
          "098-5721",
          "098-5722",
          "098-5723",
          "098-5755",
          "098-5764",
          "098-5500",
          "098-5103",
          "098-5554",
          "098-5101",
          "098-5564",
          "098-5111",
          "098-5562",
          "098-5552",
          "098-5102",
          "098-5555",
          "098-5112",
          "098-5551",
          "098-5113",
          "098-5563",
          "098-5561",
          "098-5565",
          "098-5553",
          "098-5800",
          "098-5827",
          "098-5445",
          "098-5444",
          "098-5443",
          "098-5221",
          "098-5441",
          "098-5212",
          "098-5211",
          "098-5206",
          "098-5201",
          "098-5205",
          "098-5202",
          "098-5207",
          "098-5203",
          "098-5442",
          "098-5213",
          "098-5204",
          "098-5806",
          "098-5802",
          "098-5952",
          "098-5955",
          "098-5954",
          "098-5826",
          "098-5805",
          "098-5821",
          "098-5803",
          "098-5808",
          "098-5825",
          "098-5815",
          "098-5801",
          "098-5953",
          "098-5824",
          "098-5822",
          "098-5807",
          "098-5823",
          "098-5814",
          "098-5804",
          "098-5816",
          "098-5951",
          "098-4100",
          "098-4462",
          "098-4455",
          "098-4103",
          "098-4138",
          "098-4110",
          "098-4468",
          "098-4117",
          "098-4132",
          "098-4456",
          "098-4451",
          "098-4141",
          "098-4104",
          "098-4136",
          "098-4466",
          "098-4140",
          "098-4137",
          "098-4135",
          "098-4467",
          "098-4134",
          "098-4139",
          "098-4116",
          "098-4111",
          "098-4112",
          "098-4113",
          "098-4114",
          "098-4115",
          "098-4457",
          "098-4131",
          "098-4121",
          "098-4122",
          "098-4123",
          "098-4124",
          "098-4125",
          "098-4126",
          "098-4101",
          "098-4464",
          "098-4465",
          "098-4106",
          "098-4105",
          "098-4133",
          "098-4461",
          "098-4463",
          "098-4102",
          "098-4107",
          "097-1200",
          "097-1201",
          "097-1202",
          "097-1111",
          "097-0400",
          "097-0401",
          "097-0311",
          "097-0100",
          "097-0101",
          "097-0211",
          "098-3200",
          "098-3226",
          "098-2941",
          "098-3225",
          "098-3221",
          "098-3228",
          "098-2943",
          "098-2942",
          "098-3227",
          "098-3222",
          "098-3224",
          "098-3223",
          "098-3207",
          "098-3217",
          "098-3251",
          "098-3211",
          "098-3201",
          "098-3212",
          "098-3202",
          "098-3213",
          "098-3203",
          "098-3214",
          "098-3204",
          "098-3215",
          "098-3205",
          "098-3216",
          "098-3206",
          "092-0000",
          "092-0064",
          "092-0065",
          "092-0066",
          "092-0006",
          "092-0027",
          "092-0031",
          "092-0050",
          "092-0181",
          "092-0175",
          "092-0025",
          "092-0012",
          "092-0174",
          "092-0015",
          "092-0001",
          "092-0018",
          "092-0184",
          "092-0007",
          "092-0023",
          "092-0183",
          "092-0003",
          "092-0004",
          "092-0032",
          "092-0061",
          "092-0033",
          "092-0062",
          "092-0176",
          "092-0005",
          "092-0011",
          "092-0041",
          "092-0051",
          "092-0042",
          "092-0052",
          "092-0043",
          "092-0053",
          "092-0044",
          "092-0021",
          "092-0069",
          "092-0173",
          "092-0024",
          "092-0022",
          "092-0017",
          "092-0014",
          "092-0016",
          "092-0067",
          "092-0068",
          "092-0171",
          "092-0030",
          "092-0002",
          "092-0026",
          "092-0013",
          "092-0063",
          "092-0200",
          "092-0361",
          "092-0234",
          "092-0205",
          "092-0231",
          "092-0355",
          "092-0233",
          "092-0206",
          "092-0222",
          "092-0352",
          "092-0225",
          "092-0235",
          "092-0356",
          "092-0232",
          "092-0357",
          "092-0221",
          "092-0203",
          "092-0224",
          "092-0214",
          "092-0211",
          "092-0213",
          "092-0362",
          "092-0358",
          "092-0207",
          "092-0216",
          "092-0217",
          "092-0218",
          "092-0354",
          "092-0353",
          "092-0351",
          "092-0236",
          "092-0223",
          "092-0212",
          "092-0201",
          "092-0215",
          "099-4100",
          "099-4117",
          "099-4114",
          "099-4127",
          "099-4126",
          "099-4356",
          "099-4351",
          "099-4352",
          "099-4353",
          "099-4355",
          "099-4354",
          "099-4143",
          "099-4115",
          "099-4131",
          "099-4124",
          "099-4123",
          "099-4125",
          "099-4118",
          "099-4144",
          "099-4141",
          "099-4134",
          "099-4142",
          "099-4147",
          "099-4121",
          "099-4132",
          "099-4116",
          "099-4113",
          "099-4111",
          "099-4357",
          "099-4145",
          "099-4133",
          "099-4146",
          "099-4112",
          "099-4122",
          "099-4135",
          "099-4400",
          "099-4524",
          "099-4401",
          "099-4522",
          "099-4523",
          "099-4526",
          "099-4404",
          "099-4403",
          "099-4521",
          "099-4402",
          "099-4407",
          "099-4405",
          "099-4406",
          "099-4525",
          "099-3600",
          "099-3616",
          "099-3603",
          "099-3613",
          "099-3611",
          "099-3601",
          "099-3612",
          "099-3451",
          "099-3615",
          "099-3452",
          "099-3602",
          "099-3453",
          "099-3604",
          "099-3642",
          "099-3614",
          "099-3605",
          "099-3641",
          "099-3454",
          "099-1400",
          "099-1432",
          "099-1411",
          "099-1436",
          "099-1414",
          "099-1404",
          "099-1413",
          "099-1426",
          "099-1421",
          "099-1434",
          "099-1417",
          "099-1405",
          "099-1416",
          "099-1427",
          "099-1433",
          "099-1423",
          "099-1424",
          "099-1403",
          "099-1431",
          "099-1401",
          "099-1407",
          "099-1422",
          "099-1402",
          "099-1418",
          "099-1415",
          "099-1412",
          "099-1437",
          "099-1406",
          "099-1435",
          "099-1425",
          "099-1100",
          "099-1364",
          "099-1116",
          "099-1251",
          "099-1137",
          "099-1362",
          "099-1253",
          "099-1252",
          "099-1366",
          "099-1114",
          "099-1132",
          "099-1133",
          "099-1135",
          "099-1361",
          "099-1104",
          "099-1103",
          "099-1363",
          "099-1134",
          "099-1113",
          "099-1106",
          "099-1105",
          "099-1123",
          "099-1124",
          "099-1131",
          "099-1254",
          "099-1367",
          "099-1365",
          "099-1138",
          "099-1136",
          "099-1121",
          "099-1101",
          "099-1102",
          "099-1117",
          "099-1115",
          "099-1122",
          "099-1118",
          "099-1112",
          "093-0500",
          "091-0553",
          "093-0502",
          "091-0557",
          "093-0505",
          "091-0473",
          "091-0556",
          "093-0503",
          "091-0472",
          "091-0471",
          "093-0508",
          "091-0558",
          "093-0506",
          "091-0552",
          "091-0555",
          "093-0421",
          "093-0424",
          "093-0504",
          "093-0423",
          "093-0507",
          "091-0554",
          "093-0422",
          "093-0501",
          "091-0551",
          "093-0532",
          "099-0400",
          "099-0701",
          "099-0623",
          "099-0702",
          "099-0704",
          "099-0705",
          "099-0624",
          "099-0621",
          "099-0703",
          "099-0622",
          "099-0415",
          "099-0405",
          "099-0416",
          "099-0404",
          "099-0126",
          "099-0401",
          "099-0347",
          "099-0127",
          "099-0102",
          "099-0422",
          "099-0413",
          "099-0343",
          "099-0101",
          "099-0426",
          "099-0111",
          "099-0123",
          "099-0121",
          "099-0122",
          "099-0125",
          "099-0341",
          "099-0342",
          "099-0425",
          "099-0408",
          "099-0412",
          "099-0428",
          "099-0344",
          "099-0124",
          "099-0410",
          "099-0421",
          "099-0211",
          "099-0212",
          "099-0213",
          "099-0201",
          "099-0214",
          "099-0202",
          "099-0203",
          "099-0204",
          "099-0205",
          "099-0206",
          "099-0215",
          "099-0216",
          "099-0207",
          "099-0407",
          "099-0414",
          "099-0427",
          "099-0424",
          "099-0406",
          "099-0411",
          "099-0345",
          "099-0346",
          "099-0423",
          "099-0417",
          "099-0403",
          "099-0418",
          "099-0402",
          "099-6400",
          "099-6402",
          "099-6321",
          "099-6503",
          "093-0732",
          "099-6504",
          "099-6501",
          "099-6415",
          "099-6325",
          "099-6323",
          "099-6322",
          "093-0651",
          "099-6404",
          "099-6506",
          "093-0652",
          "099-6271",
          "099-6412",
          "099-6326",
          "099-6329",
          "099-6327",
          "099-6328",
          "099-6414",
          "093-0733",
          "093-0731",
          "099-6411",
          "093-0734",
          "093-0735",
          "099-6413",
          "099-6505",
          "099-6403",
          "099-6401",
          "099-6509",
          "099-6508",
          "099-6507",
          "099-6272",
          "099-5600",
          "099-5601",
          "099-5602",
          "099-5544",
          "099-5606",
          "099-5605",
          "099-5614",
          "099-5612",
          "099-5543",
          "099-5611",
          "099-5613",
          "099-5551",
          "099-5552",
          "099-5603",
          "099-5541",
          "099-5542",
          "099-5604",
          "099-5553",
          "098-1600",
          "098-1621",
          "098-1624",
          "098-1607",
          "098-1604",
          "098-1614",
          "098-1606",
          "098-1612",
          "098-1613",
          "098-1615",
          "098-1602",
          "098-1603",
          "098-1616",
          "098-1605",
          "098-1623",
          "098-1601",
          "098-1611",
          "098-1941",
          "098-1943",
          "098-1942",
          "098-1944",
          "098-1622",
          "098-1500",
          "098-1424",
          "098-1504",
          "098-1421",
          "098-1505",
          "098-1423",
          "098-1422",
          "098-1503",
          "098-1506",
          "098-1501",
          "098-1502",
          "098-1700",
          "098-1702",
          "098-1707",
          "098-1704",
          "098-1708",
          "098-1701",
          "098-1821",
          "098-1703",
          "098-1706",
          "098-1705",
          "099-2300",
          "099-3222",
          "099-3232",
          "099-3221",
          "099-3231",
          "099-3202",
          "099-3234",
          "099-3224",
          "099-3243",
          "099-3225",
          "099-3233",
          "099-3211",
          "099-3212",
          "099-3213",
          "099-3201",
          "099-3223",
          "099-3214",
          "099-3244",
          "099-2362",
          "099-2382",
          "099-2304",
          "099-2351",
          "099-2361",
          "099-2306",
          "099-2356",
          "099-2302",
          "099-2381",
          "099-2372",
          "099-2371",
          "099-2354",
          "099-2305",
          "099-2373",
          "099-2303",
          "099-2321",
          "099-2322",
          "099-2323",
          "099-2324",
          "099-2325",
          "099-2326",
          "099-2327",
          "099-2383",
          "099-2311",
          "099-2312",
          "099-2301",
          "099-2310",
          "099-2355",
          "049-5400",
          "049-5412",
          "049-5332",
          "049-5413",
          "049-5407",
          "049-5414",
          "049-5404",
          "049-5411",
          "049-5408",
          "049-5406",
          "049-5405",
          "049-5331",
          "049-5415",
          "049-5416",
          "049-5403",
          "049-5402",
          "049-5401",
          "049-5333",
          "052-0100",
          "052-0111",
          "052-0112",
          "052-0114",
          "052-0102",
          "052-0103",
          "052-0101",
          "052-0106",
          "049-5731",
          "052-0107",
          "052-0105",
          "052-0113",
          "052-0104",
          "052-0115",
          "052-0116",
          "059-0900",
          "059-0921",
          "059-0905",
          "059-0915",
          "059-0923",
          "059-0641",
          "059-0914",
          "059-0901",
          "059-0912",
          "059-0907",
          "059-0916",
          "059-0642",
          "059-0922",
          "059-0904",
          "059-0903",
          "059-0906",
          "059-0908",
          "059-0913",
          "059-0911",
          "059-0902",
          "059-1600",
          "059-1606",
          "059-1746",
          "059-1622",
          "059-1602",
          "059-1741",
          "059-1752",
          "059-1744",
          "059-1601",
          "059-1743",
          "059-1749",
          "059-1751",
          "059-1748",
          "059-1612",
          "059-1754",
          "059-1623",
          "059-1615",
          "059-1621",
          "059-1614",
          "059-1747",
          "059-1753",
          "059-1745",
          "059-1624",
          "059-1604",
          "059-1742",
          "059-1611",
          "059-1616",
          "059-1605",
          "059-1603",
          "059-1625",
          "059-1613",
          "049-5600",
          "049-5601",
          "049-5801",
          "049-5611",
          "049-5602",
          "049-5603",
          "049-5811",
          "049-5612",
          "049-5821",
          "049-5831",
          "049-5812",
          "049-5604",
          "049-5722",
          "049-5613",
          "049-5605",
          "049-5813",
          "049-5723",
          "049-5721",
          "049-5802",
          "049-5822",
          "049-5832",
          "049-5724",
          "049-5614",
          "049-5814",
          "049-5833",
          "049-5615",
          "049-5616",
          "059-1500",
          "059-1511",
          "059-1941",
          "059-1983",
          "059-1921",
          "059-1985",
          "059-1984",
          "059-1942",
          "059-1931",
          "059-1961",
          "059-1987",
          "059-1911",
          "059-1982",
          "059-1971",
          "059-1986",
          "059-1951",
          "059-1433",
          "059-1501",
          "059-1506",
          "059-1432",
          "059-1505",
          "059-1431",
          "059-1434",
          "059-1502",
          "059-1512",
          "059-1513",
          "059-1504",
          "059-1503",
          "054-0000",
          "054-0031",
          "054-0001",
          "054-0011",
          "054-0012",
          "054-0021",
          "054-0002",
          "054-0063",
          "054-0015",
          "054-0023",
          "054-0052",
          "054-0004",
          "054-0003",
          "054-0005",
          "054-0013",
          "054-0022",
          "054-0064",
          "054-0032",
          "054-0051",
          "054-0211",
          "054-0362",
          "054-0143",
          "054-0201",
          "054-0202",
          "054-0141",
          "054-0364",
          "054-0203",
          "054-0144",
          "054-0142",
          "054-0204",
          "054-0363",
          "054-0361",
          "054-0041",
          "054-0016",
          "054-0042",
          "054-0061",
          "054-0014",
          "054-0062",
          "055-0000",
          "059-2127",
          "059-2243",
          "059-2123",
          "059-2244",
          "059-2245",
          "059-2124",
          "055-2303",
          "055-2304",
          "059-2331",
          "055-2305",
          "055-2314",
          "055-2315",
          "055-0001",
          "055-0008",
          "055-0007",
          "055-0004",
          "055-0006",
          "055-0005",
          "059-2126",
          "059-2241",
          "055-2311",
          "055-2312",
          "055-2313",
          "055-0002",
          "059-2125",
          "055-0003",
          "055-2301",
          "055-2302",
          "055-2307",
          "055-2316",
          "059-2122",
          "059-2242",
          "055-2306",
          "059-2332",
          "059-2121",
          "055-2308",
          "055-2309",
          "055-0100",
          "055-0322",
          "055-0414",
          "055-0325",
          "055-0103",
          "055-0102",
          "055-0105",
          "055-0104",
          "055-0415",
          "055-0324",
          "055-0413",
          "055-0106",
          "055-0101",
          "055-0321",
          "055-0411",
          "055-0412",
          "055-0107",
          "055-0323",
          "059-2400",
          "059-2414",
          "059-2404",
          "059-2423",
          "059-2422",
          "059-2253",
          "059-2411",
          "059-2427",
          "059-2251",
          "059-2424",
          "059-2341",
          "059-2412",
          "059-2343",
          "059-2413",
          "059-2402",
          "059-2418",
          "059-2426",
          "059-2344",
          "059-2252",
          "059-2417",
          "059-2416",
          "059-2403",
          "059-2401",
          "059-2415",
          "059-2425",
          "059-2342",
          "059-2421",
          "057-0000",
          "057-0011",
          "059-3463",
          "057-0035",
          "057-0014",
          "057-0036",
          "057-0013",
          "059-3451",
          "057-0173",
          "057-0174",
          "057-0027",
          "057-0172",
          "057-0033",
          "057-0034",
          "057-0023",
          "057-0021",
          "057-0022",
          "057-0003",
          "057-0004",
          "057-0024",
          "059-3461",
          "057-0012",
          "059-3462",
          "057-0171",
          "057-0002",
          "059-3454",
          "057-0015",
          "057-0005",
          "057-0006",
          "057-0007",
          "057-0001",
          "058-0041",
          "059-3453",
          "057-0025",
          "057-0031",
          "057-0032",
          "057-0026",
          "058-0000",
          "058-0001",
          "058-0012",
          "058-0033",
          "058-0014",
          "058-0022",
          "058-0024",
          "058-0023",
          "058-0027",
          "058-0021",
          "058-0011",
          "058-0015",
          "058-0031",
          "058-0032",
          "058-0004",
          "058-0003",
          "058-0002",
          "058-0026",
          "058-0013",
          "058-0025",
          "058-0200",
          "058-0202",
          "058-0342",
          "058-0421",
          "058-0203",
          "058-0207",
          "058-0343",
          "058-0201",
          "058-0341",
          "058-0206",
          "058-0204",
          "058-0422",
          "058-0205",
          "056-0000",
          "056-0019",
          "056-0003",
          "056-0013",
          "059-2562",
          "056-0015",
          "056-0028",
          "056-0002",
          "059-2563",
          "056-0025",
          "056-0005",
          "056-0027",
          "056-0007",
          "056-0026",
          "056-0022",
          "056-0146",
          "056-0144",
          "059-2566",
          "056-0023",
          "056-0143",
          "056-0006",
          "059-2564",
          "056-0142",
          "056-0021",
          "059-2565",
          "056-0014",
          "056-0016",
          "056-0011",
          "056-0141",
          "056-0004",
          "056-0017",
          "056-0145",
          "056-0001",
          "056-0024",
          "056-0018",
          "059-2561",
          "059-3107",
          "059-3352",
          "059-3351",
          "059-3354",
          "059-3353",
          "059-3233",
          "059-3111",
          "059-3101",
          "059-3103",
          "059-2571",
          "059-3106",
          "059-3105",
          "059-3102",
          "059-3104",
          "059-3231",
          "059-3108",
          "059-3355",
          "059-3112",
          "059-3232",
          "080-0100",
          "080-0101",
          "080-0102",
          "080-0271",
          "080-0341",
          "080-0575",
          "080-0306",
          "080-0305",
          "080-0111",
          "080-0301",
          "080-0303",
          "080-0304",
          "080-0302",
          "080-0112",
          "080-0335",
          "080-0315",
          "080-0314",
          "080-0571",
          "080-0564",
          "080-0572",
          "080-0563",
          "080-0565",
          "080-0566",
          "080-0567",
          "080-0568",
          "080-0574",
          "080-0573",
          "080-0321",
          "080-0322",
          "080-0351",
          "080-0342",
          "080-0272",
          "080-0104",
          "080-0105",
          "080-0313",
          "080-0361",
          "080-0362",
          "080-0363",
          "080-0323",
          "080-0345",
          "080-0151",
          "080-0261",
          "080-0263",
          "080-0262",
          "080-0561",
          "080-0578",
          "080-0309",
          "080-0308",
          "080-0307",
          "080-0577",
          "080-0325",
          "080-0562",
          "080-0343",
          "080-0106",
          "080-0162",
          "080-0161",
          "080-0163",
          "080-0137",
          "080-0138",
          "080-0141",
          "080-0142",
          "080-0143",
          "080-0144",
          "080-0145",
          "080-0146",
          "080-0135",
          "080-0132",
          "080-0136",
          "080-0133",
          "080-0139",
          "080-0134",
          "080-0131",
          "080-0326",
          "080-0327",
          "080-0344",
          "080-0334",
          "080-0312",
          "080-0311",
          "080-0324",
          "080-0576",
          "080-0103",
          "080-0121",
          "080-0122",
          "080-0123",
          "080-0330",
          "080-0332",
          "080-0333",
          "080-0331",
          "080-0317",
          "080-0318",
          "080-0316",
          "080-1200",
          "080-1203",
          "080-1278",
          "080-1223",
          "080-1226",
          "080-1286",
          "080-1244",
          "080-1248",
          "080-1288",
          "080-1274",
          "080-1245",
          "080-1189",
          "080-1267",
          "080-1284",
          "080-1216",
          "080-1221",
          "080-1275",
          "080-1256",
          "080-1253",
          "080-1246",
          "080-1254",
          "080-1285",
          "080-1265",
          "080-1222",
          "080-1255",
          "080-1251",
          "080-1213",
          "080-1283",
          "080-1227",
          "080-1281",
          "080-1262",
          "080-1273",
          "080-1215",
          "080-1243",
          "080-1241",
          "080-1271",
          "080-1261",
          "080-1264",
          "080-1266",
          "080-1276",
          "080-1277",
          "080-1224",
          "080-1272",
          "080-1257",
          "080-1202",
          "080-1201",
          "080-1247",
          "080-1252",
          "080-1287",
          "080-1214",
          "080-1204",
          "080-1242",
          "080-1236",
          "080-1225",
          "080-1234",
          "080-1231",
          "080-1232",
          "080-1233",
          "080-1282",
          "080-1263",
          "080-1235",
          "080-1217",
          "080-1211",
          "080-1212",
          "080-1400",
          "080-1406",
          "080-1407",
          "080-1408",
          "080-1404",
          "080-1405",
          "080-1403",
          "080-1402",
          "080-1401",
          "081-0200",
          "081-0212",
          "081-0342",
          "081-0341",
          "081-0343",
          "081-0225",
          "081-0218",
          "081-0226",
          "081-0344",
          "081-0214",
          "081-0202",
          "081-0221",
          "081-0204",
          "081-0217",
          "081-0215",
          "081-0216",
          "081-0201",
          "081-0345",
          "081-0211",
          "081-0205",
          "081-0213",
          "081-0346",
          "081-0222",
          "081-0228",
          "081-0227",
          "081-0203",
          "081-0223",
          "081-0224",
          "081-0000",
          "081-0035",
          "081-0154",
          "081-0151",
          "081-0152",
          "081-0161",
          "081-0162",
          "081-0155",
          "081-0156",
          "081-0163",
          "081-0164",
          "081-0153",
          "081-0006",
          "081-0036",
          "081-0038",
          "081-0037",
          "081-0039",
          "081-0031",
          "081-0021",
          "081-0032",
          "081-0022",
          "081-0033",
          "081-0023",
          "081-0034",
          "081-0008",
          "081-0005",
          "081-0007",
          "081-0011",
          "081-0001",
          "081-0012",
          "081-0002",
          "081-0013",
          "081-0003",
          "081-0014",
          "081-0015",
          "089-0100",
          "089-0355",
          "089-0243",
          "089-0135",
          "089-0134",
          "089-0133",
          "089-0132",
          "089-0131",
          "089-0124",
          "089-0123",
          "089-0122",
          "089-0121",
          "089-0241",
          "089-0103",
          "089-0102",
          "089-0356",
          "089-0101",
          "089-0242",
          "089-0136",
          "089-0125",
          "089-0357",
          "089-0351",
          "089-0352",
          "089-0353",
          "089-0371",
          "089-0372",
          "089-0373",
          "089-0374",
          "089-0375",
          "089-0376",
          "089-0377",
          "089-0378",
          "089-0361",
          "089-0362",
          "089-0363",
          "089-0354",
          "089-0137",
          "089-0138",
          "089-0111",
          "089-0112",
          "089-0113",
          "089-0114",
          "089-0115",
          "089-0116",
          "089-0117",
          "089-0118",
          "089-0126",
          "089-0127",
          "089-0104",
          "089-0105",
          "089-0106",
          "089-0107",
          "082-0000",
          "082-0382",
          "082-0384",
          "082-0381",
          "082-0085",
          "082-0084",
          "082-0087",
          "082-0077",
          "082-0082",
          "082-0072",
          "082-0007",
          "082-0008",
          "082-0074",
          "082-0075",
          "082-0385",
          "082-0078",
          "082-0010",
          "082-0009",
          "082-0079",
          "082-0071",
          "082-0081",
          "082-0086",
          "082-0073",
          "082-0083",
          "082-0003",
          "082-0031",
          "082-0032",
          "082-0033",
          "082-0034",
          "082-0035",
          "082-0036",
          "082-0037",
          "082-0038",
          "082-0039",
          "082-0040",
          "082-0041",
          "082-0061",
          "082-0062",
          "082-0063",
          "082-0064",
          "082-0801",
          "082-0811",
          "082-0802",
          "082-0812",
          "082-0803",
          "082-0813",
          "082-0005",
          "082-0006",
          "082-0004",
          "082-0011",
          "082-0012",
          "082-0013",
          "082-0014",
          "082-0015",
          "082-0016",
          "082-0017",
          "082-0018",
          "082-0019",
          "082-0020",
          "082-0021",
          "082-0022",
          "082-0051",
          "082-0052",
          "082-0053",
          "082-0054",
          "082-0056",
          "082-0057",
          "082-0076",
          "082-0383",
          "082-0001",
          "082-0002",
          "082-0030",
          "082-0060",
          "082-0043",
          "082-0044",
          "082-0042",
          "089-1300",
          "089-1330",
          "089-1310",
          "089-1371",
          "089-1364",
          "089-1365",
          "089-1363",
          "089-1366",
          "089-1354",
          "089-1355",
          "089-1362",
          "089-1367",
          "089-1325",
          "089-1313",
          "089-1352",
          "089-1356",
          "089-1353",
          "089-1331",
          "089-1311",
          "089-1332",
          "089-1312",
          "089-1351",
          "089-1341",
          "089-1321",
          "089-1342",
          "089-1322",
          "089-1343",
          "089-1323",
          "089-1344",
          "089-1324",
          "089-1345",
          "089-1374",
          "089-1368",
          "089-1372",
          "089-1373",
          "089-1361",
          "089-1500",
          "089-1531",
          "089-1551",
          "089-1571",
          "089-1511",
          "089-1581",
          "089-1583",
          "089-1561",
          "089-1582",
          "089-1572",
          "089-1541",
          "089-1573",
          "089-1542",
          "089-1562",
          "089-1543",
          "089-1501",
          "089-1552",
          "089-1512",
          "089-1521",
          "089-1502",
          "089-1553",
          "089-1513",
          "089-1532",
          "089-1563",
          "089-1522",
          "089-2100",
          "089-2262",
          "089-2145",
          "089-2121",
          "089-2125",
          "089-2261",
          "089-2126",
          "089-2147",
          "089-2138",
          "089-2103",
          "089-2123",
          "089-2111",
          "089-2137",
          "089-2151",
          "089-2117",
          "089-2271",
          "089-2272",
          "089-2146",
          "089-2154",
          "089-2140",
          "089-2106",
          "089-2114",
          "089-2136",
          "089-1881",
          "089-2105",
          "089-2273",
          "089-2263",
          "089-2101",
          "089-2122",
          "089-2104",
          "089-2133",
          "089-2152",
          "089-2116",
          "089-1882",
          "089-2134",
          "089-2124",
          "089-2115",
          "089-2132",
          "089-2127",
          "089-2107",
          "089-2131",
          "089-2148",
          "089-2155",
          "089-2135",
          "089-2153",
          "089-2113",
          "089-2112",
          "089-2102",
          "089-2156",
          "089-2141",
          "089-2142",
          "089-2143",
          "089-2600",
          "089-2771",
          "089-2772",
          "089-2604",
          "089-2605",
          "089-2445",
          "089-2448",
          "089-2447",
          "089-2622",
          "089-2621",
          "089-2632",
          "089-2631",
          "089-2616",
          "089-2775",
          "089-2455",
          "089-2624",
          "089-2623",
          "089-2626",
          "089-2625",
          "089-2611",
          "089-2612",
          "089-2613",
          "089-2614",
          "089-2561",
          "089-2563",
          "089-2562",
          "089-2564",
          "089-2601",
          "089-2602",
          "089-2603",
          "089-2776",
          "089-2633",
          "089-2634",
          "089-2615",
          "089-2628",
          "089-2627",
          "089-2773",
          "089-2636",
          "089-2635",
          "089-2637",
          "089-2638",
          "089-2446",
          "089-2774",
          "089-0600",
          "089-0621",
          "089-0612",
          "089-0602",
          "089-0624",
          "089-0564",
          "089-0622",
          "089-0575",
          "089-0781",
          "089-0784",
          "089-0605",
          "089-0783",
          "089-0601",
          "089-0577",
          "089-0541",
          "089-0552",
          "089-0531",
          "089-0551",
          "089-0542",
          "089-0545",
          "089-0534",
          "089-0538",
          "089-0535",
          "089-0533",
          "089-0543",
          "089-0546",
          "089-0536",
          "089-0562",
          "089-0553",
          "089-0537",
          "089-0554",
          "089-0561",
          "089-0532",
          "089-0544",
          "089-0625",
          "089-0566",
          "089-0613",
          "089-0565",
          "089-0611",
          "089-0788",
          "089-0627",
          "089-0572",
          "089-0563",
          "089-0616",
          "089-1717",
          "089-1727",
          "089-1728",
          "089-1731",
          "089-1709",
          "089-1703",
          "089-1701",
          "089-1714",
          "089-1711",
          "089-1725",
          "089-1707",
          "089-1721",
          "089-1871",
          "089-1729",
          "089-1726",
          "089-1715",
          "089-1724",
          "089-1716",
          "089-1705",
          "089-0573",
          "089-0628",
          "089-0578",
          "089-0782",
          "089-0623",
          "089-0604",
          "089-0626",
          "089-0574",
          "089-0786",
          "089-0576",
          "089-0785",
          "089-0614",
          "089-0615",
          "089-0567",
          "089-0787",
          "089-0603",
          "089-0571",
          "083-0000",
          "083-0044",
          "083-0001",
          "083-0090",
          "083-0020",
          "089-3151",
          "083-0041",
          "083-0002",
          "083-0003",
          "083-0004",
          "083-0047",
          "089-3152",
          "089-3153",
          "083-0042",
          "083-0046",
          "089-3156",
          "083-0032",
          "083-0031",
          "083-0033",
          "083-0034",
          "083-0045",
          "083-0043",
          "083-0021",
          "083-0022",
          "083-0023",
          "089-3154",
          "083-0091",
          "083-0092",
          "089-3155",
          "089-5300",
          "089-5306",
          "089-5241",
          "089-5304",
          "089-5465",
          "089-5463",
          "089-5462",
          "089-5464",
          "089-5461",
          "089-5305",
          "089-5307",
          "089-5234",
          "089-5235",
          "089-5466",
          "089-5301",
          "089-5244",
          "089-5243",
          "089-5246",
          "089-5232",
          "089-5231",
          "089-5233",
          "089-5309",
          "089-5303",
          "089-5242",
          "089-5247",
          "089-5315",
          "089-5313",
          "089-5311",
          "089-5314",
          "089-5312",
          "089-5308",
          "089-5302",
          "089-5245",
          "089-3300",
          "089-3676",
          "089-3332",
          "089-3672",
          "089-3327",
          "089-3662",
          "089-3283",
          "089-3307",
          "089-3311",
          "089-3666",
          "089-3321",
          "089-3334",
          "089-3305",
          "089-3665",
          "089-3303",
          "089-3322",
          "089-3304",
          "089-3674",
          "089-3324",
          "089-3663",
          "089-3664",
          "089-3306",
          "089-3331",
          "089-3675",
          "089-3443",
          "089-3325",
          "089-3673",
          "089-3301",
          "089-3302",
          "089-3661",
          "089-3284",
          "089-3326",
          "089-3323",
          "089-3677",
          "089-3442",
          "089-3671",
          "089-3312",
          "089-3314",
          "089-3313",
          "089-3333",
          "089-3308",
          "089-3282",
          "089-3281",
          "089-3700",
          "089-3708",
          "089-3721",
          "089-3724",
          "089-4144",
          "089-4251",
          "089-4252",
          "089-3961",
          "089-3962",
          "089-4142",
          "089-4141",
          "089-3963",
          "089-3701",
          "089-3702",
          "089-3703",
          "089-3704",
          "089-3705",
          "089-3706",
          "089-3874",
          "089-3726",
          "089-3727",
          "089-3718",
          "089-3732",
          "089-3707",
          "089-4143",
          "089-3722",
          "089-3734",
          "089-3723",
          "089-3731",
          "089-3873",
          "089-3733",
          "089-3735",
          "089-3725",
          "089-3711",
          "089-3712",
          "089-3713",
          "089-3714",
          "089-3715",
          "089-3716",
          "089-3717",
          "089-3872",
          "089-3871",
          "089-3964",
          "089-3737",
          "089-3875",
          "089-3965",
          "089-3966",
          "089-3736",
          "089-4300",
          "089-4324",
          "089-4301",
          "089-4315",
          "089-4321",
          "089-4342",
          "089-4308",
          "089-4353",
          "089-4331",
          "089-4345",
          "089-4313",
          "089-4312",
          "089-4304",
          "089-4351",
          "089-4262",
          "089-4316",
          "089-4307",
          "089-4337",
          "089-4303",
          "089-4355",
          "089-4333",
          "089-4322",
          "089-4323",
          "089-4332",
          "089-4357",
          "089-4341",
          "089-4261",
          "089-4305",
          "089-4335",
          "089-4344",
          "089-4354",
          "089-4334",
          "089-4314",
          "089-4311",
          "089-4352",
          "089-4346",
          "089-4326",
          "089-4343",
          "089-4325",
          "089-4306",
          "089-4336",
          "089-4356",
          "089-4302",
          "089-5600",
          "089-5551",
          "089-3576",
          "089-5546",
          "089-5865",
          "089-5638",
          "089-5637",
          "089-5553",
          "089-3586",
          "089-5867",
          "089-5634",
          "089-3571",
          "089-3574",
          "089-5866",
          "089-3585",
          "089-3572",
          "089-5621",
          "089-5542",
          "089-3587",
          "089-5617",
          "089-3577",
          "089-5611",
          "089-5868",
          "089-5558",
          "089-5607",
          "089-5613",
          "089-5604",
          "089-5614",
          "089-5635",
          "089-5615",
          "089-5602",
          "089-5606",
          "089-5547",
          "089-5631",
          "089-5554",
          "089-5601",
          "089-5636",
          "089-5869",
          "088-0181",
          "089-5633",
          "089-5555",
          "089-5544",
          "089-5548",
          "089-3573",
          "089-5552",
          "089-5608",
          "089-5557",
          "089-5612",
          "089-5543",
          "089-5556",
          "089-3578",
          "089-5622",
          "089-5603",
          "089-3575",
          "089-5605",
          "089-5545",
          "089-5541",
          "089-5632",
          "088-0600",
          "088-0616",
          "085-2271",
          "088-2154",
          "088-2155",
          "088-0626",
          "088-0621",
          "088-2143",
          "088-0601",
          "088-0612",
          "088-0625",
          "088-0622",
          "088-0609",
          "088-0623",
          "088-0614",
          "085-2272",
          "085-2273",
          "088-0624",
          "088-0833",
          "088-0835",
          "088-0834",
          "088-0831",
          "088-0832",
          "088-0608",
          "088-2141",
          "088-0606",
          "088-0628",
          "088-0627",
          "088-2142",
          "088-2145",
          "088-2156",
          "088-0607",
          "088-0618",
          "088-0611",
          "088-2144",
          "088-2148",
          "088-2147",
          "088-2146",
          "088-2152",
          "088-0604",
          "088-0605",
          "088-0602",
          "088-0603",
          "088-0617",
          "088-2140",
          "088-2153",
          "088-0615",
          "088-2151",
          "088-0613",
          "088-2157",
          "088-1100",
          "088-1113",
          "088-1112",
          "088-1101",
          "088-1131",
          "088-1133",
          "088-1132",
          "088-1134",
          "088-1130",
          "088-1135",
          "088-1141",
          "088-1142",
          "088-1143",
          "088-1144",
          "088-1145",
          "088-1146",
          "088-1147",
          "088-1148",
          "088-1149",
          "088-1136",
          "088-0876",
          "088-1117",
          "088-0873",
          "088-0871",
          "088-1137",
          "088-0771",
          "088-1129",
          "088-1103",
          "088-1139",
          "088-1140",
          "088-1125",
          "088-1151",
          "088-1119",
          "088-1138",
          "088-1104",
          "088-1108",
          "088-1106",
          "088-1102",
          "088-1107",
          "088-0875",
          "088-1389",
          "088-1115",
          "088-0877",
          "088-1111",
          "088-1116",
          "088-1105",
          "088-1128",
          "088-1124",
          "088-0874",
          "088-1126",
          "088-1120",
          "088-0872",
          "088-0878",
          "088-1118",
          "088-1114",
          "088-1500",
          "088-1406",
          "088-1403",
          "088-1646",
          "088-1641",
          "088-1648",
          "088-1647",
          "088-1649",
          "088-1301",
          "088-1644",
          "088-1371",
          "088-1408",
          "088-1561",
          "088-1551",
          "088-1552",
          "088-1553",
          "088-1554",
          "088-1511",
          "088-1512",
          "088-1513",
          "088-1514",
          "088-1486",
          "086-0081",
          "088-1401",
          "088-1407",
          "088-1303",
          "088-1402",
          "088-1412",
          "088-1526",
          "088-1528",
          "088-1527",
          "088-1645",
          "088-1367",
          "088-1368",
          "088-1366",
          "088-1365",
          "088-1363",
          "088-1369",
          "088-1487",
          "088-1361",
          "088-1362",
          "088-1364",
          "088-1360",
          "088-1522",
          "088-1571",
          "088-1531",
          "088-1370",
          "088-1302",
          "088-1409",
          "088-1485",
          "088-1536",
          "088-1532",
          "088-1525",
          "088-1524",
          "088-1405",
          "088-1537",
          "088-1404",
          "088-1643",
          "088-1538",
          "088-1535",
          "088-1304",
          "088-1306",
          "088-1534",
          "088-2300",
          "088-2301",
          "088-2305",
          "088-2271",
          "088-2272",
          "088-3157",
          "088-3149",
          "088-3151",
          "088-3152",
          "088-3153",
          "088-3147",
          "088-3146",
          "088-3143",
          "088-3155",
          "088-3148",
          "088-3156",
          "088-2262",
          "088-2331",
          "088-2311",
          "088-3142",
          "088-2333",
          "088-2339",
          "088-2321",
          "088-2266",
          "088-2312",
          "088-2275",
          "088-2337",
          "088-2380",
          "088-3145",
          "088-2334",
          "088-2335",
          "088-2388",
          "088-3154",
          "088-2303",
          "088-2314",
          "088-2323",
          "088-2265",
          "088-2273",
          "088-3141",
          "088-2261",
          "088-2264",
          "088-2313",
          "088-2332",
          "088-2382",
          "088-2381",
          "088-3144",
          "088-2322",
          "088-2462",
          "088-2463",
          "088-2464",
          "088-2465",
          "088-2461",
          "088-2389",
          "088-2263",
          "088-2274",
          "088-2302",
          "088-2304",
          "088-2338",
          "088-2324",
          "088-2336",
          "088-3200",
          "088-3204",
          "088-3463",
          "088-3461",
          "088-3351",
          "088-3212",
          "088-3226",
          "088-3228",
          "088-3227",
          "088-3462",
          "088-3465",
          "088-3341",
          "088-3214",
          "088-3213",
          "088-3332",
          "088-3464",
          "088-3202",
          "088-3211",
          "088-3222",
          "088-3221",
          "088-3223",
          "088-3331",
          "088-3224",
          "088-3201",
          "088-3215",
          "088-3271",
          "088-3225",
          "088-3203",
          "085-1200",
          "085-1146",
          "085-1145",
          "085-1132",
          "085-1212",
          "085-1133",
          "085-1262",
          "085-1211",
          "085-1144",
          "085-1131",
          "085-1206",
          "085-1203",
          "085-1204",
          "085-1201",
          "085-1261",
          "085-1207",
          "085-1202",
          "085-1205",
          "085-1143",
          "085-1147",
          "085-1142",
          "085-1141",
          "085-1213",
          "085-1134",
          "088-0300",
          "088-0585",
          "088-0353",
          "088-0341",
          "088-0561",
          "088-0342",
          "088-0583",
          "088-0343",
          "088-0352",
          "088-0351",
          "088-0562",
          "088-0569",
          "088-0305",
          "088-0567",
          "088-0566",
          "088-0564",
          "088-0565",
          "088-0563",
          "088-0568",
          "088-0586",
          "088-0587",
          "088-0560",
          "088-0581",
          "088-0584",
          "088-0582",
          "088-0572",
          "088-0571",
          "088-0574",
          "088-0573",
          "088-0575",
          "088-0311",
          "088-0321",
          "088-0312",
          "088-0322",
          "088-0325",
          "088-0323",
          "088-0324",
          "088-0326",
          "088-0301",
          "088-0331",
          "088-0302",
          "088-0332",
          "088-0303",
          "088-0333",
          "088-0344",
          "088-0304",
          "086-0200",
          "088-2578",
          "086-0213",
          "086-1641",
          "086-1644",
          "086-1642",
          "086-1643",
          "088-2725",
          "088-2722",
          "088-2724",
          "088-2721",
          "088-2723",
          "086-0131",
          "088-2601",
          "086-0655",
          "086-0521",
          "086-0657",
          "086-0654",
          "086-0653",
          "086-0651",
          "086-0652",
          "086-0345",
          "086-0342",
          "086-0343",
          "086-0344",
          "086-0341",
          "088-2576",
          "088-2566",
          "088-2561",
          "088-2565",
          "088-2562",
          "088-2563",
          "088-2564",
          "088-2572",
          "088-2571",
          "088-2574",
          "088-2573",
          "088-2575",
          "086-1645",
          "086-0523",
          "086-0216",
          "086-0202",
          "086-0215",
          "086-0211",
          "086-0204",
          "086-0212",
          "086-0205",
          "086-0203",
          "086-0214",
          "086-0201",
          "088-2602",
          "086-0522",
          "086-0656",
          "088-2577",
          "086-0346",
          "086-1100",
          "086-1159",
          "086-1135",
          "086-1142",
          "086-1141",
          "086-1272",
          "088-2683",
          "086-1151",
          "086-1145",
          "086-1152",
          "086-1147",
          "086-1136",
          "088-2682",
          "086-1153",
          "086-1137",
          "088-2681",
          "086-1143",
          "086-1139",
          "086-1156",
          "088-2685",
          "086-1157",
          "086-1101",
          "086-1121",
          "086-1102",
          "086-1122",
          "086-1103",
          "086-1123",
          "086-1104",
          "086-1124",
          "086-1105",
          "086-1125",
          "086-1106",
          "086-1126",
          "086-1107",
          "086-1127",
          "086-1108",
          "086-1128",
          "086-1109",
          "086-1129",
          "086-1110",
          "086-1130",
          "086-1111",
          "086-1131",
          "086-1112",
          "086-1132",
          "086-1133",
          "086-1134",
          "086-1001",
          "086-1041",
          "086-1002",
          "086-1042",
          "086-1003",
          "086-1043",
          "086-1004",
          "086-1044",
          "086-1005",
          "086-1045",
          "086-1006",
          "086-1046",
          "086-1007",
          "086-1047",
          "086-1008",
          "086-1048",
          "086-1009",
          "086-1049",
          "086-1010",
          "086-1050",
          "086-1011",
          "086-1051",
          "086-1012",
          "086-1052",
          "086-1013",
          "086-1053",
          "086-1014",
          "086-1054",
          "086-1015",
          "086-1055",
          "086-1016",
          "086-1056",
          "086-1017",
          "086-1057",
          "086-1018",
          "086-1058",
          "086-1019",
          "086-1059",
          "086-1020",
          "086-1060",
          "086-1021",
          "086-1061",
          "086-1022",
          "086-1062",
          "086-1023",
          "086-1063",
          "086-1024",
          "086-1064",
          "086-1025",
          "086-1065",
          "086-1026",
          "086-1066",
          "086-1027",
          "086-1067",
          "086-1028",
          "086-1068",
          "086-1029",
          "086-1069",
          "086-1030",
          "086-1070",
          "086-1031",
          "086-1071",
          "086-1032",
          "086-1072",
          "086-1033",
          "086-1073",
          "086-1034",
          "086-1074",
          "086-1035",
          "086-1075",
          "086-1036",
          "086-1076",
          "086-1037",
          "086-1077",
          "086-1038",
          "086-1078",
          "086-1039",
          "086-1079",
          "086-1080",
          "086-1081",
          "086-1082",
          "086-1144",
          "086-1083",
          "086-1163",
          "088-2686",
          "086-1273",
          "086-1164",
          "086-1148",
          "086-1166",
          "086-1165",
          "086-1150",
          "086-1146",
          "086-1271",
          "088-2684",
          "086-1160",
          "086-1600",
          "086-1602",
          "086-1451",
          "086-1631",
          "086-1632",
          "086-1633",
          "086-1634",
          "086-1635",
          "086-1636",
          "086-1637",
          "086-1638",
          "086-1639",
          "086-1630",
          "086-1732",
          "086-1731",
          "086-1733",
          "086-1622",
          "086-1625",
          "086-1621",
          "086-1623",
          "086-1626",
          "086-1601",
          "086-1651",
          "086-1652",
          "086-1653",
          "086-1654",
          "086-1655",
          "086-1656",
          "086-1657",
          "086-1658",
          "086-1800",
          "086-1806",
          "086-1842",
          "086-1815",
          "086-1843",
          "086-1804",
          "086-1813",
          "086-1816",
          "086-1805",
          "086-1812",
          "086-1823",
          "086-1801",
          "086-1811",
          "086-1802",
          "086-1836",
          "086-1831",
          "086-1803",
          "086-1832",
          "086-1844",
          "086-1752",
          "086-1833",
          "086-1835",
          "086-1814",
          "086-1821",
          "086-1751",
          "086-1841",
          "086-1822",
          "086-1834",
          "038-0000",
          "030-0846",
          "030-0811",
          "030-0956",
          "030-0851",
          "039-3501",
          "038-0056",
          "038-0059",
          "030-0111",
          "038-0003",
          "030-0922",
          "038-0043",
          "030-0136",
          "030-1262",
          "030-0932",
          "038-0051",
          "030-0842",
          "030-0141",
          "030-0155",
          "030-0852",
          "030-0144",
          "030-0123",
          "030-0914",
          "038-0041",
          "038-0002",
          "038-0054",
          "030-0841",
          "030-0143",
          "030-0137",
          "030-0821",
          "030-0902",
          "030-0844",
          "030-0853",
          "030-0145",
          "030-0855",
          "039-3502",
          "038-0013",
          "030-0935",
          "030-0918",
          "030-0134",
          "030-0943",
          "030-0153",
          "030-1272",
          "030-0954",
          "030-0953",
          "030-0955",
          "030-0915",
          "030-0903",
          "030-0945",
          "038-0032",
          "030-0942",
          "038-0031",
          "039-3506",
          "030-1261",
          "038-0011",
          "038-0052",
          "030-0941",
          "038-0042",
          "030-0801",
          "030-0135",
          "030-0933",
          "038-0055",
          "038-0015",
          "030-0854",
          "030-0113",
          "030-0931",
          "030-0151",
          "030-0924",
          "039-3524",
          "030-0124",
          "030-0916",
          "030-0904",
          "030-0822",
          "030-0925",
          "030-0958",
          "030-0962",
          "030-0911",
          "030-0944",
          "030-0812",
          "038-0045",
          "038-0046",
          "030-0934",
          "038-0004",
          "030-0952",
          "030-0951",
          "030-0131",
          "030-0861",
          "030-0963",
          "030-0961",
          "038-1321",
          "038-1313",
          "038-1325",
          "038-1324",
          "038-1343",
          "038-1312",
          "038-1345",
          "038-1332",
          "038-1341",
          "038-1305",
          "038-1301",
          "038-1304",
          "038-1342",
          "038-1303",
          "038-1302",
          "038-1311",
          "038-1306",
          "038-1322",
          "038-1323",
          "038-1333",
          "038-1331",
          "038-1344",
          "038-0022",
          "038-0024",
          "030-0856",
          "030-0948",
          "038-0014",
          "038-0057",
          "038-0001",
          "030-0154",
          "030-0142",
          "030-0152",
          "030-0122",
          "039-3503",
          "030-0823",
          "038-0058",
          "030-0966",
          "030-0843",
          "030-0947",
          "030-0919",
          "030-0921",
          "030-0847",
          "030-0913",
          "030-1273",
          "030-0862",
          "030-0946",
          "038-0023",
          "030-0957",
          "030-0802",
          "038-0053",
          "038-0044",
          "030-0813",
          "030-0965",
          "039-3507",
          "030-0845",
          "030-0901",
          "030-0964",
          "039-3505",
          "030-0121",
          "038-0006",
          "030-0937",
          "030-0133",
          "030-0912",
          "030-0917",
          "030-0803",
          "038-0021",
          "039-3504",
          "030-0936",
          "030-0112",
          "038-0012",
          "030-0923",
          "030-0132",
          "030-0125",
          "030-1271",
          "036-0000",
          "036-1516",
          "036-8246",
          "038-3615",
          "036-8062",
          "036-8279",
          "036-8264",
          "036-8252",
          "036-1302",
          "036-8364",
          "036-8124",
          "036-8316",
          "036-8164",
          "036-8134",
          "036-8201",
          "036-1325",
          "036-8097",
          "036-8073",
          "036-8023",
          "036-8002",
          "036-8003",
          "036-8132",
          "036-8104",
          "036-8346",
          "036-8311",
          "036-8071",
          "036-8125",
          "036-8161",
          "036-1513",
          "036-8175",
          "036-8242",
          "036-8247",
          "036-8004",
          "036-1203",
          "036-8133",
          "036-8034",
          "036-8033",
          "036-8197",
          "038-3613",
          "036-1205",
          "036-8096",
          "036-8191",
          "036-8383",
          "036-1204",
          "036-8152",
          "036-8204",
          "036-8192",
          "036-8335",
          "036-8052",
          "036-8111",
          "036-1332",
          "036-8013",
          "036-8354",
          "036-8207",
          "036-1504",
          "036-8221",
          "036-8332",
          "036-8022",
          "036-8114",
          "036-8103",
          "036-8277",
          "036-8226",
          "036-8061",
          "036-8227",
          "036-8194",
          "036-8012",
          "036-8213",
          "036-8151",
          "036-8031",
          "036-8046",
          "036-8251",
          "036-8163",
          "036-8245",
          "036-1303",
          "036-1433",
          "036-1321",
          "036-8345",
          "036-1502",
          "036-1434",
          "036-8005",
          "036-1431",
          "036-8123",
          "036-8127",
          "036-8243",
          "036-8362",
          "036-1503",
          "036-1331",
          "036-8331",
          "036-1322",
          "036-8366",
          "036-8361",
          "036-8216",
          "036-8076",
          "036-1511",
          "036-8336",
          "036-8244",
          "036-8016",
          "036-8211",
          "036-8241",
          "036-1441",
          "036-8222",
          "038-3612",
          "036-8342",
          "036-1514",
          "036-8312",
          "036-8341",
          "036-8102",
          "036-8206",
          "036-8261",
          "036-8217",
          "036-8183",
          "036-8254",
          "036-8262",
          "036-8113",
          "036-8353",
          "036-8356",
          "036-8265",
          "036-8266",
          "036-8228",
          "036-8275",
          "036-8095",
          "036-8093",
          "036-8092",
          "036-8232",
          "036-8193",
          "036-8214",
          "036-8215",
          "036-1342",
          "036-8085",
          "036-1506",
          "036-8187",
          "036-8072",
          "036-1515",
          "036-8001",
          "036-1344",
          "036-8091",
          "036-8271",
          "036-8302",
          "036-8084",
          "036-1312",
          "036-8018",
          "036-1324",
          "036-1432",
          "036-8234",
          "038-3614",
          "036-8054",
          "036-8055",
          "036-8041",
          "036-8131",
          "036-8044",
          "036-8074",
          "038-3874",
          "036-8374",
          "036-8036",
          "036-8086",
          "036-8319",
          "036-8196",
          "036-8263",
          "036-1345",
          "036-8032",
          "036-1201",
          "036-8381",
          "036-1202",
          "036-8182",
          "036-8094",
          "036-8317",
          "036-8382",
          "036-8186",
          "036-8173",
          "036-8174",
          "036-8101",
          "036-8154",
          "036-8171",
          "036-1333",
          "036-8075",
          "036-8015",
          "036-8313",
          "036-8155",
          "036-1451",
          "036-1452",
          "036-8385",
          "036-8344",
          "036-1206",
          "036-8212",
          "036-1304",
          "036-8083",
          "036-8017",
          "036-8225",
          "036-8273",
          "036-8065",
          "036-8365",
          "036-8122",
          "036-1334",
          "036-8301",
          "036-8056",
          "036-8045",
          "036-8334",
          "036-8057",
          "036-1301",
          "036-8323",
          "036-8324",
          "036-8325",
          "036-8144",
          "036-1453",
          "036-8064",
          "036-8343",
          "036-8043",
          "036-8278",
          "036-8276",
          "036-1343",
          "036-8035",
          "036-8351",
          "036-8367",
          "036-1442",
          "036-8115",
          "036-8081",
          "036-8082",
          "036-8363",
          "036-1512",
          "036-8373",
          "036-8326",
          "036-8143",
          "036-8223",
          "036-8315",
          "036-8224",
          "036-8375",
          "036-8112",
          "036-8203",
          "036-8303",
          "036-8371",
          "036-8314",
          "036-8042",
          "036-8126",
          "036-1323",
          "036-8141",
          "036-8142",
          "036-8184",
          "036-8357",
          "036-1505",
          "036-8153",
          "036-8253",
          "036-8024",
          "036-8006",
          "036-8195",
          "036-8014",
          "036-8274",
          "036-8172",
          "036-8272",
          "036-8025",
          "036-8026",
          "036-8231",
          "036-8051",
          "036-1341",
          "036-8063",
          "036-8384",
          "036-8185",
          "038-3611",
          "036-8066",
          "036-8202",
          "036-8355",
          "036-8352",
          "036-8198",
          "036-8372",
          "038-3821",
          "036-8205",
          "036-8121",
          "036-8318",
          "036-8162",
          "036-8321",
          "036-8233",
          "036-8011",
          "036-8181",
          "036-1361",
          "036-1314",
          "036-1501",
          "036-1311",
          "036-1435",
          "036-1313",
          "036-8188",
          "036-1443",
          "036-8053",
          "036-8333",
          "036-8255",
          "036-8087",
          "036-8368",
          "036-8021",
          "031-0000",
          "031-0804",
          "031-0824",
          "031-0055",
          "031-0013",
          "039-1165",
          "039-2241",
          "039-1102",
          "031-0054",
          "031-0088",
          "031-0075",
          "031-0073",
          "039-1108",
          "031-0833",
          "039-1121",
          "031-0081",
          "031-0053",
          "031-0037",
          "031-0843",
          "031-0057",
          "031-0058",
          "039-1161",
          "039-2246",
          "039-2245",
          "039-1114",
          "031-0007",
          "039-1107",
          "031-0083",
          "031-0801",
          "039-1160",
          "031-0802",
          "031-0023",
          "039-1106",
          "031-0834",
          "031-0841",
          "039-1167",
          "039-1164",
          "031-0085",
          "031-0042",
          "031-0043",
          "031-0084",
          "031-0082",
          "031-0047",
          "039-1101",
          "031-0821",
          "031-0832",
          "031-0822",
          "031-0072",
          "031-0056",
          "031-0811",
          "031-0803",
          "031-0036",
          "031-0034",
          "039-1163",
          "039-2242",
          "031-0011",
          "039-1104",
          "031-0831",
          "031-0021",
          "031-0087",
          "031-0051",
          "031-0035",
          "031-0012",
          "031-0039",
          "039-1109",
          "039-1162",
          "031-0002",
          "039-1103",
          "031-0077",
          "031-0089",
          "031-0115",
          "031-0113",
          "031-0111",
          "031-0112",
          "031-0201",
          "031-0202",
          "031-0114",
          "031-0813",
          "031-0816",
          "039-1113",
          "031-0041",
          "031-0044",
          "031-0022",
          "031-0071",
          "039-1166",
          "039-1168",
          "031-0074",
          "031-0031",
          "039-1111",
          "039-1169",
          "031-0003",
          "031-0076",
          "031-0046",
          "039-2243",
          "031-0815",
          "031-0842",
          "031-0032",
          "031-0823",
          "031-0812",
          "039-1112",
          "031-0004",
          "031-0844",
          "031-0814",
          "031-0033",
          "031-0052",
          "031-0045",
          "031-0038",
          "039-1105",
          "031-0086",
          "031-0001",
          "036-0300",
          "036-0516",
          "036-0325",
          "036-0537",
          "036-0321",
          "036-0376",
          "036-0373",
          "036-0343",
          "036-0302",
          "036-0342",
          "036-0374",
          "036-0404",
          "036-0307",
          "036-0301",
          "036-0318",
          "036-0354",
          "036-0306",
          "036-0366",
          "036-0385",
          "036-0401",
          "036-0384",
          "036-0402",
          "036-0357",
          "036-0353",
          "036-0305",
          "036-0337",
          "036-0363",
          "036-0338",
          "036-0323",
          "036-0538",
          "036-0415",
          "036-0386",
          "036-0523",
          "036-0541",
          "036-0362",
          "036-0316",
          "036-0381",
          "036-0303",
          "036-0351",
          "036-0352",
          "036-0304",
          "036-0344",
          "036-0315",
          "036-0511",
          "036-0513",
          "036-0512",
          "036-0335",
          "036-0389",
          "036-0333",
          "036-0382",
          "036-0336",
          "036-0539",
          "036-0414",
          "036-0312",
          "036-0521",
          "036-0317",
          "036-0535",
          "036-0322",
          "036-0534",
          "036-0522",
          "036-0356",
          "036-0308",
          "036-0531",
          "036-0532",
          "036-0514",
          "036-0341",
          "036-0345",
          "036-0377",
          "036-0365",
          "036-0388",
          "036-0372",
          "036-0507",
          "036-0403",
          "036-0533",
          "036-0411",
          "036-0542",
          "036-0326",
          "036-0331",
          "036-0371",
          "036-0413",
          "036-0503",
          "036-0504",
          "036-0506",
          "036-0505",
          "036-0502",
          "036-0378",
          "036-0334",
          "036-0324",
          "036-0501",
          "036-0412",
          "036-0355",
          "036-0515",
          "036-0332",
          "036-0367",
          "036-0313",
          "036-0517",
          "036-0536",
          "036-0314",
          "036-0524",
          "036-0383",
          "036-0405",
          "036-0339",
          "036-0387",
          "036-0364",
          "036-0361",
          "036-0368",
          "036-0311",
          "036-0375",
          "037-0000",
          "037-0401",
          "037-0613",
          "037-0062",
          "037-0052",
          "037-0002",
          "037-0057",
          "037-0065",
          "037-0005",
          "037-0404",
          "037-0093",
          "037-0014",
          "037-0074",
          "037-0042",
          "037-0015",
          "037-0022",
          "037-0017",
          "037-0402",
          "037-0063",
          "037-0092",
          "037-0055",
          "037-0202",
          "037-0204",
          "037-0201",
          "037-0206",
          "037-0203",
          "037-0205",
          "037-0208",
          "037-0207",
          "037-0011",
          "037-0033",
          "037-0054",
          "037-0611",
          "037-0004",
          "037-0032",
          "037-0072",
          "037-0094",
          "037-0632",
          "037-0076",
          "037-0046",
          "037-0095",
          "037-0067",
          "037-0001",
          "037-0064",
          "037-0403",
          "037-0045",
          "037-0081",
          "037-0083",
          "037-0056",
          "037-0084",
          "037-0087",
          "037-0086",
          "037-0091",
          "037-0082",
          "037-0041",
          "037-0623",
          "037-0036",
          "037-0088",
          "037-0075",
          "037-0601",
          "037-0621",
          "037-0021",
          "037-0066",
          "037-0097",
          "037-0068",
          "037-0025",
          "037-0058",
          "037-0053",
          "037-0614",
          "037-0085",
          "037-0043",
          "037-0641",
          "037-0622",
          "037-0096",
          "037-0016",
          "037-0061",
          "037-0023",
          "037-0003",
          "037-0612",
          "037-0071",
          "037-0631",
          "037-0006",
          "037-0602",
          "037-0012",
          "037-0024",
          "037-0035",
          "037-0089",
          "037-0642",
          "037-0044",
          "037-0034",
          "037-0073",
          "037-0051",
          "037-0013",
          "037-0069",
          "037-0405",
          "034-0000",
          "034-0071",
          "034-0005",
          "034-0011",
          "034-0101",
          "034-0041",
          "034-0102",
          "034-0211",
          "018-5501",
          "034-0301",
          "034-0061",
          "034-0302",
          "034-0001",
          "034-0213",
          "034-0103",
          "034-0051",
          "034-0104",
          "034-0092",
          "034-0082",
          "034-0083",
          "034-0084",
          "034-0085",
          "034-0038",
          "034-0091",
          "034-0093",
          "034-0081",
          "034-0088",
          "034-0087",
          "034-0086",
          "034-0095",
          "034-0094",
          "034-0089",
          "034-0105",
          "034-0012",
          "034-0017",
          "034-0031",
          "034-0032",
          "034-0033",
          "034-0036",
          "034-0013",
          "034-0016",
          "034-0023",
          "034-0024",
          "034-0034",
          "034-0035",
          "034-0014",
          "034-0015",
          "034-0021",
          "034-0022",
          "034-0004",
          "034-0106",
          "034-0052",
          "034-0303",
          "034-0037",
          "034-0107",
          "034-0212",
          "034-0002",
          "034-0003",
          "033-0000",
          "033-0166",
          "033-0101",
          "033-0153",
          "033-0131",
          "033-0134",
          "033-0041",
          "033-0021",
          "033-0104",
          "033-0053",
          "033-0063",
          "033-0162",
          "033-0011",
          "033-0042",
          "033-0031",
          "033-0155",
          "033-0113",
          "033-0103",
          "033-0133",
          "033-0023",
          "033-0062",
          "033-0105",
          "033-0102",
          "033-0165",
          "033-0001",
          "033-0043",
          "033-0163",
          "033-0167",
          "033-0061",
          "033-0024",
          "033-0034",
          "033-0154",
          "033-0012",
          "033-0152",
          "033-0051",
          "033-0044",
          "033-0112",
          "033-0123",
          "033-0052",
          "033-0143",
          "033-0037",
          "033-0035",
          "033-0142",
          "033-0022",
          "033-0032",
          "033-0141",
          "033-0036",
          "033-0151",
          "033-0033",
          "033-0111",
          "033-0045",
          "033-0164",
          "033-0161",
          "033-0132",
          "035-0000",
          "035-0044",
          "035-0076",
          "035-0079",
          "035-0092",
          "035-0054",
          "035-0074",
          "035-0083",
          "039-4401",
          "039-4402",
          "035-0042",
          "035-0096",
          "035-0086",
          "035-0084",
          "035-0085",
          "035-0093",
          "035-0011",
          "035-0041",
          "035-0072",
          "035-0032",
          "039-5204",
          "039-5304",
          "039-5203",
          "039-5202",
          "039-4701",
          "039-5201",
          "035-0091",
          "035-0036",
          "035-0071",
          "035-0094",
          "035-0061",
          "035-0067",
          "035-0095",
          "035-0052",
          "035-0051",
          "035-0022",
          "035-0021",
          "035-0034",
          "035-0073",
          "035-0055",
          "035-0012",
          "035-0062",
          "035-0081",
          "035-0082",
          "035-0035",
          "035-0075",
          "035-0045",
          "035-0078",
          "035-0065",
          "035-0068",
          "035-0066",
          "035-0053",
          "035-0064",
          "035-0043",
          "035-0046",
          "035-0031",
          "035-0077",
          "035-0033",
          "035-0063",
          "039-5345",
          "039-5344",
          "039-5326",
          "039-5335",
          "039-5337",
          "039-5346",
          "039-5333",
          "039-5321",
          "039-5343",
          "039-5342",
          "039-5341",
          "039-5323",
          "039-5332",
          "039-5322",
          "039-5336",
          "039-5325",
          "039-5324",
          "039-5334",
          "039-5327",
          "039-5331",
          "038-3100",
          "037-0102",
          "037-0101",
          "037-0109",
          "037-0104",
          "037-0106",
          "037-0107",
          "037-0105",
          "037-0103",
          "037-0108",
          "038-3305",
          "038-3107",
          "038-3103",
          "038-3104",
          "038-3101",
          "038-3102",
          "038-3106",
          "038-3105",
          "038-3142",
          "038-3144",
          "038-3124",
          "038-3113",
          "038-3273",
          "038-3141",
          "038-3135",
          "038-3162",
          "038-3122",
          "038-3277",
          "038-3285",
          "038-3272",
          "038-3284",
          "038-3112",
          "038-3165",
          "038-2806",
          "038-3286",
          "038-3159",
          "038-3146",
          "038-3164",
          "038-3132",
          "038-3287",
          "038-2803",
          "038-3133",
          "038-3283",
          "038-3134",
          "038-3131",
          "038-3167",
          "038-3145",
          "038-3278",
          "038-3125",
          "038-3288",
          "038-3154",
          "038-3282",
          "038-3111",
          "038-3275",
          "038-3163",
          "038-3114",
          "038-3161",
          "038-3153",
          "038-3139",
          "038-3136",
          "038-3115",
          "038-3276",
          "038-3121",
          "038-3143",
          "038-3281",
          "038-2808",
          "038-3166",
          "038-3158",
          "038-3152",
          "038-3123",
          "038-3155",
          "038-2801",
          "038-2804",
          "038-3156",
          "038-3157",
          "038-3126",
          "038-3128",
          "038-3127",
          "038-3271",
          "038-3274",
          "038-3151",
          "038-3138",
          "038-3137",
          "038-3304",
          "038-3306",
          "038-3303",
          "038-3301",
          "038-3302",
          "038-2818",
          "038-2811",
          "038-2812",
          "038-2817",
          "038-2814",
          "038-2813",
          "038-2816",
          "038-2815",
          "036-0100",
          "036-0112",
          "036-0121",
          "036-0213",
          "038-0101",
          "038-0102",
          "038-0103",
          "036-0151",
          "036-0152",
          "036-0145",
          "036-0141",
          "036-0171",
          "036-0122",
          "036-0222",
          "036-0212",
          "036-0104",
          "036-0202",
          "036-0232",
          "036-0132",
          "036-0173",
          "036-0172",
          "036-0102",
          "036-0153",
          "036-0111",
          "036-0242",
          "036-0161",
          "036-0201",
          "036-0101",
          "036-0146",
          "036-0211",
          "036-0142",
          "036-0155",
          "036-0162",
          "036-0221",
          "036-0163",
          "036-0115",
          "036-0223",
          "036-0231",
          "036-0243",
          "036-0144",
          "036-0233",
          "036-0113",
          "036-0131",
          "036-0143",
          "036-0114",
          "036-0164",
          "036-0165",
          "036-0203",
          "036-0103",
          "036-0241",
          "036-0154",
          "039-3300",
          "039-3312",
          "039-3364",
          "039-3382",
          "039-3352",
          "039-3343",
          "039-3342",
          "039-3321",
          "039-3332",
          "039-3302",
          "039-3351",
          "039-3353",
          "039-3372",
          "039-3371",
          "039-3373",
          "039-3313",
          "039-3331",
          "039-3303",
          "039-3301",
          "039-3315",
          "039-3311",
          "039-3361",
          "039-3362",
          "039-3333",
          "039-3381",
          "039-3314",
          "039-3341",
          "039-3363",
          "030-1500",
          "030-1502",
          "030-1505",
          "030-1512",
          "030-1515",
          "030-1514",
          "030-1504",
          "030-1501",
          "030-1513",
          "030-1503",
          "030-1511",
          "030-1200",
          "030-1212",
          "030-1203",
          "030-1202",
          "030-1214",
          "030-1213",
          "030-1201",
          "030-1211",
          "030-1400",
          "030-1309",
          "030-1303",
          "030-1301",
          "030-1307",
          "030-1305",
          "030-1311",
          "030-1302",
          "030-1304",
          "030-1306",
          "030-1308",
          "030-1402",
          "030-1405",
          "030-1416",
          "030-1413",
          "030-1411",
          "030-1412",
          "030-1415",
          "030-1403",
          "030-1404",
          "030-1732",
          "030-1719",
          "030-1724",
          "030-1722",
          "030-1717",
          "030-1712",
          "030-1711",
          "030-1727",
          "030-1720",
          "030-1729",
          "030-1716",
          "030-1733",
          "030-1728",
          "030-1718",
          "030-1715",
          "030-1737",
          "030-1714",
          "030-1725",
          "030-1731",
          "030-1721",
          "030-1734",
          "030-1735",
          "030-1723",
          "030-1736",
          "030-1713",
          "030-1726",
          "038-2700",
          "038-2731",
          "038-2714",
          "038-2742",
          "038-2735",
          "038-2724",
          "038-2701",
          "038-2754",
          "038-2722",
          "038-2703",
          "038-2745",
          "038-2702",
          "038-2733",
          "038-2751",
          "038-2725",
          "038-2743",
          "038-2711",
          "038-2712",
          "038-2752",
          "038-2741",
          "038-2715",
          "038-2732",
          "038-2723",
          "038-2721",
          "038-2746",
          "038-2753",
          "038-2761",
          "038-2713",
          "038-2705",
          "038-2734",
          "038-2704",
          "038-2747",
          "038-2744",
          "038-2300",
          "038-2502",
          "038-2202",
          "038-2413",
          "038-2208",
          "038-2411",
          "038-2323",
          "038-2504",
          "038-2207",
          "038-2201",
          "038-2203",
          "038-2503",
          "038-2505",
          "038-2322",
          "038-2326",
          "038-2412",
          "038-2204",
          "038-2321",
          "038-2324",
          "038-2327",
          "038-2206",
          "038-2205",
          "038-2501",
          "038-2325",
          "036-1400",
          "036-1422",
          "036-1424",
          "036-1414",
          "036-1412",
          "036-1423",
          "036-1413",
          "036-1411",
          "036-1421",
          "036-1415",
          "038-3800",
          "038-3837",
          "038-3833",
          "038-1203",
          "038-3804",
          "038-1206",
          "038-3812",
          "038-3805",
          "038-1216",
          "038-3836",
          "038-3835",
          "038-1214",
          "038-1213",
          "038-1202",
          "038-3811",
          "038-3831",
          "038-3803",
          "038-3834",
          "038-3806",
          "038-1211",
          "038-1201",
          "038-3801",
          "038-3802",
          "038-1207",
          "038-1204",
          "038-3814",
          "038-1212",
          "038-3813",
          "038-1205",
          "038-3832",
          "038-1215",
          "038-0200",
          "038-0233",
          "038-0211",
          "038-0204",
          "038-0212",
          "038-0203",
          "038-0241",
          "038-0223",
          "038-0231",
          "038-0202",
          "038-0201",
          "038-0221",
          "038-0243",
          "038-0222",
          "038-0232",
          "038-0242",
          "038-1100",
          "038-1142",
          "038-1113",
          "038-1104",
          "038-1133",
          "038-1131",
          "038-1123",
          "038-1141",
          "038-1143",
          "038-1103",
          "038-1132",
          "038-1111",
          "038-1112",
          "038-1145",
          "038-1101",
          "038-1102",
          "038-1134",
          "038-1121",
          "038-1122",
          "038-1144",
          "038-3600",
          "038-3683",
          "038-3651",
          "038-3682",
          "038-3685",
          "038-3662",
          "038-3642",
          "038-3635",
          "038-3671",
          "038-3632",
          "038-3633",
          "038-3636",
          "038-3673",
          "038-3621",
          "038-3684",
          "038-3623",
          "038-3634",
          "038-3624",
          "038-3625",
          "038-3645",
          "038-3643",
          "038-3681",
          "038-3672",
          "038-3641",
          "038-3661",
          "038-3631",
          "038-3622",
          "038-3644",
          "038-3500",
          "038-3501",
          "038-3513",
          "038-3541",
          "038-3531",
          "038-3523",
          "038-3502",
          "038-3524",
          "038-3521",
          "038-3512",
          "038-3525",
          "038-3503",
          "038-3522",
          "038-3514",
          "038-3532",
          "038-3542",
          "038-3543",
          "038-3515",
          "038-3511",
          "037-0300",
          "037-0316",
          "037-0301",
          "037-0302",
          "037-0311",
          "037-0304",
          "037-0512",
          "037-0523",
          "037-0541",
          "037-0534",
          "037-0542",
          "037-0535",
          "037-0521",
          "037-0522",
          "037-0525",
          "037-0538",
          "037-0533",
          "037-0511",
          "037-0531",
          "037-0536",
          "037-0532",
          "037-0514",
          "037-0537",
          "037-0543",
          "030-1701",
          "037-0524",
          "037-0513",
          "037-0303",
          "037-0318",
          "037-0313",
          "037-0315",
          "037-0312",
          "037-0305",
          "037-0317",
          "037-0309",
          "037-0314",
          "037-0308",
          "037-0306",
          "037-0307",
          "039-3100",
          "039-3116",
          "039-3108",
          "039-3105",
          "039-3178",
          "039-3111",
          "039-3144",
          "039-3174",
          "039-3104",
          "039-3107",
          "039-3106",
          "039-3127",
          "039-3154",
          "039-3128",
          "039-3171",
          "039-3143",
          "039-3158",
          "039-3165",
          "039-3159",
          "039-3155",
          "039-3142",
          "039-3162",
          "039-3157",
          "039-3177",
          "039-3152",
          "039-3117",
          "039-3126",
          "039-3146",
          "039-3147",
          "039-3124",
          "039-3151",
          "039-3129",
          "039-3163",
          "039-3175",
          "039-3173",
          "039-3114",
          "039-3122",
          "039-3103",
          "039-3123",
          "039-3113",
          "039-3115",
          "039-3118",
          "039-3172",
          "039-3153",
          "039-3112",
          "039-3176",
          "039-3141",
          "039-3167",
          "039-3166",
          "039-3131",
          "039-3101",
          "039-3156",
          "039-3121",
          "039-3125",
          "039-3164",
          "039-3168",
          "039-3179",
          "039-3161",
          "039-3145",
          "039-3109",
          "039-3148",
          "039-3102",
          "039-2500",
          "039-2501",
          "039-2534",
          "039-2543",
          "039-2816",
          "039-2825",
          "039-2824",
          "039-2833",
          "039-2865",
          "039-2561",
          "039-2741",
          "039-2585",
          "039-2587",
          "039-2584",
          "039-2731",
          "039-2574",
          "039-2771",
          "039-2586",
          "039-2526",
          "039-2507",
          "039-2756",
          "039-2755",
          "039-2779",
          "039-2745",
          "039-2508",
          "039-2502",
          "039-2531",
          "039-2821",
          "039-2514",
          "039-2532",
          "039-2715",
          "039-2751",
          "039-2578",
          "039-2523",
          "039-2577",
          "039-2831",
          "039-2725",
          "039-2714",
          "039-2724",
          "039-2533",
          "039-2712",
          "039-2562",
          "039-2522",
          "039-2866",
          "039-2877",
          "039-2812",
          "039-2813",
          "039-2822",
          "039-2856",
          "039-2537",
          "039-2753",
          "039-2778",
          "039-2575",
          "039-2845",
          "039-2576",
          "039-2568",
          "039-2852",
          "039-2853",
          "039-2875",
          "039-2512",
          "039-2511",
          "039-2754",
          "039-2872",
          "039-2525",
          "039-2774",
          "039-2546",
          "039-2721",
          "039-2864",
          "039-2723",
          "039-2772",
          "039-2841",
          "039-2549",
          "039-2871",
          "039-2572",
          "039-2565",
          "039-2726",
          "039-2777",
          "039-2776",
          "039-2775",
          "039-2557",
          "039-2876",
          "039-2851",
          "039-2515",
          "039-2855",
          "039-2732",
          "039-2757",
          "039-2854",
          "039-2558",
          "039-2516",
          "039-2505",
          "039-2823",
          "039-2744",
          "039-2747",
          "039-2746",
          "039-2874",
          "039-2552",
          "039-2567",
          "039-2844",
          "039-2524",
          "039-2743",
          "039-2538",
          "039-2518",
          "039-2521",
          "039-2811",
          "039-2861",
          "039-2873",
          "039-2857",
          "039-2733",
          "039-2863",
          "039-2579",
          "039-2503",
          "039-2846",
          "039-2554",
          "039-2782",
          "039-2784",
          "039-2783",
          "039-2786",
          "039-2785",
          "039-2711",
          "039-2842",
          "039-2826",
          "039-2539",
          "039-2862",
          "039-2517",
          "039-2582",
          "039-2556",
          "039-2535",
          "039-2536",
          "039-2801",
          "039-2804",
          "039-2802",
          "039-2803",
          "039-2573",
          "039-2542",
          "039-2843",
          "039-2752",
          "039-2544",
          "039-2553",
          "039-2566",
          "039-2781",
          "039-2805",
          "039-2581",
          "039-2513",
          "039-2713",
          "039-2506",
          "039-2504",
          "039-2761",
          "039-2763",
          "039-2762",
          "039-2742",
          "039-2564",
          "039-2545",
          "039-2571",
          "039-2716",
          "039-2583",
          "039-2773",
          "039-2555",
          "039-2569",
          "039-2527",
          "039-2835",
          "039-2832",
          "039-2814",
          "039-2748",
          "039-2541",
          "039-2548",
          "039-2722",
          "039-2563",
          "039-2834",
          "039-2828",
          "039-2827",
          "039-2815",
          "039-2551",
          "039-2547",
          "039-2717",
          "039-2559",
          "039-2589",
          "039-2588",
          "039-2300",
          "033-0071",
          "039-2371",
          "033-0072",
          "039-2372",
          "033-0073",
          "039-2311",
          "039-2314",
          "033-0074",
          "039-2312",
          "039-2313",
          "039-2315",
          "039-4100",
          "039-4106",
          "039-4113",
          "039-4115",
          "039-4112",
          "039-4111",
          "039-4131",
          "039-4142",
          "039-4123",
          "039-4124",
          "039-4103",
          "039-4137",
          "039-4104",
          "039-4133",
          "039-4132",
          "039-4138",
          "039-4145",
          "039-4152",
          "039-4155",
          "039-4122",
          "039-4116",
          "039-4105",
          "039-4117",
          "039-4144",
          "039-4102",
          "039-4101",
          "039-4135",
          "039-4134",
          "039-4121",
          "039-4156",
          "039-4157",
          "039-4153",
          "039-4114",
          "039-4141",
          "039-4154",
          "039-4151",
          "039-4143",
          "039-4136",
          "039-2600",
          "039-2657",
          "039-2604",
          "039-2406",
          "039-2407",
          "039-2685",
          "039-2681",
          "039-2602",
          "039-2682",
          "039-2683",
          "039-2626",
          "039-2655",
          "039-2656",
          "039-2686",
          "039-2607",
          "039-2673",
          "039-2401",
          "039-2612",
          "039-2402",
          "039-2623",
          "039-2651",
          "039-2688",
          "039-2636",
          "039-2634",
          "039-2671",
          "039-2635",
          "039-2664",
          "039-2666",
          "039-2643",
          "039-2601",
          "039-2606",
          "039-2404",
          "039-2405",
          "039-2661",
          "039-2687",
          "039-2668",
          "039-2678",
          "039-2616",
          "039-2614",
          "039-2672",
          "039-2641",
          "039-2605",
          "039-2627",
          "039-2676",
          "039-2662",
          "039-2653",
          "039-2633",
          "039-2667",
          "039-2647",
          "039-2648",
          "039-2646",
          "039-2645",
          "039-2631",
          "039-2624",
          "039-2663",
          "039-2621",
          "039-2675",
          "039-2674",
          "039-2654",
          "039-2611",
          "039-2625",
          "039-2403",
          "039-2613",
          "039-2622",
          "039-2632",
          "039-2642",
          "039-2677",
          "039-2615",
          "039-2652",
          "039-2644",
          "039-2617",
          "039-2684",
          "039-2665",
          "039-2603",
          "039-3200",
          "039-3212",
          "039-3215",
          "039-3213",
          "039-3211",
          "039-4301",
          "039-3214",
          "039-2200",
          "039-2189",
          "039-2147",
          "039-2116",
          "039-2141",
          "039-2165",
          "039-2172",
          "039-2113",
          "039-2217",
          "039-2216",
          "039-2182",
          "039-2183",
          "039-2253",
          "039-2225",
          "039-2133",
          "039-2185",
          "039-2221",
          "039-2145",
          "039-2117",
          "039-2127",
          "039-2186",
          "039-2155",
          "039-2157",
          "039-2156",
          "039-2252",
          "039-2142",
          "039-2124",
          "039-2125",
          "039-2224",
          "039-2121",
          "039-2222",
          "039-2215",
          "039-2143",
          "039-2226",
          "039-2211",
          "039-2164",
          "039-2180",
          "039-2235",
          "039-2128",
          "039-2114",
          "039-2144",
          "039-2135",
          "039-2163",
          "039-2255",
          "039-2234",
          "039-2102",
          "039-2154",
          "039-2223",
          "039-2254",
          "039-2136",
          "039-2129",
          "039-2112",
          "039-2146",
          "039-2115",
          "039-2111",
          "039-2171",
          "039-2161",
          "039-2123",
          "039-2132",
          "039-2122",
          "039-2233",
          "039-2134",
          "039-2184",
          "039-2232",
          "039-2212",
          "039-2231",
          "039-2214",
          "039-2118",
          "039-2203",
          "039-2204",
          "039-2205",
          "039-2173",
          "039-2201",
          "039-2181",
          "039-2213",
          "039-2126",
          "039-2206",
          "039-2187",
          "039-2162",
          "039-2131",
          "039-2251",
          "039-2202",
          "039-2151",
          "039-2152",
          "039-2158",
          "039-2153",
          "039-2236",
          "039-2188",
          "039-4600",
          "039-4601",
          "039-4602",
          "035-0113",
          "035-0001",
          "039-4223",
          "035-0104",
          "035-0004",
          "039-4221",
          "035-0112",
          "039-4224",
          "035-0111",
          "039-4222",
          "035-0005",
          "035-0003",
          "035-0103",
          "035-0002",
          "039-4500",
          "039-4502",
          "039-4501",
          "039-4503",
          "039-4700",
          "039-4711",
          "039-4712",
          "039-0100",
          "039-0111",
          "039-0112",
          "039-0453",
          "039-0141",
          "039-0143",
          "039-0142",
          "039-0132",
          "039-0451",
          "039-0134",
          "039-0122",
          "039-0121",
          "039-0452",
          "039-0133",
          "039-0131",
          "039-0144",
          "039-0113",
          "039-0135",
          "039-1500",
          "039-1508",
          "039-1561",
          "039-1528",
          "039-1536",
          "039-1556",
          "039-1534",
          "039-1521",
          "039-1539",
          "039-1505",
          "039-1516",
          "039-1568",
          "039-1504",
          "039-1552",
          "039-1537",
          "039-1507",
          "039-1527",
          "039-1503",
          "039-1563",
          "039-1511",
          "039-1501",
          "039-1533",
          "039-1557",
          "039-1567",
          "039-1526",
          "039-1551",
          "039-1523",
          "039-1554",
          "039-1553",
          "039-1532",
          "039-1531",
          "039-2302",
          "039-1502",
          "039-1515",
          "039-1506",
          "039-1701",
          "039-1702",
          "039-1703",
          "039-1522",
          "039-1566",
          "039-1558",
          "039-1517",
          "039-1562",
          "039-1525",
          "039-1546",
          "039-1559",
          "039-1518",
          "039-1555",
          "039-1514",
          "039-1565",
          "039-1545",
          "039-1535",
          "039-1541",
          "039-1548",
          "039-1547",
          "039-1543",
          "039-1538",
          "039-1529",
          "039-1519",
          "039-1524",
          "039-1542",
          "039-1544",
          "039-1512",
          "039-1569",
          "039-1513",
          "039-1564",
          "039-0200",
          "039-0312",
          "039-0316",
          "039-0202",
          "039-0201",
          "039-0314",
          "039-0315",
          "039-0311",
          "039-0313",
          "039-0317",
          "039-0606",
          "039-0106",
          "039-0102",
          "039-0103",
          "039-0105",
          "039-0801",
          "039-0812",
          "039-0501",
          "039-0612",
          "039-0805",
          "039-0814",
          "039-0104",
          "039-0502",
          "039-0813",
          "039-0503",
          "039-0507",
          "039-0804",
          "039-0101",
          "039-0504",
          "039-0611",
          "039-0802",
          "039-0505",
          "039-0614",
          "039-0815",
          "039-0506",
          "039-0811",
          "039-0803",
          "039-0613",
          "039-1200",
          "039-1202",
          "039-1207",
          "039-1212",
          "039-1211",
          "039-1206",
          "039-1208",
          "039-1201",
          "039-1203",
          "039-1205",
          "039-1204",
          "039-1800",
          "039-1802",
          "039-1801",
          "020-0000",
          "020-0133",
          "020-0801",
          "020-0014",
          "020-0013",
          "020-0126",
          "020-0852",
          "020-0312",
          "020-0054",
          "020-0142",
          "028-4131",
          "020-0012",
          "020-0101",
          "020-0066",
          "020-0204",
          "020-0102",
          "020-0113",
          "020-0023",
          "020-0404",
          "020-0025",
          "020-0147",
          "020-0022",
          "020-0403",
          "020-0026",
          "020-0807",
          "020-0823",
          "020-0854",
          "020-0053",
          "020-0855",
          "020-0143",
          "020-0125",
          "020-0887",
          "020-0001",
          "028-4135",
          "020-0203",
          "020-0812",
          "020-0811",
          "020-0857",
          "020-0136",
          "020-0105",
          "020-0061",
          "020-0031",
          "020-0124",
          "020-0111",
          "020-0402",
          "028-4125",
          "020-0815",
          "020-0104",
          "020-0885",
          "020-0024",
          "020-0063",
          "020-0041",
          "020-0878",
          "020-0002",
          "020-0821",
          "020-0831",
          "020-0883",
          "028-4132",
          "020-0875",
          "020-0853",
          "028-4134",
          "020-0877",
          "020-0051",
          "020-0856",
          "020-0123",
          "020-0003",
          "020-0044",
          "020-0803",
          "020-0806",
          "020-0042",
          "020-0884",
          "020-0882",
          "020-0127",
          "020-0861",
          "020-0865",
          "020-0828",
          "020-0135",
          "020-0825",
          "020-0114",
          "020-0115",
          "020-0202",
          "028-4121",
          "028-4124",
          "020-0822",
          "020-0021",
          "020-0121",
          "020-0835",
          "020-0838",
          "020-0836",
          "020-0837",
          "020-0839",
          "020-0144",
          "020-0802",
          "020-0055",
          "020-0401",
          "028-4122",
          "020-0137",
          "020-0881",
          "020-0052",
          "020-0043",
          "020-0131",
          "020-0816",
          "020-0871",
          "020-0141",
          "020-0834",
          "020-0062",
          "020-0146",
          "020-0064",
          "020-0016",
          "020-0827",
          "020-0132",
          "020-0065",
          "020-0864",
          "020-0103",
          "020-0833",
          "020-0313",
          "020-0116",
          "020-0872",
          "020-0841",
          "020-0876",
          "020-0824",
          "020-0108",
          "020-0804",
          "020-0805",
          "020-0862",
          "020-0817",
          "020-0814",
          "020-0106",
          "020-0112",
          "020-0832",
          "020-0813",
          "020-0201",
          "020-0145",
          "020-0015",
          "020-0148",
          "028-4123",
          "020-0873",
          "020-0107",
          "028-4136",
          "020-0826",
          "020-0122",
          "020-0011",
          "020-0117",
          "020-0134",
          "020-0874",
          "020-0863",
          "020-0851",
          "020-0866",
          "020-0005",
          "020-0045",
          "020-0033",
          "020-0034",
          "028-4133",
          "020-0311",
          "028-2711",
          "020-0004",
          "020-0032",
          "020-0842",
          "020-0844",
          "020-0843",
          "020-0845",
          "020-0846",
          "020-0886",
          "027-0000",
          "027-0202",
          "027-0092",
          "027-0086",
          "027-0062",
          "027-0048",
          "028-2421",
          "027-0054",
          "027-0083",
          "028-2422",
          "027-0112",
          "027-0111",
          "028-2303",
          "028-2632",
          "027-0033",
          "027-0039",
          "027-0078",
          "028-2104",
          "028-2402",
          "028-2302",
          "028-2513",
          "027-0042",
          "027-0044",
          "027-0028",
          "028-2631",
          "027-0008",
          "027-0085",
          "027-0065",
          "027-0006",
          "027-0046",
          "027-0005",
          "027-0071",
          "027-0038",
          "027-0076",
          "027-0096",
          "027-0097",
          "027-0072",
          "027-0095",
          "027-0088",
          "027-0201",
          "027-0081",
          "027-0084",
          "028-2512",
          "027-0058",
          "027-0043",
          "027-0024",
          "027-0022",
          "027-0023",
          "027-0027",
          "027-0032",
          "027-0036",
          "027-0009",
          "027-0067",
          "027-0077",
          "027-0066",
          "027-0307",
          "027-0359",
          "027-0322",
          "027-0375",
          "027-0374",
          "027-0376",
          "027-0305",
          "027-0321",
          "027-0379",
          "027-0378",
          "027-0377",
          "027-0332",
          "027-0382",
          "027-0388",
          "027-0343",
          "027-0383",
          "027-0306",
          "027-0386",
          "027-0304",
          "027-0312",
          "027-0342",
          "027-0351",
          "027-0361",
          "027-0362",
          "027-0347",
          "027-0325",
          "027-0345",
          "027-0385",
          "027-0313",
          "027-0364",
          "027-0355",
          "027-0367",
          "027-0384",
          "027-0365",
          "027-0344",
          "027-0301",
          "027-0358",
          "027-0302",
          "027-0303",
          "027-0363",
          "027-0346",
          "027-0331",
          "027-0366",
          "027-0323",
          "027-0387",
          "027-0333",
          "027-0381",
          "027-0371",
          "027-0372",
          "027-0357",
          "027-0373",
          "027-0324",
          "027-0354",
          "027-0352",
          "027-0341",
          "027-0311",
          "027-0353",
          "027-0356",
          "027-0056",
          "027-0203",
          "027-0091",
          "027-0093",
          "027-0034",
          "027-0055",
          "027-0053",
          "028-2511",
          "027-0041",
          "027-0061",
          "027-0047",
          "028-2504",
          "028-2304",
          "027-0035",
          "028-2103",
          "027-0007",
          "028-2102",
          "027-0001",
          "027-0094",
          "028-2633",
          "027-0029",
          "027-0021",
          "028-2301",
          "027-0074",
          "027-0037",
          "027-0025",
          "027-0073",
          "027-0003",
          "027-0051",
          "027-0064",
          "027-0052",
          "027-0082",
          "028-2101",
          "027-0089",
          "027-0031",
          "027-0063",
          "027-0002",
          "027-0087",
          "027-0004",
          "027-0045",
          "028-2105",
          "027-0075",
          "027-0026",
          "022-0000",
          "022-0007",
          "022-0004",
          "022-0002",
          "022-0003",
          "022-0101",
          "022-0102",
          "022-0211",
          "022-0006",
          "022-0005",
          "022-0001",
          "025-0000",
          "025-0067",
          "025-0088",
          "025-0071",
          "025-0095",
          "028-3131",
          "028-3151",
          "028-3185",
          "028-3102",
          "028-3172",
          "028-3161",
          "028-3101",
          "028-3141",
          "028-3153",
          "028-3182",
          "028-3133",
          "028-3181",
          "028-3122",
          "028-3121",
          "028-3184",
          "028-3171",
          "028-3111",
          "028-3162",
          "028-3183",
          "028-3163",
          "028-3132",
          "028-3152",
          "028-3142",
          "025-0058",
          "025-0042",
          "025-0322",
          "025-0037",
          "025-0092",
          "028-3201",
          "028-3203",
          "028-3204",
          "028-3202",
          "025-0303",
          "025-0026",
          "025-0082",
          "025-0311",
          "025-0086",
          "025-0075",
          "025-0321",
          "025-0056",
          "025-0062",
          "025-0032",
          "025-0087",
          "025-0007",
          "025-0043",
          "025-0132",
          "025-0301",
          "025-0008",
          "025-0004",
          "025-0253",
          "025-0323",
          "025-0013",
          "025-0012",
          "025-0324",
          "025-0098",
          "025-0074",
          "025-0094",
          "025-0064",
          "025-0084",
          "025-0081",
          "025-0068",
          "025-0035",
          "025-0054",
          "025-0063",
          "025-0006",
          "025-0025",
          "025-0022",
          "025-0076",
          "025-0137",
          "025-0057",
          "025-0079",
          "025-0033",
          "025-0039",
          "025-0305",
          "025-0016",
          "025-0083",
          "025-0014",
          "025-0005",
          "025-0001",
          "028-0115",
          "028-0134",
          "028-0103",
          "028-0154",
          "028-0151",
          "028-0121",
          "028-0136",
          "028-0143",
          "028-0107",
          "028-0102",
          "028-0116",
          "028-0101",
          "028-0135",
          "028-0156",
          "028-0142",
          "028-0141",
          "028-0112",
          "028-0106",
          "028-0133",
          "028-0123",
          "028-0132",
          "028-0122",
          "028-0114",
          "028-0152",
          "028-0153",
          "028-0113",
          "028-0105",
          "028-0131",
          "028-0104",
          "028-0155",
          "028-0144",
          "028-0111",
          "025-0135",
          "025-0131",
          "025-0251",
          "025-0089",
          "025-0053",
          "025-0133",
          "025-0036",
          "025-0077",
          "025-0046",
          "025-0252",
          "025-0023",
          "025-0021",
          "025-0091",
          "025-0045",
          "025-0002",
          "025-0312",
          "025-0314",
          "025-0315",
          "025-0313",
          "025-0302",
          "025-0052",
          "025-0015",
          "025-0003",
          "025-0041",
          "025-0073",
          "025-0096",
          "025-0085",
          "025-0078",
          "025-0031",
          "025-0038",
          "025-0065",
          "025-0066",
          "025-0093",
          "025-0134",
          "025-0051",
          "025-0034",
          "025-0055",
          "025-0061",
          "025-0011",
          "025-0024",
          "025-0044",
          "025-0244",
          "025-0304",
          "025-0136",
          "025-0072",
          "025-0097",
          "024-0000",
          "024-0051",
          "024-0031",
          "024-0081",
          "024-0001",
          "024-0041",
          "024-0021",
          "024-0054",
          "024-0053",
          "024-0055",
          "024-0052",
          "024-0061",
          "024-0091",
          "024-0056",
          "024-0062",
          "024-0071",
          "024-0057",
          "024-0032",
          "024-0072",
          "024-0102",
          "024-0002",
          "024-0211",
          "024-0063",
          "024-0042",
          "024-0022",
          "024-0105",
          "024-0033",
          "024-0084",
          "024-0023",
          "024-0103",
          "024-0073",
          "024-0058",
          "024-0092",
          "024-0034",
          "024-0043",
          "024-0011",
          "024-0012",
          "024-0024",
          "024-0074",
          "024-0003",
          "024-0075",
          "024-0076",
          "024-0035",
          "024-0044",
          "024-0101",
          "024-0013",
          "024-0104",
          "024-0093",
          "024-0094",
          "024-0025",
          "024-0082",
          "024-0004",
          "024-0083",
          "024-0045",
          "024-0095",
          "024-0014",
          "024-0064",
          "024-0321",
          "024-0322",
          "024-0325",
          "024-0335",
          "024-0323",
          "024-0326",
          "024-0332",
          "024-0333",
          "024-0334",
          "024-0324",
          "024-0331",
          "028-0000",
          "028-0014",
          "028-0063",
          "028-8111",
          "028-0034",
          "028-0091",
          "028-0083",
          "028-0041",
          "028-0054",
          "028-0051",
          "028-0082",
          "028-0013",
          "028-0015",
          "028-0071",
          "028-0024",
          "028-7801",
          "028-0035",
          "028-0065",
          "028-0023",
          "028-0053",
          "028-0055",
          "028-0022",
          "028-0061",
          "028-0032",
          "028-0031",
          "028-0066",
          "028-0056",
          "028-0001",
          "028-0012",
          "028-0081",
          "028-0062",
          "028-0033",
          "028-0052",
          "028-0011",
          "028-0021",
          "028-8712",
          "028-8602",
          "028-8713",
          "028-8711",
          "028-8603",
          "028-8604",
          "028-8601",
          "028-8605",
          "028-8521",
          "028-0064",
          "028-0500",
          "028-0503",
          "028-0502",
          "028-0501",
          "028-0533",
          "028-0532",
          "028-0531",
          "028-0534",
          "028-0511",
          "028-0481",
          "028-0517",
          "028-0776",
          "028-0771",
          "028-0775",
          "028-0773",
          "028-0772",
          "028-0774",
          "028-0516",
          "028-0521",
          "028-0526",
          "028-0522",
          "028-0524",
          "028-0527",
          "028-0523",
          "028-0662",
          "028-0661",
          "028-0663",
          "028-0664",
          "028-0554",
          "028-0553",
          "028-0555",
          "028-0551",
          "028-0552",
          "028-0514",
          "028-0542",
          "028-0512",
          "028-0513",
          "028-0515",
          "028-0543",
          "028-0545",
          "028-0541",
          "028-0544",
          "028-0302",
          "028-0301",
          "028-0303",
          "028-0304",
          "028-0305",
          "028-0525",
          "021-0000",
          "021-0853",
          "021-0031",
          "021-0041",
          "021-0864",
          "021-0008",
          "021-0894",
          "021-0834",
          "021-0867",
          "021-0884",
          "021-0881",
          "021-0882",
          "021-0007",
          "021-0833",
          "029-0202",
          "029-0201",
          "021-0802",
          "021-0814",
          "021-0811",
          "021-0101",
          "021-0804",
          "029-0131",
          "021-0022",
          "021-0052",
          "021-0024",
          "021-0891",
          "021-0801",
          "021-0852",
          "021-0832",
          "021-0821",
          "021-0893",
          "021-0806",
          "021-0877",
          "021-0006",
          "021-0883",
          "021-0001",
          "021-0841",
          "021-0032",
          "021-0851",
          "029-0804",
          "029-1111",
          "029-0801",
          "029-0802",
          "029-0803",
          "029-0711",
          "029-0603",
          "029-0431",
          "029-0521",
          "029-0523",
          "029-0522",
          "029-0602",
          "029-0601",
          "021-0873",
          "021-0875",
          "029-0132",
          "021-0027",
          "021-0885",
          "021-0844",
          "021-0021",
          "021-0862",
          "021-0874",
          "021-0023",
          "021-0005",
          "021-0002",
          "021-0836",
          "021-0865",
          "021-0854",
          "021-0835",
          "021-0831",
          "021-0102",
          "021-0902",
          "021-0861",
          "021-0871",
          "029-3103",
          "029-3102",
          "029-3206",
          "029-3101",
          "029-3104",
          "029-3207",
          "029-3105",
          "029-3205",
          "021-0807",
          "021-0003",
          "021-0892",
          "021-0822",
          "029-0301",
          "029-0302",
          "029-0303",
          "021-0876",
          "021-0812",
          "021-0843",
          "029-3522",
          "029-3311",
          "029-3403",
          "029-3404",
          "029-3402",
          "029-3406",
          "029-3405",
          "029-3521",
          "029-3401",
          "021-0221",
          "021-0901",
          "021-0004",
          "021-0803",
          "021-0866",
          "021-0813",
          "021-0863",
          "021-0872",
          "021-0013",
          "021-0012",
          "029-1201",
          "029-1211",
          "029-1202",
          "029-0211",
          "021-0842",
          "021-0063",
          "021-0035",
          "021-0054",
          "021-0033",
          "021-0064",
          "021-0051",
          "021-0036",
          "021-0034",
          "021-0061",
          "021-0062",
          "021-0055",
          "021-0056",
          "021-0053",
          "021-0026",
          "021-0025",
          "021-0011",
          "021-0805",
          "021-0815",
          "021-0014",
          "029-2200",
          "029-2207",
          "029-2204",
          "029-2205",
          "029-2203",
          "029-2208",
          "029-2201",
          "029-2202",
          "029-2206",
          "026-0000",
          "026-0012",
          "026-0301",
          "026-0003",
          "026-0022",
          "026-0002",
          "026-0024",
          "026-0025",
          "026-0302",
          "026-0055",
          "026-0026",
          "026-0041",
          "026-0412",
          "026-0042",
          "026-0045",
          "026-0052",
          "026-0033",
          "026-0046",
          "026-0053",
          "026-0015",
          "026-0043",
          "026-0031",
          "026-0044",
          "026-0021",
          "026-0032",
          "026-0023",
          "026-0061",
          "026-0121",
          "026-0034",
          "026-0054",
          "026-0303",
          "026-0411",
          "026-0013",
          "026-0014",
          "026-0001",
          "026-0004",
          "026-0011",
          "026-0035",
          "026-0304",
          "026-0051",
          "028-6100",
          "028-6723",
          "028-6103",
          "028-5713",
          "028-6108",
          "028-5711",
          "028-5702",
          "028-6102",
          "028-6857",
          "028-6944",
          "028-6945",
          "028-6946",
          "028-6947",
          "028-6883",
          "028-6837",
          "028-6866",
          "028-6924",
          "028-6877",
          "028-6874",
          "028-6847",
          "028-6943",
          "028-6848",
          "028-6819",
          "028-6879",
          "028-6833",
          "028-6817",
          "028-6832",
          "028-6845",
          "028-6831",
          "028-6835",
          "028-6822",
          "028-6842",
          "028-6985",
          "028-6878",
          "028-6861",
          "028-6873",
          "028-6919",
          "028-6916",
          "028-6929",
          "028-6917",
          "028-6813",
          "028-6958",
          "028-6937",
          "028-6849",
          "028-6844",
          "028-6939",
          "028-6942",
          "028-6938",
          "028-6933",
          "028-6952",
          "028-6935",
          "028-6948",
          "028-6941",
          "028-6949",
          "028-6966",
          "028-6957",
          "028-6968",
          "028-6818",
          "028-6984",
          "028-6955",
          "028-6906",
          "028-6856",
          "028-6911",
          "028-6816",
          "028-6826",
          "028-6926",
          "028-6953",
          "028-6814",
          "028-6981",
          "028-6851",
          "028-6921",
          "028-6821",
          "028-6977",
          "028-6973",
          "028-6979",
          "028-6978",
          "028-6963",
          "028-6853",
          "028-6918",
          "028-6903",
          "028-6972",
          "028-6872",
          "028-6904",
          "028-6934",
          "028-6928",
          "028-6846",
          "028-6923",
          "028-6931",
          "028-6951",
          "028-6907",
          "028-6812",
          "028-6913",
          "028-6983",
          "028-6854",
          "028-6915",
          "028-6922",
          "028-6855",
          "028-6884",
          "028-6836",
          "028-6967",
          "028-6905",
          "028-6956",
          "028-6961",
          "028-6876",
          "028-6875",
          "028-6975",
          "028-6868",
          "028-6843",
          "028-6811",
          "028-6862",
          "028-6976",
          "028-6852",
          "028-6825",
          "028-6936",
          "028-6974",
          "028-6912",
          "028-6824",
          "028-6964",
          "028-6908",
          "028-6865",
          "028-6925",
          "028-6863",
          "028-6815",
          "028-6962",
          "028-6969",
          "028-6954",
          "028-6882",
          "028-6901",
          "028-6834",
          "028-6841",
          "028-6932",
          "028-6823",
          "028-6902",
          "028-6971",
          "028-6838",
          "028-6885",
          "028-6864",
          "028-6867",
          "028-6871",
          "028-6965",
          "028-6982",
          "028-6927",
          "028-6914",
          "028-6881",
          "028-6107",
          "028-6724",
          "028-6106",
          "028-6721",
          "028-5712",
          "028-6101",
          "028-6722",
          "028-6105",
          "028-6104",
          "028-7100",
          "028-7619",
          "028-7635",
          "028-7526",
          "028-7554",
          "028-7679",
          "028-7506",
          "028-7552",
          "028-7306",
          "028-7621",
          "028-7622",
          "028-7406",
          "028-7534",
          "028-7674",
          "028-7521",
          "028-7615",
          "028-7614",
          "028-7663",
          "028-7562",
          "028-7501",
          "028-7505",
          "028-7531",
          "028-7602",
          "028-7604",
          "028-7536",
          "028-7605",
          "028-7606",
          "028-7655",
          "028-7403",
          "028-7553",
          "028-7661",
          "028-7664",
          "028-7607",
          "028-7111",
          "028-7624",
          "028-7611",
          "028-7625",
          "028-7617",
          "028-7612",
          "028-7303",
          "028-7402",
          "028-7533",
          "028-7502",
          "028-7527",
          "028-7643",
          "028-7657",
          "028-7555",
          "028-7628",
          "028-7654",
          "028-7632",
          "028-7638",
          "028-7678",
          "028-7532",
          "028-7543",
          "028-7656",
          "028-7627",
          "028-7676",
          "028-7645",
          "028-7561",
          "028-7535",
          "028-7675",
          "028-7511",
          "028-7618",
          "028-7642",
          "028-7629",
          "028-7551",
          "028-7662",
          "028-7644",
          "028-7516",
          "028-7631",
          "028-7405",
          "028-7542",
          "028-7566",
          "028-7601",
          "028-7623",
          "028-7672",
          "028-7563",
          "028-7677",
          "028-7651",
          "028-7513",
          "028-7523",
          "028-7541",
          "028-7112",
          "028-7626",
          "028-7567",
          "028-7673",
          "028-7514",
          "028-7503",
          "028-7401",
          "028-7652",
          "028-7301",
          "028-7302",
          "028-7671",
          "028-7525",
          "028-7633",
          "028-7637",
          "028-7113",
          "028-7653",
          "028-7641",
          "028-7616",
          "028-7515",
          "028-7556",
          "028-7557",
          "028-7544",
          "028-7404",
          "028-7504",
          "028-7537",
          "028-7613",
          "028-7305",
          "028-7545",
          "028-7304",
          "028-7565",
          "028-7603",
          "028-7564",
          "028-7608",
          "028-7512",
          "028-7522",
          "028-7524",
          "028-7634",
          "028-7636",
          "023-0000",
          "023-0402",
          "023-0401",
          "023-0403",
          "023-1761",
          "023-1132",
          "023-1101",
          "023-1111",
          "023-1131",
          "023-1121",
          "023-1114",
          "023-1118",
          "023-1105",
          "023-1125",
          "023-1122",
          "023-1134",
          "023-0171",
          "023-1116",
          "023-1104",
          "023-1113",
          "023-1103",
          "023-1133",
          "023-1762",
          "023-1115",
          "023-1123",
          "023-1112",
          "023-1117",
          "023-1124",
          "023-1341",
          "023-1102",
          "023-1551",
          "029-4426",
          "029-4315",
          "029-4365",
          "029-4307",
          "029-4434",
          "029-4433",
          "029-4381",
          "029-4384",
          "029-4313",
          "029-4322",
          "029-4352",
          "029-4465",
          "029-4377",
          "029-4482",
          "029-4481",
          "029-4425",
          "029-4442",
          "029-4321",
          "029-4436",
          "029-4406",
          "029-4308",
          "029-4419",
          "029-4347",
          "029-4488",
          "029-4487",
          "029-4383",
          "029-4435",
          "029-4454",
          "029-4386",
          "029-4326",
          "029-4452",
          "029-4388",
          "029-4474",
          "029-4411",
          "029-4491",
          "029-4329",
          "029-4437",
          "029-4446",
          "029-4407",
          "029-4303",
          "029-4353",
          "029-4375",
          "029-4424",
          "029-4405",
          "029-4317",
          "029-4323",
          "029-4306",
          "029-4432",
          "029-4362",
          "029-4325",
          "029-4333",
          "029-4344",
          "029-4444",
          "029-4387",
          "029-4471",
          "029-4492",
          "029-4328",
          "029-4378",
          "029-4427",
          "029-4348",
          "029-4418",
          "029-4413",
          "029-4382",
          "029-4422",
          "029-4423",
          "029-4484",
          "029-4304",
          "029-4486",
          "029-4342",
          "029-4345",
          "029-4431",
          "029-4439",
          "029-4408",
          "029-4404",
          "029-4385",
          "029-4412",
          "029-4417",
          "029-4346",
          "029-4389",
          "029-4472",
          "029-4305",
          "029-4361",
          "029-4314",
          "029-4475",
          "029-4351",
          "029-4363",
          "029-4445",
          "029-4441",
          "029-4495",
          "029-4494",
          "029-4364",
          "029-4316",
          "029-4456",
          "029-4312",
          "029-4483",
          "029-4493",
          "029-4354",
          "029-4414",
          "029-4343",
          "029-4462",
          "029-4401",
          "029-4451",
          "029-4421",
          "029-4371",
          "029-4374",
          "029-4461",
          "029-4331",
          "029-4311",
          "029-4332",
          "029-4485",
          "029-4402",
          "029-4403",
          "029-4496",
          "029-4464",
          "029-4327",
          "029-4324",
          "029-4372",
          "029-4443",
          "029-4473",
          "029-4416",
          "029-4415",
          "029-4438",
          "029-4334",
          "029-4497",
          "029-4376",
          "029-4355",
          "029-4453",
          "029-4373",
          "029-4455",
          "029-4463",
          "029-4341",
          "029-4205",
          "029-4206",
          "029-4207",
          "029-4209",
          "029-4201",
          "029-4208",
          "029-4211",
          "029-4203",
          "029-4204",
          "029-4202",
          "023-0035",
          "023-0041",
          "023-0823",
          "023-0818",
          "023-0831",
          "023-0824",
          "023-0013",
          "023-0011",
          "023-0898",
          "023-0057",
          "023-0854",
          "023-0084",
          "023-0053",
          "023-0867",
          "023-0802",
          "023-0045",
          "023-0085",
          "023-0001",
          "023-0021",
          "023-0051",
          "023-0892",
          "023-0833",
          "023-0052",
          "023-0034",
          "023-0863",
          "023-0046",
          "023-0031",
          "023-0036",
          "023-0881",
          "023-0092",
          "023-0054",
          "023-0056",
          "023-0101",
          "023-0071",
          "023-0077",
          "023-0062",
          "023-0025",
          "023-0002",
          "023-0087",
          "023-0055",
          "023-0074",
          "023-0015",
          "023-0018",
          "023-0094",
          "023-0012",
          "023-0805",
          "023-0897",
          "023-0003",
          "023-0865",
          "023-0872",
          "023-0873",
          "023-0026",
          "023-0044",
          "023-0014",
          "023-0017",
          "023-0063",
          "023-0073",
          "023-0807",
          "023-0841",
          "023-0842",
          "023-0821",
          "023-0095",
          "023-0866",
          "023-0083",
          "023-0877",
          "023-0871",
          "023-0081",
          "023-0827",
          "023-0825",
          "023-0894",
          "023-0032",
          "023-0889",
          "023-0091",
          "023-0891",
          "023-0803",
          "023-0047",
          "023-0895",
          "023-0019",
          "023-0076",
          "023-0876",
          "023-0811",
          "023-0812",
          "023-0815",
          "023-0064",
          "023-0857",
          "023-0022",
          "023-0826",
          "023-0813",
          "023-0061",
          "023-0024",
          "023-0856",
          "023-0896",
          "023-0885",
          "023-0816",
          "023-0067",
          "023-0102",
          "023-0104",
          "023-0103",
          "023-0106",
          "023-0105",
          "023-0107",
          "023-0108",
          "023-0832",
          "023-0132",
          "023-0888",
          "023-0023",
          "023-0829",
          "023-0027",
          "023-0853",
          "023-0828",
          "023-0822",
          "023-0082",
          "023-0808",
          "023-0806",
          "023-0016",
          "023-0072",
          "023-0862",
          "023-0814",
          "023-0882",
          "023-0033",
          "023-0861",
          "023-0058",
          "023-0066",
          "023-0884",
          "023-0883",
          "023-0093",
          "023-0065",
          "023-0043",
          "023-0037",
          "023-0855",
          "023-0851",
          "023-0886",
          "023-0075",
          "023-0817",
          "023-0874",
          "023-0096",
          "023-0875",
          "023-0086",
          "023-0804",
          "023-0887",
          "023-0042",
          "023-0852",
          "023-0801",
          "023-0893",
          "023-0864",
          "020-0600",
          "020-0633",
          "020-0604",
          "020-0618",
          "020-0685",
          "020-0673",
          "020-0681",
          "020-0662",
          "020-0686",
          "020-0655",
          "020-0657",
          "020-0671",
          "020-0656",
          "020-0688",
          "020-0668",
          "020-0664",
          "020-0658",
          "020-0672",
          "020-0661",
          "020-0666",
          "020-0659",
          "020-0674",
          "020-0675",
          "020-0677",
          "020-0652",
          "020-0678",
          "020-0684",
          "020-0653",
          "020-0676",
          "020-0683",
          "020-0651",
          "020-0667",
          "020-0663",
          "020-0682",
          "020-0601",
          "020-0615",
          "020-0627",
          "020-0613",
          "020-0769",
          "020-0754",
          "020-0758",
          "020-0763",
          "020-0776",
          "020-0757",
          "020-0755",
          "020-0773",
          "020-0765",
          "020-0774",
          "020-0752",
          "020-0751",
          "020-0756",
          "020-0771",
          "020-0761",
          "020-0764",
          "020-0762",
          "020-0772",
          "020-0767",
          "020-0777",
          "020-0775",
          "020-0766",
          "020-0753",
          "020-0778",
          "020-0779",
          "020-0768",
          "020-0636",
          "020-0621",
          "020-0701",
          "020-0702",
          "020-0718",
          "020-0715",
          "020-0713",
          "020-0703",
          "020-0707",
          "020-0719",
          "020-0709",
          "020-0712",
          "020-0708",
          "020-0705",
          "020-0714",
          "020-0710",
          "020-0711",
          "020-0704",
          "020-0717",
          "020-0716",
          "020-0706",
          "020-0602",
          "020-0606",
          "020-0619",
          "020-0687",
          "020-0614",
          "020-0646",
          "020-0624",
          "020-0723",
          "020-0726",
          "020-0745",
          "020-0742",
          "020-0722",
          "020-0734",
          "020-0728",
          "020-0735",
          "020-0724",
          "020-0736",
          "020-0738",
          "020-0743",
          "020-0744",
          "020-0737",
          "020-0732",
          "020-0727",
          "020-0721",
          "020-0725",
          "020-0746",
          "020-0733",
          "020-0731",
          "020-0741",
          "020-0665",
          "020-0611",
          "020-0605",
          "020-0643",
          "020-0645",
          "020-0637",
          "020-0608",
          "020-0638",
          "020-0616",
          "020-0603",
          "020-0654",
          "020-0642",
          "020-0623",
          "020-0641",
          "020-0631",
          "020-0622",
          "020-0625",
          "020-0644",
          "020-0632",
          "020-0635",
          "020-0626",
          "020-0634",
          "020-0612",
          "020-0609",
          "020-0607",
          "020-0617",
          "020-0500",
          "020-0502",
          "020-0546",
          "020-0583",
          "020-0574",
          "020-0581",
          "020-0544",
          "020-0559",
          "020-0555",
          "020-0557",
          "020-0538",
          "020-0537",
          "020-0539",
          "020-0530",
          "020-0534",
          "020-0517",
          "020-0525",
          "020-0535",
          "020-0551",
          "020-0512",
          "020-0513",
          "020-0522",
          "020-0558",
          "020-0553",
          "020-0552",
          "020-0515",
          "020-0528",
          "020-0529",
          "020-0520",
          "020-0541",
          "020-0521",
          "020-0543",
          "020-0571",
          "020-0524",
          "020-0505",
          "020-0504",
          "020-0527",
          "020-0511",
          "020-0585",
          "020-0556",
          "020-0503",
          "020-0501",
          "020-0572",
          "020-0584",
          "020-0506",
          "020-0523",
          "020-0514",
          "020-0582",
          "020-0536",
          "020-0533",
          "020-0532",
          "020-0547",
          "020-0554",
          "020-0531",
          "020-0507",
          "020-0542",
          "020-0573",
          "020-0545",
          "028-5400",
          "028-5403",
          "028-5102",
          "028-5402",
          "028-5401",
          "028-4300",
          "028-4307",
          "028-4421",
          "028-4303",
          "028-4211",
          "028-4305",
          "028-4424",
          "028-4426",
          "028-4304",
          "028-4302",
          "028-4423",
          "028-4301",
          "028-4425",
          "028-4422",
          "028-4306",
          "028-3300",
          "028-3533",
          "028-3451",
          "028-3311",
          "028-3312",
          "028-3321",
          "028-3314",
          "028-3452",
          "028-3441",
          "028-3443",
          "028-3323",
          "028-3536",
          "028-3309",
          "028-3325",
          "028-3303",
          "028-3444",
          "028-3307",
          "028-3316",
          "028-3446",
          "028-3318",
          "028-3302",
          "028-3453",
          "028-3535",
          "028-3322",
          "028-3301",
          "028-3326",
          "028-3324",
          "028-3315",
          "028-3305",
          "028-3310",
          "028-3306",
          "028-3308",
          "028-3304",
          "028-3532",
          "028-3313",
          "028-3442",
          "028-3445",
          "028-3317",
          "028-3447",
          "028-3534",
          "028-3531",
          "028-3448",
          "028-3600",
          "028-3605",
          "028-3611",
          "028-3609",
          "028-3626",
          "028-3618",
          "028-3617",
          "028-3622",
          "028-3608",
          "028-3624",
          "028-3613",
          "028-3623",
          "028-3607",
          "028-3612",
          "028-3616",
          "028-3601",
          "028-3606",
          "028-3603",
          "028-3604",
          "028-3621",
          "028-3602",
          "028-3614",
          "028-3615",
          "028-3625",
          "020-0891",
          "028-3627",
          "029-5500",
          "029-5503",
          "029-5511",
          "029-5523",
          "029-5507",
          "029-5521",
          "029-5513",
          "029-5502",
          "029-5512",
          "029-5501",
          "029-5616",
          "029-5614",
          "029-5612",
          "029-5703",
          "029-5701",
          "029-5621",
          "029-5615",
          "029-5611",
          "029-5617",
          "029-5619",
          "029-5613",
          "029-5618",
          "029-5702",
          "024-0341",
          "029-5522",
          "029-5504",
          "029-5514",
          "029-5506",
          "029-5505",
          "029-4500",
          "029-4505",
          "029-4504",
          "029-4503",
          "029-4502",
          "029-4501",
          "029-4100",
          "029-4101",
          "029-4102",
          "029-2300",
          "029-2501",
          "029-2502",
          "029-2311",
          "028-1100",
          "028-1102",
          "028-1105",
          "028-1131",
          "028-1112",
          "028-1132",
          "028-1133",
          "028-1115",
          "028-1101",
          "028-1121",
          "028-1114",
          "028-1122",
          "028-1111",
          "028-1104",
          "028-1117",
          "028-1113",
          "028-1116",
          "028-1103",
          "028-1300",
          "028-1303",
          "028-1352",
          "028-1301",
          "028-1311",
          "028-1361",
          "028-1342",
          "028-1331",
          "028-1333",
          "028-1343",
          "028-1332",
          "028-1302",
          "028-1351",
          "028-1341",
          "028-1371",
          "028-1321",
          "027-0500",
          "028-2231",
          "027-0611",
          "028-5642",
          "027-0508",
          "027-0501",
          "028-2232",
          "027-0502",
          "027-0421",
          "028-5641",
          "028-5633",
          "028-2233",
          "027-0505",
          "027-0503",
          "027-0504",
          "027-0506",
          "027-0423",
          "027-0422",
          "027-0507",
          "027-0424",
          "028-5643",
          "028-8400",
          "028-8402",
          "028-8401",
          "028-8405",
          "028-8407",
          "028-8406",
          "028-8404",
          "028-8403",
          "028-8300",
          "028-8366",
          "028-8365",
          "028-8343",
          "028-8362",
          "028-8331",
          "028-8345",
          "028-8368",
          "028-8352",
          "028-8361",
          "028-8353",
          "028-8312",
          "028-8303",
          "028-8351",
          "028-8311",
          "028-8313",
          "028-8336",
          "028-8322",
          "028-8332",
          "028-8323",
          "028-8334",
          "028-8344",
          "028-8321",
          "028-8367",
          "028-8301",
          "028-8335",
          "028-8302",
          "028-8364",
          "028-8341",
          "028-8363",
          "028-8333",
          "028-8342",
          "028-6300",
          "028-6223",
          "028-6301",
          "028-6302",
          "028-6303",
          "028-6411",
          "028-6222",
          "028-6304",
          "028-6221",
          "028-6412",
          "028-6413",
          "028-8200",
          "028-8202",
          "028-8201",
          "028-6500",
          "028-6501",
          "028-6502",
          "028-6505",
          "028-6503",
          "028-6611",
          "028-6504",
          "028-6612",
          "028-6506",
          "028-6507",
          "028-7900",
          "028-8803",
          "028-7905",
          "028-8802",
          "028-7904",
          "028-8801",
          "028-8804",
          "028-7915",
          "028-7903",
          "028-7914",
          "028-7913",
          "028-7912",
          "028-7911",
          "028-7918",
          "028-7902",
          "028-7917",
          "028-7916",
          "028-7901",
          "028-7906",
          "028-8805",
          "028-5300",
          "028-5222",
          "028-5304",
          "028-5312",
          "028-5316",
          "028-5131",
          "028-5134",
          "028-5303",
          "028-5223",
          "028-5311",
          "028-5221",
          "028-5132",
          "028-5301",
          "028-5305",
          "028-5313",
          "028-5306",
          "028-5233",
          "028-5133",
          "028-5314",
          "028-5315",
          "028-5224",
          "028-5302",
          "980-0000",
          "981-0916",
          "980-0856",
          "989-3211",
          "981-0963",
          "981-0904",
          "989-3128",
          "989-3127",
          "981-0945",
          "980-0845",
          "981-0965",
          "981-0964",
          "981-0966",
          "980-0811",
          "980-0022",
          "989-3212",
          "980-0005",
          "989-3213",
          "980-0805",
          "980-0804",
          "980-0814",
          "980-0003",
          "989-3126",
          "982-0261",
          "981-0942",
          "980-0013",
          "981-0933",
          "980-0821",
          "980-0812",
          "980-0815",
          "989-3124",
          "980-0011",
          "980-0862",
          "980-0863",
          "980-0867",
          "980-0865",
          "980-0852",
          "980-0866",
          "980-0853",
          "980-0854",
          "980-0851",
          "980-0861",
          "980-0864",
          "980-0855",
          "981-0954",
          "981-0941",
          "981-0902",
          "981-0901",
          "980-0023",
          "981-0931",
          "981-0932",
          "980-0801",
          "981-0943",
          "989-3201",
          "989-3432",
          "989-3122",
          "980-0803",
          "981-0905",
          "981-0906",
          "980-0813",
          "989-3121",
          "981-0922",
          "989-3431",
          "981-0961",
          "980-0823",
          "981-0935",
          "981-0944",
          "989-3125",
          "981-0913",
          "982-0262",
          "980-0872",
          "981-0911",
          "981-0903",
          "989-3216",
          "981-0907",
          "981-0951",
          "980-0822",
          "980-0021",
          "980-6190",
          "980-6101",
          "980-6102",
          "980-6103",
          "980-6104",
          "980-6105",
          "980-6106",
          "980-6107",
          "980-6108",
          "980-6109",
          "980-6110",
          "980-6111",
          "980-6112",
          "980-6113",
          "980-6114",
          "980-6115",
          "980-6116",
          "980-6117",
          "980-6118",
          "980-6119",
          "980-6120",
          "980-6121",
          "980-6122",
          "980-6123",
          "980-6124",
          "980-6125",
          "980-6126",
          "980-6127",
          "980-6128",
          "980-6129",
          "980-6130",
          "980-6131",
          "980-6090",
          "980-6001",
          "980-6002",
          "980-6003",
          "980-6004",
          "980-6005",
          "980-6006",
          "980-6007",
          "980-6008",
          "980-6009",
          "980-6010",
          "980-6011",
          "980-6012",
          "980-6013",
          "980-6014",
          "980-6015",
          "980-6016",
          "980-6017",
          "980-6018",
          "980-6019",
          "980-6020",
          "980-6021",
          "980-6022",
          "980-6023",
          "980-6024",
          "980-6025",
          "980-6026",
          "980-6027",
          "980-6028",
          "980-6029",
          "980-6030",
          "981-0936",
          "980-0065",
          "981-0914",
          "981-0912",
          "980-0874",
          "981-0908",
          "981-0915",
          "980-0001",
          "981-0952",
          "989-3202",
          "989-3207",
          "989-3203",
          "981-0934",
          "981-0953",
          "989-3123",
          "980-0012",
          "989-3433",
          "989-3434",
          "980-0824",
          "980-0871",
          "981-0917",
          "981-0923",
          "980-0873",
          "980-0002",
          "981-0921",
          "981-0924",
          "980-0802",
          "980-0014",
          "981-0962",
          "989-3204",
          "989-3214",
          "980-0004",
          "989-3215",
          "982-0263",
          "981-0967",
          "989-3205",
          "989-3206",
          "983-0000",
          "983-0832",
          "983-0047",
          "983-0012",
          "983-0821",
          "983-0828",
          "983-0034",
          "983-0835",
          "983-0003",
          "983-0004",
          "983-0803",
          "983-0813",
          "983-0816",
          "983-0811",
          "983-0814",
          "983-0815",
          "983-0817",
          "983-0812",
          "983-0866",
          "983-0839",
          "983-0002",
          "983-0863",
          "983-0031",
          "983-0842",
          "983-0836",
          "983-0011",
          "983-0845",
          "983-0831",
          "983-0006",
          "983-0038",
          "983-0039",
          "983-0032",
          "983-0007",
          "983-0014",
          "983-0021",
          "983-0026",
          "983-0851",
          "983-0852",
          "983-0823",
          "983-0822",
          "983-0824",
          "983-0826",
          "983-0825",
          "983-0024",
          "983-0861",
          "983-0868",
          "983-0869",
          "983-0867",
          "983-0864",
          "983-0013",
          "983-0036",
          "983-0046",
          "983-0862",
          "983-0843",
          "983-0838",
          "983-0043",
          "983-0841",
          "983-0844",
          "983-0833",
          "983-0042",
          "983-0853",
          "983-0035",
          "983-0033",
          "983-0023",
          "983-0025",
          "983-0005",
          "983-0037",
          "983-0837",
          "983-0834",
          "983-0001",
          "985-0901",
          "983-0041",
          "983-0045",
          "983-0044",
          "983-0865",
          "984-0000",
          "984-0032",
          "984-0030",
          "984-0039",
          "984-0033",
          "984-0034",
          "984-0073",
          "984-0833",
          "984-0038",
          "984-0064",
          "984-0063",
          "984-0022",
          "984-0828",
          "984-0842",
          "984-0835",
          "984-0054",
          "984-0831",
          "984-0055",
          "984-0015",
          "984-0002",
          "984-0822",
          "984-0035",
          "984-0037",
          "984-0016",
          "984-0838",
          "984-0816",
          "984-0047",
          "984-0044",
          "984-0807",
          "984-0812",
          "984-0057",
          "984-0841",
          "984-0075",
          "984-0832",
          "984-0048",
          "984-0836",
          "984-0041",
          "984-0051",
          "984-0803",
          "984-0801",
          "984-0844",
          "984-0036",
          "984-0065",
          "984-0001",
          "984-0817",
          "984-0823",
          "984-0824",
          "984-0821",
          "984-0017",
          "984-0056",
          "984-0046",
          "984-0045",
          "984-0837",
          "984-0802",
          "984-0043",
          "984-0074",
          "984-0072",
          "984-0071",
          "984-0843",
          "984-0845",
          "984-0806",
          "984-0825",
          "984-0815",
          "984-0811",
          "984-0804",
          "984-0061",
          "984-0827",
          "984-0805",
          "984-0814",
          "984-0058",
          "984-0042",
          "984-0062",
          "984-0052",
          "984-0053",
          "984-0834",
          "984-0813",
          "984-0031",
          "984-0004",
          "984-0011",
          "984-0013",
          "984-0003",
          "984-0012",
          "984-0014",
          "984-0826",
          "982-0000",
          "982-0834",
          "982-0242",
          "982-0243",
          "982-0244",
          "982-0245",
          "982-0241",
          "982-0824",
          "982-0007",
          "982-0002",
          "982-0031",
          "982-0027",
          "982-0014",
          "982-0035",
          "982-0804",
          "982-0805",
          "982-0023",
          "982-0022",
          "982-0812",
          "982-0823",
          "982-0842",
          "982-0003",
          "982-0803",
          "982-0835",
          "982-0211",
          "981-1101",
          "982-0025",
          "982-0024",
          "982-0005",
          "982-0013",
          "982-0212",
          "982-0231",
          "982-0026",
          "982-0032",
          "982-0036",
          "982-0033",
          "981-1104",
          "981-1103",
          "982-0011",
          "982-0837",
          "982-0012",
          "982-0847",
          "982-0034",
          "981-1105",
          "982-0825",
          "982-0221",
          "982-0844",
          "982-0848",
          "982-0817",
          "982-0215",
          "982-0001",
          "982-0004",
          "982-0006",
          "981-1107",
          "982-0222",
          "982-0811",
          "981-1102",
          "982-0846",
          "982-0821",
          "982-0826",
          "982-0806",
          "982-0021",
          "982-0015",
          "982-0841",
          "982-0843",
          "982-0251",
          "982-0252",
          "982-0845",
          "982-0831",
          "982-0801",
          "982-0836",
          "982-0832",
          "982-0833",
          "982-0802",
          "982-0807",
          "981-1106",
          "982-0214",
          "982-0814",
          "982-0815",
          "982-0813",
          "982-0213",
          "982-0818",
          "982-0816",
          "982-0822",
          "981-3100",
          "981-3115",
          "981-3101",
          "981-3206",
          "981-8004",
          "981-3201",
          "981-3133",
          "981-3126",
          "981-3117",
          "981-3104",
          "981-3137",
          "981-3216",
          "981-3134",
          "981-3121",
          "981-3122",
          "981-3202",
          "981-3215",
          "981-8006",
          "981-3102",
          "981-3217",
          "981-3132",
          "981-3136",
          "981-3108",
          "981-3222",
          "981-3223",
          "981-3116",
          "981-3203",
          "981-3212",
          "981-3211",
          "981-3109",
          "981-3204",
          "981-3105",
          "981-3131",
          "981-8003",
          "981-8001",
          "981-8002",
          "981-3224",
          "981-3218",
          "981-8007",
          "981-3221",
          "981-3124",
          "981-8005",
          "981-3225",
          "981-3123",
          "981-3226",
          "981-3106",
          "981-3107",
          "981-3111",
          "981-3113",
          "981-3125",
          "981-3213",
          "981-3205",
          "981-3112",
          "981-3135",
          "981-3214",
          "981-3103",
          "981-3114",
          "986-0000",
          "986-0101",
          "986-0866",
          "986-0862",
          "986-0869",
          "986-0828",
          "986-2526",
          "986-2522",
          "986-2523",
          "986-2524",
          "986-0850",
          "986-0131",
          "986-0832",
          "986-2123",
          "986-0826",
          "986-0003",
          "986-0041",
          "986-2113",
          "986-0813",
          "986-0005",
          "986-0854",
          "986-0859",
          "986-0855",
          "986-0856",
          "986-0838",
          "986-0805",
          "986-2412",
          "986-2132",
          "986-0121",
          "986-2405",
          "986-1334",
          "986-1311",
          "986-1302",
          "986-1333",
          "986-1332",
          "986-1336",
          "986-1312",
          "986-1313",
          "986-1335",
          "986-1303",
          "986-1304",
          "986-1301",
          "986-1321",
          "986-1331",
          "986-1322",
          "986-2341",
          "986-0113",
          "986-2355",
          "986-0032",
          "986-0806",
          "986-0043",
          "986-0013",
          "986-0042",
          "986-0853",
          "986-0834",
          "986-1111",
          "986-0111",
          "986-0024",
          "986-0204",
          "986-0201",
          "986-0203",
          "986-0202",
          "986-0123",
          "987-1103",
          "986-2345",
          "986-2411",
          "986-2527",
          "986-2414",
          "986-0863",
          "986-0825",
          "986-2112",
          "986-2116",
          "986-2342",
          "986-2415",
          "986-0132",
          "986-2122",
          "986-0022",
          "986-2137",
          "986-2351",
          "986-2403",
          "986-0104",
          "986-2102",
          "986-2114",
          "986-0842",
          "986-0844",
          "986-2413",
          "986-0871",
          "986-0004",
          "986-0864",
          "986-2105",
          "986-0848",
          "986-0878",
          "986-0801",
          "986-0802",
          "987-1221",
          "986-0875",
          "986-2344",
          "986-0821",
          "986-0827",
          "986-0026",
          "986-0006",
          "986-2346",
          "986-0023",
          "986-0824",
          "986-0872",
          "986-2104",
          "986-0822",
          "986-2352",
          "986-0857",
          "986-0851",
          "986-2401",
          "986-0847",
          "986-0815",
          "986-0103",
          "986-0845",
          "986-0823",
          "986-0112",
          "986-0105",
          "986-2133",
          "986-0849",
          "986-2103",
          "986-0102",
          "986-0836",
          "986-2521",
          "986-0877",
          "986-0843",
          "986-0876",
          "986-2101",
          "986-2136",
          "986-0860",
          "986-0831",
          "986-0016",
          "986-2354",
          "986-2131",
          "986-0114",
          "986-0812",
          "986-0122",
          "986-0841",
          "986-0833",
          "987-1222",
          "986-0115",
          "986-0133",
          "986-0874",
          "986-2525",
          "986-2343",
          "986-0017",
          "986-0861",
          "986-2406",
          "987-1101",
          "986-2347",
          "986-0106",
          "986-0028",
          "986-2134",
          "986-0002",
          "986-0865",
          "986-2115",
          "986-0846",
          "986-0803",
          "986-0001",
          "986-0033",
          "986-0858",
          "986-2111",
          "986-0021",
          "986-0011",
          "986-0025",
          "986-0031",
          "986-0814",
          "986-0835",
          "986-0852",
          "986-0124",
          "986-0027",
          "986-0868",
          "986-0811",
          "986-0305",
          "986-0311",
          "986-0304",
          "986-0323",
          "986-0322",
          "986-0302",
          "986-0312",
          "986-0321",
          "986-0324",
          "986-0314",
          "986-0303",
          "986-0313",
          "986-0301",
          "986-2353",
          "986-2402",
          "986-0873",
          "986-0015",
          "986-0837",
          "986-2404",
          "986-0867",
          "986-2135",
          "986-2121",
          "987-1102",
          "985-0000",
          "985-0082",
          "985-0055",
          "985-0026",
          "985-0012",
          "985-0081",
          "985-0031",
          "985-0056",
          "985-0062",
          "985-0074",
          "985-0087",
          "985-0075",
          "985-0077",
          "985-0191",
          "985-0192",
          "985-0194",
          "985-0193",
          "985-0195",
          "985-0046",
          "985-0021",
          "985-0002",
          "985-0084",
          "985-0085",
          "985-0003",
          "985-0013",
          "985-0054",
          "985-0067",
          "985-0083",
          "985-0072",
          "985-0064",
          "985-0025",
          "985-0063",
          "985-0033",
          "985-0061",
          "985-0071",
          "985-0041",
          "985-0032",
          "985-0022",
          "985-0001",
          "985-0005",
          "985-0006",
          "985-0043",
          "985-0042",
          "985-0086",
          "985-0066",
          "985-0011",
          "985-0015",
          "985-0088",
          "985-0076",
          "985-0024",
          "985-0045",
          "985-0057",
          "985-0035",
          "985-0023",
          "985-0044",
          "985-0036",
          "985-0004",
          "985-0014",
          "985-0016",
          "985-0034",
          "985-0053",
          "985-0073",
          "985-0051",
          "985-0065",
          "985-0052",
          "988-0000",
          "988-0182",
          "988-0105",
          "988-0172",
          "988-0174",
          "988-0185",
          "988-0166",
          "988-0104",
          "988-0164",
          "988-0181",
          "988-0161",
          "988-0101",
          "988-0102",
          "988-0183",
          "988-0173",
          "988-0167",
          "988-0184",
          "988-0162",
          "988-0171",
          "988-0168",
          "988-0103",
          "988-0163",
          "988-0165",
          "988-0075",
          "988-0062",
          "988-0623",
          "988-0034",
          "988-0847",
          "988-0071",
          "988-0606",
          "988-0854",
          "988-0032",
          "988-0083",
          "988-0061",
          "988-0201",
          "988-0207",
          "988-0202",
          "988-0206",
          "988-0204",
          "988-0205",
          "988-0203",
          "988-0037",
          "988-0008",
          "988-0065",
          "988-0866",
          "988-0605",
          "988-0812",
          "988-0814",
          "988-0082",
          "988-0602",
          "988-0821",
          "988-0612",
          "988-0843",
          "988-0862",
          "988-0014",
          "988-0837",
          "988-0056",
          "988-0803",
          "988-0806",
          "988-0801",
          "988-0044",
          "988-0607",
          "988-0533",
          "988-0503",
          "988-0532",
          "988-0512",
          "988-0581",
          "988-0521",
          "988-0544",
          "988-0501",
          "988-0522",
          "988-0562",
          "988-0572",
          "988-0553",
          "988-0541",
          "988-0561",
          "988-0514",
          "988-0543",
          "988-0523",
          "988-0554",
          "988-0571",
          "988-0534",
          "988-0502",
          "988-0531",
          "988-0504",
          "988-0524",
          "988-0526",
          "988-0511",
          "988-0552",
          "988-0506",
          "988-0525",
          "988-0542",
          "988-0563",
          "988-0927",
          "988-0527",
          "988-0513",
          "988-0535",
          "988-0582",
          "988-0551",
          "988-0505",
          "988-0834",
          "988-0033",
          "988-0846",
          "988-0041",
          "988-0824",
          "988-0022",
          "988-0831",
          "988-0822",
          "988-0064",
          "988-0842",
          "988-0081",
          "988-0868",
          "988-0863",
          "988-0072",
          "988-0836",
          "988-0815",
          "988-0832",
          "988-0633",
          "988-0054",
          "988-0214",
          "988-0211",
          "988-0215",
          "988-0213",
          "988-0212",
          "988-0026",
          "988-0012",
          "988-0013",
          "988-0073",
          "988-0016",
          "988-0818",
          "988-0031",
          "988-0063",
          "988-0828",
          "988-0851",
          "988-0051",
          "988-0807",
          "988-0867",
          "988-0829",
          "988-0005",
          "988-0011",
          "988-0865",
          "988-0844",
          "988-0603",
          "988-0601",
          "988-0055",
          "988-0613",
          "988-0802",
          "988-0087",
          "988-0611",
          "988-0825",
          "988-0076",
          "988-0052",
          "988-0058",
          "988-0053",
          "988-0045",
          "988-0046",
          "988-0864",
          "988-0826",
          "988-0057",
          "988-0025",
          "988-0237",
          "988-0226",
          "988-0225",
          "988-0221",
          "988-0232",
          "988-0223",
          "988-0238",
          "988-0236",
          "988-0231",
          "988-0233",
          "988-0234",
          "988-0222",
          "988-0224",
          "988-0235",
          "988-0227",
          "988-0835",
          "988-0621",
          "988-0024",
          "988-0007",
          "988-0622",
          "988-0855",
          "988-0813",
          "988-0043",
          "988-0002",
          "988-0805",
          "988-0817",
          "988-0006",
          "988-0816",
          "988-0241",
          "988-0252",
          "988-0251",
          "988-0247",
          "988-0242",
          "988-0245",
          "988-0246",
          "988-0254",
          "988-0253",
          "988-0243",
          "988-0255",
          "988-0256",
          "988-0244",
          "988-0004",
          "988-0015",
          "988-0066",
          "988-0804",
          "988-0811",
          "988-0001",
          "988-0086",
          "988-0077",
          "988-0036",
          "988-0861",
          "988-0042",
          "988-0845",
          "988-0852",
          "988-0853",
          "988-0114",
          "988-0155",
          "988-0131",
          "988-0153",
          "988-0113",
          "988-0134",
          "988-0157",
          "988-0121",
          "988-0111",
          "988-0122",
          "988-0143",
          "988-0133",
          "988-0156",
          "988-0152",
          "988-0124",
          "988-0151",
          "988-0144",
          "988-0123",
          "988-0154",
          "988-0132",
          "988-0112",
          "988-0142",
          "988-0141",
          "988-0604",
          "988-0631",
          "988-0085",
          "988-0021",
          "988-0023",
          "988-0017",
          "988-0018",
          "988-0823",
          "988-0003",
          "988-0074",
          "988-0284",
          "988-0277",
          "988-0268",
          "988-0339",
          "988-0336",
          "988-0347",
          "988-0261",
          "988-0324",
          "988-0313",
          "988-0371",
          "988-0301",
          "988-0306",
          "988-0304",
          "988-0356",
          "988-0358",
          "988-0287",
          "988-0283",
          "988-0272",
          "988-0262",
          "988-0372",
          "988-0311",
          "988-0354",
          "988-0388",
          "988-0373",
          "988-0317",
          "988-0275",
          "988-0265",
          "988-0325",
          "988-0323",
          "988-0303",
          "988-0351",
          "988-0285",
          "988-0364",
          "988-0321",
          "988-0348",
          "988-0279",
          "988-0353",
          "988-0385",
          "988-0332",
          "988-0361",
          "988-0269",
          "988-0316",
          "988-0315",
          "988-0337",
          "988-0328",
          "988-0334",
          "988-0352",
          "988-0286",
          "988-0384",
          "988-0278",
          "988-0355",
          "988-0274",
          "988-0346",
          "988-0345",
          "988-0374",
          "988-0382",
          "988-0341",
          "988-0381",
          "988-0307",
          "988-0305",
          "988-0309",
          "988-0308",
          "988-0266",
          "988-0267",
          "988-0362",
          "988-0318",
          "988-0387",
          "988-0327",
          "988-0375",
          "988-0331",
          "988-0357",
          "988-0264",
          "988-0386",
          "988-0322",
          "988-0342",
          "988-0271",
          "988-0314",
          "988-0302",
          "988-0389",
          "988-0276",
          "988-0333",
          "988-0363",
          "988-0281",
          "988-0383",
          "988-0263",
          "988-0282",
          "988-0365",
          "988-0366",
          "988-0343",
          "988-0273",
          "988-0312",
          "988-0338",
          "988-0344",
          "988-0367",
          "988-0326",
          "988-0359",
          "988-0335",
          "988-0169",
          "988-0841",
          "988-0634",
          "988-0084",
          "988-0632",
          "988-0833",
          "988-0827",
          "989-0200",
          "989-0223",
          "989-0228",
          "989-0267",
          "989-0254",
          "989-0212",
          "989-0211",
          "989-0213",
          "989-0214",
          "989-0216",
          "989-0217",
          "989-0276",
          "989-0208",
          "989-0233",
          "989-0244",
          "989-0202",
          "989-0262",
          "989-0224",
          "989-0203",
          "989-0201",
          "989-0113",
          "989-0111",
          "989-0112",
          "989-0241",
          "989-0215",
          "989-0264",
          "989-0278",
          "989-0277",
          "989-0243",
          "989-0272",
          "989-0266",
          "989-0265",
          "989-0245",
          "989-0255",
          "989-1103",
          "989-1104",
          "989-1101",
          "989-1102",
          "989-0734",
          "989-0226",
          "989-0246",
          "989-0271",
          "989-0261",
          "989-0222",
          "989-0218",
          "989-0220",
          "989-0227",
          "989-0229",
          "989-0206",
          "989-0207",
          "989-0273",
          "989-0274",
          "989-0252",
          "989-0268",
          "989-0247",
          "989-0259",
          "989-0258",
          "989-0205",
          "989-0253",
          "989-0225",
          "989-0231",
          "989-0731",
          "989-0733",
          "989-0732",
          "989-0232",
          "989-0251",
          "989-0204",
          "989-0221",
          "989-0248",
          "989-0256",
          "989-0275",
          "989-0263",
          "989-0242",
          "989-0257",
          "981-1200",
          "981-1230",
          "981-1225",
          "981-1226",
          "981-1215",
          "981-1232",
          "981-1216",
          "981-1233",
          "981-1222",
          "981-1212",
          "989-2401",
          "981-1201",
          "981-1223",
          "981-1214",
          "981-1246",
          "981-1248",
          "981-1243",
          "981-1241",
          "981-1242",
          "981-1211",
          "981-1221",
          "981-1231",
          "981-1244",
          "981-1235",
          "981-1234",
          "989-2412",
          "989-2411",
          "981-1224",
          "981-1217",
          "981-1218",
          "981-1247",
          "981-1236",
          "981-1238",
          "981-1237",
          "981-1239",
          "981-1251",
          "981-1240",
          "981-1227",
          "981-1213",
          "981-1245",
          "981-1500",
          "981-1518",
          "981-1521",
          "981-1504",
          "981-1524",
          "981-1532",
          "981-1514",
          "981-1502",
          "981-1505",
          "981-1515",
          "981-1523",
          "981-1525",
          "981-1517",
          "981-1534",
          "981-1522",
          "981-1503",
          "981-1526",
          "981-1516",
          "981-1513",
          "981-1531",
          "981-1511",
          "981-1533",
          "981-1501",
          "981-1512",
          "985-0864",
          "985-0861",
          "985-0832",
          "985-0831",
          "985-0835",
          "985-0833",
          "985-0842",
          "985-0852",
          "985-0865",
          "985-0862",
          "985-0853",
          "985-0873",
          "985-0841",
          "985-0872",
          "985-0871",
          "985-0846",
          "985-0851",
          "985-0854",
          "985-0863",
          "985-0845",
          "985-0834",
          "985-0844",
          "985-0843",
          "985-0874",
          "989-2400",
          "989-2431",
          "989-2474",
          "989-2478",
          "989-2435",
          "989-2463",
          "989-2443",
          "989-2442",
          "989-2471",
          "989-2423",
          "989-2472",
          "989-2455",
          "989-2420",
          "989-2422",
          "989-2445",
          "989-2447",
          "989-2473",
          "989-2433",
          "989-2427",
          "989-2465",
          "989-2476",
          "989-2421",
          "989-2426",
          "989-2453",
          "989-2452",
          "989-2459",
          "989-2458",
          "989-2441",
          "989-2428",
          "989-2432",
          "989-2425",
          "989-2451",
          "989-2461",
          "989-2446",
          "989-2424",
          "989-2477",
          "989-2457",
          "989-2436",
          "989-2437",
          "989-2434",
          "989-2448",
          "989-2444",
          "989-2456",
          "989-2464",
          "989-2454",
          "989-2429",
          "989-2462",
          "989-2475",
          "987-0500",
          "989-4701",
          "989-4702",
          "989-4703",
          "986-0401",
          "986-0402",
          "987-0903",
          "987-0902",
          "987-0901",
          "987-0355",
          "987-0377",
          "987-0385",
          "987-0373",
          "987-0366",
          "987-0354",
          "987-0353",
          "987-0341",
          "987-0371",
          "987-0358",
          "987-0378",
          "987-0357",
          "987-0362",
          "987-0382",
          "987-0367",
          "987-0351",
          "987-0379",
          "987-0363",
          "987-0343",
          "987-0344",
          "987-0356",
          "987-0364",
          "987-0384",
          "987-0346",
          "987-0361",
          "987-0381",
          "987-0376",
          "987-0365",
          "987-0352",
          "987-0383",
          "987-0345",
          "987-0368",
          "987-0372",
          "987-0359",
          "987-0374",
          "987-0375",
          "987-0342",
          "987-0701",
          "987-0702",
          "987-0703",
          "987-0704",
          "987-0611",
          "987-0601",
          "987-0602",
          "987-0621",
          "987-0622",
          "987-0623",
          "987-0513",
          "987-0511",
          "989-4601",
          "987-0512",
          "987-0432",
          "987-0441",
          "987-0412",
          "987-0444",
          "987-0411",
          "987-0443",
          "987-0402",
          "987-0431",
          "987-0442",
          "987-0403",
          "987-0414",
          "987-0433",
          "987-0423",
          "987-0421",
          "987-0422",
          "987-0426",
          "987-0424",
          "987-0425",
          "987-0413",
          "987-0445",
          "987-0404",
          "987-0446",
          "987-0401",
          "987-0447",
          "987-0405",
          "987-0415",
          "987-0307",
          "987-0304",
          "987-0305",
          "987-0308",
          "987-0311",
          "987-0306",
          "987-0301",
          "987-0309",
          "987-0303",
          "987-0331",
          "987-0321",
          "987-0302",
          "987-2200",
          "987-2372",
          "987-2369",
          "987-2336",
          "987-2343",
          "987-2364",
          "987-2351",
          "987-2301",
          "987-2362",
          "987-2346",
          "987-2348",
          "987-2314",
          "987-2313",
          "987-2312",
          "987-2355",
          "987-2302",
          "987-2367",
          "987-2353",
          "987-2339",
          "987-2303",
          "987-2371",
          "987-2304",
          "987-2305",
          "987-2317",
          "987-2315",
          "987-2316",
          "987-2325",
          "987-2363",
          "987-2359",
          "987-2342",
          "987-2352",
          "987-2306",
          "987-2374",
          "987-2368",
          "987-2358",
          "987-2334",
          "987-2365",
          "987-2307",
          "987-2349",
          "987-2335",
          "987-2332",
          "987-2328",
          "987-2327",
          "987-2361",
          "987-2341",
          "987-2354",
          "987-2357",
          "987-2331",
          "987-2338",
          "987-2347",
          "987-2373",
          "987-2329",
          "987-2308",
          "987-2318",
          "987-2337",
          "987-2311",
          "987-2324",
          "987-2344",
          "987-2319",
          "987-2323",
          "987-2345",
          "987-2309",
          "987-2326",
          "987-2356",
          "987-2333",
          "987-2321",
          "987-2322",
          "987-2366",
          "989-5403",
          "989-5402",
          "989-5401",
          "989-4807",
          "989-5172",
          "989-4806",
          "989-5127",
          "989-5142",
          "989-5118",
          "989-5146",
          "989-5112",
          "989-5119",
          "989-5163",
          "989-5116",
          "989-5185",
          "989-5121",
          "989-5138",
          "989-5141",
          "989-5183",
          "989-5184",
          "989-4805",
          "989-5128",
          "989-5115",
          "989-5137",
          "989-5154",
          "989-5155",
          "989-5153",
          "989-5164",
          "989-5136",
          "989-5139",
          "989-5151",
          "989-5171",
          "989-5130",
          "989-5114",
          "989-5133",
          "989-5134",
          "989-4802",
          "989-5135",
          "989-5125",
          "989-5161",
          "989-5181",
          "989-5126",
          "989-5165",
          "989-5162",
          "989-5166",
          "989-5144",
          "989-5145",
          "989-5173",
          "989-5117",
          "989-5111",
          "989-5131",
          "989-4808",
          "989-4803",
          "989-5123",
          "989-5143",
          "989-5132",
          "989-5122",
          "989-5113",
          "989-5124",
          "989-5152",
          "989-5331",
          "989-5341",
          "989-5332",
          "989-5301",
          "989-5333",
          "989-5321",
          "989-5322",
          "989-5312",
          "989-5311",
          "989-5381",
          "989-5351",
          "989-5371",
          "989-5323",
          "989-5382",
          "989-5372",
          "989-5334",
          "989-5361",
          "989-5324",
          "989-5335",
          "989-5608",
          "989-5606",
          "989-5603",
          "989-5601",
          "989-5605",
          "989-5627",
          "989-5607",
          "989-5621",
          "989-5602",
          "989-5616",
          "989-5612",
          "989-5613",
          "989-5617",
          "989-5614",
          "989-5618",
          "989-5604",
          "989-5626",
          "989-5615",
          "989-5609",
          "989-5625",
          "989-5611",
          "989-5624",
          "989-5623",
          "989-5622",
          "989-5610",
          "989-5619",
          "989-4533",
          "989-4549",
          "989-4534",
          "989-4535",
          "989-4545",
          "989-4541",
          "989-4540",
          "989-4580",
          "989-4583",
          "989-4568",
          "989-4509",
          "989-4588",
          "989-4557",
          "989-4547",
          "989-4563",
          "989-4566",
          "989-4505",
          "989-4562",
          "989-4574",
          "989-4523",
          "989-4577",
          "989-4578",
          "989-4518",
          "989-4576",
          "989-4504",
          "989-4582",
          "989-4585",
          "989-4551",
          "989-4508",
          "989-4506",
          "989-4584",
          "989-4521",
          "989-4522",
          "989-4512",
          "989-4525",
          "989-4573",
          "989-4510",
          "989-4529",
          "989-4560",
          "989-4538",
          "989-4586",
          "989-4536",
          "989-4503",
          "989-4516",
          "989-4572",
          "989-4571",
          "989-4565",
          "989-4531",
          "989-4569",
          "989-4589",
          "989-4548",
          "989-4542",
          "989-4543",
          "989-4507",
          "989-4567",
          "989-4511",
          "989-4513",
          "989-4555",
          "989-4544",
          "989-4579",
          "989-4554",
          "989-4532",
          "989-4561",
          "989-4556",
          "989-4517",
          "989-4581",
          "989-4524",
          "989-4539",
          "989-4553",
          "989-4537",
          "989-4575",
          "989-4570",
          "989-4526",
          "989-4527",
          "989-4552",
          "989-4515",
          "989-4514",
          "989-4587",
          "989-4564",
          "989-4528",
          "989-4519",
          "989-4546",
          "987-2033",
          "987-2035",
          "987-2185",
          "987-2017",
          "987-2018",
          "987-2115",
          "987-2004",
          "987-2014",
          "987-2025",
          "987-2054",
          "987-2146",
          "987-2188",
          "987-2024",
          "987-2113",
          "987-2143",
          "987-2111",
          "987-2013",
          "987-2173",
          "987-2001",
          "987-2112",
          "987-2174",
          "987-2121",
          "987-2141",
          "987-2158",
          "987-2155",
          "987-2147",
          "987-2021",
          "987-2153",
          "987-2011",
          "987-2026",
          "987-2023",
          "987-2175",
          "987-2133",
          "987-2055",
          "987-2127",
          "987-2128",
          "987-2189",
          "987-2114",
          "987-2124",
          "987-2125",
          "987-2042",
          "987-2163",
          "987-2177",
          "987-2123",
          "987-2164",
          "987-2031",
          "987-2161",
          "987-2156",
          "987-2184",
          "987-2183",
          "987-2142",
          "987-2126",
          "987-2144",
          "987-2171",
          "987-2044",
          "987-2162",
          "987-2043",
          "987-2152",
          "987-2182",
          "987-2122",
          "987-2157",
          "987-2012",
          "987-2186",
          "987-2176",
          "987-2045",
          "987-2015",
          "987-2005",
          "987-2022",
          "987-2151",
          "987-2181",
          "987-2132",
          "987-2028",
          "987-2003",
          "987-2053",
          "987-2159",
          "987-2172",
          "987-2131",
          "987-2036",
          "987-2154",
          "987-2051",
          "987-2052",
          "987-2034",
          "987-2145",
          "987-2187",
          "987-2016",
          "987-2002",
          "987-2041",
          "987-2032",
          "987-2116",
          "987-2027",
          "987-2253",
          "987-2231",
          "987-2245",
          "987-2216",
          "987-2271",
          "987-2214",
          "987-2213",
          "987-2225",
          "987-2236",
          "987-2246",
          "987-2275",
          "987-2262",
          "987-2228",
          "987-2212",
          "987-2261",
          "987-2204",
          "987-2211",
          "987-2273",
          "987-2265",
          "987-2232",
          "987-2247",
          "987-2221",
          "987-2203",
          "987-2202",
          "987-2263",
          "987-2274",
          "987-2234",
          "987-2222",
          "987-2215",
          "987-2242",
          "987-2241",
          "987-2235",
          "987-2233",
          "987-2201",
          "987-2272",
          "987-2244",
          "987-2223",
          "987-2243",
          "987-2227",
          "987-2251",
          "987-2229",
          "987-2205",
          "987-2252",
          "987-2264",
          "987-2226",
          "987-2224",
          "987-2512",
          "989-6701",
          "987-2511",
          "989-5507",
          "989-5506",
          "989-5509",
          "989-5504",
          "989-5501",
          "989-5502",
          "989-5503",
          "989-5505",
          "989-5508",
          "981-0500",
          "981-0506",
          "981-0501",
          "981-0415",
          "981-0301",
          "981-0505",
          "981-0414",
          "981-0502",
          "981-0303",
          "981-0304",
          "981-0504",
          "981-0305",
          "981-0413",
          "981-0308",
          "981-0306",
          "981-0307",
          "981-0309",
          "981-0411",
          "981-0416",
          "981-0302",
          "981-0412",
          "981-0503",
          "989-6100",
          "989-6463",
          "989-6405",
          "989-6435",
          "989-6447",
          "989-6432",
          "989-6433",
          "989-6431",
          "989-6465",
          "989-6421",
          "989-6403",
          "989-6404",
          "989-6442",
          "989-6414",
          "989-6434",
          "989-6464",
          "989-6412",
          "989-6422",
          "989-6437",
          "989-6446",
          "989-6441",
          "989-6443",
          "989-6425",
          "989-6436",
          "989-6426",
          "989-6415",
          "989-6413",
          "989-6462",
          "989-6411",
          "989-6444",
          "989-6466",
          "989-6423",
          "989-6461",
          "989-6424",
          "989-6445",
          "989-6402",
          "989-6401",
          "989-6471",
          "989-4106",
          "989-4102",
          "989-4103",
          "989-4104",
          "989-4105",
          "989-4101",
          "989-6321",
          "989-6304",
          "989-6312",
          "989-6305",
          "989-6303",
          "989-6313",
          "989-6302",
          "989-6301",
          "989-6314",
          "989-6311",
          "989-6306",
          "989-6316",
          "989-6315",
          "989-6317",
          "989-6322",
          "989-4415",
          "989-4303",
          "989-4302",
          "989-4412",
          "989-4305",
          "989-4301",
          "989-4304",
          "989-4307",
          "989-4414",
          "989-4419",
          "989-4306",
          "989-4418",
          "989-4413",
          "989-4416",
          "989-4417",
          "989-4308",
          "989-4411",
          "989-6711",
          "989-6811",
          "989-6806",
          "989-6805",
          "989-6838",
          "989-6803",
          "989-6941",
          "989-6712",
          "989-6825",
          "989-6833",
          "989-6824",
          "989-6821",
          "989-6827",
          "989-6822",
          "989-6801",
          "989-6802",
          "989-6804",
          "989-6834",
          "989-6826",
          "989-6832",
          "989-6807",
          "989-6835",
          "989-6837",
          "989-6831",
          "989-6836",
          "989-6823",
          "989-6223",
          "989-6117",
          "989-6243",
          "989-6164",
          "989-6212",
          "989-6252",
          "989-6203",
          "989-6124",
          "989-6135",
          "989-6173",
          "989-6103",
          "989-6104",
          "989-6102",
          "989-6115",
          "989-6162",
          "989-6161",
          "989-6227",
          "989-6114",
          "989-6221",
          "989-6234",
          "989-6216",
          "989-6131",
          "989-6264",
          "989-6202",
          "989-6236",
          "989-6167",
          "989-6145",
          "989-6171",
          "989-6242",
          "989-6254",
          "989-6244",
          "989-6122",
          "989-6224",
          "989-6144",
          "989-6251",
          "989-6211",
          "989-6106",
          "989-6128",
          "989-6157",
          "989-6233",
          "989-6232",
          "989-6201",
          "989-6228",
          "989-6241",
          "989-6123",
          "989-6263",
          "989-6151",
          "989-6116",
          "989-6175",
          "989-6174",
          "989-6163",
          "989-6126",
          "989-6225",
          "989-6207",
          "989-6111",
          "989-6165",
          "989-6266",
          "989-6231",
          "989-6261",
          "989-6143",
          "989-6206",
          "989-6142",
          "989-6153",
          "989-6226",
          "989-6205",
          "989-6214",
          "989-6133",
          "989-6156",
          "989-6152",
          "989-6166",
          "989-6208",
          "989-6121",
          "989-6101",
          "989-6105",
          "989-6265",
          "989-6136",
          "989-6213",
          "989-6172",
          "989-6262",
          "989-6253",
          "989-6112",
          "989-6154",
          "989-6217",
          "989-6141",
          "989-6155",
          "989-6113",
          "989-6215",
          "989-6127",
          "989-6235",
          "989-6125",
          "989-6255",
          "989-6204",
          "989-6134",
          "989-6132",
          "989-6222",
          "987-1303",
          "987-1306",
          "987-1301",
          "987-1304",
          "987-1305",
          "987-1302",
          "981-3300",
          "981-3326",
          "981-3332",
          "981-3361",
          "981-3325",
          "981-3305",
          "981-3322",
          "981-3323",
          "981-3329",
          "981-3321",
          "981-3328",
          "981-3327",
          "981-3302",
          "981-3301",
          "981-3303",
          "981-3351",
          "981-3313",
          "981-3312",
          "981-3352",
          "981-3311",
          "981-3341",
          "981-3324",
          "981-3306",
          "981-3331",
          "981-3362",
          "981-3304",
          "981-3363",
          "989-0800",
          "989-0921",
          "989-0821",
          "989-0841",
          "989-0842",
          "989-0916",
          "989-0914",
          "989-0915",
          "989-0911",
          "989-0912",
          "989-0913",
          "989-0831",
          "989-0851",
          "989-0701",
          "989-0843",
          "989-0500",
          "989-0662",
          "989-0556",
          "989-0506",
          "989-0635",
          "989-0522",
          "989-0643",
          "989-0644",
          "989-0537",
          "989-0631",
          "989-0507",
          "989-0529",
          "989-0516",
          "989-0553",
          "989-0501",
          "989-0543",
          "989-0524",
          "989-0613",
          "989-0504",
          "989-0505",
          "989-0623",
          "989-0517",
          "989-0519",
          "989-0513",
          "989-0527",
          "989-0664",
          "989-0536",
          "989-0561",
          "989-0634",
          "989-0628",
          "989-0661",
          "989-0627",
          "989-0528",
          "989-0541",
          "989-0542",
          "989-0518",
          "989-0514",
          "989-0554",
          "989-0521",
          "989-0616",
          "989-0512",
          "989-0617",
          "989-0555",
          "989-0523",
          "989-0633",
          "989-0632",
          "989-0655",
          "989-0508",
          "989-0602",
          "989-0654",
          "989-0621",
          "989-0625",
          "989-0622",
          "989-0614",
          "989-0547",
          "989-0544",
          "989-0535",
          "989-0549",
          "989-0552",
          "989-0502",
          "989-0557",
          "989-0615",
          "989-0532",
          "989-0545",
          "989-0546",
          "989-0666",
          "989-0651",
          "989-0652",
          "989-0663",
          "989-0641",
          "989-0657",
          "989-0515",
          "989-0511",
          "989-0612",
          "989-0665",
          "989-0667",
          "989-0658",
          "989-0624",
          "989-0526",
          "989-0601",
          "989-0626",
          "989-0531",
          "989-0533",
          "989-0551",
          "989-0548",
          "989-0656",
          "989-0611",
          "989-0653",
          "989-0503",
          "989-0525",
          "989-0636",
          "989-0534",
          "989-0642",
          "989-1200",
          "989-1203",
          "989-1237",
          "989-1205",
          "989-1204",
          "989-1261",
          "989-1201",
          "989-1263",
          "989-1267",
          "989-1258",
          "989-1249",
          "989-1224",
          "989-1233",
          "989-1207",
          "989-1214",
          "989-1216",
          "989-1264",
          "989-1274",
          "989-1234",
          "989-1246",
          "989-1245",
          "989-1213",
          "989-1266",
          "989-1255",
          "989-1202",
          "989-1256",
          "989-1248",
          "989-1231",
          "989-1215",
          "989-1206",
          "989-1222",
          "989-1253",
          "989-1242",
          "989-1217",
          "989-1273",
          "989-1244",
          "989-1257",
          "989-1254",
          "989-1251",
          "989-1247",
          "989-1271",
          "989-1223",
          "989-1236",
          "989-1225",
          "989-1211",
          "989-1259",
          "989-1241",
          "989-1221",
          "989-1243",
          "989-1232",
          "989-1272",
          "989-1235",
          "989-1252",
          "989-1212",
          "989-1300",
          "989-1511",
          "989-1311",
          "989-1303",
          "989-1302",
          "989-1301",
          "989-1322",
          "989-1304",
          "989-1323",
          "989-1321",
          "989-1305",
          "989-1600",
          "989-1745",
          "989-1762",
          "989-1742",
          "989-1611",
          "989-1623",
          "989-1608",
          "989-1764",
          "989-1613",
          "989-1756",
          "989-1758",
          "989-1753",
          "989-1752",
          "989-1754",
          "989-1751",
          "989-1755",
          "989-1757",
          "989-1741",
          "989-1612",
          "989-1765",
          "989-1622",
          "989-1761",
          "989-1731",
          "989-1631",
          "989-1606",
          "989-1607",
          "989-1601",
          "989-1602",
          "989-1604",
          "989-1603",
          "989-1605",
          "989-1763",
          "989-1621",
          "989-1744",
          "989-1746",
          "989-1743",
          "989-1500",
          "989-0908",
          "989-1502",
          "989-1505",
          "989-1503",
          "989-1507",
          "989-1506",
          "989-0901",
          "989-1501",
          "989-1504",
          "981-2100",
          "981-2114",
          "981-2133",
          "981-2173",
          "981-2122",
          "981-2187",
          "981-2142",
          "981-2183",
          "981-2116",
          "981-2112",
          "981-2141",
          "981-2182",
          "981-2131",
          "981-2115",
          "981-2132",
          "981-2126",
          "981-2156",
          "981-2501",
          "981-2154",
          "981-2104",
          "981-2301",
          "981-2302",
          "981-2144",
          "981-2174",
          "981-2146",
          "981-2184",
          "981-2155",
          "981-2402",
          "981-2153",
          "981-2145",
          "981-2106",
          "981-2124",
          "981-2185",
          "981-2123",
          "981-2303",
          "981-2113",
          "981-2143",
          "981-2401",
          "981-2186",
          "981-2181",
          "981-2172",
          "981-2171",
          "981-2117",
          "981-2111",
          "981-2151",
          "981-2166",
          "981-2101",
          "981-2102",
          "981-2105",
          "981-2103",
          "981-2167",
          "981-2168",
          "981-2134",
          "981-2152",
          "981-2127",
          "981-2163",
          "981-2161",
          "981-2162",
          "981-2201",
          "981-2125",
          "981-2164",
          "981-2165",
          "981-2121",
          "989-2300",
          "989-2351",
          "989-2361",
          "989-2311",
          "989-2385",
          "989-2302",
          "989-2321",
          "989-2371",
          "989-2381",
          "989-2324",
          "989-2384",
          "989-2323",
          "989-2382",
          "989-2303",
          "989-2372",
          "989-2383",
          "989-2301",
          "989-2322",
          "989-2341",
          "989-2352",
          "989-2331",
          "989-2200",
          "989-2203",
          "989-2206",
          "989-2205",
          "989-2111",
          "989-2202",
          "989-2208",
          "989-2207",
          "989-2112",
          "989-2201",
          "989-2204",
          "981-0200",
          "981-0212",
          "981-0202",
          "981-0214",
          "981-0215",
          "981-0201",
          "981-0211",
          "981-0203",
          "981-0205",
          "981-0204",
          "981-0213",
          "985-0824",
          "985-0805",
          "985-0821",
          "985-0822",
          "985-0811",
          "985-0804",
          "985-0823",
          "985-0803",
          "985-0812",
          "985-0813",
          "985-0801",
          "985-0802",
          "981-0100",
          "981-0133",
          "981-0131",
          "981-0101",
          "981-0113",
          "981-0102",
          "981-0111",
          "981-0121",
          "981-0123",
          "981-0124",
          "981-0134",
          "981-0114",
          "981-0122",
          "981-0135",
          "981-0104",
          "981-0132",
          "981-0105",
          "981-0136",
          "981-0103",
          "981-0112",
          "981-3600",
          "981-3404",
          "981-3401",
          "981-3406",
          "981-3403",
          "981-3402",
          "981-3405",
          "981-3407",
          "981-3623",
          "981-3271",
          "981-3414",
          "981-3411",
          "981-3415",
          "981-3417",
          "981-3418",
          "981-3412",
          "981-3413",
          "981-3416",
          "981-3629",
          "981-3419",
          "981-3408",
          "981-3624",
          "981-3622",
          "981-3628",
          "981-3621",
          "981-3631",
          "981-3627",
          "981-3632",
          "981-3626",
          "981-3625",
          "981-3409",
          "981-3500",
          "981-3503",
          "981-3524",
          "981-3501",
          "981-3502",
          "981-3514",
          "981-3512",
          "981-3523",
          "981-3521",
          "981-3515",
          "981-3522",
          "981-3513",
          "981-3511",
          "981-3601",
          "981-3602",
          "981-3605",
          "981-3603",
          "981-3607",
          "981-3606",
          "981-3604",
          "981-3609",
          "981-3611",
          "981-3612",
          "981-3608",
          "981-4100",
          "981-4121",
          "981-4141",
          "981-4101",
          "981-4111",
          "981-4151",
          "981-4122",
          "981-4112",
          "981-4131",
          "981-4102",
          "981-4103",
          "981-4104",
          "981-4105",
          "981-4200",
          "981-4264",
          "981-4375",
          "981-4275",
          "981-4323",
          "981-4311",
          "981-4328",
          "981-4262",
          "981-4274",
          "981-4277",
          "981-4356",
          "981-4327",
          "981-4343",
          "981-4368",
          "981-4255",
          "981-4226",
          "981-4228",
          "981-4367",
          "981-4355",
          "981-4211",
          "981-4273",
          "981-4201",
          "981-4374",
          "981-4263",
          "981-4402",
          "981-4322",
          "981-4331",
          "981-4326",
          "981-4324",
          "981-4254",
          "981-4224",
          "981-4419",
          "981-4417",
          "981-4234",
          "981-4235",
          "981-4304",
          "981-4319",
          "981-4418",
          "981-4362",
          "981-4325",
          "981-4415",
          "981-4318",
          "981-4212",
          "981-4256",
          "981-4345",
          "981-4336",
          "981-4202",
          "981-4222",
          "981-4302",
          "981-4321",
          "981-4272",
          "981-4357",
          "981-4227",
          "981-4376",
          "981-4225",
          "981-4335",
          "981-4317",
          "981-4377",
          "981-4223",
          "981-4253",
          "981-4363",
          "981-4314",
          "981-4372",
          "981-4312",
          "981-4316",
          "981-4329",
          "981-4353",
          "981-4306",
          "981-4301",
          "981-4361",
          "981-4231",
          "981-4232",
          "981-4233",
          "981-4412",
          "981-4413",
          "981-4315",
          "981-4337",
          "981-4333",
          "981-4341",
          "981-4308",
          "981-4203",
          "981-4252",
          "981-4358",
          "981-4251",
          "981-4313",
          "981-4416",
          "981-4365",
          "981-4352",
          "981-4271",
          "981-4371",
          "981-4347",
          "981-4342",
          "981-4373",
          "981-4344",
          "981-4346",
          "981-4213",
          "981-4354",
          "981-4303",
          "981-4414",
          "981-4261",
          "981-4242",
          "981-4334",
          "981-4364",
          "981-4366",
          "981-4351",
          "981-4332",
          "981-4241",
          "981-4401",
          "981-4305",
          "981-4276",
          "981-4229",
          "981-4265",
          "981-4411",
          "981-4403",
          "981-4221",
          "981-4309",
          "987-0100",
          "987-0133",
          "987-0145",
          "987-0136",
          "987-0284",
          "987-0103",
          "987-0142",
          "987-0165",
          "987-0282",
          "987-0144",
          "987-0281",
          "987-0102",
          "987-0171",
          "987-0164",
          "987-0161",
          "987-0134",
          "987-0131",
          "987-0132",
          "987-0112",
          "987-0147",
          "987-0151",
          "987-0135",
          "987-0101",
          "987-0148",
          "987-0113",
          "987-0172",
          "987-0140",
          "987-0130",
          "987-0149",
          "987-0138",
          "987-0139",
          "987-0137",
          "987-0115",
          "987-0114",
          "987-0163",
          "987-0104",
          "987-0141",
          "987-0146",
          "987-0143",
          "987-0286",
          "987-0105",
          "987-0285",
          "987-0162",
          "987-0111",
          "987-0283",
          "987-0106",
          "987-0107",
          "987-0121",
          "987-0000",
          "987-0015",
          "987-0056",
          "987-0004",
          "987-0045",
          "987-0038",
          "989-4204",
          "987-0022",
          "987-0032",
          "987-0065",
          "987-0005",
          "987-0069",
          "987-0057",
          "989-4205",
          "987-0034",
          "987-0063",
          "987-0064",
          "987-0033",
          "987-0036",
          "987-0011",
          "987-0058",
          "987-0059",
          "987-0014",
          "987-0035",
          "987-0061",
          "987-0053",
          "987-0051",
          "987-0055",
          "987-0043",
          "987-0068",
          "989-4209",
          "987-0037",
          "987-0052",
          "987-0006",
          "987-0013",
          "987-0012",
          "987-0067",
          "987-0031",
          "987-0054",
          "989-4207",
          "989-4208",
          "987-0024",
          "987-0025",
          "989-4206",
          "987-0044",
          "989-4203",
          "987-0021",
          "989-4202",
          "987-0001",
          "987-0002",
          "987-0066",
          "987-0062",
          "987-0003",
          "987-0026",
          "987-0041",
          "987-0042",
          "987-0046",
          "989-4201",
          "986-2200",
          "986-2251",
          "986-2222",
          "986-2281",
          "986-2211",
          "986-2263",
          "986-2283",
          "986-2249",
          "986-2231",
          "986-2212",
          "986-2202",
          "986-2224",
          "986-2266",
          "986-2240",
          "986-2265",
          "986-2261",
          "986-2205",
          "986-2264",
          "986-2204",
          "986-2246",
          "986-2248",
          "986-2242",
          "986-2244",
          "986-2201",
          "986-2262",
          "986-2226",
          "986-2203",
          "986-2221",
          "986-2223",
          "986-2232",
          "986-2282",
          "986-2225",
          "986-2247",
          "986-2243",
          "986-0700",
          "986-0782",
          "988-0453",
          "988-0471",
          "988-0426",
          "988-0446",
          "988-0434",
          "988-0448",
          "988-0463",
          "988-0443",
          "988-0476",
          "988-0413",
          "988-0425",
          "988-0456",
          "988-0424",
          "988-0405",
          "988-0451",
          "988-0436",
          "988-0435",
          "988-0467",
          "988-0475",
          "988-0462",
          "988-0474",
          "988-0445",
          "988-0415",
          "988-0441",
          "988-0411",
          "988-0444",
          "988-0473",
          "988-0414",
          "988-0447",
          "988-0406",
          "988-0403",
          "988-0432",
          "988-0431",
          "988-0401",
          "988-0465",
          "988-0433",
          "988-0477",
          "988-0442",
          "988-0478",
          "988-0421",
          "988-0466",
          "988-0404",
          "988-0423",
          "988-0452",
          "988-0422",
          "988-0402",
          "988-0412",
          "988-0454",
          "988-0472",
          "988-0464",
          "988-0455",
          "988-0461",
          "986-0772",
          "986-0733",
          "986-0705",
          "986-0707",
          "986-0726",
          "986-0752",
          "986-0709",
          "986-0764",
          "986-0771",
          "986-0718",
          "986-0731",
          "986-0732",
          "986-0714",
          "986-0751",
          "986-0777",
          "986-0712",
          "986-0773",
          "986-0766",
          "986-0768",
          "986-0721",
          "986-0774",
          "986-0711",
          "986-0762",
          "986-0763",
          "986-0706",
          "986-0778",
          "986-0703",
          "986-0753",
          "986-0754",
          "986-0717",
          "986-0722",
          "986-0776",
          "986-0779",
          "986-0723",
          "986-0728",
          "986-0729",
          "986-0741",
          "986-0767",
          "986-0727",
          "986-0701",
          "986-0725",
          "986-0765",
          "986-0716",
          "986-0724",
          "986-0713",
          "986-0715",
          "986-0702",
          "986-0708",
          "986-0775",
          "986-0761",
          "986-0743",
          "986-0742",
          "986-0704",
          "986-0781",
          "010-0000",
          "010-0831",
          "010-0833",
          "010-0832",
          "010-0834",
          "010-1613",
          "010-1632",
          "010-1637",
          "010-1634",
          "010-1638",
          "010-1603",
          "010-1605",
          "010-1608",
          "010-1621",
          "010-1606",
          "010-1602",
          "010-1642",
          "010-1641",
          "010-1644",
          "010-1643",
          "010-1645",
          "010-1611",
          "010-1633",
          "010-1636",
          "010-1622",
          "010-1615",
          "010-1635",
          "010-1617",
          "010-1616",
          "010-1618",
          "010-1604",
          "010-1607",
          "010-1631",
          "010-1612",
          "010-1614",
          "010-1623",
          "011-0911",
          "011-0949",
          "011-0912",
          "011-0916",
          "011-0947",
          "011-0928",
          "011-0925",
          "011-0924",
          "011-0948",
          "011-0913",
          "011-0923",
          "011-0922",
          "011-0921",
          "011-0914",
          "011-0917",
          "011-0915",
          "010-0816",
          "010-0813",
          "010-0811",
          "010-0916",
          "010-0817",
          "010-0917",
          "010-0815",
          "010-0814",
          "010-0812",
          "010-0918",
          "010-0064",
          "010-0062",
          "010-0063",
          "010-0066",
          "010-1436",
          "010-1420",
          "010-0921",
          "010-1428",
          "010-1424",
          "010-1425",
          "010-0061",
          "010-0111",
          "010-0113",
          "010-0126",
          "010-0115",
          "010-0123",
          "010-0121",
          "010-0116",
          "010-0114",
          "010-0125",
          "010-0124",
          "010-0112",
          "010-0122",
          "010-1403",
          "010-1401",
          "010-1408",
          "010-1405",
          "010-1402",
          "010-1404",
          "010-1411",
          "010-1406",
          "010-1407",
          "010-0137",
          "010-0132",
          "010-0135",
          "010-0131",
          "010-0136",
          "010-0138",
          "010-0134",
          "010-0133",
          "010-0947",
          "010-0942",
          "010-0943",
          "010-0948",
          "010-0946",
          "010-0945",
          "010-0944",
          "010-0941",
          "019-2623",
          "019-2741",
          "019-2624",
          "019-2632",
          "019-2625",
          "019-2742",
          "019-2631",
          "019-2622",
          "019-2611",
          "019-2614",
          "019-2612",
          "019-2613",
          "019-2621",
          "019-2601",
          "010-0935",
          "010-0932",
          "010-0933",
          "010-0934",
          "010-0931",
          "010-0925",
          "010-0922",
          "010-0924",
          "010-0923",
          "011-0927",
          "011-0926",
          "010-0966",
          "010-0967",
          "010-1412",
          "010-1413",
          "010-1419",
          "010-1414",
          "010-1415",
          "010-0042",
          "010-0043",
          "010-0059",
          "010-0823",
          "010-0951",
          "010-0952",
          "010-0955",
          "010-0953",
          "010-0954",
          "010-0956",
          "010-0056",
          "010-0058",
          "010-0053",
          "010-0054",
          "010-0055",
          "010-0057",
          "010-0051",
          "010-0052",
          "010-0142",
          "010-0144",
          "010-0143",
          "010-0145",
          "010-0146",
          "010-0141",
          "010-1501",
          "010-1502",
          "010-1506",
          "010-1505",
          "010-1503",
          "010-1504",
          "011-0932",
          "011-0934",
          "011-0933",
          "011-0935",
          "011-0931",
          "011-0936",
          "010-0826",
          "010-0872",
          "010-0874",
          "010-0876",
          "010-0873",
          "010-0871",
          "010-0875",
          "010-0877",
          "010-0822",
          "010-0802",
          "010-0804",
          "010-0803",
          "010-1105",
          "010-1104",
          "010-1103",
          "010-1101",
          "010-1102",
          "010-1106",
          "011-0944",
          "011-0951",
          "011-0946",
          "011-0942",
          "011-0945",
          "011-0943",
          "011-0941",
          "010-0851",
          "010-0861",
          "010-0852",
          "010-0863",
          "010-0865",
          "010-0864",
          "010-0862",
          "010-0854",
          "010-0844",
          "010-0843",
          "010-0841",
          "010-0845",
          "010-0842",
          "011-0901",
          "011-0903",
          "011-0906",
          "011-0938",
          "011-0908",
          "011-0939",
          "011-0905",
          "011-0937",
          "011-0909",
          "011-0902",
          "011-0904",
          "011-0907",
          "010-1651",
          "010-1653",
          "010-1652",
          "010-0001",
          "010-0034",
          "010-0037",
          "010-0033",
          "010-0032",
          "010-0031",
          "010-0029",
          "010-0028",
          "010-0036",
          "010-0025",
          "010-0038",
          "010-0035",
          "010-0021",
          "010-0026",
          "010-0023",
          "010-0024",
          "010-0027",
          "010-0022",
          "010-1423",
          "010-1435",
          "010-1426",
          "010-1433",
          "010-1427",
          "010-1434",
          "010-1432",
          "010-1431",
          "010-1421",
          "010-1437",
          "010-1422",
          "010-0821",
          "010-0824",
          "010-1654",
          "010-0065",
          "010-0003",
          "010-0004",
          "010-0006",
          "010-0002",
          "010-0005",
          "010-0041",
          "010-0853",
          "010-0915",
          "010-0902",
          "010-0901",
          "010-0911",
          "010-0914",
          "010-0913",
          "010-0912",
          "010-0905",
          "010-0903",
          "010-0904",
          "010-1409",
          "010-0011",
          "010-0013",
          "010-0012",
          "010-0014",
          "010-1601",
          "010-0825",
          "010-0975",
          "010-0961",
          "010-0974",
          "010-0963",
          "010-0962",
          "010-0965",
          "010-0977",
          "010-0972",
          "010-0964",
          "010-0973",
          "010-0976",
          "010-0971",
          "010-1429",
          "010-1231",
          "010-1341",
          "010-1351",
          "010-1222",
          "010-1352",
          "010-1225",
          "010-1202",
          "010-1203",
          "010-1342",
          "010-1201",
          "010-1224",
          "010-1343",
          "010-1211",
          "010-1232",
          "010-1212",
          "010-1221",
          "010-1223",
          "010-1344",
          "010-1233",
          "010-0044",
          "010-1417",
          "010-1418",
          "010-1416",
          "016-0000",
          "016-0865",
          "016-0835",
          "016-0115",
          "016-0179",
          "018-2802",
          "016-0804",
          "016-0102",
          "016-0017",
          "016-0143",
          "016-0144",
          "016-0863",
          "016-0136",
          "016-0137",
          "016-0138",
          "016-0141",
          "016-0135",
          "016-0842",
          "016-0122",
          "016-0162",
          "016-0181",
          "016-0164",
          "016-0805",
          "018-2812",
          "016-0803",
          "016-0155",
          "016-0807",
          "016-0014",
          "016-0884",
          "016-0876",
          "016-0121",
          "016-0166",
          "018-2813",
          "016-0153",
          "016-0172",
          "016-0154",
          "016-0182",
          "016-0878",
          "016-0171",
          "016-0802",
          "016-0817",
          "018-2814",
          "018-2806",
          "016-0178",
          "016-0892",
          "016-0834",
          "016-0883",
          "016-0815",
          "016-0177",
          "018-2804",
          "016-0861",
          "016-0846",
          "016-0011",
          "018-2811",
          "016-0167",
          "016-0168",
          "016-0872",
          "016-0113",
          "016-0185",
          "016-0104",
          "016-0186",
          "016-0173",
          "016-0187",
          "016-0862",
          "016-0897",
          "016-0871",
          "016-0174",
          "016-0895",
          "016-0015",
          "016-0881",
          "016-0824",
          "016-0806",
          "016-0877",
          "016-0163",
          "016-0001",
          "016-0146",
          "016-0184",
          "016-0016",
          "016-0857",
          "016-0123",
          "016-0149",
          "016-0165",
          "016-0843",
          "016-0131",
          "016-0853",
          "016-0852",
          "016-0188",
          "018-2815",
          "016-0845",
          "016-0176",
          "018-2801",
          "016-0134",
          "018-2805",
          "016-0816",
          "016-0147",
          "016-0864",
          "018-2803",
          "016-0114",
          "016-0814",
          "016-0156",
          "016-0812",
          "016-0112",
          "016-0101",
          "016-0183",
          "016-0873",
          "016-0875",
          "016-0111",
          "016-0837",
          "016-0855",
          "016-0891",
          "016-0003",
          "016-0874",
          "016-0813",
          "016-0894",
          "016-0116",
          "016-0821",
          "016-0844",
          "016-0801",
          "016-0157",
          "016-0142",
          "016-0896",
          "016-0836",
          "016-0839",
          "016-0822",
          "016-0012",
          "016-0148",
          "016-0151",
          "016-0811",
          "016-0808",
          "016-0856",
          "018-3101",
          "018-3116",
          "018-3119",
          "018-3131",
          "018-3118",
          "018-3142",
          "018-3143",
          "018-3115",
          "018-3105",
          "018-3107",
          "018-3126",
          "018-3124",
          "018-3112",
          "018-3141",
          "018-3147",
          "018-3102",
          "018-3123",
          "018-3114",
          "018-3104",
          "018-3151",
          "018-3157",
          "018-3152",
          "018-3156",
          "018-3128",
          "018-3134",
          "018-3111",
          "018-3133",
          "018-3132",
          "018-3125",
          "018-3117",
          "018-3148",
          "018-3121",
          "018-3122",
          "018-3144",
          "018-3146",
          "018-3153",
          "018-3103",
          "018-3106",
          "018-3113",
          "018-3155",
          "018-3129",
          "018-3127",
          "018-3154",
          "018-3145",
          "018-3135",
          "016-0004",
          "016-0175",
          "016-0879",
          "016-0882",
          "016-0169",
          "016-0854",
          "016-0002",
          "016-0005",
          "016-0132",
          "016-0161",
          "016-0893",
          "016-0851",
          "016-0832",
          "016-0103",
          "016-0133",
          "016-0013",
          "016-0833",
          "016-0152",
          "016-0831",
          "016-0139",
          "016-0825",
          "016-0841",
          "016-0838",
          "016-0145",
          "016-0823",
          "013-0000",
          "013-0073",
          "013-0064",
          "013-0028",
          "013-0033",
          "013-0055",
          "013-0065",
          "013-0068",
          "013-0036",
          "013-0062",
          "013-0002",
          "013-0041",
          "013-0007",
          "013-0021",
          "013-0026",
          "013-0501",
          "013-0546",
          "013-0511",
          "013-0552",
          "013-0514",
          "013-0521",
          "013-0532",
          "013-0562",
          "013-0531",
          "013-0551",
          "013-0524",
          "013-0536",
          "013-0525",
          "013-0517",
          "013-0542",
          "013-0544",
          "013-0534",
          "013-0523",
          "013-0503",
          "013-0545",
          "013-0541",
          "013-0533",
          "013-0515",
          "013-0526",
          "013-0502",
          "013-0516",
          "013-0543",
          "013-0535",
          "013-0522",
          "013-0519",
          "013-0518",
          "013-0561",
          "013-0512",
          "013-0513",
          "013-0051",
          "013-0052",
          "013-0201",
          "013-0205",
          "013-0481",
          "013-0218",
          "013-0214",
          "013-0215",
          "013-0202",
          "013-0212",
          "013-0203",
          "013-0217",
          "013-0213",
          "013-0206",
          "013-0216",
          "013-0208",
          "013-0211",
          "013-0207",
          "013-0204",
          "013-0072",
          "013-0031",
          "013-0813",
          "013-0814",
          "013-0812",
          "013-0014",
          "013-0821",
          "013-0822",
          "013-0032",
          "013-0826",
          "013-0025",
          "013-0005",
          "019-1107",
          "019-1109",
          "019-1101",
          "019-1103",
          "019-1102",
          "019-1108",
          "019-1105",
          "019-1106",
          "019-1104",
          "013-0074",
          "013-0069",
          "013-0075",
          "013-0056",
          "013-0824",
          "013-0823",
          "013-0017",
          "019-0525",
          "019-0513",
          "019-0501",
          "019-0512",
          "019-0529",
          "019-0511",
          "019-0531",
          "019-0507",
          "019-0517",
          "019-0516",
          "019-0506",
          "019-0528",
          "019-0533",
          "019-0508",
          "019-0523",
          "019-0527",
          "019-0526",
          "019-0509",
          "019-0505",
          "019-0522",
          "019-0521",
          "019-0503",
          "019-0502",
          "019-0518",
          "019-0532",
          "019-0514",
          "019-0524",
          "019-0515",
          "013-0060",
          "013-0011",
          "013-0013",
          "013-0012",
          "013-0006",
          "013-0046",
          "013-0001",
          "013-0076",
          "013-0053",
          "013-0003",
          "013-0459",
          "013-0447",
          "013-0427",
          "013-0484",
          "013-0464",
          "013-0465",
          "013-0463",
          "013-0471",
          "013-0353",
          "013-0352",
          "013-0356",
          "013-0431",
          "013-0316",
          "013-0382",
          "013-0421",
          "013-0452",
          "013-0317",
          "013-0313",
          "013-0454",
          "013-0455",
          "013-0335",
          "013-0451",
          "013-0337",
          "013-0365",
          "013-0359",
          "013-0362",
          "013-0361",
          "013-0305",
          "013-0404",
          "013-0355",
          "013-0351",
          "013-0349",
          "013-0326",
          "013-0372",
          "013-0408",
          "013-0354",
          "013-0426",
          "013-0438",
          "013-0435",
          "013-0314",
          "013-0336",
          "013-0437",
          "013-0436",
          "013-0324",
          "013-0321",
          "013-0323",
          "013-0318",
          "013-0308",
          "013-0309",
          "013-0474",
          "013-0363",
          "013-0477",
          "013-0475",
          "013-0434",
          "013-0439",
          "013-0315",
          "013-0483",
          "013-0485",
          "013-0487",
          "013-0334",
          "013-0302",
          "013-0333",
          "013-0332",
          "013-0307",
          "013-0304",
          "013-0344",
          "013-0342",
          "013-0412",
          "013-0411",
          "013-0457",
          "013-0456",
          "013-0458",
          "013-0443",
          "013-0442",
          "013-0348",
          "013-0343",
          "013-0325",
          "013-0486",
          "013-0306",
          "013-0428",
          "013-0322",
          "013-0423",
          "013-0462",
          "013-0424",
          "013-0312",
          "013-0311",
          "013-0468",
          "013-0476",
          "013-0425",
          "013-0433",
          "013-0406",
          "013-0441",
          "013-0446",
          "013-0448",
          "013-0472",
          "013-0473",
          "013-0331",
          "013-0488",
          "013-0432",
          "013-0409",
          "013-0482",
          "013-0301",
          "013-0303",
          "013-0364",
          "013-0414",
          "013-0416",
          "013-0415",
          "013-0371",
          "013-0345",
          "013-0347",
          "013-0385",
          "013-0422",
          "013-0405",
          "013-0339",
          "013-0338",
          "013-0466",
          "013-0453",
          "013-0467",
          "013-0461",
          "013-0429",
          "013-0413",
          "013-0358",
          "013-0445",
          "013-0444",
          "013-0357",
          "013-0402",
          "013-0379",
          "013-0376",
          "013-0378",
          "013-0375",
          "013-0381",
          "013-0377",
          "013-0374",
          "013-0384",
          "013-0383",
          "013-0373",
          "013-0327",
          "013-0341",
          "013-0407",
          "013-0346",
          "013-0319",
          "013-0419",
          "013-0417",
          "013-0418",
          "013-0024",
          "013-0023",
          "013-0066",
          "013-0016",
          "013-0015",
          "013-0825",
          "013-0105",
          "013-0101",
          "013-0103",
          "013-0107",
          "013-0102",
          "013-0104",
          "013-0106",
          "013-0027",
          "013-0063",
          "013-0019",
          "013-0035",
          "013-0034",
          "013-0042",
          "013-0038",
          "013-0037",
          "019-0711",
          "019-0702",
          "019-0712",
          "019-0705",
          "019-0714",
          "019-0701",
          "019-0713",
          "019-0715",
          "019-0704",
          "019-0703",
          "013-0047",
          "013-0045",
          "013-0004",
          "013-0008",
          "013-0018",
          "013-0043",
          "013-0048",
          "013-0811",
          "013-0054",
          "013-0071",
          "013-0061",
          "013-0044",
          "013-0022",
          "017-0000",
          "017-0806",
          "017-0831",
          "017-0854",
          "017-0816",
          "017-0814",
          "017-0011",
          "017-0025",
          "017-0023",
          "017-0043",
          "017-0836",
          "017-0834",
          "017-0832",
          "017-0845",
          "017-0053",
          "017-0853",
          "017-0825",
          "017-0801",
          "017-0857",
          "018-3501",
          "017-0894",
          "017-0817",
          "017-0837",
          "017-0805",
          "017-0024",
          "018-5754",
          "017-0041",
          "017-0896",
          "017-0851",
          "017-0841",
          "017-0044",
          "017-0004",
          "017-0892",
          "017-0871",
          "017-0872",
          "017-0812",
          "017-0813",
          "017-0031",
          "017-0804",
          "018-5604",
          "017-0878",
          "017-0042",
          "017-0866",
          "018-5606",
          "017-0893",
          "017-0014",
          "017-0015",
          "017-0861",
          "017-0835",
          "017-0852",
          "017-0847",
          "017-0821",
          "017-0822",
          "018-5605",
          "017-0897",
          "017-0022",
          "018-5756",
          "017-0046",
          "017-0037",
          "017-0034",
          "017-0033",
          "017-0012",
          "018-5601",
          "017-0865",
          "017-0002",
          "017-0844",
          "017-0887",
          "017-0888",
          "018-5755",
          "017-0875",
          "017-0833",
          "018-3503",
          "017-0035",
          "017-0886",
          "017-0877",
          "017-0882",
          "018-5602",
          "017-0846",
          "017-0884",
          "017-0867",
          "017-0891",
          "017-0843",
          "017-0045",
          "017-0839",
          "017-0881",
          "017-0895",
          "018-3504",
          "017-0802",
          "017-0001",
          "017-0824",
          "018-5751",
          "017-0032",
          "017-0036",
          "017-0055",
          "017-0056",
          "017-0057",
          "017-0862",
          "017-0864",
          "017-0863",
          "017-0842",
          "017-0003",
          "017-0811",
          "017-0823",
          "017-0005",
          "018-3505",
          "017-0803",
          "017-0855",
          "018-5753",
          "018-5701",
          "018-5851",
          "018-5743",
          "018-5745",
          "018-5731",
          "018-5742",
          "018-5741",
          "018-5721",
          "018-5722",
          "018-5712",
          "018-5711",
          "018-5744",
          "018-5732",
          "017-0026",
          "017-0883",
          "017-0815",
          "018-5603",
          "017-0052",
          "017-0054",
          "017-0051",
          "017-0873",
          "017-0874",
          "017-0868",
          "017-0828",
          "017-0876",
          "018-5752",
          "017-0827",
          "017-0826",
          "018-3506",
          "018-3502",
          "017-0838",
          "017-0021",
          "017-0885",
          "010-0500",
          "010-0353",
          "010-0352",
          "010-0355",
          "010-0354",
          "010-0351",
          "010-0421",
          "010-0664",
          "010-0663",
          "010-0662",
          "010-0661",
          "010-0665",
          "010-0422",
          "010-0681",
          "010-0684",
          "010-0682",
          "010-0683",
          "010-0685",
          "010-0676",
          "010-0686",
          "010-0675",
          "010-0688",
          "010-0687",
          "010-0671",
          "010-0673",
          "010-0674",
          "010-0672",
          "010-0401",
          "010-0423",
          "010-0411",
          "010-0431",
          "010-0523",
          "010-0503",
          "010-0534",
          "010-0533",
          "010-0531",
          "010-0532",
          "010-0501",
          "010-0502",
          "010-0511",
          "010-0535",
          "010-0522",
          "010-0521",
          "010-0341",
          "010-0412",
          "010-0413",
          "010-0345",
          "010-0343",
          "010-0346",
          "010-0344",
          "010-0347",
          "010-0342",
          "012-0000",
          "019-0402",
          "012-0024",
          "019-0321",
          "012-0855",
          "012-0042",
          "012-0852",
          "012-0062",
          "019-0201",
          "012-0107",
          "012-0022",
          "012-0801",
          "012-0834",
          "019-0113",
          "012-0842",
          "012-0843",
          "012-0824",
          "019-0403",
          "012-0014",
          "012-0026",
          "012-0841",
          "012-0012",
          "012-0045",
          "012-0057",
          "012-0856",
          "012-0023",
          "012-0037",
          "019-0205",
          "012-0827",
          "012-0001",
          "012-0831",
          "012-0833",
          "012-0005",
          "012-0835",
          "012-0836",
          "019-0111",
          "012-0864",
          "012-0003",
          "012-0105",
          "012-0825",
          "012-0015",
          "019-0202",
          "012-0021",
          "012-0104",
          "012-0845",
          "012-0035",
          "012-0013",
          "019-0401",
          "012-0811",
          "012-0033",
          "019-0112",
          "012-0863",
          "012-0052",
          "012-0002",
          "012-0822",
          "012-0853",
          "012-0804",
          "012-0803",
          "012-0862",
          "012-0016",
          "012-0857",
          "012-0814",
          "012-0008",
          "019-0404",
          "012-0844",
          "012-0031",
          "019-0203",
          "012-0854",
          "012-0053",
          "012-0041",
          "012-0044",
          "012-0802",
          "012-0004",
          "012-0868",
          "012-0837",
          "012-0034",
          "012-0054",
          "012-0866",
          "012-0865",
          "012-0812",
          "012-0861",
          "012-0832",
          "012-0051",
          "012-0056",
          "012-0017",
          "012-0851",
          "012-0815",
          "012-0838",
          "012-0025",
          "012-0813",
          "012-0061",
          "012-0043",
          "012-0106",
          "019-0481",
          "012-0183",
          "012-0867",
          "012-0032",
          "012-0011",
          "012-0006",
          "012-0826",
          "012-0055",
          "012-0821",
          "012-0007",
          "012-0823",
          "019-0204",
          "012-0036",
          "012-0869",
          "018-5200",
          "018-5202",
          "018-5332",
          "018-5421",
          "018-5333",
          "018-5422",
          "018-5334",
          "018-5337",
          "018-5335",
          "018-5336",
          "018-5331",
          "018-5141",
          "018-5201",
          "015-0000",
          "015-0023",
          "015-0836",
          "015-0079",
          "015-0071",
          "015-0034",
          "015-0084",
          "015-0065",
          "015-0892",
          "015-0301",
          "015-0311",
          "015-0012",
          "015-0013",
          "015-0014",
          "015-0011",
          "015-0823",
          "015-0852",
          "015-0876",
          "018-1215",
          "018-1213",
          "018-1301",
          "018-1302",
          "018-1225",
          "018-1222",
          "018-1216",
          "018-1218",
          "018-1217",
          "018-1221",
          "018-1303",
          "018-1226",
          "018-1223",
          "018-1211",
          "018-1214",
          "018-1212",
          "018-1305",
          "018-1304",
          "018-1224",
          "018-0904",
          "015-0834",
          "018-0726",
          "018-0711",
          "018-0723",
          "015-0814",
          "015-0022",
          "015-0024",
          "015-0042",
          "015-0072",
          "015-0094",
          "015-0856",
          "018-0731",
          "018-0733",
          "015-0864",
          "015-0093",
          "018-0721",
          "015-0868",
          "015-0062",
          "015-0816",
          "015-0312",
          "015-0091",
          "015-0021",
          "015-0811",
          "015-0871",
          "015-0802",
          "015-0035",
          "018-0841",
          "015-0812",
          "015-0826",
          "015-0321",
          "015-0066",
          "015-0854",
          "015-0085",
          "015-0051",
          "015-0331",
          "015-0872",
          "015-0825",
          "015-0878",
          "015-0831",
          "015-0069",
          "018-0734",
          "015-0884",
          "015-0874",
          "015-0881",
          "018-0852",
          "015-0045",
          "015-0302",
          "015-0361",
          "015-0883",
          "018-0903",
          "015-0313",
          "015-0862",
          "015-0891",
          "015-0861",
          "015-0887",
          "015-0821",
          "018-0907",
          "015-0074",
          "015-0073",
          "015-0889",
          "015-0067",
          "015-0841",
          "015-0832",
          "015-0322",
          "015-0303",
          "015-0888",
          "018-0842",
          "018-0902",
          "015-0033",
          "015-0869",
          "015-0833",
          "015-0875",
          "015-0351",
          "015-0840",
          "015-0867",
          "015-0081",
          "015-0808",
          "018-0844",
          "018-0905",
          "015-0083",
          "015-0086",
          "015-0063",
          "015-0804",
          "015-0822",
          "015-0044",
          "015-0504",
          "015-0721",
          "015-0515",
          "015-0503",
          "015-0505",
          "015-0511",
          "015-0512",
          "015-0502",
          "015-0722",
          "015-0513",
          "015-0514",
          "015-0501",
          "015-0516",
          "015-0886",
          "015-0323",
          "015-0054",
          "015-0055",
          "015-0866",
          "015-0873",
          "015-0842",
          "015-0837",
          "015-0857",
          "018-0732",
          "015-0061",
          "015-0089",
          "018-0853",
          "018-0901",
          "018-0722",
          "015-0803",
          "018-0843",
          "018-0845",
          "015-0851",
          "015-0817",
          "015-0807",
          "015-0865",
          "015-0882",
          "015-0352",
          "015-0858",
          "018-0601",
          "018-0602",
          "018-0603",
          "018-0604",
          "015-0855",
          "015-0877",
          "018-0854",
          "015-0052",
          "015-0835",
          "015-0075",
          "018-0906",
          "015-0031",
          "015-0827",
          "015-0362",
          "015-0314",
          "015-0843",
          "015-0076",
          "015-0211",
          "015-0202",
          "015-0231",
          "015-0241",
          "015-0242",
          "015-0232",
          "015-0221",
          "015-0201",
          "015-0813",
          "015-0353",
          "018-0851",
          "018-0724",
          "015-0053",
          "015-0047",
          "015-0046",
          "015-0890",
          "015-0863",
          "015-0839",
          "015-0824",
          "015-0809",
          "015-0077",
          "015-0838",
          "015-0341",
          "015-0304",
          "015-0363",
          "015-0853",
          "015-0032",
          "018-0855",
          "015-0064",
          "015-0801",
          "015-0885",
          "015-0068",
          "015-0364",
          "015-0043",
          "015-0082",
          "015-0332",
          "015-0088",
          "015-0041",
          "015-0418",
          "015-0412",
          "015-0413",
          "015-0416",
          "015-0411",
          "015-0415",
          "015-0414",
          "015-0403",
          "015-0401",
          "015-0404",
          "015-0417",
          "015-0402",
          "015-0078",
          "015-0243",
          "015-0092",
          "015-0025",
          "015-0333",
          "015-0087",
          "015-0324",
          "018-0725",
          "015-0815",
          "018-1400",
          "018-1504",
          "018-1501",
          "018-1502",
          "018-1503",
          "018-1401",
          "018-1412",
          "018-1411",
          "018-1414",
          "018-1413",
          "018-1416",
          "018-1415",
          "018-1403",
          "018-1402",
          "010-0202",
          "010-0101",
          "010-0201",
          "014-0000",
          "014-0013",
          "014-0067",
          "014-0004",
          "014-0112",
          "014-0073",
          "019-2201",
          "014-0714",
          "019-2202",
          "019-2103",
          "019-1616",
          "019-1613",
          "019-1615",
          "019-1605",
          "019-1612",
          "019-1604",
          "019-1611",
          "019-1602",
          "019-1603",
          "019-1614",
          "019-1601",
          "014-0022",
          "014-0031",
          "014-0055",
          "014-0068",
          "014-0025",
          "014-0054",
          "014-0048",
          "014-0062",
          "014-0052",
          "014-0023",
          "014-0061",
          "014-0015",
          "014-0034",
          "014-0047",
          "014-0046",
          "014-0027",
          "014-0043",
          "014-0024",
          "014-0053",
          "014-0051",
          "014-0063",
          "014-0014",
          "014-0042",
          "014-0057",
          "014-0041",
          "014-0026",
          "014-0056",
          "014-0045",
          "014-0072",
          "019-2331",
          "014-0064",
          "014-1413",
          "019-2333",
          "014-0202",
          "019-2112",
          "014-0066",
          "014-0203",
          "019-1702",
          "019-2121",
          "019-2334",
          "019-2412",
          "019-2521",
          "019-2413",
          "019-2441",
          "019-2411",
          "019-2442",
          "019-2443",
          "019-2401",
          "019-2402",
          "019-2431",
          "019-2332",
          "014-0713",
          "014-0803",
          "019-2335",
          "014-0012",
          "014-0017",
          "014-0204",
          "014-0201",
          "014-0065",
          "019-2204",
          "019-1701",
          "019-2205",
          "019-2122",
          "014-0103",
          "014-0805",
          "019-2111",
          "019-2123",
          "014-0801",
          "014-0044",
          "014-0712",
          "014-0711",
          "014-0206",
          "014-0207",
          "019-1949",
          "019-1865",
          "019-1863",
          "019-1864",
          "019-1866",
          "019-1868",
          "019-1858",
          "019-1901",
          "019-1835",
          "019-1834",
          "019-1876",
          "019-1916",
          "019-1942",
          "019-1945",
          "019-1908",
          "019-1932",
          "019-1842",
          "019-1843",
          "019-1841",
          "019-1852",
          "019-1855",
          "019-1857",
          "019-1856",
          "019-1935",
          "019-1905",
          "019-1961",
          "019-1882",
          "019-1812",
          "019-1875",
          "019-1906",
          "019-1956",
          "019-1948",
          "019-1907",
          "019-1816",
          "019-1926",
          "019-1925",
          "019-1872",
          "019-1922",
          "019-1808",
          "019-1807",
          "019-1817",
          "019-1832",
          "019-1951",
          "019-1937",
          "019-1847",
          "019-1802",
          "019-1813",
          "019-1851",
          "019-1957",
          "019-1938",
          "019-1952",
          "019-1947",
          "019-1903",
          "019-1814",
          "019-1931",
          "019-1902",
          "019-1915",
          "019-1946",
          "019-1806",
          "019-1848",
          "019-1909",
          "019-1923",
          "019-1924",
          "019-1953",
          "019-1955",
          "019-1928",
          "019-1933",
          "019-1934",
          "019-1873",
          "019-1826",
          "019-1827",
          "019-1822",
          "019-1831",
          "019-1861",
          "019-1888",
          "019-1936",
          "019-1954",
          "019-1927",
          "019-1874",
          "019-1921",
          "019-1929",
          "019-1904",
          "019-1887",
          "019-1846",
          "019-1805",
          "019-1804",
          "019-1886",
          "019-1963",
          "019-1878",
          "019-1884",
          "019-1943",
          "019-1815",
          "019-1883",
          "019-1918",
          "019-1801",
          "019-1825",
          "019-1803",
          "019-1853",
          "019-1911",
          "019-1941",
          "019-1912",
          "019-1939",
          "019-1877",
          "019-1824",
          "019-1958",
          "019-1881",
          "019-1885",
          "019-1811",
          "019-1917",
          "019-1871",
          "019-1913",
          "019-1914",
          "019-1944",
          "019-1962",
          "019-1862",
          "014-0104",
          "014-0804",
          "014-0001",
          "014-0002",
          "014-0006",
          "014-0005",
          "014-0032",
          "014-0071",
          "014-0114",
          "014-0021",
          "014-1412",
          "014-0011",
          "014-0802",
          "014-0113",
          "014-0101",
          "014-0003",
          "014-0205",
          "014-0111",
          "014-0102",
          "014-1411",
          "014-0016",
          "014-0033",
          "018-3300",
          "018-3313",
          "018-4621",
          "018-4623",
          "018-4731",
          "018-4743",
          "018-4624",
          "018-4745",
          "018-4613",
          "018-4741",
          "018-4742",
          "018-4603",
          "018-4622",
          "018-4602",
          "018-4604",
          "018-4733",
          "018-4734",
          "018-4732",
          "018-4744",
          "018-4735",
          "018-4746",
          "018-4515",
          "018-4612",
          "018-4611",
          "018-4601",
          "018-3314",
          "018-3343",
          "018-4302",
          "018-3324",
          "018-4516",
          "018-4251",
          "018-4231",
          "018-4211",
          "018-4203",
          "018-3341",
          "018-4513",
          "018-4514",
          "018-3451",
          "018-4273",
          "018-3311",
          "018-3302",
          "018-4221",
          "018-3322",
          "018-4282",
          "018-4261",
          "018-3332",
          "018-3331",
          "018-3301",
          "018-4241",
          "018-3453",
          "018-3452",
          "018-4272",
          "018-4512",
          "018-4202",
          "018-3312",
          "018-4281",
          "018-3316",
          "018-4271",
          "018-3333",
          "018-4303",
          "018-3342",
          "018-4201",
          "018-3321",
          "018-4263",
          "018-4262",
          "018-3315",
          "018-3325",
          "018-4511",
          "018-4301",
          "018-3323",
          "018-3454",
          "018-0400",
          "018-0431",
          "018-0411",
          "018-0322",
          "018-0412",
          "018-0421",
          "018-0126",
          "018-0118",
          "018-0119",
          "018-0116",
          "018-0106",
          "018-0135",
          "018-0107",
          "018-0105",
          "018-0112",
          "018-0108",
          "018-0115",
          "018-0136",
          "018-0121",
          "018-0142",
          "018-0162",
          "018-0131",
          "018-0114",
          "018-0146",
          "018-0103",
          "018-0184",
          "018-0188",
          "018-0141",
          "018-0109",
          "018-0122",
          "018-0104",
          "018-0102",
          "018-0145",
          "018-0187",
          "018-0172",
          "018-0183",
          "018-0143",
          "018-0153",
          "018-0158",
          "018-0129",
          "018-0175",
          "018-0148",
          "018-0181",
          "018-0133",
          "018-0161",
          "018-0156",
          "018-0166",
          "018-0157",
          "018-0147",
          "018-0165",
          "018-0167",
          "018-0128",
          "018-0171",
          "018-0132",
          "018-0163",
          "018-0127",
          "018-0144",
          "018-0154",
          "018-0134",
          "018-0125",
          "018-0124",
          "018-0186",
          "018-0113",
          "018-0117",
          "018-0101",
          "018-0174",
          "018-0182",
          "018-0111",
          "018-0155",
          "018-0152",
          "018-0164",
          "018-0123",
          "018-0185",
          "018-0151",
          "018-0176",
          "018-0173",
          "018-0302",
          "018-0311",
          "018-0404",
          "018-0414",
          "018-0434",
          "018-0422",
          "018-0301",
          "018-0435",
          "018-0433",
          "018-0413",
          "018-0436",
          "018-0402",
          "018-0321",
          "018-0432",
          "018-0403",
          "018-0401",
          "014-0300",
          "014-0373",
          "014-0375",
          "014-0316",
          "014-0374",
          "014-0336",
          "014-0364",
          "014-0371",
          "014-0347",
          "014-0332",
          "014-0334",
          "014-0331",
          "014-0367",
          "014-0362",
          "014-0327",
          "014-0369",
          "014-0346",
          "014-0333",
          "014-0358",
          "014-0359",
          "014-0341",
          "014-0372",
          "014-0324",
          "014-0363",
          "014-0313",
          "014-0315",
          "014-0366",
          "014-0317",
          "014-0343",
          "014-0302",
          "014-0365",
          "014-0303",
          "014-0328",
          "014-0311",
          "014-0312",
          "014-0352",
          "014-0355",
          "014-0361",
          "014-0368",
          "014-0318",
          "014-0322",
          "014-0321",
          "014-0379",
          "014-0376",
          "014-0353",
          "014-0377",
          "014-0344",
          "014-0378",
          "014-0342",
          "014-0356",
          "014-0357",
          "014-0325",
          "014-0301",
          "014-0337",
          "014-0351",
          "014-0335",
          "014-0354",
          "014-0326",
          "014-0345",
          "014-0323",
          "014-1112",
          "014-1111",
          "014-1201",
          "014-1116",
          "014-1203",
          "014-1115",
          "014-1202",
          "014-1114",
          "014-1113",
          "014-1204",
          "014-1205",
          "014-0515",
          "014-0512",
          "014-0601",
          "014-0513",
          "014-0516",
          "014-0511",
          "014-0514",
          "014-0602",
          "017-0200",
          "017-0204",
          "017-0203",
          "017-0201",
          "017-0202",
          "017-0205",
          "018-5511",
          "018-4400",
          "018-4431",
          "018-4401",
          "018-4421",
          "018-4412",
          "018-4413",
          "018-4422",
          "018-4411",
          "018-4423",
          "018-4432",
          "018-3200",
          "018-3203",
          "018-3205",
          "018-3202",
          "018-3201",
          "018-3204",
          "018-2400",
          "018-2405",
          "018-2102",
          "018-2401",
          "018-2406",
          "018-2104",
          "018-2101",
          "018-2402",
          "018-2403",
          "018-2103",
          "018-2301",
          "018-2302",
          "018-2305",
          "018-2404",
          "018-2304",
          "018-2407",
          "018-2303",
          "018-2500",
          "018-2637",
          "018-2643",
          "018-2622",
          "018-2615",
          "018-2676",
          "018-2611",
          "018-2605",
          "018-2608",
          "018-2601",
          "018-2675",
          "018-2609",
          "018-2647",
          "018-2606",
          "018-2674",
          "018-2636",
          "018-2618",
          "018-2653",
          "018-2614",
          "018-2613",
          "018-2617",
          "018-2631",
          "018-2633",
          "018-2632",
          "018-2627",
          "018-2625",
          "018-2672",
          "018-2635",
          "018-2651",
          "018-2662",
          "018-2634",
          "018-2623",
          "018-2628",
          "018-2602",
          "018-2621",
          "018-2646",
          "018-2642",
          "018-2644",
          "018-2666",
          "018-2665",
          "018-2648",
          "018-2663",
          "018-2673",
          "018-2619",
          "018-2645",
          "018-2641",
          "018-2612",
          "018-2678",
          "018-2667",
          "018-2677",
          "018-2661",
          "018-2607",
          "018-2664",
          "018-2616",
          "018-2638",
          "018-2655",
          "018-2652",
          "018-2603",
          "018-2654",
          "018-2656",
          "018-2671",
          "018-2626",
          "018-2624",
          "018-2604",
          "018-2504",
          "018-2505",
          "018-2511",
          "018-2506",
          "018-2508",
          "018-2507",
          "018-2509",
          "018-2512",
          "018-2503",
          "018-2501",
          "018-2502",
          "018-1700",
          "018-1704",
          "018-1743",
          "018-1851",
          "018-1857",
          "018-1854",
          "018-1852",
          "018-1722",
          "018-1741",
          "018-1742",
          "018-1705",
          "018-1731",
          "018-1734",
          "018-1735",
          "018-1732",
          "018-1733",
          "018-1723",
          "018-1745",
          "018-1712",
          "018-1746",
          "018-1706",
          "018-1744",
          "018-1702",
          "018-1711",
          "018-1714",
          "018-1701",
          "018-1721",
          "018-1725",
          "018-1747",
          "018-1703",
          "018-1713",
          "018-1724",
          "018-1856",
          "018-1855",
          "018-1853",
          "018-1600",
          "018-1621",
          "018-1617",
          "018-1602",
          "018-1616",
          "018-1627",
          "018-1615",
          "018-1611",
          "018-1613",
          "018-1618",
          "018-1605",
          "018-1625",
          "018-1603",
          "018-1628",
          "018-1623",
          "018-1635",
          "018-1624",
          "018-1629",
          "018-1614",
          "018-1633",
          "018-1632",
          "018-1634",
          "018-1604",
          "018-1631",
          "018-1622",
          "018-1612",
          "018-1626",
          "018-1601",
          "018-1606",
          "018-1500",
          "018-1525",
          "018-1527",
          "018-1511",
          "018-1514",
          "018-1524",
          "018-1512",
          "018-1513",
          "018-1515",
          "018-1523",
          "018-1526",
          "018-1528",
          "018-1521",
          "018-1516",
          "018-1522",
          "010-0400",
          "010-0451",
          "010-0452",
          "010-0453",
          "010-0441",
          "010-0443",
          "010-0454",
          "010-0445",
          "010-0455",
          "010-0442",
          "010-0456",
          "010-0444",
          "019-1400",
          "019-1533",
          "019-1234",
          "019-1302",
          "019-1235",
          "019-1522",
          "019-1236",
          "019-1511",
          "019-1542",
          "019-1233",
          "019-1237",
          "019-1502",
          "019-1541",
          "019-1232",
          "019-1521",
          "019-1501",
          "019-1301",
          "019-1402",
          "019-1531",
          "019-1532",
          "019-1512",
          "019-1231",
          "019-1401",
          "019-1404",
          "019-1403",
          "012-1100",
          "012-1124",
          "012-1136",
          "012-1121",
          "012-1101",
          "012-1132",
          "012-1123",
          "012-1122",
          "012-1353",
          "012-1242",
          "012-1243",
          "012-1113",
          "012-1135",
          "012-1111",
          "012-1351",
          "012-1102",
          "012-1126",
          "012-1116",
          "012-1134",
          "012-1241",
          "012-1115",
          "012-1133",
          "012-1352",
          "012-1131",
          "012-1137",
          "012-1114",
          "012-1125",
          "012-1103",
          "012-1106",
          "012-1104",
          "012-1105",
          "012-1112",
          "019-0800",
          "019-0802",
          "019-0801",
          "019-0803",
          "990-0000",
          "990-0055",
          "990-2435",
          "990-2324",
          "990-2222",
          "990-2214",
          "990-2353",
          "990-2481",
          "990-2162",
          "990-0025",
          "990-2434",
          "990-0024",
          "990-2491",
          "990-2432",
          "990-2476",
          "990-2332",
          "990-2331",
          "990-0841",
          "990-0845",
          "990-0842",
          "990-0061",
          "990-0068",
          "990-0829",
          "990-0817",
          "990-2351",
          "990-2403",
          "990-0066",
          "990-0877",
          "990-0878",
          "990-0874",
          "990-2161",
          "990-2483",
          "990-0861",
          "990-0052",
          "990-0046",
          "990-2344",
          "990-2231",
          "990-0818",
          "990-2402",
          "990-0075",
          "990-2365",
          "990-2307",
          "990-2484",
          "990-2221",
          "990-2341",
          "990-0826",
          "990-0833",
          "990-0039",
          "990-2316",
          "990-0856",
          "990-0851",
          "990-2421",
          "990-2384",
          "990-2241",
          "990-0017",
          "990-2212",
          "990-0004",
          "990-2406",
          "990-0875",
          "990-0896",
          "990-0821",
          "990-0822",
          "990-0044",
          "990-2475",
          "990-0876",
          "990-0834",
          "990-2233",
          "990-0850",
          "990-2482",
          "990-2311",
          "990-0863",
          "990-0852",
          "990-0032",
          "990-0021",
          "990-2414",
          "990-0035",
          "990-2234",
          "990-0038",
          "990-2333",
          "990-2303",
          "990-2301",
          "990-2334",
          "990-2305",
          "990-2302",
          "990-2338",
          "990-2337",
          "990-2335",
          "990-2304",
          "990-0003",
          "990-0819",
          "990-0077",
          "990-0824",
          "990-2376",
          "990-2323",
          "990-2321",
          "990-2322",
          "990-0045",
          "990-0898",
          "990-0846",
          "990-0868",
          "990-2173",
          "990-0870",
          "990-0885",
          "990-0886",
          "990-0858",
          "990-0823",
          "990-2385",
          "990-0809",
          "990-2232",
          "990-0018",
          "990-2215",
          "990-0005",
          "990-0012",
          "990-2211",
          "990-0827",
          "990-0825",
          "990-2381",
          "990-0807",
          "990-0832",
          "990-2343",
          "990-2164",
          "990-0864",
          "990-0882",
          "990-0860",
          "990-2494",
          "990-2362",
          "990-2367",
          "990-0884",
          "990-0062",
          "990-0847",
          "990-0854",
          "990-0033",
          "990-0016",
          "990-0881",
          "990-2216",
          "990-2227",
          "990-2172",
          "990-0008",
          "990-0065",
          "990-2378",
          "990-2364",
          "990-0073",
          "990-2346",
          "990-2242",
          "990-0808",
          "990-2464",
          "990-0002",
          "990-2382",
          "990-2251",
          "990-2163",
          "990-0805",
          "990-2224",
          "990-0812",
          "990-0855",
          "990-2315",
          "990-2405",
          "990-0814",
          "990-2492",
          "990-2213",
          "990-0867",
          "990-0801",
          "990-0031",
          "990-0806",
          "990-2223",
          "990-0051",
          "990-0871",
          "990-2345",
          "990-2342",
          "990-2361",
          "990-2463",
          "990-0815",
          "990-2433",
          "990-2422",
          "990-2235",
          "990-0849",
          "990-0892",
          "990-2175",
          "990-2477",
          "990-0811",
          "990-2171",
          "990-0804",
          "990-0042",
          "990-2386",
          "990-0014",
          "990-2339",
          "990-0891",
          "990-2445",
          "990-2355",
          "990-0015",
          "990-0862",
          "990-0056",
          "990-2226",
          "990-0853",
          "990-0831",
          "990-0893",
          "990-0859",
          "990-0844",
          "990-2474",
          "990-0007",
          "990-2174",
          "990-2446",
          "990-2471",
          "990-0865",
          "990-2363",
          "990-0047",
          "990-0872",
          "990-2404",
          "990-2225",
          "990-0067",
          "990-0072",
          "990-2423",
          "990-0899",
          "990-0869",
          "990-0897",
          "990-2354",
          "990-0034",
          "990-2308",
          "990-2375",
          "990-0022",
          "990-0813",
          "990-0076",
          "990-2401",
          "990-2462",
          "990-2377",
          "990-0828",
          "990-0894",
          "990-2374",
          "990-0857",
          "990-0013",
          "990-0001",
          "990-0043",
          "990-2352",
          "990-2411",
          "990-2473",
          "990-0023",
          "990-2313",
          "990-2431",
          "990-2412",
          "990-0810",
          "990-0803",
          "990-0802",
          "990-0036",
          "990-0041",
          "990-2441",
          "990-2442",
          "990-2443",
          "990-2444",
          "990-0836",
          "990-0879",
          "990-2461",
          "990-2465",
          "990-2413",
          "990-2306",
          "990-2312",
          "990-2372",
          "990-2493",
          "990-2317",
          "990-0848",
          "990-0057",
          "990-0011",
          "990-2472",
          "990-0054",
          "990-0895",
          "990-2371",
          "990-2447",
          "990-2314",
          "990-0053",
          "990-2366",
          "999-3301",
          "990-0835",
          "990-0006",
          "990-0063",
          "990-0037",
          "990-0866",
          "990-0843",
          "990-2383",
          "990-0074",
          "990-0883",
          "990-2451",
          "990-2455",
          "990-0071",
          "990-2373",
          "990-2495",
          "990-2453",
          "990-0064",
          "992-0000",
          "992-0032",
          "992-1406",
          "992-1206",
          "992-0075",
          "992-0112",
          "992-0115",
          "992-0034",
          "992-0119",
          "992-0063",
          "992-1331",
          "992-1583",
          "992-0027",
          "992-1204",
          "992-1203",
          "992-1303",
          "992-0035",
          "992-1462",
          "992-0031",
          "992-0076",
          "992-0014",
          "992-0044",
          "992-0012",
          "992-0118",
          "992-0117",
          "992-0016",
          "992-1582",
          "992-0058",
          "992-0114",
          "992-1581",
          "992-0003",
          "992-0004",
          "992-0001",
          "992-0005",
          "992-0002",
          "992-0055",
          "992-0013",
          "992-0017",
          "992-1443",
          "992-1445",
          "992-1441",
          "992-0042",
          "992-0041",
          "992-0043",
          "992-0046",
          "992-0081",
          "992-0111",
          "992-0023",
          "992-0054",
          "992-0038",
          "992-0051",
          "992-1444",
          "992-0064",
          "992-1461",
          "992-1472",
          "992-1205",
          "992-1473",
          "992-0116",
          "992-0015",
          "992-1471",
          "992-0072",
          "992-0071",
          "992-0045",
          "992-1474",
          "992-0066",
          "992-0025",
          "992-0047",
          "992-1446",
          "992-0056",
          "992-0011",
          "992-0113",
          "992-0057",
          "992-0059",
          "992-1128",
          "992-0021",
          "992-0022",
          "992-1127",
          "992-1125",
          "992-1124",
          "992-1121",
          "992-1123",
          "992-1122",
          "992-1201",
          "992-1126",
          "992-0026",
          "992-0024",
          "992-0087",
          "992-0085",
          "992-0082",
          "992-0084",
          "992-0086",
          "992-0083",
          "992-0073",
          "992-0036",
          "992-0033",
          "992-0065",
          "992-1442",
          "992-0061",
          "992-0037",
          "992-0053",
          "992-0052",
          "992-1202",
          "992-1453",
          "992-1455",
          "992-1451",
          "992-1454",
          "992-1452",
          "992-0039",
          "992-0077",
          "992-0074",
          "992-0062",
          "992-0091",
          "992-0094",
          "992-0096",
          "992-0092",
          "992-0093",
          "992-0095",
          "997-0000",
          "997-0832",
          "999-7205",
          "999-7312",
          "997-1205",
          "997-0051",
          "997-0621",
          "999-7673",
          "999-7682",
          "997-0057",
          "997-0755",
          "997-0033",
          "997-0802",
          "997-0803",
          "997-0331",
          "997-0834",
          "997-0842",
          "997-1206",
          "999-7207",
          "997-1125",
          "999-7635",
          "997-0403",
          "997-0823",
          "997-0531",
          "999-7547",
          "999-7123",
          "999-7661",
          "997-0047",
          "997-0622",
          "997-0831",
          "997-0414",
          "999-7543",
          "997-1124",
          "997-1121",
          "997-0854",
          "997-0843",
          "997-0806",
          "999-7316",
          "999-7125",
          "997-1116",
          "997-0052",
          "999-7461",
          "997-0036",
          "997-0343",
          "997-0365",
          "997-1203",
          "997-0847",
          "997-0623",
          "999-7664",
          "997-0405",
          "997-0032",
          "999-7611",
          "997-0346",
          "997-0367",
          "997-1204",
          "997-0805",
          "999-7644",
          "997-0053",
          "999-7313",
          "997-0022",
          "999-7646",
          "997-0411",
          "997-0624",
          "997-0311",
          "999-7122",
          "999-7314",
          "997-0005",
          "999-7206",
          "997-0363",
          "999-7632",
          "999-7462",
          "997-0825",
          "997-0853",
          "997-0804",
          "997-0757",
          "999-7651",
          "997-0861",
          "997-0821",
          "999-7463",
          "997-0342",
          "997-0028",
          "997-0848",
          "997-1117",
          "997-1133",
          "997-1134",
          "997-0845",
          "997-0625",
          "999-7637",
          "997-0404",
          "997-0341",
          "997-0351",
          "997-0814",
          "997-0041",
          "997-0368",
          "997-0754",
          "997-0027",
          "997-0841",
          "997-0044",
          "997-0852",
          "997-0811",
          "997-0015",
          "999-7311",
          "997-0415",
          "997-0839",
          "999-7685",
          "999-7633",
          "999-7315",
          "997-0758",
          "997-0813",
          "999-6652",
          "999-7652",
          "997-0026",
          "999-7677",
          "997-0049",
          "997-0117",
          "997-0017",
          "997-0369",
          "997-0054",
          "997-0011",
          "997-0021",
          "997-0753",
          "997-0364",
          "999-7663",
          "997-0302",
          "997-0366",
          "997-0532",
          "997-0303",
          "997-0014",
          "997-1114",
          "997-0812",
          "997-0024",
          "997-0019",
          "997-0018",
          "997-1115",
          "997-0836",
          "997-0012",
          "997-0013",
          "997-0333",
          "999-7202",
          "997-1132",
          "997-0815",
          "997-1122",
          "997-1123",
          "997-0007",
          "997-0023",
          "997-0808",
          "997-0809",
          "997-0009",
          "999-7546",
          "997-0846",
          "997-0345",
          "997-1135",
          "999-7621",
          "997-0056",
          "997-0401",
          "997-0362",
          "999-7544",
          "997-0413",
          "997-1113",
          "997-0042",
          "997-0332",
          "997-0323",
          "997-0031",
          "997-0055",
          "997-0045",
          "997-1112",
          "999-7541",
          "997-0851",
          "999-7126",
          "997-0819",
          "999-7636",
          "997-0167",
          "997-0141",
          "997-0155",
          "997-0123",
          "997-0152",
          "997-0157",
          "997-0142",
          "997-0122",
          "997-0161",
          "997-0108",
          "997-0163",
          "997-0131",
          "997-0105",
          "997-0151",
          "997-0107",
          "997-0104",
          "997-0127",
          "997-0125",
          "997-0106",
          "997-0153",
          "997-0121",
          "997-0211",
          "997-0103",
          "997-0165",
          "997-0102",
          "997-0126",
          "997-0143",
          "997-0164",
          "997-0162",
          "997-0124",
          "997-0101",
          "997-0156",
          "997-0158",
          "997-0154",
          "997-0166",
          "997-0035",
          "997-0058",
          "997-1111",
          "997-0002",
          "997-0835",
          "997-0824",
          "997-0344",
          "997-0402",
          "997-0043",
          "997-0801",
          "999-7653",
          "997-0756",
          "997-1131",
          "999-7203",
          "997-0025",
          "997-0029",
          "997-0016",
          "999-7681",
          "997-0008",
          "997-0006",
          "999-7638",
          "997-0751",
          "999-7601",
          "999-7642",
          "999-7604",
          "999-7602",
          "997-0822",
          "997-0816",
          "999-7671",
          "997-0048",
          "997-1156",
          "999-7645",
          "999-7622",
          "997-0003",
          "999-7675",
          "997-0321",
          "997-0862",
          "997-0412",
          "997-0034",
          "997-0004",
          "999-7124",
          "999-7676",
          "997-0626",
          "997-0322",
          "997-0334",
          "997-0301",
          "997-0857",
          "999-7542",
          "999-7548",
          "997-0837",
          "997-0046",
          "997-0826",
          "999-7674",
          "997-1202",
          "999-7634",
          "997-0818",
          "997-0361",
          "997-0817",
          "997-0844",
          "999-7631",
          "999-7662",
          "997-0807",
          "997-0833",
          "999-7672",
          "997-0855",
          "999-7545",
          "999-7201",
          "997-0856",
          "999-7204",
          "999-7641",
          "997-0752",
          "997-0001",
          "997-1201",
          "999-7464",
          "997-0827",
          "997-0010",
          "997-0838",
          "999-7643",
          "997-0037",
          "999-7121",
          "999-7683",
          "999-7684",
          "998-0000",
          "998-0032",
          "999-6852",
          "999-8203",
          "998-0828",
          "998-0862",
          "998-0021",
          "999-6711",
          "998-0875",
          "999-6834",
          "998-0055",
          "999-6853",
          "999-6704",
          "999-6708",
          "998-0018",
          "999-7774",
          "999-8232",
          "998-0046",
          "999-6826",
          "998-0836",
          "999-6815",
          "999-6831",
          "999-8164",
          "998-0022",
          "999-8153",
          "998-0802",
          "999-6813",
          "999-8244",
          "999-8225",
          "998-0877",
          "998-0803",
          "999-8133",
          "999-6816",
          "998-0816",
          "998-0064",
          "998-0859",
          "998-0822",
          "998-0824",
          "999-8215",
          "999-8227",
          "998-0871",
          "999-7775",
          "998-0024",
          "999-6845",
          "998-0823",
          "999-6811",
          "999-6838",
          "998-0818",
          "999-7772",
          "999-6837",
          "999-8212",
          "999-6843",
          "999-8206",
          "999-8163",
          "999-8162",
          "998-0042",
          "999-6842",
          "999-8152",
          "998-0011",
          "998-0842",
          "999-8143",
          "999-8132",
          "999-8235",
          "999-7773",
          "999-8211",
          "998-0027",
          "998-0028",
          "998-0801",
          "999-8243",
          "998-0865",
          "998-0062",
          "998-0016",
          "998-0015",
          "998-0072",
          "999-8222",
          "999-6741",
          "999-6833",
          "999-8142",
          "998-0102",
          "998-0827",
          "999-8207",
          "999-8156",
          "998-0817",
          "998-0819",
          "999-6835",
          "998-0111",
          "998-0878",
          "998-0876",
          "999-8234",
          "998-0104",
          "999-6707",
          "998-0852",
          "998-0035",
          "999-6735",
          "998-0815",
          "998-0814",
          "998-0071",
          "998-0023",
          "998-0806",
          "998-0003",
          "998-0026",
          "999-6836",
          "998-0101",
          "999-6705",
          "999-6706",
          "999-6701",
          "999-6702",
          "998-0838",
          "999-6723",
          "998-0837",
          "999-6814",
          "999-8213",
          "999-8205",
          "999-6846",
          "998-0012",
          "998-0114",
          "999-8214",
          "999-6823",
          "999-8204",
          "998-0864",
          "999-6832",
          "998-0854",
          "998-0029",
          "998-0805",
          "999-8246",
          "998-0843",
          "998-0014",
          "999-8155",
          "998-0075",
          "998-0051",
          "999-6848",
          "999-6731",
          "999-6732",
          "998-0033",
          "998-0034",
          "999-8422",
          "999-8245",
          "998-0873",
          "999-6839",
          "998-0835",
          "999-7771",
          "999-8168",
          "998-0811",
          "999-8221",
          "999-6703",
          "998-0856",
          "998-0281",
          "998-0004",
          "999-8141",
          "999-8202",
          "999-6844",
          "998-0872",
          "999-8165",
          "999-6727",
          "999-6722",
          "999-6851",
          "998-0044",
          "999-6827",
          "999-6712",
          "999-6812",
          "999-8157",
          "998-0041",
          "999-7776",
          "998-0103",
          "999-6733",
          "999-6862",
          "998-0017",
          "998-0829",
          "998-0045",
          "999-8144",
          "999-8158",
          "999-8242",
          "998-0826",
          "998-0031",
          "998-0112",
          "998-0074",
          "998-0813",
          "998-0061",
          "998-0013",
          "998-0851",
          "998-0855",
          "998-0831",
          "999-6847",
          "998-0863",
          "998-0037",
          "998-0113",
          "998-0125",
          "998-0105",
          "999-8241",
          "998-0002",
          "998-0861",
          "998-0036",
          "999-8231",
          "999-8154",
          "999-8233",
          "999-8131",
          "998-0001",
          "999-6721",
          "998-0812",
          "998-0043",
          "999-8224",
          "999-8166",
          "999-8201",
          "998-0841",
          "998-0073",
          "999-7777",
          "999-8226",
          "998-0853",
          "998-0052",
          "998-0858",
          "998-0063",
          "999-6822",
          "998-0025",
          "999-8223",
          "999-6825",
          "999-8423",
          "998-0005",
          "998-0054",
          "999-6841",
          "999-6824",
          "999-8134",
          "999-8145",
          "999-8151",
          "999-6861",
          "999-6724",
          "999-6821",
          "999-6734",
          "999-6726",
          "999-6725",
          "998-0821",
          "998-0006",
          "998-0804",
          "999-8161",
          "999-8167",
          "998-0874",
          "999-8421",
          "998-0832",
          "998-0834",
          "998-0857",
          "998-0833",
          "998-0053",
          "996-0000",
          "996-0078",
          "996-0086",
          "999-5103",
          "996-0001",
          "996-0084",
          "996-0026",
          "996-0023",
          "996-0074",
          "996-0071",
          "996-0002",
          "996-0032",
          "996-0082",
          "996-0073",
          "996-0033",
          "996-0034",
          "996-0077",
          "999-5101",
          "996-0076",
          "996-0031",
          "996-0022",
          "996-0079",
          "996-0024",
          "996-0052",
          "996-0035",
          "999-5191",
          "996-0091",
          "996-0021",
          "996-0061",
          "996-0041",
          "996-0081",
          "996-0054",
          "996-0087",
          "996-0083",
          "999-5102",
          "996-0028",
          "996-0011",
          "996-0088",
          "996-0053",
          "996-0085",
          "996-0027",
          "996-0111",
          "996-0051",
          "996-0072",
          "996-0112",
          "996-0075",
          "996-0025",
          "991-0000",
          "991-0027",
          "991-0057",
          "991-0056",
          "991-0006",
          "991-0008",
          "991-0044",
          "991-0045",
          "991-0035",
          "991-0034",
          "991-0041",
          "990-0502",
          "991-0052",
          "990-0511",
          "991-0063",
          "991-0043",
          "991-0002",
          "990-0505",
          "991-0047",
          "991-0012",
          "991-0033",
          "990-0522",
          "991-0013",
          "990-0524",
          "991-0042",
          "990-0503",
          "991-0021",
          "990-0561",
          "991-0061",
          "991-0007",
          "990-0504",
          "991-0005",
          "991-0065",
          "991-0054",
          "991-0022",
          "991-0003",
          "991-0004",
          "991-0011",
          "991-0001",
          "991-0046",
          "991-0064",
          "990-0513",
          "991-0055",
          "991-0028",
          "991-0031",
          "991-0066",
          "991-0023",
          "991-0048",
          "991-0062",
          "991-0032",
          "990-0512",
          "990-0501",
          "991-0049",
          "991-0053",
          "990-0523",
          "990-0521",
          "991-0026",
          "991-0025",
          "990-0525",
          "991-0024",
          "991-0051",
          "999-3100",
          "999-3222",
          "999-3164",
          "999-3106",
          "999-3235",
          "999-3144",
          "999-3244",
          "999-3231",
          "999-3105",
          "999-3165",
          "999-3157",
          "999-3167",
          "999-3112",
          "999-3214",
          "999-3172",
          "999-3124",
          "999-3126",
          "999-3125",
          "999-3101",
          "999-3103",
          "999-3226",
          "999-3204",
          "999-3163",
          "999-3245",
          "999-3145",
          "999-3131",
          "999-3151",
          "999-3215",
          "999-3166",
          "999-3241",
          "999-3237",
          "999-3115",
          "999-3111",
          "999-3113",
          "999-3104",
          "999-3132",
          "999-3142",
          "999-3233",
          "999-3202",
          "999-3217",
          "999-3102",
          "999-3152",
          "999-3158",
          "999-3141",
          "999-3213",
          "999-3221",
          "999-3122",
          "999-3216",
          "999-3243",
          "999-3155",
          "999-3234",
          "999-3153",
          "999-3203",
          "999-3246",
          "999-3232",
          "999-3114",
          "999-3225",
          "999-3242",
          "999-3212",
          "999-3121",
          "999-3143",
          "999-3161",
          "999-3236",
          "999-3211",
          "999-3146",
          "999-3223",
          "999-3123",
          "999-3224",
          "999-3135",
          "999-3107",
          "999-3201",
          "999-3171",
          "999-3154",
          "999-3134",
          "999-3156",
          "999-3133",
          "999-3162",
          "995-0000",
          "995-0002",
          "995-0204",
          "995-0113",
          "995-0038",
          "995-0111",
          "995-0203",
          "995-0054",
          "995-0004",
          "995-0041",
          "995-0056",
          "995-0209",
          "995-0202",
          "995-0042",
          "995-0051",
          "995-0025",
          "995-0032",
          "995-0034",
          "995-0031",
          "995-0011",
          "995-0018",
          "995-0033",
          "995-0021",
          "995-0037",
          "995-0014",
          "995-0017",
          "995-0036",
          "995-0022",
          "995-0023",
          "995-0024",
          "995-0015",
          "995-0016",
          "995-0013",
          "995-0005",
          "995-0205",
          "995-0035",
          "995-0201",
          "995-0001",
          "995-0208",
          "995-0055",
          "995-0052",
          "995-0053",
          "995-0006",
          "995-0003",
          "995-0206",
          "995-0207",
          "995-0012",
          "995-0112",
          "993-0000",
          "993-0022",
          "993-0006",
          "993-0072",
          "993-0031",
          "993-0033",
          "993-0034",
          "993-0083",
          "993-0005",
          "993-0021",
          "993-0032",
          "993-0062",
          "993-0064",
          "993-0063",
          "993-0041",
          "993-0014",
          "993-0085",
          "993-0051",
          "993-0084",
          "993-0054",
          "993-0023",
          "993-0071",
          "993-0052",
          "993-0004",
          "993-0016",
          "993-0013",
          "993-0011",
          "993-0061",
          "993-0086",
          "993-0035",
          "993-0024",
          "993-0053",
          "993-0075",
          "993-0017",
          "993-0003",
          "993-0012",
          "993-0042",
          "993-0082",
          "993-0001",
          "993-0081",
          "993-0074",
          "993-0007",
          "993-0073",
          "993-0002",
          "993-0087",
          "993-0015",
          "994-0000",
          "994-0054",
          "994-0057",
          "994-0015",
          "994-0041",
          "994-0078",
          "994-0047",
          "994-0013",
          "994-0007",
          "994-0079",
          "994-0003",
          "994-0024",
          "994-0025",
          "994-0053",
          "994-0103",
          "994-0011",
          "994-0042",
          "994-0012",
          "994-0077",
          "994-0075",
          "994-0028",
          "994-0032",
          "994-0004",
          "994-0027",
          "994-0052",
          "994-0065",
          "994-0069",
          "994-0005",
          "994-0068",
          "994-0076",
          "994-0046",
          "994-0104",
          "994-0072",
          "994-0073",
          "994-0031",
          "994-0023",
          "994-0074",
          "994-0102",
          "994-0064",
          "994-0045",
          "994-0066",
          "994-0062",
          "994-0051",
          "994-0006",
          "994-0014",
          "994-0022",
          "994-0067",
          "994-0082",
          "994-0083",
          "994-0055",
          "994-0001",
          "994-0016",
          "994-0063",
          "994-0061",
          "994-0026",
          "994-0044",
          "994-0056",
          "994-0034",
          "994-0048",
          "994-0043",
          "994-0002",
          "994-0033",
          "994-0081",
          "994-0049",
          "994-0071",
          "994-0101",
          "994-0021",
          "999-3700",
          "999-3722",
          "999-3747",
          "999-3749",
          "999-3744",
          "999-3746",
          "999-3745",
          "999-3748",
          "999-3717",
          "999-3726",
          "999-3728",
          "999-3714",
          "999-3715",
          "999-3712",
          "999-3737",
          "999-3738",
          "999-3757",
          "999-3756",
          "999-3755",
          "999-3754",
          "999-3753",
          "999-3752",
          "999-3751",
          "999-3702",
          "999-3770",
          "999-3716",
          "999-3723",
          "999-3774",
          "999-3710",
          "999-3786",
          "999-3703",
          "999-3720",
          "999-3773",
          "999-3708",
          "999-3787",
          "999-3707",
          "999-3761",
          "999-3763",
          "999-3764",
          "999-3766",
          "999-3765",
          "999-3762",
          "999-3731",
          "999-3732",
          "999-3736",
          "999-3735",
          "999-3734",
          "999-3733",
          "999-3724",
          "999-3711",
          "999-3729",
          "999-3719",
          "999-3730",
          "999-3778",
          "999-3743",
          "999-3742",
          "999-3741",
          "999-3771",
          "999-3777",
          "999-3725",
          "999-3727",
          "999-3775",
          "999-3776",
          "999-3779",
          "999-3701",
          "999-3721",
          "999-3704",
          "999-3713",
          "999-3784",
          "999-3781",
          "999-3785",
          "999-3782",
          "999-3783",
          "999-3772",
          "999-3706",
          "999-3705",
          "999-3718",
          "999-3709",
          "999-4200",
          "999-4554",
          "999-4223",
          "999-4208",
          "999-4207",
          "999-4552",
          "999-4205",
          "999-4221",
          "999-4222",
          "999-4204",
          "999-4304",
          "999-4332",
          "999-4228",
          "999-4336",
          "999-4231",
          "999-4333",
          "999-4214",
          "999-4334",
          "999-4211",
          "999-4224",
          "999-4226",
          "999-4201",
          "999-4443",
          "999-4337",
          "999-4551",
          "999-4555",
          "999-4206",
          "999-4203",
          "999-4227",
          "999-4556",
          "999-4202",
          "999-4212",
          "999-4213",
          "999-4553",
          "999-4441",
          "999-4445",
          "999-4335",
          "999-4232",
          "999-4444",
          "999-4557",
          "999-4331",
          "999-4229",
          "999-4442",
          "999-4225",
          "999-2200",
          "999-2211",
          "992-0473",
          "992-0474",
          "999-2224",
          "999-2252",
          "992-0582",
          "999-2212",
          "992-0471",
          "999-2201",
          "999-2261",
          "999-2204",
          "999-2221",
          "999-2203",
          "999-2241",
          "992-0581",
          "999-2256",
          "999-2244",
          "992-0583",
          "999-2205",
          "992-0476",
          "999-2255",
          "999-2251",
          "992-0478",
          "992-0584",
          "999-2234",
          "999-2254",
          "999-2264",
          "999-2242",
          "999-2222",
          "999-2266",
          "999-2243",
          "999-2231",
          "999-2265",
          "999-2263",
          "992-0475",
          "999-2267",
          "999-2213",
          "999-2223",
          "999-2232",
          "992-0472",
          "999-2253",
          "999-2202",
          "992-0477",
          "999-2262",
          "992-0479",
          "999-2233",
          "990-0300",
          "990-0311",
          "990-0323",
          "990-0331",
          "990-0341",
          "990-0332",
          "990-0352",
          "990-0342",
          "990-0303",
          "990-0333",
          "990-0321",
          "990-0361",
          "990-0312",
          "990-0302",
          "990-0351",
          "990-0301",
          "990-0322",
          "990-0400",
          "990-0411",
          "990-0402",
          "990-0408",
          "990-0405",
          "990-0409",
          "990-0403",
          "990-0407",
          "990-0401",
          "990-0404",
          "990-0406",
          "999-3500",
          "999-3503",
          "999-3501",
          "999-3521",
          "999-3532",
          "999-3533",
          "999-3531",
          "999-3522",
          "999-3511",
          "999-3515",
          "999-3512",
          "999-3513",
          "999-3514",
          "999-3502",
          "990-0700",
          "990-0714",
          "990-0743",
          "990-0721",
          "990-0702",
          "990-0734",
          "990-0732",
          "990-0731",
          "990-0733",
          "990-0741",
          "990-0713",
          "990-0712",
          "990-0735",
          "990-0703",
          "990-0742",
          "990-0701",
          "990-0711",
          "990-1400",
          "990-1441",
          "990-1303",
          "990-1306",
          "990-1431",
          "990-1305",
          "990-1562",
          "990-1304",
          "990-1422",
          "990-1432",
          "990-1571",
          "990-1563",
          "990-1444",
          "990-1423",
          "990-1574",
          "990-1433",
          "990-1573",
          "990-1302",
          "990-1572",
          "990-1552",
          "990-1301",
          "990-1553",
          "990-1421",
          "990-1561",
          "990-1424",
          "990-1551",
          "990-1442",
          "990-1443",
          "990-1411",
          "990-1412",
          "990-1100",
          "991-0801",
          "990-1101",
          "990-1122",
          "990-1131",
          "990-1152",
          "990-1153",
          "990-1276",
          "990-1141",
          "990-1273",
          "990-1142",
          "990-1275",
          "990-1113",
          "990-1112",
          "990-1111",
          "990-1133",
          "990-1144",
          "990-1145",
          "990-1271",
          "990-1132",
          "990-1134",
          "990-1114",
          "990-1146",
          "990-1272",
          "990-1143",
          "990-1161",
          "990-1121",
          "990-1154",
          "990-1151",
          "990-1164",
          "990-1163",
          "990-1165",
          "990-1162",
          "990-1274",
          "999-4100",
          "999-4113",
          "999-4103",
          "999-4116",
          "999-4111",
          "999-4131",
          "999-4102",
          "999-4115",
          "999-4133",
          "999-4132",
          "999-4141",
          "999-4101",
          "999-4122",
          "999-4134",
          "999-4112",
          "999-4121",
          "999-4114",
          "999-5400",
          "999-5401",
          "999-5414",
          "999-5405",
          "999-5402",
          "999-5404",
          "999-5413",
          "999-5412",
          "999-5411",
          "999-5415",
          "999-5403",
          "999-5406",
          "999-6100",
          "999-6211",
          "999-6103",
          "999-6106",
          "999-6212",
          "999-6215",
          "999-6105",
          "999-6102",
          "999-6213",
          "999-6104",
          "999-6107",
          "999-6101",
          "999-6214",
          "999-4600",
          "999-4602",
          "999-4603",
          "999-4605",
          "999-4601",
          "999-4604",
          "999-5300",
          "999-5312",
          "999-5313",
          "999-5521",
          "999-5603",
          "999-5604",
          "999-5601",
          "999-5301",
          "999-5314",
          "999-5522",
          "999-5602",
          "999-5311",
          "996-0200",
          "996-0211",
          "996-0213",
          "996-0212",
          "996-0301",
          "996-0201",
          "999-5200",
          "999-5208",
          "999-5203",
          "999-5201",
          "999-5202",
          "999-5205",
          "999-5207",
          "999-5206",
          "999-5204",
          "999-6400",
          "999-6312",
          "999-6402",
          "999-6315",
          "999-6403",
          "999-6311",
          "999-6313",
          "999-6801",
          "999-6401",
          "999-6314",
          "992-0300",
          "992-0332",
          "992-0302",
          "999-2171",
          "992-0315",
          "992-0334",
          "992-0324",
          "999-2177",
          "992-0333",
          "992-0311",
          "999-2178",
          "992-0261",
          "992-0321",
          "992-0335",
          "992-0313",
          "992-0312",
          "992-0265",
          "992-0331",
          "992-0314",
          "992-0263",
          "999-2179",
          "992-0351",
          "992-0342",
          "992-0323",
          "992-0341",
          "992-0352",
          "992-0322",
          "999-2172",
          "992-0301",
          "999-2176",
          "992-0343",
          "992-0264",
          "992-0344",
          "999-2174",
          "999-2175",
          "992-0325",
          "992-0262",
          "999-2173",
          "999-0100",
          "992-0602",
          "999-0151",
          "999-0213",
          "999-0152",
          "999-0121",
          "999-0131",
          "999-0132",
          "999-0133",
          "999-0145",
          "999-0134",
          "999-0212",
          "999-0211",
          "999-0141",
          "999-0361",
          "999-0144",
          "999-0122",
          "992-0601",
          "999-0143",
          "992-0603",
          "999-0153",
          "999-0142",
          "999-0214",
          "999-1300",
          "999-1356",
          "999-1323",
          "999-1507",
          "999-1504",
          "999-1402",
          "999-1434",
          "999-1213",
          "999-1322",
          "999-1451",
          "999-1521",
          "999-1506",
          "999-1203",
          "999-1413",
          "999-1435",
          "999-1352",
          "999-1421",
          "999-1212",
          "999-1336",
          "999-1342",
          "999-1363",
          "999-1351",
          "999-1312",
          "999-1441",
          "999-1443",
          "999-1436",
          "999-1311",
          "999-1512",
          "999-1301",
          "999-1211",
          "999-1214",
          "999-1345",
          "999-1334",
          "999-1339",
          "999-1522",
          "999-1452",
          "999-1354",
          "999-1361",
          "999-1202",
          "999-1412",
          "999-1337",
          "999-1314",
          "999-1503",
          "999-1338",
          "999-1333",
          "999-1442",
          "999-1502",
          "999-1344",
          "999-1335",
          "999-1511",
          "999-1514",
          "999-1501",
          "999-1321",
          "999-1414",
          "999-1432",
          "999-1513",
          "999-1422",
          "999-1355",
          "999-1215",
          "999-1201",
          "999-1313",
          "999-1216",
          "999-1331",
          "999-1433",
          "999-1505",
          "999-1353",
          "999-1401",
          "999-1302",
          "999-1341",
          "999-1332",
          "999-1324",
          "999-1411",
          "999-1362",
          "999-1343",
          "999-1431",
          "999-1346",
          "999-1303",
          "992-0800",
          "992-0852",
          "992-0771",
          "992-0831",
          "992-0832",
          "992-0861",
          "992-0775",
          "992-0841",
          "992-0864",
          "992-0862",
          "992-0821",
          "992-0863",
          "992-0778",
          "992-0773",
          "992-0812",
          "992-0777",
          "992-0802",
          "992-0811",
          "992-0801",
          "992-0851",
          "992-0779",
          "992-0776",
          "992-0774",
          "992-0772",
          "999-0600",
          "999-0436",
          "999-0425",
          "999-0427",
          "999-0426",
          "999-0424",
          "999-0433",
          "999-0434",
          "999-0603",
          "999-1113",
          "999-0421",
          "999-0431",
          "999-0432",
          "999-0423",
          "999-0605",
          "999-0435",
          "999-1112",
          "999-0604",
          "999-1111",
          "999-0601",
          "999-0602",
          "999-0422",
          "999-0606",
          "997-1300",
          "997-1311",
          "997-1316",
          "997-1321",
          "997-1313",
          "997-1336",
          "997-1315",
          "997-1337",
          "997-1331",
          "997-1312",
          "997-1334",
          "997-1332",
          "997-1322",
          "997-1317",
          "997-1314",
          "997-1335",
          "997-1333",
          "997-1338",
          "997-1339",
          "997-1301",
          "999-7700",
          "999-7724",
          "999-7701",
          "999-7781",
          "999-7714",
          "999-7743",
          "999-7755",
          "999-7702",
          "999-7747",
          "999-7737",
          "999-7752",
          "999-7763",
          "999-7762",
          "999-6601",
          "999-6607",
          "999-7766",
          "999-7742",
          "999-6606",
          "999-6605",
          "999-7722",
          "999-7745",
          "999-7725",
          "999-6608",
          "999-7754",
          "999-7713",
          "999-7782",
          "999-7765",
          "999-6604",
          "999-6603",
          "999-7741",
          "999-7761",
          "999-6609",
          "999-7748",
          "999-7704",
          "999-7721",
          "999-7707",
          "999-7731",
          "999-7734",
          "999-7751",
          "999-7768",
          "999-7746",
          "999-7757",
          "999-7706",
          "999-7703",
          "999-7767",
          "999-7736",
          "999-7711",
          "999-7726",
          "999-7712",
          "999-7735",
          "999-7705",
          "999-7715",
          "999-6602",
          "999-7733",
          "999-7727",
          "999-7732",
          "999-7764",
          "999-7756",
          "999-7744",
          "999-7753",
          "999-7749",
          "999-7723",
          "999-8300",
          "999-8436",
          "999-8433",
          "999-8315",
          "999-8311",
          "999-8312",
          "999-8314",
          "999-8522",
          "999-8317",
          "999-8435",
          "999-8304",
          "999-8431",
          "999-8531",
          "999-8313",
          "999-8525",
          "999-8523",
          "999-8524",
          "999-8316",
          "999-8303",
          "999-8438",
          "999-8521",
          "999-8437",
          "999-8434",
          "999-8432",
          "999-8301",
          "999-8302",
          "960-0000",
          "960-8113",
          "960-2156",
          "960-2102",
          "960-8042",
          "960-0201",
          "960-0261",
          "960-0221",
          "960-0231",
          "960-0271",
          "960-0211",
          "960-1301",
          "960-1303",
          "960-1304",
          "960-1302",
          "960-8244",
          "960-8253",
          "960-8117",
          "960-8241",
          "960-8243",
          "960-8101",
          "960-8222",
          "960-0251",
          "960-8068",
          "960-0811",
          "960-8014",
          "960-8041",
          "960-1101",
          "960-8237",
          "960-8201",
          "960-8204",
          "960-8034",
          "960-0114",
          "960-8142",
          "960-8064",
          "960-1104",
          "960-8252",
          "960-8012",
          "960-8116",
          "960-8021",
          "960-1248",
          "960-0102",
          "960-8217",
          "960-1107",
          "960-2155",
          "960-8076",
          "960-8134",
          "960-8026",
          "960-8131",
          "960-8251",
          "960-8072",
          "960-8221",
          "960-8226",
          "960-8231",
          "960-8102",
          "960-0113",
          "960-8017",
          "960-8016",
          "960-8015",
          "960-8153",
          "960-8052",
          "960-8218",
          "960-8121",
          "960-8135",
          "960-8025",
          "960-8161",
          "960-8111",
          "960-2262",
          "960-8031",
          "960-8242",
          "960-2101",
          "960-8133",
          "960-2154",
          "960-2251",
          "960-2151",
          "960-8057",
          "960-0241",
          "960-8061",
          "960-2158",
          "960-8234",
          "960-8124",
          "960-8155",
          "960-8122",
          "960-8215",
          "960-0115",
          "960-1106",
          "960-8075",
          "960-2153",
          "960-8032",
          "960-8022",
          "960-8036",
          "960-8067",
          "960-8065",
          "960-0252",
          "960-8062",
          "960-0101",
          "960-8051",
          "960-8151",
          "960-8023",
          "960-8235",
          "960-8156",
          "960-1321",
          "960-8232",
          "960-8225",
          "960-8224",
          "960-8227",
          "960-8211",
          "960-8105",
          "960-2152",
          "960-2157",
          "960-8001",
          "960-8024",
          "960-8213",
          "960-8125",
          "960-8123",
          "960-8152",
          "960-8104",
          "960-8216",
          "960-8043",
          "960-1102",
          "960-1108",
          "960-8143",
          "960-8013",
          "960-8166",
          "960-8074",
          "960-8233",
          "960-8055",
          "960-8112",
          "960-8107",
          "960-8033",
          "960-1247",
          "960-8071",
          "960-8132",
          "960-1103",
          "960-8154",
          "960-2263",
          "960-8103",
          "960-8214",
          "960-8163",
          "960-8157",
          "960-8137",
          "960-2261",
          "960-1241",
          "960-1245",
          "960-1246",
          "960-1232",
          "960-1244",
          "960-1231",
          "960-1242",
          "960-1243",
          "960-8018",
          "960-8114",
          "960-8228",
          "960-0111",
          "960-8053",
          "960-8054",
          "960-8212",
          "960-8254",
          "960-8073",
          "960-8162",
          "960-0112",
          "960-8011",
          "960-0116",
          "960-8106",
          "960-8203",
          "960-0103",
          "960-8035",
          "960-8003",
          "960-8002",
          "960-8164",
          "960-8223",
          "960-8056",
          "960-8136",
          "960-8066",
          "960-8063",
          "960-8236",
          "960-8202",
          "960-8115",
          "960-1105",
          "960-8165",
          "960-8044",
          "960-8141",
          "965-0000",
          "965-0031",
          "965-0032",
          "965-0012",
          "965-0007",
          "965-0055",
          "965-0002",
          "965-0005",
          "965-0006",
          "965-0001",
          "965-0004",
          "965-0003",
          "965-0059",
          "965-0034",
          "965-0041",
          "965-0873",
          "965-0025",
          "965-0014",
          "969-5147",
          "969-5111",
          "969-5133",
          "969-5141",
          "969-5142",
          "969-5144",
          "969-5143",
          "969-5145",
          "969-5146",
          "969-5114",
          "969-5132",
          "969-5123",
          "969-5122",
          "969-5121",
          "969-5112",
          "969-5131",
          "969-5113",
          "965-0042",
          "965-0851",
          "965-0831",
          "965-0802",
          "965-0056",
          "969-3461",
          "969-3411",
          "969-3401",
          "969-3462",
          "969-3421",
          "969-3463",
          "969-3464",
          "969-3422",
          "969-3481",
          "969-3482",
          "969-3451",
          "969-3431",
          "969-3471",
          "969-3402",
          "969-3441",
          "969-3412",
          "965-0865",
          "969-6002",
          "965-0113",
          "965-0118",
          "965-0107",
          "965-0116",
          "965-0136",
          "969-6008",
          "969-6182",
          "969-6012",
          "965-0121",
          "969-6183",
          "969-6007",
          "969-6189",
          "965-0126",
          "969-6184",
          "965-0111",
          "969-6013",
          "969-6185",
          "965-0128",
          "969-6006",
          "965-0115",
          "965-0117",
          "965-0135",
          "969-6001",
          "965-0131",
          "965-0110",
          "969-6003",
          "969-6011",
          "965-0112",
          "965-0134",
          "969-6188",
          "965-0133",
          "969-6004",
          "969-6186",
          "965-0132",
          "965-0129",
          "969-6005",
          "965-0101",
          "969-6015",
          "965-0114",
          "965-0124",
          "965-0127",
          "969-6180",
          "965-0824",
          "965-0015",
          "965-0033",
          "965-0812",
          "965-0823",
          "965-0082",
          "965-0068",
          "965-0083",
          "965-0062",
          "965-0064",
          "965-0067",
          "965-0061",
          "965-0063",
          "965-0087",
          "965-0069",
          "965-0065",
          "965-0081",
          "965-0085",
          "965-0080",
          "965-0089",
          "965-0084",
          "965-0086",
          "965-0859",
          "965-0858",
          "965-0066",
          "965-0073",
          "965-0077",
          "965-0071",
          "965-0079",
          "965-0076",
          "965-0075",
          "965-0072",
          "965-0074",
          "965-0078",
          "965-0023",
          "965-0853",
          "965-0871",
          "965-0854",
          "965-0047",
          "965-0864",
          "965-0807",
          "965-0809",
          "965-0043",
          "965-0038",
          "965-0803",
          "965-0866",
          "965-0855",
          "965-0817",
          "965-0060",
          "965-0806",
          "965-0022",
          "965-0835",
          "965-0836",
          "965-0037",
          "965-0847",
          "965-0013",
          "965-0011",
          "965-0832",
          "965-0805",
          "965-0016",
          "965-0878",
          "965-0044",
          "965-0848",
          "965-0837",
          "965-0877",
          "965-0045",
          "965-0830",
          "965-0861",
          "965-0048",
          "965-0027",
          "965-0804",
          "965-0822",
          "965-0036",
          "965-0035",
          "965-0872",
          "965-0818",
          "965-0839",
          "965-0813",
          "965-0815",
          "965-0814",
          "965-0008",
          "965-0024",
          "965-0852",
          "965-0838",
          "965-0026",
          "965-0862",
          "965-0856",
          "965-0849",
          "965-0054",
          "965-0053",
          "965-0058",
          "965-0088",
          "965-0052",
          "965-0057",
          "965-0051",
          "965-0102",
          "965-0103",
          "965-0867",
          "965-0201",
          "965-0202",
          "965-0203",
          "965-0204",
          "965-0205",
          "965-0816",
          "965-0874",
          "965-0808",
          "965-0801",
          "965-0833",
          "965-0844",
          "965-0828",
          "965-0826",
          "965-0825",
          "965-0827",
          "965-0843",
          "965-0842",
          "965-0846",
          "965-0829",
          "965-0834",
          "965-0841",
          "965-0845",
          "965-0009",
          "965-0857",
          "965-0876",
          "965-0021",
          "965-0863",
          "965-0821",
          "965-0046",
          "965-0875",
          "965-0811",
          "963-0000",
          "963-8006",
          "963-0667",
          "963-0107",
          "963-0117",
          "963-0116",
          "963-0118",
          "963-0114",
          "963-0111",
          "963-0113",
          "963-0103",
          "963-0102",
          "963-0105",
          "963-0112",
          "963-0101",
          "963-0104",
          "963-0109",
          "963-8024",
          "963-8873",
          "963-1304",
          "963-1309",
          "963-1301",
          "963-1306",
          "963-1305",
          "963-1302",
          "963-1303",
          "963-1308",
          "963-1307",
          "963-0664",
          "963-0704",
          "963-8045",
          "963-8875",
          "963-8825",
          "963-8814",
          "963-8036",
          "963-8002",
          "963-0212",
          "963-0213",
          "963-0214",
          "963-8828",
          "963-8817",
          "963-0201",
          "963-8001",
          "963-8851",
          "963-8833",
          "963-8844",
          "963-0202",
          "963-0211",
          "963-0703",
          "963-1311",
          "963-8031",
          "963-8816",
          "963-8033",
          "963-0221",
          "963-8829",
          "963-8843",
          "963-0551",
          "963-0545",
          "963-0547",
          "963-0544",
          "963-0542",
          "963-0541",
          "963-0543",
          "963-0546",
          "963-8804",
          "963-8035",
          "963-8846",
          "963-8025",
          "963-8038",
          "963-8866",
          "963-8039",
          "963-0209",
          "963-1631",
          "963-1412",
          "963-1521",
          "963-1414",
          "963-1632",
          "963-1633",
          "963-1411",
          "963-1522",
          "963-1413",
          "963-8835",
          "963-8865",
          "963-8867",
          "963-8862",
          "963-8863",
          "963-8872",
          "963-8012",
          "963-8021",
          "963-0108",
          "963-8807",
          "963-0232",
          "963-0203",
          "963-8034",
          "963-8005",
          "963-8032",
          "963-0663",
          "963-8806",
          "963-8818",
          "963-8822",
          "963-0662",
          "963-8842",
          "963-8013",
          "963-8815",
          "963-8834",
          "963-8827",
          "963-8852",
          "963-8007",
          "963-8864",
          "963-1153",
          "963-1151",
          "963-0725",
          "963-1248",
          "963-0724",
          "963-1241",
          "963-1154",
          "963-0722",
          "963-0723",
          "963-1162",
          "963-1247",
          "963-0726",
          "963-1163",
          "963-1243",
          "963-1161",
          "963-0721",
          "963-1165",
          "963-1244",
          "963-1245",
          "963-1242",
          "963-1156",
          "963-1152",
          "963-1164",
          "963-1155",
          "963-1246",
          "963-8017",
          "963-0204",
          "963-0205",
          "963-8878",
          "963-8861",
          "963-8008",
          "963-8824",
          "963-8877",
          "963-8047",
          "963-8041",
          "963-8016",
          "963-8014",
          "963-0714",
          "963-0711",
          "963-0834",
          "963-0712",
          "963-0835",
          "963-0836",
          "963-0837",
          "963-0833",
          "963-0713",
          "963-0832",
          "963-0831",
          "963-0206",
          "963-0216",
          "963-8004",
          "963-8845",
          "963-8043",
          "963-8831",
          "963-8026",
          "963-0106",
          "963-0207",
          "963-0925",
          "963-0903",
          "963-0924",
          "963-0911",
          "963-0921",
          "963-0914",
          "963-0923",
          "963-0922",
          "963-0913",
          "963-0902",
          "963-0904",
          "963-0901",
          "963-0912",
          "963-8022",
          "963-8813",
          "963-8836",
          "963-8876",
          "963-8037",
          "963-8871",
          "963-8003",
          "963-0552",
          "963-8821",
          "963-8044",
          "963-0534",
          "963-0532",
          "963-0531",
          "963-0533",
          "963-8874",
          "963-8838",
          "963-8071",
          "963-0673",
          "963-8061",
          "963-0671",
          "963-0672",
          "963-8051",
          "963-8042",
          "963-8826",
          "963-8823",
          "963-8805",
          "963-8811",
          "963-8015",
          "963-0215",
          "963-8046",
          "963-8812",
          "963-0702",
          "963-0701",
          "963-8023",
          "963-0115",
          "963-0127",
          "963-0121",
          "963-0128",
          "963-0124",
          "963-0125",
          "963-0123",
          "963-0122",
          "963-0129",
          "963-0126",
          "963-0119",
          "963-8801",
          "963-0661",
          "963-8018",
          "963-8837",
          "963-8802",
          "963-0208",
          "963-0231",
          "963-0666",
          "963-8052",
          "963-8053",
          "963-8841",
          "963-8832",
          "963-0665",
          "963-8803",
          "963-8011",
          "970-0000",
          "974-8212",
          "974-8213",
          "970-8017",
          "971-8172",
          "971-8188",
          "971-8171",
          "971-8185",
          "971-8184",
          "971-8183",
          "971-8182",
          "971-8186",
          "971-8181",
          "974-8222",
          "974-8261",
          "974-8203",
          "970-0229",
          "973-8404",
          "973-8401",
          "973-8406",
          "973-8405",
          "973-8408",
          "973-8403",
          "973-8409",
          "973-8402",
          "973-8407",
          "970-0311",
          "974-8201",
          "979-0338",
          "979-0336",
          "979-0337",
          "979-3112",
          "979-3124",
          "979-3115",
          "979-3123",
          "979-3111",
          "979-3114",
          "979-3122",
          "979-3121",
          "979-3125",
          "979-3113",
          "973-8411",
          "971-8101",
          "971-8123",
          "971-8166",
          "971-8165",
          "971-8121",
          "971-8111",
          "971-8151",
          "971-8135",
          "970-0317",
          "971-8168",
          "971-8125",
          "970-0316",
          "971-8124",
          "971-8161",
          "971-8127",
          "971-8164",
          "971-8163",
          "971-8167",
          "971-8126",
          "971-8162",
          "971-8102",
          "971-8169",
          "971-8112",
          "971-8122",
          "974-8221",
          "970-0312",
          "971-8134",
          "971-8139",
          "971-8142",
          "971-8143",
          "971-8144",
          "971-8133",
          "971-8132",
          "971-8141",
          "971-8145",
          "971-8146",
          "974-8211",
          "979-0153",
          "979-3204",
          "979-3203",
          "979-3202",
          "979-3201",
          "972-8301",
          "972-8324",
          "970-8045",
          "974-8223",
          "970-8033",
          "971-8152",
          "972-8313",
          "972-8315",
          "971-8131",
          "972-8322",
          "972-8317",
          "972-8312",
          "972-8325",
          "972-8318",
          "972-8316",
          "972-8326",
          "972-8314",
          "972-8323",
          "971-8137",
          "971-8136",
          "972-8311",
          "972-8321",
          "979-0151",
          "974-8202",
          "970-8026",
          "979-3131",
          "979-3132",
          "970-0107",
          "970-0112",
          "970-0223",
          "970-8013",
          "970-8023",
          "970-8054",
          "970-8034",
          "970-8032",
          "970-0104",
          "970-0102",
          "970-8011",
          "970-8012",
          "970-8028",
          "970-0101",
          "970-8042",
          "970-0221",
          "970-8001",
          "970-8003",
          "970-0228",
          "970-0225",
          "970-0115",
          "970-8024",
          "970-0113",
          "970-8027",
          "970-8041",
          "970-8022",
          "970-8004",
          "970-8005",
          "970-8006",
          "970-0226",
          "970-8053",
          "970-0105",
          "970-0227",
          "970-0224",
          "970-8021",
          "970-8016",
          "970-8002",
          "970-8007",
          "970-8008",
          "970-8031",
          "970-0222",
          "970-8052",
          "970-0111",
          "970-0103",
          "970-8014",
          "970-0116",
          "970-0114",
          "970-8025",
          "970-8036",
          "970-0106",
          "970-8046",
          "970-8018",
          "970-8051",
          "974-8204",
          "974-0243",
          "974-0242",
          "974-0151",
          "974-0241",
          "974-0153",
          "974-0252",
          "974-0152",
          "970-8044",
          "970-8043",
          "970-8047",
          "972-8338",
          "972-0251",
          "972-0253",
          "972-0161",
          "972-0252",
          "972-0162",
          "972-0163",
          "972-0164",
          "974-8231",
          "974-8251",
          "970-0313",
          "970-0315",
          "979-0144",
          "979-0141",
          "979-0147",
          "979-0142",
          "979-0145",
          "979-0143",
          "979-0146",
          "974-8252",
          "974-8232",
          "974-8233",
          "979-0154",
          "971-8187",
          "979-0332",
          "979-0331",
          "979-0335",
          "979-0333",
          "979-0334",
          "973-8412",
          "979-0155",
          "974-8242",
          "970-1373",
          "970-1372",
          "970-1262",
          "970-1263",
          "970-1374",
          "970-1375",
          "970-1376",
          "970-1264",
          "970-1377",
          "970-1371",
          "970-1361",
          "970-1261",
          "970-8035",
          "974-8241",
          "979-0152",
          "970-0314",
          "970-1144",
          "970-1141",
          "970-1142",
          "970-1147",
          "970-1143",
          "970-1153",
          "970-1152",
          "970-1151",
          "970-8015",
          "970-1145",
          "970-1146",
          "979-0201",
          "979-0205",
          "979-0221",
          "979-0202",
          "979-0203",
          "979-0226",
          "979-0225",
          "979-0206",
          "979-0227",
          "979-0207",
          "979-0211",
          "979-0216",
          "979-0212",
          "979-0215",
          "979-0214",
          "979-0213",
          "979-0204",
          "979-0224",
          "979-0222",
          "979-0223",
          "971-8138",
          "972-8331",
          "972-8336",
          "972-8334",
          "972-8337",
          "972-8332",
          "972-8333",
          "972-8335",
          "961-0000",
          "961-0075",
          "961-0901",
          "961-0912",
          "961-0942",
          "961-0082",
          "961-0081",
          "961-0032",
          "961-0827",
          "961-0826",
          "961-0825",
          "961-0867",
          "961-0003",
          "961-0016",
          "961-0947",
          "961-0937",
          "961-0026",
          "961-0039",
          "961-0063",
          "961-0931",
          "961-0904",
          "961-0915",
          "961-0036",
          "961-0921",
          "961-0831",
          "961-0838",
          "961-0094",
          "961-0846",
          "961-0845",
          "961-0908",
          "961-0002",
          "961-0985",
          "961-0984",
          "961-0885",
          "961-0884",
          "961-0887",
          "961-0409",
          "961-0416",
          "961-0405",
          "961-0412",
          "961-0414",
          "961-0402",
          "961-0407",
          "961-0401",
          "961-0403",
          "961-0411",
          "961-0408",
          "961-0413",
          "961-0404",
          "961-0415",
          "961-0406",
          "961-0064",
          "961-0074",
          "961-0886",
          "961-0913",
          "961-0943",
          "961-0023",
          "961-0004",
          "961-0014",
          "961-0956",
          "961-0802",
          "961-0821",
          "961-0054",
          "961-0973",
          "961-0996",
          "961-0974",
          "961-0981",
          "961-0083",
          "961-0084",
          "961-0042",
          "961-0011",
          "961-0875",
          "961-0874",
          "961-0017",
          "961-0045",
          "961-0001",
          "961-0852",
          "961-0076",
          "961-0815",
          "961-0965",
          "961-0944",
          "961-0803",
          "961-0911",
          "961-0862",
          "961-0872",
          "961-0814",
          "961-0986",
          "961-0072",
          "961-0071",
          "961-0863",
          "961-0888",
          "961-0829",
          "961-0828",
          "961-0027",
          "961-0922",
          "961-0971",
          "961-0924",
          "961-0923",
          "961-0835",
          "961-0842",
          "961-0933",
          "961-0856",
          "961-0853",
          "961-0024",
          "961-0037",
          "961-0811",
          "961-0021",
          "961-0822",
          "961-0916",
          "961-0062",
          "961-0051",
          "961-0936",
          "969-0301",
          "961-8002",
          "969-0302",
          "969-0303",
          "969-0304",
          "969-0305",
          "969-0306",
          "969-0307",
          "969-0308",
          "969-0309",
          "961-0953",
          "961-0854",
          "961-0855",
          "961-0015",
          "961-0972",
          "961-0975",
          "961-0061",
          "961-0073",
          "961-0866",
          "961-0087",
          "961-0086",
          "961-0935",
          "961-0914",
          "961-0954",
          "961-0957",
          "961-0955",
          "961-0817",
          "961-0046",
          "961-0005",
          "961-0823",
          "961-0053",
          "961-0844",
          "961-0951",
          "961-0952",
          "961-0995",
          "961-0994",
          "961-0991",
          "961-0993",
          "961-0025",
          "961-0812",
          "961-0077",
          "961-0816",
          "961-0832",
          "961-0834",
          "961-0837",
          "961-0946",
          "961-0903",
          "961-0962",
          "961-0038",
          "961-0941",
          "961-0033",
          "961-0047",
          "961-0865",
          "961-0093",
          "961-0902",
          "961-0963",
          "961-0306",
          "961-0308",
          "961-0303",
          "961-0302",
          "961-0304",
          "961-0301",
          "961-0305",
          "961-0307",
          "961-0309",
          "961-0813",
          "961-0883",
          "961-0833",
          "961-0964",
          "961-0861",
          "961-0864",
          "961-0934",
          "961-0043",
          "961-0044",
          "961-0013",
          "961-0843",
          "961-0841",
          "961-0804",
          "961-0801",
          "961-0085",
          "961-0873",
          "961-0983",
          "961-0824",
          "961-0836",
          "961-0031",
          "961-0035",
          "961-0022",
          "961-0052",
          "961-0851",
          "961-0992",
          "961-0857",
          "961-0932",
          "961-0982",
          "961-0925",
          "961-0065",
          "961-0945",
          "961-0012",
          "961-0905",
          "961-0906",
          "961-0805",
          "961-0917",
          "961-0034",
          "961-0091",
          "961-0041",
          "961-0926",
          "961-0907",
          "961-0881",
          "961-0882",
          "961-0961",
          "961-0078",
          "961-0871",
          "961-0066",
          "961-0092",
          "962-0000",
          "962-0811",
          "962-0816",
          "962-0834",
          "962-0868",
          "962-0867",
          "962-0721",
          "962-0843",
          "962-0044",
          "962-0058",
          "962-0046",
          "962-0726",
          "962-0034",
          "962-0042",
          "962-0024",
          "962-0301",
          "962-0026",
          "962-0033",
          "962-0003",
          "962-0043",
          "962-0054",
          "962-0833",
          "962-0303",
          "962-0204",
          "962-0801",
          "962-0056",
          "962-0312",
          "962-0722",
          "962-0032",
          "962-0839",
          "962-0013",
          "962-0712",
          "962-0051",
          "962-0053",
          "962-0031",
          "962-0846",
          "962-0713",
          "962-0841",
          "962-0864",
          "962-0856",
          "962-0061",
          "962-0313",
          "962-0405",
          "962-0122",
          "962-0805",
          "962-0866",
          "962-0848",
          "962-0401",
          "962-0727",
          "962-0202",
          "962-0807",
          "962-0858",
          "962-0011",
          "962-0821",
          "962-0035",
          "962-0711",
          "962-0201",
          "962-0714",
          "962-0806",
          "962-0007",
          "962-0002",
          "962-0824",
          "962-0012",
          "962-0055",
          "962-0847",
          "962-0205",
          "962-0036",
          "962-0835",
          "962-0005",
          "962-0023",
          "962-0837",
          "962-0211",
          "962-0304",
          "962-0404",
          "962-0021",
          "962-0724",
          "962-0028",
          "962-0857",
          "962-0859",
          "962-0802",
          "962-0827",
          "962-0851",
          "962-0804",
          "962-0203",
          "962-0852",
          "962-0845",
          "962-0004",
          "962-0836",
          "962-0403",
          "962-0402",
          "962-0052",
          "962-0014",
          "962-0016",
          "962-0017",
          "962-0728",
          "962-0063",
          "962-0302",
          "962-0315",
          "962-0831",
          "962-0025",
          "962-0823",
          "962-0126",
          "962-0812",
          "962-0822",
          "962-0844",
          "962-0725",
          "962-0015",
          "962-0826",
          "962-0314",
          "962-0057",
          "962-0803",
          "962-0861",
          "962-0854",
          "962-0124",
          "962-0045",
          "962-0125",
          "962-0027",
          "962-0815",
          "962-0853",
          "962-0814",
          "962-0047",
          "962-0022",
          "962-0863",
          "962-0817",
          "962-0838",
          "962-0842",
          "962-0406",
          "962-0865",
          "962-0723",
          "962-0832",
          "962-0001",
          "962-0305",
          "962-0855",
          "962-0311",
          "962-0123",
          "962-0062",
          "962-0006",
          "962-0121",
          "962-0041",
          "962-0059",
          "962-0862",
          "962-0825",
          "962-0813",
          "962-0818",
          "966-0000",
          "966-0819",
          "966-0818",
          "966-0817",
          "966-0091",
          "966-0108",
          "966-0101",
          "966-0107",
          "966-0103",
          "966-0106",
          "966-0105",
          "966-0102",
          "966-0104",
          "966-0887",
          "966-0053",
          "966-0868",
          "966-0849",
          "966-0848",
          "966-0057",
          "966-0069",
          "966-0087",
          "966-0001",
          "966-0005",
          "966-0003",
          "966-0004",
          "966-0002",
          "966-0821",
          "966-0838",
          "966-0085",
          "966-0867",
          "966-0904",
          "966-0836",
          "966-0037",
          "966-0839",
          "966-0915",
          "966-0054",
          "966-0094",
          "966-0095",
          "966-0096",
          "966-0814",
          "966-0825",
          "966-0831",
          "966-0805",
          "966-0813",
          "966-0803",
          "966-0894",
          "966-0039",
          "966-0891",
          "966-0043",
          "966-0811",
          "966-0931",
          "966-0933",
          "966-0932",
          "966-0842",
          "966-0851",
          "966-0072",
          "966-0006",
          "966-0835",
          "966-0892",
          "966-0874",
          "966-0022",
          "966-0024",
          "966-0023",
          "966-0021",
          "966-0923",
          "966-0922",
          "966-0921",
          "966-0924",
          "966-0872",
          "966-0869",
          "966-0048",
          "966-0063",
          "966-0877",
          "966-0802",
          "966-0038",
          "966-0841",
          "966-0044",
          "966-0827",
          "969-3538",
          "969-3514",
          "969-3523",
          "969-3532",
          "969-3536",
          "969-3521",
          "969-3535",
          "969-3505",
          "969-3506",
          "969-3539",
          "969-3525",
          "969-3503",
          "969-3527",
          "969-3537",
          "969-3524",
          "969-3522",
          "969-3528",
          "969-3526",
          "969-3534",
          "969-3502",
          "969-3513",
          "969-3504",
          "969-3531",
          "969-3533",
          "969-3512",
          "969-3511",
          "969-3501",
          "969-3515",
          "966-0093",
          "966-0092",
          "966-0042",
          "966-0850",
          "966-0896",
          "966-0015",
          "966-0014",
          "966-0012",
          "966-0011",
          "966-0013",
          "966-0016",
          "966-0017",
          "966-0033",
          "966-0047",
          "966-0853",
          "966-0854",
          "966-0064",
          "966-0055",
          "966-0855",
          "969-4303",
          "969-4312",
          "969-4304",
          "969-4316",
          "969-4301",
          "969-4314",
          "969-4313",
          "969-4315",
          "969-4311",
          "969-4302",
          "966-0873",
          "966-0884",
          "966-0856",
          "966-0097",
          "966-0875",
          "966-0865",
          "966-0068",
          "966-0861",
          "966-0871",
          "966-0062",
          "966-0852",
          "966-0899",
          "966-0801",
          "966-0862",
          "966-0912",
          "966-0913",
          "966-0911",
          "966-0914",
          "966-0845",
          "966-0049",
          "966-0065",
          "966-0833",
          "966-0881",
          "966-0035",
          "966-0882",
          "966-0073",
          "966-0032",
          "966-0864",
          "966-0082",
          "966-0084",
          "966-0844",
          "966-0081",
          "966-0086",
          "966-0034",
          "966-0804",
          "966-0893",
          "966-0061",
          "966-0046",
          "966-0859",
          "966-0895",
          "966-0843",
          "966-0823",
          "966-0007",
          "966-0051",
          "966-0832",
          "966-0058",
          "966-0031",
          "966-0866",
          "966-0816",
          "966-0837",
          "966-0041",
          "966-0858",
          "966-0863",
          "966-0826",
          "966-0847",
          "966-0846",
          "966-0857",
          "966-0903",
          "966-0901",
          "966-0902",
          "966-0898",
          "966-0806",
          "966-0812",
          "966-0045",
          "966-0074",
          "966-0066",
          "966-0067",
          "966-0056",
          "966-0815",
          "966-0834",
          "966-0036",
          "966-0822",
          "969-4107",
          "969-4106",
          "969-4140",
          "969-4147",
          "969-4102",
          "969-4108",
          "969-4155",
          "969-4148",
          "969-4113",
          "969-4112",
          "969-4152",
          "969-4126",
          "969-4119",
          "969-4121",
          "969-4167",
          "969-4151",
          "969-4164",
          "969-4162",
          "969-4122",
          "969-4139",
          "969-4127",
          "969-4111",
          "969-4115",
          "969-4103",
          "969-4101",
          "969-4157",
          "969-4114",
          "969-4166",
          "969-4143",
          "969-4132",
          "969-4116",
          "969-4117",
          "969-4163",
          "969-4153",
          "969-4138",
          "969-4154",
          "969-4141",
          "969-4144",
          "969-4161",
          "969-4123",
          "969-4137",
          "969-4142",
          "969-4156",
          "969-4145",
          "969-4124",
          "969-4146",
          "969-4135",
          "969-4131",
          "969-4133",
          "969-4118",
          "969-4104",
          "969-4136",
          "969-4105",
          "969-4165",
          "969-4134",
          "969-4125",
          "969-4149",
          "969-4109",
          "966-0071",
          "966-0052",
          "966-0083",
          "966-0824",
          "976-0000",
          "979-2521",
          "976-0152",
          "976-0006",
          "979-2501",
          "979-2541",
          "976-0025",
          "976-0007",
          "976-0001",
          "976-0032",
          "976-0016",
          "976-0053",
          "976-0022",
          "976-0034",
          "979-2511",
          "976-0014",
          "976-0012",
          "976-0052",
          "976-0013",
          "976-0005",
          "976-0002",
          "979-2531",
          "976-0154",
          "976-0004",
          "976-0003",
          "976-0015",
          "979-2533",
          "976-0031",
          "979-2532",
          "976-0037",
          "976-0042",
          "979-2542",
          "976-0033",
          "976-0011",
          "976-0041",
          "979-2522",
          "976-0051",
          "976-0036",
          "976-0021",
          "976-0153",
          "976-0035",
          "976-0026",
          "976-0024",
          "976-0151",
          "979-2512",
          "976-0023",
          "964-0000",
          "964-0982",
          "964-0929",
          "964-0938",
          "964-0802",
          "964-0004",
          "964-0826",
          "964-0927",
          "964-0015",
          "964-0914",
          "964-0024",
          "964-0823",
          "964-0932",
          "964-0053",
          "964-0898",
          "964-0997",
          "964-0937",
          "964-0057",
          "964-0954",
          "964-0963",
          "964-0048",
          "964-0849",
          "964-0077",
          "964-0111",
          "964-0949",
          "964-0891",
          "964-0869",
          "964-0996",
          "964-0016",
          "964-0975",
          "964-0955",
          "969-1513",
          "964-0832",
          "964-0313",
          "964-0901",
          "964-0904",
          "964-0842",
          "964-0863",
          "964-0915",
          "964-0807",
          "964-0987",
          "964-0321",
          "969-1512",
          "964-0014",
          "964-0312",
          "964-0073",
          "964-0848",
          "964-0926",
          "964-0911",
          "964-0815",
          "964-0838",
          "964-0984",
          "964-0808",
          "964-0956",
          "964-0087",
          "964-0853",
          "964-0854",
          "964-0921",
          "964-0065",
          "964-0974",
          "964-0203",
          "964-0007",
          "964-0314",
          "964-0063",
          "964-0933",
          "964-0844",
          "964-0893",
          "964-0913",
          "964-0071",
          "964-0944",
          "964-0986",
          "964-0005",
          "964-0964",
          "964-0088",
          "964-0934",
          "964-0058",
          "964-0086",
          "964-0897",
          "964-0942",
          "964-0825",
          "969-1403",
          "964-0922",
          "964-0935",
          "969-1511",
          "964-0804",
          "964-0316",
          "964-0805",
          "964-0883",
          "964-0912",
          "964-0876",
          "964-0966",
          "964-0882",
          "964-0976",
          "964-0013",
          "964-0828",
          "964-0952",
          "964-0835",
          "964-0896",
          "964-0836",
          "964-0302",
          "964-0862",
          "964-0833",
          "964-0865",
          "964-0962",
          "964-0972",
          "964-0023",
          "964-0867",
          "964-0824",
          "964-0812",
          "964-0841",
          "964-0965",
          "964-0827",
          "964-0851",
          "964-0084",
          "964-0884",
          "964-0957",
          "964-0886",
          "964-0885",
          "964-0985",
          "964-0028",
          "964-0817",
          "964-0074",
          "964-0062",
          "964-0066",
          "964-0061",
          "964-0064",
          "964-0845",
          "964-0902",
          "964-0958",
          "964-0072",
          "964-0431",
          "964-0038",
          "964-0868",
          "964-0051",
          "964-0993",
          "964-0894",
          "969-1405",
          "964-0852",
          "964-0866",
          "964-0875",
          "964-0008",
          "964-0846",
          "964-0872",
          "964-0881",
          "964-0433",
          "964-0834",
          "964-0945",
          "964-0814",
          "964-0201",
          "964-0054",
          "964-0859",
          "964-0311",
          "964-0874",
          "964-0075",
          "964-0001",
          "964-0991",
          "964-0924",
          "964-0026",
          "964-0923",
          "964-0029",
          "964-0022",
          "964-0011",
          "964-0012",
          "964-0076",
          "964-0021",
          "964-0017",
          "964-0837",
          "964-0855",
          "964-0315",
          "964-0892",
          "964-0871",
          "964-0003",
          "964-0861",
          "964-0995",
          "964-0304",
          "964-0856",
          "964-0953",
          "964-0903",
          "964-0039",
          "964-0948",
          "964-0803",
          "964-0303",
          "964-0806",
          "964-0055",
          "964-0035",
          "964-0042",
          "964-0045",
          "964-0047",
          "964-0044",
          "964-0037",
          "964-0036",
          "964-0043",
          "964-0034",
          "964-0049",
          "964-0041",
          "964-0046",
          "964-0816",
          "964-0202",
          "964-0873",
          "964-0301",
          "964-0857",
          "964-0033",
          "964-0032",
          "964-0858",
          "964-0992",
          "964-0981",
          "964-0973",
          "964-0829",
          "964-0006",
          "964-0818",
          "964-0085",
          "964-0822",
          "964-0821",
          "964-0813",
          "964-0907",
          "964-0843",
          "964-0946",
          "964-0831",
          "964-0031",
          "964-0905",
          "964-0947",
          "964-0941",
          "964-0983",
          "964-0994",
          "964-0052",
          "964-0895",
          "964-0887",
          "964-0081",
          "964-0811",
          "964-0951",
          "964-0943",
          "964-0801",
          "964-0916",
          "964-0917",
          "964-0432",
          "964-0936",
          "964-0847",
          "964-0961",
          "964-0864",
          "964-0082",
          "964-0083",
          "964-0025",
          "964-0931",
          "964-0027",
          "964-0925",
          "969-1404",
          "964-0056",
          "964-0002",
          "969-1401",
          "964-0971",
          "969-1402",
          "964-0928",
          "964-0906",
          "963-4300",
          "963-4111",
          "963-4115",
          "963-4112",
          "963-4114",
          "963-4113",
          "963-3602",
          "963-3601",
          "963-3603",
          "963-4604",
          "963-4605",
          "963-4614",
          "963-4613",
          "963-4602",
          "963-4603",
          "963-4606",
          "963-4611",
          "963-4601",
          "963-4612",
          "963-4316",
          "963-4322",
          "963-4431",
          "963-4313",
          "963-4311",
          "963-4435",
          "963-4203",
          "963-4434",
          "963-4323",
          "963-4541",
          "963-4545",
          "963-4433",
          "963-4202",
          "963-4318",
          "963-4321",
          "963-4317",
          "963-4205",
          "963-4432",
          "963-4201",
          "963-4543",
          "963-4324",
          "963-4436",
          "963-4315",
          "963-4312",
          "963-4204",
          "963-4544",
          "963-4314",
          "963-4542",
          "963-4702",
          "963-4701",
          "975-0000",
          "979-2133",
          "979-2144",
          "979-2145",
          "979-2155",
          "979-2143",
          "979-2103",
          "979-2163",
          "979-2174",
          "979-2123",
          "979-2134",
          "979-2102",
          "979-2147",
          "979-2173",
          "979-2101",
          "979-2165",
          "979-2153",
          "979-2115",
          "979-2154",
          "979-2164",
          "979-2171",
          "979-2156",
          "979-2146",
          "979-2113",
          "979-2112",
          "979-2104",
          "979-2142",
          "979-2111",
          "979-2152",
          "979-2114",
          "979-2175",
          "979-2162",
          "979-2121",
          "979-2131",
          "979-2161",
          "979-2132",
          "979-2172",
          "979-2122",
          "979-2151",
          "979-2141",
          "979-2124",
          "979-2157",
          "979-2336",
          "979-2451",
          "979-2443",
          "979-2331",
          "979-2322",
          "979-2444",
          "979-2321",
          "979-2464",
          "979-2335",
          "979-2462",
          "979-2323",
          "979-2324",
          "979-2311",
          "979-2313",
          "979-2303",
          "979-2453",
          "979-2452",
          "979-2332",
          "979-2454",
          "979-2441",
          "979-2333",
          "979-2463",
          "979-2305",
          "979-2301",
          "979-2334",
          "979-2312",
          "979-2314",
          "979-2304",
          "979-2302",
          "979-2461",
          "979-2442",
          "975-0039",
          "975-0004",
          "975-0002",
          "975-0075",
          "975-0023",
          "975-0017",
          "975-0047",
          "975-0078",
          "975-0061",
          "975-0079",
          "975-0001",
          "975-0049",
          "975-0011",
          "975-0055",
          "975-0064",
          "975-0036",
          "975-0058",
          "975-0021",
          "975-0059",
          "975-0027",
          "975-0034",
          "975-0026",
          "975-0013",
          "975-0022",
          "975-0072",
          "975-0073",
          "975-0037",
          "975-0018",
          "975-0015",
          "975-0045",
          "975-0043",
          "975-0051",
          "975-0003",
          "975-0032",
          "975-0076",
          "975-0042",
          "975-0044",
          "975-0041",
          "975-0024",
          "975-0035",
          "975-0025",
          "975-0065",
          "975-0054",
          "975-0077",
          "975-0033",
          "975-0046",
          "975-0056",
          "975-0052",
          "975-0074",
          "975-0016",
          "975-0031",
          "975-0014",
          "975-0006",
          "975-0063",
          "975-0038",
          "975-0071",
          "975-0005",
          "975-0062",
          "975-0053",
          "975-0012",
          "975-0007",
          "975-0048",
          "975-0008",
          "975-0057",
          "960-0600",
          "960-0423",
          "960-0405",
          "960-0421",
          "960-0437",
          "960-0415",
          "960-0455",
          "960-0424",
          "960-0425",
          "960-0488",
          "960-0457",
          "960-0458",
          "960-0408",
          "960-0418",
          "960-0485",
          "960-0427",
          "960-0477",
          "960-0461",
          "960-0433",
          "960-0453",
          "960-0422",
          "960-0431",
          "960-0468",
          "960-0417",
          "960-0474",
          "960-0465",
          "960-0428",
          "960-0426",
          "960-0473",
          "960-0401",
          "960-0451",
          "960-0454",
          "960-0441",
          "960-0445",
          "960-0442",
          "960-0443",
          "960-0446",
          "960-0444",
          "960-0435",
          "960-0434",
          "960-0489",
          "960-0412",
          "960-0487",
          "960-0467",
          "960-0463",
          "960-0429",
          "960-0904",
          "960-0903",
          "960-0902",
          "960-0905",
          "960-0901",
          "960-0906",
          "960-0482",
          "960-0476",
          "960-0447",
          "960-0406",
          "960-0414",
          "960-0432",
          "960-0452",
          "960-0416",
          "960-0471",
          "960-0456",
          "960-0411",
          "960-0466",
          "960-0472",
          "960-0479",
          "960-0502",
          "960-0484",
          "960-0404",
          "960-0407",
          "960-0419",
          "960-0501",
          "960-0475",
          "960-0478",
          "960-0624",
          "960-0625",
          "960-0626",
          "960-0627",
          "960-0615",
          "960-0616",
          "960-0617",
          "960-0618",
          "960-0619",
          "960-0607",
          "960-0608",
          "960-0609",
          "960-0669",
          "960-0687",
          "960-0679",
          "960-0653",
          "960-0622",
          "960-0614",
          "960-0613",
          "960-0634",
          "960-0632",
          "960-0664",
          "960-0675",
          "960-0665",
          "960-0654",
          "960-0651",
          "960-0661",
          "960-0674",
          "960-0684",
          "960-0668",
          "960-0638",
          "960-0678",
          "960-0602",
          "960-0685",
          "960-0647",
          "960-0601",
          "960-0649",
          "960-0643",
          "960-0672",
          "960-0637",
          "960-0611",
          "960-0676",
          "960-0645",
          "960-0683",
          "960-0686",
          "960-0606",
          "960-0681",
          "960-0682",
          "960-0644",
          "960-0631",
          "960-0657",
          "960-0621",
          "960-0633",
          "960-0650",
          "960-0641",
          "960-0659",
          "960-0652",
          "960-0673",
          "960-0662",
          "960-0667",
          "960-0635",
          "960-0648",
          "960-0646",
          "960-0642",
          "960-0671",
          "960-0663",
          "960-0658",
          "960-0603",
          "960-0623",
          "960-0688",
          "960-0628",
          "960-0655",
          "960-0612",
          "960-0666",
          "960-0604",
          "960-0605",
          "960-0656",
          "960-0636",
          "960-0629",
          "960-0639",
          "960-0677",
          "960-0481",
          "960-0403",
          "960-0436",
          "960-0402",
          "960-0464",
          "960-0413",
          "960-0462",
          "960-0448",
          "960-0756",
          "960-0725",
          "960-0723",
          "960-0711",
          "960-0701",
          "960-0774",
          "960-0764",
          "960-0745",
          "960-0744",
          "960-0727",
          "960-0746",
          "960-0765",
          "960-0715",
          "960-0741",
          "960-0712",
          "960-0753",
          "960-0772",
          "960-0724",
          "960-0726",
          "960-0706",
          "960-0781",
          "960-0729",
          "960-0773",
          "960-0785",
          "960-0757",
          "960-0754",
          "960-0736",
          "960-0758",
          "960-0775",
          "960-0742",
          "960-0733",
          "960-0716",
          "960-0721",
          "960-0763",
          "960-0784",
          "960-0762",
          "960-0734",
          "960-0735",
          "960-0728",
          "960-0731",
          "960-0778",
          "960-0755",
          "960-0782",
          "960-0709",
          "960-0777",
          "960-0767",
          "960-0718",
          "960-0702",
          "960-0708",
          "960-0776",
          "960-0759",
          "960-0769",
          "960-0704",
          "960-0751",
          "960-0766",
          "960-0747",
          "960-0732",
          "960-0707",
          "960-0786",
          "960-0717",
          "960-0743",
          "960-0705",
          "960-0783",
          "960-0713",
          "960-0719",
          "960-0768",
          "960-0787",
          "960-0703",
          "960-0722",
          "960-0760",
          "960-0752",
          "960-0483",
          "960-0438",
          "960-0807",
          "960-0803",
          "960-0804",
          "960-0801",
          "960-0809",
          "960-0808",
          "960-0805",
          "960-0806",
          "960-0802",
          "960-0486",
          "969-1100",
          "969-1107",
          "969-1104",
          "969-1201",
          "969-1106",
          "969-1203",
          "969-1105",
          "969-1101",
          "969-1206",
          "969-1103",
          "969-1204",
          "969-1202",
          "969-1176",
          "969-1158",
          "969-1125",
          "969-1139",
          "969-1112",
          "969-1166",
          "969-1144",
          "969-1159",
          "969-1161",
          "969-1129",
          "969-1141",
          "969-1142",
          "969-1117",
          "969-1152",
          "969-1134",
          "969-1155",
          "969-1162",
          "969-1172",
          "969-1167",
          "969-1136",
          "969-1169",
          "969-1148",
          "969-1111",
          "969-1154",
          "969-1153",
          "969-1118",
          "969-1132",
          "969-1163",
          "969-1156",
          "969-1114",
          "969-1157",
          "969-1122",
          "969-1175",
          "969-1115",
          "969-1121",
          "969-1128",
          "969-1137",
          "969-1151",
          "969-1135",
          "969-1127",
          "969-1171",
          "969-1164",
          "969-1109",
          "969-1133",
          "969-1165",
          "969-1173",
          "969-1124",
          "969-1138",
          "969-1147",
          "969-1126",
          "969-1149",
          "969-1123",
          "969-1168",
          "969-1116",
          "969-1113",
          "969-1108",
          "969-1174",
          "969-1131",
          "969-1146",
          "969-1119",
          "969-1143",
          "969-1145",
          "969-1205",
          "969-1600",
          "969-1633",
          "969-1603",
          "969-1623",
          "969-1634",
          "969-1661",
          "969-1619",
          "969-1642",
          "969-1601",
          "969-1635",
          "969-1618",
          "969-1613",
          "969-1615",
          "969-1608",
          "969-1662",
          "969-1631",
          "969-1628",
          "969-1617",
          "969-1625",
          "969-1624",
          "969-1627",
          "969-1605",
          "969-1604",
          "969-1632",
          "969-1616",
          "969-1663",
          "969-1626",
          "969-1621",
          "969-1652",
          "969-1612",
          "969-1607",
          "969-1629",
          "969-1611",
          "969-1606",
          "969-1654",
          "969-1602",
          "969-1653",
          "969-1651",
          "969-1641",
          "969-1622",
          "969-1614",
          "969-1643",
          "969-1700",
          "969-1701",
          "969-1782",
          "969-1785",
          "969-1781",
          "969-1713",
          "969-1711",
          "969-1721",
          "969-1712",
          "969-1784",
          "969-1788",
          "969-1786",
          "969-1780",
          "969-1787",
          "969-1789",
          "969-1714",
          "969-1751",
          "969-1741",
          "969-1783",
          "969-1722",
          "969-1761",
          "969-1731",
          "969-1771",
          "960-1400",
          "960-1465",
          "960-1409",
          "960-1401",
          "960-1423",
          "960-1476",
          "960-1414",
          "960-1452",
          "960-1485",
          "960-1484",
          "960-1443",
          "960-1435",
          "960-1431",
          "960-1403",
          "960-1489",
          "960-1429",
          "960-1478",
          "960-1436",
          "960-1453",
          "960-1472",
          "960-1477",
          "960-1442",
          "960-1407",
          "960-1434",
          "960-1402",
          "960-1428",
          "960-1473",
          "960-1487",
          "960-1486",
          "960-1433",
          "960-1488",
          "960-1422",
          "960-1425",
          "960-1455",
          "960-1446",
          "960-1416",
          "960-1427",
          "960-1483",
          "960-1406",
          "960-1421",
          "960-1424",
          "960-1462",
          "960-1468",
          "960-1463",
          "960-1469",
          "960-1445",
          "960-1456",
          "960-1412",
          "960-1481",
          "960-1474",
          "960-1415",
          "960-1471",
          "960-1404",
          "960-1444",
          "960-1417",
          "960-1454",
          "960-1408",
          "960-1475",
          "960-1432",
          "960-1405",
          "960-1413",
          "960-1426",
          "960-1411",
          "960-1441",
          "960-1467",
          "960-1464",
          "960-1466",
          "960-1461",
          "960-1451",
          "960-1482",
          "960-1501",
          "969-1300",
          "969-1301",
          "964-0091",
          "969-1302",
          "969-0400",
          "969-0404",
          "969-0402",
          "969-0401",
          "969-0403",
          "962-0500",
          "962-0512",
          "962-0504",
          "962-0516",
          "962-0513",
          "962-0514",
          "962-0502",
          "962-0503",
          "962-0511",
          "962-0515",
          "962-0622",
          "962-0623",
          "962-0501",
          "962-0621",
          "969-5300",
          "969-5333",
          "969-5315",
          "969-5331",
          "969-5316",
          "969-5318",
          "969-5326",
          "969-5202",
          "969-5207",
          "969-5205",
          "969-5334",
          "969-5343",
          "969-5342",
          "969-5208",
          "969-5323",
          "969-5321",
          "969-5344",
          "969-5345",
          "969-5317",
          "969-5203",
          "969-5201",
          "969-5312",
          "969-5311",
          "969-5332",
          "969-5325",
          "969-5335",
          "969-5341",
          "969-5313",
          "969-5314",
          "969-5204",
          "969-5324",
          "969-5206",
          "969-5322",
          "967-0500",
          "967-0521",
          "967-0524",
          "967-0532",
          "967-0522",
          "967-0523",
          "967-0525",
          "967-0526",
          "967-0531",
          "967-0527",
          "967-0528",
          "968-0400",
          "968-0443",
          "968-0422",
          "968-0602",
          "968-0434",
          "968-0415",
          "968-0445",
          "968-0414",
          "968-0444",
          "968-0432",
          "968-0441",
          "968-0601",
          "968-0606",
          "968-0411",
          "968-0604",
          "968-0412",
          "968-0423",
          "968-0421",
          "968-0442",
          "968-0431",
          "968-0605",
          "968-0433",
          "968-0607",
          "968-0603",
          "968-0413",
          "967-0000",
          "967-0507",
          "967-0605",
          "967-0341",
          "967-0321",
          "967-0641",
          "967-0014",
          "967-0317",
          "967-0323",
          "967-0511",
          "967-0319",
          "967-0603",
          "967-0604",
          "967-0513",
          "967-0515",
          "967-0331",
          "967-0642",
          "967-0335",
          "967-0632",
          "967-0024",
          "967-0344",
          "967-0346",
          "967-0012",
          "967-0601",
          "967-0011",
          "967-0021",
          "967-0506",
          "967-0343",
          "967-0514",
          "967-0631",
          "967-0022",
          "967-0302",
          "967-0025",
          "967-0634",
          "967-0322",
          "967-0503",
          "967-0311",
          "967-0307",
          "967-0342",
          "967-0013",
          "967-0315",
          "967-0015",
          "967-0004",
          "967-0502",
          "967-0301",
          "967-0002",
          "967-0007",
          "967-0332",
          "967-0016",
          "967-0621",
          "967-0345",
          "967-0305",
          "967-0633",
          "967-0005",
          "967-0006",
          "967-0001",
          "967-0312",
          "967-0512",
          "967-0504",
          "967-0026",
          "967-0324",
          "967-0023",
          "967-0303",
          "967-0501",
          "967-0306",
          "967-0304",
          "967-0003",
          "967-0602",
          "967-0334",
          "967-0347",
          "967-0505",
          "967-0622",
          "967-0313",
          "967-0318",
          "967-0314",
          "967-0611",
          "967-0333",
          "967-0336",
          "966-0400",
          "966-0402",
          "966-0404",
          "966-0405",
          "966-0403",
          "966-0501",
          "966-0401",
          "969-2701",
          "969-4400",
          "969-4734",
          "969-4732",
          "969-4731",
          "969-4733",
          "969-4737",
          "969-4735",
          "969-4736",
          "969-4402",
          "969-4512",
          "969-4405",
          "969-4515",
          "969-4622",
          "969-4623",
          "969-4621",
          "969-4624",
          "969-4403",
          "969-4401",
          "969-4406",
          "969-4514",
          "969-4513",
          "969-4404",
          "969-4511",
          "969-3300",
          "969-3303",
          "969-3304",
          "969-3302",
          "969-3301",
          "969-3100",
          "969-3121",
          "969-3122",
          "969-3101",
          "969-3111",
          "969-3131",
          "969-3141",
          "969-3286",
          "969-3102",
          "969-3113",
          "969-3285",
          "969-3283",
          "969-3132",
          "969-2272",
          "969-3103",
          "969-2663",
          "969-2752",
          "969-3123",
          "969-3282",
          "969-2273",
          "969-3133",
          "969-3112",
          "969-2274",
          "969-2271",
          "969-3281",
          "969-3287",
          "969-2661",
          "969-3284",
          "969-2662",
          "969-2275",
          "969-2751",
          "969-3288",
          "969-6500",
          "969-6517",
          "969-6511",
          "969-6518",
          "969-6535",
          "969-6553",
          "969-6563",
          "969-6536",
          "969-6543",
          "969-6547",
          "969-6557",
          "969-6562",
          "969-6566",
          "969-6537",
          "969-6576",
          "969-6503",
          "969-6538",
          "969-6523",
          "969-6519",
          "969-6573",
          "969-6507",
          "969-6544",
          "969-6534",
          "969-6525",
          "969-6581",
          "969-6575",
          "969-6521",
          "969-6541",
          "969-6533",
          "969-6556",
          "969-6583",
          "969-6542",
          "969-6514",
          "969-6545",
          "969-6526",
          "969-6586",
          "969-6555",
          "969-6531",
          "969-6528",
          "969-6565",
          "969-6561",
          "969-6582",
          "969-6513",
          "969-6552",
          "969-6551",
          "969-6587",
          "969-6548",
          "969-6524",
          "969-6502",
          "969-6574",
          "969-6584",
          "969-6516",
          "969-6564",
          "969-6501",
          "969-6505",
          "969-6512",
          "969-6567",
          "969-6572",
          "969-6532",
          "969-6571",
          "969-6527",
          "969-6515",
          "969-6585",
          "969-6539",
          "969-6549",
          "969-6546",
          "969-6554",
          "969-6506",
          "969-6522",
          "969-6504",
          "969-3500",
          "969-3543",
          "969-3554",
          "969-3545",
          "969-3555",
          "969-3544",
          "969-3556",
          "969-3553",
          "969-3551",
          "969-3541",
          "969-3552",
          "969-3546",
          "969-3542",
          "969-7200",
          "969-7206",
          "969-7204",
          "969-7323",
          "969-7325",
          "969-7202",
          "969-7324",
          "969-7203",
          "969-7312",
          "969-7322",
          "969-7205",
          "969-7313",
          "969-7207",
          "969-7321",
          "969-7326",
          "969-7208",
          "969-7209",
          "969-7314",
          "969-7201",
          "969-7311",
          "969-7315",
          "969-7500",
          "969-7518",
          "969-7407",
          "969-7517",
          "969-7516",
          "969-7515",
          "969-7512",
          "969-7403",
          "969-7404",
          "969-7405",
          "969-7514",
          "969-7402",
          "969-7401",
          "969-7406",
          "969-7413",
          "969-7513",
          "969-7519",
          "969-7511",
          "968-0000",
          "968-0002",
          "968-0005",
          "968-0326",
          "968-0011",
          "968-0012",
          "968-0321",
          "968-0325",
          "968-0324",
          "968-0014",
          "968-0004",
          "968-0006",
          "968-0015",
          "968-0003",
          "968-0013",
          "968-0016",
          "968-0001",
          "968-0323",
          "968-0322",
          "968-0100",
          "968-0214",
          "968-0211",
          "968-0212",
          "968-0104",
          "968-0215",
          "968-0103",
          "968-0102",
          "968-0101",
          "968-0213",
          "969-6200",
          "969-6272",
          "969-6222",
          "969-6226",
          "969-6221",
          "969-6223",
          "969-6225",
          "969-6224",
          "969-6351",
          "969-6352",
          "969-6266",
          "969-6171",
          "969-6027",
          "969-6161",
          "969-6111",
          "969-6037",
          "969-6206",
          "969-6112",
          "969-6151",
          "969-6046",
          "969-6307",
          "969-6036",
          "969-6261",
          "969-6265",
          "969-6407",
          "969-6061",
          "969-6101",
          "969-6121",
          "969-6306",
          "969-6305",
          "969-6131",
          "969-6057",
          "969-6141",
          "969-6333",
          "969-6173",
          "969-6022",
          "969-6242",
          "969-6254",
          "969-6343",
          "969-6409",
          "969-6231",
          "969-6051",
          "969-6102",
          "969-6205",
          "969-6262",
          "969-6213",
          "969-6103",
          "969-6104",
          "969-6105",
          "969-6159",
          "969-6041",
          "969-6024",
          "969-6152",
          "969-6154",
          "969-6045",
          "969-6155",
          "969-6047",
          "969-6316",
          "969-6318",
          "969-6317",
          "969-6342",
          "969-6113",
          "969-6068",
          "969-6052",
          "969-6106",
          "969-6163",
          "969-6304",
          "969-6062",
          "969-6114",
          "969-6063",
          "969-6038",
          "969-6023",
          "969-6174",
          "969-6025",
          "969-6404",
          "969-6406",
          "969-6029",
          "969-6314",
          "969-6311",
          "969-6312",
          "969-6166",
          "969-6313",
          "969-6215",
          "969-6256",
          "969-6115",
          "969-6267",
          "969-6402",
          "969-6107",
          "969-6162",
          "969-6301",
          "969-6253",
          "969-6274",
          "969-6263",
          "969-6108",
          "969-6033",
          "969-6034",
          "969-6116",
          "969-6042",
          "969-6044",
          "969-6156",
          "969-6055",
          "969-6056",
          "969-6054",
          "969-6109",
          "969-6204",
          "969-6264",
          "969-6203",
          "969-6202",
          "969-6032",
          "969-6411",
          "969-6175",
          "969-6021",
          "969-6403",
          "969-6271",
          "969-6122",
          "969-6073",
          "969-6353",
          "969-6354",
          "969-6214",
          "969-6251",
          "969-6118",
          "969-6053",
          "969-6035",
          "969-6123",
          "969-6074",
          "969-6244",
          "969-6355",
          "969-6245",
          "969-6085",
          "969-6086",
          "969-6408",
          "969-6211",
          "969-6338",
          "969-6356",
          "969-6232",
          "969-6124",
          "969-6077",
          "969-6143",
          "969-6176",
          "969-6028",
          "969-6078",
          "969-6031",
          "969-6144",
          "969-6212",
          "969-6133",
          "969-6069",
          "969-6315",
          "969-6332",
          "969-6135",
          "969-6125",
          "969-6066",
          "969-6065",
          "969-6117",
          "969-6071",
          "969-6127",
          "969-6126",
          "969-6336",
          "969-6337",
          "969-6132",
          "969-6084",
          "969-6177",
          "969-6026",
          "969-6164",
          "969-6087",
          "969-6129",
          "969-6075",
          "969-6076",
          "969-6172",
          "969-6331",
          "969-6334",
          "969-6252",
          "969-6255",
          "969-6158",
          "969-6043",
          "969-6058",
          "969-6128",
          "969-6072",
          "969-6323",
          "969-6324",
          "969-6321",
          "969-6322",
          "969-6134",
          "969-6081",
          "969-6082",
          "969-6079",
          "969-6083",
          "969-6243",
          "969-6325",
          "969-6327",
          "969-6326",
          "969-6207",
          "969-6059",
          "969-6064",
          "969-6142",
          "969-6335",
          "969-6157",
          "969-6273",
          "969-6201",
          "969-6268",
          "969-6119",
          "969-6067",
          "969-6303",
          "969-6165",
          "969-6302",
          "969-6145",
          "969-6328",
          "969-6146",
          "969-6341",
          "969-6241",
          "969-6405",
          "969-6401",
          "961-8043",
          "961-8044",
          "961-8047",
          "961-8061",
          "961-8011",
          "961-8091",
          "961-8051",
          "961-8056",
          "961-8081",
          "961-8052",
          "961-8055",
          "961-8041",
          "961-8042",
          "961-8021",
          "961-8001",
          "961-8053",
          "961-8054",
          "961-8071",
          "961-8046",
          "961-8045",
          "961-8031",
          "969-0100",
          "969-0101",
          "969-0104",
          "969-0103",
          "969-0106",
          "969-0102",
          "969-0105",
          "961-0100",
          "961-0105",
          "961-0103",
          "961-0102",
          "961-0106",
          "961-0101",
          "961-0104",
          "969-0200",
          "969-0206",
          "969-0272",
          "969-0236",
          "969-0287",
          "969-0238",
          "969-0224",
          "969-0201",
          "969-0252",
          "969-0257",
          "969-0246",
          "969-0251",
          "969-0203",
          "969-0211",
          "969-0288",
          "969-0205",
          "969-0271",
          "969-0281",
          "969-0258",
          "969-0242",
          "969-0266",
          "969-0241",
          "969-0202",
          "969-0267",
          "969-0247",
          "969-0204",
          "969-0212",
          "969-0284",
          "969-0227",
          "969-0255",
          "969-0248",
          "969-0243",
          "969-0264",
          "969-0265",
          "969-0221",
          "969-0231",
          "969-0256",
          "969-0226",
          "969-0263",
          "969-0245",
          "969-0222",
          "969-0285",
          "969-0233",
          "969-0225",
          "969-0244",
          "969-0223",
          "969-0254",
          "969-0237",
          "969-0282",
          "969-0232",
          "969-0234",
          "969-0268",
          "969-0262",
          "969-0235",
          "969-0283",
          "969-0253",
          "969-0213",
          "969-0261",
          "969-0286",
          "963-6100",
          "963-6113",
          "963-6111",
          "963-6147",
          "963-6114",
          "963-6145",
          "963-5662",
          "963-6106",
          "963-5681",
          "963-5685",
          "963-6105",
          "963-6152",
          "963-6144",
          "963-6103",
          "963-5682",
          "963-5683",
          "963-6153",
          "963-6123",
          "963-6131",
          "963-6112",
          "963-5664",
          "963-6101",
          "963-5671",
          "963-6102",
          "963-6146",
          "963-6141",
          "963-5684",
          "963-5663",
          "963-6122",
          "963-6121",
          "963-6104",
          "963-6115",
          "963-6143",
          "963-6151",
          "963-5672",
          "963-6142",
          "963-5661",
          "963-5100",
          "963-5322",
          "963-5114",
          "963-5119",
          "963-5111",
          "963-5115",
          "963-5116",
          "963-5202",
          "963-5113",
          "963-5321",
          "963-5203",
          "963-5201",
          "963-5118",
          "963-5112",
          "963-5323",
          "963-5117",
          "963-5400",
          "963-5342",
          "963-5537",
          "963-5343",
          "963-5532",
          "963-5522",
          "963-5411",
          "963-5406",
          "963-5536",
          "963-5534",
          "963-5341",
          "963-5404",
          "963-5531",
          "963-5539",
          "963-5402",
          "963-5403",
          "963-5538",
          "963-5521",
          "963-5407",
          "963-5405",
          "963-5401",
          "963-5408",
          "963-5344",
          "963-5535",
          "963-5533",
          "963-8400",
          "963-8404",
          "963-8401",
          "963-8403",
          "963-8407",
          "963-8402",
          "963-8406",
          "963-8408",
          "963-5505",
          "963-8405",
          "963-7800",
          "963-7826",
          "963-7864",
          "963-7884",
          "963-7827",
          "963-7833",
          "963-7867",
          "963-7813",
          "963-7849",
          "963-7841",
          "963-7823",
          "963-7872",
          "963-7815",
          "963-7881",
          "963-7853",
          "963-7848",
          "963-7807",
          "963-7862",
          "963-7844",
          "963-7802",
          "963-7811",
          "963-7835",
          "963-7834",
          "963-7876",
          "963-7847",
          "963-7842",
          "963-7804",
          "963-7825",
          "963-7836",
          "963-7818",
          "963-7882",
          "963-7858",
          "963-7828",
          "963-7856",
          "963-7851",
          "963-7852",
          "963-7808",
          "963-7866",
          "963-7874",
          "963-7845",
          "963-7817",
          "963-7857",
          "963-7873",
          "963-7803",
          "963-7837",
          "963-7846",
          "963-7885",
          "963-7855",
          "963-7824",
          "963-7821",
          "963-7831",
          "963-7871",
          "963-7838",
          "963-7865",
          "963-7854",
          "963-7816",
          "963-7859",
          "963-7812",
          "963-7883",
          "963-7832",
          "963-7806",
          "963-7843",
          "963-7805",
          "963-7875",
          "963-7822",
          "963-7861",
          "963-7814",
          "963-7801",
          "963-7886",
          "963-7863",
          "963-6300",
          "963-6312",
          "963-6313",
          "963-6311",
          "963-6304",
          "963-6316",
          "963-6315",
          "963-6314",
          "963-6302",
          "963-6305",
          "963-6306",
          "963-6303",
          "963-6301",
          "963-8100",
          "963-8114",
          "963-8202",
          "963-8112",
          "963-8203",
          "963-8113",
          "963-8206",
          "963-8207",
          "963-8204",
          "963-8115",
          "963-8205",
          "963-8116",
          "963-8111",
          "963-8201",
          "963-6200",
          "963-6204",
          "963-6214",
          "963-6206",
          "963-6207",
          "963-6202",
          "963-6216",
          "963-6208",
          "963-6205",
          "963-6213",
          "963-6215",
          "963-6211",
          "963-6218",
          "963-6201",
          "963-6212",
          "963-6217",
          "963-6203",
          "963-8300",
          "963-8303",
          "963-8307",
          "963-8308",
          "963-8305",
          "963-8306",
          "963-8304",
          "963-8302",
          "963-8301",
          "963-7700",
          "963-7702",
          "963-7753",
          "963-7745",
          "963-7765",
          "963-7749",
          "963-7757",
          "963-7754",
          "963-7752",
          "963-7706",
          "963-7759",
          "963-7762",
          "963-7772",
          "963-7719",
          "963-7769",
          "963-7741",
          "963-7732",
          "963-7747",
          "963-7781",
          "963-7751",
          "963-7764",
          "963-7717",
          "963-7712",
          "963-7704",
          "963-7708",
          "963-7758",
          "963-7709",
          "963-7767",
          "963-7723",
          "963-7711",
          "963-7701",
          "963-7755",
          "963-7761",
          "963-7713",
          "963-7768",
          "963-7731",
          "963-7703",
          "963-7743",
          "963-7707",
          "963-7725",
          "963-7714",
          "963-7763",
          "963-7742",
          "963-7705",
          "963-7782",
          "963-7766",
          "963-7786",
          "963-7722",
          "963-7724",
          "963-7726",
          "963-7716",
          "963-7744",
          "963-7746",
          "963-7721",
          "963-7771",
          "963-7715",
          "963-7773",
          "963-7785",
          "963-7783",
          "963-7756",
          "963-7748",
          "963-7733",
          "963-7718",
          "963-7784",
          "963-3400",
          "963-3521",
          "963-3524",
          "963-3522",
          "963-3403",
          "963-3401",
          "963-3523",
          "963-3316",
          "963-3405",
          "963-3406",
          "963-3314",
          "963-3404",
          "963-3312",
          "963-3313",
          "963-3402",
          "963-3311",
          "963-3525",
          "963-3315",
          "979-0400",
          "979-0404",
          "979-0406",
          "979-0401",
          "979-0407",
          "979-0403",
          "979-0402",
          "979-0408",
          "979-0405",
          "979-0600",
          "979-0603",
          "979-0605",
          "979-0515",
          "979-0606",
          "979-0604",
          "979-0514",
          "979-0602",
          "979-0601",
          "979-0511",
          "979-0513",
          "979-0512",
          "979-1100",
          "979-1171",
          "979-1101",
          "979-1131",
          "979-1141",
          "979-0622",
          "979-1122",
          "979-1111",
          "979-1162",
          "979-1132",
          "979-1112",
          "979-1121",
          "979-1151",
          "979-1152",
          "979-1161",
          "979-1200",
          "979-1201",
          "979-1202",
          "979-1300",
          "979-1306",
          "979-1301",
          "979-1304",
          "979-1305",
          "979-1303",
          "979-1302",
          "979-1308",
          "979-1307",
          "979-1400",
          "979-1433",
          "979-1442",
          "979-1463",
          "979-1411",
          "979-1451",
          "979-1441",
          "979-1472",
          "979-1453",
          "979-1462",
          "979-1401",
          "979-1402",
          "979-1471",
          "979-1412",
          "979-1421",
          "979-1452",
          "979-1432",
          "979-1422",
          "979-1423",
          "979-1461",
          "979-1431",
          "979-1500",
          "979-1751",
          "979-1535",
          "979-1522",
          "979-1526",
          "979-1544",
          "979-1543",
          "979-1545",
          "979-1536",
          "979-1505",
          "979-1531",
          "979-1753",
          "979-1512",
          "979-1513",
          "979-1521",
          "979-1533",
          "979-1504",
          "979-1756",
          "979-1542",
          "979-1525",
          "979-1541",
          "979-1501",
          "979-1511",
          "979-1757",
          "979-1523",
          "979-1503",
          "979-1755",
          "979-1752",
          "979-1532",
          "979-1502",
          "979-1754",
          "979-1706",
          "979-1506",
          "979-1524",
          "979-1534",
          "979-1600",
          "979-1602",
          "979-1601",
          "979-1604",
          "979-1603",
          "979-2700",
          "979-2705",
          "979-2709",
          "979-2704",
          "979-2703",
          "979-2611",
          "979-2706",
          "979-2711",
          "979-2708",
          "979-2707",
          "979-2702",
          "979-2701",
          "960-1600",
          "960-1812",
          "960-1721",
          "960-1803",
          "960-1633",
          "960-1814",
          "960-1801",
          "960-1811",
          "960-1815",
          "960-1635",
          "960-1804",
          "960-1632",
          "960-1723",
          "960-1634",
          "960-1722",
          "960-1802",
          "960-1636",
          "960-1631",
          "960-1813",
          "960-1724",
          "310-0000",
          "310-0004",
          "319-0314",
          "311-4141",
          "311-1122",
          "310-0822",
          "310-0046",
          "310-0831",
          "310-0054",
          "311-4165",
          "319-0304",
          "311-4155",
          "311-4206",
          "310-0905",
          "310-0904",
          "310-0026",
          "311-4202",
          "319-0311",
          "319-0317",
          "319-0315",
          "311-1115",
          "319-0312",
          "311-4143",
          "311-1125",
          "310-0062",
          "319-0307",
          "311-4163",
          "310-0852",
          "311-4162",
          "310-0066",
          "310-0001",
          "311-4203",
          "310-0041",
          "311-4154",
          "311-1112",
          "310-0814",
          "311-4152",
          "311-4153",
          "310-0061",
          "311-1133",
          "319-0303",
          "310-0842",
          "311-1111",
          "319-0323",
          "310-0063",
          "319-0325",
          "310-0914",
          "319-0324",
          "310-0816",
          "310-0064",
          "310-0841",
          "310-0802",
          "310-0801",
          "310-0011",
          "311-1114",
          "310-0826",
          "311-1121",
          "311-1123",
          "311-1131",
          "311-4205",
          "319-0322",
          "310-0023",
          "310-0042",
          "310-0012",
          "310-0803",
          "310-0804",
          "310-0036",
          "310-0045",
          "310-0005",
          "310-0053",
          "319-0306",
          "310-0844",
          "310-0851",
          "310-0031",
          "319-0321",
          "319-0301",
          "310-0901",
          "311-4204",
          "310-0051",
          "310-0805",
          "319-0313",
          "310-0025",
          "310-0846",
          "311-1136",
          "311-1132",
          "310-0033",
          "310-0821",
          "310-0002",
          "319-0305",
          "311-4146",
          "311-4207",
          "310-0824",
          "310-0044",
          "310-0067",
          "310-0068",
          "310-0022",
          "310-0055",
          "310-0065",
          "310-0812",
          "310-0813",
          "311-4142",
          "310-0823",
          "310-0811",
          "310-0818",
          "310-0035",
          "310-0024",
          "311-4151",
          "311-4144",
          "310-0853",
          "311-1113",
          "311-4201",
          "311-4208",
          "310-0833",
          "311-4145",
          "310-0056",
          "310-0903",
          "310-0815",
          "311-4161",
          "310-0043",
          "310-0052",
          "310-0912",
          "310-0913",
          "310-0034",
          "310-0021",
          "319-0302",
          "310-0834",
          "310-0015",
          "319-0316",
          "310-0911",
          "310-0843",
          "310-0835",
          "310-0032",
          "310-0836",
          "311-1124",
          "310-0825",
          "311-4164",
          "310-0003",
          "310-0817",
          "311-1134",
          "310-0845",
          "310-0832",
          "310-0827",
          "310-0847",
          "311-1135",
          "310-0013",
          "310-0014",
          "310-0902",
          "317-0000",
          "317-0075",
          "319-1415",
          "317-0074",
          "316-0036",
          "319-1418",
          "319-1225",
          "311-0402",
          "317-0076",
          "316-0012",
          "316-0022",
          "319-1221",
          "319-1234",
          "319-1413",
          "319-1412",
          "317-0071",
          "316-0015",
          "319-1417",
          "317-0064",
          "319-1411",
          "316-0005",
          "319-1233",
          "319-1222",
          "316-0035",
          "317-0073",
          "316-0002",
          "319-1232",
          "311-0404",
          "319-1301",
          "319-1302",
          "319-1306",
          "319-1308",
          "319-1305",
          "319-1304",
          "319-1303",
          "319-1307",
          "317-0077",
          "317-0056",
          "316-0006",
          "317-0065",
          "316-0001",
          "316-0021",
          "317-0066",
          "316-0003",
          "319-1416",
          "316-0013",
          "319-1231",
          "316-0033",
          "311-0401",
          "316-0007",
          "317-0053",
          "317-0051",
          "316-0031",
          "316-0032",
          "316-0011",
          "316-0023",
          "316-0014",
          "311-0403",
          "316-0004",
          "317-0061",
          "317-0052",
          "316-0034",
          "319-1414",
          "317-0062",
          "317-0072",
          "316-0026",
          "316-0024",
          "319-1223",
          "319-1224",
          "317-0055",
          "317-0054",
          "319-1235",
          "316-0025",
          "317-0063",
          "300-0000",
          "300-0818",
          "300-0873",
          "300-0871",
          "300-0874",
          "300-0877",
          "300-0035",
          "300-0002",
          "300-0802",
          "300-0047",
          "300-0007",
          "300-0001",
          "300-0835",
          "300-4103",
          "300-0028",
          "300-0044",
          "300-4111",
          "300-0038",
          "300-0872",
          "300-0023",
          "300-4106",
          "300-0844",
          "300-0845",
          "300-4108",
          "300-0846",
          "300-0847",
          "300-0008",
          "300-0804",
          "300-0825",
          "300-4114",
          "300-0811",
          "300-0819",
          "300-0836",
          "300-0033",
          "300-0011",
          "300-0013",
          "300-0012",
          "300-0876",
          "300-0015",
          "300-0026",
          "300-0056",
          "300-0027",
          "300-0831",
          "300-0834",
          "300-0833",
          "300-0814",
          "300-0032",
          "300-0823",
          "300-0826",
          "300-0004",
          "300-0832",
          "300-0037",
          "300-0803",
          "300-4104",
          "300-0805",
          "300-4113",
          "300-0812",
          "300-0042",
          "300-0022",
          "300-0021",
          "300-0046",
          "300-4117",
          "300-0839",
          "300-0041",
          "300-4118",
          "300-0048",
          "300-0049",
          "300-4105",
          "300-0024",
          "300-0824",
          "300-0043",
          "300-0062",
          "300-0025",
          "300-0031",
          "300-4107",
          "300-0055",
          "300-0841",
          "300-0875",
          "300-4101",
          "300-0016",
          "300-0815",
          "300-0009",
          "300-0005",
          "300-0849",
          "300-0850",
          "300-0843",
          "300-0817",
          "300-0810",
          "300-0816",
          "300-0061",
          "300-0014",
          "300-0068",
          "300-0848",
          "300-0842",
          "300-0054",
          "300-0821",
          "300-0822",
          "300-0067",
          "300-0006",
          "300-0069",
          "300-0052",
          "300-0064",
          "300-0065",
          "300-0813",
          "300-4115",
          "300-4116",
          "300-0045",
          "300-4102",
          "300-0051",
          "300-0053",
          "300-0838",
          "300-0837",
          "300-0034",
          "300-0066",
          "300-0003",
          "300-4112",
          "300-0801",
          "300-0036",
          "300-0063",
          "306-0000",
          "306-0012",
          "306-0044",
          "306-0224",
          "306-0225",
          "306-0202",
          "306-0105",
          "306-0236",
          "306-0032",
          "306-0052",
          "306-0111",
          "306-0206",
          "306-0101",
          "306-0226",
          "306-0104",
          "306-0211",
          "306-0223",
          "306-0201",
          "306-0128",
          "306-0234",
          "306-0122",
          "306-0213",
          "306-0005",
          "306-0106",
          "306-0115",
          "306-0212",
          "306-0055",
          "306-0041",
          "306-0214",
          "306-0016",
          "306-0231",
          "306-0123",
          "306-0045",
          "306-0121",
          "306-0221",
          "306-0024",
          "306-0056",
          "306-0036",
          "306-0042",
          "306-0001",
          "306-0204",
          "306-0127",
          "306-0235",
          "306-0014",
          "306-0222",
          "306-0116",
          "306-0205",
          "306-0047",
          "306-0051",
          "306-0033",
          "306-0103",
          "306-0007",
          "306-0043",
          "306-0053",
          "306-0054",
          "306-0110",
          "306-0233",
          "306-0037",
          "306-0038",
          "306-0109",
          "306-0125",
          "306-0035",
          "306-0034",
          "306-0026",
          "306-0025",
          "306-0011",
          "306-0232",
          "306-0013",
          "306-0107",
          "306-0124",
          "306-0112",
          "306-0006",
          "306-0023",
          "306-0216",
          "306-0046",
          "306-0021",
          "306-0215",
          "306-0002",
          "306-0003",
          "306-0015",
          "306-0108",
          "306-0031",
          "306-0126",
          "306-0113",
          "306-0203",
          "306-0114",
          "306-0022",
          "306-0004",
          "315-0000",
          "315-0148",
          "315-0038",
          "315-0021",
          "315-0030",
          "315-0001",
          "315-0046",
          "315-0025",
          "315-0047",
          "315-0162",
          "315-0115",
          "315-0157",
          "315-0009",
          "315-0102",
          "315-0105",
          "315-0101",
          "315-0036",
          "315-0165",
          "315-0144",
          "315-0155",
          "315-0104",
          "315-0166",
          "315-0015",
          "315-0116",
          "315-0002",
          "315-0004",
          "315-0113",
          "315-0136",
          "315-0137",
          "315-0005",
          "315-0154",
          "315-0138",
          "315-0135",
          "315-0114",
          "315-0134",
          "315-0111",
          "315-0044",
          "315-0012",
          "315-0163",
          "315-0010",
          "315-0032",
          "315-0014",
          "315-0161",
          "315-0164",
          "315-0019",
          "315-0117",
          "315-0143",
          "315-0124",
          "315-0153",
          "315-0131",
          "315-0011",
          "315-0146",
          "315-0151",
          "315-0027",
          "315-0026",
          "315-0016",
          "315-0007",
          "315-0045",
          "315-0041",
          "315-0141",
          "315-0147",
          "315-0033",
          "315-0043",
          "315-0103",
          "315-0006",
          "315-0022",
          "315-0029",
          "315-0132",
          "315-0118",
          "315-0024",
          "315-0042",
          "315-0133",
          "315-0028",
          "315-0037",
          "315-0031",
          "315-0034",
          "315-0122",
          "315-0023",
          "315-0013",
          "315-0145",
          "315-0112",
          "315-0152",
          "315-0121",
          "315-0035",
          "315-0048",
          "315-0123",
          "315-0008",
          "315-0125",
          "315-0003",
          "315-0142",
          "315-0156",
          "315-0167",
          "315-0018",
          "315-0017",
          "307-0000",
          "307-0028",
          "307-0045",
          "307-0041",
          "307-0042",
          "307-0031",
          "307-0055",
          "307-0002",
          "307-0007",
          "307-0027",
          "307-0015",
          "307-0021",
          "307-0005",
          "307-0012",
          "307-0051",
          "307-0006",
          "307-0011",
          "307-0008",
          "307-0023",
          "307-0038",
          "307-0054",
          "307-0034",
          "307-0016",
          "307-0053",
          "307-0029",
          "307-0035",
          "307-0043",
          "307-0044",
          "307-0052",
          "307-0013",
          "307-0026",
          "307-0025",
          "307-0014",
          "307-0037",
          "307-0003",
          "307-0032",
          "307-0036",
          "307-0024",
          "307-0004",
          "307-0022",
          "307-0033",
          "307-0001",
          "307-0046",
          "307-0017",
          "301-0000",
          "301-0821",
          "301-0838",
          "301-0857",
          "301-0801",
          "301-0045",
          "301-0046",
          "301-0805",
          "301-0851",
          "301-0025",
          "301-0856",
          "301-0006",
          "301-0817",
          "301-0012",
          "301-0048",
          "301-0825",
          "301-0005",
          "301-0021",
          "301-0001",
          "301-0802",
          "301-0822",
          "301-0852",
          "301-0044",
          "301-0834",
          "301-0034",
          "301-0018",
          "301-0826",
          "301-0032",
          "301-0033",
          "301-0812",
          "301-0824",
          "301-0847",
          "301-0031",
          "301-0841",
          "301-0833",
          "301-0813",
          "301-0815",
          "301-0014",
          "301-0823",
          "301-0816",
          "301-0814",
          "301-0026",
          "301-0839",
          "301-0835",
          "301-0836",
          "301-0024",
          "301-0854",
          "301-0002",
          "301-0016",
          "301-0015",
          "301-0804",
          "301-0042",
          "301-0845",
          "301-0004",
          "301-0007",
          "301-0803",
          "301-0837",
          "301-0023",
          "301-0843",
          "301-0806",
          "301-0035",
          "301-0017",
          "301-0003",
          "301-0844",
          "301-0855",
          "301-0846",
          "301-0853",
          "301-0043",
          "301-0013",
          "301-0832",
          "301-0022",
          "301-0047",
          "301-0811",
          "301-0842",
          "301-0831",
          "301-0011",
          "301-0041",
          "304-0000",
          "304-0074",
          "304-0803",
          "304-0057",
          "304-0053",
          "304-0002",
          "304-0004",
          "304-0025",
          "304-0023",
          "304-0801",
          "304-0804",
          "304-0051",
          "304-0063",
          "304-0016",
          "304-0819",
          "304-0050",
          "304-0048",
          "304-0805",
          "304-0021",
          "304-0818",
          "304-0073",
          "304-0802",
          "304-0007",
          "304-0823",
          "304-0034",
          "304-0024",
          "304-0055",
          "304-0013",
          "304-0071",
          "304-0006",
          "304-0072",
          "304-0815",
          "304-0028",
          "304-0811",
          "304-0015",
          "304-0066",
          "304-0067",
          "304-0061",
          "304-0068",
          "304-0062",
          "304-0011",
          "304-0003",
          "304-0814",
          "304-0022",
          "304-0031",
          "304-0812",
          "304-0069",
          "304-0017",
          "304-0054",
          "304-0014",
          "304-0056",
          "304-0049",
          "304-0052",
          "304-0817",
          "304-0816",
          "304-0005",
          "304-0032",
          "304-0047",
          "304-0046",
          "304-0001",
          "304-0018",
          "304-0026",
          "304-0027",
          "304-0042",
          "304-0041",
          "304-0821",
          "304-0033",
          "304-0065",
          "304-0813",
          "304-0076",
          "304-0806",
          "304-0822",
          "304-0075",
          "304-0824",
          "304-0064",
          "304-0044",
          "304-0043",
          "304-0045",
          "304-0035",
          "304-0012",
          "303-0000",
          "303-0002",
          "303-0011",
          "303-0016",
          "300-2525",
          "303-0043",
          "303-0046",
          "303-0012",
          "300-2727",
          "300-2745",
          "303-0045",
          "300-2526",
          "300-2521",
          "300-2512",
          "300-2743",
          "300-2504",
          "300-2703",
          "300-2503",
          "300-2722",
          "300-2723",
          "300-2734",
          "300-2746",
          "300-2732",
          "300-2741",
          "303-0006",
          "300-2524",
          "303-0042",
          "300-2747",
          "300-2523",
          "300-2735",
          "300-2721",
          "303-0018",
          "300-2502",
          "300-2706",
          "303-0044",
          "300-2744",
          "300-2713",
          "300-2716",
          "300-2704",
          "303-0015",
          "300-2717",
          "303-0041",
          "300-2705",
          "300-2505",
          "300-2726",
          "303-0001",
          "300-2511",
          "300-2513",
          "300-2748",
          "300-2733",
          "300-2702",
          "303-0014",
          "300-2501",
          "300-2724",
          "300-2731",
          "300-2725",
          "300-2714",
          "303-0017",
          "300-2712",
          "300-2736",
          "300-2507",
          "300-2506",
          "303-0025",
          "303-0032",
          "303-0033",
          "303-0024",
          "303-0021",
          "303-0023",
          "303-0034",
          "303-0003",
          "303-0022",
          "303-0026",
          "303-0004",
          "303-0005",
          "303-0031",
          "303-0013",
          "300-2742",
          "300-2707",
          "300-2711",
          "300-2715",
          "300-2522",
          "300-2701",
          "313-0000",
          "313-0102",
          "313-0121",
          "313-0132",
          "313-0007",
          "313-0045",
          "313-0042",
          "313-0041",
          "313-0112",
          "313-0037",
          "313-0063",
          "313-0116",
          "313-0125",
          "311-0508",
          "313-0124",
          "311-0505",
          "313-0021",
          "313-0031",
          "313-0038",
          "313-0135",
          "313-0036",
          "313-0033",
          "311-0506",
          "313-0035",
          "313-0016",
          "313-0001",
          "313-0046",
          "313-0353",
          "313-0034",
          "313-0104",
          "311-0509",
          "313-0101",
          "313-0023",
          "311-0301",
          "313-0015",
          "313-0014",
          "313-0126",
          "313-0221",
          "313-0123",
          "313-0351",
          "311-0507",
          "311-0503",
          "313-0064",
          "311-0504",
          "313-0005",
          "311-0501",
          "311-0325",
          "313-0032",
          "313-0012",
          "313-0047",
          "313-0002",
          "313-0044",
          "313-0352",
          "313-0106",
          "313-0103",
          "311-0322",
          "311-0324",
          "313-0003",
          "313-0111",
          "313-0113",
          "313-0024",
          "313-0115",
          "313-0225",
          "313-0122",
          "313-0026",
          "311-0323",
          "313-0049",
          "313-0224",
          "311-0502",
          "313-0061",
          "313-0212",
          "313-0105",
          "313-0134",
          "313-0056",
          "313-0055",
          "313-0054",
          "311-0314",
          "311-0313",
          "311-0312",
          "313-0215",
          "313-0011",
          "313-0027",
          "313-0025",
          "313-0131",
          "313-0062",
          "313-0004",
          "311-0321",
          "313-0051",
          "313-0052",
          "313-0053",
          "313-0211",
          "313-0048",
          "313-0008",
          "313-0213",
          "311-0311",
          "313-0133",
          "313-0222",
          "313-0022",
          "313-0114",
          "313-0117",
          "313-0006",
          "313-0043",
          "313-0013",
          "313-0214",
          "313-0223",
          "318-0000",
          "318-0001",
          "318-0024",
          "318-0021",
          "318-0012",
          "318-0022",
          "318-0103",
          "318-0031",
          "318-0105",
          "318-0004",
          "318-0023",
          "318-0106",
          "318-0003",
          "318-0002",
          "318-0034",
          "318-0013",
          "318-0104",
          "318-0014",
          "318-0011",
          "318-0025",
          "318-0005",
          "318-0033",
          "318-0032",
          "318-0101",
          "318-0102",
          "319-1500",
          "319-1541",
          "319-1547",
          "319-1546",
          "319-1544",
          "319-1545",
          "319-1543",
          "319-1542",
          "319-1702",
          "319-1703",
          "319-1704",
          "319-1714",
          "319-1715",
          "319-1712",
          "319-1711",
          "319-1713",
          "319-1727",
          "319-1726",
          "319-1721",
          "319-1723",
          "319-1724",
          "319-1722",
          "319-1725",
          "319-1552",
          "319-1554",
          "319-1558",
          "319-1555",
          "319-1559",
          "319-1553",
          "319-1551",
          "319-1556",
          "319-1557",
          "319-1538",
          "319-1535",
          "319-1532",
          "319-1533",
          "319-1534",
          "319-1537",
          "319-1536",
          "319-1531",
          "319-1701",
          "309-1600",
          "309-1616",
          "319-0206",
          "309-1717",
          "309-1632",
          "309-1605",
          "309-1602",
          "309-1613",
          "309-1607",
          "319-0209",
          "319-0211",
          "319-0208",
          "309-1635",
          "309-1636",
          "309-1724",
          "309-1738",
          "309-1601",
          "309-1604",
          "319-0205",
          "309-1701",
          "309-1611",
          "309-1713",
          "309-1637",
          "309-1615",
          "309-1731",
          "309-1623",
          "319-0201",
          "309-1624",
          "309-1625",
          "309-1703",
          "309-1706",
          "309-1702",
          "309-1626",
          "309-1733",
          "309-1726",
          "319-0202",
          "309-1716",
          "309-1722",
          "309-1737",
          "309-1621",
          "309-1614",
          "309-1735",
          "309-1732",
          "309-1712",
          "309-1711",
          "309-1714",
          "309-1631",
          "319-0204",
          "309-1721",
          "309-1705",
          "309-1606",
          "309-1612",
          "319-0207",
          "309-1603",
          "309-1634",
          "309-1725",
          "309-1734",
          "309-1622",
          "309-1704",
          "309-1633",
          "309-1736",
          "309-1723",
          "309-1715",
          "319-0203",
          "302-0000",
          "302-0006",
          "302-0037",
          "302-0026",
          "302-0011",
          "302-0015",
          "302-0012",
          "300-1523",
          "302-0003",
          "300-1503",
          "300-1546",
          "300-1521",
          "302-0001",
          "302-0036",
          "300-1542",
          "300-1513",
          "300-1506",
          "302-0035",
          "300-1504",
          "300-1524",
          "300-1511",
          "302-0017",
          "300-1537",
          "300-1539",
          "300-1536",
          "300-1531",
          "302-0027",
          "302-0033",
          "300-1525",
          "300-1544",
          "300-1508",
          "300-1534",
          "300-1535",
          "300-1505",
          "302-0038",
          "300-1502",
          "302-0031",
          "302-0024",
          "302-0013",
          "300-1522",
          "302-0014",
          "302-0002",
          "302-0021",
          "302-0034",
          "302-0004",
          "300-1543",
          "300-1533",
          "302-0016",
          "302-0025",
          "302-0032",
          "300-1541",
          "302-0023",
          "300-1507",
          "302-0005",
          "300-1515",
          "300-1512",
          "300-1516",
          "300-1501",
          "302-0022",
          "300-1514",
          "300-1532",
          "302-0039",
          "302-0007",
          "300-1538",
          "300-1545",
          "300-1200",
          "300-1282",
          "300-1221",
          "300-1204",
          "300-1283",
          "300-1286",
          "300-1214",
          "300-1211",
          "300-1281",
          "300-1213",
          "300-1232",
          "300-1216",
          "300-1235",
          "300-1288",
          "300-1212",
          "300-1233",
          "300-1217",
          "300-1231",
          "300-1284",
          "300-1203",
          "300-1285",
          "300-1223",
          "300-1224",
          "300-1225",
          "300-1237",
          "300-1236",
          "300-1234",
          "300-1215",
          "300-1202",
          "300-1205",
          "300-1201",
          "300-1206",
          "300-1207",
          "300-1287",
          "300-1222",
          "305-0000",
          "305-0062",
          "300-4203",
          "305-0804",
          "300-2632",
          "300-4205",
          "300-1261",
          "305-0031",
          "305-0005",
          "300-1253",
          "305-0835",
          "305-0076",
          "305-0874",
          "300-4243",
          "305-0901",
          "300-1240",
          "300-1269",
          "300-4235",
          "300-4248",
          "305-0073",
          "305-0071",
          "300-1259",
          "305-0061",
          "305-0855",
          "300-2641",
          "305-0002",
          "305-0023",
          "300-4211",
          "300-1275",
          "305-0045",
          "300-4216",
          "305-0853",
          "305-0016",
          "300-1243",
          "300-4221",
          "300-2611",
          "305-0845",
          "300-2612",
          "300-3253",
          "300-4218",
          "300-1267",
          "305-0801",
          "300-3256",
          "305-0851",
          "305-0026",
          "300-1255",
          "300-3265",
          "300-4215",
          "300-4223",
          "300-2651",
          "305-0053",
          "305-0034",
          "300-2653",
          "305-0816",
          "305-0818",
          "305-0064",
          "300-3254",
          "305-0821",
          "305-0877",
          "305-0824",
          "300-2657",
          "300-2622",
          "300-1274",
          "300-4351",
          "305-0871",
          "300-2668",
          "300-2661",
          "300-2645",
          "305-0011",
          "300-2614",
          "300-4246",
          "300-4241",
          "305-0055",
          "305-0041",
          "305-0854",
          "305-0822",
          "300-4212",
          "305-0856",
          "305-0022",
          "300-4232",
          "305-0811",
          "305-0072",
          "305-0066",
          "300-3266",
          "300-4233",
          "300-1272",
          "300-4354",
          "300-1262",
          "305-0024",
          "305-0001",
          "305-0817",
          "300-4236",
          "300-2642",
          "305-0074",
          "300-4202",
          "305-0844",
          "300-2616",
          "300-2644",
          "300-1277",
          "300-1276",
          "300-4224",
          "305-0018",
          "300-3251",
          "305-0028",
          "305-0036",
          "305-0867",
          "305-0864",
          "305-0013",
          "305-0003",
          "300-1271",
          "305-0019",
          "300-2637",
          "305-0043",
          "300-3264",
          "305-0004",
          "305-0833",
          "300-2655",
          "300-1273",
          "300-4222",
          "305-0872",
          "300-2662",
          "305-0063",
          "305-0813",
          "305-0042",
          "300-2666",
          "305-0075",
          "300-1266",
          "305-0014",
          "300-1251",
          "305-0847",
          "300-1246",
          "300-4217",
          "300-2658",
          "305-0047",
          "305-0868",
          "305-0846",
          "300-1245",
          "300-2665",
          "300-2652",
          "305-0077",
          "300-1252",
          "300-2669",
          "300-2664",
          "300-2615",
          "305-0032",
          "305-0802",
          "300-3263",
          "305-0067",
          "300-4244",
          "300-3255",
          "300-4251",
          "300-4352",
          "300-3257",
          "300-4204",
          "300-2636",
          "300-2647",
          "305-0834",
          "300-4201",
          "305-0006",
          "300-2635",
          "300-2633",
          "300-2648",
          "305-0068",
          "300-4242",
          "305-0012",
          "305-0873",
          "300-2639",
          "300-2634",
          "300-2667",
          "305-0052",
          "300-1268",
          "300-2663",
          "305-0044",
          "300-1260",
          "305-0054",
          "305-0831",
          "305-0832",
          "305-0876",
          "300-2613",
          "300-2624",
          "305-0902",
          "300-1247",
          "305-0815",
          "305-0814",
          "305-0051",
          "300-2631",
          "300-4353",
          "305-0865",
          "300-2643",
          "300-3262",
          "305-0843",
          "300-2638",
          "300-1264",
          "305-0875",
          "305-0029",
          "305-0805",
          "300-3261",
          "305-0025",
          "305-0857",
          "305-0823",
          "305-0007",
          "300-2659",
          "305-0046",
          "305-0033",
          "305-0027",
          "305-0812",
          "305-0862",
          "300-1242",
          "300-4213",
          "300-1263",
          "305-0852",
          "305-0021",
          "305-0866",
          "300-4231",
          "300-1278",
          "300-1254",
          "300-1265",
          "300-4249",
          "300-2623",
          "300-3267",
          "300-1241",
          "300-2656",
          "305-0035",
          "305-0015",
          "305-0056",
          "305-0903",
          "300-1244",
          "300-2654",
          "305-0863",
          "300-2646",
          "305-0881",
          "305-0882",
          "305-0883",
          "305-0884",
          "305-0065",
          "305-0803",
          "300-2621",
          "300-4245",
          "305-0841",
          "300-1257",
          "300-1256",
          "305-0842",
          "305-0861",
          "300-4234",
          "300-4214",
          "305-0836",
          "305-0017",
          "300-2617",
          "305-0008",
          "300-1258",
          "300-1248",
          "300-1249",
          "300-3252",
          "300-4247",
          "312-0000",
          "312-0056",
          "311-1241",
          "311-1264",
          "311-1201",
          "311-1255",
          "312-0057",
          "311-1202",
          "312-0033",
          "312-0061",
          "311-1213",
          "312-0014",
          "312-0035",
          "312-0023",
          "311-1263",
          "312-0007",
          "312-0047",
          "311-1222",
          "312-0048",
          "312-0024",
          "312-0046",
          "312-0045",
          "312-0027",
          "312-0026",
          "312-0022",
          "312-0013",
          "311-1207",
          "311-1243",
          "312-0043",
          "312-0002",
          "311-1236",
          "312-0015",
          "312-0031",
          "311-1253",
          "312-0058",
          "311-1226",
          "311-1223",
          "312-0018",
          "312-0001",
          "311-1211",
          "311-1247",
          "311-1225",
          "311-1205",
          "312-0005",
          "311-1237",
          "311-1246",
          "312-0053",
          "312-0055",
          "312-0062",
          "312-0025",
          "311-1245",
          "311-1235",
          "312-0063",
          "311-1248",
          "312-0003",
          "312-0032",
          "312-0036",
          "311-1261",
          "311-1227",
          "312-0051",
          "311-1262",
          "311-1212",
          "312-0011",
          "312-0004",
          "312-0017",
          "311-1254",
          "311-1242",
          "312-0041",
          "311-1206",
          "312-0054",
          "311-1228",
          "312-0052",
          "312-0042",
          "311-1215",
          "311-1203",
          "311-1204",
          "311-1218",
          "311-1217",
          "311-1266",
          "311-1252",
          "311-1233",
          "312-0034",
          "312-0006",
          "312-0016",
          "312-0012",
          "311-1267",
          "311-1238",
          "312-0021",
          "311-1216",
          "311-1229",
          "311-1268",
          "311-1221",
          "311-1244",
          "311-1234",
          "311-1265",
          "312-0044",
          "311-1232",
          "311-1231",
          "311-1251",
          "311-1224",
          "311-1214",
          "314-0000",
          "314-0021",
          "311-2211",
          "314-0002",
          "314-0017",
          "311-2204",
          "314-0015",
          "314-0036",
          "314-0004",
          "311-2215",
          "314-0037",
          "314-0028",
          "314-0026",
          "314-0031",
          "314-0016",
          "314-0030",
          "311-2221",
          "314-0003",
          "311-2222",
          "314-0027",
          "314-0044",
          "311-2207",
          "314-0001",
          "314-0025",
          "314-0038",
          "314-0007",
          "314-0013",
          "314-0047",
          "311-2201",
          "314-0005",
          "311-2206",
          "311-2202",
          "311-2214",
          "314-0042",
          "314-0043",
          "314-0048",
          "311-2205",
          "311-2212",
          "314-0046",
          "311-2213",
          "314-0022",
          "311-2224",
          "314-0041",
          "314-0035",
          "314-0034",
          "314-0033",
          "311-2203",
          "311-2223",
          "314-0014",
          "314-0012",
          "314-0039",
          "314-0011",
          "314-0032",
          "314-0006",
          "314-0045",
          "314-0023",
          "314-0024",
          "311-2400",
          "311-2425",
          "311-2424",
          "311-2436",
          "311-2435",
          "311-2402",
          "311-2401",
          "311-2422",
          "311-2426",
          "311-2441",
          "311-2403",
          "311-2440",
          "311-2431",
          "311-2442",
          "311-2444",
          "311-2407",
          "311-2434",
          "311-2406",
          "311-2443",
          "311-2448",
          "311-2446",
          "311-2408",
          "311-2405",
          "311-2421",
          "311-2418",
          "311-2437",
          "311-2415",
          "311-2409",
          "311-2410",
          "311-2423",
          "311-2419",
          "311-2449",
          "311-2433",
          "311-2416",
          "311-2447",
          "311-2445",
          "311-2404",
          "311-2412",
          "311-2432",
          "311-2417",
          "302-0100",
          "302-0111",
          "302-0101",
          "302-0116",
          "302-0107",
          "302-0103",
          "302-0123",
          "302-0104",
          "302-0128",
          "302-0125",
          "302-0119",
          "302-0122",
          "302-0126",
          "302-0118",
          "302-0115",
          "302-0112",
          "302-0117",
          "302-0131",
          "302-0109",
          "302-0127",
          "302-0108",
          "302-0132",
          "302-0102",
          "302-0121",
          "302-0124",
          "302-0106",
          "302-0105",
          "302-0110",
          "319-2200",
          "311-4611",
          "319-2135",
          "319-2144",
          "319-2415",
          "319-2211",
          "319-2251",
          "319-2145",
          "319-2418",
          "319-2203",
          "319-3116",
          "319-2412",
          "319-2602",
          "319-2405",
          "319-3112",
          "319-2133",
          "319-2132",
          "311-4501",
          "311-4614",
          "311-4617",
          "319-2142",
          "319-2212",
          "319-2401",
          "319-2261",
          "319-2511",
          "319-2136",
          "319-2226",
          "319-2254",
          "319-3104",
          "319-2404",
          "319-3101",
          "319-2213",
          "319-2134",
          "319-2411",
          "319-2264",
          "319-2202",
          "311-4615",
          "319-2141",
          "319-2402",
          "319-2262",
          "319-2512",
          "319-2131",
          "319-2416",
          "319-2214",
          "319-2601",
          "319-2253",
          "319-2256",
          "319-2201",
          "319-2227",
          "319-3115",
          "319-3113",
          "319-2224",
          "319-2204",
          "319-2603",
          "319-2403",
          "311-4612",
          "311-4613",
          "319-3117",
          "319-2265",
          "319-2225",
          "319-3106",
          "319-2143",
          "319-3114",
          "311-4503",
          "311-4502",
          "311-4618",
          "319-2255",
          "319-2221",
          "319-2252",
          "319-2513",
          "311-4616",
          "319-3107",
          "319-2413",
          "319-2263",
          "319-2205",
          "319-2223",
          "319-3102",
          "319-3105",
          "319-3111",
          "319-3103",
          "319-2266",
          "319-2417",
          "319-2414",
          "319-2222",
          "311-0100",
          "311-0134",
          "319-2102",
          "311-0125",
          "311-0135",
          "311-0136",
          "311-0116",
          "311-0123",
          "311-0131",
          "311-0133",
          "311-0111",
          "319-2105",
          "319-2106",
          "311-0126",
          "319-2107",
          "311-0105",
          "311-0106",
          "311-0110",
          "311-0124",
          "311-0112",
          "311-0104",
          "311-0122",
          "311-0121",
          "311-0117",
          "319-2103",
          "311-0113",
          "311-0115",
          "311-0108",
          "311-0109",
          "311-0107",
          "311-0114",
          "319-2104",
          "311-0118",
          "311-0132",
          "311-0102",
          "311-0101",
          "311-0103",
          "308-0000",
          "300-4523",
          "308-0836",
          "300-4516",
          "300-4512",
          "308-0064",
          "308-0835",
          "308-0853",
          "308-0856",
          "308-0075",
          "308-0055",
          "308-0076",
          "308-0116",
          "308-0827",
          "308-0842",
          "309-1108",
          "308-0805",
          "308-0106",
          "308-0117",
          "308-0101",
          "308-0129",
          "300-4507",
          "308-0128",
          "300-4538",
          "300-4517",
          "309-1125",
          "308-0015",
          "308-0813",
          "300-4537",
          "308-0852",
          "308-0051",
          "308-0857",
          "308-0012",
          "309-1101",
          "308-0854",
          "300-4511",
          "308-0002",
          "308-0041",
          "308-0806",
          "308-0007",
          "308-0837",
          "308-0107",
          "309-1107",
          "308-0804",
          "308-0815",
          "308-0017",
          "300-4502",
          "308-0067",
          "309-1111",
          "308-0063",
          "308-0801",
          "308-0814",
          "308-0104",
          "309-1103",
          "308-0071",
          "300-4515",
          "308-0061",
          "308-0102",
          "309-1127",
          "308-0021",
          "308-0004",
          "308-0077",
          "308-0866",
          "308-0862",
          "308-0848",
          "300-4532",
          "308-0065",
          "300-4514",
          "309-1105",
          "308-0072",
          "308-0823",
          "309-1126",
          "308-0851",
          "308-0826",
          "308-0855",
          "300-4545",
          "309-1123",
          "308-0011",
          "308-0825",
          "308-0844",
          "308-0066",
          "309-1122",
          "308-0052",
          "308-0113",
          "308-0124",
          "308-0122",
          "308-0123",
          "308-0127",
          "308-0126",
          "308-0125",
          "308-0864",
          "308-0807",
          "300-4534",
          "300-4543",
          "300-4505",
          "308-0847",
          "309-1124",
          "308-0074",
          "300-4531",
          "308-0822",
          "308-0103",
          "300-4525",
          "308-0816",
          "308-0053",
          "308-0803",
          "300-4524",
          "308-0005",
          "300-4513",
          "308-0108",
          "300-4506",
          "308-0821",
          "300-4533",
          "309-1106",
          "308-0841",
          "308-0834",
          "308-0062",
          "308-0845",
          "308-0105",
          "308-0054",
          "308-0867",
          "308-0832",
          "308-0846",
          "300-4501",
          "308-0016",
          "308-0833",
          "308-0843",
          "308-0863",
          "308-0014",
          "309-1115",
          "308-0013",
          "308-0114",
          "308-0115",
          "308-0073",
          "300-4521",
          "300-4536",
          "308-0831",
          "308-0001",
          "308-0812",
          "308-0112",
          "308-0121",
          "308-0111",
          "300-4544",
          "309-1104",
          "308-0031",
          "309-1114",
          "308-0003",
          "300-4541",
          "308-0042",
          "300-4503",
          "300-4504",
          "300-4522",
          "309-1117",
          "300-4546",
          "308-0811",
          "308-0861",
          "308-0056",
          "309-1121",
          "309-1113",
          "309-1112",
          "308-0006",
          "308-0865",
          "300-4535",
          "308-0802",
          "309-1116",
          "300-4542",
          "308-0838",
          "309-1102",
          "308-0824",
          "306-0600",
          "306-0631",
          "306-0514",
          "306-0504",
          "306-0503",
          "306-0615",
          "306-0613",
          "306-0622",
          "306-0601",
          "306-0621",
          "306-0626",
          "306-0617",
          "306-0611",
          "306-0654",
          "306-0657",
          "306-0603",
          "306-0643",
          "306-0636",
          "306-0641",
          "306-0515",
          "306-0513",
          "306-0635",
          "306-0608",
          "306-0606",
          "306-0604",
          "306-0644",
          "306-0653",
          "306-0501",
          "306-0512",
          "306-0633",
          "306-0614",
          "306-0505",
          "306-0656",
          "306-0652",
          "306-0634",
          "306-0645",
          "306-0642",
          "306-0616",
          "306-0612",
          "306-0651",
          "306-0602",
          "306-0632",
          "306-0623",
          "306-0511",
          "306-0605",
          "306-0637",
          "306-0658",
          "306-0655",
          "306-0625",
          "306-0624",
          "306-0502",
          "306-0607",
          "300-0500",
          "300-0621",
          "300-0602",
          "300-0626",
          "300-0727",
          "300-0632",
          "300-1413",
          "300-1411",
          "300-0603",
          "300-0612",
          "300-0503",
          "300-0507",
          "300-1414",
          "300-0641",
          "300-0509",
          "300-0504",
          "300-0529",
          "300-0721",
          "300-1423",
          "300-0633",
          "300-0744",
          "300-1425",
          "300-0634",
          "300-0637",
          "300-0604",
          "300-0522",
          "300-0528",
          "300-0737",
          "301-0902",
          "300-0732",
          "300-0643",
          "300-0513",
          "300-0734",
          "300-0746",
          "300-0605",
          "300-0733",
          "300-0524",
          "300-0514",
          "300-0723",
          "300-0508",
          "300-0749",
          "300-0725",
          "300-0512",
          "300-0623",
          "300-0502",
          "300-1412",
          "300-0614",
          "300-1424",
          "300-0527",
          "300-0601",
          "301-0901",
          "300-0642",
          "300-0622",
          "300-0613",
          "300-0625",
          "300-0521",
          "300-1416",
          "300-0748",
          "300-0511",
          "300-0741",
          "300-1426",
          "300-0523",
          "300-0611",
          "300-1415",
          "300-0726",
          "300-0506",
          "300-0525",
          "300-1427",
          "300-0745",
          "300-0736",
          "300-0501",
          "300-0636",
          "300-0616",
          "300-0617",
          "300-0638",
          "300-1421",
          "300-0635",
          "300-0743",
          "300-0615",
          "300-0526",
          "300-1417",
          "300-0722",
          "300-0631",
          "300-0607",
          "300-1422",
          "300-0515",
          "300-0624",
          "300-0505",
          "300-0731",
          "300-0724",
          "300-0747",
          "300-0742",
          "300-0735",
          "300-0606",
          "300-0212",
          "315-0078",
          "300-0205",
          "315-0063",
          "315-0071",
          "315-0054",
          "315-0053",
          "315-0055",
          "300-0203",
          "300-0213",
          "315-0064",
          "300-0124",
          "300-0132",
          "300-0201",
          "315-0056",
          "300-0127",
          "300-0123",
          "315-0065",
          "315-0076",
          "315-0057",
          "300-0135",
          "315-0061",
          "300-0214",
          "300-0121",
          "300-0211",
          "315-0052",
          "300-0131",
          "300-0204",
          "315-0067",
          "315-0074",
          "315-0058",
          "315-0077",
          "300-0202",
          "300-0136",
          "315-0066",
          "315-0075",
          "300-0133",
          "315-0051",
          "300-0122",
          "315-0073",
          "315-0072",
          "300-0134",
          "300-0125",
          "300-0126",
          "315-0068",
          "315-0069",
          "315-0062",
          "309-1200",
          "309-1241",
          "309-1456",
          "309-1216",
          "309-1234",
          "309-1202",
          "309-1332",
          "309-1457",
          "309-1458",
          "309-1217",
          "309-1464",
          "309-1345",
          "309-1211",
          "309-1226",
          "309-1201",
          "309-1244",
          "309-1232",
          "309-1335",
          "309-1222",
          "309-1341",
          "309-1245",
          "309-1454",
          "309-1343",
          "309-1452",
          "309-1465",
          "309-1204",
          "309-1223",
          "309-1336",
          "309-1215",
          "309-1334",
          "309-1466",
          "309-1225",
          "309-1462",
          "309-1243",
          "309-1463",
          "309-1246",
          "309-1205",
          "309-1203",
          "309-1347",
          "309-1453",
          "309-1224",
          "309-1346",
          "309-1221",
          "309-1451",
          "309-1213",
          "309-1242",
          "309-1233",
          "309-1214",
          "309-1331",
          "309-1337",
          "309-1212",
          "309-1227",
          "300-4417",
          "300-4416",
          "300-4428",
          "300-4401",
          "300-4427",
          "300-4422",
          "300-4424",
          "300-4413",
          "300-4405",
          "300-4414",
          "300-4402",
          "300-4426",
          "300-4404",
          "300-4411",
          "300-4403",
          "300-4412",
          "300-4423",
          "300-4421",
          "300-4429",
          "300-4415",
          "300-4407",
          "300-4425",
          "300-4408",
          "300-4406",
          "309-1461",
          "309-1342",
          "309-1455",
          "309-1344",
          "309-1231",
          "309-1333",
          "314-0100",
          "314-0133",
          "314-0052",
          "314-0141",
          "314-0124",
          "314-0254",
          "314-0257",
          "314-0144",
          "314-0128",
          "314-0116",
          "314-0134",
          "314-0143",
          "314-0127",
          "314-0101",
          "314-0115",
          "314-0112",
          "314-0123",
          "314-0131",
          "314-0253",
          "314-0255",
          "314-0125",
          "314-0126",
          "314-0132",
          "314-0342",
          "314-0347",
          "314-0346",
          "314-0344",
          "314-0343",
          "314-0345",
          "314-0102",
          "314-0114",
          "314-0122",
          "314-0408",
          "314-0407",
          "314-0103",
          "314-0051",
          "314-0146",
          "314-0145",
          "314-0148",
          "314-0142",
          "314-0135",
          "314-0121",
          "314-0111",
          "314-0341",
          "314-0252",
          "314-0258",
          "314-0113",
          "314-0256",
          "314-0147",
          "311-3800",
          "311-3831",
          "311-3832",
          "311-3814",
          "311-3518",
          "311-3803",
          "311-3827",
          "311-3817",
          "311-3515",
          "311-3516",
          "311-3824",
          "311-1705",
          "311-3822",
          "311-3508",
          "311-3802",
          "311-3804",
          "311-1724",
          "311-1715",
          "311-1716",
          "311-3821",
          "311-3807",
          "311-3816",
          "311-3813",
          "311-3514",
          "311-3835",
          "311-3823",
          "311-3811",
          "311-3815",
          "311-3812",
          "311-3501",
          "311-3511",
          "311-3512",
          "311-3513",
          "311-3833",
          "311-1713",
          "311-1701",
          "311-1722",
          "311-3801",
          "311-1703",
          "311-3825",
          "311-3503",
          "311-3805",
          "311-3507",
          "311-3505",
          "311-1712",
          "311-3517",
          "311-3806",
          "311-3834",
          "311-3836",
          "311-1714",
          "311-1702",
          "311-3506",
          "311-3504",
          "311-3826",
          "311-1704",
          "311-1723",
          "311-1711",
          "311-1721",
          "311-3502",
          "311-1500",
          "311-1535",
          "311-2101",
          "311-1506",
          "311-2118",
          "311-1411",
          "311-1504",
          "311-2112",
          "311-1521",
          "311-2114",
          "311-2117",
          "311-1513",
          "311-1502",
          "311-1536",
          "311-2104",
          "311-1511",
          "311-1424",
          "311-1422",
          "311-1421",
          "311-1515",
          "311-1405",
          "311-1403",
          "311-2111",
          "311-1532",
          "311-2113",
          "311-1527",
          "311-1523",
          "311-2103",
          "311-1414",
          "311-1505",
          "311-1404",
          "311-1416",
          "311-1402",
          "311-1533",
          "311-1512",
          "311-1516",
          "311-1518",
          "311-1531",
          "311-2102",
          "311-1524",
          "311-1423",
          "311-1406",
          "311-1412",
          "311-1415",
          "311-1522",
          "311-1528",
          "311-1427",
          "311-1503",
          "311-1534",
          "311-2115",
          "311-1525",
          "311-1526",
          "311-1413",
          "311-2116",
          "311-2105",
          "311-1501",
          "311-1517",
          "311-1401",
          "311-1537",
          "311-1426",
          "311-1514",
          "311-1425",
          "300-2300",
          "300-2346",
          "300-2348",
          "300-2315",
          "300-2354",
          "300-2307",
          "300-2323",
          "300-2355",
          "300-2308",
          "300-2342",
          "300-2303",
          "300-2411",
          "300-2352",
          "300-2432",
          "300-2353",
          "300-2331",
          "300-2424",
          "300-2431",
          "300-2326",
          "300-2453",
          "300-2335",
          "300-2425",
          "300-2312",
          "300-2456",
          "300-2407",
          "300-2436",
          "300-2445",
          "300-2402",
          "300-2332",
          "300-2336",
          "300-2359",
          "300-2433",
          "300-2324",
          "300-2454",
          "300-2333",
          "300-2305",
          "300-2455",
          "300-2314",
          "300-2444",
          "300-2351",
          "300-2401",
          "300-2301",
          "300-2413",
          "300-2452",
          "300-2435",
          "300-2441",
          "300-2322",
          "300-2321",
          "300-2325",
          "300-2345",
          "300-2344",
          "300-2403",
          "300-2334",
          "300-2423",
          "300-2405",
          "300-2415",
          "300-2442",
          "300-2443",
          "300-2421",
          "300-2412",
          "300-2311",
          "300-2313",
          "300-2416",
          "300-2356",
          "300-2434",
          "300-2406",
          "300-2341",
          "300-2327",
          "300-2417",
          "300-2347",
          "300-2304",
          "300-2422",
          "300-2446",
          "300-2414",
          "300-2302",
          "300-2404",
          "300-2306",
          "300-2451",
          "300-2426",
          "300-2343",
          "300-2337",
          "300-2357",
          "300-2358",
          "319-0100",
          "311-3404",
          "319-0122",
          "319-0137",
          "319-0126",
          "311-3423",
          "319-0125",
          "319-0106",
          "311-3405",
          "311-3436",
          "319-0115",
          "311-3403",
          "311-3412",
          "311-3431",
          "311-3417",
          "311-3434",
          "319-0107",
          "311-3425",
          "319-0102",
          "311-3402",
          "319-0104",
          "319-0103",
          "311-3432",
          "311-3426",
          "311-3406",
          "311-3401",
          "311-3433",
          "319-0135",
          "311-3435",
          "319-0113",
          "319-0112",
          "319-0114",
          "319-0105",
          "319-0136",
          "319-0131",
          "311-3414",
          "319-0116",
          "311-3422",
          "319-0111",
          "319-0134",
          "311-3411",
          "319-0121",
          "319-0101",
          "311-3424",
          "319-0123",
          "319-0124",
          "319-0133",
          "311-3437",
          "311-3415",
          "319-0132",
          "319-0108",
          "311-3421",
          "311-3413",
          "311-3416",
          "311-3100",
          "311-3137",
          "311-3147",
          "311-3152",
          "311-3111",
          "311-3135",
          "311-3114",
          "311-3156",
          "311-3131",
          "311-3157",
          "311-3145",
          "311-3153",
          "311-3122",
          "311-3134",
          "311-3141",
          "311-3151",
          "311-3146",
          "311-3107",
          "311-3132",
          "311-3104",
          "311-3106",
          "311-3113",
          "311-3117",
          "311-3144",
          "311-3154",
          "311-3125",
          "311-3155",
          "311-3138",
          "311-3105",
          "311-3108",
          "311-3112",
          "311-3142",
          "311-3124",
          "311-3116",
          "311-3143",
          "311-3103",
          "311-3115",
          "311-3101",
          "311-3102",
          "311-3133",
          "311-3136",
          "311-3121",
          "311-3123",
          "311-1300",
          "311-1301",
          "311-1302",
          "311-1311",
          "311-1312",
          "311-1306",
          "311-1307",
          "311-1303",
          "311-1313",
          "311-1305",
          "311-1304",
          "311-4300",
          "311-4321",
          "311-4344",
          "311-4303",
          "311-4312",
          "311-4331",
          "311-4403",
          "311-4402",
          "311-4316",
          "311-4317",
          "311-4305",
          "311-4405",
          "311-4323",
          "311-4342",
          "311-4301",
          "311-4313",
          "311-4315",
          "311-4325",
          "311-4341",
          "311-4404",
          "311-4401",
          "311-4304",
          "311-4406",
          "311-4322",
          "311-4343",
          "311-4314",
          "311-4335",
          "311-4324",
          "311-4333",
          "311-4332",
          "311-4407",
          "311-4302",
          "311-4306",
          "311-4334",
          "311-4311",
          "319-1100",
          "319-1102",
          "319-1101",
          "319-1119",
          "319-1104",
          "319-1106",
          "319-1109",
          "319-1114",
          "319-1103",
          "319-1113",
          "319-1117",
          "319-1105",
          "319-1107",
          "319-1111",
          "319-1116",
          "319-1118",
          "319-1115",
          "319-1112",
          "319-1108",
          "319-3500",
          "319-3534",
          "319-3541",
          "319-3538",
          "319-3551",
          "319-3515",
          "319-3531",
          "319-3366",
          "319-3513",
          "319-3535",
          "319-3703",
          "319-3704",
          "319-3556",
          "319-3521",
          "319-3363",
          "319-3701",
          "319-3522",
          "319-3512",
          "319-3361",
          "319-3362",
          "319-3543",
          "319-3533",
          "319-3524",
          "319-3555",
          "319-3514",
          "319-3526",
          "319-3511",
          "319-3554",
          "319-3536",
          "319-3365",
          "319-3705",
          "319-3542",
          "319-3537",
          "319-3523",
          "319-3544",
          "319-3702",
          "319-3525",
          "319-3553",
          "319-3364",
          "319-3552",
          "319-3532",
          "300-0400",
          "300-0424",
          "300-0409",
          "300-0422",
          "300-0411",
          "300-0416",
          "300-0413",
          "300-0402",
          "300-0425",
          "300-0433",
          "300-0421",
          "300-0420",
          "300-0419",
          "300-0414",
          "300-0432",
          "300-0404",
          "300-0426",
          "300-0435",
          "300-0408",
          "300-0436",
          "300-0418",
          "300-0427",
          "300-0428",
          "300-0434",
          "300-0401",
          "300-0405",
          "300-0403",
          "300-0415",
          "300-0410",
          "300-0437",
          "300-0412",
          "300-0431",
          "300-0423",
          "300-0407",
          "300-0417",
          "300-0406",
          "300-0300",
          "300-0301",
          "300-0306",
          "300-0331",
          "300-1151",
          "300-1152",
          "300-0324",
          "300-0313",
          "300-0341",
          "300-0323",
          "300-0303",
          "300-0335",
          "300-0314",
          "300-0304",
          "300-0315",
          "300-1154",
          "300-0322",
          "300-1157",
          "300-0311",
          "300-1153",
          "300-0325",
          "300-0334",
          "300-1158",
          "300-0305",
          "300-0332",
          "300-0337",
          "300-0312",
          "300-0336",
          "300-0302",
          "300-0321",
          "300-1156",
          "300-0326",
          "300-1159",
          "300-1155",
          "300-1161",
          "300-0333",
          "300-1300",
          "300-1404",
          "300-1403",
          "300-1324",
          "300-1332",
          "300-1322",
          "300-1334",
          "300-1327",
          "300-1406",
          "300-1314",
          "300-1401",
          "300-1315",
          "300-1311",
          "300-1333",
          "300-1336",
          "300-1313",
          "300-1405",
          "300-1323",
          "300-1312",
          "300-1321",
          "300-1402",
          "300-1316",
          "300-1325",
          "300-1331",
          "300-1335",
          "300-1326",
          "300-1337",
          "300-3500",
          "300-3555",
          "300-3556",
          "300-3519",
          "300-3535",
          "300-3562",
          "300-3531",
          "300-3514",
          "300-3534",
          "300-3571",
          "300-3552",
          "300-3515",
          "300-3554",
          "300-3526",
          "300-3503",
          "300-3533",
          "300-3537",
          "300-3521",
          "300-3513",
          "300-3551",
          "300-3512",
          "300-3505",
          "300-3501",
          "300-3502",
          "300-3541",
          "300-3543",
          "300-3572",
          "300-3511",
          "300-3516",
          "300-3517",
          "300-3536",
          "300-3506",
          "300-3539",
          "300-3504",
          "300-3525",
          "300-3518",
          "300-3523",
          "300-3538",
          "300-3527",
          "300-3545",
          "300-3524",
          "300-3561",
          "300-3553",
          "300-3542",
          "300-3522",
          "300-3532",
          "300-3565",
          "300-3564",
          "300-3563",
          "300-3544",
          "306-0300",
          "306-0303",
          "306-0311",
          "306-0314",
          "306-0304",
          "306-0315",
          "306-0307",
          "306-0302",
          "306-0301",
          "306-0316",
          "306-0312",
          "306-0306",
          "306-0305",
          "306-0317",
          "306-0313",
          "306-0400",
          "306-0433",
          "306-0422",
          "306-0407",
          "306-0414",
          "306-0427",
          "306-0426",
          "306-0434",
          "306-0424",
          "306-0412",
          "306-0402",
          "306-0401",
          "306-0411",
          "306-0432",
          "306-0403",
          "306-0421",
          "306-0405",
          "306-0404",
          "306-0431",
          "306-0425",
          "306-0416",
          "306-0423",
          "306-0413",
          "306-0435",
          "306-0406",
          "306-0417",
          "306-0415",
          "300-1600",
          "300-1603",
          "300-1634",
          "300-1602",
          "300-1612",
          "300-1635",
          "300-1626",
          "300-1633",
          "300-1632",
          "300-1611",
          "300-1605",
          "300-1601",
          "300-1616",
          "300-1614",
          "300-1624",
          "300-1615",
          "300-1623",
          "300-1625",
          "300-1636",
          "300-1631",
          "300-1613",
          "300-1622",
          "300-1621",
          "300-1606",
          "300-1604",
          "321-0000",
          "329-1113",
          "320-0845",
          "320-0818",
          "321-0404",
          "321-0347",
          "321-2101",
          "320-0801",
          "321-0912",
          "321-2103",
          "321-0952",
          "320-0034",
          "321-3221",
          "320-0821",
          "320-0047",
          "320-0049",
          "320-0812",
          "321-0966",
          "321-0961",
          "321-0962",
          "321-0402",
          "321-0166",
          "321-0973",
          "321-2117",
          "321-0976",
          "321-0118",
          "321-0981",
          "321-0405",
          "321-0964",
          "321-0107",
          "321-0101",
          "321-0102",
          "320-0802",
          "321-2111",
          "320-0014",
          "321-0161",
          "320-0811",
          "321-0345",
          "320-0823",
          "320-0036",
          "321-0971",
          "321-0108",
          "321-0406",
          "329-1117",
          "320-0013",
          "329-1106",
          "320-0855",
          "321-2115",
          "321-0913",
          "321-2104",
          "321-0401",
          "321-3233",
          "329-1112",
          "320-0058",
          "320-0051",
          "321-0115",
          "321-2112",
          "321-0106",
          "321-3224",
          "321-0111",
          "321-0977",
          "321-0965",
          "320-0822",
          "320-0002",
          "321-0412",
          "320-0844",
          "320-0048",
          "321-0153",
          "320-0842",
          "320-0037",
          "321-3231",
          "321-3223",
          "321-3234",
          "321-0951",
          "321-0341",
          "321-0135",
          "321-3235",
          "320-0066",
          "320-0065",
          "320-0042",
          "320-0848",
          "320-0024",
          "329-1111",
          "320-0854",
          "320-0043",
          "329-1101",
          "321-0141",
          "321-0922",
          "320-0814",
          "321-2102",
          "321-0346",
          "329-1104",
          "320-0853",
          "321-2114",
          "321-0972",
          "320-0824",
          "320-0825",
          "321-0914",
          "321-0924",
          "321-0923",
          "321-2105",
          "321-0403",
          "321-0122",
          "329-1115",
          "320-0852",
          "320-0055",
          "321-0903",
          "321-2113",
          "321-0124",
          "321-0945",
          "321-0935",
          "321-0117",
          "321-0413",
          "320-0032",
          "329-1102",
          "321-0133",
          "320-0831",
          "321-0144",
          "321-0132",
          "321-0121",
          "321-0113",
          "320-0864",
          "321-0975",
          "320-0022",
          "320-0867",
          "321-0104",
          "321-0103",
          "321-0134",
          "321-0416",
          "329-1114",
          "320-0061",
          "320-0075",
          "320-0846",
          "320-0847",
          "321-3236",
          "321-0974",
          "321-0343",
          "321-0344",
          "320-0806",
          "320-0805",
          "320-0857",
          "320-0851",
          "320-0816",
          "320-0035",
          "321-3237",
          "321-0123",
          "320-0856",
          "321-2116",
          "320-0056",
          "320-0017",
          "320-0053",
          "320-0031",
          "320-0003",
          "321-0911",
          "320-0045",
          "321-0968",
          "320-0004",
          "329-1105",
          "320-0815",
          "321-0906",
          "321-0414",
          "321-0114",
          "320-0057",
          "320-0052",
          "320-0023",
          "329-1107",
          "320-0861",
          "320-0046",
          "321-0917",
          "321-0152",
          "321-0154",
          "321-0158",
          "321-0151",
          "321-0155",
          "321-0967",
          "320-0866",
          "320-0064",
          "320-0862",
          "320-0826",
          "321-2118",
          "320-0813",
          "321-3222",
          "320-0071",
          "321-0127",
          "320-0015",
          "320-0843",
          "320-0827",
          "320-0828",
          "320-0027",
          "320-0026",
          "321-0137",
          "321-0147",
          "321-0941",
          "321-0167",
          "329-1103",
          "321-0915",
          "321-0916",
          "321-0953",
          "320-0062",
          "320-0054",
          "320-0021",
          "321-0168",
          "321-0985",
          "321-0944",
          "321-0925",
          "321-0116",
          "320-0832",
          "321-3232",
          "321-0138",
          "321-0156",
          "321-0905",
          "321-0901",
          "321-0918",
          "321-0931",
          "321-0932",
          "321-0342",
          "320-0011",
          "321-0146",
          "320-0804",
          "321-0164",
          "320-0833",
          "321-0417",
          "329-1108",
          "320-0038",
          "320-0073",
          "320-0074",
          "320-0033",
          "320-0817",
          "321-0157",
          "320-0803",
          "320-0807",
          "321-0407",
          "320-0041",
          "321-3225",
          "320-0863",
          "321-0921",
          "321-0125",
          "321-0165",
          "321-0136",
          "320-0044",
          "321-0963",
          "321-0143",
          "321-0142",
          "321-0942",
          "321-0943",
          "320-0808",
          "321-0131",
          "320-0835",
          "320-0025",
          "321-0969",
          "321-0163",
          "321-0411",
          "321-0982",
          "321-0984",
          "321-0983",
          "320-0865",
          "321-0415",
          "321-0954",
          "321-0145",
          "321-0126",
          "321-0112",
          "321-0169",
          "321-0902",
          "321-0934",
          "321-0933",
          "321-0162",
          "320-0836",
          "320-0012",
          "320-0016",
          "320-0837",
          "321-3226",
          "320-0063",
          "321-0904",
          "320-0834",
          "321-0105",
          "320-0005",
          "320-0001",
          "320-0838",
          "329-1116",
          "320-0841",
          "320-0072",
          "321-0139",
          "326-0000",
          "326-0052",
          "326-0062",
          "326-0328",
          "326-0823",
          "326-0802",
          "326-0832",
          "326-0834",
          "326-0103",
          "326-0803",
          "326-0014",
          "326-0811",
          "326-0053",
          "326-0054",
          "326-0102",
          "329-4212",
          "326-0842",
          "326-0046",
          "326-0055",
          "326-0067",
          "326-0841",
          "326-0012",
          "326-0005",
          "326-0011",
          "326-0051",
          "326-0845",
          "329-4215",
          "326-0326",
          "326-0141",
          "326-0142",
          "326-0006",
          "326-0844",
          "326-0004",
          "326-0335",
          "326-0826",
          "326-0013",
          "326-0324",
          "326-0016",
          "326-0025",
          "329-4217",
          "326-0815",
          "326-0835",
          "326-0023",
          "326-0337",
          "326-0334",
          "326-0813",
          "326-0063",
          "326-0031",
          "326-0044",
          "326-0048",
          "326-0041",
          "326-0043",
          "326-0042",
          "326-0007",
          "326-0807",
          "326-0056",
          "326-0812",
          "326-0325",
          "326-0061",
          "329-4214",
          "326-0066",
          "326-0822",
          "326-0045",
          "326-0068",
          "326-0022",
          "329-4213",
          "326-0814",
          "326-0026",
          "326-0805",
          "326-0333",
          "326-0825",
          "326-0001",
          "326-0002",
          "326-0003",
          "326-0837",
          "326-0047",
          "326-0065",
          "326-0817",
          "329-4211",
          "326-0322",
          "326-0327",
          "329-4216",
          "326-0143",
          "326-0144",
          "326-0033",
          "326-0064",
          "326-0034",
          "326-0338",
          "326-0332",
          "326-0331",
          "326-0037",
          "326-0833",
          "326-0831",
          "326-0808",
          "326-0032",
          "326-0101",
          "326-0057",
          "326-0323",
          "326-0816",
          "326-0836",
          "326-0821",
          "326-0027",
          "326-0058",
          "326-0336",
          "326-0015",
          "326-0806",
          "326-0321",
          "326-0021",
          "326-0846",
          "326-0036",
          "326-0824",
          "326-0801",
          "326-0804",
          "326-0035",
          "326-0843",
          "326-0024",
          "328-0000",
          "328-0035",
          "328-0131",
          "328-0061",
          "328-0062",
          "328-0014",
          "328-0206",
          "328-0027",
          "328-0016",
          "328-0052",
          "328-0063",
          "329-4302",
          "329-4303",
          "329-4314",
          "329-4313",
          "329-4307",
          "329-4305",
          "329-4304",
          "329-4312",
          "329-4308",
          "329-4309",
          "329-4316",
          "329-4311",
          "329-4306",
          "329-4315",
          "329-4301",
          "328-0204",
          "328-0202",
          "328-0007",
          "329-4425",
          "329-4401",
          "329-4422",
          "329-4413",
          "329-4407",
          "329-4412",
          "329-4403",
          "329-4414",
          "329-4406",
          "329-4404",
          "329-4402",
          "329-4421",
          "329-4423",
          "329-4405",
          "329-4424",
          "329-4415",
          "329-4411",
          "328-0068",
          "328-0011",
          "328-0133",
          "328-0065",
          "328-0072",
          "328-0066",
          "328-0053",
          "328-0041",
          "328-0123",
          "328-0032",
          "328-0122",
          "328-0021",
          "328-0006",
          "328-0023",
          "328-0073",
          "328-0043",
          "328-0064",
          "328-0033",
          "328-0013",
          "328-0203",
          "328-0002",
          "328-0074",
          "328-0003",
          "328-0071",
          "328-0004",
          "328-0135",
          "328-0111",
          "328-0105",
          "328-0101",
          "328-0106",
          "328-0113",
          "328-0104",
          "328-0102",
          "328-0103",
          "328-0112",
          "328-0107",
          "328-0114",
          "328-0132",
          "328-0025",
          "328-0205",
          "322-0602",
          "322-0601",
          "322-0603",
          "322-0606",
          "322-0605",
          "322-0604",
          "328-0017",
          "328-0042",
          "328-0124",
          "328-0075",
          "328-0024",
          "328-0031",
          "328-0054",
          "328-0012",
          "328-0125",
          "323-1102",
          "329-0316",
          "323-1103",
          "323-1108",
          "323-1107",
          "323-1101",
          "323-1105",
          "349-1221",
          "329-0317",
          "323-1106",
          "329-0311",
          "329-0319",
          "329-0318",
          "329-0314",
          "329-0312",
          "323-1104",
          "329-0315",
          "329-0313",
          "328-0026",
          "328-0044",
          "328-0201",
          "328-0121",
          "328-0034",
          "328-0067",
          "328-0045",
          "328-0022",
          "328-0134",
          "328-0036",
          "328-0051",
          "328-0001",
          "328-0037",
          "328-0005",
          "328-0015",
          "327-0000",
          "327-0023",
          "327-0511",
          "327-0004",
          "327-0104",
          "327-0517",
          "327-0525",
          "327-0831",
          "327-0011",
          "327-0815",
          "327-0825",
          "327-0021",
          "327-0103",
          "327-0102",
          "327-0817",
          "327-0806",
          "327-0805",
          "327-0804",
          "327-0803",
          "327-0034",
          "327-0307",
          "327-0832",
          "327-0835",
          "327-0837",
          "327-0322",
          "327-0012",
          "327-0807",
          "327-0033",
          "327-0003",
          "327-0316",
          "327-0515",
          "327-0523",
          "327-0015",
          "327-0007",
          "327-0025",
          "327-0026",
          "327-0032",
          "327-0006",
          "327-0042",
          "327-0024",
          "327-0321",
          "327-0827",
          "327-0043",
          "327-0507",
          "327-0501",
          "327-0845",
          "327-0813",
          "327-0822",
          "327-0001",
          "327-0816",
          "327-0301",
          "327-0005",
          "327-0836",
          "327-0044",
          "327-0325",
          "327-0302",
          "327-0314",
          "327-0811",
          "328-0221",
          "327-0514",
          "327-0016",
          "327-0017",
          "327-0022",
          "327-0821",
          "327-0045",
          "327-0823",
          "327-0031",
          "327-0311",
          "327-0317",
          "327-0841",
          "327-0502",
          "327-0101",
          "327-0847",
          "327-0014",
          "327-0312",
          "327-0323",
          "327-0844",
          "327-0306",
          "327-0512",
          "327-0524",
          "327-0504",
          "327-0002",
          "327-0842",
          "327-0814",
          "327-0802",
          "327-0303",
          "327-0508",
          "327-0231",
          "327-0801",
          "327-0503",
          "327-0305",
          "327-0035",
          "327-0843",
          "327-0013",
          "327-0824",
          "327-0513",
          "327-0812",
          "327-0304",
          "327-0516",
          "327-0509",
          "327-0046",
          "327-0041",
          "327-0826",
          "327-0324",
          "327-0318",
          "327-0505",
          "327-0027",
          "327-0315",
          "327-0313",
          "327-0818",
          "327-0028",
          "327-0846",
          "327-0833",
          "327-0834",
          "322-0000",
          "322-0058",
          "322-0345",
          "322-0035",
          "322-0022",
          "322-0342",
          "322-0018",
          "322-0055",
          "322-0062",
          "322-0536",
          "321-1111",
          "322-0068",
          "322-0307",
          "322-0021",
          "322-0525",
          "322-0005",
          "322-0027",
          "322-0304",
          "322-0252",
          "322-0015",
          "322-0102",
          "322-0423",
          "322-0254",
          "322-0065",
          "322-0066",
          "322-0045",
          "328-0211",
          "322-0522",
          "322-0346",
          "322-0076",
          "322-0534",
          "322-0533",
          "322-0301",
          "322-0052",
          "322-0101",
          "322-0305",
          "322-0303",
          "322-0051",
          "322-0024",
          "322-0009",
          "322-0008",
          "322-0023",
          "322-0028",
          "322-0069",
          "322-0047",
          "322-0078",
          "322-0014",
          "322-0343",
          "322-0041",
          "322-0527",
          "322-0017",
          "322-0103",
          "322-0421",
          "322-0253",
          "322-0056",
          "322-0256",
          "322-0004",
          "322-0036",
          "322-0079",
          "328-0212",
          "322-0523",
          "322-0341",
          "322-0075",
          "322-0054",
          "322-0011",
          "322-0038",
          "322-0061",
          "322-0002",
          "322-0007",
          "322-0072",
          "322-0057",
          "322-0067",
          "322-0001",
          "322-0063",
          "322-0006",
          "322-0044",
          "322-0306",
          "322-0422",
          "322-0037",
          "322-0053",
          "322-0528",
          "322-0003",
          "322-0073",
          "322-0344",
          "322-0029",
          "322-0521",
          "322-0526",
          "322-0535",
          "322-0251",
          "322-0049",
          "322-0039",
          "322-0255",
          "322-0074",
          "322-0077",
          "322-0013",
          "322-0302",
          "322-0532",
          "322-0034",
          "322-0033",
          "322-0032",
          "322-0064",
          "322-0042",
          "322-0012",
          "322-0025",
          "322-0531",
          "322-0524",
          "322-0071",
          "322-0031",
          "322-0048",
          "322-0046",
          "322-0026",
          "322-0043",
          "322-0016",
          "321-1200",
          "321-1413",
          "321-2604",
          "321-1511",
          "321-1502",
          "321-1524",
          "321-1501",
          "321-1505",
          "321-1512",
          "321-1504",
          "321-1506",
          "321-1515",
          "321-1514",
          "321-1521",
          "321-1522",
          "321-1507",
          "321-1503",
          "321-1508",
          "321-1523",
          "321-1513",
          "321-2615",
          "321-2806",
          "321-1405",
          "321-1425",
          "321-1102",
          "321-1411",
          "321-2344",
          "321-1261",
          "321-1272",
          "321-1104",
          "321-2333",
          "321-2411",
          "321-2341",
          "321-2332",
          "321-2402",
          "321-2336",
          "321-2354",
          "321-2715",
          "321-1401",
          "321-2802",
          "321-2524",
          "321-2611",
          "321-2612",
          "321-2614",
          "321-2717",
          "321-2401",
          "321-1273",
          "321-2522",
          "321-2526",
          "321-1444",
          "321-1441",
          "321-1443",
          "321-1448",
          "321-1442",
          "321-1446",
          "321-1447",
          "321-2345",
          "321-1436",
          "321-2353",
          "321-2412",
          "321-2413",
          "321-2421",
          "321-2713",
          "321-1106",
          "321-1404",
          "321-2525",
          "321-1107",
          "321-2352",
          "321-2426",
          "321-2424",
          "321-2425",
          "321-1265",
          "321-2427",
          "321-2355",
          "321-1431",
          "321-2351",
          "321-1423",
          "321-1276",
          "321-1403",
          "321-1263",
          "321-1264",
          "321-2804",
          "321-2405",
          "321-1277",
          "321-2422",
          "321-2523",
          "321-2616",
          "321-1356",
          "321-1433",
          "321-1449",
          "321-1266",
          "321-1661",
          "321-1103",
          "321-1412",
          "321-1421",
          "321-1274",
          "321-2805",
          "321-2404",
          "321-2414",
          "321-2714",
          "321-1354",
          "321-1108",
          "321-1402",
          "321-2803",
          "321-1271",
          "321-1355",
          "321-2603",
          "321-1415",
          "321-2342",
          "321-2716",
          "321-1424",
          "321-1435",
          "321-2423",
          "321-2331",
          "321-1414",
          "321-2712",
          "321-1351",
          "321-2602",
          "321-2711",
          "321-1262",
          "321-2613",
          "321-2521",
          "321-1105",
          "321-1422",
          "321-1445",
          "321-1434",
          "321-2403",
          "321-1406",
          "321-2334",
          "321-1353",
          "321-1352",
          "321-1101",
          "321-1275",
          "321-2335",
          "321-1432",
          "321-2356",
          "321-2343",
          "321-1426",
          "321-2601",
          "321-1662",
          "321-2801",
          "321-1407",
          "321-2718",
          "323-0000",
          "329-0211",
          "329-0215",
          "323-0826",
          "323-0824",
          "323-0831",
          "323-0013",
          "323-0006",
          "329-0201",
          "323-0017",
          "323-0054",
          "323-0051",
          "323-0045",
          "323-0808",
          "323-0021",
          "323-0811",
          "323-0067",
          "329-0207",
          "323-0022",
          "323-0822",
          "323-0058",
          "323-0009",
          "329-0228",
          "329-0214",
          "323-0001",
          "323-0825",
          "329-0229",
          "323-0063",
          "323-0056",
          "323-0066",
          "329-0222",
          "323-0069",
          "323-0828",
          "323-0804",
          "323-0014",
          "323-0803",
          "329-0221",
          "323-0002",
          "323-0008",
          "323-0053",
          "329-0226",
          "323-0015",
          "323-0043",
          "323-0005",
          "323-0004",
          "323-0064",
          "323-0055",
          "323-0052",
          "323-0065",
          "329-0223",
          "323-0068",
          "323-0807",
          "323-0029",
          "329-0224",
          "323-0025",
          "323-0033",
          "329-0202",
          "323-0061",
          "323-0041",
          "323-0154",
          "323-0151",
          "323-0815",
          "323-0062",
          "323-0814",
          "323-0023",
          "323-0818",
          "323-0032",
          "323-0042",
          "323-0812",
          "323-0157",
          "323-0806",
          "329-0227",
          "323-0156",
          "329-0216",
          "329-0203",
          "323-0820",
          "323-0152",
          "323-0153",
          "323-0046",
          "329-0225",
          "323-0801",
          "323-0027",
          "323-0012",
          "329-0204",
          "323-0003",
          "323-0829",
          "323-0817",
          "329-0206",
          "323-0802",
          "323-0034",
          "323-0827",
          "329-0212",
          "323-0155",
          "323-0016",
          "323-0026",
          "323-0007",
          "323-0044",
          "329-0205",
          "323-0821",
          "329-0213",
          "323-0816",
          "329-0217",
          "323-0057",
          "323-0011",
          "323-0024",
          "323-0805",
          "323-0823",
          "323-0158",
          "323-0031",
          "323-0813",
          "323-0819",
          "323-0028",
          "321-4300",
          "321-4531",
          "321-4312",
          "321-4401",
          "321-4512",
          "321-4517",
          "321-4305",
          "321-4405",
          "321-4546",
          "321-4507",
          "321-4342",
          "321-4356",
          "321-4506",
          "321-4332",
          "321-4338",
          "321-4333",
          "321-4508",
          "321-4505",
          "321-4347",
          "321-4353",
          "321-4366",
          "321-4536",
          "321-4542",
          "321-4411",
          "321-4355",
          "321-4337",
          "321-4416",
          "321-4541",
          "321-4363",
          "321-4344",
          "321-4367",
          "321-4316",
          "321-4406",
          "321-4521",
          "321-4522",
          "321-4369",
          "321-4362",
          "321-4503",
          "321-4343",
          "321-4321",
          "321-4535",
          "321-4534",
          "321-4523",
          "321-4315",
          "321-4504",
          "321-4326",
          "321-4402",
          "321-4543",
          "321-4413",
          "321-4357",
          "321-4335",
          "321-4415",
          "321-4414",
          "321-4313",
          "321-4515",
          "321-4545",
          "321-4306",
          "321-4341",
          "321-4511",
          "321-4404",
          "321-4325",
          "321-4302",
          "321-4345",
          "321-4368",
          "321-4354",
          "321-4309",
          "321-4351",
          "321-4308",
          "321-4532",
          "321-4364",
          "321-4539",
          "321-4361",
          "321-4537",
          "321-4336",
          "321-4307",
          "321-4301",
          "321-4324",
          "321-4516",
          "321-4311",
          "321-4331",
          "321-4303",
          "321-4403",
          "321-4322",
          "321-4304",
          "321-4323",
          "321-4533",
          "321-4412",
          "321-4544",
          "321-4346",
          "321-4514",
          "321-4314",
          "321-4513",
          "321-4502",
          "321-4547",
          "321-4334",
          "321-4365",
          "321-4501",
          "321-4551",
          "321-4352",
          "321-4538",
          "324-0000",
          "324-0015",
          "324-0043",
          "324-0061",
          "324-0413",
          "324-0006",
          "324-0064",
          "324-0035",
          "324-0022",
          "324-0213",
          "324-0025",
          "324-0204",
          "324-0242",
          "324-0236",
          "324-0065",
          "324-0027",
          "324-0017",
          "324-0001",
          "324-0046",
          "324-0223",
          "324-0414",
          "324-0013",
          "324-0037",
          "324-0018",
          "324-0221",
          "324-0214",
          "324-0208",
          "324-0207",
          "324-0202",
          "324-0016",
          "324-0011",
          "324-0224",
          "324-0231",
          "324-0205",
          "324-0014",
          "324-0233",
          "324-0241",
          "324-0003",
          "324-0402",
          "324-0032",
          "324-0246",
          "324-0404",
          "324-0415",
          "324-0036",
          "324-0052",
          "324-0055",
          "324-0042",
          "324-0211",
          "324-0212",
          "324-0057",
          "324-0401",
          "324-0026",
          "324-0033",
          "324-0044",
          "324-0056",
          "324-0203",
          "324-0066",
          "324-0004",
          "324-0062",
          "324-0206",
          "324-0405",
          "324-0215",
          "324-0005",
          "324-0038",
          "324-0244",
          "324-0023",
          "324-0002",
          "324-0245",
          "324-0034",
          "324-0412",
          "324-0411",
          "324-0024",
          "324-0031",
          "324-0028",
          "324-0235",
          "324-0041",
          "324-0234",
          "324-0063",
          "324-0045",
          "324-0012",
          "324-0047",
          "324-0058",
          "324-0053",
          "324-0222",
          "324-0232",
          "324-0051",
          "324-0403",
          "324-0243",
          "324-0201",
          "324-0021",
          "324-0054",
          "329-2100",
          "329-2136",
          "329-2121",
          "329-1572",
          "329-1576",
          "329-2504",
          "329-2161",
          "329-1575",
          "329-1574",
          "329-2163",
          "329-1571",
          "329-2155",
          "329-2501",
          "329-2513",
          "329-2123",
          "329-2144",
          "329-2142",
          "329-2154",
          "329-2151",
          "329-1573",
          "329-1579",
          "329-2143",
          "329-2132",
          "329-2156",
          "329-2502",
          "329-2124",
          "329-2162",
          "329-2153",
          "329-2505",
          "329-2152",
          "329-2503",
          "329-1577",
          "329-2131",
          "329-2145",
          "329-2133",
          "329-2135",
          "329-2514",
          "329-2134",
          "329-2141",
          "329-2122",
          "329-2512",
          "329-2506",
          "329-2164",
          "329-2165",
          "329-2511",
          "329-1578",
          "325-0000",
          "325-0103",
          "329-2721",
          "329-2725",
          "325-0073",
          "325-0021",
          "329-2763",
          "329-2711",
          "325-0111",
          "329-2732",
          "329-2816",
          "329-2726",
          "329-3153",
          "329-3157",
          "329-2803",
          "329-2804",
          "325-0075",
          "329-2812",
          "329-3121",
          "325-0104",
          "329-2748",
          "325-0026",
          "329-3134",
          "329-2814",
          "329-3127",
          "329-2923",
          "329-3154",
          "329-2805",
          "325-0102",
          "329-3131",
          "329-3145",
          "329-2741",
          "325-0039",
          "329-2734",
          "329-3132",
          "329-3151",
          "325-0027",
          "325-0067",
          "325-0116",
          "329-3133",
          "325-0017",
          "325-0057",
          "325-0012",
          "329-2753",
          "325-0035",
          "325-0048",
          "325-0033",
          "325-0042",
          "329-3155",
          "329-3142",
          "329-2745",
          "329-3143",
          "329-3122",
          "329-3123",
          "329-2921",
          "325-0118",
          "329-3152",
          "325-0025",
          "329-2815",
          "329-2811",
          "329-2712",
          "329-3146",
          "325-0054",
          "329-2704",
          "325-0071",
          "325-0066",
          "325-0061",
          "325-0062",
          "329-2701",
          "329-2801",
          "329-2747",
          "325-0046",
          "329-2813",
          "325-0045",
          "325-0107",
          "329-2707",
          "329-2735",
          "325-0052",
          "329-2703",
          "325-0011",
          "325-0016",
          "325-0106",
          "325-0114",
          "325-0023",
          "325-0038",
          "325-0064",
          "325-0063",
          "325-0065",
          "325-0072",
          "325-0036",
          "329-3126",
          "329-2924",
          "329-2727",
          "325-0013",
          "325-0031",
          "329-2733",
          "329-2744",
          "329-2722",
          "325-0101",
          "329-2764",
          "325-0058",
          "329-2724",
          "329-2728",
          "325-0076",
          "329-2762",
          "329-2755",
          "329-2756",
          "329-2754",
          "329-2807",
          "329-3144",
          "325-0014",
          "325-0043",
          "329-3124",
          "325-0015",
          "329-2742",
          "329-2761",
          "329-3147",
          "329-2702",
          "325-0022",
          "325-0034",
          "329-2751",
          "325-0041",
          "329-2802",
          "329-2731",
          "329-3156",
          "325-0113",
          "325-0053",
          "325-0056",
          "329-3135",
          "329-3136",
          "325-0074",
          "329-2752",
          "329-2713",
          "329-2743",
          "329-2705",
          "329-2723",
          "325-0105",
          "325-0037",
          "325-0055",
          "329-3125",
          "329-2706",
          "325-0115",
          "325-0108",
          "329-3141",
          "325-0044",
          "325-0112",
          "325-0117",
          "325-0051",
          "329-2922",
          "329-2806",
          "329-2746",
          "325-0032",
          "325-0047",
          "325-0024",
          "329-1300",
          "329-1311",
          "329-1315",
          "329-1323",
          "329-1306",
          "329-1415",
          "329-1325",
          "329-1334",
          "329-1314",
          "329-1313",
          "329-1304",
          "329-1413",
          "329-1405",
          "329-1404",
          "329-1332",
          "329-1316",
          "329-1401",
          "329-1322",
          "329-1412",
          "329-1324",
          "329-1416",
          "329-1312",
          "329-1402",
          "329-1414",
          "329-1327",
          "329-1333",
          "329-1301",
          "329-1305",
          "329-1321",
          "329-1417",
          "329-1403",
          "329-1331",
          "329-1303",
          "329-1302",
          "329-1406",
          "329-1326",
          "329-1411",
          "321-0600",
          "321-0624",
          "321-0629",
          "321-0521",
          "321-0527",
          "321-0522",
          "321-0613",
          "321-0602",
          "321-0516",
          "321-0612",
          "321-0528",
          "321-0636",
          "321-0623",
          "321-0628",
          "321-0632",
          "321-0505",
          "321-0617",
          "321-0611",
          "321-0502",
          "321-0534",
          "321-0511",
          "321-0614",
          "321-0535",
          "321-0513",
          "321-0615",
          "321-0531",
          "321-0501",
          "321-0504",
          "321-0616",
          "321-0622",
          "321-0601",
          "321-0631",
          "321-0523",
          "321-0512",
          "321-0633",
          "321-0605",
          "321-0526",
          "321-0621",
          "321-0503",
          "321-0517",
          "321-0604",
          "321-0634",
          "321-0626",
          "321-0525",
          "321-0532",
          "321-0515",
          "321-0627",
          "321-0533",
          "321-0625",
          "321-0635",
          "321-0514",
          "321-0603",
          "321-0524",
          "321-0618",
          "329-0400",
          "329-0511",
          "323-0111",
          "329-0403",
          "329-0413",
          "329-0519",
          "323-0103",
          "329-0501",
          "329-0504",
          "329-0517",
          "323-0113",
          "323-0102",
          "329-0411",
          "329-0415",
          "329-0434",
          "323-0114",
          "329-0414",
          "329-0417",
          "329-0402",
          "323-0101",
          "329-0412",
          "329-0512",
          "329-0502",
          "329-0513",
          "323-0115",
          "329-0503",
          "329-0424",
          "323-0106",
          "329-0516",
          "329-0425",
          "323-0104",
          "329-0515",
          "329-0421",
          "329-0432",
          "329-0506",
          "323-0116",
          "329-0518",
          "323-0112",
          "329-0514",
          "329-0507",
          "323-0107",
          "329-0505",
          "329-0422",
          "329-0433",
          "329-0401",
          "329-0418",
          "323-0105",
          "329-0431",
          "329-0423",
          "329-0600",
          "329-0521",
          "329-0606",
          "329-0525",
          "329-0617",
          "329-0527",
          "329-0604",
          "329-0611",
          "329-0601",
          "329-0522",
          "329-0614",
          "329-0613",
          "329-0526",
          "329-0612",
          "329-0616",
          "329-0529",
          "329-0618",
          "329-0524",
          "329-0530",
          "329-0608",
          "329-0605",
          "329-0607",
          "329-0603",
          "329-0602",
          "329-0615",
          "329-0523",
          "329-0528",
          "321-4200",
          "321-4102",
          "321-4223",
          "321-4221",
          "321-4104",
          "321-4103",
          "321-4101",
          "321-4212",
          "321-4226",
          "321-4105",
          "321-4222",
          "321-4211",
          "321-4218",
          "321-4225",
          "321-4106",
          "321-4107",
          "321-4215",
          "321-4216",
          "321-4227",
          "321-4214",
          "321-4217",
          "321-4224",
          "321-4213",
          "321-3500",
          "321-3535",
          "321-3621",
          "321-3626",
          "321-3702",
          "321-3705",
          "321-3541",
          "321-3561",
          "321-3534",
          "321-3554",
          "321-3553",
          "321-3627",
          "321-3707",
          "321-3624",
          "321-3536",
          "321-3543",
          "321-3546",
          "321-3703",
          "321-3706",
          "321-3622",
          "321-3623",
          "321-3557",
          "321-3566",
          "321-3544",
          "321-3542",
          "321-3565",
          "321-3545",
          "321-3547",
          "321-3552",
          "321-3555",
          "321-3551",
          "321-3563",
          "311-4411",
          "321-3533",
          "321-3628",
          "321-3625",
          "321-3562",
          "321-3704",
          "321-3564",
          "321-3556",
          "321-3532",
          "321-3531",
          "321-3701",
          "321-3400",
          "321-3426",
          "321-3422",
          "321-3423",
          "321-3405",
          "321-3424",
          "321-3411",
          "321-3421",
          "321-3406",
          "321-3414",
          "321-3415",
          "321-3401",
          "321-3425",
          "321-3412",
          "321-3404",
          "321-3403",
          "321-3413",
          "321-3402",
          "321-3300",
          "321-3303",
          "321-3314",
          "321-3304",
          "321-3307",
          "321-3302",
          "321-3311",
          "321-3323",
          "321-3301",
          "321-3321",
          "321-3312",
          "321-3315",
          "321-3324",
          "321-3325",
          "321-3313",
          "321-3322",
          "321-3305",
          "321-3306",
          "321-3316",
          "321-0200",
          "321-0206",
          "321-0213",
          "321-0222",
          "321-0218",
          "321-0202",
          "321-0224",
          "321-0236",
          "321-0231",
          "321-0207",
          "321-0211",
          "321-0212",
          "321-0203",
          "321-0217",
          "321-0237",
          "321-0233",
          "321-0228",
          "321-0226",
          "321-0227",
          "321-0232",
          "321-0235",
          "321-0234",
          "321-0219",
          "321-0221",
          "321-0225",
          "321-0204",
          "321-0214",
          "321-0215",
          "321-0216",
          "321-0238",
          "321-0223",
          "321-0201",
          "321-0205",
          "329-0100",
          "329-0102",
          "329-0105",
          "329-0104",
          "329-0101",
          "329-0113",
          "329-0114",
          "329-0115",
          "329-0111",
          "329-0112",
          "329-0103",
          "329-2200",
          "329-2225",
          "329-2337",
          "329-2339",
          "329-2335",
          "329-2334",
          "329-2332",
          "329-2336",
          "329-2338",
          "329-2224",
          "321-2501",
          "329-2216",
          "329-2212",
          "329-2213",
          "329-2442",
          "329-2215",
          "329-2331",
          "329-2221",
          "329-2222",
          "329-2211",
          "329-2223",
          "329-2214",
          "329-2333",
          "329-2441",
          "329-2226",
          "329-1200",
          "329-1205",
          "329-1225",
          "329-1217",
          "329-1226",
          "329-1201",
          "329-1235",
          "329-1212",
          "329-1224",
          "329-1211",
          "329-1215",
          "329-1223",
          "329-1216",
          "329-1232",
          "329-1213",
          "329-1222",
          "329-1234",
          "329-1214",
          "329-1221",
          "329-1202",
          "329-1207",
          "329-1206",
          "329-1203",
          "329-1204",
          "329-1233",
          "329-1231",
          "329-3200",
          "329-3443",
          "329-3432",
          "329-3436",
          "329-3447",
          "329-3221",
          "329-3223",
          "329-3431",
          "329-3433",
          "325-0304",
          "325-0001",
          "325-0303",
          "325-0002",
          "325-0302",
          "329-3444",
          "325-0003",
          "329-3215",
          "329-3222",
          "329-3212",
          "329-3213",
          "329-3211",
          "329-3224",
          "329-3225",
          "329-3446",
          "329-3445",
          "329-3437",
          "329-3435",
          "329-3434",
          "325-0301",
          "329-3214",
          "329-3442",
          "329-3441",
          "324-0600",
          "324-0605",
          "324-0606",
          "324-0601",
          "324-0602",
          "324-0501",
          "324-0503",
          "324-0515",
          "324-0617",
          "324-0504",
          "324-0614",
          "324-0611",
          "324-0618",
          "324-0506",
          "324-0513",
          "324-0514",
          "324-0608",
          "324-0616",
          "324-0613",
          "324-0516",
          "324-0615",
          "324-0502",
          "324-0604",
          "324-0603",
          "324-0512",
          "324-0607",
          "324-0505",
          "324-0511",
          "324-0612",
          "371-0000",
          "370-3573",
          "371-0826",
          "371-0056",
          "371-0811",
          "371-0832",
          "371-0014",
          "379-2154",
          "371-0803",
          "371-0802",
          "379-2112",
          "379-2107",
          "379-2106",
          "371-0044",
          "379-2111",
          "370-3571",
          "371-0841",
          "371-0006",
          "379-2101",
          "371-0245",
          "379-2116",
          "371-0035",
          "379-2115",
          "371-0002",
          "371-0836",
          "371-0223",
          "371-0026",
          "371-0825",
          "371-0847",
          "371-0243",
          "371-0854",
          "371-0001",
          "379-2163",
          "371-0024",
          "371-0246",
          "371-0206",
          "371-0207",
          "371-0214",
          "371-0211",
          "371-0216",
          "371-0212",
          "371-0204",
          "371-0203",
          "371-0205",
          "371-0201",
          "371-0217",
          "371-0213",
          "371-0215",
          "371-0218",
          "371-0202",
          "371-0124",
          "371-0121",
          "370-3572",
          "371-0007",
          "379-2153",
          "371-0222",
          "371-0052",
          "371-0037",
          "371-0816",
          "371-0821",
          "379-2165",
          "371-0051",
          "379-2114",
          "371-0004",
          "379-2147",
          "371-0041",
          "371-0046",
          "371-0823",
          "371-0224",
          "379-2103",
          "371-0055",
          "370-3574",
          "379-2146",
          "371-0831",
          "371-0025",
          "371-0053",
          "371-0813",
          "371-0033",
          "371-0834",
          "371-0122",
          "379-2162",
          "371-0134",
          "371-0132",
          "379-2122",
          "379-2121",
          "379-2123",
          "371-0036",
          "379-2142",
          "371-0842",
          "379-2152",
          "379-2102",
          "371-0011",
          "379-2144",
          "371-0031",
          "371-0815",
          "371-0822",
          "379-2151",
          "371-0054",
          "379-2113",
          "371-0016",
          "371-0034",
          "371-0843",
          "371-0021",
          "371-0047",
          "371-0853",
          "371-0851",
          "371-0858",
          "371-0852",
          "371-0856",
          "371-0857",
          "371-0123",
          "371-0235",
          "371-0048",
          "371-0022",
          "371-0003",
          "379-2108",
          "379-2141",
          "371-0824",
          "379-2135",
          "371-0131",
          "379-2161",
          "371-0845",
          "371-0855",
          "371-0241",
          "379-2133",
          "371-0043",
          "379-2143",
          "379-2104",
          "371-0013",
          "379-2131",
          "371-0042",
          "379-2117",
          "371-0817",
          "379-2166",
          "371-0133",
          "371-0837",
          "371-0244",
          "371-0242",
          "379-2164",
          "379-2105",
          "371-0012",
          "371-0234",
          "379-2132",
          "371-0833",
          "371-0221",
          "371-0017",
          "371-0812",
          "371-0101",
          "371-0105",
          "371-0106",
          "371-0113",
          "371-0115",
          "371-0103",
          "371-0111",
          "371-0114",
          "371-0104",
          "371-0116",
          "371-0112",
          "371-0102",
          "371-0107",
          "371-0117",
          "371-0844",
          "371-0801",
          "371-0027",
          "379-2136",
          "371-0231",
          "371-0005",
          "371-0023",
          "371-0835",
          "371-0015",
          "371-0018",
          "371-0045",
          "371-0805",
          "371-0125",
          "371-0814",
          "371-0247",
          "371-0232",
          "371-0846",
          "371-0233",
          "379-2145",
          "379-2134",
          "371-0057",
          "371-0804",
          "371-0032",
          "370-0000",
          "370-0811",
          "370-0818",
          "370-1211",
          "370-0052",
          "370-3531",
          "370-0045",
          "370-0831",
          "370-0063",
          "370-0069",
          "370-0864",
          "370-3534",
          "370-0062",
          "370-0004",
          "370-0044",
          "370-1208",
          "370-0067",
          "370-3518",
          "370-0807",
          "370-0046",
          "370-0012",
          "370-0803",
          "370-0072",
          "370-0086",
          "370-0042",
          "370-0838",
          "370-0862",
          "370-0814",
          "370-0882",
          "370-3511",
          "370-3335",
          "370-0031",
          "370-0078",
          "370-0077",
          "370-3345",
          "370-0857",
          "370-0027",
          "370-0871",
          "370-0851",
          "370-0801",
          "370-3346",
          "370-0806",
          "370-0084",
          "370-0082",
          "370-0872",
          "370-0056",
          "370-3513",
          "370-0842",
          "370-1212",
          "370-0011",
          "370-0088",
          "370-0058",
          "370-1201",
          "370-3404",
          "370-3405",
          "370-3401",
          "370-3402",
          "370-3403",
          "370-1205",
          "370-0883",
          "370-3336",
          "370-0071",
          "370-0841",
          "370-0856",
          "370-0827",
          "370-0845",
          "370-0035",
          "370-0064",
          "370-0015",
          "370-0886",
          "370-0034",
          "370-0074",
          "370-0076",
          "370-0025",
          "370-3343",
          "370-0855",
          "370-0026",
          "370-0873",
          "370-0853",
          "370-0854",
          "370-3342",
          "370-0837",
          "370-0846",
          "370-3331",
          "370-0032",
          "370-0022",
          "370-0008",
          "370-0068",
          "370-3332",
          "370-0825",
          "370-0866",
          "370-0821",
          "370-0054",
          "370-0833",
          "370-0003",
          "370-0018",
          "370-1301",
          "370-0065",
          "370-3522",
          "370-0832",
          "370-0804",
          "370-0817",
          "370-1206",
          "370-0805",
          "370-0047",
          "370-0043",
          "370-3333",
          "370-0829",
          "370-0835",
          "370-0824",
          "370-3515",
          "370-0075",
          "370-0059",
          "370-0848",
          "370-0865",
          "370-0061",
          "370-3516",
          "370-0053",
          "370-0816",
          "370-0006",
          "370-0007",
          "370-3524",
          "370-0852",
          "370-0033",
          "370-0001",
          "370-0823",
          "370-3532",
          "370-3344",
          "370-0023",
          "370-0874",
          "370-3347",
          "370-0802",
          "370-0812",
          "370-3512",
          "370-0017",
          "370-0021",
          "370-0048",
          "370-1214",
          "370-0867",
          "370-0013",
          "370-0868",
          "370-0081",
          "370-0005",
          "370-3348",
          "370-3341",
          "370-0041",
          "370-3514",
          "370-1204",
          "370-3517",
          "370-0863",
          "370-0002",
          "370-0839",
          "370-3519",
          "370-3523",
          "370-0875",
          "370-0843",
          "370-3533",
          "370-3334",
          "370-0881",
          "370-3102",
          "370-3101",
          "370-3114",
          "370-3104",
          "370-3103",
          "370-3117",
          "370-3112",
          "370-3115",
          "370-3111",
          "370-3105",
          "370-3106",
          "370-3113",
          "370-3107",
          "370-3116",
          "370-3337",
          "370-3525",
          "370-0073",
          "370-0083",
          "370-0036",
          "370-0834",
          "370-3338",
          "370-1202",
          "370-0828",
          "370-3521",
          "370-0057",
          "370-0014",
          "370-0813",
          "370-0849",
          "370-0016",
          "370-0861",
          "370-1203",
          "370-0815",
          "370-0066",
          "370-1213",
          "370-0024",
          "370-0884",
          "370-0051",
          "370-2107",
          "370-2114",
          "370-2103",
          "370-2131",
          "370-2125",
          "370-2111",
          "370-2135",
          "370-2139",
          "370-2112",
          "370-2102",
          "370-2136",
          "370-2137",
          "370-2124",
          "370-2134",
          "370-2138",
          "370-2121",
          "370-2123",
          "370-2115",
          "370-2122",
          "370-2116",
          "370-2105",
          "370-2127",
          "370-2101",
          "370-2126",
          "370-2113",
          "370-2128",
          "370-2104",
          "370-2106",
          "370-2132",
          "370-2133",
          "370-0819",
          "370-0822",
          "370-0055",
          "370-0087",
          "370-0826",
          "370-0885",
          "370-0836",
          "370-0085",
          "370-0844",
          "370-1207",
          "370-0847",
          "376-0000",
          "376-0011",
          "376-0037",
          "376-0032",
          "376-0033",
          "376-0022",
          "376-0601",
          "376-0044",
          "376-0024",
          "376-0041",
          "376-0036",
          "376-0026",
          "376-0145",
          "376-0144",
          "376-0143",
          "376-0141",
          "376-0142",
          "376-0004",
          "376-0043",
          "376-0003",
          "376-0002",
          "376-0012",
          "376-0006",
          "376-0045",
          "376-0038",
          "376-0042",
          "376-0052",
          "376-0021",
          "376-0035",
          "376-0137",
          "376-0136",
          "376-0133",
          "376-0131",
          "376-0124",
          "376-0134",
          "376-0135",
          "376-0123",
          "376-0132",
          "376-0121",
          "376-0122",
          "376-0125",
          "376-0023",
          "376-0054",
          "376-0007",
          "376-0034",
          "376-0053",
          "376-0001",
          "376-0051",
          "376-0013",
          "376-0014",
          "376-0031",
          "376-0025",
          "376-0046",
          "376-0056",
          "376-0005",
          "376-0027",
          "376-0055",
          "372-0000",
          "379-2201",
          "379-2215",
          "379-2202",
          "379-2231",
          "372-0821",
          "372-0007",
          "372-0854",
          "379-2217",
          "379-2211",
          "372-0804",
          "372-0005",
          "372-0031",
          "372-0823",
          "372-0006",
          "372-0048",
          "372-0015",
          "372-0023",
          "372-0045",
          "372-0013",
          "372-0021",
          "379-2225",
          "372-0851",
          "372-0032",
          "372-0056",
          "379-2221",
          "372-0055",
          "372-0003",
          "372-0843",
          "379-2232",
          "379-2206",
          "372-0853",
          "372-0052",
          "379-2213",
          "370-0124",
          "370-0123",
          "370-0105",
          "370-0135",
          "370-0121",
          "370-0127",
          "370-0102",
          "370-0111",
          "370-0104",
          "370-0122",
          "370-0134",
          "370-0126",
          "370-0103",
          "370-0114",
          "370-0117",
          "370-0116",
          "370-0133",
          "370-0112",
          "370-0125",
          "370-0101",
          "370-0132",
          "370-0128",
          "370-0113",
          "370-0115",
          "370-0131",
          "372-0831",
          "372-0046",
          "372-0011",
          "372-0824",
          "372-0024",
          "372-0852",
          "379-2214",
          "372-0014",
          "372-0038",
          "372-0057",
          "372-0841",
          "372-0802",
          "372-0814",
          "379-2222",
          "372-0042",
          "372-0004",
          "372-0002",
          "372-0817",
          "372-0818",
          "372-0812",
          "372-0833",
          "372-0825",
          "372-0012",
          "372-0822",
          "372-0855",
          "379-2224",
          "372-0816",
          "379-2204",
          "372-0058",
          "379-2216",
          "372-0813",
          "379-2205",
          "372-0844",
          "372-0001",
          "379-2236",
          "379-2234",
          "372-0815",
          "372-0025",
          "372-0022",
          "379-2233",
          "372-0039",
          "372-0826",
          "372-0041",
          "372-0834",
          "379-2212",
          "372-0016",
          "372-0047",
          "379-2203",
          "372-0842",
          "372-0043",
          "372-0033",
          "379-2235",
          "372-0037",
          "372-0801",
          "372-0803",
          "372-0026",
          "372-0053",
          "372-0034",
          "372-0036",
          "372-0044",
          "372-0827",
          "372-0054",
          "372-0051",
          "372-0832",
          "372-0811",
          "373-0000",
          "370-0402",
          "373-0814",
          "373-0852",
          "370-0422",
          "373-0851",
          "373-0817",
          "373-0007",
          "373-0808",
          "373-0845",
          "373-0013",
          "370-0424",
          "373-0841",
          "370-0403",
          "373-0014",
          "373-0833",
          "373-0813",
          "379-2306",
          "373-0055",
          "370-0423",
          "379-2304",
          "373-0075",
          "373-0045",
          "373-0804",
          "370-0405",
          "370-0401",
          "370-0421",
          "373-0027",
          "373-0074",
          "373-0024",
          "373-0044",
          "370-0411",
          "373-0003",
          "373-0012",
          "373-0025",
          "373-0004",
          "370-0427",
          "373-0818",
          "373-0807",
          "373-0844",
          "373-0821",
          "373-0038",
          "373-0822",
          "373-0037",
          "373-0862",
          "373-0002",
          "370-0413",
          "373-0028",
          "370-0426",
          "370-0412",
          "373-0801",
          "373-0072",
          "373-0825",
          "373-0828",
          "373-0827",
          "373-0829",
          "373-0824",
          "373-0042",
          "373-0011",
          "373-0008",
          "373-0052",
          "373-0051",
          "370-0425",
          "373-0832",
          "373-0023",
          "373-0053",
          "373-0061",
          "373-0062",
          "373-0063",
          "373-0846",
          "373-0054",
          "373-0006",
          "373-0819",
          "373-0032",
          "373-0847",
          "373-0001",
          "373-0043",
          "373-0033",
          "373-0823",
          "370-0331",
          "370-0304",
          "370-0314",
          "370-0306",
          "370-0351",
          "370-0347",
          "370-0341",
          "370-0352",
          "370-0342",
          "370-0346",
          "370-0353",
          "370-0321",
          "370-0303",
          "370-0302",
          "370-0355",
          "370-0333",
          "370-0343",
          "370-0313",
          "370-0334",
          "370-0305",
          "370-0354",
          "370-0301",
          "370-0332",
          "370-0356",
          "370-0345",
          "370-0344",
          "370-0311",
          "370-0312",
          "373-0029",
          "373-0056",
          "373-0853",
          "373-0071",
          "373-0021",
          "373-0022",
          "373-0015",
          "373-0812",
          "373-0815",
          "373-0026",
          "373-0816",
          "370-0404",
          "373-0831",
          "373-0034",
          "373-0035",
          "370-0417",
          "373-0826",
          "373-0041",
          "373-0842",
          "370-0414",
          "373-0057",
          "370-0406",
          "370-0416",
          "373-0018",
          "373-0073",
          "370-0415",
          "373-0861",
          "370-0418",
          "373-0809",
          "373-0805",
          "373-0811",
          "373-0016",
          "373-0803",
          "373-0802",
          "379-2301",
          "379-2302",
          "373-0036",
          "373-0019",
          "373-0843",
          "379-2303",
          "373-0806",
          "379-2305",
          "373-0031",
          "378-0000",
          "378-0076",
          "378-0077",
          "378-0035",
          "378-0025",
          "378-0021",
          "378-0031",
          "378-0068",
          "378-0067",
          "378-0061",
          "378-0034",
          "378-0018",
          "378-0026",
          "378-0003",
          "378-0011",
          "378-0047",
          "378-0051",
          "378-0071",
          "378-0005",
          "378-0045",
          "378-0014",
          "378-0052",
          "378-0023",
          "378-0078",
          "378-0016",
          "378-0024",
          "378-0004",
          "378-0063",
          "378-0044",
          "378-0074",
          "378-0033",
          "378-0123",
          "378-0124",
          "378-0126",
          "378-0127",
          "378-0121",
          "378-0122",
          "378-0125",
          "378-0013",
          "378-0032",
          "378-0064",
          "378-0056",
          "378-0015",
          "378-0001",
          "378-0314",
          "378-0305",
          "378-0326",
          "378-0322",
          "378-0323",
          "378-0304",
          "378-0303",
          "378-0307",
          "378-0311",
          "378-0315",
          "378-0324",
          "378-0321",
          "378-0317",
          "378-0302",
          "378-0316",
          "378-0312",
          "378-0313",
          "378-0306",
          "378-0301",
          "378-0325",
          "378-0072",
          "378-0048",
          "378-0075",
          "378-0042",
          "378-0054",
          "378-0012",
          "378-0046",
          "378-0066",
          "378-0041",
          "378-0043",
          "378-0053",
          "378-0017",
          "378-0073",
          "378-0065",
          "378-0062",
          "378-0022",
          "378-0055",
          "378-0002",
          "374-0000",
          "374-0035",
          "374-0053",
          "374-0013",
          "374-0014",
          "374-0063",
          "374-0073",
          "374-0045",
          "374-0066",
          "374-0001",
          "374-0072",
          "374-0023",
          "374-0054",
          "374-0067",
          "374-0019",
          "374-0022",
          "374-0015",
          "374-0079",
          "374-0046",
          "374-0057",
          "374-0077",
          "374-0004",
          "374-0037",
          "374-0042",
          "374-0052",
          "374-0069",
          "374-0071",
          "374-0044",
          "374-0018",
          "374-0051",
          "374-0026",
          "374-0036",
          "374-0021",
          "374-0064",
          "374-0068",
          "374-0074",
          "374-0002",
          "374-0009",
          "374-0028",
          "374-0017",
          "374-0006",
          "374-0043",
          "374-0029",
          "374-0055",
          "374-0075",
          "374-0065",
          "374-0038",
          "374-0047",
          "374-0005",
          "374-0012",
          "374-0011",
          "374-0061",
          "374-0031",
          "374-0076",
          "374-0062",
          "374-0041",
          "374-0027",
          "374-0034",
          "374-0078",
          "374-0008",
          "374-0033",
          "374-0024",
          "374-0056",
          "374-0016",
          "374-0039",
          "374-0025",
          "374-0032",
          "374-0003",
          "374-0007",
          "377-0000",
          "379-1122",
          "379-1125",
          "379-1111",
          "379-1105",
          "379-1114",
          "379-1104",
          "379-1124",
          "379-1101",
          "379-1127",
          "379-1103",
          "379-1102",
          "379-1115",
          "379-1123",
          "379-1113",
          "379-1126",
          "379-1121",
          "379-1112",
          "379-1116",
          "377-0031",
          "377-0005",
          "377-0102",
          "377-0103",
          "377-0101",
          "377-0007",
          "377-0024",
          "377-0312",
          "377-0027",
          "377-0201",
          "377-0025",
          "377-0205",
          "377-0008",
          "377-0204",
          "377-0202",
          "377-0002",
          "377-0026",
          "377-0004",
          "377-0203",
          "377-0051",
          "377-0055",
          "377-0052",
          "377-0065",
          "377-0054",
          "377-0061",
          "377-0053",
          "377-0064",
          "377-0063",
          "377-0062",
          "377-0006",
          "377-0311",
          "377-0003",
          "377-0206",
          "375-0000",
          "375-0042",
          "375-0034",
          "375-0011",
          "370-1401",
          "375-0045",
          "375-0054",
          "375-0057",
          "375-0016",
          "375-0013",
          "375-0047",
          "375-0033",
          "375-0021",
          "370-1404",
          "370-1405",
          "375-0037",
          "375-0017",
          "375-0052",
          "375-0014",
          "375-0012",
          "375-0046",
          "370-1406",
          "375-0055",
          "375-0032",
          "375-0036",
          "375-0002",
          "375-0003",
          "375-0005",
          "375-0053",
          "375-0015",
          "375-0001",
          "375-0044",
          "375-0022",
          "375-0043",
          "375-0024",
          "375-0035",
          "370-1403",
          "375-0023",
          "375-0056",
          "375-0041",
          "375-0051",
          "375-0004",
          "375-0006",
          "375-0031",
          "370-1402",
          "370-2300",
          "370-2306",
          "370-2452",
          "370-2322",
          "370-2451",
          "370-2335",
          "370-2321",
          "370-2466",
          "370-2455",
          "370-2345",
          "370-2456",
          "370-2317",
          "370-2334",
          "370-2461",
          "370-2463",
          "370-2313",
          "370-2344",
          "370-2301",
          "370-2304",
          "370-2302",
          "370-2341",
          "370-2311",
          "370-2332",
          "370-2462",
          "370-2305",
          "370-2315",
          "370-2331",
          "370-2314",
          "370-2454",
          "370-2316",
          "370-2465",
          "370-2333",
          "370-2343",
          "370-2464",
          "370-2323",
          "370-2467",
          "370-2307",
          "370-2342",
          "370-2312",
          "370-2324",
          "370-2453",
          "379-0202",
          "370-2411",
          "379-0205",
          "370-2412",
          "379-0208",
          "379-0203",
          "379-0206",
          "379-0204",
          "379-0207",
          "379-0201",
          "379-0209",
          "370-2413",
          "370-2303",
          "379-0100",
          "379-0109",
          "379-0116",
          "379-0127",
          "379-0111",
          "379-0112",
          "379-0121",
          "379-0113",
          "379-0105",
          "379-0108",
          "379-0123",
          "379-0135",
          "379-0132",
          "379-0124",
          "379-0104",
          "379-0129",
          "379-0106",
          "379-0122",
          "379-0103",
          "379-0107",
          "379-0115",
          "379-0125",
          "379-0101",
          "379-0126",
          "379-0114",
          "379-0133",
          "379-0102",
          "379-0128",
          "379-0131",
          "379-0216",
          "379-0305",
          "379-0226",
          "379-0213",
          "379-0211",
          "379-0304",
          "379-0214",
          "379-0302",
          "379-0307",
          "379-0212",
          "379-0215",
          "389-0121",
          "379-0221",
          "379-0223",
          "379-0303",
          "379-0306",
          "379-0217",
          "379-0224",
          "379-0222",
          "379-0225",
          "379-0301",
          "379-0136",
          "379-0134",
          "376-0100",
          "376-0306",
          "376-0302",
          "376-0304",
          "376-0308",
          "376-0303",
          "376-0305",
          "376-0301",
          "376-0307",
          "376-0114",
          "376-0101",
          "376-0111",
          "376-0104",
          "376-0102",
          "376-0116",
          "376-0115",
          "376-0103",
          "376-0113",
          "376-0112",
          "379-2311",
          "379-2312",
          "379-2314",
          "379-2313",
          "370-3500",
          "370-3503",
          "370-3505",
          "370-3501",
          "370-3504",
          "370-3502",
          "370-3600",
          "370-3601",
          "370-3602",
          "370-3607",
          "370-3606",
          "370-3605",
          "370-3608",
          "370-3603",
          "370-3604",
          "370-1600",
          "370-1616",
          "370-1615",
          "370-1613",
          "370-1614",
          "370-1617",
          "370-1611",
          "370-1612",
          "370-1511",
          "370-1512",
          "370-1502",
          "370-1604",
          "370-1602",
          "370-1501",
          "370-1506",
          "370-1513",
          "370-1514",
          "370-1503",
          "370-1515",
          "370-1603",
          "370-1504",
          "370-1505",
          "370-1601",
          "370-2600",
          "370-2611",
          "370-2613",
          "370-2614",
          "370-2621",
          "370-2606",
          "370-2605",
          "370-2623",
          "370-2616",
          "370-2601",
          "370-2622",
          "370-2627",
          "370-2602",
          "370-2624",
          "370-2612",
          "370-2603",
          "370-2626",
          "370-2615",
          "370-2625",
          "370-2604",
          "370-2800",
          "370-2804",
          "370-2801",
          "370-2812",
          "370-2806",
          "370-2802",
          "370-2815",
          "370-2803",
          "370-2813",
          "370-2814",
          "370-2805",
          "370-2816",
          "370-2811",
          "370-2200",
          "370-2204",
          "370-2217",
          "370-2201",
          "370-2211",
          "370-2202",
          "370-2216",
          "370-2205",
          "370-2213",
          "370-2206",
          "370-2215",
          "370-2203",
          "370-2214",
          "370-2212",
          "377-0400",
          "377-0422",
          "377-1311",
          "377-0417",
          "377-0416",
          "377-0423",
          "377-0421",
          "377-1701",
          "377-0431",
          "377-1703",
          "377-0413",
          "377-0544",
          "377-0433",
          "377-0541",
          "377-1704",
          "377-0432",
          "377-0601",
          "377-0542",
          "377-0411",
          "377-0414",
          "377-0412",
          "377-0424",
          "377-1702",
          "377-0425",
          "377-1312",
          "377-0543",
          "377-0434",
          "377-0415",
          "377-1300",
          "377-1310",
          "377-1411",
          "377-1308",
          "377-1301",
          "377-1302",
          "377-1412",
          "377-1304",
          "377-1307",
          "377-1309",
          "377-1306",
          "377-1305",
          "377-1303",
          "377-1500",
          "377-1523",
          "377-1521",
          "377-1613",
          "377-1512",
          "377-1612",
          "377-1527",
          "377-1403",
          "377-1404",
          "377-1401",
          "377-1402",
          "377-1616",
          "377-1617",
          "384-0097",
          "377-1615",
          "377-1405",
          "377-1524",
          "377-1525",
          "377-1614",
          "377-1522",
          "377-1528",
          "377-1611",
          "377-1526",
          "377-1700",
          "377-1711",
          "377-1712",
          "377-0700",
          "377-0701",
          "377-0702",
          "377-0800",
          "377-0812",
          "377-0303",
          "370-3321",
          "377-0807",
          "377-0804",
          "377-0815",
          "377-0805",
          "377-0935",
          "377-0931",
          "370-3311",
          "377-0302",
          "377-0304",
          "377-0803",
          "370-3322",
          "377-0802",
          "377-0806",
          "377-0811",
          "377-0305",
          "377-0934",
          "377-0932",
          "377-0301",
          "377-0801",
          "377-0814",
          "377-0813",
          "377-0933",
          "377-0816",
          "378-0400",
          "378-0415",
          "378-0413",
          "378-0405",
          "378-0401",
          "378-0403",
          "378-0406",
          "378-0404",
          "378-0412",
          "378-0411",
          "378-0407",
          "378-0408",
          "378-0409",
          "378-0414",
          "378-0402",
          "378-0100",
          "378-0104",
          "378-0102",
          "378-0105",
          "378-0112",
          "378-0114",
          "378-0103",
          "378-0113",
          "378-0111",
          "378-0115",
          "378-0101",
          "379-1200",
          "379-1207",
          "379-1203",
          "379-1201",
          "379-1202",
          "379-1205",
          "379-1206",
          "379-1204",
          "379-1300",
          "379-1404",
          "379-1618",
          "379-1411",
          "379-1723",
          "379-1311",
          "379-1416",
          "379-1727",
          "379-1302",
          "379-1312",
          "379-1612",
          "379-1611",
          "379-1315",
          "379-1303",
          "379-1616",
          "379-1726",
          "379-1305",
          "379-1615",
          "379-1403",
          "379-1314",
          "379-1304",
          "379-1418",
          "379-1613",
          "379-1619",
          "379-1313",
          "379-1725",
          "379-1614",
          "379-1401",
          "379-1301",
          "379-1415",
          "379-1412",
          "379-1417",
          "379-1402",
          "379-1721",
          "379-1414",
          "379-1308",
          "379-1307",
          "379-1724",
          "379-1306",
          "379-1413",
          "379-1409",
          "379-1617",
          "379-1728",
          "379-1722",
          "379-1601",
          "370-1100",
          "370-1116",
          "370-1102",
          "370-1135",
          "370-1126",
          "370-1121",
          "370-1133",
          "370-1127",
          "370-1104",
          "370-1122",
          "370-1117",
          "370-1114",
          "370-1128",
          "370-1115",
          "370-1131",
          "370-1132",
          "370-1112",
          "370-1123",
          "370-1124",
          "370-1111",
          "370-1113",
          "370-1103",
          "370-1105",
          "370-1101",
          "370-1125",
          "370-1134",
          "374-0100",
          "374-0112",
          "374-0123",
          "374-0113",
          "374-0132",
          "374-0133",
          "374-0135",
          "374-0111",
          "374-0131",
          "374-0122",
          "374-0104",
          "374-0105",
          "374-0121",
          "374-0107",
          "374-0106",
          "374-0102",
          "374-0103",
          "374-0134",
          "374-0101",
          "370-0700",
          "370-0711",
          "370-0714",
          "370-0706",
          "370-0715",
          "370-0718",
          "370-0702",
          "370-0716",
          "370-0703",
          "370-0717",
          "370-0705",
          "370-0707",
          "370-0704",
          "370-0713",
          "370-0708",
          "370-0701",
          "370-0712",
          "370-0500",
          "370-0503",
          "370-0506",
          "370-0726",
          "370-0725",
          "370-0722",
          "370-0721",
          "370-0724",
          "370-0723",
          "370-0505",
          "370-0727",
          "370-0502",
          "370-0501",
          "370-0504",
          "370-0507",
          "370-0514",
          "370-0531",
          "370-0534",
          "370-0512",
          "370-0511",
          "370-0524",
          "370-0532",
          "370-0515",
          "370-0518",
          "370-0521",
          "370-0533",
          "370-0516",
          "370-0517",
          "370-0513",
          "370-0525",
          "370-0522",
          "370-0536",
          "370-0523",
          "370-0535",
          "370-0600",
          "370-0614",
          "370-0606",
          "370-0602",
          "370-0604",
          "370-0601",
          "370-0611",
          "370-0616",
          "370-0615",
          "370-0612",
          "370-0603",
          "370-0605",
          "370-0613",
          "331-0000",
          "331-0058",
          "331-0068",
          "331-0053",
          "331-0067",
          "331-0045",
          "331-0047",
          "331-0076",
          "331-0073",
          "331-0064",
          "331-0056",
          "331-0054",
          "331-0055",
          "331-0048",
          "331-0071",
          "331-0066",
          "331-0060",
          "331-0062",
          "331-0077",
          "331-0057",
          "331-0061",
          "331-0049",
          "331-0078",
          "331-0072",
          "331-0065",
          "331-0063",
          "331-0074",
          "331-0059",
          "331-0075",
          "331-0052",
          "331-0046",
          "331-0069",
          "331-0800",
          "331-0813",
          "331-0815",
          "331-0824",
          "331-0825",
          "331-0801",
          "331-0804",
          "331-0822",
          "331-0823",
          "331-0814",
          "331-0821",
          "331-0802",
          "331-0805",
          "331-0803",
          "331-0812",
          "331-0811",
          "330-0800",
          "330-0841",
          "330-0834",
          "330-0852",
          "330-0836",
          "330-0855",
          "330-0843",
          "330-0835",
          "330-0851",
          "330-0854",
          "330-0844",
          "330-0805",
          "330-0842",
          "330-0846",
          "330-0803",
          "330-0801",
          "330-0845",
          "330-0853",
          "330-0804",
          "330-0856",
          "330-0802",
          "337-0000",
          "337-0014",
          "337-0053",
          "337-0004",
          "337-0022",
          "337-0027",
          "337-0024",
          "337-0023",
          "337-0044",
          "337-0005",
          "337-0031",
          "337-0006",
          "337-0045",
          "337-0054",
          "337-0026",
          "337-0043",
          "337-0013",
          "337-0035",
          "337-0034",
          "337-0015",
          "337-0008",
          "337-0002",
          "337-0032",
          "337-0051",
          "337-0012",
          "337-0016",
          "337-0021",
          "337-0003",
          "337-0017",
          "337-0052",
          "337-0001",
          "337-0007",
          "337-0033",
          "337-0042",
          "337-0041",
          "337-0011",
          "337-0036",
          "337-0025",
          "330-0000",
          "338-0014",
          "338-0007",
          "338-0012",
          "338-0001",
          "338-0005",
          "338-0002",
          "330-0081",
          "330-6090",
          "330-6001",
          "330-6002",
          "330-6003",
          "330-6004",
          "330-6005",
          "330-6006",
          "330-6007",
          "330-6008",
          "330-6009",
          "330-6010",
          "330-6011",
          "330-6012",
          "330-6013",
          "330-6014",
          "330-6015",
          "330-6016",
          "330-6017",
          "330-6018",
          "330-6019",
          "330-6020",
          "330-6021",
          "330-6022",
          "330-6023",
          "330-6024",
          "330-6025",
          "330-6026",
          "330-6027",
          "330-6028",
          "330-6029",
          "330-6030",
          "330-6031",
          "330-6032",
          "330-6033",
          "330-6034",
          "330-6035",
          "338-0011",
          "338-0013",
          "338-0006",
          "338-0004",
          "338-0003",
          "338-0800",
          "338-0826",
          "338-0824",
          "338-0815",
          "338-0813",
          "338-0823",
          "338-0833",
          "338-0834",
          "338-0825",
          "338-0814",
          "338-0817",
          "338-0811",
          "338-0812",
          "338-0837",
          "338-0816",
          "338-0835",
          "338-0822",
          "338-0832",
          "338-0836",
          "338-0831",
          "338-0821",
          "330-0046",
          "330-0071",
          "330-0042",
          "330-0064",
          "330-0074",
          "330-0045",
          "330-0051",
          "330-0065",
          "330-0044",
          "330-0043",
          "330-0063",
          "330-0061",
          "330-0062",
          "330-0075",
          "330-0054",
          "330-0055",
          "330-0056",
          "330-0053",
          "330-0041",
          "330-0073",
          "330-0052",
          "330-0072",
          "336-0000",
          "336-0034",
          "336-0043",
          "336-0042",
          "336-0016",
          "336-0031",
          "336-0022",
          "336-0023",
          "336-0038",
          "336-0015",
          "336-0026",
          "336-0036",
          "336-0027",
          "336-0024",
          "336-0041",
          "336-0025",
          "336-0021",
          "336-0033",
          "336-0035",
          "336-0017",
          "336-0018",
          "336-0032",
          "336-0900",
          "336-0921",
          "336-0974",
          "336-0922",
          "336-0923",
          "336-0934",
          "336-0977",
          "336-0966",
          "336-0961",
          "336-0907",
          "336-0917",
          "336-0962",
          "336-0925",
          "336-0913",
          "336-0936",
          "336-0905",
          "336-0963",
          "336-0975",
          "336-0971",
          "336-0976",
          "336-0932",
          "336-0972",
          "336-0973",
          "336-0924",
          "336-0931",
          "336-0912",
          "336-0926",
          "336-0964",
          "336-0918",
          "336-0965",
          "336-0906",
          "336-0967",
          "336-0915",
          "336-0911",
          "336-0914",
          "336-0916",
          "336-0903",
          "339-0000",
          "339-0071",
          "339-0066",
          "339-0031",
          "339-0061",
          "339-0073",
          "339-0037",
          "339-0002",
          "339-0013",
          "339-0052",
          "339-0014",
          "339-0018",
          "339-0017",
          "339-0015",
          "339-0027",
          "339-0026",
          "339-0008",
          "339-0024",
          "339-0025",
          "339-0056",
          "339-0078",
          "339-0045",
          "339-0075",
          "339-0001",
          "339-0006",
          "339-0033",
          "339-0072",
          "339-0003",
          "339-0034",
          "339-0035",
          "339-0009",
          "339-0043",
          "339-0053",
          "339-0044",
          "339-0021",
          "339-0007",
          "339-0022",
          "339-0004",
          "339-0054",
          "339-0011",
          "339-0068",
          "339-0016",
          "339-0081",
          "339-0082",
          "339-0067",
          "339-0023",
          "339-0047",
          "339-0005",
          "339-0055",
          "339-0064",
          "339-0042",
          "339-0076",
          "339-0074",
          "339-0057",
          "339-0058",
          "339-0077",
          "339-0012",
          "339-0028",
          "339-0032",
          "339-0062",
          "339-0051",
          "339-0069",
          "339-0065",
          "339-0063",
          "339-0041",
          "339-0046",
          "339-0036",
          "350-1100",
          "350-1173",
          "350-1164",
          "350-1126",
          "350-0806",
          "350-1125",
          "350-1124",
          "350-1171",
          "350-0855",
          "350-0837",
          "350-0835",
          "350-0824",
          "350-0026",
          "350-1108",
          "350-1144",
          "350-0015",
          "350-1105",
          "350-1151",
          "350-0017",
          "350-0816",
          "350-0817",
          "350-1134",
          "350-0032",
          "350-1128",
          "350-1129",
          "350-1161",
          "350-1178",
          "350-0057",
          "350-0021",
          "350-1168",
          "350-1167",
          "350-1104",
          "350-0841",
          "350-0012",
          "350-1175",
          "350-1179",
          "350-1103",
          "350-1109",
          "350-1174",
          "350-0845",
          "350-1135",
          "350-0826",
          "350-1112",
          "350-1154",
          "350-0844",
          "350-0852",
          "350-1176",
          "350-1177",
          "350-1132",
          "350-1131",
          "350-0842",
          "350-0061",
          "350-0016",
          "350-0011",
          "350-0815",
          "350-0809",
          "350-0055",
          "350-1146",
          "350-0053",
          "350-1117",
          "350-0031",
          "350-0036",
          "350-0811",
          "350-1116",
          "350-0022",
          "350-1106",
          "350-0063",
          "350-0803",
          "350-0054",
          "350-0067",
          "350-0834",
          "350-0051",
          "350-0013",
          "350-1145",
          "350-1155",
          "350-0848",
          "350-0812",
          "350-1136",
          "350-0804",
          "350-1153",
          "350-0853",
          "350-0043",
          "350-0823",
          "350-0064",
          "350-0832",
          "350-0046",
          "350-1133",
          "350-1152",
          "350-1137",
          "350-1147",
          "350-0034",
          "350-0004",
          "350-0801",
          "350-1113",
          "350-0825",
          "350-0854",
          "350-1141",
          "350-0827",
          "350-0843",
          "350-0044",
          "350-1119",
          "350-1110",
          "350-1118",
          "350-0856",
          "350-0846",
          "350-1159",
          "350-1150",
          "350-1138",
          "350-0065",
          "350-0042",
          "350-1156",
          "350-1157",
          "350-0023",
          "350-0024",
          "350-0025",
          "350-0035",
          "350-1160",
          "350-1111",
          "350-1115",
          "350-0851",
          "350-1114",
          "350-0847",
          "350-0814",
          "350-0813",
          "350-0805",
          "350-0831",
          "350-0821",
          "350-0018",
          "350-1166",
          "350-1142",
          "350-0802",
          "350-0033",
          "350-1143",
          "350-0014",
          "350-0001",
          "350-0002",
          "350-1172",
          "350-0056",
          "350-0857",
          "350-1101",
          "350-1107",
          "350-1102",
          "350-1162",
          "350-0027",
          "350-1165",
          "350-0045",
          "350-0052",
          "350-0838",
          "350-1170",
          "350-1158",
          "350-0062",
          "350-0003",
          "350-0836",
          "350-1169",
          "350-0822",
          "350-0807",
          "350-0808",
          "350-0833",
          "350-1163",
          "350-0066",
          "350-0041",
          "350-1121",
          "350-1123",
          "350-1122",
          "360-0000",
          "369-0106",
          "360-0826",
          "360-0033",
          "360-0231",
          "360-0011",
          "360-0816",
          "360-0821",
          "360-0105",
          "360-0236",
          "360-0005",
          "360-0212",
          "360-0823",
          "360-0813",
          "360-0103",
          "360-0835",
          "360-0025",
          "360-0002",
          "360-0221",
          "360-0812",
          "360-0111",
          "360-0017",
          "360-0242",
          "360-0803",
          "360-0847",
          "369-0104",
          "360-0046",
          "360-0234",
          "360-0125",
          "360-0004",
          "360-0117",
          "360-0213",
          "360-0001",
          "360-0805",
          "360-0217",
          "360-0012",
          "360-0837",
          "360-0035",
          "360-0136",
          "360-0032",
          "360-0026",
          "360-0222",
          "360-0131",
          "360-0831",
          "360-0016",
          "360-0122",
          "360-0015",
          "360-0114",
          "360-0832",
          "369-0103",
          "360-0036",
          "360-0814",
          "360-0023",
          "360-0104",
          "360-0106",
          "360-0006",
          "360-0123",
          "360-0003",
          "360-0802",
          "360-0851",
          "360-0846",
          "360-0027",
          "360-0031",
          "360-0102",
          "360-0834",
          "360-0211",
          "360-0107",
          "360-0804",
          "360-0134",
          "360-0855",
          "360-0215",
          "360-0853",
          "360-0854",
          "369-0102",
          "360-0223",
          "360-0018",
          "360-0825",
          "360-0037",
          "369-0101",
          "360-0132",
          "360-0244",
          "360-0121",
          "360-0232",
          "360-0022",
          "360-0024",
          "360-0237",
          "360-0124",
          "360-0133",
          "360-0047",
          "360-0801",
          "360-0013",
          "360-0806",
          "360-0115",
          "360-0817",
          "360-0841",
          "360-0842",
          "360-0214",
          "360-0216",
          "360-0857",
          "360-0135",
          "360-0101",
          "360-0014",
          "360-0235",
          "360-0811",
          "360-0852",
          "360-0224",
          "360-0112",
          "360-0163",
          "360-0021",
          "360-0833",
          "360-0836",
          "369-0108",
          "360-0856",
          "360-0225",
          "360-0043",
          "360-0815",
          "360-0042",
          "360-0161",
          "360-0243",
          "360-0034",
          "360-0844",
          "360-0843",
          "360-0113",
          "360-0116",
          "360-0845",
          "369-0105",
          "360-0824",
          "360-0041",
          "360-0045",
          "360-0822",
          "369-0107",
          "360-0162",
          "360-0201",
          "360-0245",
          "360-0241",
          "360-0204",
          "360-0238",
          "360-0202",
          "360-0164",
          "360-0233",
          "360-0218",
          "360-0203",
          "360-0044",
          "332-0000",
          "332-0031",
          "334-0073",
          "333-0824",
          "333-0825",
          "332-0001",
          "333-0826",
          "332-0005",
          "332-0029",
          "334-0059",
          "334-0054",
          "334-0053",
          "334-0055",
          "334-0071",
          "334-0051",
          "333-0812",
          "334-0057",
          "334-0072",
          "334-0058",
          "334-0052",
          "333-0836",
          "333-0834",
          "332-0023",
          "332-0024",
          "333-0865",
          "333-0823",
          "334-0074",
          "334-0075",
          "334-0067",
          "332-0014",
          "333-0844",
          "333-0845",
          "332-0015",
          "332-0007",
          "333-0831",
          "333-0862",
          "333-0815",
          "333-0804",
          "333-0814",
          "333-0822",
          "333-0832",
          "333-0857",
          "333-0863",
          "332-0016",
          "332-0017",
          "334-0003",
          "334-0001",
          "333-0816",
          "334-0005",
          "333-0866",
          "333-0848",
          "333-0851",
          "333-0853",
          "333-0868",
          "333-0856",
          "333-0847",
          "333-0855",
          "333-0867",
          "333-0852",
          "333-0854",
          "333-0869",
          "332-0006",
          "333-0807",
          "333-0808",
          "334-0004",
          "333-0803",
          "333-0811",
          "333-0806",
          "333-0805",
          "333-0802",
          "333-0817",
          "332-0032",
          "332-0022",
          "332-0034",
          "332-0033",
          "334-0061",
          "334-0068",
          "332-0035",
          "333-0833",
          "332-0021",
          "333-0813",
          "334-0062",
          "334-0064",
          "334-0012",
          "334-0002",
          "334-0015",
          "332-0025",
          "333-0821",
          "334-0066",
          "333-0801",
          "334-0063",
          "332-0003",
          "332-0013",
          "332-0012",
          "334-0076",
          "333-0849",
          "333-0843",
          "333-0842",
          "333-0841",
          "334-0014",
          "334-0065",
          "333-0835",
          "334-0011",
          "332-0027",
          "332-0026",
          "334-0013",
          "333-0846",
          "334-0056",
          "332-0028",
          "332-0011",
          "333-0861",
          "333-0864",
          "332-0002",
          "332-0004",
          "361-0000",
          "361-0074",
          "361-0011",
          "361-0046",
          "361-0081",
          "361-0077",
          "361-0045",
          "361-0007",
          "361-0034",
          "361-0044",
          "361-0066",
          "361-0001",
          "361-0073",
          "361-0065",
          "361-0024",
          "361-0055",
          "361-0005",
          "361-0071",
          "361-0002",
          "361-0025",
          "361-0022",
          "361-0032",
          "361-0063",
          "361-0047",
          "361-0067",
          "361-0037",
          "361-0012",
          "361-0003",
          "361-0057",
          "361-0054",
          "361-0006",
          "361-0053",
          "361-0004",
          "361-0015",
          "361-0041",
          "361-0078",
          "361-0035",
          "361-0076",
          "361-0014",
          "361-0083",
          "361-0064",
          "361-0023",
          "361-0042",
          "361-0026",
          "361-0036",
          "361-0043",
          "361-0021",
          "361-0016",
          "361-0052",
          "361-0038",
          "361-0013",
          "361-0082",
          "361-0031",
          "361-0084",
          "361-0072",
          "361-0075",
          "361-0056",
          "361-0062",
          "361-0051",
          "361-0017",
          "361-0033",
          "361-0061",
          "368-0000",
          "368-0026",
          "368-0016",
          "369-1804",
          "369-1802",
          "369-1801",
          "369-1912",
          "369-1911",
          "369-1803",
          "368-0063",
          "369-1874",
          "368-0031",
          "369-1873",
          "368-0065",
          "369-1901",
          "368-0005",
          "368-0011",
          "368-0023",
          "368-0061",
          "368-0014",
          "369-1872",
          "368-0035",
          "368-0024",
          "369-1505",
          "368-0053",
          "368-0032",
          "368-0001",
          "368-0025",
          "368-0003",
          "368-0064",
          "369-1871",
          "368-0021",
          "369-1503",
          "368-0012",
          "368-0055",
          "368-0052",
          "368-0056",
          "368-0045",
          "368-0002",
          "369-1903",
          "368-0043",
          "368-0022",
          "368-0051",
          "368-0013",
          "368-0033",
          "368-0041",
          "368-0042",
          "368-0034",
          "368-0054",
          "368-0066",
          "368-0062",
          "369-1902",
          "368-0067",
          "368-0046",
          "368-0044",
          "368-0015",
          "368-0004",
          "369-1502",
          "369-1504",
          "370-1507",
          "369-1501",
          "359-0000",
          "359-1105",
          "359-0036",
          "359-1133",
          "359-1112",
          "359-1102",
          "359-0026",
          "359-1104",
          "359-1128",
          "359-1142",
          "359-0025",
          "359-1153",
          "359-0005",
          "359-0014",
          "359-0038",
          "359-0007",
          "359-0046",
          "359-1101",
          "359-1152",
          "359-1155",
          "359-1156",
          "359-0004",
          "359-1113",
          "359-1114",
          "359-0037",
          "359-1131",
          "359-1118",
          "359-1166",
          "359-1103",
          "359-1148",
          "359-1141",
          "359-1146",
          "359-1147",
          "359-1122",
          "359-0033",
          "359-0012",
          "359-1161",
          "359-0031",
          "359-0001",
          "359-0024",
          "359-1154",
          "359-0013",
          "359-0016",
          "359-0006",
          "359-0041",
          "359-0002",
          "359-0003",
          "359-0042",
          "359-0035",
          "359-1163",
          "359-1126",
          "359-1144",
          "359-0047",
          "359-1167",
          "359-0034",
          "359-1106",
          "359-1124",
          "359-1116",
          "359-0021",
          "359-0023",
          "359-0015",
          "359-1123",
          "359-1127",
          "359-1165",
          "359-0022",
          "359-1132",
          "359-0027",
          "359-0044",
          "359-1164",
          "359-1111",
          "359-1125",
          "359-0011",
          "359-0045",
          "359-1143",
          "359-1115",
          "359-1121",
          "359-1145",
          "359-0043",
          "359-1117",
          "359-1151",
          "359-0032",
          "359-1162",
          "357-0000",
          "357-0003",
          "357-0128",
          "357-0069",
          "357-0216",
          "357-0013",
          "357-0046",
          "357-0034",
          "357-0037",
          "357-0212",
          "357-0023",
          "357-0048",
          "357-0065",
          "357-0047",
          "357-0045",
          "357-0125",
          "357-0056",
          "357-0055",
          "357-0206",
          "357-0111",
          "357-0053",
          "357-0127",
          "357-0051",
          "357-0011",
          "357-0044",
          "357-0201",
          "357-0064",
          "357-0068",
          "357-0066",
          "357-0015",
          "357-0204",
          "357-0067",
          "357-0215",
          "357-0213",
          "357-0025",
          "357-0218",
          "357-0126",
          "357-0016",
          "357-0012",
          "357-0054",
          "357-0112",
          "357-0052",
          "357-0205",
          "357-0022",
          "357-0004",
          "357-0049",
          "357-0202",
          "357-0002",
          "357-0038",
          "357-0121",
          "357-0122",
          "357-0123",
          "357-0006",
          "357-0203",
          "357-0062",
          "357-0061",
          "357-0021",
          "357-0033",
          "357-0124",
          "357-0005",
          "357-0063",
          "357-0211",
          "357-0014",
          "357-0032",
          "357-0043",
          "357-0041",
          "357-0024",
          "357-0214",
          "357-0217",
          "357-0036",
          "357-0001",
          "357-0042",
          "357-0035",
          "357-0031",
          "347-0000",
          "349-1144",
          "347-0057",
          "349-1146",
          "347-0047",
          "349-1211",
          "349-1215",
          "347-0024",
          "347-0112",
          "347-0103",
          "347-0122",
          "349-1143",
          "347-0010",
          "347-0001",
          "347-0027",
          "347-0058",
          "349-1202",
          "349-1203",
          "347-0125",
          "347-0101",
          "347-0115",
          "347-0003",
          "347-0006",
          "347-0014",
          "347-0105",
          "349-1147",
          "347-0011",
          "347-0013",
          "349-1134",
          "347-0023",
          "349-1135",
          "347-0063",
          "347-0041",
          "349-1154",
          "347-0111",
          "349-1133",
          "349-1214",
          "349-1213",
          "349-1151",
          "347-0042",
          "347-0123",
          "347-0033",
          "347-0113",
          "347-0005",
          "347-0007",
          "347-0053",
          "349-1142",
          "347-0107",
          "349-1153",
          "349-1158",
          "349-1155",
          "347-0061",
          "347-0106",
          "347-0126",
          "347-0002",
          "347-0068",
          "347-0012",
          "347-0055",
          "347-0034",
          "347-0064",
          "347-0121",
          "349-1157",
          "347-0051",
          "347-0108",
          "347-0056",
          "347-0116",
          "349-1148",
          "347-0114",
          "347-0124",
          "347-0008",
          "349-1131",
          "347-0117",
          "347-0104",
          "349-1132",
          "347-0019",
          "347-0032",
          "347-0016",
          "347-0018",
          "347-0102",
          "347-0046",
          "347-0045",
          "347-0054",
          "347-0021",
          "347-0004",
          "349-1156",
          "349-1216",
          "347-0066",
          "349-1145",
          "347-0052",
          "349-1141",
          "347-0022",
          "347-0009",
          "347-0015",
          "347-0028",
          "347-0017",
          "347-0031",
          "349-1205",
          "349-1212",
          "347-0067",
          "347-0062",
          "347-0043",
          "347-0065",
          "349-1201",
          "349-1152",
          "347-0026",
          "349-1204",
          "347-0044",
          "347-0025",
          "367-0000",
          "367-0026",
          "367-0075",
          "367-0027",
          "367-0036",
          "367-0038",
          "367-0016",
          "367-0041",
          "367-0061",
          "367-0062",
          "367-0045",
          "367-0007",
          "367-0031",
          "367-0037",
          "367-0052",
          "367-0005",
          "367-0032",
          "367-0042",
          "367-0044",
          "367-0213",
          "367-0225",
          "367-0251",
          "367-0203",
          "367-0254",
          "367-0216",
          "367-0205",
          "367-0211",
          "367-0206",
          "367-0252",
          "367-0253",
          "367-0214",
          "367-0212",
          "367-0218",
          "367-0223",
          "367-0202",
          "367-0207",
          "367-0201",
          "367-0224",
          "367-0222",
          "367-0215",
          "367-0217",
          "367-0204",
          "367-0221",
          "367-0226",
          "367-0023",
          "367-0011",
          "367-0046",
          "367-0071",
          "367-0039",
          "367-0034",
          "367-0001",
          "367-0063",
          "367-0074",
          "367-0018",
          "367-0003",
          "367-0013",
          "367-0006",
          "367-0053",
          "367-0054",
          "367-0056",
          "367-0025",
          "367-0035",
          "367-0002",
          "367-0072",
          "367-0024",
          "367-0021",
          "367-0033",
          "367-0022",
          "367-0017",
          "367-0014",
          "367-0051",
          "367-0047",
          "367-0064",
          "367-0043",
          "367-0048",
          "367-0073",
          "367-0012",
          "367-0015",
          "367-0004",
          "367-0055",
          "367-0030",
          "355-0000",
          "355-0048",
          "355-0072",
          "355-0026",
          "355-0006",
          "355-0042",
          "355-0065",
          "355-0046",
          "355-0008",
          "355-0001",
          "355-0022",
          "355-0034",
          "355-0074",
          "355-0077",
          "355-0011",
          "355-0073",
          "355-0061",
          "355-0064",
          "355-0066",
          "355-0031",
          "355-0013",
          "355-0016",
          "355-0025",
          "355-0052",
          "355-0004",
          "355-0075",
          "355-0041",
          "355-0076",
          "355-0036",
          "355-0044",
          "355-0071",
          "355-0032",
          "355-0021",
          "355-0019",
          "355-0047",
          "355-0053",
          "355-0003",
          "355-0009",
          "355-0062",
          "355-0007",
          "355-0051",
          "355-0054",
          "355-0043",
          "355-0067",
          "355-0002",
          "355-0012",
          "355-0035",
          "355-0015",
          "355-0055",
          "355-0017",
          "355-0014",
          "355-0005",
          "355-0018",
          "355-0027",
          "355-0010",
          "355-0045",
          "355-0063",
          "355-0028",
          "355-0033",
          "355-0023",
          "355-0024",
          "355-0037",
          "344-0000",
          "344-0126",
          "344-0015",
          "344-0125",
          "344-0031",
          "344-0004",
          "344-0051",
          "344-0052",
          "344-0053",
          "344-0135",
          "344-0023",
          "344-0038",
          "344-0022",
          "344-0021",
          "344-0116",
          "344-0061",
          "344-0062",
          "344-0117",
          "344-0037",
          "344-0111",
          "344-0103",
          "344-0046",
          "344-0121",
          "344-0132",
          "344-0106",
          "344-0133",
          "344-0136",
          "344-0105",
          "344-0007",
          "344-0124",
          "344-0115",
          "344-0058",
          "344-0036",
          "344-0104",
          "344-0043",
          "344-0122",
          "344-0003",
          "344-0113",
          "344-0127",
          "344-0034",
          "344-0024",
          "344-0026",
          "344-0134",
          "344-0067",
          "344-0013",
          "344-0107",
          "344-0045",
          "344-0047",
          "344-0014",
          "344-0123",
          "344-0056",
          "344-0101",
          "344-0112",
          "344-0059",
          "344-0102",
          "344-0006",
          "344-0044",
          "344-0054",
          "344-0114",
          "344-0005",
          "344-0002",
          "344-0032",
          "344-0033",
          "344-0011",
          "344-0001",
          "344-0016",
          "344-0042",
          "344-0041",
          "344-0025",
          "344-0063",
          "344-0064",
          "344-0057",
          "344-0048",
          "344-0055",
          "344-0065",
          "344-0035",
          "344-0066",
          "344-0131",
          "344-0012",
          "350-1300",
          "350-1301",
          "350-1324",
          "350-1305",
          "350-1323",
          "350-1314",
          "350-1335",
          "350-1336",
          "350-1313",
          "350-1333",
          "350-1321",
          "350-1307",
          "350-1315",
          "350-1327",
          "350-1334",
          "350-1304",
          "350-1303",
          "350-1332",
          "350-1322",
          "350-1331",
          "350-1308",
          "350-1326",
          "350-1311",
          "350-1325",
          "350-1302",
          "350-1319",
          "350-1328",
          "350-1320",
          "350-1306",
          "350-1312",
          "350-1317",
          "350-1316",
          "348-0000",
          "348-0061",
          "348-0017",
          "348-0016",
          "348-0062",
          "348-0031",
          "348-0044",
          "348-0035",
          "348-0056",
          "348-0041",
          "348-0025",
          "348-0027",
          "348-0005",
          "348-0039",
          "348-0014",
          "348-0057",
          "348-0015",
          "348-0028",
          "348-0043",
          "348-0024",
          "348-0042",
          "348-0037",
          "348-0038",
          "348-0045",
          "348-0034",
          "348-0047",
          "348-0048",
          "348-0022",
          "348-0026",
          "348-0006",
          "348-0033",
          "348-0036",
          "348-0058",
          "348-0001",
          "348-0003",
          "348-0046",
          "348-0021",
          "348-0054",
          "348-0055",
          "348-0052",
          "348-0032",
          "348-0013",
          "348-0064",
          "348-0065",
          "348-0063",
          "348-0051",
          "348-0023",
          "348-0011",
          "348-0053",
          "348-0071",
          "348-0002",
          "348-0004",
          "348-0012",
          "365-0000",
          "365-0068",
          "365-0002",
          "365-0001",
          "365-0064",
          "365-0011",
          "365-0021",
          "365-0072",
          "365-0063",
          "369-0123",
          "365-0033",
          "369-0137",
          "365-0054",
          "365-0023",
          "369-0112",
          "365-0078",
          "365-0012",
          "365-0034",
          "365-0027",
          "365-0061",
          "369-0116",
          "365-0058",
          "365-0003",
          "365-0014",
          "365-0022",
          "365-0028",
          "365-0041",
          "369-0133",
          "365-0057",
          "365-0013",
          "365-0055",
          "365-0047",
          "369-0134",
          "365-0035",
          "369-0113",
          "365-0025",
          "365-0024",
          "369-0111",
          "365-0074",
          "365-0067",
          "365-0004",
          "365-0044",
          "365-0032",
          "369-0114",
          "365-0056",
          "365-0071",
          "365-0036",
          "365-0065",
          "365-0026",
          "365-0037",
          "365-0059",
          "365-0052",
          "365-0073",
          "369-0124",
          "365-0043",
          "365-0045",
          "365-0039",
          "365-0031",
          "365-0005",
          "369-0136",
          "369-0121",
          "369-0115",
          "369-0131",
          "365-0046",
          "365-0038",
          "365-0076",
          "369-0132",
          "365-0042",
          "365-0062",
          "365-0066",
          "365-0053",
          "369-0122",
          "365-0075",
          "365-0051",
          "369-0135",
          "365-0077",
          "366-0000",
          "366-0053",
          "366-0024",
          "366-0016",
          "369-1245",
          "366-0011",
          "366-0836",
          "366-0026",
          "366-0028",
          "369-0215",
          "369-0222",
          "366-0831",
          "366-0801",
          "366-0012",
          "366-0838",
          "366-0003",
          "366-0814",
          "369-0201",
          "369-0202",
          "369-0211",
          "366-0837",
          "369-1246",
          "366-0812",
          "366-0816",
          "366-0817",
          "366-0051",
          "366-0052",
          "366-0004",
          "369-1109",
          "366-0021",
          "366-0818",
          "369-1103",
          "366-0008",
          "369-1242",
          "366-0815",
          "369-0212",
          "369-0225",
          "369-1244",
          "366-0033",
          "366-0031",
          "366-0025",
          "366-0813",
          "366-0827",
          "366-0802",
          "366-0002",
          "366-0810",
          "366-0029",
          "369-1106",
          "366-0019",
          "369-1104",
          "369-1102",
          "366-0010",
          "366-0832",
          "369-1111",
          "366-0826",
          "369-1108",
          "366-0821",
          "366-0006",
          "366-0027",
          "366-0034",
          "366-0833",
          "369-1101",
          "366-0001",
          "369-1243",
          "366-0822",
          "366-0018",
          "366-0829",
          "366-0824",
          "369-0224",
          "366-0017",
          "366-0015",
          "369-1107",
          "366-0032",
          "366-0035",
          "369-0213",
          "369-0223",
          "369-0221",
          "366-0828",
          "366-0041",
          "366-0042",
          "366-0811",
          "366-0825",
          "369-0203",
          "366-0014",
          "366-0061",
          "366-0013",
          "369-0214",
          "369-1105",
          "366-0022",
          "366-0062",
          "366-0834",
          "366-0005",
          "366-0054",
          "369-1247",
          "366-0007",
          "366-0819",
          "366-0023",
          "369-1241",
          "366-0823",
          "366-0839",
          "366-0835",
          "369-0217",
          "369-0216",
          "366-0009",
          "362-0000",
          "362-0025",
          "362-0012",
          "362-0013",
          "362-0073",
          "362-0031",
          "362-0065",
          "362-0034",
          "362-0062",
          "362-0046",
          "362-0071",
          "362-0047",
          "362-0058",
          "362-0056",
          "362-0044",
          "362-0075",
          "362-0074",
          "362-0001",
          "362-0037",
          "362-0008",
          "362-0048",
          "362-0022",
          "362-0007",
          "362-0063",
          "362-0064",
          "362-0024",
          "362-0033",
          "362-0051",
          "362-0004",
          "362-0003",
          "362-0054",
          "362-0053",
          "362-0052",
          "362-0035",
          "362-0072",
          "362-0067",
          "362-0057",
          "362-0006",
          "362-0043",
          "362-0005",
          "362-0021",
          "362-0026",
          "362-0023",
          "362-0016",
          "362-0032",
          "362-0059",
          "362-0055",
          "362-0011",
          "362-0061",
          "362-0041",
          "362-0017",
          "362-0076",
          "362-0014",
          "362-0015",
          "362-0002",
          "362-0036",
          "362-0045",
          "362-0042",
          "362-0066",
          "340-0000",
          "340-0002",
          "340-0007",
          "340-0053",
          "340-0032",
          "340-0003",
          "340-0001",
          "340-0042",
          "340-0046",
          "340-0047",
          "340-0052",
          "340-0045",
          "340-0011",
          "340-0056",
          "340-0054",
          "340-0012",
          "340-0014",
          "340-0055",
          "340-0022",
          "340-0043",
          "340-0015",
          "340-0016",
          "340-0051",
          "340-0021",
          "340-0036",
          "340-0005",
          "340-0035",
          "340-0031",
          "340-0044",
          "340-0048",
          "340-0034",
          "340-0004",
          "340-0013",
          "340-0041",
          "340-0028",
          "340-0024",
          "340-0025",
          "340-0023",
          "340-0033",
          "340-0006",
          "340-0017",
          "340-0026",
          "340-0027",
          "343-0000",
          "343-0807",
          "343-0808",
          "343-0826",
          "343-0831",
          "343-0025",
          "343-0031",
          "343-0005",
          "343-0034",
          "343-0044",
          "343-0021",
          "343-0027",
          "343-0004",
          "343-0844",
          "343-0035",
          "343-0008",
          "343-0802",
          "343-0033",
          "343-0037",
          "343-0043",
          "343-0838",
          "343-0843",
          "343-0842",
          "343-0834",
          "343-0836",
          "343-0841",
          "343-0835",
          "343-0833",
          "343-0837",
          "343-0827",
          "343-0821",
          "343-0854",
          "343-0006",
          "343-0026",
          "343-0024",
          "343-0813",
          "343-0818",
          "343-0811",
          "343-0823",
          "343-0036",
          "343-0851",
          "343-0045",
          "343-0852",
          "343-0857",
          "343-0805",
          "343-0803",
          "343-0042",
          "343-0041",
          "343-0825",
          "343-0013",
          "343-0817",
          "343-0853",
          "343-0855",
          "343-0822",
          "343-0801",
          "343-0846",
          "343-0015",
          "343-0022",
          "343-0023",
          "343-0814",
          "343-0002",
          "343-0001",
          "343-0032",
          "343-0003",
          "343-0011",
          "343-0012",
          "343-0804",
          "343-0845",
          "343-0832",
          "343-0014",
          "343-0806",
          "343-0007",
          "343-0815",
          "343-0046",
          "343-0047",
          "343-0856",
          "343-0812",
          "343-0816",
          "343-0824",
          "343-0828",
          "335-0000",
          "335-0001",
          "335-0004",
          "335-0002",
          "335-0005",
          "335-0003",
          "335-0022",
          "335-0015",
          "335-0013",
          "335-0014",
          "335-0034",
          "335-0035",
          "335-0033",
          "335-0037",
          "335-0011",
          "335-0016",
          "335-0024",
          "335-0012",
          "335-0021",
          "335-0026",
          "335-0036",
          "335-0027",
          "335-0031",
          "335-0032",
          "335-0023",
          "335-0025",
          "358-0000",
          "358-0002",
          "358-0031",
          "358-0027",
          "358-0051",
          "358-0023",
          "358-0022",
          "358-0004",
          "358-0006",
          "358-0048",
          "358-0013",
          "358-0042",
          "358-0008",
          "358-0024",
          "358-0007",
          "358-0001",
          "358-0017",
          "358-0026",
          "358-0032",
          "358-0033",
          "358-0011",
          "358-0041",
          "358-0055",
          "358-0025",
          "358-0021",
          "358-0016",
          "358-0045",
          "358-0003",
          "358-0035",
          "358-0043",
          "358-0015",
          "358-0034",
          "358-0054",
          "358-0036",
          "358-0012",
          "358-0053",
          "358-0044",
          "358-0046",
          "358-0014",
          "358-0005",
          "358-0047",
          "358-0052",
          "351-0000",
          "351-0016",
          "351-0035",
          "351-0007",
          "351-0001",
          "351-0036",
          "351-0015",
          "351-0012",
          "351-0002",
          "351-0024",
          "351-0003",
          "351-0032",
          "351-0006",
          "351-0034",
          "351-0021",
          "351-0004",
          "351-0005",
          "351-0033",
          "351-0022",
          "351-0013",
          "351-0014",
          "351-0011",
          "351-0023",
          "351-0025",
          "351-0031",
          "353-0000",
          "353-0007",
          "353-0001",
          "353-0005",
          "353-0003",
          "353-0006",
          "353-0002",
          "353-0004",
          "353-0008",
          "351-0100",
          "351-0111",
          "351-0101",
          "351-0102",
          "351-0103",
          "351-0113",
          "351-0115",
          "351-0105",
          "351-0106",
          "351-0114",
          "351-0116",
          "351-0112",
          "351-0104",
          "352-0000",
          "352-0021",
          "352-0015",
          "352-0033",
          "352-0004",
          "352-0025",
          "352-0003",
          "352-0035",
          "352-0014",
          "352-0032",
          "352-0017",
          "352-0024",
          "352-0001",
          "352-0005",
          "352-0006",
          "352-0013",
          "352-0031",
          "352-0034",
          "352-0011",
          "352-0012",
          "352-0016",
          "352-0002",
          "352-0023",
          "352-0022",
          "363-0000",
          "363-0002",
          "363-0023",
          "363-0021",
          "363-0001",
          "363-0026",
          "363-0024",
          "363-0027",
          "363-0011",
          "363-0006",
          "363-0004",
          "363-0016",
          "363-0007",
          "363-0008",
          "363-0018",
          "363-0009",
          "363-0003",
          "363-0025",
          "363-0028",
          "363-0014",
          "363-0012",
          "363-0005",
          "363-0017",
          "363-0013",
          "363-0015",
          "363-0022",
          "346-0000",
          "346-0011",
          "346-0013",
          "349-1115",
          "349-1121",
          "340-0211",
          "346-0029",
          "346-0023",
          "340-0204",
          "346-0038",
          "346-0021",
          "346-0006",
          "346-0028",
          "349-1114",
          "346-0024",
          "346-0036",
          "349-1111",
          "349-1113",
          "340-0212",
          "346-0035",
          "346-0007",
          "346-0032",
          "346-0003",
          "346-0016",
          "346-0031",
          "340-0214",
          "349-1104",
          "349-1101",
          "349-1102",
          "349-1103",
          "346-0012",
          "349-1105",
          "346-0001",
          "340-0215",
          "340-0203",
          "349-1124",
          "349-1116",
          "346-0033",
          "346-0022",
          "346-0115",
          "346-0111",
          "346-0114",
          "346-0102",
          "346-0104",
          "346-0112",
          "346-0113",
          "346-0106",
          "346-0101",
          "346-0103",
          "346-0105",
          "340-0218",
          "340-0205",
          "349-1125",
          "346-0034",
          "349-1112",
          "340-0213",
          "346-0015",
          "340-0206",
          "346-0002",
          "340-0201",
          "346-0026",
          "340-0202",
          "346-0025",
          "346-0005",
          "349-1123",
          "349-1122",
          "349-1106",
          "346-0004",
          "349-1117",
          "346-0027",
          "346-0014",
          "346-0037",
          "340-0217",
          "340-0216",
          "364-0000",
          "364-0011",
          "364-0007",
          "364-0026",
          "364-0024",
          "364-0025",
          "364-0012",
          "364-0006",
          "364-0021",
          "364-0027",
          "364-0028",
          "364-0022",
          "364-0023",
          "364-0034",
          "364-0031",
          "364-0013",
          "364-0035",
          "364-0001",
          "364-0014",
          "364-0003",
          "364-0033",
          "364-0032",
          "364-0002",
          "364-0005",
          "364-0004",
          "340-0800",
          "340-0826",
          "340-0806",
          "340-0821",
          "340-0835",
          "340-0822",
          "340-0834",
          "340-0824",
          "340-0803",
          "340-0813",
          "340-0804",
          "340-0823",
          "340-0807",
          "340-0825",
          "340-0816",
          "340-0802",
          "340-0812",
          "340-0833",
          "340-0811",
          "340-0801",
          "340-0805",
          "340-0808",
          "340-0831",
          "340-0814",
          "340-0815",
          "340-0832",
          "354-0000",
          "354-0016",
          "354-0012",
          "354-0031",
          "354-0034",
          "354-0002",
          "354-0004",
          "354-0023",
          "354-0025",
          "354-0024",
          "354-0026",
          "354-0021",
          "354-0003",
          "354-0018",
          "354-0033",
          "354-0017",
          "354-0001",
          "354-0015",
          "354-0035",
          "354-0036",
          "354-0011",
          "354-0014",
          "354-0013",
          "354-0006",
          "354-0008",
          "354-0007",
          "354-0005",
          "354-0022",
          "354-0032",
          "341-0000",
          "341-0036",
          "341-0054",
          "341-0033",
          "341-0031",
          "341-0059",
          "341-0014",
          "341-0011",
          "341-0022",
          "341-0046",
          "341-0055",
          "341-0006",
          "341-0004",
          "341-0026",
          "341-0008",
          "341-0013",
          "341-0043",
          "341-0027",
          "341-0021",
          "341-0007",
          "341-0009",
          "341-0034",
          "341-0015",
          "341-0037",
          "341-0035",
          "341-0016",
          "341-0017",
          "341-0038",
          "341-0051",
          "341-0044",
          "341-0023",
          "341-0041",
          "341-0056",
          "341-0012",
          "341-0050",
          "341-0001",
          "341-0058",
          "341-0002",
          "341-0005",
          "341-0053",
          "341-0057",
          "341-0003",
          "341-0052",
          "341-0024",
          "341-0028",
          "341-0025",
          "341-0042",
          "341-0032",
          "341-0045",
          "341-0018",
          "349-0100",
          "349-0126",
          "349-0135",
          "349-0133",
          "349-0102",
          "349-0125",
          "349-0132",
          "349-0122",
          "349-0136",
          "349-0112",
          "349-0101",
          "349-0134",
          "349-0113",
          "349-0103",
          "349-0143",
          "349-0124",
          "349-0121",
          "349-0137",
          "349-0144",
          "349-0141",
          "349-0145",
          "349-0131",
          "349-0115",
          "349-0111",
          "349-0105",
          "349-0123",
          "349-0114",
          "349-0104",
          "349-0142",
          "349-0127",
          "349-0128",
          "350-0200",
          "350-0239",
          "350-0207",
          "350-0201",
          "350-0238",
          "350-0237",
          "350-0273",
          "350-0242",
          "350-0212",
          "350-0275",
          "350-0231",
          "350-0267",
          "350-0254",
          "350-0219",
          "350-0218",
          "350-0268",
          "350-0221",
          "350-0271",
          "350-0243",
          "350-0266",
          "350-0253",
          "350-0258",
          "350-0248",
          "350-0204",
          "350-0202",
          "350-0257",
          "350-0213",
          "350-0217",
          "350-0261",
          "350-0235",
          "350-0211",
          "350-0222",
          "350-0255",
          "350-0278",
          "350-0272",
          "350-0215",
          "350-0256",
          "350-0264",
          "350-0246",
          "350-0214",
          "350-0209",
          "350-0251",
          "350-0241",
          "350-0276",
          "350-0208",
          "350-0206",
          "350-0252",
          "350-0227",
          "350-0232",
          "350-0265",
          "350-0262",
          "350-0259",
          "350-0247",
          "350-0269",
          "350-0236",
          "350-0205",
          "350-0277",
          "350-0225",
          "350-0263",
          "350-0226",
          "350-0274",
          "350-0234",
          "350-0233",
          "350-0228",
          "350-0244",
          "350-0229",
          "350-0216",
          "350-0223",
          "350-0224",
          "350-0203",
          "350-0245",
          "340-0100",
          "340-0103",
          "340-0104",
          "340-0164",
          "340-0124",
          "340-0146",
          "340-0155",
          "340-0121",
          "340-0111",
          "340-0123",
          "340-0112",
          "340-0154",
          "340-0113",
          "340-0125",
          "340-0162",
          "340-0126",
          "340-0122",
          "340-0133",
          "340-0101",
          "340-0102",
          "340-0161",
          "340-0152",
          "340-0144",
          "340-0115",
          "340-0163",
          "340-0132",
          "340-0142",
          "340-0143",
          "340-0116",
          "340-0131",
          "340-0134",
          "340-0114",
          "340-0145",
          "340-0141",
          "340-0136",
          "340-0135",
          "340-0105",
          "340-0151",
          "340-0156",
          "340-0153",
          "350-2200",
          "350-2214",
          "350-2225",
          "350-2203",
          "350-2212",
          "350-2202",
          "350-2222",
          "350-2227",
          "350-2213",
          "350-2211",
          "350-2223",
          "350-2204",
          "350-2226",
          "350-2221",
          "350-2206",
          "350-2201",
          "350-2224",
          "350-2205",
          "350-2217",
          "350-2216",
          "350-2219",
          "350-2215",
          "350-2218",
          "350-1200",
          "350-1203",
          "350-1225",
          "350-1246",
          "350-1222",
          "350-1227",
          "350-1214",
          "350-1234",
          "350-1231",
          "350-1242",
          "350-1254",
          "350-1245",
          "350-1249",
          "350-1202",
          "350-1251",
          "350-1248",
          "350-1221",
          "350-1233",
          "350-1212",
          "350-1252",
          "350-1253",
          "350-1247",
          "350-1223",
          "350-1213",
          "350-1215",
          "350-1224",
          "350-1201",
          "350-1232",
          "350-1226",
          "350-1243",
          "350-1204",
          "350-1235",
          "350-1244",
          "350-1205",
          "350-1206",
          "350-1255",
          "350-1211",
          "350-1236",
          "350-1237",
          "350-1241",
          "350-1257",
          "342-0000",
          "342-0016",
          "342-0008",
          "342-0025",
          "342-0022",
          "342-0001",
          "342-0017",
          "342-0052",
          "342-0051",
          "342-0005",
          "342-0045",
          "342-0044",
          "342-0046",
          "342-0058",
          "342-0043",
          "342-0050",
          "342-0023",
          "342-0021",
          "342-0002",
          "342-0007",
          "342-0059",
          "342-0057",
          "342-0053",
          "342-0014",
          "342-0036",
          "342-0035",
          "342-0034",
          "342-0026",
          "342-0037",
          "342-0015",
          "342-0047",
          "342-0031",
          "342-0033",
          "342-0042",
          "342-0004",
          "342-0003",
          "342-0024",
          "342-0012",
          "342-0056",
          "342-0011",
          "342-0032",
          "342-0041",
          "342-0038",
          "342-0006",
          "342-0027",
          "342-0055",
          "342-0054",
          "342-0013",
          "356-0000",
          "356-0055",
          "356-0019",
          "356-0057",
          "356-0017",
          "356-0021",
          "356-0056",
          "356-0053",
          "356-0058",
          "356-0054",
          "356-0003",
          "356-0006",
          "356-0004",
          "356-0051",
          "356-0001",
          "356-0007",
          "356-0002",
          "356-0029",
          "356-0034",
          "356-0038",
          "356-0059",
          "356-0030",
          "356-0033",
          "356-0020",
          "356-0012",
          "356-0026",
          "356-0045",
          "356-0041",
          "356-0052",
          "356-0025",
          "356-0023",
          "356-0013",
          "356-0016",
          "356-0022",
          "356-0005",
          "356-0044",
          "356-0028",
          "356-0015",
          "356-0042",
          "356-0011",
          "356-0014",
          "356-0031",
          "356-0037",
          "356-0032",
          "356-0050",
          "356-0027",
          "356-0035",
          "356-0043",
          "356-0036",
          "356-0018",
          "356-0008",
          "356-0024",
          "349-0200",
          "349-0202",
          "349-0225",
          "349-0226",
          "349-0221",
          "349-0217",
          "349-0216",
          "349-0204",
          "349-0201",
          "349-0203",
          "349-0223",
          "349-0218",
          "349-0219",
          "349-0212",
          "349-0215",
          "349-0213",
          "349-0222",
          "349-0214",
          "349-0205",
          "349-0224",
          "349-0211",
          "362-0800",
          "362-0812",
          "362-0803",
          "362-0813",
          "362-0807",
          "362-0801",
          "362-0808",
          "362-0806",
          "362-0805",
          "362-0811",
          "362-0802",
          "362-0804",
          "354-0045",
          "354-0044",
          "354-0043",
          "354-0046",
          "354-0041",
          "354-0042",
          "350-0400",
          "350-0444",
          "350-0455",
          "350-0434",
          "350-0441",
          "350-0465",
          "350-0467",
          "350-0452",
          "350-0432",
          "350-0436",
          "350-0446",
          "350-0454",
          "350-0438",
          "350-0435",
          "350-0453",
          "350-0456",
          "350-0461",
          "350-0445",
          "350-0443",
          "350-0431",
          "350-0433",
          "350-0466",
          "350-0442",
          "350-0463",
          "350-0464",
          "350-0437",
          "350-0439",
          "350-0451",
          "350-0462",
          "350-0415",
          "350-0417",
          "350-0403",
          "350-0416",
          "350-0414",
          "350-0402",
          "350-0407",
          "350-0411",
          "350-0424",
          "350-0422",
          "350-0423",
          "350-0425",
          "350-0405",
          "350-0406",
          "350-0404",
          "350-0412",
          "350-0413",
          "350-0401",
          "350-0421",
          "355-0800",
          "355-0806",
          "355-0807",
          "355-0808",
          "355-0813",
          "355-0815",
          "355-0801",
          "355-0804",
          "355-0811",
          "355-0803",
          "355-0805",
          "355-0814",
          "355-0812",
          "355-0802",
          "355-0200",
          "355-0222",
          "355-0206",
          "355-0203",
          "355-0225",
          "355-0213",
          "355-0214",
          "355-0224",
          "355-0221",
          "355-0211",
          "355-0227",
          "355-0212",
          "355-0226",
          "355-0223",
          "355-0204",
          "355-0215",
          "355-0205",
          "355-0201",
          "355-0216",
          "355-0202",
          "355-0300",
          "355-0324",
          "355-0333",
          "355-0304",
          "355-0328",
          "355-0321",
          "355-0316",
          "355-0334",
          "355-0325",
          "355-0312",
          "355-0335",
          "355-0337",
          "355-0311",
          "355-0327",
          "355-0323",
          "355-0326",
          "355-0313",
          "355-0336",
          "355-0302",
          "355-0306",
          "355-0314",
          "355-0303",
          "355-0301",
          "355-0305",
          "355-0317",
          "355-0322",
          "355-0318",
          "355-0332",
          "355-0315",
          "355-0331",
          "350-0100",
          "350-0153",
          "350-0158",
          "350-0115",
          "350-0127",
          "350-0101",
          "350-0105",
          "350-0133",
          "350-0156",
          "350-0107",
          "350-0152",
          "350-0142",
          "350-0106",
          "350-0136",
          "350-0121",
          "350-0168",
          "350-0163",
          "350-0155",
          "350-0132",
          "350-0104",
          "350-0157",
          "350-0144",
          "350-0102",
          "350-0135",
          "350-0122",
          "350-0162",
          "350-0128",
          "350-0141",
          "350-0143",
          "350-0145",
          "350-0113",
          "350-0117",
          "350-0112",
          "350-0166",
          "350-0165",
          "350-0161",
          "350-0134",
          "350-0147",
          "350-0123",
          "350-0151",
          "350-0114",
          "350-0125",
          "350-0131",
          "350-0164",
          "350-0146",
          "350-0103",
          "350-0167",
          "350-0124",
          "350-0137",
          "350-0116",
          "350-0154",
          "350-0111",
          "350-0126",
          "350-0138",
          "355-0100",
          "355-0131",
          "355-0132",
          "355-0103",
          "355-0136",
          "355-0133",
          "355-0134",
          "355-0127",
          "355-0125",
          "355-0115",
          "355-0105",
          "355-0165",
          "355-0111",
          "355-0155",
          "355-0137",
          "355-0124",
          "355-0153",
          "355-0166",
          "355-0164",
          "355-0151",
          "355-0114",
          "355-0113",
          "355-0104",
          "355-0116",
          "355-0118",
          "355-0123",
          "355-0122",
          "355-0167",
          "355-0119",
          "355-0106",
          "355-0156",
          "355-0157",
          "355-0121",
          "355-0110",
          "355-0101",
          "355-0163",
          "355-0135",
          "355-0162",
          "355-0112",
          "355-0126",
          "355-0154",
          "355-0102",
          "355-0117",
          "355-0161",
          "355-0152",
          "350-0300",
          "350-0321",
          "350-0311",
          "350-0305",
          "350-0322",
          "350-0302",
          "350-0301",
          "350-0314",
          "350-0303",
          "350-0323",
          "350-0307",
          "350-0304",
          "350-0306",
          "350-0312",
          "350-0313",
          "350-0324",
          "355-0363",
          "355-0366",
          "355-0365",
          "355-0351",
          "355-0343",
          "355-0356",
          "355-0358",
          "355-0359",
          "355-0341",
          "355-0357",
          "355-0342",
          "355-0364",
          "355-0354",
          "355-0355",
          "355-0344",
          "355-0352",
          "355-0353",
          "355-0361",
          "368-0071",
          "368-0072",
          "369-1400",
          "369-1623",
          "369-1621",
          "369-1601",
          "369-1626",
          "369-1622",
          "369-1413",
          "369-1625",
          "369-1624",
          "369-1411",
          "369-1412",
          "369-1300",
          "369-1312",
          "369-1311",
          "369-1303",
          "369-1305",
          "369-1302",
          "369-1313",
          "369-1304",
          "369-1301",
          "368-0100",
          "368-0111",
          "368-0104",
          "368-0105",
          "368-0113",
          "368-0112",
          "368-0101",
          "368-0102",
          "368-0103",
          "368-0115",
          "368-0114",
          "368-0202",
          "368-0201",
          "355-0371",
          "355-0373",
          "355-0376",
          "355-0372",
          "355-0377",
          "355-0375",
          "355-0374",
          "367-0100",
          "367-0103",
          "367-0113",
          "367-0115",
          "367-0107",
          "367-0112",
          "367-0119",
          "367-0101",
          "367-0108",
          "367-0117",
          "367-0102",
          "367-0116",
          "367-0114",
          "367-0105",
          "367-0104",
          "367-0118",
          "367-0111",
          "367-0106",
          "367-0200",
          "367-0234",
          "367-0245",
          "367-0312",
          "367-0243",
          "367-0236",
          "367-0248",
          "367-0311",
          "367-0235",
          "367-0246",
          "367-0231",
          "367-0232",
          "367-0233",
          "367-0237",
          "367-0242",
          "367-0238",
          "367-0247",
          "367-0241",
          "367-0313",
          "367-0244",
          "367-0301",
          "369-0300",
          "369-0315",
          "369-0303",
          "369-0301",
          "369-0307",
          "369-0317",
          "369-0306",
          "369-0305",
          "369-0312",
          "369-0313",
          "369-0311",
          "369-0316",
          "369-0304",
          "369-0308",
          "369-0318",
          "369-0302",
          "369-0314",
          "369-1200",
          "369-1211",
          "369-1233",
          "369-1214",
          "369-1234",
          "369-1236",
          "369-1217",
          "369-1202",
          "369-1205",
          "369-1213",
          "369-1231",
          "369-1222",
          "369-1216",
          "369-1225",
          "369-1212",
          "369-1224",
          "369-1235",
          "369-1204",
          "369-1221",
          "369-1223",
          "369-1232",
          "369-1215",
          "369-1201",
          "369-1203",
          "345-0000",
          "345-0826",
          "345-0822",
          "345-0816",
          "345-0804",
          "345-0834",
          "345-0825",
          "345-0831",
          "345-0821",
          "345-0811",
          "345-0815",
          "345-0802",
          "345-0833",
          "345-0817",
          "345-0814",
          "345-0832",
          "345-0813",
          "345-0812",
          "345-0827",
          "345-0823",
          "345-0835",
          "345-0803",
          "345-0801",
          "345-0824",
          "345-0836",
          "345-0035",
          "345-0042",
          "345-0022",
          "345-0021",
          "345-0001",
          "345-0003",
          "345-0034",
          "345-0014",
          "345-0033",
          "345-0043",
          "345-0044",
          "345-0036",
          "345-0025",
          "345-0047",
          "345-0045",
          "345-0046",
          "345-0024",
          "345-0013",
          "345-0031",
          "345-0015",
          "345-0041",
          "345-0011",
          "345-0032",
          "345-0012",
          "345-0023",
          "345-0004",
          "345-0005",
          "345-0037",
          "345-0002",
          "343-0100",
          "343-0101",
          "343-0106",
          "343-0103",
          "343-0115",
          "343-0116",
          "343-0105",
          "343-0104",
          "343-0117",
          "343-0102",
          "343-0112",
          "343-0111",
          "343-0113",
          "343-0114",
          "260-0000",
          "260-0852",
          "260-0804",
          "260-0002",
          "260-0855",
          "260-0833",
          "260-0856",
          "260-0834",
          "260-0815",
          "260-0018",
          "260-0816",
          "260-0811",
          "260-0813",
          "260-0033",
          "260-0853",
          "260-0017",
          "260-0011",
          "260-0857",
          "260-0835",
          "260-0802",
          "260-0016",
          "260-0832",
          "260-0823",
          "260-0034",
          "260-0841",
          "260-0021",
          "260-0031",
          "260-0027",
          "260-0028",
          "260-0022",
          "260-0843",
          "260-0822",
          "260-0812",
          "260-0844",
          "260-0026",
          "260-0013",
          "260-0024",
          "260-0042",
          "260-0003",
          "260-0023",
          "260-0005",
          "260-0006",
          "260-0025",
          "260-0854",
          "260-0826",
          "260-0801",
          "260-0032",
          "260-0803",
          "260-0824",
          "260-0041",
          "260-0004",
          "260-0015",
          "260-0045",
          "260-0808",
          "260-0014",
          "260-0012",
          "260-0807",
          "260-0044",
          "260-0831",
          "260-0814",
          "260-0842",
          "260-0001",
          "260-0806",
          "260-0805",
          "260-0825",
          "260-0851",
          "260-0007",
          "260-0821",
          "262-0000",
          "262-0019",
          "262-0017",
          "262-0043",
          "262-0002",
          "262-0003",
          "262-0048",
          "262-0041",
          "262-0023",
          "262-0005",
          "262-0013",
          "262-0045",
          "262-0014",
          "262-0011",
          "262-0031",
          "262-0004",
          "262-0012",
          "262-0047",
          "262-0044",
          "262-0024",
          "262-0016",
          "262-0018",
          "262-0042",
          "262-0025",
          "262-0021",
          "262-0046",
          "262-0032",
          "262-0033",
          "262-0026",
          "262-0022",
          "262-0007",
          "262-0015",
          "262-0006",
          "262-0001",
          "263-0000",
          "263-0024",
          "263-0025",
          "263-0052",
          "263-0033",
          "263-0034",
          "263-0032",
          "263-0035",
          "263-0031",
          "263-0053",
          "263-0042",
          "263-0041",
          "263-0043",
          "263-0044",
          "263-0003",
          "263-0015",
          "263-0014",
          "263-0002",
          "263-0051",
          "263-0013",
          "263-0016",
          "263-0011",
          "263-0021",
          "263-0005",
          "263-0001",
          "263-0012",
          "263-0023",
          "263-0054",
          "263-0022",
          "263-0004",
          "264-0000",
          "264-0031",
          "265-0063",
          "265-0052",
          "265-0075",
          "264-0011",
          "264-0013",
          "265-0064",
          "264-0015",
          "264-0016",
          "264-0006",
          "264-0007",
          "265-0077",
          "265-0046",
          "264-0020",
          "264-0023",
          "264-0017",
          "264-0001",
          "265-0045",
          "265-0062",
          "264-0014",
          "265-0067",
          "265-0042",
          "265-0074",
          "264-0012",
          "264-0028",
          "264-0029",
          "265-0073",
          "265-0065",
          "265-0044",
          "265-0076",
          "264-0024",
          "265-0061",
          "265-0066",
          "265-0071",
          "264-0002",
          "264-0004",
          "264-0003",
          "264-0005",
          "264-0025",
          "264-0033",
          "264-0036",
          "265-0041",
          "265-0043",
          "265-0051",
          "264-0026",
          "265-0053",
          "264-0034",
          "264-0035",
          "264-0032",
          "264-0037",
          "265-0072",
          "264-0027",
          "264-0021",
          "266-0000",
          "267-0066",
          "267-0067",
          "267-0064",
          "266-0014",
          "267-0057",
          "267-0065",
          "267-0054",
          "267-0056",
          "266-0025",
          "267-0055",
          "267-0063",
          "266-0031",
          "266-0034",
          "266-0032",
          "266-0033",
          "266-0011",
          "267-0051",
          "266-0021",
          "266-0015",
          "266-0016",
          "267-0052",
          "266-0006",
          "266-0003",
          "267-0053",
          "267-0061",
          "266-0022",
          "266-0024",
          "266-0001",
          "266-0004",
          "266-0002",
          "266-0026",
          "266-0007",
          "266-0005",
          "266-0023",
          "267-0062",
          "261-0000",
          "261-0012",
          "261-0005",
          "261-0013",
          "261-0001",
          "261-0002",
          "261-0004",
          "261-0003",
          "261-0024",
          "261-0023",
          "261-7190",
          "261-7101",
          "261-7102",
          "261-7103",
          "261-7104",
          "261-7105",
          "261-7106",
          "261-7107",
          "261-7108",
          "261-7109",
          "261-7110",
          "261-7111",
          "261-7112",
          "261-7113",
          "261-7114",
          "261-7115",
          "261-7116",
          "261-7117",
          "261-7118",
          "261-7119",
          "261-7120",
          "261-7121",
          "261-7122",
          "261-7123",
          "261-7124",
          "261-7125",
          "261-7126",
          "261-7127",
          "261-7128",
          "261-7129",
          "261-7130",
          "261-7131",
          "261-7132",
          "261-7133",
          "261-7134",
          "261-7135",
          "261-0025",
          "261-0021",
          "261-0026",
          "261-0011",
          "261-0022",
          "261-0014",
          "288-0000",
          "288-0844",
          "288-0005",
          "288-0861",
          "288-0007",
          "288-0056",
          "288-0034",
          "288-0051",
          "288-0012",
          "288-0015",
          "288-0804",
          "288-0805",
          "288-0071",
          "288-0068",
          "288-0046",
          "288-0852",
          "288-0821",
          "288-0823",
          "288-0835",
          "288-0833",
          "288-0004",
          "288-0816",
          "288-0814",
          "288-0801",
          "288-0001",
          "288-0037",
          "288-0011",
          "288-0817",
          "288-0003",
          "288-0866",
          "288-0021",
          "288-0022",
          "288-0064",
          "288-0864",
          "288-0073",
          "288-0812",
          "288-0006",
          "288-0876",
          "288-0873",
          "288-0855",
          "288-0045",
          "288-0025",
          "288-0867",
          "288-0842",
          "288-0063",
          "288-0856",
          "288-0853",
          "288-0067",
          "288-0825",
          "288-0055",
          "288-0042",
          "288-0813",
          "288-0027",
          "288-0023",
          "288-0026",
          "288-0862",
          "288-0834",
          "288-0062",
          "288-0065",
          "288-0854",
          "288-0041",
          "288-0868",
          "288-0024",
          "288-0075",
          "288-0016",
          "288-0014",
          "288-0824",
          "288-0871",
          "288-0874",
          "288-0035",
          "288-0858",
          "288-0077",
          "288-0013",
          "288-0837",
          "288-0865",
          "288-0036",
          "288-0044",
          "288-0863",
          "288-0074",
          "288-0052",
          "288-0054",
          "288-0032",
          "288-0043",
          "288-0053",
          "288-0048",
          "288-0857",
          "288-0831",
          "288-0076",
          "288-0031",
          "288-0836",
          "288-0832",
          "288-0802",
          "288-0851",
          "288-0815",
          "288-0061",
          "288-0033",
          "288-0038",
          "288-0845",
          "288-0877",
          "288-0811",
          "288-0002",
          "288-0872",
          "288-0875",
          "288-0822",
          "288-0072",
          "288-0803",
          "288-0843",
          "288-0841",
          "288-0846",
          "288-0047",
          "288-0066",
          "272-0000",
          "272-0143",
          "272-0144",
          "272-0106",
          "272-0034",
          "272-0033",
          "272-0831",
          "272-0134",
          "272-0032",
          "272-0805",
          "272-0801",
          "272-0025",
          "272-0107",
          "272-0022",
          "272-0015",
          "272-0142",
          "272-0802",
          "272-0124",
          "272-0112",
          "272-0012",
          "272-0101",
          "272-0141",
          "272-0815",
          "272-0836",
          "272-0133",
          "272-0827",
          "272-0013",
          "272-0011",
          "272-0834",
          "272-0123",
          "272-0127",
          "272-0114",
          "272-0145",
          "272-0821",
          "272-0102",
          "272-0113",
          "272-0035",
          "272-0121",
          "272-0824",
          "272-0825",
          "272-0105",
          "272-0832",
          "272-0814",
          "272-0125",
          "272-0122",
          "272-0014",
          "272-0126",
          "272-0024",
          "272-0115",
          "272-0835",
          "272-0813",
          "272-0136",
          "272-0004",
          "272-0026",
          "272-0833",
          "272-0823",
          "272-0003",
          "272-0135",
          "272-0031",
          "272-0146",
          "272-0137",
          "272-0001",
          "272-0002",
          "272-0803",
          "272-0811",
          "272-0837",
          "272-0103",
          "272-0104",
          "272-0826",
          "272-0131",
          "272-0132",
          "272-0804",
          "272-0138",
          "272-0023",
          "272-0822",
          "272-0111",
          "272-0816",
          "272-0021",
          "272-0812",
          "273-0000",
          "273-0041",
          "273-0863",
          "273-0001",
          "273-0039",
          "273-0025",
          "274-0066",
          "274-0067",
          "274-0068",
          "274-0082",
          "273-0021",
          "273-0022",
          "273-0028",
          "273-0027",
          "273-0024",
          "273-0032",
          "273-0853",
          "273-0852",
          "273-0854",
          "274-0054",
          "273-0046",
          "273-0864",
          "273-0044",
          "273-0043",
          "274-0055",
          "274-0051",
          "274-0801",
          "273-0037",
          "273-0038",
          "274-0081",
          "270-1471",
          "273-0861",
          "274-0061",
          "273-0018",
          "274-0807",
          "273-0016",
          "274-0816",
          "274-0814",
          "274-0056",
          "274-0052",
          "273-0862",
          "273-0014",
          "274-0065",
          "274-0817",
          "274-0074",
          "274-0075",
          "274-0073",
          "274-0062",
          "274-0060",
          "274-0069",
          "274-0053",
          "274-0826",
          "273-0865",
          "273-0866",
          "273-0867",
          "274-0821",
          "274-0071",
          "274-0063",
          "273-0017",
          "274-0815",
          "273-0031",
          "274-0823",
          "274-0822",
          "273-0012",
          "273-0036",
          "273-0002",
          "273-0015",
          "273-0047",
          "273-0034",
          "274-0805",
          "274-0806",
          "273-0033",
          "273-0005",
          "274-0824",
          "274-0825",
          "273-0042",
          "273-0851",
          "273-0855",
          "274-0064",
          "273-0048",
          "274-0812",
          "274-0811",
          "274-0818",
          "273-0011",
          "273-0023",
          "273-0004",
          "274-0813",
          "274-0804",
          "274-0072",
          "273-0003",
          "273-0035",
          "274-0802",
          "274-0803",
          "274-0077",
          "274-0076",
          "273-0045",
          "273-0026",
          "273-0013",
          "294-0000",
          "294-0235",
          "294-0043",
          "294-0005",
          "294-0016",
          "294-0026",
          "294-0314",
          "294-0012",
          "294-0226",
          "294-0042",
          "294-0009",
          "294-0044",
          "294-0002",
          "294-0031",
          "294-0025",
          "294-0024",
          "294-0306",
          "294-0032",
          "294-0023",
          "294-0038",
          "294-0052",
          "294-0057",
          "294-0305",
          "294-0301",
          "294-0018",
          "294-0007",
          "294-0312",
          "294-0058",
          "294-0015",
          "294-0311",
          "294-0313",
          "294-0029",
          "294-0225",
          "294-0302",
          "294-0048",
          "294-0046",
          "294-0316",
          "294-0223",
          "294-0006",
          "294-0233",
          "294-0041",
          "294-0001",
          "294-0036",
          "294-0231",
          "294-0037",
          "294-0055",
          "294-0017",
          "294-0315",
          "294-0027",
          "294-0034",
          "294-0307",
          "294-0022",
          "294-0303",
          "294-0304",
          "294-0308",
          "294-0028",
          "294-0008",
          "294-0035",
          "294-0224",
          "294-0011",
          "294-0056",
          "294-0013",
          "294-0045",
          "294-0053",
          "294-0051",
          "294-0004",
          "294-0003",
          "294-0054",
          "294-0033",
          "294-0221",
          "294-0234",
          "294-0222",
          "294-0014",
          "294-0021",
          "294-0047",
          "294-0232",
          "292-0000",
          "292-0055",
          "292-0065",
          "292-0021",
          "292-0026",
          "292-0034",
          "292-0061",
          "292-0033",
          "292-0001",
          "292-0012",
          "292-0011",
          "292-0007",
          "292-0063",
          "292-0211",
          "292-0815",
          "292-0044",
          "292-0024",
          "292-0833",
          "292-0818",
          "292-0009",
          "292-0813",
          "292-0215",
          "292-0022",
          "292-0204",
          "292-0202",
          "292-0052",
          "292-0056",
          "292-0006",
          "292-0051",
          "292-0045",
          "292-0041",
          "292-0042",
          "292-0811",
          "292-0004",
          "292-0005",
          "292-0213",
          "292-0827",
          "292-0824",
          "292-0803",
          "299-0271",
          "292-0822",
          "292-0823",
          "292-0821",
          "292-0032",
          "292-0206",
          "292-0838",
          "292-0834",
          "292-0816",
          "292-0205",
          "292-0217",
          "292-0023",
          "292-0801",
          "292-0806",
          "292-0807",
          "292-0066",
          "292-0832",
          "292-0836",
          "292-0036",
          "292-0808",
          "292-0027",
          "292-0016",
          "292-0014",
          "292-0207",
          "292-0067",
          "292-0835",
          "292-0031",
          "292-0025",
          "292-0214",
          "292-0035",
          "292-0817",
          "292-0064",
          "292-0008",
          "292-0071",
          "292-0002",
          "292-0839",
          "292-0053",
          "292-0054",
          "292-0062",
          "292-0216",
          "292-0825",
          "292-0826",
          "292-0814",
          "292-0819",
          "292-0043",
          "292-0057",
          "292-0037",
          "292-0831",
          "292-0804",
          "292-0038",
          "292-0015",
          "292-0802",
          "292-0212",
          "292-0201",
          "292-0003",
          "292-0837",
          "292-0812",
          "292-0805",
          "292-0203",
          "292-0013",
          "270-0000",
          "270-2223",
          "271-0043",
          "271-0076",
          "270-0006",
          "270-2224",
          "270-0005",
          "270-0036",
          "270-0018",
          "270-2251",
          "270-2221",
          "271-0064",
          "271-0094",
          "270-2254",
          "271-0063",
          "270-2216",
          "270-2215",
          "270-0012",
          "270-0022",
          "271-0097",
          "270-0001",
          "270-0017",
          "271-0068",
          "270-0014",
          "270-0015",
          "270-0013",
          "270-0016",
          "270-0021",
          "270-2213",
          "270-2218",
          "270-2212",
          "270-2211",
          "271-0073",
          "271-0093",
          "271-0075",
          "271-0062",
          "271-0061",
          "271-0041",
          "271-0096",
          "271-0052",
          "270-0034",
          "270-0033",
          "270-0035",
          "270-0032",
          "270-2252",
          "270-2222",
          "270-2202",
          "270-2201",
          "271-0072",
          "271-0071",
          "270-2255",
          "270-2261",
          "270-2265",
          "270-2266",
          "270-2262",
          "270-2264",
          "270-2263",
          "270-0004",
          "270-2242",
          "270-0007",
          "271-0053",
          "271-0054",
          "271-0095",
          "270-0025",
          "271-0044",
          "271-0045",
          "271-0046",
          "271-0047",
          "271-0048",
          "271-0088",
          "271-0082",
          "271-0085",
          "271-0083",
          "271-0086",
          "271-0084",
          "271-0081",
          "270-0011",
          "271-0077",
          "270-2243",
          "270-0023",
          "270-0024",
          "270-2217",
          "270-0003",
          "270-2225",
          "270-2253",
          "271-0067",
          "270-0002",
          "270-0027",
          "270-0028",
          "271-0091",
          "270-2267",
          "271-0092",
          "270-2241",
          "270-2214",
          "271-0051",
          "270-0026",
          "271-0074",
          "271-0065",
          "270-2231",
          "271-0087",
          "270-2204",
          "271-0042",
          "270-0031",
          "271-0066",
          "270-2203",
          "270-2205",
          "270-2232",
          "278-0000",
          "270-0239",
          "278-0025",
          "278-0055",
          "278-0017",
          "270-0223",
          "270-0235",
          "270-0238",
          "270-0227",
          "270-0231",
          "270-0214",
          "278-0052",
          "278-0007",
          "278-0013",
          "278-0033",
          "278-0034",
          "278-0002",
          "270-0222",
          "270-0213",
          "278-0057",
          "278-0054",
          "278-0056",
          "278-0053",
          "270-0221",
          "278-0045",
          "278-0028",
          "278-0032",
          "278-0048",
          "278-0043",
          "278-0047",
          "278-0014",
          "270-0204",
          "270-0205",
          "270-0201",
          "270-0202",
          "270-0203",
          "270-0206",
          "278-0012",
          "278-0044",
          "278-0021",
          "278-0038",
          "278-0003",
          "270-0237",
          "270-0215",
          "278-0031",
          "278-0035",
          "278-0036",
          "278-0051",
          "270-0229",
          "270-0228",
          "270-0216",
          "278-0015",
          "270-0212",
          "278-0037",
          "278-0026",
          "270-0217",
          "278-0041",
          "270-0236",
          "270-0211",
          "270-0226",
          "270-0234",
          "270-0225",
          "278-0016",
          "270-0233",
          "270-0224",
          "278-0027",
          "278-0011",
          "278-0005",
          "270-0232",
          "278-0001",
          "278-0046",
          "278-0006",
          "278-0022",
          "278-0024",
          "278-0023",
          "278-0029",
          "278-0004",
          "278-0042",
          "297-0000",
          "299-4106",
          "297-0066",
          "297-0058",
          "297-0062",
          "299-4115",
          "299-4118",
          "299-4125",
          "297-0033",
          "297-0072",
          "297-0075",
          "299-4127",
          "299-4128",
          "299-4124",
          "297-0036",
          "297-0052",
          "299-4111",
          "297-0014",
          "297-0019",
          "297-0016",
          "297-0003",
          "297-0009",
          "297-0071",
          "297-0067",
          "299-4117",
          "297-0004",
          "297-0007",
          "297-0074",
          "297-0041",
          "297-0042",
          "299-4126",
          "297-0008",
          "299-4101",
          "299-4123",
          "297-0035",
          "297-0076",
          "297-0006",
          "297-0053",
          "299-4103",
          "297-0002",
          "297-0044",
          "297-0029",
          "297-0078",
          "297-0021",
          "299-4116",
          "297-0043",
          "297-0057",
          "297-0027",
          "297-0023",
          "297-0055",
          "297-0017",
          "297-0028",
          "297-0015",
          "297-0013",
          "297-0034",
          "297-0073",
          "297-0038",
          "297-0063",
          "297-0001",
          "299-4129",
          "299-4112",
          "297-0018",
          "297-0037",
          "297-0031",
          "297-0032",
          "299-4113",
          "297-0005",
          "299-4114",
          "297-0022",
          "297-0077",
          "299-4102",
          "297-0065",
          "297-0025",
          "299-4104",
          "297-0064",
          "297-0012",
          "297-0026",
          "297-0039",
          "297-0045",
          "297-0024",
          "297-0061",
          "297-0011",
          "297-0054",
          "299-4105",
          "299-4122",
          "299-4121",
          "297-0056",
          "297-0051",
          "286-0000",
          "289-0112",
          "286-0832",
          "286-0017",
          "286-0831",
          "286-0025",
          "286-0018",
          "286-0818",
          "286-0803",
          "286-0041",
          "286-0046",
          "286-0035",
          "286-0811",
          "287-0204",
          "286-0813",
          "286-0029",
          "287-0235",
          "286-0047",
          "286-0817",
          "286-0122",
          "289-0121",
          "286-0841",
          "287-0213",
          "286-0043",
          "286-0821",
          "286-0131",
          "289-0109",
          "286-0845",
          "289-0106",
          "286-0032",
          "286-0842",
          "286-0036",
          "287-0244",
          "286-0125",
          "287-0221",
          "286-0006",
          "286-0807",
          "282-0010",
          "287-0225",
          "282-0005",
          "286-0105",
          "287-0232",
          "286-0819",
          "286-0136",
          "286-0126",
          "289-0113",
          "286-0823",
          "286-0048",
          "286-0014",
          "286-0137",
          "282-0027",
          "286-0127",
          "289-0101",
          "282-0021",
          "286-0121",
          "286-0028",
          "287-0217",
          "286-0808",
          "289-0107",
          "286-0116",
          "286-0117",
          "289-0115",
          "282-0011",
          "286-0111",
          "286-0005",
          "286-0822",
          "287-0201",
          "286-0836",
          "286-0843",
          "286-0825",
          "289-0126",
          "286-0123",
          "287-0224",
          "286-0031",
          "286-0835",
          "287-0206",
          "286-0004",
          "287-0243",
          "286-0003",
          "289-0103",
          "289-0108",
          "289-0122",
          "286-0844",
          "286-0801",
          "286-0024",
          "286-0011",
          "287-0242",
          "286-0815",
          "286-0021",
          "287-0236",
          "286-0022",
          "282-0002",
          "286-0102",
          "282-0001",
          "287-0233",
          "282-0003",
          "286-0103",
          "286-0134",
          "287-0211",
          "282-0006",
          "286-0106",
          "289-0104",
          "282-0009",
          "286-0101",
          "289-0105",
          "286-0015",
          "287-0237",
          "286-0027",
          "289-0111",
          "289-0116",
          "287-0216",
          "287-0205",
          "289-0117",
          "286-0108",
          "286-0804",
          "286-0045",
          "289-0125",
          "286-0023",
          "289-0114",
          "286-0816",
          "286-0806",
          "286-0042",
          "286-0827",
          "289-0124",
          "286-0115",
          "286-0837",
          "286-0824",
          "289-0102",
          "286-0037",
          "286-0124",
          "286-0814",
          "286-0033",
          "286-0007",
          "286-0132",
          "286-0826",
          "286-0833",
          "282-0012",
          "286-0112",
          "287-0212",
          "287-0227",
          "286-0044",
          "286-0001",
          "282-0004",
          "286-0104",
          "287-0202",
          "286-0802",
          "282-0007",
          "286-0107",
          "286-0118",
          "286-0114",
          "286-0026",
          "287-0222",
          "287-0215",
          "287-0234",
          "286-0034",
          "286-0846",
          "286-0013",
          "286-0812",
          "287-0241",
          "286-0113",
          "286-0805",
          "287-0203",
          "286-0002",
          "286-0012",
          "286-0135",
          "287-0214",
          "286-0133",
          "289-0123",
          "286-0016",
          "286-0834",
          "285-0000",
          "285-0852",
          "285-0835",
          "285-0064",
          "285-0832",
          "285-0032",
          "285-0031",
          "285-0076",
          "285-0003",
          "285-0009",
          "285-0813",
          "285-0864",
          "285-0855",
          "285-0856",
          "285-0071",
          "285-0072",
          "285-0004",
          "285-0822",
          "285-0863",
          "285-0861",
          "285-0866",
          "285-0077",
          "285-0024",
          "285-0055",
          "285-0824",
          "285-0823",
          "285-0825",
          "285-0837",
          "285-0817",
          "285-0802",
          "285-0041",
          "285-0806",
          "285-0043",
          "285-0808",
          "285-0853",
          "285-0836",
          "285-0811",
          "285-0013",
          "285-0821",
          "285-0008",
          "285-0026",
          "285-0025",
          "285-0054",
          "285-0846",
          "285-0844",
          "285-0044",
          "285-0066",
          "285-0801",
          "285-0803",
          "285-0805",
          "285-0057",
          "285-0014",
          "285-0078",
          "285-0062",
          "285-0807",
          "285-0053",
          "285-0841",
          "285-0842",
          "285-0006",
          "285-0007",
          "285-0035",
          "285-0815",
          "285-0854",
          "285-0017",
          "285-0045",
          "285-0862",
          "285-0023",
          "285-0034",
          "285-0831",
          "285-0046",
          "285-0061",
          "285-0012",
          "285-0001",
          "285-0056",
          "285-0818",
          "285-0819",
          "285-0816",
          "285-0065",
          "285-0843",
          "285-0022",
          "285-0051",
          "285-0073",
          "285-0033",
          "285-0015",
          "285-0845",
          "285-0074",
          "285-0850",
          "285-0002",
          "285-0867",
          "285-0833",
          "285-0814",
          "285-0036",
          "285-0042",
          "285-0851",
          "285-0804",
          "285-0865",
          "285-0859",
          "285-0075",
          "285-0016",
          "285-0857",
          "285-0005",
          "285-0063",
          "285-0038",
          "285-0812",
          "285-0021",
          "285-0037",
          "285-0052",
          "285-0039",
          "285-0011",
          "285-0858",
          "285-0834",
          "283-0000",
          "283-0035",
          "283-0032",
          "283-0001",
          "283-0056",
          "283-0057",
          "283-0046",
          "283-0034",
          "283-0051",
          "283-0826",
          "283-0065",
          "283-0821",
          "283-0062",
          "283-0834",
          "283-0011",
          "283-0064",
          "283-0047",
          "283-0061",
          "283-0822",
          "283-0002",
          "283-0048",
          "283-0835",
          "283-0044",
          "283-0013",
          "283-0012",
          "283-0054",
          "283-0033",
          "283-0831",
          "283-0031",
          "283-0014",
          "283-0038",
          "283-0811",
          "283-0022",
          "283-0825",
          "283-0833",
          "283-0814",
          "283-0005",
          "283-0824",
          "283-0802",
          "283-0003",
          "283-0025",
          "283-0026",
          "283-0045",
          "283-0042",
          "283-0816",
          "283-0052",
          "283-0068",
          "283-0067",
          "283-0006",
          "283-0021",
          "283-0053",
          "283-0016",
          "283-0803",
          "283-0041",
          "283-0812",
          "283-0043",
          "283-0004",
          "283-0036",
          "283-0037",
          "283-0063",
          "283-0027",
          "283-0015",
          "283-0805",
          "283-0815",
          "283-0028",
          "283-0832",
          "283-0024",
          "283-0066",
          "283-0023",
          "283-0801",
          "283-0813",
          "283-0823",
          "283-0804",
          "283-0055",
          "289-2500",
          "289-0518",
          "289-2522",
          "289-2511",
          "289-2705",
          "289-2607",
          "289-2534",
          "289-2531",
          "289-0515",
          "289-2602",
          "289-2711",
          "289-2613",
          "289-2614",
          "289-2503",
          "289-2533",
          "289-2603",
          "289-0511",
          "289-2505",
          "289-2704",
          "289-2535",
          "289-2707",
          "289-2606",
          "289-2611",
          "289-2605",
          "289-2502",
          "289-2532",
          "289-2715",
          "289-0504",
          "289-0506",
          "289-2714",
          "289-2514",
          "289-2706",
          "289-2524",
          "289-2501",
          "289-0501",
          "289-0507",
          "289-0514",
          "289-2604",
          "289-2615",
          "289-0502",
          "289-2523",
          "289-2504",
          "289-2515",
          "289-2525",
          "289-2513",
          "289-2521",
          "289-2713",
          "289-2702",
          "289-2512",
          "289-2708",
          "289-0513",
          "289-2612",
          "289-2601",
          "289-0505",
          "289-0517",
          "289-0503",
          "289-0512",
          "289-2616",
          "289-2701",
          "289-2703",
          "289-2712",
          "289-0516",
          "289-2516",
          "275-0000",
          "275-0024",
          "275-0025",
          "275-0006",
          "275-0011",
          "275-0022",
          "275-0028",
          "275-0014",
          "275-0015",
          "275-0023",
          "275-0005",
          "275-0021",
          "275-0016",
          "275-0013",
          "275-0001",
          "275-0017",
          "275-0002",
          "275-0003",
          "275-0012",
          "275-0004",
          "275-0026",
          "275-0027",
          "277-0000",
          "277-0881",
          "277-0055",
          "277-0027",
          "277-0843",
          "277-0841",
          "270-1451",
          "277-0852",
          "277-0014",
          "277-0011",
          "277-0013",
          "270-1456",
          "277-0022",
          "270-1457",
          "277-0883",
          "277-0074",
          "277-0073",
          "270-1445",
          "270-1446",
          "277-0086",
          "277-0805",
          "277-0902",
          "277-0901",
          "277-0922",
          "277-0921",
          "277-0026",
          "277-0813",
          "277-0837",
          "277-0051",
          "277-0924",
          "277-0005",
          "277-0806",
          "277-0874",
          "277-0004",
          "277-0006",
          "277-0882",
          "277-0003",
          "270-1453",
          "270-1452",
          "270-1455",
          "277-0811",
          "277-0846",
          "277-0832",
          "277-0836",
          "277-0031",
          "277-0803",
          "277-0942",
          "277-0913",
          "277-0053",
          "277-0042",
          "277-0041",
          "277-0012",
          "277-0945",
          "277-0862",
          "277-0826",
          "277-0814",
          "277-0084",
          "277-0044",
          "277-0856",
          "277-0804",
          "270-1461",
          "277-0842",
          "277-0028",
          "270-1462",
          "270-1442",
          "277-0861",
          "277-0941",
          "277-0943",
          "277-0023",
          "277-0021",
          "277-0025",
          "277-0923",
          "277-0072",
          "270-1465",
          "270-1466",
          "270-1447",
          "277-0087",
          "277-0008",
          "277-0007",
          "277-0081",
          "277-0858",
          "277-0863",
          "277-0845",
          "277-0071",
          "277-0857",
          "277-0872",
          "277-0066",
          "277-0873",
          "277-0085",
          "277-0032",
          "277-0886",
          "277-0844",
          "277-0885",
          "277-0063",
          "277-0831",
          "277-0833",
          "277-0016",
          "277-0812",
          "277-0065",
          "277-0062",
          "277-0017",
          "277-0045",
          "277-0061",
          "277-0064",
          "277-0083",
          "277-0088",
          "277-0931",
          "277-0932",
          "277-0034",
          "277-0825",
          "270-1464",
          "277-0822",
          "277-0824",
          "270-1463",
          "277-0823",
          "277-0802",
          "277-0801",
          "277-0821",
          "277-0033",
          "277-0052",
          "277-0835",
          "277-0834",
          "277-0827",
          "277-0082",
          "277-0884",
          "277-0903",
          "277-0855",
          "277-0075",
          "277-0043",
          "277-0944",
          "277-0054",
          "277-0912",
          "277-0911",
          "277-0851",
          "270-1454",
          "277-0015",
          "277-0854",
          "277-0853",
          "277-0002",
          "277-0001",
          "277-0871",
          "270-1444",
          "277-0024",
          "270-1443",
          "270-1441",
          "299-5200",
          "299-5263",
          "299-5273",
          "299-5202",
          "299-5201",
          "299-5235",
          "299-5266",
          "299-5265",
          "299-5267",
          "299-5243",
          "299-5217",
          "299-5256",
          "299-5261",
          "299-5251",
          "299-5245",
          "299-5246",
          "299-5272",
          "299-5234",
          "299-5212",
          "299-5252",
          "299-5232",
          "299-5226",
          "299-5218",
          "299-5219",
          "299-5206",
          "299-5231",
          "299-5216",
          "299-5215",
          "299-5214",
          "299-5224",
          "299-5228",
          "299-5205",
          "299-5222",
          "299-5254",
          "299-5225",
          "299-5204",
          "299-5262",
          "299-5264",
          "299-5227",
          "299-5253",
          "299-5213",
          "299-5203",
          "299-5233",
          "299-5255",
          "299-5221",
          "299-5223",
          "299-5271",
          "299-5211",
          "299-5241",
          "299-5274",
          "299-5244",
          "299-5242",
          "290-0000",
          "290-0252",
          "299-0117",
          "299-0102",
          "299-0103",
          "299-0101",
          "290-0509",
          "290-0251",
          "290-0063",
          "290-0253",
          "290-0535",
          "299-0111",
          "299-0107",
          "299-0119",
          "299-0110",
          "290-0207",
          "299-0126",
          "290-0522",
          "290-0257",
          "290-0212",
          "290-0037",
          "290-0516",
          "290-0511",
          "290-0534",
          "290-0537",
          "299-0114",
          "290-0204",
          "290-0543",
          "290-0015",
          "290-0505",
          "290-0262",
          "290-0166",
          "299-0106",
          "290-0265",
          "299-0115",
          "290-0228",
          "290-0047",
          "290-0046",
          "290-0052",
          "290-0222",
          "290-0225",
          "290-0221",
          "290-0171",
          "290-0170",
          "290-0508",
          "290-0211",
          "290-0532",
          "290-0234",
          "290-0172",
          "290-0208",
          "290-0542",
          "290-0002",
          "290-0553",
          "290-0177",
          "290-0513",
          "290-0157",
          "290-0176",
          "290-0533",
          "290-0266",
          "290-0548",
          "290-0241",
          "299-0105",
          "290-0258",
          "299-0113",
          "290-0174",
          "290-0233",
          "290-0243",
          "290-0025",
          "290-0235",
          "290-0213",
          "290-0178",
          "290-0007",
          "290-0167",
          "290-0071",
          "290-0523",
          "290-0051",
          "290-0179",
          "290-0156",
          "290-0001",
          "290-0552",
          "290-0056",
          "290-0057",
          "290-0081",
          "290-0054",
          "290-0082",
          "290-0038",
          "290-0055",
          "290-0058",
          "290-0045",
          "290-0254",
          "290-0255",
          "290-0269",
          "290-0013",
          "290-0526",
          "290-0073",
          "290-0531",
          "290-0528",
          "290-0066",
          "290-0165",
          "290-0559",
          "290-0529",
          "290-0209",
          "290-0162",
          "290-0022",
          "299-0127",
          "290-0229",
          "290-0050",
          "299-0118",
          "299-0128",
          "290-0506",
          "290-0034",
          "290-0154",
          "290-0518",
          "290-0263",
          "290-0503",
          "299-0104",
          "290-0059",
          "290-0502",
          "290-0539",
          "290-0026",
          "290-0151",
          "290-0023",
          "290-0161",
          "290-0555",
          "290-0152",
          "290-0173",
          "290-0203",
          "290-0003",
          "290-0004",
          "299-0121",
          "290-0515",
          "290-0546",
          "290-0545",
          "290-0041",
          "290-0044",
          "299-0109",
          "299-0108",
          "290-0143",
          "290-0141",
          "290-0142",
          "290-0032",
          "290-0547",
          "290-0527",
          "290-0215",
          "290-0512",
          "290-0042",
          "290-0043",
          "290-0236",
          "290-0544",
          "290-0536",
          "290-0551",
          "299-0122",
          "290-0226",
          "290-0242",
          "290-0153",
          "290-0168",
          "290-0164",
          "290-0206",
          "290-0231",
          "290-0072",
          "290-0065",
          "290-0261",
          "290-0014",
          "290-0024",
          "290-0011",
          "290-0033",
          "290-0175",
          "299-0112",
          "290-0507",
          "290-0155",
          "290-0163",
          "290-0074",
          "290-0064",
          "290-0256",
          "290-0214",
          "290-0053",
          "290-0541",
          "299-0123",
          "290-0202",
          "290-0012",
          "290-0216",
          "290-0554",
          "290-0008",
          "290-0524",
          "290-0224",
          "290-0504",
          "290-0556",
          "290-0267",
          "290-0035",
          "290-0036",
          "290-0217",
          "290-0549",
          "290-0514",
          "290-0244",
          "290-0075",
          "290-0232",
          "290-0264",
          "290-0223",
          "299-0116",
          "290-0031",
          "290-0016",
          "290-0517",
          "290-0538",
          "290-0268",
          "290-0227",
          "290-0005",
          "290-0201",
          "290-0558",
          "290-0521",
          "290-0205",
          "290-0021",
          "290-0062",
          "290-0061",
          "290-0067",
          "290-0069",
          "290-0068",
          "299-0124",
          "299-0125",
          "290-0557",
          "290-0501",
          "290-0525",
          "290-0006",
          "290-0259",
          "270-0100",
          "270-0112",
          "270-0137",
          "270-0151",
          "270-0111",
          "270-0115",
          "270-0122",
          "270-0119",
          "270-0128",
          "270-0138",
          "270-0139",
          "270-0154",
          "270-0176",
          "270-0171",
          "270-0125",
          "270-0126",
          "270-0162",
          "270-0117",
          "270-0172",
          "270-0102",
          "270-0132",
          "270-0113",
          "270-0118",
          "270-0146",
          "270-0174",
          "270-0133",
          "270-0173",
          "270-0153",
          "270-0116",
          "270-0134",
          "270-0164",
          "270-0145",
          "270-0121",
          "270-0156",
          "270-0107",
          "270-0142",
          "270-0135",
          "270-0114",
          "270-0101",
          "270-0105",
          "270-0106",
          "270-0161",
          "270-0108",
          "270-0127",
          "270-0136",
          "270-0157",
          "270-0144",
          "270-0152",
          "270-0141",
          "270-0131",
          "270-0124",
          "270-0163",
          "270-0103",
          "270-0155",
          "270-0175",
          "270-0143",
          "270-0123",
          "276-0000",
          "276-0008",
          "276-0045",
          "276-0035",
          "276-0046",
          "276-0048",
          "276-0024",
          "276-0023",
          "276-0020",
          "276-0025",
          "276-0016",
          "276-0022",
          "276-0043",
          "276-0044",
          "276-0006",
          "276-0001",
          "276-0011",
          "276-0005",
          "276-0004",
          "276-0026",
          "276-0021",
          "276-0007",
          "276-0003",
          "276-0036",
          "276-0037",
          "276-0017",
          "276-0013",
          "276-0012",
          "276-0002",
          "276-0049",
          "276-0040",
          "276-0041",
          "276-0027",
          "276-0028",
          "276-0029",
          "276-0032",
          "276-0034",
          "276-0033",
          "276-0031",
          "276-0042",
          "276-0047",
          "276-0014",
          "276-0015",
          "270-1100",
          "270-1106",
          "270-1173",
          "270-1175",
          "270-1166",
          "270-1155",
          "270-1112",
          "270-1114",
          "270-1118",
          "270-1142",
          "270-1131",
          "270-1135",
          "270-1134",
          "270-1113",
          "270-1115",
          "270-1137",
          "270-1136",
          "270-1133",
          "270-1172",
          "270-1163",
          "270-1145",
          "270-1146",
          "270-1152",
          "270-1132",
          "270-1141",
          "270-1138",
          "270-1177",
          "270-1176",
          "270-1117",
          "270-1104",
          "270-1116",
          "270-1167",
          "270-1164",
          "270-1143",
          "270-1122",
          "270-1126",
          "270-1125",
          "270-1121",
          "270-1128",
          "270-1127",
          "270-1165",
          "270-1168",
          "270-1156",
          "270-1154",
          "270-1144",
          "270-1174",
          "270-1123",
          "270-1124",
          "270-1101",
          "270-1107",
          "270-1103",
          "270-1108",
          "270-1162",
          "270-1161",
          "270-1158",
          "270-1111",
          "270-1171",
          "270-1151",
          "270-1105",
          "270-1153",
          "270-1178",
          "270-1119",
          "270-1102",
          "270-1157",
          "270-1147",
          "296-0000",
          "299-5503",
          "299-2864",
          "296-0031",
          "296-0024",
          "296-0045",
          "296-0003",
          "299-5502",
          "296-0035",
          "299-2842",
          "299-2847",
          "299-2846",
          "299-2865",
          "299-2844",
          "299-2845",
          "299-2866",
          "296-0121",
          "296-0124",
          "296-0237",
          "296-0023",
          "296-0025",
          "296-0004",
          "296-0231",
          "299-2858",
          "296-0103",
          "296-0015",
          "296-0101",
          "296-0022",
          "299-5505",
          "296-0233",
          "296-0234",
          "299-5501",
          "296-0236",
          "296-0102",
          "296-0106",
          "299-2854",
          "296-0011",
          "296-0021",
          "296-0013",
          "296-0122",
          "296-0111",
          "299-2851",
          "296-0123",
          "296-0235",
          "296-0105",
          "299-2856",
          "299-2841",
          "296-0043",
          "299-2867",
          "296-0034",
          "299-2855",
          "296-0032",
          "299-5504",
          "296-0016",
          "299-2857",
          "299-2843",
          "296-0041",
          "296-0042",
          "296-0232",
          "296-0044",
          "299-2852",
          "296-0014",
          "299-2862",
          "299-2863",
          "299-2861",
          "296-0114",
          "296-0002",
          "296-0115",
          "296-0104",
          "299-2853",
          "296-0112",
          "296-0033",
          "296-0125",
          "296-0001",
          "296-0126",
          "296-0113",
          "299-5506",
          "296-0012",
          "273-0100",
          "273-0132",
          "273-0102",
          "273-0105",
          "273-0131",
          "273-0111",
          "273-0126",
          "273-0127",
          "273-0128",
          "273-0136",
          "273-0107",
          "273-0124",
          "273-0101",
          "273-0135",
          "273-0118",
          "273-0119",
          "273-0134",
          "273-0117",
          "273-0121",
          "273-0125",
          "273-0104",
          "273-0112",
          "273-0122",
          "273-0115",
          "273-0116",
          "273-0103",
          "273-0114",
          "273-0113",
          "273-0137",
          "273-0106",
          "273-0133",
          "273-0123",
          "299-1100",
          "292-0454",
          "292-0445",
          "299-1112",
          "292-1153",
          "292-1145",
          "292-0433",
          "292-0442",
          "292-1166",
          "299-1175",
          "299-1176",
          "292-0432",
          "299-1103",
          "292-1146",
          "292-1173",
          "292-0512",
          "292-0514",
          "292-1151",
          "299-1123",
          "299-1102",
          "299-1101",
          "299-1146",
          "292-1156",
          "292-1175",
          "292-0511",
          "292-0412",
          "292-0533",
          "292-0404",
          "292-0527",
          "292-1149",
          "292-0513",
          "292-1155",
          "292-1158",
          "299-1107",
          "292-0452",
          "299-1138",
          "292-0535",
          "292-0524",
          "292-0415",
          "299-1164",
          "299-1161",
          "299-1141",
          "299-1143",
          "292-1148",
          "292-0537",
          "292-0525",
          "299-1152",
          "292-0536",
          "292-0435",
          "292-0422",
          "292-0421",
          "292-0414",
          "292-0423",
          "292-0416",
          "292-1142",
          "299-1165",
          "299-1127",
          "299-1126",
          "299-1142",
          "292-0532",
          "292-0526",
          "299-1133",
          "299-1116",
          "292-0403",
          "299-1136",
          "299-1131",
          "292-1176",
          "299-1137",
          "299-1105",
          "292-0451",
          "299-1135",
          "292-1154",
          "299-1114",
          "299-1173",
          "299-1153",
          "292-0522",
          "292-0516",
          "292-0534",
          "292-1178",
          "292-0455",
          "292-1147",
          "299-1124",
          "292-1172",
          "292-0443",
          "299-1121",
          "292-0441",
          "292-0521",
          "292-0444",
          "292-0523",
          "292-1179",
          "299-1106",
          "299-1132",
          "299-1151",
          "292-1143",
          "292-1168",
          "292-1162",
          "299-1145",
          "292-0402",
          "292-1165",
          "292-1152",
          "299-1104",
          "292-1140",
          "292-1177",
          "292-0431",
          "292-1141",
          "299-1108",
          "292-0411",
          "299-1122",
          "292-1163",
          "292-1161",
          "299-1144",
          "292-1164",
          "299-1113",
          "299-1147",
          "292-1167",
          "292-0502",
          "292-0503",
          "292-1157",
          "292-0531",
          "292-1171",
          "292-1144",
          "299-1174",
          "292-1174",
          "299-1115",
          "299-1154",
          "299-1162",
          "299-1172",
          "292-0453",
          "299-1117",
          "292-0434",
          "299-1111",
          "299-1163",
          "299-1171",
          "292-0515",
          "299-1125",
          "292-0501",
          "292-0401",
          "299-1134",
          "299-1166",
          "292-0413",
          "293-0000",
          "299-1615",
          "293-0031",
          "293-0012",
          "293-0022",
          "293-0033",
          "299-1613",
          "299-1608",
          "293-0043",
          "299-1746",
          "299-1753",
          "299-1732",
          "299-1617",
          "299-1736",
          "299-1735",
          "293-0001",
          "299-1758",
          "299-1757",
          "299-1751",
          "299-1616",
          "299-1606",
          "299-1609",
          "299-1861",
          "293-0041",
          "293-0005",
          "293-0051",
          "293-0057",
          "293-0023",
          "293-0034",
          "293-0042",
          "299-1747",
          "293-0046",
          "299-1602",
          "299-1601",
          "293-0055",
          "293-0058",
          "299-1603",
          "299-1745",
          "293-0024",
          "293-0006",
          "293-0032",
          "293-0011",
          "299-1734",
          "299-1752",
          "299-1604",
          "299-1733",
          "299-1731",
          "299-1621",
          "299-1755",
          "293-0036",
          "293-0054",
          "299-1759",
          "299-1742",
          "293-0044",
          "299-1611",
          "299-1744",
          "299-1614",
          "293-0035",
          "293-0013",
          "299-1622",
          "293-0053",
          "299-1618",
          "299-1737",
          "293-0002",
          "293-0021",
          "293-0052",
          "293-0003",
          "293-0004",
          "299-1607",
          "299-1741",
          "299-1756",
          "299-1605",
          "293-0045",
          "299-1743",
          "299-1754",
          "293-0056",
          "299-1612",
          "279-0000",
          "279-0014",
          "279-0022",
          "279-0012",
          "279-0003",
          "279-0002",
          "279-0023",
          "279-0032",
          "279-0025",
          "279-0001",
          "279-0021",
          "279-0004",
          "279-0042",
          "279-0013",
          "279-0043",
          "279-0026",
          "279-0041",
          "279-0031",
          "279-0024",
          "279-0011",
          "284-0000",
          "284-0024",
          "284-0014",
          "284-0041",
          "284-0013",
          "284-0045",
          "284-0042",
          "284-0011",
          "284-0002",
          "284-0027",
          "284-0025",
          "284-0007",
          "284-0003",
          "284-0006",
          "284-0001",
          "284-0033",
          "284-0009",
          "284-0015",
          "284-0026",
          "284-0037",
          "284-0036",
          "284-0021",
          "284-0034",
          "284-0031",
          "284-0023",
          "284-0004",
          "284-0043",
          "284-0016",
          "284-0012",
          "284-0022",
          "284-0032",
          "284-0005",
          "284-0008",
          "284-0035",
          "284-0044",
          "299-0200",
          "299-0216",
          "299-0256",
          "299-0264",
          "299-0233",
          "299-0217",
          "299-0232",
          "299-0221",
          "299-0237",
          "299-0253",
          "299-0252",
          "299-0205",
          "299-0222",
          "299-0201",
          "299-0257",
          "299-0266",
          "299-0242",
          "299-0243",
          "299-0245",
          "299-0262",
          "299-0212",
          "299-0247",
          "299-0231",
          "299-0255",
          "299-0214",
          "299-0223",
          "299-0269",
          "299-0241",
          "299-0203",
          "299-0226",
          "299-0225",
          "299-0213",
          "299-0215",
          "299-0267",
          "299-0265",
          "299-0246",
          "299-0204",
          "299-0263",
          "299-0211",
          "299-0251",
          "299-0244",
          "299-0202",
          "299-0261",
          "299-0235",
          "299-0254",
          "299-0268",
          "299-0234",
          "299-0236",
          "299-0224",
          "289-1100",
          "289-1101",
          "289-1121",
          "289-1105",
          "289-1106",
          "289-1111",
          "289-1142",
          "289-1134",
          "289-1137",
          "289-1126",
          "289-1102",
          "289-1125",
          "289-1108",
          "289-1112",
          "289-1131",
          "289-1135",
          "289-1122",
          "289-1132",
          "289-1123",
          "289-1116",
          "289-1141",
          "289-1136",
          "289-1114",
          "289-1104",
          "289-1145",
          "289-1138",
          "289-1143",
          "289-1144",
          "289-1107",
          "289-1103",
          "289-1115",
          "289-1113",
          "289-1124",
          "289-1133",
          "270-1300",
          "270-1321",
          "270-2302",
          "270-1351",
          "270-1353",
          "270-1360",
          "270-2323",
          "270-1616",
          "270-1347",
          "270-1364",
          "270-1367",
          "270-1368",
          "270-1352",
          "270-1612",
          "270-1327",
          "270-1358",
          "270-1356",
          "270-2318",
          "270-1363",
          "270-1369",
          "270-2322",
          "270-1613",
          "270-1362",
          "270-2319",
          "270-1326",
          "270-1323",
          "270-1328",
          "270-1359",
          "270-2316",
          "270-1343",
          "270-1365",
          "270-2326",
          "270-1318",
          "270-1313",
          "270-1315",
          "270-1316",
          "270-2303",
          "270-2314",
          "270-2305",
          "270-2313",
          "270-2317",
          "270-2301",
          "270-1366",
          "270-2304",
          "270-1614",
          "270-1322",
          "270-1337",
          "270-1333",
          "270-1342",
          "270-2328",
          "270-2329",
          "270-1325",
          "270-1346",
          "270-1350",
          "270-1340",
          "270-1611",
          "270-1618",
          "270-2325",
          "270-1348",
          "270-1349",
          "270-2315",
          "270-2306",
          "270-2312",
          "270-2324",
          "270-1334",
          "270-2311",
          "270-1601",
          "270-1335",
          "270-1341",
          "270-1336",
          "270-1324",
          "270-1605",
          "270-1606",
          "270-1345",
          "270-1332",
          "270-1361",
          "270-1608",
          "270-1357",
          "270-1339",
          "270-1331",
          "270-2307",
          "270-1344",
          "270-1338",
          "270-1602",
          "270-1607",
          "270-2331",
          "270-1354",
          "270-1355",
          "270-2308",
          "270-2321",
          "270-1615",
          "270-1604",
          "270-1617",
          "270-1603",
          "270-2327",
          "270-1609",
          "270-1400",
          "270-1425",
          "270-1401",
          "270-1434",
          "270-1404",
          "270-1403",
          "270-1437",
          "270-1415",
          "270-1433",
          "270-1412",
          "270-1426",
          "270-1416",
          "270-1435",
          "270-1421",
          "270-1439",
          "270-1405",
          "270-1411",
          "270-1407",
          "270-1406",
          "270-1436",
          "270-1408",
          "270-1431",
          "270-1438",
          "270-1402",
          "270-1422",
          "270-1432",
          "270-1424",
          "270-1423",
          "270-1413",
          "270-1414",
          "286-0200",
          "286-0204",
          "286-0203",
          "286-0216",
          "286-0211",
          "286-0223",
          "286-0213",
          "286-0214",
          "286-0215",
          "286-0212",
          "286-0222",
          "286-0221",
          "286-0224",
          "286-0205",
          "286-0202",
          "286-0201",
          "286-0225",
          "299-2400",
          "294-0821",
          "299-2201",
          "299-2522",
          "294-0812",
          "299-2515",
          "299-2503",
          "299-2502",
          "299-2226",
          "299-2205",
          "299-2212",
          "299-2512",
          "294-0804",
          "299-2507",
          "294-0817",
          "299-2511",
          "294-0806",
          "294-0825",
          "299-2525",
          "299-2211",
          "294-0814",
          "299-2504",
          "299-2216",
          "299-2526",
          "299-2524",
          "299-2215",
          "299-2221",
          "299-2224",
          "294-0805",
          "294-0824",
          "299-2501",
          "299-2521",
          "295-0101",
          "295-0102",
          "295-0103",
          "295-0104",
          "294-0815",
          "299-2223",
          "299-2225",
          "295-0006",
          "295-0026",
          "295-0013",
          "295-0002",
          "295-0023",
          "295-0014",
          "295-0011",
          "295-0001",
          "295-0022",
          "295-0003",
          "295-0027",
          "295-0004",
          "295-0025",
          "295-0024",
          "295-0021",
          "295-0005",
          "295-0012",
          "299-2416",
          "299-2411",
          "299-2412",
          "299-2404",
          "299-2418",
          "299-2402",
          "299-2401",
          "299-2417",
          "299-2403",
          "299-2415",
          "299-2414",
          "299-2413",
          "294-0811",
          "299-2514",
          "299-2214",
          "299-2202",
          "294-0823",
          "299-2513",
          "299-2206",
          "299-2204",
          "299-2516",
          "294-0801",
          "299-2517",
          "299-2508",
          "299-2506",
          "294-0826",
          "294-0803",
          "299-2523",
          "299-2505",
          "299-2222",
          "294-0822",
          "294-0816",
          "299-2203",
          "294-0802",
          "294-0813",
          "299-2213",
          "299-2728",
          "299-2726",
          "299-2712",
          "299-2727",
          "299-2725",
          "299-2721",
          "299-2724",
          "299-2702",
          "299-2715",
          "299-2711",
          "299-2722",
          "299-2716",
          "299-2703",
          "299-2714",
          "299-2701",
          "299-2723",
          "299-2713",
          "299-2705",
          "299-2704",
          "289-2100",
          "289-2178",
          "289-2147",
          "289-2148",
          "289-2173",
          "289-2106",
          "289-3182",
          "289-2161",
          "289-2171",
          "289-2104",
          "289-2151",
          "289-2108",
          "289-2176",
          "289-2112",
          "289-2179",
          "289-2149",
          "289-2175",
          "289-2177",
          "289-2133",
          "289-2167",
          "289-3184",
          "289-3186",
          "289-2111",
          "289-2164",
          "289-2174",
          "289-2135",
          "289-2166",
          "289-2114",
          "289-2132",
          "289-2165",
          "289-2102",
          "289-2136",
          "289-2154",
          "289-2156",
          "289-2153",
          "289-2123",
          "289-3183",
          "289-2125",
          "289-2172",
          "289-3181",
          "289-2124",
          "289-2101",
          "289-2121",
          "289-2115",
          "289-2168",
          "289-2113",
          "289-3185",
          "289-2157",
          "289-2152",
          "289-2131",
          "289-2163",
          "289-2162",
          "289-2103",
          "289-2155",
          "289-2105",
          "289-2144",
          "289-2142",
          "289-2141",
          "289-2146",
          "289-2143",
          "289-2134",
          "289-2122",
          "289-2169",
          "289-2107",
          "289-2145",
          "287-0000",
          "289-0321",
          "289-0326",
          "289-0346",
          "287-0106",
          "287-0056",
          "289-0324",
          "287-0803",
          "289-0301",
          "287-0023",
          "287-0804",
          "289-0333",
          "287-0004",
          "287-0102",
          "289-0349",
          "287-0801",
          "287-0013",
          "287-0012",
          "287-0035",
          "287-0811",
          "287-0043",
          "289-0425",
          "287-0054",
          "287-0053",
          "287-0026",
          "289-0323",
          "289-0423",
          "289-0402",
          "289-0313",
          "289-0348",
          "289-0325",
          "287-0044",
          "287-0802",
          "287-0017",
          "287-0032",
          "287-0046",
          "289-0306",
          "287-0027",
          "287-0104",
          "289-0334",
          "289-0403",
          "287-0067",
          "287-0036",
          "289-0408",
          "287-0002",
          "289-0335",
          "289-0337",
          "289-0308",
          "289-0422",
          "289-0327",
          "287-0022",
          "287-0823",
          "287-0805",
          "289-0404",
          "287-0826",
          "289-0328",
          "289-0401",
          "287-0813",
          "287-0105",
          "287-0003",
          "287-0822",
          "287-0816",
          "287-0005",
          "287-0001",
          "289-0302",
          "289-0413",
          "287-0006",
          "287-0821",
          "289-0322",
          "289-0338",
          "287-0021",
          "289-0304",
          "287-0055",
          "289-0344",
          "289-0336",
          "287-0107",
          "287-0045",
          "287-0101",
          "289-0405",
          "287-0014",
          "289-0406",
          "287-0041",
          "287-0806",
          "287-0011",
          "287-0062",
          "287-0047",
          "287-0038",
          "289-0303",
          "289-0414",
          "287-0824",
          "287-0814",
          "287-0034",
          "287-0016",
          "287-0051",
          "287-0063",
          "287-0103",
          "287-0065",
          "287-0048",
          "289-0424",
          "287-0031",
          "289-0407",
          "289-0314",
          "287-0825",
          "289-0347",
          "289-0345",
          "289-0421",
          "289-0331",
          "287-0024",
          "289-0329",
          "289-0411",
          "289-0412",
          "287-0066",
          "289-0312",
          "287-0033",
          "289-0307",
          "287-0812",
          "287-0064",
          "289-0332",
          "289-0341",
          "287-0025",
          "287-0052",
          "287-0815",
          "287-0061",
          "289-0343",
          "289-0426",
          "287-0042",
          "289-0311",
          "287-0018",
          "287-0037",
          "287-0015",
          "289-0342",
          "289-0305",
          "289-1300",
          "289-1203",
          "289-1213",
          "289-1201",
          "289-1335",
          "289-1222",
          "289-1333",
          "289-1304",
          "289-1216",
          "289-1211",
          "289-1225",
          "289-1332",
          "289-1313",
          "289-1331",
          "289-1301",
          "289-1212",
          "289-1315",
          "289-1317",
          "289-1316",
          "289-1302",
          "289-1221",
          "289-1205",
          "289-1312",
          "289-1325",
          "289-1342",
          "289-1217",
          "289-1314",
          "289-1306",
          "289-1343",
          "289-1345",
          "289-1318",
          "289-1204",
          "289-1324",
          "289-1323",
          "289-1321",
          "289-1322",
          "289-1202",
          "289-1326",
          "289-1344",
          "289-1341",
          "289-1801",
          "289-1805",
          "289-1806",
          "289-1804",
          "289-1803",
          "289-1802",
          "289-1223",
          "289-1311",
          "289-1327",
          "289-1206",
          "289-1524",
          "289-1527",
          "289-1507",
          "289-1535",
          "289-1537",
          "289-1511",
          "289-1506",
          "289-1505",
          "289-1531",
          "289-1523",
          "289-1504",
          "289-1513",
          "289-1517",
          "289-1534",
          "289-1536",
          "289-1522",
          "289-1532",
          "289-1516",
          "289-1512",
          "289-1502",
          "289-1533",
          "289-1515",
          "289-1514",
          "289-1526",
          "289-1521",
          "289-1525",
          "289-1503",
          "289-1501",
          "289-1303",
          "289-1224",
          "289-1218",
          "289-1305",
          "289-1214",
          "289-1215",
          "289-1328",
          "289-1226",
          "289-1334",
          "298-0000",
          "298-0126",
          "298-0011",
          "298-0013",
          "298-0113",
          "298-0004",
          "298-0014",
          "298-0006",
          "298-0029",
          "298-0131",
          "298-0012",
          "298-0102",
          "298-0115",
          "298-0103",
          "298-0018",
          "298-0123",
          "298-0112",
          "298-0101",
          "298-0135",
          "298-0114",
          "298-0022",
          "298-0023",
          "298-0121",
          "298-0027",
          "298-0017",
          "298-0015",
          "298-0116",
          "298-0106",
          "298-0021",
          "298-0024",
          "298-0134",
          "298-0005",
          "298-0026",
          "298-0016",
          "298-0105",
          "298-0002",
          "298-0133",
          "298-0003",
          "298-0125",
          "298-0028",
          "298-0117",
          "298-0104",
          "298-0111",
          "299-4615",
          "299-4611",
          "299-4503",
          "299-4506",
          "299-4505",
          "299-4508",
          "299-4612",
          "299-4622",
          "299-4624",
          "299-4625",
          "299-4504",
          "299-4501",
          "299-4616",
          "299-4623",
          "299-4502",
          "299-4614",
          "299-4621",
          "299-4613",
          "299-4507",
          "298-0132",
          "298-0124",
          "298-0025",
          "298-0122",
          "298-0001",
          "299-3200",
          "299-3245",
          "299-3249",
          "299-3268",
          "299-3251",
          "299-3243",
          "299-3264",
          "299-3262",
          "299-3242",
          "299-3265",
          "299-3248",
          "299-3247",
          "299-3217",
          "299-3218",
          "299-3201",
          "299-3266",
          "299-3216",
          "299-3241",
          "299-3231",
          "299-3261",
          "299-3246",
          "299-3253",
          "299-3235",
          "299-3214",
          "299-3203",
          "299-3212",
          "299-3267",
          "299-3221",
          "299-3215",
          "299-3233",
          "299-3232",
          "299-3213",
          "299-3222",
          "299-3211",
          "299-3237",
          "299-3234",
          "299-3255",
          "299-3219",
          "299-3202",
          "299-3244",
          "299-3223",
          "299-3236",
          "299-3252",
          "299-3263",
          "299-3256",
          "299-3254",
          "285-0900",
          "285-0912",
          "285-0902",
          "285-0904",
          "285-0903",
          "285-0911",
          "285-0906",
          "285-0905",
          "285-0925",
          "285-0927",
          "285-0901",
          "285-0907",
          "285-0924",
          "285-0913",
          "285-0922",
          "285-0921",
          "285-0923",
          "285-0928",
          "285-0914",
          "285-0926",
          "270-1500",
          "270-1516",
          "270-1515",
          "270-1517",
          "270-1504",
          "270-1543",
          "270-1526",
          "270-1503",
          "270-1527",
          "270-1545",
          "270-1511",
          "270-1513",
          "270-1514",
          "270-1525",
          "270-1512",
          "270-1531",
          "270-1544",
          "270-1524",
          "270-1534",
          "270-1522",
          "270-1535",
          "270-1546",
          "270-1532",
          "270-1533",
          "270-1536",
          "270-1502",
          "270-1501",
          "270-1542",
          "270-1506",
          "270-1505",
          "270-1541",
          "270-1523",
          "270-1521",
          "289-0100",
          "289-0205",
          "289-0216",
          "289-0203",
          "289-0214",
          "289-0226",
          "289-0221",
          "289-0201",
          "289-0202",
          "289-0215",
          "289-0223",
          "289-0204",
          "289-0225",
          "289-0213",
          "289-0212",
          "289-0211",
          "289-0222",
          "289-0217",
          "289-0224",
          "289-2200",
          "289-2231",
          "289-2301",
          "289-2317",
          "289-2245",
          "289-2303",
          "289-2305",
          "289-2324",
          "289-2232",
          "289-2251",
          "289-2315",
          "289-2234",
          "289-2322",
          "289-2312",
          "289-2243",
          "289-2242",
          "289-2304",
          "289-2241",
          "289-2246",
          "289-2313",
          "289-2316",
          "289-2254",
          "289-2306",
          "289-2256",
          "289-2314",
          "289-2233",
          "289-2321",
          "282-0031",
          "289-2236",
          "289-2302",
          "289-2244",
          "289-2323",
          "289-2235",
          "289-2247",
          "289-2253",
          "289-2325",
          "289-2257",
          "289-2255",
          "289-2252",
          "289-2311",
          "289-0600",
          "289-0627",
          "289-0612",
          "289-0619",
          "289-0633",
          "289-0621",
          "289-0615",
          "289-0622",
          "289-0635",
          "289-0632",
          "289-0637",
          "289-0624",
          "289-0601",
          "289-0602",
          "289-0616",
          "289-0636",
          "289-0625",
          "289-0611",
          "289-0617",
          "289-0613",
          "289-0631",
          "289-0634",
          "289-0623",
          "289-0614",
          "289-0626",
          "289-0618",
          "283-0100",
          "283-0105",
          "283-0107",
          "283-0104",
          "283-0102",
          "283-0101",
          "283-0117",
          "283-0106",
          "283-0103",
          "283-0116",
          "283-0112",
          "283-0113",
          "283-0111",
          "283-0114",
          "283-0115",
          "289-1600",
          "289-1607",
          "289-1604",
          "282-0035",
          "289-1608",
          "282-0034",
          "289-1603",
          "289-1605",
          "289-1611",
          "289-1612",
          "282-0032",
          "289-1601",
          "289-1624",
          "289-1615",
          "289-1619",
          "289-1613",
          "289-1623",
          "289-1616",
          "289-1617",
          "289-1625",
          "289-1626",
          "282-0033",
          "289-1602",
          "289-1622",
          "289-1621",
          "289-1614",
          "289-1606",
          "289-1618",
          "289-1700",
          "289-1707",
          "289-1706",
          "289-1742",
          "289-1752",
          "289-1711",
          "289-1748",
          "289-1725",
          "289-1745",
          "289-1723",
          "289-1734",
          "289-1726",
          "289-1744",
          "289-1733",
          "289-1731",
          "289-1713",
          "289-1754",
          "289-1755",
          "289-1701",
          "289-1708",
          "289-1715",
          "289-1716",
          "289-1747",
          "289-1712",
          "289-1746",
          "289-1757",
          "289-1704",
          "289-1753",
          "289-1738",
          "289-1737",
          "289-1739",
          "289-1756",
          "289-1741",
          "289-1751",
          "289-1736",
          "289-1714",
          "289-1724",
          "289-1702",
          "289-1703",
          "289-1705",
          "289-1727",
          "289-1717",
          "289-1722",
          "289-1735",
          "289-1743",
          "289-1721",
          "289-1732",
          "289-1749",
          "299-4300",
          "299-4314",
          "299-4315",
          "299-4316",
          "299-4301",
          "299-4313",
          "299-4302",
          "299-4304",
          "299-4303",
          "299-4311",
          "299-4306",
          "299-4305",
          "299-4312",
          "299-4400",
          "299-4412",
          "299-4423",
          "299-4405",
          "299-4403",
          "299-4413",
          "299-4402",
          "299-4411",
          "299-4404",
          "299-4406",
          "299-4415",
          "299-4425",
          "299-4414",
          "299-4421",
          "299-4401",
          "299-4424",
          "299-4422",
          "299-4321",
          "299-4336",
          "299-4343",
          "299-4322",
          "299-4332",
          "299-4337",
          "299-4347",
          "299-4344",
          "299-4346",
          "299-4333",
          "299-4331",
          "299-4327",
          "299-4328",
          "299-4326",
          "299-4325",
          "299-4324",
          "299-4323",
          "299-4342",
          "299-4345",
          "299-4341",
          "299-4335",
          "299-4338",
          "299-4334",
          "299-4200",
          "299-4202",
          "299-4214",
          "299-4217",
          "299-4206",
          "299-4211",
          "299-4216",
          "299-4218",
          "299-4203",
          "299-4215",
          "299-4213",
          "299-4201",
          "299-4204",
          "299-4212",
          "299-4205",
          "297-0200",
          "297-0201",
          "297-0211",
          "297-0223",
          "297-0222",
          "297-0225",
          "297-0226",
          "297-0203",
          "297-0212",
          "297-0218",
          "297-0235",
          "297-0221",
          "297-0224",
          "297-0216",
          "297-0205",
          "297-0215",
          "297-0213",
          "297-0232",
          "297-0214",
          "297-0234",
          "297-0217",
          "297-0207",
          "297-0202",
          "297-0231",
          "297-0206",
          "297-0204",
          "297-0233",
          "297-0100",
          "297-0144",
          "297-0103",
          "297-0101",
          "297-0154",
          "297-0142",
          "297-0136",
          "297-0125",
          "297-0137",
          "297-0132",
          "297-0123",
          "297-0122",
          "297-0145",
          "297-0134",
          "297-0135",
          "297-0138",
          "297-0111",
          "297-0113",
          "297-0114",
          "297-0115",
          "297-0155",
          "297-0105",
          "297-0121",
          "297-0133",
          "297-0131",
          "297-0124",
          "297-0141",
          "297-0104",
          "297-0152",
          "297-0143",
          "297-0151",
          "297-0102",
          "297-0153",
          "297-0112",
          "298-0200",
          "298-0277",
          "298-0256",
          "298-0261",
          "298-0272",
          "298-0263",
          "298-0223",
          "298-0205",
          "298-0235",
          "298-0216",
          "298-0264",
          "298-0225",
          "298-0234",
          "298-0201",
          "298-0279",
          "298-0276",
          "298-0241",
          "298-0253",
          "298-0251",
          "298-0267",
          "298-0215",
          "298-0255",
          "298-0232",
          "298-0238",
          "298-0211",
          "298-0278",
          "298-0265",
          "298-0242",
          "298-0228",
          "298-0213",
          "298-0212",
          "298-0273",
          "298-0202",
          "298-0246",
          "298-0214",
          "298-0207",
          "298-0274",
          "298-0217",
          "298-0266",
          "298-0271",
          "298-0227",
          "298-0231",
          "298-0237",
          "298-0254",
          "298-0233",
          "298-0204",
          "298-0226",
          "298-0262",
          "298-0224",
          "298-0244",
          "298-0252",
          "298-0236",
          "298-0203",
          "298-0245",
          "298-0222",
          "298-0221",
          "298-0243",
          "298-0275",
          "298-0206",
          "299-5100",
          "299-5105",
          "299-5112",
          "299-5111",
          "299-5102",
          "299-5114",
          "299-5103",
          "299-5106",
          "299-5101",
          "299-5113",
          "299-5107",
          "299-5104",
          "299-2100",
          "299-1905",
          "299-2116",
          "299-1907",
          "299-1903",
          "299-2111",
          "299-2112",
          "299-2117",
          "299-2113",
          "299-1904",
          "299-2115",
          "299-1909",
          "299-2114",
          "299-1902",
          "299-1901",
          "299-1906",
          "299-1908",
          "299-2118",
          "100-0000",
          "102-0072",
          "102-0082",
          "101-0032",
          "101-0047",
          "100-0011",
          "100-0004",
          "100-6890",
          "100-6801",
          "100-6802",
          "100-6803",
          "100-6804",
          "100-6805",
          "100-6806",
          "100-6807",
          "100-6808",
          "100-6809",
          "100-6810",
          "100-6811",
          "100-6812",
          "100-6813",
          "100-6814",
          "100-6815",
          "100-6816",
          "100-6817",
          "100-6818",
          "100-6819",
          "100-6820",
          "100-6821",
          "100-6822",
          "100-6823",
          "100-6824",
          "100-6825",
          "100-6826",
          "100-6827",
          "100-6828",
          "100-6829",
          "100-6830",
          "100-6831",
          "100-6832",
          "100-6833",
          "100-6834",
          "100-6835",
          "100-6836",
          "100-6837",
          "101-0044",
          "100-0013",
          "100-6090",
          "100-6001",
          "100-6002",
          "100-6003",
          "100-6004",
          "100-6005",
          "100-6006",
          "100-6007",
          "100-6008",
          "100-6009",
          "100-6010",
          "100-6011",
          "100-6012",
          "100-6013",
          "100-6014",
          "100-6015",
          "100-6016",
          "100-6017",
          "100-6018",
          "100-6019",
          "100-6020",
          "100-6021",
          "100-6022",
          "100-6023",
          "100-6024",
          "100-6025",
          "100-6026",
          "100-6027",
          "100-6028",
          "100-6029",
          "100-6030",
          "100-6031",
          "100-6032",
          "100-6033",
          "100-6034",
          "100-6035",
          "100-6036",
          "101-0029",
          "101-0063",
          "101-0024",
          "101-0033",
          "101-0052",
          "101-0045",
          "101-0036",
          "101-0035",
          "101-0026",
          "101-0025",
          "101-0064",
          "101-0051",
          "101-0041",
          "101-0062",
          "101-0046",
          "101-0048",
          "101-0043",
          "101-0054",
          "101-0037",
          "101-0022",
          "101-0028",
          "101-0034",
          "101-0042",
          "101-0027",
          "101-0023",
          "101-0038",
          "101-0061",
          "101-0053",
          "102-0094",
          "102-0091",
          "102-0074",
          "102-0073",
          "100-0002",
          "102-0083",
          "102-0076",
          "102-0075",
          "101-0021",
          "100-0001",
          "100-0014",
          "100-6190",
          "100-6101",
          "100-6102",
          "100-6103",
          "100-6104",
          "100-6105",
          "100-6106",
          "100-6107",
          "100-6108",
          "100-6109",
          "100-6110",
          "100-6111",
          "100-6112",
          "100-6113",
          "100-6114",
          "100-6115",
          "100-6116",
          "100-6117",
          "100-6118",
          "100-6119",
          "100-6120",
          "100-6121",
          "100-6122",
          "100-6123",
          "100-6124",
          "100-6125",
          "100-6126",
          "100-6127",
          "100-6128",
          "100-6129",
          "100-6130",
          "100-6131",
          "100-6132",
          "100-6133",
          "100-6134",
          "100-6135",
          "100-6136",
          "100-6137",
          "100-6138",
          "100-6139",
          "100-6140",
          "100-6141",
          "100-6142",
          "100-6143",
          "100-6144",
          "101-0065",
          "102-0084",
          "102-0092",
          "101-0031",
          "100-0003",
          "101-0003",
          "100-0012",
          "102-0093",
          "102-0071",
          "100-0005",
          "100-6690",
          "100-6601",
          "100-6602",
          "100-6603",
          "100-6604",
          "100-6605",
          "100-6606",
          "100-6607",
          "100-6608",
          "100-6609",
          "100-6610",
          "100-6611",
          "100-6612",
          "100-6613",
          "100-6614",
          "100-6615",
          "100-6616",
          "100-6617",
          "100-6618",
          "100-6619",
          "100-6620",
          "100-6621",
          "100-6622",
          "100-6623",
          "100-6624",
          "100-6625",
          "100-6626",
          "100-6627",
          "100-6628",
          "100-6629",
          "100-6630",
          "100-6631",
          "100-6632",
          "100-6633",
          "100-6634",
          "100-6635",
          "100-6636",
          "100-6637",
          "100-6638",
          "100-6639",
          "100-6640",
          "100-6641",
          "100-6642",
          "100-6790",
          "100-6701",
          "100-6702",
          "100-6703",
          "100-6704",
          "100-6705",
          "100-6706",
          "100-6707",
          "100-6708",
          "100-6709",
          "100-6710",
          "100-6711",
          "100-6712",
          "100-6713",
          "100-6714",
          "100-6715",
          "100-6716",
          "100-6717",
          "100-6718",
          "100-6719",
          "100-6720",
          "100-6721",
          "100-6722",
          "100-6723",
          "100-6724",
          "100-6725",
          "100-6726",
          "100-6727",
          "100-6728",
          "100-6729",
          "100-6730",
          "100-6731",
          "100-6732",
          "100-6733",
          "100-6734",
          "100-6735",
          "100-6736",
          "100-6737",
          "100-6738",
          "100-6739",
          "100-6740",
          "100-6741",
          "100-6742",
          "100-6743",
          "100-7090",
          "100-7001",
          "100-7002",
          "100-7003",
          "100-7004",
          "100-7005",
          "100-7006",
          "100-7007",
          "100-7008",
          "100-7009",
          "100-7010",
          "100-7011",
          "100-7012",
          "100-7013",
          "100-7014",
          "100-7015",
          "100-7016",
          "100-7017",
          "100-7018",
          "100-7019",
          "100-7020",
          "100-7021",
          "100-7022",
          "100-7023",
          "100-7024",
          "100-7025",
          "100-7026",
          "100-7027",
          "100-7028",
          "100-7029",
          "100-7030",
          "100-7031",
          "100-7032",
          "100-7033",
          "100-7034",
          "100-7035",
          "100-7036",
          "100-7037",
          "100-7038",
          "100-6590",
          "100-6501",
          "100-6502",
          "100-6503",
          "100-6504",
          "100-6505",
          "100-6506",
          "100-6507",
          "100-6508",
          "100-6509",
          "100-6510",
          "100-6511",
          "100-6512",
          "100-6513",
          "100-6514",
          "100-6515",
          "100-6516",
          "100-6517",
          "100-6518",
          "100-6519",
          "100-6520",
          "100-6521",
          "100-6522",
          "100-6523",
          "100-6524",
          "100-6525",
          "100-6526",
          "100-6527",
          "100-6528",
          "100-6529",
          "100-6530",
          "100-6531",
          "100-6532",
          "100-6533",
          "100-6534",
          "100-6535",
          "100-6536",
          "100-6537",
          "100-6538",
          "100-6490",
          "100-6401",
          "100-6402",
          "100-6403",
          "100-6404",
          "100-6405",
          "100-6406",
          "100-6407",
          "100-6408",
          "100-6409",
          "100-6410",
          "100-6411",
          "100-6412",
          "100-6413",
          "100-6414",
          "100-6415",
          "100-6416",
          "100-6417",
          "100-6418",
          "100-6419",
          "100-6420",
          "100-6421",
          "100-6422",
          "100-6423",
          "100-6424",
          "100-6425",
          "100-6426",
          "100-6427",
          "100-6428",
          "100-6429",
          "100-6430",
          "100-6431",
          "100-6432",
          "100-6433",
          "100-6290",
          "100-6201",
          "100-6202",
          "100-6203",
          "100-6204",
          "100-6205",
          "100-6206",
          "100-6207",
          "100-6208",
          "100-6209",
          "100-6210",
          "100-6211",
          "100-6212",
          "100-6213",
          "100-6214",
          "100-6215",
          "100-6216",
          "100-6217",
          "100-6218",
          "100-6219",
          "100-6220",
          "100-6221",
          "100-6222",
          "100-6223",
          "100-6224",
          "100-6225",
          "100-6226",
          "100-6227",
          "100-6228",
          "100-6229",
          "100-6230",
          "100-6231",
          "100-6990",
          "100-6901",
          "100-6902",
          "100-6903",
          "100-6904",
          "100-6905",
          "100-6906",
          "100-6907",
          "100-6908",
          "100-6909",
          "100-6910",
          "100-6911",
          "100-6912",
          "100-6913",
          "100-6914",
          "100-6915",
          "100-6916",
          "100-6917",
          "100-6918",
          "100-6919",
          "100-6920",
          "100-6921",
          "100-6922",
          "100-6923",
          "100-6924",
          "100-6925",
          "100-6926",
          "100-6927",
          "100-6928",
          "100-6929",
          "100-6930",
          "100-6931",
          "100-6932",
          "100-6933",
          "100-6934",
          "100-6390",
          "100-6301",
          "100-6302",
          "100-6303",
          "100-6304",
          "100-6305",
          "100-6306",
          "100-6307",
          "100-6308",
          "100-6309",
          "100-6310",
          "100-6311",
          "100-6312",
          "100-6313",
          "100-6314",
          "100-6315",
          "100-6316",
          "100-6317",
          "100-6318",
          "100-6319",
          "100-6320",
          "100-6321",
          "100-6322",
          "100-6323",
          "100-6324",
          "100-6325",
          "100-6326",
          "100-6327",
          "100-6328",
          "100-6329",
          "100-6330",
          "100-6331",
          "100-6332",
          "100-6333",
          "100-6334",
          "100-6335",
          "100-6336",
          "100-6337",
          "100-0006",
          "102-0081",
          "102-0085",
          "103-0000",
          "104-0044",
          "104-0042",
          "104-0054",
          "104-0031",
          "104-0061",
          "104-0033",
          "104-0041",
          "104-0052",
          "104-0045",
          "104-0051",
          "104-0055",
          "103-0027",
          "103-6090",
          "103-6001",
          "103-6002",
          "103-6003",
          "103-6004",
          "103-6005",
          "103-6006",
          "103-6007",
          "103-6008",
          "103-6009",
          "103-6010",
          "103-6011",
          "103-6012",
          "103-6013",
          "103-6014",
          "103-6015",
          "103-6016",
          "103-6017",
          "103-6018",
          "103-6019",
          "103-6020",
          "103-6021",
          "103-6022",
          "103-6023",
          "103-6024",
          "103-6025",
          "103-6026",
          "103-6027",
          "103-6028",
          "103-6029",
          "103-6030",
          "103-6031",
          "103-6032",
          "103-6033",
          "103-6034",
          "103-6035",
          "103-6190",
          "103-6101",
          "103-6102",
          "103-6103",
          "103-6104",
          "103-6105",
          "103-6106",
          "103-6107",
          "103-6108",
          "103-6109",
          "103-6110",
          "103-6111",
          "103-6112",
          "103-6113",
          "103-6114",
          "103-6115",
          "103-6116",
          "103-6117",
          "103-6118",
          "103-6119",
          "103-6120",
          "103-6121",
          "103-6122",
          "103-6123",
          "103-6124",
          "103-6125",
          "103-6126",
          "103-6127",
          "103-6128",
          "103-6129",
          "103-6130",
          "103-6131",
          "103-6132",
          "103-0011",
          "103-0014",
          "103-0026",
          "103-0025",
          "103-0016",
          "103-0001",
          "103-0024",
          "103-0006",
          "103-0008",
          "103-0013",
          "103-0015",
          "103-0007",
          "103-0002",
          "103-0005",
          "103-0012",
          "103-0021",
          "103-0023",
          "103-0022",
          "103-0003",
          "104-0032",
          "104-0046",
          "104-0053",
          "104-6090",
          "104-6001",
          "104-6002",
          "104-6003",
          "104-6004",
          "104-6005",
          "104-6006",
          "104-6007",
          "104-6008",
          "104-6009",
          "104-6010",
          "104-6011",
          "104-6012",
          "104-6013",
          "104-6014",
          "104-6015",
          "104-6016",
          "104-6017",
          "104-6018",
          "104-6019",
          "104-6020",
          "104-6021",
          "104-6022",
          "104-6023",
          "104-6024",
          "104-6025",
          "104-6026",
          "104-6027",
          "104-6028",
          "104-6029",
          "104-6030",
          "104-6031",
          "104-6032",
          "104-6033",
          "104-6034",
          "104-6035",
          "104-6036",
          "104-6037",
          "104-6038",
          "104-6039",
          "104-6040",
          "104-6041",
          "104-6042",
          "104-6043",
          "104-6044",
          "104-6190",
          "104-6101",
          "104-6102",
          "104-6103",
          "104-6104",
          "104-6105",
          "104-6106",
          "104-6107",
          "104-6108",
          "104-6109",
          "104-6110",
          "104-6111",
          "104-6112",
          "104-6113",
          "104-6114",
          "104-6115",
          "104-6116",
          "104-6117",
          "104-6118",
          "104-6119",
          "104-6120",
          "104-6121",
          "104-6122",
          "104-6123",
          "104-6124",
          "104-6125",
          "104-6126",
          "104-6127",
          "104-6128",
          "104-6129",
          "104-6130",
          "104-6131",
          "104-6132",
          "104-6133",
          "104-6134",
          "104-6135",
          "104-6136",
          "104-6137",
          "104-6138",
          "104-6139",
          "104-6290",
          "104-6201",
          "104-6202",
          "104-6203",
          "104-6204",
          "104-6205",
          "104-6206",
          "104-6207",
          "104-6208",
          "104-6209",
          "104-6210",
          "104-6211",
          "104-6212",
          "104-6213",
          "104-6214",
          "104-6215",
          "104-6216",
          "104-6217",
          "104-6218",
          "104-6219",
          "104-6220",
          "104-6221",
          "104-6222",
          "104-6223",
          "104-6224",
          "104-6225",
          "104-6226",
          "104-6227",
          "104-6228",
          "104-6229",
          "104-6230",
          "104-6231",
          "104-6232",
          "104-6233",
          "103-0004",
          "104-0043",
          "103-0028",
          "104-0028",
          "105-0000",
          "107-0052",
          "107-6090",
          "107-6001",
          "107-6002",
          "107-6003",
          "107-6004",
          "107-6005",
          "107-6006",
          "107-6007",
          "107-6008",
          "107-6009",
          "107-6010",
          "107-6011",
          "107-6012",
          "107-6013",
          "107-6014",
          "107-6015",
          "107-6016",
          "107-6017",
          "107-6018",
          "107-6019",
          "107-6020",
          "107-6021",
          "107-6022",
          "107-6023",
          "107-6024",
          "107-6025",
          "107-6026",
          "107-6027",
          "107-6028",
          "107-6029",
          "107-6030",
          "107-6031",
          "107-6032",
          "107-6033",
          "107-6034",
          "107-6035",
          "107-6036",
          "107-6037",
          "107-6190",
          "107-6101",
          "107-6102",
          "107-6103",
          "107-6104",
          "107-6105",
          "107-6106",
          "107-6107",
          "107-6108",
          "107-6109",
          "107-6110",
          "107-6111",
          "107-6112",
          "107-6113",
          "107-6114",
          "107-6115",
          "107-6116",
          "107-6117",
          "107-6118",
          "107-6119",
          "107-6120",
          "107-6121",
          "107-6122",
          "107-6123",
          "107-6124",
          "107-6125",
          "107-6126",
          "107-6127",
          "107-6128",
          "107-6129",
          "107-6130",
          "107-6390",
          "107-6301",
          "107-6302",
          "107-6303",
          "107-6304",
          "107-6305",
          "107-6306",
          "107-6307",
          "107-6308",
          "107-6309",
          "107-6310",
          "107-6311",
          "107-6312",
          "107-6313",
          "107-6314",
          "107-6315",
          "107-6316",
          "107-6317",
          "107-6318",
          "107-6319",
          "107-6320",
          "107-6321",
          "107-6322",
          "107-6323",
          "107-6324",
          "107-6325",
          "107-6326",
          "107-6327",
          "107-6328",
          "107-6329",
          "107-6330",
          "107-6331",
          "107-6332",
          "107-6333",
          "107-6334",
          "107-6335",
          "107-6336",
          "107-6337",
          "107-6338",
          "107-6339",
          "107-6290",
          "107-6201",
          "107-6202",
          "107-6203",
          "107-6204",
          "107-6205",
          "107-6206",
          "107-6207",
          "107-6208",
          "107-6209",
          "107-6210",
          "107-6211",
          "107-6212",
          "107-6213",
          "107-6214",
          "107-6215",
          "107-6216",
          "107-6217",
          "107-6218",
          "107-6219",
          "107-6220",
          "107-6221",
          "107-6222",
          "107-6223",
          "107-6224",
          "107-6225",
          "107-6226",
          "107-6227",
          "107-6228",
          "107-6229",
          "107-6230",
          "107-6231",
          "107-6232",
          "107-6233",
          "107-6234",
          "107-6235",
          "107-6236",
          "107-6237",
          "107-6238",
          "107-6239",
          "107-6240",
          "107-6241",
          "107-6242",
          "107-6243",
          "107-6244",
          "107-6245",
          "106-0045",
          "106-0041",
          "106-0043",
          "106-0042",
          "105-0002",
          "105-6290",
          "105-6201",
          "105-6202",
          "105-6203",
          "105-6204",
          "105-6205",
          "105-6206",
          "105-6207",
          "105-6208",
          "105-6209",
          "105-6210",
          "105-6211",
          "105-6212",
          "105-6213",
          "105-6214",
          "105-6215",
          "105-6216",
          "105-6217",
          "105-6218",
          "105-6219",
          "105-6220",
          "105-6221",
          "105-6222",
          "105-6223",
          "105-6224",
          "105-6225",
          "105-6226",
          "105-6227",
          "105-6228",
          "105-6229",
          "105-6230",
          "105-6231",
          "105-6232",
          "105-6233",
          "105-6234",
          "105-6235",
          "105-6236",
          "105-6237",
          "105-6238",
          "105-6239",
          "105-6240",
          "105-6241",
          "105-6242",
          "105-0022",
          "108-0022",
          "107-0061",
          "108-0075",
          "108-6090",
          "108-6001",
          "108-6002",
          "108-6003",
          "108-6004",
          "108-6005",
          "108-6006",
          "108-6007",
          "108-6008",
          "108-6009",
          "108-6010",
          "108-6011",
          "108-6012",
          "108-6013",
          "108-6014",
          "108-6015",
          "108-6016",
          "108-6017",
          "108-6018",
          "108-6019",
          "108-6020",
          "108-6021",
          "108-6022",
          "108-6023",
          "108-6024",
          "108-6025",
          "108-6026",
          "108-6027",
          "108-6028",
          "108-6029",
          "108-6030",
          "108-6031",
          "108-6032",
          "108-6190",
          "108-6101",
          "108-6102",
          "108-6103",
          "108-6104",
          "108-6105",
          "108-6106",
          "108-6107",
          "108-6108",
          "108-6109",
          "108-6110",
          "108-6111",
          "108-6112",
          "108-6113",
          "108-6114",
          "108-6115",
          "108-6116",
          "108-6117",
          "108-6118",
          "108-6119",
          "108-6120",
          "108-6121",
          "108-6122",
          "108-6123",
          "108-6124",
          "108-6125",
          "108-6126",
          "108-6127",
          "108-6128",
          "108-6129",
          "108-6130",
          "108-6131",
          "108-6290",
          "108-6201",
          "108-6202",
          "108-6203",
          "108-6204",
          "108-6205",
          "108-6206",
          "108-6207",
          "108-6208",
          "108-6209",
          "108-6210",
          "108-6211",
          "108-6212",
          "108-6213",
          "108-6214",
          "108-6215",
          "108-6216",
          "108-6217",
          "108-6218",
          "108-6219",
          "108-6220",
          "108-6221",
          "108-6222",
          "108-6223",
          "108-6224",
          "108-6225",
          "108-6226",
          "108-6227",
          "108-6228",
          "108-6229",
          "108-6230",
          "108-6231",
          "105-0014",
          "108-0014",
          "105-0023",
          "108-0023",
          "105-0011",
          "105-0012",
          "108-0072",
          "108-0071",
          "105-0004",
          "135-0091",
          "108-0074",
          "105-0001",
          "105-6990",
          "105-6901",
          "105-6902",
          "105-6903",
          "105-6904",
          "105-6905",
          "105-6906",
          "105-6907",
          "105-6908",
          "105-6909",
          "105-6910",
          "105-6911",
          "105-6912",
          "105-6913",
          "105-6914",
          "105-6915",
          "105-6916",
          "105-6917",
          "105-6918",
          "105-6919",
          "105-6920",
          "105-6921",
          "105-6922",
          "105-6923",
          "105-6924",
          "105-6925",
          "105-6926",
          "105-6927",
          "105-6928",
          "105-6929",
          "105-6930",
          "105-6090",
          "105-6001",
          "105-6002",
          "105-6003",
          "105-6004",
          "105-6005",
          "105-6006",
          "105-6007",
          "105-6008",
          "105-6009",
          "105-6010",
          "105-6011",
          "105-6012",
          "105-6013",
          "105-6014",
          "105-6015",
          "105-6016",
          "105-6017",
          "105-6018",
          "105-6019",
          "105-6020",
          "105-6021",
          "105-6022",
          "105-6023",
          "105-6024",
          "105-6025",
          "105-6026",
          "105-6027",
          "105-6028",
          "105-6029",
          "105-6030",
          "105-6031",
          "105-6032",
          "105-6033",
          "105-6034",
          "105-6035",
          "105-6036",
          "105-6037",
          "105-6490",
          "105-6401",
          "105-6402",
          "105-6403",
          "105-6404",
          "105-6405",
          "105-6406",
          "105-6407",
          "105-6408",
          "105-6409",
          "105-6410",
          "105-6411",
          "105-6412",
          "105-6413",
          "105-6414",
          "105-6415",
          "105-6416",
          "105-6417",
          "105-6418",
          "105-6419",
          "105-6420",
          "105-6421",
          "105-6422",
          "105-6423",
          "105-6424",
          "105-6425",
          "105-6426",
          "105-6427",
          "105-6428",
          "105-6429",
          "105-6430",
          "105-6431",
          "105-6432",
          "105-6433",
          "105-6434",
          "105-6435",
          "105-6436",
          "105-6390",
          "105-6301",
          "105-6302",
          "105-6303",
          "105-6304",
          "105-6305",
          "105-6306",
          "105-6307",
          "105-6308",
          "105-6309",
          "105-6310",
          "105-6311",
          "105-6312",
          "105-6313",
          "105-6314",
          "105-6315",
          "105-6316",
          "105-6317",
          "105-6318",
          "105-6319",
          "105-6320",
          "105-6321",
          "105-6322",
          "105-6323",
          "105-6324",
          "105-6325",
          "105-6326",
          "105-6327",
          "105-6328",
          "105-6329",
          "105-6330",
          "105-6331",
          "105-6332",
          "105-6333",
          "105-6334",
          "105-6335",
          "105-6336",
          "106-0031",
          "105-0003",
          "105-0013",
          "105-6190",
          "105-6101",
          "105-6102",
          "105-6103",
          "105-6104",
          "105-6105",
          "105-6106",
          "105-6107",
          "105-6108",
          "105-6109",
          "105-6110",
          "105-6111",
          "105-6112",
          "105-6113",
          "105-6114",
          "105-6115",
          "105-6116",
          "105-6117",
          "105-6118",
          "105-6119",
          "105-6120",
          "105-6121",
          "105-6122",
          "105-6123",
          "105-6124",
          "105-6125",
          "105-6126",
          "105-6127",
          "105-6128",
          "105-6129",
          "105-6130",
          "105-6131",
          "105-6132",
          "105-6133",
          "105-6134",
          "105-6135",
          "105-6136",
          "105-6137",
          "105-6138",
          "105-6139",
          "105-6140",
          "106-0044",
          "105-0021",
          "105-7190",
          "105-7101",
          "105-7102",
          "105-7103",
          "105-7104",
          "105-7105",
          "105-7106",
          "105-7107",
          "105-7108",
          "105-7109",
          "105-7110",
          "105-7111",
          "105-7112",
          "105-7113",
          "105-7114",
          "105-7115",
          "105-7116",
          "105-7117",
          "105-7118",
          "105-7119",
          "105-7120",
          "105-7121",
          "105-7122",
          "105-7123",
          "105-7124",
          "105-7125",
          "105-7126",
          "105-7127",
          "105-7128",
          "105-7129",
          "105-7130",
          "105-7131",
          "105-7132",
          "105-7133",
          "105-7134",
          "105-7135",
          "105-7136",
          "105-7137",
          "105-7138",
          "105-7139",
          "105-7140",
          "105-7141",
          "105-7142",
          "105-7143",
          "105-7290",
          "105-7201",
          "105-7202",
          "105-7203",
          "105-7204",
          "105-7205",
          "105-7206",
          "105-7207",
          "105-7208",
          "105-7209",
          "105-7210",
          "105-7211",
          "105-7212",
          "105-7213",
          "105-7214",
          "105-7215",
          "105-7216",
          "105-7217",
          "105-7218",
          "105-7219",
          "105-7220",
          "105-7221",
          "105-7222",
          "105-7223",
          "105-7224",
          "105-7225",
          "105-7226",
          "105-7227",
          "105-7228",
          "105-7229",
          "105-7230",
          "105-7231",
          "105-7232",
          "105-7233",
          "105-7234",
          "105-7090",
          "105-7001",
          "105-7002",
          "105-7003",
          "105-7004",
          "105-7005",
          "105-7006",
          "105-7007",
          "105-7008",
          "105-7009",
          "105-7010",
          "105-7011",
          "105-7012",
          "105-7013",
          "105-7014",
          "105-7015",
          "105-7016",
          "105-7017",
          "105-7018",
          "105-7019",
          "105-7020",
          "105-7021",
          "105-7022",
          "105-7023",
          "105-7024",
          "105-7025",
          "105-7026",
          "105-7027",
          "105-7028",
          "105-7029",
          "105-7030",
          "105-7031",
          "105-7032",
          "105-7033",
          "105-7034",
          "105-7035",
          "105-7036",
          "105-7037",
          "105-7038",
          "105-7039",
          "105-7040",
          "105-7041",
          "105-7042",
          "105-7043",
          "105-7044",
          "105-7045",
          "105-7046",
          "105-7047",
          "105-7390",
          "105-7301",
          "105-7302",
          "105-7303",
          "105-7304",
          "105-7305",
          "105-7306",
          "105-7307",
          "105-7308",
          "105-7309",
          "105-7310",
          "105-7311",
          "105-7312",
          "105-7313",
          "105-7314",
          "105-7315",
          "105-7316",
          "105-7317",
          "105-7318",
          "105-7319",
          "105-7320",
          "105-7321",
          "105-7322",
          "105-7323",
          "105-7324",
          "105-7325",
          "105-7326",
          "105-7327",
          "105-7328",
          "105-7329",
          "105-7330",
          "105-7331",
          "105-7332",
          "105-7333",
          "105-7334",
          "105-7335",
          "105-7336",
          "105-7337",
          "105-7490",
          "105-7401",
          "105-7402",
          "105-7403",
          "105-7404",
          "105-7405",
          "105-7406",
          "105-7407",
          "105-7408",
          "105-7409",
          "105-7410",
          "105-7411",
          "105-7412",
          "105-7413",
          "105-7414",
          "105-7415",
          "105-7416",
          "105-7417",
          "105-7418",
          "105-7419",
          "105-7420",
          "105-7421",
          "105-7422",
          "105-7423",
          "105-7424",
          "105-7425",
          "105-7426",
          "105-7427",
          "105-7428",
          "105-7429",
          "105-7430",
          "105-7431",
          "105-7432",
          "108-0073",
          "108-6390",
          "108-6301",
          "108-6302",
          "108-6303",
          "108-6304",
          "108-6305",
          "108-6306",
          "108-6307",
          "108-6308",
          "108-6309",
          "108-6310",
          "108-6311",
          "108-6312",
          "108-6313",
          "108-6314",
          "108-6315",
          "108-6316",
          "108-6317",
          "108-6318",
          "108-6319",
          "108-6320",
          "108-6321",
          "108-6322",
          "108-6323",
          "108-6324",
          "108-6325",
          "108-6326",
          "108-6327",
          "108-6328",
          "108-6329",
          "108-6330",
          "107-0062",
          "106-0047",
          "107-0051",
          "106-0046",
          "106-0032",
          "106-6090",
          "106-6001",
          "106-6002",
          "106-6003",
          "106-6004",
          "106-6005",
          "106-6006",
          "106-6007",
          "106-6008",
          "106-6009",
          "106-6010",
          "106-6011",
          "106-6012",
          "106-6013",
          "106-6014",
          "106-6015",
          "106-6016",
          "106-6017",
          "106-6018",
          "106-6019",
          "106-6020",
          "106-6021",
          "106-6022",
          "106-6023",
          "106-6024",
          "106-6025",
          "106-6026",
          "106-6027",
          "106-6028",
          "106-6029",
          "106-6030",
          "106-6031",
          "106-6032",
          "106-6033",
          "106-6034",
          "106-6035",
          "106-6036",
          "106-6037",
          "106-6038",
          "106-6039",
          "106-6040",
          "106-6041",
          "106-6042",
          "106-6043",
          "106-6044",
          "106-6045",
          "106-6290",
          "106-6201",
          "106-6202",
          "106-6203",
          "106-6204",
          "106-6205",
          "106-6206",
          "106-6207",
          "106-6208",
          "106-6209",
          "106-6210",
          "106-6211",
          "106-6212",
          "106-6213",
          "106-6214",
          "106-6215",
          "106-6216",
          "106-6217",
          "106-6218",
          "106-6219",
          "106-6220",
          "106-6221",
          "106-6222",
          "106-6223",
          "106-6224",
          "106-6225",
          "106-6226",
          "106-6227",
          "106-6228",
          "106-6229",
          "106-6230",
          "106-6231",
          "106-6232",
          "106-6233",
          "106-6234",
          "106-6235",
          "106-6236",
          "106-6237",
          "106-6238",
          "106-6239",
          "106-6240",
          "106-6241",
          "106-6242",
          "106-6243",
          "106-6190",
          "106-6101",
          "106-6102",
          "106-6103",
          "106-6104",
          "106-6105",
          "106-6106",
          "106-6107",
          "106-6108",
          "106-6109",
          "106-6110",
          "106-6111",
          "106-6112",
          "106-6113",
          "106-6114",
          "106-6115",
          "106-6116",
          "106-6117",
          "106-6118",
          "106-6119",
          "106-6120",
          "106-6121",
          "106-6122",
          "106-6123",
          "106-6124",
          "106-6125",
          "106-6126",
          "106-6127",
          "106-6128",
          "106-6129",
          "106-6130",
          "106-6131",
          "106-6132",
          "106-6133",
          "106-6134",
          "106-6135",
          "106-6136",
          "106-6137",
          "106-6138",
          "106-6139",
          "106-6140",
          "106-6141",
          "106-6142",
          "106-6143",
          "106-6144",
          "106-6145",
          "106-6146",
          "106-6147",
          "106-6148",
          "106-6149",
          "106-6150",
          "106-6151",
          "106-6152",
          "106-6153",
          "106-6154",
          "160-0000",
          "160-0005",
          "162-0803",
          "162-0817",
          "162-0824",
          "160-0007",
          "162-0062",
          "162-0856",
          "162-0842",
          "162-0846",
          "162-0848",
          "162-0843",
          "162-0066",
          "162-0847",
          "162-0064",
          "162-0844",
          "162-0826",
          "162-0845",
          "162-0063",
          "162-0061",
          "162-0857",
          "162-0832",
          "162-0806",
          "169-0072",
          "162-0802",
          "162-0823",
          "162-0825",
          "160-0013",
          "160-0001",
          "160-0021",
          "161-0034",
          "162-0054",
          "162-0044",
          "169-0074",
          "162-0834",
          "162-0853",
          "162-0838",
          "160-0017",
          "160-0016",
          "161-0033",
          "162-0822",
          "162-0816",
          "162-0814",
          "160-0022",
          "162-0811",
          "160-0018",
          "162-0065",
          "160-0015",
          "169-0075",
          "162-0833",
          "162-0818",
          "162-0821",
          "162-0815",
          "162-0808",
          "169-0071",
          "162-0067",
          "169-0052",
          "162-0052",
          "160-0014",
          "161-0035",
          "161-0032",
          "162-0804",
          "162-0835",
          "162-0837",
          "161-0031",
          "162-0812",
          "160-0023",
          "163-0790",
          "163-0701",
          "163-0702",
          "163-0703",
          "163-0704",
          "163-0705",
          "163-0706",
          "163-0707",
          "163-0708",
          "163-0709",
          "163-0710",
          "163-0711",
          "163-0712",
          "163-0713",
          "163-0714",
          "163-0715",
          "163-0716",
          "163-0717",
          "163-0718",
          "163-0719",
          "163-0720",
          "163-0721",
          "163-0722",
          "163-0723",
          "163-0724",
          "163-0725",
          "163-0726",
          "163-1390",
          "163-1301",
          "163-1302",
          "163-1303",
          "163-1304",
          "163-1305",
          "163-1306",
          "163-1307",
          "163-1308",
          "163-1309",
          "163-1310",
          "163-1311",
          "163-1312",
          "163-1313",
          "163-1314",
          "163-1315",
          "163-1316",
          "163-1317",
          "163-1318",
          "163-1319",
          "163-1320",
          "163-1321",
          "163-1322",
          "163-1323",
          "163-1324",
          "163-1325",
          "163-1326",
          "163-1327",
          "163-1328",
          "163-1329",
          "163-1330",
          "163-1331",
          "163-1332",
          "163-1333",
          "163-1334",
          "163-1335",
          "163-1336",
          "163-1337",
          "163-1338",
          "163-1339",
          "163-1340",
          "163-1341",
          "163-1342",
          "163-1343",
          "163-1344",
          "163-0890",
          "163-0801",
          "163-0802",
          "163-0803",
          "163-0804",
          "163-0805",
          "163-0806",
          "163-0807",
          "163-0808",
          "163-0809",
          "163-0810",
          "163-0811",
          "163-0812",
          "163-0813",
          "163-0814",
          "163-0815",
          "163-0816",
          "163-0817",
          "163-0818",
          "163-0819",
          "163-0820",
          "163-0821",
          "163-0822",
          "163-0823",
          "163-0824",
          "163-0825",
          "163-0826",
          "163-0827",
          "163-0828",
          "163-0829",
          "163-0830",
          "163-1590",
          "163-1501",
          "163-1502",
          "163-1503",
          "163-1504",
          "163-1505",
          "163-1506",
          "163-1507",
          "163-1508",
          "163-1509",
          "163-1510",
          "163-1511",
          "163-1512",
          "163-1513",
          "163-1514",
          "163-1515",
          "163-1516",
          "163-1517",
          "163-1518",
          "163-1519",
          "163-1520",
          "163-1521",
          "163-1522",
          "163-1523",
          "163-1524",
          "163-1525",
          "163-1526",
          "163-1527",
          "163-1528",
          "163-1529",
          "163-1530",
          "163-1531",
          "163-1190",
          "163-1101",
          "163-1102",
          "163-1103",
          "163-1104",
          "163-1105",
          "163-1106",
          "163-1107",
          "163-1108",
          "163-1109",
          "163-1110",
          "163-1111",
          "163-1112",
          "163-1113",
          "163-1114",
          "163-1115",
          "163-1116",
          "163-1117",
          "163-1118",
          "163-1119",
          "163-1120",
          "163-1121",
          "163-1122",
          "163-1123",
          "163-1124",
          "163-1125",
          "163-1126",
          "163-1127",
          "163-1128",
          "163-1129",
          "163-1130",
          "163-0290",
          "163-0201",
          "163-0202",
          "163-0203",
          "163-0204",
          "163-0205",
          "163-0206",
          "163-0207",
          "163-0208",
          "163-0209",
          "163-0210",
          "163-0211",
          "163-0212",
          "163-0213",
          "163-0214",
          "163-0215",
          "163-0216",
          "163-0217",
          "163-0218",
          "163-0219",
          "163-0220",
          "163-0221",
          "163-0222",
          "163-0223",
          "163-0224",
          "163-0225",
          "163-0226",
          "163-0227",
          "163-0228",
          "163-0229",
          "163-0230",
          "163-0231",
          "163-0232",
          "163-0233",
          "163-0234",
          "163-0235",
          "163-0236",
          "163-0237",
          "163-0238",
          "163-0239",
          "163-0240",
          "163-0241",
          "163-0242",
          "163-0243",
          "163-0244",
          "163-0245",
          "163-0246",
          "163-0247",
          "163-0248",
          "163-0249",
          "163-0250",
          "163-0251",
          "163-0252",
          "163-0690",
          "163-0601",
          "163-0602",
          "163-0603",
          "163-0604",
          "163-0605",
          "163-0606",
          "163-0607",
          "163-0608",
          "163-0609",
          "163-0610",
          "163-0611",
          "163-0612",
          "163-0613",
          "163-0614",
          "163-0615",
          "163-0616",
          "163-0617",
          "163-0618",
          "163-0619",
          "163-0620",
          "163-0621",
          "163-0622",
          "163-0623",
          "163-0624",
          "163-0625",
          "163-0626",
          "163-0627",
          "163-0628",
          "163-0629",
          "163-0630",
          "163-0631",
          "163-0632",
          "163-0633",
          "163-0634",
          "163-0635",
          "163-0636",
          "163-0637",
          "163-0638",
          "163-0639",
          "163-0640",
          "163-0641",
          "163-0642",
          "163-0643",
          "163-0644",
          "163-0645",
          "163-0646",
          "163-0647",
          "163-0648",
          "163-0649",
          "163-0650",
          "163-0651",
          "163-0652",
          "163-0653",
          "163-0654",
          "163-0590",
          "163-0501",
          "163-0502",
          "163-0503",
          "163-0504",
          "163-0505",
          "163-0506",
          "163-0507",
          "163-0508",
          "163-0509",
          "163-0510",
          "163-0511",
          "163-0512",
          "163-0513",
          "163-0514",
          "163-0515",
          "163-0516",
          "163-0517",
          "163-0518",
          "163-0519",
          "163-0520",
          "163-0521",
          "163-0522",
          "163-0523",
          "163-0524",
          "163-0525",
          "163-0526",
          "163-0527",
          "163-0528",
          "163-0529",
          "163-0530",
          "163-0531",
          "163-0532",
          "163-0533",
          "163-0534",
          "163-0535",
          "163-0536",
          "163-0537",
          "163-0538",
          "163-0539",
          "163-0540",
          "163-0541",
          "163-0542",
          "163-0543",
          "163-0544",
          "163-0545",
          "163-0546",
          "163-0547",
          "163-0548",
          "163-0549",
          "163-0550",
          "163-1090",
          "163-1001",
          "163-1002",
          "163-1003",
          "163-1004",
          "163-1005",
          "163-1006",
          "163-1007",
          "163-1008",
          "163-1009",
          "163-1010",
          "163-1011",
          "163-1012",
          "163-1013",
          "163-1014",
          "163-1015",
          "163-1016",
          "163-1017",
          "163-1018",
          "163-1019",
          "163-1020",
          "163-1021",
          "163-1022",
          "163-1023",
          "163-1024",
          "163-1025",
          "163-1026",
          "163-1027",
          "163-1028",
          "163-1029",
          "163-1030",
          "163-1031",
          "163-1032",
          "163-1033",
          "163-1034",
          "163-1035",
          "163-1036",
          "163-1037",
          "163-1038",
          "163-1039",
          "163-1040",
          "163-1041",
          "163-1042",
          "163-1043",
          "163-1044",
          "163-1045",
          "163-1046",
          "163-1047",
          "163-1048",
          "163-1049",
          "163-1050",
          "163-1051",
          "163-1052",
          "163-0490",
          "163-0401",
          "163-0402",
          "163-0403",
          "163-0404",
          "163-0405",
          "163-0406",
          "163-0407",
          "163-0408",
          "163-0409",
          "163-0410",
          "163-0411",
          "163-0412",
          "163-0413",
          "163-0414",
          "163-0415",
          "163-0416",
          "163-0417",
          "163-0418",
          "163-0419",
          "163-0420",
          "163-0421",
          "163-0422",
          "163-0423",
          "163-0424",
          "163-0425",
          "163-0426",
          "163-0427",
          "163-0428",
          "163-0429",
          "163-0430",
          "163-0431",
          "163-0432",
          "163-0433",
          "163-0434",
          "163-0435",
          "163-0436",
          "163-0437",
          "163-0438",
          "163-0439",
          "163-0440",
          "163-0441",
          "163-0442",
          "163-0443",
          "163-0444",
          "163-0445",
          "163-0446",
          "163-0447",
          "163-0448",
          "163-0449",
          "163-0450",
          "163-0451",
          "163-0452",
          "163-0453",
          "163-0454",
          "163-0455",
          "163-0990",
          "163-0901",
          "163-0902",
          "163-0903",
          "163-0904",
          "163-0905",
          "163-0906",
          "163-0907",
          "163-0908",
          "163-0909",
          "163-0910",
          "163-0911",
          "163-0912",
          "163-0913",
          "163-0914",
          "163-0915",
          "163-0916",
          "163-0917",
          "163-0918",
          "163-0919",
          "163-0920",
          "163-0921",
          "163-0922",
          "163-0923",
          "163-0924",
          "163-0925",
          "163-0926",
          "163-0927",
          "163-0928",
          "163-0929",
          "163-0930",
          "163-6090",
          "163-6001",
          "163-6002",
          "163-6003",
          "163-6004",
          "163-6005",
          "163-6006",
          "163-6007",
          "163-6008",
          "163-6009",
          "163-6010",
          "163-6011",
          "163-6012",
          "163-6013",
          "163-6014",
          "163-6015",
          "163-6016",
          "163-6017",
          "163-6018",
          "163-6019",
          "163-6020",
          "163-6021",
          "163-6022",
          "163-6023",
          "163-6024",
          "163-6025",
          "163-6026",
          "163-6027",
          "163-6028",
          "163-6029",
          "163-6030",
          "163-6031",
          "163-6032",
          "163-6033",
          "163-6034",
          "163-6035",
          "163-6036",
          "163-6037",
          "163-6038",
          "160-6190",
          "160-6101",
          "160-6102",
          "160-6103",
          "160-6104",
          "160-6105",
          "160-6106",
          "160-6107",
          "160-6108",
          "160-6109",
          "160-6110",
          "160-6111",
          "160-6112",
          "160-6113",
          "160-6114",
          "160-6115",
          "160-6116",
          "160-6117",
          "160-6118",
          "160-6119",
          "160-6120",
          "160-6121",
          "160-6122",
          "160-6123",
          "160-6124",
          "160-6125",
          "160-6126",
          "160-6127",
          "160-6128",
          "160-6129",
          "160-6130",
          "160-6131",
          "160-6132",
          "160-6133",
          "160-6134",
          "160-6135",
          "160-6136",
          "160-6137",
          "160-6138",
          "160-6139",
          "163-1490",
          "163-1401",
          "163-1402",
          "163-1403",
          "163-1404",
          "163-1405",
          "163-1406",
          "163-1407",
          "163-1408",
          "163-1409",
          "163-1410",
          "163-1411",
          "163-1412",
          "163-1413",
          "163-1414",
          "163-1415",
          "163-1416",
          "163-1417",
          "163-1418",
          "163-1419",
          "163-1420",
          "163-1421",
          "163-1422",
          "163-1423",
          "163-1424",
          "163-1425",
          "163-1426",
          "163-1427",
          "163-1428",
          "163-1429",
          "163-1430",
          "163-1431",
          "163-1432",
          "163-1433",
          "163-1434",
          "163-1435",
          "163-1436",
          "163-1437",
          "163-1438",
          "163-1439",
          "163-1440",
          "163-1441",
          "163-1442",
          "163-1443",
          "163-1444",
          "163-1445",
          "163-1446",
          "163-1447",
          "163-1448",
          "163-1449",
          "163-1450",
          "163-1451",
          "163-1452",
          "163-1453",
          "163-1454",
          "162-0855",
          "162-0051",
          "169-0051",
          "162-0045",
          "162-0841",
          "162-0053",
          "162-0807",
          "162-0813",
          "169-0073",
          "162-0828",
          "160-0006",
          "162-0851",
          "162-0852",
          "162-0836",
          "160-0012",
          "162-0854",
          "162-0801",
          "162-0805",
          "162-0831",
          "162-0055",
          "160-0004",
          "160-0002",
          "160-0008",
          "160-0003",
          "160-0011",
          "162-0056",
          "162-0827",
          "162-0041",
          "162-0043",
          "162-0042",
          "112-0000",
          "112-0012",
          "112-0013",
          "112-0003",
          "112-0002",
          "112-0004",
          "112-0006",
          "112-0005",
          "112-0014",
          "112-0011",
          "113-0022",
          "113-0024",
          "113-0031",
          "113-0001",
          "112-0001",
          "113-0021",
          "113-0033",
          "113-0023",
          "112-0015",
          "113-0032",
          "113-0034",
          "110-0000",
          "110-0006",
          "111-0032",
          "111-0053",
          "110-0008",
          "111-0024",
          "110-0013",
          "110-0005",
          "110-0007",
          "110-0002",
          "111-0034",
          "110-0014",
          "111-0022",
          "111-0051",
          "111-0056",
          "111-0042",
          "111-0043",
          "110-0004",
          "111-0031",
          "110-0016",
          "111-0054",
          "111-0035",
          "111-0021",
          "110-0003",
          "111-0023",
          "111-0033",
          "111-0025",
          "110-0015",
          "111-0036",
          "111-0055",
          "110-0011",
          "111-0041",
          "110-0001",
          "111-0052",
          "110-0012",
          "130-0000",
          "130-0001",
          "130-0011",
          "131-0045",
          "130-0014",
          "130-0024",
          "131-0046",
          "130-0013",
          "130-0022",
          "131-0031",
          "130-0012",
          "131-0043",
          "130-0023",
          "130-0025",
          "131-0034",
          "130-0002",
          "130-0005",
          "131-0042",
          "131-0032",
          "131-0044",
          "130-0004",
          "130-0021",
          "131-0033",
          "131-0041",
          "130-0015",
          "130-0003",
          "130-0026",
          "135-0000",
          "135-0064",
          "135-0063",
          "135-0014",
          "135-0066",
          "135-0012",
          "135-0034",
          "135-0051",
          "135-0044",
          "135-0011",
          "136-0072",
          "136-0071",
          "136-0073",
          "135-0042",
          "135-0024",
          "135-0031",
          "135-0003",
          "135-0043",
          "135-0052",
          "135-0062",
          "135-0021",
          "135-0007",
          "136-0082",
          "136-0075",
          "135-0002",
          "135-0015",
          "135-0013",
          "135-0005",
          "135-0053",
          "135-0065",
          "135-0016",
          "135-0006",
          "135-0047",
          "135-0061",
          "135-6090",
          "135-6001",
          "135-6002",
          "135-6003",
          "135-6004",
          "135-6005",
          "135-6006",
          "135-6007",
          "135-6008",
          "135-6009",
          "135-6010",
          "135-6011",
          "135-6012",
          "135-6013",
          "135-6014",
          "135-6015",
          "135-6016",
          "135-6017",
          "135-6018",
          "135-6019",
          "135-6020",
          "135-6021",
          "135-6022",
          "135-6023",
          "135-6024",
          "135-6025",
          "135-6026",
          "135-6027",
          "135-6028",
          "135-6029",
          "135-6030",
          "135-6031",
          "135-6032",
          "135-6033",
          "135-6034",
          "135-6035",
          "135-6036",
          "135-6037",
          "136-0074",
          "135-0023",
          "135-0033",
          "135-0032",
          "135-0041",
          "135-0045",
          "135-0046",
          "136-0076",
          "135-0022",
          "135-0001",
          "135-0004",
          "135-0048",
          "136-0081",
          "136-0083",
          "140-0000",
          "142-0063",
          "140-0014",
          "141-0032",
          "141-6090",
          "141-6001",
          "141-6002",
          "141-6003",
          "141-6004",
          "141-6005",
          "141-6006",
          "141-6007",
          "141-6008",
          "141-6009",
          "141-6010",
          "141-6011",
          "141-6012",
          "141-6013",
          "141-6014",
          "141-6015",
          "141-6016",
          "141-6017",
          "141-6018",
          "141-6019",
          "141-6020",
          "141-6021",
          "141-6022",
          "141-6023",
          "141-6024",
          "141-6025",
          "141-6026",
          "141-6027",
          "141-6028",
          "141-6029",
          "141-6030",
          "140-0012",
          "141-0021",
          "140-0001",
          "141-0001",
          "142-0062",
          "142-0061",
          "142-0041",
          "142-0053",
          "140-0015",
          "141-0031",
          "141-0033",
          "142-0054",
          "142-0064",
          "140-0011",
          "141-0022",
          "140-0002",
          "142-0052",
          "135-0092",
          "142-0051",
          "140-0005",
          "142-0043",
          "140-0013",
          "140-0004",
          "140-0003",
          "142-0042",
          "152-0000",
          "153-0042",
          "152-0033",
          "153-0044",
          "152-0022",
          "153-0051",
          "153-0053",
          "153-0041",
          "153-0064",
          "152-0035",
          "152-0012",
          "152-0032",
          "152-0004",
          "152-0001",
          "153-0065",
          "152-0031",
          "153-0061",
          "152-0011",
          "152-0021",
          "153-0043",
          "152-0003",
          "153-0062",
          "152-0034",
          "152-0013",
          "153-0063",
          "152-0002",
          "152-0023",
          "153-0052",
          "144-0000",
          "146-0082",
          "145-0061",
          "146-0091",
          "143-0014",
          "143-0011",
          "143-0012",
          "143-0015",
          "143-0013",
          "143-0016",
          "144-0052",
          "144-0053",
          "145-0064",
          "144-0032",
          "145-0062",
          "143-0021",
          "145-0073",
          "146-0085",
          "143-0003",
          "143-0023",
          "146-0092",
          "143-0002",
          "143-0004",
          "144-0054",
          "146-0095",
          "146-0083",
          "143-0024",
          "145-0071",
          "145-0072",
          "145-0076",
          "143-0001",
          "146-0081",
          "143-0027",
          "144-0055",
          "144-0051",
          "144-0034",
          "143-0026",
          "145-0075",
          "144-0056",
          "144-0047",
          "144-0043",
          "144-0042",
          "144-0041",
          "144-0031",
          "144-0033",
          "143-0022",
          "145-0074",
          "146-0094",
          "145-0065",
          "144-0046",
          "143-0007",
          "143-0006",
          "143-0005",
          "144-0044",
          "144-0035",
          "146-0084",
          "145-0063",
          "143-0025",
          "145-0066",
          "144-0045",
          "146-0093",
          "145-0067",
          "135-0093",
          "154-0000",
          "156-0044",
          "154-0001",
          "157-0068",
          "154-0022",
          "157-0074",
          "156-0041",
          "157-0076",
          "158-0083",
          "158-0086",
          "157-0063",
          "157-0077",
          "154-0011",
          "156-0057",
          "157-0065",
          "158-0093",
          "158-0098",
          "157-0061",
          "155-0031",
          "157-0067",
          "157-0073",
          "157-0075",
          "157-0064",
          "156-0052",
          "154-0021",
          "154-0012",
          "154-0013",
          "156-0053",
          "156-0054",
          "154-0015",
          "156-0045",
          "154-0024",
          "154-0002",
          "154-0014",
          "157-0066",
          "158-0095",
          "154-0017",
          "157-0072",
          "154-0004",
          "155-0032",
          "155-0033",
          "158-0094",
          "158-0096",
          "158-0085",
          "158-0087",
          "157-0071",
          "154-0016",
          "158-0082",
          "158-0091",
          "158-0092",
          "154-0003",
          "156-0056",
          "156-0042",
          "158-0084",
          "158-0081",
          "156-0055",
          "156-0043",
          "154-0005",
          "157-0062",
          "156-0051",
          "158-0097",
          "154-0023",
          "150-0000",
          "151-0064",
          "150-0032",
          "150-0042",
          "150-0013",
          "150-6090",
          "150-6001",
          "150-6002",
          "150-6003",
          "150-6004",
          "150-6005",
          "150-6006",
          "150-6007",
          "150-6008",
          "150-6009",
          "150-6010",
          "150-6011",
          "150-6012",
          "150-6013",
          "150-6014",
          "150-6015",
          "150-6016",
          "150-6017",
          "150-6018",
          "150-6019",
          "150-6020",
          "150-6021",
          "150-6022",
          "150-6023",
          "150-6024",
          "150-6025",
          "150-6026",
          "150-6027",
          "150-6028",
          "150-6029",
          "150-6030",
          "150-6031",
          "150-6032",
          "150-6033",
          "150-6034",
          "150-6035",
          "150-6036",
          "150-6037",
          "150-6038",
          "150-6039",
          "150-0021",
          "150-0022",
          "151-0065",
          "150-0047",
          "150-0031",
          "151-0073",
          "150-0033",
          "150-0002",
          "150-6190",
          "150-6101",
          "150-6102",
          "150-6103",
          "150-6104",
          "150-6105",
          "150-6106",
          "150-6107",
          "150-6108",
          "150-6109",
          "150-6110",
          "150-6111",
          "150-6112",
          "150-6113",
          "150-6114",
          "150-6115",
          "150-6116",
          "150-6117",
          "150-6118",
          "150-6119",
          "150-6120",
          "150-6121",
          "150-6122",
          "150-6123",
          "150-6124",
          "150-6125",
          "150-6126",
          "150-6127",
          "150-6128",
          "150-6129",
          "150-6130",
          "150-6131",
          "150-6132",
          "150-6133",
          "150-6134",
          "150-6135",
          "150-6136",
          "150-6137",
          "150-6138",
          "150-6139",
          "150-6140",
          "150-6141",
          "150-6142",
          "150-6143",
          "150-6144",
          "150-6145",
          "150-6146",
          "150-6147",
          "150-0046",
          "150-0001",
          "150-0045",
          "150-0041",
          "151-0051",
          "150-0034",
          "150-0043",
          "151-0063",
          "150-0036",
          "151-0066",
          "151-0072",
          "150-0035",
          "151-0061",
          "150-0011",
          "150-0012",
          "151-0071",
          "150-0044",
          "151-0062",
          "151-0053",
          "151-0052",
          "164-0000",
          "165-0026",
          "165-0022",
          "165-0023",
          "165-0031",
          "164-0002",
          "165-0032",
          "165-0035",
          "164-0011",
          "164-0001",
          "165-0025",
          "165-0027",
          "164-0003",
          "164-0012",
          "165-0024",
          "165-0021",
          "164-0014",
          "165-0034",
          "164-0013",
          "165-0033",
          "166-0000",
          "166-0004",
          "166-0001",
          "167-0032",
          "167-0021",
          "168-0063",
          "167-0035",
          "166-0011",
          "168-0064",
          "168-0061",
          "167-0051",
          "167-0023",
          "167-0043",
          "168-0074",
          "168-0082",
          "166-0003",
          "166-0002",
          "167-0033",
          "167-0022",
          "168-0073",
          "167-0054",
          "167-0041",
          "168-0072",
          "168-0071",
          "166-0015",
          "166-0016",
          "167-0053",
          "167-0042",
          "168-0065",
          "168-0062",
          "166-0013",
          "167-0031",
          "166-0014",
          "167-0052",
          "168-0081",
          "167-0034",
          "166-0012",
          "170-0000",
          "170-0014",
          "171-0014",
          "170-0011",
          "171-0043",
          "170-0012",
          "170-0004",
          "170-0003",
          "170-0002",
          "171-0041",
          "171-0032",
          "171-0033",
          "171-0042",
          "171-0044",
          "171-0051",
          "171-0021",
          "170-0001",
          "170-0013",
          "170-6090",
          "170-6001",
          "170-6002",
          "170-6003",
          "170-6004",
          "170-6005",
          "170-6006",
          "170-6007",
          "170-6008",
          "170-6009",
          "170-6010",
          "170-6011",
          "170-6012",
          "170-6013",
          "170-6014",
          "170-6015",
          "170-6016",
          "170-6017",
          "170-6018",
          "170-6019",
          "170-6020",
          "170-6021",
          "170-6022",
          "170-6023",
          "170-6024",
          "170-6025",
          "170-6026",
          "170-6027",
          "170-6028",
          "170-6029",
          "170-6030",
          "170-6031",
          "170-6032",
          "170-6033",
          "170-6034",
          "170-6035",
          "170-6036",
          "170-6037",
          "170-6038",
          "170-6039",
          "170-6040",
          "170-6041",
          "170-6042",
          "170-6043",
          "170-6044",
          "170-6045",
          "170-6046",
          "170-6047",
          "170-6048",
          "170-6049",
          "170-6050",
          "170-6051",
          "170-6052",
          "170-6053",
          "170-6054",
          "170-6055",
          "170-6056",
          "170-6057",
          "170-6058",
          "170-6059",
          "170-6060",
          "171-0022",
          "170-0005",
          "171-0052",
          "171-0031",
          "114-0000",
          "115-0045",
          "115-0053",
          "115-0055",
          "115-0044",
          "115-0052",
          "115-0041",
          "115-0051",
          "114-0002",
          "114-0022",
          "114-0034",
          "114-0016",
          "115-0043",
          "114-0021",
          "115-0054",
          "114-0005",
          "115-0042",
          "114-0033",
          "114-0031",
          "114-0011",
          "114-0023",
          "114-0014",
          "114-0012",
          "114-0003",
          "114-0015",
          "114-0032",
          "115-0056",
          "114-0024",
          "114-0001",
          "114-0013",
          "114-0004",
          "116-0000",
          "116-0002",
          "116-0011",
          "116-0013",
          "116-0012",
          "116-0014",
          "116-0001",
          "116-0003",
          "174-0000",
          "174-0044",
          "175-0092",
          "175-0093",
          "174-0051",
          "174-0055",
          "173-0004",
          "173-0002",
          "174-0061",
          "173-0035",
          "173-0032",
          "173-0031",
          "173-0024",
          "173-0014",
          "173-0033",
          "173-0023",
          "173-0003",
          "174-0076",
          "173-0025",
          "173-0037",
          "173-0034",
          "173-0015",
          "174-0043",
          "174-0075",
          "174-0053",
          "174-0056",
          "175-0081",
          "175-0085",
          "175-0082",
          "174-0074",
          "174-0071",
          "175-0083",
          "173-0016",
          "173-0005",
          "174-0064",
          "173-0022",
          "173-0026",
          "175-0094",
          "174-0045",
          "175-0045",
          "174-0052",
          "174-0046",
          "173-0013",
          "174-0042",
          "174-0073",
          "174-0062",
          "173-0011",
          "174-0041",
          "173-0001",
          "174-0063",
          "175-0091",
          "173-0027",
          "174-0072",
          "174-0054",
          "173-0036",
          "173-0012",
          "173-0021",
          "175-0084",
          "174-0065",
          "176-0000",
          "176-0005",
          "179-0071",
          "178-0061",
          "178-0062",
          "179-0074",
          "177-0044",
          "177-0043",
          "179-0081",
          "176-0022",
          "176-0004",
          "176-0006",
          "176-0002",
          "177-0042",
          "177-0045",
          "177-0041",
          "177-0052",
          "177-0053",
          "177-0051",
          "177-0033",
          "179-0075",
          "179-0073",
          "177-0054",
          "179-0076",
          "176-0011",
          "176-0013",
          "176-0014",
          "176-0012",
          "176-0024",
          "176-0025",
          "176-0023",
          "178-0065",
          "178-0066",
          "179-0082",
          "176-0021",
          "176-0001",
          "176-0003",
          "179-0085",
          "179-0072",
          "179-0084",
          "178-0063",
          "177-0034",
          "179-0083",
          "178-0064",
          "177-0035",
          "177-0031",
          "177-0032",
          "120-0000",
          "120-0012",
          "121-0012",
          "120-0015",
          "120-0005",
          "121-0823",
          "121-0807",
          "121-0836",
          "121-0834",
          "121-0816",
          "123-0851",
          "123-0873",
          "120-0001",
          "123-0844",
          "120-0046",
          "123-0861",
          "121-0055",
          "121-0056",
          "123-0842",
          "120-0013",
          "123-0872",
          "121-0833",
          "121-0832",
          "121-0053",
          "123-0862",
          "123-0864",
          "121-0815",
          "123-0865",
          "121-0051",
          "121-0057",
          "123-0852",
          "120-0034",
          "120-0023",
          "120-0026",
          "120-0025",
          "120-0031",
          "120-0037",
          "120-0033",
          "120-0045",
          "120-0024",
          "120-0042",
          "120-0035",
          "120-0036",
          "120-0038",
          "120-0044",
          "120-0043",
          "120-0041",
          "120-0032",
          "121-0813",
          "121-0054",
          "120-0011",
          "121-0011",
          "123-0871",
          "120-0003",
          "121-0831",
          "121-0837",
          "121-0835",
          "120-0002",
          "120-0014",
          "123-0841",
          "123-0843",
          "123-0845",
          "121-0824",
          "121-0825",
          "121-0074",
          "121-0822",
          "121-0812",
          "121-0061",
          "120-0004",
          "121-0801",
          "121-0063",
          "121-0071",
          "121-0075",
          "120-0021",
          "121-0076",
          "121-0064",
          "121-0072",
          "123-0874",
          "121-0062",
          "120-0047",
          "121-0052",
          "123-0853",
          "123-0854",
          "123-0856",
          "123-0855",
          "123-0857",
          "123-0863",
          "120-0006",
          "120-0022",
          "121-0814",
          "121-0073",
          "124-0000",
          "125-0062",
          "124-0022",
          "124-0003",
          "125-0042",
          "125-0043",
          "125-0053",
          "125-0061",
          "124-0001",
          "125-0052",
          "125-0063",
          "124-0024",
          "125-0054",
          "124-0005",
          "124-0012",
          "125-0051",
          "124-0002",
          "125-0002",
          "124-0025",
          "125-0031",
          "125-0041",
          "124-0023",
          "124-0013",
          "124-0004",
          "125-0033",
          "124-0014",
          "124-0021",
          "124-0006",
          "125-0032",
          "125-0034",
          "125-0035",
          "124-0011",
          "132-0000",
          "132-0024",
          "134-0092",
          "134-0082",
          "132-0013",
          "134-0013",
          "132-0022",
          "133-0042",
          "133-0041",
          "133-0054",
          "134-0081",
          "133-0051",
          "133-0053",
          "132-0034",
          "133-0073",
          "133-0072",
          "133-0061",
          "133-0064",
          "134-0087",
          "132-0021",
          "134-0083",
          "132-0001",
          "132-0023",
          "134-0088",
          "133-0057",
          "132-0032",
          "133-0055",
          "132-0015",
          "134-0015",
          "134-0093",
          "132-0003",
          "134-0003",
          "134-0084",
          "133-0052",
          "132-0033",
          "133-0063",
          "133-0062",
          "133-0071",
          "132-0014",
          "132-0035",
          "134-0091",
          "133-0044",
          "132-0025",
          "132-0031",
          "133-0043",
          "132-0011",
          "134-0085",
          "133-0056",
          "133-0065",
          "132-0002",
          "133-0002",
          "134-0086",
          "192-0000",
          "192-0043",
          "192-0083",
          "192-0082",
          "192-0032",
          "193-0814",
          "193-0802",
          "192-0902",
          "192-0911",
          "192-0024",
          "192-0915",
          "192-0013",
          "193-0841",
          "192-0056",
          "192-0352",
          "193-0935",
          "192-0034",
          "192-0062",
          "192-0045",
          "192-0054",
          "192-0025",
          "192-0155",
          "192-0353",
          "192-0004",
          "192-0914",
          "193-0815",
          "193-0811",
          "192-0156",
          "192-0151",
          "192-0373",
          "193-0801",
          "193-0821",
          "192-0913",
          "192-0906",
          "192-0912",
          "193-0804",
          "193-0942",
          "192-0023",
          "192-0361",
          "193-0934",
          "192-0031",
          "192-0904",
          "192-0012",
          "193-0832",
          "192-0154",
          "192-0372",
          "193-0825",
          "192-0065",
          "193-0812",
          "193-0835",
          "193-0931",
          "193-0816",
          "192-0022",
          "193-0844",
          "192-0033",
          "192-0002",
          "192-0011",
          "193-0944",
          "192-0064",
          "192-0003",
          "193-0943",
          "192-0073",
          "192-0074",
          "193-0843",
          "192-0001",
          "192-0085",
          "192-0041",
          "192-0042",
          "192-0015",
          "192-0374",
          "192-0907",
          "193-0824",
          "192-0919",
          "193-0831",
          "193-0803",
          "192-0371",
          "193-0842",
          "192-0917",
          "192-0153",
          "193-0822",
          "193-0941",
          "192-0053",
          "193-0845",
          "193-0834",
          "192-0351",
          "192-0918",
          "193-0836",
          "192-0061",
          "192-0044",
          "192-0363",
          "192-0355",
          "192-0052",
          "192-0066",
          "192-0354",
          "192-0362",
          "192-0021",
          "192-0084",
          "192-0014",
          "193-0932",
          "193-0846",
          "192-0364",
          "192-0075",
          "192-0072",
          "192-0916",
          "192-0005",
          "192-0152",
          "192-0046",
          "193-0833",
          "193-0826",
          "192-0051",
          "192-0063",
          "192-0055",
          "192-0016",
          "193-0933",
          "192-0375",
          "192-0071",
          "193-0823",
          "192-0081",
          "193-0813",
          "192-0903",
          "190-0000",
          "190-0012",
          "190-0015",
          "190-0033",
          "190-0004",
          "190-0032",
          "190-0002",
          "190-0003",
          "190-0023",
          "190-0031",
          "190-0011",
          "190-0022",
          "190-0034",
          "190-0021",
          "190-0013",
          "190-0014",
          "190-0001",
          "180-0000",
          "180-0004",
          "180-0002",
          "180-0003",
          "180-0001",
          "180-0023",
          "180-0005",
          "180-0022",
          "180-0021",
          "180-0014",
          "180-0006",
          "180-0013",
          "180-0012",
          "180-0011",
          "181-0000",
          "181-0011",
          "181-0001",
          "181-0015",
          "181-0012",
          "181-0003",
          "181-0013",
          "181-0004",
          "181-0016",
          "181-0005",
          "181-0014",
          "181-0002",
          "198-0000",
          "198-0087",
          "198-0023",
          "198-0021",
          "198-0088",
          "198-0086",
          "198-0003",
          "198-0041",
          "198-0036",
          "198-0081",
          "198-0013",
          "198-0005",
          "198-0053",
          "198-0172",
          "198-0011",
          "198-0024",
          "198-0025",
          "198-0084",
          "198-0014",
          "198-0085",
          "198-0043",
          "198-0002",
          "198-0051",
          "198-0082",
          "198-0052",
          "198-0001",
          "198-0044",
          "198-0004",
          "198-0032",
          "198-0063",
          "198-0061",
          "198-0042",
          "198-0046",
          "198-0015",
          "198-0022",
          "198-0171",
          "198-0083",
          "198-0174",
          "198-0175",
          "198-0173",
          "198-0089",
          "198-0031",
          "198-0012",
          "198-0064",
          "198-0062",
          "183-0000",
          "183-0003",
          "183-0012",
          "183-0021",
          "183-0041",
          "183-0056",
          "183-0013",
          "183-0014",
          "183-0054",
          "183-0051",
          "183-0015",
          "183-0011",
          "183-0052",
          "183-0034",
          "183-0001",
          "183-0002",
          "183-0053",
          "183-0043",
          "183-0046",
          "183-0031",
          "183-0044",
          "183-0036",
          "183-0016",
          "183-0057",
          "183-0024",
          "183-0055",
          "183-0033",
          "183-0032",
          "183-0027",
          "183-0006",
          "183-0026",
          "183-0022",
          "183-0023",
          "183-0045",
          "183-0042",
          "183-0004",
          "183-0025",
          "183-0035",
          "183-0005",
          "196-0000",
          "196-0025",
          "196-0033",
          "196-0013",
          "196-0032",
          "196-0011",
          "196-0015",
          "196-0014",
          "196-0034",
          "196-0023",
          "196-0012",
          "196-0022",
          "196-0002",
          "196-0031",
          "196-0003",
          "196-0004",
          "196-0001",
          "196-0024",
          "196-0021",
          "196-0035",
          "182-0000",
          "182-0004",
          "182-0035",
          "182-0007",
          "182-0022",
          "182-0026",
          "182-0016",
          "182-0014",
          "182-0034",
          "182-0012",
          "182-0013",
          "182-0011",
          "182-0017",
          "182-0002",
          "182-0023",
          "182-0025",
          "182-0021",
          "182-0036",
          "182-0006",
          "182-0032",
          "182-0031",
          "182-0005",
          "182-0033",
          "182-0024",
          "182-0001",
          "182-0015",
          "182-0003",
          "194-0000",
          "194-0211",
          "194-0023",
          "195-0062",
          "194-0003",
          "195-0064",
          "194-0215",
          "194-0204",
          "194-0212",
          "195-0072",
          "195-0071",
          "194-0012",
          "194-0015",
          "194-0201",
          "194-0037",
          "194-0036",
          "194-0033",
          "194-0014",
          "194-0202",
          "195-0057",
          "195-0051",
          "194-0203",
          "194-0035",
          "194-0041",
          "194-0001",
          "195-0061",
          "194-0004",
          "194-0213",
          "194-0021",
          "194-0044",
          "194-0011",
          "194-0043",
          "194-0046",
          "194-0038",
          "194-0034",
          "195-0053",
          "195-0063",
          "194-0013",
          "194-0042",
          "195-0056",
          "195-0052",
          "194-0032",
          "194-0031",
          "194-0002",
          "194-0045",
          "194-0005",
          "195-0054",
          "195-0055",
          "194-0022",
          "195-0073",
          "194-0214",
          "195-0075",
          "195-0074",
          "184-0000",
          "184-0002",
          "184-0005",
          "184-0001",
          "184-0012",
          "184-0014",
          "184-0015",
          "184-0011",
          "184-0004",
          "184-0013",
          "184-0003",
          "187-0000",
          "187-0001",
          "187-0031",
          "187-0035",
          "187-0032",
          "187-0043",
          "187-0045",
          "187-0044",
          "187-0034",
          "187-0023",
          "187-0022",
          "187-0021",
          "187-0011",
          "187-0024",
          "187-0025",
          "187-0004",
          "187-0033",
          "187-0042",
          "187-0002",
          "187-0003",
          "187-0041",
          "187-0012",
          "187-0013",
          "191-0000",
          "191-0065",
          "191-0022",
          "191-0021",
          "191-0061",
          "191-0034",
          "191-0014",
          "191-0015",
          "191-0001",
          "191-0063",
          "191-0023",
          "191-0002",
          "191-0016",
          "191-0031",
          "191-0062",
          "191-0051",
          "191-0053",
          "191-0055",
          "191-0052",
          "191-0054",
          "191-0012",
          "191-0003",
          "191-0011",
          "191-0043",
          "191-0064",
          "191-0042",
          "191-0024",
          "191-0032",
          "191-0041",
          "191-0013",
          "191-0033",
          "189-0000",
          "189-0002",
          "189-0001",
          "189-0011",
          "189-0003",
          "189-0013",
          "189-0021",
          "189-0026",
          "189-0022",
          "189-0012",
          "189-0024",
          "189-0014",
          "189-0023",
          "189-0025",
          "185-0000",
          "185-0024",
          "185-0001",
          "185-0004",
          "185-0036",
          "185-0003",
          "185-0033",
          "185-0005",
          "185-0013",
          "185-0035",
          "185-0023",
          "185-0034",
          "185-0014",
          "185-0002",
          "185-0022",
          "185-0032",
          "185-0031",
          "185-0011",
          "185-0012",
          "185-0021",
          "186-0000",
          "186-0013",
          "186-0014",
          "186-0012",
          "186-0001",
          "186-0004",
          "186-0005",
          "186-0002",
          "186-0003",
          "186-0015",
          "186-0011",
          "197-0000",
          "197-0024",
          "197-0012",
          "197-0005",
          "197-0003",
          "197-0002",
          "197-0023",
          "197-0021",
          "197-0011",
          "197-0014",
          "197-0022",
          "197-0004",
          "197-0013",
          "197-0001",
          "201-0000",
          "201-0003",
          "201-0015",
          "201-0005",
          "201-0004",
          "201-0016",
          "201-0012",
          "201-0011",
          "201-0001",
          "201-0014",
          "201-0002",
          "201-0013",
          "207-0000",
          "207-0033",
          "207-0023",
          "207-0011",
          "207-0002",
          "207-0022",
          "207-0003",
          "207-0004",
          "207-0012",
          "207-0032",
          "207-0005",
          "207-0021",
          "207-0001",
          "207-0015",
          "207-0016",
          "207-0031",
          "207-0014",
          "207-0013",
          "204-0000",
          "204-0002",
          "204-0024",
          "204-0013",
          "204-0001",
          "204-0011",
          "204-0023",
          "204-0012",
          "204-0003",
          "204-0004",
          "204-0022",
          "204-0021",
          "203-0000",
          "203-0001",
          "203-0021",
          "203-0003",
          "203-0051",
          "203-0052",
          "203-0043",
          "203-0013",
          "203-0002",
          "203-0012",
          "203-0011",
          "203-0033",
          "203-0054",
          "203-0041",
          "203-0042",
          "203-0004",
          "203-0014",
          "203-0022",
          "203-0053",
          "203-0032",
          "203-0023",
          "203-0031",
          "203-0044",
          "203-0034",
          "208-0000",
          "208-0023",
          "208-0022",
          "208-0013",
          "208-0011",
          "208-0031",
          "208-0034",
          "208-0002",
          "208-0003",
          "208-0001",
          "208-0035",
          "208-0004",
          "208-0033",
          "208-0032",
          "208-0021",
          "208-0012",
          "206-0000",
          "206-0041",
          "206-0002",
          "206-0033",
          "206-0015",
          "206-0012",
          "206-0035",
          "206-0014",
          "206-0013",
          "206-0042",
          "206-0024",
          "206-0011",
          "206-0034",
          "206-0031",
          "206-0036",
          "206-0025",
          "206-0003",
          "206-0022",
          "206-0023",
          "206-0032",
          "206-0004",
          "206-0021",
          "206-0001",
          "206-0801",
          "206-0811",
          "206-0803",
          "206-0822",
          "206-0821",
          "206-0802",
          "206-0823",
          "206-0804",
          "206-0812",
          "206-0824",
          "205-0000",
          "205-0001",
          "205-0021",
          "205-0011",
          "205-0002",
          "205-0023",
          "205-0024",
          "205-0012",
          "205-0016",
          "205-0015",
          "205-0014",
          "205-0017",
          "205-0013",
          "205-0022",
          "205-0003",
          "190-0100",
          "197-0804",
          "197-0828",
          "190-0155",
          "197-0827",
          "197-0825",
          "190-0164",
          "190-0142",
          "190-0161",
          "190-0143",
          "197-0826",
          "197-0821",
          "197-0822",
          "190-0174",
          "197-0832",
          "197-0824",
          "197-0802",
          "190-0165",
          "190-0153",
          "190-0151",
          "190-0162",
          "197-0831",
          "197-0801",
          "197-0803",
          "190-0154",
          "190-0163",
          "190-0166",
          "190-0173",
          "190-0152",
          "197-0814",
          "197-0815",
          "197-0823",
          "197-0811",
          "197-0834",
          "197-0812",
          "197-0816",
          "197-0813",
          "190-0172",
          "197-0833",
          "190-0144",
          "190-0171",
          "190-0141",
          "202-0000",
          "202-0011",
          "188-0003",
          "202-0003",
          "202-0006",
          "188-0014",
          "202-0004",
          "202-0023",
          "202-0005",
          "188-0011",
          "202-0013",
          "188-0004",
          "202-0012",
          "202-0021",
          "202-0001",
          "202-0002",
          "202-0014",
          "202-0015",
          "188-0002",
          "188-0012",
          "188-0013",
          "202-0022",
          "188-0001",
          "190-1200",
          "190-1211",
          "190-1202",
          "190-1203",
          "190-1212",
          "190-1232",
          "190-1233",
          "190-1231",
          "190-1234",
          "190-1201",
          "190-1221",
          "190-1222",
          "190-1223",
          "190-1204",
          "190-1224",
          "190-1213",
          "190-1214",
          "190-0181",
          "190-0182",
          "190-0200",
          "190-0204",
          "190-0221",
          "190-0203",
          "190-0212",
          "190-0201",
          "190-0213",
          "190-0223",
          "190-0205",
          "190-0202",
          "190-0222",
          "190-0211",
          "190-0214",
          "198-0213",
          "198-0103",
          "198-0101",
          "198-0102",
          "198-0225",
          "198-0224",
          "198-0105",
          "198-0222",
          "198-0107",
          "198-0106",
          "198-0104",
          "198-0221",
          "198-0211",
          "198-0223",
          "198-0212",
          "100-0100",
          "100-0102",
          "100-0211",
          "100-0103",
          "100-0104",
          "100-0212",
          "100-0101",
          "100-0301",
          "100-0400",
          "100-0511",
          "100-0402",
          "100-0401",
          "100-0601",
          "100-1100",
          "100-1212",
          "100-1103",
          "100-1102",
          "100-1213",
          "100-1101",
          "100-1211",
          "100-1301",
          "100-1400",
          "100-1401",
          "100-1621",
          "100-1622",
          "100-1623",
          "100-1511",
          "100-1701",
          "100-2100",
          "100-2101",
          "100-2211",
          "230-0000",
          "230-0033",
          "230-0035",
          "230-0021",
          "230-0024",
          "230-0022",
          "230-0023",
          "230-0026",
          "230-0025",
          "230-0041",
          "230-0002",
          "230-0055",
          "230-0046",
          "230-0072",
          "230-0011",
          "230-0075",
          "230-0034",
          "230-0078",
          "230-0074",
          "230-0071",
          "230-0038",
          "230-0043",
          "230-0073",
          "230-0047",
          "230-0003",
          "230-0012",
          "230-0045",
          "230-0027",
          "230-0014",
          "230-0053",
          "230-0054",
          "230-0032",
          "230-0061",
          "230-0063",
          "230-0051",
          "230-0015",
          "230-0062",
          "230-0042",
          "230-0052",
          "230-0076",
          "230-0036",
          "230-0077",
          "230-0017",
          "230-0018",
          "230-0016",
          "230-0031",
          "230-0044",
          "230-0048",
          "230-0013",
          "230-0037",
          "230-0004",
          "230-0001",
          "221-0000",
          "221-0057",
          "221-0814",
          "221-0032",
          "221-0842",
          "221-0014",
          "221-0062",
          "221-0042",
          "221-0024",
          "221-0002",
          "221-0003",
          "221-0055",
          "221-0865",
          "221-0045",
          "221-0046",
          "221-0831",
          "221-0011",
          "221-0015",
          "221-0041",
          "221-0801",
          "221-0832",
          "221-0056",
          "221-0804",
          "221-0051",
          "221-0012",
          "221-0021",
          "221-0811",
          "221-0052",
          "221-0844",
          "221-0862",
          "221-0075",
          "221-0071",
          "221-0072",
          "221-0074",
          "221-0073",
          "221-0077",
          "221-0076",
          "221-0031",
          "221-0013",
          "221-0043",
          "221-0864",
          "221-0033",
          "221-0834",
          "221-0833",
          "221-0023",
          "221-0063",
          "221-0825",
          "221-0036",
          "221-0835",
          "221-0821",
          "221-0064",
          "221-0803",
          "221-0061",
          "221-0004",
          "221-0822",
          "221-0001",
          "221-0813",
          "221-0065",
          "221-0863",
          "221-0866",
          "221-0053",
          "221-0044",
          "221-0812",
          "221-0824",
          "221-0823",
          "221-0035",
          "221-0843",
          "221-0005",
          "221-0841",
          "221-0034",
          "221-0856",
          "221-0851",
          "221-0852",
          "221-0853",
          "221-0855",
          "221-0854",
          "221-0022",
          "221-0054",
          "221-0802",
          "220-0000",
          "220-0034",
          "220-0033",
          "220-0045",
          "220-0032",
          "220-0073",
          "220-0035",
          "220-0001",
          "220-0004",
          "220-0003",
          "220-0061",
          "220-0043",
          "220-0054",
          "220-0021",
          "220-0071",
          "220-0072",
          "220-0011",
          "220-0051",
          "220-0042",
          "220-0041",
          "220-0046",
          "220-0024",
          "220-0052",
          "220-0022",
          "220-0055",
          "220-0062",
          "220-0023",
          "220-0053",
          "220-0013",
          "220-0012",
          "220-6090",
          "220-6001",
          "220-6002",
          "220-6003",
          "220-6004",
          "220-6005",
          "220-6006",
          "220-6007",
          "220-6008",
          "220-6009",
          "220-6010",
          "220-6011",
          "220-6012",
          "220-6013",
          "220-6014",
          "220-6015",
          "220-6016",
          "220-6017",
          "220-6018",
          "220-6019",
          "220-6020",
          "220-6021",
          "220-6022",
          "220-6023",
          "220-6024",
          "220-6025",
          "220-6026",
          "220-6027",
          "220-6028",
          "220-6029",
          "220-6030",
          "220-6031",
          "220-6032",
          "220-6033",
          "220-6034",
          "220-6035",
          "220-6190",
          "220-6101",
          "220-6102",
          "220-6103",
          "220-6104",
          "220-6105",
          "220-6106",
          "220-6107",
          "220-6108",
          "220-6109",
          "220-6110",
          "220-6111",
          "220-6112",
          "220-6113",
          "220-6114",
          "220-6115",
          "220-6116",
          "220-6117",
          "220-6118",
          "220-6119",
          "220-6120",
          "220-6121",
          "220-6122",
          "220-6123",
          "220-6124",
          "220-6125",
          "220-6126",
          "220-6127",
          "220-6128",
          "220-6290",
          "220-6201",
          "220-6202",
          "220-6203",
          "220-6204",
          "220-6205",
          "220-6206",
          "220-6207",
          "220-6208",
          "220-6209",
          "220-6210",
          "220-6211",
          "220-6212",
          "220-6213",
          "220-6214",
          "220-6215",
          "220-6216",
          "220-6217",
          "220-6218",
          "220-6219",
          "220-6220",
          "220-6221",
          "220-8190",
          "220-8101",
          "220-8102",
          "220-8103",
          "220-8104",
          "220-8105",
          "220-8106",
          "220-8107",
          "220-8108",
          "220-8109",
          "220-8110",
          "220-8111",
          "220-8112",
          "220-8113",
          "220-8114",
          "220-8115",
          "220-8116",
          "220-8117",
          "220-8118",
          "220-8119",
          "220-8120",
          "220-8121",
          "220-8122",
          "220-8123",
          "220-8124",
          "220-8125",
          "220-8126",
          "220-8127",
          "220-8128",
          "220-8129",
          "220-8130",
          "220-8131",
          "220-8132",
          "220-8133",
          "220-8134",
          "220-8135",
          "220-8136",
          "220-8137",
          "220-8138",
          "220-8139",
          "220-8140",
          "220-8141",
          "220-8142",
          "220-8143",
          "220-8144",
          "220-8145",
          "220-8146",
          "220-8147",
          "220-8148",
          "220-8149",
          "220-8150",
          "220-8151",
          "220-8152",
          "220-8153",
          "220-8154",
          "220-8155",
          "220-8156",
          "220-8157",
          "220-8158",
          "220-8159",
          "220-8160",
          "220-8161",
          "220-8162",
          "220-8163",
          "220-8164",
          "220-8165",
          "220-8166",
          "220-8167",
          "220-8168",
          "220-8169",
          "220-8170",
          "220-0002",
          "220-0005",
          "220-0074",
          "220-0006",
          "220-0031",
          "220-0063",
          "220-0044",
          "231-0000",
          "231-0012",
          "231-0051",
          "231-0057",
          "231-0834",
          "231-0868",
          "231-0045",
          "231-0842",
          "231-0867",
          "231-0061",
          "231-0027",
          "231-0858",
          "231-0011",
          "231-0859",
          "231-0028",
          "231-0015",
          "231-0002",
          "231-0866",
          "231-0813",
          "231-0865",
          "231-0003",
          "231-0054",
          "231-0026",
          "231-0802",
          "231-0848",
          "231-0062",
          "231-0001",
          "231-0801",
          "231-0046",
          "231-0055",
          "231-0013",
          "231-0863",
          "231-0837",
          "231-0847",
          "231-0845",
          "231-0035",
          "231-0815",
          "231-0033",
          "231-0864",
          "231-0857",
          "231-0855",
          "231-0014",
          "231-0814",
          "231-0839",
          "231-0812",
          "231-0852",
          "231-0844",
          "231-0021",
          "231-0854",
          "231-0835",
          "231-0853",
          "231-0836",
          "231-0064",
          "231-0047",
          "231-0053",
          "231-0063",
          "231-0052",
          "231-0031",
          "231-0066",
          "231-0043",
          "231-0044",
          "231-0042",
          "231-0037",
          "231-0032",
          "231-0007",
          "231-0048",
          "231-0843",
          "231-0005",
          "231-0826",
          "231-0823",
          "231-0824",
          "231-0803",
          "231-0821",
          "231-0811",
          "231-0825",
          "231-0833",
          "231-0832",
          "231-0804",
          "231-0822",
          "231-0827",
          "231-0806",
          "231-0016",
          "231-0025",
          "231-0838",
          "231-0017",
          "231-0006",
          "231-0816",
          "231-0856",
          "231-0065",
          "231-0841",
          "231-0034",
          "231-0849",
          "231-0004",
          "231-0861",
          "231-0831",
          "231-0023",
          "231-0036",
          "231-0862",
          "231-0846",
          "231-0038",
          "231-0851",
          "231-0058",
          "231-0022",
          "231-0041",
          "231-0024",
          "231-0056",
          "231-0805",
          "232-0000",
          "232-0051",
          "232-0052",
          "232-0053",
          "232-0024",
          "232-0031",
          "232-0044",
          "232-0061",
          "232-0054",
          "232-0008",
          "232-0034",
          "232-0015",
          "232-0067",
          "232-0013",
          "232-0036",
          "232-0007",
          "232-0017",
          "232-0005",
          "232-0023",
          "232-0027",
          "232-0025",
          "232-0022",
          "232-0056",
          "232-0063",
          "232-0062",
          "232-0055",
          "232-0033",
          "232-0074",
          "232-0076",
          "232-0075",
          "232-0072",
          "232-0073",
          "232-0071",
          "232-0003",
          "232-0037",
          "232-0018",
          "232-0011",
          "232-0045",
          "232-0001",
          "232-0026",
          "232-0035",
          "232-0064",
          "232-0065",
          "232-0042",
          "232-0043",
          "232-0004",
          "232-0021",
          "232-0032",
          "232-0006",
          "232-0012",
          "232-0002",
          "232-0016",
          "232-0066",
          "232-0041",
          "232-0014",
          "232-0057",
          "240-0000",
          "240-0053",
          "240-0035",
          "240-0023",
          "240-0015",
          "240-0004",
          "240-0062",
          "240-0014",
          "240-0013",
          "240-0066",
          "240-0063",
          "240-0051",
          "240-0042",
          "240-0025",
          "240-0045",
          "240-0001",
          "240-0005",
          "240-0026",
          "240-0034",
          "240-0033",
          "240-0043",
          "240-0011",
          "240-0036",
          "240-0024",
          "240-0012",
          "240-0003",
          "240-0067",
          "240-0022",
          "240-0052",
          "240-0016",
          "240-0017",
          "240-0041",
          "240-0031",
          "240-0044",
          "240-0046",
          "240-0032",
          "240-0006",
          "240-0021",
          "240-0064",
          "240-0061",
          "240-0002",
          "240-0007",
          "240-0065",
          "235-0000",
          "235-0016",
          "235-0019",
          "235-0006",
          "235-0021",
          "235-0001",
          "235-0042",
          "235-0041",
          "235-0003",
          "235-0022",
          "235-0004",
          "235-0017",
          "235-0032",
          "235-0031",
          "235-0018",
          "235-0033",
          "235-0034",
          "235-0012",
          "235-0035",
          "235-0014",
          "235-0036",
          "235-0007",
          "235-0002",
          "235-0008",
          "235-0005",
          "235-0015",
          "235-0043",
          "235-0013",
          "235-0011",
          "235-0044",
          "235-0023",
          "235-0024",
          "235-0045",
          "236-0000",
          "236-0034",
          "236-0013",
          "236-0043",
          "236-0024",
          "236-0055",
          "236-0015",
          "236-0041",
          "236-0042",
          "236-0046",
          "236-0045",
          "236-0003",
          "236-0012",
          "236-0001",
          "236-0007",
          "236-0028",
          "236-0027",
          "236-0035",
          "236-0044",
          "236-0021",
          "236-0014",
          "236-0051",
          "236-0052",
          "236-0002",
          "236-0011",
          "236-0005",
          "236-0017",
          "236-0057",
          "236-0053",
          "236-0058",
          "236-0056",
          "236-0025",
          "236-0006",
          "236-0033",
          "236-0023",
          "236-0004",
          "236-0054",
          "236-0022",
          "236-0036",
          "236-0031",
          "236-0032",
          "236-0037",
          "236-0038",
          "236-0016",
          "236-0026",
          "222-0000",
          "222-0037",
          "222-0003",
          "222-0004",
          "222-0011",
          "222-0034",
          "223-0059",
          "222-0036",
          "222-0024",
          "222-0026",
          "222-0025",
          "222-0022",
          "222-0021",
          "223-0064",
          "222-0033",
          "223-0056",
          "223-0058",
          "223-0063",
          "223-0066",
          "223-0065",
          "222-0001",
          "223-0055",
          "223-0054",
          "223-0052",
          "223-0053",
          "222-0035",
          "222-0023",
          "222-0013",
          "223-0057",
          "223-0061",
          "223-0062",
          "222-0012",
          "222-0032",
          "223-0051",
          "222-0002",
          "244-0000",
          "245-0052",
          "245-0064",
          "244-0812",
          "244-0811",
          "244-0816",
          "244-0806",
          "245-0053",
          "244-0805",
          "245-0061",
          "245-0062",
          "244-0004",
          "244-0801",
          "244-0815",
          "244-0003",
          "244-0001",
          "245-0051",
          "245-0063",
          "245-0065",
          "244-0802",
          "244-0803",
          "245-0067",
          "244-0813",
          "244-0804",
          "245-0066",
          "244-0814",
          "244-0002",
          "244-0817",
          "233-0000",
          "233-0007",
          "233-0001",
          "233-0002",
          "233-0012",
          "233-0014",
          "233-0003",
          "234-0054",
          "233-0004",
          "233-0008",
          "234-0052",
          "233-0016",
          "233-0006",
          "234-0056",
          "233-0005",
          "233-0011",
          "233-0015",
          "234-0051",
          "234-0053",
          "234-0055",
          "233-0013",
          "241-0000",
          "241-0014",
          "241-0033",
          "241-0817",
          "241-0032",
          "241-0031",
          "241-0034",
          "241-0813",
          "241-0834",
          "241-0015",
          "241-0835",
          "241-0812",
          "241-0802",
          "241-0002",
          "241-0001",
          "241-0804",
          "241-0803",
          "241-0011",
          "241-0832",
          "241-0831",
          "241-0816",
          "241-0822",
          "241-0013",
          "241-0025",
          "241-0806",
          "241-0005",
          "241-0003",
          "241-0823",
          "241-0805",
          "241-0022",
          "241-0021",
          "241-0815",
          "241-0825",
          "241-0814",
          "241-0004",
          "241-0012",
          "241-0826",
          "241-0821",
          "241-0023",
          "241-0024",
          "241-0836",
          "241-0824",
          "241-0833",
          "241-0811",
          "241-0801",
          "226-0000",
          "226-0022",
          "226-0028",
          "226-0012",
          "226-0003",
          "226-0004",
          "226-0021",
          "226-0016",
          "226-0023",
          "226-0014",
          "226-0005",
          "226-0013",
          "226-0025",
          "226-0019",
          "226-0027",
          "226-0026",
          "226-0018",
          "226-0017",
          "226-0024",
          "226-0006",
          "226-0002",
          "226-0001",
          "226-0015",
          "226-0029",
          "246-0000",
          "246-0013",
          "246-0023",
          "246-0025",
          "246-0026",
          "246-0012",
          "246-0011",
          "246-0001",
          "246-0006",
          "246-0036",
          "246-0002",
          "246-0008",
          "246-0035",
          "246-0031",
          "246-0003",
          "246-0005",
          "246-0014",
          "246-0004",
          "246-0037",
          "246-0021",
          "246-0015",
          "246-0022",
          "246-0034",
          "246-0032",
          "246-0038",
          "246-0007",
          "247-0000",
          "244-0842",
          "247-0026",
          "247-0027",
          "247-0006",
          "247-0009",
          "247-0003",
          "247-0031",
          "247-0034",
          "247-0035",
          "247-0032",
          "247-0033",
          "247-0005",
          "244-0845",
          "247-0013",
          "247-0025",
          "247-0028",
          "247-0014",
          "247-0007",
          "247-0001",
          "247-0002",
          "247-0022",
          "244-0844",
          "247-0015",
          "244-0843",
          "247-0023",
          "244-0841",
          "247-0024",
          "247-0004",
          "247-0021",
          "247-0008",
          "247-0011",
          "247-0012",
          "245-0000",
          "245-0001",
          "245-0022",
          "245-0024",
          "245-0023",
          "245-0016",
          "245-0003",
          "245-0007",
          "245-0018",
          "245-0017",
          "245-0021",
          "245-0005",
          "245-0009",
          "245-0011",
          "245-0013",
          "245-0015",
          "245-0014",
          "245-0012",
          "245-0006",
          "245-0008",
          "245-0004",
          "245-0002",
          "227-0000",
          "227-0062",
          "227-0066",
          "225-0011",
          "225-0012",
          "225-0024",
          "225-0002",
          "225-0001",
          "227-0052",
          "225-0005",
          "225-0013",
          "225-0014",
          "225-0015",
          "227-0063",
          "225-0023",
          "227-0065",
          "227-0048",
          "227-0034",
          "227-0041",
          "227-0033",
          "225-0025",
          "225-0022",
          "227-0061",
          "227-0053",
          "227-0031",
          "227-0042",
          "227-0054",
          "225-0003",
          "225-0021",
          "227-0035",
          "227-0046",
          "227-0064",
          "227-0051",
          "227-0055",
          "227-0038",
          "227-0036",
          "227-0032",
          "227-0043",
          "227-0067",
          "225-0016",
          "227-0047",
          "227-0037",
          "227-0044",
          "225-0004",
          "225-0026",
          "227-0045",
          "224-0000",
          "224-0016",
          "224-0053",
          "224-0012",
          "224-0011",
          "224-0014",
          "224-0015",
          "224-0004",
          "224-0008",
          "224-0006",
          "224-0007",
          "224-0042",
          "224-0028",
          "224-0027",
          "224-0061",
          "224-0043",
          "224-0055",
          "224-0034",
          "224-0036",
          "224-0044",
          "224-0056",
          "224-0057",
          "224-0021",
          "224-0062",
          "224-0054",
          "224-0046",
          "224-0035",
          "224-0013",
          "224-0065",
          "224-0032",
          "224-0031",
          "224-0033",
          "224-0037",
          "224-0001",
          "224-0003",
          "224-0041",
          "224-0063",
          "224-0052",
          "224-0025",
          "224-0045",
          "224-0023",
          "224-0024",
          "224-0064",
          "224-0051",
          "224-0029",
          "224-0026",
          "224-0066",
          "210-0000",
          "210-0847",
          "210-0854",
          "210-0808",
          "210-0832",
          "210-0864",
          "210-0022",
          "210-0006",
          "210-0805",
          "210-0862",
          "210-0823",
          "210-0007",
          "210-0002",
          "210-0835",
          "210-0867",
          "210-0858",
          "210-0868",
          "210-0834",
          "210-0836",
          "210-0023",
          "210-0846",
          "210-0843",
          "210-0014",
          "210-0803",
          "210-0831",
          "210-0848",
          "210-0852",
          "210-0861",
          "210-0838",
          "210-0833",
          "210-0826",
          "210-0025",
          "210-0813",
          "210-0857",
          "210-0013",
          "210-0801",
          "210-0814",
          "210-0853",
          "210-0856",
          "210-0822",
          "210-0802",
          "210-0811",
          "210-0815",
          "210-0817",
          "210-0816",
          "210-0865",
          "210-0026",
          "210-0825",
          "210-0821",
          "210-0806",
          "210-0818",
          "210-0024",
          "210-0851",
          "210-0869",
          "210-0005",
          "210-0812",
          "210-0824",
          "210-0804",
          "210-0011",
          "210-0003",
          "210-0001",
          "210-0866",
          "210-0807",
          "210-0015",
          "210-0855",
          "210-0012",
          "210-0004",
          "210-0021",
          "210-0863",
          "210-0828",
          "210-0827",
          "210-0837",
          "210-0845",
          "210-0844",
          "210-0842",
          "210-0841",
          "212-0000",
          "212-0006",
          "212-0014",
          "212-0054",
          "212-0058",
          "212-0007",
          "212-0057",
          "212-0001",
          "212-0002",
          "212-0004",
          "212-0003",
          "212-0026",
          "212-0011",
          "212-0053",
          "212-0031",
          "212-0032",
          "212-0027",
          "212-0022",
          "212-0024",
          "212-0005",
          "212-0023",
          "212-0012",
          "212-0033",
          "212-0051",
          "212-0052",
          "212-0025",
          "212-0013",
          "212-0055",
          "212-0016",
          "212-0021",
          "212-0056",
          "212-0015",
          "211-0000",
          "211-0035",
          "211-0037",
          "211-0036",
          "211-0034",
          "211-0016",
          "211-0067",
          "211-0065",
          "211-0066",
          "211-0064",
          "211-0023",
          "211-0053",
          "211-0045",
          "211-0013",
          "211-0003",
          "211-0002",
          "211-0007",
          "211-0001",
          "211-0022",
          "211-0015",
          "211-0025",
          "211-0032",
          "211-0033",
          "211-0021",
          "211-0031",
          "211-0061",
          "211-0068",
          "211-0062",
          "211-0063",
          "211-0041",
          "211-0042",
          "211-0011",
          "211-0044",
          "211-0043",
          "211-0005",
          "211-0004",
          "211-0014",
          "211-0052",
          "211-0012",
          "211-0024",
          "211-0006",
          "211-0051",
          "213-0000",
          "213-0024",
          "213-0031",
          "213-0015",
          "213-0025",
          "213-0034",
          "213-0028",
          "213-0005",
          "213-0032",
          "213-0012",
          "213-0023",
          "213-0033",
          "213-0006",
          "213-0014",
          "213-0013",
          "213-0004",
          "213-0003",
          "213-0022",
          "213-0021",
          "213-0029",
          "213-0026",
          "213-0011",
          "213-0002",
          "213-0001",
          "213-0035",
          "214-0000",
          "214-0038",
          "214-0039",
          "214-0021",
          "214-0001",
          "214-0003",
          "214-0008",
          "214-0007",
          "214-0006",
          "214-0002",
          "214-0004",
          "214-0022",
          "214-0005",
          "214-0012",
          "214-0023",
          "214-0035",
          "214-0037",
          "214-0014",
          "214-0013",
          "214-0031",
          "214-0033",
          "214-0011",
          "214-0032",
          "214-0034",
          "214-0036",
          "216-0000",
          "216-0003",
          "216-0011",
          "216-0034",
          "216-0023",
          "216-0021",
          "216-0007",
          "216-0004",
          "216-0013",
          "216-0032",
          "216-0031",
          "216-0025",
          "216-0015",
          "216-0014",
          "216-0022",
          "216-0005",
          "216-0024",
          "216-0044",
          "216-0001",
          "216-0041",
          "216-0026",
          "216-0002",
          "216-0035",
          "216-0012",
          "216-0033",
          "216-0006",
          "215-0000",
          "215-0013",
          "215-0017",
          "215-0018",
          "215-0027",
          "215-0023",
          "215-0006",
          "215-0021",
          "215-0033",
          "215-0032",
          "215-0031",
          "215-0035",
          "215-0025",
          "215-0022",
          "215-0024",
          "215-0003",
          "215-0002",
          "215-0005",
          "215-0015",
          "215-0014",
          "215-0016",
          "215-0036",
          "215-0012",
          "215-0026",
          "215-0001",
          "215-0004",
          "215-0034",
          "215-0007",
          "215-0011",
          "252-0100",
          "252-0141",
          "252-0162",
          "252-0161",
          "252-0156",
          "252-0152",
          "252-0135",
          "252-0146",
          "252-0115",
          "252-0173",
          "252-0184",
          "252-0136",
          "252-0111",
          "252-0105",
          "252-0181",
          "252-0182",
          "252-0134",
          "252-0116",
          "252-0188",
          "252-0176",
          "252-0124",
          "252-0113",
          "252-0174",
          "252-0155",
          "252-0117",
          "252-0154",
          "252-0157",
          "252-0187",
          "252-0131",
          "252-0137",
          "252-0153",
          "252-0143",
          "252-0132",
          "252-0114",
          "252-0102",
          "252-0103",
          "252-0144",
          "252-0185",
          "252-0106",
          "252-0186",
          "252-0158",
          "252-0101",
          "252-0151",
          "252-0159",
          "252-0104",
          "252-0142",
          "252-0183",
          "252-0171",
          "252-0172",
          "252-0112",
          "252-0175",
          "252-0200",
          "252-0235",
          "252-0224",
          "252-0251",
          "252-0205",
          "252-0233",
          "252-0243",
          "252-0201",
          "252-0234",
          "252-0214",
          "252-0217",
          "252-0231",
          "252-0254",
          "252-0246",
          "252-0213",
          "252-0216",
          "252-0221",
          "252-0244",
          "252-0245",
          "252-0239",
          "252-0237",
          "252-0228",
          "252-0203",
          "252-0227",
          "252-0215",
          "252-0236",
          "252-0206",
          "252-0202",
          "252-0238",
          "252-0223",
          "252-0225",
          "252-0253",
          "252-0212",
          "252-0211",
          "252-0229",
          "252-0232",
          "252-0207",
          "252-0208",
          "252-0226",
          "252-0242",
          "252-0241",
          "252-0222",
          "252-0300",
          "252-0304",
          "252-0328",
          "252-0325",
          "252-0327",
          "252-0301",
          "252-0331",
          "252-0302",
          "252-0318",
          "252-0329",
          "252-0344",
          "252-0306",
          "252-0303",
          "252-0321",
          "252-0322",
          "252-0315",
          "252-0335",
          "252-0326",
          "252-0312",
          "252-0324",
          "252-0323",
          "252-0336",
          "252-0332",
          "252-0333",
          "252-0311",
          "252-0316",
          "252-0307",
          "252-0313",
          "252-0317",
          "252-0314",
          "252-0305",
          "252-0334",
          "238-0000",
          "240-0105",
          "240-0104",
          "238-0033",
          "239-0845",
          "238-0048",
          "238-0035",
          "239-0806",
          "238-0003",
          "238-0051",
          "239-0844",
          "239-0836",
          "239-0837",
          "239-0822",
          "239-0823",
          "239-0815",
          "237-0062",
          "238-0017",
          "238-0311",
          "238-0008",
          "239-0808",
          "238-0024",
          "238-0004",
          "240-0102",
          "237-0063",
          "237-0065",
          "237-0068",
          "237-0064",
          "239-0812",
          "238-0034",
          "239-0813",
          "238-0031",
          "238-0025",
          "238-0022",
          "238-0002",
          "239-0828",
          "239-0834",
          "239-0831",
          "239-0827",
          "239-0846",
          "239-0820",
          "240-0106",
          "238-0026",
          "238-0043",
          "239-0803",
          "240-0103",
          "240-0108",
          "238-0052",
          "239-0835",
          "238-0019",
          "238-0042",
          "238-0054",
          "240-0107",
          "237-0066",
          "238-0005",
          "239-0832",
          "238-0314",
          "237-0073",
          "237-0074",
          "237-0071",
          "237-0075",
          "237-0067",
          "238-0313",
          "238-0015",
          "239-0843",
          "238-0056",
          "238-0001",
          "238-0316",
          "237-0072",
          "240-0101",
          "239-0842",
          "239-0826",
          "237-0061",
          "239-0824",
          "238-0046",
          "239-0807",
          "239-0841",
          "239-0833",
          "237-0078",
          "239-0811",
          "237-0077",
          "238-0315",
          "239-0821",
          "238-0045",
          "239-0847",
          "238-0006",
          "238-0032",
          "238-0016",
          "238-0021",
          "239-0814",
          "239-0805",
          "237-0076",
          "238-0013",
          "238-0055",
          "238-0044",
          "238-0053",
          "238-0041",
          "239-0801",
          "239-0802",
          "238-0018",
          "237-0079",
          "239-0825",
          "238-0014",
          "238-0317",
          "238-0023",
          "238-0012",
          "238-0312",
          "238-0036",
          "239-0804",
          "238-0047",
          "238-0011",
          "238-0007",
          "239-0829",
          "254-0000",
          "254-0042",
          "254-0031",
          "259-1214",
          "254-0915",
          "259-1216",
          "259-1218",
          "254-0025",
          "254-0033",
          "254-0047",
          "254-0012",
          "254-0001",
          "254-0074",
          "259-1212",
          "259-1213",
          "259-1204",
          "254-0055",
          "259-1207",
          "254-0088",
          "254-0005",
          "254-0906",
          "254-0801",
          "254-0821",
          "254-0903",
          "254-0061",
          "254-0004",
          "254-0804",
          "254-0053",
          "259-1206",
          "254-0014",
          "259-1203",
          "254-0003",
          "254-0076",
          "254-0022",
          "254-0822",
          "254-0063",
          "254-0041",
          "254-0803",
          "259-1202",
          "254-0813",
          "254-0807",
          "254-0912",
          "254-0805",
          "254-0914",
          "254-0034",
          "254-0046",
          "254-0013",
          "254-0064",
          "259-1205",
          "254-0027",
          "259-1215",
          "254-0826",
          "254-0902",
          "254-0081",
          "254-0083",
          "254-0086",
          "254-0087",
          "254-0085",
          "254-0051",
          "254-0054",
          "254-0026",
          "254-0075",
          "254-0071",
          "254-0072",
          "254-0021",
          "259-1217",
          "254-0825",
          "254-0044",
          "254-0019",
          "254-0073",
          "254-0823",
          "254-0904",
          "254-0824",
          "254-0023",
          "254-0024",
          "254-0018",
          "254-0082",
          "254-0077",
          "254-0016",
          "254-0905",
          "254-0052",
          "259-1219",
          "254-0062",
          "259-1211",
          "254-0802",
          "254-0043",
          "254-0812",
          "254-0901",
          "254-0913",
          "254-0045",
          "259-1201",
          "254-0084",
          "254-0065",
          "254-0035",
          "254-0036",
          "259-1220",
          "254-0815",
          "254-0811",
          "254-0032",
          "254-0911",
          "254-0015",
          "254-0806",
          "254-0002",
          "254-0011",
          "254-0814",
          "248-0000",
          "248-0024",
          "247-0052",
          "247-0053",
          "247-0051",
          "247-0073",
          "248-0011",
          "247-0056",
          "248-0007",
          "247-0072",
          "248-0012",
          "247-0063",
          "248-0031",
          "247-0065",
          "248-0023",
          "248-0033",
          "247-0055",
          "248-0006",
          "248-0013",
          "248-0021",
          "248-0015",
          "248-0017",
          "248-0026",
          "248-0025",
          "248-0001",
          "248-0003",
          "247-0074",
          "247-0075",
          "247-0061",
          "247-0054",
          "247-0071",
          "248-0032",
          "248-0034",
          "248-0036",
          "247-0064",
          "248-0022",
          "248-0002",
          "248-0035",
          "248-0004",
          "248-0016",
          "248-0027",
          "247-0066",
          "247-0062",
          "248-0014",
          "248-0005",
          "251-0000",
          "251-0054",
          "252-0815",
          "251-0862",
          "252-0803",
          "252-0824",
          "251-0036",
          "252-0805",
          "252-0816",
          "251-0861",
          "252-0825",
          "251-0032",
          "251-0035",
          "251-0034",
          "251-0033",
          "252-0813",
          "251-0003",
          "251-0015",
          "252-0811",
          "251-0022",
          "251-0025",
          "251-0037",
          "251-0027",
          "251-0021",
          "251-0024",
          "251-0023",
          "251-0031",
          "251-0038",
          "251-0026",
          "252-0822",
          "251-0013",
          "252-0807",
          "251-0057",
          "252-0804",
          "252-0823",
          "251-0051",
          "251-0871",
          "251-0876",
          "251-0877",
          "251-0002",
          "252-0802",
          "251-0017",
          "251-0872",
          "252-0801",
          "251-0047",
          "251-0041",
          "251-0042",
          "251-0044",
          "251-0045",
          "251-0046",
          "251-0043",
          "252-0806",
          "252-0814",
          "251-0005",
          "251-0001",
          "252-0812",
          "251-0056",
          "251-0874",
          "251-0004",
          "251-0052",
          "251-0028",
          "251-0053",
          "251-0875",
          "251-0873",
          "251-0055",
          "252-0826",
          "251-0014",
          "251-0016",
          "251-0012",
          "252-0821",
          "251-0011",
          "250-0000",
          "250-0053",
          "250-0864",
          "250-0856",
          "250-0863",
          "250-0854",
          "250-0041",
          "250-0056",
          "250-0022",
          "250-0034",
          "250-0031",
          "250-0025",
          "250-0001",
          "250-0042",
          "256-0802",
          "250-0211",
          "256-0806",
          "250-0032",
          "256-0805",
          "250-0877",
          "250-0202",
          "250-0874",
          "250-0852",
          "256-0814",
          "250-0051",
          "250-0055",
          "250-0861",
          "256-0812",
          "250-0858",
          "250-0002",
          "250-0023",
          "256-0815",
          "250-0011",
          "256-0816",
          "250-0855",
          "250-0208",
          "250-0878",
          "250-0871",
          "250-0046",
          "250-0014",
          "250-0045",
          "250-0201",
          "250-0203",
          "250-0207",
          "250-0205",
          "250-0204",
          "250-0206",
          "250-0851",
          "250-0216",
          "250-0054",
          "256-0811",
          "250-0215",
          "250-0872",
          "250-0876",
          "250-0866",
          "250-0005",
          "256-0803",
          "250-0214",
          "250-0862",
          "250-0212",
          "256-0817",
          "256-0801",
          "250-0024",
          "250-0218",
          "256-0804",
          "250-0004",
          "250-0021",
          "250-0213",
          "256-0808",
          "250-0003",
          "250-0052",
          "250-0217",
          "250-0853",
          "250-0012",
          "256-0813",
          "250-0033",
          "250-0044",
          "250-0035",
          "250-0875",
          "250-0013",
          "250-0043",
          "250-0857",
          "250-0873",
          "256-0807",
          "250-0865",
          "253-0000",
          "253-0001",
          "253-0013",
          "253-0026",
          "253-0004",
          "253-0072",
          "253-0084",
          "253-0082",
          "253-0016",
          "253-0012",
          "253-0052",
          "253-0033",
          "253-0081",
          "253-0087",
          "253-0045",
          "253-0017",
          "253-0036",
          "253-0044",
          "253-0008",
          "253-0015",
          "253-0002",
          "253-0041",
          "253-0006",
          "253-0003",
          "253-0028",
          "253-0032",
          "253-0056",
          "253-0055",
          "253-0073",
          "253-0007",
          "253-0061",
          "253-0083",
          "253-0071",
          "253-0035",
          "253-0021",
          "253-0086",
          "253-0062",
          "253-0054",
          "253-0053",
          "253-0011",
          "253-0037",
          "253-0027",
          "253-0031",
          "253-0074",
          "253-0024",
          "253-0014",
          "253-0042",
          "253-0065",
          "253-0005",
          "253-0025",
          "253-0022",
          "253-0088",
          "253-0023",
          "253-0034",
          "253-0018",
          "253-0043",
          "253-0064",
          "253-0063",
          "253-0085",
          "253-0051",
          "249-0000",
          "249-0003",
          "249-0008",
          "249-0005",
          "249-0007",
          "249-0006",
          "249-0004",
          "249-0001",
          "249-0002",
          "238-0200",
          "238-0246",
          "238-0245",
          "238-0222",
          "238-0236",
          "238-0244",
          "238-0235",
          "238-0234",
          "238-0241",
          "238-0113",
          "238-0115",
          "238-0111",
          "238-0112",
          "238-0114",
          "238-0223",
          "238-0232",
          "238-0242",
          "238-0243",
          "238-0225",
          "238-0237",
          "238-0221",
          "238-0224",
          "238-0103",
          "238-0101",
          "238-0102",
          "238-0105",
          "238-0104",
          "238-0231",
          "238-0233",
          "257-0000",
          "257-0014",
          "257-0018",
          "257-0051",
          "257-0041",
          "257-0011",
          "257-0025",
          "259-1312",
          "257-0052",
          "257-0005",
          "257-0032",
          "257-0006",
          "257-0042",
          "257-0022",
          "257-0048",
          "257-0043",
          "257-0045",
          "259-1303",
          "259-1322",
          "259-1326",
          "257-0053",
          "257-0004",
          "257-0026",
          "259-1332",
          "257-0056",
          "257-0047",
          "257-0037",
          "257-0055",
          "257-0031",
          "257-0034",
          "257-0017",
          "259-1324",
          "257-0007",
          "257-0002",
          "257-0001",
          "257-0023",
          "259-1306",
          "257-0016",
          "259-1323",
          "257-0024",
          "259-1317",
          "257-0012",
          "257-0027",
          "259-1316",
          "259-1325",
          "259-1333",
          "259-1301",
          "257-0028",
          "257-0046",
          "257-0015",
          "257-0057",
          "257-0044",
          "259-1302",
          "259-1305",
          "259-1304",
          "259-1331",
          "257-0035",
          "259-1321",
          "259-1313",
          "259-1335",
          "257-0054",
          "257-0013",
          "257-0003",
          "257-0021",
          "257-0033",
          "257-0036",
          "259-1334",
          "259-1315",
          "259-1311",
          "259-1307",
          "259-1314",
          "243-0000",
          "243-0035",
          "243-0028",
          "243-0027",
          "243-0038",
          "243-0014",
          "243-0007",
          "243-0011",
          "243-0006",
          "243-0213",
          "243-0013",
          "243-0212",
          "243-0817",
          "243-0021",
          "243-0126",
          "243-0125",
          "243-0032",
          "243-0807",
          "243-0801",
          "243-0201",
          "243-0025",
          "243-0215",
          "243-0003",
          "243-0012",
          "243-0022",
          "243-0017",
          "243-0802",
          "243-0211",
          "243-0217",
          "243-0806",
          "243-0203",
          "243-0206",
          "243-0026",
          "243-0214",
          "243-0804",
          "243-0205",
          "243-0016",
          "243-0811",
          "243-0813",
          "243-0815",
          "243-0814",
          "243-0812",
          "243-0023",
          "243-0204",
          "243-0031",
          "243-0805",
          "243-0202",
          "243-0018",
          "243-0024",
          "243-0121",
          "243-0033",
          "243-0039",
          "243-0036",
          "243-0816",
          "243-0001",
          "243-0034",
          "243-0005",
          "243-0207",
          "243-0004",
          "243-0041",
          "243-0015",
          "243-0208",
          "243-0216",
          "243-0037",
          "243-0002",
          "243-0122",
          "243-0123",
          "243-0124",
          "243-0803",
          "242-0000",
          "242-0029",
          "242-0014",
          "242-0028",
          "242-0023",
          "242-0027",
          "242-0001",
          "242-0015",
          "242-0026",
          "242-0025",
          "242-0021",
          "242-0007",
          "242-0008",
          "242-0002",
          "242-0004",
          "242-0005",
          "242-0011",
          "242-0013",
          "242-0012",
          "242-0018",
          "242-0024",
          "242-0006",
          "242-0022",
          "242-0017",
          "242-0016",
          "242-0003",
          "259-1100",
          "259-1113",
          "259-1144",
          "259-1116",
          "259-1131",
          "259-1145",
          "259-1128",
          "259-1105",
          "259-1107",
          "259-1135",
          "259-1137",
          "259-1141",
          "259-1124",
          "259-1127",
          "259-1136",
          "259-1122",
          "259-1138",
          "259-1102",
          "259-1132",
          "259-1103",
          "259-1121",
          "259-1143",
          "259-1125",
          "259-1123",
          "259-1147",
          "259-1146",
          "259-1106",
          "259-1114",
          "259-1115",
          "259-1142",
          "259-1104",
          "259-1111",
          "259-1126",
          "259-1134",
          "259-1133",
          "259-1112",
          "259-1117",
          "259-1101",
          "259-1118",
          "243-0400",
          "243-0437",
          "243-0423",
          "243-0436",
          "243-0411",
          "243-0419",
          "243-0418",
          "243-0402",
          "243-0404",
          "243-0426",
          "243-0431",
          "243-0434",
          "243-0415",
          "243-0433",
          "243-0413",
          "243-0405",
          "243-0406",
          "243-0421",
          "243-0435",
          "243-0424",
          "243-0414",
          "243-0410",
          "243-0427",
          "243-0432",
          "243-0416",
          "243-0422",
          "243-0425",
          "243-0412",
          "243-0401",
          "243-0417",
          "243-0438",
          "243-0403",
          "252-0000",
          "252-0029",
          "252-0028",
          "252-0013",
          "252-0014",
          "252-0002",
          "252-0001",
          "252-0005",
          "252-0027",
          "252-0026",
          "252-0011",
          "252-0023",
          "252-0016",
          "252-0004",
          "252-0003",
          "252-0012",
          "252-0021",
          "252-0015",
          "252-0022",
          "252-0025",
          "250-0100",
          "250-0134",
          "250-0122",
          "250-0124",
          "250-0113",
          "250-0131",
          "250-0126",
          "250-0135",
          "250-0114",
          "250-0107",
          "250-0132",
          "250-0125",
          "250-0105",
          "250-0102",
          "250-0127",
          "250-0111",
          "250-0117",
          "250-0123",
          "250-0106",
          "250-0115",
          "250-0121",
          "250-0133",
          "250-0101",
          "250-0103",
          "250-0116",
          "250-0104",
          "250-0136",
          "250-0112",
          "252-1100",
          "252-1101",
          "252-1104",
          "252-1115",
          "252-1116",
          "252-1112",
          "252-1113",
          "252-1114",
          "252-1111",
          "252-1121",
          "252-1122",
          "252-1105",
          "252-1135",
          "252-1132",
          "252-1136",
          "252-1134",
          "252-1131",
          "252-1137",
          "252-1133",
          "252-1123",
          "252-1127",
          "252-1103",
          "252-1108",
          "252-1107",
          "252-1106",
          "252-1102",
          "252-1124",
          "252-1125",
          "252-1126",
          "240-0100",
          "240-0111",
          "240-0115",
          "240-0114",
          "240-0116",
          "240-0113",
          "240-0112",
          "253-0100",
          "253-0111",
          "253-0104",
          "253-0113",
          "253-0105",
          "253-0101",
          "253-0103",
          "253-0102",
          "253-0114",
          "253-0112",
          "253-0106",
          "255-0000",
          "259-0102",
          "259-0113",
          "255-0003",
          "259-0114",
          "259-0105",
          "259-0112",
          "259-0111",
          "255-0001",
          "259-0101",
          "259-0104",
          "255-0005",
          "255-0004",
          "255-0002",
          "259-0103",
          "259-0100",
          "259-0134",
          "259-0125",
          "259-0131",
          "259-0123",
          "259-0122",
          "259-0121",
          "259-0132",
          "259-0124",
          "259-0133",
          "259-0151",
          "259-0154",
          "259-0141",
          "259-0147",
          "259-0143",
          "259-0142",
          "259-0146",
          "259-0157",
          "259-0156",
          "259-0148",
          "259-0145",
          "259-0144",
          "259-0153",
          "259-0152",
          "259-0155",
          "258-0000",
          "258-0014",
          "258-0018",
          "258-0019",
          "258-0016",
          "258-0011",
          "258-0013",
          "258-0017",
          "258-0012",
          "258-0015",
          "258-0002",
          "258-0003",
          "258-0004",
          "258-0001",
          "258-0100",
          "258-0203",
          "258-0126",
          "258-0124",
          "258-0112",
          "258-0202",
          "258-0122",
          "258-0201",
          "258-0114",
          "258-0121",
          "258-0111",
          "258-0115",
          "258-0125",
          "258-0113",
          "258-0123",
          "258-0204",
          "258-0022",
          "258-0025",
          "258-0027",
          "258-0028",
          "258-0024",
          "258-0026",
          "258-0029",
          "258-0023",
          "258-0021",
          "250-0500",
          "250-0523",
          "250-0405",
          "250-0402",
          "250-0406",
          "250-0408",
          "250-0313",
          "250-0631",
          "250-0403",
          "250-0315",
          "250-0407",
          "250-0521",
          "250-0314",
          "250-0401",
          "250-0404",
          "250-0522",
          "250-0311",
          "250-0312",
          "259-0200",
          "259-0202",
          "259-0201",
          "259-0300",
          "259-0313",
          "259-0305",
          "259-0301",
          "259-0303",
          "259-0311",
          "259-0317",
          "259-0316",
          "259-0314",
          "259-0304",
          "259-0302",
          "259-0312",
          "259-0318",
          "243-0300",
          "243-0302",
          "243-0301",
          "243-0306",
          "243-0304",
          "243-0303",
          "243-0305",
          "243-0307",
          "243-0308",
          "243-0100",
          "257-0061",
          "243-0112",
          "243-0111",
          "950-0000",
          "950-3315",
          "950-3377",
          "950-3327",
          "950-3306",
          "950-3333",
          "950-3381",
          "950-3344",
          "950-3305",
          "950-3363",
          "950-3351",
          "950-3313",
          "950-3334",
          "950-3364",
          "950-3336",
          "950-3312",
          "950-3317",
          "950-3335",
          "950-3343",
          "950-3355",
          "950-3116",
          "950-3322",
          "950-3341",
          "950-3304",
          "950-3321",
          "950-3360",
          "950-3301",
          "950-3337",
          "950-3124",
          "950-3102",
          "950-3308",
          "950-3346",
          "950-3371",
          "950-3354",
          "950-3359",
          "950-3103",
          "950-3105",
          "950-3331",
          "950-3339",
          "950-3332",
          "950-3123",
          "950-3373",
          "950-3133",
          "950-3365",
          "950-3367",
          "950-3362",
          "950-3112",
          "950-3111",
          "950-3101",
          "950-3135",
          "950-3323",
          "950-3307",
          "950-3316",
          "950-3345",
          "950-3353",
          "950-3352",
          "950-3338",
          "950-3114",
          "950-3361",
          "950-3134",
          "950-3131",
          "950-3122",
          "950-3358",
          "950-3325",
          "950-3302",
          "950-3372",
          "950-3376",
          "950-3375",
          "950-3104",
          "950-3357",
          "950-3374",
          "950-3309",
          "950-0102",
          "950-3324",
          "950-3328",
          "950-3113",
          "950-3132",
          "950-3126",
          "950-3115",
          "950-3121",
          "950-3128",
          "950-3125",
          "950-3127",
          "950-3342",
          "950-3369",
          "950-3366",
          "950-3314",
          "950-3368",
          "950-3326",
          "950-3356",
          "950-3311",
          "950-3350",
          "950-3303",
          "950-0054",
          "950-0052",
          "950-0843",
          "950-0852",
          "950-0834",
          "950-0805",
          "950-0101",
          "950-0884",
          "950-0881",
          "950-0806",
          "950-0808",
          "950-0882",
          "950-0814",
          "950-0813",
          "950-0067",
          "950-0821",
          "950-0863",
          "950-0063",
          "950-0891",
          "950-0161",
          "950-0883",
          "950-0055",
          "950-0116",
          "950-0036",
          "950-0831",
          "950-0832",
          "950-0833",
          "950-0022",
          "950-0024",
          "950-0015",
          "950-0032",
          "950-0033",
          "950-0016",
          "950-0855",
          "950-0011",
          "950-0028",
          "950-0026",
          "950-0811",
          "950-0835",
          "950-0003",
          "950-0864",
          "950-0868",
          "950-0914",
          "950-0885",
          "950-0013",
          "950-0851",
          "950-0822",
          "950-0004",
          "950-0017",
          "950-0045",
          "950-0071",
          "950-0005",
          "950-0053",
          "950-0862",
          "950-0867",
          "950-0825",
          "950-0066",
          "950-0061",
          "950-0801",
          "950-0892",
          "950-0065",
          "950-0853",
          "950-0886",
          "950-0803",
          "950-0824",
          "950-0841",
          "950-0861",
          "950-0062",
          "950-0106",
          "950-0002",
          "950-0893",
          "950-0046",
          "950-0034",
          "950-0823",
          "950-0836",
          "950-0042",
          "950-0802",
          "950-0025",
          "950-0031",
          "950-0056",
          "950-0044",
          "950-0035",
          "950-0872",
          "950-0804",
          "950-0014",
          "950-0064",
          "950-0023",
          "950-0001",
          "950-0027",
          "950-0854",
          "950-0842",
          "950-0807",
          "950-0021",
          "950-0051",
          "950-0809",
          "950-0871",
          "950-0057",
          "950-0012",
          "950-0812",
          "950-0047",
          "950-0043",
          "950-0041",
          "950-0837",
          "951-8037",
          "951-8025",
          "950-0084",
          "951-8021",
          "951-8122",
          "950-0944",
          "950-0913",
          "950-0915",
          "950-0964",
          "951-8146",
          "951-8145",
          "951-8124",
          "951-8055",
          "951-8054",
          "951-8132",
          "951-8018",
          "951-8011",
          "951-8074",
          "951-8072",
          "950-0157",
          "950-0923",
          "951-8001",
          "950-1148",
          "951-8114",
          "951-8077",
          "950-0971",
          "950-0953",
          "951-8076",
          "950-1144",
          "950-0952",
          "950-0074",
          "950-1133",
          "950-0903",
          "951-8125",
          "951-8126",
          "950-0973",
          "951-8068",
          "950-0994",
          "950-0992",
          "950-0993",
          "950-0145",
          "951-8133",
          "951-8053",
          "950-0983",
          "950-0986",
          "950-0083",
          "951-8105",
          "951-8048",
          "951-8111",
          "951-8031",
          "951-8081",
          "950-1145",
          "951-8008",
          "950-0921",
          "950-0926",
          "951-8073",
          "950-1151",
          "950-0942",
          "950-0907",
          "950-0908",
          "951-8071",
          "951-8034",
          "950-0949",
          "950-0911",
          "950-0081",
          "951-8156",
          "951-8152",
          "951-8123",
          "951-8052",
          "950-0991",
          "950-1141",
          "950-0965",
          "951-8051",
          "950-0972",
          "951-8121",
          "951-8088",
          "951-8042",
          "950-0933",
          "951-8141",
          "951-8144",
          "951-8134",
          "951-8142",
          "951-8163",
          "951-8165",
          "951-8167",
          "951-8127",
          "951-8164",
          "951-8135",
          "951-8136",
          "951-8166",
          "951-8162",
          "951-8161",
          "951-8143",
          "950-1136",
          "950-1146",
          "950-1147",
          "951-8103",
          "951-8016",
          "950-1143",
          "951-8007",
          "951-8057",
          "951-8006",
          "950-0962",
          "951-8115",
          "951-8085",
          "950-0917",
          "950-0905",
          "950-0077",
          "950-0951",
          "950-0950",
          "951-8033",
          "951-8108",
          "950-0932",
          "950-0085",
          "950-1131",
          "951-8045",
          "951-8082",
          "950-0866",
          "951-8043",
          "951-8104",
          "951-8118",
          "951-8101",
          "951-8061",
          "951-8062",
          "951-8026",
          "950-0076",
          "950-0075",
          "951-8131",
          "951-8137",
          "951-8017",
          "950-0086",
          "951-8056",
          "951-8151",
          "951-8024",
          "950-0088",
          "950-0078",
          "951-8012",
          "951-8087",
          "951-8044",
          "950-0087",
          "951-8106",
          "950-0906",
          "950-0961",
          "951-8116",
          "950-0082",
          "951-8065",
          "951-8066",
          "951-8028",
          "950-0073",
          "951-8003",
          "951-8102",
          "951-8035",
          "951-8002",
          "951-8063",
          "951-8153",
          "950-0901",
          "950-0925",
          "950-0981",
          "950-0982",
          "951-8154",
          "951-8067",
          "951-8041",
          "951-8046",
          "951-8015",
          "950-1132",
          "951-8032",
          "950-0954",
          "950-0904",
          "951-8014",
          "951-8027",
          "951-8107",
          "950-0912",
          "951-8047",
          "950-0963",
          "950-0931",
          "951-8112",
          "950-0902",
          "951-8038",
          "951-8117",
          "950-0924",
          "951-8005",
          "950-0941",
          "950-0945",
          "950-0947",
          "950-0943",
          "950-0946",
          "950-0984",
          "950-0948",
          "951-8075",
          "950-0865",
          "951-8084",
          "950-0909",
          "951-8013",
          "951-8004",
          "950-0922",
          "951-8147",
          "951-8023",
          "951-8058",
          "951-8064",
          "951-8083",
          "951-8022",
          "951-8036",
          "951-8078",
          "950-0916",
          "951-8086",
          "951-8113",
          "950-0072",
          "950-0985",
          "950-0212",
          "950-0217",
          "950-0134",
          "950-0166",
          "950-1134",
          "950-0155",
          "950-0122",
          "950-0218",
          "950-0214",
          "950-0140",
          "950-0105",
          "950-0154",
          "950-0323",
          "950-0326",
          "950-0124",
          "950-0162",
          "950-0141",
          "950-0121",
          "950-0125",
          "950-0123",
          "950-0169",
          "950-0164",
          "950-0152",
          "950-0151",
          "950-0206",
          "950-0213",
          "950-0103",
          "950-0203",
          "950-0201",
          "950-0324",
          "950-0104",
          "950-0167",
          "950-0156",
          "950-0129",
          "950-0107",
          "950-0149",
          "950-0150",
          "950-0136",
          "950-0137",
          "950-0132",
          "950-0133",
          "950-0130",
          "950-0127",
          "950-0205",
          "950-1142",
          "950-1135",
          "950-0144",
          "950-0139",
          "950-0135",
          "950-0142",
          "950-0111",
          "950-0147",
          "950-0165",
          "950-0113",
          "950-0207",
          "950-0325",
          "950-0168",
          "950-0148",
          "950-0163",
          "950-0126",
          "950-0138",
          "950-0329",
          "950-0215",
          "950-0131",
          "950-0202",
          "950-0153",
          "950-0328",
          "950-0112",
          "950-0146",
          "950-0115",
          "950-0114",
          "950-0143",
          "950-0204",
          "950-0210",
          "950-0211",
          "950-0208",
          "950-0209",
          "950-0322",
          "950-0327",
          "950-0321",
          "956-0000",
          "956-0017",
          "956-0832",
          "956-0835",
          "956-0114",
          "956-0824",
          "956-0002",
          "956-0853",
          "956-0043",
          "956-0044",
          "956-0054",
          "956-0004",
          "956-0827",
          "956-0826",
          "956-0804",
          "956-0012",
          "956-0003",
          "956-0001",
          "956-0851",
          "956-0845",
          "956-0823",
          "956-0115",
          "956-0852",
          "956-0846",
          "956-0015",
          "956-0055",
          "956-0828",
          "956-0026",
          "956-0861",
          "956-0021",
          "956-0833",
          "956-0005",
          "956-0011",
          "956-0016",
          "956-0834",
          "956-0101",
          "956-0025",
          "956-0817",
          "956-0006",
          "956-0007",
          "956-0045",
          "956-0122",
          "956-0041",
          "956-0022",
          "956-0051",
          "956-0844",
          "956-0867",
          "956-0866",
          "956-0825",
          "956-0033",
          "956-0815",
          "956-0822",
          "956-0112",
          "956-0862",
          "956-0123",
          "956-0865",
          "956-0836",
          "956-0813",
          "956-0801",
          "956-0854",
          "956-0855",
          "956-0013",
          "956-0046",
          "956-0831",
          "956-0812",
          "956-0805",
          "956-0036",
          "956-0802",
          "956-0031",
          "956-0816",
          "956-0864",
          "956-0034",
          "956-0057",
          "956-0818",
          "956-0842",
          "956-0037",
          "956-0863",
          "956-0053",
          "956-0814",
          "956-0841",
          "956-0014",
          "956-0116",
          "956-0847",
          "956-0035",
          "956-0117",
          "956-0811",
          "956-0806",
          "956-0052",
          "956-0032",
          "956-0023",
          "956-0027",
          "956-0803",
          "956-0113",
          "956-0024",
          "956-0121",
          "956-0837",
          "956-0111",
          "956-0821",
          "956-0056",
          "956-0843",
          "950-1200",
          "950-1411",
          "950-1413",
          "950-1261",
          "950-1227",
          "950-1447",
          "950-1251",
          "950-1471",
          "950-1403",
          "950-1456",
          "950-1442",
          "950-1453",
          "950-1444",
          "950-1412",
          "950-1401",
          "950-1472",
          "950-1252",
          "950-1253",
          "950-1201",
          "950-1203",
          "950-1204",
          "950-1202",
          "950-1305",
          "950-1466",
          "950-1428",
          "950-1474",
          "950-1244",
          "950-1454",
          "950-1465",
          "950-1431",
          "950-1302",
          "950-1221",
          "950-1237",
          "950-1311",
          "950-1434",
          "950-1441",
          "950-1231",
          "950-1414",
          "950-1255",
          "950-1256",
          "950-1212",
          "950-1225",
          "950-1457",
          "950-1473",
          "950-1241",
          "950-1464",
          "950-1424",
          "950-1301",
          "950-1246",
          "950-1232",
          "950-1432",
          "950-1214",
          "950-1446",
          "950-1433",
          "950-1217",
          "950-1222",
          "950-1218",
          "950-1224",
          "950-1216",
          "950-1223",
          "950-1211",
          "950-1226",
          "950-1426",
          "950-1245",
          "950-1209",
          "950-1208",
          "950-1215",
          "950-1462",
          "950-1404",
          "950-1436",
          "950-1235",
          "950-1236",
          "950-1477",
          "950-1304",
          "950-1313",
          "950-1312",
          "950-1425",
          "950-1475",
          "950-1423",
          "950-1242",
          "950-1421",
          "950-1254",
          "950-1437",
          "950-1455",
          "950-1416",
          "950-1417",
          "950-1303",
          "950-1402",
          "950-1262",
          "950-1234",
          "950-1213",
          "950-1405",
          "950-1406",
          "950-1467",
          "950-1314",
          "950-1443",
          "950-1445",
          "950-1415",
          "950-1461",
          "950-1463",
          "950-1344",
          "950-1452",
          "950-1476",
          "950-1233",
          "950-1422",
          "950-1451",
          "950-1243",
          "950-1435",
          "950-1247",
          "950-1258",
          "950-1257",
          "950-1407",
          "950-2002",
          "950-2006",
          "950-2005",
          "950-2261",
          "950-2073",
          "950-2101",
          "950-2102",
          "950-2171",
          "950-2176",
          "950-2177",
          "950-2174",
          "950-2173",
          "950-2175",
          "950-2155",
          "950-2152",
          "950-2162",
          "950-2161",
          "950-2045",
          "950-1121",
          "950-2141",
          "950-2154",
          "950-2172",
          "950-2153",
          "950-2156",
          "950-2142",
          "950-2164",
          "950-2151",
          "950-2157",
          "950-2143",
          "950-2112",
          "950-2113",
          "950-2001",
          "950-1127",
          "950-2126",
          "950-2037",
          "950-1111",
          "950-1124",
          "950-2137",
          "950-2123",
          "950-1112",
          "950-2146",
          "950-2076",
          "950-2255",
          "950-2033",
          "950-2136",
          "950-1126",
          "950-1122",
          "950-2253",
          "950-1123",
          "950-2023",
          "950-2027",
          "950-2024",
          "950-2028",
          "950-2132",
          "950-2022",
          "950-2013",
          "950-2011",
          "950-2012",
          "950-2014",
          "950-2021",
          "950-2025",
          "950-2026",
          "950-1114",
          "950-2042",
          "950-2044",
          "950-2041",
          "950-2263",
          "950-2034",
          "950-2035",
          "950-2036",
          "950-2038",
          "950-2163",
          "950-2043",
          "951-8155",
          "950-1102",
          "950-2144",
          "950-2111",
          "950-2124",
          "950-2122",
          "950-2145",
          "950-1103",
          "950-2251",
          "950-2052",
          "950-2051",
          "950-2055",
          "950-2061",
          "950-2063",
          "950-2062",
          "950-2064",
          "950-2054",
          "950-2053",
          "950-1104",
          "950-2147",
          "950-2262",
          "950-1106",
          "950-1105",
          "950-1115",
          "950-1113",
          "950-2125",
          "950-2071",
          "950-2015",
          "950-2131",
          "950-2003",
          "950-2254",
          "950-2138",
          "950-2004",
          "950-2134",
          "950-2133",
          "950-2121",
          "950-2074",
          "950-2075",
          "950-2072",
          "950-2032",
          "950-2264",
          "950-2135",
          "950-2252",
          "950-2256",
          "950-1101",
          "950-2201",
          "959-0401",
          "950-1125",
          "950-2031",
          "953-0042",
          "953-0066",
          "953-0111",
          "953-0116",
          "953-0141",
          "959-0501",
          "959-0513",
          "959-0515",
          "953-0104",
          "953-0117",
          "950-1348",
          "950-1347",
          "959-0507",
          "959-0416",
          "953-0054",
          "953-0012",
          "959-0506",
          "959-0415",
          "959-0417",
          "959-0517",
          "959-0511",
          "959-0425",
          "959-0403",
          "959-0404",
          "953-0055",
          "953-0011",
          "953-0077",
          "950-1333",
          "953-0067",
          "953-0114",
          "953-0144",
          "953-0073",
          "950-1334",
          "953-0051",
          "959-0432",
          "953-0045",
          "953-0134",
          "959-0516",
          "953-0142",
          "959-0502",
          "959-0412",
          "950-1324",
          "950-1342",
          "953-0078",
          "959-0508",
          "950-1325",
          "953-0102",
          "953-0063",
          "953-0064",
          "959-0435",
          "953-0143",
          "959-0402",
          "959-0505",
          "953-0071",
          "959-0438",
          "953-0065",
          "959-0514",
          "953-0136",
          "953-0014",
          "959-0421",
          "959-0411",
          "959-0406",
          "959-0422",
          "953-0121",
          "953-0112",
          "953-0023",
          "953-0123",
          "959-0434",
          "953-0027",
          "950-1341",
          "953-0122",
          "953-0033",
          "959-0437",
          "950-1327",
          "950-1332",
          "953-0133",
          "953-0062",
          "953-0022",
          "953-0132",
          "953-0131",
          "953-0113",
          "959-0436",
          "953-0021",
          "953-0034",
          "950-1345",
          "953-0103",
          "959-0423",
          "959-0407",
          "953-0031",
          "953-0124",
          "950-1321",
          "959-0512",
          "950-1323",
          "950-1331",
          "950-1326",
          "953-0032",
          "953-0101",
          "959-0414",
          "953-0024",
          "959-0431",
          "953-0076",
          "953-0026",
          "953-0074",
          "959-0405",
          "953-0043",
          "953-0036",
          "950-1346",
          "953-0053",
          "953-0013",
          "953-0044",
          "950-1349",
          "953-0041",
          "959-0433",
          "959-0418",
          "959-0413",
          "953-0105",
          "953-0025",
          "959-0424",
          "953-0015",
          "953-0016",
          "953-0061",
          "959-0519",
          "950-1343",
          "959-0518",
          "953-0135",
          "953-0075",
          "950-1328",
          "959-0426",
          "959-0503",
          "953-0052",
          "953-0115",
          "959-0504",
          "959-0521",
          "950-1322",
          "953-0072",
          "953-0125",
          "953-0035",
          "940-0000",
          "940-1112",
          "940-1145",
          "940-2145",
          "940-1149",
          "940-1148",
          "940-0147",
          "954-0202",
          "940-0105",
          "940-0832",
          "949-5412",
          "940-0840",
          "940-0063",
          "940-0224",
          "940-0806",
          "940-0036",
          "940-2055",
          "940-0232",
          "949-4513",
          "949-4506",
          "940-0023",
          "949-5401",
          "949-5414",
          "954-0143",
          "940-0026",
          "940-0025",
          "940-2032",
          "940-2117",
          "940-0242",
          "954-0171",
          "940-0872",
          "940-0877",
          "940-0878",
          "940-1166",
          "940-0143",
          "949-5415",
          "940-1171",
          "949-5405",
          "940-0074",
          "940-0237",
          "949-4517",
          "940-0123",
          "949-5406",
          "940-0805",
          "940-2303",
          "954-0207",
          "954-0166",
          "940-2056",
          "940-2059",
          "940-0148",
          "940-1137",
          "954-0145",
          "940-2104",
          "940-2112",
          "940-2156",
          "940-2155",
          "940-2153",
          "940-2158",
          "940-2152",
          "940-2154",
          "940-2151",
          "940-2157",
          "940-2146",
          "940-0062",
          "954-0201",
          "940-2305",
          "954-0134",
          "954-0133",
          "940-0844",
          "940-1167",
          "940-2113",
          "940-0857",
          "940-2012",
          "949-5216",
          "949-5215",
          "949-5346",
          "949-5333",
          "949-5332",
          "949-5214",
          "949-5212",
          "949-5341",
          "949-5344",
          "949-5336",
          "949-5221",
          "949-5335",
          "949-5201",
          "949-5211",
          "949-5331",
          "949-5217",
          "949-5223",
          "949-5343",
          "949-5213",
          "949-5334",
          "949-5345",
          "949-5342",
          "949-5347",
          "949-5222",
          "954-0138",
          "954-0137",
          "949-4511",
          "940-0812",
          "954-0136",
          "940-0071",
          "940-2134",
          "940-0828",
          "940-0822",
          "940-0088",
          "940-0096",
          "954-0141",
          "940-1143",
          "940-0041",
          "940-0803",
          "940-0802",
          "940-0135",
          "940-1153",
          "940-0045",
          "940-0221",
          "940-1172",
          "949-5404",
          "940-1114",
          "940-2314",
          "940-0116",
          "949-4501",
          "940-0128",
          "940-2136",
          "940-2137",
          "940-2033",
          "940-2034",
          "940-2004",
          "940-1140",
          "940-1144",
          "949-5407",
          "940-2471",
          "940-0884",
          "954-0177",
          "940-0801",
          "940-0201",
          "940-0243",
          "949-7507",
          "949-7508",
          "949-8731",
          "949-7505",
          "949-7502",
          "949-7512",
          "949-7501",
          "949-7503",
          "949-7506",
          "949-7511",
          "940-0864",
          "940-0861",
          "940-2058",
          "940-2463",
          "940-0001",
          "940-0153",
          "940-2474",
          "940-0052",
          "940-0067",
          "940-2322",
          "940-0014",
          "940-0241",
          "940-2121",
          "940-2114",
          "954-0162",
          "940-2124",
          "940-2125",
          "940-0254",
          "940-0121",
          "940-0085",
          "940-0113",
          "940-2046",
          "940-0155",
          "949-4502",
          "940-0007",
          "940-0054",
          "940-0033",
          "940-1146",
          "954-0135",
          "954-0161",
          "940-2015",
          "940-2102",
          "949-5408",
          "949-5403",
          "940-2106",
          "940-2103",
          "940-0883",
          "940-2036",
          "940-0211",
          "940-0038",
          "940-0015",
          "954-0203",
          "954-0126",
          "940-0056",
          "940-0146",
          "940-2133",
          "940-2131",
          "940-2132",
          "940-0084",
          "940-0028",
          "940-2026",
          "940-2024",
          "940-0205",
          "940-2321",
          "940-0065",
          "940-1113",
          "940-1161",
          "940-0833",
          "949-5402",
          "949-5413",
          "940-1101",
          "949-4504",
          "940-2472",
          "940-1136",
          "940-1151",
          "940-1152",
          "940-0129",
          "940-0122",
          "940-0031",
          "954-0213",
          "940-0894",
          "940-0098",
          "940-2057",
          "949-4525",
          "954-0155",
          "940-0115",
          "940-2304",
          "940-0012",
          "940-0011",
          "940-0111",
          "949-4507",
          "940-2013",
          "940-2115",
          "940-0002",
          "940-0021",
          "940-0814",
          "940-0831",
          "940-0061",
          "949-4523",
          "940-1141",
          "940-0092",
          "940-0046",
          "940-0865",
          "940-2041",
          "954-0132",
          "940-2464",
          "940-0897",
          "940-0898",
          "940-0204",
          "940-2127",
          "940-2128",
          "954-0222",
          "954-0221",
          "954-0218",
          "940-2147",
          "940-0093",
          "940-0834",
          "940-0144",
          "954-0151",
          "940-0044",
          "940-2462",
          "940-0821",
          "940-2045",
          "954-0154",
          "940-2037",
          "940-2038",
          "940-2035",
          "940-2039",
          "940-1105",
          "940-1104",
          "940-2473",
          "940-0082",
          "940-0087",
          "940-2108",
          "940-0895",
          "954-0146",
          "940-0048",
          "940-0137",
          "940-1139",
          "940-2025",
          "940-2143",
          "940-2144",
          "940-2051",
          "940-0825",
          "940-0824",
          "940-0003",
          "940-0004",
          "940-0016",
          "940-0127",
          "940-0226",
          "940-1138",
          "940-1123",
          "940-1116",
          "940-0251",
          "949-5124",
          "940-2324",
          "940-0222",
          "954-0214",
          "940-0819",
          "949-5123",
          "940-0212",
          "940-2014",
          "954-0144",
          "954-0172",
          "940-2022",
          "940-2101",
          "940-2502",
          "959-0162",
          "959-0155",
          "959-0149",
          "959-0147",
          "940-2511",
          "940-2503",
          "940-2529",
          "940-2517",
          "959-0156",
          "959-0165",
          "940-2512",
          "940-2528",
          "959-0154",
          "940-2527",
          "959-0152",
          "940-2516",
          "959-0164",
          "959-0163",
          "959-0143",
          "940-2523",
          "959-0161",
          "959-0146",
          "959-0141",
          "940-2513",
          "940-2518",
          "940-2521",
          "940-2515",
          "940-2522",
          "940-2501",
          "959-0153",
          "959-0142",
          "940-2508",
          "959-0145",
          "940-2514",
          "940-2504",
          "959-0144",
          "940-2524",
          "940-2525",
          "940-2505",
          "959-0151",
          "940-2506",
          "959-0148",
          "940-2526",
          "940-2507",
          "959-0157",
          "940-0008",
          "940-0043",
          "940-0847",
          "940-1131",
          "940-0231",
          "940-0216",
          "940-0234",
          "940-0202",
          "940-0235",
          "940-0236",
          "940-0217",
          "940-0218",
          "940-0141",
          "940-0132",
          "940-0134",
          "940-0223",
          "940-0233",
          "940-0214",
          "940-0213",
          "940-0215",
          "940-0149",
          "940-0145",
          "940-0064",
          "940-0881",
          "940-0836",
          "940-1142",
          "940-2316",
          "940-0253",
          "940-1135",
          "940-0829",
          "940-0849",
          "940-0826",
          "940-0848",
          "954-0131",
          "940-0225",
          "954-0204",
          "940-0853",
          "940-0854",
          "940-0094",
          "940-0017",
          "940-0874",
          "940-0873",
          "940-0053",
          "940-0852",
          "954-0124",
          "954-0152",
          "954-0216",
          "954-0212",
          "954-0157",
          "954-0174",
          "954-0175",
          "954-0173",
          "940-2142",
          "954-0156",
          "940-2315",
          "940-2123",
          "954-0163",
          "940-2465",
          "940-1164",
          "940-0875",
          "940-0876",
          "940-1121",
          "940-0024",
          "940-0817",
          "949-7513",
          "940-0051",
          "940-0835",
          "940-0027",
          "940-0086",
          "954-0205",
          "949-5121",
          "940-2126",
          "940-0256",
          "949-5409",
          "954-0211",
          "940-0252",
          "940-1162",
          "940-0095",
          "940-0203",
          "954-0123",
          "949-4505",
          "954-0121",
          "954-0142",
          "940-2023",
          "940-0842",
          "940-2475",
          "940-0845",
          "940-0846",
          "940-0841",
          "940-0013",
          "940-0258",
          "940-0022",
          "940-0843",
          "940-0136",
          "940-0816",
          "949-7504",
          "940-0035",
          "940-0029",
          "940-0037",
          "940-0066",
          "940-0006",
          "949-5122",
          "940-0255",
          "949-4521",
          "940-1102",
          "940-2138",
          "940-0102",
          "949-4514",
          "940-0892",
          "940-0124",
          "940-0244",
          "940-2135",
          "940-0151",
          "940-0893",
          "940-0896",
          "940-0034",
          "940-2052",
          "954-0165",
          "940-2053",
          "940-2122",
          "940-0055",
          "940-2302",
          "940-2011",
          "940-2141",
          "954-0125",
          "940-0103",
          "940-0112",
          "949-5416",
          "940-0073",
          "940-0101",
          "940-1163",
          "940-2031",
          "940-0871",
          "940-0032",
          "940-0868",
          "940-0142",
          "940-0076",
          "940-0245",
          "954-0147",
          "940-1147",
          "940-0042",
          "940-1103",
          "940-2001",
          "940-2005",
          "940-0133",
          "940-2002",
          "940-1111",
          "940-0154",
          "954-0217",
          "940-0091",
          "954-0164",
          "954-0215",
          "954-0122",
          "940-0856",
          "940-2323",
          "940-2311",
          "940-2312",
          "940-0804",
          "940-0106",
          "940-1165",
          "940-0866",
          "940-2111",
          "940-2105",
          "940-2054",
          "940-2116",
          "940-0081",
          "940-1106",
          "940-1155",
          "940-1154",
          "940-2301",
          "940-0882",
          "940-0811",
          "940-2021",
          "940-0083",
          "940-2043",
          "940-2044",
          "940-2042",
          "940-1134",
          "940-1133",
          "940-0125",
          "949-4522",
          "940-1115",
          "940-0257",
          "940-0227",
          "940-0072",
          "940-0114",
          "947-0204",
          "947-0201",
          "947-0202",
          "947-0203",
          "947-0205",
          "940-0097",
          "940-0104",
          "940-0827",
          "940-0867",
          "940-0047",
          "940-2405",
          "940-2406",
          "940-2407",
          "940-2411",
          "940-2414",
          "940-2401",
          "940-2412",
          "940-2416",
          "940-2404",
          "940-2415",
          "940-2403",
          "940-2417",
          "940-2402",
          "940-2413",
          "940-2148",
          "954-0176",
          "940-1117",
          "954-0153",
          "940-2313",
          "940-0131",
          "940-0891",
          "940-1122",
          "949-5411",
          "940-0152",
          "949-4524",
          "940-2325",
          "954-0206",
          "940-0851",
          "949-4512",
          "954-0181",
          "940-2461",
          "940-2306",
          "940-0126",
          "949-4503",
          "949-4515",
          "949-4516",
          "940-1132",
          "940-2003",
          "940-0075",
          "955-0000",
          "955-0065",
          "955-0034",
          "955-0141",
          "955-0083",
          "955-0118",
          "955-0107",
          "955-0013",
          "955-0084",
          "955-0066",
          "959-1143",
          "955-0045",
          "955-0096",
          "959-1151",
          "959-1141",
          "959-1142",
          "959-1154",
          "955-0115",
          "955-0025",
          "955-0102",
          "955-0016",
          "955-0133",
          "955-0104",
          "955-0818",
          "955-0145",
          "955-0094",
          "955-0154",
          "955-0124",
          "955-0833",
          "955-0054",
          "959-1113",
          "955-0122",
          "959-1147",
          "955-0097",
          "955-0151",
          "959-1126",
          "959-1148",
          "955-0137",
          "955-0103",
          "959-1135",
          "959-1134",
          "959-1117",
          "959-1144",
          "955-0114",
          "955-0036",
          "955-0123",
          "955-0807",
          "955-0056",
          "955-0108",
          "955-0814",
          "955-0166",
          "955-0091",
          "955-0022",
          "955-0111",
          "959-1136",
          "955-0121",
          "959-1108",
          "955-0861",
          "955-0043",
          "955-0053",
          "955-0012",
          "955-0853",
          "959-1123",
          "959-1109",
          "955-0085",
          "955-0126",
          "955-0153",
          "959-1114",
          "955-0046",
          "959-1115",
          "955-0142",
          "955-0156",
          "955-0821",
          "959-1122",
          "955-0844",
          "955-0152",
          "955-0146",
          "955-0001",
          "955-0041",
          "959-1118",
          "955-0125",
          "955-0163",
          "955-0105",
          "955-0842",
          "955-0168",
          "955-0042",
          "955-0824",
          "955-0093",
          "955-0021",
          "955-0843",
          "955-0011",
          "955-0808",
          "955-0063",
          "955-0832",
          "955-0092",
          "955-0004",
          "955-0801",
          "959-1131",
          "959-1121",
          "959-1124",
          "955-0095",
          "955-0161",
          "955-0165",
          "955-0164",
          "955-0044",
          "955-0143",
          "955-0117",
          "959-1111",
          "955-0035",
          "955-0112",
          "955-0055",
          "955-0803",
          "955-0051",
          "959-1104",
          "959-1119",
          "955-0831",
          "955-0113",
          "955-0157",
          "959-1125",
          "959-1133",
          "955-0132",
          "955-0062",
          "955-0147",
          "955-0806",
          "955-0144",
          "959-1153",
          "955-0134",
          "955-0082",
          "955-0033",
          "955-0014",
          "955-0815",
          "955-0822",
          "955-0845",
          "955-0851",
          "955-0057",
          "955-0812",
          "955-0804",
          "955-0131",
          "955-0073",
          "955-0148",
          "955-0167",
          "955-0061",
          "955-0135",
          "955-0158",
          "959-1146",
          "955-0081",
          "955-0032",
          "955-0047",
          "955-0863",
          "955-0816",
          "955-0823",
          "959-1152",
          "955-0155",
          "955-0162",
          "959-1156",
          "959-1102",
          "959-1101",
          "959-1155",
          "959-1145",
          "959-1103",
          "955-0813",
          "955-0071",
          "959-1116",
          "955-0101",
          "955-0864",
          "955-0031",
          "955-0015",
          "955-0128",
          "955-0862",
          "955-0106",
          "955-0811",
          "955-0852",
          "955-0127",
          "955-0136",
          "955-0072",
          "955-0116",
          "959-1112",
          "959-1107",
          "955-0002",
          "955-0024",
          "955-0003",
          "955-0841",
          "955-0064",
          "955-0805",
          "959-1106",
          "955-0854",
          "959-1105",
          "959-1132",
          "945-0000",
          "945-0016",
          "945-0847",
          "949-3664",
          "949-3663",
          "945-0814",
          "945-0112",
          "945-0017",
          "945-0071",
          "945-0219",
          "945-0212",
          "945-1436",
          "945-1251",
          "945-1341",
          "945-1114",
          "945-0811",
          "945-0055",
          "945-0044",
          "949-3661",
          "945-0851",
          "945-1126",
          "945-1438",
          "949-3674",
          "949-3672",
          "949-3724",
          "945-0403",
          "945-0076",
          "945-1252",
          "945-1253",
          "945-1123",
          "945-0053",
          "949-3662",
          "945-0074",
          "945-0065",
          "945-1431",
          "945-1121",
          "945-1351",
          "945-0021",
          "945-1355",
          "945-1247",
          "949-3732",
          "945-0072",
          "945-0035",
          "945-0815",
          "949-3725",
          "945-0855",
          "945-1124",
          "945-1243",
          "945-0836",
          "945-0835",
          "945-1102",
          "945-0024",
          "945-0211",
          "949-3735",
          "945-0858",
          "945-1125",
          "945-0846",
          "945-0821",
          "945-0061",
          "945-0073",
          "945-1354",
          "945-1115",
          "945-0034",
          "945-0401",
          "945-1246",
          "945-0103",
          "945-1104",
          "945-1345",
          "945-1118",
          "945-1343",
          "945-0825",
          "945-0845",
          "945-0031",
          "945-1122",
          "945-0056",
          "945-0062",
          "945-0063",
          "945-0832",
          "945-1432",
          "945-0214",
          "945-0217",
          "949-3673",
          "945-1515",
          "945-1511",
          "945-1501",
          "945-1502",
          "945-1512",
          "945-1513",
          "945-1505",
          "945-1514",
          "945-1504",
          "945-1503",
          "945-0817",
          "945-0032",
          "945-0816",
          "945-1248",
          "945-0857",
          "945-0064",
          "945-0105",
          "945-0106",
          "945-0104",
          "949-3731",
          "945-0854",
          "945-0834",
          "945-0101",
          "945-0102",
          "945-0113",
          "945-0852",
          "945-0042",
          "945-1105",
          "945-0213",
          "945-0823",
          "945-0052",
          "949-3723",
          "945-0066",
          "945-0067",
          "949-4123",
          "949-4201",
          "949-4149",
          "949-4128",
          "949-4131",
          "949-4148",
          "949-4204",
          "949-4203",
          "949-4147",
          "949-4133",
          "949-4112",
          "949-4202",
          "949-4127",
          "949-4113",
          "949-4145",
          "949-4142",
          "949-4206",
          "949-4135",
          "949-4126",
          "949-4144",
          "949-4121",
          "949-4125",
          "949-4132",
          "949-4141",
          "949-4114",
          "949-4205",
          "949-4122",
          "949-4134",
          "949-4111",
          "949-4136",
          "949-4146",
          "949-4124",
          "949-4143",
          "945-0054",
          "945-1112",
          "945-1241",
          "945-0012",
          "945-0014",
          "945-0218",
          "945-0023",
          "945-0853",
          "945-0812",
          "949-3722",
          "945-0033",
          "945-0022",
          "945-0051",
          "945-0068",
          "945-0036",
          "945-0047",
          "945-0043",
          "945-1353",
          "945-0824",
          "945-0114",
          "945-1103",
          "945-0026",
          "945-1113",
          "945-0027",
          "945-1242",
          "945-0822",
          "945-1111",
          "949-3733",
          "945-0015",
          "945-0011",
          "945-0041",
          "945-0837",
          "945-0838",
          "945-1244",
          "945-0841",
          "949-3734",
          "945-0813",
          "945-0402",
          "945-1245",
          "945-1434",
          "945-1117",
          "945-0827",
          "945-0826",
          "945-1435",
          "945-1352",
          "945-0215",
          "945-0025",
          "945-0831",
          "945-1116",
          "949-3726",
          "945-0075",
          "945-1437",
          "945-0013",
          "945-0045",
          "945-1106",
          "945-1433",
          "945-1101",
          "945-0216",
          "949-3721",
          "945-0111",
          "945-0046",
          "945-0842",
          "945-0843",
          "945-0844",
          "949-3675",
          "945-1344",
          "945-0833",
          "949-3671",
          "957-0000",
          "959-2314",
          "957-0045",
          "959-2311",
          "959-2443",
          "957-0084",
          "957-0085",
          "957-0086",
          "959-2321",
          "957-0353",
          "957-0021",
          "957-0013",
          "957-0344",
          "959-2406",
          "957-0204",
          "957-0035",
          "957-0042",
          "957-0041",
          "957-0037",
          "957-0043",
          "957-0091",
          "957-0465",
          "957-0052",
          "957-0347",
          "957-0217",
          "959-2461",
          "959-2463",
          "957-0356",
          "959-2333",
          "957-0224",
          "959-2471",
          "957-0064",
          "959-2402",
          "959-2434",
          "957-0345",
          "959-2323",
          "957-0031",
          "957-0034",
          "959-2476",
          "959-2472",
          "959-2336",
          "957-0212",
          "959-2479",
          "959-2441",
          "959-2464",
          "957-0014",
          "959-2473",
          "959-2431",
          "957-0464",
          "959-2501",
          "959-2514",
          "959-2421",
          "957-0334",
          "959-2455",
          "957-0331",
          "959-2504",
          "957-0024",
          "959-2452",
          "957-0025",
          "959-2523",
          "957-0081",
          "957-0046",
          "957-0343",
          "959-2407",
          "959-2435",
          "959-2522",
          "957-0074",
          "959-2303",
          "959-2502",
          "959-2521",
          "959-2527",
          "957-0003",
          "959-2512",
          "959-2437",
          "959-2315",
          "957-0202",
          "959-2401",
          "957-0007",
          "959-2474",
          "957-0082",
          "959-2513",
          "957-0011",
          "959-2331",
          "959-2516",
          "959-2457",
          "957-0335",
          "957-0083",
          "959-2477",
          "959-2456",
          "959-2478",
          "957-0336",
          "959-2505",
          "959-2404",
          "957-0023",
          "957-0354",
          "957-0026",
          "959-2451",
          "959-2524",
          "957-0203",
          "959-2322",
          "959-2503",
          "959-2417",
          "957-0341",
          "959-2414",
          "957-0051",
          "957-0063",
          "957-0017",
          "959-2444",
          "959-2511",
          "957-0087",
          "959-2415",
          "957-0215",
          "957-0061",
          "957-0055",
          "957-0205",
          "959-2422",
          "959-2436",
          "959-2465",
          "957-0071",
          "957-0056",
          "959-2304",
          "957-0333",
          "957-0213",
          "959-2425",
          "959-2518",
          "959-2381",
          "957-0462",
          "959-2301",
          "959-2337",
          "959-2312",
          "959-2445",
          "957-0053",
          "957-0221",
          "959-2403",
          "959-2334",
          "959-2338",
          "957-0355",
          "959-2475",
          "959-2325",
          "959-2305",
          "957-0001",
          "957-0015",
          "959-2462",
          "957-0207",
          "957-0062",
          "957-0332",
          "957-0092",
          "959-2515",
          "959-2525",
          "957-0214",
          "957-0223",
          "957-0067",
          "957-0006",
          "959-2468",
          "959-2526",
          "957-0461",
          "957-0222",
          "959-2329",
          "957-0005",
          "957-0002",
          "959-2416",
          "957-0058",
          "957-0004",
          "957-0357",
          "957-0075",
          "957-0076",
          "959-2432",
          "959-2405",
          "957-0077",
          "957-0078",
          "959-2328",
          "959-2413",
          "959-2454",
          "959-2332",
          "957-0463",
          "957-0012",
          "957-0351",
          "959-2528",
          "957-0235",
          "959-2412",
          "957-0072",
          "957-0206",
          "959-2327",
          "959-2313",
          "957-0231",
          "959-2302",
          "957-0234",
          "957-0066",
          "957-0065",
          "959-2517",
          "959-2433",
          "959-2409",
          "957-0022",
          "957-0047",
          "959-2335",
          "957-0054",
          "957-0342",
          "957-0044",
          "957-0201",
          "957-0233",
          "957-0232",
          "957-0073",
          "959-2507",
          "957-0048",
          "959-2453",
          "959-2326",
          "957-0018",
          "957-0352",
          "957-0216",
          "957-0346",
          "957-0226",
          "957-0057",
          "959-2442",
          "957-0027",
          "959-2426",
          "957-0236",
          "957-0466",
          "957-0028",
          "957-0033",
          "957-0032",
          "957-0016",
          "959-2411",
          "959-2506",
          "959-2324",
          "959-2408",
          "957-0036",
          "957-0225",
          "947-0000",
          "947-0005",
          "949-8728",
          "949-8727",
          "947-0025",
          "949-8724",
          "947-0026",
          "947-0001",
          "947-0101",
          "947-0103",
          "947-0013",
          "949-8722",
          "949-8723",
          "947-0045",
          "947-0211",
          "947-0041",
          "947-0011",
          "947-0035",
          "947-0051",
          "947-0213",
          "949-8721",
          "947-0028",
          "947-0102",
          "947-0052",
          "947-0053",
          "947-0031",
          "947-0044",
          "947-0004",
          "947-0033",
          "947-0014",
          "947-0018",
          "947-0003",
          "947-0017",
          "947-0023",
          "947-0042",
          "947-0024",
          "947-0027",
          "949-8725",
          "947-0021",
          "949-8726",
          "947-0212",
          "947-0022",
          "947-0015",
          "947-0032",
          "947-0012",
          "947-0043",
          "947-0002",
          "947-0016",
          "947-0034",
          "947-0054",
          "959-1300",
          "959-1326",
          "959-1324",
          "959-1356",
          "959-1383",
          "959-1312",
          "959-1306",
          "959-1303",
          "959-1378",
          "959-1377",
          "959-1322",
          "959-1343",
          "959-1347",
          "959-1342",
          "959-1352",
          "959-1311",
          "959-1301",
          "959-1321",
          "959-1336",
          "959-1361",
          "959-1371",
          "959-1302",
          "959-1384",
          "959-1375",
          "959-1353",
          "959-1313",
          "959-1382",
          "959-1357",
          "959-1363",
          "959-1344",
          "959-1346",
          "959-1341",
          "959-1332",
          "959-1381",
          "959-1328",
          "959-1354",
          "959-1325",
          "959-1305",
          "959-1334",
          "959-1327",
          "959-1385",
          "959-1387",
          "959-1307",
          "959-1315",
          "959-1345",
          "959-1335",
          "959-1351",
          "959-1376",
          "959-1337",
          "959-1314",
          "959-1372",
          "959-1304",
          "959-1373",
          "959-1331",
          "959-1323",
          "959-1348",
          "959-1374",
          "959-1386",
          "959-1316",
          "959-1333",
          "959-1362",
          "959-1355",
          "948-0000",
          "942-1543",
          "948-0046",
          "948-0213",
          "948-0045",
          "948-0079",
          "942-1531",
          "949-8544",
          "949-8531",
          "949-8445",
          "948-0121",
          "949-8414",
          "949-8502",
          "949-8562",
          "949-8541",
          "942-1525",
          "949-8532",
          "942-1515",
          "948-0062",
          "948-0131",
          "949-8422",
          "948-0101",
          "948-0073",
          "948-0091",
          "948-0092",
          "948-0093",
          "942-1504",
          "949-8441",
          "949-8421",
          "949-8405",
          "948-0212",
          "948-0122",
          "942-1342",
          "949-8533",
          "949-8401",
          "948-0088",
          "948-0014",
          "948-0018",
          "949-8555",
          "948-0211",
          "949-8521",
          "948-0305",
          "949-8524",
          "948-0133",
          "948-0008",
          "942-1505",
          "942-1511",
          "948-0086",
          "949-8435",
          "948-0057",
          "942-1502",
          "948-0022",
          "949-8402",
          "948-0134",
          "948-0029",
          "949-8602",
          "942-1534",
          "948-0038",
          "948-0036",
          "948-0035",
          "948-0013",
          "948-0304",
          "949-8419",
          "948-0105",
          "948-0041",
          "942-1536",
          "942-1541",
          "942-1352",
          "949-8432",
          "949-8412",
          "949-8543",
          "949-8603",
          "949-8542",
          "942-1523",
          "942-1538",
          "948-0103",
          "949-8433",
          "949-8416",
          "949-8527",
          "948-0001",
          "948-0219",
          "948-0306",
          "948-0051",
          "948-0125",
          "949-8409",
          "942-1514",
          "948-0218",
          "949-8436",
          "949-8525",
          "948-0068",
          "948-0058",
          "948-0112",
          "948-0111",
          "948-0113",
          "948-0114",
          "948-0015",
          "948-0124",
          "948-0002",
          "948-0039",
          "948-0123",
          "948-0084",
          "942-1542",
          "948-0004",
          "949-8604",
          "948-0141",
          "949-8442",
          "948-0061",
          "949-8427",
          "949-8612",
          "948-0012",
          "948-0011",
          "949-8526",
          "948-0025",
          "942-1521",
          "949-8561",
          "948-0017",
          "948-0076",
          "948-0024",
          "949-8444",
          "948-0087",
          "948-0032",
          "942-1532",
          "942-1527",
          "948-0217",
          "948-0107",
          "948-0056",
          "948-0063",
          "948-0064",
          "948-0065",
          "949-8423",
          "948-0136",
          "948-0055",
          "948-0021",
          "942-1501",
          "942-1356",
          "949-8403",
          "949-8413",
          "949-8522",
          "948-0047",
          "948-0215",
          "949-8407",
          "948-0028",
          "942-1533",
          "949-8556",
          "948-0044",
          "948-0104",
          "942-1524",
          "948-0067",
          "948-0078",
          "948-0016",
          "948-0054",
          "949-8431",
          "948-0145",
          "948-0037",
          "948-0146",
          "948-0303",
          "942-1537",
          "949-8523",
          "942-1351",
          "948-0142",
          "948-0019",
          "949-8415",
          "948-0132",
          "942-1506",
          "949-8552",
          "949-8443",
          "949-8616",
          "949-8613",
          "949-8617",
          "949-8615",
          "949-8611",
          "949-8614",
          "949-8618",
          "948-0214",
          "948-0042",
          "948-0135",
          "949-8554",
          "942-1535",
          "942-1355",
          "948-0074",
          "948-0053",
          "949-8437",
          "948-0085",
          "948-0072",
          "948-0302",
          "949-8404",
          "948-0301",
          "949-8545",
          "948-0071",
          "948-0033",
          "949-8551",
          "949-8446",
          "949-8601",
          "949-8424",
          "949-8425",
          "949-8408",
          "942-1354",
          "948-0066",
          "948-0034",
          "948-0049",
          "949-8417",
          "949-8534",
          "949-8426",
          "949-8504",
          "948-0003",
          "948-0083",
          "948-0082",
          "948-0081",
          "942-1526",
          "942-1513",
          "942-1522",
          "942-1512",
          "942-1406",
          "942-1423",
          "942-1435",
          "942-1434",
          "942-1404",
          "942-1421",
          "942-1417",
          "942-1403",
          "942-1426",
          "942-1415",
          "942-1341",
          "942-1402",
          "942-1416",
          "942-1413",
          "942-1425",
          "942-1422",
          "942-1418",
          "942-1428",
          "942-1419",
          "942-1427",
          "942-1424",
          "942-1405",
          "942-1429",
          "942-1414",
          "942-1411",
          "942-1412",
          "942-1401",
          "942-1432",
          "942-1431",
          "948-0075",
          "949-8558",
          "949-8557",
          "948-0026",
          "948-0144",
          "948-0106",
          "948-0005",
          "949-8418",
          "948-0023",
          "949-8505",
          "948-0052",
          "949-8434",
          "948-0216",
          "942-1353",
          "942-1503",
          "949-8503",
          "948-0048",
          "949-8406",
          "948-0143",
          "948-0031",
          "948-0102",
          "948-0006",
          "948-0007",
          "942-1544",
          "948-0043",
          "948-0027",
          "954-0000",
          "954-0073",
          "954-0061",
          "954-0038",
          "954-0021",
          "954-0013",
          "954-0083",
          "954-0111",
          "954-0025",
          "954-0008",
          "954-0063",
          "954-0031",
          "954-0064",
          "954-0081",
          "954-0052",
          "954-0084",
          "954-0112",
          "954-0024",
          "954-0072",
          "954-0058",
          "954-0077",
          "954-0078",
          "954-0067",
          "954-0079",
          "954-0002",
          "954-0104",
          "954-0001",
          "954-0101",
          "954-0087",
          "954-0012",
          "954-0062",
          "954-0105",
          "954-0007",
          "954-0102",
          "954-0017",
          "954-0016",
          "954-0059",
          "954-0076",
          "954-0026",
          "954-0057",
          "954-0022",
          "954-0085",
          "954-0036",
          "954-0103",
          "954-0034",
          "954-0037",
          "954-0005",
          "954-0041",
          "954-0027",
          "954-0044",
          "954-0035",
          "954-0089",
          "954-0088",
          "954-0006",
          "954-0068",
          "954-0107",
          "954-0075",
          "954-0106",
          "954-0086",
          "954-0046",
          "954-0071",
          "954-0054",
          "954-0014",
          "954-0051",
          "954-0053",
          "954-0032",
          "954-0091",
          "954-0045",
          "954-0056",
          "954-0055",
          "954-0043",
          "954-0023",
          "954-0033",
          "954-0004",
          "954-0082",
          "954-0011",
          "954-0042",
          "954-0074",
          "958-0000",
          "958-0816",
          "958-0270",
          "958-0226",
          "959-3651",
          "959-3923",
          "959-3921",
          "959-3125",
          "958-0203",
          "959-3103",
          "958-0846",
          "959-3116",
          "958-0232",
          "959-3414",
          "959-3422",
          "958-0857",
          "958-0856",
          "958-0855",
          "959-3916",
          "959-3901",
          "958-0235",
          "958-0832",
          "958-0877",
          "959-3663",
          "958-0214",
          "959-3937",
          "959-3662",
          "959-3416",
          "958-0813",
          "958-0008",
          "958-0241",
          "959-3903",
          "958-0251",
          "959-3426",
          "959-3449",
          "958-0044",
          "958-0045",
          "958-0047",
          "958-0051",
          "958-0042",
          "958-0048",
          "958-0043",
          "958-0046",
          "958-0054",
          "958-0055",
          "958-0056",
          "958-0041",
          "958-0058",
          "958-0057",
          "958-0262",
          "959-3436",
          "959-3947",
          "958-0264",
          "958-0036",
          "959-3117",
          "958-0867",
          "958-0815",
          "959-3926",
          "959-3925",
          "958-0202",
          "958-0812",
          "959-3915",
          "958-0012",
          "959-3906",
          "959-3122",
          "959-3415",
          "958-0007",
          "958-0253",
          "958-0842",
          "958-0268",
          "958-0848",
          "959-3912",
          "958-0806",
          "959-3914",
          "959-3102",
          "958-0875",
          "959-3932",
          "958-0004",
          "958-0863",
          "959-3448",
          "958-0872",
          "959-3942",
          "958-0031",
          "959-3124",
          "958-0245",
          "958-0808",
          "959-3948",
          "959-3934",
          "959-3108",
          "958-0873",
          "959-3403",
          "958-0236",
          "958-0053",
          "958-0805",
          "959-3417",
          "958-0263",
          "959-3433",
          "959-3653",
          "959-3913",
          "958-0843",
          "959-3936",
          "958-0212",
          "959-3924",
          "959-3443",
          "959-3935",
          "959-3927",
          "959-3106",
          "958-0242",
          "958-0807",
          "958-0871",
          "958-0255",
          "958-0224",
          "959-3665",
          "958-0014",
          "958-0244",
          "959-3941",
          "959-3413",
          "959-3434",
          "959-3652",
          "959-3446",
          "959-3423",
          "958-0204",
          "958-0841",
          "958-0221",
          "958-0845",
          "958-0865",
          "958-0864",
          "959-3132",
          "959-3664",
          "959-3121",
          "958-0246",
          "959-3412",
          "959-3405",
          "958-0821",
          "958-0261",
          "958-0222",
          "958-0853",
          "958-0837",
          "958-0205",
          "958-0876",
          "959-3441",
          "959-3402",
          "958-0809",
          "959-3943",
          "959-3933",
          "959-3107",
          "958-0252",
          "959-3406",
          "958-0265",
          "958-0804",
          "958-0874",
          "959-3115",
          "958-0834",
          "958-0817",
          "959-3911",
          "958-0831",
          "958-0225",
          "958-0037",
          "958-0023",
          "958-0021",
          "958-0024",
          "958-0026",
          "958-0022",
          "958-0254",
          "958-0847",
          "958-0811",
          "958-0211",
          "959-3447",
          "958-0011",
          "959-3944",
          "958-0854",
          "958-0243",
          "958-0823",
          "959-3432",
          "958-0822",
          "958-0267",
          "958-0849",
          "958-0803",
          "959-3919",
          "959-3938",
          "959-3407",
          "959-3126",
          "958-0844",
          "958-0861",
          "959-3123",
          "959-3931",
          "958-0233",
          "959-3918",
          "959-3928",
          "959-3112",
          "959-3902",
          "958-0223",
          "959-3111",
          "959-3442",
          "959-3105",
          "959-3401",
          "959-3113",
          "959-3445",
          "958-0801",
          "958-0835",
          "959-3904",
          "958-0231",
          "959-3946",
          "958-0006",
          "959-3134",
          "958-0836",
          "958-0851",
          "958-0013",
          "959-3101",
          "958-0038",
          "959-3666",
          "958-0002",
          "959-3104",
          "958-0215",
          "959-3431",
          "959-3437",
          "958-0818",
          "959-3131",
          "958-0201",
          "959-3907",
          "958-0269",
          "959-3922",
          "958-0833",
          "958-0234",
          "959-3905",
          "958-0001",
          "959-3424",
          "958-0005",
          "959-3945",
          "958-0206",
          "959-3428",
          "959-3427",
          "958-0025",
          "958-0032",
          "958-0034",
          "958-0035",
          "958-0033",
          "959-3411",
          "959-3114",
          "959-3444",
          "958-0852",
          "958-0266",
          "958-0866",
          "958-0824",
          "959-3421",
          "958-0814",
          "959-3435",
          "959-3133",
          "959-3917",
          "959-3425",
          "959-3404",
          "958-0052",
          "958-0003",
          "958-0802",
          "958-0862",
          "959-3661",
          "958-0213",
          "959-1200",
          "959-0227",
          "959-1261",
          "959-0131",
          "959-0114",
          "959-1232",
          "959-0113",
          "959-0123",
          "959-1287",
          "959-0108",
          "959-0122",
          "959-1212",
          "959-1263",
          "959-0207",
          "959-0225",
          "959-0181",
          "959-1223",
          "959-1217",
          "959-0136",
          "959-0112",
          "959-1271",
          "959-0137",
          "959-1276",
          "959-1275",
          "959-1256",
          "959-0203",
          "959-1286",
          "959-0124",
          "959-1241",
          "959-1252",
          "959-1211",
          "959-1213",
          "959-1226",
          "959-1254",
          "959-1281",
          "959-0117",
          "959-0101",
          "959-0202",
          "959-1228",
          "959-1207",
          "959-0121",
          "959-0129",
          "959-0222",
          "959-0183",
          "959-1246",
          "959-0116",
          "959-1214",
          "959-0125",
          "959-1255",
          "959-1262",
          "959-1273",
          "959-1272",
          "959-0205",
          "959-0103",
          "959-1206",
          "959-1284",
          "959-0208",
          "959-0228",
          "959-1203",
          "959-0223",
          "959-1244",
          "959-1204",
          "959-0139",
          "959-1222",
          "959-1288",
          "959-1265",
          "959-1233",
          "959-0211",
          "959-0212",
          "959-1225",
          "959-0105",
          "959-0182",
          "959-1258",
          "959-1205",
          "959-0133",
          "959-1216",
          "959-0201",
          "959-0126",
          "959-0224",
          "959-1201",
          "959-1251",
          "959-1264",
          "959-1221",
          "959-1280",
          "959-1289",
          "959-1242",
          "959-1277",
          "959-0132",
          "959-0107",
          "959-0119",
          "959-0115",
          "959-0109",
          "959-0120",
          "959-0130",
          "959-0128",
          "959-0106",
          "959-0127",
          "959-0118",
          "959-0104",
          "959-1253",
          "959-0102",
          "959-0134",
          "959-0138",
          "959-1215",
          "959-1202",
          "959-0172",
          "959-0171",
          "959-1234",
          "959-1257",
          "959-1274",
          "959-0111",
          "959-0263",
          "959-0264",
          "959-0217",
          "959-0235",
          "959-0265",
          "959-0216",
          "959-0252",
          "959-0241",
          "959-0245",
          "959-0261",
          "959-0256",
          "959-0257",
          "959-0233",
          "959-0215",
          "959-0253",
          "959-0247",
          "959-0246",
          "959-0254",
          "959-0234",
          "959-0242",
          "959-0237",
          "959-0244",
          "959-0221",
          "959-0248",
          "959-0232",
          "959-0231",
          "959-0266",
          "959-0214",
          "959-0251",
          "959-0243",
          "959-0236",
          "959-0267",
          "959-0268",
          "959-0250",
          "959-0255",
          "959-0213",
          "959-0262",
          "959-1224",
          "959-0206",
          "959-0135",
          "941-0000",
          "949-0112",
          "941-0005",
          "941-0022",
          "941-0031",
          "949-1211",
          "949-0534",
          "941-0034",
          "941-0056",
          "949-0111",
          "949-0302",
          "941-0078",
          "941-0064",
          "949-0551",
          "949-0553",
          "949-1336",
          "949-0307",
          "949-0532",
          "949-0305",
          "949-0545",
          "949-1331",
          "949-1221",
          "949-0464",
          "941-0071",
          "949-1303",
          "941-0061",
          "941-0074",
          "941-0051",
          "949-1343",
          "949-1335",
          "949-1225",
          "941-0004",
          "949-0544",
          "949-1337",
          "949-0552",
          "941-0036",
          "941-0012",
          "949-0541",
          "941-0042",
          "949-1329",
          "949-1226",
          "949-1344",
          "941-0054",
          "941-0063",
          "949-1325",
          "949-0535",
          "941-0032",
          "949-1201",
          "941-0033",
          "949-0462",
          "949-1342",
          "949-1353",
          "949-1354",
          "949-1315",
          "949-1206",
          "949-1313",
          "949-1333",
          "941-0015",
          "941-0013",
          "941-0023",
          "941-0041",
          "941-0065",
          "949-1327",
          "949-0556",
          "949-0301",
          "949-1224",
          "949-1302",
          "949-1319",
          "949-0533",
          "949-0542",
          "949-1317",
          "949-1341",
          "949-1334",
          "949-1311",
          "941-0011",
          "941-0006",
          "941-0043",
          "941-0008",
          "949-1323",
          "941-0026",
          "949-1215",
          "941-0062",
          "949-1222",
          "949-1205",
          "949-1306",
          "949-1208",
          "941-0077",
          "949-0304",
          "941-0066",
          "941-0058",
          "949-1338",
          "949-1332",
          "949-1305",
          "941-0037",
          "949-0303",
          "941-0019",
          "949-1301",
          "949-0308",
          "949-1223",
          "941-0003",
          "949-1203",
          "949-1314",
          "941-0002",
          "949-1204",
          "941-0075",
          "941-0045",
          "941-0073",
          "949-1213",
          "941-0076",
          "949-1322",
          "941-0024",
          "949-0461",
          "949-0557",
          "941-0014",
          "949-0536",
          "949-1352",
          "949-1351",
          "949-0306",
          "949-1316",
          "941-0046",
          "941-0021",
          "941-0027",
          "949-1321",
          "949-1212",
          "941-0053",
          "949-0531",
          "941-0047",
          "949-1207",
          "949-0555",
          "941-0025",
          "941-0068",
          "941-0035",
          "949-1312",
          "949-1324",
          "941-0001",
          "941-0044",
          "949-1328",
          "949-1214",
          "941-0052",
          "941-0069",
          "941-0057",
          "949-1202",
          "949-1326",
          "949-1304",
          "949-0554",
          "949-0543",
          "941-0007",
          "949-0463",
          "941-0072",
          "941-0067",
          "949-0558",
          "941-0016",
          "941-0055",
          "949-1318",
          "944-0000",
          "944-0091",
          "949-2111",
          "944-0043",
          "944-0041",
          "944-0054",
          "944-0011",
          "944-0084",
          "944-0006",
          "944-0075",
          "949-2208",
          "944-0032",
          "944-0215",
          "944-0333",
          "949-2221",
          "944-0216",
          "949-2225",
          "944-0224",
          "944-0332",
          "944-0094",
          "949-2212",
          "949-2224",
          "944-0082",
          "944-0081",
          "944-0037",
          "949-2104",
          "949-2205",
          "944-0223",
          "944-0025",
          "944-0001",
          "944-0052",
          "949-2233",
          "944-0212",
          "944-0088",
          "944-0225",
          "944-0344",
          "944-0205",
          "944-0046",
          "944-0083",
          "944-0026",
          "944-0021",
          "949-2203",
          "944-0034",
          "949-2207",
          "944-0061",
          "944-0007",
          "949-2105",
          "944-0020",
          "944-0004",
          "944-0213",
          "944-0226",
          "944-0221",
          "944-0331",
          "944-0072",
          "944-0086",
          "944-0044",
          "949-2234",
          "949-2202",
          "944-0341",
          "944-0053",
          "944-0056",
          "944-0042",
          "944-0035",
          "944-0203",
          "944-0343",
          "944-0048",
          "944-0096",
          "944-0005",
          "944-0019",
          "944-0087",
          "944-0036",
          "944-0057",
          "949-2113",
          "949-2226",
          "944-0018",
          "949-2112",
          "944-0014",
          "949-2141",
          "949-2235",
          "949-2103",
          "949-2209",
          "944-0013",
          "949-2102",
          "949-2106",
          "949-2211",
          "944-0031",
          "389-2261",
          "949-2223",
          "944-0017",
          "944-0003",
          "944-0222",
          "949-2201",
          "944-0009",
          "944-0095",
          "944-0076",
          "949-2222",
          "944-0345",
          "944-0342",
          "944-0027",
          "949-2214",
          "949-2204",
          "944-0045",
          "944-0073",
          "944-0217",
          "944-0077",
          "944-0051",
          "944-0023",
          "944-0058",
          "949-2206",
          "944-0064",
          "944-0063",
          "944-0334",
          "944-0204",
          "944-0047",
          "949-2215",
          "949-2218",
          "949-2219",
          "944-0055",
          "944-0214",
          "944-0335",
          "949-2213",
          "949-2217",
          "949-2216",
          "944-0092",
          "944-0093",
          "944-0016",
          "944-0201",
          "944-0028",
          "944-0002",
          "944-0033",
          "944-0071",
          "949-2101",
          "944-0202",
          "944-0074",
          "944-0097",
          "949-2232",
          "944-0085",
          "944-0008",
          "944-0098",
          "944-0022",
          "944-0024",
          "949-2231",
          "944-0062",
          "944-0211",
          "959-1600",
          "959-1755",
          "959-1641",
          "959-1831",
          "959-1821",
          "959-1862",
          "959-1765",
          "959-1717",
          "959-1737",
          "959-1861",
          "959-1833",
          "959-1857",
          "959-1701",
          "959-1876",
          "959-1813",
          "959-1601",
          "959-1835",
          "959-1749",
          "959-1823",
          "959-1867",
          "959-1731",
          "959-1636",
          "959-1845",
          "959-1633",
          "959-1825",
          "959-1623",
          "959-1734",
          "959-1852",
          "959-1603",
          "959-1855",
          "959-1621",
          "959-1624",
          "959-1866",
          "959-1744",
          "959-1708",
          "959-1726",
          "959-1746",
          "959-1635",
          "959-1756",
          "959-1832",
          "959-1711",
          "959-1834",
          "959-1709",
          "959-1814",
          "959-1625",
          "959-1716",
          "959-1763",
          "959-1721",
          "959-1864",
          "959-1612",
          "959-1622",
          "959-1851",
          "959-1725",
          "959-1613",
          "959-1753",
          "959-1611",
          "959-1724",
          "959-1615",
          "959-1806",
          "959-1631",
          "959-1811",
          "959-1718",
          "959-1743",
          "959-1803",
          "959-1802",
          "959-1727",
          "959-1745",
          "959-1846",
          "959-1758",
          "959-1767",
          "959-1637",
          "959-1847",
          "959-1714",
          "959-1747",
          "959-1602",
          "959-1804",
          "959-1751",
          "959-1752",
          "959-1807",
          "959-1643",
          "959-1837",
          "959-1742",
          "959-1853",
          "959-1712",
          "959-1632",
          "959-1732",
          "959-1754",
          "959-1757",
          "959-1715",
          "959-1873",
          "959-1844",
          "959-1842",
          "959-1801",
          "959-1871",
          "959-1848",
          "959-1875",
          "959-1766",
          "959-1762",
          "959-1863",
          "959-1644",
          "959-1735",
          "959-1841",
          "959-1634",
          "959-1805",
          "959-1738",
          "959-1865",
          "959-1614",
          "959-1748",
          "959-1843",
          "959-1722",
          "959-1854",
          "959-1759",
          "959-1812",
          "959-1713",
          "959-1822",
          "959-1741",
          "959-1836",
          "959-1872",
          "959-1764",
          "959-1707",
          "959-1705",
          "959-1704",
          "959-1706",
          "959-1739",
          "959-1761",
          "959-1733",
          "959-1703",
          "959-1856",
          "959-1736",
          "959-1874",
          "959-1723",
          "959-1824",
          "959-1642",
          "959-1604",
          "943-0000",
          "943-0871",
          "942-0238",
          "943-0886",
          "942-0003",
          "943-0139",
          "943-0862",
          "943-0187",
          "949-1702",
          "943-0896",
          "943-0422",
          "942-0039",
          "943-0128",
          "942-0242",
          "943-0872",
          "942-0074",
          "942-0023",
          "944-0150",
          "944-0101",
          "944-0119",
          "944-0123",
          "944-0147",
          "944-0102",
          "944-0124",
          "944-0139",
          "944-0138",
          "944-0118",
          "944-0115",
          "944-0146",
          "944-0133",
          "944-0129",
          "944-0107",
          "944-0125",
          "944-0106",
          "944-0149",
          "944-0144",
          "944-0116",
          "944-0143",
          "944-0132",
          "944-0141",
          "944-0142",
          "944-0114",
          "944-0105",
          "944-0117",
          "944-0109",
          "944-0104",
          "944-0122",
          "944-0108",
          "944-0112",
          "944-0128",
          "944-0131",
          "944-0126",
          "944-0134",
          "944-0127",
          "944-0113",
          "944-0151",
          "944-0145",
          "944-0103",
          "944-0111",
          "944-0136",
          "944-0121",
          "944-0148",
          "944-0137",
          "944-0135",
          "943-0186",
          "943-0117",
          "943-0154",
          "943-0425",
          "943-0874",
          "943-0129",
          "943-0145",
          "943-0864",
          "943-0814",
          "943-0889",
          "943-0818",
          "942-0306",
          "942-0336",
          "942-0335",
          "942-0332",
          "942-0338",
          "942-0312",
          "942-0307",
          "942-0301",
          "942-0318",
          "942-0311",
          "942-0321",
          "942-0314",
          "942-0308",
          "942-0302",
          "942-0333",
          "942-0303",
          "942-0313",
          "942-0323",
          "942-0317",
          "942-0324",
          "942-0325",
          "942-0304",
          "942-0331",
          "942-0319",
          "942-0327",
          "942-0339",
          "942-0326",
          "942-0316",
          "942-0305",
          "942-0337",
          "942-0334",
          "942-0315",
          "942-0322",
          "942-0025",
          "949-1723",
          "949-1724",
          "949-3134",
          "949-3122",
          "949-3135",
          "949-3136",
          "949-3121",
          "949-3103",
          "942-0181",
          "949-3137",
          "949-3114",
          "949-3101",
          "949-3102",
          "949-3117",
          "949-3116",
          "949-3131",
          "949-3115",
          "949-3113",
          "949-3133",
          "949-3112",
          "949-3123",
          "949-3125",
          "949-3124",
          "949-3111",
          "949-3132",
          "943-0414",
          "942-1107",
          "942-1215",
          "942-1211",
          "942-1103",
          "942-1106",
          "942-1105",
          "942-1104",
          "942-1216",
          "942-1213",
          "942-1102",
          "942-1212",
          "942-1214",
          "942-1101",
          "943-0838",
          "943-0893",
          "942-0089",
          "949-1733",
          "943-0833",
          "942-0233",
          "943-0858",
          "942-0086",
          "949-3363",
          "949-3236",
          "949-3374",
          "949-3376",
          "949-3378",
          "949-3253",
          "949-3221",
          "949-3235",
          "949-3246",
          "949-3216",
          "949-3225",
          "949-3231",
          "949-3243",
          "949-3366",
          "949-3252",
          "949-3213",
          "949-3237",
          "949-3223",
          "949-3245",
          "949-3362",
          "949-3251",
          "949-3254",
          "949-3242",
          "949-3367",
          "949-3232",
          "949-3244",
          "949-3226",
          "949-3375",
          "949-3371",
          "949-3255",
          "949-3361",
          "949-3234",
          "949-3377",
          "949-3201",
          "949-3247",
          "949-3222",
          "949-3215",
          "949-3214",
          "949-3224",
          "949-3364",
          "949-3379",
          "949-3373",
          "949-3211",
          "949-3365",
          "949-3372",
          "949-3256",
          "949-3241",
          "949-3233",
          "949-3212",
          "949-1712",
          "943-0809",
          "942-0061",
          "943-0803",
          "943-0807",
          "942-0021",
          "943-0113",
          "943-0168",
          "942-0052",
          "942-0254",
          "943-0165",
          "943-0811",
          "943-0894",
          "943-0143",
          "943-0424",
          "942-0035",
          "949-1741",
          "943-0126",
          "943-0884",
          "942-0252",
          "943-0112",
          "943-0856",
          "943-0101",
          "943-0876",
          "943-0839",
          "942-0241",
          "943-0153",
          "942-0038",
          "942-0065",
          "943-0855",
          "943-0805",
          "943-0412",
          "943-0824",
          "943-0806",
          "943-0109",
          "943-0106",
          "949-1736",
          "943-0161",
          "943-0828",
          "943-0848",
          "943-0881",
          "943-0531",
          "943-0527",
          "943-0502",
          "943-0513",
          "943-0533",
          "943-0501",
          "943-0507",
          "943-0516",
          "943-0504",
          "943-0534",
          "943-0503",
          "943-0525",
          "943-0511",
          "943-0506",
          "943-0535",
          "943-0523",
          "943-0521",
          "943-0532",
          "943-0526",
          "943-0522",
          "943-0505",
          "943-0508",
          "943-0512",
          "943-0524",
          "943-0514",
          "943-0510",
          "943-0515",
          "943-0509",
          "943-0183",
          "942-0165",
          "942-0225",
          "942-0125",
          "942-0135",
          "942-0221",
          "942-0141",
          "942-0152",
          "942-0139",
          "942-0121",
          "942-0154",
          "942-0201",
          "942-0214",
          "942-0116",
          "942-0163",
          "942-0102",
          "942-0114",
          "942-0208",
          "942-0164",
          "942-0111",
          "942-0202",
          "942-0133",
          "942-0142",
          "942-0203",
          "942-0106",
          "942-0145",
          "942-0122",
          "942-0171",
          "942-0132",
          "942-0151",
          "942-0215",
          "942-0136",
          "942-0104",
          "942-0134",
          "942-0143",
          "942-0137",
          "942-0155",
          "942-0123",
          "942-0206",
          "942-0108",
          "942-0146",
          "942-0153",
          "942-0157",
          "942-0128",
          "942-0129",
          "942-0115",
          "942-0131",
          "942-0207",
          "942-0161",
          "942-0109",
          "942-0105",
          "942-0103",
          "942-0213",
          "942-0113",
          "942-0205",
          "942-0107",
          "942-0091",
          "942-0147",
          "942-0117",
          "942-0224",
          "942-0138",
          "942-0211",
          "942-0222",
          "942-0112",
          "942-0124",
          "942-0216",
          "942-0127",
          "942-0173",
          "942-0156",
          "942-0158",
          "942-0144",
          "942-0126",
          "942-0172",
          "942-0162",
          "942-0223",
          "942-0212",
          "942-0101",
          "942-0204",
          "943-0127",
          "942-0013",
          "943-0885",
          "942-0251",
          "943-0823",
          "943-0421",
          "943-0842",
          "942-0082",
          "942-0055",
          "942-0056",
          "943-0877",
          "942-0081",
          "942-0085",
          "942-0084",
          "943-0895",
          "942-0243",
          "942-0246",
          "943-0141",
          "943-0148",
          "943-0826",
          "942-0072",
          "943-0827",
          "943-0144",
          "942-0031",
          "942-0054",
          "942-0053",
          "949-1714",
          "943-0221",
          "943-0316",
          "943-0313",
          "943-0317",
          "943-0314",
          "942-0275",
          "943-0305",
          "942-0267",
          "942-0273",
          "943-0231",
          "943-0224",
          "942-0265",
          "943-0301",
          "943-0235",
          "943-0304",
          "942-0266",
          "942-0276",
          "943-0311",
          "943-0307",
          "943-0312",
          "943-0222",
          "942-0274",
          "943-0306",
          "943-0228",
          "942-0262",
          "942-0261",
          "943-0223",
          "942-0264",
          "943-0236",
          "942-0271",
          "943-0225",
          "943-0302",
          "943-0227",
          "943-0226",
          "942-0277",
          "943-0234",
          "942-0268",
          "943-0233",
          "943-0232",
          "943-0315",
          "943-0318",
          "942-0272",
          "943-0303",
          "942-0263",
          "943-0849",
          "942-0064",
          "943-0155",
          "943-0865",
          "943-0875",
          "943-0853",
          "943-0854",
          "943-0852",
          "942-0022",
          "943-0119",
          "943-0167",
          "943-0134",
          "942-0051",
          "942-0255",
          "943-0813",
          "943-0843",
          "943-0142",
          "943-0426",
          "949-1721",
          "942-0247",
          "943-0125",
          "943-0899",
          "942-0253",
          "943-0111",
          "943-0851",
          "943-0878",
          "942-0034",
          "942-0063",
          "942-0231",
          "943-0135",
          "943-0416",
          "943-0124",
          "943-0891",
          "943-0804",
          "943-0147",
          "943-0122",
          "943-0822",
          "943-0102",
          "943-0829",
          "942-0002",
          "943-0107",
          "949-1726",
          "943-0810",
          "942-0083",
          "943-0802",
          "943-0172",
          "943-0175",
          "942-0012",
          "949-1716",
          "943-0845",
          "943-0423",
          "943-0182",
          "943-0897",
          "942-0234",
          "943-0132",
          "949-1703",
          "949-1706",
          "942-0001",
          "943-0137",
          "943-0898",
          "943-0821",
          "943-0115",
          "943-0104",
          "943-0166",
          "943-0892",
          "943-0859",
          "942-0046",
          "943-0866",
          "942-0071",
          "949-1735",
          "943-0178",
          "943-0176",
          "943-0173",
          "943-0146",
          "942-0245",
          "942-0244",
          "943-0185",
          "949-1715",
          "949-2301",
          "949-2317",
          "949-2315",
          "949-2316",
          "949-2318",
          "949-2322",
          "949-2312",
          "949-2303",
          "949-2304",
          "949-2306",
          "949-2313",
          "949-2321",
          "949-2302",
          "949-2311",
          "949-2314",
          "949-2305",
          "943-0812",
          "943-0174",
          "943-0882",
          "943-0883",
          "943-0164",
          "949-1742",
          "943-0857",
          "949-1701",
          "943-0831",
          "942-0037",
          "943-0801",
          "943-0819",
          "949-1604",
          "949-1616",
          "949-1605",
          "949-1622",
          "949-1614",
          "949-1621",
          "949-1618",
          "949-1607",
          "949-1611",
          "949-1625",
          "949-1608",
          "949-1606",
          "949-1609",
          "949-1603",
          "949-1615",
          "949-1602",
          "949-1601",
          "949-1613",
          "949-1624",
          "949-1623",
          "949-1626",
          "949-1619",
          "949-1612",
          "949-1617",
          "949-1704",
          "943-0152",
          "942-0026",
          "943-0834",
          "943-0873",
          "949-1711",
          "949-1725",
          "942-0004",
          "943-0136",
          "949-1737",
          "949-1722",
          "949-1727",
          "949-1731",
          "943-0116",
          "943-0887",
          "949-1713",
          "943-0118",
          "943-0133",
          "943-0415",
          "943-0836",
          "942-0036",
          "943-0105",
          "943-0825",
          "949-1732",
          "942-0088",
          "942-0014",
          "943-0163",
          "942-0232",
          "942-0032",
          "942-0033",
          "943-0816",
          "943-0121",
          "943-0171",
          "943-0817",
          "943-0151",
          "943-0123",
          "943-0832",
          "943-0184",
          "943-0642",
          "943-0645",
          "943-0617",
          "943-0615",
          "943-0635",
          "943-0623",
          "943-0606",
          "943-0648",
          "943-0646",
          "943-0616",
          "943-0611",
          "943-0632",
          "943-0625",
          "943-0605",
          "943-0607",
          "943-0626",
          "943-0636",
          "943-0637",
          "943-0633",
          "943-0631",
          "943-0614",
          "943-0603",
          "943-0621",
          "943-0613",
          "943-0634",
          "943-0628",
          "943-0622",
          "943-0601",
          "943-0604",
          "943-0627",
          "943-0641",
          "943-0602",
          "943-0624",
          "943-0644",
          "943-0647",
          "943-0643",
          "943-0612",
          "949-1734",
          "942-0062",
          "943-0844",
          "942-0043",
          "942-0044",
          "942-0042",
          "949-1738",
          "942-0011",
          "943-0413",
          "943-0837",
          "943-0108",
          "943-0847",
          "943-0846",
          "943-0162",
          "943-0841",
          "943-0808",
          "943-0411",
          "943-0888",
          "943-0181",
          "942-0087",
          "943-0835",
          "943-0138",
          "943-0427",
          "943-0417",
          "943-0177",
          "942-0041",
          "942-0404",
          "942-0413",
          "942-0539",
          "942-0522",
          "942-0405",
          "942-0533",
          "942-0542",
          "942-0541",
          "942-0536",
          "942-0532",
          "942-0543",
          "942-0534",
          "942-0524",
          "942-0414",
          "942-0538",
          "942-0531",
          "942-0523",
          "942-0537",
          "942-0402",
          "942-0544",
          "942-0401",
          "942-0403",
          "942-0412",
          "942-0415",
          "942-0535",
          "942-0411",
          "942-0521",
          "942-0525",
          "942-0027",
          "943-0131",
          "943-0861",
          "943-0815",
          "942-0024",
          "942-0045",
          "949-1739",
          "949-1705",
          "943-0114",
          "949-3408",
          "949-3554",
          "949-3409",
          "949-3412",
          "949-3421",
          "949-3564",
          "949-3563",
          "949-3552",
          "949-3442",
          "949-3402",
          "949-3437",
          "949-3418",
          "949-3555",
          "949-3411",
          "949-3553",
          "949-3438",
          "949-3427",
          "949-3429",
          "949-3422",
          "949-3401",
          "949-3565",
          "949-3443",
          "949-3428",
          "949-3406",
          "949-3407",
          "949-3435",
          "949-3417",
          "949-3441",
          "949-3444",
          "949-3557",
          "949-3447",
          "949-3431",
          "949-3551",
          "949-3436",
          "949-3414",
          "949-3404",
          "949-3449",
          "949-3426",
          "949-3413",
          "949-3425",
          "949-3439",
          "949-3448",
          "949-3416",
          "949-3556",
          "949-3434",
          "949-3445",
          "949-3423",
          "949-3419",
          "949-3403",
          "949-3424",
          "949-3433",
          "949-3446",
          "949-3415",
          "949-3561",
          "949-3562",
          "949-3405",
          "949-3432",
          "943-0201",
          "943-0103",
          "943-0202",
          "943-0863",
          "959-2000",
          "959-1955",
          "959-2061",
          "959-2003",
          "959-2122",
          "959-1902",
          "959-1959",
          "959-2062",
          "959-2035",
          "959-1927",
          "959-2123",
          "959-1974",
          "959-1968",
          "959-1930",
          "959-1935",
          "959-2043",
          "959-2025",
          "959-1964",
          "959-1975",
          "959-2001",
          "959-1977",
          "959-2121",
          "959-1946",
          "959-1921",
          "959-1914",
          "959-1938",
          "959-2206",
          "959-2202",
          "959-2147",
          "959-2148",
          "959-2032",
          "959-1923",
          "959-2044",
          "959-1944",
          "959-2031",
          "959-2105",
          "959-2103",
          "959-1915",
          "959-2081",
          "959-1908",
          "959-2116",
          "959-1933",
          "959-1942",
          "959-1962",
          "959-1909",
          "959-1973",
          "959-2047",
          "959-2048",
          "959-1904",
          "959-2073",
          "959-1932",
          "959-1945",
          "959-1978",
          "959-1949",
          "959-2143",
          "959-2014",
          "959-2015",
          "959-2125",
          "959-2136",
          "959-2082",
          "959-2214",
          "959-2212",
          "959-2126",
          "959-2083",
          "959-1907",
          "959-2002",
          "959-2026",
          "959-2222",
          "959-2134",
          "959-1916",
          "959-2065",
          "959-2146",
          "959-2054",
          "959-2213",
          "959-2101",
          "959-2102",
          "959-2053",
          "959-2042",
          "959-2135",
          "959-1918",
          "959-2045",
          "959-1913",
          "959-2211",
          "959-2205",
          "959-2145",
          "959-2051",
          "959-2225",
          "959-1965",
          "959-1912",
          "959-2117",
          "959-2124",
          "959-1951",
          "959-1952",
          "959-1936",
          "959-2114",
          "959-2046",
          "959-1943",
          "959-1925",
          "959-2086",
          "959-2217",
          "959-2013",
          "959-1956",
          "959-2144",
          "959-2133",
          "959-2224",
          "959-2112",
          "959-1929",
          "959-1971",
          "959-1905",
          "959-2052",
          "959-2115",
          "959-2021",
          "959-2011",
          "959-1966",
          "959-2131",
          "959-1917",
          "959-1926",
          "959-2012",
          "959-2022",
          "959-2063",
          "959-1911",
          "959-2066",
          "959-2024",
          "959-1901",
          "959-1934",
          "959-2141",
          "959-2072",
          "959-2223",
          "959-2111",
          "959-2226",
          "959-1958",
          "959-1941",
          "959-2142",
          "959-1924",
          "959-2201",
          "959-2041",
          "959-2075",
          "959-2023",
          "959-2107",
          "959-2049",
          "959-1937",
          "959-2064",
          "959-2204",
          "959-1903",
          "959-1976",
          "959-2074",
          "959-2106",
          "959-2104",
          "959-1953",
          "959-2055",
          "959-1967",
          "959-1954",
          "959-2132",
          "959-2056",
          "959-2203",
          "959-2071",
          "959-2006",
          "959-2113",
          "959-2034",
          "959-2004",
          "959-1963",
          "959-1948",
          "959-1947",
          "959-2130",
          "959-1910",
          "959-1906",
          "959-1928",
          "959-2037",
          "959-2033",
          "959-2221",
          "959-2057",
          "959-2007",
          "959-2005",
          "959-1961",
          "959-1972",
          "959-1919",
          "959-1931",
          "959-2227",
          "959-2085",
          "959-1922",
          "959-1957",
          "959-2215",
          "959-2036",
          "959-2216",
          "952-0000",
          "952-1537",
          "952-1538",
          "952-1574",
          "952-1517",
          "952-1512",
          "952-1566",
          "952-1557",
          "952-1552",
          "952-1556",
          "952-1565",
          "952-1547",
          "952-1646",
          "952-1534",
          "952-1508",
          "952-1573",
          "952-1584",
          "952-1581",
          "952-1571",
          "952-1575",
          "952-1582",
          "952-1583",
          "952-1522",
          "952-1507",
          "952-1539",
          "952-1533",
          "952-1553",
          "952-1514",
          "952-1518",
          "952-1511",
          "952-1505",
          "952-1527",
          "952-1563",
          "952-1561",
          "952-1562",
          "952-1542",
          "952-1503",
          "952-1536",
          "952-1551",
          "952-1504",
          "952-1523",
          "952-1541",
          "952-1515",
          "952-1568",
          "952-1506",
          "952-1525",
          "952-1524",
          "952-1535",
          "952-1543",
          "952-1526",
          "952-1513",
          "952-1516",
          "952-1558",
          "952-1554",
          "952-1555",
          "952-1548",
          "952-1572",
          "952-1531",
          "952-1502",
          "952-1544",
          "952-1546",
          "952-1545",
          "952-1532",
          "952-1521",
          "952-1564",
          "952-1567",
          "952-1528",
          "952-1326",
          "952-3421",
          "952-0852",
          "952-0711",
          "952-0021",
          "952-0022",
          "952-0303",
          "952-0851",
          "952-1201",
          "952-0213",
          "952-2202",
          "952-2224",
          "952-1322",
          "952-2211",
          "952-1212",
          "952-1302",
          "952-0626",
          "952-1643",
          "952-0614",
          "952-0857",
          "952-2201",
          "952-2223",
          "952-3113",
          "952-3117",
          "952-0005",
          "952-3114",
          "952-0622",
          "952-0214",
          "952-2205",
          "952-0432",
          "952-0315",
          "952-0716",
          "952-0822",
          "952-2136",
          "952-0605",
          "952-0611",
          "952-0603",
          "952-0613",
          "952-0601",
          "952-0625",
          "952-0604",
          "952-0205",
          "952-2212",
          "952-1207",
          "952-0855",
          "952-1323",
          "952-0006",
          "952-3542",
          "952-0023",
          "952-1208",
          "952-0307",
          "952-0702",
          "952-1305",
          "952-0108",
          "952-1303",
          "952-0024",
          "952-0028",
          "952-3425",
          "952-1315",
          "952-1314",
          "952-0002",
          "952-3202",
          "952-2133",
          "952-2225",
          "952-2222",
          "952-3207",
          "952-2221",
          "952-2213",
          "952-3116",
          "952-3423",
          "952-1325",
          "952-0202",
          "952-3112",
          "952-0304",
          "952-2206",
          "952-0606",
          "952-0624",
          "952-0602",
          "952-0215",
          "952-0621",
          "952-1432",
          "952-1433",
          "952-1431",
          "952-1435",
          "952-1434",
          "952-0216",
          "952-1204",
          "952-3432",
          "952-0321",
          "952-1501",
          "952-0701",
          "952-3424",
          "952-0322",
          "952-1304",
          "952-0114",
          "952-0025",
          "952-0612",
          "952-3422",
          "952-0001",
          "952-1301",
          "952-3541",
          "952-0715",
          "952-0015",
          "952-2203",
          "952-0316",
          "952-0431",
          "952-2214",
          "952-0433",
          "952-0314",
          "952-0302",
          "952-1645",
          "952-1644",
          "952-2135",
          "952-0853",
          "952-0026",
          "952-0623",
          "952-3119",
          "952-1209",
          "952-3543",
          "952-0003",
          "952-0435",
          "952-0207",
          "952-0706",
          "952-2132",
          "952-2131",
          "952-0703",
          "952-0854",
          "952-0317",
          "952-0305",
          "952-0027",
          "952-1211",
          "952-1306",
          "952-1324",
          "952-0311",
          "952-0116",
          "952-0102",
          "952-0107",
          "952-0106",
          "952-0109",
          "952-0103",
          "952-0115",
          "952-0105",
          "952-0111",
          "952-0104",
          "952-0101",
          "952-0112",
          "952-0113",
          "952-1308",
          "952-0434",
          "952-2215",
          "952-3203",
          "952-3544",
          "952-0204",
          "952-0206",
          "952-3434",
          "952-0823",
          "952-0007",
          "952-0503",
          "952-0511",
          "952-0502",
          "952-0512",
          "952-0515",
          "952-0422",
          "952-0421",
          "952-0514",
          "952-0505",
          "952-0501",
          "952-0504",
          "952-0513",
          "952-0004",
          "952-0016",
          "952-0856",
          "952-1307",
          "952-3545",
          "952-3546",
          "952-2134",
          "952-1213",
          "952-3115",
          "952-0615",
          "952-0211",
          "952-1641",
          "952-0203",
          "952-0712",
          "952-3431",
          "952-3201",
          "952-0821",
          "952-0313",
          "952-0301",
          "952-0318",
          "952-0824",
          "952-0705",
          "952-3206",
          "952-1205",
          "952-2226",
          "952-0714",
          "952-0212",
          "952-3111",
          "952-0704",
          "952-0201",
          "952-3204",
          "952-3433",
          "952-2204",
          "952-0713",
          "952-1311",
          "952-1312",
          "952-1313",
          "952-1321",
          "952-1206",
          "952-1203",
          "952-1202",
          "952-0312",
          "952-0306",
          "952-1642",
          "952-0011",
          "952-0012",
          "952-0013",
          "952-0014",
          "952-3435",
          "952-3118",
          "952-3205",
          "946-0000",
          "946-0043",
          "946-0224",
          "946-0304",
          "946-0064",
          "946-0114",
          "946-0038",
          "946-0032",
          "946-0002",
          "946-0076",
          "946-0051",
          "946-0302",
          "949-7423",
          "946-0084",
          "946-0012",
          "946-0052",
          "949-7411",
          "946-0124",
          "946-0033",
          "946-0034",
          "946-0226",
          "946-0223",
          "946-0073",
          "946-0303",
          "946-0004",
          "946-0305",
          "946-0215",
          "946-0088",
          "946-0036",
          "946-0101",
          "946-0108",
          "946-0086",
          "946-0105",
          "946-0087",
          "946-0211",
          "946-0022",
          "946-0107",
          "946-0104",
          "946-0011",
          "946-0125",
          "946-0025",
          "946-0121",
          "946-0021",
          "949-7401",
          "946-0203",
          "946-0085",
          "949-7416",
          "949-7417",
          "949-7405",
          "946-0061",
          "946-0221",
          "946-0216",
          "946-0003",
          "946-0102",
          "946-0201",
          "949-7415",
          "946-0103",
          "946-0301",
          "946-0112",
          "949-7402",
          "946-0106",
          "946-0063",
          "946-0065",
          "946-0035",
          "949-7418",
          "946-0057",
          "946-0058",
          "946-0212",
          "946-0006",
          "946-0024",
          "946-0053",
          "946-0071",
          "946-0072",
          "946-0111",
          "946-0204",
          "946-0206",
          "949-7403",
          "949-7422",
          "946-0031",
          "946-0113",
          "946-0202",
          "946-0062",
          "946-0023",
          "946-0306",
          "946-0001",
          "946-0222",
          "946-0207",
          "946-0213",
          "949-7413",
          "946-0041",
          "946-0214",
          "946-0123",
          "946-0066",
          "946-0083",
          "946-0225",
          "946-0205",
          "949-7424",
          "946-0081",
          "946-0037",
          "946-0042",
          "946-0115",
          "946-0055",
          "946-0056",
          "946-0082",
          "946-0005",
          "946-0307",
          "949-7412",
          "946-0075",
          "949-7421",
          "946-0122",
          "946-0007",
          "946-0054",
          "949-7404",
          "946-0109",
          "949-7414",
          "949-6600",
          "949-6605",
          "949-7141",
          "949-6746",
          "949-6751",
          "949-7245",
          "949-7246",
          "949-7256",
          "949-6434",
          "949-7235",
          "949-7234",
          "949-7228",
          "949-7227",
          "949-6372",
          "949-7114",
          "949-7115",
          "949-7318",
          "949-7317",
          "949-7319",
          "949-6554",
          "949-7101",
          "949-7313",
          "949-7254",
          "949-7222",
          "949-6765",
          "949-6607",
          "949-7142",
          "949-6551",
          "949-6425",
          "949-7302",
          "949-6373",
          "949-6542",
          "949-6544",
          "949-6416",
          "949-6438",
          "949-7243",
          "949-7224",
          "949-7251",
          "949-6412",
          "949-6361",
          "949-7103",
          "949-6682",
          "949-7122",
          "949-6745",
          "949-7102",
          "949-6403",
          "949-6602",
          "949-6404",
          "949-6552",
          "949-6431",
          "949-6432",
          "949-7126",
          "949-6411",
          "949-7137",
          "949-7138",
          "949-6364",
          "949-7124",
          "949-6603",
          "949-7143",
          "949-6601",
          "949-6366",
          "949-6756",
          "949-6757",
          "949-7233",
          "949-7242",
          "949-7241",
          "949-7301",
          "949-6413",
          "949-7248",
          "949-6636",
          "949-7312",
          "949-6415",
          "949-6556",
          "949-6428",
          "949-6611",
          "949-6541",
          "949-6408",
          "949-7145",
          "949-6407",
          "949-6553",
          "949-6741",
          "949-7127",
          "949-7113",
          "949-7116",
          "949-6363",
          "949-7125",
          "949-7314",
          "949-6371",
          "949-7311",
          "949-6418",
          "949-6433",
          "949-6557",
          "949-6555",
          "949-6405",
          "949-6406",
          "949-7134",
          "949-6771",
          "949-6766",
          "949-6773",
          "949-6744",
          "949-7104",
          "949-7232",
          "949-6422",
          "949-6401",
          "949-6436",
          "949-6761",
          "949-6762",
          "949-6427",
          "949-6421",
          "949-6545",
          "949-6437",
          "949-6754",
          "949-7112",
          "949-7117",
          "949-7315",
          "949-7136",
          "949-7135",
          "949-6615",
          "949-7131",
          "949-7144",
          "949-6742",
          "949-6414",
          "949-6543",
          "949-6755",
          "949-6612",
          "949-7316",
          "949-6753",
          "949-6774",
          "949-7132",
          "949-6743",
          "949-6772",
          "949-7244",
          "949-7111",
          "949-7133",
          "949-6423",
          "949-7229",
          "949-6426",
          "949-6424",
          "949-6608",
          "949-7252",
          "949-7253",
          "949-6362",
          "949-6775",
          "949-6365",
          "949-6764",
          "949-7123",
          "949-7231",
          "949-7236",
          "949-6680",
          "949-6435",
          "949-7223",
          "949-7247",
          "949-7121",
          "949-7225",
          "949-7226",
          "949-6763",
          "949-6609",
          "949-7221",
          "949-6681",
          "949-6402",
          "949-6417",
          "949-7255",
          "959-2600",
          "959-2661",
          "959-2659",
          "959-2823",
          "959-2609",
          "959-2626",
          "959-2657",
          "959-2605",
          "959-2622",
          "959-2801",
          "959-2604",
          "959-2644",
          "959-2665",
          "959-2813",
          "959-2612",
          "959-2631",
          "959-2676",
          "959-2724",
          "959-2647",
          "959-2802",
          "959-2602",
          "959-2652",
          "959-2663",
          "959-2653",
          "959-2827",
          "959-2807",
          "959-2814",
          "959-2811",
          "959-2705",
          "959-2721",
          "959-2812",
          "959-2674",
          "959-2634",
          "959-2803",
          "959-2825",
          "959-2701",
          "959-2706",
          "959-2804",
          "959-2669",
          "959-2664",
          "959-2806",
          "959-2816",
          "959-2809",
          "959-2677",
          "959-2707",
          "959-2805",
          "959-2607",
          "959-2619",
          "959-2632",
          "959-2666",
          "959-2642",
          "959-2603",
          "959-2817",
          "959-2648",
          "959-2633",
          "959-2618",
          "959-2662",
          "959-2617",
          "959-2715",
          "959-2703",
          "959-2722",
          "959-2712",
          "959-2713",
          "959-2616",
          "959-2635",
          "959-2826",
          "959-2821",
          "959-2808",
          "959-2608",
          "959-2673",
          "959-2716",
          "959-2629",
          "959-2637",
          "959-2708",
          "959-2822",
          "959-2621",
          "959-2623",
          "959-2667",
          "959-2646",
          "959-2658",
          "959-2651",
          "959-2656",
          "959-2627",
          "959-2624",
          "959-2606",
          "959-2672",
          "959-2625",
          "959-2671",
          "959-2643",
          "959-2614",
          "959-2613",
          "959-2702",
          "959-2628",
          "959-2675",
          "959-2636",
          "959-2714",
          "959-2655",
          "959-2654",
          "959-2645",
          "959-2638",
          "959-2723",
          "959-2704",
          "959-2824",
          "959-2709",
          "959-2815",
          "959-2601",
          "959-2668",
          "959-2611",
          "959-2615",
          "959-2641",
          "957-0100",
          "957-0103",
          "957-0102",
          "957-0113",
          "957-0104",
          "957-0122",
          "957-0105",
          "957-0117",
          "957-0121",
          "957-0126",
          "957-0112",
          "957-0123",
          "957-0106",
          "957-0124",
          "957-0101",
          "957-0127",
          "957-0125",
          "957-0111",
          "957-0114",
          "957-0115",
          "957-0116",
          "959-0300",
          "959-0311",
          "959-0301",
          "959-0308",
          "959-0304",
          "959-0321",
          "959-0307",
          "959-0319",
          "959-0317",
          "959-0302",
          "959-0312",
          "959-0322",
          "959-0306",
          "959-0303",
          "959-0318",
          "959-0315",
          "959-0309",
          "959-0310",
          "959-0316",
          "959-0305",
          "959-0323",
          "959-0314",
          "959-0313",
          "959-1500",
          "959-1521",
          "959-1513",
          "959-1514",
          "959-1522",
          "959-1525",
          "959-1502",
          "959-1512",
          "959-1503",
          "959-1523",
          "959-1501",
          "959-1524",
          "959-1511",
          "959-4400",
          "959-4408",
          "959-4621",
          "959-4626",
          "959-4603",
          "959-4606",
          "959-4614",
          "959-4632",
          "959-4636",
          "959-4627",
          "959-4405",
          "959-4410",
          "959-4612",
          "959-4525",
          "959-4302",
          "959-4617",
          "959-4534",
          "959-4535",
          "959-4533",
          "959-4618",
          "959-4409",
          "959-4501",
          "959-4634",
          "959-4406",
          "959-4413",
          "959-4623",
          "959-4502",
          "959-4608",
          "959-4522",
          "959-4521",
          "959-4523",
          "959-4622",
          "959-4512",
          "959-4513",
          "959-4416",
          "959-4402",
          "959-4601",
          "959-4401",
          "959-4635",
          "959-4411",
          "959-4503",
          "959-4505",
          "959-4504",
          "959-4304",
          "959-4631",
          "959-4633",
          "959-4611",
          "959-4514",
          "959-4515",
          "959-4407",
          "959-4418",
          "959-4412",
          "959-4441",
          "959-4511",
          "959-4303",
          "959-4539",
          "959-4531",
          "959-4538",
          "959-4403",
          "959-4404",
          "959-4537",
          "959-4536",
          "959-4532",
          "959-4414",
          "959-4602",
          "959-4605",
          "959-4524",
          "959-4526",
          "959-4301",
          "959-4417",
          "959-4624",
          "959-4415",
          "959-4604",
          "959-4625",
          "959-4506",
          "959-4507",
          "949-4300",
          "949-4325",
          "949-4308",
          "949-4306",
          "949-4335",
          "949-4331",
          "949-4302",
          "949-4346",
          "949-4323",
          "949-4312",
          "949-4332",
          "949-4311",
          "949-4315",
          "949-4309",
          "949-4326",
          "949-4318",
          "949-4341",
          "949-4353",
          "949-4303",
          "949-4301",
          "949-4322",
          "949-4344",
          "949-4342",
          "949-4351",
          "949-4333",
          "949-4307",
          "949-4352",
          "949-4316",
          "949-4343",
          "949-4337",
          "949-4334",
          "949-4345",
          "949-4304",
          "949-4305",
          "949-4314",
          "949-4336",
          "949-4327",
          "949-4313",
          "949-4321",
          "949-4328",
          "949-4317",
          "949-4324",
          "949-6100",
          "949-6102",
          "949-6103",
          "949-6212",
          "949-6211",
          "949-6101",
          "949-8200",
          "949-8203",
          "949-8313",
          "949-8314",
          "949-8202",
          "949-8317",
          "949-8122",
          "949-8121",
          "949-8205",
          "949-8123",
          "949-8124",
          "949-8126",
          "949-8125",
          "949-8315",
          "949-8316",
          "949-8127",
          "949-8207",
          "949-8201",
          "949-8206",
          "949-8311",
          "949-8312",
          "949-8204",
          "945-0300",
          "945-0325",
          "945-0323",
          "945-0321",
          "945-0314",
          "945-0311",
          "945-0301",
          "945-0313",
          "945-0315",
          "945-0307",
          "945-0324",
          "945-0322",
          "945-0305",
          "945-0316",
          "945-0317",
          "945-0303",
          "945-0302",
          "945-0304",
          "945-0306",
          "945-0312",
          "945-0308",
          "959-3200",
          "959-3235",
          "959-3222",
          "959-3245",
          "959-3213",
          "959-3214",
          "959-3216",
          "959-3257",
          "959-3272",
          "959-3275",
          "959-3223",
          "959-3256",
          "959-3254",
          "959-3236",
          "959-3241",
          "959-3234",
          "959-3226",
          "959-3251",
          "959-3228",
          "959-3237",
          "959-3231",
          "959-3205",
          "959-3264",
          "959-3246",
          "959-3224",
          "959-3233",
          "959-3243",
          "959-3211",
          "959-3262",
          "959-3221",
          "959-3265",
          "959-3242",
          "959-3204",
          "959-3273",
          "959-3232",
          "959-3263",
          "959-3252",
          "959-3258",
          "959-3271",
          "959-3208",
          "959-3206",
          "959-3225",
          "959-3215",
          "959-3253",
          "959-3201",
          "959-3255",
          "959-3259",
          "959-3274",
          "959-3203",
          "959-3202",
          "959-3227",
          "959-3244",
          "959-3261",
          "959-3212",
          "959-3207",
          "958-0061",
          "939-0000",
          "930-0075",
          "930-0845",
          "939-8162",
          "939-8163",
          "930-0855",
          "939-8064",
          "939-8065",
          "939-8252",
          "930-0953",
          "930-0954",
          "939-8182",
          "930-0847",
          "939-8066",
          "930-0931",
          "939-8091",
          "939-2161",
          "930-0094",
          "930-0091",
          "930-0982",
          "930-0984",
          "930-0983",
          "930-0028",
          "930-1321",
          "930-0822",
          "930-0823",
          "930-0863",
          "930-0862",
          "930-0861",
          "930-1458",
          "930-1457",
          "931-8314",
          "939-8177",
          "930-0881",
          "930-0821",
          "939-2185",
          "930-0158",
          "930-0966",
          "930-0043",
          "930-0892",
          "930-0891",
          "930-0893",
          "939-8193",
          "930-1271",
          "939-8121",
          "930-0042",
          "930-0077",
          "939-2211",
          "930-0061",
          "930-0904",
          "939-2231",
          "930-0849",
          "930-0012",
          "930-0010",
          "931-8321",
          "931-8328",
          "939-2187",
          "939-8075",
          "939-8281",
          "939-8282",
          "930-2221",
          "930-0021",
          "939-2162",
          "939-2182",
          "939-2246",
          "939-2247",
          "931-8374",
          "931-8372",
          "931-8346",
          "931-8376",
          "931-8365",
          "931-8362",
          "931-8356",
          "931-8341",
          "931-8352",
          "931-8354",
          "931-8371",
          "931-8343",
          "931-8351",
          "931-8344",
          "931-8342",
          "931-8377",
          "931-8375",
          "931-8378",
          "931-8347",
          "931-8363",
          "931-8355",
          "931-8366",
          "931-8361",
          "931-8357",
          "931-8353",
          "931-8373",
          "931-8367",
          "931-8364",
          "939-2213",
          "930-0856",
          "930-0858",
          "930-0859",
          "939-2171",
          "930-2237",
          "930-2238",
          "930-0093",
          "930-1284",
          "930-0055",
          "939-8195",
          "939-8197",
          "931-8327",
          "931-8326",
          "939-8196",
          "930-0853",
          "930-0067",
          "939-8155",
          "930-0914",
          "930-0915",
          "930-0913",
          "930-0027",
          "930-0116",
          "939-8145",
          "939-8058",
          "939-8052",
          "939-8097",
          "939-8001",
          "939-8051",
          "939-8095",
          "939-8093",
          "939-8094",
          "939-8087",
          "930-0922",
          "930-0927",
          "939-2251",
          "930-1327",
          "939-8025",
          "930-1275",
          "930-1274",
          "939-8048",
          "939-8042",
          "930-0063",
          "939-8043",
          "939-8041",
          "930-0015",
          "939-8044",
          "930-0107",
          "930-0084",
          "939-2207",
          "939-8103",
          "939-8073",
          "939-8074",
          "939-8035",
          "930-1311",
          "930-1264",
          "930-1466",
          "930-1322",
          "930-0846",
          "930-0852",
          "930-0857",
          "930-0851",
          "930-0819",
          "930-0818",
          "939-2202",
          "930-1286",
          "939-8243",
          "930-1265",
          "930-0037",
          "930-1328",
          "930-1456",
          "939-8092",
          "930-1276",
          "931-8405",
          "931-8407",
          "939-8137",
          "939-2189",
          "939-8215",
          "939-8212",
          "931-8404",
          "930-0086",
          "939-2224",
          "939-8077",
          "939-2186",
          "930-0926",
          "930-0873",
          "930-2206",
          "930-2204",
          "930-2205",
          "939-2188",
          "939-2245",
          "930-0837",
          "930-0816",
          "930-0827",
          "930-0825",
          "939-8144",
          "930-1333",
          "939-2252",
          "939-8166",
          "939-8175",
          "939-8151",
          "930-0826",
          "939-8061",
          "939-8138",
          "939-8134",
          "930-1312",
          "939-8143",
          "939-8071",
          "930-0835",
          "930-0836",
          "939-2256",
          "939-8056",
          "939-8062",
          "930-0057",
          "939-8225",
          "930-1459",
          "930-0175",
          "930-0176",
          "930-0164",
          "930-0023",
          "930-0103",
          "930-0104",
          "930-0105",
          "930-0172",
          "930-0806",
          "939-8264",
          "930-0951",
          "930-0956",
          "939-8152",
          "939-8047",
          "930-0906",
          "931-8451",
          "930-0865",
          "930-2201",
          "930-2207",
          "931-8442",
          "930-0842",
          "930-0843",
          "939-8002",
          "939-8178",
          "930-1268",
          "930-0121",
          "930-0133",
          "930-0134",
          "930-0131",
          "930-0122",
          "930-0125",
          "930-0123",
          "930-0135",
          "930-0102",
          "930-0126",
          "930-0132",
          "930-0137",
          "930-0138",
          "930-0127",
          "930-0124",
          "930-0136",
          "939-8214",
          "939-8213",
          "939-8216",
          "930-1336",
          "939-2235",
          "939-8082",
          "939-2174",
          "930-0809",
          "939-2201",
          "931-8411",
          "930-1273",
          "931-8417",
          "930-0022",
          "939-8063",
          "930-0882",
          "939-8183",
          "931-8435",
          "939-2232",
          "930-0895",
          "930-0052",
          "930-0887",
          "930-0883",
          "930-0884",
          "930-0905",
          "939-8263",
          "930-1464",
          "930-0153",
          "930-0925",
          "930-0032",
          "930-0156",
          "939-2206",
          "930-0082",
          "930-0898",
          "930-0004",
          "930-0003",
          "939-2223",
          "939-2222",
          "939-3548",
          "930-0064",
          "930-0155",
          "930-0059",
          "939-2242",
          "939-2214",
          "939-2226",
          "930-0089",
          "930-0097",
          "939-8223",
          "930-0035",
          "930-0036",
          "930-0034",
          "930-0838",
          "930-0813",
          "931-8443",
          "930-1335",
          "930-0817",
          "939-8231",
          "939-8174",
          "930-0807",
          "930-0802",
          "930-0808",
          "930-0803",
          "930-0804",
          "930-1272",
          "930-0871",
          "930-0872",
          "930-1305",
          "930-0814",
          "939-8055",
          "939-8112",
          "931-8325",
          "939-8111",
          "930-0867",
          "930-0854",
          "939-8114",
          "939-8115",
          "939-8113",
          "939-8102",
          "930-0048",
          "930-0924",
          "930-0024",
          "930-0005",
          "930-0997",
          "930-0991",
          "930-0994",
          "930-0995",
          "930-0996",
          "930-0992",
          "930-0006",
          "930-0993",
          "930-2203",
          "939-2241",
          "930-0008",
          "930-0009",
          "930-0002",
          "939-8205",
          "930-0839",
          "939-8253",
          "939-8054",
          "939-8122",
          "939-8034",
          "939-8165",
          "930-0152",
          "939-2215",
          "930-0045",
          "930-1266",
          "930-1267",
          "931-8454",
          "930-0144",
          "930-0031",
          "930-0088",
          "939-2234",
          "931-8409",
          "939-8123",
          "930-1285",
          "930-0066",
          "930-1303",
          "930-0815",
          "939-8135",
          "930-0083",
          "939-8241",
          "930-0971",
          "939-2254",
          "930-0106",
          "931-8441",
          "931-8315",
          "930-0866",
          "931-8336",
          "939-8012",
          "939-8013",
          "939-8036",
          "930-0007",
          "930-0897",
          "930-0894",
          "930-0014",
          "939-8172",
          "939-8173",
          "930-0053",
          "930-0985",
          "930-2224",
          "931-8403",
          "930-1331",
          "930-1338",
          "930-1337",
          "931-8401",
          "931-8402",
          "939-8157",
          "939-8156",
          "930-0901",
          "939-8076",
          "939-8271",
          "939-8272",
          "930-0018",
          "931-8334",
          "930-0114",
          "930-0115",
          "930-0044",
          "930-0921",
          "930-0811",
          "939-8262",
          "939-8139",
          "939-8141",
          "939-8142",
          "939-8132",
          "939-8133",
          "939-8136",
          "939-2238",
          "930-0046",
          "930-2239",
          "930-0824",
          "930-1332",
          "930-2225",
          "939-2165",
          "930-0874",
          "930-0875",
          "930-0955",
          "939-2236",
          "930-0078",
          "930-0834",
          "931-8445",
          "939-8233",
          "930-0047",
          "930-0163",
          "930-2227",
          "930-2202",
          "930-0928",
          "939-8224",
          "931-8316",
          "930-0049",
          "931-8322",
          "931-8323",
          "931-8324",
          "931-8311",
          "931-8312",
          "931-8313",
          "931-8305",
          "931-8456",
          "939-8005",
          "930-0974",
          "930-0972",
          "930-0973",
          "930-0962",
          "930-0076",
          "930-0166",
          "930-1334",
          "939-2243",
          "930-0111",
          "930-0113",
          "930-0101",
          "939-8015",
          "939-8014",
          "939-8016",
          "930-0801",
          "939-2225",
          "931-8453",
          "930-1313",
          "930-1462",
          "939-2255",
          "939-8146",
          "930-0903",
          "939-8085",
          "930-1315",
          "930-1316",
          "930-0832",
          "930-0830",
          "939-8131",
          "939-8032",
          "931-8408",
          "930-0831",
          "939-8232",
          "939-2233",
          "930-0068",
          "939-8251",
          "939-8096",
          "939-2221",
          "930-0165",
          "930-1324",
          "930-0143",
          "939-8004",
          "939-8003",
          "939-2181",
          "930-0073",
          "939-2244",
          "930-0981",
          "930-0062",
          "939-8203",
          "939-8202",
          "930-0975",
          "930-0961",
          "939-8083",
          "939-8084",
          "939-8101",
          "939-8104",
          "931-8335",
          "930-0177",
          "931-8345",
          "939-8222",
          "939-2184",
          "939-8191",
          "939-8192",
          "939-2163",
          "939-8207",
          "939-8206",
          "939-8208",
          "930-2233",
          "930-2236",
          "930-2235",
          "930-2231",
          "930-2234",
          "930-2232",
          "939-8204",
          "939-2237",
          "930-0173",
          "931-8413",
          "931-8422",
          "931-8428",
          "930-0171",
          "930-0174",
          "939-8261",
          "931-8333",
          "930-0069",
          "930-0896",
          "939-8124",
          "930-0026",
          "930-0112",
          "930-2226",
          "930-1326",
          "939-8201",
          "930-0162",
          "930-0864",
          "931-8414",
          "939-8164",
          "930-1454",
          "930-1453",
          "931-8433",
          "931-8432",
          "931-8415",
          "931-8431",
          "931-8455",
          "930-1283",
          "930-0964",
          "939-2175",
          "931-8358",
          "931-8359",
          "930-0161",
          "939-2209",
          "930-1323",
          "931-8444",
          "930-1262",
          "930-1263",
          "930-0017",
          "931-8452",
          "939-8086",
          "939-8031",
          "930-1281",
          "930-1261",
          "930-1287",
          "930-0039",
          "931-8416",
          "930-0848",
          "930-0025",
          "930-0912",
          "930-2214",
          "930-0885",
          "930-0886",
          "931-8421",
          "930-0154",
          "930-0944",
          "930-0157",
          "930-0071",
          "939-8242",
          "930-0833",
          "939-2173",
          "930-0965",
          "930-0963",
          "939-8011",
          "930-0943",
          "930-0936",
          "930-0933",
          "930-0932",
          "930-0942",
          "930-0934",
          "930-0941",
          "930-0935",
          "939-8211",
          "939-8185",
          "939-8184",
          "939-2205",
          "939-2731",
          "939-2607",
          "939-2734",
          "939-2721",
          "939-2711",
          "939-2634",
          "939-2627",
          "939-2635",
          "939-2616",
          "939-2611",
          "939-2736",
          "939-2614",
          "939-2713",
          "939-2625",
          "939-2717",
          "939-2612",
          "939-2605",
          "939-2703",
          "939-2758",
          "939-2752",
          "939-2601",
          "939-2604",
          "939-2753",
          "939-2622",
          "939-2744",
          "939-2617",
          "939-2708",
          "939-2743",
          "939-2756",
          "939-2716",
          "939-2715",
          "939-2624",
          "939-2602",
          "939-2737",
          "939-2727",
          "939-2726",
          "939-2722",
          "939-2632",
          "939-2639",
          "939-2631",
          "939-2613",
          "939-2702",
          "939-2735",
          "939-2748",
          "939-2712",
          "939-2738",
          "939-2626",
          "939-2757",
          "939-2621",
          "939-2759",
          "939-2606",
          "939-2747",
          "939-2741",
          "939-2733",
          "939-2719",
          "939-2701",
          "939-2724",
          "939-2723",
          "939-2603",
          "939-2704",
          "939-2746",
          "939-2706",
          "939-2633",
          "939-2707",
          "939-2636",
          "939-2729",
          "939-2745",
          "939-2755",
          "939-2718",
          "939-2638",
          "939-2728",
          "939-2742",
          "939-2714",
          "939-2637",
          "939-2705",
          "939-2754",
          "939-2725",
          "939-2751",
          "939-2615",
          "939-2709",
          "939-2649",
          "939-2749",
          "939-2732",
          "939-2623",
          "939-2212",
          "939-2176",
          "930-0098",
          "930-0096",
          "930-0095",
          "930-0058",
          "930-2208",
          "930-0151",
          "939-8023",
          "939-8024",
          "930-0876",
          "939-8254",
          "930-0065",
          "939-8057",
          "939-8081",
          "939-8053",
          "939-8049",
          "939-8072",
          "930-0074",
          "930-1455",
          "930-1451",
          "930-1452",
          "930-0108",
          "930-0911",
          "939-8046",
          "939-8045",
          "930-0029",
          "930-0081",
          "930-1465",
          "939-8161",
          "930-1282",
          "930-1301",
          "930-1302",
          "930-0923",
          "939-2164",
          "931-8423",
          "930-0952",
          "931-8406",
          "939-8017",
          "939-2203",
          "930-2213",
          "930-2212",
          "930-0812",
          "930-0085",
          "939-2204",
          "931-8434",
          "931-8301",
          "939-0511",
          "930-1463",
          "939-3516",
          "939-3523",
          "939-3531",
          "939-0551",
          "939-0561",
          "939-3524",
          "939-0545",
          "939-0531",
          "939-0532",
          "939-3555",
          "939-0514",
          "939-3504",
          "939-3544",
          "939-3501",
          "939-3525",
          "939-0506",
          "939-3512",
          "939-3541",
          "939-3552",
          "939-3542",
          "939-0535",
          "939-0541",
          "939-0542",
          "939-3534",
          "939-3536",
          "939-0565",
          "939-0546",
          "939-0544",
          "939-3553",
          "939-3502",
          "939-0567",
          "939-0534",
          "939-0547",
          "939-0552",
          "939-0553",
          "939-0533",
          "939-0543",
          "939-0563",
          "939-3506",
          "939-0521",
          "939-3547",
          "939-0564",
          "939-3543",
          "939-3554",
          "939-0558",
          "939-3526",
          "939-0527",
          "939-0525",
          "939-3514",
          "939-3557",
          "939-3535",
          "939-0515",
          "939-0554",
          "939-0557",
          "939-3513",
          "939-0555",
          "939-3533",
          "939-0526",
          "939-3503",
          "939-0562",
          "939-0504",
          "939-0502",
          "939-3515",
          "939-3556",
          "939-0513",
          "939-0566",
          "939-3511",
          "939-3551",
          "939-0522",
          "939-0523",
          "939-0503",
          "939-0507",
          "939-0508",
          "939-3545",
          "939-3521",
          "939-3522",
          "939-3505",
          "939-0524",
          "939-0512",
          "939-0505",
          "939-0501",
          "939-0568",
          "939-3546",
          "939-3532",
          "939-0556",
          "939-0509",
          "939-0528",
          "939-0536",
          "930-0038",
          "930-0805",
          "930-1304",
          "939-8194",
          "939-8176",
          "930-0054",
          "930-0056",
          "939-8234",
          "939-2208",
          "939-2257",
          "930-1314",
          "930-2211",
          "931-8427",
          "931-8436",
          "931-8425",
          "930-0902",
          "931-8426",
          "939-8171",
          "931-8437",
          "930-0916",
          "930-0041",
          "930-0051",
          "930-0001",
          "930-0033",
          "930-0072",
          "931-8332",
          "931-8331",
          "939-8154",
          "931-8337",
          "930-1325",
          "939-2253",
          "930-0092",
          "930-0087",
          "939-2405",
          "939-2413",
          "939-2475",
          "939-2401",
          "939-2466",
          "939-2423",
          "939-2425",
          "939-2315",
          "939-2306",
          "939-2305",
          "939-2353",
          "939-2445",
          "939-2326",
          "939-2404",
          "939-2473",
          "939-2312",
          "939-2436",
          "939-2337",
          "939-2477",
          "939-2467",
          "939-2441",
          "939-2303",
          "939-2455",
          "939-2465",
          "939-2362",
          "939-2454",
          "939-2341",
          "939-2336",
          "939-2332",
          "939-2327",
          "939-2415",
          "939-2374",
          "939-2334",
          "939-2342",
          "939-2402",
          "939-2444",
          "939-2435",
          "939-2417",
          "939-2324",
          "939-2333",
          "939-2426",
          "939-2453",
          "939-2431",
          "939-2304",
          "939-2373",
          "939-2321",
          "939-2322",
          "939-2471",
          "939-2301",
          "939-2352",
          "939-2474",
          "939-2462",
          "939-2434",
          "939-2331",
          "939-2442",
          "939-2407",
          "939-2433",
          "939-2314",
          "939-2363",
          "939-2302",
          "939-2432",
          "939-2343",
          "939-2375",
          "939-2446",
          "939-2325",
          "939-2461",
          "939-2437",
          "939-2406",
          "939-2464",
          "939-2372",
          "939-2371",
          "939-2416",
          "939-2421",
          "939-2351",
          "939-2403",
          "939-2463",
          "939-2311",
          "939-2443",
          "939-2422",
          "939-2345",
          "939-2355",
          "939-2472",
          "939-2411",
          "939-2344",
          "939-2412",
          "939-2424",
          "939-2354",
          "939-2414",
          "939-2451",
          "939-2367",
          "939-2316",
          "939-2376",
          "939-2476",
          "939-2456",
          "939-2317",
          "939-2364",
          "939-2361",
          "939-2452",
          "939-2335",
          "939-2365",
          "939-2323",
          "939-2313",
          "939-2366",
          "939-2447",
          "930-0016",
          "930-2222",
          "930-2223",
          "930-2215",
          "930-2117",
          "930-2114",
          "930-2125",
          "930-2111",
          "930-2106",
          "930-2123",
          "930-2122",
          "930-2115",
          "930-2116",
          "930-2126",
          "930-2121",
          "930-2102",
          "930-2104",
          "930-2103",
          "930-2113",
          "930-2101",
          "930-2108",
          "930-2107",
          "930-2124",
          "930-2128",
          "930-2127",
          "930-2105",
          "930-2112",
          "939-8006",
          "939-8022",
          "939-8026",
          "939-8007",
          "939-8008",
          "930-0019",
          "939-8221",
          "930-2243",
          "930-2255",
          "930-2245",
          "930-2258",
          "930-2242",
          "930-2246",
          "930-2247",
          "930-2254",
          "930-2253",
          "930-2244",
          "930-2241",
          "930-2252",
          "930-2257",
          "930-2251",
          "930-2256",
          "930-2248",
          "939-8033",
          "931-8412",
          "939-2216",
          "939-8153",
          "939-8244",
          "930-0142",
          "930-0141",
          "939-2172",
          "930-0841",
          "931-8303",
          "931-8306",
          "931-8304",
          "931-8302",
          "939-8181",
          "939-8021",
          "930-1461",
          "939-2183",
          "933-0000",
          "939-1110",
          "933-0061",
          "933-0805",
          "933-0806",
          "933-0015",
          "933-0905",
          "933-0072",
          "939-1273",
          "933-0353",
          "933-0877",
          "933-0833",
          "933-0319",
          "933-0911",
          "933-0306",
          "933-0973",
          "933-0972",
          "933-0971",
          "933-0807",
          "933-0318",
          "933-0011",
          "933-0836",
          "933-0355",
          "934-0095",
          "933-0827",
          "933-0858",
          "933-0855",
          "933-0923",
          "939-1267",
          "939-1266",
          "933-0335",
          "933-0974",
          "933-0328",
          "933-0843",
          "933-0871",
          "933-0062",
          "933-0065",
          "933-0305",
          "933-0846",
          "933-0133",
          "933-0135",
          "933-0134",
          "933-0132",
          "933-0131",
          "933-0137",
          "933-0138",
          "933-0918",
          "933-0039",
          "933-0016",
          "933-0916",
          "933-0867",
          "933-0073",
          "933-0074",
          "933-0078",
          "933-0332",
          "933-0029",
          "939-1119",
          "933-0926",
          "933-0909",
          "933-0066",
          "933-0027",
          "933-0025",
          "933-0026",
          "934-0096",
          "933-0945",
          "933-0841",
          "933-0856",
          "939-1274",
          "933-0336",
          "933-0837",
          "933-0853",
          "933-0851",
          "933-0963",
          "933-0814",
          "934-0098",
          "933-0948",
          "933-0341",
          "933-0932",
          "933-0943",
          "933-0942",
          "933-0875",
          "933-0876",
          "933-0823",
          "933-0838",
          "933-0052",
          "933-0857",
          "933-0929",
          "933-0908",
          "933-0874",
          "933-0917",
          "933-0036",
          "933-0968",
          "933-0903",
          "933-0834",
          "939-1120",
          "933-0854",
          "933-0921",
          "939-1261",
          "933-0067",
          "933-0018",
          "933-0044",
          "933-0906",
          "939-1263",
          "933-0338",
          "933-0914",
          "933-0008",
          "933-0304",
          "933-0038",
          "933-0961",
          "933-0962",
          "933-0344",
          "933-0307",
          "933-0826",
          "933-0825",
          "939-1262",
          "933-0334",
          "933-0922",
          "933-0013",
          "933-0907",
          "933-0952",
          "933-0357",
          "933-0327",
          "933-0329",
          "933-0136",
          "933-0976",
          "933-0866",
          "939-1272",
          "939-1271",
          "933-0852",
          "933-0821",
          "933-0860",
          "933-0021",
          "933-0813",
          "934-0091",
          "939-1264",
          "933-0822",
          "933-0983",
          "933-0126",
          "933-0037",
          "933-0032",
          "933-0041",
          "933-0053",
          "933-0946",
          "933-0925",
          "933-0022",
          "933-0316",
          "933-0904",
          "933-0862",
          "933-0075",
          "933-0035",
          "933-0023",
          "933-0978",
          "933-0985",
          "933-0869",
          "933-0863",
          "933-0864",
          "933-0915",
          "933-0847",
          "933-0868",
          "933-0311",
          "933-0312",
          "939-1131",
          "933-0028",
          "933-0034",
          "933-0808",
          "933-0965",
          "933-0124",
          "933-0343",
          "933-0064",
          "939-1255",
          "939-1254",
          "933-0325",
          "933-0324",
          "933-0326",
          "933-0967",
          "933-0337",
          "933-0030",
          "933-0951",
          "933-0966",
          "933-0835",
          "939-1251",
          "939-1252",
          "933-0007",
          "933-0006",
          "933-0063",
          "933-0803",
          "933-0809",
          "933-0861",
          "939-1121",
          "939-1102",
          "939-1103",
          "939-1105",
          "939-1101",
          "939-1117",
          "939-1125",
          "939-1112",
          "939-1113",
          "939-1118",
          "939-1132",
          "939-1135",
          "939-1111",
          "939-1114",
          "939-1136",
          "939-1122",
          "939-1133",
          "939-1134",
          "939-1123",
          "939-1116",
          "939-1115",
          "939-1124",
          "939-1104",
          "933-0352",
          "933-0964",
          "933-0975",
          "933-0937",
          "933-0927",
          "933-0001",
          "933-0804",
          "933-0941",
          "933-0959",
          "933-0056",
          "933-0043",
          "933-0042",
          "933-0055",
          "933-0046",
          "933-0031",
          "933-0944",
          "934-0092",
          "939-1275",
          "933-0331",
          "933-0986",
          "933-0315",
          "933-0323",
          "933-0824",
          "933-0815",
          "933-0302",
          "933-0848",
          "933-0931",
          "933-0003",
          "933-0077",
          "933-0004",
          "933-0005",
          "933-0301",
          "933-0014",
          "933-0958",
          "933-0935",
          "933-0934",
          "933-0865",
          "933-0936",
          "933-0317",
          "933-0982",
          "933-0879",
          "933-0844",
          "933-0957",
          "933-0818",
          "933-0342",
          "933-0987",
          "933-0878",
          "933-0033",
          "933-0817",
          "933-0047",
          "933-0051",
          "939-1265",
          "933-0322",
          "934-0093",
          "933-0919",
          "933-0057",
          "933-0811",
          "933-0314",
          "939-0101",
          "939-0131",
          "939-0112",
          "939-0122",
          "939-0145",
          "939-0128",
          "939-0132",
          "939-0119",
          "939-0118",
          "939-0117",
          "939-0133",
          "939-0127",
          "939-0113",
          "939-0144",
          "939-0104",
          "939-0134",
          "939-0152",
          "939-0124",
          "939-0156",
          "939-0155",
          "939-0121",
          "939-0116",
          "939-0115",
          "939-0143",
          "939-0151",
          "939-0142",
          "939-0154",
          "939-0141",
          "939-0103",
          "939-0123",
          "939-0153",
          "939-0105",
          "939-0111",
          "939-0135",
          "939-0106",
          "939-0102",
          "939-0126",
          "939-0125",
          "933-0829",
          "933-0313",
          "933-0910",
          "933-0113",
          "933-0102",
          "933-0116",
          "933-0101",
          "933-0114",
          "933-0115",
          "933-0103",
          "933-0105",
          "933-0111",
          "933-0112",
          "933-0106",
          "933-0104",
          "933-0123",
          "933-0122",
          "933-0121",
          "933-0125",
          "933-0981",
          "933-0816",
          "933-0054",
          "933-0938",
          "933-0345",
          "933-0977",
          "934-0094",
          "933-0924",
          "933-0947",
          "933-0333",
          "933-0913",
          "933-0045",
          "933-0017",
          "934-0097",
          "933-0845",
          "933-0912",
          "933-0955",
          "933-0933",
          "933-0873",
          "933-0012",
          "933-0956",
          "933-0024",
          "933-0954",
          "933-0354",
          "933-0901",
          "933-0902",
          "933-0812",
          "933-0984",
          "933-0928",
          "933-0356",
          "933-0308",
          "933-0303",
          "933-0953",
          "933-0849",
          "933-0842",
          "933-0872",
          "933-0002",
          "933-0351",
          "933-0949",
          "933-0076",
          "933-0802",
          "933-0801",
          "933-0321",
          "939-1253",
          "933-0831",
          "934-0099",
          "933-0071",
          "933-0832",
          "933-0828",
          "933-0839",
          "937-0000",
          "937-0045",
          "937-0047",
          "937-0063",
          "937-0014",
          "937-0036",
          "937-0847",
          "937-0846",
          "937-0828",
          "937-0814",
          "937-0813",
          "937-0821",
          "937-0812",
          "937-0843",
          "937-0051",
          "937-0017",
          "937-0835",
          "937-0026",
          "937-0039",
          "937-0004",
          "937-0022",
          "937-0032",
          "937-0834",
          "937-0054",
          "937-0832",
          "937-0865",
          "937-0046",
          "937-0861",
          "937-0855",
          "937-0856",
          "937-0831",
          "937-0066",
          "937-0065",
          "937-0826",
          "937-0041",
          "937-0011",
          "937-0007",
          "937-0006",
          "937-0025",
          "937-0035",
          "937-0852",
          "937-0833",
          "937-0009",
          "937-0841",
          "937-0857",
          "937-0811",
          "937-0003",
          "937-0033",
          "937-0844",
          "937-0802",
          "937-0067",
          "937-0864",
          "937-0801",
          "937-0010",
          "937-0863",
          "937-0867",
          "937-0059",
          "937-0851",
          "937-0056",
          "937-0815",
          "937-0816",
          "937-0807",
          "937-0064",
          "937-0016",
          "937-0055",
          "937-0827",
          "937-0013",
          "937-0005",
          "937-0031",
          "937-0034",
          "937-0037",
          "937-0806",
          "937-0837",
          "937-0023",
          "937-0804",
          "937-0018",
          "937-0836",
          "937-0001",
          "937-0825",
          "937-0028",
          "937-0012",
          "937-0008",
          "937-0015",
          "937-0058",
          "937-0038",
          "937-0043",
          "937-0024",
          "937-0868",
          "937-0061",
          "937-0062",
          "937-0862",
          "937-0002",
          "937-0021",
          "937-0805",
          "937-0803",
          "937-0866",
          "937-0845",
          "937-0822",
          "937-0027",
          "937-0052",
          "937-0057",
          "937-0853",
          "937-0053",
          "937-0824",
          "937-0068",
          "937-0854",
          "937-0823",
          "937-0044",
          "937-0842",
          "937-0042",
          "935-0000",
          "935-0002",
          "935-0274",
          "935-0023",
          "935-0022",
          "935-0343",
          "935-0054",
          "935-0426",
          "935-0112",
          "935-0065",
          "935-0015",
          "935-0338",
          "935-0278",
          "935-0006",
          "935-0272",
          "935-0422",
          "935-0056",
          "935-0271",
          "935-0103",
          "935-0101",
          "935-0416",
          "935-0412",
          "935-0026",
          "935-0027",
          "935-0257",
          "935-0263",
          "935-0337",
          "935-0034",
          "935-0045",
          "935-0067",
          "935-0331",
          "935-0346",
          "935-0063",
          "935-0037",
          "935-0047",
          "935-0035",
          "935-0344",
          "935-0043",
          "935-0044",
          "935-0105",
          "935-0004",
          "935-0001",
          "935-0268",
          "935-0336",
          "935-0024",
          "935-0251",
          "935-0265",
          "935-0025",
          "935-0115",
          "935-0335",
          "935-0273",
          "935-0042",
          "935-0106",
          "935-0413",
          "935-0424",
          "935-0021",
          "935-0005",
          "935-0052",
          "935-0007",
          "935-0014",
          "935-0066",
          "935-0032",
          "935-0046",
          "935-0036",
          "935-0051",
          "935-0414",
          "935-0254",
          "935-0411",
          "935-0062",
          "935-0113",
          "935-0041",
          "935-0406",
          "935-0256",
          "935-0277",
          "935-0253",
          "935-0011",
          "935-0275",
          "935-0276",
          "935-0345",
          "935-0269",
          "935-0415",
          "935-0423",
          "935-0064",
          "935-0417",
          "935-0102",
          "935-0403",
          "935-0402",
          "935-0252",
          "935-0055",
          "935-0057",
          "935-0255",
          "935-0334",
          "935-0264",
          "935-0341",
          "935-0262",
          "935-0012",
          "935-0404",
          "935-0117",
          "935-0111",
          "935-0114",
          "935-0266",
          "935-0104",
          "935-0016",
          "935-0003",
          "935-0017",
          "935-0267",
          "935-0261",
          "935-0116",
          "935-0013",
          "935-0033",
          "935-0053",
          "935-0332",
          "935-0031",
          "935-0107",
          "935-0425",
          "935-0061",
          "935-0405",
          "935-0342",
          "935-0333",
          "935-0258",
          "935-0401",
          "935-0421",
          "936-0000",
          "936-0843",
          "936-0842",
          "936-0033",
          "936-0034",
          "936-0006",
          "936-0007",
          "936-0042",
          "936-0855",
          "936-0055",
          "936-0877",
          "936-0876",
          "936-0031",
          "936-0077",
          "936-0044",
          "936-0075",
          "936-0039",
          "936-0808",
          "936-0811",
          "936-0874",
          "936-0802",
          "936-0805",
          "936-0833",
          "936-0801",
          "936-0871",
          "936-0818",
          "936-0047",
          "936-0851",
          "936-0836",
          "936-0004",
          "936-0068",
          "936-0864",
          "936-0853",
          "936-0053",
          "936-0054",
          "936-0852",
          "936-0046",
          "936-0064",
          "936-0806",
          "936-0038",
          "936-0803",
          "936-0026",
          "936-0854",
          "936-0066",
          "936-0067",
          "936-0822",
          "936-0073",
          "936-0059",
          "936-0001",
          "936-0069",
          "936-0051",
          "936-0035",
          "936-0045",
          "936-0841",
          "936-0052",
          "936-0857",
          "936-0058",
          "936-0065",
          "936-0817",
          "936-0848",
          "936-0060",
          "936-0074",
          "936-0032",
          "936-0804",
          "936-0063",
          "936-0813",
          "936-0856",
          "936-0011",
          "936-0012",
          "936-0015",
          "936-0013",
          "936-0014",
          "936-0078",
          "936-0076",
          "936-0849",
          "936-0024",
          "936-0022",
          "936-0056",
          "936-0057",
          "936-0826",
          "936-0814",
          "936-0018",
          "936-0019",
          "936-0844",
          "936-0847",
          "936-0838",
          "936-0827",
          "936-0823",
          "936-0834",
          "936-0027",
          "936-0863",
          "936-0021",
          "936-0861",
          "936-0875",
          "936-0816",
          "936-0882",
          "936-0036",
          "936-0002",
          "936-0865",
          "936-0831",
          "936-0883",
          "936-0062",
          "936-0061",
          "936-0005",
          "936-0837",
          "936-0835",
          "936-0043",
          "936-0881",
          "936-0872",
          "936-0017",
          "936-0037",
          "936-0885",
          "936-0812",
          "936-0846",
          "936-0824",
          "936-0016",
          "936-0041",
          "936-0072",
          "936-0821",
          "936-0048",
          "936-0868",
          "936-0866",
          "936-0867",
          "936-0815",
          "936-0845",
          "936-0832",
          "936-0825",
          "936-0023",
          "936-0025",
          "936-0070",
          "936-0873",
          "936-0003",
          "936-0807",
          "936-0862",
          "936-0884",
          "936-0071",
          "938-0000",
          "938-0048",
          "938-0032",
          "938-0824",
          "938-0001",
          "938-0044",
          "938-0004",
          "938-0066",
          "938-0074",
          "938-0083",
          "938-0075",
          "938-0073",
          "938-0065",
          "938-0062",
          "938-0064",
          "938-0076",
          "938-0082",
          "938-0084",
          "938-0081",
          "938-0061",
          "938-0072",
          "938-0071",
          "938-0085",
          "938-0086",
          "938-0063",
          "938-0816",
          "938-0059",
          "938-0057",
          "938-0835",
          "938-0043",
          "938-0014",
          "938-0811",
          "938-0282",
          "938-0177",
          "938-0175",
          "938-0171",
          "938-0281",
          "938-0862",
          "938-0274",
          "938-0174",
          "938-0861",
          "938-0863",
          "938-0178",
          "938-0864",
          "938-0172",
          "938-0173",
          "938-0176",
          "938-0179",
          "938-0006",
          "938-0054",
          "938-0801",
          "938-0825",
          "938-0836",
          "938-0812",
          "938-0022",
          "938-0814",
          "938-0036",
          "938-0015",
          "938-0805",
          "938-0052",
          "938-0013",
          "938-0047",
          "938-0803",
          "938-0283",
          "938-0011",
          "938-0046",
          "938-0823",
          "938-0058",
          "938-0038",
          "938-0037",
          "938-0056",
          "938-0045",
          "938-0837",
          "938-0026",
          "938-0024",
          "938-0051",
          "938-0813",
          "938-0012",
          "938-0042",
          "938-0039",
          "938-0028",
          "938-0027",
          "938-0827",
          "938-0034",
          "938-0033",
          "938-0834",
          "938-0055",
          "938-0002",
          "938-0815",
          "938-0021",
          "938-0822",
          "938-0826",
          "938-0041",
          "938-0025",
          "938-0023",
          "938-0806",
          "938-0035",
          "938-0832",
          "938-0031",
          "938-0831",
          "938-0804",
          "938-0833",
          "938-0821",
          "938-0049",
          "938-0807",
          "938-0053",
          "938-0005",
          "938-0003",
          "938-0802",
          "939-1300",
          "939-1304",
          "939-1422",
          "939-1324",
          "939-1372",
          "939-1425",
          "939-1415",
          "939-1301",
          "939-1413",
          "939-1373",
          "939-1332",
          "939-1316",
          "939-1303",
          "939-1315",
          "939-1328",
          "939-1342",
          "939-1366",
          "939-1326",
          "939-1337",
          "939-1323",
          "939-1411",
          "939-1346",
          "939-1358",
          "939-1426",
          "939-1357",
          "939-1428",
          "939-1377",
          "939-1327",
          "939-1407",
          "939-1386",
          "939-1371",
          "939-1308",
          "939-1374",
          "939-1347",
          "939-1311",
          "939-1353",
          "932-0314",
          "932-0317",
          "932-0303",
          "932-0305",
          "932-0313",
          "932-0304",
          "932-0315",
          "932-0302",
          "932-0312",
          "932-0316",
          "932-0311",
          "932-0301",
          "939-1412",
          "939-1354",
          "939-1343",
          "939-1321",
          "939-1355",
          "939-1416",
          "939-1351",
          "939-1305",
          "939-1318",
          "939-1341",
          "939-1335",
          "939-1338",
          "939-1383",
          "939-1363",
          "939-1437",
          "939-1375",
          "939-1414",
          "939-1384",
          "939-1379",
          "939-1429",
          "939-1432",
          "939-1433",
          "939-1424",
          "939-1387",
          "939-1344",
          "939-1322",
          "939-1381",
          "939-1362",
          "939-1336",
          "939-1333",
          "939-1334",
          "939-1408",
          "939-1325",
          "939-1382",
          "939-1345",
          "939-1378",
          "939-1302",
          "939-1312",
          "939-1385",
          "939-1348",
          "939-1423",
          "939-1421",
          "939-1401",
          "939-1314",
          "939-1367",
          "939-1331",
          "939-1405",
          "939-1436",
          "939-1427",
          "939-1361",
          "939-1376",
          "939-1307",
          "939-1368",
          "939-1402",
          "939-1434",
          "939-1435",
          "939-1365",
          "939-1388",
          "939-1403",
          "939-1352",
          "939-1306",
          "939-1406",
          "939-1404",
          "939-1317",
          "939-1438",
          "939-1313",
          "939-1364",
          "939-1431",
          "939-1417",
          "939-1356",
          "932-0000",
          "932-0814",
          "932-0122",
          "932-0833",
          "932-0071",
          "932-0129",
          "932-0852",
          "932-0062",
          "932-0037",
          "932-0835",
          "932-0808",
          "932-0052",
          "932-0053",
          "932-0051",
          "932-0073",
          "932-0014",
          "932-0113",
          "932-0036",
          "932-0831",
          "932-0853",
          "932-0106",
          "932-0863",
          "932-0054",
          "932-0031",
          "932-0817",
          "932-0056",
          "932-0058",
          "932-0812",
          "932-0125",
          "932-0075",
          "932-0855",
          "932-0046",
          "932-0844",
          "932-0003",
          "932-0103",
          "932-0112",
          "932-0013",
          "932-0001",
          "932-0127",
          "932-0801",
          "932-0105",
          "932-0133",
          "932-0862",
          "932-0034",
          "932-0022",
          "932-0032",
          "932-0802",
          "932-0137",
          "932-0825",
          "932-0114",
          "932-0126",
          "932-0101",
          "932-0824",
          "932-0804",
          "932-0005",
          "932-0047",
          "932-0044",
          "932-0111",
          "932-0854",
          "932-0851",
          "932-0008",
          "932-0132",
          "932-0033",
          "932-0074",
          "932-0123",
          "932-0815",
          "932-0006",
          "932-0021",
          "932-0843",
          "932-0064",
          "932-0045",
          "932-0842",
          "932-0115",
          "932-0072",
          "932-0061",
          "932-0803",
          "932-0841",
          "932-0128",
          "932-0826",
          "932-0131",
          "932-0104",
          "932-0055",
          "932-0805",
          "932-0035",
          "932-0116",
          "932-0042",
          "932-0004",
          "932-0016",
          "932-0813",
          "932-0832",
          "932-0834",
          "932-0028",
          "932-0043",
          "932-0864",
          "932-0861",
          "932-0836",
          "932-0011",
          "932-0041",
          "932-0134",
          "932-0136",
          "932-0823",
          "932-0816",
          "932-0135",
          "932-0856",
          "932-0018",
          "932-0027",
          "932-0057",
          "932-0845",
          "932-0846",
          "932-0806",
          "932-0102",
          "932-0811",
          "932-0012",
          "932-0063",
          "932-0124",
          "932-0026",
          "932-0025",
          "932-0007",
          "932-0838",
          "932-0002",
          "932-0121",
          "932-0048",
          "932-0807",
          "932-0015",
          "932-0024",
          "932-0023",
          "932-0837",
          "932-0017",
          "932-0065",
          "932-0822",
          "932-0821",
          "939-1600",
          "939-1915",
          "939-1751",
          "932-0206",
          "939-1701",
          "939-1622",
          "939-1976",
          "939-1744",
          "939-1524",
          "939-1732",
          "939-1716",
          "939-1711",
          "939-1873",
          "939-1871",
          "939-1535",
          "939-1621",
          "939-1821",
          "932-0247",
          "939-1673",
          "932-0211",
          "932-0213",
          "932-0205",
          "932-0216",
          "932-0228",
          "939-1877",
          "939-1962",
          "932-0256",
          "932-0214",
          "939-1904",
          "939-1612",
          "939-1503",
          "932-0203",
          "939-1611",
          "939-1531",
          "939-1824",
          "939-1512",
          "939-1823",
          "939-1542",
          "939-1724",
          "939-1979",
          "939-1833",
          "939-1526",
          "939-1902",
          "939-1855",
          "939-1912",
          "939-1825",
          "939-1743",
          "939-1752",
          "939-1875",
          "939-1814",
          "939-1837",
          "932-0248",
          "939-1971",
          "939-1967",
          "939-1605",
          "939-1667",
          "939-1961",
          "939-1911",
          "939-1725",
          "939-1969",
          "939-1843",
          "939-1553",
          "939-1968",
          "939-1975",
          "939-1914",
          "939-1713",
          "939-1834",
          "939-1878",
          "939-1928",
          "939-1575",
          "939-1876",
          "939-1613",
          "939-1504",
          "932-0241",
          "939-1836",
          "932-0221",
          "932-0257",
          "932-0226",
          "932-0227",
          "939-1807",
          "939-1802",
          "939-1801",
          "939-1806",
          "932-0232",
          "939-1835",
          "939-1846",
          "939-1548",
          "939-1872",
          "939-1614",
          "939-1925",
          "939-1684",
          "939-1674",
          "939-1964",
          "939-1926",
          "939-1671",
          "939-1735",
          "939-1682",
          "939-1665",
          "932-0254",
          "932-0255",
          "939-1852",
          "939-1856",
          "939-1681",
          "939-1804",
          "932-0222",
          "939-1655",
          "939-1525",
          "932-0258",
          "932-0243",
          "939-1532",
          "939-1577",
          "939-1978",
          "939-1733",
          "939-1703",
          "939-1552",
          "932-0202",
          "939-1845",
          "932-0238",
          "939-1908",
          "939-1923",
          "939-1543",
          "939-1874",
          "939-1551",
          "939-1861",
          "939-1818",
          "939-1854",
          "939-1865",
          "939-1864",
          "939-1853",
          "939-1863",
          "939-1862",
          "939-1868",
          "939-1867",
          "939-1816",
          "939-1817",
          "939-1815",
          "939-1866",
          "939-1544",
          "939-1973",
          "939-1903",
          "939-1921",
          "939-1603",
          "932-0245",
          "939-1826",
          "932-0207",
          "939-1831",
          "939-1675",
          "939-1901",
          "939-1506",
          "939-1602",
          "932-0252",
          "939-1906",
          "939-1714",
          "939-1511",
          "939-1741",
          "932-0201",
          "939-1664",
          "939-1734",
          "939-1538",
          "939-1676",
          "939-1755",
          "939-1766",
          "939-1704",
          "932-0242",
          "939-1974",
          "939-1913",
          "939-1537",
          "939-1505",
          "939-1765",
          "932-0218",
          "939-1746",
          "939-1661",
          "932-0253",
          "932-0246",
          "939-1832",
          "939-2507",
          "939-2517",
          "939-2508",
          "939-2514",
          "932-0371",
          "939-2506",
          "939-2504",
          "939-2513",
          "939-2509",
          "939-2505",
          "939-2501",
          "939-2516",
          "939-2503",
          "939-2518",
          "939-2502",
          "939-2512",
          "939-2515",
          "939-2519",
          "939-2511",
          "939-1722",
          "939-1758",
          "939-1723",
          "939-1922",
          "939-1604",
          "939-1828",
          "939-1625",
          "939-1924",
          "939-1927",
          "939-1907",
          "939-1762",
          "939-1555",
          "939-1963",
          "939-1745",
          "939-1977",
          "939-1514",
          "939-1844",
          "939-1521",
          "939-1502",
          "939-1513",
          "939-1522",
          "939-1842",
          "932-0251",
          "939-1523",
          "939-1851",
          "939-1606",
          "932-0225",
          "939-1624",
          "939-1757",
          "939-1756",
          "939-1541",
          "939-1966",
          "939-1536",
          "939-1721",
          "939-1905",
          "939-1803",
          "939-1712",
          "932-0204",
          "939-1601",
          "939-1763",
          "939-1517",
          "939-1672",
          "939-1534",
          "939-1561",
          "939-1562",
          "939-1572",
          "939-1564",
          "939-1567",
          "939-1565",
          "939-1563",
          "939-1566",
          "939-1574",
          "939-1573",
          "939-1568",
          "939-1515",
          "939-1610",
          "939-1631",
          "939-1646",
          "939-1641",
          "939-1636",
          "939-1632",
          "939-1644",
          "939-1654",
          "939-1635",
          "939-1634",
          "939-1662",
          "939-1645",
          "939-1637",
          "939-1651",
          "939-1633",
          "939-1643",
          "939-1642",
          "939-1653",
          "939-1652",
          "932-0224",
          "939-1507",
          "939-1761",
          "939-1626",
          "939-1841",
          "939-1805",
          "939-1545",
          "932-0233",
          "939-1501",
          "932-0217",
          "939-1549",
          "939-1965",
          "939-1813",
          "932-0223",
          "939-1623",
          "939-1518",
          "939-1571",
          "939-1916",
          "932-0236",
          "939-1547",
          "939-1812",
          "939-1879",
          "932-0235",
          "939-1972",
          "939-1715",
          "939-1546",
          "939-1527",
          "939-1827",
          "939-1576",
          "939-1516",
          "939-1554",
          "939-1528",
          "939-1533",
          "932-0215",
          "939-1747",
          "932-0212",
          "932-0231",
          "932-0237",
          "939-1666",
          "939-1615",
          "932-0234",
          "939-1702",
          "939-1742",
          "939-1764",
          "939-1754",
          "939-1811",
          "939-1822",
          "932-0244",
          "939-0300",
          "939-0321",
          "939-0247",
          "939-0287",
          "933-0241",
          "939-0412",
          "933-0251",
          "939-0318",
          "939-0332",
          "939-0404",
          "939-0301",
          "934-0046",
          "939-0286",
          "933-0227",
          "939-0231",
          "939-0415",
          "939-0322",
          "933-0233",
          "933-0234",
          "933-0235",
          "933-0231",
          "939-0302",
          "939-0271",
          "934-0045",
          "934-0055",
          "934-0023",
          "939-0406",
          "933-0222",
          "934-0049",
          "934-0040",
          "934-0054",
          "934-0032",
          "934-0037",
          "934-0036",
          "933-0205",
          "933-0204",
          "933-0203",
          "933-0240",
          "934-0058",
          "933-0058",
          "939-0281",
          "939-0276",
          "934-0039",
          "933-0225",
          "939-0413",
          "939-0416",
          "933-0206",
          "939-0311",
          "939-0252",
          "939-0331",
          "939-0417",
          "934-0024",
          "939-0274",
          "939-0316",
          "939-0304",
          "939-0288",
          "934-0015",
          "939-0341",
          "939-0315",
          "933-0252",
          "933-0253",
          "939-0254",
          "933-0202",
          "939-0243",
          "934-0003",
          "939-0403",
          "939-0414",
          "939-0255",
          "934-0001",
          "933-0207",
          "939-0284",
          "934-0033",
          "934-0035",
          "933-0209",
          "934-0005",
          "939-0361",
          "939-0362",
          "939-0232",
          "939-0233",
          "939-0246",
          "934-0047",
          "934-0034",
          "939-0407",
          "934-0013",
          "939-0245",
          "934-0012",
          "939-0313",
          "934-0041",
          "934-0042",
          "934-0038",
          "939-0411",
          "939-0306",
          "934-0056",
          "939-0251",
          "933-0236",
          "933-0238",
          "933-0239",
          "933-0237",
          "939-0314",
          "939-0283",
          "934-0044",
          "939-0312",
          "934-0027",
          "939-0363",
          "939-0273",
          "939-0241",
          "934-0031",
          "934-0004",
          "939-0303",
          "939-0257",
          "934-0026",
          "934-0048",
          "939-0418",
          "934-0043",
          "934-0025",
          "933-0208",
          "933-0232",
          "934-0057",
          "939-0319",
          "939-0351",
          "939-0307",
          "939-0323",
          "939-0256",
          "939-0235",
          "939-0405",
          "939-0234",
          "934-0022",
          "934-0053",
          "939-0253",
          "933-0226",
          "933-0223",
          "933-0224",
          "933-0228",
          "934-0021",
          "933-0221",
          "939-0285",
          "933-0244",
          "933-0243",
          "933-0246",
          "933-0245",
          "933-0247",
          "933-0248",
          "933-0249",
          "933-0242",
          "939-0244",
          "934-0011",
          "934-0052",
          "934-0016",
          "939-0401",
          "934-0014",
          "934-0002",
          "939-0364",
          "939-0282",
          "934-0051",
          "939-0242",
          "939-0275",
          "939-0317",
          "933-0201",
          "939-0402",
          "939-0272",
          "939-0408",
          "939-0305",
          "930-0200",
          "930-0287",
          "930-0283",
          "930-0288",
          "930-0289",
          "930-0284",
          "930-0286",
          "930-0282",
          "930-0281",
          "930-0285",
          "930-0300",
          "930-0374",
          "930-0384",
          "930-0331",
          "930-0464",
          "930-0377",
          "930-0471",
          "930-0305",
          "930-0385",
          "930-0387",
          "930-0437",
          "930-0332",
          "930-0302",
          "930-0413",
          "930-0432",
          "930-0414",
          "930-0318",
          "930-0317",
          "930-0463",
          "930-0465",
          "930-0354",
          "930-0462",
          "930-0461",
          "930-0303",
          "930-0472",
          "930-0435",
          "930-0473",
          "930-0406",
          "930-0346",
          "930-0421",
          "930-0375",
          "930-0372",
          "930-0356",
          "930-0333",
          "930-0352",
          "930-0368",
          "930-0351",
          "930-0347",
          "930-0416",
          "930-0434",
          "930-0417",
          "930-0405",
          "930-0451",
          "930-0443",
          "936-0891",
          "930-0424",
          "930-0335",
          "930-0322",
          "930-0422",
          "930-0458",
          "930-0467",
          "930-0382",
          "930-0376",
          "930-0373",
          "930-0431",
          "930-0357",
          "930-0358",
          "930-0383",
          "930-0365",
          "930-0324",
          "930-0366",
          "930-0342",
          "930-0411",
          "930-0452",
          "930-0442",
          "930-0301",
          "930-0425",
          "930-0474",
          "930-0453",
          "930-0321",
          "930-0386",
          "930-0313",
          "930-0371",
          "930-0316",
          "930-0433",
          "930-0341",
          "930-0444",
          "930-0323",
          "930-0334",
          "930-0403",
          "930-0423",
          "930-0367",
          "930-0438",
          "930-0362",
          "930-0312",
          "930-0441",
          "930-0343",
          "930-0381",
          "930-0388",
          "930-0466",
          "930-0402",
          "930-0412",
          "930-0401",
          "930-0353",
          "930-0378",
          "930-0379",
          "930-0415",
          "930-0336",
          "930-0456",
          "930-0445",
          "930-0404",
          "930-0325",
          "930-0345",
          "930-0304",
          "930-0344",
          "930-0311",
          "930-0326",
          "930-0361",
          "930-0455",
          "930-0454",
          "930-0457",
          "930-0364",
          "930-0355",
          "930-0359",
          "930-0436",
          "930-0314",
          "930-0315",
          "930-0363",
          "930-1406",
          "930-3242",
          "930-0271",
          "930-3239",
          "930-3215",
          "930-1361",
          "930-0201",
          "930-3234",
          "930-0256",
          "930-0246",
          "930-1368",
          "930-1369",
          "930-0208",
          "930-0207",
          "930-3245",
          "930-3267",
          "930-0235",
          "930-0261",
          "930-0216",
          "930-0253",
          "930-0251",
          "930-0263",
          "930-3202",
          "930-3236",
          "930-0237",
          "930-1402",
          "930-0233",
          "930-3244",
          "930-3251",
          "930-3203",
          "930-0223",
          "930-3254",
          "930-0257",
          "930-0227",
          "930-0262",
          "930-3255",
          "930-0214",
          "930-0274",
          "930-0232",
          "930-3262",
          "930-0231",
          "930-3238",
          "930-3264",
          "930-0245",
          "930-0212",
          "930-0234",
          "930-3221",
          "930-3212",
          "930-3241",
          "930-3214",
          "930-3208",
          "930-3243",
          "930-1401",
          "930-3224",
          "930-3248",
          "930-0236",
          "930-3252",
          "930-0247",
          "930-0244",
          "930-3247",
          "930-1405",
          "930-3201",
          "930-0268",
          "930-0206",
          "930-3206",
          "930-0219",
          "930-1418",
          "930-3233",
          "930-3222",
          "930-0228",
          "930-1408",
          "930-0272",
          "930-0211",
          "930-1416",
          "930-1417",
          "930-0204",
          "930-0209",
          "930-0205",
          "930-0242",
          "930-1413",
          "930-1364",
          "930-0241",
          "930-0226",
          "930-1363",
          "930-0265",
          "930-3235",
          "930-3246",
          "930-3253",
          "930-0269",
          "930-0224",
          "930-0267",
          "930-3211",
          "930-3213",
          "930-0222",
          "930-0217",
          "930-0213",
          "930-3217",
          "930-3261",
          "930-0248",
          "930-0264",
          "930-1365",
          "930-3204",
          "930-1411",
          "930-0252",
          "930-3216",
          "930-3205",
          "930-1404",
          "930-0218",
          "930-3263",
          "930-1403",
          "930-0254",
          "930-0276",
          "930-0225",
          "930-0221",
          "930-3266",
          "930-0229",
          "930-0220",
          "930-1407",
          "930-3237",
          "930-1412",
          "930-0266",
          "930-1367",
          "930-0215",
          "930-0255",
          "930-3223",
          "930-1414",
          "930-3232",
          "930-3277",
          "930-1377",
          "930-1366",
          "930-0273",
          "930-1362",
          "930-3265",
          "930-0243",
          "930-1415",
          "930-0275",
          "930-3231",
          "930-0203",
          "930-0202",
          "939-0600",
          "939-0643",
          "939-0646",
          "939-0624",
          "939-0667",
          "939-0621",
          "939-0637",
          "939-0679",
          "939-0654",
          "939-0636",
          "938-0101",
          "939-0633",
          "939-0642",
          "939-0617",
          "939-0653",
          "939-0651",
          "939-0625",
          "939-0677",
          "939-0614",
          "939-0627",
          "939-0628",
          "939-0623",
          "939-0634",
          "939-0655",
          "939-0656",
          "939-0663",
          "939-0662",
          "939-0641",
          "939-0652",
          "939-0661",
          "939-0666",
          "939-0672",
          "939-0613",
          "939-0675",
          "939-0647",
          "939-0657",
          "938-0105",
          "939-0631",
          "938-0104",
          "939-0626",
          "938-0106",
          "939-0632",
          "939-0671",
          "939-0622",
          "939-0645",
          "939-0644",
          "939-0612",
          "938-0103",
          "939-0611",
          "938-0102",
          "939-0664",
          "939-0665",
          "939-0678",
          "939-0676",
          "939-0615",
          "939-0616",
          "939-0674",
          "939-0673",
          "939-0635",
          "939-0700",
          "939-0735",
          "939-0746",
          "939-0717",
          "939-0722",
          "939-0727",
          "939-0734",
          "939-0728",
          "939-0704",
          "939-0714",
          "939-0711",
          "938-0167",
          "939-0721",
          "938-0169",
          "939-0747",
          "939-0748",
          "939-0705",
          "939-0725",
          "938-0164",
          "939-0733",
          "939-0737",
          "939-0743",
          "938-0161",
          "939-0741",
          "939-0749",
          "939-0732",
          "939-0713",
          "939-0715",
          "939-0716",
          "939-0726",
          "939-0745",
          "939-0742",
          "939-0751",
          "939-0736",
          "939-0731",
          "939-0744",
          "939-0712",
          "938-0168",
          "939-0723",
          "939-0729",
          "938-0166",
          "939-0703",
          "939-0702",
          "938-0162",
          "938-0165",
          "938-0163",
          "939-0701",
          "939-0724",
          "920-0000",
          "920-0907",
          "920-1322",
          "920-0926",
          "920-0353",
          "920-0111",
          "920-1132",
          "920-1145",
          "920-1158",
          "920-0841",
          "920-0126",
          "920-0941",
          "920-1107",
          "920-0996",
          "920-1331",
          "920-3124",
          "920-3125",
          "920-1101",
          "921-8161",
          "920-0226",
          "920-0227",
          "920-0983",
          "920-0984",
          "920-0985",
          "920-0986",
          "920-0987",
          "920-1115",
          "920-0935",
          "921-8041",
          "921-8035",
          "921-8116",
          "921-8034",
          "921-8042",
          "920-0056",
          "920-0012",
          "920-1116",
          "920-0145",
          "921-8014",
          "921-8026",
          "920-0378",
          "920-0994",
          "920-0125",
          "920-0008",
          "920-0106",
          "921-8011",
          "920-0171",
          "920-0943",
          "920-1113",
          "920-1111",
          "920-0837",
          "920-0832",
          "920-1149",
          "920-0377",
          "920-0343",
          "920-0342",
          "920-0344",
          "920-3111",
          "920-0971",
          "920-0122",
          "920-1301",
          "920-0027",
          "920-0025",
          "920-0973",
          "920-0112",
          "921-8173",
          "921-8176",
          "920-0162",
          "920-0927",
          "920-0205",
          "921-8045",
          "920-0945",
          "921-8046",
          "920-0946",
          "920-0912",
          "920-8205",
          "920-8222",
          "921-8147",
          "921-8143",
          "920-0231",
          "920-0331",
          "920-0225",
          "920-3121",
          "920-0818",
          "920-1335",
          "920-0013",
          "920-0210",
          "920-0213",
          "921-8056",
          "920-1324",
          "920-0807",
          "920-1343",
          "920-0918",
          "920-1112",
          "920-0902",
          "920-0114",
          "920-0208",
          "920-0999",
          "920-1163",
          "920-1164",
          "920-0851",
          "920-0965",
          "920-0947",
          "920-1332",
          "920-0908",
          "920-0817",
          "920-0164",
          "920-0219",
          "920-0981",
          "920-0334",
          "920-3134",
          "920-0322",
          "920-0321",
          "920-0338",
          "920-0317",
          "920-0330",
          "920-0316",
          "920-0337",
          "920-0335",
          "920-0336",
          "920-0318",
          "920-1148",
          "921-8065",
          "920-0905",
          "920-0992",
          "920-1304",
          "920-0869",
          "920-1146",
          "920-0368",
          "920-0365",
          "920-0370",
          "920-0374",
          "920-0801",
          "920-1166",
          "920-0175",
          "920-0974",
          "920-0172",
          "921-8027",
          "920-0352",
          "920-0838",
          "920-1125",
          "920-3112",
          "920-0967",
          "920-0988",
          "920-0202",
          "920-0201",
          "920-0203",
          "920-0102",
          "920-0143",
          "920-0128",
          "920-0367",
          "920-0206",
          "920-1135",
          "920-0055",
          "920-0212",
          "920-3117",
          "920-0022",
          "920-0023",
          "920-0858",
          "920-0339",
          "920-0848",
          "921-8032",
          "921-8122",
          "920-0163",
          "920-1333",
          "921-8151",
          "920-1326",
          "921-8124",
          "920-8203",
          "920-8201",
          "920-0157",
          "921-8051",
          "920-0936",
          "920-0931",
          "920-0961",
          "920-0805",
          "920-1114",
          "920-8221",
          "920-0811",
          "920-0932",
          "920-0813",
          "920-0942",
          "920-0129",
          "920-0121",
          "920-3107",
          "920-0852",
          "920-0168",
          "920-0844",
          "920-0826",
          "920-0362",
          "920-0363",
          "920-1313",
          "920-0144",
          "920-3103",
          "920-0836",
          "920-0224",
          "920-3101",
          "920-0024",
          "920-0026",
          "920-0921",
          "920-0968",
          "920-0357",
          "920-0057",
          "920-0923",
          "920-0998",
          "920-0034",
          "920-0861",
          "921-8131",
          "920-0821",
          "920-0166",
          "921-8135",
          "921-8132",
          "921-8133",
          "920-0116",
          "920-0341",
          "920-0906",
          "920-1129",
          "920-0104",
          "920-0132",
          "920-1104",
          "920-0058",
          "920-0059",
          "920-0939",
          "920-0904",
          "920-1323",
          "920-0991",
          "920-0910",
          "920-1127",
          "920-0917",
          "920-0993",
          "920-0916",
          "920-0371",
          "920-0176",
          "921-8106",
          "920-0976",
          "920-0977",
          "920-0846",
          "920-0966",
          "920-0154",
          "920-1325",
          "920-0856",
          "921-8024",
          "920-1126",
          "921-8013",
          "920-0806",
          "920-0803",
          "920-0995",
          "921-8062",
          "920-1345",
          "921-8006",
          "920-0833",
          "920-1302",
          "920-1311",
          "920-0972",
          "920-0207",
          "920-0857",
          "920-1161",
          "920-1162",
          "920-1344",
          "920-8202",
          "920-0002",
          "920-0001",
          "920-1312",
          "920-0356",
          "920-0204",
          "921-8023",
          "920-0115",
          "920-0982",
          "920-0924",
          "920-1154",
          "920-1141",
          "920-1334",
          "920-0046",
          "920-1143",
          "921-8152",
          "920-0864",
          "921-8155",
          "921-8153",
          "921-8154",
          "920-0155",
          "921-8001",
          "920-0005",
          "920-0934",
          "920-1152",
          "920-1157",
          "920-1153",
          "920-1156",
          "920-1155",
          "920-1151",
          "920-0123",
          "920-0137",
          "920-3102",
          "920-0957",
          "920-0956",
          "920-1303",
          "920-0997",
          "920-0007",
          "920-1103",
          "920-0863",
          "921-8002",
          "921-8003",
          "920-0113",
          "920-1108",
          "920-8217",
          "920-1138",
          "920-0866",
          "920-1147",
          "920-3113",
          "920-0178",
          "920-0105",
          "920-0135",
          "920-0955",
          "921-8103",
          "920-0161",
          "921-8123",
          "920-0825",
          "921-8178",
          "920-1315",
          "921-8033",
          "920-0925",
          "920-0963",
          "920-0824",
          "920-0068",
          "920-0069",
          "920-0061",
          "921-8015",
          "921-8016",
          "920-1133",
          "921-8171",
          "920-0834",
          "920-0101",
          "920-0938",
          "920-8204",
          "920-0223",
          "920-1105",
          "920-1106",
          "920-0372",
          "920-8218",
          "920-8215",
          "920-0141",
          "920-8213",
          "920-8216",
          "920-8214",
          "920-0124",
          "920-0975",
          "920-1336",
          "920-0035",
          "921-8022",
          "920-0381",
          "920-0375",
          "920-1109",
          "920-0379",
          "921-8112",
          "921-8115",
          "921-8114",
          "920-0043",
          "920-0041",
          "920-0042",
          "920-0867",
          "920-0865",
          "920-0151",
          "920-0021",
          "920-1137",
          "920-0928",
          "920-0152",
          "920-0804",
          "920-0815",
          "920-0814",
          "921-8043",
          "920-1136",
          "921-8102",
          "921-8054",
          "921-8055",
          "920-0952",
          "920-0913",
          "920-0914",
          "920-0915",
          "920-0067",
          "921-8146",
          "921-8148",
          "921-8149",
          "921-8145",
          "921-8144",
          "920-0142",
          "921-8107",
          "921-8104",
          "921-8031",
          "920-0903",
          "920-0911",
          "920-3106",
          "920-3104",
          "920-3105",
          "920-0951",
          "920-0103",
          "920-1128",
          "921-8142",
          "920-1131",
          "920-1134",
          "920-0209",
          "920-0933",
          "920-0822",
          "920-0131",
          "920-1121",
          "920-0835",
          "920-0831",
          "920-0003",
          "920-0004",
          "920-0901",
          "921-8164",
          "920-0845",
          "920-0033",
          "921-8121",
          "920-0031",
          "920-0032",
          "920-0962",
          "920-0165",
          "920-0167",
          "920-3126",
          "920-3122",
          "920-3123",
          "920-0376",
          "920-1144",
          "920-0361",
          "920-0909",
          "921-8172",
          "921-8177",
          "920-0351",
          "920-0346",
          "920-0345",
          "920-0051",
          "920-0354",
          "920-0065",
          "920-1316",
          "920-1102",
          "920-0107",
          "920-0173",
          "920-0147",
          "920-0156",
          "921-8105",
          "920-1341",
          "920-3132",
          "920-0862",
          "921-8101",
          "920-0177",
          "921-8052",
          "921-8053",
          "920-0849",
          "920-0847",
          "920-0133",
          "920-0964",
          "920-0853",
          "921-8141",
          "920-0827",
          "920-0148",
          "921-8005",
          "920-0134",
          "921-8025",
          "920-0364",
          "920-0011",
          "920-0136",
          "920-0348",
          "920-0347",
          "921-8047",
          "920-0047",
          "920-0937",
          "920-0809",
          "920-0808",
          "920-0802",
          "920-0063",
          "921-8021",
          "920-0978",
          "920-1321",
          "920-0944",
          "920-0018",
          "920-1346",
          "920-0214",
          "920-0373",
          "921-8117",
          "920-0211",
          "920-0812",
          "921-8134",
          "920-0064",
          "920-0127",
          "920-0919",
          "920-0366",
          "920-0044",
          "920-3116",
          "920-0153",
          "920-0006",
          "920-3115",
          "921-8162",
          "920-0045",
          "920-0855",
          "920-0333",
          "920-0332",
          "920-1314",
          "921-8012",
          "920-0036",
          "920-0842",
          "920-3131",
          "921-8061",
          "920-1167",
          "920-0843",
          "920-0014",
          "920-0015",
          "920-0016",
          "920-0017",
          "921-8066",
          "920-0052",
          "920-0174",
          "920-0854",
          "920-3133",
          "920-1337",
          "921-8175",
          "921-8174",
          "920-0816",
          "921-8036",
          "920-0823",
          "920-0146",
          "920-0215",
          "920-1122",
          "920-1118",
          "920-1124",
          "920-1119",
          "920-1123",
          "921-8064",
          "921-8063",
          "921-8163",
          "920-1117",
          "920-3135",
          "920-0922",
          "920-3114",
          "921-8044",
          "921-8004",
          "920-1342",
          "920-1142",
          "920-0868",
          "921-8111",
          "920-0355",
          "920-1165",
          "920-0054",
          "920-0053",
          "920-0953",
          "920-0954",
          "920-0062",
          "926-0000",
          "926-0044",
          "926-0823",
          "926-0831",
          "926-0843",
          "926-0833",
          "926-0372",
          "926-0807",
          "929-2105",
          "926-0366",
          "926-0364",
          "926-0365",
          "926-0367",
          "926-0826",
          "929-2114",
          "926-0804",
          "926-0171",
          "926-0178",
          "926-0173",
          "926-0172",
          "926-0806",
          "926-0055",
          "926-0816",
          "926-0864",
          "926-0027",
          "926-0001",
          "926-0818",
          "929-2122",
          "926-0825",
          "926-0363",
          "926-0361",
          "926-0006",
          "929-2126",
          "926-0047",
          "926-0384",
          "926-0362",
          "926-0005",
          "926-0174",
          "926-0373",
          "929-2104",
          "926-0057",
          "926-0053",
          "926-0805",
          "929-2101",
          "926-0054",
          "926-0812",
          "926-0808",
          "926-0387",
          "926-0389",
          "926-0388",
          "926-0381",
          "926-0026",
          "926-0375",
          "926-0177",
          "926-0051",
          "926-0037",
          "926-0821",
          "926-0852",
          "926-0861",
          "926-0855",
          "926-0803",
          "926-0815",
          "926-0042",
          "926-0867",
          "926-0371",
          "926-0013",
          "926-0011",
          "926-0003",
          "926-0052",
          "929-2115",
          "926-0374",
          "926-0824",
          "926-0801",
          "929-2124",
          "926-0828",
          "926-0863",
          "926-0845",
          "926-0046",
          "929-2112",
          "926-0179",
          "926-0045",
          "926-0376",
          "926-0846",
          "929-2111",
          "926-0023",
          "926-0844",
          "926-0043",
          "929-2121",
          "926-0034",
          "926-0033",
          "926-0851",
          "926-0853",
          "926-0022",
          "926-0383",
          "926-0862",
          "926-0829",
          "926-0814",
          "926-0004",
          "926-0866",
          "926-0021",
          "929-2204",
          "929-2207",
          "929-2231",
          "929-2214",
          "929-2233",
          "929-2217",
          "929-2243",
          "929-2201",
          "929-2223",
          "929-2203",
          "929-2242",
          "929-2234",
          "929-2218",
          "929-2213",
          "929-2247",
          "929-2212",
          "929-2246",
          "929-2245",
          "929-2244",
          "929-2206",
          "929-2216",
          "929-2222",
          "929-2209",
          "929-2241",
          "929-2215",
          "929-2227",
          "929-2232",
          "929-2208",
          "929-2202",
          "929-2205",
          "929-2225",
          "929-2221",
          "929-2224",
          "929-2226",
          "929-2211",
          "926-0036",
          "926-0854",
          "929-2113",
          "926-0817",
          "926-0835",
          "926-0837",
          "926-0056",
          "926-0203",
          "926-0227",
          "926-0211",
          "926-0212",
          "926-0213",
          "926-0226",
          "926-0225",
          "926-0204",
          "926-0222",
          "926-0205",
          "926-0201",
          "926-0202",
          "926-0223",
          "926-0206",
          "926-0224",
          "926-0207",
          "926-0214",
          "926-0216",
          "926-0215",
          "926-0221",
          "926-0035",
          "926-0382",
          "926-0832",
          "926-0834",
          "929-2103",
          "926-0048",
          "929-2125",
          "926-0028",
          "926-0041",
          "929-2102",
          "926-0031",
          "926-0025",
          "926-0024",
          "926-0012",
          "926-0822",
          "926-0836",
          "926-0842",
          "926-0841",
          "926-0865",
          "926-0838",
          "926-0802",
          "926-0811",
          "926-0014",
          "926-0058",
          "926-0032",
          "926-0813",
          "929-2123",
          "926-0007",
          "926-0015",
          "926-0385",
          "926-0386",
          "926-0016",
          "926-0038",
          "926-0002",
          "929-2116",
          "926-0827",
          "926-0175",
          "926-0176",
          "923-0000",
          "923-0946",
          "923-0967",
          "923-0185",
          "923-0187",
          "923-0035",
          "923-0953",
          "923-0938",
          "923-0995",
          "923-0003",
          "923-0922",
          "923-0823",
          "923-0078",
          "923-0032",
          "923-0864",
          "923-0326",
          "923-0943",
          "923-0161",
          "923-0901",
          "923-0813",
          "923-0015",
          "923-0316",
          "923-0964",
          "923-0177",
          "923-0073",
          "923-0063",
          "923-0908",
          "923-0993",
          "923-0831",
          "923-0184",
          "923-0023",
          "923-0812",
          "923-0155",
          "923-0853",
          "923-0973",
          "923-0911",
          "923-0001",
          "923-0186",
          "923-0156",
          "923-0861",
          "923-0172",
          "923-0016",
          "923-0054",
          "923-0314",
          "923-0805",
          "923-0028",
          "923-0341",
          "923-0074",
          "923-0171",
          "923-0154",
          "923-0153",
          "923-0331",
          "923-0802",
          "923-0935",
          "923-0027",
          "923-0077",
          "923-0955",
          "923-0051",
          "923-0824",
          "923-0044",
          "923-0991",
          "923-0851",
          "923-0312",
          "923-0311",
          "923-0826",
          "923-0918",
          "923-0996",
          "923-0966",
          "923-0965",
          "923-0994",
          "923-0053",
          "923-0822",
          "923-0061",
          "923-0152",
          "923-0002",
          "923-0902",
          "923-0806",
          "923-0055",
          "923-0869",
          "923-0315",
          "923-0904",
          "923-0915",
          "923-0916",
          "923-0867",
          "923-0934",
          "923-0942",
          "923-0821",
          "923-0062",
          "923-0984",
          "923-0165",
          "923-0844",
          "923-0163",
          "923-0836",
          "923-0905",
          "923-0971",
          "923-0021",
          "923-0303",
          "923-0958",
          "923-0304",
          "923-0026",
          "923-0052",
          "923-0941",
          "923-0013",
          "923-0151",
          "923-0811",
          "923-0866",
          "923-0814",
          "923-0321",
          "923-0914",
          "923-0906",
          "923-0175",
          "923-0912",
          "923-0963",
          "923-0945",
          "923-0183",
          "923-0862",
          "923-0834",
          "923-0041",
          "923-0801",
          "923-0931",
          "923-0962",
          "923-0854",
          "923-0803",
          "923-0031",
          "923-0335",
          "923-0981",
          "923-0024",
          "923-0972",
          "923-0974",
          "923-0313",
          "923-0992",
          "923-0932",
          "923-0025",
          "923-0921",
          "923-0327",
          "923-0919",
          "923-0037",
          "923-0071",
          "923-0917",
          "923-0004",
          "923-0181",
          "923-0034",
          "923-0336",
          "923-0328",
          "923-0323",
          "923-0825",
          "923-0948",
          "923-0927",
          "923-0325",
          "923-0176",
          "923-0956",
          "923-0977",
          "923-0164",
          "923-0033",
          "923-0042",
          "923-0951",
          "923-0182",
          "923-0162",
          "923-0157",
          "923-0174",
          "923-0066",
          "923-0997",
          "923-0985",
          "923-0907",
          "923-0344",
          "923-0075",
          "923-0333",
          "923-0804",
          "923-0012",
          "923-0923",
          "923-0842",
          "923-0983",
          "923-0043",
          "923-0868",
          "923-0324",
          "923-0947",
          "923-0036",
          "923-0011",
          "923-0865",
          "923-0345",
          "923-0302",
          "923-0863",
          "923-0944",
          "923-0005",
          "923-0334",
          "923-0933",
          "923-0841",
          "923-0936",
          "923-0937",
          "923-0322",
          "923-0306",
          "923-0166",
          "923-0982",
          "923-0913",
          "923-0014",
          "923-0903",
          "923-0173",
          "923-0924",
          "923-0072",
          "923-0852",
          "923-0305",
          "923-0022",
          "923-0961",
          "923-0076",
          "923-0968",
          "923-0957",
          "923-0301",
          "923-0056",
          "923-0343",
          "923-0976",
          "923-0342",
          "923-0975",
          "923-0952",
          "923-0833",
          "923-0954",
          "923-0064",
          "923-0332",
          "923-0925",
          "923-0835",
          "923-0998",
          "923-0926",
          "923-0065",
          "923-0843",
          "923-0832",
          "928-0000",
          "928-0053",
          "928-0072",
          "928-0013",
          "928-0015",
          "928-0004",
          "928-0028",
          "928-0065",
          "928-0051",
          "928-0032",
          "928-0054",
          "928-0005",
          "928-0251",
          "928-0064",
          "928-0055",
          "928-0045",
          "928-0057",
          "928-0001",
          "928-0027",
          "928-0016",
          "928-0023",
          "928-0246",
          "928-0252",
          "928-0241",
          "928-0044",
          "928-0052",
          "928-0256",
          "928-0061",
          "928-0011",
          "928-0006",
          "928-0037",
          "928-0253",
          "928-0036",
          "928-0022",
          "928-0041",
          "928-0003",
          "928-0033",
          "928-0034",
          "928-0254",
          "928-0047",
          "928-0244",
          "928-0056",
          "928-0243",
          "928-0026",
          "928-0255",
          "928-0067",
          "928-0242",
          "928-0025",
          "928-0245",
          "928-0007",
          "928-0073",
          "928-0076",
          "928-0078",
          "928-0077",
          "928-0075",
          "928-0079",
          "928-0074",
          "928-0043",
          "928-0031",
          "928-0021",
          "928-0046",
          "928-0002",
          "928-0068",
          "928-0035",
          "928-0062",
          "928-0215",
          "928-0217",
          "928-0211",
          "928-0231",
          "928-0216",
          "928-0236",
          "928-0235",
          "928-0223",
          "928-0214",
          "928-0221",
          "928-0203",
          "928-0218",
          "928-0206",
          "928-0202",
          "928-0212",
          "928-0226",
          "928-0225",
          "928-0205",
          "928-0222",
          "928-0233",
          "928-0201",
          "928-0232",
          "928-0213",
          "928-0234",
          "928-0204",
          "928-0224",
          "928-0008",
          "929-2373",
          "929-2374",
          "929-2377",
          "929-2378",
          "929-2363",
          "929-2376",
          "929-2372",
          "929-2365",
          "929-2362",
          "929-2379",
          "929-2367",
          "929-2375",
          "929-2366",
          "929-2371",
          "929-2361",
          "928-0066",
          "928-0063",
          "927-2345",
          "927-2106",
          "927-2123",
          "927-2107",
          "927-2314",
          "927-2286",
          "927-2354",
          "927-2274",
          "927-2336",
          "927-2137",
          "927-2322",
          "927-2281",
          "927-2102",
          "927-2334",
          "927-2303",
          "927-2141",
          "927-2341",
          "927-2305",
          "927-2282",
          "927-2343",
          "927-2147",
          "927-2163",
          "927-2166",
          "927-2121",
          "927-2143",
          "927-2364",
          "927-2162",
          "927-2142",
          "927-2352",
          "927-2332",
          "927-2321",
          "927-2311",
          "927-2273",
          "927-2335",
          "927-2165",
          "927-2344",
          "927-2145",
          "927-2361",
          "927-2353",
          "927-2133",
          "927-2144",
          "927-2112",
          "927-2362",
          "927-2175",
          "927-2323",
          "927-2304",
          "927-2363",
          "927-2275",
          "927-2313",
          "927-2351",
          "927-2131",
          "927-2172",
          "927-2111",
          "927-2325",
          "927-2173",
          "927-2333",
          "927-2114",
          "927-2105",
          "927-2272",
          "927-2134",
          "927-2342",
          "927-2164",
          "927-2135",
          "927-2276",
          "927-2113",
          "927-2154",
          "927-2132",
          "927-2366",
          "927-2108",
          "927-2283",
          "927-2146",
          "927-2312",
          "927-2101",
          "927-2126",
          "927-2151",
          "927-2122",
          "927-2124",
          "927-2155",
          "927-2174",
          "927-2152",
          "927-2153",
          "927-2167",
          "927-2355",
          "927-2301",
          "927-2127",
          "927-2125",
          "927-2138",
          "927-2324",
          "927-2271",
          "927-2365",
          "927-2103",
          "927-2277",
          "927-2171",
          "927-2115",
          "927-2156",
          "927-2284",
          "927-2302",
          "927-2104",
          "927-2136",
          "927-2285",
          "927-2161",
          "927-2176",
          "927-2331",
          "928-0024",
          "929-2364",
          "928-0014",
          "928-0042",
          "928-0012",
          "928-0071",
          "927-1200",
          "927-1214",
          "927-1303",
          "927-1211",
          "927-1216",
          "927-1217",
          "927-1215",
          "927-1321",
          "927-1446",
          "927-1323",
          "927-1445",
          "927-1444",
          "927-1447",
          "927-1212",
          "927-1302",
          "927-1324",
          "927-1202",
          "927-1201",
          "927-1205",
          "927-1207",
          "927-1206",
          "927-1203",
          "927-1301",
          "927-1204",
          "927-1322",
          "927-1325",
          "927-1213",
          "927-1442",
          "927-1441",
          "927-1443",
          "927-1222",
          "927-1223",
          "927-1227",
          "927-1228",
          "927-1221",
          "927-1225",
          "927-1226",
          "927-1224",
          "927-1326",
          "927-1304",
          "927-1452",
          "927-1454",
          "927-1457",
          "927-1456",
          "927-1462",
          "927-1451",
          "927-1466",
          "927-1468",
          "927-1465",
          "927-1455",
          "927-1461",
          "927-1464",
          "927-1467",
          "927-1463",
          "927-1453",
          "927-1237",
          "927-1314",
          "927-1311",
          "927-1317",
          "927-1318",
          "927-1234",
          "927-1315",
          "927-1231",
          "927-1233",
          "927-1316",
          "927-1236",
          "927-1235",
          "927-1238",
          "927-1232",
          "927-1312",
          "927-1239",
          "927-1313",
          "927-1319",
          "922-0000",
          "922-0337",
          "922-0278",
          "922-0406",
          "922-0403",
          "922-0331",
          "922-0411",
          "922-0312",
          "922-0302",
          "922-0222",
          "922-0322",
          "922-0425",
          "922-0856",
          "922-0445",
          "922-0553",
          "922-0428",
          "922-0271",
          "922-0262",
          "922-0305",
          "922-0564",
          "922-0412",
          "922-0414",
          "922-0273",
          "922-0013",
          "922-0241",
          "922-0277",
          "922-0276",
          "922-0314",
          "922-0307",
          "922-0434",
          "922-0435",
          "922-0842",
          "922-0565",
          "922-0823",
          "922-0326",
          "922-0404",
          "922-0266",
          "922-0413",
          "922-0424",
          "922-0831",
          "922-0311",
          "922-0423",
          "922-0446",
          "922-0673",
          "922-0441",
          "922-0442",
          "922-0402",
          "922-0315",
          "922-0012",
          "922-0332",
          "922-0836",
          "922-0401",
          "922-0822",
          "922-0264",
          "922-0833",
          "922-0825",
          "922-0061",
          "922-0022",
          "922-0028",
          "922-0004",
          "922-0034",
          "922-0036",
          "922-0863",
          "922-0042",
          "922-0001",
          "922-0802",
          "922-0803",
          "922-0806",
          "922-0005",
          "922-0003",
          "922-0037",
          "922-0011",
          "922-0056",
          "922-0032",
          "922-0046",
          "922-0026",
          "922-0064",
          "922-0055",
          "922-0851",
          "922-0031",
          "922-0043",
          "922-0841",
          "922-0002",
          "922-0065",
          "922-0068",
          "922-0021",
          "922-0063",
          "922-0807",
          "922-0805",
          "922-0861",
          "922-0045",
          "922-0815",
          "922-0814",
          "922-0801",
          "922-0671",
          "922-0053",
          "922-0812",
          "922-0023",
          "922-0035",
          "922-0054",
          "922-0007",
          "922-0066",
          "922-0804",
          "922-0051",
          "922-0047",
          "922-0024",
          "922-0862",
          "922-0864",
          "922-0865",
          "922-0057",
          "922-0048",
          "922-0067",
          "922-0816",
          "922-0044",
          "922-0052",
          "922-0006",
          "922-0033",
          "922-0041",
          "922-0062",
          "922-0853",
          "922-0852",
          "922-0811",
          "922-0025",
          "922-0027",
          "922-0038",
          "922-0813",
          "922-0843",
          "922-0562",
          "922-0301",
          "922-0552",
          "922-0855",
          "922-0313",
          "922-0333",
          "922-0405",
          "922-0426",
          "922-0427",
          "922-0832",
          "922-0263",
          "922-0421",
          "922-0306",
          "922-0014",
          "922-0857",
          "922-0324",
          "922-0335",
          "922-0821",
          "922-0334",
          "922-0433",
          "922-0443",
          "922-0437",
          "922-0844",
          "922-0303",
          "922-0554",
          "922-0432",
          "922-0824",
          "922-0566",
          "922-0325",
          "922-0267",
          "922-0304",
          "922-0274",
          "922-0275",
          "922-0015",
          "922-0835",
          "922-0436",
          "922-0316",
          "922-0221",
          "922-0854",
          "922-0551",
          "922-0265",
          "922-0834",
          "922-0444",
          "922-0561",
          "922-0321",
          "922-0242",
          "922-0247",
          "922-0254",
          "922-0257",
          "922-0252",
          "922-0255",
          "922-0244",
          "922-0246",
          "922-0256",
          "922-0253",
          "922-0243",
          "922-0258",
          "922-0245",
          "922-0251",
          "922-0250",
          "922-0431",
          "922-0104",
          "922-0134",
          "922-0105",
          "922-0135",
          "922-0117",
          "922-0107",
          "922-0108",
          "922-0106",
          "922-0126",
          "922-0137",
          "922-0118",
          "922-0138",
          "922-0136",
          "922-0128",
          "922-0125",
          "922-0131",
          "922-0127",
          "922-0139",
          "922-0133",
          "922-0111",
          "922-0101",
          "922-0132",
          "922-0112",
          "922-0116",
          "922-0102",
          "922-0103",
          "922-0113",
          "922-0114",
          "922-0121",
          "922-0115",
          "922-0129",
          "922-0109",
          "922-0123",
          "922-0124",
          "922-0122",
          "922-0563",
          "922-0422",
          "922-0336",
          "922-0261",
          "922-0672",
          "922-0323",
          "925-0000",
          "925-0045",
          "925-0034",
          "925-0043",
          "925-0026",
          "925-0004",
          "925-0613",
          "925-0605",
          "925-0611",
          "925-0015",
          "925-0025",
          "929-1572",
          "925-0625",
          "925-0612",
          "929-1576",
          "929-1575",
          "925-0014",
          "925-0607",
          "925-0011",
          "925-0033",
          "925-0047",
          "929-1574",
          "925-0003",
          "925-0624",
          "925-0616",
          "925-0001",
          "925-0051",
          "929-1571",
          "925-0604",
          "925-0606",
          "925-0044",
          "925-0601",
          "925-0028",
          "925-0602",
          "925-0626",
          "925-0002",
          "925-0005",
          "925-0012",
          "925-0052",
          "925-0615",
          "925-0054",
          "925-0042",
          "925-0617",
          "925-0027",
          "925-0614",
          "925-0017",
          "925-0016",
          "929-1577",
          "925-0013",
          "925-0032",
          "925-0031",
          "925-0621",
          "925-0046",
          "925-0022",
          "925-0603",
          "925-0622",
          "925-0623",
          "925-0035",
          "925-0048",
          "925-0036",
          "925-0608",
          "925-0024",
          "925-0053",
          "925-0018",
          "925-0049",
          "925-0021",
          "929-1573",
          "925-0041",
          "925-0023",
          "929-1100",
          "929-1175",
          "929-1121",
          "929-1214",
          "929-1126",
          "929-1125",
          "929-1102",
          "929-1127",
          "929-1210",
          "929-1104",
          "929-1115",
          "929-1114",
          "929-1206",
          "929-1171",
          "929-1111",
          "929-1203",
          "929-1113",
          "929-1116",
          "929-1177",
          "929-1208",
          "929-1176",
          "929-1215",
          "929-1112",
          "929-1103",
          "929-1173",
          "929-1212",
          "929-1213",
          "929-1207",
          "929-1122",
          "929-1201",
          "929-1202",
          "929-1117",
          "929-1174",
          "929-1211",
          "929-1172",
          "929-1204",
          "929-1123",
          "929-1105",
          "929-1101",
          "929-1205",
          "924-0000",
          "920-2367",
          "924-0081",
          "924-0022",
          "924-0819",
          "920-2132",
          "924-0004",
          "924-0019",
          "924-0888",
          "920-2356",
          "924-0056",
          "920-2332",
          "924-0037",
          "920-2151",
          "920-2148",
          "920-2141",
          "924-0058",
          "924-0806",
          "924-0807",
          "929-0211",
          "924-0005",
          "920-2327",
          "924-0803",
          "920-2154",
          "924-0827",
          "924-0847",
          "924-0835",
          "920-2144",
          "924-0067",
          "920-2333",
          "924-0826",
          "920-2335",
          "920-2103",
          "924-0062",
          "924-0063",
          "929-0206",
          "924-0876",
          "929-0201",
          "924-0043",
          "920-2355",
          "920-2341",
          "920-2338",
          "924-0066",
          "924-0035",
          "924-0846",
          "920-2375",
          "924-0828",
          "924-0853",
          "920-2344",
          "920-2373",
          "920-2315",
          "920-2318",
          "920-2312",
          "920-2304",
          "920-2316",
          "920-2301",
          "920-2313",
          "920-2305",
          "920-2317",
          "920-2311",
          "920-2314",
          "920-2303",
          "920-2302",
          "920-2306",
          "920-2346",
          "924-0055",
          "924-0030",
          "924-0039",
          "924-0024",
          "920-2326",
          "920-2325",
          "924-0007",
          "924-0865",
          "924-0866",
          "924-0064",
          "920-2502",
          "924-0842",
          "924-0052",
          "924-0821",
          "924-0817",
          "924-0851",
          "924-0034",
          "920-2357",
          "924-0014",
          "920-2337",
          "920-2102",
          "920-2322",
          "920-2114",
          "920-2143",
          "924-0065",
          "920-2164",
          "920-2163",
          "924-0845",
          "924-0038",
          "920-2503",
          "920-2374",
          "920-2342",
          "920-2501",
          "920-2115",
          "924-0015",
          "924-0020",
          "924-0878",
          "929-0213",
          "924-0825",
          "920-2364",
          "920-2372",
          "920-2331",
          "920-2323",
          "924-0802",
          "924-0028",
          "924-0027",
          "920-2101",
          "924-0021",
          "924-0824",
          "924-0875",
          "924-0801",
          "920-2155",
          "924-0867",
          "920-2324",
          "929-0214",
          "924-0072",
          "924-0073",
          "924-0074",
          "920-2104",
          "920-2111",
          "920-2125",
          "920-2133",
          "920-2127",
          "920-2166",
          "920-2128",
          "920-2126",
          "920-2124",
          "920-2122",
          "920-2123",
          "920-2112",
          "920-2129",
          "920-2121",
          "920-2134",
          "924-0854",
          "920-2368",
          "929-0212",
          "920-2162",
          "924-0804",
          "924-0071",
          "924-0885",
          "920-2165",
          "924-0818",
          "924-0036",
          "920-2116",
          "924-0848",
          "924-0003",
          "924-0811",
          "920-2339",
          "924-0029",
          "920-2147",
          "924-0877",
          "924-0810",
          "924-0023",
          "924-0045",
          "924-0044",
          "920-2343",
          "924-0871",
          "924-0046",
          "924-0047",
          "929-0202",
          "924-0808",
          "920-2161",
          "920-2352",
          "924-0863",
          "924-0814",
          "924-0812",
          "929-0205",
          "924-0002",
          "924-0001",
          "924-0864",
          "924-0013",
          "924-0856",
          "924-0883",
          "924-0042",
          "924-0887",
          "924-0884",
          "924-0886",
          "920-2336",
          "924-0041",
          "920-2353",
          "920-2153",
          "920-2168",
          "920-2146",
          "929-0204",
          "924-0026",
          "924-0841",
          "920-2371",
          "920-2334",
          "920-2142",
          "924-0813",
          "924-0858",
          "924-0051",
          "924-0059",
          "924-0857",
          "924-0012",
          "920-2347",
          "924-0831",
          "924-0832",
          "924-0025",
          "920-2167",
          "924-0872",
          "920-2363",
          "920-2362",
          "924-0076",
          "924-0823",
          "924-0057",
          "924-0815",
          "929-0221",
          "929-0235",
          "929-0223",
          "929-0234",
          "929-0222",
          "929-0232",
          "929-0224",
          "929-0233",
          "929-0215",
          "929-0216",
          "929-0231",
          "920-2365",
          "920-2361",
          "924-0820",
          "924-0048",
          "924-0855",
          "924-0822",
          "924-0053",
          "920-2354",
          "920-2345",
          "929-0217",
          "924-0016",
          "924-0018",
          "924-0017",
          "924-0069",
          "924-0068",
          "924-0061",
          "924-0033",
          "924-0816",
          "920-2145",
          "924-0833",
          "924-0006",
          "924-0031",
          "924-0032",
          "920-2152",
          "920-2131",
          "924-0834",
          "924-0862",
          "924-0843",
          "924-0838",
          "924-0881",
          "924-0882",
          "920-2351",
          "924-0836",
          "920-2113",
          "924-0873",
          "924-0011",
          "924-0861",
          "924-0837",
          "920-2321",
          "924-0874",
          "924-0852",
          "924-0075",
          "924-0054",
          "924-0844",
          "929-0203",
          "920-2376",
          "924-0805",
          "920-2366",
          "923-1100",
          "923-1101",
          "929-0101",
          "923-1103",
          "923-1211",
          "923-1202",
          "923-1233",
          "923-1105",
          "923-1111",
          "923-1201",
          "923-1207",
          "923-1113",
          "923-1212",
          "923-1115",
          "929-0122",
          "923-1231",
          "923-1237",
          "923-1236",
          "923-1246",
          "923-1234",
          "929-0103",
          "923-1114",
          "923-1116",
          "923-1214",
          "923-1112",
          "923-1124",
          "923-1232",
          "923-1238",
          "929-0115",
          "923-1102",
          "923-1117",
          "929-0113",
          "929-0116",
          "923-1215",
          "923-1245",
          "923-1213",
          "923-1247",
          "923-1121",
          "923-1223",
          "929-0125",
          "923-1222",
          "923-1235",
          "923-1206",
          "923-1204",
          "929-0105",
          "929-0104",
          "929-0123",
          "923-1216",
          "929-0102",
          "929-0106",
          "929-0108",
          "929-0114",
          "929-0124",
          "923-1122",
          "923-1242",
          "929-0107",
          "929-0112",
          "923-1217",
          "923-1225",
          "923-1107",
          "923-1203",
          "923-1243",
          "923-1226",
          "923-1205",
          "929-0126",
          "923-1241",
          "923-1104",
          "923-1221",
          "929-0121",
          "929-0111",
          "923-1123",
          "923-1244",
          "923-1224",
          "923-1227",
          "923-1208",
          "923-1106",
          "921-0000",
          "921-8823",
          "921-8805",
          "921-8812",
          "921-8801",
          "921-8803",
          "921-8802",
          "921-8835",
          "921-8837",
          "921-8846",
          "921-8849",
          "921-8841",
          "921-8825",
          "921-8831",
          "921-8824",
          "921-8836",
          "921-8814",
          "921-8813",
          "921-8811",
          "921-8843",
          "921-8845",
          "921-8842",
          "921-8832",
          "921-8834",
          "921-8808",
          "921-8804",
          "921-8821",
          "921-8833",
          "921-8809",
          "921-8807",
          "921-8844",
          "921-8815",
          "921-8806",
          "921-8848",
          "921-8822",
          "921-8817",
          "921-8847",
          "921-8816",
          "923-1200",
          "923-1278",
          "923-1265",
          "923-1269",
          "923-1262",
          "923-1274",
          "923-1275",
          "923-1254",
          "923-1253",
          "923-1272",
          "923-1263",
          "923-1266",
          "923-1271",
          "923-1276",
          "923-1277",
          "923-1261",
          "923-1251",
          "923-1252",
          "923-1267",
          "923-1273",
          "923-1264",
          "923-1268",
          "929-0300",
          "929-0437",
          "929-0324",
          "929-0436",
          "929-0447",
          "929-0344",
          "929-0403",
          "929-0311",
          "929-0462",
          "929-0335",
          "929-0445",
          "929-0453",
          "929-0303",
          "929-0301",
          "929-0405",
          "929-0415",
          "929-0431",
          "929-0345",
          "929-0442",
          "929-0404",
          "929-0467",
          "929-0325",
          "929-0402",
          "929-0346",
          "929-0309",
          "929-0304",
          "929-0422",
          "929-0314",
          "929-0321",
          "929-0416",
          "929-0334",
          "929-0411",
          "929-0342",
          "929-0432",
          "929-0302",
          "929-0306",
          "929-0455",
          "929-0413",
          "929-0444",
          "929-0333",
          "929-0328",
          "929-0406",
          "929-0312",
          "929-0435",
          "929-0417",
          "929-0456",
          "929-0425",
          "929-0326",
          "929-0305",
          "929-0423",
          "929-0424",
          "929-0315",
          "929-0327",
          "929-0434",
          "929-0454",
          "929-0426",
          "929-0307",
          "929-0452",
          "929-0412",
          "929-0323",
          "929-0427",
          "929-0465",
          "929-0407",
          "929-0332",
          "929-0331",
          "929-0313",
          "929-0319",
          "929-0461",
          "929-0421",
          "929-0441",
          "929-0401",
          "929-0443",
          "929-0308",
          "929-0316",
          "929-0322",
          "929-0343",
          "929-0433",
          "929-0451",
          "929-0446",
          "929-0317",
          "929-0414",
          "929-0464",
          "929-0341",
          "929-0466",
          "929-0318",
          "929-0463",
          "920-0200",
          "920-0273",
          "920-0275",
          "920-0266",
          "920-0272",
          "920-0263",
          "920-0269",
          "920-0265",
          "920-0267",
          "920-0277",
          "920-0271",
          "920-0262",
          "920-0268",
          "920-0276",
          "920-0264",
          "920-0274",
          "920-0261",
          "925-0100",
          "925-0454",
          "925-0574",
          "925-0161",
          "925-0426",
          "925-0121",
          "925-0132",
          "925-0166",
          "925-0146",
          "925-0307",
          "925-0215",
          "925-0563",
          "925-0432",
          "925-0424",
          "925-0145",
          "925-0201",
          "925-0385",
          "925-0423",
          "925-0134",
          "925-0165",
          "925-0435",
          "925-0163",
          "925-0133",
          "925-0383",
          "925-0164",
          "925-0434",
          "925-0575",
          "925-0147",
          "925-0436",
          "925-0562",
          "925-0155",
          "925-0565",
          "925-0168",
          "925-0152",
          "925-0457",
          "925-0421",
          "925-0306",
          "925-0122",
          "925-0207",
          "925-0373",
          "925-0384",
          "925-0382",
          "925-0571",
          "925-0572",
          "925-0573",
          "925-0566",
          "925-0564",
          "925-0577",
          "925-0453",
          "925-0313",
          "925-0576",
          "925-0202",
          "925-0422",
          "925-0153",
          "925-0371",
          "925-0203",
          "925-0154",
          "925-0456",
          "925-0427",
          "925-0431",
          "925-0561",
          "925-0141",
          "925-0136",
          "925-0213",
          "925-0437",
          "925-0206",
          "925-0381",
          "925-0144",
          "925-0345",
          "925-0445",
          "925-0444",
          "925-0443",
          "925-0446",
          "925-0448",
          "925-0447",
          "925-0212",
          "925-0425",
          "925-0452",
          "925-0148",
          "925-0376",
          "925-0314",
          "925-0455",
          "925-0304",
          "925-0151",
          "925-0124",
          "925-0125",
          "925-0135",
          "925-0372",
          "925-0214",
          "925-0442",
          "925-0303",
          "925-0301",
          "925-0441",
          "925-0137",
          "925-0142",
          "925-0315",
          "925-0305",
          "925-0205",
          "925-0157",
          "925-0578",
          "925-0204",
          "925-0167",
          "925-0302",
          "925-0374",
          "925-0312",
          "925-0162",
          "925-0156",
          "925-0211",
          "925-0123",
          "925-0311",
          "925-0438",
          "925-0143",
          "925-0451",
          "925-0131",
          "925-0375",
          "925-0433",
          "929-1300",
          "929-1313",
          "929-1406",
          "929-1344",
          "929-1345",
          "929-1312",
          "929-1321",
          "929-1405",
          "929-1343",
          "929-1426",
          "929-1412",
          "929-1413",
          "929-1323",
          "929-1303",
          "929-1332",
          "929-1331",
          "929-1314",
          "929-1425",
          "929-1414",
          "929-1415",
          "929-1402",
          "929-1341",
          "929-1403",
          "929-1404",
          "929-1423",
          "929-1422",
          "939-0171",
          "929-1305",
          "929-1325",
          "929-1416",
          "929-1316",
          "929-1315",
          "929-1421",
          "929-1326",
          "929-1301",
          "929-1324",
          "929-1322",
          "929-1304",
          "929-1342",
          "929-1401",
          "929-1333",
          "929-1327",
          "929-1311",
          "929-1411",
          "929-1302",
          "929-1424",
          "929-1700",
          "929-1816",
          "929-1813",
          "929-1804",
          "929-1721",
          "929-1713",
          "929-1702",
          "929-1724",
          "929-1722",
          "929-1521",
          "929-1606",
          "929-1701",
          "929-1631",
          "929-1801",
          "929-1716",
          "929-1636",
          "929-1632",
          "929-1726",
          "929-1605",
          "929-1712",
          "929-1704",
          "929-1812",
          "929-1706",
          "929-1815",
          "929-1637",
          "929-1635",
          "929-1802",
          "929-1805",
          "929-1817",
          "929-1603",
          "929-1803",
          "929-1601",
          "929-1811",
          "929-1818",
          "929-1602",
          "929-1604",
          "929-1714",
          "929-1705",
          "929-1814",
          "929-1703",
          "929-1725",
          "929-1711",
          "929-1715",
          "929-1634",
          "929-1633",
          "929-1723",
          "929-1717",
          "927-0000",
          "927-0006",
          "927-0003",
          "927-0235",
          "927-0007",
          "927-0205",
          "927-0031",
          "927-0025",
          "927-0042",
          "927-0054",
          "927-0048",
          "927-0215",
          "927-0026",
          "927-0207",
          "927-0032",
          "927-0051",
          "927-0038",
          "927-0014",
          "927-0049",
          "927-0223",
          "927-0211",
          "927-0056",
          "927-0047",
          "927-0008",
          "927-0027",
          "927-0045",
          "927-0022",
          "927-0011",
          "927-0053",
          "927-0001",
          "927-0212",
          "927-0046",
          "927-0214",
          "927-0234",
          "927-0043",
          "927-0224",
          "927-0035",
          "927-0213",
          "927-0055",
          "927-0021",
          "927-0057",
          "927-0013",
          "927-0002",
          "927-0039",
          "927-0004",
          "927-0221",
          "927-0222",
          "927-0201",
          "927-0041",
          "927-0015",
          "927-0016",
          "927-0034",
          "927-0037",
          "927-0225",
          "927-0058",
          "927-0017",
          "927-0203",
          "927-0005",
          "927-0232",
          "927-0009",
          "927-0052",
          "927-0012",
          "927-0202",
          "927-0036",
          "927-0206",
          "927-0033",
          "927-0204",
          "927-0023",
          "927-0233",
          "927-0231",
          "927-0024",
          "927-0044",
          "927-0400",
          "927-0612",
          "927-0551",
          "928-0332",
          "928-0306",
          "927-0626",
          "927-0554",
          "927-0444",
          "927-0452",
          "927-0302",
          "927-0433",
          "927-0432",
          "927-0435",
          "927-0431",
          "927-0608",
          "927-0564",
          "927-0325",
          "928-0335",
          "927-0303",
          "927-0553",
          "927-0552",
          "928-0302",
          "927-0613",
          "927-0304",
          "927-0324",
          "927-0621",
          "928-0301",
          "928-0325",
          "928-0308",
          "928-0312",
          "927-0313",
          "928-0336",
          "928-0305",
          "927-0611",
          "928-0303",
          "927-0625",
          "928-0307",
          "927-0604",
          "928-0333",
          "927-0601",
          "928-0311",
          "928-0323",
          "928-0326",
          "927-0434",
          "927-0323",
          "928-0314",
          "927-0301",
          "928-0321",
          "927-0607",
          "927-0609",
          "928-0304",
          "927-0454",
          "927-0627",
          "927-0605",
          "927-0453",
          "928-0322",
          "928-0313",
          "928-0334",
          "927-0624",
          "927-0315",
          "928-0324",
          "927-0603",
          "927-0442",
          "927-0561",
          "927-0555",
          "927-0565",
          "927-0563",
          "927-0441",
          "927-0451",
          "927-0622",
          "927-0312",
          "927-0602",
          "927-0321",
          "927-0562",
          "927-0614",
          "927-0311",
          "927-0615",
          "927-0322",
          "927-0305",
          "928-0331",
          "927-0443",
          "927-0314",
          "927-0623",
          "927-0606",
          "918-0000",
          "910-3614",
          "910-3556",
          "910-2475",
          "918-8052",
          "910-2357",
          "910-3605",
          "910-3266",
          "910-2463",
          "918-8007",
          "918-8006",
          "918-8183",
          "918-8181",
          "918-8182",
          "910-0104",
          "910-2152",
          "910-2151",
          "918-8153",
          "910-0124",
          "910-3525",
          "910-0041",
          "910-3402",
          "910-2172",
          "910-2171",
          "918-8232",
          "910-3251",
          "918-8067",
          "910-0014",
          "910-0013",
          "910-3555",
          "910-3106",
          "919-0314",
          "910-3133",
          "910-3137",
          "910-3123",
          "910-0125",
          "910-0122",
          "910-0817",
          "918-8104",
          "918-8103",
          "910-3262",
          "910-2222",
          "910-3125",
          "918-8101",
          "910-3383",
          "910-0156",
          "910-0155",
          "910-0154",
          "910-2177",
          "918-8213",
          "918-8152",
          "919-0303",
          "918-8217",
          "910-3118",
          "910-0134",
          "910-0135",
          "910-0055",
          "910-2227",
          "910-2223",
          "918-8114",
          "910-2211",
          "910-3522",
          "910-3116",
          "918-8111",
          "918-8046",
          "910-3113",
          "918-8175",
          "918-8016",
          "910-0047",
          "918-8025",
          "918-8035",
          "918-8207",
          "910-2175",
          "910-3371",
          "910-2213",
          "918-8018",
          "918-8063",
          "919-0323",
          "910-3253",
          "910-0005",
          "910-3255",
          "919-0327",
          "918-8116",
          "910-3551",
          "910-0016",
          "910-2334",
          "919-0316",
          "910-3634",
          "910-3515",
          "910-0836",
          "910-0802",
          "918-8228",
          "910-3268",
          "918-8071",
          "910-2465",
          "910-3404",
          "918-8226",
          "910-3621",
          "918-8053",
          "910-2474",
          "910-0842",
          "910-0841",
          "910-3265",
          "910-0028",
          "910-0022",
          "910-2205",
          "910-3516",
          "910-3622",
          "918-8108",
          "918-8107",
          "910-3603",
          "910-3611",
          "918-8166",
          "910-0856",
          "910-2156",
          "918-8061",
          "918-8133",
          "918-8081",
          "918-8174",
          "918-8203",
          "919-0322",
          "910-3633",
          "910-2174",
          "910-0826",
          "910-2144",
          "919-0302",
          "910-0142",
          "910-0141",
          "918-8132",
          "910-3644",
          "910-3553",
          "918-8057",
          "918-8054",
          "918-8058",
          "910-0105",
          "910-0132",
          "910-0102",
          "910-3136",
          "910-2462",
          "910-0042",
          "918-8212",
          "910-3385",
          "910-0045",
          "910-0815",
          "910-0814",
          "918-8072",
          "919-0318",
          "919-0317",
          "918-8205",
          "918-8206",
          "918-8105",
          "918-8106",
          "918-8043",
          "910-2153",
          "910-3147",
          "910-0012",
          "910-0011",
          "910-3264",
          "918-8047",
          "910-3145",
          "910-3401",
          "910-3518",
          "910-3552",
          "910-2356",
          "910-3604",
          "910-0137",
          "910-0136",
          "910-3107",
          "910-0052",
          "918-8112",
          "918-8113",
          "918-8003",
          "910-0822",
          "918-8221",
          "910-0021",
          "918-8131",
          "910-2353",
          "910-2352",
          "918-8233",
          "918-8223",
          "918-8033",
          "910-3267",
          "918-8218",
          "910-0026",
          "910-0051",
          "910-3613",
          "910-3102",
          "910-3112",
          "918-8083",
          "910-3405",
          "910-3122",
          "910-3617",
          "910-2212",
          "910-3146",
          "910-2347",
          "910-0151",
          "918-8222",
          "910-3645",
          "910-0126",
          "910-0121",
          "910-0056",
          "910-0057",
          "918-8002",
          "910-3121",
          "910-0033",
          "910-0036",
          "918-8078",
          "910-2201",
          "918-8176",
          "918-8164",
          "910-2224",
          "910-2143",
          "910-0823",
          "910-0043",
          "910-0048",
          "910-3635",
          "910-2348",
          "910-2148",
          "910-0845",
          "910-3623",
          "910-0821",
          "910-3111",
          "910-3607",
          "910-3601",
          "910-3646",
          "910-3612",
          "918-8134",
          "918-8017",
          "918-8082",
          "918-8062",
          "918-8173",
          "918-8037",
          "919-0321",
          "910-3632",
          "910-2173",
          "919-0373",
          "918-8211",
          "910-2146",
          "919-0301",
          "910-0146",
          "910-0143",
          "910-0145",
          "910-0144",
          "910-0147",
          "918-8135",
          "910-3513",
          "910-0023",
          "910-2147",
          "910-2155",
          "910-2166",
          "910-0853",
          "910-3117",
          "918-8163",
          "910-3148",
          "910-3101",
          "910-3131",
          "910-3511",
          "910-3403",
          "910-3557",
          "918-8227",
          "918-8036",
          "910-0812",
          "919-0328",
          "910-0833",
          "910-0838",
          "910-0832",
          "910-2346",
          "918-8172",
          "918-8077",
          "910-0034",
          "910-0035",
          "918-8155",
          "910-3143",
          "910-3141",
          "918-8239",
          "910-3115",
          "918-8234",
          "910-0001",
          "918-8202",
          "910-2141",
          "910-0805",
          "910-0804",
          "910-0806",
          "910-0807",
          "910-0070",
          "910-3374",
          "910-2226",
          "918-8044",
          "910-0107",
          "910-0837",
          "910-0803",
          "910-3643",
          "910-3602",
          "919-0311",
          "910-2225",
          "910-3606",
          "918-8031",
          "919-0304",
          "910-3124",
          "910-0044",
          "910-3128",
          "910-0018",
          "910-3521",
          "910-0006",
          "918-8011",
          "910-0101",
          "918-8001",
          "910-0053",
          "918-8068",
          "918-8162",
          "910-3615",
          "910-3114",
          "910-3138",
          "910-0858",
          "910-0801",
          "910-0024",
          "910-0025",
          "918-8216",
          "918-8136",
          "918-8231",
          "910-2176",
          "910-2165",
          "910-0818",
          "910-3252",
          "910-0063",
          "910-0062",
          "910-2178",
          "918-8165",
          "919-0305",
          "910-2202",
          "910-2163",
          "910-0027",
          "910-0857",
          "918-8151",
          "910-3263",
          "910-0813",
          "910-0103",
          "918-8186",
          "910-0816",
          "918-8185",
          "910-2145",
          "910-0811",
          "910-3256",
          "910-3127",
          "910-2464",
          "910-3384",
          "910-0844",
          "918-8034",
          "910-3142",
          "910-2221",
          "910-2336",
          "910-2355",
          "910-3261",
          "918-8102",
          "910-2466",
          "919-0313",
          "910-0843",
          "910-0855",
          "918-8064",
          "918-8004",
          "910-2471",
          "918-8041",
          "910-2157",
          "918-8023",
          "918-8022",
          "910-2203",
          "910-3105",
          "910-3373",
          "910-3372",
          "919-0315",
          "910-3512",
          "910-0037",
          "910-0029",
          "910-0067",
          "910-0064",
          "910-0015",
          "910-2335",
          "910-2333",
          "910-2332",
          "910-2331",
          "918-8075",
          "910-3517",
          "918-8224",
          "918-8187",
          "918-8014",
          "918-8013",
          "918-8015",
          "910-3554",
          "918-8012",
          "910-3132",
          "910-3377",
          "910-3134",
          "910-0828",
          "910-0829",
          "910-0825",
          "910-0019",
          "919-0326",
          "910-2354",
          "918-8214",
          "919-0312",
          "910-2341",
          "910-2472",
          "918-8042",
          "910-2154",
          "910-2342",
          "910-0138",
          "918-8156",
          "910-0859",
          "910-3641",
          "910-3126",
          "910-0049",
          "910-2164",
          "918-8045",
          "918-8027",
          "910-2214",
          "910-0827",
          "910-3523",
          "910-3104",
          "919-0325",
          "910-3526",
          "918-8026",
          "910-0109",
          "910-0808",
          "910-0069",
          "910-0068",
          "910-0061",
          "910-0809",
          "918-8154",
          "910-0152",
          "910-0153",
          "910-0017",
          "918-8115",
          "910-3524",
          "910-0004",
          "918-8161",
          "918-8074",
          "919-0324",
          "910-0032",
          "910-0031",
          "918-8076",
          "918-8024",
          "910-2142",
          "918-8184",
          "910-3616",
          "910-0002",
          "910-3382",
          "910-0852",
          "910-0003",
          "910-2345",
          "910-0824",
          "910-0834",
          "910-0835",
          "918-8188",
          "910-3144",
          "918-8065",
          "910-3514",
          "910-0038",
          "910-0039",
          "910-3608",
          "918-8032",
          "910-3386",
          "910-0046",
          "910-2343",
          "910-2461",
          "910-2344",
          "910-2162",
          "918-8204",
          "918-8201",
          "910-3381",
          "918-8005",
          "910-3103",
          "910-3375",
          "918-8225",
          "910-2204",
          "910-2351",
          "910-0854",
          "910-0106",
          "910-3376",
          "910-3378",
          "910-3642",
          "918-8051",
          "918-8171",
          "918-8021",
          "910-0158",
          "910-0157",
          "910-0123",
          "910-2337",
          "910-2338",
          "910-2339",
          "910-0054",
          "918-8073",
          "910-2167",
          "910-0066",
          "910-0065",
          "910-3558",
          "910-3636",
          "918-8009",
          "910-0108",
          "910-3254",
          "918-8008",
          "910-2473",
          "910-2206",
          "910-2207",
          "910-2208",
          "910-0846",
          "910-0851",
          "910-3135",
          "918-8215",
          "910-0831",
          "918-8055",
          "918-8056",
          "910-2161",
          "918-8066",
          "918-8238",
          "918-8236",
          "918-8235",
          "918-8237",
          "910-3631",
          "914-0000",
          "914-0062",
          "914-0272",
          "914-0075",
          "914-0266",
          "914-0315",
          "914-0265",
          "914-0141",
          "914-0014",
          "914-0004",
          "914-0042",
          "914-0021",
          "914-0124",
          "914-0301",
          "914-0267",
          "914-0805",
          "914-0844",
          "914-0003",
          "914-0843",
          "914-0825",
          "914-0268",
          "914-0303",
          "914-0018",
          "914-0262",
          "914-0044",
          "914-0316",
          "914-0311",
          "914-0032",
          "914-0034",
          "914-0006",
          "914-0063",
          "914-0005",
          "914-0146",
          "914-0055",
          "914-0072",
          "914-0066",
          "914-0012",
          "914-0015",
          "914-0039",
          "914-0814",
          "914-0043",
          "914-0026",
          "914-0052",
          "914-0821",
          "914-0822",
          "914-0138",
          "914-0831",
          "914-0823",
          "914-0059",
          "914-0131",
          "914-0802",
          "914-0813",
          "914-0045",
          "914-0132",
          "914-0077",
          "914-0038",
          "914-0144",
          "914-0078",
          "914-0143",
          "914-0071",
          "914-0271",
          "914-0832",
          "914-0812",
          "919-1279",
          "914-0054",
          "914-0317",
          "914-0001",
          "914-0803",
          "914-0122",
          "914-0264",
          "914-0314",
          "914-0136",
          "914-0147",
          "914-0312",
          "914-0273",
          "914-0022",
          "914-0305",
          "914-0007",
          "914-0841",
          "914-0031",
          "914-0013",
          "914-0811",
          "914-0056",
          "914-0074",
          "914-0845",
          "914-0073",
          "914-0036",
          "914-0047",
          "914-0313",
          "914-0028",
          "914-0046",
          "914-0135",
          "914-0834",
          "914-0041",
          "914-0833",
          "914-0121",
          "914-0145",
          "914-0142",
          "914-0033",
          "914-0002",
          "914-0824",
          "914-0302",
          "914-0025",
          "914-0137",
          "914-0057",
          "914-0023",
          "914-0304",
          "914-0017",
          "914-0835",
          "914-0815",
          "914-0061",
          "914-0051",
          "914-0053",
          "914-0065",
          "914-0801",
          "914-0807",
          "914-0806",
          "914-0274",
          "914-0058",
          "914-0037",
          "914-0133",
          "914-0079",
          "914-0011",
          "914-0842",
          "914-0261",
          "914-0076",
          "914-0134",
          "914-0035",
          "914-0306",
          "914-0064",
          "914-0263",
          "914-0016",
          "914-0024",
          "914-0027",
          "914-0125",
          "914-0123",
          "917-0000",
          "917-0037",
          "917-0041",
          "917-0105",
          "917-0106",
          "917-0044",
          "917-0238",
          "917-0241",
          "917-0027",
          "917-0005",
          "917-0071",
          "917-0104",
          "917-0234",
          "917-0113",
          "917-0096",
          "917-0077",
          "917-0017",
          "917-0221",
          "917-0078",
          "917-0223",
          "917-0004",
          "917-0034",
          "917-0046",
          "917-0032",
          "917-0055",
          "917-0057",
          "917-0085",
          "917-0062",
          "917-0056",
          "917-0053",
          "917-0052",
          "917-0067",
          "917-0058",
          "917-0066",
          "917-0059",
          "917-0083",
          "917-0063",
          "917-0086",
          "917-0051",
          "917-0069",
          "917-0087",
          "917-0065",
          "917-0088",
          "917-0064",
          "917-0061",
          "917-0082",
          "917-0068",
          "917-0084",
          "917-0357",
          "917-0112",
          "917-0003",
          "917-0116",
          "917-0045",
          "917-0242",
          "917-0356",
          "917-0022",
          "917-0036",
          "917-0248",
          "917-0081",
          "917-0025",
          "917-0014",
          "917-0002",
          "917-0035",
          "917-0012",
          "917-0015",
          "917-0047",
          "917-0107",
          "917-0231",
          "917-0006",
          "917-0019",
          "917-0236",
          "917-0103",
          "917-0235",
          "917-0355",
          "917-0007",
          "917-0246",
          "917-0095",
          "917-0244",
          "917-0008",
          "917-0222",
          "917-0033",
          "917-0021",
          "917-0233",
          "917-0351",
          "917-0101",
          "917-0224",
          "917-0026",
          "917-0013",
          "917-0072",
          "917-0245",
          "917-0016",
          "917-0232",
          "917-0117",
          "917-0247",
          "917-0011",
          "917-0111",
          "917-0043",
          "917-0091",
          "917-0028",
          "917-0074",
          "917-0042",
          "917-0226",
          "917-0352",
          "917-0353",
          "917-0001",
          "917-0054",
          "917-0023",
          "917-0115",
          "917-0097",
          "917-0225",
          "917-0018",
          "917-0094",
          "917-0093",
          "917-0075",
          "917-0249",
          "917-0237",
          "917-0102",
          "917-0031",
          "917-0092",
          "917-0076",
          "917-0073",
          "917-0243",
          "917-0114",
          "917-0024",
          "917-0354",
          "912-0000",
          "912-0068",
          "912-0205",
          "912-0201",
          "912-0063",
          "912-0035",
          "912-0134",
          "912-0086",
          "912-0206",
          "912-0054",
          "912-0091",
          "912-0826",
          "912-0404",
          "912-0072",
          "912-0424",
          "912-0067",
          "912-0813",
          "912-0435",
          "912-0005",
          "912-0132",
          "912-0001",
          "912-0144",
          "912-0146",
          "912-0204",
          "912-0416",
          "912-0147",
          "912-0217",
          "912-0202",
          "912-0053",
          "912-0026",
          "912-0814",
          "912-0074",
          "912-0151",
          "912-0216",
          "912-0076",
          "912-0064",
          "912-0221",
          "912-0094",
          "912-0087",
          "912-0218",
          "912-0824",
          "912-0402",
          "912-0143",
          "912-0043",
          "912-0071",
          "912-0412",
          "912-0421",
          "912-0433",
          "912-0002",
          "912-0133",
          "912-0047",
          "912-0044",
          "912-0422",
          "912-0061",
          "912-0815",
          "912-0152",
          "912-0215",
          "912-0075",
          "912-0432",
          "912-0431",
          "912-0065",
          "912-0211",
          "912-0207",
          "912-0822",
          "912-0095",
          "912-0423",
          "912-0006",
          "912-0041",
          "912-0801",
          "912-0085",
          "912-0825",
          "912-0802",
          "912-0027",
          "912-0046",
          "912-0092",
          "912-0032",
          "912-0055",
          "912-0827",
          "912-0062",
          "912-0031",
          "912-0811",
          "912-0805",
          "912-0084",
          "912-0415",
          "912-0145",
          "912-0013",
          "912-0803",
          "912-0812",
          "912-0016",
          "912-0411",
          "912-0023",
          "912-0437",
          "912-0004",
          "912-0021",
          "912-0214",
          "912-0015",
          "912-0014",
          "912-0093",
          "912-0821",
          "912-0007",
          "912-0003",
          "912-0155",
          "912-0024",
          "912-0436",
          "912-0426",
          "912-0213",
          "912-0203",
          "912-0414",
          "912-0212",
          "912-0141",
          "912-0138",
          "912-0137",
          "912-0222",
          "912-0154",
          "912-0042",
          "912-0017",
          "912-0413",
          "912-0051",
          "912-0425",
          "912-0073",
          "912-0149",
          "912-0139",
          "912-0434",
          "912-0153",
          "912-0025",
          "912-0136",
          "912-0036",
          "912-0033",
          "912-0088",
          "912-0066",
          "912-0011",
          "912-0131",
          "912-0142",
          "912-0083",
          "912-0081",
          "912-0405",
          "912-0403",
          "912-0804",
          "912-0135",
          "912-0427",
          "912-0008",
          "912-0148",
          "912-0082",
          "912-0052",
          "912-0022",
          "912-0012",
          "912-0401",
          "912-0034",
          "912-0045",
          "912-0823",
          "911-0000",
          "911-0817",
          "911-0803",
          "911-0045",
          "911-0041",
          "911-0047",
          "911-0048",
          "911-0043",
          "911-0042",
          "911-0046",
          "911-0044",
          "911-0812",
          "911-0813",
          "911-0816",
          "911-0834",
          "911-0833",
          "911-0836",
          "911-0831",
          "911-0835",
          "911-0832",
          "911-0811",
          "911-0815",
          "911-0051",
          "911-0055",
          "911-0053",
          "911-0052",
          "911-0056",
          "911-0054",
          "911-0001",
          "911-0004",
          "911-0002",
          "911-0003",
          "911-0005",
          "911-0006",
          "911-0035",
          "911-0033",
          "911-0801",
          "911-0846",
          "911-0847",
          "911-0842",
          "911-0843",
          "911-0848",
          "911-0844",
          "911-0841",
          "911-0845",
          "911-0802",
          "911-0034",
          "911-0805",
          "911-0031",
          "911-0011",
          "911-0017",
          "911-0015",
          "911-0014",
          "911-0013",
          "911-0012",
          "911-0016",
          "911-0823",
          "911-0824",
          "911-0825",
          "911-0828",
          "911-0821",
          "911-0826",
          "911-0827",
          "911-0822",
          "911-0806",
          "911-0022",
          "911-0026",
          "911-0025",
          "911-0024",
          "911-0023",
          "911-0021",
          "911-0804",
          "911-0032",
          "911-0814",
          "916-0000",
          "916-0025",
          "916-1224",
          "916-0057",
          "916-0083",
          "916-0082",
          "916-0081",
          "916-0076",
          "916-1114",
          "916-0008",
          "916-0075",
          "916-0085",
          "916-1102",
          "916-1115",
          "916-1104",
          "916-1233",
          "916-1223",
          "916-1231",
          "916-0066",
          "916-1235",
          "916-0037",
          "916-0055",
          "916-1111",
          "916-0016",
          "916-0074",
          "916-0088",
          "916-1116",
          "916-1222",
          "916-1237",
          "916-0029",
          "916-0062",
          "916-0064",
          "916-0084",
          "916-0028",
          "916-0044",
          "916-0018",
          "916-0027",
          "916-0043",
          "916-1234",
          "916-0021",
          "916-1232",
          "916-1106",
          "916-0071",
          "916-0067",
          "916-0038",
          "916-0034",
          "916-0073",
          "916-0035",
          "916-0017",
          "916-0042",
          "916-0005",
          "916-0056",
          "916-1101",
          "916-0004",
          "916-0003",
          "916-0087",
          "916-0024",
          "916-0011",
          "916-0065",
          "916-1113",
          "916-0013",
          "916-0014",
          "916-0063",
          "916-1107",
          "916-1112",
          "916-0033",
          "916-1133",
          "916-0078",
          "916-0006",
          "916-1221",
          "916-0023",
          "916-0068",
          "916-0031",
          "916-0041",
          "916-1236",
          "916-0012",
          "916-0053",
          "916-0061",
          "916-0052",
          "916-0072",
          "916-0032",
          "916-0054",
          "916-1225",
          "916-1103",
          "916-0026",
          "916-1118",
          "916-0019",
          "916-0007",
          "916-0022",
          "916-0045",
          "916-0015",
          "916-0051",
          "916-0047",
          "916-0046",
          "916-0036",
          "916-0001",
          "916-1105",
          "916-0086",
          "916-0002",
          "916-0077",
          "919-0600",
          "919-0814",
          "910-4273",
          "910-4102",
          "919-0614",
          "910-4112",
          "919-0615",
          "919-0621",
          "919-0623",
          "919-0721",
          "910-4111",
          "919-0735",
          "919-0722",
          "919-0742",
          "919-0724",
          "919-0628",
          "910-4104",
          "919-0812",
          "919-0732",
          "910-4134",
          "919-0616",
          "919-0749",
          "910-4272",
          "919-0634",
          "919-0748",
          "919-0744",
          "910-4146",
          "919-0733",
          "910-4115",
          "919-0736",
          "919-0723",
          "910-4147",
          "919-0612",
          "910-4142",
          "919-0737",
          "919-0731",
          "919-0817",
          "919-0726",
          "919-0804",
          "910-4122",
          "919-0727",
          "910-4138",
          "919-0604",
          "910-4276",
          "910-4275",
          "919-0745",
          "919-0602",
          "910-4145",
          "919-0815",
          "919-0611",
          "919-0631",
          "919-0805",
          "910-4124",
          "910-4141",
          "910-4132",
          "910-4131",
          "910-4133",
          "919-0741",
          "910-4144",
          "910-4137",
          "910-4277",
          "910-4127",
          "910-4126",
          "919-0802",
          "919-0811",
          "919-0633",
          "910-4271",
          "919-0632",
          "910-4123",
          "910-4274",
          "910-4121",
          "919-0746",
          "919-0734",
          "919-0803",
          "910-4103",
          "910-4105",
          "919-0613",
          "919-0801",
          "910-4125",
          "919-0725",
          "919-0747",
          "919-0743",
          "919-0806",
          "919-0603",
          "919-0813",
          "919-0816",
          "919-0601",
          "919-0807",
          "910-4113",
          "922-0679",
          "915-0000",
          "915-0202",
          "915-0064",
          "915-0256",
          "915-0214",
          "915-0025",
          "915-0069",
          "915-0045",
          "915-0242",
          "915-0241",
          "915-1242",
          "915-1201",
          "915-0801",
          "915-0023",
          "915-0873",
          "915-0216",
          "915-0095",
          "915-0861",
          "915-0035",
          "915-0016",
          "915-0233",
          "915-0096",
          "915-0865",
          "915-0235",
          "915-0863",
          "915-0234",
          "915-0218",
          "915-0015",
          "915-0228",
          "915-0885",
          "915-0884",
          "915-0042",
          "915-0835",
          "915-0083",
          "915-0054",
          "915-0877",
          "915-0893",
          "915-0812",
          "915-0011",
          "915-0882",
          "915-0024",
          "915-0864",
          "915-0886",
          "915-1203",
          "915-0013",
          "915-0037",
          "915-0021",
          "915-0802",
          "915-0219",
          "915-0834",
          "915-0004",
          "915-0897",
          "915-0813",
          "915-0203",
          "915-0041",
          "915-0261",
          "915-0862",
          "915-0082",
          "915-0254",
          "915-1202",
          "915-1221",
          "915-0874",
          "915-0076",
          "915-1243",
          "915-1234",
          "915-1215",
          "915-0026",
          "915-0816",
          "915-1212",
          "915-0075",
          "915-0231",
          "915-0833",
          "915-0805",
          "915-0223",
          "915-0012",
          "915-0881",
          "915-0887",
          "915-1222",
          "915-0855",
          "915-1224",
          "915-0093",
          "915-0043",
          "915-1233",
          "915-1214",
          "915-0857",
          "915-0876",
          "915-0232",
          "915-0883",
          "915-0255",
          "915-0804",
          "915-0066",
          "915-0221",
          "915-0006",
          "915-1235",
          "915-0067",
          "915-1231",
          "915-0846",
          "915-1241",
          "915-0262",
          "915-0091",
          "915-0832",
          "915-0888",
          "915-0824",
          "915-0243",
          "915-0814",
          "915-0092",
          "915-0875",
          "915-0843",
          "915-0842",
          "915-0204",
          "915-0068",
          "915-0003",
          "915-0222",
          "915-1204",
          "915-0053",
          "915-0034",
          "915-0227",
          "915-0002",
          "915-0001",
          "915-0212",
          "915-1223",
          "915-0253",
          "915-0097",
          "915-1246",
          "915-0856",
          "915-0265",
          "915-1226",
          "915-0205",
          "915-0851",
          "915-1232",
          "915-0014",
          "915-0244",
          "915-0073",
          "915-0201",
          "915-0252",
          "915-0046",
          "915-0894",
          "915-0264",
          "915-0836",
          "915-1205",
          "915-0891",
          "915-0081",
          "915-0055",
          "915-0224",
          "915-0085",
          "915-0206",
          "915-0072",
          "915-0032",
          "915-0207",
          "915-0251",
          "915-0847",
          "915-0892",
          "915-0831",
          "915-0062",
          "915-0803",
          "915-0044",
          "915-0872",
          "915-0815",
          "915-0209",
          "915-0854",
          "915-0071",
          "915-0036",
          "915-0841",
          "915-0827",
          "915-0225",
          "915-0074",
          "915-0051",
          "915-0061",
          "915-1211",
          "915-0811",
          "915-0806",
          "915-0823",
          "915-0005",
          "915-1244",
          "915-0852",
          "915-1213",
          "915-0217",
          "915-0845",
          "915-0895",
          "915-0007",
          "915-0825",
          "915-0022",
          "915-0226",
          "915-0213",
          "915-0033",
          "915-0826",
          "915-0844",
          "915-0871",
          "915-0056",
          "915-0084",
          "915-0211",
          "915-0822",
          "915-0215",
          "915-0052",
          "915-0057",
          "915-0263",
          "915-0853",
          "915-0065",
          "915-1225",
          "915-0031",
          "915-0094",
          "915-0896",
          "915-0208",
          "915-1245",
          "915-0063",
          "915-0821",
          "910-0200",
          "919-0517",
          "919-0531",
          "919-0547",
          "919-0537",
          "919-0522",
          "919-0502",
          "919-0526",
          "919-0505",
          "919-0536",
          "919-0533",
          "919-0534",
          "919-0542",
          "919-0507",
          "919-0504",
          "919-0506",
          "919-0535",
          "919-0521",
          "919-0501",
          "919-0527",
          "919-0523",
          "919-0532",
          "919-0546",
          "919-0513",
          "919-0514",
          "919-0525",
          "919-0511",
          "919-0503",
          "919-0543",
          "919-0541",
          "919-0545",
          "919-0524",
          "919-0544",
          "919-0516",
          "919-0512",
          "919-0515",
          "919-0483",
          "919-0423",
          "919-0424",
          "919-0425",
          "919-0426",
          "919-0403",
          "919-0455",
          "919-0451",
          "919-0463",
          "919-0465",
          "919-0453",
          "919-0464",
          "919-0454",
          "919-0452",
          "919-0461",
          "919-0462",
          "919-0415",
          "919-0417",
          "919-0416",
          "919-0418",
          "919-0414",
          "919-0412",
          "919-0421",
          "919-0402",
          "919-0422",
          "919-0405",
          "919-0408",
          "919-0471",
          "919-0434",
          "919-0441",
          "919-0409",
          "919-0406",
          "919-0487",
          "919-0443",
          "919-0413",
          "919-0419",
          "919-0481",
          "919-0479",
          "919-0477",
          "919-0431",
          "919-0432",
          "919-0435",
          "919-0436",
          "919-0437",
          "919-0433",
          "919-0407",
          "919-0485",
          "919-0449",
          "919-0447",
          "919-0446",
          "919-0448",
          "919-0445",
          "919-0444",
          "919-0482",
          "919-0474",
          "919-0404",
          "919-0476",
          "919-0475",
          "919-0488",
          "919-0411",
          "919-0486",
          "919-0401",
          "919-0473",
          "919-0472",
          "919-0484",
          "919-0442",
          "910-0212",
          "910-0265",
          "910-0301",
          "910-0324",
          "910-0227",
          "910-0317",
          "910-0243",
          "910-0346",
          "910-0368",
          "910-0365",
          "910-0325",
          "910-0254",
          "910-0253",
          "910-0251",
          "910-0237",
          "910-0264",
          "910-0303",
          "910-0234",
          "910-0304",
          "910-0348",
          "910-0263",
          "910-0356",
          "910-0366",
          "910-0275",
          "910-0313",
          "910-0322",
          "910-0315",
          "910-0211",
          "910-0232",
          "910-0231",
          "910-0333",
          "910-0335",
          "910-0331",
          "910-0202",
          "910-0201",
          "910-0205",
          "910-0362",
          "910-0206",
          "910-0374",
          "910-0357",
          "910-0347",
          "910-0276",
          "910-0262",
          "910-0382",
          "910-0277",
          "910-0302",
          "910-0223",
          "910-0316",
          "910-0332",
          "910-0363",
          "910-0221",
          "910-0345",
          "910-0369",
          "910-0337",
          "910-0352",
          "910-0326",
          "910-0274",
          "910-0312",
          "910-0355",
          "910-0342",
          "910-0373",
          "910-0235",
          "910-0245",
          "910-0338",
          "910-0213",
          "910-0349",
          "910-0353",
          "910-0208",
          "910-0343",
          "910-0233",
          "910-0244",
          "910-0344",
          "910-0311",
          "910-0354",
          "910-0351",
          "910-0383",
          "910-0246",
          "910-0242",
          "910-0273",
          "910-0323",
          "910-0272",
          "910-0367",
          "910-0214",
          "910-0305",
          "910-0224",
          "910-0364",
          "910-0261",
          "910-0334",
          "910-0222",
          "910-0381",
          "910-0271",
          "910-0236",
          "910-0314",
          "910-0225",
          "910-0226",
          "910-0350",
          "910-0375",
          "910-0252",
          "910-0361",
          "910-0371",
          "910-0241",
          "910-0203",
          "910-0207",
          "910-0321",
          "910-0204",
          "910-0215",
          "910-0372",
          "910-0384",
          "910-0341",
          "910-0339",
          "910-0336",
          "913-0053",
          "913-0022",
          "913-0063",
          "913-0064",
          "913-0001",
          "913-0024",
          "913-0023",
          "913-0052",
          "913-0035",
          "913-0041",
          "913-0061",
          "913-0002",
          "913-0025",
          "913-0046",
          "913-0038",
          "913-0037",
          "913-0057",
          "913-0065",
          "913-0044",
          "913-0027",
          "913-0033",
          "913-0056",
          "913-0062",
          "913-0058",
          "913-0031",
          "913-0047",
          "913-0054",
          "913-0051",
          "913-0017",
          "913-0042",
          "913-0055",
          "913-0014",
          "913-0026",
          "913-0012",
          "913-0043",
          "913-0003",
          "913-0034",
          "913-0015",
          "913-0005",
          "913-0004",
          "913-0013",
          "913-0016",
          "913-0011",
          "913-0048",
          "913-0045",
          "913-0032",
          "913-0036",
          "913-0021",
          "910-1100",
          "910-1323",
          "910-1227",
          "910-1217",
          "910-1313",
          "910-1302",
          "910-1316",
          "910-1226",
          "910-1204",
          "910-1322",
          "910-1311",
          "910-1203",
          "910-1325",
          "910-1225",
          "910-1314",
          "910-1223",
          "910-1216",
          "910-1321",
          "910-1228",
          "910-1312",
          "910-1202",
          "910-1222",
          "910-1315",
          "910-1213",
          "910-1305",
          "910-1214",
          "910-1224",
          "910-1206",
          "910-1218",
          "910-1301",
          "910-1201",
          "910-1324",
          "910-1215",
          "910-1212",
          "910-1303",
          "910-1211",
          "910-1326",
          "910-1132",
          "910-1115",
          "910-1126",
          "910-1102",
          "910-1133",
          "910-1103",
          "910-1124",
          "910-1137",
          "910-1131",
          "910-1136",
          "910-1142",
          "910-1112",
          "910-1106",
          "910-1139",
          "910-1134",
          "910-1111",
          "910-1116",
          "910-1104",
          "910-1114",
          "910-1117",
          "910-1105",
          "910-1125",
          "910-1101",
          "910-1144",
          "910-1113",
          "910-1138",
          "910-1122",
          "910-1135",
          "910-1118",
          "910-1123",
          "910-1121",
          "910-1127",
          "910-1141",
          "910-1143",
          "910-1221",
          "910-1205",
          "910-1304",
          "910-2500",
          "910-2504",
          "910-2515",
          "910-2527",
          "910-2525",
          "910-2512",
          "910-2534",
          "910-2552",
          "910-2551",
          "910-2557",
          "910-2508",
          "910-2514",
          "910-2553",
          "910-2554",
          "910-2526",
          "910-2523",
          "910-2537",
          "910-2507",
          "910-2556",
          "910-2532",
          "910-2535",
          "910-2503",
          "910-2555",
          "910-2522",
          "910-2521",
          "910-2513",
          "910-2517",
          "910-2524",
          "910-2536",
          "910-2502",
          "910-2531",
          "910-2533",
          "910-2506",
          "910-2505",
          "910-2501",
          "910-2511",
          "910-2516",
          "919-0200",
          "919-0121",
          "915-1105",
          "919-0213",
          "919-0123",
          "919-0128",
          "915-1112",
          "919-0131",
          "919-0202",
          "919-0204",
          "919-0125",
          "919-0136",
          "915-1103",
          "919-0215",
          "919-0114",
          "919-0206",
          "915-1113",
          "919-0115",
          "919-0201",
          "919-0216",
          "919-0119",
          "915-1101",
          "915-1106",
          "915-1111",
          "919-0212",
          "919-0221",
          "919-0226",
          "919-0133",
          "919-0111",
          "915-1102",
          "919-0211",
          "919-0113",
          "919-0112",
          "919-0217",
          "919-0122",
          "915-1104",
          "919-0205",
          "919-0214",
          "919-0118",
          "919-0224",
          "915-1114",
          "919-0126",
          "919-0117",
          "919-0104",
          "919-0223",
          "919-0225",
          "919-0222",
          "919-0127",
          "919-0135",
          "919-0116",
          "919-0203",
          "919-0129",
          "919-0132",
          "919-0124",
          "919-0102",
          "919-0103",
          "919-0101",
          "919-0227",
          "916-0200",
          "916-0152",
          "916-0205",
          "916-0146",
          "916-0101",
          "916-0106",
          "916-0135",
          "916-0201",
          "916-0145",
          "916-0212",
          "916-0126",
          "916-0262",
          "916-0143",
          "916-0147",
          "916-0216",
          "916-0311",
          "916-0214",
          "916-0267",
          "916-0255",
          "916-0263",
          "916-0206",
          "916-0251",
          "916-0117",
          "916-0121",
          "916-0108",
          "916-0111",
          "916-0316",
          "916-0273",
          "916-0215",
          "916-0131",
          "916-0272",
          "916-0153",
          "916-0112",
          "916-0253",
          "916-0151",
          "916-0107",
          "916-0142",
          "916-0225",
          "916-0133",
          "916-0275",
          "916-0155",
          "916-0422",
          "916-0315",
          "916-0428",
          "916-0426",
          "916-0154",
          "916-0213",
          "916-0211",
          "916-0144",
          "916-0114",
          "916-0223",
          "916-0226",
          "916-0312",
          "916-0314",
          "916-0105",
          "916-0424",
          "916-0134",
          "916-0313",
          "916-0268",
          "916-0252",
          "916-0302",
          "916-0222",
          "916-0224",
          "916-0425",
          "916-0132",
          "916-0304",
          "916-0303",
          "916-0103",
          "916-0266",
          "916-0122",
          "916-0123",
          "916-0136",
          "916-0204",
          "916-0116",
          "916-0301",
          "916-0219",
          "916-0141",
          "916-0261",
          "916-0127",
          "916-0113",
          "916-0218",
          "916-0264",
          "916-0265",
          "916-0156",
          "916-0254",
          "916-0271",
          "916-0276",
          "916-0124",
          "916-0202",
          "916-0102",
          "916-0274",
          "916-0217",
          "916-0221",
          "916-0421",
          "916-0137",
          "916-0423",
          "916-0104",
          "916-0203",
          "916-0125",
          "916-0227",
          "916-0427",
          "916-0115",
          "919-1100",
          "919-1133",
          "919-1135",
          "919-1206",
          "919-1146",
          "919-1145",
          "919-1138",
          "919-1204",
          "919-1131",
          "919-1147",
          "919-1123",
          "919-1141",
          "919-1142",
          "919-1208",
          "919-1132",
          "919-1125",
          "919-1205",
          "919-1143",
          "919-1144",
          "919-1203",
          "919-1202",
          "919-1136",
          "919-1201",
          "919-1124",
          "919-1126",
          "919-1122",
          "919-1137",
          "919-1134",
          "919-1207",
          "919-1121",
          "919-2200",
          "919-2384",
          "919-2204",
          "919-2375",
          "919-2202",
          "919-2376",
          "919-2222",
          "919-2356",
          "919-2363",
          "919-2361",
          "919-2216",
          "919-2212",
          "919-2352",
          "919-2206",
          "919-2365",
          "919-2366",
          "919-2221",
          "919-2373",
          "919-2229",
          "919-2228",
          "919-2223",
          "919-2353",
          "919-2205",
          "919-2203",
          "919-2386",
          "919-2224",
          "919-2374",
          "919-2372",
          "919-2226",
          "919-2362",
          "919-2211",
          "919-2371",
          "919-2364",
          "919-2381",
          "919-2213",
          "919-2382",
          "919-2383",
          "919-2355",
          "919-2207",
          "919-2215",
          "919-2354",
          "919-2225",
          "919-2351",
          "919-2214",
          "919-2385",
          "919-2387",
          "919-2227",
          "919-2201",
          "919-2100",
          "919-2125",
          "919-2106",
          "919-2101",
          "919-2116",
          "919-2128",
          "919-2103",
          "919-2134",
          "919-2133",
          "919-2122",
          "919-2124",
          "919-2105",
          "919-2127",
          "919-2126",
          "919-2123",
          "919-2113",
          "919-2104",
          "919-2115",
          "919-2102",
          "917-0363",
          "917-0361",
          "917-0385",
          "917-0387",
          "917-0371",
          "917-0365",
          "917-0386",
          "917-0383",
          "917-0373",
          "917-0372",
          "917-0374",
          "917-0362",
          "917-0384",
          "917-0375",
          "917-0382",
          "917-0381",
          "917-0364",
          "919-2107",
          "919-2114",
          "919-2129",
          "919-2131",
          "919-2111",
          "919-2121",
          "919-2135",
          "919-2132",
          "919-2112",
          "919-1300",
          "919-1312",
          "919-1523",
          "919-1502",
          "919-1501",
          "919-1507",
          "919-1304",
          "919-1316",
          "919-1541",
          "919-1542",
          "919-1325",
          "919-1321",
          "919-1461",
          "919-1525",
          "919-1302",
          "919-1504",
          "919-1453",
          "919-1514",
          "919-1554",
          "919-1503",
          "919-1557",
          "919-1527",
          "919-1534",
          "919-1305",
          "919-1301",
          "919-1532",
          "919-1323",
          "919-1544",
          "919-1533",
          "919-1512",
          "919-1335",
          "919-1521",
          "919-1462",
          "919-1559",
          "919-1528",
          "919-1455",
          "919-1322",
          "919-1324",
          "919-1531",
          "919-1522",
          "919-1551",
          "919-1526",
          "919-1464",
          "919-1315",
          "919-1326",
          "919-1332",
          "919-1334",
          "919-1556",
          "919-1333",
          "919-1553",
          "919-1451",
          "919-1543",
          "919-1331",
          "919-1505",
          "919-1558",
          "919-1463",
          "919-1314",
          "919-1545",
          "919-1327",
          "919-1311",
          "919-1303",
          "919-1452",
          "919-1511",
          "919-1328",
          "919-1513",
          "919-1515",
          "919-1306",
          "919-1536",
          "919-1336",
          "919-1555",
          "919-1506",
          "919-1516",
          "919-1454",
          "919-1313",
          "919-1535",
          "919-1552",
          "919-1524",
          "400-0000",
          "400-0858",
          "400-0867",
          "400-0828",
          "400-0862",
          "400-0025",
          "400-0023",
          "400-0061",
          "400-0035",
          "400-1217",
          "400-0062",
          "400-0856",
          "400-0013",
          "400-0045",
          "400-1504",
          "400-0053",
          "400-0865",
          "400-0055",
          "400-0015",
          "400-0834",
          "400-0028",
          "400-0841",
          "409-3711",
          "400-0063",
          "400-0814",
          "400-0041",
          "400-0845",
          "400-0081",
          "400-0044",
          "400-0052",
          "400-0011",
          "400-1501",
          "400-0831",
          "400-1506",
          "400-1213",
          "400-0811",
          "400-0024",
          "400-0005",
          "400-0065",
          "400-0048",
          "400-0815",
          "400-1211",
          "400-0043",
          "400-0836",
          "400-0033",
          "400-0014",
          "400-0002",
          "400-0857",
          "400-0805",
          "400-0804",
          "400-0803",
          "400-0822",
          "400-0823",
          "400-0026",
          "400-0064",
          "400-0046",
          "400-0842",
          "400-0082",
          "400-0835",
          "400-0068",
          "400-0853",
          "400-0012",
          "400-1508",
          "400-1507",
          "400-0861",
          "400-1502",
          "400-1503",
          "400-0066",
          "400-0821",
          "400-0851",
          "400-0852",
          "400-0806",
          "400-0801",
          "400-1219",
          "400-0072",
          "400-1214",
          "400-0042",
          "400-1212",
          "400-0057",
          "400-0034",
          "400-0016",
          "400-1215",
          "400-0074",
          "400-0032",
          "400-0067",
          "400-0003",
          "400-0006",
          "400-1216",
          "400-0807",
          "400-0808",
          "400-0047",
          "400-0049",
          "400-0855",
          "400-0854",
          "400-0844",
          "400-1505",
          "400-0069",
          "400-0825",
          "400-0833",
          "400-0054",
          "400-0826",
          "400-0004",
          "400-0071",
          "400-0843",
          "400-0083",
          "400-0027",
          "400-0051",
          "409-3712",
          "400-0056",
          "400-0832",
          "400-0031",
          "400-0007",
          "400-1218",
          "400-0008",
          "400-0863",
          "400-0058",
          "400-0021",
          "400-0813",
          "400-0022",
          "400-0017",
          "400-0075",
          "400-0864",
          "400-0073",
          "400-0802",
          "400-0827",
          "400-0824",
          "400-0866",
          "400-0001",
          "400-0812",
          "403-0000",
          "403-0012",
          "403-0031",
          "403-0011",
          "403-0006",
          "403-0003",
          "403-0001",
          "403-0005",
          "403-0032",
          "403-0002",
          "403-0004",
          "403-0008",
          "403-0017",
          "403-0019",
          "403-0014",
          "403-0015",
          "403-0007",
          "403-0009",
          "403-0016",
          "403-0013",
          "403-0018",
          "402-0000",
          "402-0015",
          "402-0014",
          "402-0042",
          "402-0011",
          "402-0023",
          "402-0045",
          "402-0002",
          "402-0006",
          "402-0024",
          "402-0034",
          "402-0041",
          "402-0044",
          "402-0053",
          "402-0055",
          "402-0003",
          "402-0033",
          "402-0032",
          "402-0051",
          "402-0001",
          "402-0054",
          "402-0021",
          "402-0052",
          "402-0056",
          "402-0031",
          "402-0022",
          "402-0046",
          "402-0035",
          "402-0043",
          "402-0004",
          "402-0025",
          "402-0013",
          "402-0005",
          "402-0012",
          "405-0000",
          "405-0044",
          "405-0025",
          "405-0024",
          "405-0043",
          "405-0016",
          "405-0033",
          "405-0014",
          "405-0034",
          "405-0018",
          "405-0022",
          "405-0004",
          "405-0013",
          "405-0041",
          "405-0048",
          "405-0005",
          "405-0006",
          "405-0011",
          "405-0015",
          "405-0003",
          "405-0017",
          "405-0023",
          "405-0032",
          "405-0045",
          "405-0021",
          "405-0007",
          "405-0001",
          "405-0002",
          "405-0012",
          "405-0046",
          "404-0007",
          "404-0013",
          "404-0003",
          "404-0015",
          "404-0002",
          "404-0016",
          "404-0011",
          "404-0004",
          "404-0005",
          "404-0014",
          "404-0006",
          "404-0012",
          "404-0001",
          "405-0031",
          "405-0047",
          "404-0206",
          "404-0202",
          "404-0201",
          "404-0203",
          "404-0204",
          "404-0205",
          "405-0042",
          "405-0036",
          "405-0035",
          "401-0000",
          "401-0013",
          "401-0014",
          "401-0015",
          "401-0016",
          "401-0011",
          "401-0025",
          "401-0023",
          "401-0024",
          "409-0615",
          "409-0613",
          "409-0616",
          "409-0611",
          "409-0618",
          "409-0614",
          "409-0617",
          "409-0612",
          "409-0502",
          "409-0501",
          "409-0621",
          "409-0623",
          "409-0627",
          "409-0622",
          "409-0626",
          "409-0625",
          "409-0624",
          "401-0005",
          "401-0002",
          "401-0006",
          "401-0004",
          "401-0001",
          "401-0003",
          "401-0021",
          "401-0022",
          "401-0012",
          "409-0504",
          "409-0505",
          "409-0506",
          "409-0503",
          "407-0000",
          "407-0045",
          "407-0046",
          "407-0044",
          "407-0263",
          "407-0012",
          "407-0011",
          "407-0036",
          "407-0035",
          "407-0034",
          "407-0037",
          "407-0007",
          "407-0042",
          "407-0041",
          "407-0043",
          "407-0025",
          "407-0006",
          "407-0022",
          "407-0055",
          "407-0054",
          "407-0057",
          "407-0058",
          "407-0032",
          "407-0033",
          "407-0031",
          "407-0023",
          "407-0013",
          "407-0261",
          "407-0262",
          "407-0005",
          "407-0001",
          "407-0002",
          "407-0004",
          "407-0003",
          "407-0014",
          "407-0021",
          "407-0172",
          "407-0176",
          "407-0173",
          "407-0174",
          "407-0175",
          "407-0171",
          "407-0024",
          "407-0051",
          "407-0052",
          "407-0053",
          "407-0015",
          "400-0400",
          "400-0424",
          "400-0333",
          "400-0241",
          "400-0242",
          "400-0319",
          "400-0403",
          "400-0226",
          "400-0222",
          "400-0224",
          "400-0413",
          "400-0315",
          "400-0215",
          "400-0204",
          "400-0401",
          "400-0234",
          "400-0306",
          "400-0423",
          "400-0335",
          "400-0332",
          "400-0317",
          "400-0303",
          "400-0211",
          "400-0201",
          "400-0312",
          "400-0421",
          "400-0311",
          "400-0223",
          "400-0232",
          "400-0221",
          "400-0302",
          "400-0231",
          "400-0417",
          "400-0314",
          "400-0331",
          "400-0212",
          "400-0202",
          "400-0405",
          "400-0305",
          "400-0233",
          "400-0416",
          "400-0318",
          "400-0402",
          "400-0426",
          "400-0225",
          "400-0337",
          "400-0334",
          "400-0214",
          "400-0336",
          "400-0203",
          "400-0414",
          "400-0316",
          "400-0411",
          "400-0213",
          "400-0422",
          "400-0412",
          "400-0313",
          "400-0404",
          "400-0415",
          "400-0206",
          "400-0301",
          "400-0205",
          "400-0308",
          "400-0425",
          "400-0304",
          "408-0000",
          "408-0201",
          "408-0205",
          "408-0204",
          "408-0202",
          "408-0207",
          "408-0203",
          "408-0206",
          "407-0311",
          "409-1501",
          "409-1502",
          "408-0044",
          "408-0041",
          "408-0043",
          "408-0042",
          "408-0111",
          "408-0103",
          "408-0113",
          "408-0101",
          "407-0321",
          "408-0104",
          "408-0116",
          "407-0322",
          "408-0114",
          "408-0105",
          "408-0102",
          "408-0115",
          "408-0112",
          "408-0117",
          "407-0302",
          "408-0016",
          "407-0301",
          "408-0013",
          "408-0014",
          "408-0017",
          "408-0015",
          "408-0004",
          "408-0001",
          "408-0003",
          "408-0012",
          "408-0011",
          "408-0002",
          "408-0018",
          "408-0019",
          "408-0032",
          "408-0034",
          "408-0031",
          "408-0023",
          "408-0033",
          "408-0022",
          "408-0024",
          "408-0021",
          "408-0025",
          "408-0037",
          "408-0036",
          "408-0035",
          "408-0026",
          "408-0319",
          "408-0318",
          "408-0317",
          "408-0315",
          "408-0312",
          "408-0314",
          "408-0316",
          "408-0311",
          "408-0313",
          "408-0305",
          "408-0304",
          "408-0302",
          "408-0301",
          "408-0303",
          "408-0307",
          "408-0306",
          "400-0100",
          "400-1126",
          "400-0106",
          "400-0121",
          "400-1114",
          "400-0108",
          "400-1115",
          "400-0128",
          "400-0126",
          "400-0103",
          "400-1121",
          "400-1117",
          "400-1123",
          "400-1113",
          "400-1131",
          "400-1112",
          "400-1127",
          "400-0122",
          "400-1116",
          "400-0107",
          "400-0115",
          "400-0123",
          "400-1122",
          "400-0105",
          "400-1125",
          "400-1124",
          "400-0101",
          "400-1111",
          "400-0116",
          "400-0102",
          "400-0127",
          "400-0113",
          "400-0124",
          "400-0125",
          "400-0112",
          "400-0117",
          "400-0114",
          "400-0118",
          "400-0111",
          "400-0104",
          "406-0000",
          "409-3702",
          "409-3704",
          "409-3701",
          "409-3703",
          "406-0031",
          "406-0045",
          "406-0042",
          "406-0028",
          "406-0025",
          "406-0034",
          "406-0024",
          "406-0036",
          "406-0033",
          "406-0043",
          "406-0027",
          "406-0044",
          "406-0026",
          "406-0023",
          "406-0046",
          "406-0041",
          "406-0035",
          "406-0021",
          "406-0022",
          "406-0032",
          "405-0065",
          "405-0061",
          "405-0063",
          "405-0056",
          "405-0062",
          "405-0079",
          "405-0059",
          "405-0066",
          "405-0051",
          "405-0071",
          "405-0068",
          "405-0074",
          "405-0058",
          "405-0064",
          "405-0055",
          "405-0057",
          "405-0073",
          "405-0054",
          "405-0076",
          "405-0078",
          "405-0067",
          "405-0077",
          "405-0053",
          "405-0075",
          "405-0069",
          "405-0052",
          "405-0072",
          "406-0005",
          "406-0012",
          "406-0003",
          "406-0014",
          "406-0004",
          "406-0015",
          "406-0001",
          "406-0013",
          "406-0011",
          "406-0002",
          "406-0842",
          "406-0855",
          "406-0852",
          "406-0841",
          "406-0851",
          "406-0844",
          "406-0854",
          "406-0853",
          "406-0845",
          "406-0843",
          "406-0846",
          "406-0803",
          "406-0817",
          "406-0815",
          "406-0802",
          "406-0813",
          "406-0805",
          "406-0808",
          "406-0812",
          "406-0811",
          "406-0818",
          "406-0816",
          "406-0814",
          "406-0804",
          "406-0801",
          "406-0807",
          "406-0806",
          "406-0825",
          "406-0834",
          "406-0821",
          "406-0831",
          "406-0832",
          "406-0823",
          "406-0833",
          "406-0824",
          "406-0822",
          "406-0835",
          "409-0100",
          "401-0201",
          "409-0135",
          "409-0113",
          "409-0124",
          "409-0112",
          "409-0134",
          "409-0138",
          "409-0131",
          "409-0123",
          "409-0122",
          "409-0136",
          "409-0126",
          "409-0141",
          "409-0121",
          "409-0132",
          "409-0114",
          "409-0125",
          "409-0115",
          "409-0133",
          "409-0111",
          "409-0137",
          "404-0000",
          "404-0033",
          "404-0021",
          "409-1213",
          "409-1321",
          "404-0034",
          "404-0211",
          "404-0053",
          "404-0031",
          "404-0046",
          "404-0042",
          "404-0026",
          "404-0045",
          "409-1211",
          "404-0022",
          "404-0037",
          "404-0036",
          "404-0032",
          "404-0043",
          "404-0025",
          "404-0044",
          "404-0024",
          "404-0055",
          "404-0051",
          "404-0041",
          "409-1212",
          "404-0023",
          "404-0035",
          "404-0052",
          "404-0056",
          "404-0054",
          "404-0047",
          "409-1303",
          "409-1316",
          "409-1312",
          "409-1304",
          "409-1313",
          "409-1315",
          "409-1301",
          "409-1302",
          "409-1311",
          "409-1314",
          "409-1306",
          "409-1305",
          "409-1202",
          "409-1205",
          "409-1201",
          "409-1203",
          "409-1204",
          "409-3800",
          "400-1514",
          "409-3813",
          "409-3804",
          "409-3834",
          "409-3835",
          "409-3844",
          "409-3831",
          "400-1513",
          "409-3812",
          "409-3823",
          "400-1511",
          "409-3811",
          "409-3821",
          "409-3822",
          "400-1512",
          "400-1515",
          "409-3801",
          "409-3815",
          "409-3802",
          "409-3843",
          "409-3842",
          "409-3833",
          "409-3841",
          "409-3832",
          "409-3814",
          "409-3845",
          "409-3803",
          "409-3600",
          "409-3601",
          "409-3234",
          "409-3244",
          "409-3607",
          "409-3612",
          "409-3611",
          "409-3231",
          "409-3243",
          "409-3245",
          "409-3603",
          "409-3233",
          "409-3622",
          "409-3621",
          "409-3605",
          "409-3606",
          "409-3623",
          "409-3241",
          "409-3232",
          "409-3625",
          "409-3624",
          "409-3626",
          "409-3604",
          "409-3242",
          "409-3602",
          "409-2700",
          "409-2733",
          "409-2734",
          "409-2703",
          "409-2731",
          "409-2704",
          "409-2715",
          "409-2714",
          "409-2723",
          "409-2732",
          "409-2725",
          "409-2722",
          "409-2721",
          "409-2726",
          "409-2711",
          "409-2701",
          "409-2712",
          "409-2724",
          "409-2705",
          "409-2713",
          "409-2727",
          "409-2702",
          "409-2500",
          "409-2536",
          "409-2521",
          "409-3423",
          "409-2938",
          "409-2937",
          "409-3424",
          "409-2933",
          "409-2947",
          "409-2531",
          "409-3434",
          "409-2934",
          "409-3111",
          "409-2406",
          "409-3311",
          "409-2415",
          "409-2537",
          "409-2404",
          "409-2532",
          "409-3121",
          "409-3433",
          "409-2539",
          "409-2403",
          "409-3101",
          "409-2538",
          "409-3105",
          "409-3118",
          "409-2401",
          "409-2943",
          "409-2931",
          "409-2935",
          "409-3304",
          "409-3115",
          "409-3312",
          "409-3122",
          "409-3123",
          "409-3116",
          "409-3112",
          "409-3305",
          "409-2942",
          "409-2402",
          "409-2522",
          "409-2932",
          "409-2533",
          "409-3107",
          "409-2946",
          "409-2412",
          "409-2405",
          "409-3302",
          "409-3303",
          "409-3124",
          "409-2936",
          "409-3104",
          "409-3432",
          "409-3435",
          "409-3301",
          "409-3103",
          "409-2523",
          "409-2945",
          "409-3102",
          "409-3307",
          "409-2414",
          "409-3313",
          "409-3436",
          "409-3106",
          "409-3437",
          "409-2411",
          "409-3117",
          "409-3113",
          "409-3114",
          "409-2534",
          "409-3125",
          "409-2524",
          "409-3422",
          "409-2944",
          "409-3431",
          "409-3126",
          "409-2941",
          "409-3421",
          "409-3306",
          "409-2535",
          "409-2413",
          "409-2100",
          "409-2304",
          "409-2305",
          "409-2213",
          "409-2101",
          "409-2301",
          "409-2214",
          "409-2302",
          "409-2303",
          "409-2211",
          "409-2216",
          "409-2212",
          "409-2102",
          "409-2217",
          "409-2103",
          "409-2215",
          "400-0500",
          "400-0501",
          "400-0602",
          "400-0506",
          "400-0511",
          "400-0601",
          "400-0603",
          "400-0504",
          "400-0512",
          "400-0502",
          "400-0606",
          "400-0513",
          "400-0608",
          "400-0515",
          "400-0503",
          "400-0607",
          "400-0505",
          "400-0604",
          "400-0514",
          "400-0605",
          "409-3852",
          "409-3864",
          "409-3851",
          "409-3863",
          "409-3862",
          "409-3861",
          "409-3866",
          "409-3865",
          "409-3867",
          "409-3853",
          "409-3854",
          "402-0200",
          "402-0225",
          "402-0207",
          "402-0215",
          "402-0202",
          "402-0204",
          "402-0214",
          "402-0216",
          "402-0227",
          "402-0223",
          "402-0221",
          "402-0224",
          "402-0203",
          "402-0206",
          "402-0226",
          "402-0222",
          "402-0219",
          "402-0209",
          "402-0201",
          "402-0205",
          "402-0218",
          "402-0228",
          "402-0212",
          "402-0208",
          "402-0217",
          "402-0211",
          "402-0213",
          "403-0022",
          "403-0023",
          "403-0021",
          "401-0500",
          "401-0512",
          "401-0511",
          "401-0502",
          "401-0501",
          "401-0320",
          "401-0300",
          "401-0303",
          "401-0335",
          "401-0305",
          "401-0310",
          "401-0304",
          "401-0302",
          "401-0332",
          "401-0333",
          "401-0334",
          "401-0336",
          "401-0331",
          "401-0338",
          "401-0301",
          "401-0337",
          "409-0200",
          "409-0142",
          "409-0211",
          "409-0300",
          "409-0301",
          "409-0306",
          "409-0314",
          "409-0313",
          "409-0302",
          "409-0318",
          "409-0317",
          "409-0304",
          "409-0315",
          "409-0305",
          "409-0312",
          "409-0316",
          "409-0303",
          "409-0311",
          "381-0000",
          "380-0918",
          "381-2247",
          "381-2242",
          "381-2241",
          "381-2205",
          "381-2206",
          "381-0001",
          "380-0838",
          "380-0888",
          "381-0054",
          "381-0056",
          "381-0072",
          "381-0057",
          "381-0066",
          "381-0073",
          "381-0064",
          "381-0062",
          "380-0846",
          "380-0941",
          "380-0945",
          "380-0961",
          "380-0956",
          "380-0944",
          "380-0953",
          "380-0954",
          "380-0943",
          "380-0957",
          "380-0955",
          "380-0804",
          "381-0015",
          "380-0883",
          "380-0854",
          "380-0958",
          "381-2202",
          "381-2243",
          "381-2211",
          "381-2214",
          "381-2217",
          "381-2215",
          "381-0042",
          "380-0911",
          "380-0915",
          "380-0916",
          "380-0912",
          "380-0917",
          "380-0914",
          "380-0901",
          "380-0887",
          "380-0802",
          "381-0085",
          "380-0867",
          "381-2703",
          "381-2704",
          "381-2701",
          "381-2705",
          "381-2702",
          "381-2207",
          "381-0004",
          "380-0936",
          "381-2212",
          "381-0053",
          "381-0023",
          "388-8008",
          "380-0881",
          "381-2222",
          "381-0007",
          "381-0082",
          "380-0821",
          "380-0858",
          "380-0913",
          "381-2232",
          "381-2226",
          "381-2227",
          "381-2234",
          "381-2233",
          "381-2224",
          "381-2221",
          "381-2231",
          "380-0855",
          "380-0826",
          "381-0014",
          "381-0075",
          "381-0035",
          "381-0025",
          "381-0005",
          "380-0866",
          "381-4301",
          "381-4303",
          "381-4302",
          "381-0045",
          "380-0921",
          "380-0927",
          "380-0942",
          "381-0017",
          "380-0875",
          "380-0833",
          "380-0863",
          "381-0061",
          "380-0885",
          "380-0862",
          "381-0013",
          "380-0948",
          "381-2223",
          "380-0812",
          "381-0081",
          "381-2244",
          "381-2245",
          "388-8004",
          "388-8015",
          "388-8016",
          "381-2225",
          "388-8006",
          "388-8019",
          "381-2235",
          "388-8003",
          "388-8014",
          "388-8002",
          "388-8018",
          "388-8011",
          "388-8007",
          "388-8012",
          "388-8017",
          "388-8005",
          "381-0008",
          "381-2216",
          "381-0063",
          "380-0877",
          "381-0065",
          "381-2352",
          "381-2344",
          "381-2358",
          "381-2343",
          "381-2359",
          "381-2341",
          "381-2355",
          "381-2354",
          "381-2353",
          "381-2357",
          "381-2351",
          "381-2347",
          "381-2342",
          "381-2346",
          "381-2356",
          "381-2345",
          "381-2404",
          "381-2401",
          "381-2406",
          "381-2413",
          "381-2405",
          "381-2424",
          "381-2411",
          "381-2415",
          "381-2421",
          "381-2423",
          "381-2422",
          "381-2416",
          "381-2414",
          "381-2412",
          "381-2403",
          "381-2402",
          "381-2407",
          "380-0873",
          "380-0835",
          "380-0853",
          "388-8020",
          "380-0825",
          "380-0844",
          "381-0071",
          "380-0841",
          "381-0034",
          "381-0087",
          "380-0884",
          "380-0864",
          "381-0086",
          "380-0815",
          "381-2246",
          "381-0002",
          "380-0872",
          "380-0907",
          "380-0834",
          "380-0902",
          "380-0906",
          "380-0904",
          "380-0905",
          "380-0814",
          "380-0811",
          "380-0813",
          "380-0822",
          "380-0903",
          "381-4101",
          "381-4103",
          "381-4104",
          "381-4102",
          "381-0041",
          "380-0882",
          "381-0006",
          "389-1104",
          "389-1106",
          "389-1102",
          "389-1103",
          "389-1101",
          "389-1105",
          "389-1107",
          "381-0044",
          "380-0935",
          "380-0934",
          "381-3203",
          "381-3202",
          "381-3205",
          "381-3201",
          "381-3204",
          "381-0074",
          "380-0843",
          "381-3164",
          "381-3163",
          "381-3165",
          "381-3161",
          "381-3166",
          "381-3162",
          "381-0031",
          "380-0845",
          "381-0083",
          "380-0871",
          "380-0857",
          "380-0842",
          "381-0037",
          "380-0801",
          "380-0865",
          "380-0832",
          "388-8001",
          "380-0852",
          "380-0831",
          "381-0038",
          "380-0947",
          "380-0946",
          "381-0036",
          "380-0886",
          "381-2213",
          "381-0003",
          "381-2203",
          "381-2204",
          "381-0026",
          "381-1226",
          "381-1234",
          "381-1211",
          "381-1213",
          "381-1233",
          "381-1214",
          "381-1224",
          "381-1235",
          "381-1222",
          "381-1232",
          "381-1215",
          "381-1221",
          "381-1225",
          "381-1212",
          "381-1231",
          "381-0022",
          "381-0052",
          "388-8013",
          "381-0076",
          "381-1223",
          "380-0836",
          "380-0824",
          "381-0033",
          "380-0823",
          "381-0024",
          "380-0837",
          "381-0016",
          "380-0952",
          "380-0803",
          "380-0816",
          "381-0011",
          "380-0874",
          "380-0851",
          "381-0055",
          "381-0021",
          "381-0012",
          "380-0805",
          "380-0876",
          "380-0861",
          "380-0856",
          "380-0807",
          "381-0088",
          "381-0043",
          "380-0806",
          "380-0928",
          "381-0084",
          "381-0051",
          "381-0089",
          "381-0103",
          "381-0102",
          "381-0101",
          "381-2201",
          "381-0104",
          "380-0847",
          "381-0032",
          "399-0000",
          "399-7402",
          "390-0812",
          "399-7415",
          "390-0802",
          "390-0303",
          "390-1702",
          "390-1703",
          "390-1701",
          "390-1504",
          "390-1501",
          "390-1516",
          "390-1514",
          "390-1502",
          "390-1515",
          "390-1513",
          "390-1511",
          "390-1512",
          "390-1503",
          "390-1506",
          "390-1507",
          "390-1520",
          "399-7403",
          "390-0861",
          "390-0867",
          "390-0831",
          "390-0845",
          "399-0007",
          "399-7405",
          "399-0004",
          "390-0827",
          "390-0826",
          "390-1131",
          "390-0222",
          "390-0813",
          "399-0023",
          "390-0874",
          "390-0304",
          "390-0314",
          "390-0313",
          "390-0315",
          "390-0312",
          "390-0876",
          "399-7413",
          "390-0837",
          "399-7417",
          "390-0822",
          "390-1243",
          "390-0872",
          "390-0871",
          "390-1132",
          "399-7401",
          "399-0024",
          "399-0012",
          "399-0025",
          "399-0021",
          "399-0011",
          "399-0026",
          "399-0027",
          "399-0039",
          "399-0038",
          "399-0033",
          "390-0847",
          "390-0221",
          "390-0877",
          "390-0301",
          "399-8251",
          "390-0851",
          "390-0852",
          "390-0805",
          "390-0875",
          "390-0807",
          "390-0828",
          "390-0866",
          "390-0863",
          "390-0865",
          "390-0305",
          "390-0842",
          "399-7418",
          "390-0834",
          "390-0835",
          "390-0844",
          "390-0843",
          "390-0836",
          "390-0811",
          "390-0821",
          "399-7414",
          "399-7404",
          "399-7411",
          "390-0816",
          "390-0823",
          "390-0824",
          "390-1611",
          "390-0841",
          "399-7416",
          "390-0825",
          "390-1241",
          "399-0006",
          "399-0034",
          "399-0005",
          "390-1401",
          "390-0817",
          "390-0316",
          "399-0014",
          "399-0015",
          "390-0815",
          "390-0833",
          "399-7412",
          "390-0317",
          "390-0814",
          "399-0022",
          "390-0873",
          "390-0302",
          "390-0801",
          "390-0311",
          "390-0306",
          "390-0846",
          "390-0832",
          "399-0001",
          "390-0862",
          "390-0864",
          "399-0035",
          "399-0037",
          "399-0036",
          "390-0806",
          "390-0803",
          "390-0804",
          "399-0002",
          "390-0848",
          "390-1242",
          "386-0000",
          "386-0155",
          "386-0041",
          "386-0411",
          "386-0153",
          "386-0001",
          "386-1102",
          "386-0003",
          "386-1546",
          "386-0006",
          "386-0024",
          "386-0152",
          "386-1543",
          "386-0323",
          "386-1103",
          "386-1108",
          "386-0042",
          "386-0508",
          "386-0404",
          "386-1541",
          "386-1213",
          "386-1106",
          "386-1545",
          "386-1324",
          "386-0016",
          "386-0005",
          "386-0403",
          "386-1322",
          "386-0033",
          "386-0031",
          "386-0014",
          "386-2201",
          "386-2203",
          "386-2202",
          "386-0401",
          "386-0043",
          "386-0503",
          "386-1211",
          "386-1214",
          "386-1101",
          "386-0406",
          "386-1542",
          "386-1435",
          "386-1434",
          "386-2204",
          "386-0002",
          "386-0032",
          "386-0502",
          "386-0504",
          "386-0507",
          "386-0506",
          "386-0501",
          "386-0505",
          "386-0012",
          "386-0013",
          "386-0023",
          "386-0011",
          "386-1107",
          "386-1433",
          "386-0025",
          "386-0015",
          "386-0018",
          "386-0027",
          "386-0004",
          "386-0407",
          "386-1325",
          "386-0034",
          "386-0405",
          "386-1544",
          "386-0322",
          "386-0026",
          "386-1437",
          "386-0156",
          "386-0413",
          "386-0321",
          "386-1104",
          "386-1212",
          "386-0402",
          "386-0017",
          "386-1431",
          "386-1321",
          "386-1323",
          "386-1326",
          "386-1436",
          "386-0412",
          "386-0022",
          "386-0408",
          "386-1327",
          "386-1432",
          "386-0151",
          "386-1105",
          "394-0000",
          "394-0091",
          "394-0002",
          "394-0053",
          "394-0001",
          "394-0055",
          "394-0051",
          "394-0043",
          "394-0011",
          "394-0089",
          "394-0084",
          "394-0082",
          "394-0085",
          "394-0081",
          "394-0087",
          "394-0083",
          "394-0088",
          "394-0086",
          "394-0003",
          "394-0048",
          "394-0047",
          "394-0045",
          "394-0046",
          "394-0022",
          "394-0021",
          "394-0034",
          "394-0029",
          "394-0004",
          "394-0025",
          "394-0031",
          "394-0027",
          "394-0026",
          "394-0035",
          "394-0042",
          "394-0033",
          "394-0052",
          "394-0054",
          "394-0023",
          "394-0056",
          "394-0024",
          "394-0028",
          "394-0044",
          "394-0005",
          "394-0041",
          "394-0032",
          "395-0000",
          "395-0072",
          "395-0055",
          "395-0085",
          "395-0036",
          "395-0152",
          "399-2434",
          "395-0071",
          "395-0023",
          "395-0015",
          "395-0046",
          "395-0034",
          "395-0053",
          "395-0157",
          "395-0056",
          "395-0068",
          "395-0028",
          "395-0805",
          "395-0808",
          "395-0802",
          "395-0806",
          "395-0803",
          "395-0807",
          "395-0801",
          "395-0804",
          "395-0817",
          "395-0026",
          "399-2564",
          "395-0002",
          "395-0003",
          "395-0004",
          "395-0153",
          "399-2611",
          "399-2612",
          "399-1403",
          "399-2431",
          "395-0151",
          "399-2565",
          "395-0031",
          "395-0241",
          "395-0813",
          "395-0013",
          "395-0014",
          "395-0001",
          "399-2566",
          "399-2432",
          "395-0154",
          "399-2606",
          "399-2604",
          "399-2605",
          "399-2602",
          "399-2603",
          "399-2607",
          "395-0061",
          "395-0084",
          "395-0062",
          "395-0018",
          "395-0012",
          "395-0011",
          "395-0051",
          "395-0048",
          "395-0242",
          "399-2561",
          "399-2221",
          "399-2433",
          "395-0032",
          "395-0045",
          "399-2223",
          "395-0041",
          "399-2222",
          "395-0016",
          "395-0024",
          "395-0017",
          "395-0086",
          "395-0043",
          "399-2563",
          "395-0033",
          "399-2601",
          "395-0021",
          "395-0156",
          "399-2562",
          "395-0083",
          "395-0029",
          "395-0076",
          "395-0075",
          "395-0243",
          "395-0066",
          "395-0065",
          "395-0067",
          "395-0073",
          "395-0063",
          "395-0064",
          "395-0027",
          "395-0022",
          "395-0025",
          "395-0044",
          "395-0811",
          "395-0821",
          "395-0824",
          "395-0812",
          "395-0825",
          "395-0822",
          "395-0815",
          "395-0816",
          "395-0042",
          "395-0826",
          "395-0823",
          "395-0074",
          "395-0077",
          "395-0035",
          "395-0155",
          "399-1401",
          "399-1221",
          "399-1313",
          "399-1312",
          "399-1311",
          "395-0037",
          "395-0054",
          "395-0081",
          "395-0082",
          "395-0052",
          "395-0244",
          "395-0245",
          "395-0814",
          "392-0000",
          "392-0011",
          "392-0026",
          "392-0005",
          "392-0013",
          "392-0001",
          "392-0021",
          "392-0003",
          "392-0008",
          "392-0027",
          "392-0131",
          "392-0024",
          "392-0023",
          "392-0012",
          "392-0010",
          "392-0007",
          "392-0017",
          "392-0025",
          "392-0009",
          "392-0004",
          "392-0022",
          "392-0016",
          "392-0015",
          "392-0014",
          "392-0006",
          "392-0002",
          "382-0000",
          "382-0065",
          "382-0003",
          "382-0045",
          "382-0017",
          "382-0012",
          "382-0071",
          "382-0025",
          "382-0083",
          "382-0044",
          "382-0033",
          "382-0028",
          "382-0084",
          "382-0061",
          "382-0002",
          "382-0092",
          "382-0077",
          "382-0048",
          "382-0047",
          "382-0053",
          "382-0085",
          "382-0062",
          "382-0026",
          "382-0052",
          "382-0024",
          "382-0043",
          "382-0005",
          "382-0014",
          "382-0075",
          "382-0099",
          "382-0098",
          "382-0015",
          "382-0054",
          "382-0016",
          "382-0004",
          "382-0091",
          "382-0073",
          "382-0013",
          "382-0022",
          "382-0021",
          "382-0066",
          "382-0055",
          "382-0082",
          "382-0032",
          "382-0063",
          "382-0046",
          "386-2211",
          "382-0034",
          "382-0064",
          "382-0037",
          "382-0076",
          "382-0074",
          "382-0006",
          "382-0087",
          "382-0056",
          "382-0042",
          "382-0086",
          "382-0011",
          "382-0001",
          "382-0072",
          "382-0027",
          "382-0097",
          "382-0036",
          "382-0031",
          "382-0057",
          "382-0051",
          "382-0094",
          "382-0081",
          "382-0023",
          "382-0041",
          "384-0000",
          "384-0025",
          "384-0011",
          "384-0021",
          "384-0062",
          "384-0014",
          "384-0096",
          "384-0047",
          "384-0054",
          "384-0083",
          "384-0033",
          "384-0075",
          "384-0042",
          "384-0077",
          "384-0071",
          "384-0031",
          "384-0037",
          "384-0802",
          "384-0004",
          "384-0055",
          "384-0061",
          "384-0002",
          "384-0805",
          "384-0076",
          "384-0024",
          "384-0801",
          "384-0032",
          "384-0001",
          "384-0015",
          "384-0018",
          "384-0806",
          "384-0809",
          "384-0023",
          "384-0046",
          "384-0034",
          "384-0082",
          "384-0045",
          "384-0028",
          "384-0007",
          "384-0804",
          "384-0072",
          "384-0038",
          "384-0074",
          "384-0044",
          "384-0048",
          "384-0064",
          "384-0051",
          "384-0016",
          "384-0052",
          "384-0008",
          "384-0003",
          "384-0041",
          "384-0094",
          "384-0065",
          "384-0092",
          "384-0053",
          "384-0036",
          "384-0803",
          "384-0026",
          "384-0022",
          "384-0091",
          "384-0808",
          "384-0017",
          "384-0013",
          "384-0063",
          "384-0012",
          "384-0081",
          "384-0084",
          "384-0078",
          "384-0005",
          "384-0085",
          "384-0043",
          "384-0095",
          "384-0807",
          "384-0056",
          "384-0006",
          "384-0035",
          "384-0027",
          "384-0093",
          "396-0000",
          "396-0025",
          "396-0028",
          "396-0021",
          "396-0011",
          "396-0008",
          "396-0032",
          "396-0012",
          "396-0006",
          "396-0014",
          "396-0033",
          "396-0010",
          "396-0024",
          "396-0013",
          "396-0114",
          "396-0212",
          "396-0305",
          "396-0215",
          "396-0214",
          "396-0217",
          "396-0302",
          "396-0216",
          "396-0211",
          "396-0303",
          "396-0213",
          "396-0301",
          "396-0304",
          "396-0015",
          "396-0002",
          "396-0004",
          "396-0003",
          "396-0621",
          "396-0031",
          "399-4431",
          "396-0026",
          "399-4501",
          "396-0005",
          "396-0405",
          "396-0407",
          "396-0403",
          "396-0406",
          "396-0404",
          "396-0401",
          "396-0402",
          "396-0009",
          "399-4432",
          "396-0030",
          "396-0001",
          "396-0112",
          "396-0027",
          "396-0111",
          "396-0022",
          "396-0113",
          "396-0023",
          "396-0029",
          "396-0007",
          "399-4100",
          "399-4113",
          "399-4105",
          "399-4117",
          "399-4102",
          "399-4115",
          "399-4114",
          "399-4116",
          "399-4111",
          "399-4104",
          "399-4108",
          "399-4232",
          "399-4101",
          "399-4112",
          "399-4231",
          "399-4103",
          "399-4321",
          "399-4106",
          "399-4107",
          "383-0000",
          "383-0004",
          "383-0066",
          "389-2103",
          "383-0064",
          "383-0052",
          "383-0012",
          "383-0001",
          "383-0041",
          "383-0055",
          "383-0045",
          "383-0057",
          "383-0023",
          "383-0062",
          "383-0046",
          "383-0008",
          "389-2102",
          "383-0053",
          "383-0056",
          "383-0005",
          "383-0037",
          "383-0044",
          "383-0032",
          "383-0035",
          "383-0034",
          "383-0036",
          "383-0014",
          "389-2371",
          "383-0002",
          "383-0007",
          "383-0054",
          "383-0065",
          "383-0022",
          "389-2101",
          "389-2104",
          "383-0013",
          "383-0051",
          "383-0031",
          "383-0021",
          "383-0042",
          "383-0024",
          "383-0006",
          "383-0061",
          "383-0063",
          "383-0033",
          "383-0043",
          "383-0025",
          "383-0003",
          "383-0015",
          "383-0011",
          "398-0000",
          "398-0002",
          "398-0001",
          "398-0004",
          "399-9101",
          "399-7301",
          "399-7302",
          "398-0003",
          "389-2200",
          "389-2251",
          "389-2253",
          "389-2602",
          "389-2415",
          "389-2234",
          "389-2252",
          "389-2418",
          "389-2235",
          "389-2255",
          "389-2232",
          "389-2242",
          "389-2601",
          "389-2413",
          "389-2231",
          "389-2412",
          "389-2414",
          "389-2258",
          "389-2411",
          "389-2417",
          "389-2233",
          "389-2256",
          "389-2257",
          "389-2322",
          "389-2321",
          "389-2416",
          "389-2254",
          "389-2244",
          "389-2241",
          "389-2243",
          "391-0000",
          "391-0214",
          "391-0012",
          "391-0212",
          "391-0301",
          "391-0211",
          "391-0004",
          "391-0011",
          "391-0001",
          "391-0002",
          "391-0213",
          "391-0215",
          "391-0005",
          "391-0003",
          "391-0013",
          "391-0216",
          "399-0700",
          "399-0713",
          "399-0722",
          "399-0071",
          "399-0711",
          "399-0721",
          "399-0724",
          "399-6302",
          "399-0651",
          "399-0723",
          "399-0716",
          "399-0712",
          "399-0726",
          "399-6462",
          "399-6461",
          "399-0744",
          "399-0742",
          "399-0745",
          "399-0741",
          "399-0743",
          "399-0746",
          "399-0736",
          "399-0735",
          "399-0733",
          "399-0734",
          "399-0732",
          "399-0731",
          "399-0738",
          "399-0737",
          "399-0725",
          "399-0715",
          "399-6303",
          "399-6301",
          "399-0705",
          "399-0704",
          "399-0703",
          "399-0702",
          "399-0706",
          "399-0701",
          "399-0714",
          "399-0727",
          "399-0728",
          "385-0000",
          "385-0054",
          "385-0007",
          "385-0015",
          "384-0621",
          "385-0022",
          "385-0023",
          "384-2201",
          "384-0301",
          "385-0031",
          "385-0045",
          "385-0033",
          "385-0009",
          "385-0041",
          "384-2205",
          "384-0302",
          "384-0306",
          "385-0002",
          "384-0304",
          "384-2204",
          "384-0411",
          "384-2101",
          "384-2104",
          "385-0005",
          "385-0047",
          "385-0028",
          "385-0029",
          "385-0027",
          "385-0056",
          "385-0011",
          "384-2102",
          "385-0006",
          "384-0303",
          "384-0414",
          "385-0003",
          "385-0035",
          "385-0042",
          "384-0412",
          "385-0025",
          "385-0026",
          "385-0032",
          "385-0061",
          "385-0043",
          "384-0305",
          "385-0051",
          "385-0021",
          "385-0016",
          "385-0062",
          "385-0012",
          "385-0053",
          "385-0052",
          "385-0063",
          "385-0034",
          "385-0024",
          "384-0622",
          "384-2203",
          "385-0044",
          "385-0046",
          "385-0014",
          "385-0055",
          "384-0413",
          "384-2103",
          "384-2206",
          "384-2202",
          "384-2105",
          "385-0004",
          "384-2106",
          "384-0307",
          "385-0001",
          "385-0013",
          "384-2107",
          "387-0000",
          "387-0001",
          "389-0823",
          "387-0006",
          "387-0003",
          "389-0806",
          "387-0021",
          "387-0015",
          "389-0802",
          "387-0014",
          "387-0013",
          "389-0805",
          "389-0822",
          "389-0821",
          "387-0011",
          "387-0004",
          "387-0024",
          "389-0801",
          "387-0012",
          "387-0016",
          "387-0018",
          "389-0811",
          "389-0803",
          "389-0824",
          "387-0002",
          "389-0804",
          "389-0807",
          "387-0017",
          "387-0022",
          "389-0812",
          "387-0005",
          "387-0007",
          "387-0023",
          "389-0813",
          "389-0500",
          "389-0517",
          "389-0503",
          "389-0404",
          "389-0504",
          "389-0514",
          "389-0505",
          "389-0502",
          "389-0519",
          "389-0513",
          "389-0512",
          "389-0511",
          "389-0401",
          "389-0405",
          "389-0516",
          "389-0515",
          "389-0402",
          "389-0506",
          "389-0407",
          "389-0501",
          "389-0403",
          "389-0518",
          "389-0406",
          "399-8200",
          "399-7102",
          "399-7104",
          "399-7101",
          "399-7103",
          "399-7105",
          "399-8205",
          "399-8204",
          "399-8203",
          "399-8202",
          "399-8201",
          "399-8303",
          "399-8301",
          "399-8304",
          "399-8302",
          "399-8305",
          "399-8211",
          "399-8212",
          "399-8103",
          "399-8101",
          "399-8102",
          "384-1100",
          "384-1104",
          "384-1102",
          "384-1105",
          "384-1103",
          "384-1101",
          "384-1400",
          "384-1403",
          "384-1402",
          "384-1404",
          "384-1405",
          "384-1401",
          "384-1407",
          "384-1406",
          "384-1408",
          "384-1300",
          "384-1304",
          "384-1301",
          "384-1302",
          "384-1305",
          "384-1306",
          "384-1303",
          "384-1211",
          "384-1201",
          "384-0600",
          "384-0502",
          "384-0503",
          "384-0614",
          "384-0613",
          "384-0703",
          "384-0701",
          "384-0611",
          "384-0702",
          "384-0704",
          "384-0612",
          "384-0501",
          "389-0100",
          "389-0115",
          "389-0102",
          "389-0103",
          "389-0104",
          "389-0101",
          "389-0112",
          "389-0111",
          "389-0113",
          "389-0114",
          "389-0200",
          "389-0205",
          "389-0202",
          "389-0201",
          "389-0203",
          "389-0204",
          "389-0207",
          "389-0206",
          "389-0208",
          "384-2300",
          "384-2305",
          "391-0321",
          "384-2309",
          "384-2308",
          "384-2306",
          "384-2301",
          "384-2303",
          "384-2302",
          "384-2304",
          "384-2211",
          "384-2307",
          "386-1600",
          "386-1605",
          "386-1606",
          "386-1601",
          "386-1603",
          "386-1604",
          "386-1607",
          "386-1602",
          "386-0600",
          "386-0601",
          "386-0602",
          "386-0603",
          "386-0701",
          "393-0000",
          "393-0066",
          "393-0068",
          "393-0052",
          "393-0053",
          "393-0042",
          "393-0014",
          "393-0026",
          "393-0024",
          "393-0044",
          "393-0013",
          "393-0084",
          "393-0065",
          "393-0072",
          "393-0086",
          "393-0007",
          "393-0011",
          "393-0018",
          "393-0054",
          "393-0022",
          "393-0051",
          "393-0092",
          "393-0033",
          "393-0034",
          "393-0021",
          "393-0015",
          "393-0078",
          "393-0075",
          "393-0073",
          "393-0023",
          "393-0057",
          "393-0001",
          "393-0064",
          "393-0071",
          "393-0047",
          "393-0041",
          "393-0087",
          "393-0032",
          "393-0082",
          "393-0035",
          "393-0003",
          "393-0063",
          "393-0046",
          "393-0043",
          "393-0085",
          "393-0002",
          "393-0006",
          "393-0005",
          "393-0004",
          "393-0093",
          "393-0083",
          "393-0031",
          "393-0062",
          "393-0056",
          "393-0055",
          "393-0091",
          "393-0025",
          "393-0008",
          "393-0061",
          "393-0074",
          "393-0045",
          "393-0067",
          "393-0076",
          "393-0077",
          "393-0081",
          "393-0017",
          "393-0016",
          "393-0012",
          "393-0019",
          "399-0200",
          "399-0102",
          "399-0214",
          "399-0213",
          "399-0101",
          "399-0212",
          "391-0021",
          "399-0211",
          "391-0100",
          "391-0101",
          "391-0105",
          "391-0111",
          "391-0106",
          "391-0108",
          "391-0112",
          "391-0104",
          "391-0115",
          "391-0116",
          "391-0114",
          "391-0109",
          "391-0107",
          "391-0113",
          "391-0103",
          "391-0102",
          "399-0400",
          "399-0424",
          "399-0428",
          "399-0601",
          "399-0512",
          "399-0423",
          "399-0421",
          "399-0427",
          "399-0425",
          "399-0422",
          "399-0426",
          "399-0511",
          "399-4600",
          "399-4605",
          "399-4601",
          "399-4602",
          "399-4604",
          "399-4603",
          "399-3700",
          "399-3702",
          "399-3701",
          "399-3705",
          "399-3703",
          "399-3704",
          "399-4511",
          "399-3800",
          "399-3801",
          "399-3802",
          "399-3803",
          "399-3804",
          "399-4301",
          "399-3300",
          "399-3302",
          "399-3304",
          "399-3301",
          "399-3303",
          "399-3100",
          "399-3107",
          "399-3105",
          "399-3106",
          "399-3104",
          "399-3103",
          "399-3101",
          "399-3102",
          "399-1500",
          "399-1501",
          "399-1505",
          "399-1612",
          "399-1504",
          "399-1502",
          "399-1503",
          "399-1611",
          "395-0300",
          "395-0301",
          "395-0302",
          "395-0305",
          "395-0303",
          "395-0401",
          "395-0304",
          "395-0501",
          "395-0601",
          "395-0701",
          "399-2100",
          "399-2102",
          "399-2101",
          "399-1601",
          "399-1200",
          "399-1202",
          "399-1203",
          "399-1201",
          "399-1801",
          "395-1100",
          "395-1101",
          "395-1108",
          "395-1104",
          "395-1103",
          "395-1105",
          "395-1107",
          "395-1102",
          "395-1106",
          "399-3200",
          "399-3311",
          "399-3201",
          "399-3202",
          "399-3500",
          "399-3502",
          "399-3501",
          "399-5600",
          "399-5601",
          "399-5609",
          "399-5603",
          "399-5607",
          "399-5608",
          "399-5605",
          "399-5604",
          "399-5602",
          "399-5606",
          "399-5300",
          "399-5302",
          "399-5303",
          "399-5301",
          "399-6200",
          "399-6203",
          "399-6202",
          "399-6201",
          "397-0201",
          "399-5500",
          "399-5502",
          "399-5501",
          "399-5503",
          "399-5504",
          "397-0000",
          "397-0301",
          "397-0302",
          "397-0002",
          "397-0003",
          "399-6101",
          "397-0001",
          "397-0101",
          "399-7700",
          "399-7701",
          "399-7702",
          "399-7200",
          "399-7201",
          "399-7202",
          "399-7311",
          "390-1301",
          "390-1100",
          "390-1102",
          "390-1104",
          "390-1101",
          "390-1103",
          "399-7500",
          "399-7503",
          "399-7711",
          "399-7601",
          "399-7501",
          "399-7502",
          "399-7504",
          "399-8600",
          "399-8602",
          "399-8601",
          "399-8603",
          "399-8604",
          "399-8605",
          "399-8501",
          "399-9300",
          "399-9211",
          "399-9301",
          "399-9400",
          "399-9601",
          "399-9422",
          "399-9421",
          "399-9511",
          "389-0600",
          "389-0604",
          "389-0605",
          "389-0606",
          "389-0601",
          "389-0602",
          "389-0603",
          "381-0200",
          "381-0204",
          "381-0203",
          "381-0207",
          "381-0201",
          "381-0211",
          "381-0206",
          "381-0205",
          "381-0208",
          "381-0209",
          "381-0202",
          "381-0212",
          "382-0800",
          "382-0832",
          "382-0831",
          "382-0815",
          "382-0833",
          "382-0823",
          "382-0801",
          "382-0836",
          "382-0835",
          "382-0814",
          "382-0804",
          "382-0806",
          "382-0822",
          "382-0826",
          "382-0837",
          "382-0821",
          "382-0803",
          "382-0827",
          "382-0802",
          "382-0805",
          "382-0834",
          "382-0824",
          "382-0811",
          "382-0825",
          "382-0816",
          "382-0817",
          "382-0813",
          "381-0400",
          "381-0402",
          "381-0403",
          "381-0404",
          "381-0401",
          "381-0405",
          "389-2300",
          "389-2302",
          "389-2303",
          "389-2301",
          "389-2500",
          "389-2501",
          "389-2502",
          "389-2612",
          "389-2611",
          "389-2614",
          "389-2503",
          "389-2613",
          "389-1300",
          "389-1311",
          "389-1316",
          "389-1305",
          "389-1304",
          "389-1301",
          "389-1312",
          "389-1303",
          "389-1306",
          "389-1315",
          "389-1313",
          "389-1302",
          "389-1314",
          "381-3300",
          "381-3301",
          "381-3303",
          "381-3304",
          "381-3302",
          "389-1200",
          "389-1203",
          "389-1201",
          "389-1226",
          "389-1205",
          "389-1204",
          "389-1214",
          "389-1227",
          "389-1215",
          "389-1225",
          "389-1224",
          "389-1223",
          "389-1212",
          "389-1202",
          "389-1213",
          "389-1206",
          "389-1221",
          "389-1211",
          "389-1222",
          "389-2700",
          "949-8321",
          "389-2703",
          "389-2701",
          "389-2702",
          "500-0000",
          "500-8103",
          "500-8083",
          "500-8881",
          "500-8282",
          "500-8261",
          "500-8263",
          "500-8265",
          "500-8264",
          "500-8267",
          "500-8269",
          "500-8283",
          "500-8268",
          "500-8262",
          "500-8284",
          "500-8176",
          "501-1182",
          "500-8067",
          "501-3134",
          "501-3111",
          "501-3114",
          "501-3136",
          "501-3143",
          "501-3135",
          "501-3146",
          "501-3144",
          "501-3141",
          "501-3132",
          "501-3145",
          "501-3112",
          "501-3147",
          "501-3116",
          "501-3133",
          "500-8148",
          "500-8255",
          "500-8109",
          "501-1109",
          "501-1108",
          "500-8411",
          "500-8883",
          "500-8221",
          "500-8337",
          "500-8132",
          "500-8449",
          "500-8401",
          "502-0001",
          "502-0002",
          "502-0006",
          "502-0007",
          "500-8139",
          "500-8405",
          "500-8884",
          "502-0906",
          "501-1106",
          "500-8437",
          "500-8153",
          "501-2535",
          "501-3104",
          "500-8073",
          "500-8155",
          "500-8381",
          "500-8183",
          "500-8403",
          "500-8043",
          "500-8336",
          "500-8489",
          "500-8161",
          "500-8077",
          "501-1114",
          "500-8814",
          "500-8069",
          "500-8822",
          "500-8023",
          "500-8388",
          "500-8234",
          "500-8152",
          "501-3101",
          "501-3102",
          "500-8134",
          "502-0844",
          "502-0005",
          "501-3154",
          "501-3156",
          "501-3151",
          "501-3152",
          "501-3155",
          "500-8225",
          "501-1102",
          "500-8033",
          "502-0837",
          "500-8052",
          "500-8053",
          "500-8368",
          "500-8366",
          "500-8367",
          "502-0802",
          "500-8041",
          "500-8818",
          "500-8815",
          "500-8371",
          "500-8123",
          "500-8059",
          "500-8133",
          "500-8823",
          "502-0915",
          "501-0117",
          "501-0121",
          "501-0122",
          "500-8383",
          "500-8149",
          "500-8165",
          "500-8373",
          "501-3108",
          "500-8447",
          "501-0118",
          "501-0119",
          "500-8873",
          "500-8889",
          "501-3124",
          "501-3123",
          "501-3121",
          "501-3127",
          "501-3125",
          "501-3122",
          "501-3126",
          "500-8003",
          "500-8885",
          "501-6134",
          "500-8305",
          "501-1185",
          "500-8061",
          "500-8079",
          "500-8135",
          "502-0835",
          "500-8181",
          "502-0016",
          "502-0014",
          "502-0015",
          "501-1132",
          "501-0111",
          "501-0113",
          "501-0112",
          "501-0124",
          "501-0123",
          "501-0115",
          "500-8001",
          "500-8313",
          "500-8306",
          "500-8314",
          "502-0841",
          "500-8443",
          "500-8128",
          "500-8259",
          "500-8323",
          "500-8102",
          "500-8017",
          "500-8303",
          "500-8186",
          "500-8322",
          "501-2521",
          "501-2528",
          "501-2527",
          "501-2526",
          "501-2522",
          "500-8849",
          "500-8113",
          "500-8065",
          "500-8063",
          "501-3107",
          "500-8457",
          "500-8452",
          "500-8476",
          "500-8422",
          "500-8279",
          "500-8427",
          "500-8482",
          "500-8272",
          "500-8451",
          "500-8419",
          "500-8417",
          "500-8472",
          "500-8481",
          "500-8461",
          "500-8465",
          "500-8475",
          "500-8455",
          "500-8468",
          "500-8428",
          "500-8429",
          "500-8463",
          "500-8425",
          "500-8462",
          "500-8421",
          "500-8486",
          "500-8274",
          "500-8459",
          "500-8277",
          "500-8456",
          "500-8453",
          "500-8473",
          "500-8413",
          "500-8416",
          "500-8415",
          "500-8454",
          "500-8487",
          "500-8276",
          "500-8418",
          "500-8488",
          "500-8278",
          "500-8484",
          "500-8431",
          "500-8275",
          "500-8414",
          "500-8483",
          "500-8479",
          "500-8478",
          "500-8471",
          "500-8252",
          "500-8271",
          "500-8466",
          "500-8474",
          "500-8464",
          "500-8485",
          "500-8467",
          "500-8251",
          "500-8477",
          "500-8426",
          "500-8458",
          "500-8424",
          "500-8273",
          "500-8469",
          "500-8839",
          "501-3115",
          "500-8026",
          "500-8068",
          "500-8121",
          "500-8245",
          "502-0862",
          "502-0863",
          "502-0864",
          "502-0861",
          "501-1178",
          "500-8005",
          "501-1150",
          "501-1149",
          "501-1148",
          "500-8024",
          "500-8057",
          "500-8049",
          "500-8021",
          "502-0803",
          "500-8878",
          "502-0938",
          "502-0935",
          "502-0936",
          "502-0937",
          "500-8404",
          "500-8108",
          "501-1151",
          "500-8833",
          "501-3131",
          "500-8321",
          "502-0831",
          "500-8345",
          "500-8327",
          "500-8227",
          "500-8287",
          "501-1133",
          "502-0911",
          "501-2503",
          "501-2519",
          "501-2512",
          "501-2518",
          "501-2516",
          "501-2511",
          "500-8807",
          "500-8824",
          "501-3113",
          "501-1135",
          "502-0859",
          "500-8086",
          "500-8156",
          "500-8154",
          "500-8867",
          "500-8804",
          "500-8846",
          "500-8178",
          "500-8237",
          "502-0828",
          "500-8847",
          "500-8114",
          "502-0826",
          "500-8349",
          "500-8372",
          "500-8145",
          "500-8233",
          "500-8174",
          "501-1131",
          "501-1136",
          "500-8081",
          "502-0823",
          "500-8107",
          "500-8254",
          "501-0105",
          "500-8409",
          "500-8868",
          "500-8434",
          "500-8891",
          "500-8842",
          "500-8146",
          "501-1176",
          "500-8328",
          "500-8157",
          "500-8222",
          "500-8325",
          "501-1174",
          "500-8333",
          "500-8011",
          "500-8046",
          "501-1171",
          "501-3117",
          "500-8832",
          "500-8379",
          "502-0908",
          "502-0021",
          "500-8266",
          "500-8857",
          "502-0849",
          "500-8872",
          "502-0851",
          "502-0872",
          "502-0853",
          "502-0871",
          "502-0855",
          "502-0856",
          "502-0854",
          "502-0850",
          "502-0867",
          "500-8803",
          "500-8319",
          "500-8318",
          "500-8055",
          "500-8324",
          "501-1101",
          "500-8189",
          "500-8127",
          "500-8369",
          "501-3153",
          "501-1147",
          "500-8423",
          "502-0904",
          "502-0907",
          "502-0917",
          "500-8316",
          "500-8315",
          "500-8317",
          "500-8438",
          "501-1172",
          "500-8039",
          "500-8066",
          "500-8246",
          "501-1175",
          "501-1146",
          "500-8037",
          "500-8056",
          "500-8022",
          "502-0858",
          "500-8385",
          "500-8412",
          "500-8441",
          "500-8442",
          "500-8125",
          "500-8865",
          "500-8085",
          "502-0909",
          "500-8874",
          "502-0023",
          "500-8036",
          "500-8375",
          "500-8855",
          "500-8045",
          "500-8848",
          "500-8143",
          "500-8042",
          "500-8289",
          "500-8816",
          "500-8829",
          "502-0914",
          "500-8843",
          "500-8408",
          "500-8826",
          "500-8051",
          "501-3142",
          "500-8346",
          "500-8351",
          "500-8819",
          "500-8862",
          "500-8863",
          "500-8861",
          "500-8004",
          "502-0842",
          "502-0902",
          "502-0847",
          "502-0843",
          "502-0848",
          "502-0845",
          "501-0101",
          "501-1113",
          "501-1111",
          "500-8038",
          "500-8151",
          "500-8871",
          "502-0934",
          "500-8018",
          "502-0821",
          "500-8851",
          "500-8054",
          "500-8162",
          "501-6131",
          "500-8407",
          "500-8224",
          "500-8841",
          "500-8821",
          "500-8171",
          "500-8101",
          "500-8158",
          "500-8159",
          "500-8173",
          "500-8402",
          "500-8115",
          "500-8008",
          "500-8835",
          "500-8837",
          "501-2577",
          "501-2536",
          "501-2574",
          "501-2572",
          "501-2576",
          "501-2573",
          "501-2579",
          "501-2575",
          "501-2578",
          "501-2571",
          "502-0926",
          "502-0928",
          "502-0925",
          "502-0927",
          "502-0924",
          "500-8339",
          "501-6135",
          "500-8805",
          "500-8801",
          "500-8311",
          "502-0832",
          "500-8076",
          "500-8141",
          "500-8131",
          "502-0846",
          "502-0801",
          "500-8363",
          "500-8164",
          "500-8163",
          "500-8129",
          "500-8006",
          "500-8236",
          "500-8879",
          "501-2501",
          "500-8866",
          "501-0104",
          "500-8118",
          "500-8806",
          "500-8166",
          "500-8845",
          "500-8144",
          "500-8137",
          "502-0816",
          "500-8058",
          "500-8116",
          "500-8376",
          "501-1186",
          "500-8374",
          "501-1173",
          "500-8288",
          "500-8027",
          "502-0013",
          "501-1177",
          "500-8032",
          "500-8448",
          "500-8047",
          "500-8138",
          "501-2531",
          "501-2532",
          "500-8175",
          "500-8808",
          "500-8177",
          "500-8229",
          "500-8247",
          "500-8228",
          "502-0081",
          "502-0071",
          "502-0047",
          "502-0034",
          "502-0054",
          "502-0063",
          "502-0031",
          "502-0036",
          "502-0838",
          "502-0077",
          "502-0017",
          "502-0041",
          "502-0037",
          "502-0045",
          "502-0044",
          "502-0051",
          "502-0075",
          "502-0052",
          "502-0026",
          "502-0012",
          "502-0028",
          "502-0042",
          "502-0056",
          "502-0046",
          "502-0066",
          "502-0032",
          "502-0073",
          "502-0064",
          "502-0022",
          "502-0076",
          "502-0035",
          "502-0067",
          "502-0074",
          "502-0062",
          "502-0082",
          "502-0043",
          "502-0072",
          "502-0055",
          "502-0817",
          "502-0011",
          "502-0038",
          "502-0027",
          "502-0053",
          "502-0065",
          "502-0033",
          "502-0061",
          "502-0029",
          "500-8301",
          "501-6132",
          "500-8432",
          "501-1184",
          "500-8444",
          "500-8286",
          "501-1159",
          "501-1168",
          "501-1161",
          "501-1163",
          "501-1158",
          "501-1167",
          "501-1164",
          "501-1169",
          "501-1165",
          "501-1166",
          "501-1162",
          "500-8258",
          "500-8331",
          "500-8184",
          "501-0106",
          "500-8028",
          "502-0912",
          "500-8105",
          "500-8836",
          "500-8853",
          "502-0916",
          "500-8362",
          "500-8882",
          "500-8887",
          "500-8886",
          "502-0933",
          "500-8188",
          "500-8035",
          "500-8226",
          "502-0931",
          "502-0932",
          "502-0939",
          "502-0929",
          "501-1183",
          "500-8111",
          "500-8119",
          "500-8112",
          "500-8172",
          "500-8332",
          "500-8811",
          "500-8856",
          "500-8838",
          "500-8031",
          "500-8062",
          "502-0825",
          "500-8142",
          "500-8854",
          "502-0824",
          "500-8834",
          "501-2525",
          "501-2524",
          "502-0829",
          "502-0901",
          "500-8436",
          "501-1141",
          "500-8281",
          "501-1142",
          "501-1145",
          "501-1144",
          "501-1143",
          "500-8257",
          "500-8167",
          "500-8106",
          "500-8168",
          "500-8029",
          "502-0913",
          "500-8235",
          "501-6133",
          "501-1105",
          "501-1104",
          "501-1103",
          "500-8025",
          "500-8074",
          "501-0103",
          "501-0102",
          "501-1181",
          "500-8207",
          "500-8213",
          "500-8211",
          "500-8212",
          "500-8876",
          "500-8852",
          "500-8378",
          "500-8877",
          "500-8122",
          "500-8809",
          "501-1116",
          "500-8326",
          "500-8858",
          "502-0822",
          "501-2565",
          "501-2561",
          "501-2567",
          "501-2566",
          "501-2562",
          "501-2564",
          "501-2563",
          "502-0813",
          "502-0814",
          "502-0815",
          "500-8802",
          "501-1121",
          "501-1122",
          "501-1127",
          "501-1123",
          "501-1126",
          "501-1124",
          "501-1125",
          "500-8406",
          "502-0827",
          "500-8307",
          "500-8124",
          "500-8238",
          "500-8243",
          "500-8244",
          "500-8242",
          "501-1128",
          "500-8087",
          "502-0024",
          "500-8302",
          "500-8389",
          "500-8364",
          "500-8361",
          "500-8329",
          "500-8034",
          "500-8232",
          "500-8231",
          "502-0857",
          "502-0881",
          "502-0865",
          "502-0882",
          "502-0866",
          "500-8864",
          "501-1115",
          "500-8019",
          "501-1152",
          "501-1153",
          "501-1156",
          "501-1155",
          "501-1157",
          "501-1154",
          "502-0833",
          "500-8016",
          "500-8013",
          "500-8347",
          "500-8084",
          "500-8015",
          "500-8888",
          "500-8044",
          "500-8812",
          "500-8147",
          "502-0903",
          "500-8223",
          "500-8377",
          "500-8104",
          "501-2551",
          "501-2557",
          "501-2556",
          "501-2555",
          "501-2554",
          "501-2553",
          "501-2552",
          "500-8169",
          "502-0004",
          "502-0003",
          "500-8002",
          "500-8308",
          "500-8348",
          "500-8335",
          "500-8182",
          "500-8072",
          "500-8009",
          "500-8285",
          "501-1134",
          "502-0852",
          "500-8117",
          "500-8344",
          "500-8343",
          "500-8342",
          "500-8341",
          "502-0923",
          "500-8435",
          "500-8309",
          "502-0922",
          "501-2513",
          "501-2514",
          "501-2515",
          "501-2517",
          "501-3109",
          "500-8439",
          "500-8312",
          "501-1107",
          "500-8859",
          "500-8075",
          "500-8813",
          "501-2523",
          "500-8179",
          "500-8007",
          "500-8185",
          "500-8869",
          "502-0921",
          "501-2533",
          "501-2534",
          "500-8078",
          "500-8253",
          "500-8446",
          "500-8256",
          "500-8445",
          "502-0812",
          "500-8082",
          "500-8817",
          "500-8825",
          "501-6105",
          "501-6121",
          "501-6112",
          "501-6101",
          "501-6122",
          "501-6103",
          "501-6102",
          "501-6104",
          "501-6115",
          "501-6113",
          "501-6111",
          "501-6123",
          "500-8875",
          "500-8304",
          "501-1112",
          "500-8071",
          "500-8365",
          "500-8064",
          "500-8827",
          "500-8387",
          "500-8382",
          "500-8386",
          "500-8384",
          "501-2504",
          "501-2507",
          "501-2508",
          "501-2505",
          "501-2509",
          "501-2506",
          "501-2502",
          "500-8012",
          "502-0025",
          "500-8048",
          "502-0905",
          "500-8831",
          "500-8014",
          "500-8136",
          "502-0834",
          "500-8334",
          "500-8187",
          "500-8844",
          "500-8088",
          "501-2541",
          "501-2542",
          "501-2544",
          "501-2543",
          "501-2545",
          "500-8126",
          "500-8241",
          "500-8352",
          "500-8356",
          "500-8357",
          "500-8355",
          "500-8354",
          "500-8353",
          "500-8358",
          "500-8359",
          "500-8433",
          "502-0836",
          "502-0811",
          "500-8089",
          "500-8828",
          "503-0000",
          "503-2202",
          "503-2227",
          "503-2221",
          "503-0961",
          "503-2214",
          "503-2206",
          "503-2215",
          "503-2212",
          "503-2213",
          "503-0013",
          "503-0947",
          "503-0946",
          "503-0824",
          "503-0945",
          "503-0802",
          "503-0984",
          "503-0994",
          "503-0035",
          "503-0034",
          "503-0993",
          "503-2204",
          "503-2224",
          "503-2225",
          "503-2226",
          "503-0834",
          "503-0874",
          "503-0807",
          "503-0843",
          "503-0924",
          "503-0962",
          "503-0871",
          "503-0936",
          "503-0842",
          "503-0838",
          "503-2207",
          "503-0828",
          "503-0827",
          "503-0826",
          "503-0836",
          "503-0863",
          "503-0001",
          "503-0956",
          "503-0814",
          "503-0898",
          "503-0007",
          "503-0002",
          "503-0006",
          "503-0008",
          "503-0023",
          "503-0027",
          "503-0823",
          "503-0021",
          "503-0937",
          "503-1614",
          "503-1633",
          "503-1622",
          "503-1611",
          "503-1601",
          "503-1638",
          "503-1613",
          "503-1623",
          "503-1621",
          "503-1632",
          "503-1612",
          "503-1637",
          "503-1635",
          "503-1636",
          "503-1626",
          "503-1634",
          "503-1631",
          "503-1602",
          "503-1624",
          "503-1625",
          "503-0964",
          "503-0957",
          "503-0941",
          "503-0917",
          "503-0019",
          "503-0915",
          "503-0973",
          "503-0881",
          "503-0982",
          "503-0926",
          "503-0904",
          "503-0991",
          "503-0974",
          "503-0032",
          "503-0902",
          "503-0887",
          "503-0886",
          "503-0816",
          "503-2203",
          "503-0036",
          "503-0877",
          "503-0832",
          "503-0803",
          "503-0847",
          "503-0009",
          "503-0821",
          "503-0813",
          "503-0983",
          "503-0865",
          "503-0935",
          "503-0996",
          "503-0883",
          "503-0995",
          "503-0024",
          "503-0817",
          "503-0942",
          "503-0004",
          "503-0894",
          "503-0856",
          "503-0831",
          "503-0992",
          "503-0921",
          "503-0872",
          "503-2205",
          "503-2208",
          "503-0815",
          "503-0103",
          "503-0106",
          "503-0104",
          "503-0102",
          "503-0101",
          "503-0105",
          "503-0822",
          "503-2201",
          "503-0933",
          "503-0951",
          "503-0011",
          "503-0934",
          "503-0895",
          "503-0889",
          "503-0913",
          "503-0896",
          "503-0958",
          "503-0959",
          "503-0901",
          "503-0965",
          "503-0853",
          "503-0878",
          "503-0892",
          "503-0875",
          "503-0876",
          "503-0891",
          "503-0854",
          "503-0003",
          "503-0805",
          "503-0897",
          "503-0855",
          "503-0954",
          "503-0955",
          "503-0839",
          "503-0017",
          "503-0833",
          "503-0986",
          "503-0804",
          "503-0022",
          "503-0884",
          "503-0997",
          "503-0844",
          "503-0963",
          "503-0899",
          "503-0918",
          "503-0908",
          "503-0914",
          "503-0018",
          "503-0851",
          "503-0852",
          "503-0985",
          "503-0861",
          "503-0811",
          "503-0912",
          "503-0825",
          "503-0922",
          "503-0015",
          "503-0907",
          "503-0903",
          "503-0882",
          "503-0835",
          "503-0849",
          "503-0981",
          "503-0916",
          "503-0141",
          "503-0841",
          "503-2216",
          "503-0846",
          "503-0033",
          "503-0893",
          "503-0862",
          "503-0923",
          "503-0848",
          "503-0972",
          "503-0885",
          "503-0845",
          "503-0031",
          "503-0888",
          "503-0812",
          "503-0808",
          "503-0012",
          "503-0806",
          "503-0025",
          "503-2211",
          "503-0971",
          "503-0925",
          "503-0873",
          "503-0864",
          "503-0977",
          "503-0976",
          "503-0905",
          "503-0857",
          "503-0911",
          "503-0906",
          "503-0026",
          "503-0931",
          "503-0932",
          "503-0016",
          "503-0837",
          "503-2223",
          "503-0944",
          "503-0943",
          "503-2222",
          "503-0858",
          "503-0014",
          "503-0975",
          "503-0801",
          "503-0005",
          "503-0953",
          "503-0952",
          "506-0000",
          "506-0014",
          "506-0045",
          "506-0806",
          "506-0042",
          "509-3301",
          "509-3324",
          "509-3303",
          "509-3311",
          "509-3322",
          "509-3326",
          "509-3316",
          "509-3313",
          "509-3321",
          "509-3312",
          "509-3305",
          "509-3317",
          "509-3327",
          "509-3304",
          "509-3323",
          "509-3302",
          "509-3314",
          "509-3325",
          "509-3306",
          "509-3315",
          "506-0017",
          "506-0855",
          "506-0825",
          "509-3505",
          "506-0815",
          "506-0013",
          "506-0812",
          "506-0801",
          "506-0033",
          "506-0818",
          "506-0851",
          "506-0816",
          "506-0811",
          "506-0054",
          "506-1429",
          "506-1425",
          "506-1424",
          "506-1421",
          "506-1428",
          "506-1427",
          "506-1426",
          "506-1423",
          "506-1422",
          "506-1432",
          "506-1433",
          "506-1434",
          "506-1431",
          "506-0835",
          "506-0824",
          "506-0847",
          "506-0844",
          "506-0845",
          "506-0846",
          "506-0055",
          "506-0024",
          "506-0044",
          "506-1312",
          "506-1315",
          "506-1303",
          "506-1318",
          "506-1308",
          "506-1301",
          "506-1314",
          "506-1313",
          "506-1319",
          "506-1307",
          "506-1302",
          "506-1305",
          "506-1311",
          "506-1317",
          "506-1306",
          "506-1304",
          "506-1316",
          "506-0023",
          "506-0006",
          "506-0203",
          "506-0201",
          "506-0202",
          "509-2702",
          "506-0206",
          "506-0106",
          "506-0107",
          "506-0205",
          "509-2701",
          "506-0204",
          "506-0104",
          "506-0103",
          "506-0101",
          "506-0102",
          "506-0105",
          "506-0207",
          "506-0004",
          "509-3212",
          "509-3218",
          "509-3201",
          "509-3205",
          "509-3204",
          "509-3211",
          "509-3202",
          "509-3207",
          "509-3216",
          "509-3217",
          "509-3213",
          "509-3215",
          "509-3214",
          "509-3203",
          "509-3206",
          "509-4104",
          "509-4121",
          "509-4126",
          "509-4106",
          "509-4123",
          "509-4116",
          "509-4113",
          "509-4101",
          "509-4117",
          "509-4112",
          "509-4122",
          "509-4107",
          "509-4125",
          "509-4114",
          "509-4108",
          "509-4119",
          "509-4115",
          "509-4105",
          "509-4103",
          "509-4124",
          "509-4111",
          "509-4102",
          "506-0853",
          "506-0858",
          "506-0807",
          "506-0813",
          "506-0836",
          "506-0843",
          "506-0842",
          "506-0841",
          "506-0052",
          "506-0041",
          "506-0046",
          "506-0059",
          "501-5421",
          "501-5413",
          "501-5415",
          "501-5423",
          "501-5422",
          "501-5426",
          "501-5425",
          "501-5404",
          "501-5414",
          "501-5402",
          "501-5406",
          "501-5405",
          "501-5424",
          "501-5412",
          "501-5417",
          "501-5411",
          "501-5416",
          "501-5403",
          "501-5401",
          "506-0053",
          "506-0822",
          "506-0035",
          "506-0821",
          "506-0016",
          "506-0834",
          "506-0007",
          "506-0856",
          "509-3401",
          "509-3417",
          "509-3415",
          "509-3412",
          "509-3411",
          "509-3418",
          "509-3404",
          "509-3413",
          "509-3405",
          "509-3414",
          "509-3416",
          "509-3402",
          "509-3419",
          "509-3403",
          "506-0814",
          "506-0057",
          "506-0032",
          "506-0857",
          "506-0832",
          "506-0025",
          "506-0002",
          "506-0043",
          "506-0051",
          "506-0804",
          "506-0021",
          "506-0005",
          "506-0031",
          "506-0833",
          "506-0022",
          "506-2113",
          "506-2253",
          "506-2112",
          "506-2254",
          "506-2111",
          "506-2131",
          "506-2116",
          "506-2104",
          "506-2103",
          "506-2106",
          "506-2133",
          "506-2134",
          "506-2252",
          "506-2115",
          "506-2117",
          "506-2105",
          "506-2258",
          "506-2135",
          "506-2118",
          "506-2257",
          "506-2255",
          "506-2124",
          "506-2251",
          "506-2114",
          "506-2256",
          "506-2121",
          "506-2132",
          "506-2125",
          "506-2123",
          "506-2101",
          "506-2122",
          "506-0012",
          "506-0852",
          "506-0008",
          "506-0009",
          "506-0015",
          "506-0026",
          "506-0838",
          "506-0805",
          "506-0803",
          "506-0831",
          "506-0001",
          "506-0003",
          "506-0837",
          "506-0011",
          "506-0048",
          "506-0034",
          "506-0802",
          "506-0808",
          "506-0056",
          "506-0823",
          "506-0817",
          "506-0058",
          "506-0047",
          "506-0854",
          "507-0000",
          "507-0837",
          "507-0057",
          "507-0071",
          "507-0807",
          "507-0048",
          "507-0814",
          "507-0027",
          "507-0075",
          "507-0074",
          "507-0062",
          "507-0818",
          "507-0815",
          "507-0817",
          "507-0816",
          "507-0068",
          "507-0822",
          "507-0023",
          "507-0037",
          "507-0004",
          "507-0005",
          "507-0001",
          "507-0007",
          "507-0006",
          "507-0002",
          "507-0003",
          "507-0846",
          "507-0901",
          "507-0016",
          "507-0832",
          "507-0821",
          "507-0806",
          "507-0022",
          "507-0064",
          "507-0067",
          "507-0055",
          "507-0008",
          "507-0825",
          "507-0073",
          "507-0014",
          "507-0026",
          "507-0077",
          "507-0804",
          "507-0035",
          "507-0045",
          "507-0812",
          "507-0039",
          "507-0076",
          "507-0847",
          "507-0836",
          "507-0805",
          "507-0831",
          "507-0838",
          "507-0015",
          "507-0044",
          "507-0031",
          "507-0024",
          "507-0032",
          "507-0041",
          "507-0018",
          "507-0011",
          "507-0012",
          "507-0078",
          "507-0054",
          "507-0813",
          "507-0036",
          "507-0043",
          "507-0046",
          "507-0013",
          "507-0844",
          "507-0843",
          "507-0034",
          "507-0842",
          "507-0017",
          "507-0835",
          "507-0051",
          "507-0066",
          "507-0065",
          "507-0038",
          "507-0052",
          "507-0801",
          "507-0019",
          "507-0848",
          "507-0061",
          "507-0058",
          "507-0823",
          "507-0833",
          "507-0047",
          "507-0827",
          "507-0028",
          "507-0811",
          "507-0033",
          "507-0042",
          "507-0063",
          "507-0828",
          "507-0803",
          "507-0021",
          "507-0025",
          "507-0056",
          "507-0834",
          "507-0841",
          "507-0072",
          "507-0824",
          "507-0845",
          "507-0802",
          "507-0053",
          "507-0826",
          "501-3200",
          "501-3851",
          "501-3978",
          "501-3852",
          "501-3853",
          "501-3829",
          "501-3808",
          "501-3807",
          "501-3845",
          "501-3264",
          "501-3247",
          "501-3966",
          "501-3841",
          "501-2901",
          "501-3822",
          "501-3979",
          "501-3932",
          "501-3913",
          "501-3914",
          "501-3855",
          "501-3951",
          "501-3974",
          "501-3804",
          "501-3922",
          "501-3801",
          "501-3265",
          "501-3268",
          "501-3266",
          "501-3201",
          "501-3210",
          "501-3941",
          "501-3910",
          "501-3214",
          "501-3871",
          "501-3865",
          "501-3963",
          "501-3872",
          "501-3862",
          "501-3204",
          "501-3947",
          "501-3203",
          "501-3601",
          "501-3877",
          "501-3235",
          "501-3835",
          "501-3806",
          "501-3917",
          "501-3245",
          "501-3843",
          "501-3876",
          "501-3942",
          "501-3938",
          "501-3934",
          "501-3936",
          "501-3930",
          "501-3207",
          "501-3927",
          "501-3908",
          "501-3926",
          "501-3861",
          "501-3241",
          "501-3253",
          "501-3888",
          "501-3903",
          "501-3856",
          "501-3931",
          "501-3232",
          "501-3252",
          "501-3251",
          "501-3935",
          "501-3878",
          "501-3205",
          "501-3972",
          "501-3977",
          "501-3217",
          "501-3955",
          "501-3521",
          "501-3259",
          "501-3250",
          "501-3258",
          "501-3965",
          "501-3868",
          "501-3257",
          "501-3923",
          "501-3909",
          "501-3847",
          "501-3905",
          "501-3848",
          "501-3846",
          "501-3961",
          "501-3826",
          "501-3211",
          "501-3866",
          "501-3954",
          "501-3953",
          "501-3957",
          "501-3952",
          "501-3833",
          "501-3834",
          "501-3964",
          "501-3223",
          "501-3228",
          "501-3255",
          "501-3968",
          "501-3854",
          "501-3236",
          "501-3946",
          "501-3842",
          "501-3212",
          "501-3915",
          "501-3939",
          "501-3824",
          "501-3206",
          "501-3867",
          "501-3887",
          "501-3958",
          "501-3501",
          "501-3863",
          "501-3916",
          "501-3975",
          "501-3511",
          "501-3243",
          "501-3817",
          "501-3839",
          "501-3828",
          "501-3967",
          "501-3906",
          "501-3221",
          "501-3202",
          "501-3233",
          "501-3215",
          "501-3928",
          "501-3882",
          "501-3244",
          "501-3803",
          "501-3819",
          "501-3837",
          "501-3943",
          "501-3945",
          "501-3219",
          "501-3976",
          "501-3924",
          "501-3925",
          "501-3831",
          "501-3832",
          "501-3256",
          "501-3969",
          "501-3901",
          "501-3213",
          "501-3231",
          "501-3218",
          "501-3224",
          "501-3921",
          "501-3823",
          "501-3813",
          "501-3883",
          "501-3242",
          "501-3812",
          "501-3811",
          "501-3815",
          "501-3838",
          "501-3814",
          "501-3911",
          "501-3973",
          "501-3873",
          "501-3821",
          "501-3263",
          "501-3261",
          "501-3262",
          "501-3971",
          "501-3919",
          "501-3874",
          "501-3956",
          "501-3227",
          "501-3267",
          "501-2807",
          "501-2812",
          "501-2816",
          "501-2805",
          "501-2809",
          "501-2811",
          "501-2801",
          "501-2815",
          "501-2806",
          "501-2808",
          "501-2817",
          "501-2814",
          "501-2802",
          "501-2803",
          "501-3805",
          "501-3886",
          "501-3864",
          "501-3937",
          "501-3884",
          "501-3216",
          "501-3836",
          "501-3246",
          "501-3237",
          "501-3222",
          "501-3857",
          "501-3225",
          "501-3918",
          "501-3825",
          "501-3907",
          "501-3912",
          "501-3827",
          "501-3844",
          "501-3226",
          "501-2605",
          "501-2607",
          "501-2602",
          "501-2604",
          "501-2601",
          "501-2603",
          "501-2606",
          "501-3933",
          "501-3904",
          "501-3881",
          "501-3875",
          "501-3962",
          "501-3944",
          "501-3885",
          "501-3902",
          "501-3254",
          "501-3816",
          "501-3818",
          "501-3802",
          "501-3234",
          "508-0000",
          "508-0002",
          "509-7321",
          "509-7322",
          "509-9231",
          "508-0037",
          "508-0033",
          "508-0023",
          "508-0006",
          "508-0421",
          "508-0045",
          "509-9201",
          "508-0022",
          "508-0011",
          "508-0014",
          "508-0032",
          "509-9232",
          "508-0202",
          "508-0044",
          "508-0038",
          "508-0111",
          "509-9131",
          "508-0204",
          "508-0201",
          "508-0351",
          "508-0012",
          "508-0015",
          "508-0101",
          "508-0003",
          "508-0021",
          "508-0001",
          "509-9132",
          "508-0042",
          "508-0043",
          "508-0004",
          "508-0035",
          "508-0036",
          "508-0005",
          "509-8301",
          "508-0203",
          "508-0041",
          "508-0502",
          "508-0007",
          "508-0031",
          "508-0024",
          "508-0013",
          "508-0501",
          "508-0034",
          "501-3700",
          "501-3701",
          "501-3723",
          "501-3762",
          "501-3717",
          "501-3756",
          "501-3729",
          "501-3724",
          "501-3715",
          "501-3786",
          "501-3771",
          "501-3772",
          "501-3764",
          "501-3726",
          "501-3781",
          "501-3702",
          "501-3743",
          "501-3787",
          "501-3733",
          "501-3783",
          "501-3712",
          "501-3785",
          "501-3763",
          "501-3736",
          "501-3754",
          "501-3755",
          "501-3703",
          "501-3745",
          "501-3752",
          "501-3737",
          "501-3706",
          "501-3714",
          "501-3705",
          "501-3725",
          "501-3744",
          "501-3734",
          "501-3746",
          "501-3722",
          "501-3742",
          "501-3713",
          "501-3727",
          "501-3782",
          "501-3735",
          "501-3731",
          "501-3711",
          "501-3732",
          "501-3704",
          "501-3716",
          "501-3751",
          "501-3753",
          "501-3784",
          "501-3741",
          "501-3728",
          "501-3773",
          "501-3761",
          "501-3721",
          "501-3788",
          "509-6100",
          "509-6131",
          "509-6133",
          "509-6132",
          "509-6124",
          "509-6103",
          "509-6102",
          "509-6122",
          "509-6125",
          "509-6471",
          "509-6112",
          "509-6106",
          "509-6472",
          "509-6115",
          "509-6111",
          "509-6363",
          "509-6361",
          "509-6362",
          "509-6127",
          "509-6126",
          "509-6123",
          "509-6121",
          "509-6101",
          "509-6114",
          "509-6251",
          "509-6107",
          "509-6108",
          "509-6134",
          "509-6116",
          "509-6128",
          "509-6105",
          "509-6135",
          "509-6104",
          "509-6113",
          "501-6200",
          "501-6207",
          "501-6202",
          "501-6201",
          "501-6204",
          "501-6208",
          "501-6209",
          "501-6203",
          "501-6205",
          "501-6236",
          "501-6238",
          "501-6237",
          "501-6239",
          "501-6273",
          "501-6272",
          "501-6262",
          "501-6263",
          "501-6266",
          "501-6265",
          "501-6264",
          "501-6253",
          "501-6252",
          "501-6261",
          "501-6267",
          "501-6271",
          "501-6274",
          "501-6312",
          "501-6317",
          "501-6318",
          "501-6319",
          "501-6311",
          "501-6323",
          "501-6325",
          "501-6324",
          "501-6327",
          "501-6326",
          "501-6328",
          "501-6322",
          "501-6321",
          "501-6315",
          "501-6316",
          "501-6313",
          "501-6314",
          "501-6206",
          "501-6241",
          "501-6233",
          "501-6231",
          "501-6232",
          "501-6234",
          "501-6242",
          "501-6243",
          "501-6235",
          "501-6244",
          "501-6255",
          "501-6256",
          "501-6257",
          "501-6254",
          "501-6251",
          "501-6302",
          "501-6304",
          "501-6303",
          "501-6301",
          "501-6338",
          "501-6336",
          "501-6335",
          "501-6332",
          "501-6337",
          "501-6333",
          "501-6334",
          "501-6331",
          "501-6330",
          "501-6225",
          "501-6224",
          "501-6223",
          "501-6212",
          "501-6229",
          "501-6216",
          "501-6215",
          "501-6214",
          "501-6217",
          "501-6218",
          "501-6228",
          "501-6227",
          "501-6213",
          "501-6226",
          "501-6211",
          "501-6221",
          "501-6222",
          "509-7200",
          "509-7731",
          "509-7725",
          "509-7721",
          "509-7723",
          "509-7726",
          "509-7702",
          "509-7701",
          "509-7711",
          "509-7724",
          "509-7708",
          "509-7703",
          "509-7704",
          "509-7713",
          "509-7705",
          "509-7707",
          "509-7714",
          "509-7722",
          "509-7715",
          "509-7718",
          "509-7716",
          "509-7712",
          "509-7717",
          "509-7706",
          "509-8232",
          "509-7403",
          "509-7401",
          "509-7402",
          "509-7201",
          "509-7206",
          "509-7203",
          "509-7204",
          "509-7205",
          "509-7211",
          "509-7207",
          "509-7209",
          "509-7208",
          "509-7521",
          "509-7511",
          "509-7513",
          "509-7512",
          "509-7502",
          "509-7501",
          "509-7504",
          "509-7505",
          "509-7503",
          "509-7506",
          "509-7507",
          "509-7831",
          "509-7814",
          "509-7816",
          "509-7821",
          "509-7813",
          "509-7815",
          "509-7824",
          "509-7822",
          "509-7825",
          "509-7826",
          "509-7823",
          "509-7802",
          "509-7804",
          "509-7801",
          "509-7811",
          "509-7806",
          "509-7803",
          "509-7805",
          "509-7812",
          "509-7126",
          "509-7122",
          "509-7121",
          "509-8231",
          "509-7202",
          "509-7124",
          "509-7123",
          "509-7125",
          "509-7604",
          "509-7603",
          "509-7601",
          "509-7607",
          "509-7608",
          "509-7606",
          "509-7602",
          "509-7605",
          "505-0000",
          "505-0029",
          "505-0008",
          "505-0041",
          "505-0042",
          "505-0035",
          "505-0044",
          "505-0056",
          "505-0055",
          "505-0052",
          "505-0054",
          "505-0053",
          "505-0051",
          "505-0022",
          "505-0045",
          "505-0034",
          "505-0025",
          "505-0026",
          "505-0015",
          "505-0017",
          "505-0019",
          "505-0018",
          "505-0013",
          "505-0014",
          "505-0011",
          "505-0012",
          "505-0031",
          "505-0032",
          "505-0038",
          "505-0033",
          "505-0046",
          "505-0023",
          "505-0039",
          "505-0006",
          "505-0004",
          "505-0005",
          "505-0007",
          "505-0009",
          "505-0043",
          "505-0027",
          "505-0037",
          "505-0016",
          "505-0024",
          "505-0002",
          "505-0001",
          "505-0021",
          "505-0028",
          "505-0036",
          "505-0003",
          "509-5100",
          "509-5403",
          "509-5144",
          "509-5141",
          "509-5107",
          "509-5136",
          "509-5151",
          "509-5145",
          "509-5171",
          "509-5147",
          "509-5134",
          "509-5133",
          "509-5152",
          "509-5131",
          "509-5104",
          "509-5106",
          "509-5105",
          "509-5153",
          "509-5154",
          "509-5103",
          "509-5146",
          "509-5135",
          "509-5161",
          "509-5132",
          "509-5101",
          "509-5142",
          "509-5102",
          "509-5143",
          "509-5201",
          "509-5203",
          "509-5202",
          "509-5402",
          "509-5401",
          "509-5302",
          "509-5301",
          "509-5312",
          "509-5311",
          "509-5127",
          "509-5124",
          "509-5123",
          "509-5126",
          "509-5121",
          "509-5122",
          "509-5117",
          "509-5118",
          "509-5112",
          "509-5111",
          "509-5113",
          "509-5116",
          "509-5114",
          "509-5115",
          "509-5125",
          "504-0000",
          "509-0111",
          "509-0145",
          "509-0144",
          "509-0141",
          "509-0147",
          "509-0143",
          "509-0117",
          "509-0135",
          "509-0126",
          "509-0132",
          "509-0133",
          "509-0123",
          "509-0134",
          "509-0142",
          "509-0146",
          "509-0125",
          "509-0124",
          "509-0121",
          "504-0931",
          "504-0934",
          "504-0004",
          "504-0003",
          "504-0002",
          "509-0104",
          "509-0102",
          "509-0103",
          "509-0106",
          "509-0107",
          "509-0105",
          "504-0933",
          "504-0926",
          "504-0971",
          "501-6021",
          "501-6029",
          "501-6023",
          "501-6025",
          "501-6024",
          "501-6022",
          "501-6026",
          "501-6027",
          "501-6028",
          "504-0957",
          "504-0942",
          "509-0127",
          "504-0924",
          "504-0932",
          "504-0927",
          "509-0122",
          "509-0101",
          "509-0108",
          "504-0841",
          "504-0824",
          "504-0808",
          "504-0851",
          "504-0847",
          "504-0825",
          "504-0823",
          "504-0801",
          "504-0844",
          "504-0829",
          "504-0807",
          "504-0853",
          "504-0814",
          "504-0812",
          "504-0822",
          "504-0826",
          "504-0845",
          "504-0827",
          "504-0856",
          "504-0805",
          "504-0855",
          "504-0804",
          "504-0821",
          "504-0843",
          "504-0813",
          "504-0903",
          "504-0842",
          "504-0815",
          "504-0803",
          "504-0806",
          "504-0854",
          "504-0832",
          "504-0816",
          "504-0852",
          "504-0809",
          "504-0904",
          "504-0831",
          "504-0902",
          "504-0012",
          "504-0013",
          "504-0828",
          "504-0802",
          "504-0846",
          "504-0905",
          "504-0811",
          "509-0131",
          "509-0109",
          "504-0962",
          "504-0036",
          "504-0007",
          "504-0044",
          "504-0047",
          "504-0837",
          "504-0009",
          "504-0033",
          "504-0001",
          "504-0908",
          "504-0016",
          "504-0031",
          "504-0943",
          "504-0005",
          "504-0963",
          "504-0011",
          "504-0008",
          "504-0906",
          "504-0916",
          "504-0037",
          "504-0006",
          "504-0024",
          "504-0954",
          "504-0912",
          "504-0834",
          "504-0958",
          "504-0045",
          "504-0961",
          "504-0032",
          "504-0907",
          "504-0023",
          "504-0913",
          "504-0038",
          "504-0043",
          "504-0022",
          "504-0901",
          "504-0041",
          "504-0046",
          "504-0018",
          "504-0959",
          "504-0952",
          "504-0968",
          "504-0945",
          "504-0025",
          "504-0909",
          "504-0839",
          "504-0034",
          "504-0953",
          "504-0015",
          "504-0965",
          "504-0836",
          "504-0951",
          "504-0838",
          "504-0966",
          "504-0026",
          "504-0021",
          "504-0944",
          "504-0955",
          "504-0035",
          "504-0964",
          "504-0911",
          "504-0042",
          "504-0014",
          "504-0017",
          "504-0835",
          "504-0967",
          "504-0935",
          "504-0833",
          "504-0861",
          "504-0922",
          "504-0923",
          "504-0921",
          "509-0136",
          "504-0925",
          "504-0956",
          "504-0941",
          "504-0914",
          "504-0915",
          "504-0928",
          "509-0114",
          "509-0113",
          "509-0116",
          "509-0115",
          "509-0112",
          "509-0200",
          "509-0259",
          "509-0215",
          "509-0216",
          "509-0246",
          "509-0207",
          "509-0238",
          "509-0239",
          "509-0233",
          "509-0212",
          "509-0266",
          "509-0237",
          "505-0130",
          "509-0201",
          "509-0208",
          "509-0224",
          "509-0234",
          "509-0255",
          "509-0241",
          "509-0235",
          "509-0236",
          "509-0251",
          "509-0248",
          "509-0203",
          "509-0245",
          "509-0247",
          "509-0262",
          "509-0213",
          "509-0204",
          "509-0205",
          "509-0206",
          "509-0202",
          "509-0257",
          "509-0254",
          "509-0265",
          "509-0261",
          "509-0232",
          "509-0222",
          "509-0264",
          "509-0223",
          "509-0256",
          "509-0249",
          "509-0217",
          "509-0214",
          "509-0221",
          "509-0211",
          "509-0230",
          "509-0218",
          "509-0250",
          "509-0240",
          "509-0263",
          "509-0231",
          "509-0253",
          "509-0252",
          "509-0242",
          "509-0258",
          "501-2100",
          "501-2252",
          "501-2256",
          "501-2111",
          "501-2102",
          "501-2259",
          "501-2115",
          "501-2302",
          "501-2101",
          "501-2123",
          "501-2251",
          "501-2132",
          "501-2303",
          "501-2301",
          "501-2331",
          "501-2124",
          "501-2114",
          "501-2314",
          "501-2312",
          "501-2103",
          "501-2133",
          "501-2121",
          "501-2113",
          "501-2105",
          "501-2315",
          "501-2321",
          "501-2311",
          "501-2254",
          "501-2313",
          "501-2257",
          "501-2135",
          "501-2258",
          "501-2112",
          "501-2104",
          "501-2253",
          "501-2131",
          "501-2122",
          "501-2255",
          "501-2125",
          "501-2134",
          "501-0200",
          "501-0302",
          "501-0224",
          "501-0234",
          "501-0306",
          "501-0307",
          "501-0237",
          "501-0311",
          "501-0313",
          "501-0314",
          "501-0235",
          "501-0225",
          "501-0221",
          "501-0304",
          "501-0323",
          "501-0301",
          "501-0211",
          "501-0214",
          "501-0217",
          "501-0212",
          "501-0215",
          "501-0216",
          "501-0213",
          "501-0232",
          "501-0231",
          "501-0201",
          "501-0206",
          "501-0205",
          "501-0203",
          "501-0204",
          "501-0202",
          "501-0322",
          "501-0222",
          "501-0233",
          "501-0223",
          "501-0236",
          "501-0312",
          "501-0305",
          "501-0303",
          "501-0321",
          "501-0324",
          "506-1100",
          "506-1121",
          "506-1147",
          "506-1149",
          "506-1131",
          "506-1162",
          "506-1212",
          "506-1132",
          "506-1106",
          "506-1103",
          "506-1102",
          "506-1125",
          "506-1158",
          "506-1145",
          "506-1143",
          "506-1122",
          "506-1126",
          "506-1211",
          "506-1114",
          "506-1107",
          "506-1123",
          "506-1204",
          "506-1133",
          "506-1157",
          "506-1108",
          "506-1148",
          "506-1201",
          "506-1152",
          "506-1213",
          "506-1202",
          "506-1151",
          "506-1155",
          "506-1215",
          "506-1206",
          "506-1141",
          "506-1216",
          "506-1111",
          "506-1205",
          "506-1154",
          "506-1217",
          "506-1161",
          "506-1153",
          "506-1214",
          "506-1142",
          "506-1146",
          "506-1104",
          "506-1156",
          "506-1124",
          "506-1203",
          "506-1113",
          "506-1144",
          "506-1101",
          "506-1105",
          "506-1112",
          "509-4315",
          "509-4312",
          "509-4303",
          "509-4311",
          "509-4316",
          "509-4302",
          "509-4317",
          "509-4318",
          "509-4314",
          "509-4301",
          "509-4306",
          "509-4304",
          "506-0271",
          "509-4313",
          "509-4305",
          "509-4252",
          "509-4234",
          "509-4265",
          "509-4255",
          "509-4222",
          "509-4225",
          "509-4212",
          "509-4263",
          "509-4254",
          "509-4243",
          "509-4275",
          "509-4203",
          "509-4245",
          "509-4244",
          "509-4237",
          "509-4274",
          "509-4236",
          "509-4213",
          "509-4261",
          "509-4231",
          "509-4205",
          "509-4233",
          "509-4215",
          "509-4201",
          "509-4211",
          "509-4256",
          "509-4271",
          "509-4273",
          "509-4202",
          "509-4224",
          "509-4262",
          "509-4253",
          "509-4235",
          "509-4214",
          "509-4204",
          "509-4272",
          "509-4223",
          "509-4264",
          "509-4232",
          "509-4242",
          "509-4251",
          "509-4241",
          "509-4221",
          "509-4541",
          "509-4531",
          "509-4545",
          "509-4414",
          "509-4415",
          "509-4412",
          "509-4543",
          "509-4413",
          "509-4403",
          "509-4533",
          "509-4401",
          "509-4542",
          "509-4404",
          "509-4421",
          "509-4402",
          "509-4544",
          "509-4534",
          "509-4422",
          "509-4535",
          "509-4411",
          "509-4423",
          "509-4532",
          "509-4406",
          "509-4405",
          "509-4424",
          "501-0400",
          "501-0475",
          "501-0415",
          "501-0410",
          "501-0405",
          "501-0476",
          "501-0414",
          "501-0411",
          "501-0401",
          "501-0461",
          "501-0465",
          "501-0403",
          "501-1232",
          "501-0402",
          "501-1235",
          "501-0463",
          "501-0474",
          "501-1234",
          "501-1236",
          "501-0418",
          "501-0472",
          "501-0466",
          "501-0464",
          "501-0416",
          "501-1205",
          "501-0462",
          "501-1233",
          "501-0412",
          "501-0473",
          "501-1524",
          "501-1521",
          "501-1525",
          "501-1527",
          "501-1535",
          "501-1507",
          "501-1514",
          "501-1518",
          "501-1532",
          "501-1501",
          "501-1531",
          "501-1511",
          "501-1523",
          "501-1515",
          "501-1502",
          "501-1534",
          "501-1512",
          "501-1528",
          "501-1522",
          "501-1504",
          "501-1533",
          "501-1505",
          "501-1503",
          "501-1517",
          "501-1506",
          "501-1516",
          "501-1526",
          "501-1513",
          "501-1529",
          "501-1536",
          "501-0419",
          "501-0404",
          "501-1231",
          "501-0407",
          "501-1203",
          "501-1202",
          "501-0471",
          "501-0406",
          "501-0413",
          "501-0417",
          "501-1201",
          "501-4200",
          "501-5111",
          "501-5231",
          "501-5124",
          "501-5115",
          "501-5125",
          "501-5121",
          "501-5122",
          "501-5104",
          "501-5123",
          "501-5116",
          "501-5114",
          "501-5113",
          "501-5105",
          "501-5103",
          "501-5102",
          "501-5101",
          "501-5126",
          "501-5112",
          "501-5304",
          "501-5303",
          "501-5305",
          "501-5301",
          "501-5302",
          "501-4236",
          "501-4205",
          "501-4204",
          "501-4235",
          "501-4201",
          "501-4202",
          "501-4223",
          "501-4451",
          "501-4219",
          "501-4217",
          "501-4455",
          "501-4221",
          "501-4231",
          "501-4218",
          "501-4234",
          "501-4215",
          "501-4228",
          "501-4238",
          "501-4222",
          "501-4224",
          "501-4212",
          "501-4203",
          "501-4226",
          "501-4453",
          "501-4233",
          "501-4225",
          "501-4213",
          "501-4211",
          "501-4237",
          "501-4207",
          "501-4454",
          "501-4227",
          "501-4232",
          "501-4216",
          "501-4452",
          "501-4241",
          "501-4214",
          "501-4206",
          "501-4104",
          "501-4107",
          "501-4101",
          "501-4102",
          "501-4106",
          "501-4105",
          "501-4103",
          "501-4301",
          "501-4305",
          "501-4304",
          "501-4302",
          "501-4303",
          "501-4306",
          "501-4307",
          "501-4618",
          "501-4601",
          "501-4619",
          "501-4606",
          "501-4605",
          "501-4603",
          "501-4602",
          "501-4610",
          "501-4612",
          "501-4607",
          "501-4613",
          "501-4614",
          "501-4615",
          "501-4616",
          "501-4604",
          "501-4617",
          "501-4608",
          "501-4611",
          "501-4514",
          "501-4501",
          "501-4508",
          "501-4512",
          "501-4517",
          "501-4509",
          "501-4513",
          "501-4511",
          "501-4504",
          "501-4518",
          "501-4503",
          "501-4505",
          "501-4515",
          "501-4510",
          "501-4516",
          "501-4507",
          "501-4502",
          "501-4506",
          "509-2200",
          "509-2203",
          "509-3114",
          "509-3101",
          "509-3103",
          "509-3106",
          "509-3112",
          "509-3104",
          "509-3111",
          "509-3102",
          "509-3105",
          "509-3115",
          "509-3107",
          "509-3113",
          "509-2138",
          "509-2424",
          "509-1603",
          "509-1602",
          "509-1614",
          "509-1607",
          "509-1622",
          "509-1616",
          "509-1623",
          "509-1624",
          "509-1606",
          "509-1615",
          "509-1605",
          "509-1611",
          "509-1613",
          "509-1604",
          "509-1612",
          "509-1601",
          "509-1621",
          "509-2131",
          "509-2206",
          "509-2204",
          "509-2205",
          "509-2136",
          "509-2422",
          "509-2421",
          "509-2313",
          "509-2311",
          "509-2504",
          "509-2516",
          "509-2512",
          "509-2519",
          "509-2508",
          "509-2513",
          "509-2502",
          "509-2518",
          "509-2514",
          "509-2503",
          "509-2507",
          "509-2517",
          "509-2515",
          "509-2506",
          "509-2505",
          "509-2511",
          "509-2501",
          "509-2132",
          "509-2201",
          "509-2423",
          "509-2137",
          "509-2613",
          "509-2601",
          "509-2602",
          "509-2603",
          "509-2614",
          "509-2604",
          "509-2612",
          "509-2615",
          "509-2611",
          "509-2135",
          "509-2312",
          "509-2314",
          "509-2202",
          "509-2134",
          "509-2207",
          "509-2133",
          "503-0600",
          "503-0611",
          "503-0625",
          "503-0629",
          "503-0631",
          "503-0635",
          "503-0612",
          "503-0624",
          "503-0608",
          "503-0603",
          "503-0646",
          "503-0618",
          "503-0645",
          "503-0613",
          "503-0627",
          "503-0602",
          "503-0621",
          "503-0654",
          "503-0653",
          "503-0617",
          "503-0606",
          "503-0641",
          "503-0616",
          "503-0614",
          "503-0604",
          "503-0648",
          "503-0634",
          "503-0647",
          "503-0651",
          "503-0615",
          "503-0644",
          "503-0605",
          "503-0628",
          "503-0655",
          "503-0643",
          "503-0623",
          "503-0636",
          "503-0633",
          "503-0601",
          "503-0652",
          "503-0626",
          "503-0632",
          "503-0622",
          "503-0637",
          "503-0638",
          "503-0414",
          "503-0532",
          "503-0412",
          "503-0411",
          "503-0405",
          "503-0534",
          "503-0403",
          "503-0402",
          "503-0533",
          "503-0401",
          "503-0407",
          "503-0406",
          "503-0408",
          "503-0413",
          "503-0404",
          "503-0535",
          "503-0531",
          "503-0415",
          "503-0536",
          "503-0321",
          "503-0307",
          "503-0302",
          "503-0312",
          "503-0306",
          "503-0305",
          "503-0301",
          "503-0313",
          "503-0322",
          "503-0314",
          "503-0303",
          "503-0304",
          "503-0311",
          "503-0323",
          "501-6100",
          "501-6015",
          "501-6001",
          "501-6018",
          "501-6016",
          "501-6017",
          "501-6004",
          "501-6006",
          "501-6003",
          "501-6013",
          "501-6002",
          "501-6019",
          "501-6014",
          "501-6012",
          "501-6011",
          "501-6005",
          "501-6044",
          "501-6056",
          "501-6061",
          "501-6032",
          "501-6035",
          "501-6087",
          "501-6082",
          "501-6065",
          "501-6071",
          "501-6051",
          "501-6058",
          "501-6084",
          "501-6064",
          "501-6086",
          "501-6043",
          "501-6031",
          "501-6098",
          "501-6073",
          "501-6052",
          "501-6057",
          "501-6091",
          "501-6074",
          "501-6045",
          "501-6092",
          "501-6062",
          "501-6077",
          "501-6081",
          "501-6083",
          "501-6095",
          "501-6072",
          "501-6034",
          "501-6063",
          "501-6041",
          "501-6037",
          "501-6055",
          "501-6075",
          "501-6094",
          "501-6042",
          "501-6038",
          "501-6059",
          "501-6097",
          "501-6047",
          "501-6088",
          "501-6093",
          "501-6053",
          "501-6046",
          "501-6033",
          "501-6076",
          "501-6054",
          "501-6085",
          "501-6096",
          "501-6036",
          "503-1300",
          "503-1277",
          "503-1304",
          "503-1336",
          "503-1251",
          "503-1311",
          "503-1243",
          "503-1264",
          "503-1333",
          "503-1321",
          "503-1335",
          "503-1245",
          "503-1306",
          "503-1324",
          "503-1302",
          "503-1383",
          "503-1272",
          "503-1275",
          "503-1262",
          "503-1316",
          "503-1253",
          "503-1339",
          "503-1276",
          "503-1385",
          "503-1315",
          "503-1266",
          "503-1323",
          "503-1381",
          "503-1242",
          "503-1241",
          "503-1384",
          "503-1303",
          "503-1256",
          "503-1305",
          "503-1271",
          "503-1314",
          "503-1313",
          "503-1267",
          "503-1317",
          "503-1334",
          "503-1337",
          "503-1332",
          "503-1322",
          "503-1268",
          "503-1273",
          "503-1331",
          "503-1325",
          "503-1382",
          "503-1263",
          "503-1312",
          "503-1274",
          "503-1252",
          "503-1301",
          "503-1338",
          "503-1255",
          "503-1254",
          "503-1278",
          "503-1244",
          "503-1265",
          "503-1261",
          "503-2100",
          "503-2121",
          "503-2112",
          "503-2105",
          "503-2104",
          "503-2106",
          "503-2107",
          "503-2103",
          "503-2108",
          "503-2101",
          "503-2122",
          "503-2123",
          "503-2102",
          "503-2113",
          "503-2125",
          "503-2111",
          "503-2114",
          "503-2109",
          "503-2124",
          "503-1500",
          "503-1514",
          "503-1543",
          "503-1531",
          "503-1512",
          "503-1523",
          "503-1524",
          "503-1522",
          "503-1501",
          "503-1545",
          "503-1542",
          "503-1515",
          "503-1513",
          "503-1532",
          "503-1511",
          "503-1521",
          "503-1541",
          "503-1544",
          "503-2300",
          "503-2327",
          "503-2314",
          "503-2325",
          "503-2311",
          "503-2306",
          "503-2305",
          "503-2316",
          "503-2322",
          "503-2312",
          "503-2304",
          "503-2313",
          "503-2321",
          "503-2318",
          "503-2302",
          "503-2315",
          "503-2326",
          "503-2341",
          "503-2323",
          "503-2324",
          "503-2319",
          "503-2328",
          "503-2303",
          "503-2317",
          "503-2301",
          "503-0200",
          "503-0202",
          "503-0216",
          "503-0234",
          "503-0236",
          "503-0205",
          "503-0206",
          "503-0233",
          "503-0212",
          "503-0231",
          "503-0201",
          "503-0203",
          "503-0235",
          "503-0211",
          "503-0232",
          "503-0215",
          "503-0214",
          "503-0213",
          "503-0204",
          "503-0100",
          "503-0128",
          "503-0116",
          "503-0113",
          "503-0121",
          "503-0112",
          "503-0127",
          "503-0122",
          "503-0129",
          "503-0117",
          "503-0124",
          "503-0126",
          "503-0111",
          "503-0118",
          "503-0125",
          "503-0115",
          "503-0123",
          "503-0114",
          "501-0600",
          "501-0627",
          "501-0634",
          "501-0624",
          "501-0701",
          "501-0703",
          "501-0612",
          "501-0815",
          "501-0708",
          "503-2503",
          "503-2506",
          "503-2505",
          "503-2504",
          "503-2501",
          "503-2502",
          "501-0607",
          "501-0817",
          "501-0631",
          "501-0618",
          "501-0632",
          "501-0603",
          "501-0601",
          "501-0615",
          "501-0625",
          "501-0605",
          "501-0633",
          "501-0611",
          "501-0901",
          "501-0903",
          "501-0902",
          "501-0613",
          "501-0617",
          "501-0621",
          "501-0635",
          "501-0628",
          "501-0626",
          "501-0604",
          "501-1315",
          "501-1312",
          "501-1317",
          "501-1316",
          "501-1302",
          "501-1301",
          "501-1311",
          "501-1303",
          "501-1314",
          "501-1313",
          "501-0811",
          "501-0802",
          "501-0814",
          "501-0705",
          "501-0816",
          "501-0614",
          "501-0706",
          "501-0805",
          "501-0622",
          "501-0812",
          "501-0803",
          "501-0702",
          "501-0804",
          "501-0707",
          "501-0616",
          "501-0606",
          "501-0704",
          "501-0619",
          "501-0813",
          "501-0602",
          "501-0623",
          "501-0500",
          "501-0522",
          "501-0564",
          "501-0501",
          "501-0511",
          "501-0561",
          "501-0552",
          "501-0513",
          "501-0535",
          "501-0531",
          "501-0512",
          "501-0524",
          "501-0555",
          "501-0521",
          "501-0551",
          "501-0554",
          "501-0515",
          "501-0503",
          "501-0532",
          "501-0523",
          "501-0534",
          "501-0563",
          "501-0565",
          "501-0514",
          "501-0504",
          "501-0502",
          "501-0533",
          "501-0562",
          "501-0553",
          "501-0556",
          "501-0525",
          "503-2400",
          "503-2423",
          "503-2424",
          "503-2427",
          "503-2415",
          "503-2402",
          "503-2428",
          "503-2405",
          "503-2418",
          "503-2401",
          "503-2404",
          "503-2419",
          "503-2414",
          "503-2413",
          "503-2411",
          "503-2412",
          "503-2403",
          "503-2422",
          "503-2408",
          "503-2416",
          "503-2407",
          "503-2429",
          "503-2409",
          "503-2417",
          "503-2406",
          "503-2421",
          "503-2426",
          "503-2425",
          "501-0424",
          "501-0432",
          "501-0425",
          "501-0431",
          "501-0434",
          "501-0427",
          "501-0422",
          "501-0423",
          "501-0421",
          "501-0437",
          "501-0441",
          "501-0442",
          "501-0458",
          "501-0452",
          "501-0455",
          "501-0454",
          "501-0456",
          "501-0457",
          "501-0451",
          "501-0453",
          "501-0433",
          "501-0446",
          "501-0443",
          "501-0444",
          "501-0445",
          "501-0439",
          "501-0436",
          "501-0435",
          "501-0426",
          "501-0438",
          "501-0428",
          "505-0072",
          "505-0076",
          "505-0073",
          "505-0071",
          "505-0074",
          "505-0075",
          "505-0077",
          "501-3300",
          "501-3307",
          "501-3306",
          "501-3301",
          "501-3304",
          "501-3305",
          "501-3303",
          "501-3302",
          "509-0300",
          "509-0303",
          "509-0307",
          "509-0302",
          "509-0301",
          "509-0313",
          "509-0306",
          "509-0311",
          "509-0304",
          "509-0312",
          "509-0305",
          "509-0315",
          "509-0314",
          "509-0400",
          "509-0511",
          "509-0401",
          "509-0402",
          "509-0403",
          "505-0300",
          "505-0303",
          "505-0306",
          "505-0304",
          "505-0423",
          "505-0422",
          "505-0531",
          "505-0302",
          "505-0307",
          "505-0421",
          "505-0532",
          "505-0301",
          "505-0305",
          "509-1100",
          "509-1112",
          "509-1104",
          "509-1107",
          "509-1221",
          "509-1105",
          "509-1111",
          "509-1431",
          "509-1106",
          "509-1222",
          "509-1101",
          "509-1102",
          "509-1108",
          "509-1113",
          "509-1103",
          "509-1300",
          "509-1301",
          "509-1302",
          "509-1303",
          "505-0100",
          "505-0115",
          "505-0104",
          "505-0101",
          "505-0106",
          "505-0126",
          "505-0107",
          "505-0122",
          "505-0108",
          "505-0105",
          "505-0111",
          "505-0113",
          "505-0103",
          "505-0121",
          "505-0114",
          "505-0124",
          "505-0125",
          "505-0123",
          "505-0102",
          "505-0112",
          "505-0116",
          "501-5600",
          "501-5622",
          "501-5625",
          "501-5624",
          "501-5628",
          "501-5627",
          "501-5502",
          "501-5621",
          "501-5626",
          "501-5623",
          "501-5503",
          "501-5629",
          "501-5507",
          "501-5504",
          "501-5501",
          "501-5620",
          "501-5505",
          "501-5506",
          "422-0000",
          "420-0838",
          "421-2309",
          "421-1307",
          "420-0017",
          "421-1305",
          "420-0963",
          "420-0948",
          "420-0810",
          "420-0811",
          "420-0968",
          "421-2125",
          "421-2124",
          "420-0836",
          "421-2114",
          "421-2113",
          "420-0869",
          "420-0965",
          "420-0969",
          "420-0011",
          "420-0882",
          "420-0863",
          "428-0504",
          "420-0936",
          "420-0935",
          "420-0071",
          "420-0001",
          "420-0946",
          "428-0503",
          "420-0952",
          "421-2106",
          "421-2118",
          "421-2303",
          "421-1222",
          "421-2301",
          "420-0038",
          "420-0953",
          "421-2112",
          "420-0853",
          "420-0886",
          "420-0884",
          "420-0883",
          "420-0885",
          "420-0026",
          "421-2227",
          "420-0845",
          "421-1314",
          "421-1401",
          "421-2215",
          "421-2201",
          "421-2223",
          "420-0834",
          "421-1302",
          "421-2214",
          "420-0873",
          "420-0823",
          "420-0824",
          "420-0003",
          "420-0925",
          "421-2107",
          "420-0841",
          "420-0014",
          "421-2211",
          "420-0815",
          "420-0039",
          "428-0502",
          "420-0062",
          "420-0943",
          "421-2222",
          "420-0937",
          "420-0923",
          "420-0924",
          "420-0052",
          "420-0043",
          "420-0825",
          "420-0931",
          "420-0961",
          "420-0881",
          "420-0901",
          "420-0005",
          "420-0025",
          "421-1408",
          "421-2203",
          "421-2202",
          "420-0816",
          "420-0022",
          "420-0851",
          "421-1308",
          "421-2117",
          "421-2105",
          "420-0852",
          "428-0501",
          "421-2225",
          "421-1301",
          "421-1225",
          "420-0075",
          "420-0031",
          "421-1316",
          "420-0042",
          "420-0002",
          "420-0067",
          "420-0859",
          "421-1405",
          "421-1303",
          "420-0048",
          "420-0945",
          "420-0073",
          "421-1211",
          "420-0035",
          "420-0077",
          "420-0955",
          "421-2108",
          "420-0846",
          "420-0854",
          "420-0871",
          "420-0872",
          "420-0805",
          "420-0033",
          "420-0944",
          "420-0065",
          "420-0061",
          "421-1201",
          "420-0009",
          "420-0008",
          "420-0004",
          "421-1309",
          "420-0016",
          "420-0036",
          "420-0902",
          "420-0855",
          "420-0856",
          "420-0047",
          "420-0911",
          "420-0916",
          "420-0913",
          "420-0862",
          "420-0842",
          "421-1212",
          "420-0027",
          "420-0839",
          "421-1214",
          "421-2224",
          "420-0934",
          "428-0505",
          "420-0874",
          "420-0933",
          "420-0068",
          "421-2103",
          "421-2101",
          "420-0021",
          "420-0803",
          "420-0947",
          "421-2121",
          "421-1304",
          "420-0951",
          "420-0045",
          "420-0858",
          "421-2304",
          "420-0063",
          "420-0029",
          "420-0034",
          "420-0018",
          "421-1404",
          "420-0843",
          "420-0932",
          "421-1311",
          "420-0903",
          "421-2216",
          "421-2221",
          "420-0024",
          "421-2213",
          "420-0813",
          "420-0814",
          "421-2111",
          "421-2305",
          "421-1407",
          "421-1312",
          "421-2116",
          "420-0015",
          "420-0866",
          "420-0914",
          "420-0847",
          "421-1226",
          "420-0044",
          "420-0072",
          "421-2302",
          "420-0921",
          "421-2104",
          "420-0864",
          "420-0966",
          "420-0967",
          "420-0078",
          "421-1215",
          "421-1216",
          "421-1217",
          "420-0867",
          "421-1224",
          "420-0962",
          "420-0865",
          "420-0817",
          "420-0912",
          "420-0833",
          "420-0801",
          "420-0037",
          "421-1403",
          "420-0837",
          "421-2306",
          "420-0954",
          "420-0904",
          "421-1306",
          "421-2109",
          "421-1315",
          "420-0023",
          "420-0041",
          "420-0812",
          "420-0876",
          "420-0064",
          "420-0066",
          "420-0957",
          "421-1221",
          "420-0941",
          "420-0942",
          "421-2122",
          "420-0861",
          "420-0875",
          "420-0831",
          "421-1313",
          "420-0844",
          "420-0956",
          "420-0054",
          "420-0915",
          "420-0051",
          "420-0905",
          "420-0868",
          "420-0822",
          "420-0857",
          "420-0053",
          "421-2217",
          "421-1402",
          "420-0028",
          "421-1409",
          "420-0906",
          "420-0013",
          "421-1202",
          "420-0007",
          "420-0964",
          "421-1213",
          "421-2102",
          "420-0012",
          "421-2212",
          "420-0821",
          "421-1406",
          "421-2123",
          "420-0949",
          "420-0832",
          "421-2226",
          "420-0835",
          "421-2307",
          "421-2115",
          "421-1223",
          "420-0046",
          "420-0074",
          "420-0922",
          "420-0804",
          "420-0032",
          "420-0076",
          "420-0006",
          "421-2308",
          "421-0134",
          "422-8014",
          "422-8012",
          "422-8031",
          "422-8005",
          "422-8042",
          "422-8066",
          "422-8062",
          "421-0105",
          "422-8032",
          "422-8075",
          "422-8017",
          "421-0136",
          "422-8072",
          "421-0135",
          "422-8021",
          "422-8022",
          "422-8023",
          "421-0133",
          "421-0132",
          "421-0106",
          "422-8004",
          "422-8008",
          "421-0116",
          "422-8055",
          "422-8078",
          "422-8036",
          "421-0113",
          "421-0117",
          "422-8037",
          "422-8064",
          "421-0123",
          "422-8034",
          "422-8056",
          "421-0102",
          "421-0131",
          "421-0137",
          "421-0112",
          "422-8027",
          "422-8071",
          "422-8033",
          "422-8046",
          "422-8041",
          "422-8043",
          "422-8051",
          "422-8058",
          "422-8015",
          "422-8047",
          "422-8001",
          "422-8018",
          "422-8045",
          "422-8053",
          "422-8016",
          "422-8044",
          "422-8011",
          "422-8019",
          "422-8007",
          "422-8003",
          "421-0121",
          "422-8026",
          "422-8013",
          "422-8006",
          "422-8063",
          "421-0103",
          "421-0111",
          "421-0104",
          "422-8025",
          "421-0115",
          "422-8057",
          "422-8052",
          "422-8054",
          "422-8067",
          "422-8074",
          "422-8024",
          "422-8035",
          "422-8065",
          "421-0101",
          "421-0107",
          "421-0122",
          "421-0125",
          "421-0124",
          "421-0126",
          "421-0114",
          "422-8061",
          "422-8002",
          "422-8076",
          "422-8073",
          "422-8077",
          "422-8009",
          "424-0821",
          "424-0805",
          "424-0843",
          "424-0801",
          "424-0822",
          "424-0107",
          "424-0838",
          "424-0027",
          "424-0112",
          "424-0005",
          "424-0007",
          "424-0006",
          "424-0114",
          "424-0874",
          "424-0831",
          "424-0839",
          "424-0832",
          "424-0942",
          "424-0873",
          "424-0879",
          "424-0938",
          "424-0001",
          "424-0948",
          "424-0871",
          "424-0043",
          "424-0044",
          "424-0818",
          "424-0815",
          "424-0054",
          "424-0841",
          "424-0061",
          "424-0062",
          "424-0858",
          "424-0847",
          "424-0808",
          "424-0411",
          "424-0931",
          "424-0203",
          "424-0202",
          "424-0206",
          "424-0204",
          "424-0205",
          "424-0008",
          "424-0812",
          "424-0305",
          "424-0306",
          "424-0103",
          "424-0902",
          "424-0009",
          "424-0842",
          "424-0827",
          "424-0835",
          "424-0857",
          "424-0852",
          "421-3203",
          "421-3215",
          "421-3212",
          "421-3202",
          "421-3211",
          "421-3214",
          "421-3213",
          "421-3201",
          "424-0865",
          "424-0937",
          "424-0052",
          "424-0051",
          "424-0055",
          "424-0846",
          "424-0402",
          "424-0817",
          "424-0104",
          "424-0886",
          "424-0884",
          "424-0883",
          "424-0885",
          "424-0881",
          "424-0882",
          "424-0412",
          "424-0914",
          "424-0302",
          "424-0917",
          "424-0906",
          "424-0904",
          "424-0905",
          "424-0907",
          "424-0903",
          "424-0923",
          "424-0836",
          "424-0837",
          "424-0933",
          "424-0405",
          "424-0301",
          "424-0053",
          "424-0823",
          "424-0947",
          "424-0925",
          "424-0939",
          "424-0021",
          "424-0011",
          "424-0029",
          "424-0012",
          "424-0028",
          "424-0013",
          "424-0201",
          "424-0855",
          "424-0856",
          "424-0833",
          "424-0927",
          "424-0824",
          "424-0106",
          "424-0924",
          "424-0915",
          "424-0037",
          "424-0041",
          "424-0048",
          "424-0042",
          "424-0404",
          "424-0813",
          "424-0303",
          "424-0304",
          "424-0804",
          "424-0828",
          "424-0944",
          "424-0853",
          "424-0806",
          "424-0047",
          "424-0809",
          "424-0015",
          "424-0016",
          "424-0017",
          "424-0014",
          "424-0414",
          "424-0851",
          "424-0406",
          "424-0912",
          "424-0829",
          "424-0067",
          "424-0401",
          "424-0065",
          "424-0064",
          "424-0068",
          "424-0888",
          "424-0854",
          "424-0066",
          "424-0046",
          "424-0038",
          "424-0413",
          "424-0844",
          "424-0811",
          "424-0415",
          "424-0935",
          "424-0063",
          "424-0003",
          "424-0004",
          "424-0834",
          "424-0113",
          "424-0056",
          "424-0045",
          "424-0929",
          "424-0922",
          "424-0872",
          "424-0102",
          "424-0941",
          "424-0866",
          "424-0861",
          "424-0862",
          "424-0863",
          "424-0845",
          "424-0916",
          "424-0057",
          "424-0814",
          "424-0949",
          "424-0816",
          "424-0921",
          "424-0825",
          "424-0875",
          "424-0876",
          "424-0877",
          "424-0826",
          "424-0878",
          "424-0928",
          "424-0943",
          "424-0932",
          "424-0864",
          "424-0945",
          "424-0901",
          "424-0911",
          "424-0803",
          "424-0807",
          "424-0936",
          "424-0913",
          "424-0926",
          "424-0934",
          "424-0819",
          "424-0101",
          "424-0212",
          "424-0802",
          "424-0023",
          "424-0022",
          "424-0025",
          "424-0024",
          "424-0026",
          "424-0887",
          "424-0946",
          "424-0211",
          "424-0105",
          "424-0018",
          "424-0002",
          "421-3103",
          "421-3107",
          "421-3111",
          "421-3101",
          "421-3104",
          "421-3112",
          "421-3115",
          "421-3106",
          "421-3114",
          "421-3102",
          "421-3105",
          "424-0031",
          "424-0034",
          "424-0036",
          "424-0032",
          "424-0033",
          "424-0035",
          "424-0111",
          "424-0403",
          "432-0000",
          "430-0805",
          "433-8111",
          "433-8114",
          "432-8043",
          "430-0927",
          "433-8113",
          "430-0945",
          "433-8124",
          "433-8126",
          "430-0928",
          "430-7790",
          "430-7701",
          "430-7702",
          "430-7703",
          "430-7704",
          "430-7705",
          "430-7706",
          "430-7707",
          "430-7708",
          "430-7709",
          "430-7710",
          "430-7711",
          "430-7712",
          "430-7713",
          "430-7714",
          "430-7715",
          "430-7716",
          "430-7717",
          "430-7718",
          "430-7719",
          "430-7720",
          "430-7721",
          "430-7722",
          "430-7723",
          "430-7724",
          "430-7725",
          "430-7726",
          "430-7727",
          "430-7728",
          "430-7729",
          "430-7730",
          "430-7731",
          "430-7732",
          "430-7733",
          "430-7734",
          "430-7735",
          "430-7736",
          "430-7737",
          "430-7738",
          "430-7739",
          "430-7740",
          "430-7741",
          "430-7742",
          "430-7743",
          "430-7744",
          "430-7745",
          "430-0854",
          "432-8033",
          "432-8032",
          "430-0949",
          "430-0933",
          "432-8046",
          "432-8042",
          "433-8122",
          "432-8047",
          "432-8023",
          "432-8024",
          "430-0943",
          "430-0923",
          "430-0806",
          "430-0948",
          "430-0938",
          "433-8123",
          "432-8025",
          "430-0932",
          "430-0807",
          "432-8021",
          "432-8034",
          "432-8014",
          "432-8018",
          "435-0055",
          "430-0905",
          "432-8011",
          "430-0911",
          "430-0931",
          "432-8041",
          "430-0903",
          "430-0926",
          "430-0906",
          "435-0054",
          "430-0936",
          "433-8119",
          "433-8118",
          "433-8117",
          "430-0907",
          "432-8015",
          "430-0944",
          "430-0934",
          "430-0929",
          "430-0925",
          "430-0808",
          "430-0935",
          "430-0937",
          "430-0917",
          "432-8002",
          "430-0804",
          "430-0904",
          "430-0856",
          "430-0857",
          "432-8016",
          "430-0912",
          "430-0811",
          "432-8031",
          "432-8035",
          "432-8045",
          "432-8038",
          "433-8116",
          "432-8012",
          "430-0919",
          "432-8053",
          "433-8121",
          "432-8027",
          "430-0918",
          "433-8109",
          "430-0916",
          "432-8036",
          "430-0915",
          "430-0901",
          "430-0902",
          "432-8013",
          "430-0913",
          "432-8004",
          "435-0045",
          "430-0947",
          "432-8017",
          "432-8044",
          "432-8037",
          "430-0851",
          "432-8026",
          "430-0946",
          "430-0942",
          "432-8048",
          "430-0941",
          "432-8022",
          "430-0924",
          "430-0852",
          "430-0939",
          "433-8127",
          "433-8125",
          "432-8003",
          "431-3121",
          "431-3126",
          "431-3123",
          "431-3122",
          "435-0005",
          "435-0012",
          "435-0051",
          "430-0803",
          "435-0014",
          "431-3112",
          "431-3113",
          "431-3106",
          "431-3105",
          "431-3107",
          "435-0053",
          "435-0001",
          "435-0048",
          "435-0041",
          "431-3104",
          "435-0011",
          "435-0056",
          "430-0801",
          "435-0015",
          "435-0021",
          "435-0042",
          "435-0006",
          "430-0802",
          "431-3103",
          "435-0002",
          "431-3114",
          "431-3108",
          "435-0052",
          "435-0013",
          "431-3102",
          "431-3111",
          "435-0003",
          "435-0057",
          "435-0031",
          "435-0004",
          "431-3115",
          "435-0044",
          "435-0047",
          "431-3124",
          "431-3125",
          "435-0008",
          "435-0046",
          "435-0043",
          "435-0017",
          "435-0018",
          "431-3101",
          "435-0029",
          "435-0007",
          "435-0016",
          "431-1111",
          "432-8061",
          "432-8006",
          "431-1112",
          "432-8068",
          "431-1102",
          "432-8005",
          "432-8007",
          "431-1209",
          "431-1205",
          "431-1202",
          "431-1103",
          "431-1113",
          "431-1104",
          "431-1114",
          "432-8069",
          "432-8066",
          "431-0201",
          "431-1208",
          "431-1206",
          "431-1204",
          "432-8071",
          "431-0202",
          "432-8067",
          "432-8001",
          "431-1203",
          "431-1201",
          "431-0212",
          "431-0213",
          "431-0214",
          "431-0211",
          "431-0203",
          "431-1207",
          "431-0103",
          "431-0102",
          "431-0101",
          "431-1101",
          "431-1115",
          "435-0037",
          "435-0028",
          "435-0033",
          "430-0844",
          "430-0835",
          "435-0025",
          "435-0024",
          "430-0842",
          "432-8055",
          "430-0814",
          "435-0026",
          "430-0823",
          "432-8064",
          "430-0831",
          "432-8063",
          "430-0816",
          "430-0833",
          "435-0038",
          "430-0826",
          "435-0027",
          "430-0825",
          "430-0846",
          "435-0023",
          "430-0817",
          "435-0035",
          "432-8062",
          "432-8065",
          "432-8054",
          "430-0827",
          "432-8057",
          "430-0815",
          "435-0022",
          "430-0841",
          "430-0824",
          "430-0845",
          "430-0832",
          "430-0837",
          "430-0821",
          "432-8058",
          "430-0838",
          "430-0822",
          "432-8052",
          "430-0836",
          "430-0843",
          "435-0032",
          "430-0813",
          "430-0812",
          "430-0834",
          "430-0853",
          "435-0034",
          "430-0855",
          "432-8056",
          "432-8051",
          "435-0036",
          "431-2212",
          "431-2205",
          "431-2224",
          "431-2213",
          "431-2225",
          "431-2202",
          "431-2222",
          "431-2537",
          "431-2533",
          "431-2215",
          "431-2536",
          "431-2221",
          "431-2223",
          "431-2204",
          "431-2532",
          "431-2206",
          "431-2211",
          "431-2531",
          "431-2201",
          "431-2207",
          "431-2534",
          "431-2535",
          "431-2203",
          "431-2226",
          "431-2214",
          "433-8102",
          "431-2216",
          "431-2103",
          "431-2101",
          "433-8103",
          "433-8108",
          "433-8112",
          "433-8104",
          "431-1301",
          "431-1305",
          "431-1304",
          "431-1302",
          "431-1303",
          "433-8105",
          "431-1404",
          "431-1403",
          "431-1407",
          "431-1415",
          "431-1425",
          "431-1406",
          "431-1401",
          "431-1424",
          "431-1412",
          "431-1402",
          "431-1405",
          "431-1416",
          "431-1423",
          "431-1422",
          "431-1417",
          "431-1411",
          "431-1421",
          "431-1413",
          "431-1414",
          "431-2102",
          "433-8101",
          "431-2104",
          "434-0000",
          "434-0027",
          "434-0044",
          "434-0045",
          "434-0005",
          "434-0002",
          "434-0015",
          "434-0011",
          "434-0028",
          "434-0038",
          "434-0031",
          "434-0042",
          "434-0003",
          "434-0025",
          "434-0046",
          "434-0023",
          "434-0034",
          "434-0035",
          "434-0032",
          "434-0017",
          "434-0013",
          "434-0043",
          "434-0012",
          "434-0029",
          "434-0022",
          "434-0018",
          "434-0033",
          "434-0037",
          "434-0016",
          "434-0007",
          "434-0026",
          "434-0041",
          "434-0001",
          "434-0014",
          "434-0004",
          "434-0021",
          "434-0036",
          "434-0006",
          "434-0024",
          "431-3425",
          "431-3535",
          "431-3536",
          "431-3428",
          "431-3762",
          "431-3755",
          "431-3642",
          "431-3305",
          "431-3752",
          "431-3427",
          "431-3643",
          "431-3641",
          "431-3753",
          "431-4111",
          "431-3906",
          "431-3902",
          "431-4112",
          "431-3903",
          "431-3907",
          "431-3901",
          "431-3904",
          "431-3908",
          "431-3905",
          "431-3304",
          "431-3754",
          "431-3302",
          "431-3804",
          "431-3802",
          "431-3801",
          "431-3803",
          "431-3763",
          "431-3533",
          "431-3761",
          "431-3532",
          "437-0617",
          "437-0621",
          "437-0615",
          "437-0607",
          "437-0624",
          "437-0622",
          "437-0608",
          "437-0601",
          "437-0623",
          "437-0605",
          "437-0618",
          "437-0603",
          "437-0602",
          "437-0616",
          "437-0611",
          "437-0614",
          "437-0606",
          "437-0612",
          "437-0625",
          "437-0613",
          "437-0604",
          "437-0626",
          "431-3421",
          "431-3751",
          "431-3531",
          "431-3311",
          "431-3315",
          "431-3313",
          "431-3314",
          "431-3312",
          "431-3534",
          "431-3306",
          "431-4101",
          "431-4102",
          "431-4103",
          "431-3422",
          "431-3303",
          "431-3756",
          "431-3301",
          "431-3764",
          "431-3426",
          "431-3424",
          "431-3423",
          "410-0000",
          "410-0802",
          "410-0852",
          "410-0001",
          "410-0317",
          "410-0045",
          "410-3401",
          "410-0831",
          "410-0866",
          "410-0314",
          "410-0319",
          "410-0875",
          "410-0316",
          "410-0892",
          "410-0225",
          "410-0222",
          "410-0221",
          "410-0224",
          "410-0223",
          "410-0103",
          "410-0049",
          "410-0022",
          "410-0873",
          "410-0306",
          "410-0801",
          "410-0307",
          "410-0821",
          "410-0012",
          "410-0011",
          "410-0844",
          "410-0823",
          "410-0824",
          "410-0813",
          "410-0042",
          "410-0876",
          "410-0061",
          "410-0054",
          "410-0064",
          "410-0102",
          "410-0893",
          "410-0819",
          "410-0872",
          "410-0053",
          "410-0021",
          "410-0804",
          "410-0862",
          "410-0044",
          "410-0052",
          "410-0035",
          "410-0031",
          "410-0037",
          "410-0106",
          "410-0104",
          "410-0867",
          "410-0863",
          "410-0822",
          "410-0841",
          "410-0885",
          "410-0842",
          "410-0047",
          "410-0805",
          "410-0003",
          "410-0048",
          "410-0895",
          "410-0888",
          "410-0033",
          "410-0816",
          "410-0015",
          "410-0886",
          "410-0854",
          "410-0847",
          "410-0846",
          "410-0848",
          "410-0855",
          "410-0845",
          "410-0849",
          "410-0803",
          "410-0883",
          "410-0017",
          "410-0016",
          "410-0057",
          "410-0056",
          "410-0055",
          "410-0843",
          "410-0101",
          "410-0814",
          "410-0041",
          "410-0891",
          "410-0853",
          "410-0305",
          "410-0006",
          "410-0811",
          "410-0894",
          "410-0818",
          "410-0242",
          "410-0244",
          "410-0231",
          "410-0233",
          "410-0243",
          "410-0241",
          "410-0232",
          "410-0235",
          "410-0234",
          "410-0807",
          "410-0051",
          "410-0007",
          "410-0303",
          "410-0835",
          "410-0313",
          "410-0321",
          "410-0871",
          "410-0058",
          "410-0309",
          "410-0881",
          "410-0065",
          "410-0312",
          "410-0311",
          "410-0013",
          "410-0002",
          "410-0302",
          "410-0304",
          "410-0865",
          "410-0887",
          "410-0032",
          "410-0318",
          "410-0036",
          "410-0034",
          "410-0005",
          "410-3402",
          "410-0817",
          "410-0004",
          "410-0884",
          "410-0834",
          "410-0105",
          "410-0861",
          "410-0882",
          "410-0014",
          "410-0864",
          "410-0874",
          "410-0806",
          "410-0833",
          "410-0063",
          "410-0815",
          "410-0062",
          "410-0851",
          "410-0301",
          "410-0832",
          "410-0038",
          "410-0315",
          "410-0308",
          "410-0043",
          "410-0812",
          "410-0018",
          "410-0836",
          "410-0046",
          "410-0059",
          "413-0000",
          "413-0039",
          "413-0041",
          "413-0103",
          "413-0033",
          "413-0002",
          "413-0001",
          "413-0003",
          "413-0005",
          "413-0018",
          "413-0101",
          "413-0013",
          "413-0029",
          "413-0019",
          "413-0025",
          "413-0028",
          "413-0037",
          "413-0021",
          "413-0102",
          "413-0022",
          "413-0011",
          "413-0015",
          "413-0014",
          "413-0038",
          "413-0034",
          "413-0032",
          "413-0026",
          "413-0004",
          "413-0031",
          "413-0012",
          "413-0036",
          "413-0017",
          "413-0035",
          "413-0016",
          "413-0027",
          "413-0006",
          "413-0042",
          "413-0024",
          "413-0023",
          "411-0000",
          "411-0811",
          "411-0020",
          "411-0834",
          "411-0037",
          "411-0015",
          "411-0036",
          "411-0025",
          "411-0816",
          "411-0035",
          "411-0023",
          "411-0034",
          "411-0845",
          "411-0022",
          "411-0805",
          "411-0854",
          "411-0844",
          "411-0031",
          "411-0039",
          "411-0846",
          "411-0012",
          "411-0047",
          "411-0041",
          "411-0043",
          "411-0017",
          "411-0857",
          "411-0032",
          "411-0027",
          "411-0853",
          "411-0803",
          "411-0807",
          "411-0835",
          "411-0014",
          "411-0804",
          "411-0858",
          "411-0016",
          "411-0813",
          "411-0044",
          "411-0836",
          "411-0833",
          "411-0814",
          "411-0838",
          "411-0824",
          "411-0030",
          "411-0808",
          "411-0847",
          "411-0038",
          "411-0045",
          "411-0817",
          "411-0018",
          "411-0029",
          "411-0026",
          "411-0802",
          "411-0852",
          "411-0831",
          "411-0851",
          "411-0821",
          "411-0856",
          "411-0812",
          "411-0028",
          "411-0021",
          "411-0046",
          "411-0033",
          "411-0042",
          "411-0855",
          "411-0019",
          "411-0822",
          "411-0823",
          "411-0013",
          "411-0848",
          "411-0837",
          "411-0842",
          "411-0832",
          "411-0841",
          "411-0843",
          "411-0815",
          "411-0801",
          "411-0806",
          "411-0011",
          "411-0024",
          "418-0000",
          "418-0047",
          "418-0048",
          "418-0016",
          "418-0078",
          "418-0037",
          "418-0057",
          "418-0032",
          "418-0011",
          "418-0018",
          "418-0043",
          "418-0108",
          "418-0104",
          "419-0317",
          "418-0113",
          "418-0013",
          "419-0314",
          "419-0303",
          "418-0044",
          "418-0066",
          "418-0103",
          "419-0311",
          "418-0116",
          "419-0301",
          "418-0117",
          "418-0031",
          "418-0061",
          "418-0112",
          "418-0042",
          "418-0034",
          "418-0074",
          "418-0022",
          "418-0107",
          "419-0312",
          "418-0114",
          "419-0305",
          "418-0115",
          "418-0062",
          "418-0021",
          "418-0055",
          "418-0075",
          "418-0065",
          "418-0006",
          "418-0007",
          "419-0304",
          "418-0046",
          "418-0045",
          "419-0315",
          "418-0002",
          "418-0019",
          "418-0076",
          "418-0026",
          "418-0056",
          "419-0313",
          "418-0024",
          "418-0036",
          "419-0302",
          "418-0101",
          "418-0039",
          "418-0038",
          "418-0033",
          "419-0316",
          "418-0105",
          "418-0106",
          "418-0054",
          "418-0071",
          "418-0077",
          "418-0102",
          "418-0003",
          "418-0014",
          "418-0017",
          "418-0109",
          "418-0035",
          "418-0058",
          "418-0015",
          "418-0025",
          "418-0001",
          "418-0004",
          "418-0053",
          "418-0067",
          "418-0005",
          "418-0012",
          "418-0064",
          "418-0072",
          "418-0111",
          "418-0023",
          "418-0068",
          "418-0073",
          "418-0041",
          "418-0051",
          "418-0052",
          "418-0063",
          "414-0000",
          "413-0233",
          "414-0043",
          "413-0234",
          "414-0001",
          "414-0046",
          "413-0235",
          "414-0055",
          "414-0016",
          "414-0053",
          "414-0032",
          "414-0054",
          "414-0034",
          "414-0044",
          "414-0028",
          "414-0045",
          "413-0111",
          "414-0018",
          "414-0017",
          "414-0037",
          "414-0013",
          "414-0004",
          "414-0042",
          "414-0041",
          "414-0015",
          "414-0012",
          "414-0027",
          "414-0026",
          "414-0003",
          "414-0052",
          "414-0023",
          "414-0033",
          "414-0022",
          "414-0038",
          "413-0231",
          "414-0011",
          "414-0006",
          "414-0021",
          "414-0005",
          "414-0035",
          "414-0036",
          "414-0025",
          "414-0014",
          "413-0232",
          "414-0002",
          "414-0031",
          "414-0051",
          "414-0024",
          "427-0000",
          "427-0018",
          "427-0006",
          "427-0232",
          "427-0104",
          "427-0034",
          "427-0038",
          "427-0031",
          "428-0006",
          "427-0026",
          "427-0013",
          "427-0025",
          "427-0033",
          "427-0023",
          "427-0002",
          "428-0009",
          "427-0056",
          "427-0101",
          "427-0102",
          "427-0106",
          "427-0053",
          "427-0009",
          "427-0008",
          "428-0013",
          "428-0014",
          "428-0015",
          "428-0027",
          "428-0046",
          "428-0017",
          "428-0023",
          "428-0039",
          "428-0031",
          "428-0028",
          "428-0048",
          "428-0047",
          "428-0012",
          "428-0025",
          "428-0032",
          "428-0043",
          "428-0033",
          "428-0018",
          "428-0034",
          "428-0042",
          "428-0026",
          "428-0044",
          "428-0024",
          "428-0041",
          "428-0016",
          "428-0003",
          "428-0036",
          "428-0104",
          "428-0102",
          "428-0211",
          "428-0212",
          "428-0101",
          "428-0105",
          "428-0106",
          "428-0103",
          "427-0037",
          "427-0032",
          "427-0058",
          "428-0037",
          "427-0004",
          "427-0005",
          "428-0035",
          "427-0027",
          "427-0028",
          "427-0111",
          "427-0231",
          "428-0038",
          "428-0019",
          "428-0007",
          "427-0059",
          "427-0055",
          "428-0001",
          "427-0054",
          "427-0015",
          "428-0008",
          "427-0001",
          "427-0042",
          "427-0112",
          "427-0019",
          "427-0014",
          "427-0003",
          "427-0103",
          "427-0041",
          "427-0043",
          "427-0047",
          "427-0007",
          "427-0048",
          "427-0061",
          "428-0011",
          "427-0011",
          "427-0029",
          "428-0002",
          "427-0107",
          "427-0016",
          "427-0012",
          "427-0022",
          "428-0049",
          "427-0108",
          "427-0052",
          "427-0036",
          "427-0017",
          "427-0105",
          "427-0233",
          "427-0044",
          "427-0045",
          "427-0039",
          "427-0035",
          "427-0057",
          "427-0051",
          "427-0021",
          "427-0113",
          "427-0024",
          "428-0004",
          "428-0005",
          "427-0046",
          "417-0000",
          "417-0046",
          "417-0047",
          "416-0952",
          "419-0201",
          "417-0042",
          "417-0043",
          "417-0804",
          "417-0862",
          "417-0808",
          "417-0846",
          "417-0001",
          "417-0802",
          "419-0204",
          "421-3305",
          "416-0901",
          "417-0853",
          "417-0854",
          "417-0805",
          "417-0025",
          "417-0057",
          "417-0811",
          "417-0817",
          "417-0848",
          "417-0845",
          "417-0801",
          "417-0803",
          "417-0835",
          "416-0912",
          "417-0821",
          "417-0822",
          "417-0823",
          "416-0942",
          "417-0825",
          "417-0824",
          "416-0939",
          "416-0955",
          "421-3304",
          "421-3301",
          "419-0202",
          "417-0071",
          "417-0062",
          "417-0063",
          "417-0807",
          "416-0946",
          "416-0905",
          "417-0812",
          "416-0934",
          "417-0842",
          "417-0856",
          "417-0033",
          "416-0943",
          "416-0941",
          "417-0004",
          "417-0015",
          "417-0013",
          "417-0014",
          "417-0012",
          "417-0011",
          "417-0072",
          "417-0073",
          "419-0203",
          "417-0048",
          "417-0044",
          "416-0935",
          "417-0031",
          "417-0032",
          "416-0931",
          "416-0953",
          "417-0843",
          "417-0052",
          "417-0034",
          "417-0035",
          "417-0061",
          "419-0205",
          "417-0037",
          "417-0832",
          "417-0036",
          "416-0936",
          "417-0826",
          "416-0907",
          "417-0809",
          "421-3306",
          "421-3302",
          "416-0933",
          "417-0054",
          "417-0058",
          "417-0055",
          "416-0902",
          "417-0834",
          "417-0045",
          "417-0814",
          "417-0833",
          "416-0911",
          "416-0938",
          "417-0852",
          "417-0831",
          "417-0847",
          "417-0844",
          "417-0056",
          "417-0861",
          "417-0863",
          "417-0864",
          "417-0841",
          "416-0915",
          "417-0851",
          "417-0813",
          "416-0916",
          "416-0918",
          "416-0913",
          "416-0914",
          "416-0937",
          "417-0806",
          "417-0815",
          "417-0816",
          "416-0909",
          "416-0919",
          "416-0903",
          "417-0855",
          "416-0921",
          "416-0924",
          "416-0922",
          "417-0049",
          "417-0026",
          "421-3303",
          "416-0947",
          "416-0945",
          "417-0041",
          "416-0906",
          "416-0904",
          "416-0954",
          "416-0917",
          "416-0949",
          "416-0948",
          "417-0024",
          "416-0932",
          "417-0064",
          "417-0065",
          "416-0908",
          "416-0944",
          "416-0923",
          "417-0051",
          "417-0023",
          "417-0021",
          "417-0053",
          "417-0022",
          "417-0002",
          "417-0003",
          "416-0951",
          "438-0000",
          "438-0824",
          "438-0017",
          "438-0078",
          "438-0062",
          "438-0105",
          "437-1206",
          "438-0805",
          "438-0086",
          "438-0116",
          "437-1216",
          "438-0071",
          "438-0016",
          "438-0104",
          "438-0223",
          "437-1217",
          "438-0212",
          "438-0812",
          "438-0103",
          "438-0044",
          "438-0002",
          "438-0036",
          "438-0107",
          "438-0214",
          "438-0043",
          "437-1211",
          "438-0204",
          "438-0124",
          "438-0234",
          "438-0011",
          "438-0038",
          "438-0831",
          "438-0051",
          "438-0045",
          "438-0115",
          "438-0111",
          "438-0822",
          "438-0817",
          "438-0042",
          "438-0804",
          "438-0232",
          "438-0121",
          "438-0064",
          "438-0084",
          "438-0061",
          "438-0067",
          "438-0814",
          "438-0837",
          "438-0114",
          "438-0077",
          "438-0056",
          "438-0838",
          "438-0215",
          "438-0233",
          "438-0005",
          "438-0003",
          "438-0004",
          "438-0813",
          "438-0055",
          "437-1213",
          "438-0106",
          "438-0015",
          "438-0052",
          "438-0046",
          "438-0126",
          "438-0112",
          "437-1205",
          "438-0823",
          "438-0818",
          "438-0236",
          "438-0066",
          "438-0235",
          "438-0113",
          "438-0025",
          "438-0063",
          "438-0033",
          "438-0222",
          "437-1214",
          "438-0057",
          "438-0122",
          "438-0202",
          "438-0801",
          "438-0821",
          "438-0021",
          "437-1215",
          "438-0006",
          "438-0007",
          "438-0075",
          "438-0039",
          "438-0806",
          "438-0216",
          "438-0803",
          "438-0807",
          "438-0231",
          "438-0047",
          "438-0808",
          "438-0835",
          "437-1202",
          "437-1201",
          "438-0072",
          "438-0053",
          "438-0218",
          "438-0836",
          "438-0069",
          "438-0815",
          "438-0026",
          "438-0022",
          "438-0041",
          "438-0217",
          "438-0074",
          "438-0073",
          "438-0065",
          "438-0224",
          "438-0054",
          "438-0031",
          "438-0035",
          "438-0037",
          "437-1208",
          "438-0802",
          "438-0211",
          "438-0028",
          "438-0032",
          "438-0023",
          "438-0811",
          "438-0203",
          "438-0123",
          "438-0008",
          "437-1207",
          "437-1203",
          "437-1204",
          "438-0001",
          "438-0088",
          "438-0083",
          "438-0205",
          "438-0068",
          "438-0125",
          "438-0206",
          "438-0058",
          "438-0101",
          "438-0027",
          "438-0018",
          "438-0085",
          "438-0127",
          "438-0081",
          "437-1209",
          "437-1212",
          "437-1218",
          "438-0221",
          "438-0816",
          "438-0207",
          "438-0024",
          "438-0019",
          "438-0012",
          "438-0013",
          "438-0014",
          "438-0102",
          "438-0082",
          "438-0832",
          "438-0834",
          "438-0825",
          "438-0108",
          "438-0833",
          "438-0201",
          "438-0213",
          "438-0034",
          "425-0000",
          "421-0216",
          "425-0023",
          "425-0041",
          "425-0043",
          "425-0042",
          "425-0044",
          "425-0015",
          "425-0016",
          "425-0054",
          "425-0032",
          "425-0028",
          "425-0092",
          "425-0083",
          "425-0066",
          "425-0069",
          "425-0072",
          "425-0082",
          "425-0084",
          "425-0013",
          "425-0011",
          "425-0073",
          "425-0005",
          "421-0217",
          "421-0201",
          "421-0206",
          "425-0058",
          "425-0024",
          "425-0077",
          "425-0033",
          "425-0031",
          "425-0086",
          "425-0076",
          "425-0027",
          "425-0004",
          "425-0046",
          "425-0071",
          "425-0085",
          "421-0218",
          "425-0057",
          "425-0056",
          "421-0202",
          "425-0067",
          "425-0025",
          "425-0053",
          "425-0006",
          "425-0065",
          "425-0081",
          "425-0088",
          "425-0003",
          "421-0204",
          "425-0052",
          "425-0051",
          "425-0055",
          "425-0014",
          "421-0214",
          "425-0068",
          "425-0061",
          "425-0062",
          "425-0021",
          "425-0036",
          "421-0215",
          "425-0075",
          "425-0045",
          "425-0017",
          "425-0001",
          "421-0213",
          "425-0012",
          "425-0035",
          "421-0203",
          "425-0087",
          "425-0063",
          "425-0022",
          "425-0064",
          "425-0007",
          "421-0205",
          "425-0026",
          "425-0091",
          "425-0074",
          "425-0002",
          "421-0211",
          "425-0034",
          "421-0212",
          "436-0000",
          "436-0018",
          "436-0019",
          "436-0041",
          "436-0022",
          "436-0062",
          "436-0069",
          "436-0089",
          "436-0225",
          "436-0227",
          "436-0332",
          "436-0016",
          "437-1436",
          "437-1438",
          "437-1403",
          "436-0072",
          "436-0034",
          "436-0077",
          "436-0043",
          "437-1421",
          "436-0087",
          "437-1439",
          "436-0009",
          "437-1302",
          "436-0335",
          "436-0037",
          "437-1303",
          "436-0045",
          "437-1407",
          "437-1422",
          "436-0113",
          "436-0079",
          "436-0088",
          "436-0073",
          "436-0012",
          "436-0342",
          "436-0221",
          "436-0101",
          "437-1433",
          "437-1431",
          "437-1432",
          "437-1437",
          "437-1435",
          "436-0049",
          "436-0028",
          "437-1406",
          "436-0014",
          "437-1415",
          "436-0063",
          "436-0064",
          "436-0094",
          "436-0044",
          "436-0074",
          "437-1414",
          "437-1413",
          "436-0027",
          "436-0341",
          "436-0223",
          "436-0331",
          "436-0023",
          "436-0031",
          "436-0055",
          "436-0090",
          "436-0070",
          "436-0068",
          "436-0013",
          "436-0007",
          "436-0343",
          "436-0048",
          "436-0084",
          "437-1411",
          "436-0078",
          "436-0002",
          "436-0039",
          "436-0076",
          "436-0033",
          "436-0067",
          "436-0222",
          "437-1434",
          "436-0025",
          "436-0026",
          "436-0057",
          "436-0040",
          "436-0091",
          "436-0054",
          "436-0059",
          "436-0017",
          "436-0030",
          "436-0337",
          "436-0008",
          "436-0083",
          "437-1401",
          "436-0114",
          "436-0005",
          "436-0011",
          "436-0333",
          "436-0082",
          "437-1412",
          "436-0056",
          "436-0046",
          "436-0106",
          "436-0065",
          "436-0035",
          "436-0224",
          "437-1405",
          "436-0051",
          "436-0102",
          "437-1402",
          "436-0092",
          "436-0047",
          "436-0058",
          "436-0085",
          "437-1304",
          "437-1404",
          "436-0116",
          "436-0003",
          "436-0071",
          "436-0075",
          "436-0336",
          "436-0117",
          "436-0081",
          "437-1423",
          "437-1424",
          "437-1425",
          "436-0036",
          "436-0105",
          "436-0334",
          "436-0001",
          "436-0103",
          "436-0104",
          "436-0032",
          "436-0042",
          "436-0112",
          "436-0111",
          "436-0006",
          "436-0061",
          "437-1416",
          "436-0021",
          "436-0029",
          "436-0024",
          "436-0086",
          "436-0004",
          "436-0020",
          "436-0052",
          "436-0066",
          "437-1305",
          "436-0053",
          "436-0226",
          "437-1306",
          "437-1301",
          "436-0115",
          "436-0038",
          "436-0093",
          "436-0338",
          "436-0015",
          "426-0000",
          "426-0037",
          "426-0066",
          "426-0081",
          "426-0015",
          "426-0045",
          "426-0022",
          "426-0007",
          "426-0076",
          "426-0034",
          "426-0051",
          "426-0017",
          "426-0026",
          "421-1103",
          "421-1123",
          "421-1131",
          "421-1121",
          "421-1113",
          "421-1122",
          "421-1101",
          "421-1112",
          "421-1115",
          "421-1111",
          "421-1114",
          "421-1102",
          "421-1132",
          "421-1124",
          "426-0087",
          "426-0008",
          "426-0036",
          "426-0004",
          "426-0202",
          "426-0001",
          "426-0024",
          "426-0212",
          "426-0064",
          "426-0223",
          "426-0054",
          "426-0033",
          "426-0079",
          "426-0016",
          "426-0056",
          "426-0071",
          "426-0035",
          "426-0003",
          "426-0203",
          "426-0201",
          "426-0021",
          "426-0073",
          "426-0065",
          "426-0085",
          "426-0077",
          "426-0063",
          "426-0082",
          "426-0075",
          "426-0131",
          "426-0053",
          "426-0043",
          "426-0055",
          "426-0044",
          "426-0062",
          "426-0046",
          "426-0221",
          "426-0041",
          "426-0134",
          "426-0013",
          "426-0012",
          "426-0061",
          "426-0023",
          "426-0057",
          "426-0031",
          "426-0032",
          "426-0084",
          "426-0019",
          "426-0204",
          "426-0213",
          "426-0222",
          "426-0211",
          "426-0014",
          "426-0205",
          "426-0086",
          "426-0038",
          "426-0042",
          "426-0011",
          "426-0025",
          "426-0006",
          "426-0088",
          "426-0132",
          "426-0018",
          "426-0067",
          "426-0029",
          "426-0028",
          "426-0074",
          "426-0005",
          "426-0027",
          "426-0070",
          "426-0072",
          "426-0224",
          "426-0078",
          "426-0133",
          "426-0083",
          "426-0052",
          "426-0009",
          "426-0002",
          "426-0047",
          "412-0000",
          "412-0048",
          "412-0008",
          "412-0034",
          "412-0014",
          "412-0013",
          "412-0039",
          "412-0002",
          "412-0045",
          "412-0009",
          "412-0041",
          "412-0033",
          "412-0029",
          "412-0028",
          "412-0038",
          "412-0003",
          "412-0047",
          "412-0044",
          "412-0022",
          "412-0017",
          "412-0037",
          "412-0006",
          "412-0015",
          "412-0035",
          "412-0007",
          "412-0043",
          "412-0027",
          "412-0025",
          "412-0021",
          "412-0031",
          "412-0036",
          "412-0042",
          "412-0026",
          "412-0024",
          "412-0005",
          "412-0023",
          "412-0051",
          "412-0032",
          "412-0011",
          "412-0004",
          "412-0046",
          "412-0012",
          "412-0001",
          "412-0016",
          "412-0019",
          "412-0018",
          "437-0000",
          "437-0031",
          "437-0039",
          "437-0040",
          "437-0016",
          "437-0034",
          "437-1122",
          "437-1102",
          "437-1101",
          "437-1123",
          "437-0015",
          "437-0013",
          "437-0062",
          "437-0033",
          "437-0121",
          "437-1105",
          "437-0014",
          "437-0052",
          "437-1112",
          "437-0006",
          "437-1312",
          "437-0036",
          "437-0124",
          "437-0056",
          "437-0029",
          "437-0127",
          "437-0028",
          "437-0125",
          "437-0003",
          "437-0064",
          "437-0002",
          "437-0046",
          "437-0012",
          "437-0061",
          "437-0025",
          "437-0037",
          "437-0123",
          "437-0035",
          "437-0038",
          "437-0023",
          "437-0027",
          "437-0063",
          "437-1116",
          "437-0126",
          "437-0055",
          "437-0067",
          "437-0054",
          "437-1124",
          "437-0004",
          "437-0032",
          "437-1103",
          "437-1125",
          "437-1111",
          "437-1126",
          "437-0043",
          "437-1104",
          "437-1118",
          "437-0047",
          "437-1114",
          "437-0053",
          "437-1119",
          "437-0122",
          "437-1113",
          "437-0045",
          "437-0021",
          "437-0051",
          "437-0026",
          "437-0022",
          "437-0065",
          "437-1117",
          "437-0044",
          "437-0024",
          "437-0005",
          "437-1115",
          "437-0041",
          "437-0011",
          "437-1121",
          "437-1311",
          "437-0066",
          "437-0001",
          "437-0042",
          "437-0057",
          "437-0017",
          "415-0000",
          "415-0001",
          "413-0711",
          "413-0703",
          "415-0021",
          "413-0715",
          "415-0038",
          "415-0039",
          "413-0701",
          "415-0013",
          "413-0713",
          "415-0028",
          "413-0714",
          "415-0027",
          "415-0011",
          "415-0025",
          "415-0023",
          "413-0704",
          "415-0037",
          "415-0012",
          "415-0014",
          "413-0716",
          "415-0015",
          "415-0034",
          "415-0032",
          "415-0029",
          "415-0016",
          "415-0018",
          "415-0036",
          "415-0022",
          "415-0017",
          "415-0035",
          "413-0702",
          "415-0033",
          "413-0705",
          "413-0712",
          "415-0024",
          "415-0031",
          "415-0026",
          "410-1100",
          "410-1108",
          "410-1117",
          "410-1123",
          "410-1113",
          "410-1104",
          "410-1101",
          "410-1114",
          "410-1103",
          "410-1106",
          "410-1111",
          "410-1112",
          "410-1118",
          "410-1105",
          "410-1231",
          "410-1116",
          "410-1115",
          "410-1121",
          "410-1125",
          "410-1127",
          "410-1102",
          "410-1128",
          "410-1107",
          "410-1124",
          "410-1122",
          "410-1126",
          "410-1109",
          "431-0400",
          "431-0302",
          "431-0304",
          "431-0301",
          "431-0303",
          "431-0411",
          "431-0412",
          "431-0425",
          "431-0427",
          "431-0404",
          "431-0403",
          "431-0422",
          "431-0432",
          "431-0405",
          "431-0441",
          "431-0442",
          "431-0452",
          "431-0451",
          "431-0421",
          "431-0423",
          "431-0424",
          "431-0426",
          "431-0428",
          "431-0444",
          "431-0429",
          "431-0443",
          "431-0401",
          "431-0402",
          "431-0431",
          "410-2400",
          "410-3213",
          "410-2516",
          "410-3205",
          "410-2509",
          "410-2412",
          "410-2417",
          "410-2415",
          "410-3217",
          "410-2402",
          "410-3301",
          "410-2407",
          "410-2405",
          "410-3209",
          "410-2502",
          "410-3216",
          "410-2517",
          "410-2411",
          "410-3202",
          "410-3304",
          "410-2413",
          "410-3201",
          "410-2515",
          "410-2501",
          "410-3214",
          "410-2416",
          "410-2503",
          "410-2513",
          "410-2504",
          "410-3204",
          "410-2404",
          "410-3215",
          "410-3302",
          "410-2506",
          "410-2519",
          "410-2403",
          "410-2512",
          "410-2505",
          "410-2507",
          "410-2406",
          "410-2518",
          "410-2418",
          "410-3212",
          "410-2414",
          "410-2401",
          "410-3211",
          "410-2511",
          "410-3207",
          "410-3303",
          "410-3203",
          "410-2508",
          "410-3206",
          "410-3208",
          "410-2514",
          "437-1600",
          "437-1612",
          "437-1621",
          "437-1615",
          "437-1601",
          "437-1613",
          "437-1604",
          "437-1614",
          "437-1605",
          "437-1622",
          "437-1611",
          "437-1602",
          "437-1623",
          "437-1603",
          "439-0000",
          "439-0012",
          "437-1507",
          "439-0017",
          "439-0013",
          "439-0021",
          "437-1524",
          "437-1506",
          "437-1521",
          "439-0031",
          "437-1503",
          "439-0016",
          "439-0002",
          "439-0014",
          "439-0003",
          "437-1512",
          "439-0034",
          "437-1514",
          "437-1505",
          "437-1513",
          "437-1501",
          "439-0005",
          "439-0032",
          "439-0025",
          "437-1523",
          "439-0001",
          "439-0008",
          "439-0036",
          "439-0011",
          "439-0024",
          "439-0037",
          "439-0026",
          "437-1504",
          "439-0019",
          "439-0022",
          "439-0035",
          "437-1502",
          "439-0006",
          "439-0018",
          "439-0015",
          "439-0023",
          "437-1522",
          "439-0033",
          "437-1511",
          "439-0007",
          "439-0009",
          "439-0004",
          "410-2200",
          "410-2202",
          "410-2311",
          "410-2112",
          "410-2103",
          "410-2323",
          "410-2203",
          "410-2325",
          "410-2223",
          "410-2201",
          "410-2101",
          "410-2122",
          "410-2314",
          "410-2318",
          "410-2302",
          "410-2304",
          "410-2315",
          "410-2303",
          "410-2111",
          "410-2301",
          "410-2313",
          "410-2121",
          "410-2312",
          "410-2213",
          "410-2113",
          "410-2211",
          "410-2131",
          "410-2324",
          "410-2212",
          "410-2132",
          "410-2114",
          "410-2142",
          "410-2133",
          "410-2144",
          "410-2143",
          "410-2141",
          "410-2214",
          "410-2124",
          "410-2205",
          "410-2102",
          "410-2204",
          "410-2316",
          "410-2221",
          "410-2321",
          "410-2317",
          "410-2322",
          "410-2123",
          "421-0500",
          "421-0512",
          "421-0526",
          "421-0506",
          "421-0517",
          "421-0531",
          "421-0535",
          "421-0511",
          "421-0406",
          "421-0402",
          "421-0414",
          "421-0525",
          "421-0401",
          "421-0504",
          "421-0515",
          "421-0411",
          "421-0412",
          "421-0522",
          "421-0527",
          "421-0404",
          "421-0422",
          "421-0532",
          "421-0408",
          "421-0405",
          "421-0502",
          "421-0533",
          "421-0514",
          "421-0524",
          "421-0415",
          "421-0403",
          "421-0505",
          "421-0508",
          "421-0413",
          "421-0407",
          "421-0523",
          "421-0501",
          "421-0503",
          "421-0521",
          "421-0421",
          "421-0534",
          "421-0509",
          "421-0409",
          "421-0513",
          "421-0516",
          "421-0507",
          "413-0300",
          "413-0411",
          "413-0301",
          "413-0303",
          "413-0304",
          "413-0302",
          "413-0500",
          "413-0509",
          "413-0502",
          "413-0508",
          "413-0516",
          "413-0512",
          "413-0505",
          "413-0506",
          "413-0504",
          "413-0501",
          "413-0514",
          "413-0513",
          "413-0503",
          "413-0511",
          "413-0515",
          "413-0507",
          "415-0300",
          "415-0151",
          "415-0327",
          "415-0306",
          "415-0313",
          "415-0301",
          "415-0325",
          "415-0531",
          "415-0312",
          "415-0156",
          "415-0322",
          "415-0155",
          "415-0304",
          "415-0324",
          "415-0302",
          "415-0323",
          "415-0321",
          "415-0532",
          "415-0154",
          "415-0303",
          "415-0326",
          "415-0533",
          "415-0314",
          "415-0153",
          "415-0311",
          "415-0305",
          "415-0152",
          "410-3600",
          "410-3603",
          "410-3601",
          "410-3616",
          "410-3614",
          "410-3613",
          "410-3617",
          "410-3624",
          "410-3604",
          "410-3607",
          "410-3615",
          "410-3627",
          "410-3602",
          "410-3625",
          "410-3623",
          "410-3626",
          "410-3622",
          "410-3606",
          "410-3611",
          "410-3618",
          "410-3605",
          "410-3612",
          "410-3621",
          "410-3500",
          "410-3502",
          "410-3512",
          "410-3501",
          "410-3511",
          "410-3515",
          "410-3513",
          "410-3514",
          "419-0100",
          "419-0121",
          "419-0113",
          "419-0112",
          "419-0122",
          "419-0103",
          "411-0001",
          "419-0101",
          "419-0115",
          "419-0102",
          "419-0105",
          "419-0124",
          "419-0114",
          "419-0104",
          "419-0111",
          "419-0125",
          "419-0116",
          "419-0107",
          "419-0123",
          "419-0106",
          "411-0912",
          "411-0904",
          "411-0911",
          "411-0901",
          "411-0902",
          "411-0903",
          "411-0917",
          "411-0913",
          "411-0916",
          "411-0905",
          "411-0914",
          "411-0907",
          "411-0915",
          "411-0906",
          "411-0918",
          "411-0941",
          "411-0935",
          "411-0951",
          "411-0943",
          "411-0934",
          "411-0944",
          "411-0942",
          "411-0933",
          "411-0931",
          "411-0945",
          "411-0932",
          "411-0936",
          "410-1300",
          "410-1321",
          "410-1314",
          "410-1303",
          "410-1325",
          "410-1306",
          "410-1317",
          "410-1308",
          "410-1311",
          "410-1323",
          "410-1315",
          "410-1432",
          "410-1324",
          "410-1316",
          "410-1312",
          "410-1431",
          "410-1313",
          "410-1327",
          "410-1302",
          "410-1307",
          "410-1304",
          "410-1301",
          "410-1305",
          "410-1326",
          "410-1322",
          "421-0300",
          "421-0305",
          "421-0303",
          "421-0302",
          "421-0304",
          "421-0301",
          "428-0300",
          "428-0417",
          "428-0303",
          "428-0402",
          "428-0401",
          "428-0412",
          "428-0415",
          "428-0313",
          "428-0315",
          "428-0413",
          "428-0418",
          "428-0305",
          "428-0304",
          "428-0314",
          "428-0411",
          "428-0416",
          "428-0306",
          "428-0301",
          "428-0414",
          "428-0302",
          "428-0312",
          "428-0311",
          "437-0200",
          "437-0216",
          "437-0222",
          "437-0226",
          "437-0224",
          "437-0217",
          "437-0221",
          "437-0205",
          "437-0203",
          "437-0206",
          "437-0202",
          "437-0214",
          "437-0201",
          "437-0211",
          "437-0227",
          "437-0204",
          "437-0223",
          "437-0207",
          "437-0208",
          "437-0212",
          "437-0213",
          "437-0215",
          "437-0225",
          "464-0000",
          "464-0852",
          "464-0094",
          "464-0019",
          "464-0811",
          "464-0029",
          "464-0067",
          "464-0066",
          "464-0818",
          "464-0012",
          "464-0824",
          "464-0026",
          "464-0850",
          "464-0851",
          "464-0082",
          "464-0075",
          "464-0854",
          "464-0833",
          "464-0837",
          "464-0835",
          "464-0816",
          "464-0841",
          "464-0041",
          "464-0002",
          "464-0033",
          "464-0021",
          "464-0086",
          "464-0806",
          "464-0826",
          "464-0831",
          "464-0077",
          "464-0836",
          "464-0083",
          "464-0016",
          "464-0004",
          "464-0034",
          "464-0842",
          "464-0037",
          "464-0815",
          "464-0061",
          "464-0062",
          "464-0085",
          "464-0853",
          "464-0025",
          "464-0064",
          "464-0096",
          "464-0044",
          "464-0084",
          "464-0823",
          "464-0013",
          "464-0046",
          "464-0846",
          "464-0045",
          "464-0027",
          "464-0859",
          "464-0072",
          "464-0003",
          "464-0821",
          "464-0087",
          "464-0812",
          "464-0073",
          "464-0007",
          "464-0053",
          "464-0023",
          "464-0803",
          "464-0051",
          "464-0052",
          "464-0054",
          "464-0827",
          "464-0081",
          "464-0858",
          "464-0855",
          "464-0092",
          "464-0093",
          "464-0005",
          "464-0011",
          "464-0043",
          "464-0056",
          "464-0871",
          "464-0095",
          "464-0028",
          "464-0031",
          "464-0074",
          "464-0017",
          "464-0097",
          "464-0018",
          "464-0845",
          "464-0813",
          "464-0825",
          "464-0063",
          "464-0844",
          "464-0032",
          "464-0805",
          "464-0035",
          "464-0857",
          "464-0848",
          "464-0847",
          "464-0038",
          "464-0006",
          "464-0001",
          "464-0807",
          "464-0804",
          "464-0834",
          "464-0055",
          "464-0039",
          "464-0856",
          "464-0015",
          "464-0814",
          "464-0024",
          "464-0022",
          "464-0057",
          "464-0076",
          "464-0801",
          "464-0802",
          "464-0808",
          "464-0822",
          "464-0065",
          "464-0036",
          "464-0843",
          "464-0014",
          "464-0817",
          "464-0042",
          "464-0008",
          "464-0091",
          "464-0832",
          "464-0819",
          "464-0071",
          "461-0000",
          "461-0012",
          "461-0004",
          "461-0026",
          "461-0013",
          "461-0001",
          "461-0021",
          "461-0033",
          "461-0016",
          "461-0036",
          "461-0035",
          "461-0049",
          "461-0019",
          "461-0014",
          "461-0011",
          "461-0038",
          "461-0045",
          "461-0002",
          "461-0043",
          "461-0047",
          "461-0018",
          "461-0003",
          "461-0032",
          "461-0025",
          "461-0023",
          "461-0034",
          "461-0007",
          "461-0022",
          "461-0015",
          "461-0005",
          "461-0006",
          "461-0017",
          "461-0009",
          "461-0037",
          "461-0008",
          "461-0046",
          "461-0031",
          "461-0040",
          "461-0044",
          "461-0048",
          "461-0024",
          "461-0027",
          "462-0000",
          "462-0856",
          "462-0005",
          "462-0832",
          "462-0855",
          "462-0064",
          "462-0858",
          "462-0837",
          "462-0836",
          "462-0825",
          "462-0035",
          "462-0017",
          "462-0807",
          "462-0863",
          "462-0864",
          "462-0061",
          "462-0867",
          "462-0033",
          "462-0808",
          "462-0803",
          "462-0809",
          "462-0804",
          "462-0802",
          "462-0022",
          "462-0065",
          "462-0001",
          "462-0851",
          "462-0003",
          "462-0847",
          "462-0047",
          "462-0012",
          "462-0014",
          "462-0066",
          "462-0841",
          "462-0018",
          "462-0857",
          "462-0053",
          "462-0011",
          "462-0059",
          "462-0031",
          "462-0818",
          "462-0852",
          "462-0004",
          "462-0037",
          "462-0853",
          "462-0842",
          "462-0045",
          "462-0844",
          "462-0865",
          "462-0021",
          "462-0831",
          "462-0046",
          "462-0062",
          "462-0801",
          "462-0859",
          "462-0829",
          "462-0835",
          "462-0869",
          "462-0843",
          "462-0038",
          "462-0056",
          "462-0834",
          "462-0032",
          "462-0861",
          "462-0034",
          "462-0868",
          "462-0009",
          "462-0015",
          "462-0051",
          "462-0838",
          "462-0036",
          "462-0041",
          "462-0016",
          "462-0058",
          "462-0007",
          "462-0008",
          "462-0054",
          "462-0026",
          "462-0805",
          "462-0024",
          "462-0025",
          "462-0013",
          "462-0826",
          "462-0823",
          "462-0827",
          "462-0828",
          "462-0057",
          "462-0052",
          "462-0819",
          "462-0816",
          "462-0862",
          "462-0055",
          "462-0063",
          "462-0833",
          "462-0042",
          "462-0846",
          "462-0044",
          "462-0043",
          "462-0023",
          "462-0812",
          "462-0845",
          "462-0810",
          "462-0813",
          "462-0814",
          "462-0811",
          "462-0824",
          "462-0866",
          "462-0002",
          "462-0006",
          "462-0854",
          "451-0000",
          "452-0813",
          "452-0823",
          "451-0021",
          "452-0836",
          "452-0805",
          "451-0012",
          "452-0846",
          "451-0046",
          "451-6090",
          "451-6001",
          "451-6002",
          "451-6003",
          "451-6004",
          "451-6005",
          "451-6006",
          "451-6007",
          "451-6008",
          "451-6009",
          "451-6010",
          "451-6011",
          "451-6012",
          "451-6013",
          "451-6014",
          "451-6015",
          "451-6016",
          "451-6017",
          "451-6018",
          "451-6019",
          "451-6020",
          "451-6021",
          "451-6022",
          "451-6023",
          "451-6024",
          "451-6025",
          "451-6026",
          "451-6027",
          "451-6028",
          "451-6029",
          "451-6030",
          "451-6031",
          "451-6032",
          "451-6033",
          "451-6034",
          "451-6035",
          "451-6036",
          "451-6037",
          "451-6038",
          "451-6039",
          "451-6040",
          "452-0807",
          "451-0013",
          "452-0831",
          "451-0082",
          "452-0803",
          "451-0063",
          "451-0022",
          "451-0072",
          "452-0821",
          "451-0025",
          "452-0844",
          "451-0084",
          "451-0044",
          "452-0816",
          "452-0834",
          "452-0801",
          "451-0075",
          "451-0015",
          "452-0806",
          "451-0066",
          "452-0824",
          "452-0804",
          "451-0052",
          "451-0077",
          "451-0031",
          "451-0061",
          "451-0073",
          "451-0016",
          "452-0841",
          "451-0023",
          "452-0842",
          "451-0083",
          "451-0043",
          "451-0032",
          "452-0811",
          "451-0035",
          "451-0026",
          "452-0812",
          "451-0024",
          "451-0065",
          "451-0076",
          "452-0837",
          "451-0071",
          "452-0822",
          "452-0845",
          "452-0838",
          "451-0042",
          "451-0081",
          "451-0027",
          "452-0848",
          "452-0847",
          "451-0051",
          "451-0062",
          "452-0809",
          "451-0041",
          "451-0034",
          "452-0802",
          "452-0832",
          "452-0843",
          "451-0053",
          "452-0817",
          "452-0808",
          "451-0055",
          "451-0033",
          "451-0011",
          "451-0014",
          "452-0835",
          "451-0074",
          "452-0814",
          "451-0054",
          "452-0839",
          "451-0045",
          "451-0064",
          "452-0815",
          "452-0833",
          "452-0818",
          "453-0000",
          "453-0848",
          "453-0066",
          "453-0849",
          "453-0841",
          "453-0057",
          "453-0832",
          "453-0038",
          "453-0012",
          "453-0847",
          "453-0862",
          "453-0861",
          "453-0853",
          "453-0873",
          "453-0042",
          "453-0821",
          "453-0027",
          "453-0825",
          "453-0833",
          "453-0852",
          "453-0855",
          "453-0055",
          "453-0835",
          "453-0809",
          "453-0043",
          "453-0013",
          "453-0843",
          "453-0865",
          "453-0068",
          "453-0824",
          "453-0815",
          "453-0816",
          "453-0064",
          "453-0814",
          "453-0808",
          "453-0804",
          "453-0844",
          "453-0836",
          "453-0028",
          "453-0807",
          "453-0033",
          "453-0018",
          "450-0007",
          "453-0032",
          "453-0802",
          "453-0827",
          "450-0006",
          "453-0035",
          "453-0067",
          "453-0819",
          "453-0817",
          "453-0058",
          "453-0031",
          "453-0056",
          "453-0062",
          "453-0818",
          "453-0801",
          "453-0811",
          "453-0806",
          "453-0034",
          "453-0854",
          "453-0037",
          "453-0016",
          "453-0011",
          "453-0015",
          "453-0842",
          "453-0834",
          "453-0051",
          "453-0044",
          "453-0054",
          "453-0022",
          "453-0053",
          "453-0831",
          "453-0828",
          "453-0839",
          "453-0857",
          "453-0803",
          "450-0001",
          "453-0856",
          "453-0025",
          "453-0812",
          "453-0846",
          "450-0005",
          "453-0826",
          "453-0859",
          "453-0858",
          "453-0014",
          "453-0017",
          "453-0026",
          "453-0069",
          "453-0851",
          "453-0863",
          "453-0063",
          "453-0823",
          "453-0061",
          "453-0029",
          "453-0872",
          "453-6190",
          "453-6101",
          "453-6102",
          "453-6103",
          "453-6104",
          "453-6105",
          "453-6106",
          "453-6107",
          "453-6108",
          "453-6109",
          "453-6110",
          "453-6111",
          "453-6112",
          "453-6113",
          "453-6114",
          "453-6115",
          "453-6116",
          "453-6117",
          "453-6118",
          "453-6119",
          "453-6120",
          "453-6121",
          "453-6122",
          "453-6123",
          "453-6124",
          "453-6125",
          "453-6126",
          "453-6127",
          "453-6128",
          "453-6129",
          "453-6130",
          "453-6131",
          "453-6132",
          "453-6133",
          "453-6134",
          "453-6135",
          "453-6136",
          "453-0805",
          "453-0045",
          "453-0837",
          "453-0813",
          "453-0041",
          "453-0871",
          "450-0004",
          "453-0021",
          "453-0046",
          "453-0845",
          "453-0838",
          "453-0002",
          "450-6690",
          "450-6601",
          "450-6602",
          "450-6603",
          "450-6604",
          "450-6605",
          "450-6606",
          "450-6607",
          "450-6608",
          "450-6609",
          "450-6610",
          "450-6611",
          "450-6612",
          "450-6613",
          "450-6614",
          "450-6615",
          "450-6616",
          "450-6617",
          "450-6618",
          "450-6619",
          "450-6620",
          "450-6621",
          "450-6622",
          "450-6623",
          "450-6624",
          "450-6625",
          "450-6626",
          "450-6627",
          "450-6628",
          "450-6629",
          "450-6630",
          "450-6631",
          "450-6632",
          "450-6633",
          "450-6634",
          "450-6635",
          "450-6636",
          "450-6637",
          "450-6638",
          "450-6639",
          "450-6640",
          "450-6641",
          "450-6642",
          "450-6643",
          "450-6644",
          "450-6645",
          "450-6646",
          "450-6090",
          "450-6001",
          "450-6002",
          "450-6003",
          "450-6004",
          "450-6005",
          "450-6006",
          "450-6007",
          "450-6008",
          "450-6009",
          "450-6010",
          "450-6011",
          "450-6012",
          "450-6013",
          "450-6014",
          "450-6015",
          "450-6016",
          "450-6017",
          "450-6018",
          "450-6019",
          "450-6020",
          "450-6021",
          "450-6022",
          "450-6023",
          "450-6024",
          "450-6025",
          "450-6026",
          "450-6027",
          "450-6028",
          "450-6029",
          "450-6030",
          "450-6031",
          "450-6032",
          "450-6033",
          "450-6034",
          "450-6035",
          "450-6036",
          "450-6037",
          "450-6038",
          "450-6039",
          "450-6040",
          "450-6041",
          "450-6042",
          "450-6043",
          "450-6044",
          "450-6045",
          "450-6046",
          "450-6047",
          "450-6048",
          "450-6049",
          "450-6050",
          "450-6051",
          "450-6390",
          "450-6301",
          "450-6302",
          "450-6303",
          "450-6304",
          "450-6305",
          "450-6306",
          "450-6307",
          "450-6308",
          "450-6309",
          "450-6310",
          "450-6311",
          "450-6312",
          "450-6313",
          "450-6314",
          "450-6315",
          "450-6316",
          "450-6317",
          "450-6318",
          "450-6319",
          "450-6320",
          "450-6321",
          "450-6322",
          "450-6323",
          "450-6324",
          "450-6325",
          "450-6326",
          "450-6327",
          "450-6328",
          "450-6329",
          "450-6330",
          "450-6331",
          "450-6332",
          "450-6333",
          "450-6334",
          "450-6335",
          "450-6336",
          "450-6337",
          "450-6338",
          "450-6339",
          "450-6340",
          "450-6490",
          "450-6401",
          "450-6402",
          "450-6403",
          "450-6404",
          "450-6405",
          "450-6406",
          "450-6407",
          "450-6408",
          "450-6409",
          "450-6410",
          "450-6411",
          "450-6412",
          "450-6413",
          "450-6414",
          "450-6415",
          "450-6416",
          "450-6417",
          "450-6418",
          "450-6419",
          "450-6420",
          "450-6421",
          "450-6422",
          "450-6423",
          "450-6424",
          "450-6425",
          "450-6426",
          "450-6427",
          "450-6428",
          "450-6429",
          "450-6430",
          "450-6431",
          "450-6432",
          "450-6433",
          "450-6434",
          "450-6290",
          "450-6201",
          "450-6202",
          "450-6203",
          "450-6204",
          "450-6205",
          "450-6206",
          "450-6207",
          "450-6208",
          "450-6209",
          "450-6210",
          "450-6211",
          "450-6212",
          "450-6213",
          "450-6214",
          "450-6215",
          "450-6216",
          "450-6217",
          "450-6218",
          "450-6219",
          "450-6220",
          "450-6221",
          "450-6222",
          "450-6223",
          "450-6224",
          "450-6225",
          "450-6226",
          "450-6227",
          "450-6228",
          "450-6229",
          "450-6230",
          "450-6231",
          "450-6232",
          "450-6233",
          "450-6234",
          "450-6235",
          "450-6236",
          "450-6237",
          "450-6238",
          "450-6239",
          "450-6240",
          "450-6241",
          "450-6242",
          "450-6243",
          "450-6244",
          "450-6245",
          "450-6246",
          "450-6247",
          "450-0002",
          "450-0003",
          "453-0822",
          "453-0024",
          "453-0047",
          "453-0052",
          "453-0036",
          "453-0065",
          "453-0866",
          "453-0867",
          "453-0864",
          "453-0023",
          "460-0000",
          "460-0006",
          "460-0026",
          "460-0015",
          "460-0011",
          "460-0022",
          "460-0023",
          "460-0013",
          "460-0008",
          "460-0001",
          "460-0007",
          "460-0004",
          "460-0016",
          "460-0012",
          "460-0003",
          "460-0032",
          "460-0005",
          "460-0014",
          "460-0025",
          "460-0021",
          "460-0031",
          "460-0024",
          "460-0017",
          "460-0002",
          "460-0018",
          "466-0000",
          "466-0003",
          "466-0027",
          "466-0844",
          "466-0805",
          "466-0043",
          "466-0023",
          "466-0047",
          "466-0037",
          "466-0054",
          "466-0858",
          "466-0802",
          "466-0836",
          "466-0856",
          "466-0855",
          "466-0827",
          "466-0853",
          "466-0843",
          "466-0006",
          "466-0016",
          "466-0001",
          "466-0031",
          "466-0051",
          "466-0061",
          "466-0015",
          "466-0838",
          "466-0021",
          "466-0012",
          "466-0832",
          "466-0044",
          "466-0022",
          "466-0837",
          "466-0025",
          "466-0058",
          "466-0033",
          "466-0801",
          "466-0057",
          "466-0811",
          "466-0826",
          "466-0053",
          "466-0055",
          "466-0842",
          "466-0011",
          "466-0064",
          "466-0065",
          "466-0041",
          "466-0032",
          "466-0056",
          "466-0026",
          "466-0014",
          "466-0846",
          "466-0847",
          "466-0848",
          "466-0806",
          "466-0852",
          "466-0062",
          "466-0831",
          "466-0833",
          "466-0042",
          "466-0834",
          "466-0854",
          "466-0841",
          "466-0004",
          "466-0046",
          "466-0002",
          "466-0059",
          "466-0803",
          "466-0845",
          "466-0821",
          "466-0035",
          "466-0045",
          "466-0013",
          "466-0835",
          "466-0849",
          "466-0804",
          "466-0814",
          "466-0829",
          "466-0052",
          "466-0034",
          "466-0851",
          "466-0823",
          "466-0812",
          "466-0825",
          "466-0857",
          "466-0824",
          "466-0024",
          "466-0828",
          "466-0815",
          "466-0807",
          "466-0063",
          "466-0005",
          "466-0822",
          "466-0036",
          "467-0000",
          "467-0846",
          "467-0005",
          "467-0067",
          "467-0063",
          "467-0835",
          "467-0057",
          "467-0045",
          "467-0854",
          "467-0863",
          "467-0068",
          "467-0853",
          "467-0874",
          "467-0006",
          "467-0007",
          "467-0833",
          "467-0044",
          "467-0052",
          "467-0824",
          "467-0051",
          "467-0821",
          "467-0847",
          "467-0832",
          "467-0022",
          "467-0876",
          "467-0845",
          "467-0844",
          "467-0002",
          "467-0877",
          "467-0811",
          "467-0059",
          "467-0807",
          "467-0805",
          "467-0812",
          "467-0016",
          "467-0851",
          "467-0003",
          "467-0827",
          "467-0049",
          "467-0867",
          "467-0004",
          "467-0056",
          "467-0014",
          "467-0856",
          "467-0804",
          "467-0871",
          "467-0066",
          "467-0058",
          "467-0013",
          "467-0831",
          "467-0015",
          "467-0868",
          "467-0822",
          "467-0808",
          "467-0872",
          "467-0873",
          "467-0043",
          "467-0828",
          "467-0027",
          "467-0046",
          "467-0021",
          "467-0823",
          "467-0836",
          "467-0843",
          "467-0017",
          "467-0012",
          "467-0841",
          "467-0865",
          "467-0055",
          "467-0803",
          "467-0813",
          "467-0053",
          "467-0011",
          "467-0826",
          "467-0042",
          "467-0028",
          "467-0837",
          "467-0024",
          "467-0047",
          "467-0834",
          "467-0861",
          "467-0878",
          "467-0879",
          "467-0866",
          "467-0862",
          "467-0814",
          "467-0815",
          "467-0816",
          "467-0025",
          "467-0065",
          "467-0864",
          "467-0054",
          "467-0041",
          "467-0001",
          "467-0801",
          "467-0802",
          "467-0806",
          "467-0875",
          "467-0023",
          "467-0842",
          "467-0008",
          "467-0852",
          "467-0855",
          "467-0061",
          "467-0048",
          "467-0036",
          "467-0039",
          "467-0037",
          "467-0032",
          "467-0034",
          "467-0038",
          "467-0035",
          "467-0033",
          "467-0031",
          "467-0064",
          "467-0825",
          "467-0062",
          "467-0026",
          "456-0000",
          "456-0075",
          "456-0071",
          "456-0037",
          "456-0036",
          "456-0005",
          "456-0053",
          "456-0044",
          "456-0045",
          "456-0017",
          "456-0001",
          "456-0002",
          "456-0065",
          "456-0072",
          "456-0046",
          "456-0076",
          "456-0043",
          "456-0064",
          "456-0057",
          "456-0016",
          "456-0061",
          "456-0004",
          "456-0012",
          "456-0006",
          "456-0056",
          "456-0032",
          "456-0035",
          "456-0048",
          "456-0018",
          "456-0031",
          "456-0068",
          "456-0042",
          "456-0013",
          "456-0062",
          "456-0015",
          "456-0047",
          "456-0025",
          "456-0054",
          "456-0073",
          "456-0034",
          "456-0041",
          "456-0014",
          "456-0067",
          "456-0069",
          "456-0003",
          "456-0063",
          "456-0052",
          "456-0066",
          "456-0077",
          "456-0027",
          "456-0026",
          "456-0059",
          "456-0033",
          "456-0011",
          "456-0074",
          "456-0055",
          "456-0078",
          "456-0023",
          "456-0024",
          "456-0022",
          "456-0021",
          "456-0051",
          "456-0058",
          "454-0000",
          "454-0807",
          "454-0057",
          "454-0032",
          "454-0869",
          "454-0044",
          "454-0861",
          "454-0922",
          "454-0946",
          "454-0023",
          "454-0905",
          "454-0901",
          "454-0043",
          "454-0926",
          "454-0924",
          "454-0923",
          "454-0927",
          "454-0845",
          "454-0001",
          "454-0002",
          "454-0951",
          "454-0952",
          "454-0954",
          "454-0959",
          "454-0026",
          "454-0042",
          "454-0863",
          "454-0843",
          "454-0051",
          "454-0841",
          "454-0012",
          "454-0829",
          "454-0906",
          "454-0865",
          "454-0819",
          "454-0957",
          "454-0873",
          "454-0846",
          "454-0833",
          "454-0916",
          "454-0851",
          "454-0049",
          "454-0832",
          "454-0874",
          "454-0868",
          "454-0984",
          "454-0856",
          "454-0808",
          "454-0875",
          "454-0849",
          "454-0033",
          "454-0034",
          "454-0828",
          "454-0826",
          "454-0812",
          "454-0814",
          "454-0011",
          "454-0822",
          "454-0839",
          "454-0974",
          "454-0945",
          "454-0858",
          "454-0854",
          "454-0855",
          "454-0852",
          "454-0046",
          "454-0055",
          "454-0056",
          "454-0947",
          "454-0806",
          "454-0821",
          "454-0053",
          "454-0991",
          "454-0943",
          "454-0944",
          "454-0838",
          "454-0936",
          "454-0911",
          "454-0058",
          "454-0853",
          "454-0045",
          "454-0816",
          "454-0921",
          "454-0804",
          "454-0827",
          "454-0824",
          "454-0913",
          "454-0022",
          "454-0028",
          "454-0962",
          "454-0967",
          "454-0961",
          "454-0966",
          "454-0037",
          "454-0955",
          "454-0956",
          "454-0971",
          "454-0973",
          "454-0986",
          "454-0995",
          "454-0942",
          "454-0993",
          "454-0992",
          "454-0953",
          "454-0964",
          "454-0823",
          "454-0932",
          "454-0994",
          "454-0925",
          "454-0837",
          "454-0047",
          "454-0931",
          "454-0815",
          "454-0972",
          "454-0934",
          "454-0004",
          "454-0005",
          "454-0982",
          "454-0036",
          "454-0912",
          "454-0813",
          "454-0844",
          "454-0860",
          "454-0016",
          "454-0054",
          "454-0877",
          "454-0904",
          "454-0976",
          "454-0902",
          "454-0052",
          "454-0985",
          "454-0935",
          "454-0958",
          "454-0866",
          "454-0983",
          "454-0975",
          "454-0864",
          "454-0027",
          "454-0007",
          "454-0867",
          "454-0059",
          "454-0965",
          "454-0802",
          "454-0836",
          "454-0996",
          "454-0805",
          "454-0803",
          "454-0859",
          "454-0847",
          "454-0933",
          "454-0937",
          "454-0914",
          "454-0941",
          "454-0025",
          "454-0003",
          "454-0848",
          "454-0818",
          "454-0862",
          "454-0834",
          "454-0872",
          "454-0997",
          "454-0963",
          "454-0811",
          "454-0831",
          "454-0015",
          "454-0817",
          "454-0842",
          "454-0857",
          "454-0048",
          "454-0801",
          "454-0041",
          "454-0013",
          "454-0035",
          "454-0835",
          "454-0014",
          "454-0024",
          "454-0907",
          "454-0006",
          "454-0903",
          "454-0871",
          "454-0031",
          "454-0915",
          "454-0021",
          "454-0917",
          "454-0981",
          "454-0825",
          "454-0876",
          "455-0000",
          "455-0857",
          "455-0035",
          "455-0815",
          "455-0823",
          "455-0841",
          "455-0842",
          "455-0803",
          "455-0802",
          "455-0032",
          "455-0052",
          "455-0054",
          "455-0801",
          "455-0062",
          "455-0024",
          "455-0046",
          "455-0861",
          "455-0864",
          "455-0017",
          "455-0063",
          "455-0016",
          "455-0856",
          "455-0073",
          "455-0076",
          "455-0066",
          "455-0021",
          "455-0869",
          "455-0848",
          "455-0008",
          "455-0015",
          "455-0067",
          "455-0018",
          "455-0013",
          "455-0014",
          "455-0882",
          "455-0077",
          "455-0041",
          "455-0043",
          "455-0012",
          "455-0042",
          "455-0846",
          "455-0844",
          "455-0028",
          "455-0884",
          "455-0001",
          "455-0055",
          "455-0831",
          "455-0835",
          "455-0075",
          "455-0074",
          "455-0026",
          "455-0005",
          "455-0834",
          "455-0863",
          "455-0071",
          "455-0822",
          "455-0056",
          "455-0072",
          "455-0811",
          "455-0813",
          "455-0881",
          "455-0814",
          "455-0812",
          "455-0847",
          "455-0069",
          "455-0821",
          "455-0825",
          "455-0003",
          "455-0057",
          "455-0883",
          "455-0011",
          "455-0031",
          "455-0004",
          "455-0044",
          "455-0045",
          "455-0875",
          "455-0865",
          "455-0002",
          "455-0804",
          "455-0805",
          "455-0068",
          "455-0051",
          "455-0047",
          "455-0852",
          "455-0862",
          "455-0866",
          "455-0853",
          "455-0868",
          "455-0871",
          "455-0867",
          "455-0872",
          "455-0824",
          "455-0843",
          "455-0034",
          "455-0858",
          "455-0874",
          "455-0845",
          "455-0879",
          "455-0885",
          "455-0036",
          "455-0873",
          "455-0886",
          "455-0851",
          "455-0023",
          "455-0061",
          "455-0887",
          "455-0878",
          "455-0876",
          "455-0854",
          "455-0855",
          "455-0027",
          "455-0832",
          "455-0833",
          "455-0065",
          "455-0064",
          "455-0078",
          "455-0033",
          "455-0007",
          "455-0006",
          "455-0037",
          "455-0053",
          "455-0806",
          "455-0025",
          "455-0022",
          "455-0877",
          "457-0000",
          "457-0024",
          "457-0063",
          "457-0831",
          "457-0075",
          "457-0015",
          "457-0862",
          "457-0037",
          "457-0048",
          "457-0002",
          "457-0035",
          "457-0007",
          "457-0051",
          "457-0034",
          "457-0052",
          "457-0033",
          "457-0802",
          "457-0837",
          "457-0836",
          "457-0067",
          "457-0824",
          "457-0845",
          "457-0012",
          "457-0049",
          "457-0827",
          "457-0028",
          "457-0804",
          "457-0834",
          "457-0851",
          "457-0044",
          "457-0005",
          "457-0038",
          "457-0866",
          "457-0016",
          "457-0078",
          "457-0854",
          "457-0815",
          "457-0814",
          "457-0023",
          "457-0047",
          "457-0054",
          "457-0852",
          "457-0042",
          "457-0008",
          "457-0811",
          "457-0031",
          "457-0819",
          "457-0077",
          "457-0801",
          "457-0071",
          "457-0843",
          "457-0825",
          "457-0844",
          "457-0021",
          "457-0003",
          "457-0807",
          "457-0013",
          "457-0072",
          "457-0803",
          "457-0076",
          "457-0864",
          "457-0847",
          "457-0846",
          "457-0842",
          "457-0043",
          "457-0841",
          "457-0855",
          "457-0006",
          "457-0057",
          "457-0004",
          "457-0826",
          "457-0066",
          "457-0813",
          "457-0806",
          "457-0856",
          "457-0039",
          "457-0073",
          "457-0835",
          "457-0025",
          "457-0818",
          "457-0822",
          "457-0832",
          "457-0833",
          "457-0865",
          "457-0001",
          "457-0828",
          "457-0064",
          "457-0812",
          "457-0062",
          "457-0061",
          "457-0069",
          "457-0055",
          "457-0074",
          "457-0053",
          "457-0058",
          "457-0046",
          "457-0808",
          "457-0045",
          "457-0068",
          "457-0026",
          "457-0022",
          "457-0805",
          "457-0861",
          "457-0032",
          "457-0823",
          "457-0816",
          "457-0817",
          "457-0065",
          "457-0056",
          "457-0041",
          "457-0821",
          "457-0027",
          "457-0863",
          "457-0014",
          "457-0011",
          "457-0853",
          "457-0036",
          "463-0000",
          "463-0815",
          "463-0805",
          "463-0037",
          "463-0804",
          "463-0075",
          "463-0023",
          "463-0094",
          "463-0044",
          "463-0041",
          "463-0085",
          "463-0021",
          "463-0802",
          "463-0028",
          "463-0016",
          "463-0011",
          "463-0051",
          "463-0008",
          "463-0047",
          "463-0053",
          "463-0013",
          "463-0052",
          "463-0048",
          "463-0072",
          "463-0001",
          "463-0005",
          "463-0091",
          "463-0098",
          "463-0080",
          "463-0006",
          "463-0081",
          "463-0097",
          "463-0814",
          "463-0017",
          "463-0043",
          "463-0004",
          "463-0813",
          "463-0079",
          "463-0029",
          "463-0054",
          "463-0812",
          "463-0064",
          "463-0034",
          "463-0003",
          "463-0092",
          "463-0093",
          "463-0014",
          "463-0056",
          "463-0071",
          "463-0069",
          "463-0070",
          "463-0010",
          "463-0078",
          "463-0068",
          "463-0090",
          "463-0087",
          "463-0095",
          "463-0012",
          "463-0062",
          "463-0807",
          "463-0088",
          "463-0076",
          "463-0046",
          "463-0002",
          "463-0057",
          "463-0086",
          "463-0089",
          "463-0084",
          "463-0055",
          "463-0015",
          "463-0065",
          "463-0032",
          "463-0063",
          "463-0808",
          "463-0038",
          "463-0061",
          "463-0045",
          "463-0803",
          "463-0809",
          "463-0811",
          "463-0027",
          "463-0031",
          "463-0066",
          "463-0074",
          "463-0007",
          "463-0009",
          "463-0036",
          "463-0083",
          "463-0082",
          "463-0025",
          "463-0035",
          "463-0033",
          "463-0073",
          "463-0096",
          "463-0067",
          "463-0077",
          "463-0022",
          "463-0042",
          "463-0026",
          "463-0806",
          "463-0801",
          "463-0024",
          "458-0000",
          "458-0011",
          "458-0033",
          "458-0833",
          "458-0837",
          "458-0031",
          "458-0924",
          "458-0903",
          "458-0902",
          "458-0901",
          "458-0916",
          "458-0912",
          "458-0911",
          "458-0928",
          "459-8004",
          "458-0044",
          "459-8012",
          "458-0830",
          "458-0001",
          "458-0847",
          "458-0832",
          "458-0032",
          "458-0805",
          "458-0806",
          "458-0849",
          "459-8003",
          "459-8001",
          "459-8007",
          "458-0925",
          "458-0926",
          "458-0913",
          "458-0922",
          "458-0921",
          "458-0919",
          "458-0929",
          "458-0920",
          "458-0927",
          "458-0910",
          "458-0024",
          "458-0803",
          "458-0007",
          "458-0829",
          "458-0016",
          "458-0014",
          "458-0812",
          "458-0804",
          "458-0851",
          "459-8006",
          "458-0003",
          "458-0023",
          "458-0022",
          "458-0047",
          "458-0820",
          "458-0825",
          "458-0038",
          "458-0037",
          "458-0045",
          "458-0015",
          "458-0039",
          "459-8009",
          "459-8011",
          "458-0836",
          "458-0807",
          "458-0035",
          "458-0823",
          "458-0822",
          "458-0042",
          "459-8013",
          "458-0021",
          "458-0917",
          "459-8014",
          "458-0814",
          "458-0815",
          "458-0025",
          "458-0046",
          "458-0005",
          "458-0041",
          "458-0845",
          "458-0824",
          "458-0842",
          "458-0828",
          "458-0818",
          "458-0821",
          "458-0835",
          "458-0811",
          "458-0841",
          "458-0834",
          "458-0844",
          "458-0827",
          "458-0831",
          "458-0817",
          "458-0846",
          "458-0819",
          "458-0801",
          "458-0918",
          "458-0809",
          "458-0915",
          "458-0004",
          "458-0808",
          "458-0012",
          "458-0802",
          "458-0826",
          "458-0009",
          "458-0008",
          "458-0813",
          "459-8008",
          "459-8015",
          "458-0006",
          "458-0013",
          "458-0843",
          "458-0043",
          "458-0848",
          "459-8016",
          "458-0852",
          "458-0002",
          "459-8002",
          "458-0810",
          "458-0816",
          "459-8005",
          "458-0036",
          "458-0034",
          "465-0000",
          "465-0016",
          "465-0033",
          "465-0041",
          "465-0023",
          "465-0052",
          "465-0067",
          "465-0028",
          "465-0093",
          "465-0021",
          "465-0008",
          "465-0077",
          "465-0065",
          "465-0066",
          "465-0003",
          "465-0076",
          "465-0064",
          "465-0005",
          "465-0083",
          "465-0082",
          "465-0014",
          "465-0025",
          "465-0094",
          "465-0058",
          "465-0047",
          "465-0044",
          "465-0007",
          "465-0004",
          "465-0053",
          "465-0096",
          "465-0074",
          "465-0006",
          "465-0063",
          "465-0055",
          "465-0086",
          "465-0061",
          "465-0069",
          "465-0054",
          "465-0073",
          "465-0081",
          "465-0095",
          "465-0034",
          "465-0043",
          "465-0027",
          "465-0017",
          "465-0042",
          "465-0009",
          "465-0031",
          "465-0084",
          "465-0071",
          "465-0085",
          "465-0078",
          "465-0046",
          "465-0056",
          "465-0018",
          "465-0002",
          "465-0045",
          "465-0037",
          "465-0032",
          "465-0036",
          "465-0075",
          "465-0048",
          "465-0026",
          "465-0022",
          "465-0012",
          "465-0097",
          "465-0024",
          "465-0068",
          "465-0072",
          "465-0062",
          "465-0087",
          "465-0088",
          "465-0051",
          "465-0013",
          "465-0092",
          "465-0011",
          "465-0035",
          "465-0091",
          "465-0057",
          "465-0015",
          "468-0000",
          "468-0836",
          "468-0013",
          "468-0052",
          "468-0055",
          "468-0067",
          "468-0008",
          "468-0047",
          "468-0051",
          "468-0007",
          "468-0001",
          "468-0006",
          "468-0058",
          "468-0053",
          "468-0004",
          "468-0042",
          "468-0072",
          "468-0024",
          "468-0063",
          "468-0068",
          "468-0069",
          "468-0003",
          "468-0023",
          "468-0035",
          "468-0044",
          "468-0032",
          "468-0073",
          "468-0056",
          "468-0029",
          "468-0028",
          "468-0043",
          "468-0025",
          "468-0022",
          "468-0031",
          "468-0026",
          "468-0005",
          "468-0027",
          "468-0037",
          "468-0021",
          "468-0071",
          "468-0064",
          "468-0065",
          "468-0048",
          "468-0014",
          "468-0039",
          "468-0045",
          "468-0074",
          "468-0015",
          "468-0034",
          "468-0033",
          "468-0011",
          "468-0030",
          "468-0020",
          "468-0049",
          "468-0046",
          "468-0041",
          "468-0075",
          "468-0012",
          "468-0009",
          "468-0066",
          "468-0002",
          "468-0076",
          "468-0061",
          "468-0077",
          "468-0038",
          "468-0062",
          "468-0054",
          "441-0000",
          "441-8085",
          "440-0061",
          "441-8151",
          "441-8074",
          "440-0043",
          "440-0058",
          "440-0057",
          "441-8155",
          "440-0063",
          "440-0024",
          "440-0054",
          "440-0062",
          "440-0066",
          "440-0048",
          "440-0047",
          "440-0045",
          "440-0827",
          "441-3211",
          "441-1106",
          "441-1104",
          "441-1102",
          "441-1103",
          "441-1105",
          "441-1115",
          "441-1112",
          "441-8144",
          "441-8084",
          "441-8148",
          "440-0025",
          "440-0801",
          "440-0833",
          "440-0836",
          "440-0835",
          "440-0834",
          "441-8033",
          "440-0022",
          "440-0832",
          "440-0023",
          "440-0032",
          "440-0041",
          "440-0842",
          "440-0067",
          "441-8134",
          "441-8157",
          "440-0894",
          "440-0006",
          "440-0016",
          "440-0011",
          "440-0015",
          "441-8147",
          "441-3104",
          "441-3103",
          "441-0155",
          "441-0154",
          "440-0092",
          "440-0888",
          "441-8111",
          "441-3301",
          "440-0053",
          "441-8082",
          "440-0826",
          "441-3131",
          "441-3141",
          "441-3146",
          "441-3134",
          "441-3132",
          "441-3133",
          "441-3142",
          "441-3143",
          "441-3144",
          "441-3145",
          "441-3147",
          "441-8073",
          "441-8133",
          "440-0805",
          "440-0076",
          "440-0081",
          "441-8071",
          "441-3101",
          "441-3102",
          "441-8066",
          "440-0856",
          "440-0802",
          "440-0821",
          "440-0803",
          "440-0074",
          "441-8068",
          "441-8047",
          "441-1101",
          "440-0896",
          "440-0094",
          "440-0825",
          "440-0824",
          "440-0031",
          "441-8045",
          "441-8017",
          "440-0071",
          "441-8105",
          "440-0078",
          "440-0095",
          "441-8141",
          "440-0002",
          "440-0001",
          "441-8042",
          "441-3122",
          "440-0873",
          "441-8067",
          "440-0804",
          "441-8145",
          "441-8109",
          "441-3123",
          "441-8003",
          "441-8011",
          "440-0064",
          "440-0042",
          "440-0853",
          "441-8152",
          "441-8069",
          "440-0051",
          "440-0091",
          "440-0083",
          "440-0084",
          "440-0085",
          "440-0086",
          "441-8021",
          "441-3214",
          "441-8146",
          "440-0883",
          "441-8016",
          "441-0153",
          "441-8077",
          "441-8076",
          "441-8075",
          "440-0892",
          "440-0882",
          "440-0871",
          "441-3302",
          "441-1111",
          "440-0052",
          "440-0891",
          "440-0884",
          "441-8043",
          "441-8153",
          "440-0844",
          "441-8156",
          "440-0845",
          "441-8006",
          "441-8116",
          "441-3203",
          "440-0004",
          "441-8028",
          "440-0021",
          "440-0027",
          "440-0028",
          "440-0026",
          "440-0816",
          "441-8015",
          "440-0858",
          "441-3124",
          "441-8122",
          "440-0822",
          "440-0857",
          "440-0036",
          "440-0068",
          "441-8038",
          "441-8064",
          "440-0034",
          "441-8086",
          "441-8031",
          "440-0885",
          "440-0815",
          "441-8149",
          "440-0046",
          "441-8037",
          "441-8065",
          "441-3106",
          "441-3105",
          "440-0875",
          "440-0082",
          "440-0003",
          "441-3213",
          "440-0831",
          "440-0013",
          "440-0887",
          "441-8027",
          "440-0841",
          "441-8048",
          "440-0811",
          "441-8154",
          "441-3202",
          "441-8039",
          "441-8081",
          "441-0156",
          "440-0876",
          "441-8113",
          "441-3121",
          "440-0065",
          "441-8022",
          "441-8001",
          "441-8125",
          "441-8124",
          "441-8054",
          "441-8053",
          "441-8052",
          "441-8051",
          "441-8059",
          "441-8058",
          "441-8057",
          "441-8056",
          "441-8055",
          "441-8063",
          "441-8121",
          "441-8012",
          "440-0806",
          "440-0895",
          "441-8013",
          "441-8014",
          "441-8018",
          "440-0075",
          "441-8024",
          "441-8019",
          "441-8032",
          "441-8026",
          "441-8029",
          "441-8025",
          "441-8117",
          "441-3111",
          "441-3212",
          "440-0033",
          "441-8131",
          "440-0012",
          "440-0886",
          "440-0855",
          "441-8062",
          "440-0812",
          "441-8115",
          "441-3201",
          "441-8036",
          "441-3112",
          "440-0874",
          "440-0843",
          "441-1113",
          "441-8083",
          "441-0151",
          "440-0038",
          "440-0035",
          "440-0037",
          "440-0881",
          "441-8046",
          "441-8005",
          "441-8061",
          "441-8114",
          "441-8135",
          "441-3126",
          "441-3153",
          "441-3154",
          "441-3152",
          "441-3151",
          "441-3155",
          "440-0893",
          "441-8072",
          "440-0813",
          "440-0072",
          "441-3125",
          "441-3115",
          "441-3113",
          "441-0152",
          "440-0814",
          "440-0872",
          "440-0851",
          "440-0055",
          "441-8112",
          "441-8108",
          "441-8143",
          "440-0897",
          "441-8034",
          "441-8007",
          "440-0069",
          "441-8008",
          "441-3114",
          "440-0005",
          "440-0073",
          "440-0056",
          "440-0014",
          "441-8132",
          "440-0823",
          "441-8044",
          "441-8107",
          "440-0077",
          "440-0877",
          "440-0838",
          "440-0837",
          "440-0044",
          "440-0862",
          "440-0865",
          "440-0863",
          "440-0861",
          "440-0864",
          "441-8142",
          "441-8088",
          "441-8089",
          "441-8090",
          "441-8091",
          "441-8092",
          "441-8093",
          "441-8087",
          "441-1114",
          "441-8041",
          "441-8023",
          "441-8102",
          "441-8104",
          "441-8103",
          "441-8101",
          "440-0854",
          "441-8106",
          "441-8035",
          "440-0093",
          "441-8002",
          "441-8004",
          "441-8123",
          "444-0000",
          "444-0913",
          "444-2131",
          "444-0241",
          "444-0025",
          "444-0022",
          "444-3603",
          "444-3162",
          "444-3617",
          "444-0234",
          "444-0078",
          "444-0075",
          "444-3501",
          "444-3434",
          "444-0079",
          "444-3447",
          "444-3601",
          "444-3171",
          "444-0053",
          "444-0069",
          "444-0912",
          "444-0068",
          "444-0076",
          "444-0077",
          "444-3521",
          "444-0203",
          "444-0071",
          "444-2132",
          "444-2133",
          "444-2144",
          "444-3344",
          "444-3165",
          "444-0823",
          "444-0824",
          "444-0058",
          "444-0906",
          "444-0905",
          "444-0950",
          "444-0949",
          "444-0031",
          "444-0843",
          "444-2107",
          "444-3334",
          "444-0003",
          "444-3166",
          "444-3604",
          "444-3445",
          "444-0811",
          "444-0812",
          "444-3502",
          "444-0007",
          "444-3161",
          "444-0871",
          "444-0005",
          "444-3436",
          "444-2108",
          "444-2142",
          "444-0009",
          "444-3623",
          "444-0065",
          "444-0011",
          "444-0041",
          "444-3443",
          "444-3622",
          "444-3616",
          "444-0243",
          "444-0936",
          "444-2136",
          "444-3504",
          "444-0246",
          "444-0861",
          "444-0858",
          "444-0859",
          "444-0201",
          "444-0049",
          "444-2122",
          "444-2123",
          "444-2121",
          "444-0043",
          "444-2101",
          "444-2118",
          "444-3433",
          "444-0951",
          "444-0944",
          "444-0033",
          "444-3332",
          "444-3431",
          "444-0851",
          "444-0214",
          "444-3164",
          "444-0941",
          "444-3515",
          "444-2141",
          "444-3437",
          "444-0052",
          "444-0045",
          "444-0059",
          "444-0044",
          "444-0002",
          "444-2116",
          "444-0907",
          "444-3331",
          "444-2104",
          "444-3163",
          "444-3342",
          "444-0245",
          "444-0057",
          "444-0012",
          "444-0213",
          "444-3626",
          "444-3435",
          "444-0216",
          "444-0937",
          "444-0036",
          "444-0244",
          "444-0935",
          "444-3625",
          "444-0247",
          "444-0212",
          "444-0034",
          "444-0821",
          "444-0221",
          "444-0835",
          "444-0064",
          "444-0938",
          "444-0855",
          "444-3175",
          "444-3176",
          "444-3174",
          "444-2106",
          "444-0914",
          "444-0035",
          "444-3341",
          "444-3432",
          "444-3448",
          "444-2134",
          "444-2135",
          "444-0231",
          "444-3613",
          "444-3173",
          "444-3172",
          "444-0877",
          "444-0870",
          "444-0872",
          "444-0873",
          "444-0879",
          "444-0878",
          "444-0875",
          "444-0874",
          "444-0876",
          "444-0054",
          "444-2105",
          "444-0931",
          "444-3335",
          "444-0932",
          "444-0844",
          "444-0038",
          "444-0204",
          "444-2115",
          "444-2117",
          "444-3503",
          "444-2114",
          "444-0849",
          "444-0842",
          "444-0840",
          "444-0841",
          "444-0946",
          "444-3614",
          "444-3441",
          "444-3446",
          "444-3449",
          "444-0921",
          "444-3605",
          "444-0226",
          "444-0224",
          "444-0225",
          "444-0223",
          "444-0942",
          "444-0836",
          "444-0242",
          "444-0015",
          "444-0215",
          "444-3621",
          "444-0939",
          "444-0222",
          "444-2111",
          "444-0055",
          "444-0904",
          "444-0067",
          "444-2147",
          "444-0024",
          "444-0947",
          "444-0948",
          "444-2148",
          "444-0013",
          "444-0232",
          "444-0211",
          "444-0061",
          "444-0073",
          "444-3514",
          "444-3151",
          "444-0001",
          "444-0908",
          "444-0909",
          "444-0837",
          "444-0833",
          "444-0834",
          "444-3343",
          "444-0047",
          "444-3512",
          "444-0922",
          "444-0924",
          "444-0923",
          "444-0832",
          "444-0838",
          "444-0839",
          "444-0831",
          "444-0813",
          "444-0814",
          "444-0816",
          "444-0815",
          "444-0828",
          "444-0827",
          "444-2102",
          "444-2112",
          "444-0903",
          "444-3602",
          "444-2145",
          "444-2146",
          "444-0074",
          "444-0945",
          "444-0934",
          "444-0863",
          "444-0917",
          "444-0915",
          "444-0911",
          "444-0918",
          "444-0916",
          "444-0066",
          "444-0862",
          "444-0825",
          "444-0233",
          "444-0056",
          "444-3527",
          "444-3522",
          "444-3523",
          "444-0817",
          "444-0902",
          "444-0021",
          "444-2149",
          "444-3615",
          "444-3442",
          "444-0206",
          "444-0004",
          "444-0008",
          "444-0051",
          "444-3511",
          "444-3624",
          "444-0205",
          "444-2113",
          "444-0062",
          "444-0006",
          "444-0801",
          "444-0807",
          "444-0802",
          "444-0803",
          "444-0804",
          "444-0805",
          "444-0039",
          "444-0853",
          "444-0806",
          "444-3444",
          "444-0852",
          "444-3526",
          "444-3525",
          "444-2109",
          "444-3611",
          "444-0202",
          "444-3612",
          "444-0869",
          "444-0866",
          "444-0867",
          "444-0868",
          "444-0864",
          "444-0865",
          "444-0860",
          "444-0848",
          "444-0856",
          "444-0846",
          "444-0847",
          "444-0854",
          "444-0845",
          "444-0857",
          "444-0016",
          "444-3508",
          "444-3507",
          "444-3505",
          "444-3506",
          "444-0063",
          "444-0901",
          "444-0032",
          "444-3168",
          "444-2143",
          "444-0943",
          "444-2137",
          "444-3516",
          "444-3513",
          "444-0037",
          "444-3167",
          "444-3333",
          "444-3524",
          "444-0023",
          "444-0046",
          "444-0042",
          "444-0072",
          "444-0048",
          "444-0826",
          "444-0822",
          "444-0014",
          "444-0933",
          "444-2103",
          "491-0000",
          "491-0882",
          "491-0023",
          "491-0871",
          "491-0028",
          "491-0114",
          "491-0143",
          "491-0105",
          "491-0101",
          "491-0102",
          "491-0141",
          "491-0142",
          "491-0111",
          "491-0104",
          "491-0144",
          "491-0112",
          "491-0113",
          "491-0115",
          "491-0103",
          "491-0835",
          "491-0902",
          "491-0855",
          "491-0861",
          "491-0059",
          "491-0061",
          "491-0058",
          "491-0051",
          "491-0052",
          "491-0053",
          "491-0057",
          "491-0865",
          "491-0846",
          "491-0015",
          "491-0851",
          "491-0132",
          "491-0035",
          "491-0044",
          "491-0201",
          "491-0068",
          "494-0006",
          "491-0045",
          "491-0082",
          "494-0001",
          "494-0002",
          "494-0014",
          "491-0904",
          "491-0933",
          "491-0853",
          "491-0916",
          "491-0031",
          "491-0055",
          "493-0006",
          "493-0002",
          "493-0001",
          "493-0005",
          "493-0007",
          "493-0004",
          "493-0003",
          "494-0004",
          "491-0901",
          "491-0013",
          "493-8001",
          "493-8002",
          "493-8003",
          "491-0069",
          "491-0854",
          "491-0037",
          "491-0076",
          "491-0079",
          "491-0012",
          "491-0842",
          "491-0135",
          "491-0867",
          "491-0084",
          "494-0007",
          "491-0858",
          "491-0036",
          "491-0131",
          "491-0124",
          "491-0134",
          "491-0838",
          "494-0003",
          "491-0066",
          "491-0834",
          "491-0121",
          "491-0122",
          "491-0845",
          "491-0883",
          "491-0032",
          "491-0003",
          "491-0063",
          "491-0004",
          "491-0917",
          "491-0866",
          "491-0879",
          "491-0912",
          "491-0918",
          "491-0136",
          "491-0919",
          "491-0001",
          "491-0873",
          "491-0852",
          "491-0054",
          "491-0837",
          "491-0125",
          "491-0073",
          "491-0937",
          "491-0086",
          "491-0133",
          "494-0013",
          "491-0823",
          "491-0824",
          "491-0821",
          "491-0836",
          "491-0825",
          "491-0826",
          "491-0827",
          "491-0816",
          "491-0805",
          "491-0806",
          "491-0814",
          "491-0802",
          "491-0811",
          "491-0801",
          "491-0804",
          "491-0815",
          "491-0812",
          "491-0817",
          "491-0803",
          "491-0813",
          "491-0075",
          "491-0936",
          "491-0046",
          "491-0828",
          "491-0002",
          "491-0848",
          "494-0018",
          "491-0123",
          "491-0072",
          "491-0913",
          "491-0071",
          "494-0005",
          "491-0005",
          "491-0081",
          "491-0062",
          "491-0907",
          "494-0015",
          "494-0011",
          "491-0938",
          "491-0083",
          "491-0911",
          "491-0354",
          "491-0366",
          "491-0376",
          "491-0371",
          "491-0373",
          "491-0372",
          "491-0374",
          "491-0375",
          "491-0352",
          "491-0364",
          "491-0365",
          "491-0363",
          "491-0362",
          "491-0353",
          "491-0351",
          "491-0361",
          "491-0025",
          "494-0019",
          "491-0903",
          "491-0844",
          "491-0914",
          "491-0034",
          "494-0008",
          "491-0863",
          "494-0016",
          "491-0074",
          "491-0056",
          "491-0021",
          "491-0833",
          "491-0908",
          "491-0024",
          "491-0027",
          "491-0041",
          "491-0872",
          "491-0905",
          "491-0033",
          "491-0067",
          "491-0859",
          "491-0856",
          "491-0043",
          "491-0841",
          "491-0042",
          "491-0078",
          "491-0085",
          "491-0874",
          "491-0065",
          "491-0878",
          "491-0862",
          "491-0881",
          "491-0014",
          "491-0906",
          "491-0915",
          "491-0064",
          "491-0921",
          "491-0869",
          "491-0868",
          "491-0857",
          "494-0012",
          "491-0831",
          "491-0843",
          "491-0923",
          "491-0924",
          "491-0934",
          "491-0927",
          "491-0935",
          "491-0931",
          "491-0925",
          "491-0926",
          "491-0847",
          "491-0922",
          "491-0932",
          "494-0017",
          "491-0011",
          "491-0022",
          "491-0832",
          "491-0077",
          "491-0026",
          "489-0000",
          "489-0878",
          "489-0071",
          "489-0022",
          "489-0898",
          "489-0043",
          "489-0847",
          "489-0801",
          "489-0003",
          "489-0952",
          "489-0951",
          "489-0073",
          "489-0922",
          "489-0817",
          "489-0836",
          "489-0976",
          "489-0802",
          "489-0868",
          "480-1217",
          "480-1215",
          "489-0964",
          "489-0902",
          "489-0021",
          "489-0826",
          "489-0803",
          "489-0832",
          "489-0867",
          "489-0962",
          "489-0064",
          "489-0067",
          "480-1205",
          "489-0855",
          "489-0966",
          "480-1212",
          "489-0845",
          "489-0007",
          "489-0048",
          "480-1219",
          "489-0023",
          "489-0933",
          "480-1214",
          "489-0063",
          "489-0892",
          "480-1211",
          "489-0061",
          "489-0068",
          "489-0062",
          "489-0853",
          "489-0894",
          "489-0927",
          "489-0926",
          "489-0919",
          "489-0001",
          "489-0908",
          "489-0915",
          "480-1204",
          "489-0014",
          "489-0911",
          "489-0910",
          "489-0984",
          "489-0918",
          "489-0809",
          "489-0804",
          "489-0881",
          "489-0813",
          "489-0031",
          "489-0917",
          "489-0978",
          "489-0032",
          "489-0842",
          "489-0879",
          "489-0974",
          "489-0035",
          "489-0818",
          "489-0977",
          "489-0044",
          "489-0982",
          "489-0895",
          "489-0901",
          "480-1207",
          "489-0051",
          "480-1202",
          "480-1201",
          "480-1213",
          "489-0017",
          "489-0924",
          "489-0923",
          "489-0873",
          "489-0949",
          "489-0058",
          "489-0075",
          "489-0849",
          "489-0913",
          "489-0009",
          "489-0814",
          "489-0822",
          "489-0033",
          "489-0904",
          "489-0863",
          "489-0041",
          "489-0941",
          "489-0843",
          "489-0008",
          "489-0825",
          "489-0846",
          "489-0954",
          "489-0931",
          "489-0896",
          "489-0055",
          "489-0025",
          "489-0961",
          "489-0921",
          "489-0838",
          "489-0891",
          "489-0805",
          "489-0823",
          "489-0831",
          "489-0827",
          "489-0054",
          "489-0045",
          "489-0026",
          "480-1216",
          "489-0983",
          "489-0042",
          "489-0824",
          "480-1218",
          "489-0013",
          "489-0029",
          "489-0833",
          "489-0005",
          "489-0835",
          "489-0884",
          "489-0079",
          "489-0065",
          "489-0028",
          "489-0812",
          "489-0036",
          "489-0943",
          "489-0829",
          "489-0882",
          "489-0018",
          "489-0047",
          "489-0925",
          "489-0057",
          "489-0929",
          "489-0848",
          "489-0972",
          "489-0971",
          "489-0819",
          "489-0837",
          "489-0912",
          "489-0851",
          "489-0987",
          "489-0807",
          "489-0936",
          "489-0885",
          "489-0905",
          "489-0886",
          "489-0876",
          "489-0852",
          "489-0012",
          "489-0946",
          "489-0938",
          "489-0874",
          "489-0948",
          "489-0024",
          "489-0861",
          "489-0862",
          "489-0034",
          "489-0947",
          "489-0888",
          "489-0889",
          "489-0011",
          "489-0893",
          "489-0877",
          "489-0897",
          "489-0072",
          "489-0037",
          "489-0944",
          "489-0883",
          "489-0015",
          "489-0928",
          "489-0056",
          "489-0871",
          "489-0027",
          "489-0942",
          "489-0973",
          "489-0816",
          "489-0841",
          "489-0069",
          "489-0053",
          "489-0854",
          "489-0988",
          "489-0066",
          "489-0806",
          "489-0887",
          "489-0934",
          "489-0004",
          "489-0981",
          "489-0916",
          "489-0856",
          "480-1203",
          "489-0076",
          "489-0935",
          "489-0907",
          "489-0945",
          "489-0979",
          "489-0906",
          "489-0828",
          "489-0914",
          "489-0985",
          "489-0006",
          "489-0909",
          "489-0808",
          "489-0875",
          "489-0872",
          "489-0834",
          "489-0955",
          "489-0016",
          "489-0815",
          "489-0937",
          "489-0965",
          "489-0986",
          "489-0932",
          "489-0077",
          "489-0963",
          "489-0074",
          "489-0046",
          "489-0844",
          "489-0866",
          "489-0821",
          "489-0052",
          "480-1206",
          "489-0858",
          "489-0953",
          "489-0865",
          "489-0859",
          "489-0980",
          "489-0989",
          "489-0975",
          "489-0811",
          "489-0078",
          "489-0903",
          "489-0857",
          "489-0002",
          "489-0864",
          "475-0000",
          "475-0836",
          "475-0838",
          "475-0039",
          "475-0881",
          "475-0017",
          "475-0031",
          "475-0062",
          "475-0945",
          "475-0001",
          "475-0858",
          "475-0936",
          "475-0061",
          "475-0014",
          "475-0011",
          "475-0835",
          "475-0958",
          "475-0952",
          "475-0915",
          "475-0867",
          "475-0087",
          "475-0015",
          "475-0904",
          "475-0071",
          "475-0083",
          "475-0935",
          "475-0957",
          "475-0056",
          "475-0046",
          "475-0053",
          "475-0041",
          "475-0047",
          "475-0066",
          "475-0051",
          "475-0057",
          "475-0803",
          "475-0052",
          "475-0045",
          "475-0068",
          "475-0067",
          "475-0044",
          "475-0043",
          "475-0048",
          "475-0065",
          "475-0042",
          "475-0064",
          "475-0058",
          "475-0063",
          "475-0054",
          "475-0967",
          "475-0923",
          "475-0953",
          "475-0004",
          "475-0944",
          "475-0009",
          "475-0804",
          "475-0028",
          "475-0025",
          "475-0027",
          "475-0026",
          "475-0024",
          "475-0022",
          "475-0029",
          "475-0023",
          "475-0932",
          "475-0918",
          "475-0832",
          "475-0808",
          "475-0937",
          "475-0877",
          "475-0008",
          "475-0852",
          "475-0972",
          "475-0055",
          "475-0927",
          "475-0977",
          "475-0938",
          "475-0955",
          "475-0854",
          "475-0928",
          "475-0874",
          "475-0976",
          "475-0816",
          "475-0086",
          "475-0856",
          "475-0842",
          "475-0085",
          "475-0806",
          "475-0814",
          "475-0846",
          "475-0934",
          "475-0032",
          "475-0072",
          "475-0872",
          "475-0869",
          "475-0865",
          "475-0866",
          "475-0922",
          "475-0078",
          "475-0886",
          "475-0931",
          "475-0815",
          "475-0965",
          "475-0824",
          "475-0826",
          "475-0831",
          "475-0954",
          "475-0947",
          "475-0021",
          "475-0862",
          "475-0917",
          "475-0801",
          "475-0036",
          "475-0943",
          "475-0948",
          "475-0968",
          "475-0903",
          "475-0844",
          "475-0921",
          "475-0859",
          "475-0914",
          "475-0924",
          "475-0817",
          "475-0075",
          "475-0037",
          "475-0035",
          "475-0843",
          "475-0929",
          "475-0018",
          "475-0855",
          "475-0873",
          "475-0074",
          "475-0941",
          "475-0845",
          "475-0848",
          "475-0933",
          "475-0007",
          "475-0802",
          "475-0868",
          "475-0016",
          "475-0884",
          "475-0033",
          "475-0038",
          "475-0019",
          "475-0912",
          "475-0077",
          "475-0847",
          "475-0807",
          "475-0833",
          "475-0088",
          "475-0805",
          "475-0822",
          "475-0916",
          "475-0003",
          "475-0034",
          "475-0861",
          "475-0876",
          "475-0012",
          "475-0813",
          "475-0878",
          "475-0975",
          "475-0819",
          "475-0964",
          "475-0081",
          "475-0013",
          "475-0857",
          "475-0971",
          "475-0978",
          "475-0834",
          "475-0821",
          "475-0963",
          "475-0951",
          "475-0911",
          "475-0851",
          "475-0871",
          "475-0825",
          "475-0863",
          "475-0864",
          "475-0082",
          "475-0942",
          "475-0828",
          "475-0956",
          "475-0002",
          "475-0827",
          "475-0823",
          "475-0006",
          "475-0853",
          "475-0926",
          "475-0882",
          "475-0073",
          "475-0902",
          "475-0925",
          "475-0887",
          "475-0883",
          "475-0084",
          "475-0959",
          "475-0962",
          "475-0961",
          "475-0905",
          "475-0966",
          "475-0901",
          "475-0906",
          "475-0875",
          "475-0974",
          "475-0841",
          "475-0885",
          "475-0837",
          "475-0005",
          "475-0076",
          "475-0946",
          "475-0973",
          "475-0939",
          "486-0000",
          "486-0933",
          "480-0303",
          "486-0929",
          "486-0846",
          "486-0857",
          "486-0965",
          "486-0967",
          "486-0969",
          "486-0968",
          "486-0853",
          "487-0006",
          "486-0905",
          "486-0921",
          "487-0033",
          "486-0805",
          "480-0306",
          "486-0901",
          "480-0301",
          "486-0856",
          "486-0834",
          "486-0806",
          "486-0807",
          "487-0024",
          "486-0827",
          "487-0005",
          "486-0832",
          "486-0926",
          "480-0304",
          "486-0927",
          "486-0913",
          "486-0961",
          "486-0963",
          "486-0941",
          "486-0945",
          "486-0946",
          "486-0813",
          "486-0801",
          "486-0966",
          "486-0858",
          "486-0814",
          "487-0003",
          "487-0014",
          "487-0015",
          "486-0826",
          "486-0822",
          "486-0820",
          "486-0907",
          "486-0923",
          "487-0013",
          "487-0016",
          "486-0831",
          "480-0302",
          "480-0305",
          "486-0823",
          "486-0851",
          "486-0922",
          "486-0852",
          "486-0924",
          "486-0819",
          "486-0906",
          "486-0815",
          "486-0833",
          "487-0022",
          "487-0034",
          "486-0902",
          "486-0942",
          "486-0821",
          "486-0830",
          "486-0855",
          "486-0949",
          "486-0964",
          "486-0812",
          "486-0804",
          "487-0017",
          "487-0012",
          "487-0032",
          "486-0912",
          "487-0007",
          "487-0004",
          "486-0808",
          "486-0947",
          "487-0011",
          "486-0825",
          "486-0936",
          "486-0952",
          "486-0835",
          "486-0943",
          "487-0025",
          "486-0948",
          "487-0002",
          "486-0844",
          "486-0925",
          "486-0956",
          "486-0957",
          "486-0962",
          "486-0934",
          "486-0911",
          "486-0958",
          "486-0908",
          "486-0803",
          "486-0918",
          "487-0031",
          "486-0915",
          "486-0916",
          "486-0849",
          "486-0951",
          "486-0854",
          "486-0837",
          "487-0021",
          "486-0816",
          "486-0817",
          "486-0818",
          "486-0811",
          "487-0023",
          "487-0026",
          "487-0035",
          "486-0955",
          "486-0937",
          "487-0001",
          "486-0829",
          "486-0828",
          "486-0903",
          "486-0809",
          "486-0932",
          "486-0931",
          "487-0027",
          "486-0845",
          "486-0841",
          "486-0954",
          "486-0917",
          "486-0904",
          "486-0953",
          "486-0928",
          "486-0802",
          "486-0935",
          "486-0836",
          "486-0944",
          "486-0838",
          "486-0909",
          "486-0842",
          "486-0839",
          "486-0914",
          "486-0824",
          "442-0000",
          "441-0204",
          "441-0202",
          "442-0054",
          "442-0887",
          "442-0015",
          "442-0041",
          "441-1203",
          "442-0802",
          "442-0862",
          "441-1231",
          "441-0105",
          "442-0023",
          "442-0814",
          "442-0801",
          "442-0886",
          "442-0826",
          "442-0045",
          "441-1211",
          "441-1207",
          "441-1205",
          "442-0007",
          "442-0809",
          "442-0013",
          "442-0844",
          "442-0048",
          "441-1212",
          "442-0872",
          "442-0053",
          "442-0067",
          "442-0055",
          "442-0052",
          "442-0066",
          "441-1202",
          "442-0837",
          "442-0042",
          "442-0822",
          "442-0856",
          "442-0882",
          "442-0828",
          "442-0854",
          "442-0852",
          "442-0884",
          "442-0038",
          "441-0103",
          "442-0021",
          "442-0832",
          "441-0213",
          "441-0212",
          "441-0214",
          "441-0215",
          "441-0211",
          "442-0861",
          "442-0046",
          "442-0836",
          "442-0064",
          "442-0027",
          "442-0843",
          "442-0017",
          "442-0875",
          "442-0006",
          "441-1206",
          "441-0102",
          "442-0824",
          "442-0877",
          "441-0101",
          "442-0018",
          "442-0847",
          "442-0848",
          "442-0853",
          "442-0855",
          "442-0835",
          "442-0043",
          "442-0878",
          "442-0012",
          "442-0029",
          "442-0819",
          "442-0068",
          "442-0069",
          "442-0815",
          "442-0842",
          "442-0841",
          "442-0883",
          "442-0845",
          "442-0004",
          "442-0001",
          "442-0888",
          "442-0051",
          "442-0818",
          "442-0876",
          "442-0039",
          "442-0022",
          "442-0821",
          "441-1201",
          "442-0026",
          "442-0881",
          "442-0019",
          "442-0813",
          "442-0036",
          "442-0032",
          "442-0031",
          "442-0035",
          "442-0033",
          "441-1222",
          "442-0003",
          "441-0203",
          "442-0885",
          "442-0833",
          "442-0834",
          "442-0063",
          "442-0827",
          "442-0838",
          "441-1204",
          "442-0034",
          "442-0024",
          "442-0851",
          "441-0201",
          "442-0879",
          "441-1223",
          "442-0816",
          "442-0811",
          "442-0011",
          "442-0028",
          "442-0025",
          "441-0104",
          "442-0863",
          "442-0804",
          "442-0044",
          "442-0817",
          "442-0014",
          "442-0061",
          "442-0005",
          "442-0062",
          "442-0806",
          "442-0823",
          "442-0871",
          "441-1221",
          "442-0874",
          "442-0812",
          "441-0106",
          "441-0316",
          "441-0315",
          "441-0311",
          "441-0323",
          "441-0301",
          "441-0304",
          "441-0302",
          "441-0303",
          "441-0322",
          "441-0313",
          "441-0312",
          "441-0321",
          "441-0314",
          "442-0049",
          "442-0889",
          "442-0008",
          "442-0805",
          "442-0016",
          "442-0825",
          "442-0803",
          "442-0846",
          "442-0037",
          "442-0807",
          "442-0873",
          "442-0831",
          "442-0857",
          "442-0808",
          "442-0839",
          "442-0002",
          "442-0065",
          "442-0047",
          "496-0000",
          "496-0001",
          "496-0036",
          "496-0842",
          "496-0828",
          "496-0806",
          "496-0873",
          "496-0803",
          "496-0033",
          "496-0018",
          "496-0008",
          "496-0031",
          "496-0827",
          "496-0845",
          "496-0867",
          "496-0855",
          "496-0874",
          "496-0854",
          "496-0012",
          "496-0876",
          "496-0813",
          "496-0826",
          "496-0824",
          "496-0014",
          "496-0812",
          "496-0023",
          "496-0823",
          "496-0871",
          "496-0863",
          "496-0005",
          "496-0026",
          "496-0877",
          "496-0869",
          "496-0013",
          "496-0861",
          "496-0817",
          "496-0811",
          "496-0007",
          "496-0015",
          "496-0022",
          "496-0829",
          "496-0815",
          "496-0816",
          "496-0868",
          "496-0029",
          "496-0875",
          "496-0809",
          "496-0016",
          "496-0821",
          "496-0862",
          "496-0027",
          "496-0071",
          "496-0851",
          "496-0006",
          "496-0848",
          "496-0837",
          "496-0041",
          "496-0822",
          "496-0808",
          "496-0038",
          "496-0044",
          "496-0021",
          "496-0003",
          "496-0042",
          "496-0807",
          "496-0832",
          "496-0833",
          "496-0025",
          "496-0847",
          "496-0836",
          "496-0864",
          "496-0037",
          "496-0802",
          "496-0849",
          "496-0047",
          "496-0028",
          "496-0852",
          "496-0009",
          "496-0825",
          "496-0865",
          "496-0024",
          "496-0011",
          "496-0035",
          "496-0846",
          "496-0045",
          "496-0017",
          "496-0004",
          "496-0032",
          "496-0839",
          "496-0048",
          "496-0801",
          "496-0843",
          "496-0043",
          "496-0805",
          "496-0002",
          "496-0819",
          "496-0872",
          "496-0818",
          "496-0831",
          "496-0835",
          "496-0072",
          "496-0834",
          "496-0857",
          "496-0853",
          "496-0838",
          "496-0034",
          "496-0019",
          "496-0844",
          "496-0046",
          "496-0866",
          "496-0804",
          "496-0841",
          "496-0814",
          "496-0856",
          "447-0000",
          "447-0862",
          "447-0866",
          "447-0022",
          "447-0865",
          "447-0083",
          "447-0813",
          "447-0068",
          "447-0038",
          "447-0002",
          "447-0023",
          "447-0858",
          "447-0837",
          "447-0821",
          "447-0831",
          "447-0047",
          "447-0825",
          "447-0008",
          "447-0012",
          "447-0025",
          "447-0857",
          "447-0017",
          "447-0014",
          "447-0036",
          "447-0847",
          "447-0045",
          "447-0888",
          "447-0881",
          "447-0085",
          "447-0028",
          "447-0074",
          "447-0024",
          "447-0822",
          "447-0823",
          "447-0817",
          "447-0016",
          "447-0003",
          "447-0032",
          "447-0001",
          "447-0065",
          "447-0873",
          "447-0872",
          "447-0886",
          "447-0034",
          "447-0824",
          "447-0871",
          "447-0082",
          "447-0809",
          "447-0833",
          "447-0838",
          "447-0043",
          "447-0877",
          "447-0087",
          "447-0874",
          "447-0053",
          "447-0879",
          "447-0803",
          "447-0806",
          "447-0061",
          "447-0887",
          "447-0841",
          "447-0828",
          "447-0816",
          "447-0885",
          "447-0078",
          "447-0072",
          "447-0883",
          "447-0027",
          "447-0013",
          "447-0076",
          "447-0037",
          "447-0863",
          "447-0052",
          "447-0044",
          "447-0086",
          "447-0854",
          "447-0058",
          "447-0056",
          "447-0875",
          "447-0006",
          "447-0007",
          "447-0867",
          "447-0075",
          "447-0815",
          "447-0834",
          "447-0849",
          "447-0057",
          "447-0033",
          "447-0855",
          "447-0864",
          "447-0073",
          "447-0812",
          "447-0042",
          "447-0829",
          "447-0846",
          "447-0859",
          "447-0035",
          "447-0021",
          "447-0848",
          "447-0843",
          "447-0064",
          "447-0882",
          "447-0029",
          "447-0801",
          "447-0876",
          "447-0851",
          "447-0055",
          "447-0842",
          "447-0845",
          "447-0853",
          "447-0015",
          "447-0889",
          "447-0051",
          "447-0011",
          "447-0067",
          "447-0081",
          "447-0048",
          "447-0807",
          "447-0088",
          "447-0811",
          "447-0054",
          "447-0062",
          "447-0884",
          "447-0084",
          "447-0046",
          "447-0852",
          "447-0827",
          "447-0868",
          "447-0079",
          "447-0878",
          "447-0066",
          "447-0031",
          "447-0832",
          "447-0041",
          "447-0844",
          "447-0026",
          "447-0856",
          "447-0835",
          "447-0071",
          "447-0077",
          "447-0805",
          "447-0869",
          "447-0063",
          "447-0814",
          "447-0004",
          "447-0826",
          "447-0804",
          "447-0861",
          "447-0836",
          "447-0005",
          "447-0818",
          "447-0808",
          "447-0802",
          "448-0000",
          "448-0027",
          "448-0838",
          "448-0014",
          "448-0032",
          "448-0814",
          "448-0001",
          "448-0044",
          "448-0022",
          "448-0004",
          "448-0801",
          "448-0041",
          "448-0002",
          "448-0038",
          "448-0008",
          "448-0005",
          "448-0857",
          "448-0813",
          "448-0808",
          "448-0043",
          "448-0013",
          "448-0012",
          "448-0851",
          "448-0845",
          "448-0831",
          "448-0856",
          "448-0837",
          "448-0025",
          "448-0028",
          "448-0023",
          "448-0024",
          "448-0806",
          "448-0029",
          "448-0833",
          "448-0843",
          "448-0015",
          "448-0045",
          "448-0034",
          "448-0802",
          "448-0852",
          "448-0855",
          "448-0037",
          "448-0812",
          "448-0047",
          "448-0853",
          "448-0847",
          "448-0811",
          "448-0011",
          "448-0834",
          "448-0846",
          "448-0824",
          "448-0031",
          "448-0842",
          "448-0848",
          "448-0823",
          "448-0815",
          "448-0049",
          "448-0026",
          "448-0006",
          "448-0862",
          "448-0803",
          "448-0861",
          "448-0804",
          "448-0805",
          "448-0816",
          "448-0021",
          "448-0832",
          "448-0836",
          "448-0039",
          "448-0810",
          "448-0807",
          "448-0007",
          "448-0046",
          "448-0003",
          "448-0844",
          "448-0042",
          "448-0854",
          "448-0822",
          "448-0033",
          "448-0048",
          "448-0835",
          "448-0809",
          "448-0841",
          "448-0821",
          "448-0825",
          "448-0035",
          "448-0036",
          "448-0858",
          "471-0000",
          "471-0052",
          "470-0335",
          "471-0873",
          "471-0835",
          "444-2832",
          "471-0858",
          "471-0031",
          "444-2843",
          "444-2423",
          "444-2817",
          "444-2601",
          "444-2513",
          "444-2424",
          "444-3202",
          "444-2418",
          "470-0333",
          "444-3216",
          "444-2827",
          "444-2807",
          "444-2824",
          "471-0001",
          "473-0928",
          "444-2837",
          "470-0471",
          "470-0463",
          "470-0329",
          "471-0803",
          "471-0006",
          "444-2825",
          "470-0574",
          "471-0814",
          "441-2513",
          "470-0372",
          "444-2354",
          "470-0374",
          "471-0823",
          "444-2225",
          "470-0515",
          "471-0003",
          "444-2331",
          "471-0015",
          "444-2204",
          "444-2801",
          "444-2416",
          "470-1211",
          "470-1219",
          "444-2604",
          "471-0064",
          "444-2406",
          "444-3203",
          "471-0866",
          "470-0341",
          "471-0067",
          "470-0562",
          "470-1206",
          "470-1205",
          "444-2206",
          "471-0058",
          "444-2501",
          "470-0401",
          "444-2217",
          "470-0511",
          "444-2525",
          "444-2511",
          "444-3207",
          "470-0532",
          "473-0935",
          "470-0342",
          "444-2405",
          "470-0555",
          "444-2603",
          "444-2811",
          "444-2515",
          "444-2822",
          "444-3242",
          "441-2511",
          "470-0355",
          "473-0902",
          "470-0553",
          "471-0815",
          "470-0552",
          "471-0857",
          "444-2812",
          "470-1207",
          "470-0303",
          "441-2516",
          "441-2525",
          "444-2809",
          "471-0072",
          "444-2846",
          "470-0346",
          "470-0347",
          "444-2844",
          "470-0572",
          "470-0502",
          "470-0501",
          "470-0531",
          "470-0464",
          "470-0323",
          "444-2334",
          "470-0348",
          "471-0855",
          "444-2352",
          "444-2813",
          "470-0505",
          "470-0533",
          "470-1216",
          "444-2214",
          "471-0876",
          "470-0364",
          "444-3223",
          "471-0804",
          "473-0931",
          "470-0421",
          "444-2836",
          "444-2531",
          "470-1218",
          "444-2314",
          "444-2337",
          "470-0322",
          "470-0462",
          "444-2835",
          "470-0561",
          "444-2335",
          "470-0375",
          "444-2213",
          "470-0513",
          "471-0824",
          "444-2403",
          "470-0575",
          "471-0073",
          "441-2517",
          "471-0074",
          "471-0868",
          "444-3252",
          "470-0328",
          "470-0542",
          "470-0411",
          "470-0453",
          "470-0573",
          "444-2502",
          "470-0543",
          "471-0027",
          "471-0005",
          "471-0063",
          "444-2343",
          "444-2216",
          "444-2804",
          "470-0305",
          "444-2326",
          "471-0076",
          "470-0522",
          "444-3212",
          "441-2524",
          "444-2407",
          "444-2325",
          "441-2521",
          "444-2221",
          "471-0836",
          "471-0035",
          "471-0034",
          "470-0332",
          "441-2523",
          "471-0801",
          "444-2821",
          "444-2608",
          "444-2521",
          "444-2533",
          "471-0816",
          "471-0834",
          "444-2805",
          "473-0926",
          "444-3213",
          "473-0925",
          "470-0306",
          "471-0856",
          "471-0023",
          "470-1203",
          "444-2201",
          "471-0066",
          "444-2814",
          "471-0029",
          "444-2826",
          "470-0352",
          "444-2226",
          "470-0504",
          "470-0361",
          "470-0564",
          "444-2311",
          "470-0402",
          "471-0037",
          "444-2839",
          "444-2516",
          "471-0041",
          "471-0802",
          "470-0373",
          "444-2841",
          "470-0308",
          "471-0808",
          "444-2834",
          "471-0843",
          "471-0875",
          "470-0422",
          "444-2833",
          "444-2321",
          "444-2336",
          "444-2332",
          "444-2838",
          "470-0565",
          "471-0878",
          "470-0319",
          "444-3222",
          "471-0851",
          "470-0343",
          "471-0078",
          "470-0403",
          "444-2327",
          "471-0022",
          "470-0313",
          "471-0837",
          "471-0079",
          "471-0044",
          "471-0028",
          "444-2505",
          "471-0822",
          "444-2816",
          "444-2409",
          "471-0862",
          "444-2831",
          "473-0905",
          "470-0534",
          "444-2524",
          "471-0844",
          "444-2207",
          "471-0016",
          "471-0847",
          "444-2606",
          "470-0506",
          "444-2806",
          "470-1217",
          "471-0057",
          "444-3221",
          "473-0921",
          "473-0933",
          "473-0922",
          "471-0013",
          "471-0048",
          "444-3208",
          "471-0019",
          "471-0069",
          "470-0376",
          "473-0918",
          "473-0908",
          "470-0324",
          "471-0077",
          "444-2212",
          "473-0906",
          "473-0913",
          "471-0846",
          "444-2402",
          "444-2802",
          "444-3262",
          "471-0845",
          "444-3265",
          "444-2353",
          "471-0049",
          "444-2605",
          "470-0423",
          "470-0354",
          "470-0545",
          "444-2355",
          "470-0318",
          "470-0316",
          "471-0879",
          "471-0831",
          "471-0033",
          "471-0842",
          "473-0932",
          "473-0939",
          "444-2414",
          "444-2526",
          "444-2419",
          "444-2803",
          "471-0059",
          "470-0327",
          "470-0544",
          "471-0017",
          "470-0325",
          "470-0326",
          "471-0054",
          "471-0817",
          "470-0512",
          "471-0045",
          "470-0535",
          "471-0008",
          "470-1202",
          "444-2847",
          "471-0867",
          "444-3264",
          "444-2514",
          "444-2324",
          "444-2302",
          "471-0869",
          "444-2510",
          "470-0304",
          "441-2526",
          "444-2224",
          "471-0826",
          "444-2203",
          "444-2215",
          "470-0312",
          "470-0315",
          "471-0021",
          "444-2517",
          "473-0927",
          "441-2514",
          "473-0923",
          "444-2504",
          "473-0904",
          "444-3201",
          "441-2515",
          "444-2211",
          "444-2205",
          "470-0317",
          "470-0554",
          "470-0404",
          "473-0936",
          "473-0937",
          "444-2532",
          "471-0877",
          "471-0047",
          "473-0903",
          "470-0521",
          "470-0431",
          "470-0541",
          "470-0309",
          "470-0526",
          "471-0025",
          "471-0062",
          "471-0032",
          "444-2404",
          "441-2512",
          "470-0314",
          "444-2303",
          "471-0812",
          "471-0813",
          "444-2342",
          "444-3205",
          "470-1204",
          "471-0056",
          "470-0452",
          "471-0861",
          "471-0051",
          "444-3231",
          "473-0924",
          "470-0334",
          "444-3206",
          "444-2218",
          "444-2313",
          "470-0524",
          "471-0071",
          "444-2344",
          "444-3261",
          "444-2413",
          "444-2301",
          "444-2528",
          "444-2512",
          "444-2823",
          "470-0307",
          "470-0345",
          "471-0014",
          "471-0055",
          "444-2506",
          "471-0075",
          "471-0011",
          "470-0514",
          "444-2607",
          "471-0065",
          "444-3251",
          "470-0331",
          "470-0523",
          "471-0827",
          "471-0807",
          "471-0036",
          "471-0864",
          "473-0912",
          "470-0351",
          "470-1215",
          "444-2333",
          "471-0841",
          "470-0441",
          "470-1214",
          "470-0451",
          "470-0302",
          "441-2522",
          "471-0009",
          "471-0004",
          "444-2401",
          "471-0821",
          "470-1201",
          "470-0311",
          "471-0809",
          "470-0461",
          "444-2503",
          "444-2222",
          "471-0853",
          "470-0353",
          "470-0344",
          "471-0046",
          "473-0938",
          "471-0848",
          "470-0363",
          "473-0911",
          "470-0362",
          "471-0874",
          "473-0934",
          "470-0503",
          "471-0828",
          "444-2808",
          "470-1212",
          "470-1213",
          "471-0865",
          "444-2223",
          "444-2202",
          "470-0571",
          "470-0301",
          "471-0053",
          "471-0832",
          "444-2845",
          "444-2815",
          "444-2411",
          "444-2522",
          "444-2523",
          "471-0805",
          "471-0863",
          "471-0012",
          "471-0811",
          "470-0551",
          "470-0424",
          "471-0838",
          "470-0371",
          "471-0038",
          "471-0042",
          "470-0516",
          "471-0819",
          "471-0043",
          "471-0849",
          "471-0852",
          "473-0901",
          "471-0007",
          "444-2417",
          "471-0818",
          "471-0825",
          "471-0024",
          "471-0854",
          "471-0871",
          "471-0806",
          "444-2451",
          "444-2351",
          "470-0356",
          "471-0018",
          "470-0525",
          "471-0002",
          "444-2415",
          "470-0321",
          "471-0833",
          "444-2412",
          "470-0563",
          "471-0068",
          "473-0916",
          "444-2842",
          "444-2312",
          "471-0872",
          "473-0907",
          "444-2602",
          "471-0061",
          "473-0914",
          "473-0917",
          "473-0915",
          "471-0026",
          "444-3211",
          "444-2527",
          "446-0000",
          "446-0037",
          "446-0046",
          "446-0031",
          "446-0026",
          "446-0074",
          "446-0066",
          "444-1201",
          "444-1221",
          "444-1225",
          "444-1222",
          "444-1223",
          "444-1224",
          "446-0071",
          "446-0008",
          "446-0005",
          "444-1214",
          "444-1215",
          "446-0017",
          "446-0042",
          "444-1162",
          "446-0004",
          "446-0003",
          "444-1152",
          "446-0024",
          "446-0011",
          "444-1163",
          "446-0036",
          "444-1154",
          "446-0041",
          "446-0073",
          "446-0001",
          "444-1206",
          "444-1204",
          "444-1203",
          "444-1202",
          "444-1205",
          "446-0023",
          "446-0043",
          "446-0063",
          "444-1166",
          "446-0061",
          "446-0019",
          "446-0038",
          "446-0072",
          "446-0065",
          "446-0015",
          "446-0053",
          "446-0007",
          "446-0018",
          "446-0027",
          "446-0035",
          "446-0012",
          "446-0075",
          "446-0054",
          "444-1211",
          "444-1212",
          "444-1165",
          "446-0002",
          "446-0039",
          "446-0022",
          "446-0006",
          "444-1213",
          "446-0013",
          "444-1153",
          "446-0033",
          "444-1161",
          "446-0044",
          "446-0052",
          "444-1164",
          "446-0025",
          "446-0014",
          "446-0064",
          "446-0021",
          "444-1155",
          "446-0056",
          "446-0057",
          "446-0059",
          "446-0058",
          "446-0076",
          "446-0055",
          "446-0034",
          "446-0051",
          "446-0032",
          "444-1151",
          "446-0062",
          "446-0016",
          "446-0045",
          "445-0000",
          "445-0863",
          "445-0861",
          "445-0824",
          "445-0055",
          "444-0427",
          "444-0422",
          "444-0412",
          "444-0401",
          "444-0423",
          "444-0402",
          "444-0421",
          "444-0424",
          "444-0413",
          "444-0415",
          "444-0416",
          "444-0426",
          "444-0411",
          "444-0405",
          "444-0406",
          "444-0428",
          "444-0404",
          "444-0414",
          "444-0425",
          "444-0407",
          "444-0403",
          "444-0429",
          "445-0807",
          "445-0806",
          "445-0822",
          "445-0063",
          "445-0043",
          "445-0854",
          "445-0031",
          "445-0026",
          "445-0024",
          "445-0022",
          "445-0831",
          "444-0333",
          "444-0332",
          "445-0006",
          "445-0027",
          "445-0893",
          "445-0825",
          "445-0013",
          "445-0044",
          "445-0823",
          "445-0882",
          "445-0017",
          "445-0011",
          "445-0894",
          "444-0313",
          "445-0847",
          "444-0321",
          "445-0873",
          "445-0832",
          "445-0857",
          "445-0885",
          "444-0523",
          "444-0517",
          "444-0531",
          "444-0524",
          "444-0512",
          "444-0511",
          "444-0521",
          "444-0534",
          "444-0535",
          "444-0537",
          "444-0522",
          "444-0514",
          "444-0532",
          "444-0503",
          "444-0533",
          "444-0525",
          "444-0515",
          "444-0504",
          "444-0536",
          "444-0526",
          "444-0501",
          "444-0513",
          "444-0502",
          "444-0516",
          "445-0864",
          "444-0325",
          "444-0312",
          "445-0071",
          "445-0035",
          "445-0021",
          "444-0322",
          "445-0005",
          "445-0041",
          "445-0056",
          "445-0827",
          "445-0835",
          "445-0853",
          "445-0803",
          "445-0053",
          "445-0866",
          "445-0084",
          "445-0081",
          "445-0883",
          "445-0016",
          "445-0012",
          "445-0891",
          "444-0314",
          "445-0045",
          "445-0834",
          "445-0065",
          "445-0878",
          "444-0311",
          "445-0076",
          "445-0077",
          "445-0002",
          "445-0814",
          "445-0844",
          "445-0815",
          "445-0862",
          "445-0879",
          "445-0876",
          "445-0851",
          "445-0046",
          "445-0034",
          "445-0001",
          "445-0023",
          "445-0856",
          "445-0064",
          "445-0042",
          "445-0015",
          "444-0302",
          "444-0301",
          "445-0846",
          "445-0062",
          "445-0014",
          "445-0837",
          "445-0805",
          "445-0845",
          "444-0327",
          "444-0324",
          "444-0702",
          "445-0051",
          "445-0843",
          "445-0833",
          "445-0812",
          "445-0811",
          "445-0075",
          "445-0074",
          "445-0072",
          "444-0315",
          "444-0704",
          "444-0329",
          "444-0326",
          "445-0887",
          "444-0323",
          "444-0304",
          "444-0303",
          "445-0083",
          "445-0836",
          "445-0870",
          "445-0871",
          "445-0881",
          "445-0004",
          "444-0336",
          "444-0331",
          "444-0703",
          "445-0057",
          "445-0884",
          "444-0316",
          "444-0317",
          "445-0852",
          "445-0841",
          "445-0886",
          "445-0003",
          "444-0701",
          "445-0874",
          "445-0054",
          "445-0032",
          "445-0875",
          "444-0305",
          "444-0328",
          "445-0892",
          "445-0047",
          "445-0865",
          "445-0826",
          "445-0804",
          "444-0335",
          "445-0855",
          "444-0334",
          "445-0801",
          "445-0816",
          "445-0033",
          "445-0872",
          "444-0318",
          "445-0082",
          "445-0821",
          "445-0877",
          "445-0842",
          "445-0052",
          "445-0802",
          "445-0073",
          "445-0061",
          "445-0813",
          "445-0025",
          "443-0000",
          "443-0045",
          "443-0051",
          "443-0052",
          "443-0101",
          "443-0058",
          "443-0013",
          "443-0014",
          "443-0037",
          "443-0008",
          "443-0104",
          "443-0106",
          "443-0103",
          "443-0102",
          "443-0006",
          "443-0007",
          "443-0003",
          "443-0035",
          "443-0001",
          "443-0012",
          "443-0056",
          "443-0002",
          "443-0044",
          "443-0031",
          "443-0046",
          "443-0057",
          "443-0011",
          "443-0105",
          "443-0047",
          "443-0036",
          "443-0004",
          "443-0038",
          "443-0054",
          "443-0053",
          "443-0059",
          "443-0033",
          "443-0032",
          "443-0005",
          "443-0048",
          "443-0034",
          "443-0022",
          "443-0021",
          "443-0041",
          "443-0042",
          "443-0043",
          "443-0055",
          "484-0000",
          "484-0945",
          "484-0921",
          "484-0837",
          "484-0887",
          "484-0032",
          "484-0862",
          "484-0053",
          "484-0056",
          "484-0081",
          "484-0033",
          "484-0005",
          "484-0021",
          "484-0008",
          "484-0872",
          "484-0055",
          "484-0047",
          "484-0071",
          "484-0026",
          "484-0074",
          "484-0854",
          "484-0035",
          "484-0902",
          "484-0903",
          "484-0034",
          "484-0962",
          "484-0001",
          "484-0901",
          "484-0955",
          "484-0936",
          "484-0944",
          "484-0926",
          "484-0874",
          "484-0048",
          "484-0843",
          "484-0924",
          "484-0904",
          "484-0915",
          "484-0841",
          "484-0907",
          "484-0947",
          "484-0963",
          "484-0856",
          "484-0811",
          "484-0819",
          "484-0916",
          "484-0925",
          "484-0942",
          "484-0816",
          "484-0885",
          "484-0877",
          "484-0879",
          "484-0846",
          "484-0964",
          "484-0059",
          "484-0077",
          "484-0078",
          "484-0043",
          "484-0952",
          "484-0851",
          "484-0914",
          "484-0818",
          "484-0922",
          "484-0082",
          "484-0011",
          "484-0823",
          "484-0911",
          "484-0959",
          "484-0824",
          "484-0024",
          "484-0867",
          "484-0027",
          "484-0002",
          "484-0878",
          "484-0014",
          "484-0815",
          "484-0817",
          "484-0838",
          "484-0957",
          "484-0079",
          "484-0015",
          "484-0855",
          "484-0066",
          "484-0966",
          "484-0065",
          "484-0018",
          "484-0844",
          "484-0019",
          "484-0017",
          "484-0965",
          "484-0842",
          "484-0923",
          "484-0953",
          "484-0044",
          "484-0007",
          "484-0825",
          "484-0858",
          "484-0956",
          "484-0003",
          "484-0004",
          "484-0869",
          "484-0908",
          "484-0058",
          "484-0845",
          "484-0814",
          "484-0961",
          "484-0009",
          "484-0041",
          "484-0091",
          "484-0917",
          "484-0023",
          "484-0013",
          "484-0866",
          "484-0873",
          "484-0073",
          "484-0094",
          "484-0095",
          "484-0096",
          "484-0097",
          "484-0831",
          "484-0092",
          "484-0099",
          "484-0093",
          "484-0098",
          "484-0857",
          "484-0913",
          "484-0934",
          "484-0822",
          "484-0852",
          "484-0045",
          "484-0919",
          "484-0054",
          "484-0087",
          "484-0928",
          "484-0037",
          "484-0935",
          "484-0905",
          "484-0036",
          "484-0085",
          "484-0948",
          "484-0932",
          "484-0029",
          "484-0918",
          "484-0042",
          "484-0863",
          "484-0025",
          "484-0022",
          "484-0894",
          "484-0806",
          "484-0899",
          "484-0898",
          "484-0884",
          "484-0891",
          "484-0882",
          "484-0893",
          "484-0804",
          "484-0803",
          "484-0888",
          "484-0805",
          "484-0895",
          "484-0892",
          "484-0889",
          "484-0897",
          "484-0881",
          "484-0883",
          "484-0807",
          "484-0802",
          "484-0801",
          "484-0896",
          "484-0076",
          "484-0075",
          "484-0835",
          "484-0006",
          "484-0951",
          "484-0943",
          "484-0941",
          "484-0864",
          "484-0038",
          "484-0933",
          "484-0868",
          "484-0031",
          "484-0083",
          "484-0946",
          "484-0958",
          "484-0836",
          "484-0057",
          "484-0912",
          "484-0049",
          "484-0871",
          "484-0061",
          "484-0062",
          "484-0064",
          "484-0063",
          "484-0086",
          "484-0927",
          "484-0072",
          "484-0931",
          "484-0084",
          "484-0012",
          "484-0051",
          "484-0886",
          "484-0834",
          "484-0937",
          "484-0833",
          "484-0028",
          "484-0832",
          "484-0020",
          "484-0954",
          "484-0839",
          "484-0828",
          "484-0827",
          "484-0906",
          "484-0046",
          "484-0016",
          "484-0865",
          "484-0876",
          "484-0821",
          "484-0812",
          "484-0813",
          "484-0826",
          "484-0853",
          "484-0875",
          "484-0861",
          "484-0052",
          "479-0000",
          "479-0868",
          "479-0814",
          "479-0074",
          "479-0024",
          "479-0038",
          "479-0811",
          "479-0014",
          "479-0828",
          "479-0812",
          "479-0072",
          "479-0062",
          "479-0857",
          "479-0854",
          "479-0015",
          "479-0871",
          "479-0021",
          "479-0806",
          "479-0810",
          "479-0005",
          "479-0842",
          "479-0866",
          "479-0027",
          "479-0039",
          "479-0823",
          "479-0822",
          "479-0053",
          "479-0862",
          "479-0044",
          "479-0068",
          "479-0069",
          "479-0873",
          "479-0003",
          "479-0858",
          "479-0856",
          "479-0063",
          "479-0815",
          "479-0805",
          "479-0819",
          "479-0046",
          "479-0867",
          "479-0833",
          "479-0816",
          "479-0817",
          "479-0002",
          "479-0079",
          "479-0838",
          "479-0807",
          "479-0042",
          "479-0058",
          "479-0804",
          "479-0818",
          "479-0865",
          "479-0067",
          "479-0809",
          "479-0836",
          "479-0017",
          "479-0035",
          "479-0056",
          "479-0034",
          "479-0036",
          "479-0813",
          "479-0032",
          "479-0019",
          "479-0071",
          "479-0012",
          "479-0007",
          "479-0837",
          "479-0855",
          "479-0847",
          "479-0852",
          "479-0846",
          "479-0075",
          "479-0864",
          "479-0004",
          "479-0821",
          "479-0881",
          "479-0016",
          "479-0022",
          "479-0843",
          "479-0839",
          "479-0801",
          "479-0826",
          "479-0041",
          "479-0065",
          "479-0834",
          "479-0026",
          "479-0057",
          "479-0835",
          "479-0008",
          "479-0076",
          "479-0073",
          "479-0045",
          "479-0037",
          "479-0033",
          "479-0048",
          "479-0023",
          "479-0028",
          "479-0031",
          "479-0049",
          "479-0025",
          "479-0802",
          "479-0831",
          "479-0054",
          "479-0849",
          "479-0863",
          "479-0018",
          "479-0013",
          "479-0824",
          "479-0011",
          "479-0832",
          "479-0861",
          "479-0803",
          "479-0009",
          "479-0055",
          "479-0808",
          "479-0006",
          "479-0029",
          "479-0043",
          "479-0827",
          "479-0853",
          "479-0829",
          "479-0848",
          "479-0047",
          "479-0059",
          "479-0077",
          "479-0061",
          "479-0841",
          "479-0845",
          "479-0001",
          "479-0825",
          "479-0844",
          "479-0064",
          "479-0882",
          "479-0851",
          "479-0066",
          "483-0000",
          "483-8221",
          "483-8226",
          "483-8223",
          "483-8225",
          "483-8228",
          "483-8224",
          "483-8165",
          "483-8222",
          "483-8167",
          "483-8166",
          "483-8227",
          "483-8106",
          "483-8107",
          "483-8181",
          "483-8183",
          "483-8182",
          "483-8188",
          "483-8387",
          "483-8347",
          "483-8345",
          "483-8381",
          "483-8385",
          "483-8386",
          "483-8344",
          "483-8346",
          "483-8388",
          "483-8383",
          "483-8384",
          "483-8382",
          "483-8389",
          "483-8041",
          "483-8048",
          "483-8042",
          "483-8034",
          "483-8043",
          "483-8414",
          "483-8405",
          "483-8409",
          "483-8408",
          "483-8403",
          "483-8412",
          "483-8411",
          "483-8404",
          "483-8413",
          "483-8407",
          "483-8187",
          "483-8185",
          "483-8186",
          "483-8251",
          "483-8252",
          "483-8135",
          "483-8143",
          "483-8149",
          "483-8145",
          "483-8144",
          "483-8161",
          "483-8162",
          "483-8173",
          "483-8172",
          "483-8168",
          "483-8171",
          "483-8037",
          "483-8008",
          "483-8259",
          "483-8257",
          "483-8258",
          "483-8254",
          "483-8255",
          "483-8253",
          "483-8233",
          "483-8163",
          "483-8164",
          "483-8232",
          "483-8231",
          "483-8239",
          "483-8238",
          "483-8176",
          "483-8177",
          "483-8174",
          "483-8175",
          "483-8153",
          "483-8157",
          "483-8003",
          "483-8006",
          "483-8071",
          "483-8004",
          "483-8005",
          "483-8072",
          "483-8007",
          "483-8077",
          "483-8365",
          "483-8364",
          "483-8366",
          "483-8369",
          "483-8363",
          "483-8362",
          "483-8136",
          "483-8137",
          "483-8134",
          "483-8131",
          "483-8125",
          "483-8127",
          "483-8126",
          "483-8124",
          "483-8128",
          "483-8213",
          "483-8207",
          "483-8272",
          "483-8275",
          "483-8205",
          "483-8211",
          "483-8206",
          "483-8331",
          "483-8215",
          "483-8271",
          "483-8216",
          "483-8208",
          "483-8214",
          "483-8274",
          "483-8277",
          "483-8217",
          "483-8273",
          "483-8278",
          "483-8212",
          "483-8279",
          "483-8276",
          "483-8241",
          "483-8243",
          "483-8247",
          "483-8244",
          "483-8245",
          "483-8248",
          "483-8249",
          "483-8242",
          "483-8246",
          "483-8406",
          "483-8055",
          "483-8401",
          "483-8402",
          "483-8263",
          "483-8267",
          "483-8264",
          "483-8269",
          "483-8266",
          "483-8268",
          "483-8262",
          "483-8265",
          "483-8123",
          "483-8121",
          "483-8122",
          "483-8065",
          "483-8088",
          "483-8086",
          "483-8084",
          "483-8081",
          "483-8087",
          "483-8062",
          "483-8061",
          "483-8064",
          "483-8047",
          "483-8035",
          "483-8045",
          "483-8083",
          "483-8085",
          "483-8066",
          "483-8063",
          "483-8046",
          "483-8082",
          "483-8138",
          "483-8133",
          "483-8132",
          "483-8114",
          "483-8113",
          "483-8256",
          "483-8001",
          "483-8002",
          "483-8203",
          "483-8202",
          "483-8204",
          "483-8201",
          "483-8018",
          "483-8017",
          "483-8012",
          "483-8013",
          "483-8011",
          "483-8433",
          "483-8415",
          "483-8422",
          "483-8417",
          "483-8426",
          "483-8425",
          "483-8418",
          "483-8421",
          "483-8423",
          "483-8427",
          "483-8428",
          "483-8431",
          "483-8416",
          "483-8419",
          "483-8429",
          "483-8424",
          "483-8432",
          "483-8333",
          "483-8332",
          "483-8067",
          "483-8339",
          "483-8068",
          "483-8069",
          "483-8337",
          "483-8142",
          "483-8146",
          "483-8148",
          "483-8147",
          "483-8235",
          "483-8141",
          "483-8158",
          "483-8237",
          "483-8236",
          "483-8234",
          "483-8057",
          "483-8051",
          "483-8053",
          "483-8052",
          "483-8058",
          "483-8054",
          "483-8348",
          "483-8341",
          "483-8335",
          "483-8336",
          "483-8349",
          "483-8338",
          "483-8334",
          "483-8342",
          "483-8351",
          "483-8343",
          "483-8358",
          "483-8352",
          "483-8356",
          "483-8354",
          "483-8359",
          "483-8355",
          "483-8357",
          "483-8353",
          "483-8155",
          "483-8154",
          "483-8156",
          "483-8044",
          "483-8056",
          "483-8303",
          "483-8308",
          "483-8304",
          "483-8302",
          "483-8301",
          "483-8375",
          "483-8371",
          "483-8374",
          "483-8373",
          "483-8307",
          "483-8306",
          "483-8305",
          "483-8376",
          "483-8361",
          "483-8379",
          "483-8377",
          "483-8367",
          "483-8368",
          "483-8372",
          "483-8378",
          "483-8076",
          "483-8312",
          "483-8316",
          "483-8311",
          "483-8328",
          "483-8321",
          "483-8315",
          "483-8314",
          "483-8319",
          "483-8322",
          "483-8313",
          "483-8326",
          "483-8075",
          "483-8327",
          "483-8074",
          "483-8317",
          "483-8325",
          "483-8324",
          "483-8318",
          "483-8323",
          "483-8112",
          "483-8117",
          "483-8118",
          "483-8111",
          "483-8116",
          "483-8115",
          "483-8031",
          "483-8032",
          "483-8033",
          "483-8038",
          "483-8036",
          "483-8159",
          "483-8152",
          "483-8184",
          "483-8151",
          "483-8109",
          "483-8101",
          "483-8105",
          "483-8108",
          "483-8104",
          "483-8103",
          "483-8102",
          "483-8022",
          "483-8014",
          "483-8021",
          "483-8029",
          "483-8024",
          "483-8028",
          "483-8015",
          "483-8026",
          "483-8016",
          "483-8023",
          "483-8027",
          "483-8025",
          "485-0000",
          "485-0047",
          "485-0804",
          "485-0034",
          "485-0084",
          "485-0011",
          "485-0017",
          "485-0832",
          "485-0802",
          "485-0026",
          "485-0801",
          "485-0037",
          "485-0032",
          "485-0025",
          "485-0822",
          "485-0085",
          "485-0045",
          "485-0023",
          "485-0022",
          "485-0009",
          "485-0003",
          "485-0001",
          "485-0007",
          "485-0006",
          "485-0005",
          "485-0033",
          "485-0823",
          "485-0814",
          "485-0058",
          "485-0059",
          "485-0057",
          "485-0056",
          "485-0041",
          "485-0829",
          "485-0012",
          "485-0828",
          "485-0042",
          "485-0043",
          "485-0815",
          "485-0036",
          "485-0051",
          "485-0825",
          "485-0044",
          "485-0812",
          "485-0074",
          "485-0013",
          "485-0039",
          "485-0803",
          "485-0004",
          "485-0052",
          "485-0035",
          "485-0054",
          "485-0053",
          "485-0055",
          "485-0029",
          "485-0008",
          "485-0824",
          "485-0078",
          "485-0077",
          "485-0806",
          "485-0805",
          "485-0811",
          "485-0831",
          "485-0028",
          "485-0826",
          "485-0068",
          "485-0067",
          "485-0063",
          "485-0065",
          "485-0066",
          "485-0064",
          "485-0062",
          "485-0069",
          "485-0061",
          "485-0021",
          "485-0073",
          "485-0827",
          "485-0046",
          "485-0821",
          "485-0015",
          "485-0016",
          "485-0048",
          "485-0075",
          "485-0076",
          "485-0027",
          "485-0024",
          "485-0082",
          "485-0083",
          "485-0072",
          "485-0813",
          "485-0014",
          "485-0049",
          "485-0071",
          "485-0081",
          "485-0002",
          "485-0031",
          "492-0000",
          "492-8008",
          "492-8001",
          "492-8002",
          "492-8004",
          "492-8015",
          "492-8014",
          "492-8022",
          "492-8005",
          "492-8013",
          "492-8012",
          "492-8025",
          "492-8003",
          "492-8017",
          "492-8021",
          "492-8023",
          "492-8011",
          "492-8006",
          "492-8024",
          "492-8016",
          "492-8007",
          "492-8318",
          "492-8268",
          "492-8278",
          "492-8274",
          "492-8275",
          "492-8281",
          "492-8279",
          "492-8283",
          "492-8282",
          "492-8284",
          "492-8277",
          "492-8276",
          "492-8262",
          "492-8362",
          "492-8363",
          "492-8356",
          "492-8371",
          "492-8366",
          "492-8354",
          "492-8365",
          "492-8375",
          "492-8352",
          "492-8351",
          "492-8373",
          "492-8372",
          "492-8361",
          "492-8374",
          "492-8358",
          "492-8353",
          "492-8357",
          "492-8364",
          "492-8271",
          "492-8451",
          "492-8217",
          "492-8211",
          "492-8229",
          "492-8207",
          "492-8230",
          "492-8206",
          "492-8219",
          "492-8269",
          "492-8163",
          "492-8164",
          "492-8152",
          "492-8166",
          "492-8156",
          "492-8157",
          "492-8151",
          "492-8162",
          "492-8165",
          "492-8158",
          "492-8154",
          "492-8155",
          "492-8153",
          "492-8465",
          "492-8466",
          "492-8406",
          "492-8467",
          "492-8408",
          "492-8461",
          "492-8464",
          "492-8407",
          "492-8462",
          "492-8463",
          "492-8468",
          "492-8409",
          "492-8453",
          "492-8443",
          "492-8143",
          "492-8214",
          "492-8215",
          "492-8216",
          "492-8415",
          "492-8413",
          "492-8418",
          "492-8414",
          "492-8416",
          "492-8419",
          "492-8417",
          "492-8412",
          "492-8223",
          "492-8224",
          "492-8253",
          "492-8256",
          "492-8243",
          "492-8234",
          "492-8246",
          "492-8232",
          "492-8257",
          "492-8244",
          "492-8225",
          "492-8226",
          "492-8235",
          "492-8241",
          "492-8236",
          "492-8255",
          "492-8222",
          "492-8239",
          "492-8228",
          "492-8231",
          "492-8227",
          "492-8237",
          "492-8238",
          "492-8245",
          "492-8254",
          "492-8233",
          "492-8242",
          "492-8081",
          "492-8058",
          "492-8054",
          "492-8072",
          "492-8094",
          "492-8091",
          "492-8056",
          "492-8093",
          "492-8068",
          "492-8051",
          "492-8053",
          "492-8066",
          "492-8062",
          "492-8065",
          "492-8061",
          "492-8085",
          "492-8078",
          "492-8077",
          "492-8057",
          "492-8064",
          "492-8052",
          "492-8092",
          "492-8055",
          "492-8071",
          "492-8073",
          "492-8095",
          "492-8084",
          "492-8076",
          "492-8083",
          "492-8063",
          "492-8074",
          "492-8082",
          "492-8075",
          "492-8355",
          "492-8174",
          "492-8178",
          "492-8175",
          "492-8173",
          "492-8448",
          "492-8410",
          "492-8411",
          "492-8349",
          "492-8210",
          "492-8209",
          "492-8033",
          "492-8043",
          "492-8045",
          "492-8034",
          "492-8031",
          "492-8037",
          "492-8042",
          "492-8032",
          "492-8036",
          "492-8041",
          "492-8044",
          "492-8038",
          "492-8177",
          "492-8185",
          "492-8183",
          "492-8181",
          "492-8182",
          "492-8176",
          "492-8184",
          "492-8186",
          "492-8144",
          "492-8147",
          "492-8136",
          "492-8137",
          "492-8139",
          "492-8138",
          "492-8101",
          "492-8105",
          "492-8111",
          "492-8108",
          "492-8112",
          "492-8109",
          "492-8102",
          "492-8107",
          "492-8103",
          "492-8104",
          "492-8106",
          "492-8146",
          "492-8212",
          "492-8265",
          "492-8444",
          "492-8221",
          "492-8454",
          "492-8272",
          "492-8273",
          "492-8261",
          "492-8259",
          "492-8203",
          "492-8201",
          "492-8240",
          "492-8249",
          "492-8204",
          "492-8248",
          "492-8202",
          "492-8258",
          "492-8205",
          "492-8313",
          "492-8315",
          "492-8316",
          "492-8311",
          "492-8312",
          "492-8317",
          "492-8314",
          "492-8310",
          "492-8319",
          "492-8145",
          "492-8135",
          "492-8134",
          "492-8115",
          "492-8116",
          "492-8127",
          "492-8118",
          "492-8126",
          "492-8113",
          "492-8125",
          "492-8119",
          "492-8117",
          "492-8114",
          "492-8132",
          "492-8124",
          "492-8128",
          "492-8123",
          "492-8131",
          "492-8133",
          "492-8122",
          "492-8121",
          "492-8403",
          "492-8404",
          "492-8402",
          "495-0014",
          "495-0022",
          "495-0031",
          "495-0015",
          "495-0021",
          "495-0037",
          "495-0023",
          "495-0035",
          "495-0001",
          "495-0003",
          "495-0032",
          "495-0034",
          "495-0024",
          "495-0013",
          "495-0012",
          "495-0036",
          "495-0011",
          "495-0002",
          "495-0033",
          "495-0025",
          "492-8339",
          "492-8332",
          "492-8338",
          "492-8336",
          "492-8337",
          "492-8334",
          "492-8333",
          "492-8331",
          "492-8423",
          "492-8424",
          "492-8421",
          "492-8422",
          "492-8213",
          "492-8285",
          "492-8287",
          "492-8288",
          "492-8286",
          "492-8289",
          "492-8455",
          "492-8442",
          "492-8391",
          "492-8436",
          "492-8431",
          "492-8434",
          "492-8437",
          "492-8432",
          "492-8433",
          "492-8435",
          "492-8142",
          "492-8141",
          "492-8393",
          "492-8392",
          "492-8167",
          "492-8439",
          "492-8328",
          "492-8323",
          "492-8322",
          "492-8327",
          "492-8325",
          "492-8321",
          "492-8326",
          "492-8329",
          "492-8218",
          "492-8452",
          "492-8447",
          "492-8307",
          "492-8305",
          "492-8308",
          "492-8302",
          "492-8303",
          "492-8301",
          "492-8304",
          "492-8306",
          "492-8348",
          "492-8341",
          "492-8247",
          "492-8251",
          "492-8161",
          "492-8456",
          "492-8263",
          "492-8264",
          "492-8441",
          "492-8267",
          "490-1303",
          "490-1302",
          "490-1314",
          "490-1312",
          "490-1301",
          "490-1321",
          "490-1311",
          "490-1315",
          "490-1304",
          "490-1313",
          "490-1322",
          "490-1323",
          "490-1305",
          "492-8335",
          "492-8438",
          "492-8405",
          "492-8220",
          "492-8426",
          "492-8429",
          "492-8427",
          "492-8425",
          "492-8428",
          "492-8208",
          "492-8252",
          "492-8445",
          "492-8446",
          "492-8401",
          "492-8346",
          "492-8344",
          "492-8345",
          "492-8347",
          "492-8342",
          "492-8266",
          "492-8385",
          "492-8388",
          "492-8387",
          "492-8382",
          "492-8381",
          "492-8384",
          "492-8383",
          "492-8386",
          "492-8389",
          "492-8172",
          "492-8171",
          "441-1300",
          "441-1951",
          "441-1312",
          "441-1317",
          "441-1602",
          "441-1342",
          "441-1365",
          "441-1616",
          "441-1321",
          "441-1348",
          "441-1953",
          "441-1351",
          "441-1324",
          "441-1303",
          "441-1372",
          "441-1943",
          "441-1615",
          "441-1315",
          "441-1304",
          "441-1364",
          "441-1333",
          "441-1329",
          "441-1354",
          "441-1327",
          "441-1693",
          "441-1944",
          "441-1355",
          "441-1622",
          "441-1601",
          "441-1306",
          "441-1346",
          "441-1347",
          "441-1387",
          "441-1945",
          "441-1332",
          "441-1328",
          "441-1956",
          "441-1381",
          "441-1621",
          "441-1371",
          "441-1341",
          "441-1313",
          "441-1311",
          "441-1612",
          "441-1382",
          "441-1624",
          "441-1305",
          "441-1954",
          "441-1533",
          "441-1411",
          "441-1531",
          "441-1412",
          "441-1414",
          "441-1402",
          "441-1421",
          "441-1413",
          "441-1404",
          "441-1535",
          "441-1403",
          "441-1423",
          "441-1532",
          "441-1534",
          "441-1422",
          "441-1424",
          "441-1401",
          "441-1536",
          "441-1623",
          "441-1353",
          "441-1335",
          "441-1336",
          "441-1632",
          "441-1307",
          "441-1302",
          "441-1636",
          "441-1631",
          "441-1352",
          "441-1345",
          "441-1334",
          "441-1634",
          "441-1952",
          "441-1326",
          "441-1604",
          "441-1611",
          "441-1384",
          "441-1373",
          "441-1325",
          "441-1331",
          "441-1343",
          "441-1344",
          "441-1605",
          "441-1633",
          "441-1388",
          "441-1385",
          "441-1383",
          "441-1363",
          "441-1338",
          "441-1322",
          "441-1362",
          "441-1361",
          "441-1946",
          "441-1367",
          "441-1955",
          "441-1613",
          "441-1374",
          "441-1375",
          "441-1316",
          "441-1386",
          "441-1378",
          "441-1376",
          "441-1603",
          "441-1377",
          "441-1366",
          "441-1614",
          "441-1368",
          "441-1318",
          "441-1337",
          "441-1301",
          "441-1314",
          "441-1323",
          "441-1942",
          "441-1941",
          "476-0000",
          "476-0006",
          "476-0003",
          "476-0004",
          "477-0031",
          "477-0032",
          "476-0005",
          "477-0037",
          "476-0013",
          "476-0015",
          "477-0033",
          "476-0002",
          "476-0011",
          "476-0012",
          "476-0014",
          "476-0001",
          "477-0035",
          "477-0034",
          "477-0036",
          "474-0000",
          "474-0024",
          "474-0045",
          "474-0035",
          "474-0027",
          "474-0051",
          "474-0071",
          "474-0003",
          "474-0002",
          "474-0001",
          "474-0072",
          "474-0074",
          "474-0062",
          "474-0061",
          "474-0057",
          "474-0043",
          "474-0044",
          "474-0023",
          "474-0042",
          "474-0025",
          "474-0036",
          "474-0073",
          "474-0052",
          "474-0021",
          "474-0037",
          "474-0053",
          "474-0055",
          "474-0047",
          "474-0056",
          "474-0026",
          "474-0038",
          "474-0031",
          "474-0011",
          "474-0046",
          "474-0048",
          "474-0041",
          "474-0022",
          "478-0000",
          "478-0058",
          "478-0051",
          "478-0031",
          "478-0005",
          "478-0004",
          "478-0016",
          "478-0035",
          "478-0067",
          "478-0021",
          "478-0062",
          "478-0028",
          "478-0032",
          "478-0033",
          "478-0046",
          "478-0044",
          "478-0034",
          "478-0006",
          "478-0053",
          "478-0069",
          "478-0017",
          "478-0064",
          "478-0066",
          "478-0065",
          "478-0059",
          "478-0027",
          "478-0036",
          "478-0037",
          "478-0015",
          "478-0018",
          "478-0022",
          "478-0012",
          "478-0054",
          "478-0063",
          "478-0003",
          "478-0042",
          "478-0068",
          "478-0014",
          "478-0055",
          "478-0011",
          "478-0061",
          "478-0041",
          "478-0043",
          "478-0002",
          "478-0057",
          "478-0047",
          "478-0024",
          "478-0026",
          "478-0023",
          "478-0025",
          "478-0013",
          "478-0056",
          "478-0045",
          "478-0060",
          "478-0001",
          "478-0052",
          "472-0000",
          "472-0021",
          "472-0025",
          "472-0003",
          "472-0007",
          "472-0042",
          "472-0058",
          "472-0026",
          "472-0034",
          "472-0052",
          "472-0046",
          "472-0037",
          "472-0031",
          "472-0011",
          "472-0005",
          "472-0041",
          "472-0047",
          "472-0017",
          "472-0056",
          "472-0024",
          "472-0043",
          "472-0055",
          "472-0033",
          "472-0032",
          "472-0045",
          "472-0035",
          "472-0004",
          "472-0057",
          "472-0027",
          "472-0016",
          "472-0023",
          "472-0054",
          "472-0051",
          "472-0044",
          "472-0036",
          "472-0038",
          "472-0053",
          "472-0013",
          "472-0015",
          "472-0014",
          "472-0012",
          "472-0001",
          "472-0006",
          "472-0022",
          "472-0002",
          "488-0000",
          "488-0083",
          "488-0086",
          "488-0085",
          "488-0082",
          "488-0084",
          "488-0001",
          "488-0855",
          "488-0852",
          "488-0854",
          "488-0851",
          "488-0081",
          "488-0079",
          "488-0073",
          "488-0075",
          "488-0070",
          "488-0071",
          "488-0072",
          "488-0078",
          "488-0077",
          "488-0074",
          "488-0076",
          "488-0024",
          "488-0054",
          "488-0840",
          "488-0841",
          "488-0843",
          "488-0035",
          "488-0034",
          "488-0004",
          "488-0005",
          "488-0006",
          "488-0826",
          "488-0008",
          "488-0007",
          "488-0846",
          "488-0845",
          "488-0847",
          "488-0022",
          "488-0021",
          "488-0065",
          "488-0063",
          "488-0064",
          "488-0062",
          "488-0061",
          "488-0043",
          "488-0057",
          "488-0056",
          "488-0055",
          "488-0859",
          "488-0857",
          "488-0015",
          "488-0012",
          "488-0016",
          "488-0013",
          "488-0014",
          "488-0839",
          "488-0052",
          "488-0053",
          "488-0051",
          "488-0838",
          "488-0836",
          "488-0835",
          "488-0823",
          "488-0867",
          "488-0863",
          "488-0861",
          "488-0866",
          "488-0884",
          "488-0883",
          "488-0881",
          "488-0882",
          "488-0023",
          "488-0011",
          "488-0844",
          "488-0821",
          "488-0813",
          "488-0816",
          "488-0814",
          "488-0817",
          "488-0815",
          "488-0804",
          "488-0805",
          "488-0824",
          "488-0002",
          "488-0858",
          "488-0032",
          "488-0031",
          "488-0830",
          "488-0833",
          "488-0003",
          "488-0017",
          "488-0802",
          "488-0801",
          "488-0803",
          "488-0033",
          "488-0825",
          "488-0876",
          "488-0873",
          "488-0872",
          "488-0871",
          "488-0874",
          "488-0875",
          "488-0822",
          "488-0045",
          "488-0046",
          "488-0047",
          "488-0041",
          "488-0042",
          "488-0066",
          "488-0067",
          "488-0068",
          "488-0044",
          "488-0818",
          "488-0827",
          "444-1300",
          "444-1325",
          "444-1324",
          "444-1334",
          "444-1336",
          "444-1303",
          "444-1333",
          "444-1312",
          "444-1301",
          "444-1305",
          "444-1323",
          "444-1304",
          "444-1302",
          "444-1321",
          "444-1322",
          "444-1311",
          "444-1313",
          "444-1331",
          "444-1332",
          "444-1335",
          "444-1314",
          "482-0000",
          "482-0024",
          "482-0034",
          "482-0045",
          "482-0012",
          "482-0006",
          "482-0032",
          "482-0033",
          "482-0015",
          "482-0017",
          "482-0004",
          "482-0036",
          "482-0022",
          "482-0005",
          "482-0011",
          "482-0021",
          "482-0035",
          "482-0003",
          "482-0002",
          "482-0014",
          "482-0018",
          "482-0007",
          "482-0025",
          "482-0026",
          "482-0023",
          "482-0046",
          "482-0042",
          "482-0016",
          "482-0001",
          "482-0041",
          "482-0043",
          "482-0013",
          "482-0044",
          "482-0031",
          "470-1100",
          "470-1141",
          "470-1144",
          "470-1145",
          "470-1146",
          "470-1147",
          "470-1143",
          "470-1148",
          "470-1142",
          "470-1111",
          "470-1101",
          "470-1108",
          "470-1107",
          "470-1105",
          "470-1106",
          "470-1103",
          "470-1104",
          "470-1109",
          "470-1102",
          "470-1161",
          "470-1165",
          "470-1163",
          "470-1164",
          "470-1166",
          "470-1162",
          "470-1167",
          "470-1168",
          "470-1154",
          "470-1112",
          "470-1113",
          "470-1114",
          "470-1115",
          "470-1116",
          "470-1151",
          "470-1152",
          "470-1153",
          "470-1121",
          "470-1122",
          "470-1123",
          "470-1131",
          "470-1132",
          "470-1133",
          "470-1124",
          "470-1126",
          "470-1125",
          "470-1127",
          "470-0100",
          "470-0125",
          "470-0126",
          "470-0127",
          "470-0124",
          "470-0128",
          "470-0135",
          "470-0131",
          "470-0104",
          "470-0133",
          "470-0132",
          "470-0115",
          "470-0134",
          "470-0122",
          "470-0103",
          "470-0105",
          "470-0118",
          "470-0111",
          "470-0113",
          "470-0101",
          "470-0136",
          "470-0123",
          "470-0116",
          "470-0112",
          "470-0102",
          "470-0117",
          "470-0121",
          "470-0114",
          "441-3400",
          "441-3418",
          "441-3422",
          "441-3502",
          "441-3433",
          "441-3604",
          "441-3505",
          "441-3611",
          "441-3624",
          "441-3601",
          "441-3403",
          "441-3605",
          "441-3425",
          "441-3426",
          "441-3504",
          "441-3608",
          "441-3427",
          "441-3409",
          "441-3404",
          "441-3625",
          "441-3415",
          "441-3407",
          "441-3626",
          "441-3613",
          "441-3419",
          "441-3618",
          "441-3436",
          "441-3431",
          "441-3612",
          "441-3501",
          "441-3421",
          "441-3417",
          "441-3609",
          "441-3615",
          "441-3435",
          "441-3423",
          "441-3619",
          "441-3432",
          "441-3406",
          "441-3602",
          "441-3606",
          "441-3623",
          "441-3416",
          "441-3414",
          "441-3405",
          "441-3617",
          "441-3614",
          "441-3627",
          "441-3434",
          "441-3401",
          "441-3424",
          "441-3616",
          "441-3413",
          "441-3603",
          "441-3411",
          "441-3412",
          "441-3621",
          "441-3607",
          "441-3408",
          "441-3402",
          "441-3503",
          "441-3622",
          "496-8046",
          "496-0938",
          "496-0907",
          "496-0923",
          "496-8033",
          "496-0903",
          "496-8044",
          "496-0921",
          "496-0922",
          "496-8017",
          "496-0909",
          "496-8009",
          "496-0932",
          "496-0908",
          "496-8031",
          "496-8039",
          "496-0905",
          "496-8008",
          "496-8042",
          "496-8015",
          "496-8004",
          "496-0944",
          "496-8002",
          "496-0901",
          "496-8049",
          "496-0935",
          "496-8048",
          "496-8032",
          "496-8001",
          "496-0934",
          "496-0902",
          "496-0941",
          "496-8011",
          "496-0924",
          "496-8003",
          "496-8043",
          "496-8016",
          "496-0946",
          "496-8047",
          "496-0933",
          "496-8019",
          "496-0913",
          "496-0911",
          "496-8012",
          "496-0931",
          "496-0914",
          "496-0912",
          "496-0939",
          "496-0947",
          "496-8041",
          "496-8035",
          "496-8034",
          "496-8038",
          "496-8037",
          "496-8040",
          "496-8036",
          "496-8030",
          "496-8018",
          "496-8020",
          "496-0906",
          "496-0915",
          "496-8014",
          "496-8013",
          "496-0945",
          "496-8007",
          "496-0937",
          "496-8006",
          "496-8045",
          "496-0943",
          "496-8005",
          "496-0942",
          "496-0904",
          "496-0936",
          "496-8010",
          "452-0000",
          "452-0932",
          "452-0901",
          "452-0931",
          "452-0934",
          "452-0963",
          "452-0913",
          "452-0935",
          "452-0942",
          "452-0916",
          "452-0944",
          "452-0943",
          "452-0905",
          "452-0912",
          "452-0903",
          "452-0902",
          "452-0945",
          "452-0908",
          "452-0918",
          "452-0914",
          "452-0915",
          "452-0907",
          "452-0941",
          "452-0911",
          "452-0933",
          "452-0064",
          "452-0015",
          "452-0007",
          "452-0010",
          "452-0005",
          "452-0051",
          "452-0014",
          "452-0021",
          "452-0041",
          "452-0067",
          "452-0024",
          "452-0022",
          "452-0042",
          "452-0055",
          "452-0012",
          "452-0001",
          "452-0062",
          "452-0061",
          "452-0066",
          "452-0023",
          "452-0017",
          "452-0025",
          "452-0011",
          "452-0016",
          "452-0003",
          "452-0018",
          "452-0004",
          "452-0052",
          "452-0008",
          "452-0035",
          "452-0063",
          "452-0046",
          "452-0009",
          "452-0045",
          "452-0068",
          "452-0026",
          "452-0002",
          "452-0047",
          "452-0043",
          "452-0034",
          "452-0033",
          "452-0006",
          "452-0036",
          "452-0054",
          "452-0053",
          "452-0013",
          "452-0044",
          "452-0031",
          "452-0032",
          "452-0065",
          "452-0917",
          "452-0919",
          "452-0946",
          "452-0947",
          "452-0962",
          "452-0961",
          "452-0904",
          "452-0906",
          "452-0037",
          "481-0000",
          "481-0046",
          "481-0014",
          "481-0035",
          "481-0043",
          "481-0037",
          "481-0044",
          "481-0002",
          "481-0034",
          "481-0012",
          "481-0041",
          "481-0006",
          "481-0004",
          "481-0011",
          "481-0038",
          "481-0045",
          "481-0033",
          "481-0040",
          "481-0003",
          "481-0042",
          "481-0013",
          "481-0039",
          "481-0032",
          "481-0031",
          "481-0001",
          "481-0005",
          "481-0036",
          "498-0000",
          "498-0060",
          "490-1404",
          "498-0053",
          "498-0045",
          "498-0048",
          "498-0052",
          "498-0056",
          "498-0067",
          "498-0023",
          "498-0024",
          "498-0022",
          "498-0028",
          "498-0026",
          "498-0027",
          "498-0021",
          "490-1412",
          "498-0040",
          "498-0015",
          "498-0062",
          "498-0049",
          "498-0039",
          "490-1423",
          "498-0047",
          "498-0007",
          "498-0035",
          "490-1421",
          "490-1424",
          "498-0013",
          "498-0037",
          "498-0043",
          "498-0044",
          "490-1405",
          "498-0051",
          "498-0066",
          "498-0061",
          "498-0016",
          "490-1413",
          "490-1402",
          "498-0018",
          "498-0012",
          "498-0065",
          "498-0014",
          "498-0055",
          "490-1414",
          "498-0006",
          "490-1415",
          "498-0054",
          "490-1407",
          "498-0041",
          "490-1422",
          "490-1426",
          "490-1411",
          "490-1428",
          "498-0058",
          "498-0069",
          "490-1403",
          "498-0057",
          "498-0038",
          "498-0068",
          "490-1406",
          "490-1427",
          "498-0064",
          "498-0001",
          "498-0011",
          "490-1425",
          "498-0063",
          "498-0002",
          "498-0025",
          "498-0031",
          "498-0032",
          "498-0033",
          "498-0034",
          "498-0017",
          "498-0003",
          "498-0004",
          "498-0042",
          "498-0046",
          "498-0036",
          "498-0005",
          "490-1401",
          "470-0200",
          "470-0206",
          "470-0207",
          "470-0213",
          "470-0231",
          "470-0232",
          "470-0201",
          "470-0209",
          "470-0227",
          "470-0211",
          "470-0226",
          "470-0221",
          "470-0217",
          "470-0222",
          "470-0223",
          "470-0212",
          "470-0208",
          "470-0225",
          "470-0216",
          "470-0215",
          "470-0214",
          "470-0202",
          "470-0233",
          "470-0203",
          "470-0204",
          "470-0205",
          "470-0224",
          "490-1200",
          "490-1102",
          "490-1213",
          "490-1221",
          "490-1112",
          "490-1203",
          "490-1222",
          "490-1214",
          "490-1212",
          "490-1103",
          "490-1115",
          "497-0003",
          "497-0005",
          "497-0001",
          "497-0004",
          "497-0013",
          "497-0012",
          "497-0006",
          "497-0014",
          "497-0002",
          "497-0016",
          "497-0015",
          "497-0011",
          "490-1211",
          "490-1114",
          "490-1111",
          "490-1106",
          "490-1224",
          "490-1202",
          "490-1113",
          "490-1226",
          "490-1105",
          "490-1104",
          "490-1225",
          "490-1204",
          "490-1205",
          "490-1206",
          "490-1207",
          "490-1201",
          "490-1101",
          "490-1116",
          "490-1107",
          "490-1223",
          "480-1100",
          "480-1323",
          "480-1331",
          "480-1161",
          "480-1182",
          "480-1343",
          "480-1147",
          "480-1342",
          "480-1143",
          "480-1116",
          "480-1325",
          "480-1302",
          "480-1308",
          "480-1125",
          "480-1152",
          "480-1145",
          "480-1314",
          "480-1334",
          "480-1333",
          "480-1106",
          "480-1146",
          "480-1142",
          "480-1132",
          "480-1165",
          "480-1327",
          "480-1301",
          "480-1339",
          "480-1117",
          "480-1184",
          "480-1151",
          "480-1144",
          "480-1312",
          "480-1347",
          "480-1336",
          "480-1304",
          "480-1176",
          "480-1156",
          "480-1313",
          "480-1153",
          "480-1157",
          "480-1329",
          "480-1322",
          "480-1137",
          "480-1107",
          "480-1338",
          "480-1135",
          "480-1128",
          "480-1115",
          "480-1122",
          "480-1306",
          "480-1321",
          "480-1332",
          "480-1127",
          "480-1326",
          "480-1112",
          "480-1175",
          "480-1335",
          "480-1324",
          "480-1162",
          "480-1178",
          "480-1114",
          "480-1154",
          "480-1346",
          "480-1124",
          "480-1305",
          "480-1108",
          "480-1139",
          "480-1167",
          "480-1337",
          "480-1171",
          "480-1183",
          "480-1138",
          "480-1148",
          "480-1141",
          "480-1166",
          "480-1163",
          "480-1133",
          "480-1174",
          "480-1303",
          "480-1123",
          "480-1181",
          "480-1158",
          "480-1315",
          "480-1318",
          "480-1155",
          "480-1316",
          "480-1344",
          "480-1126",
          "480-1119",
          "480-1311",
          "480-1173",
          "480-1168",
          "480-1104",
          "480-1177",
          "480-1102",
          "480-1317",
          "480-1105",
          "480-1345",
          "480-1309",
          "480-1134",
          "480-1172",
          "480-1121",
          "480-1103",
          "480-1164",
          "480-1111",
          "480-1113",
          "480-1118",
          "480-1129",
          "480-1341",
          "480-1307",
          "480-1136",
          "480-1328",
          "470-0152",
          "470-0155",
          "470-0165",
          "470-0163",
          "470-0162",
          "470-0161",
          "470-0166",
          "470-0156",
          "470-0164",
          "470-0151",
          "470-0153",
          "470-0154",
          "480-0200",
          "480-0201",
          "480-0202",
          "480-0100",
          "480-0132",
          "480-0137",
          "480-0148",
          "480-0138",
          "480-0133",
          "480-0149",
          "480-0141",
          "480-0121",
          "480-0135",
          "480-0151",
          "480-0144",
          "480-0143",
          "480-0127",
          "480-0131",
          "480-0147",
          "480-0126",
          "480-0125",
          "480-0134",
          "480-0122",
          "480-0142",
          "480-0139",
          "480-0124",
          "480-0123",
          "480-0136",
          "480-0145",
          "480-0146",
          "480-0106",
          "480-0103",
          "480-0104",
          "480-0102",
          "480-0107",
          "480-0105",
          "480-0101",
          "490-1100",
          "490-1135",
          "490-1132",
          "490-1142",
          "490-1143",
          "490-1145",
          "490-1131",
          "490-1144",
          "490-1136",
          "490-1134",
          "490-1137",
          "490-1141",
          "490-1133",
          "497-0000",
          "497-0046",
          "497-0047",
          "497-0032",
          "497-0037",
          "497-0050",
          "497-0044",
          "497-0035",
          "497-0033",
          "497-0057",
          "497-0051",
          "497-0055",
          "497-0038",
          "497-0040",
          "497-0043",
          "497-0031",
          "497-0036",
          "497-0030",
          "497-0058",
          "497-0042",
          "497-0054",
          "497-0052",
          "497-0056",
          "497-0048",
          "497-0053",
          "497-0034",
          "497-0045",
          "497-0041",
          "490-1400",
          "490-1435",
          "490-1438",
          "490-1445",
          "490-1444",
          "490-1442",
          "490-1443",
          "490-1436",
          "490-1437",
          "490-1433",
          "490-1447",
          "490-1446",
          "490-1431",
          "490-1441",
          "490-1434",
          "490-1432",
          "470-2200",
          "470-2213",
          "470-2203",
          "470-2216",
          "470-2212",
          "470-2217",
          "470-2211",
          "470-2201",
          "470-2205",
          "470-2207",
          "470-2202",
          "470-2204",
          "470-2214",
          "470-2215",
          "470-2206",
          "470-2100",
          "470-2104",
          "470-2103",
          "470-2102",
          "470-2105",
          "470-2101",
          "470-3300",
          "470-3321",
          "470-3501",
          "470-3502",
          "470-3505",
          "470-3411",
          "470-3412",
          "470-3504",
          "470-3503",
          "470-3322",
          "470-3200",
          "470-2412",
          "470-3233",
          "470-3236",
          "470-3231",
          "470-2403",
          "470-2413",
          "470-2404",
          "470-2409",
          "470-2406",
          "470-2407",
          "470-2408",
          "470-2405",
          "470-2411",
          "470-3234",
          "470-2402",
          "470-2414",
          "470-3235",
          "470-2401",
          "470-3232",
          "470-2300",
          "470-2384",
          "470-2332",
          "470-2514",
          "470-2363",
          "470-2314",
          "470-2329",
          "470-2311",
          "470-2551",
          "470-2513",
          "470-2301",
          "470-2506",
          "470-2503",
          "470-2324",
          "470-2377",
          "470-2337",
          "470-2366",
          "470-2543",
          "470-2344",
          "470-2302",
          "470-2364",
          "470-2376",
          "470-2387",
          "470-2306",
          "470-2354",
          "470-2508",
          "470-2312",
          "470-2379",
          "470-2547",
          "470-2385",
          "470-2383",
          "470-2313",
          "470-2552",
          "470-2358",
          "470-2323",
          "470-2504",
          "470-2357",
          "470-2341",
          "470-2343",
          "470-2359",
          "470-2544",
          "470-2342",
          "470-2322",
          "470-2339",
          "470-2373",
          "470-2356",
          "470-2515",
          "470-2371",
          "470-2305",
          "470-2317",
          "470-2348",
          "470-2555",
          "470-2361",
          "470-2333",
          "470-2505",
          "470-2335",
          "470-2512",
          "470-2319",
          "470-2307",
          "470-2328",
          "470-2372",
          "470-2542",
          "470-2327",
          "470-2347",
          "470-2353",
          "470-2511",
          "470-2334",
          "470-2315",
          "470-2388",
          "470-2346",
          "470-2517",
          "470-2389",
          "470-2309",
          "470-2321",
          "470-2316",
          "470-2349",
          "470-2345",
          "470-2554",
          "470-2516",
          "470-2374",
          "470-2375",
          "470-2521",
          "470-2382",
          "470-2331",
          "470-2365",
          "470-2380",
          "470-2304",
          "470-2326",
          "470-2531",
          "470-2308",
          "470-2507",
          "470-2318",
          "470-2303",
          "470-2501",
          "470-2338",
          "470-2545",
          "470-2386",
          "470-2556",
          "470-2378",
          "470-2351",
          "470-2502",
          "470-2355",
          "470-2352",
          "470-2541",
          "470-2546",
          "470-2336",
          "470-2553",
          "470-2532",
          "470-2362",
          "470-2325",
          "444-0100",
          "444-0117",
          "444-0116",
          "444-0103",
          "444-0115",
          "444-0123",
          "444-0126",
          "444-0102",
          "444-0111",
          "444-0125",
          "444-0104",
          "444-0127",
          "444-0121",
          "444-0101",
          "444-0128",
          "444-0113",
          "444-0124",
          "444-0122",
          "444-0114",
          "441-2300",
          "441-2316",
          "441-2434",
          "441-2315",
          "441-2433",
          "441-2302",
          "441-2317",
          "441-2301",
          "441-2222",
          "441-2221",
          "441-2601",
          "441-2224",
          "441-2312",
          "441-2531",
          "441-2431",
          "441-2432",
          "441-2314",
          "441-2303",
          "441-2223",
          "441-2311",
          "441-2313",
          "449-0200",
          "449-0202",
          "449-0205",
          "449-0206",
          "449-0212",
          "449-0211",
          "449-0215",
          "449-0204",
          "449-0203",
          "449-0213",
          "449-0214",
          "449-0201",
          "449-0216",
          "449-0400",
          "449-0404",
          "449-0402",
          "449-0405",
          "449-0403",
          "431-4121",
          "449-0401",
          "514-0000",
          "514-0017",
          "514-1139",
          "514-0811",
          "514-0022",
          "514-2302",
          "514-2327",
          "514-2301",
          "514-2303",
          "514-2324",
          "514-2304",
          "514-2323",
          "514-2308",
          "514-2328",
          "514-2311",
          "514-2315",
          "514-2313",
          "514-2305",
          "514-2307",
          "514-2306",
          "514-2325",
          "514-2312",
          "514-2326",
          "514-2322",
          "514-2318",
          "514-2321",
          "514-2317",
          "514-2316",
          "514-2314",
          "514-0131",
          "514-0058",
          "514-0113",
          "514-0061",
          "514-0115",
          "514-0112",
          "514-0111",
          "514-0114",
          "515-2523",
          "515-2525",
          "515-2521",
          "515-2524",
          "515-2514",
          "515-2511",
          "515-2505",
          "515-2501",
          "515-2512",
          "515-2526",
          "515-2502",
          "515-2504",
          "515-2516",
          "515-2513",
          "515-2522",
          "515-2515",
          "515-2503",
          "515-2517",
          "514-0057",
          "514-1252",
          "514-0838",
          "514-0076",
          "514-0001",
          "514-0834",
          "514-0124",
          "514-0125",
          "514-0123",
          "514-0122",
          "514-0126",
          "514-0121",
          "514-0046",
          "514-0007",
          "514-1257",
          "514-0039",
          "514-0016",
          "514-0072",
          "514-0013",
          "514-0082",
          "514-0085",
          "514-0075",
          "514-0083",
          "514-0081",
          "514-0077",
          "514-0074",
          "514-0086",
          "514-0084",
          "514-0054",
          "514-0052",
          "514-0008",
          "514-0806",
          "514-0804",
          "514-0311",
          "514-0326",
          "514-0312",
          "514-0325",
          "514-0324",
          "514-0321",
          "514-0314",
          "514-0323",
          "514-0313",
          "514-0315",
          "514-1122",
          "510-0313",
          "510-0306",
          "510-0304",
          "510-0307",
          "510-0317",
          "510-0312",
          "510-0315",
          "510-0302",
          "510-0308",
          "510-0305",
          "510-0301",
          "510-0314",
          "510-0303",
          "510-0316",
          "510-0311",
          "510-0318",
          "514-0044",
          "514-0062",
          "514-0824",
          "514-0056",
          "514-0023",
          "514-0031",
          "514-0302",
          "514-0301",
          "514-0305",
          "514-0303",
          "514-0304",
          "514-0104",
          "514-0103",
          "514-0102",
          "515-2617",
          "514-2204",
          "514-2212",
          "514-2208",
          "514-2206",
          "514-2213",
          "514-2201",
          "514-2207",
          "514-2205",
          "514-2203",
          "514-2214",
          "514-2202",
          "514-2211",
          "514-0065",
          "514-0006",
          "514-1115",
          "514-0015",
          "514-0835",
          "514-0004",
          "514-1251",
          "514-0047",
          "514-0003",
          "514-0063",
          "514-0002",
          "514-0805",
          "514-0837",
          "514-1255",
          "514-0101",
          "514-0818",
          "514-0024",
          "514-0026",
          "514-0042",
          "514-0012",
          "514-1124",
          "514-0019",
          "514-0801",
          "514-0027",
          "514-0011",
          "514-0819",
          "514-0816",
          "514-0817",
          "514-2221",
          "514-0821",
          "514-0032",
          "514-0812",
          "514-0073",
          "514-2222",
          "514-0005",
          "514-0018",
          "514-1256",
          "514-0064",
          "514-0010",
          "514-0833",
          "514-0038",
          "514-0035",
          "514-1116",
          "514-0051",
          "514-0836",
          "514-0826",
          "514-0053",
          "515-2605",
          "515-2614",
          "515-2616",
          "515-3137",
          "515-2604",
          "515-2624",
          "515-2623",
          "515-2603",
          "515-3132",
          "515-3138",
          "515-2621",
          "515-3139",
          "515-2622",
          "515-2602",
          "515-2615",
          "515-3136",
          "515-3131",
          "515-3135",
          "515-2612",
          "515-3134",
          "515-2601",
          "515-3133",
          "515-2611",
          "515-2613",
          "514-0041",
          "514-0009",
          "514-0823",
          "514-0037",
          "514-0025",
          "514-0028",
          "514-1103",
          "514-1253",
          "514-1114",
          "514-1108",
          "514-1109",
          "514-1105",
          "514-1112",
          "514-1137",
          "514-1111",
          "514-1132",
          "514-1118",
          "514-1106",
          "514-1107",
          "514-1131",
          "514-1121",
          "514-1117",
          "514-1113",
          "514-1134",
          "514-1136",
          "514-1102",
          "514-1135",
          "514-1258",
          "514-1101",
          "514-1104",
          "514-1125",
          "514-1133",
          "514-0814",
          "514-0815",
          "514-1138",
          "514-0831",
          "514-1123",
          "514-0033",
          "514-0036",
          "514-0802",
          "514-0045",
          "514-2106",
          "514-2107",
          "514-2104",
          "514-2105",
          "514-2115",
          "514-2112",
          "514-2101",
          "514-2103",
          "514-2111",
          "514-2102",
          "514-2113",
          "514-2114",
          "515-3533",
          "515-3531",
          "515-3312",
          "515-3532",
          "515-3311",
          "515-3203",
          "515-3534",
          "515-3201",
          "515-3536",
          "515-3313",
          "515-3202",
          "515-3535",
          "515-3421",
          "514-0825",
          "514-0014",
          "514-0822",
          "514-0055",
          "514-0043",
          "514-0832",
          "514-0034",
          "514-1254",
          "514-0803",
          "514-0813",
          "514-0116",
          "514-0021",
          "514-0071",
          "510-0000",
          "510-0044",
          "510-0839",
          "512-8046",
          "510-0826",
          "510-0825",
          "510-0827",
          "512-1202",
          "510-0810",
          "510-0803",
          "510-0053",
          "510-0054",
          "512-1204",
          "512-8055",
          "512-8054",
          "510-0061",
          "510-8001",
          "510-8002",
          "512-0911",
          "510-0832",
          "512-8066",
          "512-8064",
          "510-0828",
          "510-0842",
          "510-0863",
          "512-1302",
          "510-0041",
          "512-0931",
          "512-1101",
          "510-0872",
          "510-0953",
          "510-0954",
          "510-0074",
          "510-0023",
          "512-1206",
          "510-0882",
          "512-1216",
          "510-0866",
          "510-0835",
          "510-0846",
          "512-8053",
          "512-0901",
          "510-0847",
          "510-0003",
          "510-0004",
          "510-8039",
          "510-8034",
          "510-0083",
          "510-0958",
          "510-0952",
          "510-0951",
          "510-0059",
          "510-0875",
          "512-0921",
          "512-1102",
          "510-0956",
          "510-0873",
          "510-0011",
          "510-0014",
          "512-1201",
          "512-8045",
          "510-0853",
          "510-8032",
          "512-0935",
          "512-0934",
          "510-0871",
          "510-0874",
          "510-0033",
          "510-8031",
          "510-0955",
          "510-0098",
          "510-0047",
          "512-1208",
          "510-0062",
          "510-0091",
          "510-0081",
          "512-8051",
          "510-0032",
          "510-0101",
          "510-0107",
          "510-0103",
          "510-0106",
          "510-0105",
          "510-0104",
          "510-0102",
          "510-0072",
          "510-0821",
          "510-0045",
          "512-1207",
          "512-8062",
          "512-0903",
          "512-0902",
          "510-0055",
          "510-0865",
          "510-0946",
          "512-1303",
          "512-0932",
          "510-0069",
          "510-0084",
          "512-0905",
          "512-0908",
          "512-1215",
          "512-1214",
          "512-1213",
          "512-1211",
          "510-0944",
          "512-8056",
          "510-0021",
          "510-0068",
          "510-0851",
          "510-0854",
          "512-1113",
          "510-0822",
          "510-0814",
          "512-1203",
          "510-8033",
          "510-8028",
          "510-0057",
          "510-0867",
          "510-0018",
          "510-0823",
          "510-0829",
          "510-0824",
          "510-0015",
          "510-0064",
          "510-0094",
          "510-0092",
          "510-0024",
          "510-0063",
          "510-8026",
          "512-1105",
          "512-0301",
          "510-0813",
          "510-0807",
          "510-0052",
          "512-0925",
          "510-8003",
          "510-0086",
          "510-0085",
          "512-0922",
          "510-0022",
          "510-8017",
          "510-0857",
          "510-0042",
          "512-0923",
          "510-0945",
          "510-0027",
          "510-0026",
          "512-1301",
          "510-0844",
          "510-0034",
          "510-8038",
          "510-8037",
          "512-1212",
          "510-0051",
          "510-0082",
          "512-8065",
          "512-0924",
          "510-0035",
          "512-1115",
          "510-0025",
          "510-0848",
          "510-0834",
          "510-0883",
          "510-0884",
          "510-0894",
          "510-0892",
          "510-8016",
          "510-8014",
          "510-8004",
          "510-8025",
          "510-8008",
          "510-8007",
          "510-0833",
          "510-0864",
          "510-0048",
          "512-1304",
          "510-0065",
          "510-0096",
          "512-8044",
          "510-0856",
          "510-0812",
          "510-0831",
          "510-0071",
          "512-8052",
          "512-0913",
          "510-0087",
          "510-0058",
          "510-8023",
          "510-8024",
          "510-0073",
          "510-0943",
          "510-0089",
          "510-0837",
          "512-1305",
          "512-1103",
          "510-0815",
          "510-0962",
          "510-0961",
          "510-0963",
          "510-0868",
          "510-0855",
          "510-0947",
          "510-0097",
          "510-0001",
          "510-0012",
          "510-0017",
          "510-0002",
          "510-0016",
          "510-0852",
          "510-0031",
          "510-8009",
          "510-0067",
          "510-0046",
          "510-0804",
          "510-0805",
          "512-0907",
          "512-0904",
          "510-8035",
          "510-8006",
          "510-0941",
          "510-0942",
          "510-8011",
          "510-0885",
          "510-0886",
          "510-0891",
          "512-1205",
          "512-8061",
          "510-0013",
          "510-8005",
          "512-8043",
          "512-8042",
          "510-0007",
          "512-0936",
          "510-0076",
          "510-0806",
          "510-0093",
          "510-0893",
          "510-8022",
          "512-1306",
          "510-8021",
          "510-8015",
          "510-0836",
          "512-0912",
          "512-1104",
          "510-0862",
          "512-0933",
          "510-0841",
          "510-0802",
          "510-0801",
          "510-0006",
          "510-0008",
          "510-0056",
          "510-0971",
          "512-0914",
          "510-8036",
          "510-8013",
          "510-0043",
          "510-0066",
          "510-0838",
          "510-0843",
          "510-0845",
          "510-0811",
          "510-0948",
          "510-8027",
          "510-8012",
          "510-0095",
          "510-0088",
          "510-0957",
          "510-0075",
          "512-8047",
          "510-0861",
          "512-8041",
          "512-8048",
          "512-1111",
          "510-0005",
          "512-0906",
          "512-8063",
          "512-1116",
          "510-0881",
          "512-1114",
          "516-0000",
          "516-0045",
          "517-0081",
          "516-0021",
          "515-0501",
          "516-0054",
          "515-0504",
          "516-0022",
          "516-0075",
          "516-0071",
          "516-0011",
          "516-0037",
          "516-0038",
          "516-0051",
          "516-1104",
          "515-0506",
          "516-0024",
          "516-0023",
          "516-0025",
          "516-0026",
          "516-0062",
          "516-0063",
          "516-1108",
          "516-1101",
          "516-0079",
          "516-0001",
          "516-0036",
          "516-0031",
          "519-0501",
          "519-0507",
          "519-0502",
          "519-0505",
          "519-0504",
          "519-0503",
          "519-0506",
          "515-0508",
          "515-0503",
          "516-0013",
          "516-1107",
          "516-0004",
          "516-0009",
          "516-0052",
          "516-0014",
          "516-0015",
          "516-0018",
          "516-0007",
          "516-0016",
          "516-0027",
          "516-0003",
          "516-0017",
          "516-0035",
          "516-1102",
          "516-0078",
          "516-0005",
          "516-0006",
          "516-0066",
          "516-0046",
          "516-1103",
          "516-0012",
          "516-0041",
          "516-0047",
          "516-0042",
          "516-0067",
          "516-0053",
          "516-0034",
          "516-0028",
          "515-0505",
          "515-0511",
          "515-0509",
          "515-0502",
          "516-0073",
          "516-0043",
          "516-0064",
          "516-0065",
          "519-0608",
          "519-0602",
          "519-0606",
          "519-0609",
          "519-0607",
          "519-0611",
          "519-0601",
          "519-0605",
          "519-0603",
          "519-0604",
          "516-0008",
          "516-0033",
          "516-0074",
          "516-0044",
          "516-0002",
          "516-0803",
          "516-0801",
          "515-0521",
          "516-0806",
          "516-0802",
          "516-0805",
          "516-0804",
          "516-0061",
          "516-0072",
          "516-0077",
          "515-0507",
          "516-0032",
          "516-1105",
          "516-0076",
          "516-1106",
          "515-0000",
          "515-0823",
          "515-0027",
          "515-0004",
          "515-0003",
          "515-0037",
          "515-0007",
          "519-2146",
          "515-0207",
          "515-1505",
          "515-1613",
          "515-1617",
          "515-1616",
          "515-1732",
          "515-1723",
          "515-1722",
          "515-1734",
          "515-1724",
          "515-1504",
          "515-1501",
          "515-1727",
          "515-1506",
          "515-1726",
          "515-1721",
          "515-1733",
          "515-1612",
          "515-1611",
          "515-1503",
          "515-1725",
          "515-1618",
          "515-1731",
          "515-1502",
          "515-1614",
          "515-1615",
          "515-1413",
          "515-1304",
          "515-1411",
          "515-1303",
          "515-1301",
          "515-1412",
          "515-1302",
          "515-0126",
          "519-2145",
          "515-0006",
          "515-0086",
          "515-0113",
          "515-0066",
          "515-0845",
          "515-0213",
          "515-2121",
          "515-0212",
          "515-2412",
          "515-0817",
          "515-0041",
          "515-0082",
          "515-0128",
          "515-0116",
          "515-2413",
          "515-0072",
          "515-2305",
          "515-2351",
          "515-2403",
          "515-2356",
          "515-2405",
          "515-2404",
          "515-2357",
          "515-2401",
          "515-2316",
          "515-2313",
          "515-2311",
          "515-2334",
          "515-2406",
          "515-2315",
          "515-2323",
          "515-2335",
          "515-2301",
          "515-2354",
          "515-2322",
          "515-2331",
          "515-2409",
          "515-2333",
          "515-2332",
          "515-2302",
          "515-2325",
          "515-2321",
          "515-2314",
          "515-2317",
          "515-2352",
          "515-2304",
          "515-2353",
          "515-2312",
          "515-2303",
          "515-2408",
          "515-2402",
          "515-2407",
          "515-2355",
          "515-2324",
          "515-1205",
          "515-2342",
          "515-0114",
          "515-0001",
          "515-0063",
          "515-0813",
          "515-0031",
          "515-2341",
          "515-0804",
          "515-0024",
          "515-1204",
          "515-0831",
          "515-0834",
          "515-1105",
          "515-0076",
          "515-2114",
          "515-0117",
          "515-2109",
          "515-0822",
          "515-0118",
          "515-0033",
          "515-0111",
          "515-2103",
          "515-0078",
          "515-1104",
          "515-0005",
          "519-2141",
          "515-0201",
          "515-2123",
          "515-0818",
          "515-0122",
          "515-0119",
          "515-2113",
          "515-0088",
          "515-0017",
          "515-0018",
          "515-0204",
          "515-0814",
          "515-0044",
          "515-2122",
          "515-0061",
          "515-2343",
          "515-0021",
          "515-0013",
          "515-0053",
          "515-0062",
          "515-0002",
          "515-0064",
          "515-0057",
          "515-2102",
          "515-2104",
          "515-1107",
          "515-0028",
          "515-0071",
          "515-1103",
          "515-0065",
          "515-0203",
          "519-2142",
          "515-0023",
          "515-0043",
          "519-2147",
          "515-0123",
          "515-0074",
          "515-0075",
          "515-0801",
          "515-0022",
          "515-0016",
          "515-0202",
          "515-0039",
          "515-1101",
          "515-0821",
          "515-2112",
          "515-0842",
          "515-0211",
          "515-0104",
          "515-0011",
          "515-0056",
          "515-0054",
          "515-0026",
          "515-0055",
          "515-0032",
          "515-1202",
          "515-0077",
          "515-0019",
          "519-2143",
          "515-0035",
          "515-0811",
          "515-1106",
          "515-0112",
          "515-0073",
          "515-0843",
          "515-0205",
          "515-2124",
          "515-2111",
          "515-0083",
          "515-2115",
          "515-0103",
          "515-0816",
          "515-0833",
          "515-0029",
          "515-2106",
          "515-0815",
          "515-0042",
          "515-0832",
          "515-0848",
          "515-2108",
          "519-2144",
          "515-0217",
          "515-0125",
          "515-0835",
          "515-0051",
          "515-0121",
          "515-0101",
          "515-0012",
          "515-0038",
          "515-0084",
          "515-0036",
          "515-2105",
          "515-1201",
          "515-0846",
          "515-0825",
          "515-0812",
          "515-0824",
          "515-0214",
          "515-0124",
          "515-2101",
          "515-0081",
          "515-2107",
          "515-0045",
          "515-0841",
          "515-0803",
          "515-2133",
          "515-2132",
          "515-0102",
          "519-2148",
          "515-0085",
          "515-0046",
          "515-0034",
          "515-2344",
          "515-0015",
          "515-0216",
          "515-0087",
          "515-0844",
          "515-1102",
          "515-0206",
          "515-0208",
          "515-0052",
          "515-2414",
          "515-0847",
          "515-0215",
          "515-2411",
          "515-0802",
          "515-0115",
          "515-1203",
          "515-2131",
          "515-0127",
          "515-0014",
          "515-0025",
          "511-0000",
          "511-0016",
          "511-0052",
          "511-0817",
          "511-0033",
          "511-0934",
          "511-0935",
          "511-0084",
          "511-0036",
          "511-0838",
          "511-0046",
          "511-0017",
          "511-0006",
          "511-0801",
          "511-0018",
          "511-0086",
          "511-0825",
          "511-0038",
          "511-0822",
          "511-0815",
          "511-0071",
          "511-0022",
          "511-0836",
          "511-0848",
          "511-0947",
          "511-0903",
          "511-0812",
          "511-0861",
          "511-0829",
          "511-0067",
          "511-0047",
          "511-0012",
          "511-0827",
          "511-0081",
          "511-0001",
          "511-0809",
          "511-0044",
          "511-0941",
          "511-0021",
          "511-0802",
          "511-0024",
          "511-0804",
          "511-0073",
          "511-0066",
          "511-0819",
          "511-0851",
          "511-0063",
          "511-0039",
          "511-0810",
          "511-0009",
          "511-0923",
          "511-0837",
          "511-0841",
          "511-0946",
          "511-0061",
          "511-0085",
          "511-0939",
          "511-0813",
          "511-0913",
          "511-0075",
          "511-0007",
          "511-0031",
          "511-0816",
          "511-0824",
          "511-0034",
          "511-0937",
          "511-0936",
          "511-0019",
          "511-0808",
          "511-0846",
          "511-0083",
          "511-0924",
          "511-0855",
          "511-0866",
          "511-0832",
          "511-0064",
          "511-0863",
          "511-0048",
          "511-0043",
          "511-0069",
          "511-0077",
          "511-0004",
          "511-0011",
          "511-0078",
          "511-0041",
          "511-0065",
          "511-0005",
          "511-0834",
          "511-0843",
          "511-0818",
          "511-0828",
          "511-0842",
          "511-0124",
          "511-0116",
          "511-0105",
          "511-0102",
          "511-0113",
          "511-0123",
          "511-0122",
          "511-0117",
          "511-0106",
          "511-0125",
          "511-0103",
          "511-0114",
          "511-0104",
          "511-0111",
          "511-0121",
          "511-0112",
          "511-0118",
          "511-0115",
          "511-0101",
          "511-0089",
          "511-0826",
          "511-0068",
          "511-0058",
          "511-0945",
          "511-0901",
          "511-0072",
          "511-0045",
          "511-0062",
          "511-0015",
          "511-0938",
          "511-1131",
          "511-1135",
          "511-1112",
          "511-1145",
          "511-1113",
          "511-1123",
          "511-1107",
          "511-1148",
          "511-1125",
          "511-1104",
          "511-1111",
          "511-1144",
          "511-1106",
          "511-1101",
          "511-1108",
          "511-1105",
          "511-1142",
          "511-1146",
          "511-1127",
          "511-1103",
          "511-1116",
          "511-1114",
          "511-1115",
          "511-1102",
          "511-1143",
          "511-1149",
          "511-1136",
          "511-1121",
          "511-1147",
          "511-1132",
          "511-1137",
          "511-1126",
          "511-1128",
          "511-1134",
          "511-1122",
          "511-1109",
          "511-1141",
          "511-1133",
          "511-1124",
          "511-0914",
          "511-0864",
          "511-0922",
          "511-0933",
          "511-0054",
          "511-0056",
          "511-0807",
          "511-0911",
          "511-0904",
          "511-0931",
          "511-0944",
          "511-0008",
          "511-0076",
          "511-0049",
          "511-0862",
          "511-0852",
          "511-0811",
          "511-0921",
          "511-0932",
          "511-0003",
          "511-0053",
          "511-0035",
          "511-0055",
          "511-0806",
          "511-0867",
          "511-0942",
          "511-0803",
          "511-0805",
          "511-0847",
          "511-0833",
          "511-0844",
          "511-0002",
          "511-0027",
          "511-0845",
          "511-0865",
          "511-0025",
          "511-0013",
          "511-0912",
          "511-0835",
          "511-0023",
          "511-0831",
          "511-0853",
          "511-0814",
          "511-0902",
          "511-0014",
          "511-0057",
          "511-0088",
          "511-0074",
          "511-0082",
          "511-0026",
          "511-0823",
          "511-0037",
          "511-0943",
          "511-0839",
          "511-0821",
          "511-0051",
          "511-0042",
          "511-0079",
          "511-0032",
          "511-0087",
          "511-0854",
          "513-0000",
          "510-0258",
          "513-0828",
          "513-0802",
          "513-0032",
          "513-0855",
          "513-0012",
          "513-0006",
          "510-0256",
          "510-0255",
          "513-0031",
          "510-0205",
          "510-0206",
          "510-0207",
          "510-0201",
          "510-0204",
          "519-0323",
          "510-0252",
          "513-0018",
          "513-0017",
          "513-0010",
          "510-0231",
          "510-0237",
          "510-0234",
          "519-0313",
          "510-0262",
          "513-0827",
          "519-0311",
          "513-0027",
          "513-0028",
          "519-0316",
          "513-0007",
          "513-0021",
          "513-0004",
          "513-0003",
          "513-0056",
          "513-0055",
          "513-0801",
          "510-0226",
          "513-1121",
          "510-0232",
          "513-0813",
          "513-0049",
          "513-0045",
          "513-0044",
          "510-0221",
          "513-0015",
          "513-0005",
          "513-0023",
          "513-0836",
          "510-0263",
          "513-0013",
          "519-0324",
          "513-0817",
          "513-0806",
          "513-0805",
          "510-0254",
          "510-0253",
          "513-0821",
          "513-1123",
          "513-0052",
          "513-0051",
          "513-1124",
          "513-0833",
          "513-0834",
          "513-0832",
          "513-0831",
          "510-0243",
          "510-0241",
          "510-0242",
          "510-0244",
          "513-0854",
          "513-0822",
          "513-0852",
          "513-0851",
          "513-0853",
          "513-0034",
          "513-0033",
          "510-0208",
          "513-0826",
          "513-0825",
          "513-0019",
          "513-0014",
          "513-0011",
          "513-0025",
          "513-0026",
          "510-0266",
          "513-0002",
          "519-0312",
          "513-0823",
          "513-0824",
          "510-0264",
          "510-0251",
          "513-0037",
          "513-0038",
          "510-0212",
          "510-0236",
          "510-0259",
          "513-0009",
          "513-0054",
          "513-0053",
          "519-0314",
          "513-0042",
          "513-0043",
          "513-0041",
          "519-0271",
          "513-0809",
          "513-0808",
          "513-0815",
          "513-0008",
          "510-0202",
          "510-0216",
          "510-0218",
          "510-0217",
          "510-0219",
          "510-0203",
          "513-0024",
          "513-0022",
          "513-0812",
          "513-0837",
          "513-1122",
          "513-0058",
          "513-0059",
          "510-0211",
          "510-0257",
          "510-0233",
          "519-0272",
          "513-0814",
          "513-0819",
          "513-0844",
          "513-0845",
          "513-0847",
          "513-0846",
          "513-0843",
          "513-0848",
          "513-0835",
          "513-0001",
          "519-0321",
          "510-0261",
          "513-0807",
          "513-0803",
          "513-0804",
          "510-0213",
          "510-0235",
          "513-0816",
          "513-0048",
          "513-0057",
          "513-0046",
          "513-0047",
          "510-0227",
          "519-0322",
          "510-0265",
          "513-0818",
          "513-0811",
          "513-0036",
          "513-0035",
          "513-0016",
          "519-0315",
          "513-0842",
          "513-0841",
          "510-0224",
          "510-0225",
          "510-0222",
          "510-0223",
          "518-0400",
          "518-0468",
          "518-0464",
          "518-0467",
          "518-0466",
          "518-0465",
          "518-0461",
          "518-0463",
          "518-0469",
          "518-0462",
          "518-0721",
          "518-0737",
          "518-0607",
          "518-0736",
          "518-0716",
          "518-0746",
          "518-0747",
          "518-0748",
          "518-0749",
          "518-0740",
          "518-0741",
          "518-0742",
          "518-0743",
          "518-0744",
          "518-0745",
          "518-0608",
          "518-0733",
          "518-0714",
          "518-0453",
          "518-0454",
          "518-0455",
          "518-0456",
          "518-0457",
          "518-0458",
          "518-0459",
          "518-0613",
          "518-0502",
          "518-0710",
          "518-0412",
          "518-0762",
          "518-0504",
          "518-0771",
          "518-0772",
          "518-0773",
          "518-0774",
          "518-0775",
          "518-0621",
          "518-0622",
          "518-0623",
          "518-0624",
          "518-0625",
          "518-0626",
          "518-0627",
          "518-0628",
          "518-0641",
          "518-0642",
          "518-0643",
          "518-0644",
          "518-0645",
          "518-0646",
          "518-0647",
          "518-0631",
          "518-0632",
          "518-0633",
          "518-0634",
          "518-0723",
          "518-0753",
          "518-0751",
          "518-0752",
          "518-0734",
          "518-0735",
          "518-0701",
          "518-0702",
          "518-0703",
          "518-0704",
          "518-0705",
          "518-0606",
          "518-0719",
          "518-0724",
          "518-0712",
          "518-0604",
          "518-0612",
          "518-0413",
          "518-0739",
          "518-0443",
          "518-0611",
          "518-0727",
          "518-0406",
          "518-0407",
          "518-0408",
          "518-0409",
          "518-0401",
          "518-0402",
          "518-0403",
          "518-0404",
          "518-0405",
          "518-0445",
          "518-0411",
          "518-0431",
          "518-0432",
          "518-0433",
          "518-0434",
          "518-0435",
          "518-0436",
          "518-0437",
          "518-0438",
          "518-0439",
          "518-0430",
          "518-0421",
          "518-0422",
          "518-0423",
          "518-0424",
          "518-0425",
          "518-0426",
          "518-0427",
          "518-0428",
          "518-0442",
          "518-0717",
          "518-0505",
          "518-0501",
          "518-0731",
          "518-0441",
          "518-0609",
          "518-0603",
          "518-0602",
          "518-0711",
          "518-0713",
          "518-0414",
          "518-0415",
          "518-0416",
          "518-0417",
          "518-0418",
          "518-0419",
          "518-0503",
          "518-0728",
          "518-0726",
          "518-0722",
          "518-0732",
          "518-0718",
          "518-0738",
          "518-0755",
          "518-0756",
          "518-0754",
          "518-0601",
          "518-0729",
          "518-0446",
          "518-0444",
          "518-0615",
          "518-0614",
          "518-0610",
          "518-0616",
          "518-0617",
          "518-0618",
          "518-0619",
          "518-0725",
          "518-0763",
          "518-0715",
          "518-0605",
          "518-0481",
          "518-0482",
          "518-0483",
          "518-0484",
          "518-0485",
          "518-0486",
          "518-0471",
          "518-0472",
          "518-0473",
          "518-0474",
          "518-0475",
          "518-0476",
          "518-0477",
          "518-0478",
          "518-0479",
          "518-0761",
          "519-3600",
          "519-3611",
          "519-3646",
          "519-3653",
          "519-3623",
          "519-3642",
          "519-3923",
          "519-3921",
          "519-3640",
          "519-3606",
          "519-3610",
          "519-3609",
          "519-3701",
          "519-3626",
          "519-3658",
          "519-3647",
          "519-3648",
          "519-3652",
          "519-3659",
          "519-3813",
          "519-3618",
          "519-3666",
          "519-3664",
          "519-3620",
          "519-3638",
          "519-3651",
          "519-3421",
          "519-3613",
          "519-3924",
          "519-3615",
          "519-3602",
          "519-3605",
          "519-3639",
          "519-3616",
          "519-3812",
          "519-3614",
          "519-3617",
          "519-3702",
          "519-3612",
          "519-3637",
          "519-3922",
          "519-3619",
          "519-3814",
          "519-3811",
          "519-3604",
          "519-3643",
          "519-3667",
          "519-3656",
          "519-3601",
          "519-3634",
          "519-3663",
          "519-3625",
          "519-3671",
          "519-3673",
          "519-3672",
          "519-3674",
          "519-3621",
          "519-0100",
          "519-0171",
          "519-0223",
          "519-0143",
          "519-0137",
          "519-0131",
          "519-0101",
          "519-0158",
          "519-0112",
          "519-0121",
          "519-0161",
          "519-0167",
          "519-0141",
          "519-1129",
          "519-1122",
          "519-1121",
          "519-1128",
          "519-1126",
          "519-1127",
          "519-1125",
          "519-0163",
          "519-0103",
          "519-0211",
          "519-0115",
          "519-0157",
          "519-0118",
          "519-0117",
          "519-0144",
          "519-0148",
          "519-0113",
          "519-0111",
          "519-0123",
          "519-0133",
          "519-0169",
          "519-0132",
          "519-0162",
          "519-1119",
          "519-1117",
          "519-1103",
          "519-1106",
          "519-1124",
          "519-1108",
          "519-1123",
          "519-1116",
          "519-1102",
          "519-1107",
          "519-1101",
          "519-1104",
          "519-1111",
          "519-1112",
          "519-1114",
          "519-1115",
          "519-1118",
          "519-1113",
          "519-1105",
          "519-0168",
          "519-0119",
          "519-0213",
          "519-0136",
          "519-0214",
          "519-0104",
          "519-0142",
          "519-0134",
          "519-0127",
          "519-0153",
          "519-0159",
          "519-0212",
          "519-0165",
          "519-0146",
          "519-0164",
          "519-0122",
          "519-0125",
          "519-0126",
          "519-0124",
          "519-0166",
          "519-0222",
          "519-0215",
          "519-0221",
          "519-0116",
          "519-0152",
          "519-0181",
          "519-0105",
          "519-0135",
          "519-0106",
          "519-0114",
          "519-0154",
          "519-0156",
          "519-0155",
          "519-0147",
          "519-0151",
          "519-0145",
          "519-0102",
          "517-0000",
          "517-0033",
          "517-0021",
          "517-0012",
          "517-0026",
          "517-0041",
          "517-0025",
          "517-0022",
          "517-0023",
          "517-0032",
          "517-0015",
          "517-0014",
          "517-0035",
          "517-0001",
          "517-0031",
          "517-0044",
          "517-0005",
          "517-0046",
          "517-0043",
          "517-0004",
          "517-0034",
          "517-0024",
          "517-0002",
          "517-0011",
          "517-0045",
          "517-0042",
          "517-0003",
          "517-0013",
          "517-0047",
          "519-4300",
          "519-4561",
          "519-4566",
          "519-4563",
          "519-4562",
          "519-4564",
          "519-4565",
          "519-4206",
          "519-4325",
          "519-4446",
          "519-4448",
          "519-4447",
          "519-4445",
          "519-4449",
          "519-4675",
          "519-4673",
          "519-4671",
          "519-4672",
          "519-4674",
          "519-4321",
          "519-4324",
          "519-4322",
          "519-4327",
          "519-4442",
          "519-4444",
          "519-4441",
          "519-4443",
          "519-4323",
          "519-5404",
          "519-5413",
          "519-5412",
          "519-5415",
          "519-5411",
          "647-1321",
          "519-5417",
          "519-5414",
          "647-1322",
          "519-5401",
          "519-5403",
          "519-5402",
          "519-5405",
          "519-5406",
          "519-5416",
          "647-1325",
          "647-1323",
          "647-1324",
          "519-4326",
          "519-4201",
          "519-4203",
          "519-4204",
          "519-4207",
          "519-4202",
          "519-4205",
          "511-0200",
          "511-0204",
          "511-0201",
          "511-0206",
          "511-0224",
          "511-0217",
          "511-0214",
          "511-0205",
          "511-0207",
          "511-0223",
          "511-0213",
          "511-0221",
          "511-0202",
          "511-0225",
          "511-0203",
          "511-0208",
          "511-0215",
          "511-0212",
          "511-0211",
          "511-0216",
          "511-0222",
          "511-0267",
          "511-0276",
          "511-0264",
          "511-0266",
          "511-0265",
          "511-0286",
          "511-0285",
          "511-0284",
          "511-0282",
          "511-0274",
          "511-0271",
          "511-0272",
          "511-0287",
          "511-0275",
          "511-0261",
          "511-0262",
          "511-0263",
          "511-0273",
          "511-0283",
          "511-0281",
          "511-0514",
          "511-0511",
          "511-0507",
          "511-0517",
          "511-0501",
          "511-0502",
          "511-0504",
          "511-0518",
          "511-0522",
          "511-0503",
          "511-0513",
          "511-0512",
          "511-0515",
          "511-0506",
          "511-0516",
          "511-0505",
          "511-0508",
          "511-0521",
          "511-0519",
          "511-0523",
          "511-0524",
          "511-0428",
          "511-0416",
          "511-0427",
          "511-0425",
          "511-0435",
          "511-0437",
          "511-0401",
          "511-0422",
          "511-0411",
          "511-0404",
          "511-0406",
          "511-0418",
          "511-0436",
          "511-0417",
          "511-0402",
          "511-0426",
          "511-0405",
          "511-0421",
          "511-0433",
          "511-0414",
          "511-0403",
          "511-0413",
          "511-0438",
          "511-0415",
          "511-0432",
          "511-0423",
          "511-0434",
          "511-0431",
          "511-0424",
          "511-0412",
          "517-0500",
          "517-0507",
          "517-0501",
          "517-0506",
          "517-0505",
          "517-0504",
          "517-0502",
          "517-0503",
          "517-0213",
          "517-0206",
          "517-0209",
          "517-0208",
          "517-0202",
          "517-0216",
          "517-0201",
          "517-0212",
          "517-0211",
          "517-0207",
          "517-0218",
          "517-0214",
          "517-0215",
          "517-0204",
          "517-0203",
          "517-0217",
          "517-0205",
          "517-0701",
          "517-0705",
          "517-0704",
          "517-0702",
          "517-0703",
          "517-0601",
          "517-0603",
          "517-0602",
          "517-0604",
          "517-0402",
          "517-0405",
          "517-0403",
          "517-0404",
          "517-0401",
          "518-0000",
          "519-1413",
          "518-0226",
          "518-0227",
          "518-0114",
          "518-1316",
          "518-0818",
          "518-1323",
          "518-0008",
          "518-1407",
          "518-0205",
          "518-0123",
          "518-0003",
          "518-0102",
          "518-0101",
          "518-0026",
          "518-0859",
          "518-0871",
          "518-0846",
          "518-0853",
          "518-0852",
          "518-0865",
          "518-0841",
          "518-0864",
          "518-0862",
          "518-0838",
          "518-0832",
          "518-0842",
          "518-0872",
          "518-0874",
          "518-0866",
          "518-0858",
          "518-0857",
          "518-0854",
          "518-0877",
          "518-0863",
          "518-0839",
          "518-0847",
          "518-0851",
          "518-0856",
          "518-0869",
          "518-0878",
          "518-0848",
          "518-0868",
          "518-0831",
          "518-0849",
          "518-0861",
          "518-0867",
          "518-0873",
          "518-0875",
          "518-0855",
          "518-0112",
          "519-1403",
          "518-1321",
          "518-1314",
          "518-0219",
          "518-0034",
          "518-1317",
          "518-1154",
          "518-0017",
          "518-0033",
          "518-0223",
          "518-0106",
          "518-0103",
          "518-0211",
          "518-1427",
          "518-0825",
          "518-1324",
          "518-0815",
          "518-0122",
          "518-0224",
          "518-1403",
          "518-1143",
          "519-1415",
          "518-0203",
          "518-1153",
          "518-1412",
          "518-0116",
          "518-0125",
          "518-1303",
          "518-0814",
          "518-0121",
          "518-1315",
          "518-1307",
          "518-0218",
          "518-1425",
          "519-1425",
          "519-1424",
          "518-0845",
          "518-0204",
          "519-1423",
          "519-1422",
          "518-0225",
          "518-0215",
          "518-0843",
          "518-1147",
          "518-1404",
          "518-0214",
          "519-1406",
          "518-0809",
          "518-0108",
          "518-1429",
          "518-0012",
          "518-0001",
          "518-0823",
          "518-0035",
          "519-1711",
          "519-1707",
          "519-1706",
          "519-1701",
          "519-1705",
          "519-1708",
          "519-1702",
          "519-1704",
          "519-1703",
          "518-1416",
          "518-0206",
          "518-0111",
          "518-0124",
          "519-1412",
          "518-1305",
          "518-0817",
          "518-1141",
          "518-1151",
          "519-1416",
          "518-0104",
          "518-0021",
          "518-1319",
          "518-0002",
          "518-1401",
          "518-0216",
          "518-0005",
          "518-0812",
          "518-0201",
          "519-1411",
          "518-0217",
          "518-1312",
          "518-1322",
          "518-0032",
          "519-1402",
          "518-0015",
          "518-0004",
          "518-0222",
          "518-1424",
          "518-1417",
          "518-0011",
          "518-0822",
          "518-0031",
          "519-1404",
          "518-1304",
          "518-0816",
          "518-1428",
          "518-1406",
          "518-0014",
          "518-0025",
          "519-1426",
          "518-0027",
          "518-1301",
          "518-0023",
          "519-1405",
          "518-1318",
          "518-0813",
          "518-1311",
          "518-1408",
          "518-1155",
          "518-0007",
          "518-0006",
          "518-1313",
          "518-0013",
          "518-0024",
          "518-1144",
          "518-1302",
          "518-0105",
          "518-0107",
          "518-0115",
          "519-1401",
          "518-1422",
          "518-0807",
          "518-0826",
          "518-0808",
          "518-0827",
          "518-0830",
          "518-0828",
          "518-0820",
          "518-0810",
          "518-0802",
          "518-0801",
          "518-0829",
          "518-0804",
          "518-1426",
          "518-0212",
          "518-0113",
          "518-0821",
          "518-1142",
          "518-0221",
          "518-1405",
          "518-0811",
          "518-0036",
          "518-1326",
          "518-1414",
          "518-1325",
          "518-0022",
          "519-1414",
          "518-0834",
          "518-0837",
          "518-0833",
          "518-0836",
          "518-0835",
          "518-1421",
          "518-0202",
          "518-0824",
          "518-0126",
          "518-0213",
          "518-0016",
          "518-1145",
          "519-1421",
          "518-0844",
          "518-0127",
          "518-1306",
          "518-0131",
          "518-1146",
          "518-0840",
          "518-1152",
          "498-0803",
          "498-0808",
          "498-0823",
          "498-0801",
          "498-0810",
          "498-0818",
          "498-0802",
          "498-0822",
          "498-0816",
          "498-0804",
          "498-0805",
          "498-0811",
          "498-0821",
          "498-0824",
          "498-0806",
          "498-0819",
          "498-0813",
          "498-0812",
          "498-0807",
          "498-0815",
          "498-0817",
          "498-0814",
          "511-0243",
          "511-0244",
          "511-0257",
          "511-0251",
          "511-0232",
          "511-0231",
          "511-0233",
          "511-0252",
          "511-0253",
          "511-0241",
          "511-0254",
          "511-0255",
          "511-0245",
          "511-0256",
          "511-0242",
          "510-1200",
          "510-1221",
          "510-1253",
          "510-1222",
          "510-1246",
          "510-1243",
          "510-1242",
          "510-1241",
          "510-1244",
          "510-1245",
          "510-1323",
          "510-1252",
          "510-1231",
          "510-1224",
          "510-1328",
          "510-1233",
          "510-1325",
          "510-1225",
          "510-1232",
          "510-1326",
          "510-1223",
          "510-1321",
          "510-1322",
          "510-1312",
          "510-1324",
          "510-1251",
          "510-1311",
          "510-1327",
          "510-1236",
          "510-1234",
          "510-1235",
          "510-1226",
          "510-8104",
          "510-8102",
          "510-8103",
          "510-8105",
          "510-8107",
          "510-8106",
          "510-8101",
          "510-8113",
          "510-8114",
          "510-8112",
          "510-8125",
          "510-8121",
          "510-8111",
          "510-8122",
          "510-8123",
          "510-8124",
          "519-2100",
          "519-2151",
          "519-2215",
          "519-2158",
          "519-2186",
          "519-2159",
          "519-2181",
          "519-2167",
          "519-2182",
          "519-2152",
          "519-2162",
          "519-2203",
          "519-2201",
          "519-2214",
          "519-2187",
          "519-2177",
          "519-2153",
          "519-2174",
          "519-2157",
          "519-2185",
          "519-2184",
          "519-2212",
          "519-2172",
          "519-2183",
          "519-2202",
          "519-2154",
          "519-2165",
          "519-2213",
          "519-2189",
          "519-2161",
          "519-2211",
          "519-2156",
          "519-2171",
          "519-2179",
          "519-2166",
          "519-2176",
          "519-2204",
          "519-2155",
          "519-2178",
          "519-2216",
          "519-2175",
          "519-2188",
          "519-2164",
          "519-2163",
          "519-2173",
          "515-0300",
          "515-0317",
          "515-0312",
          "515-0322",
          "515-0316",
          "515-0332",
          "515-0301",
          "515-0302",
          "515-0349",
          "515-0341",
          "515-0324",
          "515-0321",
          "515-0333",
          "515-0331",
          "515-0347",
          "515-0314",
          "515-0325",
          "515-0345",
          "515-0343",
          "515-0348",
          "515-0334",
          "515-0353",
          "515-0351",
          "515-0311",
          "515-0346",
          "515-0342",
          "515-0315",
          "515-0313",
          "515-0352",
          "515-0303",
          "515-0354",
          "515-0344",
          "515-0323",
          "519-2400",
          "519-2428",
          "519-2506",
          "519-2631",
          "519-2505",
          "519-2518",
          "519-2413",
          "519-2634",
          "519-2522",
          "519-2427",
          "519-2411",
          "519-2425",
          "519-2502",
          "519-2403",
          "519-2516",
          "519-2412",
          "519-2632",
          "519-2512",
          "519-2633",
          "519-2515",
          "519-2507",
          "519-2524",
          "519-2504",
          "519-2523",
          "519-2404",
          "519-2426",
          "519-2501",
          "519-2402",
          "519-2423",
          "519-2511",
          "519-2421",
          "519-2513",
          "519-2429",
          "519-2525",
          "519-2424",
          "519-2401",
          "519-2503",
          "519-2517",
          "519-2521",
          "519-2514",
          "519-2405",
          "519-2422",
          "519-0400",
          "519-0403",
          "519-0425",
          "519-0428",
          "519-0406",
          "519-0422",
          "519-0433",
          "519-0431",
          "519-0417",
          "519-0411",
          "519-0408",
          "519-0414",
          "519-0416",
          "519-0401",
          "519-0407",
          "519-0415",
          "519-0434",
          "519-0412",
          "519-0437",
          "519-0421",
          "519-0426",
          "519-0404",
          "519-0432",
          "519-0438",
          "519-0405",
          "519-0423",
          "519-0427",
          "519-0413",
          "519-0402",
          "519-0435",
          "519-0424",
          "519-0436",
          "516-2100",
          "516-1242",
          "516-2106",
          "516-2102",
          "516-1236",
          "516-2112",
          "516-1245",
          "516-1231",
          "516-2101",
          "516-1232",
          "516-1237",
          "516-1247",
          "516-1235",
          "516-2116",
          "516-2119",
          "516-2111",
          "516-2118",
          "516-2107",
          "516-2103",
          "516-2113",
          "516-2114",
          "516-1238",
          "516-2115",
          "516-2108",
          "516-1234",
          "516-1233",
          "516-2105",
          "516-2117",
          "516-2104",
          "516-1244",
          "516-1241",
          "516-1243",
          "516-1246",
          "519-2700",
          "519-2704",
          "519-2736",
          "519-2734",
          "519-3111",
          "519-2801",
          "519-2733",
          "519-2735",
          "519-2802",
          "519-2703",
          "519-2911",
          "519-2732",
          "519-2731",
          "519-2701",
          "519-2702",
          "516-0100",
          "516-1305",
          "516-0103",
          "516-0112",
          "516-0118",
          "516-1302",
          "516-1304",
          "516-1532",
          "516-0115",
          "516-1422",
          "516-0106",
          "516-0102",
          "516-1421",
          "516-0101",
          "516-1534",
          "516-0104",
          "516-0113",
          "516-0117",
          "516-1536",
          "516-0105",
          "516-0221",
          "516-1306",
          "516-0222",
          "516-1535",
          "516-1309",
          "516-1533",
          "516-0111",
          "516-0108",
          "516-1308",
          "516-1307",
          "516-0116",
          "516-0114",
          "516-0107",
          "516-0109",
          "516-1531",
          "516-1301",
          "516-1303",
          "516-1423",
          "519-3400",
          "519-3406",
          "519-3401",
          "519-3414",
          "519-3202",
          "519-3407",
          "519-3206",
          "519-3403",
          "519-3402",
          "519-3412",
          "519-3203",
          "519-3201",
          "519-3411",
          "519-3207",
          "519-3404",
          "519-3205",
          "519-3204",
          "519-3413",
          "519-3408",
          "519-3405",
          "519-3209",
          "519-3208",
          "519-3415",
          "519-5200",
          "519-5204",
          "519-5322",
          "519-5206",
          "519-5325",
          "519-5211",
          "519-5327",
          "519-5326",
          "519-5201",
          "519-5321",
          "519-5203",
          "519-5202",
          "519-5324",
          "519-5323",
          "519-5205",
          "519-5700",
          "519-5718",
          "519-5711",
          "519-5834",
          "519-5701",
          "519-5835",
          "519-5716",
          "519-5831",
          "519-5712",
          "519-5832",
          "519-5717",
          "519-5715",
          "519-5713",
          "519-5833",
          "519-5714",
          "520-0000",
          "520-2101",
          "520-0864",
          "520-0003",
          "520-0822",
          "520-0533",
          "520-0052",
          "520-0114",
          "520-0513",
          "520-0832",
          "520-0356",
          "520-0352",
          "520-0362",
          "520-0363",
          "520-0351",
          "520-0361",
          "520-0355",
          "520-0354",
          "520-0353",
          "520-0827",
          "520-2272",
          "520-0805",
          "520-0869",
          "520-0860",
          "520-0868",
          "520-0861",
          "520-0866",
          "520-2153",
          "520-2271",
          "520-0065",
          "520-0241",
          "520-0806",
          "520-0051",
          "520-2275",
          "520-0064",
          "520-0054",
          "520-0025",
          "520-2267",
          "520-2261",
          "520-2265",
          "520-2263",
          "520-2264",
          "520-2262",
          "520-2266",
          "520-2141",
          "520-2144",
          "520-0247",
          "520-0245",
          "520-0246",
          "520-0248",
          "520-0062",
          "520-2118",
          "520-0867",
          "520-0101",
          "520-0107",
          "520-0053",
          "520-0525",
          "520-0031",
          "520-0036",
          "520-0012",
          "520-0055",
          "520-0243",
          "520-0473",
          "520-0477",
          "520-0478",
          "520-0476",
          "520-0472",
          "520-0471",
          "520-0475",
          "520-0474",
          "520-2161",
          "520-2167",
          "520-2165",
          "520-2166",
          "520-2164",
          "520-2163",
          "520-2162",
          "520-0061",
          "520-2143",
          "520-0106",
          "520-0851",
          "520-0013",
          "520-0032",
          "520-0843",
          "520-0501",
          "520-0503",
          "520-0514",
          "520-0244",
          "520-0812",
          "520-0044",
          "520-2111",
          "520-2151",
          "520-0527",
          "520-2279",
          "520-0224",
          "520-0844",
          "520-0821",
          "520-0532",
          "520-0035",
          "520-0834",
          "520-0103",
          "520-0037",
          "520-0002",
          "520-0855",
          "520-0113",
          "520-0116",
          "520-0816",
          "520-0026",
          "520-2276",
          "520-2131",
          "520-0006",
          "520-2117",
          "520-0042",
          "520-0105",
          "520-2135",
          "520-0817",
          "520-0015",
          "520-2115",
          "520-2132",
          "520-0531",
          "520-0056",
          "520-0836",
          "520-0225",
          "520-0833",
          "520-0227",
          "520-2277",
          "520-0815",
          "520-0825",
          "520-0823",
          "520-0824",
          "520-2134",
          "520-2123",
          "520-2124",
          "520-2121",
          "520-2125",
          "520-2122",
          "520-0028",
          "520-0863",
          "520-0842",
          "520-2278",
          "520-0512",
          "520-0033",
          "520-0005",
          "520-0803",
          "520-0852",
          "520-2142",
          "520-2145",
          "520-0111",
          "520-0023",
          "520-0066",
          "520-0043",
          "520-2152",
          "520-0826",
          "520-2116",
          "520-0854",
          "520-0837",
          "520-2114",
          "520-0046",
          "520-0865",
          "520-0871",
          "520-0801",
          "520-0027",
          "520-0818",
          "520-0021",
          "520-0102",
          "520-2133",
          "520-2273",
          "520-0001",
          "520-0515",
          "520-0222",
          "520-0047",
          "520-0041",
          "520-0802",
          "520-0016",
          "520-0104",
          "520-0856",
          "520-0112",
          "520-0862",
          "520-2113",
          "520-0067",
          "520-0846",
          "520-0045",
          "520-0835",
          "520-0853",
          "520-0242",
          "520-0814",
          "520-2112",
          "520-2102",
          "520-0831",
          "520-0807",
          "520-0024",
          "520-0232",
          "520-0234",
          "520-0235",
          "520-0236",
          "520-0233",
          "520-0231",
          "520-0813",
          "520-0034",
          "520-0841",
          "520-0004",
          "520-0223",
          "520-0221",
          "520-0502",
          "520-0011",
          "520-0018",
          "520-0511",
          "520-0516",
          "520-0057",
          "520-0804",
          "520-2274",
          "520-0022",
          "520-0014",
          "520-0038",
          "520-0017",
          "520-0357",
          "520-0115",
          "520-0811",
          "520-0226",
          "520-0063",
          "520-0845",
          "520-0524",
          "520-0529",
          "520-0521",
          "520-0528",
          "520-0526",
          "520-0522",
          "520-0523",
          "522-0000",
          "522-0073",
          "529-1152",
          "522-0065",
          "521-1101",
          "521-1125",
          "521-1111",
          "521-1113",
          "522-0236",
          "522-0239",
          "522-0045",
          "522-0010",
          "522-0034",
          "522-0026",
          "522-0053",
          "522-0017",
          "522-0037",
          "522-0001",
          "522-0005",
          "521-1121",
          "522-0056",
          "529-1155",
          "521-1112",
          "521-1115",
          "521-1131",
          "521-1103",
          "521-1143",
          "522-0223",
          "522-0083",
          "522-0046",
          "522-0081",
          "529-1156",
          "522-0088",
          "522-0043",
          "521-1141",
          "522-0012",
          "522-0238",
          "522-0231",
          "522-0086",
          "522-0061",
          "522-0235",
          "522-0021",
          "522-0066",
          "522-0019",
          "521-1147",
          "522-0022",
          "522-0075",
          "522-0006",
          "522-0029",
          "521-1132",
          "521-1102",
          "521-1142",
          "522-0011",
          "522-0015",
          "522-0024",
          "522-0068",
          "521-1135",
          "521-1136",
          "522-0085",
          "522-0058",
          "522-0033",
          "522-0031",
          "522-0087",
          "522-0032",
          "522-0014",
          "529-1153",
          "522-0074",
          "522-0201",
          "522-0044",
          "522-0062",
          "521-1134",
          "521-1105",
          "529-1154",
          "522-0063",
          "522-0233",
          "522-0212",
          "521-1104",
          "522-0214",
          "522-0042",
          "522-0009",
          "522-0004",
          "522-0051",
          "522-0013",
          "522-0067",
          "522-0052",
          "522-0054",
          "522-0089",
          "522-0213",
          "522-0038",
          "529-1151",
          "522-0221",
          "522-0055",
          "522-0025",
          "522-0036",
          "521-1124",
          "522-0084",
          "522-0057",
          "521-1126",
          "522-0023",
          "522-0069",
          "522-0027",
          "521-1114",
          "521-1123",
          "522-0047",
          "522-0041",
          "521-1144",
          "522-0018",
          "522-0016",
          "522-0072",
          "522-0007",
          "522-0211",
          "522-0237",
          "521-1133",
          "522-0064",
          "522-0002",
          "521-1122",
          "522-0059",
          "522-0222",
          "521-1145",
          "522-0003",
          "522-0035",
          "522-0071",
          "522-0234",
          "522-0082",
          "522-0008",
          "521-1146",
          "522-0232",
          "522-0039",
          "526-0000",
          "526-0222",
          "526-0056",
          "526-0126",
          "526-0274",
          "526-0814",
          "526-0003",
          "526-0051",
          "526-0133",
          "526-0816",
          "526-0233",
          "526-0806",
          "526-0211",
          "526-0244",
          "526-0275",
          "526-0264",
          "526-0833",
          "526-0805",
          "529-0113",
          "526-0043",
          "526-0066",
          "526-0207",
          "526-0834",
          "526-0115",
          "526-0832",
          "526-0054",
          "526-0251",
          "526-0205",
          "529-0301",
          "529-0312",
          "529-0311",
          "529-0304",
          "526-0102",
          "526-0243",
          "526-0221",
          "526-0811",
          "529-0131",
          "526-0204",
          "526-0827",
          "526-0828",
          "526-0042",
          "526-0068",
          "526-0804",
          "526-0015",
          "526-0122",
          "529-0101",
          "526-0846",
          "526-0111",
          "526-0265",
          "526-0061",
          "526-0231",
          "526-0214",
          "526-0272",
          "526-0057",
          "529-0435",
          "529-0421",
          "529-0412",
          "529-0431",
          "529-0415",
          "529-0403",
          "529-0401",
          "529-0414",
          "529-0434",
          "529-0425",
          "529-0426",
          "529-0413",
          "529-0402",
          "529-0404",
          "529-0423",
          "529-0432",
          "529-0422",
          "529-0433",
          "529-0541",
          "529-0437",
          "529-0424",
          "529-0411",
          "529-0436",
          "526-0202",
          "526-0001",
          "526-0014",
          "526-0262",
          "526-0826",
          "526-0065",
          "526-0132",
          "526-0206",
          "526-0134",
          "526-0004",
          "529-0333",
          "529-0342",
          "529-0332",
          "529-0361",
          "529-0313",
          "529-0365",
          "529-0367",
          "529-0366",
          "529-0343",
          "529-0364",
          "529-0321",
          "529-0316",
          "529-0322",
          "529-0352",
          "529-0334",
          "529-0345",
          "529-0353",
          "529-0362",
          "529-0314",
          "529-0335",
          "529-0341",
          "529-0303",
          "529-0315",
          "529-0346",
          "529-0344",
          "529-0354",
          "529-0317",
          "529-0331",
          "529-0363",
          "526-0845",
          "529-0141",
          "526-0263",
          "529-0121",
          "526-0235",
          "526-0055",
          "526-0817",
          "526-0036",
          "526-0044",
          "526-0047",
          "526-0005",
          "526-0123",
          "529-0302",
          "526-0016",
          "526-0121",
          "526-0823",
          "529-0133",
          "526-0013",
          "526-0012",
          "526-0011",
          "526-0052",
          "526-0241",
          "529-0122",
          "526-0063",
          "526-0277",
          "526-0017",
          "526-0234",
          "526-0103",
          "526-0256",
          "526-0254",
          "529-0351",
          "526-0213",
          "529-0144",
          "526-0216",
          "526-0037",
          "529-0222",
          "529-0203",
          "529-0212",
          "529-0251",
          "529-0232",
          "529-0215",
          "529-0234",
          "529-0272",
          "529-0205",
          "529-0271",
          "529-0275",
          "529-0241",
          "529-0221",
          "529-0233",
          "529-0253",
          "529-0273",
          "529-0262",
          "529-0265",
          "529-0252",
          "529-0202",
          "529-0261",
          "529-0263",
          "529-0204",
          "529-0211",
          "529-0214",
          "529-0223",
          "529-0274",
          "529-0213",
          "529-0231",
          "529-0264",
          "529-0201",
          "526-0046",
          "526-0273",
          "526-0201",
          "526-0276",
          "529-0142",
          "526-0271",
          "526-0829",
          "526-0801",
          "529-0102",
          "526-0112",
          "526-0209",
          "526-0045",
          "526-0215",
          "526-0212",
          "526-0064",
          "526-0822",
          "526-0131",
          "529-0132",
          "529-0103",
          "526-0114",
          "526-0022",
          "526-0824",
          "526-0225",
          "526-0108",
          "526-0841",
          "529-0721",
          "529-0714",
          "529-0708",
          "529-0725",
          "529-0704",
          "529-0701",
          "529-0707",
          "529-0722",
          "529-0726",
          "529-0712",
          "529-0723",
          "529-0703",
          "529-0713",
          "529-0702",
          "529-0711",
          "529-0724",
          "529-0715",
          "529-0706",
          "529-0705",
          "529-0123",
          "526-0227",
          "526-0803",
          "526-0101",
          "526-0246",
          "526-0255",
          "526-0208",
          "526-0107",
          "526-0217",
          "526-0203",
          "526-0266",
          "526-0106",
          "526-0236",
          "526-0815",
          "526-0124",
          "526-0842",
          "526-0226",
          "526-0802",
          "526-0224",
          "526-0035",
          "526-0033",
          "526-0253",
          "526-0825",
          "526-0025",
          "526-0002",
          "526-0223",
          "526-0105",
          "526-0812",
          "526-0813",
          "526-0821",
          "529-0143",
          "526-0125",
          "529-0111",
          "526-0104",
          "526-0242",
          "526-0023",
          "526-0024",
          "526-0067",
          "526-0232",
          "526-0843",
          "526-0058",
          "526-0032",
          "526-0844",
          "526-0113",
          "526-0831",
          "529-0112",
          "526-0053",
          "526-0835",
          "526-0059",
          "526-0018",
          "526-0116",
          "526-0252",
          "526-0034",
          "526-0847",
          "526-0257",
          "526-0021",
          "526-0031",
          "526-0135",
          "526-0245",
          "529-0536",
          "529-0535",
          "529-0534",
          "529-0503",
          "529-0502",
          "529-0505",
          "529-0512",
          "529-0523",
          "529-0526",
          "529-0522",
          "529-0514",
          "529-0521",
          "529-0537",
          "529-0511",
          "529-0513",
          "529-0504",
          "529-0532",
          "529-0531",
          "529-0515",
          "529-0501",
          "529-0527",
          "529-0525",
          "529-0524",
          "529-0533",
          "529-0506",
          "526-0041",
          "526-0267",
          "526-0261",
          "526-0062",
          "523-0000",
          "523-0836",
          "523-0052",
          "523-0817",
          "521-1331",
          "521-1333",
          "521-1342",
          "521-1341",
          "521-1321",
          "521-1343",
          "521-1346",
          "521-1345",
          "521-1311",
          "521-1351",
          "521-1301",
          "521-1344",
          "521-1334",
          "521-1332",
          "521-1322",
          "523-0045",
          "523-0823",
          "523-0043",
          "523-0877",
          "523-0866",
          "523-0865",
          "523-0864",
          "523-0885",
          "523-0851",
          "523-0015",
          "523-0046",
          "523-0026",
          "523-0895",
          "523-0869",
          "523-0868",
          "523-0867",
          "523-0061",
          "523-0832",
          "523-0837",
          "523-0071",
          "523-0042",
          "523-0801",
          "523-0811",
          "523-0064",
          "523-0856",
          "523-0875",
          "523-0874",
          "523-0852",
          "523-0833",
          "523-0058",
          "523-0047",
          "523-0884",
          "523-0087",
          "523-0806",
          "523-0883",
          "523-0023",
          "523-0003",
          "523-0083",
          "523-0001",
          "523-0881",
          "523-0893",
          "523-0076",
          "523-0843",
          "523-0842",
          "523-0841",
          "523-0044",
          "523-0804",
          "523-0063",
          "523-0873",
          "523-0024",
          "523-0803",
          "523-0032",
          "523-0825",
          "523-0081",
          "523-0025",
          "523-0871",
          "523-0074",
          "523-0005",
          "523-0812",
          "523-0863",
          "523-0862",
          "523-0861",
          "523-0016",
          "523-0824",
          "523-0802",
          "523-0891",
          "523-0896",
          "523-0897",
          "523-0898",
          "523-0821",
          "523-0036",
          "523-0057",
          "523-0872",
          "523-0831",
          "523-0013",
          "523-0021",
          "523-0808",
          "523-0086",
          "523-0082",
          "523-0827",
          "523-0892",
          "523-0011",
          "523-0041",
          "523-0807",
          "523-0849",
          "523-0848",
          "523-0847",
          "523-0894",
          "523-0855",
          "523-0854",
          "523-0853",
          "523-0014",
          "523-0886",
          "523-0835",
          "523-0816",
          "523-0813",
          "523-0819",
          "523-0818",
          "523-0887",
          "523-0004",
          "523-0002",
          "523-0075",
          "523-0846",
          "523-0845",
          "523-0844",
          "523-0857",
          "523-0027",
          "523-0834",
          "523-0037",
          "523-0035",
          "523-0889",
          "523-0033",
          "523-0084",
          "523-0822",
          "523-0056",
          "523-0031",
          "523-0876",
          "523-0072",
          "523-0888",
          "523-0053",
          "523-0022",
          "523-0062",
          "523-0805",
          "523-0048",
          "523-0085",
          "523-0814",
          "523-0828",
          "523-0012",
          "523-0073",
          "523-0882",
          "523-0054",
          "523-0051",
          "523-0826",
          "523-0055",
          "523-0815",
          "523-0034",
          "525-0000",
          "525-0041",
          "525-0002",
          "525-0015",
          "525-0012",
          "525-0047",
          "525-0048",
          "525-0032",
          "525-0044",
          "525-0001",
          "525-0072",
          "525-0011",
          "525-0028",
          "525-0004",
          "525-0021",
          "525-0022",
          "525-0016",
          "525-0061",
          "525-0051",
          "525-0034",
          "525-0036",
          "525-0014",
          "525-0057",
          "525-0005",
          "525-0006",
          "525-0026",
          "525-0029",
          "525-0007",
          "525-0013",
          "525-0067",
          "525-0003",
          "525-0037",
          "525-0035",
          "525-0025",
          "525-0052",
          "525-0059",
          "525-0055",
          "525-0058",
          "525-0027",
          "525-0065",
          "525-0043",
          "525-0033",
          "525-0054",
          "525-0023",
          "525-0024",
          "525-0064",
          "525-0056",
          "525-0071",
          "525-0050",
          "525-0063",
          "525-0053",
          "525-0066",
          "525-0062",
          "525-0042",
          "525-0045",
          "525-0031",
          "524-0000",
          "524-0061",
          "524-0035",
          "524-0016",
          "524-0014",
          "524-0036",
          "524-0011",
          "524-0046",
          "524-0101",
          "524-0037",
          "524-0042",
          "524-0054",
          "524-0032",
          "524-0004",
          "524-0041",
          "524-0045",
          "524-0001",
          "524-0002",
          "524-0104",
          "524-0211",
          "524-0215",
          "524-0013",
          "524-0055",
          "524-0213",
          "524-0062",
          "524-0103",
          "524-0052",
          "524-0214",
          "524-0031",
          "524-0034",
          "524-0003",
          "524-0212",
          "524-0012",
          "524-0033",
          "524-0043",
          "524-0044",
          "524-0063",
          "524-0102",
          "524-0051",
          "524-0064",
          "524-0022",
          "524-0015",
          "524-0065",
          "524-0053",
          "524-0021",
          "520-3000",
          "520-3003",
          "520-3015",
          "520-3044",
          "520-3006",
          "520-3046",
          "520-3012",
          "520-3024",
          "520-3016",
          "520-3033",
          "520-3004",
          "520-3022",
          "520-3032",
          "520-3014",
          "520-3002",
          "520-3037",
          "520-3034",
          "520-3011",
          "520-3026",
          "520-3036",
          "520-3045",
          "520-3042",
          "520-3041",
          "520-3047",
          "520-3025",
          "520-3027",
          "520-3021",
          "520-3043",
          "520-3001",
          "520-3031",
          "520-3023",
          "520-3005",
          "520-3013",
          "520-3035",
          "520-3017",
          "528-0000",
          "520-3413",
          "520-3412",
          "520-3401",
          "520-3421",
          "520-3414",
          "520-3433",
          "520-3415",
          "520-3431",
          "520-3405",
          "520-3427",
          "520-3411",
          "520-3402",
          "520-3423",
          "520-3435",
          "520-3404",
          "520-3434",
          "520-3424",
          "520-3432",
          "520-3426",
          "520-3403",
          "520-3436",
          "520-3425",
          "520-3422",
          "520-3302",
          "520-3312",
          "520-3316",
          "520-3321",
          "520-3303",
          "520-3333",
          "520-3332",
          "520-3326",
          "520-3306",
          "520-3315",
          "520-3304",
          "520-3313",
          "520-3314",
          "520-3301",
          "520-3305",
          "520-3307",
          "520-3308",
          "520-3331",
          "520-3322",
          "520-3323",
          "520-3325",
          "520-3324",
          "520-3311",
          "529-1811",
          "529-1833",
          "529-1832",
          "529-1841",
          "529-1802",
          "529-1812",
          "529-1842",
          "529-1834",
          "529-1814",
          "529-1821",
          "529-1804",
          "529-1835",
          "529-1851",
          "529-1831",
          "529-1813",
          "529-1836",
          "529-1803",
          "529-1843",
          "529-1801",
          "528-0204",
          "528-0202",
          "528-0233",
          "528-0207",
          "528-0201",
          "528-0213",
          "528-0221",
          "528-0235",
          "528-0211",
          "528-0208",
          "528-0203",
          "528-0223",
          "528-0205",
          "528-0234",
          "528-0231",
          "528-0224",
          "528-0222",
          "528-0232",
          "528-0212",
          "528-0206",
          "528-0012",
          "528-0071",
          "528-0072",
          "528-0033",
          "528-0056",
          "528-0002",
          "528-0047",
          "528-0055",
          "528-0052",
          "528-0045",
          "528-0053",
          "528-0022",
          "528-0065",
          "528-0004",
          "528-0058",
          "528-0051",
          "528-0057",
          "528-0049",
          "528-0017",
          "528-0073",
          "528-0054",
          "528-0061",
          "528-0062",
          "528-0046",
          "528-0040",
          "528-0063",
          "528-0015",
          "528-0028",
          "528-0027",
          "528-0007",
          "528-0038",
          "528-0016",
          "528-0043",
          "528-0011",
          "528-0048",
          "528-0001",
          "528-0024",
          "528-0035",
          "528-0025",
          "528-0034",
          "528-0021",
          "528-0066",
          "528-0064",
          "528-0036",
          "528-0026",
          "528-0068",
          "528-0031",
          "528-0023",
          "528-0074",
          "528-0020",
          "528-0005",
          "528-0029",
          "528-0013",
          "528-0041",
          "528-0042",
          "528-0069",
          "528-0037",
          "528-0006",
          "528-0032",
          "528-0067",
          "528-0044",
          "528-0014",
          "528-0003",
          "520-2300",
          "524-0202",
          "520-2411",
          "520-2362",
          "520-2414",
          "520-2312",
          "520-2324",
          "520-2313",
          "520-2343",
          "520-2435",
          "520-2316",
          "524-0203",
          "520-2305",
          "520-2321",
          "520-2361",
          "520-2436",
          "520-2431",
          "520-2353",
          "520-2331",
          "520-2424",
          "520-2314",
          "520-2364",
          "520-2437",
          "520-2301",
          "520-2333",
          "520-2417",
          "520-2415",
          "520-2302",
          "520-2365",
          "520-2363",
          "520-2315",
          "520-2416",
          "520-2351",
          "520-2352",
          "520-2303",
          "520-2311",
          "520-2304",
          "520-2423",
          "520-2421",
          "520-2434",
          "520-2422",
          "520-2323",
          "520-2322",
          "520-2332",
          "520-2432",
          "520-2342",
          "520-2433",
          "520-2341",
          "524-0201",
          "520-2413",
          "520-2412",
          "520-3200",
          "520-3251",
          "520-3116",
          "520-3101",
          "520-3109",
          "520-3113",
          "520-3114",
          "520-3106",
          "520-3105",
          "520-3107",
          "520-3115",
          "520-3108",
          "520-3252",
          "520-3254",
          "520-3214",
          "520-3245",
          "520-3213",
          "520-3104",
          "520-3241",
          "520-3233",
          "520-3237",
          "520-3212",
          "520-3244",
          "520-3201",
          "520-3253",
          "520-3211",
          "520-3234",
          "520-3223",
          "520-3121",
          "520-3202",
          "520-3231",
          "520-3203",
          "520-3255",
          "520-3111",
          "520-3232",
          "520-3235",
          "520-3103",
          "520-3242",
          "520-3246",
          "520-3248",
          "520-3247",
          "520-3112",
          "520-3221",
          "520-3215",
          "520-3102",
          "520-3222",
          "520-3216",
          "520-1100",
          "520-1221",
          "520-1224",
          "520-1201",
          "520-1231",
          "520-1232",
          "520-1213",
          "520-1223",
          "520-1202",
          "520-1214",
          "520-1217",
          "520-1216",
          "520-1211",
          "520-1205",
          "520-1204",
          "520-1212",
          "520-1215",
          "520-1203",
          "520-1233",
          "520-1222",
          "520-1235",
          "520-1234",
          "520-1647",
          "520-1621",
          "520-1654",
          "520-1635",
          "520-1634",
          "520-1602",
          "520-1613",
          "520-1653",
          "520-1642",
          "520-1603",
          "520-1632",
          "520-1651",
          "520-1612",
          "520-1633",
          "520-1646",
          "520-1623",
          "520-1648",
          "520-1644",
          "520-1622",
          "520-1631",
          "520-1604",
          "520-1655",
          "520-1611",
          "520-1601",
          "520-1652",
          "520-1636",
          "520-1643",
          "520-1641",
          "520-1605",
          "520-1645",
          "520-1614",
          "520-1122",
          "520-1131",
          "520-1121",
          "520-1111",
          "520-1133",
          "520-1451",
          "520-1411",
          "520-1401",
          "520-1421",
          "520-1413",
          "520-1453",
          "520-1442",
          "520-1423",
          "520-1443",
          "520-1415",
          "520-1455",
          "520-1433",
          "520-1431",
          "520-1452",
          "520-1425",
          "520-1444",
          "520-1454",
          "520-1412",
          "520-1422",
          "520-1441",
          "520-1432",
          "520-1414",
          "520-1424",
          "520-1143",
          "520-1142",
          "520-1123",
          "520-1531",
          "520-1501",
          "520-1512",
          "520-1521",
          "520-1532",
          "520-1522",
          "520-1502",
          "520-1503",
          "520-1533",
          "520-1511",
          "520-1141",
          "520-1112",
          "520-1102",
          "520-1132",
          "520-1144",
          "520-1801",
          "520-1835",
          "520-1804",
          "520-1824",
          "520-1811",
          "520-1831",
          "520-1803",
          "520-1821",
          "520-1805",
          "520-1832",
          "520-1837",
          "520-1822",
          "520-1813",
          "520-1814",
          "520-1826",
          "520-1834",
          "520-1823",
          "520-1812",
          "520-1802",
          "520-1833",
          "520-1836",
          "520-1825",
          "520-1806",
          "520-1103",
          "520-1101",
          "527-0000",
          "527-0166",
          "527-0232",
          "527-0039",
          "527-0164",
          "521-1202",
          "527-0113",
          "527-0054",
          "527-0171",
          "527-0222",
          "527-0227",
          "529-1501",
          "527-0151",
          "529-1533",
          "529-1531",
          "529-1537",
          "529-1532",
          "527-0074",
          "527-0224",
          "527-0226",
          "529-1561",
          "521-1223",
          "521-1235",
          "527-0216",
          "527-0107",
          "527-0016",
          "527-0053",
          "521-1211",
          "527-0071",
          "527-0162",
          "529-1522",
          "527-0156",
          "527-0175",
          "527-0055",
          "527-0211",
          "527-0212",
          "527-0114",
          "527-0126",
          "529-1512",
          "527-0174",
          "527-0155",
          "527-0063",
          "527-0057",
          "521-1204",
          "527-0034",
          "527-0165",
          "527-0122",
          "521-1241",
          "527-0091",
          "521-1221",
          "527-0083",
          "527-0032",
          "529-1566",
          "529-1503",
          "529-1523",
          "527-0062",
          "527-0173",
          "529-1535",
          "527-0082",
          "527-0086",
          "527-0221",
          "527-0142",
          "529-1514",
          "529-1521",
          "529-1504",
          "529-1541",
          "527-0208",
          "529-1571",
          "527-0041",
          "521-1203",
          "527-0101",
          "527-0145",
          "527-0129",
          "521-1232",
          "527-0111",
          "527-0138",
          "521-1234",
          "527-0202",
          "529-1562",
          "527-0205",
          "527-0215",
          "521-1243",
          "521-1245",
          "527-0121",
          "527-0092",
          "527-0214",
          "529-1536",
          "529-1425",
          "529-1444",
          "529-1401",
          "529-1435",
          "529-1423",
          "529-1422",
          "529-1411",
          "529-1441",
          "529-1443",
          "529-1433",
          "529-1415",
          "529-1405",
          "529-1402",
          "529-1445",
          "529-1432",
          "529-1421",
          "529-1442",
          "529-1414",
          "529-1403",
          "529-1434",
          "529-1424",
          "529-1413",
          "529-1431",
          "529-1412",
          "527-0125",
          "527-0044",
          "527-0108",
          "527-0031",
          "527-0027",
          "529-1572",
          "529-1511",
          "521-1215",
          "521-1222",
          "527-0209",
          "527-0064",
          "527-0067",
          "527-0066",
          "529-1524",
          "527-0132",
          "527-0124",
          "527-0115",
          "527-0157",
          "527-0085",
          "527-0065",
          "527-0128",
          "527-0131",
          "527-0017",
          "521-1201",
          "521-1213",
          "527-0225",
          "527-0043",
          "529-1534",
          "527-0038",
          "527-0036",
          "527-0106",
          "527-0163",
          "527-0154",
          "527-0152",
          "521-1205",
          "529-1513",
          "521-1244",
          "527-0223",
          "527-0207",
          "527-0002",
          "527-0007",
          "527-0003",
          "527-0004",
          "527-0001",
          "527-0006",
          "527-0005",
          "521-1212",
          "521-1214",
          "527-0052",
          "527-0061",
          "527-0042",
          "529-1565",
          "527-0133",
          "527-0123",
          "527-0105",
          "527-0161",
          "527-0015",
          "527-0084",
          "527-0045",
          "527-0172",
          "527-0014",
          "527-0137",
          "527-0228",
          "527-0093",
          "527-0072",
          "527-0076",
          "521-1231",
          "527-0047",
          "527-0051",
          "521-1224",
          "527-0037",
          "527-0033",
          "527-0013",
          "527-0035",
          "527-0141",
          "527-0144",
          "527-0143",
          "527-0153",
          "527-0087",
          "529-1502",
          "527-0134",
          "527-0102",
          "527-0201",
          "521-1242",
          "527-0081",
          "527-0024",
          "527-0073",
          "527-0204",
          "527-0056",
          "527-0075",
          "527-0127",
          "521-1233",
          "527-0112",
          "527-0136",
          "527-0203",
          "529-1564",
          "529-1551",
          "529-1404",
          "527-0046",
          "527-0231",
          "521-1225",
          "527-0206",
          "527-0103",
          "527-0028",
          "527-0022",
          "527-0018",
          "527-0026",
          "527-0011",
          "527-0021",
          "527-0025",
          "527-0012",
          "527-0019",
          "527-0023",
          "527-0029",
          "527-0135",
          "529-1563",
          "527-0104",
          "527-0213",
          "521-0000",
          "521-0001",
          "521-0226",
          "521-0211",
          "521-0063",
          "521-0091",
          "521-0221",
          "521-0004",
          "521-0225",
          "521-0031",
          "521-0234",
          "521-0311",
          "521-0003",
          "521-0312",
          "521-0062",
          "521-0013",
          "521-0014",
          "521-0307",
          "521-0214",
          "521-0324",
          "521-0244",
          "521-0202",
          "521-0219",
          "521-0305",
          "521-0002",
          "521-0033",
          "521-0227",
          "521-0021",
          "521-0217",
          "521-0203",
          "521-0308",
          "521-0303",
          "521-0301",
          "521-0072",
          "521-0092",
          "521-0232",
          "521-0035",
          "521-0032",
          "521-0218",
          "521-0306",
          "521-0016",
          "521-0034",
          "521-0327",
          "521-0083",
          "521-0314",
          "521-0216",
          "521-0245",
          "521-0322",
          "521-0321",
          "521-0074",
          "521-0081",
          "521-0201",
          "521-0093",
          "521-0326",
          "521-0222",
          "521-0213",
          "521-0242",
          "521-0061",
          "521-0011",
          "521-0024",
          "521-0241",
          "521-0084",
          "521-0233",
          "521-0082",
          "521-0236",
          "521-0025",
          "521-0022",
          "521-0325",
          "521-0071",
          "521-0224",
          "521-0212",
          "521-0012",
          "521-0015",
          "521-0302",
          "521-0243",
          "521-0073",
          "521-0023",
          "521-0231",
          "521-0323",
          "521-0223",
          "521-0313",
          "521-0235",
          "521-0215",
          "521-0304",
          "521-0064",
          "529-1600",
          "529-1661",
          "529-1655",
          "529-1648",
          "529-1644",
          "529-1605",
          "529-1603",
          "529-1608",
          "529-1616",
          "529-1610",
          "529-1626",
          "529-1631",
          "529-1632",
          "529-1613",
          "529-1602",
          "529-1622",
          "529-1663",
          "529-1607",
          "529-1636",
          "529-1623",
          "529-1642",
          "529-1654",
          "529-1615",
          "529-1652",
          "529-1621",
          "529-1625",
          "529-1619",
          "529-1643",
          "529-1633",
          "529-1645",
          "529-1612",
          "529-1611",
          "529-1606",
          "529-1657",
          "529-1618",
          "529-1662",
          "529-1617",
          "529-1609",
          "529-1658",
          "529-1628",
          "529-1627",
          "529-1646",
          "529-1665",
          "529-1635",
          "529-1614",
          "529-1641",
          "529-1624",
          "529-1647",
          "529-1656",
          "529-1601",
          "529-1653",
          "529-1634",
          "529-1604",
          "529-1651",
          "529-1664",
          "520-2500",
          "520-2524",
          "520-2522",
          "520-2562",
          "520-2541",
          "520-2552",
          "520-2573",
          "520-2512",
          "520-2504",
          "520-2521",
          "520-2551",
          "520-2563",
          "520-2503",
          "520-2513",
          "520-2502",
          "520-2561",
          "520-2523",
          "520-2572",
          "520-2571",
          "520-2514",
          "520-2511",
          "520-2564",
          "520-2542",
          "520-2531",
          "520-2501",
          "529-1300",
          "529-1234",
          "529-1311",
          "529-1313",
          "529-1207",
          "529-1331",
          "529-1231",
          "529-1213",
          "529-1206",
          "529-1204",
          "529-1203",
          "529-1324",
          "529-1205",
          "529-1312",
          "529-1302",
          "529-1222",
          "529-1315",
          "529-1225",
          "529-1211",
          "529-1223",
          "529-1221",
          "529-1232",
          "529-1208",
          "529-1325",
          "529-1321",
          "529-1314",
          "529-1224",
          "529-1303",
          "529-1237",
          "529-1227",
          "529-1323",
          "529-1233",
          "529-1322",
          "529-1236",
          "529-1202",
          "529-1226",
          "529-1214",
          "529-1235",
          "529-1212",
          "529-1301",
          "529-1228",
          "529-1201",
          "529-1100",
          "529-1163",
          "529-1171",
          "529-1172",
          "529-1169",
          "529-1176",
          "529-1166",
          "529-1175",
          "529-1161",
          "529-1174",
          "529-1167",
          "529-1173",
          "529-1168",
          "529-1162",
          "529-1164",
          "529-1177",
          "529-1165",
          "522-0200",
          "522-0242",
          "522-0254",
          "522-0261",
          "522-0252",
          "522-0251",
          "522-0241",
          "522-0243",
          "522-0244",
          "522-0271",
          "522-0253",
          "522-0263",
          "522-0262",
          "522-0300",
          "522-0317",
          "522-0323",
          "522-0304",
          "522-0315",
          "522-0331",
          "522-0321",
          "522-0333",
          "522-0301",
          "522-0324",
          "522-0356",
          "522-0352",
          "522-0316",
          "522-0305",
          "522-0311",
          "522-0325",
          "522-0322",
          "522-0343",
          "522-0314",
          "522-0326",
          "522-0318",
          "522-0313",
          "522-0341",
          "522-0353",
          "522-0354",
          "522-0338",
          "522-0337",
          "522-0355",
          "522-0336",
          "522-0332",
          "522-0303",
          "522-0342",
          "522-0335",
          "522-0312",
          "522-0334",
          "522-0327",
          "522-0302",
          "522-0319",
          "522-0351",
          "522-0306",
          "603-0000",
          "603-8136",
          "603-8134",
          "603-8135",
          "603-8133",
          "603-8481",
          "603-8482",
          "603-8483",
          "603-8488",
          "603-8487",
          "603-8457",
          "603-8458",
          "603-8477",
          "603-8401",
          "603-8408",
          "603-8831",
          "603-8475",
          "603-8407",
          "603-8472",
          "603-8461",
          "603-8462",
          "603-8463",
          "603-8478",
          "603-8838",
          "603-8441",
          "603-8834",
          "603-8837",
          "603-8404",
          "603-8405",
          "603-8835",
          "603-8444",
          "603-8471",
          "603-8432",
          "603-8406",
          "603-8833",
          "603-8431",
          "603-8437",
          "603-8832",
          "603-8402",
          "603-8476",
          "603-8403",
          "603-8473",
          "603-8479",
          "603-8474",
          "601-0142",
          "601-0141",
          "601-0143",
          "601-0144",
          "601-0145",
          "601-0134",
          "601-0133",
          "601-0131",
          "601-0132",
          "601-0135",
          "603-8012",
          "603-8034",
          "603-8018",
          "603-8035",
          "603-8044",
          "603-8061",
          "603-8066",
          "603-8043",
          "603-8056",
          "603-8017",
          "603-8063",
          "603-8053",
          "603-8033",
          "603-8087",
          "603-8073",
          "603-8037",
          "603-8082",
          "603-8081",
          "603-8038",
          "603-8013",
          "603-8071",
          "603-8006",
          "603-8007",
          "603-8041",
          "603-8002",
          "603-8051",
          "603-8016",
          "603-8054",
          "603-8014",
          "603-8001",
          "603-8064",
          "603-8085",
          "603-8055",
          "603-8072",
          "603-8084",
          "603-8027",
          "603-8045",
          "603-8075",
          "603-8008",
          "603-8032",
          "603-8024",
          "603-8026",
          "603-8011",
          "603-8028",
          "603-8036",
          "603-8021",
          "603-8042",
          "603-8003",
          "603-8023",
          "603-8022",
          "603-8015",
          "603-8077",
          "603-8025",
          "603-8005",
          "603-8052",
          "603-8065",
          "603-8046",
          "603-8074",
          "603-8086",
          "603-8083",
          "603-8031",
          "603-8047",
          "603-8062",
          "603-8076",
          "603-8004",
          "603-8147",
          "603-8155",
          "603-8325",
          "603-8324",
          "603-8326",
          "603-8327",
          "603-8323",
          "603-8486",
          "603-8315",
          "603-8351",
          "603-8372",
          "603-8451",
          "603-8316",
          "603-8373",
          "603-8376",
          "603-8485",
          "603-8378",
          "603-8363",
          "603-8374",
          "603-8375",
          "603-8377",
          "603-8456",
          "603-8366",
          "603-8454",
          "603-8362",
          "603-8371",
          "603-8455",
          "603-8453",
          "603-8484",
          "603-8452",
          "603-8361",
          "603-8861",
          "603-8862",
          "603-8863",
          "603-8137",
          "603-8341",
          "603-8342",
          "603-8125",
          "603-8126",
          "603-8131",
          "603-8171",
          "603-8121",
          "603-8143",
          "603-8161",
          "603-8142",
          "603-8103",
          "603-8124",
          "603-8132",
          "603-8173",
          "603-8123",
          "603-8151",
          "603-8156",
          "603-8167",
          "603-8141",
          "603-8105",
          "603-8148",
          "603-8113",
          "603-8172",
          "603-8122",
          "603-8162",
          "603-8104",
          "603-8144",
          "603-8111",
          "603-8145",
          "603-8163",
          "603-8149",
          "603-8112",
          "603-8152",
          "603-8207",
          "603-8179",
          "603-8117",
          "603-8423",
          "603-8421",
          "603-8411",
          "603-8102",
          "603-8108",
          "603-8101",
          "603-8116",
          "603-8427",
          "603-8433",
          "603-8416",
          "603-8435",
          "603-8178",
          "603-8114",
          "603-8424",
          "603-8422",
          "603-8412",
          "603-8106",
          "603-8107",
          "603-8115",
          "603-8425",
          "603-8206",
          "603-8426",
          "603-8414",
          "603-8204",
          "603-8417",
          "603-8436",
          "603-8415",
          "603-8205",
          "603-8443",
          "603-8442",
          "603-8208",
          "603-8434",
          "603-8413",
          "603-8203",
          "603-8202",
          "603-8201",
          "603-8139",
          "603-8146",
          "601-0111",
          "601-0113",
          "601-0112",
          "603-8336",
          "603-8332",
          "603-8335",
          "603-8334",
          "603-8331",
          "603-8333",
          "603-8337",
          "603-8493",
          "603-8446",
          "603-8468",
          "603-8447",
          "603-8448",
          "603-8464",
          "603-8466",
          "603-8469",
          "603-8465",
          "603-8492",
          "603-8445",
          "603-8491",
          "603-8494",
          "603-8467",
          "603-8154",
          "603-8153",
          "603-8138",
          "603-8346",
          "603-8347",
          "603-8354",
          "603-8343",
          "603-8344",
          "601-0125",
          "601-0122",
          "601-0124",
          "601-0123",
          "601-0121",
          "603-8804",
          "603-8842",
          "603-8828",
          "603-8813",
          "603-8844",
          "603-8807",
          "603-8821",
          "603-8852",
          "603-8805",
          "603-8822",
          "603-8802",
          "603-8817",
          "603-8841",
          "603-8816",
          "603-8847",
          "603-8811",
          "603-8801",
          "603-8853",
          "603-8836",
          "603-8845",
          "603-8846",
          "603-8815",
          "603-8854",
          "603-8823",
          "603-8803",
          "603-8855",
          "603-8848",
          "603-8826",
          "603-8856",
          "603-8825",
          "603-8806",
          "603-8827",
          "603-8843",
          "603-8824",
          "603-8814",
          "603-8812",
          "603-8851",
          "603-8353",
          "603-8355",
          "603-8364",
          "603-8321",
          "603-8345",
          "603-8356",
          "603-8352",
          "603-8365",
          "603-8357",
          "603-8322",
          "601-0102",
          "601-0101",
          "603-8243",
          "603-8242",
          "603-8214",
          "603-8311",
          "603-8166",
          "603-8211",
          "603-8221",
          "603-8176",
          "603-8236",
          "603-8217",
          "603-8177",
          "603-8237",
          "603-8301",
          "603-8227",
          "603-8304",
          "603-8313",
          "603-8213",
          "603-8222",
          "603-8175",
          "603-8235",
          "603-8215",
          "603-8174",
          "603-8234",
          "603-8303",
          "603-8212",
          "603-8247",
          "603-8231",
          "603-8312",
          "603-8165",
          "603-8246",
          "603-8314",
          "603-8233",
          "603-8224",
          "603-8226",
          "603-8245",
          "603-8302",
          "603-8164",
          "603-8241",
          "603-8232",
          "603-8223",
          "603-8228",
          "603-8244",
          "603-8305",
          "603-8225",
          "603-8158",
          "603-8157",
          "603-8216",
          "602-0000",
          "602-0827",
          "602-8278",
          "602-0054",
          "602-0923",
          "602-8165",
          "602-8424",
          "602-0803",
          "602-8074",
          "602-8472",
          "602-0064",
          "602-8121",
          "602-8407",
          "602-8226",
          "602-8297",
          "602-0873",
          "602-8302",
          "602-8335",
          "602-0934",
          "602-0944",
          "602-8345",
          "602-0905",
          "602-8471",
          "602-0824",
          "602-8064",
          "602-8134",
          "602-8103",
          "602-8446",
          "602-8238",
          "602-8352",
          "602-8497",
          "602-8245",
          "602-0066",
          "602-8025",
          "602-8292",
          "602-0906",
          "602-0033",
          "602-8454",
          "602-8104",
          "602-0012",
          "602-0942",
          "602-8477",
          "602-8487",
          "602-8303",
          "602-8485",
          "602-8486",
          "602-0902",
          "602-0031",
          "602-0025",
          "602-8251",
          "602-8032",
          "602-8484",
          "602-8118",
          "602-8307",
          "602-8318",
          "602-8011",
          "602-0921",
          "602-0848",
          "602-0071",
          "602-8405",
          "602-0849",
          "602-8375",
          "602-8413",
          "602-0832",
          "602-0834",
          "602-8376",
          "602-0935",
          "602-0847",
          "602-8363",
          "602-0032",
          "602-0924",
          "602-0825",
          "602-0946",
          "602-8061",
          "602-8203",
          "602-8281",
          "602-8014",
          "602-0841",
          "602-0952",
          "602-8073",
          "602-8311",
          "602-8023",
          "602-8316",
          "602-0855",
          "602-0052",
          "602-8033",
          "602-0804",
          "602-0017",
          "602-0896",
          "602-0894",
          "602-0891",
          "602-0895",
          "602-0024",
          "602-0022",
          "602-0082",
          "602-0815",
          "602-0863",
          "602-8141",
          "602-0813",
          "602-8384",
          "602-0013",
          "602-8272",
          "602-8062",
          "602-0854",
          "602-8284",
          "602-8119",
          "602-8332",
          "602-8369",
          "602-0808",
          "602-8492",
          "602-0903",
          "602-0008",
          "602-8441",
          "602-8385",
          "602-8047",
          "602-8076",
          "602-8244",
          "602-8296",
          "602-8152",
          "602-8432",
          "602-8115",
          "602-0044",
          "602-8308",
          "602-8461",
          "602-0901",
          "602-8252",
          "602-8207",
          "602-8247",
          "602-0092",
          "602-8214",
          "602-0852",
          "602-0056",
          "602-8368",
          "602-8392",
          "602-0818",
          "602-0027",
          "602-8146",
          "602-0851",
          "602-0881",
          "602-8116",
          "602-8476",
          "602-0876",
          "602-8173",
          "602-8127",
          "602-0918",
          "602-8406",
          "602-0002",
          "602-0018",
          "602-0893",
          "602-8428",
          "602-8114",
          "602-0856",
          "602-8267",
          "602-8271",
          "602-0835",
          "602-8132",
          "602-0943",
          "602-8463",
          "602-0945",
          "602-0959",
          "602-8299",
          "602-8275",
          "602-0801",
          "602-0051",
          "602-0904",
          "602-0023",
          "602-8043",
          "602-8013",
          "602-8234",
          "602-8133",
          "602-0821",
          "602-8046",
          "602-8019",
          "602-0047",
          "602-0045",
          "602-8342",
          "602-0872",
          "602-8034",
          "602-0846",
          "602-8157",
          "602-8018",
          "602-8179",
          "602-8151",
          "602-8242",
          "602-8354",
          "602-0814",
          "602-0842",
          "602-8202",
          "602-8304",
          "602-8445",
          "602-0805",
          "602-8453",
          "602-8314",
          "602-8145",
          "602-0826",
          "602-8341",
          "602-0922",
          "602-8333",
          "602-8356",
          "602-8135",
          "602-8056",
          "602-0915",
          "602-8274",
          "602-8358",
          "602-8436",
          "602-8359",
          "602-0059",
          "602-8071",
          "602-8277",
          "602-8438",
          "602-8412",
          "602-8421",
          "602-8225",
          "602-8239",
          "602-8075",
          "602-8204",
          "602-0019",
          "602-0007",
          "602-8372",
          "602-0074",
          "602-0837",
          "602-8365",
          "602-8142",
          "602-8176",
          "602-0839",
          "602-0014",
          "602-0015",
          "602-8265",
          "602-8373",
          "602-8395",
          "602-0811",
          "602-8164",
          "602-8067",
          "602-8155",
          "602-8156",
          "602-8015",
          "602-8474",
          "602-8481",
          "602-8057",
          "602-8348",
          "602-8178",
          "602-8495",
          "602-8494",
          "602-0843",
          "602-0861",
          "602-0892",
          "602-8161",
          "602-0897",
          "602-8381",
          "602-8337",
          "602-0083",
          "602-0866",
          "602-0875",
          "602-0833",
          "602-0845",
          "602-8205",
          "602-8293",
          "602-8409",
          "602-8391",
          "602-8256",
          "602-8257",
          "602-8279",
          "602-0081",
          "602-8382",
          "602-8312",
          "602-8246",
          "602-8483",
          "602-0091",
          "602-8439",
          "602-8262",
          "602-8264",
          "602-8263",
          "602-8222",
          "602-0822",
          "602-8003",
          "602-0006",
          "602-0898",
          "602-0844",
          "602-8482",
          "602-8137",
          "602-8055",
          "602-0003",
          "602-8455",
          "602-8298",
          "602-8323",
          "602-8024",
          "602-0878",
          "602-8052",
          "602-8002",
          "602-8336",
          "602-0001",
          "602-0067",
          "602-8209",
          "602-0912",
          "602-8462",
          "602-8228",
          "602-0955",
          "602-8216",
          "602-0098",
          "602-0099",
          "602-8163",
          "602-8402",
          "602-8286",
          "602-8322",
          "602-8288",
          "602-8177",
          "602-8261",
          "602-0871",
          "602-8224",
          "602-8287",
          "602-8208",
          "602-8053",
          "602-8126",
          "602-8054",
          "602-8315",
          "602-8065",
          "602-8364",
          "602-0038",
          "602-0034",
          "602-8427",
          "602-8077",
          "602-0802",
          "602-0862",
          "602-8215",
          "602-0073",
          "602-0087",
          "602-8105",
          "602-8172",
          "602-8355",
          "602-8254",
          "602-8294",
          "602-8411",
          "602-0004",
          "602-0937",
          "602-0836",
          "602-0932",
          "602-8213",
          "602-0072",
          "602-8218",
          "602-8393",
          "602-0063",
          "602-8147",
          "602-8493",
          "602-0053",
          "602-8131",
          "602-0041",
          "602-8283",
          "602-0857",
          "602-8158",
          "602-8012",
          "602-8353",
          "602-8143",
          "602-0864",
          "602-0093",
          "602-8362",
          "602-8072",
          "602-0958",
          "602-8051",
          "602-8136",
          "602-8469",
          "602-8175",
          "602-8403",
          "602-8237",
          "602-0028",
          "602-8243",
          "602-8437",
          "602-8306",
          "602-8478",
          "602-8383",
          "602-0957",
          "602-8334",
          "602-8042",
          "602-0046",
          "602-8048",
          "602-8361",
          "602-8467",
          "602-0954",
          "602-8414",
          "602-8444",
          "602-8498",
          "602-8326",
          "602-8169",
          "602-8404",
          "602-8004",
          "602-8107",
          "602-8017",
          "602-8109",
          "602-8282",
          "602-8285",
          "602-0925",
          "602-8138",
          "602-0916",
          "602-8434",
          "602-8371",
          "602-8374",
          "602-0956",
          "602-8148",
          "602-0936",
          "602-8491",
          "602-8394",
          "602-8036",
          "602-8301",
          "602-0097",
          "602-0096",
          "602-0828",
          "602-8128",
          "602-8058",
          "602-8344",
          "602-8167",
          "602-8231",
          "602-8106",
          "602-8386",
          "602-8212",
          "602-8123",
          "602-8433",
          "602-8063",
          "602-8273",
          "602-0035",
          "602-0016",
          "602-8037",
          "602-8305",
          "602-0914",
          "602-0948",
          "602-8026",
          "602-8473",
          "602-8295",
          "602-8431",
          "602-8387",
          "602-0951",
          "602-8038",
          "602-8031",
          "602-0858",
          "602-8468",
          "602-8162",
          "602-8416",
          "602-8027",
          "602-8101",
          "602-8377",
          "602-8007",
          "602-0874",
          "602-8102",
          "602-8044",
          "602-8066",
          "602-0917",
          "602-8255",
          "602-0913",
          "602-8346",
          "602-0947",
          "602-8417",
          "602-8317",
          "602-0086",
          "602-0065",
          "602-8236",
          "602-8266",
          "602-8125",
          "602-8451",
          "602-8227",
          "602-0816",
          "602-8325",
          "602-0817",
          "602-8259",
          "602-8235",
          "602-8425",
          "602-8276",
          "602-0037",
          "602-0911",
          "602-8029",
          "602-8166",
          "602-8233",
          "602-0907",
          "602-8291",
          "602-0868",
          "602-8423",
          "602-0807",
          "602-0026",
          "602-8408",
          "602-8313",
          "602-8174",
          "602-0939",
          "602-8168",
          "602-0062",
          "602-8357",
          "602-8496",
          "602-8475",
          "602-8221",
          "602-8232",
          "602-8367",
          "602-0931",
          "602-0057",
          "602-8021",
          "602-0061",
          "602-0812",
          "602-8415",
          "602-0036",
          "602-8488",
          "602-0877",
          "602-8201",
          "602-8111",
          "602-0867",
          "602-8338",
          "602-0819",
          "602-8068",
          "602-8465",
          "602-8139",
          "602-8426",
          "602-0058",
          "602-8319",
          "602-8153",
          "602-8122",
          "602-0941",
          "602-8253",
          "602-8327",
          "602-8108",
          "602-8321",
          "602-8206",
          "602-8248",
          "602-0865",
          "602-8466",
          "602-0055",
          "602-8217",
          "602-0853",
          "602-0005",
          "602-8418",
          "602-0823",
          "602-0933",
          "602-8211",
          "602-0029",
          "602-8435",
          "602-8324",
          "602-8448",
          "602-8001",
          "602-0042",
          "602-0926",
          "602-0938",
          "602-8005",
          "602-8006",
          "602-8452",
          "602-0953",
          "602-8113",
          "602-0043",
          "602-8443",
          "602-8464",
          "602-8124",
          "602-0011",
          "602-8028",
          "602-8447",
          "602-8442",
          "602-8401",
          "602-8241",
          "602-0095",
          "602-0094",
          "602-0021",
          "602-0838",
          "602-8041",
          "602-0806",
          "602-8268",
          "602-8422",
          "602-8171",
          "602-8366",
          "602-8022",
          "602-8449",
          "602-8223",
          "602-8117",
          "602-8112",
          "602-8045",
          "602-8154",
          "602-8347",
          "602-8343",
          "602-0831",
          "602-8016",
          "602-8035",
          "602-8351",
          "602-8331",
          "602-0085",
          "602-0084",
          "602-8258",
          "602-8144",
          "606-0000",
          "606-8371",
          "606-8436",
          "606-8452",
          "606-8443",
          "606-8356",
          "606-8121",
          "606-8182",
          "606-8166",
          "606-8131",
          "606-8173",
          "606-8158",
          "606-8187",
          "606-8133",
          "606-8172",
          "606-8114",
          "606-8161",
          "606-8162",
          "606-8147",
          "606-8157",
          "606-8152",
          "606-8115",
          "606-8117",
          "606-8181",
          "606-8125",
          "606-8141",
          "606-8174",
          "606-8183",
          "606-8185",
          "606-8134",
          "606-8153",
          "606-8176",
          "606-8175",
          "606-8164",
          "606-8144",
          "606-8142",
          "606-8163",
          "606-8127",
          "606-8112",
          "606-8123",
          "606-8171",
          "606-8165",
          "606-8151",
          "606-8132",
          "606-8145",
          "606-8184",
          "606-8136",
          "606-8113",
          "606-8122",
          "606-8177",
          "606-8167",
          "606-8143",
          "606-8124",
          "606-8156",
          "606-8135",
          "606-8186",
          "606-8116",
          "606-8126",
          "606-8154",
          "606-8155",
          "606-8146",
          "601-1124",
          "606-0017",
          "606-0001",
          "606-0004",
          "606-0009",
          "606-0029",
          "606-0010",
          "601-1125",
          "606-0016",
          "606-0013",
          "606-0021",
          "606-0002",
          "606-0018",
          "606-0027",
          "606-0026",
          "606-0025",
          "606-0014",
          "606-0006",
          "606-0011",
          "606-0015",
          "606-0024",
          "606-0007",
          "606-0012",
          "606-0008",
          "606-0005",
          "606-0003",
          "606-0019",
          "606-0028",
          "606-0031",
          "606-0032",
          "606-0023",
          "606-0033",
          "606-0022",
          "606-0034",
          "606-8445",
          "606-8433",
          "606-8376",
          "601-1246",
          "601-1244",
          "601-1243",
          "601-1232",
          "601-1231",
          "601-1248",
          "601-1235",
          "601-1234",
          "601-1241",
          "601-1245",
          "601-1247",
          "601-1233",
          "601-1242",
          "606-8322",
          "606-8344",
          "606-8336",
          "606-8342",
          "606-8415",
          "606-8343",
          "606-8335",
          "606-8351",
          "606-8341",
          "606-8326",
          "606-8332",
          "606-8321",
          "606-8333",
          "606-8334",
          "606-8354",
          "606-0057",
          "606-0041",
          "606-0056",
          "606-0087",
          "606-0088",
          "606-0089",
          "606-0091",
          "606-0062",
          "606-0048",
          "606-0077",
          "606-0075",
          "606-0058",
          "606-0055",
          "606-0084",
          "606-0073",
          "606-0093",
          "606-0072",
          "606-0061",
          "606-0059",
          "606-0036",
          "606-0086",
          "606-0076",
          "606-0053",
          "606-0064",
          "606-0042",
          "606-0047",
          "606-0098",
          "606-0054",
          "606-0092",
          "606-0074",
          "606-0066",
          "606-0063",
          "606-0052",
          "606-0044",
          "606-0037",
          "606-0095",
          "606-0051",
          "606-0082",
          "606-0081",
          "606-0065",
          "606-0078",
          "606-0094",
          "606-0045",
          "606-0043",
          "606-0071",
          "606-0097",
          "606-0083",
          "606-0035",
          "606-0046",
          "606-0096",
          "606-0085",
          "606-0067",
          "601-1255",
          "606-0821",
          "606-0822",
          "606-8364",
          "606-8256",
          "606-8291",
          "606-8271",
          "606-8224",
          "606-8264",
          "606-8292",
          "606-8287",
          "606-8252",
          "606-8275",
          "606-8295",
          "606-8266",
          "606-8455",
          "606-8294",
          "606-8283",
          "606-8284",
          "606-8286",
          "606-8253",
          "606-8274",
          "606-8262",
          "606-8277",
          "606-8282",
          "606-8451",
          "606-8257",
          "606-8255",
          "606-8261",
          "606-8246",
          "606-8267",
          "606-8251",
          "606-8265",
          "606-8285",
          "606-8254",
          "606-8263",
          "606-8244",
          "606-8245",
          "606-8293",
          "606-8276",
          "606-8281",
          "606-8453",
          "606-8454",
          "606-8272",
          "606-8273",
          "606-8352",
          "606-8402",
          "606-8407",
          "520-0465",
          "520-0464",
          "520-0462",
          "520-0461",
          "520-0463",
          "601-1112",
          "601-1113",
          "601-1111",
          "606-8331",
          "606-8365",
          "606-8447",
          "606-8428",
          "606-8422",
          "606-8423",
          "606-8431",
          "606-8442",
          "606-8432",
          "606-8426",
          "606-8441",
          "606-8425",
          "606-8421",
          "606-8427",
          "606-8424",
          "601-1123",
          "601-1121",
          "601-1122",
          "606-0807",
          "606-0834",
          "606-0851",
          "606-0815",
          "606-0812",
          "606-0853",
          "606-0842",
          "606-0831",
          "606-0844",
          "606-0846",
          "606-0813",
          "606-0835",
          "606-0814",
          "606-0803",
          "606-0864",
          "606-0806",
          "606-0856",
          "606-0811",
          "606-0825",
          "606-0861",
          "606-0817",
          "606-0827",
          "606-0826",
          "606-0832",
          "606-0823",
          "606-0852",
          "606-0854",
          "606-0865",
          "606-0855",
          "606-0824",
          "606-0863",
          "606-0866",
          "606-0862",
          "606-0833",
          "606-0816",
          "606-0804",
          "606-0843",
          "606-0841",
          "606-0845",
          "606-0847",
          "606-0801",
          "606-0802",
          "606-0867",
          "606-0805",
          "606-0837",
          "606-0836",
          "606-8396",
          "606-8045",
          "606-8074",
          "606-8042",
          "606-8083",
          "606-8081",
          "606-8021",
          "606-8036",
          "606-8043",
          "606-8065",
          "606-8082",
          "606-8047",
          "606-8026",
          "606-8032",
          "606-8063",
          "606-8086",
          "606-8035",
          "606-8023",
          "606-8024",
          "606-8037",
          "606-8055",
          "606-8022",
          "606-8073",
          "606-8064",
          "606-8075",
          "606-8051",
          "606-8085",
          "606-8031",
          "606-8072",
          "606-8071",
          "606-8044",
          "606-8057",
          "606-8034",
          "606-8041",
          "606-8056",
          "606-8027",
          "606-8062",
          "606-8053",
          "606-8061",
          "606-8046",
          "606-8084",
          "606-8052",
          "606-8054",
          "606-8033",
          "606-8025",
          "606-8353",
          "606-8323",
          "606-8397",
          "606-8392",
          "606-8324",
          "606-8391",
          "606-8394",
          "606-8325",
          "606-8357",
          "606-8406",
          "606-8416",
          "606-8405",
          "606-8401",
          "606-8413",
          "606-8404",
          "606-8414",
          "606-8417",
          "606-8412",
          "606-8411",
          "606-8403",
          "606-8384",
          "606-8375",
          "606-8355",
          "606-8383",
          "606-8386",
          "606-8373",
          "606-8382",
          "606-8111",
          "606-8105",
          "606-8102",
          "606-8104",
          "606-8101",
          "606-8106",
          "606-8103",
          "606-8107",
          "606-8226",
          "606-8202",
          "606-8236",
          "606-8237",
          "606-8215",
          "606-8231",
          "606-8205",
          "606-8233",
          "606-8201",
          "606-8212",
          "606-8227",
          "606-8204",
          "606-8203",
          "606-8242",
          "606-8217",
          "606-8211",
          "606-8241",
          "606-8235",
          "606-8221",
          "606-8213",
          "606-8206",
          "606-8234",
          "606-8243",
          "606-8247",
          "606-8223",
          "606-8222",
          "606-8232",
          "606-8214",
          "606-8216",
          "606-8225",
          "606-8366",
          "606-8381",
          "606-8446",
          "606-8437",
          "606-8434",
          "606-8435",
          "606-8374",
          "606-8444",
          "601-1104",
          "601-1102",
          "601-1105",
          "601-1103",
          "606-8393",
          "606-8395",
          "606-8345",
          "601-1101",
          "606-8361",
          "606-8362",
          "606-8387",
          "606-8385",
          "606-0911",
          "606-0954",
          "606-0931",
          "606-0947",
          "606-0914",
          "606-0936",
          "606-0953",
          "606-0941",
          "606-0937",
          "606-0934",
          "606-0938",
          "606-0952",
          "606-0961",
          "606-0955",
          "606-0956",
          "606-0962",
          "606-0944",
          "606-0967",
          "606-0957",
          "606-0902",
          "606-0916",
          "606-0913",
          "606-0964",
          "606-0966",
          "606-0905",
          "606-0923",
          "606-0935",
          "606-0963",
          "606-0917",
          "606-0906",
          "606-0926",
          "606-0932",
          "606-0903",
          "606-0927",
          "606-0933",
          "606-0951",
          "606-0925",
          "606-0924",
          "606-0901",
          "606-0943",
          "606-0946",
          "606-0942",
          "606-0921",
          "606-0945",
          "606-0922",
          "606-0907",
          "606-0904",
          "606-0965",
          "606-0912",
          "606-0915",
          "606-8346",
          "601-1252",
          "601-1253",
          "601-1251",
          "606-0068",
          "601-1254",
          "606-8007",
          "606-8013",
          "606-8014",
          "606-8005",
          "606-8004",
          "606-8003",
          "606-8002",
          "606-8012",
          "606-8006",
          "606-8011",
          "606-8001",
          "606-8301",
          "606-8302",
          "606-8311",
          "606-8307",
          "606-8312",
          "606-8305",
          "606-8315",
          "606-8304",
          "606-8314",
          "606-8303",
          "606-8306",
          "606-8313",
          "606-8316",
          "606-8317",
          "606-8372",
          "606-8363",
          "604-0000",
          "604-0004",
          "604-0847",
          "604-8074",
          "604-8324",
          "604-8326",
          "604-8327",
          "604-8092",
          "604-8372",
          "604-8273",
          "604-8264",
          "604-8263",
          "604-8063",
          "604-8103",
          "604-8216",
          "604-8302",
          "604-0043",
          "604-8036",
          "604-0996",
          "604-8002",
          "604-0015",
          "604-8066",
          "604-8305",
          "604-0924",
          "604-8146",
          "604-8113",
          "604-8803",
          "604-8802",
          "604-8801",
          "604-8341",
          "604-0984",
          "604-8213",
          "604-8136",
          "604-0905",
          "604-8012",
          "604-0091",
          "604-8057",
          "604-8186",
          "604-8155",
          "604-8041",
          "604-8071",
          "604-8256",
          "604-8252",
          "604-0931",
          "604-8005",
          "604-0813",
          "604-8076",
          "604-8165",
          "604-8174",
          "604-8175",
          "604-8045",
          "604-0942",
          "604-0022",
          "604-0824",
          "604-0092",
          "604-0972",
          "604-0861",
          "604-8182",
          "604-0885",
          "604-0052",
          "604-0042",
          "604-0054",
          "604-8124",
          "604-8304",
          "604-0934",
          "604-8331",
          "604-8126",
          "604-0002",
          "604-8173",
          "604-0801",
          "604-0832",
          "604-8267",
          "604-0964",
          "604-8052",
          "604-8345",
          "604-0031",
          "604-8014",
          "604-8352",
          "604-8114",
          "604-8241",
          "604-8325",
          "604-8001",
          "604-8374",
          "604-8343",
          "604-0923",
          "604-8312",
          "604-0943",
          "604-8323",
          "604-0925",
          "604-0035",
          "604-0025",
          "604-8024",
          "604-0094",
          "604-0865",
          "604-0811",
          "604-0941",
          "604-8253",
          "604-8115",
          "604-8373",
          "604-0827",
          "604-0837",
          "604-0886",
          "604-0821",
          "604-8222",
          "604-0994",
          "604-8154",
          "604-0975",
          "604-8102",
          "604-8127",
          "604-8021",
          "604-0856",
          "604-8105",
          "604-0804",
          "604-8104",
          "604-0961",
          "604-0065",
          "604-0991",
          "604-0846",
          "604-8232",
          "604-0993",
          "604-0883",
          "604-0066",
          "604-8321",
          "604-8185",
          "604-0976",
          "604-8163",
          "604-0825",
          "604-0973",
          "604-8223",
          "604-8026",
          "604-8203",
          "604-0986",
          "604-0866",
          "604-8017",
          "604-8065",
          "604-0881",
          "604-0833",
          "604-8035",
          "604-0983",
          "604-8187",
          "604-0903",
          "604-0095",
          "604-8251",
          "604-8334",
          "604-8336",
          "604-8205",
          "604-8316",
          "604-8277",
          "604-8266",
          "604-8313",
          "604-8314",
          "604-0872",
          "604-0871",
          "604-8135",
          "604-8236",
          "604-8027",
          "604-8247",
          "604-8261",
          "604-8061",
          "604-8162",
          "604-8366",
          "604-8356",
          "604-8254",
          "604-0874",
          "604-0911",
          "604-8335",
          "604-8025",
          "604-8354",
          "604-8355",
          "604-8016",
          "604-0995",
          "604-8085",
          "604-8333",
          "604-0044",
          "604-8091",
          "604-0034",
          "604-0084",
          "604-8006",
          "604-0024",
          "604-0875",
          "604-8121",
          "604-8403",
          "604-8404",
          "604-8402",
          "604-8411",
          "604-8401",
          "604-0036",
          "604-0873",
          "604-0862",
          "604-8246",
          "604-0867",
          "604-0864",
          "604-8075",
          "604-8371",
          "604-0853",
          "604-8207",
          "604-0901",
          "604-0822",
          "604-0913",
          "604-8224",
          "604-8274",
          "604-0951",
          "604-8122",
          "604-8141",
          "604-8262",
          "604-0026",
          "604-0014",
          "604-8031",
          "604-8073",
          "604-8044",
          "604-0071",
          "604-0907",
          "604-8095",
          "604-8315",
          "604-0834",
          "604-0835",
          "604-8056",
          "604-8153",
          "604-0823",
          "604-0021",
          "604-8062",
          "604-8351",
          "604-0802",
          "604-0944",
          "604-0914",
          "604-8176",
          "604-0012",
          "604-0081",
          "604-0005",
          "604-8211",
          "604-0962",
          "604-8322",
          "604-0952",
          "604-0966",
          "604-8311",
          "604-8133",
          "604-0935",
          "604-8271",
          "604-8202",
          "604-8272",
          "604-0055",
          "604-0061",
          "604-8112",
          "604-0814",
          "604-8255",
          "604-8276",
          "604-8152",
          "604-0812",
          "604-8081",
          "604-8221",
          "604-0956",
          "604-0001",
          "604-8134",
          "604-8118",
          "604-8225",
          "604-0915",
          "604-0863",
          "604-0955",
          "604-8171",
          "604-8184",
          "604-8125",
          "604-8004",
          "604-8047",
          "604-0032",
          "604-0086",
          "604-8042",
          "604-8083",
          "604-8094",
          "604-8201",
          "604-0844",
          "604-0076",
          "604-8015",
          "604-8033",
          "604-0854",
          "604-0841",
          "604-0921",
          "604-8142",
          "604-0073",
          "604-0842",
          "604-8363",
          "604-8365",
          "604-8235",
          "604-0851",
          "604-0904",
          "604-8265",
          "604-0063",
          "604-8054",
          "604-0075",
          "604-8226",
          "604-8375",
          "604-8417",
          "604-8492",
          "604-8463",
          "604-8467",
          "604-8414",
          "604-8482",
          "604-8453",
          "604-8484",
          "604-8494",
          "604-8413",
          "604-8462",
          "604-8433",
          "604-8472",
          "604-8405",
          "604-8442",
          "604-8454",
          "604-8383",
          "604-8491",
          "604-8435",
          "604-8496",
          "604-8384",
          "604-8443",
          "604-8436",
          "604-8381",
          "604-8434",
          "604-8474",
          "604-8444",
          "604-8456",
          "604-8425",
          "604-8415",
          "604-8445",
          "604-8461",
          "604-8475",
          "604-8471",
          "604-8421",
          "604-8412",
          "604-8465",
          "604-8423",
          "604-8495",
          "604-8441",
          "604-8452",
          "604-8457",
          "604-8431",
          "604-8446",
          "604-8422",
          "604-8418",
          "604-8437",
          "604-8424",
          "604-8485",
          "604-8455",
          "604-8426",
          "604-8382",
          "604-8416",
          "604-8451",
          "604-8464",
          "604-8466",
          "604-8483",
          "604-8473",
          "604-8432",
          "604-8493",
          "604-8497",
          "604-8481",
          "604-0051",
          "604-0013",
          "604-8301",
          "604-0845",
          "604-0041",
          "604-0023",
          "604-8217",
          "604-0843",
          "604-8257",
          "604-8003",
          "604-8332",
          "604-0033",
          "604-8258",
          "604-8151",
          "604-0072",
          "604-0074",
          "604-0003",
          "604-8172",
          "604-8143",
          "604-0826",
          "604-0922",
          "604-8055",
          "604-0083",
          "604-8183",
          "604-8046",
          "604-0852",
          "604-0906",
          "604-8043",
          "604-0085",
          "604-0855",
          "604-0954",
          "604-0876",
          "604-8131",
          "604-0082",
          "604-0981",
          "604-8023",
          "604-0912",
          "604-8084",
          "604-0882",
          "604-8364",
          "604-0992",
          "604-8234",
          "604-8233",
          "604-8215",
          "604-0985",
          "604-0836",
          "604-8051",
          "604-0045",
          "604-8227",
          "604-0884",
          "604-8082",
          "604-0093",
          "604-0902",
          "604-0963",
          "604-8164",
          "604-8064",
          "604-8117",
          "604-8243",
          "604-0857",
          "604-0096",
          "604-0971",
          "604-8053",
          "604-8111",
          "604-8206",
          "604-8362",
          "604-8034",
          "604-8093",
          "604-0982",
          "604-8013",
          "604-0831",
          "604-8106",
          "604-0077",
          "604-0917",
          "604-8086",
          "604-8132",
          "604-8161",
          "604-8166",
          "604-8147",
          "604-8022",
          "604-8812",
          "604-8874",
          "604-8851",
          "604-8811",
          "604-8872",
          "604-8832",
          "604-8871",
          "604-8861",
          "604-8854",
          "604-8824",
          "604-8822",
          "604-8842",
          "604-8863",
          "604-8821",
          "604-8856",
          "604-8847",
          "604-8846",
          "604-8873",
          "604-8805",
          "604-8852",
          "604-8845",
          "604-8841",
          "604-8843",
          "604-8853",
          "604-8844",
          "604-8855",
          "604-8804",
          "604-8823",
          "604-8831",
          "604-8862",
          "604-8275",
          "604-8353",
          "604-0932",
          "604-0805",
          "604-8214",
          "604-8303",
          "604-8145",
          "604-8144",
          "604-8244",
          "604-8231",
          "604-0053",
          "604-0953",
          "604-8306",
          "604-8072",
          "604-8123",
          "604-0062",
          "604-8101",
          "604-8032",
          "604-8237",
          "604-0815",
          "604-8156",
          "604-0933",
          "604-0064",
          "604-0916",
          "604-0087",
          "604-8361",
          "604-0974",
          "604-8242",
          "604-8204",
          "604-0011",
          "604-0965",
          "604-8245",
          "604-8342",
          "604-8344",
          "604-8212",
          "604-8011",
          "604-0803",
          "604-8116",
          "604-8181",
          "605-0000",
          "605-0856",
          "605-0051",
          "605-0052",
          "605-0035",
          "605-0848",
          "605-0913",
          "605-0912",
          "605-0066",
          "605-0995",
          "605-0994",
          "605-0804",
          "605-0068",
          "605-0067",
          "605-0924",
          "605-0965",
          "605-0956",
          "605-0926",
          "605-0954",
          "605-0957",
          "605-0955",
          "605-0972",
          "605-0971",
          "605-0925",
          "605-0952",
          "605-0978",
          "605-0979",
          "605-0953",
          "605-0023",
          "605-0042",
          "605-0852",
          "605-0061",
          "605-0064",
          "605-0033",
          "605-0936",
          "605-0917",
          "605-0022",
          "605-0904",
          "605-0009",
          "605-0833",
          "605-0909",
          "605-0843",
          "605-0834",
          "605-0875",
          "605-0877",
          "605-0968",
          "605-0927",
          "605-0876",
          "605-0916",
          "605-0822",
          "605-0991",
          "605-0807",
          "605-0803",
          "605-0069",
          "605-0076",
          "605-0921",
          "605-0074",
          "605-0073",
          "605-0014",
          "605-0815",
          "605-0918",
          "605-0821",
          "605-0002",
          "605-0862",
          "605-0084",
          "605-0828",
          "605-0857",
          "605-0007",
          "605-0036",
          "605-0858",
          "605-0846",
          "605-0811",
          "605-0012",
          "605-0902",
          "605-0941",
          "605-0005",
          "605-0011",
          "605-0943",
          "605-0871",
          "605-0914",
          "605-0966",
          "605-0873",
          "605-0915",
          "605-0825",
          "605-0937",
          "605-0823",
          "605-0992",
          "605-0808",
          "605-0903",
          "605-0031",
          "605-0908",
          "605-0865",
          "605-0962",
          "605-0961",
          "605-0006",
          "605-0016",
          "605-0085",
          "605-0901",
          "605-0923",
          "605-0922",
          "605-0861",
          "605-0021",
          "605-0974",
          "605-0975",
          "605-0976",
          "605-0973",
          "605-0977",
          "605-0008",
          "605-0832",
          "605-0017",
          "605-0845",
          "605-0018",
          "605-0855",
          "605-0945",
          "605-0835",
          "605-0045",
          "605-0851",
          "605-0844",
          "605-0931",
          "605-0854",
          "605-0829",
          "605-0025",
          "605-0024",
          "605-0079",
          "605-0874",
          "605-0078",
          "605-0905",
          "605-0034",
          "605-0075",
          "605-0082",
          "605-0019",
          "605-0838",
          "605-0043",
          "605-0816",
          "605-0907",
          "605-0935",
          "605-0088",
          "605-0947",
          "605-0037",
          "605-0077",
          "605-0001",
          "605-0934",
          "605-0863",
          "605-0805",
          "605-0083",
          "605-0027",
          "605-0029",
          "605-0872",
          "605-0839",
          "605-0951",
          "605-0044",
          "605-0906",
          "605-0041",
          "605-0847",
          "605-0046",
          "605-0812",
          "605-0993",
          "605-0985",
          "605-0983",
          "605-0988",
          "605-0986",
          "605-0987",
          "605-0982",
          "605-0984",
          "605-0911",
          "605-0026",
          "605-0065",
          "605-0028",
          "605-0086",
          "605-0946",
          "605-0853",
          "605-0038",
          "605-0967",
          "605-0963",
          "605-0981",
          "605-0989",
          "605-0942",
          "605-0826",
          "605-0063",
          "605-0071",
          "605-0842",
          "605-0938",
          "605-0964",
          "605-0015",
          "605-0013",
          "605-0944",
          "605-0824",
          "605-0801",
          "605-0932",
          "605-0081",
          "605-0089",
          "605-0087",
          "605-0836",
          "605-0814",
          "605-0827",
          "605-0841",
          "605-0831",
          "605-0837",
          "605-0933",
          "605-0802",
          "605-0864",
          "605-0032",
          "605-0817",
          "605-0878",
          "605-0062",
          "605-0813",
          "605-0806",
          "605-0003",
          "605-0004",
          "605-0072",
          "600-0000",
          "600-8071",
          "600-8410",
          "600-8407",
          "600-8473",
          "600-8308",
          "600-8040",
          "600-8231",
          "600-8148",
          "600-8383",
          "600-8072",
          "600-8474",
          "600-8482",
          "600-8496",
          "600-8047",
          "600-8188",
          "600-8014",
          "600-8254",
          "600-8018",
          "600-8318",
          "600-8432",
          "600-8415",
          "600-8022",
          "600-8133",
          "600-8098",
          "600-8166",
          "600-8384",
          "600-8115",
          "600-8445",
          "600-8028",
          "600-8343",
          "600-8304",
          "600-8151",
          "600-8855",
          "600-8851",
          "600-8853",
          "600-8854",
          "600-8852",
          "600-8857",
          "600-8856",
          "600-8127",
          "600-8822",
          "600-8463",
          "600-8154",
          "600-8302",
          "600-8033",
          "600-8183",
          "600-8310",
          "600-8837",
          "600-8328",
          "600-8062",
          "600-8095",
          "600-8402",
          "600-8177",
          "600-8181",
          "600-8419",
          "600-8413",
          "600-8363",
          "600-8138",
          "600-8002",
          "600-8003",
          "600-8430",
          "600-8145",
          "600-8246",
          "600-8357",
          "600-8057",
          "600-8126",
          "600-8178",
          "600-8317",
          "600-8341",
          "600-8475",
          "600-8494",
          "600-8079",
          "600-8329",
          "600-8066",
          "600-8498",
          "600-8049",
          "600-8050",
          "600-8067",
          "600-8089",
          "600-8493",
          "600-8323",
          "600-8258",
          "600-8239",
          "600-8058",
          "600-8242",
          "600-8457",
          "600-8259",
          "600-8377",
          "600-8135",
          "600-8150",
          "600-8312",
          "600-8170",
          "600-8376",
          "600-8248",
          "600-8131",
          "600-8266",
          "600-8207",
          "600-8171",
          "600-8099",
          "600-8164",
          "600-8301",
          "600-8313",
          "600-8159",
          "600-8406",
          "600-8451",
          "600-8175",
          "600-8499",
          "600-8197",
          "600-8056",
          "600-8060",
          "600-8393",
          "600-8252",
          "600-8202",
          "600-8835",
          "600-8009",
          "600-8336",
          "600-8088",
          "600-8444",
          "600-8121",
          "600-8464",
          "600-8228",
          "600-8233",
          "600-8176",
          "600-8356",
          "600-8069",
          "600-8352",
          "600-8253",
          "600-8035",
          "600-8476",
          "600-8331",
          "600-8423",
          "600-8081",
          "600-8480",
          "600-8208",
          "600-8460",
          "600-8034",
          "600-8209",
          "600-8497",
          "600-8149",
          "600-8267",
          "600-8429",
          "600-8485",
          "600-8821",
          "600-8426",
          "600-8418",
          "600-8385",
          "600-8229",
          "600-8322",
          "600-8130",
          "600-8012",
          "600-8016",
          "600-8146",
          "600-8440",
          "600-8191",
          "600-8162",
          "600-8349",
          "600-8194",
          "600-8381",
          "600-8210",
          "600-8156",
          "600-8488",
          "600-8391",
          "600-8337",
          "600-8394",
          "600-8257",
          "600-8097",
          "600-8134",
          "600-8424",
          "600-8103",
          "600-8212",
          "600-8052",
          "600-8144",
          "600-8382",
          "600-8389",
          "600-8481",
          "600-8441",
          "600-8861",
          "600-8862",
          "600-8865",
          "600-8863",
          "600-8864",
          "600-8316",
          "600-8025",
          "600-8255",
          "600-8241",
          "600-8263",
          "600-8059",
          "600-8249",
          "600-8373",
          "600-8017",
          "600-8136",
          "600-8163",
          "600-8375",
          "600-8132",
          "600-8206",
          "600-8172",
          "600-8180",
          "600-8165",
          "600-8137",
          "600-8354",
          "600-8348",
          "600-8417",
          "600-8021",
          "600-8116",
          "600-8158",
          "600-8084",
          "600-8471",
          "600-8001",
          "600-8141",
          "600-8092",
          "600-8411",
          "600-8386",
          "600-8078",
          "600-8843",
          "600-8844",
          "600-8845",
          "600-8841",
          "600-8842",
          "600-8847",
          "600-8846",
          "600-8061",
          "600-8048",
          "600-8143",
          "600-8335",
          "600-8468",
          "600-8832",
          "600-8398",
          "600-8303",
          "600-8076",
          "600-8338",
          "600-8431",
          "600-8019",
          "600-8128",
          "600-8268",
          "600-8043",
          "600-8161",
          "600-8223",
          "600-8106",
          "600-8469",
          "600-8039",
          "600-8237",
          "600-8221",
          "600-8082",
          "600-8420",
          "600-8174",
          "600-8353",
          "600-8387",
          "600-8465",
          "600-8486",
          "600-8434",
          "600-8096",
          "600-8123",
          "600-8093",
          "600-8319",
          "600-8090",
          "600-8006",
          "600-8007",
          "600-8005",
          "600-8044",
          "600-8157",
          "600-8487",
          "600-8490",
          "600-8307",
          "600-8038",
          "600-8427",
          "600-8346",
          "600-8409",
          "600-8129",
          "600-8264",
          "600-8042",
          "600-8070",
          "600-8365",
          "600-8036",
          "600-8045",
          "600-8068",
          "600-8815",
          "600-8805",
          "600-8812",
          "600-8802",
          "600-8814",
          "600-8801",
          "600-8811",
          "600-8804",
          "600-8362",
          "600-8813",
          "600-8806",
          "600-8807",
          "600-8803",
          "600-8364",
          "600-8492",
          "600-8453",
          "600-8226",
          "600-8396",
          "600-8152",
          "600-8085",
          "600-8031",
          "600-8265",
          "600-8456",
          "600-8184",
          "600-8459",
          "600-8013",
          "600-8024",
          "600-8111",
          "600-8421",
          "600-8401",
          "600-8167",
          "600-8461",
          "600-8051",
          "600-8437",
          "600-8395",
          "600-8186",
          "600-8023",
          "600-8351",
          "600-8449",
          "600-8125",
          "600-8124",
          "600-8192",
          "600-8219",
          "600-8332",
          "600-8452",
          "600-8032",
          "600-8435",
          "600-8073",
          "600-8438",
          "600-8008",
          "600-8055",
          "600-8142",
          "600-8004",
          "600-8027",
          "600-8414",
          "600-8236",
          "600-8478",
          "600-8479",
          "600-8160",
          "600-8108",
          "600-8325",
          "600-8218",
          "600-8899",
          "600-8875",
          "600-8894",
          "600-8897",
          "600-8881",
          "600-8883",
          "600-8886",
          "600-8878",
          "600-8871",
          "600-8893",
          "600-8879",
          "600-8887",
          "600-8896",
          "600-8874",
          "600-8892",
          "600-8895",
          "600-8898",
          "600-8873",
          "600-8891",
          "600-8882",
          "600-8884",
          "600-8885",
          "600-8876",
          "600-8877",
          "600-8872",
          "600-8888",
          "600-8828",
          "600-8826",
          "600-8829",
          "600-8827",
          "600-8816",
          "600-8825",
          "600-8833",
          "600-8484",
          "600-8397",
          "600-8155",
          "600-8205",
          "600-8327",
          "600-8029",
          "600-8083",
          "600-8326",
          "600-8371",
          "600-8269",
          "600-8153",
          "600-8412",
          "600-8334",
          "600-8824",
          "600-8491",
          "600-8053",
          "600-8182",
          "600-8454",
          "600-8422",
          "600-8489",
          "600-8187",
          "600-8113",
          "600-8011",
          "600-8139",
          "600-8196",
          "600-8247",
          "600-8836",
          "600-8041",
          "600-8261",
          "600-8831",
          "600-8185",
          "600-8340",
          "600-8114",
          "600-8433",
          "600-8439",
          "600-8235",
          "600-8169",
          "600-8107",
          "600-8324",
          "600-8217",
          "600-8215",
          "600-8214",
          "600-8213",
          "600-8216",
          "600-8225",
          "600-8190",
          "600-8224",
          "600-8204",
          "600-8074",
          "600-8315",
          "600-8305",
          "600-8458",
          "600-8227",
          "600-8311",
          "600-8087",
          "600-8118",
          "600-8122",
          "600-8306",
          "600-8109",
          "600-8408",
          "600-8189",
          "600-8404",
          "600-8320",
          "600-8495",
          "600-8173",
          "600-8347",
          "600-8094",
          "600-8054",
          "600-8466",
          "600-8443",
          "600-8467",
          "600-8245",
          "600-8428",
          "600-8388",
          "600-8244",
          "600-8333",
          "600-8193",
          "600-8425",
          "600-8147",
          "600-8446",
          "600-8361",
          "600-8102",
          "600-8086",
          "600-8462",
          "600-8211",
          "600-8046",
          "600-8195",
          "600-8026",
          "600-8063",
          "600-8256",
          "600-8390",
          "600-8105",
          "600-8075",
          "600-8037",
          "600-8359",
          "600-8399",
          "600-8104",
          "600-8405",
          "600-8101",
          "600-8447",
          "600-8020",
          "600-8238",
          "600-8243",
          "600-8117",
          "600-8110",
          "600-8234",
          "600-8232",
          "600-8372",
          "600-8251",
          "600-8015",
          "600-8472",
          "600-8392",
          "600-8091",
          "600-8064",
          "600-8119",
          "600-8065",
          "600-8436",
          "600-8345",
          "600-8222",
          "600-8358",
          "600-8168",
          "600-8262",
          "600-8321",
          "600-8203",
          "600-8823",
          "600-8416",
          "600-8442",
          "600-8112",
          "600-8344",
          "600-8448",
          "600-8374",
          "600-8342",
          "600-8455",
          "600-8077",
          "600-8477",
          "600-8179",
          "600-8403",
          "600-8483",
          "600-8199",
          "600-8355",
          "600-8198",
          "600-8120",
          "600-8201",
          "600-8314",
          "600-8834",
          "601-0000",
          "601-8406",
          "601-8143",
          "601-8135",
          "601-8136",
          "601-8141",
          "601-8177",
          "601-8134",
          "601-8128",
          "601-8178",
          "601-8185",
          "601-8175",
          "601-8105",
          "601-8131",
          "601-8108",
          "601-8171",
          "601-8112",
          "601-8186",
          "601-8182",
          "601-8122",
          "601-8106",
          "601-8127",
          "601-8187",
          "601-8174",
          "601-8115",
          "601-8137",
          "601-8102",
          "601-8121",
          "601-8101",
          "601-8132",
          "601-8104",
          "601-8124",
          "601-8142",
          "601-8146",
          "601-8172",
          "601-8111",
          "601-8145",
          "601-8173",
          "601-8125",
          "601-8144",
          "601-8103",
          "601-8116",
          "601-8181",
          "601-8107",
          "601-8183",
          "601-8123",
          "601-8188",
          "601-8113",
          "601-8126",
          "601-8114",
          "601-8184",
          "601-8176",
          "601-8133",
          "601-8161",
          "601-8163",
          "601-8155",
          "601-8167",
          "601-8162",
          "601-8153",
          "601-8166",
          "601-8152",
          "601-8165",
          "601-8151",
          "601-8154",
          "601-8164",
          "601-8463",
          "601-8455",
          "601-8462",
          "601-8467",
          "601-8461",
          "601-8451",
          "601-8454",
          "601-8466",
          "601-8464",
          "601-8452",
          "601-8468",
          "601-8465",
          "601-8469",
          "601-8457",
          "601-8456",
          "601-8453",
          "601-8349",
          "601-8346",
          "601-8316",
          "601-8367",
          "601-8343",
          "601-8314",
          "601-8392",
          "601-8327",
          "601-8391",
          "601-8324",
          "601-8323",
          "601-8348",
          "601-8347",
          "601-8328",
          "601-8315",
          "601-8322",
          "601-8339",
          "601-8319",
          "601-8318",
          "601-8329",
          "601-8336",
          "601-8335",
          "601-8332",
          "601-8399",
          "601-8313",
          "601-8362",
          "601-8354",
          "601-8352",
          "601-8321",
          "601-8338",
          "601-8381",
          "601-8353",
          "601-8351",
          "601-8337",
          "601-8325",
          "601-8333",
          "601-8334",
          "601-8342",
          "601-8330",
          "601-8304",
          "601-8341",
          "601-8344",
          "601-8345",
          "601-8331",
          "601-8326",
          "601-8306",
          "601-8305",
          "601-8307",
          "601-8308",
          "601-8390",
          "601-8382",
          "601-8356",
          "601-8355",
          "601-8357",
          "601-8383",
          "601-8366",
          "601-8388",
          "601-8384",
          "601-8387",
          "601-8389",
          "601-8361",
          "601-8365",
          "601-8364",
          "601-8385",
          "601-8386",
          "601-8374",
          "601-8371",
          "601-8379",
          "601-8372",
          "601-8378",
          "601-8373",
          "601-8377",
          "601-8376",
          "601-8375",
          "601-8363",
          "601-8397",
          "601-8398",
          "601-8380",
          "601-8317",
          "601-8394",
          "601-8393",
          "601-8396",
          "601-8395",
          "601-8310",
          "601-8301",
          "601-8303",
          "601-8311",
          "601-8302",
          "601-8309",
          "601-8312",
          "601-8473",
          "601-8202",
          "601-8206",
          "601-8212",
          "601-8201",
          "601-8211",
          "601-8203",
          "601-8205",
          "601-8213",
          "601-8207",
          "601-8204",
          "601-8401",
          "601-8402",
          "601-8478",
          "601-8428",
          "601-8416",
          "601-8426",
          "601-8412",
          "601-8449",
          "601-8439",
          "601-8405",
          "601-8413",
          "601-8447",
          "601-8423",
          "601-8424",
          "601-8411",
          "601-8442",
          "601-8404",
          "601-8414",
          "601-8431",
          "601-8445",
          "601-8446",
          "601-8407",
          "601-8448",
          "601-8417",
          "601-8441",
          "601-8415",
          "601-8436",
          "601-8422",
          "601-8437",
          "601-8443",
          "601-8432",
          "601-8438",
          "601-8433",
          "601-8421",
          "601-8434",
          "601-8425",
          "601-8444",
          "601-8435",
          "601-8427",
          "601-8475",
          "601-8476",
          "601-8472",
          "601-8477",
          "601-8471",
          "601-8044",
          "601-8032",
          "601-8021",
          "601-8015",
          "601-8002",
          "601-8016",
          "601-8014",
          "601-8031",
          "601-8017",
          "601-8007",
          "601-8022",
          "601-8047",
          "601-8027",
          "601-8048",
          "601-8026",
          "601-8045",
          "601-8005",
          "601-8037",
          "601-8042",
          "601-8003",
          "601-8043",
          "601-8046",
          "601-8006",
          "601-8028",
          "601-8004",
          "601-8024",
          "601-8029",
          "601-8036",
          "601-8033",
          "601-8012",
          "601-8041",
          "601-8034",
          "601-8013",
          "601-8011",
          "601-8035",
          "601-8023",
          "601-8001",
          "601-8025",
          "601-8403",
          "601-8474",
          "616-0000",
          "616-8171",
          "616-8172",
          "616-8136",
          "616-8166",
          "616-8101",
          "616-8107",
          "616-8175",
          "616-8122",
          "616-8176",
          "616-8177",
          "616-8127",
          "616-8153",
          "616-8123",
          "616-8185",
          "616-8121",
          "616-8151",
          "616-8165",
          "616-8164",
          "616-8103",
          "616-8173",
          "616-8134",
          "616-8143",
          "616-8182",
          "616-8112",
          "616-8181",
          "616-8125",
          "616-8157",
          "616-8135",
          "616-8187",
          "616-8192",
          "616-8111",
          "616-8104",
          "616-8126",
          "616-8137",
          "616-8132",
          "616-8114",
          "616-8141",
          "616-8167",
          "616-8174",
          "616-8124",
          "616-8147",
          "616-8184",
          "616-8133",
          "616-8191",
          "616-8156",
          "616-8163",
          "616-8113",
          "616-8155",
          "616-8162",
          "616-8145",
          "616-8115",
          "616-8161",
          "616-8142",
          "616-8131",
          "616-8186",
          "616-8152",
          "616-8146",
          "616-8116",
          "616-8154",
          "616-8183",
          "616-8106",
          "616-8102",
          "616-8105",
          "616-8117",
          "616-8144",
          "616-8081",
          "616-8084",
          "616-8077",
          "616-8082",
          "616-8062",
          "616-8064",
          "616-8066",
          "616-8067",
          "616-8072",
          "616-8076",
          "616-8065",
          "616-8083",
          "616-8074",
          "616-8063",
          "616-8071",
          "616-8085",
          "616-8073",
          "616-8075",
          "616-8204",
          "616-8205",
          "616-8252",
          "616-8201",
          "616-8203",
          "616-8209",
          "616-8207",
          "616-8202",
          "616-8208",
          "616-8206",
          "616-8272",
          "616-8282",
          "616-8274",
          "616-8283",
          "616-8275",
          "616-8297",
          "616-8296",
          "616-8281",
          "616-8286",
          "616-8288",
          "616-8276",
          "616-8278",
          "616-8292",
          "616-8261",
          "616-8295",
          "616-8293",
          "616-8287",
          "616-8266",
          "616-8273",
          "616-8289",
          "616-8263",
          "616-8265",
          "616-8294",
          "616-8285",
          "616-8277",
          "616-8268",
          "616-8291",
          "616-8284",
          "616-8271",
          "616-8262",
          "616-8264",
          "616-8267",
          "615-0905",
          "615-0932",
          "615-0925",
          "615-0912",
          "615-0902",
          "615-0934",
          "615-0937",
          "615-0911",
          "615-0933",
          "615-0938",
          "615-0924",
          "615-0906",
          "615-0907",
          "615-0904",
          "615-0903",
          "615-0935",
          "615-0923",
          "615-0916",
          "615-0917",
          "615-0936",
          "615-0914",
          "615-0931",
          "615-0921",
          "615-0926",
          "615-0922",
          "615-0913",
          "615-0901",
          "615-0915",
          "616-8092",
          "616-8096",
          "616-8094",
          "616-8095",
          "616-8091",
          "616-8093",
          "616-8097",
          "616-8245",
          "616-8407",
          "616-8441",
          "616-8442",
          "616-8406",
          "616-8401",
          "616-8405",
          "616-8404",
          "616-8403",
          "616-8402",
          "601-0541",
          "601-0273",
          "601-0274",
          "601-0535",
          "601-0313",
          "601-0275",
          "601-0277",
          "601-0314",
          "601-0311",
          "601-0261",
          "601-0401",
          "601-0402",
          "601-0532",
          "601-0531",
          "601-0271",
          "601-0252",
          "601-0536",
          "601-0543",
          "601-0266",
          "601-0272",
          "601-0405",
          "601-0324",
          "601-0533",
          "601-0534",
          "601-0251",
          "601-0404",
          "601-0542",
          "601-0265",
          "601-0322",
          "601-0321",
          "601-0264",
          "601-0323",
          "601-0315",
          "601-0276",
          "601-0403",
          "601-0312",
          "601-0316",
          "601-0262",
          "601-0406",
          "601-0278",
          "601-0263",
          "615-0061",
          "615-0035",
          "615-0036",
          "615-0058",
          "615-0015",
          "615-0006",
          "615-0001",
          "615-0007",
          "615-0063",
          "615-0026",
          "615-0064",
          "615-0053",
          "615-0012",
          "615-0067",
          "615-0033",
          "615-0021",
          "615-0066",
          "615-0052",
          "615-0004",
          "615-0005",
          "615-0031",
          "615-0014",
          "615-0054",
          "615-0043",
          "615-0003",
          "615-0056",
          "615-0034",
          "615-0027",
          "615-0016",
          "615-0032",
          "615-0055",
          "615-0044",
          "615-0023",
          "615-0046",
          "615-0025",
          "615-0002",
          "615-0057",
          "615-0011",
          "615-0042",
          "615-0062",
          "615-0065",
          "615-0022",
          "615-0013",
          "615-0045",
          "615-0037",
          "615-0048",
          "615-0041",
          "615-0024",
          "615-0051",
          "615-0047",
          "616-8343",
          "616-8458",
          "616-8335",
          "616-8365",
          "616-8354",
          "616-8344",
          "616-8411",
          "616-8395",
          "616-8345",
          "616-8341",
          "616-8386",
          "616-8387",
          "616-8342",
          "616-8367",
          "616-8452",
          "616-8362",
          "616-8355",
          "616-8351",
          "616-8336",
          "616-8361",
          "616-8383",
          "616-8347",
          "616-8364",
          "616-8393",
          "616-8301",
          "616-8334",
          "616-8337",
          "616-8363",
          "616-8352",
          "616-8353",
          "616-8397",
          "616-8394",
          "616-8392",
          "616-8391",
          "616-8396",
          "616-8445",
          "616-8444",
          "616-8446",
          "616-8443",
          "616-8451",
          "616-8453",
          "616-8457",
          "616-8455",
          "616-8456",
          "616-8454",
          "616-8491",
          "616-8482",
          "616-8494",
          "616-8484",
          "616-8492",
          "616-8487",
          "616-8483",
          "616-8485",
          "616-8486",
          "616-8481",
          "616-8493",
          "616-8471",
          "616-8474",
          "616-8472",
          "616-8475",
          "616-8473",
          "616-8422",
          "616-8447",
          "616-8423",
          "616-8421",
          "616-8424",
          "616-8416",
          "616-8413",
          "616-8412",
          "616-8414",
          "616-8415",
          "616-8417",
          "616-8346",
          "616-8366",
          "616-8374",
          "616-8373",
          "616-8357",
          "616-8385",
          "616-8382",
          "616-8376",
          "616-8375",
          "616-8384",
          "616-8356",
          "616-8372",
          "616-8381",
          "616-8371",
          "616-8436",
          "616-8431",
          "616-8432",
          "616-8435",
          "616-8437",
          "616-8433",
          "616-8439",
          "616-8434",
          "616-8438",
          "616-8426",
          "616-8428",
          "616-8427",
          "616-8425",
          "616-8314",
          "616-8316",
          "616-8331",
          "616-8317",
          "616-8332",
          "616-8311",
          "616-8322",
          "616-8312",
          "616-8325",
          "616-8321",
          "616-8323",
          "616-8333",
          "616-8326",
          "616-8313",
          "616-8324",
          "616-8315",
          "616-8327",
          "616-8307",
          "616-8302",
          "616-8305",
          "616-8306",
          "616-8303",
          "616-8304",
          "616-8467",
          "616-8462",
          "616-8468",
          "616-8466",
          "616-8463",
          "616-8461",
          "616-8465",
          "616-8464",
          "616-8014",
          "616-8022",
          "616-8012",
          "616-8013",
          "616-8015",
          "616-8216",
          "616-8225",
          "616-8211",
          "616-8213",
          "616-8231",
          "616-8219",
          "616-8229",
          "616-8227",
          "616-8224",
          "616-8228",
          "616-8226",
          "616-8218",
          "616-8222",
          "616-8223",
          "616-8217",
          "616-8214",
          "616-8221",
          "616-8215",
          "616-8212",
          "616-8253",
          "616-8241",
          "616-8251",
          "616-8255",
          "616-8246",
          "616-8238",
          "616-8234",
          "616-8257",
          "616-8254",
          "616-8233",
          "616-8235",
          "616-8247",
          "616-8236",
          "616-8258",
          "616-8244",
          "616-8242",
          "616-8256",
          "616-8237",
          "616-8243",
          "616-8232",
          "615-0806",
          "615-0885",
          "615-0882",
          "615-0843",
          "615-0836",
          "615-0821",
          "615-0881",
          "615-0878",
          "615-0802",
          "615-0818",
          "615-0826",
          "615-0814",
          "615-0874",
          "615-0864",
          "615-0845",
          "615-0812",
          "615-0804",
          "615-0813",
          "615-0835",
          "615-0854",
          "615-0863",
          "615-0846",
          "615-0875",
          "615-0834",
          "615-0815",
          "615-0822",
          "615-0831",
          "615-0811",
          "615-0827",
          "615-0851",
          "615-0862",
          "615-0852",
          "615-0877",
          "615-0855",
          "615-0837",
          "615-0861",
          "615-0832",
          "615-0833",
          "615-0824",
          "615-0873",
          "615-0841",
          "615-0805",
          "615-0807",
          "615-0844",
          "615-0871",
          "615-0816",
          "615-0825",
          "615-0856",
          "615-0823",
          "615-0801",
          "615-0883",
          "615-0872",
          "615-0803",
          "615-0817",
          "615-0838",
          "615-0842",
          "615-0857",
          "615-0858",
          "615-0853",
          "615-0876",
          "615-0884",
          "616-8024",
          "616-8037",
          "616-8042",
          "616-8045",
          "616-8027",
          "616-8044",
          "616-8023",
          "616-8026",
          "616-8061",
          "616-8034",
          "616-8057",
          "616-8055",
          "616-8056",
          "616-8033",
          "616-8051",
          "616-8031",
          "616-8046",
          "616-8025",
          "616-8043",
          "616-8036",
          "616-8041",
          "616-8021",
          "616-8054",
          "616-8032",
          "616-8047",
          "616-8035",
          "616-8053",
          "616-8052",
          "616-8197",
          "616-8193",
          "616-8195",
          "616-8196",
          "616-8194",
          "615-0073",
          "615-0072",
          "615-0097",
          "615-0094",
          "615-0096",
          "615-0082",
          "615-0083",
          "615-0074",
          "615-0085",
          "615-0071",
          "615-0095",
          "615-0091",
          "615-0093",
          "615-0092",
          "615-0084",
          "615-0081",
          "616-8003",
          "616-8002",
          "616-8017",
          "616-8001",
          "616-8011",
          "616-8006",
          "616-8004",
          "616-8005",
          "616-8016",
          "616-8007",
          "612-0000",
          "612-8324",
          "612-8203",
          "601-1432",
          "601-1431",
          "601-1433",
          "601-1438",
          "601-1435",
          "601-1436",
          "601-1437",
          "601-1439",
          "601-1434",
          "612-8319",
          "612-0804",
          "612-8051",
          "612-8041",
          "612-8321",
          "612-8304",
          "612-8201",
          "612-8335",
          "612-8048",
          "612-8344",
          "612-8078",
          "612-8065",
          "601-1464",
          "601-1443",
          "601-1444",
          "601-1446",
          "601-1441",
          "601-1455",
          "601-1463",
          "601-1453",
          "601-1452",
          "601-1451",
          "601-1442",
          "601-1456",
          "601-1461",
          "601-1445",
          "601-1462",
          "601-1454",
          "612-8357",
          "612-8219",
          "612-8301",
          "612-8042",
          "612-8307",
          "612-8071",
          "612-8202",
          "612-8103",
          "612-8361",
          "612-8047",
          "612-8316",
          "612-8318",
          "612-8305",
          "612-8217",
          "612-8302",
          "612-8375",
          "612-8356",
          "612-8101",
          "612-8331",
          "612-8077",
          "612-8388",
          "612-8372",
          "612-8218",
          "612-8366",
          "612-8083",
          "612-8087",
          "612-8084",
          "612-8085",
          "612-8086",
          "612-8089",
          "612-8342",
          "612-8365",
          "612-8329",
          "612-8494",
          "612-8491",
          "612-8493",
          "612-8496",
          "612-8492",
          "612-8495",
          "612-8039",
          "612-8064",
          "612-8074",
          "612-8109",
          "612-8046",
          "612-8374",
          "612-8377",
          "612-8325",
          "612-8364",
          "612-8073",
          "612-8306",
          "612-8471",
          "612-8248",
          "612-8468",
          "612-8497",
          "612-8476",
          "612-8392",
          "612-8385",
          "612-8384",
          "612-8466",
          "612-8391",
          "612-8208",
          "612-8498",
          "612-8477",
          "612-8394",
          "612-8489",
          "612-8395",
          "612-8488",
          "612-8387",
          "612-8473",
          "612-8467",
          "612-8499",
          "612-8478",
          "612-8490",
          "612-8209",
          "612-8381",
          "612-8386",
          "612-8206",
          "612-8393",
          "612-8216",
          "612-0085",
          "612-8341",
          "612-8343",
          "612-8067",
          "612-8333",
          "612-8215",
          "612-8081",
          "612-8368",
          "612-8231",
          "612-0051",
          "612-8314",
          "612-8052",
          "601-1347",
          "601-1323",
          "601-1362",
          "601-1351",
          "601-1335",
          "601-1387",
          "601-1371",
          "601-1302",
          "601-1364",
          "601-1366",
          "601-1311",
          "601-1303",
          "601-1338",
          "601-1376",
          "601-1363",
          "601-1305",
          "601-1336",
          "601-1312",
          "601-1354",
          "601-1333",
          "601-1342",
          "601-1301",
          "601-1315",
          "601-1324",
          "601-1378",
          "601-1341",
          "601-1322",
          "601-1381",
          "601-1377",
          "601-1321",
          "601-1317",
          "601-1327",
          "601-1308",
          "601-1361",
          "601-1314",
          "601-1313",
          "601-1332",
          "601-1343",
          "601-1334",
          "601-1365",
          "601-1326",
          "601-1345",
          "601-1383",
          "601-1384",
          "601-1375",
          "601-1355",
          "601-1344",
          "601-1386",
          "601-1357",
          "601-1373",
          "601-1374",
          "601-1307",
          "601-1346",
          "601-1325",
          "601-1372",
          "601-1316",
          "601-1337",
          "601-1318",
          "601-1353",
          "601-1352",
          "601-1382",
          "601-1356",
          "601-1331",
          "601-1385",
          "601-1304",
          "601-1306",
          "612-8062",
          "612-8426",
          "612-8423",
          "612-8421",
          "612-8442",
          "612-8419",
          "612-8411",
          "612-8445",
          "612-8441",
          "612-8425",
          "612-8444",
          "612-8414",
          "612-8450",
          "612-8446",
          "612-8412",
          "612-8415",
          "612-8422",
          "612-8447",
          "612-8428",
          "612-8449",
          "612-8429",
          "612-8448",
          "612-8454",
          "612-8371",
          "612-8427",
          "612-8413",
          "612-8418",
          "612-8417",
          "612-8416",
          "612-8443",
          "612-8061",
          "612-8332",
          "612-8044",
          "612-8221",
          "612-8072",
          "612-8312",
          "612-8359",
          "612-8102",
          "612-8328",
          "612-8107",
          "612-8035",
          "612-8351",
          "612-8308",
          "612-8056",
          "612-8462",
          "612-8469",
          "612-8451",
          "612-8463",
          "612-8455",
          "612-8459",
          "612-8456",
          "612-8465",
          "612-8452",
          "612-8464",
          "612-8457",
          "612-8461",
          "612-8315",
          "612-8038",
          "612-8363",
          "612-8311",
          "612-8347",
          "612-8059",
          "612-8358",
          "612-8362",
          "612-8313",
          "612-8345",
          "612-8327",
          "612-8337",
          "612-8376",
          "612-8214",
          "612-8104",
          "612-0083",
          "612-8354",
          "612-8212",
          "612-8273",
          "612-8268",
          "612-8271",
          "612-8279",
          "612-8267",
          "612-8272",
          "612-8274",
          "612-8278",
          "612-8277",
          "612-8276",
          "612-8275",
          "612-8484",
          "612-8485",
          "612-8487",
          "612-8486",
          "612-8053",
          "612-8063",
          "612-8066",
          "612-8326",
          "612-8336",
          "612-8334",
          "612-8213",
          "612-8355",
          "612-8105",
          "612-8353",
          "612-8211",
          "612-8352",
          "612-8303",
          "601-1416",
          "601-1414",
          "601-1404",
          "601-1401",
          "601-1411",
          "601-1424",
          "601-1425",
          "601-1413",
          "601-1406",
          "601-1426",
          "601-1417",
          "601-1423",
          "601-1415",
          "601-1412",
          "601-1405",
          "601-1421",
          "601-1422",
          "601-1403",
          "601-1402",
          "612-8222",
          "612-8057",
          "612-0004",
          "612-0825",
          "612-0031",
          "612-0028",
          "612-0815",
          "612-0045",
          "612-0012",
          "612-0808",
          "612-0881",
          "612-0014",
          "612-0807",
          "612-0837",
          "612-0017",
          "612-0816",
          "612-8431",
          "612-0081",
          "612-8403",
          "612-0805",
          "612-0806",
          "612-8434",
          "612-0826",
          "612-0006",
          "612-0875",
          "612-8402",
          "612-0873",
          "612-0809",
          "612-8405",
          "612-0041",
          "612-0044",
          "612-0035",
          "612-0025",
          "612-0824",
          "612-0822",
          "612-0803",
          "612-0016",
          "612-8437",
          "612-0886",
          "612-0813",
          "612-0027",
          "612-8439",
          "612-0087",
          "612-0811",
          "612-0089",
          "612-8432",
          "612-8401",
          "612-0001",
          "612-0007",
          "612-0866",
          "612-0801",
          "612-0872",
          "612-0838",
          "612-8436",
          "612-0011",
          "612-0015",
          "612-0828",
          "612-0052",
          "612-0883",
          "612-0037",
          "612-0038",
          "612-8433",
          "612-0877",
          "612-0819",
          "612-0888",
          "612-0829",
          "612-0878",
          "612-0023",
          "612-0021",
          "612-0033",
          "612-0088",
          "612-0823",
          "612-0814",
          "612-0864",
          "612-0002",
          "612-0818",
          "612-0049",
          "612-0034",
          "612-0802",
          "612-0032",
          "612-0029",
          "612-0009",
          "612-0876",
          "612-0879",
          "612-0884",
          "612-0024",
          "612-0887",
          "612-0013",
          "612-0821",
          "612-0874",
          "612-0019",
          "612-0018",
          "612-8435",
          "612-0003",
          "612-0865",
          "612-0863",
          "612-8438",
          "612-0871",
          "612-0885",
          "612-0812",
          "612-0026",
          "612-0839",
          "612-0036",
          "612-0827",
          "612-0817",
          "612-8404",
          "612-0861",
          "612-0005",
          "612-0882",
          "612-0082",
          "612-0042",
          "612-0043",
          "612-0008",
          "612-0022",
          "612-0836",
          "612-0833",
          "612-0842",
          "612-0847",
          "612-0048",
          "612-0852",
          "612-0845",
          "612-0047",
          "612-0862",
          "612-0849",
          "612-0832",
          "612-0841",
          "612-0848",
          "612-0844",
          "612-0843",
          "612-0846",
          "612-0046",
          "612-0851",
          "612-0889",
          "612-0867",
          "612-0868",
          "612-0869",
          "612-8108",
          "612-8338",
          "612-8058",
          "612-8106",
          "612-8055",
          "612-8317",
          "612-8075",
          "612-8322",
          "612-8346",
          "612-8233",
          "612-8232",
          "612-8227",
          "612-8054",
          "612-8076",
          "612-8228",
          "612-8379",
          "612-8045",
          "612-8158",
          "612-8151",
          "612-8122",
          "612-8134",
          "613-0913",
          "612-8114",
          "612-8152",
          "612-8124",
          "612-8121",
          "612-8157",
          "612-8133",
          "612-8123",
          "612-8154",
          "612-8125",
          "612-8113",
          "612-8115",
          "612-8156",
          "612-8116",
          "612-8141",
          "612-8153",
          "612-8111",
          "612-8155",
          "612-8132",
          "612-8112",
          "612-8266",
          "612-8131",
          "612-8136",
          "612-8135",
          "612-8369",
          "612-8373",
          "612-8043",
          "612-0071",
          "612-0074",
          "612-0835",
          "612-8032",
          "612-0072",
          "612-0073",
          "612-0057",
          "612-0058",
          "612-0056",
          "612-0066",
          "612-0065",
          "612-0067",
          "612-0068",
          "612-0062",
          "612-0061",
          "612-0055",
          "612-0059",
          "612-8017",
          "612-0063",
          "612-0064",
          "612-0054",
          "612-8025",
          "612-0834",
          "612-8026",
          "612-8015",
          "612-8028",
          "612-8007",
          "612-8011",
          "612-0853",
          "612-8006",
          "612-8014",
          "612-8226",
          "612-8088",
          "612-0831",
          "612-0854",
          "612-8021",
          "612-0086",
          "612-8019",
          "612-8022",
          "612-8034",
          "612-8036",
          "612-0053",
          "612-8018",
          "612-8223",
          "612-8012",
          "612-0855",
          "612-8005",
          "612-8037",
          "612-8003",
          "612-8013",
          "612-8024",
          "612-8008",
          "612-8001",
          "612-8027",
          "612-0856",
          "612-8004",
          "612-8031",
          "612-8033",
          "612-8029",
          "612-8009",
          "612-8023",
          "612-8002",
          "612-8016",
          "612-8367",
          "612-8323",
          "612-0084",
          "612-8204",
          "612-8252",
          "612-8296",
          "612-8281",
          "612-8254",
          "612-8297",
          "612-8483",
          "612-8284",
          "612-8295",
          "612-8261",
          "612-8246",
          "612-8263",
          "612-8292",
          "612-8262",
          "612-8251",
          "612-8244",
          "612-8285",
          "612-8291",
          "612-8294",
          "612-8257",
          "612-8287",
          "612-8482",
          "612-8286",
          "612-8249",
          "612-8293",
          "612-8282",
          "612-8253",
          "612-8481",
          "612-8256",
          "612-8264",
          "612-8283",
          "612-8255",
          "612-8242",
          "612-8236",
          "612-8243",
          "612-8241",
          "612-8247",
          "612-8235",
          "612-8245",
          "612-8238",
          "612-8237",
          "612-8234",
          "612-8205",
          "612-8239",
          "612-8207",
          "612-8225",
          "612-8224",
          "612-8265",
          "613-0904",
          "613-0907",
          "613-0912",
          "613-0911",
          "613-0915",
          "613-0905",
          "613-0906",
          "613-0914",
          "613-0901",
          "613-0903",
          "613-0902",
          "613-0916",
          "612-8082",
          "607-0000",
          "607-8003",
          "607-8018",
          "607-8017",
          "607-8009",
          "607-8012",
          "607-8005",
          "607-8013",
          "607-8016",
          "607-8007",
          "607-8006",
          "607-8008",
          "607-8002",
          "607-8001",
          "607-8011",
          "607-8004",
          "607-8015",
          "607-8014",
          "607-8441",
          "607-8443",
          "607-8442",
          "607-8123",
          "607-8134",
          "607-8122",
          "607-8136",
          "607-8124",
          "607-8133",
          "607-8125",
          "607-8135",
          "607-8131",
          "607-8121",
          "607-8126",
          "607-8132",
          "607-8187",
          "607-8172",
          "607-8181",
          "607-8173",
          "607-8191",
          "607-8185",
          "607-8184",
          "607-8192",
          "607-8179",
          "607-8171",
          "607-8178",
          "607-8182",
          "607-8194",
          "607-8193",
          "607-8188",
          "607-8183",
          "607-8174",
          "607-8176",
          "607-8177",
          "607-8189",
          "607-8170",
          "607-8175",
          "607-8186",
          "607-8072",
          "607-8068",
          "607-8074",
          "607-8061",
          "607-8077",
          "607-8065",
          "607-8071",
          "607-8062",
          "607-8069",
          "607-8073",
          "607-8075",
          "607-8064",
          "607-8078",
          "607-8063",
          "607-8067",
          "607-8079",
          "607-8066",
          "607-8076",
          "607-8251",
          "607-8261",
          "607-8252",
          "607-8255",
          "607-8257",
          "607-8256",
          "607-8254",
          "607-8259",
          "607-8258",
          "607-8253",
          "607-8461",
          "607-8464",
          "607-8463",
          "607-8465",
          "607-8466",
          "607-8462",
          "607-8321",
          "607-8329",
          "607-8326",
          "607-8323",
          "607-8334",
          "607-8322",
          "607-8325",
          "607-8324",
          "607-8336",
          "607-8332",
          "607-8337",
          "607-8333",
          "607-8331",
          "607-8335",
          "607-8328",
          "607-8327",
          "607-8217",
          "607-8238",
          "607-8237",
          "607-8218",
          "607-8236",
          "607-8242",
          "607-8227",
          "607-8223",
          "607-8229",
          "607-8231",
          "607-8215",
          "607-8226",
          "607-8221",
          "607-8225",
          "607-8212",
          "607-8241",
          "607-8213",
          "607-8224",
          "607-8211",
          "607-8216",
          "607-8222",
          "607-8214",
          "607-8232",
          "607-8219",
          "607-8228",
          "607-8239",
          "607-8235",
          "607-8234",
          "607-8233",
          "607-8483",
          "607-8482",
          "607-8471",
          "607-8485",
          "607-8476",
          "607-8474",
          "607-8481",
          "607-8484",
          "607-8472",
          "607-8475",
          "607-8473",
          "607-8203",
          "607-8201",
          "607-8202",
          "607-8204",
          "607-8103",
          "607-8107",
          "607-8101",
          "607-8115",
          "607-8113",
          "607-8106",
          "607-8102",
          "607-8104",
          "607-8116",
          "607-8108",
          "607-8112",
          "607-8109",
          "607-8114",
          "607-8105",
          "607-8111",
          "607-8028",
          "607-8041",
          "607-8031",
          "607-8027",
          "607-8035",
          "607-8021",
          "607-8024",
          "607-8022",
          "607-8033",
          "607-8023",
          "607-8044",
          "607-8029",
          "607-8043",
          "607-8045",
          "607-8032",
          "607-8034",
          "607-8042",
          "607-8025",
          "607-8026",
          "607-8453",
          "607-8456",
          "607-8455",
          "607-8454",
          "607-8452",
          "607-8451",
          "607-8082",
          "607-8083",
          "607-8087",
          "607-8088",
          "607-8086",
          "607-8081",
          "607-8080",
          "607-8084",
          "607-8085",
          "607-8089",
          "607-8168",
          "607-8162",
          "607-8161",
          "607-8169",
          "607-8164",
          "607-8166",
          "607-8160",
          "607-8163",
          "607-8165",
          "607-8167",
          "607-8343",
          "607-8341",
          "607-8344",
          "607-8355",
          "607-8352",
          "607-8356",
          "607-8354",
          "607-8347",
          "607-8346",
          "607-8353",
          "607-8351",
          "607-8357",
          "607-8348",
          "607-8358",
          "607-8342",
          "607-8345",
          "607-8307",
          "607-8309",
          "607-8302",
          "607-8308",
          "607-8301",
          "607-8305",
          "607-8306",
          "607-8303",
          "607-8304",
          "607-8311",
          "607-8091",
          "607-8144",
          "607-8156",
          "607-8141",
          "607-8155",
          "607-8151",
          "607-8142",
          "607-8145",
          "607-8153",
          "607-8146",
          "607-8143",
          "607-8147",
          "607-8154",
          "607-8152",
          "607-8051",
          "607-8052",
          "607-8493",
          "607-8498",
          "607-8491",
          "607-8492",
          "607-8495",
          "607-8496",
          "607-8494",
          "607-8497",
          "607-8429",
          "607-8407",
          "607-8433",
          "607-8418",
          "607-8403",
          "607-8404",
          "607-8411",
          "607-8431",
          "607-8421",
          "607-8425",
          "607-8432",
          "607-8427",
          "607-8402",
          "607-8401",
          "607-8413",
          "607-8412",
          "607-8426",
          "607-8416",
          "607-8405",
          "607-8419",
          "607-8428",
          "607-8409",
          "607-8408",
          "607-8414",
          "607-8415",
          "607-8424",
          "607-8406",
          "607-8422",
          "607-8417",
          "607-8423",
          "610-0000",
          "616-0022",
          "616-0027",
          "616-0016",
          "616-0001",
          "616-0007",
          "616-0006",
          "616-0014",
          "616-0017",
          "616-0004",
          "616-0003",
          "616-0002",
          "616-0012",
          "616-0011",
          "616-0013",
          "616-0025",
          "616-0023",
          "616-0024",
          "616-0021",
          "616-0026",
          "616-0005",
          "616-0015",
          "615-8041",
          "615-8032",
          "615-8042",
          "615-8043",
          "615-8052",
          "615-8051",
          "615-8031",
          "615-8045",
          "615-8044",
          "615-8046",
          "610-1101",
          "610-1112",
          "610-1106",
          "610-1105",
          "610-1104",
          "610-1141",
          "610-1151",
          "610-1142",
          "610-1111",
          "610-1113",
          "610-1134",
          "610-1135",
          "610-1128",
          "610-1131",
          "610-1133",
          "610-1126",
          "610-1125",
          "610-1121",
          "610-1127",
          "610-1123",
          "610-1124",
          "610-1152",
          "610-1136",
          "610-1146",
          "610-1145",
          "610-1132",
          "610-1143",
          "610-1144",
          "610-1122",
          "610-1153",
          "615-8142",
          "615-8178",
          "615-8181",
          "615-8133",
          "615-8157",
          "615-8185",
          "615-8172",
          "615-8152",
          "615-8135",
          "615-8155",
          "615-8154",
          "615-8176",
          "615-8162",
          "615-8144",
          "615-8136",
          "615-8171",
          "615-8116",
          "615-8131",
          "615-8143",
          "615-8164",
          "615-8173",
          "615-8177",
          "615-8151",
          "615-8145",
          "615-8161",
          "615-8146",
          "615-8182",
          "615-8147",
          "615-8186",
          "615-8156",
          "615-8174",
          "615-8132",
          "615-8175",
          "615-8158",
          "615-8122",
          "615-8134",
          "615-8141",
          "615-8165",
          "615-8153",
          "615-8184",
          "615-8124",
          "615-8123",
          "615-8163",
          "615-8117",
          "615-8183",
          "615-8021",
          "615-8027",
          "615-8081",
          "615-8026",
          "615-8025",
          "615-8086",
          "615-8083",
          "615-8011",
          "615-8071",
          "615-8082",
          "615-8017",
          "615-8022",
          "615-8072",
          "615-8012",
          "615-8087",
          "615-8077",
          "615-8013",
          "615-8076",
          "615-8075",
          "615-8085",
          "615-8301",
          "615-8018",
          "615-8303",
          "615-8302",
          "615-8024",
          "615-8073",
          "615-8004",
          "615-8016",
          "615-8084",
          "615-8014",
          "615-8023",
          "615-8074",
          "615-8007",
          "615-8008",
          "615-8002",
          "615-8003",
          "615-8006",
          "615-8005",
          "615-8001",
          "615-8201",
          "615-8215",
          "615-8212",
          "615-8213",
          "615-8224",
          "615-8228",
          "615-8214",
          "615-8221",
          "615-8208",
          "615-8211",
          "615-8223",
          "615-8222",
          "615-8227",
          "615-8226",
          "615-8225",
          "615-8191",
          "615-8194",
          "615-8113",
          "615-8107",
          "615-8104",
          "615-8195",
          "615-8114",
          "615-8118",
          "615-8196",
          "615-8112",
          "615-8193",
          "615-8125",
          "615-8192",
          "615-8115",
          "615-8106",
          "615-8121",
          "615-8101",
          "615-8111",
          "615-8102",
          "615-8105",
          "615-8103",
          "615-8246",
          "615-8233",
          "615-8244",
          "615-8235",
          "610-1102",
          "615-8245",
          "615-8243",
          "610-1107",
          "615-8252",
          "615-8253",
          "615-8242",
          "615-8241",
          "615-8234",
          "615-8254",
          "615-8231",
          "615-8232",
          "610-1103",
          "615-8061",
          "615-8065",
          "615-8035",
          "615-8037",
          "615-8055",
          "615-8053",
          "615-8056",
          "615-8057",
          "615-8034",
          "615-8033",
          "615-8062",
          "615-8064",
          "615-8036",
          "615-8054",
          "615-8063",
          "615-8015",
          "615-8283",
          "615-8284",
          "615-8281",
          "615-8286",
          "615-8216",
          "615-8282",
          "615-8217",
          "615-8287",
          "615-8202",
          "615-8203",
          "615-8206",
          "615-8291",
          "615-8207",
          "615-8204",
          "615-8294",
          "615-8295",
          "615-8293",
          "615-8292",
          "615-8205",
          "615-8296",
          "615-8274",
          "615-8236",
          "615-8265",
          "615-8285",
          "615-8267",
          "615-8238",
          "615-8262",
          "615-8261",
          "615-8271",
          "615-8273",
          "615-8237",
          "615-8251",
          "615-8255",
          "615-8272",
          "615-8277",
          "615-8263",
          "615-8256",
          "615-8276",
          "615-8275",
          "615-8266",
          "615-8264",
          "620-0000",
          "620-0861",
          "620-0947",
          "620-0058",
          "620-0056",
          "620-0059",
          "620-0964",
          "620-0201",
          "620-0063",
          "620-0061",
          "620-0067",
          "620-0879",
          "620-0823",
          "620-0832",
          "620-0013",
          "620-0804",
          "620-0017",
          "620-0961",
          "620-0074",
          "620-0071",
          "620-0939",
          "620-0848",
          "620-0907",
          "620-0212",
          "620-0984",
          "620-0953",
          "620-0031",
          "620-0922",
          "620-0920",
          "620-0064",
          "620-0831",
          "620-0847",
          "620-0005",
          "620-0825",
          "620-0845",
          "620-0881",
          "620-0985",
          "620-0076",
          "620-0940",
          "620-0045",
          "620-0918",
          "620-0816",
          "620-0325",
          "620-0354",
          "620-0334",
          "620-0304",
          "620-0314",
          "620-0303",
          "620-0341",
          "620-0327",
          "620-0312",
          "620-0322",
          "620-0301",
          "620-0302",
          "620-0351",
          "620-0331",
          "620-0332",
          "620-0311",
          "620-0355",
          "620-0323",
          "620-0353",
          "620-0333",
          "620-0326",
          "620-0305",
          "620-0313",
          "620-0356",
          "620-0324",
          "620-0321",
          "620-0342",
          "620-0352",
          "620-0836",
          "620-0858",
          "620-0852",
          "620-0851",
          "620-0988",
          "620-0077",
          "620-0872",
          "620-0871",
          "620-0873",
          "620-0891",
          "620-0802",
          "620-0963",
          "620-0928",
          "620-0846",
          "620-0853",
          "620-0843",
          "620-0842",
          "620-0981",
          "620-0938",
          "620-0034",
          "620-0921",
          "620-0065",
          "620-0911",
          "620-0033",
          "620-0901",
          "620-0925",
          "620-0028",
          "620-0214",
          "620-0987",
          "620-0969",
          "620-0004",
          "620-0803",
          "620-0859",
          "620-0003",
          "620-0902",
          "620-0943",
          "620-0893",
          "620-0043",
          "620-0931",
          "620-0811",
          "620-0041",
          "620-0042",
          "620-0968",
          "620-0027",
          "620-0962",
          "620-0221",
          "620-0835",
          "620-0026",
          "620-0078",
          "620-0972",
          "620-0863",
          "620-0841",
          "620-0827",
          "620-0971",
          "620-0838",
          "620-0055",
          "620-0958",
          "620-0072",
          "620-0066",
          "620-0015",
          "620-0912",
          "620-0982",
          "620-0032",
          "620-0908",
          "620-0924",
          "620-0839",
          "620-0029",
          "620-0211",
          "620-0022",
          "620-0875",
          "620-0915",
          "620-0904",
          "620-0826",
          "620-0828",
          "620-0936",
          "620-0051",
          "620-0052",
          "620-0016",
          "620-0906",
          "620-0926",
          "620-0054",
          "620-0956",
          "620-0849",
          "620-0989",
          "620-0806",
          "620-0952",
          "620-0854",
          "620-0914",
          "620-0837",
          "620-0965",
          "620-0905",
          "620-0973",
          "620-0073",
          "620-0966",
          "620-0808",
          "620-0949",
          "620-0021",
          "620-0844",
          "620-0801",
          "620-0951",
          "620-0057",
          "620-0035",
          "620-0014",
          "620-0213",
          "620-0817",
          "620-0909",
          "620-0834",
          "620-0036",
          "620-0815",
          "620-0865",
          "620-0886",
          "620-0038",
          "620-0025",
          "620-0932",
          "620-0814",
          "620-0053",
          "620-0039",
          "620-0888",
          "620-0983",
          "620-0917",
          "620-0955",
          "620-0075",
          "620-0822",
          "620-0011",
          "620-0857",
          "620-0855",
          "620-0856",
          "620-0967",
          "620-0954",
          "620-0892",
          "620-0862",
          "620-0887",
          "620-0037",
          "620-0024",
          "620-0807",
          "620-0933",
          "620-0812",
          "620-0882",
          "620-0047",
          "620-0023",
          "620-0903",
          "620-0878",
          "620-0945",
          "620-0974",
          "620-0002",
          "620-0874",
          "620-0824",
          "620-0923",
          "620-0883",
          "620-0867",
          "620-0866",
          "620-0913",
          "620-0894",
          "620-0876",
          "620-0895",
          "620-0946",
          "620-0944",
          "620-0864",
          "620-0885",
          "620-0044",
          "620-0805",
          "620-0934",
          "620-0813",
          "620-0046",
          "620-0884",
          "620-0821",
          "620-0833",
          "620-0986",
          "620-1444",
          "620-1425",
          "620-1422",
          "620-1441",
          "620-1301",
          "620-1421",
          "620-1311",
          "620-1314",
          "620-1435",
          "620-1434",
          "620-1313",
          "620-1442",
          "620-1302",
          "620-1423",
          "620-1433",
          "620-1431",
          "620-1443",
          "620-1424",
          "620-1432",
          "620-1445",
          "620-1312",
          "620-0935",
          "620-0916",
          "620-0937",
          "620-0877",
          "629-1303",
          "629-1323",
          "629-1302",
          "629-1314",
          "629-1315",
          "629-1312",
          "629-1313",
          "629-1305",
          "629-1321",
          "629-1304",
          "629-1301",
          "629-1322",
          "629-1311",
          "620-0012",
          "620-0957",
          "620-0001",
          "620-0948",
          "620-0062",
          "620-0927",
          "625-0000",
          "624-0942",
          "625-0151",
          "624-0842",
          "625-0005",
          "625-0004",
          "625-0030",
          "625-0031",
          "625-0032",
          "625-0033",
          "625-0083",
          "625-0087",
          "624-0811",
          "624-0816",
          "625-0025",
          "624-0813",
          "624-0802",
          "624-0912",
          "624-0911",
          "624-0923",
          "625-0043",
          "624-0854",
          "624-0852",
          "624-0101",
          "624-0944",
          "624-0851",
          "625-0136",
          "625-0006",
          "625-0007",
          "624-0123",
          "625-0158",
          "624-0117",
          "625-0015",
          "625-0020",
          "625-0154",
          "625-0053",
          "625-0014",
          "625-0013",
          "624-0964",
          "624-0913",
          "624-0112",
          "624-0968",
          "624-0951",
          "625-0077",
          "625-0141",
          "625-0146",
          "625-0144",
          "625-0145",
          "624-0804",
          "624-0945",
          "625-0080",
          "624-0855",
          "625-0050",
          "625-0011",
          "625-0073",
          "624-0935",
          "625-0076",
          "625-0075",
          "624-0823",
          "624-0826",
          "624-0901",
          "624-0902",
          "624-0908",
          "624-0103",
          "624-0821",
          "624-0906",
          "625-0056",
          "625-0055",
          "624-0125",
          "624-0124",
          "624-0115",
          "624-0936",
          "624-0118",
          "624-0815",
          "625-0134",
          "624-0102",
          "625-0054",
          "624-0122",
          "624-0929",
          "624-0914",
          "624-0113",
          "624-0967",
          "624-0946",
          "624-0114",
          "624-0834",
          "624-0904",
          "624-0924",
          "624-0941",
          "624-0803",
          "625-0084",
          "625-0016",
          "625-0012",
          "624-0933",
          "625-0001",
          "625-0137",
          "625-0026",
          "625-0157",
          "625-0133",
          "624-0832",
          "624-0835",
          "624-0121",
          "624-0928",
          "625-0023",
          "625-0024",
          "625-0152",
          "625-0045",
          "624-0925",
          "625-0135",
          "625-0082",
          "625-0072",
          "625-0071",
          "624-0801",
          "625-0027",
          "624-0903",
          "624-0909",
          "625-0044",
          "624-0825",
          "625-0147",
          "625-0132",
          "625-0131",
          "624-0111",
          "625-0086",
          "624-0966",
          "624-0822",
          "625-0156",
          "624-0937",
          "624-0961",
          "625-0142",
          "624-0922",
          "624-0831",
          "624-0836",
          "624-0806",
          "625-0155",
          "625-0002",
          "624-0833",
          "624-0954",
          "625-0078",
          "625-0070",
          "624-0953",
          "625-0036",
          "625-0037",
          "624-0962",
          "624-0921",
          "624-0841",
          "624-0843",
          "624-0927",
          "624-0905",
          "624-0907",
          "624-0116",
          "624-0805",
          "624-0812",
          "624-0934",
          "624-0926",
          "624-0824",
          "625-0010",
          "624-0931",
          "624-0955",
          "625-0065",
          "625-0064",
          "625-0066",
          "625-0063",
          "624-0814",
          "624-0965",
          "625-0035",
          "625-0042",
          "625-0041",
          "624-0952",
          "624-0853",
          "625-0057",
          "625-0153",
          "625-0081",
          "624-0932",
          "625-0143",
          "625-0060",
          "625-0062",
          "625-0061",
          "625-0067",
          "625-0021",
          "625-0022",
          "625-0040",
          "625-0052",
          "625-0058",
          "625-0051",
          "624-0963",
          "624-0943",
          "625-0003",
          "625-0074",
          "625-0034",
          "624-0956",
          "625-0085",
          "623-0000",
          "623-0062",
          "623-0011",
          "629-1261",
          "623-0013",
          "623-0006",
          "623-0104",
          "623-1124",
          "623-0224",
          "623-1123",
          "623-0221",
          "629-1241",
          "623-0051",
          "623-0054",
          "623-0233",
          "623-0102",
          "623-0035",
          "623-0341",
          "623-0103",
          "623-0043",
          "623-0066",
          "623-1134",
          "623-0046",
          "623-0231",
          "623-0225",
          "623-0042",
          "623-0114",
          "623-0236",
          "623-0101",
          "623-0001",
          "623-0235",
          "623-0342",
          "629-1254",
          "623-0112",
          "623-0012",
          "629-1271",
          "623-0226",
          "623-0222",
          "623-0108",
          "623-0234",
          "623-1132",
          "623-0052",
          "623-0008",
          "623-0005",
          "623-0343",
          "629-1272",
          "623-0111",
          "623-0351",
          "629-1273",
          "623-0116",
          "623-0003",
          "623-0026",
          "623-0022",
          "623-0363",
          "623-0023",
          "623-0002",
          "623-0106",
          "623-0045",
          "629-1263",
          "629-1253",
          "623-0004",
          "629-1251",
          "623-0232",
          "623-0034",
          "623-0024",
          "623-0025",
          "629-1252",
          "623-0033",
          "623-0061",
          "629-1245",
          "629-1244",
          "629-1242",
          "629-1243",
          "629-1255",
          "623-0117",
          "623-0223",
          "623-0113",
          "623-0064",
          "623-0105",
          "623-0037",
          "623-0344",
          "623-0364",
          "623-0065",
          "629-1264",
          "623-0016",
          "623-0345",
          "623-0032",
          "623-0041",
          "629-1257",
          "623-0361",
          "629-1262",
          "623-0063",
          "629-1256",
          "623-0115",
          "623-0353",
          "623-0346",
          "623-0007",
          "623-0036",
          "623-0021",
          "623-0031",
          "623-1133",
          "623-0053",
          "623-0352",
          "623-1121",
          "623-1131",
          "623-0362",
          "623-0107",
          "623-0044",
          "623-1122",
          "623-0014",
          "623-0015",
          "629-1274",
          "611-0000",
          "601-1394",
          "611-0043",
          "611-0044",
          "611-0021",
          "611-0033",
          "611-0042",
          "611-0023",
          "611-0011",
          "611-0002",
          "611-0015",
          "611-0022",
          "611-0025",
          "601-1395",
          "611-0032",
          "611-0029",
          "601-1396",
          "611-0013",
          "611-0028",
          "601-1393",
          "601-1392",
          "611-0012",
          "611-0027",
          "601-1391",
          "611-0003",
          "611-0026",
          "611-0031",
          "611-0024",
          "611-0041",
          "611-0014",
          "611-0045",
          "611-0001",
          "626-0000",
          "626-0042",
          "626-0007",
          "626-0072",
          "626-0036",
          "626-0203",
          "626-0015",
          "629-2244",
          "626-0006",
          "629-2242",
          "626-0028",
          "626-0202",
          "626-0021",
          "626-0213",
          "626-0037",
          "626-0052",
          "626-0063",
          "626-0055",
          "626-0029",
          "626-0227",
          "626-0004",
          "626-0014",
          "626-0221",
          "626-0035",
          "626-0025",
          "626-0027",
          "626-0031",
          "626-0026",
          "626-0054",
          "629-2234",
          "626-0075",
          "629-2231",
          "626-0211",
          "626-0065",
          "626-0051",
          "626-0017",
          "626-0224",
          "626-0074",
          "626-0011",
          "626-0073",
          "626-0016",
          "626-0002",
          "629-2251",
          "626-0013",
          "626-0043",
          "626-0047",
          "626-0068",
          "626-0034",
          "626-0201",
          "626-0066",
          "626-0041",
          "626-0205",
          "626-0204",
          "626-0053",
          "629-2232",
          "626-0046",
          "626-0212",
          "626-0076",
          "629-2241",
          "629-2243",
          "626-0061",
          "626-0064",
          "626-0226",
          "626-0045",
          "626-0012",
          "626-0225",
          "626-0222",
          "626-0206",
          "626-0018",
          "626-0223",
          "626-0032",
          "626-0008",
          "626-0019",
          "629-2233",
          "626-0005",
          "626-0033",
          "626-0023",
          "626-0001",
          "626-0024",
          "626-0062",
          "626-0067",
          "626-0071",
          "626-0044",
          "626-0022",
          "626-0003",
          "626-0020",
          "626-0077",
          "621-0000",
          "621-0001",
          "621-0806",
          "621-0851",
          "621-0864",
          "621-0801",
          "621-0008",
          "621-0804",
          "621-0012",
          "621-0018",
          "621-0011",
          "621-0013",
          "621-0016",
          "621-0017",
          "621-0856",
          "621-0007",
          "621-0006",
          "621-0803",
          "621-0802",
          "621-0811",
          "621-0861",
          "621-0818",
          "621-0815",
          "621-0819",
          "621-0852",
          "621-0867",
          "621-0823",
          "621-0828",
          "621-0827",
          "621-0821",
          "621-0826",
          "621-0835",
          "621-0822",
          "621-0834",
          "621-0824",
          "621-0831",
          "621-0825",
          "621-0829",
          "621-0854",
          "621-0865",
          "621-0029",
          "621-0027",
          "621-0024",
          "621-0021",
          "621-0023",
          "621-0025",
          "621-0022",
          "621-0028",
          "621-0026",
          "621-0003",
          "621-0002",
          "621-0004",
          "621-0051",
          "621-0041",
          "621-0043",
          "621-0054",
          "621-0046",
          "621-0042",
          "621-0052",
          "621-0053",
          "621-0044",
          "621-0045",
          "621-0813",
          "621-0855",
          "621-0863",
          "621-0817",
          "621-0842",
          "621-0844",
          "621-0841",
          "621-0843",
          "621-0845",
          "621-0126",
          "621-0121",
          "621-0127",
          "621-0123",
          "621-0122",
          "621-0124",
          "621-0125",
          "621-0862",
          "621-0866",
          "621-0261",
          "621-0263",
          "621-0262",
          "621-0034",
          "621-0031",
          "621-0035",
          "621-0036",
          "621-0033",
          "621-0032",
          "621-0037",
          "621-0816",
          "621-0833",
          "621-0832",
          "621-0104",
          "621-0115",
          "621-0114",
          "621-0102",
          "621-0113",
          "621-0101",
          "621-0103",
          "621-0111",
          "621-0112",
          "621-0234",
          "621-0231",
          "621-0233",
          "621-0235",
          "621-0232",
          "621-0005",
          "621-0869",
          "621-0253",
          "621-0252",
          "621-0254",
          "621-0255",
          "621-0251",
          "621-0846",
          "621-0847",
          "621-0814",
          "621-0241",
          "621-0242",
          "621-0243",
          "621-0805",
          "621-0853",
          "621-0868",
          "621-0812",
          "621-0014",
          "621-0015",
          "610-0100",
          "610-0114",
          "610-0115",
          "610-0102",
          "610-0103",
          "610-0121",
          "610-0111",
          "610-0113",
          "610-0112",
          "610-0116",
          "610-0101",
          "610-0117",
          "610-0118",
          "617-0000",
          "617-0004",
          "617-0006",
          "617-0002",
          "617-0005",
          "617-0001",
          "617-0003",
          "617-0811",
          "617-0846",
          "617-0825",
          "617-0831",
          "617-0813",
          "617-0814",
          "617-0815",
          "617-0841",
          "617-0853",
          "617-0826",
          "617-0856",
          "617-0852",
          "617-0837",
          "617-0833",
          "617-0851",
          "617-0854",
          "617-0818",
          "617-0845",
          "617-0855",
          "617-0836",
          "617-0835",
          "617-0847",
          "617-0857",
          "617-0817",
          "617-0827",
          "617-0844",
          "617-0812",
          "617-0824",
          "617-0834",
          "617-0843",
          "617-0823",
          "617-0816",
          "617-0821",
          "617-0822",
          "617-0842",
          "617-0828",
          "617-0832",
          "617-0838",
          "614-0000",
          "614-8256",
          "614-8258",
          "614-8267",
          "614-8254",
          "614-8252",
          "614-8268",
          "614-8255",
          "614-8251",
          "614-8261",
          "614-8253",
          "614-8257",
          "614-8266",
          "614-8262",
          "614-8265",
          "614-8264",
          "614-8263",
          "614-8235",
          "614-8232",
          "614-8231",
          "614-8227",
          "614-8239",
          "614-8234",
          "614-8236",
          "614-8233",
          "614-8229",
          "614-8223",
          "614-8222",
          "614-8249",
          "614-8228",
          "614-8225",
          "614-8238",
          "614-8242",
          "614-8221",
          "614-8248",
          "614-8237",
          "614-8226",
          "614-8244",
          "614-8247",
          "614-8230",
          "614-8245",
          "614-8224",
          "614-8243",
          "614-8246",
          "614-8241",
          "614-8374",
          "614-8366",
          "614-8365",
          "614-8377",
          "614-8372",
          "614-8361",
          "614-8376",
          "614-8367",
          "614-8373",
          "614-8364",
          "614-8362",
          "614-8371",
          "614-8375",
          "614-8363",
          "614-8165",
          "614-8151",
          "614-8158",
          "614-8153",
          "614-8155",
          "614-8159",
          "614-8166",
          "614-8163",
          "614-8156",
          "614-8157",
          "614-8162",
          "614-8152",
          "614-8164",
          "614-8161",
          "614-8154",
          "614-8112",
          "614-8115",
          "614-8102",
          "614-8105",
          "614-8111",
          "613-0851",
          "614-8106",
          "614-8117",
          "614-8113",
          "614-8101",
          "614-8116",
          "614-8104",
          "614-8114",
          "614-8103",
          "614-8294",
          "614-8295",
          "614-8297",
          "614-8296",
          "614-8171",
          "614-8175",
          "614-8173",
          "614-8176",
          "614-8183",
          "614-8174",
          "614-8184",
          "614-8181",
          "614-8172",
          "614-8182",
          "614-8148",
          "614-8143",
          "614-8122",
          "614-8147",
          "614-8124",
          "614-8141",
          "614-8146",
          "614-8121",
          "614-8132",
          "614-8126",
          "614-8133",
          "614-8127",
          "614-8149",
          "614-8125",
          "614-8136",
          "614-8135",
          "614-8134",
          "614-8123",
          "614-8144",
          "614-8145",
          "614-8128",
          "614-8142",
          "614-8131",
          "614-8208",
          "614-8280",
          "614-8207",
          "614-8211",
          "614-8206",
          "614-8216",
          "614-8215",
          "614-8204",
          "614-8203",
          "614-8212",
          "614-8205",
          "614-8202",
          "614-8214",
          "614-8201",
          "614-8213",
          "614-8351",
          "614-8353",
          "614-8352",
          "614-8193",
          "614-8194",
          "614-8191",
          "614-8197",
          "614-8195",
          "614-8196",
          "614-8192",
          "614-8345",
          "614-8326",
          "614-8331",
          "614-8349",
          "614-8311",
          "614-8325",
          "614-8315",
          "614-8327",
          "614-8323",
          "614-8342",
          "614-8321",
          "614-8346",
          "614-8312",
          "614-8332",
          "614-8344",
          "614-8322",
          "614-8335",
          "614-8341",
          "614-8334",
          "614-8314",
          "614-8333",
          "614-8324",
          "614-8348",
          "614-8313",
          "614-8347",
          "614-8336",
          "614-8343",
          "614-8292",
          "614-8293",
          "614-8291",
          "614-8289",
          "614-8273",
          "614-8284",
          "614-8282",
          "614-8281",
          "614-8279",
          "614-8286",
          "614-8287",
          "614-8288",
          "614-8275",
          "614-8278",
          "614-8274",
          "614-8271",
          "614-8283",
          "614-8277",
          "614-8276",
          "614-8272",
          "614-8285",
          "614-8057",
          "614-8301",
          "614-8088",
          "614-8043",
          "614-8084",
          "614-8076",
          "614-8066",
          "614-8006",
          "614-8072",
          "614-8077",
          "614-8011",
          "614-8302",
          "614-8055",
          "614-8036",
          "614-8087",
          "614-8086",
          "614-8063",
          "614-8014",
          "614-8095",
          "614-8045",
          "614-8025",
          "614-8304",
          "614-8044",
          "614-8071",
          "614-8031",
          "614-8081",
          "614-8035",
          "614-8303",
          "614-8307",
          "614-8042",
          "614-8046",
          "614-8306",
          "614-8075",
          "614-8096",
          "614-8093",
          "614-8061",
          "614-8073",
          "614-8001",
          "614-8017",
          "614-8062",
          "614-8092",
          "614-8082",
          "614-8053",
          "614-8068",
          "614-8003",
          "614-8024",
          "614-8038",
          "614-8037",
          "614-8005",
          "614-8015",
          "614-8047",
          "614-8002",
          "614-8079",
          "614-8039",
          "614-8058",
          "614-8067",
          "613-0853",
          "614-8023",
          "614-8033",
          "614-8007",
          "614-8085",
          "614-8032",
          "614-8022",
          "614-8030",
          "614-8048",
          "613-0852",
          "614-8091",
          "614-8094",
          "614-8008",
          "614-8078",
          "614-8056",
          "614-8034",
          "614-8064",
          "614-8054",
          "614-8052",
          "614-8026",
          "614-8021",
          "614-8305",
          "614-8308",
          "614-8016",
          "614-8065",
          "614-8004",
          "614-8051",
          "614-8083",
          "614-8012",
          "614-8013",
          "614-8041",
          "614-8074",
          "610-0300",
          "610-0312",
          "610-0324",
          "610-0343",
          "610-0351",
          "610-0352",
          "610-0361",
          "610-0333",
          "610-0311",
          "610-0332",
          "610-0325",
          "610-0341",
          "610-0321",
          "610-0331",
          "610-0334",
          "610-0326",
          "610-0315",
          "610-0362",
          "610-0322",
          "610-0342",
          "610-0353",
          "610-0323",
          "610-0314",
          "610-0313",
          "610-0356",
          "610-0357",
          "610-0355",
          "610-0354",
          "627-0000",
          "629-3104",
          "629-3101",
          "629-3134",
          "629-3103",
          "629-3112",
          "629-3241",
          "629-3135",
          "629-3132",
          "629-3133",
          "629-3113",
          "629-3246",
          "629-3121",
          "629-3102",
          "629-3136",
          "629-3131",
          "629-3244",
          "629-3122",
          "629-3245",
          "629-3242",
          "629-3243",
          "629-3111",
          "629-2514",
          "629-2512",
          "629-2531",
          "629-2533",
          "629-2511",
          "629-2501",
          "629-2502",
          "629-2534",
          "629-2515",
          "629-2503",
          "629-2504",
          "629-2532",
          "629-2513",
          "629-2522",
          "629-2523",
          "629-2521",
          "629-3410",
          "629-3424",
          "629-3571",
          "629-3443",
          "629-3566",
          "629-3573",
          "629-3576",
          "629-3574",
          "629-3435",
          "629-3438",
          "629-3555",
          "629-3436",
          "629-3423",
          "629-3414",
          "629-3412",
          "629-3422",
          "629-3421",
          "629-3575",
          "629-3431",
          "629-3441",
          "629-3416",
          "629-3413",
          "629-3556",
          "629-3411",
          "629-3415",
          "629-3442",
          "629-3565",
          "629-3448",
          "629-3405",
          "629-3554",
          "629-3562",
          "629-3433",
          "629-3445",
          "629-3401",
          "629-3564",
          "629-3570",
          "629-3407",
          "629-3408",
          "629-3579",
          "629-3437",
          "629-3557",
          "629-3559",
          "629-3404",
          "629-3447",
          "629-3551",
          "629-3553",
          "629-3402",
          "629-3572",
          "629-3444",
          "629-3409",
          "629-3552",
          "629-3561",
          "629-3578",
          "629-3406",
          "629-3432",
          "629-3563",
          "629-3577",
          "629-3446",
          "629-3558",
          "629-3434",
          "629-3403",
          "629-3449",
          "627-0227",
          "627-0248",
          "627-0237",
          "627-0235",
          "627-0224",
          "627-0241",
          "627-0247",
          "627-0211",
          "627-0244",
          "627-0239",
          "627-0225",
          "627-0242",
          "627-0238",
          "627-0232",
          "627-0214",
          "627-0215",
          "627-0202",
          "627-0245",
          "627-0201",
          "627-0221",
          "627-0246",
          "627-0216",
          "627-0234",
          "627-0243",
          "627-0231",
          "627-0236",
          "627-0222",
          "627-0233",
          "627-0226",
          "627-0228",
          "627-0212",
          "627-0249",
          "627-0223",
          "627-0213",
          "627-0006",
          "627-0004",
          "627-0007",
          "627-0034",
          "627-0036",
          "627-0023",
          "627-0022",
          "627-0035",
          "627-0052",
          "627-0044",
          "627-0031",
          "627-0025",
          "627-0014",
          "627-0033",
          "627-0005",
          "627-0012",
          "627-0041",
          "627-0011",
          "627-0037",
          "627-0003",
          "627-0042",
          "627-0032",
          "627-0051",
          "627-0045",
          "627-0043",
          "627-0001",
          "627-0054",
          "627-0038",
          "627-0013",
          "627-0026",
          "627-0053",
          "627-0024",
          "627-0027",
          "627-0002",
          "627-0021",
          "627-0144",
          "627-0122",
          "627-0132",
          "627-0145",
          "627-0142",
          "627-0141",
          "627-0102",
          "627-0121",
          "627-0112",
          "627-0133",
          "627-0101",
          "627-0143",
          "627-0111",
          "627-0123",
          "627-0131",
          "622-0000",
          "622-0063",
          "622-0012",
          "622-0021",
          "622-0065",
          "622-0033",
          "622-0054",
          "622-0036",
          "622-0043",
          "622-0041",
          "622-0011",
          "622-0014",
          "622-0016",
          "622-0015",
          "622-0046",
          "622-0022",
          "622-0034",
          "622-0052",
          "622-0047",
          "622-0004",
          "622-0042",
          "622-0035",
          "622-0055",
          "622-0044",
          "622-0023",
          "622-0003",
          "622-0024",
          "622-0025",
          "622-0032",
          "622-0062",
          "622-0057",
          "622-0061",
          "622-0056",
          "622-0045",
          "622-0031",
          "622-0053",
          "622-0064",
          "622-0013",
          "622-0002",
          "622-0059",
          "622-0066",
          "622-0001",
          "622-0051",
          "622-0017",
          "622-0058",
          "629-0334",
          "629-0312",
          "629-0331",
          "629-0332",
          "629-0311",
          "629-0321",
          "629-0302",
          "629-0323",
          "629-0341",
          "629-0335",
          "629-0333",
          "629-0313",
          "629-0301",
          "629-0322",
          "601-0722",
          "601-0703",
          "601-0723",
          "601-0754",
          "601-0742",
          "601-0724",
          "601-0701",
          "601-0772",
          "601-0778",
          "601-0775",
          "601-0777",
          "601-0721",
          "601-0771",
          "601-0714",
          "601-0712",
          "601-0705",
          "601-0755",
          "601-0751",
          "601-0715",
          "601-0732",
          "601-0744",
          "601-0753",
          "601-0704",
          "601-0702",
          "601-0761",
          "601-0716",
          "601-0762",
          "601-0763",
          "601-0713",
          "601-0734",
          "601-0752",
          "601-0733",
          "601-0741",
          "601-0774",
          "601-0735",
          "601-0765",
          "601-0731",
          "601-0773",
          "601-0711",
          "601-0743",
          "601-0776",
          "601-0764",
          "629-0122",
          "629-0112",
          "629-0164",
          "629-0152",
          "629-0113",
          "629-0271",
          "629-0133",
          "629-0114",
          "629-0131",
          "629-0165",
          "629-0154",
          "629-0163",
          "629-0162",
          "629-0134",
          "629-0111",
          "629-0104",
          "629-0121",
          "629-0101",
          "629-0161",
          "629-0151",
          "629-0166",
          "629-0102",
          "629-0103",
          "629-0132",
          "629-0141",
          "629-0153",
          "629-0115",
          "619-0200",
          "619-0213",
          "619-0212",
          "619-0215",
          "619-0211",
          "619-0224",
          "619-1102",
          "619-1133",
          "619-1112",
          "619-1153",
          "619-1154",
          "619-1142",
          "619-1132",
          "619-1103",
          "619-1107",
          "619-1104",
          "619-1143",
          "619-1113",
          "619-1121",
          "619-1136",
          "619-1152",
          "619-1124",
          "619-1126",
          "619-1101",
          "619-1125",
          "619-1144",
          "619-1131",
          "619-1105",
          "619-1135",
          "619-1134",
          "619-1141",
          "619-1151",
          "619-1122",
          "619-1123",
          "619-1111",
          "619-1106",
          "619-0214",
          "619-0225",
          "619-0217",
          "619-0216",
          "619-0222",
          "619-0223",
          "619-0218",
          "619-1127",
          "619-0221",
          "619-0201",
          "619-0204",
          "619-0206",
          "619-0203",
          "619-0205",
          "619-0202",
          "618-0000",
          "618-0091",
          "618-0071",
          "618-0081",
          "613-0000",
          "613-0022",
          "613-0046",
          "613-0025",
          "613-0045",
          "613-0032",
          "613-0031",
          "613-0034",
          "613-0043",
          "613-0035",
          "613-0036",
          "613-0041",
          "613-0026",
          "613-0023",
          "613-0033",
          "613-0021",
          "613-0044",
          "613-0042",
          "613-0024",
          "610-0302",
          "610-0301",
          "610-0303",
          "610-0200",
          "610-0252",
          "610-0261",
          "610-0211",
          "610-0251",
          "610-0255",
          "610-0201",
          "610-0231",
          "610-0253",
          "610-0241",
          "610-0254",
          "610-0221",
          "610-0202",
          "619-1300",
          "619-1302",
          "619-1301",
          "619-1303",
          "619-1304",
          "619-1200",
          "619-1221",
          "619-1225",
          "619-1212",
          "619-1224",
          "619-1226",
          "619-1222",
          "619-1201",
          "619-1223",
          "619-1205",
          "619-1202",
          "619-1211",
          "619-1213",
          "619-1204",
          "619-1203",
          "619-0233",
          "619-0236",
          "619-0244",
          "619-0247",
          "619-0232",
          "619-0234",
          "619-0245",
          "619-0242",
          "619-0238",
          "619-0235",
          "619-0237",
          "619-0246",
          "619-0241",
          "619-0240",
          "619-0243",
          "619-0231",
          "619-1400",
          "619-1411",
          "619-1422",
          "619-1421",
          "619-1401",
          "619-1402",
          "619-1412",
          "622-0200",
          "629-1141",
          "622-0301",
          "622-0323",
          "629-1116",
          "622-0212",
          "629-1143",
          "629-1142",
          "622-0304",
          "622-0312",
          "622-0236",
          "622-0211",
          "629-1117",
          "629-1111",
          "629-1145",
          "629-1122",
          "622-0322",
          "629-1133",
          "622-0445",
          "622-0442",
          "622-0444",
          "629-1108",
          "622-0452",
          "629-1102",
          "622-0223",
          "622-0325",
          "622-0214",
          "629-1135",
          "622-0441",
          "629-1131",
          "622-0303",
          "622-0234",
          "629-1112",
          "622-0315",
          "622-0202",
          "622-0332",
          "629-1104",
          "629-1105",
          "622-0451",
          "629-1103",
          "622-0201",
          "622-0213",
          "622-0222",
          "622-0232",
          "622-0224",
          "622-0331",
          "622-0316",
          "622-0203",
          "622-0231",
          "629-1132",
          "629-1113",
          "629-1115",
          "629-1107",
          "622-0321",
          "622-0324",
          "622-0443",
          "629-1134",
          "629-1144",
          "622-0313",
          "629-1106",
          "629-1101",
          "629-1121",
          "629-1114",
          "622-0314",
          "622-0453",
          "622-0221",
          "622-0302",
          "622-0233",
          "622-0235",
          "622-0311",
          "626-0400",
          "626-0415",
          "626-0422",
          "626-0401",
          "626-0424",
          "626-0431",
          "626-0402",
          "626-0412",
          "626-0417",
          "626-0413",
          "626-0421",
          "626-0433",
          "626-0411",
          "626-0416",
          "626-0425",
          "626-0423",
          "626-0432",
          "626-0405",
          "626-0404",
          "626-0403",
          "626-0414",
          "629-2200",
          "629-2411",
          "629-2413",
          "629-2311",
          "629-2303",
          "629-2262",
          "629-2314",
          "629-2404",
          "629-2261",
          "629-2412",
          "629-2421",
          "629-2301",
          "629-2403",
          "629-2401",
          "629-2402",
          "629-2302",
          "629-2422",
          "629-2313",
          "629-2263",
          "629-2423",
          "629-2312",
          "534-0000",
          "534-0026",
          "534-0013",
          "534-0025",
          "534-0001",
          "534-0015",
          "534-0002",
          "534-0011",
          "534-0016",
          "534-0027",
          "534-0024",
          "534-0022",
          "534-0021",
          "534-0023",
          "534-0014",
          "534-0012",
          "553-0000",
          "553-0001",
          "553-0007",
          "553-0002",
          "553-0004",
          "553-0005",
          "553-0003",
          "553-0006",
          "554-0000",
          "554-0011",
          "554-0032",
          "554-0022",
          "554-0023",
          "554-0021",
          "554-0031",
          "554-0014",
          "554-0024",
          "554-0001",
          "554-0052",
          "554-0002",
          "554-0051",
          "554-0012",
          "554-0013",
          "554-0033",
          "554-0041",
          "554-0042",
          "554-0043",
          "550-0000",
          "550-0026",
          "550-0011",
          "550-0012",
          "550-0004",
          "550-0002",
          "550-0006",
          "550-0021",
          "550-0014",
          "550-0003",
          "550-0027",
          "550-0025",
          "550-0024",
          "550-0013",
          "550-0023",
          "550-0001",
          "550-0005",
          "550-0022",
          "550-0015",
          "552-0000",
          "552-0015",
          "552-0006",
          "552-0003",
          "552-0012",
          "552-0002",
          "552-0022",
          "552-0023",
          "552-0005",
          "552-0021",
          "552-0001",
          "552-0013",
          "552-0007",
          "552-0016",
          "552-0011",
          "552-0014",
          "552-0004",
          "551-0000",
          "551-0031",
          "551-0033",
          "551-0032",
          "551-0011",
          "551-0013",
          "551-0002",
          "551-0001",
          "551-0003",
          "551-0023",
          "551-0012",
          "551-0022",
          "551-0021",
          "543-0000",
          "543-0023",
          "543-0022",
          "543-0073",
          "543-0072",
          "543-0071",
          "543-0031",
          "543-0002",
          "543-0037",
          "543-0001",
          "543-0016",
          "543-0062",
          "543-0028",
          "543-0043",
          "543-0018",
          "543-0042",
          "543-0012",
          "543-0053",
          "543-0035",
          "543-0044",
          "543-0036",
          "543-0032",
          "543-0015",
          "543-0076",
          "543-0051",
          "543-0011",
          "543-0025",
          "543-0017",
          "543-0041",
          "543-0052",
          "543-0013",
          "543-0014",
          "543-0063",
          "543-0045",
          "543-0033",
          "543-0026",
          "543-0021",
          "543-0055",
          "543-0027",
          "543-0024",
          "543-0056",
          "543-0034",
          "543-0054",
          "543-0075",
          "543-0061",
          "543-0074",
          "556-0000",
          "556-0029",
          "556-0023",
          "556-0013",
          "556-0002",
          "556-0003",
          "556-0027",
          "556-0028",
          "556-0021",
          "556-0022",
          "556-0024",
          "556-0012",
          "556-0015",
          "556-0001",
          "556-0014",
          "556-0020",
          "556-0025",
          "556-0026",
          "556-0011",
          "556-0005",
          "556-0006",
          "556-0004",
          "556-0017",
          "556-0016",
          "555-0000",
          "555-0021",
          "555-0043",
          "555-0032",
          "555-0022",
          "555-0011",
          "555-0013",
          "555-0001",
          "555-0031",
          "555-0041",
          "555-0042",
          "555-0024",
          "555-0023",
          "555-0025",
          "555-0033",
          "555-0044",
          "555-0034",
          "555-0012",
          "533-0000",
          "533-0007",
          "533-0032",
          "533-0001",
          "533-0015",
          "533-0006",
          "533-0002",
          "533-0024",
          "533-0004",
          "533-0021",
          "533-0005",
          "533-0022",
          "533-0011",
          "533-0012",
          "533-0013",
          "533-0031",
          "533-0023",
          "533-0033",
          "533-0014",
          "533-0003",
          "537-0000",
          "537-0012",
          "537-0014",
          "537-0013",
          "537-0003",
          "537-0023",
          "537-0025",
          "537-0022",
          "537-0011",
          "537-0024",
          "537-0021",
          "537-0002",
          "537-0001",
          "544-0000",
          "544-0025",
          "544-0024",
          "544-0021",
          "544-0033",
          "544-0022",
          "544-0002",
          "544-0003",
          "544-0001",
          "544-0011",
          "544-0013",
          "544-0014",
          "544-0012",
          "544-0015",
          "544-0004",
          "544-0031",
          "544-0005",
          "544-0006",
          "544-0032",
          "544-0023",
          "544-0034",
          "535-0000",
          "535-0005",
          "535-0004",
          "535-0011",
          "535-0002",
          "535-0021",
          "535-0022",
          "535-0012",
          "535-0001",
          "535-0031",
          "535-0003",
          "535-0013",
          "536-0000",
          "536-0002",
          "536-0004",
          "536-0003",
          "536-0016",
          "536-0015",
          "536-0017",
          "536-0013",
          "536-0014",
          "536-0021",
          "536-0007",
          "536-0008",
          "536-0005",
          "536-0012",
          "536-0024",
          "536-0022",
          "536-0006",
          "536-0011",
          "536-0023",
          "536-0001",
          "536-0025",
          "545-0000",
          "545-0033",
          "545-0051",
          "545-0052",
          "545-6090",
          "545-6001",
          "545-6002",
          "545-6003",
          "545-6004",
          "545-6005",
          "545-6006",
          "545-6007",
          "545-6008",
          "545-6009",
          "545-6010",
          "545-6011",
          "545-6012",
          "545-6013",
          "545-6014",
          "545-6015",
          "545-6016",
          "545-6017",
          "545-6018",
          "545-6019",
          "545-6020",
          "545-6021",
          "545-6022",
          "545-6023",
          "545-6024",
          "545-6025",
          "545-6026",
          "545-6027",
          "545-6028",
          "545-6029",
          "545-6030",
          "545-6031",
          "545-6032",
          "545-6033",
          "545-6034",
          "545-6035",
          "545-6036",
          "545-6037",
          "545-6038",
          "545-6039",
          "545-6040",
          "545-6041",
          "545-6042",
          "545-6043",
          "545-6044",
          "545-6045",
          "545-6046",
          "545-6047",
          "545-6048",
          "545-6049",
          "545-6050",
          "545-6051",
          "545-6052",
          "545-6053",
          "545-6054",
          "545-6055",
          "545-6056",
          "545-6057",
          "545-6058",
          "545-6059",
          "545-6060",
          "545-0034",
          "545-0023",
          "545-0035",
          "545-0041",
          "545-0005",
          "545-0011",
          "545-0032",
          "545-0037",
          "545-0002",
          "545-0001",
          "545-0013",
          "545-0014",
          "545-0031",
          "545-0022",
          "545-0021",
          "545-0036",
          "545-0003",
          "545-0004",
          "545-0053",
          "545-0043",
          "545-0042",
          "545-0012",
          "558-0000",
          "558-0021",
          "558-0014",
          "558-0013",
          "558-0015",
          "558-0046",
          "558-0032",
          "558-0011",
          "558-0031",
          "558-0033",
          "558-0022",
          "558-0043",
          "558-0045",
          "558-0047",
          "558-0001",
          "558-0053",
          "558-0054",
          "558-0052",
          "558-0042",
          "558-0003",
          "558-0004",
          "558-0002",
          "558-0044",
          "558-0012",
          "558-0055",
          "558-0056",
          "558-0051",
          "558-0041",
          "558-0023",
          "558-0024",
          "546-0000",
          "546-0003",
          "546-0001",
          "546-0044",
          "546-0002",
          "546-0041",
          "546-0024",
          "546-0043",
          "546-0022",
          "546-0014",
          "546-0031",
          "546-0021",
          "546-0012",
          "546-0034",
          "546-0042",
          "546-0011",
          "546-0032",
          "546-0033",
          "546-0023",
          "546-0035",
          "546-0013",
          "557-0000",
          "557-0032",
          "557-0041",
          "557-0042",
          "557-0061",
          "557-0021",
          "557-0001",
          "557-0052",
          "557-0012",
          "557-0054",
          "557-0055",
          "557-0053",
          "557-0002",
          "557-0051",
          "557-0044",
          "557-0043",
          "557-0045",
          "557-0062",
          "557-0031",
          "557-0024",
          "557-0014",
          "557-0011",
          "557-0003",
          "557-0013",
          "557-0022",
          "557-0025",
          "557-0033",
          "557-0004",
          "557-0015",
          "557-0016",
          "557-0034",
          "557-0063",
          "557-0023",
          "532-0000",
          "532-0031",
          "532-0012",
          "532-0013",
          "532-0025",
          "532-0024",
          "532-0028",
          "532-0023",
          "532-0001",
          "532-0027",
          "532-0021",
          "532-0026",
          "532-0033",
          "532-0011",
          "532-0006",
          "532-0004",
          "532-0022",
          "532-0034",
          "532-0002",
          "532-0005",
          "532-0036",
          "532-0035",
          "532-0032",
          "532-0003",
          "538-0000",
          "538-0042",
          "538-0043",
          "538-0041",
          "538-0053",
          "538-0034",
          "538-0033",
          "538-0044",
          "538-0035",
          "538-0031",
          "538-0054",
          "538-0051",
          "538-0037",
          "538-0032",
          "538-0052",
          "538-0036",
          "559-0000",
          "559-0003",
          "559-0023",
          "559-0011",
          "559-0014",
          "559-0001",
          "559-0007",
          "559-0021",
          "559-0024",
          "559-0004",
          "559-0017",
          "559-0033",
          "559-0031",
          "559-0032",
          "559-0034",
          "559-0016",
          "559-0005",
          "559-0002",
          "559-0006",
          "559-0012",
          "559-0025",
          "559-0026",
          "559-0013",
          "559-0022",
          "559-0015",
          "547-0000",
          "547-0024",
          "547-0022",
          "547-0025",
          "547-0023",
          "547-0004",
          "547-0006",
          "547-0002",
          "547-0005",
          "547-0003",
          "547-0001",
          "547-0027",
          "547-0021",
          "547-0026",
          "547-0034",
          "547-0014",
          "547-0011",
          "547-0016",
          "547-0013",
          "547-0015",
          "547-0012",
          "547-0032",
          "547-0035",
          "547-0042",
          "547-0045",
          "547-0048",
          "547-0044",
          "547-0046",
          "547-0047",
          "547-0043",
          "547-0033",
          "547-0031",
          "547-0041",
          "530-0000",
          "530-0033",
          "530-0021",
          "530-0001",
          "530-0025",
          "530-0011",
          "531-0076",
          "531-6090",
          "531-6001",
          "531-6002",
          "531-6003",
          "531-6004",
          "531-6005",
          "531-6006",
          "531-6007",
          "531-6008",
          "531-6009",
          "531-6010",
          "531-6011",
          "531-6012",
          "531-6013",
          "531-6014",
          "531-6015",
          "531-6016",
          "531-6017",
          "531-6018",
          "531-6019",
          "531-6020",
          "531-6021",
          "531-6022",
          "531-6023",
          "531-6024",
          "531-6025",
          "531-6026",
          "531-6027",
          "531-6028",
          "531-6029",
          "531-6030",
          "531-6031",
          "531-6032",
          "531-6033",
          "531-6034",
          "531-6035",
          "531-6036",
          "531-6037",
          "531-6038",
          "531-6039",
          "531-6190",
          "531-6101",
          "531-6102",
          "531-6103",
          "531-6104",
          "531-6105",
          "531-6106",
          "531-6107",
          "531-6108",
          "531-6109",
          "531-6110",
          "531-6111",
          "531-6112",
          "531-6113",
          "531-6114",
          "531-6115",
          "531-6116",
          "531-6117",
          "531-6118",
          "531-6119",
          "531-6120",
          "531-6121",
          "531-6122",
          "531-6123",
          "531-6124",
          "531-6125",
          "531-6126",
          "531-6127",
          "531-6128",
          "531-6129",
          "531-6130",
          "531-6131",
          "531-6132",
          "531-6133",
          "531-6134",
          "531-6135",
          "531-6136",
          "531-6137",
          "531-6138",
          "531-6139",
          "531-0075",
          "531-0077",
          "530-0017",
          "530-0026",
          "530-0031",
          "530-0023",
          "530-0038",
          "531-0064",
          "530-0018",
          "530-0012",
          "530-0053",
          "530-0046",
          "530-0057",
          "530-0002",
          "530-0051",
          "530-0013",
          "530-0014",
          "530-0045",
          "530-0041",
          "531-0041",
          "530-0043",
          "530-0042",
          "530-6090",
          "530-6001",
          "530-6002",
          "530-6003",
          "530-6004",
          "530-6005",
          "530-6006",
          "530-6007",
          "530-6008",
          "530-6009",
          "530-6010",
          "530-6011",
          "530-6012",
          "530-6013",
          "530-6014",
          "530-6015",
          "530-6016",
          "530-6017",
          "530-6018",
          "530-6019",
          "530-6020",
          "530-6021",
          "530-6022",
          "530-6023",
          "530-6024",
          "530-6025",
          "530-6026",
          "530-6027",
          "530-6028",
          "530-6029",
          "530-6030",
          "530-6031",
          "530-6032",
          "530-6033",
          "530-6034",
          "530-6035",
          "530-6036",
          "530-6037",
          "530-6038",
          "530-6039",
          "530-0003",
          "530-0004",
          "530-0035",
          "530-0027",
          "530-0056",
          "531-0072",
          "530-0016",
          "530-0015",
          "531-0071",
          "530-0005",
          "530-6190",
          "530-6101",
          "530-6102",
          "530-6103",
          "530-6104",
          "530-6105",
          "530-6106",
          "530-6107",
          "530-6108",
          "530-6109",
          "530-6110",
          "530-6111",
          "530-6112",
          "530-6113",
          "530-6114",
          "530-6115",
          "530-6116",
          "530-6117",
          "530-6118",
          "530-6119",
          "530-6120",
          "530-6121",
          "530-6122",
          "530-6123",
          "530-6124",
          "530-6125",
          "530-6126",
          "530-6127",
          "530-6128",
          "530-6129",
          "530-6130",
          "530-6131",
          "530-6132",
          "530-6133",
          "530-6134",
          "530-6135",
          "531-0062",
          "531-0063",
          "531-0061",
          "530-0022",
          "530-0034",
          "530-0047",
          "530-0055",
          "530-0028",
          "530-0044",
          "530-0032",
          "531-0074",
          "531-0073",
          "530-0037",
          "530-0052",
          "530-0054",
          "530-0024",
          "530-0036",
          "539-0000",
          "541-0052",
          "541-0047",
          "542-0061",
          "540-0019",
          "540-0022",
          "541-0042",
          "542-0064",
          "542-0062",
          "540-0005",
          "540-0038",
          "540-0013",
          "540-0037",
          "540-0026",
          "540-0002",
          "540-0021",
          "540-0008",
          "541-0048",
          "542-0066",
          "540-0016",
          "541-0057",
          "540-0023",
          "541-0041",
          "540-0031",
          "541-0056",
          "542-0072",
          "541-0043",
          "540-0018",
          "540-0033",
          "540-0010",
          "542-0082",
          "540-0034",
          "540-0015",
          "540-0001",
          "540-6190",
          "540-6101",
          "540-6102",
          "540-6103",
          "540-6104",
          "540-6105",
          "540-6106",
          "540-6107",
          "540-6108",
          "540-6109",
          "540-6110",
          "540-6111",
          "540-6112",
          "540-6113",
          "540-6114",
          "540-6115",
          "540-6116",
          "540-6117",
          "540-6118",
          "540-6119",
          "540-6120",
          "540-6121",
          "540-6122",
          "540-6123",
          "540-6124",
          "540-6125",
          "540-6126",
          "540-6127",
          "540-6128",
          "540-6129",
          "540-6130",
          "540-6131",
          "540-6132",
          "540-6133",
          "540-6134",
          "540-6135",
          "540-6136",
          "540-6137",
          "540-6138",
          "540-6090",
          "540-6001",
          "540-6002",
          "540-6003",
          "540-6004",
          "540-6005",
          "540-6006",
          "540-6007",
          "540-6008",
          "540-6009",
          "540-6010",
          "540-6011",
          "540-6012",
          "540-6013",
          "540-6014",
          "540-6015",
          "540-6016",
          "540-6017",
          "540-6018",
          "540-6019",
          "540-6020",
          "540-6021",
          "540-6022",
          "540-6023",
          "540-6024",
          "540-6025",
          "540-6026",
          "540-6027",
          "540-6028",
          "540-6029",
          "540-6030",
          "540-6031",
          "540-6032",
          "540-6033",
          "540-6034",
          "540-6035",
          "540-6036",
          "540-6037",
          "540-6290",
          "540-6201",
          "540-6202",
          "540-6203",
          "540-6204",
          "540-6205",
          "540-6206",
          "540-6207",
          "540-6208",
          "540-6209",
          "540-6210",
          "540-6211",
          "540-6212",
          "540-6213",
          "540-6214",
          "540-6215",
          "540-6216",
          "540-6217",
          "540-6218",
          "540-6219",
          "540-6220",
          "540-6221",
          "540-6222",
          "540-6223",
          "540-6224",
          "540-6225",
          "540-6226",
          "540-6227",
          "540-6228",
          "540-6229",
          "540-6230",
          "540-6231",
          "540-6232",
          "540-6233",
          "540-6234",
          "540-6235",
          "540-6236",
          "540-6237",
          "540-6238",
          "540-6390",
          "540-6301",
          "540-6302",
          "540-6303",
          "540-6304",
          "540-6305",
          "540-6306",
          "540-6307",
          "540-6308",
          "540-6309",
          "540-6310",
          "540-6311",
          "540-6312",
          "540-6313",
          "540-6314",
          "540-6315",
          "540-6316",
          "540-6317",
          "540-6318",
          "540-6319",
          "540-6320",
          "540-6321",
          "540-6322",
          "540-6323",
          "540-6324",
          "540-6325",
          "540-6326",
          "542-0085",
          "542-0074",
          "541-0055",
          "542-0084",
          "540-0012",
          "542-0012",
          "540-0004",
          "540-0035",
          "540-0032",
          "542-0063",
          "540-0028",
          "540-0025",
          "542-0077",
          "542-0071",
          "541-0045",
          "542-0065",
          "542-0076",
          "542-0075",
          "542-0086",
          "542-0073",
          "540-0011",
          "541-0059",
          "540-0007",
          "540-0039",
          "542-0083",
          "541-0046",
          "541-0051",
          "541-0044",
          "540-0036",
          "540-0006",
          "541-0053",
          "540-0029",
          "542-0067",
          "540-0017",
          "541-0058",
          "540-0024",
          "542-0081",
          "541-0054",
          "540-0003",
          "540-0027",
          "540-0014",
          "590-0000",
          "590-0012",
          "590-0809",
          "590-0808",
          "590-0807",
          "590-0055",
          "590-0926",
          "590-0925",
          "590-0823",
          "590-0814",
          "590-0048",
          "590-0951",
          "590-0952",
          "590-0018",
          "590-0065",
          "590-0027",
          "590-0985",
          "590-0948",
          "590-0945",
          "590-0824",
          "590-0959",
          "590-0954",
          "590-0974",
          "590-0975",
          "590-0977",
          "590-0976",
          "590-0061",
          "590-0001",
          "590-0982",
          "590-0950",
          "590-0953",
          "590-0011",
          "590-0837",
          "590-0827",
          "590-0812",
          "590-0813",
          "590-0984",
          "590-0076",
          "590-0071",
          "590-0004",
          "590-0007",
          "590-0017",
          "590-0928",
          "590-0923",
          "590-0986",
          "590-0074",
          "590-0921",
          "590-0922",
          "590-0037",
          "590-0021",
          "590-0062",
          "590-0054",
          "590-0822",
          "590-0006",
          "590-0939",
          "590-0934",
          "590-0949",
          "590-0944",
          "590-0836",
          "590-0947",
          "590-0946",
          "590-0940",
          "590-0943",
          "590-0024",
          "590-0026",
          "590-0025",
          "590-0044",
          "590-0057",
          "590-0941",
          "590-0942",
          "590-0051",
          "590-0971",
          "590-0927",
          "590-0924",
          "590-0031",
          "590-0046",
          "590-0906",
          "590-0981",
          "590-0045",
          "590-0042",
          "590-0911",
          "590-0913",
          "590-0013",
          "590-0958",
          "590-0955",
          "590-0937",
          "590-0936",
          "590-0960",
          "590-0963",
          "590-0825",
          "590-0969",
          "590-0964",
          "590-0056",
          "590-0079",
          "590-0938",
          "590-0935",
          "590-0826",
          "590-0002",
          "590-0973",
          "590-0035",
          "590-0801",
          "590-0821",
          "590-0820",
          "590-0003",
          "590-0908",
          "590-0014",
          "590-0987",
          "590-0901",
          "590-0833",
          "590-0834",
          "590-0831",
          "590-0832",
          "590-0905",
          "590-0961",
          "590-0962",
          "590-0077",
          "590-0072",
          "590-0016",
          "590-0033",
          "590-0957",
          "590-0956",
          "590-0022",
          "590-0063",
          "590-0912",
          "590-0811",
          "590-0066",
          "590-0931",
          "590-0932",
          "590-0032",
          "590-0835",
          "590-0047",
          "590-0803",
          "590-0034",
          "590-0829",
          "590-0903",
          "590-0902",
          "590-0028",
          "590-0806",
          "590-0805",
          "590-0804",
          "590-0907",
          "590-0078",
          "590-0073",
          "590-0904",
          "590-0005",
          "590-0008",
          "590-0015",
          "590-0968",
          "590-0965",
          "590-0075",
          "590-0967",
          "590-0966",
          "590-0036",
          "590-0023",
          "590-0064",
          "590-0802",
          "590-0053",
          "590-0052",
          "590-0930",
          "590-0933",
          "590-0828",
          "590-0983",
          "590-0972",
          "590-0041",
          "590-0043",
          "599-0000",
          "599-8244",
          "599-8233",
          "599-8231",
          "599-8266",
          "599-8276",
          "599-8264",
          "599-8232",
          "599-8246",
          "599-8245",
          "599-8242",
          "599-8234",
          "599-8252",
          "599-8238",
          "599-8267",
          "599-8262",
          "599-8265",
          "599-8263",
          "599-8275",
          "599-8247",
          "599-8251",
          "599-8271",
          "599-8236",
          "599-8273",
          "599-8272",
          "599-8248",
          "599-8235",
          "599-8237",
          "599-8253",
          "599-8241",
          "599-8254",
          "599-8261",
          "599-8243",
          "599-8274",
          "599-8102",
          "599-8126",
          "599-8123",
          "599-8127",
          "599-8122",
          "599-8107",
          "599-8115",
          "599-8121",
          "599-8128",
          "599-8125",
          "599-8116",
          "599-8111",
          "599-8113",
          "599-8114",
          "599-8112",
          "599-8104",
          "599-8103",
          "599-8124",
          "599-8101",
          "593-0000",
          "592-8332",
          "593-8301",
          "593-8303",
          "593-8304",
          "593-8328",
          "593-8327",
          "593-8326",
          "593-8324",
          "593-8325",
          "593-8311",
          "593-8312",
          "593-8308",
          "593-8313",
          "593-8329",
          "593-8314",
          "592-8331",
          "592-8351",
          "592-8352",
          "593-8322",
          "593-8323",
          "592-8334",
          "592-8333",
          "592-8335",
          "592-8346",
          "592-8345",
          "592-8348",
          "592-8347",
          "592-8349",
          "592-8342",
          "592-8341",
          "592-8344",
          "592-8343",
          "593-8317",
          "593-8306",
          "593-8315",
          "593-8307",
          "593-8302",
          "593-8305",
          "593-8321",
          "593-8316",
          "590-0100",
          "590-0144",
          "590-0126",
          "590-0156",
          "590-0112",
          "590-0153",
          "590-0145",
          "590-0121",
          "590-0122",
          "590-0138",
          "590-0151",
          "590-0123",
          "590-0137",
          "590-0143",
          "590-0158",
          "590-0157",
          "590-0117",
          "590-0105",
          "590-0115",
          "590-0131",
          "590-0104",
          "590-0127",
          "590-0106",
          "590-0133",
          "590-0155",
          "590-0124",
          "590-0125",
          "590-0132",
          "590-0113",
          "590-0142",
          "590-0103",
          "590-0135",
          "590-0114",
          "590-0134",
          "590-0136",
          "590-0154",
          "590-0111",
          "590-0101",
          "590-0141",
          "590-0116",
          "590-0152",
          "590-0102",
          "591-0000",
          "591-8007",
          "591-8022",
          "591-8043",
          "591-8002",
          "591-8004",
          "591-8024",
          "591-8041",
          "591-8021",
          "591-8005",
          "591-8003",
          "591-8001",
          "591-8025",
          "591-8044",
          "591-8012",
          "591-8023",
          "591-8013",
          "591-8008",
          "591-8035",
          "591-8046",
          "591-8042",
          "591-8045",
          "591-8011",
          "591-8006",
          "591-8037",
          "591-8031",
          "591-8032",
          "591-8033",
          "591-8036",
          "591-8034",
          "591-8014",
          "587-0000",
          "587-0003",
          "587-0066",
          "587-0061",
          "587-0063",
          "587-0051",
          "587-0053",
          "587-0002",
          "587-0065",
          "587-0021",
          "587-0031",
          "587-0032",
          "587-0013",
          "587-0041",
          "587-0043",
          "587-0062",
          "587-0001",
          "587-0012",
          "587-0011",
          "587-0014",
          "587-0022",
          "587-0064",
          "587-0052",
          "587-0054",
          "587-0042",
          "596-0000",
          "596-0845",
          "596-0004",
          "596-0813",
          "596-0001",
          "596-0103",
          "596-0804",
          "596-0077",
          "596-0071",
          "596-0105",
          "596-0022",
          "596-0061",
          "596-0114",
          "596-0063",
          "596-0812",
          "596-0814",
          "596-0816",
          "596-0113",
          "596-0822",
          "596-0824",
          "596-0101",
          "596-0111",
          "596-0047",
          "596-0048",
          "596-0827",
          "596-0064",
          "596-0042",
          "596-0073",
          "596-0016",
          "596-0817",
          "596-0051",
          "596-0843",
          "596-0056",
          "596-0833",
          "596-0112",
          "596-0832",
          "596-0055",
          "596-0821",
          "596-0072",
          "596-0826",
          "596-0815",
          "596-0015",
          "596-0811",
          "596-0041",
          "596-0823",
          "596-0012",
          "596-0057",
          "596-0115",
          "596-0066",
          "596-0805",
          "596-0104",
          "596-0834",
          "596-0116",
          "596-0003",
          "596-0062",
          "596-0065",
          "596-0075",
          "596-0835",
          "596-0052",
          "596-0802",
          "596-0044",
          "596-0053",
          "596-0076",
          "596-0831",
          "596-0023",
          "596-0841",
          "596-0844",
          "596-0825",
          "596-0005",
          "596-0035",
          "596-0031",
          "596-0026",
          "596-0033",
          "596-0034",
          "596-0036",
          "596-0037",
          "596-0024",
          "596-0025",
          "596-0032",
          "596-0006",
          "596-0803",
          "596-0807",
          "596-0046",
          "596-0045",
          "596-0074",
          "596-0842",
          "596-0021",
          "596-0806",
          "596-0808",
          "596-0801",
          "596-0014",
          "596-0078",
          "596-0067",
          "596-0043",
          "596-0054",
          "596-0011",
          "596-0828",
          "596-0102",
          "596-0049",
          "596-0836",
          "596-0002",
          "596-0013",
          "560-0000",
          "560-0015",
          "561-0865",
          "560-0042",
          "561-0854",
          "561-0842",
          "560-0013",
          "560-0011",
          "560-0012",
          "560-0051",
          "561-0824",
          "560-0023",
          "561-0885",
          "561-0883",
          "561-0884",
          "561-0813",
          "560-0052",
          "561-0894",
          "560-0085",
          "561-0823",
          "560-0022",
          "561-0812",
          "560-0001",
          "560-0014",
          "560-0016",
          "561-0843",
          "560-0054",
          "561-0828",
          "560-0055",
          "561-0826",
          "560-0004",
          "561-0833",
          "561-0834",
          "561-0836",
          "561-0831",
          "561-0832",
          "561-0835",
          "561-0803",
          "560-0082",
          "560-0083",
          "560-0084",
          "560-0081",
          "560-0024",
          "560-0041",
          "561-0829",
          "560-0046",
          "561-0802",
          "561-0801",
          "561-0804",
          "561-0827",
          "560-0025",
          "560-0026",
          "561-0874",
          "561-0875",
          "561-0872",
          "561-0845",
          "561-0846",
          "561-0844",
          "560-0045",
          "560-0044",
          "561-0881",
          "561-0862",
          "560-0005",
          "561-0855",
          "561-0891",
          "561-0857",
          "561-0852",
          "561-0858",
          "561-0853",
          "561-0851",
          "561-0859",
          "561-0873",
          "561-0817",
          "561-0806",
          "561-0808",
          "561-0805",
          "561-0807",
          "561-0861",
          "561-0871",
          "560-0003",
          "561-0821",
          "561-0863",
          "561-0825",
          "561-0893",
          "561-0814",
          "561-0816",
          "561-0815",
          "560-0032",
          "560-0036",
          "560-0034",
          "560-0031",
          "560-0033",
          "561-0856",
          "560-0021",
          "560-0043",
          "561-0822",
          "560-0002",
          "561-0882",
          "560-0035",
          "560-0056",
          "560-0053",
          "561-0841",
          "561-0892",
          "561-0864",
          "561-0811",
          "563-0000",
          "563-0022",
          "563-0051",
          "563-0023",
          "563-0032",
          "563-0027",
          "563-0042",
          "563-0014",
          "563-0034",
          "563-0048",
          "563-0043",
          "563-0058",
          "563-0056",
          "563-0029",
          "563-0028",
          "563-0025",
          "563-0052",
          "563-0050",
          "563-0055",
          "563-0033",
          "563-0038",
          "563-0044",
          "563-0054",
          "563-0053",
          "563-0057",
          "563-0031",
          "563-0035",
          "563-0036",
          "563-0013",
          "563-0059",
          "563-0021",
          "563-0037",
          "563-0024",
          "563-0012",
          "563-0046",
          "563-0017",
          "563-0011",
          "563-0015",
          "563-0041",
          "563-0026",
          "563-0047",
          "563-0045",
          "563-0016",
          "564-0000",
          "565-0802",
          "565-0801",
          "565-0875",
          "564-0083",
          "564-0027",
          "564-0041",
          "564-0032",
          "564-0063",
          "564-0053",
          "565-0806",
          "565-0853",
          "564-0082",
          "564-0045",
          "565-0872",
          "565-0841",
          "564-0037",
          "564-0013",
          "564-0002",
          "564-0011",
          "564-0001",
          "564-0018",
          "564-0036",
          "565-0836",
          "565-0837",
          "564-0015",
          "565-0855",
          "565-0831",
          "565-0833",
          "565-0832",
          "565-0834",
          "564-0017",
          "565-0805",
          "565-0818",
          "564-0028",
          "565-0804",
          "565-0803",
          "564-0014",
          "564-0022",
          "564-0039",
          "565-0826",
          "565-0811",
          "565-0812",
          "565-0813",
          "565-0814",
          "565-0815",
          "565-0844",
          "565-0848",
          "565-0852",
          "565-0847",
          "565-0846",
          "565-0845",
          "565-0843",
          "565-0842",
          "565-0851",
          "564-0024",
          "565-0861",
          "564-0026",
          "565-0835",
          "565-0863",
          "564-0062",
          "565-0862",
          "564-0072",
          "564-0003",
          "564-0051",
          "564-0035",
          "565-0816",
          "565-0817",
          "564-0034",
          "564-0071",
          "564-0004",
          "564-0033",
          "564-0023",
          "564-0016",
          "564-0052",
          "564-0081",
          "565-0873",
          "565-0874",
          "564-0042",
          "564-0061",
          "564-0044",
          "564-0012",
          "564-0043",
          "564-0038",
          "564-0025",
          "564-0021",
          "564-0031",
          "565-0854",
          "565-0822",
          "565-0821",
          "565-0824",
          "565-0823",
          "565-0825",
          "565-0871",
          "564-0073",
          "564-0054",
          "595-0000",
          "595-0053",
          "595-0025",
          "595-0032",
          "595-0031",
          "595-0001",
          "595-0022",
          "595-0024",
          "595-0017",
          "595-0033",
          "595-0046",
          "595-0034",
          "595-0041",
          "595-0003",
          "595-0074",
          "595-0061",
          "595-0028",
          "595-0044",
          "595-0012",
          "595-0038",
          "595-0039",
          "595-0027",
          "595-0014",
          "595-0067",
          "595-0054",
          "595-0035",
          "595-0045",
          "595-0026",
          "595-0043",
          "595-0016",
          "595-0036",
          "595-0073",
          "595-0064",
          "595-0002",
          "595-0066",
          "595-0071",
          "595-0007",
          "595-0011",
          "595-0042",
          "595-0062",
          "595-0004",
          "595-0023",
          "595-0055",
          "595-0052",
          "595-0006",
          "595-0021",
          "595-0051",
          "595-0015",
          "595-0063",
          "595-0072",
          "595-0013",
          "595-0037",
          "595-0005",
          "595-0056",
          "595-0075",
          "595-0065",
          "569-0000",
          "569-1146",
          "569-1123",
          "569-0806",
          "569-0082",
          "569-1134",
          "569-1045",
          "569-1102",
          "569-1101",
          "569-1106",
          "569-1105",
          "569-1104",
          "569-1107",
          "569-1108",
          "569-0027",
          "569-0026",
          "569-1029",
          "569-0015",
          "569-1003",
          "569-1135",
          "569-1111",
          "569-1027",
          "569-1028",
          "569-0083",
          "569-0031",
          "569-0034",
          "569-0078",
          "569-1144",
          "569-1137",
          "569-1118",
          "569-0091",
          "569-0092",
          "569-0053",
          "569-0805",
          "569-1044",
          "569-0073",
          "569-0834",
          "569-0832",
          "569-0836",
          "569-0833",
          "569-0831",
          "569-1018",
          "569-1011",
          "569-0824",
          "569-1133",
          "569-0004",
          "569-0005",
          "569-0006",
          "569-0003",
          "569-0041",
          "569-0816",
          "569-0802",
          "569-0852",
          "569-0072",
          "569-1136",
          "569-1131",
          "569-0061",
          "569-0007",
          "569-1038",
          "569-1115",
          "569-0826",
          "569-0016",
          "569-0804",
          "569-0842",
          "569-0847",
          "569-0841",
          "569-1143",
          "569-0825",
          "569-0818",
          "569-0817",
          "569-0807",
          "569-0084",
          "569-0843",
          "569-1025",
          "569-0823",
          "569-1039",
          "569-0062",
          "569-0064",
          "569-0815",
          "569-0052",
          "569-0065",
          "569-0056",
          "569-0071",
          "569-0075",
          "569-0022",
          "569-1005",
          "569-0036",
          "569-1132",
          "569-0097",
          "569-0803",
          "569-1020",
          "569-0043",
          "569-0801",
          "569-1034",
          "569-1047",
          "569-1002",
          "569-0857",
          "569-0856",
          "569-0087",
          "569-1046",
          "569-1036",
          "569-1122",
          "569-0047",
          "569-0821",
          "569-0822",
          "569-0076",
          "569-1024",
          "569-1117",
          "569-0088",
          "569-0011",
          "569-0067",
          "569-0032",
          "569-1126",
          "569-0057",
          "569-0812",
          "569-1145",
          "569-0814",
          "569-0066",
          "569-1001",
          "569-1041",
          "569-1043",
          "569-1012",
          "569-1014",
          "569-1016",
          "569-1013",
          "569-1017",
          "569-1015",
          "569-1042",
          "569-0045",
          "569-0055",
          "569-1035",
          "569-1127",
          "569-0854",
          "569-0813",
          "569-0827",
          "569-1004",
          "569-0013",
          "569-0014",
          "569-0046",
          "569-0077",
          "569-1054",
          "569-1053",
          "569-0093",
          "569-1116",
          "569-0844",
          "569-0846",
          "569-0845",
          "569-0096",
          "569-0095",
          "569-1147",
          "569-1051",
          "569-0044",
          "569-0012",
          "569-0002",
          "569-1037",
          "569-0811",
          "569-1141",
          "569-0024",
          "569-1022",
          "569-0035",
          "569-0033",
          "569-0025",
          "569-1114",
          "569-1113",
          "569-1112",
          "569-1109",
          "569-0074",
          "569-0021",
          "569-1121",
          "569-0855",
          "569-0023",
          "569-1031",
          "569-0086",
          "569-0835",
          "569-1026",
          "569-0094",
          "569-1124",
          "569-0042",
          "569-0063",
          "569-0851",
          "569-0085",
          "569-1023",
          "569-1142",
          "569-1032",
          "569-1033",
          "569-0081",
          "569-1125",
          "569-1128",
          "569-0853",
          "569-0051",
          "569-1103",
          "569-1021",
          "569-0001",
          "569-1052",
          "569-0054",
          "597-0000",
          "597-0081",
          "597-0082",
          "597-0083",
          "597-0061",
          "597-0051",
          "597-0112",
          "597-0074",
          "597-0071",
          "597-0011",
          "597-0113",
          "597-0031",
          "597-0052",
          "597-0075",
          "597-0001",
          "597-0021",
          "597-0102",
          "597-0062",
          "597-0107",
          "597-0053",
          "597-0002",
          "597-0041",
          "596-0901",
          "597-0111",
          "597-0012",
          "597-0014",
          "597-0013",
          "597-0054",
          "597-0084",
          "597-0003",
          "597-0032",
          "597-0042",
          "597-0022",
          "597-0091",
          "597-0093",
          "597-0063",
          "597-0094",
          "597-0092",
          "597-0004",
          "597-0043",
          "597-0106",
          "597-0072",
          "597-0103",
          "597-0033",
          "597-0085",
          "597-0046",
          "597-0023",
          "597-0015",
          "597-0101",
          "597-0104",
          "597-0045",
          "590-0461",
          "597-0105",
          "597-0095",
          "597-0005",
          "597-0044",
          "597-0073",
          "570-0000",
          "570-0022",
          "570-0071",
          "570-0066",
          "570-0087",
          "570-0036",
          "570-0054",
          "570-0051",
          "570-0037",
          "570-0012",
          "570-0009",
          "570-0033",
          "570-0015",
          "570-0055",
          "570-0079",
          "570-0024",
          "570-0038",
          "570-0032",
          "570-0011",
          "570-0094",
          "570-0083",
          "570-0077",
          "570-0061",
          "570-0034",
          "570-0027",
          "570-0002",
          "570-0017",
          "570-0001",
          "570-0072",
          "570-0056",
          "570-0007",
          "570-0026",
          "570-0098",
          "570-0096",
          "570-0003",
          "570-0016",
          "570-0063",
          "570-0043",
          "570-0053",
          "570-0076",
          "570-0065",
          "570-0086",
          "570-0025",
          "570-0042",
          "570-0048",
          "570-0047",
          "570-0073",
          "570-0035",
          "570-0041",
          "570-0014",
          "570-0082",
          "570-0064",
          "570-0092",
          "570-0031",
          "570-0039",
          "570-0093",
          "570-0062",
          "570-0013",
          "570-0023",
          "570-0081",
          "570-0078",
          "570-0074",
          "570-0075",
          "570-0091",
          "570-0028",
          "570-0052",
          "570-0085",
          "570-0084",
          "570-0045",
          "570-0044",
          "570-0046",
          "570-0097",
          "570-0005",
          "570-0021",
          "570-0006",
          "570-0008",
          "570-0095",
          "570-0004",
          "570-0029",
          "573-0000",
          "573-0026",
          "573-1185",
          "573-0058",
          "573-0066",
          "573-0053",
          "573-0036",
          "573-0061",
          "573-0062",
          "573-0055",
          "573-0067",
          "573-0005",
          "573-1184",
          "573-1186",
          "573-1188",
          "573-1187",
          "573-0017",
          "573-1175",
          "573-1143",
          "573-1136",
          "573-0027",
          "573-0142",
          "573-0145",
          "573-0141",
          "573-0146",
          "573-0032",
          "573-0031",
          "573-0033",
          "573-0034",
          "573-1173",
          "573-1174",
          "573-1163",
          "573-1168",
          "573-1167",
          "573-0134",
          "573-0136",
          "573-0137",
          "573-0135",
          "573-0131",
          "573-1156",
          "573-1157",
          "573-1127",
          "573-1126",
          "573-0028",
          "573-0091",
          "573-0092",
          "573-1158",
          "573-1102",
          "573-0064",
          "573-1117",
          "573-0171",
          "573-1197",
          "573-1111",
          "573-1104",
          "573-1101",
          "573-1107",
          "573-1118",
          "573-1103",
          "573-1121",
          "573-1112",
          "573-1113",
          "573-1159",
          "573-0073",
          "573-1161",
          "573-1131",
          "573-0088",
          "573-0085",
          "573-0087",
          "573-0086",
          "573-0084",
          "573-1145",
          "573-1182",
          "573-1193",
          "573-0018",
          "573-0056",
          "573-0081",
          "573-1153",
          "573-1132",
          "573-1152",
          "573-1135",
          "573-1154",
          "573-1155",
          "573-1138",
          "573-1133",
          "573-1166",
          "573-1191",
          "573-0095",
          "573-0117",
          "573-0111",
          "573-0116",
          "573-0118",
          "573-1164",
          "573-0113",
          "573-0112",
          "573-0035",
          "573-1162",
          "573-0001",
          "573-0024",
          "573-0123",
          "573-0125",
          "573-0122",
          "573-0126",
          "573-0124",
          "573-0121",
          "573-0127",
          "573-0128",
          "573-0057",
          "573-0065",
          "573-0003",
          "573-0002",
          "573-0045",
          "573-0007",
          "573-0006",
          "573-0004",
          "573-1194",
          "573-1195",
          "573-0021",
          "573-1196",
          "573-0011",
          "573-0103",
          "573-0102",
          "573-0164",
          "573-0101",
          "573-0104",
          "573-0105",
          "573-0162",
          "573-0161",
          "573-0107",
          "573-0163",
          "573-0106",
          "573-1147",
          "573-1172",
          "573-1181",
          "573-1176",
          "573-1183",
          "573-1177",
          "573-1178",
          "573-0071",
          "573-0082",
          "573-0072",
          "573-0083",
          "573-1192",
          "573-1137",
          "573-0025",
          "573-1122",
          "573-1148",
          "573-0144",
          "573-0133",
          "573-0143",
          "573-0132",
          "573-0063",
          "573-0075",
          "573-0077",
          "573-0074",
          "573-0076",
          "573-0023",
          "573-0044",
          "573-0093",
          "573-1115",
          "573-1151",
          "573-1114",
          "573-1128",
          "573-0115",
          "573-0037",
          "573-0054",
          "573-0052",
          "573-0155",
          "573-0152",
          "573-0153",
          "573-0158",
          "573-0156",
          "573-0151",
          "573-0157",
          "573-1116",
          "573-0013",
          "573-0114",
          "573-1149",
          "573-1146",
          "573-1142",
          "573-1144",
          "573-1106",
          "573-0012",
          "573-0051",
          "573-1105",
          "573-0094",
          "573-1123",
          "573-1165",
          "573-0022",
          "573-0046",
          "573-0014",
          "573-0015",
          "573-0042",
          "573-0043",
          "573-0016",
          "573-1171",
          "573-1124",
          "573-1141",
          "573-1125",
          "573-1134",
          "573-0167",
          "573-0165",
          "573-0168",
          "573-0166",
          "573-0047",
          "573-0041",
          "573-0048",
          "573-0049",
          "573-0154",
          "567-0000",
          "567-0001",
          "568-0096",
          "567-0831",
          "567-0897",
          "567-0076",
          "567-0842",
          "568-0097",
          "567-0005",
          "567-0029",
          "567-0827",
          "567-0871",
          "567-0064",
          "567-0877",
          "567-0042",
          "567-0816",
          "567-0888",
          "567-0826",
          "568-0091",
          "567-0813",
          "567-0018",
          "567-0013",
          "567-0883",
          "567-0873",
          "567-0833",
          "567-0834",
          "567-0031",
          "567-0819",
          "567-0811",
          "568-0086",
          "567-0065",
          "567-0881",
          "567-0036",
          "567-0037",
          "567-0048",
          "568-0081",
          "567-0878",
          "568-0083",
          "567-0841",
          "568-0094",
          "567-0072",
          "567-0071",
          "567-0043",
          "567-0852",
          "567-0084",
          "567-0085",
          "567-0082",
          "567-0083",
          "567-0086",
          "567-0075",
          "568-0095",
          "567-0864",
          "567-0863",
          "567-0868",
          "567-0854",
          "567-0059",
          "567-0045",
          "567-0066",
          "568-0082",
          "567-0886",
          "567-0041",
          "567-0055",
          "567-0051",
          "567-0806",
          "568-0092",
          "567-0832",
          "567-0014",
          "567-0074",
          "567-0884",
          "567-0872",
          "567-0835",
          "567-0855",
          "567-0821",
          "568-0087",
          "568-0098",
          "567-0801",
          "567-0802",
          "567-0804",
          "567-0825",
          "567-0867",
          "567-0844",
          "568-0093",
          "567-0011",
          "567-0866",
          "567-0815",
          "567-0025",
          "567-0895",
          "567-0846",
          "567-0848",
          "567-0893",
          "567-0896",
          "567-0823",
          "567-0876",
          "567-0812",
          "567-0016",
          "567-0814",
          "567-0057",
          "567-0053",
          "567-0063",
          "567-0803",
          "567-0824",
          "567-0034",
          "567-0822",
          "568-0088",
          "567-0892",
          "567-0874",
          "567-0008",
          "567-0032",
          "567-0015",
          "567-0023",
          "567-0003",
          "567-0027",
          "567-0887",
          "567-0058",
          "567-0067",
          "567-0073",
          "568-0085",
          "567-0847",
          "567-0805",
          "567-0028",
          "567-0017",
          "567-0002",
          "567-0879",
          "567-0012",
          "567-0885",
          "567-0861",
          "567-0838",
          "567-0062",
          "567-0845",
          "567-0849",
          "567-0061",
          "567-0054",
          "567-0829",
          "567-0828",
          "567-0817",
          "567-0843",
          "567-0044",
          "567-0818",
          "567-0851",
          "567-0850",
          "567-0033",
          "567-0026",
          "567-0024",
          "567-0862",
          "567-0021",
          "567-0022",
          "567-0891",
          "567-0035",
          "567-0007",
          "567-0046",
          "567-0056",
          "567-0004",
          "567-0837",
          "567-0006",
          "567-0047",
          "567-0853",
          "567-0810",
          "567-0052",
          "567-0836",
          "567-0882",
          "568-0084",
          "567-0009",
          "567-0010",
          "568-0089",
          "567-0865",
          "567-0875",
          "567-0894",
          "581-0000",
          "581-0082",
          "581-0018",
          "581-0020",
          "581-0026",
          "581-0087",
          "581-0833",
          "581-0064",
          "581-0055",
          "581-0068",
          "581-0813",
          "581-0084",
          "581-0092",
          "581-0863",
          "581-0037",
          "581-0854",
          "581-0039",
          "581-0015",
          "581-0883",
          "581-0884",
          "581-0882",
          "581-0881",
          "581-0853",
          "581-0022",
          "581-0061",
          "581-0823",
          "581-0851",
          "581-0846",
          "581-0845",
          "581-0065",
          "581-0834",
          "581-0066",
          "581-0041",
          "581-0071",
          "581-0802",
          "581-0044",
          "581-0817",
          "581-0072",
          "581-0874",
          "581-0043",
          "581-0814",
          "581-0873",
          "581-0855",
          "581-0007",
          "581-0872",
          "581-0012",
          "581-0835",
          "581-0821",
          "581-0074",
          "581-0869",
          "581-0816",
          "581-0031",
          "581-0094",
          "581-0033",
          "581-0075",
          "581-0006",
          "581-0811",
          "581-0885",
          "581-0067",
          "581-0001",
          "581-0005",
          "581-0063",
          "581-0095",
          "581-0822",
          "581-0073",
          "581-0017",
          "581-0875",
          "581-0871",
          "581-0052",
          "581-0053",
          "581-0051",
          "581-0862",
          "581-0832",
          "581-0025",
          "581-0014",
          "581-0836",
          "581-0083",
          "581-0045",
          "581-0077",
          "581-0852",
          "581-0868",
          "581-0035",
          "581-0036",
          "581-0865",
          "581-0803",
          "581-0093",
          "581-0002",
          "581-0062",
          "581-0004",
          "581-0861",
          "581-0866",
          "581-0847",
          "581-0029",
          "581-0844",
          "581-0842",
          "581-0843",
          "581-0841",
          "581-0024",
          "581-0003",
          "581-0088",
          "581-0856",
          "581-0818",
          "581-0837",
          "581-0091",
          "581-0054",
          "581-0042",
          "581-0076",
          "581-0019",
          "581-0056",
          "581-0081",
          "581-0023",
          "581-0010",
          "581-0030",
          "581-0815",
          "581-0027",
          "581-0028",
          "581-0016",
          "581-0085",
          "581-0812",
          "581-0801",
          "581-0864",
          "581-0021",
          "581-0867",
          "581-0013",
          "581-0831",
          "581-0032",
          "581-0034",
          "581-0086",
          "581-0069",
          "581-0011",
          "581-0038",
          "598-0000",
          "598-0014",
          "598-0052",
          "598-0072",
          "598-0005",
          "598-0006",
          "598-0004",
          "598-0007",
          "598-0023",
          "598-0053",
          "598-0043",
          "598-0044",
          "598-0058",
          "598-0001",
          "598-0024",
          "598-0054",
          "598-0075",
          "598-0062",
          "598-0008",
          "598-0051",
          "598-0032",
          "598-0061",
          "549-0001",
          "598-0012",
          "598-0016",
          "598-0015",
          "598-0011",
          "598-0003",
          "598-0022",
          "598-0071",
          "598-0002",
          "598-0013",
          "598-0034",
          "598-0064",
          "598-0042",
          "598-0041",
          "598-0046",
          "598-0037",
          "598-0074",
          "598-0031",
          "598-0021",
          "598-0057",
          "598-0045",
          "598-0063",
          "598-0073",
          "598-0036",
          "598-0035",
          "598-0033",
          "598-0056",
          "598-0047",
          "598-0048",
          "598-0055",
          "584-0000",
          "584-0076",
          "584-0006",
          "584-0012",
          "584-0001",
          "584-0056",
          "584-0095",
          "584-0058",
          "584-0040",
          "584-0078",
          "584-0014",
          "584-0049",
          "584-0054",
          "584-0008",
          "584-0003",
          "584-0005",
          "584-0042",
          "584-0004",
          "584-0041",
          "584-0074",
          "584-0036",
          "584-0082",
          "584-0083",
          "584-0079",
          "584-0031",
          "584-0070",
          "584-0065",
          "584-0015",
          "584-0013",
          "584-0084",
          "584-0052",
          "584-0034",
          "584-0092",
          "584-0077",
          "584-0085",
          "584-0091",
          "584-0062",
          "584-0072",
          "584-0035",
          "584-0016",
          "584-0081",
          "584-0086",
          "584-0073",
          "584-0032",
          "584-0033",
          "584-0027",
          "584-0021",
          "584-0022",
          "584-0028",
          "584-0051",
          "584-0048",
          "584-0063",
          "584-0066",
          "584-0068",
          "584-0069",
          "584-0067",
          "584-0038",
          "584-0046",
          "584-0002",
          "584-0055",
          "584-0061",
          "584-0071",
          "584-0064",
          "584-0094",
          "584-0044",
          "584-0093",
          "584-0026",
          "584-0007",
          "584-0043",
          "584-0037",
          "584-0011",
          "584-0039",
          "584-0045",
          "584-0047",
          "584-0057",
          "584-0053",
          "584-0024",
          "584-0023",
          "584-0025",
          "572-0000",
          "572-0039",
          "572-0035",
          "572-0033",
          "572-0036",
          "572-0034",
          "572-0073",
          "572-0038",
          "572-0074",
          "572-0030",
          "572-0012",
          "572-0026",
          "572-0027",
          "572-0024",
          "572-0025",
          "572-0821",
          "572-0840",
          "572-0842",
          "572-0843",
          "572-0841",
          "572-0844",
          "572-0849",
          "572-0856",
          "572-0859",
          "572-0850",
          "572-0857",
          "572-0861",
          "572-0862",
          "572-0858",
          "572-0803",
          "572-0853",
          "572-0048",
          "572-0047",
          "572-0023",
          "572-0063",
          "572-0052",
          "572-0828",
          "572-0829",
          "572-0827",
          "572-0825",
          "572-0824",
          "572-0015",
          "572-0816",
          "572-0815",
          "572-0817",
          "572-0008",
          "572-0032",
          "572-0836",
          "572-0822",
          "572-0811",
          "572-0845",
          "572-0075",
          "572-0037",
          "572-0016",
          "572-0057",
          "572-0059",
          "572-0050",
          "572-0058",
          "572-0085",
          "572-0082",
          "572-0089",
          "572-0084",
          "572-0080",
          "572-0083",
          "572-0029",
          "572-0087",
          "572-0088",
          "572-0017",
          "572-0018",
          "572-0041",
          "572-0813",
          "572-0818",
          "572-0044",
          "572-0077",
          "572-0054",
          "572-0823",
          "572-0834",
          "572-0865",
          "572-0866",
          "572-0812",
          "572-0009",
          "572-0046",
          "572-0819",
          "572-0021",
          "572-0020",
          "572-0078",
          "572-0072",
          "572-0864",
          "572-0806",
          "572-0867",
          "572-0846",
          "572-0847",
          "572-0051",
          "572-0062",
          "572-0067",
          "572-0061",
          "572-0064",
          "572-0065",
          "572-0071",
          "572-0831",
          "572-0053",
          "572-0820",
          "572-0002",
          "572-0001",
          "572-0005",
          "572-0003",
          "572-0004",
          "572-0826",
          "572-0043",
          "572-0028",
          "572-0066",
          "572-0076",
          "572-0801",
          "572-0854",
          "572-0851",
          "572-0852",
          "572-0855",
          "572-0848",
          "572-0014",
          "572-0833",
          "572-0837",
          "572-0042",
          "572-0045",
          "572-0081",
          "572-0835",
          "572-0839",
          "572-0814",
          "572-0810",
          "572-0832",
          "572-0086",
          "572-0013",
          "572-0007",
          "572-0019",
          "572-0006",
          "572-0022",
          "572-0055",
          "572-0056",
          "572-0011",
          "572-0863",
          "572-0838",
          "572-0031",
          "586-0000",
          "586-0095",
          "586-0084",
          "586-0086",
          "586-0062",
          "586-0069",
          "586-0058",
          "586-0002",
          "586-0061",
          "586-0034",
          "586-0037",
          "586-0038",
          "586-0056",
          "586-0075",
          "586-0073",
          "586-0074",
          "586-0076",
          "586-0035",
          "586-0094",
          "586-0071",
          "586-0054",
          "586-0064",
          "586-0052",
          "586-0012",
          "586-0068",
          "586-0091",
          "586-0033",
          "586-0001",
          "586-0009",
          "586-0008",
          "586-0043",
          "586-0097",
          "586-0039",
          "586-0003",
          "586-0004",
          "586-0026",
          "586-0057",
          "586-0032",
          "586-0011",
          "586-0066",
          "586-0087",
          "586-0096",
          "586-0025",
          "586-0051",
          "586-0093",
          "586-0041",
          "586-0072",
          "586-0036",
          "586-0027",
          "586-0018",
          "586-0053",
          "586-0046",
          "586-0014",
          "586-0063",
          "586-0077",
          "586-0047",
          "586-0031",
          "586-0016",
          "586-0024",
          "586-0042",
          "586-0023",
          "586-0055",
          "586-0021",
          "586-0045",
          "586-0085",
          "586-0017",
          "586-0022",
          "586-0015",
          "586-0006",
          "586-0007",
          "586-0005",
          "586-0044",
          "586-0048",
          "586-0082",
          "586-0083",
          "586-0081",
          "586-0067",
          "586-0065",
          "586-0092",
          "586-0013",
          "580-0000",
          "580-0043",
          "580-0032",
          "580-0034",
          "580-0033",
          "580-0031",
          "580-0026",
          "580-0016",
          "580-0006",
          "580-0014",
          "580-0002",
          "580-0022",
          "580-0025",
          "580-0017",
          "580-0015",
          "580-0044",
          "580-0021",
          "580-0012",
          "580-0013",
          "580-0011",
          "580-0004",
          "580-0024",
          "580-0003",
          "580-0005",
          "580-0042",
          "580-0023",
          "580-0046",
          "580-0041",
          "580-0045",
          "580-0001",
          "574-0000",
          "574-0046",
          "574-0076",
          "574-0003",
          "574-0024",
          "574-0032",
          "574-0033",
          "574-0042",
          "574-0001",
          "574-0031",
          "574-0007",
          "574-0008",
          "574-0025",
          "574-0064",
          "574-0028",
          "574-0077",
          "574-0035",
          "574-0053",
          "574-0051",
          "574-0056",
          "574-0057",
          "574-0052",
          "574-0054",
          "574-0055",
          "574-0037",
          "574-0036",
          "574-0026",
          "574-0061",
          "574-0045",
          "574-0012",
          "574-0074",
          "574-0017",
          "574-0014",
          "574-0013",
          "574-0006",
          "574-0063",
          "574-0002",
          "574-0005",
          "574-0015",
          "574-0043",
          "574-0041",
          "574-0062",
          "574-0022",
          "574-0021",
          "574-0072",
          "574-0075",
          "574-0071",
          "574-0011",
          "574-0034",
          "574-0027",
          "574-0073",
          "574-0004",
          "574-0023",
          "574-0016",
          "574-0044",
          "594-0000",
          "594-1153",
          "594-0053",
          "594-1157",
          "594-0083",
          "594-0032",
          "594-0054",
          "594-0072",
          "594-0041",
          "594-0063",
          "594-0011",
          "594-1156",
          "594-1103",
          "594-0004",
          "594-1134",
          "594-1128",
          "594-0074",
          "594-0006",
          "594-1127",
          "594-0012",
          "594-1117",
          "594-0002",
          "594-1151",
          "594-0065",
          "594-1122",
          "594-1126",
          "594-0081",
          "594-1113",
          "594-0022",
          "594-0066",
          "594-1111",
          "594-1114",
          "594-0005",
          "594-0052",
          "594-0021",
          "594-1121",
          "594-1125",
          "594-0003",
          "594-1132",
          "594-1135",
          "594-0013",
          "594-1144",
          "594-0064",
          "594-0062",
          "594-0082",
          "594-1124",
          "594-1116",
          "594-1105",
          "594-0023",
          "594-1106",
          "594-1133",
          "594-1141",
          "594-0075",
          "594-0051",
          "594-0076",
          "594-1142",
          "594-1115",
          "594-1123",
          "594-0031",
          "594-0071",
          "594-1136",
          "594-0001",
          "594-1131",
          "594-1154",
          "594-1152",
          "594-1104",
          "594-0042",
          "594-1118",
          "594-1155",
          "594-1112",
          "594-1101",
          "594-0061",
          "594-1143",
          "594-0073",
          "594-1102",
          "562-0000",
          "562-0025",
          "562-0024",
          "562-0021",
          "562-0022",
          "562-0023",
          "562-0027",
          "562-0015",
          "562-0033",
          "562-0031",
          "562-0032",
          "562-0006",
          "563-0251",
          "562-0014",
          "562-0026",
          "562-0028",
          "562-0029",
          "562-0041",
          "562-0043",
          "562-0046",
          "563-0252",
          "563-0256",
          "563-0257",
          "563-0255",
          "563-0258",
          "562-0045",
          "562-0035",
          "562-0036",
          "562-0005",
          "562-0003",
          "562-0034",
          "562-0011",
          "562-0012",
          "562-0044",
          "562-0042",
          "562-0013",
          "562-0004",
          "562-0001",
          "562-0002",
          "582-0000",
          "582-0014",
          "582-0026",
          "582-0016",
          "582-0029",
          "582-0002",
          "582-0027",
          "582-0018",
          "582-0020",
          "582-0007",
          "582-0012",
          "582-0004",
          "582-0006",
          "582-0022",
          "582-0023",
          "582-0021",
          "582-0025",
          "582-0009",
          "582-0017",
          "582-0015",
          "582-0024",
          "582-0028",
          "582-0013",
          "582-0003",
          "582-0019",
          "582-0008",
          "582-0005",
          "582-0001",
          "582-0011",
          "582-0010",
          "583-0000",
          "583-0842",
          "583-0876",
          "583-0851",
          "583-0886",
          "583-0847",
          "583-0868",
          "583-0875",
          "583-0854",
          "583-0867",
          "583-0848",
          "583-0863",
          "583-0874",
          "583-0841",
          "583-0857",
          "583-0853",
          "583-0881",
          "583-0862",
          "583-0855",
          "583-0882",
          "583-0843",
          "583-0844",
          "583-0861",
          "583-0884",
          "583-0871",
          "583-0856",
          "583-0866",
          "583-0864",
          "583-0865",
          "583-0872",
          "583-0846",
          "583-0845",
          "583-0852",
          "583-0885",
          "583-0858",
          "583-0883",
          "583-0873",
          "571-0000",
          "571-0061",
          "571-0067",
          "571-0053",
          "571-0033",
          "571-0028",
          "571-0029",
          "571-0012",
          "571-0076",
          "571-0068",
          "571-0077",
          "571-0022",
          "571-0065",
          "571-0050",
          "571-0071",
          "571-0070",
          "571-0002",
          "571-0007",
          "571-0025",
          "571-0018",
          "571-0026",
          "571-0073",
          "571-0043",
          "571-0035",
          "571-0066",
          "571-0032",
          "571-0047",
          "571-0027",
          "571-0017",
          "571-0016",
          "571-0075",
          "571-0009",
          "571-0058",
          "571-0063",
          "571-0072",
          "571-0048",
          "571-0030",
          "571-0001",
          "571-0013",
          "571-0014",
          "571-0052",
          "571-0059",
          "571-0078",
          "571-0045",
          "571-0055",
          "571-0024",
          "571-0079",
          "571-0054",
          "571-0039",
          "571-0037",
          "571-0008",
          "571-0034",
          "571-0042",
          "571-0021",
          "571-0031",
          "571-0046",
          "571-0044",
          "571-0056",
          "571-0015",
          "571-0064",
          "571-0005",
          "571-0062",
          "571-0074",
          "571-0051",
          "571-0057",
          "571-0038",
          "571-0041",
          "571-0023",
          "571-0011",
          "566-0000",
          "566-0051",
          "566-0033",
          "566-0041",
          "566-0034",
          "566-0032",
          "566-0023",
          "566-0024",
          "566-0012",
          "566-0031",
          "566-0055",
          "566-0001",
          "566-0002",
          "566-0011",
          "566-0035",
          "566-0062",
          "566-0064",
          "566-0071",
          "566-0065",
          "566-0053",
          "566-0054",
          "566-0061",
          "566-0052",
          "566-0063",
          "566-0073",
          "566-0072",
          "566-0044",
          "566-0047",
          "566-0013",
          "566-0025",
          "566-0074",
          "566-0042",
          "566-0043",
          "566-0046",
          "566-0022",
          "566-0021",
          "566-0045",
          "592-0000",
          "592-0014",
          "592-0011",
          "592-0001",
          "592-0004",
          "592-0006",
          "592-0005",
          "592-0013",
          "592-0012",
          "592-0002",
          "592-0003",
          "595-0081",
          "583-0015",
          "583-0004",
          "583-0036",
          "583-0008",
          "583-0027",
          "583-0026",
          "583-0025",
          "583-0001",
          "583-0035",
          "583-0006",
          "583-0013",
          "583-0033",
          "583-0031",
          "583-0034",
          "583-0032",
          "583-0023",
          "583-0011",
          "583-0005",
          "583-0037",
          "583-0012",
          "583-0009",
          "583-0018",
          "583-0014",
          "583-0007",
          "583-0022",
          "583-0024",
          "583-0017",
          "583-0003",
          "583-0002",
          "583-0021",
          "583-0016",
          "577-0000",
          "579-8048",
          "577-0841",
          "577-0057",
          "577-0842",
          "577-0058",
          "577-0843",
          "577-0023",
          "577-0022",
          "577-0024",
          "577-0011",
          "579-8064",
          "579-8002",
          "579-8033",
          "579-8034",
          "577-0002",
          "577-0004",
          "577-0007",
          "577-0003",
          "578-0925",
          "578-0903",
          "578-0941",
          "578-0946",
          "577-0809",
          "577-0817",
          "577-0824",
          "577-0825",
          "577-0826",
          "577-0833",
          "577-0834",
          "577-0835",
          "577-0823",
          "577-0815",
          "578-0901",
          "630-0271",
          "579-8012",
          "577-0806",
          "579-8052",
          "579-8062",
          "578-0905",
          "579-8044",
          "578-0902",
          "577-0063",
          "577-0064",
          "579-8058",
          "577-0847",
          "577-0846",
          "577-0848",
          "577-0827",
          "579-8015",
          "578-0978",
          "579-8043",
          "579-8041",
          "579-8003",
          "577-0006",
          "577-0822",
          "578-0977",
          "578-0971",
          "578-0974",
          "578-0972",
          "577-0801",
          "577-0802",
          "579-8042",
          "577-0837",
          "578-0915",
          "577-0818",
          "579-8047",
          "577-0849",
          "577-0052",
          "579-8053",
          "577-0005",
          "577-0836",
          "578-0981",
          "577-0803",
          "579-8066",
          "577-0831",
          "579-8046",
          "579-8065",
          "577-0813",
          "577-0025",
          "577-0027",
          "577-0026",
          "577-0028",
          "578-0967",
          "578-0963",
          "578-0951",
          "578-0964",
          "578-0958",
          "579-8037",
          "579-8055",
          "578-0912",
          "579-8001",
          "577-0844",
          "577-0053",
          "577-0065",
          "577-0066",
          "577-0054",
          "577-0067",
          "579-8036",
          "579-8025",
          "579-8023",
          "578-0932",
          "578-0934",
          "578-0933",
          "577-0055",
          "577-0056",
          "577-0845",
          "577-0001",
          "577-0816",
          "579-8031",
          "579-8035",
          "579-8014",
          "578-0975",
          "577-0804",
          "578-0911",
          "577-0832",
          "577-0015",
          "577-0014",
          "577-0013",
          "577-0012",
          "577-0016",
          "578-0913",
          "578-0985",
          "579-8024",
          "579-8013",
          "578-0947",
          "577-0811",
          "578-0976",
          "577-0042",
          "577-0044",
          "577-0047",
          "577-0048",
          "577-0045",
          "577-0046",
          "579-8021",
          "579-8004",
          "579-8038",
          "578-0931",
          "578-0936",
          "578-0937",
          "579-8011",
          "577-0812",
          "578-0973",
          "579-8032",
          "579-8027",
          "578-0984",
          "578-0948",
          "577-0807",
          "579-8051",
          "577-0017",
          "577-0805",
          "578-0953",
          "578-0957",
          "578-0952",
          "578-0965",
          "579-8045",
          "578-0922",
          "578-0923",
          "577-0032",
          "577-0036",
          "577-0035",
          "577-0037",
          "577-0033",
          "577-0034",
          "578-0966",
          "578-0921",
          "577-0814",
          "578-0961",
          "579-8054",
          "578-0914",
          "579-8057",
          "579-8005",
          "577-0062",
          "577-0061",
          "579-8022",
          "630-0272",
          "579-8026",
          "579-8063",
          "577-0808",
          "578-0954",
          "578-0956",
          "578-0955",
          "578-0924",
          "578-0983",
          "578-0982",
          "578-0904",
          "577-0821",
          "579-8061",
          "578-0935",
          "578-0943",
          "578-0945",
          "578-0944",
          "578-0942",
          "579-8056",
          "590-0500",
          "590-0501",
          "590-0531",
          "590-0526",
          "590-0532",
          "590-0503",
          "590-0504",
          "590-0523",
          "590-0505",
          "590-0514",
          "590-0513",
          "590-0511",
          "590-0522",
          "590-0515",
          "590-0512",
          "549-0021",
          "590-0521",
          "590-0533",
          "590-0534",
          "590-0525",
          "590-0524",
          "590-0502",
          "590-0535",
          "575-0000",
          "575-0034",
          "575-0011",
          "575-0004",
          "575-0002",
          "575-0003",
          "575-0014",
          "575-0045",
          "575-0036",
          "575-0035",
          "575-0043",
          "575-0063",
          "575-0062",
          "575-0061",
          "575-0032",
          "575-0015",
          "575-0041",
          "575-0042",
          "575-0012",
          "575-0001",
          "575-0013",
          "575-0024",
          "575-0053",
          "575-0052",
          "575-0054",
          "575-0051",
          "575-0023",
          "575-0055",
          "575-0044",
          "575-0033",
          "575-0022",
          "575-0021",
          "575-0016",
          "576-0000",
          "576-0066",
          "576-0034",
          "576-0054",
          "576-0042",
          "576-0033",
          "576-0004",
          "576-0032",
          "576-0052",
          "576-0002",
          "576-0041",
          "576-0035",
          "576-0051",
          "576-0001",
          "576-0053",
          "576-0062",
          "576-0063",
          "576-0006",
          "576-0064",
          "576-0013",
          "576-0061",
          "576-0022",
          "576-0003",
          "576-0016",
          "576-0011",
          "576-0014",
          "576-0015",
          "576-0017",
          "576-0043",
          "576-0021",
          "576-0012",
          "576-0065",
          "576-0005",
          "576-0031",
          "576-0036",
          "589-0000",
          "589-0008",
          "589-0007",
          "589-0009",
          "589-0031",
          "589-0021",
          "589-0032",
          "589-0023",
          "589-0015",
          "589-0014",
          "589-0016",
          "589-0013",
          "589-0006",
          "589-0005",
          "589-0022",
          "589-0011",
          "589-0004",
          "589-0012",
          "589-0002",
          "589-0003",
          "589-0001",
          "589-0034",
          "589-0036",
          "589-0033",
          "589-0035",
          "599-0200",
          "599-0221",
          "599-0213",
          "599-0201",
          "599-0231",
          "599-0203",
          "599-0222",
          "599-0223",
          "599-0215",
          "599-0212",
          "599-0202",
          "599-0205",
          "599-0234",
          "599-0204",
          "599-0211",
          "599-0225",
          "599-0232",
          "599-0235",
          "599-0224",
          "599-0216",
          "599-0233",
          "599-0236",
          "599-0214",
          "618-0015",
          "618-0013",
          "618-0004",
          "618-0022",
          "618-0023",
          "618-0003",
          "618-0012",
          "618-0002",
          "618-0021",
          "618-0011",
          "618-0014",
          "618-0001",
          "618-0024",
          "563-0100",
          "563-0217",
          "563-0215",
          "563-0214",
          "563-0213",
          "563-0104",
          "563-0105",
          "563-0216",
          "563-0212",
          "563-0102",
          "563-0218",
          "563-0103",
          "563-0211",
          "563-0101",
          "563-0219",
          "563-0300",
          "563-0363",
          "563-0361",
          "563-0365",
          "563-0352",
          "563-0353",
          "563-0354",
          "563-0122",
          "563-0113",
          "563-0351",
          "563-0367",
          "563-0121",
          "563-0123",
          "563-0355",
          "563-0341",
          "563-0112",
          "563-0366",
          "563-0371",
          "563-0368",
          "563-0133",
          "563-0131",
          "563-0134",
          "563-0132",
          "563-0135",
          "563-0356",
          "563-0364",
          "563-0362",
          "563-0114",
          "563-0373",
          "563-0372",
          "563-0111",
          "595-0803",
          "595-0802",
          "595-0801",
          "595-0812",
          "595-0805",
          "595-0813",
          "595-0811",
          "595-0814",
          "595-0804",
          "590-0400",
          "590-0407",
          "590-0458",
          "590-0457",
          "590-0459",
          "590-0401",
          "590-0402",
          "590-0403",
          "590-0404",
          "590-0406",
          "590-0405",
          "590-0450",
          "590-0432",
          "590-0431",
          "590-0434",
          "590-0435",
          "590-0422",
          "590-0441",
          "590-0436",
          "590-0411",
          "590-0415",
          "590-0414",
          "590-0412",
          "590-0413",
          "590-0445",
          "590-0421",
          "590-0425",
          "590-0427",
          "590-0426",
          "590-0424",
          "590-0423",
          "590-0454",
          "590-0444",
          "590-0443",
          "590-0442",
          "590-0416",
          "590-0455",
          "590-0447",
          "590-0449",
          "590-0448",
          "590-0446",
          "590-0451",
          "590-0456",
          "590-0453",
          "590-0452",
          "590-0433",
          "590-0417",
          "598-0091",
          "549-0011",
          "598-0092",
          "598-0094",
          "598-0093",
          "599-0300",
          "599-0302",
          "599-0314",
          "599-0311",
          "599-0312",
          "599-0313",
          "599-0301",
          "599-0304",
          "599-0303",
          "583-0991",
          "583-0996",
          "583-0995",
          "583-0993",
          "583-0994",
          "583-0992",
          "585-0000",
          "585-0002",
          "585-0012",
          "585-0024",
          "585-0035",
          "585-0034",
          "585-0025",
          "585-0027",
          "585-0023",
          "585-0014",
          "585-0026",
          "585-0033",
          "585-0003",
          "585-0005",
          "585-0011",
          "585-0031",
          "585-0006",
          "585-0001",
          "585-0013",
          "585-0022",
          "585-0032",
          "585-0021",
          "585-0004",
          "585-0055",
          "585-0045",
          "585-0043",
          "585-0053",
          "585-0041",
          "585-0051",
          "585-0052",
          "585-0042",
          "585-0044",
          "585-0054",
          "658-0000",
          "658-0083",
          "658-0026",
          "658-0025",
          "658-0082",
          "658-0024",
          "658-0066",
          "658-0027",
          "658-0072",
          "658-0064",
          "658-0014",
          "658-0002",
          "658-0084",
          "658-0032",
          "658-0031",
          "658-0033",
          "658-0062",
          "658-0042",
          "658-0051",
          "658-0052",
          "658-0041",
          "658-0053",
          "658-0063",
          "658-0081",
          "658-0073",
          "658-0023",
          "658-0021",
          "658-0022",
          "658-0013",
          "658-0012",
          "658-0047",
          "658-0045",
          "658-0048",
          "658-0044",
          "658-0054",
          "658-0043",
          "658-0046",
          "658-0065",
          "658-0003",
          "658-0071",
          "658-0005",
          "658-0061",
          "658-0004",
          "657-0111",
          "658-0016",
          "658-0015",
          "658-0001",
          "658-0011",
          "657-0000",
          "657-0805",
          "657-0821",
          "657-0061",
          "657-0823",
          "657-0834",
          "657-0012",
          "657-0803",
          "657-0846",
          "657-0845",
          "657-0856",
          "657-0103",
          "657-0817",
          "657-0042",
          "657-0838",
          "657-0843",
          "657-0043",
          "657-0852",
          "657-0833",
          "657-0017",
          "657-0014",
          "657-0055",
          "657-0057",
          "657-0052",
          "657-0832",
          "657-0034",
          "657-0024",
          "657-0816",
          "657-0826",
          "657-0025",
          "657-0801",
          "657-0814",
          "657-0021",
          "657-0036",
          "657-0044",
          "657-0015",
          "657-0068",
          "657-0016",
          "657-0066",
          "657-0067",
          "657-0059",
          "657-0002",
          "657-0045",
          "657-0058",
          "657-0836",
          "657-0804",
          "657-0864",
          "657-0861",
          "657-0018",
          "657-0831",
          "657-0056",
          "657-0063",
          "657-0813",
          "657-0001",
          "657-0023",
          "657-0022",
          "657-0011",
          "657-0062",
          "657-0033",
          "657-0035",
          "657-0032",
          "657-0825",
          "657-0027",
          "657-0811",
          "657-0835",
          "657-0853",
          "657-0863",
          "657-0841",
          "657-0102",
          "657-0822",
          "657-0862",
          "657-0802",
          "657-0837",
          "657-0054",
          "657-0029",
          "657-0041",
          "657-0037",
          "657-0038",
          "657-0824",
          "657-0842",
          "657-0855",
          "657-0104",
          "657-0105",
          "657-0854",
          "657-0851",
          "657-0812",
          "657-0844",
          "657-0065",
          "657-0028",
          "657-0815",
          "657-0051",
          "657-0064",
          "657-0031",
          "657-0026",
          "657-0101",
          "657-0013",
          "657-0053",
          "652-0000",
          "652-0882",
          "652-0032",
          "652-0061",
          "652-0842",
          "652-0853",
          "652-0894",
          "652-0003",
          "652-0816",
          "652-0898",
          "652-0897",
          "652-0043",
          "652-0044",
          "652-0895",
          "652-0864",
          "652-0832",
          "652-0008",
          "652-0046",
          "652-0013",
          "652-0862",
          "652-0001",
          "652-0006",
          "652-0058",
          "652-0837",
          "652-0053",
          "652-0847",
          "652-0873",
          "652-0004",
          "652-0064",
          "652-0885",
          "652-0007",
          "652-0865",
          "652-0055",
          "652-0851",
          "652-0051",
          "652-0821",
          "652-0011",
          "652-0831",
          "652-0833",
          "652-0065",
          "652-0015",
          "652-0047",
          "652-0014",
          "652-0811",
          "652-0836",
          "652-0896",
          "652-0062",
          "652-0874",
          "652-0056",
          "652-0803",
          "652-0022",
          "652-0804",
          "652-0845",
          "652-0023",
          "652-0846",
          "652-0021",
          "652-0866",
          "652-0844",
          "652-0801",
          "652-0033",
          "652-0034",
          "652-0035",
          "652-0822",
          "652-0835",
          "652-0891",
          "652-0806",
          "652-0805",
          "652-0016",
          "652-0807",
          "652-0875",
          "652-0871",
          "652-0823",
          "652-0892",
          "652-0042",
          "652-0054",
          "652-0813",
          "652-0052",
          "652-0057",
          "652-0002",
          "652-0036",
          "652-0843",
          "652-0834",
          "652-0881",
          "652-0045",
          "652-0815",
          "652-0855",
          "652-0852",
          "652-0802",
          "652-0861",
          "652-0041",
          "652-0812",
          "652-0012",
          "652-0893",
          "652-0841",
          "652-0883",
          "652-0814",
          "652-0005",
          "652-0031",
          "652-0063",
          "652-0872",
          "652-0854",
          "652-0863",
          "652-0884",
          "653-0000",
          "653-0824",
          "653-0823",
          "653-0826",
          "653-0825",
          "653-0864",
          "653-0822",
          "653-0814",
          "653-0865",
          "653-0821",
          "653-0013",
          "653-0878",
          "653-0871",
          "653-0036",
          "653-0021",
          "653-0838",
          "653-0811",
          "653-0037",
          "653-0833",
          "653-0802",
          "653-0843",
          "653-0052",
          "653-0836",
          "653-0805",
          "653-0827",
          "653-0033",
          "653-0032",
          "653-0834",
          "653-0016",
          "653-0041",
          "653-0888",
          "653-0851",
          "653-0867",
          "653-0003",
          "653-0034",
          "653-0043",
          "653-0045",
          "653-0011",
          "653-0877",
          "653-0035",
          "653-0853",
          "653-0015",
          "653-0806",
          "653-0856",
          "653-0881",
          "653-0872",
          "653-0866",
          "653-0804",
          "653-0845",
          "653-0855",
          "653-0812",
          "653-0882",
          "653-0054",
          "653-0883",
          "653-0001",
          "653-0055",
          "653-0031",
          "653-0844",
          "653-0874",
          "653-0862",
          "653-0012",
          "653-0051",
          "653-0873",
          "653-0837",
          "653-0831",
          "653-0876",
          "653-0024",
          "653-0861",
          "653-0887",
          "653-0023",
          "653-0022",
          "653-0886",
          "653-0879",
          "653-0039",
          "653-0042",
          "653-0854",
          "653-0801",
          "653-0835",
          "653-0885",
          "653-0053",
          "653-0803",
          "653-0841",
          "653-0025",
          "653-0875",
          "653-0014",
          "653-0842",
          "653-0044",
          "653-0832",
          "653-0863",
          "653-0813",
          "653-0884",
          "653-0852",
          "653-0004",
          "653-0002",
          "653-0038",
          "654-0000",
          "654-0038",
          "654-0047",
          "654-0009",
          "654-0076",
          "654-0044",
          "654-0004",
          "654-0023",
          "654-0026",
          "654-0024",
          "654-0017",
          "654-0013",
          "654-0015",
          "654-0162",
          "654-0016",
          "654-0005",
          "654-0008",
          "654-0151",
          "654-0064",
          "654-0048",
          "654-0111",
          "654-0042",
          "654-0031",
          "654-0066",
          "654-0114",
          "654-0075",
          "654-0123",
          "654-0101",
          "654-0103",
          "654-0003",
          "654-0143",
          "654-0055",
          "654-0071",
          "654-0054",
          "654-0073",
          "654-0001",
          "654-0043",
          "654-0022",
          "654-0133",
          "654-0134",
          "654-0132",
          "654-0061",
          "654-0081",
          "654-0074",
          "654-0039",
          "654-0027",
          "654-0072",
          "654-0063",
          "654-0051",
          "654-0025",
          "654-0053",
          "654-0122",
          "654-0028",
          "654-0012",
          "654-0034",
          "654-0142",
          "654-0154",
          "654-0035",
          "654-0155",
          "654-0068",
          "654-0152",
          "654-0102",
          "654-0018",
          "654-0033",
          "654-0021",
          "654-0041",
          "654-0007",
          "654-0032",
          "654-0011",
          "654-0045",
          "654-0062",
          "654-0113",
          "654-0163",
          "654-0153",
          "654-0036",
          "654-0052",
          "654-0002",
          "654-0121",
          "654-0046",
          "654-0161",
          "654-0037",
          "654-0006",
          "654-0131",
          "654-0067",
          "654-0065",
          "654-0141",
          "654-0014",
          "654-0112",
          "654-0049",
          "655-0000",
          "655-0873",
          "655-0862",
          "655-0033",
          "655-0885",
          "655-0037",
          "655-0883",
          "655-0014",
          "655-0882",
          "655-0036",
          "655-0039",
          "655-0017",
          "655-0049",
          "655-0894",
          "655-0027",
          "655-0045",
          "655-0026",
          "655-0012",
          "655-0008",
          "655-0061",
          "655-0002",
          "655-0009",
          "655-0003",
          "655-0035",
          "655-0024",
          "655-0895",
          "655-0005",
          "655-0863",
          "655-0864",
          "655-0872",
          "655-0031",
          "655-0023",
          "655-0861",
          "655-0871",
          "655-0884",
          "655-0041",
          "655-0851",
          "655-0865",
          "655-0038",
          "655-0016",
          "655-0007",
          "655-0001",
          "655-0011",
          "655-0018",
          "655-0853",
          "655-0029",
          "655-0034",
          "655-0896",
          "655-0048",
          "655-0042",
          "655-0015",
          "655-0021",
          "655-0886",
          "655-0881",
          "655-0047",
          "655-0893",
          "655-0892",
          "655-0013",
          "655-0032",
          "655-0006",
          "655-0044",
          "655-0046",
          "655-0051",
          "655-0052",
          "655-0004",
          "655-0025",
          "655-0022",
          "655-0043",
          "655-0874",
          "655-0028",
          "655-0852",
          "655-0854",
          "655-0891",
          "651-1100",
          "651-1231",
          "651-1516",
          "651-1321",
          "651-1312",
          "651-1331",
          "651-1311",
          "651-1313",
          "651-1401",
          "651-1141",
          "651-1603",
          "651-1604",
          "651-1601",
          "651-1616",
          "651-1614",
          "651-1613",
          "651-1622",
          "651-1611",
          "651-1623",
          "651-1615",
          "651-1612",
          "651-1621",
          "651-1602",
          "651-1206",
          "651-1521",
          "651-1522",
          "651-1523",
          "651-1526",
          "651-1524",
          "651-1525",
          "651-1222",
          "651-1144",
          "651-1211",
          "651-1255",
          "651-1223",
          "651-1514",
          "651-1513",
          "651-1332",
          "651-1334",
          "651-1131",
          "651-1122",
          "651-1304",
          "651-1142",
          "651-1515",
          "651-1203",
          "651-1213",
          "651-1214",
          "651-1106",
          "651-1306",
          "651-1146",
          "651-1112",
          "651-1114",
          "651-1113",
          "651-1111",
          "651-1121",
          "651-1145",
          "651-1245",
          "651-1246",
          "651-1244",
          "651-1212",
          "651-1505",
          "651-1502",
          "651-1501",
          "651-1504",
          "669-1161",
          "651-1503",
          "651-1103",
          "651-1511",
          "651-1512",
          "651-1133",
          "651-1201",
          "651-1305",
          "651-1354",
          "651-1352",
          "651-1343",
          "651-1351",
          "651-1345",
          "651-1344",
          "651-1341",
          "651-1342",
          "651-1353",
          "651-1205",
          "651-1202",
          "651-1204",
          "651-1322",
          "651-1333",
          "651-1233",
          "651-1124",
          "651-1123",
          "651-1125",
          "651-1301",
          "651-1302",
          "651-1303",
          "651-1232",
          "651-1147",
          "651-1221",
          "651-1132",
          "651-1104",
          "651-1105",
          "651-1101",
          "651-1241",
          "651-1242",
          "651-1261",
          "651-1102",
          "652-0071",
          "651-1243",
          "651-1264",
          "651-1253",
          "651-1263",
          "651-1252",
          "651-1262",
          "651-1254",
          "651-1251",
          "651-1143",
          "650-0000",
          "650-0025",
          "650-0037",
          "651-0095",
          "651-0076",
          "651-0092",
          "651-0086",
          "651-0084",
          "650-0032",
          "650-0033",
          "651-0088",
          "651-0082",
          "650-0024",
          "651-0053",
          "650-0001",
          "651-0061",
          "651-0067",
          "650-0012",
          "650-0002",
          "651-0075",
          "650-0034",
          "650-0017",
          "651-0066",
          "651-0096",
          "651-0056",
          "651-0055",
          "650-0048",
          "650-0007",
          "651-0087",
          "651-0094",
          "650-0026",
          "650-0023",
          "651-0062",
          "650-0021",
          "651-0079",
          "650-0011",
          "650-0041",
          "651-0051",
          "650-0006",
          "651-0064",
          "650-0016",
          "650-0015",
          "651-0071",
          "651-0057",
          "651-0052",
          "650-0027",
          "650-0004",
          "650-0035",
          "650-0038",
          "651-0093",
          "651-0097",
          "651-0054",
          "651-0068",
          "651-0085",
          "650-0042",
          "650-0013",
          "651-0083",
          "650-0036",
          "650-0044",
          "650-0031",
          "651-0077",
          "651-0058",
          "650-0005",
          "650-0043",
          "650-0039",
          "651-0081",
          "650-0045",
          "650-0046",
          "650-0047",
          "651-0074",
          "651-0063",
          "650-0014",
          "650-0022",
          "651-0078",
          "650-0003",
          "651-0091",
          "651-0073",
          "651-0072",
          "651-0065",
          "651-2224",
          "651-2134",
          "651-2141",
          "651-2113",
          "651-2106",
          "651-2105",
          "651-2107",
          "651-2124",
          "651-2108",
          "651-2104",
          "651-2101",
          "651-2115",
          "651-2111",
          "651-2242",
          "651-2243",
          "651-2244",
          "651-2114",
          "651-2401",
          "651-2402",
          "651-2403",
          "651-2405",
          "651-2404",
          "651-2133",
          "651-2135",
          "651-2414",
          "651-2112",
          "651-2212",
          "651-2222",
          "651-2203",
          "651-2223",
          "651-2221",
          "651-2207",
          "651-2211",
          "651-2204",
          "651-2202",
          "651-2213",
          "651-2205",
          "651-2206",
          "651-2103",
          "651-2102",
          "651-2275",
          "651-2276",
          "651-2411",
          "651-2272",
          "651-2303",
          "651-2333",
          "651-2302",
          "651-2304",
          "651-2313",
          "651-2331",
          "651-2321",
          "651-2334",
          "651-2301",
          "651-2311",
          "651-2312",
          "651-2332",
          "651-2117",
          "651-2215",
          "651-2273",
          "651-2144",
          "651-2226",
          "651-2225",
          "651-2227",
          "651-2129",
          "651-2109",
          "651-2201",
          "651-2271",
          "651-2274",
          "651-2145",
          "651-2128",
          "651-2126",
          "651-2122",
          "651-2125",
          "651-2147",
          "651-2137",
          "651-2127",
          "651-2142",
          "651-2143",
          "651-2121",
          "651-2138",
          "651-2217",
          "651-2123",
          "651-2136",
          "651-2148",
          "651-2234",
          "651-2238",
          "651-2237",
          "651-2231",
          "651-2236",
          "651-2232",
          "651-2235",
          "651-2233",
          "651-2239",
          "651-2266",
          "651-2256",
          "651-2264",
          "651-2261",
          "651-2268",
          "651-2255",
          "651-2262",
          "651-2254",
          "651-2251",
          "651-2263",
          "651-2257",
          "651-2267",
          "651-2252",
          "651-2265",
          "651-2253",
          "651-2413",
          "651-2214",
          "651-2277",
          "651-2228",
          "651-2116",
          "651-2216",
          "651-2146",
          "651-2241",
          "651-2131",
          "651-2132",
          "651-2412",
          "651-2120",
          "670-0000",
          "671-2232",
          "671-2222",
          "671-2224",
          "671-2223",
          "671-2221",
          "670-0934",
          "670-0944",
          "671-1236",
          "671-1231",
          "671-1232",
          "671-1233",
          "671-1241",
          "671-1253",
          "671-1252",
          "671-1256",
          "671-1255",
          "671-1251",
          "671-1257",
          "671-1235",
          "671-1223",
          "671-1228",
          "671-1234",
          "671-1221",
          "671-1226",
          "671-1224",
          "671-1242",
          "671-1225",
          "671-1222",
          "671-1254",
          "671-1227",
          "670-0029",
          "670-0974",
          "672-0103",
          "672-0101",
          "672-0102",
          "670-0007",
          "671-2231",
          "670-0822",
          "670-0825",
          "670-0943",
          "670-0871",
          "670-0816",
          "670-0983",
          "670-0052",
          "670-0028",
          "670-0905",
          "671-2246",
          "670-0817",
          "670-0894",
          "670-0927",
          "671-2233",
          "671-0101",
          "671-0102",
          "671-0103",
          "671-1136",
          "671-1146",
          "671-1132",
          "671-1142",
          "671-1133",
          "671-1135",
          "671-1131",
          "671-1143",
          "671-1144",
          "671-1141",
          "671-1145",
          "671-1134",
          "670-0868",
          "670-0982",
          "670-0026",
          "672-8003",
          "670-0037",
          "670-0009",
          "670-0002",
          "670-0045",
          "671-2241",
          "671-1204",
          "671-1205",
          "671-1212",
          "671-1202",
          "671-1211",
          "671-1201",
          "671-1213",
          "671-1214",
          "671-1203",
          "670-0005",
          "672-8001",
          "670-0896",
          "670-0041",
          "670-0065",
          "670-0836",
          "670-0925",
          "670-0973",
          "671-2213",
          "671-2212",
          "670-0991",
          "670-0057",
          "670-0091",
          "672-8002",
          "670-0893",
          "670-0892",
          "670-0895",
          "670-0887",
          "670-0877",
          "671-2202",
          "670-0075",
          "672-8016",
          "672-8017",
          "672-8018",
          "672-8019",
          "670-0851",
          "670-0824",
          "670-0826",
          "670-0916",
          "670-0954",
          "670-0058",
          "670-0027",
          "679-2154",
          "679-2131",
          "679-2141",
          "679-2167",
          "679-2151",
          "679-2132",
          "679-2153",
          "679-2165",
          "679-2164",
          "679-2143",
          "679-2166",
          "679-2144",
          "679-2162",
          "679-2163",
          "679-2142",
          "679-2161",
          "679-2155",
          "679-2152",
          "670-0852",
          "670-0854",
          "670-0043",
          "670-0035",
          "670-0936",
          "670-0001",
          "670-0003",
          "670-0022",
          "670-0924",
          "670-0923",
          "670-0857",
          "670-0981",
          "670-0025",
          "670-0835",
          "670-0014",
          "670-0931",
          "670-0016",
          "670-0994",
          "670-0940",
          "670-0949",
          "670-0953",
          "672-8041",
          "670-0904",
          "672-8078",
          "672-8092",
          "672-8084",
          "672-8087",
          "672-8088",
          "672-8091",
          "672-8089",
          "672-8080",
          "672-8037",
          "672-8030",
          "672-8038",
          "672-8059",
          "672-8058",
          "672-8039",
          "672-8079",
          "672-8090",
          "672-8076",
          "672-8057",
          "672-8062",
          "672-8077",
          "672-8071",
          "672-8094",
          "672-8043",
          "672-8047",
          "672-8074",
          "672-8073",
          "672-8070",
          "672-8069",
          "672-8056",
          "672-8053",
          "672-8036",
          "672-8075",
          "672-8051",
          "672-8044",
          "672-8083",
          "672-8063",
          "672-8081",
          "672-8072",
          "672-8052",
          "672-8082",
          "672-8061",
          "672-8046",
          "672-8035",
          "672-8045",
          "672-8085",
          "672-8086",
          "672-8040",
          "672-8054",
          "672-8098",
          "672-8064",
          "672-8025",
          "672-8055",
          "672-8048",
          "672-8031",
          "672-8032",
          "672-8034",
          "672-8033",
          "672-8093",
          "672-8097",
          "672-8096",
          "672-8095",
          "671-2216",
          "671-2215",
          "671-0203",
          "671-0204",
          "671-0209",
          "671-0201",
          "671-0214",
          "671-0202",
          "671-0212",
          "671-0205",
          "671-0217",
          "671-0211",
          "671-0216",
          "671-0218",
          "671-0219",
          "671-0208",
          "671-0207",
          "671-0215",
          "671-0245",
          "671-0241",
          "671-0246",
          "671-0242",
          "671-0247",
          "671-0243",
          "671-0244",
          "671-0248",
          "670-0044",
          "670-0046",
          "670-0917",
          "671-2244",
          "670-0063",
          "670-0932",
          "670-0911",
          "670-0951",
          "670-0841",
          "670-0845",
          "670-0849",
          "670-0843",
          "670-0848",
          "670-0847",
          "670-0844",
          "670-0842",
          "670-0883",
          "670-0884",
          "671-2201",
          "671-2203",
          "670-0808",
          "672-8023",
          "672-8021",
          "672-8022",
          "672-8013",
          "672-8011",
          "672-8012",
          "672-8024",
          "670-0902",
          "670-0803",
          "670-0831",
          "670-0095",
          "670-0094",
          "670-0092",
          "670-0834",
          "671-2243",
          "670-0015",
          "670-0853",
          "670-0898",
          "670-0833",
          "671-2211",
          "670-0062",
          "670-0915",
          "670-0024",
          "670-0013",
          "670-0032",
          "670-0903",
          "670-0086",
          "670-0082",
          "670-0081",
          "670-0985",
          "670-0976",
          "670-0975",
          "671-2217",
          "670-0984",
          "670-0989",
          "670-0993",
          "672-8004",
          "672-8049",
          "670-0083",
          "670-0996",
          "670-0995",
          "670-0972",
          "670-0846",
          "670-0821",
          "670-0856",
          "670-0914",
          "670-0802",
          "670-0986",
          "670-0987",
          "670-0964",
          "679-2124",
          "679-2121",
          "679-2123",
          "679-2122",
          "670-0051",
          "670-0952",
          "670-0922",
          "670-0061",
          "670-0913",
          "670-0096",
          "670-0033",
          "670-0897",
          "670-0805",
          "670-0901",
          "670-0971",
          "670-0876",
          "671-2214",
          "671-2234",
          "670-0801",
          "670-0038",
          "670-0961",
          "670-0811",
          "670-0814",
          "670-0813",
          "670-0862",
          "670-0815",
          "670-0865",
          "670-0867",
          "670-0864",
          "670-0863",
          "670-0861",
          "670-0866",
          "670-0966",
          "671-2245",
          "670-0906",
          "670-0008",
          "670-0047",
          "671-0253",
          "671-0255",
          "671-0252",
          "671-0251",
          "671-0256",
          "671-0254",
          "679-4231",
          "679-4223",
          "679-4232",
          "679-4233",
          "679-4204",
          "679-4203",
          "679-4202",
          "679-4222",
          "679-4201",
          "679-4205",
          "679-4214",
          "679-4206",
          "679-4221",
          "679-4212",
          "679-4211",
          "679-4215",
          "679-4213",
          "670-0056",
          "670-0926",
          "670-0084",
          "670-0965",
          "672-8014",
          "670-0064",
          "670-0942",
          "670-0933",
          "671-1154",
          "671-1155",
          "671-1102",
          "671-1111",
          "671-1112",
          "671-1106",
          "671-1156",
          "671-1152",
          "671-1104",
          "671-1113",
          "671-1108",
          "671-1115",
          "671-1116",
          "671-1153",
          "671-1124",
          "671-1125",
          "671-1107",
          "671-1105",
          "671-1151",
          "671-1121",
          "671-1101",
          "671-1103",
          "671-1123",
          "671-1114",
          "671-1122",
          "670-0882",
          "670-0891",
          "670-0855",
          "670-0992",
          "670-0017",
          "670-0004",
          "670-0066",
          "670-0832",
          "670-0034",
          "679-2101",
          "670-0048",
          "671-0225",
          "671-0223",
          "671-0222",
          "671-0224",
          "671-0226",
          "671-0221",
          "670-0947",
          "670-0945",
          "670-0946",
          "670-0948",
          "670-0935",
          "670-0804",
          "670-0011",
          "670-0881",
          "670-0012",
          "670-0806",
          "670-0807",
          "671-0112",
          "671-0111",
          "670-0827",
          "671-0234",
          "671-0232",
          "671-0233",
          "671-0231",
          "670-0055",
          "670-0073",
          "670-0072",
          "670-0074",
          "670-0071",
          "671-2247",
          "670-0054",
          "670-0962",
          "670-0053",
          "670-0093",
          "670-0912",
          "670-0875",
          "670-0823",
          "670-0837",
          "670-0812",
          "670-0937",
          "670-0049",
          "672-8015",
          "670-0006",
          "670-0872",
          "670-0873",
          "670-0874",
          "670-0886",
          "670-0885",
          "670-0955",
          "671-2401",
          "671-2426",
          "671-2422",
          "671-2413",
          "671-2424",
          "671-2416",
          "671-2423",
          "671-2414",
          "671-2421",
          "671-2412",
          "671-2425",
          "671-2411",
          "671-2415",
          "670-0023",
          "679-2111",
          "679-2114",
          "679-2115",
          "679-2113",
          "679-2112",
          "670-0021",
          "670-0036",
          "670-0085",
          "671-2133",
          "671-2106",
          "671-2114",
          "671-2122",
          "671-2117",
          "671-2136",
          "671-2132",
          "671-2113",
          "671-2105",
          "671-2112",
          "671-2102",
          "671-2111",
          "671-2134",
          "671-2124",
          "671-2135",
          "671-2116",
          "671-2131",
          "671-2137",
          "671-2103",
          "671-2115",
          "671-2121",
          "671-2123",
          "671-2101",
          "670-0031",
          "670-0042",
          "671-1263",
          "671-1262",
          "671-1261",
          "671-2242",
          "670-0941",
          "670-0921",
          "660-0000",
          "661-0981",
          "660-0064",
          "660-0055",
          "660-0812",
          "660-0096",
          "660-0076",
          "660-0072",
          "660-0075",
          "660-0077",
          "660-0063",
          "660-0842",
          "661-0023",
          "660-0095",
          "661-0022",
          "660-0862",
          "660-0821",
          "661-0979",
          "661-0014",
          "661-0971",
          "661-0964",
          "660-0884",
          "660-0885",
          "660-0883",
          "660-0826",
          "660-0878",
          "660-0804",
          "660-0834",
          "660-0806",
          "660-0813",
          "660-0814",
          "660-0822",
          "660-0815",
          "661-0977",
          "661-0978",
          "661-0983",
          "661-0013",
          "660-0873",
          "660-0872",
          "661-0982",
          "660-0074",
          "661-0972",
          "661-0024",
          "660-0808",
          "661-0976",
          "660-0866",
          "661-0952",
          "661-0975",
          "660-0811",
          "660-0881",
          "660-0882",
          "660-0082",
          "660-0094",
          "660-0071",
          "661-0973",
          "660-0823",
          "661-0963",
          "660-0876",
          "661-0025",
          "660-0871",
          "661-0951",
          "661-0002",
          "661-0001",
          "660-0858",
          "661-0965",
          "661-0046",
          "661-0042",
          "660-0092",
          "660-0867",
          "660-0083",
          "661-0961",
          "661-0003",
          "660-0851",
          "660-0091",
          "660-0802",
          "660-0801",
          "660-0807",
          "660-0803",
          "660-0073",
          "661-0974",
          "660-0052",
          "660-0093",
          "661-0966",
          "661-0047",
          "660-0865",
          "660-0845",
          "660-0054",
          "660-0827",
          "660-0805",
          "660-0893",
          "660-0874",
          "660-0863",
          "660-0837",
          "660-0868",
          "660-0857",
          "661-0962",
          "661-0967",
          "660-0062",
          "660-0843",
          "660-0864",
          "661-0953",
          "660-0841",
          "660-0828",
          "661-0011",
          "660-0051",
          "660-0892",
          "660-0832",
          "660-0844",
          "660-0824",
          "660-0831",
          "660-0835",
          "660-0856",
          "660-0891",
          "660-0846",
          "660-0087",
          "660-0086",
          "661-0026",
          "661-0984",
          "660-0861",
          "661-0985",
          "660-0825",
          "660-0875",
          "661-0012",
          "660-0053",
          "660-0833",
          "661-0033",
          "660-0877",
          "660-0084",
          "661-0044",
          "661-0041",
          "661-0035",
          "661-0031",
          "661-0032",
          "661-0034",
          "661-0043",
          "661-0045",
          "661-0021",
          "660-0085",
          "661-0970",
          "660-0061",
          "660-0081",
          "673-0000",
          "673-0882",
          "673-0847",
          "673-0851",
          "673-0852",
          "673-0866",
          "673-0860",
          "673-0870",
          "673-0853",
          "673-0002",
          "673-0846",
          "674-0071",
          "674-0073",
          "674-0074",
          "674-0083",
          "674-0072",
          "674-0082",
          "674-0084",
          "674-0081",
          "673-0022",
          "673-0891",
          "674-0059",
          "674-0064",
          "674-0058",
          "674-0051",
          "674-0067",
          "674-0057",
          "674-0062",
          "674-0065",
          "674-0054",
          "674-0066",
          "674-0053",
          "674-0052",
          "674-0050",
          "674-0055",
          "674-0061",
          "674-0063",
          "674-0056",
          "674-0068",
          "674-0069",
          "673-0879",
          "673-0875",
          "673-0873",
          "673-0871",
          "673-0874",
          "673-0867",
          "673-0872",
          "673-0884",
          "673-0012",
          "673-0014",
          "673-0037",
          "673-0857",
          "673-0021",
          "673-0005",
          "673-0893",
          "673-0849",
          "673-0885",
          "673-0008",
          "673-0027",
          "673-0028",
          "673-0897",
          "673-0845",
          "673-0843",
          "673-0841",
          "673-0029",
          "673-0848",
          "673-0032",
          "673-0025",
          "673-0898",
          "673-0881",
          "673-0003",
          "673-0007",
          "673-0006",
          "673-0004",
          "673-0855",
          "673-0883",
          "673-0009",
          "673-0049",
          "673-0041",
          "673-0018",
          "673-0011",
          "673-0856",
          "673-0023",
          "673-0842",
          "673-0017",
          "673-0015",
          "673-0034",
          "673-0033",
          "673-0854",
          "673-0886",
          "673-0844",
          "673-0876",
          "673-0042",
          "673-0868",
          "673-0877",
          "673-0896",
          "673-0044",
          "673-0043",
          "673-0047",
          "673-0048",
          "673-0045",
          "673-0046",
          "674-0092",
          "674-0094",
          "674-0095",
          "674-0093",
          "674-0091",
          "673-0026",
          "673-0038",
          "673-0892",
          "673-0036",
          "673-0862",
          "673-0861",
          "673-0016",
          "673-0895",
          "673-0894",
          "673-0024",
          "673-0035",
          "673-0031",
          "673-0001",
          "673-0878",
          "673-0013",
          "662-0000",
          "662-0063",
          "662-0862",
          "669-1122",
          "663-8186",
          "662-0925",
          "662-0842",
          "662-0871",
          "662-0946",
          "663-8025",
          "662-0911",
          "663-8137",
          "662-0928",
          "662-0074",
          "662-0932",
          "662-0873",
          "662-0975",
          "663-8002",
          "662-0972",
          "663-8214",
          "663-8213",
          "663-8221",
          "663-8222",
          "663-8229",
          "663-8223",
          "663-8227",
          "663-8225",
          "663-8212",
          "663-8228",
          "663-8224",
          "663-8215",
          "663-8226",
          "663-8211",
          "662-0886",
          "662-0885",
          "662-0891",
          "662-0892",
          "662-0893",
          "662-0894",
          "662-0895",
          "662-0896",
          "662-0881",
          "662-0882",
          "662-0883",
          "662-0884",
          "663-8134",
          "663-8133",
          "663-8135",
          "662-0855",
          "663-8143",
          "662-0085",
          "662-0036",
          "663-8017",
          "662-0054",
          "662-0836",
          "662-0957",
          "663-8023",
          "663-8106",
          "662-0827",
          "662-0022",
          "662-0961",
          "663-8182",
          "662-0977",
          "663-8136",
          "662-0052",
          "662-0001",
          "663-8003",
          "662-0865",
          "663-8114",
          "662-0813",
          "662-0027",
          "663-8021",
          "662-0954",
          "662-0097",
          "662-0098",
          "662-0944",
          "662-0951",
          "662-0861",
          "662-0945",
          "663-8107",
          "662-0823",
          "662-0021",
          "662-0078",
          "662-0062",
          "663-8035",
          "662-0833",
          "662-0025",
          "662-0091",
          "651-1413",
          "669-1131",
          "662-0077",
          "669-1135",
          "662-0927",
          "663-8103",
          "662-0064",
          "662-0926",
          "662-0083",
          "662-0082",
          "662-0081",
          "662-0088",
          "662-0087",
          "662-0086",
          "662-0037",
          "662-0099",
          "663-8156",
          "663-8165",
          "663-8151",
          "663-8162",
          "663-8166",
          "663-8167",
          "663-8161",
          "663-8163",
          "663-8164",
          "663-8171",
          "663-8172",
          "663-8173",
          "663-8174",
          "663-8175",
          "663-8176",
          "663-8177",
          "663-8178",
          "663-8179",
          "663-8113",
          "663-8112",
          "663-8152",
          "663-8155",
          "662-0812",
          "662-0832",
          "662-0965",
          "662-0018",
          "662-0012",
          "662-0017",
          "662-0014",
          "662-0015",
          "662-0011",
          "662-0016",
          "662-0092",
          "662-0006",
          "662-0864",
          "663-8122",
          "662-0047",
          "663-8123",
          "663-8125",
          "663-8124",
          "663-8126",
          "663-8127",
          "662-0844",
          "662-0032",
          "662-0071",
          "662-0875",
          "663-8183",
          "662-0978",
          "669-1101",
          "669-1251",
          "669-1141",
          "662-0026",
          "662-0033",
          "663-8004",
          "663-8005",
          "662-0956",
          "662-0974",
          "662-0004",
          "662-0003",
          "662-0002",
          "662-0856",
          "662-0822",
          "662-0023",
          "662-0843",
          "662-0013",
          "662-0845",
          "662-0041",
          "662-0096",
          "651-1432",
          "662-0913",
          "662-0867",
          "663-8033",
          "663-8032",
          "662-0872",
          "663-8141",
          "662-0066",
          "663-8202",
          "663-8204",
          "663-8201",
          "663-8001",
          "662-0943",
          "662-0973",
          "663-8006",
          "662-0046",
          "662-0853",
          "663-8012",
          "663-8244",
          "663-8242",
          "663-8247",
          "663-8243",
          "663-8241",
          "663-8245",
          "663-8234",
          "663-8231",
          "663-8246",
          "663-8232",
          "663-8233",
          "663-8104",
          "662-0043",
          "663-8121",
          "662-0916",
          "662-0065",
          "663-8105",
          "662-0851",
          "662-0852",
          "662-0952",
          "662-0857",
          "662-0868",
          "662-0955",
          "663-8034",
          "669-1147",
          "669-1149",
          "669-1143",
          "669-1136",
          "669-1146",
          "669-1142",
          "669-1144",
          "669-1148",
          "669-1145",
          "669-1132",
          "669-1162",
          "669-1134",
          "662-0024",
          "669-1103",
          "669-1111",
          "669-1102",
          "669-1104",
          "663-8184",
          "663-8142",
          "662-0038",
          "662-0814",
          "662-0815",
          "662-0811",
          "662-0034",
          "662-0934",
          "662-0933",
          "662-0093",
          "662-0838",
          "663-8015",
          "662-0051",
          "662-0854",
          "663-8187",
          "669-1121",
          "662-0915",
          "663-8154",
          "662-0942",
          "662-0923",
          "662-0941",
          "663-8014",
          "663-8132",
          "662-0924",
          "662-0922",
          "669-1133",
          "662-0094",
          "662-0084",
          "663-8011",
          "663-8022",
          "662-0835",
          "662-0044",
          "662-0837",
          "663-8203",
          "662-0067",
          "663-8031",
          "663-8111",
          "663-8185",
          "662-0042",
          "669-1112",
          "662-0072",
          "662-0953",
          "662-0914",
          "662-0931",
          "662-0076",
          "662-0073",
          "662-0061",
          "662-0962",
          "662-0053",
          "663-8102",
          "662-0912",
          "663-8101",
          "662-0831",
          "662-0031",
          "662-0095",
          "663-8153",
          "662-0075",
          "662-0834",
          "662-0976",
          "662-0947",
          "663-8131",
          "662-0863",
          "662-0846",
          "663-8013",
          "662-0826",
          "662-0824",
          "662-0828",
          "662-0825",
          "663-8024",
          "662-0963",
          "662-0045",
          "662-0866",
          "651-1421",
          "651-1422",
          "651-1424",
          "651-1412",
          "651-1433",
          "651-1411",
          "651-1431",
          "651-1423",
          "662-0005",
          "662-0964",
          "662-0921",
          "662-0917",
          "662-0841",
          "662-0918",
          "662-0874",
          "663-8181",
          "662-0035",
          "663-8016",
          "662-0971",
          "656-0000",
          "656-2531",
          "656-2124",
          "656-2122",
          "656-2123",
          "656-2121",
          "656-2126",
          "656-2125",
          "656-0111",
          "656-0043",
          "656-0042",
          "656-0054",
          "656-0012",
          "656-0055",
          "656-0018",
          "656-0101",
          "656-0023",
          "656-0022",
          "656-0046",
          "656-0015",
          "656-0017",
          "656-0053",
          "656-0045",
          "656-0014",
          "656-1314",
          "656-1315",
          "656-1322",
          "656-1316",
          "656-1317",
          "656-1326",
          "656-1318",
          "656-1327",
          "656-1311",
          "656-1323",
          "656-1321",
          "656-1313",
          "656-1325",
          "656-1324",
          "656-1312",
          "656-1336",
          "656-1337",
          "656-1301",
          "656-1303",
          "656-1302",
          "656-1331",
          "656-1341",
          "656-1304",
          "656-1344",
          "656-1342",
          "656-1343",
          "656-1333",
          "656-1332",
          "656-1335",
          "656-1334",
          "656-0026",
          "656-0021",
          "656-0013",
          "656-0016",
          "656-0041",
          "656-0011",
          "656-0031",
          "656-0052",
          "656-0001",
          "656-0005",
          "656-0002",
          "656-0006",
          "656-0003",
          "656-0004",
          "656-2532",
          "656-2533",
          "656-0025",
          "656-0044",
          "656-0027",
          "656-0051",
          "656-0024",
          "656-2541",
          "656-2542",
          "656-2543",
          "659-0000",
          "659-0012",
          "659-0052",
          "659-0013",
          "659-0028",
          "659-0022",
          "659-0092",
          "659-0066",
          "659-0003",
          "659-0004",
          "659-0002",
          "659-0035",
          "659-0021",
          "659-0061",
          "659-0072",
          "659-0065",
          "659-0015",
          "659-0051",
          "659-0001",
          "659-0087",
          "659-0086",
          "659-0043",
          "659-0076",
          "659-0081",
          "659-0016",
          "659-0036",
          "659-0064",
          "659-0023",
          "659-0033",
          "659-0055",
          "659-0067",
          "659-0084",
          "659-0075",
          "659-0068",
          "659-0024",
          "659-0031",
          "659-0085",
          "659-0026",
          "659-0083",
          "659-0054",
          "659-0032",
          "659-0025",
          "659-0095",
          "659-0091",
          "659-0073",
          "659-0074",
          "659-0093",
          "659-0071",
          "659-0094",
          "659-0053",
          "659-0014",
          "659-0042",
          "659-0037",
          "659-0063",
          "659-0062",
          "659-0082",
          "659-0096",
          "659-0034",
          "659-0011",
          "659-0041",
          "659-0027",
          "664-0000",
          "664-0001",
          "664-0008",
          "664-0864",
          "664-0027",
          "664-0846",
          "664-0861",
          "664-0011",
          "664-0843",
          "664-0856",
          "664-0899",
          "664-0003",
          "664-0002",
          "664-0031",
          "664-0025",
          "563-0801",
          "664-0833",
          "664-0863",
          "664-0893",
          "664-0831",
          "664-0837",
          "664-0891",
          "664-0007",
          "664-0836",
          "664-0857",
          "664-0844",
          "664-0872",
          "664-0839",
          "664-0006",
          "664-0855",
          "664-0881",
          "664-0015",
          "664-0885",
          "664-0016",
          "664-0886",
          "664-0888",
          "664-0897",
          "664-0894",
          "664-0832",
          "664-0882",
          "664-0898",
          "664-0892",
          "664-0851",
          "664-0026",
          "664-0020",
          "664-0022",
          "664-0023",
          "664-0029",
          "664-0838",
          "664-0834",
          "664-0858",
          "664-0028",
          "664-0873",
          "664-0875",
          "664-0845",
          "664-0835",
          "664-0004",
          "664-0853",
          "664-0014",
          "664-0847",
          "664-0896",
          "664-0871",
          "664-0024",
          "664-0884",
          "664-0017",
          "664-0005",
          "664-0013",
          "664-0012",
          "664-0883",
          "664-0854",
          "664-0865",
          "664-0887",
          "664-0852",
          "664-0895",
          "664-0842",
          "664-0874",
          "664-0862",
          "678-0000",
          "678-0141",
          "678-0041",
          "678-0064",
          "678-0021",
          "678-0031",
          "678-0004",
          "678-0005",
          "678-0052",
          "678-0043",
          "678-0022",
          "678-0042",
          "678-0003",
          "678-0007",
          "678-0023",
          "678-0008",
          "678-0063",
          "678-0061",
          "678-0002",
          "678-0073",
          "678-0062",
          "678-0067",
          "678-0051",
          "678-0056",
          "678-0054",
          "678-0053",
          "678-0055",
          "678-0011",
          "678-0065",
          "678-0044",
          "678-0074",
          "678-0024",
          "678-0012",
          "678-0025",
          "678-0006",
          "678-0071",
          "678-0091",
          "678-0092",
          "678-0066",
          "678-0001",
          "678-0072",
          "678-0081",
          "678-0082",
          "668-0000",
          "668-0801",
          "668-0001",
          "668-0261",
          "668-0213",
          "668-0207",
          "668-0218",
          "668-0244",
          "668-0215",
          "668-0214",
          "668-0271",
          "668-0201",
          "668-0251",
          "668-0235",
          "668-0279",
          "668-0255",
          "668-0231",
          "668-0242",
          "668-0202",
          "668-0264",
          "668-0256",
          "668-0216",
          "668-0205",
          "668-0211",
          "668-0233",
          "668-0209",
          "668-0212",
          "668-0273",
          "668-0257",
          "668-0223",
          "668-0241",
          "668-0222",
          "668-0217",
          "668-0272",
          "668-0275",
          "668-0243",
          "668-0254",
          "668-0203",
          "668-0237",
          "668-0246",
          "668-0266",
          "668-0238",
          "668-0206",
          "668-0263",
          "668-0265",
          "668-0262",
          "668-0224",
          "668-0221",
          "668-0236",
          "668-0277",
          "668-0278",
          "668-0204",
          "668-0274",
          "668-0276",
          "668-0225",
          "668-0208",
          "668-0234",
          "668-0245",
          "668-0232",
          "668-0253",
          "668-0252",
          "668-0021",
          "668-0821",
          "668-0851",
          "668-0081",
          "668-0002",
          "668-0071",
          "668-0852",
          "668-0041",
          "668-0861",
          "668-0072",
          "668-0031",
          "668-0822",
          "669-6123",
          "668-0022",
          "668-0871",
          "668-0862",
          "668-0023",
          "668-0811",
          "668-0011",
          "668-0061",
          "668-0863",
          "668-0831",
          "668-0841",
          "668-0864",
          "669-6103",
          "669-6116",
          "669-6115",
          "669-6111",
          "669-6114",
          "669-6112",
          "669-6113",
          "669-6102",
          "669-6101",
          "668-0042",
          "668-0832",
          "669-6124",
          "668-0872",
          "668-0003",
          "668-0051",
          "668-0053",
          "668-0052",
          "668-0024",
          "668-0802",
          "668-0025",
          "668-0812",
          "668-0043",
          "668-0062",
          "668-0044",
          "668-0054",
          "668-0012",
          "668-0803",
          "668-0813",
          "668-0865",
          "668-0082",
          "668-0814",
          "668-0873",
          "668-0045",
          "668-0063",
          "668-0853",
          "668-0055",
          "668-0004",
          "669-6122",
          "669-6125",
          "668-0064",
          "668-0005",
          "669-6214",
          "669-6223",
          "669-6202",
          "669-6352",
          "669-6218",
          "669-6224",
          "669-6333",
          "669-6354",
          "669-6334",
          "669-6216",
          "669-6229",
          "669-6215",
          "669-6353",
          "669-6341",
          "669-6222",
          "669-6226",
          "669-6221",
          "669-6351",
          "669-6203",
          "669-6201",
          "669-6343",
          "669-6225",
          "669-6342",
          "669-6344",
          "669-6213",
          "669-6217",
          "669-6227",
          "669-6228",
          "669-6331",
          "669-6212",
          "669-6355",
          "669-6332",
          "669-6335",
          "669-6211",
          "668-0866",
          "668-0046",
          "668-0833",
          "668-0324",
          "668-0352",
          "668-0316",
          "668-0374",
          "668-0372",
          "668-0335",
          "668-0353",
          "668-0343",
          "668-0301",
          "668-0323",
          "668-0321",
          "668-0331",
          "668-0341",
          "668-0373",
          "668-0363",
          "668-0315",
          "668-0333",
          "668-0376",
          "668-0354",
          "668-0334",
          "668-0325",
          "668-0364",
          "668-0361",
          "668-0311",
          "668-0313",
          "668-0337",
          "668-0342",
          "668-0345",
          "668-0317",
          "668-0332",
          "668-0303",
          "668-0351",
          "668-0375",
          "668-0314",
          "668-0336",
          "668-0362",
          "668-0304",
          "668-0312",
          "668-0322",
          "668-0344",
          "668-0371",
          "668-0302",
          "668-0033",
          "668-0032",
          "669-6121",
          "668-0073",
          "668-0083",
          "668-0065",
          "668-0013",
          "668-0842",
          "668-0874",
          "668-0834",
          "668-0074",
          "668-0804",
          "668-0014",
          "668-0854",
          "669-6127",
          "668-0843",
          "668-0844",
          "669-5314",
          "669-5331",
          "669-5315",
          "669-5356",
          "669-5326",
          "669-5367",
          "669-5375",
          "669-5357",
          "669-5338",
          "669-5346",
          "669-5302",
          "669-5301",
          "669-5339",
          "669-5324",
          "669-5354",
          "669-5345",
          "669-5342",
          "669-5372",
          "669-5361",
          "669-5341",
          "669-5366",
          "669-5351",
          "669-5355",
          "669-5362",
          "669-5365",
          "669-5364",
          "669-5332",
          "669-5371",
          "669-5336",
          "669-5352",
          "669-5313",
          "669-5321",
          "669-5343",
          "669-5369",
          "669-5358",
          "669-5337",
          "669-5335",
          "669-5379",
          "669-5344",
          "669-5328",
          "669-5305",
          "669-5363",
          "669-5327",
          "669-5359",
          "669-5311",
          "669-5303",
          "669-5373",
          "669-5312",
          "669-5322",
          "669-5333",
          "669-5323",
          "669-5325",
          "669-5307",
          "669-5376",
          "669-5378",
          "669-5306",
          "669-5374",
          "669-5353",
          "669-5377",
          "669-5368",
          "669-5334",
          "669-5304",
          "668-0015",
          "668-0815",
          "668-0075",
          "668-0084",
          "668-0855",
          "668-0076",
          "668-0805",
          "668-0816",
          "668-0047",
          "669-6126",
          "668-0085",
          "668-0823",
          "668-0016",
          "668-0056",
          "668-0077",
          "668-0026",
          "668-0806",
          "668-0824",
          "668-0006",
          "668-0057",
          "668-0807",
          "668-0875",
          "668-0078",
          "668-0817",
          "668-0027",
          "675-0000",
          "675-0026",
          "675-0023",
          "675-0027",
          "675-0022",
          "675-0024",
          "675-0021",
          "675-0025",
          "675-0039",
          "675-0034",
          "675-0061",
          "675-0067",
          "675-0031",
          "675-0038",
          "675-0065",
          "675-0066",
          "675-0035",
          "675-0068",
          "675-0036",
          "675-0063",
          "675-0032",
          "675-0037",
          "675-0064",
          "675-0033",
          "675-0062",
          "675-0137",
          "675-1212",
          "675-1218",
          "675-1217",
          "675-1213",
          "675-1211",
          "675-1216",
          "675-1214",
          "675-1215",
          "675-0005",
          "675-0003",
          "675-0009",
          "675-0007",
          "675-0006",
          "675-0004",
          "675-0001",
          "675-0301",
          "675-0305",
          "675-0311",
          "675-0314",
          "675-0303",
          "675-0321",
          "675-0342",
          "675-0304",
          "675-0347",
          "675-0334",
          "675-0345",
          "675-0346",
          "675-0331",
          "675-0333",
          "675-0313",
          "675-0302",
          "675-0341",
          "675-0335",
          "675-0344",
          "675-0306",
          "675-0312",
          "675-0336",
          "675-0343",
          "675-0332",
          "675-0008",
          "675-0044",
          "675-0047",
          "675-0045",
          "675-0046",
          "675-0043",
          "675-0042",
          "675-0041",
          "675-0011",
          "675-0015",
          "675-0018",
          "675-0010",
          "675-0016",
          "675-0012",
          "675-0013",
          "675-0014",
          "675-0019",
          "675-0017",
          "675-0058",
          "675-0056",
          "675-0057",
          "675-0052",
          "675-0055",
          "675-0051",
          "675-0115",
          "675-0116",
          "675-0117",
          "675-0101",
          "675-0103",
          "675-0104",
          "675-0105",
          "675-0113",
          "675-0102",
          "675-0114",
          "675-0111",
          "675-0112",
          "675-1233",
          "675-1236",
          "675-1226",
          "675-1224",
          "675-1222",
          "675-1235",
          "675-1232",
          "675-1223",
          "675-1225",
          "675-1234",
          "675-1221",
          "675-1231",
          "675-0123",
          "675-0127",
          "675-0131",
          "675-0121",
          "675-0128",
          "675-0133",
          "675-0125",
          "675-0135",
          "675-0122",
          "675-0126",
          "675-0124",
          "675-0136",
          "675-0132",
          "675-0134",
          "675-1204",
          "675-1203",
          "675-1201",
          "675-1205",
          "675-1202",
          "675-1206",
          "675-0002",
          "675-0053",
          "675-0054",
          "678-0200",
          "678-0214",
          "678-0250",
          "678-0248",
          "678-1181",
          "678-1182",
          "678-1183",
          "678-1184",
          "678-0252",
          "678-0229",
          "678-0205",
          "678-0221",
          "678-0254",
          "678-0225",
          "678-0249",
          "678-0235",
          "678-0236",
          "678-0237",
          "678-0239",
          "678-0233",
          "678-0234",
          "678-0175",
          "678-0165",
          "678-0253",
          "678-0259",
          "678-0223",
          "678-0171",
          "678-0204",
          "678-0258",
          "678-0172",
          "678-0226",
          "678-0201",
          "678-0212",
          "678-0244",
          "678-0216",
          "678-0255",
          "678-0162",
          "678-0241",
          "678-0163",
          "678-0256",
          "678-0227",
          "678-0232",
          "678-0161",
          "678-0242",
          "678-0211",
          "678-0251",
          "678-1186",
          "678-0207",
          "678-0208",
          "678-0238",
          "678-0173",
          "678-1185",
          "678-0222",
          "678-0257",
          "678-0247",
          "678-0231",
          "678-0217",
          "678-0228",
          "678-0166",
          "678-0174",
          "678-0215",
          "678-0245",
          "678-0176",
          "678-0206",
          "678-0164",
          "678-0224",
          "678-0213",
          "678-0203",
          "678-0202",
          "678-0246",
          "678-0243",
          "677-0000",
          "677-0061",
          "677-0056",
          "677-0004",
          "677-0044",
          "677-0038",
          "677-0001",
          "677-0025",
          "677-0065",
          "677-0068",
          "677-0069",
          "677-0035",
          "677-0039",
          "679-0322",
          "679-0324",
          "679-0313",
          "679-0311",
          "679-0302",
          "679-0301",
          "679-0316",
          "679-0321",
          "679-0315",
          "679-0323",
          "679-0314",
          "679-0304",
          "679-0303",
          "679-0312",
          "677-0016",
          "677-0017",
          "677-0014",
          "677-0021",
          "677-0026",
          "677-0033",
          "677-0024",
          "677-0043",
          "677-0031",
          "677-0041",
          "677-0055",
          "677-0051",
          "677-0034",
          "677-0036",
          "677-0062",
          "677-0022",
          "677-0018",
          "677-0011",
          "677-0012",
          "677-0032",
          "677-0023",
          "677-0003",
          "677-0015",
          "677-0005",
          "677-0054",
          "677-0057",
          "677-0006",
          "677-0037",
          "677-0013",
          "677-0063",
          "677-0042",
          "677-0002",
          "677-0066",
          "677-0067",
          "677-0064",
          "677-0052",
          "677-0053",
          "665-0000",
          "665-0014",
          "665-0822",
          "665-0825",
          "665-0823",
          "665-0821",
          "665-0835",
          "665-0851",
          "665-0864",
          "665-0033",
          "665-0007",
          "665-0862",
          "665-0004",
          "669-1211",
          "665-0057",
          "665-0034",
          "665-0017",
          "665-0054",
          "665-0824",
          "669-1202",
          "665-0047",
          "665-0842",
          "665-0848",
          "665-0836",
          "669-1241",
          "666-0161",
          "665-0808",
          "665-0812",
          "665-0813",
          "665-0023",
          "665-0832",
          "669-1201",
          "665-0045",
          "665-0041",
          "665-0841",
          "665-0865",
          "665-0827",
          "665-0053",
          "669-1222",
          "665-0845",
          "665-0035",
          "665-0024",
          "665-0846",
          "669-1205",
          "669-1203",
          "665-0012",
          "665-0052",
          "665-0044",
          "665-0031",
          "665-0847",
          "665-0055",
          "665-0051",
          "665-0043",
          "665-0076",
          "669-1231",
          "665-0072",
          "665-0001",
          "665-0002",
          "665-0833",
          "665-0073",
          "665-0032",
          "665-0021",
          "665-0874",
          "665-0872",
          "665-0875",
          "665-0056",
          "665-0877",
          "665-0871",
          "665-0868",
          "665-0876",
          "665-0861",
          "665-0807",
          "665-0873",
          "669-1204",
          "665-0065",
          "665-0064",
          "665-0068",
          "665-0062",
          "665-0063",
          "665-0066",
          "665-0067",
          "665-0075",
          "665-0061",
          "665-0074",
          "665-0022",
          "669-1221",
          "665-0802",
          "665-0803",
          "665-0801",
          "666-0162",
          "665-0015",
          "665-0805",
          "665-0804",
          "665-0816",
          "665-0817",
          "665-0046",
          "665-0806",
          "665-0016",
          "665-0013",
          "665-0866",
          "665-0831",
          "665-0837",
          "665-0863",
          "665-0834",
          "665-0011",
          "665-0811",
          "665-0843",
          "665-0042",
          "665-0844",
          "665-0005",
          "665-0852",
          "665-0855",
          "665-0856",
          "665-0867",
          "665-0854",
          "665-0853",
          "665-0006",
          "665-0071",
          "665-0887",
          "665-0886",
          "665-0883",
          "665-0814",
          "665-0815",
          "665-0881",
          "665-0884",
          "665-0882",
          "665-0885",
          "665-0826",
          "665-0025",
          "665-0003",
          "673-0400",
          "673-0401",
          "673-0412",
          "673-0432",
          "673-0413",
          "673-0404",
          "673-0402",
          "673-0723",
          "673-0425",
          "673-0755",
          "673-0752",
          "673-0743",
          "673-0757",
          "673-0751",
          "673-0754",
          "673-0741",
          "673-0735",
          "673-0732",
          "673-0731",
          "673-0758",
          "673-0742",
          "673-0753",
          "673-0756",
          "673-0736",
          "673-0734",
          "673-0733",
          "673-0411",
          "673-0436",
          "673-0521",
          "673-0502",
          "673-0512",
          "673-0503",
          "673-0513",
          "673-0504",
          "673-0506",
          "673-0511",
          "673-0514",
          "673-0552",
          "673-0553",
          "673-0551",
          "673-0541",
          "673-0505",
          "673-0516",
          "673-0515",
          "673-0501",
          "673-0414",
          "673-0424",
          "673-0423",
          "673-0403",
          "673-0456",
          "673-0421",
          "673-0405",
          "673-0433",
          "673-0415",
          "673-0416",
          "673-0441",
          "673-0452",
          "673-0442",
          "673-0434",
          "673-0451",
          "673-0453",
          "673-0454",
          "673-0435",
          "673-0443",
          "673-0446",
          "673-0444",
          "673-0445",
          "673-0455",
          "673-0711",
          "673-0721",
          "673-0724",
          "673-0703",
          "673-0713",
          "673-0702",
          "673-0714",
          "673-0704",
          "673-0701",
          "673-0712",
          "673-0722",
          "673-0715",
          "673-0431",
          "673-0532",
          "673-0534",
          "673-0533",
          "673-0531",
          "673-1107",
          "673-1235",
          "673-1231",
          "673-1126",
          "673-1115",
          "673-1116",
          "673-1242",
          "673-1118",
          "673-1119",
          "673-1111",
          "673-1104",
          "673-1114",
          "673-1232",
          "673-1241",
          "673-1106",
          "673-1125",
          "673-1102",
          "673-1243",
          "673-1127",
          "673-1122",
          "673-1101",
          "673-1112",
          "673-1236",
          "673-1233",
          "673-1113",
          "673-1234",
          "673-1108",
          "673-1105",
          "673-1124",
          "673-1103",
          "673-1244",
          "673-1117",
          "673-1128",
          "673-1123",
          "673-1121",
          "673-1129",
          "673-0422",
          "676-0000",
          "676-0815",
          "676-0827",
          "676-0822",
          "676-0823",
          "676-0825",
          "676-0826",
          "676-0828",
          "676-0821",
          "676-0824",
          "676-0016",
          "676-0005",
          "676-0015",
          "676-0011",
          "676-0008",
          "676-0004",
          "676-0012",
          "676-0007",
          "676-0013",
          "676-0017",
          "676-0014",
          "676-0006",
          "676-0018",
          "676-0078",
          "676-0072",
          "676-0071",
          "676-0076",
          "676-0075",
          "676-0081",
          "676-0003",
          "676-0074",
          "676-0814",
          "676-0808",
          "676-0816",
          "671-0121",
          "671-0122",
          "671-0123",
          "676-0813",
          "676-0077",
          "676-0002",
          "676-0082",
          "676-0028",
          "676-0037",
          "676-0021",
          "676-0041",
          "676-0053",
          "676-0045",
          "676-0026",
          "676-0066",
          "676-0068",
          "676-0054",
          "676-0024",
          "676-0062",
          "676-0064",
          "676-0065",
          "676-0038",
          "676-0033",
          "676-0035",
          "676-0063",
          "676-0034",
          "676-0036",
          "676-0049",
          "676-0056",
          "676-0055",
          "676-0046",
          "676-0061",
          "676-0022",
          "676-0067",
          "676-0032",
          "676-0043",
          "676-0023",
          "676-0044",
          "676-0052",
          "676-0042",
          "676-0047",
          "676-0027",
          "676-0031",
          "676-0051",
          "676-0048",
          "676-0073",
          "676-0811",
          "676-0001",
          "676-0812",
          "676-0025",
          "676-0019",
          "676-0804",
          "676-0803",
          "676-0809",
          "676-0802",
          "676-0806",
          "676-0807",
          "676-0805",
          "676-0801",
          "666-0000",
          "666-0148",
          "666-0156",
          "666-0146",
          "666-0007",
          "666-0133",
          "666-0001",
          "666-0014",
          "666-0015",
          "666-0031",
          "666-0025",
          "666-0012",
          "666-0135",
          "666-0024",
          "666-0103",
          "666-0101",
          "666-0107",
          "666-0145",
          "666-0115",
          "666-0033",
          "666-0021",
          "666-0104",
          "666-0022",
          "666-0125",
          "666-0116",
          "666-0158",
          "666-0142",
          "666-0143",
          "666-0111",
          "666-0112",
          "666-0002",
          "666-0126",
          "666-0127",
          "666-0128",
          "666-0124",
          "666-0016",
          "666-0123",
          "666-0011",
          "666-0034",
          "666-0113",
          "666-0155",
          "666-0138",
          "666-0004",
          "666-0005",
          "666-0006",
          "666-0134",
          "666-0035",
          "666-0036",
          "666-0017",
          "666-0117",
          "666-0114",
          "666-0023",
          "666-0122",
          "666-0032",
          "666-0153",
          "666-0121",
          "666-0037",
          "666-0003",
          "666-0152",
          "665-0891",
          "666-0013",
          "666-0157",
          "666-0129",
          "666-0136",
          "666-0026",
          "666-0105",
          "666-0151",
          "666-0141",
          "666-0131",
          "666-0132",
          "666-0144",
          "666-0106",
          "666-0154",
          "666-0137",
          "666-0102",
          "666-0147",
          "675-1300",
          "675-1358",
          "675-1352",
          "675-1342",
          "675-1356",
          "675-1324",
          "675-1326",
          "675-1303",
          "675-1327",
          "675-1378",
          "675-1334",
          "675-1301",
          "675-1325",
          "675-1335",
          "675-1364",
          "675-1379",
          "675-1353",
          "675-1354",
          "675-1343",
          "675-1318",
          "675-1360",
          "675-1345",
          "675-1317",
          "675-1362",
          "675-1337",
          "675-1371",
          "675-1365",
          "675-1312",
          "675-1323",
          "675-1351",
          "675-1367",
          "675-1336",
          "675-1344",
          "675-1359",
          "675-1355",
          "675-1331",
          "675-1307",
          "675-1368",
          "675-1361",
          "675-1302",
          "675-1313",
          "675-1369",
          "675-1322",
          "675-1333",
          "675-1338",
          "675-1316",
          "675-1366",
          "675-1304",
          "675-1332",
          "675-1308",
          "675-1314",
          "675-1375",
          "675-1341",
          "675-1377",
          "675-1373",
          "675-1315",
          "675-1309",
          "675-1346",
          "675-1328",
          "675-1306",
          "675-1363",
          "675-1374",
          "675-1372",
          "675-1376",
          "675-1311",
          "675-1350",
          "675-1357",
          "675-1321",
          "675-1305",
          "669-1300",
          "669-1536",
          "669-1526",
          "669-1358",
          "669-1323",
          "669-1548",
          "669-1414",
          "669-1356",
          "669-1336",
          "669-1502",
          "669-1528",
          "669-1349",
          "669-1354",
          "669-1515",
          "669-1503",
          "669-1504",
          "669-1337",
          "669-1507",
          "669-1346",
          "669-1301",
          "669-1316",
          "669-1338",
          "669-1415",
          "669-1542",
          "669-1351",
          "669-1311",
          "669-1514",
          "669-1403",
          "669-1541",
          "669-1304",
          "669-1521",
          "669-1321",
          "669-1412",
          "669-1401",
          "669-1405",
          "669-1325",
          "669-1335",
          "669-1533",
          "669-1506",
          "669-1345",
          "669-1302",
          "669-1315",
          "669-1333",
          "669-1416",
          "669-1522",
          "669-1413",
          "669-1543",
          "669-1303",
          "669-1402",
          "669-1417",
          "669-1322",
          "669-1352",
          "669-1525",
          "669-1512",
          "669-1406",
          "669-1529",
          "669-1347",
          "669-1348",
          "669-1339",
          "669-1523",
          "669-1531",
          "669-1404",
          "669-1516",
          "669-1334",
          "669-1527",
          "669-1355",
          "669-1517",
          "669-1341",
          "669-1314",
          "669-1537",
          "669-1505",
          "669-1545",
          "669-1411",
          "669-1524",
          "669-1312",
          "669-1357",
          "669-1353",
          "669-1332",
          "669-1331",
          "669-1407",
          "669-1313",
          "669-1547",
          "669-1343",
          "669-1344",
          "669-1535",
          "669-1317",
          "669-1513",
          "669-1544",
          "669-1501",
          "669-1532",
          "669-1511",
          "669-1546",
          "669-1324",
          "669-1534",
          "669-1342",
          "675-2413",
          "679-0102",
          "679-0105",
          "675-2113",
          "675-2425",
          "675-2423",
          "675-2337",
          "675-2434",
          "675-2203",
          "675-2103",
          "675-2441",
          "675-2231",
          "675-2455",
          "675-2234",
          "675-2242",
          "675-2344",
          "675-2412",
          "675-2465",
          "675-2451",
          "675-2453",
          "675-2104",
          "675-2444",
          "675-2333",
          "675-2433",
          "675-2401",
          "675-2364",
          "675-2221",
          "675-2111",
          "675-2403",
          "675-2421",
          "675-2112",
          "675-2222",
          "675-2336",
          "675-2443",
          "675-2461",
          "675-2431",
          "675-2464",
          "675-2452",
          "675-2454",
          "675-2105",
          "675-2204",
          "675-2363",
          "675-2411",
          "675-2352",
          "675-2361",
          "675-2114",
          "679-0109",
          "679-0107",
          "675-2402",
          "675-2241",
          "679-0101",
          "679-0104",
          "675-2332",
          "675-2232",
          "675-2445",
          "679-0106",
          "675-2442",
          "675-2243",
          "675-2102",
          "675-2343",
          "675-2362",
          "675-2342",
          "675-2213",
          "675-2345",
          "675-2366",
          "675-2426",
          "675-2335",
          "675-2202",
          "675-2424",
          "675-2211",
          "675-2365",
          "675-2101",
          "675-2341",
          "675-2212",
          "675-2346",
          "675-2331",
          "675-2463",
          "675-2201",
          "675-2351",
          "675-2334",
          "675-2462",
          "679-0103",
          "675-2302",
          "675-2313",
          "675-2301",
          "675-2321",
          "675-2322",
          "675-2324",
          "675-2323",
          "675-2303",
          "675-2312",
          "675-2311",
          "675-2432",
          "675-2223",
          "675-2414",
          "679-0108",
          "675-2354",
          "675-2422",
          "675-2404",
          "675-2353",
          "675-2456",
          "675-2233",
          "669-2300",
          "669-2205",
          "669-2402",
          "669-2822",
          "669-2223",
          "669-2224",
          "669-2214",
          "669-2222",
          "669-2114",
          "669-2804",
          "669-2354",
          "669-2541",
          "669-2436",
          "669-2811",
          "669-2406",
          "669-2813",
          "669-2613",
          "669-2718",
          "669-2335",
          "669-2105",
          "669-2416",
          "669-2304",
          "669-2357",
          "669-2454",
          "669-2336",
          "669-2106",
          "669-2715",
          "669-2455",
          "669-2801",
          "669-2306",
          "669-2318",
          "669-2212",
          "669-2211",
          "669-2363",
          "669-2355",
          "669-2611",
          "669-2309",
          "669-2803",
          "669-2823",
          "669-2827",
          "669-2802",
          "669-2326",
          "669-2401",
          "669-2302",
          "669-2501",
          "669-2616",
          "669-2614",
          "669-2731",
          "669-2435",
          "669-2532",
          "669-2704",
          "669-2522",
          "669-2523",
          "669-2604",
          "669-2554",
          "669-2714",
          "669-2408",
          "669-2732",
          "669-2534",
          "669-2415",
          "669-2722",
          "669-2724",
          "669-2725",
          "669-2701",
          "669-2735",
          "669-2512",
          "669-2325",
          "669-2451",
          "669-2317",
          "669-2417",
          "669-2332",
          "669-2824",
          "669-2825",
          "669-2438",
          "669-2113",
          "669-2544",
          "669-2723",
          "669-2367",
          "669-2407",
          "669-2713",
          "669-2711",
          "669-2465",
          "669-2321",
          "669-2726",
          "669-2703",
          "669-2341",
          "669-2112",
          "669-2545",
          "669-2412",
          "669-2124",
          "669-2322",
          "669-2461",
          "669-2144",
          "669-2155",
          "669-2154",
          "669-2152",
          "669-2143",
          "669-2132",
          "669-2135",
          "669-2162",
          "669-2145",
          "669-2151",
          "669-2153",
          "669-2156",
          "669-2161",
          "669-2133",
          "669-2141",
          "669-2131",
          "669-2142",
          "669-2163",
          "669-2134",
          "669-2542",
          "669-2712",
          "669-2365",
          "669-2405",
          "669-2425",
          "669-2422",
          "669-2424",
          "669-2421",
          "669-2423",
          "669-2439",
          "669-2733",
          "669-2535",
          "669-2503",
          "669-2543",
          "669-2311",
          "669-2204",
          "669-2312",
          "669-2315",
          "669-2125",
          "669-2231",
          "669-2303",
          "669-2444",
          "669-2442",
          "669-2443",
          "669-2805",
          "669-2812",
          "669-2717",
          "669-2727",
          "669-2612",
          "669-2323",
          "669-2453",
          "669-2531",
          "669-2362",
          "669-2814",
          "669-2815",
          "669-2411",
          "669-2366",
          "669-2821",
          "669-2111",
          "669-2826",
          "669-2525",
          "669-2434",
          "669-2601",
          "669-2213",
          "669-2502",
          "669-2331",
          "669-2346",
          "669-2736",
          "669-2221",
          "669-2728",
          "669-2447",
          "669-2334",
          "669-2721",
          "669-2504",
          "669-2352",
          "669-2206",
          "669-2404",
          "669-2342",
          "669-2433",
          "669-2521",
          "669-2353",
          "669-2452",
          "669-2445",
          "669-2313",
          "669-2716",
          "669-2103",
          "669-2122",
          "669-2524",
          "669-2418",
          "669-2413",
          "669-2505",
          "669-2553",
          "669-2305",
          "669-2101",
          "669-2307",
          "669-2301",
          "669-2441",
          "669-2345",
          "669-2737",
          "669-2201",
          "669-2314",
          "669-2324",
          "669-2351",
          "669-2202",
          "669-2403",
          "669-2343",
          "669-2344",
          "669-2203",
          "669-2603",
          "669-2513",
          "669-2369",
          "669-2368",
          "669-2605",
          "669-2552",
          "669-2123",
          "669-2702",
          "669-2511",
          "669-2316",
          "669-2527",
          "669-2462",
          "669-2464",
          "669-2463",
          "669-2361",
          "669-2121",
          "669-2602",
          "669-2333",
          "669-2102",
          "669-2615",
          "669-2734",
          "669-2414",
          "669-2526",
          "669-2437",
          "669-2432",
          "669-2446",
          "669-2431",
          "669-2356",
          "669-2104",
          "669-2551",
          "669-2337",
          "669-2533",
          "669-2364",
          "669-2308",
          "667-0000",
          "667-0115",
          "667-0103",
          "667-0104",
          "667-0132",
          "667-0131",
          "667-1119",
          "667-1127",
          "667-1102",
          "667-0125",
          "667-0134",
          "667-0436",
          "667-0322",
          "667-0431",
          "667-0301",
          "667-0303",
          "667-0314",
          "667-0311",
          "667-0313",
          "667-0433",
          "667-0315",
          "667-0321",
          "667-0325",
          "667-0434",
          "667-0302",
          "667-0304",
          "667-0305",
          "667-0306",
          "667-0432",
          "667-0312",
          "667-0324",
          "667-0323",
          "667-0435",
          "667-0111",
          "667-0121",
          "667-1104",
          "667-1114",
          "667-1115",
          "667-0123",
          "667-1113",
          "667-1122",
          "667-0124",
          "667-0114",
          "667-0105",
          "667-0102",
          "667-0107",
          "667-1105",
          "667-0142",
          "667-0106",
          "667-1124",
          "667-1112",
          "667-1117",
          "667-1121",
          "667-1116",
          "667-0145",
          "667-0122",
          "667-1123",
          "667-1125",
          "667-0143",
          "667-0133",
          "667-0101",
          "667-1126",
          "667-0135",
          "667-1128",
          "667-0126",
          "667-1103",
          "667-0136",
          "667-1101",
          "667-0144",
          "667-0141",
          "667-1118",
          "667-0112",
          "667-0113",
          "667-0001",
          "667-0024",
          "667-0011",
          "667-0012",
          "667-0051",
          "667-0014",
          "667-0015",
          "667-0053",
          "667-0004",
          "667-0023",
          "667-0044",
          "667-0031",
          "667-0032",
          "667-0042",
          "667-0013",
          "667-0005",
          "667-0022",
          "667-0003",
          "667-0043",
          "667-0052",
          "667-0016",
          "667-0002",
          "667-0045",
          "667-0041",
          "667-0021",
          "667-1111",
          "669-3300",
          "669-3831",
          "669-3827",
          "669-3843",
          "669-3812",
          "669-3822",
          "669-3823",
          "669-3841",
          "669-3802",
          "669-3824",
          "669-3811",
          "669-3842",
          "669-3825",
          "669-3804",
          "669-3832",
          "669-3834",
          "669-3803",
          "669-3801",
          "669-3821",
          "669-3826",
          "669-3833",
          "669-4324",
          "669-4316",
          "669-4321",
          "669-4317",
          "669-4336",
          "669-4323",
          "669-4344",
          "669-4322",
          "669-4341",
          "669-4315",
          "669-4325",
          "669-4312",
          "669-4337",
          "669-4343",
          "669-4301",
          "669-4313",
          "669-4332",
          "669-4345",
          "669-4333",
          "669-4311",
          "669-4302",
          "669-4331",
          "669-4334",
          "669-4314",
          "669-4342",
          "669-4335",
          "669-3314",
          "669-3307",
          "669-3315",
          "669-3309",
          "669-3304",
          "669-3316",
          "669-3306",
          "669-3313",
          "669-3308",
          "669-3305",
          "669-3312",
          "669-3302",
          "669-3311",
          "669-3303",
          "669-3301",
          "669-3411",
          "669-4121",
          "669-3413",
          "669-4135",
          "669-3404",
          "669-3414",
          "669-4251",
          "669-4262",
          "669-4253",
          "669-4141",
          "669-4273",
          "669-4122",
          "669-3415",
          "669-4252",
          "669-3402",
          "669-3412",
          "669-4125",
          "669-4274",
          "669-4123",
          "669-3403",
          "669-4265",
          "669-4131",
          "669-4124",
          "669-4261",
          "669-4132",
          "669-3416",
          "669-4272",
          "669-4133",
          "669-4263",
          "669-4134",
          "669-4264",
          "669-3401",
          "669-4271",
          "669-3112",
          "669-3111",
          "669-3125",
          "669-3143",
          "669-3141",
          "669-3158",
          "669-3123",
          "669-3113",
          "669-3124",
          "669-3127",
          "669-3144",
          "669-3121",
          "669-3166",
          "669-3167",
          "669-3154",
          "669-3156",
          "669-3128",
          "669-3101",
          "669-3105",
          "669-3152",
          "669-3148",
          "669-3151",
          "669-3161",
          "669-3155",
          "669-3162",
          "669-3103",
          "669-3147",
          "669-3102",
          "669-3131",
          "669-3122",
          "669-3165",
          "669-3126",
          "669-3168",
          "669-3145",
          "669-3104",
          "669-3153",
          "669-3146",
          "669-3159",
          "669-3142",
          "669-3132",
          "669-3163",
          "669-3164",
          "669-3157",
          "669-3606",
          "669-3574",
          "669-3643",
          "669-3464",
          "669-3461",
          "669-3632",
          "669-3466",
          "669-3581",
          "669-3604",
          "669-3462",
          "669-3621",
          "669-3612",
          "669-3575",
          "669-3611",
          "669-3613",
          "669-3631",
          "669-3645",
          "669-3463",
          "669-3653",
          "669-3641",
          "669-3626",
          "669-3605",
          "669-3642",
          "669-3646",
          "669-3633",
          "669-3652",
          "669-3582",
          "669-3614",
          "669-3602",
          "669-3571",
          "669-3572",
          "669-3625",
          "669-3623",
          "669-3601",
          "669-3603",
          "669-3634",
          "669-3651",
          "669-3644",
          "669-3583",
          "669-3467",
          "669-3624",
          "669-3654",
          "669-3622",
          "669-3573",
          "669-3465",
          "656-0400",
          "656-0661",
          "656-0662",
          "656-0663",
          "656-0541",
          "656-0543",
          "656-0544",
          "656-0545",
          "656-0546",
          "656-0542",
          "656-0651",
          "656-0462",
          "656-0474",
          "656-0461",
          "656-0473",
          "656-0475",
          "656-0471",
          "656-0476",
          "656-0472",
          "656-0477",
          "656-0478",
          "656-0426",
          "656-0422",
          "656-0428",
          "656-0425",
          "656-0423",
          "656-0424",
          "656-0427",
          "656-0421",
          "656-0328",
          "656-0518",
          "656-0517",
          "656-0515",
          "656-0512",
          "656-0513",
          "656-0516",
          "656-0511",
          "656-0514",
          "656-0531",
          "656-0532",
          "656-0533",
          "656-0534",
          "656-0521",
          "656-0321",
          "656-0325",
          "656-0327",
          "656-0324",
          "656-0484",
          "656-0322",
          "656-0483",
          "656-0482",
          "656-0323",
          "656-0481",
          "656-0326",
          "656-0151",
          "656-0412",
          "656-0411",
          "656-0153",
          "656-0154",
          "656-0161",
          "656-0152",
          "656-0413",
          "656-0452",
          "656-0454",
          "656-0453",
          "656-0455",
          "656-0456",
          "656-0451",
          "656-0457",
          "656-0143",
          "656-0142",
          "656-0141",
          "656-0341",
          "656-0551",
          "656-0961",
          "656-0131",
          "656-0122",
          "656-0502",
          "656-0501",
          "656-0503",
          "656-0307",
          "656-0303",
          "656-0311",
          "656-0301",
          "656-0305",
          "656-0306",
          "656-0304",
          "656-0302",
          "656-0313",
          "656-0315",
          "656-0314",
          "656-0308",
          "656-0312",
          "656-0332",
          "656-0331",
          "656-0441",
          "656-0445",
          "656-0444",
          "656-0434",
          "656-0446",
          "656-0436",
          "656-0435",
          "656-0432",
          "656-0433",
          "656-0431",
          "656-0443",
          "656-0442",
          "656-0121",
          "669-5200",
          "679-3325",
          "679-3322",
          "679-3332",
          "679-3301",
          "679-3341",
          "679-3324",
          "679-3326",
          "679-3321",
          "679-3323",
          "679-3331",
          "679-3311",
          "679-3302",
          "679-3422",
          "679-3421",
          "679-3433",
          "679-3451",
          "679-3414",
          "679-3402",
          "679-3453",
          "679-3411",
          "669-5125",
          "669-5123",
          "669-5112",
          "669-5102",
          "669-5153",
          "669-5142",
          "669-5143",
          "669-5152",
          "669-5115",
          "669-5133",
          "669-5151",
          "669-5113",
          "669-5124",
          "669-5111",
          "669-5101",
          "669-5114",
          "669-5134",
          "669-5131",
          "669-5104",
          "669-5132",
          "669-5141",
          "669-5135",
          "669-5103",
          "669-5136",
          "669-5121",
          "669-5122",
          "679-3423",
          "679-3403",
          "679-3424",
          "679-3442",
          "679-3431",
          "679-3413",
          "679-3441",
          "679-3401",
          "679-3452",
          "679-3412",
          "679-3432",
          "669-5221",
          "669-5238",
          "669-5234",
          "669-5262",
          "669-5236",
          "669-5204",
          "669-5246",
          "669-5224",
          "669-5264",
          "669-5253",
          "669-5228",
          "669-5263",
          "669-5214",
          "669-5251",
          "669-5256",
          "669-5258",
          "669-5220",
          "669-5243",
          "669-5252",
          "669-5237",
          "669-5233",
          "669-5268",
          "669-5213",
          "669-5265",
          "669-5232",
          "669-5203",
          "669-5255",
          "669-5226",
          "669-5225",
          "669-5231",
          "669-5241",
          "669-5202",
          "669-5227",
          "669-5266",
          "669-5261",
          "669-5215",
          "669-5211",
          "669-5257",
          "669-5245",
          "669-5267",
          "669-5222",
          "669-5229",
          "669-5244",
          "669-5242",
          "669-5223",
          "669-5254",
          "669-5212",
          "669-5216",
          "669-5235",
          "669-5201",
          "656-2100",
          "656-1742",
          "656-1741",
          "656-1603",
          "656-1605",
          "656-1604",
          "656-1602",
          "656-2223",
          "656-2225",
          "656-2161",
          "656-1712",
          "656-1525",
          "656-1552",
          "656-2401",
          "656-2305",
          "656-1531",
          "656-2162",
          "656-2302",
          "656-2224",
          "656-2155",
          "656-2156",
          "656-2151",
          "656-1736",
          "656-1501",
          "656-1732",
          "656-2334",
          "656-1523",
          "656-2331",
          "656-2152",
          "656-2153",
          "656-2154",
          "656-1512",
          "656-1556",
          "656-1558",
          "656-2301",
          "656-2144",
          "656-1735",
          "656-2311",
          "656-1601",
          "656-1511",
          "656-2303",
          "656-2323",
          "656-2211",
          "656-2143",
          "656-2212",
          "656-2213",
          "656-2141",
          "656-2142",
          "656-2131",
          "656-2132",
          "656-1522",
          "656-2333",
          "656-2322",
          "656-1502",
          "656-1521",
          "656-1551",
          "656-1524",
          "656-2332",
          "656-2214",
          "656-1503",
          "656-1711",
          "656-1743",
          "656-2221",
          "656-2163",
          "656-1733",
          "656-1526",
          "656-2321",
          "656-1731",
          "656-1723",
          "656-1727",
          "656-1726",
          "656-1722",
          "656-1721",
          "656-1724",
          "656-2451",
          "656-1725",
          "656-2222",
          "656-2304",
          "656-1554",
          "656-1734",
          "656-1555",
          "656-2307",
          "656-1557",
          "656-1606",
          "656-1541",
          "656-1553",
          "656-2306",
          "671-2500",
          "671-4135",
          "671-4131",
          "671-4104",
          "671-4123",
          "671-4134",
          "671-4137",
          "671-4106",
          "671-4105",
          "671-4143",
          "671-4115",
          "671-4107",
          "671-4111",
          "671-4101",
          "671-4103",
          "671-4136",
          "671-4144",
          "671-4139",
          "671-4133",
          "671-4108",
          "671-4138",
          "671-4125",
          "671-4132",
          "671-4141",
          "671-4124",
          "671-4122",
          "671-4121",
          "671-4114",
          "671-4113",
          "671-4112",
          "671-4142",
          "671-4102",
          "671-3211",
          "671-3222",
          "671-3202",
          "671-3225",
          "671-3232",
          "671-3231",
          "671-3212",
          "671-3201",
          "671-3233",
          "671-3221",
          "671-3224",
          "671-3223",
          "671-4231",
          "671-4215",
          "671-4242",
          "671-4221",
          "671-4243",
          "671-4211",
          "671-4232",
          "671-4203",
          "671-4244",
          "671-4202",
          "671-4201",
          "671-4214",
          "671-4213",
          "671-4204",
          "671-4212",
          "671-4245",
          "671-4216",
          "671-4241",
          "671-2564",
          "671-2515",
          "671-2517",
          "671-2566",
          "671-2573",
          "671-2571",
          "671-2506",
          "671-2535",
          "671-2562",
          "671-2503",
          "671-2513",
          "671-2570",
          "671-2568",
          "671-2505",
          "671-2555",
          "671-2501",
          "671-2558",
          "671-2508",
          "671-2534",
          "671-2527",
          "671-2567",
          "671-2521",
          "671-2565",
          "671-2532",
          "671-2525",
          "671-2561",
          "671-2554",
          "671-2563",
          "671-2560",
          "671-2576",
          "671-2536",
          "671-2556",
          "671-2541",
          "671-2507",
          "671-2519",
          "671-2572",
          "671-2533",
          "671-2522",
          "671-2511",
          "671-2544",
          "671-2514",
          "671-2552",
          "671-2553",
          "671-2531",
          "671-2545",
          "671-2502",
          "671-2557",
          "671-2574",
          "671-2543",
          "671-2528",
          "671-2551",
          "671-2504",
          "671-2569",
          "671-2542",
          "671-2524",
          "671-2516",
          "671-2523",
          "671-2578",
          "671-2579",
          "671-2526",
          "671-2577",
          "671-2575",
          "671-2512",
          "671-2518",
          "673-1400",
          "673-1302",
          "673-1338",
          "673-1451",
          "673-1413",
          "673-1442",
          "679-0203",
          "673-1321",
          "673-1446",
          "673-1404",
          "673-1313",
          "679-0202",
          "673-1325",
          "673-1323",
          "673-1333",
          "673-1453",
          "673-1463",
          "673-1401",
          "673-1414",
          "679-0211",
          "673-1464",
          "673-1472",
          "673-1465",
          "679-0205",
          "673-1461",
          "673-1456",
          "673-1416",
          "673-1301",
          "679-0221",
          "679-0213",
          "673-1332",
          "679-0223",
          "673-1447",
          "673-1444",
          "673-1403",
          "673-1415",
          "679-0212",
          "673-1473",
          "673-1303",
          "673-1324",
          "679-0204",
          "679-0201",
          "673-1445",
          "679-0222",
          "679-0207",
          "673-1441",
          "673-1311",
          "673-1434",
          "673-1452",
          "673-1424",
          "673-1304",
          "673-1425",
          "673-1455",
          "673-1454",
          "673-1312",
          "673-1411",
          "673-1423",
          "673-1336",
          "673-1402",
          "673-1432",
          "673-1443",
          "673-1462",
          "679-0206",
          "673-1474",
          "673-1433",
          "673-1337",
          "673-1412",
          "673-1341",
          "673-1322",
          "673-1331",
          "673-1431",
          "673-1422",
          "673-1335",
          "673-1471",
          "673-1421",
          "673-1314",
          "673-1334",
          "673-1475",
          "679-4100",
          "679-4008",
          "679-4003",
          "679-4024",
          "679-4025",
          "679-4007",
          "679-4022",
          "679-4013",
          "679-4021",
          "679-4011",
          "679-4005",
          "679-4004",
          "679-4001",
          "679-4023",
          "679-4006",
          "679-4026",
          "679-4014",
          "679-4027",
          "679-4002",
          "679-4017",
          "679-4012",
          "679-4016",
          "679-4015",
          "671-1662",
          "671-1665",
          "671-1663",
          "671-1651",
          "671-1643",
          "671-1632",
          "671-1664",
          "671-1621",
          "671-1611",
          "671-1642",
          "671-1602",
          "671-1641",
          "671-1601",
          "671-1661",
          "671-1613",
          "671-1612",
          "671-1603",
          "671-1631",
          "679-4156",
          "679-4155",
          "679-4146",
          "679-4141",
          "679-4143",
          "679-4152",
          "679-4154",
          "679-4145",
          "679-4144",
          "679-4142",
          "679-4153",
          "679-4151",
          "679-4115",
          "679-4112",
          "679-4101",
          "679-4103",
          "679-4102",
          "679-4116",
          "679-4108",
          "679-4113",
          "679-4104",
          "679-4105",
          "679-4107",
          "679-4111",
          "679-4109",
          "679-4106",
          "679-4114",
          "679-4331",
          "679-4315",
          "679-4332",
          "679-4343",
          "679-5151",
          "679-5154",
          "679-5162",
          "679-4303",
          "679-4323",
          "679-5155",
          "679-5165",
          "679-4302",
          "679-4316",
          "679-4325",
          "679-4301",
          "679-5161",
          "679-4304",
          "679-4312",
          "679-4333",
          "679-4313",
          "679-4344",
          "679-4322",
          "679-4346",
          "679-4314",
          "679-4321",
          "679-5163",
          "679-5153",
          "679-4327",
          "679-4341",
          "679-4324",
          "679-4342",
          "679-4345",
          "679-5164",
          "679-4326",
          "679-5152",
          "679-4311",
          "679-4305",
          "679-4175",
          "679-4178",
          "679-4128",
          "679-4123",
          "679-4179",
          "679-4172",
          "679-4166",
          "679-4171",
          "679-4121",
          "679-4162",
          "679-4177",
          "679-4176",
          "679-4125",
          "679-4169",
          "679-4164",
          "679-4129",
          "679-4167",
          "679-4124",
          "679-4170",
          "679-4126",
          "679-4122",
          "679-4161",
          "679-4163",
          "679-4165",
          "679-4127",
          "679-4173",
          "679-4174",
          "679-4168",
          "679-4136",
          "679-4131",
          "679-4137",
          "679-4139",
          "679-4138",
          "679-4135",
          "679-4130",
          "679-4134",
          "679-4132",
          "679-4133",
          "671-1342",
          "671-1312",
          "671-1331",
          "671-1341",
          "671-1321",
          "671-1301",
          "671-1311",
          "671-1332",
          "666-0200",
          "666-0212",
          "666-0246",
          "666-0255",
          "666-0244",
          "666-0241",
          "666-0243",
          "666-0204",
          "666-0202",
          "666-0231",
          "666-0236",
          "666-0234",
          "666-0225",
          "666-0254",
          "666-0256",
          "666-0223",
          "666-0227",
          "666-0253",
          "666-0215",
          "666-0214",
          "666-0213",
          "666-0237",
          "666-0257",
          "666-0201",
          "666-0238",
          "666-0232",
          "666-0222",
          "666-0245",
          "666-0221",
          "666-0203",
          "666-0211",
          "666-0226",
          "666-0242",
          "666-0252",
          "666-0262",
          "666-0261",
          "666-0224",
          "666-0235",
          "666-0233",
          "666-0251",
          "679-1100",
          "679-1205",
          "679-1327",
          "679-1332",
          "679-1215",
          "679-1337",
          "679-1335",
          "679-1338",
          "679-1323",
          "679-1202",
          "679-1336",
          "679-1203",
          "679-1204",
          "679-1331",
          "679-1211",
          "679-1324",
          "679-1201",
          "679-1322",
          "679-1326",
          "679-1212",
          "679-1334",
          "679-1214",
          "679-1333",
          "679-1325",
          "679-1213",
          "679-1321",
          "679-1135",
          "679-1115",
          "679-1102",
          "679-1107",
          "679-1111",
          "679-1114",
          "679-1133",
          "679-1132",
          "679-1134",
          "679-1131",
          "679-1106",
          "679-1104",
          "679-1113",
          "679-1122",
          "679-1123",
          "679-1121",
          "679-1105",
          "679-1103",
          "679-1112",
          "679-1124",
          "679-1101",
          "677-0112",
          "677-0101",
          "677-0111",
          "677-0102",
          "677-0114",
          "677-0122",
          "677-0131",
          "677-0105",
          "677-0113",
          "677-0121",
          "677-0103",
          "677-0132",
          "677-0104",
          "675-1100",
          "675-1111",
          "675-1113",
          "675-1105",
          "675-1121",
          "675-1102",
          "675-1115",
          "675-1123",
          "675-1114",
          "675-1126",
          "675-1101",
          "675-1116",
          "675-1127",
          "675-1122",
          "675-1103",
          "675-1104",
          "675-1124",
          "675-1112",
          "675-1125",
          "675-0100",
          "675-0142",
          "675-0157",
          "675-0158",
          "675-0148",
          "675-0144",
          "675-0163",
          "675-0155",
          "675-0160",
          "675-0151",
          "675-0141",
          "675-0164",
          "675-0159",
          "675-0156",
          "675-0162",
          "675-0146",
          "675-0154",
          "675-0147",
          "675-0150",
          "675-0143",
          "675-0145",
          "679-2300",
          "679-2317",
          "679-2323",
          "679-2311",
          "679-2325",
          "679-2318",
          "679-2301",
          "679-2303",
          "679-2333",
          "679-2314",
          "679-2322",
          "679-2331",
          "679-2324",
          "679-2336",
          "679-2302",
          "679-2304",
          "679-2332",
          "679-2326",
          "679-2327",
          "679-2321",
          "679-2334",
          "679-2315",
          "679-2313",
          "679-2316",
          "679-2312",
          "679-2335",
          "679-2337",
          "679-2200",
          "679-2213",
          "679-2201",
          "679-2215",
          "679-2217",
          "679-2216",
          "679-2218",
          "679-2204",
          "679-2205",
          "679-2214",
          "679-2212",
          "679-2203",
          "679-2202",
          "679-2211",
          "679-3100",
          "679-3121",
          "679-2414",
          "679-2431",
          "679-2405",
          "679-3111",
          "679-2403",
          "679-2432",
          "679-2404",
          "679-2422",
          "679-3112",
          "679-2424",
          "679-2421",
          "679-3125",
          "679-3104",
          "679-3102",
          "679-2402",
          "679-2401",
          "679-2433",
          "679-3122",
          "679-2423",
          "679-3116",
          "679-2413",
          "679-3114",
          "679-3113",
          "679-3103",
          "679-3115",
          "679-2425",
          "679-2415",
          "679-3101",
          "679-3124",
          "679-3123",
          "679-2411",
          "679-2412",
          "679-2434",
          "671-1500",
          "671-1557",
          "671-1561",
          "671-1532",
          "671-1545",
          "671-1553",
          "671-1572",
          "671-1511",
          "671-1543",
          "671-1573",
          "671-1504",
          "671-1575",
          "671-1552",
          "671-1556",
          "671-1533",
          "671-1531",
          "671-1541",
          "671-1503",
          "671-1521",
          "671-1523",
          "671-1524",
          "671-1551",
          "671-1502",
          "671-1571",
          "671-1534",
          "671-1554",
          "671-1576",
          "671-1574",
          "671-1555",
          "671-1522",
          "671-1501",
          "671-1544",
          "671-1542",
          "671-1535",
          "678-1200",
          "678-1273",
          "678-1261",
          "678-1251",
          "678-1262",
          "678-1218",
          "678-1213",
          "678-1234",
          "678-1275",
          "678-1276",
          "678-1204",
          "678-1219",
          "678-1203",
          "678-1211",
          "678-1243",
          "678-1274",
          "678-1201",
          "678-1223",
          "678-1231",
          "678-1214",
          "678-1271",
          "678-1242",
          "678-1205",
          "678-1278",
          "678-1277",
          "678-1212",
          "678-1221",
          "678-1217",
          "678-1215",
          "678-1233",
          "678-1226",
          "678-1254",
          "678-1232",
          "678-1216",
          "678-1244",
          "678-1222",
          "678-1202",
          "678-1252",
          "678-1253",
          "678-1272",
          "678-1256",
          "678-1241",
          "678-1255",
          "678-1225",
          "678-1224",
          "679-5300",
          "679-5333",
          "679-5531",
          "679-5221",
          "679-5642",
          "679-5307",
          "679-5504",
          "679-5314",
          "679-5146",
          "679-5654",
          "679-5145",
          "679-5319",
          "679-5646",
          "679-5345",
          "679-5344",
          "679-5324",
          "679-5505",
          "679-5513",
          "679-5644",
          "679-5322",
          "679-5131",
          "679-5225",
          "679-5641",
          "679-5651",
          "679-5346",
          "679-5343",
          "679-5334",
          "679-5652",
          "679-5653",
          "679-5226",
          "679-5523",
          "679-5148",
          "679-5535",
          "679-5204",
          "679-5502",
          "679-5501",
          "679-5303",
          "679-5137",
          "679-5301",
          "679-5136",
          "679-5643",
          "679-5321",
          "679-5211",
          "679-5132",
          "679-5223",
          "679-5317",
          "679-5147",
          "679-5532",
          "679-5201",
          "679-5142",
          "679-5206",
          "679-5316",
          "679-5202",
          "679-5224",
          "679-5305",
          "679-5522",
          "679-5312",
          "679-5534",
          "679-5313",
          "679-5222",
          "679-5645",
          "679-5214",
          "679-5134",
          "679-5332",
          "679-5212",
          "679-5521",
          "679-5135",
          "679-5213",
          "679-5318",
          "679-5331",
          "679-5215",
          "679-5141",
          "679-5311",
          "679-5511",
          "679-5514",
          "679-5227",
          "679-5207",
          "679-5306",
          "679-5503",
          "679-5335",
          "679-5133",
          "679-5325",
          "679-5144",
          "679-5512",
          "679-5143",
          "679-5342",
          "679-5525",
          "679-5205",
          "679-5304",
          "679-5302",
          "679-5341",
          "679-5315",
          "679-5203",
          "679-5524",
          "679-5533",
          "679-5323",
          "669-6500",
          "667-1533",
          "667-1512",
          "667-1503",
          "667-1542",
          "667-1531",
          "667-1511",
          "667-1514",
          "667-1501",
          "667-1522",
          "667-1541",
          "667-1502",
          "667-1543",
          "667-1532",
          "667-1544",
          "667-1521",
          "667-1545",
          "667-1523",
          "667-1513",
          "667-1515",
          "669-6404",
          "669-6432",
          "669-6671",
          "669-6431",
          "669-6425",
          "669-6554",
          "669-6555",
          "669-6433",
          "669-6552",
          "669-6544",
          "669-6414",
          "669-6411",
          "669-6402",
          "669-6559",
          "669-6541",
          "669-6413",
          "669-6564",
          "669-6551",
          "669-6556",
          "669-6546",
          "669-6416",
          "669-6415",
          "669-6423",
          "669-6422",
          "669-6424",
          "669-6542",
          "669-6557",
          "669-6561",
          "669-6426",
          "669-6553",
          "669-6401",
          "669-6412",
          "669-6421",
          "669-6545",
          "669-6403",
          "669-6563",
          "669-6558",
          "669-6562",
          "669-6672",
          "669-6543",
          "667-1312",
          "667-1346",
          "667-1315",
          "667-1324",
          "667-1368",
          "667-1344",
          "667-1321",
          "667-1333",
          "667-1323",
          "667-1366",
          "667-1313",
          "667-1342",
          "667-1353",
          "667-1335",
          "667-1354",
          "667-1326",
          "667-1303",
          "667-1301",
          "667-1316",
          "667-1325",
          "667-1345",
          "667-1365",
          "667-1331",
          "667-1322",
          "667-1352",
          "667-1343",
          "667-1364",
          "667-1361",
          "667-1314",
          "667-1362",
          "667-1337",
          "667-1334",
          "667-1351",
          "667-1363",
          "667-1311",
          "667-1341",
          "667-1332",
          "667-1336",
          "667-1302",
          "667-1317",
          "667-1304",
          "667-1367",
          "667-1347",
          "669-6700",
          "669-6714",
          "669-6701",
          "669-6832",
          "669-6751",
          "669-6953",
          "669-6805",
          "669-6801",
          "669-6803",
          "669-6808",
          "669-6945",
          "669-6952",
          "669-6811",
          "669-6946",
          "669-6802",
          "669-6942",
          "669-6752",
          "669-6954",
          "669-6711",
          "669-6815",
          "669-6812",
          "669-6721",
          "669-6727",
          "669-6804",
          "669-6726",
          "669-6712",
          "669-6833",
          "669-6741",
          "669-6723",
          "669-6742",
          "669-6713",
          "669-6728",
          "669-6722",
          "669-6761",
          "669-6831",
          "669-6813",
          "669-6943",
          "669-6941",
          "669-6745",
          "669-6814",
          "669-6702",
          "669-6807",
          "669-6806",
          "669-6732",
          "669-6725",
          "669-6731",
          "669-6743",
          "669-6746",
          "669-6724",
          "669-6822",
          "669-6951",
          "669-6715",
          "669-6747",
          "669-6944",
          "669-6753",
          "669-6821",
          "669-6744",
          "669-6716",
          "630-0000",
          "631-0053",
          "631-0841",
          "630-8101",
          "630-8035",
          "631-0812",
          "631-0814",
          "631-0813",
          "631-0811",
          "631-0014",
          "630-8346",
          "630-8246",
          "630-8247",
          "630-8024",
          "630-8023",
          "630-8022",
          "630-8025",
          "630-8021",
          "631-0033",
          "631-0032",
          "632-0245",
          "630-8445",
          "630-8361",
          "631-0054",
          "630-8317",
          "630-8444",
          "630-8207",
          "630-8205",
          "630-8243",
          "630-8374",
          "630-8338",
          "631-0805",
          "631-0802",
          "632-0103",
          "630-1233",
          "630-2161",
          "631-0005",
          "630-1236",
          "630-8115",
          "630-8131",
          "630-8132",
          "630-1242",
          "631-0042",
          "631-0055",
          "630-8233",
          "630-1232",
          "630-8235",
          "630-8256",
          "632-0111",
          "630-8273",
          "631-0011",
          "630-8294",
          "630-1243",
          "630-8142",
          "630-8391",
          "630-8031",
          "630-8212",
          "630-8143",
          "630-8228",
          "632-0102",
          "630-8454",
          "630-8202",
          "630-8293",
          "630-8313",
          "630-8314",
          "630-8326",
          "630-8242",
          "631-0027",
          "631-0016",
          "631-0015",
          "631-0025",
          "631-0041",
          "631-0035",
          "631-0026",
          "631-0034",
          "631-0036",
          "630-8332",
          "630-8221",
          "630-8261",
          "630-8285",
          "630-8263",
          "630-8297",
          "630-8322",
          "630-8252",
          "630-8011",
          "630-8405",
          "631-0001",
          "630-8442",
          "630-8451",
          "630-8452",
          "630-1234",
          "630-8275",
          "630-8274",
          "630-8276",
          "630-8262",
          "630-8352",
          "630-8204",
          "630-8232",
          "630-1113",
          "630-8364",
          "630-8306",
          "630-8323",
          "630-8324",
          "630-2172",
          "630-8382",
          "630-8431",
          "630-8136",
          "630-8137",
          "630-8103",
          "630-8371",
          "630-8403",
          "630-8412",
          "630-8348",
          "630-8296",
          "630-8441",
          "630-8226",
          "630-2177",
          "630-8033",
          "630-8032",
          "630-8036",
          "630-8034",
          "630-8453",
          "631-0818",
          "631-0823",
          "631-0827",
          "631-0822",
          "631-0825",
          "631-0834",
          "631-0832",
          "631-0815",
          "631-0835",
          "631-0831",
          "631-0833",
          "631-0816",
          "631-0821",
          "631-0824",
          "631-0817",
          "631-0836",
          "631-0826",
          "630-8255",
          "630-1241",
          "630-1103",
          "630-1104",
          "630-8003",
          "631-0801",
          "630-8105",
          "630-8106",
          "630-8013",
          "630-8123",
          "630-8125",
          "630-8126",
          "630-8127",
          "630-8124",
          "630-8122",
          "630-8121",
          "630-8244",
          "631-0031",
          "630-8014",
          "630-8015",
          "630-8053",
          "630-8051",
          "630-8052",
          "630-8054",
          "630-8385",
          "630-8114",
          "630-8384",
          "630-8433",
          "630-1102",
          "630-8236",
          "632-0101",
          "630-8365",
          "630-8265",
          "630-8363",
          "630-8254",
          "631-0007",
          "630-8312",
          "630-8311",
          "631-0804",
          "630-8208",
          "631-0043",
          "631-0842",
          "630-1111",
          "631-0806",
          "630-2178",
          "630-8357",
          "630-2171",
          "630-8211",
          "630-1121",
          "630-2152",
          "630-8133",
          "630-8135",
          "630-8134",
          "630-1245",
          "630-8301",
          "630-8411",
          "630-8238",
          "630-8241",
          "630-8336",
          "630-8432",
          "630-8112",
          "630-8218",
          "630-2167",
          "630-8392",
          "631-0045",
          "630-2301",
          "630-2302",
          "630-2304",
          "630-2305",
          "630-2303",
          "630-2306",
          "632-0243",
          "632-0247",
          "632-0232",
          "632-0221",
          "632-0242",
          "632-0246",
          "632-0113",
          "632-0231",
          "632-0241",
          "630-8316",
          "630-8223",
          "630-8224",
          "630-8343",
          "630-8393",
          "631-0021",
          "631-0022",
          "630-8206",
          "631-0062",
          "631-0063",
          "631-0066",
          "631-0064",
          "630-8423",
          "630-8234",
          "630-8144",
          "631-0051",
          "631-0077",
          "631-0078",
          "631-0076",
          "631-0004",
          "631-0065",
          "630-8237",
          "630-8315",
          "630-2162",
          "631-0003",
          "630-1124",
          "630-8201",
          "630-2163",
          "630-8333",
          "630-8401",
          "630-8037",
          "631-0052",
          "630-8292",
          "631-0012",
          "631-0013",
          "630-2165",
          "630-8253",
          "630-8264",
          "630-8107",
          "630-8104",
          "630-8335",
          "630-8287",
          "630-8325",
          "630-8307",
          "630-1105",
          "630-8291",
          "630-8251",
          "630-8248",
          "630-8345",
          "631-0046",
          "630-8372",
          "631-0006",
          "630-8042",
          "630-8245",
          "630-8334",
          "630-8225",
          "630-8012",
          "630-8002",
          "631-0072",
          "631-0073",
          "631-0071",
          "631-0008",
          "630-1235",
          "630-1244",
          "630-8318",
          "630-8213",
          "630-8217",
          "630-8257",
          "630-8145",
          "630-8146",
          "630-8414",
          "630-8266",
          "630-8328",
          "630-8354",
          "630-8227",
          "632-0112",
          "632-0251",
          "630-8295",
          "630-8111",
          "630-8284",
          "630-8102",
          "630-2173",
          "630-8286",
          "630-8327",
          "630-8305",
          "630-8288",
          "630-8272",
          "630-8344",
          "630-8362",
          "631-0002",
          "630-1125",
          "630-8203",
          "630-8215",
          "630-8216",
          "630-8214",
          "631-0843",
          "630-8383",
          "630-8302",
          "631-0024",
          "630-1122",
          "631-0846",
          "630-1101",
          "630-8381",
          "630-8394",
          "631-0044",
          "630-8421",
          "630-8258",
          "630-8424",
          "630-1123",
          "630-2153",
          "630-1126",
          "631-0845",
          "631-0844",
          "630-8108",
          "630-8113",
          "630-8001",
          "630-8231",
          "630-8271",
          "630-2168",
          "630-8413",
          "630-8402",
          "630-8268",
          "630-8267",
          "631-0056",
          "631-0803",
          "631-0061",
          "630-8331",
          "630-8373",
          "630-8355",
          "630-8304",
          "630-8303",
          "630-8141",
          "630-1112",
          "630-8356",
          "630-8016",
          "630-8341",
          "630-2164",
          "630-8404",
          "631-0023",
          "630-8347",
          "630-8443",
          "630-8281",
          "630-8277",
          "630-8282",
          "630-8342",
          "630-8351",
          "630-2151",
          "631-0074",
          "631-0075",
          "630-2175",
          "630-8222",
          "630-1231",
          "630-1237",
          "630-8321",
          "630-8435",
          "630-2166",
          "630-8353",
          "630-8434",
          "630-8283",
          "630-8422",
          "630-2174",
          "631-0828",
          "632-0244",
          "630-8043",
          "630-8045",
          "630-8044",
          "630-8041",
          "630-8425",
          "631-0837",
          "630-8337",
          "630-2176",
          "635-0000",
          "635-0053",
          "635-0012",
          "635-0035",
          "635-0036",
          "635-0072",
          "635-0021",
          "635-0077",
          "635-0093",
          "635-0063",
          "635-0061",
          "635-0062",
          "635-0094",
          "635-0074",
          "635-0043",
          "635-0031",
          "635-0032",
          "635-0087",
          "635-0083",
          "635-0076",
          "635-0095",
          "635-0091",
          "635-0092",
          "635-0016",
          "635-0073",
          "635-0052",
          "635-0042",
          "635-0067",
          "635-0085",
          "635-0056",
          "635-0084",
          "635-0097",
          "635-0044",
          "635-0011",
          "635-0015",
          "635-0064",
          "635-0014",
          "635-0017",
          "635-0013",
          "635-0025",
          "635-0026",
          "635-0055",
          "635-0054",
          "635-0041",
          "635-0047",
          "635-0081",
          "635-0022",
          "635-0071",
          "635-0002",
          "635-0003",
          "635-0037",
          "635-0045",
          "635-0057",
          "635-0058",
          "635-0096",
          "635-0046",
          "635-0051",
          "635-0075",
          "635-0065",
          "635-0066",
          "635-0034",
          "635-0023",
          "635-0024",
          "635-0004",
          "635-0082",
          "635-0001",
          "635-0033",
          "635-0086",
          "635-0059",
          "639-1100",
          "639-1013",
          "639-1032",
          "639-1027",
          "639-1111",
          "639-1116",
          "639-1056",
          "639-1113",
          "639-1104",
          "639-1158",
          "639-1155",
          "639-1031",
          "639-1005",
          "639-1168",
          "639-1019",
          "639-1106",
          "639-1138",
          "639-1034",
          "639-1102",
          "639-1018",
          "639-1161",
          "639-1165",
          "639-1160",
          "639-1146",
          "639-1025",
          "639-1001",
          "639-1002",
          "639-1147",
          "639-1042",
          "639-1044",
          "639-1026",
          "639-1045",
          "639-1023",
          "639-1148",
          "639-1156",
          "639-1141",
          "639-1150",
          "639-1169",
          "639-1039",
          "639-1101",
          "639-1051",
          "639-1011",
          "639-1016",
          "639-1004",
          "639-1033",
          "639-1112",
          "639-1008",
          "639-1012",
          "639-1143",
          "639-1114",
          "639-1157",
          "639-1054",
          "639-1121",
          "639-1053",
          "639-1003",
          "639-1133",
          "639-1132",
          "639-1028",
          "639-1122",
          "639-1152",
          "639-1127",
          "639-1123",
          "639-1135",
          "639-1006",
          "639-1144",
          "639-1149",
          "639-1052",
          "639-1022",
          "639-1166",
          "639-1118",
          "639-1159",
          "639-1021",
          "639-1014",
          "639-1164",
          "639-1043",
          "639-1163",
          "639-1153",
          "639-1038",
          "639-1036",
          "639-1035",
          "639-1037",
          "639-1131",
          "639-1125",
          "639-1119",
          "639-1105",
          "639-1117",
          "639-1108",
          "639-1137",
          "639-1162",
          "639-1017",
          "639-1136",
          "639-1151",
          "639-1124",
          "639-1041",
          "639-1024",
          "639-1167",
          "639-1007",
          "639-1145",
          "639-1103",
          "639-1015",
          "639-1126",
          "639-1058",
          "639-1142",
          "639-1055",
          "639-1134",
          "639-1057",
          "639-1115",
          "639-1107",
          "639-1154",
          "632-0000",
          "632-0068",
          "632-0082",
          "632-0011",
          "632-0004",
          "632-0083",
          "632-0076",
          "632-0003",
          "632-0031",
          "632-0086",
          "632-0047",
          "632-0064",
          "632-0084",
          "632-0024",
          "632-0042",
          "632-0016",
          "632-0091",
          "632-0056",
          "632-0095",
          "632-0069",
          "632-0006",
          "632-0036",
          "632-0085",
          "632-0092",
          "632-0093",
          "632-0043",
          "632-0046",
          "632-0053",
          "632-0023",
          "632-0058",
          "632-0096",
          "632-0078",
          "632-0094",
          "632-0048",
          "632-0032",
          "632-0071",
          "632-0021",
          "632-0041",
          "632-0073",
          "632-0017",
          "632-0034",
          "632-0022",
          "632-0055",
          "632-0072",
          "632-0013",
          "632-0012",
          "632-0097",
          "632-0001",
          "632-0051",
          "632-0123",
          "632-0061",
          "632-0062",
          "632-0005",
          "632-0057",
          "632-0081",
          "632-0087",
          "632-0088",
          "632-0075",
          "632-0063",
          "632-0054",
          "632-0074",
          "632-0044",
          "632-0066",
          "632-0077",
          "632-0122",
          "632-0045",
          "632-0025",
          "632-0014",
          "632-0018",
          "632-0033",
          "632-0015",
          "632-0098",
          "632-0065",
          "632-0035",
          "632-0007",
          "632-0052",
          "632-0121",
          "632-0067",
          "632-0002",
          "634-0000",
          "634-0045",
          "634-0014",
          "634-0812",
          "634-0833",
          "634-0834",
          "634-0065",
          "634-0046",
          "634-0075",
          "634-0846",
          "634-0841",
          "634-0044",
          "634-0061",
          "634-0815",
          "634-0001",
          "634-0023",
          "634-0012",
          "634-0824",
          "634-0031",
          "634-0826",
          "634-0825",
          "634-0823",
          "634-0843",
          "634-0005",
          "634-0033",
          "634-0025",
          "634-0004",
          "634-0007",
          "634-0063",
          "634-0827",
          "634-0832",
          "634-0043",
          "634-0062",
          "634-0813",
          "634-0074",
          "634-0029",
          "634-0811",
          "634-0042",
          "634-0803",
          "634-0051",
          "634-0006",
          "634-0836",
          "634-0805",
          "634-0816",
          "634-0831",
          "634-0072",
          "634-0027",
          "634-0032",
          "634-0844",
          "634-0013",
          "634-0011",
          "634-0817",
          "634-0008",
          "634-0003",
          "634-0842",
          "634-0822",
          "634-0804",
          "634-0845",
          "634-0009",
          "634-0073",
          "634-0821",
          "634-0801",
          "634-0802",
          "634-0021",
          "634-0002",
          "634-0835",
          "634-0847",
          "634-0034",
          "634-0076",
          "634-0828",
          "634-0026",
          "634-0028",
          "634-0837",
          "634-0064",
          "634-0022",
          "634-0052",
          "634-0077",
          "634-0024",
          "634-0078",
          "634-0071",
          "634-0814",
          "634-0829",
          "634-0041",
          "633-0000",
          "633-0006",
          "633-0003",
          "633-0004",
          "633-0052",
          "633-0071",
          "633-0054",
          "633-0055",
          "633-0026",
          "633-0046",
          "633-0122",
          "633-0035",
          "633-0013",
          "633-0041",
          "633-0086",
          "633-0076",
          "633-0048",
          "633-0084",
          "633-0062",
          "633-0014",
          "633-0101",
          "633-0103",
          "633-0077",
          "633-0005",
          "633-0031",
          "633-0064",
          "633-0133",
          "633-0002",
          "633-0061",
          "633-0106",
          "633-0063",
          "633-0051",
          "633-0022",
          "633-0034",
          "633-0065",
          "633-0081",
          "633-0021",
          "633-0011",
          "633-0012",
          "633-0015",
          "633-0091",
          "633-0017",
          "633-0074",
          "633-0042",
          "633-0131",
          "633-0121",
          "633-0105",
          "633-0075",
          "633-0104",
          "633-0044",
          "633-0067",
          "633-0043",
          "633-0108",
          "633-0053",
          "633-0073",
          "633-0083",
          "633-0032",
          "633-0007",
          "633-0079",
          "633-0107",
          "633-0033",
          "633-0066",
          "633-0072",
          "633-0047",
          "633-0112",
          "633-0024",
          "633-0068",
          "633-0085",
          "633-0078",
          "633-0082",
          "633-0087",
          "633-0102",
          "633-0023",
          "633-0001",
          "633-0028",
          "633-0025",
          "633-0045",
          "633-0036",
          "633-0111",
          "633-0016",
          "633-0027",
          "633-0018",
          "633-0132",
          "637-0000",
          "637-0074",
          "637-0013",
          "637-0072",
          "637-0004",
          "637-0003",
          "637-0077",
          "637-0060",
          "637-0405",
          "637-0416",
          "637-0417",
          "637-0414",
          "637-0401",
          "637-0406",
          "637-0419",
          "637-0402",
          "637-0408",
          "637-0411",
          "637-0407",
          "637-0409",
          "637-0403",
          "637-0415",
          "637-0404",
          "637-0413",
          "637-0412",
          "637-0015",
          "637-0063",
          "637-0066",
          "637-0006",
          "637-0092",
          "637-0053",
          "637-0019",
          "637-0054",
          "637-0084",
          "637-0081",
          "637-0091",
          "637-0076",
          "637-0018",
          "637-0025",
          "637-0062",
          "637-0073",
          "637-0031",
          "637-0042",
          "637-0012",
          "637-0065",
          "637-0002",
          "637-0027",
          "637-0083",
          "637-0043",
          "637-0005",
          "637-0014",
          "637-0024",
          "637-0067",
          "637-0052",
          "637-0016",
          "637-0011",
          "637-0093",
          "637-0061",
          "637-0082",
          "637-0078",
          "637-0020",
          "637-0001",
          "637-0017",
          "638-0643",
          "637-0117",
          "638-0652",
          "637-0221",
          "637-0111",
          "637-0112",
          "637-0234",
          "638-0663",
          "637-0101",
          "638-0655",
          "637-0239",
          "638-0651",
          "637-0231",
          "637-0225",
          "637-0102",
          "637-0113",
          "637-0236",
          "638-0656",
          "637-0230",
          "637-0227",
          "637-0114",
          "637-0222",
          "637-0232",
          "638-0653",
          "637-0224",
          "638-0661",
          "637-0238",
          "637-0226",
          "637-0233",
          "637-0235",
          "638-0642",
          "637-0115",
          "638-0654",
          "637-0103",
          "637-0237",
          "637-0223",
          "638-0641",
          "638-0657",
          "637-0104",
          "638-0644",
          "637-0105",
          "638-0662",
          "637-0116",
          "637-0034",
          "637-0037",
          "637-0036",
          "637-0038",
          "637-0075",
          "637-0022",
          "637-0028",
          "637-0068",
          "637-0021",
          "637-0069",
          "637-0071",
          "637-0041",
          "637-0033",
          "637-0023",
          "637-0051",
          "637-0032",
          "637-0064",
          "637-0029",
          "637-0026",
          "637-0035",
          "639-2200",
          "639-2341",
          "639-2239",
          "639-2255",
          "639-2264",
          "639-2273",
          "639-2326",
          "639-2258",
          "639-2245",
          "639-2279",
          "639-2207",
          "639-2267",
          "639-2323",
          "639-2238",
          "639-2304",
          "639-2257",
          "639-2231",
          "639-2244",
          "639-2343",
          "639-2229",
          "639-2334",
          "639-2203",
          "639-2312",
          "639-2256",
          "639-2337",
          "639-2254",
          "639-2311",
          "639-2224",
          "639-2314",
          "639-2221",
          "639-2325",
          "639-2272",
          "639-2211",
          "639-2324",
          "639-2276",
          "639-2261",
          "639-2213",
          "639-2217",
          "639-2265",
          "639-2235",
          "639-2303",
          "639-2328",
          "639-2342",
          "639-2236",
          "639-2336",
          "639-2206",
          "639-2247",
          "639-2241",
          "639-2212",
          "639-2275",
          "639-2202",
          "639-2251",
          "639-2274",
          "639-2317",
          "639-2263",
          "639-2225",
          "639-2321",
          "639-2313",
          "639-2331",
          "639-2335",
          "639-2228",
          "639-2345",
          "639-2316",
          "639-2215",
          "639-2332",
          "639-2333",
          "639-2246",
          "639-2227",
          "639-2344",
          "639-2205",
          "639-2243",
          "639-2322",
          "639-2302",
          "639-2262",
          "639-2252",
          "639-2346",
          "639-2268",
          "639-2253",
          "639-2266",
          "639-2237",
          "639-2242",
          "639-2223",
          "639-2327",
          "639-2232",
          "639-2216",
          "639-2214",
          "639-2278",
          "639-2248",
          "639-2204",
          "639-2226",
          "639-2306",
          "639-2233",
          "639-2315",
          "639-2271",
          "639-2277",
          "639-2301",
          "639-2318",
          "639-2305",
          "639-2201",
          "639-2234",
          "639-2222",
          "630-0200",
          "630-0239",
          "630-0132",
          "630-0133",
          "630-0134",
          "630-0233",
          "630-0202",
          "630-0203",
          "630-0222",
          "630-0232",
          "630-0223",
          "630-0227",
          "630-0237",
          "630-0131",
          "630-0138",
          "630-0265",
          "630-0245",
          "630-0142",
          "630-0121",
          "630-0248",
          "630-0201",
          "630-0247",
          "630-0226",
          "630-0211",
          "630-0221",
          "630-0112",
          "630-0114",
          "630-0113",
          "630-0111",
          "630-0115",
          "630-0136",
          "630-0253",
          "630-0242",
          "630-0229",
          "630-0238",
          "630-0101",
          "630-0251",
          "630-0243",
          "630-0212",
          "630-0263",
          "630-0267",
          "630-0231",
          "630-0261",
          "630-0137",
          "630-0264",
          "630-0236",
          "630-0246",
          "630-0224",
          "630-0234",
          "630-0141",
          "630-0254",
          "630-0213",
          "630-0214",
          "630-0258",
          "630-0215",
          "630-0244",
          "630-0225",
          "630-0235",
          "630-0256",
          "630-0241",
          "630-0122",
          "630-0123",
          "630-0116",
          "630-0262",
          "630-0135",
          "630-0228",
          "630-0257",
          "630-0266",
          "630-0255",
          "630-0252",
          "639-0200",
          "639-0266",
          "639-0252",
          "639-0236",
          "639-0264",
          "639-0251",
          "639-0227",
          "639-0265",
          "639-0225",
          "639-0242",
          "639-0234",
          "639-0226",
          "639-0221",
          "639-0233",
          "639-0232",
          "639-0231",
          "639-0237",
          "639-0255",
          "639-0254",
          "639-0241",
          "639-0256",
          "639-0253",
          "639-0222",
          "639-0261",
          "639-0262",
          "639-0245",
          "639-0263",
          "639-0243",
          "639-0224",
          "639-0244",
          "639-0223",
          "639-0235",
          "639-2100",
          "639-0274",
          "639-2133",
          "639-2153",
          "639-2145",
          "639-2123",
          "639-2152",
          "639-2111",
          "639-0275",
          "639-2144",
          "639-0271",
          "639-2113",
          "639-2142",
          "639-2161",
          "639-2121",
          "639-2162",
          "639-0272",
          "639-2147",
          "639-2127",
          "639-0273",
          "639-0276",
          "639-2155",
          "639-2135",
          "639-2164",
          "639-2146",
          "639-2125",
          "639-2103",
          "639-2122",
          "639-2163",
          "639-2131",
          "639-2102",
          "639-2101",
          "639-2154",
          "639-2136",
          "639-2112",
          "639-2132",
          "639-2141",
          "639-2151",
          "639-2126",
          "639-2137",
          "639-2143",
          "639-2134",
          "639-2138",
          "639-2124",
          "633-0200",
          "633-2225",
          "633-2227",
          "633-2214",
          "633-2223",
          "633-2202",
          "633-2204",
          "633-2213",
          "633-2222",
          "633-2224",
          "633-2212",
          "633-2215",
          "633-2211",
          "633-2201",
          "633-2226",
          "633-2205",
          "633-2221",
          "633-2203",
          "633-2105",
          "633-2101",
          "633-2162",
          "633-2126",
          "633-2116",
          "633-2111",
          "633-2107",
          "633-2136",
          "633-2114",
          "633-2174",
          "633-2141",
          "633-2133",
          "633-2161",
          "633-2171",
          "633-2173",
          "633-2172",
          "633-2104",
          "633-2144",
          "633-2155",
          "633-2176",
          "633-2112",
          "633-2134",
          "633-2124",
          "633-2117",
          "633-2137",
          "633-2132",
          "633-2113",
          "633-2170",
          "633-2177",
          "633-2178",
          "633-2179",
          "633-2153",
          "633-2138",
          "633-2152",
          "633-2151",
          "633-2142",
          "633-2122",
          "633-2121",
          "633-2175",
          "633-2165",
          "633-2115",
          "633-2103",
          "633-2166",
          "633-2108",
          "633-2135",
          "633-2102",
          "633-2164",
          "633-2123",
          "633-2156",
          "633-2143",
          "633-2106",
          "633-2163",
          "633-2154",
          "633-2125",
          "633-2139",
          "633-2131",
          "633-0207",
          "633-0256",
          "633-0213",
          "633-0231",
          "633-0243",
          "633-0232",
          "633-0223",
          "633-0215",
          "633-0225",
          "633-0201",
          "633-0245",
          "633-0222",
          "633-0228",
          "633-0252",
          "633-0242",
          "633-0226",
          "633-0227",
          "633-0217",
          "633-0241",
          "633-0212",
          "633-0234",
          "633-0254",
          "633-0255",
          "633-0206",
          "633-0205",
          "633-0203",
          "633-0211",
          "633-0208",
          "633-0221",
          "633-0253",
          "633-0257",
          "633-0251",
          "633-0218",
          "633-0235",
          "633-0204",
          "633-0233",
          "633-0236",
          "633-0214",
          "633-0244",
          "633-0216",
          "633-0246",
          "633-0224",
          "633-0202",
          "633-0421",
          "633-0315",
          "632-0204",
          "632-0202",
          "633-0425",
          "633-0317",
          "632-0201",
          "633-0422",
          "632-0205",
          "633-0313",
          "633-0424",
          "633-0423",
          "632-0206",
          "633-0314",
          "633-0312",
          "632-0203",
          "633-0316",
          "632-0207",
          "633-0311",
          "630-2232",
          "630-2355",
          "630-2212",
          "630-2344",
          "630-2341",
          "630-2343",
          "630-2356",
          "630-2231",
          "630-2211",
          "630-2234",
          "630-2205",
          "630-2357",
          "630-2233",
          "630-2345",
          "630-2224",
          "630-2351",
          "630-2222",
          "630-2352",
          "630-2346",
          "630-2354",
          "630-2342",
          "630-2225",
          "630-2203",
          "630-2202",
          "630-2223",
          "630-2201",
          "630-2221",
          "630-2204",
          "630-2353",
          "636-0000",
          "636-0944",
          "636-0915",
          "636-0905",
          "636-0906",
          "636-0913",
          "636-0924",
          "636-0925",
          "636-0923",
          "636-0922",
          "636-0901",
          "636-0933",
          "636-0902",
          "636-0912",
          "636-0911",
          "636-0943",
          "636-0931",
          "636-0945",
          "636-0914",
          "636-0942",
          "636-0934",
          "636-0935",
          "636-0903",
          "636-0936",
          "636-0937",
          "636-0921",
          "636-0904",
          "636-0941",
          "636-0932",
          "636-0916",
          "636-0938",
          "636-0813",
          "636-0831",
          "636-0832",
          "636-0833",
          "636-0824",
          "636-0814",
          "636-0815",
          "636-0811",
          "636-0812",
          "636-0823",
          "636-0822",
          "636-0821",
          "636-0803",
          "636-0834",
          "636-0805",
          "636-0804",
          "636-0802",
          "636-0801",
          "636-0100",
          "636-0122",
          "636-0124",
          "636-0144",
          "636-0141",
          "636-0102",
          "636-0123",
          "636-0121",
          "636-0103",
          "636-0142",
          "636-0143",
          "636-0104",
          "636-0106",
          "636-0152",
          "636-0154",
          "636-0153",
          "636-0151",
          "636-0105",
          "636-0131",
          "636-0116",
          "636-0115",
          "636-0112",
          "636-0114",
          "636-0113",
          "636-0111",
          "636-0101",
          "636-0132",
          "636-0133",
          "639-1062",
          "639-1065",
          "639-1063",
          "639-1064",
          "639-1066",
          "639-1061",
          "636-0300",
          "636-0203",
          "636-0201",
          "636-0204",
          "636-0206",
          "636-0205",
          "636-0202",
          "636-0212",
          "636-0216",
          "636-0215",
          "636-0214",
          "636-0213",
          "636-0217",
          "636-0211",
          "636-0313",
          "636-0245",
          "636-0329",
          "636-0332",
          "636-0224",
          "636-0243",
          "636-0331",
          "636-0314",
          "636-0345",
          "636-0353",
          "636-0242",
          "636-0223",
          "636-0322",
          "636-0244",
          "636-0232",
          "636-0226",
          "636-0333",
          "636-0234",
          "636-0301",
          "636-0237",
          "636-0339",
          "636-0352",
          "636-0328",
          "636-0315",
          "636-0327",
          "636-0247",
          "636-0355",
          "636-0304",
          "636-0326",
          "636-0312",
          "636-0233",
          "636-0231",
          "636-0248",
          "636-0336",
          "636-0335",
          "636-0337",
          "636-0246",
          "636-0338",
          "636-0317",
          "636-0307",
          "636-0347",
          "636-0236",
          "636-0306",
          "636-0225",
          "636-0323",
          "636-0343",
          "636-0221",
          "636-0235",
          "636-0241",
          "636-0305",
          "636-0222",
          "636-0303",
          "636-0334",
          "636-0351",
          "636-0354",
          "636-0342",
          "636-0325",
          "636-0302",
          "636-0344",
          "636-0324",
          "636-0316",
          "636-0311",
          "636-0341",
          "636-0321",
          "636-0346",
          "633-1200",
          "633-1201",
          "633-1212",
          "633-1215",
          "633-1203",
          "633-1213",
          "633-1211",
          "633-1202",
          "633-1214",
          "633-1216",
          "633-1300",
          "633-1301",
          "633-1302",
          "633-1303",
          "633-1304",
          "635-0100",
          "635-0123",
          "635-0144",
          "635-0104",
          "635-0152",
          "635-0154",
          "635-0133",
          "635-0143",
          "635-0131",
          "635-0134",
          "635-0103",
          "635-0151",
          "635-0153",
          "635-0135",
          "635-0101",
          "635-0102",
          "635-0142",
          "635-0121",
          "635-0136",
          "635-0112",
          "635-0113",
          "635-0111",
          "635-0132",
          "635-0122",
          "635-0141",
          "634-0100",
          "634-0103",
          "634-0134",
          "634-0108",
          "634-0123",
          "634-0121",
          "634-0116",
          "634-0133",
          "634-0111",
          "634-0102",
          "634-0106",
          "634-0115",
          "634-0124",
          "634-0141",
          "634-0132",
          "634-0138",
          "634-0101",
          "634-0122",
          "634-0136",
          "634-0112",
          "634-0113",
          "634-0142",
          "634-0143",
          "634-0107",
          "634-0125",
          "634-0145",
          "634-0118",
          "634-0105",
          "634-0135",
          "634-0144",
          "634-0117",
          "634-0114",
          "634-0137",
          "634-0131",
          "634-0104",
          "639-0201",
          "639-0215",
          "639-0214",
          "639-0202",
          "639-0218",
          "639-0205",
          "639-0216",
          "639-0211",
          "639-0203",
          "639-0217",
          "639-0212",
          "639-0204",
          "639-0206",
          "639-0213",
          "636-0002",
          "636-0011",
          "636-0003",
          "636-0023",
          "636-0021",
          "636-0014",
          "636-0001",
          "636-0012",
          "636-0015",
          "636-0022",
          "636-0013",
          "635-0825",
          "635-0831",
          "635-0832",
          "635-0833",
          "635-0834",
          "635-0803",
          "635-0801",
          "635-0821",
          "635-0805",
          "635-0813",
          "635-0815",
          "635-0804",
          "635-0817",
          "635-0816",
          "635-0814",
          "635-0824",
          "635-0822",
          "635-0812",
          "635-0811",
          "635-0802",
          "635-0835",
          "635-0823",
          "635-0818",
          "636-0053",
          "636-0091",
          "636-0057",
          "636-0093",
          "636-0051",
          "636-0082",
          "636-0063",
          "636-0062",
          "636-0092",
          "636-0081",
          "636-0071",
          "636-0052",
          "636-0072",
          "636-0054",
          "636-0055",
          "636-0056",
          "636-0073",
          "636-0061",
          "639-3100",
          "639-3433",
          "639-3113",
          "639-3323",
          "639-3436",
          "639-3111",
          "639-3102",
          "639-3442",
          "639-3434",
          "639-3432",
          "639-3324",
          "639-3322",
          "639-3107",
          "639-3117",
          "639-3431",
          "639-3106",
          "639-3112",
          "639-3114",
          "639-3105",
          "639-3446",
          "639-3445",
          "639-3108",
          "639-3118",
          "639-3103",
          "639-3444",
          "639-3321",
          "639-3437",
          "639-3435",
          "639-3104",
          "639-3443",
          "639-3116",
          "639-3441",
          "639-3325",
          "639-3101",
          "639-3115",
          "638-0000",
          "638-0801",
          "638-0841",
          "638-0851",
          "638-0842",
          "639-3125",
          "639-3124",
          "638-0832",
          "638-0803",
          "638-0831",
          "638-0821",
          "638-0811",
          "639-3122",
          "639-3121",
          "639-3126",
          "639-3127",
          "638-0802",
          "638-0812",
          "639-3128",
          "638-0833",
          "638-0843",
          "639-3123",
          "638-0852",
          "638-0853",
          "638-0045",
          "638-0001",
          "638-0012",
          "638-0043",
          "638-0024",
          "638-0023",
          "638-0014",
          "638-0042",
          "638-0041",
          "638-0002",
          "638-0003",
          "638-0013",
          "638-0044",
          "638-0025",
          "638-0035",
          "638-0031",
          "638-0021",
          "638-0033",
          "638-0022",
          "638-0026",
          "638-0032",
          "638-0015",
          "638-0034",
          "638-0011",
          "638-0200",
          "638-0211",
          "638-0241",
          "638-0231",
          "638-0232",
          "638-0251",
          "638-0243",
          "638-0203",
          "638-0221",
          "638-0233",
          "638-0201",
          "638-0242",
          "638-0202",
          "638-0300",
          "638-0552",
          "638-0311",
          "638-0301",
          "638-0313",
          "638-0303",
          "638-0314",
          "638-0551",
          "638-0305",
          "638-0315",
          "638-0564",
          "638-0563",
          "638-0562",
          "638-0541",
          "638-0321",
          "638-0542",
          "638-0431",
          "638-0302",
          "638-0312",
          "638-0561",
          "638-0322",
          "638-0304",
          "638-0553",
          "638-0543",
          "648-0300",
          "648-0301",
          "637-0421",
          "637-0425",
          "648-0307",
          "648-0305",
          "648-0302",
          "648-0306",
          "648-0304",
          "637-0424",
          "648-0303",
          "648-0308",
          "637-0422",
          "637-0423",
          "648-0309",
          "637-1500",
          "637-1102",
          "637-1215",
          "637-1664",
          "637-1224",
          "637-1103",
          "637-1107",
          "637-1221",
          "637-1331",
          "637-1441",
          "637-1333",
          "637-1443",
          "637-1446",
          "637-1217",
          "647-1584",
          "637-1559",
          "637-1216",
          "637-1556",
          "637-1336",
          "647-1581",
          "637-1667",
          "637-1445",
          "637-1334",
          "637-1666",
          "637-1555",
          "637-1661",
          "637-1225",
          "637-1668",
          "637-1442",
          "637-1211",
          "647-1271",
          "637-1104",
          "637-1552",
          "637-1106",
          "647-1582",
          "637-1663",
          "637-1558",
          "637-1212",
          "637-1662",
          "637-1108",
          "637-1551",
          "637-1557",
          "637-1665",
          "637-1101",
          "637-1213",
          "637-1105",
          "647-1583",
          "637-1554",
          "637-1223",
          "637-1332",
          "637-1214",
          "637-1553",
          "637-1444",
          "637-1222",
          "637-1335",
          "639-3800",
          "639-3804",
          "639-3802",
          "639-3805",
          "639-3808",
          "639-3801",
          "639-3806",
          "639-3807",
          "639-3809",
          "639-3803",
          "639-3700",
          "639-3701",
          "639-3702",
          "639-3703",
          "639-3704",
          "639-3705",
          "639-3500",
          "639-3623",
          "639-3622",
          "639-3558",
          "639-3541",
          "639-3612",
          "639-3543",
          "639-3613",
          "639-3601",
          "639-3552",
          "639-3603",
          "639-3602",
          "639-3604",
          "639-3635",
          "639-3553",
          "639-3611",
          "639-3621",
          "639-3631",
          "639-3555",
          "639-3634",
          "639-3632",
          "639-3554",
          "639-3556",
          "639-3551",
          "639-3633",
          "639-3542",
          "639-3557",
          "633-2400",
          "633-2312",
          "633-2444",
          "633-2421",
          "633-2431",
          "633-2423",
          "633-2311",
          "633-2432",
          "633-2304",
          "633-2441",
          "633-2301",
          "633-2302",
          "633-2424",
          "633-2314",
          "633-2313",
          "633-2303",
          "633-2442",
          "633-2433",
          "633-2443",
          "633-2422",
          "640-0000",
          "640-8273",
          "640-8322",
          "641-0056",
          "640-0344",
          "640-8134",
          "649-6336",
          "640-8238",
          "640-8316",
          "640-8248",
          "640-8246",
          "640-8245",
          "640-8390",
          "640-8351",
          "640-8462",
          "640-8201",
          "640-0114",
          "640-8044",
          "640-0361",
          "640-8464",
          "640-8146",
          "640-8076",
          "640-0352",
          "649-6323",
          "641-0044",
          "640-8301",
          "640-8302",
          "649-6316",
          "640-8242",
          "640-8298",
          "640-8078",
          "640-8039",
          "640-8072",
          "640-8071",
          "641-0043",
          "649-6332",
          "641-0053",
          "641-0013",
          "640-8452",
          "640-8239",
          "640-8335",
          "640-0343",
          "640-8434",
          "640-0101",
          "640-0316",
          "649-6272",
          "640-8472",
          "640-8323",
          "640-8361",
          "640-8364",
          "640-8362",
          "640-8365",
          "640-8363",
          "640-8145",
          "640-0362",
          "649-6261",
          "640-8271",
          "649-6308",
          "640-8230",
          "640-8224",
          "640-8124",
          "640-8073",
          "640-8293",
          "640-8139",
          "640-0103",
          "640-8243",
          "649-6274",
          "640-8391",
          "640-8288",
          "649-6306",
          "649-6262",
          "649-6312",
          "640-8411",
          "649-6334",
          "640-8253",
          "640-8299",
          "640-8020",
          "640-8103",
          "640-8062",
          "640-8118",
          "640-8233",
          "640-8002",
          "640-8017",
          "640-8015",
          "640-8012",
          "640-8001",
          "640-8016",
          "640-8003",
          "640-8011",
          "640-8403",
          "640-8291",
          "640-8252",
          "640-8031",
          "640-8294",
          "640-8317",
          "640-8296",
          "641-0008",
          "649-6331",
          "640-8355",
          "640-8352",
          "640-8353",
          "640-8356",
          "640-8357",
          "640-8358",
          "640-8359",
          "640-8354",
          "640-8350",
          "649-6307",
          "640-8038",
          "640-8231",
          "640-8412",
          "640-8453",
          "640-8328",
          "641-0012",
          "640-8244",
          "640-8155",
          "640-0351",
          "640-8274",
          "641-0001",
          "640-8055",
          "640-8332",
          "640-8463",
          "649-6313",
          "640-0364",
          "640-8225",
          "640-8333",
          "640-8305",
          "640-0311",
          "640-8341",
          "640-0312",
          "640-0345",
          "640-8337",
          "641-0014",
          "640-8220",
          "640-8075",
          "640-8314",
          "649-6315",
          "641-0007",
          "640-0323",
          "640-8141",
          "640-8373",
          "640-8226",
          "640-8228",
          "640-0301",
          "640-8265",
          "640-8269",
          "640-8027",
          "640-8435",
          "641-0062",
          "640-8108",
          "640-8121",
          "640-8249",
          "640-8241",
          "640-8237",
          "640-0313",
          "640-8441",
          "641-0003",
          "640-8053",
          "640-8054",
          "640-8057",
          "640-8052",
          "640-8058",
          "640-8051",
          "640-8056",
          "640-8047",
          "640-8059",
          "640-8276",
          "649-6311",
          "640-0303",
          "640-8142",
          "640-0306",
          "640-8122",
          "641-0054",
          "640-8156",
          "640-8267",
          "649-6314",
          "640-8125",
          "640-8413",
          "640-8414",
          "640-8415",
          "640-8416",
          "649-6263",
          "649-6325",
          "640-8074",
          "640-8101",
          "640-8377",
          "640-8345",
          "649-6264",
          "640-8325",
          "640-8372",
          "640-8111",
          "641-0002",
          "640-8376",
          "641-0042",
          "640-8371",
          "641-0023",
          "640-8152",
          "640-8159",
          "640-8158",
          "640-8150",
          "640-8444",
          "640-8374",
          "640-8212",
          "640-8378",
          "640-0314",
          "640-8272",
          "640-8022",
          "640-8034",
          "641-0035",
          "640-8041",
          "640-8114",
          "640-8471",
          "640-0341",
          "640-8483",
          "640-8135",
          "649-6301",
          "640-8028",
          "641-0005",
          "640-8061",
          "640-8329",
          "649-6305",
          "640-8133",
          "641-0061",
          "649-6337",
          "640-8287",
          "640-8263",
          "640-8334",
          "640-0115",
          "640-8315",
          "640-8319",
          "640-8320",
          "640-8311",
          "640-8282",
          "640-8285",
          "640-8283",
          "640-8284",
          "640-8306",
          "640-8321",
          "640-8204",
          "640-8229",
          "640-8432",
          "640-8206",
          "640-8256",
          "640-8342",
          "640-8451",
          "641-0006",
          "649-6304",
          "640-8433",
          "640-8392",
          "640-8025",
          "640-8026",
          "640-8023",
          "640-0302",
          "640-8236",
          "640-8009",
          "640-8303",
          "649-6333",
          "641-0034",
          "640-0322",
          "640-8313",
          "640-8046",
          "640-8297",
          "640-8063",
          "640-8205",
          "641-0031",
          "640-8116",
          "640-8234",
          "649-6335",
          "641-0051",
          "640-8037",
          "640-8014",
          "640-8290",
          "640-8211",
          "640-0112",
          "640-8042",
          "640-8021",
          "641-0036",
          "640-8227",
          "640-8143",
          "640-8326",
          "641-0015",
          "649-6324",
          "640-8481",
          "640-8344",
          "640-8402",
          "640-8443",
          "640-8215",
          "640-8327",
          "640-8382",
          "640-8383",
          "640-8385",
          "640-8386",
          "640-8384",
          "640-8397",
          "640-8394",
          "640-8395",
          "640-8393",
          "640-8381",
          "640-8396",
          "640-8399",
          "640-8387",
          "640-8398",
          "640-8157",
          "640-0353",
          "649-6275",
          "640-8036",
          "640-8064",
          "640-8203",
          "641-0032",
          "640-8115",
          "640-8247",
          "641-0052",
          "649-6273",
          "640-8013",
          "640-8235",
          "640-8266",
          "640-8066",
          "640-8004",
          "640-8067",
          "640-0111",
          "640-8202",
          "640-8442",
          "640-0304",
          "649-6303",
          "640-8113",
          "640-8128",
          "640-0333",
          "640-8268",
          "649-6339",
          "640-8137",
          "640-8324",
          "640-8401",
          "640-8043",
          "649-6318",
          "640-8068",
          "649-6338",
          "640-8213",
          "640-8255",
          "640-8461",
          "640-0332",
          "640-8131",
          "640-8375",
          "640-8045",
          "649-6321",
          "641-0041",
          "640-8136",
          "641-0045",
          "640-8033",
          "640-8261",
          "640-8421",
          "640-8423",
          "640-8422",
          "640-8424",
          "640-8425",
          "641-0033",
          "640-8304",
          "640-0342",
          "641-0011",
          "640-8153",
          "640-8106",
          "640-8107",
          "640-8105",
          "640-8123",
          "640-8069",
          "640-8331",
          "649-6271",
          "640-8404",
          "640-8264",
          "640-8223",
          "640-8221",
          "640-8286",
          "640-8281",
          "640-8262",
          "640-8222",
          "640-8275",
          "640-8295",
          "640-8029",
          "640-8126",
          "640-8104",
          "640-8102",
          "640-8117",
          "640-8112",
          "640-8292",
          "640-8254",
          "640-8032",
          "640-8251",
          "640-8318",
          "640-0315",
          "640-8232",
          "640-0102",
          "640-0305",
          "640-8431",
          "640-8077",
          "640-8482",
          "640-8024",
          "640-8006",
          "640-8007",
          "640-8005",
          "640-8008",
          "640-8216",
          "640-8127",
          "640-0113",
          "640-0324",
          "640-8312",
          "640-8151",
          "640-0321",
          "640-0307",
          "640-8336",
          "640-8138",
          "640-8132",
          "649-6317",
          "640-8065",
          "649-6302",
          "640-0363",
          "640-8343",
          "640-0331",
          "640-8060",
          "640-8214",
          "640-8035",
          "640-8144",
          "640-8154",
          "641-0025",
          "641-0021",
          "641-0024",
          "641-0022",
          "641-0055",
          "640-8119",
          "649-6322",
          "649-6326",
          "641-0004",
          "642-0000",
          "640-1163",
          "642-0015",
          "642-0021",
          "640-1164",
          "642-0013",
          "642-0022",
          "642-0012",
          "640-1175",
          "642-0014",
          "640-1162",
          "640-1174",
          "642-0016",
          "640-1167",
          "642-0027",
          "642-0011",
          "642-0024",
          "642-0023",
          "642-0019",
          "642-0018",
          "642-0035",
          "649-0147",
          "649-0145",
          "649-0132",
          "649-0155",
          "649-0112",
          "649-0153",
          "649-0162",
          "649-0154",
          "649-0111",
          "649-0164",
          "649-0163",
          "649-0144",
          "649-0146",
          "649-0122",
          "649-0161",
          "649-0143",
          "649-0141",
          "649-0131",
          "649-0133",
          "649-0101",
          "649-0151",
          "649-0142",
          "649-0152",
          "649-0121",
          "649-0156",
          "649-0123",
          "640-0443",
          "640-0451",
          "642-0031",
          "640-1166",
          "642-0033",
          "642-0032",
          "640-0441",
          "640-1161",
          "640-1171",
          "640-0453",
          "642-0028",
          "642-0004",
          "640-0442",
          "642-0002",
          "642-0025",
          "640-1165",
          "642-0034",
          "642-0001",
          "640-0454",
          "642-0026",
          "640-1172",
          "642-0017",
          "640-1173",
          "640-0452",
          "642-0003",
          "642-0029",
          "648-0000",
          "648-0022",
          "648-0019",
          "648-0073",
          "648-0024",
          "648-0071",
          "648-0005",
          "648-0097",
          "648-0037",
          "648-0084",
          "648-0043",
          "648-0085",
          "648-0061",
          "648-0033",
          "648-0007",
          "648-0052",
          "648-0092",
          "648-0093",
          "648-0021",
          "649-7201",
          "649-7207",
          "649-7204",
          "649-7212",
          "649-7215",
          "649-7213",
          "649-7211",
          "649-7214",
          "649-7216",
          "649-7205",
          "649-7203",
          "649-7202",
          "649-7206",
          "648-0099",
          "648-0065",
          "648-0086",
          "648-0066",
          "648-0006",
          "648-0075",
          "648-0041",
          "648-0082",
          "648-0053",
          "648-0054",
          "648-0001",
          "648-0038",
          "648-0012",
          "648-0014",
          "648-0016",
          "648-0015",
          "648-0004",
          "648-0018",
          "648-0013",
          "648-0017",
          "648-0002",
          "648-0011",
          "648-0003",
          "648-0031",
          "648-0032",
          "648-0062",
          "648-0083",
          "648-0072",
          "648-0023",
          "648-0042",
          "648-0074",
          "648-0095",
          "648-0064",
          "648-0091",
          "648-0063",
          "648-0035",
          "648-0051",
          "648-0094",
          "648-0044",
          "648-0034",
          "648-0088",
          "648-0096",
          "648-0025",
          "648-0098",
          "648-0081",
          "648-0036",
          "648-0087",
          "649-0300",
          "649-0421",
          "649-0422",
          "649-0317",
          "649-0301",
          "649-0303",
          "649-0313",
          "649-0311",
          "649-0314",
          "649-0307",
          "649-0306",
          "649-0312",
          "649-0305",
          "649-0304",
          "649-0316",
          "649-0434",
          "649-0433",
          "649-0437",
          "649-0435",
          "649-0436",
          "649-0431",
          "649-0432",
          "649-0302",
          "649-0315",
          "644-0000",
          "644-0015",
          "644-0033",
          "644-0032",
          "644-0001",
          "644-0024",
          "644-0025",
          "644-0003",
          "644-0002",
          "644-0022",
          "644-0021",
          "644-0023",
          "644-0004",
          "644-0005",
          "644-0031",
          "649-1341",
          "649-1342",
          "644-0034",
          "644-0012",
          "644-0011",
          "644-0014",
          "644-0013",
          "646-0000",
          "646-0102",
          "646-0005",
          "646-0021",
          "646-0027",
          "646-1101",
          "646-0037",
          "646-0051",
          "646-0043",
          "646-1321",
          "646-0212",
          "646-0061",
          "646-0054",
          "646-0034",
          "646-0024",
          "646-0012",
          "646-0045",
          "646-0001",
          "646-0101",
          "646-0002",
          "646-0214",
          "646-0036",
          "646-0041",
          "646-1334",
          "646-1335",
          "646-1338",
          "646-1325",
          "646-1332",
          "646-1331",
          "646-0047",
          "646-0048",
          "646-1212",
          "646-1213",
          "646-1337",
          "646-0004",
          "646-0216",
          "646-0032",
          "646-0217",
          "646-0011",
          "646-0014",
          "646-0033",
          "646-0038",
          "646-0028",
          "646-0015",
          "646-1324",
          "646-1336",
          "646-0050",
          "646-0029",
          "646-1339",
          "646-0057",
          "646-1412",
          "646-1439",
          "646-1411",
          "646-1433",
          "646-1417",
          "646-1436",
          "646-1421",
          "646-1435",
          "646-1431",
          "646-1437",
          "646-1416",
          "646-1402",
          "646-1414",
          "646-1434",
          "646-1401",
          "646-1432",
          "646-1413",
          "646-1415",
          "646-1438",
          "646-0003",
          "646-0215",
          "646-0035",
          "646-0213",
          "646-0056",
          "646-0063",
          "646-1333",
          "646-0022",
          "646-1214",
          "646-1326",
          "646-0044",
          "646-0211",
          "646-0059",
          "646-0026",
          "647-1742",
          "647-1703",
          "647-1741",
          "647-1725",
          "647-1702",
          "647-1716",
          "647-1751",
          "647-1717",
          "647-1752",
          "647-1736",
          "647-1722",
          "647-1701",
          "647-1714",
          "647-1734",
          "647-1705",
          "647-1712",
          "647-1753",
          "647-1724",
          "647-1715",
          "647-1721",
          "647-1743",
          "647-1726",
          "647-1731",
          "647-1735",
          "647-1744",
          "647-1711",
          "647-1723",
          "647-1713",
          "647-1704",
          "647-1732",
          "647-1733",
          "646-0046",
          "646-0025",
          "646-0031",
          "646-0042",
          "646-0013",
          "646-1323",
          "646-0052",
          "646-0062",
          "646-0058",
          "646-1322",
          "646-0053",
          "646-0023",
          "645-0303",
          "645-0302",
          "645-0521",
          "645-0413",
          "645-0415",
          "645-0412",
          "645-0414",
          "645-0523",
          "645-0301",
          "645-0522",
          "645-0411",
          "645-0416",
          "645-0417",
          "645-0524",
          "645-0525",
          "646-1211",
          "647-0000",
          "647-0001",
          "647-0025",
          "647-0022",
          "647-0021",
          "647-0012",
          "647-0045",
          "647-0051",
          "647-0014",
          "647-0008",
          "647-1102",
          "647-0032",
          "647-0004",
          "647-0013",
          "647-0044",
          "647-0003",
          "647-0073",
          "647-1216",
          "647-1214",
          "647-1207",
          "647-1203",
          "647-1204",
          "647-1201",
          "647-1233",
          "647-1223",
          "647-1234",
          "647-1232",
          "647-1205",
          "647-1212",
          "647-1231",
          "647-1206",
          "647-1221",
          "647-1213",
          "647-1202",
          "647-1222",
          "647-1211",
          "647-1235",
          "647-1215",
          "647-0024",
          "647-0053",
          "647-0071",
          "647-0033",
          "647-0042",
          "647-0011",
          "647-0020",
          "647-0081",
          "647-0019",
          "647-1101",
          "647-0031",
          "647-0016",
          "647-0015",
          "647-0018",
          "647-0041",
          "647-0052",
          "647-0072",
          "647-0002",
          "647-0007",
          "647-0023",
          "647-0034",
          "647-0043",
          "647-0054",
          "647-1103",
          "647-0061",
          "647-0005",
          "647-0006",
          "647-0017",
          "649-6400",
          "649-6404",
          "649-6614",
          "649-6611",
          "649-6561",
          "649-6407",
          "649-6541",
          "649-6511",
          "649-6416",
          "649-6414",
          "649-6521",
          "649-6605",
          "649-6624",
          "649-6615",
          "649-6423",
          "649-6562",
          "649-6563",
          "649-6564",
          "649-6571",
          "649-6522",
          "640-0403",
          "640-0424",
          "640-0412",
          "640-0422",
          "640-0405",
          "640-0421",
          "640-0402",
          "640-0414",
          "640-0413",
          "640-0423",
          "640-0404",
          "640-0415",
          "640-0416",
          "640-0406",
          "640-0411",
          "640-0401",
          "649-6406",
          "649-6501",
          "649-6402",
          "649-6443",
          "649-6502",
          "649-6612",
          "649-6606",
          "649-6415",
          "649-6418",
          "649-6412",
          "649-6422",
          "649-6551",
          "649-6531",
          "649-6401",
          "649-6552",
          "649-6426",
          "649-6572",
          "649-6523",
          "649-6622",
          "649-6451",
          "649-6442",
          "649-6565",
          "649-6161",
          "649-6413",
          "649-6162",
          "649-6421",
          "649-6512",
          "649-6445",
          "649-6425",
          "649-6503",
          "649-6513",
          "649-6573",
          "649-6452",
          "649-6434",
          "649-6532",
          "649-6631",
          "649-6601",
          "649-6603",
          "649-6621",
          "649-6427",
          "649-6417",
          "649-6524",
          "649-6604",
          "649-6433",
          "649-6447",
          "649-6616",
          "649-6525",
          "649-6444",
          "649-6424",
          "649-6405",
          "649-6526",
          "649-6428",
          "649-6542",
          "649-6435",
          "649-6441",
          "649-6602",
          "649-6411",
          "649-6446",
          "649-6553",
          "649-6514",
          "649-6623",
          "649-6432",
          "649-6554",
          "649-6555",
          "649-6504",
          "649-6403",
          "649-6431",
          "649-6124",
          "649-6105",
          "640-1333",
          "649-6102",
          "649-6123",
          "649-6101",
          "649-6125",
          "649-6121",
          "649-6112",
          "640-1332",
          "649-6103",
          "640-1331",
          "649-6111",
          "649-6122",
          "649-6104",
          "649-6613",
          "649-6200",
          "649-6257",
          "649-6242",
          "649-6207",
          "649-6252",
          "649-6232",
          "649-6204",
          "649-6208",
          "649-6228",
          "649-6222",
          "649-6201",
          "649-6256",
          "649-6243",
          "649-6231",
          "649-6253",
          "649-6219",
          "649-6251",
          "649-6203",
          "649-6227",
          "649-6212",
          "649-6236",
          "649-6234",
          "649-6223",
          "649-6248",
          "649-6245",
          "649-6215",
          "649-6255",
          "649-6213",
          "649-6235",
          "649-6202",
          "649-6216",
          "649-6244",
          "649-6241",
          "649-6254",
          "649-6211",
          "649-6233",
          "649-6225",
          "649-6206",
          "649-6214",
          "649-6221",
          "649-6218",
          "649-6226",
          "649-6205",
          "649-6258",
          "649-6224",
          "649-6217",
          "649-6246",
          "640-1100",
          "640-1213",
          "640-1231",
          "640-1207",
          "640-1365",
          "640-1202",
          "640-1113",
          "640-1353",
          "640-1222",
          "640-1115",
          "640-1351",
          "640-1211",
          "640-1255",
          "640-1215",
          "640-1201",
          "640-1251",
          "640-1472",
          "640-1476",
          "640-1474",
          "640-1473",
          "640-1243",
          "640-1475",
          "640-1112",
          "640-1102",
          "640-1121",
          "640-1141",
          "640-1364",
          "640-1363",
          "640-1212",
          "640-1362",
          "640-1352",
          "640-1223",
          "640-1131",
          "640-1361",
          "640-1114",
          "640-1101",
          "640-1241",
          "640-1252",
          "640-1235",
          "640-1471",
          "640-1203",
          "640-1253",
          "640-1242",
          "640-1111",
          "640-1244",
          "640-1205",
          "640-1366",
          "640-1254",
          "640-1221",
          "640-1233",
          "640-1206",
          "640-1204",
          "640-1214",
          "640-1232",
          "640-1234",
          "640-1354",
          "640-1103",
          "649-7100",
          "649-7137",
          "649-7167",
          "649-7172",
          "649-7173",
          "649-7111",
          "649-7171",
          "649-7123",
          "649-7162",
          "649-7161",
          "649-7141",
          "649-7132",
          "649-7164",
          "649-7143",
          "649-7153",
          "649-7174",
          "649-7144",
          "649-7155",
          "649-7142",
          "640-1481",
          "649-7122",
          "649-7165",
          "649-7104",
          "649-7166",
          "649-7102",
          "649-7121",
          "649-7136",
          "649-7112",
          "649-7114",
          "649-7154",
          "649-7163",
          "643-0614",
          "643-0613",
          "643-0612",
          "648-0201",
          "648-0202",
          "643-0611",
          "649-7151",
          "649-7101",
          "649-7145",
          "649-7135",
          "649-7175",
          "649-7103",
          "649-7152",
          "649-7146",
          "649-7115",
          "649-7133",
          "649-7134",
          "649-7113",
          "649-7131",
          "648-0100",
          "648-0131",
          "648-0142",
          "648-0111",
          "648-0143",
          "648-0132",
          "648-0101",
          "648-0141",
          "648-0151",
          "648-0145",
          "648-0144",
          "648-0121",
          "648-0161",
          "648-0133",
          "648-0200",
          "648-0241",
          "648-0231",
          "648-0227",
          "648-0403",
          "648-0211",
          "648-0405",
          "648-0225",
          "648-0404",
          "648-0221",
          "648-0261",
          "648-0171",
          "648-0401",
          "648-0263",
          "648-0223",
          "648-0402",
          "648-0226",
          "648-0224",
          "648-0262",
          "648-0222",
          "648-0251",
          "643-0000",
          "643-0002",
          "643-0005",
          "643-0006",
          "643-0003",
          "643-0001",
          "643-0004",
          "643-0007",
          "643-0055",
          "643-0052",
          "643-0064",
          "643-0073",
          "643-0053",
          "643-0051",
          "643-0062",
          "643-0066",
          "643-0074",
          "643-0065",
          "643-0071",
          "643-0054",
          "643-0063",
          "643-0061",
          "643-0072",
          "643-0075",
          "643-0366",
          "643-0136",
          "643-0129",
          "643-0127",
          "643-0603",
          "643-0604",
          "643-0144",
          "643-0851",
          "643-0165",
          "643-0174",
          "643-0844",
          "643-0312",
          "643-0164",
          "643-0026",
          "643-0131",
          "643-0847",
          "643-0513",
          "643-0134",
          "643-0845",
          "643-0135",
          "643-0142",
          "643-0022",
          "643-0601",
          "643-0034",
          "643-0852",
          "643-0133",
          "643-0132",
          "643-0812",
          "643-0843",
          "643-0152",
          "643-0176",
          "643-0855",
          "643-0171",
          "643-0551",
          "643-0364",
          "643-0313",
          "643-0161",
          "643-0362",
          "643-0531",
          "643-0514",
          "643-0023",
          "643-0172",
          "643-0544",
          "643-0521",
          "643-0021",
          "643-0173",
          "643-0522",
          "643-0811",
          "643-0602",
          "643-0853",
          "643-0163",
          "643-0122",
          "643-0846",
          "643-0848",
          "643-0314",
          "643-0311",
          "643-0032",
          "643-0533",
          "643-0801",
          "643-0123",
          "643-0153",
          "643-0854",
          "643-0841",
          "643-0143",
          "643-0365",
          "643-0124",
          "643-0175",
          "643-0363",
          "643-0128",
          "643-0813",
          "643-0125",
          "643-0532",
          "643-0605",
          "643-0031",
          "643-0137",
          "643-0151",
          "643-0025",
          "643-0541",
          "643-0803",
          "643-0121",
          "643-0543",
          "643-0542",
          "643-0842",
          "643-0141",
          "643-0126",
          "643-0162",
          "643-0024",
          "643-0361",
          "643-0511",
          "643-0512",
          "643-0033",
          "643-0515",
          "643-0166",
          "643-0802",
          "644-0041",
          "644-0042",
          "644-0045",
          "644-0043",
          "644-0044",
          "649-1200",
          "649-1232",
          "649-1203",
          "649-1211",
          "649-1233",
          "649-1222",
          "649-1223",
          "649-1231",
          "649-1212",
          "649-1225",
          "649-1221",
          "649-1213",
          "649-1224",
          "649-1202",
          "649-1201",
          "649-1234",
          "649-1100",
          "649-1112",
          "649-1113",
          "649-1132",
          "649-1104",
          "649-1123",
          "649-1122",
          "649-1131",
          "649-1111",
          "649-1134",
          "649-1102",
          "649-1101",
          "649-1121",
          "649-1133",
          "649-1103",
          "649-1500",
          "649-1534",
          "649-1532",
          "644-0215",
          "644-0202",
          "644-0201",
          "644-0214",
          "644-0216",
          "649-1527",
          "644-0211",
          "649-1531",
          "644-0212",
          "649-1535",
          "644-0213",
          "649-1528",
          "644-0217",
          "649-1524",
          "649-1522",
          "649-1525",
          "649-1523",
          "644-0218",
          "649-1521",
          "649-1536",
          "649-1526",
          "649-1537",
          "649-1533",
          "645-0000",
          "645-0208",
          "645-0022",
          "645-0011",
          "645-0006",
          "645-0201",
          "645-0023",
          "645-0028",
          "645-0003",
          "645-0002",
          "645-0203",
          "645-0025",
          "645-0207",
          "645-0205",
          "645-0026",
          "645-0206",
          "645-0024",
          "645-0014",
          "645-0027",
          "645-0004",
          "645-0013",
          "645-0202",
          "645-0021",
          "645-0001",
          "645-0204",
          "645-0005",
          "645-0012",
          "649-1300",
          "644-1243",
          "644-1213",
          "644-1132",
          "649-1313",
          "644-1211",
          "644-1231",
          "649-1442",
          "644-1162",
          "644-1163",
          "644-1212",
          "649-1331",
          "644-1214",
          "644-1244",
          "644-1141",
          "644-1201",
          "644-1222",
          "644-1242",
          "649-1315",
          "644-1143",
          "649-1323",
          "644-1164",
          "644-1161",
          "649-1441",
          "644-1142",
          "649-1332",
          "644-1221",
          "645-0551",
          "644-1122",
          "644-1123",
          "644-1241",
          "644-1151",
          "644-1101",
          "649-1325",
          "644-1121",
          "649-1321",
          "649-1314",
          "649-1324",
          "644-1133",
          "649-1311",
          "644-1111",
          "649-1316",
          "649-1444",
          "644-1152",
          "644-1131",
          "644-1134",
          "649-1312",
          "649-1322",
          "649-1443",
          "649-2200",
          "649-2211",
          "649-2532",
          "649-2524",
          "646-0301",
          "649-2322",
          "649-2537",
          "646-0312",
          "646-0303",
          "649-2521",
          "646-0311",
          "649-2201",
          "646-0305",
          "649-2531",
          "646-0302",
          "649-2538",
          "649-2334",
          "649-2332",
          "646-0314",
          "649-2525",
          "649-2323",
          "649-2539",
          "649-2331",
          "646-0304",
          "649-2523",
          "646-0313",
          "649-2324",
          "649-2326",
          "649-2534",
          "649-2325",
          "649-2333",
          "649-2533",
          "649-2511",
          "649-2536",
          "649-2321",
          "649-2535",
          "649-2522",
          "649-2100",
          "649-2105",
          "649-2103",
          "649-2107",
          "649-2104",
          "649-2102",
          "649-2101",
          "649-2108",
          "649-2106",
          "649-2600",
          "649-3142",
          "649-3151",
          "649-3153",
          "649-2602",
          "649-2603",
          "649-2612",
          "649-2601",
          "649-3143",
          "649-3162",
          "649-3161",
          "649-3165",
          "649-3163",
          "649-3166",
          "649-3168",
          "649-3164",
          "649-3167",
          "649-3169",
          "649-2621",
          "649-2631",
          "649-3152",
          "649-3141",
          "649-2604",
          "649-2611",
          "649-5300",
          "649-5332",
          "649-5133",
          "649-5303",
          "649-5302",
          "649-5339",
          "649-5141",
          "649-5312",
          "649-5145",
          "649-5461",
          "649-5466",
          "649-5334",
          "649-5304",
          "649-5333",
          "649-5313",
          "649-5451",
          "649-5454",
          "649-5311",
          "649-5135",
          "649-5452",
          "649-5137",
          "649-5144",
          "649-5465",
          "649-5142",
          "649-5148",
          "649-5147",
          "649-5463",
          "649-5462",
          "649-5335",
          "649-5331",
          "649-5146",
          "649-5132",
          "649-5136",
          "649-5301",
          "649-5338",
          "649-5131",
          "649-5337",
          "649-5314",
          "649-5464",
          "649-5134",
          "649-5453",
          "649-5143",
          "649-5336",
          "649-5100",
          "649-5371",
          "649-5171",
          "649-5172",
          "649-4100",
          "649-4235",
          "649-4103",
          "649-4232",
          "649-4453",
          "649-4105",
          "649-4214",
          "649-4225",
          "649-4451",
          "649-4215",
          "649-4227",
          "649-4101",
          "649-4223",
          "649-4102",
          "649-4452",
          "649-4216",
          "649-4211",
          "649-4442",
          "649-4562",
          "649-4441",
          "649-4104",
          "649-4224",
          "649-4212",
          "649-4233",
          "649-4236",
          "649-4106",
          "649-4231",
          "649-4221",
          "649-4444",
          "649-4454",
          "649-4565",
          "649-4213",
          "649-4561",
          "649-4222",
          "649-4563",
          "649-4564",
          "649-4443",
          "649-4455",
          "649-4234",
          "649-4226",
          "649-4217",
          "647-1600",
          "647-1603",
          "647-1605",
          "647-1604",
          "647-1602",
          "647-1601",
          "649-3500",
          "649-3514",
          "649-3518",
          "649-4124",
          "649-3501",
          "649-4114",
          "649-3521",
          "649-3633",
          "649-3631",
          "649-4111",
          "649-3511",
          "649-3503",
          "649-4115",
          "649-4123",
          "649-3524",
          "649-4117",
          "649-3510",
          "649-3502",
          "649-3632",
          "649-3513",
          "649-3522",
          "649-3515",
          "649-3516",
          "649-4112",
          "649-4113",
          "649-4116",
          "649-3512",
          "649-4122",
          "649-3517",
          "649-4125",
          "649-4126",
          "649-4121",
          "649-3523",
          "680-0000",
          "680-0805",
          "680-0802",
          "689-0501",
          "689-0535",
          "689-0518",
          "689-0519",
          "689-0516",
          "689-0526",
          "689-0522",
          "689-0515",
          "689-0532",
          "689-0533",
          "689-0527",
          "689-0513",
          "689-0529",
          "689-0537",
          "689-0528",
          "689-0525",
          "689-0521",
          "689-0536",
          "689-0531",
          "689-0524",
          "689-0517",
          "689-0523",
          "689-0514",
          "689-0512",
          "689-0534",
          "689-0511",
          "680-0902",
          "680-1146",
          "680-1166",
          "680-1176",
          "680-1164",
          "680-0822",
          "680-0081",
          "680-1157",
          "680-0931",
          "680-1422",
          "680-0015",
          "689-0205",
          "680-0834",
          "680-0013",
          "680-0901",
          "680-0055",
          "680-0005",
          "680-1144",
          "680-0846",
          "680-0043",
          "680-0851",
          "680-1415",
          "680-1437",
          "680-0904",
          "680-0054",
          "680-1427",
          "680-0855",
          "680-0044",
          "689-1117",
          "680-0003",
          "680-0041",
          "689-1115",
          "680-0052",
          "680-0023",
          "689-1104",
          "680-1417",
          "689-1114",
          "680-1439",
          "680-0874",
          "680-1167",
          "680-0047",
          "680-1156",
          "680-1421",
          "680-0905",
          "680-0907",
          "680-0908",
          "680-0909",
          "680-0036",
          "680-1208",
          "680-1203",
          "680-1205",
          "680-1225",
          "680-1245",
          "680-1253",
          "680-1232",
          "680-1204",
          "680-1216",
          "680-1251",
          "680-1254",
          "680-1234",
          "680-1207",
          "680-1243",
          "680-1213",
          "680-1242",
          "680-1223",
          "680-1212",
          "680-1224",
          "680-1241",
          "680-1209",
          "680-1222",
          "680-1201",
          "680-1202",
          "680-1252",
          "680-1244",
          "680-1206",
          "680-1246",
          "680-1211",
          "680-1231",
          "680-1233",
          "680-1214",
          "680-1221",
          "680-1215",
          "680-0821",
          "680-0004",
          "680-1172",
          "680-0824",
          "680-1132",
          "680-0862",
          "680-1141",
          "680-0012",
          "689-0343",
          "689-0355",
          "689-0211",
          "689-0341",
          "689-0332",
          "689-0214",
          "689-0344",
          "689-0334",
          "689-0353",
          "689-0217",
          "689-0224",
          "689-0221",
          "689-0356",
          "689-0213",
          "689-0226",
          "689-0333",
          "689-0352",
          "689-0212",
          "689-0225",
          "689-0342",
          "689-0215",
          "689-0222",
          "689-0223",
          "689-0331",
          "689-0216",
          "689-0354",
          "689-0357",
          "689-0345",
          "689-0351",
          "680-0024",
          "680-1133",
          "689-1124",
          "680-1425",
          "680-0844",
          "680-1177",
          "680-0142",
          "680-0201",
          "680-0216",
          "680-0136",
          "680-8062",
          "680-0202",
          "680-0203",
          "680-0144",
          "680-8063",
          "680-0214",
          "680-0213",
          "680-0221",
          "680-0208",
          "680-0132",
          "680-0155",
          "680-0154",
          "680-0205",
          "680-0207",
          "680-8066",
          "680-8065",
          "680-0211",
          "680-0134",
          "680-0131",
          "680-0135",
          "680-0143",
          "680-0156",
          "680-0152",
          "680-0206",
          "680-0222",
          "680-0223",
          "680-0204",
          "680-0226",
          "680-0145",
          "680-8064",
          "680-0153",
          "680-0146",
          "680-0224",
          "680-0141",
          "680-0151",
          "680-0215",
          "680-0133",
          "680-0225",
          "680-0212",
          "689-1125",
          "680-0073",
          "689-0207",
          "680-0932",
          "680-0813",
          "680-0946",
          "680-0942",
          "680-0947",
          "680-0945",
          "680-0941",
          "680-0021",
          "680-0823",
          "680-0831",
          "680-0853",
          "689-1304",
          "689-1324",
          "689-1301",
          "689-1313",
          "689-1314",
          "689-1303",
          "689-1321",
          "689-1302",
          "689-1312",
          "689-1322",
          "689-1307",
          "689-1311",
          "689-1326",
          "689-1325",
          "689-1315",
          "689-1316",
          "689-1306",
          "689-1305",
          "689-1323",
          "680-0935",
          "689-0425",
          "689-0422",
          "689-0421",
          "689-0412",
          "689-0413",
          "689-0405",
          "689-0411",
          "689-0403",
          "689-0426",
          "689-0402",
          "689-0423",
          "689-0401",
          "689-0404",
          "689-0424",
          "680-1151",
          "680-1174",
          "680-1411",
          "680-1165",
          "680-1154",
          "680-1414",
          "680-0912",
          "689-1103",
          "680-0017",
          "680-0922",
          "680-0854",
          "680-0056",
          "680-0861",
          "680-0812",
          "680-0035",
          "680-0833",
          "689-1101",
          "680-0875",
          "680-1435",
          "680-1432",
          "680-1418",
          "680-0863",
          "680-1416",
          "680-0045",
          "680-0072",
          "680-1162",
          "680-0804",
          "680-0061",
          "680-1152",
          "680-0943",
          "680-0032",
          "680-0911",
          "689-1102",
          "680-0053",
          "680-0803",
          "680-0847",
          "680-0934",
          "680-0933",
          "680-0845",
          "689-1106",
          "680-1155",
          "680-0016",
          "680-1175",
          "680-1436",
          "689-1121",
          "680-0033",
          "680-1173",
          "680-1145",
          "689-1107",
          "680-0811",
          "680-0022",
          "689-1113",
          "680-1413",
          "680-0924",
          "689-0206",
          "680-1142",
          "680-1153",
          "680-1143",
          "680-0923",
          "680-1131",
          "680-0014",
          "680-0001",
          "680-0002",
          "680-0852",
          "689-1105",
          "680-0835",
          "680-0011",
          "689-1123",
          "689-1116",
          "680-1438",
          "689-0106",
          "689-0101",
          "680-8021",
          "689-0113",
          "689-0112",
          "689-0111",
          "680-8022",
          "689-0114",
          "689-0103",
          "689-0116",
          "689-0117",
          "689-0102",
          "689-0115",
          "689-0104",
          "689-0105",
          "689-0201",
          "680-0944",
          "689-1122",
          "680-0865",
          "680-0921",
          "680-0074",
          "680-0042",
          "680-1426",
          "680-1434",
          "680-0031",
          "680-1424",
          "680-1423",
          "680-0801",
          "680-1444",
          "680-0873",
          "680-0006",
          "689-0204",
          "689-0203",
          "680-0915",
          "680-0906",
          "680-0903",
          "680-0814",
          "680-0914",
          "680-0843",
          "689-0202",
          "680-1412",
          "680-0872",
          "680-1428",
          "680-1431",
          "689-1126",
          "680-1161",
          "689-1215",
          "689-1214",
          "689-1227",
          "689-1222",
          "689-1229",
          "689-1223",
          "689-1226",
          "689-1224",
          "689-1213",
          "689-1221",
          "689-1211",
          "689-1212",
          "689-1225",
          "689-1201",
          "689-1228",
          "680-0034",
          "680-0046",
          "680-1171",
          "680-0037",
          "680-0071",
          "680-0806",
          "680-0913",
          "680-1433",
          "680-0008",
          "680-0832",
          "680-0007",
          "680-1163",
          "680-1442",
          "680-0842",
          "680-0841",
          "680-0062",
          "680-1441",
          "680-0864",
          "680-0871",
          "680-1443",
          "680-0051",
          "689-1112",
          "689-1111",
          "683-0000",
          "683-0252",
          "689-3515",
          "683-0813",
          "683-0046",
          "683-0846",
          "683-0021",
          "689-3512",
          "689-3533",
          "689-3542",
          "683-0833",
          "683-0027",
          "683-0834",
          "689-3544",
          "683-0257",
          "683-0104",
          "683-0101",
          "683-0045",
          "683-0256",
          "689-3513",
          "683-0016",
          "689-3514",
          "683-0814",
          "683-0003",
          "683-0001",
          "683-0002",
          "683-0812",
          "683-0251",
          "683-0255",
          "683-0841",
          "689-3532",
          "683-0004",
          "683-0823",
          "689-3543",
          "689-3521",
          "683-0852",
          "683-0051",
          "683-0007",
          "683-0009",
          "683-0047",
          "683-0844",
          "683-0825",
          "689-3522",
          "683-0006",
          "683-0008",
          "689-3546",
          "683-0824",
          "683-0054",
          "683-0062",
          "689-3537",
          "683-0842",
          "683-0042",
          "683-0253",
          "689-3531",
          "689-3511",
          "683-0037",
          "683-0801",
          "683-0043",
          "683-0013",
          "689-3524",
          "683-0044",
          "689-3536",
          "683-0832",
          "683-0041",
          "683-0831",
          "683-0821",
          "683-0064",
          "683-0103",
          "683-0005",
          "683-0822",
          "683-0014",
          "683-0033",
          "683-0022",
          "683-0835",
          "683-0026",
          "683-0811",
          "683-0816",
          "683-0826",
          "683-0805",
          "689-3541",
          "683-0052",
          "683-0023",
          "683-0845",
          "683-0836",
          "683-0815",
          "683-0067",
          "683-0802",
          "683-0031",
          "689-3535",
          "683-0855",
          "683-0854",
          "683-0803",
          "683-0066",
          "683-0015",
          "683-0011",
          "689-3523",
          "683-0055",
          "683-0025",
          "683-0254",
          "683-0063",
          "683-0065",
          "689-3534",
          "683-0843",
          "683-0034",
          "683-0017",
          "683-0053",
          "683-0035",
          "683-0036",
          "683-0012",
          "683-0032",
          "689-3545",
          "683-0024",
          "683-0105",
          "683-0061",
          "689-3412",
          "689-3401",
          "689-3423",
          "689-3425",
          "689-3418",
          "689-3415",
          "689-3417",
          "689-3424",
          "689-3414",
          "689-3403",
          "689-3422",
          "689-3416",
          "689-3411",
          "689-3421",
          "689-3413",
          "689-3402",
          "683-0804",
          "683-0851",
          "689-3547",
          "683-0853",
          "683-0102",
          "682-0000",
          "682-0822",
          "682-0021",
          "682-0022",
          "682-0871",
          "682-0001",
          "682-0901",
          "682-0024",
          "682-0855",
          "682-0933",
          "682-0006",
          "682-0641",
          "682-0801",
          "682-0842",
          "682-0821",
          "682-0811",
          "682-0865",
          "682-0813",
          "682-0623",
          "682-0947",
          "682-0632",
          "682-0941",
          "682-0948",
          "682-0011",
          "682-0042",
          "682-0841",
          "682-0645",
          "682-0931",
          "682-0607",
          "682-0034",
          "682-0904",
          "682-0014",
          "682-0016",
          "682-0015",
          "682-0864",
          "682-0902",
          "682-0621",
          "682-0875",
          "682-0041",
          "682-0631",
          "682-0642",
          "682-0934",
          "682-0032",
          "682-0602",
          "682-0923",
          "682-0846",
          "682-0633",
          "682-0924",
          "682-0857",
          "682-0903",
          "682-0932",
          "682-0033",
          "682-0945",
          "682-0942",
          "682-0035",
          "682-0883",
          "682-0943",
          "682-0867",
          "682-0044",
          "682-0045",
          "682-0807",
          "682-0885",
          "682-0634",
          "682-0606",
          "682-0613",
          "682-0837",
          "682-0812",
          "682-0643",
          "682-0005",
          "682-0031",
          "682-0601",
          "682-0925",
          "682-0926",
          "682-0806",
          "682-0003",
          "682-0861",
          "682-0815",
          "682-0952",
          "682-0611",
          "682-0843",
          "682-0817",
          "682-0012",
          "682-0017",
          "682-0401",
          "682-0421",
          "682-0402",
          "682-0433",
          "682-0413",
          "682-0411",
          "682-0404",
          "682-0434",
          "682-0432",
          "682-0422",
          "682-0403",
          "682-0423",
          "682-0412",
          "682-0431",
          "682-0863",
          "682-0886",
          "682-0816",
          "682-0626",
          "682-0954",
          "682-0951",
          "682-0911",
          "682-0043",
          "682-0884",
          "682-0832",
          "682-0002",
          "682-0856",
          "682-0612",
          "682-0824",
          "682-0836",
          "682-0835",
          "682-0622",
          "682-0874",
          "682-0851",
          "682-0825",
          "682-0921",
          "682-0862",
          "682-0036",
          "682-0831",
          "682-0635",
          "682-0953",
          "682-0914",
          "682-0624",
          "682-0802",
          "682-0873",
          "682-0834",
          "682-0833",
          "682-0804",
          "682-0826",
          "682-0823",
          "682-0844",
          "682-0866",
          "682-0644",
          "682-0605",
          "682-0013",
          "682-0018",
          "682-0944",
          "682-0604",
          "682-0922",
          "682-0847",
          "682-0872",
          "682-0915",
          "682-0004",
          "682-0905",
          "682-0852",
          "682-0603",
          "682-0854",
          "682-0882",
          "682-0805",
          "682-0845",
          "682-0881",
          "682-0803",
          "682-0887",
          "682-0625",
          "682-0615",
          "682-0025",
          "682-0023",
          "682-0946",
          "682-0853",
          "682-0814",
          "682-0912",
          "682-0913",
          "684-0000",
          "684-0011",
          "684-0033",
          "684-0013",
          "684-0006",
          "684-0023",
          "684-0056",
          "684-0053",
          "684-0055",
          "684-0054",
          "684-0064",
          "684-0074",
          "684-0015",
          "684-0066",
          "684-0001",
          "684-0034",
          "684-0026",
          "684-0063",
          "684-0004",
          "684-0045",
          "684-0046",
          "684-0043",
          "684-0071",
          "684-0073",
          "684-0041",
          "684-0012",
          "684-0051",
          "684-0075",
          "684-0014",
          "684-0062",
          "684-0016",
          "684-0021",
          "684-0003",
          "684-0027",
          "684-0024",
          "684-0042",
          "684-0025",
          "684-0005",
          "684-0017",
          "684-0031",
          "684-0044",
          "684-0052",
          "684-0022",
          "684-0032",
          "684-0065",
          "684-0002",
          "684-0076",
          "684-0061",
          "684-0072",
          "681-0000",
          "681-0002",
          "681-0036",
          "681-0074",
          "681-0032",
          "681-0055",
          "681-0047",
          "681-0024",
          "681-0052",
          "681-0072",
          "681-0054",
          "681-0025",
          "681-0003",
          "681-0046",
          "681-0043",
          "681-0063",
          "681-0073",
          "681-0014",
          "681-0042",
          "681-0062",
          "681-0031",
          "681-0045",
          "681-0051",
          "681-0034",
          "681-0011",
          "681-0041",
          "681-0013",
          "681-0022",
          "681-0053",
          "681-0061",
          "681-0071",
          "681-0012",
          "681-0056",
          "681-0044",
          "681-0033",
          "681-0021",
          "681-0065",
          "681-0035",
          "681-0064",
          "681-0001",
          "681-0023",
          "680-0700",
          "680-0713",
          "680-0722",
          "680-0743",
          "680-0731",
          "680-0741",
          "680-0733",
          "680-0735",
          "680-0734",
          "680-0742",
          "680-0714",
          "680-0723",
          "680-0745",
          "680-0712",
          "680-0728",
          "680-0732",
          "680-0724",
          "680-0744",
          "680-0726",
          "680-0711",
          "680-0727",
          "680-0715",
          "680-0721",
          "680-0725",
          "680-0746",
          "680-0701",
          "689-1400",
          "689-1412",
          "689-1401",
          "689-1404",
          "689-1465",
          "689-1451",
          "689-1421",
          "689-1442",
          "689-1413",
          "689-1452",
          "689-1422",
          "689-1436",
          "689-1464",
          "689-1467",
          "689-1441",
          "689-1416",
          "689-1454",
          "689-1415",
          "689-1424",
          "689-1461",
          "689-1417",
          "689-1468",
          "689-1402",
          "689-1462",
          "689-1423",
          "689-1463",
          "689-1455",
          "689-1426",
          "689-1414",
          "689-1444",
          "689-1466",
          "689-1433",
          "689-1445",
          "689-1453",
          "689-1425",
          "689-1432",
          "689-1443",
          "689-1437",
          "689-1403",
          "689-1434",
          "689-1411",
          "689-1431",
          "689-1435",
          "680-0400",
          "680-0302",
          "680-0305",
          "680-0452",
          "680-0425",
          "680-0454",
          "680-0442",
          "680-0311",
          "680-0424",
          "680-0537",
          "680-0434",
          "680-0416",
          "680-0435",
          "680-0427",
          "680-0543",
          "680-0303",
          "680-0426",
          "680-0533",
          "680-0545",
          "680-0312",
          "680-0534",
          "680-0422",
          "680-0313",
          "680-0401",
          "680-0432",
          "680-0601",
          "680-0526",
          "680-0457",
          "680-0451",
          "680-0443",
          "680-0461",
          "680-0523",
          "680-0531",
          "680-0473",
          "680-0527",
          "680-0544",
          "680-0316",
          "680-0413",
          "680-0606",
          "680-0407",
          "680-0612",
          "680-0605",
          "680-0421",
          "680-0314",
          "680-0415",
          "680-0472",
          "680-0431",
          "680-0522",
          "680-0541",
          "680-0445",
          "680-0607",
          "680-0611",
          "680-0614",
          "680-0408",
          "680-0441",
          "680-0306",
          "680-0414",
          "680-0455",
          "680-0444",
          "680-0437",
          "680-0402",
          "680-0405",
          "680-0613",
          "680-0532",
          "680-0603",
          "680-0301",
          "680-0403",
          "680-0307",
          "680-0462",
          "680-0471",
          "680-0411",
          "680-0315",
          "680-0423",
          "680-0453",
          "680-0536",
          "680-0406",
          "680-0404",
          "680-0412",
          "680-0604",
          "680-0463",
          "680-0535",
          "680-0524",
          "680-0542",
          "680-0521",
          "680-0436",
          "680-0304",
          "680-0438",
          "680-0433",
          "680-0602",
          "680-0525",
          "680-0456",
          "680-0474",
          "682-0100",
          "682-0172",
          "682-0303",
          "682-0151",
          "682-0177",
          "682-0121",
          "682-0315",
          "682-0157",
          "682-0173",
          "682-0161",
          "682-0135",
          "682-0302",
          "682-0154",
          "682-0313",
          "682-0142",
          "682-0301",
          "682-0375",
          "682-0123",
          "682-0136",
          "682-0133",
          "682-0156",
          "682-0312",
          "682-0316",
          "682-0176",
          "682-0124",
          "682-0374",
          "682-0146",
          "682-0314",
          "682-0131",
          "682-0158",
          "682-0153",
          "682-0125",
          "682-0141",
          "682-0162",
          "682-0145",
          "682-0144",
          "682-0143",
          "682-0159",
          "682-0317",
          "682-0311",
          "682-0163",
          "682-0178",
          "682-0132",
          "682-0152",
          "682-0122",
          "682-0171",
          "682-0155",
          "682-0134",
          "682-0700",
          "682-0714",
          "689-0721",
          "689-0713",
          "689-0602",
          "689-0733",
          "689-0607",
          "682-0701",
          "689-0702",
          "689-0729",
          "689-0724",
          "689-0736",
          "682-0712",
          "682-0703",
          "689-0722",
          "689-0701",
          "689-0726",
          "689-0603",
          "689-0735",
          "682-0711",
          "689-0704",
          "689-0605",
          "689-0723",
          "682-0721",
          "689-0727",
          "689-0712",
          "689-0604",
          "689-0601",
          "689-0737",
          "689-0732",
          "689-0705",
          "689-0731",
          "682-0702",
          "689-0734",
          "689-0606",
          "682-0715",
          "682-0722",
          "689-0715",
          "682-0723",
          "689-0728",
          "689-0706",
          "689-0725",
          "689-0703",
          "689-0711",
          "682-0724",
          "682-0713",
          "682-0704",
          "689-0707",
          "689-0714",
          "689-2300",
          "689-2501",
          "689-2511",
          "689-2543",
          "689-2352",
          "689-2344",
          "689-2304",
          "689-2524",
          "689-2535",
          "689-2306",
          "689-2512",
          "689-2312",
          "689-2315",
          "689-2342",
          "689-2341",
          "689-2355",
          "689-2531",
          "689-2334",
          "689-2316",
          "689-2314",
          "689-2331",
          "689-2313",
          "689-2532",
          "689-2523",
          "689-2521",
          "689-2356",
          "689-2305",
          "689-2303",
          "689-2311",
          "689-2335",
          "689-2533",
          "689-2513",
          "689-2336",
          "689-2346",
          "689-2544",
          "689-2322",
          "689-2345",
          "689-2332",
          "689-2502",
          "689-2333",
          "689-2351",
          "689-2325",
          "689-2503",
          "689-2302",
          "689-2534",
          "689-2326",
          "689-2353",
          "689-2522",
          "689-2323",
          "689-2354",
          "689-2321",
          "689-2324",
          "689-2301",
          "689-2525",
          "689-2343",
          "689-2541",
          "689-2542",
          "689-2200",
          "689-2216",
          "689-2101",
          "689-2206",
          "689-2223",
          "689-2213",
          "689-2211",
          "689-2114",
          "689-2102",
          "689-2212",
          "689-2105",
          "689-2205",
          "689-2103",
          "689-2224",
          "689-2201",
          "689-2215",
          "689-2207",
          "689-2111",
          "689-2203",
          "689-2202",
          "689-2214",
          "689-2112",
          "689-2204",
          "689-2115",
          "689-2106",
          "689-2208",
          "689-2104",
          "689-2221",
          "689-2113",
          "689-3500",
          "689-3551",
          "689-3552",
          "689-3553",
          "689-3200",
          "689-3111",
          "689-3319",
          "689-3334",
          "689-3314",
          "689-3102",
          "689-3302",
          "689-3124",
          "689-3226",
          "689-3121",
          "689-3225",
          "689-3214",
          "689-3305",
          "689-3308",
          "689-3309",
          "689-3202",
          "689-3203",
          "689-3222",
          "689-3115",
          "689-3313",
          "689-3122",
          "689-3125",
          "689-3112",
          "689-3323",
          "689-3335",
          "689-3332",
          "689-3331",
          "689-3123",
          "689-3133",
          "689-3318",
          "689-3224",
          "689-3134",
          "689-3317",
          "689-3114",
          "689-3223",
          "689-3101",
          "689-3105",
          "689-3333",
          "689-3303",
          "689-3135",
          "689-3325",
          "689-3221",
          "689-3201",
          "689-3316",
          "689-3322",
          "689-3306",
          "689-3136",
          "689-3212",
          "689-3205",
          "689-3307",
          "689-3106",
          "689-3204",
          "689-3103",
          "689-3321",
          "689-3304",
          "689-3336",
          "689-3301",
          "689-3312",
          "689-3315",
          "689-3132",
          "689-3211",
          "689-3113",
          "689-3311",
          "689-3324",
          "689-3213",
          "689-3104",
          "689-3327",
          "689-3326",
          "683-0300",
          "683-0322",
          "683-0227",
          "683-0216",
          "683-0218",
          "683-0222",
          "683-0223",
          "683-0367",
          "683-0345",
          "683-0215",
          "683-0337",
          "683-0331",
          "683-0224",
          "683-0344",
          "683-0341",
          "683-0361",
          "683-0364",
          "683-0356",
          "683-0311",
          "683-0321",
          "683-0343",
          "683-0226",
          "683-0354",
          "683-0214",
          "683-0217",
          "683-0202",
          "683-0201",
          "683-0355",
          "683-0334",
          "683-0353",
          "683-0335",
          "683-0365",
          "683-0363",
          "683-0213",
          "683-0302",
          "683-0342",
          "683-0332",
          "683-0352",
          "683-0362",
          "683-0301",
          "683-0204",
          "683-0312",
          "683-0336",
          "683-0351",
          "683-0211",
          "683-0225",
          "683-0203",
          "683-0221",
          "683-0212",
          "683-0333",
          "683-0323",
          "683-0366",
          "689-4100",
          "689-4214",
          "689-4123",
          "689-4212",
          "689-4207",
          "689-4134",
          "689-4215",
          "689-4211",
          "689-4205",
          "689-4226",
          "689-4222",
          "689-4121",
          "689-4102",
          "689-4135",
          "689-4113",
          "689-4213",
          "689-4112",
          "689-4132",
          "689-4203",
          "689-4111",
          "689-4105",
          "689-4106",
          "689-4101",
          "689-4115",
          "689-4122",
          "689-4246",
          "689-4243",
          "689-4225",
          "689-4107",
          "689-4217",
          "689-4114",
          "689-4204",
          "689-4244",
          "689-4223",
          "689-4221",
          "689-4241",
          "689-4202",
          "689-4233",
          "689-4224",
          "689-4234",
          "689-4104",
          "689-4237",
          "689-4235",
          "689-4136",
          "689-4216",
          "689-4232",
          "689-4245",
          "689-4231",
          "689-4242",
          "689-4103",
          "689-4108",
          "689-4201",
          "689-4206",
          "689-4236",
          "689-4131",
          "689-4133",
          "689-5200",
          "689-5551",
          "689-5531",
          "689-5534",
          "689-5543",
          "689-5212",
          "689-5662",
          "689-5663",
          "689-5223",
          "689-5672",
          "689-5221",
          "689-5541",
          "689-5552",
          "689-5665",
          "689-5211",
          "689-5532",
          "689-5533",
          "689-5224",
          "689-5544",
          "689-5673",
          "689-5664",
          "689-5225",
          "689-5222",
          "689-5661",
          "689-5545",
          "689-5671",
          "689-5542",
          "689-5213",
          "689-5214",
          "689-5216",
          "689-5666",
          "689-5215",
          "689-5226",
          "689-4500",
          "689-4515",
          "689-4513",
          "689-4523",
          "689-5136",
          "689-4501",
          "689-4516",
          "689-5137",
          "689-4512",
          "689-5132",
          "689-5131",
          "689-4511",
          "689-4525",
          "689-4526",
          "689-5133",
          "689-5134",
          "689-4521",
          "689-5135",
          "689-4517",
          "689-4503",
          "689-4504",
          "689-4505",
          "689-4524",
          "689-4522",
          "689-4502",
          "689-4514",
          "689-4527",
          "689-4400",
          "689-4401",
          "689-4434",
          "689-4435",
          "689-4432",
          "689-4403",
          "689-4402",
          "689-4425",
          "689-4431",
          "689-4412",
          "689-4413",
          "689-4422",
          "689-4426",
          "689-4414",
          "689-4424",
          "689-4421",
          "689-4423",
          "689-4411",
          "689-4433",
          "690-0000",
          "690-0261",
          "690-0022",
          "690-0015",
          "690-0834",
          "690-0003",
          "690-0027",
          "690-0881",
          "690-0006",
          "690-0034",
          "690-0062",
          "690-0869",
          "690-0131",
          "690-0873",
          "690-1115",
          "690-0832",
          "690-0263",
          "690-0032",
          "690-0264",
          "690-0033",
          "690-0831",
          "690-0262",
          "690-0872",
          "690-0007",
          "690-0266",
          "690-0848",
          "690-0825",
          "690-0826",
          "690-0322",
          "690-0324",
          "690-0801",
          "690-0804",
          "690-0333",
          "690-0332",
          "690-0331",
          "690-0321",
          "690-0323",
          "690-0411",
          "690-0802",
          "690-0803",
          "690-0877",
          "690-0847",
          "690-1104",
          "690-0265",
          "690-0867",
          "690-0821",
          "690-1102",
          "690-0812",
          "690-0883",
          "690-0888",
          "690-0859",
          "690-0876",
          "690-0121",
          "690-0012",
          "690-0013",
          "690-0151",
          "690-0856",
          "690-0056",
          "690-0041",
          "690-0042",
          "690-0813",
          "690-0035",
          "690-0402",
          "690-0401",
          "690-1213",
          "690-1211",
          "690-1212",
          "690-0866",
          "690-0822",
          "690-0141",
          "690-0868",
          "690-0061",
          "690-0054",
          "699-0407",
          "699-0405",
          "699-0406",
          "699-0408",
          "699-0401",
          "699-0403",
          "699-0402",
          "699-0404",
          "690-1103",
          "690-0057",
          "690-0846",
          "690-0843",
          "690-0824",
          "690-0878",
          "690-0049",
          "690-0875",
          "690-0002",
          "690-0882",
          "690-1113",
          "690-0052",
          "699-0205",
          "699-0201",
          "699-0204",
          "699-0203",
          "699-0202",
          "690-0058",
          "690-0023",
          "690-0852",
          "690-0055",
          "690-0063",
          "690-0064",
          "690-0851",
          "690-0887",
          "690-0874",
          "690-1112",
          "690-0065",
          "690-0854",
          "690-0865",
          "690-0037",
          "690-0835",
          "690-0823",
          "690-0142",
          "690-0845",
          "690-0017",
          "690-0132",
          "690-0122",
          "690-0860",
          "690-0815",
          "690-0048",
          "690-0046",
          "690-0045",
          "690-1114",
          "690-0004",
          "690-0855",
          "690-0044",
          "690-0001",
          "690-0864",
          "699-0108",
          "699-0111",
          "699-0112",
          "699-0107",
          "699-0101",
          "699-0105",
          "699-0106",
          "699-0103",
          "699-0102",
          "699-0104",
          "699-0110",
          "699-0109",
          "690-0036",
          "690-0871",
          "690-0844",
          "690-0011",
          "690-0133",
          "690-0842",
          "690-0814",
          "690-0862",
          "690-0863",
          "690-0833",
          "690-0811",
          "690-0026",
          "690-0038",
          "690-0816",
          "690-0861",
          "690-0886",
          "690-0053",
          "690-1101",
          "690-0024",
          "690-1111",
          "690-0043",
          "690-0884",
          "690-1223",
          "690-1315",
          "690-1221",
          "690-1502",
          "690-1311",
          "690-1313",
          "690-1314",
          "690-1222",
          "690-1504",
          "690-1501",
          "690-1505",
          "690-1312",
          "690-1503",
          "690-0841",
          "690-0014",
          "690-2104",
          "690-2103",
          "690-2102",
          "690-2101",
          "690-2105",
          "690-0021",
          "690-1401",
          "690-1403",
          "690-1408",
          "690-1407",
          "690-1405",
          "690-1404",
          "690-1406",
          "690-1402",
          "690-0031",
          "690-0025",
          "690-0051",
          "690-0885",
          "690-0047",
          "690-0005",
          "697-0000",
          "697-0034",
          "697-0022",
          "697-0514",
          "697-0425",
          "697-0427",
          "697-0512",
          "697-0513",
          "697-0431",
          "697-0423",
          "697-0511",
          "697-0422",
          "697-0426",
          "697-0421",
          "697-0424",
          "697-0033",
          "697-0062",
          "697-1334",
          "697-1335",
          "697-0032",
          "697-0011",
          "697-0064",
          "697-1323",
          "697-0312",
          "695-0102",
          "697-0002",
          "697-0044",
          "695-0103",
          "697-0053",
          "697-1338",
          "697-0061",
          "697-0041",
          "697-0302",
          "697-0305",
          "697-0304",
          "697-0301",
          "697-0213",
          "697-0122",
          "697-0303",
          "697-0123",
          "697-0121",
          "697-0212",
          "697-0211",
          "697-0005",
          "697-0045",
          "697-0004",
          "697-0024",
          "697-0007",
          "697-0012",
          "697-0003",
          "697-0031",
          "697-0043",
          "697-0311",
          "697-0013",
          "697-0047",
          "695-0101",
          "697-0006",
          "697-0046",
          "697-0037",
          "697-0035",
          "697-1321",
          "697-0051",
          "697-0057",
          "697-0054",
          "697-0015",
          "697-1332",
          "697-0026",
          "697-1326",
          "697-1327",
          "697-0036",
          "697-0001",
          "697-0027",
          "697-0065",
          "697-1331",
          "697-0023",
          "697-0063",
          "697-0014",
          "697-1333",
          "697-0042",
          "697-1337",
          "697-0016",
          "697-0017",
          "697-0056",
          "697-1322",
          "697-0025",
          "697-1324",
          "697-0021",
          "699-3302",
          "699-3215",
          "699-3301",
          "699-3226",
          "699-3222",
          "699-3216",
          "699-3217",
          "699-3213",
          "699-3223",
          "699-3221",
          "699-3225",
          "699-3211",
          "699-3224",
          "699-3212",
          "699-3303",
          "699-3214",
          "697-0052",
          "697-0055",
          "697-1215",
          "697-1214",
          "697-1202",
          "697-1204",
          "697-1122",
          "697-1203",
          "697-1123",
          "697-1201",
          "697-1211",
          "697-1121",
          "697-1213",
          "697-1212",
          "697-1336",
          "697-1325",
          "693-0000",
          "693-0213",
          "693-0035",
          "693-0044",
          "693-0027",
          "693-0071",
          "691-0024",
          "693-0001",
          "693-0002",
          "693-0003",
          "691-0042",
          "693-0105",
          "693-0007",
          "693-0008",
          "693-0017",
          "693-0056",
          "693-0023",
          "693-0024",
          "693-0028",
          "693-0021",
          "693-0025",
          "693-0026",
          "699-0821",
          "693-0015",
          "693-0063",
          "693-0012",
          "693-0011",
          "691-0063",
          "693-0013",
          "691-0021",
          "693-0216",
          "693-0051",
          "691-0043",
          "693-0022",
          "691-0064",
          "693-0101",
          "691-0023",
          "691-0025",
          "693-0034",
          "693-0072",
          "691-0034",
          "691-0014",
          "691-0011",
          "691-0052",
          "691-0074",
          "693-0031",
          "691-0041",
          "699-0817",
          "699-0816",
          "699-0811",
          "699-0813",
          "699-0814",
          "699-0812",
          "699-0815",
          "691-0015",
          "691-0051",
          "693-0501",
          "693-0504",
          "693-0526",
          "693-0521",
          "693-0523",
          "693-0525",
          "693-0503",
          "693-0524",
          "693-0506",
          "693-0502",
          "693-0512",
          "693-0522",
          "693-0511",
          "693-0505",
          "693-0064",
          "691-0044",
          "691-0004",
          "693-0032",
          "693-0046",
          "693-0006",
          "699-0822",
          "699-0825",
          "693-0042",
          "691-0076",
          "699-0762",
          "699-0764",
          "699-0722",
          "699-0702",
          "699-0751",
          "699-0701",
          "699-0711",
          "699-0761",
          "699-0721",
          "699-0741",
          "699-0732",
          "699-0733",
          "699-0763",
          "699-0731",
          "693-0066",
          "693-0053",
          "699-0905",
          "699-0903",
          "699-0906",
          "699-0904",
          "699-0901",
          "699-0902",
          "691-0062",
          "691-0061",
          "693-0014",
          "693-0033",
          "691-0071",
          "693-0029",
          "693-0057",
          "693-0005",
          "691-0065",
          "691-0031",
          "693-0214",
          "693-0062",
          "693-0081",
          "693-0082",
          "693-0043",
          "691-0003",
          "699-0824",
          "693-0037",
          "693-0041",
          "691-0012",
          "693-0102",
          "693-0073",
          "691-0002",
          "691-0066",
          "691-0072",
          "693-0103",
          "693-0054",
          "693-0104",
          "699-0823",
          "693-0045",
          "693-0074",
          "699-0615",
          "699-0611",
          "699-0644",
          "699-0551",
          "699-0501",
          "699-0505",
          "699-0624",
          "699-0503",
          "699-0613",
          "699-0614",
          "699-0553",
          "699-0555",
          "699-0554",
          "699-0612",
          "699-0502",
          "699-0621",
          "699-0623",
          "699-0631",
          "699-0552",
          "699-0622",
          "699-0643",
          "699-0642",
          "699-0504",
          "699-0641",
          "693-0068",
          "693-0061",
          "691-0001",
          "693-0065",
          "693-0106",
          "693-0036",
          "691-0022",
          "691-0032",
          "693-0211",
          "693-0212",
          "693-0052",
          "691-0033",
          "691-0013",
          "691-0053",
          "691-0045",
          "693-0215",
          "693-0055",
          "693-0058",
          "693-0067",
          "691-0073",
          "691-0075",
          "693-0004",
          "698-0000",
          "699-3672",
          "698-0034",
          "698-0027",
          "698-0025",
          "698-0026",
          "698-2253",
          "698-0022",
          "699-3765",
          "698-0037",
          "699-3761",
          "698-2142",
          "699-5123",
          "698-0014",
          "698-0051",
          "698-2143",
          "698-0413",
          "699-5127",
          "698-0024",
          "699-3674",
          "698-0012",
          "699-3675",
          "698-0003",
          "698-2252",
          "698-2254",
          "699-3501",
          "698-2255",
          "698-0045",
          "698-0047",
          "698-0046",
          "698-2145",
          "699-5133",
          "699-3764",
          "699-3502",
          "698-0013",
          "698-0001",
          "698-2251",
          "699-3762",
          "698-0021",
          "698-0035",
          "699-3503",
          "698-0414",
          "698-0002",
          "698-0007",
          "699-5125",
          "698-2141",
          "698-0036",
          "699-5124",
          "699-5126",
          "698-0011",
          "698-0041",
          "698-0031",
          "699-3504",
          "699-3671",
          "699-3505",
          "698-0016",
          "699-3676",
          "698-0023",
          "699-3763",
          "698-0015",
          "698-2146",
          "698-0044",
          "698-0043",
          "698-0042",
          "698-0412",
          "698-0017",
          "699-3506",
          "698-0411",
          "698-0004",
          "698-1223",
          "698-1213",
          "698-1212",
          "698-1221",
          "698-1211",
          "698-1222",
          "698-1201",
          "699-5121",
          "699-5122",
          "698-0005",
          "698-0032",
          "698-0213",
          "698-0201",
          "698-0202",
          "698-0206",
          "698-0211",
          "698-0214",
          "698-0212",
          "698-0203",
          "698-0207",
          "698-0205",
          "698-0204",
          "699-3766",
          "698-0006",
          "699-5134",
          "698-2144",
          "698-0033",
          "699-5131",
          "699-3673",
          "699-5132",
          "694-0000",
          "699-2213",
          "699-2212",
          "694-0035",
          "694-0433",
          "694-0432",
          "694-0064",
          "694-0062",
          "694-0063",
          "694-0305",
          "694-0033",
          "694-0034",
          "694-0032",
          "694-0012",
          "694-0011",
          "694-0013",
          "694-0052",
          "694-0051",
          "694-0022",
          "694-0024",
          "694-0023",
          "694-0025",
          "694-0021",
          "694-0223",
          "694-0221",
          "694-0224",
          "694-0222",
          "694-0003",
          "694-0004",
          "694-0031",
          "694-0431",
          "699-2214",
          "699-2215",
          "694-0061",
          "699-2216",
          "694-0054",
          "694-0053",
          "694-0042",
          "694-0044",
          "694-0041",
          "694-0043",
          "699-2305",
          "699-2303",
          "699-2302",
          "699-2301",
          "699-2304",
          "699-2211",
          "694-0301",
          "694-0303",
          "694-0302",
          "694-0304",
          "694-0001",
          "694-0002",
          "699-2507",
          "699-2515",
          "699-2505",
          "699-2504",
          "699-2513",
          "699-2511",
          "699-2503",
          "699-2512",
          "699-2506",
          "699-2514",
          "699-2502",
          "699-2501",
          "699-2516",
          "692-0000",
          "692-0001",
          "692-0052",
          "692-0007",
          "692-0066",
          "692-0055",
          "692-0015",
          "692-0065",
          "692-0063",
          "692-0034",
          "692-0057",
          "692-0042",
          "692-0046",
          "692-0045",
          "692-0027",
          "692-0002",
          "692-0043",
          "692-0071",
          "692-0075",
          "692-0026",
          "692-0056",
          "692-0035",
          "692-0033",
          "692-0051",
          "692-0004",
          "692-0032",
          "692-0023",
          "692-0031",
          "692-0062",
          "692-0053",
          "692-0028",
          "692-0024",
          "692-0017",
          "692-0044",
          "692-0021",
          "692-0047",
          "692-0067",
          "692-0013",
          "692-0054",
          "692-0041",
          "692-0074",
          "692-0061",
          "692-0003",
          "692-0006",
          "692-0058",
          "692-0077",
          "692-0036",
          "692-0072",
          "692-0321",
          "692-0213",
          "692-0322",
          "692-0325",
          "692-0324",
          "692-0323",
          "692-0326",
          "692-0214",
          "692-0215",
          "692-0218",
          "692-0212",
          "692-0207",
          "692-0216",
          "692-0203",
          "692-0211",
          "692-0206",
          "692-0202",
          "692-0205",
          "692-0204",
          "692-0201",
          "692-0217",
          "692-0014",
          "692-0016",
          "692-0005",
          "692-0401",
          "692-0622",
          "692-0625",
          "692-0405",
          "692-0732",
          "692-0413",
          "692-0412",
          "692-0411",
          "692-0621",
          "692-0403",
          "692-0624",
          "692-0731",
          "692-0733",
          "692-0404",
          "692-0623",
          "692-0402",
          "692-0064",
          "692-0025",
          "692-0022",
          "692-0012",
          "692-0011",
          "692-0073",
          "692-0037",
          "695-0000",
          "695-0002",
          "695-0152",
          "695-0156",
          "695-0155",
          "695-0154",
          "699-2841",
          "699-3162",
          "695-0016",
          "695-0012",
          "695-0014",
          "695-0013",
          "699-2831",
          "695-0011",
          "699-4221",
          "699-4222",
          "699-4223",
          "699-4224",
          "699-4504",
          "699-4225",
          "699-4502",
          "699-4226",
          "699-4505",
          "699-4501",
          "699-4503",
          "699-4111",
          "699-4431",
          "699-4432",
          "695-0015",
          "695-0153",
          "695-0151",
          "699-2842",
          "695-0021",
          "695-0023",
          "695-0024",
          "695-0022",
          "699-3161",
          "699-2833",
          "699-2834",
          "699-2832",
          "695-0004",
          "695-0007",
          "699-2837",
          "695-0003",
          "699-2835",
          "695-0005",
          "699-2836",
          "695-0006",
          "695-0017",
          "695-0001",
          "690-2400",
          "690-2704",
          "690-2702",
          "690-2701",
          "690-2706",
          "690-2703",
          "690-2705",
          "699-1114",
          "699-1115",
          "699-1105",
          "699-1125",
          "699-1123",
          "699-1106",
          "699-1121",
          "699-1112",
          "699-1111",
          "699-1101",
          "699-1102",
          "699-1103",
          "699-1124",
          "699-1113",
          "699-1122",
          "699-1104",
          "699-1321",
          "699-1331",
          "699-1332",
          "699-1401",
          "699-1341",
          "699-1311",
          "699-1333",
          "699-1322",
          "699-1334",
          "699-1324",
          "699-1323",
          "699-1342",
          "699-1312",
          "699-1343",
          "699-1221",
          "699-1231",
          "699-1213",
          "699-1201",
          "699-1261",
          "699-1211",
          "699-1214",
          "699-1202",
          "699-1222",
          "699-1203",
          "699-1204",
          "699-1241",
          "699-1262",
          "699-1263",
          "699-1223",
          "699-1212",
          "699-1215",
          "699-1251",
          "699-1205",
          "699-1264",
          "699-1242",
          "699-1252",
          "699-1253",
          "699-1216",
          "699-1232",
          "699-1243",
          "699-1233",
          "699-1224",
          "699-1234",
          "699-1206",
          "699-1244",
          "699-1245",
          "690-2513",
          "690-2401",
          "690-2634",
          "690-2511",
          "690-2402",
          "690-2521",
          "690-2405",
          "690-2525",
          "690-2625",
          "690-2632",
          "690-2403",
          "690-2524",
          "690-2406",
          "690-2512",
          "690-2633",
          "690-2523",
          "690-2631",
          "690-2404",
          "690-2522",
          "690-2311",
          "690-2314",
          "690-2312",
          "690-2313",
          "690-2802",
          "690-2801",
          "699-1500",
          "699-1821",
          "699-1812",
          "699-1941",
          "699-1802",
          "699-1621",
          "699-1431",
          "699-1701",
          "699-1515",
          "699-1514",
          "699-1702",
          "699-1942",
          "699-1434",
          "699-1517",
          "699-1622",
          "699-1822",
          "699-1512",
          "699-1703",
          "699-1801",
          "699-1831",
          "699-1432",
          "699-1513",
          "699-1516",
          "699-1511",
          "699-1811",
          "699-1433",
          "699-1832",
          "690-3200",
          "690-3511",
          "690-3514",
          "690-3403",
          "690-3512",
          "690-3405",
          "690-3204",
          "690-3515",
          "690-3311",
          "690-3313",
          "690-3513",
          "690-3402",
          "690-3203",
          "690-3314",
          "690-3207",
          "690-3205",
          "690-3401",
          "690-3312",
          "690-3516",
          "690-3206",
          "690-3404",
          "696-0000",
          "696-0003",
          "696-0011",
          "696-0004",
          "696-0001",
          "696-1221",
          "696-0006",
          "696-0012",
          "696-1226",
          "696-0007",
          "696-0005",
          "696-0002",
          "696-0013",
          "696-1225",
          "696-1224",
          "696-1223",
          "696-1222",
          "699-4600",
          "699-4624",
          "699-4627",
          "699-4715",
          "696-0701",
          "696-1136",
          "699-4631",
          "699-4626",
          "699-4621",
          "699-4714",
          "696-1137",
          "699-4702",
          "696-0702",
          "699-4707",
          "696-1141",
          "696-1142",
          "699-4622",
          "699-4703",
          "699-4712",
          "696-1144",
          "696-1133",
          "696-1135",
          "699-4713",
          "699-4704",
          "696-1132",
          "696-1143",
          "696-1134",
          "699-4632",
          "699-4605",
          "699-4706",
          "699-4711",
          "696-0703",
          "696-0704",
          "696-0705",
          "696-0706",
          "699-4623",
          "699-4701",
          "696-0712",
          "696-1131",
          "696-1145",
          "696-0711",
          "696-0713",
          "699-4625",
          "699-4633",
          "696-0100",
          "696-0501",
          "696-0312",
          "697-0631",
          "696-0101",
          "696-0504",
          "696-0314",
          "696-0601",
          "696-0503",
          "696-0315",
          "696-0224",
          "696-0602",
          "696-0225",
          "696-0405",
          "696-0502",
          "696-0316",
          "696-0131",
          "696-0223",
          "696-0603",
          "696-0222",
          "696-0406",
          "696-0505",
          "696-0102",
          "696-0404",
          "699-4311",
          "696-0104",
          "696-0402",
          "696-0401",
          "696-0221",
          "696-0311",
          "696-0407",
          "696-0103",
          "696-0313",
          "696-0506",
          "696-0317",
          "696-0403",
          "699-5600",
          "699-5211",
          "699-5201",
          "699-5601",
          "699-5216",
          "699-5605",
          "699-5212",
          "699-5607",
          "699-5603",
          "699-5202",
          "699-5204",
          "699-5203",
          "699-5213",
          "699-5614",
          "699-5205",
          "699-5206",
          "699-5602",
          "699-5617",
          "699-5214",
          "699-5606",
          "699-5215",
          "699-5632",
          "699-5621",
          "699-5634",
          "699-5612",
          "699-5636",
          "699-5631",
          "699-5633",
          "699-5615",
          "699-5221",
          "699-5637",
          "699-5616",
          "699-5207",
          "699-5611",
          "699-5622",
          "699-5604",
          "699-5217",
          "699-5635",
          "699-5613",
          "699-5500",
          "699-5523",
          "699-5506",
          "699-5306",
          "699-5301",
          "699-5303",
          "699-5307",
          "699-5305",
          "699-5304",
          "699-5302",
          "699-5501",
          "699-5504",
          "699-5505",
          "699-5515",
          "699-5521",
          "699-5516",
          "699-5517",
          "699-5507",
          "699-5514",
          "699-5511",
          "699-5524",
          "699-5502",
          "699-5522",
          "699-5525",
          "699-5503",
          "699-5512",
          "699-5513",
          "684-0400",
          "684-0403",
          "684-0401",
          "684-0413",
          "684-0411",
          "684-0402",
          "684-0404",
          "684-0412",
          "684-0300",
          "684-0301",
          "684-0211",
          "684-0302",
          "684-0303",
          "684-0100",
          "684-0104",
          "684-0107",
          "684-0101",
          "684-0106",
          "684-0102",
          "684-0103",
          "684-0105",
          "685-0000",
          "685-0006",
          "685-0004",
          "685-0411",
          "685-0007",
          "685-0431",
          "685-0306",
          "685-0003",
          "685-0022",
          "685-0413",
          "685-0001",
          "685-0002",
          "685-0026",
          "685-0024",
          "685-0435",
          "685-0301",
          "685-0305",
          "685-0101",
          "685-0312",
          "685-0311",
          "685-0011",
          "685-0017",
          "685-0016",
          "685-0304",
          "685-0106",
          "685-0105",
          "685-0104",
          "685-0005",
          "685-0013",
          "685-0434",
          "685-0103",
          "685-0313",
          "685-0302",
          "685-0023",
          "685-0014",
          "685-0432",
          "685-0027",
          "685-0012",
          "685-0412",
          "685-0025",
          "685-0021",
          "685-0433",
          "685-0015",
          "685-0303",
          "685-0314",
          "685-0102",
          "700-0000",
          "700-0045",
          "700-0941",
          "700-0865",
          "700-0864",
          "701-1463",
          "700-0833",
          "700-0834",
          "701-1461",
          "700-0813",
          "701-1527",
          "700-0017",
          "700-0016",
          "700-0812",
          "700-0012",
          "701-1211",
          "701-1203",
          "700-0013",
          "700-0975",
          "701-1204",
          "701-0145",
          "700-0974",
          "700-0046",
          "700-0041",
          "700-0022",
          "700-0824",
          "700-0023",
          "700-0024",
          "700-0028",
          "701-1462",
          "701-0165",
          "701-1223",
          "701-1336",
          "700-0924",
          "700-0923",
          "700-0925",
          "700-0867",
          "700-0933",
          "700-0931",
          "700-0932",
          "700-0934",
          "701-1212",
          "700-0844",
          "700-0822",
          "701-1144",
          "700-0011",
          "701-1601",
          "700-0905",
          "701-2151",
          "701-1525",
          "701-1465",
          "700-0972",
          "701-1342",
          "701-1214",
          "701-0161",
          "701-1605",
          "700-0047",
          "700-0935",
          "703-8207",
          "700-0803",
          "700-0963",
          "700-0962",
          "700-0961",
          "701-1341",
          "700-0831",
          "700-0832",
          "700-0838",
          "700-0015",
          "701-0144",
          "700-0984",
          "700-0985",
          "700-0866",
          "701-1201",
          "701-2152",
          "703-8257",
          "700-0021",
          "701-1604",
          "700-0025",
          "701-1352",
          "700-0903",
          "701-1205",
          "700-0914",
          "700-0915",
          "700-0033",
          "701-1464",
          "700-0907",
          "700-0052",
          "700-0051",
          "700-0054",
          "700-0053",
          "700-0846",
          "701-1524",
          "701-1356",
          "700-0973",
          "701-2143",
          "700-0001",
          "700-0002",
          "701-1603",
          "700-0032",
          "701-0143",
          "701-0142",
          "701-0141",
          "701-1345",
          "701-1344",
          "700-0863",
          "700-0986",
          "701-1141",
          "701-1522",
          "700-0861",
          "700-0862",
          "700-0027",
          "700-0842",
          "701-1343",
          "700-0062",
          "700-0061",
          "700-0063",
          "700-0064",
          "700-0906",
          "700-0913",
          "700-0912",
          "700-0911",
          "701-1354",
          "701-1142",
          "701-1335",
          "701-1331",
          "701-1355",
          "701-1334",
          "700-0035",
          "700-0034",
          "709-3131",
          "709-3121",
          "709-3124",
          "709-3112",
          "709-3134",
          "709-3105",
          "709-3141",
          "709-3113",
          "709-3142",
          "709-3145",
          "709-3101",
          "709-3103",
          "709-3104",
          "709-3144",
          "709-3132",
          "709-3133",
          "709-3123",
          "709-3111",
          "709-3114",
          "709-3143",
          "709-3122",
          "709-3102",
          "701-1333",
          "700-0976",
          "700-0951",
          "700-0071",
          "701-1132",
          "701-2142",
          "701-1154",
          "700-0825",
          "700-0836",
          "700-0014",
          "700-0087",
          "700-0084",
          "700-0088",
          "700-0082",
          "700-0083",
          "700-0086",
          "700-0081",
          "700-0080",
          "700-0089",
          "700-0085",
          "701-1152",
          "701-1151",
          "701-1346",
          "700-0814",
          "700-0977",
          "700-0855",
          "700-0856",
          "700-0854",
          "700-0826",
          "700-0936",
          "701-1153",
          "700-0031",
          "701-1133",
          "700-0816",
          "700-0804",
          "700-0821",
          "700-0982",
          "700-0964",
          "701-0163",
          "701-1224",
          "701-2155",
          "701-2144",
          "701-0164",
          "700-0851",
          "700-0852",
          "701-1202",
          "700-0953",
          "701-1213",
          "700-0902",
          "700-0055",
          "700-0056",
          "700-0981",
          "700-0965",
          "700-0916",
          "700-0067",
          "701-0136",
          "700-0927",
          "700-0926",
          "701-1612",
          "701-1131",
          "701-0153",
          "701-0162",
          "700-0971",
          "700-0815",
          "700-0066",
          "700-0065",
          "701-0152",
          "701-1221",
          "701-2153",
          "701-0134",
          "701-0133",
          "701-0132",
          "701-0131",
          "701-2154",
          "700-0818",
          "700-0003",
          "700-0811",
          "700-0983",
          "700-0835",
          "700-0068",
          "701-0135",
          "700-0921",
          "700-0922",
          "701-1611",
          "701-1521",
          "700-0966",
          "700-0952",
          "701-0151",
          "701-1332",
          "700-0806",
          "701-1357",
          "701-1225",
          "700-0843",
          "700-0841",
          "700-0805",
          "700-0827",
          "700-0004",
          "700-0026",
          "700-0901",
          "701-1613",
          "701-1222",
          "701-1602",
          "700-0823",
          "700-0073",
          "700-0072",
          "700-0043",
          "700-0044",
          "700-0042",
          "709-2101",
          "709-2105",
          "709-2125",
          "709-2121",
          "709-2131",
          "709-2126",
          "709-2133",
          "709-2111",
          "709-2115",
          "709-2132",
          "709-2112",
          "709-2123",
          "709-2137",
          "709-2136",
          "709-2134",
          "709-2106",
          "709-2124",
          "709-2135",
          "709-2102",
          "709-2114",
          "709-2116",
          "709-2117",
          "709-2104",
          "709-2103",
          "709-2107",
          "709-2122",
          "709-2113",
          "701-1353",
          "701-1134",
          "700-0807",
          "700-0837",
          "700-0802",
          "700-0801",
          "701-2141",
          "701-1351",
          "700-0076",
          "700-0074",
          "700-0075",
          "700-0904",
          "700-0847",
          "700-0808",
          "701-1526",
          "700-0817",
          "701-1145",
          "701-1226",
          "701-1523",
          "701-1143",
          "700-0005",
          "701-1337",
          "703-8288",
          "703-8283",
          "703-8287",
          "703-8231",
          "703-8284",
          "703-8208",
          "703-8226",
          "702-8005",
          "702-8004",
          "702-8001",
          "703-8272",
          "703-8228",
          "703-8277",
          "703-8204",
          "703-8273",
          "703-8274",
          "703-8275",
          "703-8276",
          "703-8227",
          "703-8286",
          "703-8236",
          "703-8265",
          "703-8264",
          "703-8263",
          "702-8002",
          "703-8225",
          "703-8203",
          "703-8293",
          "703-8248",
          "703-8247",
          "703-8296",
          "703-8285",
          "703-8234",
          "703-8201",
          "703-8243",
          "703-8222",
          "703-8206",
          "703-8294",
          "702-8003",
          "703-8238",
          "703-8232",
          "703-8242",
          "703-8241",
          "703-8233",
          "703-8251",
          "703-8292",
          "703-8217",
          "703-8291",
          "703-8205",
          "703-8221",
          "703-8252",
          "703-8223",
          "703-8258",
          "703-8298",
          "703-8256",
          "703-8235",
          "703-8255",
          "703-8297",
          "703-8281",
          "703-8282",
          "703-8262",
          "702-8006",
          "703-8245",
          "703-8244",
          "703-8246",
          "703-8278",
          "703-8271",
          "703-8266",
          "703-8295",
          "703-8261",
          "703-8237",
          "703-8254",
          "703-8253",
          "703-8267",
          "703-8202",
          "703-8224",
          "709-0605",
          "704-8181",
          "704-8153",
          "709-0612",
          "709-0607",
          "704-8172",
          "704-8132",
          "704-8137",
          "704-8173",
          "704-8193",
          "704-8194",
          "704-8196",
          "704-8142",
          "704-8138",
          "704-8134",
          "704-8166",
          "704-8154",
          "709-0635",
          "704-8161",
          "704-8102",
          "703-8214",
          "704-8149",
          "704-8164",
          "704-8103",
          "703-8212",
          "703-8215",
          "709-0615",
          "704-8113",
          "704-8121",
          "704-8144",
          "704-8195",
          "704-8112",
          "704-8125",
          "704-8111",
          "704-8124",
          "704-8127",
          "704-8122",
          "704-8116",
          "704-8191",
          "704-8192",
          "704-8126",
          "704-8114",
          "704-8183",
          "704-8117",
          "704-8123",
          "704-8101",
          "703-8216",
          "704-8141",
          "704-8133",
          "709-0625",
          "709-0624",
          "709-0622",
          "709-0623",
          "704-8148",
          "709-0634",
          "709-0603",
          "709-0853",
          "709-0854",
          "709-0851",
          "709-0855",
          "709-0845",
          "709-0852",
          "709-0863",
          "709-0865",
          "709-0876",
          "709-0873",
          "709-0862",
          "709-0871",
          "709-0856",
          "709-0864",
          "709-0861",
          "709-0872",
          "709-0846",
          "709-0875",
          "709-0842",
          "709-0841",
          "709-0844",
          "709-0874",
          "709-0843",
          "704-8143",
          "709-0614",
          "709-0636",
          "709-0604",
          "704-8104",
          "704-8162",
          "709-0626",
          "704-8176",
          "704-8131",
          "709-0611",
          "704-8155",
          "704-8136",
          "704-8106",
          "709-0633",
          "709-0621",
          "704-8151",
          "704-8135",
          "704-8145",
          "709-0631",
          "709-0602",
          "704-8182",
          "704-8107",
          "703-8213",
          "704-8184",
          "704-8152",
          "704-8147",
          "704-8165",
          "704-8163",
          "704-8175",
          "704-8174",
          "709-0632",
          "704-8146",
          "704-8115",
          "704-8171",
          "709-0613",
          "709-0606",
          "703-8211",
          "709-0601",
          "704-8105",
          "702-8013",
          "702-8057",
          "702-8015",
          "700-0944",
          "710-0151",
          "701-0212",
          "702-8025",
          "702-8026",
          "702-8024",
          "701-0204",
          "709-1212",
          "702-8045",
          "709-1215",
          "709-1214",
          "702-8012",
          "709-1201",
          "702-8011",
          "702-8016",
          "701-0203",
          "702-8052",
          "700-0943",
          "700-0945",
          "702-8042",
          "701-0205",
          "701-0201",
          "709-1216",
          "701-0214",
          "702-8046",
          "702-8053",
          "702-8056",
          "702-8054",
          "702-8055",
          "702-8051",
          "702-8037",
          "700-0956",
          "702-8041",
          "700-0942",
          "700-0853",
          "701-0213",
          "702-8058",
          "702-8023",
          "701-0215",
          "709-1203",
          "709-1204",
          "709-1202",
          "709-1211",
          "700-0845",
          "701-0211",
          "709-1213",
          "702-8043",
          "702-8044",
          "702-8021",
          "702-8032",
          "702-8031",
          "702-8033",
          "702-8022",
          "702-8035",
          "702-8034",
          "702-8048",
          "701-0221",
          "702-8027",
          "702-8038",
          "700-0955",
          "701-0206",
          "702-8036",
          "702-8014",
          "701-0202",
          "700-0954",
          "702-8047",
          "710-0000",
          "710-0064",
          "710-0007",
          "710-0055",
          "710-0131",
          "710-0031",
          "710-0002",
          "710-0041",
          "710-0822",
          "710-0814",
          "712-8054",
          "710-0843",
          "710-0826",
          "710-0817",
          "710-0047",
          "711-0924",
          "710-0836",
          "710-0837",
          "710-0144",
          "710-0023",
          "710-0026",
          "710-0805",
          "710-0846",
          "712-8013",
          "710-0024",
          "710-0811",
          "710-0821",
          "712-8061",
          "712-8032",
          "710-0812",
          "710-0143",
          "710-0141",
          "710-0025",
          "701-0113",
          "710-0035",
          "710-0014",
          "711-0931",
          "711-0913",
          "711-0917",
          "711-0916",
          "711-0914",
          "711-0915",
          "711-0923",
          "711-0935",
          "711-0921",
          "711-0911",
          "711-0912",
          "711-0907",
          "711-0906",
          "711-0933",
          "711-0904",
          "711-0905",
          "711-0934",
          "711-0902",
          "711-0903",
          "711-0937",
          "711-0922",
          "711-0936",
          "711-0901",
          "710-0813",
          "711-0932",
          "710-0051",
          "710-0801",
          "710-0834",
          "710-0835",
          "701-0112",
          "711-0927",
          "711-0925",
          "711-0926",
          "701-0102",
          "701-0111",
          "710-0057",
          "710-0253",
          "710-0038",
          "710-0006",
          "710-0146",
          "710-0021",
          "710-0831",
          "710-0832",
          "713-8102",
          "713-8121",
          "713-8101",
          "713-8103",
          "713-8123",
          "713-8124",
          "713-8126",
          "713-8127",
          "713-8112",
          "713-8122",
          "710-0252",
          "713-8116",
          "710-0251",
          "713-8111",
          "713-8115",
          "713-8114",
          "713-8113",
          "713-8125",
          "710-1101",
          "710-1102",
          "710-0046",
          "710-0036",
          "710-0034",
          "710-0033",
          "712-8012",
          "712-8014",
          "712-8002",
          "712-8011",
          "712-8006",
          "712-8001",
          "712-8015",
          "710-0056",
          "712-8007",
          "710-0011",
          "710-0012",
          "710-0013",
          "710-0803",
          "710-0016",
          "710-0015",
          "712-8051",
          "710-0807",
          "710-0804",
          "710-0806",
          "701-0103",
          "710-0005",
          "710-0004",
          "710-0027",
          "710-0845",
          "710-0833",
          "710-0824",
          "710-0043",
          "710-0816",
          "710-0037",
          "710-0061",
          "710-0062",
          "710-0142",
          "710-0022",
          "710-0032",
          "712-8044",
          "710-0847",
          "710-0053",
          "710-0063",
          "701-0101",
          "710-0815",
          "710-0003",
          "712-8043",
          "710-0844",
          "710-0145",
          "710-0048",
          "712-8031",
          "712-8046",
          "712-8045",
          "712-8042",
          "712-8041",
          "710-0132",
          "710-0133",
          "701-0115",
          "710-0042",
          "710-0261",
          "710-0262",
          "710-0263",
          "710-0045",
          "710-0841",
          "710-0054",
          "712-8052",
          "701-0114",
          "710-1306",
          "710-1305",
          "710-1311",
          "710-1304",
          "710-1315",
          "710-1313",
          "710-1314",
          "710-1303",
          "710-1312",
          "710-1302",
          "710-1301",
          "710-0802",
          "712-8039",
          "712-8064",
          "712-8071",
          "712-8074",
          "712-8066",
          "712-8072",
          "712-8073",
          "712-8021",
          "712-8037",
          "712-8038",
          "712-8033",
          "712-8034",
          "712-8057",
          "712-8065",
          "712-8058",
          "712-8059",
          "712-8035",
          "712-8036",
          "712-8056",
          "712-8025",
          "712-8024",
          "712-8004",
          "712-8005",
          "712-8063",
          "712-8062",
          "712-8026",
          "712-8027",
          "712-8023",
          "712-8022",
          "712-8003",
          "710-0001",
          "712-8055",
          "710-0823",
          "710-0065",
          "710-0052",
          "710-0044",
          "710-0825",
          "701-0105",
          "701-0104",
          "710-0842",
          "712-8053",
          "708-0000",
          "709-3951",
          "708-1104",
          "708-0852",
          "709-4615",
          "708-0815",
          "708-1206",
          "708-0883",
          "708-0885",
          "708-0014",
          "708-0831",
          "708-0844",
          "708-1202",
          "708-0802",
          "708-0882",
          "708-0806",
          "708-0023",
          "708-1203",
          "708-1201",
          "708-0066",
          "708-0863",
          "708-1126",
          "708-0865",
          "708-0006",
          "708-0001",
          "708-0077",
          "708-0804",
          "708-0835",
          "708-0855",
          "708-0864",
          "708-0002",
          "708-0076",
          "708-1121",
          "708-0011",
          "708-1214",
          "708-1224",
          "708-0801",
          "709-3915",
          "709-3907",
          "709-3924",
          "709-3912",
          "709-3921",
          "709-3901",
          "709-3902",
          "709-3923",
          "709-3906",
          "709-3904",
          "709-3913",
          "709-3922",
          "709-3905",
          "709-3914",
          "709-3935",
          "709-3903",
          "709-3931",
          "709-3934",
          "709-3932",
          "709-3908",
          "709-3911",
          "709-3933",
          "708-0043",
          "708-0841",
          "708-0842",
          "708-0033",
          "708-0003",
          "708-0021",
          "708-0062",
          "708-1117",
          "709-4612",
          "709-4614",
          "709-4624",
          "709-4623",
          "709-4621",
          "708-0866",
          "708-1115",
          "708-0843",
          "708-0063",
          "708-0053",
          "708-0031",
          "708-0064",
          "708-1223",
          "709-4625",
          "709-4626",
          "708-0873",
          "708-0022",
          "708-0825",
          "708-0805",
          "708-0071",
          "708-1122",
          "708-1123",
          "708-0012",
          "708-1213",
          "708-0807",
          "708-0005",
          "708-0886",
          "708-0065",
          "708-0042",
          "708-0015",
          "708-0067",
          "708-1215",
          "708-0034",
          "708-0007",
          "708-0876",
          "708-1125",
          "708-1124",
          "708-0874",
          "708-1113",
          "708-0052",
          "708-1112",
          "708-0051",
          "709-4605",
          "709-4604",
          "708-0075",
          "708-0884",
          "708-0041",
          "708-0853",
          "708-0037",
          "708-0016",
          "709-4622",
          "709-4606",
          "709-4603",
          "708-0871",
          "708-0834",
          "708-0854",
          "708-1216",
          "708-1111",
          "708-0851",
          "708-1205",
          "708-1226",
          "708-0024",
          "708-0046",
          "708-1221",
          "708-1225",
          "708-0833",
          "708-0811",
          "708-0045",
          "708-1222",
          "708-0856",
          "708-0013",
          "708-1204",
          "708-0824",
          "708-0821",
          "708-1116",
          "708-0822",
          "708-0836",
          "708-0837",
          "708-1211",
          "708-0845",
          "708-0814",
          "708-0832",
          "708-0812",
          "708-0872",
          "708-0035",
          "708-1114",
          "708-0875",
          "709-4631",
          "708-0857",
          "708-0074",
          "708-0032",
          "708-1103",
          "708-0073",
          "708-1101",
          "709-4616",
          "708-0036",
          "708-0881",
          "708-0072",
          "709-4613",
          "709-4601",
          "709-4602",
          "708-0047",
          "708-1102",
          "708-0061",
          "708-0803",
          "708-0861",
          "709-4632",
          "708-1212",
          "708-0044",
          "708-0813",
          "708-0004",
          "708-0823",
          "709-4633",
          "709-4635",
          "709-4634",
          "708-0862",
          "708-1105",
          "709-4611",
          "706-0000",
          "706-0306",
          "706-0133",
          "706-0011",
          "706-0317",
          "706-0013",
          "706-0024",
          "706-0311",
          "706-0303",
          "706-0301",
          "706-0315",
          "706-0144",
          "706-0028",
          "706-0302",
          "706-0001",
          "706-0153",
          "706-0012",
          "706-0014",
          "706-0002",
          "706-0141",
          "706-0152",
          "706-0151",
          "706-0313",
          "706-0316",
          "706-0142",
          "706-0224",
          "706-0223",
          "706-0221",
          "706-0222",
          "706-0026",
          "706-0304",
          "706-0131",
          "706-0312",
          "706-0134",
          "706-0226",
          "706-0314",
          "706-0027",
          "706-0154",
          "706-0023",
          "706-0225",
          "706-0025",
          "706-0022",
          "706-0305",
          "706-0143",
          "706-0132",
          "706-0021",
          "714-0000",
          "714-0014",
          "714-0056",
          "714-0075",
          "714-0082",
          "714-0022",
          "714-0041",
          "714-0091",
          "714-0055",
          "714-0013",
          "714-0061",
          "714-0073",
          "714-0033",
          "714-0003",
          "714-0076",
          "714-0012",
          "714-0081",
          "714-0025",
          "714-0057",
          "714-0052",
          "714-0051",
          "714-0053",
          "714-0046",
          "714-0301",
          "714-0096",
          "714-0063",
          "714-0002",
          "714-0044",
          "714-0034",
          "714-0086",
          "714-0084",
          "714-0077",
          "714-0036",
          "714-0065",
          "714-0005",
          "714-0093",
          "714-0097",
          "714-0098",
          "714-0004",
          "714-0021",
          "714-0035",
          "714-0047",
          "714-0088",
          "714-0092",
          "714-0094",
          "714-0032",
          "714-0031",
          "714-0072",
          "714-0064",
          "714-0083",
          "714-0078",
          "714-0001",
          "714-0095",
          "714-0071",
          "714-0302",
          "714-0023",
          "714-0054",
          "714-0024",
          "714-0037",
          "714-0048",
          "714-0045",
          "714-0006",
          "714-0042",
          "714-0038",
          "714-0066",
          "714-0062",
          "714-0007",
          "714-0043",
          "714-0011",
          "714-0074",
          "714-0085",
          "714-0087",
          "715-0000",
          "715-0012",
          "715-0019",
          "715-0016",
          "715-0023",
          "715-0021",
          "715-0026",
          "715-0018",
          "715-0013",
          "715-0004",
          "715-0002",
          "715-0025",
          "715-0022",
          "715-0017",
          "715-0024",
          "715-0014",
          "715-0006",
          "715-0015",
          "715-0001",
          "715-0011",
          "715-0003",
          "714-1405",
          "714-1404",
          "714-1402",
          "714-1411",
          "714-1403",
          "714-1414",
          "714-1407",
          "714-1413",
          "714-1412",
          "714-1415",
          "714-1406",
          "714-1401",
          "715-0005",
          "714-2125",
          "714-2124",
          "714-2103",
          "714-2101",
          "714-2123",
          "714-2232",
          "714-2114",
          "714-2121",
          "714-2231",
          "714-2122",
          "714-2113",
          "714-2234",
          "714-2104",
          "714-2341",
          "714-2112",
          "714-2233",
          "714-2102",
          "714-2111",
          "719-1100",
          "719-1121",
          "719-1154",
          "719-1106",
          "719-1125",
          "719-1315",
          "719-1137",
          "719-1136",
          "719-1162",
          "719-1101",
          "719-1116",
          "719-1322",
          "719-1114",
          "719-1123",
          "719-1143",
          "719-1117",
          "719-1176",
          "719-1175",
          "719-1172",
          "719-1173",
          "719-1174",
          "719-1171",
          "710-1201",
          "719-1112",
          "719-1104",
          "719-1105",
          "719-1313",
          "719-1155",
          "719-1153",
          "719-1321",
          "719-1163",
          "719-1122",
          "719-1145",
          "719-1161",
          "710-1203",
          "719-1126",
          "719-1312",
          "719-1131",
          "719-1144",
          "719-1323",
          "719-1133",
          "719-1111",
          "719-1103",
          "719-1164",
          "719-1165",
          "719-1314",
          "719-1142",
          "719-1324",
          "719-1102",
          "719-1316",
          "719-1115",
          "719-1141",
          "719-1134",
          "719-1151",
          "719-1124",
          "719-1135",
          "719-1311",
          "719-1113",
          "719-1152",
          "719-1132",
          "719-1156",
          "719-1146",
          "710-1202",
          "716-0000",
          "716-0009",
          "716-0039",
          "716-0018",
          "716-0015",
          "716-1321",
          "716-1322",
          "719-2233",
          "719-2232",
          "719-2231",
          "719-2234",
          "716-0004",
          "716-0007",
          "716-0061",
          "716-0064",
          "716-0062",
          "716-0063",
          "716-0017",
          "716-0028",
          "716-0023",
          "716-0013",
          "716-0041",
          "716-0222",
          "716-0211",
          "716-0223",
          "716-0221",
          "716-0201",
          "716-0212",
          "716-0205",
          "716-0202",
          "716-0207",
          "716-0203",
          "716-0206",
          "716-0204",
          "716-0005",
          "719-2121",
          "716-0026",
          "716-0025",
          "716-0006",
          "716-1311",
          "716-0035",
          "716-0042",
          "716-0022",
          "716-0012",
          "719-2123",
          "716-0003",
          "719-2122",
          "716-0053",
          "716-0052",
          "716-0054",
          "716-0024",
          "716-0047",
          "716-0021",
          "716-0002",
          "716-0001",
          "716-0031",
          "716-0019",
          "719-2401",
          "719-2402",
          "716-0014",
          "716-0045",
          "716-0333",
          "716-0334",
          "716-0102",
          "716-0332",
          "719-2343",
          "716-0113",
          "716-0111",
          "716-0101",
          "719-2342",
          "716-0121",
          "716-0331",
          "716-0122",
          "719-2341",
          "716-0335",
          "716-0112",
          "716-0038",
          "716-0044",
          "716-0043",
          "716-0034",
          "716-0301",
          "716-0303",
          "716-0323",
          "716-0322",
          "716-0321",
          "716-0311",
          "716-0304",
          "716-0302",
          "716-0011",
          "716-0037",
          "716-0065",
          "716-0068",
          "716-0067",
          "716-0066",
          "716-0036",
          "716-0051",
          "716-0033",
          "716-0029",
          "716-0027",
          "716-0032",
          "716-0046",
          "716-0016",
          "716-0008",
          "718-0000",
          "718-0006",
          "719-2551",
          "718-0015",
          "719-3501",
          "719-3503",
          "719-3502",
          "719-3507",
          "719-3506",
          "719-3504",
          "719-3505",
          "718-0016",
          "718-0005",
          "718-0001",
          "718-0012",
          "719-2732",
          "719-2641",
          "718-0007",
          "718-0002",
          "718-0013",
          "719-2801",
          "719-3611",
          "719-2802",
          "719-3612",
          "718-0211",
          "718-0003",
          "719-2642",
          "718-0101",
          "718-0103",
          "718-0102",
          "718-0104",
          "719-2731",
          "719-2643",
          "719-3811",
          "719-3814",
          "719-3702",
          "719-3812",
          "719-3813",
          "719-3701",
          "718-0307",
          "718-0313",
          "718-0305",
          "718-0311",
          "718-0312",
          "718-0304",
          "718-0302",
          "718-0303",
          "718-0301",
          "718-0306",
          "719-2721",
          "719-2723",
          "719-2722",
          "718-0014",
          "718-0011",
          "718-0017",
          "719-2552",
          "718-0004",
          "705-0000",
          "705-0032",
          "705-0023",
          "705-0001",
          "705-0002",
          "705-0003",
          "705-0012",
          "705-0011",
          "705-0035",
          "705-0024",
          "705-0016",
          "705-0026",
          "705-0031",
          "705-0036",
          "705-0014",
          "705-0025",
          "705-0034",
          "705-0021",
          "705-0131",
          "705-0015",
          "705-0022",
          "701-3203",
          "701-3202",
          "701-3201",
          "701-3204",
          "705-0013",
          "705-0033",
          "705-0132",
          "705-0133",
          "709-0213",
          "709-0226",
          "709-0301",
          "709-0221",
          "709-0212",
          "709-0304",
          "709-0211",
          "709-0302",
          "709-0303",
          "709-0222",
          "709-0225",
          "709-0223",
          "709-0224",
          "709-0214",
          "701-4200",
          "701-4302",
          "701-4303",
          "701-4304",
          "701-4301",
          "701-4231",
          "701-4234",
          "701-4221",
          "701-4252",
          "701-4215",
          "701-4251",
          "701-4232",
          "701-4247",
          "701-4216",
          "701-4211",
          "701-4212",
          "701-4243",
          "701-4223",
          "701-4222",
          "701-4224",
          "701-4502",
          "701-4244",
          "701-4241",
          "701-4245",
          "701-4214",
          "701-4254",
          "701-4253",
          "701-4233",
          "701-4501",
          "701-4248",
          "701-4246",
          "701-4213",
          "701-4261",
          "701-4273",
          "701-4274",
          "701-4271",
          "701-4263",
          "701-4264",
          "701-4276",
          "701-4262",
          "701-4265",
          "701-4275",
          "701-4272",
          "709-0800",
          "701-2443",
          "701-2514",
          "701-2445",
          "709-0831",
          "701-2511",
          "701-2213",
          "709-0822",
          "709-0711",
          "701-2221",
          "701-2205",
          "709-0702",
          "701-2446",
          "709-0713",
          "709-0717",
          "709-0806",
          "709-0733",
          "709-0732",
          "709-0817",
          "709-0837",
          "709-0834",
          "709-0719",
          "701-2501",
          "701-2211",
          "701-2502",
          "709-0833",
          "701-2512",
          "701-2522",
          "701-2521",
          "701-2515",
          "709-0801",
          "709-0821",
          "701-2201",
          "701-2525",
          "709-0813",
          "701-2202",
          "709-0802",
          "709-0721",
          "709-0706",
          "709-0704",
          "709-0827",
          "701-2432",
          "709-0816",
          "709-0836",
          "709-0701",
          "709-0731",
          "709-0832",
          "701-2503",
          "709-0715",
          "709-0714",
          "701-2203",
          "701-2216",
          "709-0811",
          "701-2524",
          "709-0815",
          "709-0807",
          "709-0718",
          "709-0838",
          "709-0716",
          "701-2431",
          "709-0703",
          "709-0823",
          "709-0803",
          "701-2437",
          "701-2444",
          "701-2523",
          "701-2215",
          "701-2224",
          "701-2441",
          "709-0835",
          "701-2435",
          "701-2436",
          "701-2434",
          "709-0812",
          "709-0735",
          "709-0736",
          "701-2214",
          "701-2223",
          "709-0804",
          "701-2433",
          "701-2442",
          "701-2504",
          "709-0805",
          "709-0824",
          "701-2222",
          "709-0705",
          "709-0825",
          "709-0814",
          "701-2212",
          "709-0734",
          "701-2513",
          "701-2225",
          "701-2204",
          "701-2226",
          "709-0712",
          "709-0826",
          "719-3100",
          "719-3101",
          "716-1431",
          "717-0026",
          "717-0421",
          "719-3151",
          "717-0413",
          "717-0745",
          "717-0744",
          "719-3131",
          "717-0742",
          "717-0025",
          "717-0023",
          "719-3102",
          "717-0015",
          "719-3144",
          "719-3111",
          "719-3112",
          "719-3211",
          "719-3223",
          "719-3152",
          "717-0013",
          "717-0101",
          "717-0746",
          "716-1432",
          "719-3141",
          "719-3121",
          "716-1422",
          "716-1411",
          "717-0004",
          "719-3142",
          "717-0414",
          "719-3205",
          "719-3201",
          "717-0006",
          "719-3153",
          "717-0423",
          "717-0102",
          "719-3206",
          "717-0027",
          "719-3228",
          "719-3103",
          "716-1401",
          "717-0736",
          "719-3154",
          "717-0022",
          "717-0014",
          "716-1433",
          "719-3143",
          "717-0735",
          "719-3155",
          "719-3122",
          "716-1421",
          "719-3123",
          "717-0403",
          "717-0002",
          "719-3113",
          "717-0737",
          "719-3156",
          "719-3204",
          "719-3227",
          "717-0732",
          "719-3114",
          "717-0103",
          "717-0003",
          "719-3213",
          "717-0424",
          "717-0401",
          "719-3104",
          "719-3132",
          "719-3133",
          "717-0024",
          "717-0743",
          "717-0415",
          "719-3203",
          "717-0406",
          "719-3115",
          "719-3124",
          "719-3202",
          "719-3225",
          "717-0416",
          "719-3214",
          "719-3145",
          "719-3105",
          "717-0734",
          "719-3106",
          "719-3134",
          "717-0104",
          "717-0405",
          "717-0425",
          "719-3116",
          "719-3146",
          "719-3107",
          "717-0612",
          "717-0505",
          "717-0602",
          "717-0513",
          "717-0613",
          "717-0506",
          "717-0504",
          "717-0507",
          "717-0502",
          "717-0503",
          "717-0501",
          "717-0604",
          "717-0511",
          "717-0603",
          "717-0515",
          "717-0611",
          "717-0512",
          "717-0601",
          "717-0514",
          "719-3117",
          "717-0021",
          "717-0422",
          "719-3157",
          "719-3125",
          "717-0001",
          "717-0007",
          "717-0412",
          "719-3135",
          "717-0017",
          "717-0731",
          "717-0016",
          "717-0411",
          "717-0011",
          "717-0105",
          "719-3212",
          "719-3226",
          "717-0426",
          "716-1403",
          "719-3126",
          "719-3224",
          "717-0404",
          "717-0012",
          "716-1402",
          "717-0402",
          "717-0005",
          "719-3136",
          "719-3221",
          "719-3222",
          "717-0741",
          "717-0733",
          "707-0000",
          "701-2623",
          "707-0065",
          "707-0432",
          "709-4232",
          "707-0053",
          "709-4205",
          "707-0437",
          "701-2606",
          "707-0052",
          "707-0051",
          "707-0034",
          "707-0416",
          "709-4222",
          "707-0054",
          "701-2614",
          "707-0401",
          "707-0204",
          "707-0411",
          "709-4234",
          "709-4227",
          "707-0005",
          "709-4223",
          "707-0404",
          "707-0033",
          "707-0124",
          "701-2605",
          "707-0067",
          "701-2601",
          "709-4203",
          "709-4215",
          "707-0132",
          "707-0423",
          "709-4201",
          "707-0044",
          "709-4253",
          "707-0201",
          "709-4202",
          "707-0426",
          "707-0055",
          "709-4246",
          "707-0001",
          "707-0421",
          "709-4236",
          "707-0436",
          "707-0407",
          "701-2611",
          "707-0063",
          "707-0036",
          "707-0014",
          "707-0111",
          "707-0042",
          "709-4255",
          "707-0202",
          "707-0131",
          "707-0045",
          "709-4211",
          "707-0025",
          "709-4204",
          "707-0422",
          "707-0435",
          "707-0066",
          "707-0016",
          "707-0425",
          "707-0417",
          "701-2621",
          "701-2625",
          "709-4251",
          "707-0133",
          "709-4256",
          "709-4252",
          "709-4221",
          "707-0431",
          "709-4213",
          "707-0427",
          "701-2612",
          "709-4245",
          "707-0433",
          "707-0012",
          "709-4257",
          "709-4242",
          "709-4244",
          "707-0064",
          "707-0037",
          "707-0015",
          "709-4224",
          "701-2622",
          "707-0056",
          "707-0002",
          "701-2615",
          "701-2624",
          "707-0402",
          "707-0413",
          "707-0061",
          "709-4226",
          "707-0022",
          "707-0024",
          "707-0021",
          "709-4231",
          "707-0414",
          "707-0004",
          "707-0424",
          "707-0405",
          "707-0057",
          "707-0121",
          "707-0041",
          "709-4235",
          "707-0403",
          "707-0205",
          "707-0206",
          "707-0406",
          "709-4241",
          "707-0035",
          "707-0023",
          "701-2604",
          "709-4233",
          "707-0412",
          "707-0122",
          "707-0113",
          "701-2602",
          "709-4225",
          "707-0203",
          "709-4214",
          "709-4254",
          "707-0043",
          "707-0046",
          "701-2616",
          "707-0434",
          "701-2603",
          "709-4212",
          "707-0415",
          "707-0003",
          "707-0123",
          "707-0134",
          "707-0031",
          "709-4247",
          "709-4216",
          "707-0032",
          "707-0062",
          "701-2613",
          "707-0013",
          "707-0112",
          "709-4243",
          "707-0011",
          "719-0200",
          "719-0243",
          "719-0231",
          "719-0241",
          "719-0233",
          "719-0253",
          "719-0244",
          "719-0232",
          "719-0234",
          "719-0242",
          "719-0252",
          "719-0251",
          "719-0254",
          "719-0105",
          "719-0104",
          "719-0111",
          "719-0221",
          "719-0101",
          "719-0113",
          "719-0106",
          "719-0102",
          "719-0112",
          "719-0103",
          "714-0101",
          "709-0400",
          "709-0413",
          "709-0513",
          "709-0525",
          "709-0414",
          "709-0432",
          "709-0501",
          "709-0522",
          "709-0504",
          "709-0441",
          "709-0404",
          "709-0523",
          "709-0514",
          "709-0506",
          "709-0431",
          "709-0422",
          "709-0524",
          "709-0512",
          "709-0463",
          "709-0464",
          "709-0521",
          "709-0516",
          "709-0505",
          "709-0461",
          "709-0402",
          "709-0403",
          "709-0421",
          "709-0442",
          "709-0412",
          "709-0401",
          "709-0462",
          "709-0452",
          "709-0502",
          "709-0503",
          "709-0511",
          "709-0526",
          "709-0411",
          "709-0515",
          "709-0451",
          "701-0300",
          "701-0304",
          "701-0303",
          "701-0301",
          "701-0302",
          "719-0300",
          "719-0301",
          "719-0302",
          "719-0304",
          "719-0303",
          "714-1200",
          "714-1225",
          "714-1205",
          "714-1206",
          "714-1221",
          "714-1226",
          "714-1227",
          "714-1202",
          "714-1203",
          "714-1213",
          "714-1204",
          "714-1215",
          "714-1222",
          "714-1223",
          "714-1211",
          "714-1214",
          "714-1224",
          "714-1201",
          "714-1212",
          "717-0201",
          "708-0300",
          "708-0421",
          "708-0315",
          "708-0351",
          "708-0302",
          "708-0321",
          "708-0704",
          "708-0303",
          "708-0322",
          "708-0503",
          "708-0504",
          "708-0363",
          "708-0423",
          "708-0312",
          "708-0601",
          "708-0361",
          "708-0705",
          "708-0432",
          "708-0433",
          "708-0313",
          "708-0435",
          "708-0431",
          "708-0343",
          "708-0301",
          "708-0304",
          "708-0314",
          "708-0427",
          "708-0501",
          "708-0341",
          "708-0364",
          "708-0424",
          "708-0325",
          "708-0345",
          "708-0342",
          "708-0324",
          "708-0365",
          "708-0362",
          "708-0323",
          "708-0311",
          "708-0317",
          "708-0703",
          "708-0701",
          "708-0702",
          "708-0353",
          "708-0502",
          "708-0426",
          "708-0331",
          "708-0425",
          "708-0511",
          "708-0512",
          "708-0366",
          "708-0434",
          "708-0344",
          "708-0333",
          "708-0335",
          "708-0334",
          "708-0305",
          "708-0352",
          "708-0422",
          "708-0332",
          "708-0316",
          "709-4300",
          "709-4307",
          "709-4335",
          "709-4332",
          "709-4331",
          "709-4311",
          "709-4313",
          "709-4316",
          "709-4304",
          "709-4302",
          "709-4323",
          "709-4312",
          "709-4301",
          "709-4305",
          "709-4333",
          "709-4321",
          "709-4334",
          "709-4324",
          "709-4303",
          "709-4315",
          "709-4314",
          "709-4322",
          "709-4306",
          "708-1300",
          "708-1314",
          "708-1302",
          "708-1312",
          "708-1326",
          "708-1305",
          "708-1307",
          "708-1304",
          "708-1325",
          "708-1323",
          "708-1313",
          "708-1315",
          "708-1322",
          "708-1306",
          "708-1311",
          "708-1324",
          "708-1301",
          "708-1303",
          "708-1321",
          "707-0500",
          "707-0505",
          "707-0501",
          "707-0503",
          "707-0502",
          "707-0506",
          "707-0504",
          "709-3600",
          "709-3626",
          "709-3615",
          "709-3621",
          "709-3612",
          "709-3601",
          "709-3634",
          "709-3627",
          "709-3602",
          "709-3605",
          "709-3617",
          "709-3624",
          "709-3614",
          "709-3633",
          "709-3623",
          "709-3613",
          "709-3606",
          "709-3622",
          "709-3625",
          "709-3616",
          "709-3611",
          "709-3604",
          "709-3635",
          "709-3631",
          "709-3636",
          "709-3632",
          "709-3603",
          "709-3700",
          "709-3411",
          "709-3705",
          "709-3706",
          "709-3704",
          "709-3702",
          "709-3703",
          "709-3707",
          "708-1506",
          "709-3415",
          "708-1525",
          "709-3726",
          "709-3722",
          "709-3714",
          "708-1543",
          "709-3712",
          "709-3401",
          "708-1523",
          "708-1531",
          "708-1526",
          "708-1532",
          "709-3412",
          "709-3711",
          "709-3715",
          "709-3723",
          "708-1536",
          "709-3403",
          "708-1503",
          "708-1505",
          "708-1515",
          "709-3713",
          "708-1544",
          "708-1522",
          "708-1545",
          "708-1546",
          "708-1535",
          "709-3724",
          "708-1541",
          "708-1507",
          "709-3413",
          "709-3407",
          "709-3417",
          "709-3405",
          "709-3404",
          "709-3406",
          "709-3701",
          "709-3414",
          "708-1547",
          "708-1542",
          "709-3717",
          "709-3416",
          "708-1533",
          "708-1514",
          "708-1513",
          "708-1534",
          "708-1512",
          "709-3402",
          "708-1502",
          "708-1501",
          "708-1521",
          "708-1527",
          "708-1524",
          "708-1511",
          "708-1504",
          "709-3716",
          "709-3721",
          "708-1516",
          "709-3725",
          "716-1100",
          "709-2672",
          "709-2403",
          "709-2552",
          "709-2413",
          "709-2411",
          "709-2344",
          "709-2412",
          "709-2663",
          "709-2673",
          "709-2341",
          "716-1131",
          "709-2333",
          "709-2401",
          "716-1551",
          "716-1102",
          "716-1242",
          "709-2404",
          "709-2674",
          "709-2331",
          "709-2551",
          "709-2671",
          "716-1552",
          "709-2402",
          "709-2332",
          "716-1122",
          "709-2343",
          "716-1111",
          "709-2553",
          "709-2664",
          "709-2661",
          "716-1101",
          "716-1554",
          "716-1121",
          "709-2345",
          "709-2342",
          "709-2675",
          "709-2421",
          "709-2676",
          "709-2662",
          "709-2422",
          "709-2334",
          "716-1553",
          "716-1112",
          "716-1241",
          "709-2554",
          "730-0000",
          "730-0851",
          "730-0837",
          "730-0836",
          "730-0834",
          "730-0833",
          "730-0832",
          "730-0831",
          "730-0835",
          "730-0021",
          "730-0051",
          "730-0812",
          "730-0022",
          "730-0014",
          "730-0012",
          "730-0031",
          "730-0856",
          "730-0855",
          "730-0825",
          "730-0042",
          "730-0041",
          "730-0853",
          "730-0046",
          "730-0034",
          "730-0813",
          "730-0052",
          "730-0044",
          "730-0048",
          "730-0032",
          "730-0026",
          "730-0045",
          "730-0017",
          "730-0801",
          "730-0805",
          "730-0854",
          "730-0811",
          "730-0037",
          "730-0028",
          "730-0846",
          "730-0806",
          "730-0005",
          "730-0024",
          "730-0852",
          "730-0016",
          "730-0001",
          "730-0003",
          "730-0002",
          "730-0814",
          "730-0015",
          "730-0013",
          "730-0053",
          "730-0004",
          "730-0025",
          "730-0047",
          "730-0803",
          "730-0804",
          "730-0036",
          "730-0043",
          "730-0845",
          "730-0844",
          "730-0842",
          "730-0843",
          "730-0847",
          "730-0841",
          "730-0033",
          "730-0802",
          "730-0035",
          "730-0029",
          "730-0054",
          "730-0055",
          "730-0049",
          "730-0826",
          "730-0011",
          "730-0027",
          "730-0023",
          "730-0824",
          "730-0822",
          "730-0823",
          "730-0821",
          "732-0000",
          "732-0045",
          "732-0054",
          "732-0067",
          "732-0068",
          "732-0065",
          "732-0066",
          "732-0062",
          "732-0063",
          "732-0064",
          "732-0061",
          "732-0031",
          "732-0035",
          "732-0046",
          "732-0047",
          "732-0049",
          "732-0056",
          "732-0032",
          "732-0022",
          "732-0027",
          "732-0028",
          "732-0021",
          "732-0026",
          "732-0023",
          "732-0025",
          "732-0024",
          "732-0033",
          "732-0034",
          "732-0051",
          "732-0052",
          "732-0055",
          "732-0043",
          "732-0029",
          "732-0036",
          "732-0057",
          "732-0016",
          "732-0014",
          "732-0017",
          "732-0008",
          "732-0007",
          "732-0005",
          "732-0006",
          "732-0015",
          "732-0012",
          "732-0009",
          "732-0001",
          "732-0018",
          "732-0003",
          "732-0004",
          "732-0002",
          "732-0013",
          "732-0011",
          "732-0042",
          "732-0044",
          "732-0041",
          "732-0048",
          "732-0053",
          "734-0000",
          "734-0053",
          "734-0036",
          "732-0827",
          "734-0011",
          "734-0004",
          "734-0015",
          "734-0003",
          "734-0014",
          "734-0016",
          "732-0823",
          "734-0041",
          "732-0821",
          "732-0802",
          "734-0037",
          "734-0021",
          "734-0042",
          "732-0828",
          "732-0825",
          "734-0032",
          "734-0064",
          "732-0807",
          "734-0022",
          "734-0023",
          "734-0033",
          "734-0034",
          "732-0811",
          "732-0818",
          "732-0814",
          "732-0819",
          "734-0054",
          "734-0001",
          "734-0013",
          "734-0002",
          "734-0044",
          "732-0804",
          "732-0806",
          "734-0045",
          "734-0006",
          "734-0017",
          "734-0026",
          "734-0057",
          "734-0024",
          "734-0027",
          "734-0031",
          "734-0051",
          "732-0801",
          "734-0046",
          "732-0805",
          "734-0025",
          "732-0815",
          "732-0816",
          "732-0817",
          "734-0052",
          "734-0047",
          "732-0826",
          "732-0822",
          "732-0824",
          "734-0005",
          "734-0043",
          "732-0803",
          "734-0007",
          "734-0063",
          "734-0056",
          "734-0055",
          "734-0061",
          "734-0062",
          "734-0012",
          "734-0035",
          "733-0000",
          "733-0845",
          "733-0842",
          "733-0843",
          "733-0841",
          "733-0844",
          "733-0004",
          "733-0831",
          "733-0001",
          "733-0007",
          "733-0025",
          "733-0021",
          "733-0036",
          "733-0033",
          "733-0031",
          "733-0864",
          "733-0834",
          "733-0862",
          "733-0865",
          "733-0861",
          "733-0863",
          "733-0832",
          "733-0002",
          "733-0815",
          "733-0816",
          "733-0813",
          "733-0814",
          "733-0812",
          "733-0811",
          "733-0822",
          "733-0823",
          "733-0821",
          "733-0833",
          "733-0801",
          "733-0852",
          "733-0871",
          "733-0876",
          "733-0851",
          "733-0022",
          "733-0012",
          "733-0037",
          "733-0032",
          "733-0024",
          "733-0875",
          "733-0873",
          "733-0872",
          "733-0874",
          "733-0877",
          "733-0006",
          "733-0003",
          "733-0802",
          "733-0005",
          "733-0805",
          "733-0035",
          "733-0034",
          "733-0023",
          "733-0853",
          "733-0854",
          "733-0804",
          "733-0013",
          "733-0011",
          "733-0803",
          "731-0100",
          "731-0141",
          "731-3166",
          "731-3173",
          "731-3167",
          "731-3174",
          "731-0126",
          "731-0124",
          "731-0125",
          "731-0154",
          "731-0102",
          "731-0138",
          "731-0142",
          "731-0144",
          "731-0143",
          "731-3163",
          "731-3171",
          "731-3165",
          "731-3169",
          "731-3175",
          "731-3164",
          "731-3172",
          "731-3168",
          "731-0121",
          "731-0122",
          "731-0135",
          "731-0136",
          "731-0113",
          "731-3271",
          "731-3161",
          "731-3272",
          "731-0111",
          "731-0112",
          "731-0152",
          "731-0151",
          "731-0123",
          "731-0103",
          "731-0101",
          "731-0153",
          "731-0137",
          "731-0139",
          "739-1700",
          "731-1142",
          "731-3352",
          "731-1171",
          "731-3363",
          "731-3362",
          "731-3351",
          "731-1141",
          "731-3354",
          "731-3355",
          "731-3353",
          "731-3361",
          "731-0201",
          "731-0202",
          "739-1754",
          "739-1731",
          "739-1732",
          "731-0221",
          "731-0236",
          "731-0234",
          "731-0225",
          "731-0235",
          "731-0216",
          "731-0217",
          "731-0214",
          "731-0224",
          "731-0215",
          "731-0222",
          "731-0223",
          "739-1752",
          "739-1742",
          "731-0231",
          "731-0233",
          "731-0232",
          "739-1753",
          "739-1734",
          "739-1733",
          "739-1743",
          "739-1414",
          "739-1413",
          "739-1411",
          "739-1301",
          "739-1412",
          "739-1302",
          "739-1303",
          "739-1521",
          "739-1751",
          "739-1741",
          "731-0211",
          "731-0212",
          "731-0213",
          "736-0000",
          "731-4231",
          "739-0301",
          "739-0302",
          "739-0303",
          "739-0311",
          "739-0312",
          "739-0315",
          "739-0313",
          "739-0314",
          "739-0321",
          "739-0322",
          "739-0324",
          "739-0323",
          "736-0088",
          "736-0089",
          "736-0081",
          "736-0082",
          "736-0084",
          "736-0087",
          "736-0083",
          "736-0085",
          "736-0086",
          "731-5100",
          "731-5133",
          "731-5107",
          "731-5109",
          "731-5162",
          "731-5108",
          "731-5127",
          "731-5125",
          "731-5161",
          "731-5128",
          "731-5102",
          "731-5104",
          "731-5105",
          "731-5151",
          "731-5152",
          "731-5123",
          "731-5116",
          "731-5115",
          "731-5121",
          "731-5122",
          "731-5135",
          "731-5134",
          "731-5138",
          "731-5157",
          "731-5156",
          "731-5153",
          "731-5101",
          "731-5155",
          "731-5126",
          "738-0514",
          "731-5145",
          "731-5141",
          "731-5142",
          "731-5131",
          "731-5106",
          "731-5103",
          "731-5144",
          "731-5113",
          "731-5111",
          "731-5114",
          "731-5112",
          "731-5124",
          "731-5137",
          "731-5143",
          "731-5154",
          "731-5146",
          "731-5147",
          "731-5117",
          "738-0603",
          "738-0512",
          "738-0513",
          "738-0722",
          "738-0721",
          "738-0511",
          "738-0602",
          "738-0601",
          "731-5132",
          "731-5136",
          "737-0000",
          "737-0023",
          "737-0003",
          "737-0004",
          "737-0001",
          "737-0005",
          "737-0056",
          "737-0076",
          "737-0804",
          "737-0061",
          "737-0872",
          "737-0807",
          "737-0878",
          "737-0915",
          "737-0914",
          "737-1212",
          "737-1203",
          "737-1204",
          "737-1213",
          "737-1206",
          "737-1216",
          "737-1201",
          "737-1217",
          "737-1211",
          "737-1207",
          "737-1215",
          "737-1202",
          "737-1214",
          "737-1205",
          "737-0823",
          "737-0402",
          "737-0403",
          "737-0401",
          "737-0311",
          "737-0808",
          "737-0031",
          "737-0817",
          "737-0071",
          "737-0079",
          "737-0054",
          "737-0862",
          "737-2631",
          "737-2634",
          "737-2637",
          "737-2614",
          "737-2633",
          "737-2632",
          "737-2606",
          "737-2605",
          "737-2604",
          "737-2617",
          "737-2608",
          "737-2636",
          "737-2615",
          "737-2603",
          "737-2609",
          "737-2601",
          "737-2607",
          "737-2616",
          "737-2602",
          "737-2635",
          "737-0026",
          "737-0836",
          "737-1377",
          "737-0012",
          "737-0163",
          "737-0162",
          "737-0161",
          "737-0803",
          "737-0028",
          "737-0821",
          "737-0021",
          "737-0873",
          "737-0022",
          "737-0302",
          "737-0301",
          "737-0303",
          "737-0055",
          "737-0027",
          "737-0835",
          "737-0923",
          "737-0834",
          "737-0815",
          "737-0029",
          "737-0051",
          "737-0822",
          "737-0014",
          "737-0033",
          "737-0875",
          "737-0881",
          "737-0884",
          "737-0883",
          "737-0882",
          "737-0885",
          "737-0874",
          "737-0876",
          "737-0922",
          "734-0103",
          "734-0102",
          "734-0101",
          "737-0921",
          "737-0046",
          "737-0035",
          "737-0871",
          "737-0053",
          "737-0153",
          "737-0154",
          "737-0151",
          "737-0145",
          "737-0155",
          "737-0152",
          "737-0156",
          "737-0146",
          "737-0157",
          "737-0816",
          "737-0818",
          "737-0827",
          "737-0806",
          "737-0825",
          "737-0838",
          "737-0074",
          "737-0062",
          "737-0809",
          "737-0064",
          "737-0811",
          "737-0075",
          "737-0812",
          "737-0833",
          "737-0831",
          "737-0828",
          "737-0805",
          "737-0824",
          "737-0837",
          "737-0073",
          "737-0063",
          "737-0801",
          "737-0052",
          "737-0072",
          "737-0813",
          "737-0078",
          "737-0101",
          "737-0142",
          "737-0138",
          "737-0141",
          "737-0111",
          "737-0122",
          "737-0112",
          "737-0137",
          "737-0103",
          "737-0143",
          "737-0144",
          "737-0133",
          "737-0134",
          "737-0135",
          "737-0102",
          "737-0105",
          "737-0124",
          "737-0131",
          "737-0136",
          "737-0132",
          "737-0114",
          "737-0107",
          "737-0125",
          "737-0002",
          "737-0115",
          "737-0104",
          "737-0106",
          "737-0113",
          "737-0121",
          "737-0123",
          "737-0077",
          "737-0015",
          "737-0065",
          "737-0045",
          "737-0032",
          "737-0013",
          "737-0034",
          "737-0802",
          "737-0011",
          "737-0024",
          "737-0025",
          "737-0904",
          "737-0913",
          "737-0902",
          "737-0933",
          "737-0935",
          "737-0901",
          "737-0912",
          "737-0934",
          "737-0932",
          "737-0931",
          "737-0908",
          "737-0936",
          "737-0903",
          "737-0924",
          "737-0911",
          "737-0906",
          "737-0905",
          "737-0907",
          "737-2511",
          "737-2503",
          "737-2512",
          "737-2513",
          "737-2507",
          "737-2518",
          "737-2519",
          "737-2505",
          "737-2501",
          "737-2509",
          "737-2516",
          "737-2515",
          "737-2514",
          "737-2504",
          "737-2508",
          "737-2506",
          "737-2517",
          "737-2502",
          "737-0044",
          "737-0814",
          "737-0877",
          "734-0301",
          "734-0303",
          "734-0304",
          "734-0302",
          "737-0844",
          "737-0865",
          "737-0867",
          "737-0851",
          "737-0845",
          "737-0841",
          "737-0843",
          "737-0853",
          "737-0864",
          "737-0852",
          "737-0842",
          "737-0861",
          "737-0866",
          "737-0863",
          "737-0846",
          "737-0854",
          "737-0826",
          "737-0832",
          "737-0041",
          "737-0043",
          "737-0042",
          "725-0000",
          "725-0011",
          "725-0025",
          "725-0012",
          "725-0003",
          "729-2313",
          "725-0021",
          "729-2311",
          "729-2314",
          "729-2315",
          "729-2316",
          "729-2317",
          "725-0023",
          "725-0001",
          "725-0026",
          "725-0005",
          "725-0002",
          "725-0004",
          "729-2312",
          "725-0022",
          "725-0024",
          "725-0013",
          "723-0000",
          "723-0047",
          "723-0012",
          "729-0324",
          "729-0329",
          "723-0015",
          "723-0066",
          "723-0033",
          "729-0322",
          "723-0131",
          "723-0043",
          "723-0053",
          "729-0321",
          "722-1301",
          "722-1411",
          "722-1304",
          "722-1417",
          "722-1414",
          "722-1303",
          "722-1415",
          "722-1413",
          "722-1416",
          "722-1302",
          "722-1412",
          "729-2361",
          "723-0013",
          "723-0006",
          "729-2251",
          "729-2252",
          "729-2253",
          "723-0021",
          "723-0022",
          "723-0005",
          "729-0414",
          "723-0014",
          "723-0134",
          "723-0031",
          "723-0032",
          "723-0035",
          "723-0044",
          "729-1212",
          "729-1323",
          "729-1211",
          "729-1332",
          "729-1405",
          "729-1401",
          "729-1402",
          "729-1333",
          "729-1406",
          "729-1403",
          "729-1322",
          "729-1213",
          "729-1404",
          "729-1331",
          "729-1321",
          "729-0472",
          "729-0471",
          "723-0045",
          "723-0003",
          "723-0002",
          "723-0007",
          "723-0132",
          "723-0065",
          "723-0063",
          "723-0064",
          "723-0133",
          "729-0473",
          "729-0474",
          "729-0475",
          "723-0145",
          "723-0143",
          "723-0148",
          "723-0144",
          "723-0142",
          "723-0146",
          "723-0147",
          "723-0141",
          "723-0034",
          "729-0323",
          "723-0011",
          "723-0001",
          "729-0418",
          "729-0417",
          "729-0415",
          "729-0416",
          "722-1401",
          "729-0411",
          "729-0412",
          "729-0413",
          "723-0062",
          "723-0017",
          "723-0052",
          "729-0419",
          "723-0051",
          "723-0016",
          "723-0046",
          "723-0004",
          "723-0061",
          "722-1501",
          "722-1511",
          "722-1512",
          "722-1516",
          "722-1515",
          "722-1513",
          "722-1514",
          "723-0054",
          "723-0042",
          "723-0041",
          "722-0000",
          "722-2101",
          "722-2212",
          "722-2102",
          "722-2431",
          "722-2324",
          "722-2213",
          "722-2211",
          "722-2323",
          "722-2432",
          "722-2322",
          "722-2321",
          "720-0551",
          "722-0006",
          "722-0053",
          "722-0054",
          "722-0016",
          "722-0233",
          "722-0234",
          "722-0235",
          "722-0232",
          "722-0231",
          "722-0045",
          "722-0042",
          "722-0025",
          "722-0026",
          "722-0022",
          "722-0002",
          "722-0011",
          "722-0031",
          "722-0052",
          "722-0012",
          "722-0004",
          "722-0055",
          "722-0014",
          "722-2403",
          "722-2412",
          "722-2413",
          "722-2414",
          "722-2411",
          "722-2404",
          "722-2415",
          "722-2416",
          "722-2405",
          "722-2401",
          "722-2402",
          "722-2417",
          "729-0141",
          "722-0221",
          "722-0035",
          "722-0001",
          "722-0038",
          "722-0047",
          "722-0034",
          "722-0046",
          "722-0044",
          "722-0037",
          "722-0032",
          "722-0024",
          "729-0142",
          "722-0201",
          "722-0202",
          "722-0051",
          "722-0043",
          "722-0036",
          "722-0033",
          "722-0023",
          "722-0003",
          "722-0021",
          "722-0013",
          "722-0018",
          "722-0005",
          "722-0041",
          "722-0354",
          "722-0311",
          "722-1564",
          "722-0326",
          "722-1563",
          "722-0336",
          "722-0342",
          "722-0351",
          "722-0314",
          "722-0403",
          "722-0312",
          "722-0315",
          "722-0341",
          "722-0335",
          "722-0352",
          "722-0322",
          "722-0402",
          "722-0334",
          "722-0401",
          "722-0323",
          "722-0333",
          "722-0353",
          "722-1562",
          "722-0345",
          "722-0325",
          "722-0331",
          "722-1565",
          "722-0324",
          "722-0316",
          "722-0313",
          "722-0332",
          "722-1561",
          "722-0321",
          "722-0343",
          "722-0344",
          "722-0355",
          "722-0214",
          "722-0213",
          "722-0211",
          "722-0212",
          "722-0215",
          "722-0073",
          "722-0072",
          "722-0071",
          "722-0062",
          "722-0061",
          "722-0017",
          "722-0015",
          "722-0008",
          "722-0007",
          "721-0000",
          "721-0911",
          "720-0843",
          "720-0844",
          "721-0952",
          "720-0033",
          "720-1261",
          "720-1262",
          "720-1263",
          "720-1265",
          "720-0845",
          "720-1264",
          "721-0915",
          "721-0953",
          "729-0111",
          "720-0046",
          "720-0801",
          "722-2641",
          "722-2631",
          "722-2632",
          "722-2633",
          "720-2525",
          "720-1145",
          "720-1141",
          "720-1146",
          "720-1142",
          "720-1143",
          "720-1132",
          "720-2524",
          "720-1133",
          "720-1134",
          "720-2523",
          "720-2522",
          "720-2521",
          "720-2413",
          "720-1144",
          "720-1131",
          "720-1147",
          "720-1135",
          "720-0055",
          "721-0965",
          "721-0914",
          "720-0825",
          "721-0954",
          "720-0044",
          "720-0091",
          "721-0917",
          "721-0916",
          "721-0907",
          "721-0901",
          "721-0902",
          "721-0908",
          "720-0812",
          "720-0541",
          "720-0542",
          "729-0112",
          "720-2417",
          "720-2416",
          "720-2419",
          "720-2415",
          "720-2412",
          "720-2418",
          "720-2410",
          "720-2414",
          "720-0822",
          "720-2113",
          "720-2111",
          "720-2114",
          "720-2123",
          "720-2124",
          "720-2117",
          "720-2115",
          "720-2106",
          "720-2105",
          "720-2108",
          "720-2125",
          "720-2107",
          "720-2122",
          "720-2126",
          "720-2103",
          "720-2127",
          "720-2102",
          "720-2116",
          "720-2101",
          "720-2104",
          "720-2112",
          "720-2121",
          "720-0074",
          "720-0023",
          "720-0073",
          "720-0082",
          "720-0831",
          "720-0411",
          "721-0931",
          "720-0814",
          "720-0093",
          "720-0081",
          "721-0971",
          "720-0051",
          "720-0835",
          "720-0066",
          "720-0816",
          "720-0025",
          "721-0929",
          "720-0808",
          "720-0054",
          "729-3111",
          "729-3106",
          "729-3102",
          "729-3105",
          "729-3103",
          "729-3107",
          "729-3101",
          "729-3112",
          "729-3104",
          "721-0955",
          "721-0951",
          "720-0809",
          "720-0838",
          "720-0837",
          "720-0836",
          "720-0017",
          "720-0015",
          "720-0013",
          "720-0014",
          "720-0016",
          "729-0106",
          "729-0101",
          "729-0102",
          "729-0103",
          "720-0024",
          "720-0045",
          "720-0824",
          "720-0203",
          "720-0053",
          "721-0926",
          "721-0924",
          "721-0922",
          "721-0925",
          "721-0921",
          "721-0927",
          "721-0923",
          "720-0075",
          "720-0823",
          "720-0842",
          "720-0841",
          "721-0903",
          "721-0904",
          "721-0966",
          "720-0041",
          "720-0813",
          "721-0912",
          "720-0202",
          "720-0201",
          "720-0022",
          "720-0818",
          "721-0958",
          "721-0975",
          "720-0067",
          "720-0401",
          "720-0311",
          "720-0403",
          "720-0313",
          "720-0402",
          "720-0312",
          "721-0906",
          "720-0815",
          "720-0064",
          "720-0204",
          "720-0803",
          "720-0821",
          "720-0065",
          "721-0962",
          "721-0974",
          "720-0052",
          "720-0839",
          "729-0251",
          "720-0071",
          "721-0942",
          "721-0941",
          "721-0944",
          "721-0945",
          "720-0083",
          "721-0972",
          "720-0062",
          "720-0543",
          "720-0043",
          "720-0817",
          "721-0943",
          "729-0252",
          "720-0076",
          "720-0056",
          "721-0913",
          "729-0104",
          "720-0802",
          "720-0061",
          "720-0805",
          "720-0804",
          "721-0964",
          "729-0115",
          "721-0973",
          "721-0963",
          "720-0077",
          "720-0806",
          "729-0105",
          "721-0956",
          "721-0957",
          "720-0832",
          "720-0833",
          "720-0042",
          "729-0113",
          "720-0001",
          "720-0002",
          "720-0004",
          "720-0003",
          "720-0834",
          "721-0961",
          "720-0031",
          "720-0032",
          "720-0807",
          "720-0063",
          "720-0811",
          "729-0114",
          "720-0092",
          "720-2601",
          "720-2602",
          "720-0011",
          "720-0072",
          "720-0021",
          "720-0034",
          "726-0000",
          "729-3212",
          "726-0031",
          "726-0002",
          "726-0034",
          "722-0432",
          "726-0025",
          "729-3221",
          "729-3211",
          "729-3222",
          "726-0023",
          "726-0036",
          "726-0006",
          "726-0026",
          "726-0027",
          "729-3405",
          "729-3411",
          "729-3412",
          "729-3401",
          "729-3422",
          "729-3402",
          "729-3414",
          "729-3403",
          "729-3431",
          "729-3421",
          "729-3404",
          "729-3424",
          "729-3413",
          "729-3415",
          "729-3423",
          "726-0024",
          "726-0013",
          "726-0035",
          "726-0032",
          "729-3201",
          "726-0012",
          "726-0021",
          "726-0011",
          "726-0004",
          "726-0005",
          "729-3202",
          "726-0033",
          "726-0003",
          "726-0001",
          "722-0431",
          "726-0022",
          "728-0000",
          "728-0024",
          "729-6335",
          "728-0004",
          "728-0625",
          "728-0025",
          "728-0623",
          "729-6212",
          "728-0624",
          "728-0005",
          "728-0622",
          "729-6215",
          "729-6211",
          "728-0007",
          "729-6334",
          "729-6332",
          "729-4223",
          "729-4205",
          "729-4202",
          "729-4211",
          "729-4226",
          "729-4221",
          "729-4207",
          "729-4201",
          "729-4224",
          "729-4225",
          "729-4227",
          "729-4222",
          "729-4204",
          "729-4206",
          "729-4203",
          "729-4208",
          "729-6204",
          "728-0404",
          "728-0405",
          "728-0402",
          "728-0401",
          "728-0406",
          "728-0403",
          "728-0407",
          "729-4106",
          "729-4104",
          "729-4105",
          "729-4113",
          "729-4102",
          "729-4112",
          "729-4103",
          "729-4111",
          "729-4101",
          "729-6216",
          "728-0111",
          "728-0115",
          "728-0121",
          "728-0132",
          "728-0101",
          "728-0123",
          "728-0131",
          "728-0124",
          "728-0122",
          "728-0125",
          "728-0114",
          "728-0112",
          "728-0113",
          "728-0133",
          "729-6205",
          "729-6203",
          "728-0016",
          "729-6333",
          "729-6331",
          "729-6214",
          "728-0012",
          "728-0013",
          "728-0011",
          "728-0014",
          "728-0015",
          "728-0002",
          "728-0022",
          "728-0006",
          "728-0003",
          "728-0023",
          "728-0026",
          "728-0201",
          "728-0202",
          "728-0203",
          "728-0211",
          "728-0017",
          "728-0027",
          "728-0021",
          "729-4306",
          "729-4307",
          "729-4308",
          "729-4305",
          "729-4302",
          "729-4303",
          "729-4301",
          "729-4304",
          "728-0621",
          "729-6613",
          "729-6701",
          "729-6615",
          "729-6612",
          "729-6702",
          "729-6616",
          "729-6614",
          "729-6611",
          "729-6202",
          "729-6213",
          "728-0001",
          "729-6201",
          "727-0000",
          "727-0014",
          "727-0025",
          "727-0624",
          "727-0001",
          "729-6143",
          "729-5812",
          "727-0026",
          "727-0022",
          "727-0203",
          "727-0005",
          "729-5813",
          "729-6134",
          "728-0503",
          "727-0112",
          "728-0504",
          "727-0113",
          "727-0114",
          "728-0501",
          "728-0502",
          "727-0111",
          "729-6142",
          "727-0003",
          "729-5733",
          "729-5722",
          "729-5744",
          "729-5603",
          "729-5741",
          "729-5732",
          "729-5612",
          "729-5731",
          "729-5743",
          "729-5742",
          "729-5613",
          "729-5721",
          "729-5601",
          "729-5723",
          "729-5745",
          "729-5611",
          "729-5602",
          "727-0015",
          "727-0621",
          "727-0004",
          "729-3721",
          "729-3712",
          "729-3702",
          "729-3722",
          "729-3701",
          "729-3711",
          "729-3703",
          "729-3713",
          "727-0002",
          "727-0425",
          "727-0403",
          "727-0422",
          "727-0411",
          "727-0424",
          "727-0412",
          "727-0423",
          "727-0402",
          "727-0421",
          "727-0413",
          "727-0401",
          "729-5811",
          "727-0024",
          "729-5127",
          "729-5128",
          "729-5453",
          "729-5502",
          "729-5504",
          "729-5501",
          "729-5506",
          "729-5454",
          "729-5125",
          "729-5121",
          "729-5122",
          "729-5505",
          "729-5112",
          "729-5131",
          "729-5452",
          "729-5241",
          "729-5243",
          "729-5244",
          "729-5242",
          "729-5451",
          "729-5126",
          "729-5503",
          "729-5123",
          "729-5124",
          "729-5111",
          "729-5132",
          "729-5456",
          "729-5455",
          "727-0017",
          "729-6133",
          "727-0008",
          "727-0012",
          "727-0023",
          "727-0202",
          "727-0013",
          "727-0011",
          "727-0016",
          "727-0302",
          "727-0312",
          "727-0301",
          "727-0311",
          "727-0321",
          "729-6144",
          "729-6132",
          "727-0006",
          "727-0623",
          "729-6141",
          "727-0021",
          "727-0622",
          "727-0007",
          "727-0201",
          "729-6131",
          "739-0600",
          "739-0607",
          "739-0634",
          "739-0637",
          "739-0623",
          "739-0628",
          "739-0627",
          "739-0654",
          "739-0632",
          "739-0604",
          "739-0651",
          "739-0656",
          "739-0644",
          "739-0646",
          "739-0642",
          "739-0645",
          "739-0643",
          "739-0641",
          "739-0653",
          "739-0616",
          "739-0614",
          "739-0611",
          "739-0605",
          "739-0603",
          "739-0635",
          "739-0622",
          "739-0601",
          "739-0633",
          "739-0631",
          "739-0613",
          "739-0636",
          "739-0657",
          "739-0624",
          "739-0625",
          "739-0626",
          "739-0621",
          "739-0602",
          "739-0606",
          "739-0652",
          "739-0615",
          "739-0612",
          "739-0655",
          "739-0000",
          "739-2404",
          "739-2403",
          "739-2401",
          "739-2405",
          "739-2402",
          "739-0046",
          "739-0045",
          "739-2631",
          "739-2615",
          "739-2619",
          "739-2618",
          "739-2627",
          "739-2629",
          "739-2628",
          "739-2614",
          "739-2626",
          "739-2611",
          "739-2501",
          "739-2731",
          "739-2616",
          "739-2625",
          "739-2623",
          "739-2617",
          "739-2502",
          "739-2624",
          "739-2732",
          "739-2613",
          "739-2622",
          "739-2612",
          "739-2503",
          "739-2621",
          "739-2504",
          "739-2206",
          "739-2207",
          "739-2203",
          "739-2204",
          "739-2202",
          "739-2205",
          "739-2201",
          "739-2208",
          "739-2211",
          "739-0012",
          "739-0005",
          "739-0016",
          "739-0006",
          "739-0013",
          "739-0015",
          "739-0047",
          "739-0014",
          "739-0004",
          "739-0025",
          "739-0007",
          "739-0043",
          "739-0048",
          "739-0011",
          "739-0008",
          "739-0033",
          "739-0034",
          "739-0022",
          "739-0035",
          "739-0001",
          "739-0042",
          "739-0041",
          "739-0044",
          "739-0023",
          "739-0021",
          "739-0036",
          "739-0003",
          "739-0031",
          "739-0024",
          "739-0032",
          "739-0002",
          "739-0040",
          "739-0049",
          "739-0263",
          "739-0261",
          "739-0266",
          "739-0265",
          "739-0264",
          "739-0268",
          "739-0262",
          "739-0269",
          "739-0267",
          "739-2116",
          "739-2115",
          "739-2117",
          "739-2106",
          "739-2104",
          "739-2102",
          "739-2124",
          "739-2121",
          "739-2112",
          "739-2122",
          "739-2114",
          "739-2101",
          "739-2113",
          "739-2111",
          "739-2125",
          "739-2105",
          "739-2123",
          "739-2103",
          "739-0038",
          "739-2316",
          "739-2314",
          "739-2317",
          "739-2313",
          "739-2318",
          "739-2311",
          "739-2312",
          "739-2315",
          "739-0037",
          "739-2209",
          "739-0146",
          "739-0147",
          "739-0142",
          "739-0144",
          "739-0141",
          "739-0131",
          "739-0132",
          "739-0151",
          "739-0145",
          "739-0152",
          "739-0133",
          "739-2301",
          "739-2304",
          "739-2303",
          "739-2302",
          "739-0026",
          "739-0153",
          "738-0000",
          "738-0223",
          "738-0054",
          "738-0053",
          "738-0051",
          "738-0055",
          "738-0052",
          "738-0056",
          "738-0226",
          "739-0442",
          "738-0011",
          "739-0664",
          "739-0478",
          "739-0479",
          "739-0667",
          "739-0463",
          "739-0456",
          "739-0423",
          "739-0407",
          "738-0281",
          "739-0661",
          "739-0461",
          "739-0446",
          "739-0459",
          "739-0403",
          "739-0457",
          "739-0404",
          "739-0462",
          "739-0422",
          "739-0408",
          "739-0475",
          "739-0476",
          "739-0466",
          "739-0472",
          "739-0473",
          "739-0437",
          "739-0474",
          "739-0405",
          "739-0467",
          "739-0406",
          "739-0458",
          "739-0663",
          "739-0471",
          "739-0477",
          "739-0464",
          "739-0665",
          "738-0282",
          "739-0434",
          "739-0488",
          "739-0441",
          "738-0006",
          "739-0443",
          "738-0016",
          "739-0432",
          "738-0026",
          "738-0204",
          "738-0033",
          "738-0205",
          "738-0224",
          "738-0001",
          "738-0003",
          "738-0004",
          "738-0005",
          "738-0002",
          "739-0445",
          "738-0036",
          "738-0038",
          "738-0042",
          "738-0043",
          "739-0433",
          "738-0023",
          "738-0007",
          "738-0024",
          "738-0017",
          "738-0014",
          "739-0402",
          "738-0222",
          "738-0012",
          "738-0202",
          "738-0203",
          "738-0201",
          "738-0225",
          "738-0013",
          "739-0455",
          "739-0444",
          "738-0031",
          "739-0421",
          "739-0401",
          "738-0025",
          "738-0027",
          "738-0015",
          "739-0424",
          "739-0452",
          "738-0032",
          "738-0034",
          "738-0039",
          "739-0411",
          "739-0413",
          "739-0412",
          "739-0414",
          "739-0541",
          "739-0511",
          "739-0515",
          "739-0505",
          "739-0507",
          "739-0521",
          "739-0513",
          "739-0531",
          "739-0535",
          "739-0552",
          "739-0559",
          "739-0551",
          "739-0525",
          "739-0555",
          "739-0556",
          "739-0554",
          "739-0557",
          "739-0516",
          "739-0518",
          "739-0536",
          "739-0512",
          "739-0501",
          "739-0502",
          "739-0524",
          "739-0542",
          "739-0523",
          "739-0553",
          "739-0558",
          "739-0534",
          "739-0550",
          "739-0532",
          "739-0514",
          "739-0503",
          "739-0506",
          "739-0504",
          "739-0533",
          "739-0522",
          "739-0543",
          "739-0517",
          "739-0588",
          "738-0035",
          "738-0037",
          "739-0454",
          "738-0221",
          "738-0021",
          "738-0022",
          "739-0425",
          "739-0426",
          "738-0060",
          "738-0301",
          "738-0041",
          "731-0500",
          "739-1106",
          "739-1102",
          "739-1104",
          "739-1103",
          "739-1105",
          "739-1107",
          "739-1101",
          "739-1108",
          "739-1801",
          "739-1806",
          "739-1802",
          "739-1807",
          "739-1805",
          "739-1803",
          "739-1804",
          "731-0703",
          "731-0701",
          "731-0702",
          "731-0612",
          "731-0611",
          "739-1204",
          "739-1201",
          "739-1202",
          "739-1203",
          "739-1205",
          "731-0302",
          "731-0305",
          "731-0303",
          "731-0304",
          "731-0301",
          "731-0306",
          "731-0542",
          "731-0512",
          "731-0534",
          "731-0532",
          "731-0524",
          "731-0502",
          "731-0535",
          "731-0531",
          "731-0522",
          "731-0511",
          "731-0544",
          "731-0525",
          "731-0521",
          "731-0533",
          "731-0543",
          "731-0513",
          "731-0523",
          "731-0541",
          "731-0501",
          "737-2100",
          "737-2131",
          "737-2113",
          "737-2125",
          "737-2111",
          "737-2132",
          "737-2112",
          "737-2123",
          "737-2121",
          "737-2122",
          "737-2126",
          "737-2124",
          "737-2133",
          "737-2212",
          "737-2213",
          "737-2215",
          "737-2211",
          "737-2101",
          "737-2214",
          "737-2311",
          "737-2315",
          "737-2313",
          "737-2312",
          "737-2314",
          "737-2316",
          "737-2302",
          "737-2303",
          "737-2301",
          "735-0000",
          "735-0016",
          "735-0015",
          "735-0017",
          "735-0007",
          "735-0021",
          "735-0022",
          "735-0025",
          "735-0001",
          "735-0002",
          "735-0009",
          "735-0028",
          "735-0011",
          "735-0027",
          "735-0008",
          "735-0013",
          "735-0023",
          "735-0006",
          "735-0003",
          "735-0024",
          "735-0005",
          "735-0029",
          "735-0026",
          "735-0014",
          "735-0012",
          "735-0004",
          "736-0031",
          "736-0004",
          "736-0012",
          "736-0067",
          "736-0005",
          "736-0025",
          "736-0022",
          "736-0061",
          "736-0002",
          "736-0046",
          "736-0053",
          "736-0026",
          "736-0043",
          "736-0064",
          "736-0062",
          "736-0068",
          "736-0001",
          "736-0003",
          "736-0041",
          "736-0034",
          "736-0051",
          "736-0011",
          "736-0066",
          "736-0021",
          "736-0024",
          "736-0054",
          "736-0023",
          "736-0013",
          "736-0071",
          "736-0063",
          "736-0035",
          "736-0045",
          "736-0014",
          "736-0032",
          "736-0065",
          "736-0042",
          "736-0052",
          "736-0044",
          "736-0033",
          "736-0055",
          "736-0056",
          "731-4200",
          "731-4225",
          "731-4228",
          "731-4223",
          "731-4224",
          "731-4227",
          "731-4222",
          "731-4215",
          "731-4211",
          "731-4221",
          "731-4214",
          "731-4213",
          "731-4212",
          "731-4226",
          "731-4229",
          "731-4300",
          "731-4301",
          "731-4321",
          "731-4311",
          "731-4331",
          "731-4313",
          "731-4314",
          "731-4325",
          "731-4312",
          "731-4323",
          "731-4324",
          "731-4322",
          "731-3500",
          "731-3812",
          "731-3411",
          "731-3833",
          "731-3551",
          "731-3844",
          "731-3501",
          "731-3832",
          "731-3701",
          "731-3664",
          "731-3831",
          "731-3503",
          "731-3835",
          "731-3621",
          "731-3622",
          "731-3824",
          "731-3813",
          "731-3842",
          "731-3502",
          "731-3412",
          "731-3821",
          "731-3810",
          "731-3702",
          "731-3845",
          "731-3552",
          "731-3834",
          "731-3801",
          "731-3843",
          "731-1500",
          "731-1222",
          "731-1533",
          "731-1503",
          "731-2106",
          "731-1525",
          "731-2321",
          "731-1535",
          "731-1221",
          "731-2102",
          "731-1534",
          "731-2442",
          "731-2206",
          "731-2104",
          "731-2204",
          "731-2107",
          "731-2315",
          "731-2437",
          "731-2324",
          "731-2312",
          "731-1703",
          "731-1702",
          "731-2317",
          "731-1513",
          "731-2323",
          "731-1501",
          "731-1516",
          "731-1512",
          "731-1524",
          "731-2313",
          "731-1502",
          "731-2431",
          "731-2203",
          "731-1532",
          "731-2314",
          "731-1701",
          "731-1704",
          "731-1514",
          "731-1522",
          "731-2103",
          "731-1511",
          "731-2435",
          "731-2201",
          "731-2105",
          "731-1712",
          "731-2311",
          "731-1504",
          "731-1711",
          "731-1713",
          "731-2432",
          "731-1706",
          "731-1506",
          "731-2316",
          "731-1705",
          "731-2552",
          "731-2434",
          "731-1531",
          "731-2551",
          "731-3561",
          "731-2322",
          "731-1526",
          "731-2436",
          "731-2202",
          "731-1523",
          "731-1515",
          "731-2101",
          "731-2441",
          "731-1505",
          "731-1521",
          "731-1714",
          "731-1223",
          "731-2433",
          "731-2205",
          "725-0200",
          "725-0403",
          "725-0303",
          "725-0402",
          "725-0401",
          "725-0301",
          "725-0302",
          "725-0231",
          "722-1100",
          "729-3306",
          "722-1627",
          "722-1116",
          "729-3304",
          "729-3307",
          "722-1113",
          "722-0411",
          "722-1701",
          "722-1122",
          "729-3301",
          "729-6714",
          "722-1626",
          "729-3302",
          "722-1204",
          "722-1621",
          "729-6711",
          "722-1732",
          "722-1123",
          "722-1117",
          "722-1625",
          "729-6715",
          "722-1731",
          "722-1111",
          "722-1624",
          "722-1203",
          "722-1201",
          "729-6713",
          "729-6716",
          "722-1623",
          "722-1121",
          "722-1115",
          "729-3303",
          "722-1114",
          "729-3305",
          "722-1622",
          "722-1112",
          "722-1202",
          "722-1702",
          "729-6712",
          "720-1800",
          "729-3601",
          "720-1521",
          "720-1701",
          "720-1602",
          "720-1624",
          "720-1601",
          "720-1901",
          "720-1525",
          "720-1702",
          "720-1523",
          "720-1416",
          "729-3512",
          "720-1414",
          "720-1522",
          "720-1604",
          "720-1703",
          "720-1415",
          "720-1704",
          "720-1902",
          "720-1621",
          "720-1410",
          "729-3511",
          "729-3514",
          "720-1622",
          "720-1413",
          "720-1524",
          "720-1603",
          "720-1705",
          "729-3602",
          "720-1623",
          "729-3515",
          "729-3516",
          "729-3513",
          "720-1412",
          "720-1411",
          "720-1811",
          "720-1812",
          "750-0000",
          "752-0902",
          "751-0846",
          "751-0841",
          "750-0007",
          "751-0871",
          "751-0878",
          "751-0874",
          "751-0877",
          "751-0873",
          "751-0872",
          "751-0876",
          "751-0875",
          "750-0003",
          "751-0866",
          "751-0865",
          "751-0849",
          "751-0848",
          "751-0868",
          "750-0036",
          "751-0832",
          "751-0862",
          "751-0869",
          "751-0861",
          "751-0863",
          "751-0864",
          "750-0065",
          "751-0825",
          "751-0886",
          "751-0881",
          "751-0817",
          "751-0807",
          "751-0805",
          "751-0809",
          "751-0808",
          "751-0806",
          "750-0064",
          "750-0013",
          "750-0027",
          "750-0251",
          "751-0826",
          "750-0252",
          "750-0253",
          "750-1111",
          "752-0923",
          "750-1115",
          "750-1114",
          "752-0916",
          "752-0912",
          "752-0911",
          "752-0915",
          "752-0924",
          "750-1171",
          "750-0051",
          "750-1147",
          "750-1143",
          "750-1134",
          "750-1146",
          "750-1136",
          "750-1141",
          "750-1145",
          "750-1133",
          "750-1144",
          "750-1131",
          "750-1135",
          "750-1142",
          "750-1137",
          "750-1132",
          "751-0887",
          "751-0818",
          "759-6614",
          "750-0031",
          "752-0904",
          "752-0903",
          "751-0884",
          "751-0888",
          "751-0885",
          "750-0061",
          "750-0009",
          "752-0925",
          "759-6602",
          "750-0005",
          "751-0859",
          "751-0853",
          "750-0032",
          "750-0022",
          "752-0907",
          "750-0044",
          "750-0012",
          "750-0311",
          "750-0321",
          "750-0314",
          "750-0307",
          "750-0325",
          "750-0305",
          "750-0324",
          "750-0312",
          "750-0317",
          "750-0306",
          "750-0313",
          "750-0315",
          "750-0322",
          "750-0301",
          "750-0323",
          "750-0302",
          "750-0304",
          "750-0303",
          "750-0316",
          "751-0823",
          "750-1151",
          "750-1156",
          "750-1153",
          "750-1162",
          "750-1152",
          "750-1163",
          "750-1164",
          "750-1155",
          "750-1161",
          "750-1154",
          "751-0804",
          "751-0852",
          "751-0851",
          "750-0041",
          "750-1112",
          "750-1113",
          "750-0058",
          "752-0921",
          "750-0001",
          "750-0049",
          "750-0035",
          "750-0024",
          "750-0059",
          "751-0801",
          "751-0802",
          "750-1116",
          "751-0843",
          "751-0844",
          "751-0842",
          "751-0845",
          "750-0063",
          "750-0062",
          "751-0820",
          "750-0057",
          "750-0056",
          "750-0053",
          "752-0991",
          "751-0822",
          "751-0883",
          "751-0882",
          "750-0025",
          "751-0833",
          "751-0819",
          "750-0008",
          "751-0831",
          "751-0814",
          "752-0922",
          "752-0914",
          "750-0042",
          "752-0962",
          "752-0957",
          "752-0952",
          "752-0971",
          "752-0927",
          "752-0959",
          "752-0958",
          "752-0966",
          "752-0979",
          "752-0980",
          "752-0986",
          "752-0989",
          "752-0954",
          "752-0968",
          "752-0928",
          "752-0978",
          "752-0942",
          "752-0941",
          "752-0982",
          "752-0970",
          "752-0985",
          "752-0994",
          "752-0961",
          "752-0945",
          "752-0974",
          "752-0946",
          "752-0963",
          "752-0964",
          "752-0973",
          "752-0975",
          "752-0944",
          "752-0992",
          "752-0987",
          "752-0988",
          "752-0993",
          "752-0998",
          "752-0995",
          "752-0977",
          "752-0951",
          "752-0972",
          "752-0943",
          "752-0956",
          "752-0935",
          "752-0934",
          "752-0937",
          "752-0936",
          "752-0932",
          "752-0933",
          "752-0983",
          "752-0948",
          "752-0947",
          "752-0965",
          "752-0953",
          "752-0976",
          "752-0984",
          "752-0967",
          "752-0996",
          "752-0955",
          "759-6613",
          "759-6314",
          "759-6303",
          "759-6301",
          "759-6312",
          "759-6302",
          "759-6313",
          "759-6315",
          "759-6316",
          "759-6311",
          "759-6317",
          "752-0981",
          "750-0451",
          "750-0404",
          "750-0403",
          "750-0412",
          "750-0442",
          "750-0431",
          "750-0415",
          "750-0411",
          "750-0452",
          "750-0433",
          "750-0455",
          "750-0413",
          "750-0402",
          "750-0432",
          "750-0416",
          "750-0446",
          "750-0453",
          "750-0401",
          "750-0421",
          "750-0441",
          "750-0422",
          "750-0423",
          "750-0454",
          "750-0425",
          "750-0444",
          "750-0445",
          "750-0443",
          "750-0405",
          "750-0414",
          "750-0424",
          "750-0004",
          "750-0023",
          "750-0021",
          "750-0028",
          "750-0029",
          "759-6534",
          "759-6533",
          "750-0026",
          "750-0006",
          "750-0015",
          "750-0054",
          "750-0034",
          "752-0905",
          "752-0913",
          "751-0867",
          "751-0830",
          "751-0827",
          "751-0829",
          "751-0828",
          "750-0014",
          "750-0046",
          "751-0856",
          "751-0855",
          "751-0854",
          "751-0857",
          "751-0858",
          "750-0043",
          "752-0906",
          "751-0879",
          "750-0048",
          "750-0066",
          "750-0071",
          "750-0075",
          "750-0073",
          "750-0072",
          "750-0083",
          "750-0092",
          "750-0086",
          "750-0078",
          "750-0081",
          "750-0094",
          "750-0085",
          "750-0076",
          "750-0077",
          "750-0093",
          "750-0087",
          "750-0074",
          "750-0091",
          "750-0084",
          "750-0082",
          "759-6601",
          "751-0811",
          "750-0052",
          "750-0018",
          "759-6542",
          "751-0847",
          "759-5241",
          "759-5101",
          "759-5331",
          "759-5513",
          "759-6121",
          "759-5511",
          "759-5512",
          "759-5332",
          "759-6122",
          "750-0017",
          "750-0016",
          "751-0815",
          "751-0803",
          "752-0997",
          "752-0931",
          "750-1121",
          "750-1122",
          "750-1123",
          "750-1124",
          "750-0019",
          "751-0821",
          "750-0055",
          "751-0813",
          "750-0002",
          "750-0047",
          "751-0812",
          "751-0816",
          "750-0095",
          "750-0011",
          "750-0045",
          "759-6612",
          "759-6603",
          "759-6611",
          "752-0901",
          "750-0033",
          "750-0067",
          "751-0824",
          "751-0837",
          "751-0834",
          "751-0836",
          "751-0835",
          "751-0839",
          "751-0838",
          "752-0926",
          "759-6604",
          "750-1101",
          "750-1102",
          "759-6524",
          "759-6523",
          "759-6521",
          "759-6525",
          "759-6532",
          "759-6531",
          "759-6522",
          "759-6541",
          "755-0000",
          "755-0043",
          "755-0801",
          "755-0041",
          "757-0211",
          "755-0152",
          "759-0131",
          "754-1314",
          "755-0055",
          "757-0212",
          "755-0155",
          "755-0154",
          "755-0810",
          "755-0051",
          "754-1312",
          "755-0062",
          "759-0135",
          "755-0076",
          "755-0001",
          "759-0202",
          "757-0213",
          "754-1311",
          "755-0023",
          "755-0038",
          "755-0091",
          "755-0092",
          "755-0022",
          "755-0002",
          "755-0084",
          "755-0074",
          "755-0081",
          "755-0036",
          "755-0093",
          "755-0802",
          "759-0136",
          "759-0207",
          "755-0004",
          "759-0133",
          "759-0213",
          "759-0209",
          "759-0212",
          "755-0067",
          "755-0005",
          "755-0075",
          "755-0033",
          "755-0032",
          "755-0066",
          "755-0012",
          "755-0015",
          "755-0017",
          "755-0047",
          "755-0048",
          "755-0011",
          "755-0029",
          "755-0044",
          "759-0123",
          "755-0014",
          "755-0054",
          "759-0121",
          "755-0045",
          "755-0021",
          "759-0204",
          "755-0078",
          "755-0097",
          "755-0031",
          "755-0153",
          "755-0086",
          "755-0073",
          "759-0203",
          "755-0072",
          "755-0058",
          "755-0064",
          "759-0211",
          "759-0208",
          "759-0205",
          "755-0037",
          "755-0018",
          "757-0402",
          "755-0151",
          "755-0049",
          "755-0035",
          "755-0053",
          "755-0808",
          "755-0052",
          "757-0214",
          "754-1315",
          "755-0085",
          "755-0025",
          "755-0024",
          "755-0003",
          "755-0007",
          "755-0806",
          "755-0065",
          "755-0082",
          "755-0039",
          "757-0401",
          "755-0241",
          "755-0068",
          "755-0034",
          "755-0016",
          "755-0019",
          "759-0206",
          "755-0807",
          "755-0803",
          "755-0028",
          "757-0215",
          "755-0009",
          "755-0096",
          "755-0094",
          "759-0124",
          "754-1313",
          "755-0057",
          "757-0216",
          "755-0095",
          "755-0805",
          "755-0056",
          "755-0809",
          "755-0042",
          "755-0026",
          "755-0006",
          "755-0027",
          "755-0083",
          "755-0046",
          "755-0804",
          "755-0063",
          "755-0071",
          "755-0008",
          "755-0013",
          "757-0217",
          "755-0077",
          "759-0132",
          "759-0201",
          "759-0122",
          "759-0134",
          "755-0061",
          "753-0000",
          "754-1102",
          "754-1101",
          "754-0893",
          "753-0821",
          "753-0012",
          "753-0067",
          "753-0061",
          "753-0871",
          "753-0872",
          "753-0051",
          "754-1277",
          "759-1342",
          "759-1341",
          "759-1231",
          "759-1601",
          "759-1602",
          "759-1232",
          "759-1421",
          "759-1422",
          "759-1343",
          "759-1511",
          "759-1513",
          "759-1512",
          "753-0038",
          "753-0815",
          "753-0066",
          "753-0079",
          "753-0055",
          "753-0083",
          "753-0048",
          "754-0896",
          "753-0017",
          "753-0036",
          "753-0033",
          "753-0242",
          "753-0251",
          "753-0252",
          "753-0241",
          "753-0211",
          "753-0231",
          "753-0243",
          "753-0214",
          "753-0215",
          "753-0221",
          "753-0222",
          "753-0072",
          "753-0093",
          "753-0062",
          "754-0029",
          "754-0008",
          "754-0007",
          "754-0015",
          "754-0006",
          "754-0034",
          "754-0004",
          "754-0001",
          "754-0028",
          "754-0021",
          "754-0026",
          "754-0027",
          "754-0002",
          "754-0031",
          "754-0014",
          "754-0022",
          "754-0033",
          "754-0025",
          "754-0012",
          "754-0020",
          "754-0023",
          "754-0003",
          "754-0013",
          "754-0011",
          "754-0032",
          "754-0005",
          "754-0024",
          "753-0022",
          "754-0897",
          "753-0073",
          "753-0024",
          "753-0091",
          "753-0213",
          "753-0035",
          "753-0891",
          "753-0089",
          "753-0064",
          "753-0095",
          "753-0065",
          "753-0084",
          "753-0077",
          "753-0851",
          "753-0081",
          "753-0045",
          "753-0087",
          "753-0826",
          "753-0021",
          "754-0894",
          "753-0023",
          "753-0052",
          "753-0025",
          "753-0058",
          "753-0212",
          "753-0034",
          "753-0070",
          "753-0085",
          "754-0891",
          "747-1221",
          "753-0822",
          "753-0076",
          "753-0042",
          "753-0812",
          "753-0071",
          "753-0074",
          "753-0047",
          "753-0037",
          "753-0032",
          "747-0232",
          "747-0234",
          "747-0523",
          "747-0233",
          "747-0612",
          "747-0611",
          "747-0522",
          "747-0401",
          "747-0341",
          "747-0235",
          "747-0524",
          "747-0342",
          "747-0231",
          "747-0343",
          "747-0344",
          "747-0521",
          "747-0402",
          "753-0054",
          "753-0086",
          "753-0801",
          "753-0088",
          "753-0075",
          "754-0892",
          "753-0018",
          "753-0068",
          "753-0301",
          "753-0303",
          "753-0302",
          "753-0094",
          "753-0041",
          "753-0831",
          "753-0015",
          "754-0895",
          "753-0031",
          "753-0824",
          "753-0046",
          "753-0057",
          "753-0053",
          "753-0082",
          "753-0016",
          "753-0078",
          "753-0043",
          "753-0001",
          "753-0011",
          "753-0063",
          "753-0861",
          "753-0825",
          "753-0092",
          "753-0056",
          "753-0811",
          "753-0817",
          "753-0818",
          "753-0816",
          "753-0814",
          "753-0813",
          "753-0841",
          "753-0823",
          "753-0044",
          "758-0000",
          "758-0001",
          "754-0411",
          "758-0051",
          "758-0052",
          "758-0021",
          "759-3113",
          "758-0033",
          "758-0041",
          "759-3611",
          "758-0003",
          "758-0042",
          "758-0301",
          "759-3201",
          "759-3202",
          "758-0043",
          "759-3111",
          "758-0044",
          "758-0141",
          "758-0031",
          "758-0071",
          "758-0053",
          "758-0032",
          "758-0304",
          "758-0305",
          "758-0034",
          "758-0213",
          "758-0073",
          "758-0072",
          "758-0045",
          "758-0035",
          "753-0101",
          "759-3721",
          "758-0036",
          "758-0501",
          "759-3204",
          "759-3112",
          "759-3411",
          "759-3303",
          "758-0302",
          "758-0303",
          "758-0054",
          "758-0011",
          "758-0061",
          "758-0037",
          "759-3203",
          "758-0046",
          "758-0062",
          "758-0023",
          "758-0022",
          "758-0055",
          "758-0047",
          "758-0024",
          "758-0004",
          "758-0025",
          "758-0002",
          "758-0074",
          "758-0211",
          "758-0212",
          "758-0056",
          "758-0026",
          "758-0057",
          "758-0701",
          "758-0076",
          "758-0077",
          "759-3301",
          "759-3302",
          "758-0063",
          "758-0027",
          "747-0000",
          "747-0846",
          "747-0847",
          "747-0806",
          "747-0051",
          "747-0042",
          "747-0812",
          "747-0001",
          "747-0836",
          "747-0801",
          "747-0014",
          "747-0036",
          "747-0065",
          "747-0803",
          "747-0013",
          "747-0101",
          "747-0819",
          "747-0052",
          "747-0054",
          "747-0053",
          "747-0822",
          "747-0823",
          "747-0816",
          "747-0033",
          "747-0062",
          "747-0011",
          "747-0815",
          "747-1231",
          "747-0811",
          "747-0808",
          "747-0821",
          "747-0024",
          "747-0021",
          "747-0056",
          "747-0809",
          "747-0035",
          "747-0067",
          "747-0044",
          "747-0006",
          "747-0842",
          "747-0063",
          "747-0824",
          "747-0825",
          "747-0047",
          "747-0066",
          "747-0817",
          "747-0002",
          "747-0105",
          "747-0031",
          "747-0046",
          "747-0022",
          "747-0807",
          "747-1232",
          "747-0064",
          "747-0045",
          "747-0834",
          "747-0023",
          "747-0802",
          "747-0034",
          "747-1111",
          "747-0055",
          "747-0005",
          "747-0107",
          "747-0106",
          "747-0845",
          "747-0841",
          "747-0849",
          "747-0835",
          "747-0832",
          "747-0037",
          "747-0848",
          "747-0844",
          "747-0833",
          "747-0061",
          "747-0843",
          "747-0028",
          "747-0813",
          "747-0102",
          "747-0043",
          "747-0029",
          "747-0804",
          "747-0104",
          "747-0805",
          "747-0814",
          "747-0818",
          "747-0026",
          "747-0027",
          "747-0032",
          "747-0025",
          "747-0831",
          "747-0004",
          "747-0012",
          "747-0003",
          "747-0041",
          "747-0103",
          "744-0000",
          "744-0004",
          "744-0031",
          "744-0032",
          "744-0033",
          "744-0007",
          "744-0015",
          "744-0272",
          "744-0001",
          "744-0071",
          "744-0042",
          "744-0029",
          "744-0271",
          "744-0051",
          "744-0061",
          "744-0003",
          "744-0013",
          "744-0019",
          "744-0074",
          "744-0062",
          "744-0008",
          "744-0024",
          "744-0022",
          "744-0023",
          "744-0076",
          "744-0273",
          "744-0025",
          "744-0028",
          "744-0043",
          "744-0053",
          "744-0014",
          "744-0077",
          "744-0275",
          "744-0078",
          "744-0011",
          "744-0018",
          "744-0274",
          "744-0072",
          "744-0006",
          "744-0002",
          "744-0017",
          "744-0021",
          "744-0005",
          "744-0012",
          "744-0065",
          "744-0073",
          "744-0075",
          "744-0027",
          "744-0052",
          "744-0041",
          "744-0276",
          "744-0063",
          "740-0000",
          "740-0304",
          "740-0024",
          "741-0094",
          "740-0037",
          "740-0003",
          "740-0324",
          "740-0017",
          "740-0321",
          "741-0062",
          "740-0317",
          "741-0071",
          "740-0042",
          "741-0084",
          "740-0323",
          "741-0091",
          "740-0032",
          "740-0013",
          "741-0075",
          "740-0015",
          "740-0023",
          "740-0311",
          "741-0082",
          "740-0303",
          "742-0332",
          "742-0338",
          "742-0321",
          "742-0334",
          "742-0322",
          "742-0324",
          "742-0342",
          "742-0312",
          "742-0311",
          "742-0337",
          "742-0331",
          "742-0313",
          "742-0336",
          "742-0335",
          "742-0315",
          "742-0333",
          "742-0326",
          "742-0314",
          "742-0343",
          "742-0344",
          "742-0325",
          "742-0323",
          "742-0341",
          "740-0028",
          "740-0026",
          "740-0041",
          "740-0302",
          "740-0312",
          "742-0411",
          "742-0422",
          "742-0413",
          "742-0426",
          "742-0412",
          "742-0424",
          "742-0421",
          "742-0417",
          "742-0423",
          "742-0301",
          "742-0414",
          "742-0415",
          "742-0425",
          "742-0427",
          "742-0416",
          "740-0001",
          "740-0004",
          "740-0002",
          "740-0019",
          "740-0327",
          "741-0063",
          "740-0325",
          "741-0092",
          "740-0011",
          "741-0093",
          "740-0315",
          "740-0044",
          "740-0314",
          "740-0306",
          "740-0027",
          "740-0045",
          "740-0033",
          "740-0901",
          "740-0904",
          "740-0902",
          "740-0721",
          "740-0903",
          "740-0811",
          "740-0722",
          "740-0725",
          "740-0724",
          "740-0812",
          "740-0723",
          "741-0061",
          "740-0051",
          "741-0073",
          "740-0322",
          "740-0326",
          "740-0014",
          "741-0072",
          "740-0036",
          "740-0305",
          "740-0313",
          "740-0043",
          "740-0604",
          "740-0605",
          "740-0603",
          "740-0602",
          "740-0601",
          "740-0018",
          "740-0016",
          "740-0501",
          "740-0502",
          "740-0503",
          "740-0504",
          "740-0505",
          "741-0083",
          "740-0025",
          "740-0035",
          "740-0034",
          "740-1241",
          "740-1201",
          "740-1231",
          "740-1217",
          "740-1211",
          "740-1221",
          "740-1213",
          "740-1202",
          "740-1212",
          "740-1224",
          "740-1225",
          "740-1242",
          "740-1219",
          "740-1222",
          "740-1218",
          "740-1215",
          "740-1223",
          "740-1232",
          "740-1216",
          "740-1214",
          "740-0021",
          "741-0085",
          "740-0012",
          "740-0031",
          "740-0022",
          "740-1455",
          "740-1432",
          "740-1441",
          "740-1428",
          "740-1454",
          "740-1424",
          "740-1451",
          "740-1425",
          "740-1426",
          "740-1431",
          "740-1405",
          "740-1413",
          "740-1406",
          "740-1411",
          "740-1402",
          "740-1452",
          "740-1401",
          "740-1403",
          "740-1412",
          "740-1404",
          "740-1407",
          "740-1488",
          "740-0301",
          "740-0316",
          "741-0081",
          "741-0074",
          "743-0000",
          "743-0021",
          "743-0051",
          "743-0103",
          "743-0104",
          "743-0003",
          "743-0065",
          "743-0046",
          "743-0043",
          "743-0061",
          "743-0101",
          "743-0063",
          "743-0012",
          "743-0042",
          "743-0062",
          "743-0013",
          "743-0105",
          "743-0064",
          "743-0048",
          "743-0031",
          "743-0022",
          "743-0047",
          "743-0023",
          "743-0041",
          "743-0052",
          "743-0011",
          "743-0045",
          "743-0102",
          "743-0007",
          "743-0004",
          "743-0002",
          "743-0072",
          "743-0075",
          "743-0071",
          "743-0006",
          "743-0008",
          "743-0074",
          "743-0005",
          "743-0073",
          "743-0009",
          "743-0001",
          "743-0044",
          "759-4100",
          "759-4107",
          "759-4104",
          "759-4106",
          "759-4211",
          "759-4102",
          "759-4101",
          "759-4103",
          "759-4401",
          "759-4405",
          "759-4403",
          "759-4402",
          "759-4404",
          "759-4105",
          "759-3801",
          "759-3803",
          "759-3802",
          "759-4505",
          "759-4711",
          "759-4713",
          "759-4621",
          "759-4504",
          "759-4501",
          "759-4503",
          "759-4712",
          "759-4502",
          "759-4622",
          "759-4623",
          "742-0000",
          "742-1351",
          "742-1353",
          "742-0201",
          "742-1352",
          "742-0036",
          "749-0102",
          "742-0003",
          "742-0012",
          "749-0101",
          "742-0032",
          "742-0009",
          "742-0011",
          "742-0008",
          "742-0010",
          "742-0033",
          "742-0006",
          "742-0035",
          "742-0005",
          "749-0103",
          "742-0004",
          "742-0024",
          "742-0007",
          "742-0111",
          "742-0001",
          "742-0041",
          "742-0023",
          "742-0031",
          "742-0021",
          "742-0022",
          "742-0002",
          "742-0034",
          "759-2200",
          "759-2222",
          "759-2223",
          "759-2221",
          "759-2131",
          "759-2214",
          "759-2212",
          "759-2213",
          "759-2211",
          "759-2301",
          "759-2302",
          "754-0602",
          "754-0511",
          "754-0513",
          "754-0512",
          "754-0601",
          "754-0603",
          "754-0514",
          "750-0601",
          "750-0602",
          "750-0603",
          "750-0606",
          "750-0605",
          "750-0604",
          "759-2152",
          "759-2151",
          "759-2142",
          "759-2141",
          "754-0302",
          "754-0212",
          "754-0301",
          "754-0211",
          "754-0123",
          "754-0121",
          "754-0213",
          "754-0122",
          "754-0214",
          "745-0000",
          "745-0055",
          "745-0842",
          "745-0825",
          "745-0821",
          "745-0124",
          "745-0014",
          "745-0833",
          "745-0882",
          "745-0872",
          "745-0074",
          "745-0063",
          "745-0047",
          "746-0105",
          "745-0887",
          "745-0076",
          "745-0856",
          "745-0857",
          "745-0862",
          "745-0826",
          "745-0041",
          "745-0832",
          "745-0824",
          "745-0651",
          "745-0301",
          "745-0803",
          "745-0057",
          "745-0242",
          "745-0241",
          "745-0066",
          "746-0027",
          "745-0051",
          "745-0611",
          "746-0013",
          "746-0083",
          "746-0051",
          "745-0871",
          "746-0036",
          "746-0006",
          "746-0055",
          "745-0615",
          "745-0617",
          "745-0302",
          "745-0304",
          "745-0303",
          "746-0065",
          "745-0817",
          "745-0858",
          "745-0855",
          "746-0001",
          "746-0009",
          "745-0012",
          "745-0845",
          "745-0852",
          "745-0071",
          "745-0864",
          "745-0007",
          "745-0032",
          "745-0031",
          "745-0805",
          "745-0831",
          "745-0663",
          "745-0801",
          "745-0802",
          "745-0886",
          "745-0836",
          "746-0024",
          "745-0874",
          "745-0027",
          "745-0822",
          "746-0032",
          "745-0878",
          "745-0814",
          "745-0614",
          "745-0005",
          "745-0641",
          "745-0046",
          "745-0883",
          "745-0037",
          "746-0031",
          "745-0806",
          "745-0011",
          "745-0652",
          "745-0811",
          "746-0061",
          "745-0003",
          "746-0008",
          "746-0081",
          "746-0015",
          "745-0834",
          "746-0082",
          "746-0041",
          "745-0654",
          "745-0823",
          "745-0807",
          "745-0853",
          "745-0061",
          "745-0013",
          "745-0843",
          "745-0056",
          "745-0643",
          "745-0861",
          "746-0045",
          "746-0033",
          "746-0043",
          "745-0867",
          "745-0017",
          "745-0804",
          "745-0121",
          "745-0122",
          "745-0401",
          "745-0026",
          "745-0064",
          "747-0621",
          "745-0653",
          "745-0623",
          "745-0827",
          "746-0018",
          "746-0103",
          "745-0885",
          "746-0101",
          "745-0662",
          "746-0007",
          "745-0025",
          "746-0016",
          "745-0044",
          "745-0062",
          "745-0001",
          "745-0632",
          "746-0011",
          "745-0816",
          "746-0003",
          "745-0123",
          "745-0851",
          "745-0045",
          "746-0034",
          "745-0876",
          "745-0511",
          "745-0512",
          "746-0054",
          "746-0052",
          "745-0854",
          "745-0125",
          "745-0642",
          "746-0005",
          "745-0023",
          "746-0102",
          "745-0875",
          "746-0002",
          "746-0044",
          "745-0054",
          "745-0884",
          "745-0002",
          "745-0042",
          "746-0022",
          "746-0023",
          "746-0056",
          "745-0022",
          "745-0865",
          "745-0052",
          "746-0021",
          "745-0006",
          "746-0026",
          "745-0844",
          "745-0621",
          "745-0065",
          "745-0024",
          "745-0869",
          "745-0877",
          "745-0881",
          "745-0846",
          "745-0622",
          "745-0866",
          "746-0035",
          "746-0029",
          "745-0808",
          "746-0038",
          "746-0062",
          "746-0042",
          "745-0618",
          "746-0025",
          "746-0014",
          "745-0015",
          "745-1131",
          "746-0063",
          "745-0036",
          "745-0835",
          "745-0847",
          "746-0012",
          "746-0037",
          "745-0053",
          "746-0004",
          "745-0873",
          "745-0402",
          "745-0616",
          "745-0075",
          "746-0028",
          "745-0868",
          "745-0033",
          "745-0043",
          "746-0017",
          "745-0815",
          "745-0863",
          "745-0034",
          "746-0053",
          "745-0004",
          "746-0084",
          "745-0501",
          "745-0631",
          "745-0021",
          "745-0072",
          "745-0035",
          "745-0813",
          "745-0837",
          "745-1132",
          "745-0613",
          "745-0812",
          "746-0104",
          "745-0612",
          "745-0661",
          "745-0073",
          "746-0019",
          "745-0841",
          "745-0016",
          "746-0064",
          "756-0000",
          "756-0030",
          "756-0841",
          "757-0001",
          "756-0871",
          "756-0808",
          "756-0038",
          "756-0009",
          "756-0003",
          "756-0063",
          "756-0811",
          "756-0863",
          "756-0049",
          "756-0048",
          "756-0855",
          "756-0025",
          "756-0026",
          "756-0027",
          "756-0873",
          "756-0042",
          "756-0036",
          "756-0866",
          "756-0852",
          "756-0817",
          "756-0812",
          "756-0067",
          "756-0013",
          "756-0012",
          "756-0854",
          "756-0056",
          "756-0041",
          "756-0086",
          "756-0075",
          "757-0005",
          "756-0843",
          "756-0842",
          "756-0848",
          "756-0051",
          "756-0801",
          "756-0007",
          "756-0833",
          "756-0822",
          "756-0844",
          "756-0846",
          "756-0845",
          "756-0011",
          "756-0028",
          "756-0080",
          "756-0044",
          "756-0815",
          "757-0002",
          "756-0037",
          "756-0802",
          "757-0006",
          "756-0851",
          "756-0888",
          "756-0881",
          "756-0053",
          "756-0805",
          "756-0094",
          "756-0010",
          "756-0847",
          "756-0092",
          "756-0823",
          "756-0836",
          "756-0862",
          "756-0889",
          "756-0882",
          "756-0813",
          "756-0835",
          "756-0884",
          "756-0001",
          "756-0008",
          "756-0087",
          "756-0060",
          "756-0021",
          "756-0047",
          "756-0865",
          "756-0055",
          "756-0054",
          "756-0039",
          "756-0022",
          "756-0023",
          "756-0824",
          "756-0804",
          "756-0814",
          "757-0011",
          "756-0806",
          "756-0004",
          "756-0005",
          "756-0886",
          "756-0016",
          "756-0885",
          "756-0864",
          "756-0816",
          "756-0057",
          "756-0046",
          "756-0093",
          "756-0017",
          "756-0853",
          "756-0024",
          "756-0861",
          "757-0012",
          "756-0043",
          "756-0872",
          "756-0052",
          "756-0883",
          "756-0825",
          "756-0088",
          "756-0018",
          "756-0014",
          "756-0015",
          "756-0091",
          "756-0032",
          "756-0035",
          "757-0013",
          "756-0029",
          "756-0856",
          "756-0857",
          "756-0837",
          "756-0031",
          "756-0887",
          "756-0877",
          "756-0878",
          "756-0821",
          "756-0034",
          "756-0834",
          "756-0045",
          "756-0803",
          "756-0019",
          "756-0875",
          "756-0832",
          "756-0831",
          "756-0076",
          "756-0074",
          "756-0073",
          "756-0077",
          "756-0071",
          "756-0072",
          "756-0876",
          "756-0874",
          "757-0004",
          "757-0003",
          "756-0809",
          "756-0807",
          "756-0095",
          "756-0033",
          "742-2100",
          "742-2807",
          "742-2712",
          "742-2601",
          "742-2801",
          "742-2515",
          "742-2922",
          "742-2108",
          "742-2511",
          "742-2711",
          "742-2301",
          "742-2514",
          "742-2517",
          "742-2106",
          "742-2105",
          "742-2923",
          "742-2104",
          "742-2713",
          "742-2803",
          "742-2924",
          "742-2806",
          "742-2921",
          "742-2101",
          "742-2103",
          "742-2805",
          "742-2102",
          "742-2107",
          "742-2804",
          "742-2716",
          "742-2512",
          "742-2714",
          "742-2302",
          "742-2513",
          "742-2602",
          "742-2802",
          "742-2715",
          "742-2518",
          "742-2516",
          "740-0063",
          "740-0062",
          "740-0061",
          "742-1400",
          "742-1401",
          "742-1402",
          "742-1403",
          "742-1404",
          "742-1500",
          "742-1516",
          "742-1501",
          "742-1513",
          "742-1512",
          "742-1515",
          "742-1504",
          "742-1511",
          "742-1503",
          "742-1517",
          "742-1502",
          "742-1514",
          "742-1100",
          "742-1104",
          "742-1106",
          "742-1105",
          "742-1113",
          "742-1112",
          "742-1111",
          "742-1114",
          "742-1107",
          "742-1103",
          "742-1101",
          "742-1102",
          "759-3600",
          "759-3501",
          "758-0613",
          "759-3621",
          "759-3502",
          "759-3622",
          "758-0612",
          "758-0611",
          "770-0000",
          "770-0835",
          "770-0934",
          "770-0046",
          "770-0863",
          "771-4265",
          "770-0926",
          "779-3132",
          "770-0833",
          "770-0935",
          "771-1156",
          "771-1152",
          "771-1154",
          "771-1155",
          "771-1151",
          "771-1153",
          "770-8031",
          "773-0070",
          "770-8012",
          "770-8022",
          "770-0923",
          "770-8052",
          "770-8051",
          "770-8053",
          "770-0914",
          "770-0002",
          "770-0001",
          "770-8033",
          "770-0939",
          "770-8023",
          "770-0871",
          "770-0801",
          "770-8041",
          "770-8040",
          "770-0803",
          "770-0048",
          "771-0101",
          "771-0144",
          "771-0131",
          "771-0142",
          "771-0130",
          "771-0125",
          "771-0126",
          "771-0127",
          "771-0128",
          "771-0129",
          "771-0103",
          "771-0104",
          "771-0102",
          "771-0106",
          "771-0105",
          "771-0121",
          "771-0122",
          "771-0124",
          "771-0123",
          "771-0141",
          "771-0117",
          "771-0111",
          "771-0112",
          "771-0143",
          "771-0132",
          "771-0133",
          "771-0136",
          "771-0134",
          "771-0138",
          "771-0135",
          "771-0137",
          "771-0113",
          "771-0116",
          "771-0115",
          "771-0114",
          "771-0139",
          "770-0872",
          "770-0011",
          "770-0012",
          "770-0051",
          "770-0812",
          "770-0003",
          "770-0821",
          "770-0806",
          "770-0006",
          "770-8032",
          "770-0916",
          "770-0042",
          "770-0041",
          "779-3116",
          "779-3118",
          "779-3128",
          "779-3113",
          "779-3123",
          "779-3122",
          "779-3114",
          "779-3101",
          "779-3115",
          "779-3112",
          "779-3124",
          "779-3127",
          "779-3106",
          "779-3125",
          "779-3117",
          "779-3103",
          "779-3102",
          "779-3120",
          "779-3119",
          "779-3105",
          "779-3104",
          "779-3126",
          "779-3111",
          "779-3121",
          "770-0918",
          "770-8021",
          "770-0847",
          "770-0921",
          "770-0021",
          "770-0022",
          "770-0023",
          "770-0024",
          "770-0025",
          "770-0026",
          "770-0027",
          "770-0028",
          "770-0039",
          "770-8025",
          "771-4267",
          "770-0805",
          "779-3131",
          "770-0862",
          "770-8064",
          "770-0044",
          "771-4263",
          "771-4262",
          "771-4261",
          "770-0942",
          "770-0845",
          "770-0855",
          "770-8006",
          "770-8007",
          "770-0904",
          "770-0867",
          "770-0866",
          "770-0815",
          "770-0816",
          "770-0861",
          "770-0927",
          "770-0922",
          "771-4264",
          "770-0936",
          "770-8001",
          "770-8004",
          "770-8005",
          "770-8003",
          "770-8002",
          "770-0823",
          "770-0832",
          "770-0831",
          "770-0909",
          "770-8056",
          "770-0842",
          "770-0852",
          "770-0851",
          "770-0854",
          "770-0931",
          "770-0937",
          "770-0915",
          "770-0052",
          "770-0943",
          "770-0813",
          "770-0856",
          "770-0844",
          "770-0853",
          "770-0932",
          "770-0807",
          "770-0804",
          "770-0928",
          "770-8008",
          "770-0902",
          "770-8024",
          "770-0901",
          "770-0903",
          "770-0929",
          "770-8061",
          "770-0907",
          "779-3133",
          "770-0924",
          "771-4266",
          "770-8076",
          "770-8077",
          "770-8079",
          "770-8073",
          "770-8074",
          "770-8082",
          "770-8075",
          "770-8072",
          "770-8071",
          "770-8081",
          "770-8078",
          "770-8083",
          "770-8084",
          "770-8070",
          "770-0941",
          "770-0873",
          "770-0912",
          "770-0911",
          "770-0905",
          "770-0822",
          "770-0906",
          "770-0811",
          "770-0908",
          "770-0868",
          "770-0062",
          "770-0064",
          "770-0061",
          "770-0063",
          "770-0846",
          "770-0874",
          "770-0043",
          "770-0031",
          "770-0032",
          "770-0033",
          "770-0034",
          "770-0035",
          "770-0036",
          "770-0037",
          "770-0038",
          "770-0053",
          "770-0045",
          "770-0944",
          "770-0913",
          "770-0814",
          "770-0865",
          "770-0004",
          "770-0824",
          "770-0933",
          "770-8063",
          "770-0808",
          "770-0005",
          "770-0938",
          "770-0047",
          "770-0834",
          "770-0841",
          "770-8055",
          "770-8054",
          "770-0864",
          "770-0925",
          "770-0802",
          "770-0917",
          "770-0843",
          "770-8011",
          "772-0000",
          "779-0303",
          "779-0315",
          "779-0311",
          "779-0302",
          "779-0223",
          "779-0305",
          "779-0224",
          "779-0313",
          "779-0314",
          "779-0221",
          "779-0234",
          "779-0231",
          "779-0232",
          "779-0235",
          "779-0238",
          "779-0236",
          "779-0237",
          "779-0233",
          "779-0230",
          "779-0312",
          "779-0225",
          "779-0301",
          "779-0304",
          "779-0222",
          "772-0041",
          "772-0031",
          "772-0044",
          "772-0043",
          "772-0034",
          "772-0033",
          "772-0042",
          "772-0035",
          "772-0032",
          "771-0372",
          "771-0373",
          "771-0377",
          "771-0376",
          "771-0371",
          "771-0378",
          "771-0374",
          "771-0375",
          "772-0022",
          "772-0021",
          "772-0060",
          "771-0360",
          "771-0362",
          "771-0364",
          "771-0367",
          "771-0366",
          "771-0365",
          "771-0361",
          "771-0363",
          "771-0369",
          "771-0368",
          "772-0051",
          "772-0053",
          "772-0052",
          "772-0011",
          "772-0012",
          "772-0013",
          "772-0004",
          "772-0001",
          "772-0002",
          "772-0017",
          "772-0016",
          "772-0014",
          "772-0003",
          "772-0015",
          "773-0000",
          "773-0024",
          "773-0021",
          "773-0014",
          "773-0022",
          "773-0007",
          "773-0002",
          "773-0018",
          "773-0001",
          "773-0023",
          "773-0009",
          "773-0012",
          "773-0017",
          "773-0008",
          "773-0015",
          "773-0019",
          "773-0016",
          "773-0011",
          "773-0010",
          "773-0004",
          "773-0013",
          "773-0003",
          "773-0005",
          "773-0006",
          "773-0031",
          "773-0025",
          "773-0020",
          "774-0000",
          "779-1404",
          "779-1510",
          "774-1760",
          "779-1401",
          "771-5177",
          "774-0022",
          "771-5176",
          "774-0014",
          "774-0049",
          "774-0044",
          "771-5173",
          "771-5170",
          "771-5171",
          "774-0006",
          "779-1402",
          "774-0015",
          "774-0009",
          "771-5178",
          "774-0047",
          "771-5174",
          "774-0041",
          "774-0045",
          "779-1631",
          "779-1630",
          "774-0023",
          "774-0001",
          "774-0021",
          "779-1750",
          "779-1740",
          "774-0007",
          "774-0030",
          "774-0002",
          "774-0046",
          "774-0048",
          "779-1242",
          "779-1114",
          "779-1112",
          "779-1111",
          "779-1243",
          "779-1235",
          "779-1246",
          "779-1121",
          "779-1116",
          "779-1115",
          "779-1117",
          "779-1233",
          "779-1236",
          "779-1123",
          "779-1245",
          "779-1232",
          "779-1231",
          "779-1119",
          "779-1234",
          "779-1113",
          "779-1241",
          "779-1244",
          "779-1122",
          "779-1118",
          "774-0016",
          "774-0012",
          "779-1107",
          "779-1106",
          "779-1103",
          "779-1109",
          "779-1101",
          "779-1104",
          "779-1105",
          "779-1102",
          "779-1108",
          "774-0008",
          "774-0003",
          "774-0013",
          "771-5179",
          "779-1620",
          "774-0004",
          "771-5175",
          "774-0017",
          "774-0005",
          "774-0043",
          "779-1403",
          "774-0042",
          "771-5172",
          "774-0011",
          "776-0000",
          "776-0015",
          "776-0033",
          "776-0001",
          "776-0003",
          "776-0002",
          "776-0037",
          "776-0010",
          "776-0011",
          "776-0012",
          "776-0005",
          "776-0006",
          "776-0007",
          "776-0034",
          "776-0036",
          "776-0031",
          "776-0013",
          "776-0014",
          "776-0004",
          "776-0020",
          "776-0032",
          "776-0035",
          "779-3306",
          "779-3301",
          "779-3303",
          "779-3305",
          "779-3307",
          "779-3304",
          "779-3302",
          "779-3501",
          "779-3505",
          "779-3502",
          "779-3503",
          "779-3504",
          "779-3407",
          "779-3405",
          "779-3401",
          "779-3404",
          "779-3402",
          "779-3406",
          "779-3403",
          "771-1700",
          "771-1705",
          "771-1701",
          "771-1703",
          "771-1704",
          "771-1702",
          "771-1706",
          "771-1602",
          "771-1603",
          "771-1601",
          "771-1604",
          "771-1626",
          "771-1714",
          "771-1614",
          "771-1615",
          "771-1627",
          "771-1613",
          "771-1621",
          "771-1611",
          "771-1610",
          "771-1612",
          "771-1623",
          "771-1622",
          "771-1616",
          "771-1624",
          "771-1625",
          "771-1501",
          "771-1503",
          "771-1505",
          "771-1509",
          "771-1506",
          "771-1504",
          "771-1502",
          "771-1508",
          "771-1507",
          "771-1401",
          "771-1403",
          "771-1402",
          "779-3600",
          "777-0005",
          "777-0006",
          "777-0007",
          "777-0004",
          "777-0001",
          "777-0002",
          "777-0003",
          "777-0302",
          "777-0301",
          "777-0303",
          "771-2107",
          "771-2106",
          "771-2102",
          "771-2105",
          "771-2103",
          "771-2101",
          "771-2104",
          "779-3604",
          "779-3603",
          "779-3602",
          "779-3620",
          "779-3610",
          "779-3633",
          "779-3632",
          "779-3636",
          "779-3639",
          "779-3638",
          "779-3637",
          "779-3635",
          "779-3625",
          "779-3634",
          "779-3631",
          "779-3741",
          "779-3742",
          "779-3744",
          "779-3601",
          "779-3743",
          "779-3745",
          "778-0000",
          "779-4801",
          "779-4805",
          "779-4804",
          "779-4802",
          "779-4807",
          "779-4803",
          "779-4806",
          "778-0012",
          "778-0014",
          "778-0001",
          "778-0010",
          "778-5252",
          "779-5164",
          "779-5166",
          "778-0008",
          "778-5253",
          "778-0003",
          "779-5162",
          "778-0005",
          "778-0020",
          "778-0004",
          "778-0013",
          "778-0006",
          "779-5163",
          "779-5161",
          "778-0031",
          "778-0032",
          "778-0040",
          "778-5251",
          "778-0011",
          "778-0002",
          "778-0165",
          "779-5165",
          "778-0009",
          "778-0007",
          "778-0104",
          "778-0103",
          "778-0101",
          "778-0102",
          "778-0105",
          "779-5172",
          "779-5173",
          "779-5171",
          "778-0205",
          "778-0206",
          "778-0204",
          "778-0203",
          "778-0202",
          "778-0201",
          "771-2302",
          "771-2304",
          "771-2301",
          "771-2303",
          "771-2305",
          "771-2306",
          "779-5307",
          "779-5336",
          "779-5328",
          "779-5314",
          "779-5304",
          "779-5342",
          "779-5347",
          "779-5333",
          "779-5332",
          "779-5327",
          "779-5452",
          "779-5305",
          "779-5321",
          "779-5313",
          "778-5254",
          "779-5341",
          "779-5422",
          "779-5322",
          "779-5343",
          "779-5303",
          "779-5453",
          "779-5324",
          "779-5316",
          "779-5345",
          "779-5337",
          "779-5306",
          "779-5323",
          "779-5311",
          "779-5451",
          "779-5334",
          "779-5312",
          "779-5315",
          "779-5326",
          "779-5344",
          "779-5325",
          "779-5331",
          "779-5301",
          "779-5335",
          "779-5302",
          "779-5346",
          "771-4300",
          "771-4303",
          "771-4308",
          "771-4306",
          "771-4302",
          "771-4301",
          "771-4305",
          "771-4304",
          "771-4307",
          "771-4500",
          "771-4502",
          "771-4503",
          "771-4501",
          "771-4504",
          "771-4505",
          "771-4100",
          "771-4102",
          "771-4101",
          "779-3200",
          "779-3213",
          "779-3214",
          "779-3212",
          "779-3211",
          "779-3215",
          "779-3233",
          "779-3236",
          "779-3231",
          "779-3234",
          "779-3232",
          "779-3235",
          "779-3245",
          "779-3242",
          "779-3244",
          "779-3241",
          "779-3243",
          "779-3226",
          "779-3224",
          "779-3225",
          "779-3223",
          "779-3222",
          "779-3221",
          "779-3206",
          "779-3207",
          "779-3202",
          "779-3208",
          "779-3201",
          "779-3205",
          "779-3204",
          "779-3203",
          "771-3200",
          "771-3202",
          "771-3201",
          "771-3203",
          "771-3422",
          "771-3421",
          "771-3311",
          "771-3310",
          "771-5200",
          "771-5207",
          "771-5403",
          "771-5323",
          "771-5401",
          "771-6101",
          "771-6103",
          "771-5324",
          "771-5405",
          "771-6118",
          "771-5328",
          "771-5404",
          "771-5504",
          "771-5326",
          "771-5321",
          "771-5320",
          "771-5410",
          "771-5516",
          "771-6322",
          "771-6115",
          "771-5501",
          "771-5407",
          "771-6328",
          "771-5413",
          "771-6107",
          "771-6117",
          "771-5515",
          "771-6105",
          "771-6402",
          "771-6511",
          "771-6512",
          "771-6401",
          "771-6405",
          "771-6404",
          "771-6403",
          "771-6102",
          "771-6111",
          "771-6324",
          "771-5209",
          "771-5512",
          "771-5503",
          "771-6106",
          "771-5502",
          "771-6114",
          "771-6325",
          "771-5507",
          "771-6323",
          "771-6112",
          "771-5329",
          "771-5322",
          "771-6113",
          "771-6104",
          "771-5202",
          "771-5505",
          "771-5204",
          "771-6327",
          "771-5208",
          "771-5327",
          "771-5406",
          "771-5518",
          "771-5409",
          "771-5532",
          "771-5531",
          "771-5508",
          "771-5506",
          "771-5517",
          "771-6321",
          "771-5325",
          "771-5514",
          "771-6326",
          "771-5513",
          "771-5412",
          "771-5511",
          "771-5206",
          "771-5205",
          "771-5402",
          "771-5411",
          "771-6116",
          "771-5408",
          "771-5201",
          "771-5203",
          "775-0000",
          "775-0007",
          "775-0004",
          "775-0001",
          "775-0002",
          "775-0006",
          "775-0005",
          "775-0003",
          "775-0013",
          "775-0011",
          "775-0012",
          "775-0010",
          "779-2300",
          "779-2301",
          "779-2106",
          "779-2107",
          "779-2303",
          "779-2305",
          "779-2108",
          "779-2302",
          "779-2105",
          "779-2109",
          "779-2306",
          "779-2103",
          "779-2101",
          "779-2104",
          "779-2304",
          "779-2102",
          "779-2307",
          "775-0200",
          "775-0415",
          "775-0101",
          "775-0310",
          "775-0203",
          "775-0412",
          "775-0302",
          "775-0504",
          "775-0506",
          "775-0511",
          "775-0505",
          "775-0306",
          "775-0502",
          "775-0413",
          "775-0508",
          "775-0509",
          "775-0513",
          "775-0512",
          "775-0501",
          "775-0307",
          "775-0202",
          "775-0206",
          "775-0303",
          "775-0204",
          "775-0309",
          "775-0301",
          "775-0305",
          "775-0304",
          "775-0503",
          "775-0411",
          "775-0507",
          "775-0510",
          "775-0308",
          "775-0205",
          "775-0414",
          "771-0200",
          "771-0219",
          "771-0218",
          "771-0215",
          "771-0217",
          "771-0213",
          "771-0212",
          "771-0211",
          "771-0216",
          "771-0220",
          "771-0214",
          "771-0205",
          "771-0201",
          "771-0207",
          "771-0204",
          "771-0206",
          "771-0202",
          "771-0203",
          "771-1200",
          "771-1202",
          "771-1203",
          "771-1201",
          "771-1240",
          "771-1262",
          "771-1261",
          "771-1260",
          "771-1271",
          "771-1273",
          "771-1272",
          "771-1270",
          "771-1267",
          "771-1265",
          "771-1266",
          "771-1264",
          "771-1212",
          "771-1211",
          "771-1210",
          "771-1232",
          "771-1231",
          "771-1230",
          "771-1224",
          "771-1222",
          "771-1223",
          "771-1221",
          "771-1220",
          "771-1253",
          "771-1252",
          "771-1251",
          "771-1250",
          "779-0100",
          "779-0108",
          "779-0101",
          "779-0106",
          "779-0105",
          "779-0103",
          "779-0102",
          "779-0113",
          "779-0118",
          "779-0116",
          "779-0117",
          "779-0111",
          "779-0119",
          "779-0104",
          "779-0107",
          "779-0112",
          "779-0115",
          "779-0114",
          "771-1300",
          "771-1310",
          "771-1301",
          "771-1345",
          "771-1320",
          "771-1342",
          "771-1343",
          "771-1302",
          "771-1344",
          "771-1350",
          "771-1341",
          "771-1346",
          "771-1347",
          "771-1330",
          "771-1311",
          "779-4100",
          "779-4302",
          "779-4305",
          "779-4301",
          "779-4304",
          "779-4306",
          "779-4307",
          "779-4303",
          "779-4101",
          "779-4105",
          "779-4103",
          "779-4106",
          "779-4104",
          "779-4108",
          "779-4109",
          "779-4107",
          "779-4102",
          "779-4404",
          "779-4402",
          "779-4401",
          "779-4406",
          "779-4405",
          "779-4403",
          "779-4407",
          "779-4700",
          "771-2502",
          "779-4701",
          "779-4707",
          "779-4706",
          "779-4705",
          "779-4704",
          "779-4703",
          "779-4702",
          "771-2503",
          "771-2501",
          "760-0000",
          "760-0002",
          "760-0064",
          "760-0065",
          "761-0130",
          "761-8033",
          "761-8002",
          "760-0038",
          "761-0444",
          "761-8084",
          "760-0078",
          "760-0043",
          "761-8005",
          "760-0034",
          "761-8044",
          "760-0013",
          "761-8074",
          "761-8073",
          "761-8047",
          "760-0091",
          "761-0431",
          "761-1703",
          "761-1701",
          "761-1704",
          "761-1706",
          "761-1705",
          "761-1702",
          "761-1707",
          "761-1708",
          "760-0028",
          "761-0101",
          "760-0040",
          "761-8082",
          "761-8056",
          "761-8064",
          "761-0302",
          "760-0077",
          "761-8055",
          "760-0050",
          "760-0006",
          "761-0323",
          "761-0432",
          "761-0443",
          "761-0442",
          "761-8046",
          "760-0052",
          "760-0076",
          "760-0055",
          "760-0080",
          "760-0031",
          "761-8026",
          "761-8021",
          "761-8023",
          "761-8022",
          "761-8024",
          "761-8025",
          "760-0075",
          "761-8013",
          "761-8015",
          "761-8014",
          "761-8011",
          "761-8012",
          "761-8031",
          "761-1405",
          "761-1401",
          "761-1406",
          "761-1402",
          "761-1404",
          "761-1403",
          "769-0105",
          "769-0102",
          "769-0104",
          "769-0101",
          "769-0103",
          "760-0023",
          "760-0044",
          "760-0027",
          "760-0004",
          "760-0016",
          "760-0074",
          "761-8072",
          "760-0019",
          "761-8083",
          "760-0015",
          "760-0062",
          "761-1614",
          "761-1613",
          "761-1611",
          "761-1612",
          "761-1615",
          "761-1501",
          "761-1502",
          "761-1503",
          "761-1504",
          "760-0047",
          "761-0313",
          "761-8077",
          "760-0036",
          "760-0014",
          "760-0001",
          "761-8003",
          "761-0102",
          "761-0103",
          "760-0060",
          "761-1616",
          "760-0012",
          "761-0434",
          "761-0433",
          "761-0104",
          "760-0063",
          "761-8076",
          "761-8075",
          "760-0053",
          "760-0030",
          "761-8057",
          "761-8001",
          "760-0042",
          "761-8041",
          "760-0007",
          "761-8058",
          "760-0061",
          "760-0093",
          "761-8032",
          "760-0035",
          "761-8085",
          "760-0018",
          "760-0046",
          "760-0054",
          "760-0026",
          "760-0056",
          "761-8043",
          "760-0008",
          "761-8004",
          "761-8081",
          "761-0445",
          "760-0022",
          "761-8051",
          "760-0020",
          "760-0021",
          "761-8053",
          "760-0003",
          "761-8045",
          "760-0057",
          "760-0072",
          "761-8063",
          "760-0011",
          "761-0301",
          "760-0017",
          "761-0446",
          "760-0058",
          "761-8054",
          "760-0037",
          "761-0312",
          "760-0041",
          "760-0024",
          "760-0066",
          "760-0048",
          "760-0071",
          "761-8071",
          "760-0025",
          "760-0045",
          "761-8078",
          "761-8079",
          "760-0032",
          "761-0322",
          "761-0321",
          "760-0068",
          "761-8052",
          "760-0079",
          "760-0067",
          "760-0029",
          "760-0033",
          "761-0450",
          "760-0051",
          "760-0009",
          "761-8042",
          "760-0005",
          "761-0122",
          "761-0123",
          "761-0121",
          "761-8062",
          "761-8061",
          "760-0092",
          "761-0311",
          "760-0049",
          "761-0112",
          "761-0111",
          "761-0113",
          "761-0441",
          "760-0073",
          "761-0303",
          "763-0000",
          "761-2401",
          "761-2402",
          "761-2404",
          "761-2403",
          "761-2406",
          "761-2405",
          "761-2408",
          "761-2407",
          "763-0084",
          "763-0085",
          "763-0086",
          "763-0025",
          "763-0051",
          "763-0006",
          "763-0231",
          "763-0034",
          "763-0053",
          "763-0003",
          "763-0092",
          "763-0091",
          "763-0002",
          "763-0015",
          "763-0073",
          "763-0029",
          "763-0093",
          "763-0014",
          "763-0004",
          "763-0048",
          "763-0094",
          "763-0065",
          "763-0027",
          "763-0030",
          "763-0013",
          "763-0031",
          "763-0032",
          "763-0061",
          "763-0024",
          "763-0055",
          "763-0063",
          "763-0045",
          "763-0007",
          "763-0071",
          "763-0095",
          "763-0052",
          "763-0111",
          "763-0066",
          "763-0043",
          "763-0021",
          "763-0012",
          "763-0082",
          "763-0081",
          "763-0083",
          "763-0054",
          "763-0033",
          "763-0046",
          "763-0041",
          "763-0047",
          "763-0028",
          "763-0022",
          "763-0075",
          "763-0074",
          "762-0084",
          "762-0082",
          "762-0086",
          "762-0083",
          "762-0087",
          "762-0085",
          "762-0081",
          "763-0105",
          "763-0106",
          "763-0102",
          "763-0108",
          "763-0103",
          "763-0104",
          "763-0101",
          "763-0107",
          "763-0044",
          "763-0011",
          "763-0001",
          "763-0062",
          "763-0225",
          "763-0228",
          "763-0221",
          "763-0222",
          "763-0224",
          "763-0226",
          "763-0223",
          "763-0227",
          "763-0023",
          "763-0064",
          "763-0005",
          "763-0042",
          "763-0072",
          "763-0026",
          "762-0000",
          "762-0037",
          "762-0006",
          "762-0035",
          "762-0002",
          "762-0072",
          "762-0011",
          "762-0014",
          "762-0013",
          "762-0016",
          "762-0027",
          "762-0015",
          "762-0052",
          "762-0038",
          "762-0022",
          "762-0023",
          "762-0062",
          "762-0025",
          "762-0018",
          "762-0001",
          "762-0003",
          "762-0043",
          "762-0051",
          "762-0032",
          "762-0026",
          "762-0061",
          "762-0066",
          "762-0004",
          "762-0042",
          "762-0047",
          "762-0067",
          "762-0017",
          "762-0033",
          "762-0055",
          "762-0056",
          "762-0058",
          "762-0054",
          "762-0053",
          "762-0021",
          "762-0041",
          "762-0036",
          "762-0012",
          "762-0063",
          "762-0064",
          "762-0065",
          "762-0073",
          "762-0034",
          "762-0046",
          "762-0024",
          "762-0031",
          "762-0044",
          "762-0057",
          "762-0007",
          "762-0045",
          "762-0005",
          "762-0071",
          "765-0000",
          "765-0053",
          "765-0014",
          "765-0022",
          "765-0052",
          "765-0011",
          "765-0012",
          "765-0033",
          "765-0051",
          "765-0031",
          "765-0021",
          "765-0003",
          "765-0004",
          "765-0001",
          "765-0072",
          "765-0073",
          "765-0032",
          "765-0062",
          "765-0071",
          "765-0013",
          "765-0002",
          "765-0040",
          "765-0061",
          "768-0000",
          "768-0062",
          "768-0052",
          "768-0031",
          "768-0071",
          "768-0012",
          "769-1617",
          "769-1624",
          "769-1621",
          "769-1622",
          "769-1625",
          "769-1611",
          "769-1623",
          "769-1612",
          "769-1614",
          "769-1613",
          "769-1616",
          "769-1615",
          "768-0060",
          "768-0051",
          "768-0040",
          "768-0064",
          "768-0074",
          "768-0072",
          "768-0067",
          "768-0063",
          "768-0069",
          "768-0073",
          "768-0011",
          "768-0066",
          "768-0033",
          "768-0065",
          "768-0002",
          "768-0068",
          "769-1601",
          "769-1604",
          "769-1603",
          "769-1602",
          "768-0024",
          "768-0014",
          "768-0075",
          "768-0032",
          "768-0023",
          "768-0076",
          "768-0070",
          "768-0013",
          "768-0001",
          "768-0022",
          "768-0061",
          "768-0021",
          "769-2300",
          "761-0904",
          "761-0902",
          "761-0901",
          "761-0903",
          "761-0905",
          "769-2103",
          "769-2104",
          "769-2102",
          "769-2322",
          "769-2321",
          "769-2323",
          "769-2101",
          "769-2304",
          "769-2105",
          "769-2315",
          "769-2314",
          "769-2312",
          "769-2313",
          "769-2311",
          "769-2306",
          "769-2401",
          "769-2402",
          "769-2302",
          "769-2301",
          "769-2303",
          "769-2305",
          "769-2700",
          "769-2703",
          "769-2520",
          "769-2902",
          "769-2908",
          "769-2513",
          "769-2521",
          "769-2512",
          "769-2602",
          "769-2906",
          "769-2704",
          "769-2905",
          "769-2511",
          "769-2519",
          "769-2715",
          "769-2904",
          "769-2601",
          "769-2705",
          "769-2516",
          "769-2605",
          "769-2518",
          "769-2604",
          "769-2712",
          "769-2714",
          "769-2711",
          "769-2901",
          "769-2515",
          "769-2514",
          "769-2702",
          "769-2606",
          "769-2517",
          "769-2701",
          "769-2903",
          "769-2603",
          "769-2907",
          "769-2713",
          "767-0000",
          "769-0401",
          "769-0402",
          "767-0014",
          "767-0012",
          "767-0001",
          "767-0021",
          "767-0013",
          "767-0011",
          "767-0002",
          "767-0022",
          "767-0004",
          "767-0003",
          "769-1108",
          "769-1104",
          "769-1103",
          "769-1109",
          "769-1101",
          "769-1105",
          "769-1107",
          "769-1106",
          "769-1102",
          "769-1507",
          "769-1502",
          "769-1503",
          "769-1504",
          "769-1508",
          "769-1501",
          "769-1505",
          "769-1506",
          "769-1410",
          "769-1404",
          "769-1401",
          "769-1408",
          "769-1405",
          "769-1406",
          "769-1407",
          "769-1403",
          "769-1402",
          "767-0031",
          "767-0032",
          "767-0033",
          "768-0102",
          "768-0104",
          "768-0105",
          "768-0103",
          "768-0101",
          "761-4100",
          "761-4664",
          "761-4131",
          "761-4141",
          "761-4132",
          "761-4145",
          "761-4144",
          "761-4154",
          "761-4122",
          "761-4152",
          "761-4153",
          "761-4146",
          "761-4134",
          "761-4661",
          "761-4662",
          "761-4663",
          "761-4133",
          "761-4151",
          "761-4121",
          "761-4143",
          "761-4142",
          "761-4103",
          "761-4112",
          "761-4115",
          "761-4114",
          "761-4105",
          "761-4111",
          "761-4106",
          "761-4102",
          "761-4113",
          "761-4104",
          "761-4101",
          "761-4300",
          "761-4403",
          "761-4301",
          "761-4404",
          "761-4426",
          "761-4431",
          "761-4307",
          "761-4302",
          "761-4433",
          "761-4412",
          "761-4432",
          "761-4308",
          "761-4425",
          "761-4405",
          "761-4424",
          "761-4155",
          "761-4303",
          "761-4434",
          "761-4421",
          "761-4402",
          "761-4305",
          "761-4422",
          "761-4423",
          "761-4304",
          "761-4411",
          "761-4401",
          "761-4306",
          "761-0700",
          "761-0614",
          "761-0701",
          "761-0823",
          "761-0705",
          "761-0822",
          "761-0821",
          "761-0613",
          "761-0615",
          "761-0703",
          "761-0704",
          "761-0611",
          "761-0612",
          "761-0702",
          "761-3110",
          "769-0200",
          "769-0210",
          "769-0227",
          "769-0222",
          "769-0226",
          "769-0223",
          "769-0225",
          "769-0211",
          "769-0212",
          "769-0201",
          "769-0202",
          "769-0203",
          "769-0204",
          "769-0205",
          "769-0206",
          "769-0207",
          "769-0208",
          "769-0209",
          "769-0213",
          "769-0224",
          "769-0228",
          "769-0221",
          "761-2300",
          "761-2208",
          "761-2307",
          "761-2304",
          "761-2306",
          "761-2103",
          "761-2102",
          "761-2202",
          "761-2201",
          "761-2305",
          "761-2206",
          "761-2101",
          "761-2207",
          "761-2308",
          "761-2205",
          "761-2203",
          "761-2204",
          "766-0000",
          "766-0004",
          "766-0006",
          "766-0002",
          "766-0001",
          "766-0003",
          "766-0007",
          "766-0005",
          "764-0000",
          "764-0033",
          "764-0005",
          "764-0035",
          "764-0028",
          "764-0002",
          "764-0022",
          "764-0013",
          "764-0025",
          "764-0024",
          "764-0011",
          "764-0012",
          "764-0040",
          "764-0031",
          "764-0050",
          "764-0027",
          "764-0004",
          "764-0037",
          "764-0015",
          "764-0017",
          "764-0038",
          "764-0001",
          "764-0016",
          "764-0018",
          "764-0006",
          "764-0021",
          "764-0014",
          "764-0032",
          "764-0036",
          "764-0026",
          "764-0003",
          "764-0034",
          "764-0023",
          "769-0313",
          "769-0315",
          "769-0319",
          "769-0316",
          "769-0311",
          "766-0204",
          "766-0203",
          "766-0024",
          "766-0026",
          "766-0011",
          "766-0027",
          "769-0301",
          "769-0302",
          "766-0021",
          "769-0303",
          "769-0317",
          "766-0017",
          "766-0016",
          "766-0201",
          "766-0015",
          "766-0202",
          "766-0012",
          "766-0014",
          "766-0013",
          "769-0314",
          "766-0025",
          "769-0312",
          "769-0318",
          "766-0023",
          "766-0022",
          "791-0000",
          "790-0064",
          "799-2433",
          "791-8076",
          "791-0124",
          "791-8019",
          "799-2401",
          "799-2402",
          "791-8024",
          "790-0876",
          "791-8023",
          "790-0952",
          "790-0951",
          "799-2463",
          "791-8006",
          "790-0934",
          "790-0051",
          "790-0852",
          "790-0902",
          "791-8084",
          "790-0025",
          "790-0941",
          "799-2467",
          "790-0038",
          "790-0948",
          "790-0947",
          "790-0946",
          "790-0001",
          "791-1114",
          "799-2416",
          "791-1106",
          "791-1103",
          "790-0833",
          "790-0835",
          "790-0832",
          "790-0834",
          "790-0854",
          "799-2423",
          "791-1136",
          "799-2446",
          "791-8077",
          "799-2654",
          "799-2655",
          "799-2643",
          "791-8051",
          "791-4506",
          "790-0022",
          "790-0962",
          "791-1134",
          "791-0134",
          "799-2408",
          "790-0004",
          "791-8057",
          "790-0067",
          "799-2458",
          "791-1126",
          "799-2468",
          "799-2418",
          "790-0036",
          "790-0037",
          "790-0933",
          "791-0241",
          "791-4502",
          "799-2410",
          "799-2642",
          "791-8058",
          "790-0024",
          "799-2644",
          "799-2439",
          "790-0801",
          "799-2661",
          "790-0878",
          "791-8091",
          "799-2461",
          "791-0111",
          "790-0853",
          "791-1124",
          "791-0103",
          "799-2405",
          "791-4322",
          "791-8004",
          "799-2466",
          "790-0813",
          "791-0132",
          "791-0129",
          "790-0013",
          "791-8063",
          "790-0965",
          "799-2411",
          "791-1102",
          "791-1105",
          "791-0242",
          "790-0923",
          "791-8031",
          "790-0867",
          "791-1104",
          "790-0033",
          "790-0873",
          "791-8041",
          "791-8025",
          "799-2454",
          "790-0821",
          "791-8055",
          "790-0802",
          "790-0054",
          "791-0054",
          "791-0150",
          "791-1132",
          "799-2462",
          "791-8035",
          "791-1131",
          "791-4507",
          "791-8016",
          "791-1101",
          "790-0911",
          "799-2445",
          "799-2438",
          "799-2436",
          "791-4505",
          "799-2469",
          "799-2451",
          "790-0963",
          "790-0863",
          "791-1125",
          "791-0135",
          "799-2645",
          "799-2653",
          "799-2417",
          "791-8072",
          "790-0838",
          "799-2447",
          "799-2415",
          "799-2419",
          "790-0914",
          "790-0003",
          "791-0104",
          "791-8003",
          "790-0803",
          "790-0823",
          "791-0112",
          "799-2407",
          "791-0123",
          "799-2404",
          "790-0904",
          "790-0851",
          "799-2647",
          "799-2412",
          "799-2442",
          "791-1133",
          "790-0872",
          "790-0901",
          "799-2646",
          "790-0865",
          "791-8083",
          "790-0023",
          "791-0122",
          "791-8052",
          "791-0105",
          "799-2648",
          "799-2460",
          "791-8062",
          "799-2443",
          "799-2662",
          "791-1111",
          "791-8036",
          "791-8007",
          "790-0822",
          "799-2422",
          "790-0925",
          "791-0102",
          "791-8081",
          "791-8079",
          "790-0967",
          "790-0053",
          "790-0052",
          "790-0966",
          "791-8086",
          "799-2413",
          "799-2414",
          "791-8002",
          "791-0126",
          "790-0905",
          "790-0011",
          "791-8015",
          "790-0916",
          "790-0864",
          "790-0063",
          "799-2455",
          "791-1122",
          "791-4324",
          "790-0048",
          "790-0827",
          "790-0056",
          "791-1115",
          "791-8018",
          "790-0844",
          "790-0845",
          "790-0846",
          "790-0848",
          "790-0857",
          "790-0836",
          "790-0841",
          "790-0825",
          "790-0858",
          "790-0847",
          "790-0837",
          "790-0842",
          "799-2432",
          "790-0843",
          "790-0032",
          "791-8093",
          "791-8034",
          "790-0804",
          "791-8078",
          "791-1121",
          "790-0964",
          "790-0866",
          "791-4503",
          "791-4511",
          "791-4501",
          "799-2406",
          "799-2426",
          "799-2425",
          "799-2437",
          "790-0931",
          "790-0805",
          "790-0877",
          "799-2457",
          "791-8017",
          "791-1135",
          "791-8044",
          "790-0002",
          "791-4509",
          "791-4432",
          "791-8082",
          "799-2403",
          "791-0113",
          "790-0913",
          "790-0912",
          "791-4510",
          "799-2424",
          "790-0005",
          "791-8066",
          "790-0055",
          "791-8087",
          "790-0932",
          "790-0871",
          "799-2649",
          "791-1123",
          "791-0133",
          "791-8005",
          "790-0903",
          "791-8043",
          "791-8074",
          "790-0961",
          "791-8075",
          "791-8012",
          "791-0243",
          "791-8001",
          "799-2452",
          "790-0921",
          "799-2652",
          "791-0128",
          "791-0127",
          "790-0035",
          "790-0034",
          "791-4323",
          "799-2435",
          "791-8073",
          "799-2453",
          "790-0945",
          "790-0944",
          "790-0943",
          "790-0942",
          "791-8067",
          "790-0826",
          "790-0807",
          "791-8056",
          "799-2431",
          "799-2430",
          "790-0041",
          "790-0042",
          "790-0043",
          "790-0922",
          "799-2651",
          "790-0007",
          "799-2456",
          "790-0811",
          "799-2421",
          "790-0812",
          "790-0021",
          "791-8054",
          "790-0915",
          "791-8071",
          "790-0008",
          "790-0814",
          "791-8022",
          "791-8065",
          "791-0101",
          "790-0875",
          "791-8061",
          "791-8060",
          "791-8068",
          "790-0806",
          "791-0244",
          "791-0131",
          "790-0012",
          "791-8085",
          "791-0245",
          "790-0062",
          "790-0061",
          "790-0924",
          "791-8032",
          "791-1112",
          "791-1116",
          "791-0114",
          "790-0006",
          "790-0856",
          "790-0874",
          "791-8042",
          "799-2441",
          "790-0066",
          "790-0065",
          "791-4504",
          "790-0824",
          "791-8027",
          "791-4431",
          "790-0026",
          "790-0855",
          "791-4321",
          "791-8064",
          "790-0861",
          "791-1113",
          "799-2464",
          "799-2641",
          "790-0014",
          "799-2434",
          "791-8013",
          "791-8014",
          "790-0831",
          "791-8026",
          "790-0031",
          "791-0121",
          "791-0120",
          "791-0125",
          "791-8092",
          "790-0862",
          "790-0045",
          "790-0044",
          "790-0046",
          "790-0047",
          "799-2444",
          "791-4508",
          "791-8069",
          "791-8011",
          "791-8021",
          "790-0808",
          "791-8053",
          "799-2656",
          "799-2465",
          "794-0000",
          "794-0081",
          "799-1607",
          "799-1604",
          "799-1603",
          "799-1606",
          "799-1605",
          "799-1608",
          "794-0042",
          "794-0861",
          "794-0085",
          "794-0006",
          "794-0824",
          "794-0057",
          "794-0014",
          "799-2116",
          "794-0062",
          "794-0061",
          "799-2123",
          "794-0035",
          "794-0031",
          "794-0084",
          "794-0005",
          "799-2204",
          "799-2201",
          "799-2202",
          "799-2203",
          "799-2209",
          "799-2208",
          "799-2205",
          "799-2207",
          "799-2206",
          "794-0002",
          "794-1303",
          "794-1305",
          "794-1308",
          "794-1302",
          "794-1307",
          "794-1306",
          "794-1301",
          "794-1304",
          "794-1309",
          "794-0017",
          "794-0013",
          "794-0063",
          "794-0822",
          "794-0004",
          "794-1403",
          "794-1402",
          "794-1401",
          "794-1404",
          "799-1511",
          "799-1531",
          "799-1532",
          "794-0074",
          "794-0804",
          "799-2304",
          "799-2307",
          "799-2306",
          "799-2309",
          "799-2301",
          "799-2302",
          "799-2312",
          "799-2310",
          "799-2308",
          "799-2311",
          "799-2303",
          "799-2305",
          "794-0812",
          "794-0803",
          "794-0011",
          "794-0054",
          "794-0028",
          "799-1502",
          "799-1501",
          "794-0813",
          "794-0024",
          "794-0044",
          "794-0069",
          "799-2122",
          "799-2121",
          "794-0059",
          "794-0064",
          "794-0826",
          "794-0823",
          "794-0825",
          "799-1523",
          "794-0805",
          "794-0051",
          "799-2111",
          "794-0037",
          "799-1533",
          "794-0021",
          "799-1601",
          "794-0023",
          "799-1522",
          "799-1524",
          "799-1534",
          "799-2117",
          "794-0086",
          "794-0087",
          "794-0038",
          "794-0001",
          "794-1103",
          "794-1101",
          "794-1102",
          "794-0058",
          "799-2114",
          "794-0025",
          "799-1512",
          "794-0066",
          "794-0067",
          "799-2113",
          "794-0083",
          "794-0821",
          "794-0102",
          "794-0117",
          "794-0125",
          "794-0107",
          "794-0122",
          "794-0115",
          "794-0112",
          "794-0101",
          "794-0104",
          "794-0109",
          "794-0111",
          "794-0106",
          "794-0121",
          "794-0116",
          "794-0113",
          "794-0103",
          "794-0108",
          "794-0114",
          "794-0105",
          "794-0124",
          "794-0123",
          "799-1536",
          "794-0007",
          "794-0827",
          "794-0815",
          "794-0032",
          "794-0036",
          "794-0015",
          "794-0863",
          "799-1503",
          "799-1527",
          "794-0840",
          "794-0016",
          "794-0055",
          "799-2115",
          "799-2110",
          "799-2108",
          "799-2103",
          "799-2101",
          "799-2107",
          "799-2102",
          "799-2105",
          "799-2104",
          "799-2106",
          "799-2109",
          "794-0068",
          "794-0850",
          "799-1535",
          "794-0082",
          "799-1504",
          "794-2301",
          "794-2303",
          "794-2302",
          "794-2304",
          "794-2305",
          "799-2112",
          "799-2118",
          "794-0831",
          "794-0832",
          "794-0801",
          "799-1506",
          "799-1505",
          "799-1507",
          "794-0033",
          "799-1521",
          "794-0026",
          "794-0065",
          "794-0018",
          "799-1526",
          "799-1514",
          "799-1513",
          "794-0041",
          "794-0034",
          "794-0003",
          "794-0811",
          "794-0027",
          "794-0802",
          "794-0056",
          "794-0043",
          "794-0012",
          "799-1537",
          "792-0080",
          "794-2204",
          "794-2201",
          "794-2203",
          "794-2202",
          "794-0052",
          "794-0022",
          "794-0073",
          "794-0053",
          "799-1602",
          "794-0072",
          "794-0071",
          "799-1525",
          "794-0814",
          "794-2111",
          "794-2117",
          "794-2101",
          "794-2119",
          "794-2102",
          "794-2116",
          "794-2104",
          "794-2103",
          "794-2118",
          "794-2112",
          "794-2115",
          "794-2114",
          "794-2113",
          "794-2110",
          "794-0862",
          "798-0000",
          "798-0030",
          "798-0004",
          "798-0042",
          "798-0026",
          "798-0023",
          "798-0024",
          "798-0025",
          "798-0022",
          "798-0078",
          "798-0043",
          "798-0032",
          "798-0001",
          "798-0002",
          "798-0039",
          "798-0063",
          "798-0027",
          "798-0053",
          "798-0076",
          "798-0075",
          "798-0010",
          "798-0052",
          "798-0093",
          "798-0091",
          "798-0061",
          "798-0007",
          "798-0092",
          "798-0211",
          "798-0064",
          "798-0031",
          "798-0087",
          "798-0062",
          "798-0054",
          "798-0104",
          "798-0090",
          "798-0070",
          "798-0080",
          "798-0035",
          "798-0011",
          "798-0003",
          "798-0045",
          "798-0020",
          "798-0040",
          "798-0005",
          "798-3344",
          "798-3311",
          "798-3301",
          "798-3331",
          "798-3342",
          "798-3341",
          "798-3337",
          "798-3338",
          "798-3323",
          "798-3362",
          "798-3361",
          "798-3363",
          "798-3364",
          "798-3312",
          "798-3322",
          "798-3321",
          "798-3332",
          "798-3356",
          "798-3354",
          "798-3302",
          "798-3358",
          "798-3357",
          "798-3303",
          "798-3352",
          "798-3353",
          "798-3333",
          "798-3346",
          "798-3343",
          "798-3335",
          "798-3336",
          "798-3272",
          "798-3313",
          "798-3271",
          "798-3351",
          "798-3345",
          "798-3334",
          "798-3355",
          "798-0033",
          "798-0065",
          "798-0036",
          "798-0212",
          "798-0081",
          "798-0082",
          "798-0083",
          "798-0074",
          "798-0034",
          "798-2146",
          "798-0044",
          "798-0098",
          "798-0099",
          "798-0097",
          "798-0095",
          "798-0051",
          "798-0066",
          "798-0086",
          "798-0006",
          "798-0088",
          "798-0050",
          "798-0096",
          "798-0041",
          "798-0067",
          "798-0037",
          "798-0038",
          "798-0060",
          "798-0101",
          "798-0102",
          "798-0021",
          "798-1136",
          "798-1101",
          "798-1141",
          "798-1134",
          "798-1137",
          "798-1121",
          "798-1111",
          "798-1116",
          "798-1143",
          "798-1122",
          "798-1135",
          "798-1139",
          "798-1105",
          "798-1102",
          "798-1104",
          "798-1131",
          "798-1138",
          "798-1125",
          "798-1115",
          "798-1133",
          "798-1132",
          "798-1103",
          "798-1113",
          "798-1124",
          "798-1142",
          "798-1112",
          "798-1114",
          "798-1123",
          "798-0085",
          "798-0013",
          "798-0071",
          "798-0068",
          "798-0072",
          "798-0077",
          "798-0073",
          "798-0103",
          "799-3763",
          "799-3704",
          "799-3706",
          "799-3751",
          "799-3772",
          "799-3752",
          "799-3701",
          "799-3741",
          "799-3730",
          "799-3710",
          "799-3720",
          "799-3707",
          "799-3762",
          "799-3761",
          "799-3771",
          "799-3702",
          "799-3703",
          "799-3743",
          "799-3742",
          "799-3705",
          "798-0084",
          "798-0094",
          "798-0014",
          "798-0016",
          "798-0017",
          "798-0015",
          "798-0012",
          "796-0000",
          "796-0088",
          "796-0081",
          "796-0086",
          "796-0056",
          "796-0057",
          "796-8054",
          "796-0022",
          "796-0031",
          "796-0061",
          "796-0073",
          "796-8060",
          "796-8001",
          "796-0004",
          "796-0002",
          "796-0003",
          "796-0087",
          "796-0053",
          "796-0065",
          "796-8036",
          "796-8051",
          "796-8050",
          "796-8052",
          "796-8025",
          "796-0082",
          "796-0048",
          "796-0011",
          "796-0042",
          "796-0046",
          "796-0077",
          "796-8015",
          "796-8008",
          "796-8020",
          "796-8041",
          "796-8010",
          "796-0054",
          "796-0041",
          "796-0051",
          "796-8004",
          "796-8040",
          "796-0069",
          "796-0028",
          "796-0038",
          "796-0037",
          "796-0047",
          "796-0062",
          "796-0036",
          "796-0020",
          "796-0024",
          "796-0023",
          "796-0071",
          "796-0074",
          "796-0079",
          "796-0014",
          "796-0035",
          "796-0064",
          "796-0083",
          "796-0033",
          "796-0055",
          "796-0005",
          "796-8037",
          "796-0067",
          "796-0076",
          "796-0089",
          "796-0085",
          "796-8030",
          "796-0075",
          "796-0044",
          "796-0045",
          "796-0029",
          "796-0034",
          "796-0068",
          "796-0043",
          "796-0032",
          "796-0025",
          "796-0170",
          "796-0021",
          "796-8002",
          "796-8039",
          "796-8003",
          "796-0203",
          "796-0201",
          "796-0111",
          "796-0204",
          "796-0112",
          "796-0205",
          "796-0202",
          "796-0066",
          "796-8053",
          "796-0027",
          "796-0010",
          "796-0052",
          "796-0072",
          "796-0012",
          "796-0084",
          "796-0001",
          "796-8011",
          "796-8006",
          "796-8007",
          "796-8005",
          "796-0026",
          "796-0013",
          "796-8038",
          "796-0063",
          "796-8035",
          "792-0000",
          "792-0897",
          "792-0896",
          "792-0013",
          "792-0021",
          "792-0002",
          "792-0025",
          "792-0866",
          "792-0046",
          "792-0005",
          "792-0008",
          "792-0015",
          "792-0891",
          "792-0060",
          "792-0047",
          "792-0883",
          "792-0071",
          "792-0824",
          "792-0851",
          "792-0801",
          "792-0826",
          "792-0815",
          "792-0842",
          "792-0004",
          "792-0885",
          "792-0890",
          "792-0026",
          "792-0892",
          "792-0884",
          "792-0006",
          "792-0853",
          "792-0854",
          "792-0822",
          "792-0886",
          "792-0895",
          "792-0894",
          "792-0831",
          "792-0812",
          "792-0865",
          "792-0862",
          "792-0023",
          "792-0855",
          "792-0864",
          "792-0836",
          "792-0861",
          "792-0813",
          "792-0811",
          "792-0814",
          "792-0802",
          "792-0003",
          "792-0857",
          "792-0844",
          "792-0821",
          "792-0001",
          "792-0847",
          "792-0031",
          "792-0887",
          "792-0867",
          "792-0034",
          "792-0893",
          "792-0846",
          "792-0804",
          "792-0845",
          "792-0848",
          "792-0888",
          "792-0043",
          "792-0852",
          "792-0022",
          "792-0823",
          "792-0012",
          "792-0841",
          "792-0834",
          "792-0045",
          "792-0044",
          "792-0041",
          "792-0874",
          "792-0072",
          "792-0832",
          "792-0827",
          "792-0035",
          "792-0011",
          "792-0014",
          "792-0898",
          "792-0050",
          "792-0871",
          "792-0872",
          "792-0873",
          "792-0803",
          "792-0856",
          "799-0650",
          "792-0009",
          "792-0825",
          "792-0042",
          "792-0007",
          "792-0032",
          "792-0882",
          "792-0829",
          "792-0868",
          "792-0828",
          "792-0881",
          "792-0016",
          "792-0863",
          "792-0024",
          "792-0833",
          "792-0805",
          "792-0837",
          "792-0835",
          "792-0033",
          "792-0843",
          "792-0017",
          "793-0000",
          "799-1345",
          "793-0023",
          "793-0103",
          "793-0051",
          "793-0010",
          "799-1364",
          "799-1335",
          "793-0037",
          "799-1362",
          "799-1344",
          "799-1342",
          "799-1312",
          "793-0016",
          "793-0211",
          "793-0030",
          "799-1336",
          "799-1314",
          "799-1303",
          "799-1304",
          "793-0041",
          "793-0021",
          "793-0042",
          "799-1343",
          "799-1302",
          "799-1322",
          "793-0212",
          "799-1315",
          "799-1323",
          "799-1107",
          "791-0562",
          "799-1111",
          "799-1112",
          "799-1105",
          "799-1106",
          "799-1103",
          "799-1101",
          "799-1102",
          "799-1104",
          "799-1108",
          "793-0025",
          "793-0067",
          "799-1317",
          "793-0006",
          "793-0007",
          "799-1371",
          "799-1325",
          "793-0028",
          "799-1331",
          "793-0053",
          "793-0101",
          "793-0024",
          "799-1324",
          "799-1321",
          "793-0001",
          "799-1363",
          "799-1313",
          "791-0533",
          "791-0508",
          "791-0532",
          "791-0503",
          "791-0537",
          "791-0525",
          "791-0502",
          "791-0523",
          "791-0542",
          "791-0504",
          "791-0541",
          "791-0531",
          "791-0507",
          "791-0505",
          "791-0535",
          "791-0527",
          "791-0524",
          "791-0526",
          "791-0522",
          "791-0510",
          "791-0538",
          "791-0534",
          "791-0506",
          "791-0501",
          "791-0521",
          "791-0543",
          "791-0536",
          "793-0027",
          "793-0057",
          "793-0061",
          "793-0002",
          "793-0213",
          "793-0214",
          "793-0052",
          "793-0054",
          "793-0055",
          "793-0056",
          "793-0065",
          "793-0063",
          "793-0064",
          "793-0062",
          "793-0215",
          "799-1341",
          "793-0066",
          "793-0017",
          "793-0003",
          "793-0216",
          "793-0026",
          "793-0043",
          "793-0071",
          "793-0072",
          "793-0073",
          "793-0074",
          "793-0075",
          "799-1361",
          "799-1334",
          "799-1316",
          "793-0035",
          "793-0036",
          "793-0102",
          "793-0004",
          "793-0005",
          "793-0044",
          "793-0045",
          "799-1354",
          "793-0039",
          "793-0022",
          "793-0038",
          "799-1351",
          "799-1352",
          "799-1353",
          "793-0046",
          "799-1311",
          "793-0034",
          "799-1301",
          "799-1333",
          "799-1332",
          "799-1372",
          "795-0000",
          "795-0025",
          "795-0062",
          "795-0007",
          "795-0003",
          "795-0088",
          "795-0012",
          "799-3421",
          "795-0032",
          "797-1601",
          "797-1607",
          "797-1604",
          "797-1605",
          "797-1608",
          "797-1606",
          "797-1602",
          "797-1603",
          "795-0009",
          "795-0001",
          "795-0075",
          "795-0089",
          "795-0008",
          "795-0074",
          "795-0051",
          "799-3433",
          "799-3432",
          "799-3431",
          "795-0084",
          "795-0085",
          "795-0083",
          "795-0081",
          "795-0082",
          "795-0024",
          "795-0031",
          "795-0078",
          "795-0063",
          "795-0044",
          "795-0053",
          "795-0061",
          "799-3462",
          "799-3461",
          "799-3464",
          "799-3463",
          "795-0004",
          "799-3402",
          "799-3401",
          "799-3470",
          "799-3456",
          "799-3455",
          "799-3422",
          "799-3405",
          "799-3404",
          "799-3406",
          "799-3453",
          "799-3452",
          "799-3454",
          "799-3407",
          "799-3411",
          "799-3441",
          "799-3444",
          "799-3451",
          "799-3413",
          "799-3403",
          "799-3412",
          "799-3442",
          "799-3443",
          "795-0054",
          "795-0086",
          "795-0069",
          "795-0072",
          "795-0071",
          "795-0070",
          "795-0073",
          "795-0013",
          "795-0041",
          "795-0046",
          "795-0045",
          "795-0064",
          "795-0065",
          "797-1503",
          "797-1507",
          "797-1501",
          "797-1506",
          "797-1508",
          "797-1502",
          "797-1504",
          "797-1505",
          "795-0021",
          "795-0023",
          "795-0022",
          "795-0076",
          "795-0002",
          "795-0087",
          "795-0006",
          "795-0077",
          "795-0011",
          "795-0005",
          "795-0042",
          "795-0043",
          "795-0052",
          "799-3100",
          "799-3122",
          "799-3121",
          "799-3103",
          "799-3136",
          "799-3131",
          "799-3127",
          "799-3112",
          "799-3134",
          "799-3104",
          "799-3113",
          "799-3111",
          "799-3133",
          "799-3105",
          "799-3123",
          "791-3203",
          "791-3204",
          "791-3202",
          "791-3201",
          "791-3205",
          "791-3206",
          "799-3114",
          "799-3132",
          "799-3311",
          "799-3202",
          "799-3313",
          "799-3314",
          "799-3312",
          "799-3201",
          "799-3207",
          "799-3126",
          "799-3124",
          "799-3128",
          "799-3115",
          "799-3102",
          "799-3125",
          "799-3101",
          "799-3135",
          "799-0400",
          "799-0123",
          "799-0124",
          "799-0122",
          "799-0412",
          "799-0121",
          "799-0127",
          "799-0128",
          "799-0101",
          "799-0102",
          "799-0103",
          "799-0641",
          "799-0642",
          "799-0111",
          "799-0112",
          "799-0423",
          "799-0431",
          "799-0125",
          "799-0411",
          "799-0126",
          "799-0301",
          "799-0302",
          "799-0303",
          "799-0304",
          "799-0712",
          "799-0721",
          "799-0713",
          "799-0724",
          "799-0722",
          "799-0702",
          "799-0704",
          "799-0723",
          "799-0711",
          "799-0701",
          "799-0705",
          "799-0714",
          "799-0703",
          "799-0643",
          "799-0645",
          "799-0644",
          "799-0434",
          "799-0432",
          "799-0436",
          "799-0435",
          "799-0433",
          "799-0413",
          "799-0422",
          "799-0403",
          "799-0421",
          "799-0402",
          "799-0405",
          "799-0404",
          "799-0401",
          "799-0113",
          "797-0000",
          "797-0113",
          "797-0201",
          "797-0203",
          "797-0111",
          "797-0112",
          "797-0202",
          "797-0010",
          "797-0007",
          "797-0014",
          "797-0004",
          "797-0013",
          "797-0034",
          "797-0026",
          "797-0015",
          "797-0043",
          "797-0033",
          "797-0022",
          "797-0027",
          "797-0012",
          "797-0046",
          "797-0044",
          "797-0035",
          "797-0030",
          "797-0036",
          "797-0003",
          "797-0025",
          "797-0045",
          "797-0008",
          "797-0018",
          "797-0005",
          "797-0006",
          "797-0016",
          "797-0042",
          "797-0032",
          "797-0001",
          "797-0029",
          "797-0024",
          "797-0021",
          "797-0037",
          "797-0041",
          "797-0020",
          "797-0011",
          "797-0017",
          "797-0002",
          "797-0031",
          "797-0023",
          "797-0028",
          "797-1716",
          "797-1717",
          "797-1714",
          "797-1713",
          "797-1704",
          "797-1703",
          "797-1715",
          "797-1705",
          "797-1701",
          "797-1711",
          "797-1702",
          "797-1712",
          "797-1211",
          "797-1106",
          "797-1324",
          "797-1434",
          "797-1213",
          "797-1323",
          "797-1326",
          "797-1104",
          "797-1216",
          "797-1327",
          "797-1433",
          "797-1322",
          "797-1101",
          "797-1103",
          "797-1432",
          "797-1215",
          "797-1107",
          "797-1214",
          "797-1105",
          "797-1325",
          "797-1328",
          "797-1212",
          "797-1217",
          "797-1431",
          "797-1102",
          "797-1321",
          "796-0907",
          "796-0909",
          "796-0910",
          "796-0911",
          "796-0906",
          "796-0913",
          "796-0912",
          "796-0905",
          "796-0915",
          "796-0901",
          "796-0908",
          "796-0902",
          "796-0903",
          "796-0904",
          "796-0914",
          "791-0200",
          "791-0315",
          "791-0221",
          "791-0213",
          "791-0223",
          "791-0321",
          "791-0303",
          "791-0215",
          "791-0204",
          "791-0206",
          "791-0222",
          "791-0311",
          "791-0312",
          "791-0313",
          "791-0212",
          "791-0322",
          "791-0205",
          "791-0216",
          "791-0202",
          "791-0314",
          "791-0301",
          "791-0214",
          "791-0211",
          "791-0323",
          "791-0201",
          "791-0203",
          "791-0302",
          "794-2500",
          "794-2550",
          "794-2410",
          "794-2540",
          "794-2541",
          "794-2542",
          "794-2508",
          "794-2513",
          "794-2510",
          "794-2503",
          "794-2512",
          "794-2501",
          "794-2520",
          "794-2502",
          "794-2506",
          "794-2530",
          "794-2509",
          "794-2504",
          "794-2511",
          "794-2507",
          "794-2505",
          "791-1200",
          "791-1709",
          "791-1705",
          "791-1505",
          "791-1202",
          "791-1504",
          "791-1702",
          "791-1703",
          "791-1501",
          "791-1206",
          "791-1211",
          "791-1201",
          "791-1515",
          "791-1708",
          "791-1514",
          "791-1513",
          "791-1701",
          "791-1207",
          "791-1212",
          "791-1205",
          "791-1223",
          "791-1221",
          "791-1213",
          "791-1707",
          "791-1502",
          "791-1803",
          "791-1511",
          "791-1802",
          "791-1203",
          "791-1222",
          "791-1512",
          "791-1204",
          "791-1503",
          "791-1706",
          "791-1704",
          "791-1801",
          "791-1710",
          "791-3100",
          "791-3141",
          "791-3153",
          "791-3142",
          "791-3161",
          "791-3131",
          "791-3102",
          "791-3162",
          "791-3133",
          "791-3143",
          "791-3120",
          "791-3155",
          "791-3163",
          "791-3164",
          "791-3152",
          "791-3134",
          "791-3132",
          "791-3110",
          "791-3151",
          "791-3101",
          "791-3154",
          "791-2100",
          "791-2114",
          "791-2142",
          "791-2141",
          "791-2135",
          "791-2206",
          "791-2126",
          "791-2145",
          "791-2132",
          "791-2117",
          "791-2123",
          "791-2143",
          "791-2131",
          "791-2133",
          "791-2112",
          "791-2113",
          "791-2122",
          "791-2207",
          "791-2205",
          "791-2204",
          "791-2103",
          "791-2102",
          "791-2101",
          "791-2124",
          "791-2202",
          "791-2134",
          "791-2203",
          "791-2125",
          "791-2116",
          "791-2144",
          "791-2201",
          "791-2121",
          "791-2120",
          "791-2115",
          "791-2111",
          "791-3300",
          "795-0301",
          "791-3343",
          "791-3351",
          "791-3514",
          "791-3301",
          "795-0302",
          "791-3360",
          "791-3363",
          "791-3364",
          "791-3362",
          "791-3361",
          "791-3504",
          "791-3501",
          "791-3524",
          "791-3523",
          "791-3513",
          "791-3321",
          "791-3342",
          "795-0307",
          "795-0304",
          "795-0305",
          "791-3310",
          "795-0309",
          "791-3331",
          "791-3505",
          "791-3322",
          "791-3502",
          "791-3522",
          "791-3512",
          "791-3503",
          "795-0303",
          "795-0306",
          "791-3332",
          "791-3521",
          "791-3506",
          "791-3352",
          "795-0308",
          "791-3511",
          "791-3341",
          "796-0300",
          "796-0501",
          "796-0304",
          "796-0805",
          "796-0503",
          "796-0612",
          "796-0804",
          "796-0308",
          "796-0815",
          "796-0303",
          "796-0305",
          "796-0312",
          "796-0611",
          "796-0822",
          "796-0421",
          "796-0613",
          "796-0615",
          "796-0505",
          "796-0302",
          "796-0803",
          "796-0506",
          "796-0504",
          "796-0823",
          "796-0802",
          "796-0614",
          "796-0313",
          "796-0311",
          "796-0307",
          "796-0816",
          "796-0306",
          "796-0814",
          "796-0813",
          "796-0422",
          "796-0811",
          "796-0801",
          "796-0502",
          "796-0301",
          "796-0812",
          "796-0821",
          "798-2100",
          "798-2113",
          "798-2105",
          "798-2104",
          "798-2103",
          "798-2102",
          "798-2101",
          "798-2106",
          "798-2111",
          "798-2112",
          "798-1300",
          "798-1375",
          "798-1371",
          "798-1332",
          "798-1323",
          "798-1363",
          "798-1301",
          "798-1331",
          "798-1321",
          "798-1503",
          "798-1501",
          "798-1322",
          "798-1312",
          "798-1354",
          "798-1362",
          "798-1361",
          "798-1314",
          "798-1324",
          "798-1311",
          "798-1367",
          "798-1355",
          "798-1302",
          "798-1502",
          "798-1373",
          "798-1341",
          "798-1342",
          "798-1343",
          "798-1344",
          "798-1345",
          "798-1505",
          "798-1506",
          "798-1507",
          "798-1333",
          "798-1356",
          "798-1352",
          "798-1353",
          "798-1351",
          "798-1374",
          "798-1365",
          "798-1372",
          "798-1313",
          "798-1366",
          "798-1504",
          "798-1303",
          "798-1364",
          "798-4100",
          "798-4123",
          "798-3708",
          "798-4345",
          "798-3705",
          "798-4408",
          "798-4351",
          "798-4344",
          "798-4206",
          "798-4407",
          "798-4214",
          "798-4347",
          "798-4343",
          "798-4346",
          "798-4204",
          "798-4209",
          "798-3701",
          "798-3702",
          "798-4219",
          "798-4203",
          "798-4201",
          "798-4215",
          "798-4403",
          "798-4126",
          "798-4212",
          "798-4131",
          "798-4132",
          "798-3703",
          "798-4136",
          "798-4208",
          "798-4124",
          "798-4213",
          "798-4125",
          "798-4348",
          "798-4207",
          "798-4404",
          "798-3707",
          "798-4211",
          "798-4353",
          "798-3704",
          "798-4406",
          "798-4342",
          "798-4216",
          "798-4205",
          "798-4352",
          "798-4122",
          "798-4401",
          "798-4402",
          "798-4101",
          "798-4103",
          "798-4105",
          "798-4110",
          "798-4102",
          "798-4121",
          "798-4104",
          "798-4405",
          "798-4134",
          "798-4133",
          "798-4135",
          "798-4217",
          "798-4218",
          "798-3706",
          "798-4202",
          "798-4341",
          "798-4349",
          "780-0000",
          "780-0054",
          "781-0813",
          "780-0936",
          "780-8072",
          "780-8061",
          "780-8062",
          "780-8063",
          "780-8064",
          "780-8065",
          "780-8066",
          "780-8077",
          "780-8076",
          "780-8075",
          "780-8074",
          "780-8073",
          "780-0938",
          "780-0943",
          "780-0955",
          "780-0935",
          "781-0010",
          "781-0013",
          "781-0012",
          "781-0015",
          "781-0014",
          "781-0011",
          "780-0051",
          "780-0025",
          "780-0027",
          "780-0921",
          "781-0111",
          "780-8038",
          "780-0064",
          "780-0046",
          "781-8130",
          "781-8131",
          "781-8133",
          "781-8134",
          "781-8136",
          "781-8132",
          "781-8135",
          "781-0814",
          "780-0041",
          "780-0948",
          "780-8083",
          "781-8008",
          "780-0031",
          "780-8011",
          "781-0262",
          "780-0844",
          "780-0053",
          "780-0928",
          "781-0086",
          "780-0974",
          "780-0842",
          "780-0052",
          "780-0947",
          "780-8085",
          "781-5102",
          "781-5103",
          "780-8031",
          "781-0801",
          "780-0915",
          "780-0841",
          "780-0032",
          "781-3104",
          "781-3124",
          "781-3101",
          "781-3103",
          "781-3115",
          "781-3123",
          "781-3107",
          "781-3105",
          "781-3102",
          "781-3125",
          "781-3112",
          "781-3114",
          "781-3106",
          "781-3113",
          "781-3122",
          "781-3111",
          "781-3121",
          "781-3108",
          "780-0933",
          "781-8121",
          "780-0946",
          "780-0901",
          "780-8052",
          "780-8050",
          "780-8051",
          "780-8071",
          "780-0994",
          "781-0073",
          "781-0081",
          "781-0088",
          "781-0083",
          "781-8003",
          "780-0022",
          "780-8028",
          "780-8019",
          "780-8026",
          "780-0913",
          "780-0956",
          "780-0056",
          "781-8126",
          "781-0832",
          "780-0963",
          "780-0001",
          "781-5105",
          "781-5106",
          "781-5107",
          "781-5104",
          "780-8032",
          "781-0811",
          "780-8033",
          "780-8040",
          "780-8035",
          "780-0055",
          "781-8125",
          "780-0043",
          "780-0045",
          "780-0823",
          "780-0834",
          "780-0061",
          "780-0047",
          "780-0821",
          "780-0929",
          "780-0954",
          "780-0923",
          "781-8010",
          "780-0065",
          "781-5108",
          "780-8014",
          "780-0002",
          "781-0805",
          "780-0975",
          "780-0934",
          "780-0916",
          "780-8037",
          "780-0996",
          "780-0063",
          "780-0824",
          "781-8004",
          "780-0062",
          "780-0911",
          "780-0944",
          "780-0903",
          "780-0072",
          "781-0250",
          "781-0252",
          "781-0251",
          "781-0253",
          "780-0991",
          "780-0926",
          "780-0862",
          "781-8123",
          "781-8104",
          "781-8111",
          "781-8112",
          "781-8103",
          "781-8122",
          "781-8101",
          "781-8113",
          "781-8114",
          "781-8105",
          "781-8102",
          "780-0071",
          "780-8027",
          "780-0914",
          "780-8018",
          "781-0113",
          "780-0931",
          "781-0806",
          "780-0952",
          "780-8012",
          "781-8001",
          "780-0864",
          "781-0114",
          "780-0904",
          "781-3201",
          "781-3212",
          "781-3221",
          "781-3214",
          "781-3211",
          "781-3202",
          "781-3223",
          "781-3213",
          "781-3222",
          "781-3203",
          "780-0949",
          "780-0983",
          "780-0021",
          "780-0044",
          "780-0937",
          "781-8007",
          "781-0831",
          "780-0817",
          "780-0972",
          "780-0953",
          "781-0270",
          "781-0245",
          "781-0271",
          "780-0003",
          "780-0992",
          "780-0932",
          "781-0112",
          "780-0984",
          "780-0033",
          "780-0951",
          "780-0925",
          "780-0843",
          "781-5101",
          "780-0825",
          "781-8006",
          "780-0026",
          "780-0912",
          "780-8021",
          "780-8022",
          "780-8087",
          "780-8090",
          "780-8086",
          "780-8088",
          "780-8089",
          "780-0993",
          "780-0822",
          "781-0321",
          "781-0313",
          "781-0322",
          "781-0324",
          "781-0304",
          "781-0316",
          "781-0323",
          "781-0315",
          "781-0301",
          "781-0303",
          "781-0302",
          "781-0312",
          "781-0314",
          "781-0325",
          "781-0311",
          "780-8039",
          "780-0982",
          "780-8036",
          "780-0023",
          "780-0962",
          "780-0066",
          "780-8013",
          "780-0981",
          "781-0804",
          "780-8015",
          "780-8024",
          "780-0966",
          "780-0965",
          "780-0967",
          "781-0085",
          "781-0815",
          "780-0922",
          "780-0818",
          "780-0042",
          "780-0945",
          "780-0902",
          "780-0870",
          "780-0024",
          "780-8084",
          "780-0861",
          "780-0973",
          "781-0802",
          "780-0850",
          "780-0034",
          "780-0004",
          "780-0976",
          "780-0977",
          "781-0074",
          "781-0082",
          "781-0087",
          "780-0985",
          "780-8034",
          "781-0084",
          "781-8005",
          "780-8017",
          "780-8025",
          "781-8016",
          "780-0833",
          "780-0816",
          "780-0971",
          "780-0942",
          "781-0261",
          "780-0924",
          "780-0941",
          "781-8124",
          "781-8002",
          "780-0957",
          "780-0927",
          "781-0803",
          "780-0964",
          "781-0240",
          "781-0241",
          "781-0242",
          "781-0243",
          "781-0244",
          "780-0048",
          "780-0863",
          "780-0995",
          "780-0961",
          "780-8023",
          "780-8081",
          "780-8082",
          "781-0812",
          "781-7100",
          "781-7103",
          "781-7104",
          "781-7105",
          "781-7106",
          "781-6832",
          "781-6831",
          "781-6833",
          "781-7220",
          "781-6741",
          "781-6742",
          "781-7102",
          "781-7101",
          "781-7107",
          "781-7108",
          "781-7109",
          "784-0000",
          "784-0033",
          "784-0034",
          "784-0057",
          "784-0058",
          "784-0031",
          "784-0032",
          "784-0045",
          "784-0051",
          "784-0052",
          "784-0029",
          "784-0274",
          "784-0275",
          "784-0055",
          "784-0056",
          "784-0053",
          "784-0043",
          "784-0044",
          "784-0003",
          "784-0273",
          "784-0028",
          "784-0276",
          "784-0007",
          "784-0021",
          "784-0026",
          "784-0277",
          "784-0046",
          "784-0022",
          "784-0008",
          "784-0041",
          "784-0023",
          "784-0024",
          "784-0025",
          "784-0042",
          "784-0054",
          "784-0271",
          "784-0020",
          "784-0272",
          "784-0061",
          "784-0062",
          "784-0063",
          "784-0002",
          "784-0010",
          "784-0006",
          "784-0278",
          "784-0027",
          "784-0004",
          "784-0064",
          "784-0005",
          "784-0001",
          "783-0000",
          "783-0074",
          "783-0008",
          "783-0084",
          "783-0063",
          "783-0061",
          "783-0002",
          "783-0077",
          "783-0004",
          "783-0005",
          "783-0046",
          "783-0051",
          "783-0042",
          "783-0048",
          "783-0043",
          "783-0047",
          "783-0041",
          "783-0040",
          "783-0049",
          "783-0044",
          "783-0045",
          "783-0081",
          "783-0035",
          "783-0033",
          "783-0026",
          "783-0032",
          "783-0071",
          "783-0062",
          "783-0076",
          "783-0075",
          "783-0053",
          "783-0022",
          "783-0011",
          "783-0068",
          "783-0013",
          "783-0082",
          "783-0027",
          "783-0064",
          "783-0006",
          "783-0095",
          "783-0025",
          "783-0031",
          "783-0058",
          "783-0028",
          "783-0052",
          "783-0037",
          "783-0091",
          "783-0092",
          "783-0067",
          "783-0085",
          "783-0065",
          "783-0073",
          "783-0078",
          "783-0066",
          "783-0072",
          "783-0003",
          "783-0029",
          "783-0021",
          "783-0023",
          "783-0083",
          "783-0054",
          "783-0024",
          "783-0012",
          "783-0096",
          "783-0001",
          "783-0036",
          "783-0055",
          "783-0060",
          "783-0034",
          "783-0094",
          "783-0086",
          "783-0007",
          "783-0087",
          "783-0014",
          "783-0093",
          "783-0057",
          "783-0056",
          "781-1100",
          "781-1136",
          "781-1134",
          "781-1142",
          "781-1132",
          "781-1141",
          "781-1164",
          "781-1162",
          "781-1161",
          "781-1163",
          "781-1165",
          "781-1113",
          "781-1111",
          "781-1125",
          "781-1101",
          "781-1102",
          "781-1103",
          "781-1104",
          "781-1133",
          "781-1135",
          "781-1153",
          "781-1151",
          "781-1131",
          "781-1154",
          "781-1123",
          "781-1143",
          "781-1105",
          "781-1121",
          "781-1112",
          "781-1122",
          "781-1124",
          "781-1152",
          "781-1114",
          "785-0000",
          "785-0047",
          "785-0044",
          "785-0004",
          "785-0037",
          "785-0024",
          "785-0021",
          "785-0017",
          "785-0165",
          "785-0173",
          "785-0174",
          "785-0166",
          "785-0171",
          "785-0164",
          "785-0161",
          "785-0167",
          "785-0163",
          "785-0162",
          "785-0172",
          "785-0055",
          "785-0030",
          "785-0054",
          "785-0035",
          "785-0033",
          "785-0034",
          "785-0052",
          "785-0010",
          "785-0026",
          "785-0027",
          "785-0028",
          "785-0059",
          "785-0057",
          "785-0058",
          "785-0053",
          "785-0051",
          "785-0015",
          "785-0016",
          "785-0032",
          "785-0025",
          "785-0022",
          "785-0023",
          "785-0003",
          "785-0018",
          "785-0046",
          "785-0045",
          "785-0043",
          "785-0008",
          "785-0041",
          "785-0012",
          "785-0013",
          "785-0009",
          "785-0056",
          "785-0006",
          "785-0001",
          "785-0011",
          "785-0005",
          "785-0036",
          "785-0002",
          "785-0007",
          "785-0042",
          "785-0031",
          "785-0014",
          "788-0000",
          "788-0021",
          "788-0023",
          "788-0009",
          "788-0010",
          "788-0014",
          "788-0034",
          "788-0679",
          "788-0678",
          "788-0677",
          "788-0051",
          "788-0031",
          "788-0013",
          "788-0024",
          "788-0035",
          "788-0027",
          "788-0272",
          "788-0267",
          "788-0266",
          "788-0262",
          "788-0271",
          "788-0274",
          "788-0261",
          "788-0268",
          "788-0263",
          "788-0273",
          "788-0265",
          "788-0264",
          "788-0033",
          "788-0003",
          "788-0053",
          "788-0054",
          "788-0006",
          "788-0030",
          "788-0026",
          "788-0028",
          "788-0011",
          "788-0012",
          "788-0001",
          "788-0039",
          "788-0004",
          "788-0015",
          "788-0032",
          "788-0025",
          "788-0038",
          "788-0036",
          "788-0005",
          "788-0041",
          "788-0045",
          "788-0044",
          "788-0048",
          "788-0042",
          "788-0049",
          "788-0043",
          "788-0046",
          "788-0047",
          "788-0781",
          "788-0782",
          "788-0786",
          "788-0783",
          "788-0007",
          "788-0002",
          "788-0022",
          "788-0037",
          "788-0784",
          "788-0785",
          "788-0008",
          "788-0052",
          "787-0300",
          "787-0303",
          "787-0315",
          "787-0556",
          "787-0327",
          "787-0302",
          "787-0447",
          "787-0310",
          "787-0331",
          "787-0328",
          "787-0301",
          "787-0314",
          "787-0562",
          "787-0317",
          "787-0446",
          "787-0243",
          "787-0561",
          "787-0334",
          "787-0335",
          "787-0338",
          "787-0336",
          "787-0560",
          "787-0312",
          "787-0244",
          "787-0311",
          "787-0308",
          "787-0322",
          "787-0323",
          "787-0306",
          "787-0325",
          "787-0332",
          "787-0320",
          "787-0330",
          "787-0559",
          "787-0242",
          "787-0445",
          "787-0563",
          "787-0557",
          "787-0558",
          "787-0452",
          "787-0240",
          "787-0324",
          "787-0453",
          "787-0313",
          "787-0305",
          "787-0318",
          "787-0333",
          "787-0241",
          "787-0321",
          "787-0326",
          "787-0316",
          "787-0450",
          "787-0451",
          "787-0307",
          "787-0304",
          "787-0337",
          "787-0339",
          "787-0000",
          "787-0007",
          "787-0052",
          "787-0006",
          "787-0668",
          "787-0771",
          "787-1441",
          "787-0150",
          "787-0773",
          "787-1103",
          "787-1107",
          "787-1226",
          "787-0015",
          "787-0012",
          "787-0013",
          "787-0011",
          "787-0014",
          "787-0669",
          "787-0774",
          "787-1557",
          "787-1553",
          "787-1550",
          "787-1101",
          "787-1552",
          "787-1223",
          "787-1224",
          "787-0776",
          "787-1220",
          "787-0775",
          "787-1227",
          "787-0666",
          "787-1102",
          "787-0019",
          "787-0051",
          "787-0667",
          "787-1225",
          "787-0010",
          "787-1556",
          "787-1558",
          "787-0009",
          "787-0156",
          "787-1106",
          "787-0158",
          "787-1108",
          "787-0155",
          "787-1551",
          "787-1554",
          "787-1228",
          "787-0151",
          "787-1559",
          "787-1229",
          "787-1109",
          "787-1222",
          "787-0161",
          "787-0016",
          "787-1105",
          "787-0026",
          "787-0025",
          "787-0036",
          "787-0033",
          "787-0024",
          "787-0030",
          "787-0021",
          "787-0029",
          "787-0032",
          "787-0002",
          "787-0037",
          "787-0022",
          "787-0027",
          "787-0038",
          "787-0035",
          "787-0031",
          "787-0023",
          "787-0001",
          "787-0004",
          "787-0003",
          "787-0028",
          "787-0034",
          "787-0005",
          "787-0163",
          "787-0152",
          "787-1321",
          "787-1607",
          "787-1601",
          "787-1615",
          "787-1326",
          "787-1322",
          "787-1325",
          "787-1324",
          "787-1617",
          "787-1616",
          "787-1611",
          "787-1613",
          "787-1612",
          "787-1618",
          "787-1605",
          "787-1323",
          "787-1602",
          "787-1606",
          "787-1604",
          "787-1603",
          "787-1614",
          "787-0020",
          "787-0162",
          "787-0154",
          "787-0159",
          "787-1444",
          "787-0153",
          "787-0017",
          "787-0018",
          "787-0160",
          "787-1221",
          "787-1555",
          "787-0665",
          "787-0008",
          "787-0157",
          "787-0772",
          "787-1104",
          "787-0050",
          "787-1443",
          "787-1442",
          "781-5200",
          "781-5310",
          "781-5467",
          "781-5451",
          "781-5331",
          "781-5454",
          "781-5452",
          "781-5464",
          "781-5463",
          "781-5332",
          "781-5455",
          "781-5461",
          "781-5466",
          "781-5469",
          "781-5465",
          "781-5468",
          "781-5462",
          "781-5453",
          "781-5202",
          "781-5233",
          "781-5234",
          "781-5235",
          "781-5204",
          "781-5212",
          "781-5211",
          "781-5203",
          "781-5223",
          "781-5232",
          "781-5224",
          "781-5213",
          "781-5231",
          "781-5221",
          "781-5222",
          "781-5201",
          "781-5206",
          "781-5205",
          "781-5604",
          "781-5606",
          "781-5613",
          "781-5615",
          "781-5602",
          "781-5601",
          "781-5621",
          "781-5622",
          "781-5605",
          "781-5616",
          "781-5603",
          "781-5614",
          "781-5612",
          "781-5611",
          "781-5242",
          "781-5241",
          "782-0000",
          "781-4223",
          "781-4224",
          "781-4222",
          "781-4247",
          "781-4215",
          "781-4243",
          "781-4241",
          "781-4242",
          "781-4206",
          "781-4227",
          "781-4226",
          "781-4213",
          "781-4203",
          "781-4221",
          "781-4245",
          "781-4232",
          "781-4214",
          "781-4201",
          "781-4233",
          "781-4236",
          "781-4208",
          "781-4207",
          "781-4225",
          "781-4211",
          "781-4204",
          "781-4216",
          "781-4217",
          "781-4244",
          "781-4231",
          "781-4246",
          "781-4212",
          "781-4235",
          "781-4234",
          "781-4205",
          "781-4202",
          "782-0033",
          "782-0072",
          "782-0009",
          "782-0059",
          "782-0017",
          "782-0021",
          "782-0054",
          "782-0074",
          "782-0078",
          "782-0014",
          "789-0582",
          "782-0006",
          "789-0586",
          "789-0587",
          "782-0056",
          "782-0012",
          "789-0584",
          "782-0022",
          "782-0023",
          "782-0051",
          "782-0039",
          "782-0005",
          "782-0008",
          "782-0071",
          "782-0077",
          "782-0079",
          "789-0585",
          "782-0015",
          "782-0058",
          "782-0038",
          "782-0024",
          "782-0001",
          "782-0055",
          "782-0061",
          "782-0064",
          "782-0034",
          "782-0010",
          "782-0018",
          "782-0073",
          "782-0019",
          "782-0075",
          "782-0032",
          "789-0581",
          "782-0004",
          "782-0007",
          "782-0063",
          "782-0031",
          "782-0057",
          "782-0035",
          "789-0583",
          "782-0062",
          "782-0002",
          "782-0076",
          "782-0013",
          "782-0025",
          "782-0003",
          "782-0037",
          "782-0016",
          "782-0011",
          "782-0043",
          "782-0041",
          "782-0045",
          "782-0044",
          "782-0036",
          "782-0042",
          "782-0046",
          "782-0047",
          "781-4643",
          "781-4401",
          "781-4528",
          "781-4641",
          "781-4403",
          "781-4524",
          "781-4523",
          "781-4531",
          "781-4522",
          "781-4526",
          "781-4404",
          "781-4530",
          "781-4413",
          "781-4406",
          "781-4412",
          "781-4414",
          "781-4529",
          "781-4411",
          "784-0065",
          "781-4405",
          "781-4642",
          "781-4644",
          "781-4415",
          "781-4527",
          "781-4521",
          "781-4525",
          "781-4645",
          "781-4402",
          "781-7300",
          "781-7414",
          "781-7412",
          "781-7411",
          "781-7413",
          "781-7302",
          "781-7304",
          "781-7301",
          "781-7303",
          "781-6400",
          "781-6401",
          "781-6402",
          "781-6403",
          "781-6410",
          "781-6438",
          "781-6436",
          "781-6424",
          "781-6422",
          "781-6427",
          "781-6437",
          "781-6433",
          "781-6423",
          "781-6432",
          "781-6425",
          "781-6439",
          "781-6435",
          "781-6431",
          "781-6426",
          "781-6430",
          "781-6421",
          "781-6434",
          "781-6458",
          "781-6449",
          "781-6443",
          "781-6455",
          "781-6456",
          "781-6451",
          "781-6447",
          "781-6454",
          "781-6459",
          "781-6448",
          "781-6460",
          "781-6445",
          "781-6446",
          "781-6444",
          "781-6441",
          "781-6442",
          "781-6452",
          "781-6457",
          "781-6453",
          "781-6450",
          "781-6200",
          "781-6201",
          "781-6202",
          "781-5700",
          "781-5705",
          "781-5708",
          "781-5707",
          "781-5706",
          "781-5703",
          "781-5704",
          "781-5701",
          "781-5702",
          "781-3600",
          "781-3604",
          "781-3623",
          "781-3602",
          "781-3611",
          "781-3612",
          "781-3613",
          "781-3614",
          "781-3615",
          "781-3608",
          "781-3620",
          "781-3617",
          "781-3610",
          "781-3605",
          "781-3609",
          "781-3622",
          "781-3606",
          "781-3619",
          "781-3624",
          "781-3607",
          "781-3601",
          "781-3621",
          "781-3618",
          "781-3603",
          "789-0300",
          "789-0167",
          "789-0307",
          "789-0237",
          "789-0157",
          "789-0233",
          "789-0158",
          "789-0323",
          "789-0306",
          "789-0248",
          "789-0247",
          "789-0173",
          "789-0169",
          "789-0170",
          "789-0171",
          "789-0316",
          "789-0231",
          "789-0321",
          "789-0232",
          "789-0428",
          "789-0302",
          "789-0252",
          "789-0172",
          "789-0303",
          "789-0313",
          "789-0241",
          "789-0325",
          "789-0324",
          "789-0250",
          "789-0255",
          "789-0305",
          "789-0311",
          "789-0312",
          "789-0426",
          "789-0427",
          "789-0168",
          "789-0304",
          "789-0301",
          "789-0242",
          "789-0234",
          "789-0322",
          "789-0174",
          "789-0315",
          "789-0251",
          "789-0245",
          "789-0165",
          "789-0243",
          "789-0254",
          "789-0159",
          "789-0160",
          "789-0162",
          "789-0314",
          "789-0166",
          "789-0235",
          "789-0163",
          "789-0244",
          "789-0156",
          "789-0253",
          "789-0246",
          "789-0161",
          "789-0164",
          "789-0236",
          "781-3400",
          "781-3408",
          "781-3336",
          "781-3335",
          "781-3524",
          "781-3522",
          "781-3407",
          "781-3332",
          "781-3526",
          "781-3523",
          "781-3402",
          "781-3331",
          "781-3525",
          "781-3337",
          "781-3521",
          "781-3406",
          "781-3401",
          "781-3334",
          "781-3404",
          "781-3333",
          "781-3405",
          "781-3742",
          "781-3403",
          "781-3741",
          "781-3409",
          "781-3700",
          "781-3704",
          "781-3713",
          "781-3705",
          "781-3714",
          "781-3717",
          "781-3723",
          "781-3712",
          "781-3716",
          "781-3703",
          "781-3715",
          "781-3725",
          "781-3722",
          "781-3711",
          "781-3721",
          "781-3702",
          "781-3701",
          "781-3724",
          "781-2100",
          "781-2110",
          "781-2115",
          "781-2613",
          "781-2121",
          "781-2119",
          "781-2117",
          "781-2118",
          "781-2108",
          "781-2107",
          "781-2106",
          "781-2120",
          "781-2604",
          "781-2126",
          "781-2603",
          "781-2136",
          "781-2614",
          "781-2133",
          "781-2127",
          "781-2401",
          "781-2402",
          "781-2114",
          "781-2511",
          "781-2512",
          "781-2143",
          "781-2615",
          "781-2102",
          "781-2134",
          "781-2324",
          "781-2322",
          "781-2321",
          "781-2323",
          "781-2325",
          "781-2135",
          "781-2103",
          "781-2332",
          "781-2331",
          "781-2334",
          "781-2335",
          "781-2333",
          "781-2141",
          "781-2105",
          "781-2101",
          "781-2612",
          "781-2605",
          "781-2122",
          "781-2123",
          "781-2602",
          "781-2142",
          "781-2601",
          "781-2616",
          "781-2132",
          "781-2112",
          "781-2128",
          "781-2124",
          "781-2111",
          "781-2104",
          "781-2131",
          "781-2113",
          "781-2116",
          "781-2145",
          "781-2146",
          "781-2144",
          "781-2611",
          "781-1500",
          "781-1532",
          "781-1612",
          "781-1914",
          "781-1621",
          "781-1615",
          "781-1512",
          "781-1611",
          "781-1514",
          "781-1915",
          "781-1756",
          "781-1501",
          "781-1751",
          "781-1614",
          "781-1617",
          "781-1601",
          "781-1628",
          "781-1520",
          "781-1534",
          "781-1518",
          "781-1602",
          "781-1766",
          "781-1605",
          "781-1502",
          "781-1804",
          "781-1754",
          "781-1607",
          "781-1746",
          "781-1531",
          "781-1517",
          "781-1608",
          "781-1743",
          "781-1505",
          "781-1506",
          "781-1745",
          "781-1762",
          "781-1523",
          "781-1802",
          "781-1610",
          "781-1742",
          "781-1758",
          "781-1503",
          "781-1522",
          "781-1911",
          "781-1912",
          "781-1913",
          "781-1765",
          "781-1753",
          "781-1618",
          "781-1626",
          "781-1511",
          "781-1606",
          "781-1624",
          "781-1752",
          "781-1763",
          "781-1764",
          "781-1516",
          "781-1524",
          "781-1741",
          "781-1744",
          "781-1622",
          "781-1761",
          "781-1603",
          "781-1533",
          "781-1504",
          "781-1535",
          "781-1803",
          "781-1521",
          "781-1513",
          "781-1604",
          "781-1627",
          "781-1613",
          "781-1620",
          "781-1619",
          "781-1616",
          "781-1801",
          "781-1755",
          "781-1625",
          "781-1623",
          "781-1609",
          "781-1757",
          "781-1515",
          "789-1300",
          "789-1413",
          "789-1414",
          "789-1405",
          "789-1418",
          "789-1412",
          "789-1416",
          "789-1403",
          "789-1419",
          "789-1409",
          "789-1410",
          "789-1415",
          "789-1411",
          "789-1408",
          "789-1404",
          "789-1417",
          "789-1402",
          "789-1406",
          "789-1407",
          "789-1401",
          "789-1302",
          "789-1301",
          "789-1304",
          "789-1303",
          "789-1200",
          "789-1217",
          "789-1202",
          "789-1204",
          "789-1235",
          "789-1211",
          "789-1201",
          "789-1216",
          "789-1215",
          "789-1233",
          "789-1214",
          "789-1231",
          "789-1234",
          "789-1222",
          "789-1223",
          "789-1232",
          "789-1218",
          "789-1213",
          "789-1224",
          "789-1203",
          "789-1221",
          "789-1225",
          "789-1205",
          "789-1212",
          "781-1300",
          "781-1325",
          "781-1311",
          "781-1333",
          "781-1301",
          "781-1302",
          "781-1303",
          "781-1304",
          "781-1326",
          "781-1322",
          "781-1324",
          "781-1323",
          "781-1321",
          "781-1334",
          "781-1327",
          "781-1331",
          "781-1337",
          "781-1307",
          "781-1335",
          "781-1305",
          "781-1332",
          "781-1328",
          "781-1336",
          "781-1338",
          "781-1308",
          "781-1306",
          "781-1314",
          "781-1313",
          "781-1312",
          "781-1315",
          "785-0600",
          "785-0611",
          "785-0666",
          "785-0602",
          "785-0641",
          "785-0603",
          "785-0626",
          "785-0771",
          "785-0613",
          "785-0652",
          "785-0627",
          "785-0625",
          "785-0654",
          "785-0646",
          "785-0664",
          "785-0606",
          "785-0776",
          "785-0635",
          "785-0636",
          "785-0612",
          "785-0622",
          "785-0774",
          "785-0657",
          "785-0608",
          "785-0662",
          "785-0631",
          "785-0775",
          "785-0624",
          "785-0655",
          "785-0647",
          "785-0605",
          "785-0645",
          "785-0607",
          "785-0621",
          "785-0651",
          "785-0665",
          "785-0658",
          "785-0633",
          "785-0648",
          "785-0634",
          "785-0623",
          "785-0653",
          "785-0772",
          "785-0601",
          "785-0632",
          "785-0656",
          "785-0644",
          "785-0663",
          "785-0642",
          "785-0773",
          "785-0643",
          "785-0610",
          "785-0604",
          "785-0661",
          "781-2154",
          "781-2163",
          "781-2152",
          "781-2167",
          "781-2155",
          "781-2151",
          "781-2166",
          "781-2162",
          "781-2161",
          "781-2153",
          "781-2164",
          "781-2165",
          "785-0200",
          "785-0219",
          "785-0218",
          "785-0203",
          "785-0210",
          "785-0206",
          "785-0413",
          "785-0502",
          "785-0204",
          "785-0217",
          "785-0412",
          "785-0212",
          "785-0211",
          "785-0213",
          "785-0207",
          "785-0215",
          "785-0214",
          "785-0216",
          "785-0501",
          "785-0201",
          "785-0209",
          "785-0205",
          "785-0202",
          "785-0411",
          "785-0208",
          "785-0504",
          "785-0503",
          "785-0505",
          "786-0000",
          "786-0327",
          "786-0075",
          "786-0064",
          "786-0533",
          "786-0088",
          "786-0325",
          "786-0094",
          "786-0037",
          "786-0322",
          "786-0523",
          "786-0307",
          "786-0532",
          "786-0016",
          "786-0058",
          "786-0067",
          "786-0045",
          "786-0046",
          "786-0517",
          "786-0038",
          "786-0071",
          "786-0531",
          "786-0048",
          "786-0078",
          "786-0034",
          "786-0011",
          "786-0032",
          "786-0049",
          "786-0098",
          "786-0305",
          "786-0522",
          "786-0326",
          "786-0514",
          "786-0091",
          "786-0012",
          "786-0303",
          "786-0003",
          "786-0516",
          "786-0073",
          "786-0010",
          "786-0515",
          "786-0096",
          "786-0042",
          "786-0306",
          "786-0017",
          "786-0502",
          "786-0057",
          "786-0013",
          "786-0022",
          "786-0313",
          "786-0028",
          "786-0015",
          "786-0008",
          "786-0087",
          "786-0524",
          "786-0004",
          "786-0018",
          "786-0304",
          "786-0036",
          "786-0315",
          "786-0314",
          "786-0092",
          "786-0323",
          "786-0513",
          "786-0512",
          "786-0511",
          "786-0501",
          "786-0056",
          "786-0055",
          "786-0014",
          "786-0302",
          "786-0066",
          "786-0301",
          "786-0312",
          "786-0321",
          "786-0316",
          "786-0063",
          "786-0521",
          "786-0076",
          "786-0052",
          "786-0033",
          "786-0504",
          "786-0535",
          "786-0503",
          "786-0031",
          "786-0025",
          "786-0072",
          "786-0023",
          "786-0081",
          "786-0082",
          "786-0041",
          "786-0021",
          "786-0083",
          "786-0311",
          "786-0085",
          "786-0065",
          "786-0525",
          "786-0047",
          "786-0054",
          "786-0027",
          "786-0084",
          "786-0093",
          "786-0006",
          "786-0077",
          "786-0097",
          "786-0026",
          "786-0051",
          "786-0324",
          "786-0534",
          "786-0053",
          "786-0001",
          "786-0007",
          "786-0043",
          "786-0005",
          "786-0002",
          "786-0074",
          "786-0061",
          "786-0086",
          "786-0024",
          "786-0308",
          "786-0044",
          "786-0095",
          "786-0035",
          "786-0068",
          "786-0062",
          "788-0300",
          "788-0332",
          "788-0351",
          "788-0342",
          "788-0324",
          "788-0334",
          "788-0314",
          "788-0343",
          "788-0335",
          "788-0331",
          "788-0322",
          "788-0315",
          "788-0323",
          "788-0313",
          "788-0312",
          "788-0363",
          "788-0352",
          "788-0361",
          "788-0325",
          "788-0353",
          "788-0333",
          "788-0321",
          "788-0341",
          "788-0302",
          "788-0311",
          "788-0362",
          "787-0800",
          "787-0806",
          "787-0804",
          "787-0805",
          "787-0815",
          "787-0803",
          "787-0816",
          "787-0812",
          "787-0807",
          "787-0814",
          "787-0813",
          "787-0802",
          "787-0801",
          "787-0811",
          "789-1900",
          "789-1903",
          "789-1904",
          "789-1701",
          "789-1711",
          "789-1934",
          "789-1713",
          "789-1931",
          "789-1911",
          "789-1924",
          "789-1923",
          "789-1925",
          "789-1913",
          "789-1936",
          "789-1705",
          "789-1901",
          "789-1935",
          "789-1921",
          "789-1922",
          "789-1704",
          "789-1912",
          "789-1715",
          "789-1716",
          "789-1706",
          "789-1703",
          "789-1723",
          "789-1722",
          "789-1721",
          "789-1724",
          "789-1720",
          "789-1702",
          "789-1932",
          "789-1725",
          "789-1708",
          "789-1933",
          "789-1707",
          "789-1905",
          "789-1714",
          "789-1712",
          "789-1902",
          "800-0000",
          "800-0045",
          "800-0101",
          "800-0041",
          "800-0048",
          "800-0111",
          "800-0026",
          "801-0864",
          "801-0883",
          "801-0811",
          "800-0011",
          "801-0876",
          "801-0801",
          "800-0001",
          "801-0823",
          "800-0061",
          "800-0003",
          "800-0016",
          "800-0044",
          "801-0871",
          "800-0042",
          "800-0114",
          "800-0118",
          "800-0004",
          "801-0812",
          "801-0854",
          "801-0833",
          "801-0882",
          "801-0886",
          "801-0808",
          "800-0008",
          "801-0821",
          "801-0826",
          "801-0825",
          "800-0027",
          "800-0034",
          "800-0007",
          "801-0863",
          "800-0102",
          "800-0015",
          "800-0028",
          "800-0051",
          "800-0054",
          "801-0865",
          "801-0802",
          "800-0013",
          "801-0885",
          "800-0053",
          "800-0115",
          "800-0113",
          "801-0884",
          "800-0014",
          "800-0018",
          "800-0057",
          "800-0024",
          "800-0038",
          "800-0022",
          "800-0029",
          "800-0063",
          "800-0062",
          "800-0033",
          "801-0822",
          "800-0031",
          "801-0805",
          "801-0872",
          "801-0803",
          "801-0804",
          "800-0117",
          "800-0116",
          "800-0023",
          "800-0039",
          "800-0017",
          "801-0861",
          "801-0881",
          "801-0841",
          "801-0862",
          "800-0056",
          "800-0112",
          "801-0874",
          "801-0856",
          "800-0005",
          "800-0037",
          "800-0046",
          "800-0055",
          "801-0851",
          "800-0052",
          "801-0853",
          "801-0873",
          "801-0813",
          "801-0814",
          "801-0842",
          "800-0047",
          "800-0002",
          "800-0032",
          "800-0035",
          "801-0875",
          "801-0834",
          "800-0012",
          "800-0064",
          "801-0831",
          "801-0824",
          "800-0043",
          "801-0852",
          "800-0021",
          "801-0855",
          "801-0832",
          "800-0030",
          "800-0036",
          "800-0025",
          "800-0006",
          "808-0000",
          "808-0141",
          "808-0143",
          "808-0142",
          "808-0175",
          "808-0075",
          "808-0003",
          "808-0073",
          "808-0122",
          "808-0123",
          "808-0022",
          "808-0124",
          "808-0071",
          "808-0014",
          "808-0032",
          "808-0061",
          "808-0033",
          "808-0051",
          "808-0133",
          "808-0008",
          "808-0108",
          "808-0134",
          "808-0106",
          "808-0015",
          "808-0105",
          "808-0023",
          "808-0027",
          "808-0011",
          "808-0066",
          "808-0054",
          "808-0007",
          "808-0001",
          "808-0046",
          "808-0002",
          "808-0132",
          "808-0139",
          "808-0026",
          "808-0041",
          "808-0131",
          "808-0005",
          "808-0052",
          "808-0053",
          "808-0148",
          "808-0144",
          "808-0146",
          "808-0145",
          "808-0147",
          "808-0121",
          "808-0042",
          "808-0076",
          "808-0112",
          "808-0025",
          "808-0047",
          "808-0013",
          "808-0004",
          "808-0031",
          "808-0101",
          "808-0043",
          "808-0035",
          "808-0104",
          "808-0055",
          "808-0136",
          "808-0024",
          "808-0113",
          "808-0016",
          "808-0017",
          "808-0044",
          "808-0102",
          "808-0135",
          "808-0138",
          "808-0137",
          "808-0021",
          "808-0012",
          "808-0065",
          "808-0074",
          "808-0103",
          "808-0062",
          "808-0034",
          "808-0109",
          "808-0006",
          "808-0064",
          "808-0111",
          "808-0036",
          "808-0045",
          "808-0072",
          "808-0077",
          "808-0063",
          "804-0000",
          "804-0083",
          "804-0062",
          "804-0021",
          "804-0064",
          "804-0071",
          "804-0043",
          "804-0075",
          "804-0076",
          "804-0092",
          "804-0022",
          "804-0084",
          "804-0013",
          "804-0093",
          "804-0091",
          "804-0033",
          "804-0067",
          "804-0063",
          "804-0082",
          "804-0065",
          "804-0044",
          "804-0015",
          "804-0081",
          "804-0051",
          "804-0014",
          "804-0094",
          "804-0041",
          "804-0004",
          "804-0001",
          "804-0002",
          "804-0003",
          "804-0012",
          "804-0011",
          "804-0061",
          "804-0032",
          "804-0024",
          "804-0066",
          "804-0031",
          "804-0023",
          "804-0025",
          "804-0053",
          "804-0077",
          "804-0054",
          "804-0052",
          "804-0074",
          "804-0073",
          "804-0072",
          "804-0042",
          "802-0000",
          "802-0091",
          "803-0822",
          "802-0032",
          "802-0031",
          "802-0001",
          "803-0833",
          "802-0043",
          "803-0828",
          "802-0042",
          "803-0842",
          "803-0824",
          "803-0835",
          "803-0862",
          "803-0821",
          "802-0006",
          "802-0016",
          "802-0092",
          "802-0083",
          "802-0015",
          "803-0814",
          "802-0026",
          "802-0004",
          "802-0064",
          "802-0062",
          "803-0816",
          "803-0845",
          "802-0022",
          "802-0084",
          "802-0045",
          "802-0073",
          "803-0851",
          "802-0002",
          "803-0841",
          "802-0052",
          "803-0843",
          "803-0864",
          "802-0044",
          "802-0056",
          "802-0051",
          "802-0071",
          "803-0803",
          "802-0003",
          "802-0037",
          "802-0081",
          "803-0823",
          "802-0005",
          "802-0061",
          "803-0854",
          "802-0024",
          "802-0011",
          "803-0861",
          "803-0846",
          "802-0023",
          "802-0025",
          "803-0813",
          "802-0055",
          "802-0075",
          "802-0074",
          "803-0825",
          "802-0038",
          "803-0852",
          "803-0805",
          "802-0012",
          "802-0034",
          "802-0014",
          "802-0008",
          "802-0007",
          "803-0811",
          "803-0853",
          "802-0021",
          "802-0053",
          "803-0838",
          "803-0826",
          "803-0855",
          "803-0818",
          "803-0817",
          "802-0035",
          "802-0036",
          "802-0033",
          "803-0836",
          "803-0837",
          "803-0804",
          "802-0076",
          "802-0018",
          "802-0013",
          "803-0801",
          "802-0066",
          "802-0077",
          "803-0815",
          "803-0831",
          "802-0072",
          "802-0054",
          "803-0802",
          "803-0832",
          "802-0082",
          "803-0856",
          "803-0844",
          "803-0827",
          "803-0863",
          "802-0065",
          "803-0834",
          "802-0041",
          "803-0812",
          "802-0017",
          "803-0865",
          "802-0085",
          "802-0063",
          "800-0258",
          "802-0838",
          "802-0836",
          "803-0185",
          "803-0183",
          "803-0189",
          "803-0261",
          "803-0271",
          "803-0273",
          "803-0272",
          "802-0834",
          "803-0267",
          "802-0833",
          "800-0255",
          "800-0223",
          "800-0215",
          "800-0244",
          "800-0201",
          "802-0978",
          "802-0981",
          "802-0841",
          "803-0184",
          "800-0306",
          "800-0231",
          "800-0232",
          "800-0233",
          "800-0251",
          "800-0252",
          "800-0253",
          "800-0254",
          "800-0206",
          "803-0182",
          "802-0985",
          "802-0984",
          "802-0986",
          "802-0811",
          "802-0983",
          "802-0832",
          "802-0804",
          "800-0217",
          "800-0221",
          "800-0236",
          "802-0977",
          "800-0203",
          "802-0802",
          "800-0211",
          "803-0186",
          "802-0973",
          "800-0212",
          "800-0229",
          "800-0214",
          "800-0220",
          "800-0219",
          "803-0268",
          "803-0275",
          "803-0262",
          "800-0225",
          "800-0226",
          "803-0263",
          "800-0242",
          "800-0227",
          "800-0248",
          "803-0266",
          "803-0276",
          "803-0277",
          "803-0278",
          "803-0279",
          "802-0974",
          "802-0979",
          "802-0975",
          "800-0222",
          "800-0216",
          "800-0213",
          "800-0237",
          "800-0235",
          "800-0204",
          "803-0274",
          "800-0228",
          "800-0246",
          "800-0247",
          "800-0241",
          "800-0243",
          "802-0812",
          "802-0814",
          "800-0245",
          "800-0234",
          "800-0209",
          "800-0218",
          "800-0208",
          "800-0207",
          "800-0205",
          "802-0805",
          "802-0837",
          "802-0803",
          "803-0265",
          "800-0224",
          "802-0813",
          "802-0842",
          "803-0180",
          "802-0801",
          "802-0835",
          "802-0823",
          "802-0976",
          "802-0815",
          "803-0187",
          "803-0188",
          "802-0972",
          "802-0971",
          "802-0831",
          "802-0982",
          "803-0264",
          "800-0257",
          "800-0256",
          "802-0824",
          "802-0825",
          "802-0822",
          "802-0826",
          "802-0821",
          "800-0202",
          "800-0210",
          "803-0181",
          "802-0816",
          "805-0000",
          "805-0001",
          "805-0015",
          "805-0021",
          "805-0037",
          "805-0041",
          "805-0002",
          "805-0008",
          "805-0048",
          "805-0053",
          "805-0038",
          "805-0003",
          "805-0057",
          "805-0059",
          "805-0043",
          "805-0018",
          "805-0055",
          "805-0045",
          "805-0012",
          "805-0067",
          "805-0066",
          "805-0034",
          "805-0047",
          "805-0036",
          "805-0035",
          "805-0033",
          "805-0017",
          "805-0013",
          "805-0007",
          "805-0049",
          "805-0006",
          "805-0016",
          "805-0022",
          "805-0046",
          "805-0014",
          "805-0019",
          "805-0031",
          "805-0054",
          "805-0025",
          "805-0024",
          "805-0064",
          "805-0061",
          "805-0052",
          "805-0042",
          "805-0011",
          "805-0065",
          "805-0050",
          "805-0071",
          "805-0063",
          "805-0027",
          "805-0051",
          "805-0026",
          "805-0004",
          "805-0062",
          "805-0005",
          "805-0056",
          "805-0058",
          "805-0069",
          "805-0032",
          "805-0009",
          "805-0023",
          "805-0068",
          "805-0044",
          "806-0000",
          "806-0044",
          "806-0043",
          "807-0872",
          "807-0877",
          "807-0871",
          "807-0875",
          "807-0876",
          "807-0879",
          "806-0049",
          "807-1125",
          "807-1121",
          "807-0854",
          "807-0804",
          "806-0063",
          "807-1153",
          "807-0071",
          "807-0851",
          "807-0842",
          "807-0852",
          "807-0845",
          "807-0874",
          "806-0053",
          "807-0083",
          "807-0084",
          "806-0033",
          "807-0077",
          "807-0806",
          "807-0825",
          "807-0864",
          "807-0844",
          "807-1102",
          "807-1103",
          "807-1101",
          "807-0072",
          "806-0034",
          "807-0834",
          "807-1114",
          "807-0814",
          "806-0061",
          "807-0812",
          "807-1154",
          "807-0827",
          "807-1151",
          "807-1141",
          "807-1146",
          "807-1142",
          "807-1145",
          "807-1143",
          "806-0028",
          "806-0031",
          "806-0021",
          "806-0004",
          "806-0041",
          "806-0016",
          "806-0011",
          "807-0824",
          "806-0056",
          "807-0081",
          "807-0082",
          "807-1261",
          "807-1263",
          "806-0055",
          "806-0042",
          "807-1265",
          "807-0868",
          "807-0846",
          "807-0843",
          "807-0075",
          "807-0076",
          "807-1123",
          "807-0867",
          "807-0855",
          "807-1113",
          "807-0821",
          "806-0012",
          "806-0027",
          "807-0822",
          "806-0013",
          "807-0829",
          "807-0863",
          "807-1152",
          "806-0047",
          "807-0853",
          "806-0045",
          "806-0003",
          "806-0069",
          "807-1134",
          "807-1112",
          "807-0803",
          "806-0001",
          "806-0032",
          "806-0057",
          "806-0058",
          "807-0832",
          "807-0085",
          "807-0811",
          "807-0828",
          "807-0823",
          "807-0078",
          "807-0836",
          "806-0052",
          "806-0039",
          "807-0862",
          "806-0017",
          "806-0026",
          "806-0054",
          "806-0036",
          "807-1262",
          "807-0831",
          "807-0837",
          "806-0059",
          "807-1124",
          "807-1136",
          "807-1135",
          "807-1131",
          "807-1132",
          "807-1133",
          "807-1122",
          "806-0037",
          "807-0835",
          "806-0014",
          "806-0025",
          "806-0051",
          "806-0002",
          "806-0035",
          "806-0067",
          "806-0048",
          "807-0866",
          "806-0018",
          "806-0022",
          "807-0873",
          "807-1111",
          "806-0005",
          "806-0068",
          "806-0062",
          "807-0857",
          "807-1264",
          "807-0861",
          "807-0801",
          "807-0807",
          "807-0815",
          "807-0073",
          "807-0074",
          "807-0841",
          "807-1144",
          "807-0826",
          "807-0878",
          "807-0805",
          "806-0038",
          "807-0833",
          "806-0024",
          "807-0847",
          "807-0865",
          "807-1115",
          "806-0015",
          "806-0046",
          "806-0006",
          "806-0023",
          "807-0856",
          "806-0030",
          "807-0813",
          "806-0065",
          "807-0802",
          "806-0066",
          "806-0064",
          "813-0000",
          "813-0025",
          "811-0322",
          "812-0052",
          "813-0011",
          "813-0013",
          "813-0012",
          "813-0014",
          "813-0015",
          "813-0017",
          "813-0016",
          "813-0018",
          "813-0003",
          "811-0325",
          "813-0023",
          "811-0216",
          "811-0206",
          "812-0069",
          "811-0321",
          "811-0203",
          "811-0323",
          "813-0002",
          "812-0068",
          "813-0045",
          "811-0215",
          "813-0033",
          "813-0034",
          "813-0044",
          "813-0032",
          "813-0001",
          "813-0024",
          "813-0043",
          "811-0204",
          "811-0205",
          "812-0053",
          "812-0051",
          "812-0061",
          "812-0067",
          "813-0031",
          "812-0063",
          "812-0055",
          "811-0324",
          "812-0066",
          "812-0065",
          "812-0054",
          "813-0042",
          "813-0004",
          "813-0035",
          "812-0062",
          "813-0062",
          "812-0064",
          "813-0005",
          "813-0041",
          "811-0201",
          "813-0021",
          "813-0019",
          "811-0212",
          "811-0211",
          "813-0036",
          "811-0202",
          "811-0213",
          "811-0214",
          "812-0000",
          "812-0885",
          "812-0851",
          "812-0881",
          "812-0888",
          "812-0861",
          "812-0004",
          "812-0001",
          "812-0031",
          "812-0043",
          "812-0863",
          "812-0005",
          "812-0026",
          "812-0036",
          "812-0006",
          "812-0022",
          "812-0038",
          "812-0879",
          "812-0002",
          "812-0037",
          "812-0884",
          "812-0029",
          "812-0891",
          "812-0887",
          "812-0015",
          "812-0871",
          "812-0003",
          "812-0027",
          "812-0034",
          "812-0855",
          "812-0876",
          "812-0875",
          "812-0028",
          "812-0018",
          "812-0032",
          "812-0033",
          "812-0878",
          "812-0895",
          "812-0021",
          "812-0044",
          "812-0858",
          "812-0024",
          "812-0020",
          "812-0025",
          "812-0008",
          "812-0896",
          "812-0893",
          "812-0035",
          "810-0801",
          "810-0802",
          "812-0023",
          "812-0857",
          "812-0873",
          "812-0012",
          "812-0011",
          "812-0013",
          "812-0016",
          "812-0872",
          "812-0897",
          "812-0014",
          "812-0874",
          "812-0045",
          "812-0854",
          "812-0892",
          "812-0007",
          "812-0853",
          "812-0852",
          "812-0886",
          "812-0883",
          "812-0017",
          "812-0882",
          "812-0877",
          "812-0894",
          "812-0042",
          "812-0041",
          "812-0046",
          "812-0862",
          "812-0039",
          "810-0000",
          "810-0042",
          "810-0076",
          "810-0062",
          "810-0067",
          "810-0021",
          "810-0054",
          "810-0074",
          "810-0052",
          "810-0051",
          "810-0013",
          "810-0033",
          "810-0005",
          "810-0045",
          "810-0055",
          "810-0023",
          "810-0027",
          "810-0024",
          "810-0034",
          "810-0018",
          "810-0028",
          "810-0043",
          "810-0012",
          "810-0064",
          "810-0065",
          "810-0041",
          "810-0011",
          "810-0031",
          "810-0032",
          "810-0001",
          "810-0063",
          "810-0053",
          "810-0072",
          "810-0015",
          "810-0071",
          "810-0061",
          "810-0002",
          "810-0035",
          "810-0036",
          "810-0003",
          "810-0014",
          "810-0017",
          "810-0029",
          "810-0066",
          "810-0026",
          "810-0016",
          "810-0073",
          "810-0075",
          "810-0037",
          "810-0022",
          "810-0025",
          "810-0044",
          "810-0004",
          "815-0000",
          "811-1302",
          "815-0084",
          "815-0073",
          "815-0082",
          "815-0033",
          "815-0038",
          "811-1313",
          "811-1303",
          "811-1353",
          "811-1324",
          "815-0001",
          "811-1365",
          "815-0032",
          "815-0031",
          "811-1354",
          "815-0004",
          "815-0083",
          "815-0072",
          "815-0037",
          "815-0036",
          "811-1352",
          "815-0074",
          "811-1364",
          "815-0075",
          "811-1362",
          "815-0081",
          "811-1361",
          "811-1347",
          "815-0041",
          "811-1356",
          "811-1355",
          "815-0071",
          "811-1314",
          "815-0034",
          "811-1344",
          "811-1345",
          "815-0035",
          "811-1351",
          "811-1323",
          "811-1322",
          "815-0063",
          "811-1321",
          "811-1311",
          "811-1312",
          "811-1346",
          "815-0042",
          "815-0048",
          "811-1343",
          "819-0000",
          "819-0015",
          "819-0013",
          "819-0007",
          "819-0371",
          "819-0037",
          "819-0042",
          "819-0055",
          "819-0044",
          "819-0025",
          "819-0381",
          "819-0167",
          "819-0162",
          "819-0168",
          "819-0163",
          "819-0164",
          "819-0169",
          "819-0161",
          "819-0165",
          "819-0372",
          "819-0005",
          "819-0021",
          "819-0001",
          "819-0011",
          "819-0035",
          "819-0054",
          "819-0379",
          "819-0388",
          "819-0204",
          "819-0382",
          "819-0205",
          "819-0203",
          "819-0367",
          "819-0052",
          "819-0051",
          "819-0024",
          "819-0041",
          "819-0045",
          "819-0053",
          "819-0373",
          "819-0374",
          "819-0034",
          "819-0383",
          "819-0384",
          "819-0032",
          "819-0375",
          "819-0378",
          "819-0014",
          "819-0039",
          "819-0202",
          "819-0046",
          "819-0043",
          "819-0012",
          "819-0033",
          "819-0031",
          "819-0038",
          "819-0022",
          "819-0023",
          "819-0387",
          "819-0201",
          "819-0376",
          "819-0377",
          "819-0030",
          "819-0002",
          "819-0006",
          "819-0385",
          "819-0386",
          "819-0166",
          "819-0366",
          "819-0036",
          "814-0100",
          "814-0101",
          "814-0102",
          "814-0134",
          "814-0144",
          "814-0142",
          "814-0114",
          "814-0105",
          "814-0121",
          "814-0154",
          "814-0113",
          "814-0111",
          "814-0151",
          "814-0152",
          "814-0112",
          "814-0103",
          "814-0123",
          "814-0133",
          "814-0141",
          "814-0153",
          "814-0155",
          "814-0104",
          "814-0106",
          "814-0132",
          "814-0131",
          "814-0143",
          "814-0122",
          "814-0000",
          "814-0004",
          "814-0021",
          "814-0033",
          "814-0034",
          "814-0161",
          "811-1134",
          "811-1132",
          "811-1113",
          "811-1123",
          "814-0172",
          "811-1112",
          "811-1124",
          "814-0164",
          "814-0032",
          "811-1122",
          "811-1114",
          "811-1103",
          "814-0176",
          "811-1101",
          "814-0003",
          "814-0012",
          "814-0165",
          "814-0005",
          "814-0177",
          "814-0011",
          "814-0174",
          "814-0175",
          "811-1131",
          "814-0173",
          "811-1121",
          "814-0002",
          "814-0171",
          "814-0022",
          "814-0023",
          "811-1102",
          "814-0013",
          "814-0163",
          "814-0162",
          "811-1133",
          "814-0031",
          "814-0035",
          "814-0015",
          "814-0006",
          "814-0001",
          "814-0014",
          "811-1111",
          "836-0000",
          "836-0897",
          "836-0852",
          "836-0807",
          "836-0817",
          "837-0905",
          "836-0087",
          "836-0831",
          "836-0854",
          "836-0893",
          "836-0863",
          "836-0085",
          "836-0834",
          "837-0922",
          "836-0063",
          "837-0913",
          "837-0910",
          "836-0846",
          "836-0882",
          "836-0094",
          "836-0014",
          "836-0877",
          "836-0824",
          "836-0036",
          "836-0091",
          "836-0801",
          "836-0082",
          "836-0886",
          "836-0071",
          "837-0902",
          "837-0926",
          "836-0853",
          "836-0072",
          "836-0823",
          "836-0812",
          "836-0815",
          "836-0093",
          "836-0016",
          "836-0894",
          "837-0917",
          "837-0924",
          "837-0915",
          "836-0045",
          "837-0906",
          "836-0011",
          "836-0891",
          "836-0872",
          "836-0034",
          "836-0042",
          "836-0092",
          "836-0836",
          "836-0884",
          "836-0851",
          "836-0825",
          "836-0057",
          "837-0901",
          "837-0907",
          "836-0885",
          "837-0928",
          "836-0866",
          "836-0845",
          "836-0844",
          "836-0001",
          "836-0871",
          "837-0925",
          "837-0912",
          "836-0052",
          "836-0843",
          "836-0007",
          "836-0017",
          "836-0895",
          "836-0061",
          "836-0041",
          "836-0032",
          "836-0864",
          "837-0923",
          "836-0874",
          "836-0024",
          "836-0051",
          "836-0077",
          "836-0006",
          "836-0047",
          "836-0064",
          "836-0861",
          "837-0916",
          "837-0911",
          "836-0837",
          "836-0081",
          "836-0841",
          "836-0035",
          "836-0005",
          "836-0004",
          "836-0015",
          "836-0896",
          "836-0054",
          "836-0822",
          "836-0003",
          "836-0805",
          "836-0832",
          "836-0803",
          "836-0023",
          "837-0927",
          "836-0025",
          "836-0013",
          "836-0083",
          "836-0804",
          "836-0865",
          "836-0066",
          "836-0031",
          "836-0027",
          "836-0062",
          "836-0835",
          "836-0095",
          "836-0096",
          "836-0043",
          "836-0811",
          "836-0816",
          "836-0867",
          "836-0084",
          "836-0026",
          "836-0021",
          "836-0892",
          "836-0873",
          "836-0862",
          "836-0821",
          "836-0806",
          "836-0097",
          "836-0827",
          "836-0055",
          "836-0802",
          "836-0056",
          "836-0813",
          "836-0074",
          "836-0073",
          "836-0044",
          "836-0046",
          "836-0086",
          "836-0855",
          "836-0033",
          "836-0883",
          "837-0921",
          "836-0065",
          "836-0002",
          "836-0037",
          "836-0076",
          "836-0022",
          "836-0075",
          "836-0856",
          "837-0903",
          "836-0875",
          "837-0914",
          "836-0857",
          "836-0012",
          "836-0826",
          "836-0847",
          "836-0053",
          "836-0833",
          "836-0842",
          "837-0904",
          "836-0067",
          "836-0881",
          "836-0814",
          "836-0876",
          "839-0000",
          "839-0861",
          "839-0843",
          "830-0011",
          "830-0029",
          "830-0063",
          "830-0065",
          "830-0066",
          "830-0062",
          "830-0064",
          "830-0048",
          "830-0059",
          "830-0049",
          "830-0034",
          "839-0832",
          "839-0833",
          "839-0831",
          "830-0055",
          "830-0052",
          "830-1127",
          "830-1116",
          "830-1126",
          "830-1122",
          "830-1104",
          "830-1125",
          "830-1124",
          "830-1103",
          "830-1117",
          "830-1114",
          "830-1121",
          "830-1112",
          "830-1111",
          "830-1107",
          "830-1123",
          "830-1115",
          "830-1113",
          "830-1101",
          "830-1105",
          "830-1106",
          "830-1102",
          "830-0028",
          "839-0835",
          "839-0834",
          "839-0837",
          "839-0836",
          "830-0013",
          "839-0852",
          "830-0045",
          "839-0863",
          "830-0001",
          "830-0019",
          "830-0021",
          "830-0036",
          "830-0042",
          "830-0222",
          "830-0201",
          "830-0221",
          "830-0204",
          "830-0213",
          "830-0212",
          "830-0214",
          "830-0216",
          "830-0205",
          "830-0224",
          "830-0225",
          "830-0202",
          "830-0207",
          "830-0223",
          "830-0211",
          "830-0226",
          "830-0203",
          "830-0215",
          "830-0206",
          "830-0022",
          "830-0041",
          "839-0865",
          "830-0037",
          "839-0853",
          "830-0025",
          "839-0824",
          "839-0822",
          "839-0825",
          "839-0823",
          "830-0079",
          "830-0075",
          "830-0077",
          "830-0076",
          "830-0073",
          "830-0074",
          "830-0070",
          "839-0821",
          "830-0002",
          "839-1203",
          "839-1227",
          "839-1212",
          "839-1223",
          "839-1228",
          "839-1221",
          "839-1222",
          "839-1225",
          "839-1202",
          "839-1215",
          "839-1233",
          "839-1214",
          "839-1232",
          "839-1234",
          "839-1216",
          "839-1201",
          "839-1231",
          "839-1204",
          "839-1205",
          "839-1224",
          "839-1213",
          "839-1211",
          "839-1226",
          "839-1206",
          "830-0023",
          "830-0061",
          "830-0047",
          "830-0014",
          "830-0033",
          "830-0035",
          "830-0016",
          "830-0005",
          "830-0018",
          "830-0027",
          "830-0026",
          "830-0024",
          "830-0006",
          "830-0004",
          "830-0038",
          "839-0862",
          "830-0058",
          "830-0039",
          "830-0046",
          "839-0809",
          "839-0808",
          "839-0806",
          "839-0807",
          "830-0003",
          "830-0032",
          "830-0012",
          "839-0864",
          "830-0017",
          "830-0057",
          "830-0054",
          "830-0053",
          "830-0015",
          "830-0044",
          "830-0043",
          "839-0842",
          "839-0841",
          "839-0851",
          "830-0113",
          "830-0115",
          "830-0116",
          "830-0105",
          "830-0103",
          "830-0102",
          "830-0112",
          "830-0111",
          "830-0101",
          "830-0104",
          "830-0114",
          "830-0051",
          "839-0801",
          "839-0803",
          "839-0802",
          "839-0805",
          "839-0804",
          "830-0031",
          "830-0056",
          "830-0078",
          "830-0071",
          "830-0072",
          "839-0812",
          "839-0813",
          "839-0814",
          "839-0815",
          "839-0811",
          "839-0816",
          "839-0817",
          "839-0827",
          "839-0826",
          "822-0000",
          "822-0012",
          "822-0031",
          "822-0005",
          "822-0006",
          "822-0033",
          "822-0003",
          "822-0001",
          "822-0007",
          "822-0032",
          "822-0023",
          "822-0021",
          "822-0015",
          "822-0024",
          "822-0022",
          "822-0026",
          "822-0017",
          "822-0002",
          "822-0011",
          "822-0016",
          "822-0004",
          "822-0025",
          "822-0027",
          "822-0014",
          "822-0013",
          "822-0034",
          "822-0008",
          "820-0000",
          "820-0052",
          "820-0704",
          "820-0106",
          "820-0083",
          "820-0112",
          "820-0111",
          "820-0041",
          "820-0054",
          "820-0053",
          "820-0103",
          "820-0706",
          "820-0021",
          "820-0081",
          "820-0114",
          "820-0089",
          "820-1112",
          "820-0068",
          "820-0013",
          "820-0011",
          "820-0002",
          "820-0067",
          "820-0703",
          "820-1114",
          "820-0078",
          "820-0707",
          "820-0049",
          "820-0066",
          "820-0015",
          "820-0016",
          "820-0017",
          "820-1113",
          "820-0012",
          "820-0062",
          "820-0087",
          "820-0051",
          "820-0113",
          "820-0005",
          "820-0004",
          "820-1111",
          "820-0046",
          "820-0712",
          "820-0104",
          "820-0079",
          "820-0116",
          "820-0071",
          "820-0003",
          "820-0076",
          "820-0705",
          "820-0064",
          "820-0105",
          "820-0101",
          "820-0084",
          "820-0014",
          "820-0086",
          "820-0075",
          "820-0033",
          "820-0713",
          "820-0065",
          "820-0701",
          "820-0001",
          "820-0031",
          "820-0043",
          "820-0115",
          "820-0045",
          "820-0032",
          "820-0702",
          "820-0073",
          "820-0088",
          "820-0070",
          "820-0042",
          "820-0709",
          "820-0072",
          "820-0069",
          "820-0022",
          "820-0077",
          "820-0047",
          "820-0085",
          "820-0063",
          "820-0711",
          "820-0102",
          "820-0708",
          "820-0044",
          "820-0018",
          "820-0040",
          "820-0061",
          "820-0074",
          "820-0048",
          "820-0082",
          "825-0000",
          "825-0001",
          "825-0002",
          "825-0015",
          "826-0044",
          "826-0045",
          "825-0014",
          "826-0026",
          "826-0023",
          "826-0042",
          "825-0017",
          "825-0011",
          "826-0021",
          "825-0003",
          "825-0016",
          "826-0025",
          "825-0013",
          "826-0031",
          "825-0004",
          "826-0043",
          "826-0024",
          "825-0018",
          "825-0012",
          "826-0032",
          "825-0005",
          "826-0022",
          "826-0033",
          "826-0027",
          "826-0041",
          "832-0000",
          "832-0026",
          "832-0022",
          "832-0054",
          "832-0042",
          "832-0066",
          "832-0025",
          "832-0046",
          "832-0053",
          "832-0065",
          "832-0067",
          "832-0073",
          "832-0041",
          "832-0016",
          "832-0013",
          "832-0058",
          "832-0007",
          "832-0001",
          "832-0034",
          "832-0023",
          "832-0086",
          "832-0072",
          "832-0082",
          "832-0036",
          "832-0037",
          "832-0017",
          "832-0076",
          "832-0059",
          "832-0068",
          "832-0084",
          "832-0062",
          "832-0071",
          "832-0069",
          "832-0032",
          "832-0021",
          "832-0002",
          "832-0003",
          "832-0089",
          "832-0077",
          "832-0051",
          "832-0024",
          "832-0031",
          "832-0043",
          "832-0028",
          "832-0012",
          "832-0087",
          "832-0015",
          "832-0005",
          "832-0081",
          "832-0088",
          "832-0052",
          "832-0029",
          "832-0035",
          "832-0006",
          "832-0044",
          "832-0011",
          "832-0061",
          "832-0045",
          "832-0805",
          "832-0823",
          "832-0807",
          "832-0825",
          "832-0801",
          "832-0827",
          "832-0804",
          "832-0812",
          "832-0822",
          "832-0815",
          "832-0826",
          "832-0813",
          "832-0814",
          "832-0811",
          "832-0816",
          "832-0821",
          "832-0824",
          "832-0828",
          "832-0803",
          "832-0806",
          "832-0802",
          "832-0033",
          "832-0083",
          "832-0064",
          "832-0063",
          "832-0018",
          "832-0074",
          "832-0014",
          "832-0004",
          "832-0057",
          "832-0056",
          "832-0050",
          "832-0075",
          "839-0251",
          "839-0263",
          "839-0252",
          "839-0261",
          "839-0243",
          "839-0253",
          "839-0264",
          "839-0241",
          "839-0242",
          "839-0254",
          "839-0262",
          "839-0244",
          "832-0027",
          "832-0055",
          "832-0085",
          "834-0000",
          "834-0047",
          "834-0026",
          "834-0061",
          "834-0062",
          "834-0055",
          "834-0013",
          "834-0005",
          "834-0041",
          "834-0064",
          "834-0065",
          "834-0053",
          "834-0021",
          "834-0025",
          "834-0046",
          "834-1221",
          "834-1202",
          "834-1212",
          "834-1222",
          "834-1201",
          "834-1203",
          "834-1217",
          "834-1216",
          "834-1204",
          "834-1205",
          "834-1214",
          "834-1211",
          "834-1213",
          "834-1215",
          "834-0002",
          "834-0042",
          "834-1101",
          "834-1102",
          "834-1103",
          "834-1104",
          "834-0052",
          "834-0045",
          "834-0034",
          "834-0001",
          "834-0014",
          "834-0082",
          "834-0083",
          "834-0085",
          "834-0073",
          "834-0084",
          "834-0071",
          "834-0074",
          "834-0072",
          "834-0075",
          "834-0081",
          "834-0067",
          "834-0051",
          "834-0024",
          "834-0016",
          "834-0011",
          "834-0004",
          "834-0023",
          "834-0043",
          "834-0003",
          "834-0201",
          "834-0015",
          "834-0054",
          "834-0032",
          "834-0066",
          "834-0031",
          "834-0063",
          "834-0022",
          "834-0033",
          "834-0044",
          "834-1401",
          "834-1402",
          "834-0012",
          "834-0006",
          "833-0000",
          "833-0041",
          "833-0001",
          "833-0046",
          "833-0014",
          "833-0026",
          "833-0033",
          "833-0013",
          "833-0011",
          "833-0055",
          "833-0054",
          "833-0035",
          "833-0045",
          "833-0037",
          "833-0017",
          "833-0034",
          "833-0021",
          "833-0043",
          "833-0006",
          "833-0036",
          "833-0052",
          "833-0015",
          "833-0016",
          "833-0007",
          "833-0004",
          "833-0051",
          "833-0044",
          "833-0022",
          "833-0025",
          "833-0024",
          "833-0042",
          "833-0005",
          "833-0053",
          "833-0032",
          "833-0003",
          "833-0056",
          "833-0002",
          "833-0023",
          "833-0027",
          "833-0012",
          "833-0031",
          "833-0047",
          "831-0000",
          "831-0031",
          "831-0004",
          "831-0045",
          "831-0021",
          "831-0027",
          "831-0024",
          "831-0008",
          "831-0012",
          "831-0032",
          "831-0042",
          "831-0002",
          "831-0028",
          "831-0041",
          "831-0025",
          "831-0016",
          "831-0001",
          "831-0022",
          "831-0011",
          "831-0017",
          "831-0023",
          "831-0043",
          "831-0035",
          "831-0007",
          "831-0014",
          "831-0006",
          "831-0013",
          "831-0033",
          "831-0034",
          "831-0044",
          "831-0015",
          "831-0026",
          "831-0005",
          "831-0003",
          "824-0000",
          "824-0044",
          "824-0034",
          "824-0022",
          "824-0018",
          "824-0045",
          "824-0041",
          "824-0003",
          "824-0058",
          "824-0004",
          "824-0052",
          "824-0064",
          "824-0055",
          "824-0033",
          "824-0001",
          "824-0061",
          "824-0013",
          "824-0051",
          "824-0076",
          "824-0062",
          "824-0054",
          "824-0007",
          "824-0072",
          "824-0078",
          "824-0027",
          "824-0048",
          "824-0005",
          "824-0065",
          "824-0028",
          "824-0047",
          "824-0074",
          "824-0016",
          "824-0042",
          "824-0026",
          "824-0071",
          "824-0053",
          "824-0063",
          "824-0014",
          "824-0075",
          "824-0038",
          "824-0046",
          "824-0031",
          "824-0077",
          "824-0068",
          "824-0021",
          "824-0035",
          "824-0002",
          "824-0025",
          "824-0049",
          "824-0073",
          "824-0024",
          "824-0067",
          "824-0012",
          "824-0056",
          "824-0017",
          "824-0023",
          "824-0036",
          "824-0032",
          "824-0011",
          "824-0008",
          "824-0057",
          "824-0015",
          "824-0006",
          "824-0037",
          "824-0079",
          "824-0066",
          "824-0043",
          "828-0000",
          "828-0065",
          "828-0027",
          "828-0061",
          "828-0035",
          "828-0062",
          "828-0083",
          "828-0022",
          "828-0082",
          "828-0066",
          "828-0064",
          "828-0049",
          "828-0045",
          "828-0041",
          "828-0077",
          "828-0013",
          "828-0055",
          "828-0043",
          "828-0048",
          "828-0023",
          "828-0086",
          "828-0044",
          "828-0036",
          "828-0072",
          "828-0032",
          "828-0084",
          "828-0075",
          "828-0074",
          "828-0002",
          "828-0026",
          "828-0011",
          "828-0028",
          "828-0046",
          "828-0053",
          "828-0025",
          "828-0081",
          "828-0052",
          "828-0085",
          "828-0012",
          "828-0076",
          "828-0003",
          "828-0054",
          "828-0063",
          "828-0073",
          "828-0005",
          "828-0001",
          "828-0021",
          "828-0004",
          "828-0024",
          "828-0047",
          "828-0042",
          "828-0031",
          "828-0034",
          "828-0056",
          "828-0071",
          "828-0051",
          "828-0033",
          "809-0000",
          "809-0021",
          "809-0024",
          "809-0011",
          "809-0041",
          "809-0023",
          "809-0026",
          "809-0039",
          "809-0031",
          "809-0003",
          "809-0013",
          "809-0017",
          "809-0004",
          "809-0012",
          "809-0038",
          "809-0015",
          "809-0030",
          "809-0018",
          "809-0033",
          "809-0032",
          "809-0002",
          "809-0036",
          "809-0037",
          "809-0034",
          "809-0027",
          "809-0022",
          "809-0001",
          "809-0019",
          "809-0025",
          "809-0016",
          "809-0035",
          "809-0028",
          "809-0014",
          "838-0100",
          "838-0135",
          "838-0109",
          "838-0128",
          "838-0114",
          "838-0142",
          "838-0127",
          "838-0115",
          "838-0141",
          "838-0104",
          "838-0121",
          "838-0136",
          "838-0144",
          "838-0143",
          "838-0123",
          "838-0134",
          "838-0102",
          "838-0138",
          "838-0107",
          "838-0112",
          "838-0131",
          "838-0111",
          "838-0137",
          "838-0125",
          "838-0126",
          "838-0124",
          "838-0122",
          "838-0103",
          "838-0101",
          "838-0108",
          "838-0106",
          "838-0132",
          "838-0133",
          "838-0113",
          "838-0105",
          "838-0116",
          "818-0000",
          "818-0011",
          "818-0012",
          "818-0068",
          "818-0014",
          "818-0034",
          "818-0035",
          "818-0006",
          "818-0013",
          "818-0041",
          "818-0031",
          "818-0002",
          "818-0047",
          "818-0063",
          "818-0021",
          "818-0054",
          "818-0067",
          "818-0025",
          "818-0022",
          "818-0064",
          "818-0053",
          "818-0059",
          "818-0073",
          "818-0074",
          "818-0066",
          "818-0032",
          "818-0044",
          "818-0085",
          "818-0083",
          "818-0084",
          "818-0081",
          "818-0082",
          "818-0005",
          "818-0024",
          "818-0036",
          "818-0045",
          "818-0056",
          "818-0072",
          "818-0071",
          "818-0057",
          "818-0007",
          "818-0026",
          "818-0052",
          "818-0043",
          "818-0061",
          "818-0065",
          "818-0003",
          "818-0046",
          "818-0001",
          "818-0058",
          "818-0004",
          "818-0042",
          "818-0023",
          "816-0000",
          "816-0853",
          "816-0852",
          "816-0831",
          "816-0847",
          "816-0861",
          "816-0814",
          "816-0811",
          "816-0801",
          "816-0803",
          "816-0802",
          "816-0844",
          "816-0824",
          "816-0826",
          "816-0872",
          "816-0842",
          "816-0854",
          "816-0846",
          "816-0848",
          "816-0845",
          "816-0871",
          "816-0863",
          "816-0864",
          "816-0813",
          "816-0807",
          "816-0822",
          "816-0805",
          "816-0841",
          "816-0855",
          "816-0851",
          "816-0825",
          "816-0804",
          "816-0806",
          "816-0873",
          "816-0812",
          "816-0849",
          "816-0843",
          "816-0833",
          "816-0832",
          "816-0874",
          "816-0862",
          "816-0821",
          "816-0823",
          "816-0934",
          "816-0953",
          "816-0971",
          "816-0904",
          "816-0911",
          "816-0902",
          "816-0903",
          "816-0901",
          "816-0955",
          "816-0905",
          "816-0932",
          "816-0924",
          "816-0923",
          "816-0952",
          "816-0951",
          "816-0943",
          "816-0942",
          "816-0983",
          "816-0931",
          "816-0962",
          "816-0906",
          "816-0921",
          "816-0935",
          "816-0982",
          "816-0941",
          "816-0972",
          "816-0912",
          "816-0933",
          "816-0961",
          "816-0956",
          "816-0964",
          "816-0963",
          "816-0954",
          "816-0922",
          "816-0973",
          "816-0981",
          "811-3400",
          "811-4162",
          "811-4146",
          "811-4185",
          "811-4176",
          "811-4148",
          "811-3415",
          "811-4161",
          "811-4157",
          "811-3401",
          "811-3515",
          "811-4147",
          "811-4142",
          "811-3406",
          "811-3502",
          "811-4177",
          "811-3422",
          "811-3432",
          "811-3433",
          "811-3440",
          "811-3701",
          "811-4141",
          "811-3421",
          "811-3402",
          "811-3512",
          "811-3437",
          "811-4184",
          "811-3516",
          "811-3513",
          "811-3501",
          "811-4165",
          "811-4173",
          "811-4166",
          "811-4143",
          "811-3511",
          "811-4163",
          "811-4174",
          "811-4156",
          "811-4182",
          "811-3404",
          "811-4151",
          "811-4181",
          "811-3408",
          "811-3405",
          "811-4175",
          "811-3431",
          "811-4152",
          "811-3505",
          "811-3514",
          "811-3507",
          "811-4183",
          "811-3407",
          "811-3436",
          "811-4164",
          "811-4155",
          "811-3423",
          "811-4171",
          "811-3424",
          "811-3403",
          "811-3425",
          "811-3412",
          "811-3430",
          "811-3504",
          "811-4154",
          "811-4113",
          "811-3413",
          "811-3439",
          "811-3414",
          "811-4172",
          "811-3416",
          "811-3503",
          "811-3434",
          "811-3435",
          "811-3411",
          "811-3506",
          "811-4153",
          "811-4145",
          "811-3438",
          "818-0100",
          "818-0137",
          "818-0121",
          "818-0118",
          "818-0115",
          "818-0123",
          "818-0134",
          "818-0101",
          "818-0114",
          "818-0132",
          "818-0125",
          "818-0139",
          "818-0117",
          "818-0133",
          "818-0111",
          "818-0102",
          "818-0103",
          "818-0122",
          "818-0104",
          "818-0105",
          "818-0136",
          "818-0124",
          "818-0110",
          "818-0131",
          "818-0135",
          "818-0138",
          "818-0119",
          "811-3100",
          "811-3134",
          "811-3133",
          "811-3136",
          "811-3131",
          "811-3117",
          "811-3102",
          "811-3135",
          "811-3126",
          "811-3104",
          "811-3132",
          "811-3115",
          "811-3137",
          "811-3122",
          "811-3105",
          "811-3116",
          "811-3118",
          "811-3127",
          "811-3125",
          "811-3113",
          "811-3103",
          "811-3101",
          "811-3123",
          "811-3112",
          "811-3111",
          "811-3106",
          "811-3114",
          "811-3107",
          "811-3119",
          "811-3121",
          "811-3124",
          "811-3200",
          "811-3213",
          "811-3220",
          "811-3202",
          "811-3301",
          "811-3205",
          "811-3302",
          "811-3226",
          "811-3521",
          "811-3207",
          "811-3223",
          "811-3228",
          "811-3229",
          "811-3204",
          "811-3303",
          "811-3227",
          "811-3217",
          "811-3222",
          "811-3304",
          "811-3224",
          "811-3218",
          "811-3219",
          "811-3522",
          "811-3214",
          "811-3216",
          "811-3215",
          "811-3225",
          "811-3206",
          "811-3209",
          "811-3208",
          "811-3212",
          "811-3308",
          "811-3305",
          "811-3312",
          "811-3311",
          "811-3309",
          "811-3203",
          "811-3201",
          "811-3306",
          "811-3211",
          "811-3221",
          "811-3307",
          "839-1400",
          "839-1401",
          "839-1415",
          "839-1402",
          "839-1412",
          "839-1406",
          "839-1414",
          "839-1411",
          "839-1413",
          "839-1404",
          "839-1403",
          "839-1405",
          "839-1407",
          "839-1408",
          "839-1321",
          "839-1342",
          "839-1341",
          "839-1312",
          "839-1301",
          "839-1343",
          "839-1307",
          "839-1304",
          "839-1302",
          "839-1333",
          "839-1344",
          "839-1306",
          "839-1305",
          "839-1332",
          "839-1303",
          "839-1331",
          "839-1308",
          "839-1311",
          "823-0000",
          "823-0004",
          "822-0144",
          "822-0134",
          "822-0131",
          "822-0111",
          "822-0113",
          "823-0015",
          "823-0005",
          "823-0017",
          "822-0146",
          "822-0132",
          "822-0123",
          "822-0122",
          "823-0014",
          "823-0016",
          "823-0013",
          "822-0141",
          "822-0143",
          "822-0142",
          "823-0002",
          "823-0012",
          "822-0152",
          "822-0112",
          "822-0101",
          "822-0124",
          "823-0003",
          "822-0151",
          "823-0011",
          "822-0145",
          "822-0153",
          "822-0121",
          "823-0001",
          "822-0133",
          "820-0200",
          "820-0331",
          "820-0501",
          "820-0334",
          "820-0204",
          "821-0014",
          "820-0205",
          "820-0301",
          "820-0321",
          "820-0201",
          "821-0004",
          "820-0304",
          "821-0002",
          "820-0302",
          "820-0314",
          "820-0336",
          "820-0311",
          "820-0502",
          "820-0306",
          "821-0012",
          "820-0206",
          "820-0207",
          "821-0013",
          "820-0337",
          "820-0313",
          "820-0503",
          "820-0305",
          "820-0323",
          "820-0504",
          "821-0011",
          "820-0332",
          "820-0333",
          "820-0303",
          "820-0505",
          "820-0335",
          "820-0203",
          "820-0506",
          "820-0322",
          "820-0312",
          "820-0202",
          "838-0000",
          "838-0025",
          "838-0001",
          "838-0011",
          "838-0068",
          "838-0005",
          "838-1317",
          "838-0027",
          "838-0029",
          "838-1315",
          "838-0042",
          "838-0067",
          "838-0024",
          "838-1301",
          "838-0038",
          "838-0012",
          "838-1316",
          "838-0052",
          "838-0051",
          "838-0026",
          "838-0036",
          "838-0048",
          "838-0041",
          "838-0019",
          "838-0057",
          "838-1313",
          "838-0004",
          "838-0046",
          "838-0072",
          "838-0039",
          "838-0063",
          "838-1307",
          "838-0071",
          "838-0016",
          "838-0055",
          "838-0045",
          "838-0022",
          "838-1304",
          "838-0017",
          "838-0054",
          "838-0033",
          "838-0013",
          "838-1311",
          "838-1312",
          "838-0066",
          "838-0062",
          "838-0047",
          "838-0064",
          "838-0035",
          "838-0032",
          "838-0053",
          "838-0043",
          "838-0056",
          "838-1314",
          "838-0003",
          "838-1501",
          "838-1511",
          "838-1503",
          "838-1514",
          "838-1513",
          "838-1507",
          "838-1521",
          "838-1512",
          "838-1506",
          "838-1505",
          "838-1504",
          "838-1502",
          "838-1515",
          "838-0002",
          "838-0037",
          "838-1305",
          "838-0065",
          "838-0018",
          "838-0059",
          "838-1303",
          "838-0034",
          "838-0061",
          "838-0058",
          "838-0023",
          "838-0020",
          "838-1302",
          "838-0015",
          "838-0044",
          "838-0028",
          "838-0031",
          "838-0021",
          "838-1306",
          "838-0014",
          "838-0069",
          "835-0000",
          "835-0022",
          "835-0019",
          "835-0013",
          "835-0005",
          "835-0012",
          "835-0023",
          "835-0002",
          "835-0025",
          "835-0014",
          "835-0006",
          "835-0024",
          "835-0015",
          "835-0018",
          "835-0007",
          "835-0016",
          "835-0017",
          "835-0001",
          "835-0021",
          "835-0011",
          "835-0003",
          "835-0004",
          "839-0214",
          "839-0223",
          "839-0202",
          "839-0213",
          "839-0212",
          "835-0136",
          "839-0225",
          "835-0132",
          "839-0204",
          "839-0203",
          "839-0221",
          "839-0201",
          "835-0135",
          "839-0224",
          "835-0133",
          "839-0211",
          "839-0215",
          "835-0134",
          "839-0222",
          "835-0131",
          "839-0205",
          "835-0102",
          "835-0104",
          "835-0112",
          "835-0114",
          "835-0113",
          "835-0103",
          "835-0101",
          "835-0115",
          "835-0111",
          "819-1100",
          "819-1132",
          "819-1127",
          "819-1152",
          "819-1103",
          "819-1562",
          "819-1101",
          "819-1130",
          "819-1126",
          "819-1582",
          "819-1112",
          "819-1105",
          "819-1573",
          "819-1135",
          "819-1121",
          "819-1124",
          "819-1123",
          "819-1120",
          "819-1155",
          "819-1574",
          "819-1141",
          "819-1563",
          "819-1147",
          "819-1106",
          "819-1131",
          "819-1129",
          "819-1128",
          "819-1301",
          "819-1313",
          "819-1315",
          "819-1334",
          "819-1331",
          "819-1335",
          "819-1323",
          "819-1321",
          "819-1304",
          "819-1333",
          "819-1311",
          "819-1325",
          "819-1303",
          "819-1312",
          "819-1305",
          "819-1324",
          "819-1336",
          "819-1332",
          "819-1306",
          "819-1322",
          "819-1314",
          "819-1302",
          "819-1154",
          "819-1114",
          "819-1581",
          "819-1572",
          "819-1156",
          "819-1561",
          "819-1564",
          "819-1143",
          "819-1571",
          "819-1102",
          "819-1134",
          "819-1125",
          "819-1111",
          "819-1133",
          "819-1153",
          "819-1575",
          "819-1622",
          "819-1623",
          "819-1611",
          "819-1621",
          "819-1642",
          "819-1616",
          "819-1615",
          "819-1625",
          "819-1614",
          "819-1626",
          "819-1601",
          "819-1631",
          "819-1612",
          "819-1613",
          "819-1627",
          "819-1624",
          "819-1641",
          "819-1104",
          "819-1107",
          "819-1108",
          "819-1122",
          "819-1151",
          "819-1113",
          "819-1138",
          "819-1118",
          "819-1116",
          "819-1117",
          "819-1119",
          "819-1139",
          "819-1583",
          "819-1146",
          "819-1136",
          "819-1137",
          "819-1142",
          "819-1144",
          "819-1115",
          "819-1145",
          "811-1200",
          "811-1224",
          "811-1233",
          "811-1211",
          "811-1241",
          "811-1232",
          "811-1255",
          "811-1221",
          "811-1201",
          "811-1203",
          "811-1202",
          "811-1204",
          "811-1223",
          "811-1234",
          "811-1252",
          "811-1222",
          "811-1253",
          "811-1256",
          "811-1254",
          "811-1213",
          "811-1214",
          "811-1236",
          "811-1235",
          "811-1242",
          "811-1246",
          "811-1243",
          "811-1231",
          "811-1245",
          "811-1251",
          "811-1215",
          "811-1216",
          "811-1244",
          "811-2100",
          "811-2104",
          "811-2101",
          "811-2128",
          "811-2125",
          "811-2131",
          "811-2123",
          "811-2109",
          "811-2105",
          "811-2103",
          "811-2127",
          "811-2126",
          "811-2129",
          "811-2102",
          "811-2107",
          "811-2132",
          "811-2106",
          "811-2121",
          "811-2122",
          "811-2108",
          "811-2124",
          "811-2400",
          "811-2418",
          "811-2412",
          "811-2413",
          "811-2402",
          "811-2405",
          "811-2401",
          "811-2416",
          "811-2417",
          "811-2415",
          "811-2404",
          "811-2403",
          "811-2411",
          "811-2414",
          "811-2200",
          "811-2203",
          "811-2209",
          "811-2245",
          "811-2246",
          "811-2248",
          "811-2201",
          "811-2202",
          "811-2244",
          "811-2243",
          "811-2204",
          "811-2241",
          "811-2205",
          "811-2233",
          "811-2232",
          "811-2231",
          "811-2242",
          "811-2206",
          "811-2207",
          "811-2247",
          "811-2208",
          "811-2112",
          "811-2114",
          "811-2115",
          "811-2111",
          "811-2113",
          "811-2221",
          "811-0100",
          "811-0118",
          "811-0117",
          "811-0123",
          "811-0113",
          "811-0112",
          "811-0115",
          "811-0124",
          "811-0102",
          "811-0120",
          "811-0103",
          "811-0101",
          "811-0104",
          "811-0121",
          "811-0111",
          "811-0125",
          "811-0119",
          "811-0116",
          "811-0114",
          "811-0122",
          "811-0110",
          "811-2500",
          "811-2503",
          "811-2501",
          "811-2502",
          "811-2300",
          "811-2306",
          "813-0008",
          "811-2308",
          "811-2313",
          "811-2302",
          "811-2301",
          "811-2309",
          "811-2315",
          "811-2303",
          "811-2311",
          "811-2316",
          "811-2317",
          "811-2312",
          "811-2319",
          "811-2318",
          "811-2304",
          "811-2310",
          "811-2307",
          "811-2305",
          "811-2314",
          "807-0100",
          "807-0133",
          "807-0142",
          "807-0123",
          "807-0101",
          "807-0111",
          "807-0112",
          "807-0121",
          "807-0122",
          "807-0113",
          "807-0102",
          "807-0143",
          "807-0132",
          "807-0131",
          "807-0141",
          "807-0000",
          "807-0056",
          "807-0001",
          "807-0006",
          "807-0031",
          "807-0003",
          "807-0047",
          "807-0012",
          "807-0021",
          "807-0022",
          "807-0025",
          "807-0043",
          "807-0053",
          "807-0052",
          "807-0024",
          "807-0005",
          "807-0051",
          "807-0023",
          "807-0002",
          "807-0004",
          "807-0054",
          "807-0055",
          "807-0011",
          "807-0041",
          "807-0044",
          "807-0007",
          "807-0042",
          "807-0046",
          "807-0045",
          "807-0048",
          "811-4200",
          "811-4215",
          "811-4216",
          "811-4203",
          "811-4231",
          "811-4236",
          "811-4238",
          "811-4212",
          "811-4235",
          "811-4227",
          "811-4217",
          "811-4232",
          "811-4234",
          "811-4218",
          "811-4204",
          "811-4222",
          "811-4224",
          "811-4213",
          "811-4233",
          "811-4239",
          "811-4201",
          "811-4202",
          "811-4225",
          "811-4237",
          "811-4228",
          "811-4220",
          "811-4214",
          "811-4226",
          "811-4205",
          "811-4221",
          "811-4223",
          "811-4229",
          "811-4211",
          "811-4242",
          "811-4241",
          "811-4300",
          "811-4312",
          "811-4303",
          "811-4311",
          "811-4342",
          "811-4341",
          "811-4307",
          "811-4332",
          "811-4313",
          "811-4306",
          "811-4301",
          "811-4333",
          "811-4343",
          "811-4302",
          "811-4322",
          "811-4331",
          "811-4305",
          "811-4321",
          "811-4324",
          "811-4334",
          "811-4323",
          "811-4304",
          "820-1100",
          "820-1102",
          "820-1103",
          "820-1101",
          "820-1105",
          "820-1106",
          "820-1104",
          "807-1300",
          "807-1301",
          "807-1311",
          "807-1302",
          "807-1303",
          "807-1312",
          "807-1304",
          "807-1313",
          "807-1305",
          "807-1314",
          "807-1306",
          "807-1307",
          "807-1308",
          "807-1315",
          "820-0600",
          "820-0601",
          "820-0602",
          "820-0603",
          "820-0604",
          "820-0605",
          "820-0606",
          "820-0607",
          "820-0608",
          "820-0609",
          "838-0222",
          "838-0227",
          "838-0817",
          "838-0825",
          "838-0225",
          "838-0811",
          "838-0812",
          "838-0821",
          "838-0201",
          "838-0801",
          "838-0202",
          "838-0212",
          "838-0215",
          "838-0211",
          "838-0816",
          "838-0206",
          "838-0814",
          "838-0822",
          "838-0204",
          "838-0803",
          "838-0223",
          "838-0226",
          "838-0815",
          "838-0203",
          "838-0824",
          "838-0214",
          "838-0802",
          "838-0221",
          "838-0228",
          "838-0224",
          "838-0205",
          "838-0207",
          "838-0804",
          "838-0213",
          "838-0823",
          "838-0813",
          "838-1700",
          "838-1601",
          "838-1602",
          "838-1702",
          "838-1701",
          "830-1200",
          "830-1223",
          "830-1224",
          "830-1213",
          "830-1222",
          "830-1212",
          "830-1214",
          "830-1225",
          "830-1202",
          "830-1221",
          "830-1201",
          "830-1206",
          "830-1204",
          "830-1211",
          "830-1203",
          "830-1205",
          "830-1226",
          "830-0400",
          "830-0425",
          "830-0415",
          "830-0403",
          "830-0423",
          "830-0421",
          "830-0414",
          "830-0404",
          "830-0417",
          "830-0413",
          "830-0401",
          "830-0412",
          "830-0422",
          "830-0416",
          "830-0411",
          "830-0402",
          "830-0406",
          "830-0424",
          "830-0405",
          "834-0100",
          "834-0122",
          "834-0114",
          "834-0113",
          "834-0101",
          "834-0105",
          "834-0115",
          "834-0112",
          "834-0111",
          "834-0121",
          "834-0123",
          "834-0102",
          "834-0104",
          "834-0103",
          "822-1400",
          "822-1402",
          "822-1404",
          "822-1406",
          "822-1401",
          "822-1403",
          "822-1405",
          "824-0600",
          "824-0722",
          "824-0601",
          "824-0602",
          "824-0603",
          "824-0411",
          "824-0604",
          "824-0721",
          "824-0723",
          "822-1300",
          "822-1324",
          "822-1313",
          "822-1302",
          "822-1316",
          "822-1311",
          "822-1306",
          "822-1322",
          "822-1312",
          "822-1304",
          "822-1323",
          "822-1314",
          "822-1326",
          "822-1318",
          "822-1301",
          "822-1325",
          "822-1317",
          "822-1315",
          "822-1321",
          "822-1307",
          "822-1305",
          "822-1303",
          "827-0000",
          "827-0001",
          "826-0002",
          "827-0002",
          "827-0003",
          "827-0004",
          "824-0500",
          "824-0511",
          "824-0512",
          "824-0400",
          "824-0431",
          "824-0432",
          "822-1200",
          "822-1101",
          "822-1102",
          "822-1211",
          "822-1103",
          "822-1201",
          "822-1202",
          "822-1212",
          "800-0300",
          "800-0354",
          "800-0366",
          "800-0344",
          "800-0313",
          "800-0337",
          "800-0331",
          "800-0353",
          "800-0345",
          "800-0343",
          "800-0365",
          "800-0351",
          "800-0305",
          "800-0338",
          "800-0333",
          "800-0356",
          "800-0314",
          "800-0357",
          "800-0341",
          "800-0342",
          "800-0361",
          "800-0321",
          "800-0332",
          "800-0335",
          "800-0312",
          "800-0352",
          "800-0304",
          "800-0311",
          "800-0362",
          "800-0324",
          "800-0364",
          "800-0322",
          "800-0334",
          "800-0301",
          "800-0303",
          "800-0363",
          "800-0315",
          "800-0355",
          "800-0336",
          "800-0323",
          "800-0302",
          "824-0800",
          "824-0102",
          "824-0104",
          "824-0106",
          "824-0211",
          "824-0818",
          "824-0817",
          "824-0821",
          "824-0814",
          "824-0801",
          "824-0815",
          "824-0822",
          "824-0812",
          "824-0802",
          "824-0811",
          "824-0813",
          "824-0816",
          "824-0111",
          "824-0112",
          "824-0207",
          "824-0122",
          "824-0125",
          "824-0123",
          "824-0214",
          "824-0242",
          "824-0241",
          "824-0215",
          "824-0254",
          "824-0212",
          "824-0225",
          "824-0222",
          "824-0252",
          "824-0202",
          "824-0243",
          "824-0213",
          "824-0235",
          "824-0224",
          "824-0251",
          "824-0201",
          "824-0204",
          "824-0203",
          "824-0216",
          "824-0233",
          "824-0205",
          "824-0217",
          "824-0253",
          "824-0231",
          "824-0206",
          "824-0223",
          "824-0221",
          "824-0244",
          "824-0232",
          "824-0234",
          "824-0103",
          "824-0114",
          "824-0124",
          "824-0107",
          "824-0105",
          "824-0101",
          "824-0121",
          "824-0226",
          "824-0115",
          "824-0113",
          "871-0000",
          "871-0822",
          "871-0802",
          "871-0801",
          "871-0821",
          "871-0832",
          "871-0834",
          "871-0831",
          "871-0833",
          "871-0823",
          "871-0811",
          "871-0900",
          "871-0904",
          "871-0914",
          "871-0907",
          "871-0924",
          "871-0905",
          "871-0923",
          "871-0902",
          "871-0913",
          "871-0921",
          "871-0911",
          "871-0901",
          "871-0928",
          "871-0226",
          "871-0926",
          "871-0927",
          "871-0922",
          "871-0925",
          "871-0906",
          "871-0903",
          "871-0912",
          "829-0100",
          "829-0112",
          "829-0315",
          "829-0313",
          "829-0312",
          "829-0124",
          "829-0335",
          "829-0314",
          "829-0302",
          "829-0341",
          "829-0304",
          "829-0104",
          "829-0114",
          "829-0115",
          "829-0105",
          "829-0117",
          "829-0332",
          "829-0323",
          "829-0321",
          "829-0125",
          "829-0301",
          "829-0113",
          "829-0116",
          "829-0108",
          "829-0305",
          "829-0331",
          "829-0102",
          "829-0122",
          "829-0334",
          "829-0151",
          "829-0343",
          "829-0101",
          "829-0342",
          "829-0322",
          "829-0103",
          "829-0106",
          "829-0123",
          "829-0121",
          "829-0333",
          "829-0311",
          "829-0111",
          "829-0303",
          "829-0107",
          "849-0000",
          "840-0812",
          "840-0042",
          "840-0053",
          "840-0844",
          "840-0052",
          "840-0801",
          "840-0816",
          "840-0811",
          "840-0802",
          "840-0021",
          "849-0933",
          "849-0934",
          "840-0862",
          "840-0864",
          "840-0863",
          "840-0861",
          "840-0806",
          "840-2212",
          "840-2211",
          "840-2213",
          "840-2214",
          "840-2205",
          "840-2204",
          "840-2203",
          "840-2202",
          "840-2201",
          "840-0843",
          "840-0011",
          "840-0013",
          "840-0012",
          "840-0015",
          "849-0906",
          "849-0905",
          "849-0904",
          "849-0902",
          "849-0901",
          "849-0903",
          "849-0205",
          "849-0204",
          "849-0203",
          "849-0201",
          "849-0202",
          "840-0804",
          "840-0805",
          "840-0008",
          "840-0007",
          "840-0001",
          "840-0006",
          "840-0824",
          "840-0056",
          "840-0055",
          "840-0803",
          "840-0044",
          "840-0031",
          "840-0855",
          "840-0041",
          "840-0043",
          "840-0826",
          "840-0859",
          "840-0850",
          "840-0017",
          "840-0856",
          "849-0924",
          "840-0032",
          "840-0814",
          "849-0927",
          "849-0922",
          "849-0921",
          "849-0917",
          "849-0916",
          "840-0822",
          "840-0051",
          "840-0842",
          "840-0825",
          "840-0815",
          "840-0851",
          "840-0858",
          "840-0813",
          "840-0852",
          "840-0833",
          "840-0022",
          "840-0853",
          "849-0937",
          "849-0931",
          "849-0938",
          "849-0936",
          "840-0857",
          "849-0932",
          "840-0046",
          "840-0045",
          "840-0035",
          "840-0037",
          "840-0034",
          "840-0036",
          "840-0005",
          "840-0003",
          "840-0004",
          "840-0002",
          "840-0834",
          "849-0925",
          "840-0033",
          "840-0821",
          "840-2223",
          "840-2221",
          "840-2222",
          "849-0923",
          "849-0912",
          "849-0915",
          "849-0914",
          "849-0913",
          "849-0911",
          "849-0919",
          "849-0918",
          "840-0503",
          "840-0514",
          "840-0516",
          "840-0533",
          "840-0532",
          "840-0521",
          "840-0511",
          "840-0545",
          "840-0512",
          "840-0536",
          "840-0531",
          "840-0543",
          "840-0544",
          "840-0513",
          "840-0535",
          "840-0502",
          "840-0541",
          "840-0504",
          "840-0534",
          "840-0522",
          "840-0542",
          "840-0501",
          "840-0515",
          "840-0537",
          "840-0832",
          "840-0025",
          "840-0027",
          "840-0026",
          "840-0024",
          "840-0023",
          "840-0831",
          "840-0054",
          "842-0302",
          "842-0301",
          "842-0303",
          "840-0841",
          "840-0016",
          "840-2101",
          "840-2102",
          "840-2103",
          "840-2104",
          "840-2105",
          "840-2106",
          "840-0854",
          "849-0935",
          "840-0823",
          "840-0212",
          "840-0203",
          "840-0214",
          "840-0202",
          "840-0213",
          "840-0205",
          "840-0201",
          "840-0215",
          "840-0211",
          "840-0204",
          "840-0047",
          "840-0845",
          "849-0928",
          "849-0926",
          "847-0000",
          "847-0823",
          "847-0841",
          "847-0832",
          "847-0042",
          "847-0025",
          "847-0804",
          "847-0124",
          "847-0853",
          "847-0123",
          "847-0132",
          "849-3223",
          "849-3201",
          "849-3221",
          "849-3215",
          "849-3232",
          "849-3222",
          "849-3233",
          "849-3211",
          "849-3214",
          "849-3219",
          "849-3216",
          "849-3217",
          "849-3218",
          "849-3203",
          "849-3202",
          "849-3231",
          "849-3224",
          "849-3213",
          "849-3212",
          "847-0066",
          "847-0873",
          "847-0022",
          "847-0028",
          "847-0065",
          "847-0026",
          "847-0131",
          "847-0055",
          "847-0015",
          "847-1212",
          "847-1221",
          "847-1211",
          "847-1225",
          "847-1223",
          "847-1213",
          "847-1202",
          "847-1201",
          "847-1222",
          "847-1214",
          "847-1203",
          "847-1224",
          "849-3101",
          "849-3123",
          "849-3132",
          "849-3114",
          "849-3131",
          "849-3121",
          "849-3102",
          "849-3112",
          "849-3122",
          "849-3115",
          "849-3103",
          "849-3111",
          "849-3104",
          "849-3113",
          "849-3133",
          "847-0045",
          "847-0044",
          "847-0817",
          "847-0884",
          "847-0033",
          "847-0824",
          "847-0052",
          "847-0054",
          "847-0053",
          "847-0061",
          "847-0011",
          "847-0843",
          "847-0104",
          "847-0111",
          "847-0113",
          "847-0114",
          "847-0115",
          "847-0112",
          "847-0883",
          "847-0067",
          "847-0021",
          "847-0043",
          "847-0816",
          "847-0813",
          "847-0882",
          "847-0001",
          "847-0012",
          "847-0803",
          "847-0046",
          "847-0027",
          "847-0881",
          "847-0831",
          "847-0821",
          "847-0041",
          "847-0312",
          "847-0327",
          "847-0323",
          "847-0322",
          "847-0317",
          "847-0325",
          "847-0403",
          "847-0324",
          "847-0313",
          "847-0314",
          "847-0316",
          "847-0401",
          "847-0402",
          "847-0404",
          "847-0326",
          "847-0405",
          "847-0406",
          "847-0311",
          "847-0315",
          "847-0321",
          "847-0885",
          "847-0122",
          "847-0134",
          "847-0101",
          "847-0034",
          "847-0051",
          "847-0862",
          "847-0822",
          "847-0802",
          "847-1101",
          "847-1103",
          "847-1104",
          "847-1108",
          "847-1106",
          "847-1105",
          "847-1107",
          "847-1102",
          "847-0844",
          "847-0872",
          "847-0875",
          "847-0014",
          "847-0815",
          "847-0855",
          "847-0854",
          "847-0003",
          "847-0103",
          "847-0833",
          "847-0023",
          "847-0121",
          "849-5103",
          "849-5101",
          "849-5102",
          "849-5105",
          "849-5113",
          "849-5131",
          "849-5123",
          "849-5112",
          "849-5104",
          "849-5111",
          "849-5124",
          "849-5121",
          "849-5122",
          "847-0031",
          "847-0024",
          "847-0871",
          "847-0017",
          "847-0016",
          "847-0063",
          "847-0801",
          "847-1502",
          "847-1517",
          "847-1522",
          "847-1526",
          "847-1512",
          "847-1516",
          "847-1506",
          "847-1501",
          "847-1505",
          "847-1521",
          "847-1527",
          "847-1513",
          "847-1504",
          "847-1511",
          "847-1514",
          "847-1525",
          "847-1523",
          "847-1515",
          "847-1507",
          "847-1524",
          "847-1503",
          "847-0812",
          "847-0874",
          "847-0851",
          "847-0861",
          "847-0062",
          "847-0056",
          "847-0047",
          "847-0133",
          "847-0013",
          "847-0876",
          "847-0863",
          "847-0825",
          "847-0064",
          "847-0852",
          "847-0811",
          "847-0135",
          "847-0102",
          "847-0004",
          "847-0005",
          "847-0842",
          "847-0834",
          "847-0002",
          "847-0032",
          "847-0814",
          "847-0136",
          "847-0301",
          "847-0306",
          "847-0305",
          "847-0302",
          "847-0304",
          "847-0303",
          "847-0071",
          "847-0083",
          "847-0074",
          "847-0082",
          "847-0084",
          "847-0073",
          "847-0072",
          "847-0085",
          "847-0081",
          "847-0075",
          "841-0000",
          "841-0036",
          "841-0082",
          "841-0068",
          "841-0045",
          "841-0022",
          "841-0047",
          "841-0001",
          "841-0086",
          "841-0073",
          "841-0003",
          "841-0081",
          "841-0087",
          "841-0066",
          "841-0034",
          "841-0056",
          "841-0054",
          "841-0004",
          "841-0083",
          "841-0062",
          "841-0041",
          "841-0042",
          "841-0088",
          "841-0014",
          "841-0063",
          "841-0052",
          "841-0025",
          "841-0032",
          "841-0044",
          "841-0015",
          "841-0012",
          "841-0013",
          "841-0017",
          "841-0016",
          "841-0018",
          "841-0075",
          "841-0039",
          "841-0061",
          "841-0011",
          "841-0074",
          "841-0067",
          "841-0089",
          "841-0021",
          "841-0071",
          "841-0024",
          "841-0035",
          "841-0023",
          "841-0076",
          "841-0048",
          "841-0053",
          "841-0038",
          "841-0033",
          "841-0026",
          "841-0037",
          "841-0065",
          "841-0046",
          "841-0027",
          "841-0064",
          "841-0043",
          "841-0072",
          "841-0051",
          "841-0055",
          "841-0084",
          "841-0085",
          "841-0005",
          "841-0031",
          "841-0002",
          "846-0000",
          "846-0001",
          "846-0006",
          "846-0002",
          "846-0005",
          "846-0003",
          "846-0004",
          "846-0007",
          "846-0031",
          "846-0041",
          "846-0011",
          "846-0013",
          "846-0014",
          "846-0012",
          "846-0021",
          "846-0022",
          "846-0024",
          "846-0023",
          "846-0025",
          "848-0000",
          "848-0047",
          "848-0046",
          "848-0024",
          "848-0025",
          "848-0026",
          "849-5251",
          "849-5257",
          "849-5252",
          "849-5253",
          "849-5254",
          "849-5256",
          "849-5255",
          "848-0021",
          "848-0022",
          "848-0023",
          "848-0044",
          "848-0124",
          "848-0123",
          "848-0146",
          "848-0125",
          "848-0121",
          "848-0141",
          "848-0142",
          "848-0145",
          "848-0132",
          "848-0131",
          "848-0134",
          "848-0122",
          "848-0133",
          "848-0143",
          "848-0144",
          "848-0041",
          "848-0043",
          "848-0027",
          "848-0032",
          "848-0035",
          "848-0034",
          "848-0033",
          "848-0031",
          "848-0042",
          "848-0113",
          "848-0116",
          "848-0103",
          "848-0111",
          "848-0104",
          "848-0112",
          "848-0101",
          "848-0117",
          "848-0114",
          "848-0115",
          "848-0102",
          "848-0105",
          "849-4284",
          "849-4281",
          "849-4286",
          "849-4282",
          "849-4285",
          "849-4273",
          "849-4271",
          "849-4272",
          "849-4283",
          "849-4274",
          "849-5264",
          "849-5262",
          "849-5261",
          "849-5263",
          "848-0045",
          "848-0007",
          "848-0011",
          "848-0005",
          "848-0013",
          "848-0014",
          "848-0001",
          "848-0006",
          "848-0002",
          "848-0004",
          "848-0016",
          "848-0015",
          "848-0012",
          "848-0003",
          "849-4251",
          "849-4252",
          "849-4256",
          "849-4254",
          "849-4261",
          "849-4263",
          "849-4264",
          "849-4262",
          "849-4255",
          "849-4253",
          "848-0028",
          "843-0000",
          "843-0003",
          "843-0001",
          "843-0002",
          "849-2203",
          "849-2204",
          "849-2202",
          "849-2201",
          "849-2341",
          "849-2342",
          "843-0023",
          "843-0022",
          "843-0024",
          "843-0021",
          "843-0011",
          "843-0012",
          "843-0013",
          "843-0014",
          "843-0231",
          "843-0232",
          "843-0233",
          "843-0234",
          "849-2301",
          "849-2304",
          "849-2302",
          "849-2303",
          "849-2305",
          "843-0151",
          "843-0152",
          "843-0153",
          "849-1300",
          "849-1324",
          "849-1302",
          "849-1323",
          "849-1313",
          "849-1311",
          "849-1301",
          "849-1304",
          "849-1312",
          "849-1322",
          "849-1321",
          "849-1315",
          "849-1303",
          "849-1314",
          "845-0000",
          "849-0311",
          "849-0312",
          "849-0316",
          "849-0313",
          "849-0315",
          "849-0314",
          "849-0303",
          "849-0301",
          "849-0302",
          "849-0306",
          "849-0305",
          "849-0304",
          "845-0001",
          "845-0012",
          "845-0003",
          "845-0013",
          "845-0002",
          "845-0014",
          "845-0005",
          "845-0011",
          "845-0004",
          "845-0035",
          "845-0023",
          "845-0032",
          "845-0022",
          "845-0034",
          "845-0021",
          "845-0033",
          "845-0031",
          "845-0025",
          "845-0024",
          "843-0300",
          "843-0304",
          "843-0301",
          "843-0302",
          "843-0305",
          "843-0303",
          "849-1416",
          "849-1414",
          "849-1415",
          "849-1402",
          "849-1401",
          "849-1404",
          "849-1403",
          "849-1426",
          "849-1425",
          "849-1423",
          "849-1422",
          "849-1424",
          "849-1412",
          "849-1411",
          "849-1413",
          "849-1421",
          "842-0000",
          "842-0014",
          "842-0123",
          "842-0006",
          "842-0015",
          "842-0001",
          "842-0122",
          "842-0121",
          "842-0011",
          "842-0002",
          "842-0107",
          "842-0007",
          "842-0004",
          "842-0005",
          "842-0013",
          "842-0003",
          "842-0012",
          "842-0203",
          "842-0201",
          "842-0202",
          "842-0052",
          "842-0054",
          "842-0067",
          "842-0051",
          "842-0056",
          "842-0065",
          "842-0068",
          "842-0055",
          "842-0061",
          "842-0053",
          "842-0063",
          "842-0062",
          "842-0066",
          "842-0064",
          "842-0102",
          "842-0103",
          "842-0035",
          "842-0032",
          "842-0034",
          "842-0101",
          "842-0033",
          "842-0104",
          "842-0031",
          "841-0200",
          "841-0205",
          "841-0201",
          "841-0203",
          "841-0202",
          "841-0204",
          "849-0100",
          "849-0121",
          "849-0124",
          "849-0123",
          "849-0122",
          "840-1106",
          "849-0112",
          "840-1103",
          "849-0111",
          "840-1102",
          "849-0114",
          "840-1101",
          "849-0101",
          "849-0113",
          "840-1104",
          "849-0102",
          "840-1105",
          "847-1400",
          "847-1403",
          "847-1402",
          "847-1423",
          "847-1441",
          "847-1434",
          "847-1413",
          "847-1443",
          "847-1435",
          "847-1401",
          "847-1424",
          "847-1445",
          "847-1422",
          "847-1415",
          "847-1412",
          "847-1442",
          "847-1411",
          "847-1444",
          "847-1404",
          "847-1425",
          "847-1433",
          "847-1432",
          "847-1431",
          "847-1405",
          "847-1446",
          "847-1416",
          "847-1421",
          "847-1414",
          "844-0000",
          "844-0006",
          "844-0024",
          "844-0001",
          "844-0011",
          "844-0021",
          "849-4154",
          "844-0004",
          "844-0013",
          "849-4162",
          "844-0003",
          "849-4174",
          "849-4144",
          "849-4166",
          "849-4175",
          "849-4165",
          "844-0022",
          "844-0012",
          "849-4156",
          "844-0005",
          "844-0016",
          "849-4163",
          "849-4172",
          "849-4143",
          "844-0007",
          "849-4161",
          "849-4146",
          "849-4153",
          "844-0017",
          "844-0014",
          "844-0002",
          "844-0009",
          "844-0028",
          "844-0027",
          "849-4141",
          "849-4176",
          "844-0008",
          "849-4152",
          "849-4151",
          "844-0015",
          "844-0026",
          "844-0025",
          "849-4164",
          "844-0018",
          "849-4173",
          "844-0023",
          "849-4145",
          "849-4142",
          "849-4155",
          "849-4171",
          "849-2100",
          "849-2101",
          "849-2102",
          "849-0500",
          "849-0506",
          "849-0502",
          "849-0505",
          "849-0503",
          "849-0504",
          "849-0501",
          "849-1100",
          "849-1101",
          "849-1201",
          "849-1102",
          "849-1204",
          "849-1208",
          "849-1221",
          "849-1202",
          "849-1205",
          "849-1103",
          "849-1104",
          "849-1105",
          "849-1203",
          "849-1106",
          "849-0403",
          "849-1111",
          "849-1207",
          "849-1112",
          "849-0401",
          "849-0402",
          "849-1113",
          "849-1206",
          "849-1114",
          "849-1115",
          "849-1116",
          "849-1600",
          "849-1603",
          "849-1601",
          "849-1614",
          "849-1615",
          "849-1613",
          "849-1612",
          "849-1611",
          "849-1616",
          "849-1602",
          "850-0000",
          "850-0922",
          "851-1122",
          "852-8036",
          "851-2321",
          "852-8156",
          "850-0064",
          "850-0063",
          "852-8008",
          "852-8003",
          "851-2212",
          "852-8141",
          "851-2201",
          "850-0822",
          "851-0123",
          "852-8035",
          "850-0832",
          "852-8136",
          "851-1201",
          "851-0254",
          "851-0502",
          "857-0071",
          "852-8126",
          "852-8151",
          "852-8157",
          "850-0924",
          "850-0018",
          "850-0971",
          "852-8011",
          "850-0907",
          "850-0025",
          "850-0802",
          "850-0065",
          "852-8106",
          "850-0072",
          "852-8017",
          "852-8052",
          "850-0923",
          "852-8113",
          "850-0874",
          "851-0135",
          "850-0022",
          "850-0909",
          "850-0054",
          "850-0992",
          "850-0861",
          "852-8007",
          "850-0056",
          "852-8101",
          "852-8054",
          "852-8032",
          "852-8132",
          "850-0024",
          "850-0916",
          "850-0918",
          "851-0302",
          "851-0244",
          "852-8062",
          "851-0255",
          "850-0062",
          "852-8127",
          "852-8005",
          "852-8134",
          "850-0066",
          "852-8056",
          "850-0964",
          "852-8115",
          "850-0027",
          "852-8044",
          "850-0058",
          "850-0042",
          "851-0115",
          "851-1134",
          "850-0905",
          "850-0803",
          "851-2202",
          "850-0831",
          "851-0124",
          "850-0003",
          "850-0028",
          "852-8026",
          "850-0037",
          "850-0973",
          "850-0034",
          "851-1131",
          "851-2426",
          "851-2324",
          "850-0834",
          "850-0048",
          "851-0111",
          "850-0953",
          "850-0006",
          "850-0078",
          "851-0401",
          "851-0112",
          "850-0946",
          "852-8108",
          "852-8143",
          "851-0407",
          "850-0906",
          "851-0242",
          "850-0076",
          "850-0974",
          "851-2211",
          "851-3214",
          "851-3215",
          "851-3213",
          "851-3211",
          "851-3103",
          "851-3102",
          "850-0854",
          "850-0981",
          "851-0501",
          "850-0976",
          "852-8146",
          "850-0871",
          "850-0032",
          "851-2403",
          "851-2411",
          "851-2422",
          "851-2424",
          "851-2421",
          "851-2401",
          "851-2423",
          "851-2425",
          "851-2413",
          "851-2404",
          "851-2405",
          "851-0310",
          "850-0067",
          "851-1132",
          "851-1133",
          "850-0961",
          "851-0101",
          "850-0951",
          "850-0934",
          "850-0077",
          "850-0937",
          "850-0036",
          "850-0002",
          "852-8125",
          "850-0983",
          "850-0046",
          "850-0994",
          "851-0122",
          "850-0875",
          "852-8102",
          "850-0835",
          "851-2207",
          "850-0015",
          "850-0031",
          "851-2206",
          "850-0824",
          "850-0975",
          "850-0947",
          "850-0071",
          "851-0125",
          "851-1137",
          "850-0917",
          "852-8041",
          "851-2427",
          "851-2326",
          "850-0004",
          "850-0908",
          "851-0121",
          "852-8034",
          "852-8145",
          "852-8042",
          "850-0812",
          "852-8027",
          "852-8021",
          "850-0962",
          "850-0017",
          "850-0842",
          "850-0954",
          "850-0014",
          "851-2323",
          "850-0991",
          "851-0126",
          "852-8152",
          "852-8154",
          "850-0873",
          "850-0047",
          "851-1125",
          "850-0057",
          "850-0963",
          "851-2213",
          "850-0941",
          "852-8111",
          "851-1315",
          "851-0137",
          "851-0503",
          "850-0821",
          "850-0045",
          "851-0251",
          "852-8014",
          "852-8025",
          "850-0007",
          "851-0252",
          "851-0134",
          "850-0053",
          "851-0405",
          "850-0052",
          "851-0245",
          "852-8135",
          "850-0877",
          "852-8124",
          "851-0102",
          "851-0406",
          "851-0132",
          "850-0984",
          "850-0023",
          "851-1135",
          "850-0862",
          "850-0872",
          "850-0044",
          "851-0113",
          "850-0977",
          "850-0841",
          "851-0404",
          "850-0843",
          "850-0952",
          "851-3212",
          "850-0013",
          "850-0836",
          "851-0103",
          "850-0912",
          "852-8155",
          "851-2325",
          "850-0055",
          "850-0936",
          "852-8061",
          "850-0011",
          "851-2215",
          "851-2214",
          "851-0504",
          "850-0876",
          "851-3101",
          "852-8055",
          "852-8051",
          "852-8045",
          "850-0837",
          "850-0933",
          "850-0051",
          "851-2322",
          "850-0074",
          "850-0075",
          "852-8043",
          "850-0001",
          "852-8122",
          "850-0005",
          "851-0403",
          "851-0507",
          "851-0505",
          "852-8114",
          "850-0993",
          "850-0944",
          "852-8153",
          "852-8024",
          "852-8107",
          "850-0041",
          "850-0853",
          "851-0253",
          "852-8053",
          "852-8015",
          "851-0402",
          "852-8001",
          "850-0833",
          "850-0932",
          "851-2327",
          "850-0073",
          "850-0855",
          "851-0116",
          "850-0911",
          "850-0915",
          "850-0804",
          "850-0914",
          "850-0985",
          "852-8006",
          "852-8117",
          "851-0136",
          "850-0996",
          "850-0995",
          "850-0016",
          "851-0301",
          "850-0068",
          "852-8022",
          "852-8012",
          "851-0104",
          "850-0904",
          "850-0851",
          "850-0935",
          "850-0026",
          "850-0972",
          "852-8131",
          "852-8116",
          "852-8002",
          "852-8016",
          "851-2216",
          "852-8063",
          "852-8064",
          "850-0945",
          "850-0012",
          "851-0114",
          "851-1124",
          "850-0921",
          "851-2205",
          "851-0131",
          "852-8118",
          "852-8004",
          "850-0902",
          "850-0033",
          "851-2203",
          "851-2204",
          "852-8121",
          "851-1121",
          "850-0061",
          "852-8142",
          "852-8033",
          "852-8103",
          "850-0079",
          "850-0943",
          "850-0942",
          "850-0931",
          "852-8123",
          "851-0408",
          "851-0243",
          "852-8031",
          "851-1136",
          "852-8105",
          "852-8144",
          "851-0241",
          "852-8112",
          "850-0901",
          "852-8133",
          "850-0035",
          "850-0913",
          "852-8104",
          "850-0029",
          "851-0133",
          "850-0043",
          "850-0813",
          "852-8013",
          "852-8046",
          "850-0982",
          "850-0811",
          "850-0801",
          "850-0823",
          "852-8065",
          "851-1123",
          "850-0903",
          "850-0852",
          "850-0021",
          "852-8023",
          "852-8047",
          "852-8137",
          "851-0506",
          "857-0000",
          "857-0044",
          "858-0918",
          "857-0013",
          "857-0064",
          "857-0431",
          "858-0917",
          "859-3241",
          "857-1233",
          "857-0037",
          "857-0057",
          "857-0851",
          "857-0061",
          "857-4813",
          "857-4815",
          "857-4903",
          "857-4812",
          "857-4811",
          "857-4904",
          "857-4901",
          "857-4816",
          "857-4902",
          "857-4814",
          "857-0069",
          "857-0017",
          "859-3225",
          "859-3202",
          "857-0058",
          "859-3244",
          "859-3165",
          "857-0001",
          "859-6131",
          "859-6111",
          "859-6133",
          "859-6103",
          "859-6114",
          "859-6121",
          "859-6105",
          "859-6102",
          "859-6106",
          "859-6126",
          "859-6113",
          "859-6123",
          "859-6132",
          "859-6104",
          "859-6134",
          "859-6115",
          "859-6101",
          "859-6122",
          "859-6112",
          "859-6125",
          "859-6124",
          "858-0926",
          "857-1163",
          "857-0131",
          "857-0841",
          "857-0146",
          "857-1171",
          "859-3233",
          "858-0902",
          "857-0065",
          "858-0965",
          "857-0021",
          "857-1162",
          "857-0144",
          "858-0922",
          "857-0011",
          "859-3216",
          "857-0803",
          "858-0915",
          "857-0872",
          "857-0067",
          "858-0903",
          "857-0126",
          "858-0914",
          "857-0123",
          "857-0801",
          "857-1166",
          "858-0916",
          "859-3166",
          "857-0874",
          "857-0121",
          "857-0104",
          "859-3161",
          "857-0025",
          "857-1152",
          "857-3271",
          "859-3157",
          "857-0805",
          "857-0802",
          "859-3164",
          "857-0403",
          "857-0413",
          "857-0401",
          "857-0402",
          "857-0411",
          "857-0404",
          "857-0405",
          "857-0412",
          "857-0406",
          "857-0414",
          "857-0813",
          "857-0066",
          "857-0041",
          "857-0114",
          "857-0106",
          "859-3214",
          "859-3213",
          "857-0062",
          "857-0054",
          "859-3226",
          "857-1176",
          "857-0012",
          "859-3242",
          "857-0122",
          "859-3211",
          "858-0925",
          "857-0876",
          "859-3154",
          "857-0834",
          "859-6201",
          "859-6202",
          "859-6203",
          "859-6144",
          "859-6204",
          "859-6141",
          "859-6145",
          "859-6205",
          "859-6206",
          "859-6142",
          "859-6143",
          "859-6207",
          "859-3224",
          "857-0806",
          "857-0879",
          "857-0036",
          "857-0113",
          "857-0875",
          "859-3156",
          "857-1232",
          "858-0905",
          "857-1173",
          "859-3237",
          "857-0821",
          "857-1164",
          "857-0105",
          "857-0862",
          "857-0033",
          "859-3158",
          "859-3152",
          "858-0913",
          "859-3203",
          "857-0855",
          "857-0812",
          "857-0831",
          "858-0924",
          "859-6401",
          "859-6402",
          "859-6403",
          "859-6404",
          "859-6405",
          "859-6406",
          "859-6407",
          "859-6408",
          "859-6411",
          "859-6409",
          "859-6412",
          "859-6413",
          "859-6414",
          "859-6415",
          "859-3231",
          "857-0134",
          "857-0135",
          "857-0045",
          "857-0843",
          "857-1161",
          "857-0042",
          "858-0931",
          "857-0811",
          "857-0125",
          "858-0901",
          "858-0911",
          "857-0014",
          "857-0063",
          "858-0907",
          "857-0027",
          "859-3205",
          "857-0136",
          "857-1235",
          "857-0016",
          "857-0101",
          "857-0111",
          "857-1174",
          "857-1175",
          "857-0043",
          "857-0124",
          "857-0053",
          "857-0864",
          "857-0141",
          "857-0046",
          "858-0921",
          "858-0904",
          "857-0038",
          "859-3234",
          "859-3221",
          "857-0023",
          "857-0048",
          "857-1234",
          "857-0142",
          "859-3215",
          "859-3243",
          "859-3236",
          "859-3232",
          "858-0906",
          "857-0028",
          "857-0024",
          "859-3212",
          "857-0051",
          "859-3454",
          "859-3452",
          "859-3453",
          "859-3451",
          "857-0103",
          "857-1151",
          "857-0049",
          "857-1172",
          "857-0842",
          "858-0908",
          "857-0852",
          "858-0923",
          "857-0056",
          "857-0040",
          "859-3201",
          "859-3223",
          "859-3222",
          "857-0854",
          "857-0035",
          "857-0832",
          "857-1231",
          "858-0912",
          "857-0031",
          "857-0853",
          "857-0145",
          "857-0052",
          "857-0804",
          "857-0102",
          "857-0132",
          "857-0015",
          "857-0034",
          "857-0863",
          "859-3153",
          "859-3155",
          "859-3151",
          "857-0055",
          "857-0861",
          "857-0068",
          "857-0873",
          "857-0026",
          "857-0032",
          "859-3235",
          "857-0871",
          "857-0059",
          "857-1153",
          "857-0047",
          "857-0878",
          "857-0822",
          "857-0022",
          "857-1165",
          "857-0133",
          "857-0112",
          "857-0115",
          "857-0018",
          "859-3163",
          "859-6303",
          "859-6325",
          "859-6316",
          "859-6322",
          "859-6304",
          "859-6313",
          "859-6315",
          "859-6301",
          "859-6317",
          "859-6326",
          "859-6314",
          "859-6305",
          "859-6311",
          "859-6312",
          "859-6323",
          "859-6302",
          "859-6321",
          "859-6324",
          "857-0143",
          "859-3162",
          "857-0877",
          "859-3204",
          "857-0833",
          "855-0000",
          "855-0038",
          "855-0855",
          "855-0021",
          "855-0002",
          "859-1412",
          "859-1411",
          "859-1414",
          "859-1413",
          "859-1415",
          "859-1402",
          "859-1401",
          "859-1404",
          "859-1403",
          "855-0813",
          "855-0023",
          "855-0015",
          "855-0046",
          "855-0853",
          "855-0045",
          "855-0071",
          "855-0872",
          "855-0817",
          "855-0056",
          "855-0067",
          "855-0059",
          "855-0816",
          "855-0017",
          "855-0878",
          "855-0012",
          "855-0011",
          "855-0066",
          "855-0064",
          "855-0042",
          "855-0881",
          "855-0874",
          "855-0076",
          "855-0808",
          "855-0004",
          "855-0873",
          "855-0886",
          "855-0078",
          "855-0058",
          "855-0032",
          "855-0841",
          "855-0026",
          "855-0836",
          "855-0856",
          "855-0832",
          "855-0842",
          "855-0833",
          "855-0035",
          "855-0809",
          "855-0051",
          "855-0006",
          "855-0055",
          "855-0052",
          "855-0075",
          "855-0861",
          "855-0014",
          "855-0053",
          "855-0036",
          "855-0885",
          "855-0807",
          "855-0811",
          "855-0074",
          "855-0057",
          "855-0043",
          "855-0033",
          "855-0803",
          "855-0862",
          "855-0843",
          "855-0863",
          "855-0068",
          "855-0801",
          "855-0025",
          "855-0034",
          "855-0864",
          "855-0007",
          "855-0814",
          "855-0852",
          "855-0883",
          "855-0875",
          "855-0061",
          "855-0822",
          "855-0001",
          "855-0005",
          "855-0806",
          "855-0044",
          "855-0022",
          "855-0018",
          "855-0835",
          "855-0884",
          "855-0854",
          "855-0851",
          "855-0824",
          "855-0877",
          "855-0008",
          "855-0063",
          "855-0013",
          "855-0024",
          "855-0825",
          "855-0882",
          "855-0865",
          "855-0054",
          "855-0879",
          "855-0802",
          "855-0805",
          "855-0073",
          "855-0062",
          "855-0031",
          "855-0003",
          "855-0867",
          "855-0821",
          "855-0823",
          "855-0831",
          "855-0876",
          "855-0065",
          "855-0887",
          "855-0871",
          "855-0866",
          "855-0077",
          "855-0041",
          "855-0072",
          "855-0815",
          "855-0834",
          "855-0016",
          "855-0804",
          "855-0812",
          "854-0000",
          "854-0068",
          "854-0032",
          "854-0027",
          "859-0311",
          "854-1125",
          "854-1104",
          "854-1105",
          "854-1124",
          "854-1114",
          "854-1121",
          "854-1122",
          "854-1123",
          "854-1113",
          "854-1103",
          "854-1101",
          "854-1112",
          "854-1111",
          "854-1102",
          "854-0003",
          "854-0042",
          "854-0121",
          "854-0061",
          "854-0071",
          "854-0072",
          "854-0081",
          "854-0087",
          "859-0315",
          "854-0053",
          "859-0314",
          "854-0031",
          "854-0034",
          "854-0062",
          "854-0069",
          "854-0063",
          "854-0004",
          "854-0095",
          "854-0024",
          "854-0037",
          "854-0052",
          "854-0067",
          "854-0066",
          "854-0055",
          "854-0033",
          "854-0023",
          "859-0303",
          "854-0054",
          "859-0166",
          "859-0151",
          "859-0152",
          "859-0153",
          "859-0165",
          "859-0154",
          "859-0161",
          "859-0162",
          "859-0163",
          "859-0167",
          "859-0164",
          "854-0022",
          "854-0013",
          "859-0305",
          "854-0096",
          "859-0302",
          "854-0077",
          "859-0307",
          "859-0304",
          "859-0306",
          "854-0005",
          "854-0045",
          "859-0121",
          "859-0111",
          "859-0171",
          "859-0101",
          "859-0102",
          "859-0146",
          "859-0141",
          "859-0122",
          "859-0142",
          "859-0131",
          "859-0103",
          "859-0112",
          "859-0123",
          "859-0143",
          "859-0124",
          "859-0132",
          "859-0113",
          "859-0125",
          "859-0104",
          "859-0115",
          "859-0114",
          "859-0126",
          "859-0133",
          "859-0116",
          "859-0106",
          "859-0105",
          "859-0127",
          "859-0147",
          "859-0144",
          "859-0117",
          "859-0145",
          "854-0016",
          "854-0043",
          "859-0403",
          "859-0402",
          "859-0406",
          "859-0401",
          "859-0418",
          "859-0407",
          "859-0405",
          "859-0404",
          "859-0412",
          "859-0416",
          "859-0413",
          "859-0411",
          "859-0417",
          "859-0414",
          "859-0415",
          "854-0038",
          "854-0065",
          "854-0083",
          "854-0122",
          "854-0123",
          "854-0006",
          "854-0076",
          "854-0091",
          "854-0021",
          "854-0073",
          "859-0313",
          "859-0301",
          "854-0124",
          "854-0036",
          "854-0082",
          "854-0015",
          "854-0044",
          "859-0312",
          "854-0047",
          "854-0056",
          "854-0011",
          "854-0125",
          "854-0046",
          "854-0014",
          "854-0026",
          "854-0002",
          "854-0057",
          "854-0001",
          "854-0041",
          "854-0086",
          "854-0012",
          "854-0094",
          "854-0084",
          "854-0126",
          "854-0075",
          "854-0035",
          "854-0007",
          "854-0093",
          "854-0209",
          "854-0206",
          "854-0208",
          "854-0207",
          "854-0202",
          "854-0201",
          "854-0205",
          "854-0204",
          "854-0203",
          "854-0025",
          "854-0074",
          "854-0092",
          "854-0064",
          "854-0051",
          "854-0085",
          "856-0000",
          "856-0048",
          "856-0017",
          "856-0033",
          "856-0026",
          "856-0029",
          "856-0823",
          "856-0818",
          "856-0018",
          "856-0843",
          "856-0044",
          "856-0027",
          "856-0804",
          "856-0845",
          "856-0043",
          "856-0809",
          "856-0021",
          "856-0020",
          "856-0025",
          "856-0802",
          "856-0841",
          "856-0827",
          "856-0833",
          "856-0023",
          "856-0820",
          "856-0828",
          "856-0007",
          "856-0834",
          "856-0835",
          "856-0012",
          "856-0808",
          "856-0817",
          "856-0046",
          "856-0836",
          "856-0028",
          "856-0812",
          "856-0031",
          "856-0011",
          "856-0801",
          "856-0047",
          "856-0024",
          "856-0847",
          "856-0035",
          "856-0805",
          "856-0803",
          "856-0014",
          "856-0041",
          "856-0806",
          "856-0842",
          "856-0013",
          "856-0821",
          "856-0813",
          "856-0825",
          "856-0837",
          "856-0003",
          "856-0019",
          "856-0811",
          "856-0016",
          "856-0032",
          "856-0826",
          "856-0002",
          "856-0831",
          "856-0846",
          "856-0042",
          "856-0006",
          "856-0822",
          "856-0832",
          "856-0022",
          "856-0814",
          "856-0008",
          "856-0009",
          "856-0829",
          "856-0816",
          "856-0824",
          "856-0034",
          "856-0844",
          "856-0807",
          "856-0015",
          "856-0005",
          "856-0045",
          "856-0001",
          "856-0815",
          "856-0004",
          "859-5100",
          "859-5384",
          "859-5122",
          "859-5515",
          "859-5382",
          "859-5701",
          "859-5702",
          "859-5703",
          "859-5705",
          "859-5707",
          "859-5706",
          "859-5704",
          "859-5502",
          "859-5121",
          "859-5117",
          "859-5111",
          "859-5376",
          "859-5383",
          "859-5102",
          "859-5516",
          "859-5532",
          "859-5805",
          "859-5806",
          "859-5804",
          "859-5801",
          "859-5803",
          "859-5802",
          "859-5123",
          "859-5131",
          "859-5534",
          "859-5152",
          "859-5373",
          "859-5524",
          "859-5503",
          "859-5132",
          "859-5362",
          "859-5113",
          "859-5363",
          "859-5522",
          "859-5118",
          "859-5365",
          "859-5151",
          "859-5104",
          "859-5505",
          "859-5371",
          "859-5533",
          "859-5511",
          "859-5504",
          "859-5144",
          "859-5142",
          "859-5116",
          "859-5115",
          "859-5372",
          "859-5101",
          "859-5527",
          "859-5103",
          "859-4822",
          "859-4814",
          "859-4821",
          "859-4823",
          "859-4804",
          "859-4803",
          "859-4824",
          "859-4807",
          "859-4806",
          "859-4815",
          "859-4801",
          "859-4812",
          "859-4826",
          "859-4813",
          "859-4802",
          "859-4811",
          "859-4805",
          "859-4825",
          "859-4827",
          "859-5114",
          "859-5513",
          "859-5501",
          "859-5512",
          "859-5153",
          "859-5133",
          "859-5526",
          "859-5381",
          "859-5535",
          "859-5531",
          "859-5525",
          "859-5361",
          "859-5374",
          "859-5514",
          "859-5521",
          "859-5145",
          "859-5375",
          "859-5143",
          "859-5366",
          "859-5523",
          "859-5134",
          "859-5112",
          "859-5364",
          "859-5141",
          "859-4500",
          "859-4528",
          "859-4521",
          "859-4524",
          "859-4526",
          "859-4525",
          "859-4529",
          "859-4523",
          "859-4522",
          "859-4527",
          "859-4511",
          "859-4518",
          "859-4501",
          "859-4504",
          "859-4502",
          "859-4507",
          "859-4506",
          "859-4503",
          "859-4513",
          "859-4516",
          "859-4505",
          "859-4515",
          "859-4512",
          "859-4514",
          "859-4517",
          "859-4301",
          "859-4302",
          "859-4309",
          "859-4303",
          "859-4304",
          "859-4307",
          "859-4305",
          "859-4306",
          "859-4308",
          "859-4533",
          "859-4532",
          "859-4536",
          "859-4534",
          "859-4531",
          "859-4535",
          "848-0404",
          "848-0401",
          "848-0408",
          "848-0403",
          "848-0405",
          "848-0407",
          "848-0402",
          "848-0406",
          "859-4745",
          "859-4741",
          "859-4743",
          "859-4744",
          "859-4742",
          "859-4761",
          "859-4751",
          "859-4777",
          "859-4758",
          "859-4773",
          "859-4764",
          "859-4767",
          "859-4754",
          "859-4775",
          "859-4776",
          "859-4762",
          "859-4765",
          "859-4752",
          "859-4771",
          "859-4757",
          "859-4778",
          "859-4774",
          "859-4772",
          "859-4753",
          "859-4769",
          "859-4768",
          "859-4766",
          "859-4756",
          "859-4763",
          "859-4755",
          "817-0000",
          "817-0034",
          "817-0153",
          "817-0241",
          "817-0021",
          "817-0157",
          "817-0033",
          "817-0024",
          "817-0243",
          "817-0006",
          "817-0032",
          "817-0031",
          "817-0245",
          "817-0244",
          "817-0035",
          "817-0246",
          "817-0001",
          "817-0022",
          "817-0248",
          "817-0005",
          "817-0156",
          "817-0247",
          "817-0242",
          "817-0023",
          "817-0154",
          "817-0155",
          "817-0152",
          "817-0014",
          "817-0013",
          "817-0003",
          "817-0015",
          "817-0016",
          "817-0012",
          "817-0002",
          "817-0011",
          "817-0151",
          "817-1532",
          "817-1524",
          "817-1513",
          "817-1521",
          "817-1522",
          "817-1512",
          "817-1531",
          "817-1603",
          "817-1602",
          "817-1511",
          "817-1533",
          "817-1523",
          "817-1601",
          "817-1525",
          "817-2243",
          "817-1704",
          "817-1725",
          "817-1722",
          "817-1715",
          "817-2241",
          "817-1721",
          "817-2331",
          "817-1714",
          "817-2332",
          "817-2333",
          "817-1712",
          "817-1711",
          "817-1724",
          "817-1703",
          "817-1713",
          "817-1701",
          "817-2242",
          "817-1702",
          "817-1723",
          "817-1231",
          "817-1253",
          "817-1252",
          "817-1241",
          "817-1233",
          "817-1245",
          "817-1256",
          "817-1232",
          "817-1234",
          "817-1254",
          "817-1255",
          "817-1212",
          "817-1251",
          "817-1213",
          "817-1201",
          "817-1246",
          "817-1257",
          "817-1214",
          "817-1223",
          "817-1202",
          "817-1106",
          "817-0432",
          "817-0323",
          "817-0325",
          "817-0431",
          "817-1105",
          "817-0433",
          "817-1107",
          "817-1103",
          "817-0324",
          "817-0512",
          "817-0322",
          "817-1101",
          "817-0514",
          "817-0321",
          "817-0511",
          "817-0326",
          "817-1104",
          "817-0513",
          "817-0434",
          "817-0435",
          "817-1102",
          "817-1304",
          "817-1307",
          "817-1302",
          "817-1303",
          "817-1411",
          "817-1412",
          "817-1413",
          "817-1305",
          "817-1301",
          "817-1306",
          "811-5100",
          "811-5301",
          "811-5733",
          "811-5731",
          "811-5732",
          "811-5734",
          "811-5744",
          "811-5742",
          "811-5743",
          "811-5741",
          "811-5461",
          "811-5751",
          "811-5757",
          "811-5752",
          "811-5756",
          "811-5467",
          "811-5465",
          "811-5462",
          "811-5464",
          "811-5463",
          "811-5466",
          "811-5468",
          "811-5321",
          "811-5322",
          "811-5324",
          "811-5323",
          "811-5326",
          "811-5325",
          "811-5316",
          "811-5313",
          "811-5314",
          "811-5315",
          "811-5311",
          "811-5312",
          "811-5755",
          "811-5754",
          "811-5753",
          "811-5222",
          "811-5224",
          "811-5221",
          "811-5215",
          "811-5211",
          "811-5214",
          "811-5223",
          "811-5202",
          "811-5204",
          "811-5203",
          "811-5212",
          "811-5213",
          "811-5201",
          "811-5226",
          "811-5225",
          "811-5543",
          "811-5532",
          "811-5523",
          "811-5501",
          "811-5513",
          "811-5521",
          "811-5531",
          "811-5533",
          "811-5522",
          "811-5554",
          "811-5556",
          "811-5553",
          "811-5555",
          "811-5511",
          "811-5512",
          "811-5544",
          "811-5546",
          "811-5541",
          "811-5542",
          "811-5545",
          "811-5551",
          "811-5552",
          "811-5107",
          "811-5113",
          "811-5112",
          "811-5161",
          "811-5136",
          "811-5115",
          "811-5123",
          "811-5135",
          "811-5105",
          "811-5106",
          "811-5104",
          "811-5125",
          "811-5124",
          "811-5134",
          "811-5103",
          "811-5122",
          "811-5117",
          "811-5142",
          "811-5162",
          "811-5131",
          "811-5102",
          "811-5101",
          "811-5143",
          "811-5144",
          "811-5163",
          "811-5111",
          "811-5132",
          "811-5121",
          "811-5133",
          "811-5155",
          "811-5116",
          "811-5114",
          "811-5141",
          "811-5151",
          "811-5153",
          "811-5154",
          "811-5152",
          "853-0000",
          "853-0062",
          "853-0018",
          "853-2174",
          "853-2481",
          "853-0006",
          "853-0061",
          "853-0032",
          "853-0053",
          "853-0025",
          "853-0013",
          "853-0023",
          "853-0702",
          "853-0701",
          "853-0703",
          "853-0704",
          "853-0706",
          "853-0705",
          "853-0312",
          "853-0311",
          "853-0313",
          "853-0043",
          "853-0033",
          "853-0041",
          "853-0016",
          "853-0004",
          "853-0001",
          "853-0065",
          "853-0011",
          "853-0021",
          "853-0063",
          "853-0005",
          "853-0066",
          "853-2173",
          "853-0501",
          "853-0502",
          "853-0503",
          "853-0506",
          "853-0413",
          "853-0412",
          "853-0411",
          "853-0504",
          "853-0507",
          "853-0505",
          "853-0508",
          "853-0002",
          "853-0044",
          "853-0054",
          "853-0205",
          "853-0208",
          "853-0211",
          "853-0204",
          "853-0215",
          "853-0203",
          "853-0213",
          "853-0214",
          "853-0201",
          "853-0207",
          "853-0202",
          "853-0212",
          "853-0206",
          "853-0012",
          "853-2201",
          "853-2202",
          "853-2203",
          "853-2204",
          "853-0003",
          "853-0024",
          "853-0026",
          "853-0015",
          "853-2171",
          "853-0051",
          "853-0007",
          "853-0017",
          "853-0027",
          "853-0052",
          "853-0606",
          "853-0602",
          "853-0604",
          "853-0603",
          "853-0611",
          "853-0613",
          "853-0612",
          "853-0607",
          "853-0608",
          "853-0605",
          "853-0601",
          "853-0609",
          "853-0064",
          "853-0014",
          "853-0022",
          "853-2482",
          "853-0031",
          "853-0042",
          "853-2172",
          "851-3500",
          "857-2427",
          "857-2402",
          "857-2426",
          "857-2422",
          "857-2401",
          "857-2424",
          "857-2425",
          "857-2405",
          "857-2411",
          "857-2423",
          "857-2418",
          "857-2421",
          "857-2419",
          "857-2403",
          "857-2412",
          "857-2413",
          "857-2417",
          "857-2301",
          "857-2302",
          "857-2304",
          "857-2303",
          "857-2305",
          "857-2306",
          "857-2307",
          "857-2312",
          "857-2311",
          "857-2531",
          "857-2532",
          "857-2324",
          "857-2327",
          "857-2322",
          "857-2323",
          "857-2321",
          "857-2325",
          "857-2326",
          "857-2328",
          "851-3507",
          "851-3503",
          "851-3505",
          "851-3508",
          "851-3502",
          "851-3506",
          "851-3504",
          "851-3501",
          "857-2222",
          "857-2221",
          "857-2223",
          "851-3511",
          "851-3509",
          "857-3103",
          "857-3101",
          "857-3311",
          "857-3102",
          "851-3421",
          "851-3424",
          "851-3313",
          "851-3304",
          "851-3303",
          "851-3422",
          "851-3305",
          "851-3311",
          "851-3314",
          "851-3312",
          "851-3306",
          "851-3406",
          "851-3302",
          "851-3315",
          "851-3425",
          "851-3301",
          "851-3423",
          "854-0500",
          "854-0302",
          "854-0301",
          "859-1116",
          "859-1107",
          "859-1115",
          "859-1106",
          "859-1114",
          "859-1112",
          "859-1102",
          "859-1105",
          "859-1113",
          "859-1111",
          "859-1103",
          "859-1104",
          "859-1101",
          "854-0621",
          "854-0501",
          "854-0504",
          "854-0512",
          "854-0515",
          "854-0514",
          "854-0505",
          "854-0503",
          "854-0516",
          "854-0517",
          "854-0511",
          "854-0513",
          "854-0502",
          "859-1302",
          "859-1306",
          "859-1301",
          "859-1307",
          "859-1308",
          "859-1304",
          "859-1303",
          "859-1305",
          "859-1322",
          "859-1321",
          "859-1324",
          "859-1323",
          "859-1325",
          "859-1312",
          "859-1316",
          "859-1311",
          "859-1317",
          "859-1314",
          "859-1313",
          "859-1315",
          "854-0402",
          "854-0406",
          "854-0401",
          "854-0407",
          "854-0404",
          "854-0403",
          "854-0405",
          "859-1214",
          "859-1213",
          "859-1216",
          "859-1215",
          "859-1203",
          "859-1212",
          "859-1202",
          "859-1201",
          "859-1206",
          "859-1205",
          "859-1204",
          "859-1211",
          "854-0702",
          "854-0701",
          "854-0703",
          "859-2600",
          "859-2121",
          "859-2122",
          "859-2203",
          "859-2204",
          "859-2201",
          "859-2205",
          "859-2206",
          "859-2123",
          "859-2202",
          "859-2605",
          "859-2601",
          "859-2606",
          "859-2603",
          "859-2604",
          "859-2602",
          "859-2302",
          "859-2306",
          "859-2301",
          "859-2304",
          "859-2303",
          "859-2305",
          "859-2501",
          "859-2502",
          "859-2503",
          "859-2504",
          "859-2211",
          "859-2214",
          "859-2212",
          "859-2216",
          "859-2215",
          "859-2213",
          "859-1502",
          "859-1501",
          "859-1504",
          "859-1503",
          "859-1505",
          "859-2112",
          "859-2111",
          "859-2113",
          "859-2412",
          "859-2316",
          "859-2416",
          "859-2411",
          "859-2414",
          "859-2413",
          "859-2415",
          "851-2100",
          "851-2128",
          "851-2121",
          "851-2127",
          "851-2129",
          "851-2123",
          "851-2131",
          "851-2122",
          "851-2130",
          "851-2124",
          "851-2125",
          "851-2126",
          "851-2105",
          "851-2107",
          "851-2106",
          "851-2111",
          "851-2101",
          "851-2104",
          "851-2102",
          "851-2108",
          "851-2103",
          "859-3800",
          "859-3811",
          "859-3926",
          "859-3805",
          "859-3809",
          "859-3808",
          "859-3812",
          "859-3931",
          "859-3802",
          "859-3929",
          "859-3803",
          "859-3923",
          "859-3807",
          "859-3927",
          "859-3924",
          "859-3921",
          "859-3932",
          "859-3801",
          "859-3925",
          "859-3922",
          "859-3933",
          "859-3928",
          "859-3804",
          "859-3806",
          "859-3600",
          "859-3604",
          "859-3601",
          "859-3603",
          "859-3618",
          "859-3613",
          "859-3612",
          "859-3606",
          "859-3602",
          "859-3608",
          "859-3615",
          "859-3616",
          "859-3607",
          "859-3619",
          "859-3614",
          "859-3611",
          "859-3617",
          "859-3605",
          "859-3700",
          "859-3711",
          "859-3713",
          "859-3701",
          "859-3714",
          "859-3721",
          "859-3704",
          "859-3727",
          "859-3724",
          "859-3715",
          "859-3722",
          "859-3716",
          "859-3712",
          "859-3705",
          "859-3725",
          "859-3703",
          "859-3726",
          "859-3723",
          "859-3706",
          "859-3728",
          "859-3702",
          "857-4700",
          "857-4708",
          "857-4706",
          "857-4703",
          "857-4711",
          "857-4709",
          "857-4705",
          "857-4701",
          "857-4702",
          "857-4707",
          "857-4712",
          "857-4704",
          "857-0300",
          "857-0334",
          "857-0321",
          "857-0312",
          "857-0323",
          "857-0324",
          "857-0353",
          "857-0335",
          "857-0313",
          "857-0352",
          "857-0332",
          "857-0336",
          "857-0361",
          "857-0343",
          "857-0315",
          "857-0351",
          "857-0338",
          "857-0333",
          "857-0331",
          "857-0341",
          "857-0342",
          "857-0314",
          "857-0311",
          "857-0322",
          "857-0344",
          "857-0337",
          "857-4400",
          "857-4411",
          "857-4404",
          "857-4101",
          "853-3322",
          "857-4401",
          "853-2304",
          "857-4211",
          "853-2313",
          "857-4414",
          "857-4413",
          "853-3102",
          "857-4511",
          "857-4512",
          "857-4103",
          "857-4213",
          "857-4212",
          "853-2302",
          "857-4601",
          "853-2311",
          "853-2303",
          "857-4602",
          "853-3321",
          "857-4603",
          "857-4415",
          "857-4604",
          "857-4102",
          "857-4214",
          "857-4402",
          "853-3101",
          "853-2305",
          "857-4514",
          "853-3323",
          "853-2312",
          "857-4405",
          "853-2315",
          "857-4513",
          "857-4412",
          "857-4416",
          "853-2314",
          "853-2301",
          "861-0000",
          "860-0801",
          "860-0841",
          "862-0941",
          "860-0043",
          "860-0031",
          "860-0077",
          "862-0942",
          "862-0971",
          "862-0973",
          "862-0958",
          "862-0924",
          "860-0026",
          "860-0021",
          "862-0953",
          "862-0951",
          "860-0845",
          "860-0847",
          "860-0804",
          "860-0039",
          "860-0023",
          "860-0855",
          "860-0078",
          "860-0081",
          "860-0843",
          "862-0976",
          "860-0862",
          "862-0954",
          "862-0955",
          "860-0014",
          "860-0033",
          "860-0012",
          "860-0025",
          "860-0851",
          "862-0949",
          "862-0948",
          "860-0042",
          "860-0003",
          "860-0076",
          "862-0909",
          "860-0813",
          "860-0814",
          "860-0035",
          "860-0029",
          "860-0041",
          "860-0805",
          "862-0922",
          "860-0073",
          "860-0807",
          "860-0824",
          "860-0825",
          "860-0846",
          "862-0972",
          "860-0011",
          "860-0803",
          "860-0004",
          "862-0975",
          "862-0950",
          "862-0956",
          "860-0844",
          "862-0957",
          "860-0019",
          "860-0018",
          "860-0006",
          "860-0001",
          "860-0802",
          "860-0863",
          "860-0808",
          "860-0013",
          "862-0970",
          "860-0028",
          "860-0037",
          "860-0853",
          "860-0027",
          "860-0008",
          "860-0832",
          "862-0959",
          "860-0831",
          "860-0806",
          "860-0815",
          "860-0034",
          "862-0923",
          "860-0854",
          "860-0038",
          "860-0015",
          "860-0007",
          "860-0036",
          "860-0833",
          "862-0926",
          "860-0811",
          "860-0816",
          "860-0002",
          "860-0024",
          "860-0812",
          "860-0842",
          "860-0848",
          "860-0005",
          "860-0856",
          "860-0817",
          "861-8072",
          "860-0821",
          "860-0822",
          "860-0852",
          "860-0016",
          "860-0818",
          "860-0022",
          "860-0046",
          "860-0823",
          "860-0032",
          "860-0017",
          "861-2104",
          "861-2107",
          "861-2105",
          "861-8046",
          "861-8014",
          "862-0961",
          "862-0944",
          "862-0947",
          "862-0943",
          "862-0945",
          "862-0946",
          "862-0917",
          "862-0913",
          "862-0933",
          "861-8045",
          "861-8030",
          "861-8011",
          "861-8010",
          "861-8017",
          "862-0952",
          "862-0911",
          "862-0910",
          "861-8044",
          "861-8035",
          "862-0904",
          "861-2101",
          "862-0916",
          "862-0960",
          "861-8019",
          "861-2108",
          "862-0908",
          "861-8028",
          "862-0921",
          "862-0907",
          "862-0920",
          "861-8041",
          "861-8043",
          "861-8042",
          "861-8031",
          "861-8015",
          "861-8037",
          "861-8038",
          "861-8039",
          "862-0912",
          "861-8029",
          "861-2102",
          "861-8034",
          "861-2118",
          "862-0918",
          "861-2106",
          "862-0902",
          "862-0901",
          "861-8012",
          "862-0906",
          "862-0925",
          "862-0905",
          "862-0914",
          "862-0915",
          "861-8013",
          "861-8016",
          "862-0903",
          "861-2103",
          "860-0071",
          "860-0082",
          "860-0048",
          "861-5273",
          "861-5287",
          "861-5285",
          "861-5284",
          "860-0047",
          "860-0079",
          "860-0068",
          "860-0061",
          "861-5289",
          "861-5341",
          "861-5345",
          "861-5346",
          "861-5348",
          "861-5344",
          "861-5342",
          "861-5343",
          "861-5347",
          "860-0067",
          "860-0063",
          "860-0066",
          "860-0064",
          "860-0065",
          "860-0056",
          "861-5274",
          "860-0062",
          "860-0053",
          "860-0052",
          "860-0058",
          "860-0044",
          "860-0088",
          "860-0074",
          "860-0045",
          "861-5272",
          "861-5271",
          "861-5286",
          "861-5288",
          "860-0051",
          "860-0059",
          "860-0072",
          "860-0075",
          "861-5280",
          "861-5281",
          "861-5282",
          "860-0054",
          "860-0057",
          "860-0055",
          "861-4121",
          "861-4136",
          "862-0963",
          "861-5251",
          "861-4124",
          "861-4131",
          "861-4127",
          "860-0834",
          "861-4125",
          "861-4132",
          "861-4134",
          "861-4123",
          "861-4115",
          "861-4111",
          "861-4108",
          "861-4117",
          "861-4133",
          "861-4231",
          "861-4224",
          "861-4205",
          "861-4213",
          "861-4211",
          "861-4203",
          "861-4201",
          "861-4206",
          "861-4215",
          "861-4236",
          "861-4204",
          "861-4221",
          "861-4232",
          "861-4235",
          "861-4212",
          "861-4226",
          "861-4234",
          "861-4233",
          "861-4225",
          "861-4223",
          "861-4214",
          "861-4202",
          "861-4237",
          "861-4222",
          "861-4112",
          "861-5264",
          "861-5255",
          "861-4126",
          "862-0965",
          "862-0962",
          "862-0966",
          "861-4101",
          "861-5252",
          "861-4135",
          "861-4146",
          "861-4145",
          "861-4141",
          "861-4165",
          "861-4143",
          "861-4151",
          "861-4153",
          "861-4161",
          "861-4166",
          "861-4157",
          "861-4162",
          "861-4167",
          "861-4163",
          "861-4144",
          "861-4152",
          "861-4142",
          "861-4156",
          "861-4164",
          "861-4154",
          "861-4147",
          "861-4155",
          "861-4116",
          "861-5263",
          "861-4137",
          "861-4114",
          "861-5265",
          "861-5253",
          "861-5262",
          "861-4109",
          "860-0826",
          "861-5254",
          "862-0968",
          "861-4122",
          "861-4106",
          "861-4104",
          "861-4102",
          "861-4103",
          "861-4173",
          "861-4171",
          "861-4172",
          "861-5261",
          "861-4105",
          "861-4113",
          "862-0969",
          "862-0967",
          "861-8081",
          "861-5501",
          "861-5533",
          "861-0142",
          "861-0123",
          "861-0124",
          "861-0113",
          "861-0104",
          "861-0136",
          "861-0132",
          "861-0152",
          "861-0156",
          "861-0102",
          "861-0153",
          "861-0126",
          "861-0145",
          "861-0125",
          "861-0127",
          "861-0151",
          "861-0103",
          "861-0161",
          "861-0122",
          "861-0116",
          "861-0117",
          "861-0164",
          "861-0143",
          "861-0112",
          "861-0133",
          "861-0155",
          "861-0162",
          "861-0163",
          "861-0106",
          "861-0141",
          "861-0154",
          "861-0135",
          "861-0121",
          "861-0144",
          "861-0165",
          "861-0131",
          "861-0114",
          "861-0146",
          "861-0105",
          "861-0111",
          "861-0134",
          "861-0101",
          "861-0115",
          "861-8082",
          "860-0086",
          "860-0083",
          "861-5502",
          "861-5512",
          "861-5521",
          "861-5534",
          "861-5531",
          "861-8003",
          "861-5511",
          "860-0861",
          "861-5504",
          "861-8084",
          "861-8066",
          "861-8075",
          "861-8065",
          "861-8074",
          "861-8068",
          "860-0087",
          "861-8073",
          "861-8071",
          "861-5526",
          "861-5522",
          "861-5524",
          "860-0085",
          "861-8006",
          "861-8005",
          "861-8007",
          "861-5532",
          "861-5517",
          "861-5513",
          "861-5525",
          "861-5523",
          "861-5516",
          "861-8083",
          "861-8064",
          "861-5514",
          "861-5537",
          "861-5535",
          "861-8001",
          "861-5503",
          "860-0084",
          "861-8002",
          "861-5515",
          "861-5536",
          "866-0000",
          "869-5152",
          "866-0844",
          "866-0893",
          "866-0011",
          "869-4501",
          "869-4401",
          "869-4402",
          "869-4513",
          "869-4514",
          "869-4403",
          "869-4515",
          "869-4511",
          "869-4512",
          "866-0825",
          "866-0081",
          "866-0083",
          "866-0084",
          "866-0085",
          "866-0035",
          "866-0852",
          "866-0895",
          "869-4611",
          "869-4613",
          "869-4612",
          "866-0013",
          "869-4213",
          "869-4202",
          "869-4223",
          "869-4203",
          "869-4201",
          "869-4211",
          "869-4225",
          "869-4224",
          "869-4204",
          "869-4212",
          "869-4215",
          "869-4214",
          "869-4205",
          "869-4221",
          "869-4222",
          "866-0813",
          "866-0824",
          "869-4615",
          "869-4616",
          "866-0865",
          "869-5162",
          "869-5166",
          "866-0024",
          "866-0023",
          "866-0022",
          "866-0021",
          "866-0008",
          "866-0007",
          "866-0006",
          "866-0005",
          "866-0004",
          "866-0003",
          "866-0002",
          "866-0001",
          "866-0071",
          "866-0072",
          "866-0881",
          "866-0012",
          "866-0894",
          "869-4614",
          "866-0897",
          "866-0898",
          "866-0892",
          "866-0891",
          "866-0845",
          "869-6104",
          "869-6115",
          "869-6114",
          "869-6112",
          "869-5221",
          "869-5225",
          "869-5224",
          "869-6101",
          "869-6105",
          "869-5223",
          "869-5222",
          "869-6103",
          "869-6113",
          "869-6111",
          "869-6102",
          "866-0017",
          "866-0864",
          "869-5151",
          "866-0827",
          "866-0853",
          "866-0042",
          "866-0823",
          "869-4723",
          "869-4721",
          "869-4722",
          "866-0032",
          "866-0016",
          "866-0031",
          "866-0854",
          "866-0034",
          "866-0832",
          "866-0053",
          "866-0054",
          "869-4701",
          "869-4704",
          "869-4703",
          "869-4702",
          "869-5164",
          "866-0082",
          "869-5154",
          "866-0014",
          "866-0866",
          "866-0826",
          "866-0045",
          "866-0871",
          "866-0876",
          "866-0877",
          "866-0872",
          "866-0015",
          "866-0857",
          "869-4303",
          "869-4302",
          "869-4304",
          "869-4301",
          "866-0856",
          "866-0812",
          "866-0044",
          "866-0885",
          "866-0815",
          "866-0064",
          "866-0811",
          "866-0834",
          "866-0863",
          "866-0804",
          "866-0831",
          "866-0041",
          "866-0843",
          "866-0896",
          "866-0814",
          "866-0801",
          "866-0851",
          "869-5146",
          "869-5134",
          "869-5133",
          "869-5132",
          "869-5148",
          "869-5141",
          "869-5142",
          "869-5147",
          "869-5145",
          "869-5143",
          "869-5135",
          "869-5137",
          "869-5136",
          "869-5138",
          "869-5131",
          "869-5144",
          "866-0074",
          "866-0063",
          "866-0062",
          "866-0065",
          "866-0821",
          "866-0822",
          "866-0855",
          "869-5173",
          "869-5174",
          "869-5171",
          "869-5175",
          "869-5172",
          "866-0043",
          "866-0803",
          "866-0073",
          "866-0861",
          "866-0862",
          "866-0882",
          "866-0883",
          "866-0884",
          "869-5155",
          "869-5163",
          "866-0841",
          "866-0033",
          "869-5165",
          "866-0805",
          "866-0802",
          "866-0055",
          "866-0051",
          "866-0052",
          "869-5153",
          "866-0846",
          "866-0833",
          "866-0875",
          "866-0874",
          "866-0873",
          "869-5161",
          "866-0842",
          "866-0061",
          "868-0000",
          "868-0825",
          "868-0824",
          "868-0035",
          "868-0027",
          "868-0047",
          "868-0053",
          "868-0812",
          "868-0811",
          "868-0803",
          "868-0021",
          "868-0084",
          "868-0001",
          "868-0078",
          "868-0005",
          "868-0821",
          "868-0013",
          "868-0032",
          "868-0801",
          "868-0076",
          "868-0073",
          "868-0081",
          "868-0087",
          "868-0025",
          "868-0022",
          "868-0042",
          "868-0063",
          "868-0023",
          "868-0026",
          "868-0003",
          "868-0004",
          "868-0062",
          "868-0006",
          "868-0012",
          "868-0041",
          "868-0007",
          "868-0822",
          "868-0014",
          "868-0015",
          "868-0033",
          "868-0802",
          "868-0077",
          "868-0074",
          "868-0086",
          "868-0083",
          "868-0016",
          "868-0052",
          "868-0002",
          "868-0066",
          "868-0054",
          "868-0024",
          "868-0056",
          "868-0057",
          "868-0048",
          "868-0008",
          "868-0085",
          "868-0082",
          "868-0034",
          "868-0045",
          "868-0071",
          "868-0072",
          "868-0065",
          "868-0036",
          "868-0058",
          "868-0046",
          "868-0043",
          "868-0044",
          "868-0823",
          "868-0064",
          "868-0051",
          "868-0011",
          "868-0037",
          "868-0031",
          "868-0055",
          "868-0061",
          "868-0075",
          "868-0813",
          "864-0000",
          "864-0041",
          "864-0021",
          "864-0026",
          "864-0057",
          "864-0051",
          "864-0005",
          "864-0162",
          "864-0165",
          "864-0013",
          "864-0014",
          "864-0031",
          "864-0131",
          "864-0004",
          "864-0003",
          "864-0027",
          "864-0161",
          "864-0022",
          "864-0011",
          "864-0056",
          "864-0006",
          "864-0054",
          "864-0025",
          "864-0053",
          "864-0163",
          "864-0164",
          "864-0001",
          "864-0042",
          "864-0055",
          "864-0015",
          "864-0166",
          "864-0012",
          "864-0032",
          "864-0002",
          "864-0023",
          "864-0033",
          "864-0052",
          "867-0000",
          "867-0044",
          "867-0063",
          "867-0174",
          "867-0172",
          "867-0056",
          "867-0036",
          "867-0032",
          "867-0022",
          "867-0283",
          "867-0009",
          "867-0042",
          "867-0057",
          "867-0281",
          "867-0173",
          "867-0066",
          "867-0284",
          "867-0012",
          "867-0001",
          "867-0064",
          "867-0059",
          "867-0045",
          "867-0007",
          "867-0067",
          "867-0054",
          "867-0051",
          "867-0006",
          "867-0011",
          "867-0016",
          "867-0116",
          "867-0043",
          "867-0048",
          "867-0062",
          "867-0035",
          "867-0041",
          "867-0014",
          "867-0033",
          "867-0024",
          "867-0013",
          "867-0023",
          "867-0053",
          "867-0031",
          "867-0061",
          "867-0002",
          "867-0008",
          "867-0065",
          "867-0068",
          "867-0003",
          "867-0049",
          "867-0021",
          "867-0015",
          "867-0034",
          "867-0282",
          "867-0171",
          "867-0005",
          "867-0058",
          "867-0047",
          "867-0052",
          "867-0055",
          "867-0046",
          "867-0025",
          "867-0004",
          "865-0000",
          "865-0004",
          "865-0035",
          "865-0026",
          "865-0014",
          "865-0045",
          "865-0041",
          "865-0008",
          "865-0016",
          "865-0024",
          "865-0023",
          "865-0055",
          "865-0054",
          "865-0048",
          "865-0044",
          "865-0011",
          "865-0015",
          "865-0007",
          "865-0047",
          "865-0017",
          "865-0032",
          "865-0046",
          "865-0057",
          "865-0013",
          "865-0018",
          "865-0053",
          "869-0213",
          "869-0224",
          "869-0235",
          "869-0233",
          "869-0236",
          "869-0212",
          "869-0221",
          "869-0232",
          "869-0231",
          "869-0202",
          "869-0223",
          "869-0211",
          "869-0222",
          "869-0203",
          "869-0238",
          "869-0234",
          "869-0201",
          "865-0025",
          "865-0031",
          "865-0005",
          "865-0065",
          "865-0001",
          "865-0021",
          "865-0022",
          "861-5401",
          "861-5406",
          "861-5404",
          "861-5402",
          "861-5405",
          "861-5403",
          "865-0062",
          "865-0064",
          "865-0063",
          "865-0033",
          "865-0056",
          "865-0002",
          "865-0051",
          "865-0052",
          "865-0003",
          "865-0009",
          "865-0034",
          "865-0042",
          "865-0027",
          "865-0066",
          "865-0012",
          "865-0071",
          "865-0073",
          "865-0072",
          "865-0043",
          "865-0061",
          "865-0006",
          "865-0058",
          "861-0500",
          "861-0547",
          "861-0553",
          "861-0512",
          "861-0517",
          "861-0521",
          "861-0543",
          "861-0555",
          "861-0565",
          "861-0561",
          "861-0574",
          "861-0576",
          "861-0571",
          "861-0573",
          "861-0563",
          "861-0575",
          "861-0572",
          "861-0564",
          "861-0562",
          "861-0532",
          "861-0382",
          "861-0602",
          "861-0603",
          "861-0604",
          "861-0601",
          "861-0605",
          "861-0524",
          "861-0523",
          "861-0311",
          "861-0315",
          "861-0312",
          "861-0331",
          "861-0324",
          "861-0316",
          "861-0323",
          "861-0301",
          "861-0303",
          "861-0302",
          "861-0314",
          "861-0313",
          "861-0322",
          "861-0321",
          "861-0304",
          "861-0519",
          "861-0412",
          "861-0421",
          "861-0423",
          "861-0402",
          "861-0414",
          "861-0404",
          "861-0426",
          "861-0403",
          "861-0406",
          "861-0405",
          "861-0401",
          "861-0424",
          "861-0422",
          "861-0413",
          "861-0411",
          "861-0425",
          "861-0522",
          "861-0511",
          "861-0533",
          "861-0546",
          "861-0542",
          "861-0526",
          "861-0554",
          "861-0515",
          "861-0514",
          "861-0552",
          "861-0516",
          "861-0548",
          "861-0551",
          "861-0527",
          "861-0531",
          "861-0534",
          "861-0525",
          "861-0541",
          "861-0545",
          "861-0556",
          "861-0381",
          "861-0544",
          "861-0535",
          "861-0513",
          "861-0518",
          "861-0501",
          "861-1300",
          "861-1311",
          "861-1686",
          "861-1313",
          "861-1303",
          "861-1683",
          "861-1673",
          "861-1307",
          "861-1315",
          "861-1305",
          "861-1326",
          "869-1206",
          "869-1208",
          "869-1203",
          "869-1204",
          "869-1205",
          "869-1207",
          "869-1202",
          "869-1201",
          "861-1322",
          "861-1325",
          "861-1301",
          "861-1682",
          "861-1211",
          "861-1203",
          "861-1214",
          "861-1202",
          "861-1212",
          "861-1204",
          "861-1205",
          "861-1213",
          "861-1201",
          "861-1363",
          "861-1365",
          "861-1368",
          "861-1345",
          "861-1356",
          "861-1342",
          "861-1341",
          "861-1353",
          "861-1354",
          "861-1352",
          "861-1351",
          "861-1366",
          "861-1344",
          "861-1355",
          "861-1357",
          "861-1367",
          "861-1346",
          "861-1343",
          "861-1364",
          "861-1361",
          "861-1362",
          "861-1442",
          "861-1302",
          "861-1306",
          "861-1684",
          "861-1316",
          "861-1323",
          "861-1685",
          "861-1324",
          "861-1441",
          "861-1671",
          "861-1321",
          "861-1314",
          "861-1304",
          "861-1309",
          "861-1317",
          "861-1312",
          "861-1681",
          "861-1672",
          "861-1331",
          "861-1308",
          "869-0400",
          "869-3175",
          "869-0432",
          "869-0465",
          "869-0461",
          "869-0441",
          "869-0456",
          "869-0435",
          "869-0423",
          "869-0422",
          "869-0412",
          "869-0405",
          "869-0445",
          "869-0464",
          "869-3172",
          "869-0451",
          "869-0425",
          "869-0426",
          "869-0415",
          "869-0454",
          "869-0417",
          "869-0453",
          "869-0402",
          "869-0406",
          "869-3173",
          "869-0462",
          "869-0442",
          "869-0436",
          "869-0403",
          "869-0433",
          "869-0444",
          "869-0419",
          "869-0424",
          "869-0401",
          "869-0418",
          "869-0443",
          "869-0452",
          "869-0414",
          "869-0408",
          "869-0455",
          "869-3174",
          "869-3171",
          "869-0463",
          "869-0404",
          "869-0410",
          "869-0413",
          "869-0431",
          "869-0407",
          "869-0416",
          "869-0411",
          "869-0421",
          "869-0457",
          "869-0434",
          "869-3600",
          "869-3604",
          "869-3602",
          "869-3603",
          "869-3601",
          "869-3711",
          "866-0101",
          "866-0102",
          "861-6102",
          "861-6101",
          "861-6103",
          "861-6104",
          "861-6105",
          "866-0201",
          "866-0202",
          "866-0203",
          "869-0500",
          "869-0624",
          "869-0621",
          "869-0623",
          "869-0601",
          "869-0616",
          "869-0631",
          "869-0604",
          "869-0606",
          "869-0635",
          "869-0633",
          "869-0636",
          "869-0634",
          "869-0602",
          "869-0615",
          "869-0622",
          "869-0613",
          "869-0611",
          "869-0614",
          "869-0603",
          "869-0612",
          "869-0632",
          "869-0605",
          "869-0563",
          "869-3471",
          "869-3473",
          "869-0554",
          "869-0561",
          "869-0552",
          "869-0553",
          "869-0551",
          "869-0562",
          "869-3472",
          "861-4301",
          "861-4303",
          "861-4304",
          "861-4307",
          "861-4302",
          "861-4306",
          "861-4305",
          "869-0544",
          "869-0522",
          "869-0521",
          "869-0531",
          "869-0503",
          "869-0532",
          "869-0512",
          "869-0545",
          "869-0523",
          "869-0542",
          "869-0524",
          "869-0534",
          "869-0513",
          "869-0541",
          "869-0511",
          "869-0502",
          "869-0501",
          "869-0543",
          "869-0546",
          "869-0533",
          "869-3411",
          "869-3201",
          "869-3202",
          "869-3413",
          "869-3412",
          "869-3203",
          "869-3204",
          "869-3205",
          "869-3206",
          "869-3207",
          "869-2600",
          "869-2232",
          "869-2236",
          "869-2621",
          "869-2603",
          "869-2611",
          "869-2602",
          "869-2601",
          "869-2604",
          "869-2613",
          "869-2612",
          "869-2315",
          "869-2301",
          "869-2312",
          "869-2307",
          "869-2226",
          "869-2314",
          "869-2235",
          "869-2224",
          "869-2234",
          "869-2225",
          "869-2316",
          "869-2311",
          "869-2223",
          "869-2231",
          "869-2803",
          "869-2802",
          "869-2801",
          "869-2807",
          "869-2804",
          "869-2805",
          "869-2806",
          "869-2303",
          "869-2222",
          "869-2304",
          "869-2237",
          "869-2302",
          "869-2306",
          "869-2233",
          "869-2221",
          "869-2413",
          "869-2313",
          "869-2305",
          "863-0000",
          "863-2172",
          "863-2801",
          "863-1401",
          "863-2803",
          "863-2802",
          "863-1205",
          "863-2805",
          "863-2804",
          "863-2806",
          "861-7201",
          "861-7203",
          "861-7314",
          "861-7204",
          "861-7311",
          "861-7313",
          "861-7312",
          "861-7202",
          "863-2331",
          "863-2201",
          "863-2114",
          "863-2424",
          "863-2421",
          "863-0013",
          "863-0012",
          "863-1901",
          "863-0032",
          "863-0015",
          "863-1721",
          "863-0043",
          "863-0046",
          "863-1201",
          "863-1403",
          "863-1203",
          "863-1202",
          "863-1404",
          "863-1204",
          "863-1215",
          "863-1216",
          "863-1211",
          "863-1214",
          "863-1212",
          "863-1213",
          "863-0036",
          "863-0024",
          "863-0011",
          "863-0049",
          "863-0044",
          "863-1902",
          "861-6401",
          "861-6402",
          "861-6403",
          "866-0313",
          "866-0334",
          "866-0303",
          "863-0019",
          "863-2171",
          "863-0022",
          "863-0041",
          "861-6551",
          "863-0016",
          "863-0034",
          "863-1111",
          "863-0102",
          "863-0103",
          "863-0101",
          "863-1112",
          "861-6301",
          "861-6302",
          "861-6303",
          "861-6304",
          "861-6305",
          "863-0037",
          "863-0042",
          "863-0023",
          "863-0048",
          "863-0045",
          "863-0047",
          "863-0018",
          "863-0014",
          "863-0033",
          "863-1511",
          "863-1432",
          "863-1431",
          "863-0017",
          "863-0025",
          "863-0001",
          "863-0003",
          "863-0002",
          "863-0004",
          "863-0006",
          "863-0005",
          "863-0007",
          "863-0050",
          "863-0021",
          "863-0031",
          "863-0038",
          "863-1161",
          "863-0035",
          "861-1100",
          "861-1101",
          "861-1111",
          "861-1112",
          "861-1113",
          "861-1102",
          "861-1114",
          "861-1115",
          "861-1103",
          "861-1116",
          "861-1104",
          "861-1105",
          "861-4700",
          "861-4714",
          "861-4716",
          "861-4734",
          "861-4404",
          "861-4413",
          "861-4703",
          "861-4701",
          "861-4726",
          "861-4401",
          "861-4712",
          "861-4402",
          "861-4405",
          "861-4707",
          "861-4425",
          "861-4715",
          "861-4731",
          "861-4424",
          "861-4706",
          "861-4737",
          "861-4411",
          "861-4723",
          "861-4725",
          "861-4415",
          "861-4412",
          "861-4735",
          "861-4426",
          "861-4721",
          "861-4414",
          "861-4427",
          "861-4702",
          "861-4705",
          "861-4417",
          "861-4422",
          "861-4403",
          "861-4407",
          "861-4722",
          "861-4736",
          "861-4733",
          "861-4406",
          "861-4713",
          "861-4416",
          "861-4421",
          "861-4727",
          "861-4711",
          "861-4423",
          "861-4732",
          "861-4704",
          "869-0300",
          "869-0301",
          "869-0304",
          "869-0305",
          "869-0313",
          "869-0303",
          "869-0321",
          "869-0312",
          "869-0322",
          "869-0311",
          "869-0302",
          "861-0800",
          "861-0812",
          "861-0832",
          "861-0822",
          "861-0837",
          "861-0836",
          "861-0814",
          "861-0813",
          "861-0811",
          "861-0821",
          "861-0805",
          "861-0801",
          "861-0803",
          "861-0804",
          "861-0802",
          "861-0833",
          "861-0815",
          "861-0835",
          "861-0831",
          "861-0834",
          "861-0823",
          "869-0100",
          "869-0113",
          "869-0122",
          "869-0102",
          "869-0104",
          "869-0105",
          "869-0121",
          "869-0106",
          "869-0123",
          "869-0103",
          "869-0112",
          "869-0101",
          "869-0111",
          "865-0100",
          "861-0913",
          "861-0922",
          "865-0114",
          "865-0104",
          "865-0101",
          "865-0136",
          "865-0121",
          "861-0924",
          "865-0112",
          "865-0116",
          "861-0914",
          "861-0911",
          "861-0901",
          "865-0115",
          "865-0117",
          "865-0111",
          "865-0135",
          "865-0122",
          "861-0921",
          "865-0103",
          "861-0912",
          "861-0905",
          "861-0902",
          "861-0906",
          "861-0925",
          "865-0132",
          "865-0124",
          "861-0904",
          "865-0102",
          "865-0134",
          "861-0923",
          "865-0125",
          "865-0133",
          "865-0126",
          "865-0123",
          "865-0131",
          "865-0113",
          "861-0915",
          "861-0903",
          "869-1200",
          "869-1222",
          "869-1233",
          "869-1219",
          "869-1225",
          "869-1227",
          "869-1221",
          "869-1236",
          "869-1214",
          "869-1232",
          "869-1223",
          "869-1216",
          "869-1226",
          "869-1234",
          "869-1231",
          "869-1218",
          "869-1213",
          "869-1215",
          "869-1212",
          "869-1224",
          "869-1237",
          "869-1235",
          "869-1217",
          "869-1211",
          "869-1100",
          "869-1115",
          "869-1107",
          "869-1103",
          "869-1114",
          "869-1109",
          "869-1110",
          "869-1101",
          "869-1104",
          "869-1113",
          "869-1105",
          "869-1102",
          "869-1108",
          "869-1106",
          "869-1111",
          "869-1112",
          "869-2400",
          "869-2401",
          "869-2403",
          "869-2402",
          "869-2500",
          "869-2506",
          "869-2505",
          "869-2502",
          "869-2503",
          "869-2504",
          "869-2501",
          "869-2700",
          "869-2705",
          "869-2702",
          "869-2701",
          "869-2704",
          "869-2703",
          "869-1600",
          "869-1825",
          "869-1601",
          "869-1826",
          "869-1811",
          "869-1603",
          "869-1815",
          "869-1813",
          "869-1812",
          "869-1602",
          "869-1823",
          "869-1821",
          "869-1814",
          "869-1824",
          "869-1822",
          "861-2400",
          "861-2404",
          "861-2402",
          "861-2401",
          "861-2403",
          "861-2405",
          "869-1400",
          "869-1504",
          "869-1411",
          "869-1404",
          "869-1402",
          "869-1502",
          "869-1401",
          "869-1403",
          "869-2205",
          "869-1505",
          "869-1412",
          "869-1503",
          "869-1501",
          "861-3200",
          "861-3322",
          "861-3202",
          "861-3204",
          "861-3201",
          "861-3203",
          "861-3208",
          "861-3205",
          "861-3323",
          "861-3131",
          "861-3421",
          "861-3321",
          "861-3206",
          "861-3211",
          "861-3207",
          "861-3100",
          "861-3103",
          "861-3109",
          "861-3106",
          "861-3107",
          "861-3105",
          "861-3104",
          "861-3108",
          "861-3102",
          "861-3101",
          "861-2200",
          "861-2221",
          "861-2223",
          "861-2204",
          "861-2203",
          "861-2242",
          "861-2234",
          "861-2201",
          "861-2224",
          "861-2206",
          "861-2205",
          "861-2233",
          "861-2202",
          "861-2243",
          "861-2244",
          "861-2222",
          "861-2212",
          "861-2236",
          "861-2235",
          "861-2211",
          "861-2232",
          "861-2241",
          "861-2231",
          "861-4600",
          "861-4618",
          "861-4605",
          "861-3242",
          "861-4601",
          "861-4604",
          "861-4634",
          "861-4631",
          "861-4622",
          "861-4632",
          "861-3244",
          "861-4621",
          "861-3243",
          "861-3241",
          "861-4616",
          "861-4617",
          "861-4607",
          "861-4614",
          "861-4623",
          "861-4609",
          "861-4633",
          "861-4603",
          "861-4608",
          "861-4611",
          "861-4615",
          "861-4602",
          "861-4613",
          "861-4635",
          "861-4606",
          "861-3245",
          "861-4612",
          "861-3500",
          "861-3781",
          "861-3541",
          "861-3521",
          "861-3937",
          "861-3842",
          "861-3542",
          "861-3665",
          "861-3913",
          "861-3832",
          "861-3511",
          "861-3905",
          "861-3811",
          "861-3926",
          "861-3788",
          "861-3789",
          "861-3844",
          "861-3801",
          "861-3923",
          "861-3451",
          "861-3843",
          "861-3782",
          "861-3925",
          "861-3906",
          "861-3841",
          "861-3813",
          "861-3784",
          "861-3455",
          "861-3802",
          "861-3531",
          "861-3501",
          "861-3512",
          "861-3834",
          "861-3831",
          "861-3502",
          "861-3803",
          "861-3532",
          "861-3533",
          "861-3915",
          "861-3916",
          "861-3454",
          "861-3513",
          "861-3786",
          "861-3503",
          "861-3932",
          "861-3543",
          "861-3514",
          "861-3515",
          "861-3907",
          "861-3522",
          "861-3664",
          "861-3663",
          "861-3544",
          "861-3671",
          "861-3911",
          "861-3805",
          "861-3523",
          "861-3516",
          "861-3452",
          "861-3933",
          "861-3934",
          "861-3902",
          "861-3931",
          "861-3785",
          "861-3927",
          "861-3662",
          "861-3673",
          "861-3812",
          "861-3908",
          "861-3545",
          "861-3928",
          "861-3661",
          "861-3783",
          "861-3922",
          "861-3804",
          "861-3787",
          "861-3517",
          "861-3921",
          "861-3914",
          "861-3518",
          "861-3453",
          "861-3935",
          "861-3524",
          "861-3924",
          "861-3904",
          "861-3835",
          "861-3525",
          "861-3901",
          "861-3526",
          "861-3845",
          "861-3546",
          "861-3672",
          "861-3833",
          "861-3903",
          "861-3936",
          "861-3547",
          "861-3534",
          "861-3806",
          "861-3912",
          "869-4600",
          "869-4812",
          "869-4604",
          "869-4601",
          "869-4804",
          "869-4607",
          "869-4815",
          "869-4811",
          "869-4806",
          "869-4814",
          "869-4801",
          "869-4802",
          "869-4603",
          "869-4605",
          "869-4805",
          "869-4606",
          "869-4602",
          "869-4608",
          "869-4803",
          "869-4813",
          "869-5400",
          "869-5561",
          "869-5461",
          "869-6301",
          "869-6306",
          "869-5307",
          "869-5304",
          "869-6215",
          "869-6211",
          "869-6213",
          "869-5574",
          "869-5422",
          "869-6305",
          "869-5431",
          "869-6216",
          "869-6304",
          "869-6214",
          "869-5434",
          "869-5303",
          "869-5441",
          "869-6307",
          "869-6302",
          "869-5452",
          "869-6308",
          "869-5576",
          "869-5443",
          "869-5421",
          "869-5302",
          "869-5305",
          "869-6303",
          "869-5454",
          "869-5571",
          "869-5453",
          "869-5306",
          "869-5442",
          "869-5424",
          "869-5575",
          "869-5423",
          "869-5572",
          "869-5451",
          "869-5562",
          "869-5432",
          "869-5564",
          "869-5433",
          "869-5563",
          "869-5301",
          "869-6212",
          "869-5573",
          "869-5600",
          "869-5603",
          "869-5604",
          "869-5601",
          "869-5602",
          "869-5605",
          "868-0300",
          "868-0302",
          "868-0301",
          "868-0303",
          "868-0500",
          "868-0504",
          "868-0503",
          "868-0502",
          "868-0501",
          "868-0505",
          "868-0600",
          "868-0604",
          "868-0611",
          "868-0625",
          "868-0621",
          "868-0622",
          "868-0612",
          "868-0601",
          "868-0607",
          "868-0605",
          "868-0616",
          "868-0615",
          "868-0613",
          "868-0624",
          "868-0606",
          "868-0623",
          "868-0614",
          "868-0602",
          "868-0603",
          "868-0700",
          "868-0701",
          "868-0702",
          "868-0703",
          "868-0093",
          "868-0094",
          "868-0095",
          "868-0101",
          "868-0200",
          "868-0201",
          "868-0202",
          "868-0203",
          "868-0091",
          "868-0092",
          "869-6400",
          "869-6403",
          "869-6405",
          "869-6205",
          "869-6404",
          "869-6204",
          "869-6402",
          "869-6401",
          "868-0400",
          "868-0421",
          "868-0424",
          "868-0423",
          "868-0422",
          "868-0432",
          "868-0431",
          "868-0451",
          "868-0442",
          "868-0444",
          "868-0443",
          "868-0441",
          "868-0425",
          "868-0408",
          "868-0415",
          "863-2500",
          "863-2505",
          "863-2502",
          "863-2501",
          "863-2503",
          "863-2506",
          "863-2504",
          "863-2507",
          "863-2611",
          "870-0100",
          "870-0278",
          "870-0875",
          "870-0908",
          "870-0317",
          "870-0857",
          "870-0860",
          "870-0162",
          "870-0161",
          "870-0164",
          "870-0163",
          "870-0165",
          "870-0166",
          "870-0167",
          "870-0168",
          "870-0273",
          "870-0884",
          "870-0014",
          "870-0858",
          "879-7504",
          "870-0113",
          "870-0003",
          "870-0001",
          "870-0041",
          "870-1151",
          "870-0316",
          "870-0312",
          "870-0112",
          "879-2203",
          "870-0134",
          "870-1223",
          "870-0938",
          "870-1202",
          "870-0936",
          "870-0886",
          "870-0836",
          "870-0835",
          "870-0833",
          "870-0834",
          "870-0832",
          "879-7885",
          "870-0956",
          "870-0889",
          "870-0322",
          "870-0819",
          "870-0006",
          "870-0004",
          "870-0008",
          "870-0007",
          "870-0005",
          "870-0813",
          "870-0009",
          "870-0321",
          "870-0851",
          "870-0319",
          "870-0806",
          "870-0266",
          "870-0245",
          "870-0251",
          "870-0252",
          "870-0906",
          "870-1125",
          "870-1214",
          "870-0907",
          "870-0123",
          "870-0022",
          "879-2114",
          "870-0822",
          "870-0158",
          "870-1131",
          "870-0159",
          "870-1165",
          "870-1164",
          "879-7881",
          "870-1121",
          "870-0144",
          "870-0145",
          "870-0146",
          "870-0114",
          "870-1171",
          "870-1153",
          "870-1156",
          "870-1150",
          "870-0107",
          "870-0877",
          "870-0848",
          "870-0850",
          "870-0849",
          "870-0011",
          "870-0943",
          "870-0949",
          "870-0133",
          "870-0026",
          "870-0839",
          "870-0831",
          "870-0879",
          "870-0926",
          "870-0817",
          "870-0805",
          "870-1215",
          "870-1111",
          "879-7764",
          "870-1152",
          "870-1167",
          "870-0808",
          "879-7503",
          "879-2113",
          "870-0927",
          "870-0102",
          "870-0311",
          "870-0809",
          "870-1161",
          "870-0870",
          "870-0959",
          "870-0129",
          "870-1162",
          "870-0314",
          "870-0304",
          "870-0324",
          "870-0325",
          "870-0326",
          "870-0124",
          "879-7762",
          "870-0025",
          "870-0147",
          "870-0173",
          "870-0174",
          "870-0935",
          "870-0864",
          "870-0869",
          "870-0863",
          "870-0865",
          "870-0327",
          "870-0036",
          "870-1134",
          "870-0302",
          "870-0307",
          "870-0309",
          "870-0308",
          "879-2201",
          "870-0838",
          "870-0272",
          "870-0303",
          "870-0315",
          "870-1212",
          "870-1120",
          "870-0829",
          "870-0253",
          "870-1122",
          "870-1107",
          "870-1102",
          "870-1106",
          "870-1104",
          "870-1103",
          "870-1105",
          "870-1101",
          "879-7884",
          "870-0821",
          "870-0261",
          "870-0952",
          "870-0954",
          "870-0953",
          "870-0955",
          "870-0961",
          "870-0951",
          "870-0941",
          "870-0803",
          "870-0118",
          "870-1213",
          "870-1112",
          "879-7763",
          "870-1141",
          "870-0807",
          "879-2115",
          "870-0241",
          "870-0922",
          "870-0153",
          "870-0824",
          "870-0826",
          "870-0825",
          "870-0827",
          "870-0828",
          "870-0267",
          "870-0876",
          "879-2202",
          "870-0045",
          "870-0818",
          "870-0015",
          "870-0016",
          "870-0911",
          "870-0919",
          "870-0028",
          "870-0172",
          "870-0027",
          "870-0244",
          "879-7882",
          "870-0032",
          "870-0031",
          "870-1114",
          "870-0115",
          "870-0048",
          "870-0132",
          "870-1123",
          "870-1138",
          "870-1139",
          "870-1127",
          "870-0837",
          "870-1116",
          "870-1117",
          "870-1118",
          "870-1119",
          "870-0873",
          "870-0872",
          "870-0029",
          "870-0156",
          "870-0148",
          "870-0149",
          "870-0923",
          "870-0154",
          "870-0157",
          "870-0155",
          "870-1142",
          "870-1222",
          "870-0917",
          "870-0916",
          "870-0265",
          "879-7501",
          "870-0882",
          "870-1211",
          "870-1143",
          "870-1140",
          "870-1130",
          "870-1144",
          "870-1149",
          "870-1145",
          "870-0852",
          "870-0274",
          "870-0802",
          "870-1154",
          "870-1155",
          "870-0816",
          "870-1124",
          "870-0035",
          "870-0033",
          "879-7872",
          "879-7871",
          "870-1204",
          "870-0116",
          "870-0271",
          "870-0242",
          "870-1166",
          "870-0945",
          "870-0930",
          "870-0106",
          "870-0120",
          "870-0279",
          "870-0121",
          "870-0137",
          "870-1148",
          "870-0861",
          "870-0867",
          "870-0109",
          "870-0947",
          "870-0018",
          "870-0862",
          "870-0039",
          "870-0049",
          "870-0043",
          "870-0047",
          "870-0101",
          "870-0939",
          "870-0135",
          "870-0111",
          "870-0859",
          "870-1113",
          "879-7761",
          "870-0929",
          "870-0023",
          "870-0801",
          "870-0046",
          "870-1221",
          "870-0820",
          "870-0038",
          "870-0024",
          "870-0901",
          "870-0105",
          "870-0902",
          "870-0931",
          "870-0874",
          "870-0318",
          "870-0270",
          "870-0868",
          "870-1203",
          "879-7883",
          "870-0921",
          "870-0856",
          "879-7502",
          "870-0942",
          "870-0243",
          "870-0846",
          "870-0915",
          "870-0933",
          "870-1128",
          "870-0880",
          "879-2112",
          "870-0323",
          "870-0002",
          "870-0013",
          "870-0012",
          "870-0854",
          "870-0853",
          "870-0138",
          "870-0912",
          "870-1110",
          "870-1126",
          "870-1108",
          "870-1109",
          "870-0914",
          "870-0151",
          "870-0306",
          "870-0823",
          "870-0037",
          "870-0103",
          "870-0934",
          "870-0932",
          "870-0150",
          "870-0871",
          "870-1115",
          "870-0301",
          "870-0918",
          "870-0866",
          "870-0277",
          "870-0847",
          "870-0881",
          "870-1205",
          "879-7874",
          "870-1147",
          "870-0957",
          "870-1176",
          "870-1177",
          "870-0887",
          "870-0021",
          "870-0855",
          "870-0844",
          "870-0845",
          "870-0017",
          "870-0948",
          "870-0171",
          "870-0305",
          "879-2111",
          "870-0044",
          "870-1146",
          "870-0946",
          "870-0924",
          "870-0152",
          "870-0925",
          "870-0125",
          "870-1168",
          "870-0913",
          "870-0268",
          "870-0122",
          "870-0888",
          "870-0108",
          "870-0143",
          "870-0142",
          "870-0141",
          "879-7765",
          "870-1132",
          "870-1135",
          "870-1136",
          "870-1172",
          "870-0131",
          "870-0117",
          "870-0812",
          "870-0811",
          "870-0814",
          "870-0815",
          "870-0928",
          "870-0885",
          "870-0104",
          "870-0937",
          "879-7873",
          "870-0276",
          "870-0275",
          "870-0034",
          "870-1133",
          "870-1137",
          "870-0878",
          "870-0804",
          "870-0030",
          "870-0903",
          "870-0904",
          "870-0905",
          "870-1159",
          "870-1158",
          "870-1157",
          "870-1163",
          "870-1201",
          "870-0944",
          "870-1174",
          "870-0843",
          "870-0139",
          "870-0128",
          "870-0127",
          "870-0140",
          "870-0136",
          "870-0313",
          "870-0042",
          "870-0958",
          "870-0126",
          "870-0130",
          "870-1173",
          "870-0263",
          "870-0254",
          "879-7875",
          "870-0883",
          "870-0842",
          "870-0841",
          "874-0000",
          "874-0902",
          "874-0819",
          "874-0937",
          "874-0846",
          "874-0812",
          "874-0005",
          "874-0919",
          "874-0910",
          "874-0043",
          "874-0011",
          "879-5551",
          "874-0814",
          "874-0935",
          "874-0934",
          "874-0805",
          "874-0849",
          "874-0842",
          "874-0001",
          "874-0003",
          "874-0821",
          "874-0848",
          "874-0908",
          "874-0905",
          "874-0829",
          "874-0036",
          "874-0025",
          "874-0021",
          "874-0014",
          "874-0022",
          "874-0822",
          "874-0046",
          "874-0042",
          "874-0802",
          "874-0041",
          "874-0845",
          "874-0920",
          "874-0928",
          "874-0926",
          "874-0943",
          "874-0015",
          "874-0816",
          "879-5552",
          "874-0907",
          "874-0915",
          "874-0918",
          "874-0835",
          "874-0034",
          "874-0032",
          "874-0035",
          "874-0033",
          "874-0023",
          "874-0031",
          "874-0834",
          "874-0923",
          "874-0938",
          "874-0012",
          "874-0002",
          "874-0838",
          "874-0837",
          "874-0037",
          "874-0841",
          "874-0939",
          "874-0815",
          "874-0909",
          "874-0936",
          "874-0942",
          "874-0840",
          "874-0833",
          "874-0826",
          "874-0906",
          "874-0817",
          "874-0901",
          "874-0917",
          "874-0916",
          "874-0914",
          "874-0931",
          "874-0932",
          "874-0933",
          "874-0903",
          "874-0016",
          "874-0847",
          "874-0945",
          "874-0947",
          "874-0820",
          "874-0913",
          "874-0930",
          "874-0836",
          "874-0803",
          "874-0804",
          "874-0024",
          "874-0921",
          "874-0922",
          "874-0013",
          "874-0044",
          "874-0844",
          "874-0831",
          "874-0946",
          "874-0911",
          "874-0912",
          "874-0904",
          "874-0832",
          "874-0824",
          "874-0839",
          "874-0827",
          "874-0825",
          "874-0823",
          "874-0941",
          "874-0929",
          "874-0045",
          "874-0843",
          "874-0924",
          "874-0944",
          "874-0811",
          "874-0818",
          "874-0801",
          "874-0828",
          "874-0927",
          "874-0004",
          "874-0813",
          "874-0925",
          "871-0099",
          "871-0122",
          "871-0022",
          "879-0106",
          "871-0098",
          "879-0111",
          "879-0105",
          "879-0101",
          "879-0103",
          "871-0015",
          "871-0016",
          "871-0093",
          "871-0064",
          "871-0038",
          "871-0065",
          "871-0044",
          "871-0005",
          "871-0153",
          "871-0001",
          "871-0008",
          "871-0021",
          "871-0045",
          "871-0007",
          "871-0152",
          "871-0082",
          "871-0056",
          "871-0013",
          "871-0046",
          "871-0161",
          "871-0004",
          "871-0042",
          "871-0027",
          "871-0060",
          "871-0094",
          "871-0090",
          "879-0113",
          "871-0081",
          "871-0079",
          "871-0054",
          "871-0091",
          "871-0078",
          "871-0080",
          "871-0154",
          "871-0084",
          "871-0076",
          "871-0003",
          "871-0043",
          "871-0156",
          "871-0074",
          "879-0122",
          "871-0104",
          "871-0112",
          "871-0114",
          "879-0225",
          "879-0221",
          "871-0111",
          "879-0224",
          "879-0223",
          "871-0103",
          "871-0113",
          "871-0102",
          "879-0222",
          "871-0105",
          "871-0101",
          "871-0057",
          "871-0073",
          "871-0033",
          "871-0035",
          "871-0036",
          "871-0011",
          "871-0097",
          "871-0164",
          "871-0029",
          "879-0107",
          "871-0048",
          "871-0009",
          "871-0039",
          "871-0041",
          "871-0069",
          "871-0086",
          "871-0002",
          "871-0089",
          "871-0059",
          "871-0151",
          "871-0066",
          "871-0026",
          "871-0071",
          "879-0123",
          "879-0124",
          "871-0024",
          "871-0067",
          "871-0095",
          "871-0028",
          "871-0075",
          "871-0055",
          "871-0058",
          "871-0031",
          "871-0030",
          "871-0157",
          "871-0162",
          "879-0102",
          "871-0163",
          "871-0050",
          "879-0104",
          "871-0155",
          "871-0006",
          "871-0032",
          "871-0014",
          "871-0034",
          "871-0077",
          "879-0112",
          "871-0063",
          "871-0072",
          "871-0053",
          "871-0051",
          "871-0068",
          "871-0311",
          "871-0206",
          "871-0313",
          "871-0312",
          "871-0204",
          "871-0205",
          "871-0202",
          "871-0203",
          "871-0314",
          "871-0208",
          "871-0315",
          "871-0207",
          "871-0201",
          "871-0047",
          "871-0025",
          "871-0061",
          "871-0092",
          "871-0087",
          "871-0037",
          "871-0012",
          "879-0121",
          "871-0049",
          "871-0083",
          "871-0431",
          "871-0413",
          "871-0406",
          "871-0405",
          "871-0432",
          "871-0402",
          "871-0414",
          "871-0422",
          "871-0403",
          "871-0412",
          "871-0404",
          "871-0411",
          "871-0434",
          "871-0401",
          "871-0408",
          "871-0407",
          "871-0433",
          "871-0421",
          "871-0715",
          "871-0702",
          "871-0703",
          "871-0701",
          "871-0714",
          "871-0716",
          "871-0711",
          "871-0713",
          "871-0712",
          "871-0704",
          "871-0062",
          "871-0085",
          "871-0023",
          "871-0096",
          "871-0088",
          "877-0000",
          "877-1224",
          "877-0001",
          "877-0084",
          "877-0085",
          "879-4202",
          "877-0111",
          "877-0114",
          "879-4123",
          "879-4122",
          "879-4201",
          "877-0113",
          "877-0112",
          "879-4121",
          "879-4203",
          "877-1366",
          "877-1361",
          "877-1375",
          "877-0061",
          "877-1352",
          "877-1223",
          "877-1383",
          "877-0062",
          "877-0068",
          "877-1104",
          "877-1107",
          "877-1105",
          "877-1106",
          "877-0033",
          "877-0055",
          "877-0201",
          "877-0202",
          "877-0032",
          "877-1222",
          "877-0088",
          "877-1362",
          "877-0064",
          "877-0022",
          "877-0003",
          "877-0312",
          "877-0311",
          "877-1372",
          "877-0076",
          "877-0066",
          "877-0043",
          "877-0045",
          "877-0078",
          "877-0087",
          "877-0051",
          "877-0063",
          "877-0044",
          "877-0031",
          "877-0054",
          "877-1231",
          "877-1354",
          "877-1351",
          "877-0016",
          "877-0017",
          "877-1232",
          "877-0038",
          "877-1102",
          "877-0002",
          "877-0004",
          "877-1243",
          "877-0081",
          "877-0056",
          "877-0052",
          "877-0059",
          "877-0067",
          "877-0053",
          "877-0041",
          "877-0023",
          "877-0025",
          "877-0026",
          "877-0071",
          "877-0012",
          "877-0015",
          "877-1373",
          "877-1103",
          "877-1101",
          "877-1234",
          "877-1242",
          "877-1363",
          "877-0011",
          "877-0302",
          "877-0301",
          "877-0075",
          "877-0074",
          "877-0047",
          "877-0058",
          "877-0072",
          "877-0086",
          "877-1353",
          "877-1384",
          "877-1381",
          "877-0042",
          "877-0035",
          "877-0073",
          "877-0082",
          "877-1382",
          "877-0083",
          "877-1221",
          "877-1225",
          "877-0046",
          "877-0014",
          "877-0211",
          "877-0212",
          "839-1421",
          "877-0221",
          "877-1374",
          "877-0005",
          "877-0007",
          "877-0008",
          "877-1364",
          "877-1244",
          "877-1365",
          "877-0065",
          "877-0006",
          "877-0077",
          "877-0024",
          "877-0036",
          "877-1233",
          "877-0013",
          "877-1121",
          "877-1241",
          "877-0021",
          "877-0034",
          "877-1371",
          "877-0057",
          "877-0089",
          "877-0039",
          "877-1111",
          "877-1112",
          "877-1113",
          "877-0037",
          "876-0000",
          "876-1513",
          "876-0004",
          "876-0025",
          "876-0833",
          "876-0005",
          "876-0042",
          "876-0849",
          "876-0845",
          "879-3201",
          "879-3301",
          "879-3202",
          "879-3402",
          "879-3401",
          "879-3203",
          "879-3204",
          "879-3205",
          "879-3302",
          "876-0803",
          "876-0016",
          "876-0036",
          "876-0831",
          "876-1105",
          "876-0043",
          "876-0806",
          "876-1104",
          "876-0008",
          "876-1512",
          "876-0801",
          "876-2402",
          "876-2202",
          "876-2406",
          "876-2401",
          "876-2203",
          "876-2301",
          "876-2302",
          "876-2403",
          "876-2201",
          "876-2407",
          "876-2405",
          "876-2404",
          "879-2601",
          "879-2602",
          "879-2603",
          "876-0045",
          "876-0027",
          "876-0034",
          "876-0022",
          "876-1101",
          "876-0031",
          "876-0804",
          "876-0035",
          "876-2121",
          "876-0007",
          "876-0841",
          "876-0011",
          "876-0052",
          "876-0003",
          "876-0024",
          "876-0033",
          "876-0848",
          "876-0847",
          "876-0063",
          "876-0846",
          "876-0834",
          "876-0026",
          "876-0014",
          "876-0824",
          "876-0832",
          "876-0044",
          "876-0053",
          "876-0001",
          "876-0807",
          "876-0047",
          "876-0835",
          "876-0012",
          "876-1204",
          "876-1313",
          "876-1203",
          "876-1312",
          "876-1202",
          "876-1311",
          "876-1306",
          "876-1206",
          "876-1205",
          "876-1201",
          "876-0811",
          "876-0051",
          "876-0851",
          "876-0857",
          "876-0852",
          "879-3101",
          "879-3102",
          "879-3103",
          "879-3104",
          "879-3105",
          "876-0812",
          "876-0843",
          "876-0842",
          "876-0853",
          "876-0855",
          "876-0854",
          "876-0856",
          "876-0032",
          "876-0813",
          "876-0041",
          "876-1511",
          "876-0836",
          "876-0822",
          "876-0815",
          "876-0017",
          "876-0037",
          "876-1106",
          "876-0021",
          "876-0821",
          "876-0814",
          "876-0802",
          "876-0002",
          "876-0018",
          "876-0805",
          "876-1102",
          "876-0062",
          "876-0023",
          "876-0844",
          "876-0211",
          "876-0212",
          "876-0204",
          "876-0206",
          "876-0215",
          "876-0202",
          "876-0201",
          "876-0214",
          "876-0213",
          "876-0205",
          "876-0203",
          "876-0216",
          "876-0823",
          "876-0825",
          "876-0015",
          "876-1103",
          "876-0006",
          "876-0061",
          "876-0064",
          "876-0111",
          "876-0125",
          "876-0101",
          "876-0112",
          "876-0122",
          "876-0121",
          "876-0124",
          "876-0102",
          "876-0126",
          "876-0123",
          "876-0113",
          "876-0103",
          "876-1402",
          "876-1401",
          "876-1301",
          "876-1404",
          "876-1405",
          "876-1403",
          "876-0013",
          "876-0046",
          "875-0000",
          "875-0065",
          "875-0034",
          "875-0052",
          "875-0082",
          "875-0083",
          "875-0041",
          "875-0023",
          "875-0033",
          "875-0004",
          "875-0012",
          "875-0077",
          "875-0042",
          "875-0073",
          "875-0032",
          "875-0070",
          "875-0001",
          "875-0074",
          "875-0002",
          "875-0022",
          "875-0011",
          "875-0003",
          "875-0078",
          "875-0084",
          "875-0079",
          "875-0021",
          "875-0051",
          "875-0072",
          "875-0075",
          "875-0013",
          "875-0043",
          "875-0062",
          "875-0221",
          "875-0343",
          "875-0232",
          "875-0212",
          "875-0215",
          "875-0342",
          "875-0352",
          "875-0216",
          "875-0237",
          "875-0344",
          "875-0341",
          "875-0231",
          "875-0351",
          "875-0353",
          "875-0224",
          "875-0201",
          "875-0213",
          "875-0234",
          "875-0323",
          "875-0223",
          "875-0214",
          "875-0235",
          "875-0203",
          "875-0211",
          "875-0233",
          "875-0202",
          "875-0236",
          "875-0222",
          "875-0076",
          "875-0031",
          "875-0064",
          "875-0053",
          "875-0081",
          "875-0061",
          "875-0063",
          "875-0071",
          "879-2400",
          "879-2682",
          "879-2445",
          "879-2459",
          "879-2458",
          "879-2411",
          "879-2431",
          "879-2455",
          "879-2475",
          "879-2461",
          "879-2436",
          "879-2471",
          "879-2453",
          "879-2454",
          "879-2457",
          "879-2446",
          "879-2451",
          "879-2443",
          "879-2412",
          "879-2434",
          "879-2401",
          "879-2441",
          "879-2421",
          "879-2413",
          "879-2474",
          "879-2472",
          "879-2473",
          "879-2433",
          "879-2452",
          "879-2476",
          "879-2681",
          "879-2432",
          "879-2501",
          "879-2442",
          "879-2435",
          "879-2444",
          "879-2456",
          "879-2422",
          "879-2683",
          "878-0000",
          "878-0011",
          "878-0021",
          "878-0153",
          "879-6182",
          "878-0022",
          "878-0031",
          "878-0001",
          "878-0002",
          "878-0032",
          "878-0141",
          "879-6134",
          "879-6113",
          "879-6126",
          "879-6122",
          "879-6127",
          "879-6135",
          "879-6101",
          "879-6121",
          "879-6132",
          "879-6131",
          "879-6103",
          "879-6116",
          "879-6128",
          "879-6133",
          "879-6115",
          "879-6124",
          "879-6104",
          "879-6125",
          "879-6112",
          "879-6102",
          "879-6111",
          "879-6123",
          "879-6181",
          "878-0003",
          "878-0161",
          "878-0163",
          "878-0164",
          "878-0154",
          "878-0143",
          "878-0023",
          "878-0572",
          "878-0202",
          "878-0204",
          "878-0201",
          "878-0205",
          "878-0206",
          "878-0203",
          "878-0256",
          "878-0156",
          "878-0576",
          "878-0574",
          "878-0155",
          "878-0151",
          "878-0152",
          "879-6184",
          "878-0162",
          "878-0575",
          "878-0144",
          "878-0013",
          "878-0012",
          "878-0024",
          "878-0571",
          "879-6183",
          "878-0403",
          "878-0401",
          "878-0404",
          "878-0402",
          "878-0004",
          "878-0573",
          "878-0033",
          "878-0025",
          "878-0005",
          "878-0026",
          "878-0006",
          "878-0142",
          "878-0146",
          "878-0007",
          "878-0027",
          "878-0034",
          "878-0035",
          "878-0145",
          "878-0028",
          "879-0600",
          "879-0733",
          "879-0722",
          "879-0626",
          "872-1107",
          "879-0723",
          "872-1201",
          "872-1102",
          "872-1106",
          "879-0605",
          "872-1202",
          "879-0622",
          "872-1203",
          "879-0603",
          "879-0623",
          "872-1204",
          "879-0721",
          "879-0601",
          "879-0614",
          "879-0608",
          "872-1103",
          "879-0613",
          "872-1205",
          "879-0621",
          "879-0615",
          "879-0612",
          "872-1104",
          "879-0609",
          "879-0607",
          "879-0724",
          "879-0627",
          "879-0628",
          "879-0732",
          "879-0617",
          "879-0843",
          "879-0842",
          "879-0844",
          "879-0854",
          "879-0853",
          "879-0841",
          "879-0855",
          "879-0852",
          "879-0851",
          "879-0606",
          "879-0618",
          "879-0734",
          "879-0731",
          "872-1101",
          "872-1105",
          "879-0619",
          "872-1206",
          "879-0602",
          "879-0624",
          "879-0735",
          "879-0616",
          "879-0625",
          "872-1207",
          "879-0604",
          "879-0611",
          "873-0000",
          "873-0011",
          "873-0005",
          "873-0021",
          "873-0006",
          "873-0022",
          "879-0901",
          "879-0904",
          "879-0902",
          "879-0912",
          "879-0903",
          "879-0911",
          "873-0041",
          "879-0941",
          "873-0007",
          "873-0023",
          "873-0031",
          "873-0001",
          "873-0008",
          "873-0012",
          "873-0032",
          "873-0003",
          "873-0013",
          "873-0024",
          "873-0014",
          "873-0025",
          "873-0002",
          "873-0004",
          "873-0033",
          "873-0015",
          "879-1311",
          "879-1304",
          "879-1313",
          "879-1305",
          "879-1303",
          "879-1302",
          "879-1307",
          "879-1312",
          "879-1306",
          "879-1314",
          "879-1301",
          "879-1315",
          "879-1316",
          "873-0034",
          "872-0000",
          "879-1138",
          "879-0233",
          "872-0732",
          "872-0518",
          "872-0843",
          "872-0654",
          "872-0510",
          "872-0663",
          "872-0522",
          "872-0703",
          "872-0671",
          "872-0511",
          "872-0852",
          "872-0723",
          "872-0731",
          "872-0862",
          "872-0507",
          "872-0674",
          "872-0673",
          "872-0541",
          "872-0712",
          "872-0861",
          "872-0661",
          "872-0651",
          "872-0842",
          "872-0521",
          "872-0504",
          "872-0542",
          "872-0873",
          "872-0854",
          "872-0863",
          "872-0517",
          "872-0523",
          "872-0857",
          "872-0526",
          "872-0527",
          "872-0524",
          "872-0506",
          "872-0664",
          "872-0505",
          "872-0514",
          "872-0525",
          "872-0701",
          "872-0503",
          "872-0519",
          "872-0515",
          "872-0501",
          "872-0864",
          "872-0502",
          "872-0702",
          "872-0724",
          "872-0543",
          "872-0871",
          "872-0672",
          "872-0851",
          "872-0855",
          "872-0872",
          "872-0512",
          "872-0655",
          "872-0653",
          "872-0865",
          "872-0733",
          "872-0858",
          "872-0722",
          "872-0853",
          "872-0516",
          "872-0675",
          "872-0662",
          "872-0841",
          "872-0652",
          "872-0856",
          "872-0513",
          "872-0711",
          "872-0721",
          "879-0501",
          "879-0312",
          "879-0444",
          "879-1131",
          "879-0514",
          "879-0234",
          "879-1132",
          "872-0011",
          "872-0323",
          "872-0331",
          "872-0458",
          "872-0457",
          "872-0314",
          "872-0482",
          "872-0316",
          "872-0334",
          "872-0324",
          "872-0342",
          "872-0459",
          "872-0484",
          "872-0452",
          "872-0326",
          "872-0315",
          "872-0312",
          "872-0466",
          "872-0456",
          "872-0325",
          "872-0311",
          "872-0455",
          "872-0321",
          "872-0341",
          "872-0451",
          "872-0481",
          "872-0327",
          "872-0346",
          "872-0313",
          "872-0318",
          "872-0461",
          "872-0344",
          "872-0328",
          "872-0454",
          "872-0473",
          "872-0465",
          "872-0345",
          "872-0483",
          "872-0464",
          "872-0471",
          "872-0472",
          "872-0462",
          "872-0333",
          "872-0322",
          "872-0453",
          "872-0317",
          "872-0302",
          "872-0301",
          "872-0343",
          "872-0332",
          "872-0463",
          "879-0453",
          "879-1126",
          "872-0032",
          "879-0464",
          "879-0232",
          "872-0031",
          "879-0301",
          "879-0304",
          "879-1128",
          "872-0021",
          "879-0303",
          "879-0163",
          "879-0153",
          "879-0313",
          "879-0305",
          "879-0315",
          "872-0366",
          "879-0466",
          "879-0472",
          "872-0112",
          "879-0456",
          "879-1137",
          "879-0452",
          "872-0103",
          "872-0013",
          "879-0516",
          "872-0042",
          "879-0235",
          "872-0012",
          "879-0443",
          "872-0114",
          "879-0512",
          "872-0045",
          "879-0455",
          "872-0104",
          "872-0043",
          "879-1136",
          "872-0016",
          "879-0237",
          "879-0314",
          "879-0457",
          "879-0236",
          "879-0302",
          "879-0161",
          "879-0152",
          "879-0317",
          "879-0308",
          "879-0316",
          "879-0465",
          "879-0473",
          "872-0111",
          "872-0047",
          "879-0442",
          "872-0113",
          "879-0515",
          "872-0044",
          "872-0033",
          "872-0046",
          "872-0101",
          "879-0502",
          "879-1123",
          "879-0164",
          "879-0513",
          "879-0162",
          "879-0463",
          "872-0001",
          "879-0503",
          "872-0022",
          "879-0306",
          "879-1127",
          "872-0023",
          "879-1134",
          "879-0451",
          "879-0307",
          "879-1133",
          "879-1121",
          "879-0309",
          "879-0461",
          "879-0462",
          "879-0454",
          "872-0015",
          "872-0041",
          "872-0102",
          "879-0231",
          "872-0014",
          "879-0151",
          "879-0311",
          "879-1124",
          "879-0504",
          "879-0474",
          "879-0511",
          "879-0467",
          "879-1122",
          "879-0441",
          "879-0471",
          "879-1125",
          "879-1135",
          "879-7100",
          "879-6222",
          "879-6224",
          "879-6223",
          "879-6201",
          "879-6213",
          "879-6333",
          "879-6212",
          "879-6202",
          "879-6221",
          "879-6331",
          "879-6334",
          "879-6211",
          "879-6332",
          "879-7301",
          "879-7304",
          "879-7302",
          "879-7314",
          "879-7313",
          "879-7312",
          "879-7307",
          "879-7311",
          "879-7306",
          "879-7305",
          "879-7316",
          "879-7315",
          "879-7303",
          "879-6401",
          "879-6404",
          "879-6433",
          "879-6445",
          "879-6435",
          "879-6434",
          "879-6426",
          "879-6422",
          "879-6431",
          "879-6408",
          "879-6406",
          "879-6405",
          "879-6444",
          "879-6441",
          "879-6407",
          "879-6402",
          "879-6403",
          "879-6421",
          "879-6424",
          "879-6442",
          "879-6443",
          "879-6423",
          "879-6432",
          "879-6425",
          "879-6613",
          "879-6864",
          "879-6633",
          "879-6759",
          "879-6861",
          "879-6865",
          "879-6625",
          "879-6642",
          "879-6751",
          "879-6755",
          "879-6757",
          "879-6641",
          "879-6616",
          "879-6862",
          "879-6612",
          "879-6602",
          "879-6635",
          "879-6643",
          "879-6753",
          "879-6626",
          "879-6863",
          "879-6614",
          "879-6632",
          "879-6634",
          "879-6622",
          "879-6756",
          "879-6758",
          "879-6611",
          "879-6621",
          "879-6601",
          "879-6631",
          "879-6624",
          "879-6615",
          "879-6754",
          "879-6623",
          "879-6752",
          "879-6902",
          "879-6901",
          "879-6911",
          "879-6922",
          "879-6903",
          "879-6914",
          "879-6904",
          "879-6913",
          "879-6921",
          "879-6905",
          "879-6912",
          "879-7403",
          "879-7411",
          "879-7413",
          "879-7412",
          "879-7404",
          "879-7401",
          "879-7402",
          "879-7414",
          "879-7111",
          "879-7141",
          "879-7108",
          "879-7105",
          "879-7106",
          "879-7131",
          "879-7125",
          "879-7124",
          "879-7264",
          "879-7262",
          "879-7104",
          "879-7142",
          "879-7107",
          "879-7154",
          "879-7102",
          "879-7153",
          "879-7263",
          "879-7151",
          "879-7103",
          "879-7143",
          "879-7261",
          "879-7144",
          "879-7123",
          "879-7101",
          "879-7155",
          "879-7152",
          "879-7121",
          "879-7122",
          "879-5400",
          "879-5423",
          "879-5404",
          "879-5413",
          "879-5402",
          "879-5421",
          "879-5401",
          "879-5412",
          "879-5434",
          "879-5433",
          "879-5411",
          "879-5424",
          "879-5435",
          "879-5431",
          "879-5436",
          "879-5408",
          "879-5406",
          "879-5422",
          "879-5432",
          "879-5403",
          "879-5405",
          "879-5437",
          "879-5425",
          "879-5407",
          "879-5516",
          "879-5503",
          "879-5517",
          "879-5521",
          "879-5501",
          "879-5522",
          "879-5518",
          "879-5512",
          "879-5523",
          "879-5504",
          "879-5513",
          "879-5519",
          "879-5531",
          "879-5532",
          "879-5510",
          "879-5524",
          "879-5514",
          "879-5506",
          "879-5511",
          "879-5525",
          "879-5515",
          "879-5502",
          "879-5102",
          "879-5114",
          "879-5113",
          "879-5103",
          "879-5111",
          "879-5101",
          "879-5104",
          "879-5112",
          "873-0500",
          "873-0351",
          "873-0354",
          "873-0223",
          "873-0205",
          "873-0232",
          "873-0212",
          "873-0231",
          "873-0222",
          "873-0202",
          "873-0355",
          "873-0203",
          "873-0204",
          "873-0221",
          "873-0211",
          "873-0356",
          "873-0352",
          "873-0053",
          "873-0353",
          "873-0206",
          "873-0224",
          "873-0207",
          "873-0201",
          "873-0523",
          "873-0504",
          "872-1653",
          "873-0522",
          "873-0511",
          "873-0531",
          "873-0501",
          "872-1652",
          "873-0533",
          "873-0514",
          "873-0534",
          "873-0535",
          "873-0512",
          "873-0646",
          "873-0502",
          "873-0513",
          "873-0503",
          "873-0645",
          "873-0643",
          "873-0532",
          "872-1651",
          "873-0644",
          "873-0521",
          "873-0642",
          "873-0641",
          "873-0524",
          "872-1405",
          "872-1401",
          "872-1612",
          "872-1323",
          "872-1614",
          "872-1406",
          "872-1324",
          "872-1613",
          "872-1322",
          "872-1404",
          "872-1321",
          "872-1402",
          "872-1403",
          "872-1611",
          "873-0405",
          "873-0401",
          "873-0421",
          "873-0402",
          "873-0422",
          "873-0432",
          "873-0424",
          "873-0414",
          "873-0404",
          "873-0407",
          "873-0412",
          "873-0406",
          "873-0423",
          "873-0415",
          "872-1501",
          "879-1500",
          "879-1506",
          "879-1504",
          "879-1505",
          "879-1507",
          "879-1508",
          "879-1501",
          "879-1502",
          "879-1503",
          "879-1509",
          "879-4800",
          "879-4721",
          "879-4803",
          "879-4631",
          "879-4724",
          "879-4911",
          "879-4802",
          "879-4722",
          "879-4723",
          "879-4632",
          "879-4801",
          "879-4601",
          "879-4912",
          "879-4400",
          "879-4402",
          "879-4405",
          "879-4414",
          "879-4521",
          "879-4411",
          "879-4523",
          "879-4413",
          "879-4331",
          "879-4406",
          "879-4403",
          "879-4404",
          "879-4332",
          "879-4732",
          "879-4522",
          "879-4412",
          "879-4401",
          "879-4301",
          "880-0000",
          "889-2162",
          "889-2163",
          "880-0842",
          "880-0912",
          "880-0803",
          "880-0864",
          "880-2101",
          "880-2102",
          "880-0835",
          "880-2103",
          "880-0942",
          "880-0943",
          "880-0041",
          "880-0854",
          "880-2231",
          "880-2104",
          "880-0821",
          "889-2301",
          "880-0344",
          "880-0044",
          "880-0872",
          "880-0814",
          "880-0817",
          "880-0816",
          "880-0051",
          "880-0815",
          "880-0801",
          "880-0824",
          "880-0345",
          "880-0045",
          "880-0903",
          "880-0952",
          "880-2105",
          "880-0951",
          "880-0933",
          "880-0934",
          "880-0932",
          "880-0022",
          "880-0902",
          "880-0857",
          "889-2164",
          "889-2161",
          "880-0947",
          "889-2156",
          "889-2154",
          "889-2155",
          "889-2153",
          "889-2152",
          "880-2111",
          "880-2234",
          "880-0043",
          "880-0011",
          "880-0866",
          "880-0024",
          "880-0941",
          "880-0823",
          "880-0017",
          "880-0923",
          "880-0937",
          "880-0938",
          "889-1609",
          "889-1606",
          "889-1608",
          "889-1602",
          "889-1612",
          "889-1607",
          "889-1605",
          "889-1601",
          "889-1603",
          "889-1611",
          "889-1613",
          "889-1604",
          "880-0032",
          "880-0924",
          "889-2151",
          "880-0927",
          "880-0944",
          "880-2112",
          "880-2113",
          "880-0954",
          "880-0953",
          "880-0956",
          "880-0822",
          "880-0955",
          "880-0057",
          "880-0213",
          "880-0301",
          "880-0211",
          "880-0204",
          "880-0212",
          "880-0302",
          "880-0303",
          "880-0214",
          "880-0122",
          "880-0862",
          "880-0121",
          "880-0021",
          "880-0035",
          "880-0843",
          "880-0833",
          "880-0917",
          "880-0876",
          "880-0874",
          "880-0831",
          "880-0053",
          "880-0033",
          "880-0056",
          "880-0054",
          "880-0845",
          "880-0834",
          "880-0012",
          "880-0867",
          "880-0868",
          "880-0875",
          "880-0871",
          "880-0015",
          "880-2224",
          "880-2221",
          "880-2321",
          "880-2223",
          "880-2323",
          "880-2214",
          "889-1713",
          "880-2213",
          "880-2325",
          "880-2222",
          "880-2322",
          "880-2212",
          "880-2215",
          "880-2211",
          "880-0852",
          "880-0812",
          "880-0003",
          "880-0855",
          "880-0001",
          "880-0805",
          "880-0908",
          "880-0909",
          "889-1703",
          "889-1702",
          "889-1701",
          "889-1704",
          "880-0911",
          "880-0006",
          "880-0002",
          "880-0926",
          "880-2232",
          "880-0913",
          "880-0916",
          "880-0915",
          "880-0014",
          "880-0861",
          "880-0936",
          "880-0935",
          "880-0928",
          "880-2114",
          "880-0025",
          "880-0853",
          "880-0904",
          "880-0905",
          "880-2115",
          "880-0826",
          "880-0124",
          "880-0027",
          "880-0818",
          "880-0811",
          "880-0016",
          "880-0036",
          "880-0026",
          "880-0939",
          "880-0930",
          "880-0007",
          "880-0832",
          "880-0825",
          "880-0901",
          "880-0856",
          "880-0806",
          "880-0125",
          "880-0946",
          "880-0945",
          "880-0031",
          "880-0931",
          "880-0046",
          "880-0047",
          "880-0042",
          "880-0802",
          "880-0123",
          "889-1716",
          "880-2116",
          "880-0873",
          "880-0922",
          "880-0925",
          "880-0921",
          "880-0863",
          "880-0013",
          "880-0865",
          "880-0929",
          "880-0813",
          "880-0052",
          "880-0858",
          "880-0851",
          "880-0037",
          "880-0005",
          "880-0055",
          "880-0906",
          "880-0879",
          "880-0804",
          "880-0914",
          "880-0877",
          "880-0837",
          "880-0004",
          "880-0844",
          "880-0034",
          "880-0836",
          "880-0878",
          "880-2233",
          "880-0841",
          "880-0907",
          "880-0023",
          "885-0000",
          "885-0034",
          "885-0041",
          "885-0064",
          "885-1101",
          "885-0019",
          "885-0014",
          "885-0063",
          "885-0062",
          "885-0112",
          "885-0074",
          "885-0111",
          "885-0001",
          "885-0012",
          "885-1103",
          "885-0042",
          "885-0053",
          "885-0072",
          "885-0024",
          "885-0086",
          "885-0051",
          "885-0018",
          "885-0013",
          "885-0084",
          "885-0022",
          "885-0023",
          "885-0093",
          "885-0011",
          "885-1102",
          "885-0061",
          "885-0114",
          "885-0005",
          "885-0113",
          "885-0015",
          "885-0026",
          "885-0081",
          "885-0003",
          "889-4502",
          "889-4505",
          "889-4504",
          "889-4503",
          "889-4501",
          "889-4506",
          "885-1311",
          "885-1205",
          "885-1203",
          "885-1204",
          "885-1312",
          "885-1201",
          "885-1202",
          "885-0221",
          "885-0035",
          "885-0002",
          "885-0033",
          "885-0031",
          "885-0017",
          "885-0004",
          "885-0043",
          "885-0032",
          "885-0071",
          "885-0225",
          "885-0076",
          "885-1104",
          "885-0075",
          "885-0037",
          "885-0055",
          "885-0016",
          "885-0052",
          "885-0073",
          "885-0021",
          "885-0085",
          "885-0036",
          "885-0025",
          "885-0077",
          "885-1105",
          "885-0224",
          "885-0222",
          "885-0082",
          "885-0092",
          "885-0095",
          "885-0083",
          "885-0094",
          "885-0078",
          "885-0079",
          "885-0044",
          "889-4602",
          "889-4601",
          "889-1801",
          "889-1802",
          "880-2303",
          "889-1803",
          "885-0091",
          "885-0006",
          "885-0223",
          "885-0054",
          "882-0000",
          "889-0517",
          "882-0845",
          "889-0507",
          "882-0847",
          "882-0872",
          "882-0871",
          "882-0071",
          "882-0025",
          "889-0503",
          "889-0501",
          "882-0831",
          "882-0856",
          "882-0003",
          "882-0095",
          "882-0084",
          "882-0046",
          "882-0013",
          "882-0001",
          "882-0027",
          "882-0841",
          "882-0024",
          "882-0803",
          "882-0086",
          "882-0056",
          "882-0057",
          "882-0075",
          "882-0876",
          "882-0006",
          "882-0855",
          "882-0073",
          "882-0085",
          "882-0004",
          "882-0012",
          "882-0844",
          "882-0877",
          "882-0867",
          "889-0502",
          "882-0833",
          "882-0885",
          "882-0017",
          "882-0033",
          "882-0043",
          "889-0302",
          "889-0301",
          "889-0304",
          "889-0303",
          "882-0121",
          "882-0122",
          "882-0123",
          "882-0106",
          "882-0126",
          "882-0231",
          "882-0125",
          "882-0129",
          "882-0127",
          "882-0241",
          "882-0237",
          "882-0232",
          "882-0233",
          "882-0124",
          "882-0238",
          "882-0104",
          "882-0245",
          "882-0244",
          "882-0243",
          "882-0236",
          "882-0107",
          "882-0101",
          "882-0235",
          "882-0128",
          "882-0234",
          "882-0242",
          "882-0097",
          "889-0101",
          "889-0102",
          "882-0041",
          "882-0834",
          "889-0505",
          "882-0814",
          "882-0873",
          "889-0514",
          "889-0322",
          "882-0091",
          "882-0093",
          "882-0076",
          "882-0882",
          "882-0061",
          "882-0047",
          "882-0832",
          "882-0053",
          "882-0054",
          "882-0007",
          "882-0816",
          "882-0036",
          "882-0002",
          "882-0081",
          "882-0864",
          "882-0096",
          "889-0504",
          "882-0883",
          "882-0034",
          "882-0014",
          "882-0835",
          "889-0512",
          "882-0827",
          "882-0011",
          "882-0825",
          "889-0321",
          "882-0045",
          "882-0857",
          "889-0516",
          "882-0042",
          "882-0064",
          "882-0874",
          "882-0824",
          "882-0836",
          "882-0865",
          "882-0811",
          "882-0016",
          "889-0513",
          "882-0051",
          "882-0031",
          "882-0846",
          "882-0032",
          "882-0823",
          "882-0884",
          "882-0843",
          "882-0854",
          "882-0005",
          "882-0804",
          "882-0802",
          "882-0805",
          "882-0801",
          "882-0052",
          "882-0044",
          "882-0851",
          "882-0862",
          "882-0852",
          "882-0813",
          "882-0035",
          "882-0861",
          "882-0065",
          "882-0866",
          "882-0022",
          "882-0826",
          "882-0063",
          "882-0837",
          "882-0853",
          "882-0082",
          "882-0074",
          "882-0812",
          "882-0821",
          "882-0066",
          "882-0023",
          "889-0511",
          "882-0062",
          "882-0881",
          "882-0015",
          "882-0842",
          "882-0863",
          "889-0506",
          "882-0822",
          "882-0092",
          "889-0515",
          "882-0087",
          "882-0077",
          "882-0021",
          "882-0094",
          "882-0815",
          "882-0055",
          "882-0037",
          "882-0083",
          "882-0026",
          "882-0072",
          "882-0875",
          "887-0000",
          "887-0041",
          "889-2541",
          "889-2536",
          "887-0001",
          "889-2532",
          "887-0111",
          "889-2525",
          "887-0014",
          "887-0017",
          "889-3156",
          "889-3141",
          "887-0007",
          "889-2535",
          "887-0006",
          "887-0034",
          "889-3151",
          "887-0022",
          "889-2401",
          "889-2403",
          "889-2402",
          "887-0013",
          "889-2514",
          "887-0023",
          "889-3152",
          "887-0005",
          "889-2512",
          "889-2511",
          "889-3142",
          "889-3143",
          "887-0011",
          "887-0003",
          "887-0012",
          "887-0021",
          "889-3154",
          "889-3155",
          "887-0004",
          "889-2534",
          "887-0031",
          "889-2524",
          "887-0016",
          "889-3213",
          "889-3203",
          "889-3201",
          "889-3202",
          "889-3204",
          "889-3211",
          "889-3205",
          "889-3207",
          "889-3206",
          "889-3214",
          "889-3215",
          "889-3216",
          "889-3217",
          "889-3212",
          "887-0024",
          "887-0002",
          "889-3153",
          "889-2521",
          "889-2522",
          "887-0015",
          "887-0033",
          "887-0102",
          "889-2533",
          "889-2531",
          "887-0032",
          "889-2523",
          "887-0101",
          "889-2513",
          "886-0000",
          "886-0009",
          "886-0006",
          "886-0115",
          "886-0112",
          "886-0113",
          "886-0111",
          "886-0114",
          "886-0003",
          "886-0002",
          "886-0211",
          "886-0212",
          "886-0213",
          "886-0101",
          "886-0001",
          "886-0004",
          "886-0008",
          "886-0007",
          "886-0005",
          "883-0000",
          "883-0003",
          "883-0044",
          "883-0012",
          "883-0053",
          "883-0066",
          "883-0068",
          "883-0067",
          "883-0041",
          "883-0038",
          "883-0021",
          "883-0024",
          "883-0023",
          "889-1112",
          "883-0033",
          "883-0013",
          "883-0011",
          "883-0061",
          "883-0042",
          "883-0063",
          "883-0052",
          "883-0111",
          "883-0213",
          "883-0211",
          "883-0108",
          "883-0109",
          "889-1101",
          "883-0101",
          "883-0105",
          "889-1121",
          "883-0107",
          "883-0106",
          "883-0103",
          "883-0102",
          "883-0104",
          "883-0212",
          "883-0034",
          "883-0005",
          "883-0046",
          "883-0015",
          "883-0004",
          "883-0014",
          "883-0035",
          "883-0062",
          "883-0064",
          "883-0022",
          "883-0031",
          "883-0002",
          "883-0037",
          "883-0065",
          "883-0001",
          "883-0045",
          "883-0036",
          "889-1111",
          "883-0043",
          "883-0051",
          "883-0032",
          "883-0006",
          "888-0000",
          "888-0006",
          "889-3533",
          "889-3311",
          "888-0221",
          "889-3532",
          "889-3534",
          "888-0005",
          "888-0004",
          "888-0009",
          "888-0002",
          "888-0011",
          "888-0222",
          "889-3531",
          "888-0001",
          "888-0012",
          "888-0003",
          "888-0013",
          "888-0008",
          "888-0007",
          "881-0000",
          "881-0031",
          "881-0111",
          "881-0011",
          "881-0106",
          "881-0001",
          "881-0012",
          "881-0013",
          "881-1121",
          "881-0103",
          "881-1122",
          "881-0104",
          "881-1231",
          "881-0115",
          "881-0021",
          "881-0004",
          "881-0002",
          "880-0341",
          "881-0022",
          "881-0116",
          "881-0113",
          "881-0014",
          "881-0032",
          "881-1232",
          "881-0006",
          "881-0015",
          "881-0037",
          "881-0035",
          "881-0023",
          "881-0033",
          "881-0034",
          "881-0036",
          "881-0025",
          "881-0114",
          "881-0105",
          "881-1123",
          "881-0024",
          "881-1233",
          "881-0102",
          "881-0026",
          "881-0003",
          "881-0027",
          "881-0101",
          "881-0016",
          "881-0005",
          "881-0112",
          "889-4300",
          "889-4303",
          "889-4306",
          "889-4162",
          "889-4153",
          "889-4304",
          "889-4243",
          "889-4314",
          "889-4161",
          "889-4222",
          "889-4155",
          "889-4221",
          "889-4241",
          "889-4312",
          "889-4152",
          "889-4164",
          "889-4302",
          "889-4313",
          "889-4311",
          "889-4163",
          "889-4234",
          "889-4165",
          "889-4232",
          "889-4233",
          "889-4301",
          "889-4244",
          "889-4231",
          "889-4305",
          "889-4151",
          "889-4154",
          "889-4242",
          "889-1900",
          "889-1905",
          "889-1901",
          "889-1902",
          "889-1904",
          "889-1914",
          "889-1906",
          "889-1911",
          "889-1907",
          "889-1903",
          "889-1912",
          "889-1913",
          "889-4400",
          "889-4413",
          "889-4414",
          "889-4412",
          "889-4411",
          "880-1100",
          "880-1103",
          "880-1121",
          "880-1221",
          "880-1111",
          "880-1113",
          "880-1114",
          "880-1108",
          "880-1107",
          "880-1104",
          "880-1112",
          "880-1224",
          "880-1101",
          "880-1102",
          "880-1105",
          "880-1106",
          "880-1222",
          "880-1223",
          "880-1300",
          "880-1301",
          "880-1302",
          "880-1303",
          "884-0000",
          "884-0006",
          "884-0004",
          "884-0002",
          "884-0001",
          "884-0003",
          "884-0005",
          "889-1400",
          "889-1405",
          "889-1403",
          "889-1404",
          "889-1411",
          "889-1415",
          "889-1412",
          "889-1413",
          "889-1414",
          "889-1406",
          "889-1401",
          "889-1402",
          "881-1400",
          "881-1412",
          "881-1302",
          "881-1413",
          "881-1301",
          "881-1414",
          "881-1411",
          "881-1303",
          "884-0100",
          "884-0104",
          "884-0103",
          "884-0102",
          "884-0101",
          "884-0105",
          "889-1300",
          "889-1301",
          "889-1302",
          "889-1200",
          "889-1201",
          "889-0600",
          "889-0602",
          "889-0605",
          "889-0603",
          "889-0611",
          "889-0614",
          "889-0604",
          "889-0615",
          "889-0624",
          "889-0601",
          "889-0612",
          "889-0622",
          "889-0621",
          "889-0626",
          "889-0625",
          "889-0613",
          "889-0617",
          "889-0616",
          "889-0623",
          "883-1300",
          "883-1301",
          "883-1402",
          "883-1302",
          "883-1600",
          "883-0402",
          "883-1602",
          "883-1601",
          "883-1603",
          "883-1604",
          "883-1100",
          "889-0901",
          "889-0903",
          "889-0902",
          "883-1212",
          "883-1101",
          "883-1102",
          "883-1211",
          "883-0303",
          "883-0304",
          "883-0302",
          "883-0306",
          "883-0301",
          "883-0305",
          "882-1100",
          "882-1621",
          "882-1102",
          "882-1622",
          "882-1411",
          "882-1414",
          "882-1415",
          "882-1412",
          "882-1413",
          "882-1101",
          "882-1103",
          "882-0400",
          "882-0302",
          "882-0402",
          "882-0301",
          "882-0401",
          "882-0403",
          "882-0304",
          "882-1200",
          "882-1201",
          "882-1202",
          "882-1203",
          "890-0000",
          "890-0054",
          "891-1545",
          "891-1107",
          "892-0806",
          "890-0008",
          "890-0007",
          "891-1203",
          "890-0003",
          "899-2701",
          "892-0822",
          "892-0801",
          "891-1205",
          "899-3206",
          "899-2706",
          "890-0055",
          "890-0052",
          "891-0112",
          "890-0073",
          "890-0074",
          "892-0876",
          "891-1201",
          "892-0817",
          "890-0021",
          "891-1222",
          "890-0022",
          "891-0111",
          "891-0123",
          "892-0846",
          "892-0804",
          "892-0851",
          "899-2703",
          "891-0116",
          "892-0818",
          "890-0063",
          "890-0064",
          "891-1275",
          "892-0875",
          "891-1103",
          "891-0201",
          "891-0202",
          "891-0206",
          "891-0204",
          "891-0205",
          "891-0203",
          "891-0107",
          "891-0145",
          "892-0836",
          "892-0828",
          "892-0803",
          "891-1501",
          "891-1401",
          "891-1204",
          "892-0837",
          "891-0103",
          "891-1402",
          "890-0038",
          "890-0051",
          "890-0065",
          "890-0084",
          "891-1108",
          "891-1105",
          "891-0101",
          "892-0826",
          "891-0114",
          "899-2531",
          "891-1231",
          "891-0150",
          "892-0862",
          "891-0175",
          "890-0075",
          "891-1420",
          "891-1417",
          "891-1418",
          "891-1414",
          "891-1411",
          "891-1416",
          "891-1415",
          "891-1412",
          "891-1413",
          "891-1419",
          "890-0071",
          "891-0146",
          "892-0802",
          "890-0056",
          "890-0005",
          "890-0004",
          "892-0873",
          "892-0852",
          "891-0144",
          "891-0106",
          "890-0041",
          "892-0835",
          "899-2707",
          "890-0013",
          "892-0813",
          "892-0853",
          "890-0072",
          "891-1403",
          "890-0016",
          "892-0832",
          "892-0838",
          "892-0823",
          "890-0032",
          "891-0109",
          "892-0843",
          "890-0001",
          "890-0014",
          "890-0015",
          "892-0825",
          "892-0872",
          "892-0805",
          "890-0043",
          "890-0034",
          "890-0036",
          "890-0035",
          "890-0045",
          "890-0031",
          "891-0131",
          "891-0141",
          "890-0011",
          "892-0811",
          "890-0012",
          "890-0076",
          "890-0053",
          "891-0108",
          "891-0105",
          "892-0807",
          "892-0845",
          "892-0841",
          "890-0061",
          "891-0115",
          "890-0047",
          "890-0044",
          "890-0081",
          "899-2705",
          "892-0827",
          "892-0854",
          "890-0023",
          "891-0132",
          "891-0122",
          "892-0834",
          "890-0002",
          "891-1202",
          "892-0863",
          "891-1301",
          "892-0847",
          "890-0046",
          "891-0117",
          "890-0033",
          "891-1106",
          "890-0083",
          "891-1541",
          "891-1101",
          "892-0812",
          "890-0026",
          "890-0025",
          "899-2704",
          "890-0068",
          "892-0861",
          "891-1543",
          "891-1302",
          "892-0842",
          "891-0113",
          "891-1102",
          "891-0151",
          "890-0086",
          "892-0855",
          "891-0133",
          "899-2709",
          "892-0848",
          "890-0037",
          "899-2702",
          "892-0831",
          "891-1544",
          "891-0102",
          "892-0824",
          "892-0814",
          "891-1303",
          "891-1304",
          "890-0066",
          "890-0067",
          "892-0833",
          "892-0874",
          "891-1274",
          "890-0069",
          "890-0085",
          "891-1206",
          "891-1305",
          "890-0082",
          "891-1306",
          "892-0821",
          "890-0024",
          "891-1542",
          "890-0042",
          "892-0815",
          "892-0819",
          "892-0816",
          "891-0104",
          "892-0844",
          "891-1104",
          "892-0877",
          "892-0871",
          "890-0062",
          "899-2708",
          "890-0006",
          "891-0143",
          "893-0000",
          "893-1101",
          "893-1102",
          "893-1103",
          "893-0022",
          "893-0004",
          "891-2301",
          "893-0035",
          "893-0042",
          "893-0057",
          "893-0056",
          "893-0011",
          "893-0012",
          "893-0051",
          "893-0067",
          "893-0009",
          "891-2302",
          "891-2312",
          "891-2303",
          "893-0023",
          "893-0131",
          "893-0061",
          "893-0027",
          "893-0032",
          "893-0031",
          "893-0007",
          "899-8511",
          "893-0201",
          "893-0202",
          "899-8512",
          "893-0203",
          "893-0005",
          "893-1602",
          "893-1603",
          "893-1605",
          "893-1604",
          "893-1601",
          "893-0065",
          "893-0001",
          "893-0014",
          "893-0044",
          "893-0132",
          "893-0024",
          "893-0047",
          "893-0016",
          "891-2311",
          "893-0063",
          "893-0015",
          "893-0062",
          "893-0003",
          "893-0054",
          "893-0066",
          "893-0037",
          "893-0045",
          "891-2313",
          "893-0052",
          "893-0033",
          "893-0034",
          "893-0008",
          "893-0064",
          "893-0025",
          "891-2305",
          "893-0055",
          "893-0036",
          "891-2304",
          "891-2306",
          "893-0053",
          "893-0026",
          "893-0021",
          "893-0013",
          "891-2314",
          "891-2321",
          "891-2322",
          "893-0041",
          "893-0002",
          "893-0043",
          "893-0006",
          "893-0046",
          "898-0000",
          "898-0080",
          "898-0008",
          "898-0006",
          "898-0084",
          "898-0082",
          "898-0083",
          "898-0052",
          "898-0058",
          "898-0009",
          "898-0026",
          "898-0028",
          "898-0027",
          "898-0029",
          "898-0003",
          "898-0054",
          "898-0044",
          "898-0098",
          "898-0057",
          "898-0066",
          "898-0076",
          "898-0074",
          "898-0088",
          "898-0099",
          "898-0062",
          "898-0053",
          "898-0094",
          "898-0038",
          "898-0037",
          "898-0018",
          "898-0073",
          "898-0061",
          "898-0055",
          "898-0065",
          "898-0064",
          "898-0097",
          "898-0002",
          "898-0041",
          "898-0042",
          "898-0095",
          "898-0089",
          "898-0092",
          "898-0091",
          "898-0007",
          "898-0017",
          "898-0087",
          "898-0047",
          "898-0046",
          "898-0016",
          "898-0045",
          "898-0025",
          "898-0075",
          "898-0051",
          "898-0012",
          "898-0081",
          "898-0005",
          "898-0024",
          "898-0015",
          "898-0093",
          "898-0021",
          "898-0014",
          "898-0043",
          "898-0048",
          "898-0049",
          "898-0034",
          "898-0035",
          "898-0032",
          "898-0086",
          "898-0085",
          "898-0096",
          "898-0031",
          "898-0001",
          "898-0072",
          "898-0011",
          "898-0004",
          "898-0056",
          "898-0022",
          "898-0033",
          "898-0071",
          "898-0063",
          "898-0036",
          "898-0013",
          "898-0023",
          "899-1600",
          "899-1611",
          "899-1741",
          "899-1624",
          "899-1601",
          "899-1615",
          "899-1616",
          "899-1628",
          "899-1629",
          "899-1613",
          "899-1622",
          "899-1602",
          "899-1603",
          "899-1626",
          "899-1627",
          "899-1617",
          "899-1625",
          "899-1614",
          "899-1621",
          "899-1612",
          "899-1623",
          "899-1604",
          "899-1131",
          "899-0200",
          "899-0137",
          "899-0134",
          "899-0216",
          "899-0341",
          "899-0203",
          "899-0212",
          "899-0125",
          "899-0214",
          "899-0121",
          "899-0122",
          "899-0136",
          "899-0342",
          "899-0123",
          "899-0132",
          "899-0435",
          "899-0202",
          "899-0138",
          "899-0407",
          "899-0401",
          "899-0406",
          "899-0403",
          "899-0402",
          "899-0405",
          "899-0404",
          "899-0215",
          "899-0211",
          "899-0207",
          "899-0213",
          "899-0501",
          "899-0502",
          "899-0133",
          "899-0204",
          "899-0208",
          "899-0217",
          "899-0205",
          "899-0201",
          "899-0124",
          "899-0131",
          "899-0206",
          "899-0126",
          "891-0400",
          "891-0312",
          "891-0315",
          "891-0401",
          "891-0601",
          "891-0602",
          "891-0603",
          "891-0604",
          "891-0314",
          "891-0403",
          "891-0402",
          "891-0313",
          "891-0311",
          "891-0304",
          "891-0404",
          "891-0405",
          "891-0502",
          "891-0507",
          "891-0614",
          "891-0514",
          "891-0513",
          "891-0515",
          "891-0506",
          "891-0503",
          "891-0501",
          "891-0504",
          "891-0621",
          "891-0516",
          "891-0512",
          "891-0511",
          "891-0505",
          "891-0406",
          "891-3100",
          "891-3432",
          "891-3102",
          "891-3202",
          "891-3114",
          "891-3221",
          "891-3116",
          "891-3222",
          "891-3103",
          "891-3112",
          "891-3117",
          "891-3104",
          "891-3115",
          "891-3101",
          "891-3111",
          "891-3113",
          "891-3431",
          "891-3118",
          "891-2100",
          "891-2125",
          "891-2103",
          "899-4631",
          "899-4632",
          "891-2101",
          "891-2122",
          "891-2124",
          "891-2116",
          "891-2121",
          "891-2117",
          "891-2127",
          "891-2114",
          "891-2111",
          "891-2113",
          "891-2104",
          "891-2106",
          "891-2102",
          "891-2115",
          "899-4633",
          "891-2112",
          "891-2123",
          "891-2105",
          "891-2126",
          "895-0000",
          "895-0044",
          "895-0011",
          "895-1402",
          "895-1401",
          "895-0214",
          "895-0077",
          "899-1925",
          "895-0076",
          "895-0035",
          "896-1301",
          "895-0031",
          "896-1203",
          "896-1204",
          "896-1206",
          "896-1205",
          "896-1281",
          "896-1201",
          "896-1202",
          "895-0067",
          "895-0033",
          "895-0052",
          "895-0004",
          "895-0002",
          "895-0041",
          "895-0132",
          "895-1502",
          "895-1503",
          "895-1504",
          "895-1501",
          "895-0073",
          "899-1922",
          "895-0066",
          "895-0034",
          "895-0061",
          "896-1101",
          "896-1521",
          "896-1602",
          "896-1412",
          "896-1512",
          "896-1601",
          "896-1411",
          "895-0213",
          "895-0001",
          "895-0022",
          "895-0062",
          "895-0071",
          "895-0131",
          "895-0211",
          "895-0006",
          "895-0072",
          "895-1106",
          "895-1101",
          "895-1103",
          "895-1105",
          "895-1102",
          "895-1104",
          "895-0024",
          "895-0005",
          "895-0042",
          "895-0003",
          "895-0055",
          "899-1801",
          "895-0027",
          "895-0064",
          "895-0074",
          "895-0075",
          "895-0051",
          "895-0026",
          "895-0053",
          "895-0012",
          "895-1203",
          "895-1201",
          "895-1202",
          "899-1921",
          "899-1924",
          "895-0065",
          "895-0043",
          "895-0013",
          "895-0056",
          "895-0025",
          "895-0021",
          "895-0007",
          "895-0036",
          "895-0032",
          "899-1923",
          "899-1802",
          "895-0212",
          "895-0023",
          "895-0133",
          "895-0063",
          "895-0054",
          "899-2500",
          "899-2522",
          "899-2505",
          "899-3121",
          "899-2521",
          "899-2512",
          "899-2506",
          "899-2441",
          "899-2524",
          "899-2504",
          "899-2511",
          "899-2501",
          "899-2515",
          "899-2516",
          "899-2443",
          "899-2502",
          "899-2514",
          "899-2442",
          "899-2523",
          "899-2503",
          "899-2513",
          "899-2203",
          "899-2204",
          "899-2432",
          "899-2202",
          "899-2434",
          "899-2433",
          "899-2431",
          "899-2201",
          "899-2311",
          "899-2421",
          "899-3101",
          "899-3102",
          "899-3103",
          "899-3203",
          "899-3305",
          "899-3304",
          "899-3306",
          "899-3307",
          "899-3308",
          "899-3302",
          "899-3301",
          "899-3221",
          "899-3303",
          "899-3309",
          "899-3311",
          "899-8600",
          "899-8211",
          "899-8311",
          "899-8102",
          "899-8421",
          "899-8213",
          "899-8422",
          "899-8106",
          "899-8423",
          "899-8105",
          "899-8212",
          "899-8424",
          "899-8103",
          "899-8104",
          "899-8101",
          "899-8601",
          "899-8609",
          "899-8602",
          "899-8603",
          "899-8604",
          "899-8605",
          "899-8606",
          "899-8607",
          "899-8608",
          "899-4102",
          "899-4103",
          "899-4101",
          "899-4300",
          "899-4203",
          "899-4204",
          "899-4201",
          "899-4202",
          "899-4461",
          "899-4318",
          "899-4317",
          "899-4313",
          "899-4316",
          "899-4314",
          "899-4303",
          "899-4304",
          "899-4355",
          "899-4305",
          "899-4462",
          "899-4301",
          "899-4463",
          "899-4331",
          "899-4351",
          "899-4302",
          "899-4332",
          "899-4311",
          "899-4344",
          "899-4342",
          "899-4343",
          "899-4341",
          "899-4354",
          "899-4356",
          "899-4321",
          "899-4322",
          "899-4345",
          "899-4346",
          "899-4323",
          "899-4325",
          "899-4324",
          "899-4315",
          "899-4352",
          "899-4353",
          "899-4312",
          "899-5118",
          "899-5116",
          "899-5106",
          "899-5105",
          "899-5103",
          "899-5113",
          "899-5114",
          "899-5121",
          "899-5102",
          "899-5101",
          "899-5115",
          "899-5104",
          "899-5111",
          "899-5112",
          "899-5117",
          "899-4504",
          "899-4503",
          "899-4502",
          "899-4501",
          "899-6604",
          "899-6504",
          "899-6602",
          "899-6502",
          "899-6506",
          "899-6507",
          "899-6503",
          "899-6603",
          "899-6601",
          "899-6501",
          "899-6505",
          "899-6401",
          "899-6405",
          "899-6402",
          "899-6404",
          "899-6403",
          "899-6301",
          "899-6302",
          "899-6303",
          "896-0000",
          "896-0061",
          "896-0001",
          "896-0015",
          "896-0065",
          "896-0036",
          "896-0027",
          "899-2103",
          "896-0011",
          "896-0025",
          "896-0057",
          "896-0002",
          "896-0079",
          "899-2102",
          "896-0052",
          "896-0051",
          "896-0041",
          "896-0003",
          "896-0075",
          "896-0074",
          "896-0063",
          "896-0034",
          "896-0013",
          "896-0016",
          "896-0072",
          "896-0004",
          "896-0023",
          "896-0026",
          "896-0035",
          "896-0021",
          "896-0046",
          "896-0078",
          "896-0076",
          "896-0017",
          "896-0055",
          "896-0012",
          "896-0033",
          "896-0005",
          "896-0032",
          "896-0044",
          "896-0073",
          "896-0066",
          "896-0058",
          "896-0064",
          "896-0069",
          "896-0062",
          "896-0006",
          "896-0031",
          "896-0054",
          "896-0028",
          "896-0067",
          "896-0071",
          "896-0077",
          "896-0037",
          "896-0045",
          "896-0024",
          "896-0068",
          "896-0022",
          "896-0043",
          "899-2101",
          "896-0042",
          "896-0014",
          "896-0056",
          "897-0000",
          "898-0221",
          "897-1201",
          "897-1302",
          "897-1301",
          "897-0004",
          "897-0003",
          "897-1122",
          "897-0008",
          "897-0007",
          "897-1123",
          "897-0002",
          "899-3611",
          "897-1121",
          "897-0009",
          "897-0031",
          "897-0005",
          "897-0006",
          "897-1125",
          "897-1124",
          "897-0001",
          "899-3405",
          "899-3516",
          "899-3401",
          "899-3403",
          "899-3513",
          "899-3402",
          "899-3404",
          "899-3515",
          "899-3514",
          "899-3512",
          "899-3511",
          "898-0212",
          "898-0211",
          "898-0102",
          "898-0101",
          "899-7100",
          "899-7401",
          "899-7402",
          "899-8312",
          "899-7512",
          "899-7511",
          "899-7403",
          "899-7503",
          "899-7513",
          "899-7104",
          "899-7211",
          "899-7103",
          "899-7212",
          "899-7102",
          "899-7101",
          "899-7603",
          "899-7601",
          "899-7602",
          "894-0000",
          "894-0501",
          "894-0622",
          "894-0625",
          "894-0507",
          "894-0511",
          "894-0627",
          "894-0624",
          "894-0504",
          "894-0513",
          "894-0505",
          "894-0506",
          "894-0512",
          "894-0623",
          "894-0502",
          "894-0626",
          "894-0621",
          "894-0508",
          "894-0503",
          "894-1201",
          "894-1321",
          "894-1203",
          "894-1115",
          "894-1111",
          "894-1116",
          "894-1202",
          "894-1114",
          "894-1113",
          "894-1205",
          "894-1304",
          "894-1204",
          "894-1112",
          "894-0773",
          "894-0043",
          "894-0041",
          "894-0042",
          "894-0061",
          "894-0351",
          "894-0002",
          "894-0062",
          "894-0352",
          "894-0011",
          "894-0017",
          "894-0774",
          "894-0021",
          "894-0024",
          "894-0034",
          "894-0108",
          "894-0008",
          "894-0068",
          "894-0013",
          "894-0031",
          "894-0022",
          "894-0046",
          "894-0006",
          "894-0012",
          "894-0771",
          "894-0025",
          "894-0776",
          "894-0005",
          "894-0035",
          "894-0027",
          "894-0001",
          "894-0009",
          "894-0047",
          "894-0003",
          "894-0063",
          "894-0023",
          "894-0036",
          "894-0775",
          "894-0772",
          "894-0048",
          "894-0004",
          "894-0044",
          "894-0014",
          "894-0045",
          "894-0016",
          "894-0015",
          "894-0026",
          "894-0032",
          "894-0033",
          "894-0007",
          "897-0200",
          "891-0705",
          "891-0701",
          "891-0703",
          "891-0704",
          "891-0702",
          "897-0212",
          "897-0213",
          "897-0131",
          "897-0202",
          "897-0201",
          "897-0133",
          "897-0223",
          "897-0221",
          "897-0222",
          "897-0132",
          "897-0203",
          "897-0205",
          "897-0215",
          "897-0204",
          "897-0214",
          "897-0224",
          "897-0211",
          "897-0301",
          "897-0302",
          "891-0911",
          "897-0305",
          "897-0303",
          "897-0306",
          "897-0304",
          "891-0912",
          "895-2500",
          "895-2504",
          "895-2501",
          "895-2522",
          "895-2507",
          "895-2523",
          "895-2513",
          "895-2528",
          "895-2502",
          "895-2634",
          "895-2631",
          "895-2511",
          "895-2503",
          "895-2525",
          "895-2529",
          "895-2441",
          "895-2527",
          "895-2524",
          "895-2521",
          "895-2506",
          "895-2442",
          "895-2633",
          "895-2632",
          "895-2526",
          "895-2505",
          "895-2512",
          "895-2635",
          "895-2811",
          "895-2704",
          "895-2708",
          "895-2812",
          "895-2705",
          "895-2702",
          "895-2706",
          "895-2707",
          "895-2703",
          "895-2701",
          "895-2813",
          "899-5400",
          "899-5653",
          "899-5544",
          "899-5213",
          "899-5214",
          "899-5241",
          "899-5222",
          "899-5203",
          "899-5223",
          "899-5211",
          "899-5212",
          "899-5231",
          "899-5201",
          "899-5204",
          "899-5202",
          "899-5221",
          "899-5215",
          "899-5542",
          "899-5301",
          "899-5302",
          "899-5303",
          "899-5304",
          "899-5305",
          "899-5306",
          "899-5307",
          "899-5308",
          "899-5541",
          "899-5545",
          "899-5412",
          "899-5543",
          "899-5405",
          "899-5401",
          "899-5413",
          "899-5654",
          "899-5404",
          "899-5402",
          "899-5411",
          "899-5656",
          "899-5433",
          "899-5431",
          "899-5421",
          "899-5652",
          "899-5414",
          "899-5655",
          "899-5403",
          "899-5422",
          "899-5432",
          "899-5651",
          "890-0901",
          "890-0902",
          "890-0903",
          "891-5200",
          "891-5204",
          "891-5101",
          "891-5205",
          "891-5203",
          "891-5202",
          "891-5301",
          "891-5201",
          "895-1800",
          "895-1814",
          "895-2104",
          "895-2131",
          "895-1722",
          "895-2201",
          "895-2102",
          "895-2103",
          "895-1805",
          "895-1802",
          "895-2101",
          "895-1816",
          "895-1813",
          "895-1806",
          "895-1811",
          "895-1812",
          "895-2202",
          "895-2203",
          "895-1815",
          "895-1807",
          "895-1801",
          "895-1723",
          "895-1804",
          "895-1803",
          "895-1721",
          "895-1817",
          "899-1400",
          "899-1402",
          "899-1212",
          "899-1301",
          "899-1303",
          "899-1501",
          "899-1321",
          "899-1304",
          "899-1403",
          "899-1401",
          "899-1302",
          "899-1211",
          "899-6200",
          "899-6204",
          "899-6103",
          "899-6104",
          "899-6202",
          "899-6205",
          "899-6201",
          "899-6203",
          "899-6206",
          "899-6101",
          "899-6102",
          "899-6105",
          "899-6207",
          "899-7300",
          "899-7309",
          "899-7308",
          "899-7305",
          "899-7302",
          "899-7306",
          "899-8313",
          "899-7301",
          "899-7303",
          "899-7307",
          "899-7304",
          "893-1600",
          "893-1612",
          "893-1611",
          "893-1615",
          "893-1613",
          "893-1614",
          "893-2300",
          "893-2301",
          "893-2302",
          "893-2402",
          "893-2401",
          "893-2303",
          "893-2500",
          "893-2601",
          "893-2603",
          "893-2602",
          "893-2604",
          "893-2501",
          "893-2502",
          "893-2505",
          "893-2504",
          "893-2503",
          "893-1200",
          "893-1203",
          "893-1511",
          "893-1401",
          "893-1204",
          "893-1207",
          "893-1201",
          "893-1202",
          "893-1206",
          "893-1402",
          "893-1205",
          "891-3600",
          "891-3606",
          "891-3607",
          "891-3601",
          "891-3604",
          "891-3602",
          "891-3603",
          "891-3605",
          "891-3700",
          "891-3703",
          "891-3706",
          "891-3701",
          "891-3704",
          "891-3705",
          "891-3702",
          "891-4200",
          "891-4311",
          "891-4203",
          "891-4404",
          "891-4206",
          "891-4208",
          "891-4409",
          "891-4405",
          "891-4207",
          "891-4204",
          "891-4201",
          "891-4408",
          "891-4403",
          "891-4406",
          "891-4312",
          "891-4205",
          "891-4401",
          "891-4402",
          "891-4407",
          "891-4202",
          "894-3100",
          "894-3214",
          "894-3107",
          "894-3106",
          "894-3104",
          "894-3101",
          "894-3213",
          "894-3103",
          "894-3211",
          "894-3212",
          "894-3105",
          "894-3102",
          "894-3300",
          "894-3302",
          "894-3632",
          "894-3413",
          "894-3305",
          "894-3411",
          "894-3412",
          "894-3522",
          "894-3304",
          "894-3303",
          "894-3521",
          "894-3523",
          "894-3631",
          "894-3633",
          "894-3301",
          "894-1500",
          "894-2234",
          "894-1511",
          "894-2411",
          "894-1744",
          "894-1513",
          "894-1742",
          "894-2501",
          "894-2142",
          "894-2236",
          "894-1524",
          "894-2502",
          "894-2235",
          "894-2231",
          "894-1512",
          "894-2232",
          "894-1522",
          "894-1515",
          "894-2413",
          "894-2417",
          "894-1851",
          "894-1854",
          "894-1746",
          "894-1853",
          "894-2237",
          "894-1852",
          "894-1743",
          "894-1508",
          "894-1503",
          "894-1504",
          "894-1507",
          "894-1501",
          "894-1506",
          "894-1505",
          "894-1502",
          "894-1510",
          "894-1509",
          "894-2402",
          "894-2403",
          "894-1741",
          "894-2404",
          "894-2144",
          "894-2141",
          "894-2412",
          "894-1521",
          "894-2322",
          "894-2401",
          "894-1514",
          "894-1523",
          "894-2416",
          "894-2415",
          "894-1531",
          "894-2143",
          "894-2321",
          "894-1855",
          "894-2233",
          "894-2323",
          "894-2414",
          "894-1745",
          "894-2601",
          "894-0100",
          "894-0411",
          "894-0333",
          "894-0412",
          "894-0323",
          "894-0332",
          "894-0104",
          "894-0324",
          "894-0105",
          "894-0331",
          "894-0322",
          "894-0102",
          "894-0321",
          "894-0103",
          "894-0107",
          "894-0106",
          "894-0101",
          "891-6200",
          "891-6201",
          "891-6162",
          "891-6231",
          "891-6221",
          "891-6217",
          "891-6141",
          "891-6228",
          "891-6213",
          "891-6142",
          "891-6161",
          "891-6233",
          "891-6227",
          "891-6224",
          "891-6164",
          "891-6163",
          "891-6216",
          "891-6229",
          "891-6144",
          "891-6151",
          "891-6143",
          "891-6222",
          "891-6154",
          "891-6152",
          "891-6223",
          "891-6232",
          "891-6215",
          "891-6212",
          "891-6203",
          "891-6211",
          "891-6153",
          "891-6214",
          "891-6226",
          "891-6225",
          "891-6202",
          "891-7100",
          "891-7116",
          "891-7114",
          "891-7104",
          "891-7422",
          "891-7113",
          "891-7101",
          "891-7102",
          "891-7425",
          "891-7423",
          "891-7115",
          "891-7112",
          "891-7105",
          "891-7421",
          "891-7111",
          "891-7424",
          "891-7426",
          "891-7103",
          "891-7600",
          "891-7605",
          "891-7611",
          "891-7622",
          "891-7603",
          "891-7621",
          "891-7623",
          "891-7624",
          "891-7731",
          "891-7612",
          "891-7604",
          "891-7602",
          "891-7601",
          "891-8300",
          "891-8322",
          "891-8221",
          "891-8321",
          "891-8201",
          "891-8324",
          "891-8327",
          "891-8114",
          "891-8111",
          "891-8323",
          "891-8216",
          "891-8116",
          "891-8329",
          "891-8328",
          "891-8112",
          "891-8117",
          "891-8326",
          "891-8115",
          "891-8113",
          "891-8325",
          "891-9100",
          "891-9114",
          "891-9115",
          "891-9116",
          "891-9131",
          "891-9125",
          "891-9102",
          "891-9101",
          "891-9132",
          "891-9136",
          "891-9133",
          "891-9122",
          "891-9103",
          "891-9111",
          "891-9135",
          "891-9134",
          "891-9104",
          "891-9121",
          "891-9124",
          "891-9123",
          "891-9113",
          "891-9112",
          "891-9200",
          "891-9206",
          "891-9211",
          "891-9201",
          "891-9221",
          "891-9234",
          "891-9204",
          "891-9205",
          "891-9212",
          "891-9207",
          "891-9233",
          "891-9203",
          "891-9232",
          "891-9223",
          "891-9213",
          "891-9231",
          "891-9214",
          "891-9222",
          "891-9224",
          "891-9215",
          "891-9202",
          "891-9300",
          "891-9304",
          "891-9309",
          "891-9303",
          "891-9301",
          "891-9308",
          "891-9305",
          "891-9306",
          "891-9307",
          "891-9302",
          "900-0000",
          "901-0154",
          "900-0002",
          "902-0067",
          "900-0029",
          "901-0143",
          "900-0003",
          "900-0005",
          "900-0021",
          "900-0011",
          "901-0153",
          "902-0073",
          "900-0026",
          "901-0148",
          "900-0006",
          "901-0152",
          "901-0142",
          "900-0028",
          "901-0155",
          "901-0151",
          "901-0146",
          "900-0033",
          "900-0015",
          "902-0075",
          "900-0024",
          "902-0078",
          "903-0813",
          "903-0811",
          "903-0824",
          "903-0804",
          "903-0823",
          "903-0802",
          "903-0815",
          "903-0821",
          "903-0807",
          "903-0814",
          "903-0826",
          "903-0801",
          "903-0803",
          "903-0806",
          "903-0812",
          "903-0822",
          "903-0805",
          "903-0816",
          "903-0825",
          "901-0141",
          "900-0023",
          "902-0066",
          "901-0145",
          "901-0156",
          "900-0037",
          "900-0025",
          "902-0065",
          "901-0144",
          "900-0012",
          "900-0035",
          "902-0074",
          "902-0077",
          "900-0036",
          "902-0071",
          "900-0034",
          "900-0022",
          "902-0061",
          "902-0072",
          "900-0016",
          "902-0068",
          "900-0013",
          "900-0014",
          "902-0062",
          "902-0069",
          "900-0032",
          "900-0001",
          "902-0063",
          "901-0147",
          "900-0004",
          "900-0027",
          "902-0076",
          "902-0064",
          "900-0031",
          "901-2200",
          "901-2206",
          "901-2205",
          "901-2201",
          "901-2221",
          "901-2204",
          "901-2227",
          "901-2225",
          "901-2223",
          "901-2226",
          "901-2214",
          "901-2207",
          "901-2211",
          "901-2222",
          "901-2216",
          "901-2213",
          "901-2212",
          "901-2203",
          "901-2202",
          "901-2215",
          "901-2224",
          "907-0000",
          "907-0024",
          "907-0023",
          "907-0332",
          "907-0022",
          "907-0001",
          "907-0453",
          "907-0452",
          "907-0242",
          "907-0014",
          "907-0241",
          "907-0004",
          "907-0021",
          "907-0333",
          "907-0013",
          "907-0003",
          "907-0331",
          "907-0451",
          "907-0002",
          "907-0012",
          "907-0243",
          "907-0244",
          "907-0011",
          "901-2100",
          "901-2114",
          "901-2132",
          "901-2128",
          "901-2123",
          "901-2121",
          "901-2113",
          "901-2111",
          "901-2133",
          "901-2124",
          "901-2122",
          "901-2112",
          "901-2104",
          "901-2103",
          "901-2125",
          "901-2101",
          "901-2102",
          "901-2131",
          "901-2134",
          "901-2126",
          "901-2127",
          "905-0000",
          "905-0021",
          "905-0003",
          "905-2263",
          "905-0001",
          "905-1152",
          "905-1142",
          "905-0006",
          "905-0009",
          "905-1634",
          "905-2267",
          "905-2268",
          "905-0019",
          "905-0017",
          "905-0018",
          "905-0016",
          "905-0015",
          "905-1146",
          "905-0002",
          "905-1633",
          "905-1155",
          "905-2262",
          "905-1145",
          "905-0026",
          "905-0024",
          "905-2173",
          "905-0013",
          "905-1141",
          "905-0025",
          "905-1154",
          "905-1156",
          "905-0023",
          "905-1635",
          "905-2266",
          "905-1147",
          "905-2265",
          "905-2261",
          "905-2172",
          "905-1153",
          "905-1144",
          "905-0004",
          "905-0012",
          "905-0005",
          "905-2269",
          "905-1151",
          "905-2171",
          "905-1143",
          "905-0014",
          "905-2264",
          "905-0011",
          "905-1631",
          "905-0007",
          "905-0008",
          "905-0022",
          "905-1632",
          "901-0300",
          "901-0301",
          "901-0323",
          "901-0363",
          "901-0342",
          "901-0361",
          "901-0344",
          "901-0332",
          "901-0325",
          "901-0334",
          "901-0313",
          "901-0303",
          "901-0312",
          "901-0354",
          "901-0324",
          "901-0341",
          "901-0335",
          "901-0314",
          "901-0364",
          "901-0302",
          "901-0311",
          "901-0353",
          "901-0315",
          "901-0321",
          "901-0351",
          "901-0304",
          "901-0305",
          "901-0306",
          "901-0345",
          "901-0362",
          "901-0331",
          "901-0336",
          "901-0333",
          "901-0343",
          "901-0352",
          "901-0322",
          "904-0000",
          "904-2152",
          "904-0012",
          "904-2172",
          "904-2141",
          "904-0031",
          "904-2163",
          "904-2162",
          "904-0005",
          "904-0023",
          "904-2145",
          "904-2161",
          "904-2166",
          "904-0001",
          "904-0021",
          "904-2175",
          "904-2144",
          "904-0002",
          "904-0003",
          "904-0022",
          "904-2171",
          "904-2143",
          "904-0004",
          "904-0011",
          "904-2164",
          "904-0014",
          "904-2142",
          "904-2154",
          "904-2173",
          "904-2151",
          "904-2153",
          "904-2156",
          "904-0035",
          "904-2155",
          "904-2165",
          "904-0013",
          "904-0032",
          "904-0006",
          "904-0034",
          "904-0033",
          "904-2174",
          "901-0200",
          "901-0232",
          "901-0243",
          "901-0223",
          "901-0202",
          "901-0231",
          "901-0204",
          "901-0244",
          "901-0221",
          "901-0233",
          "901-0212",
          "901-0213",
          "901-0242",
          "901-0234",
          "901-0215",
          "901-0222",
          "901-0241",
          "901-0225",
          "901-0235",
          "901-0203",
          "901-0205",
          "901-0211",
          "901-0214",
          "901-0201",
          "901-0224",
          "904-2200",
          "904-2212",
          "904-2245",
          "904-2214",
          "904-1106",
          "904-1103",
          "904-1102",
          "904-1101",
          "904-1107",
          "904-1104",
          "904-1115",
          "904-1114",
          "904-1105",
          "904-1112",
          "904-1111",
          "904-1108",
          "904-1113",
          "904-2204",
          "904-2222",
          "904-2211",
          "904-2244",
          "904-2205",
          "904-2224",
          "904-2313",
          "904-2317",
          "904-2311",
          "904-2315",
          "904-2316",
          "904-2314",
          "904-2312",
          "904-2241",
          "904-2203",
          "904-2232",
          "904-2236",
          "904-2225",
          "904-2223",
          "904-2201",
          "904-2231",
          "904-2234",
          "904-2221",
          "904-2242",
          "904-2213",
          "904-2202",
          "904-2233",
          "904-2226",
          "904-2235",
          "904-2215",
          "904-2243",
          "904-2303",
          "904-2306",
          "904-2421",
          "904-2422",
          "904-2424",
          "904-2305",
          "904-2301",
          "904-2425",
          "904-2302",
          "904-2307",
          "904-2428",
          "904-2426",
          "904-2423",
          "904-2304",
          "904-2427",
          "906-0000",
          "906-0502",
          "906-0503",
          "906-0505",
          "906-0507",
          "906-0504",
          "906-0506",
          "906-0501",
          "906-0204",
          "906-0202",
          "906-0201",
          "906-0203",
          "906-0102",
          "906-0108",
          "906-0109",
          "906-0107",
          "906-0105",
          "906-0106",
          "906-0104",
          "906-0103",
          "906-0101",
          "906-0304",
          "906-0302",
          "906-0301",
          "906-0306",
          "906-0303",
          "906-0305",
          "906-0421",
          "906-0004",
          "906-0001",
          "906-0002",
          "906-0015",
          "906-0003",
          "906-0013",
          "906-0008",
          "906-0012",
          "906-0006",
          "906-0005",
          "906-0007",
          "906-0011",
          "906-0422",
          "906-0014",
          "901-1400",
          "901-1204",
          "901-1202",
          "901-1203",
          "901-1208",
          "901-1205",
          "901-1206",
          "901-1207",
          "901-1201",
          "901-1401",
          "901-1413",
          "901-1411",
          "901-1403",
          "901-1415",
          "901-1412",
          "901-1414",
          "901-1402",
          "901-1405",
          "901-1404",
          "901-1406",
          "901-0617",
          "901-0606",
          "901-0614",
          "901-0608",
          "901-0601",
          "901-0607",
          "901-0613",
          "901-0604",
          "901-0612",
          "901-0605",
          "901-0602",
          "901-0603",
          "901-0611",
          "901-0618",
          "901-0615",
          "901-0616",
          "901-0619",
          "901-1502",
          "901-1504",
          "901-1514",
          "901-1501",
          "901-1511",
          "901-1505",
          "901-1516",
          "901-1503",
          "901-1513",
          "901-1515",
          "901-1512",
          "901-1407",
          "905-1400",
          "905-1503",
          "905-1504",
          "905-1428",
          "905-1423",
          "905-1429",
          "905-1501",
          "905-1412",
          "905-1416",
          "905-1422",
          "905-1425",
          "905-1426",
          "905-1502",
          "905-1417",
          "905-1415",
          "905-1414",
          "905-1413",
          "905-1421",
          "905-1424",
          "905-1411",
          "905-1427",
          "905-1300",
          "905-1308",
          "905-1317",
          "905-1305",
          "905-1306",
          "905-1313",
          "905-1303",
          "905-1311",
          "905-1302",
          "905-1316",
          "905-1315",
          "905-1301",
          "905-1314",
          "905-1318",
          "905-1304",
          "905-1307",
          "905-1319",
          "905-1312",
          "905-1200",
          "905-1206",
          "905-1203",
          "905-1205",
          "905-1204",
          "905-1201",
          "905-1202",
          "905-0400",
          "905-0411",
          "905-0428",
          "905-0403",
          "905-0427",
          "905-0404",
          "905-0406",
          "905-0421",
          "905-0413",
          "905-0422",
          "905-0414",
          "905-0426",
          "905-0405",
          "905-0415",
          "905-0402",
          "905-0424",
          "905-0401",
          "905-0423",
          "905-0425",
          "905-0412",
          "905-0200",
          "905-0206",
          "905-0221",
          "905-0228",
          "905-0229",
          "905-0217",
          "905-0223",
          "905-0212",
          "905-0202",
          "905-0209",
          "905-0201",
          "905-0226",
          "905-0225",
          "905-0203",
          "905-0208",
          "905-0227",
          "905-0213",
          "905-0214",
          "905-0204",
          "905-0222",
          "905-0215",
          "905-0216",
          "905-0211",
          "905-0207",
          "905-0218",
          "905-0224",
          "905-0205",
          "905-0219",
          "904-0400",
          "904-0402",
          "904-0411",
          "904-0403",
          "904-0404",
          "904-0412",
          "904-0415",
          "904-0401",
          "904-0413",
          "904-0414",
          "904-0417",
          "904-0416",
          "904-1300",
          "904-1304",
          "904-1302",
          "904-1303",
          "904-1301",
          "904-1200",
          "904-1202",
          "904-1201",
          "904-1203",
          "905-0500",
          "905-0503",
          "905-0505",
          "905-0504",
          "905-0501",
          "905-0502",
          "904-0300",
          "904-0303",
          "904-0321",
          "904-0328",
          "904-0316",
          "904-0313",
          "904-0302",
          "904-0327",
          "904-0301",
          "904-0325",
          "904-0304",
          "904-0323",
          "904-0315",
          "904-0326",
          "904-0305",
          "904-0324",
          "904-0322",
          "904-0311",
          "904-0312",
          "904-0314",
          "904-0200",
          "904-0203",
          "904-0205",
          "904-0201",
          "904-0204",
          "904-0202",
          "904-0100",
          "904-0102",
          "904-0107",
          "904-0101",
          "904-0117",
          "904-0103",
          "904-0111",
          "904-0106",
          "904-0116",
          "904-0104",
          "904-0112",
          "904-0114",
          "904-0115",
          "904-0113",
          "904-0105",
          "901-2300",
          "901-2316",
          "901-2313",
          "901-2314",
          "901-2315",
          "901-2311",
          "901-2301",
          "901-2317",
          "901-2303",
          "901-2302",
          "901-2305",
          "901-2321",
          "901-2304",
          "901-2306",
          "901-2312",
          "901-2400",
          "901-2407",
          "901-2422",
          "901-2403",
          "901-2417",
          "901-2412",
          "901-2423",
          "901-2414",
          "901-2401",
          "901-2404",
          "901-2413",
          "901-2406",
          "901-2402",
          "901-2421",
          "901-2411",
          "901-2424",
          "901-2415",
          "901-2405",
          "901-2416",
          "903-0100",
          "903-0105",
          "903-0113",
          "903-0115",
          "903-0125",
          "903-0121",
          "903-0117",
          "903-0103",
          "903-0101",
          "903-0112",
          "903-0102",
          "903-0104",
          "903-0116",
          "903-0122",
          "903-0118",
          "903-0124",
          "903-0129",
          "903-0126",
          "903-0123",
          "903-0114",
          "903-0127",
          "903-0128",
          "903-0111",
          "901-1300",
          "901-1304",
          "901-1301",
          "901-1302",
          "901-1303",
          "901-1100",
          "901-1105",
          "901-1101",
          "901-1111",
          "901-1114",
          "901-1113",
          "901-1117",
          "901-1116",
          "901-1102",
          "901-1104",
          "901-1112",
          "901-1115",
          "901-1103",
          "901-3500",
          "901-3502",
          "901-3501",
          "901-3400",
          "901-3311",
          "901-3401",
          "901-3403",
          "901-3312",
          "901-3402",
          "901-3700",
          "901-3703",
          "901-3701",
          "901-3702",
          "901-3601",
          "901-3800",
          "901-3806",
          "901-3801",
          "901-3803",
          "901-3805",
          "901-3802",
          "901-3804",
          "901-3900",
          "901-3902",
          "901-3903",
          "901-3901",
          "905-0700",
          "905-0703",
          "905-0704",
          "905-0701",
          "905-0705",
          "905-0702",
          "905-0600",
          "905-0604",
          "905-0601",
          "905-0602",
          "905-0605",
          "905-0603",
          "901-3100",
          "901-3103",
          "901-3101",
          "901-3138",
          "901-3105",
          "901-3106",
          "901-3123",
          "901-3132",
          "901-3121",
          "901-3122",
          "901-3133",
          "901-3115",
          "901-3134",
          "901-3114",
          "901-3107",
          "901-3113",
          "901-3125",
          "901-3136",
          "901-3124",
          "901-3135",
          "901-3131",
          "901-3108",
          "901-3102",
          "901-3112",
          "901-3104",
          "901-3111",
          "901-3137",
          "901-0400",
          "901-0514",
          "901-0503",
          "901-0405",
          "901-0412",
          "901-0502",
          "901-0416",
          "901-0512",
          "901-0415",
          "901-0504",
          "901-0401",
          "901-0413",
          "901-0404",
          "901-0414",
          "901-0411",
          "901-0402",
          "901-0516",
          "901-0501",
          "901-0513",
          "901-0417",
          "901-0511",
          "901-0406",
          "901-0515",
          "901-0403",
          "906-0600",
          "906-0601",
          "906-0602",
          "906-0603",
          "907-1435",
          "907-1542",
          "907-1541",
          "907-1311",
          "907-1221",
          "907-1432",
          "907-1543",
          "907-1431",
          "907-1101",
          "907-1434",
          "907-1433",
          "907-1751",
          "907-1544",
          "907-1800",
          "907-1801"
        ],
        "state": [
          "北海道",
          "青森県",
          "岩手県",
          "宮城県",
          "秋田県",
          "山形県",
          "福島県",
          "茨城県",
          "栃木県",
          "群馬県",
          "埼玉県",
          "千葉県",
          "東京都",
          "神奈川県",
          "新潟県",
          "富山県",
          "石川県",
          "福井県",
          "山梨県",
          "長野県",
          "岐阜県",
          "静岡県",
          "愛知県",
          "三重県",
          "滋賀県",
          "京都府",
          "大阪府",
          "兵庫県",
          "奈良県",
          "和歌山県",
          "鳥取県",
          "島根県",
          "岡山県",
          "広島県",
          "山口県",
          "徳島県",
          "香川県",
          "愛媛県",
          "高知県",
          "福岡県",
          "佐賀県",
          "長崎県",
          "熊本県",
          "大分県",
          "宮崎県",
          "鹿児島県",
          "沖縄県"
        ],
        "state_abbr": [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "32",
          "33",
          "34",
          "35",
          "36",
          "37",
          "38",
          "39",
          "40",
          "41",
          "42",
          "43",
          "44",
          "45",
          "46",
          "47"
        ],
        "street_name": [
          "#{Name.first_name}",
          "#{Name.last_name}"
        ]
      },
      "adjective": {
        "negative": [
          "攻撃的な",
          "イライラする",
          "不安な",
          "傲慢な",
          "恥ずかしい",
          "平均的な",
          "ひどい",
          "悪い",
          "血まみれな",
          "退屈な",
          "慎重な",
          "心配性な",
          "混乱した",
          "クレイジーな",
          "不気味な",
          "残酷な",
          "危険な",
          "鬱陶しい",
          "乱れた",
          "邪悪な",
          "高い",
          "不潔な",
          "愚かな",
          "脆い",
          "弱い",
          "恐ろしい",
          "悲嘆な",
          "グロテスクな",
          "無力な",
          "病的な",
          "嫉妬深い",
          "ジタバタした",
          "怠け者な",
          "寂しい",
          "怠け者な",
          "泥臭い",
          "汚い",
          "やんちゃな",
          "神経質な",
          "不愉快な",
          "変な",
          "古臭い",
          "パニック的な",
          "貧しい",
          "かび臭い",
          "困惑した",
          "いやらしい",
          "怖い",
          "自分勝手な",
          "恥ずかしがり屋な",
          "くだらない",
          "ぼーっとした",
          "モヤモヤした",
          "痛い",
          "荒れ模様の",
          "軽率な",
          "疲れる",
          "困った",
          "醜い",
          "興味がない",
          "動揺した",
          "堅苦しい",
          "荒々しい",
          "臆病な",
          "誤った",
          "手抜きな"
        ],
        "positive": [
          "愛らしい",
          "冒険的な",
          "積極的な",
          "魅力的な",
          "美しい",
          "頭脳明晰な",
          "勇敢な",
          "明るい",
          "穏やかな",
          "チャーミングな",
          "清潔な",
          "賢い",
          "カラフルな",
          "快適な",
          "協調的な",
          "勇ましい",
          "好奇心旺盛な",
          "かわいい",
          "楽しい",
          "決心した",
          "エレガントな",
          "魅惑的な",
          "元気な",
          "エネルギッシュな",
          "熱狂的な",
          "興奮した",
          "公平な",
          "忠実な",
          "有名な",
          "おしゃれな",
          "ファンタスティックな",
          "フレンドリーな",
          "面白い",
          "優しい",
          "才能豊かな",
          "グラマラスな",
          "きらびやかな",
          "輝かしい",
          "良い",
          "華やかな",
          "優美な",
          "ハンサムな",
          "幸せな",
          "健康的な",
          "役に立つ",
          "陽気な",
          "安い",
          "無邪気な",
          "活発な",
          "幸運な",
          "壮大な",
          "モダンな",
          "素敵な",
          "広い心の",
          "卓越した",
          "完璧な",
          "心地よい",
          "パワフルな",
          "貴重な",
          "誇り高い",
          "趣のある",
          "豊かな",
          "光沢のある",
          "微笑ましい",
          "きらびやかな",
          "素晴らしい",
          "汚れのない",
          "成功した",
          "すごい",
          "才能ある",
          "美味しい",
          "ありがたい",
          "思いやりのある",
          "広い",
          "勝利の",
          "みずみずしい",
          "気の利いた"
        ]
      },
      "ancient": {
        "god": [
          "アフロディテ",
          "アポロン",
          "アレス",
          "アルテミス",
          "アテナ",
          "デメテル",
          "ディオニュソス",
          "ハデス",
          "ヘパイストス",
          "ヘラ",
          "ヘルメス",
          "ヘスティア",
          "ポセイドン",
          "ゼウス"
        ]
      },
      "bank": {
        "name": [
          "日本銀行",
          "みずほ銀行",
          "三菱ＵＦＪ銀行",
          "三井住友銀行",
          "りそな銀行",
          "埼玉りそな銀行",
          "三菱UFJ信託銀行",
          "みずほ信託銀行",
          "三井住友信託銀行",
          "バンクオブニューヨークメロン信託銀行",
          "日本マスタートラスト信託銀行",
          "野村信託銀行",
          "オリックス銀行",
          "あおぞら信託銀行",
          "農中信託銀行",
          "中央三井アセット信託銀行",
          "新生信託銀行",
          "日証金信託銀行",
          "日本トラスティ・サービス信託銀行",
          "資産管理サービス信託銀行",
          "株式会社ＳＭＢＣ信託銀行",
          "新生銀行",
          "あおぞら銀行",
          "ジャパンネット銀行",
          "セブン銀行",
          "ソニー銀行",
          "楽天銀行",
          "住信SBIネット銀行",
          "じぶん銀行",
          "イオン銀行",
          "大和ネクスト銀行",
          "北海道銀行",
          "青森銀行",
          "みちのく銀行",
          "秋田銀行",
          "北都銀行",
          "荘内銀行",
          "山形銀行",
          "岩手銀行",
          "東北銀行",
          "七十七銀行",
          "東邦銀行",
          "北洋銀行",
          "きらやか銀行",
          "北日本銀行",
          "仙台銀行",
          "福島銀行",
          "大東銀行",
          "群馬銀行",
          "足利銀行",
          "常陽銀行",
          "筑波銀行",
          "武蔵野銀行",
          "千葉銀行",
          "千葉興業銀行",
          "横浜銀行",
          "東和銀行",
          "栃木銀行",
          "京葉銀行",
          "きらぼし銀行",
          "東日本銀行",
          "東京スター銀行",
          "神奈川銀行",
          "第四銀行",
          "北越銀行",
          "山梨中央銀行",
          "八十二銀行",
          "北陸銀行",
          "富山銀行",
          "北國銀行",
          "福井銀行",
          "大光銀行",
          "長野銀行",
          "富山第一銀行",
          "福邦銀行",
          "静岡銀行",
          "スルガ銀行",
          "清水銀行",
          "大垣共立銀行",
          "十六銀行",
          "三重銀行",
          "百五銀行",
          "静岡中央銀行",
          "愛知銀行",
          "名古屋銀行",
          "中京銀行",
          "第三銀行",
          "滋賀銀行",
          "京都銀行",
          "近畿大阪銀行",
          "池田泉州銀行",
          "南都銀行",
          "紀陽銀行",
          "但馬銀行",
          "関西みらい銀行",
          "大正銀行",
          "みなと銀行",
          "鳥取銀行",
          "山陰合同銀行",
          "中国銀行",
          "広島銀行",
          "山口銀行",
          "阿波銀行",
          "百十四銀行",
          "伊予銀行",
          "四国銀行",
          "島根銀行",
          "トマト銀行",
          "もみじ銀行",
          "西京銀行",
          "徳島銀行",
          "香川銀行",
          "愛媛銀行",
          "高知銀行",
          "福岡銀行",
          "筑邦銀行",
          "西日本シティ銀行",
          "北九州銀行",
          "佐賀銀行",
          "十八銀行",
          "親和銀行",
          "肥後銀行",
          "大分銀行",
          "宮崎銀行",
          "鹿児島銀行",
          "琉球銀行",
          "沖縄銀行",
          "福岡中央銀行",
          "佐賀共栄銀行",
          "長崎銀行",
          "熊本銀行",
          "豊和銀行",
          "宮崎太陽銀行",
          "南日本銀行",
          "沖縄海邦銀行"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "genre": [
          "現代小説",
          "推理小説",
          "歴史・時代小説",
          "映画原作・ノベライズ",
          "ノンフィクション・エッセイ・評論",
          "ファンタジー",
          "SF・ホラー",
          "ライトノベル",
          "海外文学",
          "児童文学",
          "詩歌",
          "古典",
          "時事・社会",
          "ビジネス",
          "環境・地球",
          "生き方・自己啓発",
          "料理・グルメ",
          "レシピ・食材",
          "ファッション",
          "マネー・家計",
          "家事・生活",
          "住まい・インテリア",
          "冠婚葬祭・マナー",
          "家庭医学",
          "美容・ダイエット",
          "学習参考書",
          "知育",
          "音楽",
          "舞台・演劇",
          "古典芸能",
          "美術・工芸",
          "イラスト・デザイン",
          "写真集",
          "歴史",
          "自然科学",
          "百科事典・図鑑",
          "絵本"
        ],
        "publisher": [
          "岩波書店",
          "講談社",
          "新潮社",
          "筑摩書房",
          "平凡社",
          "中央公論社",
          "朝日新聞社",
          "みすず書房",
          "吉川弘文館",
          "角川書店",
          "東京大学出版会",
          "小学館",
          "河出書房新社",
          "集英社",
          "白水社",
          "文藝春秋",
          "至文堂",
          "国書刊行会",
          "青土社",
          "早川書房",
          "毎日新聞社",
          "美術出版社",
          "有斐閣",
          "春秋社",
          "法政大学出版局",
          "二玄社",
          "新人物往来社",
          "勁草書房",
          "三一書房",
          "明治書院",
          "創元社",
          "雄山閣",
          "未来社",
          "思潮社",
          "音楽之友社",
          "日本放送出版協会",
          "日本評論社",
          "大修館書店",
          "三省堂",
          "創文社",
          "河出書房",
          "人文書院",
          "弘文堂",
          "徳間書店",
          "晶文社",
          "ミネルヴァ書房",
          "東京創元社",
          "淡交社",
          "読売新聞社",
          "光文社",
          "改造社",
          "日本経済新聞社",
          "原書房",
          "誠文堂新光社",
          "実業之日本社",
          "博文館",
          "東京堂出版",
          "新教出版社",
          "青木書店",
          "東洋経済新報社",
          "教文館",
          "法蔵館",
          "学習研究社",
          "研究社",
          "思文閣出版",
          "春陽堂",
          "柏書房",
          "山川出版社",
          "汲古書院",
          "第一書房",
          "冨山房",
          "明治図書",
          "作品社",
          "笠間書院",
          "藤原書店",
          "大月書店",
          "福音館書店",
          "理想社",
          "角川文庫",
          "東京書籍",
          "中央公論新社",
          "御茶の水書房",
          "新曜社",
          "塙書房",
          "旺文社",
          "鹿島出版会",
          "日本基督教団出版局",
          "社会思想社",
          "草思社",
          "名著出版",
          "ＰＨＰ研究所",
          "大和書房",
          "明石書店",
          "文化出版局",
          "キネマ旬報社",
          "学生社",
          "ぺりかん社",
          "新日本出版社",
          "中華書局",
          "保育社",
          "桜楓社",
          "立風書房",
          "中央公論美術出版",
          "丸善",
          "現代思潮社",
          "臨川書店",
          "求龍堂",
          "三笠書房",
          "和泉書院",
          "朝倉書店",
          "名古屋大学出版会",
          "時事通信社",
          "誠信書房",
          "共立出版",
          "檜書店",
          "国文社",
          "福武書店",
          "芸術新聞社",
          "風間書房",
          "ベースボールマガジン社",
          "双葉社",
          "大東出版社",
          "彰国社",
          "主婦の友社",
          "朝日出版社",
          "朝日ソノラマ",
          "紀伊國屋書店",
          "秋田書店",
          "ほるぷ出版",
          "工作舎",
          "偕成社",
          "光人社",
          "校倉書房",
          "古今書院",
          "木耳社",
          "潮出版社",
          "青蛙房",
          "二見書房",
          "沖積舎",
          "同朋舎",
          "大蔵出版",
          "岩崎美術社",
          "せりか書房",
          "サンリオ",
          "世界文化社",
          "小沢書店",
          "新評論",
          "学燈社",
          "山と渓谷社",
          "大法輪閣",
          "早稲田大学出版部",
          "冬樹社",
          "日本経済評論社",
          "新泉社",
          "培風館",
          "リブロポート",
          "古典文庫",
          "新書館",
          "東京美術",
          "桃源社",
          "アルス",
          "有精堂",
          "日本教文社",
          "平楽寺書店",
          "勉誠出版",
          "世界思想社",
          "ぎょうせい",
          "勉誠社",
          "東海大学出版会",
          "書肆山田",
          "玉川大学出版部",
          "恒文社",
          "法律文化社",
          "北海道新聞社",
          "京都書院",
          "いのちのことば社",
          "三彩社",
          "芙蓉書房",
          "ＮＨＫ出版",
          "第一法規",
          "評論社",
          "理論社",
          "明徳出版社",
          "社会評論社",
          "學燈社",
          "京都大学学術出版会",
          "ＮＴＴ出版",
          "葦書房",
          "日本近代文学館",
          "彩流社",
          "芳賀書店",
          "八木書店",
          "青弓社",
          "農山漁村文化協会",
          "短歌新聞社",
          "六興出版",
          "同文館",
          "築地書館",
          "続群書類従完成会",
          "柴田書店",
          "水声社",
          "人物往来社",
          "朝雲新聞社",
          "日貿出版社",
          "宝文館",
          "日本文芸社",
          "日本棋院",
          "白揚社",
          "晃洋書房",
          "里文出版",
          "成文堂",
          "福村出版",
          "文藝春秋新社",
          "砂子屋書房",
          "雑司ヶ谷書房",
          "論創社",
          "国土社",
          "教育社",
          "芸艸堂",
          "以文社",
          "大明堂",
          "金剛出版",
          "婦人画報社",
          "千倉書房",
          "沖縄タイムス社",
          "ポプラ社",
          "マガジンハウス",
          "刀水書房",
          "ＴＢＳブリタニカ",
          "主婦と生活社",
          "岩田書院",
          "八坂書房",
          "木鐸社",
          "八幡書店",
          "新建築社",
          "大学書林",
          "番町書房",
          "日本将棋連盟",
          "東京国立博物館",
          "五月書房",
          "近代映画社",
          "おうふう",
          "永田文昌堂",
          "平凡出版",
          "北隆館",
          "中央経済社",
          "刀江書院",
          "鉄道図書刊行会",
          "思索社",
          "学陽書房",
          "三和出版",
          "山本書店",
          "太田出版",
          "東方出版",
          "わんや書店",
          "東方書店",
          "東京図書",
          "産業図書",
          "岩崎学術出版社",
          "日本図書センター"
        ],
        "title": [
          "こころ",
          "羅生門",
          "人間失格",
          "吾輩は猫である",
          "銀河鉄道の夜",
          "坊っちゃん",
          "痴人の愛",
          "ドグラ・マグラ",
          "蜘蛛の糸",
          "蟹工船",
          "春琴抄",
          "三四郎",
          "斜陽",
          "夢十夜",
          "走れメロス",
          "怪人二十面相",
          "人間椅子",
          "檸檬",
          "舞姫",
          "道鏡",
          "ポオ異界詩集",
          "銀河鉄道の夜",
          "変身",
          "山月記",
          "注文の多い料理店",
          "吉野葛",
          "百足ちがい",
          "Ｄ坂の殺人事件",
          "草枕",
          "地底獣国",
          "堕落論",
          "七日七夜",
          "ヴィヨンの妻",
          "学問のすすめ",
          "孤島の鬼",
          "湖畔",
          "女生徒",
          "鼻",
          "遠野物語",
          "生霊",
          "河童",
          "少女地獄",
          "高瀬舟",
          "少年探偵団",
          "陰翳礼讃",
          "桜の森の満開の下",
          "押絵と旅する男",
          "風立ちぬ",
          "或阿呆の一生",
          "鬼",
          "カラマゾフの兄弟",
          "乞食",
          "心理試験",
          "猫の蚤とり武士",
          "相対性理論",
          "地獄変",
          "一握の砂",
          "注文の多い料理店",
          "ア、秋",
          "セロ弾きのゴーシュ",
          "小夜の中山夜啼石",
          "ごん狐",
          "金色夜叉",
          "とびくらべ",
          "方丈記",
          "雉子のはなし",
          "ファウスト",
          "それから",
          "寸感",
          "風の又三郎",
          "パノラマ島綺譚",
          "ノア",
          "グッド・バイ",
          "黒猫",
          "秋",
          "よだかの星",
          "虞美人草",
          "智恵子抄",
          "芋粥",
          "化学調味料",
          "心得教育",
          "破戒",
          "刺青",
          "舞姫",
          "国防と科学",
          "浮雲",
          "雁",
          "あばばばば",
          "聖家族",
          "富嶽百景",
          "手習鑑評判記",
          "藪の中",
          "高野聖",
          "阿Ｑ正伝",
          "『春と修羅』",
          "白痴",
          "蒲団",
          "桜の樹の下には",
          "二銭銅貨",
          "モルグ街の殺人事件",
          "ガリバー旅行記",
          "ヰタ・セクスアリス",
          "たけくらべ",
          "蒲団",
          "トロッコ",
          "山月記",
          "お伽草紙",
          "つばくろ",
          "アーサー王物語",
          "長崎の鐘",
          "家畜食に甘んずる多くの人々",
          "山椒大夫",
          "手袋を買いに",
          "それから",
          "悪魔",
          "オツベルと象",
          "杜子春",
          "あさましきもの",
          "門",
          "駈込み訴え",
          "赤い部屋",
          "阿部一族",
          "羅生門",
          "はたし状",
          "鍵",
          "オリンピック東京大会讃歌",
          "歴史哲学",
          "I can speak",
          "老人と海",
          "赤いカブトムシ",
          "蜜柑",
          "愛読書の印象",
          "『吾輩は猫である』上篇自序",
          "外科室",
          "やまなし",
          "アッシャー家の崩壊",
          "山羊の歌",
          "新潮記",
          "銀河鉄道の夜",
          "黒死館殺人事件",
          "芝居に出た名残星月夜",
          "イズムの功過",
          "明暗",
          "ああ華族様だよ　と私は嘘を吐くのであった",
          "私の個人主義",
          "グスコーブドリの伝記",
          "津軽",
          "歯車",
          "日記帳",
          "江戸前の釣り",
          "屋根裏の散歩者",
          "オオカミと七ひきの子ヤギ",
          "妙義山の五日",
          "道草",
          "道化の華",
          "土佐日記",
          "一夜",
          "若草物語",
          "黒蜥蜴",
          "彼岸過迄",
          "桃太郎",
          "城",
          "いなか、の、じけん",
          "指環",
          "野菊の墓",
          "管見芭蕉翁",
          "ある時刻",
          "夫婦共稼ぎと女子の学問",
          "行人",
          "瓶詰地獄",
          "赤いくつ",
          "赤毛連盟",
          "李陵",
          "雪女",
          "愛と美について",
          "瘋癲老人日記",
          "耳無芳一の話",
          "クリスマス・カロル",
          "はちとばらの花",
          "パンドラの匣",
          "赤ひげ診療譚 狂女の",
          "怪奇四十面相",
          "文字禍",
          "蜜柑",
          "遥かな旅",
          "或恋愛小説",
          "イワンの馬鹿",
          "盲目物語",
          "白雪姫",
          "桜桃",
          "銀河鉄道の夜",
          "狂人日記"
        ]
      },
      "cell_phone": {
        "formats": [
          "090-####-####",
          "080-####-####",
          "070-####-####"
        ]
      },
      "coffee": {
        "country": [
          "イエメン",
          "インド",
          "ウガンダ",
          "エチオピア",
          "エルサルバドル",
          "グアテマラ",
          "ケニア",
          "コスタリカ",
          "コロンビア",
          "スマトラ",
          "タンザニア",
          "ニカラグア",
          "パナマ",
          "ブラジル",
          "ブルンジ",
          "ホンジュラス",
          "メキシコ",
          "ルワンダ"
        ]
      },
      "color": {
        "name": [
          "赤",
          "緑",
          "青",
          "黄",
          "紫",
          "ミントグリーン",
          "ティール",
          "白",
          "黒",
          "オレンジ",
          "ピンク",
          "灰色",
          "栗色",
          "バイオレット",
          "ターコイズブルー",
          "タン",
          "空色",
          "サーモン",
          "プラム",
          "オーキッド",
          "オリーブ",
          "マゼンタ",
          "ライム",
          "アイボリー",
          "藍色",
          "金",
          "フクシア",
          "シアン",
          "紺碧",
          "ラベンダー",
          "銀"
        ]
      },
      "commerce": {
        "department": [
          "書籍",
          "映画",
          "音楽",
          "ゲーム",
          "電子工学",
          "コンピュータ",
          "住まい",
          "ガーデニング",
          "工具",
          "食料品",
          "健康",
          "美容",
          "おもちゃ",
          "こども用品",
          "ベビー用品",
          "衣服",
          "靴",
          "ジュエリー",
          "スポーツ",
          "アウトドア",
          "自動車",
          "工業"
        ],
        "product_name": {
          "adjective": [
            "小さめ",
            "大きめ",
            "エルゴノミクス",
            "シンプルな",
            "ゴージャスな",
            "一生モノの",
            "ワンランク上の",
            "贅沢な",
            "光沢のある",
            "実力派",
            "軽い",
            "高機能",
            "丈夫な",
            "国産",
            "多機能"
          ],
          "material": [
            "鋼鉄",
            "木製",
            "コンクリート",
            "プラスチック",
            "綿",
            "花崗岩",
            "ゴム",
            "革",
            "シルク",
            "ウール",
            "リネン",
            "大理石",
            "鉄",
            "ブロンズ",
            "銅製",
            "アルミニウム",
            "紙"
          ],
          "product": [
            "椅子",
            "自動車",
            "コンピュータ",
            "手袋",
            "パンツ",
            "シャツ",
            "テーブル",
            "靴",
            "帽子",
            "茶碗",
            "フォーク",
            "水筒",
            "コート",
            "ランプ",
            "キーボード",
            "バッグ",
            "ベンチ",
            "掛時計",
            "腕時計",
            "財布",
            "万年筆"
          ]
        },
        "promotion_code": {
          "adjective": [
            "最終処分",
            "感謝祭",
            "メンバー限定",
            "期間限定",
            "プレミアム",
            "スペシャル",
            "出血大サービス",
            "お買い得"
          ],
          "noun": [
            "クーポン",
            "増量キャンペーン",
            "割引",
            "価格",
            "プロモーション",
            "セール",
            "特典",
            "プライス",
            "バーゲン"
          ]
        }
      },
      "company": {
        "category": [
          "水産",
          "農林",
          "鉱業",
          "建設",
          "食品",
          "印刷",
          "電気",
          "ガス",
          "情報",
          "通信",
          "運輸",
          "銀行",
          "保険"
        ],
        "name": [
          "#{Name.last_name}#{category}#{suffix}",
          "#{suffix}#{Name.last_name}#{category}"
        ],
        "suffix": [
          "株式会社",
          "有限会社",
          "合名会社",
          "合資会社",
          "合同会社"
        ]
      },
      "creature": {
        "animal": {
          "name": [
            "ホンドテン",
            "ホワイトタイガー",
            "コツメカワウソ",
            "マンドリル",
            "エランド",
            "アムールヒョウ",
            "ブラッザグエノン",
            "カバ",
            "アルパカ",
            "ポニー",
            "オウサマペンギン",
            "アンデスコンドル",
            "オシドリ",
            "チーター",
            "ホンドリス",
            "ホンシュウジカ",
            "タンチョウ",
            "レッサーパンダ",
            "アメリカビーバー",
            "ジェフロイクモザル",
            "カピバラ",
            "マレーバク",
            "アカゲザル",
            "フンボルトペンギン",
            "パルマワラビー",
            "ビルマニシキヘビ",
            "アカカンガルー",
            "ワオキツネザル",
            "ラブラドールレトリバー",
            "アルダブラゾウガメ",
            "モルモット",
            "ヒヨコ（ニワトリ）",
            "ヤギ",
            "ヒツジ",
            "ウサギ",
            "ブラックバック",
            "シロクジャク",
            "ヒグマ",
            "アクシスジカ",
            "ヒクイドリ",
            "エミュー",
            "アフリカゾウ",
            "フラミンゴ",
            "シタツンガ",
            "ハゴロモヅル",
            "エジプトガン",
            "ライオン",
            "ミーアキャット",
            "ホオジロカンムリヅル",
            "コフラミンゴ",
            "ショウジョウトキ",
            "オウギバト",
            "ホンドフクロウ",
            "ホンドタヌキ",
            "ホンドキツネ",
            "オオワシ",
            "ヘビクイワシ",
            "コクチョウ",
            "アメリカバイソン",
            "ワピチ",
            "ミナミアフリカオットセイ",
            "ゴマフアザラシ",
            "アビシニアコロブス",
            "マントヒヒ",
            "シロテテナガザル",
            "シシオザル",
            "モモイロペリカン",
            "コモンリスザル",
            "オオサイチョウ",
            "シワコブサイチョウ",
            "メガネカイマン",
            "ラマ",
            "フタコブラクダ",
            "シナガチョウ",
            "アライグマ",
            "エジプトルーセットオオコウモリ",
            "アフリカタテガミヤマアラシ",
            "キリン",
            "ダチョウ",
            "シロサイ",
            "シマウマ",
            "バーバリーシープ"
          ]
        },
        "cat": {
          "breed": [
            "アジアンセミロングヘア",
            "アビシニアン",
            "アメリカンカール",
            "アメリカンショートヘア",
            "アメリカンボブテイル",
            "アメリカンワイヤーヘア",
            "アラビアンマウ",
            "イジアン",
            "エキゾチックショートヘア",
            "エキゾチックフォールド",
            "エジプシャンマウ",
            "オーストラリアンミスト",
            "オシキャット",
            "オリエンタルショートヘア",
            "カオマニー",
            "キムリック",
            "キンカロー",
            "コーニッシュレックス",
            "コラット",
            "サイベリアン",
            "ジャパニーズボブテイル",
            "シャム",
            "シャルトリュー",
            "シンガプーラ",
            "ラパーマ",
            "リュコイ",
            "ジャーマンレックス",
            "ハバマブラウン",
            "ハイランダーリンクス",
            "スコティッシュフォールド",
            "スノーシュー",
            "スフィンクス",
            "セルカークレックス",
            "ソマリ",
            "クリルアイランドボブテイル",
            "ターキッシュアンゴラ",
            "ターキッシュバン",
            "チャウシー",
            "チートー",
            "カラーポイントショートヘア",
            "コーニッシュレックス",
            "デボンレックス",
            "ドンスコイ",
            "ドラゴンリー",
            "ヨーロピアンショートヘア",
            "デボンレックス",
            "トンキニーズ",
            "ノルウェージャンフォレストキャット",
            "バーマン",
            "バーミーズ",
            "バーミラ",
            "バリニーズ",
            "シャンティリー",
            "バンビーノ",
            "ヒマラヤン",
            "メコンボブテイル",
            "ミンスキン",
            "ブラジリアンショートヘア",
            "ブリティッシュロングヘア",
            "ブリティッシュショートヘア",
            "カリフォルニアスパングルド",
            "ペルシャ",
            "ベンガル",
            "ボンベイ",
            "マンクス",
            "マンチカン",
            "ミヌエット",
            "メインクーン",
            "ヨーロピアンバーミーズ",
            "ラガマフィン",
            "ラグドール",
            "ラパーマ",
            "ラムキン",
            "ロシアンブルー"
          ]
        },
        "dog": {
          "breed": [
            "アーフェンピンシャー",
            "アイリッシュ・ウォーター・スパニエル",
            "アイリッシュ・ウルフハウンド",
            "アイリッシュ・セッター",
            "アイリッシュ・テリア",
            "アッペンツェラー・キャトル・ドッグ",
            "アフガン・ハウンド",
            "アメリカン・エスキモー・ドッグ",
            "アメリカン・スタッフォードシャー・テリア",
            "アラスカン・マラミュート",
            "イタリアン・グレイハウンド",
            "イビザン・ハウンド",
            "イングリッシュ・コッカー・スパニエル",
            "イングリッシュ・スプリンガー・スパニエル",
            "イングリッシュ・セッター",
            "イングリッシュ･トイ･テリア",
            "イングリッシュ・フォックスハウンド",
            "ウィペット",
            "ウエスト・ハイランド・ホワイト・テリア",
            "ウェルシュ・コーギー・カーディガン",
            "ウェルシュ・コーギー・ペンブローク",
            "ウェルシュ・スプリンガー・スパニエル",
            "エアデール・テリア",
            "エントレブッハー・キャトル・ドッグ",
            "オーストラリアン・ケルピー",
            "オーストラリアン・シルキー・テリア",
            "オーストラリアン・テリア",
            "オールド・イングリッシュ・シープドッグ",
            "オッターハウンド",
            "カーリーコーテッド・レトリーバー",
            "キースホンド",
            "キャバリア・キング・チャールズ・スパニエル",
            "クーバース",
            "クーンハウンド",
            "クランバー・スパニエル",
            "グレーター・スイス・マウンテン・ドッグ",
            "グレート・デーン",
            "グレート・ピレニーズ",
            "ケアーン・テリア",
            "ケリー・ブルー・テリア",
            "ゴードン・セッター",
            "ゴールデン・レトリバー",
            "コモンドール",
            "サセックス・スパニエル",
            "サモエド",
            "サルーキ",
            "シーズー",
            "シーリハム・テリア",
            "シェットランド・シープドッグ",
            "シベリアン・ハスキー",
            "ジャーマン・シェパード・ドッグ",
            "ジャーマン・ショートヘアード・ポインター",
            "ジャイアント・シュナウザー",
            "ショートヘアード・ハンガリアン・ビズラ",
            "スキッパーキ",
            "スコティッシュ・ディアハウンド",
            "スコティッシュ・テリア",
            "スタッフォードシャー・ブル・テリア",
            "スタンダード・プードル",
            "セント・バーナード",
            "ソフトコーテッド・ウィートン・テリア",
            "ダックスフント",
            "ダンディ・ディンモント・テリア",
            "チェサピーク・ベイ・レトリーバー",
            "チベタン・テリア",
            "チベタン・マスティフ",
            "チャウ・チャウ",
            "チワワ",
            "ツリーイング・ウォーカー・クーンハウンド",
            "ディンゴ",
            "トイ・プードル",
            "ドーベルマン",
            "ドール",
            "ニューファンドランド",
            "ノーフォーク・テリア",
            "ノーリッチ・テリア",
            "ノルウェジアン・エルクハウンド・グレー",
            "バーニーズ・マウンテン・ドッグ",
            "パグ",
            "バセット・ハウンド",
            "バセンジー",
            "パタデール・テリア",
            "パピヨン",
            "ビーグル",
            "ブービエ・デ・フランダース",
            "フォックス・テリア",
            "フラットコーテッド・レトリーバー",
            "ブラッドハウンド",
            "ブリアード",
            "ブリタニー・スパニエル",
            "ブリュッセル・グリフォン",
            "ブルーティック・クーンハウンド",
            "ブルマスティフ",
            "フレンチ・ブルドッグ",
            "ペキニーズ",
            "ベドリントン・テリア",
            "ベルジアン・シェパード・ドッグ・グローネンダール",
            "ベルジアン・シェパード・ドッグ・マリノア",
            "ボーダー・コリー",
            "ボーダー・テリア",
            "ボクサー",
            "ボストンテリア",
            "ポメラニアン",
            "ボルゾイ",
            "マルチーズ",
            "ミニチュア・シュナウザー",
            "ミニチュア・ピンシャー",
            "ミニチュア・プードル",
            "メキシカン・ヘアレス・ドッグ",
            "ヨークシャー・テリア",
            "ラサ・アプソ",
            "ラット・テリア",
            "ラブラドール・レトリバー",
            "リカオン",
            "レークランド・テリア",
            "レオンベルガー",
            "レッドボーン・クーンハウンド",
            "ローデシアン・リッジバック",
            "ロットワイラー",
            "ワイマラナー",
            "柴犬",
            "秋田犬",
            "狆"
          ],
          "name": [
            "ポチ",
            "コマチ",
            "ハル",
            "チャチャ",
            "ボンド",
            "コタロウ",
            "マーブル",
            "コジロウ",
            "レオ",
            "ラオウ",
            "コクオウ",
            "ベンケイ",
            "モモ",
            "ハナ",
            "ココ",
            "ムギ",
            "マロン",
            "モカ",
            "コムギ",
            "ソラ",
            "サクラ",
            "サチコ",
            "ヨウコ",
            "カエデ",
            "チョコ",
            "キナコ",
            "ロイ",
            "ラテ",
            "ルーク",
            "マル",
            "ノア",
            "モカ",
            "クルミ",
            "ハナ",
            "ベル",
            "アズキ",
            "オモチ",
            "ユズ",
            "ミルク",
            "チクワ",
            "ピノ",
            "フク",
            "ダイフク",
            "コハク",
            "ウミ",
            "ジャスミン",
            "ラブ",
            "ララ",
            "ナナ",
            "ポンタ",
            "コテツ",
            "アーニャ",
            "クロ",
            "シロ",
            "エリー",
            "ハンキチ",
            "ジャック",
            "ハリー",
            "タケシ",
            "タロウ",
            "クロエ",
            "オボロ",
            "クロウ",
            "ユキ",
            "ミユキ",
            "アイ",
            "アイコ",
            "アイリーン",
            "ユウコ",
            "ハナコ",
            "シフ",
            "アル",
            "サン",
            "ウタ",
            "ゲッコウ",
            "アレン",
            "アン",
            "ポチタ",
            "パワー",
            "ビーム",
            "エンジェル",
            "アンジェリカ",
            "レダ",
            "ロック",
            "ボーイ",
            "ガール",
            "マキマ",
            "マックス",
            "ハルキ",
            "シェリー",
            "キール",
            "ダニー",
            "ヘックス",
            "スズラン",
            "リンドウ",
            "カブト",
            "エース",
            "ルフィ",
            "ダイスケ",
            "ビスケット",
            "ナックル",
            "ビリー",
            "ゲンキ",
            "タイヨウ",
            "マサムネ",
            "アメ",
            "キャンディー",
            "ベイブ",
            "バレッド",
            "クラウド",
            "ティファ",
            "ゼツエイ",
            "シャンクス",
            "コーヒー",
            "ドラゴン",
            "ゴクウ",
            "サスケ",
            "ムサシ",
            "ヤマト",
            "イナズマ",
            "カミナリ",
            "レックウ",
            "ジョニー",
            "スタローン",
            "ロッキー",
            "ヒナタ",
            "ハナビ",
            "ユウキ",
            "ホウショウ",
            "リアム",
            "スコール",
            "ティーダ",
            "リュック",
            "ユウナ",
            "アンズ",
            "キララ",
            "キラリ",
            "ケン",
            "テリー",
            "マリー",
            "ジョー",
            "ショコラ",
            "シン",
            "アスカ",
            "レイ",
            "シンジ",
            "ミサト",
            "リツ",
            "リバティ",
            "グリーン",
            "レッド",
            "ヨシノ",
            "ララ",
            "リリー",
            "ヒイロ",
            "ベージュ",
            "イオン",
            "ロッコウ",
            "サム",
            "ライナー",
            "ミカサ",
            "ミコト",
            "ベック",
            "フィル",
            "ルル",
            "チヅル",
            "オウガ",
            "テンテン",
            "キバ",
            "ボルト",
            "レモン",
            "リンゴ",
            "ミカン",
            "ファラオ",
            "ミミ",
            "ヨコヅナ",
            "イオリ",
            "クウラ",
            "イージス",
            "レベッカ",
            "テル",
            "レオン",
            "ジェット",
            "スノー",
            "キキ",
            "ガガ",
            "チーズ",
            "カイ",
            "スキヤキ",
            "テリヤキ",
            "レンジ",
            "アキ",
            "フユ",
            "ナツ",
            "マツリ",
            "アヤネ",
            "アヤト",
            "アキト",
            "ユリ",
            "チカ",
            "ケンタ",
            "マックス",
            "ライト",
            "ヒカリ",
            "レイニー",
            "キリヒコ",
            "ハルカ",
            "ラン",
            "コベニ",
            "ショウヘイ"
          ]
        }
      },
      "emotion": {
        "adjective": [
          "穏やか",
          "嬉しい",
          "楽しい",
          "幸せ",
          "興奮する",
          "昂る",
          "傷ついている",
          "イライラする",
          "気になる",
          "恥ずかしい",
          "気持ちいい",
          "スッキリ",
          "和む",
          "癒される",
          "落ち着く",
          "悲しい",
          "面白い",
          "切ない",
          "寂しい",
          "困る",
          "戸惑う",
          "萎える"
        ],
        "noun": [
          "笑い",
          "満足",
          "爽快",
          "感動",
          "感心",
          "恐れ",
          "孤独",
          "憂鬱",
          "落胆",
          "憤怒",
          "嫉妬",
          "好き",
          "欲望",
          "哀れ",
          "緊張",
          "パニック",
          "喜び",
          "後悔",
          "安心",
          "恨み",
          "驚き",
          "同情"
        ]
      },
      "food": {
        "sushi": [
          "アオヤギ",
          "アカガイ",
          "アジ",
          "アナゴ",
          "アマエビ",
          "アワビ",
          "イカ",
          "イクラ",
          "ウナギ",
          "カキ",
          "カツオ",
          "カニ",
          "カンパチ",
          "キス",
          "コハダ",
          "サーモン",
          "サザエ",
          "サバ",
          "サヨリ",
          "サワラ",
          "シマアジ",
          "シラコ",
          "スズキ",
          "タイ",
          "タコ",
          "タマゴ",
          "ノドグロ",
          "ハマグリ",
          "ハマチ",
          "ヒラメ",
          "ブリ",
          "ホタテ",
          "ホタルイカ",
          "ボタンエビ",
          "マグロ",
          "マス",
          "ミルガイ"
        ]
      },
      "football": {
        "coaches": [
          "エルネスト・バルベルデ",
          "ジネディーヌ・ジダン",
          "ジョゼ・モウリーニョ",
          "アントニオ・コンテ",
          "ユルゲン・クロップ",
          "マウリシオ・ポチェッティーノ",
          "ディエゴ・シメオネ",
          "マッシミリアーノ・アッレグリ",
          "ユップ・ハインケス",
          "アーセン・ベンゲル",
          "ホルヘ・サンパオリ",
          "フェルナンド・サントス",
          "ディディエ・デシャン",
          "ヨアヒム・レーヴ",
          "フレン・ロペテギ",
          "マウリシオ・ポチェッティーノ",
          "ウナイ・エメリ",
          "マッシミリアーノ・アッレグリ",
          "トーマス・トゥヘル"
        ],
        "competitions": [
          "UEFAヨーロッパ選手権",
          "アジアカップ",
          "アフリカネイションズカップ",
          "コパ・アメリカ",
          "UEFAチャンピオンズリーグ",
          "FIFAワールドカップ",
          "UEFAヨーロッパリーグ",
          "セリエA",
          "バークレイズ・プレミアリーグ",
          "ブンデスリーガ",
          "リーガ・サンタンデール",
          "FAカップ",
          "リーグ・アン",
          "プリメイラ・リーガ",
          "エールディヴィジ",
          "スーパーリーグ",
          "メジャーリーグサッカー",
          "コッパ・イタリア",
          "DFBポカール",
          "CONCACAFゴールドカップ",
          "ネーションズカップ",
          "コパ・デル・レイ"
        ],
        "players": [
          "リオネル・メッシ",
          "ジェラール・ピケ",
          "セルヒオ・ラモス",
          "クリスティアーノ・ロナウド",
          "ダビド・デ・ヘア",
          "ポール・ポグバ",
          "アントワーヌ・グリーズマン",
          "アルバロ・モラタ",
          "アンドレス・イニエスタ",
          "ロベルト・フィルミーノ",
          "モハメド・サラー",
          "ハリー・ケイン",
          "デレ・アリ",
          "アリエン・ロッベン",
          "フランク・リベリー",
          "マルコ・ロイス",
          "ロベルト・レヴァンドフスキ",
          "ズラタン・イブラヒモビッチ",
          "エディンソン・カバーニ",
          "セルヒオ・アグエロ",
          "ネイマール",
          "メスト・エジル",
          "ジャンルイジ・ブッフォン",
          "ウィリアン",
          "マヌエル・ノイアー",
          "ファン・マタ",
          "マヌエル・ノイアー",
          "セスク・ファブレガス",
          "ガレス・ベイル",
          "エデン・アザール",
          "マリオ・マンジュキッチ",
          "キリアン・ムバッペ"
        ],
        "positions": [
          "ゴールキーパー",
          "フルバック",
          "ライトバック",
          "レフトバック",
          "ディフェンシブミッドフィールダー",
          "ミッドフィールダー",
          "アタッキングミッドフィールダー",
          "ライトミッドフィールダー",
          "レフトミッドフィールダー",
          "ライトウィング",
          "レフトウィング",
          "セカンドストライカー",
          "センターフォワード"
        ],
        "teams": [
          "レアル・マドリード",
          "FCバルセロナ",
          "バレンシアCF",
          "アトレティコ・マドリード",
          "マンチェスター・ユナイテッド",
          "チェルシー",
          "リヴァプール",
          "アーセナル",
          "トッテナム・ホットスパー",
          "ACミラン",
          "インテル・ミラノ",
          "ASローマ",
          "ユヴェントス",
          "バイエルン・ミュンヘン",
          "ボルシア・ドルトムント",
          "シャルケ04",
          "ベンフィカ",
          "ガラタサライ",
          "PSVアイントホーフェン",
          "LAギャラクシー",
          "パリ・サンジェルマン"
        ]
      },
      "games": {
        "overwatch": {
          "heroes": [
            "D.Va",
            "アッシュ",
            "アナ",
            "ウィドウメイカー",
            "ウィンストン",
            "エコー",
            "オリーサ",
            "ゲンジ",
            "ザリア",
            "シグマ",
            "シンメトラ",
            "ジャンクラット",
            "ゼニヤッタ",
            "ソルジャー76",
            "ソンブラ",
            "トレーサー",
            "トールビョーン",
            "ドゥームフィスト",
            "ハンゾー",
            "バスティオン",
            "バティスト",
            "ファラ",
            "ブリギッテ",
            "マクリー",
            "マーシー",
            "メイ",
            "モイラ",
            "ラインハルト",
            "リーパー",
            "ルシオ",
            "レッキング・ボール",
            "ロードホッグ"
          ]
        },
        "pokemon": {
          "locations": [
            "マサラタウン",
            "トキワシティ",
            "トキワのもり",
            "ニビシティ",
            "おつきみやま",
            "ハナダシティ",
            "イワヤマトンネル",
            "クチバシティ",
            "むじんはつでんしょ",
            "シオンタウン",
            "タマムシシティ",
            "ヤマブキシティ",
            "セキチクシティ",
            "サファリゾーン",
            "サイクリングロード",
            "ふたごじま",
            "グレンじま",
            "セキエイこうげん"
          ],
          "moves": [
            "すいとる",
            "ようかいえき",
            "とける",
            "こうそくいどう",
            "ドわすれ",
            "オーロラビーム",
            "たまなげ",
            "バリアー",
            "がまん",
            "しめつける",
            "かみつく",
            "ふぶき",
            "のしかかり",
            "ホネこんぼう",
            "ホネブーメラン",
            "あわ",
            "バブルこうせん",
            "からではさむ",
            "れんぞくパンチ",
            "あやしいひかり",
            "ねんりき",
            "からみつく",
            "テクスチャー",
            "カウンター",
            "クラブハンマー",
            "いあいぎり",
            "まるくなる",
            "あなをほる",
            "かなしばり",
            "ピヨピヨパンチ",
            "にどげり",
            "おうふくビンタ",
            "かげぶんしん",
            "すてみタックル",
            "りゅうのいかり",
            "ゆめくい",
            "ドリルくちばし",
            "じしん",
            "タマゴばくだん",
            "ひのこ",
            "だいばくはつ",
            "だいもんじ",
            "ほのおのパンチ",
            "ほのおのうず",
            "じわれ",
            "かえんほうしゃ",
            "フラッシュ",
            "そらをとぶ",
            "きあいだめ",
            "みだれづき",
            "みだれひっかき",
            "へびにらみ",
            "なきごえ",
            "せいちょう",
            "ハサミギロチン",
            "かぜおこし",
            "かたくなる",
            "くろいきり",
            "ずつき",
            "とびひざげり",
            "つのでつく",
            "つのドリル",
            "ハイドロポンプ",
            "はかいこうせん",
            "ひっさつまえば",
            "さいみんじゅつ",
            "れいとうビーム",
            "れいとうパンチ",
            "とびげり",
            "からてチョップ",
            "スプーンまげ",
            "きゅうけつ",
            "やどりぎのタネ",
            "にらみつける",
            "したでなめる",
            "ひかりのかべ",
            "あくまのキッス",
            "けたぐり",
            "ヨガのポーズ",
            "メガドレイン",
            "メガトンキック",
            "メガトンパンチ",
            "ゆびをふる",
            "ものまね",
            "ちいさくなる",
            "オウムがえし",
            "しろいきり",
            "ナイトヘッド",
            "ネコにこばん",
            "つつく",
            "はなびらのまい",
            "ミサイルばり",
            "どくガス",
            "どくのこな",
            "どくばり",
            "はたく",
            "サイケこうせん",
            "サイコキネシス",
            "サイコウェーブ",
            "でんこうせっか",
            "いかり",
            "はっぱカッター",
            "かまいたち",
            "じこさいせい",
            "リフレクター",
            "ねむる",
            "ほえる",
            "いわなだれ",
            "いわおとし",
            "まわしげり",
            "すなかけ",
            "ひっかく",
            "いやなおと",
            "ちきゅうなげ",
            "じばく",
            "かくばる",
            "うたう",
            "ロケットずつき",
            "ゴッドバード",
            "たたきつける",
            "きりさく",
            "ねむりごな",
            "ヘドロこうげき",
            "スモッグ",
            "えんまく",
            "タマゴうみ",
            "ソーラービーム",
            "ソニックブーム",
            "とげキャノン",
            "はねる",
            "キノコのほうし",
            "ふみつけ",
            "かいりき",
            "いとをはく",
            "わるあがき",
            "しびれごな",
            "じごくぐるま",
            "みがわり",
            "いかりのまえば",
            "ちょうおんぱ",
            "なみのり",
            "スピードスター",
            "つるぎのまい",
            "たいあたり",
            "しっぽをふる",
            "とっしん",
            "テレポート",
            "あばれる",
            "かみなり",
            "かみなりパンチ",
            "でんきショック",
            "でんじは",
            "10まんボルト",
            "どくどく",
            "へんしん",
            "トライアタック",
            "ダブルニードル",
            "はさむ",
            "つるのムチ",
            "みずでっぽう",
            "たきのぼり",
            "ふきとばし",
            "つばさでうつ",
            "からにこもる",
            "まきつく"
          ],
          "names": [
            "フシギダネ",
            "フシギソウ",
            "フシギバナ",
            "ヒトカゲ",
            "リザード",
            "リザードン",
            "ゼニガメ",
            "カメール",
            "カメックス",
            "キャタピー",
            "トランセル",
            "バタフリー",
            "ビードル",
            "コクーン",
            "スピアー",
            "ポッポ",
            "ピジョン",
            "ピジョット",
            "コラッタ",
            "ラッタ",
            "オニスズメ",
            "オニドリル",
            "アーボ",
            "アーボック",
            "ピカチュウ",
            "ライチュウ",
            "サンド",
            "サンドパン",
            "ニドラン♀",
            "ニドリーナ",
            "ニドクイン",
            "ニドラン♂",
            "ニドリーノ",
            "ニドキング",
            "ピッピ",
            "ピクシー",
            "ロコン",
            "キュウコン",
            "プリン",
            "プクリン",
            "ズバット",
            "ゴルバット",
            "ナゾノクサ",
            "クサイハナ",
            "ラフレシア",
            "パラス",
            "パラセクト",
            "コンパン",
            "モルフォン",
            "ディグダ",
            "ダグトリオ",
            "ニャース",
            "ペルシアン",
            "コダック",
            "ゴルダック",
            "マンキー",
            "オコリザル",
            "ガーディ",
            "ウインディ",
            "ニョロモ",
            "ニョロゾ",
            "ニョロボン",
            "ケーシィ",
            "ユンゲラー",
            "フーディン",
            "ワンリキー",
            "ゴーリキー",
            "カイリキー",
            "マダツボミ",
            "ウツドン",
            "ウツボット",
            "メノクラゲ",
            "ドククラゲ",
            "イシツブテ",
            "ゴローン",
            "ゴローニャ",
            "ポニータ",
            "ギャロップ",
            "ヤドン",
            "ヤドラン",
            "コイル",
            "レアコイル",
            "カモネギ",
            "ドードー",
            "ドードリオ",
            "パウワウ",
            "ジュゴン",
            "ベトベター",
            "ベトベトン",
            "シェルダー",
            "パルシェン",
            "ゴース",
            "ゴースト",
            "ゲンガー",
            "イワーク",
            "スリープ",
            "スリーパー",
            "クラブ",
            "キングラー",
            "ビリリダマ",
            "マルマイン",
            "タマタマ",
            "ナッシー",
            "カラカラ",
            "ガラガラ",
            "サワムラー",
            "エビワラー",
            "ベロリンガ",
            "ドガース",
            "マタドガス",
            "サイホーン",
            "サイドン",
            "ラッキー",
            "モンジャラ",
            "ガルーラ",
            "タッツー",
            "シードラ",
            "トサキント",
            "アズマオウ",
            "ヒトデマン",
            "スターミー",
            "バリヤード",
            "ストライク",
            "ルージュラ",
            "エレブー",
            "ブーバー",
            "カイロス",
            "ケンタロス",
            "コイキング",
            "ギャラドス",
            "ラプラス",
            "メタモン",
            "イーブイ",
            "シャワーズ",
            "サンダース",
            "ブースター",
            "ポリゴン",
            "オムナイト",
            "オムスター",
            "カブト",
            "カブトプス",
            "プテラ",
            "カビゴン",
            "フリーザー",
            "サンダー",
            "ファイヤー",
            "ミニリュウ",
            "ハクリュー",
            "カイリュー",
            "ミュウツー",
            "ミュウ",
            "チコリータ",
            "ベイリーフ",
            "メガニウム",
            "ヒノアラシ",
            "マグマラシ",
            "バクフーン",
            "ワニノコ",
            "アリゲイツ",
            "オーダイル",
            "オタチ",
            "オオタチ",
            "ホーホー",
            "ヨルノズク",
            "レディバ",
            "レディアン",
            "イトマル",
            "アリアドス",
            "クロバット",
            "チョンチー",
            "ランターン",
            "ピチュー",
            "ピィ",
            "ププリン",
            "トゲピー",
            "トゲチック",
            "ネイティ",
            "ネイティオ",
            "メリープ",
            "モココ",
            "デンリュウ",
            "キレイハナ",
            "マリル",
            "マリルリ",
            "ウソッキー",
            "ニョロトノ",
            "ハネッコ",
            "ポポッコ",
            "ワタッコ",
            "エイパム",
            "ヒマナッツ",
            "キマワリ",
            "ヤンヤンマ",
            "ウパー",
            "ヌオー",
            "エーフィ",
            "ブラッキー",
            "ヤミカラス",
            "ヤドキング",
            "ムウマ",
            "アンノーン",
            "ソーナンス",
            "キリンリキ",
            "クヌギダマ",
            "フォレトス",
            "ノコッチ",
            "グライガー",
            "ハガネール",
            "ブルー",
            "グランブル",
            "ハリーセン",
            "ハッサム",
            "ツボツボ",
            "ヘラクロス",
            "ニューラ",
            "ヒメグマ",
            "リングマ",
            "マグマッグ",
            "マグカルゴ",
            "ウリムー",
            "イノムー",
            "サニーゴ",
            "テッポウオ",
            "オクタン",
            "デリバード",
            "マンタイン",
            "エアームド",
            "デルビル",
            "ヘルガー",
            "キングドラ",
            "ゴマゾウ",
            "ドンファン",
            "ポリゴン2",
            "オドシシ",
            "ドーブル",
            "バルキー",
            "カポエラー",
            "ムチュール",
            "エレキッド",
            "ブビィ",
            "ミルタンク",
            "ハピナス",
            "ライコウ",
            "エンテイ",
            "スイクン",
            "ヨーギラス",
            "サナギラス",
            "バンギラス",
            "ルギア",
            "ホウオウ",
            "セレビィ"
          ]
        },
        "super_mario": {
          "characters": [
            "マリオ",
            "ルイージ",
            "ピーチ姫",
            "キノピオ",
            "クッパ",
            "ヨッシー",
            "デイジー姫",
            "ロゼッタ",
            "ドンキーコング",
            "ディディーコング",
            "キノピコ",
            "キャサリン",
            "キノじい",
            "キノピオ隊長",
            "ポリーン",
            "ワリオ",
            "ワルイージ",
            "コクッパ",
            "カメック",
            "ブンブン",
            "プンプン",
            "キングテレサ"
          ],
          "games": [
            "ルイージマンション",
            "スーパーマリオブラザーズ",
            "スーパーマリオワールド",
            "スーパーマリオカート",
            "スーパーマリオ64",
            "スーパーマリオパーティ",
            "大乱闘スマッシュブラザーズ",
            "スーパーマリオギャラクシー",
            "スーパーマリオオデッセイ",
            "スーパーマリオメーカー",
            "ペーパーマリオ"
          ],
          "locations": [
            "カブロン",
            "ダイナフォー",
            "アッチーニャ",
            "ドレッシーバレー",
            "スチームガーデン",
            "グランドモック",
            "ロス島",
            "ニュードンク・シティ",
            "パウダーボウル",
            "シュワシュワーナ",
            "ボルボーノ",
            "ホロビア",
            "クッパ城",
            "ハニークレーター",
            "ピーチ城",
            "ラビットクレーター",
            "ラストクレーター"
          ]
        },
        "super_smash_bros": {
          "fighter": [
            "ソラ"
          ],
          "stage": [
            "ホロウバスティオン"
          ]
        },
        "touhou": {
          "characters": [
            "博麗霊夢",
            "霧雨魔理沙",
            "ルーミア",
            "チルノ",
            "紅美鈴",
            "パチュリー・ノーレッジ",
            "十六夜咲夜",
            "レミリア・スカーレット",
            "フランドール・スカーレット",
            "レティ・ホワイトロック",
            "橙",
            "アリス・マーガトロイド",
            "リリーホワイト",
            "ルナサ・プリズムリバー",
            "メルラン・プリズムリバー",
            "リリカ・プリズムリバー",
            "魂魄 妖夢",
            "西行寺 幽々子",
            "八雲藍",
            "八雲紫",
            "リグル・ナイトバグ",
            "ミスティア・ローレライ",
            "上白沢慧音",
            "因幡てゐ",
            "鈴仙・優曇華院・イナバ",
            "八意永琳",
            "蓬莱山輝夜",
            "藤原妹紅",
            "伊吹萃香",
            "射命丸文",
            "メディスン・メランコリー",
            "風見幽香",
            "小野塚小町",
            "四季映姫・ヤマザナドゥ",
            "秋静葉",
            "秋穣子",
            "鍵山雛",
            "河城にとり",
            "犬走椛",
            "東風谷早苗",
            "八坂神奈子",
            "洩矢諏訪子",
            "永江衣玖",
            "比那名居天子",
            "キスメ",
            "黒谷ヤマメ",
            "水橋パルスィ",
            "星熊勇儀",
            "古明地さとり",
            "火焔猫燐",
            "霊烏路空",
            "古明地こいし",
            "ナズーリン",
            "多々良小傘",
            "雲居一輪",
            "村紗水蜜",
            "寅丸星",
            "聖白蓮",
            "封獣 ぬえ",
            "大ナマズ",
            "姫海棠 はたて",
            "サニーミルク",
            "スターサファイア",
            "ルナチャイルド",
            "幽谷響子",
            "宮古芳香",
            "霍青娥",
            "蘇我屠自古",
            "物部布都",
            "豊聡耳神子",
            "二ッ岩マミゾウ",
            "秦こころ",
            "わかさぎ姫",
            "赤蛮奇",
            "今泉影狼",
            "九十九弁々",
            "九十九八橋",
            "鬼人正邪",
            "少名針妙丸",
            "堀川雷鼓",
            "茨木華扇",
            "宇佐見菫子",
            "清蘭",
            "鈴瑚",
            "ドレミー・スイート",
            "稀神 サグメ",
            "クラウンピース",
            "純狐",
            "ヘカーティア・ラピスラズリ",
            "エタニティラルバ",
            "坂田ネムノ",
            "高麗野あうん",
            "矢田寺成美",
            "爾子田里乃",
            "丁礼田舞",
            "摩多羅隠岐奈",
            "依神女苑",
            "依神紫苑",
            "戎瓔花",
            "牛崎潤美",
            "庭渡久侘歌",
            "吉弔八千慧",
            "杖刀偶磨弓",
            "埴安神袿姫",
            "驪駒早鬼",
            "饕餮尤魔",
            "豪徳寺ミケ",
            "山城たかね",
            "駒草山如",
            "玉造魅須丸",
            "飯綱丸龍",
            "菅牧典",
            "天弓千亦",
            "姫虫百々世",
            "孫美天",
            "三頭慧ノ子",
            "天火人ちやり",
            "豫母都日狭美",
            "日白残無"
          ],
          "games": [
            "東方靈異伝",
            "東方封魔録",
            "東方夢時空",
            "東方幻想郷",
            "東方怪綺談",
            "東方紅魔郷",
            "東方妖々夢",
            "東方永夜抄",
            "東方花映塚",
            "東方文花帖",
            "東方風神録",
            "東方地霊殿",
            "東方星蓮船",
            "ダブルスポイラー",
            "妖精大戦争",
            "東方神霊廟",
            "東方輝針城",
            "弾幕アマノジャク",
            "東方紺珠伝",
            "東方天空璋",
            "秘封ナイトメアダイアリー",
            "東方鬼形獣",
            "東方虹龍洞",
            "東方獣王園"
          ],
          "locations": [
            "博麗神社",
            "人間の里",
            "鈴奈庵",
            "鯢呑亭",
            "命蓮寺",
            "夢殿大祀廟",
            "霧の湖",
            "廃洋館",
            "紅魔館",
            "魔法の森",
            "香霖堂",
            "霧雨魔法店",
            "マーガトロイド邸",
            "玄武の沢",
            "再思の道",
            "無縁塚",
            "妖怪の山",
            "守矢神社",
            "虹龍洞",
            "大蝦蟇の池",
            "聖地ヤマンバの地",
            "茨華仙の屋敷",
            "マヨヒガ",
            "間欠泉地下センター",
            "中有の道",
            "三途の川",
            "迷いの竹林",
            "永遠亭",
            "無名の丘",
            "太陽の畑",
            "旧都",
            "地霊殿",
            "旧血の池地獄",
            "冥界",
            "白玉楼",
            "天界",
            "彼岸",
            "地獄",
            "畜生界",
            "霊長園",
            "魔界",
            "法界",
            "仙界",
            "後戸の国",
            "八雲紫の屋敷",
            "輝針城",
            "月の都",
            "外の世界",
            "夢の世界"
          ],
          "songs": [
            "赤より紅い夢",
            "ほおずきみたいに紅い魂",
            "妖魔夜行",
            "ルーネイトエルフ",
            "おてんば恋娘",
            "明治十七年の上海アリス",
            "ヴワル魔法図書館",
            "ラクトガール　～ 少女密室",
            "メイドと血の懐中時計",
            "月時計　～ ルナ・ダイアル",
            "ツェペシュの幼き末裔",
            "亡き王女の為のセプテット",
            "魔法少女達の百年祭",
            "紅より儚い永遠",
            "クリスタライズシルバー",
            "遠野幻想物語",
            "ブクレシュティの人形師",
            "人形裁判　～ 人の形弄びし少女",
            "天空の花の都",
            "アルティメットトゥルース",
            "ボーダーオブライフ",
            "妖々跋扈",
            "ネクロファンタジア",
            "春風の夢",
            "もう歌しか聞こえない",
            "プレインエイジア",
            "恋色マスタースパーク",
            "ヴォヤージュ1969",
            "ヴォヤージュ1970",
            "エクステンドアッシュ　～ 蓬莱人",
            "月まで届け、不死の煙",
            "月見草",
            "東方妖怪小町",
            "オリエンタルダークフライト",
            "フラワリングナイト",
            "おてんば恋娘の冒険",
            "お宇佐さまの素い幡",
            "花の映る塚",
            "此岸の塚",
            "花は幻想のままに",
            "東の国の眠らない夜",
            "レトロスペクティブ京都",
            "風神少女",
            "封印されし神々",
            "稲田姫様に叱られるから",
            "運命のダークサイド",
            "神々が恋した幻想郷",
            "フォールオブフォール　～ 秋めく滝",
            "少女が見た日本の原風景",
            "信仰は儚き人間の為に",
            "明日ハレの日、ケの昨日",
            "ネイティブフェイス",
            "麓の神社",
            "プレイヤーズスコア",
            "幼心地の有頂天",
            "地霊達の起床",
            "暗闇の風穴",
            "渡る者の途絶えた橋",
            "緑眼のジェラシー",
            "旧地獄街道を行く",
            "華のさかづき大江山",
            "ハートフェルトファンシー",
            "廃獄ララバイ",
            "業火マントル",
            "ラストリモート",
            "ハルトマンの妖怪少女",
            "地霊達の帰宅",
            "青空の影",
            "春の湊に",
            "小さな小さな賢将",
            "閉ざせし雲の通い路",
            "万年置き傘にご注意を",
            "スカイルーイン",
            "時代親父とハイカラ少女",
            "幽霊客船の時空を越えた旅",
            "キャプテン・ムラサ",
            "魔界地方都市エソテリア",
            "虎柄の毘沙門天",
            "法界の火",
            "夜空のユーフォーロマンス",
            "平安のエイリアン",
            "妖怪寺",
            "ニュースハウンド",
            "あなたの町の怪事件",
            "妖怪モダンコロニー",
            "ネメシスの要塞",
            "春の氷精",
            "可愛い大戦争のリフレーン",
            "いたずらに命をかけて",
            "年中夢中の好奇心",
            "真夜中のフェアリーダンス",
            "ルーズレイン",
            "メイガスナイト",
            "春の氷精　- 静 -",
            "欲深き霊魂",
            "死霊の夜桜",
            "ゴーストリード",
            "妖怪寺へようこそ",
            "門前の妖怪小娘",
            "素敵な墓場で暮しましょ",
            "リジッドパラダイス",
            "デザイアドライブ",
            "古きユアンシェン",
            "夢殿大祀廟",
            "大神神話伝",
            "小さな欲望の星空",
            "妖怪裏参道",
            "佐渡の二ッ岩",
            "神社の新しい風",
            "デザイアドリーム",
            "幻想郷の二ッ岩",
            "亡失のエモーション",
            "不思議なお祓い棒",
            "ミストレイク",
            "秘境のマーメイド",
            "運河を行き交う人妖",
            "柳の下のデュラハン",
            "満月の竹林",
            "孤独なウェアウルフ",
            "マジカルストーム",
            "幻想浄瑠璃",
            "空中に沈む輝針城",
            "リバースイデオロギー",
            "針小棒大の天守閣",
            "魔力の雷雲",
            "小槌の魔力",
            "不思議な不思議な道具達",
            "反則の狼煙を上げろ",
            "不可能弾幕には反則を",
            "ミッドナイトスペルカード",
            "ロマンチック逃飛行",
            "永遠の三日天下",
            "華狭間のバトルフィールド",
            "ラストオカルティズム　～ 現し世の秘術師",
            "宇宙巫女現る",
            "忘れがたき、よすがの緑",
            "兎は舞い降りた",
            "湖は浄めの月光を映して",
            "九月のパンプキン",
            "宇宙を飛ぶ不思議な巫女",
            "永遠の春夢",
            "凍り付いた永遠の都",
            "逆転するホイールオブフォーチュン",
            "遥か３８万キロのボヤージュ",
            "星条旗のピエロ",
            "故郷の星が映る海",
            "ピュアヒューリーズ　～ 心の在処",
            "見た事も無い悪夢の世界",
            "パンデモニックプラネット",
            "神社から見える月",
            "宇宙巫女帰還する",
            "桜舞い散る天空",
            "希望の星は青霄に昇る",
            "真夏の妖精の夢",
            "色無き風は妖怪の山に",
            "山奥のエンカウンター",
            "桜色の海を泳いで",
            "一対の神獣",
            "幻想のホワイトトラベラー",
            "魔法の笠地蔵",
            "禁断の扉の向こうは、この世かあの世か",
            "クレイジーバックダンサーズ",
            "イントゥ・バックドア",
            "秘匿されたフォーシーズンズ",
            "もうドアには入れない",
            "不自然な自然",
            "白い旅人",
            "物言わぬ獣の霊",
            "地蔵だけが知る哀嘆",
            "ジェリーストーン",
            "ロストリバー",
            "石の赤子と水中の牛",
            "不朽の曼珠沙華",
            "セラフィックチキン",
            "アンロケイテッドヘル",
            "トータスドラゴン ～幸運と不運",
            "ビーストメトロポリス",
            "セラミックスの杖刀人",
            "エレクトリックヘリテージ",
            "輝かしき弱肉強食の掟",
            "畜生達の休息",
            "地下からの帰還",
            "虹の架かる幻想郷",
            "妖異達の通り雨",
            "大吉キトゥン",
            "深緑に隠された断崖",
            "バンデットリィテクノロジー",
            "駒草咲くパーペチュアルスノー",
            "スモーキングドラゴン",
            "廃れゆく産業遺構",
            "神代鉱石",
            "待ちわびた逢魔が時",
            "星降る天魔の山",
            "ルナレインボー",
            "幻想の地下大線路網",
            "龍王殺しのプリンセス",
            "嵐の後の日曜日",
            "虹色の世界",
            "コレクターの憂鬱な午後",
            "ワクワクする見慣れた幻想郷",
            "妖怪フックオン",
            "闇市場は場所を選ばない",
            "１００回目のブラックマーケット",
            "ルナティックドリーマー",
            "獣の知性",
            "世界は可愛く出来ている",
            "魔獣スクランブル",
            "鬼は悠久の山に",
            "タイニーシャングリラ",
            "勇敢で有閑な妖獣",
            "吸血怪獣チュパカブラ",
            "振り向かない黄泉の道",
            "強欲な獣のメメント",
            "獣王達の休息",
            "獣に知性はあるか"
          ],
          "spell_cards": [
            "恋符「マスタースパーク」",
            "禁忌「レーヴァテイン」",
            "紫奥義「弾幕結界」",
            "桜符「完全なる墨染の桜」",
            "「百万鬼夜行」",
            "「深弾幕結界　-夢幻泡影-」",
            "日符「ロイヤルフレア」",
            "神槍「スピア・ザ・グングニル」",
            "新難題「金閣寺の一枚天井」",
            "凍符「パーフェクトフリーズ」",
            "蓬莱「凱風快晴　-フジヤマヴォルケイノ-」",
            "「レッドマジック」",
            "魔砲「ファイナルマスタースパーク」",
            "「夢想天生」",
            "無題「空を飛ぶ不思議な巫女」",
            "ＱＥＤ「４９５年の波紋」",
            "神鬼「レミリアストーカー」",
            "彗星「ブレイジングスター」",
            "審判「浄頗梨審判 -射命丸文-」",
            "人鬼「未来永劫斬」",
            "天呪「アポロ１３」",
            "秘弾「そして誰もいなくなるか？」",
            "日＆月符「ロイヤルダイアモンドリング」",
            "幻想「花鳥風月、嘯風弄月」",
            "禁忌「恋の迷路」",
            "疾風「風神少女」",
            "霊符「夢想封印」",
            "「紅色の幻想郷」",
            "氷符「アイシクルフォール」",
            "虹符「彩虹の風鈴」",
            "「インペリシャブルシューティング」",
            "幽曲「リポジトリ・オブ・ヒロカワ」",
            "銀符「パーフェクトメイド」",
            "月＆木符「サテライトヒマワリ」",
            "審判「ラストジャッジメント」",
            "滅罪「正直者の死」",
            "禁薬「蓬莱の薬」",
            "魔符「スターダストレヴァリエ」",
            "境符「波と粒の境界」",
            "魔符「全世界ナイトメア」",
            "鬼神「ミッシングパープルパワー」",
            "秘術「天文密葬法」",
            "紅符「スカーレットマイスタ」",
            "神宝「ブリリアントドラゴンバレッタ」",
            "月符「サイレントセレナ」",
            "大合葬「霊車コンチェルトグロッソ」",
            "咒詛「首吊り蓬莱人形」",
            "火水木金土符「賢者の石」",
            "式神「橙」",
            "鬼神「飛翔毘沙門天」"
          ]
        },
        "zelda": {
          "games": [
            "神々のトライフォース",
            "ブレス オブ ザ ワイルド",
            "4つの剣",
            "夢をみる島",
            "ムジュラの仮面",
            "時のオカリナ",
            "ふしぎの木の実 - 大地の章",
            "ふしぎの木の実 - 時空の章",
            "夢幻の砂時計",
            "ゼルダの伝説",
            "ふしぎのぼうし",
            "風のタクト",
            "トワイライトプリンセス",
            "リンクの冒険"
          ]
        }
      },
      "gender": {
        "binary_types": [
          "女性",
          "男性"
        ]
      },
      "lorem": {
        "punctuation": {
          "period": "。",
          "question_mark": "？",
          "space": ""
        },
        "supplemental": [
          "おどりば",
          "料理人",
          "いち",
          "やぶれる",
          "辞儀する",
          "逮捕",
          "色彩",
          "妻",
          "きづく",
          "はきだす",
          "歯",
          "憶測",
          "すむ",
          "墨",
          "胃腸",
          "駆け出す",
          "栞",
          "ふゆかい",
          "豪華",
          "写す",
          "むちつじょ",
          "ごらく",
          "可愛い",
          "ふじょ",
          "でんせんびょう",
          "いちにち",
          "ついたち",
          "彼女",
          "ひめさま",
          "解説",
          "すいがら",
          "約",
          "並",
          "こっせつ",
          "あらじお",
          "あらしお",
          "書架",
          "勝手",
          "ぎせい",
          "こくひん",
          "嫌",
          "博物館",
          "しんし",
          "帳簿",
          "初めに",
          "空き瓶",
          "ふてい",
          "見返す",
          "ほんるいだ",
          "さわ",
          "悪気",
          "ほんそう",
          "謙虚",
          "耐火",
          "ぼうりょく",
          "潔い",
          "けす",
          "締まる",
          "ちょうりょく",
          "のうし",
          "暴走",
          "華道",
          "基盤",
          "廃棄",
          "かざる",
          "くら",
          "氏名",
          "がぞう",
          "ふきつ",
          "こうばん",
          "かんさい",
          "ひとごみ",
          "構える",
          "たす",
          "とむ",
          "すみ",
          "めいよ",
          "帝",
          "かんえん",
          "たび",
          "模型",
          "冬休み",
          "誇張",
          "何千",
          "そうだん",
          "しっぷう",
          "はやて",
          "ほどう",
          "敵",
          "ひふ",
          "火",
          "壁",
          "弱点",
          "かいそく",
          "没頭",
          "貴賓",
          "さいげつ",
          "盛り上がる",
          "柱",
          "ひはん",
          "輪郭",
          "こづつみ",
          "扇",
          "性病",
          "濃紺",
          "洗浄剤",
          "舞踏",
          "つぎ",
          "しめる",
          "延長",
          "しつ",
          "ざせき",
          "もくひょう",
          "宝くじ",
          "劣悪",
          "はなみ",
          "同音異義語",
          "たいほう",
          "慶弔",
          "疎外",
          "れいてん",
          "さと",
          "煩い",
          "携帯",
          "かいせい",
          "哺育",
          "敬語",
          "とうとい",
          "とうひょうする",
          "頑張れ",
          "れいせい",
          "蛇",
          "いしゃりょう",
          "アメリカ製",
          "光年",
          "社員",
          "もよう",
          "ぎゃくしゅう",
          "甲乙",
          "ふくし",
          "へいせい",
          "てんのう",
          "年次",
          "二巻",
          "がくふ",
          "しどう",
          "よすみ",
          "おおごえ",
          "かつぐ",
          "地下街",
          "はくじん",
          "間接",
          "せっとく",
          "つうこん",
          "びんぼう",
          "川底",
          "こうえん",
          "うごき",
          "六",
          "乾燥",
          "洗濯屋",
          "なぞ",
          "ふじん",
          "対応",
          "順序",
          "首",
          "むれる",
          "しめる",
          "移す",
          "分ける",
          "しょうげき",
          "ぎょうし",
          "あまい",
          "じょうきゅう",
          "たんれん",
          "かけこむ",
          "素材",
          "受付",
          "いままで",
          "りょこう",
          "満潮",
          "もちいる",
          "あわれ",
          "賀状",
          "詰め込む",
          "数える",
          "ずいじ",
          "いっぱく",
          "聴者",
          "そうぐう",
          "とうさく",
          "思い遣り",
          "鋭い",
          "貞操",
          "原因",
          "象牙",
          "歌謡",
          "会議",
          "待遇",
          "なかよし",
          "おなか",
          "りりしい",
          "おおちがい",
          "賛成",
          "奔放",
          "非難",
          "ようじ",
          "錯乱",
          "じこ",
          "前",
          "累進",
          "緊張する",
          "ぎじゅく",
          "うち",
          "悪霊",
          "枢軸",
          "子守歌",
          "りゅうき",
          "雄犬",
          "みずいろ",
          "大間違い",
          "走り回る",
          "そんけい",
          "しっぺい",
          "てんし",
          "病院",
          "残業",
          "ひんしつ",
          "けんしゅうせい",
          "椅子",
          "いさぎよい",
          "枕",
          "墓",
          "洗剤",
          "たいがい",
          "じしょ",
          "副大統領",
          "瞬く",
          "ふじ山",
          "ふくせん",
          "漬物",
          "はんけん",
          "愛する",
          "ねんがん",
          "ねんじ",
          "いきどおり",
          "おとこのこ",
          "仁",
          "鶴",
          "施設",
          "請ける",
          "拒否",
          "うみ",
          "移譲",
          "溶岩",
          "性格",
          "じしん",
          "裏口",
          "ふたたび",
          "猿真似",
          "しめらせる",
          "みき",
          "つぐなう",
          "しんじゅく",
          "こせき",
          "よくあつ",
          "懇談",
          "指定する",
          "専門",
          "一生",
          "平壌",
          "滝",
          "じどうし",
          "着く",
          "泥棒",
          "構え",
          "きじゅつ",
          "しょひょう",
          "貨幣",
          "好奇心",
          "皇太子妃",
          "かいほうする",
          "主に",
          "背広",
          "ちんみ",
          "よそく",
          "なつかしい",
          "がんい",
          "ちょうしゃ",
          "無敵",
          "所",
          "だいがくいんせい",
          "左右",
          "のむ",
          "愛国心",
          "桑原",
          "どうはんする",
          "いっかい",
          "なみだ",
          "くまもとけん",
          "主観的",
          "普段",
          "こころみる",
          "ふくぶくろ",
          "てんぷく",
          "せいめい",
          "はなのあな",
          "みぎて",
          "親子丼",
          "反則",
          "しゅうり",
          "かくにん",
          "生える",
          "けむし",
          "すける",
          "のぞいて",
          "和尚",
          "えんちょうする",
          "こうとう",
          "なげすてる",
          "なまけもの",
          "あい",
          "きとく",
          "審判",
          "怖い",
          "こたえる",
          "比較",
          "ゆにゅう",
          "曲",
          "ちんもく",
          "破産",
          "迫る",
          "あわ",
          "辛子",
          "糸",
          "早々",
          "運命",
          "錠",
          "のうみん",
          "夏",
          "野獣",
          "試験",
          "数詞",
          "毎日",
          "ぎせいしゃ",
          "よくし",
          "せん",
          "おろし",
          "ゆれる",
          "いし",
          "える",
          "ごらん",
          "ばい",
          "たい",
          "拘置",
          "うらぎり",
          "競艇",
          "かぐ",
          "悔しい",
          "にゅうせき",
          "ために",
          "ふうふ",
          "ちょうせん",
          "破壊",
          "困難",
          "まんえつ",
          "移動",
          "しあつ",
          "あまる",
          "香り",
          "いなか",
          "通す",
          "ほうき",
          "栄誉",
          "ちめいてき",
          "おとろえる",
          "いしずえ",
          "知り合い",
          "貨物船",
          "酸っぱい",
          "めいわくめーる",
          "めいわくメール",
          "とうほう",
          "てら",
          "ぜんにほん",
          "七つ",
          "暗い",
          "てのこう",
          "しんぞう",
          "仰々しい",
          "さんぎょう",
          "公共",
          "年額",
          "かわさき",
          "日刊",
          "ちょう",
          "縮小",
          "いっこ",
          "不況",
          "人柄",
          "はい",
          "原潜",
          "つみ",
          "かんかつ",
          "ぞうえん",
          "雑費",
          "おくれる",
          "面倒臭い",
          "しょうじょう",
          "たおす",
          "順番",
          "天皇",
          "しゅいん",
          "動揺",
          "乙",
          "さわやか",
          "とう",
          "望み",
          "一人娘",
          "かく",
          "かど",
          "ねんがじょう",
          "ちょくせつ",
          "せんじょう",
          "燃やす",
          "ふかのう",
          "買い物",
          "風潮",
          "沖縄",
          "いか",
          "こうくうぼかん",
          "かくれる",
          "きぼうする",
          "媒介",
          "れいぞうこ",
          "冷酷",
          "紛らわしい",
          "せんげん",
          "家具",
          "繁茂",
          "なさけない",
          "きずつく",
          "空き缶",
          "禅寺",
          "大文字",
          "火葬",
          "雰囲気",
          "化粧",
          "忍者",
          "ふんしゃ",
          "限る",
          "ちゅうとはんぱ",
          "はずかしめる",
          "何度",
          "風船",
          "こうぎょう",
          "かくしゅう",
          "しりつ",
          "こい",
          "あがる",
          "教える",
          "程",
          "忘れ物",
          "襲撃",
          "かいころく",
          "月刊",
          "となえる",
          "せんのう",
          "営業中",
          "ながさき",
          "げんまい",
          "二つ",
          "髪の毛",
          "ろくおん",
          "匿名",
          "高瀬",
          "しききん",
          "ふかぶん",
          "怒鳴る",
          "福祉",
          "あさねぼう",
          "りゃくご",
          "しざい",
          "運",
          "力",
          "ねばる",
          "つくる",
          "わかめ",
          "おうしゅう",
          "やすい",
          "え",
          "かせぎ",
          "あらかじめ",
          "かんせつ",
          "恥ずかしがる",
          "焦がす",
          "はいき",
          "はかる",
          "図説",
          "どうめい",
          "ようじ",
          "ふねんごみ",
          "ふねんゴミ",
          "鎮める",
          "しゅくん"
        ],
        "words": [
          "つぎつぎ",
          "薬",
          "当て字",
          "しょくん",
          "間隔",
          "飽くまでも",
          "あびる",
          "雇用",
          "かんどうする",
          "じじょでん",
          "超音波",
          "じゅうどう",
          "面",
          "先週",
          "しょうがっこう",
          "避ける",
          "ふそく",
          "まぎらす",
          "閉める",
          "たまご",
          "こわす",
          "底",
          "〜亭",
          "しゃくや",
          "しゃっか",
          "ひきざん",
          "割り箸",
          "こうぞく",
          "果てる",
          "つなひき",
          "漂う",
          "漠然",
          "しょうりゃく",
          "減俸",
          "さいぼう",
          "さいほう",
          "平安",
          "封筒",
          "旧姓",
          "よわよわしい",
          "味噌",
          "ぼきん",
          "くつじょく",
          "絹糸",
          "ちきゅう",
          "かぜ",
          "半額",
          "かんそく",
          "ぶん",
          "ふん",
          "たれる",
          "廉価",
          "ずいぶん",
          "屈む",
          "かんりょうてき",
          "すんか",
          "殻",
          "擬装",
          "うえる",
          "たいさ",
          "あつい",
          "げいひんかん",
          "洋服",
          "大丈夫",
          "察知",
          "しえんする",
          "仕方がない",
          "徳川",
          "ちらかす",
          "こくふくする",
          "ぶそう",
          "こうつう",
          "逆",
          "馬鹿馬鹿しい",
          "切迫",
          "不健康",
          "学院",
          "都合",
          "備える",
          "へいがい",
          "はじめて",
          "輸出",
          "迷路",
          "母",
          "ひかくする",
          "はなぢ",
          "はなじ",
          "むこう",
          "ねんじゅう",
          "自宅",
          "誘惑",
          "ちえん",
          "太る",
          "ちかく",
          "奴ら",
          "堀川",
          "ちがい",
          "たいこうする",
          "運ぶ",
          "独裁",
          "はっぽう",
          "とちょう",
          "先ず",
          "はんそう",
          "せいじょう",
          "しょうじょう",
          "かんじる",
          "体重",
          "上手",
          "原油",
          "ざぜん",
          "既に",
          "華やか",
          "仕事",
          "あらす",
          "ゆるむ",
          "きょうどう",
          "開閉",
          "悲しみ",
          "しゃこ",
          "ねばり",
          "ようい",
          "おりめ",
          "伐採",
          "牛乳",
          "秘める",
          "右翼",
          "伝統",
          "きひん",
          "やさしい",
          "ほ",
          "警官",
          "左手",
          "全日本",
          "むぜい",
          "ごふく",
          "かいたく",
          "撃つ",
          "しあとるし",
          "シアトルし",
          "ちょさくけん",
          "じぎする",
          "譜面",
          "貫く",
          "約する",
          "提案する",
          "哀れむ",
          "迷子",
          "きょうき",
          "ごうけん",
          "せんたくする",
          "しゅしょう",
          "江戸",
          "狂う",
          "助手",
          "新婚旅行",
          "検査",
          "色々",
          "かぶしきしじょう",
          "桜色",
          "普及",
          "零す",
          "ししょく",
          "きゅうりょう",
          "おんとう",
          "しょうゆ",
          "没落",
          "人性",
          "けいかん",
          "電話",
          "お盆",
          "きいろ",
          "やしなう",
          "鍋",
          "遮断",
          "かわかす",
          "寮生",
          "面積",
          "とうき",
          "ふくへい",
          "ないしょばなし",
          "不思議",
          "この頃",
          "おかね",
          "かいぞく",
          "歯を磨く",
          "店",
          "はなはだ",
          "フランス語",
          "評価",
          "九日",
          "さいばん",
          "推奨",
          "出版",
          "恨み",
          "気持ちいい",
          "黙る",
          "はりい",
          "凝固",
          "傑作",
          "魅力",
          "ぐん",
          "右利き",
          "まほうつかい",
          "復旧",
          "かくじっけん",
          "じきしょうそう",
          "あれる",
          "きょうはんしゃ",
          "たいりく",
          "げんめつ",
          "俵",
          "むらさきいろ",
          "病床",
          "米兵",
          "まつり",
          "塾生",
          "親切",
          "めいがら",
          "なおさら",
          "魔術",
          "がいよう",
          "かんぜん",
          "せいかん",
          "果樹",
          "〜系",
          "ほにゅうびん",
          "じょうだん",
          "賢明",
          "みなと",
          "もはん",
          "こうちょく",
          "泳ぐ",
          "重い",
          "日没",
          "碁",
          "かつ",
          "どうけつ",
          "近視",
          "配慮",
          "のき",
          "入江",
          "とめる",
          "暇",
          "書き方",
          "胃",
          "りょうど",
          "難しい",
          "浮世絵",
          "喜劇",
          "とうさん",
          "はんだんする",
          "こうせい",
          "大仏",
          "揺さぶる",
          "いじん",
          "機嫌",
          "黒板",
          "えきびょう",
          "妥協する",
          "つうやく",
          "乗せる",
          "けしき",
          "床",
          "品詞",
          "消す",
          "金縛り",
          "じゅうらい",
          "急騰",
          "十台",
          "窓",
          "雑音",
          "きょだい",
          "鈍器",
          "禍根",
          "かたみち",
          "山葵",
          "店舗",
          "渦巻き",
          "おととい",
          "いっさくじつ",
          "救急車",
          "馬",
          "ころす",
          "ぼくし",
          "せっぷく",
          "たて",
          "おどろく",
          "やさい",
          "じぞう",
          "こはん",
          "いく",
          "自立",
          "かっこう",
          "脱税",
          "始まる",
          "学者",
          "かい",
          "ひきさく",
          "長唄",
          "下着",
          "よくげつ",
          "休日",
          "以下",
          "廃墟",
          "部首",
          "壊す",
          "むく",
          "委員",
          "待合",
          "頂く",
          "よぼう",
          "壮年",
          "ちゅうもんする",
          "じっかん",
          "境",
          "施行",
          "つく",
          "活用",
          "ぶき",
          "かいじゅう",
          "人口",
          "ぼうず",
          "そあく",
          "むぼう",
          "白菊",
          "りゃくず",
          "汚す",
          "すいせん",
          "あらそう",
          "高値",
          "あう",
          "せいしん",
          "指紋",
          "超〜",
          "うえる",
          "つまる",
          "靖国神社",
          "とりあえず",
          "とふ",
          "たくす",
          "じょうじゅん",
          "羊毛",
          "浅い",
          "閉じる",
          "戦没",
          "あっとうする",
          "ひがい",
          "量",
          "じょうき",
          "誤用",
          "ほうせき",
          "つばさ",
          "号",
          "けいむしょ",
          "電源",
          "勇気",
          "ふかさ",
          "はだか",
          "たいやく",
          "きょうしつ",
          "退く",
          "さきまわり",
          "こうおつ",
          "無糖",
          "ふさい",
          "とくに",
          "めいし",
          "みつ",
          "ほんらい",
          "まもる",
          "あつかい",
          "日欧",
          "天井",
          "みさき",
          "おきゃくさん",
          "にんい",
          "きょうかい",
          "いつ頃",
          "かん",
          "しきもう",
          "特殊",
          "同僚",
          "血液",
          "じぶん",
          "しょうかする",
          "礎",
          "みなもと",
          "軒",
          "ぶっきょう",
          "しずむ",
          "たらす",
          "憂い",
          "総括",
          "もうす",
          "暴力",
          "しばふ",
          "いたずら",
          "米国",
          "魔法",
          "ことばつき",
          "窒息",
          "唄う",
          "金",
          "きもち",
          "誓い",
          "どろ",
          "話",
          "奇襲",
          "巡回",
          "失う",
          "隆起",
          "投資",
          "芽",
          "あくれい",
          "奉仕",
          "ひんきゃく",
          "ひんかく",
          "まつ",
          "せんりゅう",
          "だいどころ",
          "いう",
          "こいぬ",
          "なんべい",
          "さくにゅう",
          "フランス人",
          "きげんご",
          "こくみん",
          "交錯",
          "好き",
          "一文字",
          "ほうげん",
          "地面",
          "だくりゅう",
          "見当たる",
          "浸す",
          "あしくび",
          "弱虫",
          "送る",
          "遺失",
          "あおい",
          "ちあん",
          "宜しく",
          "あらあらしい",
          "かおつき",
          "かちゅう",
          "がんばる",
          "芸者",
          "陳列室",
          "弥生",
          "明治",
          "めいしょ",
          "ごじゅう",
          "済ます",
          "無駄",
          "終点",
          "ぞくご",
          "掛ける",
          "ほうしゅう",
          "騎兵",
          "液体",
          "下さい",
          "けいじばん",
          "杏",
          "合う",
          "疾走",
          "りゅうこうご",
          "出かける",
          "はちまき",
          "手作り",
          "れつあく",
          "うんがいい",
          "はちのす",
          "ハチのす",
          "色盲",
          "形",
          "希望する",
          "こうせい",
          "いちだい",
          "春休み",
          "縛る",
          "金星",
          "そんざい",
          "防犯",
          "大尉",
          "老齢",
          "差し上げる",
          "犠牲",
          "にる",
          "問題",
          "双",
          "安泰",
          "せんじょうざい",
          "継承",
          "かんしん",
          "丼",
          "ざんぴん",
          "そだてる",
          "たつ",
          "不可欠",
          "報じる",
          "抑制",
          "けいけんしゃ",
          "きょうふ",
          "せいぞう",
          "きんく"
        ]
      },
      "name": {
        "female_first_name": [
          "葵",
          "優那",
          "優奈",
          "凛",
          "陽菜",
          "愛",
          "結衣",
          "美咲",
          "楓",
          "さくら",
          "遥",
          "美優",
          "莉子",
          "七海",
          "美月",
          "結菜",
          "真央",
          "花音",
          "陽子",
          "舞",
          "美羽",
          "優衣",
          "未来",
          "彩",
          "彩乃",
          "彩花",
          "優",
          "智子",
          "奈々",
          "千尋",
          "愛美",
          "優菜",
          "杏",
          "裕子",
          "芽衣",
          "綾乃",
          "琴音",
          "桜",
          "恵",
          "杏奈",
          "美桜",
          "優花",
          "玲奈",
          "結",
          "茜",
          "美穂",
          "明日香",
          "愛子",
          "美緒",
          "碧"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "佐藤",
          "鈴木",
          "高橋",
          "田中",
          "伊藤",
          "山本",
          "渡辺",
          "中村",
          "小林",
          "加藤",
          "吉田",
          "山田",
          "佐々木",
          "山口",
          "松本",
          "井上",
          "木村",
          "林",
          "斎藤",
          "清水",
          "山崎",
          "阿部",
          "森",
          "池田",
          "橋本",
          "山下",
          "石川",
          "中島",
          "前田",
          "藤田",
          "後藤",
          "小川",
          "岡田",
          "村上",
          "長谷川",
          "近藤",
          "石井",
          "斉藤",
          "坂本",
          "遠藤",
          "藤井",
          "青木",
          "福田",
          "三浦",
          "西村",
          "藤原",
          "太田",
          "松田",
          "原田",
          "岡本",
          "中野",
          "中川",
          "小野",
          "田村",
          "竹内",
          "金子",
          "中山",
          "和田",
          "石田",
          "工藤",
          "上田",
          "原",
          "森田",
          "酒井",
          "横山",
          "柴田",
          "宮崎",
          "宮本",
          "内田",
          "高木",
          "谷口",
          "安藤",
          "丸山",
          "今井",
          "大野",
          "高田",
          "菅原",
          "河野",
          "武田",
          "藤本",
          "上野",
          "杉山",
          "千葉",
          "村田",
          "増田",
          "小島",
          "小山",
          "大塚",
          "平野",
          "久保",
          "渡部",
          "松井",
          "菊地",
          "岩崎",
          "松尾",
          "佐野",
          "木下",
          "野口",
          "野村",
          "新井"
        ],
        "male_first_name": [
          "翔太",
          "蓮",
          "翔",
          "陸",
          "颯太",
          "悠斗",
          "大翔",
          "翼",
          "樹",
          "奏太",
          "大和",
          "大輝",
          "悠",
          "隼人",
          "健太",
          "大輔",
          "駿",
          "陽斗",
          "優",
          "陽",
          "悠人",
          "誠",
          "拓海",
          "仁",
          "悠太",
          "悠真",
          "大地",
          "健",
          "遼",
          "大樹",
          "諒",
          "響",
          "太一",
          "一郎",
          "優斗",
          "亮",
          "海斗",
          "颯",
          "亮太",
          "匠",
          "陽太",
          "航",
          "瑛太",
          "直樹",
          "空",
          "光",
          "太郎",
          "輝",
          "一輝",
          "蒼"
        ],
        "name": [
          "#{last_name} #{first_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "naruto": {
        "characters": [
          "うずまきナルト",
          "はたけカカシ",
          "うちはサスケ",
          "波風ミナト",
          "うちはオビト",
          "うちはイタチ",
          "アビル",
          "アガラ",
          "アガリ",
          "海鮮アガリ",
          "アゲハ",
          "龍堂院アギラ",
          "アヒコ",
          "アホと鳴くカラス",
          "アイノ",
          "アジサイ",
          "アカボシ",
          "アカホシ",
          "赤丸",
          "アカネ",
          "アカネ（くのいち）",
          "アカネの父",
          "龍代アカリ",
          "赤ツチ",
          "朱丸",
          "アキノ",
          "アキオ",
          "犬塚アキタ",
          "アックン",
          "アマチ",
          "アマド",
          "アマギ",
          "アマイ",
          "アマル",
          "アマヨ",
          "アメノ",
          "飴雪",
          "林檎雨由利",
          "アミ",
          "アミノ",
          "アムダ",
          "アナト",
          "暗部の司令官",
          "兄貴",
          "みたらしアンコ",
          "青",
          "山城アオバ",
          "アオダ",
          "あおい（ゲーム）",
          "緑青アオイ",
          "アオネコ",
          "アライ",
          "アラシ",
          "梅矢アラシ",
          "アラヤ",
          "アルマジ子",
          "アサカ",
          "アサキ",
          "アサミ",
          "葦丸",
          "アシナ",
          "うずまきアシナ",
          "アシタバ",
          "猿飛アスマ",
          "修羅道",
          "大筒木アシュラ",
          "アツイ",
          "アヤメ",
          "アザミ",
          "苍蓝之牙",
          "バイウ",
          "バジ",
          "バキ",
          "獏",
          "獏（暗部）",
          "バクト",
          "バンド",
          "バンドウ",
          "バンナ",
          "板斎",
          "バラキ",
          "うちはバル",
          "蜂使い",
          "ベッコウ",
          "ベンガ",
          "ベンテン",
          "鳥の仮面の暗部",
          "ビスケ",
          "猿飛ビワコ",
          "影法師",
          "黒ゼツ",
          "ブルービー",
          "イノシシの仮面の暗部",
          "ボロ",
          "うずまきボルト",
          "ボクシングカンガルー",
          "疾风舞者",
          "ブル",
          "ブナ",
          "分福",
          "黒鋤文淡",
          "ブンゾウ",
          "ブラミ",
          "猫科ぶりこ",
          "千手仏間",
          "白蓮",
          "幽霊船の船長",
          "茶丸",
          "チャムー",
          "チェン",
          "チビ",
          "チチアツ",
          "チカラ",
          "チノ",
          "地陸",
          "チシマ",
          "チヨ",
          "千代",
          "チヨマツ",
          "秋道チョウベエ",
          "秋道チョウチョウ",
          "チョウハン",
          "秋道チョウジ",
          "チョウジの母親",
          "長十郎",
          "重明",
          "チョウセキ",
          "秋道チョウザ",
          "忠治",
          "中覚",
          "中吉",
          "チュウシン",
          "爪の国の大名",
          "コード",
          "貝螺王",
          "コンドル",
          "赤色岩拳",
          "呪術師",
          "呪い武者",
          "奈良ダエン",
          "大仏",
          "ダイチ",
          "ふねのダイコク",
          "ダイマル",
          "ダジム",
          "加藤ダン",
          "観月ダンゴ",
          "ダンゴウ",
          "ダンジョウ",
          "志村ダンゾウ",
          "道噸堀ダオレ",
          "ダルイ",
          "ダツジ",
          "ディーパ",
          "デイダラ",
          "デルタ",
          "外道魔像",
          "デンガク",
          "デンカ",
          "雷門デンキ",
          "ディソナス",
          "ドダイ",
          "ドカン",
          "怒鬼",
          "ドック",
          "ドン",
          "ドラグ",
          "ドス・キヌタ",
          "風花ドトウ",
          "ドレッドライオン",
          "童芯",
          "呉越ドウシュ",
          "秋道ドウトウ",
          "鷲の仮面の暗部",
          "土の国の大名",
          "土牢剛霊無",
          "エビス",
          "エビゾウ",
          "海苔巻エホウ",
          "エミ",
          "エミナ",
          "エミル",
          "役の行者",
          "御屋城エン",
          "奈良エンチュウ",
          "鬼熊えんこ",
          "猿羅",
          "奈良エンスイ",
          "天狼エンゾ",
          "雷門エレキ",
          "斜路エリマキ",
          "金色エトロ",
          "茶の国の悪代官",
          "エブ",
          "牙の国の大名",
          "ファズ",
          "火の国の大名",
          "畜生道",
          "初代火影",
          "撫子の里の元里長",
          "狐の仮面の暗部"
        ],
        "demons": [
          "一尾（守鶴）",
          "二尾（又旅）",
          "三尾（磯撫）",
          "四尾（孫悟空）",
          "五尾（穆王）",
          "六尾（犀犬）",
          "七尾（重明）",
          "八尾（牛鬼）",
          "九尾（九喇嘛）",
          "十尾（神樹）"
        ],
        "eyes": [
          "白眼",
          "写輪眼",
          "淨眼",
          "万華鏡写輪眼",
          "輪廻眼",
          "転生眼",
          "輪廻写輪眼"
        ],
        "villages": [
          "木の葉隠れ",
          "砂隠れ",
          "霧隠れ",
          "雲隠れ",
          "岩隠れ"
        ]
      },
      "phone_number": {
        "formats": [
          "0####-#-####",
          "0###-##-####",
          "0##-###-####",
          "0#-####-####"
        ]
      },
      "relationship": {
        "familial": {
          "direct": [
            "父",
            "母",
            "姉",
            "兄"
          ],
          "extended": [
            "祖父",
            "祖母",
            "叔父",
            "叔母",
            "従兄弟",
            "姪",
            "甥",
            "孫息子",
            "孫娘"
          ]
        },
        "in_law": [
          "義父",
          "義母",
          "義姉",
          "義兄"
        ],
        "parent": [
          "父",
          "母"
        ],
        "sibling": [
          "姉",
          "兄"
        ],
        "spouse": [
          "夫",
          "妻"
        ]
      },
      "restaurant": {
        "name": [
          "#{name_suffix} #{Name.last_name}",
          "#{name_suffix} #{name_prefix}#{Name.last_name}",
          "#{name_suffix} #{name_prefix}",
          "#{type} #{Name.last_name}"
        ],
        "name_prefix": [
          "ビッグ",
          "ゴールデン",
          "ハングリー",
          "シルバー",
          "レッド",
          "ブルー",
          "グリーン",
          "オレンジ",
          "イエロー"
        ],
        "name_suffix": [
          "ベーカリー",
          "バー",
          "焼肉",
          "ブラッスリー",
          "バーガー",
          "カフェ",
          "コーヒー",
          "ピッツア",
          "鉄板焼き",
          "鮨",
          "ラーメン",
          "居酒屋"
        ],
        "type": [
          "懐石",
          "割烹",
          "精進料理",
          "京料理",
          "寿司",
          "ふぐ",
          "かに",
          "すっぽん",
          "あんこう",
          "天ぷら",
          "とんかつ",
          "串揚げ",
          "からあげ",
          "そば",
          "うどん",
          "うなぎ",
          "焼鳥",
          "すき焼き",
          "しゃぶしゃぶ",
          "おでん",
          "お好み焼き",
          "もんじゃ焼き",
          "たこ焼き",
          "牛丼",
          "ステーキ",
          "ハンバーグ",
          "鉄板焼き",
          "パスタ",
          "ピザ",
          "ハンバーガー",
          "洋食",
          "フレンチ",
          "ビストロ",
          "イタリアン",
          "中華料理",
          "韓国料理",
          "タイ料理",
          "メキシコ料理",
          "カレー",
          "焼肉",
          "居酒屋",
          "ダイニングバー",
          "ファミレス",
          "ラーメン",
          "カフェ",
          "喫茶店",
          "パン",
          "洋菓子",
          "和菓子",
          "バー"
        ]
      },
      "space": {
        "galaxy": [
          "天の川",
          "小マゼラン雲",
          "大マゼラン雲",
          "アンドロメダ銀河",
          "Ω星団",
          "さんかく座銀河",
          "ケンタウルス座A",
          "ボーデの銀河",
          "NGC 253",
          "M83"
        ],
        "planet": [
          "水星",
          "金星",
          "地球",
          "火星",
          "木星",
          "土星",
          "天王星",
          "海王星"
        ]
      },
      "sport": {
        "ancient_olympics": [
          "ボクシング",
          "戦車競走",
          "円盤投げ",
          "馬競走",
          "長距離ジャンプ",
          "パンクラチオン",
          "五種競技",
          "ランニング",
          "レスリング"
        ],
        "summer_olympics": [
          "バスケットボール 3x3",
          "アーチェリー",
          "体操",
          "アーティスティックスイミング",
          "陸上競技",
          "バドミントン",
          "野球",
          "バスケットボール",
          "ビーチバレーボール",
          "BMX フリースタイル",
          "BMX レーシング",
          "ボクシング",
          "カヌー/カヤック フラットウォーター",
          "カヌー/カヤック スラローム",
          "飛込",
          "馬術",
          "フェンシング",
          "サッカー",
          "ゴルフ",
          "ハンドボール",
          "ホッケー",
          "柔道",
          "空手",
          "マラソンスイミング",
          "近代五種",
          "マウンテンバイク",
          "新体操",
          "自転車ロードレース",
          "ボート",
          "ラグビー",
          "セーリング",
          "射撃",
          "スケートボード",
          "ソフトボール",
          "スポーツクライミング",
          "サーフィン",
          "競泳",
          "卓球",
          "テコンドー",
          "テニス",
          "自転車トラックレース",
          "トランポリン",
          "トライアスロン",
          "バレーボール",
          "水球",
          "重量挙げ",
          "レスリング"
        ],
        "summer_paralympics": [
          "アーチェリー",
          "陸上競技",
          "バドミントン",
          "ブラインドサッカー",
          "ボッチャ",
          "カヌー",
          "自転車競技",
          "馬術",
          "ゴールボール",
          "柔道",
          "パワーリフティング",
          "ローイング",
          "射撃",
          "シッティングバレーボール",
          "競泳",
          "卓球",
          "テコンドー",
          "トライアスロン",
          "車椅子バスケットボール",
          "車椅子フェンシング",
          "車椅子ラグビー",
          "車椅子テニス"
        ],
        "unusual": [
          "アップルレーシング",
          "馬引き競走",
          "バスタブレース",
          "ベッドレーシング",
          "ボッサボール",
          "棒倒し",
          "ビール缶レガッタ",
          "ブラックプディング投げ",
          "ボグスノーケリング",
          "ボトルキッキング",
          "ラクダジャンプ",
          "ラクダレスリング",
          "チェスボクシング",
          "エクストリームアイロニング",
          "フルークタグ/バードマン",
          "ガーニング",
          "ビールケースランニング",
          "オイルレスリング",
          "プーポーキック",
          "妻運び競走",
          "ゾービング"
        ],
        "winter_olympics": [
          "アルペンスキー",
          "バイアスロン",
          "ボブスレー",
          "クロスカントリースキー",
          "カーリング",
          "フィギュアスケート",
          "フリースタイルスキー",
          "アイスホッケー",
          "リュージュ",
          "ノルディック複合",
          "ショートトラック",
          "スケルトン",
          "スキージャンプ",
          "スキーマウンテニアリング",
          "スノーボード",
          "スピードスケート"
        ],
        "winter_paralympics": [
          "アルペンスキー",
          "バイアスロン",
          "クロスカントリースキー",
          "アイスホッケー",
          "スノーボード",
          "車椅子カーリング"
        ]
      },
      "studio_ghibli": {
        "characters": [
          "荻野 千尋",
          "ススワタリ",
          "湯婆婆",
          "ハク",
          "カオナシ",
          "銭婆",
          "釜爺",
          "ハウル",
          "ソフィー・ハッター",
          "荒地の魔女",
          "レティー・ハッター",
          "カルシファー",
          "マルクル",
          "かかしのカブ",
          "サリマン",
          "パズー",
          "シータ",
          "マ=ドーラ",
          "ルイ",
          "横川 清太",
          "横川 節子",
          "横川 清",
          "ポニョ",
          "フジモト",
          "グランマンマーレ",
          "宗介",
          "リサ",
          "耕一",
          "アシタカ",
          "サン",
          "ジコ坊",
          "エボシ御前",
          "モロの君",
          "ナウシカ",
          "ジル",
          "ユパ・ミラルダ",
          "大ババ",
          "マルコ・パゴット",
          "マダム・ジーナ",
          "フィオ・ピッコロ",
          "ドナルド・カーチス",
          "マンマユート・ボス",
          "ピッコロおやじ",
          "ベルリーニ",
          "ジジ",
          "キキ",
          "トンボ",
          "おソノ",
          "ウルスラ",
          "トトロ",
          "草壁 メイ",
          "ネコバス",
          "草壁 サツキ",
          "草壁 タツオ",
          "大垣 勘太",
          "草壁 靖子"
        ],
        "movies": [
          "千と千尋の神隠し",
          "魔女の宅急便",
          "となりのトトロ",
          "ハウルの動く城",
          "もののけ姫",
          "紅の豚",
          "猫の恩返し",
          "崖の上のポニョ",
          "風の谷のナウシカ",
          "天空の城ラピュタ",
          "火垂るの墓",
          "借りぐらしのアリエッティ",
          "ゲド戦記",
          "コクリコ坂から",
          "風立ちぬ",
          "かぐや姫の物語",
          "ホーホケキョ となりの山田くん"
        ],
        "quotes": [
          "そんなに形にこだわらないの。大切なのは心よ。",
          "いつも笑顔を忘れずにね。",
          "神様か誰かがくれた力なんだよね。おかげで苦労もするけどさ。",
          "大きな街だから いろんな人がいるさ。でも、私はあんたが気に入ったよ。",
          "怖がるな。私はそなたの味方だ。",
          "嫌だとか、帰りたいとか言わせるように仕向けてくるけど働きたいとだけ言うんだ。辛くても、耐えて機会を待つんだよ。",
          "ここで働かせてください！",
          "千尋の元気が出るようにまじないをかけて作ったんだ。お食べ。",
          "えんがちょ、せい！えんがちょ！！",
          "私がほしいものは、あなたにはぜったい出せない。",
          "一度あったことは忘れないものさ…思い出せないだけで。",
          "千尋。いい名だね。自分の名前を大事にね。",
          "やーい！おまえん家、お化け屋敷ー！",
          "トトロ！あなたトトロって言うのね！",
          "もう終わりだ。美しくなかったら生きていたって仕方がない。",
          "そうさ、この国一番のきれい好きな魔女さ。",
          "待たれよ。",
          "恋だね。",
          "生きろ。そなたは美しい。",
          "黙れ小僧！お前にサンが救えるか！",
          "賢しらに僅かな不運を見せびらかすな。",
          "飛ばねぇ豚は、ただの豚だ。",
          "馬鹿野郎！そういうのは一番大事な時にととっけ！",
          "飛行機乗りは、船乗りよりも勇敢で、陸の飛行乗りより誇り高いんだって。",
          "意地も見栄も無い男なんて最低よ！堂々と戦いなさい！",
          "大丈夫だよ。僕が守ってあげるからね。",
          "ここにバケツ置いとけば、ポニョが来た時に、このうちってわかるよね。",
          "ポニョ、そーすけ好きー！",
          "ポニョ、人間になるー！",
          "ほら、怖くない。",
          "親方!空から女の子が!",
          "バルス",
          "40秒で仕度しな！"
        ]
      },
      "subscription": {
        "payment_methods": [
          "クレジットカード",
          "デビットカード",
          "PayPal",
          "現金",
          "送金",
          "ビットコイン",
          "小切手",
          "Apple Pay",
          "Google Pay",
          "WeChat Pay",
          "Alipay",
          "Visaチェックアウト"
        ],
        "payment_terms": [
          "前払い",
          "月払い",
          "年払い",
          "フルサブスクリプション"
        ],
        "plans": [
          "フリートライアル",
          "ベーシック",
          "スターター",
          "エッセンシャル",
          "学生",
          "ブロンズ",
          "スタンダード",
          "シルバー",
          "ゴールド",
          "プラチナ",
          "プロフェッショナル",
          "ビジネス",
          "ダイヤモンド",
          "プレミアム"
        ],
        "statuses": [
          "アクティブ",
          "アイドル",
          "ブロック中",
          "保留中"
        ],
        "subscription_terms": [
          "毎日",
          "毎週",
          "毎月",
          "毎年",
          "隔年",
          "3年毎",
          "5年毎",
          "終身"
        ]
      },
      "university": {
        "name": [
          "#{Name.last_name}#{University.suffix}",
          "#{University.prefix}#{Name.last_name}#{University.suffix}",
          "#{University.prefix}#{Address.city_prefix}#{University.suffix}"
        ],
        "prefix": [
          "北海道",
          "東北",
          "関東",
          "中部",
          "近畿",
          "中国",
          "四国",
          "九州"
        ],
        "suffix": [
          "大学",
          "医科大学",
          "芸術大学",
          "音楽大学",
          "工業大学"
        ]
      }
    },
    "hello": "こんにちは",
    "helpers": {
      "select": {
        "prompt": "選択してください"
      },
      "submit": {
        "create": "登録する",
        "submit": "保存する",
        "update": "更新する"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n%u",
          "negative_format": "-%u%n",
          "precision": 0,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "円"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "十億",
            "million": "百万",
            "quadrillion": "千兆",
            "thousand": "千",
            "trillion": "兆",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n%u",
          "units": {
            "byte": "バイト",
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": "、",
        "two_words_connector": "、",
        "words_connector": "、"
      }
    },
    "time": {
      "am": "午前",
      "formats": {
        "default": "%Y年%m月%d日(%a) %H時%M分%S秒 %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%Y年%m月%d日%H時%M分"
            }
          }
        },
        "long": "%Y/%m/%d %H:%M",
        "short": "%m/%d %H:%M"
      },
      "pm": "午後"
    },
    "welcome": "ようこそ"
  },
  "ka": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "მიმდინარე პაროლი",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "ელ-ფოსტა",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "პაროლი",
          "password_confirmation": "პაროლის დადასტურება",
          "remember_created_at": null,
          "remember_me": "დამიმახსოვრე",
          "reset_password_sent_at": null,
          "reset_password_token": "პაროლის მარკერის გადატვირთვა",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "მარკერის გახსნა",
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "დადასტურება წარუმატებელია: %{errors}"
        }
      },
      "models": {
        "user": {
          "one": "მომხმარებელი",
          "other": "მომხმარებელი"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "კვ",
        "ორშ",
        "სამშ",
        "ოთხშ",
        "ხუთშ",
        "პარ",
        "შაბ"
      ],
      "abbr_month_names": [
        null,
        "იანვ",
        "თებ",
        "მარტი",
        "აპრ",
        "მაისი",
        "ივნ",
        "ივლ",
        "აგვ",
        "სექტ",
        "ოქტ",
        "ნოემბ",
        "დეკ"
      ],
      "day_names": [
        "კვირა",
        "ორშაბათი",
        "სამშაბათი",
        "ოთხშაბათი",
        "ხუთშაბათი",
        "პარასკევი",
        "შაბათი"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "იანვარი",
        "თებერვალი",
        "მარტი",
        "აპრილი",
        "მაისი",
        "ივნისი",
        "ივლისი",
        "აგვისტო",
        "სექტემბერი",
        "ოქტომბერი",
        "ნოემბერი",
        "დეკემბერი"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "დაახლოებით %{count} საათი",
          "other": "დაახლოებით %{count} საათი"
        },
        "about_x_months": {
          "one": "დაახლოებით %{count} თვე",
          "other": "დაახლოებით %{count} თვე"
        },
        "about_x_years": {
          "one": "დაახლოებით %{count} წელი",
          "other": "დაახლოებით %{count} წელი"
        },
        "almost_x_years": {
          "one": "თითქმის %{count} წელი",
          "other": "თითქმის %{count} წელი"
        },
        "half_a_minute": "ნახევარი წუთი",
        "less_than_x_minutes": {
          "one": "%{count} წუთზე ნაკლები",
          "other": "%{count} წუთზე ნაკლები"
        },
        "less_than_x_seconds": {
          "one": "%{count} წამზე ნაკლები",
          "other": "%{count} წამზე ნაკლები"
        },
        "over_x_years": {
          "one": "%{count} წელზე მეტი",
          "other": "%{count} წელზე მეტი"
        },
        "x_days": {
          "one": "%{count} დღე",
          "other": "%{count} დღე"
        },
        "x_minutes": {
          "one": "%{count} წუთი",
          "other": "%{count} წუთი"
        },
        "x_months": {
          "one": "%{count} თვე",
          "other": "%{count} თვე"
        },
        "x_seconds": {
          "one": "%{count} წამი",
          "other": "%{count} წამი"
        },
        "x_years": {
          "one": "%{count} წელი",
          "other": "%{count} წელი"
        }
      },
      "prompts": {
        "day": "დღე",
        "hour": "საათი",
        "minute": "წუთი",
        "month": "თვე",
        "second": "წამი",
        "year": "წელი"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "თქვენი ელ-ფოსტა წარმატებულად დადასტურდა.",
        "new": {
          "resend_confirmation_instructions": "დადასტურების ინსტრუქციის ხელახლა გაგზავნა"
        },
        "send_instructions": "თქვენ რამოდენიმე წუთში მიიღებთ ელ-ფოსტას ინსტრუქციით ელ-ფოსტის დასადასტურებლად.",
        "send_paranoid_instructions": "თუ თქვენი ელ-ფოსტა არსებობს მონაცემთა ბაზაში, რამოდენიმე წუთში მიიღებთ ელ-ფოსტას ინსტრუქციით თქვენი ელ-ფოსტის დასადასტურებლად."
      },
      "failure": {
        "already_authenticated": "თქვენ უკვე ავტორიზირებული ხართ.",
        "inactive": "თქვენი ანგარი ჯერ არ არის აქტივირებული.",
        "invalid": null,
        "last_attempt": "თქვენ გაქვთ კიდევ ერთი ცდა სანამ თქვენი ანგარიში ჩაიკეტება.",
        "locked": "თქვენი ანგარიში ჩაკეტილია.",
        "not_found_in_database": null,
        "timeout": "თქვენი სეანსი დასრულებულია.",
        "unauthenticated": "გასაგრძელებლად თქვენ უნდა გაიაროთ ავტორიზაცია ან დარეგისტრირდეთ.",
        "unconfirmed": "გაგრძელებისთვის თქვენ უნდა დაადასტუროთ თქვენი ელ-ფოსტის მისამართი."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "დაადასტურე ჩემი ანგარიში",
          "greeting": "მოგესალმებით %{recipient}!",
          "instruction": "თქვენ შეგიძლიათ დაადასტუროთ თქვენი ანგარიშის ელ-ფოსტა ქვემო ბმულით:",
          "subject": "ინსტრუქცია დასადასტურებლად"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "გამარჯობა %{recipient}!",
          "message": "ჩვენ გატყობინებთ რომ თქვენი პაროლი შეიცვალა.",
          "subject": "პაროლი შეცვლილია"
        },
        "reset_password_instructions": {
          "action": "პაროლის გამოცვლა",
          "greeting": "გამარჯობა %{recipient}!",
          "instruction": "ვიღაცამ მოითხოვა პაროლის გამოცვლა, თქვენ ამის გაკეთებას ქვემო ბმულით შეძლებთ.",
          "instruction_2": "თუ თქვენ ეს არ მოგითხოვიათ, გთხოვთ უგულვებელყოთ ეს შეტყობინება.",
          "instruction_3": "თქვენი პაროლი არ შეიცვლება სანამ არ შეხვალთ ზემო ბმულში და ახალს არ შექმნით.",
          "subject": "პაროლის შეცვლის ინსტრუქცია"
        },
        "unlock_instructions": {
          "action": "ჩემი ანგარიშის გახსნა",
          "greeting": "Hello %{recipient}!",
          "instruction": "დააწკაპუნეთ ქვემო ბმულზე თქვენი ანგარიშის გასახსნელად:",
          "message": "თქვენი ანგარიში დაიხურა ბევრი წარუმატებელი ავტორიზაციის მცდელობის გამო.",
          "subject": "გახსნის ინსტრუქცია"
        }
      },
      "omniauth_callbacks": {
        "failure": "თქვენი ავთენტიკაცია %{kind}-დან ვერ მოხერხდა  რადგან \"%{reason}\".",
        "success": "ავთენტიკაცია %{kind}-ის ანგარიშიდან წარმატებულია."
      },
      "passwords": {
        "edit": {
          "change_my_password": "გამოცვალე ჩემი პაროლი",
          "change_your_password": "გამოცვალე თქვენი პაროლი",
          "confirm_new_password": "ახალი პაროლის დადასტურება",
          "new_password": "ახალი პაროლი"
        },
        "new": {
          "forgot_your_password": "დაგავიწყდათ თქვენი პაროლი?",
          "send_me_reset_password_instructions": "გამომიგზავნეთ პაროლის განახლების ინსტრუქცია"
        },
        "no_token": "თქვენ არ შეგიძლიათ ამ გვერდზე შესვლა პაროლის აღმდგენი შეტყობინებიდან გადამისამართების გარეშე. თუ თქვენ პაროლის აღმდგენი შეტყობინებიდან გადმომისამართდით, მაშინ ხელახლა გამოიყენეთ სრული ბმული.",
        "send_instructions": "თქვენ რამოდენიმე წუთში მოგივათ პაროლის განახლების ელ-ფოსტა ინსტრუქციით.",
        "send_paranoid_instructions": "თუ თქვენი ელ-ფოსტა მონაცემთა ბაზაში არსებობს, რამოდენიმე წუთში მოგივათ პაროლის აღმდგენი ბმული თქვენს ელ-ფოსტის მისამართზე. ",
        "updated": "თქვენი პაროლი წარმატებით შეიცვალა. ეხლა თქვენ ავთენტირებული ხართ.",
        "updated_not_active": "თქვენი პაროლი წარმატებით შეიცვალა."
      },
      "registrations": {
        "destroyed": "ნახვამდის! თქვენი ანგარიში წარმატებით გაუქმდა. ვიმედოვნებთ თქვენთან ხელახლა შეხვედრას. ",
        "edit": {
          "are_you_sure": "დარწმუნებული ხართ?",
          "cancel_my_account": "ჩემი ანგარიშის გაუქმება",
          "currently_waiting_confirmation_for_email": "ამჟამად ველოდებით დასტურს: %{email}-სთვის",
          "leave_blank_if_you_don_t_want_to_change_it": "თუ შეცვლა არ გნებავთ დატოვეთ ცარიელი",
          "title": "Edit  %{resource}",
          "unhappy": "უკმაყოფილო ხართ?",
          "update": "განახლება",
          "we_need_your_current_password_to_confirm_your_changes": "ჩვენ გვჭირდება თქვენი მოქმედი პაროლი ცვლილებების დასადასტურებლად"
        },
        "new": {
          "sign_up": "რეგისტრაცია"
        },
        "signed_up": "მოგესალმებით! თქვენ წარმატებით დარეგისტრირდით.",
        "signed_up_but_inactive": "თქვენ წარმატებით დარეგისტრირდით. თუმცა თქვენ არ ხართ ავთენტირებული რადგან თქვენი ანგარიში ჯერ არ არის აქტივირებული.",
        "signed_up_but_locked": "თქვენ წარმატებით დარეგისტრირდით. თუმცა თქვენ არ ხართ ავთენტირებული რადგან თქვენი ანგარიში ჩაკეტილია.",
        "signed_up_but_unconfirmed": "დამადასტურებელი ბმული გამოიგზავნა თქვენს ელ-ფოსტის მისამართზე. გთხოვთ მიჰყვეთ ბმულს თქვენი ანგარიშის გასააქტიურებლად.",
        "update_needs_confirmation": "თქვენ წარმატებით განაახლეთ თქვენი ანგარიში, მაგრამ ჩვენ უნდა დავადასტუროთ თქვენი ახალი ელ-ფოსტის მისამართი. გთხოვთ შეამოწმოთ თქვენი ელ-ფოსტა და მიჰყვეთ დამადასტურებელ ბმულს რათა დაადასტუროთ თქვენი ახალი ელ-ფოსტის მისამართი.",
        "updated": "თქვენი ანგარიში განახლებულია წარმატებით.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "თქვენ წარმატებით გამოხვედით სისტემიდან.",
        "new": {
          "sign_in": "ავთენტიკაცია"
        },
        "signed_in": "ავთენტიკაცია წარმატებულია.",
        "signed_out": "თქვენ წარმატებით გამოხვედით სისტემიდან."
      },
      "shared": {
        "links": {
          "back": "უკან",
          "didn_t_receive_confirmation_instructions": "არ მოგსვლიათ დადასტურების ინსტრუქცია?",
          "didn_t_receive_unlock_instructions": "არ მოგსვლიათ ანგარიშის გახსნის ინსტრუქცია?",
          "forgot_your_password": "დაგავიწყდათ პაროლი?",
          "sign_in": "ავთენტიკაცია",
          "sign_in_with_provider": "%{provider}-ით ავთენტიკაცია",
          "sign_up": "რეგისტრაცია"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "ხელახლა ანგარიშის გახსნის ინსტრუქციის გაგზავნა "
        },
        "send_instructions": "თქვენ რამოდენიმე წუთში მიიღებთ შეტყობინებას ანგარიშის გასახსნელად ინსტრუქციით.",
        "send_paranoid_instructions": "თუ თქვენი ანგარიში არსებობს, თქვენ რამოდენიმე წუთში მიიღებთ ანგარიშის გასახსნელ ინსტრუქციის ელ-ფოსტას.",
        "unlocked": "თქვენი ანგარიში წარმატებით განიბლოკა. გასაგრძელებლად გთხოვთ გაიაროთ ავთენტიკაცია."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "უნდა იყოს დადასტურებული",
        "already_confirmed": "უკვე დადასტურებულია, გთხოვთ სცადოთ ავთენტიკაცია",
        "blank": "არ შეიძლება იყოს ცარიელი",
        "confirmation": "ველი %{attribute}-ს არ ემთხვევა",
        "confirmation_period_expired": "უნდა დადასტურდეს %{period}-ის განმავლობაში, გთხოვთ მოითხოვოთ ახალი",
        "empty": "არ შეიძლება იყოს ცარიელი",
        "equal_to": "უნდა უდრიდეს %{count}-ს",
        "even": "უნდა იყოს ლუწი",
        "exclusion": "რეზერვირებულია",
        "expired": "ვადა გაუვიდა, გთხოვთ მოითხოვოთ ახალი",
        "greater_than": "უნდა იყოს %{count}-ზე მეტი",
        "greater_than_or_equal_to": "უნდა იყოს %{count}-ზე მეტი ან ტოლი",
        "inclusion": "არ არის სიაში",
        "invalid": "არასწორია",
        "less_than": "უნდა იყოს %{count}-ზე ნაკლები",
        "less_than_or_equal_to": "უნდა იყოს %{count}-ზე ნაკლები ან ტოლი",
        "model_invalid": "დადასტურება წარუმატებელია: %{errors}",
        "not_a_number": "არ არის რიცხვი",
        "not_an_integer": "არ არის მთელი რიცხვი",
        "not_found": "არ მოიძებნა",
        "not_locked": "არ იყო დაბლოკილი",
        "not_saved": {
          "one": "ერთი შეცდომის გამო ვერ მოხდა %{resource}-ის დამახსოვრება:",
          "other": "%{count} შეცდომის გამო ვერ მოხდა %{resource}-ის დამახსოვრება"
        },
        "odd": "უნდა იყოს კენტი",
        "other_than": "უნდა განსხვავდებოდეს %{count}-გან",
        "present": "უნდა იყოს ცარიელი",
        "required": "უნდა არსებობდეს",
        "taken": "უკვე დაკავებულია",
        "too_long": {
          "one": "არის ძალიან გრძელი (მაქსიმუმია %{count} სიმბოლო)",
          "other": "არის მეტისმეტად დიდი სიგრძის (მაქსიმუმია %{count} სიმბოლო)"
        },
        "too_short": {
          "one": "არის ძალიან მოკლე (მინიმუმია %{count} სიმბოლო)",
          "other": "არის ძალიან მოკლე (მინიმუმია %{count} სიმბოლო)"
        },
        "wrong_length": {
          "one": "არის არასწორი სიგრძის (უნდა იყოს ზუსტად %{count} სიბმოლო)",
          "other": "არის არასწორი სიგრძის (უნდა იყოს ზუსტად %{count} სიბმოლო)"
        }
      },
      "template": {
        "body": "შეიქმნა პრობლემები შემდეგ ველებთან დაკავშირებით:",
        "header": {
          "one": "%{model}-ს შენახვა ვერ განხორციელდა %{count} შეცდომის გამო",
          "other": "%{model}-ს შენახვა ვერ განხორციელდა %{count} შეცდომის გამო"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "გთხოვთ აირჩიოთ"
      },
      "submit": {
        "create": "%{model}-ს შექმნა",
        "submit": "%{model}-ს დამახსოვრება",
        "update": "%{model}-ს განახლება"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "ა": "a",
          "ბ": "b",
          "გ": "g",
          "დ": "d",
          "ე": "e",
          "ვ": "v",
          "ზ": "z",
          "თ": "T",
          "ი": "i",
          "კ": "k",
          "ლ": "l",
          "მ": "m",
          "ნ": "n",
          "ო": "o",
          "პ": "p",
          "ჟ": "J",
          "რ": "r",
          "ს": "s",
          "ტ": "t",
          "უ": "u",
          "ფ": "f",
          "ქ": "q",
          "ღ": "R",
          "ყ": "y",
          "შ": "S",
          "ჩ": "C",
          "ც": "c",
          "ძ": "Z",
          "წ": "w",
          "ჭ": "W",
          "ხ": "x",
          "ჯ": "j",
          "ჰ": "h"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "ლ"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "მილიარდი",
            "million": "მილიონი",
            "quadrillion": "კვადრილიონი",
            "thousand": "ათასი",
            "trillion": "ტრილიონი",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "ბაიტი",
              "other": "ბაიტები"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", და ",
        "two_words_connector": " და ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "დილის",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "საღამოს"
    }
  },
  "kk": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Тексеру сәтсіз аяқталды: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Жазбаны жою мүмкін емес, тәуелділіктер бар: %{record}",
            "has_one": "Жазбаны жою мүмкін емес, тәуелділік бар: %{record}"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Жс",
        "Дс",
        "Сс",
        "Ср",
        "Бс",
        "Жм",
        "Сб"
      ],
      "abbr_month_names": [
        null,
        "қаң.",
        "ақп.",
        "нау.",
        "сәу.",
        "мам.",
        "мау.",
        "шіл.",
        "там.",
        "қыр.",
        "қаз.",
        "қар.",
        "жел."
      ],
      "day_names": [
        "жексенбі",
        "дүйсенбі",
        "сейсенбі",
        "сәрсенбі",
        "бейсенбі",
        "жұма",
        "сенбі"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "каңтар",
        "ақпан",
        "наурыз",
        "сәуір",
        "мамыр",
        "маусым",
        "шілде",
        "тамыз",
        "қыркүйек",
        "қазан",
        "қараша",
        "желтоқсан"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "шамамен %{count} сағат",
          "other": "шамамен %{count} сағат"
        },
        "about_x_months": {
          "one": "шамамен %{count} ай",
          "other": "шамамен %{count} ай"
        },
        "about_x_years": {
          "one": "шамамен %{count} жыл",
          "other": "шамамен %{count} жыл"
        },
        "almost_x_years": {
          "one": "%{count} жылға жуық",
          "other": "%{count} жылға жуық"
        },
        "half_a_minute": "жарты минут",
        "less_than_x_minutes": {
          "one": "%{count} минуттан аз",
          "other": "%{count} минуттан аз"
        },
        "less_than_x_seconds": {
          "one": "%{count} секундтан аз",
          "other": "%{count} секундтан аз"
        },
        "over_x_years": {
          "one": "%{count} жылдан астам",
          "other": "%{count} жылдан астам"
        },
        "x_days": {
          "one": "%{count} күн",
          "other": "%{count} күн"
        },
        "x_minutes": {
          "one": "%{count} минут",
          "other": "%{count} минут"
        },
        "x_months": {
          "one": "%{count} ай",
          "other": "%{count} ай"
        },
        "x_seconds": {
          "one": "%{count} секунд",
          "other": "%{count} секунд"
        },
        "x_years": {
          "one": "%{count} жыл",
          "other": "%{count} жыл"
        }
      },
      "prompts": {
        "day": "Күн",
        "hour": "Сағат",
        "minute": "Минут",
        "month": "Ай",
        "second": "Секунд",
        "year": "Жыл"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "расталуы тиіс",
        "blank": "бос болуы мүмкін емес",
        "confirmation": "%{attribute} мәніне сәйкес келмейді",
        "empty": "бос болуы мүмкін емес",
        "equal_to": "тек %{count} тең мәнге ие болуы мүмкін",
        "even": "тек жұп мәнге ие бола алады",
        "exclusion": "сақталған мағына",
        "greater_than": "мәні %{count} санынан жоғары болуы керек",
        "greater_than_or_equal_to": "мәні %{count} санынан жоғары немесе тең болуы керек",
        "inclusion": "күтпеген мағына",
        "invalid": "қате мағына",
        "less_than": "мәні %{count} санынан кем болуы керек",
        "less_than_or_equal_to": "мәні %{count} санынан кем немесе тең болуы керек",
        "model_invalid": "Тексеру сәтсіз аяқталды: %{errors}",
        "not_a_number": "сан емес",
        "not_an_integer": "бүтін сан емес",
        "odd": "тек тақ мәнге ие бола алады",
        "other_than": "%{count} санынан өзгеше болуы тиіс",
        "present": "бос қалуы тиіс",
        "required": "жоқ болуы мүмкін емес",
        "taken": "бұрыннан бар",
        "too_long": {
          "one": "тым ұзын (%{count} таңбадан асырмаңыз)",
          "other": "тым ұзын (%{count} таңбадан асырмаңыз)"
        },
        "too_short": {
          "one": "тым қысқа (%{count} таңбадан көп немесе тең болуы тиіс)",
          "other": "тым қысқа (%{count} таңбадан көп немесе тең болуы тиіс)"
        },
        "wrong_length": {
          "one": "ұзындығы дұрыс емес (дәл %{count} таңба болуы тиіс)",
          "other": "ұзындығы дұрыс емес (дәл %{count} таңба болуы тиіс)"
        }
      },
      "template": {
        "body": "Келесі өрістермен проблемалар туындады:",
        "header": {
          "one": "%{model}: %{count} қатеге байланысты сақтау сәтсіз аяқталды",
          "other": "%{model}: %{count} қатеге байланысты сақтау сәтсіз аяқталды"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Таңдаңыз: "
      },
      "submit": {
        "create": "Құру %{model}",
        "submit": "Сақтау %{model}",
        "update": "Өзгерту %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "теңге"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "миллиард",
              "other": "миллиард"
            },
            "million": {
              "one": "миллион",
              "other": "миллион"
            },
            "quadrillion": {
              "one": "квадриллион",
              "other": "квадриллион"
            },
            "thousand": {
              "one": "мың",
              "other": "мың"
            },
            "trillion": {
              "one": "триллион",
              "other": "триллион"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "байт",
              "other": "байт"
            },
            "eb": "ЭБ",
            "gb": "ГБ",
            "kb": "КБ",
            "mb": "МБ",
            "pb": "ПБ",
            "tb": "ТБ"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " және ",
        "two_words_connector": " және ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "таңғы",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "кешкі"
    }
  },
  "km": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "ថ្ងៃដែលបានបញ្ជូនការបញ្ជាក់ពាក្យសម្ងាត់",
          "confirmation_token": "តូឃុនសំរាប់ការបញ្ជាក់ពាក្យសម្ងាត់",
          "confirmed_at": "ថ្ងៃដែលបានបញ្ជាក់ពាក្យសំងាត់",
          "created_at": "ថ្ងៃដែលបានបង្កើត",
          "current_password": "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
          "current_sign_in_at": "ពេលវេលាបច្ចុប្បន្នដែលបានចូលក្នុងប្រព័ន្ធ",
          "current_sign_in_ip": "អាសយដ្ឋានIPបច្ចុប្បន្នដែលបានចូលក្នុងប្រព័ន្ធ",
          "email": "អ៊ីមែល",
          "encrypted_password": "ពាក្យសំងាត់ដែលបានអ៊ិនគ្រីប",
          "failed_attempts": "ចំនួនដែលបានប៉ុនប៉ងចូលក្នុងប្រព័ន្ធមិនបានជោគជ័យ",
          "last_sign_in_at": "ពេលវេលាចូលចុងក្រោយដែលបានចូលក្នុងប្រព័ន្ធ",
          "last_sign_in_ip": "អាសយដ្ឋានIPចុងក្រោយដែលបានចូលក្នុងប្រព័ន្ធ",
          "locked_at": "ថ្ងៃដែលបានចាក់សោ",
          "password": "ពាក្យសម្ងាត់",
          "password_confirmation": "បញ្ជាក់ពាក្យសម្ងាត់",
          "remember_created_at": "ថ្ងៃដែលបានចងចាំខ្ញុំ",
          "remember_me": "ចងចាំខ្ញុំ",
          "reset_password_sent_at": "ថ្ងៃដែលបានបញ្ជូនការកំណត់ពាក្យសម្ងាត់ឡើងវិញ",
          "reset_password_token": "តូឃុនសំរាប់ការកំណត់ពាក្យសម្ងាត់ឡើងវិញ",
          "sign_in_count": "ចំនួនដែលបានចូលក្នុងប្រព័ន្ធ",
          "unconfirmed_email": "អ៊ីមែលដែលមិនបានបញ្ជាក់",
          "unlock_token": "តូឃុនសំរាប់ដោះសោ",
          "updated_at": "ថ្ងៃដែលបានធ្វើបច្ចុប្បន្នភាព"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "មិនមានសុពលភាព៖ %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "មិនអាចលុបបានទេពីព្រោះមាន %{record} នៅឡើយ",
            "has_one": "មិនអាចលុបបានទេពីព្រោះមាន %{record} នៅឡើយ"
          }
        }
      },
      "models": {
        "user": {
          "other": "អ្នកប្រើប្រាស់"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "អា",
        "ច",
        "អ",
        "ពុ",
        "ព្រហ",
        "សុ",
        "ស"
      ],
      "abbr_month_names": [
        null,
        "មករា",
        "កុម្ភៈ",
        "មិនា",
        "មេសា",
        "ឧសភា",
        "មិថុនា",
        "កក្កដា",
        "សីហា",
        "កញ្ញា",
        "តុលា",
        "វិច្ឆិកា",
        "ធ្នូ"
      ],
      "day_names": [
        "អាទិត្យ",
        "ចន្ទ",
        "អង្គារ",
        "ពុធ",
        "ព្រហស្បតិ៍",
        "សុក្រ",
        "សៅរ៍"
      ],
      "formats": {
        "default": "%d %B %Y",
        "long": "ថ្ងៃ%A ទី%e ខែ%B ឆ្នាំ%Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "មករា",
        "កុម្ភៈ",
        "មិនា",
        "មេសា",
        "ឧសភា",
        "មិថុនា",
        "កក្កដា",
        "សីហា",
        "កញ្ញា",
        "តុលា",
        "វិច្ឆិកា",
        "ធ្នូ"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "ប្រមាណ %{count} ម៉ោង",
        "about_x_months": "ប្រមាណ %{count} ខែ",
        "about_x_years": "ប្រមាណ %{count} ឆ្នាំ",
        "almost_x_years": "ជិត %{count} ឆ្នាំ",
        "half_a_minute": "កន្លះនាទី",
        "less_than_x_minutes": "តិចជាង %{count} នាទី",
        "less_than_x_seconds": "តិចជាង %{count} វិនាទី",
        "over_x_years": "លើសពី %{count} ឆ្នាំ",
        "x_days": "%{count} ថ្ងៃ",
        "x_minutes": "%{count} នាទី",
        "x_months": "%{count} ខែ",
        "x_seconds": "%{count} វិនាទី"
      },
      "prompts": {
        "day": "ថ្ងៃ",
        "hour": "ម៉ោង",
        "minute": "នាទី",
        "month": "ខែ",
        "second": "វិនាទី",
        "year": "ឆ្នាំ"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "អ្នកបានចុះឈ្មោះចូលក្នុងប្រព័ន្ធរួចរាល់ហើយ",
        "new": {
          "resend_confirmation_instructions": "ផ្ញើអ៊ីមែលសំរាប់ការបញ្ជាក់ការចុះឈ្មោះឡើងវិញ"
        },
        "send_instructions": "យើងនឹងផ្ញើអ៊ីមែលទៅអ្នកក្នុងរយៈពេលពីរបីនាទីអំពីដំណើរការការចុះឈ្មោះរបស់អ្នក។",
        "send_paranoid_instructions": "អ៊ីមែលបញ្ជាក់នឹងត្រូវបានផ្ញើទៅក្នុងរយៈពេលពីរបីនាទី ប្រសិនបើអ្នកបានចុះឈ្មោចូលក្នុងប្រព័ន្ធរួចរាល់ហើយនោះ។"
      },
      "failure": {
        "already_authenticated": "អ្នកបានចូលក្នុងប្រព័ន្ធរួចហើយ",
        "inactive": "ការចុះឈ្មោះរបស់អ្នកមិនទាន់បានបញ្ចប់នៅឡើយទេ។ សូមអនុវត្តតាមការណែនាំនៅក្នុងអ៊ីម៉ែលដើម្បបញ្ចប់។",
        "invalid": "%{authentication_keys}ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
        "last_attempt": "ប្រសិនបើអ្នកមានកំហុសមួយទៀតគណនីរបស់អ្នកនឹងត្រូវបានចាក់សោ។",
        "locked": "គណនីរបស់អ្នកត្រូវបានចាក់សោ។",
        "not_found_in_database": "%{authentication_keys}ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
        "timeout": "រយៈពេលប្រើប្រាស់ប្រព័ន្ធរបស់អ្នកបានផុតកំណត់។ សូមចូលក្នុងប្រព័ន្ធម្តងទៀត។",
        "unauthenticated": "សូមចុះឈ្មោះចូលដើម្បីប្រើប្រាស់ប្រព័ន្ធ។",
        "unconfirmed": "អ្នកត្រូវធ្វើរការបញ្ជាក់អាសយដ្ឋានអ៊ីមែលរបស់អ្នក។"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "បញ្ជាក់អាសយដ្ឋានអ៊ីមែល",
          "greeting": "សូមស្វាគមន៍! %{recipient}",
          "instruction": "សូមចុចតំណខាងក្រោមដើម្បីបញ្ចប់ដំណើរការផ្ទៀងផ្ទាត់តាមអាសយដ្ឋានអ៊ីមែល។",
          "subject": "អ៊ីមែលបញ្ជាក់"
        },
        "email_changed": {
          "greeting": "សួស្តី! %{recipient}",
          "message": "សូមជូនដំណឹងអំពីការផ្លាស់ប្តូរអ៊ីមែល %{email} របស់អ្នក។",
          "message_unconfirmed": null,
          "subject": "ការផ្លាស់ប្តូរអ៊ីមែលត្រូវបានបញ្ចប់រួចរាល់ហើយ។"
        },
        "password_change": {
          "greeting": "សួស្តី! %{recipient}",
          "message": "សូមជូនដំណឹងអំពីការផ្លាស់ប្តូរពាក្យសម្ងាត់របស់អ្នក។",
          "subject": "ការផ្លាស់ប្តូរពាក្យសម្ងាត់ត្រូវបានបញ្ចប់រួចរាល់ហើយ។"
        },
        "reset_password_instructions": {
          "action": "ការផ្លាស់ប្តូរពាក្យសម្ងាត់",
          "greeting": "សួស្តី! %{recipient}",
          "instruction": "អ៊ីមែលត្រូវបានផ្ញើព្រោះបានទទួលសំណើកំណត់ពាក្យសម្ងាត់ឡើងវិញ។ អ្នកអាចកំណត់ពាក្យសម្ងាត់របស់អ្នកឡើងវិញតាមរយ:តំណខាងក្រោម។",
          "instruction_2": "ប្រសិនបើអ្នកមិនបានស្នើសុំកំណត់លេខសំងាត់ឡើងវិញទេ សូមមេត្តាកុំអើពើអ៊ីមែលនេះ។",
          "instruction_3": "ការកំណត់ពាក្យសំងាត់ឡើងវិញនឹងមិនត្រូវបានបញ្ចប់ទេរហូតទាល់តែលេខសំងាត់ថ្មីត្រូវបានបង្កើតពីតំណខាងលើ។",
          "subject": "អំពីការកំណត់ពាក្យសម្ងាត់ឡើងវិញ"
        },
        "unlock_instructions": {
          "action": "ដោះសោគណនី",
          "greeting": "សួស្តី! %{recipient}",
          "instruction": "សូមចុចតំណខាងក្រោមដើម្បីដោះសោគណនីរបស់អ្នក។",
          "message": "គណនីរបស់អ្នកត្រូវបានចាក់សោរដោយសារតែមានប៉ុនប៉ងចូលក្នុងប្រព័ន្ធមិនបានជោគជ័យជាច្រើនលើក។",
          "subject": "អំពីការដោះសោគណនី"
        }
      },
      "omniauth_callbacks": {
        "failure": "ការផ្ទៀងផ្ទាត់តាមរយ: %{kind} មិនបានជោគជ័យ។ ដោយសារតែ %{reason}",
        "success": "ការផ្ទៀងផ្ទាត់តាមរយ: %{kind} បានជោគជ័យ។"
      },
      "passwords": {
        "edit": {
          "change_my_password": "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
          "change_your_password": "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
          "confirm_new_password": "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី",
          "new_password": "ភ្លេចពាក្យសម្ងាត់?"
        },
        "new": {
          "forgot_your_password": "ភ្លេចពាក្យសម្ងាត់?",
          "send_me_reset_password_instructions": "ផ្ញើការណែនាំអំពីការកំណត់ពាក្យសម្ងាត់ឡើងវិញ។"
        },
        "no_token": "អ្នកមិនអាចចូលប្រើទំព័រនេះតាមរយ:តំណនេះបានទេ។ សូមប្រាកដថាអ្នកបានប្រើURLពេញលេញដែលបានផ្តល់។",
        "send_instructions": "យើងនឹងផ្ញើអ៊ីមែលទៅអ្នកក្នុងរយៈពេលពីរបីនាទីអំពីការកំណត់ពាក្យសម្ងាត់ឡើងវិញ។",
        "send_paranoid_instructions": "អ៊ីមែលអំពីការកំណត់ពាក្យសម្ងាត់ឡើងវិញនឹងត្រូវបានផ្ញើទៅក្នុងរយៈពេលពីរបីនាទី ប្រសិនបើអ្នកបានចុះឈ្មោចូលក្នុងប្រព័ន្ធរួចរាល់ហើយនោះ។",
        "updated": "ពាក្យសម្ងាត់ត្រូវបានផ្លាស់ប្តូររួចរាល់ហើយ។",
        "updated_not_active": "ពាក្យសម្ងាត់ត្រូវបានផ្លាស់ប្តូររួចរាល់ហើយ។"
      },
      "registrations": {
        "destroyed": "ជំរាបលា! គណនីរបស់អ្នកត្រូវបានលុបចោល។",
        "edit": {
          "are_you_sure": "តើអ្នកប្រាកដទេ?",
          "cancel_my_account": "លុបគណនី",
          "currently_waiting_confirmation_for_email": "កំពុងរង់ចាំការបញ្ជាក់អ៊ីមែល %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "សូមទុកឱ្យនៅទទេប្រសិនបើអ្នកមិនចង់ធ្វើរការផ្លាស់ប្តូរ។",
          "title": "កែ%{resource}",
          "unhappy": "មិនសប្បាយចិត្ត?",
          "update": "ធ្វើបច្ចុប្បន្នភាព",
          "we_need_your_current_password_to_confirm_your_changes": "សូមបញ្ចូលពាក្យសម្ងាត់បច្ចុប្បន្នដើម្បីធ្វើរការផ្លាស់ប្តូរ។"
        },
        "new": {
          "sign_up": "ចុះឈ្មោះ"
        },
        "signed_up": "សូមស្វាគមន៍! អ្នកបានចុះឈ្មោះចូលក្នុងប្រព័ន្ធរួចរាល់ហើយ។",
        "signed_up_but_inactive": "ការចុះឈ្មោះរបស់អ្នកមិនទាន់បានបញ្ចប់នៅឡើយទេ។ សូមអនុវត្តតាមការណែនាំដើម្បបញ្ចប់។",
        "signed_up_but_locked": "អ្នកមិនអាចចូលក្នុងប្រព័ន្ធបានទេព្រោះគណនីរបស់អ្នកជាប់សោ។",
        "signed_up_but_unconfirmed": "អ៊ីមែលសម្រាប់ការបញ្ជាក់ត្រូវបានផ្ញើ។ សូមអនុវត្តតាមការណែនាំនៅក្នុងអ៊ីម៉ែលដើម្បបញ្ចប់។",
        "update_needs_confirmation": "ព័ត៌មានគណនីត្រូវបានផ្លាស់ប្តូរ។ ដើម្បីផ្ទៀងផ្ទាត់អាសយដ្ឋានអ៊ីមែលដែលបានផ្លាស់ប្តូរ សូមអនុវត្តតាមការណែនាំនៅក្នុងអ៊ីម៉ែលដើម្បបញ្ចប់។",
        "updated": "ព័ត៌មានគណនីត្រូវបានផ្លាស់ប្តូរ។",
        "updated_but_not_signed_in": "ព័ត៌មានគណនីត្រូវបានផ្លាស់ប្តូរ។ សូមចូលក្នុងប្រព័ន្ធម្តងទៀត។"
      },
      "sessions": {
        "already_signed_out": "អ្នកបានចេញពីប្រព័ន្ធរួចហើយ។",
        "new": {
          "sign_in": "ចូល"
        },
        "signed_in": "បានចូលក្នុងប្រព័ន្ធ។",
        "signed_out": "បានចេញពីប្រព័ន្ធ។"
      },
      "shared": {
        "links": {
          "back": "ត្រឡប់ក្រោយ",
          "didn_t_receive_confirmation_instructions": "មិនបានទទួលអ៊ីមែលបញ្ជាក់គណនី?",
          "didn_t_receive_unlock_instructions": "មិនបានទទួលអ៊ីមែលអំពីរបៀបដោះសោគណនី?",
          "forgot_your_password": "ភ្លេចពាក្យសម្ងាត់?",
          "sign_in": "ចូល",
          "sign_in_with_provider": "ចូលតាមរយ: %{provider}",
          "sign_up": "ចុះឈ្មោះ"
        },
        "minimum_password_length": {
          "other": "(ច្រើនជាង%{count}តួអក្សរ។)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "ផ្ញើអ៊ីមែលម្ដងទៀតអំពីរបៀបដោះសោគណនី"
        },
        "send_instructions": "យើងនឹងផ្ញើអ៊ីមែលទៅអ្នកក្នុងរយៈពេលពីរបីនាទីអំពីរបៀបដោះសោគណនី។",
        "send_paranoid_instructions": "អ៊ីមែលអំពីរបៀបដោះសោគណនីនឹងត្រូវបានផ្ញើទៅក្នុងរយៈពេលពីរបីនាទី ប្រសិនបើអ្នកបានចុះឈ្មោចូលក្នុងប្រព័ន្ធរួចរាល់ហើយនោះ។",
        "unlocked": "គណនីរបស់អ្នកត្រូវបានដោះសោ។ សូមចូលក្នុងប្រព័ន្ធម្តងទៀត។"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ត្រូវតែយល់ព្រម",
        "already_confirmed": "បានចុះឈ្មោះរួចរាល់ហើយ។ សូមចូលក្នុងប្រព័ន្ធ។",
        "blank": "មិនអាចរំលង",
        "confirmation": "ផ្ទៀងផ្ទាត់មិនត្រូវនឹង %{attribute}",
        "confirmation_period_expired": "រយៈពេលប្រើប្រាស់បានផុតកំណត់។ ត្រូវការបញ្ជាក់នៅក្នុងកំឡុង%{period}។ សូមធ្វើសំណើថ្មី។",
        "empty": "មិនអាចរំលង",
        "equal_to": "ត្រូវតែស្មើ %{count}",
        "even": "ត្រូវតែជាចំនួនគត់",
        "exclusion": "មិនអនុញ្ញាតឱ្យប្រើ",
        "expired": "រយៈពេលប្រើប្រាស់បានផុតកំណត់។ សូមធ្វើសំណើថ្មី។",
        "greater_than": "ត្រូវតែច្រើនជាង %{count}",
        "greater_than_or_equal_to": "ត្រូវតែច្រើនជាងឬស្មើ %{count}",
        "inclusion": "មិនមាននៅក្នុងបញ្ជី",
        "invalid": "មិនត្រឹមត្រូវ",
        "less_than": "ត្រូវតែតិចជាង %{count}",
        "less_than_or_equal_to": "ត្រូវតែតិចជាងឬស្មើ %{count}",
        "not_a_number": "មិនមែនជាលេខទេ",
        "not_an_integer": "ត្រូវតែជាចំនួនគត់",
        "not_found": "ស្វែងរកមិនឃើញ",
        "not_locked": "មិនបានចាក់សោ",
        "not_saved": {
          "other": "%{resource}មិនត្រូវបានរក្សាទុកដោយសារមានកំហុស។"
        },
        "odd": "ត្រូវតែជាចំនួនសេស",
        "other_than": "ត្រូវតែខុសពី %{count}",
        "present": "ត្រូវតែរំលង",
        "taken": "មានរួចហើយ",
        "too_long": "វែងពេក (យ៉ាងច្រើន %{count} តួ)",
        "too_short": "ខ្លីពេក (យ៉ាងតិច %{count} តួ)",
        "wrong_length": "ប្រវែងមិនត្រូវ (គួរតែមាន %{count} តួ)"
      },
      "template": {
        "body": "សូមពិនិត្យមើលកំហុសនៅខាងក្រោម:",
        "header": "មានកំហុស %{count} ដែលបានបញ្ឈប់ការរក្សាទុក %{model}នេះ"
      }
    },
    "helpers": {
      "select": {
        "prompt": "សូមជ្រើសរើស"
      },
      "submit": {
        "create": "បង្កើត%{model}",
        "submit": "រក្សាទុក%{model}",
        "update": "ប្តូរ%{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "៛"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "ប៊ីលាន",
            "million": "លាន",
            "quadrillion": "ក្វាទ្រីលាន",
            "thousand": "ពាន់",
            "trillion": "ទ្រីលាន",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", និង ",
        "two_words_connector": " និង ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "ព្រឹក",
      "formats": {
        "default": "%a %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "​ល្ងាច"
    }
  },
  "kn": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "ತಪ್ಪು ಆಧಾರ: %{errors}"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ರವಿ",
        "ಸೋಮ",
        "ಮಂಗಳ",
        "ಬುಧ",
        "ಗುರು",
        "ಶುಕ್ರ",
        "ಶನಿ"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "ರವಿವಾರ",
        "ಸೋಮವಾರ",
        "ಮಂಗಳವಾರ",
        "ಬುಧವಾರ",
        "ಗುರುವಾರ",
        "ಶುಕ್ರವಾರ",
        "ಶನಿವಾರ"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "ಜನವರಿ",
        "ಫೆಬ್ರವರಿ",
        "ಮಾರ್ಚ್",
        "ಏಪ್ರಿಲ್",
        "ಮೇ",
        "ಜೂನ್",
        "ಜುಲೈ",
        "ಆಗಸ್ಟ್",
        "ಸೆಪ್ಟೆಂಬರ್",
        "ಅಕ್ಟೋಬರ್",
        "ನವಂಬರ್",
        "ಡಿಸೆಂಬರ್"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ಸುಮಾರು ಒಂದು ಗಂಟೆ",
          "other": "ಸುಮಾರು %{count} ಗಂಟೆಗಳು"
        },
        "about_x_months": {
          "one": "ಸುಮಾರು ಒಂದು ತಿಂಗಳು",
          "other": "ಸುಮಾರು %{count} ತಿಂಗಳುಗಳು"
        },
        "about_x_years": {
          "one": "ಸುಮಾರು ಒಂದು ವರುಷ",
          "other": "ಸುಮಾರು %{count} ವರುಷಗಳು"
        },
        "almost_x_years": {
          "one": "ಸರಿಸುಮಾರು ಒಂದು ವರುಷ",
          "other": "ಸರಿಸುಮಾರು %{count} ವರುಷಗಳು"
        },
        "half_a_minute": "ಒಂದು ಅರ್ಧ ನಿಮಿಷ",
        "less_than_x_minutes": {
          "one": "ಒಂದು ನಿಮಿಷಕ್ಕೂ ಕಡಿಮೆ",
          "other": "%{count} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
        },
        "less_than_x_seconds": {
          "one": "ಒಂದು ಸೆಕೆಂಡಿಗೂ ಕಡಿಮೆ",
          "other": "%{count} ಸೆಕೆಂಡಿಗಿಂತ ಕಡಿಮೆ"
        },
        "over_x_years": {
          "one": "ಒಂದು ವರುಷಕ್ಕಿಂತ ಹೆಚ್ಚು",
          "other": "%{count} ವರುಷಗಳಿಗಿಂತ ಹೆಚ್ಚು"
        },
        "x_days": {
          "one": "%{count} ದಿನ",
          "other": "%{count} ದಿನಗಳು"
        },
        "x_minutes": {
          "one": "%{count} ನಿಮಿಷ",
          "other": "%{count} ನಿಮಿಷಗಳು"
        },
        "x_months": {
          "one": "%{count} ತಿಂಗಳು",
          "other": "%{count} ತಿಂಗಳುಗಳು"
        },
        "x_seconds": {
          "one": "%{count} ಸೆಕೆಂಡ್",
          "other": "%{count} ಸೆಕೆಂಡುಗಳು"
        }
      },
      "prompts": {
        "day": "ದಿನ",
        "hour": "ಗಂಟೆ",
        "minute": "ನಿಮಿಷ",
        "month": "ತಿಂಗಳು",
        "second": "ಸೆಕೆಂಡು",
        "year": "ವರುಷ"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ಒಪ್ಪಿಕೊಳ್ಳಬೇಕು",
        "blank": "ಖಾಲಿ ಬಿಡಲು ಸಧ್ಯವಿಲ್ಲ",
        "confirmation": "ಸಮರ್ಥನೆ ಸರಿಬರಲ್ಲಿಲ್ಲ",
        "empty": "ಖಾಲಿ ಬಿಡಲು ಸಧ್ಯವಿಲ್ಲ",
        "equal_to": "%{count} ಕ್ಕೆ ಸಮಾನವಾಗಿರಬೇಕು",
        "even": "ಸಮ ಆಗಿರಬೇಕು",
        "exclusion": "ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ",
        "greater_than": "%{count} ಕ್ಕಿಂತ ಹೆಚ್ಚಿರಬೇಕು",
        "greater_than_or_equal_to": "%{count} ಕಿಂತ ಹೆಚ್ಚು ಅಥವಾ ಸಮಾನವಾಗಿರ ಇರಬೇಕು",
        "inclusion": "ಪಟ್ಟಿಯಲ್ಲಿ ಶಾಮೀಲು ಆಗಿಲ್ಲ",
        "invalid": "ನಿರರ್ಥಕವಾಗಿದೆ",
        "less_than": "%{count} ಕ್ಕಿಂತ ಕಡಿಮೆ ಆಗಿರಬೇಕು",
        "less_than_or_equal_to": "%{count} ಕಿಂತ ಕಡಿಮೆ ಅಥವಾ ಸಮಾನವಾಗಿರ ಇರಬೇಕು",
        "not_a_number": "ಸಂಖೆ ಆಗಿಲ್ಲ",
        "not_an_integer": "ಸಂಖೆ ಆಗಿರಬೇಕು",
        "odd": "ಬೆಸ ಆಗಿರಬೇಕು",
        "taken": "ತೆಗೆದುಕೊಂಡಾಗಿದೆ",
        "too_long": "ಬಹಳ ದೊಡ್ಡದಾಗಿದೆ (ಗರಿಷ್ಟ %{count} ಅಕ್ಷರಗಳು)",
        "too_short": "ಬಹಳ ಚಿಕ್ಕದಾಗಿದೆ (ಕನಿಷ್ಠ %{count} ಅಕ್ಷರಗಳು)",
        "wrong_length": "ತಪ್ಪು ಉದ್ದವಿದೆ (%{count} ಅಕ್ಷರಗಳಿರಬೇಕು)"
      },
      "template": {
        "body": "ಸಮಸ್ಯೆಗಳಿರುವ ಜಾಗಗಳು:",
        "header": {
          "one": "%{count} ಧೋಷದ ಪರಿಣಾಮ %{model} ಅನ್ನು ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ",
          "other": "%{count} ಧೋಷಗಳ ಪರಿಣಾಮ %{model} ಅನ್ನು ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "ದಯವಿಟ್ಟು ಆರಿಸಿ"
      },
      "submit": {
        "create": "%{model} ರಚಿಸಿ",
        "submit": "%{model} ಕಳುಹಿಸು",
        "update": "%{model} ರಚಿಸಿ"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "ಲಕ್ಷಕೋಟಿ",
            "million": "ದಶಲಕ್ಷ",
            "quadrillion": "ಪದ್ಮ",
            "thousand": "ಸಾವಿರ",
            "trillion": "ನೀಲ್",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", ಮತ್ತು  ",
        "two_words_connector": " ಮತ್ತು  ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "ಪ್ರಾತಃಕಾಲ",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "ಅಪರನ್ನಃ"
    }
  },
  "ko": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "확인 메일 전송 시간",
          "confirmation_token": "확인 토큰",
          "confirmed_at": "확인된 시간",
          "created_at": "생성된 시간",
          "current_password": "현재 비밀번호",
          "current_sign_in_at": "현재 접속 시간",
          "current_sign_in_ip": "현재 접속 IP주소",
          "email": "이메일",
          "encrypted_password": "암호화된 비밀번호",
          "failed_attempts": "접속시도 실패",
          "last_sign_in_at": "마지막 접속 시간",
          "last_sign_in_ip": "마지막 접속 IP주소",
          "locked_at": "접근 잠김 시간",
          "password": "비밀번호",
          "password_confirmation": "비밀번호 확인",
          "remember_created_at": "로그인 기록된 시간",
          "remember_me": "로그인 정보 기억하기",
          "reset_password_sent_at": "재설정된 암호 발송",
          "reset_password_token": "재설정된 암호 토큰",
          "sign_in_count": "로그인 수",
          "unconfirmed_email": "확인되지 않은 이메일 주소",
          "unlock_token": "잠금해제 토큰",
          "updated_at": "업데이트된 시간"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "데이터 검증에 실패하였습니다. %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "%{record}(이)가 존재하기 때문에 삭제할 수 없습니다",
            "has_one": "%{record}(이)가 존재하기 때문에 삭제할 수 없습니다"
          }
        }
      },
      "models": {
        "user": {
          "other": "사용자"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "일",
        "월",
        "화",
        "수",
        "목",
        "금",
        "토"
      ],
      "abbr_month_names": [
        null,
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월"
      ],
      "day_names": [
        "일요일",
        "월요일",
        "화요일",
        "수요일",
        "목요일",
        "금요일",
        "토요일"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y년 %m월 %d일",
        "short": "%m월 %d일"
      },
      "month_names": [
        null,
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "대략 %{count}시간",
        "about_x_months": "대략 %{count}개월",
        "about_x_years": "대략 %{count}년",
        "almost_x_years": "거의 %{count}년",
        "half_a_minute": "30초",
        "less_than_x_minutes": "%{count}분 미만",
        "less_than_x_seconds": "%{count}초 미만",
        "over_x_years": "%{count}년 초과",
        "x_days": "%{count}일",
        "x_minutes": "%{count}분",
        "x_months": "%{count}개월",
        "x_seconds": "%{count}초",
        "x_years": "%{count}년"
      },
      "prompts": {
        "day": "일",
        "hour": "시",
        "minute": "분",
        "month": "월",
        "second": "초",
        "year": "년"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "이메일 주소가 성공적으로 인증되었습니다.",
        "new": {
          "resend_confirmation_instructions": "인증 안내 재발송"
        },
        "send_instructions": "이메일로 이메일 주소 인증 안내가 발송되었습니다.",
        "send_paranoid_instructions": "이메일 주소가 존재한다면 메일로 인증 안내 메일을 받을 수 있습니다."
      },
      "failure": {
        "already_authenticated": "이미 로그인되어 있습니다.",
        "inactive": "계정이 아직 활성화되지 않았습니다.",
        "invalid": "%{authentication_keys} 또는 비밀번호가 올바르지 않습니다.",
        "invited": "귀하께로 초대장이 발부되었습니다. 초대를 수락하면 계정을 생성할 수 있습니다. ",
        "last_attempt": "이번 로그인 시도를 실패하면 계정이 잠깁니다.",
        "locked": "계정이 잠겨있습니다.",
        "not_found_in_database": "%{authentication_keys} 또는 비밀번호가 올바르지 않습니다.",
        "timeout": "세션이 만료되었습니다. 계속하려면 다시 로그인해야 합니다.",
        "unauthenticated": "계속하려면 로그인하거나 가입해야 합니다.",
        "unconfirmed": "계속하기 전에 이메일 주소를 인증해야 합니다."
      },
      "invitations": {
        "edit": {
          "header": "비밀번호 설정",
          "submit_button": "설정하기"
        },
        "invitation_removed": "귀하께로 온 초대장이 삭제되었습니다.",
        "invitation_token_invalid": "제공된 초대장 토큰이 유효하지 않습니다!",
        "new": {
          "header": "초대장 발송",
          "submit_button": "발송하기"
        },
        "no_invitations_remaining": "남은 초대장이 없습니다.",
        "send_instructions": "초대 이메일이 %{email}에게로 발송되었습니다.",
        "updated": "비밀번호가 성공적으로 설정되었으며, 현재 로그인 상태입니다.",
        "updated_not_active": "비밀번호가 성공적으로 설정되었습니다."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "본인 계정 인증",
          "confirm_account_link": "본인 계정 인증",
          "confirm_link_msg": "아래의 링크를 이용해 계정 인증을 할 수 있습니다.",
          "greeting": "%{recipient}님",
          "instruction": "아래 링크를 클릭하시면 이메일 인증이 완료됩니다:",
          "subject": "이메일 인증 안내"
        },
        "email_changed": {
          "greeting": "%{recipient}님 환영합니다!",
          "message": "당신의 이메일이 %{email}로 변경되었음을 알려드립니다.",
          "message_unconfirmed": null,
          "subject": "이메일이 변경되었습니다."
        },
        "invitation_instructions": {
          "accept": "초대수락",
          "hello": "%{email}님 안녕하세요.",
          "ignore": "초대를 원치 않을 경우 이 이메일을 무시해도 됩니다.<br />위의 링크로 접속하여 귀하의 비밀번호를 설정하여 계정을 생성할 수 있습니다.",
          "someone_invited_you": "귀하는 %{url}로 초대되었습니다. 아래의 링크를 클릭하여 초대를 수락할 수 있습니다.",
          "subject": "초대장 안내메일"
        },
        "password_change": {
          "greeting": "%{recipient}님",
          "message": "당신의 계정 비밀번호가 변경되었음을 알려드립니다.",
          "subject": "비밀번호가 변경되었습니다."
        },
        "reset_password_instructions": {
          "action": "비밀번호 변경",
          "greeting": "%{recipient}님",
          "ignore_mail_msg": "비밀번호 변경을 요청하지 않으셨다면 이 메일을 무시하십시오.",
          "instruction": "누군가 당신의 비밀번호를 변경하는 링크를 요청했으며, 다음의 링크에서 비밀번호 변경이 가능합니다.",
          "instruction_2": "비밀번호 변경을 요청하지 않으셨다면 이 메일을 무시하십시오.",
          "instruction_3": "위 링크에 접속하여 새로운 비밀번호를 생성하기 전까지 귀하의 비밀번호는 변경되지 않습니다.",
          "no_changes_msg": "위 링크에 접속하여 새로운 비밀번호를 생성하기 전까지 귀하의 비밀번호는 변경되지 않습니다.",
          "password_change_link": "비밀번호 변경",
          "request_reset_link_msg": "누군가 당신의 비밀번호를 변경하는 링크를 요청했으며, 다음의 링크에서 비밀번호 변경이 가능합니다.",
          "subject": "비밀번호 재설정 안내"
        },
        "unlock_instructions": {
          "account_lock_msg": "로그인 실패 횟수 초과로 귀하의 계정이 잠금 처리되었습니다.",
          "action": "본인 계정 잠금 해제",
          "greeting": "%{recipient}님",
          "instruction": "계정 잠금을 해제하려면 아래 링크를 클릭하세요.",
          "message": "로그인 실패 횟수 초과로 귀하의 계정이 잠금 처리되었습니다.",
          "subject": "잠금 해제 안내",
          "unlock_link": "계정 잠금 해제",
          "unlock_link_msg": "계정 잠금을 해제하려면 아래 링크를 클릭하세요."
        }
      },
      "omniauth_callbacks": {
        "failure": "%{reason}(으)로 인하여 %{kind}(으)로부터 인증받지 못했습니다.",
        "success": "%{kind} 계정으로부터 인증되었습니다."
      },
      "passwords": {
        "edit": {
          "change_my_password": "내 비밀번호를 변경합니다",
          "change_your_password": "비밀번호 변경",
          "confirm_new_password": "새 비밀번호 확인",
          "new_password": "새 비밀번호"
        },
        "new": {
          "forgot_your_password": "비밀번호를 잊으셨나요?",
          "send_me_reset_password_instructions": "비밀번호 재설정 안내를 요청합니다"
        },
        "no_token": "비밀번호 재설정 이메일을 거치지 않고 이 페이지에 접근할 수 없습니다. 비밀번호 재설정 이메일에서 오셨다면, 주소가 제대로 되었는지 확인해 주세요.",
        "send_instructions": "잠시 후에 비밀번호 재설정 안내 메일을 받을 수 있습니다.",
        "send_paranoid_instructions": "회원정보에 등록된 이메일 주소와 동일하면, 몇 분 안에 비밀번호 재설정 주소를 이메일로 받으실 수 있습니다.",
        "updated": "성공적으로 비밀번호를 변경했습니다. 로그인 되었습니다.",
        "updated_not_active": "비밀번호가 성공적으로 변경되었습니다."
      },
      "registrations": {
        "destroyed": "회원님의 계정이 성공적으로 탈퇴처리 되었습니다. 다시 볼 수 있기를 바랍니다.",
        "edit": {
          "are_you_sure": "정말로 탈퇴하시겠습니까?",
          "cancel_my_account": "회원 탈퇴",
          "currently_waiting_confirmation_for_email": "현재 이메일 인증 대기중 입니다: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "변경을 원하지 않으시면 빈 칸으로 남겨주세요",
          "title": "%{resource} 정보 수정",
          "unhappy": "회원 탈퇴를 하시겠습니까?",
          "update": "변경",
          "we_need_your_current_password_to_confirm_your_changes": "변경 사항을 반영하려면 현재 비밀번호를 입력하세요"
        },
        "new": {
          "sign_up": "회원 가입"
        },
        "signed_up": "환영합니다! 성공적으로 가입 되었습니다.",
        "signed_up_but_inactive": "성공적으로 가입되었지만, 아직 계정이 활성화되어 있지 않아 로그인 할 수 없습니다.",
        "signed_up_but_locked": "성공적으로 가입되었지만, 계정이 잠겨있어 로그인 할 수 없습니다.",
        "signed_up_but_unconfirmed": "인증 주소가 포함된 메시지를 이메일 주소로 보냈습니다. 계정을 활성화하기 위해 메일을 확인하세요.",
        "update_needs_confirmation": "계정이 성공적으로 수정되었지만, 새로운 이메일 주소를 확인해야 합니다. 이메일로 전송된 인증 주소를 클릭하여 새로운 이메일 주소를 인증해 주세요.",
        "updated": "계정이 성공적으로 수정되었습니다.",
        "updated_but_not_signed_in": "계정이 성공적으로 수정되었지만, 비밀번호가 변경되어 다시 로그인 해야 합니다."
      },
      "sessions": {
        "already_signed_out": "성공적으로 로그아웃 되었습니다.",
        "new": {
          "sign_in": "로그인"
        },
        "signed_in": "성공적으로 로그인 되었습니다.",
        "signed_out": "성공적으로 로그아웃 되었습니다."
      },
      "shared": {
        "links": {
          "back": "돌아가기",
          "didn_t_receive_confirmation_instructions": "인증 이메일을 못받으셨나요?",
          "didn_t_receive_unlock_instructions": "잠금 해제 이메일을 못받으셨나요?",
          "forgot_your_password": "비밀번호를 잊으셨나요?",
          "sign_in": "로그인",
          "sign_in_with_provider": "%{provider}(으)로 로그인",
          "sign_up": "회원 가입"
        },
        "minimum_password_length": {
          "other": "최소 길이 %{count} 자"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "계정 잠금 해제 재요청"
        },
        "send_instructions": "잠시 후 이메일로 계정 잠금 해제 안내를 받아보실 수 있습니다.",
        "send_paranoid_instructions": "계정이 존재한다면 메일로 계정 잠금 해제 안내를 받을 수 있습니다.",
        "unlocked": "계정이 성공적으로 잠금 해제되었습니다. 새로 로그인해 주세요."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "'%{redirect_url}' 주소로 리다이렉트는 허용하지 않습니다."
      },
      "passwords": {
        "missing_email": "이메일 주소를 입력해야 합니다.",
        "missing_passwords": "비밀번호와 비밀번호 확인 필드를 반드시 입력해야 합니다.",
        "missing_redirect_url": "redirect URL이 없습니다.",
        "not_allowed_redirect_url": "'%{redirect_url}' 주소로 리다이렉트는 허용하지 않습니다.",
        "password_not_required": "이 계정은 비밀번호가 필요하지 않습니다. '%{provider}'으로 로그인을 진행해 주세요.",
        "sended": "'%{email}'로 비밀번호를 재설정하기 위한 안내 메일을 발송했습니다.",
        "successfully_updated": "비밀번호를 성공적으로 업데이트 했습니다.",
        "user_not_found": "'%{email}'을 사용하는 유저를 찾을 수 없습니다."
      },
      "registrations": {
        "account_to_destroy_not_found": "삭제할 계정을 찾을 수 없습니다.",
        "account_with_uid_destroyed": " UID가 '%{uid}'인 계정을 삭제했습니다.",
        "email_already_exists": "'%{email}'을 사용하는 계정이 이미 있습니다.",
        "missing_confirm_success_url": "'confirm_success_url' 파라미터가 없습니다.",
        "redirect_url_not_allowed": "'%{redirect_url}' 주소로 리다이렉트는 허용하지 않습니다.",
        "user_not_found": "유저를 찾을 수 없습니다."
      },
      "sessions": {
        "bad_credentials": "계정 정보가 맞지 않습니다. 다시 시도해 주세요.",
        "invalid": "계정 정보가 맞지 않습니다.",
        "not_confirmed": "'%{email}'로 주소 인증 메일을 발송했습니다. 계정을 활성화하기 위해서는 반드시 메일의 안내를 따라야 합니다.",
        "not_supported": "POST /sign_in to sign in을 사용해주세요. GET은 지원하지 않습니다.",
        "user_not_found": "유저를 찾을 수 없습니다."
      },
      "unlocks": {
        "missing_email": "이메일 주소를 반드시 입력해야 합니다.",
        "sended": "'%{email}'로 계정 잠금 해제를 위한 안내 메일을 발송했습니다.",
        "user_not_found": "'%{email}'을 사용하는 유저를 찾을 수 없습니다."
      }
    },
    "errors": {
      "format": "%{message}",
      "messages": {
        "accepted": "%{attribute}을(를) 반드시 확인해야 합니다",
        "already_confirmed": "은(는) 이미 인증되었습니다. 다시 로그인 해보세요.",
        "blank": "%{attribute}에 내용을 입력해 주세요",
        "confirmation": "%{attribute}은(는) 서로 일치해야 합니다",
        "confirmation_period_expired": "%{period} 이내에 이메일 인증을 해야 합니다. 새로 요청해 주세요.",
        "empty": "%{attribute}에 내용을 입력해 주세요",
        "equal_to": "%{attribute}은(는) %{count}와(과) 같아야 합니다",
        "even": "%{attribute}에 짝수를 입력해 주세요",
        "exclusion": "%{attribute}은(는) 이미 예약되어 있는 값입니다",
        "expired": "이(가) 만료되었습니다 새로 요청해 주세요.",
        "greater_than": "%{attribute}은(는) %{count}보다 커야 합니다",
        "greater_than_or_equal_to": "%{attribute}은(는) %{count}보다 크거나 같아야 합니다",
        "in": "%{attribute}은(는) %{count}범위 안에 있어야 합니다",
        "inclusion": "%{attribute}은(는) 목록에 포함되어 있는 값이 아닙니다",
        "invalid": "%{attribute}은(는) 올바르지 않은 값입니다",
        "less_than": "%{attribute}은(는) %{count}보다 작아야 합니다",
        "less_than_or_equal_to": "%{attribute}은(는) %{count}와(과) 작거나 같아야 합니다",
        "model_invalid": "%{attribute}에 대한 데이터 검증에 실패하였습니다: %{errors}",
        "not_a_number": "%{attribute}에 숫자를 입력해 주세요",
        "not_an_integer": "%{attribute}에 정수를 입력해 주세요",
        "not_email": "이메일이 아닙니다.",
        "not_found": "찾을 수 없습니다.",
        "not_locked": "은(는) 잠기지 않았습니다.",
        "not_saved": {
          "other": "%{count}개의 오류로 인해 %{resource}이(가) 저장되지 못했습니다."
        },
        "odd": "%{attribute}에 홀수를 입력해 주세요",
        "other_than": "%{attribute}은(는) %{count}와(과) 달라야 합니다",
        "present": "%{attribute}은(는) 비어있어야 합니다",
        "required": "%{attribute}은(는) 반드시 있어야 합니다",
        "taken": "%{attribute}은(는) 이미 존재합니다",
        "too_long": "%{attribute}은(는) %{count}자를 넘을 수 없습니다",
        "too_short": "%{attribute}은(는) 적어도 %{count}자를 넘어야 합니다",
        "validate_account_update_params": "요청 값에 알맞은 업데이트 데이터를 입력하세요.",
        "validate_sign_up_params": "요청 값에 알맞은 로그인 데이터를 입력하세요.",
        "wrong_length": "%{attribute}은(는) %{count}자여야 합니다"
      },
      "template": {
        "body": "아래 문제를 확인해 주세요.",
        "header": "%{count}개의 오류로 인해 %{model}을(를) 저장할 수 없습니다"
      }
    },
    "faker": {
      "address": {
        "city": [
          "#{city_name}#{city_suffix}"
        ],
        "city_name": [
          "강릉",
          "양양",
          "인제",
          "광주",
          "구리",
          "부천",
          "밀양",
          "통영",
          "창원",
          "거창",
          "고성",
          "양산",
          "김천",
          "구미",
          "영주",
          "광산",
          "남",
          "북",
          "고창",
          "군산",
          "남원",
          "동작",
          "마포",
          "송파",
          "용산",
          "부평",
          "강화",
          "수성]"
        ],
        "city_suffix": [
          "구",
          "시",
          "군"
        ],
        "default_country": [
          "대한민국"
        ],
        "default_country_code": [
          "KR"
        ],
        "postcode": [
          "#####"
        ],
        "state": [
          "강원",
          "경기",
          "경남",
          "경북",
          "광주",
          "대구",
          "대전",
          "부산",
          "서울",
          "울산",
          "인천",
          "전남",
          "전북",
          "제주",
          "충남",
          "충북",
          "세종"
        ],
        "state_abbr": [
          "강원",
          "경기",
          "경남",
          "경북",
          "광주",
          "대구",
          "대전",
          "부산",
          "서울",
          "울산",
          "인천",
          "전남",
          "전북",
          "제주",
          "충남",
          "충북",
          "세종"
        ],
        "street_name": [
          "#{street_root}#{street_suffix}"
        ],
        "street_root": [
          "상계",
          "화곡",
          "신정",
          "목",
          "잠실",
          "면목",
          "주안",
          "안양",
          "중",
          "정왕",
          "구로",
          "신월",
          "연산",
          "부평",
          "창",
          "만수",
          "중계",
          "검단",
          "시흥",
          "상도",
          "방배",
          "장유",
          "상",
          "광명",
          "신길",
          "행신",
          "대명",
          "동탄"
        ],
        "street_suffix": [
          "읍",
          "면",
          "동"
        ]
      },
      "adjective": {
        "negative": [
          "가난한",
          "가려운",
          "거만한",
          "걱정하는",
          "겁먹은",
          "게으러운",
          "격렬한",
          "고통스러운",
          "공격적인",
          "긴장한",
          "끔찍한",
          "나쁜",
          "더러운",
          "못된",
          "못생긴",
          "무관심한",
          "무력한",
          "무서워하는",
          "무심한",
          "미친",
          "버릇없는",
          "부끄러운",
          "부러워하는",
          "부정적인",
          "부패하는",
          "불안하는",
          "불안한",
          "불쾌한",
          "비싼",
          "비통해하는",
          "사악한",
          "소극적인",
          "소용없는",
          "속상한",
          "슬픈",
          "심각한",
          "심한",
          "썩은",
          "아픈",
          "약한",
          "어려운",
          "어리석은",
          "역겨운",
          "외로운",
          "우스꽝스러운",
          "우울한",
          "위험한",
          "으스스한",
          "이기적인",
          "이상한",
          "잔혹한",
          "전전긍긍하는",
          "조마조마한",
          "조심스러운",
          "조심하는",
          "지루해하는",
          "지친",
          "질투하는",
          "짜증스러운",
          "창피한",
          "충격적인",
          "터무니없는",
          "틀린",
          "피곤한",
          "혼란스러운",
          "힘든"
        ],
        "positive": [
          "감사하는",
          "강력한",
          "강한",
          "거대한",
          "거벼운",
          "공평한",
          "궁금한",
          "귀여운",
          "귀중한",
          "귀한",
          "기쁜",
          "깨끗한",
          "대단한",
          "도움이 되는",
          "똑똑한",
          "뛰어난",
          "마땅한",
          "마음에 드는",
          "매력적인",
          "모험적인",
          "반짝거리는",
          "밝은",
          "배려심 있는",
          "부드러운",
          "부유한",
          "빛나는",
          "사랑스러운",
          "성공한",
          "세련된",
          "순결한",
          "순한",
          "승리한",
          "신이 난",
          "아름다운",
          "어마어마한",
          "엄청난",
          "열광적인",
          "열린",
          "영광스러운",
          "완벽한",
          "용감한",
          "우아한",
          "운이 좋은",
          "웃기는",
          "유명한",
          "인상적인",
          "자랑스러운",
          "잘 생긴",
          "장대한",
          "재능이 있는",
          "저렴한",
          "정력적인",
          "좋은",
          "차분한",
          "착한",
          "친절한",
          "쾌적한",
          "탐구심이 많은",
          "특별한",
          "편안한",
          "편한",
          "평범한",
          "행복한",
          "현대적인",
          "화려한",
          "활발한",
          "흥미러운"
        ]
      },
      "color": {
        "name": [
          "빨간색",
          "다홍색",
          "주황색",
          "귤색",
          "노란색",
          "연두색",
          "녹색",
          "청록색",
          "하늘색",
          "파란색",
          "남색",
          "보라색",
          "자주색",
          "자홍색",
          "분홍색",
          "산호색",
          "라임색",
          "올리브색",
          "카키색",
          "군청색",
          "바다색",
          "버건디색",
          "베이지색",
          "갈색",
          "민트색",
          "황토색",
          "금색",
          "음색",
          "검은색",
          "회색",
          "흰색"
        ]
      },
      "commerce": {
        "department": [
          "의류"
        ],
        "product_name": {
          "adjective": [
            "핏좋은",
            "섹시한",
            "부드러운",
            "깔끔한",
            "트렌디한",
            "편안한",
            "댄디한",
            "포근한",
            "소박한",
            "화려한",
            "멋진",
            "환상적인",
            "실용적인",
            "산뜻한",
            "무난한",
            "평범한",
            "가벼운",
            "튼튼한"
          ],
          "material": [
            "울",
            "기모",
            "강철",
            "목재",
            "면",
            "고무",
            "가죽",
            "린넨",
            "실크",
            "대리석",
            "청동",
            "구리",
            "알루미늄",
            "종이",
            "양털",
            "캐시미어",
            "데님"
          ],
          "product": [
            "치마",
            "셔츠",
            "티셔츠",
            "바지",
            "슬랙스",
            "자켓",
            "니트",
            "가디건",
            "블라우스",
            "원피스",
            "구두",
            "바람막이",
            "맨투맨",
            "패딩"
          ]
        },
        "promotion_code": {
          "adjective": [
            "단독",
            "봄맞이",
            "봄",
            "여름",
            "가을",
            "겨울",
            "새해",
            "설",
            "특별",
            "가을맞이",
            "신년맞이",
            "연말",
            "브랜드",
            "신학기",
            "봄준비"
          ],
          "noun": [
            "기획전",
            "세일",
            "할인",
            "기획",
            "특가",
            "시즌오프",
            "이벤트"
          ]
        }
      },
      "company": {
        "name": [
          "#{prefix} #{Name.first_name}",
          "#{Name.first_name} #{suffix}"
        ],
        "prefix": [
          "주식회사",
          "한국"
        ],
        "suffix": [
          "연구소",
          "게임즈",
          "그룹",
          "전자",
          "물산",
          "코리아"
        ]
      },
      "creature": {
        "animal": {
          "name": [
            "개",
            "개구리",
            "개미",
            "개코원숭이",
            "거미",
            "거북이",
            "거위",
            "게",
            "고래",
            "고릴라",
            "고슴도치",
            "고양이",
            "곰",
            "공룡",
            "굴",
            "기니피그",
            "기린",
            "까마귀",
            "나비",
            "낙타",
            "너구리",
            "늑대",
            "다람쥐",
            "달팽이",
            "당나귀",
            "도마뱀",
            "독수리",
            "돌고래",
            "돼지",
            "두꺼비",
            "딱정벌레",
            "말",
            "말벌",
            "매미",
            "메뚜기",
            "모기",
            "물고기",
            "물소",
            "바다 사자",
            "바다 코끼리",
            "바다소",
            "바퀴벌레",
            "박쥐",
            "백조",
            "뱀",
            "벌",
            "벌레",
            "비버",
            "사냥개",
            "사슴",
            "사자",
            "상어",
            "소",
            "송어",
            "수달",
            "순록",
            "스컹크",
            "아르마딜로",
            "악어",
            "알파카",
            "앤텔로프",
            "앵무새",
            "야마",
            "야크",
            "양",
            "얼룩말",
            "엘크",
            "여우",
            "연어",
            "염소",
            "오리",
            "오리너구리",
            "원숭이",
            "웜뱃",
            "임팔라",
            "정어리",
            "조개",
            "족제비",
            "쥐",
            "청어",
            "치타",
            "친칠라",
            "침팬지",
            "캥거루",
            "코끼리",
            "코뿔소",
            "코알라",
            "코요테",
            "토끼",
            "파리",
            "팬더",
            "표범",
            "하마",
            "하이에나",
            "해파리",
            "햄스터",
            "호넷",
            "호랑이",
            "호저",
            "황소",
            "흰개미"
          ]
        }
      },
      "dessert": {
        "flavor": [
          "녹차",
          "딸기",
          "땅콩 버터",
          "레드벨벳",
          "레몬",
          "말차",
          "민트 초코",
          "바나나",
          "바닐라",
          "버터 피칸",
          "버터스카치",
          "사과",
          "생일 케이크",
          "솔티드 캐러멜",
          "아몬드",
          "에스프레소",
          "오미자",
          "오트밀",
          "유자",
          "체리",
          "초콜릿",
          "치즈 케잌",
          "캐러멜",
          "코코넛",
          "쿠키앤크림",
          "피스타치오",
          "호박",
          "흑임자"
        ],
        "topping": [
          "가루 설탕",
          "글레이즈",
          "땅콩",
          "땅콩 버터",
          "레인보우 스프링클",
          "마시멜로",
          "버터스카치 시럽",
          "베이컨",
          "설탕 프로스팅",
          "시나몬",
          "인절미",
          "잼",
          "젤리곰",
          "초콜릿 스프링클",
          "초콜릿 시럽",
          "초콜릿 칩",
          "치즈케이크 바이트",
          "캐러멜",
          "쿠키 반죽",
          "호두",
          "휘핑 크림"
        ],
        "variety": [
          "과일 케이크",
          "꽈배기",
          "냉동 요구르트",
          "달고나",
          "달콤한 빵",
          "도넛",
          "떡",
          "붕어빵",
          "브라우니",
          "송편",
          "아이스크림",
          "아이스크림 케이크",
          "약과",
          "치즈 케잌",
          "커피 케이크",
          "컵케이크",
          "케이크",
          "쿠키",
          "키 라임 파이",
          "파르페",
          "파이",
          "팥빙수",
          "푸딩",
          "호떡"
        ]
      },
      "emotion": {
        "adjective": [
          "걱정하는",
          "게으른",
          "격렬한",
          "고마워하는",
          "고집스러운",
          "공격적인",
          "관심 있는",
          "낙관적인",
          "놀란",
          "다정한",
          "당황스러운",
          "두려워하는",
          "따뜻한",
          "반항적인",
          "버려진",
          "부러워하는",
          "불안정한",
          "불안해하는",
          "불편한",
          "불행한",
          "비관적인",
          "사려 깊은",
          "상냥한",
          "시무룩한",
          "실망한",
          "안전한",
          "양면적인",
          "역겨운",
          "열렬한",
          "예민한",
          "외로운",
          "용감한",
          "우울한",
          "음울한",
          "자랑스러운",
          "재미있는",
          "젊은",
          "즐기는",
          "짜증이 난",
          "침착한",
          "쾌활한",
          "탐욕스러운",
          "편안한",
          "평온한",
          "평화로운",
          "화난",
          "흡수된",
          "흥분한"
        ],
        "noun": [
          "경멸",
          "고뇌",
          "고통",
          "공포",
          "공황",
          "기쁨",
          "낙담",
          "놀람",
          "다시 없는 기쁨",
          "당황",
          "동정심",
          "두려움",
          "배려",
          "부러움",
          "불안",
          "불쾌",
          "사랑",
          "성가심",
          "실망",
          "싫음",
          "안도",
          "애정",
          "열광",
          "열성",
          "열정",
          "외로움",
          "자부심",
          "즐거움",
          "창피",
          "충격",
          "쾌활함",
          "행복감",
          "향수병",
          "향유",
          "화",
          "후회",
          "희망"
        ]
      },
      "food": {
        "allergens": [
          "게",
          "견과류",
          "고등어",
          "난류",
          "닭고기",
          "대두",
          "돼지고기",
          "땅콩",
          "머스타드",
          "메밀",
          "밀",
          "복숭아",
          "새우",
          "쇠고기",
          "아황산류",
          "오징어",
          "우유",
          "잣",
          "조개류",
          "토마토",
          "호두"
        ],
        "dish": [
          "갈비",
          "갈비찜",
          "곱창",
          "김밥",
          "김치",
          "김치볶음밥",
          "김치찌개",
          "김치찜",
          "깐풍기",
          "닭갈비",
          "동치미",
          "된장찌개",
          "두부",
          "두부김치",
          "떡갈비",
          "떡볶이",
          "뚝배기 불고기",
          "마라탕",
          "막창",
          "만두",
          "물냉면",
          "버거",
          "보쌈",
          "불고기",
          "비빔냉면",
          "비빔밥",
          "삼겹살",
          "샐러드",
          "순두부찌개",
          "스시",
          "양꼬치",
          "잡채",
          "짜장면",
          "짬뽕",
          "청국장",
          "치즈버거",
          "치킨",
          "카레",
          "타코",
          "탕수육",
          "파스타",
          "파전",
          "피자",
          "해물 파전",
          "회"
        ],
        "fruits": [
          "감",
          "귤",
          "딸기",
          "라임",
          "레몬",
          "망고",
          "매실",
          "멜론",
          "무화과",
          "바나나",
          "배",
          "복숭아",
          "블루베리",
          "비파",
          "사과",
          "살구",
          "샤인 무스카트",
          "석류",
          "수박",
          "스타프루트",
          "아보카도",
          "애플망고",
          "유자",
          "자두",
          "참외",
          "천혜향",
          "체리",
          "키위",
          "파인애플",
          "파파야",
          "패션프루트",
          "포도",
          "한라봉"
        ],
        "ingredients": [
          "가리비",
          "가지",
          "간장",
          "감자",
          "건포도",
          "견과류",
          "계란",
          "고구마",
          "고등어",
          "고수",
          "고추가루",
          "고추장",
          "김",
          "깻잎",
          "꿀",
          "녹두",
          "녹차",
          "당근",
          "당면",
          "대파",
          "돼지고기",
          "된장",
          "두유",
          "들기름",
          "딸기",
          "땅콩",
          "라임",
          "랍스터",
          "레몬",
          "리코타",
          "마늘",
          "망고",
          "메밀",
          "멜론",
          "면",
          "멸치",
          "모짜렐라",
          "무",
          "무화과",
          "문어",
          "미림",
          "미역",
          "밀가루",
          "배",
          "배추",
          "버섯",
          "버터",
          "복숭아",
          "부추",
          "브로콜리",
          "비파",
          "사과",
          "사과식초",
          "상추",
          "생강",
          "설탕",
          "셀러리",
          "소금",
          "소시지",
          "송어",
          "수박",
          "시금치",
          "시나몬",
          "식초",
          "쌀",
          "쌀국수",
          "쌈장",
          "알몬드",
          "액젓",
          "양배추",
          "양파",
          "연근",
          "연어",
          "오이",
          "오이고추",
          "오징어",
          "오트밀",
          "올리브",
          "요거트",
          "우유",
          "자두",
          "젤리",
          "참기름",
          "참깨",
          "참치",
          "청경채",
          "청양고추",
          "카놀라유",
          "코코넛 오일",
          "코코아 가루",
          "콜리플라워",
          "콩나물",
          "크림 치즈",
          "토마토",
          "파",
          "파인애플",
          "파파야",
          "파프리카",
          "팥",
          "팽이버섯",
          "포도",
          "표고버섯",
          "해바라기 씨",
          "해초",
          "현미",
          "호박",
          "홍합",
          "후추",
          "훈제 연어"
        ],
        "vegetables": [
          "가지",
          "감자",
          "고구마",
          "당근",
          "대파",
          "루콜라",
          "마늘",
          "부추",
          "브로콜리",
          "상추",
          "셀러리",
          "시금치",
          "아스파라거스",
          "아티초크",
          "애호박",
          "양배추",
          "양파",
          "오이",
          "오이고추",
          "청경채",
          "콜리플라워",
          "콩나물",
          "파",
          "호박"
        ]
      },
      "games": {
        "pokemon": {
          "locations": [
            "갈색시티",
            "검은먹시티",
            "고동마을",
            "금빛시티",
            "노랑시티",
            "달맞이산",
            "무지개시티",
            "보라타운",
            "블루시티",
            "상록숲",
            "상록시티",
            "석영고원",
            "쌍둥이섬",
            "연두마을",
            "연분홍시티",
            "은빛산",
            "인주시티",
            "태초마을",
            "홍련섬",
            "황토마을",
            "회색시티"
          ],
          "moves": [
            "10만볼트",
            "거품광선",
            "고속이동",
            "고양이돈받기",
            "공중날기",
            "구멍파기",
            "김밥말이",
            "날개치기",
            "날려버리기",
            "냉동빔",
            "냉동펀치",
            "누르기",
            "눈보라",
            "독가루",
            "돌떨구기",
            "땅가르기",
            "막치기",
            "메가톤펀치",
            "몸통박치기",
            "물대포",
            "바람일으키기",
            "번개",
            "번개펀치",
            "분노",
            "불꽃세례",
            "불꽃펀치",
            "사이코키네시스",
            "성장",
            "솔라빔",
            "수면가루",
            "순간이동",
            "연속뺨치기",
            "연속펀치",
            "오로라빔",
            "요가포즈",
            "잎날가르기",
            "저리가루",
            "전광석화",
            "전기쇼크",
            "전기자석파",
            "지진",
            "최면술",
            "칼바람",
            "코골기",
            "태권당수",
            "파괴광선",
            "파도타기",
            "풀베기",
            "하이드로펌프",
            "할퀴기",
            "화염방사",
            "화염자동차",
            "환상빔",
            "흰안개"
          ],
          "names": [
            "갸라도스",
            "거북왕",
            "고라파덕",
            "고오스",
            "고우스트",
            "골덕",
            "꼬부기",
            "나옹",
            "나인테일",
            "내루미",
            "또가스",
            "또도가스",
            "라이츄",
            "라프라스",
            "럭키",
            "롱스톤",
            "루주라",
            "리자드",
            "리자몽",
            "마임맨",
            "망나뇽",
            "메타몽",
            "뮤",
            "뮤츠",
            "미뇽",
            "별가사리",
            "부스터",
            "샤미드",
            "스라크",
            "시라소몬",
            "식스테일",
            "신뇽",
            "썬더",
            "아쿠스타",
            "어니부기",
            "이브이",
            "이상해꽃",
            "이상해씨",
            "이상해풀",
            "잉어킹",
            "잠만보",
            "쥬피썬더",
            "파오리",
            "파이리",
            "파이어",
            "팬텀",
            "페르시온",
            "프리져",
            "피카츄",
            "홍수몬"
          ]
        }
      },
      "gender": {
        "binary_types": [
          "여성",
          "남성"
        ]
      },
      "hobby": {
        "activity": [
          "배드민턴",
          "보드 게임",
          "사이클링",
          "사진술",
          "산책하기",
          "서예",
          "서핑",
          "수영",
          "스키 타기",
          "스포츠",
          "아이스 스케이팅",
          "야구",
          "양궁",
          "연기",
          "외국어 학습",
          "요가",
          "요리",
          "운동",
          "운전",
          "자수법",
          "재봉",
          "종이접기",
          "직소 퍼즐",
          "축구",
          "춤",
          "캠핑",
          "커피 로스팅",
          "컴퓨터 프로그래밍",
          "탁구",
          "태권도",
          "태극권",
          "테니스",
          "플라잉 요가"
        ]
      },
      "house": {
        "furniture": [
          "램프",
          "목욕통",
          "발판",
          "서랍",
          "소파",
          "식탁",
          "안락의자",
          "옷장",
          "의자",
          "이불",
          "찬장",
          "침대",
          "테이블"
        ],
        "rooms": [
          "거실",
          "로프트",
          "발코니",
          "베란다",
          "식료품 저장실",
          "안방",
          "애틱",
          "주방",
          "지하실",
          "침실",
          "현관",
          "화장실"
        ]
      },
      "internet": {
        "domain_suffix": [
          "co.kr",
          "com",
          "biz",
          "info",
          "ne.kr",
          "net",
          "or.kr",
          "org"
        ]
      },
      "kpop": {
        "boy_bands": [
          "FT아일랜드",
          "갓세븐",
          "데이식스",
          "동방신기",
          "디제이 디오씨",
          "루시",
          "몬스타엑스",
          "방탄소년단",
          "비스트",
          "빅뱅",
          "빅스",
          "샤이니",
          "세븐틴",
          "슈퍼주니어",
          "스트레이키즈",
          "씨엔블루",
          "에이치오티",
          "에픽하이",
          "엑소",
          "엠블랙",
          "워너원",
          "위너",
          "인피니트",
          "터보",
          "투모로우바이투게더",
          "투에이엠",
          "투피엠"
        ],
        "girl_groups": [
          "(여자)아이들",
          "뉴진스",
          "레드벨벳",
          "르세라핌",
          "마마무",
          "미쓰에이",
          "브라운 아이드 걸스",
          "브레이브걸스",
          "블랙핑크",
          "소녀시대",
          "씨스타",
          "아이브",
          "아이즈원",
          "애프터스쿨",
          "에스파",
          "에이오에이",
          "에이핑크",
          "에프엑스",
          "원더걸스",
          "이엑스아이디",
          "카라",
          "투애니원",
          "트와이스",
          "티아라",
          "포미닛",
          "핑클"
        ],
        "solo": [
          "강다니엘",
          "딘",
          "박재범",
          "보아",
          "비오",
          "빅나티",
          "산이",
          "선미",
          "세븐",
          "싸이",
          "아이유",
          "알엠",
          "애쉬 아일랜드",
          "에릭남",
          "에일리",
          "오존",
          "이하이",
          "이효리",
          "자이언티",
          "전소미",
          "제시",
          "지드래곤",
          "지코",
          "청하",
          "크러쉬",
          "탑",
          "헤이즈",
          "현아"
        ]
      },
      "lorem": {
        "words": [
          "국가는",
          "법률이",
          "정하는",
          "바에",
          "의하여",
          "재외국민을",
          "보호할",
          "의무를",
          "진다.",
          "모든",
          "국민은",
          "신체의",
          "자유를",
          "가진다.",
          "국가는",
          "전통문화의",
          "계승·발전과",
          "민족문화의",
          "창달에",
          "노력하여야",
          "한다.",
          "통신·방송의",
          "시설기준과",
          "신문의",
          "기능을",
          "보장하기",
          "위하여",
          "필요한",
          "사항은",
          "법률로",
          "정한다.",
          "헌법에",
          "의하여",
          "체결·공포된",
          "조약과",
          "일반적으로",
          "승인된",
          "국제법규는",
          "국내법과",
          "같은",
          "효력을",
          "가진다.",
          "다만,",
          "현행범인인",
          "경우와",
          "장기",
          "3년",
          "이상의",
          "형에",
          "해당하는",
          "죄를",
          "범하고",
          "도피",
          "또는",
          "증거인멸의",
          "염려가",
          "있을",
          "때에는",
          "사후에",
          "영장을",
          "청구할",
          "수",
          "있다.",
          "저작자·발명가·과학기술자와",
          "예술가의",
          "권리는",
          "법률로써",
          "보호한다.",
          "형사피고인은",
          "유죄의",
          "판결이",
          "확정될",
          "때까지는",
          "무죄로",
          "추정된다.",
          "모든",
          "국민은",
          "행위시의",
          "법률에",
          "의하여",
          "범죄를",
          "구성하지",
          "아니하는",
          "행위로",
          "소추되지",
          "아니하며,",
          "동일한",
          "범죄에",
          "대하여",
          "거듭",
          "처벌받지",
          "아니한다.",
          "국가는",
          "평생교육을",
          "진흥하여야",
          "한다.",
          "모든",
          "국민은",
          "사생활의",
          "비밀과",
          "자유를",
          "침해받지",
          "아니한다.",
          "의무교육은",
          "무상으로",
          "한다.",
          "저작자·발명가·과학기술자와",
          "예술가의",
          "권리는",
          "법률로써",
          "보호한다.",
          "국가는",
          "모성의",
          "보호를",
          "위하여",
          "노력하여야",
          "한다.",
          "헌법에",
          "의하여",
          "체결·공포된",
          "조약과",
          "일반적으로",
          "승인된",
          "국제법규는",
          "국내법과",
          "같은",
          "효력을",
          "가진다."
        ]
      },
      "movie": {
        "title": [
          "7번방의 선물",
          "겨울왕국",
          "과속스캔들",
          "괴물",
          "국제시장",
          "기생충",
          "도둑들",
          "명량",
          "미녀는 괴로워",
          "범죄도시",
          "베테랑",
          "부산행",
          "센과 치히로의 행방불명",
          "써니",
          "아바타",
          "알라딘",
          "인터스텔라",
          "친구",
          "타이타닉",
          "택시운전사",
          "포레스트 검프",
          "해리 포터와 마법사의 돌"
        ]
      },
      "name": {
        "first_name": [
          "서연",
          "민서",
          "서현",
          "지우",
          "서윤",
          "지민",
          "수빈",
          "하은",
          "예은",
          "윤서",
          "민준",
          "지후",
          "지훈",
          "준서",
          "현우",
          "예준",
          "건우",
          "현준",
          "민재",
          "우진",
          "은주"
        ],
        "last_name": [
          "김",
          "이",
          "박",
          "최",
          "정",
          "강",
          "조",
          "윤",
          "장",
          "임",
          "오",
          "한",
          "신",
          "서",
          "권",
          "황",
          "안",
          "송",
          "류",
          "홍"
        ],
        "name": [
          "#{last_name} #{first_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "0#-#####-####",
          "0##-###-####",
          "0##-####-####"
        ]
      },
      "space": {
        "galaxy": [
          "우리은하",
          "소마젤란 은하",
          "대마젤란 은하",
          "안드로메다 은하",
          "센타우루스자리 오메가",
          "삼각형자리 은하",
          "센타우루스자리 A",
          "조각가자리 은하"
        ],
        "planet": [
          "수성",
          "금성",
          "지구",
          "화성",
          "목성",
          "토성",
          "천왕성",
          "해왕성"
        ]
      },
      "studio_ghibli": {
        "characters": [
          "가오나시",
          "나우시카",
          "도라",
          "린",
          "마니",
          "마르클",
          "모노노케",
          "무스카",
          "소스케",
          "소피",
          "쇼",
          "시타",
          "아리에티",
          "아시타카",
          "안나",
          "오소노",
          "우르슬라",
          "유바바",
          "제니바",
          "지지",
          "치히로",
          "캘시퍼",
          "쿠사카베 메이",
          "쿠사카베 사츠키",
          "키키",
          "토토로",
          "톰보",
          "파즈",
          "포뇨",
          "포르코 로소",
          "하울",
          "하쿠",
          "황야의 마녀"
        ],
        "movies": [
          "귀를 기울이면",
          "마녀 배달부 키키",
          "마루 밑 아리에티",
          "모노노케 히메",
          "바람계곡의 나우시카",
          "반딧불의 묘",
          "벼랑 위의 포뇨",
          "붉은 돼지",
          "센과 치히로의 행방불명",
          "이웃집 토토로",
          "천공의 성 라퓨타",
          "추억의 마니",
          "하울의 움직이는 성"
        ]
      }
    },
    "hello": "안녕하세요",
    "helpers": {
      "select": {
        "prompt": "선택해주세요"
      },
      "submit": {
        "create": "등록",
        "submit": "제출",
        "update": "수정"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n%u",
          "precision": 0,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "원"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n%u",
          "units": {
            "billion": "십억",
            "million": "백만",
            "quadrillion": "천조",
            "thousand": "천",
            "trillion": "조",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n%u",
          "units": {
            "byte": "바이트",
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", ",
        "two_words_connector": ", ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "오전",
      "formats": {
        "default": "%Y년 %m월 %d일 %A %H시 %M분 %S초 %z",
        "long": "%Y년 %m월 %d일 %H시 %M분",
        "short": "%m월 %d일 %H:%M"
      },
      "pm": "오후"
    },
    "welcome": "환영합니다"
  },
  "lb": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validatioun feelgeschlo: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Den Enregistrement kann net geläscht gi wëll et dovun ofhängegt %{record} gëtt",
            "has_one": "Den Enregistrement kann net geläscht gi wëll et en dovun ofhängegt %{record} gëtt"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Son",
        "Méi",
        "Dën",
        "Mët",
        "Don",
        "Fre",
        "Sam"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mäe",
        "Abr",
        "Mee",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "day_names": [
        "Sonndeg",
        "Méindeg",
        "Dënschdeg",
        "Mëttwoch",
        "Donneschdeg",
        "Freideg",
        "Samschdeg"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "Januar",
        "Februar",
        "Mäerz",
        "Abrëll",
        "Mee",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "order": [
        "Joer",
        "Mount",
        "Dag"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ongeféier eng Stonn",
          "other": "ongeféier %{count} Stonnen"
        },
        "about_x_months": {
          "one": "ongeféier ee Mount",
          "other": "ongeféier %{count} Méint"
        },
        "about_x_years": {
          "one": "ongeféier ee Joer",
          "other": "ongeféier %{count} Joer"
        },
        "almost_x_years": {
          "one": "bal ee Joer",
          "other": "bal %{count} Joer"
        },
        "half_a_minute": "eng hallef Minutt",
        "less_than_x_minutes": {
          "one": "manner wéi eng Minutt",
          "other": "manner wéi %{count} Minutten"
        },
        "less_than_x_seconds": {
          "one": "manner wéi eng Sekonn",
          "other": "manner wéi %{count} Sekonnen"
        },
        "over_x_years": {
          "one": "méi wéi ee Joer",
          "other": "méi wéi %{count} Joer"
        },
        "x_days": {
          "one": "%{count} Dag",
          "other": "%{count} Deeg"
        },
        "x_minutes": {
          "one": "%{count} Minutt",
          "other": "%{count} Minutten"
        },
        "x_months": {
          "one": "%{count} Mount",
          "other": "%{count} Méint"
        },
        "x_seconds": {
          "one": "%{count} Sekonn",
          "other": "%{count} Sekonnen"
        }
      },
      "prompts": {
        "day": "Dag",
        "hour": "Stonn",
        "minute": "Minutt",
        "month": "Mount",
        "second": "Sekonnen",
        "year": "Joer"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "muss akzeptéiert ginn",
        "blank": "däerf net eidel sinn",
        "confirmation": "stëmmt net mat %{attribute} iwwerenee",
        "empty": "däerf net eidel sinn",
        "equal_to": "muss d'selwecht si wéi %{count}",
        "even": "muss gerued sinn",
        "exclusion": "ass reservéiert",
        "greater_than": "muss méi grouss wéi %{count} sinn",
        "greater_than_or_equal_to": "muss méi grouss oder gläich si wéi %{count}",
        "inclusion": "ass net an der Lëscht dran",
        "invalid": "ass net valabel",
        "less_than": "muss méi kleng wéi %{count} sinn",
        "less_than_or_equal_to": "muss méi kleng oder gläich si wéi %{count}",
        "not_a_number": "ass keng Zuel",
        "not_an_integer": "muss eng ganz Zuel sinn",
        "odd": "muss ongerued sinn",
        "other_than": "muss anescht si wéi %{count}",
        "present": "muss eidel sinn",
        "taken": "gouf scho geholl",
        "too_long": {
          "one": "ass ze laang (Maximal %{count} Zeechen)",
          "other": "ass ze laang (net méi wéi %{count} Zeechen)"
        },
        "too_short": {
          "one": "ass ze kuerz (Mniimal %{count} Zeechen)",
          "other": "ass ze kuerz (mindestens %{count} Zeechen)"
        },
        "wrong_length": {
          "one": "huet déi falsch Längt (muss genee een Zeeche sinn)",
          "other": "huet déi falsch Längt (musse genee %{count} Zeeche sinn)"
        }
      },
      "template": {
        "body": "Et gouf Problemer mat dëse Felder:",
        "header": {
          "one": "%{count} Feeler verhënnert d'Späichere vu(n) %{model}",
          "other": "%{count} Feeler verhënneren d'Späichere vu(n) %{model}"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Sicht w.e.g. eraus"
      },
      "submit": {
        "create": "uleeën %{model}",
        "submit": "späicheren %{model}",
        "update": "aktualiséieren %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Milliard",
            "million": "Millioun",
            "quadrillion": {
              "one": "Billiard",
              "other": "Billiarden"
            },
            "thousand": "Dausend",
            "trillion": "Billioun",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Byten"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", an ",
        "two_words_connector": " an ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "moies",
      "formats": {
        "default": "%A, %d. %B %Y, %H:%M Auer",
        "long": "%A, %d. %B %Y, %H:%M Auer",
        "short": "%d. %b %H:%M"
      },
      "pm": "mëttes"
    }
  },
  "lo": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "ການຢືນຢັນບໍ່ສຳເລັດ : %{errors}"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ອາທິດ",
        "ຈັນ",
        "ອັງຄານ",
        "ພຸດ",
        "ພະຫັດ",
        "ສຸກ",
        "ເສົາ"
      ],
      "abbr_month_names": [
        null,
        "ມ.ກ",
        "ກ.ພ",
        "ມ.ນ",
        "ມ.ສ",
        "ພ.ພ",
        "ມິ.ຖ",
        "ກ.ລ",
        "ສ.ຫ",
        "ກ.ຍ",
        "ຕ.ລ",
        "ພ.ຈ",
        "ທ.ວ"
      ],
      "day_names": [
        "ອາທິດ",
        "ຈັນ",
        "ອັງຄານ",
        "ພຸດ",
        "ພະຫັດ",
        "ສຸກ",
        "ເສົາ"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "ມັງກອນ",
        "ກຸມພາ",
        "ມີນາ",
        "ເມສາ",
        "ພຶດສະພາ",
        "ມິຖຸນາ",
        "ກໍລະກົດ",
        "ສິງຫາ",
        "ກັນຍາ",
        "ຕຸລາ",
        "ພະຈິກ",
        "ທັນວາ"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "ປະມານ %{count} ຊົ່ວໂມງ",
        "about_x_months": "ປະມານ %{count} ເດືອນ",
        "about_x_years": "ປະມານ %{count} ປີ",
        "almost_x_years": "ເກືອບ %{count} ປີ",
        "half_a_minute": "ເຄິ່ງນາທີ",
        "less_than_x_minutes": "ນ້ອຍກວ່າ %{count} ນາທີ",
        "less_than_x_seconds": "ນ້ອຍກວ່າ %{count} ວິນາທີ",
        "over_x_years": "ຫຼາຍກວ່າ %{count} ປີ",
        "x_days": "%{count} ມື້",
        "x_minutes": "%{count} ນາທີ",
        "x_months": "%{count} ເດືອນ",
        "x_seconds": "%{count} ວິນາທີ"
      },
      "prompts": {
        "day": "ວັນ",
        "hour": "ຊົ່ວໂມງ",
        "minute": "ນາທີ",
        "month": "ເດືອນ",
        "second": "ວິນາທີ",
        "year": "ປີ"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ຕ້ອງຍອມຮັບ",
        "blank": "ເປົ່າບໍ່ໄດ້",
        "confirmation": "ບໍ່ຖືກກັບການຢືນຢັນ",
        "empty": "ວ່າງໄວ້ບໍ່ໄດ້",
        "equal_to": "ຕ້ອງເທົ່າກັບ %{count}",
        "even": "ຕ້ອງເປັນເລກຄູ່",
        "exclusion": "ມີການຈອງໄວ້ແລ້ວ",
        "greater_than": "ຕ້ອງສູງກວ່າ %{count}",
        "greater_than_or_equal_to": "ຕ້ອງສູງກວ່າ ຫຼື ເທົ່າກັບ %{count}",
        "inclusion": "ບໍ່ໄດ້ຮວມຢູ່ໃນບັນຊີລາຍການ",
        "invalid": "ບໍ່ຖືກ",
        "less_than": "ຕ້ອງຕຳ່ກວ່າ %{count}",
        "less_than_or_equal_to": "ຕ້ອງຕຳ່ກວ່າ ຫຼື ເທົ່າກັບ %{count}",
        "not_a_number": "ບໍ່ແມ່ນຕົວເລກ",
        "odd": "ຕ້ອງເປັນເລກຄີກ",
        "taken": "ຮັບເອົາໄປແລ້ວ",
        "too_long": "ຍາວໂພດ (ສູງສຸດຄື %{count} ຕົວອັກສອນ)",
        "too_short": "ສັ້ນໂພດ (ຕຳ່ສຸດຄື %{count} ຕົວອັກສອນ)",
        "wrong_length": "ຄວາມຍາວຜິດ (ຄວນຈະເປັນ %{count} ຕົວອັກສອນ)"
      },
      "template": {
        "body": "ກະລຸນາກວດສອບຂໍ້ມູນໃນຫ້ອງຕໍ່ໄປນີ້ :",
        "header": "ບໍ່ສາມາດບັນທຶກ %{model} ໄດ້ເນື່ອງຈາກ ເກີດ %{count} ຂໍ້ຜິດພາດ"
      }
    },
    "helpers": {
      "select": {
        "prompt": "โปรดเลือก"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "Kip"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "Bytes",
              "many": "Bytes",
              "one": "Byte",
              "other": "Bytes",
              "two": "Bytes",
              "zero": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", ແລະ ",
        "two_words_connector": "ແລະ ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "ເຊົ້າ",
      "formats": {
        "default": "%a %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M น.",
        "short": "%d %b %H:%M น."
      },
      "pm": "ແລງ"
    }
  },
  "lo-LA": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "ລະຫັດຜ່ານປັດຈຸບັນ",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "ອີເມລ",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "ລະຫັດຜ່ານ",
          "password_confirmation": "ການຢືນຢັນລະຫັດຜ່ານ",
          "remember_created_at": null,
          "remember_me": "ຈື່ຂ້ອຍໄວ້",
          "reset_password_sent_at": null,
          "reset_password_token": "ຕັ້ງ token ລະຫັດຜ່ານຄືນໃໝ່",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "ປົດລັອກ token",
          "updated_at": null
        }
      },
      "models": {
        "user": {
          "one": "ຜູ່ໃຊ້",
          "other": "ຜູ່ໃຊ້"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "ລະຫັດຜ່ານຂອງທ່ານໄດ້ຮັບການຢືນຢັນແລ້ວ.",
        "new": {
          "resend_confirmation_instructions": "ສົ່ງຂັ້ນຕອນການຍືນຍັນຕົວຕົນອີກຄັ້ງ"
        },
        "send_instructions": "ທ່ານຈະໄດ້ຮັບອີເມວພ້ອມຂັ້ນຕອນສຳລັບຢືນຢັນທີ່ຢູ່ອີເມວຂອງທ່ານໃນອີກບໍ່ດົນ.",
        "send_paranoid_instructions": "ຖ້າອີເມວຂອງທ່ານມີຢູ່ໃນຖານຂໍ້ມູນຂອງພວກເຮົາ, ທ່ານຈະໄດ້ຮັບອີເມວພ້ອມຂັ້ນຕອນສຳລັບຢືນຢັນທີ່ຢູ່ອີເມວຂອງທ່ານໃນອີກບໍ່ດົນ."
      },
      "failure": {
        "already_authenticated": "ທ່ານໄດ້ເຂົ້າສູ່ລະບົບແລ້ວ.",
        "inactive": "ບັນຊີຂອງທ່ານຖືກເປີດໃຊ້ງານເທື່ອ.",
        "invalid": null,
        "last_attempt": "ທ່ານສາມາດລອງໄດ້ອີກຄັ້ງນຶ່ງ ກ່ອນທີ່ບັນຊີຂອງທ່ານຈະຖືກລັອກ.",
        "locked": "ບັນຊີຂອງທ່ານຖືກລັອກ.",
        "not_found_in_database": null,
        "timeout": "ກຳນົດເວລານຳໃຊ້ຂອງທ່ານໝົດລົງແລ້ວ. ກະລຸນາເຂົ້າສູ່ລະບົບອີກຄັ້ງເພື່ອດຳເນີນການຕໍ່.",
        "unauthenticated": "ທ່ານຕ້ອງເຂົ້າສູ່ລະບົບ ຫຼື ສະໝັກກ່ອນຈະດຳເນີນການຕໍ່ໄດ້.",
        "unconfirmed": "ທ່ານຕ້ອງຢືນຢັນທີ່ຢູ່ອີເມວກ່ອນຈະດຳເນີນການຕໍ່ໄດ້."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "ຢືນຢັນບັນຊີຂອງຂ້ອຍ.",
          "greeting": "ຍິນດີຕ້ອນຮັບ %{recipient}!",
          "instruction": "ທ່ານສາມາດຢືັນຢັນບັນຊີຂອງທ່ານຜ່ານລິ້ງລຸ່ມນີ້:",
          "subject": "ຂັ້ນຕອນການຢືນຢັນ"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "ສະບາຍດີ %{recipient}!",
          "message": "ພວກເຮົາກຳລັງຕິດຕໍ່ຫາທ່ານເພື່ອເຕືອນໃຫ້ຮູ້ວ່າລະຫັດຜ່ານຂອງທ່ານໄດ້ຖືກປ່ຽນແລ້ວ.",
          "subject": "ລະຫັດຜ່ານປ່ຽນແລ້ວ"
        },
        "reset_password_instructions": {
          "action": "ປ່ຽນລະຫັດຜ່ານຂອງຂ້ອຍ",
          "greeting": "ສະບາຍດີ %{recipient}!",
          "instruction": "ມີບາງຄົນໄດ້ຮ້ອງຂໍລິ້ງເພື່ອປ່ຽນລະຫັດຂອງທ່ານ, ແລະ ທ່ານສາມາດດຳເນີນການຜ່ານລິ້ງລຸ່ມນີ້.",
          "instruction_2": "ຖ້າທ່ານບໍ່ໄດ້ຮ້ອງຂໍ, ກະລຸນາເມີນເສີຍຕໍ່ກັບອີເມວນີ້.",
          "instruction_3": "ລະຫັດຜ່ານຂອງທ່ານຈະບໍ່ຖືກປ່ຽນ ຈົນກວ່າທ່ານເຂົ້າລິ້ງດ້ານເທິງ ແລະ ສ້າງລະຫັດຜ່ານໃໝ່.",
          "subject": "ຂັ້ນຕອນການປ່ຽນລະຫັດຜ່ານ"
        },
        "unlock_instructions": {
          "action": "ປົດລັອກບັນຊີຂອງຂ້ອຍ",
          "greeting": "ສະບາຍດີ %{recipient}!",
          "instruction": "ຄລິກດ້ານລຸ່ມເພື່ອປົດລັອກບັນຊີຂອງທ່ານ:",
          "message": "ບັນຊີຂອງທ່ານໄດ້ຖືກລັອກເນື່ອງຈາກການພະຍາຍາມເຂົ້າສູ່ລະບົບທີ່ບໍ່ສຳເລັດຫຼາຍຄັ້ງເກີນໄປ.",
          "subject": "ຂັ້ນຕອນການປົດລັອກ"
        }
      },
      "omniauth_callbacks": {
        "failure": "ບໍ່ສາມາດຢືນຢັນຕົວຕົນທ່ານຈາກ %{kind} ເພາະວ່າ \"%{reason}\".",
        "success": "ຢືນຢັນຕົວຕົນທ່ານສຳເລັດແລ້ວຈາກບັນຊີ %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "ປ່ຽນລະຫັດຜ່ານຂອງຂ້ອຍ",
          "change_your_password": "ປ່ຽນລະຫັດຜ່ານຂອງທ່ານ",
          "confirm_new_password": "ຢືນຢັນລະຫັດຜ່ານໃໝ່",
          "new_password": "ລະຫັດຜ່ານໃໝ່"
        },
        "new": {
          "forgot_your_password": "ລືມລະຫັດຜ່ານຂອງທ່ານລບໍ?",
          "send_me_reset_password_instructions": "ສົ່ງຂັ້ນຕອນຕັ້ງລະຫັດຜ່ານໃໝ່ມາໃຫ້ຂ້ອຍ"
        },
        "no_token": "ທ່ານບໍ່ສາມາດເຂົ້າເຖິງໜ້ານີ້ໄດ້ໂດຍບໍ່ໄດ້ເຂົ້າມາຈາກອີເມວຕັ້ງລະຫັດຜ່ານໃໝ່. ຖ້າທ່ານມາຈາກອີເມວຕັ້ງລະຫັດຜ່ານໃໝ່, ກະລຸນາກວດຄືນວ່າທ່ານໃຊ້ URL ເຕັມຕາມທີ່ໃຫ້ມາ.",
        "send_instructions": "ທ່ານຈະໄດ້ຮັບອີເມວພ້ອມກັບຂັ້ນຕອນວິທີຕັ້ງລະຫັດຜ່ານໃໝ່ໃນອີກບໍ່ດົນ.",
        "send_paranoid_instructions": "ຖ້າອີເມວຂອງທ່ານມີຢູ່ໃນຖານຂໍ້ມູນຂອງພວກເຮົາ, ທ່ານຈະໄດ້ຮັບອີເມວພ້ອມກັບຂັ້ນຕອນວິທີຕັ້ງລະຫັດຜ່ານໃໝ່ໃນອີກບໍ່ດົນ.",
        "updated": "ລະຫັດຜ່ານຂອງທ່ານໄດ້ຖືກປ່ຽນສຳເລັດແລ້ວ. ທ່ານເຂົ້າສູ່ລະບົບແລ້ວຕອນນີ້.",
        "updated_not_active": "ລະຫັດຜ່ານຂອງທ່ານໄດ້ຖືກປ່ຽນສຳເລັດແລ້ວ."
      },
      "registrations": {
        "destroyed": "ລາກ່ອນ! ບັນຊີຂອງທ່ານໄດ້ຖືກຍົກເລີກສຳເລັດແລ້ວ. ພວກເຮົາຫວັງວ່າຈະໄດ້ພົບທ່ານອີກ ໃນໄວໆນີ້.",
        "edit": {
          "are_you_sure": "ທ່ານໝັ້ນໃຈບໍ່?",
          "cancel_my_account": "ຍົກເລີກບັນຊີຂອງຂ້ອຍ",
          "currently_waiting_confirmation_for_email": "ກຳລັງລໍຖ້າການຢືນຢັນສຳລັບ: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "ປະຫວ່າງຖ້າທ່ານບໍ່ຢາກປ່ຽນມັນ",
          "title": "ແກ້ໄຂ %{resource}",
          "unhappy": "ບໍ່ພໍໃຈ?",
          "update": "ອັບເດດ",
          "we_need_your_current_password_to_confirm_your_changes": "ພວກເຮົາຕ້ອງການລະຫັດຜ່ານປັດຈຸບັນຂອງທ່ານເພື່ອຢືນຢັນການປ່ຽນແປງຂອງທ່ານ"
        },
        "new": {
          "sign_up": "ສະໝັກ"
        },
        "signed_up": "ຍິນດີຕ້ອນຮັບ! ທ່ານໄດ້ສະໝັກສຳເລັດແລ້ວ.",
        "signed_up_but_inactive": "ທ່ານໄດ້ສະໝັກສຳເລັດແລ້ວ. ແຕ່ວ່າ, ພວກເຮົາບໍ່ສາມາດພາທ່ານເຂົ້າສູ່ລະບົບໄດ້ ຍ້ອນວ່າບັນຊີຂອງທ່ານຍັງບໍ່ຖືກເປີດນຳໃຊ້ເທື່ອ.",
        "signed_up_but_locked": "ທ່ານໄດ້ສະໝັກສຳເລັດແລ້ວ. ແຕ່ວ່າ, ພວກເຮົາບໍ່ສາມາດພາທ່ານເຂົ້າສູ່ລະບົບໄດ້ ຍ້ອນວ່າບັນຊີຂອງທ່ານຖືກລັອກ.",
        "signed_up_but_unconfirmed": "ຂໍ້ຄວາມພ້ອມລິ້ງຢືນຢັນໄດ້ຖືກສົ່ງໄປທີ່ທີ່ຢູ່ອີເມວຂອງທ່ານ. ກະລຸນານຳລິ້ງໄປເພື່ອເປີດນຳໃຊ້ບັນຊີຂອງທ່ານ.",
        "update_needs_confirmation": "ທ່ານໄດ້ອັບເດດບັນຊີຂອງທ່ານສຳເລັດແລ້ວ, ແຕ່ພວກເຮົາຕ້ອງໄດ້ຢັ້ງຢືນທີ່ຢູ່ອີເມວໃໝ່ຂອງທ່ານໄດ້. ກະລຸນາກວດອີເມວຂອງທ່ານຄືນ ແລະ ຕາມລິ້ງໄປເພື່ອຢືນຢັນທີ່ຢູ່ອີເມວໃໝ່ຂອງທ່ານ.",
        "updated": "ບັນຊີຂອງທ່ານໄດ້ຖືກອັບເດດສຳເລັດແລ້ວ.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "ອອກຈາກລະບົບສຳເລັດແລ້ວ.",
        "new": {
          "sign_in": "ເຂົ້າສູ່ລະບົບ"
        },
        "signed_in": "ເຂົ້າສູ່ລະບົບສຳເລັດແລ້ວ.",
        "signed_out": "ອອກຈາກລະບົບສຳເລັດແລ້ວ."
      },
      "shared": {
        "links": {
          "back": "ກັບຄືນ",
          "didn_t_receive_confirmation_instructions": "ບໍ່ໄດ້ຮັບຂັ້ນຕອນການຢືນຢັນ?",
          "didn_t_receive_unlock_instructions": "ບໍ່ໄດ້ຮັບຂັ້ນຕອນການປົດລັອກ?",
          "forgot_your_password": "ລົມລະຫັດຜ່ານຂອງທ່ານ?",
          "sign_in": "ເຂົ້າສູ່ລະບົບ",
          "sign_in_with_provider": "ເຂົ້າສູ່ລະບົບດ້ວຍ %{provider}",
          "sign_up": "ສະໝັກ"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "ສົ່ງຂັ້ນຕອນການປົດລັອກໃໝ່"
        },
        "send_instructions": "ທ່ານຈະໄດ້ຮັບອີເມວພ້ອມກັບຂັ້ນຕອນວິທີປົດລັອກບັນຊີຂອງທ່ານໃນອີກບໍ່ດົນ.",
        "send_paranoid_instructions": "ຖ້າບັນຊີຂອງທ່ານມີຢູ່ແລ້ວ, ທ່ານຈະໄດ້ຮັບອີເມວພ້ອມກັບຂັ້ນຕອນວິທີປົດລັອກບັນຊີຂອງທ່ານໃນອີກບໍ່ດົນ.",
        "unlocked": "ບັນຊີຂອງທ່ານໄດ້ຖືກປົດລັອກສຳເລັດແລ້ວ. ກະລຸນາເຂົ້າສູ່ລະບົບເພື່ອດຳເນີນຕໍ່."
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "ຢືນຢັນແລ້ວ, ກະລຸນາລອງເຂົ້າສູ່ລະບົບໃໝ່",
        "confirmation_period_expired": "ຕ້ອງໄດ້ຮັບການຢືນຢັນພາຍໃນ  %{period}, ກະລຸນາຮ້ອງຈໍໃໝ່ອີກຄັ້ງ",
        "expired": "ໝົດກຳນັດແລ້ວ, ກະລຸນາຮ້ອງຂໍໃໝ່ອີກຄັ້ງ",
        "not_found": "ບໍ່ພັບເຫັນ",
        "not_locked": "ບໍ່ໄດ້ຖືກລັອກ",
        "not_saved": {
          "one": "ຂໍ້ຜິດພາດ %{count}ຢ່າງໄດ້ຢຸດ %{resource} ບໍ່ໃຫ້ຖືກບັນທຶກໄດ້.",
          "other": "ຂໍ້ຜິດພາດ %{count}ຢ່າງໄດ້ຢຸດ %{resource} ບໍ່ໃຫ້ຖືກບັນທຶກໄດ້."
        }
      }
    }
  },
  "lt": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Patvirtinimas išsiųstas",
          "confirmation_token": "Patvirtinimo žymė",
          "confirmed_at": "Patvirtinta",
          "created_at": "Sukurta",
          "current_password": "Dabartinis slaptažodis",
          "current_sign_in_at": "Dabartinis prisijungimas",
          "current_sign_in_ip": "Dabartinio prisijungimo IP",
          "email": "El. paštas",
          "encrypted_password": "Užšifruotas slaptažodis",
          "failed_attempts": "Nepavykę bandymai",
          "last_sign_in_at": "Paskutinį kartą prisijungta",
          "last_sign_in_ip": "Paskutinio prisijungimo IP",
          "locked_at": "Užblokuota",
          "password": "Slaptažodis",
          "password_confirmation": "Slaptažodžio patvirtinimas",
          "remember_created_at": "Priminti mane sukurta",
          "remember_me": "Prisiminti mane",
          "reset_password_sent_at": "Slaptažodžio nustatymas iš naujo išsiųstas",
          "reset_password_token": "Slaptažodžio nustatymo iš naujo žymė",
          "sign_in_count": "Prisijungta kartų",
          "unconfirmed_email": "Nepatvirtintas slaptažodis",
          "unlock_token": "Atblokuoti žymę",
          "updated_at": "Atnaujinta"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Nepraeitos patikros: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Negalima ištrinti įrašų nes priklausomi %{record} egzistuoja",
            "has_one": "Negalima ištrinti įrašo nes priklausomas %{record} egzistuoja"
          }
        }
      },
      "models": {
        "user": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sek",
        "Pir",
        "Ant",
        "Tre",
        "Ket",
        "Pen",
        "Šeš"
      ],
      "abbr_month_names": [
        null,
        "Sau",
        "Vas",
        "Kov",
        "Bal",
        "Geg",
        "Bir",
        "Lie",
        "Rgp",
        "Rgs",
        "Spa",
        "Lap",
        "Grd"
      ],
      "day_names": [
        "sekmadienis",
        "pirmadienis",
        "antradienis",
        "trečiadienis",
        "ketvirtadienis",
        "penktadienis",
        "šeštadienis"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y m. %B %d d.",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "sausio",
        "vasario",
        "kovo",
        "balandžio",
        "gegužės",
        "birželio",
        "liepos",
        "rugpjūčio",
        "rugsėjo",
        "spalio",
        "lapkričio",
        "gruodžio"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "apie %{count} valandas",
          "one": "apie %{count} valandą",
          "other": "apie %{count} valandų"
        },
        "about_x_months": {
          "few": "apie %{count} mėnesius",
          "one": "apie %{count} mėnesį",
          "other": "apie %{count} mėnesių"
        },
        "about_x_years": {
          "few": "apie %{count} metus",
          "one": "apie %{count} metus",
          "other": "apie %{count} metų"
        },
        "almost_x_years": {
          "few": "beveik %{count} metai",
          "one": "beveik %{count} metai",
          "other": "beveik %{count} metų"
        },
        "half_a_minute": "pusė minutės",
        "less_than_x_minutes": {
          "few": "mažiau nei %{count} minutės",
          "one": "mažiau nei %{count} minutė",
          "other": "mažiau nei %{count} minučių"
        },
        "less_than_x_seconds": {
          "few": "mažiau nei %{count} sekundės",
          "one": "mažiau nei %{count} sekundė",
          "other": "mažiau nei %{count} sekundžių"
        },
        "over_x_years": {
          "few": "virš %{count} metų",
          "one": "virš %{count} metų",
          "other": "virš %{count} metų"
        },
        "x_days": {
          "few": "%{count} dienos",
          "one": "%{count} diena",
          "other": "%{count} dienų"
        },
        "x_minutes": {
          "few": "%{count} minutės",
          "one": "%{count} minutė",
          "other": "%{count} minučių"
        },
        "x_months": {
          "few": "%{count} mėnesiai",
          "one": "%{count} mėnesis",
          "other": "%{count} mėnesių"
        },
        "x_seconds": {
          "few": "%{count} sekundės",
          "one": "%{count} sekundė",
          "other": "%{count} sekundžių"
        },
        "x_years": {
          "few": "%{count} metai",
          "one": "%{count} metai",
          "other": "%{count} metai"
        }
      },
      "prompts": {
        "day": "Diena",
        "hour": "Valanda",
        "minute": "Minutė",
        "month": "Mėnuo",
        "second": "Sekundės",
        "year": "Metai"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Jūsų el. pašto adresas sėkmingai patvirtintas.",
        "new": {
          "resend_confirmation_instructions": null
        },
        "send_instructions": "Už keleto minučių sulauksite elektroninio laiško su instrukcijomis kaip patvirtinti jūsų vartotojo paskyrą.",
        "send_paranoid_instructions": "Jei esatę prisiregistravę šiuo e-pašto adresu, už keleto minučių sulauksite elektroninio laiško su instrukcijomis kaip patvirtinti jūsų vartotojo paskyrą"
      },
      "failure": {
        "already_authenticated": "Jūs jau prisijungęs.",
        "inactive": "Jūsų paskyra dar neaktyvuota.",
        "invalid": "Nevalidus slaptažodis arba %{authentication_keys}.",
        "last_attempt": "Jums liko paskutinis bandymas prieš užblokuojant paskyrą.",
        "locked": "Jūsų paskyra laikinai užblokuota.",
        "not_found_in_database": "Nevalidus slaptažodis arba  %{authentication_keys}.",
        "timeout": "Jūsų sesija baigta. Prisijunkite iš naujo norėdami tęsti.",
        "unauthenticated": "Būtina prisijungti arba prisiregistruoti prieš tęsiant.",
        "unconfirmed": "Būtina patvirtinti e-pašto adresą prieš tęsiant."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Patvirtinti mano paskyrą",
          "greeting": "Sveiki %{recipient}!",
          "instruction": null,
          "subject": "Paskyros patvirtinimo instrukcijos"
        },
        "email_changed": {
          "greeting": "Sveiki %{recipient}!",
          "message": null,
          "message_unconfirmed": null,
          "subject": "El. paštas pakeistas"
        },
        "password_change": {
          "greeting": "Sveiki %{recipient}!",
          "message": null,
          "subject": "Slaptažodis pakeistas"
        },
        "reset_password_instructions": {
          "action": "Pakeisti mano slaptažodį",
          "greeting": null,
          "instruction": null,
          "instruction_2": null,
          "instruction_3": null,
          "subject": "Slaptažodžio keitimo instrukcijos"
        },
        "unlock_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "message": null,
          "subject": "Paskyros atblokavimo instrukcijos"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nepavyko autentikaciją per %{kind}, klaida: \"%{reason}\".",
        "success": "Sėkmingai prisijungėte su savo %{kind} paskyra."
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": null,
          "send_me_reset_password_instructions": null
        },
        "no_token": "Jūs negalite pasiekti šio puslapio tiesiogiai, tą turite padaryti iš slaptažodžio keitimo laiško. Jei jūs atėjote naudodami nuorodą, pateiktą slaptažodžio keitimo laiške, įsitikinkite, kad nukopijavote ją visą.",
        "send_instructions": "Jūs gausite el. laišką su slaptažodžio pakeitimo instrukcijomis netrukus.",
        "send_paranoid_instructions": "Jei prisiregistravote šiuo e-pašto adresu, netrukus gausite el. laišką su slaptažodžio pakeitimo instrukcijomis.",
        "updated": "Jūsų slaptažodis pakeistas sėkmingai. Jūs esate prisijungę.",
        "updated_not_active": "Jūsų slaptažodis pakeistas sėkmingai."
      },
      "registrations": {
        "destroyed": "Iki! Jūsų paskyra dabar yra panaikinta. Tikimės, kad ateityje sugrįšite.",
        "edit": {
          "are_you_sure": null,
          "cancel_my_account": null,
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": null,
          "title": null,
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": null
        },
        "new": {
          "sign_up": null
        },
        "signed_up": "Sveiki, jūs sėkmingai prisiregistravote.",
        "signed_up_but_inactive": "Jūs sėkmingai prisiregistravote. Deja dar negalime jūsų prijungti, nes jūsų paskyra nėra aktyvuota.",
        "signed_up_but_locked": "Jūs sėkmingai prisiregistravote. Deja dar negalime jūsų prijungti, nes jūsų paskyra laikinai užblokuota.",
        "signed_up_but_unconfirmed": "El. laiškas buvo išsiųstas jūsų pateiktu adresu. Sekite nuorodą laiške paskyrai aktyvuoti.",
        "update_needs_confirmation": "Jūsų paskyra sėkmingai atnaujinta, tačiau mums reikia patvirtinti jūsų naują el. pašto adresą. Prašome pasitikrinkite savo e-paštą ir sekite instrukcijas laiške.",
        "updated": "Jūsų duomenys sėkmingai atnaujinti.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Jau esate atsijungę.",
        "new": {
          "sign_in": null
        },
        "signed_in": "Jūs prisijungėte.",
        "signed_out": "Sėkmingai atsijungėte iš savo paskyros."
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": null,
          "didn_t_receive_unlock_instructions": null,
          "forgot_your_password": null,
          "sign_in": null,
          "sign_in_with_provider": null,
          "sign_up": null
        },
        "minimum_password_length": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": null
        },
        "send_instructions": "Netrukus sulauksite el. laiško su instrukcijomis, kaip atblokuoti paskyrą.",
        "send_paranoid_instructions": "Jei registracijai naudojote šį e-pašto adresą, netrukus sulauksite el. laiško su instrukcijomis, kaip atblokuoti paskyrą.",
        "unlocked": "Jūsų paskyra atblokuota. Prisijunkite prie paskyros darbui tęsti."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "turi būti patvirtintas",
        "already_confirmed": "jau buvo patvirtintas, pamėginkite prisijungti",
        "blank": "negali būti tuščias",
        "confirmation": "neteisingai pakartotas",
        "confirmation_period_expired": "privalo būti patvirtintas per %{period}.",
        "empty": "negali būti tuščias",
        "equal_to": "turi būti lygus %{count}",
        "even": "turi būti lyginis skaičius",
        "exclusion": "yra rezervuotas",
        "expired": "nebegalioja, aktyvuokite naują",
        "greater_than": "turi būti didesnis už %{count}",
        "greater_than_or_equal_to": "turi būti didesnis arba lygus %{count}",
        "in": "turi būti skaičiuje %{count}",
        "inclusion": "nenumatyta reikšmė",
        "invalid": "neteisingas",
        "less_than": "turi būti mažesnis už %{count}",
        "less_than_or_equal_to": "turi būti mažesnis arba lygus %{count}",
        "model_invalid": "Tikrinimo klaida: %{errors}",
        "not_a_number": "ne skaičius",
        "not_an_integer": "privalo būti sveikas skaičius",
        "not_found": "nerastas",
        "not_locked": "nebuvo užblokuota",
        "not_saved": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "turi būti nelyginis skaičius",
        "other_than": "privalo būti kitoks nei %{count}",
        "present": "turi būti tuščias",
        "required": "turi egzistuoti",
        "taken": "jau užimtas",
        "too_long": {
          "few": "per ilgas (daugiausiai %{count} simboliai)",
          "one": "per ilgas (daugiausiai %{count} simbolis)",
          "other": "per ilgas (daugiausiai %{count} simbolių)"
        },
        "too_short": {
          "few": "per trumpas (mažiausiai %{count} simboliai)",
          "one": "per trumpas (mažiausiai %{count} simbolis)",
          "other": "per trumpas (mažiausiai %{count} simbolių)"
        },
        "wrong_length": "neteisingo ilgio (turi būti %{count} simboliai)"
      },
      "template": {
        "body": "Šiuose laukuose yra klaidų:",
        "header": {
          "few": "Išsaugant objektą %{model} rastos %{count} klaidos",
          "one": "Išsaugant objektą %{model} rasta %{count} klaida",
          "other": "Išsaugant objektą %{model} rasta %{count} klaidų"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Akmenė",
          "Alytus",
          "Anykščiai",
          "Ariogala",
          "Baltoji Vokė",
          "Birštonas",
          "Biržai",
          "Daugai",
          "Druskininkai",
          "Dūkštas",
          "Dusetos",
          "Eišiškės",
          "Elektrėnai",
          "Ežerėlis",
          "Gargždai",
          "Garliava",
          "Gelgaudiškis",
          "Grigiškės",
          "Ignalina",
          "Jieznas",
          "Jonava",
          "Joniškėlis",
          "Joniškis",
          "Jurbarkas",
          "Kaišiadorys",
          "Kalvarija",
          "Kaunas",
          "Kavarskas",
          "Kazlų Rūda",
          "Kėdainiai",
          "Kelmė",
          "Kybartai",
          "Klaipėda",
          "Kretinga",
          "Kudirkos Naumiestis",
          "Kupiškis",
          "Kuršėnai",
          "Lazdijai",
          "Lentvaris",
          "Linkuva",
          "Marijampolė",
          "Mažeikiai",
          "Molėtai",
          "Naujoji Akmenė",
          "Nemenčinė",
          "Neringa",
          "Obeliai",
          "Pabradė",
          "Pagėgiai",
          "Pakruojis",
          "Palanga",
          "Pandėlys",
          "Panemunė",
          "Panevėžys",
          "Pasvalys",
          "Plungė",
          "Priekulė",
          "Prienai",
          "Radviliškis",
          "Ramygala",
          "Raseiniai",
          "Rietavas",
          "Rokiškis",
          "Rūdiškės",
          "Salantai",
          "Seda",
          "Simnas",
          "Skaudvilė",
          "Skuodas",
          "Smalininkai",
          "Subačius",
          "Šakiai",
          "Šalčininkai",
          "Šeduva",
          "Šiauliai",
          "Šilalė",
          "Šilutė",
          "Širvintos",
          "Švenčionėliai",
          "Švenčionys",
          "Tauragė",
          "Telšiai",
          "Tytuvėnai",
          "Trakai",
          "Troškūnai",
          "Ukmergė",
          "Utena",
          "Užventis",
          "Vabalninkas",
          "Varėna",
          "Varniai",
          "Veisiejai",
          "Venta",
          "Viekšniai",
          "Vievis",
          "Vilkaviškis",
          "Vilkija",
          "Vilnius",
          "Virbalis",
          "Visaginas",
          "Zarasai",
          "Žagarė",
          "Žiežmariai"
        ],
        "postcode": [
          "LT-#####"
        ],
        "street": [
          "#{street} #{street_suffix}"
        ],
        "street_address": [
          "#{street_name} #{street_suffix} #{building_number}"
        ],
        "street_name": [
          "Algirdo",
          "Gedimino",
          "Goštauto",
          "Kaštonų",
          "Laisvės",
          "Liepų",
          "Mindaugo",
          "Olandų",
          "Ozo",
          "Sanatorijos",
          "Šermukšnių",
          "Šešuolių",
          "Šešupės",
          "Teatro",
          "Upės",
          "Žalioji",
          "Žukausko"
        ],
        "street_suffix": [
          "gatvė",
          "prospektas",
          "alėja",
          "aikštė",
          "plentas",
          "skersgatvis",
          "skveras",
          "takas",
          "kelias",
          "aplinkkelis",
          "vieškelis",
          "krantinė"
        ]
      },
      "company": {
        "suffix": [
          "AB",
          "UAB",
          "IĮ",
          "KB",
          "VŠĮ",
          "MB"
        ]
      },
      "internet": {
        "domain_suffix": [
          "lt",
          "com",
          "net"
        ]
      },
      "name": {
        "female_first_name": [
          "Agnė",
          "Austėja",
          "Barbora",
          "Beatričė",
          "Benedikta",
          "Brigita",
          "Cecilija",
          "Dalia",
          "Elžbieta",
          "Enrika",
          "Eugenija",
          "Genovaitė",
          "Gintarė",
          "Gintė",
          "Jomantė",
          "Jonė",
          "Jūratė",
          "Karolina",
          "Kristina",
          "Laura",
          "Liepa",
          "Loreta",
          "Milda",
          "Modesta",
          "Nomeda",
          "Olga",
          "Renata",
          "Rimantė",
          "Roberta",
          "Rožė",
          "Saulė",
          "Silvija",
          "Simona",
          "Stasė",
          "Stefanija",
          "Teresė",
          "Tatjana",
          "Toma",
          "Vida",
          "Viktorija",
          "Vitalija",
          "Živilė"
        ],
        "female_last_name": [
          "Kazlauskienė",
          "Kazlauskaitė",
          "Stankevičienė",
          "Stankevičiūtė",
          "Petrauskienė",
          "Petrauksaitė",
          "Jankauskienė",
          "Jankauskaitė",
          "Žukauskas",
          "Žukauskienė",
          "Butkuvienė Baličūnienė",
          "Balčiūnaitė",
          "Paulauskienė",
          "Paulauskaitė",
          "Vasiliauskienė",
          "Vasiliauskaitė",
          "Baranauskienė",
          "Baranauskaitė"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "male_first_name": [
          "Adolfas",
          "Aleksandras",
          "Alfonsas",
          "Alius",
          "Algirdas",
          "Algimantas",
          "Algis",
          "Andrius",
          "Antanas",
          "Arminas",
          "Arnas",
          "Audrius",
          "Aurelijus",
          "Aurimas",
          "Benas",
          "Benediktas",
          "Boleslovas",
          "Dainius",
          "Danielius",
          "Egidijus",
          "Enrikas",
          "Ernestas",
          "Florijonas",
          "Gintaras",
          "Henrikas",
          "Jogaila",
          "Jokūbas",
          "Jomantas",
          "Jonas",
          "Juozapas",
          "Juozas",
          "Justas",
          "Justinas",
          "Karolis",
          "Kazimieras",
          "Kazys",
          "Laurynas",
          "Liutauras",
          "Mantas",
          "Mečislovas",
          "Mykolas",
          "Modestas",
          "Nojus",
          "Paulius",
          "Prančiškus",
          "Renatas",
          "Rimantas",
          "Rimas",
          "Robertas",
          "Rokas",
          "Romas",
          "Simas",
          "Simonas",
          "Titas",
          "Tomas",
          "Vaidas",
          "Vaidotas",
          "Valdemaras",
          "Valys",
          "Vidas",
          "Viktoras",
          "Vygantas",
          "Vigilijus",
          "Vitalijus",
          "Zenonas",
          "Žilvinas",
          "Žygimantas"
        ],
        "male_last_name": [
          "Kazlauskas",
          "Stankevičius",
          "Petrauskas",
          "Jankauskas",
          "Žukauskas",
          "Butkus",
          "Balčiūnas",
          "Paulauskas",
          "Vasiliauskas",
          "Baranauskas"
        ],
        "name": [
          "#{male_first_name} #{male_last_name}",
          "#{female_first_name} #{female_last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "370"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Prašom pasirinkti"
      },
      "submit": {
        "create": "Sukurti %{model}",
        "submit": "Išsaugoti %{model}",
        "update": "Atnaujinti %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Milijardas",
            "million": "Milijonas",
            "quadrillion": "Kvadrilijonas",
            "thousand": "Tūkstantis",
            "trillion": "Trilijonas",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "Baitai",
              "one": "Baitas",
              "other": "Baitų"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " ir ",
        "two_words_connector": " ir ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%Y %B %d %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "lv": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Apstiprinājums nosūtīts",
          "confirmation_token": "Apstiprinājuma marķieris",
          "confirmed_at": "Apstiprināts",
          "created_at": "Izveidots",
          "current_password": "Tagadējā parole",
          "current_sign_in_at": "Sesija sākta",
          "current_sign_in_ip": "Tagadējā IP adrese",
          "email": "Epasts",
          "encrypted_password": "Nošifrētā parole",
          "failed_attempts": "Kļudaini mēģinājumi",
          "last_sign_in_at": "Pēdējā sesija",
          "last_sign_in_ip": "Pēdējā IP adrese",
          "locked_at": "Nobloķēts",
          "password": "Parole",
          "password_confirmation": "Apstiprināt paroli",
          "remember_created_at": "Atcerēties mani atjaunots",
          "remember_me": "Atcerēties mani",
          "reset_password_sent_at": "Paroles maiņas ziņojums nosūtīts",
          "reset_password_token": "Paroles maiņas marķieris",
          "sign_in_count": "Pierakstīšanās reizes",
          "unconfirmed_email": "Neapstiprināts epasts",
          "unlock_token": "Atbloķēšanas marķieris",
          "updated_at": "Atjaunināts"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Pārbaude neizdevās: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Nevar dzēst ierakstu, jo ir atkarīgi %{record}",
            "has_one": "Nevar dzēst ierakstu, jo ir atkarīgs %{record}"
          }
        }
      },
      "models": {
        "user": {
          "one": "Lietotājs",
          "other": "Lietotājs",
          "zero": "Lietotājs"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Sv.",
        "P.",
        "O.",
        "T.",
        "C.",
        "Pk.",
        "S."
      ],
      "abbr_month_names": [
        null,
        "Janv",
        "Febr",
        "Marts",
        "Apr",
        "Maijs",
        "Jūn",
        "Jūl",
        "Aug",
        "Sept",
        "Okt",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "svētdiena",
        "pirmdiena",
        "otrdiena",
        "trešdiena",
        "ceturtdiena",
        "piektdiena",
        "sestdiena"
      ],
      "formats": {
        "default": "%d.%m.%Y.",
        "long": "%Y. gada %e. %B",
        "short": "%e. %B"
      },
      "month_names": [
        null,
        "janvārī",
        "februārī",
        "martā",
        "aprīlī",
        "maijā",
        "jūnijā",
        "jūlijā",
        "augustā",
        "septembrī",
        "oktobrī",
        "novembrī",
        "decembrī"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "apmēram %{count} stunda",
          "other": "apmēram %{count} stundas",
          "zero": "apmēram %{count} stundas"
        },
        "about_x_months": {
          "one": "apmēram %{count} mēnesis",
          "other": "apmēram %{count} mēneši",
          "zero": "apmēram %{count} mēneši"
        },
        "about_x_years": {
          "one": "apmēram %{count} gads",
          "other": "apmēram %{count} gadi",
          "zero": "apmēram %{count} gadi"
        },
        "almost_x_years": {
          "one": "gandrīz %{count} gads",
          "other": "gandrīz %{count} gadi",
          "zero": "gandrīz %{count} gadi"
        },
        "half_a_minute": "pusminūte",
        "less_than_x_minutes": {
          "one": "mazāk par %{count} minūti",
          "other": "mazāk par %{count} minūtēm",
          "zero": "mazāk par %{count} minūtēm"
        },
        "less_than_x_seconds": {
          "one": "mazāk par %{count} sekundi",
          "other": "mazāk par %{count} sekundēm",
          "zero": "mazāk par %{count} sekundēm"
        },
        "over_x_years": {
          "one": "vairāk kā %{count} gads",
          "other": "vairāk kā %{count} gadi",
          "zero": "vairāk kā %{count} gadi"
        },
        "x_days": {
          "one": "%{count} diena",
          "other": "%{count} dienas",
          "zero": "%{count} dienas"
        },
        "x_minutes": {
          "one": "%{count} minūte",
          "other": "%{count} minūtes",
          "zero": "%{count} minūtes"
        },
        "x_months": {
          "one": "%{count} mēnesis",
          "other": "%{count} mēneši",
          "zero": "%{count} mēneši"
        },
        "x_seconds": {
          "one": "%{count} sekunde",
          "other": "%{count} sekundes",
          "zero": "%{count} sekundes"
        }
      },
      "prompts": {
        "day": "diena",
        "hour": "stunda",
        "minute": "minūte",
        "month": "mēnesis",
        "second": "sekunde",
        "year": "gads"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Jūsu lietotājs ir veiksmīgi apstiprināts. Jūs esat pieslēdzies.",
        "new": {
          "resend_confirmation_instructions": "Atkārtoti atsūtīt instrukcijas apstiprinājumu"
        },
        "send_instructions": "Pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā apstiprināt Jūsu lietotāju.",
        "send_paranoid_instructions": "Ja Jūsu parole eksistē mūsu datubāzē, tad pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā apstiprināt Jūsu lietotāju."
      },
      "failure": {
        "already_authenticated": "Jūs jau esiet pieslēdzies.",
        "inactive": "Jūsu lietotājs vēl nav aktivizēts.",
        "invalid": "Nepareizs %{authentication_keys} vai parole.",
        "last_attempt": "Jums ir atlicis pēdējais mēģinājums, pirms jūsu lietotājs tiks bloķēts.",
        "locked": "Jūsu lietotājs ir nobloķēts.",
        "not_found_in_database": "Nepareizs %{authentication_keys} vai parole.",
        "timeout": "Jūsu sesijas laiks ir beidzies. Lūdzu, pieslēdzieties vēlreiz, lai turpinātu.",
        "unauthenticated": "Jums ir jāpieslēdzas vai jāreģistrējas, lai turpinātu.",
        "unconfirmed": "Jums ir jāapstiprina reģistrācijas epasts, lai turpinātu."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Apstiprināt kontu",
          "greeting": "Sveicināti, %{recipient}!",
          "instruction": "Jūs varat apstiprināt, Jūsu konta epastu caur saiti zemāk:",
          "subject": "Apstiprināšanas apraksts"
        },
        "email_changed": {
          "greeting": "Sveicināti, %{recipient}!",
          "message": "Informējam, ka Jūsu epasts ir nomainīts uz %{email}.",
          "message_unconfirmed": null,
          "subject": "Epasts nomainīts"
        },
        "password_change": {
          "greeting": "Sveicināti, %{recipient}!",
          "message": "Informējam, ka Jūsu parole ir nomainīta.",
          "subject": "Parole nomainīta"
        },
        "reset_password_instructions": {
          "action": "Veikt paroles maiņu",
          "greeting": "Sveicināti, %{recipient}!",
          "instruction": "Kāds ir nosūtijis pieprasijumu, Jūsu paroles maiņai, to var veikt caur saiti zemāk.",
          "instruction_2": "Ja Jūs neveicāt šo pieprasījumu, lūdzu, ignorējiet šo ziņu.",
          "instruction_3": "Jūsu parole netiks mainīta, kamēr Jūs neapstiprināsiet saiti augstāk un neizveidosiet jaunu.",
          "subject": "Paroles nomainīšanas apraksts"
        },
        "unlock_instructions": {
          "action": "Atbloķēt kontu",
          "greeting": "Sveicināti, %{recipient}!",
          "instruction": "Nospiežiet uz saites zemāk, lai atbloķētu kontu:",
          "message": "Jūsu konts tika bloķēts vairāku kļūdainu pieteikšanās mēģinājumu rezultātā.",
          "subject": "Atbloķēšanas apraksts"
        }
      },
      "omniauth_callbacks": {
        "failure": "Neizdevās autorizēties ar %{kind} lietotāju. Iemesls: \"%{reason}\".",
        "success": "Veiksmīgi autorizējis ar %{kind} lietotāju."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Mainīt paroli",
          "change_your_password": "Paroles maiņa",
          "confirm_new_password": "Apstiprināt jauno paroli",
          "new_password": "Jauna parole"
        },
        "new": {
          "forgot_your_password": "Aizmirsāt paroli?",
          "send_me_reset_password_instructions": "Atsūtīt paroles maiņas instrukciju"
        },
        "no_token": "Šī lapa ir pieejama tikai no paroles maiņas e-pasta. Ja Jūs atvērāt šo lapu no e-pasta, tad pārliecinieties, ka izmantojāt pilno URL adresi.",
        "send_instructions": "Pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā nomainīt jūsu paroli.",
        "send_paranoid_instructions": "Ja Jūsu parole eksistē mūsu datubāzē, tad jums tiks nosūtīts paroles atjaunošanas apraksts uz epastu",
        "updated": "Jūsu parole ir veiksmīgi nomainīta. Jūs esat pieslēdzies.",
        "updated_not_active": "Jūsu parole ir veiksmīgi nomainīta."
      },
      "registrations": {
        "destroyed": "Uz redzēšanos! Jūsu lietotājs ir veiksmīgi dzēsts. Ceram Jūs drīzumā redzēt atkal.",
        "edit": {
          "are_you_sure": "Vai Jūs esat pārliecināts/-ta?",
          "cancel_my_account": "Atcelt kontu",
          "currently_waiting_confirmation_for_email": "Pašlaik gaida apstiprinājumu epastam: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "atstājiet tukšu šo lauku, ja nevēlaties veikt izmaiņas",
          "title": "Rediģēt %{resource}",
          "unhappy": "Neapmierināts",
          "update": "Izmainīt",
          "we_need_your_current_password_to_confirm_your_changes": "mums ir nepieciešama Jūsu tagadējā parole, lai veiktu izmaiņas"
        },
        "new": {
          "sign_up": "Reģistrēties"
        },
        "signed_up": "Laipni lūgti! Jūs esiet veiksmīgi reģistrējies.",
        "signed_up_but_inactive": "Jūs esat veiksmīgi reģistrējies. Tomēr Jūs neesat pieslēdzies, jo Jūsu lietotājs vēl nav aktivizēts.",
        "signed_up_but_locked": "Jūs esat veiksmīgi reģistrējies. Tomēr Jūs neesat pieslēdzies, jo Jūsu lietotājs ir nobloķēts.",
        "signed_up_but_unconfirmed": "Jums ir nosūtīts e-pasts ar reģistrācijas apstiprinājuma saiti. Lūdzu, atveriet šo saiti, lai aktivizētu Jūsu lietotāju.",
        "update_needs_confirmation": "Jūsu labotās izmaiņas ir veiksmīgi saglabātas, bet mums ir jāpārbauda Jūsu jaunā e-pasta adrese. Lūdzu, pārbaudiet Jūsu e-pastu un uzklikšķiniet uz apstiprinājuma saites, lai pabeigtu Jūsu jaunās e-pasta adreses apstiprināšanu.",
        "updated": "Jūsu labotās izmaiņas ir veiksmīgi saglabātas.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Veiksmīgi atslēdzies.",
        "new": {
          "sign_in": "Pievienoties"
        },
        "signed_in": "Veiksmīgi pieslēdzies.",
        "signed_out": "Veiksmīgi atslēdzies."
      },
      "shared": {
        "links": {
          "back": "Atpakaļ",
          "didn_t_receive_confirmation_instructions": "Nesaņēmāt apstiprināšanas instrukciju?",
          "didn_t_receive_unlock_instructions": "Nesaņēmāt atbloķēšanas instrukciju?",
          "forgot_your_password": "Aizmirsāt paroli?",
          "sign_in": "Pievienoties",
          "sign_in_with_provider": "Pievienoties ar %{provider}",
          "sign_up": "Reģistrēties"
        },
        "minimum_password_length": {
          "one": "(vismaz %{count} zīme)",
          "other": "(vismaz %{count} zīmes)",
          "zero": "(vismaz %{count} zīmes)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Atkārtoti atsūtīt atbloķēšanas instrukciju"
        },
        "send_instructions": "Pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā atbloķēt Jūsu lietotāju.",
        "send_paranoid_instructions": "Ja Jūsu parole eksistē mūsu datubāzē, tad pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā atbloķēt jūsu lietotāju.",
        "unlocked": "Jūsu lietotājs ir veiksmīgi atbloķēts. Jūs esat pieslēdzies."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ir jāpiekrīt",
        "already_confirmed": "ir jau apstiprināts, lūdzu, mēģiniet pieslēgties",
        "blank": "ir jābūt aizpildītam",
        "confirmation": "nesakrīt ar apstiprinājumu",
        "confirmation_period_expired": "nepieciešama apstiprināšana %{period} laikā, lūdzu, piesakieties jaunam",
        "empty": "ir jābūt aizpildītam",
        "equal_to": "ir jābūt vienādam ar %{count}",
        "even": "ir jābūt pāra skaitlim",
        "exclusion": "nav pieejams",
        "expired": "derīgums beidzies, lūdzu, piesakieties jaunam",
        "greater_than": "ir jābūt lielākam par %{count}",
        "greater_than_or_equal_to": "ir jābūt lielākam vai vienādam ar %{count}",
        "inclusion": "nav iekļauts sarakstā",
        "invalid": "nav derīgs",
        "less_than": "ir jābūt mazākam par %{count}",
        "less_than_or_equal_to": "ir jābūt mazākam vai vienādam ar %{count}",
        "model_invalid": "Validācija neizdevās: %{errors}",
        "not_a_number": "nav skaitlis",
        "not_an_integer": "ir jābūt veselam skaitlim",
        "not_found": "netika atrasts",
        "not_locked": "netika nobloķēts",
        "not_saved": {
          "one": "%{resource} netika saglabāts %{count} kļūdas dēļ:",
          "other": "%{resource} netika saglabāts %{count} kļūdu dēļ:",
          "zero": "%{resource} netika saglabāts %{count} kļūdu dēļ:"
        },
        "odd": "ir jābūt nepāra skaitlim",
        "other_than": "jābūt citam nekā %{count}",
        "present": "jābūt tukšam",
        "required": "ir jābūt",
        "taken": "ir jau aizņemts",
        "too_long": {
          "one": "ir par garu (maksimums ir %{count} simbols)",
          "other": "ir par garu (maksimums ir %{count} simboli)",
          "zero": "ir par garu (maksimums ir %{count} simboli)"
        },
        "too_short": {
          "one": "ir par īsu (minimums ir %{count} simbols)",
          "other": "ir par īsu (minimums ir %{count} simboli)",
          "zero": "ir par īsu (minimums ir %{count} simboli)"
        },
        "wrong_length": {
          "one": "ir nepareizs garums (jābūt %{count} simbolam)",
          "other": "ir nepareizs garums (jābūt %{count} simboliem)",
          "zero": "ir nepareizs garums (jābūt %{count} simboliem)"
        }
      },
      "template": {
        "body": "Problēmas ir šajos ievades laukos:",
        "header": {
          "one": "Dēļ %{count} kļūdas šis %{model} netika saglabāts",
          "other": "Dēļ %{count} kļūdām šis %{model} netika saglabāts",
          "zero": "Dēļ %{count} kļūdām šis %{model} netika saglabāts"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Ādaži",
          "Aglona",
          "Aizstrautnieki",
          "Akācijas",
          "Alderi",
          "Almāle",
          "Alsunga",
          "Ambeļi",
          "Ance",
          "Āne",
          "Āņi",
          "Annenieki",
          "Apšupe",
          "Auči",
          "Audriņi",
          "Audrupi",
          "Auri",
          "Ausātas",
          "Balande",
          "Baldonas",
          "Baltinava",
          "Bērzbeķe",
          "Bērzkrasti",
          "Biķernieki",
          "Biksti",
          "Bikstu Stacija",
          "Bitenieki",
          "Braki",
          "Brankas",
          "Briģi",
          "Būcmaņciems",
          "Burtnieki",
          "Carnikava",
          "Cekule",
          "Ceriņi",
          "Červonka",
          "Cibla",
          "Dalbe",
          "Degumuiža",
          "Demene",
          "Dienvidstacija",
          "Dimzukalns",
          "Divezeri",
          "Dundaga",
          "Dviete",
          "Dzelzāmurs",
          "Dzelzava",
          "Dzidriņas",
          "Dzimtmisa",
          "Eglaine",
          "Emburga",
          "Engure",
          "Ērģeme",
          "Ērgļi",
          "Gardene",
          "Gaujiena",
          "Grīnvalti",
          "Iecava",
          "Iļķene",
          "Inčukalns",
          "Jaunā Māja",
          "Jaunbērze",
          "Jaunciems",
          "Jaungulbene",
          "Jaunpēternieki",
          "Jaunpiebalga",
          "Jaunpils",
          "Jūrkalne",
          "Kadaga",
          "Kaķenieki",
          "Kalupe",
          "Kazupe",
          "Ķirpēni",
          "Kocēni",
          "Koknese",
          "Kolka",
          "Košrags",
          "Krimūnas",
          "Ķekava",
          "Lauciņi",
          "Lauderi",
          "Lejasciems",
          "Lejasstrazdi",
          "Līči",
          "Līdumi",
          "Lieģi",
          "Lielbērze",
          "Lielirbe",
          "Liepziedi",
          "Līksna",
          "Litene",
          "Līvi",
          "Lociki",
          "Ļukas",
          "Lūžņa",
          "Maļinova",
          "Mālpils",
          "Mārupe",
          "Mazbiksti",
          "Mazirbe",
          "Medumi",
          "Melnsils",
          "Mērsrags",
          "Mežinieki",
          "Mežotne",
          "Miķeļtornis",
          "Miltiņi",
          "Mūrmuiža",
          "Naudīte",
          "Naukšēni",
          "Nereta",
          "Nīca",
          "Nīcgale",
          "Nītaure",
          "Ņivņiki",
          "Ozolnieki",
          "Parūķis",
          "Pasiene",
          "Patkule",
          "Penkule",
          "Pilsrundāle",
          "Piņķi",
          "Pitrags",
          "Priekuļi",
          "Reģi",
          "Riebiņi",
          "Ropaži",
          "Rosme",
          "Rožupe Parish",
          "Rucava",
          "Rugāji",
          "Sala",
          "Saliena",
          "Saunags",
          "Saurieši",
          "Sīkrags",
          "Sīpele",
          "Skaistkalne",
          "Šķibe",
          "Skrīveri",
          "Skrudaliena",
          "Skujaine",
          "Slagūne",
          "Smārde",
          "Stalbe",
          "Stapriņi",
          "Straupe",
          "Tabore",
          "Tārgale",
          "Tetele",
          "Ulbroka",
          "Upeslejas",
          "Vabole",
          "Vaide",
          "Vaiņode",
          "Vālodzes",
          "Vandzene",
          "Vecpiebalga",
          "Vecumnieki",
          "Vecvārkava",
          "Višķi",
          "Zaķumuiža",
          "Zaļesje",
          "Zālīte",
          "Zaube",
          "Zebrene",
          "Zelmeņi",
          "Ziedlejas",
          "Zorģi"
        ],
        "postcode": [
          "LV-####"
        ],
        "state": [
          "Kurzeme",
          "Rīga",
          "Latgale",
          "Zemgale",
          "Vidzeme"
        ],
        "street_address": [
          "#{Name.last_name} #{street_suffix} #{building_number}"
        ],
        "street_name": [
          "#{Name.last_name} #{street_suffix}"
        ],
        "street_suffix": [
          "iela"
        ]
      },
      "cell_phone": {
        "formats": [
          "2# ### ###"
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{suffix} #{Name.last_name}"
        ],
        "suffix": [
          "SIA",
          "AS"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "lv",
          "net",
          "org"
        ]
      },
      "name": {
        "first_name": [
          "Agate",
          "Agita",
          "Agnese",
          "Agra",
          "Agrita",
          "Aiga",
          "Aija",
          "Aina",
          "Aira",
          "Airita",
          "Aiva",
          "Aivita",
          "Aleksandra",
          "Aleksandrīna",
          "Alina",
          "Alise",
          "Alla",
          "Alma",
          "Alvīna",
          "Alvīne",
          "Alīna",
          "Amanda",
          "Amālija",
          "Anastasija",
          "Ance",
          "Anda",
          "Andra",
          "Andžela",
          "Anete",
          "Anita",
          "Anna",
          "Annija",
          "Antonija",
          "Antoņina",
          "Antra",
          "Anžela",
          "Anželika",
          "Arnita",
          "Arta",
          "Astra",
          "Astrīda",
          "Ausma",
          "Austra",
          "Baba",
          "Baiba",
          "Beatrise",
          "Benita",
          "Betija",
          "Beāte",
          "Biruta",
          "Brigita",
          "Broņislava",
          "Dace",
          "Dagmāra",
          "Dagnija",
          "Daiga",
          "Daina",
          "Dainuvīte",
          "Dana",
          "Daniela",
          "Dina",
          "Dita",
          "Diāna",
          "Doroteja",
          "Dzidra",
          "Dzintra",
          "Dārta",
          "Eda",
          "Edīte",
          "Egija",
          "Egita",
          "Eiženija",
          "Elena",
          "Eleonora",
          "Elga",
          "Elita",
          "Elizabete",
          "Elvīra",
          "Elza",
          "Elēna",
          "Elīna",
          "Elīza",
          "Emma",
          "Emīlija",
          "Enija",
          "Estere",
          "Eva",
          "Evelīna",
          "Evija",
          "Evita",
          "Gaida",
          "Gaļina",
          "Genovefa",
          "Ginta",
          "Gita",
          "Grieta",
          "Guna",
          "Gundega",
          "Gunita",
          "Gunta",
          "Helēna",
          "Ieva",
          "Ilga",
          "Ilona",
          "Iluta",
          "Ilva",
          "Ilze",
          "Ilzīte",
          "Ina",
          "Indra",
          "Inesa",
          "Inese",
          "Ineta",
          "Inga",
          "Ingrīda",
          "Inguna",
          "Ingūna",
          "Inita",
          "Inna",
          "Inta",
          "Ināra",
          "Irma",
          "Irēna",
          "Irīna",
          "Iveta",
          "Jadviga",
          "Jana",
          "Jeļena",
          "Jolanta",
          "Judīte",
          "Justīne",
          "Juta",
          "Jūlija",
          "Karina",
          "Karlīna",
          "Karolīna",
          "Karīna",
          "Katarīna",
          "Katrīna",
          "Keita",
          "Kintija",
          "Kitija",
          "Klaudija",
          "Krista",
          "Kristina",
          "Kristiāna",
          "Kristīna",
          "Kristīn1e",
          "Ksenija",
          "Laila",
          "Laima",
          "Laimdota",
          "Larisa",
          "Lauma",
          "Laura",
          "Lavīze",
          "Lelde",
          "Lidija",
          "Liene",
          "Lienīte",
          "Liesma",
          "Ligita",
          "Lija",
          "Lilija",
          "Lilita",
          "Linda",
          "Liāna",
          "Lolita",
          "Ludmila",
          "Luīze",
          "Lāsma",
          "Līga",
          "Līna",
          "Līva",
          "Līvija",
          "Lūcija",
          "Madara",
          "Maiga",
          "Maija",
          "Maira",
          "Mairita",
          "Margarita",
          "Margita",
          "Margrieta",
          "Marija",
          "Marika",
          "Marina",
          "Marita",
          "Marta",
          "Maruta",
          "Megija",
          "Milda",
          "Mirdza",
          "Modra",
          "Modrīte",
          "Monika",
          "Monta",
          "Mudīte",
          "Māra",
          "Mārīte",
          "Adrians",
          "Adriāns",
          "Agnis",
          "Agris",
          "Aigars",
          "Ainars",
          "Ainis",
          "Ainārs",
          "Aivars",
          "Aivis",
          "Alberts",
          "Aleksanders",
          "Aleksandras",
          "Aleksandrs",
          "Aleksejs",
          "Aleksis",
          "Alfons",
          "Alfrēds",
          "Aloizs",
          "Alvis",
          "Anatolijs",
          "Andis",
          "Andrejs",
          "Andris",
          "Andžejs",
          "Anrijs",
          "Ansis",
          "Antons",
          "Arkādijs",
          "Armands",
          "Armīns",
          "Arnis",
          "Arnolds",
          "Artis",
          "Arturs",
          "Artūrs",
          "Arvis",
          "Arvīds",
          "Atis",
          "Augusts",
          "Austris",
          "Boriss",
          "Brencis",
          "Bruno",
          "Cefanja",
          "Dagnis",
          "Dainis",
          "Daniels",
          "Didzis",
          "Dmitrijs",
          "Dzintars",
          "Dāvids",
          "Dāvis",
          "Džeimss",
          "Džons",
          "Džordžs",
          "Edgars",
          "Edijs",
          "Edmunds",
          "Eduards",
          "Edvards",
          "Edvīns",
          "Egils",
          "Egons",
          "Einārs",
          "Eižens",
          "Elmārs",
          "Elvijs",
          "Elvis",
          "Elviss",
          "Elīza",
          "Emīls",
          "Endijs",
          "Ernests",
          "Ervīns",
          "Felikss",
          "Filips",
          "Fjodors",
          "Francis",
          "Fricis",
          "Fridrihs",
          "Fēlikss",
          "Fīlips",
          "Gatis",
          "Georgs",
          "Gintars",
          "Gintauts",
          "Gints",
          "Gothards",
          "Gundars",
          "Guntars",
          "Guntis",
          "Gunārs",
          "Gustavs",
          "Gusts",
          "Gvido",
          "Hanss",
          "Haralds",
          "Harijs",
          "Helmuts",
          "Henrihs",
          "Henrijs",
          "Henriks",
          "Herberts",
          "Hermanis",
          "Ignats",
          "Igors",
          "Ilgonis",
          "Ilgvars",
          "Ilmārs",
          "Ilvars",
          "Imants",
          "Indriķis",
          "Indulis",
          "Ingars",
          "Ingus",
          "Intars",
          "Ints",
          "Inārs",
          "Ivans",
          "Ivars",
          "Ivo",
          "Jans",
          "Jevgeņijs",
          "Johans",
          "Jozua",
          "Juris",
          "Jurģis",
          "Jānis",
          "Jāzeps",
          "Jēkabs",
          "Jūlijs",
          "Kaspars",
          "Kazimirs",
          "Kirils",
          "Klāvs",
          "Konstantīns",
          "Kristaps",
          "Kristers",
          "Kristiāns",
          "Krists",
          "Krišjānis",
          "Krišs",
          "Kārlis",
          "Laimdots",
          "Laimonis",
          "Lauris",
          "Leonards",
          "Leons",
          "Leonīds",
          "Linards",
          "Ludis",
          "Ludvigs",
          "Lūks",
          "Madars",
          "Maigonis",
          "Maikls",
          "Mairis",
          "Maksims",
          "Mareks",
          "Marks",
          "Markuss",
          "Matejs",
          "Matīss",
          "Miervaldis",
          "Mihaels",
          "Mihails",
          "Miks",
          "Mikus",
          "Miķelis",
          "Modris",
          "Mozus",
          "Mārcis",
          "Māris",
          "Mārtiņš",
          "Nauris",
          "Niklāvs",
          "Nikolajs",
          "Niks",
          "Normunds",
          "Ojārs",
          "Olafs",
          "Olivers",
          "Olivjē",
          "Oskars",
          "Osvalds",
          "Oto",
          "Oļegs",
          "Paulis",
          "Pauls",
          "Pjotrs",
          "Pāvels",
          "Pāvils",
          "Pēteris",
          "Raimonds",
          "Raitis",
          "Raivis",
          "Raivo",
          "Ralfs",
          "Reinholds"
        ],
        "last_name": [
          "Āboliņš",
          "Ābols",
          "Alksnis",
          "Annina",
          "Antons",
          "Arājs",
          "Balodis",
          "Bartulis",
          "Baumanis",
          "Bertāns",
          "Bertholds",
          "Bērziņš",
          "Briedis",
          "Dārziņš",
          "Dukurs",
          "Džeriņš",
          "Eglītis",
          "Ezergailis",
          "Freimanis",
          "Godmanis",
          "Gulbis",
          "Helmanis",
          "Irbe",
          "Jansons",
          "Jaunzeme",
          "Kalniņš",
          "Krūmiņa",
          "Krūmiņš",
          "Kulda",
          "Lācis",
          "Liepa",
          "Liepiņš",
          "Matīss",
          "Mezhlauk",
          "Mucenieks",
          "Muižnieks",
          "Novickis",
          "Ozoliņš",
          "Ozols",
          "Pelšs",
          "Pētersons",
          "Rozītis",
          "Rubenis",
          "Šics",
          "Sirmais",
          "Skrastiņš",
          "Tīruma",
          "Ulmanis",
          "Vanags",
          "Vasiļjevs",
          "Vilks",
          "Vītoliņš",
          "Vītols",
          "Zariņš"
        ],
        "name": [
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ],
        "title": {
          "descriptor": [
            "Lead",
            "Senior",
            "Direct",
            "Corporate",
            "Dynamic",
            "Future",
            "Product",
            "National",
            "Regional",
            "District",
            "Central",
            "Global",
            "Customer",
            "Investor",
            "Dynamic",
            "International",
            "Legacy",
            "Forward",
            "Internal",
            "Human",
            "Chief",
            "Principal"
          ],
          "job": [
            "Supervisor",
            "Associate",
            "Executive",
            "Liaison",
            "Officer",
            "Manager",
            "Engineer",
            "Specialist",
            "Director",
            "Coordinator",
            "Administrator",
            "Architect",
            "Analyst",
            "Designer",
            "Planner",
            "Orchestrator",
            "Technician",
            "Developer",
            "Producer",
            "Consultant",
            "Assistant",
            "Facilitator",
            "Agent",
            "Representative",
            "Strategist"
          ],
          "level": [
            "Solutions",
            "Program",
            "Brand",
            "Security",
            "Research",
            "Marketing",
            "Directives",
            "Implementation",
            "Integration",
            "Functionality",
            "Response",
            "Paradigm",
            "Tactics",
            "Identity",
            "Markets",
            "Group",
            "Division",
            "Applications",
            "Optimization",
            "Operations",
            "Infrastructure",
            "Intranet",
            "Communications",
            "Web",
            "Branding",
            "Quality",
            "Assurance",
            "Mobility",
            "Accounts",
            "Data",
            "Creative",
            "Configuration",
            "Accountability",
            "Interactions",
            "Factors",
            "Usability",
            "Metrics"
          ]
        }
      },
      "phone_number": {
        "formats": [
          "5# ### ###",
          "6# ### ###",
          "7# ### ###"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Lūdzu izvēlies"
      },
      "submit": {
        "create": "Izveidot %{model}",
        "submit": "Saglabāt %{model}",
        "update": "Atjaunināt %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "miljards",
              "other": "miljardi",
              "zero": "miljardi"
            },
            "million": {
              "one": "miljons",
              "other": "miljoni",
              "zero": "miljoni"
            },
            "quadrillion": {
              "one": "kvadriljons",
              "other": "kvadriljoni",
              "zero": "kvadriljoni"
            },
            "thousand": {
              "one": "tūkstotis",
              "other": "tūkstoši",
              "zero": "tūkstoši"
            },
            "trillion": {
              "one": "triljons",
              "other": "triljoni",
              "zero": "triljoni"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "baits",
              "other": "baiti",
              "zero": "baiti"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " un ",
        "two_words_connector": " un ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "priekšpusdiena",
      "formats": {
        "default": "%Y. gada %e. %B, %H:%M",
        "long": "%Y. gada %e. %B, %H:%M:%S",
        "short": "%d.%m.%Y., %H:%M"
      },
      "pm": "pēcpusdiena"
    }
  },
  "mg": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Tsy tontosa ny fankatoavana : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Tsy afaka mamafa io andalana io ianao satria misy %{record} betsaka miankina aminy",
            "has_one": "Tsy afaka mamafa io andalana io ianao satria misy %{record} iray miankina amin'io"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Alah",
        "Alats",
        "Tal",
        "Alar",
        "Alak",
        "Zom",
        "Asab"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "may",
        "jona",
        "jolay.",
        "aog",
        "sept.",
        "okt.",
        "nov.",
        "des."
      ],
      "day_names": [
        "Alahady",
        "Alatsinainy",
        "Talata",
        "Alarobia",
        "Alakamisy",
        "Zoma",
        "Asabotsy"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "janoary",
        "febroary",
        "martsa",
        "aprily",
        "may",
        "jona",
        "jolay",
        "aogositra",
        "septambra",
        "aktobra",
        "novambra",
        "desambra"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "adiny iray eo ho eo",
          "other": "adiny %{count} eo ho eo"
        },
        "about_x_months": {
          "one": "iray volana eo ho eo",
          "other": "volana %{count} eo ho eo"
        },
        "about_x_years": {
          "one": "herintaona eo ho eo",
          "other": "taona %{count} eo ho eo"
        },
        "almost_x_years": {
          "one": "saika herintaona",
          "other": "saika %{count} taona"
        },
        "half_a_minute": "antsasak'adiny",
        "less_than_x_minutes": {
          "one": "latsaky ny iray segondra",
          "other": "latsaky ny %{count} minitra",
          "zero": "latsaky ny iray minitra"
        },
        "less_than_x_seconds": {
          "one": "latsaky ny iray segondra",
          "other": "latsaky ny %{count} segondra",
          "zero": "latsaky ny iray segondra"
        },
        "over_x_years": {
          "one": "Herintaona mahery",
          "other": "maherin'ny %{count} taona"
        },
        "x_days": {
          "one": "%{count} andro",
          "other": "%{count} andro"
        },
        "x_minutes": {
          "one": "%{count} minitra",
          "other": "%{count} minitra"
        },
        "x_months": {
          "one": "%{count} volana",
          "other": "%{count} volana"
        },
        "x_seconds": {
          "one": "%{count} segondra",
          "other": "%{count} segondra"
        },
        "x_years": {
          "one": "%{count} taona",
          "other": "%{count} taona"
        }
      },
      "prompts": {
        "day": "Andro",
        "hour": "Ora",
        "minute": "Minitra",
        "month": "Volana",
        "second": "Segondra",
        "year": "Taona"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "tsy maintsy ekena",
        "blank": "tsy maintsy fenoina",
        "confirmation": "tsy mifanaraka amin'ny %{attribute}",
        "empty": "tsy maintsy fenoina",
        "equal_to": "tsy maintsy mitovy amin'ny %{count}",
        "even": "tsy maintsy miankin-droa",
        "exclusion": "Tsy misy",
        "greater_than": "Tsy mihoatra ny %{count}",
        "greater_than_or_equal_to": "tsy maintsy mihoatra na mitovy amin'ny à %{count}",
        "inclusion": "tsy ao anaty lisitra",
        "invalid": "tsy ekena",
        "less_than": "tsy maintsy kely noho ny %{count}",
        "less_than_or_equal_to": "tsy kely na mitovy nohon'ny %{count}",
        "model_invalid": "Fangatahana tsy tontosa: %{errors}",
        "not_a_number": "tsy isa io",
        "not_an_integer": "tsy maintsy isa tsotra",
        "odd": "tsy maintsy impair",
        "other_than": "tsy maintsy hafa noho ny %{count}",
        "present": "tsy maintsy banga",
        "required": "tsy maintsy misy",
        "taken": "tsy misy",
        "too_long": {
          "one": "dia lava loatra (tsy mihoatra ny litera iray)",
          "other": "dia lava loatra (tsy mihoatra ny litera %{count})"
        },
        "too_short": {
          "one": "dia fohy loatra (farafahakeliny litera iray)",
          "other": "dia fohy loatra (farafahakeliny litera %{count})"
        },
        "wrong_length": {
          "one": "tsy amin'ny halavany (tokony ho litera iray)",
          "other": "tsy amin'ny halavany (tokony ho litera %{count})"
        }
      },
      "template": {
        "body": "Hamarino ireo saha manaraka azafady : ",
        "header": {
          "one": "Tsy azo tadidiana ity %{model} : olana %{count}",
          "other": "Tsy azo tadidiana ity %{model} : olana %{count}"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Misafidiana azafady"
      },
      "submit": {
        "create": "Mamorona %{model} iray",
        "submit": "Tadidiana ity %{model}",
        "update": "Ovaina ity %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "Ar"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "tapitrisa",
            "million": "hetsy",
            "quadrillion": "hetsy tapitrisa",
            "thousand": "Arivo",
            "trillion": "arivo tapitrisa",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %Hh %Mmin %Ss",
        "long": "%A %d %B %Y %Hh%M",
        "short": "%d %b %Hh%M"
      },
      "pm": "pm"
    }
  },
  "mi-NZ": {
    "faker": {
      "address": {
        "building_number": [
          "####",
          "###",
          "##",
          "#/##",
          "#/#",
          "#?",
          "?/##",
          "?/##?"
        ],
        "city": [
          "Ahuriri",
          "Awaroa",
          "Heretaunga",
          "Hokitika",
          "Kā Roimata o Hine Hukatere",
          "Kaikōura",
          "Kaitaia",
          "Kaiwaewae",
          "Kapanga",
          "Kāpiti",
          "Manawatu",
          "Manukau",
          "Māwhera",
          "Ngāmotu",
          "Ngāruawahia",
          "Ngāruawahia",
          "Ōamaru",
          "Ōtaki",
          "Otautahi",
          "Ōtepoti",
          "Papawai",
          "Pā nui o Hau",
          "Rānui",
          "Rotorua-nui-a-Kahumatamomoe",
          "Tāmaki Makaurau",
          "Taranaki",
          "Taupo-nui-a-Tia",
          "Tauranga-Moana",
          "Te Moeka o Tūawe",
          "Te Tai Poutini",
          "Te Waipounamu",
          "Te Whanganui-a-Tara",
          "Te Tihi-o-MaruTōtaranui",
          "Tūranganui-a-Kiwa",
          "Waiharakeke",
          "Waihōpai",
          "Waikato",
          "Whakatāne",
          "Whakatū",
          "Whanganui",
          "Whangarei",
          "Wharekākā"
        ],
        "community": [
          "#{Name.surname}",
          "#{place_names}",
          "#{place_names} #{landscape_elements}"
        ],
        "default_country": [
          "Aotearoa"
        ],
        "default_country_code": [
          "NZ"
        ],
        "full_address": [
          "#{street_address}, #{city} #{postcode}",
          "#{street_address}, #{secondary_address}, #{city} #{postcode}",
          "#{street_address}, #{community}, #{city} #{postcode}",
          "#{street_address}, #{community}, #{city} #{postcode}",
          "#{mail_box} #{community} #{postcode}",
          "#{mail_box}, #{community}, #{city} #{postcode}"
        ],
        "landscape_elements": [
          "Tātahi",
          "Roto",
          "Moana",
          "Awa",
          "Pa",
          "Maunga",
          "Māra",
          "Motu",
          "Ngāhere"
        ],
        "mail_box": [
          "PO Box ##",
          "PO Box #####",
          "CMB ##",
          "CMB C#"
        ],
        "place_names": [
          "Kauri",
          "Tōtara",
          "Kowhai",
          "Rata",
          "Pohutakawa",
          "Tawa",
          "Koromiko",
          "Hinau",
          "Manuka",
          "Kanuka",
          "Kawakawa",
          "Ngaio",
          "Karo",
          "Puriri",
          "Rewarewa",
          "Karamu",
          "Ti Kouka",
          "Hōhipera",
          "Kura",
          "Kāreti",
          "Ruapara",
          "Rerewhenua",
          "Teihana",
          "Wāpu",
          "Golf",
          "Arawhiti",
          "Papa Rererangi",
          "Whare Karakia Kakariki",
          "Kahurangi",
          "Mā",
          "Pango",
          "Kōwhai",
          "Poto",
          "Roa",
          "Kereru",
          "Kiwi",
          "Weka",
          "Pukeko",
          "Ruru",
          "Pīwakawaka",
          "Kea",
          "Kaka",
          "Kakariki",
          "Kakapō",
          "Kumara",
          "Riwai",
          "Rapeti"
        ],
        "postcode": [
          "0###",
          "2###",
          "3###",
          "4###",
          "5###",
          "6###",
          "7###",
          "8###",
          "9###"
        ],
        "region": [
          "Te Tai Hauāuru",
          "Te Tai Rāwhiti",
          "Te Tai Tonga",
          "Te Tai Tokerau"
        ],
        "region_abbr": [
          "TTH",
          "TTR",
          "TTT",
          "TT-TK"
        ],
        "secondary_address": [
          "RD #",
          "Apt #",
          "Unit #",
          "Level #"
        ],
        "street_address": [
          "#{building_number} #{street_name}"
        ],
        "street_name": [
          "#{Name.first_name} #{street_suffix}",
          "#{Name.last_name} #{street_suffix}",
          "#{landscape_elements} #{street_suffix}",
          "#{place_names} #{street_suffix}"
        ],
        "street_suffix": [
          "Avenue",
          "Boulevard",
          "Circle",
          "Circuit",
          "Court",
          "Crescent",
          "Crest",
          "Drive",
          "Estate Dr",
          "Grove",
          "Hill",
          "Junction",
          "Knoll",
          "Lane",
          "Loop",
          "Mall",
          "Manor",
          "Meadow",
          "Mews",
          "Parade",
          "Pass",
          "Place",
          "Plaza",
          "Ridge",
          "Road",
          "Run",
          "Square",
          "Street",
          "St",
          "Summit",
          "Terrace",
          "Track",
          "Trail",
          "View Road",
          "Way",
          "Esplanade"
        ]
      },
      "name": {
        "first_name": [
          "Anahera",
          "Aroha",
          "Ataahua",
          "Awhina",
          "Hana",
          "Hoani",
          "Hohepa",
          "Hone",
          "Ihaia",
          "Ihaka",
          "Kara",
          "Kauri",
          "Maia",
          "Manaaki",
          "Manaia",
          "Manawa",
          "Mārama",
          "Matai",
          "Mikaere",
          "Moana",
          "Ngaire",
          "Nikau",
          "Rangi",
          "Rawiri",
          "Ripeka",
          "Tai",
          "Taika",
          "Tama",
          "Tamati",
          "Tane",
          "Tangaroa",
          "Tawhiri",
          "Te Ao",
          "Te Ariki",
          "Te Aroha",
          "Te Whiti",
          "Tu",
          "Tui",
          "Whina",
          "Wiremu"
        ],
        "last_name": [
          "#{surname}",
          "#{surname}-#{surname}",
          "#{surname} #{surname}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{first_name} #{last_name}"
        ],
        "surname": [
          "Arahanga",
          "Heke",
          "Henare",
          "Hiko",
          "Houra",
          "Karaka",
          "Mahia",
          "Mako",
          "Manawaiti",
          "Matene",
          "Mihaere",
          "Mikaere",
          "Ngata",
          "Parata",
          "Paratene",
          "Ruakere",
          "Tahere",
          "Tamahori",
          "Taumata",
          "Tawhiao",
          "Te Kanawa",
          "Te Whiti",
          "Timutimu",
          "Tuhaka",
          "Turei",
          "Waikari",
          "Waititi",
          "Wharerau",
          "Wikaira",
          "Winiata",
          "Wiparata"
        ]
      }
    }
  },
  "mk": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Потврдата е испратена во",
          "confirmation_token": "Токен за потврда",
          "confirmed_at": "Потврдена на",
          "created_at": "Креирана на",
          "current_password": "Моментална лозинка",
          "current_sign_in_at": "Current sign in at",
          "current_sign_in_ip": "Current sign in IP",
          "email": "Е-маил",
          "encrypted_password": "Енкриптирана лозинка",
          "failed_attempts": "Failed attempts",
          "last_sign_in_at": "Последно најавен на",
          "last_sign_in_ip": "Последно најавен во IP",
          "locked_at": "Заклучен на",
          "password": "Лозинка",
          "password_confirmation": "Потврда на лозинка",
          "remember_created_at": "Запомни ме креиран на",
          "remember_me": "Запомни ме",
          "reset_password_sent_at": "Промена на лозинка пратена на",
          "reset_password_token": "Токен за промена на лозинка",
          "sign_in_count": "Број на најавувања",
          "unconfirmed_email": "Непотврден е-маил",
          "unlock_token": "Токен за отклучување",
          "updated_at": "Ажуриран на"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "неуспешна валидација: %{errors}"
        }
      },
      "models": {
        "user": {
          "one": "Корисник",
          "other": "Корисници"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Нед",
        "Пон",
        "Вто",
        "Сре",
        "Чет",
        "Пет",
        "Саб"
      ],
      "abbr_month_names": [
        null,
        "Јан",
        "Фев",
        "Мар",
        "Апр",
        "Мај",
        "Јун",
        "Јул",
        "Авг",
        "Сеп",
        "Окт",
        "Ное",
        "Дек"
      ],
      "day_names": [
        "Недела",
        "Понеделник",
        "Вторник",
        "Среда",
        "Четврток",
        "Петок",
        "Сабота"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%B %e, %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "Јануари",
        "Февруари",
        "Март",
        "Април",
        "Мај",
        "Јуни",
        "Јули",
        "Август",
        "Септември",
        "Октомври",
        "Ноември",
        "Декември"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "околу %{count} час",
          "other": "околу %{count} часа"
        },
        "about_x_months": {
          "one": "околу %{count} месец",
          "other": "околу %{count} месеци"
        },
        "about_x_years": {
          "one": "околу %{count} година",
          "other": "околу %{count} години"
        },
        "almost_x_years": {
          "one": "скоро %{count} година",
          "other": "скоро %{count} години"
        },
        "half_a_minute": "пола минута",
        "less_than_x_minutes": {
          "one": "помалку од %{count} минута",
          "other": "помалку од %{count} минути"
        },
        "less_than_x_seconds": {
          "one": "помалку од %{count} секунда",
          "other": "помалку од %{count} секунди"
        },
        "over_x_years": {
          "one": "над %{count} година",
          "other": "над %{count} години"
        },
        "x_days": {
          "one": "%{count} ден",
          "other": "%{count} денови"
        },
        "x_minutes": {
          "one": "%{count} минута",
          "other": "%{count} минути"
        },
        "x_months": {
          "one": "%{count} месец",
          "other": "%{count} месеци"
        },
        "x_seconds": {
          "one": "%{count} секунда",
          "other": "%{count} секунди"
        }
      },
      "prompts": {
        "day": "Ден",
        "hour": "Час",
        "minute": "Минута",
        "month": "Месец",
        "second": "Секунди",
        "year": "Година"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Вашата е-маил адреса е успешно потврдена.",
        "new": {
          "resend_confirmation_instructions": "Повторно испрати инструкции за потврда"
        },
        "send_instructions": "Ќе добиете е-маил со инструкции како да ја потврдите Вашата е-маил адреса за неколку минути.",
        "send_paranoid_instructions": "Доколку Вашиот е-маил веќе постои во базата со податоци, ќе добиете е-маил со инструкции како да ја потврдите вашата е-маил адреса за неколку минути."
      },
      "failure": {
        "already_authenticated": "Веќе сте најавени.",
        "inactive": "Вашиот профил сеуште не е активиран.",
        "invalid": "Невалиден %{authentication_keys} или лозинка.",
        "last_attempt": "Имате уште еден обид пред вашиот профил да биде заклучен.",
        "locked": "Вашиот профил е заклучен.",
        "not_found_in_database": "Невалиден %{authentication_keys} или лозинка.",
        "timeout": "Вашата сесија заврши. Ве молиме најавете се повторно за да продолжите.",
        "unauthenticated": "Мора да се најавите или да креирате профил за да можете да продолжите.",
        "unconfirmed": "Мора да ја потврдите Вашата е-маил адреса за да можете да продолжите."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Потврди го мојот профил",
          "greeting": "Добредојде %{recipient}!",
          "instruction": "Може да ја потврдите Вашата е-маил адреса за Вашиот профил преку линкот кој е зададен подолу:",
          "subject": "Инструкции за потврда на е-маил адреса"
        },
        "email_changed": {
          "greeting": "Здраво %{recipient}!",
          "message": "Ве контактираме за да Ве известиме дека Вашата е-маил адреса е заменета со %{email}.",
          "message_unconfirmed": null,
          "subject": "Промена на е-маил"
        },
        "password_change": {
          "greeting": "Здраво %{recipient}!",
          "message": "Ве контактираме за да ве известиме дека Вашата лозинка е променета.",
          "subject": "Промена на лозинка"
        },
        "reset_password_instructions": {
          "action": "Промена на моја лозинка",
          "greeting": "Здраво %{recipient}!",
          "instruction": "Некој побара линк за промена на Вашата лозинка. Промената може да ја направите преку подолу зададениот линк",
          "instruction_2": "Доколку Вие не сте побарале промена на Вашата лозинка, Ве замолуваме да го игнорирате овој е-маил.",
          "instruction_3": "Вашата лозинка нема да се промени се додека не пристапите до линкот зададен погоре и не креирате нова лозинка.",
          "subject": "Инструкции за промена на лозинка"
        },
        "unlock_instructions": {
          "action": "Отклучи го мојот профил",
          "greeting": "Здраво %{recipient}!",
          "instruction": "Кликнете не линкот зададен подолу за да го отклучите Вашиот профил:",
          "message": "Вашиот профил е заклучен поради преминување на дозволениот број на обиди за најавување.",
          "subject": "Инструкции за отклучување на профил"
        }
      },
      "omniauth_callbacks": {
        "failure": "Не можевме да Ве верификуваме од %{kind} профил поради \"%{reason}\".",
        "success": "Успешно сте верификувани од %{kind} профил."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Промени ја мојата лозинката",
          "change_your_password": "Промени ја лозинката",
          "confirm_new_password": "Потврди ја новата лозинка",
          "new_password": "Нова лозинка"
        },
        "new": {
          "forgot_your_password": "Ја заборавивте лозинката?",
          "send_me_reset_password_instructions": "Испрати ми инструкции за промена на лозинка"
        },
        "no_token": "Не можете да пристапите до оваа страна доколку не доаѓате од е-маил за промена на лозинка. Доколку доаѓате од е-маил за промена на лозинка, Ве замолуваме да проверите дали го имате целосниот URL.",
        "send_instructions": "Ќе добиете е-маил со инструкции за промена на Вашата лозинка во неколку минути.",
        "send_paranoid_instructions": "Доколку Вашата е-маил адреса веќе постои во базата со податоци, на Вашата е-маил адреса ќе добиете линк за обновување на лозинката во неколку минути.",
        "updated": "Вашата лозинка е успешно променета. Сега сте најавени.",
        "updated_not_active": "Вашата лозинка е успешно променета."
      },
      "registrations": {
        "destroyed": "Довидување! Вашиот профил е успешно откажан. Се надеваме дека ќе се вратите.",
        "edit": {
          "are_you_sure": "Дали сте сигурни?",
          "cancel_my_account": "Откажи го мојот профил",
          "currently_waiting_confirmation_for_email": "Моментално се чека потврда за: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "оставете празно доколку не сакате да извршите промена",
          "title": "Измени %{resource}",
          "unhappy": "Не сте задоволни?",
          "update": "Ажурирај",
          "we_need_your_current_password_to_confirm_your_changes": "потребна ни е Вашата моментална лозинка за да ги потврдиме измените"
        },
        "new": {
          "sign_up": "Креирај нов профил"
        },
        "signed_up": "Добредојдовте! Успешно се регистриравте.",
        "signed_up_but_inactive": "Успешно се регистриравте. Но притоа, не можевме да Ве најавиме бидејќи Вашиот профил сеуште не е активиран.",
        "signed_up_but_locked": "Успешно се регистриравте. Но притоа, не можевме да Ве најавиме бидејќи Вашиот профил е заклучен.",
        "signed_up_but_unconfirmed": "Порака со линк за потврда е испратен на Вашата е-маил адреса. Ве замолуваме следете го линкот за да го активирате профилот.",
        "update_needs_confirmation": "Успешно го ажуриравте профилот, но ние мора да ја верифицираме Вашата нова е-маил адреса. Ве замолуваме проверете го е-маилот и следете го линкот за да ја потврдите Вашата нова е-маил адреса.",
        "updated": "Успешно го ажуриравте профилот.",
        "updated_but_not_signed_in": "Успешно го ажуриравте профилот, но бидејќи ја променивте лозинката мора да се најавите повторно"
      },
      "sessions": {
        "already_signed_out": "Успешно се одјавивте.",
        "new": {
          "sign_in": "Најави се"
        },
        "signed_in": "Успешно се најавивте.",
        "signed_out": "Успешно се одјавивте."
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Не добивте инструкции за потврда?",
          "didn_t_receive_unlock_instructions": "Не добивте инструкции за отклучување?",
          "forgot_your_password": "Ја заборавивте Вашата лозинка?",
          "sign_in": "Најави се",
          "sign_in_with_provider": "Најави се со %{provider}",
          "sign_up": "Креирај профил"
        },
        "minimum_password_length": {
          "one": "(%{count} карактер минимум)",
          "other": "(%{count} карактери минимум)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Повторно испрати инструкции за отклучување"
        },
        "send_instructions": "Ќе добиете е-маил со инструкции за отклучување на Вашиот профил во неколку минути.",
        "send_paranoid_instructions": "Доколку Вашата е-маил адреса веќе постои во базата со податоци, на Вашата е-маил адреса ќе добиете линк за отклучување ма профилот во неколку минути.",
        "unlocked": "Вашиот профил е успешно отклучен. Ве замолуваме најавите се за да продолжите."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "мора да биде прифатен",
        "already_confirmed": "е веќе потврдена, Ве замолуваме пробајте да се најавите",
        "blank": "мора да биде зададен",
        "confirmation": "не се совпаѓа со својата потврда",
        "confirmation_period_expired": "мора да биде потврдена во период од %{period}, Ве замолуваме побарајте нова",
        "empty": "мора да биде зададен",
        "equal_to": "мора да биде еднакво на %{count}",
        "even": "мора да биде парно",
        "exclusion": "не е достапно",
        "expired": "заврши, Ве замолуваме побарајте нова",
        "greater_than": "мора да биде поголемо од %{count}",
        "greater_than_or_equal_to": "мора да биде поголемо или еднакво на %{count}",
        "inclusion": "не е во листата",
        "invalid": "не е исправен",
        "less_than": "мора да биде помало од %{count}",
        "less_than_or_equal_to": "мора да биде помало или еднакво на %{count}",
        "not_a_number": "не е број ",
        "not_an_integer": "не е цел број",
        "not_found": "не е пронајден",
        "not_locked": "е заклучен",
        "not_saved": {
          "one": "1 грешка спречија %{resource} да се зачува:",
          "other": "%{count} грешки спречија %{resource} да се зачува:"
        },
        "odd": "мора да биде непарно",
        "taken": "е зафатено",
        "too_long": {
          "one": "е предолг (не повеќе од %{count} карактер)",
          "other": "е предолг (не повеќе од %{count} карактери)"
        },
        "too_short": {
          "one": "е прекраток (не помалку од %{count} карактер)",
          "other": "е прекраток (не помалку од %{count} карактери)"
        },
        "wrong_length": {
          "one": "несоодветна должина (мора да имате %{count} карактер)",
          "other": "несоодветна должина (мора да имате %{count} карактери)"
        }
      },
      "template": {
        "body": "Ве молиме проверете ги следните полиња:",
        "header": {
          "one": "Не успеав да го зачувам %{model}: %{count} грешка.",
          "other": "Не успеав да го зачувам %{model}: %{count} грешки."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Одберете"
      },
      "submit": {
        "create": "Креира %{model}",
        "submit": "Зачувај %{model}",
        "update": "Измени %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "MKD"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "илјади",
            "million": "милјони",
            "quadrillion": "милјарди",
            "thousand": "трилјони",
            "trillion": "квадрилјони",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "бајт",
              "other": "бајти"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", и ",
        "two_words_connector": " и ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "АМ",
      "formats": {
        "default": "%a %d %b %Y %H:%M:%S %Z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "ПМ"
    }
  },
  "ml": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "സാധൂകരണം പരാജയപ്പെട്ടു: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "%{record} ആയി ബന്ദം ഉള്ളതിനാൽ നീക്കം ചെയ്യാൻ പറ്റില്ല",
            "has_one": "%{record} ആയി ബന്ദം ഉള്ളതിനാൽ നീക്കം ചെയ്യാൻ പറ്റില്ല"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ഞാ.",
        "തി.",
        "ചൊ.",
        "ബു.",
        "വ്യാ.",
        "വെ.",
        "ശ."
      ],
      "abbr_month_names": [
        null,
        "ജനു.",
        "ഫെബ്ര.",
        "മാർ.",
        "എപ്രി.",
        "മെയ്.",
        "ജൂണ്‍.",
        "ജൂലൈ.",
        "ആഗ.",
        "സെപ്തം.",
        "ഒക്ടോ.",
        "നവം.",
        "ഡിസം."
      ],
      "day_names": [
        "ഞായര്‍",
        "തിങ്കള്‍",
        "ചൊവ്വ",
        "ബുധൻ",
        "വ്യാഴം",
        "വെള്ളി",
        "ശനി"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "ജനുവരി",
        "ഫെബ്രുവരി",
        "മാർച്ച്",
        "ഏപ്രിൽ",
        "മെയ്",
        "ജൂണ്‍",
        "ജൂലൈ",
        "ഓഗസ്റ്റ്‌",
        "സെപ്റ്റംബർ",
        "ഒക്ടോബർ",
        "നവംബർ",
        "ഡിസംബർ"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "എകദേശം %{count} മണിക്കൂർ",
          "other": "എകദേശം %{count} മണിക്കൂർ"
        },
        "about_x_months": {
          "one": "എകദേശം %{count} മാസം",
          "other": "എകദേശം %{count} മാസം"
        },
        "about_x_years": {
          "one": "എകദേശം %{count} വർഷം",
          "other": "എകദേശം %{count} വർഷം"
        },
        "almost_x_years": {
          "one": "ഏതാണ്ട്  %{count} വർഷം",
          "other": "ഏതാണ്ട്  %{count} വർഷം"
        },
        "half_a_minute": "അര സൂക്ഷ്മ",
        "less_than_x_minutes": {
          "one": "ഒരു മിനുറ്റിനു ഉള്ളിൽ",
          "other": "%{count} മിനുറ്റിനു ഉള്ളിൽ"
        },
        "less_than_x_seconds": {
          "one": "ഒരു നിമിഷത്തിനു ഉള്ളിൽ",
          "other": "%{count} നിമിഷത്തിനു ഉള്ളിൽ"
        },
        "over_x_years": {
          "one": "ഒരു വര്ഷത്തിനു മേലെ",
          "other": "%{count} വര്ഷത്തിനു മേലെ"
        },
        "x_days": {
          "one": "%{count} ദിവസം",
          "other": "%{count} ദിവസങ്ങൾ"
        },
        "x_minutes": {
          "one": "%{count} മിനിറ്റ്",
          "other": "%{count} മിനിറ്റ്"
        },
        "x_months": {
          "one": "%{count} മാസം",
          "other": "%{count} മാസം"
        },
        "x_seconds": {
          "one": "%{count} നിമിഷം",
          "other": "%{count} നിമിഷം"
        },
        "x_years": {
          "one": "%{count} വർഷം",
          "other": "%{count} വർഷങ്ങൾ"
        }
      },
      "prompts": {
        "day": "ദിവസം",
        "hour": "മണിക്കൂർ",
        "minute": "സുക്ഷ്മ",
        "month": "സുക്ഷ്മ",
        "second": "നിമിഷം",
        "year": "വർഷം"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "സ്വീകരികേണ്ടത്  അത്യാവശ്യം ആണ്",
        "blank": "ഒഴിവായി കിടക്കുവാൻ പാടുള്ളതല്ല",
        "confirmation": "%{attribute} ആയി സാമ്യം ഇല്ല",
        "empty": "ഒഴിവായി കിടക്കുവാൻ പാടുള്ളതല്ല",
        "equal_to": "%{count} ആയി സാമ്യം വേണം",
        "even": "ഇരട്ട സംഖ്യ ആയിരിക്കണം",
        "exclusion": "കരുതിവെച്ചിരികുന്നതാണ്",
        "greater_than": "%{count} നേകാൾ വലുതായിരിക്കണം",
        "greater_than_or_equal_to": "%{count} നു തുല്യമോ അല്ലെങ്കിൽ വലുതോ ആയിരിക്കണം",
        "in": "%{count}ൽ ഉൾപ്പെടുത്തണം",
        "inclusion": "ഇതിൽ ഉള്ട്പെട്ടിട്ടില്ല",
        "invalid": "അസാധുവാണ്",
        "less_than": "%{count} നേകാൾ ചെറുതായിരിക്കണം",
        "less_than_or_equal_to": "%{count} നു തുല്യമോ അല്ലെങ്കിൽ ചെറുതോ ആയിരിക്കണം",
        "model_invalid": "മൂല്യനിർണ്ണയം പരാജയപ്പെട്ടു: %{errors}",
        "not_a_number": "ഒരു അക്കം അല്ല",
        "not_an_integer": "ഒരു അക്കം ആയിരിക്കണം",
        "odd": "ഒട്ടസന്ഘ്യ ആയിരിക്കണം",
        "other_than": "%{count} അല്ലാതെ മറ്റൊന്നായിരിക്കണം",
        "password_too_long": "ദൈർഘ്യമേറിയതാണ്",
        "present": "ഒഴിവായി ഇരിക്കണം",
        "required": "എന്തായാലും ഉണ്ടായിരിക്കണം",
        "taken": "ഇതിനു മുൻപേ ഉപയോഗിച്ചിരിക്കുന്നു",
        "too_long": {
          "one": "വളരെ വലുതാണ് (പരമാവധി %{count} പ്രതീകം)",
          "other": "വളരെ വലുതാണ് (പരമാവധി %{count} പ്രതീകങ്ങൾ)"
        },
        "too_short": {
          "one": "വളരെ ചെറുതാണ് (ഏറ്റവും കുറഞ്ഞത്‌  %{count} പ്രതീകം)",
          "other": "വളരെ ചെറുതാണ് (ഏറ്റവും കുറഞ്ഞത്‌ %{count} പ്രതീകങ്ങൾ)"
        },
        "wrong_length": {
          "one": "തെറ്റായ നീളം ആണ്  (%{count} പ്രതീകം ആയിരിക്കണം)",
          "other": "തെറ്റായ നീളം ആണ്  (%{count} പ്രതീകങ്ങൾ ആയിരിക്കണം)"
        }
      },
      "template": {
        "body": "താഴെ പറഞ്ഞവയിൽ തെറ്റുകൾ ഉണ്ട്:",
        "header": {
          "one": "%{model} സേവ് ചെയ്യുനത്തിൽ നിന്നും ഒരു തെറ്റ് വിലക്കിയിരിക്കുന്നു",
          "other": "%{model} സേവ് ചെയ്യുനത്തിൽ നിന്നും %{count} തെറ്റുകൾ വിലക്കിയിരിക്കുന്നു"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "ദയവായി തിരഞ്ഞെടുക്കുക"
      },
      "submit": {
        "create": "%{model} സൃഷ്ടിക്കുക",
        "submit": "%{model} സേവ് ചെയ്യുക",
        "update": "%{model} തിരുത്തുക്ക"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "നൂറുകോടി",
            "million": "ദശലക്ഷം",
            "quadrillion": "ക്വാഡ്രില്യൺ",
            "thousand": "ആയിരം",
            "trillion": "ട്രില്യൺ",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "ബൈറ്റ്",
              "other": "ബൈറ്റുകൾ"
            },
            "eb": "ഇ.ബി",
            "gb": "ജി.ബി",
            "kb": "കെ.ബി.",
            "mb": "എം.ബി.",
            "pb": "പി.ബി",
            "tb": "ടി.ബി",
            "zb": "സി.ബി"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", ഒപ്പം ",
        "two_words_connector": " ഒപ്പം ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "രാവിലെ",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%Y, %B %d %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "വൈകിട്ട്"
    }
  },
  "mn": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Шалгалт амжилтгүй: %{errors}"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Ня",
        "Да",
        "Мя",
        "Лх",
        "Пү",
        "Ба",
        "Бя"
      ],
      "abbr_month_names": [
        null,
        "1 сар",
        "2 сар",
        "3 сар",
        "4 сар",
        "5 сар",
        "6 сар",
        "7 сар",
        "8 сар",
        "9 сар",
        "10 сар",
        "11 сар",
        "12 сар"
      ],
      "day_names": [
        "Ням",
        "Даваа",
        "Мягмар",
        "Лхагва",
        "Пүрэв",
        "Баасан",
        "Бямба"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y %B %d",
        "short": "%y-%m-%d"
      },
      "month_names": [
        null,
        "1 сар",
        "2 сар",
        "3 сар",
        "4 сар",
        "5 сар",
        "6 сар",
        "7 сар",
        "8 сар",
        "9 сар",
        "10 сар",
        "11 сар",
        "12 сар"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "%{count} цаг орчим",
          "other": "%{count} цаг орчим"
        },
        "about_x_months": {
          "one": "%{count} сар орчим",
          "other": "%{count} сар орчим"
        },
        "about_x_years": {
          "one": "%{count} жил орчим",
          "other": "%{count} жил орчим"
        },
        "almost_x_years": {
          "one": "бараг %{count} жил",
          "other": "бараг %{count} жил"
        },
        "half_a_minute": "хагас минут",
        "less_than_x_minutes": {
          "one": "%{count} минутаас бага",
          "other": "%{count} минутаас бага"
        },
        "less_than_x_seconds": {
          "one": "%{count} секундээс бага",
          "other": "%{count} секундээс бага"
        },
        "over_x_years": {
          "one": "%{count} жилээс илүү",
          "other": "%{count} жилээс илүү"
        },
        "x_days": {
          "one": "%{count} өдөр",
          "other": "%{count} өдөр"
        },
        "x_minutes": {
          "one": "%{count} минут",
          "other": "%{count} минут"
        },
        "x_months": {
          "one": "%{count} сар",
          "other": "%{count} сар"
        },
        "x_seconds": {
          "one": "%{count} секунд",
          "other": "%{count} секунд"
        }
      },
      "prompts": {
        "day": "Өдөр",
        "hour": "Цаг",
        "minute": "Минут",
        "month": "Сар",
        "second": "Секунд",
        "year": "Жил"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "хүлээн зөвшөөрөгдсөн байх ёстой",
        "blank": "хоосон байж болохгүй",
        "confirmation": "адилгүй байна",
        "empty": "байхгүй байж болохгүй",
        "equal_to": "%{count}-тэй тэнцүү байх ёстой",
        "even": "тэгш байх ёстой",
        "exclusion": "бол ашиглахад хориотой",
        "greater_than": "%{count}-с их байх ёстой",
        "greater_than_or_equal_to": "%{count}-с их юмуу эсвэл тэнцүү байх ёстой",
        "inclusion": "жагсаалтанд алга байна",
        "invalid": "буруу байна",
        "less_than": "%{count}-с бага байх ёстой",
        "less_than_or_equal_to": "%{count}-с бага юмуу эсвэл тэнцүү байх ёстой",
        "not_a_number": "тоо биш байна",
        "not_an_integer": "бүхэл тоо байх ёстой",
        "odd": "сонгой байх ёстой",
        "taken": "аль хэдийн авчихсан байна",
        "too_long": {
          "one": "урт байна (хамгийн уртдаа %{count} тэмдэгт)",
          "other": "урт байна (хамгийн уртдаа %{count} тэмдэгт)"
        },
        "too_short": {
          "one": "богино байна (хамгийн багадаа %{count} тэмдэгт)",
          "other": "богино байна (хамгийн багадаа %{count} тэмдэгт)"
        },
        "wrong_length": {
          "one": "урт нь буруу байна (%{count} тэмдэгт байх ёстой)",
          "other": "урт нь буруу байна (%{count} тэмдэгт байх ёстой)"
        }
      },
      "template": {
        "body": "Дараах талбарууд дээр алдаа гарлаа:",
        "header": {
          "one": "%{count} алдаа гарсан тул %{model} хадгалагдахгүй байна",
          "other": "%{count} алдаа гарсан тул %{model} хадгалагдахгүй байна"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Сонгоно уу"
      },
      "submit": {
        "create": "Үүсгэх",
        "submit": "Хадгалах",
        "update": "Шинэчлэх"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "төг."
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Тэрбум",
            "million": "Сая",
            "quadrillion": "Тунамал",
            "thousand": "Мянга",
            "trillion": "Их наяд",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Байт",
              "other": "Байт"
            },
            "gb": "ГБ",
            "kb": "КБ",
            "mb": "МБ",
            "tb": "ТБ"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " болон ",
        "two_words_connector": " болон ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "өглөө",
      "formats": {
        "default": "%Y-%m-%d %H:%M",
        "long": "%Y %B %d, %H:%M:%S",
        "short": "%y-%m-%d"
      },
      "pm": "орой"
    }
  },
  "mr-IN": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "प्रमाणीकरण अयशस्वी: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "अवलंबून %{record} अस्तित्वात असल्याने रेकॉर्ड हटवू शकत नाही",
            "has_one": "अवलंबून %{record} अस्तित्वात असल्याने रेकॉर्ड हटवू शकत नाही"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "सोम",
        "मंगळ",
        "बुध",
        "गुरु",
        "शुक्र",
        "शनि",
        "रवि"
      ],
      "abbr_month_names": [
        null,
        "जाने",
        "फेब्रु",
        "मार्च",
        "एप्रि",
        "मे",
        "जून",
        "जुलै",
        "ऑग",
        "सेप्टें",
        "ऑक्टोबर",
        "नोव्हें",
        "डिसे"
      ],
      "day_names": [
        "सोमवार",
        "मंगळवार",
        "बुधवार",
        "गुरुवार",
        "शुक्रवार",
        "शनिवार",
        "रविवार"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "जानेवारी",
        "फेब्रुवारी",
        "मार्च",
        "एप्रिल",
        "मे",
        "जून",
        "जुलै",
        "ऑगस्ट",
        "सप्टेंबर",
        "ऑक्टोबर",
        "नोव्हेंबर",
        "डिसेंबर"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "सुमारे एक तास",
          "other": "सुमारे %{count} तास"
        },
        "about_x_months": {
          "one": "सुमारे %{count} महीना",
          "other": "सुमारे %{count} महिना"
        },
        "about_x_years": {
          "one": "सुमारे %{count} वर्ष",
          "other": "सुमारे %{count} वर्ष"
        },
        "almost_x_years": {
          "one": "जवळजवळ एक वर्ष",
          "other": "जवळजवळ %{count} वर्ष"
        },
        "half_a_minute": "अर्धा मिनिट",
        "less_than_x_minutes": {
          "one": "एका मिनिटापेक्षा कमी",
          "other": "%{count} मिनिटापेक्षा कमी"
        },
        "less_than_x_seconds": {
          "one": "एक सेकंद पेक्षा कमी",
          "other": "%{count} सेकंद पेक्षा कमी"
        },
        "over_x_years": {
          "one": "एका वर्षापेक्षा जास्त काळ",
          "other": "%{count} वर्षापेक्षा जास्त काळ"
        },
        "x_days": {
          "one": "एक दिवस",
          "other": "%{count} दिवस"
        },
        "x_minutes": {
          "one": "एक मिनिट",
          "other": "%{count} मिनिट"
        },
        "x_months": {
          "one": "एक महिना",
          "other": "%{count} महिना"
        },
        "x_seconds": {
          "one": "एक सेकंद",
          "other": "%{count} सेकंद"
        }
      },
      "prompts": {
        "day": "दिवस",
        "hour": "तास",
        "minute": "मिनिट",
        "month": "महिना",
        "second": "सेकंद",
        "year": "वर्ष"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "मान्य केले पाहिजे",
        "blank": "रिक्त ठेवता येणार नाही",
        "confirmation": "%{attribute} जुळत नाही",
        "empty": "रिक्त असू शकत नाही",
        "equal_to": "%{count} समान असणे आवश्यक",
        "even": "समांक असणे आवश्यक आहे",
        "exclusion": "राखीव आहे",
        "greater_than": "%{count} पेक्षा जास्त असणे आवश्यक आहे",
        "greater_than_or_equal_to": "%{count} पेक्षा मोठे किंवा समान असणे आवश्यक आहे",
        "inclusion": "यादीत समाविष्ट नाही",
        "invalid": "अवैध आहे",
        "less_than": "%{count} पेक्षा कमी असणे आवश्यक",
        "less_than_or_equal_to": "%{count} पेक्षा कमी किंवा समान असणे आवश्यक आहे",
        "not_a_number": "क्रमांक नाही",
        "not_an_integer": "पूर्णांक असणे आवश्यक आहे",
        "odd": "विषम संख्या असणे आवश्यक आहे",
        "other_than": "%{count} पेक्षा इतर असणे आवश्यक आहे",
        "present": "रिक्त असणे आवश्यक आहे",
        "taken": "यापूर्वीच घेतले गेले आहे",
        "too_long": {
          "one": "खूप लांब आहे (जास्तीत जास्त एक वर्ण परवानगी आहे)",
          "other": "खूप लांब आहे (जास्तीत जास्त %{count} वर्ण परवानगी आहे)"
        },
        "too_short": {
          "one": "खूप लहान आहे (किमान एक वर्ण परवानगी आहे)",
          "other": "खूप लहान आहे (किमान %{count} वर्ण परवानगी आहे)"
        },
        "wrong_length": {
          "one": "लांबी चुक आहे (एक वर्ण असणे आवश्यक आहे)",
          "other": "लांबी चुक आहे (%{count} वर्ण असणे आवश्यक आहे)"
        }
      },
      "template": {
        "body": "खालील फील्ड सह समस्या होते:",
        "header": {
          "one": "एक चूक ह्या %{model} ला जतन करण्यापासून प्रतिबंधित करत आहे",
          "other": "%{count} चुका ह्या %{model} ला जतन करण्यापासून प्रतिबंधित करत आहे"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "कृपया निवडा"
      },
      "submit": {
        "create": "%{model} निर्माण करा",
        "submit": "%{model} जतन करा",
        "update": "%{model} अद्यतनित करा"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "अब्ज",
            "million": "दशलक्ष",
            "quadrillion": "एकावर १५ शून्य इतकी संख्या",
            "thousand": "हजार",
            "trillion": "एकावर १२ शून्ये इतकी संख्या",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", आणि ",
        "two_words_connector": " आणि ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "म.पू.",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "म.नं."
    }
  },
  "ms": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Pengesahan dihantar ke",
          "confirmation_token": "Token pengesahan",
          "confirmed_at": "Disahkan pada",
          "created_at": "Dicipta pada",
          "current_password": "Kata laluan kini",
          "current_sign_in_at": "Kini log masuk pada",
          "current_sign_in_ip": "IP log masuk kini",
          "email": "E-mel",
          "encrypted_password": "Kata laluan tersulit",
          "failed_attempts": "Percubaan gagal",
          "last_sign_in_at": "Log masuk terakhir pada",
          "last_sign_in_ip": "IP log masuk terakhir",
          "locked_at": "Dikunci pada",
          "password": "Kata laluan",
          "password_confirmation": "Pengesahan kata laluan",
          "remember_created_at": "Ingat dicipta pada",
          "remember_me": "Ingat saya",
          "reset_password_sent_at": "Kata laluan set semula dihantar pada",
          "reset_password_token": "Token kata laluan set semula",
          "sign_in_count": "Kiraan log masuk",
          "unconfirmed_email": "E-mel yang belum sah",
          "unlock_token": "Buka token",
          "updated_at": "Dikemaskinikan pada"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Pengesahan gagal: %{errors}"
        }
      },
      "models": {
        "user": {
          "other": "User"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mac",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ogo",
        "Sep",
        "Okt",
        "Nov",
        "Dis"
      ],
      "day_names": [
        "Ahad",
        "Isnin",
        "Selasa",
        "Rabu",
        "Khamis",
        "Jumaat",
        "Sabtu"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Januari",
        "Febuari",
        "Mac",
        "April",
        "Mei",
        "Jun",
        "Julai",
        "Ogos",
        "September",
        "Oktober",
        "November",
        "Disember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "lebih kurang %{count} jam",
          "other": "lebih kurang %{count} jam"
        },
        "about_x_months": {
          "one": "lebih kurang %{count} bulan",
          "other": "lebih kurang %{count} bulan"
        },
        "about_x_years": {
          "one": "lebih kurang %{count} tahun",
          "other": "lebih kurang %{count} tahun"
        },
        "almost_x_years": {
          "one": "hampir %{count} tahun",
          "other": "hampir %{count} tahun"
        },
        "half_a_minute": "setengah minit",
        "less_than_x_minutes": {
          "one": "kurang dari satu minit",
          "other": "kurang dari %{count} minit"
        },
        "less_than_x_seconds": {
          "one": "kurang dari satu saat",
          "other": "kurang dari %{count} saat"
        },
        "over_x_years": {
          "one": "lebih %{count} tahun",
          "other": "lebih %{count} tahun"
        },
        "x_days": {
          "one": "%{count} hari",
          "other": "%{count} hari"
        },
        "x_minutes": {
          "one": "%{count} minit",
          "other": "%{count} minit"
        },
        "x_months": {
          "one": "%{count} bulan",
          "other": "%{count} bulan"
        },
        "x_seconds": {
          "one": "%{count} saat",
          "other": "%{count} saat"
        }
      },
      "prompts": {
        "day": "Hari",
        "hour": "Jam",
        "minute": "Minit",
        "month": "Bulan",
        "second": "Saat",
        "year": "Tahun"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Alamat e-mel anda telah berjaya disahkan.",
        "new": {
          "resend_confirmation_instructions": "Hantar semula pengesahan arahan"
        },
        "send_instructions": "Anda akan menerima e-mel dengan arahan untuk bagaimana untuk mengesahkan alamat e-mel anda dalam beberapa minit.",
        "send_paranoid_instructions": "Jika emel anda wujud di dalam pangkalan data kami, anda akan menerima e-mel dengan arahan untuk bagaimana mengesahkan alamat e-mel anda dalam beberapa minit."
      },
      "failure": {
        "already_authenticated": "Anda telah log masuk.",
        "inactive": "Akaun anda belum diaktifkan lagi.",
        "invalid": null,
        "last_attempt": "Anda ada satu lagi percubaan sebelum akaun anda dikunci.",
        "locked": "Akaun anda telah dikunci.",
        "not_found_in_database": null,
        "timeout": "Sesi anda telah tamat. Sila log masuk lagi untuk meneruskan.",
        "unauthenticated": "Anda perlu log masuk atau daftar sebelum meneruskan.",
        "unconfirmed": "Anda perlu mengesahkan alamat e-mel anda sebelum meneruskan."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Sahkan akaun saya",
          "greeting": "Selamat datang %{recipient}!",
          "instruction": "Anda boleh mengesahkan akaun e-mel anda melalui pautan di bawah:",
          "subject": "Arahan pengesahan"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Helo %{recipient}!",
          "message": "Kami sedang menghubungi anda untuk memberitahu anda bahawa kata laluan anda telah ditukar.",
          "subject": "Kata Laluan Ditukar"
        },
        "reset_password_instructions": {
          "action": "Tukar kata laluan saya",
          "greeting": "Helo %{recipient}!",
          "instruction": "Seseorang telah meminta sebuah pautan untuk menukar kata laluan anda dan anda boleh melakukannya melalui pautan di bawah.",
          "instruction_2": "Jika anda tidak meminta ini, sila abaikan e-mel ini.",
          "instruction_3": "Kata laluan anda tidak akan ditukar sehingga anda mengakses pautan di atas dan membuat yang baru.",
          "subject": "Arahan kata laluan set semula"
        },
        "unlock_instructions": {
          "action": "Buka akaun saya",
          "greeting": "Helo %{recipient}!",
          "instruction": "Klik pautan di bawah untuk membuka akaun anda:",
          "message": "Akaun anda telah dikunci disebabkan terlalu banyak kegagalan percubaan log masuk.",
          "subject": "Arahan membuka"
        }
      },
      "omniauth_callbacks": {
        "failure": "Tidak dapat mengesahkan anda daripada %{kind} kerana \"%{reason}\".",
        "success": "Berjaya mengesahkan daripada akaun %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Tukar kata laluan saya",
          "change_your_password": "Tukar kata laluan anda",
          "confirm_new_password": "Sahkan kata laluan baru",
          "new_password": "Kata laluan baru"
        },
        "new": {
          "forgot_your_password": "Lupa kata laluan anda?",
          "send_me_reset_password_instructions": "Hantar saya arahan kata laluan set semula"
        },
        "no_token": "Anda tidak boleh mengakses halaman ini tanpa didatangi daripada e-mel kata laluan set semula. Jika anda datang daripada e-mel kata laluan set semula, sila pastikan anda telah menggunakan URL penuh yang diberikan.",
        "send_instructions": "Anda akan menerima sebuah e-mel dengan arahan mengenai bagaimana untuk menetapkan semula kata laluan anda dalam beberapa minit.",
        "send_paranoid_instructions": "Jika alamat e-mel anda wujud di dalam pangkalan data kami, anda akan menerima sebuah pemulihan kata laluan di alamat e-mel anda dalam beberapa minit.",
        "updated": "Kata laluan anda telah berjaya ditukar. Anda kini telah log masuk.",
        "updated_not_active": "Kata laluan anda telah berjaya ditukar"
      },
      "registrations": {
        "destroyed": "Selamat tinggal! Akaun anda telah berjaya dibatalkan. Kami berharap untuk berjumpa dengan anda lagi.",
        "edit": {
          "are_you_sure": "Adakah anda pasti?",
          "cancel_my_account": "Batalkan akaun saya",
          "currently_waiting_confirmation_for_email": "Kini menunggu pengesahan untuk: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "tinggalkan kosong jika anda tidak ingin untuk mengubahnya",
          "title": "Edit %{resource}",
          "unhappy": "Tidak Gembira?",
          "update": "Kemas Kini",
          "we_need_your_current_password_to_confirm_your_changes": "kami memerlukan kata laluan anda yang kini untuk mengesahkan perubahan anda"
        },
        "new": {
          "sign_up": "Daftar"
        },
        "signed_up": "Selamat datang! Anda telah berjaya mendaftar.",
        "signed_up_but_inactive": "Anda telah berjaya mendaftar. Namun, kami tidak dapat melog masuk anda kerana akaun anda belum diaktifkan.",
        "signed_up_but_locked": "Anda telah berjaya mendaftar. Namun, kami tidak dapat melog masuk anda kerana akaun anda telah dikunci.",
        "signed_up_but_unconfirmed": "Sebuah mesej dengan pautan pengesahan telah dihantar ke alamat e-mel anda. Sila ikuti pautan tersebut untuk mengaktifkan akaun anda.",
        "update_needs_confirmation": "Anda telah mengemas kini akaun anda dengan berjaya, tetapi kami perlu mengesahkan alamat e-mel anda yang baharu. Sila periksa e-mel anda dan ikuti pautan pengesahan untuk mengesahkan alamat e-mel anda yang baharu.",
        "updated": "Akaun anda telah berjaya dikemaskinikan.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Berjaya dilog keluar.",
        "new": {
          "sign_in": "Log masuk"
        },
        "signed_in": "Berjaya dilog masuk.",
        "signed_out": "Berjaya dilog keluar."
      },
      "shared": {
        "links": {
          "back": "Kembali",
          "didn_t_receive_confirmation_instructions": "Tidak mendapat arahan pengesahan?",
          "didn_t_receive_unlock_instructions": "Tidak mendapat arahan membuka akaun?",
          "forgot_your_password": "Lupa kata laluan anda?",
          "sign_in": "Log masuk",
          "sign_in_with_provider": "Log masuk dengan %{provider}",
          "sign_up": "Daftar"
        },
        "minimum_password_length": {
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Hantar semula arahan buka akaun"
        },
        "send_instructions": "Anda akan menerima sebuah e-mel dengan arahan untuk bagaimana untuk membuka akaun anda dalam beberapa minit.",
        "send_paranoid_instructions": "Jika akaun anda wujud, anda akan menerima sebuah e-mel dengan arahan untuk bagaimana untuk membukanya dalam beberapa minit.",
        "unlocked": "Akaun anda telah berjaya dibuka. Sila log masuk untuk meneruskan."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "wajib diterima",
        "already_confirmed": "telah disahkan, sila cuba untuk log masuk",
        "blank": "tidak boleh dikosongkan",
        "confirmation": "tidak sama dengan penegasan",
        "confirmation_period_expired": "perlu disahkan dalam %{period}, sila minta yang baharu",
        "empty": "tidak boleh dikosongkan",
        "equal_to": "mesti sama dengan %{count}",
        "even": "mesti genap",
        "exclusion": "telah terpelihara",
        "expired": "telah tamat, sila minta yang baharu",
        "greater_than": "mesti lebih dari %{count}",
        "greater_than_or_equal_to": "mesti melibihi atau sama dengan %{count}",
        "inclusion": "tidak termasuk dalam senarai",
        "invalid": "adalah tidak laku",
        "less_than": "mesti kurang daripada %{count}",
        "less_than_or_equal_to": "mesti kurang daripada atat sama dengan %{count}",
        "not_a_number": "bukan nombor",
        "not_an_integer": "mestilah integer",
        "not_found": "tidak dijumpai",
        "not_locked": "tidak dikunci",
        "not_saved": {
          "other": "%{count} ralat telah melarang %{resource} daripada disimpan:"
        },
        "odd": "mesti ganjil",
        "taken": "telah digunakan",
        "too_long": {
          "one": "terlalu panjang (maksima adalah %{count} karakter)",
          "other": "terlalu panjang (maksima adalah %{count} karakter)"
        },
        "too_short": {
          "one": "terlalu pendek (minima adalah %{count} karakter)",
          "other": "terlalu pendek (minima adalah %{count} karakter)"
        },
        "wrong_length": {
          "one": "mempunyai panjang yang salah (sepatutnya %{count} karakter sahaja)",
          "other": "mempunyai panjang yang salah(sepatutnya %{count} karakter sahaja)"
        }
      },
      "template": {
        "body": "Terdapat masalah dengan medan data tersebut:",
        "header": {
          "one": "%{count} ralat menhalang  %{model} ini dari disimpan",
          "other": "%{count} ralat menhalang %{model} ini dari disimpan"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Sila pilih"
      },
      "submit": {
        "create": "Cipta %{model}",
        "submit": "Simpan %{model}",
        "update": "Kemaskini %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "RM"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Ribu Juta",
            "million": "Juta",
            "quadrillion": "Juta-juta",
            "thousand": "Ribu",
            "trillion": "Trilion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Bait",
              "other": "Bait"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", dan ",
        "two_words_connector": " dan ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "nb": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bekreftelse sendt",
          "confirmation_token": "Bekreftelseskode",
          "confirmed_at": "Bekreftet",
          "created_at": "Opprettet",
          "current_password": "Gjeldende passord",
          "current_sign_in_at": "Innlogget siden",
          "current_sign_in_ip": "Innlogget fra IP",
          "email": "E-post",
          "encrypted_password": "Kryptert passord",
          "failed_attempts": "Mislykkede forsøk",
          "last_sign_in_at": "Sist innlogget",
          "last_sign_in_ip": "Sist innlogget fra IP",
          "locked_at": "Låst",
          "password": "Passord",
          "password_confirmation": "Gjenta passordet",
          "remember_created_at": "Husk meg opprettet den",
          "remember_me": "Husk meg",
          "reset_password_sent_at": "Passordgjennoppretting sendt",
          "reset_password_token": "Nytt passord-kode",
          "sign_in_count": "Antall innlogginger",
          "unconfirmed_email": "Ubekreftet epost",
          "unlock_token": "Lås opp-kode",
          "updated_at": "Oppdatert den"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Det oppstod feil: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan ikke slette registreringen, fordi %{record} avhenger av denne.",
            "has_one": "Kan ikke slette registreringen, fordi %{record} avhenger av denne."
          }
        }
      },
      "models": {
        "user": {
          "one": "Brukerkonto",
          "other": "Brukerkonto"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "søn",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "lør"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "mai",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "des"
      ],
      "day_names": [
        "søndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lørdag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "rundt %{count} time",
          "other": "rundt %{count} timer"
        },
        "about_x_months": {
          "one": "rundt %{count} måned",
          "other": "rundt %{count} måneder"
        },
        "about_x_years": {
          "one": "rundt %{count} år",
          "other": "rundt %{count} år"
        },
        "almost_x_years": {
          "one": "nesten %{count} år",
          "other": "nesten %{count} år"
        },
        "half_a_minute": "et halvt minutt",
        "less_than_x_minutes": {
          "one": "mindre enn %{count} minutt",
          "other": "mindre enn %{count} minutter"
        },
        "less_than_x_seconds": {
          "one": "mindre enn %{count} sekund",
          "other": "mindre enn %{count} sekunder"
        },
        "over_x_years": {
          "one": "over %{count} år",
          "other": "over %{count} år"
        },
        "x_days": {
          "one": "%{count} dag",
          "other": "%{count} dager"
        },
        "x_minutes": {
          "one": "%{count} minutt",
          "other": "%{count} minutter"
        },
        "x_months": {
          "one": "%{count} måned",
          "other": "%{count} måneder"
        },
        "x_seconds": {
          "one": "%{count} sekund",
          "other": "%{count} sekunder"
        },
        "x_years": {
          "one": "%{count} år",
          "other": "%{count} år"
        }
      },
      "prompts": {
        "day": "dag",
        "hour": "time",
        "minute": "minutt",
        "month": "måned",
        "second": "sekund",
        "year": "år"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Din konto har blitt aktivert og du er nå logget inn",
        "new": {
          "resend_confirmation_instructions": "Send bekreftelsesinstruksjoner på nytt"
        },
        "send_instructions": "Du vil snart motta en epost med instruksjoner for å aktivere din konto.",
        "send_paranoid_instructions": "Om vi har din e-post allerede vil du om få minutter motta en e-post med instruksjoner for å bekrefte kontoen."
      },
      "failure": {
        "already_authenticated": "Du er allerede innlogget.",
        "inactive": "Din konto er ikke aktivert.",
        "invalid": "Ugyldig %{authentication_keys} eller passord.",
        "last_attempt": "Du har ett forsøk til før din konto blir sperret.",
        "locked": "Din konto er sperret.",
        "not_found_in_database": "Ugyldig %{authentication_keys} eller passord.",
        "timeout": "Din sesjon er utløpt. Logg inn igjen for å gå videre.",
        "unauthenticated": "Du må logge inn eller registrere deg for å gå videre.",
        "unconfirmed": "Du må bekrefte kontoen din for å kunne fortsette."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Aktiver min konto",
          "greeting": "Velkommen %{recipient}!",
          "instruction": "Du kan aktivere din konto ved å trykke på lenken nedenfor.",
          "subject": "Bekreftelsesinstruksjoner"
        },
        "email_changed": {
          "greeting": "Hei! %{recipient}!",
          "message": "Vi kontakter deg for å varsle at e-post adressen din har blitt endret til %{email}.",
          "message_unconfirmed": "Vi kontakter deg for å informere om at din epost er endret til %{email}",
          "subject": "E-post adressen din ble endret"
        },
        "password_change": {
          "greeting": "Hei %{recipient}!",
          "message": "Vi ønsker å melde fra om at ditt passord har blitt forandret.",
          "subject": "Passordbytte"
        },
        "reset_password_instructions": {
          "action": "Bytt passord",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Noen har bedt om en link for å endre passordet ditt, og dette kan gjøres på lenken under.",
          "instruction_2": "Vennligst se bort fra denne e-posten hvis du ikke ba om dette.",
          "instruction_3": "Passordet ditt endres ikke før du følger linken over og velger et nytt passord.",
          "subject": "Instruksjoner for å tilbakestille passordet"
        },
        "unlock_instructions": {
          "action": "Gjenåpne min konto",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Trykk på linken under for å gjenåpne din konto.",
          "message": "Kontoen din har blitt sperret grunnet et høyt antall mislykkede innloggingsforsøk.",
          "subject": "Gjenåpning av konto"
        }
      },
      "omniauth_callbacks": {
        "failure": "Kunne ikke autorisere deg fra %{kind} fordi \"%{reason}\".",
        "success": "Vellykket autorisering fra %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Endre mitt passord",
          "change_your_password": "Endre ditt passord",
          "confirm_new_password": "Bekreft nytt passord",
          "new_password": "Nytt passord"
        },
        "new": {
          "forgot_your_password": "Har du glemt passordet?",
          "send_me_reset_password_instructions": "Send instrukser for å tilbakestille passordet"
        },
        "no_token": "For å få tilgang til denne siden må du ha fått en epost om å tilbakestille passordet. Hvis det er tilfelle, sørg for at hele lenken blir brukt.",
        "send_instructions": "Du vil snart motta en epost med instruksjoner for å tilbakestille passordet ditt.",
        "send_paranoid_instructions": "Hvis e-postadressen allerede finnes hos oss, vil du motta en lenke for å sette passordet på nytt",
        "updated": "Ditt passord er endret og du er nå innlogget.",
        "updated_not_active": "Passordet er endret."
      },
      "registrations": {
        "destroyed": "Takk for laget. Din konto er nå slettet.",
        "edit": {
          "are_you_sure": "Er du sikker?",
          "cancel_my_account": "Slett min konto",
          "currently_waiting_confirmation_for_email": "Vi avventer bekreftelse for %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "la være tomt hvis du ikke ønsker å endre dette",
          "title": "Rediger %{resource}",
          "unhappy": "Misfornøyd?",
          "update": "Lagre",
          "we_need_your_current_password_to_confirm_your_changes": "vi trenger ditt nåværende passord for å bekrefte endringene"
        },
        "new": {
          "sign_up": "Registrering"
        },
        "signed_up": "Velkommen! Din registrering er vellykket.",
        "signed_up_but_inactive": "Du er nå registrert. Men vi kan ikke logge deg inn før kontoen blir aktivert.",
        "signed_up_but_locked": "Du er nå registrert. Men vi kan ikke logge deg inn fordi kontoen er sperret.",
        "signed_up_but_unconfirmed": "En bekreftelsesmelding er sendt til e-postadressen. Vennligst åpne lenken for å aktivere kontoen.",
        "update_needs_confirmation": "Brukerkontoen er nå oppdatert, men vi må bekrefte den nye e-postadressen. Vennligst sjekk din e-post og klikk på lenken for å bekrefte din nye e-postadresse.",
        "updated": "Din brukerkonto er oppdatert.",
        "updated_but_not_signed_in": "Kontoen din har blitt oppdatert, på grunn av passord endring må du logge inn på nytt."
      },
      "sessions": {
        "already_signed_out": "Du er nå logget ut.",
        "new": {
          "sign_in": "Logg inn"
        },
        "signed_in": "Du er nå innlogget.",
        "signed_out": "Du er nå logget ut."
      },
      "shared": {
        "links": {
          "back": "Tilbake",
          "didn_t_receive_confirmation_instructions": "Har du ikke mottatt bekreftelsesinstruksjoner?",
          "didn_t_receive_unlock_instructions": "Har du ikke mottatt instruksjoner for å tilbakestille passordet?",
          "forgot_your_password": "Har du glemt passordet ditt?",
          "sign_in": "Logg inn",
          "sign_in_with_provider": "Logg inn med %{provider}",
          "sign_up": "Registrering"
        },
        "minimum_password_length": {
          "one": "(Minimum %{count} tegn)",
          "other": "(Minimum %{count} tegn)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Send instrukser for gjenåpning av konto på nytt"
        },
        "send_instructions": "Du vil snart motta en epost med instruksjon for å gjenåpne din konto.",
        "send_paranoid_instructions": "Hvis kontoen eksisterer, vil du om få minutter motta en e-post med instruksjoner om hvordan du låser opp den.",
        "unlocked": "Din konto er gjenåpnet og du er nå innlogget."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "må være akseptert",
        "already_confirmed": "har allerede blitt bekreftet. Prøv å logge inn.",
        "blank": "kan ikke være tom",
        "confirmation": "er ikke lik %{attribute}",
        "confirmation_period_expired": "må bekreftes innen %{period}, vennligst be om et nytt",
        "empty": "kan ikke være tom",
        "equal_to": "må være lik %{count}",
        "even": "må være partall",
        "exclusion": "er reservert",
        "expired": "har utløpt, vennligst forespør en ny",
        "greater_than": "må være større enn %{count}",
        "greater_than_or_equal_to": "må være større enn eller lik %{count}",
        "inclusion": "er ikke inkludert i listen",
        "invalid": "er ugyldig",
        "less_than": "må være mindre enn %{count}",
        "less_than_or_equal_to": "må være mindre enn eller lik %{count}",
        "model_invalid": "Det oppstod feil: %{errors}",
        "not_a_number": "er ikke et tall",
        "not_an_integer": "er ikke et heltall",
        "not_found": "ikke funnet",
        "not_locked": "var ikke sperret",
        "not_saved": {
          "one": "En feil gjorde at %{resource} ikke kunne lagres:",
          "other": "%{count} feil gjorde at %{resource} ikke kunne lagres:"
        },
        "odd": "må være oddetall",
        "other_than": "kan ikke være nøyaktig %{count}",
        "present": "må være tom",
        "required": "må eksistere",
        "taken": "er allerede i bruk",
        "too_long": {
          "one": "er for lang (maksimalt %{count} tegn)",
          "other": "er for lang (maksimalt %{count} tegn)"
        },
        "too_short": {
          "one": "er for kort (minst %{count} tegn)",
          "other": "er for kort (minst %{count} tegn)"
        },
        "wrong_length": {
          "one": "har feil lengde (må være %{count} tegn)",
          "other": "har feil lengde (må være %{count} tegn)"
        }
      },
      "template": {
        "body": "Det oppstod problemer med følgende felt:",
        "header": {
          "one": "Kunne ikke lagre %{model} på grunn av én feil.",
          "other": "Kunne ikke lagre %{model} på grunn av %{count} feil."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Vennligst velg"
      },
      "submit": {
        "create": "Lag %{model}",
        "submit": "Lagre %{model}",
        "update": "Oppdater %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "kr"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": true
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "milliard",
              "other": "milliarder"
            },
            "million": {
              "one": "million",
              "other": "millioner"
            },
            "quadrillion": {
              "one": "billiard",
              "other": "billiarder"
            },
            "thousand": "tusen",
            "trillion": {
              "one": "billion",
              "other": "billioner"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": " ",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "kB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " og ",
        "two_words_connector": " og ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %e. %B %Y, %H:%M",
        "long": "%A, %e. %B %Y, %H:%M",
        "short": "%e. %B, %H:%M"
      },
      "pm": "pm"
    }
  },
  "nb-NO": {
    "faker": {
      "address": {
        "building_number": [
          "#",
          "##"
        ],
        "city": [
          "#{city_root}#{city_suffix}"
        ],
        "city_root": [
          "Fet",
          "Gjes",
          "Høy",
          "Inn",
          "Fager",
          "Lille",
          "Lo",
          "Mal",
          "Nord",
          "Nær",
          "Sand",
          "Sme",
          "Stav",
          "Stor",
          "Tand",
          "Ut",
          "Vest"
        ],
        "city_suffix": [
          "berg",
          "borg",
          "by",
          "bø",
          "dal",
          "eid",
          "fjell",
          "fjord",
          "foss",
          "grunn",
          "hamn",
          "havn",
          "helle",
          "mark",
          "nes",
          "odden",
          "sand",
          "sjøen",
          "stad",
          "strand",
          "strøm",
          "sund",
          "vik",
          "vær",
          "våg",
          "ø",
          "øy",
          "ås"
        ],
        "common_street_suffix": [
          "sgate",
          "svei",
          "s Gate",
          "s Vei",
          "gata",
          "veien"
        ],
        "default_country": [
          "Norge"
        ],
        "default_country_code": [
          "NO"
        ],
        "postcode": [
          "####",
          "####",
          "####",
          "0###"
        ],
        "secondary_address": [
          "Leil. ###",
          "Oppgang A",
          "Oppgang B"
        ],
        "state": [
          "Østfold",
          "Akershus",
          "Oslo",
          "Hedmark",
          "Oppland",
          "Buskerud",
          "Vestfold",
          "Telemark",
          "Aust-Agder",
          "Vest-Agder",
          "Rogaland",
          "Hordaland",
          "Sogn og Fjordane",
          "Møre og Romsdal",
          "Sør-Trøndelag",
          "Nord-Trøndelag",
          "Nordland",
          "Troms",
          "Finnmark",
          "Svalbard"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_root}#{street_suffix}",
          "#{street_prefix} #{street_root}#{street_suffix}",
          "#{Name.first_name}#{common_street_suffix}",
          "#{Name.last_name}#{common_street_suffix}"
        ],
        "street_prefix": [
          "Øvre",
          "Nedre",
          "Søndre",
          "Gamle",
          "Østre",
          "Vestre"
        ],
        "street_root": [
          "Eike",
          "Bjørke",
          "Gran",
          "Vass",
          "Furu",
          "Litj",
          "Lille",
          "Høy",
          "Fosse",
          "Elve",
          "Ku",
          "Konvall",
          "Soldugg",
          "Hestemyr",
          "Granitt",
          "Hegge",
          "Rogne",
          "Fiol",
          "Sol",
          "Ting",
          "Malm",
          "Klokker",
          "Preste",
          "Dam",
          "Geiterygg",
          "Bekke",
          "Berg",
          "Kirke",
          "Kors",
          "Bru",
          "Blåveis",
          "Torg",
          "Sjø"
        ],
        "street_suffix": [
          "alléen",
          "bakken",
          "berget",
          "bråten",
          "eggen",
          "engen",
          "ekra",
          "faret",
          "flata",
          "gata",
          "gjerdet",
          "grenda",
          "gropa",
          "hagen",
          "haugen",
          "havna",
          "holtet",
          "høgda",
          "jordet",
          "kollen",
          "kroken",
          "lia",
          "lunden",
          "lyngen",
          "løkka",
          "marka",
          "moen",
          "myra",
          "plassen",
          "ringen",
          "roa",
          "røa",
          "skogen",
          "skrenten",
          "spranget",
          "stien",
          "stranda",
          "stubben",
          "stykket",
          "svingen",
          "tjernet",
          "toppen",
          "tunet",
          "vollen",
          "vika",
          "åsen"
        ]
      },
      "cell_phone": {
        "formats": [
          "########",
          "## ## ## ##",
          "### ## ###",
          "## ## ## ##"
        ]
      },
      "company": {
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} og #{Name.last_name}"
        ],
        "suffix": [
          "Gruppen",
          "AS",
          "ASA",
          "BA",
          "RFH",
          "og Sønner"
        ]
      },
      "internet": {
        "domain_suffix": [
          "no",
          "com",
          "net",
          "org"
        ]
      },
      "name": {
        "female_first_name": [
          "Emma",
          "Sara",
          "Thea",
          "Ida",
          "Julie",
          "Nora",
          "Emilie",
          "Ingrid",
          "Hanna",
          "Maria",
          "Sofie",
          "Anna",
          "Malin",
          "Amalie",
          "Vilde",
          "Frida",
          "Andrea",
          "Tuva",
          "Victoria",
          "Mia",
          "Karoline",
          "Mathilde",
          "Martine",
          "Linnea",
          "Marte",
          "Hedda",
          "Marie",
          "Helene",
          "Silje",
          "Leah",
          "Maja",
          "Elise",
          "Oda",
          "Kristine",
          "Aurora",
          "Kaja",
          "Camilla",
          "Mari",
          "Maren",
          "Mina",
          "Selma",
          "Jenny",
          "Celine",
          "Eline",
          "Sunniva",
          "Natalie",
          "Tiril",
          "Synne",
          "Sandra",
          "Madeleine"
        ],
        "first_name": [
          "Emma",
          "Sara",
          "Thea",
          "Ida",
          "Julie",
          "Nora",
          "Emilie",
          "Ingrid",
          "Hanna",
          "Maria",
          "Sofie",
          "Anna",
          "Malin",
          "Amalie",
          "Vilde",
          "Frida",
          "Andrea",
          "Tuva",
          "Victoria",
          "Mia",
          "Karoline",
          "Mathilde",
          "Martine",
          "Linnea",
          "Marte",
          "Hedda",
          "Marie",
          "Helene",
          "Silje",
          "Leah",
          "Maja",
          "Elise",
          "Oda",
          "Kristine",
          "Aurora",
          "Kaja",
          "Camilla",
          "Mari",
          "Maren",
          "Mina",
          "Selma",
          "Jenny",
          "Celine",
          "Eline",
          "Sunniva",
          "Natalie",
          "Tiril",
          "Synne",
          "Sandra",
          "Madeleine",
          "Markus",
          "Mathias",
          "Kristian",
          "Jonas",
          "Andreas",
          "Alexander",
          "Martin",
          "Sander",
          "Daniel",
          "Magnus",
          "Henrik",
          "Tobias",
          "Kristoffer",
          "Emil",
          "Adrian",
          "Sebastian",
          "Marius",
          "Elias",
          "Fredrik",
          "Thomas",
          "Sondre",
          "Benjamin",
          "Jakob",
          "Oliver",
          "Lucas",
          "Oskar",
          "Nikolai",
          "Filip",
          "Mats",
          "William",
          "Erik",
          "Simen",
          "Ole",
          "Eirik",
          "Isak",
          "Kasper",
          "Noah",
          "Lars",
          "Joakim",
          "Johannes",
          "Håkon",
          "Sindre",
          "Jørgen",
          "Herman",
          "Anders",
          "Jonathan",
          "Even",
          "Theodor",
          "Mikkel",
          "Aksel"
        ],
        "last_name": [
          "Johansen",
          "Hansen",
          "Andersen",
          "Kristiansen",
          "Larsen",
          "Olsen",
          "Solberg",
          "Andresen",
          "Pedersen",
          "Nilsen",
          "Berg",
          "Halvorsen",
          "Karlsen",
          "Svendsen",
          "Jensen",
          "Haugen",
          "Martinsen",
          "Eriksen",
          "Sørensen",
          "Johnsen",
          "Myhrer",
          "Johannessen",
          "Nielsen",
          "Hagen",
          "Pettersen",
          "Bakke",
          "Skuterud",
          "Løken",
          "Gundersen",
          "Strand",
          "Jørgensen",
          "Kvarme",
          "Røed",
          "Sæther",
          "Stensrud",
          "Moe",
          "Kristoffersen",
          "Jakobsen",
          "Holm",
          "Aas",
          "Lie",
          "Moen",
          "Andreassen",
          "Vedvik",
          "Nguyen",
          "Jacobsen",
          "Torgersen",
          "Ruud",
          "Krogh",
          "Christiansen",
          "Bjerke",
          "Aalerud",
          "Borge",
          "Sørlie",
          "Berge",
          "Østli",
          "Ødegård",
          "Torp",
          "Henriksen",
          "Haukelidsæter",
          "Fjeld",
          "Danielsen",
          "Aasen",
          "Fredriksen",
          "Dahl",
          "Berntsen",
          "Arnesen",
          "Wold",
          "Thoresen",
          "Solheim",
          "Skoglund",
          "Bakken",
          "Amundsen",
          "Solli",
          "Smogeli",
          "Kristensen",
          "Glosli",
          "Fossum",
          "Evensen",
          "Eide",
          "Carlsen",
          "Østby",
          "Vegge",
          "Tangen",
          "Smedsrud",
          "Olstad",
          "Lunde",
          "Kleven",
          "Huseby",
          "Bjørnstad",
          "Ryan",
          "Rasmussen",
          "Nygård",
          "Nordskaug",
          "Nordby",
          "Mathisen",
          "Hopland",
          "Gran",
          "Finstad",
          "Edvardsen"
        ],
        "male_first_name": [
          "Markus",
          "Mathias",
          "Kristian",
          "Jonas",
          "Andreas",
          "Alexander",
          "Martin",
          "Sander",
          "Daniel",
          "Magnus",
          "Henrik",
          "Tobias",
          "Kristoffer",
          "Emil",
          "Adrian",
          "Sebastian",
          "Marius",
          "Elias",
          "Fredrik",
          "Thomas",
          "Sondre",
          "Benjamin",
          "Jakob",
          "Oliver",
          "Lucas",
          "Oskar",
          "Nikolai",
          "Filip",
          "Mats",
          "William",
          "Erik",
          "Simen",
          "Ole",
          "Eirik",
          "Isak",
          "Kasper",
          "Noah",
          "Lars",
          "Joakim",
          "Johannes",
          "Håkon",
          "Sindre",
          "Jørgen",
          "Herman",
          "Anders",
          "Jonathan",
          "Even",
          "Theodor",
          "Mikkel",
          "Aksel"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name} #{suffix}",
          "#{female_first_name} #{female_first_name} #{last_name}",
          "#{male_first_name} #{male_first_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Dr.",
          "Prof."
        ],
        "suffix": [
          "Jr.",
          "Sr.",
          "I",
          "II",
          "III",
          "IV",
          "V"
        ]
      },
      "phone_number": {
        "country_code": [
          "47"
        ],
        "formats": [
          "########",
          "## ## ## ##",
          "### ## ###",
          "## ## ## ##"
        ]
      }
    }
  },
  "ne": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "मान्य भएन: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "रेकर्ड मेटाउन सक्दैन किनभने धेरै निर्भर %{record} अवस्थित छन",
            "has_one": "रेकर्ड मेटाउन सक्दैन किनभने एउटा निर्भर %{record} अवस्थित छ"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "आईत",
        "सोम",
        "मंगल",
        "बुध",
        "बिही",
        "शुक्र",
        "शनि"
      ],
      "abbr_month_names": [
        null,
        "जन.",
        "फेब्रु.",
        "मार्च",
        "अप्रिल",
        "मई",
        "जुन",
        "जुलाई",
        "अगष्ट",
        "सेप्ट.",
        "अक्टो.",
        "नोभ.",
        "डिसे."
      ],
      "day_names": [
        "आईतबार",
        "सोमबार",
        "मंगलबार",
        "बुधबार",
        "बिहीबार",
        "शुक्रबार",
        "शनिबार"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "जनवरी",
        "फेब्रुवरी",
        "मार्च",
        "अप्रिल",
        "मई",
        "जुन",
        "जुलाई",
        "अगष्ट",
        "सेप्टेम्बार",
        "अक्टोबर",
        "नोभेम्बर",
        "डिसेम्बर"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "लगभग %{count} घण्टा",
          "other": "लगभग %{count} घण्टा"
        },
        "about_x_months": {
          "one": "लगभग %{count} महिना",
          "other": "लगभग %{count} महिना"
        },
        "about_x_years": {
          "one": "लगभग %{count} बर्ष",
          "other": "लगभग %{count} बर्ष"
        },
        "almost_x_years": {
          "one": "झण्डै %{count} बर्ष",
          "other": "झण्डै %{count} बर्ष"
        },
        "half_a_minute": "आधा मिनेट",
        "less_than_x_minutes": {
          "one": "%{count} मिनेटभन्दा कम्ति",
          "other": "%{count} मिनेटभन्दा कम्ति"
        },
        "less_than_x_seconds": {
          "one": "%{count} सेकेण्डभन्दा कम्ति",
          "other": "%{count} सेकेण्डभन्दा कम्ति"
        },
        "over_x_years": {
          "one": "%{count} बर्षभन्दा बढी",
          "other": "%{count} बर्षभन्दा बेसी"
        },
        "x_days": {
          "one": "%{count} दिन",
          "other": "%{count} दिन"
        },
        "x_minutes": {
          "one": "%{count} मिनेट",
          "other": "%{count} मिनेट"
        },
        "x_months": {
          "one": "%{count} महिना",
          "other": "%{count} महिना"
        },
        "x_seconds": {
          "one": "%{count} सेकेण्ड",
          "other": "%{count} सेकेण्ड"
        }
      },
      "prompts": {
        "day": "दिन",
        "hour": "घण्टा",
        "minute": "मिनेट",
        "month": "महिना",
        "second": "सेकेण्ड",
        "year": "बर्ष"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "स्वीकार गरिनुपर्नेछ",
        "blank": "खाली हुन सक्दैन",
        "confirmation": "पुष्टिकरणसँग मेल खाँदैन",
        "empty": "रित्तो हुन सक्दैन",
        "equal_to": "%{count} सँग बराबर हुनुपर्नेछ",
        "even": "जोर संख्या हुनुपर्नेछ",
        "exclusion": "प्रयोगको लागी संरक्षित छ",
        "greater_than": "%{count} भन्दा बेसी हुनुपर्नेछ",
        "greater_than_or_equal_to": "%{count} सँग बराबर अथवा बेसी हुनुपर्नेछ",
        "inclusion": "सुचीमा सामेल गरिएको छैन",
        "invalid": "अमान्य छ",
        "less_than": "%{count} भन्दा कम हुनुपर्नेछ",
        "less_than_or_equal_to": "%{count} सँग बराबर अथवा कम हुनुपर्नेछ",
        "not_a_number": "अंक होईन",
        "not_an_integer": "पुर्णाकं हुनुपर्नेछ",
        "odd": "बिजोर संख्या हुनुपर्नेछ",
        "taken": "पहिल्यै प्रयोग गरीएको छ",
        "too_long": {
          "one": "धेरै लामो छ (अधिक्तम %{count} character हो)",
          "other": "धेरै लामो छ (अधिक्तम %{count} characters हो)"
        },
        "too_short": {
          "one": "धेरै छोटो छ (न्युनत्तम %{count} character हो)",
          "other": "धेरै छोटो छ (न्युनत्तम %{count} characters हो)"
        },
        "wrong_length": {
          "one": "गलत लम्बाई हो (%{count} character हुनुपर्नेछ)",
          "other": "गलत लम्बाई हो (%{count} characters हुनुपर्नेछ)"
        }
      },
      "template": {
        "body": "त्यहाँ निम्न क्षेत्रहरुमा समस्या देखियो:",
        "header": {
          "one": "%{count} गल्तीले यस %{model} लाई सुरक्षित गर्नबाट रोक्यो",
          "other": "%{count} गल्तीले यस %{model} लाई सुरक्षित गर्नबाट रोक्यो"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "कृपया छान्नुहोस्"
      },
      "submit": {
        "create": "नयाँ %{model} बनाउ",
        "submit": "%{model} सुरक्षित गर",
        "update": "%{model} सामयिक बनाउ"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "रू"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "अर्ब",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "हजार",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "जि.बी.",
            "kb": "के.बी.",
            "mb": "एम.बी",
            "tb": "टि.बी"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", र ",
        "two_words_connector": " र ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "बिहान",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "बेलुका"
    }
  },
  "nl": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bevestiging verstuurd op",
          "confirmation_token": "Bevestigingstoken",
          "confirmed_at": "Bevestigd op",
          "created_at": "Aangemaakt op",
          "current_password": "Huidig wachtwoord",
          "current_sign_in_at": "Huidige login op",
          "current_sign_in_ip": "Huidige login IP",
          "email": "E-mailadres",
          "encrypted_password": "Versleuteld wachtwoord",
          "failed_attempts": "Mislukte pogingen",
          "last_sign_in_at": "Laatste login op",
          "last_sign_in_ip": "Laatste login IP",
          "locked_at": "Vergrendeld op",
          "password": "Wachtwoord",
          "password_confirmation": "Bevestig wachtwoord",
          "remember_created_at": "Herinneren aangemaakt op",
          "remember_me": "Ingelogd blijven",
          "reset_password_sent_at": "Reset wachtwoord verstuurd op",
          "reset_password_token": "Reset wachtwoord token",
          "sign_in_count": "Aantal logins",
          "unconfirmed_email": "Onbevestigd e-mailadres",
          "unlock_token": "Ontgrendel token",
          "updated_at": "Bijgewerkt op"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validatie mislukt: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan item niet verwijderen omdat afhankelijke %{record} bestaan",
            "has_one": "Kan item niet verwijderen omdat %{record} afhankelijk is"
          }
        }
      },
      "models": {
        "user": {
          "one": "Gebruiker",
          "other": "Gebruikers"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mrt",
        "apr",
        "mei",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ongeveer een uur",
          "other": "ongeveer %{count} uur"
        },
        "about_x_months": {
          "one": "ongeveer een maand",
          "other": "ongeveer %{count} maanden"
        },
        "about_x_years": {
          "one": "ongeveer een jaar",
          "other": "ongeveer %{count} jaar"
        },
        "almost_x_years": {
          "one": "bijna een jaar",
          "other": "bijna %{count} jaar"
        },
        "half_a_minute": "een halve minuut",
        "less_than_x_minutes": {
          "one": "minder dan een minuut",
          "other": "minder dan %{count} minuten"
        },
        "less_than_x_seconds": {
          "one": "minder dan een seconde",
          "other": "minder dan %{count} seconden"
        },
        "over_x_years": {
          "one": "meer dan een jaar",
          "other": "meer dan %{count} jaar"
        },
        "x_days": {
          "one": "%{count} dag",
          "other": "%{count} dagen"
        },
        "x_minutes": {
          "one": "%{count} minuut",
          "other": "%{count} minuten"
        },
        "x_months": {
          "one": "%{count} maand",
          "other": "%{count} maanden"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} seconden"
        },
        "x_years": {
          "one": "%{count} jaar",
          "other": "%{count} jaar"
        }
      },
      "prompts": {
        "day": "dag",
        "hour": "uur",
        "minute": "minuut",
        "month": "maand",
        "second": "seconde",
        "year": "jaar"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Je account is bevestigd.",
        "new": {
          "resend_confirmation_instructions": "Verstuur bevestiging-instructies opnieuw"
        },
        "send_instructions": "Je ontvangt via e-mail instructies hoe je je account kan bevestigen.",
        "send_paranoid_instructions": "Als we je e-mailadres terugvinden in onze database, zal je binnen enkele ogenblikken een e-mail ontvangen met instructies hoe je je account kan bevestigen."
      },
      "failure": {
        "already_authenticated": "Je bent reeds aangemeld.",
        "inactive": "Je account is nog niet geactiveerd.",
        "invalid": "Ongeldig %{authentication_keys} of wachtwoord.",
        "invited": "U bent reeds uitgenodigd, accepteer de uitnodiging die u heeft ontvangen per mail om uw account te accepteren.",
        "last_attempt": "Je hebt nog één poging voordat je account vergrendeld wordt.",
        "locked": "Je account is vergrendeld.",
        "not_found_in_database": "Ongeldig %{authentication_keys} of wachtwoord.",
        "timeout": "Je sessie is verlopen, meld je opnieuw aan om door te gaan.",
        "unauthenticated": "Je dient je aan te melden of in te schrijven om door te gaan.",
        "unconfirmed": "Je dient eerst je account te bevestigen."
      },
      "invitations": {
        "edit": {
          "header": "Stel Uw wachtwoord in",
          "submit_button": "Stel mijn wachtwoord in"
        },
        "invitation_removed": "Uw uitnodiging is verwijderd.",
        "invitation_token_invalid": "De uitnodigingscode is ongeldig!",
        "new": {
          "header": "Verstuur uitnodiging",
          "submit_button": "Verstuur een uitnodiging"
        },
        "no_invitations_remaining": "Geen uitnodigingen over.",
        "send_instructions": "Een uitnodigingsmail aan %{email} is verstuurd.",
        "updated": "Uw wachtwoord is ingesteld. U bent nu ingelogd.",
        "updated_not_active": "Uw wachtwoord is ingesteld."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bevestig mijn account",
          "greeting": "Welkom %{recipient}!",
          "instruction": "Je kunt je e-mailadres bevestigen via onderstaande link:",
          "subject": "Bevestiging"
        },
        "email_changed": {
          "greeting": "Beste %{recipient}!",
          "message": "Het e-mailadres van uw account is gewijzigd in %{email}.",
          "message_unconfirmed": "We nemen contact op om je te laten weten dat je emailadres is gewijzigd naar %{email}.",
          "subject": "E-mailadres veranderd"
        },
        "invitation_instructions": {
          "accept": "Accepteer uitnodiging",
          "accept_until": "Deze uitnodoging vervalt per %{due_date}.",
          "hello": "Beste %{email}",
          "ignore": "Indien U de uitnodiging niet wenst te accepteren, negeer dan alstublieft deze email.<br />\nUw account wordt niet aangemaakt indien U niet via bovenstaande link uw wachtwoord aanmaakt.",
          "someone_invited_you": "Iemand heeft U uitgenodigd voor %{url}, U kunt de uitnodiging accepteren via onderstaande link.",
          "subject": "Instructies voor uitnodigingen"
        },
        "password_change": {
          "greeting": "Hallo %{recipient}!",
          "message": "We stellen je met deze e-mail ervan op de hoogte dat je wachtwoord is gewijzigd.",
          "subject": "Je wachtwoord is gewijzigd"
        },
        "reset_password_instructions": {
          "action": "Verander mijn wachtwoord",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Iemand heeft een link gevraagd om uw wachtwoord te wijzigen; dit kan via onderstaande link.",
          "instruction_2": "Als je dit niet zelf hebt gevraagd, negeer deze mail dan alsjeblieft.",
          "instruction_3": "Je wachtwoord zal niet wijzigen totdat je bovenstaande link hebt gevolgd en een nieuw wachtwoord hebt aangemaakt.",
          "subject": "Instructies om je wachtwoord opnieuw in te stellen"
        },
        "unlock_instructions": {
          "action": "Ontgrendel mijn account",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Je kunt je account ontgrendelen via onderstaande link:",
          "message": "Je account is vergrendeld door te veel mislukte pogingen om in te loggen.",
          "subject": "Ontgrendelinstructies"
        }
      },
      "omniauth_callbacks": {
        "failure": "We konden je niet aanmelden op je %{kind} omdat \"%{reason}\".",
        "success": "Je bent succesvol ingelogd op je %{kind} account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Verander mijn wachtwoord",
          "change_your_password": "Wijzig je wachtwoord",
          "confirm_new_password": "Bevestig nieuw wachtwoord",
          "new_password": "Nieuw wachtwoord"
        },
        "new": {
          "forgot_your_password": "Wachtwoord vergeten?",
          "send_me_reset_password_instructions": "Stuur me wachtwoord reset instructies"
        },
        "no_token": "Deze pagina is alleen bereikbaar via een wachtwoord vergeten e-mail. Als je wel via een wachtwoord vergeten e-mail komt, zorg er dan voor dat je de volledige URL gebruikt.",
        "send_instructions": "Je ontvangt een e-mail met instructies hoe je je wachtwoord opnieuw kan instellen.",
        "send_paranoid_instructions": "Als we je e-mailadres terugvinden in onze database, zal je binnen enkele ogenblikken via e-mail een link ontvangen om je wachtwoord opnieuw in te stellen.",
        "updated": "Je wachtwoord is gewijzigd. Je bent nu aangemeld.",
        "updated_not_active": "Je wachtwoord is met succes gewijzigd."
      },
      "registrations": {
        "destroyed": "Je account is verwijderd, wellicht tot ziens!",
        "edit": {
          "are_you_sure": "Weet je het zeker?",
          "cancel_my_account": "Annuleer mijn account",
          "currently_waiting_confirmation_for_email": "Aan het wachten op de bevestiging voor: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "laat leeg als je het niet wilt wijzigen",
          "title": "Bewerk %{resource}",
          "unhappy": "Niet blij",
          "update": "Bijwerken",
          "we_need_your_current_password_to_confirm_your_changes": "we hebben je huidige wachtwoord nodig om je veranderingen te bevestigen"
        },
        "new": {
          "sign_up": "Maak account aan"
        },
        "signed_up": "Je bent ingeschreven.",
        "signed_up_but_inactive": "Je bent ingeschreven, maar we konden je niet inloggen omdat je account nog niet is geactiveerd.",
        "signed_up_but_locked": "Je bent ingeschreven, maar we konden je niet inloggen omdat je account is vergrendeld.",
        "signed_up_but_unconfirmed": "Een e-mail met een confirmatielink is naar je e-mailadres gestuurd. Open de link in je browser om je account te activeren.",
        "update_needs_confirmation": "Je account is bijgewerkt, maar we moeten je e-mailadres nog valideren. Een e-mail met een confirmatielink is naar je e-mailadres gestuurd. Open de link in je browser om je e-mailadres te confirmeren.",
        "updated": "Je accountgegevens zijn opgeslagen.",
        "updated_but_not_signed_in": "Je account is succesvol bijgewerkt, maar omdat je wachtwoord is aangepast moet je opnieuw inloggen."
      },
      "sessions": {
        "already_signed_out": "Je bent succesvol uitgelogd.",
        "new": {
          "sign_in": "Inloggen"
        },
        "signed_in": "Je bent succesvol ingelogd.",
        "signed_out": "Je bent succesvol uitgelogd."
      },
      "shared": {
        "links": {
          "back": "Terug",
          "didn_t_receive_confirmation_instructions": "Geen bevestigingsmail ontvangen?",
          "didn_t_receive_unlock_instructions": "Geen ontgrendel-instructies ontvangen?",
          "forgot_your_password": "Wachtwoord vergeten?",
          "sign_in": "Inloggen",
          "sign_in_with_provider": "Inloggen met %{provider}",
          "sign_up": "Maak account aan"
        },
        "minimum_password_length": {
          "one": "(minimaal %{count} karakter)",
          "other": "(minimaal %{count} karakters)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Verstuur ontgrendel-instructies opnieuw"
        },
        "send_instructions": "Je ontvangt via e-mail instructies hoe je je account kan ontgrendelen.",
        "send_paranoid_instructions": "Als we je e-mailadres terugvinden in onze database, zal je binnen enkele ogenblikken een e-mail ontvangen met instructies hoe je je account kan ontgrendelen.",
        "unlocked": "Je account is ontgrendeld. Je kan nu weer inloggen."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Redirect naar '%{redirect_url}' niet toegestaan."
      },
      "passwords": {
        "missing_email": "Je moet een e-mailadres opgeven.",
        "missing_passwords": "De velden 'Wachtwoord' en 'Wachtwoord bevestiging' zijn verplicht.",
        "missing_redirect_url": "Redirect URL ontbreekt.",
        "not_allowed_redirect_url": "Redirect naar '%{redirect_url}' niet toegestaan.",
        "password_not_required": "Voor dit account is geen wachtwoord nodig. Log in met uw '%{provider}' account.",
        "sended": "Er is een e-mail naar '%{email}' verstuurd met instructies om uw wachtwoord te resetten.",
        "successfully_updated": "Uw wachtwoord is aangepast.",
        "user_not_found": "Kan gebruiker met e-mail '%{email}' niet vinden."
      },
      "registrations": {
        "account_to_destroy_not_found": "Te verwijderen account niet gevonden.",
        "account_with_uid_destroyed": "Account met id '%{uid}' is verwijderd.",
        "email_already_exists": "Er bestaat al een account voor het adres '%{email}'",
        "missing_confirm_success_url": "Parameter 'confirm_success_url' ontbreekt.",
        "redirect_url_not_allowed": "Redirect naar '%{redirect_url}' niet toegestaan.",
        "user_not_found": "Gebruiker niet gevonden."
      },
      "sessions": {
        "bad_credentials": "Ongeldige logingegevens.",
        "not_confirmed": "Een bevestingsmail is verzonden naar het adres '%{email}'. Volg de instructies in de mail om uw account te activeren.",
        "not_supported": "Gebruik POST /sign_in om in te loggen. GET wordt niet ondersteund.",
        "user_not_found": "Gebruiker is niet gevonden of niet ingelogd."
      },
      "token_validations": {
        "invalid": "Ongeldige logingegevens."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "moet worden geaccepteerd",
        "already_confirmed": "is reeds bevestigd",
        "blank": "moet opgegeven zijn",
        "confirmation": "komt niet overeen met %{attribute}",
        "confirmation_period_expired": "moet binnen %{period} worden bevestigd, plaats a.u.b. een nieuw verzoek",
        "empty": "moet opgegeven zijn",
        "equal_to": "moet gelijk zijn aan %{count}",
        "even": "moet even zijn",
        "exclusion": "is gereserveerd",
        "expired": "is verlopen, vraag een nieuwe aan",
        "greater_than": "moet groter zijn dan %{count}",
        "greater_than_or_equal_to": "moet groter dan of gelijk zijn aan %{count}",
        "inclusion": "is niet in de lijst opgenomen",
        "invalid": "is ongeldig",
        "less_than": "moet minder zijn dan %{count}",
        "less_than_or_equal_to": "moet minder dan of gelijk zijn aan %{count}",
        "model_invalid": "Validatie mislukt: %{errors}",
        "not_a_number": "is geen getal",
        "not_an_integer": "moet een geheel getal zijn",
        "not_email": "is geen geldig e-emailadres",
        "not_found": "niet gevonden",
        "not_locked": "is niet gesloten",
        "not_saved": {
          "one": "Een fout verhinderde het opslaan van deze %{resource}:",
          "other": "%{count} fouten verhinderde het opslaan van deze %{resource}:"
        },
        "odd": "moet oneven zijn",
        "other_than": "moet anders zijn dan %{count}",
        "present": "moet leeg zijn",
        "required": "moet bestaan",
        "taken": "is al in gebruik",
        "too_long": {
          "one": "is te lang (maximaal %{count} teken)",
          "other": "is te lang (maximaal %{count} tekens)"
        },
        "too_short": {
          "one": "is te kort (minimaal %{count} teken)",
          "other": "is te kort (minimaal %{count} tekens)"
        },
        "validate_account_update_params": "Gegevens voor updaten van het account zijn niet geldig.",
        "validate_sign_up_params": "Gegevens voor aanmaken van het account zijn niet geldig.",
        "wrong_length": {
          "one": "heeft onjuiste lengte (moet %{count} teken lang zijn)",
          "other": "heeft onjuiste lengte (moet %{count} tekens lang zijn)"
        }
      },
      "template": {
        "body": "Er zijn problemen met de volgende velden:",
        "header": {
          "one": "%{model} niet opgeslagen: %{count} fout gevonden",
          "other": "%{model} niet opgeslagen: %{count} fouten gevonden"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#",
          "##",
          "###",
          "###a",
          "###b",
          "###c",
          "### I",
          "### II",
          "### III"
        ],
        "city": [
          "#{Name.first_name}#{city_suffix}",
          "#{Name.last_name}#{city_suffix}",
          "#{city_prefix} #{Name.first_name}#{city_suffix}",
          "#{city_prefix} #{Name.last_name}#{city_suffix}"
        ],
        "city_prefix": [
          "Noord",
          "Oost",
          "West",
          "Zuid",
          "Nieuw",
          "Oud"
        ],
        "city_suffix": [
          "dam",
          "berg",
          " aan de Rijn",
          " aan de IJssel",
          "swaerd",
          "endrecht",
          "recht",
          "ambacht",
          "enmaes",
          "wijk",
          "sland",
          "stroom",
          "sluus",
          "dijk",
          "dorp",
          "burg",
          "veld",
          "sluis",
          "koop",
          "lek",
          "hout",
          "geest",
          "kerk",
          "woude",
          "hoven",
          "hoten",
          "ingen",
          "plas",
          "meer"
        ],
        "country": [
          "Afghanistan",
          "Akrotiri",
          "Albanië",
          "Algerije",
          "Amerikaanse Maagdeneilanden",
          "Amerikaans-Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarctica",
          "Antigua en Barbuda",
          "Noordelijke IJszee",
          "Argentinië",
          "Armenië",
          "Aruba",
          "Ashmore- en Cartiereilanden",
          "Atlantische Oceaan",
          "Australië",
          "Azerbeidzjan",
          "Bahama's",
          "Bahrein",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "België",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivië",
          "Bosnië-Herzegovina",
          "Botswana",
          "Bouveteiland",
          "Brazilië",
          "Brits Indische Oceaanterritorium",
          "Britse Maagdeneilanden",
          "Brunei",
          "Bulgarije",
          "Burkina Faso",
          "Burundi",
          "Cambodja",
          "Canada",
          "Caymaneilanden",
          "Centraal-Afrikaanse Republiek",
          "Chili",
          "China",
          "Christmaseiland",
          "Clipperton",
          "Cocoseilanden",
          "Colombia",
          "Comoren (Unie)",
          "Congo (Democratische Republiek)",
          "Congo (Volksrepubliek)",
          "Cook",
          "Coral Sea Islands",
          "Costa Rica",
          "Cuba",
          "Cyprus",
          "Denemarken",
          "Dhekelia",
          "Djibouti",
          "Dominica",
          "Dominicaanse Republiek",
          "Duitsland",
          "Ecuador",
          "Egypte",
          "El Salvador",
          "Equatoriaal-Guinea",
          "Eritrea",
          "Estland",
          "Ethiopië",
          "Europese Unie",
          "Falkland",
          "Faeröer",
          "Fiji",
          "Filipijnen",
          "Finland",
          "Frankrijk",
          "Frans-Polynesië",
          "Franse Zuidelijke en Antarctische Gebieden",
          "Gabon",
          "Gambia",
          "Gaza Strip",
          "Georgië",
          "Ghana",
          "Gibraltar",
          "Grenada",
          "Griekenland",
          "Groenland",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinee-Bissau",
          "Guyana",
          "Haïti",
          "Heard en McDonaldeilanden",
          "Heilige Stoel",
          "Honduras",
          "Hongarije",
          "Hongkong",
          "Ierland",
          "IJsland",
          "India",
          "Indian Ocean",
          "Indonesië",
          "Irak",
          "Iran",
          "Isle of Man",
          "Israël",
          "Italië",
          "Ivoorkust",
          "Jamaica",
          "Jan Mayen",
          "Japan",
          "Jemen",
          "Jersey",
          "Jordanië",
          "Kaapverdië",
          "Kameroen",
          "Kazachstan",
          "Kenia",
          "Kirgizstan",
          "Kiribati",
          "Koeweit",
          "Kroatië",
          "Laos",
          "Lesotho",
          "Letland",
          "Libanon",
          "Liberia",
          "Libië",
          "Liechtenstein",
          "Litouwen",
          "Luxemburg",
          "Macao",
          "Macedonië",
          "Madagaskar",
          "Malawi",
          "Maldiven",
          "Maleisië",
          "Mali",
          "Malta",
          "Marokko",
          "Marshalleilanden",
          "Mauritanië",
          "Mauritius",
          "Mayotte",
          "Mexico",
          "Micronesia, Federale Staten van",
          "Moldavië",
          "Monaco",
          "Mongolië",
          "Montenegro",
          "Montserrat",
          "Mozambique",
          "Myanmar",
          "Namibië",
          "Nauru",
          "Navassa",
          "Nederland",
          "Nederlandse Antillen",
          "Nepal",
          "Ngwane",
          "Nicaragua",
          "Nieuw-Caledonië",
          "Nieuw-Zeeland",
          "Niger",
          "Nigeria",
          "Niue",
          "Noordelijke Marianen",
          "Noord-Korea",
          "Noorwegen",
          "Norfolk (eiland)",
          "Oekraïne",
          "Oezbekistan",
          "Oman",
          "Oostenrijk",
          "Grote Oceaan",
          "Pakistan",
          "Palau",
          "Panama",
          "Papoea-Nieuw-Guinea",
          "Paracel Islands",
          "Paraguay",
          "Peru",
          "Pitcairn",
          "Polen",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Roemenië",
          "Rusland",
          "Rwanda",
          "Saint Helena",
          "Saint Lucia",
          "Saint Vincent en de Grenadines",
          "Saint-Pierre en Miquelon",
          "Salomon",
          "Samoa",
          "San Marino",
          "São Tomé en Principe",
          "Saudi-Arabië",
          "Senegal",
          "Servië",
          "Seychellen",
          "Sierra Leone",
          "Singapore",
          "Sint-Kitts en Nevis",
          "Slovenië",
          "Slowakije",
          "Soedan",
          "Somalië",
          "South Georgia and the South Sandwich Islands",
          "Zuidelijke Oceaan",
          "Spanje",
          "Spratly Islands",
          "Sri Lanka",
          "Suriname",
          "Svalbard",
          "Syrië",
          "Tadzjikistan",
          "Taiwan",
          "Tanzania",
          "Thailand",
          "Timor Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad en Tobago",
          "Tsjaad",
          "Tsjechië",
          "Tunesië",
          "Turkije",
          "Turkmenistan",
          "Turks-en Caicoseilanden",
          "Tuvalu",
          "Uganda",
          "Uruguay",
          "Vanuatu",
          "Venezuela",
          "Verenigd Koninkrijk",
          "Verenigde Arabische Emiraten",
          "Verenigde Staten van Amerika",
          "Vietnam",
          "Wake (eiland)",
          "Wallis en Futuna",
          "Wereld",
          "Westelijke Jordaanoever",
          "Westelijke Sahara",
          "Zambia",
          "Zimbabwe",
          "Zuid-Afrika",
          "Zuid-Korea",
          "Zweden",
          "Zwitserland"
        ],
        "default_country": [
          "Nederland"
        ],
        "default_country_code": [
          "NL"
        ],
        "postcode": "/[1-9][0-9]{3} (AA|AB|AC|AD|AE|AF|AG|AH|AI|AJ|AK|AL|AM|AN|AO|AP|AQ|AR|AS|AT|AU|AV|AW|AX|AY|AZ|BA|BB|BC|BD|BE|BF|BG|BH|BI|BJ|BK|BL|BM|BN|BO|BP|BQ|BR|BS|BT|BU|BV|BW|BX|BY|BZ|CA|CB|CC|CD|CE|CF|CG|CH|CI|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|CV|CW|CX|CY|CZ|DA|DB|DC|DD|DE|DF|DG|DH|DI|DJ|DK|DL|DM|DN|DO|DP|DQ|DR|DS|DT|DU|DV|DW|DX|DY|DZ|EA|EB|EC|ED|EE|EF|EG|EH|EI|EJ|EK|EL|EM|EN|EO|EP|EQ|ER|ES|ET|EU|EV|EW|EX|EY|EZ|FA|FB|FC|FD|FE|FF|FG|FH|FI|FJ|FK|FL|FM|FN|FO|FP|FQ|FR|FS|FT|FU|FV|FW|FX|FY|FZ|GA|GB|GC|GD|GE|GF|GG|GH|GI|GJ|GK|GL|GM|GN|GO|GP|GQ|GR|GS|GT|GU|GV|GW|GX|GY|GZ|HA|HB|HC|HD|HE|HF|HG|HH|HI|HJ|HK|HL|HM|HN|HO|HP|HQ|HR|HS|HT|HU|HV|HW|HX|HY|HZ|IA|IB|IC|ID|IE|IF|IG|IH|II|IJ|IK|IL|IM|IN|IO|IP|IQ|IR|IS|IT|IU|IV|IW|IX|IY|IZ|JA|JB|JC|JD|JE|JF|JG|JH|JI|JJ|JK|JL|JM|JN|JO|JP|JQ|JR|JS|JT|JU|JV|JW|JX|JY|JZ|KA|KB|KC|KD|KE|KF|KG|KH|KI|KJ|KK|KL|KM|KN|KO|KP|KQ|KR|KS|KT|KU|KV|KW|KX|KY|KZ|LA|LB|LC|LD|LE|LF|LG|LH|LI|LJ|LK|LL|LM|LN|LO|LP|LQ|LR|LS|LT|LU|LV|LW|LX|LY|LZ|MA|MB|MC|MD|ME|MF|MG|MH|MI|MJ|MK|ML|MM|MN|MO|MP|MQ|MR|MS|MT|MU|MV|MW|MX|MY|MZ|NA|NB|NC|ND|NE|NF|NG|NH|NI|NJ|NK|NL|NM|NN|NO|NP|NQ|NR|NS|NT|NU|NV|NW|NX|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OI|OJ|OK|OL|OM|ON|OO|OP|OQ|OR|OS|OT|OU|OV|OW|OX|OY|OZ|PA|PB|PC|PD|PE|PF|PG|PH|PI|PJ|PK|PL|PM|PN|PO|PP|PQ|PR|PS|PT|PU|PV|PW|PX|PY|PZ|QA|QB|QC|QD|QE|QF|QG|QH|QI|QJ|QK|QL|QM|QN|QO|QP|QQ|QR|QS|QT|QU|QV|QW|QX|QY|QZ|RA|RB|RC|RD|RE|RF|RG|RH|RI|RJ|RK|RL|RM|RN|RO|RP|RQ|RR|RS|RT|RU|RV|RW|RX|RY|RZ|SB|SC|SE|SF|SG|SH|SI|SJ|SK|SL|SM|SN|SO|SP|SQ|SR|ST|SU|SV|SW|SX|SY|SZ|TA|TB|TC|TD|TE|TF|TG|TH|TI|TJ|TK|TL|TM|TN|TO|TP|TQ|TR|TS|TT|TU|TV|TW|TX|TY|TZ|UA|UB|UC|UD|UE|UF|UG|UH|UI|UJ|UK|UL|UM|UN|UO|UP|UQ|UR|US|UT|UU|UV|UW|UX|UY|UZ|VA|VB|VC|VD|VE|VF|VG|VH|VI|VJ|VK|VL|VM|VN|VO|VP|VQ|VR|VS|VT|VU|VV|VW|VX|VY|VZ|WA|WB|WC|WD|WE|WF|WG|WH|WI|WJ|WK|WL|WM|WN|WO|WP|WQ|WR|WS|WT|WU|WV|WW|WX|WY|WZ|XA|XB|XC|XD|XE|XF|XG|XH|XI|XJ|XK|XL|XM|XN|XO|XP|XQ|XR|XS|XT|XU|XV|XW|XX|XY|XZ|YA|YB|YC|YD|YE|YF|YG|YH|YI|YJ|YK|YL|YM|YN|YO|YP|YQ|YR|YS|YT|YU|YV|YW|YX|YY|YZ|ZA|ZB|ZC|ZD|ZE|ZF|ZG|ZH|ZI|ZJ|ZK|ZL|ZM|ZN|ZO|ZP|ZQ|ZR|ZS|ZT|ZU|ZV|ZW|ZX|ZY|ZZ)/",
        "secondary_address": [
          "1 hoog",
          "2 hoog",
          "3 hoog"
        ],
        "state": [
          "Noord-Holland",
          "Zuid-Holland",
          "Utrecht",
          "Zeeland",
          "Overijssel",
          "Gelderland",
          "Drenthe",
          "Friesland",
          "Groningen",
          "Noord-Brabant",
          "Limburg"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{Name.first_name}#{street_suffix}",
          "#{Name.last_name}#{street_suffix}"
        ],
        "street_suffix": [
          "straat",
          "laan",
          "weg",
          "plantsoen",
          "park"
        ]
      },
      "company": {
        "suffix": [
          "BV",
          "V.O.F.",
          "Group",
          "en Zonen"
        ]
      },
      "internet": {
        "domain_suffix": [
          "nl",
          "com",
          "net",
          "org"
        ]
      },
      "lorem": {
        "supplemental": [
          "abbas",
          "abduco",
          "abeo",
          "abscido",
          "absconditus",
          "absens",
          "absorbeo",
          "absque",
          "abstergo",
          "absum",
          "abundans",
          "abutor",
          "accedo",
          "accendo",
          "acceptus",
          "accipio",
          "accommodo",
          "accusator",
          "acer",
          "acerbitas",
          "acervus",
          "acidus",
          "acies",
          "acquiro",
          "acsi",
          "adamo",
          "adaugeo",
          "addo",
          "adduco",
          "ademptio",
          "adeo",
          "adeptio",
          "adfectus",
          "adfero",
          "adficio",
          "adflicto",
          "adhaero",
          "adhuc",
          "adicio",
          "adimpleo",
          "adinventitias",
          "adipiscor",
          "adiuvo",
          "administratio",
          "admiratio",
          "admitto",
          "admoneo",
          "admoveo",
          "adnuo",
          "adopto",
          "adsidue",
          "adstringo",
          "adsuesco",
          "adsum",
          "adulatio",
          "adulescens",
          "adultus",
          "aduro",
          "advenio",
          "adversus",
          "advoco",
          "aedificium",
          "aeger",
          "aegre",
          "aegrotatio",
          "aegrus",
          "aeneus",
          "aequitas",
          "aequus",
          "aer",
          "aestas",
          "aestivus",
          "aestus",
          "aetas",
          "aeternus",
          "ager",
          "aggero",
          "aggredior",
          "agnitio",
          "agnosco",
          "ago",
          "ait",
          "aiunt",
          "alienus",
          "alii",
          "alioqui",
          "aliqua",
          "alius",
          "allatus",
          "alo",
          "alter",
          "altus",
          "alveus",
          "amaritudo",
          "ambitus",
          "ambulo",
          "amicitia",
          "amiculum",
          "amissio",
          "amita",
          "amitto",
          "amo",
          "amor",
          "amoveo",
          "amplexus",
          "amplitudo",
          "amplus",
          "ancilla",
          "angelus",
          "angulus",
          "angustus",
          "animadverto",
          "animi",
          "animus",
          "annus",
          "anser",
          "ante",
          "antea",
          "antepono",
          "antiquus",
          "aperio",
          "aperte",
          "apostolus",
          "apparatus",
          "appello",
          "appono",
          "appositus",
          "approbo",
          "apto",
          "aptus",
          "apud",
          "aqua",
          "ara",
          "aranea",
          "arbitro",
          "arbor",
          "arbustum",
          "arca",
          "arceo",
          "arcesso",
          "arcus",
          "argentum",
          "argumentum",
          "arguo",
          "arma",
          "armarium",
          "armo",
          "aro",
          "ars",
          "articulus",
          "artificiose",
          "arto",
          "arx",
          "ascisco",
          "ascit",
          "asper",
          "aspicio",
          "asporto",
          "assentator",
          "astrum",
          "atavus",
          "ater",
          "atqui",
          "atrocitas",
          "atrox",
          "attero",
          "attollo",
          "attonbitus",
          "auctor",
          "auctus",
          "audacia",
          "audax",
          "audentia",
          "audeo",
          "audio",
          "auditor",
          "aufero",
          "aureus",
          "auris",
          "aurum",
          "aut",
          "autem",
          "autus",
          "auxilium",
          "avaritia",
          "avarus",
          "aveho",
          "averto",
          "avoco",
          "baiulus",
          "balbus",
          "barba",
          "bardus",
          "basium",
          "beatus",
          "bellicus",
          "bellum",
          "bene",
          "beneficium",
          "benevolentia",
          "benigne",
          "bestia",
          "bibo",
          "bis",
          "blandior",
          "bonus",
          "bos",
          "brevis",
          "cado",
          "caecus",
          "caelestis",
          "caelum",
          "calamitas",
          "calcar",
          "calco",
          "calculus",
          "callide",
          "campana",
          "candidus",
          "canis",
          "canonicus",
          "canto",
          "capillus",
          "capio",
          "capitulus",
          "capto",
          "caput",
          "carbo",
          "carcer",
          "careo",
          "caries",
          "cariosus",
          "caritas",
          "carmen",
          "carpo",
          "carus",
          "casso",
          "caste",
          "casus",
          "catena",
          "caterva",
          "cattus",
          "cauda",
          "causa",
          "caute",
          "caveo",
          "cavus",
          "cedo",
          "celebrer",
          "celer",
          "celo",
          "cena",
          "cenaculum",
          "ceno",
          "censura",
          "centum",
          "cerno",
          "cernuus",
          "certe",
          "certo",
          "certus",
          "cervus",
          "cetera",
          "charisma",
          "chirographum",
          "cibo",
          "cibus",
          "cicuta",
          "cilicium",
          "cimentarius",
          "ciminatio",
          "cinis",
          "circumvenio",
          "cito",
          "civis",
          "civitas",
          "clam",
          "clamo",
          "claro",
          "clarus",
          "claudeo",
          "claustrum",
          "clementia",
          "clibanus",
          "coadunatio",
          "coaegresco",
          "coepi",
          "coerceo",
          "cogito",
          "cognatus",
          "cognomen",
          "cogo",
          "cohaero",
          "cohibeo",
          "cohors",
          "colligo",
          "colloco",
          "collum",
          "colo",
          "color",
          "coma",
          "combibo",
          "comburo",
          "comedo",
          "comes",
          "cometes",
          "comis",
          "comitatus",
          "commemoro",
          "comminor",
          "commodo",
          "communis",
          "comparo",
          "compello",
          "complectus",
          "compono",
          "comprehendo",
          "comptus",
          "conatus",
          "concedo",
          "concido",
          "conculco",
          "condico",
          "conduco",
          "confero",
          "confido",
          "conforto",
          "confugo",
          "congregatio",
          "conicio",
          "coniecto",
          "conitor",
          "coniuratio",
          "conor",
          "conqueror",
          "conscendo",
          "conservo",
          "considero",
          "conspergo",
          "constans",
          "consuasor",
          "contabesco",
          "contego",
          "contigo",
          "contra",
          "conturbo",
          "conventus",
          "convoco",
          "copia",
          "copiose",
          "cornu",
          "corona",
          "corpus",
          "correptius",
          "corrigo",
          "corroboro",
          "corrumpo",
          "coruscus",
          "cotidie",
          "crapula",
          "cras",
          "crastinus",
          "creator",
          "creber",
          "crebro",
          "credo",
          "creo",
          "creptio",
          "crepusculum",
          "cresco",
          "creta",
          "cribro",
          "crinis",
          "cruciamentum",
          "crudelis",
          "cruentus",
          "crur",
          "crustulum",
          "crux",
          "cubicularis",
          "cubitum",
          "cubo",
          "cui",
          "cuius",
          "culpa",
          "culpo",
          "cultellus",
          "cultura",
          "cum",
          "cunabula",
          "cunae",
          "cunctatio",
          "cupiditas",
          "cupio",
          "cuppedia",
          "cupressus",
          "cur",
          "cura",
          "curatio",
          "curia",
          "curiositas",
          "curis",
          "curo",
          "curriculum",
          "currus",
          "cursim",
          "curso",
          "cursus",
          "curto",
          "curtus",
          "curvo",
          "curvus",
          "custodia",
          "damnatio",
          "damno",
          "dapifer",
          "debeo",
          "debilito",
          "decens",
          "decerno",
          "decet",
          "decimus",
          "decipio",
          "decor",
          "decretum",
          "decumbo",
          "dedecor",
          "dedico",
          "deduco",
          "defaeco",
          "defendo",
          "defero",
          "defessus",
          "defetiscor",
          "deficio",
          "defigo",
          "defleo",
          "defluo",
          "defungo",
          "degenero",
          "degero",
          "degusto",
          "deinde",
          "delectatio",
          "delego",
          "deleo",
          "delibero",
          "delicate",
          "delinquo",
          "deludo",
          "demens",
          "demergo",
          "demitto",
          "demo",
          "demonstro",
          "demoror",
          "demulceo",
          "demum",
          "denego",
          "denique",
          "dens",
          "denuncio",
          "denuo",
          "deorsum",
          "depereo",
          "depono",
          "depopulo",
          "deporto",
          "depraedor",
          "deprecator",
          "deprimo",
          "depromo",
          "depulso",
          "deputo",
          "derelinquo",
          "derideo",
          "deripio",
          "desidero",
          "desino",
          "desipio",
          "desolo",
          "desparatus",
          "despecto",
          "despirmatio",
          "infit",
          "inflammatio",
          "paens",
          "patior",
          "patria",
          "patrocinor",
          "patruus",
          "pauci",
          "paulatim",
          "pauper",
          "pax",
          "peccatus",
          "pecco",
          "pecto",
          "pectus",
          "pecunia",
          "pecus",
          "peior",
          "pel",
          "ocer",
          "socius",
          "sodalitas",
          "sol",
          "soleo",
          "solio",
          "solitudo",
          "solium",
          "sollers",
          "sollicito",
          "solum",
          "solus",
          "solutio",
          "solvo",
          "somniculosus",
          "somnus",
          "sonitus",
          "sono",
          "sophismata",
          "sopor",
          "sordeo",
          "sortitus",
          "spargo",
          "speciosus",
          "spectaculum",
          "speculum",
          "sperno",
          "spero",
          "spes",
          "spiculum",
          "spiritus",
          "spoliatio",
          "sponte",
          "stabilis",
          "statim",
          "statua",
          "stella",
          "stillicidium",
          "stipes",
          "stips",
          "sto",
          "strenuus",
          "strues",
          "studio",
          "stultus",
          "suadeo",
          "suasoria",
          "sub",
          "subito",
          "subiungo",
          "sublime",
          "subnecto",
          "subseco",
          "substantia",
          "subvenio",
          "succedo",
          "succurro",
          "sufficio",
          "suffoco",
          "suffragium",
          "suggero",
          "sui",
          "sulum",
          "sum",
          "summa",
          "summisse",
          "summopere",
          "sumo",
          "sumptus",
          "supellex",
          "super",
          "suppellex",
          "supplanto",
          "suppono",
          "supra",
          "surculus",
          "surgo",
          "sursum",
          "suscipio",
          "suspendo",
          "sustineo",
          "suus",
          "synagoga",
          "tabella",
          "tabernus",
          "tabesco",
          "tabgo",
          "tabula",
          "taceo",
          "tactus",
          "taedium",
          "talio",
          "talis",
          "talus",
          "tam",
          "tamdiu",
          "tamen",
          "tametsi",
          "tamisium",
          "tamquam",
          "tandem",
          "tantillus",
          "tantum",
          "tardus",
          "tego",
          "temeritas",
          "temperantia",
          "templum",
          "temptatio",
          "tempus",
          "tenax",
          "tendo",
          "teneo",
          "tener",
          "tenuis",
          "tenus",
          "tepesco",
          "tepidus",
          "ter",
          "terebro",
          "teres",
          "terga",
          "tergeo",
          "tergiversatio",
          "tergo",
          "tergum",
          "termes",
          "terminatio",
          "tero",
          "terra",
          "terreo",
          "territo",
          "terror",
          "tersus",
          "tertius",
          "testimonium",
          "texo",
          "textilis",
          "textor",
          "textus",
          "thalassinus",
          "theatrum",
          "theca",
          "thema",
          "theologus",
          "thermae",
          "thesaurus",
          "thesis",
          "thorax",
          "thymbra",
          "thymum",
          "tibi",
          "timidus",
          "timor",
          "titulus",
          "tolero",
          "tollo",
          "tondeo",
          "tonsor",
          "torqueo",
          "torrens",
          "tot",
          "totidem",
          "toties",
          "totus",
          "tracto",
          "trado",
          "traho",
          "trans",
          "tredecim",
          "tremo",
          "trepide",
          "tres",
          "tribuo",
          "tricesimus",
          "triduana",
          "triginta",
          "tripudio",
          "tristis",
          "triumphus",
          "trucido",
          "truculenter",
          "tubineus",
          "tui",
          "tum",
          "tumultus",
          "tunc",
          "turba",
          "turbo",
          "turpe",
          "turpis",
          "tutamen",
          "tutis",
          "tyrannus",
          "uberrime",
          "ubi",
          "ulciscor",
          "ullus",
          "ulterius",
          "ultio",
          "ultra",
          "umbra",
          "umerus",
          "umquam",
          "una",
          "unde",
          "undique",
          "universe",
          "unus",
          "urbanus",
          "urbs",
          "uredo",
          "usitas",
          "usque",
          "ustilo",
          "ustulo",
          "usus",
          "uter",
          "uterque",
          "utilis",
          "utique",
          "utor",
          "utpote",
          "utrimque",
          "utroque",
          "utrum",
          "uxor",
          "vaco",
          "vacuus",
          "vado",
          "vae",
          "valde",
          "valens",
          "valeo",
          "valetudo",
          "validus",
          "vallum",
          "vapulus",
          "varietas",
          "varius",
          "vehemens",
          "vel",
          "velociter",
          "velum",
          "velut",
          "venia",
          "venio",
          "ventito",
          "ventosus",
          "ventus",
          "venustas",
          "ver",
          "verbera",
          "verbum",
          "vere",
          "verecundia",
          "vereor",
          "vergo",
          "veritas",
          "vero",
          "versus",
          "verto",
          "verumtamen",
          "verus",
          "vesco",
          "vesica",
          "vesper",
          "vespillo",
          "vester",
          "vestigium",
          "vestrum",
          "vetus",
          "via",
          "vicinus",
          "vicissitudo",
          "victoria",
          "victus",
          "videlicet",
          "video",
          "viduata",
          "viduo",
          "vigilo",
          "vigor",
          "vilicus",
          "vilis",
          "vilitas",
          "villa",
          "vinco",
          "vinculum",
          "vindico",
          "vinitor",
          "vinum",
          "vir",
          "virga",
          "virgo",
          "viridis",
          "viriliter",
          "virtus",
          "vis",
          "viscus",
          "vita",
          "vitiosus",
          "vitium",
          "vito",
          "vivo",
          "vix",
          "vobis",
          "vociferor",
          "voco",
          "volaticus",
          "volo",
          "volubilis",
          "voluntarius",
          "volup",
          "volutabrum",
          "volva",
          "vomer",
          "vomica",
          "vomito",
          "vorago",
          "vorax",
          "voro",
          "vos",
          "votum",
          "voveo",
          "vox",
          "vulariter",
          "vulgaris",
          "vulgivagus",
          "vulgo",
          "vulgus",
          "vulnero",
          "vulnus",
          "vulpes",
          "vulticulus",
          "vultuosus",
          "xiphias"
        ],
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "name": {
        "first_name": [
          "Aad",
          "Aadje",
          "Aafke",
          "Aaik",
          "Aaldert",
          "Aale",
          "Aaliyah",
          "Aalke",
          "Aalt",
          "Aaltje",
          "Aan",
          "Aarjen",
          "Aarke",
          "Aarnout",
          "Aaron",
          "Aart",
          "Aatif",
          "Aayk",
          "Aaykie",
          "Abbas",
          "Abbe",
          "Abbey",
          "Abbo",
          "Abby",
          "Abderahmaan",
          "Abe",
          "Abel",
          "Abigail",
          "Abish",
          "Aboney",
          "Abraham",
          "Abram",
          "Abuzer",
          "Achiel",
          "Achmed",
          "Ad",
          "Ada",
          "Adaja",
          "Adam",
          "Adan",
          "Adaya",
          "Addi",
          "Addie",
          "Adeline",
          "Adger",
          "Adi",
          "Adina",
          "Adinda",
          "Adino",
          "Adiël",
          "Adjan",
          "Adjani",
          "Adne",
          "Adorée",
          "Adra",
          "Adriaan",
          "Adrian",
          "Adriana",
          "Adrianne",
          "Adrienne",
          "Adrish",
          "Adriënne",
          "Adriëtte",
          "Adwine",
          "Adája",
          "Adèle",
          "Adél",
          "Aegina",
          "Aemke",
          "Aeryn",
          "Aesa",
          "Afiah",
          "Afke",
          "Afra",
          "Afshin",
          "Agaat",
          "Age",
          "Ageline",
          "Agnes",
          "Agnese",
          "Agnita",
          "Ahlam",
          "Ahmed",
          "Aicha",
          "Aida",
          "Aidan",
          "Aideen",
          "Aiden",
          "Aiko",
          "Aileen",
          "Ailish",
          "Ailsa",
          "Aimee",
          "Aimy",
          "Aimée",
          "Aimély",
          "Ainoa",
          "Ainsley",
          "Airto",
          "Aisa",
          "Aisha",
          "Aisling",
          "Aiso",
          "Aivy",
          "Aiyana",
          "Ajolt",
          "Akash",
          "Akeesha",
          "Akira",
          "Akis",
          "Akkie",
          "Akram",
          "Aladin",
          "Alain",
          "Alan",
          "Alana",
          "Alannah",
          "Alanso",
          "Alaric",
          "Alba",
          "Alberdien",
          "Albert",
          "Albertien",
          "Albertine",
          "Albertje",
          "Alberto",
          "Albertus",
          "Albi",
          "Alde",
          "Aldert",
          "Aldin",
          "Aldwin",
          "Alec",
          "Alegandra",
          "Alegandro",
          "Aleida",
          "Alejandra",
          "Aleksandar",
          "Aleksander",
          "Aleksandra",
          "Alena",
          "Alengca",
          "Alesha",
          "Alesio",
          "Alessa",
          "Alessandro",
          "Alessia",
          "Alessio",
          "Aletha",
          "Aletta",
          "Alette",
          "Alex",
          "Alexa",
          "Alexander",
          "Alexandra",
          "Alexandre",
          "Alexandrina",
          "Alexandro",
          "Alexandros",
          "Alexi",
          "Alexia",
          "Alexine",
          "Alexis",
          "Aleyna",
          "Ali",
          "Alianne",
          "Alice",
          "Alicia",
          "Alida",
          "Alide",
          "Aliek",
          "Alieke",
          "Alien",
          "Aliena",
          "Aliene",
          "Alieneke",
          "Alies",
          "Alieske",
          "Aliki",
          "Alina",
          "Alinda",
          "Alinde",
          "Aline",
          "Alinne",
          "Alisa",
          "Alise",
          "Alisha",
          "Alisia",
          "Alison",
          "Alissa",
          "Alistair",
          "Aliséa",
          "Alix",
          "Aliya",
          "Alizé",
          "Alizée",
          "Aliëtte",
          "Alja",
          "Aljan",
          "Aljandra",
          "Aljen",
          "Aljosha",
          "Alke",
          "Alkenah",
          "Allan",
          "Allard",
          "Allart",
          "Allert",
          "Allery",
          "Allicia",
          "Allisha",
          "Allison",
          "Almar",
          "Almaz",
          "Almer",
          "Alon",
          "Alouette",
          "Aloussia",
          "Aloys",
          "Aloïse",
          "Alrik",
          "Alvian",
          "Alvin",
          "Alwin",
          "Alyanne",
          "Alycia",
          "Alyde",
          "Alyna",
          "Alyscha",
          "Alysha",
          "Alyshia",
          "Alysia",
          "Alyssa",
          "Alyssia",
          "Alyt",
          "Aléssio",
          "Amadeüs",
          "Amaish",
          "Amal",
          "Amalina",
          "Aman",
          "Amanda",
          "Amar",
          "Amarantha",
          "Amarins",
          "Amarinske",
          "Amaro",
          "Amaryl",
          "Amaury",
          "Amber",
          "Ambra",
          "Ambre",
          "Amel",
          "Amelia",
          "Amelie",
          "Amely",
          "Amenda",
          "Amenthis",
          "Amerentia",
          "Ami",
          "Amida",
          "Amieke",
          "Amilia",
          "Amin",
          "Amina",
          "Aminda",
          "Amine",
          "Amir",
          "Amira",
          "Amissa",
          "Amke",
          "Ammara",
          "Ammelita",
          "Ammon",
          "Amon",
          "Amory",
          "Amos",
          "Amrah",
          "Amrish",
          "Amrita",
          "Amy",
          "Amélie",
          "Amére",
          "An",
          "Ana",
          "Anabel",
          "Anaisa",
          "Analicia",
          "Analise",
          "Anamika",
          "Ananda",
          "Anastasia",
          "Anastasios",
          "Anatolia",
          "Anaï",
          "Anaïs",
          "Ancella",
          "Ancko",
          "Anco",
          "Andel",
          "Andjel",
          "Andor",
          "Andra",
          "Andras",
          "Andrea",
          "Andreas",
          "Andres",
          "Andress",
          "Andrew",
          "Andria",
          "Andries",
          "André",
          "Andréa",
          "Andy",
          "Ane",
          "Anemoon",
          "Anes",
          "Anette",
          "Anfred",
          "Anfry",
          "Anganita",
          "Ange",
          "Angel",
          "Angela",
          "Angelica",
          "Angelie",
          "Angeliek",
          "Angelina",
          "Angeline",
          "Angelique",
          "Angelita",
          "Angelle",
          "Angelo",
          "Angemar",
          "Angie",
          "Angreth",
          "Angél",
          "Angéla",
          "Anh",
          "Aniam",
          "Anica",
          "Anice",
          "Aniek",
          "Anieka",
          "Anieke",
          "Anies",
          "Anik",
          "Anika",
          "Anil",
          "Anine",
          "Aninka",
          "Anique",
          "Anisa",
          "Anischa",
          "Anish",
          "Anissa",
          "Anita",
          "Anitsia",
          "Aniéla",
          "Aniëlle",
          "Anja",
          "Anjali",
          "Anjemieke",
          "Anjes",
          "Anjesca",
          "Anjet",
          "Anjo",
          "Anjola",
          "Anke",
          "Ankie",
          "Ankita",
          "Anko",
          "Anky",
          "Anmara",
          "Ann",
          "Anna",
          "Annabel",
          "Annabelle",
          "Annahinke",
          "Annakumari",
          "Annaliet",
          "Annalin",
          "Annalinde",
          "Annalisa",
          "Annaloes",
          "Annamara",
          "Annamarij",
          "Annamarijn",
          "Anne",
          "Annebeau",
          "Annebel",
          "Annebeth",
          "Annebé",
          "Annechien",
          "Annechiena",
          "Annedien",
          "Annefleur",
          "Annefloor",
          "Annegonda",
          "Annegreet",
          "Annegré",
          "Annehil",
          "Annejes",
          "Annejet",
          "Anneke",
          "Annelaura",
          "Annelee",
          "Anneleen",
          "Annelein",
          "Anneli",
          "Annelie",
          "Anneliek",
          "Annelieke",
          "Annelien",
          "Annelies",
          "Annelin",
          "Anneline",
          "Annelise",
          "Annelle",
          "Annellie",
          "Anneloes",
          "Annelon",
          "Annelot",
          "Annelotte",
          "Annelou",
          "Annely",
          "Annemae",
          "Annemarelle",
          "Annemaret",
          "Annemaria",
          "Annemarie",
          "Annemarieke",
          "Annemarije",
          "Annemarijn",
          "Annemarlijn",
          "Annemart",
          "Annemay",
          "Annemee",
          "Annemeijn",
          "Annemein",
          "Annemette",
          "Annemie",
          "Annemiek",
          "Annemieke",
          "Annemijn",
          "Annemijne",
          "Annemik",
          "Anner",
          "Annerein",
          "Annerie",
          "Annerieke",
          "Annerije",
          "Anneroos",
          "Anneruth",
          "Annet",
          "Annetje",
          "Annetta",
          "Annette",
          "Annewieke",
          "Annewies",
          "Annica",
          "Annick",
          "Annicke",
          "Annie",
          "Annieck",
          "Anniek",
          "Annieke",
          "Annigje",
          "Annika",
          "Anniki",
          "Anniko",
          "Annina",
          "Anninco",
          "Annisa",
          "Annisaa",
          "Annita",
          "Anno",
          "Annoeska",
          "Annouk",
          "Annoëlle",
          "Annuschka",
          "Anné",
          "Anoek",
          "Anoeshka",
          "Anoeska",
          "Anouar",
          "Anouchka",
          "Anouck",
          "Anouk",
          "Anous",
          "Anouschka",
          "Anoushka",
          "Anouska",
          "Anoûl",
          "Ans",
          "Anse",
          "Anselm",
          "Ansje",
          "Anske",
          "Anta",
          "Antara",
          "Ante",
          "Anteun",
          "Anthe",
          "Anthia",
          "Anthonetta",
          "Anthonie",
          "Anthonio",
          "Anthony",
          "Anthoon",
          "Antigoné",
          "Antiny",
          "Antje",
          "Antoine",
          "Antoinet",
          "Antoinette",
          "Anton",
          "Antoni",
          "Antonie",
          "Antonieke",
          "Antonio",
          "Antony",
          "Antoon",
          "Antwan",
          "Anuja",
          "Anushka",
          "Anwar",
          "Anya",
          "Aphra",
          "Aplonia",
          "Appie",
          "Appolonia",
          "April",
          "Aquisha",
          "Ara",
          "Aragorn",
          "Aram",
          "Aramiz",
          "Aran",
          "Aranca",
          "Aranea",
          "Aranka",
          "Arantxa",
          "Arash",
          "Arbaya",
          "Archana",
          "Arcon",
          "Ard",
          "Arden",
          "Ardian",
          "Ardie",
          "Ardin",
          "Ardjan",
          "Ardjuna",
          "Ardon",
          "Ardy",
          "Are",
          "Areen",
          "Arend",
          "Arenda",
          "Ari",
          "Ariane",
          "Arianna",
          "Arianne",
          "Aricia",
          "Arie",
          "Arieke",
          "Arieko",
          "Ariena",
          "Aries",
          "Arik",
          "Arina",
          "Arinda",
          "Arinde",
          "Arion",
          "Arita",
          "Ariëla",
          "Ariëlle",
          "Ariën",
          "Ariënne",
          "Ariëtte",
          "Arjam",
          "Arjan",
          "Arjando",
          "Arjanne",
          "Arjanto",
          "Arjate",
          "Arjen",
          "Arjo",
          "Arjon",
          "Arjos",
          "Arjun",
          "Arjuna",
          "Arkadi",
          "Arko",
          "Arle",
          "Arlene",
          "Arletta",
          "Arlette",
          "Arlinde",
          "Arlon",
          "Arlène",
          "Arman",
          "Armance",
          "Armand",
          "Armanda",
          "Armando",
          "Armijn",
          "Armin",
          "Arminda",
          "Arn",
          "Arnand",
          "Arnando",
          "Arnaud",
          "Arne",
          "Arnelieke",
          "Arnine",
          "Arninja",
          "Arno",
          "Arnold",
          "Arnoud",
          "Arnout",
          "Arné",
          "Aroen",
          "Aron",
          "Arre",
          "Arrie",
          "Arshaad",
          "Art",
          "Artan",
          "Artho",
          "Arthur",
          "Arthy",
          "Artine",
          "Artjan",
          "Arton",
          "Arun",
          "Arunesh",
          "Aruni",
          "Arvid",
          "Arvin",
          "Arvo",
          "Arwen",
          "Arwin",
          "Arwinkumar",
          "Aryan",
          "Asaf",
          "Asha",
          "Ashley",
          "Ashlinn",
          "Ashlynn",
          "Ashna",
          "Ashraf",
          "Ashton",
          "Ashwien",
          "Ashwin",
          "Ashwita",
          "Asia",
          "Asjer",
          "Aslihan",
          "Asmar",
          "Asmara",
          "Asraf",
          "Asselien",
          "Assumpta",
          "Aster",
          "Aston",
          "Astrid",
          "Aswin",
          "Atakan",
          "Athina",
          "Athreyu",
          "Atreyu",
          "Atser",
          "Atsje",
          "Attenee",
          "Atticus",
          "Attila",
          "Atze",
          "Aubry",
          "Aude",
          "Audrey",
          "August",
          "Auke",
          "Aukje",
          "Aura",
          "Aurelia",
          "Aurelie",
          "Aurora",
          "Aurélie",
          "Austin",
          "Auwina",
          "Ava",
          "Avalon",
          "Avantika",
          "Avelien",
          "Avelineke",
          "Avelon",
          "Avinaash",
          "Avinash",
          "Avital",
          "Aviva",
          "Avner",
          "Avram",
          "Avreyl",
          "Awienaash",
          "Axel",
          "Axelle",
          "Axl",
          "Aycan",
          "Aycha",
          "Ayco",
          "Ayesha",
          "Ayla",
          "Aylan",
          "Ayleen",
          "Aylin",
          "Aymen",
          "Aymée",
          "Ayron",
          "Ayrson",
          "Ayrton",
          "Ayse",
          "Ayyoeb",
          "Azadeh",
          "Azalea",
          "Aziz",
          "Azra",
          "Azzurra",
          "Aäron",
          "Aïda",
          "Aïmane",
          "Aïmen",
          "Aïscha",
          "Aïsha",
          "B'Elanna",
          "Baarend",
          "Babbe",
          "Babet",
          "Babeth",
          "Babette",
          "Babiche",
          "Babs",
          "Bacheeva",
          "Baerke",
          "Baggio",
          "Bailey",
          "Bald",
          "Balou",
          "Bam",
          "Bambi",
          "Bandu",
          "Bandy",
          "Bapke",
          "Barbara",
          "Barbera",
          "Barberieke",
          "Bardo",
          "Bareld",
          "Barend",
          "Barendine",
          "Baris",
          "Barney",
          "Barri",
          "Barrie",
          "Barry",
          "Bart",
          "Bartel",
          "Barth",
          "Barthel",
          "Bartjan",
          "Bartske",
          "Bartu",
          "Bartus",
          "Baruch",
          "Bas",
          "Basak",
          "Baselique",
          "Bashiri",
          "Basil",
          "Basjan",
          "Bassim",
          "Basten",
          "Bastiaan",
          "Bastian",
          "Bastianne",
          "Bastien",
          "Bastiene",
          "Bastienne",
          "Bastijn",
          "Bastino",
          "Batina",
          "Batsheva",
          "Baudien",
          "Baudine",
          "Baue",
          "Bauke",
          "Baukje",
          "Bauwe",
          "Bavo",
          "Bayard",
          "Bea",
          "Beata",
          "Beate",
          "Beatrice",
          "Beatrix",
          "Beau",
          "Beaudille",
          "Beaudine",
          "Beaudé",
          "Becky",
          "Bedri",
          "Beer",
          "Beert",
          "Beirem",
          "Beja",
          "Belinda",
          "Bellamie",
          "Belle",
          "Belén",
          "Ben",
          "Benard",
          "Benaya",
          "Bender",
          "Bendix",
          "Bene",
          "Benedict",
          "Bengt",
          "Benice",
          "Benicio",
          "Benito",
          "Benjamin",
          "Benji",
          "Benjo",
          "Benn",
          "Benne",
          "Bennet",
          "Bennett",
          "Bennie",
          "Benno",
          "Benny",
          "Benoit",
          "Benoît",
          "Bent",
          "Bente",
          "Benthe",
          "Bently",
          "Bento",
          "Benyamin",
          "Berbara",
          "Berbe",
          "Berbel",
          "Berber",
          "Berdi",
          "Berdie",
          "Berdien",
          "Berdiene",
          "Berdine",
          "Berend",
          "Berendjan",
          "Berenice",
          "Bergina",
          "Berit",
          "Berith",
          "Berjan",
          "Berkay",
          "Berlinda",
          "Berlinde",
          "Bern",
          "Berna",
          "Bernadet",
          "Bernadette",
          "Bernadien",
          "Bernalt",
          "Bernar",
          "Bernard",
          "Bernd",
          "Bernette",
          "Bernice",
          "Bernie",
          "Bernies",
          "Bernike",
          "Bernitha",
          "Bernt",
          "Berra",
          "Berre",
          "Berrend",
          "Berrit",
          "Berry",
          "Bert",
          "Berta",
          "Bertan",
          "Bertha",
          "Bertie",
          "Bertina",
          "Bertine",
          "Bertje",
          "Bertram",
          "Bertrin",
          "Bertus",
          "Bertwin",
          "Besarta",
          "Beschier",
          "Beth",
          "Bethany",
          "Betina",
          "Bets",
          "Bette",
          "Bettie",
          "Betty",
          "Beyko",
          "Bhavana",
          "Bhor",
          "Bianca",
          "Bianka",
          "Bianne",
          "Biba",
          "Bibi",
          "Bibia",
          "Bibian",
          "Bibianne",
          "Biek",
          "Bieke",
          "Biem",
          "Bijke",
          "Bijou",
          "Biko",
          "Bil",
          "Bilal",
          "Bilgin",
          "Bill",
          "Billie",
          "Billy",
          "Billyjean",
          "Binck",
          "Bing",
          "Binh",
          "Binita",
          "Bink",
          "Binnie",
          "Bintine",
          "Bionda",
          "Birger",
          "Birgit",
          "Birgitta",
          "Birk",
          "Birne",
          "Birte",
          "Birthe",
          "Biscayne",
          "Bishoy",
          "Bjarn",
          "Bjarne",
          "Bjinse",
          "Bjoke",
          "Bjork",
          "Bjorn",
          "Bjoyd",
          "Björgvin",
          "Björk",
          "Björn",
          "Björne",
          "Björre",
          "Blanche",
          "Blandina",
          "Bloeme",
          "Bloesem",
          "Bloys",
          "Bo",
          "Boal",
          "Boas",
          "Boaz",
          "Bob",
          "Bobbi",
          "Bobbie",
          "Bobby",
          "Boda",
          "Bodain",
          "Bodean",
          "Bodee",
          "Bodey",
          "Bodhi",
          "Bodhie",
          "Bodi",
          "Bodien",
          "Bodil",
          "Bodile",
          "Bodine",
          "Bodyl",
          "Bodé",
          "Boet",
          "Bogdan",
          "Bojan",
          "Bojanne",
          "Bojoura",
          "Boke",
          "Boni",
          "Bonita",
          "Bonne",
          "Bonnie",
          "Bonnor",
          "Bonny",
          "Bono",
          "Booy",
          "Bori",
          "Boris",
          "Borke",
          "Borre",
          "Borren",
          "Boré",
          "Bosko",
          "Bosse",
          "Bote",
          "Bouchta",
          "Boudewijn",
          "Boudina",
          "Boudine",
          "Boudy",
          "Bouke",
          "Boukje",
          "Bouwe",
          "Bouwina",
          "Bowey",
          "Bowie",
          "Bowien",
          "Boy",
          "Boyan",
          "Boyca",
          "Boycke",
          "Boyd",
          "Boyke",
          "Bozz",
          "Boàz",
          "Boëlle",
          "Brad",
          "Bradley",
          "Brady",
          "Brahim",
          "Brain",
          "Bram",
          "Brammert",
          "Brammetje",
          "Branco",
          "Brand",
          "Branda",
          "Brandine",
          "Brandon",
          "Brandy",
          "Branko",
          "Brant",
          "Bratt",
          "Brayn",
          "Brechje",
          "Brecht",
          "Brechtje",
          "Brechtsje",
          "Breelina",
          "Breg",
          "Bregita",
          "Bregje",
          "Bregtje",
          "Brend",
          "Brenda",
          "Brendan",
          "Brende",
          "Brenden",
          "Brendie",
          "Brendon",
          "Brendt",
          "Brendy",
          "Brenice",
          "Brent",
          "Brett",
          "Breyaunne",
          "Breyten",
          "Brian",
          "Brianda",
          "Brianna",
          "Brianne",
          "Brichet",
          "Brick",
          "Bridget",
          "Brigit",
          "Brigith",
          "Brigitt",
          "Brigitta",
          "Brigitte",
          "Brit",
          "Brita",
          "Britney",
          "Britt",
          "Britta",
          "Brittany",
          "Britte",
          "Brittje",
          "Brittney",
          "Brody",
          "Broes",
          "Bronno",
          "Bronwyn",
          "Brooklyn",
          "Bror",
          "Brord",
          "Bruce",
          "Bruno",
          "Bryan",
          "Bryannah",
          "Bryanne",
          "Bryant",
          "Bryden",
          "Brynn",
          "Bryony",
          "Btissam",
          "Buck",
          "Bud",
          "Bundi",
          "Bunga",
          "Burak",
          "Burdey",
          "Butros",
          "Byorick",
          "Byoux",
          "Byron",
          "Bärbel",
          "Bélanna",
          "Bó",
          "Büsra",
          "Caan",
          "Cachella",
          "Cachèl",
          "Caddy",
          "Cadya",
          "Caelesta",
          "Caelis",
          "Cahrin",
          "Cailean",
          "Cailey",
          "Cailim",
          "Caily",
          "Caine",
          "Caisey",
          "Caithlin",
          "Caithlyn",
          "Caitlen",
          "Caitlin",
          "Caitlyn",
          "Cajo",
          "Calcey",
          "Caleb",
          "Calina",
          "Calinda",
          "Callan",
          "Calluna",
          "Callyon",
          "Calvin",
          "Camella",
          "Camelot",
          "Cameron",
          "Camiel",
          "Camilia",
          "Camilla",
          "Camille",
          "Camm",
          "Canan",
          "Candice",
          "Candida",
          "Candide",
          "Candy",
          "Caner",
          "Cansu",
          "Caramia",
          "Carel",
          "Caren",
          "Carena",
          "Caressa",
          "Carey",
          "Caricia",
          "Carien",
          "Carienne",
          "Carina",
          "Carinda",
          "Carine",
          "Carit",
          "Carl",
          "Carla",
          "Carlee",
          "Carlein",
          "Carli",
          "Carlie",
          "Carlien",
          "Carlijn",
          "Carlijne",
          "Carlinde",
          "Carline",
          "Carlissa",
          "Carlito",
          "Carlo",
          "Carlon",
          "Carlotta",
          "Carlotte",
          "Carly",
          "Carlyne",
          "Carma",
          "Carmelle",
          "Carmen",
          "Carmencita",
          "Carmenza",
          "Carmine",
          "Carmita",
          "Caro",
          "Carol",
          "Carola",
          "Carolien",
          "Carolijn",
          "Carolina",
          "Caroline",
          "Caroly",
          "Carressa",
          "Carry",
          "Cars",
          "Carsten",
          "Cartouche",
          "Carucha",
          "Cas",
          "Casey",
          "Casijn",
          "Casimir",
          "Caspar",
          "Casper",
          "Cassandra",
          "Cassey",
          "Cassian",
          "Cassy",
          "Catalina",
          "Cataline",
          "Cateline",
          "Catharina",
          "Catharinus",
          "Catheleine",
          "Cathelijn",
          "Cathelijne",
          "Catheline",
          "Catherine",
          "Cathinca",
          "Cathleen",
          "Cathlin",
          "Cathy",
          "Catinca",
          "Cato",
          "Catrinus",
          "Cavin",
          "Cay",
          "Caya",
          "Cayetano",
          "Cayley",
          "Caysa",
          "Caz",
          "Cecca",
          "Ceciel",
          "Cecile",
          "Cecilia",
          "Ceddriec",
          "Cedric",
          "Cedrych",
          "Cees",
          "Celaine",
          "Celal",
          "Celena",
          "Celess",
          "Celeste",
          "Celester",
          "Celestijn",
          "Celestine",
          "Celiene",
          "Celina",
          "Celine",
          "Cella",
          "Celle",
          "Cellienne",
          "Cem",
          "Cemal",
          "Cemil",
          "Cendrine",
          "Cennet",
          "Ceremco",
          "Ceren",
          "Ceriel",
          "Cerina",
          "Cerise",
          "Cesanne",
          "Cesar",
          "Cesco",
          "Cetus",
          "Ceyenne",
          "Ceylan",
          "Chabely",
          "Chacandra",
          "Chad",
          "Chadi",
          "Chadiya",
          "Chadya",
          "Chahine",
          "Chaim",
          "Chaira",
          "Chaja",
          "Chajah",
          "Chakira",
          "Chalinde",
          "Chaline",
          "Chamaima",
          "Chamara",
          "Chanan",
          "Chananja",
          "Chancy",
          "Chandler",
          "Chanel",
          "Chanelle",
          "Chanelva",
          "Chanique",
          "Chaniya",
          "Channa",
          "Channah",
          "Channe",
          "Chano",
          "Chanouk",
          "Chantal",
          "Chantalle",
          "Chantalli",
          "Chantaly",
          "Chantelle",
          "Chantine",
          "Charanna",
          "Charda",
          "Chardée",
          "Charel",
          "Charell",
          "Charella",
          "Charelle",
          "Charessa",
          "Charida",
          "Charif",
          "Charina",
          "Charis",
          "Charisa",
          "Chariska",
          "Charissa",
          "Charita",
          "Charity",
          "Chariëlle",
          "Charl",
          "Charlaine",
          "Charlene",
          "Charles",
          "Charley",
          "Charlie",
          "Charlien",
          "Charline",
          "Charlotte",
          "Charlynn",
          "Charmain",
          "Charmaine",
          "Charmayne",
          "Charneal",
          "Charnell",
          "Charo",
          "Charon",
          "Charona",
          "Charonne",
          "Charrell",
          "Charris",
          "Charro",
          "Chas",
          "Chauncey",
          "Chaunie",
          "Chava",
          "Chavel",
          "Chavira",
          "Chavon",
          "Chavonne",
          "Chaya",
          "Chayen",
          "Chayenna",
          "Chayenne",
          "Chaz",
          "Chaznay",
          "Chaïmae",
          "Chee-Hang",
          "Chelan",
          "Chelly",
          "Chelsea",
          "Chelsee",
          "Chelsey",
          "Chelène",
          "Chemay",
          "Chenaika",
          "Chendo",
          "Chendon",
          "Cheneequa",
          "Chenelle",
          "Chenice",
          "Chenise",
          "Chenita",
          "Chenna",
          "Chenoa",
          "Cher",
          "Cheramise",
          "Cheranie",
          "Cheraya",
          "Cherella",
          "Cherelle",
          "Cherida",
          "Cherilyn",
          "Cherinda",
          "Cherine",
          "Cherique",
          "Cherise",
          "Cherissa",
          "Cherisse",
          "Cherley",
          "Cherlindrea",
          "Cherlise",
          "Chern",
          "Chero",
          "Cheron",
          "Cherouq",
          "Cherrelle",
          "Cherrise",
          "Cherryl",
          "Cherstiena",
          "Cheryl",
          "Cheryll",
          "Cherylle",
          "Cherèl",
          "Cherélise",
          "Cherêne",
          "Cheska",
          "Chesney",
          "Chesron",
          "Chess",
          "Chessarina",
          "Chester",
          "Chet",
          "Chevanna",
          "Chevanny",
          "Chevaughn",
          "Chevella",
          "Chevon",
          "Chevy",
          "Chevyrain",
          "Chewenne",
          "Cheyenne",
          "Cheynne",
          "Chiara",
          "Chiarèlla",
          "Chico",
          "Chiel",
          "Chiela",
          "Chiem",
          "Chimene",
          "Chimezie",
          "Chimo",
          "Chimène",
          "Chiméne",
          "Chinook",
          "Chinouk",
          "Chinthya",
          "Chiraaz",
          "Chirley",
          "Chiron",
          "Chironne",
          "Chislaine",
          "Chitra",
          "Chivo",
          "Chiël",
          "Chloe",
          "Chloé",
          "Chloë",
          "Choeryl",
          "Choly",
          "Chongyi",
          "Chouke",
          "Chowy",
          "Choëlle",
          "Chris",
          "Chrisje",
          "Chrissie",
          "Chrissy",
          "Christ",
          "Christa",
          "Christan",
          "Christel",
          "Christi",
          "Christiaan",
          "Christian",
          "Christianne",
          "Christie",
          "Christien",
          "Christin",
          "Christina",
          "Christine",
          "Christinne",
          "Christje",
          "Christof",
          "Christoffer",
          "Christon",
          "Christoph",
          "Christophe",
          "Christopher",
          "Christy",
          "Chrystal",
          "Chrétienne",
          "Chula",
          "Chung",
          "Chyanne",
          "Chyenne",
          "Chyla",
          "Chynita",
          "Chynna",
          "Chyron",
          "Chèlle",
          "Chèrella",
          "Chénoah",
          "Chéraine",
          "Chérida",
          "Chérie",
          "Chérise",
          "Chévene",
          "Cian",
          "Ciara",
          "Cicille",
          "Cidney",
          "Cielke",
          "Cika",
          "Cil",
          "Cilesta",
          "Cilie",
          "Cilla",
          "Cillian",
          "Cilly",
          "Cinda",
          "Cindel",
          "Cindle",
          "Cindy",
          "Cinthia",
          "Ciro",
          "Ciry",
          "Cis",
          "Cisca",
          "Ciska",
          "Ciske",
          "Cissy",
          "Ciáran",
          "Ciárán",
          "Claartje",
          "Claas",
          "Clair",
          "Claire",
          "Clancy",
          "Clara",
          "Claran",
          "Clarice",
          "Clarie",
          "Clarieke",
          "Clarien",
          "Clarinda",
          "Clarinde",
          "Clark",
          "Claske",
          "Clathilda",
          "Claudi",
          "Claudia",
          "Claudine",
          "Claudio",
          "Claudy",
          "Clay",
          "Clayton",
          "Clem",
          "Clemence",
          "Clemens",
          "Clement",
          "Clemijn",
          "Clen",
          "Clenn",
          "Cleo",
          "Clessia",
          "Cliff",
          "Cliffred",
          "Clifton",
          "Clim",
          "Climmy",
          "Clint",
          "Clotilde",
          "Clément",
          "Co",
          "Coan",
          "Coba",
          "Cobi",
          "Cobie",
          "Cobus",
          "Coco",
          "Codi",
          "Codrin",
          "Cody",
          "Coen",
          "Coenraad",
          "Colet",
          "Colette",
          "Colien",
          "Colin",
          "Colina",
          "Coline",
          "Colinja",
          "Colleen",
          "Collin",
          "Collinda",
          "Colline",
          "Conan",
          "Concilia",
          "Condor",
          "Conner",
          "Connor",
          "Conor",
          "Constant",
          "Constantijn",
          "Constantyn",
          "Cooper",
          "Coos",
          "Coosje",
          "Cor",
          "Cora",
          "Coralie",
          "Coralien",
          "Corbin",
          "Cordi",
          "Corelien",
          "Coreline",
          "Corianne",
          "Corien",
          "Coriena",
          "Coriene",
          "Corijn",
          "Corina",
          "Corinde",
          "Corine",
          "Corinja",
          "Corinna",
          "Corinne",
          "Coriëlle",
          "Corja",
          "Corjanne",
          "Corka",
          "Corke",
          "Corlaine",
          "Corlieke",
          "Corliene",
          "Corlinda",
          "Corline",
          "Corma",
          "Cornalie",
          "Cornel",
          "Cornelia",
          "Cornelie",
          "Cornelieke",
          "Cornelis",
          "Cornie",
          "Corniël",
          "Corné",
          "Cornée",
          "Cornélie",
          "Cornéta",
          "Corola",
          "Corrianne",
          "Corrie",
          "Corrinda",
          "Corrine",
          "Corrinne",
          "Corrola",
          "Corry",
          "Corstiaan",
          "Corstian",
          "Corwi",
          "Corwin",
          "Cosette",
          "Courtney",
          "Craig",
          "Creten",
          "Cretiënne",
          "Crijn",
          "Cristan",
          "Cristhel",
          "Cristian",
          "Criswellin",
          "Critiën",
          "Crystal",
          "Cuba",
          "Cunera",
          "Curtis",
          "Cyane",
          "Cyanne",
          "Cylia",
          "Cynric",
          "Cyntha",
          "Cynthia",
          "Cyrano",
          "Cyrella",
          "Cyrelle",
          "Cyriel",
          "Cyril",
          "Cyrilein",
          "Cyrilla",
          "Cyrille",
          "Cyrina",
          "Cyrion",
          "Cyrus",
          "Cèzanne",
          "Cébas",
          "Céciel",
          "Cécile",
          "Céderic",
          "Cédric",
          "Céleste",
          "Célestine",
          "Céliah",
          "Célie",
          "Célina",
          "Célinde",
          "Céline",
          "Céryl",
          "Cérès",
          "Césanne",
          "Cézary",
          "D'Jazer",
          "D'Shawn",
          "Daan",
          "Daanisj",
          "Daaniya",
          "Daantje",
          "Daatje",
          "Daborah",
          "Daeline",
          "Daelynn",
          "Dafne",
          "Dagmar",
          "Dagmare",
          "Dagna",
          "Dahniek",
          "Dahné",
          "Daiko",
          "Daily",
          "Daimerly",
          "Daimy",
          "Daimyo",
          "Daina",
          "Daine",
          "Dairo",
          "Dairon",
          "Daisy",
          "Daivon",
          "Dajo",
          "Dale",
          "Dalena",
          "Daley",
          "Dalibor",
          "Dalida",
          "Dalisa",
          "Dalisha",
          "Dalì",
          "Damanja",
          "Damar",
          "Damaris",
          "Damas",
          "Dami",
          "Damia",
          "Damian",
          "Damiano",
          "Damien",
          "Damion",
          "Damir",
          "Damiën",
          "Dammes",
          "Dammis",
          "Damon",
          "Damy",
          "Dana",
          "Danah",
          "Dananja",
          "Danara",
          "Danceney",
          "Dane",
          "Danee",
          "Danella",
          "Dani",
          "Danica",
          "Danicha",
          "Danick",
          "Daniek",
          "Danieke",
          "Daniel",
          "Danielle",
          "Danijela",
          "Danil",
          "Danila",
          "Danilo",
          "Danine",
          "Danion",
          "Danique",
          "Danischa",
          "Danisha",
          "Danisho",
          "Danita",
          "Danitia",
          "Danitsja",
          "Daniël",
          "Daniëla",
          "Daniëlla",
          "Daniëlle",
          "Danja",
          "Danjel",
          "Danjella",
          "Danjèl",
          "Danne",
          "Dannick",
          "Dannie",
          "Danniek",
          "Dannique",
          "Danny",
          "Dano",
          "Danouk",
          "Dante",
          "Danusia",
          "Danuszja",
          "Dany",
          "Danya",
          "Danyla",
          "Danyra",
          "Danzel",
          "Danée",
          "Daníel",
          "Danütha",
          "Daphnah",
          "Daphne",
          "Daphni",
          "Daphny",
          "Daphné",
          "Dara",
          "Darcey",
          "Darcy",
          "Daria",
          "Darian",
          "Darinka",
          "Dario",
          "Darios",
          "Dariën",
          "Darlene",
          "Daron",
          "Darragh",
          "Darren",
          "Darryl",
          "Darryll",
          "Darsen",
          "Darshan",
          "Darwin",
          "Daryk",
          "Daryl",
          "Daryll",
          "Dascha",
          "Dasja",
          "Date",
          "Dave",
          "Davey",
          "Davian",
          "David",
          "Davida",
          "Davie",
          "Davin",
          "Davina",
          "Davine",
          "Davinia",
          "Davira",
          "Davita",
          "Daviyo",
          "Davy",
          "Dawayne",
          "Dawn",
          "Dax",
          "Dayar",
          "Dayla",
          "Daylene",
          "Daymee",
          "Dayna",
          "Dayne",
          "Dayvid",
          "Daén",
          "Daïn",
          "De",
          "Dean",
          "Debbie",
          "Debby",
          "Debora",
          "Deborah",
          "Debra",
          "Decia",
          "Declan",
          "Dedy",
          "Dee",
          "Dee-Dee",
          "Deef",
          "Deejee",
          "Deen",
          "Dees",
          "Deesje",
          "Defne",
          "Defrie",
          "Deirdre",
          "Dejan",
          "Delaja",
          "Delana",
          "Delano",
          "Delany",
          "Delaya",
          "Delayla",
          "Delfie",
          "Deli",
          "Delia",
          "Deliana",
          "Delilah",
          "Delin",
          "Delinia",
          "Delisa",
          "Delivio",
          "Delorean",
          "Delphine",
          "Delshay",
          "Delvin",
          "Demelsa",
          "Demelza",
          "Demi",
          "Demian",
          "Demie",
          "Demiën",
          "Dempsey",
          "Demy",
          "Dena",
          "Denah",
          "Dencey",
          "Denian",
          "Denice",
          "Deniece",
          "Denis",
          "Denise",
          "Denisha",
          "Deniz",
          "Denize",
          "Denizhan",
          "Dennie",
          "Dennis",
          "Denny",
          "Denver",
          "Deny",
          "Denzel",
          "Denzell",
          "Deon",
          "Deony",
          "Derek",
          "Derk",
          "Derkjan",
          "Derrick",
          "Derryn",
          "Dervla",
          "Derwin",
          "Derya",
          "Deshamaira",
          "Deshny",
          "Desi",
          "Desiree",
          "Desiré",
          "Desirée",
          "Desley",
          "Desly",
          "Desmond",
          "Desteny",
          "Destiney",
          "Destiny",
          "Deswin",
          "Desy",
          "Detlef",
          "Detlev",
          "Detmar",
          "Devan",
          "Devancy",
          "Deveney",
          "Deveny",
          "Devi",
          "Devid",
          "Devie",
          "Devika",
          "Devin",
          "Devlin",
          "Devon",
          "Dewantara",
          "Dewi",
          "Dewy",
          "Dex",
          "Dexter",
          "Dhaly",
          "Dhana",
          "Dhanesh",
          "Dhariël",
          "Dharmdew",
          "Dhidey",
          "Dhorn",
          "Diala",
          "Dian",
          "Diana",
          "Dianca",
          "Dianda",
          "Diandra",
          "Diane",
          "Dianne",
          "Diantha",
          "Dianthe",
          "Dianto",
          "Diaro",
          "Diaz",
          "Diba",
          "Dichanne",
          "Dichelle",
          "Dick",
          "Dickie",
          "Dicky",
          "Dico",
          "Dictus",
          "Dide",
          "Diderik",
          "Didi",
          "Didier",
          "Didjay",
          "Didrik",
          "Diede",
          "Diederick",
          "Diederik",
          "Diederike",
          "Diego",
          "Diek",
          "Dieka",
          "Dieke",
          "Dieko",
          "Diem",
          "Dienie",
          "Dienke",
          "Dierieke",
          "Dieta",
          "Dieter",
          "Dieudonnee",
          "Dieudy",
          "Dieuwer",
          "Dieuwertje",
          "Dieuwke",
          "Diewerke",
          "Diger",
          "Dijanne",
          "Dijs",
          "Dik",
          "Dilan",
          "Dilana",
          "Dilano",
          "Dilara",
          "Dilek",
          "Dilhan",
          "Dili",
          "Dille",
          "Dilliam",
          "Dillon",
          "Diloy",
          "Diluk",
          "Dilâra",
          "Dim",
          "Dima",
          "Dimar",
          "Dimara",
          "Dimfy",
          "Dimitri",
          "Dimitrios",
          "Dimitry",
          "Dimmy",
          "Dimphna",
          "Dimphy",
          "Din",
          "Dina",
          "Dinah",
          "Dinand",
          "Dinande",
          "Dineke",
          "Dinella",
          "Dinesh",
          "Dingeman",
          "Dinieke",
          "Dinja",
          "Dink",
          "Dino",
          "Dinthe",
          "Dio",
          "Dion",
          "Diona",
          "Dione",
          "Dioni",
          "Dionne",
          "Diria",
          "Dirja",
          "Dirk",
          "Dirkjan",
          "Dirkje",
          "Dirma",
          "Dirra",
          "Dirthe",
          "Disley",
          "Disney",
          "Ditmar",
          "Ditske",
          "Ditsy",
          "Ditte",
          "Divera",
          "Diyanne",
          "Diègo",
          "Diémo",
          "Diéry",
          "Diönna",
          "Djadi",
          "Djago",
          "Djahmillah",
          "Djai",
          "Djaira",
          "Djamel",
          "Djamilla",
          "Django",
          "Djannie",
          "Djano",
          "Djany",
          "Djanyl",
          "Djara",
          "Djarda",
          "Djardy",
          "Djarmelza",
          "Djarno",
          "Djayden",
          "Djaïr",
          "Djecky",
          "Djeedy",
          "Djef",
          "Djefrey",
          "Djelana",
          "Djelano",
          "Djen",
          "Djenitha",
          "Djermo",
          "Djesse",
          "Djessy",
          "Djetto",
          "Djewi",
          "Djezz",
          "Djezzy",
          "Djijo",
          "Djim",
          "Djimmy",
          "Djindji",
          "Djinn",
          "Djinni",
          "Djino",
          "Djody",
          "Djoeke",
          "Djoenie",
          "Djoere",
          "Djoeri",
          "Djohnno",
          "Djoke",
          "Djolien",
          "Djoni",
          "Djonie",
          "Djordi",
          "Djordin",
          "Djordy",
          "Djorni",
          "Djoshua",
          "Djovanny",
          "Djowy",
          "Djulita",
          "Djuna",
          "Djura",
          "Djuri",
          "Djurra",
          "Djurre",
          "Dmitri",
          "Dodijn",
          "Doede",
          "Doedo",
          "Doekle",
          "Doenja",
          "Doenya",
          "Doganay",
          "Doj",
          "Doke",
          "Dolf",
          "Dolinda",
          "Domenico",
          "Domenique",
          "Domien",
          "Domingo",
          "Domingus",
          "Dominic",
          "Dominick",
          "Dominiek",
          "Dominique",
          "Domino",
          "Doménique",
          "Don",
          "Donald",
          "Donathe",
          "Donchavèl",
          "Doney",
          "Donika",
          "Donja",
          "Donna",
          "Donnely",
          "Donnever",
          "Donny",
          "Donné",
          "Donnée",
          "Donovan",
          "Doné",
          "Doortje",
          "Doralice",
          "Doran",
          "Dore",
          "Dorelie",
          "Doret",
          "Doreth",
          "Dorian",
          "Dorianne",
          "Dorieke",
          "Dorien",
          "Dorienke",
          "Dorijn",
          "Dorinda",
          "Dorine",
          "Doris",
          "Dorith",
          "Dorocia",
          "Doron",
          "Dorothy",
          "Dorothée",
          "Dorrit",
          "Dorrus",
          "Dort",
          "Dorthe",
          "Dorus",
          "Dosanne",
          "Douglas",
          "Douk",
          "Dounia",
          "Doutina",
          "Doutzen",
          "Douwe",
          "Doy",
          "Dracina",
          "Drazic",
          "Drico",
          "Driek",
          "Driekus",
          "Dries",
          "Duanca",
          "Duane",
          "Duco",
          "Duell",
          "Duke",
          "Dumont",
          "Duna",
          "Duncan",
          "Dunja",
          "Dunya",
          "Durk",
          "Dustin",
          "Dusty",
          "Duurt",
          "Duve",
          "Duy",
          "Duèn",
          "Dwain",
          "Dwayn",
          "Dwayne",
          "Dwight",
          "Dyan",
          "Dyango",
          "Dyanne",
          "Dyantha",
          "Dyanthe",
          "Dyce",
          "Dylaine",
          "Dylan",
          "Dylano",
          "Dylian",
          "Dymphe",
          "Dymphia",
          "Dymphie",
          "Dymphy",
          "Dynphy",
          "Dynthe",
          "Dyon",
          "Dyonne",
          "Dániel",
          "Dävy",
          "Däyna",
          "Dèz",
          "Débra",
          "Déjany",
          "Déjon",
          "Délano",
          "Démen",
          "Dési",
          "Désiree",
          "Désiré",
          "Désirée",
          "Dévinjo",
          "Eamonn",
          "Ebbe",
          "Ebbo",
          "Ebe",
          "Ebel",
          "Ebony",
          "Ebrina",
          "Ebru",
          "Eckart",
          "Edcharda",
          "Edden",
          "Eddie",
          "Eddy",
          "Edgar",
          "Edi",
          "Edina",
          "Edinno",
          "Edip",
          "Edith",
          "Ediz",
          "Edmar",
          "Edmee",
          "Edmée",
          "Edo",
          "Edrik",
          "Edske",
          "Edu",
          "Eduard",
          "Eduardo",
          "Edward",
          "Edwin",
          "Edwina",
          "Edzo",
          "Eef",
          "Eefie",
          "Eefje",
          "Eefke",
          "Eeke",
          "Eelco",
          "Eelke",
          "Eelse",
          "Eelze",
          "Eenje",
          "Eetze",
          "Eeuwe",
          "Effie",
          "Efi",
          "Efraïm",
          "Efrin",
          "Egbert",
          "Egbertje",
          "Egide",
          "Egon",
          "Egwin",
          "Ehran",
          "Eibert",
          "Eike",
          "Eildert",
          "Eilish",
          "Eimerdine",
          "Einar",
          "Eise",
          "Eiso",
          "Eitze",
          "Eize",
          "Eke",
          "el",
          "Ela",
          "Elaine",
          "Elana",
          "Elano",
          "Elayne",
          "Elcharro",
          "Elcke",
          "Elco",
          "Eldrid",
          "Ele",
          "Eleana",
          "Eleanor",
          "Elena",
          "Eleonora",
          "Elfi",
          "Elfy",
          "Elga",
          "Elger",
          "Elginio",
          "Eli",
          "Eliah",
          "Eliam",
          "Elian",
          "Eliana",
          "Eliane",
          "Elianne",
          "Elias",
          "Elien",
          "Elies",
          "Elieze",
          "Elif",
          "Elija",
          "Elijne",
          "Elin",
          "Elina",
          "Eline",
          "Elinn",
          "Elion",
          "Elisa",
          "Elisabeth",
          "Elisah",
          "Elise",
          "Elisha",
          "Elisheva",
          "Elishevah",
          "Eliyah",
          "Eliza",
          "Elizabeth",
          "Elizah",
          "Elize",
          "Eliëtte",
          "Elja",
          "Eljade",
          "Eljah",
          "Eljakim",
          "Eljon",
          "Eljoënai",
          "Elke",
          "Elkjaer",
          "Elko",
          "Ella",
          "Ellard",
          "Elle",
          "Elleke",
          "Ellemarie",
          "Ellemieke",
          "Ellemijn",
          "Ellen",
          "Ellena",
          "Ellenoor",
          "Ellery",
          "Elles",
          "Ellian",
          "Ellie",
          "Ellina",
          "Elliot",
          "Ellis",
          "Elliëtte",
          "Elloise",
          "Elly",
          "Ellymay",
          "Ellys",
          "Elma",
          "Elmarije",
          "Elmas",
          "Elmer",
          "Elmi",
          "Elmir",
          "Elmo",
          "Elodie",
          "Eloi",
          "Eloise",
          "Elon",
          "Eloniek",
          "Eloy",
          "Eloyke",
          "Elra",
          "Elrein",
          "Elric",
          "Elriecke",
          "Elrik",
          "Elroy",
          "Els",
          "Elsa",
          "Elsanne",
          "Elsberth",
          "Elsbeth",
          "Else",
          "Elsebé",
          "Elseline",
          "Elsemarie",
          "Elsemarijn",
          "Elsemiek",
          "Elsemieke",
          "Elsenoor",
          "Elsina",
          "Elsje",
          "Elske",
          "Eltica",
          "Eltina",
          "Eltine",
          "Eltio",
          "Elton",
          "Elunde",
          "Elvera",
          "Elvi",
          "Elvida",
          "Elvie",
          "Elvieke",
          "Elviera",
          "Elvin",
          "Elvina",
          "Elvira",
          "Elwin",
          "Ely",
          "Elycia",
          "Elyne",
          "Elyon",
          "Elyse",
          "Elyseo",
          "Elysha",
          "Elza",
          "Elzard",
          "Elze",
          "Elzelien",
          "Elzeline",
          "Elzemiek",
          "Elzerd",
          "Elzo",
          "Eléna",
          "Elía",
          "Elöise",
          "Emalise",
          "Emanuel",
          "Emardo",
          "Emelie",
          "Emely",
          "Emerance",
          "Emerentia",
          "Emeric",
          "Emese",
          "Emi",
          "Emie",
          "Emiel",
          "Emile",
          "Emilia",
          "Emilie",
          "Emilio",
          "Emilva",
          "Emily",
          "Emina",
          "Emke",
          "Emma",
          "Emmaline",
          "Emmaly",
          "Emme",
          "Emmeke",
          "Emmelie",
          "Emmeliek",
          "Emmelien",
          "Emmeline",
          "Emmelotte",
          "Emmely",
          "Emmerick",
          "Emmerson",
          "Emmie",
          "Emmily",
          "Emmy",
          "Emmylou",
          "Emond",
          "Emrah",
          "Emre",
          "Emsley",
          "Emy",
          "Enara",
          "Enes",
          "Engbert",
          "Enis",
          "Enja",
          "Enna",
          "Enneke",
          "Ennie",
          "Eno",
          "Enoch",
          "Enola",
          "Enrico",
          "Ente",
          "Enya",
          "Enze",
          "Enzio",
          "Enzo",
          "Ephraïm",
          "Epke",
          "Eral",
          "Eray",
          "Erben",
          "Erdin",
          "Erhan",
          "Eri",
          "Eric",
          "Erica",
          "Erich",
          "Erick",
          "Erik",
          "Erika",
          "Erin",
          "Erinke",
          "Erinn",
          "Eritia",
          "Erja",
          "Erjan",
          "Erlinde",
          "Erline",
          "Ernick",
          "Ernie",
          "Ernst",
          "Ernstjan",
          "Erol",
          "Eros",
          "Erris",
          "Errol",
          "Erszi",
          "Ervin",
          "Ervinda",
          "Erwin",
          "Eryk",
          "Esdert",
          "Esdra",
          "Esger",
          "Eshelle",
          "Eshmé",
          "Eske",
          "Eslem",
          "Esley",
          "Esli",
          "Eslie",
          "Esma",
          "Esmaralda",
          "Esmay",
          "Esmee",
          "Esmeralda",
          "Esmilia",
          "Esmond",
          "Esmé",
          "Esmée",
          "Espen",
          "Espérance",
          "Esra",
          "Esrah",
          "Esri",
          "Esry",
          "Esteban",
          "Estee",
          "Estefanía",
          "Estel",
          "Estella",
          "Estelle",
          "Ester",
          "Estevan",
          "Esther",
          "Esti",
          "Estrea",
          "Esty",
          "Estée",
          "Eswin",
          "Eszra",
          "Etchika",
          "Ethama",
          "Ethan",
          "Ethelle",
          "Etienne",
          "Etiënne",
          "Eugeen",
          "Eugénie",
          "Euníce",
          "Euwen",
          "Eva",
          "Evalien",
          "Evalina",
          "Evaluna",
          "Evan",
          "Evander",
          "Evangeline",
          "Evany",
          "Eve",
          "Evelien",
          "Eveliene",
          "Eveline",
          "Evelyn",
          "Evelyne",
          "Evenne",
          "Everdien",
          "Everhart",
          "Evert",
          "Evi",
          "Evianne",
          "Evie",
          "Evin",
          "Evina",
          "Evine",
          "Evita",
          "Evy",
          "Ewa",
          "Ewald",
          "Ewan",
          "Eward",
          "Ewart",
          "Ewoud",
          "Ewout",
          "Eyzo",
          "Ezar",
          "Ezra",
          "Fab",
          "Fabia",
          "Fabiaan",
          "Fabian",
          "Fabiana",
          "Fabien",
          "Fabienne",
          "Fabio",
          "Fabiola",
          "Fabiènne",
          "Fabiën",
          "Fabiënne",
          "Fabrice",
          "Fabricio",
          "Fadila",
          "Fagmar",
          "Fai",
          "Fairy",
          "Faisal",
          "Faith",
          "Faiçal",
          "Falcke",
          "Falco",
          "Falisha",
          "Falk",
          "Falko",
          "Famke",
          "Fammeke",
          "Fancy",
          "Fania",
          "Fannie",
          "Fanny",
          "Faraaz",
          "Farah",
          "Fardau",
          "Farid",
          "Faris",
          "Farley",
          "Faroek",
          "Farrah",
          "Farshaad",
          "Fascal",
          "Fasillio",
          "Fastwin",
          "Fatima",
          "Faustino",
          "Fausto",
          "Fauve",
          "Fawn",
          "Fay",
          "Fayan",
          "Faye",
          "Fayette",
          "Fayola",
          "Fayrouz",
          "Faysal",
          "Fayyaz",
          "Fayza",
          "Faïza",
          "Feargal",
          "Febe",
          "Fedde",
          "Fedderi",
          "Feddrick",
          "Feddrik",
          "Feder",
          "Fedhi",
          "Fedor",
          "Fee",
          "Feije",
          "Feike",
          "Feiko",
          "Feite",
          "Feitze",
          "Fekke",
          "Feli",
          "Felice",
          "Felicia",
          "Felicita",
          "Felicity",
          "Felien",
          "Feline",
          "Felisha",
          "Felitsa",
          "Felix",
          "Feliza",
          "Femi",
          "Femia",
          "Femke",
          "Femme",
          "Femmelina",
          "Femmie",
          "Femmina",
          "Fen",
          "Fenanda",
          "Fenda",
          "Fenke",
          "Fenna",
          "Fenne",
          "Fenneke",
          "Fenno",
          "Fenny",
          "Fera",
          "Ferd",
          "Ferdi",
          "Ferdie",
          "Ferdinand",
          "Ferdjo",
          "Ferdy",
          "Fere",
          "Ferenc",
          "Ference",
          "Ferencz",
          "Ferjo",
          "Fern",
          "Fernan",
          "Fernanda",
          "Fernandez",
          "Fernando",
          "Ferran",
          "Ferre",
          "Ferrie",
          "Ferris",
          "Ferron",
          "Ferry",
          "Fester",
          "Feyona",
          "Fian",
          "Fianna",
          "Fianne",
          "Fiano",
          "Fidel",
          "Fidelma",
          "Fidessa",
          "Fieke",
          "Fien",
          "Fiene",
          "Fienna",
          "Fientje",
          "Fifianne",
          "Figo",
          "Figou",
          "Fije",
          "Fijnanda",
          "Fik",
          "Fikri",
          "Filip",
          "Filippa",
          "Filique",
          "Filou",
          "Fimke",
          "Fimme",
          "Fin",
          "Fineke",
          "Finet",
          "Finette",
          "Finja",
          "Finlay",
          "Finley",
          "Finn",
          "Finne",
          "Finola",
          "Fintan",
          "Fiona",
          "Fiore",
          "Fip",
          "Fir",
          "Fira",
          "Firenze",
          "Fitzgerald",
          "Fjäll",
          "Flavio",
          "Flavié",
          "Fleur",
          "Fleurien",
          "Fleurine",
          "Fleurita",
          "Fleurke",
          "Fleurtje",
          "Flint",
          "Flip",
          "Flo",
          "Floid",
          "Floor",
          "Floorke",
          "Floortje",
          "Flor",
          "Flora",
          "Floran",
          "Florance",
          "Flore",
          "Florean",
          "Floren",
          "Florence",
          "Florens",
          "Florent",
          "Florentien",
          "Florentin",
          "Florentine",
          "Florenzo",
          "Florian",
          "Floriane",
          "Florianne",
          "Florieke",
          "Florien",
          "Florieneke",
          "Florinde",
          "Florine",
          "Floris",
          "Florith",
          "Floyd",
          "Flynn",
          "Foeke",
          "Foke",
          "Fokje",
          "Fokke",
          "Folckert",
          "Folker",
          "Folkert",
          "Folkje",
          "Folmer",
          "Foléor",
          "Fonger",
          "Fongman",
          "Fonne",
          "Fons",
          "Foor",
          "Forra",
          "Forrianne",
          "Fos",
          "Foske",
          "Fouke",
          "Franca",
          "France",
          "Frances",
          "Francesca",
          "Francesco",
          "Franchesco",
          "Francien",
          "Francies",
          "Francijn",
          "Francina",
          "Francine",
          "Francis",
          "Francisca",
          "Francy",
          "Frank",
          "Franka",
          "Franke",
          "Franky",
          "Franny",
          "Frans",
          "Fransien",
          "Fransina",
          "Fransis",
          "Franske",
          "François",
          "Frauke",
          "Fraukje",
          "Freark",
          "Fred",
          "Freddy",
          "Frederick",
          "Frederiecke",
          "Frederiek",
          "Frederieke",
          "Frederik",
          "Frederika",
          "Frederike",
          "Frederique",
          "Fredie",
          "Fredolina",
          "Freek",
          "Freeke",
          "Freekje",
          "Freemer",
          "Freerk",
          "Freesje",
          "Freija",
          "Freke",
          "Fren",
          "Frenk",
          "Frenklin",
          "Frenny",
          "Frens",
          "Frenske",
          "Freyja",
          "Frida",
          "Fridse",
          "Frieda",
          "Friedarica",
          "Friedeke",
          "Friederieke",
          "Frieke",
          "Frija",
          "Frim",
          "Frisian",
          "Friso",
          "Frits",
          "Fritsjan",
          "Fronnie",
          "Frouk",
          "Froukje",
          "Frouktje",
          "Frouwke",
          "Frytskje",
          "Fréderique",
          "Frédéric",
          "Frédérique",
          "Fulco",
          "Funda",
          "Funs",
          "Fygo",
          "Fyor",
          "Fánus",
          "Fèdde",
          "Fé",
          "Fébe",
          "Félice",
          "Félicien",
          "Féline",
          "Félipe",
          "Férieke",
          "Fótis",
          "Gaatze",
          "Gaauwe",
          "Gabe",
          "Gabi",
          "Gable",
          "Gabor",
          "Gabri",
          "Gabriela",
          "Gabriele",
          "Gabriël",
          "Gabriëla",
          "Gabriëlla",
          "Gabriëlle",
          "Gabry",
          "Gaby",
          "Gaetano",
          "Gaia",
          "Gaime",
          "Gaius",
          "Gajanan",
          "Galina",
          "Galliano",
          "Gallyon",
          "Gardy",
          "Garke",
          "Garp",
          "Garreth",
          "Garrie",
          "Gary",
          "Gaudenso",
          "Gauthier",
          "Gavin",
          "Gawein",
          "Gaya",
          "Gayle",
          "Gayrlan",
          "Gaël",
          "Gaëlle",
          "Gaëtan",
          "Gea",
          "Geanne",
          "Geart",
          "Geartsje",
          "Gebke",
          "Gedeona",
          "Gedieke",
          "Gedy",
          "Geeke",
          "Geena",
          "Geerhart",
          "Geerine",
          "Geert",
          "Geerte",
          "Geerten",
          "Geerthilde",
          "Geertjan",
          "Geertje",
          "Geery",
          "Geesje",
          "Gejo",
          "Geke",
          "Gekelien",
          "Gelein",
          "Gelina",
          "Gelindo",
          "Gelisa",
          "Gemayel",
          "Gemke",
          "Gemma",
          "Gemme",
          "Gemmy",
          "Genardo",
          "Genaud",
          "Gene",
          "Geneva",
          "Genevieve",
          "Geneviève",
          "Geneyro",
          "Geniefjeiva",
          "Genise",
          "Genita",
          "Geoffrey",
          "Geoneal",
          "Geordi",
          "Geordy",
          "George",
          "Georgette",
          "Georgia",
          "Georgina",
          "Georgo",
          "Georgos",
          "Georgy",
          "Geovanna",
          "Ger",
          "Gera",
          "Gerald",
          "Geralda",
          "Geraldien",
          "Geraldine",
          "Geralise",
          "Geralt",
          "Geranka",
          "Gerard",
          "Gerarda",
          "Gerardje",
          "Gerardy",
          "Gerbart",
          "Gerben",
          "Gerber",
          "Gerbert",
          "Gerbine",
          "Gerbrand",
          "Gerbrich",
          "Gerbrig",
          "Gerco",
          "Gerd",
          "Gerda",
          "Gerdien",
          "Gerdin",
          "Gerdinand",
          "Gerdine",
          "Gerdo",
          "Gerelbe",
          "Gerenda",
          "Gerhard",
          "Gerharda",
          "Gerhart",
          "Geri",
          "Gerian",
          "Gerianne",
          "Gerie",
          "Gerieke",
          "Geriena",
          "Geriene",
          "Gerije",
          "Gerike",
          "Gerinda",
          "Gerinde",
          "Gerjan",
          "Gerjanna",
          "Gerjanne",
          "Gerjen",
          "Gerjo",
          "Gerjon",
          "Gerke",
          "Gerkje",
          "Gerlanda",
          "Gerlien",
          "Gerlin",
          "Gerlina",
          "Gerlinda",
          "Gerlinde",
          "Gerline",
          "Gerlineke",
          "Gerlise",
          "Germa",
          "Germain",
          "Germaine",
          "Germana",
          "Germen",
          "Germer",
          "Germie",
          "Gernaldo",
          "Gernand",
          "Gero",
          "Gerola",
          "Gerolf",
          "Gerona",
          "Geroy",
          "Gerrald",
          "Gerralt",
          "Gerreke",
          "Gerret",
          "Gerrianne",
          "Gerrie",
          "Gerrieke",
          "Gerrieta",
          "Gerrine",
          "Gerrit",
          "Gerrita",
          "Gerritte",
          "Gerro",
          "Gerronne",
          "Gerry",
          "Gershon",
          "Gersjom",
          "Gersom",
          "Gerson",
          "Gert",
          "Gertia",
          "Gertie",
          "Gertina",
          "Gertjan",
          "Gertrude",
          "Gerty",
          "Gerwald",
          "Gerwilmer",
          "Gerwim",
          "Gerwin",
          "Geryanne",
          "Geryo",
          "Gesanneke",
          "Gesine",
          "Geske",
          "Gesley",
          "Getwin",
          "Geurt",
          "Geurtjan",
          "Geza",
          "Ghalid",
          "Ghalith",
          "Gheena",
          "Ghilaine",
          "Ghino",
          "Ghislain",
          "Ghislaine",
          "Giacomo",
          "Giada",
          "Gian",
          "Gianluca",
          "Gianna",
          "Gianni",
          "Giannini",
          "Giano",
          "Gideon",
          "Gidion",
          "Gido",
          "Gidon",
          "Giel",
          "Gielijan",
          "Gienus",
          "Gieske",
          "Gigi",
          "Gijan",
          "Gijs",
          "Gijsbert",
          "Gijsbertine",
          "Gila",
          "Gilano",
          "Gilene",
          "Gilermo",
          "Giliam",
          "Gilian",
          "Gilke",
          "Gilles",
          "Gillian",
          "Gilliano",
          "Gina",
          "Gineke",
          "Ginette",
          "Ginger",
          "Ginny",
          "Gino",
          "Gio",
          "Gioia",
          "Giome",
          "Giomi",
          "Giora",
          "Giorgina",
          "Giorginio",
          "Giorgio",
          "Giorgo",
          "Giorny",
          "Giovanna",
          "Giovanni",
          "Giovanny",
          "Giray",
          "Girtje",
          "Giselle",
          "Gismaro",
          "Githe",
          "Gitta",
          "Gittan",
          "Gitte",
          "Giulia",
          "Giuliano",
          "Giulietta",
          "Giusi",
          "Givanny",
          "Givanti",
          "Giverney",
          "Giyo",
          "Gjerryt",
          "Gjilke",
          "Gladys",
          "Glein",
          "Glen",
          "Glenda",
          "Glenn",
          "Glennys",
          "Glenys",
          "Gloria",
          "Glyn",
          "Glynnis",
          "Godain",
          "Godert",
          "Goedele",
          "Goke",
          "Golan",
          "Goldie",
          "Gonda",
          "Gonnie",
          "Goof",
          "Goofy",
          "Goord",
          "Goos",
          "Gooswijn",
          "Goran",
          "Gosen",
          "Gosse",
          "Goudje",
          "Govanni",
          "Govanny",
          "Govert",
          "Grace",
          "Gracia",
          "Graciëla",
          "Graciëlla",
          "Gradsie",
          "Graham",
          "Granville",
          "Graziëlla",
          "Greca",
          "Greggy",
          "Gregoor",
          "Gregor",
          "Gregory",
          "Greta",
          "Gretje",
          "Gretske",
          "Grianne",
          "Grieanda",
          "Grietina",
          "Grietje",
          "Grietsje",
          "Griffhin",
          "Griffin",
          "Gringa",
          "Griselda",
          "Groucho",
          "Guerchôm",
          "Guerlain",
          "Guichelle",
          "Guidione",
          "Guido",
          "Guiguitte",
          "Guillaume",
          "Guillermo",
          "Guillette",
          "Guilliano",
          "Guinevere",
          "Guiv",
          "Gulian",
          "Gulyan",
          "Guna",
          "Gunhild",
          "Gunnar",
          "Gunther",
          "Gus",
          "Gusta",
          "Gustaaf",
          "Gustin",
          "Guurtje",
          "Guus",
          "Guusje",
          "Guust",
          "Guy",
          "Guydo",
          "Guylian",
          "Guynan",
          "Guyon",
          "Guyrin",
          "Gwen",
          "Gwendolien",
          "Gwendolyn",
          "Gwendolynn",
          "Gwenne",
          "Gwennis",
          "Gwenny",
          "Gwyn",
          "Gwynedd",
          "Gwyneth",
          "Gwynn",
          "Gydo",
          "Gylan",
          "Gyon",
          "Gysbert",
          "Gyselke",
          "Gyselle",
          "Gysette",
          "Gyöngyi",
          "Gábor",
          "Gé",
          "Géan",
          "Géke",
          "Géline",
          "Géraud",
          "Gösta",
          "Gülin",
          "Haaije",
          "Haaye",
          "Haci",
          "Hadassa",
          "Hadassah",
          "Haddah",
          "Hadewych",
          "Hafez",
          "Haico",
          "Haije",
          "Haike",
          "Haiko",
          "Haitsen",
          "Haitske",
          "Hakim",
          "Halbert",
          "Haley",
          "Halima",
          "Hallina",
          "Hamanda",
          "Han",
          "Hanan",
          "Hananja",
          "Hanco",
          "Haniff",
          "Hanjo",
          "Hanka",
          "Hanke",
          "Hanna",
          "Hannae",
          "Hannah",
          "Hannalore",
          "Hannan",
          "Hanne",
          "Hanneke",
          "Hannelies",
          "Hannelinde",
          "Hannelore",
          "Hannerieke",
          "Hannes",
          "Hannewil",
          "Hannie",
          "Hannine",
          "Hans",
          "Hansje",
          "Hara",
          "Harald",
          "Harber",
          "Harbert",
          "Hardo",
          "Harjan",
          "Harke",
          "Harley",
          "Harlinde",
          "Harm",
          "Harma",
          "Harmanna",
          "Harmen",
          "Harmke",
          "Harnt",
          "Harold",
          "Haron",
          "Harrie",
          "Harris",
          "Harrison",
          "Harriët",
          "Harro",
          "Harrold",
          "Harron",
          "Harry",
          "Harryt",
          "Hart",
          "Harvey",
          "Harvrey",
          "Harwin",
          "Haryan",
          "Has",
          "Hasse",
          "Hayco",
          "Haylee",
          "Hayley",
          "Hayo",
          "Hazel",
          "Heather",
          "Heatherly",
          "Heaven",
          "Heavenly",
          "Hebe",
          "Hebel",
          "Heber",
          "Hedde",
          "Heddy",
          "Hedera",
          "Hedser",
          "Hedwich",
          "Hedwig",
          "Hedy",
          "Hedzer",
          "Heerco",
          "Heide",
          "Heidi",
          "Heidy",
          "Heije",
          "Heike",
          "Heiki",
          "Heiko",
          "Heilien",
          "Hein",
          "Heino",
          "Heiralde",
          "Helder",
          "Heleanne",
          "Heleen",
          "Helen",
          "Helena",
          "Helga",
          "Helger",
          "Helina",
          "Heline",
          "Hella",
          "Helle",
          "Hellen",
          "Helm",
          "Helma",
          "Helmer",
          "Helmi",
          "Helmien",
          "Helmus",
          "Helmut",
          "Helscha",
          "Hemmo",
          "Henaly",
          "Henda",
          "Henderik",
          "Hendi",
          "Hendri",
          "Hendrie",
          "Hendrik",
          "Hendrika",
          "Hendrinand",
          "Hendriënne",
          "Hendry",
          "Hendryetta",
          "Henja",
          "Henjoëlle",
          "Henk",
          "Henkjan",
          "Henko",
          "Henna",
          "Henneke",
          "Hennelien",
          "Hennes",
          "Hennie",
          "Henno",
          "Henny",
          "Henri",
          "Henria",
          "Henrick",
          "Henrico",
          "Henriek",
          "Henrieke",
          "Henriene",
          "Henrik",
          "Henrita",
          "Henritha",
          "Henriët",
          "Henriëtte",
          "Henry",
          "Henske",
          "Herbert",
          "Herco",
          "Heriëtte",
          "Herjan",
          "Herjanne",
          "Herlinde",
          "Herliëth",
          "Herman",
          "Hermanus",
          "Hermina",
          "Hermine",
          "Herna",
          "Hero",
          "Herrald",
          "Herry",
          "Hervé",
          "Herwald",
          "Herwin",
          "Hesco",
          "Hessel",
          "Hester",
          "Hette",
          "Heva",
          "Hiba",
          "Hidde",
          "Hieke",
          "Hielke",
          "Hielkje",
          "Hielko",
          "Hijko",
          "Hijlke",
          "Hijmke",
          "Hilaya",
          "Hilbert",
          "Hilco",
          "Hilda",
          "Hilde",
          "Hildo",
          "Hilja",
          "Hilke",
          "Hilko",
          "Hillary",
          "Hille",
          "Hilleane",
          "Hilleen",
          "Hillene",
          "Hillianne",
          "Hillyanne",
          "Hilma",
          "Hilse",
          "Hilsje",
          "Hiltjo",
          "Hilâl",
          "Himmet",
          "Hind",
          "Hindrik",
          "Hindrikje",
          "Hinse",
          "Hischia",
          "Hiske",
          "Hizkia",
          "Hjalmar",
          "Hjordis",
          "Hobbe",
          "Hobie",
          "Hoi",
          "Holger",
          "Hong",
          "Hortie",
          "Houda",
          "Hristo",
          "Huey",
          "Hugine",
          "Hugo",
          "Huib",
          "Huibert",
          "Huibertje",
          "Huppie",
          "Huub",
          "Huyen",
          "Hyleco",
          "Hylke",
          "Hèlanie",
          "Hélène",
          "Hémke",
          "Hüliya",
          "Hülya",
          "Ian",
          "Ianthe",
          "Iard",
          "Ibe",
          "Iboyca",
          "Ibrahim",
          "Ibsa",
          "Ibtissam",
          "Ichelle",
          "Ico",
          "Ida",
          "Idelette",
          "Idhuna",
          "Idris",
          "Ids",
          "Idske",
          "Idwer",
          "Iede",
          "Iefke",
          "Iekelien",
          "Ieme",
          "Iep",
          "Ifa",
          "Ifna",
          "Igmar",
          "Ignaat",
          "Ignace",
          "Ignacio",
          "Ignas",
          "Igor",
          "Igrayne",
          "Ihab",
          "Ihlay",
          "Iida",
          "IJde",
          "IJmert",
          "IJsbrand",
          "IJtzen",
          "Ike",
          "Ikenna",
          "Ikram",
          "Ilan",
          "Ilana",
          "Ilaniek",
          "Ilayda",
          "Ildi",
          "Ildiko",
          "Ileen",
          "Ilhami",
          "Ilias",
          "Ilie",
          "Ilja",
          "Iljoes",
          "Ilka",
          "Ilke",
          "Ilker",
          "Illin",
          "Ilna",
          "Ilon",
          "Ilona",
          "Ilonda",
          "Ilone",
          "Ilonka",
          "Iloy",
          "Ilsa",
          "Ilse",
          "Ilske",
          "Ilva",
          "Ilvie",
          "Ilvy",
          "Ilya",
          "Ilze",
          "Ilène",
          "Iman",
          "Imane",
          "Imani",
          "Imany",
          "Imara",
          "Imare",
          "Imaro",
          "Imelda",
          "Imgert",
          "Imke",
          "Imko",
          "Immanuel",
          "Imme",
          "Imogen",
          "Imoghean",
          "Imran",
          "Imre",
          "Imro",
          "Inayah",
          "Indi",
          "India",
          "Indiana",
          "Indira",
          "Indra",
          "Indy",
          "Ine",
          "Ineke",
          "Ines",
          "Inessa",
          "Inesse",
          "Inez",
          "Inga",
          "Inge",
          "Ingeborg",
          "Ingela",
          "Ingelien",
          "Ingelise",
          "Ingemar",
          "Inger",
          "Ingfielt",
          "Ingmar",
          "Ingo",
          "Ingrid",
          "Inja",
          "Inje",
          "Inke",
          "Inne",
          "Inneke",
          "Innes",
          "Ino",
          "Inouchka",
          "Inouschka",
          "Inti",
          "Inès",
          "Ioannis",
          "Iona",
          "Ionah",
          "Iorio",
          "Iphnan",
          "Ippe",
          "Ira",
          "Irah",
          "Irana",
          "Iraïs",
          "Irbe",
          "Ireen",
          "Ireentje",
          "Irem",
          "Irena",
          "Irene",
          "Ireneo",
          "Irha",
          "Irian",
          "Irin",
          "Irina",
          "Irini",
          "Iris",
          "Irisa",
          "Irish",
          "Irja",
          "Irma",
          "Irmen",
          "Irmin",
          "Irna",
          "Irone",
          "Iroska",
          "Iroy",
          "Irsa",
          "Irsan",
          "Irthe",
          "Irvin",
          "Irwin",
          "Isa",
          "Isaac",
          "Isaak",
          "Isabeau",
          "Isabel",
          "Isabella",
          "Isabelle",
          "Isaiah",
          "Isaura",
          "Isaäk",
          "Isca",
          "Ise",
          "Isfaha",
          "Isha",
          "Ishana",
          "Ishara",
          "Ishri",
          "Ishwar",
          "Isis",
          "Iskander",
          "Isla",
          "Ismael",
          "Ismay",
          "Ismaël",
          "Ismene",
          "Ismini",
          "Isobel",
          "Isolde",
          "Isra",
          "Issa",
          "Issaschar",
          "Istar",
          "Istref",
          "István",
          "Itchie",
          "Iteke",
          "Iva",
          "Ivan",
          "Ivana",
          "Ivanca",
          "Ivancka",
          "Ivania",
          "Ivanka",
          "Ivanna",
          "Ivano",
          "Ivar",
          "Ive",
          "Iven",
          "Ives",
          "Ivette",
          "Ivo",
          "Ivon",
          "Ivonne",
          "Ivor",
          "Ivy",
          "Iwan",
          "Iwein",
          "Iwen",
          "Iwikje",
          "Ixora",
          "Iza",
          "Izaac",
          "Izabella",
          "Izak",
          "Ize",
          "Izem",
          "Izi",
          "Izy",
          "Iñigo",
          "Jaan",
          "Jaantje",
          "Jaap",
          "Jabco",
          "Jabik",
          "Jabir",
          "Jabuck",
          "Jacco",
          "Jaccy",
          "Jace",
          "Jacek",
          "Jacintha",
          "Jacinthe",
          "Jack",
          "Jackelien",
          "Jackie",
          "Jacklynn",
          "Jacko",
          "Jackson",
          "Jacky",
          "Jaclyn",
          "Jaco",
          "Jacob",
          "Jacobien",
          "Jacobiene",
          "Jacobine",
          "Jacolien",
          "Jacoliene",
          "Jacoline",
          "Jacomien",
          "Jacon",
          "Jacopo",
          "Jacquelien",
          "Jacqueline",
          "Jacques",
          "Jacquiëlle",
          "Jacy",
          "Jada",
          "Jade",
          "Jaden",
          "Jadey",
          "Jadi",
          "Jadian",
          "Jadine",
          "Jaditha",
          "Jady",
          "Jadzyah",
          "Jaeike",
          "Jael",
          "Jaela",
          "Jaey",
          "Jahmairo",
          "Jaibreyon",
          "Jaiden",
          "Jaider",
          "Jaidy",
          "Jaier",
          "Jaike",
          "Jaime",
          "Jaimee",
          "Jaimey",
          "Jaimie",
          "Jaimy",
          "Jaimé",
          "Jainy",
          "Jair",
          "Jairo",
          "Jairzinho",
          "Jaitse",
          "Jaivy",
          "Jake",
          "Jakko",
          "Jako",
          "Jakob",
          "Jakolien",
          "Jaleesa",
          "Jaleesha",
          "Jalena",
          "Jalessa",
          "Jalien",
          "Jalinde",
          "Jalisa",
          "Jalisca",
          "Jalou",
          "Jalyssa",
          "Jamaica",
          "Jamaine",
          "Jamal",
          "James",
          "Jametta",
          "Jamey",
          "Jami",
          "Jamie",
          "Jamiel",
          "Jamil",
          "Jamila",
          "Jamilla",
          "Jamir",
          "Jamirico",
          "Jamiro",
          "Jamon",
          "Jamy",
          "Jan",
          "Jana",
          "Janay",
          "Janco",
          "Jandar",
          "Jander",
          "Jane",
          "Janeck",
          "Janelin",
          "Janelle",
          "Janet",
          "Janette",
          "Janey",
          "Jani",
          "Janice",
          "Janick",
          "Janida",
          "Janiek",
          "Janieke",
          "Janienke",
          "Janike",
          "Janilée",
          "Janin",
          "Janina",
          "Janine",
          "Janinka",
          "Janique",
          "Janita",
          "Janke",
          "Janko",
          "Janna",
          "Jannah",
          "Jannart",
          "Janne",
          "Janneau",
          "Jannec",
          "Janneke",
          "Jannelena",
          "Jannelie",
          "Jannemarie",
          "Jannemiek",
          "Jannemieke",
          "Jannes",
          "Jannet",
          "Jannette",
          "Jannice",
          "Jannick",
          "Jannicke",
          "Jannie",
          "Jannieke",
          "Jannik",
          "Jannika",
          "Jannina",
          "Jannine",
          "Jannita",
          "Janno",
          "Jannoula",
          "Jano",
          "Janoe",
          "Janosh",
          "Janou",
          "Janoux",
          "Jansina",
          "Janske",
          "Janthe",
          "Janthijs",
          "Jantiena",
          "Jantiene",
          "Jantina",
          "Jantine",
          "Jantje",
          "Jap",
          "Japke",
          "Jappie",
          "Jaqueline",
          "Jara",
          "Jarco",
          "Jard",
          "Jarda",
          "Jarde",
          "Jarden",
          "Jardi",
          "Jardy",
          "Jared",
          "Jarell",
          "Jari",
          "Jarick",
          "Jaricko",
          "Jarie",
          "Jarieke",
          "Jarik",
          "Jarin",
          "Jarina",
          "Jarine",
          "Jarino",
          "Jarisha",
          "Jarissa",
          "Jaritsa",
          "Jarkko",
          "Jarl",
          "Jarle",
          "Jarmen",
          "Jarmo",
          "Jarne",
          "Jarni",
          "Jarnick",
          "Jarnik",
          "Jarno",
          "Jaro",
          "Jarod",
          "Jarold",
          "Jarom",
          "Jaromir",
          "Jaron",
          "Jaronie",
          "Jaroslav",
          "Jarreau",
          "Jarren",
          "Jarrik",
          "Jarrod",
          "Jarryd",
          "Jarryl",
          "Jarst",
          "Jart",
          "Jarusha",
          "Jarvi",
          "Jarwin",
          "Jaryl",
          "Jaré",
          "Jascha",
          "Jaschenca",
          "Jashinka",
          "Jashvant",
          "Jasinka",
          "Jaska",
          "Jasmien",
          "Jasmijn",
          "Jasmin",
          "Jasmine",
          "Jason",
          "Jasper",
          "Jassin",
          "Jassine",
          "Jatinka",
          "Javaid",
          "Javea",
          "Javier",
          "Javina",
          "Jawad",
          "Jay",
          "Jay-Jay",
          "Jaya",
          "Jayant",
          "Jayanti",
          "Jayce",
          "Jaycee",
          "Jayda",
          "Jaydee",
          "Jayden",
          "Jaydey",
          "Jayke",
          "Jayla",
          "Jayleigh",
          "Jaylo",
          "Jaymie",
          "Jaymz",
          "Jayne",
          "Jaynie",
          "Jaypal",
          "Jaysen",
          "Jayson",
          "Jazz",
          "Jazzley",
          "Jazzy",
          "Jaël",
          "Jaëla",
          "Jaïro",
          "Jealine",
          "Jeamène",
          "Jean",
          "Jeanella",
          "Jeanet",
          "Jeanette",
          "Jeaney",
          "Jeanicque",
          "Jeanien",
          "Jeanine",
          "Jeanineke",
          "Jeanique",
          "Jeanne",
          "Jeannet",
          "Jeannine",
          "Jeannita",
          "Jeanno",
          "Jeanny",
          "Jeanot",
          "Jearon",
          "Jearrel",
          "Jebbie",
          "Jedidiah",
          "Jedidja",
          "Jedinja",
          "Jeditha",
          "Jeeco",
          "Jeen",
          "Jeewan",
          "Jef",
          "Jeff",
          "Jeffrey",
          "Jeffrie",
          "Jeffry",
          "Jefke",
          "Jefta",
          "Jega",
          "Jehan",
          "Jelany",
          "Jelbrig",
          "Jelco",
          "Jelda",
          "Jeldert",
          "Jeleesa",
          "Jelger",
          "Jeli",
          "Jelien",
          "Jelina",
          "Jelisa",
          "Jelke",
          "Jelle",
          "Jelleke",
          "Jellena",
          "Jellie",
          "Jellien",
          "Jellina",
          "Jelline",
          "Jellis",
          "Jelly",
          "Jelmar",
          "Jelme",
          "Jelmer",
          "Jelrik",
          "Jelske",
          "Jelt",
          "Jelte",
          "Jeltina",
          "Jeltje",
          "Jeltse",
          "Jeltsje",
          "Jelyn",
          "Jemaine",
          "Jemaira",
          "Jemmy",
          "Jen-Ai",
          "Jenco",
          "Jendy",
          "Jenell",
          "Jeneska",
          "Jenessa",
          "Jeniek",
          "Jenieke",
          "Jenienke",
          "Jenine",
          "Jenita",
          "Jenna",
          "Jenneke",
          "Jennely",
          "Jennemie",
          "Jennemiek",
          "Jennette",
          "Jennica",
          "Jennie",
          "Jenniek",
          "Jennieke",
          "Jennifer",
          "Jennika",
          "Jenno",
          "Jenny",
          "Jens",
          "Jense",
          "Jensen",
          "Jensey",
          "Jenske",
          "Jent",
          "Jente",
          "Jentel",
          "Jenthe",
          "Jentina",
          "Jenty",
          "Jephta",
          "Jerco",
          "Jere",
          "Jeremaih",
          "Jeremias",
          "Jeremie",
          "Jeremy",
          "Jerfaas",
          "Jerfy",
          "Jergus",
          "Jeri",
          "Jerica",
          "Jericho",
          "Jerina",
          "Jermain",
          "Jermaine",
          "Jermo",
          "Jermy",
          "Jerney",
          "Jeroen",
          "Jerom",
          "Jerome",
          "Jeron",
          "Jeronimo",
          "Jerphaas",
          "Jerre",
          "Jerrel",
          "Jerrian",
          "Jerrold",
          "Jerry",
          "Jersey",
          "Jertske",
          "Jerusha",
          "Jerwin",
          "Jerôme",
          "Jesca",
          "Jesco",
          "Jesine",
          "Jeske",
          "Jesko",
          "Jesler",
          "Jeslin",
          "Jesmer",
          "Jesper",
          "Jessa",
          "Jessalyn",
          "Jessamy",
          "Jesse",
          "Jesselyn",
          "Jessey",
          "Jessi",
          "Jessica",
          "Jessie",
          "Jessley",
          "Jessy",
          "Jessyca",
          "Jester",
          "Jet",
          "Jethro",
          "Jetse",
          "Jetske",
          "Jette",
          "Jettie",
          "Jetze",
          "Jewel",
          "Ji",
          "Jia",
          "Jibbe",
          "Jidde",
          "Jidske",
          "Jielis",
          "Jielles",
          "Jiery",
          "Jifke",
          "Jigal",
          "Jigaye",
          "Jijs",
          "Jikke",
          "Jilby",
          "Jilda",
          "Jildar",
          "Jildau",
          "Jilde",
          "Jildes",
          "Jildit",
          "Jildou",
          "Jilke",
          "Jill",
          "Jillan",
          "Jille",
          "Jilles",
          "Jillian",
          "Jilliano",
          "Jillin",
          "Jillis",
          "Jilly",
          "Jilske",
          "Jilva",
          "Jim",
          "Jimco",
          "Jimi",
          "Jimlee",
          "Jimme",
          "Jimmie",
          "Jimmy",
          "Jimte",
          "Jin",
          "Jindra",
          "Jindy",
          "Jinke",
          "Jinne",
          "Jinske",
          "Jinte",
          "Jiovanni",
          "Jip",
          "Jippe",
          "Jirana",
          "Jirina",
          "Jirka",
          "Jirre",
          "Jirrin",
          "Jirska",
          "Jiry",
          "Jisca",
          "Jisk",
          "Jiska",
          "Jiske",
          "Jismerai",
          "Jisse",
          "Jisvy",
          "Jita",
          "Jits",
          "Jitse",
          "Jitske",
          "Jitta",
          "Jitte",
          "Jitze",
          "Jivika",
          "Jizreël",
          "JJ",
          "Jo",
          "Joa",
          "Joab",
          "Joachim",
          "Joan",
          "Joanan",
          "Joanie",
          "Joanique",
          "Joanita",
          "Joanka",
          "Joanna",
          "Joanne",
          "Joanneke",
          "Joanny",
          "Joany",
          "Joaquin",
          "Joaquina",
          "Joardy",
          "Joas",
          "Job",
          "Jobbe",
          "Jobber",
          "Jobien",
          "Jobke",
          "Jocelyn",
          "Jochanan",
          "Joche",
          "Jochebed",
          "Jochem",
          "Jochiem",
          "Jochim",
          "Jodene",
          "Jodie",
          "Jody",
          "Joe",
          "Joek",
          "Joelle",
          "Joep",
          "Joepke",
          "Joeri",
          "Joerie",
          "Joery",
          "Joes",
          "Joey",
          "Joffra",
          "Joffrey",
          "Jogchum",
          "Johan",
          "Johann",
          "Johanna",
          "Johanne",
          "Johanneke",
          "Johannes",
          "Johara",
          "John",
          "Johndy",
          "Johnnie",
          "Johnno",
          "Johnny",
          "Johr",
          "Joia",
          "Joice",
          "Jojanneke",
          "Jok",
          "Jokelien",
          "Jola",
          "Jolanda",
          "Jolande",
          "Jolani",
          "Jolanthe",
          "Jolein",
          "Jolene",
          "Joleyn",
          "Jolie",
          "Jolieke",
          "Jolien",
          "Joliene",
          "Jolijn",
          "Jolijne",
          "Jolijt",
          "Jolina",
          "Jolinda",
          "Jolinde",
          "Joline",
          "Jolinka",
          "Jolisa",
          "Jolita",
          "Jolize",
          "Jolke",
          "Jolle",
          "Jolmer",
          "Jolyn",
          "Jolynn",
          "Jon",
          "Jona",
          "Jonah",
          "Jonan",
          "Jonar",
          "Jonas",
          "Jonat",
          "Jonatan",
          "Jonathan",
          "Jondalar",
          "Jonella",
          "Jonet",
          "Joni",
          "Jonie",
          "Jonine",
          "Jonna",
          "Jonne",
          "Jonneke",
          "Jonno",
          "Jonti",
          "Jontsje",
          "Jony",
          "Jools",
          "Joop",
          "Joos",
          "Joosje",
          "Joost",
          "Jop",
          "Jopie",
          "Joppe",
          "Joram",
          "Joran",
          "Jorben",
          "Jord",
          "Jordan",
          "Jorden",
          "Jordi",
          "Jordie",
          "Jordin",
          "Jordy",
          "Jorel",
          "Jorell",
          "Joren",
          "Jorg",
          "Jorghino",
          "Jorgi",
          "Jorgo",
          "Jorgé",
          "Jori",
          "Jorian",
          "Jorick",
          "Jorie",
          "Jorieke",
          "Jorien",
          "Joriena",
          "Joriene",
          "Joriet",
          "Jorijn",
          "Jorik",
          "Jorike",
          "Jorim",
          "Jorin",
          "Jorina",
          "Jorinda",
          "Jorinde",
          "Jorine",
          "Jorinke",
          "Jorino",
          "Jorique",
          "Joris",
          "Jorissa",
          "Jorit",
          "Jorja",
          "Jorke",
          "Jorn",
          "Jorne",
          "Jornt",
          "Jorran",
          "Jorren",
          "Jorrian",
          "Jorrick",
          "Jorrin",
          "Jorrit",
          "Jorryn",
          "Jorryt",
          "Jort",
          "Jorus",
          "Jos",
          "Josanne",
          "Josbert",
          "Josca",
          "Josee",
          "Josefa",
          "Josefien",
          "Joselyn",
          "Joseph",
          "Josephien",
          "Josephine",
          "Josette",
          "Josh",
          "Josha",
          "Joshe",
          "Joshka",
          "Joshua",
          "Josianne",
          "Josie",
          "Josine",
          "Josip",
          "Josje",
          "Joska",
          "Joske",
          "Josse",
          "Josselijn",
          "Josselin",
          "Josseline",
          "Jossica",
          "Jossie",
          "Josta",
          "Jostein",
          "Joster",
          "Josua",
          "Josyne",
          "José",
          "Joséphine",
          "Jotam",
          "Jotan",
          "Jotta",
          "Jouke",
          "Jouri",
          "Joury",
          "Jovana",
          "Jovanie",
          "Jovanka",
          "Jovanni",
          "Jovino",
          "Jowan",
          "Jowelle",
          "Jowi",
          "Jowieke",
          "Jowim",
          "Jowin",
          "Joy",
          "Joya",
          "Joyca",
          "Joyce",
          "Jozef",
          "Jozefien",
          "Jozien",
          "Jozua",
          "Joälle",
          "Joël",
          "Joëll",
          "Joëlla",
          "Joëlle",
          "Joëy",
          "Juan",
          "Juanita",
          "Juanito",
          "Jubinka",
          "Judie",
          "Judine",
          "Judith",
          "Judy",
          "Juenna",
          "Jula",
          "Jule",
          "Jules",
          "Julia",
          "Juliaan",
          "Julian",
          "Juliana",
          "Julianne",
          "Juliano",
          "Julias",
          "Julicke",
          "Julie",
          "Julien",
          "Julienne",
          "Juliet",
          "Julietta",
          "Juliette",
          "Julika",
          "Julina",
          "Julio",
          "Julisa",
          "Julisca",
          "Juliska",
          "Julissa",
          "Julius",
          "Julièn",
          "Juliën",
          "Juliët",
          "Juliëtte",
          "Julot",
          "July",
          "Julya",
          "Juma",
          "Jun",
          "June",
          "Junior",
          "Juno",
          "Junyfer",
          "Jur",
          "Juran",
          "Juray",
          "Jurdy",
          "Jure",
          "Jurek",
          "Jurgen",
          "Juri",
          "Juriaan",
          "Jurian",
          "Jurie",
          "Jurjan",
          "Jurjen",
          "Jurmaine",
          "Jurn",
          "Jurre",
          "Jurren",
          "Jurriaan",
          "Jurrian",
          "Jurriën",
          "Jusni",
          "Jussi",
          "Just",
          "Justa",
          "Juste",
          "Justen",
          "Justian",
          "Justien",
          "Justijn",
          "Justin",
          "Justine",
          "Justus",
          "Justy",
          "Jutta",
          "Juul",
          "Juulke",
          "Juultje",
          "Juup",
          "Jynte",
          "Jytte",
          "Järvi",
          "Jéhène",
          "Jéremy",
          "Jérien",
          "Jérôme",
          "Jöran",
          "Jörren",
          "Jørgen",
          "Jørre",
          "Jülide",
          "Jürgen",
          "Kaat",
          "Kaatje",
          "Kadeem",
          "Kadem",
          "Kadji",
          "Kady",
          "Kaely",
          "Kah",
          "Kahlan",
          "Kai",
          "Kaien",
          "Kaij",
          "Kailey",
          "Kaily",
          "Kaipo",
          "Kaisa",
          "Kaithlyn",
          "Kaitlyn",
          "Kaj",
          "Kaja",
          "Kajal",
          "Kalea",
          "Kaleb",
          "Kalina",
          "Kalineke",
          "Kalinka",
          "Kalle",
          "Kallisty",
          "Kam",
          "Kamiela",
          "Kamil",
          "Kamilia",
          "Kamin",
          "Kamran",
          "Kamyar",
          "Kandis",
          "Kane",
          "Kanisha",
          "Kanta",
          "Kanzy",
          "Kaoutar",
          "Kapinda",
          "Karan",
          "Kardo",
          "Kareem",
          "Karel",
          "Karelle",
          "Karen",
          "Karesla",
          "Kari",
          "Karianne",
          "Kariem",
          "Karije",
          "Karim",
          "Karimah",
          "Karin",
          "Karina",
          "Karjolieke",
          "Karlene",
          "Karli",
          "Karlien",
          "Karlijn",
          "Karly",
          "Karna",
          "Karola",
          "Karolien",
          "Karoline",
          "Karosh",
          "Kars",
          "Karst",
          "Karsten",
          "Kartika",
          "Kas",
          "Kasal",
          "Kashmira",
          "Kasim",
          "Kasper",
          "Katanja",
          "Kate",
          "Kateleine",
          "Kathalijn",
          "Katharina",
          "Kathelijn",
          "Kathelijne",
          "Katherine",
          "Kathi",
          "Kathinka",
          "Kathleen",
          "Kathlijn",
          "Kathy",
          "Katiana",
          "Katie",
          "Katinka",
          "Katja",
          "Kato",
          "Katouscha",
          "Katrien",
          "Katrijntje",
          "Katrin",
          "Katrina",
          "Katrine",
          "Kattelijn",
          "Katy",
          "Kavita",
          "Kay",
          "Kaya",
          "Kayanda",
          "Kaydee",
          "Kayla",
          "Kaylee",
          "Kayleigh",
          "Kayley",
          "Kaylie",
          "Kaylin",
          "Kaylée",
          "Kayne",
          "Kayo",
          "Kayra",
          "Kaz",
          "Kaïn",
          "Kaïs",
          "Keagan",
          "Kealey",
          "Kealy",
          "Keanu",
          "Keaven",
          "Keefer",
          "Keelan",
          "Keely",
          "Keenan",
          "Kees",
          "Keesjan",
          "Keetie",
          "Keetje",
          "Keevil",
          "Keije",
          "Keimpe",
          "Keith",
          "Keke",
          "Kelby",
          "Kelfey",
          "Kelhi",
          "Keli",
          "Kelian",
          "Kelley",
          "Kellin",
          "Kelly",
          "Kelsey",
          "Kelten",
          "Kelvin",
          "Kely",
          "Kemi",
          "Kemy",
          "Kenan",
          "Kendra",
          "Kendrick",
          "Kenjiro",
          "Kenly",
          "Kenna",
          "Kennard",
          "Kenneth",
          "Kennith",
          "Kenny",
          "Kenosha",
          "Kenrick",
          "Kent",
          "Kenya",
          "Kenzo",
          "Kenzy",
          "Keona",
          "Keresztély",
          "Keri",
          "Keriam",
          "Kerim",
          "Kersten",
          "Kervin",
          "Kerwin",
          "Kes",
          "Keshia",
          "Kessy",
          "Kety",
          "Keupie",
          "Keven",
          "Kevin",
          "Kevyn",
          "Keyanu",
          "Keye",
          "Keyon",
          "Keysha",
          "Khadija",
          "Khalil",
          "Khalisha",
          "Khusboo",
          "Kia",
          "Kian",
          "Kiandra",
          "Kiani",
          "Kiara",
          "Kiaya",
          "Kibo",
          "Kick",
          "Kicky",
          "Kid",
          "Kiefer",
          "Kiek",
          "Kieron",
          "Kiki",
          "Kikianne",
          "Kikki",
          "Kilay",
          "Kiley",
          "Kilian",
          "Killian",
          "Kim",
          "Kimani",
          "Kimara",
          "Kimber",
          "Kimberleigh",
          "Kimberley",
          "Kimberly",
          "Kimly",
          "Kimme",
          "Kimmelotte",
          "Kimmely",
          "Kimmo",
          "Kimmy",
          "Kimshana",
          "Kina",
          "Kindra",
          "Kine",
          "Kineke",
          "Kinny",
          "Kino",
          "Kinzi",
          "Kiomy",
          "Kiona",
          "Kira",
          "Kiran",
          "Kirby",
          "Kiri",
          "Kirian",
          "Kirin",
          "Kirina",
          "Kirmen",
          "Kirmie",
          "Kirolos",
          "Kiron",
          "Kirsi",
          "Kirsten",
          "Kirstin",
          "Kirsty",
          "Kirth",
          "Kirti",
          "Kiruna",
          "Kiryan",
          "Kishan",
          "Kishen",
          "Kiske",
          "Kit",
          "Kitana",
          "Kitty",
          "Kiyaro",
          "Kizzy",
          "Kjara",
          "Kjartan",
          "Kjel",
          "Kjeld",
          "Kjell",
          "Kjenta",
          "Kjetill",
          "Kjield",
          "Klaartje",
          "Klaas",
          "Klaasjan",
          "Klaes",
          "Klarieke",
          "Klarinda",
          "Klarine",
          "Klarissa",
          "Klasien",
          "Klasina",
          "Klasine",
          "Klaske",
          "Klazien",
          "Klaziena",
          "Klazina",
          "Klazine",
          "Kobe",
          "Kobie",
          "Koen",
          "Koene",
          "Koert",
          "Kommer",
          "Koob",
          "Koos",
          "Koosje",
          "Kor",
          "Korneel",
          "Kornel",
          "Korrie",
          "Kors",
          "Korstiaan",
          "Kos",
          "Kosse",
          "Kostas",
          "Kostein",
          "Koushirou",
          "Koyan",
          "Krijn",
          "Krineke",
          "Kris",
          "Krishna",
          "Krissie",
          "Krissy",
          "Krista",
          "Kristel",
          "Kristen",
          "Kristi",
          "Kristiaan",
          "Kristian",
          "Kristianne",
          "Kristie",
          "Kristien",
          "Kristin",
          "Kristina",
          "Kristine",
          "Kristof",
          "Kristy",
          "Kristél",
          "Krystina",
          "Krystle",
          "Kudret",
          "Kumara",
          "Kurt",
          "Kuun",
          "Kwabena",
          "Kyan",
          "Kyana",
          "Kyane",
          "Kyano",
          "Kyapwa",
          "Kyara",
          "Kyla",
          "Kyle",
          "Kyler",
          "Kylian",
          "Kylianna",
          "Kylie",
          "Kyllian",
          "Kyllie",
          "Kyma",
          "Kymara",
          "Kymora",
          "Kynja",
          "Kyo",
          "Kyoma",
          "Kyon",
          "Kyona",
          "Kyra",
          "Kyran",
          "Kyrana",
          "Kyrill",
          "Kyro",
          "Kyrola",
          "Käthe",
          "Kélian",
          "La",
          "Laas",
          "Lachlan",
          "Laetitia",
          "Lai-Fung",
          "Laila",
          "Laisa",
          "Lajea",
          "Lajla",
          "Lajos",
          "Laki",
          "Lakishia",
          "Lakshmi",
          "Lalique",
          "Lamanda",
          "Lamar",
          "Lamara",
          "Lambertine",
          "Lamindah",
          "Lammertine",
          "Lammie",
          "Lan",
          "Lana",
          "Lance",
          "Lander",
          "Lando",
          "Lani",
          "Lanny",
          "Lanon",
          "Lante",
          "Laquisha",
          "Lara",
          "Lard",
          "Larissa",
          "Lariz",
          "Larno",
          "Larry",
          "Lars",
          "Laschenko",
          "Lasse",
          "Laszlo",
          "Latifa",
          "Latifah",
          "Latisha",
          "Latoya",
          "Laudine",
          "Laudy",
          "Lauke",
          "Laura",
          "Lauraine",
          "Lauran",
          "Laurande",
          "Lauranne",
          "Laure",
          "Laureanne",
          "Laureen",
          "Laureline",
          "Lauren",
          "Laurena",
          "Laurence",
          "Laurens",
          "Laurensz",
          "Laurent",
          "Lauri",
          "Laurian",
          "Laurianne",
          "Laurie",
          "Laurien",
          "Lauriene",
          "Laurika",
          "Laurina",
          "Laurine",
          "Laurissa",
          "Laurit",
          "Laury",
          "Lauryn",
          "Laurèl",
          "Laurèlle",
          "Laushana",
          "Lauwrence",
          "Lauwrens",
          "Lavendel",
          "Lavigna",
          "Lavinia",
          "Lavita",
          "Lavonne",
          "Lawrence",
          "Layla",
          "Layos",
          "Layton",
          "Lazlo",
          "Laätzar",
          "Laïka",
          "Lea",
          "Leahna",
          "Lean",
          "Leander",
          "Leandra",
          "Leandro",
          "Leandros",
          "Leaniek",
          "Leann",
          "Leanna",
          "Leanne",
          "Lechana",
          "Leco",
          "Lee",
          "Leen",
          "Leena",
          "Leenard",
          "Leendert",
          "Leentje",
          "Leeroy",
          "Leeza",
          "Lefteris",
          "Leia",
          "Leida",
          "Leide",
          "Leigh",
          "Leighann",
          "Leih",
          "Leijn",
          "Leike",
          "Leila",
          "Leilia",
          "Leja",
          "Lejah",
          "Lejan",
          "Lejobe",
          "Lejon",
          "Leks",
          "Lela",
          "Lemmy",
          "Len",
          "Lena",
          "Lenada",
          "Lenardo",
          "Lendert",
          "Lene",
          "Lenhart",
          "Lenja",
          "Lenn",
          "Lenna",
          "Lennard",
          "Lennart",
          "Lenne",
          "Lenneke",
          "Lenner",
          "Lennert",
          "Lennie",
          "Lenno",
          "Lennon",
          "Lenny",
          "Lenore",
          "Lenrine",
          "Lente",
          "Lenthe",
          "Leny",
          "Leo",
          "Leon",
          "Leona",
          "Leonard",
          "Leonardo",
          "Leonce",
          "Leone",
          "Leoni",
          "Leonie",
          "Leoniek",
          "Leonieke",
          "Leonien",
          "Leonique",
          "Leonoor",
          "Leonora",
          "Leonore",
          "Leontien",
          "Leontine",
          "Leontyne",
          "Leony",
          "Leorah",
          "Leroij",
          "Leroy",
          "Lerôn",
          "Les",
          "Lesha",
          "Lesharo",
          "Lesley",
          "Leslie",
          "Lesly",
          "Lesse",
          "Letho",
          "Leticia",
          "Lette",
          "Lettie",
          "Lev",
          "Levey",
          "Levi",
          "Leviath",
          "Levien",
          "Levijah",
          "Levina",
          "Levinia",
          "Levy",
          "Lewis",
          "Lex",
          "Lexi",
          "Lexmy",
          "Lexy",
          "Leya",
          "Leyla",
          "Leyona",
          "Leôn",
          "Lhaksmi",
          "Li",
          "Lia",
          "Liam",
          "Lian",
          "Liana",
          "Lianca",
          "Liane",
          "Lianne",
          "Liannon",
          "Libby",
          "Licelle",
          "Lichella",
          "Lichelle",
          "Lida",
          "Liddy",
          "Lideke",
          "Lidewei",
          "Lideweij",
          "Lidewey",
          "Lidewij",
          "Liduina",
          "Lidwine",
          "Lidy",
          "Lidyhan",
          "Liecke",
          "Liedeke",
          "Liedy",
          "Liefke",
          "Liejèn",
          "Lieke",
          "Lien",
          "Liene",
          "Lieneke",
          "Lienke",
          "Lies",
          "Liesa",
          "Liesanne",
          "Liesbeth",
          "Liese",
          "Liesel",
          "Lieselot",
          "Lieselotte",
          "Lieset",
          "Lieske",
          "Liesl",
          "Lieuwe",
          "Lieuwke",
          "Lieve",
          "Lieveken",
          "Lieven",
          "Lieze",
          "Ligaya",
          "Liiban",
          "Lijanne",
          "Lijkel",
          "Lijon",
          "Lika",
          "Like",
          "Lila",
          "Lili",
          "Lilian",
          "Liliana",
          "Liliane",
          "Lillian",
          "Lilly",
          "Lillyjade",
          "Lilo",
          "Lilou",
          "Lily",
          "Lilya",
          "Lilyan",
          "Limahl",
          "Limalh",
          "Lin",
          "Lina",
          "Lincy",
          "Linda",
          "Linday",
          "Linde",
          "Linden",
          "Lindert",
          "Lindey",
          "Lindi",
          "Lindie",
          "Lindo",
          "Lindsay",
          "Lindsey",
          "Lindsy",
          "Lindy",
          "Line",
          "Lineke",
          "Linelle",
          "Linette",
          "Ling",
          "Linic",
          "Linn",
          "Linnea",
          "Linny",
          "Lino",
          "Linoesja",
          "Linor",
          "Linquenda",
          "Linsey",
          "Linsy",
          "Linthon",
          "Linton",
          "Linzy",
          "Lio",
          "Liola",
          "Lion",
          "Liona",
          "Lionda",
          "Lione",
          "Lionel",
          "Lioney",
          "Lionne",
          "Liora",
          "Lioz",
          "Lique",
          "Lirije",
          "Lis",
          "Lisa",
          "Lisabeau",
          "Lisah",
          "Lisalon",
          "Lisalotte",
          "Lisan",
          "Lisanka",
          "Lisanne",
          "Lise",
          "Liselore",
          "Liselot",
          "Liselotte",
          "Lisenka",
          "Liset",
          "Lisette",
          "Lisha",
          "Liske",
          "Lissa",
          "Lisse",
          "Lissey",
          "Litmar",
          "Liv",
          "Livay",
          "Livia",
          "Liviu",
          "Livius",
          "Livvy",
          "Livy",
          "Liz",
          "Liza",
          "Lizalorra",
          "Lizan",
          "Lizanne",
          "Lize",
          "Lizelot",
          "Lizette",
          "Lizz",
          "Lizzi",
          "Lizzie",
          "Lizzy",
          "Liël",
          "Ljubica",
          "Llorenç",
          "Lloyd",
          "Lloïc",
          "Lobke",
          "Lode",
          "Lodewijk",
          "Lody",
          "Loe",
          "Loed",
          "Loek",
          "Loeka",
          "Loeki",
          "Loekie",
          "Loes",
          "Loesan",
          "Loet",
          "Lois",
          "Lola",
          "Lolita",
          "Lon",
          "Long",
          "Lonne",
          "Lonneke",
          "Lonni",
          "Looy",
          "Lora",
          "Loraine",
          "Lorainne",
          "Loran",
          "Lore",
          "Loreane",
          "Loreen",
          "Loreena",
          "Loreine",
          "Lorella",
          "Loren",
          "Lorena",
          "Lorentz",
          "Lorenzo",
          "Lorenzs",
          "Loretta",
          "Lori",
          "Lorien",
          "Lorijn",
          "Lorin",
          "Lorinda",
          "Loris",
          "Lorraine",
          "Lorre",
          "Lory",
          "Lot",
          "Lotar",
          "Lotje",
          "Lotta",
          "Lotte",
          "Lottelein",
          "Lotty",
          "Lotus",
          "Lou",
          "Louana",
          "Loubna",
          "Loucinda",
          "Loudi",
          "Louella",
          "Loues",
          "Louie",
          "Louis",
          "Louisa",
          "Louise",
          "Louisiana",
          "Louk",
          "Louka",
          "Louky",
          "Loulou",
          "Loure",
          "Louren",
          "Lourens",
          "Lourenz",
          "Lousanne",
          "Louwe",
          "Louwra",
          "Lovely",
          "Lowie",
          "Loyce",
          "Loys",
          "Loïc",
          "Loïs",
          "Luan",
          "Lubbert",
          "Lubberta",
          "Lubbigje",
          "Lubert",
          "Lubina",
          "Lubèr",
          "Luc",
          "Luca",
          "Lucardy",
          "Lucas",
          "Lucel",
          "Luchien",
          "Luchina",
          "Lucia",
          "Lucian",
          "Luciano",
          "Lucie",
          "Luciel",
          "Lucien",
          "Lucienne",
          "Lucile",
          "Lucinda",
          "Lucinde",
          "Lucky",
          "Luco",
          "Lucy",
          "Lucya",
          "Lucyle",
          "Ludchano",
          "Ludo",
          "Ludwien",
          "Ludwig",
          "Luigi",
          "Luis",
          "Luisa",
          "Luit",
          "Luite",
          "Luitzen",
          "Luka",
          "Lukas",
          "Luke",
          "Lula",
          "Lulu",
          "Luna",
          "Lune",
          "Luscha",
          "Lusha",
          "Lute",
          "Lutina",
          "Lutske",
          "Luuc",
          "Luud",
          "Luuk",
          "Luuke",
          "Luut",
          "Luã",
          "Lyan",
          "Lyanna",
          "Lyanne",
          "Lybrich",
          "Lyckele",
          "Lydi",
          "Lydia",
          "Lydie",
          "Lydwien",
          "Lyette",
          "Lyke",
          "Lymee",
          "Lyn",
          "Lynda",
          "Lyndi",
          "Lyndsay",
          "Lynet",
          "Lynette",
          "Lynn",
          "Lynne",
          "Lyone",
          "Lyonne",
          "Lyotte",
          "Lysa",
          "Lysandro",
          "Lysanne",
          "Lysenka",
          "Lysette",
          "Lysian",
          "Lyske",
          "Lyssa",
          "Lyudmyla",
          "Lyzette",
          "Lâtife",
          "Léa",
          "Léan",
          "Léander",
          "Léanne",
          "Léanore",
          "Léjanne",
          "Léon",
          "Léoni",
          "Léonie",
          "Léroy",
          "Lòra",
          "Lútsen",
          "Maaik",
          "Maaike",
          "Maan",
          "Maaren",
          "Maarten",
          "Maartje",
          "Maas",
          "Maayke",
          "Mabs",
          "Mabèl",
          "Macey",
          "Macha",
          "Machael",
          "Machela",
          "Machella",
          "Machelle",
          "Machiel",
          "Machteld",
          "Macie",
          "Mack",
          "Macy",
          "Madalien",
          "Madani",
          "Madde",
          "Maddie",
          "Maddy",
          "Madeleen",
          "Madelein",
          "Madeleine",
          "Madelief",
          "Madelijn",
          "Madelinde",
          "Madelon",
          "Madelyn",
          "Madelène",
          "Madieke",
          "Madison",
          "Madita",
          "Mado",
          "Mads",
          "Mady",
          "Madé",
          "Mae",
          "Maedy",
          "Maeike",
          "Maelynn",
          "Maemi",
          "Maeve",
          "Magaidh",
          "Magali",
          "Magalie",
          "Magdaleen",
          "Maggie",
          "Magid",
          "Magnus",
          "Magteld",
          "Mahelia",
          "Mahez",
          "Mahsooma",
          "Mai",
          "Maica",
          "Maick",
          "Maickel",
          "Maico",
          "Maik",
          "Maike",
          "Maikel",
          "Maiko",
          "Maiky",
          "Maira",
          "Mairenn",
          "Mairin",
          "Maisha",
          "Maite",
          "Maitenna",
          "Maité",
          "Maja",
          "Majella",
          "Majka",
          "Majken",
          "Majlen",
          "Majlis",
          "Maks",
          "Malco",
          "Malcolm",
          "Malee",
          "Malek",
          "Malik",
          "Malika",
          "Malin",
          "Malinda",
          "Malindi",
          "Malissa",
          "Mallika",
          "Mallon",
          "Mallory",
          "Maloe",
          "Malon",
          "Malou",
          "Malouke",
          "Malu",
          "Malvin",
          "Malya",
          "Malynn",
          "Manal",
          "Manasse",
          "Mandely",
          "Mandy",
          "Maneesha",
          "Manel",
          "Manello",
          "Manet",
          "Manieska",
          "Manisha",
          "Manissa",
          "Manita",
          "Maniëlle",
          "Manja",
          "Mannes",
          "Mannetha",
          "Manny",
          "Mano",
          "Manoah",
          "Manoeska",
          "Manoli",
          "Manolya",
          "Manon",
          "Manou",
          "Manouk",
          "Manous",
          "Manousha",
          "Manoushka",
          "Mans",
          "Manu",
          "Manuel",
          "Manuela",
          "Manuelle",
          "Manus",
          "Manó",
          "Mao",
          "Mara",
          "Maraea",
          "Marald",
          "Maraly",
          "Maram",
          "Maran",
          "Maranata",
          "Marasha",
          "Marath",
          "Maraya",
          "Marc",
          "Marcel",
          "Marcelina",
          "Marcella",
          "Marcello",
          "Marcha",
          "Marchella",
          "Marchelle",
          "Marchien",
          "Marchim",
          "Marcia",
          "Marciano",
          "Marcin",
          "Marcio",
          "Marck",
          "Marco",
          "Marcus",
          "Marcy",
          "Mardi",
          "Mardieke",
          "Mardy",
          "Mare",
          "Marec",
          "Mareen",
          "Marek",
          "Marelda",
          "Marelien",
          "Marell",
          "Maren",
          "Marena",
          "Marene",
          "Marenne",
          "Mareno",
          "Marens",
          "Marenthe",
          "Maresa",
          "Maresha",
          "Maresi",
          "Marette",
          "Mareva",
          "Marga",
          "Margareth",
          "Margaretha",
          "Margaritha",
          "Margaux",
          "Margie",
          "Margies",
          "Margit",
          "Margite",
          "Margje",
          "Margo",
          "Margonda",
          "Margot",
          "Margreet",
          "Margreeth",
          "Margret",
          "Margreth",
          "Margriet",
          "Margryt",
          "Margy",
          "Marhilde",
          "Mari",
          "Maria",
          "Mariam",
          "Marian",
          "Mariangela",
          "Marianka",
          "Marianne",
          "Mariati",
          "Marick",
          "Maricke",
          "Marie",
          "Mariecke",
          "Mariek",
          "Marieke",
          "Marieken",
          "Marielle",
          "Marielse",
          "Marien",
          "Marieneke",
          "Marienes",
          "Marienjo",
          "Marienke",
          "Maries",
          "Mariet",
          "Marieta",
          "Mariete",
          "Marij",
          "Marija",
          "Marije",
          "Marijke",
          "Marijn",
          "Marijne",
          "Marijntje",
          "Marijon",
          "Marijs",
          "Marijse",
          "Marijt",
          "Marijtje",
          "Marika",
          "Marike",
          "Mariken",
          "Marilaine",
          "Marilee",
          "Marileen",
          "Marilene",
          "Marilieke",
          "Marilieze",
          "Marilinde",
          "Mariloe",
          "Marilotte",
          "Marilou",
          "Marilva",
          "Marilyn",
          "Marilène",
          "Marin",
          "Marina",
          "Marinda",
          "Marinde",
          "Marine",
          "Maringe",
          "Marinka",
          "Marinke",
          "Marinko",
          "Marinne",
          "Marinske",
          "Marinthe",
          "Marinus",
          "Mario",
          "Marion",
          "Marionne",
          "Marique",
          "Maris",
          "Marisa",
          "Marisca",
          "Marise",
          "Marisha",
          "Marisja",
          "Mariska",
          "Mariske",
          "Marisol",
          "Marissa",
          "Marisse",
          "Marisya",
          "Marit",
          "Marita",
          "Marith",
          "Maritza",
          "Marius",
          "Marize",
          "Mariël",
          "Mariëlla",
          "Mariëlle",
          "Mariësse",
          "Mariët",
          "Mariëtta",
          "Mariëtte",
          "Marjan",
          "Marjanka",
          "Marjanna",
          "Marjanne",
          "Marjet",
          "Marjette",
          "Marjoes",
          "Marjoke",
          "Marjolein",
          "Marjoleine",
          "Marjolie",
          "Marjolien",
          "Marjolijn",
          "Marjon",
          "Marjonne",
          "Marjos",
          "Marjus",
          "Mark",
          "Marka",
          "Markaryd",
          "Marko",
          "Markus",
          "Markwin",
          "Marla",
          "Marle",
          "Marlee",
          "Marleen",
          "Marleentje",
          "Marlen",
          "Marlene",
          "Marlette",
          "Marley",
          "Marli",
          "Marlia",
          "Marlie",
          "Marliek",
          "Marlieke",
          "Marlien",
          "Marlies",
          "Marlijn",
          "Marlijna",
          "Marlijne",
          "Marlijnn",
          "Marlim",
          "Marlin",
          "Marlinda",
          "Marlinde",
          "Marline",
          "Marlissa",
          "Marlisse",
          "Marlize",
          "Marloe",
          "Marloeke",
          "Marloes",
          "Marloeska",
          "Marlon",
          "Marlot",
          "Marlotte",
          "Marlou",
          "Marloucha",
          "Marlouk",
          "Marlouke",
          "Marlous",
          "Marluza",
          "Marly",
          "Marlynn",
          "Marlène",
          "Marn",
          "Marnelle",
          "Marnick",
          "Marnik",
          "Marnix",
          "Marné",
          "Maroes",
          "Maroesjka",
          "Marolise",
          "Maron",
          "Marouan",
          "Marouane",
          "Maroucha",
          "Maroula",
          "Marouscha",
          "Marouschka",
          "Maroushka",
          "Maroussia",
          "Marre",
          "Marrigje",
          "Marrit",
          "Marriële",
          "Marriët",
          "Marriëtte",
          "Marron",
          "Marry",
          "Mars",
          "Marscha",
          "Marschinka",
          "Marsha",
          "Marshall",
          "Mart",
          "Martan",
          "Marte",
          "Marteijn",
          "Martel",
          "Marten",
          "Martha",
          "Marthe",
          "Marthijn",
          "Marthijs",
          "Marti",
          "Martiene",
          "Martijn",
          "Martijntje",
          "Martika",
          "Martin",
          "Martina",
          "Martine",
          "Martinus",
          "Martje",
          "Marttanja",
          "Martène",
          "Marvin",
          "Marvy",
          "Marvyn",
          "Marwa",
          "Marwan",
          "Marwin",
          "Mary",
          "Marylene",
          "Maryline",
          "Marylse",
          "Marysa",
          "Maryse",
          "Marytha",
          "Maràyah",
          "Marçanne",
          "Marèl",
          "Marèll",
          "Marèse",
          "Masami",
          "Masaya",
          "Masha",
          "Maske",
          "Masny",
          "Mat",
          "Matan",
          "Matanja",
          "Matanya",
          "Mathea",
          "Mathee",
          "Matheo",
          "Mathew",
          "Mathias",
          "Mathien",
          "Mathies",
          "Mathieu",
          "Mathiez",
          "Mathijn",
          "Mathijs",
          "Mathilde",
          "Mathis",
          "Mathyn",
          "Mathé",
          "Matias",
          "Matija",
          "Matiji",
          "Matisse",
          "Mats",
          "Matt",
          "Mattanja",
          "Matteo",
          "Mattessa",
          "Matthea",
          "Mattheo",
          "Mattheus",
          "Matthew",
          "Matthia",
          "Matthias",
          "Matthieu",
          "Matthijs",
          "Matthys",
          "Matthé",
          "Matti",
          "Mattia",
          "Mattias",
          "Mattie",
          "Mattijn",
          "Mattijs",
          "Mattis",
          "Matts",
          "Matty",
          "Mattya",
          "Matté",
          "Matyi",
          "Matys",
          "Matz",
          "Maud",
          "Maudy",
          "Mauk",
          "Maup",
          "Maura",
          "Maureen",
          "Maurenke",
          "Mauri",
          "Maurice",
          "Maurick",
          "Maurien",
          "Mauries",
          "Maurijn",
          "Maurik",
          "Maurits",
          "Maurizio",
          "Mauro",
          "Maury",
          "Max",
          "Maxiem",
          "Maxien",
          "Maxim",
          "Maxime",
          "Maximiliaan",
          "Maximilian",
          "Maxine",
          "Maya",
          "Maybritt",
          "Mayella",
          "Mayelle",
          "Mayenne",
          "Mayke",
          "Maykel",
          "Mayken",
          "Mayla",
          "Maylo",
          "Maylon",
          "Mayon",
          "Mayra",
          "Mayron",
          "Mayté",
          "Mayuko",
          "Mayuri",
          "Mazarine",
          "Mazurka",
          "McKenzo",
          "Mea",
          "Meaghan",
          "Meake",
          "Meandra",
          "Meanne",
          "Mearle",
          "Mechelina",
          "Mechelle",
          "Mechiel",
          "Medde",
          "Medy",
          "Meehna",
          "Meerle",
          "Meerte",
          "Meerten",
          "Meerthe",
          "Mees",
          "Meeuwis",
          "Meg",
          "Megan",
          "Meggie",
          "Meghan",
          "Meghann",
          "Megin",
          "Mehdi",
          "Mehdy",
          "Mehmet",
          "Mei",
          "Meical",
          "Meie",
          "Meike",
          "Meindert",
          "Meinke",
          "Meint",
          "Meira",
          "Meisha",
          "Meissie",
          "Mejdoulin",
          "Mekel",
          "Mel",
          "Mela",
          "Melan",
          "Melanie",
          "Melany",
          "Melatti",
          "Melcher",
          "Melchert",
          "Melchior",
          "Melchor",
          "Melda",
          "Melenie",
          "Melenka",
          "Melianthe",
          "Melicio",
          "Meliek",
          "Melika",
          "Melinda",
          "Meline",
          "Melis",
          "Melisa",
          "Melisande",
          "Melissa",
          "Mellan",
          "Mellaney",
          "Mellanie",
          "Mellany",
          "Melle",
          "Melleny",
          "Mellijn",
          "Melline",
          "Mellis",
          "Mellisa",
          "Mellissa",
          "Melody",
          "Melony",
          "Melroy",
          "Mels",
          "Melse",
          "Melvin",
          "Melvyn",
          "Melwin",
          "Mendel",
          "Mendie",
          "Mendy",
          "Menje",
          "Menjous",
          "Menk",
          "Menka",
          "Menke",
          "Menko",
          "Menna",
          "Mennard",
          "Menne",
          "Menno",
          "Ment",
          "Mentha",
          "Menthe",
          "Menze",
          "Merana",
          "Merande",
          "Merav",
          "Mercedes",
          "Mercedez",
          "Mercella",
          "Merchier",
          "Merchy",
          "Mercè",
          "Meredith",
          "Merel",
          "Mereline",
          "Meren",
          "Merethé",
          "Meriam",
          "Merijn",
          "Merissa",
          "Merit",
          "Merith",
          "Merle",
          "Merlen",
          "Merlijn",
          "Merlin",
          "Merlinda",
          "Merlinde",
          "Merlissa",
          "Merre",
          "Merredith",
          "Mert",
          "Merten",
          "Merthe",
          "Merve",
          "Merwin",
          "Mery",
          "Meryam",
          "Meryem",
          "Meryl",
          "Mesach",
          "Messalina",
          "Metah",
          "Metehan",
          "Mette",
          "Mex",
          "Mexi",
          "Mexx",
          "Mexy",
          "Meya",
          "Meyke",
          "Meyra",
          "Mia",
          "Miarca",
          "Micaela",
          "Micah",
          "Micha",
          "Michael",
          "Michaell",
          "Michal",
          "Michan",
          "Michanou",
          "Michar",
          "Michaèl",
          "Michaël",
          "Michaëla",
          "Micheal",
          "Michel",
          "Michela",
          "Micheline",
          "Michelle",
          "Michiel",
          "Michon",
          "Michou",
          "Michèl",
          "Michèle",
          "Michèlle",
          "Michél",
          "Michéle",
          "Michélle",
          "Mick",
          "Mickay",
          "Mickeal",
          "Mickey",
          "Mickkel",
          "Micky",
          "Micolas",
          "Midas",
          "Midge",
          "Midun",
          "Miek",
          "Mieka",
          "Mieke",
          "Miel",
          "Mieneke",
          "Mienke",
          "Miep",
          "Miera",
          "Mies",
          "Mietek",
          "Migaela",
          "Miggy",
          "Migiel",
          "Mignon",
          "Miguel",
          "Mija",
          "Mijanou",
          "Mijntje",
          "Mik",
          "Mika",
          "Mikael",
          "Mikai",
          "Mikail",
          "Mikal",
          "Mikay",
          "Mike",
          "Mikela",
          "Mikey",
          "Mikki",
          "Miklos",
          "Miklós",
          "Mikolaj",
          "Mila",
          "Milada",
          "Milan",
          "Milaya",
          "Mildred",
          "Mileen",
          "Milena",
          "Milenco",
          "Milenka",
          "Milenko",
          "Miles",
          "Milette",
          "Milique",
          "Milka",
          "Milko",
          "Milla",
          "Mille",
          "Millie",
          "Milly",
          "Milo",
          "Miloe",
          "Milon",
          "Milos",
          "Milou",
          "Miloud",
          "Milouda",
          "Milroy",
          "Milton",
          "Mimi",
          "Min",
          "Mina",
          "Mindou",
          "Mindy",
          "Minette",
          "Minh",
          "Minjon",
          "Minjonet",
          "Mink",
          "Minka",
          "Minke",
          "Minne",
          "Minoesch",
          "Minou",
          "Minouk",
          "Minte",
          "Mintya",
          "Mioma",
          "Miora",
          "Miqaëla",
          "Miquel",
          "Miquitte",
          "Miquél",
          "Miquéle",
          "Miquël",
          "Mira",
          "Miran",
          "Miranda",
          "Mireau",
          "Mirei",
          "Mireille",
          "Mirel",
          "Mirella",
          "Mirelle",
          "Mirga",
          "Miria",
          "Miriam",
          "Mirije",
          "Mirim",
          "Mirja",
          "Mirjam",
          "Mirjana",
          "Mirke",
          "Mirko",
          "Mirl",
          "Mirlaine",
          "Mirle",
          "Mirli",
          "Mirlin",
          "Mirly",
          "Mirne",
          "Miro",
          "Miron",
          "Mirre",
          "Mirren",
          "Mirron",
          "Mirte",
          "Mirthe",
          "Miryam",
          "Miryea",
          "Miryeah",
          "Mirza",
          "Mirèse",
          "Mirée",
          "Misaël",
          "Mischa",
          "Misha",
          "Misja",
          "Misjèl",
          "Misra",
          "Misrie",
          "Mistral",
          "Misty",
          "Mitch",
          "Mitchel",
          "Mitchell",
          "Mitchey",
          "Mitran",
          "Mitsy",
          "Mitta",
          "Mitzi",
          "Mitzy",
          "Miëlla",
          "Mo",
          "Moana",
          "Modesty",
          "Modine",
          "Moed",
          "Mohammed",
          "Moira",
          "Moisha",
          "Moncef",
          "Mondie",
          "Monica",
          "Moniek",
          "Monika",
          "Monique",
          "Monir",
          "Monisha",
          "Mons",
          "Monte",
          "Montse",
          "Moo",
          "Moon",
          "Moos",
          "Moran",
          "Morane",
          "Moreno",
          "Morgan",
          "Morgana",
          "Morgane",
          "Morghane",
          "Morino",
          "Moritz",
          "Morris",
          "Morrison",
          "Morten",
          "Morvenna",
          "Moréno",
          "Moshe",
          "Moundir",
          "Mounir",
          "Moya",
          "Moïbe",
          "Moïse",
          "Muel",
          "Muhammad",
          "Mumtaz",
          "Muqet",
          "Muriël",
          "Muriëlle",
          "Murk",
          "Murphy",
          "Mushirah",
          "Muus",
          "Myanou",
          "Myck",
          "Myke",
          "Mylaine",
          "Mylan",
          "Mylia",
          "Mylie",
          "Mylon",
          "Mylou",
          "Mylène",
          "Myléne",
          "Mynthe",
          "Myon",
          "Myra",
          "Myrcea",
          "Myrdhin",
          "Myren",
          "Myriam",
          "Myrle",
          "Myrlin",
          "Myrna",
          "Myro",
          "Myron",
          "Myronne",
          "Myrren",
          "Myrte",
          "Myrthe",
          "Myrtle",
          "Mysthe",
          "Mária",
          "Mârlon",
          "Mèdellin",
          "Mèlani",
          "Mèlanie",
          "Mèranne",
          "Mélanie",
          "Mélischa",
          "Mérette",
          "Mêgan",
          "N'Dea",
          "N'kulu",
          "Na",
          "Na'shaya",
          "Nabila",
          "Nada",
          "Nadal",
          "Nadda",
          "Nadeche",
          "Nadedja",
          "Nadeem",
          "Nadi",
          "Nadia",
          "Nadiah",
          "Nadide",
          "Nadie",
          "Nadieh",
          "Nadiene",
          "Nadine",
          "Nadir",
          "Nadisha",
          "Nadiye",
          "Nadja",
          "Nadjara",
          "Nadjesdha",
          "Nadya",
          "Nadyl",
          "Nadyne",
          "Nadéche",
          "Naftali",
          "Naila",
          "Naim",
          "Naire",
          "Najola",
          "Nakisha",
          "Nakita",
          "Naletta",
          "Nalini",
          "Namara",
          "Nan",
          "Nana",
          "Nance",
          "Nanco",
          "Nancy",
          "Nanda",
          "Nander",
          "Nandine",
          "Nandini",
          "Nandio",
          "Nando",
          "Nandy",
          "Nanet",
          "Nanette",
          "Nanine",
          "Nanisha",
          "Nanja",
          "Nanko",
          "Nanna",
          "Nanne",
          "Nanneke",
          "Nannerelle",
          "Nannet",
          "Nannick",
          "Nannie",
          "Nanno",
          "Nanny",
          "Nanoek",
          "Nanou",
          "Nanouche",
          "Nanouck",
          "Nanouschka",
          "Nanya",
          "Naomi",
          "Naomy",
          "Narada",
          "Nard",
          "Narda",
          "Nardo",
          "Nardy",
          "Naresh",
          "Narjena",
          "Narouz",
          "Nash",
          "Nashara",
          "Nasheela",
          "Nasrin",
          "Nassim",
          "Nassma",
          "Nastassia",
          "Natacha",
          "Natalie",
          "Natalja",
          "Natanaël",
          "Natanja",
          "Natanya",
          "Natascha",
          "Natasha",
          "Natashia",
          "Natasja",
          "Nathalia",
          "Nathalie",
          "Nathalja",
          "Nathalya",
          "Nathan",
          "Nathanaël",
          "Nathaniel",
          "Nathanja",
          "Nathanje",
          "Nathascha",
          "Nathasja",
          "Nathilja",
          "Nathánaël",
          "Naud",
          "Naut",
          "Navajo",
          "Nawal",
          "Nawin",
          "Nayan",
          "Nayra",
          "Naza",
          "Nazaré",
          "Nazila",
          "Nazir",
          "Nazmi",
          "Naïem",
          "Neal",
          "Neeke",
          "Neel",
          "Neele",
          "Neeley",
          "Neelke",
          "Neels",
          "Neeltje",
          "Nehemia",
          "Nehuén",
          "Neil",
          "Neill",
          "Neis",
          "Nejia",
          "Nel",
          "Nele",
          "Neletta",
          "Nelian",
          "Nelianne",
          "Neline",
          "Nelinho",
          "Nelis",
          "Nelissa",
          "Nelize",
          "Nelle",
          "Nelleke",
          "Nellianne",
          "Nellie",
          "Nelline",
          "Nelske",
          "Nelson",
          "Nemi",
          "Nemo",
          "Nena",
          "Nencio",
          "Neno",
          "Nenske",
          "Neo",
          "Neomi",
          "Neomie",
          "Nephtis",
          "Nera",
          "Nerissa",
          "Nerisse",
          "Neryah",
          "Nese",
          "Nesia",
          "Nesrine",
          "Nette",
          "Nevada",
          "Nevin",
          "Niallan",
          "Nianne",
          "Nica",
          "Nichola",
          "Nicholas",
          "Nick",
          "Nickardo",
          "Nickey",
          "Nickie",
          "Nickolai",
          "Nicky",
          "Nico",
          "Nicol",
          "Nicola",
          "Nicolaas",
          "Nicolai",
          "Nicolas",
          "Nicolay",
          "Nicole",
          "Nicolet",
          "Nicolette",
          "Nicolien",
          "Nicoline",
          "Nicolás",
          "Nicôle",
          "Nidia",
          "Nieck",
          "Nieco",
          "Niek",
          "Nieke",
          "Niekee",
          "Niekele",
          "Niel",
          "Nielis",
          "Niels",
          "Nielse",
          "Niene",
          "Nieneke",
          "Nienja",
          "Nienke",
          "Niesje",
          "Niesjèn",
          "Nieske",
          "Nigel",
          "Nijs",
          "Nijswin",
          "Nik",
          "Nika",
          "Nikana",
          "Nikay",
          "Nike",
          "Nikhila",
          "Niki",
          "Nikie",
          "Nikita",
          "Nikki",
          "Nikkie",
          "Nikky",
          "Nikolai",
          "Nikor",
          "Nikos",
          "Niky",
          "Nikya",
          "Nikè",
          "Nikèle",
          "Niké",
          "Nikée",
          "Nilay",
          "Nili",
          "Nillis",
          "Nilou",
          "Nils",
          "Nilvana",
          "Nina",
          "Ninanda",
          "Nine",
          "Nineke",
          "Ninette",
          "Ninharra",
          "Ninho",
          "Ninja",
          "Ninke",
          "Nino",
          "Ninon",
          "Ninotchka",
          "Nirea",
          "Nisa",
          "Nisha",
          "Nishant",
          "Niske",
          "Nisma",
          "Nisrine",
          "Nita",
          "Nitida",
          "Nitin",
          "Nitish",
          "Nivard",
          "Niël",
          "Noa",
          "Noach",
          "Noah",
          "Noam",
          "Nobbie",
          "Nobilé",
          "Noecki",
          "Noek",
          "Noeka",
          "Noeki",
          "Noelia",
          "Noemie",
          "Noesjka",
          "Noey",
          "Nola",
          "Nolan",
          "Nolay",
          "Noleen",
          "Nollie",
          "Nomad",
          "Nomi",
          "Nomie",
          "Nona",
          "Nonja",
          "Nonke",
          "Nonna",
          "Noor",
          "Noora",
          "Noortje",
          "Nora",
          "Norah",
          "Noraly",
          "Noran",
          "Norbert",
          "Norbertus",
          "Nordin",
          "Norick",
          "Norieke",
          "Norman",
          "Norsiah",
          "Nort",
          "Nosa",
          "Nouchka",
          "Noud",
          "Noudie",
          "Nouk",
          "Noukje",
          "Nour",
          "Noura",
          "Nourdin",
          "Nourdine",
          "Nouri",
          "Nourthe",
          "Noury",
          "Nouschka",
          "Noushin",
          "Nousjka",
          "Nout",
          "Nova",
          "Novak",
          "Novel",
          "Nowell",
          "Nowi",
          "Noémi",
          "Noémie",
          "Noë",
          "Noël",
          "Noëlla",
          "Noëlle",
          "Noëmi",
          "Noïna",
          "Noömy",
          "Nubi",
          "Nuij",
          "Nur",
          "Nura",
          "Nusharat",
          "Nusiya",
          "Nutte",
          "Nyckele",
          "Nydia",
          "Nyika",
          "Nylas",
          "Nymke",
          "Nymphe",
          "Nyne",
          "Nynke",
          "Nándor",
          "Nèjet",
          "Núria",
          "Oane",
          "Oasis",
          "Obbe",
          "Obe",
          "Obed",
          "Ocean",
          "Oceanne",
          "Ocki",
          "Océane",
          "Oda",
          "Odessa",
          "Odette",
          "Odilio",
          "Odin",
          "Odinah",
          "Oebele",
          "Oedger",
          "Oege",
          "Oene",
          "Oetske",
          "Ofelia",
          "Ofra",
          "Oguz",
          "Ok",
          "Oka",
          "Okan",
          "Okke",
          "Okki",
          "Oktjen",
          "Olaf",
          "Olav",
          "Ole",
          "Olga",
          "Olgert",
          "Oliander",
          "Oliver",
          "Olivia",
          "Olivier",
          "Olle",
          "Olleke",
          "Ollie",
          "Olly",
          "Olmo",
          "Olof",
          "Olwen",
          "Omaira",
          "Omar",
          "Omer",
          "Omri",
          "Ona",
          "Onno",
          "Onur",
          "Onurcan",
          "Oona",
          "Ophélie",
          "Orban",
          "Orbo",
          "Orfeo",
          "Orhan",
          "Orian",
          "Orinda",
          "Oriona",
          "Orkun",
          "Orlando",
          "Orline",
          "Ornella",
          "Orrin",
          "Orriona",
          "Oscar",
          "Oshra",
          "Osin",
          "Oskar",
          "Oswin",
          "Ot",
          "Otger",
          "Othniël",
          "Otis",
          "Otje",
          "Otte",
          "Ottelien",
          "Otteliene",
          "Otto",
          "Otty",
          "Oualid",
          "Ouassim",
          "Ouren",
          "Outjer",
          "Owen",
          "Owyn",
          "Ozzie",
          "Pablo",
          "Pacelle",
          "Paco",
          "Paddy",
          "Padrick",
          "Pai-Lin",
          "Paige",
          "Palasha",
          "Paloma",
          "Pam",
          "Pammi",
          "Panchero",
          "Pander",
          "Panji",
          "Pank",
          "Paolo",
          "Parisch",
          "Paroene",
          "Parveenie",
          "Pascal",
          "Pascale",
          "Pascalle",
          "Pasha",
          "Pasqual",
          "Pasquale",
          "Passchier",
          "Pat",
          "Patjoelah",
          "Patricia",
          "Patrick",
          "Patriek",
          "Patrique",
          "Patty",
          "Paul",
          "Paula",
          "Pauley",
          "Pauli",
          "Paulie",
          "Paulien",
          "Paulina",
          "Pauline",
          "Paulinho",
          "Pauly",
          "Pauwel",
          "Pavel",
          "Pax",
          "Payel",
          "Pearl",
          "Pearly",
          "Pebbles",
          "Peder",
          "Pedram",
          "Pedro",
          "Peer",
          "Peerke",
          "Peet",
          "Peggy",
          "Peije",
          "Pel",
          "Pelle",
          "Pellina",
          "Pelueyne",
          "Penelope",
          "Penny",
          "Pepijn",
          "Peppa",
          "Per",
          "Percy",
          "Perine",
          "Perla",
          "Perlita",
          "Pernella",
          "Pernilla",
          "Pernille",
          "Perrie",
          "Perry",
          "Persia",
          "Persijn",
          "Peter",
          "Petra",
          "Petran",
          "Petri",
          "Petrie",
          "Petry",
          "Petter",
          "Petty",
          "Petula",
          "Peyton",
          "Phaedra",
          "Phanna",
          "Phebe",
          "Pherenikè",
          "Phil",
          "Phileine",
          "Philia",
          "Philine",
          "Philip",
          "Philipp",
          "Philippa",
          "Philippe",
          "Philippine",
          "Phill",
          "Philly",
          "Philo",
          "Phine",
          "Phoebe",
          "Phoenix",
          "Phylicia",
          "Phyline",
          "Phyllis",
          "Phyrine",
          "Phébe",
          "Pi-Jee",
          "Pia",
          "Pieja",
          "Pien",
          "Pierkje",
          "Pierre",
          "Piet",
          "Pieter",
          "Pieterbas",
          "Pieterjan",
          "Pieterke",
          "Pieternella",
          "Pietrix",
          "Pike",
          "Pilar",
          "Pilou",
          "Pim",
          "Pinnie",
          "Pippa",
          "Pippie",
          "Pirmin",
          "Piroska",
          "Piter",
          "Pjiërra",
          "Pjort",
          "Pjotr",
          "Pleuke",
          "Pleun",
          "Pleuni",
          "Pleunie",
          "Plien",
          "Pol",
          "Polle",
          "Polly",
          "Pom",
          "Pomeline",
          "Pommelien",
          "Pranay",
          "Prashant",
          "Prativinda",
          "Prayesh",
          "Precilla",
          "Prescilla",
          "Preshwand",
          "Pria",
          "Pricilla",
          "Prilissa",
          "Primo",
          "Princella",
          "Prisca",
          "Priscilla",
          "Priscillia",
          "Prissilla",
          "Priya",
          "Priyanka",
          "Prosper",
          "Ptesaem",
          "Puck",
          "Puk",
          "Purcy",
          "Purdey",
          "Pybe",
          "Pymm",
          "Pyne",
          "Pythia",
          "Pytrik",
          "Qian",
          "Qienie",
          "Qiëlle",
          "Qruun",
          "Quanah",
          "Quanilla",
          "Queeny",
          "Quemio",
          "Quentin",
          "Quentyn",
          "Querida",
          "Querine",
          "Quifaina",
          "Quilaine",
          "Quillermo",
          "Quin",
          "Quinby",
          "Quincey",
          "Quincie",
          "Quincy",
          "Quinlan",
          "Quinn",
          "Quinny",
          "Quint",
          "Quinta",
          "Quinte",
          "Quinten",
          "Quintijn",
          "Quintin",
          "Quintina",
          "Quinto",
          "Quinton",
          "Quintus",
          "Quinty",
          "Quinz",
          "Quirein",
          "Quirien",
          "Quirijn",
          "Quirin",
          "Quirine",
          "Quiriën",
          "Quiryn",
          "Quita",
          "Quyonne",
          "Qy",
          "Rabecca",
          "Rabia",
          "Rachana",
          "Rachaël",
          "Rachel",
          "Rachela",
          "Rachella",
          "Rachelle",
          "Rachid",
          "Rachma",
          "Rachèl",
          "Radha",
          "Radjend",
          "Radya",
          "Raemon",
          "Raf",
          "Rafael",
          "Rafaela",
          "Rafaël",
          "Rafaëla",
          "Rafaëlla",
          "Rafaëlle",
          "Raff",
          "Raffaela",
          "Rafid",
          "Rafik",
          "Rafiq",
          "Raghield",
          "Ragna",
          "Ragnar",
          "Ragni",
          "Ragnor",
          "Rahina",
          "Rahoel",
          "Railey",
          "Raimonda",
          "Rainaldo",
          "Rainier",
          "Rainy",
          "Raisa",
          "Raj",
          "Raja",
          "Rajeev",
          "Rajenco",
          "Rajiv",
          "Rajko",
          "Rajsa",
          "Raju",
          "Rakeseh",
          "Rakoen",
          "Ralf",
          "Ralph",
          "Rama",
          "Ramano",
          "Ramie",
          "Ramira",
          "Ramiro",
          "Ramon",
          "Ramona",
          "Ramses",
          "Ramzi",
          "Ramzy",
          "Ramón",
          "Ran",
          "Rana",
          "Ranald",
          "Ranchel",
          "Randall",
          "Randi",
          "Randie",
          "Randsley",
          "Randy",
          "Ranec",
          "Rani",
          "Rania",
          "Ranish",
          "Ranjit",
          "Rano",
          "Raoul",
          "Raphael",
          "Raphaela",
          "Raphay",
          "Raphaël",
          "Raphaëla",
          "Raquel",
          "Rard",
          "Rashel",
          "Rashil",
          "Raul",
          "Raun",
          "Raveena",
          "Raven",
          "Ravenna",
          "Ravi",
          "Ravien",
          "Ravindra",
          "Ravinia",
          "Ravish",
          "Ravy",
          "Rawi",
          "Rawita",
          "Ray",
          "Raychel",
          "Rayelle",
          "Rayen",
          "Rayene",
          "Rayenne",
          "Rayke",
          "Rayko",
          "Raymon",
          "Raymond",
          "Raymonde",
          "Raymone",
          "Rayna",
          "Rayner",
          "Raynold",
          "Raynor",
          "Rayvano",
          "Razia",
          "Raïsa",
          "Raïssa",
          "Raúl",
          "Raül",
          "Reamon",
          "Reanna",
          "Reanne",
          "Rebecca",
          "Rebekka",
          "Redmar",
          "Redmer",
          "Redmond",
          "Redney",
          "Redouan",
          "Reduan",
          "Reece",
          "Reemond",
          "Reena",
          "Reenie",
          "Refaël",
          "Rega",
          "Reggie",
          "Reggy",
          "Regiany",
          "Regien",
          "Regieta",
          "Regilio",
          "Regina",
          "Reginald",
          "Regis",
          "Regit",
          "Reguillo",
          "Reijer",
          "Rein",
          "Reina",
          "Reinalde",
          "Reinalt",
          "Reinard",
          "Reinate",
          "Reinbert",
          "Reinder",
          "Reindert",
          "Reineke",
          "Reinetta",
          "Reinhard",
          "Reinieke",
          "Reinier",
          "Reinike",
          "Reino",
          "Reinoud",
          "Reinout",
          "Reint",
          "Reitse",
          "Relano",
          "Relinde",
          "Relise",
          "Rembrandt",
          "Remco",
          "Remen",
          "Remi",
          "Remie",
          "Remke",
          "Remkje",
          "Remko",
          "Remmelt",
          "Remo",
          "Remon",
          "Remona",
          "Remy",
          "Renald",
          "Renalda",
          "Renaldo",
          "Renard",
          "Renate",
          "Renato",
          "Renco",
          "Renda",
          "Rende",
          "Rendi",
          "Renee",
          "Renelle",
          "Renettha",
          "Renger",
          "Rengernier",
          "Renie",
          "Reninka",
          "Renisha",
          "Renko",
          "Reno",
          "Renout",
          "Rens",
          "Rense",
          "Rensie",
          "Renske",
          "Reny",
          "Renze",
          "Renzo",
          "René",
          "Renée",
          "Reon",
          "Resa",
          "Reshma",
          "Reslyn",
          "Resy",
          "Reuben",
          "Reuven",
          "Revano",
          "Revee",
          "Revelino",
          "Revina",
          "Revlie",
          "Revée",
          "Rewhi",
          "Rex",
          "Reyer",
          "Reymbold",
          "Reynald",
          "Reynaldo",
          "Reynoud",
          "Reyyan",
          "Reza",
          "Rhandy",
          "Rhea",
          "Rhianne",
          "Rhiannon",
          "Rho",
          "Rhodee",
          "Rhoderick",
          "Rhodé",
          "Rhona",
          "Rhyonnah",
          "Rhys",
          "Riaan",
          "Rian",
          "Riana",
          "Rianda",
          "Rianka",
          "Rianke",
          "Rianna",
          "Riannah",
          "Rianne",
          "Riano",
          "Ricardo",
          "Riccardo",
          "Richaldo",
          "Richalle",
          "Richard",
          "Richarda",
          "Richel",
          "Richell",
          "Richella",
          "Richelle",
          "Richenel",
          "Richey",
          "Richie",
          "Richy",
          "Rick",
          "Ricky",
          "Rico",
          "Ricole",
          "Ridge",
          "Ridley",
          "Riduan",
          "Ridvan",
          "Ridwan",
          "Ridzert",
          "Riejanne",
          "Rieke",
          "Riekelt",
          "Riekie",
          "Riekje",
          "Rieko",
          "Rieks",
          "Riekus",
          "Rieky",
          "Riemer",
          "Rien",
          "Rieneke",
          "Rienette",
          "Rieni",
          "Rienk",
          "Rients",
          "Ries",
          "Riet",
          "Rieteke",
          "Rietje",
          "Rieuwert",
          "Riezel",
          "Riezé",
          "Rifka",
          "Rifky",
          "Rigo",
          "Rigobert",
          "Rigulmo",
          "Rijanne",
          "Rijck",
          "Rijk",
          "Rijkie",
          "Rijn",
          "Rijna",
          "Rijnko",
          "Rik",
          "Rikjan",
          "Rikke",
          "Rikko",
          "Rikst",
          "Rikus",
          "Rilana",
          "Riley",
          "Rili",
          "Rim",
          "Rima",
          "Rimco",
          "Rimke",
          "Rimmer",
          "Rimmie",
          "Rimona",
          "Rimsky",
          "Rina",
          "Rinath",
          "Rindert",
          "Rineke",
          "Rinel",
          "Rinesh",
          "Ringa",
          "Ringo",
          "Rinia",
          "Rinie",
          "Rink",
          "Rinke",
          "Rinkie",
          "Rinkja",
          "Rinkje",
          "Rinnert",
          "Rinnie",
          "Rins",
          "Rinse",
          "Rinske",
          "Rinskje",
          "Rintje",
          "Rinze",
          "Rio",
          "Rionne",
          "Riordan",
          "Ris",
          "Rischa",
          "Rishi",
          "Rishiewand",
          "Rishvan",
          "Risto",
          "Rita",
          "Ritch",
          "Ritchey",
          "Ritchie",
          "Ritchy",
          "Ritsaert",
          "Ritu",
          "Riva",
          "Rivaldo",
          "Rivano",
          "Rivka",
          "Rivo",
          "Rixt",
          "Rixte",
          "Riyad",
          "Riza",
          "Riëlle",
          "Riët",
          "Riëtta",
          "Roald",
          "Roan",
          "Roanne",
          "Rob",
          "Robbe",
          "Robbert",
          "Robbertjan",
          "Robbie",
          "Robbin",
          "Robby",
          "Robert",
          "Robertino",
          "Roberto",
          "Robertus",
          "Robey",
          "Robi",
          "Robias",
          "Robie",
          "Robien",
          "Robin",
          "Robina",
          "Robine",
          "Robinne",
          "Robrecht",
          "Roby",
          "Robyn",
          "Robynne",
          "Rocco",
          "Rochella",
          "Rochelle",
          "Roché",
          "Rocio",
          "Rocky",
          "Roderick",
          "Roderik",
          "Rodi",
          "Rodin",
          "Rodinde",
          "Rodney",
          "Rodny",
          "Rodolf",
          "Rodolfo",
          "Rodrigo",
          "Rody",
          "Roeanne",
          "Roel",
          "Roeland",
          "Roelanda",
          "Roele",
          "Roelfiena",
          "Roelie",
          "Roeliene",
          "Roelinda",
          "Roeline",
          "Roelinka",
          "Roelof",
          "Roemer",
          "Roepesh",
          "Roeshil",
          "Roewena",
          "Roger",
          "Rogerio",
          "Rogier",
          "Rogé",
          "Rogér",
          "Rohald",
          "Rohan",
          "Rohini",
          "Rohy",
          "Roisin",
          "Rojanne",
          "Rokus",
          "Rolan",
          "Roland",
          "Rolanda",
          "Rolf",
          "Rolien",
          "Rolinca",
          "Rolinda",
          "Rolinde",
          "Rolinka",
          "Rolph",
          "Roma",
          "Romaisa",
          "Roman",
          "Romana",
          "Romando",
          "Romane",
          "Romanie",
          "Romano",
          "Romany",
          "Romanya",
          "Romar",
          "Romario",
          "Romax",
          "Rombout",
          "Romec",
          "Romeck",
          "Romee",
          "Romeny",
          "Romeo",
          "Romero",
          "Romi",
          "Romie",
          "Romijn",
          "Romina",
          "Rominy",
          "Romke",
          "Rommert",
          "Rommie",
          "Romy",
          "Romynique",
          "Romé",
          "Romée",
          "Ron",
          "Ronald",
          "Ronaldo",
          "Ronan",
          "Ronell",
          "Ronella",
          "Ronin",
          "Ronique",
          "Roniëlle",
          "Ronja",
          "Ronne",
          "Ronnie",
          "Ronny",
          "Ronschau",
          "Rony",
          "Roo",
          "Roos",
          "Roosanne",
          "Roosje",
          "Rooske",
          "Roosmarie",
          "Roosmarijn",
          "Rorich",
          "Rory",
          "Rosa",
          "Rosalee",
          "Rosalia",
          "Rosalie",
          "Rosalien",
          "Rosalin",
          "Rosalinde",
          "Rosaline",
          "Rosaly",
          "Rosalyn",
          "Rosalyne",
          "Rosan",
          "Rosanna",
          "Rosannah",
          "Rosanne",
          "Rose",
          "Roselie",
          "Roselies",
          "Roselijne",
          "Roseline",
          "Roselique",
          "Rosemarie",
          "Rosemarije",
          "Rosemarijn",
          "Rosemary",
          "Rosemieke",
          "Rosemijn",
          "Rosemyn",
          "Roshan",
          "Roshila",
          "Roshni",
          "Roshnie",
          "Rosie",
          "Rosiena",
          "Rosita",
          "Rositha",
          "Ross",
          "Rossanno",
          "Roswell",
          "Roswita",
          "Roswitha",
          "Rouven",
          "Roviëny",
          "Rowaine",
          "Rowan",
          "Rowana",
          "Rowanda",
          "Rowanne",
          "Rowaya",
          "Rowdy",
          "Rowen",
          "Rowena",
          "Rowie",
          "Rowiena",
          "Rowin",
          "Rowina",
          "Rowinda",
          "Rowney",
          "Rowshan",
          "Rowy",
          "Roxaan",
          "Roxan",
          "Roxana",
          "Roxane",
          "Roxann",
          "Roxanna",
          "Roxanne",
          "Roxena",
          "Roxenne",
          "Roxy",
          "Roy",
          "Royi",
          "Roza",
          "Rozan",
          "Rozemarie",
          "Rozemarijn",
          "Rozemarijne",
          "Rozina",
          "Roëlle",
          "Ruan",
          "Ruben",
          "Rubert",
          "Rubin",
          "Ruby",
          "Rubya",
          "Rubèn",
          "Ruchama",
          "Ruchika",
          "Rudi",
          "Rudie",
          "Rudiëngelo",
          "Rudmer",
          "Rudo",
          "Rudolf",
          "Rueben",
          "Rufano",
          "Ruginio",
          "Rui",
          "Ruigi",
          "Ruiz",
          "Rumi",
          "Rumo",
          "Runa",
          "Runar",
          "Rune",
          "Rupert",
          "Russel",
          "Russell",
          "Rutger",
          "Rutgert",
          "Ruth",
          "Rutmer",
          "Ruud",
          "Ruudtje",
          "Ruurd",
          "Ruurdsje",
          "Ruël",
          "Ryan",
          "Ryanne",
          "Ryelle",
          "Rykold",
          "Rylana",
          "Ryn",
          "Ryon",
          "Réanna",
          "Régie",
          "Régis",
          "Rémon",
          "Rénan",
          "Réni",
          "Röwena",
          "Rúbia",
          "Rümeysa",
          "Saakien",
          "Saar",
          "Saartje",
          "Sabah",
          "Sabahat",
          "Sabeau",
          "Sabina",
          "Sabine",
          "Sabriena",
          "Sabrina",
          "Sabrine",
          "Sacha",
          "Sadriane",
          "Sadé",
          "Sadée",
          "Safanja",
          "Saffira",
          "Safiena",
          "Safiera",
          "Safira",
          "Sagitha",
          "Sagitta",
          "Sahièla",
          "Sahrone",
          "Sai",
          "Said",
          "Saida",
          "Saidou",
          "Saiën",
          "Saja",
          "Sajeda",
          "Sakina",
          "Sal",
          "Saladin",
          "Saleh",
          "Salem",
          "Salena",
          "Salina",
          "Salinia",
          "Sally",
          "Salma",
          "Salo",
          "Salome",
          "Salvador",
          "Salves",
          "Salvi",
          "Sam",
          "Samah",
          "Samantha",
          "Samara",
          "Samarinda",
          "Samenda",
          "Samentha",
          "Sami",
          "Samia",
          "Samiah",
          "Samien",
          "Samieo",
          "Samier",
          "Samih",
          "Samila",
          "Samina",
          "Samir",
          "Samira",
          "Samirah",
          "Samja",
          "Sammie",
          "Sammy",
          "Samo",
          "Samora",
          "Samuel",
          "Samuelle",
          "Samuël",
          "Samy",
          "Sana",
          "Sanaa",
          "Sancha",
          "Sanco",
          "Sander",
          "Sanderijn",
          "Sandhia",
          "Sando",
          "Sandor",
          "Sandra",
          "Sandrie",
          "Sandrien",
          "Sandrina",
          "Sandrine",
          "Sandro",
          "Sandré",
          "Sandy",
          "Sanette",
          "Sangita",
          "Sanja",
          "Sanjana",
          "Sanjay",
          "Sanjeeva",
          "Sanjiv",
          "Sanjula",
          "Sanna",
          "Sannah",
          "Sanne",
          "Sanneke",
          "Sannelieke",
          "Sannelien",
          "Sannemarije",
          "Sannemarijn",
          "Sannie",
          "Sanno",
          "Sanny",
          "Sanse",
          "Sansorei",
          "Santana",
          "Santiago",
          "Santina",
          "Santino",
          "Santoucha",
          "Sanya",
          "Sanza",
          "Saoed",
          "Saona",
          "Saphir",
          "Sara",
          "Sarah",
          "Sarai",
          "Sarana",
          "Saranda",
          "Saranne",
          "Saraya",
          "Sardee",
          "Sarella",
          "Sarena",
          "Saressa",
          "Sari",
          "Sarianne",
          "Sarina",
          "Sarine",
          "Sarissa",
          "Sarita",
          "Sarith",
          "Saritha",
          "Sarnia",
          "Saronna",
          "Sarra",
          "Saryo",
          "Sascha",
          "Sasha",
          "Sashenka",
          "Sasja",
          "Sasker",
          "Saskia",
          "Satnin",
          "Savan",
          "Savannah",
          "Savenna",
          "Savine",
          "Saviël",
          "Sawina",
          "Sayenna",
          "Saylenna",
          "Sayrah",
          "Saïda",
          "Saša",
          "Scanny",
          "Scarlet",
          "Scarlett",
          "Scato",
          "Schelte",
          "Schelyna",
          "Scott",
          "Scout",
          "Sean",
          "Seb",
          "Sebas",
          "Sebastiaan",
          "Sebastian",
          "Sebastien",
          "Sebastièn",
          "Sebastiën",
          "Sebby",
          "Sebnem",
          "Seda",
          "Sedat",
          "Seegert",
          "Sef",
          "Sefa",
          "Sefanja",
          "Seger",
          "Selena",
          "Selfina",
          "Selian",
          "Selim",
          "Selin",
          "Selina",
          "Selinde",
          "Seline",
          "Sella",
          "Selly",
          "Sellym",
          "Selma",
          "Selmo",
          "Seloua",
          "Selva",
          "Selwin",
          "Selwyn",
          "Sem",
          "Semia",
          "Semme",
          "Semmy",
          "Sen",
          "Sena",
          "Sendré",
          "Sendy",
          "Senn",
          "Senna",
          "Senne",
          "Sennie",
          "Senta",
          "Sentia",
          "Senze",
          "Sep",
          "Sepp",
          "Seppe",
          "Sequenna",
          "Sera",
          "Seraf",
          "Serafien",
          "Serah",
          "Seraina",
          "Serana",
          "Seranda",
          "Seray",
          "Seraya",
          "Serena",
          "Sergamy",
          "Serge",
          "Sergen",
          "Sergio",
          "Serhat",
          "Serina",
          "Serjana",
          "Serjay",
          "Serlo",
          "Serra",
          "Serrahya",
          "Serrano",
          "Serv",
          "Servie",
          "Serylio",
          "Seth",
          "Setje",
          "Setscha",
          "Setzer",
          "Sevan",
          "Sevanna",
          "Severin",
          "Severine",
          "Sevgi",
          "Sevven",
          "Seyhan",
          "Seyla",
          "Seymour",
          "Sezen",
          "Seán",
          "Shadee",
          "Shadé",
          "Shadée",
          "Shafira",
          "Shahira",
          "Shahnaz",
          "Shahzaad",
          "Shaila",
          "Shailesh",
          "Shaira",
          "Shaja",
          "Shakiel",
          "Shakyra",
          "Shalaina",
          "Shalamar",
          "Shalana",
          "Shalane",
          "Shaleen",
          "Shalina",
          "Shaline",
          "Shalini",
          "Shalinie",
          "Shamaila",
          "Shamiera",
          "Shamira",
          "Shamon",
          "Shan",
          "Shana",
          "Shanaya",
          "Shanda",
          "Shandia",
          "Shandro",
          "Shane",
          "Shaney",
          "Shania",
          "Shanice",
          "Shanigua",
          "Shanise",
          "Shanita",
          "Shanna",
          "Shannah",
          "Shanne",
          "Shannen",
          "Shannon",
          "Shanon",
          "Shanou",
          "Shanti",
          "Shanty",
          "Shanua",
          "Shanya",
          "Shanée",
          "Shaquille",
          "Shara",
          "Sharay",
          "Sharaya",
          "Sharda",
          "Shardé",
          "Shardée",
          "Shareev",
          "Sharella",
          "Sharelle",
          "Sharena",
          "Sharette",
          "Shari",
          "Sharida",
          "Sharief",
          "Sharif",
          "Sharifa",
          "Shariff",
          "Sharin",
          "Sharina",
          "Sharissa",
          "Sharita",
          "Sharlaine",
          "Sharlane",
          "Sharlon",
          "Sharmain",
          "Sharmaine",
          "Sharmayne",
          "Sharon",
          "Sharona",
          "Sharonique",
          "Sharonne",
          "Sharron",
          "Shary",
          "Sharyn",
          "Sharél",
          "Shasa",
          "Shatis",
          "Shaun",
          "Shauna",
          "Shauni",
          "Shaunté",
          "Shauny",
          "Shavenna",
          "Shawn",
          "Shawna",
          "Shawnee",
          "Shawny",
          "Shay",
          "Shay-Ann",
          "Shayen",
          "Shayenne",
          "Shaylee",
          "Shayne",
          "Shaynee",
          "Shaznay",
          "Shaïna",
          "Shaúla",
          "Shean",
          "Sheanne",
          "Sheba",
          "Shedy",
          "Sheelah",
          "Sheena",
          "Sheenika",
          "Sheila",
          "Sheilah",
          "Sheina",
          "Shelby",
          "Shelena",
          "Sheline",
          "Shelley",
          "Shelly",
          "Shelsey",
          "Shemara",
          "Shemayma",
          "Shena",
          "Shenena",
          "Shenna",
          "Shennelyn",
          "Shera",
          "Sheralee",
          "Sheranie",
          "Sherasade",
          "Shereen",
          "Sherick",
          "Sherida",
          "Sherien",
          "Sherilyn",
          "Sherina",
          "Sherinda",
          "Sherine",
          "Sherisha",
          "Sherley",
          "Sherlynn",
          "Shermain",
          "Sherona",
          "Sherryl",
          "Sherwin",
          "Sheryl",
          "Shesney",
          "Shevaun",
          "Shevon",
          "Shifaz",
          "Shifaët",
          "Shifra",
          "Shimon",
          "Shimroy",
          "Shinook",
          "Shinouk",
          "Shira",
          "Shiraaz",
          "Shireleah",
          "Shiri",
          "Shirien",
          "Shirin",
          "Shirley",
          "Shirly",
          "Shiva",
          "Shivam",
          "Shivane",
          "Shivani",
          "Shiyania",
          "Shoeraya",
          "Shoko",
          "Sholakhsana",
          "Shona",
          "Shoshoni",
          "Shreef",
          "Shri",
          "Shulie",
          "Shunita",
          "Shyrita",
          "Shéryl",
          "Shétiel",
          "Siard",
          "Sibe",
          "Sibel",
          "Sibold",
          "Sibren",
          "Sibrich",
          "Sicco",
          "Sicilia",
          "Sid",
          "Sidin",
          "Sidney",
          "Sido",
          "Sieb",
          "Siebe",
          "Siebrand",
          "Siebranda",
          "Siebrant",
          "Siebren",
          "Siebretta",
          "Sied",
          "Sieger",
          "Sieglin",
          "Sieglinde",
          "Siego",
          "Siegrid",
          "Siella",
          "Siem",
          "Sieme",
          "Siemen",
          "Siemke",
          "Sien",
          "Siena",
          "Sienna",
          "Siep",
          "Sierd",
          "Sierra",
          "Siert",
          "Sierus",
          "Sies",
          "Sietse",
          "Sietske",
          "Sietz",
          "Sietze",
          "Sieuwerd",
          "Siewerd",
          "Sifra",
          "Sigalle",
          "Siger",
          "Sigi",
          "Siglinde",
          "Sigo",
          "Sigourney",
          "Sigourny",
          "Sigrid",
          "Siham",
          "Sijanne",
          "Sijarina",
          "Sijbren",
          "Sijdine",
          "Sije",
          "Sijke",
          "Sijmen",
          "Sijrine",
          "Sijt",
          "Sijta",
          "Sika",
          "Sikira",
          "Sil",
          "Silas",
          "Silina",
          "Silja",
          "Silje",
          "Silke",
          "Sill",
          "Silva",
          "Silvain",
          "Silvan",
          "Silvana",
          "Silvanno",
          "Silvano",
          "Silvester",
          "Silvia",
          "Silvie",
          "Silvijn",
          "Silvio",
          "Silvy",
          "Sim",
          "Simar",
          "Simcha",
          "Simeon",
          "Simmie",
          "Simo",
          "Simon",
          "Simona",
          "Simone",
          "Sina",
          "Sinai",
          "Sinan",
          "Sinclair",
          "Sindhu",
          "Sindia",
          "Sindy",
          "Sineke",
          "Sinne",
          "Sino",
          "Sinsothany",
          "Sinta",
          "Sinyo",
          "Siobhan",
          "Siobhán",
          "Sip",
          "Siplo",
          "Sir",
          "Sira",
          "Sirach",
          "Siri",
          "Sis",
          "Siska",
          "Sissie",
          "Sita",
          "Sivar",
          "Siân",
          "Siënna",
          "Siërra",
          "Sjaak",
          "Sjaantje",
          "Sjacco",
          "Sjacky",
          "Sjadée",
          "Sjanie",
          "Sjaniene",
          "Sjanne",
          "Sjanoek",
          "Sjantana",
          "Sjardo",
          "Sjeel",
          "Sjef",
          "Sjeffrey",
          "Sjefke",
          "Sjenette",
          "Sjeng",
          "Sjimmie",
          "Sjir",
          "Sjirk",
          "Sjo",
          "Sjoerd",
          "Sjoeriene",
          "Sjoertje",
          "Sjon",
          "Sjors",
          "Sjouk",
          "Sjouke",
          "Sjoukje",
          "Sjuul",
          "Sjuulke",
          "Skender",
          "Skip",
          "Sky",
          "Skye",
          "Skylar",
          "Skyler",
          "Soefjen",
          "Soeminie",
          "Soenita",
          "Soeraya",
          "Soeredj",
          "Soesja",
          "Soetkin",
          "Sofia",
          "Sofian",
          "Sofie",
          "Sofieke",
          "Sofietje",
          "Sohan",
          "Sohanie",
          "Solange",
          "Solayka",
          "Soleil",
          "Soleine",
          "Solinah",
          "Solveig",
          "Solène",
          "Someya",
          "Sonay",
          "Sonia",
          "Sonique",
          "Sonja",
          "Sonnie",
          "Sonny",
          "Sonson",
          "Sooreechay",
          "Sophanna",
          "Sophia",
          "Sophie",
          "Sophieke",
          "Sophine",
          "Soraya",
          "Sorayda",
          "Sorcha",
          "Sosha",
          "Soufian",
          "Soufyan",
          "Souhaila",
          "Souhaïla",
          "Soundry",
          "Souverein",
          "Spike",
          "Sraja",
          "Staas",
          "Stacey",
          "Stacy",
          "Staffan",
          "Stafke",
          "Stan",
          "Stanley",
          "Stanneke",
          "Stans",
          "Stanse",
          "Stars",
          "Stash",
          "Stasz",
          "Steef",
          "Stef",
          "Stefaan",
          "Stefan",
          "Stefania",
          "Stefanie",
          "Stefano",
          "Steff",
          "Steffan",
          "Steffanie",
          "Steffany",
          "Steffen",
          "Steffi",
          "Steffie",
          "Stefi",
          "Stefke",
          "Steijn",
          "Stein",
          "Stella",
          "Stellios",
          "Sten",
          "Steph",
          "Stephan",
          "Stephana",
          "Stephanie",
          "Stephany",
          "Stephen",
          "Sterre",
          "Stevan",
          "Steve",
          "Steven",
          "Stevianne",
          "Stevie",
          "Steye",
          "Steyn",
          "Steyntje",
          "Stien",
          "Stig",
          "Stije",
          "Stijn",
          "Stijna",
          "Sting",
          "Stoffel",
          "Stojan",
          "Stoney",
          "Storm",
          "Storn",
          "Stuart",
          "Stèphanie",
          "Stéphane",
          "Stéphanie",
          "Sue",
          "Sueandra",
          "Sueraya",
          "Suganty",
          "Suleika",
          "Sulya",
          "Sumeya",
          "Sunaina",
          "Sundri",
          "Sundus",
          "Sunna",
          "Sunniva",
          "Sunny",
          "Suraj",
          "Suraya",
          "Sus",
          "Susan",
          "Susana",
          "Susanna",
          "Susannah",
          "Susanne",
          "Suse",
          "Susie",
          "Susilla",
          "Susy",
          "Suus",
          "Suzan",
          "Suzana",
          "Suzanna",
          "Suzanne",
          "Suze",
          "Suzet",
          "Suzette",
          "Suzi",
          "Suzy",
          "Svanne",
          "Svea",
          "Sven",
          "Svend",
          "Svenja",
          "Svenne",
          "Svennie",
          "Svenno",
          "Svenny",
          "Sverre",
          "Swa",
          "Swanette",
          "Sweder",
          "Swen",
          "Swinda",
          "Sya",
          "Syar",
          "Syb",
          "Sybe",
          "Sybren",
          "Sybrich",
          "Sybrine",
          "Sydney",
          "Sydo",
          "Syed",
          "Syfra",
          "Sykira",
          "Syl",
          "Sylke",
          "Syllia",
          "Sylvain",
          "Sylvan",
          "Sylvana",
          "Sylvano",
          "Sylvesta",
          "Sylvester",
          "Sylvia",
          "Sylvian",
          "Sylvie",
          "Symen",
          "Symena",
          "Synthia",
          "Syra",
          "Syralene",
          "Syri",
          "Syrina",
          "Sytse",
          "Sytske",
          "Sytze",
          "Syvart",
          "Sywarde",
          "Szymon",
          "Sèlena",
          "Sébastien",
          "Séréna",
          "Séverine",
          "Sêre",
          "Sínticha",
          "Sólon",
          "Sören",
          "Süeda",
          "Sümeyye",
          "Tabbe",
          "Tabitah",
          "Tabitha",
          "Tacilo",
          "Taco",
          "Tadinda",
          "Taeke",
          "Tahmee",
          "Tahnee",
          "Taika",
          "Take",
          "Tako",
          "Talbert",
          "Talia",
          "Talina",
          "Talisa",
          "Talishia",
          "Talissa",
          "Talitha",
          "Talja",
          "Talle",
          "Tallechien",
          "Tally",
          "Tama",
          "Tamar",
          "Tamara",
          "Tamarah",
          "Tamarind",
          "Taminho",
          "Tamino",
          "Tamira",
          "Tammy",
          "Tanea",
          "Tanguy",
          "Tanika",
          "Tanisha",
          "Tanit",
          "Tanita",
          "Tanja",
          "Tanne",
          "Tanneke",
          "Tanno",
          "Tanné",
          "Tanver",
          "Tanya",
          "Tanysha",
          "Tara",
          "Tarah",
          "Taran",
          "Tari",
          "Tarick",
          "Tarik",
          "Tariq",
          "Tarissa",
          "Tarquin",
          "Tasch",
          "Tasha",
          "Tashina",
          "Tassoula",
          "Tatchiana",
          "Tatiana",
          "Tatijana",
          "Tatjana",
          "Tatum",
          "Tatyana",
          "Tavi",
          "Tawny",
          "Taylor",
          "Tchissy",
          "Teade",
          "Teake",
          "Teanne",
          "Teatske",
          "Tecla",
          "Ted",
          "Teddie",
          "Teddy",
          "Teije",
          "Teis",
          "Temke",
          "Tenika",
          "Tenischa",
          "Tenynke",
          "Teo",
          "Teon",
          "Tequischa",
          "Terence",
          "Terje",
          "Terlissa",
          "Terra",
          "Terrence",
          "Terri",
          "Terry",
          "Tes",
          "Teske",
          "Tess",
          "Tessa",
          "Tesse",
          "Tessel",
          "Tessi",
          "Tessie",
          "Tessy",
          "Tet",
          "Tetsje",
          "Tetske",
          "Tettje",
          "Teun",
          "Teunard",
          "Teunette",
          "Teuni",
          "Teuntje",
          "Teus",
          "Tex",
          "Thalassa",
          "Thaleah",
          "Thalia",
          "Thalien",
          "Thalina",
          "Thalisa",
          "Thalita",
          "Thalya",
          "Thamea",
          "Thanh",
          "Thanos",
          "Thara",
          "Thari",
          "Tharischa",
          "Tharisha",
          "Thassia",
          "Thayrence",
          "Thaïsa",
          "Thaïsha",
          "Thaïsia",
          "Thea",
          "Theimen",
          "Thejon",
          "Thekla",
          "Thelma",
          "Themar",
          "Themba",
          "Thembi",
          "Theo",
          "Theodros",
          "Theon",
          "Therese",
          "Theresia",
          "Thessa",
          "Thetmar",
          "Theu",
          "Theun",
          "Theunis",
          "Theuntje",
          "Thiadrik",
          "Thiago",
          "Thiald",
          "Thialda",
          "Thibault",
          "Thibaut",
          "Thibo",
          "Thieme",
          "Thiemen",
          "Thiemo",
          "Thieri",
          "Thierry",
          "Thies",
          "Thije",
          "Thijm",
          "Thijme",
          "Thijmen",
          "Thijn",
          "Thijs",
          "Thilde",
          "Thildy",
          "Thilo",
          "Thim",
          "Thimar",
          "Thimo",
          "Thimon",
          "Thirsa",
          "Thirza",
          "Thirze",
          "Thisca",
          "Thiska",
          "Thiuri",
          "Thièrro",
          "Thobian",
          "Thom",
          "Thomas",
          "Thonke",
          "Thony",
          "Thor",
          "Thora",
          "Thorbe",
          "Thorben",
          "Thore",
          "Thorgal",
          "Thorne",
          "Thorsten",
          "Thriksy",
          "Thula",
          "Thulaï",
          "Thura",
          "Thy",
          "Thybeau",
          "Thye",
          "Thygo",
          "Thymen",
          "Thymo",
          "Thyn",
          "Thyra",
          "Thyrsah",
          "Thyrza",
          "Thys",
          "Thysa",
          "Thécla",
          "Théon",
          "Thérèse",
          "Tia",
          "Tiago",
          "Tialda",
          "Tialna",
          "Tiana",
          "Tianda",
          "Tianka",
          "Tiara",
          "Tiarde",
          "Tiba",
          "Tibbe",
          "Tibey",
          "Tibo",
          "Tibor",
          "Ticha",
          "Ticho",
          "Tico",
          "Tiede",
          "Tielke",
          "Tiemar",
          "Tieme",
          "Tiemen",
          "Tieneke",
          "Tienus",
          "Tiertje",
          "Ties",
          "Tietsje",
          "Tieu",
          "Tiffanny",
          "Tiffany",
          "Tiga",
          "Tigo",
          "Tije",
          "Tijen",
          "Tijl",
          "Tijme",
          "Tijmen",
          "Tijn",
          "Tijs",
          "Tika",
          "Tilde",
          "Tim",
          "Timar",
          "Timboy",
          "Timco",
          "Timen",
          "Timme",
          "Timmie",
          "Timmy",
          "Timo",
          "Timon",
          "Timothy",
          "Tina",
          "Tine",
          "Tineke",
          "Tinet",
          "Tinia",
          "Tinie",
          "Tinka",
          "Tinke",
          "Tinko",
          "Tinne",
          "Tinneke",
          "Tino",
          "Tinus",
          "Tirsa",
          "Tirza",
          "Tirzah",
          "Tisha",
          "Tishaawna",
          "Tishania",
          "Tissa",
          "Tithia",
          "Titus",
          "Titzya",
          "Tiuri",
          "Tivan",
          "Tiäna",
          "Tjabine",
          "Tjadda",
          "Tjade",
          "Tjaka",
          "Tjakko",
          "Tjalle",
          "Tjalling",
          "Tjamke",
          "Tjapco",
          "Tjarco",
          "Tjarda",
          "Tjardo",
          "Tjardy",
          "Tjark",
          "Tjarko",
          "Tjedrowald",
          "Tjeeraldo",
          "Tjeerd",
          "Tjendo",
          "Tjerk",
          "Tjerry",
          "Tjeu",
          "Tjibbe",
          "Tjilde",
          "Tjimkje",
          "Tjinta",
          "Tjitse",
          "Tjitske",
          "Tjitte",
          "Tjobbe",
          "Tjomme",
          "Tjongkonnie",
          "Toanne",
          "Tobi",
          "Tobian",
          "Tobias",
          "Tobie",
          "Tobit",
          "Toby",
          "Toine",
          "Toiny",
          "Tole",
          "Tom",
          "Tomas",
          "Tomaz",
          "Tommas",
          "Tommer",
          "Tommi",
          "Tommie",
          "Tommy",
          "Tomás",
          "Tonci",
          "Toni",
          "Tonie",
          "Toninho",
          "Tonio",
          "Tonka",
          "Tonke",
          "Tonki",
          "Tonko",
          "Tonnie",
          "Tonny",
          "Tony",
          "Toon",
          "Toontje",
          "Toos",
          "Tooske",
          "Torben",
          "Torfinn",
          "Tori",
          "Torkjell",
          "Torstein",
          "Tosca",
          "Toyah",
          "Tracy",
          "Travis",
          "Trees",
          "Tren",
          "Treney",
          "Tresan",
          "Tresita",
          "Trevor",
          "Trey",
          "Trieneke",
          "Trijnke",
          "Trijntje",
          "Trineke",
          "Trinke",
          "Trishtán",
          "Trista",
          "Tristan",
          "Tristen",
          "Troy",
          "Truderieke",
          "Trudi",
          "Trudie",
          "Trynette",
          "Trèfainyan",
          "Tsaya",
          "Tseard",
          "Tsilla",
          "Tsjalle",
          "Tsjalling",
          "Tsjerk",
          "Tsjikke",
          "Tsjisse",
          "Tuan",
          "Tudor",
          "Tufan",
          "Tujuh",
          "Tulsi",
          "Tum",
          "Tumsa",
          "Tuncer",
          "Tunnis",
          "Tuulia",
          "Tuur",
          "Twan",
          "Twannie",
          "Twanny",
          "Twinkel",
          "Twirre",
          "Tyana",
          "Tyara",
          "Tyard",
          "Tyas",
          "Tybalt",
          "Tyche",
          "Tycho",
          "Tyeisha",
          "Tygo",
          "Tyka",
          "Tyla",
          "Tyler",
          "Tymeck",
          "Tymen",
          "Tymo",
          "Tymon",
          "Tyra",
          "Tyrell",
          "Tyrese",
          "Tyron",
          "Tyrone",
          "Tyrza",
          "Tysha",
          "Tyso",
          "Tyson",
          "Tzivya",
          "Téo",
          "Tù",
          "Tünde",
          "Uddo",
          "Ufuk",
          "Ugo",
          "Uilke",
          "Ulmt",
          "Ulrike",
          "Umut",
          "Urs",
          "Ursel",
          "Ursela",
          "Usama",
          "Uschi",
          "Vaisa",
          "Vaitaira",
          "Valaine",
          "Valco",
          "Valdano",
          "Valentijn",
          "Valentin",
          "Valentina",
          "Valentine",
          "Valentino",
          "Valeria",
          "Valerie",
          "Valerio",
          "Valerye",
          "Valesca",
          "Vallerie",
          "Valèrie",
          "Valérie",
          "Valéry",
          "Vaneeta",
          "Vanessa",
          "Vanita",
          "Vanity",
          "Vanja",
          "Vanna",
          "Vasco",
          "Vasthi",
          "Veda",
          "Vedat",
          "Vedran",
          "Veerle",
          "Veikko",
          "Veiko",
          "Venice",
          "Venise",
          "Venna",
          "Venne",
          "Vera",
          "Veran",
          "Verde",
          "Vere",
          "Verelle",
          "Verena",
          "Verginia",
          "Veri",
          "Verie",
          "Vernon",
          "Vero",
          "Veron",
          "Verona",
          "Veronic",
          "Veronica",
          "Veronie",
          "Veronika",
          "Veronique",
          "Verron",
          "Very",
          "Vesna",
          "Vesta",
          "Vianne",
          "Vianney",
          "Vic",
          "Vicki",
          "Vicky",
          "Victoire",
          "Victor",
          "Victoria",
          "Victorine",
          "Vida",
          "Vienna",
          "Viggo",
          "Vigo",
          "Vijay",
          "Vikash",
          "Vikita",
          "Vikram",
          "Vikthor",
          "Viktor",
          "Viktorien",
          "Vilaya",
          "Vilja",
          "Viljar",
          "Vilmar",
          "Vilmor",
          "Vinand",
          "Vince",
          "Vincent",
          "Vincenzo",
          "Vinesh",
          "Vinish",
          "Vinnie",
          "Vinz",
          "Viola",
          "Violet",
          "Violetta",
          "Violette",
          "Vionne",
          "Virea",
          "Viresh",
          "Virgil",
          "Virgillia",
          "Virginie",
          "Virginnia",
          "Virna",
          "Vishani",
          "Vita",
          "Vital",
          "Vitas",
          "Vito",
          "Vitoria",
          "Vitto",
          "Vittòre",
          "Vivanne",
          "Vivian",
          "Viviane",
          "Vivianne",
          "Vivica",
          "Vivien",
          "Vivienne",
          "Vivike",
          "Vivièn",
          "Viviënne",
          "Viënna",
          "Vjera",
          "Vlinder",
          "Vogelina",
          "Volkert",
          "Vosmar",
          "Vosse",
          "Vreni",
          "Vreny",
          "Vroni",
          "Vronie",
          "Vroukje",
          "Vrouwke",
          "Vy",
          "Vydeline",
          "Vynia",
          "Vyo",
          "Váso",
          "Véronie",
          "Véronique",
          "Waatze",
          "Wai",
          "Wai-Co",
          "Walid",
          "Walinka",
          "Walt",
          "Walter",
          "Walther",
          "Wander",
          "Wanne",
          "Wannes",
          "Ward",
          "Warre",
          "Warren",
          "Warry",
          "Wasilis",
          "Watse",
          "Waukena",
          "Wauter",
          "Waylon",
          "Wayne",
          "Weam",
          "Weijma",
          "Welmoed",
          "Wen",
          "Wencke",
          "Wenda",
          "Wendel",
          "Wendell",
          "Wendie",
          "Wendy",
          "Wenke",
          "Wenneke",
          "Wernard",
          "Werner",
          "Werschell",
          "Wes",
          "Wescel",
          "Wesley",
          "Wesly",
          "Wessel",
          "Weyert",
          "Whitley",
          "Whitney",
          "Wia",
          "Wian",
          "Wianda",
          "Wianette",
          "Wianka",
          "Wianne",
          "Wiardi",
          "Wibe",
          "Wibo",
          "Wibout",
          "Wibren",
          "Wicher",
          "Wichert",
          "Wick",
          "Wicky",
          "Widrik",
          "Wiebart",
          "Wiebe",
          "Wieberen",
          "Wiebke",
          "Wiebo",
          "Wiebren",
          "Wiecke",
          "Wieger",
          "Wiek",
          "Wieke",
          "Wieland",
          "Wiemela",
          "Wienanda",
          "Wieneke",
          "Wienie",
          "Wiep",
          "Wierd",
          "Wieresh",
          "Wies",
          "Wiesje",
          "Wieske",
          "Wieteke",
          "Wietse",
          "Wietske",
          "Wietze",
          "Wiger",
          "Wijcher",
          "Wije",
          "Wijke",
          "Wijmke",
          "Wijnand",
          "Wijneliene",
          "Wikash",
          "Wikke",
          "Wil",
          "Wilber",
          "Wilbert",
          "Wilco",
          "Wildrik",
          "Wilger",
          "Wilgertine",
          "Wilhelm",
          "Wilianne",
          "Wiljan",
          "Wiljo",
          "Wiljon",
          "Wilke",
          "Wilkin",
          "Wilko",
          "Willanka",
          "Willard",
          "Willart",
          "Willeditke",
          "Willeke",
          "Willem",
          "Willemarthe",
          "Willemiek",
          "Willemieke",
          "Willemien",
          "Willemijke",
          "Willemijn",
          "Willemijnne",
          "Willemine",
          "William",
          "Willianne",
          "Williejanne",
          "Willine",
          "Willow",
          "Willy",
          "Willyjanne",
          "Willyon",
          "Wilma",
          "Wilmar",
          "Wilmer",
          "Wilmy",
          "Wilrieke",
          "Wilrik",
          "Wilte",
          "Wim",
          "Wimar",
          "Wimjan",
          "Wimke",
          "Winanneke",
          "Winant",
          "Wineke",
          "Winesh",
          "Winneke",
          "Winnie",
          "Winny",
          "Wino",
          "Winona",
          "Winston",
          "Wirna",
          "Wiske",
          "Wisse",
          "Witalik",
          "Witse",
          "Wivineke",
          "Wiwien",
          "Wladek",
          "Wladimir",
          "Woes",
          "Wolf",
          "Wolke",
          "Wolter",
          "Wonmen",
          "Wopke",
          "Woud",
          "Wouda",
          "Wout",
          "Wouter",
          "Wouterjan",
          "Wouthilde",
          "Wridzer",
          "Wrister",
          "Wubbo",
          "Wubby",
          "Wybe",
          "Wybren",
          "Wycher",
          "Wyko",
          "Wymer",
          "Wynette",
          "Wynona",
          "Wyona",
          "Wytse",
          "Wytske",
          "Wytze",
          "Xam",
          "Xan",
          "Xander",
          "Xandra",
          "Xandrine",
          "Xandro",
          "Xanne",
          "Xanthe",
          "Xanto",
          "Xarain",
          "Xarella",
          "Xaver",
          "Xaverio",
          "Xavier",
          "Xaviera",
          "Xaviéra",
          "Xem",
          "Xena",
          "Xenja",
          "Xenna",
          "Xennith",
          "Xeréa",
          "Xian",
          "Xilan",
          "Ximena",
          "Xin",
          "Xinia",
          "Xiomara",
          "Xochil",
          "Xynthia",
          "Ya-Ya",
          "Yabbo",
          "Yacin",
          "Yacintha",
          "Yade",
          "Yael",
          "Yagho",
          "Yakima",
          "Yale",
          "Yalenka",
          "Yalisa",
          "Yalmar",
          "Yami",
          "Yamiko",
          "Yamina",
          "Yammie",
          "Yana",
          "Yanaika",
          "Yancey",
          "Yandé",
          "Yanice",
          "Yanick",
          "Yaniek",
          "Yanieke",
          "Yanika",
          "Yanna",
          "Yannah",
          "Yannai",
          "Yanne",
          "Yanneke",
          "Yannemieke",
          "Yannic",
          "Yannick",
          "Yanniek",
          "Yannis",
          "Yanos",
          "Yanou",
          "Yanouck",
          "Yanív",
          "Yara",
          "Yardenah",
          "Yared",
          "Yaren",
          "Yari",
          "Yarich",
          "Yarin",
          "Yarmilla",
          "Yarmo",
          "Yarni",
          "Yarno",
          "Yaro",
          "Yarrick",
          "Yarron",
          "Yasemin",
          "Yasmijn",
          "Yasmin",
          "Yasmina",
          "Yasmine",
          "Yasper",
          "Yassin",
          "Yassine",
          "Yassir",
          "Yastika",
          "Yayla",
          "Yaz",
          "Yazz",
          "Yaël",
          "Yaëll",
          "Yaëlle",
          "Yaïka",
          "Yaïr",
          "Yaïra",
          "Yaïsha",
          "Ybe",
          "Ybele",
          "Yberè",
          "Yboya",
          "Yeala",
          "Yehya",
          "Yelmar",
          "Yelmer",
          "Yemi",
          "Yenca",
          "Yencie",
          "Yenna",
          "Yente",
          "Yentel",
          "Yenthe",
          "Yenthel",
          "Yenthl",
          "Yentl",
          "Yermo",
          "Yerne",
          "Yervin",
          "Yesenia",
          "Yesse",
          "Yessica",
          "Yessin",
          "Yesswan",
          "Yfke",
          "Yfonne",
          "Ygram",
          "Yhaël",
          "Yi",
          "Yilgör",
          "Yimo",
          "Ying",
          "Yinthe",
          "Yirca",
          "Yiri",
          "Yismerai",
          "Yke",
          "Ylai",
          "Ylenia",
          "Yliana",
          "Ylja",
          "Yllja",
          "Ylona",
          "Ylonka",
          "Ylse",
          "Ylva",
          "Ylze",
          "Ymca",
          "Ymco",
          "Yme",
          "Ymke",
          "Ymkje",
          "Ymme",
          "Yna",
          "Yno",
          "Ynse",
          "Ynske",
          "Yntse",
          "Ynze",
          "Yob",
          "Yocaste",
          "Yodi",
          "Yoek",
          "Yoeki",
          "Yoeran",
          "Yoerd",
          "Yoeri",
          "Yoerik",
          "Yoes",
          "Yoesri",
          "Yoica",
          "Yolan",
          "Yolanda",
          "Yole",
          "Yolin",
          "Yolinde",
          "Yoline",
          "Yollin",
          "Yona",
          "Yonah",
          "Yonathan",
          "Yonca",
          "Yoni",
          "Yonie",
          "Yonina",
          "Yonis",
          "Yonna",
          "Yooni",
          "Yoore",
          "Yoram",
          "Yoran",
          "Yorben",
          "Yorca",
          "Yordan",
          "Yordanka",
          "Yordi",
          "Yordy",
          "Yoren",
          "Yori",
          "Yorick",
          "Yorik",
          "Yorim",
          "Yorin",
          "Yorinde",
          "Yorinn",
          "Yoris",
          "Yorisha",
          "York",
          "Yorn",
          "Yorrick",
          "Yort",
          "Yos",
          "Yosca",
          "Yosh",
          "Yosha",
          "Yoshi",
          "Yoshie",
          "Yoshka",
          "Yosri",
          "Yosta",
          "Youandi",
          "Youk",
          "Younes",
          "Younez",
          "Youni",
          "Youp",
          "Youra",
          "Youri",
          "Yourick",
          "Yourie",
          "Yousef",
          "Youssra",
          "Yowanka",
          "Yoëlla",
          "Yoëlle",
          "Ype",
          "Ypie",
          "Yrreb",
          "Yrsa",
          "Ysabelle",
          "Ysanne",
          "Ysbrand",
          "Ysbrant",
          "Yselle",
          "Yssette",
          "Yteke",
          "Ytsje",
          "Yu",
          "Yuen-Man",
          "Yule",
          "Yuna",
          "Yunes",
          "Yunita",
          "Yunuën",
          "Yuri",
          "Yurian",
          "Yurn",
          "Yusuf",
          "Yva",
          "Yvan",
          "Yvana",
          "Yvanca",
          "Yvanka",
          "Yvar",
          "Yvelle",
          "Yvenka",
          "Yves",
          "Yvet",
          "Yvette",
          "Yvo",
          "Yvon",
          "Yvonne",
          "Zabelle",
          "Zach",
          "Zachery",
          "Zadik",
          "Zadrach",
          "Zahir",
          "Zahra",
          "Zaira",
          "Zamiera",
          "Zamira",
          "Zamé",
          "Zana",
          "Zanthe",
          "Zappa",
          "Zara",
          "Zarah",
          "Zatchel",
          "Zayenne",
          "Zayin",
          "Zayra",
          "Zaza",
          "Zazou",
          "Zaïef",
          "Zeb",
          "Zebulon",
          "Zefanja",
          "Zegert",
          "Zehna",
          "Zelâo",
          "Zena",
          "Zenith",
          "Zenja",
          "Zenna",
          "Zeno",
          "Zenon",
          "Zep",
          "Zerina",
          "Zev",
          "Zeyneb",
          "Zhen",
          "Zhino",
          "Zias",
          "Zico",
          "Zifra",
          "Ziggy",
          "Zilla",
          "Zillah",
          "Zilpa",
          "Zilvester",
          "Zina",
          "Zinaïda",
          "Zindziswa",
          "Zineb",
          "Zinho",
          "Zinio",
          "Zino",
          "Zinzi",
          "Zion",
          "Zippora",
          "Zipporah",
          "Zita",
          "Zitah",
          "Zjanne",
          "Zjuul",
          "Zoey",
          "Zoila",
          "Zola",
          "Zora",
          "Zorah",
          "Zoraima",
          "Zoran",
          "Zorin",
          "Zosima",
          "Zoubaida",
          "Zouher",
          "Zowa",
          "Zowie",
          "Zoè",
          "Zoë",
          "Zoëy",
          "Zsazsa",
          "Zulima",
          "Zuma",
          "Zwaantje",
          "Zwanet",
          "Zwier",
          "Zwkan",
          "Zyal",
          "Zyara",
          "Zyhilfra",
          "Zyla",
          "Zynia"
        ],
        "last_name": [
          "Aafjes",
          "Aaftink",
          "Aaij",
          "Aaken",
          "Aakster",
          "Aal",
          "Aalbers",
          "Aalbersberg",
          "Aalberts",
          "Aalbrecht",
          "Aalbregt",
          "Aalderen",
          "Aaldering",
          "Aalderink",
          "Aalders",
          "Aaldijk",
          "Aalpoel",
          "Aalsburg",
          "Aalst",
          "Aalsum",
          "Aalten",
          "Aaltink",
          "Aalvanger",
          "Aandewiel",
          "Aanen",
          "Aangeenbrug",
          "Aanholt",
          "Aanraad",
          "Aanstoot",
          "Aantjes",
          "Aar",
          "Aarab",
          "Aardema",
          "Aarden",
          "Aardenburg",
          "Aardoom",
          "Aardweg",
          "Aarle",
          "Aarnink",
          "Aarnoudse",
          "Aarnoutse",
          "Aarns",
          "Aarntzen",
          "Aarse",
          "Aarsen",
          "Aarsman",
          "Aarssen",
          "Aarst",
          "Aart",
          "Aarten",
          "Aartman",
          "Aarts",
          "Aartse",
          "Aartsen",
          "Aartsma",
          "Abarkan",
          "Abba",
          "Abbadi",
          "Abbas",
          "Abbassi",
          "Abbeelen",
          "Abbekerk",
          "Abbema",
          "Abbenhuis",
          "Abbes",
          "Abbing",
          "Abbink",
          "Abbo",
          "Abbou",
          "Abbring",
          "Abcouwer",
          "Abdalla",
          "Abdallah",
          "Abdellaoui",
          "Abdi",
          "Abdoel",
          "Abdoelkariem",
          "Abdoella",
          "Abdoelrahman",
          "Abdul",
          "Abdullah",
          "Abdullahi",
          "Abee",
          "Abeele",
          "Abeelen",
          "Abel",
          "Abelen",
          "Abeling",
          "Abeln",
          "Abels",
          "Aben",
          "Aberson",
          "Abma",
          "Abraham",
          "Abrahams",
          "Abrahamse",
          "Abspoel",
          "Abswoude",
          "Acar",
          "Acda",
          "Acer",
          "Achahbar",
          "Achalhi",
          "Acheampong",
          "Acht",
          "Achten",
          "Achterberg",
          "Achterbergh",
          "Achtereekte",
          "Achteren",
          "Achterhof",
          "Achterhuis",
          "Achterkamp",
          "Achterstraat",
          "Achthoven",
          "Achtien",
          "Ackema",
          "Acker",
          "Ackerman",
          "Ackermann",
          "Ackermans",
          "Acquoij",
          "Acton",
          "Adahchour",
          "Adam",
          "Adams",
          "Adamse",
          "Adamus",
          "Adan",
          "Adang",
          "Adank",
          "Adda",
          "Addens",
          "Addink",
          "Addouti",
          "Adegeest",
          "Adel",
          "Adelaar",
          "Adelaars",
          "Adelerhof",
          "Adema",
          "Aden",
          "Adhin",
          "Adigüzel",
          "Adjei",
          "Admiraal",
          "Adolfs",
          "Adriaans",
          "Adriaanse",
          "Adriaansen",
          "Adriaansens",
          "Adriaansz",
          "Adriaens",
          "Adriaensen",
          "Adrichem",
          "Advocaat",
          "Advokaat",
          "Aelbers",
          "Aelen",
          "Aelmans",
          "Aendekerk",
          "Aerde",
          "Aerdts",
          "Aerle",
          "Aert",
          "Aerts",
          "Aertsen",
          "Aertssen",
          "Afkir",
          "Afman",
          "Agelink",
          "Agema",
          "Agerbeek",
          "Aggelen",
          "Agricola",
          "Agt",
          "Agten",
          "Agterberg",
          "Agterbos",
          "Agteren",
          "Agterhof",
          "Agterhuis",
          "Agthoven",
          "Agtmaal",
          "Agyemang",
          "Ahlers",
          "Ahmad",
          "Ahmadi",
          "Ahmadzai",
          "Ahmed",
          "Ahmetović",
          "Ahrens",
          "Ahrouch",
          "Ahsmann",
          "Ahuis",
          "Aikema",
          "Aipassa",
          "Aissaoui",
          "Aissati",
          "Ajdid",
          "Ajjouri",
          "Ajodhia",
          "Ajoeb",
          "Ajouaou",
          "Ak",
          "Akachar",
          "Akar",
          "Akay",
          "Akbaba",
          "Akbar",
          "Akbari",
          "Akbaş",
          "Akbulut",
          "Akdağ",
          "Akdemir",
          "Akdeniz",
          "Akdoğan",
          "Aken",
          "Aker",
          "Akerboom",
          "Akershoek",
          "Akgül",
          "Akgün",
          "Akhtar",
          "Akihary",
          "Akin",
          "Akka",
          "Akkaya",
          "Akker",
          "Akkeren",
          "Akkerman",
          "Akkermans",
          "Akkers",
          "Akkersdijk",
          "Akkouh",
          "Akkoç",
          "Akkurt",
          "Akkuş",
          "Akloe",
          "Akman",
          "Akoudad",
          "Akpinar",
          "Akram",
          "Akse",
          "Aksoy",
          "Akster",
          "Aksu",
          "Aktan",
          "Aktas",
          "Aktaş",
          "Akyol",
          "Akyüz",
          "Akça",
          "Akçay",
          "Al",
          "Alaerds",
          "Alam",
          "Alan",
          "Alards",
          "Albada",
          "Albayrak",
          "Alberda",
          "Alberg",
          "Alberink",
          "Albers",
          "Albersen",
          "Albert",
          "Alberti",
          "Alberto",
          "Alberts",
          "Albertsma",
          "Albertus",
          "Alblas",
          "Albrecht",
          "Albronda",
          "Aldenhoven",
          "Aldenkamp",
          "Aldenzee",
          "Alderden",
          "Alderlieste",
          "Alderliesten",
          "Alders",
          "Aldershof",
          "Aldewereld",
          "Aldus",
          "Alebeek",
          "Alem",
          "Aleman",
          "Alen",
          "Alers",
          "Aleven",
          "Alewijnse",
          "Alexander",
          "Alfen",
          "Alferink",
          "Alfing",
          "Alfons",
          "Alfrink",
          "Algera",
          "Algoe",
          "Algra",
          "Ali",
          "Alibaks",
          "Alibux",
          "Alici",
          "Aling",
          "Alink",
          "Alkan",
          "Alkema",
          "Alkemade",
          "Alken",
          "Allaart",
          "Allali",
          "Allaoui",
          "Allard",
          "Allart",
          "Allati",
          "Alleblas",
          "Alleman",
          "Allen",
          "Aller",
          "Allers",
          "Alles",
          "Allewijn",
          "Allon",
          "Allouchi",
          "Alma",
          "Almeida",
          "Almekinders",
          "Alofs",
          "Alons",
          "Aloserij",
          "Alp",
          "Alphen",
          "Alphenaar",
          "Alsema",
          "Alsemgeest",
          "Alserda",
          "Alssema",
          "Alst",
          "Alta",
          "Altan",
          "Altay",
          "Altelaar",
          "Alten",
          "Altena",
          "Altenburg",
          "Althof",
          "Althoff",
          "Althuis",
          "Althuizen",
          "Altin",
          "Alting",
          "Alting Siberg",
          "Altink",
          "Altintas",
          "Altintaş",
          "Altman",
          "Altorf",
          "Altun",
          "Altuntaş",
          "Alvares",
          "Alvarez",
          "Alves",
          "Amakran",
          "Aman",
          "Amar",
          "Ambachtsheer",
          "Ambagtsheer",
          "Ambaum",
          "Ambergen",
          "Ambrosius",
          "Ambtman",
          "Ameijde",
          "Ameling",
          "Amelink",
          "Amelo",
          "Amels",
          "Amelsfoort",
          "Amelsfort",
          "Amelsvoort",
          "Amen",
          "Amende",
          "Amendt",
          "Ament",
          "America",
          "Amerom",
          "Amerongen",
          "Amersfoort",
          "Amersvoort",
          "Amesz",
          "Amezian",
          "Ameziane",
          "Amghar",
          "Amier",
          "Amin",
          "Amini",
          "Amir",
          "Amiri",
          "Amkreutz",
          "Ammeraal",
          "Ammerlaan",
          "Ammers",
          "Amorij",
          "Ampting",
          "Amptmeijer",
          "Amrani",
          "Amraoui",
          "Amri",
          "Amsing",
          "Amstel",
          "Amstelveen",
          "Amsterdam",
          "Anakotta",
          "Analbers",
          "Anandbahadoer",
          "Ananias",
          "Anbeek",
          "Anbergen",
          "Ancher",
          "Anches",
          "Ancker",
          "Andel",
          "Andela",
          "Anders",
          "Anderson",
          "Andeweg",
          "Andrade",
          "Andrea",
          "Andreae",
          "Andreas",
          "Andree",
          "Andries",
          "Andriese",
          "Andriesse",
          "Andriessen",
          "Andringa",
          "André",
          "Anema",
          "Anemaat",
          "Ang",
          "Angel",
          "Angela",
          "Angenent",
          "Angeren",
          "Angevaare",
          "Angevare",
          "Anholts",
          "Anjema",
          "Anker",
          "Ankeren",
          "Ankersmit",
          "Ankone",
          "Annema",
          "Annen",
          "Anneveld",
          "Anneveldt",
          "Anninga",
          "Annink",
          "Anrooij",
          "Ansem",
          "Ansems",
          "Ansing",
          "Ansink",
          "Anten",
          "Antens",
          "Antes",
          "Antheunisse",
          "Anthonijsz",
          "Anthonio",
          "Anthonisse",
          "Anthonissen",
          "Anthony",
          "Antonia",
          "Antonides",
          "Antonio",
          "Antonis",
          "Antonise",
          "Antonisse",
          "Antonissen",
          "Antonius",
          "Antvelink",
          "Antwerpen",
          "Anwar",
          "Aouragh",
          "Apaydin",
          "Apeldoorn",
          "Apol",
          "Apon",
          "Appel",
          "Appelboom",
          "Appeldoorn",
          "Appelhof",
          "Appelman",
          "Appelo",
          "Appels",
          "Apperlo",
          "Apperloo",
          "Appiah",
          "Arab",
          "Aras",
          "Arbeider",
          "Arbib",
          "Arbouw",
          "Ardenne",
          "Ardesch",
          "Ardon",
          "Arem",
          "Arend",
          "Arendonk",
          "Arends",
          "Arendse",
          "Arendsen",
          "Arendshorst",
          "Arens",
          "Arensman",
          "Arenthals",
          "Arents",
          "Arentsen",
          "Arentz",
          "Aret",
          "Arets",
          "Aretz",
          "Arfman",
          "Ari",
          "Ariaans",
          "Ariens",
          "Aries",
          "Ariese",
          "Ariesen",
          "Arif",
          "Arik",
          "Arikan",
          "Arink",
          "Arisse",
          "Arissen",
          "Ariëns",
          "Ark",
          "Arkel",
          "Arkelen",
          "Arkema",
          "Arkenbout",
          "Arkes",
          "Arkesteijn",
          "Arkink",
          "Arkoubi",
          "Arlar",
          "Arler",
          "Arling",
          "Arnhem",
          "Arnold",
          "Arnoldus",
          "Arnoldussen",
          "Arnouts",
          "Arns",
          "Arnts",
          "Arntz",
          "Arntzen",
          "Arons",
          "Arp",
          "Arragon",
          "Arrindell",
          "Ars",
          "Arslan",
          "Artist",
          "Arts",
          "Artz",
          "Arum",
          "Arve",
          "As",
          "Asamoah",
          "Asante",
          "Asbreuk",
          "Asbroek",
          "Asch",
          "Aschman",
          "Ashraf",
          "Ashruf",
          "Asjes",
          "Askamp",
          "Askes",
          "Aslan",
          "Aslander",
          "Asma",
          "Asmus",
          "Asperdt",
          "Asperen",
          "Aspers",
          "Aspert",
          "Asruf",
          "Ass",
          "Asscheman",
          "Asselbergs",
          "Asseldonk",
          "Asselen",
          "Asselman",
          "Asselt",
          "Assem",
          "Assema",
          "Assen",
          "Assenberg",
          "Assendelft",
          "Assies",
          "Assinck",
          "Assink",
          "Assmann",
          "Assouw",
          "Ast",
          "Asten",
          "Astitou",
          "Asveld",
          "Ata",
          "Atak",
          "Atalay",
          "Atay",
          "Atema",
          "Aten",
          "Ates",
          "Ateş",
          "Atici",
          "Atik",
          "Atmaca",
          "Atmani",
          "Atsma",
          "Attema",
          "Atten",
          "Atteveld",
          "Attevelt",
          "Attia",
          "Au",
          "Audenaerd",
          "Augenbroe",
          "Augusteijn",
          "Augustijn",
          "Augustin",
          "Augustinus",
          "Augustus",
          "Aukema",
          "Aukes",
          "Ausema",
          "Ausems",
          "Ausma",
          "Aussems",
          "Autar",
          "Auwens",
          "Aué",
          "Avci",
          "Avdić",
          "Avendonk",
          "Averdijk",
          "Averesch",
          "Averink",
          "Avesaath",
          "Aveskamp",
          "Avest",
          "Avezaat",
          "Avezaath",
          "Avis",
          "Avoird",
          "Avontuur",
          "Avoort",
          "Awad",
          "Awater",
          "Ax",
          "Ay",
          "Ayadi",
          "Ayaz",
          "Aydemir",
          "Aydin",
          "Aydogan",
          "Aydoğan",
          "Aydoğdu",
          "Aygün",
          "Ayhan",
          "Ayoub",
          "Aytekin",
          "Ayyildiz",
          "Azahaf",
          "Azaoum",
          "Azarfane",
          "Azarkan",
          "Azdad",
          "Azier",
          "Azimi",
          "Aziz",
          "Azizi",
          "Azmani",
          "Aznag",
          "Azouagh",
          "Azougagh",
          "Azzaoui",
          "Azzouz",
          "Azzouzi",
          "Açikgöz",
          "Baaij",
          "Baaijen",
          "Baaijens",
          "Baak",
          "Baake",
          "Baakman",
          "Baal",
          "Baalbergen",
          "Baalen",
          "Baalhuis",
          "Baalman",
          "Baan",
          "Baanders",
          "Baans",
          "Baanstra",
          "Baar",
          "Baard",
          "Baarda",
          "Baardewijk",
          "Baardman",
          "Baardwijk",
          "Baaren",
          "Baarends",
          "Baarle",
          "Baarlen",
          "Baars",
          "Baarsen",
          "Baarslag",
          "Baarsma",
          "Baarspul",
          "Baarssen",
          "Baart",
          "Baartman",
          "Baartmans",
          "Baas",
          "Baast",
          "Baat",
          "Baaten",
          "Baatje",
          "Baauw",
          "Baay",
          "Babel",
          "Baboelal",
          "Baboeram",
          "Bac",
          "Bach",
          "Bachiri",
          "Bachoe",
          "Back",
          "Backer",
          "Backers",
          "Backes",
          "Backus",
          "Backx",
          "Badal",
          "Badart",
          "Bade",
          "Baden",
          "Bader",
          "Badloe",
          "Badoux",
          "Badri",
          "Baecke",
          "Baegen",
          "Baelde",
          "Baelemans",
          "Baerends",
          "Baert",
          "Baerts",
          "Baerveldt",
          "Baest",
          "Baeten",
          "Baetsen",
          "Bagchus",
          "Bagerman",
          "Baggem",
          "Baggen",
          "Baggerman",
          "Baggermans",
          "Baghdadi",
          "Bagijn",
          "Bah",
          "Bahadir",
          "Bahadoer",
          "Bahar",
          "Bahida",
          "Bahlmann",
          "Bahnerth",
          "Bahri",
          "Baidjoe",
          "Baijens",
          "Baijense",
          "Baijer",
          "Bais",
          "Bajema",
          "Bajnath",
          "Bak",
          "Bakarbessy",
          "Bakboord",
          "Bakel",
          "Bakelaar",
          "Bakels",
          "Bakema",
          "Baken",
          "Bakens",
          "Baker",
          "Bakermans",
          "Bakers",
          "Bakhuis",
          "Bakhuizen",
          "Bakir",
          "Bakkali",
          "Bakkenes",
          "Bakker",
          "Bakkeren",
          "Bakkers",
          "Bakkes",
          "Bakkum",
          "Bakridi",
          "Baks",
          "Baksteen",
          "Bakvis",
          "Bakx",
          "Bal",
          "Balak",
          "Balaydin",
          "Balci",
          "Balder",
          "Baldew",
          "Balduk",
          "Baldé",
          "Balemans",
          "Balen",
          "Balendonck",
          "Balentien",
          "Balentina",
          "Balfoort",
          "Balgobind",
          "Bali",
          "Baljet",
          "Baljeu",
          "Baljon",
          "Baljé",
          "Balk",
          "Balkaran",
          "Balke",
          "Balkema",
          "Balkenende",
          "Balkom",
          "Balkum",
          "Ballast",
          "Ballegooij",
          "Ballegooijen",
          "Ballemans",
          "Ballering",
          "Balm",
          "Bals",
          "Balster",
          "Balsters",
          "Balt",
          "Baltes",
          "Baltissen",
          "Baltus",
          "Baltussen",
          "Balveren",
          "Balvers",
          "Balvert",
          "Bambacht",
          "Ban",
          "Band",
          "Banda",
          "Bandel",
          "Bandhoe",
          "Bandringa",
          "Bandsma",
          "Bandstra",
          "Banel",
          "Banen",
          "Banga",
          "Bangma",
          "Banis",
          "Bank",
          "Banken",
          "Bankers",
          "Bankert",
          "Bankras",
          "Bannenberg",
          "Banning",
          "Bannink",
          "Bannisseht",
          "Bansi",
          "Bansie",
          "Bant",
          "Banus",
          "Baptist",
          "Baptista",
          "Baptiste",
          "Bar",
          "Baran",
          "Barbier",
          "Barbiers",
          "Barbé",
          "Bardoel",
          "Barel",
          "Barelds",
          "Barels",
          "Bareman",
          "Baremans",
          "Baren",
          "Barendrecht",
          "Barendregt",
          "Barends",
          "Barendse",
          "Barendsen",
          "Barens",
          "Barents",
          "Barentsen",
          "Barg",
          "Barge",
          "Bargeman",
          "Barhorst",
          "Barink",
          "Baris",
          "Bark",
          "Barkel",
          "Barkema",
          "Barkey",
          "Barkhof",
          "Barkhuis",
          "Barkmeijer",
          "Barlag",
          "Barlingen",
          "Barmentlo",
          "Barmentloo",
          "Barnard",
          "Barneveld",
          "Barnhoorn",
          "Barning",
          "Baron",
          "Baroudi",
          "Barreveld",
          "Barron",
          "Barry",
          "Barselaar",
          "Barsingerhorn",
          "Bart",
          "Bartelds",
          "Bartelen",
          "Bartelings",
          "Bartelink",
          "Bartels",
          "Bartelse",
          "Barten",
          "Barth",
          "Bartholomeus",
          "Bartholomé",
          "Bartlema",
          "Bartman",
          "Barto",
          "Barut",
          "Barwari",
          "Bas",
          "Basdew",
          "Baselier",
          "Baselmans",
          "Bashir",
          "Basjes",
          "Bassa",
          "Bassant",
          "Bassie",
          "Bast",
          "Bastelaar",
          "Bastemeijer",
          "Basten",
          "Basters",
          "Bastiaan",
          "Bastiaannet",
          "Bastiaans",
          "Bastiaanse",
          "Bastiaansen",
          "Bastiaanssen",
          "Bastiaenen",
          "Bastiaens",
          "Bastian",
          "Bastianen",
          "Bastin",
          "Basting",
          "Bastings",
          "Bastmeijer",
          "Bat",
          "Batelaan",
          "Batema",
          "Baten",
          "Batenburg",
          "Batens",
          "Bathoorn",
          "Batist",
          "Batman",
          "Bats",
          "Batstra",
          "Batterink",
          "Battjes",
          "Battum",
          "Batur",
          "Baudoin",
          "Bauer",
          "Bauhuis",
          "Baum",
          "Bauman",
          "Baumann",
          "Baur",
          "Bausch",
          "Bauwens",
          "Bavel",
          "Bavelaar",
          "Bavinck",
          "Baving",
          "Bax",
          "Bayat",
          "Bayrak",
          "Bayraktar",
          "Bayram",
          "Bazelmans",
          "Bazen",
          "Bazuin",
          "Bağci",
          "Baş",
          "Başaran",
          "Başer",
          "Beaufort",
          "Beaujean",
          "Beaumont",
          "Bebber",
          "Bechan",
          "Becht",
          "Bechtold",
          "Beck",
          "Becker",
          "Beckers",
          "Beckhoven",
          "Becking",
          "Beckman",
          "Beckmann",
          "Becks",
          "Beckx",
          "Becx",
          "Bedaf",
          "Bedaux",
          "Bedem",
          "Bedijn",
          "Beeck",
          "Beeftink",
          "Beek",
          "Beeke",
          "Beekelaar",
          "Beekenkamp",
          "Beeker",
          "Beekers",
          "Beekes",
          "Beekhof",
          "Beekhuijzen",
          "Beekhuis",
          "Beekhuizen",
          "Beekink",
          "Beekman",
          "Beekmans",
          "Beeks",
          "Beeksma",
          "Beekum",
          "Beekveld",
          "Beekwilder",
          "Beeldsnijder",
          "Beele",
          "Beelen",
          "Beeloo",
          "Beem",
          "Beemd",
          "Beemer",
          "Beems",
          "Beemster",
          "Beemsterboer",
          "Beemt",
          "Been",
          "Beenakker",
          "Beenders",
          "Beenen",
          "Beenhakker",
          "Beens",
          "Beentjes",
          "Beer",
          "Beerda",
          "Beeren",
          "Beerendonk",
          "Beerends",
          "Beerens",
          "Beerepoot",
          "Beeris",
          "Beerkens",
          "Beerlage",
          "Beerling",
          "Beerman",
          "Beernink",
          "Beers",
          "Beerse",
          "Beersma",
          "Beersum",
          "Beerta",
          "Beerten",
          "Beerthuizen",
          "Beest",
          "Beesten",
          "Beeten",
          "Beets",
          "Beetsma",
          "Beetstra",
          "Beeuwkes",
          "Begeman",
          "Begemann",
          "Begum",
          "Behari",
          "Behr",
          "Behrens",
          "Beij",
          "Beijaard",
          "Beije",
          "Beijeman",
          "Beijen",
          "Beijer",
          "Beijeren",
          "Beijering",
          "Beijers",
          "Beijersbergen",
          "Beijersbergen van Henegouwen",
          "Beijert",
          "Beijes",
          "Beijk",
          "Beijl",
          "Beijleveld",
          "Beijnen",
          "Beijnes",
          "Beijnhem",
          "Beijnum",
          "Beijsterveldt",
          "Beikes",
          "Beilen",
          "Beimers",
          "Beintema",
          "Beishuizen",
          "Bek",
          "Beke",
          "Bekebrede",
          "Bekedam",
          "Bekelaar",
          "Bekema",
          "Bekendam",
          "Bekenkamp",
          "Beker",
          "Bekerom",
          "Bekers",
          "Bekhof",
          "Bekhoven",
          "Bekhuis",
          "Bekink",
          "Bekius",
          "Bekke",
          "Bekkema",
          "Bekker",
          "Bekkering",
          "Bekkernens",
          "Bekkers",
          "Bekking",
          "Bekkum",
          "Bekman",
          "Bekooij",
          "Beks",
          "Bektas",
          "Bektaş",
          "Bekx",
          "Bel",
          "Belarbi",
          "Beld",
          "Belder",
          "Belderbos",
          "Belderink",
          "Belderok",
          "Beldman",
          "Belfor",
          "Belga",
          "Belgers",
          "Belgraver",
          "Belhadi",
          "Belhadj",
          "Belhaj",
          "Beliën",
          "Beljaars",
          "Beljon",
          "Belkadi",
          "Belkasmi",
          "Belkom",
          "Belksma",
          "Belkum",
          "Bell",
          "Bellaart",
          "Belle",
          "Bellekom",
          "Bellemakers",
          "Bellen",
          "Bellinga",
          "Belliot",
          "Bellis",
          "Bello",
          "Belmer",
          "Belt",
          "Belterman",
          "Beltman",
          "Belzen",
          "Bemd",
          "Bemelen",
          "Bemelmans",
          "Bemer",
          "Bemmel",
          "Bemmelen",
          "Bemt",
          "Ben",
          "Ben Haddou",
          "Benaissa",
          "Benali",
          "Benamar",
          "Benard",
          "Bend",
          "Benda",
          "Bendanon",
          "Bender",
          "Benders",
          "Bendt",
          "Benedictus",
          "Beneker",
          "Benerink",
          "Benes",
          "Benhaddou",
          "Benhammou",
          "Beniers",
          "Benink",
          "Benjamin",
          "Benjamins",
          "Bennaars",
          "Benne",
          "Benneker",
          "Bennekom",
          "Bennekum",
          "Bennema",
          "Bennen",
          "Bennenbroek",
          "Benner",
          "Bennett",
          "Bennik",
          "Benning",
          "Benninga",
          "Benningshof",
          "Bennink",
          "Bennis",
          "Benoist",
          "Bens",
          "Benschop",
          "Bensdorp",
          "Bense",
          "Bensink",
          "Bent",
          "Bentem",
          "Benten",
          "Benthem",
          "Benthum",
          "Bentlage",
          "Bentum",
          "Bentvelsen",
          "Bentvelzen",
          "Benus",
          "Berbee",
          "Berben",
          "Berbers",
          "Berchum",
          "Berckel",
          "Bercken",
          "Berden",
          "Berende",
          "Berendijk",
          "Berendrecht",
          "Berends",
          "Berendse",
          "Berendsen",
          "Berenpas",
          "Berens",
          "Berenschot",
          "Berentschot",
          "Berentsen",
          "Berfelo",
          "Berg",
          "Berga",
          "Bergboer",
          "Berge",
          "Berge Henegouwen",
          "Bergeijk",
          "Bergem",
          "Bergen",
          "Bergenhenegouwen",
          "Berger",
          "Bergers",
          "Bergervoet",
          "Bergevoet",
          "Bergh",
          "Berghe",
          "Berghmans",
          "Berghoef",
          "Berghorst",
          "Berghout",
          "Berghs",
          "Berghuijs",
          "Berghuis",
          "Bergkamp",
          "Bergman",
          "Bergmann",
          "Bergmans",
          "Bergs",
          "Bergshoeff",
          "Bergsma",
          "Bergstra",
          "Bergwerf",
          "Bergwerff",
          "Bergwijn",
          "Berhane",
          "Berhitu",
          "Beringen",
          "Berisha",
          "Berk",
          "Berkel",
          "Berkelaar",
          "Berkelder",
          "Berkelmans",
          "Berkenbosch",
          "Berkenpas",
          "Berkers",
          "Berkheij",
          "Berkhof",
          "Berkhoff",
          "Berkhout",
          "Berkien",
          "Berkman",
          "Berkmortel",
          "Berkom",
          "Berkouwer",
          "Berkt",
          "Berkum",
          "Berkvens",
          "Berlijn",
          "Berlo",
          "Berloo",
          "Berman",
          "Bernaards",
          "Bernabela",
          "Bernadina",
          "Bernard",
          "Bernardina",
          "Bernards",
          "Bernardus",
          "Bernds",
          "Berndsen",
          "Berne",
          "Bernhard",
          "Bernhart",
          "Berning",
          "Berns",
          "Bernsen",
          "Bernts",
          "Berntsen",
          "Berrens",
          "Berrenstein",
          "Berrevoets",
          "Bers",
          "Bersee",
          "Berserik",
          "Bersselaar",
          "Bertelink",
          "Bertels",
          "Bertens",
          "Bertholet",
          "Berting",
          "Bertram",
          "Bertrams",
          "Bertrand",
          "Bertrums",
          "Berveling",
          "Bervoets",
          "Berwald",
          "Bes",
          "Besamusca",
          "Besemer",
          "Besems",
          "Beset",
          "Beskers",
          "Besouw",
          "Besse",
          "Besselaar",
          "Besseling",
          "Besselink",
          "Bessels",
          "Besselsen",
          "Bessem",
          "Bessems",
          "Best",
          "Bestebreur",
          "Bestebreurtje",
          "Bestebroer",
          "Besteman",
          "Besten",
          "Besters",
          "Bestman",
          "Besuijen",
          "Beterams",
          "Bethlehem",
          "Betist",
          "Betjes",
          "Betlem",
          "Betten",
          "Betting",
          "Bettink",
          "Bettonvil",
          "Betuw",
          "Beucken",
          "Beuckens",
          "Beudeker",
          "Beugel",
          "Beugelaar",
          "Beugeling",
          "Beugelink",
          "Beugels",
          "Beugelsdijk",
          "Beugen",
          "Beuger",
          "Beuk",
          "Beukeboom",
          "Beukel",
          "Beukelman",
          "Beukema",
          "Beuken",
          "Beukenkamp",
          "Beuker",
          "Beukering",
          "Beukers",
          "Beukeveld",
          "Beukhof",
          "Beukman",
          "Beulen",
          "Beulink",
          "Beuman",
          "Beumer",
          "Beumers",
          "Beumkes",
          "Beun",
          "Beunder",
          "Beune",
          "Beunen",
          "Beuningen",
          "Beunis",
          "Beunk",
          "Beurden",
          "Beurs",
          "Beursken",
          "Beurskens",
          "Beus",
          "Beuse",
          "Beusekamp",
          "Beusekom",
          "Beusen",
          "Beusenberg",
          "Beusichem",
          "Beusink",
          "Beute",
          "Beuting",
          "Beuving",
          "Beuvink",
          "Beuwer",
          "Beuzekom",
          "Beuzel",
          "Beuzenberg",
          "Bevaart",
          "Bevelander",
          "Bever",
          "Beverdam",
          "Beveren",
          "Beverloo",
          "Bevers",
          "Beverwijk",
          "Beving",
          "Bex",
          "Bexkens",
          "Beyer",
          "Bezem",
          "Bezema",
          "Bezembinder",
          "Bezemer",
          "Bezooijen",
          "Bezouw",
          "Bezouwen",
          "Bezuijen",
          "Bhageloe",
          "Bhaggoe",
          "Bhagwandas",
          "Bhagwandien",
          "Bhagwandin",
          "Bhagwat",
          "Bharos",
          "Bhatti",
          "Bhattoe",
          "Bhawan",
          "Bhawanidin",
          "Bhikhie",
          "Bhoelai",
          "Bhoelan",
          "Bhola",
          "Bholai",
          "Bholasingh",
          "Bhugwansing",
          "Bianchi",
          "Bibi",
          "Bibo",
          "Bicker",
          "Bie",
          "Biegel",
          "Biegstraaten",
          "Biekens",
          "Biekram",
          "Biel",
          "Bielderman",
          "Bieleman",
          "Bieleveld",
          "Bielsma",
          "Bieman",
          "Biemans",
          "Biemen",
          "Biemold",
          "Biemolt",
          "Biemond",
          "Bien",
          "Biene",
          "Bier",
          "Bierbooms",
          "Biere",
          "Bierenbroodspot",
          "Bierens",
          "Bierhof",
          "Bierhuizen",
          "Bierings",
          "Bierkens",
          "Bierling",
          "Bierma",
          "Bierman",
          "Biermann",
          "Biermans",
          "Biersteker",
          "Bierstekers",
          "Biervliet",
          "Bies",
          "Biesbroek",
          "Biesen",
          "Bieshaar",
          "Biesheuvel",
          "Biesma",
          "Biesmans",
          "Biesot",
          "Biesterbos",
          "Biesterveld",
          "Biever",
          "Biewenga",
          "Bieze",
          "Biezen",
          "Biggelaar",
          "Bighelaar",
          "Bihari",
          "Biharie",
          "Bij",
          "Bijen",
          "Bijenhof",
          "Bijgaart",
          "Bijker",
          "Bijkerk",
          "Bijl",
          "Bijland",
          "Bijlard",
          "Bijlenga",
          "Bijleveld",
          "Bijlevelt",
          "Bijlholt",
          "Bijlhout",
          "Bijlmakers",
          "Bijloo",
          "Bijlsma",
          "Bijlstra",
          "Bijma",
          "Bijman",
          "Bijmans",
          "Bijmolt",
          "Bijnen",
          "Bijnsdorp",
          "Bijpost",
          "Bijster",
          "Bijsterbosch",
          "Bijsteren",
          "Bijsterveld",
          "Bijsterveldt",
          "Bijstra",
          "Bijvank",
          "Bijvelds",
          "Bijvoet",
          "Bijvoets",
          "Bijwaard",
          "Bijzitter",
          "Bik",
          "Bikker",
          "Bil",
          "Bilderbeek",
          "Bilen",
          "Bilgin",
          "Bilgiç",
          "Bilici",
          "Biljouw",
          "Billar",
          "Billekens",
          "Bilsen",
          "Bilt",
          "Bimmel",
          "Binda",
          "Bindels",
          "Bindsbergen",
          "Bink",
          "Binken",
          "Binkhorst",
          "Binnekade",
          "Binnekamp",
          "Binnema",
          "Binnendijk",
          "Binnenmars",
          "Binnerts",
          "Binneveld",
          "Bins",
          "Binsbergen",
          "Bipat",
          "Birkhoff",
          "Birza",
          "Bisai",
          "Bischoff",
          "Bisessar",
          "Bish",
          "Bishesar",
          "Bisoen",
          "Bisscheroux",
          "Bisschop",
          "Bisschops",
          "Bisseling",
          "Bisselink",
          "Bissels",
          "Bissumbhar",
          "Bitter",
          "Bittich",
          "Biçer",
          "Blaaij",
          "Blaak",
          "Blaakman",
          "Blaas",
          "Blaauboer",
          "Blaauw",
          "Blaauwbroek",
          "Blaauwendraad",
          "Blaauwgeers",
          "Blaauwwiekel",
          "Blaazer",
          "Blacquière",
          "Blad",
          "Bladel",
          "Bladeren",
          "Blaeij",
          "Blakenburg",
          "Blanc",
          "Blank",
          "Blanke",
          "Blanken",
          "Blankenburgh",
          "Blankendaal",
          "Blankendal",
          "Blankenspoor",
          "Blankenstein",
          "Blankenstijn",
          "Blankenvoorde",
          "Blankenzee",
          "Blanker",
          "Blankers",
          "Blankert",
          "Blankespoor",
          "Blankestein",
          "Blankestijn",
          "Blankevoort",
          "Blankhorst",
          "Blanksma",
          "Blankvoort",
          "Blans",
          "Blansjaar",
          "Blatter",
          "Blauw",
          "Blecourt",
          "Bleekemolen",
          "Bleeker",
          "Bleekman",
          "Blees",
          "Blei",
          "Bleij",
          "Bleijenberg",
          "Bleijendaal",
          "Bleijerveld",
          "Bleijs",
          "Bleijswijk",
          "Bleize",
          "Bleker",
          "Blekkenhorst",
          "Blekkink",
          "Blerck",
          "Blerk",
          "Bles",
          "Blesgraaf",
          "Blesing",
          "Bleumer",
          "Bleumink",
          "Blewanus",
          "Bleyenberg",
          "Blezer",
          "Blieck",
          "Bliek",
          "Bliekendaal",
          "Blij",
          "Blijd",
          "Blijderveen",
          "Blijdorp",
          "Blijenberg",
          "Blijham",
          "Blijleven",
          "Blijlevens",
          "Blijswijk",
          "Blik",
          "Blikman",
          "Blind",
          "Blink",
          "Blinker",
          "Blitterswijk",
          "Blitz",
          "Block",
          "Bloed",
          "Bloedjes",
          "Bloem",
          "Bloemberg",
          "Bloembergen",
          "Bloeme",
          "Bloemen",
          "Bloemendaal",
          "Bloemendal",
          "Bloemenkamp",
          "Bloemer",
          "Bloemers",
          "Bloemert",
          "Bloemhard",
          "Bloemheuvel",
          "Bloemhof",
          "Bloemhoff",
          "Bloeming",
          "Bloemink",
          "Bloemsma",
          "Bloetjes",
          "Blois",
          "Blok",
          "Blokdijk",
          "Blokhuis",
          "Blokker",
          "Blokland",
          "Blokpoel",
          "Bloks",
          "Bloksma",
          "Blokvoort",
          "Blokzijl",
          "Blom",
          "Blomberg",
          "Blomen",
          "Blommaert",
          "Blomme",
          "Blommendaal",
          "Blommerde",
          "Blommers",
          "Blommestein",
          "Blommestijn",
          "Blomsma",
          "Blonk",
          "Bloo",
          "Bloois",
          "Bloom",
          "Bloos",
          "Bloot",
          "Bloothoofd",
          "Blotenburg",
          "Blouw",
          "Bluemink",
          "Blum",
          "Blume",
          "Blumers",
          "Blummel",
          "Blöte",
          "Blüm",
          "Boakye",
          "Boateng",
          "Bobbink",
          "Bobeldijk",
          "Bochem",
          "Bochove",
          "Bock",
          "Bockel",
          "Bocken",
          "Bockting",
          "Bockweg",
          "Bocxe",
          "Bod",
          "Bodaan",
          "Bodbijl",
          "Bodde",
          "Boddeke",
          "Bodden",
          "Boddeus",
          "Boddé",
          "Bode",
          "Bodegom",
          "Bodegraven",
          "Bodelier",
          "Bodemeijer",
          "Boden",
          "Bodenstaff",
          "Bodewes",
          "Bodewits",
          "Bodewitz",
          "Bodha",
          "Bodt",
          "Boe",
          "Boeckel",
          "Boed",
          "Boeder",
          "Boedhai",
          "Boedhoe",
          "Boedhram",
          "Boedjarath",
          "Boef",
          "Boegheim",
          "Boeije",
          "Boeijen",
          "Boeijenga",
          "Boeijink",
          "Boejharat",
          "Boek",
          "Boekee",
          "Boekel",
          "Boekelaar",
          "Boekelder",
          "Boekelman",
          "Boekelo",
          "Boekema",
          "Boekestein",
          "Boekestijn",
          "Boekhoff",
          "Boekhold",
          "Boekholt",
          "Boekhoorn",
          "Boekhorst",
          "Boekhoudt",
          "Boekhout",
          "Boekweit",
          "Boel",
          "Boelaars",
          "Boele",
          "Boelee",
          "Boelema",
          "Boelen",
          "Boelens",
          "Boelhouwer",
          "Boelhouwers",
          "Boellaard",
          "Boelman",
          "Boels",
          "Boelsma",
          "Boemaars",
          "Boender",
          "Boendermaker",
          "Boenders",
          "Boensma",
          "Boer",
          "Boerakker",
          "Boerboom",
          "Boerdam",
          "Boerdijk",
          "Boere",
          "Boerebach",
          "Boereboom",
          "Boeree",
          "Boerefijn",
          "Boerekamp",
          "Boerema",
          "Boeren",
          "Boerenkamp",
          "Boerhof",
          "Boerhoop",
          "Boerhout",
          "Boering",
          "Boerjan",
          "Boerkamp",
          "Boerlage",
          "Boerland",
          "Boerleider",
          "Boerma",
          "Boerman",
          "Boermans",
          "Boerrigter",
          "Boers",
          "Boersbroek",
          "Boersema",
          "Boersen",
          "Boersma",
          "Boerstal",
          "Boerstra",
          "Boertien",
          "Boertje",
          "Boertjes",
          "Boerwinkel",
          "Boerée",
          "Boes",
          "Boeschoten",
          "Boesenkool",
          "Boeser",
          "Boesjes",
          "Boesschoten",
          "Boessen",
          "Boessenkool",
          "Boesten",
          "Boesterd",
          "Boestert",
          "Boesveld",
          "Boet",
          "Boeter",
          "Boeters",
          "Boetes",
          "Boetzkes",
          "Boeve",
          "Boevink",
          "Boevé",
          "Boezaard",
          "Boezelman",
          "Boezem",
          "Boezer",
          "Bogaard",
          "Bogaards",
          "Bogaars",
          "Bogaart",
          "Bogaarts",
          "Bogaers",
          "Bogaert",
          "Bogaerts",
          "Bogema",
          "Bogerd",
          "Bogerman",
          "Bogers",
          "Bogert",
          "Boggelen",
          "Bogget",
          "Bogie",
          "Bogman",
          "Bogmans",
          "Bogt",
          "Boheemen",
          "Bohemen",
          "Bohle",
          "Bohnen",
          "Bohte",
          "Boin",
          "Boink",
          "Bois",
          "Boiten",
          "Bok",
          "Bokdam",
          "Bokhorst",
          "Bokhove",
          "Bokhoven",
          "Bokkel",
          "Bokkem",
          "Bokkers",
          "Bokma",
          "Boks",
          "Boksebeld",
          "Bokum",
          "Bokx",
          "Bol",
          "Boland",
          "Bolat",
          "Bolck",
          "Bolder",
          "Bolderdijk",
          "Bolderen",
          "Bolderman",
          "Bolders",
          "Boldewijn",
          "Bolding",
          "Boleij",
          "Bolhaar",
          "Bolhoeve",
          "Bolhuis",
          "Bolier",
          "Bolijn",
          "Bolink",
          "Bolk",
          "Bolks",
          "Boll",
          "Bollaart",
          "Bolland",
          "Bolle",
          "Bollebakker",
          "Bolleboom",
          "Bollema",
          "Bolleman",
          "Bollen",
          "Bolluijt",
          "Bolman",
          "Bolmer",
          "Bolmers",
          "Bols",
          "Bolscher",
          "Bolsenbroek",
          "Bolsius",
          "Bolster",
          "Bolt",
          "Bolte",
          "Bolten",
          "Boltendal",
          "Boltje",
          "Boltjes",
          "Boltong",
          "Bolwerk",
          "Bolwijn",
          "Bom",
          "Bomas",
          "Bombeeck",
          "Bomer",
          "Bomers",
          "Bomert",
          "Bomhof",
          "Bommel",
          "Bommeljé",
          "Bommer",
          "Bommezijn",
          "Bon",
          "Bonants",
          "Bonarius",
          "Bond",
          "Bonder",
          "Bondt",
          "Bonefaas",
          "Bonekamp",
          "Bonenberg",
          "Bonenkamp",
          "Boneschansker",
          "Bonestroo",
          "Bongaards",
          "Bongaarts",
          "Bongaerts",
          "Bongard",
          "Bongarts",
          "Bongartz",
          "Bongenaar",
          "Bongers",
          "Bongertman",
          "Bonhof",
          "Bonke",
          "Bonne",
          "Bonnema",
          "Bonnes",
          "Bonnet",
          "Bonneveld",
          "Bonnier",
          "Bonné",
          "Bonouvrié",
          "Bons",
          "Bonsel",
          "Bonsink",
          "Bonsu",
          "Bont",
          "Bontan",
          "Bonte",
          "Bontekoe",
          "Bontekoning",
          "Bonten",
          "Bontenbal",
          "Bontes",
          "Bonth",
          "Bonthuis",
          "Bontje",
          "Bontjer",
          "Bontrop",
          "Bontsema",
          "Boo",
          "Bood",
          "Boode",
          "Booden",
          "Boog",
          "Boogaard",
          "Boogaart",
          "Boogaarts",
          "Boogaers",
          "Boogaert",
          "Boogerd",
          "Boogers",
          "Boogert",
          "Boogmans",
          "Booi",
          "Booij",
          "Booijink",
          "Booiman",
          "Bool",
          "Booltink",
          "Boom",
          "Boomaars",
          "Boomaerts",
          "Booman",
          "Boome",
          "Boomen",
          "Boomgaard",
          "Boomkamp",
          "Boomkens",
          "Booms",
          "Boomsma",
          "Boomstra",
          "Boon",
          "Boonacker",
          "Boone",
          "Boonekamp",
          "Boonen",
          "Boonk",
          "Boonman",
          "Boons",
          "Boonstoppel",
          "Boonstra",
          "Boontje",
          "Boontjes",
          "Boonzaaijer",
          "Boor",
          "Boorder",
          "Boorn",
          "Boorsma",
          "Boos",
          "Boosman",
          "Boosten",
          "Booster",
          "Boot",
          "Boots",
          "Bootsma",
          "Bootsman",
          "Bootsveld",
          "Booy",
          "Bor",
          "Borchers",
          "Borden",
          "Bordes",
          "Bordewijk",
          "Borg",
          "Borgdorff",
          "Borger",
          "Borgerink",
          "Borgers",
          "Borggreve",
          "Borgh",
          "Borghans",
          "Borghols",
          "Borghouts",
          "Borghuis",
          "Borgman",
          "Borgmeijer",
          "Borgonjen",
          "Borgstein",
          "Borgt",
          "Bork",
          "Borkent",
          "Borkus",
          "Borm",
          "Borman",
          "Bormans",
          "Born",
          "Borne",
          "Bornebroek",
          "Borneman",
          "Borninkhof",
          "Borra",
          "Borrel",
          "Borreman",
          "Borremans",
          "Borren",
          "Borrenbergs",
          "Bors",
          "Borsboom",
          "Borsch",
          "Borsje",
          "Borst",
          "Borsten",
          "Borstlap",
          "Bos",
          "Bosboom",
          "Bosch",
          "Boschker",
          "Boschloo",
          "Boschma",
          "Boschman",
          "Boselie",
          "Bosgoed",
          "Bosgra",
          "Bosgraaf",
          "Boshart",
          "Boshouwers",
          "Boshoven",
          "Boshuis",
          "Boshuizen",
          "Boskamp",
          "Bosker",
          "Bosklopper",
          "Boskma",
          "Bosland",
          "Bosma",
          "Bosman",
          "Bosmans",
          "Boss",
          "Bosscha",
          "Bosschaart",
          "Bossche",
          "Bosscher",
          "Bosschers",
          "Bosschieter",
          "Bosse",
          "Bosselaar",
          "Bossema",
          "Bossen",
          "Bossenbroek",
          "Bossers",
          "Bossink",
          "Bossé",
          "Bostanci",
          "Bostelaar",
          "Bostelen",
          "Bosten",
          "Bosters",
          "Bosua",
          "Bosveld",
          "Bosvelt",
          "Boswerger",
          "Boswijk",
          "Boswinkel",
          "Bot",
          "Botden",
          "Boter",
          "Boterman",
          "Botermans",
          "Both",
          "Bothmer",
          "Bothof",
          "Boting",
          "Botma",
          "Botman",
          "Bots",
          "Bottelier",
          "Bottema",
          "Bottenberg",
          "Bottenheft",
          "Botter",
          "Botterhuis",
          "Botterman",
          "Bottinga",
          "Bottse",
          "Bouali",
          "Bouazza",
          "Bouazzaoui",
          "Bouazzati",
          "Bouchiba",
          "Bouckaert",
          "Boudens",
          "Boudesteijn",
          "Boudestein",
          "Boudewijn",
          "Boudewijns",
          "Boudhan",
          "Bougie",
          "Bouhali",
          "Bouhof",
          "Bouhuijs",
          "Bouhuis",
          "Bouius",
          "Boukema",
          "Boukens",
          "Boukes",
          "Boukhizzou",
          "Boulakhrif",
          "Bouland",
          "Boulogne",
          "Bouma",
          "Bouman",
          "Boumans",
          "Boumeester",
          "Bouquet",
          "Bour",
          "Bouras",
          "Bourgondiën",
          "Bourgonje",
          "Bours",
          "Bousema",
          "Bout",
          "Boute",
          "Bouten",
          "Boutens",
          "Bouter",
          "Bouterse",
          "Bouthoorn",
          "Boutier",
          "Boutkabout",
          "Boutkan",
          "Bouts",
          "Bouvrie",
          "Bouw",
          "Bouwels",
          "Bouwen",
          "Bouwens",
          "Bouwense",
          "Bouwer",
          "Bouwers",
          "Bouwes",
          "Bouwheer",
          "Bouwhuis",
          "Bouwkamp",
          "Bouwknegt",
          "Bouwma",
          "Bouwman",
          "Bouwmans",
          "Bouwmeester",
          "Bouwmeister",
          "Bouws",
          "Bouwsema",
          "Bouwsma",
          "Bouziane",
          "Bouzidi",
          "Bovee",
          "Boven",
          "Bovenberg",
          "Bovendorp",
          "Bovenkamp",
          "Bovenkerk",
          "Bovenlander",
          "Bovens",
          "Bovenschen",
          "Boverhof",
          "Bovée",
          "Box",
          "Boxel",
          "Boxem",
          "Boxhoorn",
          "Boxma",
          "Boxman",
          "Boxmeer",
          "Boxtel",
          "Boxum",
          "Boymans",
          "Bozdağ",
          "Bozkurt",
          "Bozuwa",
          "Braad",
          "Braaf",
          "Braafhart",
          "Braak",
          "Braake",
          "Braakhekke",
          "Braakhuis",
          "Braakman",
          "Braaksma",
          "Braal",
          "Braam",
          "Braamhaar",
          "Braams",
          "Braamse",
          "Braamskamp",
          "Braan",
          "Braas",
          "Braat",
          "Brabander",
          "Braber",
          "Brabers",
          "Bracht",
          "Bracke",
          "Brader",
          "Braek",
          "Braeken",
          "Braekt",
          "Braem",
          "Bragt",
          "Brak",
          "Brake",
          "Brakeboer",
          "Brakel",
          "Brakels",
          "Braken",
          "Brakenhoff",
          "Braker",
          "Brakke",
          "Brakkee",
          "Brakman",
          "Brals",
          "Bralts",
          "Brama",
          "Bramer",
          "Brammer",
          "Brand",
          "Brande",
          "Branden",
          "Brandenbarg",
          "Brandenburg",
          "Brander",
          "Branderhorst",
          "Brandes",
          "Brandhof",
          "Brandhoff",
          "Brandhorst",
          "Brandjes",
          "Brandon",
          "Brands",
          "Brandse",
          "Brandsema",
          "Brandsen",
          "Brandsma",
          "Brandt",
          "Brandts",
          "Brandwacht",
          "Brandwijk",
          "Branger",
          "Brankaert",
          "Brans",
          "Bransen",
          "Brant",
          "Branten",
          "Brantenaar",
          "Brantjes",
          "Brants",
          "Brantsma",
          "Bras",
          "Brasjen",
          "Braspenning",
          "Brasser",
          "Brassé",
          "Brasz",
          "Brattinga",
          "Brauer",
          "Brauers",
          "Braun",
          "Brauns",
          "Brave",
          "Braven",
          "Bravenboer",
          "Braver",
          "Braxhoofden",
          "Brecht",
          "Breda",
          "Breddels",
          "Breden",
          "Bredenhoff",
          "Brederode",
          "Brederoo",
          "Brederveld",
          "Bredewold",
          "Bredewoud",
          "Bredewout",
          "Bredius",
          "Bree",
          "Breebaart",
          "Breed",
          "Breederland",
          "Breederveld",
          "Breedeveld",
          "Breedijk",
          "Breedveld",
          "Breejen",
          "Breek",
          "Breekveldt",
          "Breel",
          "Breeman",
          "Breemen",
          "Breemer",
          "Breems",
          "Breen",
          "Breenen",
          "Breeschoten",
          "Breet",
          "Breetveld",
          "Breeuwer",
          "Breeuwsma",
          "Breevaart",
          "Breeveld",
          "Breevoort",
          "Breg",
          "Breggen",
          "Bregman",
          "Bregonje",
          "Brehler",
          "Brehm",
          "Breidel",
          "Breidenbach",
          "Breider",
          "Breij",
          "Breijer",
          "Breimer",
          "Breinburg",
          "Brekel",
          "Brekelmans",
          "Brekveld",
          "Brem",
          "Breman",
          "Bremen",
          "Bremer",
          "Bremmer",
          "Bremmers",
          "Brendel",
          "Brenk",
          "Brenkelen",
          "Brenkman",
          "Brenninkmeijer",
          "Brenters",
          "Brentjens",
          "Bres",
          "Bresser",
          "Bressers",
          "Breteler",
          "Brethouwer",
          "Bretveld",
          "Breuer",
          "Breugel",
          "Breugelmans",
          "Breugem",
          "Breukel",
          "Breukelaar",
          "Breukelen",
          "Breukelman",
          "Breuker",
          "Breukers",
          "Breukhoven",
          "Breukink",
          "Breul",
          "Breuls",
          "Breunesse",
          "Breunis",
          "Breunissen",
          "Breur",
          "Breure",
          "Brevoord",
          "Brevé",
          "Brewster",
          "Briaire",
          "Brian",
          "Brie",
          "Briedé",
          "Briek",
          "Briels",
          "Briemen",
          "Briene",
          "Brienen",
          "Brienesse",
          "Briggeman",
          "Brijder",
          "Brijker",
          "Brik",
          "Bril",
          "Brilleman",
          "Brilman",
          "Brink",
          "Brinke",
          "Brinker",
          "Brinkerink",
          "Brinkers",
          "Brinkhof",
          "Brinkhoff",
          "Brinkhorst",
          "Brinkhuis",
          "Brinkkemper",
          "Brinkman",
          "Brinkmann",
          "Brinkmans",
          "Brinks",
          "Brinksma",
          "Brito",
          "Britstra",
          "Brittijn",
          "Briët",
          "Brobbel",
          "Brocatus",
          "Brochard",
          "Brock",
          "Brocken",
          "Brockhoff",
          "Brockhus",
          "Brockötter",
          "Broeck",
          "Broecke",
          "Broeckhuijsen",
          "Broecks",
          "Broeder",
          "Broeders",
          "Broek",
          "Broekaart",
          "Broeke",
          "Broekema",
          "Broeken",
          "Broekhof",
          "Broekhoff",
          "Broekhoven",
          "Broekhuijse",
          "Broekhuijsen",
          "Broekhuis",
          "Broekhuisen",
          "Broekhuizen",
          "Broekkamp",
          "Broekman",
          "Broekmans",
          "Broekmeulen",
          "Broekroelofs",
          "Broeks",
          "Broeksema",
          "Broeksma",
          "Broeksteeg",
          "Broekstra",
          "Broekzitter",
          "Broen",
          "Broenink",
          "Broens",
          "Broer",
          "Broere",
          "Broeren",
          "Broers",
          "Broerse",
          "Broersen",
          "Broersma",
          "Broertjes",
          "Broesder",
          "Broeshart",
          "Broeze",
          "Brok",
          "Brokelman",
          "Brokke",
          "Brokken",
          "Brokking",
          "Broks",
          "Brokx",
          "Brolsma",
          "Brom",
          "Brommer",
          "Bron",
          "Bronckers",
          "Bronckhorst",
          "Bronder",
          "Brondijk",
          "Brondsema",
          "Bronger",
          "Brongers",
          "Bronk",
          "Bronkhorst",
          "Bronneberg",
          "Brons",
          "Bronsdijk",
          "Bronsema",
          "Bronsgeest",
          "Bronsveld",
          "Bronsvoort",
          "Bronswijk",
          "Bronts",
          "Brontsema",
          "Bronwasser",
          "Brood",
          "Broodman",
          "Brooijmans",
          "Brookhuis",
          "Brookman",
          "Brooks",
          "Broos",
          "Brosens",
          "Broshuis",
          "Brouns",
          "Brouw",
          "Brouwer",
          "Brouwer de Koning",
          "Brouwers",
          "Brouwershaven",
          "Brown",
          "Brozius",
          "Bruce",
          "Bruchem",
          "Bruekers",
          "Bruel",
          "Bruens",
          "Brueren",
          "Bruers",
          "Brug",
          "Brugel",
          "Brugge",
          "Bruggeling",
          "Bruggeman",
          "Bruggen",
          "Bruggencate",
          "Bruggenkamp",
          "Bruggers",
          "Bruggink",
          "Brughuis",
          "Brugman",
          "Brugmans",
          "Brugts",
          "Bruijn",
          "Bruijnaers",
          "Bruijne",
          "Bruijnen",
          "Bruijnes",
          "Bruijnesteijn",
          "Bruijninckx",
          "Bruijnis",
          "Bruijnooge",
          "Bruijns",
          "Bruijnzeel",
          "Bruijnzeels",
          "Bruijs",
          "Bruijsten",
          "Bruijstens",
          "Bruil",
          "Bruin",
          "Bruine",
          "Bruinekool",
          "Bruinen",
          "Bruinenberg",
          "Bruines",
          "Bruinewoud",
          "Bruinhard",
          "Bruinhorst",
          "Bruinier",
          "Bruining",
          "Bruinink",
          "Bruinooge",
          "Bruins",
          "Bruins Slot",
          "Bruinsma",
          "Bruintjes",
          "Bruisten",
          "Brul",
          "Brule",
          "Brull",
          "Bruls",
          "Brummans",
          "Brummel",
          "Brummelen",
          "Brummelhuis",
          "Brummelkamp",
          "Brummelman",
          "Brummelstroete",
          "Brummen",
          "Brummer",
          "Brundel",
          "Brunekreef",
          "Brunekreeft",
          "Brunenberg",
          "Brunia",
          "Bruning",
          "Brunings",
          "Brunink",
          "Brunnekreef",
          "Brunninkhuis",
          "Bruno",
          "Bruns",
          "Brunschot",
          "Brunsman",
          "Brunsting",
          "Brunsveld",
          "Brunt",
          "Bruntink",
          "Brus",
          "Brusche",
          "Brussaard",
          "Brusse",
          "Brussee",
          "Brussel",
          "Brusselaars",
          "Brusselers",
          "Brussen",
          "Brussé",
          "Brust",
          "Bruurmijn",
          "Bruurs",
          "Bruxvoort",
          "Bruyn",
          "Bruyne",
          "Bryson",
          "Bröcker",
          "Bröker",
          "Brökling",
          "Bröring",
          "Brüggemann",
          "Brüggink",
          "Brüll",
          "Brüning",
          "Bubberman",
          "Buchem",
          "Buchner",
          "Buck",
          "Buckens",
          "Budak",
          "Budde",
          "Buddenberg",
          "Budding",
          "Buddingh",
          "Budel",
          "Budé",
          "Buel",
          "Buenen",
          "Bueren",
          "Buermans",
          "Buesink",
          "Buffing",
          "Buggenum",
          "Bugter",
          "Buhrs",
          "Bui",
          "Buijing",
          "Buijk",
          "Buijks",
          "Buijl",
          "Buijnink",
          "Buijnsters",
          "Buijs",
          "Buijsen",
          "Buijserd",
          "Buijsman",
          "Buijsrogge",
          "Buijsse",
          "Buijssen",
          "Buijtels",
          "Buijtendijk",
          "Buijtene",
          "Buijtenen",
          "Buijtenhek",
          "Buijtenhuis",
          "Buijvoets",
          "Buijze",
          "Buijzer",
          "Buik",
          "Buikema",
          "Buiks",
          "Buil",
          "Buining",
          "Buis",
          "Buise",
          "Buiskool",
          "Buisman",
          "Buist",
          "Buit",
          "Buitelaar",
          "Buiteman",
          "Buiten",
          "Buitendijk",
          "Buitenen",
          "Buitenga",
          "Buitenhek",
          "Buitenhuis",
          "Buitenkamp",
          "Buitenweg",
          "Buitenwerf",
          "Buiter",
          "Buiting",
          "Buitink",
          "Buizer",
          "Buizert",
          "Bukkems",
          "Bul",
          "Bulder",
          "Bulk",
          "Bulkmans",
          "Bulle",
          "Bullee",
          "Bullens",
          "Buls",
          "Bulsing",
          "Bulsink",
          "Bult",
          "Bulte",
          "Bulten",
          "Bultena",
          "Bulter",
          "Bulterman",
          "Bulters",
          "Bulthuis",
          "Bultink",
          "Bultje",
          "Bultman",
          "Bults",
          "Bultsma",
          "Bultstra",
          "Bulut",
          "Buma",
          "Bun",
          "Bungelaar",
          "Buning",
          "Bunink",
          "Bunk",
          "Bunnik",
          "Bunningen",
          "Bunschoten",
          "Bunsee",
          "Bunskoek",
          "Bunt",
          "Bunte",
          "Buntsma",
          "Burema",
          "Buren",
          "Burer",
          "Burg",
          "Burgel",
          "Burgemeester",
          "Burger",
          "Burgerhout",
          "Burgering",
          "Burgers",
          "Burgersdijk",
          "Burggraaf",
          "Burggraaff",
          "Burgh",
          "Burghard",
          "Burghardt",
          "Burghgraef",
          "Burghoorn",
          "Burghout",
          "Burghouts",
          "Burghouwt",
          "Burght",
          "Burgler",
          "Burgman",
          "Burgmans",
          "Burgmeijer",
          "Burgsteden",
          "Burgstra",
          "Burgt",
          "Burgwal",
          "Burgzorg",
          "Burhenne",
          "Burik",
          "Buring",
          "Burink",
          "Burk",
          "Burke",
          "Burken",
          "Burki",
          "Burlage",
          "Burleson",
          "Burm",
          "Burnet",
          "Buruma",
          "Bus",
          "Busch",
          "Buscher",
          "Buschgens",
          "Buschman",
          "Buscop",
          "Buser",
          "Busink",
          "Busio",
          "Busken",
          "Buskens",
          "Busker",
          "Buskermolen",
          "Buskes",
          "Buskop",
          "Busman",
          "Buss",
          "Busscher",
          "Busschers",
          "Busse",
          "Bussel",
          "Bussemaker",
          "Busser",
          "Bussing",
          "Bussink",
          "Busstra",
          "Bust",
          "Buster",
          "Bustraan",
          "But",
          "Buteijn",
          "Buter",
          "Buth",
          "Butijn",
          "Butink",
          "Buts",
          "Butselaar",
          "Butt",
          "Butter",
          "Butzelaar",
          "Buul",
          "Buunk",
          "Buur",
          "Buuren",
          "Buurke",
          "Buurkes",
          "Buurlage",
          "Buurma",
          "Buurman",
          "Buurmans",
          "Buurmeijer",
          "Buuron",
          "Buursema",
          "Buursen",
          "Buursink",
          "Buursma",
          "Buurstede",
          "Buuts",
          "Buvelot",
          "Buwalda",
          "Buys",
          "Buysse",
          "Bäcker",
          "Bär",
          "Böck",
          "Böcker",
          "Bögels",
          "Böhm",
          "Böhmer",
          "Böhne",
          "Böke",
          "Bökkerink",
          "Bömer",
          "Börger",
          "Bührs",
          "Bülbül",
          "Bürmann",
          "Büter",
          "Büttner",
          "Caam",
          "Caarels",
          "Caarls",
          "Caat",
          "Cadsand",
          "Caelen",
          "Caelers",
          "Caem",
          "Caenen",
          "Cai",
          "Cairo",
          "Calis",
          "Caljouw",
          "Calker",
          "Calkhoven",
          "Callaars",
          "Callemeijn",
          "Callenbach",
          "Calon",
          "Calor",
          "Cals",
          "Calsteren",
          "Caluwe",
          "Caluwé",
          "Camara",
          "Cameron",
          "Camfferman",
          "Caminada",
          "Cammen",
          "Cammeraat",
          "Camp",
          "Campagne",
          "Campbell",
          "Campen",
          "Campenhout",
          "Campfens",
          "Camphens",
          "Campman",
          "Camps",
          "Campschroer",
          "Can",
          "Candan",
          "Candel",
          "Canisius",
          "Canjels",
          "Cann",
          "Cannegieter",
          "Canninga",
          "Canrinus",
          "Canters",
          "Canton",
          "Cao",
          "Capel",
          "Capelle",
          "Capelleveen",
          "Capello",
          "Cappelle",
          "Cappellen",
          "Cappendijk",
          "Cappon",
          "Captein",
          "Captijn",
          "Car",
          "Carbaat",
          "Cardinaal",
          "Cardol",
          "Carels",
          "Caris",
          "Carli",
          "Carlier",
          "Carmiggelt",
          "Caro",
          "Carolina",
          "Carolus",
          "Caron",
          "Carpaij",
          "Carpentier",
          "Carree",
          "Carrilho",
          "Carrière",
          "Carstens",
          "Carter",
          "Carton",
          "Caspel",
          "Caspers",
          "Cassee",
          "Castel",
          "Casteleijn",
          "Castelein",
          "Castelijn",
          "Castelijns",
          "Castenmiller",
          "Casteren",
          "Castermans",
          "Castillo",
          "Castricum",
          "Castro",
          "Cate",
          "Cathalina",
          "Cats",
          "Catsburg",
          "Cauberg",
          "Caubo",
          "Caulil",
          "Caupain",
          "Cazemier",
          "Cecilia",
          "Ceder",
          "Ceelen",
          "Ceelie",
          "Celie",
          "Celik",
          "Cengiz",
          "Centen",
          "Cents",
          "Cesur",
          "Ceulemans",
          "Ceuninck van Capelle",
          "Cevaal",
          "Cevat",
          "Ceyhan",
          "Ceylan",
          "Chaara",
          "Chabot",
          "Chahbari",
          "Chahid",
          "Chaigneau",
          "Chakawri",
          "Chakir",
          "Chamlal",
          "Chamoun",
          "Chan",
          "Chand",
          "Chandoe",
          "Chang",
          "Changoer",
          "Changur",
          "Chaoui",
          "Chardon",
          "Charif",
          "Charité",
          "Charles",
          "Charlier",
          "Charpentier",
          "Chatenier",
          "Chatinier",
          "Chatrer",
          "Chau",
          "Chaudhry",
          "Chaudron",
          "Chauthi",
          "Chedi",
          "Chen",
          "Cheng",
          "Cheret",
          "Cheung",
          "Chevalking",
          "Chi",
          "Chiang",
          "Chin",
          "Chirino",
          "Chiu",
          "Choi",
          "Chong",
          "Chotkan",
          "Chotoe",
          "Chou",
          "Chow",
          "Choy",
          "Chrispijn",
          "Christ",
          "Christen",
          "Christenhusz",
          "Christiaan",
          "Christiaans",
          "Christiaanse",
          "Christiaens",
          "Christianen",
          "Christiani",
          "Christians",
          "Christis",
          "Chtatou",
          "Chu",
          "Chung",
          "Cicilia",
          "Cieraad",
          "Ciere",
          "Cieremans",
          "Cihan",
          "Cijntje",
          "Cijs",
          "Cijsouw",
          "Cillekens",
          "Cillessen",
          "Cingel",
          "Cinjee",
          "Cirkel",
          "Cissen",
          "Claas",
          "Claase",
          "Claasen",
          "Claassen",
          "Claassens",
          "Clabbers",
          "Claes",
          "Claesen",
          "Claessen",
          "Claessens",
          "Claij",
          "Clappers",
          "Clarijs",
          "Clarinda",
          "Clarisse",
          "Clark",
          "Clarke",
          "Classen",
          "Classens",
          "Claus",
          "Claver",
          "Clazing",
          "Cleef",
          "Cleijne",
          "Cleiren",
          "Clemens",
          "Clement",
          "Clements",
          "Cleophas",
          "Clephas",
          "Clerck",
          "Clercq",
          "Clercx",
          "Clerkx",
          "Clermonts",
          "Clerx",
          "Cleton",
          "Cleutjens",
          "Cleven",
          "Cleveringa",
          "Clevers",
          "Clijnk",
          "Clijsen",
          "Cloe",
          "Cloin",
          "Cloo",
          "Cloosterman",
          "Cloots",
          "Cloudt",
          "Clout",
          "Cluistra",
          "Cnossen",
          "Cobben",
          "Cobelens",
          "Cobussen",
          "Cock",
          "Cocq",
          "Cocq van Delwijnen",
          "Cocu",
          "Codrington",
          "Coehoorn",
          "Coehorst",
          "Coelen",
          "Coelingh",
          "Coenders",
          "Coene",
          "Coenen",
          "Coenraad",
          "Coenraads",
          "Coenraadts",
          "Coenraats",
          "Coenradi",
          "Coenradie",
          "Coens",
          "Coers",
          "Coert",
          "Coerver",
          "Coesel",
          "Coeverden",
          "Coevering",
          "Coevert",
          "Coevorden",
          "Coffeng",
          "Coffie",
          "Cohen",
          "Cok",
          "Colaris",
          "Colbers",
          "Coldenhoff",
          "Colen",
          "Colenbrander",
          "Colijn",
          "Colin",
          "Coljee",
          "Collard",
          "Collaris",
          "Collenburg",
          "Collet",
          "Collette",
          "Collewijn",
          "Collignon",
          "Collin",
          "Collins",
          "Collé",
          "Collée",
          "Colpa",
          "Colson",
          "Comans",
          "Combee",
          "Combé",
          "Comello",
          "Commandeur",
          "Commijs",
          "Commissaris",
          "Compaan",
          "Compagne",
          "Compagner",
          "Companje",
          "Companjen",
          "Compas",
          "Compeer",
          "Compen",
          "Compier",
          "Comte",
          "Comvalius",
          "Concincion",
          "Conen",
          "Confurius",
          "Conijn",
          "Coninck",
          "Conrad",
          "Conradi",
          "Consemulder",
          "Constancia",
          "Constandse",
          "Constant",
          "Consten",
          "Contant",
          "Coo",
          "Cooijmans",
          "Cooiman",
          "Cooke",
          "Cool",
          "Coolegem",
          "Coolen",
          "Cools",
          "Coolwijk",
          "Cooman",
          "Coomans",
          "Coonen",
          "Cooper",
          "Coopman",
          "Coopmans",
          "Coops",
          "Coort",
          "Cooten",
          "Copal",
          "Copier",
          "Copinga",
          "Coppelmans",
          "Coppen",
          "Coppens",
          "Copper",
          "Coppers",
          "Coppes",
          "Coppoolse",
          "Coppus",
          "Corba",
          "Corbeau",
          "Corbeek",
          "Corbeij",
          "Corbet",
          "Corbijn",
          "Cordes",
          "Cordewener",
          "Coremans",
          "Coret",
          "Corijn",
          "Cornax",
          "Cornel",
          "Cornelia",
          "Cornelis",
          "Cornelisse",
          "Cornelissen",
          "Cornelissens",
          "Cornelius",
          "Cornet",
          "Cornielje",
          "Cornips",
          "Corporaal",
          "Corput",
          "Correia",
          "Correljé",
          "Corsius",
          "Corstanje",
          "Corsten",
          "Corstens",
          "Corstjens",
          "Cort",
          "Corte",
          "Corten",
          "Cortenbach",
          "Cortenraad",
          "Corts",
          "Corveleijn",
          "Corven",
          "Corver",
          "Corvers",
          "Cosijn",
          "Cosman",
          "Cossee",
          "Costa",
          "Coster",
          "Costongs",
          "Coumans",
          "Coumou",
          "Couperus",
          "Couprie",
          "Courbois",
          "Courtens",
          "Coutinho",
          "Couvreur",
          "Couvée",
          "Couwenberg",
          "Couwenbergh",
          "Cox",
          "Cozijn",
          "Cozijnsen",
          "Coşkun",
          "Craane",
          "Craanen",
          "Craats",
          "Craemers",
          "Craen",
          "Craenen",
          "Craenmehr",
          "Crama",
          "Cramer",
          "Cramers",
          "Cranen",
          "Cranenbroek",
          "Crans",
          "Crapels",
          "Cras",
          "Crawford",
          "Creemers",
          "Creij",
          "Cremer",
          "Cremers",
          "Cretier",
          "Creusen",
          "Creutzburg",
          "Creuwels",
          "Crezee",
          "Crielaard",
          "Crienen",
          "Criens",
          "Crijnen",
          "Crijns",
          "Crins",
          "Cristina",
          "Crocq",
          "Croes",
          "Croese",
          "Croeze",
          "Croezen",
          "Croijmans",
          "Croix",
          "Crolla",
          "Crom",
          "Crombach",
          "Crombag",
          "Crombeen",
          "Crommenacker",
          "Crommentuijn",
          "Crommert",
          "Crompvoets",
          "Cromvoirt",
          "Cromwijk",
          "Crone",
          "Crooijmans",
          "Croon",
          "Croonen",
          "Croonenberg",
          "Crouwel",
          "Cruchten",
          "Crucq",
          "Cruden",
          "Cruijsberg",
          "Cruijsen",
          "Cruijssen",
          "Cruiming",
          "Crul",
          "Crum",
          "Cruts",
          "Crutzen",
          "Cruz",
          "Cuba",
          "Cuijk",
          "Cuijpers",
          "Cuijten",
          "Cuiper",
          "Cullens",
          "Cup",
          "Cuperus",
          "Cupido",
          "Cuppen",
          "Cuppens",
          "Cuppers",
          "Curfs",
          "Curiel",
          "Curré",
          "Curvers",
          "Cusiel",
          "Custers",
          "Cuvelier",
          "Cuypers",
          "Cörvers",
          "d'Hont",
          "d'Hooghe",
          "Daal",
          "Daalder",
          "Daalderop",
          "Daalen",
          "Daalhuisen",
          "Daalhuizen",
          "Daalman",
          "Daalmans",
          "Daalmeijer",
          "Daals",
          "Daamen",
          "Daams",
          "Daan",
          "Daane",
          "Daanen",
          "Daanje",
          "Daas",
          "Daatselaar",
          "Dackus",
          "Dael",
          "Daele",
          "Daelen",
          "Daelmans",
          "Daemen",
          "Daems",
          "Daenen",
          "Dag",
          "Dagelet",
          "Dagevos",
          "Dahlhaus",
          "Dahlmans",
          "Dahmani",
          "Dahmen",
          "Dahoe",
          "Dahri",
          "Dal",
          "Dalebout",
          "Daleman",
          "Dalemans",
          "Dalen",
          "Dalenberg",
          "Dalenoord",
          "Dales",
          "Dalfsen",
          "Dalhuisen",
          "Daling",
          "Dallinga",
          "Dalm",
          "Dalmaijer",
          "Dalman",
          "Dalmeijer",
          "Dalmolen",
          "Dalmulder",
          "Dalsem",
          "Dalsen",
          "Dalstra",
          "Dalum",
          "Dam",
          "Daman",
          "Dame",
          "Damen",
          "Dames",
          "Damhuis",
          "Damink",
          "Damkat",
          "Damkot",
          "Damman",
          "Damme",
          "Dammer",
          "Dammers",
          "Damming",
          "Damoiseaux",
          "Dams",
          "Damsma",
          "Damsteeg",
          "Damsteegt",
          "Damstra",
          "Damveld",
          "Damwijk",
          "Dane",
          "Danen",
          "Danenberg",
          "Dang",
          "Dangremond",
          "Danhof",
          "Daniel",
          "Daniels",
          "Daniël",
          "Daniëls",
          "Daniëlse",
          "Dank",
          "Dankaart",
          "Dankbaar",
          "Dankelman",
          "Danker",
          "Dankers",
          "Danklof",
          "Dannenberg",
          "Danse",
          "Dansen",
          "Danser",
          "Dansik",
          "Dantuma",
          "Dantzig",
          "Dao",
          "Daoud",
          "Daoudi",
          "Dap",
          "Dapper",
          "Dappers",
          "Daris",
          "Darkaoui",
          "Darsan",
          "Dartel",
          "Darwinkel",
          "Das",
          "Dashorst",
          "Dasler",
          "Dasselaar",
          "Dassen",
          "Dat",
          "Datema",
          "Daudeij",
          "Dauphin",
          "Dautzenberg",
          "Davelaar",
          "Davenschot",
          "Daverveld",
          "David",
          "Davids",
          "Davidse",
          "Davidson",
          "Davies",
          "Davina",
          "Davis",
          "Davits",
          "Day",
          "Dağ",
          "Dağdeviren",
          "Deben",
          "Debets",
          "Debi",
          "Debie",
          "Debije",
          "Debipersad",
          "Debisarun",
          "Decker",
          "Deckers",
          "Dedden",
          "Deddens",
          "Dede",
          "Deden",
          "Dedić",
          "Dee",
          "Deeben",
          "Deegens",
          "Deekman",
          "Deelen",
          "Deelman",
          "Deelstra",
          "Deen",
          "Deenen",
          "Deenik",
          "Deerenberg",
          "Dees",
          "Deetman",
          "Defesche",
          "Degeling",
          "Degen",
          "Degenaar",
          "Degenaars",
          "Degener",
          "Degenhart",
          "Degenkamp",
          "Degens",
          "Degger",
          "Deguelle",
          "Dehing",
          "Deij",
          "Deijck",
          "Deijk",
          "Deijkers",
          "Deijl",
          "Deijs",
          "Deijssel",
          "Deijzen",
          "Deiman",
          "Deinum",
          "Deira",
          "Dek",
          "Deken",
          "Dekens",
          "Dekken",
          "Dekker",
          "Dekkers",
          "Dekkinga",
          "Del Grosso",
          "Delahaije",
          "Delden",
          "Deleij",
          "Delemarre",
          "Delen",
          "Delfgaauw",
          "Delfgou",
          "Delfos",
          "Delfsma",
          "Delft",
          "Delgado",
          "Delger",
          "Delhaas",
          "Delhez",
          "Deli",
          "Delil",
          "Delis",
          "Delissen",
          "Deliën",
          "Delić",
          "Dellaert",
          "Dellebeke",
          "Delleman",
          "Dellemann",
          "Dellemijn",
          "Dellen",
          "Delmee",
          "Delnoij",
          "Delpeut",
          "Delsing",
          "Delsink",
          "Delsman",
          "Delst",
          "Delver",
          "Delwel",
          "Demandt",
          "Demarteau",
          "Demas",
          "Demeijer",
          "Demir",
          "Demirci",
          "Demirel",
          "Demirhan",
          "Demirtas",
          "Demirtaş",
          "Demkes",
          "Demmenie",
          "Demmer",
          "Demmers",
          "Demming",
          "Demmink",
          "Demoed",
          "Demon",
          "Demper",
          "Denderen",
          "Deneer",
          "Denekamp",
          "Denessen",
          "Denge",
          "Dengerink",
          "Denie",
          "Denis",
          "Denissen",
          "Deniz",
          "Denkers",
          "Denneboom",
          "Denneman",
          "Dennissen",
          "Deppe",
          "Derby",
          "Dercksen",
          "Derckx",
          "Derhaag",
          "Derickx",
          "Derikx",
          "Derix",
          "Derkink",
          "Derks",
          "Derkse",
          "Derksema",
          "Derksen",
          "Derkx",
          "Derlagen",
          "Dermois",
          "Dernison",
          "Derogee",
          "Derrez",
          "Derwort",
          "Descendre",
          "Dessel",
          "Dessens",
          "Dessing",
          "Determan",
          "Deters",
          "Deth",
          "Dethmers",
          "Detmar",
          "Detmers",
          "Deudekom",
          "Deugd",
          "Deuling",
          "Deunk",
          "Deur",
          "Deure",
          "Deuren",
          "Deurhof",
          "Deuring",
          "Deurloo",
          "Deurse",
          "Deursen",
          "Deurwaarder",
          "Deurzen",
          "Deuss",
          "Deutekom",
          "Deuten",
          "Deuveren",
          "Deuzeman",
          "Deveci",
          "Develing",
          "Deventer",
          "Devilee",
          "Dewaide",
          "Dewnarain",
          "Dharampal",
          "Dhondt",
          "Dhonre",
          "Diallo",
          "Dias",
          "Diaz",
          "Dibbets",
          "Dibbits",
          "Dicke",
          "Dickens",
          "Dicker",
          "Dickhoff",
          "Dickmann",
          "Dictus",
          "Didden",
          "Diderich",
          "Die",
          "Diebels",
          "Dieben",
          "Dieckmann",
          "Diederen",
          "Diederik",
          "Diederiks",
          "Diehl",
          "Diejen",
          "Dieke",
          "Diekema",
          "Dieker",
          "Diekman",
          "Diekmann",
          "Dieks",
          "Diekstra",
          "Dieleman",
          "Dielemans",
          "Dielen",
          "Dielis",
          "Dielissen",
          "Diels",
          "Diem",
          "Diemeer",
          "Diemel",
          "Diemen",
          "Diemer",
          "Diemers",
          "Dien",
          "Dienaar",
          "Diender",
          "Dienst",
          "Diepen",
          "Diepenbeek",
          "Diepenbroek",
          "Diependaal",
          "Diepenhorst",
          "Diepenmaat",
          "Diepens",
          "Dieperink",
          "Diepeveen",
          "Diepgrond",
          "Diephuis",
          "Diepman",
          "Diepstra",
          "Diepstraten",
          "Dierckx",
          "Dierdorp",
          "Dieren",
          "Dierendonck",
          "Dierick",
          "Dierikx",
          "Dierks",
          "Dierkx",
          "Diermen",
          "Dierx",
          "Diesen",
          "Diessen",
          "Diest",
          "Diesveld",
          "Dieten",
          "Dieteren",
          "Dieterman",
          "Dieters",
          "Dietrich",
          "Diets",
          "Dietvorst",
          "Dietz",
          "Diever",
          "Dieën",
          "Diggele",
          "Diggelen",
          "Dignum",
          "Dihal",
          "Dijck",
          "Dijcks",
          "Dijen",
          "Dijk",
          "Dijke",
          "Dijkema",
          "Dijken",
          "Dijker",
          "Dijkerman",
          "Dijkers",
          "Dijkgraaf",
          "Dijkhof",
          "Dijkhoff",
          "Dijkhorst",
          "Dijkhuis",
          "Dijkhuizen",
          "Dijkink",
          "Dijkkamp",
          "Dijkman",
          "Dijkmans",
          "Dijks",
          "Dijkshoorn",
          "Dijkslag",
          "Dijksma",
          "Dijksman",
          "Dijksteel",
          "Dijksterhuis",
          "Dijkstra",
          "Dijkxhoorn",
          "Dijkzeul",
          "Dijl",
          "Dijs",
          "Dijssel",
          "Dijsselbloem",
          "Dijsselhof",
          "Dijst",
          "Dijstelbloem",
          "Dijt",
          "Dik",
          "Dikhooff",
          "Dikkeboom",
          "Dikken",
          "Dikkenberg",
          "Dikker",
          "Dikkerboom",
          "Dikkers",
          "Dikkes",
          "Dikmans",
          "Diks",
          "Dil",
          "Dillema",
          "Dillen",
          "Dilling",
          "Dilven",
          "Dimmendaal",
          "Dimmers",
          "Dingelstad",
          "Dingemans",
          "Dingemanse",
          "Dingen",
          "Dingena",
          "Dingenen",
          "Dingenouts",
          "Dingerdis",
          "Dingjan",
          "Dingler",
          "Dings",
          "Dinh",
          "Dinjens",
          "Dinkelberg",
          "Dinkelman",
          "Dinkgreve",
          "Dinkla",
          "Dinmohamed",
          "Dinnissen",
          "Dinten",
          "Dinter",
          "Dinteren",
          "Dinther",
          "Dinç",
          "Dinçer",
          "Diphoorn",
          "Dircken",
          "Dircks",
          "Dirckx",
          "Dirix",
          "Dirken",
          "Dirkmaat",
          "Dirks",
          "Dirkse",
          "Dirksen",
          "Dirkson",
          "Dirksz",
          "Dirkx",
          "Dirkzwager",
          "Dirne",
          "Dirven",
          "Dis",
          "Disco",
          "Dissel",
          "Disseldorp",
          "Disveld",
          "Ditewig",
          "Ditmarsch",
          "Dits",
          "Ditshuizen",
          "Ditters",
          "Dittmar",
          "Ditzel",
          "Dix",
          "Dixhoorn",
          "Djaoen",
          "Djorai",
          "Djordjević",
          "Do",
          "Dob",
          "Dobbe",
          "Dobbelaar",
          "Dobbelaer",
          "Dobbelsteen",
          "Dobbelstein",
          "Dobben",
          "Dobber",
          "Dobma",
          "Docter",
          "Docters van Leeuwen",
          "Dodde",
          "Doddema",
          "Dodemont",
          "Dodewaard",
          "Dodeweerd",
          "Doe",
          "Doebar",
          "Doedens",
          "Doedée",
          "Doejaaren",
          "Doek",
          "Doekes",
          "Doekharan",
          "Doekhi",
          "Doekhie",
          "Doeksen",
          "Doel",
          "Doeland",
          "Doelder",
          "Doeleman",
          "Doelen",
          "Doelman",
          "Doensen",
          "Doerga",
          "Does",
          "Doesburg",
          "Doeselaar",
          "Doeser",
          "Doest",
          "Doeswijk",
          "Doetjes",
          "Doets",
          "Doeve",
          "Doeven",
          "Doevendans",
          "Doeveren",
          "Doezé",
          "Doff",
          "Dofferhoff",
          "Dogan",
          "Dogge",
          "Doggen",
          "Dogger",
          "Dogterom",
          "Dohmen",
          "Dok",
          "Dokkum",
          "Dokman",
          "Dokter",
          "Dol",
          "Dolder",
          "Dolderen",
          "Dolderman",
          "Doldersum",
          "Doleweerd",
          "Dolfing",
          "Dolfsma",
          "Dolk",
          "Doll",
          "Dollart",
          "Dolle",
          "Dollee",
          "Dollekamp",
          "Dollekens",
          "Dolleman",
          "Dollenkamp",
          "Doller",
          "Dollevoet",
          "Dollé",
          "Dolman",
          "Dolmans",
          "Dolphijn",
          "Dols",
          "Dolsma",
          "Dolstra",
          "Dom",
          "Domburg",
          "Domen",
          "Domenie",
          "Domhof",
          "Dominicus",
          "Dommele",
          "Dommelen",
          "Dommerholt",
          "Dommisse",
          "Dompeling",
          "Dompig",
          "Doms",
          "Domselaar",
          "Don",
          "Dona",
          "Donath",
          "Donck",
          "Donders",
          "Donderwinkel",
          "Dondorp",
          "Dong",
          "Donga",
          "Donge",
          "Dongelmans",
          "Dongen",
          "Dongeren",
          "Donia",
          "Donk",
          "Donkelaar",
          "Donker",
          "Donkerbroek",
          "Donkers",
          "Donkersgoed",
          "Donkersloot",
          "Donkersteeg",
          "Donkervoort",
          "Donks",
          "Donner",
          "Donners",
          "Dons",
          "Donselaar",
          "Dontje",
          "Donze",
          "Donzel",
          "Dood",
          "Doodeman",
          "Doodewaard",
          "Doodkorte",
          "Dooge",
          "Dooijeweerd",
          "Dooijeweert",
          "Dool",
          "Doolaard",
          "Doomen",
          "Doomernik",
          "Dooms",
          "Doop",
          "Dooper",
          "Doorakkers",
          "Doorduin",
          "Dooremaal",
          "Dooremalen",
          "Dooremolen",
          "Dooren",
          "Doorenbos",
          "Doorenbosch",
          "Doorenspleet",
          "Doorgeest",
          "Doormaal",
          "Doormalen",
          "Doorman",
          "Doorn",
          "Doornberg",
          "Doornbos",
          "Doornbosch",
          "Doornbusch",
          "Doorne",
          "Doornebal",
          "Doornebosch",
          "Doornekamp",
          "Doornenbal",
          "Doornewaard",
          "Doorneweerd",
          "Doornhein",
          "Doornik",
          "Doornink",
          "Doornkamp",
          "Doornmalen",
          "Doornspeek",
          "Doornwaard",
          "Doornweerd",
          "Doorschodt",
          "Doorson",
          "Doorten",
          "Doosje",
          "Dootjes",
          "Doove",
          "Dop",
          "Doppen",
          "Doppenberg",
          "Dopper",
          "Dopperen",
          "Doran",
          "Dorder",
          "Doreleijers",
          "Doremalen",
          "Doren",
          "Dorenbos",
          "Dorgelo",
          "Dorhout",
          "Dorland",
          "Dorlandt",
          "Dorlas",
          "Dorleijn",
          "Dorman",
          "Dormans",
          "Dormolen",
          "Dorn",
          "Dorothea",
          "Dorp",
          "Dorpel",
          "Dorren",
          "Dorrepaal",
          "Dorresteijn",
          "Dorrestein",
          "Dorrestijn",
          "Dorré",
          "Dors",
          "Dorsman",
          "Dorsselaer",
          "Dorssen",
          "Dorssers",
          "Dorst",
          "Dorsten",
          "Dorsthorst",
          "Dort",
          "Dortants",
          "Dorth",
          "Dortland",
          "Dortmans",
          "Dortmont",
          "Dossett",
          "Dost",
          "Dotinga",
          "Doudouh",
          "Douglas",
          "Douiri",
          "Douma",
          "Douna",
          "Dousi",
          "Douven",
          "Douw",
          "Douwenga",
          "Douwes",
          "Douwma",
          "Douwsma",
          "Douwstra",
          "Doveren",
          "Dovermann",
          "Doves",
          "Doze",
          "Dozeman",
          "Doğan",
          "Draad",
          "Draai",
          "Draaijer",
          "Draaisma",
          "Draak",
          "Draanen",
          "Drabbe",
          "Drabbels",
          "Dragstra",
          "Dragt",
          "Draijer",
          "Draisma",
          "Dral",
          "Dreef",
          "Drees",
          "Dreesen",
          "Dreessen",
          "Dreijer",
          "Dreise",
          "Dreissen",
          "Drempt",
          "Drent",
          "Drenth",
          "Drenthe",
          "Drenthen",
          "Dresen",
          "Dresens",
          "Dreu",
          "Dreumel",
          "Dreuning",
          "Dreven",
          "Dreves",
          "Drewel",
          "Drewes",
          "Drie",
          "Driebergen",
          "Driedijk",
          "Driegen",
          "Driehuijs",
          "Driehuis",
          "Driel",
          "Drielen",
          "Drieman",
          "Dries",
          "Driesche",
          "Driesen",
          "Driesprong",
          "Driessche",
          "Driesse",
          "Driessen",
          "Driessens",
          "Driest",
          "Driesten",
          "Driever",
          "Driezen",
          "Drieënhuizen",
          "Drift",
          "Drijfhout",
          "Drijver",
          "Drijvers",
          "Drimmelen",
          "Drinkwaard",
          "Drissen",
          "Droffelaar",
          "Drogen",
          "Drogt",
          "Drok",
          "Drommel",
          "Drongelen",
          "Dronkelaar",
          "Dronkers",
          "Dronkert",
          "Droog",
          "Drooge",
          "Droogendijk",
          "Drooger",
          "Droogers",
          "Droogh",
          "Droogsma",
          "Droomers",
          "Drop",
          "Droppers",
          "Droppert",
          "Dros",
          "Drossaert",
          "Drost",
          "Droste",
          "Drosten",
          "Drubbel",
          "Druenen",
          "Druif",
          "Druijf",
          "Druijff",
          "Druijven",
          "Druiventak",
          "Drukker",
          "Drummen",
          "Drumpt",
          "Drunen",
          "Drunick",
          "Druppers",
          "Drupsteen",
          "Druten",
          "Dröge",
          "Duarte",
          "Dubach",
          "Dubbelaar",
          "Dubbelboer",
          "Dubbeld",
          "Dubbeldam",
          "Dubbeldeman",
          "Dubbelden",
          "Dubbelman",
          "Dubbers",
          "Dubbink",
          "Dubelaar",
          "Dubois",
          "Duc",
          "Ducaat",
          "Duchateau",
          "Duckers",
          "Dudink",
          "Dudok",
          "Dudok van Heel",
          "Duenk",
          "Dueren den Hollander",
          "Duerink",
          "Duffelen",
          "Duffels",
          "Duffhues",
          "Dufour",
          "Duif",
          "Duifhuizen",
          "Duijf",
          "Duijker",
          "Duijkeren",
          "Duijkers",
          "Duijl",
          "Duijm",
          "Duijmelinck",
          "Duijn",
          "Duijndam",
          "Duijne",
          "Duijnen",
          "Duijnhouwer",
          "Duijnhoven",
          "Duijnisveld",
          "Duijnstee",
          "Duijs",
          "Duijsens",
          "Duijsings",
          "Duijst",
          "Duijster",
          "Duijsters",
          "Duijts",
          "Duijvelaar",
          "Duijvelshoff",
          "Duijvenbode",
          "Duijvenboden",
          "Duijvendijk",
          "Duijvenvoorde",
          "Duijvesteijn",
          "Duijvestijn",
          "Duijzer",
          "Duijzings",
          "Duiker",
          "Duikersloot",
          "Duim",
          "Duimel",
          "Duin",
          "Duindam",
          "Duine",
          "Duinen",
          "Duineveld",
          "Duinhouwer",
          "Duinker",
          "Duinkerke",
          "Duinkerken",
          "Duinmaijer",
          "Duinmeijer",
          "Duis",
          "Duist",
          "Duister",
          "Duistermaat",
          "Duisters",
          "Duisterwinkel",
          "Duit",
          "Duitman",
          "Duits",
          "Duitscher",
          "Duiveman",
          "Duiven",
          "Duivenbode",
          "Duivenboden",
          "Duivenbooden",
          "Duivendijk",
          "Duivenvoorde",
          "Duivenvoorden",
          "Duiverman",
          "Duivesteijn",
          "Duivestein",
          "Duivis",
          "Duizendstra",
          "Duizer",
          "Dujardin",
          "Dukel",
          "Duker",
          "Dukers",
          "Dukker",
          "Dul",
          "Dulfer",
          "Dulk",
          "Dulken",
          "Dullaart",
          "Dullaert",
          "Dullemen",
          "Dullemond",
          "Dullens",
          "Dulmen",
          "Dulos",
          "Dulst",
          "Duman",
          "Dumas",
          "Dumont",
          "Dumoulin",
          "Dun",
          "Duncker",
          "Dundas",
          "Dungen",
          "Dunk",
          "Dunnen",
          "Dunnewind",
          "Dunnewold",
          "Dunning",
          "Dunnink",
          "Dunsbergen",
          "Dunschoten",
          "Dunselman",
          "Duong",
          "Dupon",
          "Dupont",
          "Duppen",
          "Dupuis",
          "Dur",
          "Durak",
          "Duran",
          "Durand",
          "Duren",
          "Durenkamp",
          "Durieux",
          "Durinck",
          "During",
          "Durlinger",
          "Durmaz",
          "Durmus",
          "Durmuş",
          "Dursun",
          "Durville",
          "Dusink",
          "Dusschoten",
          "Dussel",
          "Dusseldorp",
          "Dusseljee",
          "Dussen",
          "Dusée",
          "Duteweert",
          "Dutrieux",
          "Duuren",
          "Duurkoop",
          "Duurland",
          "Duurling",
          "Duursema",
          "Duursma",
          "Duut",
          "Duvekot",
          "Duvigneau",
          "Duwel",
          "Duyvestijn",
          "Dwarka",
          "Dwarkasing",
          "Dwars",
          "Dwarshuis",
          "Dwarswaard",
          "Dykstra",
          "Dönmez",
          "Dörenberg",
          "Dörr",
          "Düzgün",
          "Ebbekink",
          "Ebbelaar",
          "Ebbeling",
          "Ebbelink",
          "Ebben",
          "Ebbenhorst",
          "Ebbens",
          "Ebbers",
          "Ebbing",
          "Ebbinge",
          "Ebbink",
          "Ebeling",
          "Ebels",
          "Ebelties",
          "Ebeltjes",
          "Eberhard",
          "Eberson",
          "Ebert",
          "Ebing",
          "Ebskamp",
          "Ebus",
          "Echteld",
          "Echtelt",
          "Echten",
          "Eck",
          "Eckeveld",
          "Eckhardt",
          "Edam",
          "Ede",
          "Edel",
          "Edelaar",
          "Edelbroek",
          "Edelenbos",
          "Edelenbosch",
          "Edelijn",
          "Edeling",
          "Edelman",
          "Eden",
          "Edens",
          "Ederen",
          "Ederveen",
          "Eding",
          "Edwards",
          "Ee",
          "Eeckhout",
          "Eeden",
          "Eefting",
          "Eeftink",
          "Eek",
          "Eekelder",
          "Eekelen",
          "Eekels",
          "Eeken",
          "Eekeren",
          "Eekert",
          "Eekhof",
          "Eekhout",
          "Eekhuis",
          "Eekma",
          "Eekman",
          "Eelderink",
          "Eelkema",
          "Eelman",
          "Eelsing",
          "Eeltink",
          "Eem",
          "Eems",
          "Eenbergen",
          "Eendenburg",
          "Eenennaam",
          "Eenhoorn",
          "Eenige",
          "Eenink",
          "Eenkhoorn",
          "Eerd",
          "Eerde",
          "Eerden",
          "Eerdt",
          "Eeren",
          "Eerenbeemt",
          "Eerenberg",
          "Eerens",
          "Eerhard",
          "Eerhart",
          "Eerkens",
          "Eerkes",
          "Eerland",
          "Eersel",
          "Eert",
          "Eerten",
          "Eertink",
          "Eertman",
          "Eertwegh",
          "Ees",
          "Eestermans",
          "Eeten",
          "Eeuwen",
          "Eeuwes",
          "Eeuwijk",
          "Efdé",
          "Efe",
          "Efferen",
          "Effing",
          "Effting",
          "Egas",
          "Egberink",
          "Egbers",
          "Egberts",
          "Egbertzen",
          "Egdom",
          "Egelmeers",
          "Egeraat",
          "Eggebeen",
          "Eggelen",
          "Eggels",
          "Eggen",
          "Eggengoor",
          "Eggenhuizen",
          "Eggenkamp",
          "Eggens",
          "Eggermont",
          "Eggers",
          "Eggert",
          "Egging",
          "Eggink",
          "Egmond",
          "Egtberts",
          "Egten",
          "Egteren",
          "Ehlen",
          "Ehren",
          "Eibrink",
          "Eichelsheim",
          "Eichhorn",
          "Eickhoff",
          "Eidhof",
          "Eier",
          "Eigenhuis",
          "Eigenraam",
          "Eijbergen",
          "Eijck",
          "Eijdems",
          "Eijden",
          "Eijer",
          "Eijgelaar",
          "Eijgelsheim",
          "Eijgen",
          "Eijgenhuijsen",
          "Eijgenraam",
          "Eijk",
          "Eijkel",
          "Eijkelboom",
          "Eijkelenboom",
          "Eijkelenburg",
          "Eijkelenkamp",
          "Eijkelhof",
          "Eijkelkamp",
          "Eijkemans",
          "Eijken",
          "Eijkenaar",
          "Eijkenboom",
          "Eijkens",
          "Eijkeren",
          "Eijkhout",
          "Eijking",
          "Eijkman",
          "Eijl",
          "Eijlander",
          "Eijlers",
          "Eijmeren",
          "Eijnde",
          "Eijnden",
          "Eijndhoven",
          "Eijndt",
          "Eijndthoven",
          "Eijnsbergen",
          "Eijpe",
          "Eijs",
          "Eijsackers",
          "Eijsbouts",
          "Eijsden",
          "Eijsermans",
          "Eijsink",
          "Eijssen",
          "Eijsvogels",
          "Eijt",
          "Eijzenga",
          "Eijzeren",
          "Eik",
          "Eikelboom",
          "Eikelenboom",
          "Eikema",
          "Eikenaar",
          "Eikenboom",
          "Eikendal",
          "Eikenhorst",
          "Eikens",
          "Eikholt",
          "Eikhout",
          "Eikmans",
          "Eilander",
          "Eilering",
          "Eilers",
          "Eilert",
          "Eiling",
          "Eimers",
          "Eind",
          "Einden",
          "Eindhoven",
          "Eis",
          "Eisden",
          "Eisen",
          "Eisenga",
          "Eising",
          "Eisinga",
          "Eisink",
          "Eisma",
          "Eissens",
          "Eisses",
          "Eitens",
          "Eiting",
          "Eizinga",
          "Ek",
          "Ekamper",
          "Ekelenburg",
          "Ekelmans",
          "Ekelschot",
          "Ekema",
          "Eken",
          "Eker",
          "Ekeren",
          "Ekeris",
          "Ekert",
          "Ekhart",
          "Ekici",
          "Ekinci",
          "Ekiz",
          "Ekkebus",
          "Ekkel",
          "Ekkelboom",
          "Ekkelenkamp",
          "Ekkelkamp",
          "Ekkels",
          "Ekker",
          "Ekkers",
          "Ekris",
          "El",
          "El Haddad",
          "El Haddioui",
          "El Hadouchi",
          "El Kaddouri",
          "El Makhloufi",
          "El Messaoudi",
          "El Sayed",
          "Eland",
          "Elands",
          "Elbers",
          "Elberse",
          "Elbersen",
          "Elbert",
          "Elbertse",
          "Elbertsen",
          "Elbrink",
          "Elburg",
          "Elden",
          "Elderen",
          "Elderhorst",
          "Eldering",
          "Elderkamp",
          "Elderman",
          "Elders",
          "Elderson",
          "Eldijk",
          "Eldik",
          "Eldonk",
          "Elema",
          "Elemans",
          "Elenbaas",
          "Eleonora",
          "Eleveld",
          "Elewout",
          "Elferen",
          "Elfering",
          "Elferink",
          "Elfers",
          "Elfferich",
          "Elfring",
          "Elfrink",
          "Elgersma",
          "Elhorst",
          "Elias",
          "Elich",
          "Elie",
          "Elijzen",
          "Eling",
          "Elings",
          "Elisabeth",
          "Elissen",
          "Elizabeth",
          "Elizen",
          "Eliëns",
          "Elk",
          "Elkerbout",
          "Elkhuizen",
          "Elkink",
          "Ellen",
          "Ellenbroek",
          "Ellenkamp",
          "Ellens",
          "Elleswijk",
          "Elling",
          "Ellis",
          "Elmas",
          "Elmendorp",
          "Elmers",
          "Elmi",
          "Elmpt",
          "Elout",
          "Elp",
          "Els",
          "Elschot",
          "Elsen",
          "Elsenaar",
          "Elsendoorn",
          "Elshof",
          "Elshoff",
          "Elshout",
          "Elsing",
          "Elsinga",
          "Elsinghorst",
          "Elskamp",
          "Elsman",
          "Elst",
          "Elstak",
          "Elsten",
          "Elstgeest",
          "Elswijk",
          "Elsäcker",
          "Elten",
          "Elteren",
          "Elting",
          "Eltink",
          "Elve",
          "Elven",
          "Elverding",
          "Elvers",
          "Elzakker",
          "Elzakkers",
          "Elzelingen",
          "Elzen",
          "Elzenaar",
          "Elzenga",
          "Elzer",
          "Elzerman",
          "Elzinga",
          "Eman",
          "Emans",
          "Emanuel",
          "Emanuels",
          "Emanuelson",
          "Emaus",
          "Embden",
          "Embrechts",
          "Embregts",
          "Emden",
          "Emerenciana",
          "Emmelkamp",
          "Emmelot",
          "Emmen",
          "Emmens",
          "Emmer",
          "Emmerich",
          "Emmerik",
          "Emmerink",
          "Emmerloot",
          "Emmers",
          "Emming",
          "Emmink",
          "Emo",
          "Emonds",
          "Emons",
          "Emonts",
          "Emous",
          "Empel",
          "Empelen",
          "Emst",
          "Enckevort",
          "End",
          "Ende",
          "Endeman",
          "Enden",
          "Endenburg",
          "Endendijk",
          "Enderink",
          "Endeveld",
          "Endhoven",
          "Endlich",
          "Endschot",
          "Endt",
          "Eng",
          "Engberink",
          "Engbers",
          "Engbersen",
          "Engberts",
          "Engel",
          "Engelaar",
          "Engelage",
          "Engeland",
          "Engelander",
          "Engelbart",
          "Engelbarts",
          "Engelbert",
          "Engelbertink",
          "Engelberts",
          "Engelbracht",
          "Engelbrecht",
          "Engelen",
          "Engelenburg",
          "Engelenhoven",
          "Engelgeer",
          "Engelhard",
          "Engelhardt",
          "Engelhart",
          "Engelkes",
          "Engelman",
          "Engels",
          "Engelse",
          "Engelsen",
          "Engelshoven",
          "Engelsma",
          "Engelsman",
          "Engeltjes",
          "Engen",
          "Engering",
          "Engh",
          "Engwerda",
          "Enk",
          "Enkelaar",
          "Enkhuizen",
          "Enklaar",
          "Ennema",
          "Ennik",
          "Enserink",
          "Ensing",
          "Ensink",
          "Ent",
          "Enter",
          "Enthoven",
          "Enting",
          "Entius",
          "Entjes",
          "Entrop",
          "Enzerink",
          "Epema",
          "Eppenga",
          "Epping",
          "Eppinga",
          "Eppink",
          "Epskamp",
          "Er",
          "Erades",
          "Eradus",
          "Eras",
          "Erasmus",
          "Erbrink",
          "Ercan",
          "Erckens",
          "Erdem",
          "Erdkamp",
          "Erdmann",
          "Erdogan",
          "Erdoğan",
          "Erdtsieck",
          "Eren",
          "Erens",
          "Erenstein",
          "Erents",
          "Erf",
          "Ergin",
          "Ergül",
          "Ergün",
          "Erich",
          "Eriks",
          "Eringa",
          "Eringaard",
          "Erinkveld",
          "Erk",
          "Erkamp",
          "Erkan",
          "Erkel",
          "Erkeland",
          "Erkelens",
          "Erkemeij",
          "Erken",
          "Erkens",
          "Erlings",
          "Ermen",
          "Ermens",
          "Ermers",
          "Ermes",
          "Ermiş",
          "Ermstrang",
          "Ernens",
          "Ernes",
          "Ernest",
          "Ernst",
          "Ernste",
          "Ernsten",
          "Eroglu",
          "Erol",
          "Eroğlu",
          "Erp",
          "Erren",
          "Ersoy",
          "Erve",
          "Erven",
          "Erwich",
          "Eryilmaz",
          "Es",
          "Esajas",
          "Esbach",
          "Esch",
          "Eschweiler",
          "Esdonk",
          "Esen",
          "Eser",
          "Eshof",
          "Eshuis",
          "Eskens",
          "Eskes",
          "Esman",
          "Esmeijer",
          "Espeldoorn",
          "Espen",
          "Essaidi",
          "Essanoussi",
          "Esschert",
          "Esschoten",
          "Esseboom",
          "Essed",
          "Esselbrugge",
          "Esseling",
          "Esselink",
          "Esselman",
          "Essen",
          "Essenberg",
          "Essenburg",
          "Essens",
          "Essenstam",
          "Esser",
          "Essers",
          "Esseveld",
          "Essing",
          "Essink",
          "Est",
          "Ester",
          "Esterik",
          "Esveld",
          "Esveldt",
          "Etienne",
          "Etman",
          "Etnel",
          "Ettekoven",
          "Ettema",
          "Etten",
          "Ettinger",
          "Eugelink",
          "Eulderink",
          "Eulink",
          "Eunen",
          "Eupen",
          "Eurlings",
          "Euser",
          "Eussen",
          "Euverman",
          "Euving",
          "Eveleens",
          "Even",
          "Evenblij",
          "Evenboer",
          "Evenhuis",
          "Everaars",
          "Everaarts",
          "Everaers",
          "Everaert",
          "Everaerts",
          "Everdingen",
          "Everhardus",
          "Everink",
          "Everling",
          "Evers",
          "Eversdijk",
          "Everse",
          "Eversen",
          "Eversteijn",
          "Evert",
          "Everts",
          "Evertse",
          "Evertsen",
          "Evertsz",
          "Evertz",
          "Evertzen",
          "Everwijn",
          "Evink",
          "Ewalds",
          "Ewals",
          "Ewalts",
          "Ewijck",
          "Ewijk",
          "Exalto",
          "Exel",
          "Exoo",
          "Extel",
          "Exter",
          "Exterkate",
          "Extra",
          "Eyck",
          "Eyk",
          "Ezendam",
          "Ezinga",
          "Faaij",
          "Faas",
          "Faase",
          "Faasen",
          "Faasse",
          "Faassen",
          "Faber",
          "Fabrie",
          "Fabriek",
          "Faerber",
          "Faes",
          "Faessen",
          "Fagel",
          "Fahner",
          "Faille",
          "Faken",
          "Fakkel",
          "Fakkeldij",
          "Fakkert",
          "Falier",
          "Falize",
          "Falke",
          "Falkena",
          "Farag",
          "Farah",
          "Faraj",
          "Farenhorst",
          "Fares",
          "Farissi",
          "Farla",
          "Faro",
          "Fase",
          "Fasel",
          "Fasen",
          "Fassaert",
          "Fatehmahomed",
          "Fatels",
          "Fathi",
          "Favier",
          "Feber",
          "Fecunda",
          "Feddema",
          "Feddes",
          "Feelders",
          "Feen",
          "Feenstra",
          "Fehling",
          "Feij",
          "Feijen",
          "Feijer",
          "Feijt",
          "Feijtel",
          "Feijter",
          "Feijth",
          "Feiken",
          "Feikens",
          "Feith",
          "Feitsma",
          "Fekken",
          "Fekkes",
          "Feld",
          "Feldbrugge",
          "Feldmann",
          "Felicia",
          "Felida",
          "Felius",
          "Felix",
          "Feller",
          "Fellinger",
          "Fels",
          "Felten",
          "Felter",
          "Fenijn",
          "Fennema",
          "Fennis",
          "Fens",
          "Fer",
          "Ferdinandus",
          "Feringa",
          "Ferket",
          "Fermont",
          "Fernand",
          "Fernandes",
          "Fernandez",
          "Fernando",
          "Fernhout",
          "Feron",
          "Ferreira",
          "Ferrier",
          "Ferwerda",
          "Feskens",
          "Fessem",
          "Festen",
          "Feteris",
          "Fetter",
          "Feunekes",
          "Fevre",
          "Fial",
          "Fick",
          "Fictorie",
          "Fidan",
          "Fiddelers",
          "Fidder",
          "Fidom",
          "Fiechter",
          "Fiege",
          "Fielt",
          "Fiene",
          "Fiere",
          "Fieret",
          "Fiering",
          "Fierloos",
          "Fiers",
          "Fieten",
          "Fietje",
          "Figaroa",
          "Figee",
          "Figge",
          "Fijan",
          "Fijen",
          "Fijlstra",
          "Fijma",
          "Fijn",
          "Fijnaut",
          "Fijneman",
          "Fijnvandraat",
          "Fijten",
          "Fijter",
          "Fikke",
          "Fikkers",
          "Fikkert",
          "Fiks",
          "Fikse",
          "Filart",
          "Filemon",
          "Filippini",
          "Filippo",
          "Filius",
          "Fillekes",
          "Filé",
          "Finders",
          "Finke",
          "Finkers",
          "Finnema",
          "Finsy",
          "Fintelman",
          "Fiolet",
          "Fioole",
          "Firat",
          "Firing",
          "Fischer",
          "Fiselier",
          "Fisscher",
          "Fisser",
          "Fitters",
          "Fix",
          "Flach",
          "Flaman",
          "Flameling",
          "Flantua",
          "Flapper",
          "Flaton",
          "Flecken",
          "Fledderman",
          "Fledderus",
          "Fleer",
          "Fleerakkers",
          "Fleming",
          "Flemming",
          "Flens",
          "Fles",
          "Fleskens",
          "Fleur",
          "Fleuren",
          "Fleurke",
          "Fleurkens",
          "Flick",
          "Flier",
          "Flierman",
          "Fliert",
          "Flietstra",
          "Flik",
          "Flikkema",
          "Flikweert",
          "Flim",
          "Flink",
          "Flinsenberg",
          "Flint",
          "Flinterman",
          "Flippo",
          "Flipse",
          "Flipsen",
          "Flisijn",
          "Flobbe",
          "Flohil",
          "Flohr",
          "Flokstra",
          "Flonk",
          "Floor",
          "Floors",
          "Florack",
          "Florax",
          "Floren",
          "Florentinus",
          "Flores",
          "Florie",
          "Florijn",
          "Floris",
          "Florissen",
          "Florusse",
          "Flos",
          "Fluijt",
          "Fluit",
          "Fluiter",
          "Fluitman",
          "Fluitsma",
          "Fluks",
          "Flux",
          "Focke",
          "Fockert",
          "Foederer",
          "Foekema",
          "Foeken",
          "Foekens",
          "Foesenek",
          "Fok",
          "Fokke",
          "Fokkema",
          "Fokken",
          "Fokkens",
          "Fokker",
          "Fokkert",
          "Fokkinga",
          "Fokkink",
          "Foks",
          "Folbert",
          "Folkeringa",
          "Folkers",
          "Folkersma",
          "Folkerts",
          "Folkertsma",
          "Folmer",
          "Fondse",
          "Fonk",
          "Fonken",
          "Fonseca",
          "Fontaine",
          "Fonteijn",
          "Fontein",
          "Fonteine",
          "Fontijn",
          "Fontijne",
          "Fonville",
          "Foolen",
          "Foort",
          "Fopma",
          "Foppele",
          "Foppen",
          "Former",
          "Forrer",
          "Fortes",
          "Fortgens",
          "Fortuijn",
          "Fortuin",
          "Fossen",
          "Fouchier",
          "Fouw",
          "Fox",
          "Fraaij",
          "Fraanje",
          "Fraenk",
          "Fraikin",
          "Fraiquin",
          "Francis",
          "Francisca",
          "Francisco",
          "Francissen",
          "Franck",
          "Francke",
          "Francken",
          "Francot",
          "Frank",
          "Franke",
          "Frankema",
          "Franken",
          "Frankena",
          "Frankes",
          "Frankfort",
          "Frankhuisen",
          "Frankhuizen",
          "Frankrijker",
          "Frans",
          "Franse",
          "Fransen",
          "Fransens",
          "Fransman",
          "Franssen",
          "Franssens",
          "Fransz",
          "Frantzen",
          "Franx",
          "Franz",
          "Franzen",
          "François",
          "Fraser",
          "Fraterman",
          "Frauenfelder",
          "Fraza",
          "Frazer",
          "Frederik",
          "Frederiks",
          "Frederix",
          "Fredriks",
          "Fredriksz",
          "Fredrix",
          "Free",
          "Freeke",
          "Freese",
          "Freeth",
          "Freij",
          "Freije",
          "Freijser",
          "Freitas",
          "Freke",
          "Frel",
          "Freling",
          "Frelink",
          "Fremouw",
          "Frenaij",
          "Frencken",
          "Frenk",
          "Frenken",
          "Frens",
          "Frensch",
          "Frentz",
          "Frerichs",
          "Frericks",
          "Freriks",
          "Freriksen",
          "Fresco",
          "Fresen",
          "Fretes",
          "Fricke",
          "Frie",
          "Friebel",
          "Friederich",
          "Friederichs",
          "Friedrich",
          "Frieling",
          "Frielink",
          "Friesen",
          "Frieser",
          "Frieswijk",
          "Frietema",
          "Frietman",
          "Frijling",
          "Frijlink",
          "Frijns",
          "Frijters",
          "Frik",
          "Frikken",
          "Frimpong",
          "Frings",
          "Frinking",
          "Frints",
          "Fris",
          "Frishert",
          "Friso",
          "Frissen",
          "Fritschij",
          "Fritz",
          "Froeling",
          "Froger",
          "Frohn",
          "From",
          "Froma",
          "Fronik",
          "Froon",
          "Frowijn",
          "Fruijtier",
          "Frumau",
          "Frusch",
          "Fränkel",
          "Fräser",
          "Frèrejean",
          "Frölich",
          "Fröling",
          "Fu",
          "Fuchs",
          "Fuhler",
          "Fuhren",
          "Fuite",
          "Fukkink",
          "Fulpen",
          "Fun",
          "Funcke",
          "Fung",
          "Funk",
          "Funke",
          "Futselaar",
          "Förster",
          "Gaag",
          "Gaakeer",
          "Gaal",
          "Gaalen",
          "Gaans",
          "Gaarden",
          "Gaarenstroom",
          "Gaarthuis",
          "Gaasbeek",
          "Gaasenbeek",
          "Gaasendam",
          "Gaast",
          "Gaastra",
          "Gabel",
          "Gabeler",
          "Gabriel",
          "Gabriels",
          "Gabriël",
          "Gabriëls",
          "Gabriëlse",
          "Gadellaa",
          "Gademan",
          "Gaemers",
          "Gaertner",
          "Gageldonk",
          "Gaikema",
          "Gaillard",
          "Gajadhar",
          "Gajadien",
          "Gajadin",
          "Gal",
          "Galama",
          "Galema",
          "Galen",
          "Galenkamp",
          "Galesloot",
          "Galiart",
          "Galis",
          "Galiën",
          "Galjaard",
          "Gall",
          "Gallas",
          "Galle",
          "Gallé",
          "Gambier",
          "Game",
          "Gameren",
          "Gammeren",
          "Ganesh",
          "Ganga",
          "Gangadien",
          "Gangadin",
          "Gangapersad",
          "Gangelen",
          "Gankema",
          "Ganpat",
          "Ganput",
          "Gans",
          "Gansewinkel",
          "Ganzeboer",
          "Ganzeboom",
          "Ganzeveld",
          "Ganzevles",
          "Ganzevoort",
          "Ganzewinkel",
          "Garcia",
          "Garde",
          "Gardenier",
          "Gardeniers",
          "Garderen",
          "Gardien",
          "Gardingen",
          "Garib",
          "Garnier",
          "Garretsen",
          "Garritsen",
          "Garssen",
          "Garst",
          "Gashi",
          "Gaspersz",
          "Gasseling",
          "Gasselt",
          "Gast",
          "Gastel",
          "Gasteren",
          "Gatsonides",
          "Gebben",
          "Gebbinck",
          "Gebbink",
          "Gebhardt",
          "Geboers",
          "Gebraad",
          "Gebuis",
          "Gedik",
          "Geel",
          "Geelen",
          "Geelhoed",
          "Geelink",
          "Geelkerken",
          "Geels",
          "Geemen",
          "Geemert",
          "Geene",
          "Geenen",
          "Geenhuizen",
          "Geense",
          "Geensen",
          "Geer",
          "Geeraets",
          "Geerards",
          "Geerdes",
          "Geerdinck",
          "Geerdink",
          "Geerds",
          "Geerenstein",
          "Geerings",
          "Geerink",
          "Geeris",
          "Geerligs",
          "Geerling",
          "Geerlings",
          "Geerlof",
          "Geerman",
          "Geers",
          "Geerse",
          "Geersing",
          "Geertman",
          "Geerts",
          "Geertse",
          "Geertsema",
          "Geertsen",
          "Geertsma",
          "Geervliet",
          "Geesing",
          "Geesink",
          "Geessink",
          "Geest",
          "Geet",
          "Geeve",
          "Geeven",
          "Geevers",
          "Geffen",
          "Gefferie",
          "Gehlen",
          "Gehring",
          "Geijlswijk",
          "Geijn",
          "Geijs",
          "Geijselaers",
          "Geijsen",
          "Geijteman",
          "Geijtenbeek",
          "Geilen",
          "Geilenkirchen",
          "Geilings",
          "Geitenbeek",
          "Gelauf",
          "Gelauff",
          "Geld",
          "Gelder",
          "Gelderblom",
          "Geldere",
          "Gelderen",
          "Gelderland",
          "Gelderloos",
          "Gelderman",
          "Geldermans",
          "Geldhof",
          "Geldof",
          "Geldorp",
          "Geleijns",
          "Geleijnse",
          "Gelens",
          "Geleuken",
          "Gelici",
          "Geling",
          "Gelink",
          "Gelissen",
          "Gellecom",
          "Gellecum",
          "Gellekom",
          "Gelling",
          "Gelmers",
          "Gelok",
          "Geloof",
          "Geloven",
          "Gels",
          "Gelsing",
          "Gelten",
          "Geltink",
          "Gelton",
          "Geluk",
          "Gemerden",
          "Gemeren",
          "Gemert",
          "Gemerts",
          "Gemin",
          "Gemmink",
          "Gemser",
          "Gend",
          "Genderen",
          "Genders",
          "Gendt",
          "Genechten",
          "Genee",
          "Geneijgen",
          "Genet",
          "Geneugelijk",
          "Gennep",
          "Gennip",
          "Gennissen",
          "Gent",
          "Gentenaar",
          "Genuchten",
          "Genugten",
          "Genç",
          "George",
          "Gepken",
          "Geraads",
          "Geraats",
          "Geradts",
          "Geraeds",
          "Geraedts",
          "Geraerts",
          "Geraets",
          "Gerard",
          "Gerards",
          "Gerardu",
          "Gerats",
          "Gerber",
          "Gerbers",
          "Gerbrandij",
          "Gerbrands",
          "Gerdes",
          "Gerding",
          "Gerdsen",
          "Geresteijn",
          "Gerhards",
          "Gering",
          "Gerits",
          "Gerkema",
          "Gerla",
          "Gerlach",
          "Gerlag",
          "Gerlings",
          "Gerlofsma",
          "Germans",
          "Germeraad",
          "Germs",
          "Gernaat",
          "Gerner",
          "Gerrets",
          "Gerretsen",
          "Gerrevink",
          "Gerris",
          "Gerrist",
          "Gerrits",
          "Gerritse",
          "Gerritsen",
          "Gerritsma",
          "Gerritzen",
          "Gersen",
          "Gerssen",
          "Gerth",
          "Gertsen",
          "Gerven",
          "Gervink",
          "Gerwen",
          "Gerwig",
          "Geschiere",
          "Gesink",
          "Geskus",
          "Gessel",
          "Gesser",
          "Gest",
          "Gestel",
          "Gesthuizen",
          "Getkate",
          "Getrouw",
          "Geugjes",
          "Geugten",
          "Geuijen",
          "Geuke",
          "Geukes",
          "Geul",
          "Geuns",
          "Geurds",
          "Geurink",
          "Geurkink",
          "Geurs",
          "Geurten",
          "Geurtjens",
          "Geurts",
          "Geurts van Kessel",
          "Geurtse",
          "Geurtsen",
          "Geurtz",
          "Geus",
          "Geusebroek",
          "Geuskens",
          "Geutjes",
          "Geuze",
          "Geuzebroek",
          "Geuzinge",
          "Geveke",
          "Gevel",
          "Geven",
          "Geverink",
          "Gevers",
          "Geway",
          "Gezer",
          "Ghaddari",
          "Ghamarti",
          "Gharbharan",
          "Ghazi",
          "Ghielen",
          "Ghijsen",
          "Ghiraw",
          "Ghisaidoobe",
          "Gianotten",
          "Gibbs",
          "Gibcus",
          "Gidding",
          "Gideonse",
          "Giebels",
          "Gieben",
          "Giel",
          "Giele",
          "Gielen",
          "Gielens",
          "Gieles",
          "Gielesen",
          "Gieling",
          "Gielink",
          "Gielis",
          "Gielisse",
          "Gielissen",
          "Gielkens",
          "Giepmans",
          "Gier",
          "Gierkink",
          "Gierman",
          "Giersbergen",
          "Gierveld",
          "Gies",
          "Giesbergen",
          "Giesbers",
          "Giesberts",
          "Giesbertz",
          "Giesen",
          "Giesing",
          "Gieskens",
          "Gieskes",
          "Giessen",
          "Gietema",
          "Giethoorn",
          "Gietman",
          "Giezeman",
          "Giezen",
          "Giezenaar",
          "Gigengack",
          "Gijbels",
          "Gijben",
          "Gijlswijk",
          "Gijn",
          "Gijsbers",
          "Gijsbertha",
          "Gijsberts",
          "Gijsbertse",
          "Gijsbertsen",
          "Gijsel",
          "Gijselhart",
          "Gijsen",
          "Gijsman",
          "Gijssel",
          "Gijtenbeek",
          "Gijzel",
          "Gijzen",
          "Gilbers",
          "Gilde",
          "Giliam",
          "Gilijamse",
          "Giling",
          "Gilissen",
          "Giljam",
          "Gill",
          "Gille",
          "Gillebaard",
          "Gilles",
          "Gillesen",
          "Gillis",
          "Gillissen",
          "Gils",
          "Gilsing",
          "Gilst",
          "Ginderen",
          "Ginhoven",
          "Gink",
          "Ginkel",
          "Ginneke",
          "Ginneken",
          "Girdhari",
          "Girigorie",
          "Gisbergen",
          "Giskes",
          "Gisteren",
          "Gjaltema",
          "Glabbeek",
          "Gladdines",
          "Glandorf",
          "Glas",
          "Glasbergen",
          "Glaser",
          "Glashouwer",
          "Glasius",
          "Glastra",
          "Glaudemans",
          "Glavimans",
          "Glazenborg",
          "Glazenburg",
          "Glebbeek",
          "Glee",
          "Gleijm",
          "Glerum",
          "Glim",
          "Glimmerveen",
          "Glind",
          "Glissenaar",
          "Glopper",
          "Glorie",
          "Gloudemans",
          "Gnodde",
          "Go",
          "Gobardhan",
          "Gobind",
          "Goch",
          "Goddijn",
          "Godding",
          "Godeke",
          "Goderie",
          "Godfried",
          "Godijn",
          "Godlieb",
          "Godrie",
          "Godschalk",
          "Godthelp",
          "Godwaldt",
          "Godée",
          "Goed",
          "Goedbloed",
          "Goede",
          "Goedee",
          "Goedegebure",
          "Goedegebuur",
          "Goedegebuure",
          "Goedemans",
          "Goedendorp",
          "Goederen",
          "Goedhart",
          "Goedknegt",
          "Goedkoop",
          "Goedman",
          "Goedvolk",
          "Goei",
          "Goeij",
          "Goeijen",
          "Goeloe",
          "Goemaat",
          "Goeman",
          "Goemans",
          "Goense",
          "Goeptar",
          "Goeree",
          "Goertz",
          "Goes",
          "Goessen",
          "Goessens",
          "Goesten",
          "Goethals",
          "Goetheer",
          "Goethem",
          "Goettsch",
          "Goey",
          "Goezinne",
          "Goffau",
          "Goffin",
          "Gog",
          "Gogh",
          "Goijaerts",
          "Goinga",
          "Gokoel",
          "Gol",
          "Golbach",
          "Goldberg",
          "Golde",
          "Goldenbeld",
          "Goldewijk",
          "Goldman",
          "Goldstein",
          "Golen",
          "Golsteijn",
          "Golstein",
          "Golverdingen",
          "Gom",
          "Gombert",
          "Gomersbach",
          "Gomes",
          "Gomez",
          "Gommans",
          "Gommer",
          "Gommeren",
          "Gommers",
          "Gompel",
          "Gonesh",
          "Gonggrijp",
          "Gonlag",
          "Gons",
          "Gonzalez",
          "Gonçalves",
          "Goodijk",
          "Gooijer",
          "Gooijers",
          "Gool",
          "Goor",
          "Goorbergh",
          "Goorden",
          "Gooren",
          "Goorhuis",
          "Goorman",
          "Goorts",
          "Goos",
          "Goosen",
          "Goosens",
          "Gooskens",
          "Goossen",
          "Goossens",
          "Gooswilligen",
          "Goot",
          "Gootjes",
          "Gootzen",
          "Goozen",
          "Gopal",
          "Gopi",
          "Gopie",
          "Goppel",
          "Gorcum",
          "Gordeau",
          "Gordebeke",
          "Gordijn",
          "Gordon",
          "Gorel",
          "Goris",
          "Gorissen",
          "Gorkink",
          "Gorkom",
          "Gorkum",
          "Gorp",
          "Gorree",
          "Gorsel",
          "Gort",
          "Gortel",
          "Gortemaker",
          "Gorter",
          "Gortworst",
          "Gortzak",
          "Goselink",
          "Gosen",
          "Gosens",
          "Gosliga",
          "Goslinga",
          "Gosman",
          "Gosselaar",
          "Gosseling",
          "Gosselink",
          "Gossen",
          "Gossens",
          "Gossink",
          "Gotink",
          "Gotjé",
          "Gottenbos",
          "Gottmer",
          "Goud",
          "Gouda",
          "Goudappel",
          "Goudbeek",
          "Goudberg",
          "Goudkuil",
          "Goudriaan",
          "Goudsblom",
          "Goudsmit",
          "Goudswaard",
          "Goudzwaard",
          "Gouka",
          "Goulooze",
          "Gouma",
          "Gouman",
          "Goumans",
          "Gouriye",
          "Gout",
          "Goutier",
          "Gouverneur",
          "Gouw",
          "Gouwe",
          "Gouweleeuw",
          "Gouweloos",
          "Gouwenberg",
          "Gouwens",
          "Gouwerok",
          "Govaarts",
          "Govaert",
          "Govaerts",
          "Goverde",
          "Govers",
          "Goverts",
          "Gowrising",
          "Gozeling",
          "Graaf",
          "Graafeiland",
          "Graaff",
          "Graafland",
          "Graafmans",
          "Graafsma",
          "Graag",
          "Graanoogst",
          "Graansma",
          "Graas",
          "Graat",
          "Graauw",
          "Graauwmans",
          "Grabijn",
          "Gracht",
          "Gradussen",
          "Graef",
          "Grafhorst",
          "Graft",
          "Gragt",
          "Gram",
          "Gramberg",
          "Gramser",
          "Gramsma",
          "Grand",
          "Grandia",
          "Grandiek",
          "Granneman",
          "Grannetia",
          "Grant",
          "Grapendaal",
          "Gras",
          "Grasdijk",
          "Grashof",
          "Grashoff",
          "Grashuis",
          "Grasman",
          "Grasmeijer",
          "Graumans",
          "Graus",
          "Grauss",
          "Grauw",
          "Grave",
          "Gravekamp",
          "Graveland",
          "Gravemaker",
          "Graven",
          "Gravenbeek",
          "Gravenberch",
          "Gravendeel",
          "Graver",
          "Gravesteijn",
          "Gravestein",
          "Graça",
          "Greebe",
          "Greef",
          "Greeff",
          "Greefhorst",
          "Green",
          "Greeuw",
          "Greeve",
          "Greeven",
          "Greevink",
          "Grefkens",
          "Greft",
          "Grefte",
          "Gregoire",
          "Gregoor",
          "Greidanus",
          "Greijdanus",
          "Greijmans",
          "Greijn",
          "Greiner",
          "Gremmen",
          "Gremmer",
          "Grendel",
          "Grendelman",
          "Grens",
          "Grent",
          "Gresnigt",
          "Greten",
          "Greuningen",
          "Greuter",
          "Greve",
          "Greveling",
          "Grevelink",
          "Greven",
          "Grevenbroek",
          "Grevenstuk",
          "Grevers",
          "Greving",
          "Grevinga",
          "Grevink",
          "Gribnau",
          "Griek",
          "Grieken",
          "Griekspoor",
          "Griemink",
          "Griend",
          "Griendt",
          "Griens",
          "Griensven",
          "Griep",
          "Gries",
          "Griethuijsen",
          "Grievink",
          "Griffioen",
          "Griffith",
          "Grifhorst",
          "Grift",
          "Grijmans",
          "Grijn",
          "Grijpink",
          "Grijpma",
          "Grijpstra",
          "Grijs",
          "Grijseels",
          "Grijsen",
          "Grijzenhout",
          "Grim",
          "Grimberg",
          "Grimbergen",
          "Grimm",
          "Grimme",
          "Grimminck",
          "Grimmius",
          "Grin",
          "Gringhuis",
          "Grinsven",
          "Grint",
          "Grinten",
          "Grinwis",
          "Grippeling",
          "Grisel",
          "Grispen",
          "Grissen",
          "Grit",
          "Gritter",
          "Grob",
          "Grobbe",
          "Grobben",
          "Groef",
          "Groefsema",
          "Groen",
          "Groen in 't Woud",
          "Groen in 't Wout",
          "Groenbroek",
          "Groendijk",
          "Groene",
          "Groenen",
          "Groenenberg",
          "Groenenboom",
          "Groenendaal",
          "Groenendal",
          "Groenendijk",
          "Groener",
          "Groenestein",
          "Groeneveld",
          "Groenevelt",
          "Groenewald",
          "Groeneweg",
          "Groenewege",
          "Groenewegen",
          "Groenewold",
          "Groenewoud",
          "Groenhagen",
          "Groenhart",
          "Groenheide",
          "Groenheijde",
          "Groenhof",
          "Groenhout",
          "Groenhuijzen",
          "Groenigen",
          "Groeningen",
          "Groenink",
          "Groenland",
          "Groentjes",
          "Groenveld",
          "Groenwold",
          "Groep",
          "Groesbeek",
          "Groesen",
          "Groet",
          "Groezen",
          "Groffen",
          "Grofsmid",
          "Grol",
          "Grolleman",
          "Grollé",
          "Grond",
          "Grondel",
          "Grondelle",
          "Gronden",
          "Grondhuis",
          "Grondman",
          "Grondsma",
          "Groningen",
          "Grood",
          "Groodt",
          "Groof",
          "Groos",
          "Groosman",
          "Groot",
          "Groot Hulze",
          "Groot Jebbink",
          "Groot Koerkamp",
          "Groot Kormelink",
          "Groot Nibbelink",
          "Groot Roessink",
          "Groot Wassink",
          "Groot Zevert",
          "Groote",
          "Groote Schaarsberg",
          "Grootel",
          "Grootelaar",
          "Grooteman",
          "Grooten",
          "Grootenboer",
          "Grootendorst",
          "Grootenhuis",
          "Grootens",
          "Grooters",
          "Grootes",
          "Grootevheen",
          "Grootfaam",
          "Grooth",
          "Groothedde",
          "Grootheest",
          "Groothof",
          "Groothoff",
          "Groothuis",
          "Groothuizen",
          "Grootjans",
          "Grootjen",
          "Grootjes",
          "Grootkarzijn",
          "Grootoonk",
          "Grootscholten",
          "Grootswagers",
          "Grootveld",
          "Gros",
          "Grosfeld",
          "Groskamp",
          "Grot",
          "Grote",
          "Groteboer",
          "Grotel",
          "Groten",
          "Grotenbreg",
          "Grotendorst",
          "Grotenhuis",
          "Grotens",
          "Groters",
          "Grouw",
          "Grouwstra",
          "Grozema",
          "Grubben",
          "Gruben",
          "Gruijl",
          "Gruijs",
          "Gruijter",
          "Gruijters",
          "Gruijthuijsen",
          "Gruis",
          "Gruisen",
          "Gruiter",
          "Gruiters",
          "Grul",
          "Grummel",
          "Grund",
          "Grundeken",
          "Grundel",
          "Grunder",
          "Grunsven",
          "Grunt",
          "Gruntjes",
          "Gruppen",
          "Grupstra",
          "Gruter",
          "Gruters",
          "Grutter",
          "Grutters",
          "Gruyters",
          "Gräper",
          "Gubbels",
          "Gubler",
          "Guchte",
          "Gudde",
          "Gudden",
          "Gude",
          "Guelen",
          "Gugten",
          "Guichelaar",
          "Guijt",
          "Guikema",
          "Guiljam",
          "Guis",
          "Guit",
          "Gul",
          "Guldemeester",
          "Guldemond",
          "Gulden",
          "Guldenaar",
          "Guldener",
          "Gulick",
          "Gulickx",
          "Gulik",
          "Guliker",
          "Gulikers",
          "Gulpen",
          "Gulpers",
          "Guman",
          "Gumbs",
          "Gun",
          "Gundlach",
          "Gunneman",
          "Gunneweg",
          "Gunning",
          "Gunnink",
          "Guns",
          "Gunsing",
          "Gunst",
          "Gunter",
          "Gunther",
          "Guntlisbergen",
          "Guo",
          "Gurp",
          "Gussenhoven",
          "Gussinklo",
          "Gustin",
          "Guth",
          "Gutteling",
          "Gutter",
          "Göbbels",
          "Göbel",
          "Göertz",
          "Gök",
          "Gökalp",
          "Gökmen",
          "Göksu",
          "Göktaş",
          "Gökçe",
          "Gören",
          "Görtz",
          "Görtzen",
          "Göttgens",
          "Götz",
          "Gül",
          "Güler",
          "Güleç",
          "Gültekin",
          "Gümüs",
          "Gümüş",
          "Gün",
          "Günay",
          "Günaydin",
          "Gündoğdu",
          "Gündüz",
          "Güner",
          "Günes",
          "Güney",
          "Güneş",
          "Güngör",
          "Günther",
          "Gür",
          "Gürbüz",
          "Gürel",
          "Gürler",
          "Gürsoy",
          "Güven",
          "Güzel",
          "Güçlü",
          "Ha",
          "Haaf",
          "Haafkes",
          "Haaften",
          "Haag",
          "Haagen",
          "Haagh",
          "Haagmans",
          "Haagsma",
          "Haagsman",
          "Haaij",
          "Haaijer",
          "Haaima",
          "Haak",
          "Haakma",
          "Haakman",
          "Haakmat",
          "Haakmeester",
          "Haaksema",
          "Haaksma",
          "Haaksman",
          "Haalboom",
          "Haalen",
          "Haan",
          "Haanappel",
          "Haandel",
          "Haandrikman",
          "Haanen",
          "Haans",
          "Haanschoten",
          "Haanskorf",
          "Haanstra",
          "Haantjes",
          "Haar",
          "Haarbosch",
          "Haarbrink",
          "Haard",
          "Haardt",
          "Haare",
          "Haaren",
          "Haarhuis",
          "Haaring",
          "Haarlem",
          "Haarman",
          "Haarmans",
          "Haars",
          "Haarsma",
          "Haarst",
          "Haart",
          "Haartsen",
          "Haas",
          "Haasbroek",
          "Haasdijk",
          "Haase",
          "Haasen",
          "Haasjes",
          "Haasnoot",
          "Haast",
          "Haaster",
          "Haasteren",
          "Haastert",
          "Haastrecht",
          "Haastregt",
          "Haazen",
          "Habekotté",
          "Habermehl",
          "Habers",
          "Habes",
          "Habets",
          "Habib",
          "Habibi",
          "Habich",
          "Habing",
          "Habraken",
          "Hachioui",
          "Hachmang",
          "Hack",
          "Hacken",
          "Hacking",
          "Haddad",
          "Haddeman",
          "Hadderingh",
          "Hadders",
          "Haddouch",
          "Haddouchi",
          "Haddouti",
          "Hadi",
          "Hadžić",
          "Haeck",
          "Haeften",
          "Haegens",
          "Haemers",
          "Haen",
          "Haenen",
          "Haer",
          "Haeren",
          "Haeringen",
          "Haerkens",
          "Haesen",
          "Haest",
          "Haex",
          "Haffmans",
          "Hafid",
          "Hafkamp",
          "Hafkenscheid",
          "Haften",
          "Hag",
          "Haga",
          "Hage",
          "Hagebeek",
          "Hagebeuk",
          "Hagedoorn",
          "Hagedorn",
          "Hagelaar",
          "Hagelaars",
          "Hagels",
          "Hagelstein",
          "Hageman",
          "Hagemans",
          "Hagemeijer",
          "Hagen",
          "Hagenaar",
          "Hagenaars",
          "Hagenauw",
          "Hagenbeek",
          "Hagendijk",
          "Hagendoorn",
          "Hagenouw",
          "Hagens",
          "Hagenstein",
          "Hager",
          "Hageraats",
          "Hagers",
          "Hagestein",
          "Hagg",
          "Haggenburg",
          "Hagman",
          "Hagoort",
          "Hagreis",
          "Hagting",
          "Hahn",
          "Hahnraths",
          "Haidari",
          "Haije",
          "Haijes",
          "Haijma",
          "Haijtink",
          "Haile",
          "Haimé",
          "Haisma",
          "Haitjema",
          "Haitsma",
          "Haji",
          "Hajjari",
          "Hajji",
          "Hajoui",
          "Hak",
          "Hake",
          "Haken",
          "Haket",
          "Hakimi",
          "Hakkaart",
          "Hakkenberg",
          "Hakkenbroek",
          "Hakkens",
          "Hakker",
          "Hakkers",
          "Hakkert",
          "Hakkesteegt",
          "Haklander",
          "Haksteen",
          "Hakstege",
          "Hakvoort",
          "Hakze",
          "Hal",
          "Halbersma",
          "Halberstadt",
          "Halbertsma",
          "Halbesma",
          "Halder",
          "Halderen",
          "Halderman",
          "Halem",
          "Halen",
          "Halewijn",
          "Halfhide",
          "Halfman",
          "Halfwerk",
          "Hali",
          "Halici",
          "Halilović",
          "Halkes",
          "Hall",
          "Hallatu",
          "Halle",
          "Hallema",
          "Haller",
          "Hallie",
          "Hallink",
          "Halm",
          "Halma",
          "Halman",
          "Halmans",
          "Halmingh",
          "Halsema",
          "Halteren",
          "Halters",
          "Ham",
          "Hamacher",
          "Hamaker",
          "Hamakers",
          "Hamann",
          "Hamans",
          "Hamar de la Brethonière",
          "Hamberg",
          "Hamburg",
          "Hamburger",
          "Hamdan",
          "Hamdaoui",
          "Hamdi",
          "Hameeteman",
          "Hameetman",
          "Hamel",
          "Hameleers",
          "Hamelers",
          "Hamelijnck",
          "Hamelink",
          "Hamels",
          "Hamer",
          "Hameren",
          "Hamerlinck",
          "Hamerling",
          "Hamers",
          "Hamerslag",
          "Hamersma",
          "Hamersveld",
          "Hamhuis",
          "Hamid",
          "Hamidi",
          "Hamilton",
          "Hammen",
          "Hammer",
          "Hammers",
          "Hamming",
          "Hamminga",
          "Hammink",
          "Hammouchi",
          "Hammouti",
          "Hamoen",
          "Hamond",
          "Hamont",
          "Hampsink",
          "Hams",
          "Hamstra",
          "Han",
          "Hand",
          "Handels",
          "Handgraaf",
          "Hanegraaf",
          "Hanekamp",
          "Hanemaaijer",
          "Hanenberg",
          "Hanenburg",
          "Haneveer",
          "Haneveld",
          "Hanff",
          "Hanhart",
          "Hani",
          "Hania",
          "Hankel",
          "Hanna",
          "Hannema",
          "Hanneman",
          "Hannen",
          "Hannessen",
          "Hannewijk",
          "Hanning",
          "Hannink",
          "Hanoeman",
          "Hanraets",
          "Hans",
          "Hanse",
          "Hanselaar",
          "Hanselman",
          "Hansen",
          "Hanskamp",
          "Hansler",
          "Hansma",
          "Hansman",
          "Hanson",
          "Hanssen",
          "Hanssens",
          "Hanstede",
          "Hansum",
          "Hanswijk",
          "Hanzen",
          "Haouli",
          "Haperen",
          "Happel",
          "Happen",
          "Happé",
          "Harberink",
          "Harbers",
          "Harberts",
          "Hardam",
          "Hardeman",
          "Hardenberg",
          "Hardenbol",
          "Harder",
          "Harders",
          "Harderwijk",
          "Hardeveld",
          "Hardij",
          "Hardin",
          "Harding",
          "Hardoar",
          "Hardon",
          "Hardonk",
          "Hardorff",
          "Hardy",
          "Haren",
          "Harg",
          "Harinck",
          "Haring",
          "Haringa",
          "Haringsma",
          "Harink",
          "Hark",
          "Harke",
          "Harkel",
          "Harkema",
          "Harkes",
          "Harkhoe",
          "Harkink",
          "Harks",
          "Harlaar",
          "Harland",
          "Harleman",
          "Harlingen",
          "Harman",
          "Harmans",
          "Harmelen",
          "Harmeling",
          "Harmelink",
          "Harmens",
          "Harmes",
          "Harms",
          "Harmse",
          "Harmsel",
          "Harmsen",
          "Harmsma",
          "Harn",
          "Harnam",
          "Harpal",
          "Harpe",
          "Harperink",
          "Harreman",
          "Harren",
          "Harrevelt",
          "Harrewijn",
          "Harris",
          "Harrison",
          "Harselaar",
          "Harsevoort",
          "Harskamp",
          "Harst",
          "Harsveld",
          "Hart",
          "Harte",
          "Harteman",
          "Hartemink",
          "Harten",
          "Hartenberg",
          "Hartendorp",
          "Hartensveld",
          "Harteveld",
          "Hartevelt",
          "Hartgerink",
          "Hartgers",
          "Hartgring",
          "Hartholt",
          "Harthoorn",
          "Hartigh",
          "Harting",
          "Hartings",
          "Hartingsveldt",
          "Hartjes",
          "Hartkamp",
          "Hartkoorn",
          "Hartland",
          "Hartlief",
          "Hartman",
          "Hartmann",
          "Hartmans",
          "Hartog",
          "Hartogh",
          "Hartogs",
          "Hartogsveld",
          "Hartong",
          "Harts",
          "Hartsema",
          "Hartsink",
          "Hartskamp",
          "Hartstra",
          "Hartsuijker",
          "Hartsuiker",
          "Hartveld",
          "Hartwig",
          "Harwig",
          "Has",
          "Hasan",
          "Haselager",
          "Hashemi",
          "Hasnaoui",
          "Haspel",
          "Haspels",
          "Hasper",
          "Hasperhoven",
          "Hassan",
          "Hassani",
          "Hassankhan",
          "Hassel",
          "Hasselaar",
          "Hasselbach",
          "Hasselbaink",
          "Hassell",
          "Hasselman",
          "Hasselo",
          "Hasselt",
          "Hassing",
          "Hassink",
          "Hassnaoui",
          "Hastenberg",
          "Haster",
          "Hater",
          "Haterd",
          "Hatert",
          "Hattem",
          "Hattink",
          "Hattu",
          "Hattum",
          "Hatzmann",
          "Hau",
          "Hauer",
          "Hauptmeijer",
          "Haurissa",
          "Hauser",
          "Hautvast",
          "Hauwert",
          "Have",
          "Havekes",
          "Havelaar",
          "Haveman",
          "Haven",
          "Havenaar",
          "Havenga",
          "Haver",
          "Haverhals",
          "Haverhoek",
          "Haverkamp",
          "Haverkate",
          "Haverkort",
          "Haverlag",
          "Haverman",
          "Havermans",
          "Havers",
          "Haverslag",
          "Havik",
          "Havinga",
          "Hawinkels",
          "Hayes",
          "Haze",
          "Hazebroek",
          "Hazekamp",
          "Hazel",
          "Hazelaar",
          "Hazeleger",
          "Hazelhof",
          "Hazelhoff",
          "Hazelhorst",
          "Hazelkamp",
          "Hazelzet",
          "Hazen",
          "Hazenberg",
          "Hazenbosch",
          "Hazenbroek",
          "Hazendonk",
          "Hazenoot",
          "Hazes",
          "Hazeu",
          "Hazeveld",
          "Hazewindus",
          "Hazewinkel",
          "He",
          "Hebben",
          "Hebbink",
          "Hebels",
          "Hebing",
          "Heblij",
          "Heck",
          "Hecke",
          "Hecker",
          "Heckers",
          "Heckman",
          "Hector",
          "Hectors",
          "Hedde",
          "Heddema",
          "Heddes",
          "Hedel",
          "Hee",
          "Heebing",
          "Heebink",
          "Heefer",
          "Heeffer",
          "Heeg",
          "Heegde",
          "Heege",
          "Heeger",
          "Heek",
          "Heel",
          "Heeling",
          "Heeman",
          "Heemels",
          "Heems",
          "Heemsbergen",
          "Heemskerk",
          "Heemst",
          "Heemstra",
          "Heeneman",
          "Heer",
          "Heerbeek",
          "Heerde",
          "Heerden",
          "Heerdink",
          "Heerdt",
          "Heere",
          "Heerebeek",
          "Heerema",
          "Heeremans",
          "Heeren",
          "Heerens",
          "Heeres",
          "Heerik",
          "Heerikhuize",
          "Heering",
          "Heeringa",
          "Heeringen",
          "Heerings",
          "Heerink",
          "Heerkens",
          "Heerlien",
          "Heeroma",
          "Heerschap",
          "Heerschop",
          "Heersema",
          "Heersink",
          "Heerspink",
          "Heertum",
          "Heerwaarden",
          "Hees",
          "Heesakkers",
          "Heesbeen",
          "Heesch",
          "Heese",
          "Heesen",
          "Heesewijk",
          "Heesmans",
          "Heessels",
          "Heest",
          "Heesterbeek",
          "Heesterman",
          "Heestermans",
          "Heesters",
          "Heeswijk",
          "Heetebrij",
          "Heeten",
          "Heethuis",
          "Heetkamp",
          "Heezen",
          "Heezik",
          "Heffels",
          "Hegeman",
          "Hegen",
          "Heger",
          "Hegge",
          "Heggeler",
          "Hegger",
          "Hehenkamp",
          "Heida",
          "Heidbuurt",
          "Heide",
          "Heidekamp",
          "Heidema",
          "Heideman",
          "Heiden",
          "Heideveld",
          "Heidinga",
          "Heidotting",
          "Heidstra",
          "Heij",
          "Heijblom",
          "Heijboer",
          "Heijde",
          "Heijdeman",
          "Heijdemann",
          "Heijden",
          "Heijdenrijk",
          "Heijdens",
          "Heijdra",
          "Heijdt",
          "Heije",
          "Heijen",
          "Heijenk",
          "Heijenrath",
          "Heijens",
          "Heijer",
          "Heijerman",
          "Heijes",
          "Heijink",
          "Heijkamp",
          "Heijkant",
          "Heijkers",
          "Heijkoop",
          "Heijl",
          "Heijligers",
          "Heijltjes",
          "Heijman",
          "Heijmann",
          "Heijmans",
          "Heijmen",
          "Heijmerink",
          "Heijmink",
          "Heijn",
          "Heijndijk",
          "Heijne",
          "Heijnekamp",
          "Heijneman",
          "Heijnemans",
          "Heijnen",
          "Heijnens",
          "Heijningen",
          "Heijnis",
          "Heijns",
          "Heijnsbergen",
          "Heijnsdijk",
          "Heijs",
          "Heijst",
          "Heijstee",
          "Heijsteeg",
          "Heijstek",
          "Heijster",
          "Heijt",
          "Heijting",
          "Heikamp",
          "Heikens",
          "Heikoop",
          "Heil",
          "Heilbron",
          "Heilig",
          "Heiligenberg",
          "Heiligers",
          "Heimans",
          "Heimensen",
          "Heimeriks",
          "Heimgartner",
          "Hein",
          "Heine",
          "Heineman",
          "Heinemans",
          "Heinen",
          "Heinhuis",
          "Heiningen",
          "Heinink",
          "Heinis",
          "Heino",
          "Heinrich",
          "Heinrichs",
          "Heins",
          "Heinsbroek",
          "Heinsius",
          "Heinsman",
          "Heinst",
          "Heintjes",
          "Heintz",
          "Heinz",
          "Heinze",
          "Heistek",
          "Heister",
          "Heisterkamp",
          "Heitbrink",
          "Heite",
          "Heitink",
          "Heitkamp",
          "Heitlager",
          "Heiwegen",
          "Hek",
          "Hekelaar",
          "Hekhuis",
          "Hekkelman",
          "Hekkema",
          "Hekken",
          "Hekkenberg",
          "Hekkens",
          "Hekker",
          "Hekkers",
          "Hekkert",
          "Hekking",
          "Hekman",
          "Hekstra",
          "Hel",
          "Helbers",
          "Helbig",
          "Held",
          "Helden",
          "Heldens",
          "Helder",
          "Helderman",
          "Helderop",
          "Helders",
          "Heldoorn",
          "Helfferich",
          "Helfrich",
          "Helgers",
          "Heling",
          "Hell",
          "Helle",
          "Hellebrekers",
          "Hellegers",
          "Hellema",
          "Helleman",
          "Hellemond",
          "Hellemons",
          "Hellenbrand",
          "Hellendoorn",
          "Hellenthal",
          "Heller",
          "Helling",
          "Hellinga",
          "Hellingman",
          "Hellings",
          "Helm",
          "Helmantel",
          "Helmer",
          "Helmerhorst",
          "Helmers",
          "Helmes",
          "Helmholt",
          "Helmhout",
          "Helmich",
          "Helmig",
          "Helming",
          "Helmink",
          "Helmond",
          "Helmons",
          "Helmont",
          "Helms",
          "Helmstrijd",
          "Helmus",
          "Helsdingen",
          "Helsen",
          "Helsloot",
          "Helsper",
          "Helstone",
          "Helten",
          "Helthuis",
          "Heltzel",
          "Helvert",
          "Helvoirt",
          "Helvoort",
          "Helweg",
          "Helwegen",
          "Helwig",
          "Hem",
          "Hemel",
          "Hemelaar",
          "Hemelrijk",
          "Hemels",
          "Hemeltjen",
          "Hemerik",
          "Hemert",
          "Heming",
          "Hemink",
          "Hemme",
          "Hemmelder",
          "Hemmen",
          "Hemmer",
          "Hemmers",
          "Hemmes",
          "Hemminga",
          "Hemmink",
          "Hempel",
          "Hempen",
          "Hempenius",
          "Hems",
          "Hemstede",
          "Hemstra",
          "Henckens",
          "Henderickx",
          "Henderiks",
          "Henderikx",
          "Henderson",
          "Hendrick",
          "Hendricks",
          "Hendricksen",
          "Hendrickx",
          "Hendriks",
          "Hendrikse",
          "Hendriksen",
          "Hendriksma",
          "Hendrikx",
          "Hendrix",
          "Hengel",
          "Hengelman",
          "Hengeveld",
          "Hengst",
          "Hengstman",
          "Hengstmengel",
          "Hengstum",
          "Henke",
          "Henkelman",
          "Henken",
          "Henkens",
          "Henkes",
          "Hennekam",
          "Henneke",
          "Hennekens",
          "Hennekes",
          "Henneman",
          "Hennen",
          "Hennepe",
          "Hennequin",
          "Henneveld",
          "Hennevelt",
          "Hennik",
          "Henning",
          "Hennink",
          "Hennipman",
          "Hennissen",
          "Henny",
          "Henraat",
          "Henraath",
          "Henriques",
          "Henriquez",
          "Henry",
          "Hens",
          "Hensbergen",
          "Hense",
          "Henselmans",
          "Hensels",
          "Hensema",
          "Hensen",
          "Hensens",
          "Hensgens",
          "Hensing",
          "Henskens",
          "Henssen",
          "Henst",
          "Henstra",
          "Henten",
          "Hentenaar",
          "Henze",
          "Henzen",
          "Hepkema",
          "Heppe",
          "Heppener",
          "Herben",
          "Herber",
          "Herbers",
          "Herbert",
          "Herbrink",
          "Herckenrath",
          "Herder",
          "Hereijgers",
          "Herel",
          "Heres",
          "Herfkens",
          "Herfst",
          "Herijgers",
          "Herik",
          "Hering",
          "Heringa",
          "Herk",
          "Herlaar",
          "Herman",
          "Hermanides",
          "Hermann",
          "Hermanns",
          "Hermans",
          "Hermanussen",
          "Hermeling",
          "Hermelink",
          "Hermens",
          "Hermes",
          "Hermkens",
          "Herms",
          "Hermse",
          "Hermsen",
          "Hermus",
          "Hernandez",
          "Herp",
          "Herpen",
          "Herpers",
          "Herps",
          "Herpt",
          "Herrebout",
          "Herrebrugh",
          "Herrema",
          "Herremans",
          "Herrewijn",
          "Herrewijnen",
          "Herrijgers",
          "Herrmann",
          "Hersbach",
          "Hersevoort",
          "Herst",
          "Hert",
          "Herten",
          "Hertgers",
          "Hertog",
          "Hertogh",
          "Hertogs",
          "Hertsenberg",
          "Heruer",
          "Herwaarde",
          "Herwaarden",
          "Herwegh",
          "Herweijer",
          "Herwerden",
          "Herwig",
          "Herwijnen",
          "Hes",
          "Hese",
          "Hesemans",
          "Hesen",
          "Heshof",
          "Heshusius",
          "Heskamp",
          "Heskes",
          "Heslenfeld",
          "Heslinga",
          "Hesp",
          "Hess",
          "Hesse",
          "Hessel",
          "Hesselberth",
          "Hesseling",
          "Hesselink",
          "Hesselman",
          "Hesselmans",
          "Hessels",
          "Hessing",
          "Hest",
          "Hester",
          "Hesteren",
          "Hesterman",
          "Hetebrij",
          "Hetem",
          "Heteren",
          "Hetharia",
          "Hettema",
          "Hetterscheid",
          "Hettinga",
          "Heuer",
          "Heuff",
          "Heuft",
          "Heugen",
          "Heugten",
          "Heuijerjans",
          "Heukelom",
          "Heukels",
          "Heukelum",
          "Heuker",
          "Heuker of Hoek",
          "Heukers",
          "Heul",
          "Heule",
          "Heulen",
          "Heumen",
          "Heun",
          "Heunen",
          "Heuperman",
          "Heupers",
          "Heupink",
          "Heur",
          "Heurik",
          "Heurkens",
          "Heurman",
          "Heurter",
          "Heus",
          "Heusden",
          "Heusdens",
          "Heuser",
          "Heuseveldt",
          "Heusinkveld",
          "Heusschen",
          "Heussen",
          "Heuten",
          "Heutinck",
          "Heutink",
          "Heutmekers",
          "Heuts",
          "Heutz",
          "Heuvel",
          "Heuvelen",
          "Heuveling",
          "Heuvelink",
          "Heuvelman",
          "Heuvelmans",
          "Heuveln",
          "Heuvels",
          "Heuven",
          "Heuven van Staereling",
          "Heuver",
          "Heuverling",
          "Heuving",
          "Heuvink",
          "Heuzen",
          "Hexspoor",
          "Heyden",
          "Heymans",
          "Heynen",
          "Heyningen",
          "Hezel",
          "Hezemans",
          "Hezik",
          "Hibma",
          "Hiddema",
          "Hiddes",
          "Hidding",
          "Hiddinga",
          "Hiddingh",
          "Hiddink",
          "Hiel",
          "Hielema",
          "Hielkema",
          "Hieltjes",
          "Hiemstra",
          "Hien",
          "Hienen",
          "Hiensch",
          "Hiep",
          "Hierck",
          "Hierden",
          "Hietbrink",
          "Hietkamp",
          "Hijden",
          "Hijdra",
          "Hijink",
          "Hijkoop",
          "Hijlkema",
          "Hijma",
          "Hijman",
          "Hijmans",
          "Hijmering",
          "Hijne",
          "Hijnekamp",
          "Hijnen",
          "Hijstek",
          "Hijum",
          "Hijwegen",
          "Hijzelendoorn",
          "Hikspoors",
          "Hil",
          "Hilarius",
          "Hilberdink",
          "Hilberink",
          "Hilbers",
          "Hilberts",
          "Hilbink",
          "Hilbolling",
          "Hilbrands",
          "Hilbrink",
          "Hildebrand",
          "Hildering",
          "Hilderink",
          "Hilders",
          "Hilferink",
          "Hilgeman",
          "Hilgen",
          "Hilgenga",
          "Hilgenkamp",
          "Hilgerink",
          "Hilgers",
          "Hilgersom",
          "Hilhorst",
          "Hilkens",
          "Hilkhuijsen",
          "Hill",
          "Hille",
          "Hillebrand",
          "Hillebrandt",
          "Hillebrink",
          "Hillegers",
          "Hillen",
          "Hillenaar",
          "Hillenga",
          "Hilligehekken",
          "Hillo",
          "Hilst",
          "Hilster",
          "Hilt",
          "Hilten",
          "Hilverda",
          "Hilverink",
          "Hilverts",
          "Himst",
          "Hin",
          "Hinderiks",
          "Hinderks",
          "Hindriks",
          "Hindriksen",
          "Hinfelaar",
          "Hingstman",
          "Hink",
          "Hinke",
          "Hinnen",
          "Hinrichs",
          "Hinskens",
          "Hinssen",
          "Hinte",
          "Hinten",
          "Hintum",
          "Hintzen",
          "Hinzen",
          "Hira",
          "Hiralal",
          "Hirdes",
          "Hirs",
          "Hirsch",
          "Hirschfeld",
          "Hirtum",
          "Hissink",
          "Hitipeuw",
          "Hitz",
          "Hitzert",
          "Hiwat",
          "Ho",
          "Hoang",
          "Hobbel",
          "Hobbelen",
          "Hobbelink",
          "Hobelman",
          "Hobers",
          "Hobert",
          "Hobma",
          "Hobo",
          "Hobus",
          "Hobé",
          "Hochstenbach",
          "Hock",
          "Hocks",
          "Hockx",
          "Hodde",
          "Hodes",
          "Hodge",
          "Hodiamont",
          "Hodzelmans",
          "Hodžić",
          "Hoebe",
          "Hoebee",
          "Hoebeke",
          "Hoeben",
          "Hoebergen",
          "Hoeberichts",
          "Hoebers",
          "Hoebink",
          "Hoeboer",
          "Hoeckel",
          "Hoed",
          "Hoedemaker",
          "Hoedemakers",
          "Hoedeman",
          "Hoedjes",
          "Hoedt",
          "Hoef",
          "Hoefakker",
          "Hoeff",
          "Hoeflaak",
          "Hoeflaken",
          "Hoefman",
          "Hoefnagel",
          "Hoefnagels",
          "Hoefs",
          "Hoefsloot",
          "Hoefsmit",
          "Hoegee",
          "Hoegen",
          "Hoeij",
          "Hoeijen",
          "Hoeijmakers",
          "Hoeijmans",
          "Hoek",
          "Hoeke",
          "Hoekema",
          "Hoekerd",
          "Hoekert",
          "Hoekman",
          "Hoekmeijer",
          "Hoeks",
          "Hoeksema",
          "Hoeksma",
          "Hoekstra",
          "Hoekwater",
          "Hoekzema",
          "Hoen",
          "Hoencamp",
          "Hoenderboom",
          "Hoenderdaal",
          "Hoenderdos",
          "Hoenderkamp",
          "Hoenderop",
          "Hoenders",
          "Hoendervangers",
          "Hoenen",
          "Hoeneveld",
          "Hoenink",
          "Hoenjet",
          "Hoens",
          "Hoenselaar",
          "Hoentjen",
          "Hoep",
          "Hoepel",
          "Hoepen",
          "Hoes",
          "Hoesel",
          "Hoesen",
          "Hoeseni",
          "Hoesenie",
          "Hoetink",
          "Hoetjes",
          "Hoetmer",
          "Hoeve",
          "Hoeven",
          "Hoevenaar",
          "Hoevenaars",
          "Hoevenberg",
          "Hoevers",
          "Hoewijk",
          "Hoex",
          "Hoexum",
          "Hoezen",
          "Hof",
          "Hofenk",
          "Hoff",
          "Hoffer",
          "Hoffland",
          "Hoffman",
          "Hoffmann",
          "Hoffmans",
          "Hofhuis",
          "Hofkamp",
          "Hofkens",
          "Hofker",
          "Hofland",
          "Hofma",
          "Hofman",
          "Hofmann",
          "Hofmans",
          "Hofmeester",
          "Hofmeijer",
          "Hofs",
          "Hofsink",
          "Hofste",
          "Hofstede",
          "Hofstee",
          "Hofsteenge",
          "Hofstra",
          "Hoft",
          "Hofte",
          "Hoften",
          "Hoftijzer",
          "Hofwegen",
          "Hofwijks",
          "Hoge",
          "Hogeboom",
          "Hogeling",
          "Hogeman",
          "Hogen",
          "Hogenberg",
          "Hogenbirk",
          "Hogenboom",
          "Hogendoorn",
          "Hogendorf",
          "Hogendorp",
          "Hogenelst",
          "Hogenes",
          "Hogenhout",
          "Hogenhuis",
          "Hogenkamp",
          "Hogerheijde",
          "Hogerhuis",
          "Hogers",
          "Hogervorst",
          "Hogerwerf",
          "Hogeslag",
          "Hogeterp",
          "Hogetoorn",
          "Hogeveen",
          "Hogeweg",
          "Hogewoning",
          "Hoijtink",
          "Hoiting",
          "Hoitinga",
          "Hoitink",
          "Hokke",
          "Hokken",
          "Hoks",
          "Hoksbergen",
          "Hokse",
          "Hol",
          "Holder",
          "Holdijk",
          "Holdinga",
          "Holdorp",
          "Holewijn",
          "Holierhoek",
          "Holkamp",
          "Holkema",
          "Holkenborg",
          "Holl",
          "Holla",
          "Hollaar",
          "Hollak",
          "Holland",
          "Hollander",
          "Hollanders",
          "Hollands",
          "Holle",
          "Hollebeek",
          "Holleboom",
          "Hollebrandse",
          "Hollegien",
          "Hollema",
          "Holleman",
          "Hollemans",
          "Hollenberg",
          "Hollestelle",
          "Hollink",
          "Hollmann",
          "Holm",
          "Holman",
          "Holmer",
          "Hols",
          "Holsappel",
          "Holscher",
          "Holshuijsen",
          "Holslag",
          "Holst",
          "Holstege",
          "Holsteijn",
          "Holstein",
          "Holster",
          "Holswilder",
          "Holt",
          "Holtackers",
          "Holten",
          "Holterman",
          "Holtermans",
          "Holthaus",
          "Holthausen",
          "Holthof",
          "Holthuijsen",
          "Holthuis",
          "Holthuizen",
          "Holties",
          "Holtjer",
          "Holtkamp",
          "Holtkuile",
          "Holtland",
          "Holtmaat",
          "Holtman",
          "Holtrop",
          "Holtrust",
          "Holtslag",
          "Holtus",
          "Holtz",
          "Holtzer",
          "Holvast",
          "Holverda",
          "Holweg",
          "Holwerda",
          "Holzken",
          "Hom",
          "Homan",
          "Homans",
          "Hombergen",
          "Hombergh",
          "Homburg",
          "Homma",
          "Hommel",
          "Hommeles",
          "Hommels",
          "Hommen",
          "Hommersom",
          "Hommerson",
          "Hommes",
          "Homminga",
          "Hompes",
          "Homs",
          "Hon",
          "Honcoop",
          "Hond",
          "Hondebrink",
          "Hondel",
          "Hondelink",
          "Hondema",
          "Honders",
          "Hondeveld",
          "Hondius",
          "Hondt",
          "Hong",
          "Honhoff",
          "Honig",
          "Honing",
          "Honingh",
          "Honings",
          "Honk",
          "Honkoop",
          "Honsbeek",
          "Honschoten",
          "Honselaar",
          "Honée",
          "Hoof",
          "Hoofd",
          "Hooff",
          "Hoofs",
          "Hooft",
          "Hooftman",
          "Hoofwijk",
          "Hoog",
          "Hoog Antink",
          "Hoogakker",
          "Hoogdalem",
          "Hoogdorp",
          "Hoogduijn",
          "Hoogduin",
          "Hooge",
          "Hoogeboom",
          "Hoogeland",
          "Hoogelander",
          "Hoogen",
          "Hoogenband",
          "Hoogenberg",
          "Hoogenboezem",
          "Hoogenboom",
          "Hoogenbosch",
          "Hoogendam",
          "Hoogendijk",
          "Hoogendonk",
          "Hoogendoorn",
          "Hoogendorp",
          "Hoogenes",
          "Hoogenhout",
          "Hoogenkamp",
          "Hoogenraad",
          "Hoogerbrug",
          "Hoogerbrugge",
          "Hoogerdijk",
          "Hoogerheide",
          "Hoogerhuis",
          "Hoogerland",
          "Hoogers",
          "Hoogervorst",
          "Hoogerwaard",
          "Hoogerwerf",
          "Hoogeslag",
          "Hoogesteger",
          "Hoogeveen",
          "Hoogewerf",
          "Hoogh",
          "Hooghiem",
          "Hooghiemstra",
          "Hooghuis",
          "Hoogkamer",
          "Hoogkamp",
          "Hoogland",
          "Hooglander",
          "Hooglugt",
          "Hoogma",
          "Hoogmoed",
          "Hoogschagen",
          "Hoogstad",
          "Hoogstede",
          "Hoogsteder",
          "Hoogsteen",
          "Hoogstra",
          "Hoogstraate",
          "Hoogstraaten",
          "Hoogstrate",
          "Hoogstraten",
          "Hoogt",
          "Hoogteijling",
          "Hoogterp",
          "Hoogveld",
          "Hoogvliet",
          "Hoogvliets",
          "Hoogvorst",
          "Hoogwerf",
          "Hoogzaad",
          "Hooi",
          "Hooidonk",
          "Hooij",
          "Hooijberg",
          "Hooijdonk",
          "Hooijen",
          "Hooijenga",
          "Hooijer",
          "Hooijkaas",
          "Hooijmaijers",
          "Hooijman",
          "Hooijmans",
          "Hooijmeijer",
          "Hooijschuur",
          "Hooijsma",
          "Hooikammer",
          "Hooimeijer",
          "Hooisma",
          "Hooiveld",
          "Hoolsema",
          "Hoolwerf",
          "Hoolwerff",
          "Hoomans",
          "Hoomoedt",
          "Hoon",
          "Hoonaard",
          "Hoonakker",
          "Hoondert",
          "Hoonhorst",
          "Hoonhout",
          "Hooning",
          "Hoop",
          "Hoope",
          "Hoopen",
          "Hooplot",
          "Hoopman",
          "Hoor",
          "Hooren",
          "Hoorn",
          "Hoorne",
          "Hoornenborg",
          "Hoornstra",
          "Hoornweg",
          "Hoorweg",
          "Hoos",
          "Hoosemans",
          "Hootsen",
          "Hoove",
          "Hooven",
          "Hooydonk",
          "Hoozemans",
          "Hop",
          "Hopma",
          "Hopman",
          "Hopmans",
          "Hoppe",
          "Hoppen",
          "Hoppenbrouwer",
          "Hoppenbrouwers",
          "Hoppener",
          "Hoppenreijs",
          "Hopstaken",
          "Hopster",
          "Hor",
          "Horbach",
          "Horck",
          "Horde",
          "Horden",
          "Hordijk",
          "Horeman",
          "Horen",
          "Horenberg",
          "Horijon",
          "Horik",
          "Horjus",
          "Horlings",
          "Hormes",
          "Horn",
          "Horne",
          "Horneman",
          "Hornman",
          "Hornstra",
          "Hornsveld",
          "Horrik",
          "Horsch",
          "Horseling",
          "Horsen",
          "Horsman",
          "Horsmans",
          "Horssen",
          "Horst",
          "Horsten",
          "Horsthuis",
          "Horsting",
          "Horstink",
          "Horstman",
          "Hortensius",
          "Horvers",
          "Horváth",
          "Hos",
          "Hoskam",
          "Hoskens",
          "Hosman",
          "Hosper",
          "Hospers",
          "Hospes",
          "Hosseini",
          "Hoste",
          "Hottentot",
          "Hotting",
          "Hottinga",
          "Houba",
          "Houben",
          "Houbraken",
          "Houdijk",
          "Houdijker",
          "Houdt",
          "Houkes",
          "Houmes",
          "Houniet",
          "Houselt",
          "Housen",
          "Hout",
          "Houtappels",
          "Houte",
          "Houtekamer",
          "Houtem",
          "Houten",
          "Houtenbos",
          "Houtepen",
          "Houter",
          "Houterman",
          "Houtert",
          "Houthuijzen",
          "Houting",
          "Houtkamp",
          "Houtkoop",
          "Houtkooper",
          "Houtman",
          "Houtriet",
          "Houts",
          "Houtsma",
          "Houtstra",
          "Houttuin",
          "Houtum",
          "Houtvast",
          "Houtveen",
          "Houtzager",
          "Houwaard",
          "Houwaart",
          "Houweling",
          "Houwelingen",
          "Houwen",
          "Houwer",
          "Houwers",
          "Houwing",
          "Houwink",
          "Hove",
          "Hoveling",
          "Hoven",
          "Hovenga",
          "Hovenier",
          "Hovenkamp",
          "Hovens",
          "Hover",
          "Hovers",
          "Hovestad",
          "Hovestadt",
          "Hoving",
          "Hovinga",
          "Hovingh",
          "Hovius",
          "Hoyer",
          "Hsu",
          "Hu",
          "Huang",
          "Hubbers",
          "Hubeek",
          "Hubens",
          "Huber",
          "Hubers",
          "Hubert",
          "Huberts",
          "Hubregtse",
          "Hudding",
          "Hudepohl",
          "Huegen",
          "Huenestein",
          "Huesken",
          "Huet",
          "Hueting",
          "Huetink",
          "Huf",
          "Huffel",
          "Huffelen",
          "Huft",
          "Hugen",
          "Hugens",
          "Huggers",
          "Hughes",
          "Hugten",
          "Huibers",
          "Huiberts",
          "Huibrechtse",
          "Huibregtse",
          "Huiden",
          "Huige",
          "Huigen",
          "Huigenbos",
          "Huigens",
          "Huigsloot",
          "Huijben",
          "Huijbens",
          "Huijbers",
          "Huijberts",
          "Huijboom",
          "Huijbrechts",
          "Huijbregts",
          "Huijer",
          "Huijerjans",
          "Huijg",
          "Huijgen",
          "Huijgens",
          "Huijgevoort",
          "Huijing",
          "Huijink",
          "Huijkelom",
          "Huijnen",
          "Huijps",
          "Huijs",
          "Huijsen",
          "Huijser",
          "Huijsing",
          "Huijskens",
          "Huijskes",
          "Huijsman",
          "Huijsmans",
          "Huijssoon",
          "Huijstee",
          "Huijten",
          "Huijts",
          "Huijzer",
          "Huijzers",
          "Huikeshoven",
          "Huinink",
          "Huirne",
          "Huis",
          "Huis in 't Veld",
          "Huiser",
          "Huising",
          "Huisinga",
          "Huisintveld",
          "Huisjes",
          "Huiskamp",
          "Huisken",
          "Huiskens",
          "Huiskes",
          "Huisma",
          "Huisman",
          "Huismans",
          "Huissen",
          "Huissoon",
          "Huisstede",
          "Huissteden",
          "Huistra",
          "Huiszoon",
          "Huitema",
          "Huiting",
          "Huitink",
          "Huits",
          "Huitsing",
          "Huizen",
          "Huizenga",
          "Huizer",
          "Huizing",
          "Huizinga",
          "Huizingh",
          "Hukema",
          "Hul",
          "Huliselan",
          "Hull",
          "Hullegie",
          "Hulleman",
          "Hullenaar",
          "Hullu",
          "Hulman",
          "Huls",
          "Hulsbergen",
          "Hulsbos",
          "Hulsbosch",
          "Hulscher",
          "Hulsebos",
          "Hulsebosch",
          "Hulsegge",
          "Hulsen",
          "Hulsenboom",
          "Hulshof",
          "Hulshoff",
          "Hulshorst",
          "Hulsing",
          "Hulsink",
          "Hulskamp",
          "Hulsker",
          "Hulskers",
          "Hulskes",
          "Hulsman",
          "Hulspas",
          "Hulst",
          "Hulsteijn",
          "Hulstein",
          "Hulswit",
          "Hulten",
          "Hultermans",
          "Hultink",
          "Hulzebos",
          "Hulzebosch",
          "Hulzen",
          "Hulzinga",
          "Hulzink",
          "Humblet",
          "Humme",
          "Hummel",
          "Hummelen",
          "Hummelink",
          "Hund",
          "Hundscheid",
          "Hunen",
          "Hunink",
          "Hunnekens",
          "Hunneman",
          "Hunnik",
          "Huntelerslag",
          "Hunter",
          "Hunting",
          "Huntink",
          "Huntjens",
          "Hup",
          "Hupkens",
          "Hupkes",
          "Huppelschoten",
          "Huppertz",
          "Hurck",
          "Hurenkamp",
          "Hurk",
          "Hurkens",
          "Hurkmans",
          "Hurks",
          "Hurkx",
          "Hus",
          "Husken",
          "Huskens",
          "Husmann",
          "Hussaarts",
          "Hussain",
          "Hussainali",
          "Hussein",
          "Hussen",
          "Husslage",
          "Husson",
          "Hustinx",
          "Hut",
          "Huting",
          "Hutjens",
          "Hutjes",
          "Hutten",
          "Hutter",
          "Hutting",
          "Huttinga",
          "Hutzezon",
          "Huuksloot",
          "Huurdeman",
          "Huurman",
          "Huurne",
          "Huurneman",
          "Huurnink",
          "Huuskes",
          "Huussen",
          "Huvenaars",
          "Huveneers",
          "Huver",
          "Huwae",
          "Huwaë",
          "Huynen",
          "Huynh",
          "Huysmans",
          "Huzen",
          "Hylkema",
          "Hölscher",
          "Hölzken",
          "Höppener",
          "Hörchner",
          "Hübner",
          "Hülters",
          "Ibiş",
          "Ibrahim",
          "Ibrahimi",
          "Icke",
          "Ickenroth",
          "Idema",
          "Idenburg",
          "Iding",
          "Idoe",
          "Idrissi",
          "Idsardi",
          "Idsinga",
          "Idzenga",
          "Idzerda",
          "Idzes",
          "Idzinga",
          "Iedema",
          "Ieperen",
          "Ierland",
          "Iersel",
          "Ierssel",
          "Iest",
          "Ignacia",
          "Ignacio",
          "Ignatius",
          "IJbema",
          "IJben",
          "IJdema",
          "IJdo",
          "IJff",
          "IJkelenstam",
          "IJkema",
          "IJken",
          "IJkhout",
          "IJland",
          "IJlstra",
          "IJmker",
          "IJntema",
          "IJpeij",
          "IJpelaar",
          "IJperen",
          "IJpma",
          "IJsbrandij",
          "IJspeerd",
          "IJspeert",
          "IJssel",
          "IJsseldijk",
          "IJsselmuiden",
          "IJsselsteijn",
          "IJsselstein",
          "IJsselstijn",
          "IJsveld",
          "IJtsma",
          "IJzelenberg",
          "IJzendoorn",
          "IJzer",
          "IJzereef",
          "IJzerman",
          "IJzermans",
          "Ike",
          "Ikelaar",
          "Iking",
          "Ikink",
          "Ilahi",
          "Ilahibaks",
          "Ilbay",
          "Ilbrink",
          "Ilhan",
          "Iliohan",
          "Ilić",
          "Ilmer",
          "Imamdi",
          "Imanse",
          "Imanuel",
          "Imhof",
          "Immens",
          "Immers",
          "Immerseel",
          "Immerzeel",
          "Imming",
          "Imminga",
          "Immink",
          "Imminkhuizen",
          "Impelen",
          "Imthorn",
          "Inan",
          "Ince",
          "Inci",
          "Ineveld",
          "Ing",
          "Inge",
          "Ingelse",
          "Ingen",
          "Ingen Schenau",
          "Inghels",
          "Inia",
          "Innemee",
          "Inpijn",
          "Intven",
          "Ip",
          "Ipek",
          "Ipema",
          "Ipenburg",
          "Iperen",
          "Ippel",
          "Ipskamp",
          "Iqbal",
          "Iren",
          "Irik",
          "Iriks",
          "Irmak",
          "Isaak",
          "Isabella",
          "Isbouts",
          "Iseger",
          "Isenia",
          "Ishaak",
          "Ishak",
          "Isidora",
          "Isik",
          "Ismail",
          "Israël",
          "Issa",
          "Ista",
          "Italiaander",
          "Iterson",
          "Ittersum",
          "Ivens",
          "Iwaarden",
          "Iwema",
          "Iz",
          "Izaks",
          "Izeboud",
          "Izelaar",
          "Işik",
          "Jaakke",
          "Jaarsma",
          "Jaarsveld",
          "Jaartsveld",
          "Jaasma",
          "Jabbar",
          "Jackson",
          "Jacob",
          "Jacobi",
          "Jacobs",
          "Jacobse",
          "Jacobsen",
          "Jacobson",
          "Jacobus",
          "Jacott",
          "Jacques",
          "Jaddoe",
          "Jadoenath",
          "Jaeger",
          "Jaegers",
          "Jagai",
          "Jagan",
          "Jagdew",
          "Jager",
          "Jagerman",
          "Jagernath",
          "Jagers",
          "Jagersma",
          "Jagesar",
          "Jagessar",
          "Jaggan",
          "Jaggoe",
          "Jagram",
          "Jagroep",
          "Jagt",
          "Jagtenberg",
          "Jagtman",
          "Jahangier",
          "Jahangir",
          "Jainandunsing",
          "Jairam",
          "Jak",
          "Jakobs",
          "Jakobsen",
          "Jalimsing",
          "Jalink",
          "Jalloh",
          "Jalving",
          "Jalvingh",
          "Jama",
          "Jamal",
          "James",
          "Jamin",
          "Jaminon",
          "Janbroers",
          "Janga",
          "Janissen",
          "Janki",
          "Jankie",
          "Janknegt",
          "Janmaat",
          "Jannes",
          "Jannink",
          "Jans",
          "Janse",
          "Jansema",
          "Jansen",
          "Jansen Holleboom",
          "Jansen of Lorkeers",
          "Jansen op de Haar",
          "Jansen van der Sligte",
          "Jansen van Galen",
          "Jansen van Rosendaal",
          "Jansens",
          "Jansink",
          "Jansma",
          "Jansman",
          "Janson",
          "Jansonius",
          "Janssen",
          "Janssen Steenberg",
          "Janssens",
          "Jansson",
          "Jansz",
          "Janszen",
          "Janus",
          "Janzen",
          "Japenga",
          "Japink",
          "Jaquet",
          "Jarbandhan",
          "Jaring",
          "Jarmohamed",
          "Jas",
          "Jaspar",
          "Jasper",
          "Jaspers",
          "Jaspers Faijer",
          "Jasperse",
          "Jassies",
          "Jawalapersad",
          "Jebbink",
          "Jeeninga",
          "Jegerings",
          "Jehee",
          "Jekel",
          "Jel",
          "Jelier",
          "Jellema",
          "Jelles",
          "Jellesma",
          "Jelsma",
          "Jeltema",
          "Jeltes",
          "Jeninga",
          "Jennekens",
          "Jennen",
          "Jenner",
          "Jenneskens",
          "Jenniskens",
          "Jennissen",
          "Jens",
          "Jense",
          "Jensen",
          "Jensma",
          "Jentink",
          "Jentjens",
          "Jepma",
          "Jeremiasse",
          "Jeroense",
          "Jeronimus",
          "Jerphanion",
          "Jespers",
          "Jesse",
          "Jessen",
          "Jessurun",
          "Jethoe",
          "Jeths",
          "Jetten",
          "Jeu",
          "Jeucken",
          "Jeuken",
          "Jeukens",
          "Jeunink",
          "Jeuring",
          "Jeurink",
          "Jeurissen",
          "Jeurninck",
          "Jeursen",
          "Jeveren",
          "Jhagroe",
          "Jharap",
          "Jhinkoe",
          "Jiang",
          "Jiawan",
          "Jibodh",
          "Jilderda",
          "Jilesen",
          "Jillings",
          "Jimmink",
          "Jin",
          "Jipping",
          "Jiskoot",
          "Jissink",
          "Jitan",
          "Job",
          "Jobse",
          "Jochem",
          "Jochems",
          "Jochemsen",
          "Joerawan",
          "Joha",
          "Johannes",
          "Johansen",
          "John",
          "Johnson",
          "Jokhoe",
          "Jol",
          "Joldersma",
          "Jole",
          "Jolie",
          "Joling",
          "Jolink",
          "Jonas",
          "Jonathans",
          "Jones",
          "Jong",
          "Jongbloed",
          "Jongbloets",
          "Jongboom",
          "Jonge",
          "Jonge Poerink",
          "Jongebloed",
          "Jongebreur",
          "Jongedijk",
          "Jongejan",
          "Jongejans",
          "Jongeleen",
          "Jongeling",
          "Jongema",
          "Jongen",
          "Jongenburger",
          "Jongeneel",
          "Jongeneelen",
          "Jongenelen",
          "Jongenelis",
          "Jongenotter",
          "Jongens",
          "Jongepier",
          "Jongerden",
          "Jongerius",
          "Jongerling",
          "Jongert",
          "Jonges",
          "Jongewaard",
          "Jongh",
          "Jongkind",
          "Jongma",
          "Jongman",
          "Jongmans",
          "Jongschaap",
          "Jongsma",
          "Jongste",
          "Jongstra",
          "Jonk",
          "Jonker",
          "Jonkeren",
          "Jonkergouw",
          "Jonkers",
          "Jonkhart",
          "Jonkheer",
          "Jonkhout",
          "Jonkman",
          "Jonkmans",
          "Joode",
          "Joon",
          "Joor",
          "Joore",
          "Jooren",
          "Joosen",
          "Joosse",
          "Joossen",
          "Joostema",
          "Joosten",
          "Joostens",
          "Joppe",
          "Joppen",
          "Jordaan",
          "Jordan",
          "Jordans",
          "Jordens",
          "Joren",
          "Jorink",
          "Joris",
          "Jorissen",
          "Jorna",
          "Jorritsma",
          "Josemanders",
          "Joseph",
          "Josepha",
          "Josephs",
          "Josten",
          "Jouhri",
          "Jousma",
          "Joustra",
          "Jouvenaar",
          "Jovanović",
          "Jozefzoon",
          "Joziasse",
          "Ju",
          "Jubitana",
          "Juch",
          "Juckers",
          "Juffer",
          "Juffermans",
          "Juijn",
          "Jukema",
          "Juliana",
          "Julicher",
          "Julien",
          "Jullens",
          "Julsing",
          "Jumelet",
          "Jung",
          "Junge",
          "Jungen",
          "Jungerius",
          "Jungschläger",
          "Junier",
          "Junte",
          "Jurg",
          "Jurgens",
          "Jurjens",
          "Jurriaans",
          "Jurriens",
          "Jurrius",
          "Jurriëns",
          "Jussen",
          "Jut",
          "Jutte",
          "Jutten",
          "Juurlink",
          "Jäger",
          "Jägers",
          "Jörissen",
          "Kaa",
          "Kaaden",
          "Kaag",
          "Kaagman",
          "Kaaij",
          "Kaaijk",
          "Kaak",
          "Kaal",
          "Kaam",
          "Kaan",
          "Kaandorp",
          "Kaap",
          "Kaar",
          "Kaars",
          "Kaarsemaker",
          "Kaarsgaren",
          "Kaart",
          "Kaas",
          "Kaashoek",
          "Kaasjager",
          "Kaastra",
          "Kaat",
          "Kaatee",
          "Kaathoven",
          "Kaatman",
          "Kaats",
          "Kaauwen",
          "Kaay",
          "Kabalt",
          "Kabbedijk",
          "Kabel",
          "Kaddouri",
          "Kader",
          "Kadi",
          "Kadijk",
          "Kadir",
          "Kadirbaks",
          "Kaelen",
          "Kaffa",
          "Kafoe",
          "Kagchelland",
          "Kagenaar",
          "Kager",
          "Kagie",
          "Kahraman",
          "Kahveci",
          "Kaijen",
          "Kaijim",
          "Kaijser",
          "Kailola",
          "Kainama",
          "Kaiser",
          "Kaizer",
          "Kakisina",
          "Kal",
          "Kalai",
          "Kalayci",
          "Kalb",
          "Kalden",
          "Kaldenbach",
          "Kaldenberg",
          "Kaldenhoven",
          "Kale",
          "Kalee",
          "Kalf",
          "Kalff",
          "Kalfsbeek",
          "Kali",
          "Kalicharan",
          "Kalidien",
          "Kalika",
          "Kalis",
          "Kalishoek",
          "Kalisvaart",
          "Kaljouw",
          "Kalk",
          "Kalkan",
          "Kalken",
          "Kalkeren",
          "Kalkhoven",
          "Kalkhuis",
          "Kalkman",
          "Kalksma",
          "Kallan",
          "Kalle",
          "Kallen",
          "Kallenbach",
          "Kallenkoot",
          "Kalleveen",
          "Kalloe",
          "Kalma",
          "Kalmeijer",
          "Kalmthout",
          "Kalpoe",
          "Kalsbeek",
          "Kalse",
          "Kalshoven",
          "Kalter",
          "Kalverboer",
          "Kalwij",
          "Kam",
          "Kamal",
          "Kaman",
          "Kamans",
          "Kamara",
          "Kamel",
          "Kamer",
          "Kamerbeek",
          "Kamerling",
          "Kamerman",
          "Kamermans",
          "Kamies",
          "Kamman",
          "Kammeijer",
          "Kammen",
          "Kammenga",
          "Kammeraat",
          "Kammeron",
          "Kamminga",
          "Kamp",
          "Kampe",
          "Kampen",
          "Kamper",
          "Kamperman",
          "Kampers",
          "Kampert",
          "Kamperveen",
          "Kampherbeek",
          "Kamphof",
          "Kamphorst",
          "Kamphues",
          "Kamphuijs",
          "Kamphuis",
          "Kampijon",
          "Kamping",
          "Kampinga",
          "Kampman",
          "Kamps",
          "Kampschreur",
          "Kampstra",
          "Kamsma",
          "Kamst",
          "Kamsteeg",
          "Kamstra",
          "Kamta",
          "Kan",
          "Kanbier",
          "Kandelaars",
          "Kandemir",
          "Kanders",
          "Kandhai",
          "Kandoussi",
          "Kanen",
          "Kanhai",
          "Kanis",
          "Kanne",
          "Kannegieter",
          "Kannekens",
          "Kanning",
          "Kanninga",
          "Kanon",
          "Kanselaar",
          "Kant",
          "Kantelberg",
          "Kanter",
          "Kanters",
          "Kap",
          "Kapaan",
          "Kapel",
          "Kapelle",
          "Kaper",
          "Kapiteijn",
          "Kapitein",
          "Kaplan",
          "Kapoen",
          "Kappe",
          "Kappel",
          "Kappelhof",
          "Kappelle",
          "Kappen",
          "Kapper",
          "Kappers",
          "Kappert",
          "Kappetein",
          "Kappetijn",
          "Kappé",
          "Kapteijn",
          "Kapteijns",
          "Kaptein",
          "Kaptijn",
          "Kar",
          "Kara",
          "Karaaslan",
          "Karabacak",
          "Karabulut",
          "Karaca",
          "Karacan",
          "Karadavut",
          "Karadağ",
          "Karademir",
          "Karadeniz",
          "Karaduman",
          "Karagöz",
          "Karahan",
          "Karakaya",
          "Karakaş",
          "Karakoç",
          "Karakuş",
          "Karaman",
          "Karamat Ali",
          "Karapinar",
          "Karasu",
          "Karatas",
          "Karataş",
          "Karbet",
          "Kardinaal",
          "Kardol",
          "Kardux",
          "Karel",
          "Karels",
          "Karelse",
          "Karemaker",
          "Karens",
          "Karg",
          "Karia",
          "Karim",
          "Kariman",
          "Karimi",
          "Karis",
          "Karkdijk",
          "Karlas",
          "Karman",
          "Karnebeek",
          "Karregat",
          "Karreman",
          "Karremans",
          "Karrenbeld",
          "Kars",
          "Karsdorp",
          "Karsemeijer",
          "Karsmakers",
          "Karssemakers",
          "Karssen",
          "Karssenberg",
          "Karssies",
          "Karssing",
          "Karst",
          "Karsten",
          "Karstenberg",
          "Karstens",
          "Karsters",
          "Kartal",
          "Karten",
          "Karthaus",
          "Kartodikromo",
          "Kartodimedjo",
          "Kartopawiro",
          "Kartoredjo",
          "Kas",
          "Kasbergen",
          "Kasi",
          "Kasius",
          "Kaslander",
          "Kasmi",
          "Kasper",
          "Kaspers",
          "Kasse",
          "Kassels",
          "Kassies",
          "Kassim",
          "Kassing",
          "Kaste",
          "Kasteel",
          "Kasteele",
          "Kastel",
          "Kasteleijn",
          "Kastelein",
          "Kastelijn",
          "Kastelijns",
          "Kasten",
          "Kasteren",
          "Kastermans",
          "Kastrop",
          "Kat",
          "Kate",
          "Kateman",
          "Katen",
          "Kater",
          "Katerberg",
          "Katers",
          "Katgert",
          "Katier",
          "Katoele",
          "Katoen",
          "Kats",
          "Katsma",
          "Katsman",
          "Kattenberg",
          "Kattestaart",
          "Kattevilder",
          "Kattouw",
          "Katuin",
          "Katwijk",
          "Kauffeld",
          "Kauffman",
          "Kauffmann",
          "Kaufman",
          "Kaufmann",
          "Kaur",
          "Kavak",
          "Kavelaars",
          "Kaya",
          "Kayhan",
          "Kaynak",
          "Kazemier",
          "Kazen",
          "Kea",
          "Kedde",
          "Kee",
          "Keegstra",
          "Keehnen",
          "Keeken",
          "Keekstra",
          "Keeman",
          "Keemink",
          "Keen",
          "Keereweer",
          "Keeris",
          "Keers",
          "Keerssemeeckers",
          "Kees",
          "Keesmaat",
          "Keesman",
          "Keesom",
          "Keessen",
          "Keet",
          "Keetels",
          "Keetman",
          "Kegel",
          "Kegels",
          "Kegge",
          "Keij",
          "Keijdener",
          "Keijer",
          "Keijers",
          "Keijl",
          "Keijman",
          "Keijmel",
          "Keijnemans",
          "Keijser",
          "Keijsers",
          "Keijsper",
          "Keijzer",
          "Keijzers",
          "Keim",
          "Keiman",
          "Keimpema",
          "Keinemans",
          "Keiren",
          "Keizer",
          "Keizers",
          "Keja",
          "Kekem",
          "Keken",
          "Kelder",
          "Kelderhuis",
          "Kelderman",
          "Kelders",
          "Keleş",
          "Kelfkens",
          "Kellenaers",
          "Kelleners",
          "Keller",
          "Kellij",
          "Kelly",
          "Keltjens",
          "Kemeling",
          "Kemenade",
          "Kemerink",
          "Kemink",
          "Kemker",
          "Kemkers",
          "Kemkes",
          "Kemme",
          "Kemmeren",
          "Kemmerling",
          "Kemna",
          "Kemner",
          "Kemp",
          "Kempe",
          "Kempees",
          "Kempen",
          "Kempenaar",
          "Kempenaars",
          "Kempeneers",
          "Kemper",
          "Kemperink",
          "Kemperman",
          "Kempers",
          "Kempes",
          "Kempff",
          "Kempinga",
          "Kempink",
          "Kempkens",
          "Kempkes",
          "Kemps",
          "Kenbeek",
          "Kengen",
          "Kennedy",
          "Kennes",
          "Kennis",
          "Kensmil",
          "Kenter",
          "Kenters",
          "Kentgens",
          "Kentie",
          "Kepel",
          "Kepers",
          "Keppel",
          "Keppels",
          "Kepser",
          "Kerbof",
          "Kerbusch",
          "Kerckhaert",
          "Kerckhoffs",
          "Kerckhoven",
          "Kerdijk",
          "Kerk",
          "Kerkdijk",
          "Kerke",
          "Kerkemeijer",
          "Kerkhof",
          "Kerkhoff",
          "Kerkhoffs",
          "Kerkhofs",
          "Kerkhove",
          "Kerkhoven",
          "Kerklaan",
          "Kerkman",
          "Kerkmeester",
          "Kerkmeijer",
          "Kerkoerle",
          "Kerkstra",
          "Kerkvliet",
          "Kerkwijk",
          "Kern",
          "Kernebeek",
          "Kerpel",
          "Kerpentier",
          "Kerpershoek",
          "Kerrebijn",
          "Kerremans",
          "Kers",
          "Kersbergen",
          "Kerseboom",
          "Kersemakers",
          "Kersjes",
          "Kerskes",
          "Kersseboom",
          "Kerssemakers",
          "Kerssen",
          "Kerssens",
          "Kerssies",
          "Kerst",
          "Kerste",
          "Kersten",
          "Kerstens",
          "Kerstholt",
          "Kersting",
          "Kerstjens",
          "Kervel",
          "Kerver",
          "Kervezee",
          "Kes",
          "Keser",
          "Keskin",
          "Kesler",
          "Kessel",
          "Kesselaar",
          "Kesseler",
          "Kessels",
          "Kessen",
          "Kessler",
          "Kesteloo",
          "Kester",
          "Kesteren",
          "Kesting",
          "Ket",
          "Ketel",
          "Ketelaar",
          "Ketelaars",
          "Ketelings",
          "Ketellapper",
          "Ketels",
          "Kets",
          "Kettelarij",
          "Kettenis",
          "Ketterij",
          "Ketting",
          "Ketwaru",
          "Ketz",
          "Keuben",
          "Keuken",
          "Keukens",
          "Keulemans",
          "Keulen",
          "Keulers",
          "Keultjes",
          "Keun",
          "Keune",
          "Keunen",
          "Keuning",
          "Keuper",
          "Keupink",
          "Keur",
          "Keuren",
          "Keurentjes",
          "Keurhorst",
          "Keurntjes",
          "Keurs",
          "Keus",
          "Keuter",
          "Keuvelaar",
          "Keuzenkamp",
          "Kevelam",
          "Kevenaar",
          "Kewal",
          "Keyner",
          "Keyzer",
          "Khalid",
          "Khalifa",
          "Khalil",
          "Khamlichi",
          "Khan",
          "Khattabi",
          "Khattouti",
          "Khawaja",
          "Khedoe",
          "Khelawan",
          "Khemai",
          "Kho",
          "Khodabaks",
          "Khoenkhoen",
          "Kiburg",
          "Kicken",
          "Kidane",
          "Kiebert",
          "Kieboom",
          "Kieft",
          "Kiefte",
          "Kieftenbeld",
          "Kieftenburg",
          "Kiekebos",
          "Kiekebosch",
          "Kiekens",
          "Kiel",
          "Kiela",
          "Kielman",
          "Kielstra",
          "Kiemel",
          "Kienhuis",
          "Kienstra",
          "Kierkels",
          "Kiers",
          "Kies",
          "Kiesbrink",
          "Kieskamp",
          "Kiestra",
          "Kievid",
          "Kieviet",
          "Kievit",
          "Kievith",
          "Kievits",
          "Kiewiet",
          "Kiewit",
          "Kiezebrink",
          "Kiezenberg",
          "Kiffen",
          "Kiggen",
          "Kijk in de Vegte",
          "Kijlstra",
          "Kijzers",
          "Kik",
          "Kikken",
          "Kikkert",
          "Kikstra",
          "Kil",
          "Kila",
          "Kilian",
          "Kilic",
          "Kilinç",
          "Kiliç",
          "Kiljan",
          "Kilkens",
          "Killaars",
          "Kilsdonk",
          "Kim",
          "Kimenai",
          "Kimman",
          "Kimmel",
          "Kimmels",
          "Kimmenade",
          "Kimmenaede",
          "Kimpe",
          "Kin",
          "Kind",
          "Kinderen",
          "Kinderman",
          "Kinds",
          "Kindt",
          "King",
          "Kingma",
          "Kinkel",
          "Kinkelaar",
          "Kinkelder",
          "Kinket",
          "Kinneging",
          "Kins",
          "Kinsbergen",
          "Kint",
          "Kints",
          "Kip",
          "Kipp",
          "Kippers",
          "Kippersluis",
          "Kipping",
          "Kirchhoff",
          "Kirchner",
          "Kirindongo",
          "Kirkels",
          "Kisjes",
          "Kisoen",
          "Kissami",
          "Kist",
          "Kistemaker",
          "Kisteman",
          "Kisters",
          "Kits",
          "Kitzen",
          "Kivit",
          "Kivits",
          "Klaaijsen",
          "Klaarbergen",
          "Klaarenbeek",
          "Klaas",
          "Klaase",
          "Klaasen",
          "Klaasse",
          "Klaassen",
          "Klaassens",
          "Klaauw",
          "Klabbers",
          "Klamer",
          "Klanderman",
          "Klap",
          "Klappe",
          "Klapwijk",
          "Klaren",
          "Klarenbeek",
          "Klarenberg",
          "Klas",
          "Klasen",
          "Klasens",
          "Klashorst",
          "Klaster",
          "Klaucke",
          "Klaui",
          "Klaus",
          "Klauw",
          "Klaver",
          "Klaverdijk",
          "Klaveren",
          "Klavers",
          "Klaverstijn",
          "Klaverweide",
          "Klee",
          "Kleef",
          "Kleeff",
          "Kleefman",
          "Kleefstra",
          "Kleemans",
          "Kleen",
          "Kleene",
          "Kleer",
          "Klees",
          "Kleeven",
          "Klei",
          "Kleiberg",
          "Kleiboer",
          "Kleij",
          "Kleijburg",
          "Kleijer",
          "Kleijkers",
          "Kleijn",
          "Kleijne",
          "Kleijnen",
          "Kleijngeld",
          "Kleijsen",
          "Kleijweg",
          "Kleijwegt",
          "Kleiker",
          "Kleiman",
          "Klein",
          "Klein Breteler",
          "Klein Entink",
          "Klein Geltink",
          "klein Goldewijk",
          "Klein Gunnewiek",
          "Klein Haneveld",
          "Klein Hesselink",
          "Klein Hofmeijer",
          "Klein Koerkamp",
          "Klein Kranenbarg",
          "Klein Nagelvoort",
          "Klein Overmeen",
          "Klein Swormink",
          "Klein Velderman",
          "Klein Wassink",
          "Klein Willink",
          "Klein Wolterink",
          "Klein Woolthuis",
          "Kleine",
          "Kleine Deters",
          "Kleine Schaars",
          "Kleine Staarman",
          "Kleinen",
          "Kleinendorst",
          "Kleinepier",
          "Kleingeld",
          "Kleinheerenbrink",
          "Kleinherenbrink",
          "Kleinhesselink",
          "Kleinhout",
          "Kleinhuis",
          "Kleinjan",
          "Kleinjans",
          "Kleinloog",
          "Kleinlugtenbeld",
          "Kleinlugtenbelt",
          "Kleinman",
          "Kleinmeulman",
          "Kleinmoedig",
          "Kleinpenning",
          "Kleinsman",
          "Kleinsmit",
          "Kleintjens",
          "Kleintjes",
          "Kleinveld",
          "Kleinwee",
          "Kleis",
          "Kleisen",
          "Kleiss",
          "Kleissen",
          "Kleisterlee",
          "Kleiterp",
          "Kleiweg",
          "Klem",
          "Klemann",
          "Klemans",
          "Klement",
          "Klene",
          "Klep",
          "Klepke",
          "Kleppe",
          "Klepper",
          "Kler",
          "Klerck",
          "Klercq",
          "Klerk",
          "Klerken",
          "Klerks",
          "Klerkx",
          "Klerx",
          "Klessens",
          "Kleton",
          "Kleuskens",
          "Kleut",
          "Kleuters",
          "Kleuver",
          "Kleve",
          "Klever",
          "Klevering",
          "Kleverlaan",
          "Kleverwal",
          "Klieverik",
          "Kliffen",
          "Klifman",
          "Klift",
          "Klij",
          "Klijberg",
          "Klijn",
          "Klijn Velderman",
          "Klijnhout",
          "Klijnsma",
          "Klijnsmit",
          "Klijnstra",
          "Klijs",
          "Klijsen",
          "Klijzing",
          "Kling",
          "Klinge",
          "Klingenberg",
          "Klingeren",
          "Klingers",
          "Klink",
          "Klinken",
          "Klinkenberg",
          "Klinker",
          "Klinkers",
          "Klinkert",
          "Klinkhamer",
          "Klinkien",
          "Klip",
          "Kliphuis",
          "Klippel",
          "Klis",
          "Klitsie",
          "Klock",
          "Kloe",
          "Kloeg",
          "Kloek",
          "Kloen",
          "Kloes",
          "Kloese",
          "Kloet",
          "Kloetstra",
          "Kloeze",
          "Kloezeman",
          "Kloezen",
          "Klok",
          "Klokgieter",
          "Klokgieters",
          "Klokkers",
          "Klokman",
          "Klom",
          "Klomp",
          "Klompe",
          "Klompen",
          "Klompenburg",
          "Klompenhouwer",
          "Klompenmaker",
          "Klompmaker",
          "Klomps",
          "Klompstra",
          "Kloos",
          "Klooster",
          "Kloosterboer",
          "Kloosterhuis",
          "Kloosterman",
          "Kloosterziel",
          "Kloostra",
          "Kloot",
          "Kloots",
          "Klootsema",
          "Klootwijk",
          "Klop",
          "Klopman",
          "Kloppenborg",
          "Kloppenburg",
          "Klopper",
          "Kloppers",
          "Klopstra",
          "Klos",
          "Klotz",
          "Klous",
          "Klouwer",
          "Kluck",
          "Kluft",
          "Klugt",
          "Kluijfhout",
          "Kluijt",
          "Kluijtmans",
          "Kluijver",
          "Kluin",
          "Kluinhaar",
          "Kluit",
          "Kluitenberg",
          "Kluiter",
          "Kluiters",
          "Kluitman",
          "Kluitmans",
          "Kluiver",
          "Kluivers",
          "Kluivert",
          "Klumpenaar",
          "Klumper",
          "Klumpers",
          "Klunder",
          "Klundert",
          "Klungel",
          "Kluskens",
          "Kluts",
          "Kluvers",
          "Kluwen",
          "Klösters",
          "Knaap",
          "Knaapen",
          "Knap",
          "Knape",
          "Knapen",
          "Knapper",
          "Knappers",
          "Knarren",
          "Knaven",
          "Knecht",
          "Kneefel",
          "Kneepkens",
          "Knegt",
          "Kneijber",
          "Knepper",
          "Kneppers",
          "Knetemann",
          "Knetsch",
          "Knevel",
          "Knevelbaard",
          "Knibbe",
          "Knibbeler",
          "Kniest",
          "Knigge",
          "Knijf",
          "Knijff",
          "Knijn",
          "Knijnenburg",
          "Knijpstra",
          "Knikker",
          "Knip",
          "Knipmeijer",
          "Knippels",
          "Knippenberg",
          "Knippers",
          "Knipping",
          "Knipscheer",
          "Knobbe",
          "Knobben",
          "Knobbout",
          "Knobel",
          "Knoben",
          "Knoef",
          "Knoeff",
          "Knoester",
          "Knokke",
          "Knol",
          "Knoll",
          "Knollema",
          "Knols",
          "Knook",
          "Knoop",
          "Knoope",
          "Knoops",
          "Knooren",
          "Knoors",
          "Knop",
          "Knopper",
          "Knoppers",
          "Knoppert",
          "Knops",
          "Knorren",
          "Knot",
          "Knotter",
          "Knottnerus",
          "Knubben",
          "Knuiman",
          "Knuit",
          "Knulst",
          "Knuppe",
          "Knuvers",
          "Knöps",
          "Ko",
          "Kobes",
          "Kobus",
          "Kobussen",
          "Koca",
          "Koch",
          "Kochen",
          "Kock",
          "Kockelkoren",
          "Kockelkorn",
          "Kocken",
          "Kocks",
          "Kockx",
          "Kodde",
          "Koe",
          "Koebrugge",
          "Koeckhoven",
          "Koedam",
          "Koedijk",
          "Koedood",
          "Koedooder",
          "Koedoot",
          "Koegler",
          "Koehler",
          "Koehof",
          "Koehoorn",
          "Koehorst",
          "Koeijer",
          "Koeiman",
          "Koek",
          "Koekebakker",
          "Koeken",
          "Koekenbier",
          "Koekkoek",
          "Koekoek",
          "Koel",
          "Koele",
          "Koeleman",
          "Koelemeij",
          "Koelemeijer",
          "Koelemij",
          "Koelen",
          "Koelewijn",
          "Koeling",
          "Koelink",
          "Koelma",
          "Koelman",
          "Koelmans",
          "Koelstra",
          "Koeman",
          "Koemans",
          "Koen",
          "Koenderink",
          "Koenders",
          "Koendjbiharie",
          "Koene",
          "Koenekoop",
          "Koenen",
          "Koenes",
          "Koenis",
          "Koenjer",
          "Koenraad",
          "Koenraads",
          "Koenraadt",
          "Koens",
          "Koerhuis",
          "Koerntjes",
          "Koers",
          "Koerselman",
          "Koersen",
          "Koert",
          "Koerts",
          "Koertshuis",
          "Koesal",
          "Koese",
          "Koeslag",
          "Koesveld",
          "Koet",
          "Koetje",
          "Koets",
          "Koetse",
          "Koetsenruijter",
          "Koetsier",
          "Koetsveld",
          "Koetze",
          "Koetzier",
          "Koeverden",
          "Koevering",
          "Koeveringe",
          "Koevermans",
          "Koevoet",
          "Koevoets",
          "Koezen",
          "Koff",
          "Koffeman",
          "Koffijberg",
          "Kogel",
          "Kogelman",
          "Koggel",
          "Kohl",
          "Kohlen",
          "Kohlmann",
          "Kohnen",
          "Koijen",
          "Koiter",
          "Kok",
          "Kokhuis",
          "Kokje",
          "Kokke",
          "Kokkeler",
          "Kokkelink",
          "Kokkelkoren",
          "Kokken",
          "Koks",
          "Kokshoorn",
          "Kokx",
          "Kol",
          "Kolb",
          "Kolck",
          "Koldenhof",
          "Kolder",
          "Koldeweij",
          "Koldewijn",
          "Koldijk",
          "Kole",
          "Kolen",
          "Kolenberg",
          "Kolenbrander",
          "Kolf",
          "Kolff",
          "Kolfschoten",
          "Kolijn",
          "Kolk",
          "Kolkman",
          "Koll",
          "Kollau",
          "Kolle",
          "Kollen",
          "Kollenburg",
          "Koller",
          "Kollmer",
          "Kollée",
          "Kolman",
          "Kolmer",
          "Kolmus",
          "Kolner",
          "Kolstee",
          "Kolsteeg",
          "Kolster",
          "Kolsteren",
          "Kolsters",
          "Kolthof",
          "Kolthoorn",
          "Kom",
          "Koman",
          "Kombrink",
          "Komdeur",
          "Komduur",
          "Komen",
          "Kommer",
          "Kommeren",
          "Kommers",
          "Kompier",
          "Komrij",
          "Kon",
          "Kondu",
          "Kong",
          "Konijn",
          "Konijnenbelt",
          "Konijnenberg",
          "Konijnenburg",
          "Konijnendijk",
          "Koning",
          "Koningen",
          "Konings",
          "Koningsbruggen",
          "Koningstein",
          "Koningsveld",
          "Konink",
          "Koninkx",
          "Konst",
          "Konstapel",
          "Konter",
          "Koobs",
          "Kooger",
          "Koogje",
          "Kooi",
          "Kooij",
          "Kooijker",
          "Kooijman",
          "Kooijmans",
          "Kooiker",
          "Kooiman",
          "Kooistra",
          "Kooke",
          "Kooker",
          "Kool",
          "Koolbergen",
          "Koole",
          "Koolen",
          "Koolhaas",
          "Koolhof",
          "Koolhoven",
          "Koolman",
          "Koolmees",
          "Koolmoes",
          "Kooloos",
          "Kools",
          "Koolschijn",
          "Koolstra",
          "Koolwijk",
          "Kooman",
          "Koomans",
          "Koomen",
          "Koonen",
          "Koonings",
          "Koonstra",
          "Koop",
          "Koopal",
          "Koopen",
          "Kooper",
          "Kooperen",
          "Koopman",
          "Koopmans",
          "Koopmanschap",
          "Koops",
          "Koopstra",
          "Kooreman",
          "Kooren",
          "Koorevaar",
          "Kooring",
          "Koorn",
          "Koorndijk",
          "Koorneef",
          "Koornneef",
          "Koornstra",
          "Koot",
          "Koote",
          "Kooten",
          "Kooter",
          "Kootkar",
          "Kootstra",
          "Kooy",
          "Kooyman",
          "Kooymans",
          "Kop",
          "Koper",
          "Koperdraat",
          "Kopmels",
          "Koppe",
          "Koppejan",
          "Koppel",
          "Koppelaar",
          "Koppele",
          "Koppelman",
          "Koppelmans",
          "Koppen",
          "Koppenaal",
          "Koppenhagen",
          "Koppenhol",
          "Koppenol",
          "Koppens",
          "Koppers",
          "Koppert",
          "Koppes",
          "Kops",
          "Kor",
          "Korbee",
          "Korbijn",
          "Kordelaar",
          "Korebrits",
          "Koree",
          "Koreman",
          "Koremans",
          "Koren",
          "Korenberg",
          "Korenblik",
          "Korendijk",
          "Koreneef",
          "Korenhof",
          "Korenromp",
          "Korevaar",
          "Korf",
          "Korfage",
          "Korff",
          "Korhorn",
          "Koridon",
          "Korkmaz",
          "Korlaar",
          "Korn",
          "Kornaat",
          "Kornegoor",
          "Kornelis",
          "Kornet",
          "Kornman",
          "Korpel",
          "Korpershoek",
          "Korporaal",
          "Korput",
          "Korrel",
          "Korremans",
          "Korringa",
          "Kors",
          "Korse",
          "Korsman",
          "Korsmit",
          "Korst",
          "Korstanje",
          "Korsten",
          "Korsuize",
          "Korswagen",
          "Kort",
          "Kortbeek",
          "Korte",
          "Kortekaas",
          "Korteland",
          "Korten",
          "Kortenhoeven",
          "Kortenhof",
          "Kortenhorst",
          "Kortenoeven",
          "Korterink",
          "Korteweg",
          "Korthals",
          "Korthals Altes",
          "Korthof",
          "Korthout",
          "Korthouwer",
          "Korthuis",
          "Korting",
          "Kortink",
          "Kortland",
          "Kortleve",
          "Kortleven",
          "Kortlever",
          "Kortman",
          "Kortmann",
          "Kortooms",
          "Kortsmit",
          "Kortstee",
          "Korvemaker",
          "Korven",
          "Korver",
          "Korving",
          "Korzelius",
          "Kos",
          "Koskamp",
          "Kosman",
          "Kosse",
          "Kossen",
          "Kost",
          "Kostelijk",
          "Kosten",
          "Kostense",
          "Koster",
          "Kosterink",
          "Kosterman",
          "Kostermans",
          "Kosters",
          "Kostons",
          "Kostwinder",
          "Koswal",
          "Kot",
          "Koten",
          "Kotte",
          "Kottier",
          "Kottink",
          "Koubaa",
          "Koudenburg",
          "Koudijs",
          "Koudstaal",
          "Kouijzer",
          "Koumans",
          "Kous",
          "Kousbroek",
          "Kousemaker",
          "Kouteren",
          "Kouterik",
          "Kouters",
          "Koutrik",
          "Koutstaal",
          "Kouw",
          "Kouwen",
          "Kouwenberg",
          "Kouwenhoven",
          "Kouwer",
          "Kovačević",
          "Kovel",
          "Kovács",
          "Kowalski",
          "Kowsoleea",
          "Kox",
          "Koyuncu",
          "Kozan",
          "Kozijn",
          "Koç",
          "Koçak",
          "Koçer",
          "Kraag",
          "Kraai",
          "Kraaij",
          "Kraaijenbrink",
          "Kraaijenhagen",
          "Kraaijenhof",
          "Kraaijenoord",
          "Kraaijeveld",
          "Kraaijkamp",
          "Kraaijvanger",
          "Kraaijveld",
          "Kraaikamp",
          "Kraak",
          "Kraakman",
          "Kraal",
          "Kraamer",
          "Kraan",
          "Kraanen",
          "Kraats",
          "Krab",
          "Krabbe",
          "Krabben",
          "Krabbenborg",
          "Krabbenbos",
          "Krabbendam",
          "Krabshuis",
          "Kracht",
          "Kradolfer",
          "Kraft",
          "Kragt",
          "Kragten",
          "Kragting",
          "Kragtwijk",
          "Krah",
          "Kraijenoord",
          "Krajenbrink",
          "Krak",
          "Krake",
          "Kraker",
          "Kral",
          "Krale",
          "Kralingen",
          "Kralt",
          "Kram",
          "Kramer",
          "Kramers",
          "Kramp",
          "Kranen",
          "Kranenberg",
          "Kranenborg",
          "Kranenburg",
          "Kranendonk",
          "Kraneveld",
          "Kranghand",
          "Krans",
          "Krap",
          "Krapels",
          "Kras",
          "Krasniqi",
          "Krassenburg",
          "Kraster",
          "Kraus",
          "Krause",
          "Krauts",
          "Krebbekx",
          "Krebber",
          "Krebbers",
          "Krebs",
          "Krechting",
          "Krediet",
          "Kreeft",
          "Kreeftenberg",
          "Kreeftmeijer",
          "Kreek",
          "Kreeke",
          "Kreemers",
          "Kreffer",
          "Kreft",
          "Kregel",
          "Kregting",
          "Kreij",
          "Kreijkes",
          "Kreikamp",
          "Kreike",
          "Krekel",
          "Krekels",
          "Kreling",
          "Kremer",
          "Kremers",
          "Krens",
          "Kreté",
          "Kreugel",
          "Kreuger",
          "Kreuk",
          "Kreukniet",
          "Kreulen",
          "Kreunen",
          "Kreuning",
          "Kreuningen",
          "Kreutz",
          "Kreuwel",
          "Kreuze",
          "Kreuzen",
          "Krevel",
          "Krevelen",
          "Krewinkel",
          "Kriegenbergh",
          "Krieger",
          "Kriek",
          "Kriekaard",
          "Krieke",
          "Krieken",
          "Kriekjes",
          "Krielaart",
          "Kriele",
          "Krielen",
          "Kriens",
          "Kriesels",
          "Krijbolder",
          "Krijger",
          "Krijgh",
          "Krijgsheld",
          "Krijgsman",
          "Krijn",
          "Krijnen",
          "Krijnsen",
          "Krijntjes",
          "Krijt",
          "Krijtenberg",
          "Krijtenburg",
          "Krijthe",
          "Krikhaar",
          "Krikke",
          "Krikken",
          "Krimp",
          "Krimpen",
          "Krings",
          "Krips",
          "Krisman",
          "Krispijn",
          "Krist",
          "Kristalijn",
          "Kristel",
          "Kristelijn",
          "Kroef",
          "Kroek",
          "Kroep",
          "Kroes",
          "Kroesbergen",
          "Kroese",
          "Kroesen",
          "Kroeske",
          "Kroeze",
          "Kroezen",
          "Kroft",
          "Krogt",
          "Krol",
          "Kroll",
          "Krom",
          "Kromdijk",
          "Kromhout",
          "Kromhout van der Meer",
          "Kromkamp",
          "Krommendijk",
          "Krommenhoek",
          "Kromwijk",
          "Krone",
          "Kroneman",
          "Kronemeijer",
          "Kronenberg",
          "Kronenburg",
          "Kronnie",
          "Krooder",
          "Krook",
          "Kroon",
          "Kroondijk",
          "Kroone",
          "Krooneman",
          "Kroonen",
          "Kroonenberg",
          "Kroonenburg",
          "Kroos",
          "Krooshof",
          "Krooswijk",
          "Kroot",
          "Krop",
          "Kropff",
          "Kropman",
          "Krops",
          "Kros",
          "Kross",
          "Krosse",
          "Krottje",
          "Krouwel",
          "Kruchten",
          "Kruf",
          "Krug",
          "Kruger",
          "Krugten",
          "Kruid",
          "Kruidenberg",
          "Kruidenier",
          "Kruidhof",
          "Kruif",
          "Kruiff",
          "Kruiger",
          "Kruijer",
          "Kruijf",
          "Kruijff",
          "Kruijk",
          "Kruijs",
          "Kruijsbergen",
          "Kruijsdijk",
          "Kruijsen",
          "Kruijshaar",
          "Kruijsse",
          "Kruijssen",
          "Kruijswijk",
          "Kruijt",
          "Kruijthof",
          "Kruijthoff",
          "Kruijtzer",
          "Kruijver",
          "Kruik",
          "Kruimer",
          "Kruining",
          "Kruip",
          "Kruiper",
          "Kruis",
          "Kruisbergen",
          "Kruisdijk",
          "Kruise",
          "Kruisheer",
          "Kruisinga",
          "Kruiskamp",
          "Kruisman",
          "Kruisselbrink",
          "Kruissen",
          "Kruistum",
          "Kruiswijk",
          "Kruit",
          "Kruitbos",
          "Kruitbosch",
          "Kruiter",
          "Kruithof",
          "Kruitwagen",
          "Kruiver",
          "Kruize",
          "Kruizenga",
          "Kruizinga",
          "Kruk",
          "Krukkert",
          "Krul",
          "Krus",
          "Kruse",
          "Krutzen",
          "Kruyff",
          "Kruyt",
          "Krämer",
          "Krüger",
          "Krüse",
          "Kubben",
          "Kubber",
          "Kuenen",
          "Kuepers",
          "Kugel",
          "Kuhl",
          "Kuhlman",
          "Kuhlmann",
          "Kuhn",
          "Kuhnen",
          "Kuiers",
          "Kuij",
          "Kuijck",
          "Kuijen",
          "Kuijer",
          "Kuijeren",
          "Kuijers",
          "Kuijf",
          "Kuijk",
          "Kuijken",
          "Kuijl",
          "Kuijlaars",
          "Kuijlen",
          "Kuijlenburg",
          "Kuijntjes",
          "Kuijp",
          "Kuijpens",
          "Kuijper",
          "Kuijpers",
          "Kuijs",
          "Kuijsten",
          "Kuijstermans",
          "Kuijsters",
          "Kuijt",
          "Kuijten",
          "Kuijvenhoven",
          "Kuik",
          "Kuiken",
          "Kuil",
          "Kuilboer",
          "Kuilder",
          "Kuile",
          "Kuilen",
          "Kuilenburg",
          "Kuilman",
          "Kuin",
          "Kuinder",
          "Kuindersma",
          "Kuip",
          "Kuiper",
          "Kuiperij",
          "Kuipers",
          "Kuiphuis",
          "Kuis",
          "Kuit",
          "Kuiten",
          "Kuitenbrouwer",
          "Kuiter",
          "Kuiters",
          "Kuitert",
          "Kuivenhoven",
          "Kuizenga",
          "Kukler",
          "Kulik",
          "Kuling",
          "Kulk",
          "Kulsdom",
          "Kulve",
          "Kumar",
          "Kumaş",
          "Kummeling",
          "Kunder",
          "Kunen",
          "Kunkeler",
          "Kunkels",
          "Kunne",
          "Kunnen",
          "Kunst",
          "Kunstman",
          "Kunz",
          "Kuo",
          "Kup",
          "Kuper",
          "Kupers",
          "Kuperus",
          "Kuppen",
          "Kuppens",
          "Kupper",
          "Kuppeveld",
          "Kurban",
          "Kuringen",
          "Kurnaz",
          "Kurpershoek",
          "Kursten",
          "Kurstjens",
          "Kurt",
          "Kuru",
          "Kurver",
          "Kurvers",
          "Kurvink",
          "Kussendrager",
          "Kust",
          "Kuster",
          "Kustermans",
          "Kusters",
          "Kutlu",
          "Kuunders",
          "Kuur",
          "Kuurstra",
          "Kuus",
          "Kuyper",
          "Kuypers",
          "Kuyvenhoven",
          "Kuzee",
          "Kuş",
          "Kwaadsteniet",
          "Kwaaitaal",
          "Kwaak",
          "Kwaasteniet",
          "Kwadijk",
          "Kwak",
          "Kwakernaak",
          "Kwakernaat",
          "Kwakkel",
          "Kwakkelstein",
          "Kwakkenbos",
          "Kwakman",
          "Kwaks",
          "Kwant",
          "Kwanten",
          "Kwantes",
          "Kwappenberg",
          "Kwarten",
          "Kwaspen",
          "Kwast",
          "Kwawegen",
          "Kwee",
          "Kweekel",
          "Kweens",
          "Kwekkeboom",
          "Kwerreveld",
          "Kwetters",
          "Kwidama",
          "Kwinkelenberg",
          "Kwint",
          "Kwinten",
          "Kwist",
          "Kwisthout",
          "Kwok",
          "Köhlen",
          "Köhler",
          "Köhne",
          "Kök",
          "Köksal",
          "Kölker",
          "Köller",
          "König",
          "Könings",
          "Körver",
          "Köse",
          "Köster",
          "Kösters",
          "Köycü",
          "Kühn",
          "Kühne",
          "Küpers",
          "Küppers",
          "Küsters",
          "Kütük",
          "Küçük",
          "Laaf",
          "Laag",
          "Laagland",
          "Laak",
          "Laan",
          "Laane",
          "Laanen",
          "Laanstra",
          "Laar",
          "Laarakker",
          "Laarakkers",
          "Laaren",
          "Laarhoven",
          "Laarhuis",
          "Laarman",
          "Laars",
          "Laarschot",
          "Laarse",
          "Laat",
          "Laats",
          "Laatum",
          "Laban",
          "Labee",
          "Labeur",
          "Lablans",
          "Labordus",
          "Labots",
          "Labree",
          "Labrie",
          "Labrijn",
          "Lacet",
          "Lachhab",
          "Lachkar",
          "Lachman",
          "Lachmansingh",
          "Lachmon",
          "Laclé",
          "Lacroes",
          "Lacroix",
          "Ladage",
          "Ladan",
          "Ladenius",
          "Ladru",
          "Laemers",
          "Laenen",
          "Laer",
          "Laere",
          "Laerhoven",
          "Laet",
          "Laeven",
          "Lafeber",
          "Laffra",
          "Lafleur",
          "Lagarde",
          "Lagas",
          "Lagcher",
          "Lagemaat",
          "Lageman",
          "Lagen",
          "Lagendijk",
          "Lagerberg",
          "Lagerburg",
          "Lagerwaard",
          "Lagerweij",
          "Lagerwerf",
          "Lageschaar",
          "Lageveen",
          "Lagewaard",
          "Lageweg",
          "Lagraauw",
          "Lagrand",
          "Lagrouw",
          "Lahaije",
          "Lahaye",
          "Lahdo",
          "Laheij",
          "Lahr",
          "Lahuis",
          "Lai",
          "Laisina",
          "Lak",
          "Lake",
          "Lakeman",
          "Laken",
          "Lakenman",
          "Lakerveld",
          "Lakhal",
          "Lakwijk",
          "Lala",
          "Lalbiharie",
          "Lalieu",
          "Lalkens",
          "Lalleman",
          "Lam",
          "Lamain",
          "Laman",
          "Lambalgen",
          "Lambeck",
          "Lambeek",
          "Lamberink",
          "Lambermon",
          "Lambermont",
          "Lambers",
          "Lambert",
          "Lamberts",
          "Lamboo",
          "Lambooij",
          "Lambrechts",
          "Lambregts",
          "Lambregtse",
          "Lambrichs",
          "Lambrichts",
          "Lameijer",
          "Lamein",
          "Lamens",
          "Lamerichs",
          "Lameris",
          "Lamers",
          "Lamfers",
          "Laming",
          "Lamme",
          "Lammen",
          "Lammens",
          "Lammeren",
          "Lammerink",
          "Lammers",
          "Lammerse",
          "Lammersen",
          "Lammertink",
          "Lammerts",
          "Lammerts van Bueren",
          "Lammertse",
          "Lammertsma",
          "Lamoen",
          "Lampe",
          "Lamper",
          "Lampers",
          "Lamping",
          "Lamrini",
          "Lamsma",
          "Lancee",
          "Lancel",
          "Land",
          "Landa",
          "Landaal",
          "Landburg",
          "Lande",
          "Landegent",
          "Landen",
          "Lander",
          "Landeweer",
          "Landeweerd",
          "Landheer",
          "Landkroon",
          "Landman",
          "Landmeter",
          "Landsbergen",
          "Landsman",
          "Landsmeer",
          "Landstra",
          "Landveld",
          "Landvreugd",
          "Landwaart",
          "Landwehr",
          "Landzaat",
          "Lanen",
          "Lanfermeijer",
          "Lang",
          "Langbroek",
          "Lange",
          "Langebeeke",
          "Langeberg",
          "Langedijk",
          "Langejan",
          "Langejans",
          "Langelaan",
          "Langelaar",
          "Langeland",
          "Langeler",
          "Langemeijer",
          "Langemheen",
          "Langen",
          "Langenbach",
          "Langenberg",
          "Langendam",
          "Langendijk",
          "Langendoen",
          "Langendonk",
          "Langenhof",
          "Langenhoff",
          "Langenhuijsen",
          "Langenhuijzen",
          "Langenhuizen",
          "Langenkamp",
          "Langens",
          "Langerak",
          "Langereis",
          "Langerhorst",
          "Langerhuizen",
          "Langermans",
          "Langerwerf",
          "Langes",
          "Langeslag",
          "Langeveld",
          "Langevelde",
          "Langevoort",
          "Langeweg",
          "Langezaal",
          "Langhorst",
          "Langhout",
          "Langius",
          "Langkamp",
          "Langkemper",
          "Langras",
          "Langstraat",
          "Langwerden",
          "Laning",
          "Lanjouw",
          "Lankamp",
          "Lankeren",
          "Lankester",
          "Lankhaar",
          "Lankheet",
          "Lankhof",
          "Lankhorst",
          "Lankhuijzen",
          "Lankman",
          "Lankreijer",
          "Lankveld",
          "Lankvelt",
          "Lankwarden",
          "Lannoy",
          "Lanphen",
          "Lans",
          "Lansbergen",
          "Lansdaal",
          "Lansen",
          "Lanser",
          "Lansing",
          "Lansink",
          "Lanslots",
          "Lansu",
          "Lanters",
          "Lanting",
          "Lantinga",
          "Lantink",
          "Lap",
          "Lapien",
          "Laponder",
          "Lapré",
          "Lardenoije",
          "Lardinois",
          "Larmit",
          "Larooij",
          "Laros",
          "Larsen",
          "Laseur",
          "Lasker",
          "Lasonder",
          "Lassche",
          "Lasschuit",
          "Lassooij",
          "Last",
          "Lastdrager",
          "Lataster",
          "Later",
          "Laterveer",
          "Lathouwers",
          "Latif",
          "Latijnhouwers",
          "Latour",
          "Latten",
          "Latuheru",
          "Latum",
          "Latumahina",
          "Latupeirissa",
          "Lau",
          "Lauffer",
          "Laugs",
          "Laumans",
          "Laumen",
          "Laurant",
          "Laureijs",
          "Laurens",
          "Laurense",
          "Laurenssen",
          "Laurentzen",
          "Lauret",
          "Laurier",
          "Laurijsen",
          "Laurijssen",
          "Laus",
          "Lausberg",
          "Lautenbach",
          "Lautenschutz",
          "Lauw",
          "Lauwen",
          "Lauwerijssen",
          "Lauwers",
          "Laven",
          "Laverman",
          "Lavieren",
          "Lavooij",
          "Lavrijsen",
          "Lavrijssen",
          "Law",
          "Lawalata",
          "Lazaar",
          "Lazaroms",
          "Lazeroms",
          "Lazet",
          "Le",
          "Leander",
          "Leatemia",
          "Lebbing",
          "Lebbink",
          "Lebens",
          "Leber",
          "Lebesque",
          "Leblanc",
          "Lebon",
          "Lechner",
          "Leclaire",
          "Leclercq",
          "Lecq",
          "Ledden",
          "Ledder",
          "Ledeboer",
          "Leden",
          "Leduc",
          "Lee",
          "Leede",
          "Leeden",
          "Leeflang",
          "Leeftink",
          "Leeggangers",
          "Leegstra",
          "Leegte",
          "Leegwater",
          "Leeijen",
          "Leek",
          "Leeman",
          "Leemans",
          "Leemburg",
          "Leemeijer",
          "Leemhuis",
          "Leemkolk",
          "Leemkuil",
          "Leemput",
          "Leemreize",
          "Leen",
          "Leenaars",
          "Leenaarts",
          "Leenaerts",
          "Leenards",
          "Leenders",
          "Leenderts",
          "Leendertse",
          "Leene",
          "Leenen",
          "Leenes",
          "Leenheer",
          "Leenheers",
          "Leenhouts",
          "Leenhouwers",
          "Leenknegt",
          "Leenman",
          "Leensen",
          "Leenstra",
          "Leent",
          "Leentfaar",
          "Leentvaar",
          "Leer",
          "Leerdam",
          "Leerentveld",
          "Leering",
          "Leerink",
          "Leerintveld",
          "Leerkes",
          "Leerling",
          "Leermakers",
          "Leers",
          "Leersum",
          "Leertouwer",
          "Leest",
          "Leeuw",
          "Leeuw van Weenen",
          "Leeuwaarde",
          "Leeuwaarden",
          "Leeuwangh",
          "Leeuwe",
          "Leeuwen",
          "Leeuwenburg",
          "Leeuwenburgh",
          "Leeuwenkamp",
          "Leeuwerik",
          "Leeuwerink",
          "Leeuwerke",
          "Leeuwesteijn",
          "Leeuwestein",
          "Leeuwin",
          "Leeuwis",
          "Leeuwrik",
          "Leever",
          "Leewis",
          "Lefeber",
          "Lefering",
          "Leferink",
          "Lefers",
          "Leffers",
          "Lefferts",
          "Lege",
          "Legebeke",
          "Legemaat",
          "Legemaate",
          "Legerstee",
          "Leget",
          "Legierse",
          "Legius",
          "Legtenberg",
          "Legters",
          "Leguijt",
          "Leguit",
          "Lehmann",
          "Lei",
          "Leibbrand",
          "Leidekker",
          "Leidelmeijer",
          "Leidelmeyer",
          "Leiden",
          "Leij",
          "Leijdekker",
          "Leijdekkers",
          "Leijden",
          "Leijdens",
          "Leije",
          "Leijen",
          "Leijenaar",
          "Leijendeckers",
          "Leijendekker",
          "Leijendekkers",
          "Leijenhorst",
          "Leijer",
          "Leijgraaff",
          "Leijnse",
          "Leijs",
          "Leijsen",
          "Leijser",
          "Leijssen",
          "Leijssenaar",
          "Leijsten",
          "Leijstra",
          "Leijte",
          "Leijten",
          "Leijtens",
          "Leijzer",
          "Leinders",
          "Leinenga",
          "Leipsig",
          "Leisink",
          "Leistra",
          "Leito",
          "Leiwakabessy",
          "Lejeune",
          "Lek",
          "Lekatompessy",
          "Lekkerkerk",
          "Lekkerkerker",
          "Lekx",
          "Lelie",
          "Lelieveld",
          "Lelij",
          "Lelijveld",
          "Leliveld",
          "Lelivelt",
          "Leloux",
          "Lely",
          "Lem",
          "Lemaire",
          "Lemans",
          "Lemckert",
          "Lemeer",
          "Lemke",
          "Lemlijn",
          "Lemm",
          "Lemmen",
          "Lemmens",
          "Lemmers",
          "Lemmert",
          "Lemmink",
          "Lempens",
          "Lempers",
          "Lems",
          "Lemsom",
          "Lemson",
          "Lemstra",
          "Lenaers",
          "Lenaerts",
          "Lende",
          "Lendering",
          "Lenderink",
          "Lenders",
          "Lendfers",
          "Lenes",
          "Lenferink",
          "Leng",
          "Lengers",
          "Lengkeek",
          "Lengton",
          "Lenior",
          "Lenkens",
          "Lennaerts",
          "Lennartz",
          "Lennep",
          "Lennertz",
          "Lennips",
          "Lenoir",
          "Lenos",
          "Lens",
          "Lenselink",
          "Lensen",
          "Lensing",
          "Lensink",
          "Lenssen",
          "Lenstra",
          "Lensvelt",
          "Lent",
          "Lente",
          "Lentelink",
          "Lenten",
          "Lenters",
          "Lentfert",
          "Lenthe",
          "Lenting",
          "Lentink",
          "Lentjes",
          "Lentz",
          "Lentze",
          "Lenz",
          "Lenzen",
          "Leo",
          "Leonard",
          "Leonora",
          "Leopold",
          "Lepelaar",
          "Lepelaars",
          "Lepoeter",
          "Lepoutre",
          "Lepper",
          "Leppers",
          "Leppink",
          "Leseman",
          "Lesman",
          "Lesscher",
          "Lest",
          "Lesterhuis",
          "Let",
          "Leter",
          "Leth",
          "Lether",
          "Letsch",
          "Letschert",
          "Lette",
          "Letteboer",
          "Letterman",
          "Lettinga",
          "Lettink",
          "Leufkens",
          "Leuken",
          "Leun",
          "Leune",
          "Leunen",
          "Leung",
          "Leunge",
          "Leunis",
          "Leunissen",
          "Leunk",
          "Leupen",
          "Leur",
          "Leurink",
          "Leurs",
          "Leus",
          "Leusden",
          "Leusen",
          "Leushuis",
          "Leusink",
          "Leussen",
          "Leussink",
          "Leutscher",
          "Leuven",
          "Leuvenink",
          "Leuveren",
          "Leuverink",
          "Leuw",
          "Levels",
          "Leven",
          "Levens",
          "Lever",
          "Levering",
          "Leverink",
          "Levie",
          "Levinga",
          "Levy",
          "Lewerissa",
          "Lewis",
          "Lexmond",
          "Ley",
          "Leysner",
          "Lezwijn",
          "Li",
          "Liang",
          "Libbers",
          "Libregts",
          "Lich",
          "Licher",
          "Licht",
          "Lichtenberg",
          "Lichtendahl",
          "Lichtendonk",
          "Lichteveld",
          "Lie",
          "Liebe",
          "Lieben",
          "Liebergen",
          "Liebers",
          "Liebrand",
          "Liebrecht",
          "Liebregts",
          "Liefde",
          "Lieferink",
          "Liefers",
          "Lieffering",
          "Liefhebber",
          "Liefland",
          "Liefrink",
          "Liefting",
          "Lieftink",
          "Liefvoort",
          "Liem",
          "Lieman",
          "Liemburg",
          "Liempd",
          "Liempt",
          "Lien",
          "Lienden",
          "Lienen",
          "Lier",
          "Liere",
          "Lierop",
          "Liesdek",
          "Lieshout",
          "Lieskamp",
          "Liesker",
          "Liesting",
          "Liesveld",
          "Liet",
          "Liethof",
          "Lieuw",
          "Lieuwen",
          "Lieuwes",
          "Lievaart",
          "Lieveld",
          "Lieven",
          "Lievens",
          "Lievense",
          "Lieverdink",
          "Lieverloo",
          "Lievers",
          "Lieverse",
          "Lieverst",
          "Lievestro",
          "Liewes",
          "Liezen",
          "Liezenga",
          "Ligeon",
          "Ligt",
          "Ligtelijn",
          "Ligten",
          "Ligtenbarg",
          "Ligtenberg",
          "Ligteringen",
          "Ligterink",
          "Ligtermoet",
          "Ligthart",
          "Ligtlee",
          "Ligtvoet",
          "Lijbers",
          "Lijcklama à Nijeholt",
          "Lijesen",
          "Lijf",
          "Lijffijt",
          "Lijftogt",
          "Lijkendijk",
          "Lijklema",
          "Lijn",
          "Lijnsvelt",
          "Lijssel",
          "Lijster",
          "Lijten",
          "Lijzenga",
          "Lilipaly",
          "Lim",
          "Lima",
          "Limbeek",
          "Limberger",
          "Limburg",
          "Limmen",
          "Limon",
          "Limonard",
          "Limpens",
          "Limpt",
          "Lin",
          "Lina",
          "Linckens",
          "Lind",
          "Lindaart",
          "Linde",
          "Lindeboom",
          "Lindelauf",
          "Lindeloof",
          "Lindeman",
          "Lindemans",
          "Linden",
          "Lindenberg",
          "Lindenbergh",
          "Lindenburg",
          "Lindenhovius",
          "Linder",
          "Linderhof",
          "Linders",
          "Lindert",
          "Lindhout",
          "Lindner",
          "Lindsen",
          "Ling",
          "Lingbeek",
          "Linge",
          "Lingeman",
          "Lingen",
          "Linger",
          "Link",
          "Linke",
          "Linkels",
          "Linker",
          "Links",
          "Linnartz",
          "Linnebank",
          "Linneman",
          "Linnemann",
          "Linnenbank",
          "Linschoten",
          "Linsen",
          "Linskens",
          "Linssen",
          "Linstra",
          "Lint",
          "Lintelo",
          "Lintermans",
          "Linthorst",
          "Linthout",
          "Linting",
          "Lintjens",
          "Lintsen",
          "Lion",
          "Lip",
          "Liplijn",
          "Lipman",
          "Lippe",
          "Lippens",
          "Lippinkhof",
          "Lippmann",
          "Lippold",
          "Lips",
          "Lipsch",
          "Lipzig",
          "Lisdonk",
          "Lisman",
          "Lispet",
          "Lissenberg",
          "Lissenburg",
          "Lissum",
          "List",
          "Lit",
          "Lith",
          "Litjens",
          "Litjes",
          "Litsenburg",
          "Littel",
          "Littooij",
          "Liu",
          "Lo",
          "Lo-A-Njoe",
          "Lobbes",
          "Lobbezoo",
          "Lobeek",
          "Lobles",
          "Lobo",
          "Lobregt",
          "Loch",
          "Lochem",
          "Locht",
          "Lochtenberg",
          "Lock",
          "Lockefeer",
          "Lockhorst",
          "Lodder",
          "Lodders",
          "Lode",
          "Loderus",
          "Lodeweges",
          "Lodewijk",
          "Lodewijks",
          "Lodewijkx",
          "Lodewikus",
          "Loedeman",
          "Loef",
          "Loeff",
          "Loeffen",
          "Loen",
          "Loendersloot",
          "Loenen",
          "Loenhout",
          "Loer",
          "Loerakker",
          "Loermans",
          "Loeters",
          "Loeve",
          "Loevezijn",
          "Lof",
          "Loffeld",
          "Logchem",
          "Loggen",
          "Logger",
          "Logister",
          "Logt",
          "Logten",
          "Logtenberg",
          "Logtens",
          "Logtmeijer",
          "Lohman",
          "Lohmann",
          "Lohmeijer",
          "Lohuis",
          "Lohuizen",
          "Loijen",
          "Loijenga",
          "Loijens",
          "Lok",
          "Lokate",
          "Lokers",
          "Lokerse",
          "Lokhoff",
          "Lokhorst",
          "Lokken",
          "Lokker",
          "Lokkerbol",
          "Lokven",
          "Lolkema",
          "Loman",
          "Lomans",
          "Lomme",
          "Lommen",
          "Lommerde",
          "Lommers",
          "Lommerse",
          "Lomwel",
          "Londen",
          "London",
          "Lonis",
          "Lonkhuijzen",
          "Lont",
          "Loo",
          "Loock",
          "Loof",
          "Looff",
          "Loogman",
          "Loohuis",
          "Looij",
          "Looije",
          "Looijen",
          "Looijenga",
          "Looijengoed",
          "Looijer",
          "Looijestijn",
          "Looijmans",
          "Looijs",
          "Looijschelder",
          "Loois",
          "Look",
          "Lookman",
          "Looman",
          "Loomans",
          "Loon",
          "Loonen",
          "Loonstra",
          "Loontjens",
          "Loop",
          "Looper",
          "Loopik",
          "Loopstra",
          "Loor",
          "Loorbach",
          "Looren de Jong",
          "Loos",
          "Loosbroek",
          "Loosdrecht",
          "Loose",
          "Loosen",
          "Loosman",
          "Loot",
          "Lootens",
          "Loots",
          "Lootsma",
          "Looze",
          "Loozen",
          "Lopes",
          "Lopes Cardozo",
          "Lopez",
          "Lopik",
          "Lops",
          "Lopulalan",
          "Lorier",
          "Lorijn",
          "Lorist",
          "Lorié",
          "Lorjé",
          "Lorkeers",
          "Lormans",
          "Lorsé",
          "Los",
          "Losekoot",
          "Losser",
          "Lossie",
          "Loth",
          "Lotringen",
          "Lotte",
          "Lotterman",
          "Lottum",
          "Lotz",
          "Louer",
          "Louhenapessy",
          "Louis",
          "Louisa",
          "Louisse",
          "Loukili",
          "Louman",
          "Loupatty",
          "Loupias",
          "Lourens",
          "Lourensen",
          "Lourenssen",
          "Lous",
          "Lousberg",
          "Louter",
          "Louters",
          "Louw",
          "Louwe",
          "Louwen",
          "Louwerens",
          "Louwers",
          "Louwerse",
          "Louwersheimer",
          "Louwes",
          "Louwman",
          "Louws",
          "Louwsma",
          "Loveren",
          "Loves",
          "Lovink",
          "Lowes",
          "Lowijs",
          "Lozeman",
          "Lu",
          "Lub",
          "Lubach",
          "Lubbe",
          "Lubbelinkhof",
          "Lubben",
          "Lubberding",
          "Lubberdink",
          "Lubberink",
          "Lubbers",
          "Lubbersen",
          "Lubberts",
          "Lubbinge",
          "Lubek",
          "Luca",
          "Lucardie",
          "Lucas",
          "Lucassen",
          "Luchies",
          "Luchtenberg",
          "Luchtenburg",
          "Luchtmeijer",
          "Lucius",
          "Lucke",
          "Lucker",
          "Ludema",
          "Ludwig",
          "Lueb",
          "Lueks",
          "Luesink",
          "Lugt",
          "Lugten",
          "Lugtenberg",
          "Lugtenburg",
          "Lugters",
          "Lugthart",
          "Lugtigheid",
          "Lugtmeijer",
          "Luhrman",
          "Luhulima",
          "Luider",
          "Luigjes",
          "Luijben",
          "Luijbregts",
          "Luijckx",
          "Luijcx",
          "Luijendijk",
          "Luijer",
          "Luijerink",
          "Luijk",
          "Luijken",
          "Luijks",
          "Luijkx",
          "Luijmes",
          "Luijn",
          "Luijpen",
          "Luijpers",
          "Luijs",
          "Luijsterburg",
          "Luijt",
          "Luijtelaar",
          "Luijten",
          "Luijtgaarden",
          "Luik",
          "Luiken",
          "Luikens",
          "Luimes",
          "Luimstra",
          "Luinen",
          "Luinenburg",
          "Luinge",
          "Luining",
          "Luinstra",
          "Luis",
          "Luisman",
          "Luit",
          "Luiten",
          "Luites",
          "Luitgaarden",
          "Luiting",
          "Luitjens",
          "Luitjes",
          "Luitwieler",
          "Luk",
          "Lukas",
          "Lukasse",
          "Lukassen",
          "Luken",
          "Lukens",
          "Lukkassen",
          "Lukken",
          "Lukkes",
          "Lukkien",
          "Lulofs",
          "Lumens",
          "Lune",
          "Lunenborg",
          "Lunenburg",
          "Luning",
          "Lunsen",
          "Lunshof",
          "Lunter",
          "Lunteren",
          "Luong",
          "Lupker",
          "Luppens",
          "Luppes",
          "Lups",
          "Lurvink",
          "Lusink",
          "Lussenburg",
          "Lust",
          "Lustenhouwer",
          "Lustgraaf",
          "Lustig",
          "Lut",
          "Lute",
          "Luteijn",
          "Luten",
          "Lutgens",
          "Lutgerink",
          "Luth",
          "Luthart",
          "Lutjeboer",
          "Lutjes",
          "Lutke",
          "Lutke Schipholt",
          "Luttenberg",
          "Lutter",
          "Lutterman",
          "Lutters",
          "Lutterveld",
          "Luttik",
          "Luttikhold",
          "Luttikholt",
          "Luttikhuis",
          "Luttikhuizen",
          "Luttje",
          "Luttjeboer",
          "Luttmer",
          "Lutz",
          "Luu",
          "Luursema",
          "Luurtsema",
          "Lux",
          "Luxemburg",
          "Luyckx",
          "Luykx",
          "Luyten",
          "Luz",
          "Ly",
          "Lynch",
          "Löbker",
          "Löhr",
          "Löwenthal",
          "Löwik",
          "Lübbers",
          "Lüschen",
          "Ma",
          "Maagdelijn",
          "Maagdenberg",
          "Maaijen",
          "Maalderink",
          "Maale",
          "Maan",
          "Maandag",
          "Maanen",
          "Maar",
          "Maarel",
          "Maaren",
          "Maarl",
          "Maarleveld",
          "Maarschalkerweerd",
          "Maarse",
          "Maarsen",
          "Maarseveen",
          "Maarsingh",
          "Maartens",
          "Maartense",
          "Maas",
          "Maasakker",
          "Maasakkers",
          "Maasbach",
          "Maasdam",
          "Maasen",
          "Maaskant",
          "Maasland",
          "Maass",
          "Maassen",
          "Maassen van den Brink",
          "Maastricht",
          "Maastrigt",
          "Maaswinkel",
          "Maat",
          "Maaten",
          "Maathuis",
          "Maatje",
          "Maatjes",
          "Maatkamp",
          "Maatman",
          "Maats",
          "Mac Donald",
          "Mac Gillavry",
          "Macco",
          "Machiela",
          "Machiels",
          "Machielse",
          "Machielsen",
          "Mackaaij",
          "Mackaij",
          "Mackay",
          "Mackelenbergh",
          "Mackenbach",
          "Mackloet",
          "Macnack",
          "Madani",
          "Made",
          "Maden",
          "Madern",
          "Madhar",
          "Madlener",
          "Madou",
          "Maduro",
          "Maenen",
          "Maertens",
          "Maes",
          "Maesen",
          "Maessen",
          "Magdalena",
          "Magendans",
          "Mager",
          "Magermans",
          "Magielse",
          "Magielsen",
          "Magnin",
          "Magnée",
          "Magré",
          "Mahabali",
          "Mahabier",
          "Mahabir",
          "Mahadew",
          "Mahamed",
          "Mahangoe",
          "Mahboeb",
          "Mahdad",
          "Mahdaoui",
          "Mahes",
          "Mahieu",
          "Mahler",
          "Mahmood",
          "Mahmoud",
          "Mahn",
          "Mahu",
          "Mai",
          "Maier",
          "Maij",
          "Maijen",
          "Maijenburg",
          "Maijer",
          "Maijers",
          "Maijs",
          "Maikoe",
          "Maine",
          "Maissan",
          "Majid",
          "Majoor",
          "Mak",
          "Makatita",
          "Makhlouf",
          "Makhloufi",
          "Makkelie",
          "Makken",
          "Makker",
          "Makkes",
          "Makkinga",
          "Makkinje",
          "Makkink",
          "Makkus",
          "Maks",
          "Maldegem",
          "Male",
          "Malenstein",
          "Malestein",
          "Mali",
          "Maliepaard",
          "Malik",
          "Malipaard",
          "Maljaars",
          "Maljers",
          "Malki",
          "Mallee",
          "Mallens",
          "Mallo",
          "Malmberg",
          "Malsen",
          "Malssen",
          "Maltha",
          "Mameren",
          "Man",
          "Manakker",
          "Manbodh",
          "Mandema",
          "Mandemaker",
          "Mandemakers",
          "Manders",
          "Mandersloot",
          "Mandigers",
          "Mandjes",
          "Mandos",
          "Manen",
          "Manenschijn",
          "Maneschijn",
          "Mangal",
          "Mangelaars",
          "Mangnus",
          "Mangon",
          "Mangre",
          "Mangroe",
          "Mangroelal",
          "Manintveld",
          "Mank",
          "Mann",
          "Manna",
          "Mannaart",
          "Mannaert",
          "Mannaerts",
          "Mannak",
          "Mannee",
          "Mannens",
          "Mannes",
          "Mannessen",
          "Mannetje",
          "Manni",
          "Manning",
          "Mans",
          "Manschot",
          "Mansens",
          "Manshande",
          "Manshanden",
          "Mansom",
          "Mansour",
          "Mansouri",
          "Mansveld",
          "Mansvelders",
          "Mantel",
          "Manten",
          "Mantingh",
          "Mantje",
          "Mantjes",
          "Manuel",
          "Manuela",
          "Manuhutu",
          "Manuputty",
          "Manusama",
          "Manusiwa",
          "Mar",
          "Maranus",
          "Marbus",
          "Marcelis",
          "Marcelissen",
          "Marcellis",
          "Marchal",
          "Marchand",
          "Marchena",
          "Marck",
          "Marcus",
          "Marcusse",
          "Mare",
          "Marechal",
          "Maree",
          "Marees",
          "Marel",
          "Marell",
          "Maren",
          "Marengo",
          "Mares",
          "Margarita",
          "Marges",
          "Maria",
          "Marijnen",
          "Marijnissen",
          "Marijs",
          "Marijt",
          "Mariman",
          "Maring",
          "Marinissen",
          "Marinus",
          "Marinussen",
          "Marion",
          "Maris",
          "Marissen",
          "Marissink",
          "Mariën",
          "Marić",
          "Mark",
          "Markenstein",
          "Markerink",
          "Markesteijn",
          "Markestein",
          "Markgraaf",
          "Markhorst",
          "Markies",
          "Markink",
          "Marković",
          "Marks",
          "Markslag",
          "Markt",
          "Markus",
          "Markusse",
          "Markvoort",
          "Markwat",
          "Markx",
          "Marle",
          "Marquenie",
          "Marra",
          "Marree",
          "Marrewijk",
          "Marrink",
          "Mars",
          "Marsbergen",
          "Marseille",
          "Marshall",
          "Marskamp",
          "Marsman",
          "Marsé",
          "Marteijn",
          "Marten",
          "Martena",
          "Martens",
          "Martes",
          "Martha",
          "Martherus",
          "Martijn",
          "Martin",
          "Martina",
          "Martinali",
          "Martines",
          "Martinez",
          "Martini",
          "Martins",
          "Martinus",
          "Martis",
          "Marvelde",
          "Marwijk",
          "Marx",
          "Mascini",
          "Maseland",
          "Masmeijer",
          "Massa",
          "Massaar",
          "Massar",
          "Massee",
          "Masseling",
          "Masselink",
          "Massen",
          "Masseurs",
          "Massier",
          "Massing",
          "Massink",
          "Masson",
          "Massop",
          "Massoudi",
          "Massuger",
          "Mast",
          "Mastebroek",
          "Masteling",
          "Mastenbroek",
          "Mastrigt",
          "Mastwijk",
          "Matabadal",
          "Matadin",
          "Matahelumual",
          "Matai",
          "Mateboer",
          "Mateijsen",
          "Mateman",
          "Maten",
          "Matena",
          "Mater",
          "Materman",
          "Maters",
          "Matheeuwsen",
          "Matheij",
          "Mathijsen",
          "Mathijssen",
          "Mathilda",
          "Mathlener",
          "Mathoera",
          "Mathon",
          "Mathot",
          "Matla",
          "Maton",
          "Matse",
          "Matser",
          "Matthee",
          "Mattheij",
          "Matthijs",
          "Matthijsen",
          "Matthijsse",
          "Matthijssen",
          "Mattijssen",
          "Mattu",
          "Matulessy",
          "Matze",
          "Mauer",
          "Maulany",
          "Maurer",
          "Maurik",
          "Mauriks",
          "Maurits",
          "Mauritz",
          "Maurix",
          "Maussen",
          "Max",
          "May",
          "Mayer",
          "Mazee",
          "Mazereeuw",
          "Mazijk",
          "Mazouz",
          "Mazurel",
          "Mebel",
          "Mebius",
          "Mechelen",
          "Mechielsen",
          "Mecking",
          "Mecklenfeld",
          "Meddeler",
          "Meddens",
          "Medema",
          "Medemblik",
          "Medenblik",
          "Medendorp",
          "Medina",
          "Mee",
          "Meeberg",
          "Meedendorp",
          "Meeder",
          "Meegdenburg",
          "Meegdes",
          "Meegen",
          "Meek",
          "Meekel",
          "Meekeren",
          "Meekes",
          "Meekhof",
          "Meel",
          "Meeldijk",
          "Meelker",
          "Meelkop",
          "Meems",
          "Meendering",
          "Meenderink",
          "Meenen",
          "Meeng",
          "Meenhorst",
          "Meenhuis",
          "Meenink",
          "Meens",
          "Meent",
          "Meer",
          "Meerakker",
          "Meerbeek",
          "Meerburg",
          "Meerding",
          "Meerdink",
          "Meere",
          "Meereboer",
          "Meeren",
          "Meerendonk",
          "Meerhof",
          "Meerhoff",
          "Meering",
          "Meerkerk",
          "Meerlo",
          "Meerman",
          "Meersbergen",
          "Meershoek",
          "Meerstra",
          "Meerten",
          "Meertens",
          "Meerts",
          "Meerveld",
          "Meerwijk",
          "Mees",
          "Meesen",
          "Meessen",
          "Meester",
          "Meesters",
          "Meeter",
          "Meeteren",
          "Meetsma",
          "Meeus",
          "Meeuse",
          "Meeusen",
          "Meeuwen",
          "Meeuwenoord",
          "Meeuwesen",
          "Meeuwis",
          "Meeuwisse",
          "Meeuwissen",
          "Meeuwisz",
          "Meeuws",
          "Meeuwse",
          "Meeuwsen",
          "Meevis",
          "Meewis",
          "Meewisse",
          "Meex",
          "Megen",
          "Megens",
          "Meggelen",
          "Mei",
          "Meiberg",
          "Meiboom",
          "Meide",
          "Meiden",
          "Meier",
          "Meihuizen",
          "Meij",
          "Meijaard",
          "Meijberg",
          "Meijboom",
          "Meijburg",
          "Meijdam",
          "Meijde",
          "Meijden",
          "Meijdenberg",
          "Meijel",
          "Meijer",
          "Meijere",
          "Meijeren",
          "Meijerhof",
          "Meijering",
          "Meijeringh",
          "Meijerink",
          "Meijerman",
          "Meijers",
          "Meijgaarden",
          "Meijl",
          "Meijler",
          "Meijlink",
          "Meijn",
          "Meijnders",
          "Meijndert",
          "Meijne",
          "Meijnen",
          "Meijners",
          "Meijs",
          "Meijsen",
          "Meijssen",
          "Meijster",
          "Meijvis",
          "Meijvogel",
          "Meijwaard",
          "Meiland",
          "Meiling",
          "Meilink",
          "Meilof",
          "Meima",
          "Mein",
          "Meinardi",
          "Meinders",
          "Meindersma",
          "Meinderts",
          "Meindertsma",
          "Meinema",
          "Meinen",
          "Meiners",
          "Meines",
          "Meinhardt",
          "Meinsma",
          "Meinster",
          "Meints",
          "Meiracker",
          "Meiring",
          "Meis",
          "Meisen",
          "Meisner",
          "Meissen",
          "Meister",
          "Meisters",
          "Mekel",
          "Mekelenkamp",
          "Mekenkamp",
          "Mekers",
          "Mekes",
          "Mekkelholt",
          "Mekkering",
          "Mekkes",
          "Mekking",
          "Mel",
          "Melaard",
          "Melchers",
          "Melcherts",
          "Melching",
          "Melchior",
          "Melein",
          "Melenhorst",
          "Melessen",
          "Melfor",
          "Melger",
          "Melgers",
          "Melgert",
          "Melick",
          "Melief",
          "Melis",
          "Melissant",
          "Melisse",
          "Melissen",
          "Melk",
          "Melker",
          "Melkert",
          "Melle",
          "Mellegers",
          "Mellema",
          "Mellendijk",
          "Melles",
          "Mellink",
          "Melman",
          "Mels",
          "Melse",
          "Melsen",
          "Melssen",
          "Melzen",
          "Memelink",
          "Mencke",
          "Mendel",
          "Mendes",
          "Mendeszoon",
          "Menge",
          "Mengelers",
          "Menger",
          "Mengerink",
          "Mengers",
          "Menheere",
          "Menick",
          "Menig",
          "Menke",
          "Menkehorst",
          "Menken",
          "Menkhorst",
          "Menkveld",
          "Mennega",
          "Mennema",
          "Mennen",
          "Mennens",
          "Mennes",
          "Menning",
          "Menninga",
          "Mennings",
          "Mennink",
          "Mens",
          "Mensah",
          "Mensch",
          "Mense",
          "Mensen",
          "Menses",
          "Mensing",
          "Mensinga",
          "Mensink",
          "Mensonides",
          "Mensvoort",
          "Menten",
          "Menting",
          "Mentink",
          "Mentjox",
          "Mentzij",
          "Menzo",
          "Meppelink",
          "Mepschen",
          "Merbel",
          "Merbis",
          "Mercan",
          "Mercelina",
          "Mercera",
          "Merckx",
          "Merk",
          "Merkelbach",
          "Merkens",
          "Merkestein",
          "Merkies",
          "Merks",
          "Merkus",
          "Merkx",
          "Merlijn",
          "Mermans",
          "Mermer",
          "Merode",
          "Merrienboer",
          "Mersbergen",
          "Mert",
          "Mertens",
          "Merts",
          "Merwe",
          "Merwijk",
          "Merx",
          "Mes",
          "Mesbahi",
          "Mesken",
          "Mesker",
          "Meskers",
          "Mesman",
          "Messaoudi",
          "Messchaert",
          "Messchendorp",
          "Messelink",
          "Messemaker",
          "Messing",
          "Messink",
          "Mestebeld",
          "Mesters",
          "Mestrom",
          "Mestrum",
          "Mesu",
          "Metaal",
          "Meter",
          "Meteren",
          "Methorst",
          "Metin",
          "Mets",
          "Metselaar",
          "Metsemakers",
          "Metske",
          "Metten",
          "Mettendaf",
          "Metternich",
          "Mettes",
          "Mettler",
          "Metz",
          "Metzelaar",
          "Metzlar",
          "Meuffels",
          "Meuken",
          "Meulblok",
          "Meulder",
          "Meuldijk",
          "Meule",
          "Meuleman",
          "Meulemans",
          "Meulen",
          "Meulenbeek",
          "Meulenbeld",
          "Meulenbelt",
          "Meulenberg",
          "Meulenbroek",
          "Meulenbroeks",
          "Meulendijk",
          "Meulendijks",
          "Meuleners",
          "Meulengraaf",
          "Meulenhof",
          "Meulenkamp",
          "Meulens",
          "Meulensteen",
          "Meulepas",
          "Meulman",
          "Meulmeester",
          "Meulstee",
          "Meun",
          "Meupelenberg",
          "Meurders",
          "Meurer",
          "Meurkens",
          "Meurs",
          "Meursing",
          "Meusen",
          "Meussen",
          "Meuter",
          "Meutstege",
          "Meuwese",
          "Meuwissen",
          "Meuwsen",
          "Meuzelaar",
          "Mevis",
          "Mevissen",
          "Mewe",
          "Mey",
          "Meyer",
          "Meyers",
          "Meys",
          "Meza",
          "Mhassani",
          "Mheen",
          "Michael",
          "Michel",
          "Michels",
          "Michiels",
          "Michielse",
          "Michielsen",
          "Michilsen",
          "Michon",
          "Michorius",
          "Midavaine",
          "Middag",
          "Middel",
          "Middelaar",
          "Middelbeek",
          "Middelberg",
          "Middelbos",
          "Middelburg",
          "Middeldorp",
          "Middelhoek",
          "Middelhof",
          "Middelhoven",
          "Middelhuis",
          "Middelink",
          "Middeljans",
          "Middelkamp",
          "Middelkoop",
          "Middelman",
          "Middelveld",
          "Middelweerd",
          "Midden",
          "Middendorp",
          "Miedema",
          "Mieghem",
          "Mieloo",
          "Mienis",
          "Mientjes",
          "Mieras",
          "Mierden",
          "Mieremet",
          "Mierle",
          "Mierlo",
          "Mierop",
          "Miert",
          "Mies",
          "Miesen",
          "Migchelbrink",
          "Migchels",
          "Migchelsen",
          "Migchielsen",
          "Miggelbrink",
          "Miggels",
          "Miguel",
          "Mijdam",
          "Mijden",
          "Mije",
          "Mijl",
          "Mijland",
          "Mijling",
          "Mijn",
          "Mijnals",
          "Mijnders",
          "Mijnen",
          "Mijnheer",
          "Mijnsbergen",
          "Mijnster",
          "Mijnten",
          "Mijs",
          "Mik",
          "Mikkers",
          "Mil",
          "Milan",
          "Milder",
          "Mildert",
          "Milius",
          "Mill",
          "Millenaar",
          "Miller",
          "Milliano",
          "Milligen",
          "Miltenburg",
          "Mimpen",
          "Min",
          "Minderhoud",
          "Minderhout",
          "Minderman",
          "Mineur",
          "Mingels",
          "Minguel",
          "Minheere",
          "Minjon",
          "Mink",
          "Minke",
          "Minkelis",
          "Minkels",
          "Minkema",
          "Minkenberg",
          "Minkes",
          "Minkhorst",
          "Minkjan",
          "Minkman",
          "Minks",
          "Minnaar",
          "Minnaard",
          "Minneboo",
          "Minnebreuker",
          "Minnee",
          "Minnema",
          "Minnen",
          "Minnes",
          "Minnesma",
          "Minten",
          "Mintjes",
          "Miranda",
          "Mirani",
          "Mirck",
          "Mirza",
          "Misiedjan",
          "Miske",
          "Mispel",
          "Misset",
          "Missler",
          "Mitchell",
          "Mitrović",
          "Mittelmeijer",
          "Mittendorff",
          "Mittertreiner",
          "Mobach",
          "Mobers",
          "Mobron",
          "Mocking",
          "Moddejonge",
          "Modder",
          "Modderkolk",
          "Modderman",
          "Moed",
          "Moedt",
          "Moeijes",
          "Moek",
          "Moeken",
          "Moekotte",
          "Moel",
          "Moelands",
          "Moelchand",
          "Moeliker",
          "Moelker",
          "Moen",
          "Moenen",
          "Moenesar",
          "Moennasing",
          "Moennoe",
          "Moens",
          "Moerbeek",
          "Moerdijk",
          "Moere",
          "Moerenhout",
          "Moergastel",
          "Moerings",
          "Moerkens",
          "Moerkerk",
          "Moerkerke",
          "Moerkerken",
          "Moerland",
          "Moerlie",
          "Moerman",
          "Moers",
          "Moes",
          "Moesbergen",
          "Moesker",
          "Moeskops",
          "Moesman",
          "Moet",
          "Moggré",
          "Mohabir",
          "Mohamad",
          "Mohamed",
          "Mohammad",
          "Mohammadi",
          "Mohammed",
          "Mohamud",
          "Mohan",
          "Mohanlal",
          "Mohnen",
          "Mohr",
          "Moinat",
          "Moison",
          "Mok",
          "Mokhtari",
          "Mokiem",
          "Mokkink",
          "Mokveld",
          "Mol",
          "Molder",
          "Molegraaf",
          "Molema",
          "Moleman",
          "Molen",
          "Molenaar",
          "Molenaars",
          "Molenbeek",
          "Molenberg",
          "Molenbroek",
          "Molendijk",
          "Molengraft",
          "Molenhuis",
          "Molenkamp",
          "Molenmaker",
          "Molenschot",
          "Molenveld",
          "Moleveld",
          "Molewijk",
          "Molhoek",
          "Molier",
          "Molijn",
          "Molin",
          "Molina",
          "Molkenboer",
          "Moll",
          "Molle",
          "Mollee",
          "Mollema",
          "Molleman",
          "Mollemans",
          "Mollen",
          "Mollers",
          "Mollet",
          "Mollink",
          "Molly",
          "Molmans",
          "Molnár",
          "Mols",
          "Molthoff",
          "Moltmaker",
          "Mom",
          "Mombarg",
          "Mommers",
          "Mommersteeg",
          "Mondeel",
          "Monden",
          "Mondria",
          "Monen",
          "Monfils",
          "Mongen",
          "Monhemius",
          "Monkau",
          "Monnink",
          "Monné",
          "Mons",
          "Monsanto",
          "Monshouwer",
          "Monsieurs",
          "Monsma",
          "Monster",
          "Montagne",
          "Montanus",
          "Monte",
          "Monteban",
          "Monteiro",
          "Montenij",
          "Montfoort",
          "Montfort",
          "Montforts",
          "Montijn",
          "Mooi",
          "Mooibroek",
          "Mooij",
          "Mooijekind",
          "Mooijer",
          "Mooijman",
          "Mooiman",
          "Mooiweer",
          "Moojen",
          "Mook",
          "Mookhoek",
          "Mooldijk",
          "Moolen",
          "Moolenaar",
          "Moolenbroek",
          "Moolenschot",
          "Moolhuijsen",
          "Moolhuizen",
          "Moonen",
          "Moons",
          "Moor",
          "Moore",
          "Mooren",
          "Mooring",
          "Moorlag",
          "Moorman",
          "Moormann",
          "Moorrees",
          "Moors",
          "Moorsel",
          "Moorselaar",
          "Moorst",
          "Moort",
          "Moosdijk",
          "Moot",
          "Mooten",
          "Mooy",
          "Moraal",
          "Morabet",
          "Morabit",
          "Morales",
          "Moras",
          "Morauw",
          "Morcus",
          "Mordang",
          "Moree",
          "Morel",
          "Moret",
          "Moritz",
          "Morlog",
          "Mormon",
          "Morren",
          "Morrenhof",
          "Morris",
          "Morriën",
          "Mors",
          "Morsch",
          "Morsche",
          "Morshuis",
          "Morsink",
          "Morskieft",
          "Morsman",
          "Morssink",
          "Morssinkhof",
          "Mortel",
          "Mortier",
          "Morée",
          "Mos",
          "Mosch",
          "Moser",
          "Mosk",
          "Mosmans",
          "Mossel",
          "Mosselaar",
          "Mosselman",
          "Mosseveld",
          "Mossink",
          "Most",
          "Mostard",
          "Mosterd",
          "Mosterdijk",
          "Mosterman",
          "Mostert",
          "Moti",
          "Motman",
          "Mots",
          "Motshagen",
          "Mourabit",
          "Mourik",
          "Mouris",
          "Mourits",
          "Mourmans",
          "Mous",
          "Mousa",
          "Moussa",
          "Moussaoui",
          "Moussaten",
          "Moussati",
          "Mout",
          "Mouthaan",
          "Mouton",
          "Mouw",
          "Mouwen",
          "Mouws",
          "Mozes",
          "Mual",
          "Mud",
          "Mudde",
          "Mugge",
          "Muggen",
          "Muijden",
          "Muijderman",
          "Muijen",
          "Muijlwijk",
          "Muijnck",
          "Muijrers",
          "Muijres",
          "Muijs",
          "Muijsenberg",
          "Muijsers",
          "Muijsson",
          "Muijtjens",
          "Muilenburg",
          "Muilwijk",
          "Muis",
          "Muiser",
          "Muiswinkel",
          "Muit",
          "Muizelaar",
          "Muizer",
          "Mul",
          "Mulckhuijse",
          "Mulder",
          "Mulderij",
          "Mulders",
          "Mulken",
          "Mulkens",
          "Mullekom",
          "Mullem",
          "Mullenders",
          "Mulleneers",
          "Mullens",
          "Muller",
          "Mullers",
          "Mulligen",
          "Mullink",
          "Munck",
          "Munckhof",
          "Mungra",
          "Munier",
          "Munk",
          "Munne",
          "Munnecom",
          "Munneke",
          "Munnichs",
          "Munnik",
          "Munniksma",
          "Muns",
          "Munster",
          "Munsteren",
          "Munsterman",
          "Munsters",
          "Munt",
          "Munten",
          "Muntendam",
          "Munter",
          "Munters",
          "Muntinga",
          "Muntjewerf",
          "Muntjewerff",
          "Muntslag",
          "Muntz",
          "Mur",
          "Muradin",
          "Murat",
          "Mureau",
          "Muris",
          "Murk",
          "Murray",
          "Murre",
          "Mus",
          "Musch",
          "Muskee",
          "Muskens",
          "Mussche",
          "Musscher",
          "Mustafa",
          "Mustamu",
          "Muste",
          "Musters",
          "Mustert",
          "Mutlu",
          "Muts",
          "Mutsaars",
          "Mutsaers",
          "Mutsaerts",
          "Mutsers",
          "Mutter",
          "Muurling",
          "Muurlink",
          "Muurman",
          "Muurmans",
          "Muus",
          "Muusse",
          "Mäkel",
          "Möhlmann",
          "Möller",
          "Möllers",
          "Mönnink",
          "Möring",
          "Müller",
          "Müskens",
          "Naafs",
          "Naaijen",
          "Naaijer",
          "Naaijkens",
          "Naaktgeboren",
          "Naald",
          "Naalden",
          "Naarden",
          "Naarding",
          "Nab",
          "Nabbe",
          "Nabben",
          "Naber",
          "Naberman",
          "Nabi",
          "Nabibaks",
          "Nabuurs",
          "Nachtegaal",
          "Nacken",
          "Nadorp",
          "Nadort",
          "Naessens",
          "Nafzger",
          "Nagel",
          "Nagelhout",
          "Nagelkerke",
          "Nagelkerken",
          "Nagels",
          "Nagesar",
          "Naglé",
          "Nagtegaal",
          "Nagtzaam",
          "Nagy",
          "Nahar",
          "Nahon",
          "Nahuis",
          "Nahumury",
          "Naipal",
          "Naji",
          "Nak",
          "Nakken",
          "Nales",
          "Namen",
          "Nammensma",
          "Nan",
          "Nandpersad",
          "Nanhekhan",
          "Nanhoe",
          "Nankoe",
          "Nanlohy",
          "Nanne",
          "Nannen",
          "Nannes",
          "Nanning",
          "Nanninga",
          "Nannings",
          "Nansink",
          "Nanuru",
          "Nap",
          "Napel",
          "Narain",
          "Nas",
          "Nasri",
          "Nass",
          "Nassau",
          "Nassiri",
          "Nassy",
          "Nat",
          "Natris",
          "Natrop",
          "Nauman",
          "Naumann",
          "Naus",
          "Nauta",
          "Nauts",
          "Navarro",
          "Naves",
          "Navest",
          "Navis",
          "Nawijn",
          "Nazari",
          "Nazir",
          "Nebbeling",
          "Neck",
          "Nederend",
          "Nederhand",
          "Nederhoed",
          "Nederhof",
          "Nederhoff",
          "Nederkoorn",
          "Nederlof",
          "Nederpel",
          "Nederpelt",
          "Nederstigt",
          "Nederveen",
          "Neef",
          "Neefjes",
          "Neefs",
          "Neeft",
          "Neele",
          "Neeleman",
          "Neelen",
          "Neelis",
          "Neels",
          "Neer",
          "Neerbos",
          "Neerhof",
          "Neerings",
          "Neerven",
          "Neervoort",
          "Neeskens",
          "Neeteson",
          "Nefkens",
          "Nefs",
          "Negenman",
          "Neggers",
          "Neijenhuis",
          "Neijman",
          "Neijmeijer",
          "Neijndorff",
          "Neijnens",
          "Neijs",
          "Neijssen",
          "Neijts",
          "Neijzen",
          "Nek",
          "Nekeman",
          "Nekker",
          "Nekkers",
          "Nel",
          "Neleman",
          "Nelemans",
          "Nelen",
          "Nelis",
          "Nelisse",
          "Nelissen",
          "Nell",
          "Nellen",
          "Nellestijn",
          "Nellissen",
          "Nelom",
          "Nelson",
          "Nelstein",
          "Nendels",
          "Nengerman",
          "Nennie",
          "Nentjes",
          "Neppelenbroek",
          "Nes",
          "Neslo",
          "Nesselaar",
          "Net",
          "Netjes",
          "Nettekoven",
          "Netten",
          "Neuhaus",
          "Neuman",
          "Neumann",
          "Neurink",
          "Neus",
          "Neut",
          "Neuteboom",
          "Neutel",
          "Neutelings",
          "Neutkens",
          "Neuvel",
          "Neve",
          "Nevels",
          "Neven",
          "Neves",
          "Ng",
          "Ngo",
          "Nguyen",
          "Niamat",
          "Niamut",
          "Nibbeling",
          "Nibbelink",
          "Nibbering",
          "Nibourg",
          "Nicola",
          "Nicolaas",
          "Nicolaes",
          "Nicolai",
          "Nicolaij",
          "Nicolasen",
          "Nicolaï",
          "Nie",
          "Niebeek",
          "Nieberg",
          "Nieboer",
          "Nieborg",
          "Niehof",
          "Niehoff",
          "Niekamp",
          "Niekerk",
          "Niekoop",
          "Niekus",
          "Niel",
          "Nieland",
          "Nielen",
          "Nieling",
          "Niels",
          "Nielsen",
          "Nieman",
          "Niemans",
          "Niemantsverdriet",
          "Niemarkt",
          "Niemeijer",
          "Nienhuis",
          "Nienkemper",
          "Niens",
          "Nierop",
          "Niers",
          "Nies",
          "Niesen",
          "Niesing",
          "Niesink",
          "Nieskens",
          "Niessen",
          "Niessink",
          "Nieste",
          "Niesten",
          "Nieswaag",
          "Niet",
          "Nietveld",
          "Nieuwaal",
          "Nieuwamerongen",
          "Nieuwboer",
          "Nieuwburg",
          "Nieuwdorp",
          "Nieuweboer",
          "Nieuwegiessen",
          "Nieuwelink",
          "Nieuwenbroek",
          "Nieuwenburg",
          "Nieuwendijk",
          "Nieuwenhof",
          "Nieuwenhout",
          "Nieuwenhoven",
          "Nieuwenhuijs",
          "Nieuwenhuijse",
          "Nieuwenhuijsen",
          "Nieuwenhuijze",
          "Nieuwenhuijzen",
          "Nieuwenhuis",
          "Nieuwenhuisen",
          "Nieuwenhuize",
          "Nieuwenhuizen",
          "Nieuwenkamp",
          "Nieuwenweg",
          "Nieuwerth",
          "Nieuwesteeg",
          "Nieuwhof",
          "Nieuwhoff",
          "Nieuwkamp",
          "Nieuwkerk",
          "Nieuwkoop",
          "Nieuwlaat",
          "Nieuwland",
          "Nieuwmeijer",
          "Nieuwold",
          "Nieuwpoort",
          "Nieuwstad",
          "Nieuwstraten",
          "Nieuwveld",
          "Nievaart",
          "Nieveen",
          "Nievelstein",
          "Nieweg",
          "Niewold",
          "Niezen",
          "Niezing",
          "Niezink",
          "Nifterik",
          "Niftrik",
          "Nihot",
          "Nijboer",
          "Nijborg",
          "Nijbroek",
          "Nijburg",
          "Nijdam",
          "Nijdeken",
          "Nijeboer",
          "Nijen",
          "Nijen Twilhaar",
          "Nijenbanning",
          "Nijenhuis",
          "Nijenkamp",
          "Nijgh",
          "Nijhof",
          "Nijhoff",
          "Nijholt",
          "Nijhove",
          "Nijhuis",
          "Nijk",
          "Nijkamp",
          "Nijland",
          "Nijlant",
          "Nijman",
          "Nijmeijer",
          "Nijnatten",
          "Nijnens",
          "Nijnuis",
          "Nijp",
          "Nijpels",
          "Nijs",
          "Nijsen",
          "Nijsingh",
          "Nijsink",
          "Nijskens",
          "Nijsse",
          "Nijssen",
          "Nijst",
          "Nijstad",
          "Nijsten",
          "Nijveen",
          "Nijveld",
          "Nijzink",
          "Nikkelen",
          "Nikkels",
          "Nikken",
          "Nikolić",
          "Niks",
          "Nillesen",
          "Nillessen",
          "Nimwegen",
          "Ninaber",
          "Nipius",
          "Nispen",
          "Nissen",
          "Nissink",
          "Nistelrooij",
          "Nitert",
          "Nitrauw",
          "Nix",
          "Noach",
          "Nobbe",
          "Nobbenhuis",
          "Nobel",
          "Nobelen",
          "Nobels",
          "Noble",
          "Noest",
          "Noeverman",
          "Nohar",
          "Noij",
          "Noija",
          "Noije",
          "Noijen",
          "Noijons",
          "Nol",
          "Nolden",
          "Noldus",
          "Nolen",
          "Nolet",
          "Noll",
          "Nolle",
          "Nollen",
          "Nolles",
          "Nollet",
          "Nolte",
          "Nolten",
          "Noltes",
          "Nolting",
          "Nomden",
          "Nomen",
          "Nonkes",
          "Nonnekes",
          "Nood",
          "Nooij",
          "Nooijen",
          "Nooijens",
          "Nooijer",
          "Nooitgedagt",
          "Nooitmeer",
          "Noom",
          "Noomen",
          "Noor",
          "Noord",
          "Noorda",
          "Noordaa",
          "Noordam",
          "Noordanus",
          "Noordegraaf",
          "Noordeloos",
          "Noorden",
          "Noordenbos",
          "Noordenburg",
          "Noordende",
          "Noordenne",
          "Noordennen",
          "Noordergraaf",
          "Noordermeer",
          "Noordervliet",
          "Noordhoek",
          "Noordhof",
          "Noordhoff",
          "Noordhuis",
          "Noordhuizen",
          "Noordijk",
          "Noordink",
          "Noordkamp",
          "Noordman",
          "Noordmans",
          "Noordover",
          "Noordsij",
          "Noordt",
          "Noordzij",
          "Nooren",
          "Noori",
          "Noorland",
          "Noorlander",
          "Noorloos",
          "Noorman",
          "Noort",
          "Noorthoek",
          "Noortman",
          "Noortwijk",
          "Noot",
          "Nooteboom",
          "Nootebos",
          "Nooten",
          "Nootenboom",
          "Nooter",
          "Noppe",
          "Noppen",
          "Noppers",
          "Noppert",
          "Norbart",
          "Norbruis",
          "Norde",
          "Norden",
          "Norder",
          "Nordkamp",
          "Norel",
          "Norg",
          "Norren",
          "Nortier",
          "Nossent",
          "Nota",
          "Notebaart",
          "Noteboom",
          "Noteborn",
          "Noten",
          "Notenboom",
          "Notermans",
          "Notkamp",
          "Nottelman",
          "Notten",
          "Notté",
          "Nouland",
          "Nouri",
          "Nouris",
          "Nous",
          "Nout",
          "Nouweland",
          "Nouwen",
          "Nouwens",
          "Nouwland",
          "Nouws",
          "Nowak",
          "Nowee",
          "Noya",
          "Noë",
          "Nuchelmans",
          "Nuenen",
          "Nuesink",
          "Nugter",
          "Nugteren",
          "Nuij",
          "Nuijen",
          "Nuijens",
          "Nuijten",
          "Nuijts",
          "Nuil",
          "Nuis",
          "Nuiten",
          "Nuland",
          "Nulkes",
          "Numan",
          "Nummerdor",
          "Nunen",
          "Nunes",
          "Nuninga",
          "Nunnink",
          "Nunspeet",
          "Nunumete",
          "Nur",
          "Nurmohamed",
          "Nus",
          "Nusselder",
          "Nussy",
          "Nutbeij",
          "Nutma",
          "Nuus",
          "Nuvelstijn",
          "Németh",
          "Obbens",
          "Obbes",
          "Obbink",
          "Obdam",
          "Obdeijn",
          "Ober",
          "Oberink",
          "Oberman",
          "Obers",
          "Obispo",
          "Ocak",
          "Och",
          "Ochten",
          "Ockeloen",
          "Ockenburg",
          "Ockers",
          "Ockhuijsen",
          "Ockhuizen",
          "Odding",
          "Odekerken",
          "Odijk",
          "Odinga",
          "Odink",
          "Oeben",
          "Oechies",
          "Oedai",
          "Oedairadjsingh",
          "Oedayrajsingh Varma",
          "Oeffel",
          "Oeffelen",
          "Oegema",
          "Oehlers",
          "Oei",
          "Oel",
          "Oele",
          "Oelen",
          "Oemar",
          "Oemraw",
          "Oemrawsingh",
          "Oene",
          "Oenema",
          "Oenen",
          "Oerle",
          "Oerlemans",
          "Oers",
          "Oest",
          "Oesterholt",
          "Oetelaar",
          "Oevelen",
          "Oever",
          "Oeveren",
          "Oevering",
          "Oey",
          "Offenberg",
          "Offerein",
          "Offereins",
          "Offeren",
          "Offerhaus",
          "Offeringa",
          "Offerman",
          "Offermanns",
          "Offermans",
          "Offers",
          "Offringa",
          "Ofman",
          "Ofwegen",
          "Ogier",
          "Ogink",
          "Ogtrop",
          "Ohm",
          "Oijen",
          "Oirschot",
          "Ojen",
          "Ojik",
          "Okhuijsen",
          "Okkema",
          "Okken",
          "Okker",
          "Okkerman",
          "Okkerse",
          "Okur",
          "Olde",
          "Olde Bijvank",
          "Olde Daalhuis",
          "Olde Dubbelink",
          "Olde Kalter",
          "Olde Keizer",
          "Olde Olthof",
          "Olde Riekerink",
          "Olde Scholtenhuis",
          "Oldekamp",
          "Oldeman",
          "Olden",
          "Oldenbeuving",
          "Oldenboom",
          "Oldenbroek",
          "Oldenburg",
          "Oldenburger",
          "Oldengarm",
          "Oldenhave",
          "Oldenhof",
          "Oldenhuis",
          "Oldeniel",
          "Oldenkamp",
          "Oldenkotte",
          "Oldenmenger",
          "Oldenziel",
          "Olderen",
          "Olders",
          "Oldersma",
          "Olfers",
          "Olffen",
          "Olgers",
          "Olgun",
          "Olie",
          "Olieberg",
          "Olieman",
          "Oliemans",
          "Oliemeulen",
          "Olierook",
          "Olieslagers",
          "Oligschläger",
          "Olij",
          "Olijerhoek",
          "Olijfveld",
          "Olijhoek",
          "Olijslager",
          "Olijslagers",
          "Olijve",
          "Olinga",
          "Olink",
          "Olislagers",
          "Oliveira",
          "Olivieira",
          "Olivier",
          "Olofsen",
          "Olphen",
          "Olree",
          "Olsder",
          "Olsman",
          "Olst",
          "Olsthoorn",
          "Olthof",
          "Olthoff",
          "Olthuis",
          "Oltmans",
          "Omar",
          "Omer",
          "Omerović",
          "Omlo",
          "Omme",
          "Ommen",
          "Ommeren",
          "Ommering",
          "Omtzigt",
          "Omvlee",
          "Onck",
          "Onclin",
          "Onderdelinden",
          "Onderdijk",
          "Onderstal",
          "Onderwater",
          "Onderweegs",
          "Ong",
          "Onink",
          "Onkenhout",
          "Onland",
          "Onna",
          "Onnes",
          "Onnink",
          "Onos",
          "Onrust",
          "Onselen",
          "Onstein",
          "Onstenk",
          "Onstwedder",
          "Onvlee",
          "Onwezen",
          "Onzen",
          "Onzenoort",
          "Ooft",
          "Ooij",
          "Ooijen",
          "Ooijevaar",
          "Ooijman",
          "Ooink",
          "Ool",
          "Oolbekkink",
          "Oolders",
          "Oome",
          "Oomen",
          "Oomens",
          "Oomes",
          "Oomkens",
          "Oomkes",
          "Ooms",
          "Oonincx",
          "Oonk",
          "Oor",
          "Oorbeek",
          "Oorburg",
          "Oord",
          "Oordt",
          "Oors",
          "Oorschot",
          "Oorsouw",
          "Oorspronk",
          "Oort",
          "Oortgiesen",
          "Oorthuis",
          "Oortman",
          "Oortmerssen",
          "Oortwijn",
          "Oosenbrug",
          "Oossanen",
          "Oosse",
          "Oost",
          "Oostdam",
          "Oostdijk",
          "Oostelbos",
          "Oosten",
          "Oostenbrink",
          "Oostenbrug",
          "Oostenbrugge",
          "Oostende",
          "Oostendorp",
          "Oostenrijk",
          "Oostenveld",
          "Oosterbaan",
          "Oosterbeek",
          "Oosterbos",
          "Oosterbosch",
          "Oosterbroek",
          "Oosterdijk",
          "Oosteren",
          "Oosterhaven",
          "Oosterheert",
          "Oosterhof",
          "Oosterhoff",
          "Oosterholt",
          "Oosterhout",
          "Oosterhuis",
          "Oosterik",
          "Oosterink",
          "Oosterkamp",
          "Oosterlaar",
          "Oosterlaken",
          "Oosterlee",
          "Oosterling",
          "Oosterloo",
          "Oosterman",
          "Oostermeijer",
          "Oosterom",
          "Oosters",
          "Oosterum",
          "Oosterveen",
          "Oosterveer",
          "Oosterveld",
          "Oosterwaal",
          "Oosterwegel",
          "Oosterwijk",
          "Oosterwolde",
          "Oosthoek",
          "Oosthof",
          "Oosthuizen",
          "Oostindie",
          "Oostindiën",
          "Oosting",
          "Oostinga",
          "Oostingh",
          "Oostland",
          "Oostlander",
          "Oostmeijer",
          "Oostra",
          "Oostrom",
          "Oostrum",
          "Oostveen",
          "Oostvogels",
          "Oostwaard",
          "Oostwal",
          "Oostwoud",
          "Oostwouder",
          "Ooteman",
          "Ootes",
          "Ootjers",
          "Ooyen",
          "Opbergen",
          "Opbroek",
          "Opdam",
          "Opdorp",
          "Openneer",
          "Opgenoort",
          "Opheij",
          "Ophelders",
          "Ophem",
          "Ophof",
          "Ophoff",
          "Ophorst",
          "Ophoven",
          "Ophuis",
          "Ophuizen",
          "Opijnen",
          "Oplaat",
          "Opmeer",
          "Opoku",
          "Oppedijk",
          "Oppelaar",
          "Oppen",
          "Oppeneer",
          "Oppenhuizen",
          "Opperman",
          "Oppers",
          "Oppewal",
          "Oprel",
          "Oprins",
          "Opschoor",
          "Opstal",
          "Opsteegh",
          "Opzeeland",
          "Oral",
          "Oranje",
          "Orbons",
          "Ordelman",
          "Ordelmans",
          "Orden",
          "Oreel",
          "Oremus",
          "Orgers",
          "Orhan",
          "Ori",
          "Orie",
          "Orij",
          "Orman",
          "Ormel",
          "Orriëns",
          "Orsel",
          "Orsouw",
          "Ortega",
          "Ortela",
          "Orth",
          "Ortmans",
          "Oruç",
          "Os",
          "Osch",
          "Osei",
          "Osenbruggen",
          "Osendarp",
          "Osenga",
          "Osinga",
          "Oskam",
          "Oskamp",
          "Osman",
          "Osmani",
          "Osnabrugge",
          "Oss",
          "Osse",
          "Osseforth",
          "Ossel",
          "Ossenblok",
          "Ossenbruggen",
          "Ossendrijver",
          "Ossevoort",
          "Ossewaarde",
          "Osseweijer",
          "Ost",
          "Osta",
          "Ostaden",
          "Ostaijen",
          "Ostendorf",
          "Ostermann",
          "Oterdoom",
          "Otermans",
          "Otjens",
          "Otmani",
          "Ots",
          "Otsen",
          "Ott",
          "Otte",
          "Ottema",
          "Otten",
          "Ottenheijm",
          "Ottenheim",
          "Ottenhof",
          "Ottenhoff",
          "Ottens",
          "Ottenschot",
          "Otter",
          "Otterdijk",
          "Otterlo",
          "Otterloo",
          "Otterspeer",
          "Ottervanger",
          "Ottes",
          "Ottevanger",
          "Otting",
          "Ottink",
          "Ottjes",
          "Otto",
          "Ouaali",
          "Ouahabi",
          "Ouakili",
          "Ouali",
          "Ouardi",
          "Ouasghiri",
          "Ouborg",
          "Ouchan",
          "Ouchen",
          "Ouchene",
          "Oud",
          "Oudakker",
          "Oudbier",
          "Oude",
          "Oude Alink",
          "Oude Avenhuis",
          "Oude Booijink",
          "Oude Breuil",
          "Oude Egberink",
          "Oude Elferink",
          "Oude Engberink",
          "Oude Geerdink",
          "Oude Kotte",
          "Oude Lansink",
          "Oude Lenferink",
          "Oude Luttikhuis",
          "Oude Nijeweme",
          "Oude Nijhuis",
          "Oude Ophuis",
          "Oude Veldhuis",
          "Oude Voshaar",
          "Oude Vrielink",
          "Oude Weernink",
          "Oude Wesselink",
          "Oude Wolbers",
          "Oudega",
          "Oudejans",
          "Oudekerk",
          "Oudelaar",
          "Oudeman",
          "Ouden",
          "Oudenaarde",
          "Oudenaarden",
          "Oudenalder",
          "Oudenallen",
          "Oudenampsen",
          "Oudenaren",
          "Oudendijk",
          "Oudendorp",
          "Oudenes",
          "Oudenhoven",
          "Oudenrijn",
          "Ouderdorp",
          "Oudesluijs",
          "Oudheusden",
          "Oudhof",
          "Oudhoff",
          "Oudhuis",
          "Oudijk",
          "Oudijn",
          "Oudkerk",
          "Oudman",
          "Oudsen",
          "Oudshoorn",
          "Oudsten",
          "Oudt",
          "Oudwater",
          "Ousrouti",
          "Oussoren",
          "Out",
          "Outenaar",
          "Outer",
          "Outheusden",
          "Outhuijse",
          "Outshoorn",
          "Ouwehand",
          "Ouwejan",
          "Ouweland",
          "Ouwendijk",
          "Ouweneel",
          "Ouwens",
          "Ouwerkerk",
          "Ouwerling",
          "Ouwersloot",
          "Ovaa",
          "Oven",
          "Over",
          "Overbeek",
          "Overbeeke",
          "Overberg",
          "Overboom",
          "Overbosch",
          "Overdam",
          "Overdevest",
          "Overdiep",
          "Overdijk",
          "Overdijkink",
          "Overduijn",
          "Overduin",
          "Overdulve",
          "Overeem",
          "Overes",
          "Overgaag",
          "Overgaauw",
          "Overgoor",
          "Overhand",
          "Overheul",
          "Overink",
          "Overkamp",
          "Overkleeft",
          "Overloop",
          "Overmaat",
          "Overman",
          "Overmans",
          "Overmars",
          "Overmeen",
          "Overmeer",
          "Overmeeren",
          "Oversier",
          "Oversluizen",
          "Oversteeg",
          "Oversteegen",
          "Overtoom",
          "Overveld",
          "Overvelde",
          "Overvest",
          "Overvliet",
          "Overvoorde",
          "Overwater",
          "Overweel",
          "Overweg",
          "Overwijk",
          "Overzet",
          "Oving",
          "Owusu",
          "Oyen",
          "Ozinga",
          "Ozir",
          "Oğuz",
          "Paal",
          "Paalman",
          "Paalvast",
          "Paanakker",
          "Paans",
          "Paap",
          "Paape",
          "Paardekam",
          "Paardekooper",
          "Paardenkooper",
          "Paarhuis",
          "Paarlberg",
          "Paas",
          "Paashuis",
          "Paasman",
          "Paassen",
          "Paats",
          "Paauw",
          "Paauwe",
          "Packbier",
          "Pad",
          "Padberg",
          "Padding",
          "Padje",
          "Padmos",
          "Padt",
          "Paepe",
          "Paes",
          "Paesch",
          "Paffen",
          "Pagie",
          "Pagter",
          "Pahladsingh",
          "Paijens",
          "Paijmans",
          "Pak",
          "Pakes",
          "Pakkert",
          "Pakvis",
          "Pal",
          "Pala",
          "Palen",
          "Palijama",
          "Palinckx",
          "Paling",
          "Pallada",
          "Palland",
          "Palm",
          "Palma",
          "Palmen",
          "Palmer",
          "Pals",
          "Palsgraaf",
          "Palsma",
          "Palstra",
          "Palte",
          "Palts",
          "Paludanus",
          "Pama",
          "Pamelen",
          "Pampiermole",
          "Pan",
          "Panchoe",
          "Pancras",
          "Panday",
          "Pander",
          "Pang",
          "Panhuijsen",
          "Panhuijzen",
          "Panhuis",
          "Panis",
          "Panjer",
          "Panka",
          "Panken",
          "Pankow",
          "Pankras",
          "Panman",
          "Panne",
          "Panneflek",
          "Pannekeet",
          "Pannekoek",
          "Panneman",
          "Pannen",
          "Pansier",
          "Pansters",
          "Pap",
          "Papa",
          "Papavoine",
          "Pape",
          "Papen",
          "Papenborg",
          "Papenburg",
          "Papilaja",
          "Paping",
          "Pappers",
          "Pappot",
          "Parag",
          "Paragh",
          "Pardijs",
          "Pardoel",
          "Pardoen",
          "Pardon",
          "Parent",
          "Paridaans",
          "Paridon",
          "Parijs",
          "Parinussa",
          "Paris",
          "Parisius",
          "Park",
          "Parker",
          "Parlak",
          "Parlevliet",
          "Parmentier",
          "Parmessar",
          "Parren",
          "Pars",
          "Partouns",
          "Pas",
          "Pasch",
          "Paschedag",
          "Pashouwers",
          "Paske",
          "Pasker",
          "Pasma",
          "Pasman",
          "Pasmans",
          "Pasop",
          "Passage",
          "Passchier",
          "Passenier",
          "Passier",
          "Passon",
          "Pasterkamp",
          "Pasteuning",
          "Pastoor",
          "Pastoors",
          "Pastor",
          "Pasveer",
          "Pat",
          "Pater",
          "Paternotte",
          "Paters",
          "Pathuis",
          "Patijn",
          "Patist",
          "Patje",
          "Pattiasina",
          "Pattikawa",
          "Pattinama",
          "Pattipeilohy",
          "Pattiwael",
          "Patty",
          "Pattynama",
          "Pau",
          "Paul",
          "Paula",
          "Pauli",
          "Paulides",
          "Paulina",
          "Paulis",
          "Paulissen",
          "Paulssen",
          "Paulus",
          "Paulusma",
          "Paulusse",
          "Paulussen",
          "Pauly",
          "Paumen",
          "Pauptit",
          "Paus",
          "Pauw",
          "Pauwels",
          "Paverd",
          "Pavert",
          "Pavlović",
          "Pawiroredjo",
          "Pebesma",
          "Pechler",
          "Pecht",
          "Peddemors",
          "Pedro",
          "Pee",
          "Peek",
          "Peeks",
          "Peekstok",
          "Peele",
          "Peelen",
          "Peels",
          "Peeman",
          "Peemen",
          "Peene",
          "Peer",
          "Peerboom",
          "Peerbooms",
          "Peerdeman",
          "Peereboom",
          "Peerenboom",
          "Peerlings",
          "Peersman",
          "Pees",
          "Peet",
          "Peeters",
          "Peeters Weem",
          "Peetoom",
          "Peffer",
          "Pegels",
          "Pegge",
          "Pehlivan",
          "Peijen",
          "Peijl",
          "Peijnenburg",
          "Peijper",
          "Peijs",
          "Peinder",
          "Pekaar",
          "Pekel",
          "Pekelharing",
          "Peker",
          "Pekkeriet",
          "Pel",
          "Pelders",
          "Pelger",
          "Pelgrim",
          "Pelgrom",
          "Pelgrum",
          "Pelgröm",
          "Pelk",
          "Pelkman",
          "Pelkmans",
          "Pelle",
          "Pelleboer",
          "Pellegrom",
          "Pellemans",
          "Pellen",
          "Pellicaan",
          "Pellikaan",
          "Pellis",
          "Pels",
          "Pelser",
          "Pelsma",
          "Pelt",
          "Peltenburg",
          "Peltzer",
          "Pelupessy",
          "Pelzer",
          "Pelzers",
          "Pen",
          "Pender",
          "Penders",
          "Pengel",
          "Pennekamp",
          "Pennen",
          "Penners",
          "Pennewaard",
          "Penning",
          "Penninga",
          "Pennings",
          "Penninkhof",
          "Penninx",
          "Pennock",
          "Penris",
          "Penterman",
          "Pepels",
          "Peper",
          "Peperkamp",
          "Pepers",
          "Peperstraten",
          "Peperzak",
          "Peppel",
          "Peppelman",
          "Pepping",
          "Pepplinkhuizen",
          "Pera",
          "Perdaems",
          "Perdijk",
          "Perdok",
          "Perdon",
          "Pereboom",
          "Pereira",
          "Perez",
          "Perfors",
          "Perik",
          "Perk",
          "Perlo",
          "Pernot",
          "Pero",
          "Peroti",
          "Perquin",
          "Pers",
          "Persad",
          "Persijn",
          "Persoon",
          "Persoons",
          "Pertijs",
          "Perton",
          "Pesch",
          "Peschier",
          "Peskens",
          "Pesman",
          "Pessers",
          "Pestman",
          "Pesulima",
          "Pet",
          "Petalo",
          "Petegem",
          "Peter",
          "Peterman",
          "Peters",
          "Peterse",
          "Petersen",
          "Peterson",
          "Petiet",
          "Petit",
          "Petra",
          "Petri",
          "Petronilia",
          "Petrović",
          "Petrus",
          "Petrusma",
          "Petten",
          "Petter",
          "Petterson",
          "Pettinga",
          "Peulen",
          "Peursem",
          "Peusens",
          "Peute",
          "Peuter",
          "Peverelli",
          "Pex",
          "Pfaff",
          "Pfeifer",
          "Pfeiffer",
          "Pfennings",
          "Phaff",
          "Phagoe",
          "Pham",
          "Phan",
          "Pherai",
          "Phielix",
          "Philip",
          "Philipoom",
          "Philippa",
          "Philippart",
          "Philippen",
          "Philippens",
          "Philippi",
          "Philippo",
          "Philippus",
          "Philips",
          "Philipse",
          "Philipsen",
          "Phoelich",
          "Picavet",
          "Pichel",
          "Pickkers",
          "Pico",
          "Pieck",
          "Pieffers",
          "Piek",
          "Piekartz",
          "Pieksma",
          "Pielaat",
          "Pielage",
          "Piels",
          "Pieneman",
          "Piening",
          "Pieper",
          "Piepers",
          "Pieplenbosch",
          "Pierau",
          "Pieren",
          "Pierik",
          "Piers",
          "Piersma",
          "Pierweijer",
          "Piest",
          "Piet",
          "Pietens",
          "Pieter",
          "Pieterman",
          "Pieternella",
          "Pieters",
          "Pieterse",
          "Pietersen",
          "Pietersma",
          "Pieterson",
          "Pietersz",
          "Pietjouw",
          "Piets",
          "Pigge",
          "Piggelen",
          "Pigmans",
          "Pijcke",
          "Pijfers",
          "Pijffers",
          "Pijkeren",
          "Pijl",
          "Pijll",
          "Pijlman",
          "Pijls",
          "Pijnacker",
          "Pijnaker",
          "Pijnappel",
          "Pijnappels",
          "Pijnen",
          "Pijnenborg",
          "Pijnenburg",
          "Pijpelink",
          "Pijper",
          "Pijpers",
          "Pijpker",
          "Pijpstra",
          "Pijs",
          "Pik",
          "Pikaar",
          "Piket",
          "Pikkemaat",
          "Pil",
          "Pilat",
          "Pilkes",
          "Pille",
          "Pillen",
          "Pilon",
          "Pin",
          "Pina",
          "Pinar",
          "Pinas",
          "Pince van der Aa",
          "Pinckaers",
          "Pinckers",
          "Pinedo",
          "Pingen",
          "Pinkse",
          "Pinkster",
          "Pino",
          "Pinto",
          "Pinxt",
          "Pinxten",
          "Pinxteren",
          "Pippel",
          "Pipping",
          "Piqué",
          "Pires",
          "Pirovano",
          "Pisa",
          "Pisano",
          "Piso",
          "Pisters",
          "Pistoor",
          "Pistorius",
          "Pit",
          "Piters",
          "Pitlo",
          "Pitstra",
          "Pittens",
          "Plaat",
          "Plaats",
          "Plaatsman",
          "Pladdet",
          "Plagge",
          "Plaggenborg",
          "Plaggenmarsch",
          "Plaisier",
          "Plaizier",
          "Plak",
          "Plakke",
          "Plandsoen",
          "Planje",
          "Planjer",
          "Plank",
          "Planken",
          "Plant",
          "Plantenga",
          "Planting",
          "Plantinga",
          "Plas",
          "Plasman",
          "Plasmans",
          "Plasmeijer",
          "Plass",
          "Plasschaert",
          "Plasse",
          "Plat",
          "Plate",
          "Platen",
          "Platenburg",
          "Platenkamp",
          "Plateringen",
          "Platje",
          "Platjouw",
          "Platschorre",
          "Platte",
          "Platteel",
          "Platteeuw",
          "Plattel",
          "Platvoet",
          "Plazier",
          "Plegt",
          "Pleij",
          "Pleijsier",
          "Pleijte",
          "Plein",
          "Pleiter",
          "Pleizier",
          "Plekkenpol",
          "Plekker",
          "Plender",
          "Plenter",
          "Plessius",
          "Plet",
          "Plette",
          "Pleumeekers",
          "Pleune",
          "Pleunis",
          "Plevier",
          "Plieger",
          "Pligt",
          "Plijter",
          "Ploeg",
          "Ploegaert",
          "Ploeger",
          "Ploegmakers",
          "Ploegman",
          "Ploegstra",
          "Ploem",
          "Ploemen",
          "Plokker",
          "Plomp",
          "Plompen",
          "Plooij",
          "Plooijer",
          "Ploos van Amstel",
          "Ploum",
          "Ploumen",
          "Plu",
          "Plug",
          "Plugers",
          "Plugge",
          "Pluijgers",
          "Pluijm",
          "Pluijmaekers",
          "Pluijmakers",
          "Pluijmen",
          "Pluijmers",
          "Pluijmert",
          "Pluim",
          "Pluimers",
          "Pluis",
          "Pluister",
          "Pluk",
          "Plukker",
          "Plum",
          "Pluuren",
          "Pluut",
          "Pluym",
          "Pluymaekers",
          "Pocorni",
          "Podt",
          "Poecke",
          "Poede",
          "Poeder",
          "Poel",
          "Poelarends",
          "Poelen",
          "Poelgeest",
          "Poelje",
          "Poell",
          "Poelma",
          "Poelman",
          "Poelmann",
          "Poelmans",
          "Poels",
          "Poelsma",
          "Poelstra",
          "Poelwijk",
          "Poen",
          "Poepjes",
          "Poeran",
          "Poeste",
          "Poeth",
          "Poeze",
          "Poffers",
          "Poiesz",
          "Poirters",
          "Poker",
          "Pol",
          "Polak",
          "Poland",
          "Polane",
          "Polanen",
          "Polanen Petel",
          "Polat",
          "Polder",
          "Polderdijk",
          "Polderman",
          "Poldermans",
          "Poldervaart",
          "Poleij",
          "Polen",
          "Polet",
          "Polfliet",
          "Polhout",
          "Polhuis",
          "Polinder",
          "Politiek",
          "Poll",
          "Pollaert",
          "Pollemans",
          "Polling",
          "Pollmann",
          "Pollé",
          "Polman",
          "Pols",
          "Polstra",
          "Pomeren",
          "Pommerel",
          "Pommeren",
          "Pomp",
          "Pompe",
          "Pompen",
          "Pomper",
          "Pompert",
          "Pompstra",
          "Pomstra",
          "Pon",
          "Pongers",
          "Ponjee",
          "Ponne",
          "Pons",
          "Ponse",
          "Ponsen",
          "Ponsioen",
          "Ponsteen",
          "Ponstein",
          "Pont",
          "Ponte",
          "Pontier",
          "Pool",
          "Poolen",
          "Poolman",
          "Poon",
          "Poort",
          "Poorte",
          "Poorten",
          "Poorter",
          "Poorterman",
          "Poorthuis",
          "Poortinga",
          "Poortman",
          "Poorts",
          "Poortvliet",
          "Poos",
          "Poot",
          "Pooter",
          "Pooters",
          "Pootjes",
          "Poots",
          "Pop",
          "Popal",
          "Popelier",
          "Popering",
          "Popkema",
          "Popken",
          "Popma",
          "Popović",
          "Poppe",
          "Poppel",
          "Poppelaars",
          "Poppelen",
          "Poppelier",
          "Poppeliers",
          "Poppema",
          "Poppen",
          "Poppes",
          "Popping",
          "Poppinga",
          "Popta",
          "Por",
          "Pors",
          "Porsius",
          "Port",
          "Porte",
          "Portegies",
          "Portegijs",
          "Portengen",
          "Portier",
          "Pos",
          "Posch",
          "Posma",
          "Posno",
          "Possemis",
          "Post",
          "Postel",
          "Postelmans",
          "Postema",
          "Posthoorn",
          "Posthouwer",
          "Posthuma",
          "Posthumus",
          "Postma",
          "Postmus",
          "Postulart",
          "Postuma",
          "Pot",
          "Potappel",
          "Potgieter",
          "Poth",
          "Potharst",
          "Pothof",
          "Pothoff",
          "Pothoven",
          "Pothuizen",
          "Potijk",
          "Potjer",
          "Potjes",
          "Potkamp",
          "Potma",
          "Potman",
          "Pots",
          "Pott",
          "Potter",
          "Potters",
          "Potuijt",
          "Potze",
          "Pouderoijen",
          "Poulina",
          "Poulisse",
          "Poulissen",
          "Pouls",
          "Poulus",
          "Poulussen",
          "Poutsma",
          "Pouw",
          "Pouw Kraan",
          "Pouwels",
          "Pouwelse",
          "Pouwer",
          "Pover",
          "Power",
          "Poyraz",
          "Praag",
          "Praamstra",
          "Praas",
          "Praat",
          "Pracht",
          "Prado",
          "Pragt",
          "Prak",
          "Prakken",
          "Pranger",
          "Prast",
          "Praster",
          "Pree",
          "Preesman",
          "Prein",
          "Premchand",
          "Prenen",
          "Prenger",
          "Prent",
          "Preuter",
          "Prevo",
          "Prevoo",
          "Prevos",
          "Prick",
          "Prickaerts",
          "Prie",
          "Priem",
          "Priems",
          "Priest",
          "Priester",
          "Prijn",
          "Prijs",
          "Prijt",
          "Prikken",
          "Pril",
          "Prince",
          "Princen",
          "Prins",
          "Prinse",
          "Prinsen",
          "Prinssen",
          "Prinsze",
          "Procee",
          "Proenings",
          "Profijt",
          "Promes",
          "Pronk",
          "Prooij",
          "Prooijen",
          "Proos",
          "Proosdij",
          "Proost",
          "Proosten",
          "Prop",
          "Proper",
          "Prophitius",
          "Prosman",
          "Pross",
          "Protzman",
          "Provence",
          "Provilij",
          "Provoost",
          "Prudon",
          "Pruijmboom",
          "Pruijn",
          "Pruijs",
          "Pruijsen",
          "Pruijsers",
          "Pruijssers",
          "Pruijt",
          "Pruiksma",
          "Pruim",
          "Pruimboom",
          "Pruis",
          "Pruisscher",
          "Pruissen",
          "Prummel",
          "Pruntel",
          "Pré",
          "Pubben",
          "Puffelen",
          "Puijenbroek",
          "Puijk",
          "Puijn",
          "Puik",
          "Puister",
          "Pul",
          "Pullen",
          "Pullens",
          "Pulles",
          "Puls",
          "Pultrum",
          "Punder",
          "Punselie",
          "Punt",
          "Punte",
          "Punter",
          "Puntman",
          "Puper",
          "Puriel",
          "Purmer",
          "Purnot",
          "Purperhart",
          "Pustjens",
          "Put",
          "Putker",
          "Putman",
          "Putmans",
          "Puts",
          "Putte",
          "Putten",
          "Puttenstein",
          "Putter",
          "Putters",
          "Pörteners",
          "Quaak",
          "Quaars",
          "Quaden",
          "Quadvlieg",
          "Quaedackers",
          "Quaedflieg",
          "Quaedvlieg",
          "Quak",
          "Quakernaat",
          "Quakkelaar",
          "Qualm",
          "Quant",
          "Quarré",
          "Quartel",
          "Quast",
          "Quax",
          "Quekel",
          "Quick",
          "Quik",
          "Quint",
          "Quinten",
          "Quirijnen",
          "Quirijns",
          "Quispel",
          "Quist",
          "Quix",
          "Qureshi",
          "Raa",
          "Raad",
          "Raadschelders",
          "Raadsen",
          "Raadt",
          "Raaf",
          "Raaff",
          "Raafs",
          "Raaij",
          "Raaijen",
          "Raaijmakers",
          "Raaijman",
          "Raak",
          "Raalte",
          "Raalten",
          "Raam",
          "Raams",
          "Raamsdonk",
          "Raamsman",
          "Raan",
          "Raangs",
          "Raanhuis",
          "Raap",
          "Raaphorst",
          "Raas",
          "Raasveld",
          "Raat",
          "Raateland",
          "Raatgever",
          "Raatjes",
          "Raats",
          "Raay",
          "Raaymakers",
          "Rab",
          "Rabbers",
          "Rabe",
          "Rabeling",
          "Rabelink",
          "Raben",
          "Rabouw",
          "Radder",
          "Radema",
          "Rademacher",
          "Rademaekers",
          "Rademaker",
          "Rademakers",
          "Radermacher",
          "Radersma",
          "Radius",
          "Radix",
          "Radjkoemar",
          "Radsma",
          "Radstaak",
          "Radstaat",
          "Radstake",
          "Radt",
          "Raedts",
          "Raemaekers",
          "Raemakers",
          "Raes",
          "Raets",
          "Raeven",
          "Raggers",
          "Raghoe",
          "Raghoebar",
          "Raghoebarsing",
          "Raghoebier",
          "Raghoenandan",
          "Raghoenath",
          "Rahamat",
          "Rahim",
          "Rahimbaks",
          "Rahimi",
          "Rahman",
          "Rahmani",
          "Rahmouni",
          "Rahou",
          "Raijer",
          "Raijmakers",
          "Raijmann",
          "Raja",
          "Rakers",
          "Rakhan",
          "Rakhorst",
          "Rakt",
          "Ram",
          "Rama",
          "Ramadhin",
          "Ramaekers",
          "Ramaker",
          "Ramakers",
          "Ramasray",
          "Ramautar",
          "Ramautarsing",
          "Rambaran",
          "Rambelje",
          "Ramcharan",
          "Ramdajal",
          "Ramdani",
          "Ramdas",
          "Ramdhan",
          "Ramdhani",
          "Ramdien",
          "Ramdin",
          "Ramdjan",
          "Rameckers",
          "Ramerman",
          "Ramesar",
          "Ramgolam",
          "Ramjiawan",
          "Ramkema",
          "Ramkhelawan",
          "Ramkisoen",
          "Ramlakhan",
          "Ramlal",
          "Rammeloo",
          "Ramnarain",
          "Ramnath",
          "Ramos",
          "Ramp",
          "Rampen",
          "Rampersad",
          "Ramphal",
          "Rams",
          "Ramsaran",
          "Ramsaroep",
          "Ramselaar",
          "Ramshorst",
          "Ramsodit",
          "Ramzan",
          "Ran",
          "Rana",
          "Randamie",
          "Randen",
          "Randsdorp",
          "Randwijk",
          "Rang",
          "Rangelrooij",
          "Ransdorp",
          "Ransijn",
          "Ranzijn",
          "Rap",
          "Rapati",
          "Raphaela",
          "Rappange",
          "Rappard",
          "Ras",
          "Rasch",
          "Rasenberg",
          "Rashid",
          "Rasing",
          "Rasker",
          "Rasoelbaks",
          "Raspe",
          "Rassel",
          "Rast",
          "Ratelband",
          "Ratering",
          "Raterink",
          "Rath",
          "Ratingen",
          "Rattink",
          "Rauwerda",
          "Rauwerdink",
          "Rave",
          "Ravelli",
          "Ravels",
          "Raven",
          "Ravenhorst",
          "Ravensberg",
          "Ravensbergen",
          "Ravenshorst",
          "Ravensteijn",
          "Ravenstein",
          "Ravenstijn",
          "Ravenswaaij",
          "Ravenzwaaij",
          "Ravesloot",
          "Ravesteijn",
          "Ravestein",
          "Ravestijn",
          "Raymakers",
          "Razab-Sekh",
          "Razenberg",
          "Read",
          "Rebel",
          "Rebergen",
          "Rebers",
          "Receveur",
          "Rechter",
          "Recourt",
          "Redan",
          "Redder",
          "Redegeld",
          "Redeker",
          "Redelijkheid",
          "Redert",
          "Ree",
          "Ree Doolaard",
          "Reede",
          "Reeden",
          "Reeder",
          "Reeders",
          "Reedijk",
          "Reef",
          "Reefhuis",
          "Reefman",
          "Reehorst",
          "Reek",
          "Reeken",
          "Reekers",
          "Reekum",
          "Reem",
          "Reemer",
          "Reemers",
          "Reemnet",
          "Reemst",
          "Reen",
          "Reenen",
          "Reep",
          "Reerink",
          "Rees",
          "Reesink",
          "Reessink",
          "Reest",
          "Reeuwijk",
          "Reeven",
          "Reezigt",
          "Refos",
          "Regales",
          "Regeer",
          "Regeling",
          "Regelink",
          "Regensburg",
          "Regnerus",
          "Regt",
          "Regter",
          "Regteren",
          "Regterschot",
          "Regtien",
          "Regtop",
          "Regts",
          "Rehman",
          "Rehorst",
          "Reiber",
          "Reichardt",
          "Reichart",
          "Reiche",
          "Reichert",
          "Reichgelt",
          "Reiding",
          "Reidinga",
          "Reidsma",
          "Reij",
          "Reijbroek",
          "Reijden",
          "Reijen",
          "Reijenga",
          "Reijer",
          "Reijerink",
          "Reijerkerk",
          "Reijers",
          "Reijerse",
          "Reijersen",
          "Reijersen van Buuren",
          "Reijgersberg",
          "Reijinga",
          "Reijke",
          "Reijken",
          "Reijm",
          "Reijman",
          "Reijmer",
          "Reijmerink",
          "Reijmers",
          "Reijmersdal",
          "Reijn",
          "Reijnders",
          "Reijne",
          "Reijnen",
          "Reijners",
          "Reijneveld",
          "Reijngoud",
          "Reijngoudt",
          "Reijnhoudt",
          "Reijnhout",
          "Reijnier",
          "Reijnierse",
          "Reijns",
          "Reijntjens",
          "Reijntjes",
          "Reijrink",
          "Reijs",
          "Reijsen",
          "Reijt",
          "Reijtenbagh",
          "Reijven",
          "Reiling",
          "Reilink",
          "Reilman",
          "Reimerink",
          "Reimert",
          "Reimink",
          "Rein",
          "Reina",
          "Reinalda",
          "Reinartz",
          "Reinbergen",
          "Reinderink",
          "Reinders",
          "Reinds",
          "Reinerink",
          "Reiners",
          "Reingoud",
          "Reinhard",
          "Reinieren",
          "Reiniers",
          "Reininga",
          "Reinink",
          "Reins",
          "Reinsma",
          "Reintjens",
          "Reintjes",
          "Reintke",
          "Reints",
          "Reis",
          "Reisen",
          "Reit",
          "Reith",
          "Reitsema",
          "Reitsma",
          "Reitzema",
          "Rek",
          "Rekelhof",
          "Reker",
          "Rekers",
          "Rekker",
          "Rekkers",
          "Rekoert",
          "Rekum",
          "Rekveld",
          "Rellum",
          "Relou",
          "Relouw",
          "Rem",
          "Remeeus",
          "Remeijsen",
          "Remerij",
          "Remers",
          "Remie",
          "Remijn",
          "Remijnse",
          "Remkes",
          "Remmelink",
          "Remmelts",
          "Remmelzwaal",
          "Remmen",
          "Remmerde",
          "Remmerden",
          "Remmers",
          "Remmerswaal",
          "Remmerts",
          "Remmits",
          "Rempt",
          "Renaud",
          "Renckens",
          "Rendering",
          "Renders",
          "Reneerkens",
          "Renema",
          "Reneman",
          "Renes",
          "Renet",
          "Renfrum",
          "Renfurm",
          "Rengelink",
          "Rengers",
          "Rengs",
          "Reniers",
          "Renirie",
          "Renkema",
          "Renken",
          "Renkens",
          "Renne",
          "Rennen",
          "Rennenberg",
          "Rennes",
          "Renooij",
          "Rens",
          "Rensch",
          "Rense",
          "Renselaar",
          "Rensen",
          "Rensenbrink",
          "Rensing",
          "Rensink",
          "Renskers",
          "Renssen",
          "Renswoude",
          "Renswouw",
          "Rentenaar",
          "Renting",
          "Rentmeester",
          "Rentrop",
          "Rep",
          "Repko",
          "Res",
          "Resida",
          "Resink",
          "Resoort",
          "Rest",
          "Retel",
          "Retera",
          "Reterink",
          "Retz",
          "Reu",
          "Reubsaet",
          "Reugebrink",
          "Reukers",
          "Reule",
          "Reulen",
          "Reuling",
          "Reulink",
          "Reumer",
          "Reumerman",
          "Reumkens",
          "Reurekas",
          "Reurings",
          "Reurink",
          "Reurslag",
          "Reus",
          "Reusen",
          "Reuser",
          "Reusken",
          "Reutelingsperger",
          "Reuten",
          "Reuter",
          "Reuvekamp",
          "Reuver",
          "Reuvers",
          "Reve",
          "Revenberg",
          "Revers",
          "Revet",
          "Rewijk",
          "Rewinkel",
          "Rexwinkel",
          "Reyes",
          "Reynders",
          "Rezelman",
          "Rhebergen",
          "Rhee",
          "Rheenen",
          "Rhemrev",
          "Rhenen",
          "Rhijn",
          "Rhijnsburger",
          "Rhoon",
          "Ribbens",
          "Ribberink",
          "Ribbers",
          "Ribbink",
          "Ricardo",
          "Richard",
          "Richards",
          "Richardson",
          "Richel",
          "Richter",
          "Richters",
          "Ridder",
          "Ridderbos",
          "Ridderhof",
          "Riddersma",
          "Rie",
          "Riebeek",
          "Riedel",
          "Riedeman",
          "Rieder",
          "Riedewald",
          "Riedijk",
          "Riedstra",
          "Rieff",
          "Riegman",
          "Rieken",
          "Rieks",
          "Riekwel",
          "Riel",
          "Riele",
          "Riem",
          "Riemeijer",
          "Riemens",
          "Riemer",
          "Riemers",
          "Riemersma",
          "Riemsdijk",
          "Riemslag",
          "Rienks",
          "Rienstra",
          "Rienties",
          "Rientjes",
          "Riep",
          "Riepen",
          "Riepma",
          "Riesen",
          "Riesewijk",
          "Riesmeijer",
          "Riessen",
          "Riesthuis",
          "Rieswijk",
          "Riet",
          "Rietberg",
          "Rietbergen",
          "Rietbroek",
          "Rietdijk",
          "Rietema",
          "Rieter",
          "Riethoff",
          "Riethorst",
          "Riethoven",
          "Rietjens",
          "Rietkerk",
          "Rietkerken",
          "Rietman",
          "Rietmeijer",
          "Rietschoten",
          "Rietveld",
          "Rietveldt",
          "Rietvelt",
          "Rietvink",
          "Riewald",
          "Riezebos",
          "Riezen",
          "Rigter",
          "Rigterink",
          "Rigters",
          "Rij",
          "Rijbroek",
          "Rijck",
          "Rijcke",
          "Rijcken",
          "Rijckevorsel",
          "Rijdt",
          "Rijen",
          "Rijfers",
          "Rijff",
          "Rijfkogel",
          "Rijgersberg",
          "Rijk",
          "Rijkaart",
          "Rijke",
          "Rijkeboer",
          "Rijkee",
          "Rijkelijkhuizen",
          "Rijken",
          "Rijkenberg",
          "Rijkens",
          "Rijkers",
          "Rijkes",
          "Rijkhoek",
          "Rijkhoff",
          "Rijkmans",
          "Rijkom",
          "Rijks",
          "Rijkschroeff",
          "Rijkse",
          "Rijksen",
          "Rijlaarsdam",
          "Rijn",
          "Rijnaard",
          "Rijnbeek",
          "Rijnberg",
          "Rijnbergen",
          "Rijnberk",
          "Rijnbout",
          "Rijnders",
          "Rijndorp",
          "Rijneker",
          "Rijnen",
          "Rijneveld",
          "Rijnhart",
          "Rijnhout",
          "Rijnierse",
          "Rijnja",
          "Rijnsbergen",
          "Rijnsburger",
          "Rijnsoever",
          "Rijntjes",
          "Rijper",
          "Rijpers",
          "Rijpert",
          "Rijpkema",
          "Rijpma",
          "Rijpstra",
          "Rijs",
          "Rijsbergen",
          "Rijsdam",
          "Rijsdijk",
          "Rijsemus",
          "Rijsenbrij",
          "Rijsewijk",
          "Rijshouwer",
          "Rijsinge",
          "Rijsingen",
          "Rijskamp",
          "Rijsmus",
          "Rijssel",
          "Rijssemus",
          "Rijssen",
          "Rijst",
          "Rijstenberg",
          "Rijstenbil",
          "Rijswick",
          "Rijswijck",
          "Rijswijk",
          "Rijszen",
          "Rijt",
          "Rijthoven",
          "Rijvers",
          "Rijzinga",
          "Rikers",
          "Rikhof",
          "Rikken",
          "Rikkerink",
          "Rikkers",
          "Rikkert",
          "Rikmanspoel",
          "Riksen",
          "Riksten",
          "Rikxoort",
          "Riley",
          "Rill",
          "Rimmelzwaan",
          "Ring",
          "Ringelberg",
          "Ringelenstein",
          "Ringeling",
          "Ringenier",
          "Ringers",
          "Ringlever",
          "Ringma",
          "Ringnalda",
          "Rings",
          "Rinia",
          "Rink",
          "Rinkel",
          "Rinkema",
          "Rinkens",
          "Rinsema",
          "Rinsma",
          "Rinsum",
          "Rintjema",
          "Rinzema",
          "Rip",
          "Riphagen",
          "Ripken",
          "Ripmeester",
          "Rippen",
          "Ripzaad",
          "Ririhena",
          "Ris",
          "Risakotta",
          "Rison",
          "Rispens",
          "Risseeuw",
          "Risselada",
          "Rissewijck",
          "Ritchi",
          "Riteco",
          "Ritfeld",
          "Ritman",
          "Ritmeester",
          "Ritmeijer",
          "Ritsema",
          "Ritskes",
          "Ritsma",
          "Ritter",
          "Ritzema",
          "Ritzen",
          "Ritzer",
          "Rixel",
          "Rixtel",
          "Rob",
          "Robaard",
          "Robbe",
          "Robbemond",
          "Robbemont",
          "Robben",
          "Robbers",
          "Robbertsen",
          "Robeerst",
          "Robers",
          "Robert",
          "Roberti",
          "Roberts",
          "Robertson",
          "Robertus",
          "Robijn",
          "Robijns",
          "Robinson",
          "Robles",
          "Robroek",
          "Rocha",
          "Rochat",
          "Rocks",
          "Rockx",
          "Roddenhof",
          "Rode",
          "Rodenberg",
          "Rodenboog",
          "Rodenburg",
          "Rodenhuis",
          "Rodenrijs",
          "Rodermond",
          "Rodewijk",
          "Rodgers",
          "Rodijk",
          "Rodijnen",
          "Roding",
          "Rodjan",
          "Rodrigues",
          "Rodriguez",
          "Roebers",
          "Roebersen",
          "Roebroek",
          "Roebroeks",
          "Roede",
          "Roeden",
          "Roeffen",
          "Roefs",
          "Roek",
          "Roekel",
          "Roekevisch",
          "Roeland",
          "Roelands",
          "Roelandschap",
          "Roelandse",
          "Roelants",
          "Roele",
          "Roelen",
          "Roeleveld",
          "Roeleven",
          "Roelevink",
          "Roelfs",
          "Roelfsema",
          "Roeling",
          "Roelink",
          "Roeloffs",
          "Roeloffzen",
          "Roelofs",
          "Roelofse",
          "Roelofsen",
          "Roelofsma",
          "Roels",
          "Roelse",
          "Roelsma",
          "Roelvink",
          "Roem",
          "Roemaat",
          "Roemburg",
          "Roemeling",
          "Roemen",
          "Roemer",
          "Roemers",
          "Roenhorst",
          "Roep",
          "Roeper",
          "Roepers",
          "Roer",
          "Roerade",
          "Roerdink",
          "Roerdinkholder",
          "Roerig",
          "Roering",
          "Roerink",
          "Roermund",
          "Roersma",
          "Roes",
          "Roescher",
          "Roesink",
          "Roessel",
          "Roessen",
          "Roessink",
          "Roest",
          "Roestenberg",
          "Roestenburg",
          "Roet",
          "Roeten",
          "Roeterdink",
          "Roeterink",
          "Roeters",
          "Roetert",
          "Roetgerink",
          "Roethof",
          "Roetman",
          "Roeven",
          "Roex",
          "Roffel",
          "Roffelsen",
          "Rog",
          "Rogaar",
          "Rogers",
          "Rogge",
          "Roggeband",
          "Roggema",
          "Roggen",
          "Roggeveen",
          "Roggeveld",
          "Rogier",
          "Rohaan",
          "Rohde",
          "Rohling",
          "Rohof",
          "Roij",
          "Roijackers",
          "Roijakkers",
          "Roijen",
          "Roijers",
          "Roijmans",
          "Rojer",
          "Roke",
          "Rokebrand",
          "Rokers",
          "Roks",
          "Rokven",
          "Rokx",
          "Rol",
          "Roland",
          "Rolf",
          "Rolfes",
          "Rolff",
          "Roling",
          "Rolink",
          "Rollema",
          "Rolleman",
          "Rolloos",
          "Rolsma",
          "Rolvink",
          "Roman",
          "Romano",
          "Rombaut",
          "Romberg",
          "Rombout",
          "Rombouts",
          "Romeijn",
          "Romeijnders",
          "Romein",
          "Romers",
          "Romijn",
          "Romijnders",
          "Romkema",
          "Romkes",
          "Romme",
          "Rommelse",
          "Rommen",
          "Rommens",
          "Rommers",
          "Romp",
          "Rompa",
          "Rompelberg",
          "Rompelman",
          "Rompen",
          "Romph",
          "Romviel",
          "Ron",
          "Ronckers",
          "Rond",
          "Ronda",
          "Ronde",
          "Rondeel",
          "Rondhuis",
          "Rongen",
          "Ronhaar",
          "Ronken",
          "Ronkes",
          "Ronner",
          "Ronteltap",
          "Roo",
          "Roobol",
          "Roock",
          "Rood",
          "Rooda",
          "Roodakker",
          "Roodbeen",
          "Roodbergen",
          "Roodbol",
          "Roode",
          "Rooden",
          "Roodenburg",
          "Roodenrijs",
          "Roodhart",
          "Roodhorst",
          "Rooding",
          "Roodink",
          "Roodnat",
          "Roodt",
          "Roodzant",
          "Roof",
          "Rooi",
          "Rooij",
          "Rooijackers",
          "Rooijakkers",
          "Rooijen",
          "Rooijendijk",
          "Rooijens",
          "Rooijers",
          "Rooijmans",
          "Rooimans",
          "Rook",
          "Rooker",
          "Rookhuizen",
          "Rooks",
          "Roolvink",
          "Room",
          "Roomen",
          "Roomer",
          "Roon",
          "Roor",
          "Roord",
          "Roorda",
          "Roording",
          "Roordink",
          "Roos",
          "Roose",
          "Rooseboom",
          "Roosen",
          "Roosenboom",
          "Roosenbrand",
          "Roosenburg",
          "Roosendaal",
          "Roosien",
          "Roosink",
          "Roosjen",
          "Roosken",
          "Roosloot",
          "Roosma",
          "Roosmalen",
          "Roossien",
          "Roost",
          "Rooswinkel",
          "Root",
          "Rooth",
          "Roothans",
          "Rootlieb",
          "Rootselaar",
          "Roover",
          "Roovers",
          "Roovert",
          "Rooy",
          "Rooyakkers",
          "Rooyen",
          "Rooze",
          "Roozeboom",
          "Roozemond",
          "Roozen",
          "Roozenbeek",
          "Roozenboom",
          "Roozenburg",
          "Roozendaal",
          "Rop",
          "Rops",
          "Roquas",
          "Rorije",
          "Rorijs",
          "Ros",
          "Rosa",
          "Rosalia",
          "Rosaria",
          "Rosbergen",
          "Rosdorff",
          "Rose",
          "Roseboom",
          "Roselaar",
          "Rosema",
          "Rosenbaum",
          "Rosenberg",
          "Rosenboom",
          "Rosenbrand",
          "Rosendaal",
          "Rosendahl",
          "Rosendal",
          "Rosenthal",
          "Rosheuvel",
          "Rosiek",
          "Rosielle",
          "Rosier",
          "Rosing",
          "Rosink",
          "Roskam",
          "Roskamp",
          "Rosmalen",
          "Rosman",
          "Rosmolen",
          "Ross",
          "Rossel",
          "Rossem",
          "Rossen",
          "Rossenaar",
          "Rossenberg",
          "Rossewij",
          "Rossing",
          "Rossum",
          "Rost",
          "Rosário",
          "Rot",
          "Rotgans",
          "Rotgers",
          "Roth",
          "Rothengatter",
          "Rothman",
          "Rothuis",
          "Rothuizen",
          "Rotman",
          "Rotmans",
          "Rotmensen",
          "Rots",
          "Rotte",
          "Rotterdam",
          "Rotteveel",
          "Rottier",
          "Rottiné",
          "Roubos",
          "Roubroeks",
          "Roufs",
          "Rougoor",
          "Rouhof",
          "Roukema",
          "Roukens",
          "Roulaux",
          "Rouleaux",
          "Roumans",
          "Roumen",
          "Roumimper",
          "Rous",
          "Rouschop",
          "Rouss",
          "Rousseau",
          "Rouw",
          "Rouweler",
          "Rouwen",
          "Rouwendaal",
          "Rouwendal",
          "Rouwenhorst",
          "Rouwet",
          "Rouwette",
          "Rouwhorst",
          "Rover",
          "Rovers",
          "Roverts",
          "Rowaan",
          "Roxs",
          "Roy",
          "Roza",
          "Roze",
          "Rozeboom",
          "Rozema",
          "Rozeman",
          "Rozemeijer",
          "Rozemuller",
          "Rozen",
          "Rozenberg",
          "Rozenblad",
          "Rozenboom",
          "Rozenbrand",
          "Rozendaal",
          "Rozendal",
          "Rozendom",
          "Rozenveld",
          "Rozestraten",
          "Rozier",
          "Rozijn",
          "Rozing",
          "Ru",
          "Ruben",
          "Rubens",
          "Rubingh",
          "Rudge",
          "Rudolph",
          "Rueck",
          "Ruedisueli",
          "Ruesink",
          "Ruessink",
          "Rugebregt",
          "Rugenbrink",
          "Ruhe",
          "Ruhl",
          "Ruig",
          "Ruighaver",
          "Ruigrok",
          "Ruijer",
          "Ruijg",
          "Ruijgers",
          "Ruijgh",
          "Ruijgrok",
          "Ruijgt",
          "Ruijs",
          "Ruijsch",
          "Ruijsscher",
          "Ruijssenaars",
          "Ruijten",
          "Ruijtenbeek",
          "Ruijtenberg",
          "Ruijter",
          "Ruijters",
          "Ruijven",
          "Ruijzenaars",
          "Ruiken",
          "Ruikes",
          "Ruinard",
          "Ruinemans",
          "Ruis",
          "Ruisch",
          "Ruissen",
          "Ruiswijk",
          "Ruit",
          "Ruiten",
          "Ruitenbeek",
          "Ruitenberg",
          "Ruitenburg",
          "Ruiter",
          "Ruiterkamp",
          "Ruiterman",
          "Ruiters",
          "Ruiven",
          "Ruiz",
          "Ruizendaal",
          "Ruler",
          "Rulkens",
          "Rullens",
          "Rump",
          "Rumping",
          "Rumpt",
          "Run",
          "Runderkamp",
          "Runge",
          "Runhaar",
          "Runhart",
          "Runia",
          "Runneboom",
          "Rupert",
          "Ruppert",
          "Rus",
          "Rusch",
          "Ruseler",
          "Ruskus",
          "Rusman",
          "Russchen",
          "Russcher",
          "Russel",
          "Rust",
          "Rustenburg",
          "Rustenhoven",
          "Rusticus",
          "Rustveld",
          "Rutenfrans",
          "Rutgers",
          "Rutgrink",
          "Ruth",
          "Rutjens",
          "Rutjes",
          "Ruts",
          "Rutte",
          "Rutteman",
          "Rutten",
          "Ruttenberg",
          "Rutterkamp",
          "Rutters",
          "Rutting",
          "Ruumpol",
          "Ruwaard",
          "Ruys",
          "Ruyter",
          "Ruyters",
          "Röben",
          "Rödel",
          "Röder",
          "Röell",
          "Röling",
          "Römer",
          "Römers",
          "Römgens",
          "Römkens",
          "Röttger",
          "Rövekamp",
          "Rühl",
          "Rüter",
          "Rütten",
          "Rütter",
          "Saad",
          "Saadhoff",
          "Saalmink",
          "Saaltink",
          "Saaman",
          "Saane",
          "Saanen",
          "Saarloos",
          "Saas",
          "Saase",
          "Saasen",
          "Saat",
          "Saathof",
          "Sabajo",
          "Sabandar",
          "Sabben",
          "Sabel",
          "Saber",
          "Sabir",
          "Sabri",
          "Sachs",
          "Sack",
          "Sadal",
          "Saddal",
          "Saddik",
          "Saddiki",
          "Sadhoe",
          "Sadik",
          "Sadloe",
          "Saedt",
          "Saeed",
          "Saelman",
          "Saelmans",
          "Saes",
          "Saffrie",
          "Safi",
          "Sage",
          "Sagel",
          "Sahebali",
          "Sahebdin",
          "Sahertian",
          "Sahetapy",
          "Sahin",
          "Said",
          "Saidi",
          "Saija",
          "Sain",
          "Sak",
          "Sakkers",
          "Sakko",
          "Sala",
          "Salah",
          "Salakory",
          "Salama",
          "Salarbux",
          "Salari",
          "Salden",
          "Saleh",
          "Salem",
          "Salemans",
          "Salemink",
          "Salentijn",
          "Salet",
          "Salfischberger",
          "Salhi",
          "Salih",
          "Salij",
          "Salim",
          "Salimans",
          "Salm",
          "Salman",
          "Salmans",
          "Salmi",
          "Salomon",
          "Salomons",
          "Salomé",
          "Salters",
          "Salverda",
          "Sam",
          "Sam-Sin",
          "Saman",
          "Sambeeck",
          "Sambeek",
          "Sambo",
          "Sampat",
          "Sampers",
          "Samplonius",
          "Samsen",
          "Samsom",
          "Samson",
          "Samuel",
          "Samuels",
          "Samwel",
          "Sanberg",
          "Sanches",
          "Sanchez",
          "Sandberg",
          "Sandbergen",
          "Sandbrink",
          "Sande",
          "Sandee",
          "Sandel",
          "Sanden",
          "Sander",
          "Sanderink",
          "Sanderman",
          "Sanders",
          "Sanderse",
          "Sandifort",
          "Sandijk",
          "Sandt",
          "Sandvliet",
          "Sandwijk",
          "Sangen",
          "Sangers",
          "Sanna",
          "Sannen",
          "Sannes",
          "Sanou",
          "Sanstra",
          "Sant",
          "Santbergen",
          "Santbrink",
          "Sante",
          "Santegoeds",
          "Santegoets",
          "Santema",
          "Santen",
          "Santing",
          "Santman",
          "Santoe",
          "Santokhi",
          "Santos",
          "Santvoort",
          "Sap",
          "Sapulette",
          "Sar",
          "Saraber",
          "Saraç",
          "Sardar",
          "Sardjoe",
          "Sari",
          "Sarikaya",
          "Sarink",
          "Saris",
          "Sark",
          "Sarneel",
          "Sarpong",
          "Sars",
          "Sarton",
          "Sarwari",
          "Sas",
          "Sasbrink",
          "Sassen",
          "Satijn",
          "Satink",
          "Satter",
          "Sauer",
          "Sauren",
          "Sauter",
          "Sauvé",
          "Savaş",
          "Savelberg",
          "Savelkoul",
          "Savelkouls",
          "Savelsberg",
          "Savenije",
          "Savić",
          "Sax",
          "Saya",
          "Sayed",
          "Saygili",
          "Saïdi",
          "Sağlam",
          "Schaaf",
          "Schaafsma",
          "Schaafstra",
          "Schaaij",
          "Schaaik",
          "Schaak",
          "Schaake",
          "Schaap",
          "Schaaper",
          "Schaapherder",
          "Schaaphok",
          "Schaapman",
          "Schaapveld",
          "Schaar",
          "Schaardenburg",
          "Schaareman",
          "Schaars",
          "Schaart",
          "Schaasberg",
          "Schabbink",
          "Schaddelee",
          "Schade",
          "Schadee",
          "Schadenberg",
          "Schadewijk",
          "Schadron",
          "Schaefer",
          "Schaefers",
          "Schaeffer",
          "Schaeken",
          "Schaeks",
          "Schaepkens",
          "Schaerlaeckens",
          "Schaffers",
          "Schaft",
          "Schaftenaar",
          "Schagen",
          "Schager",
          "Schagt",
          "Schaick",
          "Schaijik",
          "Schaijk",
          "Schaik",
          "Schajik",
          "Schakel",
          "Schakelaar",
          "Schakenbos",
          "Schakenraad",
          "Schalekamp",
          "Schalen",
          "Schalie",
          "Schalk",
          "Schalke",
          "Schalken",
          "Schalker",
          "Schalks",
          "Schalkwijk",
          "Schalkx",
          "Schallenberg",
          "Schalm",
          "Schaminée",
          "Schamp",
          "Schampers",
          "Schans",
          "Schanssema",
          "Schapelhouman",
          "Schapendonk",
          "Schaper",
          "Schapers",
          "Schardijn",
          "Scharenborg",
          "Scharff",
          "Scharis",
          "Scharloo",
          "Scharphof",
          "Scharrenberg",
          "Scharroo",
          "Schasfoort",
          "Schat",
          "Schatorjé",
          "Schats",
          "Schattefor",
          "Schattevoet",
          "Schaufeli",
          "Schavemaker",
          "Schayk",
          "Schee",
          "Scheefhals",
          "Scheek",
          "Scheel",
          "Scheele",
          "Scheelings",
          "Scheen",
          "Scheenen",
          "Scheenloop",
          "Scheenstra",
          "Scheepbouwer",
          "Scheepens",
          "Scheeper",
          "Scheepers",
          "Scheepmaker",
          "Scheepstra",
          "Scheer",
          "Scheerder",
          "Scheerders",
          "Scheeren",
          "Scheeres",
          "Scheerhoorn",
          "Scheeringa",
          "Scheerman",
          "Scheermeijer",
          "Scheers",
          "Scheffel",
          "Scheffer",
          "Schefferlie",
          "Scheffers",
          "Schegget",
          "Scheggetman",
          "Scheij",
          "Scheijen",
          "Scheijndel",
          "Scheijven",
          "Scheijvens",
          "Schekkerman",
          "Schel",
          "Schelde",
          "Schelfhorst",
          "Schelfhout",
          "Schelhaas",
          "Schell",
          "Schellart",
          "Schelle",
          "Schellekens",
          "Schellen",
          "Schellens",
          "Schellevis",
          "Schelling",
          "Schellinger",
          "Schellingerhout",
          "Schellings",
          "Schelt",
          "Scheltema",
          "Scheltens",
          "Scheltinga",
          "Scheltus",
          "Schelven",
          "Schelvis",
          "Schemkes",
          "Schemmekes",
          "Schenau",
          "Schendel",
          "Schendelaar",
          "Schenderling",
          "Schenk",
          "Schenkel",
          "Schenkelaars",
          "Schenkels",
          "Schenkers",
          "Schenkeveld",
          "Schenning",
          "Schennink",
          "Schep",
          "Schepel",
          "Schepen",
          "Schepens",
          "Scheper",
          "Schepers",
          "Schepman",
          "Schepop",
          "Schepper",
          "Scheppers",
          "Scheppingen",
          "Scheppink",
          "Scherbeijn",
          "Scherders",
          "Scheren",
          "Scherer",
          "Scheres",
          "Scherff",
          "Scheringa",
          "Scherjon",
          "Schermer",
          "Schermerhorn",
          "Schermers",
          "Scherpen",
          "Scherpenhuizen",
          "Scherpenisse",
          "Scherpenzeel",
          "Scherphof",
          "Scherrenberg",
          "Scherrenburg",
          "Schers",
          "Schets",
          "Schetters",
          "Scheuer",
          "Scheur",
          "Scheurink",
          "Scheurkogel",
          "Scheurwater",
          "Scheuter",
          "Scheutjens",
          "Scheve",
          "Schevers",
          "Schie",
          "Schiedon",
          "Schieman",
          "Schiepers",
          "Schierbeek",
          "Schierboom",
          "Schiere",
          "Schiettekatte",
          "Schieveen",
          "Schieven",
          "Schieving",
          "Schievink",
          "Schiffart",
          "Schiffelers",
          "Schiffer",
          "Schiffers",
          "Schigt",
          "Schijf",
          "Schijff",
          "Schijndel",
          "Schijns",
          "Schijven",
          "Schijvenaars",
          "Schijvens",
          "Schiks",
          "Schild",
          "Schilden",
          "Schilder",
          "Schilderinck",
          "Schilderman",
          "Schilders",
          "Schildkamp",
          "Schildmeijer",
          "Schildwacht",
          "Schill",
          "Schillemans",
          "Schilling",
          "Schillings",
          "Schilp",
          "Schilperoord",
          "Schilperoort",
          "Schils",
          "Schilstra",
          "Schilt",
          "Schilte",
          "Schilthuizen",
          "Schiltkamp",
          "Schiltmans",
          "Schiltmeijer",
          "Schimmel",
          "Schimmelpennink",
          "Schimmer",
          "Schinkel",
          "Schinkelshoek",
          "Schins",
          "Schip",
          "Schipaanboord",
          "Schiphof",
          "Schiphorst",
          "Schiphouwer",
          "Schipper",
          "Schipperen",
          "Schipperheijn",
          "Schipperijn",
          "Schippers",
          "Schlagwein",
          "Schlangen",
          "Schlatmann",
          "Schlenter",
          "Schlepers",
          "Schlicher",
          "Schlief",
          "Schlosser",
          "Schluter",
          "Schlösser",
          "Schlüter",
          "Schmaal",
          "Schmal",
          "Schmeets",
          "Schmeits",
          "Schmeitz",
          "Schmeltz",
          "Schmets",
          "Schmetz",
          "Schmid",
          "Schmidt",
          "Schmit",
          "Schmits",
          "Schmitt",
          "Schmitz",
          "Schneider",
          "Schneiders",
          "Schneijderberg",
          "Schnieders",
          "Schniermanni",
          "Schnitzler",
          "Schobben",
          "Schoe",
          "Schoeber",
          "Schoemaker",
          "Schoemakers",
          "Schoeman",
          "Schoen",
          "Schoenaker",
          "Schoenmaeckers",
          "Schoenmaekers",
          "Schoenmaker",
          "Schoenmakers",
          "Schoep",
          "Schoester",
          "Schoffelen",
          "Schoffelmeer",
          "Schokkenbroek",
          "Schokker",
          "Schol",
          "Scholing",
          "Scholl",
          "Schollema",
          "Schollen",
          "Scholma",
          "Scholman",
          "Schols",
          "Scholsberg",
          "Scholte",
          "Scholte Lubberink",
          "Scholten",
          "Scholtens",
          "Scholtes",
          "Scholtmeijer",
          "Scholts",
          "Scholtus",
          "Scholtz",
          "Schomaker",
          "Schonenberg",
          "Schoneveld",
          "Schonewille",
          "Schonk",
          "Schoo",
          "Schoof",
          "Schoofs",
          "Schook",
          "School",
          "Schoolderman",
          "Schoolmeesters",
          "Schoon",
          "Schoonakker",
          "Schoonbeek",
          "Schoonbergen",
          "Schoonbrood",
          "Schoonbroodt",
          "Schoonderbeek",
          "Schoondermark",
          "Schoonderwalt",
          "Schoonderwoerd",
          "Schoonderwoert",
          "Schoone",
          "Schoonebeek",
          "Schooneman",
          "Schoonen",
          "Schoonenberg",
          "Schoonens",
          "Schoones",
          "Schooneveld",
          "Schoonewille",
          "Schoonheim",
          "Schoonhoven",
          "Schoonman",
          "Schoonus",
          "Schoonveld",
          "Schoonwater",
          "Schoop",
          "Schoor",
          "Schoordijk",
          "Schoorl",
          "Schoorlemmer",
          "Schoormans",
          "Schoorstra",
          "Schoot",
          "Schoot Uiterkamp",
          "Schootbrugge",
          "Schooten",
          "Schoots",
          "Schootstra",
          "Schop",
          "Schopenhouer",
          "Schopman",
          "Schoppema",
          "Schoppers",
          "Schoppink",
          "Schormans",
          "Schornagel",
          "Schortinghuis",
          "Schot",
          "Schotanus",
          "Schotborg",
          "Schotel",
          "Schoten",
          "Schothorst",
          "Schothuis",
          "Schotman",
          "Schotpoort",
          "Schots",
          "Schotsman",
          "Schotte",
          "Schotten",
          "Schottert",
          "Schotting",
          "Schotvanger",
          "Schouenberg",
          "Schouls",
          "Schoumans",
          "Schouren",
          "Schout",
          "Schoute",
          "Schouten",
          "Schoutens",
          "Schouteren",
          "Schouteten",
          "Schoutrop",
          "Schoutsen",
          "Schouw",
          "Schouwen",
          "Schouwenaar",
          "Schouwenaars",
          "Schouwenberg",
          "Schouwenburg",
          "Schouwink",
          "Schouwstra",
          "Schra",
          "Schraa",
          "Schraaf",
          "Schraal",
          "Schrader",
          "Schrage",
          "Schram",
          "Schrama",
          "Schrauwen",
          "Schrauwers",
          "Schraven",
          "Schravendijk",
          "Schravesande",
          "Schregardus",
          "Schreiber",
          "Schreij",
          "Schreijenberg",
          "Schreijer",
          "Schreiner",
          "Schreuder",
          "Schreuders",
          "Schreur",
          "Schreurs",
          "Schreutelkamp",
          "Schreven",
          "Schriek",
          "Schrieken",
          "Schriel",
          "Schriemer",
          "Schrier",
          "Schriever",
          "Schrievers",
          "Schrijen",
          "Schrijer",
          "Schrijnemaekers",
          "Schrijnemakers",
          "Schrijver",
          "Schrijvers",
          "Schrijvershof",
          "Schrik",
          "Schrikkema",
          "Schriks",
          "Schripsema",
          "Schroeder",
          "Schroen",
          "Schroer",
          "Schroeten",
          "Schroevers",
          "Schroijen",
          "Schroor",
          "Schroot",
          "Schrooten",
          "Schroten",
          "Schrotenboer",
          "Schrover",
          "Schroën",
          "Schruijer",
          "Schrurs",
          "Schröder",
          "Schröer",
          "Schubert",
          "Schuchard",
          "Schudde",
          "Schuddebeurs",
          "Schuddeboom",
          "Schueler",
          "Schuerman",
          "Schuermans",
          "Schuhmacher",
          "Schuijer",
          "Schuijers",
          "Schuijl",
          "Schuijt",
          "Schuil",
          "Schuilenburg",
          "Schuiling",
          "Schuit",
          "Schuite",
          "Schuitema",
          "Schuitemaker",
          "Schuiteman",
          "Schuiten",
          "Schuitert",
          "Schuitmaker",
          "Schuivens",
          "Schukken",
          "Schukking",
          "Schukkink",
          "Schuldink",
          "Schulenburg",
          "Schuler",
          "Schuling",
          "Schuller",
          "Schulp",
          "Schulpen",
          "Schulte",
          "Schulten",
          "Schulting",
          "Schultink",
          "Schults",
          "Schultz",
          "Schulz",
          "Schulze",
          "Schumacher",
          "Schuman",
          "Schumans",
          "Schumer",
          "Schunselaar",
          "Schuppen",
          "Schuppert",
          "Schure",
          "Schuren",
          "Schurer",
          "Schurgers",
          "Schuring",
          "Schuringa",
          "Schurink",
          "Schuster",
          "Schut",
          "Schutgens",
          "Schutjes",
          "Schutmaat",
          "Schutrups",
          "Schuts",
          "Schutte",
          "Schuttel",
          "Schutten",
          "Schuttenbeld",
          "Schutter",
          "Schuttert",
          "Schuttevaar",
          "Schutz",
          "Schuur",
          "Schuurbiers",
          "Schuurhuis",
          "Schuuring",
          "Schuurink",
          "Schuurkamp",
          "Schuurkes",
          "Schuurman",
          "Schuurmans",
          "Schuurs",
          "Schwab",
          "Schwanen",
          "Schwarte",
          "Schwartz",
          "Schwarz",
          "Schweitzer",
          "Schwencke",
          "Schwering",
          "Schwillens",
          "Schyns",
          "Schäfer",
          "Schäffer",
          "Schönberger",
          "Schönhage",
          "Schüller",
          "Schürmann",
          "Schütte",
          "Schütz",
          "Sciarone",
          "Scipio",
          "Scott",
          "Sebel",
          "Sebille",
          "Sebrechts",
          "Sebregts",
          "Seccelen",
          "Sedee",
          "Sedney",
          "Sedoc",
          "Seebregts",
          "Seedorf",
          "Seeger",
          "Seegers",
          "Seekles",
          "Seelen",
          "Seepma",
          "Seerden",
          "Seesing",
          "Seesink",
          "Seeters",
          "Segaar",
          "Segboer",
          "Segeren",
          "Segerink",
          "Segers",
          "Seggelen",
          "Seghers",
          "Seidel",
          "Seiger",
          "Seignette",
          "Seij",
          "Seijbel",
          "Seijen",
          "Seijger",
          "Seijkens",
          "Seijsener",
          "Seine",
          "Seinen",
          "Seinhorst",
          "Seinstra",
          "Seip",
          "Sekeris",
          "Sekreve",
          "Selbach",
          "Seldam",
          "Selder",
          "Selders",
          "Selen",
          "Selhorst",
          "Selie",
          "Selier",
          "Selle",
          "Selles",
          "Sellies",
          "Sellink",
          "Sellis",
          "Sellmeijer",
          "Selm",
          "Selman",
          "Sels",
          "Selst",
          "Selten",
          "Selvi",
          "Semeijn",
          "Semeleer",
          "Semler",
          "Semmekrot",
          "Sempel",
          "Semplonius",
          "Sen",
          "Senden",
          "Senders",
          "Senger",
          "Sengers",
          "Senneker",
          "Sennema",
          "Sens",
          "Senten",
          "Sentjens",
          "Sep",
          "Sepers",
          "Seppenwoolde",
          "Septer",
          "Serghini",
          "Serier",
          "Serin",
          "Serné",
          "Seroo",
          "Serpenti",
          "Serrarens",
          "Sert",
          "Servaas",
          "Servais",
          "Sesink",
          "Sessink",
          "Sestig",
          "Seters",
          "Seton",
          "Settels",
          "Setten",
          "Setz",
          "Seubers",
          "Seubring",
          "Seumeren",
          "Seuntiëns",
          "Seuntjens",
          "Seuren",
          "Seven",
          "Sevenhuijsen",
          "Sevenich",
          "Seventer",
          "Severein",
          "Severens",
          "Severien",
          "Severijn",
          "Severijnen",
          "Severijns",
          "Severijnse",
          "Severin",
          "Severins",
          "Severs",
          "Sevim",
          "Sevink",
          "Sevriens",
          "Sewalt",
          "Sewcharan",
          "Sewdajal",
          "Sewgobind",
          "Sewlal",
          "Sewnandan",
          "Sewnarain",
          "Sewnath",
          "Sewpal",
          "Sewpersad",
          "Sewradj",
          "Sewtahal",
          "Sezer",
          "Shah",
          "Sharif",
          "Sharifi",
          "Sharma",
          "Sheikh",
          "Sheombar",
          "Shi",
          "Siahaija",
          "Siahaya",
          "Sibbald",
          "Sibbel",
          "Sibbing",
          "Siben",
          "Sibma",
          "Sibon",
          "Sibum",
          "Siccama",
          "Siderius",
          "Sie",
          "Siebel",
          "Siebeling",
          "Siebelink",
          "Siebelt",
          "Sieben",
          "Siebenga",
          "Siebenheller",
          "Siebers",
          "Siebert",
          "Siebes",
          "Siebrand",
          "Siebring",
          "Siebum",
          "Siecker",
          "Sieders",
          "Siegel",
          "Siegers",
          "Siegersma",
          "Siekman",
          "Sieling",
          "Sieljes",
          "Siem",
          "Siemeling",
          "Siemelink",
          "Siemens",
          "Siemensma",
          "Siemerink",
          "Siemers",
          "Siemes",
          "Siemons",
          "Siemonsma",
          "Siep",
          "Siepel",
          "Sieperda",
          "Siepman",
          "Sier",
          "Siera",
          "Sieraad",
          "Sierat",
          "Siereveld",
          "Sierhuis",
          "Sierink",
          "Sierksma",
          "Sierkstra",
          "Siero",
          "Siers",
          "Siersema",
          "Siersma",
          "Siertsema",
          "Sies",
          "Siesling",
          "Sieswerda",
          "Sietsema",
          "Sietses",
          "Sietsma",
          "Sietzema",
          "Sieval",
          "Sieverink",
          "Sievers",
          "Sigmans",
          "Sigmond",
          "Sijben",
          "Sijbers",
          "Sijbesma",
          "Sijbom",
          "Sijbrandij",
          "Sijbrands",
          "Sijbring",
          "Sijde",
          "Sijens",
          "Sijl",
          "Sijm",
          "Sijmens",
          "Sijmons",
          "Sijnesael",
          "Sijp",
          "Sijpkens",
          "Sijpkes",
          "Sijrier",
          "Sijs",
          "Sijsling",
          "Sijstermans",
          "Sijtema",
          "Sijtsema",
          "Sijtsma",
          "Sikkelerus",
          "Sikkema",
          "Sikken",
          "Sikkenga",
          "Sikkens",
          "Sikkes",
          "Sikking",
          "Sikkink",
          "Sikma",
          "Siksma",
          "Silfhout",
          "Siliakus",
          "Silkens",
          "Sillekens",
          "Sillen",
          "Sillessen",
          "Silva",
          "Silvertand",
          "Silvis",
          "Silvius",
          "Simmelink",
          "Simmers",
          "Simmons",
          "Simon",
          "Simonis",
          "Simons",
          "Simonse",
          "Simpelaar",
          "Simsek",
          "Simson",
          "Sinay",
          "Sinderen",
          "Singelenberg",
          "Singeling",
          "Singels",
          "Singer",
          "Singerling",
          "Singh",
          "Sinke",
          "Sinkeldam",
          "Sinnema",
          "Sinnige",
          "Sinon",
          "Sinot",
          "Sins",
          "Sint",
          "Sint Jago",
          "Sint Nicolaas",
          "Sintemaartensdijk",
          "Sinten",
          "Sintenie",
          "Sinteur",
          "Sintmaartensdijk",
          "Sintnicolaas",
          "Sip",
          "Sipkema",
          "Sipkens",
          "Sipkes",
          "Sipma",
          "Sipman",
          "Sips",
          "Sipsma",
          "Sira",
          "Sirach",
          "Siroen",
          "Sirre",
          "Sissing",
          "Sistermans",
          "Sital",
          "Sitaram",
          "Siteur",
          "Sitters",
          "Sittrop",
          "Siu",
          "Six",
          "Sixma",
          "Sjardijn",
          "Sjerp",
          "Sjerps",
          "Sjoerds",
          "Sjoerdsma",
          "Sjoers",
          "Sjollema",
          "Sjouke",
          "Sjouw",
          "Slaa",
          "Slaats",
          "Slabbekoorn",
          "Slabbers",
          "Slag",
          "Slagboom",
          "Slager",
          "Slageren",
          "Slagers",
          "Slaghekke",
          "Slaghuis",
          "Slagman",
          "Slagmolen",
          "Slagt",
          "Slagter",
          "Slakhorst",
          "Slaman",
          "Slangen",
          "Slangewal",
          "Slappendel",
          "Slats",
          "Slavenburg",
          "Sleddens",
          "Slee",
          "Sleebos",
          "Sleegers",
          "Sleeking",
          "Sleen",
          "Sleenhoff",
          "Sleeuwen",
          "Sleeuwenhoek",
          "Slegers",
          "Slegh",
          "Slegt",
          "Slegtenhorst",
          "Sleijpen",
          "Sleijster",
          "Slemmer",
          "Slendebroek",
          "Slenders",
          "Slenter",
          "Slettenhaar",
          "Sleurink",
          "Sleutjes",
          "Sleuwen",
          "Sleven",
          "Sliedrecht",
          "Sliedregt",
          "Slieker",
          "Sliep",
          "Sliepen",
          "Sligman",
          "Sligtenhorst",
          "Slijfer",
          "Slijkerman",
          "Slijkhuis",
          "Slijm",
          "Slijngard",
          "Slijpen",
          "Slijper",
          "Slijters",
          "Slik",
          "Slikboer",
          "Slikke",
          "Slikker",
          "Slikkerveer",
          "Slim",
          "Slinger",
          "Slingerland",
          "Slings",
          "Slinkman",
          "Slippens",
          "Slits",
          "Slob",
          "Slobbe",
          "Slochteren",
          "Sloep",
          "Sloesen",
          "Slof",
          "Slofstra",
          "Slok",
          "Slokker",
          "Slokkers",
          "Slomp",
          "Sloof",
          "Slooff",
          "Slooijer",
          "Sloos",
          "Sloot",
          "Slooten",
          "Slooter",
          "Sloothaak",
          "Slootjes",
          "Slootmaker",
          "Slootman",
          "Slootmans",
          "Sloots",
          "Slootweg",
          "Slop",
          "Slor",
          "Slort",
          "Slot",
          "Slotboom",
          "Slotegraaf",
          "Slotema",
          "Slotemaker",
          "Sloten",
          "Sloterdijk",
          "Sloterwijk",
          "Slothouber",
          "Slotman",
          "Slots",
          "Sloun",
          "Slui",
          "Sluijer",
          "Sluijk",
          "Sluijmer",
          "Sluijmers",
          "Sluijs",
          "Sluijsmans",
          "Sluijter",
          "Sluijters",
          "Sluik",
          "Sluiman",
          "Sluimer",
          "Sluis",
          "Sluisveld",
          "Sluiter",
          "Sluiters",
          "Slump",
          "Slurink",
          "Slutter",
          "Sluys",
          "Slöetjes",
          "Smaak",
          "Smaal",
          "Smaalen",
          "Smak",
          "Smakman",
          "Smal",
          "Smalbil",
          "Smalbrugge",
          "Smale",
          "Smalen",
          "Smalheer",
          "Smaling",
          "Smallegange",
          "Smallegoor",
          "Smallenbroek",
          "Smallenburg",
          "Smals",
          "Sman",
          "Smans",
          "Smarius",
          "Smedema",
          "Smeden",
          "Smedes",
          "Smeding",
          "Smedinga",
          "Smedts",
          "Smeekens",
          "Smeekes",
          "Smeele",
          "Smeenge",
          "Smeenk",
          "Smeets",
          "Smeijers",
          "Smeijsters",
          "Smeink",
          "Smeitink",
          "Smelik",
          "Smelt",
          "Smeltink",
          "Smeman",
          "Smet",
          "Smets",
          "Smetsers",
          "Smeulders",
          "Smid",
          "Smids",
          "Smidt",
          "Smidts",
          "Smienk",
          "Smiers",
          "Smies",
          "Smiet",
          "Smilda",
          "Smilde",
          "Sminia",
          "Smink",
          "Smirren",
          "Smissen",
          "Smit",
          "Smith",
          "Smithuis",
          "Smits",
          "Smitshoek",
          "Smitskamp",
          "Smitsman",
          "Smitsmans",
          "Smittenaar",
          "Smittenberg",
          "Smoes",
          "Smol",
          "Smolders",
          "Smolenaars",
          "Smolenaers",
          "Smook",
          "Smoor",
          "Smoorenburg",
          "Smorenberg",
          "Smorenburg",
          "Smout",
          "Smouter",
          "Smulders",
          "Snaaijer",
          "Snaauw",
          "Snabel",
          "Snabilie",
          "Snackers",
          "Snaijer",
          "Snakenborg",
          "Snaphaan",
          "Snapper",
          "Snaterse",
          "Sneeboer",
          "Sneek",
          "Sneekes",
          "Sneep",
          "Sneijder",
          "Sneijders",
          "Sneijers",
          "Snel",
          "Snelder",
          "Snelders",
          "Snelderwaard",
          "Snell",
          "Snelleman",
          "Snellen",
          "Snellenberg",
          "Snellenburg",
          "Snellens",
          "Sneller",
          "Snellink",
          "Snels",
          "Snelting",
          "Snepvangers",
          "Snetselaar",
          "Snieder",
          "Snieders",
          "Sniekers",
          "Snijder",
          "Snijders",
          "Snijkers",
          "Snik",
          "Snikkers",
          "Snip",
          "Snippe",
          "Snippenberg",
          "Snippert",
          "Snitjer",
          "Snitselaar",
          "Sno",
          "Snoeck",
          "Snoei",
          "Snoeij",
          "Snoeijen",
          "Snoeijer",
          "Snoeijers",
          "Snoeijink",
          "Snoeijs",
          "Snoek",
          "Snoeks",
          "Snoep",
          "Snoeren",
          "Snoo",
          "Snoodijk",
          "Snuverink",
          "So",
          "Soares",
          "Soebedar",
          "Soebhan",
          "Soechit",
          "Soede",
          "Soek",
          "Soekha",
          "Soekhai",
          "Soekhan",
          "Soekhlal",
          "Soekhoe",
          "Soekhradj",
          "Soekhram",
          "Soelen",
          "Soentjens",
          "Soepboer",
          "Soepenberg",
          "Soer",
          "Soerdjbali",
          "Soeren",
          "Soerland",
          "Soesbergen",
          "Soesman",
          "Soest",
          "Soet",
          "Soetekouw",
          "Soeteman",
          "Soetendaal",
          "Soetens",
          "Soeter",
          "Soeterboek",
          "Soeterbroek",
          "Soeters",
          "Soethout",
          "Soffers",
          "Soffner",
          "Sohier",
          "Sohilait",
          "Soijer",
          "Sok",
          "Sol",
          "Solak",
          "Soldaat",
          "Soldt",
          "Soliman",
          "Solingen",
          "Solkema",
          "Solleveld",
          "Sollie",
          "Solmaz",
          "Soltani",
          "Somai",
          "Somaroe",
          "Sombroek",
          "Somer",
          "Someren",
          "Somers",
          "Somhorst",
          "Sommeling",
          "Sommen",
          "Sommer",
          "Sommerdijk",
          "Sommeren",
          "Sommers",
          "Somsen",
          "Son",
          "Sondaar",
          "Sondag",
          "Sonder",
          "Sonderen",
          "Sondervan",
          "Sonke",
          "Sonnega",
          "Sonnema",
          "Sonnemans",
          "Sonnenberg",
          "Sonnenschein",
          "Sonneveld",
          "Sonneveldt",
          "Sonnevelt",
          "Sonneville",
          "Sonsbeek",
          "Soolingen",
          "Soolsma",
          "Soomers",
          "Soonius",
          "Soons",
          "Sopacua",
          "Sophia",
          "Soppe",
          "Sorber",
          "Sordam",
          "Soree",
          "Sorge",
          "Sormani",
          "Sosef",
          "Sotthewes",
          "Soudant",
          "Souer",
          "Souhoka",
          "Souisa",
          "Souman",
          "Sour",
          "Souren",
          "Soussi",
          "Souverein",
          "Souverijn",
          "Souwer",
          "Soy",
          "Soysal",
          "Spa",
          "Spaaij",
          "Spaak",
          "Spaan",
          "Spaander",
          "Spaanderman",
          "Spaandonk",
          "Spaans",
          "Spaansen",
          "Spaapen",
          "Spaargaren",
          "Spaendonck",
          "Spaendonk",
          "Spakman",
          "Spalburg",
          "Spall",
          "Span",
          "Spanbroek",
          "Spang",
          "Spangenberg",
          "Spanhaak",
          "Spaninks",
          "Spanjaard",
          "Spanjaards",
          "Spanjaart",
          "Spanje",
          "Spanjer",
          "Spanjers",
          "Spanjersberg",
          "Spank",
          "Spankeren",
          "Spannenburg",
          "Spanninga",
          "Spans",
          "Spapens",
          "Sparidaens",
          "Sparidans",
          "Sparla",
          "Sparnaaij",
          "Sparreboom",
          "Spauwen",
          "Specht",
          "Specken",
          "Spee",
          "Speek",
          "Speekenbrink",
          "Speel",
          "Speelman",
          "Speerstra",
          "Speet",
          "Speetjens",
          "Speets",
          "Speijer",
          "Speijers",
          "Spek",
          "Spekking",
          "Spekle",
          "Spekman",
          "Spekreijse",
          "Spekschoor",
          "Speksnijder",
          "Spel",
          "Spelbos",
          "Spelbrink",
          "Spelde",
          "Speller",
          "Spelt",
          "Spencer",
          "Spengen",
          "Spenkelink",
          "Sperber",
          "Sperling",
          "Spermon",
          "Speth",
          "Speulman",
          "Spieard",
          "Spiegel",
          "Spiegelaar",
          "Spiegelenberg",
          "Spieker",
          "Spiekerman",
          "Spiekman",
          "Spier",
          "Spierdijk",
          "Spierenburg",
          "Spiering",
          "Spieringhs",
          "Spierings",
          "Spierts",
          "Spiertz",
          "Spies",
          "Spigt",
          "Spijk",
          "Spijker",
          "Spijkerboer",
          "Spijkeren",
          "Spijkerman",
          "Spijkers",
          "Spijkman",
          "Spijksma",
          "Spijkstra",
          "Spikker",
          "Spikmans",
          "Spil",
          "Spiljard",
          "Spilker",
          "Spilt",
          "Spin",
          "Spinder",
          "Spinhoven",
          "Spit",
          "Spithoff",
          "Spithorst",
          "Spithoven",
          "Spits",
          "Spitsbaard",
          "Spitse",
          "Spitteler",
          "Spitters",
          "Spliet",
          "Splint",
          "Splinter",
          "Split",
          "Splithof",
          "Splunder",
          "Splunter",
          "Spoel",
          "Spoelder",
          "Spoelman",
          "Spoelstra",
          "Sponselee",
          "Spoolder",
          "Spoor",
          "Spooren",
          "Spoorenberg",
          "Spoormakers",
          "Spork",
          "Sporken",
          "Sporkslede",
          "Sportel",
          "Spraakman",
          "Sprakel",
          "Sprang",
          "Sprangers",
          "Spreen",
          "Spreeuw",
          "Spreeuwel",
          "Spreeuwenberg",
          "Spreeuwers",
          "Spreij",
          "Spreng",
          "Sprenger",
          "Sprengers",
          "Sprenkeling",
          "Sprenkels",
          "Spreuwel",
          "Spriensma",
          "Sprik",
          "Springer",
          "Springintveld",
          "Sprinkhuizen",
          "Sprokholt",
          "Sprokkereef",
          "Spronck",
          "Sprong",
          "Spronk",
          "Spronken",
          "Spronsen",
          "Spruijt",
          "Spruijtenburg",
          "Spruit",
          "Spruitenburg",
          "Sprundel",
          "Spruyt",
          "Spuij",
          "Spuijbroek",
          "Staa",
          "Staaij",
          "Staak",
          "Staaks",
          "Staal",
          "Staalduinen",
          "Staalman",
          "Staals",
          "Staarink",
          "Staas",
          "Staat",
          "Staats",
          "Stabel",
          "Stad",
          "Staden",
          "Stadhouder",
          "Stadhouders",
          "Stadman",
          "Stadt",
          "Stafleu",
          "Stahl",
          "Stakenborg",
          "Stakenburg",
          "Stal",
          "Stalenhoef",
          "Stalknecht",
          "Stallinga",
          "Stallmann",
          "Stalman",
          "Stalpers",
          "Stals",
          "Stam",
          "Staman",
          "Stamhuis",
          "Stammen",
          "Stammes",
          "Stamps",
          "Stams",
          "Standaar",
          "Stander",
          "Staneke",
          "Stange",
          "Stanneveld",
          "Stans",
          "Stap",
          "Stapel",
          "Stapelbroek",
          "Stapelkamp",
          "Stapersma",
          "Stapert",
          "Staphorst",
          "Stappen",
          "Stappenbeld",
          "Stapper",
          "Stappers",
          "Stappershoef",
          "Staps",
          "Star",
          "Staring",
          "Starink",
          "Stark",
          "Starke",
          "Starkenburg",
          "Starmans",
          "Starre",
          "Starren",
          "Starrenburg",
          "Starreveld",
          "Start",
          "Stas",
          "Stasse",
          "Stassen",
          "Statia",
          "Stavast",
          "Stavenuiter",
          "Staveren",
          "Stavinga",
          "Stavleu",
          "Stavorinus",
          "Steba",
          "Stedehouder",
          "Stee",
          "Steeg",
          "Steege",
          "Steegers",
          "Steegh",
          "Steeghs",
          "Steegman",
          "Steegmans",
          "Steegs",
          "Steegstra",
          "Steehouder",
          "Steehouwer",
          "Steekelenburg",
          "Steeman",
          "Steemers",
          "Steen",
          "Steenaart",
          "Steenbakker",
          "Steenbakkers",
          "Steenbeek",
          "Steenbeeke",
          "Steenbekkers",
          "Steenbergen",
          "Steenbreker",
          "Steenbrink",
          "Steenbruggen",
          "Steendam",
          "Steenderen",
          "Steendijk",
          "Steenge",
          "Steenhagen",
          "Steenhoek",
          "Steenhorst",
          "Steenhoven",
          "Steenhuis",
          "Steenhuisen",
          "Steenhuizen",
          "Steenis",
          "Steenkamer",
          "Steenkamp",
          "Steenkist",
          "Steenks",
          "Steenland",
          "Steenman",
          "Steenmeijer",
          "Steennis",
          "Steenoven",
          "Steenpaal",
          "Steenpoorte",
          "Steens",
          "Steensel",
          "Steensma",
          "Steenstra",
          "Steentjes",
          "Steenvoorde",
          "Steenvoorden",
          "Steenvoort",
          "Steenwijk",
          "Steenwinkel",
          "Steer",
          "Steert",
          "Steevens",
          "Steevensz",
          "Steffen",
          "Steffens",
          "Steffers",
          "Steg",
          "Stege",
          "Stegehuis",
          "Stegeman",
          "Stegen",
          "Stegenga",
          "Stegerman",
          "Stegers",
          "Stegge",
          "Steggerda",
          "Steggink",
          "Steghuis",
          "Stegink",
          "Stegmeijer",
          "Stehmann",
          "Stehouwer",
          "Steigenga",
          "Steiginga",
          "Steigstra",
          "Steijaert",
          "Steijger",
          "Steijlen",
          "Steijn",
          "Steijns",
          "Steijvers",
          "Stein",
          "Steinbach",
          "Steinbusch",
          "Steinebach",
          "Steiner",
          "Steinfelder",
          "Steinfort",
          "Steinmann",
          "Steinmeijer",
          "Steinmetz",
          "Steins",
          "Steintjes",
          "Steinvoorn",
          "Steinvoort",
          "Steinz",
          "Stek",
          "Stekelenburg",
          "Steketee",
          "Stel",
          "Stelder",
          "Stellaard",
          "Stellema",
          "Steller",
          "Stelling",
          "Stellinga",
          "Stellingwerf",
          "Stellingwerff",
          "Stelloo",
          "Stelma",
          "Stelpstra",
          "Stelt",
          "Stelte",
          "Stelten",
          "Steltenpool",
          "Stelwagen",
          "Steman",
          "Stemerding",
          "Stemerdink",
          "Stemkens",
          "Stempher",
          "Stempvoort",
          "Stender",
          "Steneker",
          "Stenekes",
          "Stengs",
          "Stenis",
          "Stensen",
          "Stenvers",
          "Stenvert",
          "Stephan",
          "Ster",
          "Sterenberg",
          "Sterenborg",
          "Steringa",
          "Sterk",
          "Sterke",
          "Sterken",
          "Sterkenburg",
          "Sterkenburgh",
          "Sterkens",
          "Sterkman",
          "Sterks",
          "Sterling",
          "Stern",
          "Sterre",
          "Sterren",
          "Sterrenberg",
          "Sterrenburg",
          "Stet",
          "Steunebrink",
          "Steunenberg",
          "Steur",
          "Steutel",
          "Steuten",
          "Stevelink",
          "Stevelmans",
          "Steveninck",
          "Stevens",
          "Stevense",
          "Steverink",
          "Stewart",
          "Stibbe",
          "Stiekema",
          "Stielstra",
          "Stiemer",
          "Stienen",
          "Stienezen",
          "Stienissen",
          "Stienstra",
          "Stierman",
          "Stift",
          "Stigchel",
          "Stigt",
          "Stigter",
          "Stijf",
          "Stijfs",
          "Stijger",
          "Stijkel",
          "Stijlaart",
          "Stijn",
          "Stijnen",
          "Stijnman",
          "Stijns",
          "Stijntjes",
          "Stijsiger",
          "Stikkelbroeck",
          "Stikkelman",
          "Stikkelorum",
          "Stiksma",
          "Stikvoort",
          "Stil",
          "Stilma",
          "Stinissen",
          "Stins",
          "Stip",
          "Stipdonk",
          "Stiphout",
          "Stitselaar",
          "Stob",
          "Stobbe",
          "Stobbelaar",
          "Stock",
          "Stockmann",
          "Stoel",
          "Stoelhorst",
          "Stoelinga",
          "Stoeltie",
          "Stoelwinder",
          "Stoep",
          "Stoepker",
          "Stoer",
          "Stoeten",
          "Stoevelaar",
          "Stofberg",
          "Stofbergen",
          "Stoffelen",
          "Stoffels",
          "Stoffelsen",
          "Stoffelsma",
          "Stoffer",
          "Stoffers",
          "Stofmeel",
          "Stojanović",
          "Stok",
          "Stoker",
          "Stokhof",
          "Stokkel",
          "Stokker",
          "Stokkermans",
          "Stokkers",
          "Stokking",
          "Stokkink",
          "Stokkom",
          "Stokkum",
          "Stokman",
          "Stokmans",
          "Stokreef",
          "Stokroos",
          "Stoks",
          "Stokvis",
          "Stokx",
          "Stol",
          "Stolk",
          "Stolker",
          "Stoll",
          "Stollman",
          "Stolp",
          "Stolpe",
          "Stols",
          "Stolte",
          "Stoltenborg",
          "Stoltenkamp",
          "Stoltz",
          "Stolwerk",
          "Stolwijk",
          "Stolze",
          "Stolzenbach",
          "Stomp",
          "Stomphorst",
          "Stomps",
          "Stoof",
          "Stooker",
          "Stoop",
          "Stoopen",
          "Stoopman",
          "Stoops",
          "Stoorvogel",
          "Stoot",
          "Stoots",
          "Stopel",
          "Stoppelenburg",
          "Stoppels",
          "Stor",
          "Storcken",
          "Storij",
          "Storimans",
          "Stork",
          "Storm",
          "Stormbroek",
          "Storms",
          "Stornebrink",
          "Storteboom",
          "Stortelder",
          "Stortelers",
          "Stoter",
          "Stotijn",
          "Stougie",
          "Stout",
          "Stoute",
          "Stouten",
          "Stouthamer",
          "Stouthart",
          "Stoutjesdijk",
          "Stouw",
          "Stouwdam",
          "Stouwe",
          "Stoverink",
          "Straalen",
          "Straalman",
          "Straat",
          "Straaten",
          "Straathof",
          "Straatman",
          "Straatsma",
          "Straetemans",
          "Straeten",
          "Stralen",
          "Stralendorff",
          "Strampel",
          "Strang",
          "Straten",
          "Strating",
          "Stratum",
          "Straub",
          "Straus",
          "Straver",
          "Stravers",
          "Streef",
          "Streefkerk",
          "Streefland",
          "Streek",
          "Streekstra",
          "Stremler",
          "Stremmelaar",
          "Streng",
          "Strengers",
          "Streppel",
          "Streuer",
          "Streunding",
          "Streuper",
          "Streur",
          "Streutker",
          "Stribos",
          "Stricker",
          "Striekwold",
          "Strien",
          "Strietman",
          "Strijbis",
          "Strijbos",
          "Strijbosch",
          "Strijder",
          "Strijdhaftig",
          "Strijdveen",
          "Strijen",
          "Strijk",
          "Strijker",
          "Strijkers",
          "Strijkert",
          "Strijland",
          "Strijp",
          "Strik",
          "Strikker",
          "Strikkers",
          "Strikwerda",
          "Strobbe",
          "Strobos",
          "Strockmeijer",
          "Stroe",
          "Stroek",
          "Stroeken",
          "Stroeks",
          "Stroes",
          "Stroet",
          "Stroetinga",
          "Stroeve",
          "Stroink",
          "Strolenberg",
          "Stronkhorst",
          "Stronks",
          "Stroo",
          "Stroobach",
          "Strooband",
          "Strooker",
          "Stroom",
          "Stroomberg",
          "Stroombergen",
          "Stroomer",
          "Stroop",
          "Strooper",
          "Stroosma",
          "Stroosnijder",
          "Stroot",
          "Strootman",
          "Stroucken",
          "Strous",
          "Strubbe",
          "Struijcken",
          "Struijk",
          "Struijs",
          "Struik",
          "Struiken",
          "Struiksma",
          "Struis",
          "Strunk",
          "Struyk",
          "Sträter",
          "Stuart",
          "Stubbe",
          "Stuger",
          "Stuifbergen",
          "Stuifzand",
          "Stuij",
          "Stuijfzand",
          "Stuijt",
          "Stuijts",
          "Stuijvenberg",
          "Stuit",
          "Stuive",
          "Stuivenberg",
          "Stuiver",
          "Stukker",
          "Stulen",
          "Stulp",
          "Stultiens",
          "Stultjens",
          "Stumpel",
          "Stunnenberg",
          "Stupers",
          "Sturing",
          "Sturkenboom",
          "Sturm",
          "Sturmans",
          "Sturme",
          "Sturris",
          "Sturrus",
          "Stut",
          "Stutterheim",
          "Stutvoet",
          "Stuurman",
          "Stuurop",
          "Stuurwold",
          "Stuut",
          "Stuve",
          "Stäbler",
          "Stöver",
          "Su",
          "Sucu",
          "Suelmann",
          "Sueters",
          "Suijdam",
          "Suijk",
          "Suijker",
          "Suijkerbuijk",
          "Suijlekom",
          "Suijlen",
          "Suijs",
          "Suik",
          "Suiker",
          "Suilen",
          "Suitela",
          "Suk",
          "Sukel",
          "Sukhraj",
          "Sukkel",
          "Sulaiman",
          "Sulkers",
          "Sullot",
          "Sulman",
          "Sulmann",
          "Sulsters",
          "Sultan",
          "Sultani",
          "Summeren",
          "Sumter",
          "Sun",
          "Sundert",
          "Suntenmaartensdijk",
          "Suntjens",
          "Super",
          "Supheert",
          "Suppers",
          "Supusepa",
          "Surksum",
          "Susan",
          "Susanna",
          "Susteren",
          "Sutherland",
          "Sutmuller",
          "Suttorp",
          "Suur",
          "Suurd",
          "Suurland",
          "Suurling",
          "Suurmeijer",
          "Suurmond",
          "Suvaal",
          "Suykerbuyk",
          "Swaab",
          "Swaaij",
          "Swaak",
          "Swaan",
          "Swaanen",
          "Swaans",
          "Swaen",
          "Swagemakers",
          "Swager",
          "Swagerman",
          "Swagers",
          "Swam",
          "Swanen",
          "Swanenberg",
          "Swaneveld",
          "Swanink",
          "Swank",
          "Swart",
          "Swarte",
          "Swartjes",
          "Swarts",
          "Swaters",
          "Swaving",
          "Sweegers",
          "Sweelssen",
          "Sweens",
          "Sweep",
          "Sweere",
          "Sweers",
          "Sweerts",
          "Sweet",
          "Swelsen",
          "Swenne",
          "Swertz",
          "Swets",
          "Swiebel",
          "Swier",
          "Swieringa",
          "Swiers",
          "Swierstra",
          "Swieten",
          "Swijnenburg",
          "Swildens",
          "Swillens",
          "Swinkels",
          "Swint",
          "Switzar",
          "Swolfs",
          "Sybesma",
          "Syed",
          "Szabó",
          "Sönmez",
          "Ta",
          "Taal",
          "Taalman",
          "Taams",
          "Taanman",
          "Taat",
          "Tabak",
          "Tabbers",
          "Tabor",
          "Tack",
          "Tacke",
          "Tacken",
          "Taconis",
          "Tacx",
          "Tadema",
          "Taekema",
          "Taffijn",
          "Taha",
          "Tahalele",
          "Tahapary",
          "Taheij",
          "Taheri",
          "Tahir",
          "Tahiri",
          "Tahri",
          "Tahtah",
          "Tai",
          "Taibi",
          "Tajjiou",
          "Tak",
          "Taken",
          "Takens",
          "Takes",
          "Takken",
          "Takkenberg",
          "Taks",
          "Takx",
          "Talbi",
          "Talboom",
          "Talen",
          "Talens",
          "Talhaoui",
          "Talib",
          "Taling",
          "Tallih",
          "Talma",
          "Talman",
          "Talsma",
          "Talstra",
          "Tam",
          "Tambach",
          "Tamboer",
          "Tamelen",
          "Tamer",
          "Tameris",
          "Tamerus",
          "Tames",
          "Taminiau",
          "Tamis",
          "Tammeling",
          "Tammenga",
          "Tammer",
          "Tammes",
          "Tamminga",
          "Tamsma",
          "Tan",
          "Tanahatoe",
          "Tang",
          "Tange",
          "Tangelder",
          "Tangenberg",
          "Tanger",
          "Tanghe",
          "Tanis",
          "Tanja",
          "Tanke",
          "Tankeren",
          "Tankink",
          "Tannemaat",
          "Tanriverdi",
          "Tans",
          "Taouil",
          "Tap",
          "Tappel",
          "Tapper",
          "Tarhan",
          "Tartwijk",
          "Tas",
          "Taselaar",
          "Tasma",
          "Tatenhove",
          "Tates",
          "Tausch",
          "Tavares",
          "Tavenier",
          "Taverne",
          "Tax",
          "Taylor",
          "Tazelaar",
          "Taş",
          "Taşdelen",
          "Taşdemir",
          "Taşkin",
          "Taştan",
          "Tebbens",
          "Teeffelen",
          "Teeken",
          "Teekens",
          "Teekman",
          "Teelen",
          "Teeling",
          "Teems",
          "Teeninga",
          "Teensma",
          "Teer",
          "Teerds",
          "Teerenstra",
          "Teerhuis",
          "Teering",
          "Teerink",
          "Teerling",
          "Teerlink",
          "Teernstra",
          "Teeseling",
          "Teesink",
          "Teeuw",
          "Teeuwen",
          "Teeuwisse",
          "Teeuwissen",
          "Teeuwsen",
          "Tegel",
          "Tegelaar",
          "Tegelaers",
          "Tegels",
          "Tegenbosch",
          "Teggeler",
          "Teheux",
          "Teijema",
          "Teijgeler",
          "Teijlingen",
          "Teisman",
          "Teitsma",
          "Teiwes",
          "Tek",
          "Tekelenburg",
          "Tekin",
          "Teklenburg",
          "Tekstra",
          "Tel",
          "Telgen",
          "Telgenkamp",
          "Telgt",
          "Teljeur",
          "Telkamp",
          "Tellegen",
          "Tellekamp",
          "Telleman",
          "Tellier",
          "Tellingen",
          "Telman",
          "Telussa",
          "Temel",
          "Temme",
          "Temmerman",
          "Temminck",
          "Temming",
          "Temmink",
          "Tempel",
          "Tempelaar",
          "Tempelaars",
          "Tempelman",
          "Tempels",
          "Tempert",
          "Tenbült",
          "Teng",
          "Tenge",
          "Tenhagen",
          "Tenkink",
          "Tennekes",
          "Tenniglo",
          "Tensen",
          "Tent",
          "Tenten",
          "Tentij",
          "Tepe",
          "Teppema",
          "Tepper",
          "Terbeek",
          "Terburg",
          "Tergouw",
          "Terhaar",
          "Terheijden",
          "Terhorst",
          "Terhürne",
          "Terink",
          "Terlaak",
          "Terlien",
          "Terlingen",
          "Terlouw",
          "Terluin",
          "Termaat",
          "Termeer",
          "Termeulen",
          "Termohlen",
          "Termorshuizen",
          "Terol",
          "Terp",
          "Terpstra",
          "Terra",
          "Terschegget",
          "Terstall",
          "Terstappen",
          "Tersteeg",
          "Terstegen",
          "Tervoort",
          "Terweij",
          "Terwel",
          "Terwiel",
          "Terwijn",
          "Terwindt",
          "Terwisga",
          "Terwisscha van Scheltinga",
          "Terzi",
          "Tesink",
          "Teske",
          "Tessel",
          "Tesselaar",
          "Tessemaker",
          "Tesser",
          "Tessers",
          "Testerink",
          "Testroote",
          "Tetelepta",
          "Tetenburg",
          "Tetering",
          "Teters",
          "Tetik",
          "Tettelaar",
          "Tettero",
          "Tetteroo",
          "Teuben",
          "Teuling",
          "Teulings",
          "Teune",
          "Teunen",
          "Teunenbroek",
          "Teunis",
          "Teunisse",
          "Teunissen",
          "Teunissen van Manen",
          "Teuns",
          "Teurlings",
          "Teusink",
          "Teuwen",
          "Teuwsen",
          "Tevel",
          "Tevreden",
          "Tewari",
          "Thakoer",
          "Thakoerdat",
          "Thakoerdin",
          "Thakoersingh",
          "Thalen",
          "The",
          "Theebe",
          "Theelen",
          "Theeuwen",
          "Theeuwes",
          "Theije",
          "Theijs",
          "Theijssen",
          "Theil",
          "Theissen",
          "Thelen",
          "Theloosen",
          "Thelosen",
          "Themen",
          "Thenu",
          "Thesing",
          "Theuerzeit",
          "Theune",
          "Theunis",
          "Theunisse",
          "Theunissen",
          "Theunisz",
          "Theuns",
          "Theuws",
          "Thewessen",
          "Thewissen",
          "Thie",
          "Thiel",
          "Thiele",
          "Thielen",
          "Thielens",
          "Thielman",
          "Thiemann",
          "Thieme",
          "Thienen",
          "Thierry",
          "Thies",
          "Thiescheffer",
          "Thiesen",
          "Thiessen",
          "Thij",
          "Thije",
          "Thijm",
          "Thijs",
          "Thijsen",
          "Thijsse",
          "Thijsseling",
          "Thijssen",
          "Thijssens",
          "Thillart",
          "Thimister",
          "Thio",
          "Thissen",
          "Thodé",
          "Thoen",
          "Thole",
          "Tholen",
          "Thoma",
          "Thomas",
          "Thomasse",
          "Thomassen",
          "Thomissen",
          "Thompson",
          "Thomson",
          "Thonen",
          "Thoolen",
          "Thoonen",
          "Thoonsen",
          "Thoor",
          "Thuijl",
          "Thuijs",
          "Thuis",
          "Thung",
          "Thunnissen",
          "Thus",
          "Thuss",
          "Thönissen",
          "Tibbe",
          "Tibben",
          "Tibboel",
          "Tiben",
          "Tibosch",
          "Tichelaar",
          "Ticheler",
          "Tichem",
          "Tieben",
          "Tiebie",
          "Tiebosch",
          "Tiecken",
          "Tiedink",
          "Tiehuis",
          "Tieken",
          "Tiekstra",
          "Tiel",
          "Tiel Groenestege",
          "Tieland",
          "Tielbeke",
          "Tieleman",
          "Tielemans",
          "Tielen",
          "Tielenburg",
          "Tielens",
          "Tielman",
          "Tielrooij",
          "Tieltjes",
          "Tiem",
          "Tieman",
          "Tiemens",
          "Tiemersma",
          "Tiemes",
          "Tiemessen",
          "Tiemissen",
          "Tiems",
          "Tien",
          "Tienderen",
          "Tienen",
          "Tienhoven",
          "Tienkamp",
          "Tienstra",
          "Tier",
          "Tierie",
          "Tiersma",
          "Tiesinga",
          "Tietema",
          "Tigchelaar",
          "Tigelaar",
          "Tiggelaar",
          "Tiggelen",
          "Tiggelman",
          "Tiggeloven",
          "Tighadouini",
          "Tijdeman",
          "Tijdhof",
          "Tijdink",
          "Tije",
          "Tijhaar",
          "Tijhof",
          "Tijhuis",
          "Tijink",
          "Tijl",
          "Tijm",
          "Tijman",
          "Tijmensen",
          "Tijmes",
          "Tijms",
          "Tijmstra",
          "Tijnagel",
          "Tijs",
          "Tijsen",
          "Tijsma",
          "Tijsseling",
          "Tijssen",
          "Tijssens",
          "Tijsterman",
          "Tikai",
          "Til",
          "Tilanus",
          "Tilborg",
          "Tilborgh",
          "Tilburg",
          "Tilburgs",
          "Tillaar",
          "Tillaart",
          "Tillart",
          "Tillema",
          "Tilleman",
          "Tillemans",
          "Tillie",
          "Tillmans",
          "Tillo",
          "Tilma",
          "Tilman",
          "Tilmans",
          "Tilroe",
          "Tilstra",
          "Timal",
          "Timan",
          "Timans",
          "Timisela",
          "Timman",
          "Timmer",
          "Timmeren",
          "Timmerhuis",
          "Timmerije",
          "Timmerman",
          "Timmermans",
          "Timmers",
          "Timp",
          "Tims",
          "Tinga",
          "Tinge",
          "Tingen",
          "Tinholt",
          "Tinnemans",
          "Tinneveld",
          "Tintelen",
          "Tio",
          "Tip",
          "Tipker",
          "Tippe",
          "Tirion",
          "Tissen",
          "Tissingh",
          "Tissink",
          "Titsing",
          "Titulaer",
          "Tjaden",
          "Tjallinks",
          "Tjalma",
          "Tjalsma",
          "Tjan",
          "Tjassing",
          "Tjebbes",
          "Tjeerdsma",
          "Tjeertes",
          "Tjepkema",
          "Tjerkstra",
          "Tjia",
          "Tjin",
          "Tjoa",
          "Tjoelker",
          "Tjon",
          "Tjoonk",
          "To",
          "Tobben",
          "Tober",
          "Tobé",
          "Toebak",
          "Toebast",
          "Toebes",
          "Toelen",
          "Toelsie",
          "Toemen",
          "Toepoel",
          "Toering",
          "Toes",
          "Toet",
          "Toetenel",
          "Toeter",
          "Togt",
          "Tok",
          "Toker",
          "Tokkie",
          "Tol",
          "Tolboom",
          "Toledo",
          "Tolen",
          "Tolenaar",
          "Tolenaars",
          "Tolhoek",
          "Tolhuis",
          "Tolhuisen",
          "Tolij",
          "Tolk",
          "Tolkamp",
          "Tollenaar",
          "Tolman",
          "Tolner",
          "Tolsma",
          "Tolud",
          "Tom",
          "Toma",
          "Tomas",
          "Tomasoa",
          "Tomassen",
          "Tombe",
          "Tomesen",
          "Ton",
          "Tonen",
          "Tong",
          "Tongeren",
          "Tongerlo",
          "Tongerloo",
          "Tonies",
          "Tonino",
          "Tonk",
          "Tonkens",
          "Tonkes",
          "Tonnaer",
          "Tonnard",
          "Tool",
          "Toolen",
          "Toom",
          "Toonder",
          "Toonders",
          "Toonen",
          "Toonstra",
          "Toor",
          "Tooren",
          "Toorenburg",
          "Toorn",
          "Toornstra",
          "Toornvliet",
          "Toorop",
          "Tooten",
          "Top",
          "Topal",
          "Topcu",
          "Topelen",
          "Topper",
          "Toprak",
          "Tops",
          "Topuz",
          "Topçu",
          "Toren",
          "Torenbeek",
          "Torensma",
          "Torenstra",
          "Torenvlied",
          "Torn",
          "Torn Broers",
          "Torre",
          "Torren",
          "Torun",
          "Tossings",
          "Tosun",
          "Tot",
          "Touber",
          "Tour",
          "Tournier",
          "Tousain",
          "Toussaint",
          "Toutenhoofd",
          "Touw",
          "Touwen",
          "Touwslager",
          "Touzani",
          "Toxopeus",
          "Traa",
          "Traas",
          "Traets",
          "Tragter",
          "Tramper",
          "Tran",
          "Trap",
          "Trapman",
          "Travaille",
          "Treep",
          "Treffers",
          "Treijen",
          "Trenning",
          "Trentelman",
          "Trepels",
          "Treur",
          "Treure",
          "Treuren",
          "Treurniet",
          "Tricht",
          "Triemstra",
          "Trienekens",
          "Triep",
          "Triepels",
          "Trier",
          "Trierum",
          "Triest",
          "Triet",
          "Trigt",
          "Trijp",
          "Trilsbeek",
          "Trimbach",
          "Trimbos",
          "Trimp",
          "Trines",
          "Trinh",
          "Trinidad",
          "Trinks",
          "Trip",
          "Troelstra",
          "Troije",
          "Troisfontaine",
          "Trommel",
          "Trommelen",
          "Tromp",
          "Trompert",
          "Trompetter",
          "Troost",
          "Trooster",
          "Tros",
          "Trouw",
          "Trouwborst",
          "Truijen",
          "Truijens",
          "Trum",
          "Truong",
          "Trustfull",
          "Tsang",
          "Tse",
          "Tseng",
          "Tubben",
          "Tubée",
          "Tuel",
          "Tuenter",
          "Tuerlings",
          "Tuhuteru",
          "Tuijl",
          "Tuijn",
          "Tuijnman",
          "Tuijp",
          "Tuijt",
          "Tuijtel",
          "Tuijtelaars",
          "Tuik",
          "Tuil",
          "Tuin",
          "Tuinder",
          "Tuinema",
          "Tuinen",
          "Tuinenburg",
          "Tuinenga",
          "Tuinfort",
          "Tuinhof",
          "Tuinhout",
          "Tuinier",
          "Tuininga",
          "Tuinman",
          "Tuinstra",
          "Tuinte",
          "Tuip",
          "Tuit",
          "Tuitel",
          "Tuiten",
          "Tuitert",
          "Tuithof",
          "Tuitman",
          "Tuk",
          "Tukker",
          "Tukkers",
          "Tulden",
          "Tulder",
          "Tulen",
          "Tullemans",
          "Tuller",
          "Tulling",
          "Tulner",
          "Tulp",
          "Tuls",
          "Tuma",
          "Tummers",
          "Tump",
          "Tuna",
          "Tuncer",
          "Tunderman",
          "Tunen",
          "Tunnissen",
          "Tuns",
          "Tunç",
          "Turan",
          "Turck",
          "Turenhout",
          "Turfboer",
          "Turgut",
          "Turhan",
          "Turk",
          "Turkenburg",
          "Turksema",
          "Turksma",
          "Turkstra",
          "Turlings",
          "Turner",
          "Turnhout",
          "Turpijn",
          "Tusscher",
          "Tussenbroek",
          "Tusveld",
          "Tutert",
          "Tuuk",
          "Tuyl",
          "Tuynman",
          "Twaalfhoven",
          "Tweeboom",
          "Tweel",
          "Twickler",
          "Twigt",
          "Twijnstra",
          "Twilhaar",
          "Twillert",
          "Twilt",
          "Twint",
          "Twisk",
          "Twist",
          "Twuijver",
          "Tóth",
          "Többen",
          "Tönnissen",
          "Töpfer",
          "Ubachs",
          "Ubaghs",
          "Ubags",
          "Ubbels",
          "Ubben",
          "Ubbens",
          "Ubbink",
          "Ubeda",
          "Ubels",
          "Ubink",
          "Udding",
          "Udema",
          "Uden",
          "Uding",
          "Udinga",
          "Udink",
          "Udo",
          "Uem",
          "Uenk",
          "Uffelen",
          "Uffen",
          "Uffing",
          "Ufkes",
          "Uhm",
          "Uijen",
          "Uijl",
          "Uijlenbroek",
          "UijtdeHaag",
          "Uijtdewilligen",
          "Uijtendaal",
          "Uijterlinde",
          "Uijterwaal",
          "Uijtewaal",
          "Uijthoven",
          "Uijttewaal",
          "Uil",
          "Uildriks",
          "Uilenberg",
          "Uitbeijerse",
          "Uitdewilligen",
          "Uitenbroek",
          "Uitendaal",
          "Uiterloo",
          "Uitermark",
          "Uitert",
          "Uiterwaal",
          "Uiterweerd",
          "Uiterwijk",
          "Uiterwijk Winkel",
          "Uithol",
          "Uitman",
          "Uitslag",
          "Uittenbogaard",
          "Uittenbosch",
          "Uittenbroek",
          "Uitterdijk",
          "Uitterhoeve",
          "Uitterlinden",
          "Uitvlugt",
          "Uitzetter",
          "Ulaş",
          "Ulden",
          "Ulehake",
          "Uleman",
          "Ulfman",
          "Ulijn",
          "Uljee",
          "Ulrich",
          "Ulsen",
          "Ultee",
          "Ulu",
          "Ulusoy",
          "Umans",
          "Ummels",
          "Uneken",
          "Unen",
          "Unger",
          "Unnik",
          "Uphoff",
          "Uppelschoten",
          "Urbach",
          "Urban",
          "Urbanus",
          "Urgert",
          "Uriot",
          "Urk",
          "Urlings",
          "Urselmann",
          "Ursem",
          "Ursinus",
          "Uslu",
          "Usmany",
          "Usta",
          "Utrecht",
          "Uuldriks",
          "Uum",
          "Uyar",
          "Uysal",
          "Uz",
          "Uzun",
          "Uçar",
          "Uğur",
          "Uğurlu",
          "Vaags",
          "Vaal",
          "Vaan",
          "Vaandering",
          "Vaandrager",
          "Vaanhold",
          "Vaanholt",
          "Vaarkamp",
          "Vaart",
          "Vaartjes",
          "Vaarwerk",
          "Vaas",
          "Vaasen",
          "Vaassen",
          "Vaate",
          "Vaatstra",
          "Vader",
          "Vaders",
          "Vaes",
          "Vaessen",
          "Vaessens",
          "Vagevuur",
          "Vahl",
          "Vahrmeijer",
          "Valburg",
          "Valckx",
          "Valderen",
          "Vale",
          "Valen",
          "Valent",
          "Valenteijn",
          "Valentijn",
          "Valentin",
          "Valies",
          "Valk",
          "Valke",
          "Valkema",
          "Valken",
          "Valkenaars",
          "Valkenberg",
          "Valkenburg",
          "Valkengoed",
          "Valkenhoef",
          "Valkenhoff",
          "Valkenier",
          "Valkering",
          "Valkhof",
          "Valkman",
          "Valks",
          "Vallen",
          "Vallinga",
          "Valpoort",
          "Valstar",
          "Valster",
          "Van",
          "Vandeberg",
          "Vanderheijden",
          "Vane",
          "Vaneker",
          "Vaneman",
          "Vanenburg",
          "Vanhommerig",
          "Vankan",
          "Vanlier",
          "Vanwersch",
          "Varekamp",
          "Varga",
          "Varik",
          "Vark",
          "Varkevisser",
          "Varol",
          "Varwijk",
          "Vasen",
          "Vasilda",
          "Vasse",
          "Vasseur",
          "Vast",
          "Vastenburg",
          "Vastenhoud",
          "Vastenhout",
          "Vastenhouw",
          "Vat",
          "Vecht",
          "Vedder",
          "Veefkind",
          "Veeger",
          "Veek",
          "Veeke",
          "Veeken",
          "Veekens",
          "Veel",
          "Veelen",
          "Veelenturf",
          "Veelers",
          "Veeman",
          "Veen",
          "Veenboer",
          "Veenbrink",
          "Veendorp",
          "Veenema",
          "Veeneman",
          "Veenen",
          "Veenendaal",
          "Veenhof",
          "Veenhoven",
          "Veenhuis",
          "Veenhuizen",
          "Veening",
          "Veeninga",
          "Veeningen",
          "Veenings",
          "Veenink",
          "Veenis",
          "Veenje",
          "Veenkamp",
          "Veenker",
          "Veenma",
          "Veenman",
          "Veens",
          "Veenschoten",
          "Veensma",
          "Veenstra",
          "Veentjer",
          "Veenvliet",
          "Veer",
          "Veerbeek",
          "Veerdonk",
          "Veerhoek",
          "Veerhuis",
          "Veerkamp",
          "Veerman",
          "Vega",
          "Vegchel",
          "Veger",
          "Vegers",
          "Veggel",
          "Veghel",
          "Vegt",
          "Vegte",
          "Vegten",
          "Vegter",
          "Vehof",
          "Veij",
          "Veijer",
          "Vekemans",
          "Veken",
          "Velberg",
          "Veld",
          "Velda",
          "Veldboer",
          "Veldboom",
          "Velde",
          "Velde Harsenhorst",
          "Veldema",
          "Velden",
          "Velderman",
          "Velders",
          "Veldhoen",
          "Veldhof",
          "Veldhorst",
          "Veldhoven",
          "Veldhuijsen",
          "Veldhuijzen",
          "Veldhuijzen van Zanten",
          "Veldhuis",
          "Veldhuisen",
          "Veldhuizen",
          "Veldink",
          "Veldkamp",
          "Veldman",
          "Veldmeijer",
          "Veldpaus",
          "Veldscholten",
          "Veldsink",
          "Veldstra",
          "Veldt",
          "Veldwijk",
          "Velema",
          "Velgersdijk",
          "Veling",
          "Vellekoop",
          "Vellema",
          "Velleman",
          "Vellenga",
          "Vellinga",
          "Velner",
          "Velraeds",
          "Vels",
          "Velsen",
          "Velsink",
          "Velstra",
          "Velt",
          "Velten",
          "Veltenaar",
          "Velter",
          "Velthoen",
          "Velthof",
          "Velthorst",
          "Velthoven",
          "Velthuijs",
          "Velthuijsen",
          "Velthuijzen",
          "Velthuis",
          "Velthuizen",
          "Velting",
          "Veltink",
          "Veltkamp",
          "Veltmaat",
          "Veltman",
          "Veltmeijer",
          "Veltrop",
          "Veluw",
          "Veluwen",
          "Veluwenkamp",
          "Velzeboer",
          "Velzen",
          "Vemde",
          "Ven",
          "Vencken",
          "Vendel",
          "Vendelbosch",
          "Vendeloo",
          "Venderbos",
          "Venderbosch",
          "Vendrig",
          "Vendrik",
          "Veneberg",
          "Veneboer",
          "Venekamp",
          "Veneklaas",
          "Venema",
          "Veneman",
          "Venhorst",
          "Venhovens",
          "Venhuis",
          "Venhuizen",
          "Vening",
          "Veninga",
          "Venis",
          "Venmans",
          "Venne",
          "Vennegoor",
          "Venneker",
          "Vennema",
          "Venneman",
          "Venner",
          "Vennik",
          "Vennink",
          "Vennix",
          "Venrooij",
          "Vens",
          "Venselaar",
          "Vent",
          "Vente",
          "Ventevogel",
          "Venus",
          "Vera",
          "Veraa",
          "Veraar",
          "Veraart",
          "Verbaan",
          "Verbaandert",
          "Verbaarschot",
          "Verbaas",
          "Verbakel",
          "Verbart",
          "Verbaten",
          "Verbeek",
          "Verbeem",
          "Verbeet",
          "Verbeeten",
          "Verbeij",
          "Verberg",
          "Verberk",
          "Verberkmoes",
          "Verberkt",
          "Verberne",
          "Verbeten",
          "Verbeucken",
          "Verbiesen",
          "Verbiest",
          "Verbij",
          "Verbist",
          "Verbocht",
          "Verboeket",
          "Verbogt",
          "Verbon",
          "Verbong",
          "Verboom",
          "Verboon",
          "Verboort",
          "Verboven",
          "Verbraak",
          "Verbraeken",
          "Verbree",
          "Verbroekken",
          "Verbrugge",
          "Verbruggen",
          "Verbrugh",
          "Verbugt",
          "Verbunt",
          "Verburg",
          "Verburgh",
          "Verburgt",
          "Vercammen",
          "Vercauteren",
          "Vercoulen",
          "Vercouteren",
          "Verdaas",
          "Verdaasdonk",
          "Verdam",
          "Verdegaal",
          "Verdel",
          "Verdellen",
          "Verdiesen",
          "Verdijk",
          "Verdoes",
          "Verdonck",
          "Verdonk",
          "Verdonkschot",
          "Verdonschot",
          "Verdoold",
          "Verdoorn",
          "Verdouw",
          "Verduijn",
          "Verduin",
          "Verdult",
          "Verdurmen",
          "Verduyn",
          "Vereecken",
          "Vereggen",
          "Vereijken",
          "Verest",
          "Verf",
          "Vergeer",
          "Vergeest",
          "Vergeldt",
          "Vergers",
          "Vergert",
          "Vergoossen",
          "Vergouw",
          "Vergouwe",
          "Vergouwen",
          "Vergroesen",
          "Vergunst",
          "Verhaaf",
          "Verhaaff",
          "Verhaag",
          "Verhaagen",
          "Verhaak",
          "Verhaar",
          "Verhaard",
          "Verhaaren",
          "Verhaart",
          "Verhaeg",
          "Verhaegen",
          "Verhaegh",
          "Verhaeren",
          "Verhage",
          "Verhagen",
          "Verhallen",
          "Verhappen",
          "Verharen",
          "Verhart",
          "Verhees",
          "Verheesen",
          "Verheezen",
          "Verheggen",
          "Verheij",
          "Verheijde",
          "Verheijden",
          "Verheijen",
          "Verheijke",
          "Verhelst",
          "Verheugd",
          "Verheul",
          "Verheuvel",
          "Verhey",
          "Verheyen",
          "Verhoeckx",
          "Verhoef",
          "Verhoeff",
          "Verhoek",
          "Verhoeks",
          "Verhoeve",
          "Verhoeven",
          "Verhofstad",
          "Verhofstadt",
          "Verhoof",
          "Verhoofstad",
          "Verhoog",
          "Verhoogt",
          "Verhoosel",
          "Verhorst",
          "Verhulsdonck",
          "Verhulst",
          "Veringa",
          "Veringmeier",
          "Verjans",
          "Verkaaik",
          "Verkaart",
          "Verkade",
          "Verkaik",
          "Verkamman",
          "Verkennis",
          "Verkerk",
          "Verkerke",
          "Verkijk",
          "Verkleij",
          "Verkoeijen",
          "Verkoelen",
          "Verkoijen",
          "Verkooijen",
          "Verkoulen",
          "Verkouter",
          "Verkroost",
          "Verkuijl",
          "Verkuijlen",
          "Verkuil",
          "Verlaan",
          "Verlaat",
          "Verlaek",
          "Verlangen",
          "Verlee",
          "Verleg",
          "Verlegh",
          "Verleun",
          "Verlijsdonk",
          "Verlind",
          "Verlinde",
          "Verlinden",
          "Verlooij",
          "Verloop",
          "Verlouw",
          "Vermaak",
          "Vermaas",
          "Vermaat",
          "Vermaesen",
          "Vermaire",
          "Vermanen",
          "Vermaning",
          "Vermast",
          "Vermazeren",
          "Vermeegen",
          "Vermeer",
          "Vermeeren",
          "Vermeij",
          "Vermeijden",
          "Vermeire",
          "Vermeiren",
          "Vermeltfoort",
          "Vermetten",
          "Vermeul",
          "Vermeule",
          "Vermeulen",
          "Vermij",
          "Vermijs",
          "Vermin",
          "Vermoen",
          "Vermolen",
          "Vermond",
          "Vermonden",
          "Vermorken",
          "Vermue",
          "Vermulm",
          "Vermulst",
          "Vermunt",
          "Vernes",
          "Vernhout",
          "Vernimmen",
          "Vernooij",
          "Verolme",
          "Verouden",
          "Verpaalen",
          "Verpalen",
          "Verplak",
          "Verplancke",
          "Verplanke",
          "Verploeg",
          "Verploegen",
          "Verploegh",
          "Verpoort",
          "Verpoorte",
          "Verpoorten",
          "Verra",
          "Verreck",
          "Verreijt",
          "Verriet",
          "Verrijdt",
          "Verrijp",
          "Verrijt",
          "Verrips",
          "Verroen",
          "Versantvoort",
          "Verschelling",
          "Verschoof",
          "Verschoor",
          "Verschragen",
          "Verschueren",
          "Verschuijten",
          "Verschure",
          "Verschuren",
          "Verschut",
          "Verschuur",
          "Verschuure",
          "Verschuuren",
          "Versendaal",
          "Verseput",
          "Verseveld",
          "Versfeld",
          "Versleijen",
          "Versloot",
          "Versluijs",
          "Versluis",
          "Versmissen",
          "Versnel",
          "Verspaandonk",
          "Verspagen",
          "Verspaget",
          "Verspeek",
          "Verspoor",
          "Versprille",
          "Verspui",
          "Verspuij",
          "Verstappen",
          "Versteden",
          "Versteeg",
          "Versteege",
          "Versteegen",
          "Versteegh",
          "Versteegt",
          "Verstege",
          "Verstegen",
          "Versteijnen",
          "Verstijlen",
          "Verstijnen",
          "Verstoep",
          "Verstraate",
          "Verstraaten",
          "Verstraelen",
          "Verstraete",
          "Verstraeten",
          "Verstralen",
          "Verstrate",
          "Verstraten",
          "Vertegaal",
          "Vertelman",
          "Verton",
          "Vervaart",
          "Vervaet",
          "Vervat",
          "Verveen",
          "Verveer",
          "Verveld",
          "Vervelde",
          "Vervenne",
          "Verver",
          "Ververgaert",
          "Ververs",
          "Vervest",
          "Vervloed",
          "Vervloet",
          "Vervoordeldonk",
          "Vervoorn",
          "Vervoort",
          "Vervuren",
          "Vervuurt",
          "Verwaaijen",
          "Verwaal",
          "Verwaijen",
          "Verwater",
          "Verweel",
          "Verweg",
          "Verwegen",
          "Verweij",
          "Verweijen",
          "Verweijmeren",
          "Verwer",
          "Verwey",
          "Verwiel",
          "Verwijk",
          "Verwijlen",
          "Verwijmeren",
          "Verwijs",
          "Verwijst",
          "Verwilligen",
          "Verwimp",
          "Verwoerd",
          "Verwoerdt",
          "Verwoert",
          "Verwolf",
          "Verzaal",
          "Verzijden",
          "Verzijl",
          "Verzuu",
          "Vessem",
          "Vesseur",
          "Vessies",
          "Vester",
          "Vestering",
          "Vesters",
          "Vestjens",
          "Vet",
          "Veth",
          "Vette",
          "Vetten",
          "Vetter",
          "Veugelers",
          "Veugen",
          "Veuger",
          "Veul",
          "Veulings",
          "Veur",
          "Veurink",
          "Veurman",
          "Vial",
          "Vialle",
          "Vianen",
          "Victoria",
          "Videler",
          "Viegen",
          "Vieira",
          "Viel",
          "Vielvoije",
          "Vierbergen",
          "Viergever",
          "Vierhout",
          "Vierhoven",
          "Vierhuis",
          "Vierkant",
          "Vierling",
          "Viersen",
          "Viersma",
          "Vierstra",
          "Vierveijzer",
          "Vierwind",
          "Viester",
          "Viet",
          "Viets",
          "Vieveen",
          "Viguurs",
          "Vijent",
          "Vijfeijken",
          "Vijfhuizen",
          "Vijfschaft",
          "Vijftigschild",
          "Vijfvinkel",
          "Vijge",
          "Vijgen",
          "Vijlbrief",
          "Vijlder",
          "Vijn",
          "Vijver",
          "Vijverberg",
          "Vijzelaar",
          "Vilder",
          "Villanueva",
          "Villerius",
          "Vilsteren",
          "Vilters",
          "Vin",
          "Vincent",
          "Vincenten",
          "Vinck",
          "Vincken",
          "Vinders",
          "Vingerhoed",
          "Vingerhoets",
          "Vingerling",
          "Vink",
          "Vinke",
          "Vinken",
          "Vinkenborg",
          "Vinkenvleugel",
          "Vinne",
          "Vintges",
          "Virginia",
          "Vis",
          "Visbeek",
          "Visbeen",
          "Visch",
          "Visee",
          "Vishnudatt",
          "Visker",
          "Viskil",
          "Visman",
          "Visschedijk",
          "Visscher",
          "Visschers",
          "Vissenberg",
          "Visser",
          "Visseren",
          "Visserman",
          "Vissers",
          "Vissia",
          "Viswat",
          "Visée",
          "Vittali",
          "Vitters",
          "Viveen",
          "Viëtor",
          "Vlaam",
          "Vlaanderen",
          "Vlaar",
          "Vlaardingen",
          "Vlaardingerbroek",
          "Vlag",
          "Vlak",
          "Vlam",
          "Vlaminckx",
          "Vlaming",
          "Vlamings",
          "Vlas",
          "Vlasakker",
          "Vlasblom",
          "Vlaskamp",
          "Vlasma",
          "Vlasman",
          "Vlassak",
          "Vlastuin",
          "Vlasveld",
          "Vlaswinkel",
          "Vledder",
          "Vleeming",
          "Vleer",
          "Vleesenbeek",
          "Vleeshouwers",
          "Vlek",
          "Vlekkert",
          "Vlemmings",
          "Vlemmix",
          "Vlerk",
          "Vlerken",
          "Vletter",
          "Vleugel",
          "Vleugels",
          "Vleuten",
          "Vlieg",
          "Vliegen",
          "Vliegenthart",
          "Vlieger",
          "Vliek",
          "Vlieland",
          "Vlielander",
          "Vliem",
          "Vlierden",
          "Vlierman",
          "Vliert",
          "Vlies",
          "Vliet",
          "Vlietman",
          "Vlietstra",
          "Vliex",
          "Vlig",
          "Vlijm",
          "Vlijmen",
          "Vlijter",
          "Vlimmeren",
          "Vlis",
          "Vlist",
          "Vlodrop",
          "Vloedbeld",
          "Vloedgraven",
          "Vloemans",
          "Vloet",
          "Vlok",
          "Vlokhoven",
          "Vloon",
          "Vlooswijk",
          "Vlot",
          "Vloten",
          "Vlug",
          "Vluggen",
          "Vlugt",
          "Vlutters",
          "Vo",
          "Vocht",
          "Vochteloo",
          "Vocking",
          "Vodegel",
          "Voer",
          "Voerman",
          "Voermans",
          "Voert",
          "Voesenek",
          "Voesten",
          "Voet",
          "Voetelink",
          "Voeten",
          "Voets",
          "Vogel",
          "Vogelaar",
          "Vogelenzang",
          "Vogelesang",
          "Vogelezang",
          "Vogelpoel",
          "Vogels",
          "Vogelsang",
          "Vogelsangs",
          "Vogelzang",
          "Voges",
          "Vogt",
          "Voigt",
          "Volbeda",
          "Volder",
          "Volders",
          "Volger",
          "Volgers",
          "Volk",
          "Volker",
          "Volkering",
          "Volkerink",
          "Volkers",
          "Volkert",
          "Volkerts",
          "Voll",
          "Vollaard",
          "Volleberg",
          "Vollebergh",
          "Vollebregt",
          "Vollema",
          "Vollenberg",
          "Vollenbroek",
          "Vollering",
          "Vollmuller",
          "Volman",
          "Volmer",
          "Volwater",
          "Volwerk",
          "Vonck",
          "Voncken",
          "Vondel",
          "Vondelen",
          "Vondeling",
          "Vondenhoff",
          "Vonder",
          "Vonderen",
          "Vondervoort",
          "Vonhof",
          "Vonk",
          "Vonk Noordegraaf",
          "Vonkeman",
          "Vonken",
          "Vonno",
          "Vons",
          "Voogd",
          "Voogdt",
          "Voogel",
          "Vooges",
          "Vooght",
          "Voogsgeerd",
          "Voogt",
          "Vooijs",
          "Voois",
          "Voolstra",
          "Voorbach",
          "Voorberg",
          "Voorbergen",
          "Voorbij",
          "Voorbraak",
          "Voorburg",
          "Voorde",
          "Voorden",
          "Voordouw",
          "Vooren",
          "Voorend",
          "Voorhaar",
          "Voorham",
          "Voorhoeve",
          "Voorhorst",
          "Voorhout",
          "Voorhuis",
          "Voorintholt",
          "Voorjans",
          "Voorma",
          "Voormolen",
          "Voorn",
          "Voorneveld",
          "Voors",
          "Voorsluijs",
          "Voorst",
          "Voorst tot Voorst",
          "Voort",
          "Voorthuijsen",
          "Voorthuijzen",
          "Voorthuis",
          "Voorthuizen",
          "Voortman",
          "Voorwinde",
          "Voorwinden",
          "Voorzaat",
          "Vor",
          "Voragen",
          "Vorderman",
          "Vording",
          "Vorenholt",
          "Vorenkamp",
          "Vorgers",
          "Vork",
          "Vorle",
          "Vorm",
          "Vormer",
          "Vorselaars",
          "Vorselen",
          "Vorsselen",
          "Vorst",
          "Vorstenbosch",
          "Vorster",
          "Vorstermans",
          "Vorsteveld",
          "Vorstman",
          "Vos",
          "Voshaar",
          "Voshart",
          "Voshol",
          "Voskamp",
          "Voskes",
          "Voskuijl",
          "Voskuil",
          "Voskuilen",
          "Vosman",
          "Vosmeer",
          "Voss",
          "Vosse",
          "Vossebeld",
          "Vossebelt",
          "Vosseberg",
          "Vosselman",
          "Vossen",
          "Vossenaar",
          "Vossenberg",
          "Vossers",
          "Vosters",
          "Voulon",
          "Vousten",
          "Vrakking",
          "Vrancken",
          "Vrande",
          "Vranken",
          "Vrauwdeunt",
          "Vrede",
          "Vredegoor",
          "Vreden",
          "Vredenberg",
          "Vredenbregt",
          "Vredenburg",
          "Vredendaal",
          "Vredeveld",
          "Vredeveldt",
          "Vredevoort",
          "Vree",
          "Vreeburg",
          "Vreede",
          "Vreekamp",
          "Vreeke",
          "Vreeken",
          "Vreeker",
          "Vreeling",
          "Vreeman",
          "Vreenegoor",
          "Vreeswijk",
          "Vreeze",
          "Vregelaar",
          "Vrehen",
          "Vreijsen",
          "Vreman",
          "Vrencken",
          "Vrenegoor",
          "Vrenken",
          "Vreugd",
          "Vreugdenhil",
          "Vreuls",
          "Vreven",
          "Vrie",
          "Vrieling",
          "Vrielink",
          "Vriend",
          "Vriends",
          "Vriens",
          "Vries",
          "Vriesde",
          "Vriese",
          "Vriesema",
          "Vriesen",
          "Vriesinga",
          "Vriesman",
          "Vrieswijk",
          "Vrieze",
          "Vriezekolk",
          "Vriezema",
          "Vriezen",
          "Vrij",
          "Vrijburg",
          "Vrijdag",
          "Vrijenhoek",
          "Vrijens",
          "Vrijer",
          "Vrijhoef",
          "Vrijhoeven",
          "Vrijhof",
          "Vrijland",
          "Vrijman",
          "Vrijmoed",
          "Vrijs",
          "Vrijsen",
          "Vrind",
          "Vringer",
          "Vrins",
          "Vrinten",
          "Vroed",
          "Vroedt",
          "Vroege",
          "Vroegh",
          "Vroegindeweij",
          "Vroegop",
          "Vroegrijk",
          "Vroemen",
          "Vroenhoven",
          "Vrolijk",
          "Vrolijks",
          "Vroling",
          "Vromans",
          "Vromen",
          "Vrooland",
          "Vroom",
          "Vrooman",
          "Vroomans",
          "Vroome",
          "Vroomen",
          "Vroon",
          "Vroonhoven",
          "Vroonland",
          "Vrouwe",
          "Vrouwenvelder",
          "Vruggink",
          "Vrugt",
          "Vrugteveen",
          "Vrutaal",
          "Vruwink",
          "Vré",
          "Vrösch",
          "Vu",
          "Vucht",
          "Vught",
          "Vugs",
          "Vugt",
          "Vugteveen",
          "Vugts",
          "Vuijk",
          "Vuijst",
          "Vuik",
          "Vulders",
          "Vulink",
          "Vullers",
          "Vullings",
          "Vulpen",
          "Vulto",
          "Vunderink",
          "Vuong",
          "Vural",
          "Vuren",
          "Vuurboom",
          "Vuure",
          "Vuuren",
          "Vuurens",
          "Vuurst",
          "Vyent",
          "Waagmeester",
          "Waaij",
          "Waaijenberg",
          "Waaijer",
          "Waal",
          "Waalboer",
          "Waalderbos",
          "Waalewijn",
          "Waalkens",
          "Waals",
          "Waalwijk",
          "Waanders",
          "Waard",
          "Waarde",
          "Waarden",
          "Waardenberg",
          "Waardenburg",
          "Waardhuizen",
          "Waardt",
          "Waarsenburg",
          "Waart",
          "Waarts",
          "Waas",
          "Waasdorp",
          "Wabeke",
          "Wachelder",
          "Wachter",
          "Wachtmeester",
          "Wackers",
          "Waeijen",
          "Waele",
          "Waelen",
          "Waenink",
          "Waerden",
          "Waerdt",
          "Waes",
          "Waesberghe",
          "Wage",
          "Wagelaar",
          "Wagelmans",
          "Wagemaker",
          "Wagemakers",
          "Wageman",
          "Wagemans",
          "Wagen",
          "Wagenaar",
          "Wagenaars",
          "Wagenberg",
          "Wagener",
          "Wageningen",
          "Wagenmakers",
          "Wagenmans",
          "Wagensveld",
          "Wagenvoort",
          "Wageveld",
          "Wagid Hosain",
          "Wagner",
          "Wagt",
          "Wagtendonk",
          "Wagter",
          "Wagteveld",
          "Wagtmans",
          "Wahle",
          "Wahlen",
          "Waij",
          "Waijenberg",
          "Waijer",
          "Waijers",
          "Wajer",
          "Wakelkamp",
          "Wakeren",
          "Wakker",
          "Wal",
          "Walbeek",
          "Walburg",
          "Walda",
          "Walden",
          "Walderveen",
          "Waldram",
          "Walen",
          "Walet",
          "Walgemoet",
          "Walhof",
          "Walhout",
          "Walinga",
          "Walk",
          "Walker",
          "Wall",
          "Wallaard",
          "Wallaart",
          "Walle",
          "Wallen",
          "Wallenburg",
          "Waller",
          "Wallet",
          "Wallinga",
          "Wallé",
          "Walma",
          "Walpot",
          "Walrave",
          "Walraven",
          "Walravens",
          "Wals",
          "Walschot",
          "Walschots",
          "Walsem",
          "Walsma",
          "Walst",
          "Walstijn",
          "Walstock",
          "Walstra",
          "Walsum",
          "Walsweer",
          "Walta",
          "Walter",
          "Walters",
          "Walthaus",
          "Walther",
          "Waltman",
          "Waltmann",
          "Waltmans",
          "Walvaart",
          "Walvoort",
          "Wamel",
          "Wamelen",
          "Wamelink",
          "Wammes",
          "Wams",
          "Wamsteker",
          "Wan",
          "Wandel",
          "Wandelen",
          "Wander",
          "Wanders",
          "Wang",
          "Wanga",
          "Waning",
          "Waninge",
          "Wanink",
          "Wanner",
          "Wannet",
          "Wanningen",
          "Wanroij",
          "Wanrooij",
          "Wanrooy",
          "Wanschers",
          "Wansem",
          "Wansink",
          "Want",
          "Wanten",
          "Wantia",
          "Wapenaar",
          "Wapperom",
          "Wapstra",
          "Warbout",
          "Warbroek",
          "Wardenaar",
          "Wardenburg",
          "Wardenier",
          "Wardt",
          "Wareman",
          "Warenburg",
          "Waringa",
          "Warmelink",
          "Warmels",
          "Warmenhoven",
          "Warmer",
          "Warmerdam",
          "Warmink",
          "Warmoeskerken",
          "Warnaar",
          "Warnar",
          "Warnars",
          "Warnders",
          "Warner",
          "Warners",
          "Warnier",
          "Warning",
          "Warren",
          "Warrens",
          "Warries",
          "Warring",
          "Warringa",
          "Warrink",
          "Warris",
          "Warsame",
          "Wart",
          "Warta",
          "Wartena",
          "Wasch",
          "Waslander",
          "Wassen",
          "Wassenaar",
          "Wassenberg",
          "Wassenburg",
          "Wassens",
          "Wasser",
          "Wassing",
          "Wassink",
          "Water",
          "Waterberg",
          "Wateren",
          "Waterham",
          "Watering",
          "Waterink",
          "Waterlander",
          "Waterman",
          "Waterreus",
          "Waterschoot",
          "Waterval",
          "Watson",
          "Wattel",
          "Wattimena",
          "Wattimury",
          "Wattum",
          "Wauben",
          "Wauters",
          "Waveren",
          "Waverijn",
          "Wawoe",
          "Webbers",
          "Webbink",
          "Weber",
          "Webers",
          "Webster",
          "Weckseler",
          "Weda",
          "Wedding",
          "Wedema",
          "Wedman",
          "Wedzinga",
          "Wee",
          "Weeber",
          "Weeda",
          "Weegberg",
          "Weegels",
          "Weegen",
          "Weegerink",
          "Weegh",
          "Weeghel",
          "Weekamp",
          "Weekers",
          "Weekhout",
          "Weel",
          "Weeland",
          "Weelden",
          "Weelderen",
          "Weele",
          "Weeling",
          "Weelink",
          "Weem",
          "Weemaes",
          "Weeme",
          "Weemhoff",
          "Weenen",
          "Weener",
          "Weening",
          "Weenink",
          "Weenk",
          "Weerd",
          "Weerden",
          "Weerdenburg",
          "Weerdhof",
          "Weerdmeester",
          "Weerdt",
          "Weeren",
          "Weerepas",
          "Weerheijm",
          "Weerheim",
          "Weering",
          "Weerink",
          "Weerkamp",
          "Weerman",
          "Weernink",
          "Weers",
          "Weersch",
          "Weersink",
          "Weerstand",
          "Weert",
          "Weertman",
          "Weerts",
          "Wees",
          "Weesie",
          "Weessies",
          "Weeteling",
          "Weetering",
          "Weeterings",
          "Weetink",
          "Weevers",
          "Weezel",
          "Weezepoel",
          "Weg",
          "Wegberg",
          "Wegdam",
          "Wege",
          "Wegen",
          "Weger",
          "Wegerif",
          "Weggelaar",
          "Weggeman",
          "Weggemans",
          "Weggen",
          "Wegh",
          "Weghorst",
          "Wegkamp",
          "Wegman",
          "Wegner",
          "Wegter",
          "Wehkamp",
          "Wehl",
          "Wehnes",
          "Wehrens",
          "Wehrmeijer",
          "Weide",
          "Weidema",
          "Weideman",
          "Weiden",
          "Weidenaar",
          "Weidgraaf",
          "Weidijk",
          "Weierink",
          "Weij",
          "Weijde",
          "Weijdema",
          "Weijden",
          "Weijen",
          "Weijenberg",
          "Weijenborg",
          "Weijer",
          "Weijermans",
          "Weijermars",
          "Weijers",
          "Weijgers",
          "Weijgertse",
          "Weijgertze",
          "Weijkamp",
          "Weijl",
          "Weijland",
          "Weijman",
          "Weijmans",
          "Weijmer",
          "Weijn",
          "Weijnen",
          "Weijs",
          "Weijst",
          "Weijsters",
          "Weijtens",
          "Weijters",
          "Weijtmans",
          "Weijts",
          "Weijzen",
          "Weikamp",
          "Weiland",
          "Weima",
          "Weimar",
          "Weimer",
          "Weinand",
          "Weinans",
          "Weinberg",
          "Weis",
          "Weiss",
          "Weisscher",
          "Weistra",
          "Weisz",
          "Weitenberg",
          "Weitering",
          "Weites",
          "Weits",
          "Wekema",
          "Wekken",
          "Wekker",
          "Wekking",
          "Wel",
          "Welberg",
          "Welbergen",
          "Welbers",
          "Welbie",
          "Welboren",
          "Weldam",
          "Welgraven",
          "Welhuis",
          "Welie",
          "Welij",
          "Welink",
          "Well",
          "Welle",
          "Welleman",
          "Wellen",
          "Wellenberg",
          "Wellens",
          "Weller",
          "Welles",
          "Welleweerd",
          "Welling",
          "Wellink",
          "Wellner",
          "Welman",
          "Welmers",
          "Welp",
          "Wels",
          "Welschen",
          "Welsing",
          "Welsink",
          "Welte",
          "Welten",
          "Welter",
          "Welters",
          "Weltevrede",
          "Weltevreden",
          "Welvaart",
          "Welvaarts",
          "Wely",
          "Welzen",
          "Welzenis",
          "Wemekamp",
          "Wemer",
          "Wemmenhove",
          "Wemmers",
          "Wempe",
          "Wende",
          "Wendel",
          "Wendel de Joode",
          "Wendels",
          "Wenders",
          "Wendrich",
          "Wendt",
          "Wenink",
          "Wenker",
          "Wenmakers",
          "Wenneker",
          "Wennekers",
          "Wennekes",
          "Wennemers",
          "Wenning",
          "Wennink",
          "Wenno",
          "Wens",
          "Wensen",
          "Wensing",
          "Wensink",
          "Wensveen",
          "Went",
          "Wentholt",
          "Wenting",
          "Wentink",
          "Wentzel",
          "Wenum",
          "Wenzel",
          "Weperen",
          "Werd",
          "Werde",
          "Werdekker",
          "Werdler",
          "Werdt",
          "Wereld",
          "Weren",
          "Werensteijn",
          "Werf",
          "Werff",
          "Werfhorst",
          "Werink",
          "Werk",
          "Werken",
          "Werker",
          "Werkhoven",
          "Werkman",
          "Werleman",
          "Wermeskerken",
          "Wermink",
          "Werner",
          "Werners",
          "Wernke",
          "Wernsen",
          "Werring",
          "Wersch",
          "Wert",
          "Werther",
          "Werts",
          "Werve",
          "Werven",
          "Wervers",
          "Wes",
          "Wesdijk",
          "Wesdorp",
          "Wesel",
          "Wesenhagen",
          "Wessel",
          "Wesseldijk",
          "Wesseling",
          "Wesselingh",
          "Wesselink",
          "Wesselius",
          "Wesselkamp",
          "Wesselman",
          "Wesselo",
          "Wessels",
          "West",
          "Westbroek",
          "Westdijk",
          "Westdorp",
          "Westein",
          "Westeinde",
          "Westelaken",
          "Westen",
          "Westenberg",
          "Westenbrink",
          "Westenbroek",
          "Westenbrugge",
          "Westende",
          "Westendorp",
          "Westeneind",
          "Westenend",
          "Westeneng",
          "Westenenk",
          "Wester",
          "Westera",
          "Westerbaan",
          "Westerbeek",
          "Westerbeke",
          "Westerbos",
          "Westerbrink",
          "Westerbroek",
          "Westerdiep",
          "Westerdijk",
          "Westerduin",
          "Westerhof",
          "Westerhoff",
          "Westerhout",
          "Westerhoven",
          "Westerhuis",
          "Westerik",
          "Westering",
          "Westeringh",
          "Westerink",
          "Westerkamp",
          "Westerlaak",
          "Westerlaken",
          "Westerling",
          "Westerlo",
          "Westerman",
          "Westermann",
          "Westerneng",
          "Westerop",
          "Westers",
          "Westert",
          "Westerterp",
          "Westerveen",
          "Westerveld",
          "Westervoorde",
          "Westerweel",
          "Westerweele",
          "Westgeest",
          "Westheim",
          "Westhiner",
          "Westhoek",
          "Westhoeve",
          "Westhof",
          "Westhoff",
          "Westhovens",
          "Westhuis",
          "Westing",
          "Westland",
          "Westmaas",
          "Westphal",
          "Westra",
          "Westreenen",
          "Westrenen",
          "Westrienen",
          "Westrik",
          "Weststeijn",
          "Weststrate",
          "Westveer",
          "Wetemans",
          "Wetering",
          "Weterings",
          "Wetselaar",
          "Wetsteijn",
          "Wetten",
          "Wetters",
          "Wetting",
          "Wettum",
          "Wetzel",
          "Wetzelaer",
          "Wetzels",
          "Wetzer",
          "Weultjes",
          "Weurding",
          "Weusten",
          "Weustenenk",
          "Weusthof",
          "Weustink",
          "Wever",
          "Weverink",
          "Weverling",
          "Wevers",
          "Weverwijk",
          "Weyers",
          "Wezel",
          "Wezelman",
          "Wezeman",
          "Wezenaar",
          "Wezenbeek",
          "Wezenberg",
          "Wezendonk",
          "Wezep",
          "Wezer",
          "White",
          "Wiarda",
          "Wibbelink",
          "Wibier",
          "Wich",
          "Wichen",
          "Wicherink",
          "Wichers",
          "Wichers Schreur",
          "Wichgers",
          "Wichman",
          "Widdershoven",
          "Widt",
          "Wiebenga",
          "Wieberdink",
          "Wiebers",
          "Wiebes",
          "Wiebing",
          "Wiechers",
          "Wiedeman",
          "Wiedemeijer",
          "Wiedijk",
          "Wieferink",
          "Wieffering",
          "Wiefferink",
          "Wiegel",
          "Wiegeraad",
          "Wiegerinck",
          "Wiegerink",
          "Wiegers",
          "Wiegersma",
          "Wieggers",
          "Wiegman",
          "Wiegmans",
          "Wiegmink",
          "Wiekens",
          "Wiel",
          "Wielaard",
          "Wieland",
          "Wielandt",
          "Wielders",
          "Wieldraaijer",
          "Wiele",
          "Wielemaker",
          "Wieleman",
          "Wielen",
          "Wielenga",
          "Wielens",
          "Wielhouwer",
          "Wieling",
          "Wielinga",
          "Wielink",
          "Wielsma",
          "Wielstra",
          "Wielzen",
          "Wieman",
          "Wiemer",
          "Wien",
          "Wiendels",
          "Wienen",
          "Wienholts",
          "Wienk",
          "Wientjens",
          "Wientjes",
          "Wier",
          "Wierbos",
          "Wierckx",
          "Wiercx",
          "Wierda",
          "Wierdsma",
          "Wierema",
          "Wieren",
          "Wierenga",
          "Wierik",
          "Wierike",
          "Wierikx",
          "Wiering",
          "Wieringa",
          "Wieringen",
          "Wierink",
          "Wierks",
          "Wiermans",
          "Wiers",
          "Wiersema",
          "Wiersinga",
          "Wiersma",
          "Wierst",
          "Wierstra",
          "Wiersum",
          "Wierts",
          "Wiertsema",
          "Wiertz",
          "Wiese",
          "Wiesenekker",
          "Wieser",
          "Wieskamp",
          "Wieske",
          "Wieten",
          "Wietmarschen",
          "Wietsma",
          "Wigbers",
          "Wigboldus",
          "Wigchert",
          "Wiggen",
          "Wigger",
          "Wiggers",
          "Wiggerts",
          "Wigman",
          "Wigmans",
          "Wijbenga",
          "Wijbrands",
          "Wijburg",
          "Wijchen",
          "Wijchers",
          "Wijck",
          "Wijckmans",
          "Wijdemans",
          "Wijden",
          "Wijdenes",
          "Wijdeveld",
          "Wijdeven",
          "Wijen",
          "Wijenberg",
          "Wijering",
          "Wijermars",
          "Wijers",
          "Wijffelaars",
          "Wijffels",
          "Wijfje",
          "Wijfjes",
          "Wijga",
          "Wijgerde",
          "Wijgerden",
          "Wijgergangs",
          "Wijgers",
          "Wijgerse",
          "Wijgert",
          "Wijgman",
          "Wijhe",
          "Wijk",
          "Wijkamp",
          "Wijker",
          "Wijkhuijs",
          "Wijkhuizen",
          "Wijkman",
          "Wijkmans",
          "Wijkstra",
          "Wijlaars",
          "Wijland",
          "Wijlen",
          "Wijlens",
          "Wijler",
          "Wijlhuizen",
          "Wijlick",
          "Wijling",
          "Wijma",
          "Wijman",
          "Wijmans",
          "Wijmenga",
          "Wijn",
          "Wijnakker",
          "Wijnalda",
          "Wijnaldum",
          "Wijnand",
          "Wijnands",
          "Wijnans",
          "Wijnants",
          "Wijnbelt",
          "Wijnberg",
          "Wijnbergen",
          "Wijnberger",
          "Wijne",
          "Wijnen",
          "Wijngaard",
          "Wijngaarde",
          "Wijngaarden",
          "Wijngaards",
          "Wijngaart",
          "Wijnholds",
          "Wijnhorst",
          "Wijnhoud",
          "Wijnhout",
          "Wijnhoven",
          "Wijnia",
          "Wijninga",
          "Wijnings",
          "Wijnja",
          "Wijnker",
          "Wijnmaalen",
          "Wijnmalen",
          "Wijnne",
          "Wijns",
          "Wijnschenk",
          "Wijnsma",
          "Wijnstekers",
          "Wijnstok",
          "Wijnstra",
          "Wijntje",
          "Wijntjes",
          "Wijntuin",
          "Wijnveen",
          "Wijs",
          "Wijsbeek",
          "Wijsen",
          "Wijshake",
          "Wijshoff",
          "Wijsman",
          "Wijst",
          "Wijte",
          "Wijten",
          "Wijtenburg",
          "Wijtman",
          "Wijtmans",
          "Wijts",
          "Wijtsma",
          "Wijtvliet",
          "Wijtzes",
          "Wijze",
          "Wijzenbroek",
          "Wikkerink",
          "Wikselaar",
          "Wilbers",
          "Wilborts",
          "Wilbrink",
          "Wilcke",
          "Wild",
          "Wildbret",
          "Wilde",
          "Wildeboer",
          "Wildeman",
          "Wilden",
          "Wildenbeest",
          "Wildenberg",
          "Wildenborg",
          "Wildenburg",
          "Wilderink",
          "Wilderom",
          "Wilders",
          "Wildhagen",
          "Wildschut",
          "Wildt",
          "Wildvank",
          "Wilgen",
          "Wilgenburg",
          "Wilgenhof",
          "Wilhelm",
          "Wilhelmus",
          "Wilk",
          "Wilke",
          "Wilken",
          "Wilkens",
          "Wilkes",
          "Will",
          "Willaert",
          "Willard",
          "Willart",
          "Wille",
          "Willeboordse",
          "Willebrands",
          "Willegen",
          "Willegers",
          "Willekens",
          "Willekes",
          "Willemars",
          "Willemen",
          "Willems",
          "Willemse",
          "Willemsen",
          "Willemsma",
          "Willemstein",
          "Willemstijn",
          "Willemsz",
          "Willenborg",
          "Willers",
          "William",
          "Williams",
          "Willig",
          "Willigen",
          "Willigenburg",
          "Willigers",
          "Willik",
          "Willink",
          "Willms",
          "Wilmer",
          "Wilmes",
          "Wilmink",
          "Wilms",
          "Wilmsen",
          "Wilpshaar",
          "Wilpstra",
          "Wils",
          "Wilschut",
          "Wilson",
          "Wilsum",
          "Wilt",
          "Wilten",
          "Wiltenburg",
          "Wilthagen",
          "Wilting",
          "Wiltink",
          "Wiltjer",
          "Wilts",
          "Wimmenhove",
          "Wimmer",
          "Wimmers",
          "Win",
          "Winands",
          "Winckers",
          "Wincoop",
          "Wind",
          "Winden",
          "Winder",
          "Windhorst",
          "Windhouwer",
          "Windmeijer",
          "Windster",
          "Windt",
          "Wingelaar",
          "Wingens",
          "Wingerde",
          "Wingerden",
          "Wings",
          "Winia",
          "Wink",
          "Winkel",
          "Winkelaar",
          "Winkeler",
          "Winkelhorst",
          "Winkelman",
          "Winkelmolen",
          "Winkels",
          "Winkens",
          "Winklaar",
          "Winkler",
          "Winkoop",
          "Winnemuller",
          "Winnen",
          "Winnubst",
          "Winsen",
          "Winssen",
          "Winter",
          "Winterink",
          "Winterman",
          "Wintermans",
          "Winters",
          "Wintershoven",
          "Winterswijk",
          "Winthagen",
          "Wintjens",
          "Wintjes",
          "Wintraecken",
          "Wip",
          "Wippert",
          "Wirken",
          "Wirtz",
          "Wisgerhof",
          "Wishaupt",
          "Wiskerke",
          "Wisman",
          "Wismans",
          "Wismeijer",
          "Wispelweij",
          "Wiss",
          "Wisse",
          "Wisseborn",
          "Wissel",
          "Wisselink",
          "Wisselo",
          "Wissen",
          "Wissenburg",
          "Wissing",
          "Wissink",
          "Wit",
          "Witberg",
          "Witbreuk",
          "With",
          "Withaar",
          "Withag",
          "Withagen",
          "Witjes",
          "Witkam",
          "Witkamp",
          "Witlox",
          "Witman",
          "Witmer",
          "Witmond",
          "Witsel",
          "Witsenburg",
          "Witsiers",
          "Witt",
          "Witte",
          "Wittebol",
          "Wittebrood",
          "Wittekoek",
          "Witteman",
          "Witten",
          "Wittenaar",
          "Wittenberg",
          "Wittenboer",
          "Wittendorp",
          "Wittens",
          "Witter",
          "Wittermans",
          "Witteveen",
          "Witting",
          "Wittingen",
          "Witvliet",
          "Witvoet",
          "Witzand",
          "Witzenburg",
          "Wobben",
          "Wobbes",
          "Wobma",
          "Woelders",
          "Woeltjes",
          "Woensdregt",
          "Woensel",
          "Woerd",
          "Woerde",
          "Woerdeman",
          "Woerden",
          "Woerdman",
          "Woerds",
          "Woerdt",
          "Woering",
          "Woerkens",
          "Woerkom",
          "Woerkum",
          "Woerlee",
          "Woertink",
          "Woertman",
          "Woerts",
          "Woesik",
          "Woestenberg",
          "Woestenburg",
          "Woestenenk",
          "Woesthoff",
          "Woesthuis",
          "Woestijne",
          "Woezik",
          "Wognum",
          "Wokke",
          "Wolberink",
          "Wolbers",
          "Wolbert",
          "Wolbink",
          "Wolbrink",
          "Wolda",
          "Woldberg",
          "Wolde",
          "Woldendorp",
          "Woldering",
          "Woldhuis",
          "Woldman",
          "Woldring",
          "Woldringh",
          "Wolf",
          "Wolferen",
          "Wolferink",
          "Wolfert",
          "Wolff",
          "Wolffenbuttel",
          "Wolffensperger",
          "Wolffers",
          "Wolffs",
          "Wolfhagen",
          "Wolfkamp",
          "Wolfs",
          "Wolfsen",
          "Wolfshaar",
          "Wolfswinkel",
          "Wolgen",
          "Wolk",
          "Wolke",
          "Wolken",
          "Wolkenfelt",
          "Wolkers",
          "Wollenberg",
          "Wollerich",
          "Wolleswinkel",
          "Wollrabe",
          "Wols",
          "Wolsheimer",
          "Wolsing",
          "Wolsink",
          "Wolswijk",
          "Wolswinkel",
          "Wolter",
          "Wolterbeek",
          "Wolterinck",
          "Woltering",
          "Wolterink",
          "Wolterman",
          "Wolters",
          "Wolthers",
          "Wolthuis",
          "Wolthuizen",
          "Wolting",
          "Woltinge",
          "Woltjer",
          "Woltjes",
          "Woltman",
          "Wolvekamp",
          "Wolven",
          "Wolvers",
          "Wolzak",
          "Wonderen",
          "Wondergem",
          "Wong",
          "Woning",
          "Wonink",
          "Wonnink",
          "Woo",
          "Woolderink",
          "Wooldrik",
          "Woolthuis",
          "Wooninck",
          "Wooning",
          "Woord",
          "Woordes",
          "Woort",
          "Woortman",
          "Wopereis",
          "Woppenkamp",
          "Wordragen",
          "Workel",
          "Workum",
          "Worm",
          "Wormgoor",
          "Wormmeester",
          "Worms",
          "Wormsbecher",
          "Worp",
          "Worst",
          "Wort",
          "Wortel",
          "Wortelboer",
          "Wortman",
          "Woud",
          "Wouda",
          "Woude",
          "Wouden",
          "Woudenberg",
          "Woudenbergh",
          "Woudsma",
          "Woudstra",
          "Woudt",
          "Woudwijk",
          "Wout",
          "Wouter",
          "Wouters",
          "Wouterse",
          "Woutersen",
          "Wouterson",
          "Wouts",
          "Wouw",
          "Wouwe",
          "Wright",
          "Wu",
          "Wubbe",
          "Wubbels",
          "Wubben",
          "Wubbolts",
          "Wubs",
          "Wuijckhuijse",
          "Wuijster",
          "Wuijts",
          "Wuisman",
          "Wuister",
          "Wuite",
          "Wulff",
          "Wulffraat",
          "Wullems",
          "Wullink",
          "Wulms",
          "Wulp",
          "Wulterkens",
          "Wunderink",
          "Wunnik",
          "Wunnink",
          "Wurf",
          "Wurff",
          "Wursten",
          "Wurtz",
          "Wösten",
          "Wüst",
          "Xhofleer",
          "Xie",
          "Xu",
          "Yaakoubi",
          "Yachou",
          "Yacoub",
          "Yagoubi",
          "Yahia",
          "Yahyaoui",
          "Yakoubi",
          "Yalcin",
          "Yalçin",
          "Yaman",
          "Yan",
          "Yang",
          "Yanik",
          "Yap",
          "Yard",
          "Yau",
          "Yavuz",
          "Yazici",
          "Yazidi",
          "Yazir",
          "Yaşar",
          "Ybema",
          "Ye",
          "Yeboah",
          "Yeh",
          "Yeung",
          "Yeşil",
          "Yigit",
          "Yildirim",
          "Yildiz",
          "Yilmaz",
          "Yip",
          "Yiğit",
          "Ykema",
          "Yntema",
          "Yorks",
          "Young",
          "Yousef",
          "Yousfi",
          "Yousif",
          "Youssef",
          "Yperen",
          "Ypma",
          "Ytsma",
          "Yu",
          "Yuen",
          "Yurdakul",
          "Yurt",
          "Yusuf",
          "Yüce",
          "Yücel",
          "Yüksel",
          "Zaadnoordijk",
          "Zaag",
          "Zaagman",
          "Zaaijer",
          "Zaal",
          "Zaalberg",
          "Zaalman",
          "Zaan",
          "Zaandam",
          "Zaane",
          "Zaanen",
          "Zaat",
          "Zadelhoff",
          "Zagers",
          "Zagt",
          "Zagwijn",
          "Zaidi",
          "Zaki",
          "Zalen",
          "Zalinge",
          "Zalingen",
          "Zalk",
          "Zalm",
          "Zaman",
          "Zand",
          "Zandbeek",
          "Zandbelt",
          "Zandberg",
          "Zandbergen",
          "Zande",
          "Zandee",
          "Zanden",
          "Zander",
          "Zanderink",
          "Zanders",
          "Zandgrond",
          "Zandhuis",
          "Zandijk",
          "Zandman",
          "Zandschulp",
          "Zandsteeg",
          "Zandstra",
          "Zandt",
          "Zandvliet",
          "Zandvoort",
          "Zandwijk",
          "Zanen",
          "Zanoli",
          "Zanoni",
          "Zant",
          "Zanten",
          "Zanting",
          "Zantinge",
          "Zantingh",
          "Zantman",
          "Zantvliet",
          "Zantvoort",
          "Zappeij",
          "Zariouh",
          "Zaroual",
          "Zaunbrecher",
          "Zebeda",
          "Zeben",
          "Zebregs",
          "Zee",
          "Zeebregts",
          "Zeedijk",
          "Zeegelaar",
          "Zeegers",
          "Zeeland",
          "Zeelen",
          "Zeelenberg",
          "Zeelst",
          "Zeeman",
          "Zeestraten",
          "Zeeuw",
          "Zeeuwen",
          "Zeevat",
          "Zegel",
          "Zegelaar",
          "Zegeling",
          "Zegers",
          "Zeggelaar",
          "Zegger",
          "Zeggeren",
          "Zegveld",
          "Zegwaard",
          "Zegwaart",
          "Zeijden",
          "Zeijl",
          "Zeijlemaker",
          "Zeijst",
          "Zeilemaker",
          "Zeilmaker",
          "Zeilstra",
          "Zeinstra",
          "Zeist",
          "Zekhnini",
          "Zekveld",
          "Zel",
          "Zeldenrijk",
          "Zeldenrust",
          "Zeldenthuis",
          "Zelderen",
          "Zelen",
          "Zelfde",
          "Zelis",
          "Zelissen",
          "Zeller",
          "Zelm",
          "Zelst",
          "Zenden",
          "Zendman",
          "Zengerink",
          "Zengin",
          "Zentjens",
          "Zentveld",
          "Zeroual",
          "Zessen",
          "Zethof",
          "Zetten",
          "Zevenberg",
          "Zevenbergen",
          "Zevenhoven",
          "Zevenhuizen",
          "Zeventer",
          "Zewald",
          "Zhang",
          "Zhao",
          "Zheng",
          "Zhou",
          "Zhu",
          "Ziani",
          "Zieck",
          "Ziel",
          "Zieleman",
          "Zielhuis",
          "Zielman",
          "Zielst",
          "Zielstra",
          "Zieltjens",
          "Ziengs",
          "Zieverink",
          "Zigterman",
          "Zijde",
          "Zijden",
          "Zijdenbos",
          "Zijderlaan",
          "Zijderveld",
          "Zijl",
          "Zijlema",
          "Zijll",
          "Zijlma",
          "Zijlmans",
          "Zijlstra",
          "Zijm",
          "Zijp",
          "Zijsling",
          "Zijtveld",
          "Zijverden",
          "Zillig",
          "Zilver",
          "Zilverberg",
          "Zilverschoon",
          "Zimmer",
          "Zimmerman",
          "Zimmermann",
          "Zinger",
          "Zinhagel",
          "Zink",
          "Zinken",
          "Zinnemers",
          "Zirkzee",
          "Zitman",
          "Zitter",
          "Zitteren",
          "Zoelen",
          "Zoen",
          "Zoer",
          "Zoeren",
          "Zoest",
          "Zoet",
          "Zoetbrood",
          "Zoete",
          "Zoetebier",
          "Zoetekouw",
          "Zoetelief",
          "Zoeteman",
          "Zoetemeijer",
          "Zoetemelk",
          "Zoeten",
          "Zoeteweij",
          "Zoethout",
          "Zoetmulder",
          "Zoggel",
          "Zom",
          "Zomer",
          "Zomerdijk",
          "Zomeren",
          "Zomerhuis",
          "Zomerman",
          "Zomers",
          "Zon",
          "Zondag",
          "Zonderland",
          "Zonderman",
          "Zonderop",
          "Zondervan",
          "Zonjee",
          "Zonnebeld",
          "Zonnenberg",
          "Zonneveld",
          "Zonnevijlle",
          "Zonsbeek",
          "Zoodsma",
          "Zoolingen",
          "Zoomer",
          "Zoomeren",
          "Zoomers",
          "Zoon",
          "Zoontjens",
          "Zoontjes",
          "Zopfi",
          "Zorg",
          "Zorgdrager",
          "Zorge",
          "Zorlu",
          "Zorn",
          "Zoutenbier",
          "Zoutendijk",
          "Zoutewelle",
          "Zoutman",
          "Zouw",
          "Zouwen",
          "Zuidam",
          "Zuidberg",
          "Zuiddam",
          "Zuidema",
          "Zuiden",
          "Zuiderbaan",
          "Zuiderduin",
          "Zuiderhoek",
          "Zuidersma",
          "Zuidervaart",
          "Zuiderveld",
          "Zuiderwijk",
          "Zuidgeest",
          "Zuidhoek",
          "Zuidhof",
          "Zuidinga",
          "Zuidland",
          "Zuidmeer",
          "Zuidweg",
          "Zuidwijk",
          "Zuijdam",
          "Zuijdendorp",
          "Zuijderduijn",
          "Zuijdervliet",
          "Zuijderwijk",
          "Zuijdgeest",
          "Zuijdweg",
          "Zuijdwegt",
          "Zuijdwijk",
          "Zuijlen",
          "Zuiker",
          "Zuilekom",
          "Zuilen",
          "Zuman",
          "Zumbrink",
          "Zunderd",
          "Zundert",
          "Zunnebeld",
          "Zut",
          "Zuthem",
          "Zutphen",
          "Zutt",
          "Zutven",
          "Zuuk",
          "Zuur",
          "Zuurbier",
          "Zuuren",
          "Zuurendonk",
          "Zuurman",
          "Zuurmond",
          "Zuurveen",
          "Zuurveld",
          "Zuylen",
          "Zwaag",
          "Zwaagman",
          "Zwaagstra",
          "Zwaal",
          "Zwaan",
          "Zwaans",
          "Zwaanswijk",
          "Zwaard",
          "Zwaga",
          "Zwagemaker",
          "Zwager",
          "Zwagerman",
          "Zwakenberg",
          "Zwakhalen",
          "Zwakhoven",
          "Zwaluw",
          "Zwam",
          "Zwama",
          "Zwambag",
          "Zwamborn",
          "Zwan",
          "Zwanenberg",
          "Zwanenburg",
          "Zwanepol",
          "Zwaneveld",
          "Zwang",
          "Zwanikken",
          "Zwanink",
          "Zwart",
          "Zwartbol",
          "Zwarte",
          "Zwartepoorte",
          "Zwarteveen",
          "Zwarthoed",
          "Zwartjens",
          "Zwartjes",
          "Zwartkruis",
          "Zwarts",
          "Zwaving",
          "Zweden",
          "Zweeden",
          "Zweedijk",
          "Zweegers",
          "Zweekhorst",
          "Zweep",
          "Zweerink",
          "Zweers",
          "Zweerts",
          "Zweerus",
          "Zwegers",
          "Zweistra",
          "Zwemer",
          "Zwemmer",
          "Zwennes",
          "Zwep",
          "Zwerink",
          "Zwerts",
          "Zwerus",
          "Zwerver",
          "Zwerwer",
          "Zwet",
          "Zwets",
          "Zwetselaar",
          "Zwetsloot",
          "Zweverink",
          "Zwezerijnen",
          "Zwienen",
          "Zwienenberg",
          "Zwiep",
          "Zwier",
          "Zwiers",
          "Zwieten",
          "Zwiggelaar",
          "Zwijger",
          "Zwijgers",
          "Zwijnenberg",
          "Zwijnenburg",
          "Zwijsen",
          "Zwik",
          "Zwikker",
          "Zwinkels",
          "Zwirs",
          "Zwitser",
          "Zwitserloot",
          "Zwoferink",
          "Zwol",
          "Zwolle",
          "Zwols",
          "Zwolsman"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{tussenvoegsel} #{last_name}",
          "#{first_name} #{tussenvoegsel} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Dhr.",
          "Mevr. Dr.",
          "Bsc",
          "Msc",
          "Prof."
        ],
        "suffix": [
          "Jr.",
          "Sr.",
          "I",
          "II",
          "III",
          "IV",
          "V"
        ],
        "tussenvoegsel": [
          "de",
          "den",
          "te",
          "ten",
          "ter",
          "van",
          "van 't",
          "van de",
          "van den",
          "van der",
          "van het",
          "von",
          "voor den"
        ]
      },
      "phone_number": {
        "cell_phone": {
          "formats": [
            "06########",
            "06 #### ####"
          ]
        },
        "country_code": [
          "31"
        ],
        "formats": [
          "(####) ######",
          "##########"
        ]
      },
      "university": {
        "name": [
          "#{University.prefix} #{Name.last_name}",
          "#{University.prefix} #{Address.city}"
        ],
        "prefix": [
          "Universiteit",
          "Hogeschool"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Maak een keuze"
      },
      "submit": {
        "create": "%{model} toevoegen",
        "submit": "%{model} opslaan",
        "update": "%{model} bijwerken"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u %n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miljard",
            "million": "miljoen",
            "quadrillion": "biljard",
            "thousand": "duizend",
            "trillion": "biljoen",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "byte",
              "other": "bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " en ",
        "two_words_connector": " en ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "'s ochtends",
      "formats": {
        "default": "%a %d %b %Y %H:%M:%S %Z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%a %d %b %Y %H:%M:%S %Z"
            }
          }
        },
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "'s middags"
    }
  },
  "nn": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Valideringa mislukka: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan ikkje sletta registreringa, fordi avhengige %{record} finst.",
            "has_one": "Kan ikkje sletta registreringa, fordi 1 avhengig %{record} finst."
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "sun",
        "mån",
        "tys",
        "ons",
        "tor",
        "fre",
        "lau"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "mai",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "des"
      ],
      "day_names": [
        "sundag",
        "måndag",
        "tysdag",
        "onsdag",
        "torsdag",
        "fredag",
        "laurdag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "rundt %{count} time",
          "other": "rundt %{count} timar"
        },
        "about_x_months": {
          "one": "rundt %{count} månad",
          "other": "rundt %{count} månader"
        },
        "about_x_years": {
          "one": "rundt %{count} år",
          "other": "rundt %{count} år"
        },
        "almost_x_years": "nesten %{count} år",
        "half_a_minute": "eit halvt minutt",
        "less_than_x_minutes": {
          "one": "mindre enn %{count} minutt",
          "other": "mindre enn %{count} minutt"
        },
        "less_than_x_seconds": {
          "one": "mindre enn %{count} sekund",
          "other": "mindre enn %{count} sekund"
        },
        "over_x_years": {
          "one": "over %{count} år",
          "other": "over %{count} år"
        },
        "x_days": {
          "one": "%{count} dag",
          "other": "%{count} dagar"
        },
        "x_minutes": {
          "one": "%{count} minutt",
          "other": "%{count} minutt"
        },
        "x_months": {
          "one": "%{count} månad",
          "other": "%{count} månader"
        },
        "x_seconds": {
          "one": "%{count} sekund",
          "other": "%{count} sekund"
        }
      },
      "prompts": {
        "day": "Dag",
        "hour": "Time",
        "minute": "Minutt",
        "month": "Månad",
        "second": "Sekund",
        "year": "År"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "må vera akseptert",
        "blank": "kan ikkje vera blank",
        "confirmation": "er ikkje lik %{attribute}",
        "empty": "kan ikkje vera tom",
        "equal_to": "må vera lik %{count}",
        "even": "må vera partal",
        "exclusion": "er reservert",
        "greater_than": "må vera større enn %{count}",
        "greater_than_or_equal_to": "må vera større enn eller lik %{count}",
        "inclusion": "er ikkje inkludert i lista",
        "invalid": "er ugyldig",
        "less_than": "må vera mindre enn %{count}",
        "less_than_or_equal_to": "må vera mindre enn eller lik %{count}",
        "model_invalid": "Valideringa mislukka: %{errors}",
        "not_a_number": "er ikkje eit tal",
        "not_an_integer": "er ikkje eit heiltal",
        "odd": "må vera oddetal",
        "other_than": "må vera noko anna enn %{count}",
        "present": "må vera blank",
        "required": "må eksistera",
        "taken": "er allereie i bruk",
        "too_long": "er for lang (maksimum %{count} teikn)",
        "too_short": "er for kort (minimum %{count} teikn)",
        "wrong_length": "har feil lengde (maksimum %{count} teikn)"
      },
      "template": {
        "body": "det oppstod problem i følgjande felt:",
        "header": "kunne ikkje lagra %{model} grunna %{count} feil."
      }
    },
    "helpers": {
      "select": {
        "prompt": "Gjer eit val"
      },
      "submit": {
        "create": "Lag %{model}",
        "submit": "Lagre %{model}",
        "update": "Oppdater %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "kr"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "milliard",
              "other": "milliardar"
            },
            "million": {
              "one": "million",
              "other": "millionar"
            },
            "quadrillion": {
              "one": "billiard",
              "other": "billiardar"
            },
            "thousand": "tusen",
            "trillion": {
              "one": "billion",
              "other": "billionar"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "kB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " og ",
        "two_words_connector": " og ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%A, %e. %B %Y, %H:%M",
        "long": "%A, %e. %B %Y, %H:%M",
        "short": "%e. %B, %H:%M"
      },
      "pm": "pm"
    }
  },
  "nn-NO": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Stadfesting sendt",
          "confirmation_token": "Stadfestingskode",
          "confirmed_at": "Stadfesta",
          "created_at": "Oppretta",
          "current_password": "Noverande passord",
          "current_sign_in_at": "Innlogga sidan",
          "current_sign_in_ip": "Innlogga frå IP",
          "email": "Epost",
          "encrypted_password": "Kryptert passord",
          "failed_attempts": "Mislykka forsøk",
          "last_sign_in_at": "Forrige innlogging",
          "last_sign_in_ip": "Forrige innlogging IP",
          "locked_at": "Låst den",
          "password": "Passord",
          "password_confirmation": "Stadfest passord",
          "remember_created_at": "Hugs meg oppretta",
          "remember_me": "Hugs meg",
          "reset_password_sent_at": "Tilbakestilling av passord sendt",
          "reset_password_token": "Nullstill passordkode",
          "sign_in_count": "Tal på innloggingar",
          "unconfirmed_email": "Ikkje stadfesta e-post",
          "unlock_token": "Opplåsingskode",
          "updated_at": "Oppdatert"
        }
      },
      "models": {
        "user": {
          "one": "Brukar",
          "other": "Brukar"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "E-postadressen din har blitt stadfesta.",
        "new": {
          "resend_confirmation_instructions": "Send instruksjonar for stadfesting på nytt"
        },
        "send_instructions": "Du vil om få minutt motta ein epost med instruksjonar om korleis stadfeste e-postadressen din.",
        "send_paranoid_instructions": "Dersom e-postadressen finst i databasen vår, vil du om få minutt motta ein e-post med instruksjonar om korleis å stadfeste e-posten din."
      },
      "failure": {
        "already_authenticated": "Du er allereie innlogga.",
        "inactive": "Kontoen din er ikkje aktivert enno.",
        "invalid": null,
        "last_attempt": "Du har berre eitt forsøk til før kontoen din blir låst.",
        "locked": "Kontoen din er låst.",
        "not_found_in_database": null,
        "timeout": "Økta di er utgått. Logg inn på nytt for å halde fram.",
        "unauthenticated": "Du må logge inn eller registrere deg før du kan halde fram.",
        "unconfirmed": "Du må stadfeste e-posten din før du kan halde fram."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Stadfest konto",
          "greeting": "Velkommen %{recipient}!",
          "instruction": "Du kan stadfeste kontoen din med å klikke på lenka under:",
          "subject": "Instruksjonar for å stadfeste"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Hei %{recipient}!",
          "message": "Vi kontaktar deg for å gi deg eit varsel om at passordet ditt har blitt endra.",
          "subject": "Passord endra"
        },
        "reset_password_instructions": {
          "action": "Endre passordet mitt",
          "greeting": "Hei %{recipient}!",
          "instruction": "Nokon ønskjer å endre passordet ditt, du kan gjere dette med å klikke på lenka under.",
          "instruction_2": "Dersom du ikkje har bedt om dette, sjå bort frå denne e-posten.",
          "instruction_3": "Passordet ditt vil ikkje endre seg før du klikker på lenka over og lagar eit nytt.",
          "subject": "Instruksjonar for å nullstille passord."
        },
        "unlock_instructions": {
          "action": "Lås opp kontoen min",
          "greeting": "Hei %{recipient}!",
          "instruction": "Klikk på lenka under for å låse opp kontoen din:",
          "message": "Kontoen din har blitt låst på grunn av for mange mislukka påloggingsforsøk.",
          "subject": "Instruksjonar for å låse opp"
        }
      },
      "omniauth_callbacks": {
        "failure": "Kunne ikkje autentisere deg frå %{kind} på grunn av \"%{reason}\".",
        "success": "Vellukka autentisering frå kontoen %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Endre passordet mitt",
          "change_your_password": "Endre passordet ditt",
          "confirm_new_password": "Stadfest nytt passord",
          "new_password": "Nytt passord"
        },
        "new": {
          "forgot_your_password": "Gløymt passordet ditt?",
          "send_me_reset_password_instructions": "Send meg instruksjonar for å nullstille passord"
        },
        "no_token": "Du har ikkje tilgang til denne sida utan å komme frå ein e-post med nullstill passord-lenke. Dersom du kjem frå ein slik ein, kontroller at du har brukt full URL.",
        "send_instructions": "Du vil om få minutt motta ein e-post med instruksjonar om å nullstille passordet ditt.",
        "send_paranoid_instructions": "Dersom e-postadressen din allereie finst i databasen vår, vil du om få minutt motta lenke for å motta passord på e-post.",
        "updated": "Passordet ditt har blitt endra. Du er no innlogga.",
        "updated_not_active": "Passordet ditt har blitt endra."
      },
      "registrations": {
        "destroyed": "Hadet! Kontoen din har blitt kansellert. Vi håpar å sjå deg att snart.",
        "edit": {
          "are_you_sure": "Er du sikker?",
          "cancel_my_account": "Kanseller kontoen min",
          "currently_waiting_confirmation_for_email": "Ventar stadfesting frå: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "la stå tomt dersom du ikkje ønskjer å endre",
          "title": "Rediger %{resource}",
          "unhappy": "Ikkje nøgd",
          "update": "Oppdater",
          "we_need_your_current_password_to_confirm_your_changes": "vi treng ditt noverande passord for å stadfeste endringar"
        },
        "new": {
          "sign_up": "Registrer"
        },
        "signed_up": "Velkommen! Du er blitt registrert.",
        "signed_up_but_inactive": "Du er blitt registrert. Men, vi kunne ikkje logge deg inn sidan kontoen ikkje er aktivert enno.",
        "signed_up_but_locked": "Du er blitt registrert. Men, vi kunne ikkje logge deg inn sidan kontoen din er låst.",
        "signed_up_but_unconfirmed": "Ei melding med stadfestingslenke er blitt sendt til e-postadressen din. Følg lenka for å aktivere kontoen din.",
        "update_needs_confirmation": "Du har oppdatert kontoen din, men vi treng å stadfeste di nye e-postadresse. Sjekk e-posten din og følg lenka for å stadfeste di nye e-postadresse.",
        "updated": "Kontoen din har blitt oppdatert.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Du er utlogga.",
        "new": {
          "sign_in": "Logg inn"
        },
        "signed_in": "Du er innlogga.",
        "signed_out": "Du har logga ut."
      },
      "shared": {
        "links": {
          "back": "Tilbake",
          "didn_t_receive_confirmation_instructions": "Ikkje motteke instruksjonar for å stadfeste konto?",
          "didn_t_receive_unlock_instructions": "Ikkje motteke instruksjonar for å låse opp konto?",
          "forgot_your_password": "Gløymt passordet ditt?",
          "sign_in": "Logg inn",
          "sign_in_with_provider": "Logg inn med %{provider}",
          "sign_up": "Registrer"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Send instruksjonar på nytt for å låse opp konto"
        },
        "send_instructions": "Du vil om få minutt motta ein e-post med instruksjonar for å låse opp kontoen din.",
        "send_paranoid_instructions": "Dersom kontoen din finst, vil du om få minutt motta ein e-post med instruksjonar om korleis låse opp.",
        "unlocked": "Kontoen din har blitt låst opp. Logg inn for å halde fram."
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "var allereie stadfesta, prøv å logg inn",
        "confirmation_period_expired": "treng å blir stadfesta innan %{period}, be om ei ny",
        "expired": "har blitt utdatert, be om ein ny",
        "not_found": "ikkje funnen",
        "not_locked": "var ikkje låst",
        "not_saved": {
          "one": "1 feil hindra %{resource} frå å bli lagra:",
          "other": "%{count} feil hindra %{resource} frå å bli lagra:"
        }
      }
    }
  },
  "no": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bekreftelse sendt",
          "confirmation_token": "Bekreftelsesnøkkel",
          "confirmed_at": "Bekreftet",
          "created_at": "Opprettet",
          "current_password": "Nåværende passord",
          "current_sign_in_at": "Gjeldende innlogging",
          "current_sign_in_ip": "Gjeldende innlogget IP",
          "email": "Epost",
          "encrypted_password": "Kryptert passord",
          "failed_attempts": "Mislykkede forsøk",
          "last_sign_in_at": "Sist innlogget",
          "last_sign_in_ip": "Sist innlogget IP",
          "locked_at": "Låst",
          "password": "Passord",
          "password_confirmation": "Passordbekreftelse",
          "remember_created_at": "Huskenøkkel opprettet",
          "remember_me": "Husk meg",
          "reset_password_sent_at": "Passordgjenoppretting sendt",
          "reset_password_token": "Passordgjenopprettingsnøkkel",
          "sign_in_count": "Antall innlogginger",
          "unconfirmed_email": "Ubekreftet epost",
          "unlock_token": "Nøkkelsymbol",
          "updated_at": "Oppdatert"
        }
      },
      "models": {
        "user": {
          "one": "Bruker",
          "other": "Bruker"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Din konto er aktivert og du er nå innlogget.",
        "new": {
          "resend_confirmation_instructions": "Send nye bekreftelsesinstruksjoner"
        },
        "send_instructions": "Du vil innen få minutter motta en epost med instruksjoner for å aktivere din konto.",
        "send_paranoid_instructions": "Hvis epostadressen din finnes i vår database vil du innen få minutter motta en epost med instruksjoner for å aktivere din konto."
      },
      "failure": {
        "already_authenticated": "Du er allerede logget inn.",
        "inactive": "Din konto er ikke aktivert enda.",
        "invalid": null,
        "last_attempt": "Du har et forsøk til før din konto blir låst.",
        "locked": "Din konto er låst.",
        "not_found_in_database": null,
        "timeout": "Din sesjon er utløpt. Logg inn igjen for å kunne fortsette.",
        "unauthenticated": "Du må logge inn eller registrere deg for å kunne fortsette.",
        "unconfirmed": "Du må bekrefte kontoen din for å kunne fortsette."
      },
      "invitations": {
        "edit": {
          "header": "Sett ditt passord",
          "submit_button": "Sett mitt passord"
        },
        "invitation_removed": "Din invitasjon ble fjernet.",
        "invitation_token_invalid": "Autentiseringskoden er ikke gyldig!",
        "new": {
          "header": "Send invitasjon",
          "submit_button": "Send en invitasjon"
        },
        "no_invitations_remaining": "Ingen gjenværende invitasjoner.",
        "send_instructions": "En epost med invitasjon er sent til %{email}.",
        "updated": "Passordet ble oppdatert suksessfullt. Du er nå logget inn."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bekreft min konto",
          "greeting": "Velkommen %{recipient}!",
          "instruction": "Du kan bekrefte kontoen din gjennom linken nedenfor:",
          "subject": "Bekreftelsesinstruksjoner"
        },
        "email_changed": {
          "greeting": "Hei %{recipient}!",
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "invitation_instructions": {
          "subject": "Invitasjonsinstruksjoner"
        },
        "password_change": {
          "greeting": "Hallo %{recipient}!",
          "message": "Vi kontakter deg for å meddele at ditt passord har blitt endret.",
          "subject": "Passord endret"
        },
        "reset_password_instructions": {
          "action": "Endre passord",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Noen har bedt om en link til å endre ditt passord og du kan gjøre det her.",
          "instruction_2": "Hvis du ikke har bedt om dette, vennligst overse denne eposten.",
          "instruction_3": "Ditt passord vil ikke bli endret med mindre du følger linken ovenfor og oppretter et nytt ett.",
          "subject": "Nullstilling av passord"
        },
        "unlock_instructions": {
          "action": "Lås opp konto",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Klikk på linken nedenfor for å låse opp kontoen din:",
          "message": "Kontoen din har blitt låst på grunn av alt for mange mislykkede påloggingsforsøk.",
          "subject": "Gjenåpning av konto"
        }
      },
      "omniauth_callbacks": {
        "failure": "Kunne ikke autorisere deg fra %{kind} fordi \"%{reason}\".",
        "success": "Vellykket autorisering fra %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Endre passord",
          "change_your_password": "Endre ditt passord",
          "confirm_new_password": "Bekreft nytt passord",
          "new_password": "Nytt passord"
        },
        "new": {
          "forgot_your_password": "Glemt passord?",
          "send_me_reset_password_instructions": "Send meg instruksjoner for å sette nytt passord"
        },
        "no_token": "Du kan ikke aksessere denne siden uten å bli videresendt fra en epost med intrukssjoner for å tilbakestille passord. Hvis dette er tilfelle, vennligst sørg for at du brukte hele lenken inneholdt i eposten.",
        "send_instructions": "Du vil innen få minutter motta en epost med instruksjoner for å nullstille passordet ditt.",
        "send_paranoid_instructions": "Hvis epostadressen din finnes i vår database vil du innen få minutter motta en epost med instruksjoner for å nullstille passordet ditt.",
        "updated": "Ditt passord er endret og du er nå innlogget.",
        "updated_not_active": "Ditt passord er endret."
      },
      "registrations": {
        "destroyed": "Farvel! Din konto er nå slettet. Vi håper å se deg igjen snart.",
        "edit": {
          "are_you_sure": "Er du sikker?",
          "cancel_my_account": "Deaktiver konto",
          "currently_waiting_confirmation_for_email": "Venter på bekreftelse for: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "la stå tomt dersom du ikke vil endre det",
          "title": "Rediger %{resource}",
          "unhappy": "Misfornøyd?",
          "update": "Oppdater",
          "we_need_your_current_password_to_confirm_your_changes": "vi trenger du nåværende passord for å bekrefte endringene du har gjort"
        },
        "new": {
          "sign_up": "Opprett konto"
        },
        "signed_up": "Velkommen! Din registrering er vellykket.",
        "signed_up_but_inactive": "Du er registrert. Vi kan derimot ikke logge deg på siden kontoen din ennå ikke er aktivert.",
        "signed_up_but_locked": "Du er registrert. Vi kan derimot ikke logge deg på siden kontoen din er låst.",
        "signed_up_but_unconfirmed": "En epost med en aktiveringslink er sent til din epostadresse.  Vennligst klikk på linken for å aktivere din konto.",
        "update_needs_confirmation": "Din profil er oppdatert, men vi trenger å bekrefte din nye epost-adresse. Vennligst sjekk din innboks og klikk på lenken inneholdt i eposten for å bekrefte endring av din epost-adresse.",
        "updated": "Din profil er oppdatert.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Logget ut",
        "new": {
          "sign_in": "Logg inn"
        },
        "signed_in": "Du er nå innlogget.",
        "signed_out": "Du er nå logget ut."
      },
      "shared": {
        "links": {
          "back": "Tilbake",
          "didn_t_receive_confirmation_instructions": "Ikke mottatt bekreftelsesinstruksjoner?",
          "didn_t_receive_unlock_instructions": "Ikke mottatt aktiveringsinstruksjoner?",
          "forgot_your_password": "Glemt passord?",
          "sign_in": "Logg inn",
          "sign_in_with_provider": "Logg inn med %{provider}",
          "sign_up": "Opprett konto"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Send nye aktiveringsinstruksjoner"
        },
        "send_instructions": "Du vil innen få minutter motta en epost med instruksjoner for å gjenåpne din konto.",
        "send_paranoid_instructions": "Hvis kontoen din eksisterer vil du innen få minutter motta en epost med instruksjoner for å låse den opp.",
        "unlocked": "Din konto er gjenåpnet. Vennligst logg inn for å fortsette."
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "har allerede blitt bekreftet, forsøk å logg inn",
        "confirmation_period_expired": "må bekreftes innen %{period}, vennligst forespør en ny en",
        "expired": "har utløpt, vennligst få en ny en",
        "not_found": "ikke funnet",
        "not_locked": "var ikke låst",
        "not_saved": {
          "one": "Én feil gjorde at %{resource} ikke kunne lagres:",
          "other": "%{count} feil gjorde at %{resource} ikke kunne lagres:"
        }
      }
    }
  },
  "no-NO": {
    "faker": {
      "invoice": {
        "reference": {
          "check_digit_method": "kidmod10",
          "pattern": "\\d{24}#"
        }
      }
    }
  },
  "oc": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "La validacion a fracassat : %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Podètz pas suprimir l’enregistrament perque i a %{record} dependéncias",
            "has_one": "Podètz pas suprimir l’enregistrament perque i a una dependéncia"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dg",
        "dl",
        "dm",
        "dc",
        "dj",
        "dv",
        "ds"
      ],
      "abbr_month_names": [
        null,
        "gen",
        "feb",
        "març",
        "abr",
        "mai",
        "junh",
        "jul",
        "ago",
        "set",
        "oct",
        "nov",
        "dec"
      ],
      "day_names": [
        "dimenge",
        "diluns",
        "dimars",
        "dimècres",
        "dijòus",
        "divendres",
        "dissabte"
      ],
      "formats": {
        "default": "%e/%m/%Y",
        "long": "Lo %e %B de %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "de genièr",
        "de febrièr",
        "de març",
        "d’abrial",
        "de mai",
        "de junh",
        "de julhet",
        "d’agost",
        "de setembre",
        "d’octòbre",
        "de novembre",
        "de decembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "Fa una ora",
          "other": "Fa %{count} oras"
        },
        "about_x_months": {
          "one": "Fa un mes",
          "other": "Fa %{count} meses"
        },
        "about_x_years": {
          "one": "Fa un an",
          "other": "Fa %{count} ans"
        },
        "almost_x_years": {
          "one": "quasi un an",
          "other": "quasi %{count} ans"
        },
        "half_a_minute": "mièja minuta",
        "less_than_x_minutes": {
          "one": "mens d’una minuta",
          "other": "mens de %{count} minutas"
        },
        "less_than_x_seconds": {
          "one": "mens d’una segonda",
          "other": "mens de %{count} segondas"
        },
        "over_x_years": {
          "one": "mai d’un an",
          "other": "mai de %{count} ans"
        },
        "x_days": {
          "one": "un jorn",
          "other": "%{count} jorns"
        },
        "x_minutes": {
          "one": "una minuta",
          "other": "%{count} minutas"
        },
        "x_months": {
          "one": "un mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "una segonda",
          "other": "%{count} segondas"
        },
        "x_years": {
          "one": "un an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "jorn",
        "hour": "ora",
        "minute": "minuta",
        "month": "mes",
        "second": "segonda",
        "year": "an"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "deu èsser acceptat",
        "blank": "deu èsser garnit",
        "confirmation": "correspond pas a %{attribute}",
        "empty": "pòt pas èsser void",
        "equal_to": "deu èsser egal a %{count}",
        "even": "deu èsser parelh",
        "exclusion": "es reservat",
        "greater_than": "deu èsser superior a %{count}",
        "greater_than_or_equal_to": "deu èsser mai grand o egal a %{count}",
        "inclusion": "es pas inclús dins la lista",
        "invalid": "es pas valid",
        "less_than": "deu èsser inferior a %{count}",
        "less_than_or_equal_to": "deu èsser inferior o egal a %{count}",
        "model_invalid": "Validacion fracassada : %{errors}",
        "not_a_number": "es pas un nombre",
        "not_an_integer": "deu èsser un nombre entièr",
        "odd": "deu èsser un nombre impar",
        "other_than": "deu èsser diferent de %{count}",
        "present": "deu èsser void",
        "required": "deu existir",
        "taken": "es pas disponible",
        "too_long": {
          "one": "es tròp long (pas mai d’un caractèr)",
          "other": "es tròp long (%{count} caractèrs al maximum)"
        },
        "too_short": {
          "one": "es tròp cort (almens un caractèr)",
          "other": "es tròp cort (almens %{count} caractèrs)"
        },
        "wrong_length": {
          "one": "a pas la bona longor (un caractèr solament)",
          "other": "a pas la bona longor (%{count} caractèrs exactament)"
        }
      },
      "template": {
        "body": "I a agut de problèmas amb los camps seguents : ",
        "header": {
          "one": "Impossible d’enregistrar aqueste/a %{model} perque i a %{count} error",
          "other": "Impossible d’enregistrar aqueste/a %{model} perque i a %{count} errors"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Mercés de seleccionar"
      },
      "submit": {
        "create": "Crear %{model}",
        "submit": "Salvar %{model}",
        "update": "Actualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Á": "A",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ë": "E",
          "Í": "I",
          "Ï": "I",
          "Ò": "O",
          "Ó": "O",
          "Ú": "U",
          "Ü": "U",
          "à": "a",
          "á": "a",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ë": "e",
          "í": "i",
          "ï": "i",
          "ò": "o",
          "ó": "o",
          "ú": "u",
          "ü": "u"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miliard",
            "million": "milion",
            "quadrillion": "milion de miliards",
            "thousand": "mila",
            "trillion": "bilion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "tb": "To"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "Lo %e %b de %Y a %Ho%M %Ss",
        "long": "Lo %a %e %b de %Y a %Ho%M",
        "short": "%e %b %Ho%M"
      },
      "pm": "pm"
    }
  },
  "or": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "ସଠିକ୍ ନୁହ: %{errors}"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ରବି",
        "ସୋମ",
        "ମଂଗଳ",
        "ବୁଧ",
        "ଗୁରୁ",
        "ଶୁକ୍ର",
        "ଶନି"
      ],
      "abbr_month_names": [
        null,
        "ଜାନୁ",
        "ଫେବରୁ",
        "ମାର",
        "ଏପ୍ର",
        "ମାଈ",
        "ଜୁନ୍",
        "ଜୁଲ୍",
        "ଅଗସ୍ଟ",
        "ସେପ୍ଟ",
        "ଅକ୍ଟ",
        "ନୋଭ",
        "ଡିସ୍"
      ],
      "day_names": [
        "ରବିବାର",
        "ସୋମବାର",
        "ମଗଂଳବାର",
        "ବୁଧବାର",
        "ଗୁରୁବାର",
        "ଶୁକ୍ରବାର",
        "ଶନିବାର"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "ଜାନୁୟାରୀ",
        "ଫେବୃୟାରୀ",
        "ମାର୍ଚ଼",
        "ଏପ୍ରଲ",
        "ମାଈ",
        "ଜୁନ୍",
        "ଜୁଲାୟ",
        "ଅଗଷ୍ତ",
        "ସେପ୍ଟମ୍ବର୍",
        "ଅକ୍ଟୋବର୍",
        "ନୋଭେମ୍ବର",
        "ଡିସମ୍ବର"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ପାଖାପାଖି %{count} ଘଣ୍ତ",
          "other": "ପାଖାପାଖି %{count} ଘଣ୍ତ"
        },
        "about_x_months": {
          "one": "ପାଖାପାଖି %{count} ମାସ",
          "other": "ପାଖାପାଖି %{count} ମାସ"
        },
        "about_x_years": {
          "one": "ପାଖାପାଖି %{count} year",
          "other": "ପାଖାପାଖି %{count} years"
        },
        "almost_x_years": {
          "one": "ଅଳ୍ପ ଉଣ %{count} ବର୍ଷ",
          "other": "ଅଳ୍ପ ଉଣ %{count} ବର୍ଷ"
        },
        "half_a_minute": "ଦେଢ ମିନଟ୍",
        "less_than_x_minutes": {
          "one": "%{count} ମିନଟ ବାକ",
          "other": "%{count} ମିନଟ ବାକ"
        },
        "less_than_x_seconds": {
          "one": "%{count} ସେକଣ୍ଢ ବାକ",
          "other": "%{count} ସେକଣ୍ଢ ବାକ"
        },
        "over_x_years": {
          "one": "%{count} ବର୍ଷରୁ ଅଧିକ",
          "other": "%{count} ବର୍ଷରୁ ଅଧିକ"
        },
        "x_days": {
          "one": "%{count}  ଦିନ",
          "other": "%{count} ଦିନ"
        },
        "x_minutes": {
          "one": "%{count} ମିନଟ",
          "other": "%{count} ମିନଟ"
        },
        "x_months": {
          "one": "%{count} ମାସ",
          "other": "%{count} ମାସ"
        },
        "x_seconds": {
          "one": "%{count} ସେକଣ୍ଢ",
          "other": "%{count} ସେକଣ୍ଢ"
        }
      },
      "prompts": {
        "day": "ଦିନ",
        "hour": "ଘଣ୍ତ",
        "minute": "ମିନଟ",
        "month": "ମାସ",
        "second": "ସେକଣ୍ଢ",
        "year": "ବର୍ଷ"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ଗ୍ରହଣ କରିବାର ଅଛି",
        "blank": "ଖାଲି ହେଇ ପାରୀବନ",
        "confirmation": "ପ୍ରମାଣ ହେଇନି",
        "empty": "ଖାଲି ହେଇପାରିବନି",
        "equal_to": "%{count} କୁ ସମାନ",
        "even": "ଯୁଗ୍ମ ହେବାର ଅଛି",
        "exclusion": "ସୁରଖିତ ଅଟେ",
        "greater_than": "%{count} ରୁ ବଡ ହେବାର ଅଛି",
        "greater_than_or_equal_to": "%{count} ରୁ ବଡ କିମ୍ବା ସମାନ ହେବାର ଅଛି",
        "inclusion": "ସୁଚୀ ରେ ଅନ୍ତର୍ଭୁକ୍ତ ନୁହେଁ",
        "invalid": "ଠିକ୍ ନୁହେଁ",
        "less_than": "%{count} ରୁ ଛୋଟ",
        "less_than_or_equal_to": "%{count} ରୁ ଛୋଟ କିମ୍ବା ସମାନ ହେବାର ଅଛି",
        "not_a_number": "ସଂଖ୍ଯ ନୁହେଁ",
        "not_an_integer": "ଗଣନ ସଂଖ୍ଯା ହେବାର ଅଛି",
        "odd": "ଅଯୁଗ୍ମ ହେବାର ଅଛି",
        "taken": "ଗ୍ରହଣ  କରା ଯାଇଛି",
        "too_long": "ଦିର୍ଘତମ ଅଟେ(ଅତ୍ୟଧୀକ %{count} ଅଖ୍ଯର)",
        "too_short": "ଅତି ସଂଖିପ୍ତ ଅଟେ (ଅତ୍ଯଳ୍ପ %{count} ଅଖ୍ଯର ଅଟେ)",
        "wrong_length": "ଲମ୍ବା ଭୁଲ ଅଟେ (%{count} ଅଖ୍ଯର ହେବା ଉଚିତ୍)"
      },
      "template": {
        "body": "ନିମ୍ନ ଜାଗା ରେ ଅସୁବିଧା ହେଇଛି:",
        "header": {
          "one": "%{count} ଭୁଲ ଯଗୁଁ ନିମ୍ନ %{model} ସୁରଖିତ ହେଇପାରି ନଥିଲା",
          "other": "%{count} ଭୁଲ ଯଗୁଁ ଏହି %{model} ସୁରଖିତ ହେଇପାରି ନଥିଲା"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "ପସନ୍ଦ କର"
      },
      "submit": {
        "create": "%{model} ବନାଅ",
        "submit": "%{model} ସୁରଖିତ କର",
        "update": "%{model} ଅାଧୂନିକରଣ କର"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": "ମିଥ୍ଯା",
        "strip_insignificant_zeros": "ମିଥ୍ଯା"
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "ବିଲିୟନ୍",
            "million": "ମିଲିୟନ୍",
            "quadrillion": "ହଜାର ବିଲିୟନ୍",
            "thousand": "ହଜାର",
            "trillion": "ଟ୍ରିଲିୟନ୍",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", ଏବଂ ",
        "two_words_connector": " ଏବଂ ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "ପୁର୍ଵାହ୍ନ",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "ଅପରାହ୍ନ"
    }
  },
  "pa": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "ਪਰਮਾਣ ਫ਼ੇਲ ਹੋਇਆ: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "ਮਿਟਾ ਨਹੀਂ ਸਕਦੇ ਕਿਉਂਕਿ ਨਿਰਭਰ %{record} ਮੌਜੂਦ ਹਨ",
            "has_one": "ਮਿਟਾ ਨਹੀਂ ਸਕਦੇ ਕਿਉਂਕਿ ਇੱਕ ਨਿਰਭਰ %{record} ਮੌਜੂਦ ਹੈ"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ਅੈਤ",
        "ਸੋਮ",
        "ਮੰਗਲ",
        "ਬੱੁਧ",
        "ਵੀਰ",
        "ਸ਼ੁੱਕਰ",
        "ਸ਼ਨਿੱਚਰ"
      ],
      "abbr_month_names": [
        null,
        "ਜਨ",
        "ਫ਼ਰ",
        "ਮਾਰਚ",
        "ਅਪ੍ਰੈ",
        "ਮਈ",
        "ਜੂਨ",
        "ਜੁਲਾ",
        "ਅਗ",
        "ਸਤੰ",
        "ਅਕਤੂ",
        "ਨਵੰ",
        "ਦਸੰ"
      ],
      "day_names": [
        "ਐਤਵਾਰ",
        "ਸੋਮਵਾਰ",
        "ਮੰਗਲਵਾਰ",
        "ਬੁੱਧਵਾਰ",
        "ਵੀਰਵਾਰ",
        "ਸ਼ੁੱਕਰਵਾਰ",
        "ਸ਼ਨਿੱਚਰਵਾਰ"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "ਜਨਵਰੀ",
        "ਫ਼ਰਵਰੀ",
        "ਮਾਰਚ",
        "ਅਪ੍ਰੈਲ",
        "ਮਈ",
        "ਜੂਨ",
        "ਜੁਲਾਈ",
        "ਅਗਸਤ",
        "ਸਤੰਬਰ",
        "ਅਕਤੂਬਰ",
        "ਨਵੰਬਰ",
        "ਦਸੰਬਰ"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ਲਗਭਗ %{count} ਘੰਟਾ",
          "other": "ਲਗਭਗ %{count} ਘੰਟੇ"
        },
        "about_x_months": {
          "one": "ਲਗਭਗ %{count} ਮਹੀਨਾ",
          "other": "ਲਗਭਗ %{count} ਮਹੀਨੇ"
        },
        "about_x_years": {
          "one": "ਲਗਭਗ %{count} ਸਾਲ",
          "other": "ਲਗਭਗ %{count} ਸਾਲ"
        },
        "almost_x_years": {
          "one": "ਤਕਰੀਬਨ %{count} ਸਾਲ",
          "other": "ਤਕਰੀਬਨ %{count} ਸਾਲ"
        },
        "half_a_minute": "ਅੱਧਾ ਮਿੰਟ",
        "less_than_x_minutes": {
          "one": "%{count} ਮਿੰਟ ਤੋਂ ਘੱਟ",
          "other": "%{count} ਮਿੰਟਾਂ ਤੋਂ ਘੱਟ"
        },
        "less_than_x_seconds": {
          "one": "%{count} ਸਕਿੰਟ ਤੋਂ ਘੱਟ",
          "other": "%{count} ਸਕਿੰਟਾਂ ਤੋਂ ਘੱਟ"
        },
        "over_x_years": {
          "one": "%{count} ਸਾਲ ਤੋਂ ਵੱਧ",
          "other": "%{count} ਸਾਲਾਂ ਤੋਂ ਵੱਧ"
        },
        "x_days": {
          "one": "%{count} ਦਿਨ",
          "other": "%{count} ਦਿਨ"
        },
        "x_minutes": {
          "one": "%{count} ਮਿੰਟ",
          "other": "%{count} ਮਿੰਟ"
        },
        "x_months": {
          "one": "%{count} ਮਹੀਨਾ",
          "other": "%{count} ਮਹੀਨੇ"
        },
        "x_seconds": {
          "one": "%{count} ਸਕਿੰਟ",
          "other": "%{count} ਸਕਿੰਟ"
        }
      },
      "prompts": {
        "day": "ਦਿਨ",
        "hour": "ਘੰਟਾ",
        "minute": "ਮਿੰਟ",
        "month": "ਮਹੀਨਾ",
        "second": "ਸਕਿੰਟ",
        "year": "ਸਾਲ"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ਜਰੂਰ ਮੰਜੂਰ ਹੋਵੇ",
        "blank": "ਖਾਲੀ ਨਹੀਂ ਹੋ ਸਕਦਾ",
        "confirmation": "%{attribute} ਨਹੀਂ ਰਲਦੇ",
        "empty": "ਖਾਲੀ ਨਹੀਂ ਹੋ ਸਕਦਾ",
        "equal_to": "%{count} ਦੇ ਬਰਾਬਰ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
        "even": "ਜਰੂਰੀ ਹੈ ਕੇ ਜੋਟਾ ਹੋਵੇ",
        "exclusion": "ਮੱਲਿਆ ਹੋਇਆ ਹੈ",
        "greater_than": "%{count} ਤੋਂ ਵਧੇਰੇ ਹੋਣਾ ਜਰੂਰੀ ਹੈ",
        "greater_than_or_equal_to": "%{count} ਤੋਂ ਵਧੇਰੇ ਜਾਂ ਬਰਾਬਰ ਹੋਣਾ ਜਰੂਰੀ ਹੈ",
        "inclusion": "ਇਸ ਲਿਸਟ ਵਿੱਚ ਸ਼ਾਮਿਲ ਨਹੀਂ ਹੈ",
        "invalid": "ਨਾ-ਮੰਜੂਰਸ਼ੁਦਾ ਹੈ",
        "less_than": "%{count} ਤੋਂ ਘੱਟ ਹੋਣਾ ਜਰੂਰੀ ਹੈ",
        "less_than_or_equal_to": "%{count} ਤੋਂ ਘੱਟ ਜਾਂ ਬਰਾਬਰ ਹੋਣਾ ਜਰੂਰੀ ਹੈ",
        "not_a_number": "ਸੰਖਿਆ ਨਹੀਂ ਹੈ",
        "not_an_integer": "ਜਰੂਰੀ ਹੈ ਕੇ ਪੂਰਨ ਅੰਕ ਹੋਵੇ",
        "odd": "ਜਰੂਰੀ ਹੈ ਕੇ ਕਲ਼ੀ ਹੋਵੇ",
        "other_than": "%{count} ਦੀ ਜਗ੍ਹਾ ਹੋਰ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ",
        "present": "ਜਰੂਰ ਖਾਲੀ ਹੋਵੇ",
        "taken": "ਪਹਿਲਾਂ ਹੀ ਮੱਲਿਆ ਹੋਇਆ ਹੈ",
        "too_long": {
          "one": "ਲੰਬਾਈ ਜ਼ਿਆਦਾ ਹੈ (ਵੱਧ ਤੋਂ ਵੱਧ %{count} ਅੱਖਰ)",
          "other": "ਲੰਬਾਈ ਜ਼ਿਆਦਾ ਹੈ (ਵੱਧ ਤੋਂ ਵੱਧ %{count} ਅੱਖਰ)"
        },
        "too_short": {
          "one": "ਲੰਬਾਈ ਘੱਟ ਹੈ (ਘੱਟ ਤੋਂ ਘੱਟ %{count} ਅੱਖਰ)",
          "other": "ਲੰਬਾਈ ਘੱਟ ਹੈ (ਘੱਟ ਤੋਂ ਘੱਟ %{count} ਅੱਖਰ)"
        },
        "wrong_length": {
          "one": "ਲੰਬਾਈ ਗਲਤ ਹੈ (%{count} ਅੱਖਰ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ)",
          "other": "ਲੰਬਾਈ ਗਲਤ ਹੈ (%{count} ਅੱਖਰ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ)"
        }
      },
      "template": {
        "body": "ਹੇਠਲੇ ਖੇਤਰਾਂ ਵਿੱਚ ਗਲਤੀਆਂ ਹਨ:",
        "header": {
          "one": "%{count} ਗਲਤੀ ਕਰਕੇ ਇਹ %{model} ਸੰਭਾਲਿ਼ਆ ਨਹੀਂ ਗਿਆ",
          "other": "%{count} ਗਲਤੀਆਂ ਕਰਕੇ ਇਹ %{model} ਸੰਭਾਲਿ਼ਆ ਨਹੀਂ ਗਿਆ"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "ਕਿਰਪਾ ਕਰਕੇ ਚੁਣੋ"
      },
      "submit": {
        "create": "%{model} ਬਣਾਓ",
        "submit": "%{model} ਬਚਾਓ",
        "update": "%{model} ਬਦਲੋ"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "ਬਿਲੀਅਨ",
            "million": "ਮਿਲੀਅਨ",
            "quadrillion": "ਕ੍ਵਾਡਰਿਲੀਅਨ",
            "thousand": "ਹਜ਼ਾਰ",
            "trillion": "ਟ੍ਰਿਲੀਅਨ",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "ਬਾਈਟ",
              "other": "ਬਾਈਟ"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", ਅਤੇ ",
        "two_words_connector": " ਅਤੇ ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "ਸਵੇਰ",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "ਸ਼ਾਮ"
    }
  },
  "pap-AW": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "A manda konfirmashon",
          "confirmation_token": "Token di konfirmashon",
          "confirmed_at": "Konfirmá",
          "created_at": "Kreá",
          "current_password": "Kódigo di akseso aktual",
          "current_sign_in_at": "Seshon aktual di",
          "current_sign_in_ip": "PI di seshon aktual",
          "email": "E-mail",
          "encrypted_password": "kódigo di akseso sifrá",
          "failed_attempts": "Intentonan frakasá",
          "last_sign_in_at": "Lastu seshon",
          "last_sign_in_ip": "Lastu PI di un seshon",
          "locked_at": "Akseso eliminá",
          "password": "Kódigo di akseso",
          "password_confirmation": "Konfirmashon di kódigo di akseso",
          "remember_created_at": "Kòrda, kreá",
          "remember_me": "Kòrdami",
          "reset_password_sent_at": "Re-establesementu di kódigo mandá",
          "reset_password_token": "Re-establesé token di kódigo di akseso",
          "sign_in_count": "Kantidat di seshon",
          "unconfirmed_email": "E-mail no konfirmá",
          "unlock_token": "Krea akseso na e token",
          "updated_at": "Aktualisá"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validashon a faya: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No por kita e registro akí pasobra otro %{record} ta dependé di dje",
            "has_one": "No por kita e registro akí pasobra un otro %{record} ta dependé di dje"
          }
        }
      },
      "models": {
        "user": "Usadó"
      }
    },
    "date": {
      "abbr_day_names": [
        "dum",
        "lun",
        "mar",
        "ras",
        "wep",
        "biè",
        "sab"
      ],
      "abbr_month_names": [
        null,
        "yan",
        "feb",
        "mar",
        "apr",
        "mei",
        "yün",
        "yül",
        "oug",
        "sèp",
        "òkt",
        "nov",
        "des"
      ],
      "day_names": [
        "djadumingu",
        "djaluna",
        "djamars",
        "djárason",
        "djaweps",
        "djabièrnè",
        "djasabra"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B di %d, %Y",
        "short": "%b di %d"
      },
      "month_names": [
        null,
        "yanüari",
        "febrüari",
        "mart",
        "aprel",
        "mei",
        "yüni",
        "yüli",
        "ougùstùs",
        "sèptèmber",
        "òktober",
        "novèmber",
        "desèmber"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "mas o ménos %{count} ora",
          "other": "mas o ménos %{count} ora"
        },
        "about_x_months": {
          "one": "mas o ménos %{count} luna",
          "other": "mas o ménos %{count} luna"
        },
        "about_x_years": {
          "one": "mas o ménos %{count} aña",
          "other": "mas o ménos %{count} aña"
        },
        "almost_x_years": {
          "one": "kasi %{count} aña",
          "other": "kasi %{count} aña"
        },
        "half_a_minute": "mei minüt",
        "less_than_x_minutes": {
          "one": "ménos ku %{count} minüt",
          "other": "ménos ku %{count} minüt"
        },
        "less_than_x_seconds": {
          "one": "ménos ku %{count} sekònde",
          "other": "ménos ku %{count} sekònde"
        },
        "over_x_years": {
          "one": "mas ku %{count} aña",
          "other": "mas ku %{count} aña"
        },
        "x_days": {
          "one": "%{count} dia",
          "other": "%{count} dia"
        },
        "x_minutes": {
          "one": "%{count} minüt",
          "other": "%{count} minüt"
        },
        "x_months": {
          "one": "%{count} luna",
          "other": "%{count} luna"
        },
        "x_seconds": {
          "one": "%{count} sekònde",
          "other": "%{count} sekònde"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Dia",
        "hour": "Ora",
        "minute": "Minüt",
        "month": "Luna",
        "second": "Sekònde",
        "year": "Aña"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Bo kuenta ta konfirmá.",
        "new": {
          "resend_confirmation_instructions": "manda instrukshon di konfirmashon atrobe"
        },
        "send_instructions": "Djis akí lo bo risibí un e-mail ku instrukshon tokante kon konirmá bo kuenta.",
        "send_paranoid_instructions": "Si bo e-mail ta den nos banko di dato, lo bo haña un mensage djis akí via e-mail ku instrukshon pa konfirmá bo kuenta."
      },
      "failure": {
        "already_authenticated": "Bo seshon a kuminsá kaba.",
        "inactive": "Bo kuenta no ta aktivá ainda.",
        "invalid": "%{authentication_keys} òf kódigo di akseso inbálido.",
        "last_attempt": "Bo a sobra un intento promé ku bo kuenta bira inaksesibel.",
        "locked": "Bo kuenta ta inaksesibel.",
        "not_found_in_database": "%{authentication_keys} òf kódigo di akseso inbálido.",
        "timeout": "Bo seshon a kaduká, por fabor kuminsá un seshon nobo pa por sigui.",
        "unauthenticated": "Pa haña akseso, bo mester kuminsá un seshon òf registrá.",
        "unconfirmed": "Bo mester konfirmá bo kuenta di e-mail promé ku sigui."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Konfirmá mi kuenta.",
          "greeting": "Bonbiní %{recipient}!",
          "instruction": "Bo por konfirmá bo kuenta di e-mail via e lenk aki bou:",
          "subject": "Instrukshon pa konfirmashon"
        },
        "email_changed": {
          "greeting": "Saludo %{recipient}!",
          "message": "Nos ta tuma kontakto awor pa informábo ku nos ta den proseso di kambia bo e-mail pa %{email}.",
          "subject": "E-mail a kambia"
        },
        "password_change": {
          "greeting": "Saludo %{recipient}!",
          "message": "Nos ta tuma kontakto awor pa informábo ku bo e-mail a kambia.",
          "subject": "E-mail a kambia"
        },
        "reset_password_instructions": {
          "action": "Kambia mi e-mail",
          "greeting": "Saludo %{recipient}!",
          "instruction": "Un hende a pidi un lenk pa kambia bo kódigo di akseso, i bo por hasi esaki via e lenk abou.",
          "instruction_2": "Si bo no a pidi esaki, por fabor no paga tinu na e mail akí.",
          "instruction_3": "Bo kódigo di akseso lo no kambia te ora bo usa e lenk indiká ariba i krea unu nobo.",
          "subject": "Instrukshon pa re-establesé kódigo di akseso"
        },
        "unlock_instructions": {
          "action": "Krea akseso na mi kuenta",
          "greeting": "Saludo %{recipient}!",
          "instruction": "Klek riba e lenk abou pa haña akseso na bo kuenta:",
          "message": "A eliminá akseso na bo kuenta pa motibu di un kantidat eksesivo di intento frakasá pa kuminsá un seshon.",
          "subject": "Instrukshon pa re-establesé akseso."
        }
      },
      "omniauth_callbacks": {
        "failure": "No por a sertifikábo for di %{kind} pasobra \"%{reason}\".",
        "success": "Sertifiká for di kuenta %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Kambia mi kódigo di akseso",
          "change_your_password": "Kambia bo kódigo di akseso",
          "confirm_new_password": "Konfirmá kódigo di akseso nobo",
          "new_password": "Kódigo di akseso nobo"
        },
        "new": {
          "forgot_your_password": "Bo a lubidá bo kódigo di akseso?",
          "send_me_reset_password_instructions": "Manda instrukshon pa mi pa re-establesé kódigo di akseso."
        },
        "no_token": "Bo no tin akseso na e página akí si bo no bini di un e-mail pa re-establesé bo kódigo di akseso. Si bo ta bin di un e-mail pa re-establesé kódigo di akseso, por fabor chèk si bo a usa e URL ku bo a haña den su forma kompletu.",
        "send_instructions": "Lo bo haña un e-mail djis akí ku instrukshon pa re-establesé bo kódigo di akseso.",
        "send_paranoid_instructions": "Si bo e-mail ta den nos banko di dato,lo bo haña un lenk djis akí via e-mail pa rekuperá bo kódigo di akseso.",
        "updated": "Bo kódigo di akseso a kambia. Awor bo seshon a kuminsá.",
        "updated_not_active": "Bo kódigo di akseso a kambia."
      },
      "registrations": {
        "destroyed": "Ayó! Bo a kanselá bo kuenta. Nos ta spera di mirabo bèk prònto.",
        "edit": {
          "are_you_sure": "Bo ta sigur?",
          "cancel_my_account": "Kanselá mi kuenta.",
          "currently_waiting_confirmation_for_email": "Nos ta warda konfirmashon pa: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lag'é sin yena si bo no ke kambié",
          "title": "Redaktá %{resource}",
          "unhappy": "Bo no ta satisfecho?",
          "update": "Aktualisá",
          "we_need_your_current_password_to_confirm_your_changes": "nos mester di bo kódigo aktual pa konfirmá bo kambionan"
        },
        "new": {
          "sign_up": "Habri un kuenta nobo"
        },
        "signed_up": "Bonbiní! Bo a kuminsá un seshon.",
        "signed_up_but_inactive": "Bo a logra habri un kuenta. Pero nos no por a kuminsá un seshon pasobra bo kuenta no ta aktivo ainda.",
        "signed_up_but_locked": "Bo a logra habri un kuenta. Pero nos no por a kuminsá un seshon pasobra bo kuenta no ta aksesibel.",
        "signed_up_but_unconfirmed": "Nos a manda un mensage, ku un lenk pa konfirmashon, na bo e-mail. Por fabor, habri e lenk pa aktivá bo kuenta.",
        "update_needs_confirmation": "Bo a aktualisá bo kuenta, pero nos mester verifiká bo e-mail nobo. Por fabor chèk bo e-mail i klek riba e lenk di konfirmashon pa por kaba di konfirmá bo kuenta di e-mail nobo.",
        "updated": "Bo a aktualisá bo kuenta."
      },
      "sessions": {
        "already_signed_out": "Bo a finalisá bo seshon.",
        "new": {
          "sign_in": "Kuminsá un seshon"
        },
        "signed_in": "Bo a kuminsá un seshon.",
        "signed_out": "Bo a finalisá un seshon."
      },
      "shared": {
        "links": {
          "back": "Bai bèk",
          "didn_t_receive_confirmation_instructions": "Bo no a haña instrukshon pa konfirmashon?",
          "didn_t_receive_unlock_instructions": "Bo no a haña instrushon pa krea akseso na e kuenta?",
          "forgot_your_password": "Bo a lubidá bo kódigo di akseso?",
          "sign_in": "Kuminsá un seshon",
          "sign_in_with_provider": "Kuminsá un seshon ku %{provider}",
          "sign_up": "Habri un kuenta nobo"
        },
        "minimum_password_length": {
          "one": "(%{count} lèter mínimo)",
          "other": "(%{count} lèter mínimo)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Bolbe manda instrukshon pa krea akseso"
        },
        "send_instructions": "Djis akí lo bo haña un mail ku instrukshon pa krea akseso na bo kuenta.",
        "send_paranoid_instructions": "Si bo kuenta ta eksistí, djis akí lo bo haña un e-mail ku instrukshon pa krea akseso na bo kuenta.",
        "unlocked": "Bo tin akseso atrobe na bo kuenta. Por fabor kuminsá un seshon pa por sigui."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "mester asept'é",
        "already_confirmed": "e tabata konfirmá kaba, por fabor purba kuminsá un seshon",
        "blank": "no por keda sin yen'é",
        "confirmation": "no ta meskos %{attribute}",
        "confirmation_period_expired": "mester konfirmá denter di %{period}, por fabor pidi unu nobo",
        "empty": "no por keda bashí",
        "equal_to": "mester ta meskos ku %{count}",
        "even": "mester ta par",
        "exclusion": "ta reservá",
        "expired": "el a kaduká, por fabor pidi unu nobo",
        "greater_than": "mester ta mas grandi ku %{count}",
        "greater_than_or_equal_to": "mester ta mes òf mas grandi ku %{count}",
        "inclusion": "no ta aparesé den e lista",
        "invalid": "no ta bálido",
        "less_than": "mester ta ménos ku %{count}",
        "less_than_or_equal_to": "mester ta ménos òf mes tantu ku %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "no ta un number",
        "not_an_integer": "mester ta un number hinté",
        "not_found": "no por a hañ'é",
        "not_locked": "e no tabata inaksesibel",
        "not_saved": {
          "one": "1 eror a anulá registrashon di e %{resource}:",
          "other": "%{count} eror a anulá registrashon di e %{resource}:"
        },
        "odd": "mester ta impar",
        "other_than": "no por ta %{count}",
        "present": "mester keda bashí",
        "required": "must exist",
        "taken": "ta usá kaba",
        "too_long": {
          "one": "ta muchu largu (máksimo ta %{count} karakter)",
          "other": "ta muchu largu (máksimo ta %{count} karakter)"
        },
        "too_short": {
          "one": "ta muchu kòrtiku (mínimo ta %{count} karakter)",
          "other": "ta muchu kòrtiku (mínimo ta %{count} karakter)"
        },
        "wrong_length": {
          "one": "su largura no ta korekto (mester ta %{count} karakter)",
          "other": "su largura no ta korekto (mester ta %{count} karakter)"
        }
      },
      "template": {
        "body": "E siguiente rúbrikanan ta duna problema:",
        "header": {
          "one": "%{count} fout a pone ku no por a warda e %{model} akí",
          "other": "%{count} fout a pone ku no por a save e %{model} akí"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por fabor skohe"
      },
      "submit": {
        "create": "Krea %{model}",
        "submit": "Warda %{model}",
        "update": "Aktualisá %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "ANG"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "bion",
            "million": "mion",
            "quadrillion": "kuatrion",
            "thousand": "mil",
            "trillion": "trion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": "bèrdat",
          "strip_insignificant_zeros": "bèrdat"
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Bait",
              "other": "Bait"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", i ",
        "two_words_connector": " i ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H.%M.%S %z",
        "long": "%d %B %Y %H.%M",
        "short": "%d %b %H.%M"
      },
      "pm": "pm"
    }
  },
  "pap-CW": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "A manda konfirmashon",
          "confirmation_token": "Token di konfirmashon",
          "confirmed_at": "Konfirmá",
          "created_at": "Kreá",
          "current_password": "Kódigo di akseso aktual",
          "current_sign_in_at": "Seshon aktual di",
          "current_sign_in_ip": "PI di seshon aktual",
          "email": "E-mail",
          "encrypted_password": "kódigo di akseso sifrá",
          "failed_attempts": "Intentonan frakasá",
          "last_sign_in_at": "Lastu seshon",
          "last_sign_in_ip": "Lastu PI di un seshon",
          "locked_at": "Akseso eliminá",
          "password": "Kódigo di akseso",
          "password_confirmation": "Konfirmashon di kódigo di akseso",
          "remember_created_at": "Kòrda, kreá",
          "remember_me": "Kòrdami",
          "reset_password_sent_at": "Re-establesementu di kódigo mandá",
          "reset_password_token": "Re-establesé token di kódigo di akseso",
          "sign_in_count": "Kantidat di seshon",
          "unconfirmed_email": "E-mail no konfirmá",
          "unlock_token": "Krea akseso na e token",
          "updated_at": "Aktualisá"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validashon a faya: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No por kita e registro akí pasobra otro %{record} ta dependé di dje",
            "has_one": "No por kita e registro akí pasobra un otro %{record} ta dependé di dje"
          }
        }
      },
      "models": {
        "user": "Usadó"
      }
    },
    "date": {
      "abbr_day_names": [
        "dum",
        "lun",
        "mar",
        "ras",
        "wep",
        "biè",
        "sab"
      ],
      "abbr_month_names": [
        null,
        "yan",
        "feb",
        "mar",
        "apr",
        "mei",
        "yün",
        "yül",
        "oug",
        "sèp",
        "òkt",
        "nov",
        "des"
      ],
      "day_names": [
        "djadumingu",
        "djaluna",
        "djamars",
        "djárason",
        "djaweps",
        "djabièrnè",
        "djasabra"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B di %d, %Y",
        "short": "%b di %d"
      },
      "month_names": [
        null,
        "yanüari",
        "febrüari",
        "mart",
        "aprel",
        "mei",
        "yüni",
        "yüli",
        "ougùstùs",
        "sèptèmber",
        "òktober",
        "novèmber",
        "desèmber"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "mas o ménos %{count} ora",
          "other": "mas o ménos %{count} ora"
        },
        "about_x_months": {
          "one": "mas o ménos %{count} luna",
          "other": "mas o ménos %{count} luna"
        },
        "about_x_years": {
          "one": "mas o ménos %{count} aña",
          "other": "mas o ménos %{count} aña"
        },
        "almost_x_years": {
          "one": "kasi %{count} aña",
          "other": "kasi %{count} aña"
        },
        "half_a_minute": "mei minüt",
        "less_than_x_minutes": {
          "one": "ménos ku %{count} minüt",
          "other": "ménos ku %{count} minüt"
        },
        "less_than_x_seconds": {
          "one": "ménos ku %{count} sekònde",
          "other": "ménos ku %{count} sekònde"
        },
        "over_x_years": {
          "one": "mas ku %{count} aña",
          "other": "mas ku %{count} aña"
        },
        "x_days": {
          "one": "%{count} dia",
          "other": "%{count} dia"
        },
        "x_minutes": {
          "one": "%{count} minüt",
          "other": "%{count} minüt"
        },
        "x_months": {
          "one": "%{count} luna",
          "other": "%{count} luna"
        },
        "x_seconds": {
          "one": "%{count} sekònde",
          "other": "%{count} sekònde"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Dia",
        "hour": "Ora",
        "minute": "Minüt",
        "month": "Luna",
        "second": "Sekònde",
        "year": "Aña"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Bo kuenta ta konfirmá.",
        "new": {
          "resend_confirmation_instructions": "manda instrukshon di konfirmashon atrobe"
        },
        "send_instructions": "Djis akí lo bo risibí un e-mail ku instrukshon tokante kon konirmá bo kuenta.",
        "send_paranoid_instructions": "Si bo e-mail ta den nos banko di dato, lo bo haña un mensage djis akí via e-mail ku instrukshon pa konfirmá bo kuenta."
      },
      "failure": {
        "already_authenticated": "Bo seshon a kuminsá kaba.",
        "inactive": "Bo kuenta no ta aktivá ainda.",
        "invalid": "%{authentication_keys} òf kódigo di akseso inbálido.",
        "last_attempt": "Bo a sobra un intento promé ku bo kuenta bira inaksesibel.",
        "locked": "Bo kuenta ta inaksesibel.",
        "not_found_in_database": "%{authentication_keys} òf kódigo di akseso inbálido.",
        "timeout": "Bo seshon a kaduká, por fabor kuminsá un seshon nobo pa por sigui.",
        "unauthenticated": "Pa haña akseso, bo mester kuminsá un seshon òf registrá.",
        "unconfirmed": "Bo mester konfirmá bo kuenta di e-mail promé ku sigui."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Konfirmá mi kuenta.",
          "greeting": "Bonbiní %{recipient}!",
          "instruction": "Bo por konfirmá bo kuenta di e-mail via e lenk aki bou:",
          "subject": "Instrukshon pa konfirmashon"
        },
        "email_changed": {
          "greeting": "Saludo %{recipient}!",
          "message": "Nos ta tuma kontakto awor pa informábo ku nos ta den proseso di kambia bo e-mail pa %{email}.",
          "subject": "E-mail a kambia"
        },
        "password_change": {
          "greeting": "Saludo %{recipient}!",
          "message": "Nos ta tuma kontakto awor pa informábo ku bo e-mail a kambia.",
          "subject": "E-mail a kambia"
        },
        "reset_password_instructions": {
          "action": "Kambia mi e-mail",
          "greeting": "Saludo %{recipient}!",
          "instruction": "Un hende a pidi un lenk pa kambia bo kódigo di akseso, i bo por hasi esaki via e lenk abou.",
          "instruction_2": "Si bo no a pidi esaki, por fabor no paga tinu na e mail akí.",
          "instruction_3": "Bo kódigo di akseso lo no kambia te ora bo usa e lenk indiká ariba i krea unu nobo.",
          "subject": "Instrukshon pa re-establesé kódigo di akseso"
        },
        "unlock_instructions": {
          "action": "Krea akseso na mi kuenta",
          "greeting": "Saludo %{recipient}!",
          "instruction": "Klek riba e lenk abou pa haña akseso na bo kuenta:",
          "message": "A eliminá akseso na bo kuenta pa motibu di un kantidat eksesivo di intento frakasá pa kuminsá un seshon.",
          "subject": "Instrukshon pa re-establesé akseso."
        }
      },
      "omniauth_callbacks": {
        "failure": "No por a sertifikábo for di %{kind} pasobra \"%{reason}\".",
        "success": "Sertifiká for di kuenta %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Kambia mi kódigo di akseso",
          "change_your_password": "Kambia bo kódigo di akseso",
          "confirm_new_password": "Konfirmá kódigo di akseso nobo",
          "new_password": "Kódigo di akseso nobo"
        },
        "new": {
          "forgot_your_password": "Bo a lubidá bo kódigo di akseso?",
          "send_me_reset_password_instructions": "Manda instrukshon pa mi pa re-establesé kódigo di akseso."
        },
        "no_token": "Bo no tin akseso na e página akí si bo no bini di un e-mail pa re-establesé bo kódigo di akseso. Si bo ta bin di un e-mail pa re-establesé kódigo di akseso, por fabor chèk si bo a usa e URL ku bo a haña den su forma kompletu.",
        "send_instructions": "Lo bo haña un e-mail djis akí ku instrukshon pa re-establesé bo kódigo di akseso.",
        "send_paranoid_instructions": "Si bo e-mail ta den nos banko di dato,lo bo haña un lenk djis akí via e-mail pa rekuperá bo kódigo di akseso.",
        "updated": "Bo kódigo di akseso a kambia. Awor bo seshon a kuminsá.",
        "updated_not_active": "Bo kódigo di akseso a kambia."
      },
      "registrations": {
        "destroyed": "Ayó! Bo a kanselá bo kuenta. Nos ta spera di mirabo bèk prònto.",
        "edit": {
          "are_you_sure": "Bo ta sigur?",
          "cancel_my_account": "Kanselá mi kuenta.",
          "currently_waiting_confirmation_for_email": "Nos ta warda konfirmashon pa: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lag'é sin yena si bo no ke kambié",
          "title": "Redaktá %{resource}",
          "unhappy": "Bo no ta satisfecho?",
          "update": "Aktualisá",
          "we_need_your_current_password_to_confirm_your_changes": "nos mester di bo kódigo aktual pa konfirmá bo kambionan"
        },
        "new": {
          "sign_up": "Habri un kuenta nobo"
        },
        "signed_up": "Bonbiní! Bo a kuminsá un seshon.",
        "signed_up_but_inactive": "Bo a logra habri un kuenta. Pero nos no por a kuminsá un seshon pasobra bo kuenta no ta aktivo ainda.",
        "signed_up_but_locked": "Bo a logra habri un kuenta. Pero nos no por a kuminsá un seshon pasobra bo kuenta no ta aksesibel.",
        "signed_up_but_unconfirmed": "Nos a manda un mensage, ku un lenk pa konfirmashon, na bo e-mail. Por fabor, habri e lenk pa aktivá bo kuenta.",
        "update_needs_confirmation": "Bo a aktualisá bo kuenta, pero nos mester verifiká bo e-mail nobo. Por fabor chèk bo e-mail i klek riba e lenk di konfirmashon pa por kaba di konfirmá bo kuenta di e-mail nobo.",
        "updated": "Bo a aktualisá bo kuenta."
      },
      "sessions": {
        "already_signed_out": "Bo a finalisá bo seshon.",
        "new": {
          "sign_in": "Kuminsá un seshon"
        },
        "signed_in": "Bo a kuminsá un seshon.",
        "signed_out": "Bo a finalisá un seshon."
      },
      "shared": {
        "links": {
          "back": "Bai bèk",
          "didn_t_receive_confirmation_instructions": "Bo no a haña instrukshon pa konfirmashon?",
          "didn_t_receive_unlock_instructions": "Bo no a haña instrushon pa krea akseso na e kuenta?",
          "forgot_your_password": "Bo a lubidá bo kódigo di akseso?",
          "sign_in": "Kuminsá un seshon",
          "sign_in_with_provider": "Kuminsá un seshon ku %{provider}",
          "sign_up": "Habri un kuenta nobo"
        },
        "minimum_password_length": {
          "one": "(%{count} lèter mínimo)",
          "other": "(%{count} lèter mínimo)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Bolbe manda instrukshon pa krea akseso"
        },
        "send_instructions": "Djis akí lo bo haña un mail ku instrukshon pa krea akseso na bo kuenta.",
        "send_paranoid_instructions": "Si bo kuenta ta eksistí, djis akí lo bo haña un e-mail ku instrukshon pa krea akseso na bo kuenta.",
        "unlocked": "Bo tin akseso atrobe na bo kuenta. Por fabor kuminsá un seshon pa por sigui."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "mester asept'é",
        "already_confirmed": "e tabata konfirmá kaba, por fabor purba kuminsá un seshon",
        "blank": "no por keda sin yen'é",
        "confirmation": "no ta meskos %{attribute}",
        "confirmation_period_expired": "mester konfirmá denter di %{period}, por fabor pidi unu nobo",
        "empty": "no por keda bashí",
        "equal_to": "mester ta meskos ku %{count}",
        "even": "mester ta par",
        "exclusion": "ta reservá",
        "expired": "el a kaduká, por fabor pidi unu nobo",
        "greater_than": "mester ta mas grandi ku %{count}",
        "greater_than_or_equal_to": "mester ta mes òf mas grandi ku %{count}",
        "inclusion": "no ta aparesé den e lista",
        "invalid": "no ta bálido",
        "less_than": "mester ta ménos ku %{count}",
        "less_than_or_equal_to": "mester ta ménos òf mes tantu ku %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "no ta un number",
        "not_an_integer": "mester ta un number hinté",
        "not_found": "no por a hañ'é",
        "not_locked": "e no tabata inaksesibel",
        "not_saved": {
          "one": "1 eror a anulá registrashon di e %{resource}:",
          "other": "%{count} eror a anulá registrashon di e %{resource}:"
        },
        "odd": "mester ta impar",
        "other_than": "no por ta %{count}",
        "present": "mester keda bashí",
        "required": "must exist",
        "taken": "ta usá kaba",
        "too_long": {
          "one": "ta muchu largu (máksimo ta %{count} karakter)",
          "other": "ta muchu largu (máksimo ta %{count} karakter)"
        },
        "too_short": {
          "one": "ta muchu kòrtiku (mínimo ta %{count} karakter)",
          "other": "ta muchu kòrtiku (mínimo ta %{count} karakter)"
        },
        "wrong_length": {
          "one": "su largura no ta korekto (mester ta %{count} karakter)",
          "other": "su largura no ta korekto (mester ta %{count} karakter)"
        }
      },
      "template": {
        "body": "E siguiente rúbrikanan ta duna problema:",
        "header": {
          "one": "%{count} fout a pone ku no por a warda e %{model} akí",
          "other": "%{count} fout a pone ku no por a save e %{model} akí"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por fabor skohe"
      },
      "submit": {
        "create": "Krea %{model}",
        "submit": "Warda %{model}",
        "update": "Aktualisá %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "ANG"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "bion",
            "million": "mion",
            "quadrillion": "kuatrion",
            "thousand": "mil",
            "trillion": "trion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": "bèrdat",
          "strip_insignificant_zeros": "bèrdat"
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Bait",
              "other": "Bait"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", i ",
        "two_words_connector": " i ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H.%M.%S %z",
        "long": "%d %B %Y %H.%M",
        "short": "%d %b %H.%M"
      },
      "pm": "pm"
    }
  },
  "pl": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Data wysłania potwierdzenia",
          "confirmation_token": "Token potwierdzający",
          "confirmed_at": "Data potwierdzenia",
          "created_at": "Data utworzenia",
          "current_password": "Aktualne hasło",
          "current_sign_in_at": "Data bieżącego logowania",
          "current_sign_in_ip": "Bieżący adres IP",
          "email": "Adres e-mail",
          "encrypted_password": "Zaszyfrowane hasło",
          "failed_attempts": "Nieudanych prób",
          "last_sign_in_at": "Data ostatniego logowania",
          "last_sign_in_ip": "Ostatni adres IP",
          "locked_at": "Data zablokowania",
          "password": "Hasło",
          "password_confirmation": "Potwierdzenie hasła",
          "remember_created_at": "Data utworzenia zapamiętania logowania",
          "remember_me": "Zapamiętaj mnie",
          "reset_password_sent_at": "Data wysłania żądania resetu hasła",
          "reset_password_token": "Token umożliwiający reset hasła",
          "sign_in_count": "Liczba logowań",
          "unconfirmed_email": "Niepotwierdzony adres e-mail",
          "unlock_token": "Token odblokowywujący",
          "updated_at": "Data uaktualnienia"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Znaleziono błędy: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Nie można usunąć, gdyż istnieją zależne od niego %{record}",
            "has_one": "Nie można usunąć, gdyż istnieje zależny od niego %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "nie",
        "pon",
        "wto",
        "śro",
        "czw",
        "pią",
        "sob"
      ],
      "abbr_month_names": [
        null,
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "paź",
        "lis",
        "gru"
      ],
      "day_names": [
        "niedziela",
        "poniedziałek",
        "wtorek",
        "środa",
        "czwartek",
        "piątek",
        "sobota"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "września",
        "października",
        "listopada",
        "grudnia"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "około %{count} godziny",
          "many": "około %{count} godzin",
          "one": "około godziny",
          "other": "około %{count} godzin"
        },
        "about_x_months": {
          "few": "około %{count} miesiące",
          "many": "około %{count} miesięcy",
          "one": "około miesiąca",
          "other": "około %{count} miesięcy"
        },
        "about_x_years": {
          "few": "około %{count} lata",
          "many": "około %{count} lat",
          "one": "około rok",
          "other": "około %{count} lat"
        },
        "almost_x_years": {
          "few": "prawie %{count} lata",
          "many": "prawie %{count} lat",
          "one": "prawie rok",
          "other": "prawie %{count} lat"
        },
        "half_a_minute": "pół minuty",
        "less_than_x_minutes": {
          "few": "mniej niż %{count} minuty",
          "many": "mniej niż %{count} minut",
          "one": "mniej niż minutę",
          "other": "mniej niż %{count} minut"
        },
        "less_than_x_seconds": {
          "few": "mniej niż %{count} sekundy",
          "many": "mniej niż %{count} sekund",
          "one": "mniej niż sekundę",
          "other": "mniej niż %{count} sekund"
        },
        "over_x_years": {
          "few": "ponad %{count} lata",
          "many": "ponad %{count} lat",
          "one": "ponad rok",
          "other": "ponad %{count} lat"
        },
        "x_days": {
          "few": "%{count} dni",
          "many": "%{count} dni",
          "one": "%{count} dzień",
          "other": "%{count} dni"
        },
        "x_minutes": {
          "few": "%{count} minuty",
          "many": "%{count} minut",
          "one": "%{count} minuta",
          "other": "%{count} minut"
        },
        "x_months": {
          "few": "%{count} miesiące",
          "many": "%{count} miesięcy",
          "one": "%{count} miesiąc",
          "other": "%{count} miesięcy"
        },
        "x_seconds": {
          "few": "%{count} sekundy",
          "many": "%{count} sekund",
          "one": "%{count} sekunda",
          "other": "%{count} sekund"
        }
      },
      "prompts": {
        "day": "Dzień",
        "hour": "Godzina",
        "minute": "Minuta",
        "month": "Miesiąc",
        "second": "Sekundy",
        "year": "Rok"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Twój adres e-mail został potwierdzony.",
        "new": {
          "resend_confirmation_instructions": "Wyślij ponownie instrukcje aktywacji"
        },
        "send_instructions": "Instrukcja jak aktywować konto zostanie niezwłocznie wysłana na podany adres e-mail.",
        "send_paranoid_instructions": "Jeśli Twój adres e-mail istnieje w naszej bazie, w ciągu najbliższych minut otrzymasz instrukcje jak aktywować konto."
      },
      "failure": {
        "already_authenticated": "Jesteś już zalogowany.",
        "inactive": "Twoje konto nie zostało jeszcze aktywowane.",
        "invalid": "Błędny adres %{authentication_keys} lub hasło.",
        "invited": "Posiadasz oczekujące zaproszenie, zaakceptuj je aby ukończyć proces rejestracji.",
        "last_attempt": "Masz jeszcze jedną próbę, nim Twoje konto zostanie zablokowane.",
        "locked": "Twoje konto jest zablokowane.",
        "not_found_in_database": "Błędny adres %{authentication_keys} lub hasło.",
        "timeout": "Sesja wygasła, aby kontynuować zaloguj się ponownie.",
        "unauthenticated": "Aby kontynuować zaloguj lub zarejestruj się.",
        "unconfirmed": "Aby kontynuować aktywuj konto."
      },
      "invitations": {
        "edit": {
          "header": "Ustaw swoje hasło",
          "submit_button": "Zapisz moje hasło"
        },
        "invitation_removed": "Twoje zaproszenie zostało usunięte.",
        "invitation_token_invalid": "Kod zaproszenia jest nieprawidłowy.",
        "new": {
          "header": "Wyślij zaproszenie",
          "submit_button": "Wyślij zaproszenie"
        },
        "no_invitations_remaining": "Brak oczekujących zaproszeń",
        "send_instructions": "E-mail z zaproszeniem został wysłany do %{email}.",
        "updated": "Twoje hasło zostało pomyślnie ustawione. Jesteś teraz zalogowany.",
        "updated_not_active": "Twoje hasło zostało ustawione."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potwierdź swoje konto",
          "confirm_account_link": "Potwierdź swoje konto",
          "confirm_link_msg": "Możesz potwierdzić swój e-mail poprzez link poniżej:",
          "greeting": "Witaj %{recipient}!",
          "instruction": "Możesz potwierdzić swoje konto przy pomocy poniższego linku:",
          "subject": "Instrukcja potwierdzania"
        },
        "email_changed": {
          "greeting": "Witaj %{recipient}!",
          "message": "Kontaktujemy się z Tobą, aby Cię poinformować o zmianie Twojego adresu e-mail na %{email}.",
          "message_unconfirmed": "Kontaktujemy się, by poinformować, że Twój adres e-mail został zmieniony na %{email}.",
          "subject": "E-mail zmieniony"
        },
        "invitation_instructions": {
          "accept": "Przyjmij zaproszenie",
          "accept_until": "Zaprosze będzie ważne do %{due_date}.",
          "hello": "Cześć %{email}",
          "ignore": "Jeśli nie chcesz przyjąć zaproszenia, zignoruj tę wiadomość.<br />Twoje konto nie zostanie utworzone do momentu ustawienia przez Ciebie hasła.",
          "someone_invited_you": "Ktoś zaprosił Cię do %{url}. Zaproszenie możesz zaakceptować przez podany link.",
          "subject": "Instrukcja do zaproszenia"
        },
        "password_change": {
          "greeting": "Witaj %{recipient}!",
          "message": "Kontaktujemy się z Tobą w celu poinformowania, że Twoje hasło zostało zmienione.",
          "subject": "Hasło zostało zmienione"
        },
        "reset_password_instructions": {
          "action": "Zmień swoje hasło",
          "greeting": "Cześć %{recipient}!",
          "ignore_mail_msg": "Jeśli to nie Ty próbowałeś zmienić swoje hasło to zignoruj ten email.",
          "instruction": "Ktoś zażądał zmiany hasła do Twojego konta. Hasło możesz zmienić wchodząc na poniższy link.",
          "instruction_2": "Jeśli to nie Ty zażądałeś zmiany hasła, proszę zignoruj tę wiadomość.",
          "instruction_3": "Twoje hasło nie ulegnie zmianie dopóki nie wejdziesz na poniższy link i nie ustawisz nowego.",
          "no_changes_msg": "Twoje hasło nie zmieni się do momentu ustawienia nowego.",
          "password_change_link": "Zmień hasło",
          "request_reset_link_msg": "Otrzymaliśmy prośbę o zmianę Twojego hasła. Możesz tego dokonać poprzez link poniżej:",
          "subject": "Instrukcje resetowania hasła"
        },
        "unlock_instructions": {
          "account_lock_msg": "Twoje konto zostało zablokowane z powodu zbyt dużej liczby nieudanych prób logowania.",
          "action": "Odblokuj swoje konto",
          "greeting": "Cześć %{recipient}!",
          "instruction": "Kliknij poniższy link, aby odblokować swoje konto:",
          "message": "Twoje konto zostało zablokowane z powodu zbyt dużej liczby nieprawidłowych prób zalogowania się na nie.",
          "subject": "Instrukcje do odblokowania",
          "unlock_link": "Odblokuj konto",
          "unlock_link_msg": "Kliknij poniższy link, aby odblokować konto:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Logowanie przez konto %{kind} zakończyło się błędem z powodu \"%{reason}\".",
        "success": "Logowanie przez konto %{kind} zakończyło się pomyślnie."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Zmień moje hasło",
          "change_your_password": "Zmień swoje hasło",
          "confirm_new_password": "Powtórz nowe hasło",
          "new_password": "Nowe hasło"
        },
        "new": {
          "forgot_your_password": "Zapomniałeś swojego hasła?",
          "send_me_reset_password_instructions": "Wyślij instrukcje zmiany hasła"
        },
        "no_token": "Do tej strony możesz dostać się tylko poprzez wiadomość e-mail resetującą hasło. Jeśli to z niej tu trafiłeś, upewnij się, że użyłeś pełnego adresu.",
        "send_instructions": "Instrukcja zmiany hasła zostanie niezwłocznie wysłana na podany adres e-mail.",
        "send_paranoid_instructions": "Jeśli Twój adres e-mail istnieje w naszej bazie, otrzymasz zaraz wiadomość z instrukcjami odzyskiwania hasła.",
        "updated": "Hasło zmienione poprawnie. Zostałeś automatycznie zalogowany.",
        "updated_not_active": "Twoje hasło zmienione poprawnie."
      },
      "registrations": {
        "destroyed": "Twoje konto zostało usunięte.",
        "edit": {
          "are_you_sure": "Jesteś pewny?",
          "cancel_my_account": "Anuluj moje konto",
          "currently_waiting_confirmation_for_email": "Aktualnie oczekujemy na potwierdzenie z: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "pozostaw puste, jeśli nie chcesz wprowadzać zmian",
          "title": "Edytuj %{resource}",
          "unhappy": "Niezadowolony",
          "update": "Aktualizuj",
          "we_need_your_current_password_to_confirm_your_changes": "potrzebujemy Twojego bieżącego hasła, aby potwierdzić zmiany"
        },
        "new": {
          "sign_up": "Zarejestruj się"
        },
        "signed_up": "Witaj! Rejestracja zakończyła się pomyślnie.",
        "signed_up_but_inactive": "Konto zostało utworzone pomyślnie. Zanim się jednak zalogujesz, musi ono zostać jeszcze aktywowane.",
        "signed_up_but_locked": "Konto zostało utworzone pomyślnie. Nie możesz się jednak zalogować, ponieważ jest ono zablokowane.",
        "signed_up_but_unconfirmed": "Wiadomość z linkiem aktywacyjnym została wysłana na podany adres e-mail. Otwórz link w celu aktywacji konta.",
        "update_needs_confirmation": "Konto zostało zaktualizowane, musimy jednak potwierdzić nowy adres e-mail. Sprawdź swoją skrzynkę pocztową i otwórz link aktywacyjny, aby ukończyć zmianę adresu.",
        "updated": "Konto zostało pomyślnie zaktualizowane.",
        "updated_but_not_signed_in": "Twoje konto zostało pomyślnie zaktualizowane, ale ponieważ hasło zostało zmienione, musisz się ponownie zalogować"
      },
      "sessions": {
        "already_signed_out": "Wylogowano pomyślnie.",
        "new": {
          "sign_in": "Zaloguj się"
        },
        "signed_in": "Zalogowano pomyślnie.",
        "signed_out": "Wylogowano pomyślnie."
      },
      "shared": {
        "links": {
          "back": "Powrót",
          "didn_t_receive_confirmation_instructions": "Nie otrzymałeś instrukcji aktywacji konta?",
          "didn_t_receive_unlock_instructions": "Nie otrzymałeś instrukcji odblokowania konta?",
          "forgot_your_password": "Zapomniałeś hasła?",
          "sign_in": "Zaloguj się",
          "sign_in_with_provider": "Zaloguj się przez %{provider}",
          "sign_up": "Zarejestruj się"
        },
        "minimum_password_length": {
          "few": "(minimum %{count} znaki)",
          "many": "(minimum %{count} znaków)",
          "one": "(minimum %{count} znak)",
          "other": "(minimum %{count} znaku)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Wyślij instrukcje odblokowania konta"
        },
        "send_instructions": "Wkrótce powinieneś otrzymać e-mail z instrukcjami jak odblokować swoje konto.",
        "send_paranoid_instructions": "Jeśli Twoje konto istnieje w naszej bazie, otrzymasz zaraz e-mail z instrukcjami jak odblokować swoje konto.",
        "unlocked": "Twoje konto zostało odblokowane. Zaloguj się, aby kontynuować."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Przekierowanie na adres '%{redirect_url}' nie jest dozwolone."
      },
      "passwords": {
        "missing_email": "Musisz wprowadzić adres e-mail.",
        "missing_passwords": "Musisz wypełnić wszystkie pola z etykietą 'Hasło' oraz 'Potwierdzenie hasła'.",
        "missing_redirect_url": "Brak adresu zwrotnego.",
        "not_allowed_redirect_url": "Przekierowanie na adres '%{redirect_url}' nie jest dozwolone.",
        "password_not_required": "To konto nie wymaga podania hasła. Zaloguj się używając konta '%{provider}'.",
        "sended": "Wiadomość wysłana na adres '%{email}' zawiera instrukcje dotyczące zmiany hasła.",
        "successfully_updated": "Twoje hasło zostało zaktualizowane.",
        "user_not_found": "Nie odnaleziono użytkownika o adresie '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Nie odnaleziono konta do usunięcia.",
        "account_with_uid_destroyed": "Konto z uid '%{uid}' zostało usunięte.",
        "email_already_exists": "Konto z adresem '%{email}' już istnieje.",
        "missing_confirm_success_url": "Brak parametru 'confirm_success_url'.",
        "redirect_url_not_allowed": "Przekierowanie na adres '%{redirect_url}' nie jest dozwolone.",
        "user_not_found": "Użytkownik nie został odnaleziony."
      },
      "sessions": {
        "bad_credentials": "Nieprawidłowe dane logowania. Proszę spróbować ponownie.",
        "not_confirmed": "Wiadomość z potwierdzeniem Twojego konta została wysłana na '%{email}'. Proszę postępować zgodnie z wskazówkami znajdującymi się w wiadomości celem aktywacji konta.",
        "not_supported": "Proszę użyć POST /sign_in do zalogowania. GET nie jest obsługiwany.",
        "user_not_found": "Użytkownik nie został odnaleziony lub nie jest zalogowany."
      },
      "token_validations": {
        "invalid": "Nieprawidłowe dane logowania."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "musi zostać zaakceptowane",
        "already_confirmed": "już został aktywowany, możesz się zalogować",
        "blank": "nie może być puste",
        "confirmation": "musi być taki sam jak w %{attribute}",
        "confirmation_period_expired": "musi być potwierdzone w ciągu %{period}, zamów nową wiadomość aktywacyjną",
        "empty": "nie może być puste",
        "equal_to": "musi być równe %{count}",
        "even": "musi być parzyste",
        "exclusion": "jest zarezerwowane",
        "expired": "stracił ważność, wyślij zapytanie o nowy",
        "greater_than": "musi być większe od %{count}",
        "greater_than_or_equal_to": "musi być większe lub równe %{count}",
        "inclusion": "nie znajduje się na liście dopuszczalnych wartości",
        "invalid": "jest nieprawidłowe",
        "less_than": "musi być mniejsze od %{count}",
        "less_than_or_equal_to": "musi być mniejsze lub równe %{count}",
        "not_a_number": "nie jest liczbą",
        "not_an_integer": "musi być liczbą całkowitą",
        "not_email": "nie jest prawidłowym adresem e-mail",
        "not_found": "nie znaleziono",
        "not_locked": "nie był zablokowany",
        "not_saved": {
          "few": "%{resource} nie został zapisany z powodu %{count} błędów:",
          "many": "%{resource} nie został zapisany z powodu %{count} błędów:",
          "one": "%{resource} nie został zapisany z powodu jednego błędu:",
          "other": "%{resource} nie został zapisany z powodu %{count} błędów:"
        },
        "odd": "musi być nieparzyste",
        "other_than": "musi być inne niż %{count}",
        "present": "musi być puste",
        "required": "musi istnieć",
        "taken": "zostało już zajęte",
        "too_long": {
          "few": "jest za długie (maksymalnie %{count} znaki)",
          "many": "jest za długie (maksymalnie %{count} znaków)",
          "one": "jest za długie (maksymalnie jeden znak)",
          "other": "jest za długie (maksymalnie %{count} znaków)"
        },
        "too_short": {
          "few": "jest za krótkie (przynajmniej %{count} znaki)",
          "many": "jest za krótkie (przynajmniej %{count} znaków)",
          "one": "jest za krótkie (przynajmniej jeden znak)",
          "other": "jest za krótkie (przynajmniej %{count} znaków)"
        },
        "validate_account_update_params": "Proszę dostarczyć odpowiednie dane aktualizacji konta w ciele zapytania.",
        "validate_sign_up_params": "Proszę dostarczyć odpowiednie dane logowania w ciele zapytania.",
        "wrong_length": {
          "few": "ma nieprawidłową długość (powinna wynosić %{count} znaki)",
          "many": "ma nieprawidłową długość (powinna wynosić %{count} znaków)",
          "one": "ma nieprawidłową długość (powinna wynosić jeden znak)",
          "other": "ma nieprawidłową długość (powinna wynosić %{count} znaków)"
        }
      },
      "template": {
        "body": "Błędy dotyczą następujących pól:",
        "header": {
          "few": "%{model} nie został zachowany z powodu %{count} błędów",
          "many": "%{model} nie został zachowany z powodu %{count} błędów",
          "one": "%{model} nie został zachowany z powodu jednego błędu",
          "other": "%{model} nie został zachowany z powodu %{count} błędów"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#####",
          "####",
          "###"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Aleksandrów Kujawski",
          "Aleksandrów Łódzki",
          "Alwernia",
          "Andrychów",
          "Annopol",
          "Augustów",
          "Babimost",
          "Baborów",
          "Baranów Sandomierski",
          "Barcin",
          "Barczewo",
          "Bardo",
          "Barlinek",
          "Bartoszyce",
          "Barwice",
          "Bełchatów",
          "Bełżyce",
          "Będzin",
          "Biała",
          "Biała Piska",
          "Biała Podlaska",
          "Biała Rawska",
          "Białobrzegi",
          "Białogard",
          "Biały Bór",
          "Białystok",
          "Biecz",
          "Bielawa",
          "Bielsk Podlaski",
          "Bielsko-Biała",
          "Bieruń",
          "Bierutów",
          "Bieżuń",
          "Biłgoraj",
          "Biskupiec",
          "Bisztynek",
          "Blachownia",
          "Błaszki",
          "Błażowa",
          "Błonie",
          "Bobolice",
          "Bobowa",
          "Bochnia",
          "Bodzentyn",
          "Bogatynia",
          "Boguchwała",
          "Boguszów-Gorce",
          "Bojanowo",
          "Bolesławiec",
          "Bolków",
          "Borek Wielkopolski",
          "Borne Sulinowo",
          "Braniewo",
          "Brańsk",
          "Brodnica",
          "Brok",
          "Brusy",
          "Brwinów",
          "Brzeg",
          "Brzeg Dolny",
          "Brzesko",
          "Brzeszcze",
          "Brześć Kujawski",
          "Brzeziny",
          "Brzostek",
          "Brzozów",
          "Buk",
          "Bukowno",
          "Busko-Zdrój",
          "Bychawa",
          "Byczyna",
          "Bydgoszcz",
          "Bystrzyca Kłodzka",
          "Bytom",
          "Bytom Odrzański",
          "Bytów",
          "Cedynia",
          "Chełm",
          "Chełmek",
          "Chełmno",
          "Chełmża",
          "Chęciny",
          "Chmielnik",
          "Chocianów",
          "Chociwel",
          "Chodecz",
          "Chodzież",
          "Chojna",
          "Chojnice",
          "Chojnów",
          "Choroszcz",
          "Chorzele",
          "Chorzów",
          "Choszczno",
          "Chrzanów",
          "Ciechanowiec",
          "Ciechanów",
          "Ciechocinek",
          "Cieszanów",
          "Cieszyn",
          "Ciężkowice",
          "Cybinka",
          "Czaplinek",
          "Czarna Białostocka",
          "Czarna Woda",
          "Czarne",
          "Czarnków",
          "Czchów",
          "Czechowice-Dziedzice",
          "Czeladź",
          "Czempiń",
          "Czerniejewo",
          "Czersk",
          "Czerwieńsk",
          "Czerwionka-Leszczyny",
          "Częstochowa",
          "Człopa",
          "Człuchów",
          "Czyżew",
          "Ćmielów",
          "Daleszyce",
          "Darłowo",
          "Dąbie",
          "Dąbrowa Białostocka",
          "Dąbrowa Górnicza",
          "Dąbrowa Tarnowska",
          "Debrzno",
          "Dębica",
          "Dęblin",
          "Dębno",
          "Dobczyce",
          "Dobiegniew",
          "Dobra (powiat łobeski)",
          "Dobra (powiat turecki)",
          "Dobre Miasto",
          "Dobrodzień",
          "Dobrzany",
          "Dobrzyń nad Wisłą",
          "Dolsk",
          "Drawno",
          "Drawsko Pomorskie",
          "Drezdenko",
          "Drobin",
          "Drohiczyn",
          "Drzewica",
          "Dukla",
          "Duszniki-Zdrój",
          "Dynów",
          "Działdowo",
          "Działoszyce",
          "Działoszyn",
          "Dzierzgoń",
          "Dzierżoniów",
          "Dziwnów",
          "Elbląg",
          "Ełk",
          "Frampol",
          "Frombork",
          "Garwolin",
          "Gąbin",
          "Gdańsk",
          "Gdynia",
          "Giżycko",
          "Glinojeck",
          "Gliwice",
          "Głogów",
          "Głogów Małopolski",
          "Głogówek",
          "Głowno",
          "Głubczyce",
          "Głuchołazy",
          "Głuszyca",
          "Gniew",
          "Gniewkowo",
          "Gniezno",
          "Gogolin",
          "Golczewo",
          "Goleniów",
          "Golina",
          "Golub-Dobrzyń",
          "Gołańcz",
          "Gołdap",
          "Goniądz",
          "Gorlice",
          "Gorzów Śląski",
          "Gorzów Wielkopolski",
          "Gostynin",
          "Gostyń",
          "Gościno",
          "Gozdnica",
          "Góra",
          "Góra Kalwaria",
          "Górowo Iławeckie",
          "Górzno",
          "Grabów nad Prosną",
          "Grajewo",
          "Grodków",
          "Grodzisk Mazowiecki",
          "Grodzisk Wielkopolski",
          "Grójec",
          "Grudziądz",
          "Grybów",
          "Gryfice",
          "Gryfino",
          "Gryfów Śląski",
          "Gubin",
          "Hajnówka",
          "Halinów",
          "Hel",
          "Hrubieszów",
          "Iława",
          "Iłowa",
          "Iłża",
          "Imielin",
          "Inowrocław",
          "Ińsko",
          "Iwonicz-Zdrój",
          "Izbica Kujawska",
          "Jabłonowo Pomorskie",
          "Janikowo",
          "Janowiec Wielkopolski",
          "Janów Lubelski",
          "Jarocin",
          "Jarosław",
          "Jasień",
          "Jasło",
          "Jastarnia",
          "Jastrowie",
          "Jastrzębie-Zdrój",
          "Jawor",
          "Jaworzno",
          "Jaworzyna Śląska",
          "Jedlicze",
          "Jedlina-Zdrój",
          "Jedwabne",
          "Jelcz-Laskowice",
          "Jelenia Góra",
          "Jeziorany",
          "Jędrzejów",
          "Jordanów",
          "Józefów (powiat biłgorajski)",
          "Józefów (powiat otwocki)",
          "Jutrosin",
          "Kalety",
          "Kalisz",
          "Kalisz Pomorski",
          "Kalwaria Zebrzydowska",
          "Kałuszyn",
          "Kamienna Góra",
          "Kamień Krajeński",
          "Kamień Pomorski",
          "Kamieńsk",
          "Kańczuga",
          "Karczew",
          "Kargowa",
          "Karlino",
          "Karpacz",
          "Kartuzy",
          "Katowice",
          "Kazimierz Dolny",
          "Kazimierza Wielka",
          "Kąty Wrocławskie",
          "Kcynia",
          "Kędzierzyn-Koźle",
          "Kępice",
          "Kępno",
          "Kętrzyn",
          "Kęty",
          "Kielce",
          "Kietrz",
          "Kisielice",
          "Kleczew",
          "Kleszczele",
          "Kluczbork",
          "Kłecko",
          "Kłobuck",
          "Kłodawa",
          "Kłodzko",
          "Knurów",
          "Knyszyn",
          "Kobylin",
          "Kobyłka",
          "Kock",
          "Kolbuszowa",
          "Kolno",
          "Kolonowskie",
          "Koluszki",
          "Kołaczyce",
          "Koło",
          "Kołobrzeg",
          "Koniecpol",
          "Konin",
          "Konstancin-Jeziorna",
          "Konstantynów Łódzki",
          "Końskie",
          "Koprzywnica",
          "Korfantów",
          "Koronowo",
          "Korsze",
          "Kosów Lacki",
          "Kostrzyn",
          "Kostrzyn nad Odrą",
          "Koszalin",
          "Kościan",
          "Kościerzyna",
          "Kowal",
          "Kowalewo Pomorskie",
          "Kowary",
          "Koziegłowy",
          "Kozienice",
          "Koźmin Wielkopolski",
          "Kożuchów",
          "Kórnik",
          "Krajenka",
          "Kraków",
          "Krapkowice",
          "Krasnobród",
          "Krasnystaw",
          "Kraśnik",
          "Krobia",
          "Krosno",
          "Krosno Odrzańskie",
          "Krośniewice",
          "Krotoszyn",
          "Kruszwica",
          "Krynica Morska",
          "Krynica-Zdrój",
          "Krynki",
          "Krzanowice",
          "Krzepice",
          "Krzeszowice",
          "Krzywiń",
          "Krzyż Wielkopolski",
          "Książ Wielkopolski",
          "Kudowa-Zdrój",
          "Kunów",
          "Kutno",
          "Kuźnia Raciborska",
          "Kwidzyn",
          "Lądek-Zdrój",
          "Legionowo",
          "Legnica",
          "Lesko",
          "Leszno",
          "Leśna",
          "Leśnica",
          "Lewin Brzeski",
          "Leżajsk",
          "Lębork",
          "Lędziny",
          "Libiąż",
          "Lidzbark",
          "Lidzbark Warmiński",
          "Limanowa",
          "Lipiany",
          "Lipno",
          "Lipsk",
          "Lipsko",
          "Lubaczów",
          "Lubań",
          "Lubartów",
          "Lubawa",
          "Lubawka",
          "Lubień Kujawski",
          "Lubin",
          "Lublin",
          "Lubliniec",
          "Lubniewice",
          "Lubomierz",
          "Luboń",
          "Lubraniec",
          "Lubsko",
          "Lwówek",
          "Lwówek Śląski",
          "Łabiszyn",
          "Łańcut",
          "Łapy",
          "Łasin",
          "Łask",
          "Łaskarzew",
          "Łaszczów",
          "Łaziska Górne",
          "Łazy",
          "Łeba",
          "Łęczna",
          "Łęczyca",
          "Łęknica",
          "Łobez",
          "Łobżenica",
          "Łochów",
          "Łomianki",
          "Łomża",
          "Łosice",
          "Łowicz",
          "Łódź",
          "Łuków",
          "Maków Mazowiecki",
          "Maków Podhalański",
          "Malbork",
          "Małogoszcz",
          "Małomice",
          "Margonin",
          "Marki",
          "Maszewo",
          "Miasteczko Śląskie",
          "Miastko",
          "Michałowo",
          "Miechów",
          "Miejska Górka",
          "Mielec",
          "Mieroszów",
          "Mieszkowice",
          "Międzybórz",
          "Międzychód",
          "Międzylesie",
          "Międzyrzec Podlaski",
          "Międzyrzecz",
          "Międzyzdroje",
          "Mikołajki",
          "Mikołów",
          "Mikstat",
          "Milanówek",
          "Milicz",
          "Miłakowo",
          "Miłomłyn",
          "Miłosław",
          "Mińsk Mazowiecki",
          "Mirosławiec",
          "Mirsk",
          "Mława",
          "Młynary",
          "Mogielnica",
          "Mogilno",
          "Mońki",
          "Morąg",
          "Mordy",
          "Moryń",
          "Mosina",
          "Mrągowo",
          "Mrocza",
          "Mszana Dolna",
          "Mszczonów",
          "Murowana Goślina",
          "Muszyna",
          "Mysłowice",
          "Myszków",
          "Myszyniec",
          "Myślenice",
          "Myślibórz",
          "Nakło nad Notecią",
          "Nałęczów",
          "Namysłów",
          "Narol",
          "Nasielsk",
          "Nekla",
          "Nidzica",
          "Niemcza",
          "Niemodlin",
          "Niepołomice",
          "Nieszawa",
          "Nisko",
          "Nowa Dęba",
          "Nowa Ruda",
          "Nowa Sarzyna",
          "Nowa Sól",
          "Nowe",
          "Nowe Brzesko",
          "Nowe Miasteczko",
          "Nowe Miasto Lubawskie",
          "Nowe Miasto nad Pilicą",
          "Nowe Skalmierzyce",
          "Nowe Warpno",
          "Nowogard",
          "Nowogrodziec",
          "Nowogród",
          "Nowogród Bobrzański",
          "Nowy Dwór Gdański",
          "Nowy Dwór Mazowiecki",
          "Nowy Sącz",
          "Nowy Staw",
          "Nowy Targ",
          "Nowy Tomyśl",
          "Nowy Wiśnicz",
          "Nysa",
          "Oborniki",
          "Oborniki Śląskie",
          "Obrzycko",
          "Odolanów",
          "Ogrodzieniec",
          "Okonek",
          "Olecko",
          "Olesno",
          "Oleszyce",
          "Oleśnica",
          "Olkusz",
          "Olsztyn",
          "Olsztynek",
          "Olszyna",
          "Oława",
          "Opalenica",
          "Opatów",
          "Opoczno",
          "Opole",
          "Opole Lubelskie",
          "Orneta",
          "Orzesze",
          "Orzysz",
          "Osieczna",
          "Osiek",
          "Ostrołęka",
          "Ostroróg",
          "Ostrowiec Świętokrzyski",
          "Ostróda",
          "Ostrów Lubelski",
          "Ostrów Mazowiecka",
          "Ostrów Wielkopolski",
          "Ostrzeszów",
          "Ośno Lubuskie",
          "Oświęcim",
          "Otmuchów",
          "Otwock",
          "Ozimek",
          "Ozorków",
          "Ożarów",
          "Ożarów Mazowiecki",
          "Pabianice",
          "Paczków",
          "Pajęczno",
          "Pakość",
          "Parczew",
          "Pasłęk",
          "Pasym",
          "Pelplin",
          "Pełczyce",
          "Piaseczno",
          "Piaski",
          "Piastów",
          "Piechowice",
          "Piekary Śląskie",
          "Pieniężno",
          "Pieńsk",
          "Pieszyce",
          "Pilawa",
          "Pilica",
          "Pilzno",
          "Piła",
          "Piława Górna",
          "Pińczów",
          "Pionki",
          "Piotrków Kujawski",
          "Piotrków Trybunalski",
          "Pisz",
          "Piwniczna-Zdrój",
          "Pleszew",
          "Płock",
          "Płońsk",
          "Płoty",
          "Pniewy",
          "Pobiedziska",
          "Poddębice",
          "Podkowa Leśna",
          "Pogorzela",
          "Polanica-Zdrój",
          "Polanów",
          "Police",
          "Polkowice",
          "Połaniec",
          "Połczyn-Zdrój",
          "Poniatowa",
          "Poniec",
          "Poręba",
          "Poznań",
          "Prabuty",
          "Praszka",
          "Prochowice",
          "Proszowice",
          "Prószków",
          "Pruchnik",
          "Prudnik",
          "Prusice",
          "Pruszcz Gdański",
          "Pruszków",
          "Przasnysz",
          "Przecław",
          "Przedbórz",
          "Przedecz",
          "Przemków",
          "Przemyśl",
          "Przeworsk",
          "Przysucha",
          "Pszczyna",
          "Pszów",
          "Puck",
          "Puławy",
          "Pułtusk",
          "Puszczykowo",
          "Pyrzyce",
          "Pyskowice",
          "Pyzdry",
          "Rabka-Zdrój",
          "Raciąż",
          "Racibórz",
          "Radków",
          "Radlin",
          "Radłów",
          "Radom",
          "Radomsko",
          "Radomyśl Wielki",
          "Radymno",
          "Radziejów",
          "Radzionków",
          "Radzymin",
          "Radzyń Chełmiński",
          "Radzyń Podlaski",
          "Rajgród",
          "Rakoniewice",
          "Raszków",
          "Rawa Mazowiecka",
          "Rawicz",
          "Recz",
          "Reda",
          "Rejowiec Fabryczny",
          "Resko",
          "Reszel",
          "Rogoźno",
          "Ropczyce",
          "Różan",
          "Ruciane-Nida",
          "Ruda Śląska",
          "Rudnik nad Sanem",
          "Rumia",
          "Rybnik",
          "Rychwał",
          "Rydułtowy",
          "Rydzyna",
          "Ryglice",
          "Ryki",
          "Rymanów",
          "Ryn",
          "Rypin",
          "Rzepin",
          "Rzeszów",
          "Rzgów",
          "Sandomierz",
          "Sanok",
          "Sejny",
          "Serock",
          "Sędziszów",
          "Sędziszów Małopolski",
          "Sępopol",
          "Sępólno Krajeńskie",
          "Sianów",
          "Siechnice",
          "Siedlce",
          "Siemianowice Śląskie",
          "Siemiatycze",
          "Sieniawa",
          "Sieradz",
          "Sieraków",
          "Sierpc",
          "Siewierz",
          "Skalbmierz",
          "Skała",
          "Skarszewy",
          "Skaryszew",
          "Skarżysko-Kamienna",
          "Skawina",
          "Skępe",
          "Skierniewice",
          "Skoczów",
          "Skoki",
          "Skórcz",
          "Skwierzyna",
          "Sława",
          "Sławków",
          "Sławno",
          "Słomniki",
          "Słubice",
          "Słupca",
          "Słupsk",
          "Sobótka",
          "Sochaczew",
          "Sokołów Małopolski",
          "Sokołów Podlaski",
          "Sokółka",
          "Solec Kujawski",
          "Sompolno",
          "Sopot",
          "Sosnowiec",
          "Sośnicowice",
          "Stalowa Wola",
          "Starachowice",
          "Stargard Szczeciński",
          "Starogard Gdański",
          "Stary Sącz",
          "Staszów",
          "Stawiski",
          "Stawiszyn",
          "Stąporków",
          "Stęszew",
          "Stoczek Łukowski",
          "Stronie Śląskie",
          "Strumień",
          "Stryków",
          "Strzegom",
          "Strzelce Krajeńskie",
          "Strzelce Opolskie",
          "Strzelin",
          "Strzelno",
          "Strzyżów",
          "Sucha Beskidzka",
          "Suchań",
          "Suchedniów",
          "Suchowola",
          "Sulechów",
          "Sulejów",
          "Sulejówek",
          "Sulęcin",
          "Sulmierzyce",
          "Sułkowice",
          "Supraśl",
          "Suraż",
          "Susz",
          "Suwałki",
          "Swarzędz",
          "Syców",
          "Szadek",
          "Szamocin",
          "Szamotuły",
          "Szczawnica",
          "Szczawno-Zdrój",
          "Szczebrzeszyn",
          "Szczecin",
          "Szczecinek",
          "Szczekociny",
          "Szczucin",
          "Szczuczyn",
          "Szczyrk",
          "Szczytna",
          "Szczytno",
          "Szepietowo",
          "Szklarska Poręba",
          "Szlichtyngowa",
          "Szprotawa",
          "Sztum",
          "Szubin",
          "Szydłowiec",
          "Ścinawa",
          "Ślesin",
          "Śmigiel",
          "Śrem",
          "Środa Śląska",
          "Środa Wielkopolska",
          "Świątniki Górne",
          "Świdnica",
          "Świdnik",
          "Świdwin",
          "Świebodzice",
          "Świebodzin",
          "Świecie",
          "Świeradów-Zdrój",
          "Świerzawa",
          "Świętochłowice",
          "Świnoujście",
          "Tarczyn",
          "Tarnobrzeg",
          "Tarnogród",
          "Tarnowskie Góry",
          "Tarnów",
          "Tczew",
          "Terespol",
          "Tłuszcz",
          "Tolkmicko",
          "Tomaszów Lubelski",
          "Tomaszów Mazowiecki",
          "Toruń",
          "Torzym",
          "Toszek",
          "Trzcianka",
          "Trzciel",
          "Trzcińsko-Zdrój",
          "Trzebiatów",
          "Trzebinia",
          "Trzebnica",
          "Trzemeszno",
          "Tuchola",
          "Tuchów",
          "Tuczno",
          "Tuliszków",
          "Turek",
          "Tuszyn",
          "Twardogóra",
          "Tychowo",
          "Tychy",
          "Tyczyn",
          "Tykocin",
          "Tyszowce",
          "Ujazd",
          "Ujście",
          "Ulanów",
          "Uniejów",
          "Ustka",
          "Ustroń",
          "Ustrzyki Dolne",
          "Wadowice",
          "Wałbrzych",
          "Wałcz",
          "Warka",
          "Warszawa",
          "Warta",
          "Wasilków",
          "Wąbrzeźno",
          "Wąchock",
          "Wągrowiec",
          "Wąsosz",
          "Wejherowo",
          "Węgliniec",
          "Węgorzewo",
          "Węgorzyno",
          "Węgrów",
          "Wiązów",
          "Wieleń",
          "Wielichowo",
          "Wieliczka",
          "Wieluń",
          "Wieruszów",
          "Więcbork",
          "Wilamowice",
          "Wisła",
          "Witkowo",
          "Witnica",
          "Wleń",
          "Władysławowo",
          "Włocławek",
          "Włodawa",
          "Włoszczowa",
          "Wodzisław Śląski",
          "Wojcieszów",
          "Wojkowice",
          "Wojnicz",
          "Wolbórz",
          "Wolbrom",
          "Wolin",
          "Wolsztyn",
          "Wołczyn",
          "Wołomin",
          "Wołów",
          "Woźniki",
          "Wrocław",
          "Wronki",
          "Września",
          "Wschowa",
          "Wyrzysk",
          "Wysoka",
          "Wysokie Mazowieckie",
          "Wyszków",
          "Wyszogród",
          "Wyśmierzyce",
          "Zabłudów",
          "Zabrze",
          "Zagórów",
          "Zagórz",
          "Zakliczyn",
          "Zakopane",
          "Zakroczym",
          "Zalewo",
          "Zambrów",
          "Zamość",
          "Zator",
          "Zawadzkie",
          "Zawichost",
          "Zawidów",
          "Zawiercie",
          "Ząbki",
          "Ząbkowice Śląskie",
          "Zbąszynek",
          "Zbąszyń",
          "Zduny",
          "Zduńska Wola",
          "Zdzieszowice",
          "Zelów",
          "Zgierz",
          "Zgorzelec",
          "Zielona Góra",
          "Zielonka",
          "Ziębice",
          "Złocieniec",
          "Złoczew",
          "Złotoryja",
          "Złotów",
          "Złoty Stok",
          "Zwierzyniec",
          "Zwoleń",
          "Żabno",
          "Żagań",
          "Żarki",
          "Żarów",
          "Żary",
          "Żelechów",
          "Żerków",
          "Żmigród",
          "Żnin",
          "Żory",
          "Żukowo",
          "Żuromin",
          "Żychlin",
          "Żyrardów",
          "Żywiec"
        ],
        "country": [
          "Afganistan",
          "Albania",
          "Algieria",
          "Andora",
          "Angola",
          "Antigua i Barbuda",
          "Arabia Saudyjska",
          "Argentyna",
          "Armenia",
          "Australia",
          "Austria",
          "Azerbejdżan",
          "Bahamy",
          "Bahrajn",
          "Bangladesz",
          "Barbados",
          "Belgia",
          "Belize",
          "Benin",
          "Bhutan",
          "Białoruś",
          "Birma",
          "Boliwia",
          "Sucre",
          "Bośnia i Hercegowina",
          "Botswana",
          "Brazylia",
          "Brunei",
          "Bułgaria",
          "Burkina Faso",
          "Burundi",
          "Chile",
          "Chiny",
          "Chorwacja",
          "Cypr",
          "Czad",
          "Czarnogóra",
          "Czechy",
          "Dania",
          "Demokratyczna Republika Konga",
          "Dominika",
          "Dominikana",
          "Dżibuti",
          "Egipt",
          "Ekwador",
          "Erytrea",
          "Estonia",
          "Etiopia",
          "Fidżi",
          "Filipiny",
          "Finlandia",
          "Francja",
          "Gabon",
          "Gambia",
          "Ghana",
          "Grecja",
          "Grenada",
          "Gruzja",
          "Gujana",
          "Gwatemala",
          "Gwinea",
          "Gwinea Bissau",
          "Gwinea Równikowa",
          "Haiti",
          "Hiszpania",
          "Holandia",
          "Haga",
          "Honduras",
          "Indie",
          "Indonezja",
          "Irak",
          "Iran",
          "Irlandia",
          "Islandia",
          "Izrael",
          "Jamajka",
          "Japonia",
          "Jemen",
          "Jordania",
          "Kambodża",
          "Kamerun",
          "Kanada",
          "Katar",
          "Kazachstan",
          "Kenia",
          "Kirgistan",
          "Kiribati",
          "Kolumbia",
          "Komory",
          "Kongo",
          "Korea Południowa",
          "Korea Północna",
          "Kostaryka",
          "Kuba",
          "Kuwejt",
          "Laos",
          "Lesotho",
          "Liban",
          "Liberia",
          "Libia",
          "Liechtenstein",
          "Litwa",
          "Luksemburg",
          "Łotwa",
          "Macedonia",
          "Madagaskar",
          "Malawi",
          "Malediwy",
          "Malezja",
          "Mali",
          "Malta",
          "Maroko",
          "Mauretania",
          "Mauritius",
          "Meksyk",
          "Mikronezja",
          "Mołdawia",
          "Monako",
          "Mongolia",
          "Mozambik",
          "Namibia",
          "Nauru",
          "Nepal",
          "Niemcy",
          "Niger",
          "Nigeria",
          "Nikaragua",
          "Norwegia",
          "Nowa Zelandia",
          "Oman",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua-Nowa Gwinea",
          "Paragwaj",
          "Peru",
          "Polska",
          "Portugalia",
          "Republika Południowej Afryki",
          "Republika Środkowoafrykańska",
          "Republika Zielonego Przylądka",
          "Rosja",
          "Rumunia",
          "Rwanda",
          "Saint Kitts i Nevis",
          "Saint Lucia",
          "Saint Vincent i Grenadyny",
          "Salwador",
          "Samoa",
          "San Marino",
          "Senegal",
          "Serbia",
          "Seszele",
          "Sierra Leone",
          "Singapur",
          "Słowacja",
          "Słowenia",
          "Somalia",
          "Sri Lanka",
          "Stany Zjednoczone",
          "Suazi",
          "Sudan",
          "Sudan Południowy",
          "Surinam",
          "Syria",
          "Szwajcaria",
          "Szwecja",
          "Tadżykistan",
          "Tajlandia",
          "Tanzania",
          "Timor Wschodni",
          "Togo",
          "Tonga",
          "Trynidad i Tobago",
          "Tunezja",
          "Turcja",
          "Turkmenistan",
          "Tuvalu",
          "Funafuti",
          "Uganda",
          "Ukraina",
          "Urugwaj",
          "Uzbekistan",
          "Vanuatu",
          "Watykan",
          "Wenezuela",
          "Węgry",
          "Wielka Brytania",
          "Wietnam",
          "Włochy",
          "Wybrzeże Kości Słoniowej",
          "Wyspy Marshalla",
          "Wyspy Salomona",
          "Wyspy Świętego Tomasza i Książęca",
          "Zambia",
          "Zimbabwe",
          "Zjednoczone Emiraty Arabskie"
        ],
        "default_country": [
          "Polska"
        ],
        "default_country_code": [
          "PL"
        ],
        "postcode": [
          "##-###"
        ],
        "secondary_address": [
          "Apt. ###",
          "Suite ###"
        ],
        "state": [
          "Dolnośląskie",
          "Kujawsko-pomorskie",
          "Lubelskie",
          "Lubuskie",
          "Łódzkie",
          "Małopolskie",
          "Mazowieckie",
          "Opolskie",
          "Podkarpackie",
          "Podlaskie",
          "Pomorskie",
          "Śląskie",
          "Świętokrzyskie",
          "Warmińsko-mazurskie",
          "Wielkopolskie",
          "Zachodniopomorskie"
        ],
        "state_abbr": [
          "DŚ",
          "KP",
          "LB",
          "LS",
          "ŁD",
          "MP",
          "MZ",
          "OP",
          "PK",
          "PL",
          "PM",
          "ŚL",
          "ŚK",
          "WM",
          "WP",
          "ZP"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_prefix} #{Name.last_name}"
        ],
        "street_prefix": [
          "ul.",
          "al."
        ]
      },
      "cell_phone": {
        "formats": [
          "50-###-##-##",
          "51-###-##-##",
          "53-###-##-##",
          "57-###-##-##",
          "60-###-##-##",
          "66-###-##-##",
          "69-###-##-##",
          "72-###-##-##",
          "73-###-##-##",
          "78-###-##-##",
          "79-###-##-##",
          "88-###-##-##"
        ]
      },
      "coin": {
        "flip": [
          "Orzeł",
          "Reszka"
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
        ],
        "suffix": [
          "S.A.",
          "sp. z o.o.",
          "sp. j.",
          "sp.p.",
          "sp. k.",
          "S.K.A."
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "pl",
          "com.pl",
          "net",
          "org"
        ]
      },
      "lorem": {
        "supplemental": [
          "abbas",
          "abduco",
          "abeo",
          "abscido",
          "absconditus",
          "absens",
          "absorbeo",
          "absque",
          "abstergo",
          "absum",
          "abundans",
          "abutor",
          "accedo",
          "accendo",
          "acceptus",
          "accipio",
          "accommodo",
          "accusator",
          "acer",
          "acerbitas",
          "acervus",
          "acidus",
          "acies",
          "acquiro",
          "acsi",
          "adamo",
          "adaugeo",
          "addo",
          "adduco",
          "ademptio",
          "adeo",
          "adeptio",
          "adfectus",
          "adfero",
          "adficio",
          "adflicto",
          "adhaero",
          "adhuc",
          "adicio",
          "adimpleo",
          "adinventitias",
          "adipiscor",
          "adiuvo",
          "administratio",
          "admiratio",
          "admitto",
          "admoneo",
          "admoveo",
          "adnuo",
          "adopto",
          "adsidue",
          "adstringo",
          "adsuesco",
          "adsum",
          "adulatio",
          "adulescens",
          "adultus",
          "aduro",
          "advenio",
          "adversus",
          "advoco",
          "aedificium",
          "aeger",
          "aegre",
          "aegrotatio",
          "aegrus",
          "aeneus",
          "aequitas",
          "aequus",
          "aer",
          "aestas",
          "aestivus",
          "aestus",
          "aetas",
          "aeternus",
          "ager",
          "aggero",
          "aggredior",
          "agnitio",
          "agnosco",
          "ago",
          "ait",
          "aiunt",
          "alienus",
          "alii",
          "alioqui",
          "aliqua",
          "alius",
          "allatus",
          "alo",
          "alter",
          "altus",
          "alveus",
          "amaritudo",
          "ambitus",
          "ambulo",
          "amicitia",
          "amiculum",
          "amissio",
          "amita",
          "amitto",
          "amo",
          "amor",
          "amoveo",
          "amplexus",
          "amplitudo",
          "amplus",
          "ancilla",
          "angelus",
          "angulus",
          "angustus",
          "animadverto",
          "animi",
          "animus",
          "annus",
          "anser",
          "ante",
          "antea",
          "antepono",
          "antiquus",
          "aperio",
          "aperte",
          "apostolus",
          "apparatus",
          "appello",
          "appono",
          "appositus",
          "approbo",
          "apto",
          "aptus",
          "apud",
          "aqua",
          "ara",
          "aranea",
          "arbitro",
          "arbor",
          "arbustum",
          "arca",
          "arceo",
          "arcesso",
          "arcus",
          "argentum",
          "argumentum",
          "arguo",
          "arma",
          "armarium",
          "armo",
          "aro",
          "ars",
          "articulus",
          "artificiose",
          "arto",
          "arx",
          "ascisco",
          "ascit",
          "asper",
          "aspicio",
          "asporto",
          "assentator",
          "astrum",
          "atavus",
          "ater",
          "atqui",
          "atrocitas",
          "atrox",
          "attero",
          "attollo",
          "attonbitus",
          "auctor",
          "auctus",
          "audacia",
          "audax",
          "audentia",
          "audeo",
          "audio",
          "auditor",
          "aufero",
          "aureus",
          "auris",
          "aurum",
          "aut",
          "autem",
          "autus",
          "auxilium",
          "avaritia",
          "avarus",
          "aveho",
          "averto",
          "avoco",
          "baiulus",
          "balbus",
          "barba",
          "bardus",
          "basium",
          "beatus",
          "bellicus",
          "bellum",
          "bene",
          "beneficium",
          "benevolentia",
          "benigne",
          "bestia",
          "bibo",
          "bis",
          "blandior",
          "bonus",
          "bos",
          "brevis",
          "cado",
          "caecus",
          "caelestis",
          "caelum",
          "calamitas",
          "calcar",
          "calco",
          "calculus",
          "callide",
          "campana",
          "candidus",
          "canis",
          "canonicus",
          "canto",
          "capillus",
          "capio",
          "capitulus",
          "capto",
          "caput",
          "carbo",
          "carcer",
          "careo",
          "caries",
          "cariosus",
          "caritas",
          "carmen",
          "carpo",
          "carus",
          "casso",
          "caste",
          "casus",
          "catena",
          "caterva",
          "cattus",
          "cauda",
          "causa",
          "caute",
          "caveo",
          "cavus",
          "cedo",
          "celebrer",
          "celer",
          "celo",
          "cena",
          "cenaculum",
          "ceno",
          "censura",
          "centum",
          "cerno",
          "cernuus",
          "certe",
          "certo",
          "certus",
          "cervus",
          "cetera",
          "charisma",
          "chirographum",
          "cibo",
          "cibus",
          "cicuta",
          "cilicium",
          "cimentarius",
          "ciminatio",
          "cinis",
          "circumvenio",
          "cito",
          "civis",
          "civitas",
          "clam",
          "clamo",
          "claro",
          "clarus",
          "claudeo",
          "claustrum",
          "clementia",
          "clibanus",
          "coadunatio",
          "coaegresco",
          "coepi",
          "coerceo",
          "cogito",
          "cognatus",
          "cognomen",
          "cogo",
          "cohaero",
          "cohibeo",
          "cohors",
          "colligo",
          "colloco",
          "collum",
          "colo",
          "color",
          "coma",
          "combibo",
          "comburo",
          "comedo",
          "comes",
          "cometes",
          "comis",
          "comitatus",
          "commemoro",
          "comminor",
          "commodo",
          "communis",
          "comparo",
          "compello",
          "complectus",
          "compono",
          "comprehendo",
          "comptus",
          "conatus",
          "concedo",
          "concido",
          "conculco",
          "condico",
          "conduco",
          "confero",
          "confido",
          "conforto",
          "confugo",
          "congregatio",
          "conicio",
          "coniecto",
          "conitor",
          "coniuratio",
          "conor",
          "conqueror",
          "conscendo",
          "conservo",
          "considero",
          "conspergo",
          "constans",
          "consuasor",
          "contabesco",
          "contego",
          "contigo",
          "contra",
          "conturbo",
          "conventus",
          "convoco",
          "copia",
          "copiose",
          "cornu",
          "corona",
          "corpus",
          "correptius",
          "corrigo",
          "corroboro",
          "corrumpo",
          "coruscus",
          "cotidie",
          "crapula",
          "cras",
          "crastinus",
          "creator",
          "creber",
          "crebro",
          "credo",
          "creo",
          "creptio",
          "crepusculum",
          "cresco",
          "creta",
          "cribro",
          "crinis",
          "cruciamentum",
          "crudelis",
          "cruentus",
          "crur",
          "crustulum",
          "crux",
          "cubicularis",
          "cubitum",
          "cubo",
          "cui",
          "cuius",
          "culpa",
          "culpo",
          "cultellus",
          "cultura",
          "cum",
          "cunabula",
          "cunae",
          "cunctatio",
          "cupiditas",
          "cupio",
          "cuppedia",
          "cupressus",
          "cur",
          "cura",
          "curatio",
          "curia",
          "curiositas",
          "curis",
          "curo",
          "curriculum",
          "currus",
          "cursim",
          "curso",
          "cursus",
          "curto",
          "curtus",
          "curvo",
          "curvus",
          "custodia",
          "damnatio",
          "damno",
          "dapifer",
          "debeo",
          "debilito",
          "decens",
          "decerno",
          "decet",
          "decimus",
          "decipio",
          "decor",
          "decretum",
          "decumbo",
          "dedecor",
          "dedico",
          "deduco",
          "defaeco",
          "defendo",
          "defero",
          "defessus",
          "defetiscor",
          "deficio",
          "defigo",
          "defleo",
          "defluo",
          "defungo",
          "degenero",
          "degero",
          "degusto",
          "deinde",
          "delectatio",
          "delego",
          "deleo",
          "delibero",
          "delicate",
          "delinquo",
          "deludo",
          "demens",
          "demergo",
          "demitto",
          "demo",
          "demonstro",
          "demoror",
          "demulceo",
          "demum",
          "denego",
          "denique",
          "dens",
          "denuncio",
          "denuo",
          "deorsum",
          "depereo",
          "depono",
          "depopulo",
          "deporto",
          "depraedor",
          "deprecator",
          "deprimo",
          "depromo",
          "depulso",
          "deputo",
          "derelinquo",
          "derideo",
          "deripio",
          "desidero",
          "desino",
          "desipio",
          "desolo",
          "desparatus",
          "despecto",
          "despirmatio",
          "infit",
          "inflammatio",
          "paens",
          "patior",
          "patria",
          "patrocinor",
          "patruus",
          "pauci",
          "paulatim",
          "pauper",
          "pax",
          "peccatus",
          "pecco",
          "pecto",
          "pectus",
          "pecunia",
          "pecus",
          "peior",
          "pel",
          "ocer",
          "socius",
          "sodalitas",
          "sol",
          "soleo",
          "solio",
          "solitudo",
          "solium",
          "sollers",
          "sollicito",
          "solum",
          "solus",
          "solutio",
          "solvo",
          "somniculosus",
          "somnus",
          "sonitus",
          "sono",
          "sophismata",
          "sopor",
          "sordeo",
          "sortitus",
          "spargo",
          "speciosus",
          "spectaculum",
          "speculum",
          "sperno",
          "spero",
          "spes",
          "spiculum",
          "spiritus",
          "spoliatio",
          "sponte",
          "stabilis",
          "statim",
          "statua",
          "stella",
          "stillicidium",
          "stipes",
          "stips",
          "sto",
          "strenuus",
          "strues",
          "studio",
          "stultus",
          "suadeo",
          "suasoria",
          "sub",
          "subito",
          "subiungo",
          "sublime",
          "subnecto",
          "subseco",
          "substantia",
          "subvenio",
          "succedo",
          "succurro",
          "sufficio",
          "suffoco",
          "suffragium",
          "suggero",
          "sui",
          "sulum",
          "sum",
          "summa",
          "summisse",
          "summopere",
          "sumo",
          "sumptus",
          "supellex",
          "super",
          "suppellex",
          "supplanto",
          "suppono",
          "supra",
          "surculus",
          "surgo",
          "sursum",
          "suscipio",
          "suspendo",
          "sustineo",
          "suus",
          "synagoga",
          "tabella",
          "tabernus",
          "tabesco",
          "tabgo",
          "tabula",
          "taceo",
          "tactus",
          "taedium",
          "talio",
          "talis",
          "talus",
          "tam",
          "tamdiu",
          "tamen",
          "tametsi",
          "tamisium",
          "tamquam",
          "tandem",
          "tantillus",
          "tantum",
          "tardus",
          "tego",
          "temeritas",
          "temperantia",
          "templum",
          "temptatio",
          "tempus",
          "tenax",
          "tendo",
          "teneo",
          "tener",
          "tenuis",
          "tenus",
          "tepesco",
          "tepidus",
          "ter",
          "terebro",
          "teres",
          "terga",
          "tergeo",
          "tergiversatio",
          "tergo",
          "tergum",
          "termes",
          "terminatio",
          "tero",
          "terra",
          "terreo",
          "territo",
          "terror",
          "tersus",
          "tertius",
          "testimonium",
          "texo",
          "textilis",
          "textor",
          "textus",
          "thalassinus",
          "theatrum",
          "theca",
          "thema",
          "theologus",
          "thermae",
          "thesaurus",
          "thesis",
          "thorax",
          "thymbra",
          "thymum",
          "tibi",
          "timidus",
          "timor",
          "titulus",
          "tolero",
          "tollo",
          "tondeo",
          "tonsor",
          "torqueo",
          "torrens",
          "tot",
          "totidem",
          "toties",
          "totus",
          "tracto",
          "trado",
          "traho",
          "trans",
          "tredecim",
          "tremo",
          "trepide",
          "tres",
          "tribuo",
          "tricesimus",
          "triduana",
          "triginta",
          "tripudio",
          "tristis",
          "triumphus",
          "trucido",
          "truculenter",
          "tubineus",
          "tui",
          "tum",
          "tumultus",
          "tunc",
          "turba",
          "turbo",
          "turpe",
          "turpis",
          "tutamen",
          "tutis",
          "tyrannus",
          "uberrime",
          "ubi",
          "ulciscor",
          "ullus",
          "ulterius",
          "ultio",
          "ultra",
          "umbra",
          "umerus",
          "umquam",
          "una",
          "unde",
          "undique",
          "universe",
          "unus",
          "urbanus",
          "urbs",
          "uredo",
          "usitas",
          "usque",
          "ustilo",
          "ustulo",
          "usus",
          "uter",
          "uterque",
          "utilis",
          "utique",
          "utor",
          "utpote",
          "utrimque",
          "utroque",
          "utrum",
          "uxor",
          "vaco",
          "vacuus",
          "vado",
          "vae",
          "valde",
          "valens",
          "valeo",
          "valetudo",
          "validus",
          "vallum",
          "vapulus",
          "varietas",
          "varius",
          "vehemens",
          "vel",
          "velociter",
          "velum",
          "velut",
          "venia",
          "venio",
          "ventito",
          "ventosus",
          "ventus",
          "venustas",
          "ver",
          "verbera",
          "verbum",
          "vere",
          "verecundia",
          "vereor",
          "vergo",
          "veritas",
          "vero",
          "versus",
          "verto",
          "verumtamen",
          "verus",
          "vesco",
          "vesica",
          "vesper",
          "vespillo",
          "vester",
          "vestigium",
          "vestrum",
          "vetus",
          "via",
          "vicinus",
          "vicissitudo",
          "victoria",
          "victus",
          "videlicet",
          "video",
          "viduata",
          "viduo",
          "vigilo",
          "vigor",
          "vilicus",
          "vilis",
          "vilitas",
          "villa",
          "vinco",
          "vinculum",
          "vindico",
          "vinitor",
          "vinum",
          "vir",
          "virga",
          "virgo",
          "viridis",
          "viriliter",
          "virtus",
          "vis",
          "viscus",
          "vita",
          "vitiosus",
          "vitium",
          "vito",
          "vivo",
          "vix",
          "vobis",
          "vociferor",
          "voco",
          "volaticus",
          "volo",
          "volubilis",
          "voluntarius",
          "volup",
          "volutabrum",
          "volva",
          "vomer",
          "vomica",
          "vomito",
          "vorago",
          "vorax",
          "voro",
          "vos",
          "votum",
          "voveo",
          "vox",
          "vulariter",
          "vulgaris",
          "vulgivagus",
          "vulgo",
          "vulgus",
          "vulnero",
          "vulnus",
          "vulpes",
          "vulticulus",
          "vultuosus",
          "xiphias"
        ],
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "name": {
        "first_name": [
          "Aaron",
          "Abraham",
          "Adam",
          "Adrian",
          "Atanazy",
          "Agaton",
          "Alan",
          "Albert",
          "Aleksander",
          "Aleksy",
          "Alfred",
          "Alwar",
          "Ambroży",
          "Anatol",
          "Andrzej",
          "Antoni",
          "Apollinary",
          "Apollo",
          "Arkady",
          "Arkadiusz",
          "Archibald",
          "Arystarch",
          "Arnold",
          "Arseniusz",
          "Artur",
          "August",
          "Baldwin",
          "Bazyli",
          "Benedykt",
          "Beniamin",
          "Bernard",
          "Bertrand",
          "Bertram",
          "Borys",
          "Brajan",
          "Bruno",
          "Cezary",
          "Cecyliusz",
          "Karol",
          "Krystian",
          "Krzysztof",
          "Klarencjusz",
          "Klaudiusz",
          "Klemens",
          "Konrad",
          "Konstanty",
          "Konstantyn",
          "Kornel",
          "Korneliusz",
          "Korneli",
          "Cyryl",
          "Cyrus",
          "Damian",
          "Daniel",
          "Dariusz",
          "Dawid",
          "Dionizy",
          "Demetriusz",
          "Dominik",
          "Donald",
          "Dorian",
          "Edgar",
          "Edmund",
          "Edward",
          "Edwin",
          "Efrem",
          "Efraim",
          "Eliasz",
          "Eleazar",
          "Emil",
          "Emanuel",
          "Erast",
          "Ernest",
          "Eugeniusz",
          "Eustracjusz",
          "Fabian",
          "Feliks",
          "Florian",
          "Franciszek",
          "Fryderyk",
          "Gabriel",
          "Gedeon",
          "Galfryd",
          "Jerzy",
          "Gerald",
          "Gerazym",
          "Gilbert",
          "Gonsalwy",
          "Grzegorz",
          "Gwido",
          "Harald",
          "Henryk",
          "Herbert",
          "Herman",
          "Hilary",
          "Horacy",
          "Hubert",
          "Hugo",
          "Ignacy",
          "Igor",
          "Hilarion",
          "Innocenty",
          "Hipolit",
          "Ireneusz",
          "Erwin",
          "Izaak",
          "Izajasz",
          "Izydor",
          "Jakub",
          "Jeremi",
          "Jeremiasz",
          "Hieronim",
          "Gerald",
          "Joachim",
          "Jan",
          "Janusz",
          "Jonatan",
          "Józef",
          "Jozue",
          "Julian",
          "Juliusz",
          "Justyn",
          "Kalistrat",
          "Kazimierz",
          "Wawrzyniec",
          "Laurenty",
          "Laurencjusz",
          "Łazarz",
          "Leon",
          "Leonard",
          "Leonid",
          "Leon",
          "Ludwik",
          "Łukasz",
          "Lucjan",
          "Magnus",
          "Makary",
          "Marceli",
          "Marek",
          "Marcin",
          "Mateusz",
          "Maurycy",
          "Maksym",
          "Maksymilian",
          "Michał",
          "Miron",
          "Modest",
          "Mojżesz",
          "Natan",
          "Natanael",
          "Nazariusz",
          "Nazary",
          "Nestor",
          "Mikołaj",
          "Nikodem",
          "Olaf",
          "Oleg",
          "Oliwier",
          "Onufry",
          "Orestes",
          "Oskar",
          "Ansgary",
          "Osmund",
          "Pankracy",
          "Pantaleon",
          "Patryk",
          "Patrycjusz",
          "Patrycy",
          "Paweł",
          "Piotr",
          "Filemon",
          "Filip",
          "Platon",
          "Polikarp",
          "Porfiry",
          "Porfiriusz",
          "Prokles",
          "Prokul",
          "Prokop",
          "Kwintyn",
          "Randolf",
          "Rafał",
          "Rajmund",
          "Reginald",
          "Rajnold",
          "Ryszard",
          "Robert",
          "Roderyk",
          "Roger",
          "Roland",
          "Roman",
          "Romeo",
          "Reginald",
          "Rudolf",
          "Samson",
          "Samuel",
          "Salwator",
          "Sebastian",
          "Serafin",
          "Sergiusz",
          "Seweryn",
          "Zygmunt",
          "Sylwester",
          "Szymon",
          "Salomon",
          "Spirydion",
          "Stanisław",
          "Szczepan",
          "Stefan",
          "Terencjusz",
          "Teodor",
          "Tomasz",
          "Tymoteusz",
          "Tobiasz",
          "Walenty",
          "Walentyn",
          "Walerian",
          "Walery",
          "Wiktor",
          "Wincenty",
          "Witalis",
          "Włodzimierz",
          "Władysław",
          "Błażej",
          "Walter",
          "Walgierz",
          "Wacław",
          "Wilfryd",
          "Wilhelm",
          "Ksawery",
          "Ksenofont",
          "Jerzy",
          "Zachariasz",
          "Zachary",
          "Ada",
          "Adelajda",
          "Agata",
          "Agnieszka",
          "Agrypina",
          "Aida",
          "Aleksandra",
          "Alicja",
          "Alina",
          "Amanda",
          "Anastazja",
          "Angela",
          "Andżelika",
          "Angelina",
          "Anna",
          "Hanna",
          "Antonina",
          "Ariadna",
          "Aurora",
          "Barbara",
          "Beatrycze",
          "Berta",
          "Brygida",
          "Kamila",
          "Karolina",
          "Karolina",
          "Kornelia",
          "Katarzyna",
          "Cecylia",
          "Karolina",
          "Chloe",
          "Krystyna",
          "Klara",
          "Klaudia",
          "Klementyna",
          "Konstancja",
          "Koralia",
          "Daria",
          "Diana",
          "Dina",
          "Dorota",
          "Edyta",
          "Eleonora",
          "Eliza",
          "Elżbieta",
          "Izabela",
          "Elwira",
          "Emilia",
          "Estera",
          "Eudoksja",
          "Eudokia",
          "Eugenia",
          "Ewa",
          "Ewelina",
          "Ferdynanda",
          "Florencja",
          "Franciszka",
          "Gabriela",
          "Gertruda",
          "Gloria",
          "Gracja",
          "Jadwiga",
          "Helena",
          "Henryka",
          "Nadzieja",
          "Ida",
          "Ilona",
          "Helena",
          "Irena",
          "Irma",
          "Izabela",
          "Izolda",
          "Jakubina",
          "Joanna",
          "Janina",
          "Żaneta",
          "Joanna",
          "Ginewra",
          "Józefina",
          "Judyta",
          "Julia",
          "Julia",
          "Julita",
          "Justyna",
          "Kira",
          "Cyra",
          "Kleopatra",
          "Larysa",
          "Laura",
          "Laurencja",
          "Laurentyna",
          "Lea",
          "Leila",
          "Eleonora",
          "Liliana",
          "Lilianna",
          "Lilia",
          "Lilla",
          "Liza",
          "Eliza",
          "Laura",
          "Ludwika",
          "Luiza",
          "Łucja",
          "Lucja",
          "Lidia",
          "Amabela",
          "Magdalena",
          "Malwina",
          "Małgorzata",
          "Greta",
          "Marianna",
          "Maryna",
          "Marta",
          "Martyna",
          "Maria",
          "Matylda",
          "Maja",
          "Maja",
          "Melania",
          "Michalina",
          "Monika",
          "Nadzieja",
          "Noemi",
          "Natalia",
          "Nikola",
          "Nina",
          "Olga",
          "Olimpia",
          "Oliwia",
          "Ofelia",
          "Patrycja",
          "Paula",
          "Pelagia",
          "Penelopa",
          "Filipa",
          "Paulina",
          "Rachela",
          "Rebeka",
          "Regina",
          "Renata",
          "Rozalia",
          "Róża",
          "Roksana",
          "Rufina",
          "Ruta",
          "Sabina",
          "Sara",
          "Serafina",
          "Sybilla",
          "Sylwia",
          "Zofia",
          "Stella",
          "Stefania",
          "Zuzanna",
          "Tamara",
          "Tacjana",
          "Tekla",
          "Teodora",
          "Teresa",
          "Walentyna",
          "Waleria",
          "Wanesa",
          "Wiara",
          "Weronika",
          "Wiktoria",
          "Wirginia",
          "Bibiana",
          "Bibianna",
          "Wanda",
          "Wilhelmina",
          "Ksawera",
          "Ksenia",
          "Zoe"
        ],
        "last_name": [
          "Adamczak",
          "Adamczyk",
          "Adamek",
          "Adamiak",
          "Adamiec",
          "Adamowicz",
          "Adamski",
          "Adamus",
          "Aleksandrowicz",
          "Andrzejczak",
          "Andrzejewski",
          "Antczak",
          "Augustyn",
          "Augustyniak",
          "Bagiński",
          "Balcerzak",
          "Banach",
          "Banasiak",
          "Banasik",
          "Banaś",
          "Baran",
          "Baranowski",
          "Barański",
          "Bartczak",
          "Bartkowiak",
          "Bartnik",
          "Bartosik",
          "Bednarczyk",
          "Bednarek",
          "Bednarski",
          "Bednarz",
          "Białas",
          "Białek",
          "Białkowski",
          "Bielak",
          "Bielawski",
          "Bielecki",
          "Bielski",
          "Bieniek",
          "Biernacki",
          "Biernat",
          "Bieńkowski",
          "Bilski",
          "Bober",
          "Bochenek",
          "Bogucki",
          "Bogusz",
          "Borek",
          "Borkowski",
          "Borowiec",
          "Borowski",
          "Bożek",
          "Broda",
          "Brzeziński",
          "Brzozowski",
          "Buczek",
          "Buczkowski",
          "Buczyński",
          "Budziński",
          "Budzyński",
          "Bujak",
          "Bukowski",
          "Burzyński",
          "Bąk",
          "Bąkowski",
          "Błaszczak",
          "Błaszczyk",
          "Cebula",
          "Chmiel",
          "Chmielewski",
          "Chmura",
          "Chojnacki",
          "Chojnowski",
          "Cholewa",
          "Chrzanowski",
          "Chudzik",
          "Cichocki",
          "Cichoń",
          "Cichy",
          "Ciesielski",
          "Cieśla",
          "Cieślak",
          "Cieślik",
          "Ciszewski",
          "Cybulski",
          "Cygan",
          "Czaja",
          "Czajka",
          "Czajkowski",
          "Czapla",
          "Czarnecki",
          "Czech",
          "Czechowski",
          "Czekaj",
          "Czerniak",
          "Czerwiński",
          "Czyż",
          "Czyżewski",
          "Dec",
          "Dobosz",
          "Dobrowolski",
          "Dobrzyński",
          "Domagała",
          "Domański",
          "Dominiak",
          "Drabik",
          "Drozd",
          "Drozdowski",
          "Drzewiecki",
          "Dróżdż",
          "Dubiel",
          "Duda",
          "Dudek",
          "Dudziak",
          "Dudzik",
          "Dudziński",
          "Duszyński",
          "Dziedzic",
          "Dziuba",
          "Dąbek",
          "Dąbkowski",
          "Dąbrowski",
          "Dębowski",
          "Dębski",
          "Długosz",
          "Falkowski",
          "Fijałkowski",
          "Filipek",
          "Filipiak",
          "Filipowicz",
          "Flak",
          "Flis",
          "Florczak",
          "Florek",
          "Frankowski",
          "Frąckowiak",
          "Frączek",
          "Frątczak",
          "Furman",
          "Gadomski",
          "Gajda",
          "Gajewski",
          "Gaweł",
          "Gawlik",
          "Gawron",
          "Gawroński",
          "Gałka",
          "Gałązka",
          "Gil",
          "Godlewski",
          "Golec",
          "Gołąb",
          "Gołębiewski",
          "Gołębiowski",
          "Grabowski",
          "Graczyk",
          "Grochowski",
          "Grudzień",
          "Gruszczyński",
          "Gruszka",
          "Grzegorczyk",
          "Grzelak",
          "Grzesiak",
          "Grzesik",
          "Grześkowiak",
          "Grzyb",
          "Grzybowski",
          "Grzywacz",
          "Gutowski",
          "Guzik",
          "Gwóźdź",
          "Góra",
          "Góral",
          "Górecki",
          "Górka",
          "Górniak",
          "Górny",
          "Górski",
          "Gąsior",
          "Gąsiorowski",
          "Głogowski",
          "Głowacki",
          "Głąb",
          "Hajduk",
          "Herman",
          "Iwański",
          "Izdebski",
          "Jabłoński",
          "Jackowski",
          "Jagielski",
          "Jagiełło",
          "Jagodziński",
          "Jakubiak",
          "Jakubowski",
          "Janas",
          "Janiak",
          "Janicki",
          "Janik",
          "Janiszewski",
          "Jankowiak",
          "Jankowski",
          "Janowski",
          "Janus",
          "Janusz",
          "Januszewski",
          "Jaros",
          "Jarosz",
          "Jarząbek",
          "Jasiński",
          "Jastrzębski",
          "Jaworski",
          "Jaśkiewicz",
          "Jezierski",
          "Jurek",
          "Jurkiewicz",
          "Jurkowski",
          "Juszczak",
          "Jóźwiak",
          "Jóźwik",
          "Jędrzejczak",
          "Jędrzejczyk",
          "Jędrzejewski",
          "Kacprzak",
          "Kaczmarczyk",
          "Kaczmarek",
          "Kaczmarski",
          "Kaczor",
          "Kaczorowski",
          "Kaczyński",
          "Kaleta",
          "Kalinowski",
          "Kalisz",
          "Kamiński",
          "Kania",
          "Kaniewski",
          "Kapusta",
          "Karaś",
          "Karczewski",
          "Karpiński",
          "Karwowski",
          "Kasperek",
          "Kasprzak",
          "Kasprzyk",
          "Kaszuba",
          "Kawa",
          "Kawecki",
          "Kałuża",
          "Kaźmierczak",
          "Kiełbasa",
          "Kisiel",
          "Kita",
          "Klimczak",
          "Klimek",
          "Kmiecik",
          "Kmieć",
          "Knapik",
          "Kobus",
          "Kogut",
          "Kolasa",
          "Komorowski",
          "Konieczna",
          "Konieczny",
          "Konopka",
          "Kopczyński",
          "Koper",
          "Kopeć",
          "Korzeniowski",
          "Kos",
          "Kosiński",
          "Kosowski",
          "Kostecki",
          "Kostrzewa",
          "Kot",
          "Kotowski",
          "Kowal",
          "Kowalczuk",
          "Kowalczyk",
          "Kowalewski",
          "Kowalik",
          "Kowalski",
          "Koza",
          "Kozak",
          "Kozieł",
          "Kozioł",
          "Kozłowski",
          "Kołakowski",
          "Kołodziej",
          "Kołodziejczyk",
          "Kołodziejski",
          "Krajewski",
          "Krakowiak",
          "Krawczyk",
          "Krawiec",
          "Kruk",
          "Krukowski",
          "Krupa",
          "Krupiński",
          "Kruszewski",
          "Krysiak",
          "Krzemiński",
          "Krzyżanowski",
          "Król",
          "Królikowski",
          "Książek",
          "Kubacki",
          "Kubiak",
          "Kubica",
          "Kubicki",
          "Kubik",
          "Kuc",
          "Kucharczyk",
          "Kucharski",
          "Kuchta",
          "Kuciński",
          "Kuczyński",
          "Kujawa",
          "Kujawski",
          "Kula",
          "Kulesza",
          "Kulig",
          "Kulik",
          "Kuliński",
          "Kurek",
          "Kurowski",
          "Kuś",
          "Kwaśniewski",
          "Kwiatkowski",
          "Kwiecień",
          "Kwieciński",
          "Kędzierski",
          "Kędziora",
          "Kępa",
          "Kłos",
          "Kłosowski",
          "Lach",
          "Laskowski",
          "Lasota",
          "Lech",
          "Lenart",
          "Lesiak",
          "Leszczyński",
          "Lewandowski",
          "Lewicki",
          "Leśniak",
          "Leśniewski",
          "Lipiński",
          "Lipka",
          "Lipski",
          "Lis",
          "Lisiecki",
          "Lisowski",
          "Maciejewski",
          "Maciąg",
          "Mackiewicz",
          "Madej",
          "Maj",
          "Majcher",
          "Majchrzak",
          "Majewski",
          "Majka",
          "Makowski",
          "Malec",
          "Malicki",
          "Malinowski",
          "Maliszewski",
          "Marchewka",
          "Marciniak",
          "Marcinkowski",
          "Marczak",
          "Marek",
          "Markiewicz",
          "Markowski",
          "Marszałek",
          "Marzec",
          "Masłowski",
          "Matusiak",
          "Matuszak",
          "Matuszewski",
          "Matysiak",
          "Mazur",
          "Mazurek",
          "Mazurkiewicz",
          "Maćkowiak",
          "Małecki",
          "Małek",
          "Maślanka",
          "Michalak",
          "Michalczyk",
          "Michalik",
          "Michalski",
          "Michałek",
          "Michałowski",
          "Mielczarek",
          "Mierzejewski",
          "Mika",
          "Mikołajczak",
          "Mikołajczyk",
          "Mikulski",
          "Milczarek",
          "Milewski",
          "Miller",
          "Misiak",
          "Misztal",
          "Miśkiewicz",
          "Modzelewski",
          "Molenda",
          "Morawski",
          "Motyka",
          "Mroczek",
          "Mroczkowski",
          "Mrozek",
          "Mróz",
          "Mucha",
          "Murawski",
          "Musiał",
          "Muszyński",
          "Młynarczyk",
          "Napierała",
          "Nawrocki",
          "Nawrot",
          "Niedziela",
          "Niedzielski",
          "Niedźwiecki",
          "Niemczyk",
          "Niemiec",
          "Niewiadomski",
          "Noga",
          "Nowacki",
          "Nowaczyk",
          "Nowak",
          "Nowakowski",
          "Nowicki",
          "Nowiński",
          "Olczak",
          "Olejniczak",
          "Olejnik",
          "Olszewski",
          "Orzechowski",
          "Orłowski",
          "Osiński",
          "Ossowski",
          "Ostrowski",
          "Owczarek",
          "Paczkowski",
          "Pająk",
          "Pakuła",
          "Paluch",
          "Panek",
          "Partyka",
          "Pasternak",
          "Paszkowski",
          "Pawelec",
          "Pawlak",
          "Pawlicki",
          "Pawlik",
          "Pawlikowski",
          "Pawłowski",
          "Pałka",
          "Piasecki",
          "Piechota",
          "Piekarski",
          "Pietras",
          "Pietruszka",
          "Pietrzak",
          "Pietrzyk",
          "Pilarski",
          "Pilch",
          "Piotrowicz",
          "Piotrowski",
          "Piwowarczyk",
          "Piórkowski",
          "Piątek",
          "Piątkowski",
          "Piłat",
          "Pluta",
          "Podgórski",
          "Polak",
          "Popławski",
          "Porębski",
          "Prokop",
          "Prus",
          "Przybylski",
          "Przybysz",
          "Przybył",
          "Przybyła",
          "Ptak",
          "Puchalski",
          "Pytel",
          "Płonka",
          "Raczyński",
          "Radecki",
          "Radomski",
          "Rak",
          "Rakowski",
          "Ratajczak",
          "Robak",
          "Rogala",
          "Rogalski",
          "Rogowski",
          "Rojek",
          "Romanowski",
          "Rosa",
          "Rosiak",
          "Rosiński",
          "Ruciński",
          "Rudnicki",
          "Rudziński",
          "Rudzki",
          "Rusin",
          "Rutkowski",
          "Rybak",
          "Rybarczyk",
          "Rybicki",
          "Rzepka",
          "Różański",
          "Różycki",
          "Sadowski",
          "Sawicki",
          "Serafin",
          "Siedlecki",
          "Sienkiewicz",
          "Sieradzki",
          "Sikora",
          "Sikorski",
          "Sitek",
          "Siwek",
          "Skalski",
          "Skiba",
          "Skibiński",
          "Skoczylas",
          "Skowron",
          "Skowronek",
          "Skowroński",
          "Skrzypczak",
          "Skrzypek",
          "Skóra",
          "Smoliński",
          "Sobczak",
          "Sobczyk",
          "Sobieraj",
          "Sobolewski",
          "Socha",
          "Sochacki",
          "Sokołowski",
          "Sokół",
          "Sosnowski",
          "Sowa",
          "Sowiński",
          "Sołtys",
          "Sołtysiak",
          "Sroka",
          "Stachowiak",
          "Stachowicz",
          "Stachura",
          "Stachurski",
          "Stanek",
          "Staniszewski",
          "Stanisławski",
          "Stankiewicz",
          "Stasiak",
          "Staszewski",
          "Stawicki",
          "Stec",
          "Stefaniak",
          "Stefański",
          "Stelmach",
          "Stolarczyk",
          "Stolarski",
          "Strzelczyk",
          "Strzelecki",
          "Stępień",
          "Stępniak",
          "Surma",
          "Suski",
          "Szafrański",
          "Szatkowski",
          "Szczepaniak",
          "Szczepanik",
          "Szczepański",
          "Szczerba",
          "Szcześniak",
          "Szczygieł",
          "Szczęsna",
          "Szczęsny",
          "Szeląg",
          "Szewczyk",
          "Szostak",
          "Szulc",
          "Szwarc",
          "Szwed",
          "Szydłowski",
          "Szymański",
          "Szymczak",
          "Szymczyk",
          "Szymkowiak",
          "Szyszka",
          "Sławiński",
          "Słowik",
          "Słowiński",
          "Tarnowski",
          "Tkaczyk",
          "Tokarski",
          "Tomala",
          "Tomaszewski",
          "Tomczak",
          "Tomczyk",
          "Tracz",
          "Trojanowski",
          "Trzciński",
          "Trzeciak",
          "Turek",
          "Twardowski",
          "Urban",
          "Urbanek",
          "Urbaniak",
          "Urbanowicz",
          "Urbańczyk",
          "Urbański",
          "Walczak",
          "Walkowiak",
          "Warchoł",
          "Wasiak",
          "Wasilewski",
          "Wawrzyniak",
          "Wesołowski",
          "Wieczorek",
          "Wierzbicki",
          "Wilczek",
          "Wilczyński",
          "Wilk",
          "Winiarski",
          "Witczak",
          "Witek",
          "Witkowski",
          "Wiącek",
          "Więcek",
          "Więckowski",
          "Wiśniewski",
          "Wnuk",
          "Wojciechowski",
          "Wojtas",
          "Wojtasik",
          "Wojtczak",
          "Wojtkowiak",
          "Wolak",
          "Woliński",
          "Wolny",
          "Wolski",
          "Woś",
          "Woźniak",
          "Wrona",
          "Wroński",
          "Wróbel",
          "Wróblewski",
          "Wypych",
          "Wysocki",
          "Wyszyński",
          "Wójcicki",
          "Wójcik",
          "Wójtowicz",
          "Wąsik",
          "Węgrzyn",
          "Włodarczyk",
          "Włodarski",
          "Zaborowski",
          "Zabłocki",
          "Zagórski",
          "Zając",
          "Zajączkowski",
          "Zakrzewski",
          "Zalewski",
          "Zaremba",
          "Zarzycki",
          "Zaręba",
          "Zawada",
          "Zawadzki",
          "Zdunek",
          "Zieliński",
          "Zielonka",
          "Ziółkowski",
          "Zięba",
          "Ziętek",
          "Zwoliński",
          "Zych",
          "Zygmunt",
          "Łapiński",
          "Łuczak",
          "Łukasiewicz",
          "Łukasik",
          "Łukaszewski",
          "Śliwa",
          "Śliwiński",
          "Ślusarczyk",
          "Świderski",
          "Świerczyński",
          "Świątek",
          "Żak",
          "Żebrowski",
          "Żmuda",
          "Żuk",
          "Żukowski",
          "Żurawski",
          "Żurek",
          "Żyła"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Pan",
          "Pani"
        ],
        "title": {
          "descriptor": [
            "Lead",
            "Senior",
            "Direct",
            "Corporate",
            "Dynamic",
            "Future",
            "Product",
            "National",
            "Regional",
            "District",
            "Central",
            "Global",
            "Customer",
            "Investor",
            "Dynamic",
            "International",
            "Legacy",
            "Forward",
            "Internal",
            "Human",
            "Chief",
            "Principal"
          ],
          "job": [
            "Supervisor",
            "Associate",
            "Executive",
            "Liaison",
            "Officer",
            "Manager",
            "Engineer",
            "Specialist",
            "Director",
            "Coordinator",
            "Administrator",
            "Architect",
            "Analyst",
            "Designer",
            "Planner",
            "Orchestrator",
            "Technician",
            "Developer",
            "Producer",
            "Consultant",
            "Assistant",
            "Facilitator",
            "Agent",
            "Representative",
            "Strategist"
          ],
          "level": [
            "Solutions",
            "Program",
            "Brand",
            "Security",
            "Research",
            "Marketing",
            "Directives",
            "Implementation",
            "Integration",
            "Functionality",
            "Response",
            "Paradigm",
            "Tactics",
            "Identity",
            "Markets",
            "Group",
            "Division",
            "Applications",
            "Optimization",
            "Operations",
            "Infrastructure",
            "Intranet",
            "Communications",
            "Web",
            "Branding",
            "Quality",
            "Assurance",
            "Mobility",
            "Accounts",
            "Data",
            "Creative",
            "Configuration",
            "Accountability",
            "Interactions",
            "Factors",
            "Usability",
            "Metrics"
          ]
        }
      },
      "phone_number": {
        "formats": [
          "12-###-##-##",
          "13-###-##-##",
          "14-###-##-##",
          "15-###-##-##",
          "16-###-##-##",
          "17-###-##-##",
          "18-###-##-##",
          "22-###-##-##",
          "23-###-##-##",
          "24-###-##-##",
          "25-###-##-##",
          "29-###-##-##",
          "32-###-##-##",
          "33-###-##-##",
          "34-###-##-##",
          "41-###-##-##",
          "42-###-##-##",
          "43-###-##-##",
          "44-###-##-##",
          "46-###-##-##",
          "48-###-##-##",
          "52-###-##-##",
          "54-###-##-##",
          "55-###-##-##",
          "56-###-##-##",
          "58-###-##-##",
          "59-###-##-##",
          "61-###-##-##",
          "62-###-##-##",
          "63-###-##-##",
          "65-###-##-##",
          "67-###-##-##",
          "68-###-##-##",
          "71-###-##-##",
          "74-###-##-##",
          "75-###-##-##",
          "76-###-##-##",
          "77-###-##-##",
          "81-###-##-##",
          "82-###-##-##",
          "83-###-##-##",
          "84-###-##-##",
          "85-###-##-##",
          "86-###-##-##",
          "87-###-##-##",
          "89-###-##-##",
          "91-###-##-##",
          "94-###-##-##",
          "95-###-##-##"
        ]
      }
    },
    "hello": "Witaj",
    "helpers": {
      "select": {
        "prompt": "Proszę wybrać"
      },
      "submit": {
        "create": "Utwórz %{model}",
        "submit": "Wyślij %{model}",
        "update": "Aktualizuj %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "many",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "Ó": "O",
          "ó": "o",
          "Ą": "A",
          "ą": "a",
          "Ć": "C",
          "ć": "c",
          "Ę": "E",
          "ę": "e",
          "Ł": "L",
          "ł": "l",
          "Ń": "N",
          "ń": "n",
          "Ś": "S",
          "ś": "s",
          "Ź": "Z",
          "ź": "z",
          "Ż": "Z",
          "ż": "z"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": true,
          "unit": "zł"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miliard",
            "million": "Milion",
            "quadrillion": "Biliard",
            "thousand": "Tysiąc",
            "trillion": "Bilion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "bajty",
              "many": "bajtów",
              "one": "bajt",
              "other": "bajty"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " oraz ",
        "two_words_connector": " i ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "przed południem",
      "formats": {
        "default": "%a, %-d %b %Y %H:%M:%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%-d %B %Y %H:%M",
        "short": "%-d %b %H:%M"
      },
      "pm": "po południu"
    },
    "welcome": "Witaj"
  },
  "pt": {
    "accounts": {
      "nav": {
        "account": "Conta",
        "edit_profile": "Editar perfil",
        "log_out": "Sair",
        "session": "Sessão",
        "tools": "As tuas ferramentas"
      },
      "show": {
        "edit": "Editar perfil",
        "profile": "Perfil",
        "title": "A tua conta"
      }
    },
    "activerecord": {
      "attributes": {
        "board": {
          "add_creator_to_cards": "Atribuir-me os cartões que crio",
          "color": "Cor",
          "description": "Descrição",
          "key": "Chave",
          "name": "Nome",
          "number_format": "Numeração dos cartões",
          "number_formats": {
            "hash": "#142",
            "key": "MKT-142",
            "workspace": "Predefinição do espaço"
          },
          "show_card_numbers": "Mostrar números dos cartões"
        },
        "board_list": {
          "name": "Nome"
        },
        "board_membership": {
          "role": "Papel",
          "roles": {
            "admin": "Administrador",
            "member": "Membro",
            "observer": "Observador"
          },
          "user": "Pessoa"
        },
        "card": {
          "board_list": "Lista",
          "description": "Descrição",
          "due_list": "Conclui em",
          "due_on": "Data limite",
          "due_time": "Hora limite",
          "number": "Número",
          "title": "Título"
        },
        "card_attachment": {
          "file": "Ficheiro"
        },
        "card_comment": {
          "body": "Comentário"
        },
        "checklist_item": {
          "text": "Item"
        },
        "client": {
          "contact_email": "Email de contacto",
          "default_hourly_rate": "Valor por hora por defeito",
          "name": "Nome do cliente"
        },
        "consent": {
          "accepted_consents": "Consentimentos Aceites",
          "active": "Ativo",
          "content": "Conteúdo",
          "kind": "Nome",
          "kind_list": {
            "cookies": "Política de Cookies",
            "privacy": "Política de Privacidade",
            "terms": "Termos e Condições"
          },
          "version": "Versão"
        },
        "doorkeeper/application": {
          "name": "Nome",
          "redirect_uri": "URI de redirecionamento"
        },
        "group": {
          "anyone_can_add_reminders": "Qualquer pessoa pode criar lembretes",
          "color": "Cor",
          "name": "Nome do grupo"
        },
        "group_invitation": {
          "email": "Email"
        },
        "import": {
          "file": "Ficheiro",
          "provider": "Origem",
          "providers": {
            "clockify": "Clockify"
          },
          "status": "Estado",
          "statuses": {
            "done": "Concluída",
            "failed": "Falhou",
            "pending": "Em fila",
            "running": "A correr"
          },
          "time_zone": "Fuso horário do ficheiro"
        },
        "label": {
          "color": "Cor",
          "name": "Nome"
        },
        "membership": {
          "role": "Papel",
          "roles": {
            "admin": "Admin",
            "member": "Membro"
          }
        },
        "nav_item": {
          "position": "Posição",
          "route": "Rota",
          "title": "Título"
        },
        "page": {
          "slug": "Slug",
          "title": "Título"
        },
        "page_block": {
          "column": "Coluna",
          "height": "Altura",
          "row": "Linha",
          "title": "Etiqueta",
          "width": "Largura"
        },
        "page_block_carousel": {
          "autoplay": "Reprodução automática",
          "autoplay_delay": "Intervalo de Reprodução",
          "effect": "Efeito",
          "loop": "Repetir",
          "show_navigation": "Mostrar Navegação",
          "show_pagination": "Mostrar Paginação",
          "speed": "Velocidade de Transição"
        },
        "page_block_carousel_slide": {
          "image": "Imagem",
          "position": "Posição",
          "text": "Texto",
          "title": "Título"
        },
        "page_block_video": {
          "autoplay": "Reprodução automática",
          "caption": "Legenda",
          "file": "Ficheiro de Vídeo",
          "loop": "Repetir",
          "show_controls": "Mostrar Controlos",
          "video_url": "URL do Vídeo"
        },
        "project": {
          "billable": "Facturável",
          "client": "Cliente",
          "color": "Cor",
          "hourly_rate": "Valor por hora",
          "name": "Nome do projecto"
        },
        "reminder": {
          "audience": "Para quem",
          "audiences": {
            "group_all": "Todos",
            "group_anyone": "Qualquer um",
            "members": "Algumas pessoas",
            "only_me": "Só eu"
          },
          "description": "Descrição",
          "due_at": "Quando",
          "repeat_rule": "Repete",
          "repeat_rules": {
            "daily": "Todos os dias",
            "monthly": "Todos os meses",
            "never": "Nunca",
            "weekly": "Todas as semanas"
          },
          "title": "Título do lembrete"
        },
        "time_entry": {
          "project": "Projecto",
          "started_at": "Início",
          "stopped_at": "Fim",
          "task": "Tarefa"
        },
        "user": {
          "confirmation_sent_at": "Confirmação enviada em",
          "confirmation_token": "Código de confirmação",
          "confirmed_at": "Confirmado em",
          "created_at": "Criado em",
          "current_password": "Palavra-passe actual",
          "current_sign_in_at": "Entrada atual em",
          "current_sign_in_ip": "Entrada atual com IP",
          "email": "Email",
          "encrypted_password": "Palavra-passe cifrada",
          "failed_attempts": "Tentativas falhadas",
          "last_sign_in_at": "Última entrada em",
          "last_sign_in_ip": "Última entrada com IP",
          "locked_at": "Bloqueado em",
          "name": "Nome",
          "password": "Palavra-passe",
          "password_confirmation": "Confirmar palavra-passe",
          "remember_created_at": "Lembrança criada em",
          "remember_me": "Manter sessão iniciada",
          "reset_password_sent_at": "Recuperação de palavra-passe enviada em",
          "reset_password_token": "Código para recuperar palavra-passe",
          "sign_in_count": "Número de entradas",
          "time_zone": "Fuso horário",
          "unconfirmed_email": "Email não confirmado",
          "unlock_token": "Código de desbloqueio",
          "updated_at": "Atualizado em"
        },
        "workspace": {
          "card_number_format": "Numeração dos cartões",
          "card_number_formats": {
            "hash": "#142",
            "key": "MKT-142"
          },
          "currency": "Moeda",
          "daily_target_hours": "Horas por dia",
          "daily_target_minutes": "Horas por dia",
          "name": "Nome do espaço de trabalho"
        },
        "workspace_invitation": {
          "email": "Endereços de email",
          "role": "Papel",
          "roles": {
            "admin": "Admin",
            "member": "Membro",
            "owner": "Dono"
          }
        },
        "workspace_membership": {
          "role": "Papel",
          "roles": {
            "admin": "Admin",
            "member": "Membro",
            "owner": "Dono"
          }
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "A validação falhou: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Não pode ser eliminado por existirem dependências de %{record}",
            "has_one": "Não pode ser eliminado por existir uma dependência de %{record}"
          }
        },
        "models": {
          "card_attachment": {
            "attributes": {
              "file": {
                "too_large": "é demasiado grande (máximo %{count} MB)"
              }
            }
          },
          "doorkeeper/application": {
            "attributes": {
              "redirect_uri": {
                "forbidden_uri": "não é permitido pelo servidor.",
                "fragment_present": "não pode conter um fragmento.",
                "invalid_uri": "tem de ser um URI válido.",
                "relative_uri": "tem de ser um URI absoluto.",
                "secured_uri": "tem de ser um URI HTTPS/SSL.",
                "unspecified_scheme": "tem de indicar um esquema."
              },
              "scopes": {
                "not_match_configured": "não correspondem aos configurados no servidor."
              }
            }
          },
          "import": {
            "attributes": {
              "file": {
                "not_csv": "tem de ser um ficheiro CSV",
                "too_large": "tem de ter menos de %{max} MB"
              }
            }
          },
          "page_block_video": {
            "attributes": {
              "base": {
                "video_source_exclusive": "não pode ter simultaneamente um URL e um ficheiro — escolha um",
                "video_source_required": "deve ter um URL ou um ficheiro de vídeo"
              }
            }
          },
          "time_entry": {
            "attributes": {
              "stopped_at": {
                "after_start": "tem de ser depois do início"
              },
              "user_id": {
                "already_running": "já tem um cronómetro a correr"
              }
            }
          }
        }
      },
      "models": {
        "board": {
          "one": "Quadro",
          "other": "Quadros"
        },
        "board_list": {
          "one": "Lista",
          "other": "Listas"
        },
        "board_membership": {
          "one": "Membro do quadro",
          "other": "Membros do quadro"
        },
        "card": {
          "one": "Cartão",
          "other": "Cartões"
        },
        "card_activity": {
          "one": "Atividade",
          "other": "Atividades"
        },
        "card_assignment": {
          "one": "Atribuição",
          "other": "Atribuições"
        },
        "card_attachment": {
          "one": "Anexo",
          "other": "Anexos"
        },
        "card_comment": {
          "one": "Comentário",
          "other": "Comentários"
        },
        "card_label": {
          "one": "Etiqueta do cartão",
          "other": "Etiquetas do cartão"
        },
        "card_watch": {
          "one": "Seguidor",
          "other": "Seguidores"
        },
        "checklist_item": {
          "one": "Item da lista de verificação",
          "other": "Itens da lista de verificação"
        },
        "client": {
          "one": "Cliente",
          "other": "Clientes"
        },
        "consent": {
          "one": "Consentimento",
          "other": "Consentimentos"
        },
        "group": {
          "one": "Grupo",
          "other": "Grupos"
        },
        "group_invitation": {
          "one": "Convite",
          "other": "Convites"
        },
        "import": {
          "one": "Importação",
          "other": "Importações"
        },
        "label": {
          "one": "Etiqueta",
          "other": "Etiquetas"
        },
        "membership": {
          "one": "Membro",
          "other": "Membros"
        },
        "nav_item": {
          "one": "Item de Navegação",
          "other": "Itens de Navegação"
        },
        "page": {
          "one": "Página",
          "other": "Páginas"
        },
        "page_block": {
          "one": "Bloco",
          "other": "Blocos"
        },
        "page_block_carousel": {
          "one": "Bloco de Carrossel",
          "other": "Blocos de Carrossel"
        },
        "page_block_carousel_slide": {
          "one": "Diapositivo",
          "other": "Diapositivos"
        },
        "page_block_image": {
          "one": "Bloco de Imagem",
          "other": "Blocos de Imagem"
        },
        "page_block_text": {
          "one": "Bloco de Texto",
          "other": "Blocos de Texto"
        },
        "page_block_video": {
          "one": "Bloco de Vídeo",
          "other": "Blocos de Vídeo"
        },
        "project": {
          "one": "Projecto",
          "other": "Projectos"
        },
        "reminder": {
          "one": "Lembrete",
          "other": "Lembretes"
        },
        "time_entry": {
          "one": "Registo de tempo",
          "other": "Registos de tempo"
        },
        "user": {
          "many": null,
          "one": null,
          "other": null
        },
        "workspace": {
          "one": "Espaço de trabalho",
          "other": "Espaços de trabalho"
        },
        "workspace_invitation": {
          "one": "Convite",
          "other": "Convites"
        },
        "workspace_membership": {
          "one": "Pessoa",
          "other": "Pessoas"
        }
      }
    },
    "api": {
      "v1": {
        "consents_missing": "Aceita os Termos e Condições e a Política de Privacidade atualizados para continuar.",
        "invalid_time": "“%{value}” não é uma data e hora ISO 8601.",
        "social_logins": {
          "app": {
            "invalid_code": "Esta entrada expirou ou não é válida. Entra de novo a partir da aplicação.",
            "missing_code": "Falta o código para entrar ou o seu verificador."
          }
        },
        "timers": {
          "destroy": {
            "nothing_running": "Não há nenhum cronómetro a decorrer."
          }
        }
      }
    },
    "auth": {
      "app_sign_ins": {
        "invalid": {
          "expired": "Esta entrada demorou demasiado ou já foi usada. Começa de novo na aplicação.",
          "invalid": "Começa de novo a entrar a partir da aplicação.",
          "title": "Esta ligação para entrar não pode ser usada"
        },
        "new": {
          "subtitle": "A levar-te para a tua conta… Quando terminares, voltas à aplicação.",
          "title": "Entrar no Meerkeep"
        }
      }
    },
    "boards": {
      "archived_cards": {
        "restore": {
          "success": "%{number} restaurado."
        }
      },
      "assistant_pastes": {
        "create": {
          "success": "O texto foi recebido. O assistente está a analisá-lo."
        },
        "destroy": {
          "success": "O texto foi descartado."
        },
        "retry": {
          "success": "O assistente vai tentar de novo."
        }
      },
      "assistant_prompts": {
        "update": {
          "invalid": "As instruções não podem estar vazias nem ter mais de %{max} carateres.",
          "success": "Instruções guardadas."
        }
      },
      "assistant_settings": {
        "show": {
          "back": "Voltar ao assistente",
          "eyebrow": "Espaço %{workspace} · só tu vês esta página",
          "gmail_hint": "Diz ao assistente quando criar um cartão e em que quadro. Ele também sabe a data de hoje, os teus quadros, as listas e as etiquetas.",
          "gmail_label": "Prompt",
          "gmail_title": "Correio de %{email}",
          "intro": "As instruções que o assistente segue neste workspace. Cada origem de texto tem as suas.",
          "no_gmail": "Não há nenhuma conta Gmail ligada, por isso ainda não há instruções de correio para editar.",
          "paste_hint": "Diz ao assistente como transformar o texto em cartões. Ele também sabe a data de hoje, os teus quadros, as listas e as etiquetas, e os teus cartões abertos.",
          "paste_label": "Instruções",
          "paste_title": "Texto colado",
          "save": "Guardar",
          "title": "Definições do assistente"
        }
      },
      "assistant_suggestions": {
        "accept": {
          "success": "Sugestão aplicada."
        },
        "dismiss": {
          "success": "Sugestão recusada."
        }
      },
      "assistants": {
        "activity_item": {
          "accepted": "Aceite",
          "archived": "arquivado",
          "created": "Cartão criado",
          "dismissed": "Recusada"
        },
        "connection": {
          "checked": "Última verificação %{time}",
          "disconnect": "Desligar",
          "disconnect_confirm": "Desligar %{email}? O acesso guardado é apagado e revogado no Google. Os cartões que o assistente criou ficam.",
          "never_checked": "Ainda não verificada",
          "pause": "Ler o meu correio",
          "pause_hint": "Desliga para pausar. O correio recebido durante a pausa é ignorado.",
          "reconnect": "Voltar a ligar",
          "reconnect_hint": "O Google já não aceita o acesso guardado. Volta a ligar para continuar.",
          "status": {
            "active": "Ligada",
            "disconnected": "Desligada",
            "paused": "Em pausa"
          }
        },
        "paste": {
          "cards": {
            "one": "%{count} cartão",
            "other": "%{count} cartões"
          },
          "discard": "Descartar",
          "discard_confirm": "Descartar este texto? Os cartões já criados ficam.",
          "done": "%{cards}, %{suggestions}",
          "retry": "Tentar de novo",
          "status": {
            "done": "Concluído",
            "failed": "Não foi possível contactar o modelo",
            "pending": "Em espera",
            "processing": "A analisar…"
          },
          "suggestions": {
            "one": "%{count} sugestão",
            "other": "%{count} sugestões"
          }
        },
        "paste_box": {
          "analyse": "Analisar",
          "hint": "Cola notas, uma lista de tarefas ou uma mensagem reencaminhada. O assistente lê-o em segundo plano, cria um cartão por cada tarefa e sugere alterações aos teus cartões existentes. Funciona sem Gmail.",
          "not_configured": "O servidor de modelo não está configurado neste servidor, por isso ainda não é possível analisar texto.",
          "placeholder": "Cola aqui o teu texto",
          "text": "Texto a analisar",
          "text_hint": "Até %{max} carateres. O texto é apagado depois de analisado.",
          "title": "Colar texto"
        },
        "pastes": {
          "title": "Textos colados"
        },
        "proposal": {
          "comment": "Adicionar um comentário:",
          "due_date": "Alterar a data limite para %{date} %{time}",
          "move": "Mover para %{list}"
        },
        "show": {
          "activity": "Atividade",
          "activity_empty": "O assistente ainda não fez nada.",
          "activity_hint": "Cartões que o assistente criou para ti e sugestões que aceitaste ou recusaste, as mais recentes primeiro.",
          "connect": "Ligar Gmail",
          "connect_another": "Ligar outra conta Gmail",
          "connections": "Ligações Gmail",
          "eyebrow": "Espaço %{workspace} · só tu vês esta página",
          "intro": "Liga o teu Gmail e o assistente transforma o correio que pede uma ação em cartões nos teus quadros, seguindo o teu prompt.",
          "none": "Ainda não há nenhuma conta Gmail ligada neste espaço.",
          "not_configured": "O início de sessão com Google não está configurado neste servidor, por isso ainda não é possível ligar o Gmail.",
          "privacy": {
            "model": "O texto de cada email é enviado para o servidor de modelo do próprio Meerkeep, que decide se precisa de um cartão. Não é partilhado com mais ninguém.",
            "paste": "O texto que coles é enviado para o servidor de modelo do próprio Meerkeep e apagado assim que for analisado.",
            "read": "De 3 em 3 horas lê o correio novo de cada conta ligada, exceto Spam, Promoções e Social. O correio recebido antes de ligares não é lido.",
            "stored": "Só são guardados identificadores das mensagens, nunca o email em si. Os cartões mostram um resumo curto e o nome do remetente aos membros do quadro."
          },
          "privacy_title": "O que o assistente lê e guarda",
          "settings": "Definições",
          "suggestions": "Sugestões",
          "suggestions_empty": "Sem sugestões à espera.",
          "suggestions_hint": "Alterações que o assistente propõe para os teus cartões, a partir do teu correio ou de texto que colaste. Nada muda até aceitares.",
          "title": "Assistente"
        },
        "suggestion": {
          "accept": "Aceitar",
          "dismiss": "Recusar"
        }
      },
      "board_duplicates": {
        "create": {
          "success": "%{name} está pronto: uma cópia do quadro."
        }
      },
      "board_lists": {
        "archive": {
          "success": "%{name} arquivada com os seus cartões."
        },
        "create": {
          "alert": "Não foi possível adicionar a lista: %{errors}",
          "success": "Lista adicionada."
        },
        "list": {
          "actions": "Ações de %{list}",
          "archive_all": "Arquivar todos os cartões",
          "archive_all_confirm": {
            "one": "Arquivar o cartão de %{list}?",
            "other": "Arquivar os %{count} cartões de %{list}?"
          },
          "drop_here": "Larga um cartão aqui",
          "move_all_to": "Mover todos os cartões para",
          "select_all": "Selecionar todos os cartões"
        },
        "update": {
          "success": "Lista renomeada."
        }
      },
      "board_memberships": {
        "create": {
          "success": "%{name} adicionado(a) a %{board}."
        },
        "destroy": {
          "success": "%{name} removido(a) do quadro."
        },
        "update": {
          "success": "Papel de %{name} no quadro atualizado."
        }
      },
      "board_settings": {
        "archived_cards": {
          "empty": "Não há cartões arquivados neste quadro.",
          "meta": "Arquivado por %{name} · %{date}",
          "restore": "Restaurar",
          "someone": "alguém",
          "title": "Cartões arquivados"
        },
        "close": {
          "archive": "Arquivar quadro",
          "archive_confirm": "Arquivar %{name}? Fica só de leitura e sai da barra lateral.",
          "delete": "Eliminar quadro…",
          "delete_confirm": "Eliminar %{name} e todos os seus cartões? Não pode ser anulado.",
          "hint": "Os quadros arquivados são só de leitura e saem da barra lateral. Podes reabri-los em Todos os quadros. Eliminar remove todos os cartões e não pode ser anulado.",
          "title": "Fechar este quadro"
        },
        "duplicate": {
          "copy_name": "%{name} (cópia)",
          "hint": "Cria um quadro novo com as mesmas listas, etiquetas, definições e cartões (com as suas listas de verificação, datas e ficheiros), para servir de modelo. As pessoas, os comentários e os cartões arquivados não são copiados; ficas como administrador do novo quadro.",
          "name": "Nome da cópia",
          "submit": "Duplicar quadro",
          "title": "Duplicar este quadro"
        },
        "general": {
          "color": "Cor",
          "description": "Descrição",
          "key": "Chave do quadro",
          "name": "Nome",
          "optional": "(opcional)",
          "title": "Geral"
        },
        "labels": {
          "add": "+ Etiqueta do quadro",
          "color_for": "Cor de %{name}",
          "delete": "Eliminar a etiqueta %{name}",
          "delete_confirm": "Eliminar a etiqueta %{name}? Sai de todos os cartões que a têm.",
          "hint": "As etiquetas só existem neste quadro.",
          "new_color": "Cor da nova etiqueta",
          "new_name": "Nome da nova etiqueta",
          "preview": "Pré-visualização",
          "preview_name": "Nova etiqueta",
          "rename": "Renomear %{name}",
          "title": "Etiquetas"
        },
        "lists": {
          "add": "+ Adicionar lista",
          "archive": "Arquivar a lista %{name}",
          "archive_confirm": "Arquivar %{name} e todos os seus cartões? As listas não podem ser restauradas.",
          "cards": {
            "one": "1 cartão",
            "other": "%{count} cartões"
          },
          "hint": "Arrasta para reordenar. Arquivar uma lista arquiva também os seus cartões.",
          "new_name": "Nome da nova lista",
          "rename": "Renomear %{name}",
          "title": "Listas"
        },
        "members": {
          "add_from": "Adicionar de %{workspace}",
          "hint": "Os admins do quadro alteram estas definições. Os membros trabalham nos cartões. Os observadores só leem e comentam, ótimo para clientes.",
          "remove": "Remover %{name} deste quadro",
          "remove_confirm": "Remover %{name} deste quadro? As atribuições de cartões mantêm-se.",
          "role_for": "Papel de %{name} no quadro",
          "title": "Membros"
        },
        "numbers": {
          "format": "Formato neste quadro",
          "hint": "Os números começam em #1 em cada quadro e nunca são reutilizados. Mudar a chave mantém os links antigos a funcionar.",
          "next": "O próximo cartão fica com",
          "title": "Números dos cartões",
          "workspace": "Espaço de trabalho (%{sample})"
        },
        "show": {
          "board": "Quadro",
          "eyebrow": "Definições do quadro · %{workspace}",
          "open_board": "Abrir quadro",
          "title": "Definições do quadro · %{board}"
        },
        "switches": {
          "add_creator_to_cards": {
            "hint": "Põe os novos cartões nas tuas Tarefas",
            "title": "Adicionar-me aos cartões que crio"
          },
          "show_card_numbers": {
            "hint": "Os números continuam a funcionar na pesquisa e nos links quando estão escondidos",
            "title": "Mostrar o número nos cartões"
          },
          "title": "Cartões neste quadro"
        },
        "update": {
          "success": "Guardado."
        }
      },
      "boards": {
        "archive": {
          "success": "%{name} arquivado. Podes reabri-lo em Todos os quadros."
        },
        "chips": {
          "query": "“%{q}”",
          "remove": "Remover filtro %{filter}"
        },
        "create": {
          "success": "Quadro criado."
        },
        "destroy": {
          "success": "%{name} eliminado."
        },
        "filter": {
          "clear_all": "Limpar tudo",
          "due": {
            "none": "Sem data limite",
            "overdue": "Em atraso",
            "today": "Para hoje",
            "tomorrow": "Para amanhã",
            "week": "Para esta semana"
          },
          "due_date": "Data limite",
          "labels": "Etiquetas",
          "match": "Mostrar cartões que cumpram",
          "matches": {
            "all": "Todos os grupos",
            "any": "Qualquer filtro"
          },
          "me": "Eu",
          "members": "Membros",
          "no_labels": "Sem etiquetas",
          "no_members": "Sem membros",
          "showing": "A mostrar %{shown} de %{total} cartões",
          "title": "Filtrar"
        },
        "index": {
          "all_my_tasks": "Todas as minhas tarefas",
          "archived_boards": {
            "one": "1 quadro arquivado",
            "other": "%{count} quadros arquivados"
          },
          "create_board": "Criar um quadro",
          "create_hint": "Começa com Backlog, Por fazer, A fazer, Feito",
          "due_for_you": "Para entregar",
          "empty": "Ainda não há quadros.",
          "eyebrow": {
            "one": "Espaço %{workspace} · 1 quadro",
            "other": "Espaço %{workspace} · %{count} quadros"
          },
          "groups": {
            "overdue": "Em atraso",
            "today": "Hoje · %{date}",
            "tomorrow": "Amanhã"
          },
          "meta": "%{board} · %{list}",
          "new_board": "Novo quadro",
          "no_results": "Nenhum quadro corresponde à pesquisa.",
          "nothing_due": "Nada para hoje ou amanhã.",
          "other": "Outros quadros em %{workspace}",
          "reopen": "Reabrir",
          "search_label": "Procurar quadros",
          "search_placeholder": "Procurar quadros…",
          "starred": "Favoritos",
          "title": "Quadros"
        },
        "new": {
          "back": "← Quadros",
          "eyebrow": "Espaço %{workspace}",
          "heading": "Configura o teu quadro",
          "hint": "Começa com as listas Backlog, Por fazer, A fazer e Feito.",
          "key_hint": "Até 5 letras ou números mostrados antes do número do cartão. Automática a partir do nome se vazia.",
          "name_placeholder": "ex. Redesenho do site",
          "submit": "Criar quadro",
          "title": "Novo quadro"
        },
        "reopen": {
          "success": "%{name} reaberto."
        },
        "selection_panel": {
          "add": "Adicionar",
          "archive": "Arquivar cartões",
          "archive_confirm": "Arquivar os cartões selecionados?",
          "clear": "Limpar seleção",
          "clear_due": "Remover data",
          "count": {
            "one": "1 cartão selecionado",
            "other": "%{count} cartões selecionados",
            "zero": "Nenhum cartão selecionado"
          },
          "done": "Sair da seleção",
          "due": "Data limite",
          "eyebrow": "Seleção",
          "hint": "Clica nos cartões do quadro para os selecionar. Depois move-os, adiciona pessoas ou etiquetas, define uma data ou arquiva-os, todos de uma vez.",
          "labels": "Etiquetas",
          "members": "Membros",
          "move": "Mover",
          "move_to": "Mover para a lista",
          "remove": "Remover",
          "set_due": "Definir"
        },
        "show": {
          "add_list": "Adicionar outra lista",
          "add_list_submit": "Adicionar lista",
          "archived": "Arquivado · só de leitura",
          "list_name": "Nome da lista",
          "members": "Membros do quadro: %{names}",
          "only_mine": "Só os meus cartões",
          "search_label": "Procurar cartões por título ou número",
          "search_placeholder": "Procurar ou saltar para #142…",
          "select": "Selecionar",
          "settings": "Definições do quadro"
        },
        "stats": {
          "one": "Quadro · 1 cartão aberto · o próximo é #%{next}",
          "other": "Quadro · %{count} cartões abertos · o próximo é #%{next}"
        },
        "tile": {
          "due_today": {
            "one": "1 para hoje",
            "other": "%{count} para hoje"
          },
          "open": {
            "one": "1 aberto",
            "other": "%{count} abertos"
          },
          "overdue": {
            "one": "1 em atraso",
            "other": "%{count} em atraso"
          },
          "star": "Marcar %{board} como favorito",
          "unstar": "Desmarcar %{board} como favorito",
          "updated": "Atualizado há %{time}"
        }
      },
      "bulk_cards": {
        "update": {
          "success": {
            "one": "1 cartão atualizado.",
            "other": "%{count} cartões atualizados."
          }
        }
      },
      "calendars": {
        "day": {
          "label": {
            "one": "%{date}, 1 cartão",
            "other": "%{date}, %{count} cartões"
          },
          "more": "+%{count} mais"
        },
        "show": {
          "cards": {
            "one": "1 cartão",
            "other": "%{count} cartões"
          },
          "empty_day": "Nenhum cartão para entregar neste dia.",
          "eyebrow": {
            "one": "1 cartão para entregar · todos os quadros em %{workspace}",
            "other": "%{count} cartões para entregar · todos os quadros em %{workspace}"
          },
          "next_month": "Mês seguinte",
          "only_mine": "Só os meus cartões",
          "overdue": "Em atraso",
          "previous_month": "Mês anterior",
          "show": "Mostrar",
          "title": "Calendário",
          "today": "Hoje",
          "today_prefix": "Hoje, %{date}"
        }
      },
      "cards": {
        "archive": {
          "success": "Cartão arquivado."
        },
        "card": {
          "attachments": {
            "one": "%{count} anexo",
            "other": "%{count} anexos"
          },
          "checklist": "Lista de verificação %{done} de %{total}",
          "comments": {
            "one": "%{count} comentário",
            "other": "%{count} comentários"
          },
          "due": {
            "completed": "Concluído",
            "overdue": "Em atraso",
            "today": "Para hoje",
            "upcoming": "Data limite"
          },
          "has_description": "Este cartão tem descrição"
        },
        "composer": {
          "add_card": "Adicionar um cartão",
          "cancel": "Cancelar",
          "hint": "Enter para adicionar",
          "label": "Título do novo cartão em %{list}",
          "placeholder": "O que é preciso fazer?",
          "submit": "Adicionar cartão"
        },
        "create": {
          "alert": "Não foi possível adicionar o cartão: %{errors}",
          "success": "Cartão adicionado."
        },
        "detail": {
          "actions": "Ações",
          "activity": "Atividade",
          "add": "Adicionar",
          "add_attachment": "Adicionar um anexo",
          "add_item": "Adicionar um item",
          "add_to_card": "Adicionar ao cartão",
          "ai": "IA",
          "ai_comment": "Escrito por IA",
          "archive": "Arquivar",
          "archive_confirm": "Arquivar este cartão? Vai desaparecer do quadro.",
          "attachment": "Anexo",
          "attachments": "Anexos",
          "cancel": "Cancelar",
          "checklist": "Lista de verificação",
          "checklist_title": "Título da lista de verificação",
          "close": "Fechar cartão",
          "comment": "Comentar",
          "comment_label": "Escrever um comentário",
          "comment_placeholder": "Escreve um comentário… usa @ para mencionar, #número para ligar a um cartão",
          "commented": "comentou",
          "completed_in": "Concluído em %{list}",
          "completes_in": "Conclui em %{list}",
          "copied": "Copiado",
          "copy_link": "Copiar ligação",
          "copy_number": "Copiar número do cartão",
          "copy_number_label": "Copiar número do cartão %{number}",
          "create_label": "Criar etiqueta",
          "dates": "Datas",
          "description": "Descrição",
          "description_placeholder": "Adiciona uma descrição mais detalhada…",
          "download": "Transferir",
          "drop_files": "Larga os ficheiros para os anexar",
          "due": "Prazo",
          "due_date": "Data",
          "due_list": "Conclui em",
          "due_list_hint": "O prazo fica concluído quando o cartão chega a esta coluna, e assim permanece.",
          "due_state": {
            "completed": "Concluído",
            "overdue": "Em atraso",
            "today": "Hoje",
            "upcoming": "Futuro"
          },
          "due_time": "Hora",
          "due_time_hint": "Deixa vazio para um prazo de dia inteiro.",
          "editor": {
            "attach": "Inserir uma imagem ou um ficheiro",
            "blockquote": "Citação",
            "bold": "Negrito",
            "bullet_list": "Lista com marcas",
            "code": "Código",
            "code_block": "Bloco de código",
            "heading": "Título",
            "italic": "Itálico",
            "link": "Ligação",
            "link_prompt": "Endereço da ligação (deixa vazio para remover a ligação)",
            "ordered_list": "Lista numerada",
            "strike": "Riscado",
            "task_list": "Lista de tarefas",
            "toolbar": "Formatação",
            "upload_failed": "Não foi possível carregar o ficheiro.",
            "uploading": "A carregar…"
          },
          "events": {
            "archived": "arquivou este cartão",
            "attached": "anexou %{filename}",
            "commented": "comentou",
            "created": "criou este cartão como %{number}",
            "moved": "moveu este cartão de %{from} para %{to}",
            "restored": "restaurou este cartão"
          },
          "footer": "Criado por %{name}, %{date}. Os números dos cartões nunca mudam, mesmo quando o cartão passa para outra lista.",
          "in": "em",
          "label_name": "Nome da etiqueta",
          "labels": "Etiquetas",
          "list": "Lista",
          "members": "Membros",
          "mention_label": "Membros do quadro",
          "new_checklist": "Nova lista de verificação",
          "new_label": "Nova etiqueta",
          "no_board_labels": "Este quadro ainda não tem etiquetas. Cria a primeira abaixo.",
          "no_board_members": "Este quadro ainda não tem membros.",
          "no_description": "Sem descrição.",
          "no_due": "Sem prazo",
          "no_labels": "Sem etiquetas",
          "no_members": "Sem membros",
          "paste_or_drop": "ou cola ou larga ficheiros no cartão",
          "preview": "Pré-visualizar",
          "preview_file": "Pré-visualizar %{file}",
          "remove": "Remover",
          "remove_checklist": "Remover a lista de verificação %{title}",
          "remove_checklist_confirm": "Remover a lista de verificação “%{title}” e os seus itens?",
          "remove_due": "Remover prazo",
          "remove_file": "Remover %{file}",
          "remove_file_confirm": "Remover %{file}?",
          "remove_item": "Remover o item %{item}",
          "save": "Guardar",
          "title": "Título do cartão",
          "uploaded_by": "%{name} · %{date}",
          "watch": "Seguir",
          "watching": "A seguir"
        }
      },
      "gmail_connections": {
        "callback": {
          "denied": "O Gmail não foi ligado.",
          "invalid_state": "O pedido de ligação expirou ou não é teu. Tenta ligar outra vez.",
          "success": "%{email} está ligada."
        },
        "destroy": {
          "success": "%{email} foi desligada."
        },
        "new": {
          "not_configured": "O início de sessão com Google não está configurado neste servidor, por isso ainda não é possível ligar o Gmail."
        },
        "update": {
          "success": "Guardado."
        }
      },
      "joins": {
        "already_member": "Já estás em %{workspace}.",
        "create": {
          "success": "Bem-vindo(a) a %{workspace}."
        },
        "show": {
          "back": "Ir para o Meerkeep Boards",
          "body": "%{name} convidou-te para trabalhares em quadros neste espaço de trabalho como %{role}.",
          "title": "Entrar em %{workspace}?"
        }
      },
      "labels": {
        "destroy": {
          "success": "%{name} eliminada."
        },
        "update": {
          "success": "Etiqueta atualizada."
        }
      },
      "my_tasks": {
        "column": {
          "done": "%{done} de %{total} concluídos",
          "empty": "Nada para entregar. Aproveite.",
          "today": "Hoje",
          "tomorrow": "Amanhã"
        },
        "complete": {
          "no_due_list": "Este cartão não tem coluna onde concluir a data limite."
        },
        "show": {
          "due_on": "para %{date}",
          "eyebrow": "%{date} · todos os quadros em %{workspace}",
          "move_to_today": "Mover para hoje",
          "open_calendar": "Abrir calendário",
          "overdue": {
            "one": "1 cartão está em atraso",
            "other": "%{count} cartões estão em atraso"
          },
          "scope_label": "Que cartões",
          "scopes": {
            "mine": "Atribuídos a mim",
            "watching": "Também a seguir"
          },
          "title": "As minhas tarefas"
        },
        "task": {
          "all_day": "Todo o dia",
          "checklist": "lista %{done}/%{total}",
          "complete": "Marcar %{number} como concluído",
          "done": "Concluído",
          "push": "Mover %{number} para %{day}"
        }
      },
      "people": {
        "index": {
          "clear_search": "Mostrar todos",
          "columns": {
            "actions": "Ações",
            "boards": "Quadros",
            "open_cards": "Cartões abertos",
            "person": "Pessoa",
            "role": "Papel"
          },
          "everyone": "Todos em %{workspace}",
          "eyebrow": "Espaço %{workspace} · %{people}",
          "no_results": "Ninguém corresponde a “%{query}”.",
          "people_count": {
            "one": "1 pessoa",
            "other": "%{count} pessoas"
          },
          "search": "Procurar pessoas",
          "search_placeholder": "Procurar pessoas…",
          "settings": "Definições do espaço",
          "title": "Pessoas"
        },
        "invite_card": {
          "boards": "Adicionar a quadros",
          "emails": "Endereços de email",
          "emails_placeholder": "nome@empresa.com, outro@empresa.com",
          "existing_hint": "Quem já está em %{workspace} pelo Meerkeep Time mantém a mesma conta e papel. Só escolhes os quadros.",
          "optional": "(opcional)",
          "role": "Papel",
          "send": "Enviar convites",
          "title": "Convidar para %{workspace}"
        },
        "membership": {
          "activate": "Ativar",
          "add_board": "+ Quadro",
          "add_to_board": "Adicionar %{name} a um quadro",
          "deactivate": "Desativar",
          "deactivate_confirm": "Desativar %{name}? Deixa de conseguir abrir %{workspace} até um dono o(a) voltar a ativar. A conta e os cartões ficam.",
          "inactive": "Inativo(a)",
          "leave_confirm": "Sair de %{workspace}? Perdes o acesso aos quadros.",
          "make": "Tornar %{role}",
          "open_cards": "%{count}",
          "overdue": {
            "one": "· 1 em atraso",
            "other": "· %{count} em atraso"
          },
          "remove": "Remover %{name} do espaço de trabalho",
          "remove_confirm": "Remover %{name} de %{workspace}? Também sai dos quadros e dos cartões.",
          "role_for": "Papel de %{name}: %{role}. Alterar papel"
        },
        "roles_card": {
          "admin": "Cria, arquiva e elimina quadros, gere etiquetas e pessoas, e vê todos os quadros.",
          "member": "Trabalha nos quadros a que foi adicionado: cria, move e comenta cartões.",
          "owner": "Tudo o que um admin pode, mais faturação, nomear admins e eliminar o espaço de trabalho.",
          "title": "Papéis num espaço de trabalho"
        }
      },
      "shared": {
        "nav": {
          "all_boards": "Todos os quadros",
          "assistant": "Assistente",
          "assistant_pending": {
            "one": "sugestão à espera",
            "other": "sugestões à espera"
          },
          "calendar": "Calendário",
          "manage": "Gerir",
          "my_tasks": "As minhas tarefas",
          "my_tasks_open": {
            "one": "cartão por fazer",
            "other": "cartões por fazer"
          },
          "new_board": "Novo quadro",
          "people": "Pessoas",
          "plan": "Planear",
          "settings": "Definições",
          "starred": "Quadros favoritos"
        }
      },
      "workspace_invitations": {
        "added": "%{emails} adicionado(s) ao espaço de trabalho.",
        "invited": "Convite enviado para %{emails}."
      },
      "workspace_memberships": {
        "activate": {
          "success": "%{name} ativado(a)."
        },
        "deactivate": {
          "success": "%{name} desativado(a)."
        },
        "destroy": {
          "success": "%{name} removido(a) do espaço de trabalho."
        },
        "update": {
          "success": "Papel de %{name} atualizado."
        }
      },
      "workspaces": {
        "create": {
          "success": "Espaço de trabalho criado."
        },
        "destroy": {
          "success": "Espaço de trabalho eliminado."
        },
        "edit": {
          "card_numbers": "Números dos cartões",
          "card_numbers_hint": "Os novos quadros usam isto. Cada quadro pode mudá-lo nas suas definições.",
          "danger": "Eliminar espaço de trabalho",
          "danger_hint": "Isto remove todos os quadros, cartões, clientes, projetos e registos de tempo, para todos.",
          "delete": "Eliminar espaço de trabalho",
          "delete_confirm": "Eliminar %{workspace}? Isto remove todos os quadros, cartões, clientes, projetos e registos de tempo, para todos. Não pode ser anulado.",
          "eyebrow": "Espaço %{workspace}",
          "formats": {
            "hash": "#142, só o número",
            "key": "MKT-142, chave do quadro e número"
          },
          "general": "Geral",
          "name": "Nome do espaço de trabalho",
          "save": "Guardar alterações",
          "title": "Definições do espaço de trabalho"
        },
        "new": {
          "heading": "A casa da tua equipa",
          "hint": "Tudo no Meerkeep Boards — pessoas e quadros — vive dentro de um espaço de trabalho.",
          "name_placeholder": "ex. Empresa Fantástica",
          "submit": "Criar espaço de trabalho",
          "title": "Criar um espaço de trabalho"
        },
        "update": {
          "success": "Guardado."
        }
      }
    },
    "brand": {
      "name": "Meerkeep",
      "tagline": "Uma conta. Três ferramentas para fazer as coisas em conjunto.",
      "wordmark": "meerkeep"
    },
    "card_mailer": {
      "comment": {
        "body": "%{author} comentou em %{number} %{title} no quadro %{board}:",
        "hello": "Olá %{name},",
        "open": "Abrir o cartão",
        "subject": "%{author} comentou em %{number} %{title}"
      },
      "mention": {
        "body": "%{author} mencionou-te num comentário em %{number} %{title} no quadro %{board}:",
        "hello": "Olá %{name},",
        "open": "Abrir o cartão",
        "subject": "%{author} mencionou-te em %{number} %{title}"
      }
    },
    "colors": {
      "blue": "Azul",
      "blue_light": "Azul claro",
      "green": "Verde",
      "green_light": "Verde claro",
      "orange": "Laranja",
      "orange_light": "Laranja claro",
      "pink": "Rosa",
      "pink_light": "Rosa claro",
      "red": "Vermelho",
      "red_light": "Vermelho claro",
      "sky": "Céu",
      "sky_light": "Céu claro",
      "slate": "Ardósia",
      "slate_light": "Ardósia claro",
      "teal": "Verde-azulado",
      "teal_light": "Verde-azulado claro",
      "violet": "Violeta",
      "violet_light": "Violeta claro",
      "yellow": "Amarelo",
      "yellow_light": "Amarelo claro"
    },
    "common": {
      "you": "Tu"
    },
    "controllers": {
      "create_error": "Ocorreu um erro ao criar %{model}. Por favor, tente mais tarde.",
      "created": "%{model} foi criado com sucesso.",
      "destroy_error": "Ocorreu um erro ao apagar %{model}. Por favor, tente mais tarde.",
      "destroyed": "%{model} foi apagado com sucesso.",
      "not_authorized": "Não tens permissão para fazer isso.",
      "updated": "%{model} foi actualizado com sucesso."
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "day_names": [
        "domingo",
        "segunda-feira",
        "terça-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "sábado"
      ],
      "formats": {
        "day_heading": "%A, %-d de %B",
        "day_month": "%-d %b",
        "day_month_year": "%-d %b %Y",
        "default": "%d/%m/%Y",
        "long": "%d de %B de %Y",
        "month": "%b",
        "month_short_year": "%b %Y",
        "month_year": "%B %Y",
        "short": "%d de %B",
        "short_day": "%a %-d %b",
        "weekday": "%a",
        "weekday_day_month": "%a %-d %b"
      },
      "month_names": [
        null,
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "aproximadamente %{count} hora",
          "other": "aproximadamente %{count} horas"
        },
        "about_x_months": {
          "one": "aproximadamente %{count} mês",
          "other": "aproximadamente %{count} meses"
        },
        "about_x_years": {
          "one": "aproximadamente %{count} ano",
          "other": "aproximadamente %{count} anos"
        },
        "almost_x_years": {
          "one": "quase %{count} ano",
          "other": "quase %{count} anos"
        },
        "half_a_minute": "meio minuto",
        "less_than_x_minutes": {
          "one": "menos de um minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "mais de %{count} ano",
          "other": "mais de %{count} anos"
        },
        "x_days": {
          "one": "%{count} dia",
          "other": "%{count} dias"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mês",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} ano",
          "other": "%{count} anos"
        }
      },
      "prompts": {
        "day": "Dia",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mês",
        "second": "Segundo",
        "year": "Ano"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "A sua conta foi confirmada com sucesso.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instruções de confirmação"
        },
        "send_instructions": "Dentro de alguns minutos irá receber um email com instruções para confirmar a sua conta.",
        "send_paranoid_instructions": "Se o seu email existir na nossa base de dados, irá receber dentro de alguns minutos um email com instruções para confirmar a sua conta."
      },
      "failure": {
        "already_authenticated": "Já se encontra autenticado.",
        "inactive": "A sua conta ainda não foi ativada.",
        "invalid": "%{authentication_keys} ou palavra-passe inválidos.",
        "invited": "Você tem um convite pendente, aceite para finalizar sua conta.",
        "last_attempt": "Tem mais uma tentativa antes da sua conta ser bloqueada.",
        "locked": "A sua conta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} ou palavra-passe inválidos.",
        "timeout": "A sua sessão expirou, por favor autentique-se novamente para continuar.",
        "unauthenticated": "Antes de continuar tem de se autenticar ou efetuar um registo.",
        "unconfirmed": "Tem de confirmar a sua conta antes de continuar."
      },
      "invitations": {
        "edit": {
          "header": "Escolha sua senha",
          "submit_button": "Atualizar minha senha"
        },
        "invitation_removed": "Seu convite foi removido.",
        "invitation_token_invalid": "O código do convite não é válido!",
        "new": {
          "header": "Enviar convite",
          "submit_button": "Enviar um convite"
        },
        "no_invitations_remaining": "Sem convites pendentes",
        "send_instructions": "Um email de convite foi enviado para %{email}.",
        "updated": "Sua senha foi atualizada com sucesso. Você está autenticado agora."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar a minha conta",
          "confirm_account_link": "Confirme conta",
          "confirm_link_msg": "Você pode confirmar a sua conta de e-mail através do link abaixo :",
          "greeting": "Bem-vindo %{recipient}!",
          "instruction": "Pode confirmar a sua conta através do link:",
          "subject": "Instruções de confirmação"
        },
        "email_changed": {
          "greeting": "Olá %{recipient}!",
          "message": "Estamos a entrar em contacto para notificar que o seu endereço de email foi alterado para %{email}.",
          "message_unconfirmed": null,
          "subject": "Endereço de email alterado"
        },
        "invitation_instructions": {
          "accept": "Aceitar convite",
          "hello": "Olá %{email}",
          "ignore": "Se você não quer aceitar esse convite, por favor ignore esse e-mail.<br />Sua conta não será criada até você acessar o link abaixo e escolher sua senha.",
          "someone_invited_you": "Alguém convidou você para acessar %{url}, você pode aceitar o convite através do link abaixo.",
          "subject": "Instruções do convite"
        },
        "password_change": {
          "greeting": "Olá %{recipient}!",
          "message": "Estamos a entrar em contacto para notificar que a sua palavra-passe foi alterada.",
          "subject": "Palavra-passe alterada"
        },
        "reset_password_instructions": {
          "action": "Repor a minha palavra-passe",
          "greeting": "Olá %{recipient}!",
          "ignore_mail_msg": "Se você não pediu isso, por favor, ignore este e-mail.",
          "instruction": "Foi efetuado um pedido para repor a sua palavra-passe. Para prosseguir clique no link abaixo.",
          "instruction_2": "Se não fez este pedido, por favor ignore este e-mail.",
          "instruction_3": "A sua palavra-passe só será alterada quando aceder ao link abaixo para a alterar.",
          "no_changes_msg": "Sua senha não será alterada até que você acessar o link acima e criar um novo.",
          "password_change_link": "Alterar a senha",
          "request_reset_link_msg": "Alguém pediu um link para mudar sua senha. Você pode fazer isso através do link abaixo ",
          "subject": "Instruções para redefinir sua senha"
        },
        "unlock_instructions": {
          "account_lock_msg": "A sua conta foi bloqueada devido a um número excessivo de sinal de sucesso em tentativas.",
          "action": "Desbloquear a minha conta",
          "greeting": "Olá %{recipient}!",
          "instruction": "Clique no seguinte link para desbloquear a sua conta:",
          "message": "A sua conta foi bloqueada devido a um número excessivo de tentativas de acesso inválidas.",
          "subject": "Instruções de desbloqueio",
          "unlock_link": "Desbloquear minha conta",
          "unlock_link_msg": "Clique no link abaixo para desbloquear sua conta:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Não foi possível autenticar a sua conta por %{kind} porque \"%{reason}\".",
        "success": "A sua conta foi autenticada por %{kind} com sucesso."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Alterar a minha palavra-passe",
          "change_your_password": "Altere a sua palavra-passe",
          "confirm_new_password": "Confirme a nova palavra-passe",
          "new_password": "Nova palavra-passe"
        },
        "new": {
          "forgot_your_password": "Esqueceu a sua palavra-passe?",
          "send_me_reset_password_instructions": "Enviar-me instruções para repor a palavra-passe"
        },
        "no_token": "Não pode aceder a esta página sem vir do email de recuperação da palavra-passe. Se vem de um email para recuperar a palavra-passe, por favor certifique-se que usou o URL completo que foi enviado.",
        "send_instructions": "Dentro de alguns minutos irá receber um email com instruções de reinicialização da palavra-passe.",
        "send_paranoid_instructions": "Se o seu e-mail existir na nossa base de dados, irá receber dentro de alguns minutos um e-mail com instruções para recuperar a sua palavra-passe.",
        "updated": "A sua palavra-passe foi alterada com sucesso. Agora está autenticado.",
        "updated_not_active": "A sua password foi alterada com sucesso."
      },
      "registrations": {
        "destroyed": "A sua conta foi cancelada com sucesso.",
        "edit": {
          "are_you_sure": "Tem a certeza?",
          "cancel_my_account": "Cancelar a minha conta",
          "currently_waiting_confirmation_for_email": "A aguardar a confirmação de: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "deixe em branco caso não queira alterar",
          "title": "Editar %{resource}",
          "unhappy": "Descontente?",
          "update": "Atualizar",
          "we_need_your_current_password_to_confirm_your_changes": "precisamos da sua palavra-passe atual para confirmar as alterações"
        },
        "new": {
          "sign_up": "Criar Conta"
        },
        "signed_up": "Bemvindo! A autenticação foi efetuada com sucesso.",
        "signed_up_but_inactive": "Registou-se com sucesso. No entanto, não podemos iniciar a sua sessão porque ainda não confirmou a sua conta.",
        "signed_up_but_locked": "Registou-se com sucesso. No entanto, não podemos iniciar a sua sessão porque a sua conta encontra-se bloqueada.",
        "signed_up_but_unconfirmed": "Foi enviado um email com um link para confirmar o seu email. Por favor abra o link para ativar a sua conta.",
        "update_needs_confirmation": "A sua conta foi atualizada com sucesso, mas precisamos de confirmar o seu email. Por favor veja o seu email e clique no link para finalizar a confirmação do seu email.",
        "updated": "A sua conta foi atualizada com sucesso.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Sessão terminada com sucesso.",
        "new": {
          "sign_in": "Entrar"
        },
        "signed_in": "Autenticação efetuada com sucesso.",
        "signed_out": "Saiu da sessão com sucesso."
      },
      "shared": {
        "links": {
          "back": "Voltar",
          "didn_t_receive_confirmation_instructions": "Não recebeu instruções de confirmação?",
          "didn_t_receive_unlock_instructions": "Não recebeu instruções de desbloqueio?",
          "forgot_your_password": "Esqueceu a palavra-passe?",
          "sign_in": "Login",
          "sign_in_with_provider": "Entrar com %{provider}",
          "sign_up": "Criar conta"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instruções de desbloqueio"
        },
        "send_instructions": "Dentro de alguns minutos irá receber um email com as instruções para desbloquear a sua conta.",
        "send_paranoid_instructions": "Se a sua conta existir, irá receber dentro de alguns minutos um email com instruções para a desbloquear.",
        "unlocked": "A sua conta foi desbloqueada com sucesso. Por favor autentique-se para continuar."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Redirecionamento para '%{redirect_url}' não permitido."
      },
      "passwords": {
        "missing_email": "Informe o endereço de e-mail.",
        "missing_passwords": "Preencha a senha e a confirmação de senha.",
        "missing_redirect_url": "URL para redirecionamento não informada.",
        "not_allowed_redirect_url": "Redirecionamento para '%{redirect_url}' não permitido.",
        "password_not_required": "Esta conta não necessita de uma senha. Faça login utilizando '%{provider}'.",
        "sended": "Você receberá um e-mail com instruções sobre como redefinir sua senha.",
        "successfully_updated": "Senha atualizada com sucesso.",
        "user_not_found": "Não existe um utilizador com o e-mail '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Não foi possível encontrar a conta para exclusão.",
        "account_with_uid_destroyed": "A conta com uid '%{uid}' foi excluída.",
        "email_already_exists": "Já existe uma conta com o email '%{email}'.",
        "missing_confirm_success_url": "Parâmetro 'confirm_success_url' não informado.",
        "redirect_url_not_allowed": "Redirecionamento para '%{redirect_url}' não permitido.",
        "user_not_found": "Utilizador não encontrado."
      },
      "sessions": {
        "bad_credentials": "E-mail ou senha inválidos.",
        "not_confirmed": "Uma mensagem com um link de confirmação foi enviado para seu endereço de e-mail. Você precisa confirmar sua conta antes de continuar.",
        "not_supported": "Use POST /sign_in para efetuar o login. GET não é suportado.",
        "user_not_found": "Utilizador não existe ou não está logado."
      },
      "token_validations": {
        "invalid": "Dados de login inválidos."
      }
    },
    "doorkeeper": {
      "authorizations": {
        "buttons": {
          "authorize": "Autorizar",
          "deny": "Recusar"
        },
        "error": {
          "title": "Ocorreu um erro"
        },
        "form_post": {
          "title": "Submeter este formulário"
        },
        "new": {
          "able_to": "Esta aplicação poderá:",
          "prompt": "Autorizar %{client_name} a usar a sua conta?",
          "title": "Autorização necessária"
        },
        "show": {
          "title": "Código de autorização:"
        }
      },
      "errors": {
        "messages": {
          "access_denied": "O titular do recurso ou o servidor de autorização recusou o pedido.",
          "admin_authenticator_not_configured": "O acesso ao painel de administração está proibido porque Doorkeeper.configure.admin_authenticator não está configurado.",
          "credential_flow_not_configured": "O fluxo Resource Owner Password Credentials falhou porque Doorkeeper.configure.resource_owner_from_credentials não está configurado.",
          "forbidden_token": {
            "missing_scope": "O acesso a este recurso requer o âmbito \"%{oauth_scopes}\"."
          },
          "invalid_client": "A autenticação do cliente falhou: cliente desconhecido, sem autenticação ou com um método não suportado.",
          "invalid_code_challenge_method": {
            "one": "O code_challenge_method tem de ser %{challenge_methods}.",
            "other": "O code_challenge_method tem de ser um de %{challenge_methods}.",
            "zero": "O servidor de autorização não suporta PKCE porque não aceita nenhum code_challenge_method."
          },
          "invalid_grant": "A autorização fornecida é inválida, expirou, foi revogada, não corresponde ao URI de redirecionamento usado no pedido ou foi emitida para outro cliente.",
          "invalid_redirect_uri": "O URI de redirecionamento pedido está malformado ou não corresponde ao do cliente.",
          "invalid_request": {
            "invalid_code_challenge": "O code challenge é obrigatório.",
            "missing_param": "Falta o parâmetro obrigatório: %{value}.",
            "multiple_client_auth_methods": "O pedido usa mais do que um mecanismo de autenticação do cliente.",
            "request_not_authorized": "O pedido tem de ser autorizado. Falta ou é inválido o parâmetro que o autoriza.",
            "unknown": "Falta um parâmetro obrigatório ao pedido, inclui um valor não suportado ou está malformado."
          },
          "invalid_scope": "O âmbito pedido é inválido, desconhecido ou malformado.",
          "invalid_token": {
            "expired": "O token de acesso expirou",
            "revoked": "O token de acesso foi revogado",
            "unknown": "O token de acesso é inválido"
          },
          "resource_owner_authenticator_not_configured": "Não foi possível encontrar o titular do recurso porque Doorkeeper.configure.resource_owner_authenticator não está configurado.",
          "revoke": {
            "unauthorized": "Não tem autorização para revogar este token"
          },
          "server_error": "O servidor de autorização encontrou uma condição inesperada que o impediu de responder ao pedido.",
          "temporarily_unavailable": "O servidor de autorização não consegue responder de momento por sobrecarga ou manutenção.",
          "unauthorized_client": "O cliente não está autorizado a fazer este pedido com este método.",
          "unsupported_grant_type": "O tipo de autorização não é suportado pelo servidor de autorização.",
          "unsupported_response_mode": "O servidor de autorização não suporta este modo de resposta.",
          "unsupported_response_type": "O servidor de autorização não suporta este tipo de resposta."
        }
      },
      "layouts": {
        "application": {
          "title": "Autorização OAuth necessária"
        }
      },
      "pre_authorization": {
        "status": "Pré-autorização"
      },
      "scopes": {
        "boards": "Ver e gerir os seus quadros: quadros, listas e cartões em todos os espaços de trabalho a que pertence"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "tem de ser aceite",
        "already_confirmed": "já foi confirmado, por favor tente efetuar a autenticação",
        "blank": "não pode estar em branco",
        "confirmation": "não coincide com a confirmação",
        "confirmation_period_expired": "necessitava de confirmação até %{period}, por favor faça um novo pedido",
        "empty": "não pode estar vazio",
        "equal_to": "tem de ser igual a %{count}",
        "even": "tem de ser par",
        "exclusion": "é reservado",
        "expired": "expirou, por favor solicite um novo",
        "greater_than": "tem de ser maior que %{count}",
        "greater_than_or_equal_to": "tem de ser maior ou igual a %{count}",
        "in": "deve estar em %{count}",
        "inclusion": "não está incluído na lista",
        "invalid": "é inválido",
        "less_than": "tem de ser menor que %{count}",
        "less_than_or_equal_to": "tem de ser menor ou igual a %{count}",
        "model_invalid": "A validação falhou: %{errors}",
        "not_a_number": "não é um número",
        "not_an_integer": "tem de ser um inteiro",
        "not_email": "não é um e-mail",
        "not_found": "não foi encontrado",
        "not_locked": "não foi bloqueado",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "tem de ser ímpar",
        "other_than": "tem de ser diferente de %{count}",
        "password_too_long": "é muita longa",
        "present": "não pode estar em branco",
        "required": "é obrigatório",
        "taken": "não está disponível",
        "too_long": "é demasiado grande (o máximo é de %{count} caracteres)",
        "too_short": "é demasiado pequeno (o mínimo é de %{count} caracteres)",
        "validate_account_update_params": "Os dados submetidos para atualização de conta são inválidos.",
        "validate_sign_up_params": "Os dados submetidos na requisição de registo são inválidos.",
        "wrong_length": "comprimento errado (deve ter %{count} caracteres)"
      },
      "template": {
        "body": "Por favor, verifique os seguintes campos:",
        "header": {
          "one": "%{count} erro impediu guardar este %{model}",
          "other": "%{count} erros impediram guardar este %{model}"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#####",
          "####",
          "###"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Abrantes",
          "Agualva-Cacém",
          "Águeda",
          "Albergaria-a-Velha",
          "Albufeira",
          "Alcácer do Sal",
          "Alcobaça",
          "Alfena",
          "Almada",
          "Almeirim",
          "Alverca do Ribatejo",
          "Amadora",
          "Amarante",
          "Amora",
          "Anadia",
          "Angra do Heroísmo",
          "Aveiro",
          "Barcelos",
          "Barreiro",
          "Beja",
          "Borba",
          "Braga",
          "Bragança",
          "Caldas da Rainha",
          "Câmara de Lobos",
          "Caniço",
          "Cantanhede",
          "Cartaxo",
          "Castelo Branco",
          "Chaves",
          "Coimbra",
          "Costa da Caparica",
          "Covilhã",
          "Elvas",
          "Entroncamento",
          "Ermesinde",
          "Esmoriz",
          "Espinho",
          "Esposende",
          "Estarreja",
          "Estremoz",
          "Évora",
          "Fafe",
          "Faro",
          "Fátima",
          "Felgueiras",
          "Figueira da Foz",
          "Fiães",
          "Freamunde",
          "Funchal",
          "Fundão",
          "Gafanha da Nazaré",
          "Gandra",
          "Gondomar",
          "Gouveia",
          "Guarda",
          "Guimarães",
          "Horta",
          "Ílhavo",
          "Lagoa",
          "Lagoa",
          "Lagos",
          "Lamego",
          "Leiria",
          "Lisboa",
          "Lixa",
          "Loulé",
          "Loures",
          "Lourosa",
          "Macedo de Cavaleiros",
          "Machico",
          "Maia",
          "Mangualde",
          "Marco de Canaveses",
          "Marinha Grande",
          "Matosinhos",
          "Mealhada",
          "Mêda",
          "Miranda do Douro / Miranda de l Douro",
          "Mirandela",
          "Montemor-o-Novo",
          "Montijo",
          "Moura",
          "Odivelas",
          "Olhão da Restauração",
          "Oliveira de Azeméis",
          "Oliveira do Bairro",
          "Oliveira do Hospital",
          "Ourém",
          "Ovar",
          "Paços de Ferreira",
          "Paredes",
          "Penafiel",
          "Peniche",
          "Peso da Régua",
          "Pinhel",
          "Pombal",
          "Ponta Delgada",
          "Ponte de Sor",
          "Portalegre",
          "Portimão",
          "Porto",
          "Póvoa de Santa Iria",
          "Póvoa de Varzim",
          "Praia da Vitória",
          "Quarteira",
          "Queluz",
          "Rebordosa",
          "Reguengos de Monsaraz",
          "Ribeira Grande",
          "Rio Maior",
          "Rio Tinto",
          "Sabugal",
          "Sacavém",
          "Samora Correia",
          "Santa Comba Dão",
          "Santa Cruz",
          "Santa Maria da Feira",
          "Santana",
          "Santarém",
          "Santiago do Cacém",
          "Santo Tirso",
          "São João da Madeira",
          "São Mamede de Infesta",
          "São Pedro do Sul",
          "Lordelo",
          "Seia",
          "Seixal",
          "Senhora da Hora",
          "Serpa",
          "Setúbal",
          "Silves",
          "Sines",
          "Tarouca",
          "Tavira",
          "Tomar",
          "Tondela",
          "Torres Novas",
          "Torres Vedras",
          "Trancoso",
          "Trofa",
          "Valbom",
          "Vale de Cambra",
          "Valença",
          "Valongo",
          "Valpaços",
          "Vendas Novas",
          "Viana do Castelo",
          "Vila Baleira",
          "Vila do Conde",
          "Vila Franca de Xira",
          "Vila Nova de Famalicão",
          "Vila Nova de Foz Côa",
          "Vila Nova de Gaia",
          "Vila Nova de Santo André",
          "Vila Real",
          "Vila Real de Santo António",
          "Viseu",
          "Vizela"
        ],
        "city_prefix": [],
        "city_suffix": [],
        "country": [
          "Afeganistão",
          "Albânia",
          "Algéria",
          "Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antigua and Barbada",
          "Argentina",
          "Armênia",
          "Aruba",
          "Austrália",
          "Áustria",
          "Alzerbajão",
          "Bahamas",
          "Barém",
          "Bangladesh",
          "Barbado",
          "Belgrado",
          "Bélgica",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolívia",
          "Bôsnia",
          "Botuasuna",
          "Bouvetoia",
          "Brasil",
          "Arquipélago de Chagos",
          "Ilhas Virgens",
          "Brunei",
          "Bulgária",
          "Burkina Faso",
          "Burundi",
          "Cambójia",
          "Camarões",
          "Canadá",
          "Cabo Verde",
          "Ilhas Caiman",
          "República da África Central",
          "Chad",
          "Chile",
          "China",
          "Ilhas Natal",
          "Ilhas Cocos",
          "Colômbia",
          "Comoros",
          "Congo",
          "Ilhas Cook",
          "Costa Rica",
          "Costa do Marfim",
          "Croácia",
          "Cuba",
          "Cyprus",
          "República Tcheca",
          "Dinamarca",
          "Djibouti",
          "Dominica",
          "República Dominicana",
          "Equador",
          "Egito",
          "El Salvador",
          "Guiné Equatorial",
          "Eritrea",
          "Estônia",
          "Etiópia",
          "Ilhas Faroe",
          "Malvinas",
          "Fiji",
          "Finlândia",
          "França",
          "Guiné Francesa",
          "Polinésia Francesa",
          "Gabão",
          "Gâmbia",
          "Georgia",
          "Alemanha",
          "Gana",
          "Gibraltar",
          "Grécia",
          "Groelândia",
          "Granada",
          "Guadalupe",
          "Guano",
          "Guatemala",
          "Guernsey",
          "Guiné",
          "Guiné-Bissau",
          "Guiana",
          "Haiti",
          "Heard Island and McDonald Islands",
          "Vaticano",
          "Honduras",
          "Hong Kong",
          "Hungria",
          "Iceland",
          "Índia",
          "Indonésia",
          "Irã",
          "Iraque",
          "Irlanda",
          "Ilha de Man",
          "Israel",
          "Itália",
          "Jamaica",
          "Japão",
          "Jersey",
          "Jordânia",
          "Cazaquistão",
          "Quênia",
          "Kiribati",
          "Coreia do Norte",
          "Coreia do Sul",
          "Kuwait",
          "Kyrgyz Republic",
          "República Democrática de Lao People",
          "Latvia",
          "Líbano",
          "Lesotho",
          "Libéria",
          "Libyan Arab Jamahiriya",
          "Liechtenstein",
          "Lituânia",
          "Luxemburgo",
          "Macao",
          "Macedônia",
          "Madagascar",
          "Malawi",
          "Malásia",
          "Maldives",
          "Mali",
          "Malta",
          "Ilhas Marshall",
          "Martinica",
          "Mauritânia",
          "Mauritius",
          "Mayotte",
          "México",
          "Micronésia",
          "Moldova",
          "Mônaco",
          "Mongólia",
          "Montenegro",
          "Montserrat",
          "Marrocos",
          "Moçambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Antilhas Holandesas",
          "Holanda",
          "Nova Caledonia",
          "Nova Zelândia",
          "Nicarágua",
          "Nigéria",
          "Niue",
          "Ilha Norfolk",
          "Northern Mariana Islands",
          "Noruega",
          "Oman",
          "Paquistão",
          "Palau",
          "Território da Palestina",
          "Panamá",
          "Nova Guiné Papua",
          "Paraguai",
          "Peru",
          "Filipinas",
          "Polônia",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Romênia",
          "Rússia",
          "Ruanda",
          "São Bartolomeu",
          "Santa Helena",
          "Santa Lúcia",
          "Saint Martin",
          "Saint Pierre and Miquelon",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tomé e Príncipe",
          "Arábia Saudita",
          "Senegal",
          "Sérvia",
          "Seychelles",
          "Serra Leoa",
          "Singapura",
          "Eslováquia",
          "Eslovênia",
          "Ilhas Salomão",
          "Somália",
          "África do Sul",
          "South Georgia and the South Sandwich Islands",
          "Spanha",
          "Sri Lanka",
          "Sudão",
          "Suriname",
          "Svalbard & Jan Mayen Islands",
          "Swaziland",
          "Suécia",
          "Suíça",
          "Síria",
          "Taiwan",
          "Tajiquistão",
          "Tanzânia",
          "Tailândia",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidá e Tobago",
          "Tunísia",
          "Turquia",
          "Turcomenistão",
          "Turks and Caicos Islands",
          "Tuvalu",
          "Uganda",
          "Ucrânia",
          "Emirados Árabes Unidos",
          "Reino Unido",
          "Estados Unidos da América",
          "Estados Unidos das Ilhas Virgens",
          "Uruguai",
          "Uzbequistão",
          "Vanuatu",
          "Venezuela",
          "Vietnã",
          "Wallis and Futuna",
          "Sahara",
          "Yemen",
          "Zâmbia",
          "Zimbábue"
        ],
        "default_country": [
          "Portugal"
        ],
        "default_country_code": [
          "PT"
        ],
        "postcode": [
          "####"
        ],
        "secondary_address": [
          "Apto. ###",
          "Sobrado ##",
          "Casa #",
          "Lote ##",
          "Quadra ##"
        ],
        "state": [
          "Lisboa",
          "Leiria",
          "Santarém",
          "Setúbal",
          "Beja",
          "Faro",
          "Évora",
          "Portalegre",
          "Castelo Branco",
          "Guarda",
          "Coimbra",
          "Aveiro",
          "Viseu",
          "Bragança",
          "Vila Real",
          "Porto",
          "Braga",
          "Viana do Castelo"
        ],
        "street_suffix": [
          "Rua",
          "Avenida",
          "Travessa",
          "Ponté",
          "Alameda",
          "Marginal",
          "Viela",
          "Rodovia"
        ]
      },
      "company": {
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} e #{Name.last_name}"
        ],
        "suffix": [
          "S.A.",
          "LTDA",
          "e Associados",
          "Comércio",
          "EIRELI"
        ]
      },
      "internet": {
        "domain_suffix": [
          "pt",
          "com",
          "biz",
          "info",
          "net",
          "org"
        ]
      },
      "lorem": {
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "name": {
        "first_name": [
          "Águeda",
          "Amélia",
          "Ângela",
          "Alessandro",
          "Alessandra",
          "Alexandre",
          "Aline",
          "Antônio",
          "Breno",
          "Bruna",
          "Carlos",
          "Carla",
          "Célia",
          "Cecília",
          "César",
          "Danilo",
          "Dalila",
          "Deneval",
          "Eduardo",
          "Eduarda",
          "Esther",
          "Elísio",
          "Fábio",
          "Fabrício",
          "Fabrícia",
          "Félix",
          "Felícia",
          "Feliciano",
          "Frederico",
          "Fabiano",
          "Gustavo",
          "Guilherme",
          "Gúbio",
          "Heitor",
          "Hélio",
          "Hugo",
          "Isabel",
          "Isabela",
          "Ígor",
          "João",
          "Joana",
          "Júlio César",
          "Júlio",
          "Júlia",
          "Janaína",
          "Karla",
          "Kléber",
          "Lucas",
          "Lorena",
          "Lorraine",
          "Larissa",
          "Ladislau",
          "Marcos",
          "Meire",
          "Marcelo",
          "Marcela",
          "Margarida",
          "Mércia",
          "Márcia",
          "Marli",
          "Morgana",
          "Maria",
          "Norberto",
          "Natália",
          "Nataniel",
          "Núbia",
          "Ofélia",
          "Paulo",
          "Paula",
          "Pablo",
          "Pedro",
          "Raul",
          "Rafael",
          "Rafaela",
          "Ricardo",
          "Roberto",
          "Roberta",
          "Sílvia",
          "Sílvia",
          "Silas",
          "Simão",
          "Suélen",
          "Sara",
          "Salvador",
          "Sirineu",
          "Talita",
          "Tertuliano",
          "Vicente",
          "Víctor",
          "Vitória",
          "Yango",
          "Yago",
          "Yuri",
          "Washington",
          "Warley"
        ],
        "last_name": [
          "Araújo",
          "D'cruze",
          "Estéves",
          "Silva",
          "Souza",
          "Carvalho",
          "Santos",
          "Reis",
          "Xavier",
          "Franco",
          "Braga",
          "Macedo",
          "Batista",
          "Barros",
          "Moraes",
          "Costa",
          "Pereira",
          "Carvalho",
          "Melo",
          "Lemos",
          "Saraiva",
          "Nogueira",
          "Oliveira",
          "Martins",
          "Moreira",
          "Albuquerque"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Sr.",
          "Sra.",
          "Srta.",
          "Dr.",
          "Eng."
        ],
        "suffix": [
          "Jr.",
          "Neto",
          "Filho"
        ]
      },
      "phone_number": {
        "country_code": [
          "351"
        ],
        "formats": [
          "(##) ###-####",
          "(##) ###-####",
          "884 ###-###"
        ]
      }
    },
    "gdpr": {
      "controllers": {
        "accept_cookies_error": "Algo correu mal",
        "create_error": "Precisa de aceitar todos os consentimentos"
      },
      "views": {
        "cookies_disclaimer": {
          "accept": "Aceitar",
          "learn_more": "Ver Política de Cookies",
          "text": "O Meerkeep usa apenas os cookies de que precisa para funcionar: para manter a tua sessão e lembrar o teu idioma. Sem cookies de estatísticas nem de publicidade.\n"
        },
        "missing": {
          "accept_html": "Li e aceito: %{consent}",
          "intro": "Antes de continuar é necessário aceitar os seguintes consentimentos",
          "submit": "Aceitar Selecionados",
          "title": "Consentimentos Por Aceitar"
        }
      }
    },
    "group_invitation_mailer": {
      "invite": {
        "body": "%{name} convidou-te para o grupo %{group} no Meerkeep, para partilharem lembretes.",
        "hello": "Olá,",
        "ignore": "Se não estavas à espera deste email, podes ignorá-lo.",
        "join": "Entrar no grupo",
        "subject": "%{name} convidou-te para %{group} no Meerkeep"
      }
    },
    "hello": "olá",
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "create": "Criar %{model}",
        "submit": "Gravar %{model}",
        "update": "Atualizar %{model}"
      },
      "yes_no": {
        "no": "Não",
        "yes": "Sim"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "ª": "a",
          "º": "o",
          "À": "A",
          "Á": "A",
          "Ã": "A",
          "Æ": "Ae",
          "É": "E",
          "Ê": "E",
          "Í": "I",
          "Ó": "O",
          "Õ": "O",
          "Ú": "U",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "æ": "ae",
          "ç": "c",
          "é": "e",
          "ê": "e",
          "í": "i",
          "ó": "o",
          "õ": "o",
          "ú": "u"
        }
      }
    },
    "landing": {
      "index": {
        "coming_soon": "Em breve",
        "headline": "Uma conta. Três ferramentas para fazer as coisas em conjunto.",
        "open_tool": "Abrir %{tool}",
        "signed_in_as": "Sessão iniciada como %{name}",
        "subline": "Escolhe uma ferramenta para começar. O mesmo login funciona em todas.",
        "title": "Início"
      }
    },
    "layouts": {
      "app": {
        "close_menu": "Fechar menu",
        "open_menu": "Abrir menu",
        "settings": "Definições",
        "skip_to_content": "Saltar para o conteúdo",
        "tool_launcher": {
          "account": "Conta",
          "open": "Mudar de ferramenta",
          "title": "Ferramentas Meerkeep"
        },
        "your_account": "A tua conta"
      },
      "auth": {
        "headline": "Uma conta. Três ferramentas para fazer as coisas em conjunto.",
        "made_in": "Feito em Coimbra."
      }
    },
    "middleware": {
      "apple_form_post_callback": {
        "continue": "Continuar"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "mil milhões",
              "other": "mil milhões"
            },
            "million": {
              "one": "milhão",
              "other": "milhões"
            },
            "quadrillion": {
              "one": "mil biliões",
              "other": "mil biliões"
            },
            "thousand": "mil",
            "trillion": {
              "one": "bilião",
              "other": "biliões"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "oauth": {
      "authorizations": {
        "new": {
          "able_to": "Poderá:",
          "prompt_html": "%{client_name} está a pedir acesso à sua conta Meerkeep.",
          "signed_in_as_html": "Tem sessão iniciada como %{name} (%{email}).",
          "title": "Ligar ao Meerkeep"
        }
      },
      "registrations": {
        "unnamed_client": "Cliente sem nome"
      }
    },
    "push": {
      "due": {
        "body": "Para as %{time}"
      },
      "nudge": {
        "title": "%{name} deu-te um toque"
      }
    },
    "reminders": {
      "group_invitations": {
        "create": {
          "success": "Convite enviado para %{email}."
        },
        "destroy": {
          "success": "Convite anulado."
        },
        "resend": {
          "success": "Convite reenviado para %{email}."
        }
      },
      "groups": {
        "create": {
          "success": "Grupo criado."
        },
        "destroy": {
          "success": "Grupo apagado."
        },
        "index": {
          "empty_body": "Cria um grupo para as pessoas com quem partilhas coisas.",
          "empty_title": "Ainda não há grupos",
          "groups_count": {
            "one": "1 grupo",
            "other": "%{count} grupos"
          },
          "new": "Novo grupo",
          "open_reminders": {
            "one": "1 lembrete em aberto",
            "other": "%{count} lembretes em aberto",
            "zero": "nada em aberto"
          },
          "people": {
            "one": "1 pessoa",
            "other": "%{count} pessoas"
          },
          "select_one": "Escolhe um grupo para veres os membros.",
          "summary": {
            "one": "%{groups} · 1 pessoa",
            "other": "%{groups} · %{count} pessoas"
          },
          "title": "Grupos",
          "you_are_admin": "és admin",
          "your_groups": "Os teus grupos"
        },
        "leave": {
          "success": "Saíste do grupo."
        },
        "panel": {
          "anyone_can_add": "Qualquer pessoa pode criar lembretes",
          "anyone_can_add_hint": "Desligado significa que só os admins podem",
          "cancel": "Cancelar",
          "close": "Fechar painel",
          "colour": "Cor",
          "copied": "Copiado",
          "copy": "Copiar",
          "create": "Criar grupo",
          "delete": "Apagar grupo",
          "delete_confirm": "Apagar %{group} e todos os seus lembretes?",
          "email_placeholder": "nome@exemplo.com",
          "invite": "Convidar",
          "invite_by_email": "Convidar por email",
          "invite_link": "Link de convite",
          "invited": "Convidado",
          "leave": "Sair do grupo",
          "leave_confirm": "Sair de %{group}?",
          "make_admin": "Tornar admin",
          "make_member": "Tornar membro",
          "members": "Membros · %{count}",
          "members_hint": "Os admins podem remover pessoas",
          "new_title": "Novo grupo",
          "options_for": "Opções para %{name}",
          "remove": "Remover do grupo",
          "remove_confirm": "Remover %{name} de %{group}?",
          "resend": "Reenviar",
          "revoke": "Anular convite",
          "save": "Guardar",
          "send_invite": "Enviar convite",
          "title": "Grupo",
          "you": "Tu"
        },
        "update": {
          "success": "Grupo guardado."
        }
      },
      "joins": {
        "create": {
          "success": "Bem-vindo a %{group}."
        },
        "show": {
          "already_member": "Já fazes parte deste grupo.",
          "body": "%{name} usa o Meerkeep para partilhar lembretes com este grupo.",
          "join": "Entrar em %{group}",
          "members": {
            "one": "1 membro",
            "other": "%{count} membros"
          },
          "no_thanks": "Não, obrigado",
          "title": "Entrar em %{group}?"
        }
      },
      "memberships": {
        "destroy": {
          "success": "Membro removido."
        },
        "update": {
          "success": "Papel actualizado."
        }
      },
      "nav": {
        "groups": "Grupos",
        "reminders": "Lembretes"
      },
      "reminders": {
        "complete": {
          "success": "Feito."
        },
        "create": {
          "success": "Lembrete criado."
        },
        "destroy": {
          "success": "Lembrete apagado."
        },
        "index": {
          "empty_body": "Os lembretes que crias ou recebes aparecem aqui.",
          "empty_search": "Nenhum lembrete corresponde a \"%{query}\".",
          "empty_title": "Ainda não há nada aqui",
          "new": "Novo lembrete",
          "search_label": "Pesquisar lembretes",
          "search_placeholder": "Pesquisar lembretes…",
          "select_one": "Escolhe um lembrete para veres quem já o fez.",
          "show": "Mostrar",
          "title_all": "Hoje",
          "title_me": "Só eu"
        },
        "new": {
          "all_hint": "Toda a gente tem de concluir",
          "all_of": "Todos os %{count}",
          "anyone": "Qualquer um",
          "anyone_hint": "O primeiro a fazer fecha o lembrete",
          "cancel": "Cancelar",
          "close": "Fechar",
          "create_group": "Cria um",
          "custom": "Escolher outra data e hora",
          "description": "Descrição",
          "description_placeholder": "Adicionar uma descrição…",
          "just_me": "Só eu",
          "no_groups_html": "Ainda não estás em nenhum grupo. %{link} para lembrares outras pessoas.",
          "people": "%{count} pessoas",
          "recurring_note": "A repetição define-se no lembrete depois de criado.",
          "submit": "Criar lembrete",
          "submit_group": "Lembrar %{group}",
          "submit_members": "Lembrar %{names}",
          "title": "Novo lembrete",
          "what": "O que deve dizer o lembrete?",
          "what_placeholder": "Pôr o lixo na rua",
          "when": "Quando",
          "who": "Para quem é"
        },
        "nudge": {
          "success": {
            "one": "Deste um toque a 1 pessoa.",
            "other": "Deste um toque a %{count} pessoas."
          }
        },
        "panel": {
          "close": "Fechar painel",
          "created_by": "Criado por %{name}",
          "delete": "Apagar lembrete",
          "delete_confirm": "Apagar este lembrete para toda a gente?",
          "done_at": "Feito · %{time}",
          "mark_done": "Marcar como feito",
          "not_yet": "Ainda não",
          "nudge": "Dar um toque a %{count}",
          "progress": "Progresso",
          "progress_count": "%{done} de %{total}",
          "repeats": "Repete",
          "save": "Guardar",
          "title": "Lembrete",
          "undo": "Anular",
          "when": "Quando",
          "who": "Para quem",
          "you": "Tu"
        },
        "quick_picks": {
          "in_1_hour": "Daqui a 1 hora",
          "in_30_minutes": "Daqui a 30 minutos",
          "in_3_hours": "Daqui a 3 horas",
          "next_monday": "Segunda-feira",
          "tomorrow": "Amanhã"
        },
        "reminder": {
          "anyone": "qualquer um",
          "done_at": "Feito às %{time}",
          "everyone": "todos",
          "mark_done": "Marcar como feito: %{title}",
          "me": "Eu",
          "nudge": "Dar um toque a %{target}",
          "open": "Abrir %{title}",
          "progress": "%{done} de %{total} feitos",
          "repeats": "Repete %{rule}",
          "sent_to": "Enviado a %{names}",
          "snooze": "Adiar: %{title}",
          "snooze_menu": "Adiar",
          "undo_done": "Anular feito: %{title}",
          "you_done": "Já fizeste",
          "you_only": "só tu"
        },
        "scopes": {
          "all": "Tudo",
          "me": "Só eu"
        },
        "sections": {
          "later": "Mais tarde",
          "overdue": "Atrasados",
          "today": "Hoje",
          "tomorrow": "Amanhã"
        },
        "snooze": {
          "success": "Adiado até %{time}."
        },
        "snooze_options": {
          "fifteen_minutes": "15 minutos",
          "one_hour": "1 hora",
          "tomorrow_morning": "Amanhã às 09:00"
        },
        "uncomplete": {
          "success": "Reaberto."
        },
        "update": {
          "success": "Lembrete guardado."
        }
      }
    },
    "services": {
      "boards": {
        "assignments": {
          "create": {
            "not_a_member": "Só os membros do quadro podem ser atribuídos a um cartão."
          }
        },
        "assistant": {
          "connect": {
            "encryption": "Não é possível ligar o Gmail porque a encriptação dos tokens não está configurada neste servidor.",
            "failed": "O Google não aceitou a ligação. Tenta outra vez.",
            "no_address": "O Google não indicou que endereço Gmail é este. Tenta outra vez.",
            "no_refresh_token": "O Google não deu um acesso duradouro. Tenta outra vez e aceita todas as permissões.",
            "scope": "O acesso de leitura ao Gmail não foi concedido. Liga outra vez e permite-o no ecrã do Google."
          },
          "paste_starter_prompt": "Cria um cartão por cada tarefa ou coisa a fazer no texto. Ignora contexto, opiniões e o que já está feito. Coloca cada cartão no quadro que melhor corresponder ao seu assunto; se nenhum quadro corresponder claramente, não cries um cartão. Escreve um título curto que comece por um verbo. Define uma data limite apenas quando o texto a indicar. Se o texto disser que um dos meus cartões está concluído ou que o prazo mudou, sugere a alteração em vez de criar um cartão novo.",
          "pastes": {
            "retry": {
              "not_failed": "Só é possível tentar de novo um texto que falhou."
            },
            "submit": {
              "blank": "Cola primeiro algum texto.",
              "too_long": "O texto é demasiado longo. O limite é de %{max} carateres."
            }
          },
          "starter_prompt": "Cria um cartão apenas quando um email exigir uma ação ou uma resposta minha. Ignora newsletters, recibos e notificações automáticas, a não ser que me peçam para fazer alguma coisa. Coloca o cartão no quadro que melhor corresponder ao remetente ou ao assunto; se nenhum quadro corresponder claramente, não cries um cartão. Escreve um título curto que comece por um verbo. Define uma data limite apenas quando o email indicar um prazo.",
          "suggestions": {
            "accept": {
              "stale": "Esta sugestão já não se aplica e foi removida."
            },
            "dismiss": {
              "resolved": "Esta sugestão já foi tratada."
            }
          }
        },
        "boards": {
          "create": {
            "lists": [
              "Backlog",
              "Por fazer",
              "Em curso",
              "Concluído"
            ]
          }
        },
        "cards": {
          "bulk_update": {
            "nothing_selected": "Seleciona pelo menos um cartão.",
            "unknown_operation": "Alteração desconhecida."
          },
          "move": {
            "other_board": "O cartão só pode ser movido para uma lista do seu próprio quadro."
          },
          "reschedule": {
            "nothing": "Não há nada para reagendar, ou não pode alterar esses cartões."
          },
          "update": {
            "invalid_list": "Essa lista não pertence a este quadro."
          }
        },
        "lists": {
          "archive": {
            "last_list": "Um quadro precisa de pelo menos uma lista."
          }
        }
      },
      "groups": {
        "invite": {
          "already_member": "Essa pessoa já está no grupo."
        },
        "leave": {
          "last_admin": "Torna outra pessoa admin antes de sair.",
          "not_member": "Não fazes parte deste grupo."
        },
        "membership": {
          "last_admin": "Um grupo precisa de pelo menos um admin.",
          "unknown_change": "Alteração desconhecida."
        }
      },
      "reminders": {
        "complete": {
          "not_assigned": "Este lembrete não é teu para concluir."
        },
        "create": {
          "group_required": "Escolhe um grupo para este lembrete.",
          "not_allowed_in_group": "Só os admins podem criar lembretes em %{group}.",
          "pick_someone": "Escolhe pelo menos uma pessoa."
        },
        "nudge": {
          "nobody_pending": "Já não há ninguém para avisar."
        },
        "snooze": {
          "unknown_option": "Opção de adiar desconhecida."
        }
      },
      "time_tracker": {
        "imports": {
          "bad_time": "tem uma data ou hora que não foi possível ler (%{value})",
          "ends_before_start": "acaba antes de começar",
          "missing_email": "não tem email, por isso não há a quem dar o tempo",
          "missing_headers": "Isto não parece um relatório detalhado do Clockify. Faltam as colunas: %{headers}",
          "missing_time": "não tem hora de início ou de fim",
          "no_description": "Sem descrição",
          "still_running": "Esta importação ainda está a correr."
        },
        "reports": {
          "csv_export": {
            "all_clients": "Todos os clientes",
            "all_projects": "Todos os projectos",
            "billable": "%{amount} facturável",
            "count_day": {
              "one": "1 dia-pessoa",
              "other": "%{count} dias-pessoa",
              "zero": "sem dias-pessoa"
            },
            "count_entry": {
              "one": "1 registo de tempo",
              "other": "%{count} registos de tempo",
              "zero": "sem registos de tempo"
            },
            "count_task": {
              "one": "1 tarefa",
              "other": "%{count} tarefas",
              "zero": "sem tarefas"
            },
            "everyone": "toda a gente",
            "headers": {
              "amount": "Valor",
              "date": "Data",
              "duration": "Duração",
              "end": "Fim",
              "entries": "Registos",
              "hours": "Horas",
              "people": "Pessoas",
              "person": "Pessoa",
              "project": "Projecto",
              "projects": "Projectos",
              "rate": "Tarifa",
              "start": "Início",
              "task": "Tarefa"
            },
            "now": "agora",
            "people": {
              "one": "1 pessoa",
              "other": "%{count} pessoas"
            }
          },
          "dashboard": {
            "long_days": "três dias acima de 9h",
            "long_days_and_weekend": "três dias acima de 9h, mais %{weekend}",
            "missing_days": "nada registado em %{days}",
            "open": "Abrir",
            "project_billable": "%{client} · %{rate}",
            "project_internal": "Sem cliente · não facturável",
            "project_not_billable": "%{client} · não facturável",
            "review_entry": "Rever registo",
            "short_days": "%{total} esta semana, todos os dias abaixo de 6h 30m",
            "too_long": "%{task} durou %{duration}%{range}",
            "weekend": "trabalhou em %{weekend}"
          }
        },
        "time_entries": {
          "stop": {
            "not_running": "Esse registo não está a decorrer."
          }
        },
        "workspaces": {
          "accept_invitation": {
            "already_accepted": "Este convite já foi usado.",
            "wrong_email": "Este convite foi enviado para %{email}. Entra com essa conta para o aceitares."
          },
          "create": {
            "success": "Espaço de trabalho criado."
          },
          "invite": {
            "added_to_boards": {
              "one": "%{emails} já está no espaço de trabalho e foi adicionado(a) aos quadros.",
              "other": "%{emails} já estão no espaço de trabalho e foram adicionados aos quadros."
            },
            "already_members": {
              "one": "%{emails} já está no espaço de trabalho.",
              "other": "%{emails} já estão no espaço de trabalho."
            },
            "no_emails": "Escreve pelo menos um endereço de email.",
            "unknown_role": "Papel desconhecido."
          },
          "manage_membership": {
            "deactivate_self": "Não te podes desactivar a ti próprio.",
            "last_owner": "Um espaço de trabalho precisa de pelo menos um dono. Nomeia outra pessoa primeiro.",
            "last_owner_self": "És o último dono. Nomeia outra pessoa como dono antes de sair.",
            "owners_only": "Só os donos podem nomear ou destituir donos.",
            "unknown_change": "Alteração desconhecida."
          }
        }
      },
      "users": {
        "omniauth": {
          "no_email": "Não conseguimos obter um email dessa conta."
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "day_time": "%-d %b · %H:%M",
        "default": "%A, %d de %B de %Y, %H:%Mh",
        "long": "%A, %d de %B de %Y, %H:%Mh",
        "short": "%a %-d %b · %H:%M",
        "time": "%H:%M",
        "weekday_time": "%a %H:%M"
      },
      "pm": "pm"
    },
    "time_tracker": {
      "clients": {
        "archive": {
          "success": "Cliente arquivado."
        },
        "create": {
          "success": "Cliente criado."
        },
        "destroy": {
          "has_projects": "Arquiva o cliente e remove os projectos antes de o apagares.",
          "success": "Cliente apagado."
        },
        "form": {
          "cancel": "Cancelar",
          "contact_placeholder": "faturacao@empresa.com",
          "create": "Criar cliente",
          "name_placeholder": "Empresa ou pessoa",
          "optional": "(opcional)",
          "per_hour": "/h",
          "rate_hint": "(cada projecto pode alterá-lo)",
          "save": "Guardar alterações"
        },
        "index": {
          "active_count": {
            "one": "1 activo",
            "other": "%{count} activos"
          },
          "archived": "Arquivado",
          "billable_this_month": "Facturável este mês",
          "empty_body": "Adiciona quem facturas e depois dá-lhes projectos.",
          "empty_search": "Nenhum cliente corresponde a \"%{query}\".",
          "empty_title": "Ainda não há clientes",
          "eyebrow": "Espaço %{workspace} · %{month}",
          "footnote": "Os projectos sem cliente, como o trabalho interno, aparecem em Projectos como “Sem cliente” e nunca são facturáveis.",
          "hours_this_month": "Horas este mês",
          "new": "Novo cliente",
          "no_projects": "Ainda sem projectos",
          "project_archived": "%{name} (arquivado)",
          "projects": "Projectos",
          "search_label": "Pesquisar clientes",
          "search_placeholder": "Pesquisar clientes…",
          "select_one": "Escolhe um cliente para veres os projectos e o tempo deste mês.",
          "title": "Clientes"
        },
        "panel": {
          "amount": "Montante",
          "archive": "Arquivar",
          "archive_confirm": "Arquivar %{name}? Os projectos ficam como estão.",
          "archived": "Arquivado",
          "close": "Fechar painel",
          "contact": "Contacto",
          "default_rate": "Valor por defeito para novos projectos",
          "delete": "Apagar",
          "delete_confirm": "Apagar %{name}? Esta acção não pode ser anulada.",
          "edit": "Editar",
          "export": "Exportar o tempo deste cliente",
          "month_total": "Total de %{month}",
          "new_project_for": "+ Novo projecto para %{name}",
          "new_title": "Novo cliente",
          "no_projects": "Ainda sem projectos.",
          "not_billable": "Não facturável",
          "not_set": "Não definido",
          "project": "Projecto",
          "projects": "Projectos",
          "rate": "Valor",
          "this_month": "Este mês",
          "unarchive": "Desarquivar"
        },
        "unarchive": {
          "success": "O cliente voltou a estar activo."
        },
        "update": {
          "success": "Cliente guardado."
        }
      },
      "dashboards": {
        "people_filter": {
          "apply": "Aplicar",
          "empty": "Ninguém aqui.",
          "everyone": "Todas",
          "summary": {
            "one": "1 pessoa",
            "other": "%{count} pessoas",
            "zero": "Todas as pessoas"
          },
          "title": "Pessoas"
        },
        "range_chart": {
          "bar_title": "%{when}: %{duration}",
          "hours": "%{hours}h",
          "segment_title": "%{when} · %{project}: %{duration}",
          "summary": "%{grouping}, %{range}: %{duration} no total, divididas por projecto",
          "title": {
            "day": "Horas por dia",
            "month": "Horas por mês",
            "week": "Horas por semana"
          },
          "total": "Total %{duration}"
        },
        "range_hours": {
          "days": "Dias",
          "empty": "Ninguém registou tempo neste período.",
          "intro": {
            "one": "Objectivo contado sobre 1 dia útil.",
            "other": "Objectivo contado sobre %{count} dias úteis."
          },
          "nothing": "nada registado",
          "person": "Pessoa",
          "projects": "Projectos",
          "segment_title": "%{project}: %{duration}",
          "title": "Horas por pessoa",
          "total": "Total",
          "vs_target": "vs %{hours}h"
        },
        "range_nav": {
          "apply": "Aplicar",
          "custom": "Datas à escolha",
          "from": "De",
          "label": "Período",
          "next": {
            "custom": "Período seguinte",
            "month": "Mês seguinte",
            "week": "Semana seguinte",
            "year": "Ano seguinte"
          },
          "periods": {
            "month": "Mês",
            "week": "Semana",
            "year": "Ano"
          },
          "presets": {
            "last_month": "Mês passado",
            "last_week": "Semana passada",
            "last_year": "Ano passado",
            "this_month": "Este mês",
            "this_week": "Esta semana",
            "this_year": "Este ano"
          },
          "previous": {
            "custom": "Período anterior",
            "month": "Mês anterior",
            "week": "Semana anterior",
            "year": "Ano anterior"
          },
          "title": "Escolher período",
          "to": "Até",
          "view": "Ver por"
        },
        "show": {
          "alerts": {
            "dismiss": "Ignorar",
            "empty": "Nada a assinalar neste período.",
            "title": "Precisa de atenção"
          },
          "all_clients": "Todos os clientes",
          "client_label": "Cliente",
          "eyebrow": "Admins e donos",
          "heatmap": {
            "busiest": "Mais movimento %{from} – %{to}.",
            "cell_title": {
              "one": "%{day} %{hour}:00 — 1 pessoa a registar",
              "other": "%{day} %{hour}:00 — %{count} pessoas a registar",
              "zero": "%{day} %{hour}:00 — ninguém a registar"
            },
            "everyone": "Todos",
            "intro": "Pessoas com o cronómetro a correr, por hora.",
            "intro_average": "Média de pessoas com o cronómetro a correr, por dia da semana e hora.",
            "nobody": "Ninguém",
            "title": "Quando a equipa regista"
          },
          "kpis": {
            "average": "Média por pessoa, por dia útil",
            "average_note": "Objectivo %{target}",
            "billable": "Facturável",
            "billable_note": "%{amount} às tarifas dos projectos · %{share}% do tempo registado",
            "too_long": "Registos demasiado longos",
            "too_long_note": "Mais de %{hours}h seguidas",
            "tracked": "Registado",
            "tracked_note": {
              "one": "de %{hours}h previstas para 1 pessoa",
              "other": "de %{hours}h previstas para %{count} pessoas"
            }
          },
          "projects": {
            "all": "Todos os projectos",
            "empty": "Nenhum tempo em projectos neste período.",
            "title": "Projectos"
          },
          "status_label": "Pessoas",
          "statuses": {
            "active": "Pessoas activas",
            "all": "Todos",
            "inactive": "Pessoas inactivas"
          },
          "title": "Painel de %{workspace}"
        },
        "week_hours": {
          "cell_title": "%{name}, %{day}: %{value}",
          "empty": "Ainda ninguém registou tempo esta semana.",
          "legend": {
            "close": "Perto",
            "on_target": "No objectivo",
            "over": "Acima",
            "under": "Abaixo"
          },
          "nothing": "nada registado",
          "person": "Pessoa",
          "title": "Horas por pessoa, por dia",
          "total": "Total",
          "vs_target": "vs %{hours}h"
        },
        "week_nav": {
          "label": "Semana",
          "next_week": "Semana seguinte",
          "previous_week": "Semana anterior"
        }
      },
      "entries": {
        "no_project": "Sem projecto",
        "now": "agora"
      },
      "exports": {
        "show": {
          "all_clients": "Todos os clientes",
          "billable_only": "Só tempo facturável",
          "client": "Cliente",
          "empty": "Nenhum tempo corresponde a estes filtros.",
          "everyone": "Toda a gente",
          "eyebrow": "Filtrar, pré-visualizar, descarregar",
          "from": "De",
          "mode": "Uma linha por",
          "modes": {
            "day": "Pessoa por dia",
            "entry": "Registo de tempo",
            "task": "Tarefa, somada"
          },
          "people": "Pessoas",
          "people_everyone": "Pessoas · toda a gente",
          "people_you": "Pessoas · você",
          "period": "Período",
          "periods": {
            "custom": "Personalizado",
            "last_month": "Mês passado",
            "last_week": "Semana passada",
            "this_month": "Este mês",
            "this_week": "Esta semana"
          },
          "preview": "Pré-visualização",
          "projects": "Projectos",
          "projects_empty": "Ainda não há projectos.",
          "projects_hint": "Só os projectos deste cliente são listados.",
          "projects_of": "Projectos · %{client}",
          "showing": "A mostrar %{shown} de %{total} linhas. O CSV tem todas as linhas.",
          "showing_all": {
            "one": "A mostrar a única linha.",
            "other": "A mostrar todas as %{count} linhas."
          },
          "submit": "Exportar CSV",
          "task_contains": "Tarefa contém",
          "task_placeholder": "ex. QA",
          "title": "Exportar registos de tempo",
          "to": "a"
        }
      },
      "imports": {
        "create": {
          "success": "Ficheiro recebido. A importação está a correr."
        },
        "destroy": {
          "success": "Importação removida, com os seus registos de tempo."
        },
        "index": {
          "columns": {
            "by": "Por",
            "file": "Ficheiro",
            "imported": "Importados",
            "skipped": "Ignorados",
            "status": "Estado",
            "when": "Quando"
          },
          "empty": "Ainda não foi importado nada.",
          "eyebrow": "Espaço de trabalho %{workspace}",
          "file_hint": "Clockify: Reports → Detailed → Export → CSV. Até %{max} MB.",
          "hint": "Traz tempo de outro tracker. Clientes, projectos e pessoas referidos no ficheiro são criados quando ainda não existem; registos sem projecto ou sem descrição são mantidos na mesma.",
          "history": "Importações anteriores",
          "submit": "Importar",
          "time_zone_hint": "O ficheiro mostra as horas como quem o exportou as via. Escolhe o fuso horário dessa pessoa.",
          "title": "Importar tempo",
          "upload": "Carregar um ficheiro"
        },
        "show": {
          "back": "Todas as importações",
          "counts": {
            "clients": "Clientes criados",
            "imported": "Registos importados",
            "projects": "Projectos criados",
            "rows": "Linhas",
            "skipped": "Linhas ignoradas",
            "users": "Pessoas criadas"
          },
          "danger": "Anular esta importação",
          "danger_hint": {
            "one": "Remove a importação e o 1 registo de tempo que criou. Clientes, projectos e pessoas ficam.",
            "other": "Remove a importação e os %{count} registos de tempo que criou. Clientes, projectos e pessoas ficam.",
            "zero": "Remove a importação. Já não tem registos de tempo."
          },
          "delete": "Remover importação e os seus registos",
          "delete_confirm": "Remover esta importação e todos os registos de tempo que criou? Não é possível voltar atrás.",
          "done": "Terminada a %{finished}, iniciada por %{by}.",
          "eyebrow": "%{provider} · %{when}",
          "failed": "A importação parou e nada foi guardado: %{message}",
          "in_progress": "A percorrer o ficheiro. Esta página actualiza-se sozinha.",
          "issues": {
            "capped": "A mostrar as primeiras %{shown}.",
            "line": "Linha",
            "message": "Porquê",
            "title": {
              "one": "1 linha ignorada",
              "other": "%{count} linhas ignoradas"
            }
          },
          "status": "Estado",
          "title": "Importação"
        }
      },
      "joins": {
        "already_member": "Estás em %{workspace}.",
        "create": {
          "success": "Bem-vindo a %{workspace}."
        },
        "show": {
          "already_used": "Este convite já foi usado.",
          "back": "Ir para o Meerkeep Time",
          "body": "%{name} convidou-te para registar tempo neste espaço de trabalho como %{role}.",
          "join": "Entrar em %{workspace}",
          "members": {
            "one": "1 pessoa está lá",
            "other": "%{count} pessoas estão lá"
          },
          "no_thanks": "Não, obrigado",
          "switch_account": "Terminar sessão e usar outra conta",
          "title": "Entrar em %{workspace}?",
          "wrong_email": "Este convite foi enviado para %{invited}, mas tens sessão iniciada como %{current}."
        }
      },
      "nav": {
        "clients": "Clientes",
        "dashboard": "Painel",
        "export": "Exportar",
        "import": "Importar",
        "manage": "Gerir",
        "people": "Pessoas",
        "projects": "Projectos",
        "timer": "Cronómetro",
        "track": "Registar"
      },
      "people": {
        "index": {
          "clear_search": "Mostrar toda a gente",
          "columns": {
            "actions": "Acções",
            "last_tracked": "Último registo",
            "person": "Pessoa",
            "projects": "Projectos",
            "role": "Papel"
          },
          "everyone": "Toda a gente em %{workspace}",
          "eyebrow": "Espaço de trabalho %{workspace} · %{people}",
          "no_results": "Ninguém corresponde a “%{query}”.",
          "people_count": {
            "one": "1 pessoa",
            "other": "%{count} pessoas"
          },
          "search": "Procurar pessoas",
          "search_placeholder": "Procurar pessoas…",
          "settings": "Definições do espaço de trabalho",
          "title": "Pessoas"
        },
        "invite_card": {
          "emails": "Endereços de email",
          "emails_placeholder": "nome@empresa.com, outro@empresa.com",
          "optional": "(opcional)",
          "pending": "Convites pendentes",
          "projects": "Adicionar a projectos",
          "resend": "Reenviar",
          "revoke": "Revogar o convite de %{email}",
          "role": "Papel",
          "send": "Enviar convites",
          "title": "Convidar para %{workspace}",
          "waiting": "%{role} · à espera"
        },
        "membership": {
          "activate": "Activar",
          "add_project": "+ Projecto",
          "add_to_project": "Adicionar %{name} a um projecto",
          "deactivate": "Desactivar",
          "deactivate_confirm": "Desactivar %{name}? Deixa de conseguir abrir %{workspace} até um dono o voltar a activar. A conta e os registos de tempo ficam.",
          "inactive": "Inactivo",
          "leave_confirm": "Sair de %{workspace}? Perdes o acesso aos projectos e ao tempo.",
          "make": "Tornar %{role}",
          "never": "Nunca",
          "remove": "Remover %{name} do espaço de trabalho",
          "remove_confirm": "Remover %{name} de %{workspace}? Os registos de tempo ficam.",
          "role_for": "Papel de %{name}: %{role}. Alterar papel",
          "timer_running": "Cronómetro a contar",
          "today": "Hoje, %{time}",
          "tracking_now": "A registar agora",
          "yesterday": "Ontem"
        },
        "roles_card": {
          "admin": "Gere clientes, projectos e tarifas. Vê o painel e as pessoas, e pode editar e exportar o tempo de toda a gente.",
          "member": "Regista tempo nos projectos a que foi adicionado, e edita e exporta os seus próprios registos. Só vê o seu próprio tempo, sem tarifas.",
          "owner": "Tudo o que um admin pode, mais as definições do espaço de trabalho, convidar pessoas, mudar papéis, remover pessoas e apagar o espaço de trabalho.",
          "title": "Papéis num espaço de trabalho"
        }
      },
      "person_entries": {
        "index": {
          "back": "← Semana de %{name}",
          "empty_body": "Os últimos 30 dias de %{name} aparecem aqui. Adiciona tempo manualmente para preencher o que falta.",
          "empty_title": "Ainda não há tempo registado",
          "title": "Registos de tempo de %{name}"
        }
      },
      "person_weeks": {
        "show": {
          "back": "← Painel da equipa",
          "back_to_timer": "← Cronómetro",
          "days": {
            "segment_title": "%{project}: %{duration}",
            "target": "%{hours}h",
            "title": "Horas por dia"
          },
          "entries": "Registos de tempo",
          "export": "Exportar o tempo de %{name}",
          "kpis": {
            "billable": "Parte facturável",
            "billable_note": "%{duration} · %{amount} às tarifas dos projectos",
            "entries": "Registos de tempo",
            "entries_empty": "Nada registado esta semana",
            "entries_note": "O mais longo: %{longest}",
            "tracked": "Registado esta semana",
            "tracked_note": "de %{hours}h previstas",
            "vs_target": "vs objectivo",
            "vs_target_note": "Média de %{average} por dia útil · objectivo %{target}"
          },
          "projects": {
            "empty": "Nenhum tempo em projectos esta semana.",
            "title": "Por projecto"
          },
          "role_badge": "%{role} · espaço %{workspace}",
          "timeline": {
            "block_title": "%{project} · %{range} · %{task}",
            "intro": "Cada registo de tempo, colocado à hora a que aconteceu.",
            "title": "Quando %{name} registou"
          },
          "title": "Semana de %{name}"
        }
      },
      "project_memberships": {
        "create": {
          "success": "%{name} adicionado a %{project}."
        },
        "destroy": {
          "success": "%{name} removido de %{project}."
        }
      },
      "projects": {
        "amounts": {
          "all_time": "Total",
          "this_month": "Este mês"
        },
        "archive": {
          "success": "Projecto arquivado."
        },
        "create": {
          "success": "Projecto criado."
        },
        "destroy": {
          "success": "Projecto apagado."
        },
        "details": {
          "add": "Adicionar",
          "add_label": "Adicionar alguém do espaço de trabalho",
          "add_prompt": "Adicionar alguém de %{workspace}…",
          "archive": "Arquivar",
          "archive_confirm": "Arquivar %{name}? Ninguém pode registar tempo nele até ser desarquivado.",
          "archived": "Arquivado",
          "billable": "Facturável",
          "billable_hint": "O tempo neste projecto é cobrado ao cliente.",
          "delete": "Apagar",
          "delete_confirm": "Apagar %{name}? Esta acção não pode ser anulada.",
          "edit": "Editar",
          "entries": {
            "one": "1 registo",
            "other": "%{count} registos"
          },
          "export": "Exportar este projecto",
          "internal_hint": "Os projectos sem cliente são trabalho interno e nunca são facturáveis.",
          "no_client": "Sem cliente",
          "no_people": "Ainda ninguém. Adiciona alguém do espaço de trabalho.",
          "no_tasks": "Ainda sem tempo registado.",
          "not_billable": "Não facturável",
          "people": "Pessoas neste projecto",
          "people_hint": "Só elas podem registar tempo aqui",
          "per_hour": "/h",
          "remove": "Remover %{name} do projecto",
          "tasks": "Tarefas · tempo de todos os registos",
          "unarchive": "Desarquivar"
        },
        "form": {
          "billable_hint": "Só os projectos com cliente podem ser facturáveis.",
          "cancel": "Cancelar",
          "create": "Criar projecto",
          "name_placeholder": "ex. Site da campanha de Primavera",
          "new_client": "+ Novo cliente",
          "no_client": "Sem cliente",
          "people": "Pessoas que podem registar aqui",
          "per_hour": "/h",
          "rate_hint": "Deixa em branco para usar o valor por defeito do cliente.",
          "rate_hint_client": "%{name} costuma ser %{rate} — deixa em branco para o usar.",
          "save": "Guardar alterações"
        },
        "index": {
          "active": {
            "one": "Activos · 1",
            "other": "Activos · %{count}"
          },
          "all_clients": "Todos os clientes",
          "all_time": "Total",
          "archived": {
            "one": "Arquivados · 1",
            "other": "Arquivados · %{count}"
          },
          "billable": "Facturável",
          "billing": "Facturação",
          "client": "Cliente",
          "client_filter": "Filtrar por cliente",
          "empty_archived": "Nada arquivado.",
          "empty_body": "Cria um projecto para as pessoas registarem tempo nele.",
          "empty_title": "Ainda não há projectos",
          "eyebrow": "Espaço %{workspace}",
          "new": "Novo projecto",
          "no_client": "Sem cliente",
          "not_billable": "Não facturável",
          "people": "Pessoas",
          "people_count": {
            "one": "1 pessoa",
            "other": "%{count} pessoas"
          },
          "project": "Projecto",
          "status": "Estado",
          "tasks": {
            "one": "1 tarefa",
            "other": "%{count} tarefas"
          },
          "this_week": "Esta semana",
          "title": "Projectos"
        },
        "new": {
          "back": "← Projectos",
          "title": "Novo projecto"
        },
        "show": {
          "back": "← Projectos"
        },
        "unarchive": {
          "success": "O projecto voltou a estar activo."
        },
        "update": {
          "success": "Projecto guardado."
        }
      },
      "task_suggestions": {
        "create_and_start": "Criar a tarefa “%{task}” e iniciar",
        "so_far": "%{total} até agora",
        "tasks_in": "Tarefas em %{project}"
      },
      "time_entries": {
        "create": {
          "success": "Tempo adicionado."
        },
        "day": {
          "today": "Hoje · %{date}",
          "total_to_check": "%{total} + %{flagged} a confirmar",
          "yesterday": "Ontem · %{date}"
        },
        "destroy": {
          "success": "Registo eliminado."
        },
        "dismiss_too_long": {
          "success": "O registo deixou de estar assinalado."
        },
        "edit": {
          "cancel": "Cancelar",
          "close": "Fechar",
          "delete": "Eliminar registo de tempo",
          "delete_confirm": "Eliminar o registo \"%{task}\"? Esta ação não pode ser anulada.",
          "dismiss": "Está correto, ignorar",
          "duration": "Duração",
          "footnote": "Iniciado com o cronómetro a %{started} · parado a %{stopped}. Este registo não marca a tarefa como concluída.",
          "footnote_running": "Iniciado com o cronómetro a %{started} · ainda a decorrer. Deixa o fim vazio para continuar a contar.",
          "hint": "Parece que o cronómetro continuou a contar depois de teres parado de trabalhar. Escolhe uma hora de fim:",
          "negative": "O fim é antes do início. Corrige as datas ou horas antes de guardar.",
          "pick": "%{day} às %{time}",
          "picks_label": "Horas de fim rápidas",
          "running": "A decorrer",
          "save": "Guardar alterações",
          "suggestion": {
            "history": "O teu dia habitual · %{duration}",
            "target": "Objetivo diário · %{duration}",
            "target_plus": "Objetivo + 1h · %{duration}"
          },
          "suggestions": "Sugestões de tarefas",
          "title": "Editar registo de tempo",
          "too_long": "Este registo tem %{duration}."
        },
        "entry": {
          "edit": "Editar registo: %{task}",
          "resume": "Registar de novo: %{task}",
          "running": "A decorrer",
          "stop": "Parar: %{task}",
          "too_long": "Demasiado longo?"
        },
        "index": {
          "empty_body": "Inicia o cronómetro acima ou adiciona tempo manualmente. Os últimos 30 dias aparecem aqui.",
          "empty_search": "Nenhum registo corresponde a \"%{query}\".",
          "empty_title": "Ainda não registaste tempo",
          "search_label": "Pesquisar registos de tempo",
          "search_placeholder": "Pesquisar registos…",
          "title": "Cronómetro"
        },
        "manual_form": {
          "duration": "Duração",
          "submit": "Adicionar registo",
          "suggestions": "Sugestões de tarefas",
          "task_placeholder": "Em que trabalhaste?",
          "title": "Adicionar tempo manualmente"
        },
        "resume": {
          "not_trackable": "Já não podes registar tempo em %{project}.",
          "success": "Cronómetro iniciado em \"%{task}\"."
        },
        "time_fields": {
          "end_date": "Data de fim",
          "end_time": "Hora de fim",
          "start_date": "Data de início",
          "start_time": "Hora de início"
        },
        "timer_bar": {
          "no_projects": "Ainda não estás em nenhum projeto. Pede a um admin que te adicione a um.",
          "project": "Projeto",
          "start": "Iniciar cronómetro",
          "stop": "Parar cronómetro",
          "suggestions": "Sugestões de tarefas",
          "task": "Tarefa",
          "task_placeholder": "Escolhe uma tarefa ou escreve uma nova…"
        },
        "too_long_banner": {
          "dismiss": "Ignorar",
          "fix": "Corrigir registo",
          "text_html": "%{task} decorreu de %{from} até %{to}. São %{duration} num único registo."
        },
        "update": {
          "success": "Registo guardado."
        },
        "week": {
          "chart_label": "Horas registadas por dia esta semana",
          "day_total": "%{day}: %{total}",
          "entries": {
            "one": "1 registo",
            "other": "%{count} registos"
          },
          "running": {
            "one": ", 1 a decorrer",
            "other": ", %{count} a decorrer"
          },
          "target": "%{hours}h",
          "tasks": "Tarefas desta semana",
          "tasks_empty": "Ainda não há tempo registado esta semana.",
          "tasks_hint": "Todos os registos somados",
          "title": "Esta semana · %{range}"
        }
      },
      "timers": {
        "create": {
          "success": "Cronómetro iniciado."
        },
        "destroy": {
          "nothing_running": "Não há nenhum cronómetro a decorrer.",
          "success": "Cronómetro parado ao fim de %{duration}."
        }
      },
      "workspace_invitations": {
        "added": "%{emails} adicionado ao espaço de trabalho.",
        "destroy": {
          "success": "Convite revogado."
        },
        "invited": "Convite enviado para %{emails}."
      },
      "workspace_memberships": {
        "activate": {
          "success": "%{name} activado."
        },
        "deactivate": {
          "success": "%{name} desactivado."
        },
        "destroy": {
          "success": "%{name} removido do espaço de trabalho."
        },
        "update": {
          "success": "Papel de %{name} actualizado."
        }
      },
      "workspaces": {
        "create": {
          "success": "Espaço de trabalho criado. Convida a tua equipa."
        },
        "destroy": {
          "success": "Espaço de trabalho apagado."
        },
        "edit": {
          "danger": "Apagar espaço de trabalho",
          "danger_hint": "Remove todos os clientes, projectos e registos de tempo, para toda a gente.",
          "delete": "Apagar espaço de trabalho",
          "delete_confirm": "Apagar %{workspace} e todo o seu tempo? Não é possível voltar atrás.",
          "eyebrow": "Espaço de trabalho %{workspace}",
          "general": "Geral",
          "save": "Guardar alterações",
          "target_hint": "O painel compara o dia de cada pessoa com este objectivo.",
          "title": "Definições do espaço de trabalho"
        },
        "new": {
          "heading": "A casa da tua equipa",
          "hint": "Tudo no Meerkeep Time — pessoas, clientes, projectos e tempo — vive dentro de um espaço de trabalho.",
          "name_placeholder": "ex. Awesome Company",
          "submit": "Criar espaço de trabalho",
          "title": "Criar um espaço de trabalho"
        },
        "update": {
          "success": "Espaço de trabalho guardado."
        }
      }
    },
    "tools": {
      "boards": {
        "name": "Meerkeep Boards",
        "short_name": "Quadros",
        "tagline": "Move o trabalho entre colunas até estar feito."
      },
      "reminders": {
        "name": "Meerkeep Reminders",
        "short_name": "Lembretes",
        "tagline": "Para ti, para alguém, ou para um grupo inteiro."
      },
      "time": {
        "name": "Meerkeep Time",
        "short_name": "Tempo",
        "tagline": "Carrega no play numa tarefa. Vê para onde foi a semana."
      }
    },
    "users": {
      "passwords": {
        "edit": {
          "submit": "Guardar palavra-passe",
          "title": "Define uma nova palavra-passe"
        },
        "new": {
          "submit": "Enviar link",
          "subtitle": "Enviamos-te um email com um link para definires uma nova.",
          "title": "Esqueceste-te da palavra-passe?"
        }
      },
      "registrations": {
        "edit": {
          "change_password": "Alterar palavra-passe",
          "danger": "Apagar conta",
          "danger_hint": "Remove os teus lembretes, os teus registos de tempo e tira-te de todos os grupos e espaços de trabalho.",
          "delete_account": "Apagar a minha conta",
          "delete_confirm": "Apagar a tua conta? Não é possível voltar atrás.",
          "disable_push": "Desactivar neste dispositivo",
          "enable_push": "Activar notificações",
          "new_password": "Nova palavra-passe",
          "notifications": "Notificações",
          "notifications_hint": "Recebe uma notificação neste dispositivo quando um lembrete chegar à hora ou alguém te der um toque.",
          "password": "Palavra-passe",
          "password_hint": "Deixa em branco para manter a actual.",
          "profile": "Perfil",
          "push_denied": "As notificações estão bloqueadas nas definições do browser.",
          "push_enabled": "As notificações estão activas neste dispositivo.",
          "push_unsupported": "Este browser não suporta notificações.",
          "save": "Guardar alterações",
          "session": "Sessão",
          "sign_out": "Sair",
          "title": "Editar perfil"
        },
        "new": {
          "accept_html": "Li e aceito: %{consent}",
          "password_hint": "Pelo menos 8 caracteres",
          "submit": "Criar conta",
          "subtitle": "Grátis enquanto estamos em beta.",
          "subtitle_invited": "Cria a tua conta para entrares em %{workspace}.",
          "title": "Cria a tua conta"
        }
      },
      "sessions": {
        "new": {
          "submit": "Entrar",
          "subtitle": "Entra para continuares onde ficaste.",
          "title": "Bem-vindo de volta"
        }
      },
      "shared": {
        "continuing_to": "A continuar para %{tool}",
        "links": {
          "back_to_login": "Voltar ao início de sessão",
          "create_account": "Criar conta",
          "forgot": "Esqueceste-te?",
          "have_account": "Já tens conta?",
          "log_in": "Entrar",
          "new_here": "Novo no Meerkeep?"
        },
        "same_login": "O mesmo login funciona em %{others}.",
        "social": {
          "apple": "Continuar com a Apple",
          "google": "Continuar com o Google",
          "or": "ou"
        }
      }
    },
    "views": {
      "admin": {
        "page_blocks": {
          "add_block": "Adicionar Bloco",
          "add_slide": "Adicionar Diapositivo",
          "alt_text_label": "Texto Alternativo",
          "autoplay_label": "Reprodução automática",
          "body_label": "Conteúdo",
          "caption_label": "Legenda",
          "carousel_autoplay_delay_label": "Intervalo de Reprodução (ms)",
          "carousel_autoplay_label": "Reprodução automática",
          "carousel_effect_fade": "Dissolver",
          "carousel_effect_label": "Efeito de Transição",
          "carousel_effect_slide": "Deslizar",
          "carousel_loop_label": "Repetir",
          "carousel_navigation_label": "Mostrar Setas de Navegação",
          "carousel_pagination_label": "Mostrar Indicadores de Página",
          "carousel_speed_label": "Velocidade de Transição (ms)",
          "content_type": "Tipo de Bloco",
          "controls_label": "Mostrar controlos",
          "image_label": "Ficheiro de Imagem",
          "loop_label": "Repetir",
          "remove_slide": "Remover",
          "replace_image": "Substituir imagem",
          "replace_video": "Substituir vídeo",
          "slide_image_label": "Imagem",
          "slide_text_label": "Texto",
          "slide_title_label": "Título",
          "slides_heading": "Diapositivos",
          "title_placeholder": "ex. Banner Principal",
          "type_carousel": "Carrossel",
          "type_image": "Imagem",
          "type_text": "Texto",
          "type_video": "Vídeo",
          "video_file_label": "Ficheiro de Vídeo",
          "video_source_help": "Indique um URL (YouTube, Vimeo ou outro) OU carregue um ficheiro — não ambos.",
          "video_url_label": "URL do Vídeo"
        },
        "pages": {
          "back_to_layout": "Voltar ao layout",
          "empty_grid": "Sem blocos. Clique em \"Adicionar Bloco\" para começar."
        }
      },
      "hypmin": {
        "action": {
          "create": "Novo",
          "edit": "Editar",
          "index": "Listar",
          "new": "Novo",
          "show": "Mostrar",
          "update": "Editar"
        },
        "add": "Adicionar",
        "admin_panel": "Painel de Admin",
        "alert": "Alerta!",
        "all": "Todos",
        "are_you_sure": "Tem a certeza?",
        "back": "Anterior",
        "ban": "Ban",
        "cancel": "Cancelar",
        "collapse": "Colapsar",
        "confirm_destroy": "Tem a certeza? Esta ação não pode ser revertida.",
        "create": "Criar",
        "created_by": "Criado por",
        "data_of": "Dados",
        "date": "Data",
        "destroy": "Eliminar",
        "download_pdf": "Download PDF",
        "edit": "Editar",
        "error": "Erro!",
        "filter": "Filtrar",
        "insert_link": "Inserir link",
        "lang_label": {
          "en": "(EN)",
          "pt": "(PT)"
        },
        "main_menu": "Menu Principal",
        "member_since": "Membro desde",
        "new": "Criar",
        "no": "Não",
        "notice": "Informação!",
        "page_blocks": "Blocos",
        "pagination": {
          "showing_results_html": "A mostrar %{from}–%{to} de %{count} resultados"
        },
        "profile": "Perfil",
        "save": "Guardar",
        "search_for": "Procurar por...",
        "search_placeholder": "Pesquisar...",
        "select": "Selecionar...",
        "send": "Enviar",
        "show": "Mostrar",
        "welcome_message": "Bem-vindo",
        "yes": "Sim"
      }
    },
    "welcome": "bem-vindo",
    "workspace_invitation_mailer": {
      "added": {
        "body_boards": "%{name} adicionou-te ao espaço de trabalho %{workspace} no Meerkeep Boards como %{role}, para trabalharem em quadros em conjunto.",
        "body_time": "%{name} adicionou-te ao espaço de trabalho %{workspace} no Meerkeep Time como %{role}, para registarem tempo em conjunto.",
        "hello": "Olá,",
        "open": "Abrir %{workspace}",
        "subject_boards": "%{name} adicionou-te a %{workspace} no Meerkeep Boards",
        "subject_time": "%{name} adicionou-te a %{workspace} no Meerkeep Time"
      },
      "invite": {
        "body_boards": "%{name} convidou-te para o espaço de trabalho %{workspace} no Meerkeep Boards como %{role}, para trabalharem em quadros em conjunto.",
        "body_time": "%{name} convidou-te para o espaço de trabalho %{workspace} no Meerkeep Time como %{role}, para registarem tempo em conjunto.",
        "hello": "Olá,",
        "ignore": "Se não estavas à espera deste email, podes ignorá-lo.",
        "join": "Entrar no espaço de trabalho",
        "subject_boards": "%{name} convidou-te para %{workspace} no Meerkeep Boards",
        "subject_time": "%{name} convidou-te para %{workspace} no Meerkeep Time"
      }
    },
    "workspace_switcher": {
      "create_workspace": "Criar um espaço de trabalho",
      "switch_workspace": "Espaço de trabalho: %{workspace}. Mudar de espaço",
      "workspace": "Espaço de trabalho",
      "workspace_meta": {
        "one": "1 pessoa · és %{role}",
        "other": "%{count} pessoas · és %{role}"
      },
      "your_workspaces": "Os teus espaços de trabalho"
    }
  },
  "pt-BR": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Confirmação enviada em",
          "confirmation_token": "Token de confirmação",
          "confirmed_at": "Confirmado em",
          "created_at": "Criado em",
          "current_password": "Senha atual",
          "current_sign_in_at": "Atualmente logado em",
          "current_sign_in_ip": "IP do acesso atual",
          "email": "E-mail",
          "encrypted_password": "Senha criptografada",
          "failed_attempts": "Tentativas sem sucesso",
          "last_sign_in_at": "Último acesso em",
          "last_sign_in_ip": "Último IP de acesso",
          "locked_at": "Bloqueado em",
          "password": "Senha",
          "password_confirmation": "Confirme sua senha",
          "remember_created_at": "Lembrar criado em",
          "remember_me": "Lembre-se de mim",
          "reset_password_sent_at": "Resetar senha enviado em",
          "reset_password_token": "Resetar token de senha",
          "sign_in_count": "Contagem de acessos",
          "unconfirmed_email": "E-mail não confirmado",
          "unlock_token": "Token de desbloqueio",
          "updated_at": "Atualizado em"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "A validação falhou: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Não é possível excluir o registro pois existem %{record} dependentes",
            "has_one": "Não é possível excluir o registro pois existe um %{record} dependente"
          }
        }
      },
      "models": {
        "user": {
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "day_names": [
        "domingo",
        "segunda-feira",
        "terça-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%d de %B de %Y",
        "short": "%d de %B"
      },
      "month_names": [
        null,
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "aproximadamente %{count} hora",
          "other": "aproximadamente %{count} horas"
        },
        "about_x_months": {
          "one": "aproximadamente %{count} mês",
          "other": "aproximadamente %{count} meses"
        },
        "about_x_years": {
          "one": "aproximadamente %{count} ano",
          "other": "aproximadamente %{count} anos"
        },
        "almost_x_years": {
          "one": "quase %{count} ano",
          "other": "quase %{count} anos"
        },
        "half_a_minute": "meio minuto",
        "less_than_x_minutes": {
          "one": "menos de um minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "mais de %{count} ano",
          "other": "mais de %{count} anos"
        },
        "x_days": {
          "one": "%{count} dia",
          "other": "%{count} dias"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mês",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} ano",
          "other": "%{count} anos"
        }
      },
      "prompts": {
        "day": "Dia",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mês",
        "second": "Segundo",
        "year": "Ano"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "A sua conta foi confirmada com sucesso.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instruções de confirmação"
        },
        "send_instructions": "Dentro de minutos, você receberá um email com as instruções de confirmação da sua conta.",
        "send_paranoid_instructions": "Se o seu e-mail existir em nosso banco de dados, você receberá um email com instruções sobre como confirmar sua conta em alguns minutos."
      },
      "failure": {
        "already_authenticated": "Você já está autenticado.",
        "inactive": "A sua conta ainda não foi ativada.",
        "invalid": "%{authentication_keys} ou senha inválidos.",
        "last_attempt": "Você tem mais uma única tentativa antes de sua conta ser bloqueada.",
        "locked": "A sua conta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} ou senha inválidos.",
        "timeout": "A sua sessão expirou, por favor, faça login novamente para continuar.",
        "unauthenticated": "Para continuar, faça login ou registre-se.",
        "unconfirmed": "Antes de continuar, confirme a sua conta."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar minha conta",
          "confirm_account_link": "Confirme conta",
          "confirm_link_msg": "Você pode confirmar a sua conta de e-mail através do link abaixo :",
          "greeting": "Bem-vindo %{recipient}!",
          "instruction": "Você pode confirmar sua conta através do link abaixo:",
          "subject": "Instruções de confirmação"
        },
        "email_changed": {
          "greeting": "Olá %{recipient}!",
          "message": "Estamos entrando em contato para notificá-lo de que seu e-mail está sendo alterado para %{email}.",
          "message_unconfirmed": "Estamos entrando em contato para notificá-lo de que seu e-mail está sendo alterado para %{email}.",
          "subject": "E-mail alterado"
        },
        "password_change": {
          "greeting": "Olá %{recipient}!",
          "message": "Estamos entrando em contato para notificá-lo de que sua senha foi alterada.",
          "subject": "Senha alterada"
        },
        "reset_password_instructions": {
          "action": "Redefinir minha senha",
          "greeting": "Olá %{recipient}!",
          "ignore_mail_msg": "Se você não pediu isso, por favor, ignore este e-mail.",
          "instruction": "Alguém fez o pedido para redefinir sua senha, e você pode fazer isso clicando no link abaixo.",
          "instruction_2": "Se você não fez este pedido, por favor ignore este e-mail.",
          "instruction_3": "Sua senha não será alterada até que você acesse o link acima e crie uma nova.",
          "no_changes_msg": "Sua senha não será alterada até que você acessar o link acima e criar um novo.",
          "password_change_link": "Alterar a senha",
          "request_reset_link_msg": "Alguém pediu um link para mudar sua senha. Você pode fazer isso através do link abaixo ",
          "subject": "Instruções de redefinição de senha"
        },
        "unlock_instructions": {
          "account_lock_msg": "A sua conta foi bloqueada devido a um número excessivo de sinal de sucesso em tentativas.",
          "action": "Desbloquear minha conta",
          "greeting": "Olá %{recipient}!",
          "instruction": "Clique no link abaixo para desbloquear sua conta:",
          "message": "Sua conta foi bloqueada devido ao excessivo número de tentativas acesso inválidas.",
          "subject": "Instruções de desbloqueio",
          "unlock_link": "Desbloquear minha conta",
          "unlock_link_msg": "Clique no link abaixo para desbloquear sua conta:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Não foi possível autorizar de uma conta de %{kind} porque \"%{reason}\".",
        "success": "Autorizado com sucesso de uma conta de %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Alterar minha senha",
          "change_your_password": "Alterar sua senha",
          "confirm_new_password": "Confirme sua nova senha",
          "new_password": "Nova senha"
        },
        "new": {
          "forgot_your_password": "Esqueceu sua senha?",
          "send_me_reset_password_instructions": "Enviar instruções para redefinição da senha"
        },
        "no_token": "Você não pode acessar esta página sem estar logado. Se você veio de um email de redefinição de senha, por favor certifique-se de ter digitado a URL corretamente.",
        "send_instructions": "Dentro de minutos, você receberá um e-mail com as instruções de redefinição da sua senha.",
        "send_paranoid_instructions": "Se o seu email existir em nosso banco de dados, você receberá um email com um link para recuperação da senha.",
        "updated": "A sua senha foi alterada com sucesso. Você está autenticado.",
        "updated_not_active": "Sua senha foi alterada com sucesso."
      },
      "registrations": {
        "destroyed": "Adeus! A sua conta foi cancelada com sucesso. Esperamos vê-lo novamente em breve.",
        "edit": {
          "are_you_sure": "Você tem certeza?",
          "cancel_my_account": "Cancelar minha conta",
          "currently_waiting_confirmation_for_email": "No momento esperando por: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "deixe em branco caso não queira alterá-la",
          "title": "Editar %{resource}",
          "unhappy": "Não está contente?",
          "update": "Atualizar",
          "we_need_your_current_password_to_confirm_your_changes": "precisamos da sua senha atual para confirmar suas mudanças"
        },
        "new": {
          "sign_up": "Inscrever-se"
        },
        "signed_up": "Bem vindo! Você realizou seu registro com sucesso.",
        "signed_up_but_inactive": "Você se inscreveu com sucesso, porém nós não podemos autenticá-lo porque sua conta ainda não foi ativada.",
        "signed_up_but_locked": "Você se inscreveu com sucesso. Porém nós não podemos autenticá-lo porque sua conta está bloqueada.",
        "signed_up_but_unconfirmed": "Uma mensagem com um link de confirmação foi enviada para o seu e-mail. Por favor, acesse o link para ativar sua conta.",
        "update_needs_confirmation": "Sua conta foi atualizada com sucesso, mas nós precisamos verificar o novo endereço de email. Por favor, verifique seu e-mail e clique no link de confirmação para finalizar confirmando o seu novo e-mail.",
        "updated": "A sua conta foi atualizada com sucesso.",
        "updated_but_not_signed_in": "Sua conta foi atualizada com sucesso, uma vez que sua senha foi alterada será necessário realizar o login novamente."
      },
      "sessions": {
        "already_signed_out": "Logout efetuado com sucesso.",
        "new": {
          "sign_in": "Login"
        },
        "signed_in": "Login efetuado com sucesso.",
        "signed_out": "Logout efetuado com sucesso."
      },
      "shared": {
        "links": {
          "back": "Voltar",
          "didn_t_receive_confirmation_instructions": "Não recebeu instruções de confirmação?",
          "didn_t_receive_unlock_instructions": "Não recebeu instruções de desbloqueio?",
          "forgot_your_password": "Esqueceu sua senha?",
          "sign_in": "Login",
          "sign_in_with_provider": "Entrar com %{provider}",
          "sign_up": "Inscrever-se"
        },
        "minimum_password_length": {
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instruções de desbloqueio"
        },
        "send_instructions": "Dentro de minutos, você receberá um e-mail com instruções de desbloqueio da sua conta.",
        "send_paranoid_instructions": "Se sua conta existir em nosso banco de dados, você receberá em breve um e-mail com instruções para desbloquear ela.",
        "unlocked": "A sua conta foi desbloqueada com sucesso. Efetue login para continuar."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Redirecionamento para '%{redirect_url}' não permitido."
      },
      "passwords": {
        "missing_email": "Informe o endereço de e-mail.",
        "missing_passwords": "Preencha a senha e a confirmação de senha.",
        "missing_redirect_url": "URL para redirecionamento não informada.",
        "not_allowed_redirect_url": "Redirecionamento para '%{redirect_url}' não permitido.",
        "password_not_required": "Esta conta não necessita de uma senha. Faça login utilizando '%{provider}'.",
        "sended": "Você receberá um e-mail com instruções sobre como redefinir sua senha.",
        "successfully_updated": "Senha atualizada com sucesso.",
        "user_not_found": "Não existe um usuário com o e-mail '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Não foi possível encontrar a conta para exclusão.",
        "account_with_uid_destroyed": "A conta com uid '%{uid}' foi excluída.",
        "email_already_exists": "Já existe uma conta com o email '%{email}'.",
        "missing_confirm_success_url": "Parâmetro 'confirm_success_url' não informado.",
        "redirect_url_not_allowed": "Redirecionamento para '%{redirect_url}' não permitido.",
        "user_not_found": "Usuário não encontrado."
      },
      "sessions": {
        "bad_credentials": "E-mail ou senha inválidos.",
        "not_confirmed": "Uma mensagem com um link de confirmação foi enviado para seu endereço de e-mail. Você precisa confirmar sua conta antes de continuar.",
        "not_supported": "Use POST /sign_in para efetuar o login. GET não é suportado.",
        "user_not_found": "Usuário não existe ou não está logado."
      },
      "token_validations": {
        "invalid": "Dados de login inválidos."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "deve ser aceito",
        "already_confirmed": "já foi confirmado",
        "blank": "não pode ficar em branco",
        "confirmation": "não é igual a %{attribute}",
        "confirmation_period_expired": "É necessário ser confirmado dentro do período %{period}, por favor requisite um novo usuário.",
        "empty": "não pode ficar vazio",
        "equal_to": "deve ser igual a %{count}",
        "even": "deve ser par",
        "exclusion": "não está disponível",
        "expired": "expirou, por favor solicite uma nova",
        "greater_than": "deve ser maior que %{count}",
        "greater_than_or_equal_to": "deve ser maior ou igual a %{count}",
        "in": "deve estar em %{count}",
        "inclusion": "não está incluído na lista",
        "invalid": "não é válido",
        "less_than": "deve ser menor que %{count}",
        "less_than_or_equal_to": "deve ser menor ou igual a %{count}",
        "model_invalid": "A validação falhou: %{errors}",
        "not_a_number": "não é um número",
        "not_an_integer": "não é um número inteiro",
        "not_email": "não é um e-mail",
        "not_found": "não encontrado",
        "not_locked": "não foi bloqueado",
        "not_saved": {
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "deve ser ímpar",
        "other_than": "deve ser diferente de %{count}",
        "present": "deve ficar em branco",
        "required": "é obrigatório(a)",
        "taken": "já está em uso",
        "too_long": {
          "one": "é muito longo (máximo: %{count} caracter)",
          "other": "é muito longo (máximo: %{count} caracteres)"
        },
        "too_short": {
          "one": "é muito curto (mínimo: %{count} caracter)",
          "other": "é muito curto (mínimo: %{count} caracteres)"
        },
        "validate_account_update_params": "Os dados submetidos para atualização de conta são inválidos.",
        "validate_sign_up_params": "Os dados submetidos na requisição de cadastro são inválidos.",
        "wrong_length": {
          "one": "não possui o tamanho esperado (%{count} caracter)",
          "other": "não possui o tamanho esperado (%{count} caracteres)"
        }
      },
      "template": {
        "body": "Por favor, verifique o(s) seguinte(s) campo(s):",
        "header": {
          "one": "Não foi possível gravar %{model}: %{count} erro",
          "other": "Não foi possível gravar %{model}: %{count} erros"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#####",
          "####",
          "###",
          "s/n"
        ],
        "city": [
          "Abadia de Goiás",
          "Abadia dos Dourados",
          "Abadiânia",
          "Abaetetuba",
          "Abaeté",
          "Abaiara",
          "Abaré",
          "Abatiá",
          "Abaíra",
          "Abdon Batista",
          "Abel Figueiredo",
          "Abelardo Luz",
          "Abre Campo",
          "Abreu e Lima",
          "Abreulândia",
          "Acaiaca",
          "Acajutiba",
          "Acarapé",
          "Acaraú",
          "Acari",
          "Acará",
          "Acauã",
          "Aceguá",
          "Acopiara",
          "Acorizal",
          "Acrelândia",
          "Acreúna",
          "Adamantina",
          "Adelândia",
          "Adolfo",
          "Adrianópolis",
          "Adustina",
          "Afogados da Ingazeira",
          "Afonso Bezerra",
          "Afonso Cláudio",
          "Afonso Cunha",
          "Afrânio",
          "Afuá",
          "Agrestina",
          "Agricolândia",
          "Agrolândia",
          "Agronômica",
          "Aguanil",
          "Aguaí",
          "Agudo",
          "Agudos",
          "Agudos do Sul",
          "Aguiar",
          "Aguiarnópolis",
          "Aimorés",
          "Aiquara",
          "Aiuaba",
          "Aiuruoca",
          "Ajuricaba",
          "Alagoa",
          "Alagoa Grande",
          "Alagoa Nova",
          "Alagoinha",
          "Alagoinha do Piauí",
          "Alagoinhas",
          "Alambari",
          "Albertina",
          "Alcantil",
          "Alcinópolis",
          "Alcobaça",
          "Alcântara",
          "Alcântaras",
          "Aldeias Altas",
          "Alecrim",
          "Alegre",
          "Alegrete",
          "Alegrete do Piauí",
          "Alegria",
          "Alenquer",
          "Alexandria",
          "Alexânia",
          "Alfenas",
          "Alfredo Chaves",
          "Alfredo Marcondes",
          "Alfredo Vasconcelos",
          "Alfredo Wagner",
          "Algodão de Jandaíra",
          "Alhandra",
          "Aliança",
          "Aliança do Tocantins",
          "Almadina",
          "Almas",
          "Almeirim",
          "Almenara",
          "Almino Afonso",
          "Almirante Tamandaré",
          "Almirante Tamandaré do Sul",
          "Aloândia",
          "Alpercata",
          "Alpestre",
          "Alpinópolis",
          "Alta Floresta",
          "Alta Floresta d'Oeste",
          "Altair",
          "Altamira",
          "Altamira do Maranhão",
          "Altamira do Paraná",
          "Altaneira",
          "Alterosa",
          "Altinho",
          "Altinópolis",
          "Alto Alegre",
          "Alto Alegre do Maranhão",
          "Alto Alegre do Parecis",
          "Alto Alegre do Pindaré",
          "Alto Araguaia",
          "Alto Bela Vista",
          "Alto Boa Vista",
          "Alto Caparaó",
          "Alto Feliz",
          "Alto Garças",
          "Alto Horizonte",
          "Alto Jequitibá",
          "Alto Longá",
          "Alto Paraguai",
          "Alto Paraná",
          "Alto Paraíso",
          "Alto Paraíso de Goiás",
          "Alto Parnaíba",
          "Alto Piquiri",
          "Alto Rio Doce",
          "Alto Rio Novo",
          "Alto Santo",
          "Alto Taquari",
          "Alto do Rodrigues",
          "Altos",
          "Altônia",
          "Alumínio",
          "Alvarenga",
          "Alvarães",
          "Alvinlândia",
          "Alvinópolis",
          "Alvorada",
          "Alvorada d'Oeste",
          "Alvorada de Minas",
          "Alvorada do Gurguéia",
          "Alvorada do Norte",
          "Alvorada do Sul",
          "Além Paraíba",
          "Amajari",
          "Amambaí",
          "Amaporã",
          "Amapá",
          "Amapá do Maranhão",
          "Amaraji",
          "Amaral Ferrador",
          "Amaralina",
          "Amarante",
          "Amarante do Maranhão",
          "Amargosa",
          "Amaturá",
          "Americana",
          "Americano do Brasil",
          "Ametista do Sul",
          "Amontada",
          "Amorinópolis",
          "Amparo",
          "Amparo de São Francisco",
          "Amparo do Serra",
          "Ampére",
          "Amélia Rodrigues",
          "América Dourada",
          "Américo Brasiliense",
          "Américo de Campos",
          "Anadia",
          "Anagé",
          "Anahy",
          "Anajatuba",
          "Anajás",
          "Analândia",
          "Anamã",
          "Ananindeua",
          "Ananás",
          "Anapu",
          "Anapurus",
          "Anastácio",
          "Anaurilândia",
          "Anchieta",
          "Andaraí",
          "Andirá",
          "Andorinha",
          "Andradas",
          "Andradina",
          "Andrelândia",
          "André da Rocha",
          "Angatuba",
          "Angelim",
          "Angelina",
          "Angelândia",
          "Angical",
          "Angical do Piauí",
          "Angico",
          "Angicos",
          "Angra dos Reis",
          "Anguera",
          "Angélica",
          "Anhanguera",
          "Anhembi",
          "Anhumas",
          "Anicuns",
          "Anita Garibaldi",
          "Anitápolis",
          "Anori",
          "Anta Gorda",
          "Antas",
          "Antonina",
          "Antonina do Norte",
          "Antônio Almeida",
          "Antônio Cardoso",
          "Antônio Carlos",
          "Antônio Dias",
          "Antônio Gonçalves",
          "Antônio João",
          "Antônio Martins",
          "Antônio Olinto",
          "Antônio Prado",
          "Antônio Prado de Minas",
          "Anápolis",
          "Anísio de Abreu",
          "Aparecida",
          "Aparecida d'Oeste",
          "Aparecida de Goiânia",
          "Aparecida do Rio Doce",
          "Aparecida do Rio Negro",
          "Aparecida do Taboado",
          "Aperibé",
          "Apiacá",
          "Apiacás",
          "Apiaí",
          "Apicum-Açu",
          "Apiúna",
          "Apodi",
          "Aporá",
          "Aporé",
          "Apuarema",
          "Apucarana",
          "Apuiarés",
          "Apuí",
          "Aquidabã",
          "Aquidauana",
          "Aquiraz",
          "Arabutã",
          "Aracaju",
          "Aracati",
          "Aracatu",
          "Araci",
          "Aracitaba",
          "Aracoiaba",
          "Aracruz",
          "Aragarças",
          "Aragoiânia",
          "Aragominas",
          "Araguacema",
          "Araguaiana",
          "Araguainha",
          "Araguanã",
          "Araguapaz",
          "Araguari",
          "Araguatins",
          "Araguaçu",
          "Araguaína",
          "Araioses",
          "Aral Moreira",
          "Aramari",
          "Arambaré",
          "Arame",
          "Aramina",
          "Arandu",
          "Arantina",
          "Arapeí",
          "Arapiraca",
          "Arapoema",
          "Araponga",
          "Arapongas",
          "Araporã",
          "Arapoti",
          "Araputanga",
          "Arapuá",
          "Arapuã",
          "Araquari",
          "Arara",
          "Araranguá",
          "Araraquara",
          "Araras",
          "Ararendá",
          "Arari",
          "Araricá",
          "Araripe",
          "Araripina",
          "Araruama",
          "Araruna",
          "Arataca",
          "Aratiba",
          "Aratuba",
          "Aratuípe",
          "Araucária",
          "Arauá",
          "Araxá",
          "Araçagi",
          "Araçariguama",
          "Araças",
          "Araçatuba",
          "Araçaí",
          "Araçoiaba",
          "Araçoiaba da Serra",
          "Araçu",
          "Araçuaí",
          "Araújos",
          "Arceburgo",
          "Arco-Íris",
          "Arcos",
          "Arcoverde",
          "Areado",
          "Areal",
          "Arealva",
          "Areia",
          "Areia Branca",
          "Areia de Baraúnas",
          "Areial",
          "Areias",
          "Areiópolis",
          "Arenápolis",
          "Arenópolis",
          "Argirita",
          "Aricanduva",
          "Arinos",
          "Aripuanã",
          "Ariquemes",
          "Ariranha",
          "Ariranha do Ivaí",
          "Armazém",
          "Armação de Búzios",
          "Arneiroz",
          "Aroazes",
          "Aroeiras",
          "Arraial",
          "Arraial do Cabo",
          "Arraias",
          "Arroio Grande",
          "Arroio Trinta",
          "Arroio do Meio",
          "Arroio do Padre",
          "Arroio do Sal",
          "Arroio do Tigre",
          "Arroio dos Ratos",
          "Artur Nogueira",
          "Aruanã",
          "Arujá",
          "Arvoredo",
          "Arvorezinha",
          "Arês",
          "Ascurra",
          "Aspásia",
          "Assaré",
          "Assaí",
          "Assis",
          "Assis Brasil",
          "Assis Chateaubriand",
          "Assunção",
          "Assunção do Piauí",
          "Astolfo Dutra",
          "Astorga",
          "Atalaia",
          "Atalaia do Norte",
          "Atalanta",
          "Ataléia",
          "Atibaia",
          "Atilio Vivacqua",
          "Augustinópolis",
          "Augusto Corrêa",
          "Augusto Pestana",
          "Augusto Severo",
          "Augusto de Lima",
          "Aurelino Leal",
          "Auriflama",
          "Aurilândia",
          "Aurora",
          "Aurora do Pará",
          "Aurora do Tocantins",
          "Autazes",
          "Avanhandava",
          "Avaré",
          "Avaí",
          "Aveiro",
          "Avelino Lopes",
          "Avelinópolis",
          "Axixá",
          "Axixá do Tocantins",
          "Açailândia",
          "Açu",
          "Açucena",
          "Babaçulândia",
          "Bacabal",
          "Bacabeira",
          "Bacuri",
          "Bacurituba",
          "Bady Bassitt",
          "Baependi",
          "Bagre",
          "Bagé",
          "Baianópolis",
          "Baixa Grande",
          "Baixa Grande do Ribeiro",
          "Baixio",
          "Baixo Guandu",
          "Baião",
          "Balbinos",
          "Baldim",
          "Baliza",
          "Balneário Arroio do Silva",
          "Balneário Barra do Sul",
          "Balneário Camboriú",
          "Balneário Gaivota",
          "Balneário Pinhal",
          "Balsa Nova",
          "Balsas",
          "Bambuí",
          "Banabuiú",
          "Bananal",
          "Bananeiras",
          "Bandeira",
          "Bandeira do Sul",
          "Bandeirante",
          "Bandeirantes",
          "Bandeirantes do Tocantins",
          "Bannach",
          "Banzaê",
          "Baraúna",
          "Barbacena",
          "Barbalha",
          "Barbosa",
          "Barbosa Ferraz",
          "Barcarena",
          "Barcelona",
          "Barcelos",
          "Bariri",
          "Barra",
          "Barra Bonita",
          "Barra Funda",
          "Barra Longa",
          "Barra Mansa",
          "Barra Velha",
          "Barra d'Alcântara",
          "Barra da Estiva",
          "Barra de Guabiraba",
          "Barra de Santa Rosa",
          "Barra de Santana",
          "Barra de Santo Antônio",
          "Barra de São Francisco",
          "Barra de São Miguel",
          "Barra do Bugres",
          "Barra do Chapéu",
          "Barra do Choça",
          "Barra do Corda",
          "Barra do Garças",
          "Barra do Guarita",
          "Barra do Jacaré",
          "Barra do Mendes",
          "Barra do Ouro",
          "Barra do Piraí",
          "Barra do Quaraí",
          "Barra do Ribeiro",
          "Barra do Rio Azul",
          "Barra do Rocha",
          "Barra do Turvo",
          "Barra dos Coqueiros",
          "Barracão",
          "Barras",
          "Barreira",
          "Barreiras",
          "Barreiras do Piauí",
          "Barreirinha",
          "Barreirinhas",
          "Barreiros",
          "Barretos",
          "Barrinha",
          "Barro",
          "Barro Alto",
          "Barro Duro",
          "Barro Preto",
          "Barrocas",
          "Barrolândia",
          "Barroquinha",
          "Barros Cassal",
          "Barroso",
          "Barueri",
          "Barão",
          "Barão de Antonina",
          "Barão de Cocais",
          "Barão de Cotegipe",
          "Barão de Grajaú",
          "Barão de Melgaço",
          "Barão de Monte Alto",
          "Barão do Triunfo",
          "Bastos",
          "Bataguassu",
          "Bataiporã",
          "Batalha",
          "Batatais",
          "Baturité",
          "Bauru",
          "Bayeux",
          "Baía Formosa",
          "Baía da Traição",
          "Bebedouro",
          "Beberibe",
          "Bela Cruz",
          "Bela Vista",
          "Bela Vista da Caroba",
          "Bela Vista de Goiás",
          "Bela Vista de Minas",
          "Bela Vista do Maranhão",
          "Bela Vista do Paraíso",
          "Bela Vista do Piauí",
          "Bela Vista do Toldo",
          "Belford Roxo",
          "Belmiro Braga",
          "Belmonte",
          "Belo Campo",
          "Belo Horizonte",
          "Belo Jardim",
          "Belo Monte",
          "Belo Oriente",
          "Belo Vale",
          "Belterra",
          "Belágua",
          "Belém",
          "Belém de Maria",
          "Belém de São Francisco",
          "Belém do Brejo do Cruz",
          "Belém do Piauí",
          "Beneditinos",
          "Benedito Leite",
          "Benedito Novo",
          "Benevides",
          "Benjamin Constan do Sul",
          "Benjamin Constant",
          "Bento Fernandes",
          "Bento Gonçalves",
          "Bento de Abreu",
          "Bequimão",
          "Berilo",
          "Berizal",
          "Bernardino Batista",
          "Bernardino de Campos",
          "Bernardo Sayão",
          "Bernardo do Mearim",
          "Bertioga",
          "Bertolínia",
          "Bertópolis",
          "Beruri",
          "Betim",
          "Betânia",
          "Betânia do Piauí",
          "Bezerros",
          "Bias Fortes",
          "Bicas",
          "Biguaçu",
          "Bilac",
          "Biquinhas",
          "Birigui",
          "Biritiba-Mirim",
          "Biritinga",
          "Bituruna",
          "Blumenau",
          "Boa Esperança",
          "Boa Esperança do Iguaçu",
          "Boa Esperança do Sul",
          "Boa Hora",
          "Boa Nova",
          "Boa Ventura",
          "Boa Ventura de São Roque",
          "Boa Viagem",
          "Boa Vista",
          "Boa Vista da Aparecida",
          "Boa Vista das Missões",
          "Boa Vista do Buricá",
          "Boa Vista do Cadeado",
          "Boa Vista do Gurupi",
          "Boa Vista do Incra",
          "Boa Vista do Ramos",
          "Boa Vista do Sul",
          "Boa Vista do Tupim",
          "Boca da Mata",
          "Boca do Acre",
          "Bocaina",
          "Bocaina de Minas",
          "Bocaina do Sul",
          "Bocaiúva",
          "Bocaiúva do Sul",
          "Bodocó",
          "Bodoquena",
          "Bodó",
          "Bofete",
          "Boituva",
          "Bom Conselho",
          "Bom Despacho",
          "Bom Jardim",
          "Bom Jardim da Serra",
          "Bom Jardim de Goiás",
          "Bom Jardim de Minas",
          "Bom Jesus",
          "Bom Jesus da Lapa",
          "Bom Jesus da Penha",
          "Bom Jesus da Serra",
          "Bom Jesus das Selvas",
          "Bom Jesus de Goiás",
          "Bom Jesus do Amparo",
          "Bom Jesus do Araguaia",
          "Bom Jesus do Galho",
          "Bom Jesus do Itabapoana",
          "Bom Jesus do Norte",
          "Bom Jesus do Oeste",
          "Bom Jesus do Sul",
          "Bom Jesus do Tocantins",
          "Bom Jesus dos Perdões",
          "Bom Lugar",
          "Bom Princípio",
          "Bom Princípio do Piauí",
          "Bom Progresso",
          "Bom Repouso",
          "Bom Retiro",
          "Bom Retiro do Sul",
          "Bom Sucesso",
          "Bom Sucesso de Itararé",
          "Bom Sucesso do Sul",
          "Bombinhas",
          "Bonfim",
          "Bonfim do Piauí",
          "Bonfinópolis",
          "Bonfinópolis de Minas",
          "Boninal",
          "Bonito",
          "Bonito de Minas",
          "Bonito de Santa Fé",
          "Bonópolis",
          "Boqueirão",
          "Boqueirão do Leão",
          "Boqueirão do Piauí",
          "Boquim",
          "Boquira",
          "Boracéia",
          "Borba",
          "Borborema",
          "Borda da Mata",
          "Borebi",
          "Borrazópolis",
          "Borá",
          "Bossoroca",
          "Botelhos",
          "Botucatu",
          "Botumirim",
          "Botuporã",
          "Botuverá",
          "Bozano",
          "Braga",
          "Braganey",
          "Bragança",
          "Bragança Paulista",
          "Branquinha",
          "Brasil Novo",
          "Brasileira",
          "Brasilândia",
          "Brasilândia de Minas",
          "Brasilândia do Sul",
          "Brasilândia do Tocantins",
          "Brasiléia",
          "Brasnorte",
          "Brasília",
          "Brasília de Minas",
          "Brasópolis",
          "Brazabrantes",
          "Braço do Norte",
          "Braço do Trombudo",
          "Braúna",
          "Braúnas",
          "Brejetuba",
          "Brejinho",
          "Brejinho de Nazaré",
          "Brejo",
          "Brejo Alegre",
          "Brejo Grande",
          "Brejo Grande do Araguaia",
          "Brejo Santo",
          "Brejo da Madre de Deus",
          "Brejo de Areia",
          "Brejo do Cruz",
          "Brejo do Piauí",
          "Brejo dos Santos",
          "Brejolândia",
          "Brejão",
          "Brejões",
          "Breu Branco",
          "Breves",
          "Britânia",
          "Brochier",
          "Brodowski",
          "Brotas",
          "Brotas de Macaúbas",
          "Brumadinho",
          "Brumado",
          "Brunópolis",
          "Brusque",
          "Brás Pires",
          "Bueno Brandão",
          "Buenos Aires",
          "Buenópolis",
          "Buerarema",
          "Bugre",
          "Bujari",
          "Bujaru",
          "Buri",
          "Buritama",
          "Buriti",
          "Buriti Alegre",
          "Buriti Bravo",
          "Buriti de Goiás",
          "Buriti do Tocantins",
          "Buriti dos Lopes",
          "Buriti dos Montes",
          "Buriticupu",
          "Buritinópolis",
          "Buritirama",
          "Buritirana",
          "Buritis",
          "Buritizal",
          "Buritizeiro",
          "Butiá",
          "Buíque",
          "Bálsamo",
          "Caapiranga",
          "Caaporã",
          "Caarapó",
          "Caatiba",
          "Cabaceiras",
          "Cabaceiras do Paraguaçu",
          "Cabeceira Grande",
          "Cabeceiras",
          "Cabeceiras do Piauí",
          "Cabedelo",
          "Cabixi",
          "Cabo Frio",
          "Cabo Verde",
          "Cabo de Santo Agostinho",
          "Cabreúva",
          "Cabrobó",
          "Cabrália Paulista",
          "Cacaulândia",
          "Cacequi",
          "Cachoeira",
          "Cachoeira Alta",
          "Cachoeira Dourada",
          "Cachoeira Grande",
          "Cachoeira Paulista",
          "Cachoeira da Prata",
          "Cachoeira de Goiás",
          "Cachoeira de Minas",
          "Cachoeira de Pajeú",
          "Cachoeira do Arari",
          "Cachoeira do Piriá",
          "Cachoeira do Sul",
          "Cachoeira dos Índios",
          "Cachoeiras de Macacu",
          "Cachoeirinha",
          "Cachoeiro de Itapemirim",
          "Cacimba de Areia",
          "Cacimba de Dentro",
          "Cacimbas",
          "Cacimbinhas",
          "Cacique Doble",
          "Cacoal",
          "Caconde",
          "Caculé",
          "Caetanos",
          "Caetanópolis",
          "Caetité",
          "Caeté",
          "Caetés",
          "Cafarnaum",
          "Cafeara",
          "Cafelândia",
          "Cafezal do Sul",
          "Caiabu",
          "Caiana",
          "Caiapônia",
          "Caibaté",
          "Caibi",
          "Caicó",
          "Caieiras",
          "Cairu",
          "Caiuá",
          "Caiçara",
          "Caiçara do Norte",
          "Caiçara do Rio do Vento",
          "Cajamar",
          "Cajapió",
          "Cajari",
          "Cajati",
          "Cajazeiras",
          "Cajazeiras do Piauí",
          "Cajazeirinhas",
          "Cajobi",
          "Cajueiro",
          "Cajueiro da Praia",
          "Cajuri",
          "Cajuru",
          "Caldas",
          "Caldas Brandão",
          "Caldas Novas",
          "Caldazinha",
          "Caldeirão Grande",
          "Caldeirão Grande do Piauí",
          "Califórnia",
          "Calmon",
          "Calumbi",
          "Calçado",
          "Calçoene",
          "Camacan",
          "Camacho",
          "Camalaú",
          "Camamu",
          "Camanducaia",
          "Camapuã",
          "Camaquã",
          "Camaragibe",
          "Camargo",
          "Camaçari",
          "Cambará",
          "Cambará do Sul",
          "Cambira",
          "Camboriú",
          "Cambuci",
          "Cambuquira",
          "Cambuí",
          "Cambé",
          "Cametá",
          "Camocim",
          "Camocim de São Félix",
          "Campanha",
          "Campanário",
          "Campestre",
          "Campestre da Serra",
          "Campestre de Goiás",
          "Campestre do Maranhão",
          "Campina Grande",
          "Campina Grande do Sul",
          "Campina Verde",
          "Campina da Lagoa",
          "Campina das Missões",
          "Campina do Monte Alegre",
          "Campina do Simão",
          "Campinas",
          "Campinas do Piauí",
          "Campinas do Sul",
          "Campinaçu",
          "Campinorte",
          "Campinápolis",
          "Campo Alegre",
          "Campo Alegre de Goiás",
          "Campo Alegre de Lourdes",
          "Campo Alegre do Fidalgo",
          "Campo Azul",
          "Campo Belo",
          "Campo Belo do Sul",
          "Campo Bom",
          "Campo Bonito",
          "Campo Erê",
          "Campo Florido",
          "Campo Formoso",
          "Campo Grande",
          "Campo Grande do Piauí",
          "Campo Largo",
          "Campo Largo do Piauí",
          "Campo Limpo Paulista",
          "Campo Magro",
          "Campo Maior",
          "Campo Mourão",
          "Campo Novo",
          "Campo Novo de Rondônia",
          "Campo Novo do Parecis",
          "Campo Redondo",
          "Campo Verde",
          "Campo de Santana",
          "Campo do Brito",
          "Campo do Meio",
          "Campo do Tenente",
          "Campos Altos",
          "Campos Belos",
          "Campos Borges",
          "Campos Gerais",
          "Campos Limpo de Goiás",
          "Campos Lindos",
          "Campos Novos",
          "Campos Novos Paulista",
          "Campos Sales",
          "Campos Verdes",
          "Campos de Júlio",
          "Campos do Jordão",
          "Campos dos Goytacazes",
          "Camutanga",
          "Cana Verde",
          "Canabrava do Norte",
          "Cananéia",
          "Canapi",
          "Canarana",
          "Canas",
          "Canavieira",
          "Canavieiras",
          "Canaã",
          "Canaã dos Carajás",
          "Candeal",
          "Candeias",
          "Candeias do Jamari",
          "Candelária",
          "Candiba",
          "Candiota",
          "Candói",
          "Canela",
          "Canelinha",
          "Canguaretama",
          "Canguçu",
          "Canhoba",
          "Canhotinho",
          "Canindé",
          "Canindé de São Francisco",
          "Canitar",
          "Canoas",
          "Canoinhas",
          "Cansanção",
          "Cantagalo",
          "Cantanhede",
          "Canto do Buriti",
          "Cantá",
          "Canudos",
          "Canudos do Vale",
          "Canutama",
          "Canápolis",
          "Capanema",
          "Caparaó",
          "Capela",
          "Capela Nova",
          "Capela de Santana",
          "Capela do Alto",
          "Capela do Alto Alegre",
          "Capelinha",
          "Capetinga",
          "Capim",
          "Capim Branco",
          "Capim Grosso",
          "Capinzal",
          "Capinzal do Norte",
          "Capinópolis",
          "Capistrano",
          "Capitão",
          "Capitão Andrade",
          "Capitão Enéas",
          "Capitão Gervásio Oliveira",
          "Capitão Leônidas Marques",
          "Capitão Poço",
          "Capitão de Campos",
          "Capitólio",
          "Capivari",
          "Capivari de Baixo",
          "Capivari do Sul",
          "Capixaba",
          "Capoeiras",
          "Caputira",
          "Capão Alto",
          "Capão Bonito",
          "Capão Bonito do Sul",
          "Capão da Canoa",
          "Capão do Cipó",
          "Capão do Leão",
          "Caracaraí",
          "Caracol",
          "Caraguatatuba",
          "Carambeí",
          "Caranaíba",
          "Carandaí",
          "Carangola",
          "Carapebus",
          "Carapicuíba",
          "Caratinga",
          "Carauari",
          "Caravelas",
          "Carazinho",
          "Caraá",
          "Caraí",
          "Caraíbas",
          "Caraúbas",
          "Caraúbas do Piauí",
          "Carbonita",
          "Cardeal da Silva",
          "Cardoso",
          "Cardoso Moreira",
          "Careaçu",
          "Careiro",
          "Careiro da Várzea",
          "Cariacica",
          "Caridade",
          "Caridade do Piauí",
          "Carinhanha",
          "Carira",
          "Cariri do Tocantins",
          "Caririaçu",
          "Cariré",
          "Cariús",
          "Carlinda",
          "Carlos Barbosa",
          "Carlos Chagas",
          "Carlos Gomes",
          "Carlópolis",
          "Carmo",
          "Carmo da Cachoeira",
          "Carmo da Mata",
          "Carmo de Minas",
          "Carmo do Cajuru",
          "Carmo do Paranaíba",
          "Carmo do Rio Claro",
          "Carmo do Rio Verde",
          "Carmolândia",
          "Carmésia",
          "Carmópolis",
          "Carmópolis de Minas",
          "Carnaubais",
          "Carnaubal",
          "Carnaubeira da Penha",
          "Carnaíba",
          "Carnaúba dos Dantas",
          "Carneirinho",
          "Carneiros",
          "Caroebe",
          "Carolina",
          "Carpina",
          "Carrancas",
          "Carrapateira",
          "Carrasco Bonito",
          "Caruaru",
          "Carutapera",
          "Carvalhos",
          "Carvalhópolis",
          "Casa Branca",
          "Casa Grande",
          "Casa Nova",
          "Casca",
          "Cascalho Rico",
          "Cascavel",
          "Caseara",
          "Caseiros",
          "Casimiro de Abreu",
          "Casinhas",
          "Casserengue",
          "Cassilândia",
          "Castanhal",
          "Castanheira",
          "Castanheiras",
          "Castelo",
          "Castelo do Piauí",
          "Castelândia",
          "Castilho",
          "Castro",
          "Castro Alves",
          "Cataguases",
          "Catalão",
          "Catanduva",
          "Catanduvas",
          "Catarina",
          "Catas Altas",
          "Catas Altas da Noruega",
          "Catende",
          "Catiguá",
          "Catingueira",
          "Catolândia",
          "Catolé do Rocha",
          "Catu",
          "Catuji",
          "Catunda",
          "Caturama",
          "Caturaí",
          "Caturité",
          "Catuti",
          "Catuípe",
          "Caucaia",
          "Cavalcante",
          "Caxambu",
          "Caxambu do Sul",
          "Caxias",
          "Caxias do Sul",
          "Caxingó",
          "Caçador",
          "Caçapava",
          "Caçapava do Sul",
          "Caçu",
          "Caém",
          "Ceará-Mirim",
          "Cedral",
          "Cedro",
          "Cedro de São João",
          "Cedro do Abaeté",
          "Celso Ramos",
          "Centenário",
          "Centenário do Sul",
          "Central",
          "Central de Minas",
          "Central do Maranhão",
          "Centralina",
          "Centro Novo do Maranhão",
          "Centro do Guilherme",
          "Cerejeiras",
          "Ceres",
          "Cerqueira César",
          "Cerquilho",
          "Cerrito",
          "Cerro Azul",
          "Cerro Branco",
          "Cerro Corá",
          "Cerro Grande",
          "Cerro Grande do Sul",
          "Cerro Largo",
          "Cerro Negro",
          "Cesário Lange",
          "Cezarina",
          "Chalé",
          "Chapada",
          "Chapada Gaúcha",
          "Chapada da Natividade",
          "Chapada de Areia",
          "Chapada do Norte",
          "Chapada dos Guimarães",
          "Chapadinha",
          "Chapadão do Céu",
          "Chapadão do Lageado",
          "Chapadão do Sul",
          "Chapecó",
          "Charqueada",
          "Charqueadas",
          "Charrua",
          "Chaval",
          "Chavantes",
          "Chaves",
          "Chiador",
          "Chiapeta",
          "Chopinzinho",
          "Chorozinho",
          "Chorrochó",
          "Choró",
          "Chupinguaia",
          "Chuvisca",
          "Chuí",
          "Chácara",
          "Chã Grande",
          "Chã Preta",
          "Chã de Alegria",
          "Cianorte",
          "Cidade Gaúcha",
          "Cidade Ocidental",
          "Cidelândia",
          "Cidreira",
          "Cipotânea",
          "Cipó",
          "Ciríaco",
          "Claraval",
          "Claro dos Poções",
          "Clementina",
          "Clevelândia",
          "Cláudia",
          "Cláudio",
          "Coaraci",
          "Coari",
          "Cocal",
          "Cocal de Telha",
          "Cocal do Sul",
          "Cocal dos Alves",
          "Cocalinho",
          "Cocalzinho de Goiás",
          "Cocos",
          "Codajás",
          "Codó",
          "Coelho Neto",
          "Coimbra",
          "Coité do Nóia",
          "Coivaras",
          "Colares",
          "Colatina",
          "Colina",
          "Colinas",
          "Colinas do Sul",
          "Colinas do Tocantins",
          "Colméia",
          "Colniza",
          "Colombo",
          "Colorado",
          "Colorado do Oeste",
          "Coluna",
          "Colíder",
          "Colômbia",
          "Colônia Leopoldina",
          "Colônia do Gurguéia",
          "Colônia do Piauí",
          "Combinado",
          "Comendador Gomes",
          "Comendador Levy Gasparian",
          "Comercinho",
          "Comodoro",
          "Conceição",
          "Conceição da Aparecida",
          "Conceição da Barra",
          "Conceição da Barra de Minas",
          "Conceição da Feira",
          "Conceição das Alagoas",
          "Conceição das Pedras",
          "Conceição de Ipanema",
          "Conceição de Macabu",
          "Conceição do Almeida",
          "Conceição do Araguaia",
          "Conceição do Canindé",
          "Conceição do Castelo",
          "Conceição do Coité",
          "Conceição do Jacuípe",
          "Conceição do Lago-Açu",
          "Conceição do Mato Dentro",
          "Conceição do Pará",
          "Conceição do Rio Verde",
          "Conceição do Tocantins",
          "Conceição dos Ouros",
          "Conchal",
          "Conchas",
          "Concórdia",
          "Concórdia do Pará",
          "Condado",
          "Conde",
          "Condeúba",
          "Condor",
          "Confins",
          "Confresa",
          "Congo",
          "Congonhal",
          "Congonhas",
          "Congonhas do Norte",
          "Congonhinhas",
          "Conquista",
          "Conquista d'Oeste",
          "Conselheiro Lafaiete",
          "Conselheiro Mairinck",
          "Conselheiro Pena",
          "Consolação",
          "Constantina",
          "Contagem",
          "Contenda",
          "Contendas do Sincorá",
          "Coqueiral",
          "Coqueiro Baixo",
          "Coqueiro Seco",
          "Coqueiros do Sul",
          "Coração de Jesus",
          "Coração de Maria",
          "Corbélia",
          "Cordeiro",
          "Cordeiros",
          "Cordeirópolis",
          "Cordilheira Alta",
          "Cordisburgo",
          "Cordislândia",
          "Coreaú",
          "Coremas",
          "Corguinho",
          "Coribe",
          "Corinto",
          "Cornélio Procópio",
          "Coroaci",
          "Coroados",
          "Coroatá",
          "Coromandel",
          "Coronel Barros",
          "Coronel Bicaco",
          "Coronel Domingos Soares",
          "Coronel Ezequiel",
          "Coronel Fabriciano",
          "Coronel Freitas",
          "Coronel José Dias",
          "Coronel João Pessoa",
          "Coronel João Sá",
          "Coronel Macedo",
          "Coronel Martins",
          "Coronel Murta",
          "Coronel Pacheco",
          "Coronel Pilar",
          "Coronel Sapucaia",
          "Coronel Vivida",
          "Coronel Xavier Chaves",
          "Correia Pinto",
          "Corrente",
          "Correntes",
          "Correntina",
          "Cortês",
          "Corumbataí",
          "Corumbataí do Sul",
          "Corumbaíba",
          "Corumbiara",
          "Corumbá",
          "Corumbá de Goiás",
          "Corupá",
          "Coruripe",
          "Cosmorama",
          "Cosmópolis",
          "Costa Marques",
          "Costa Rica",
          "Cotegipe",
          "Cotia",
          "Cotiporã",
          "Cotriguaçu",
          "Couto de Magalhães",
          "Couto de Magalhães de Minas",
          "Coxilha",
          "Coxim",
          "Coxixola",
          "Crateús",
          "Crato",
          "Cravinhos",
          "Cravolândia",
          "Craíbas",
          "Criciúma",
          "Crissiumal",
          "Cristais",
          "Cristais Paulista",
          "Cristal",
          "Cristal do Sul",
          "Cristalina",
          "Cristalândia",
          "Cristalândia do Piauí",
          "Cristiano Otoni",
          "Cristianópolis",
          "Cristina",
          "Cristino Castro",
          "Cristinápolis",
          "Cristália",
          "Cristópolis",
          "Crisólita",
          "Crisópolis",
          "Crixás",
          "Crixás do Tocantins",
          "Croatá",
          "Cromínia",
          "Crucilândia",
          "Cruz",
          "Cruz Alta",
          "Cruz Machado",
          "Cruz das Almas",
          "Cruz do Espírito Santo",
          "Cruzaltense",
          "Cruzeiro",
          "Cruzeiro da Fortaleza",
          "Cruzeiro do Iguaçu",
          "Cruzeiro do Oeste",
          "Cruzeiro do Sul",
          "Cruzeta",
          "Cruzmaltina",
          "Cruzália",
          "Cruzília",
          "Cubati",
          "Cubatão",
          "Cuiabá",
          "Cuitegi",
          "Cuité",
          "Cuité de Mamanguape",
          "Cujubim",
          "Cumari",
          "Cumaru",
          "Cumaru do Norte",
          "Cumbe",
          "Cunha",
          "Cunha Porã",
          "Cunhataí",
          "Cuparaque",
          "Cupira",
          "Curaçá",
          "Curimatá",
          "Curionópolis",
          "Curitiba",
          "Curitibanos",
          "Curiúva",
          "Currais",
          "Currais Novos",
          "Curral Novo do Piauí",
          "Curral Velho",
          "Curral de Cima",
          "Curral de Dentro",
          "Curralinho",
          "Curralinhos",
          "Cururupu",
          "Curuá",
          "Curuçá",
          "Curvelo",
          "Curvelândia",
          "Custódia",
          "Cutias",
          "Cáceres",
          "Cássia",
          "Cássia dos Coqueiros",
          "Cândido Godói",
          "Cândido Mendes",
          "Cândido Mota",
          "Cândido Rodrigues",
          "Cândido Sales",
          "Cândido de Abreu",
          "Céu Azul",
          "Cícero Dantas",
          "Córrego Danta",
          "Córrego Fundo",
          "Córrego Novo",
          "Córrego do Bom Jesus",
          "Córrego do Ouro",
          "Cônego Marinho",
          "Damianópolis",
          "Damião",
          "Damolândia",
          "Darcinópolis",
          "Datas",
          "David Canabarro",
          "Davinópolis",
          "Delfim Moreira",
          "Delfinópolis",
          "Delmiro Gouveia",
          "Delta",
          "Demerval Lobão",
          "Denise",
          "Deodápolis",
          "Deputado Irapuan Pinheiro",
          "Derrubadas",
          "Descalvado",
          "Descanso",
          "Descoberto",
          "Desterro",
          "Desterro de Entre Rios",
          "Desterro do Melo",
          "Dezesseis de Novembro",
          "Diadema",
          "Diamante",
          "Diamante d'Oeste",
          "Diamante do Norte",
          "Diamante do Sul",
          "Diamantina",
          "Diamantino",
          "Dianópolis",
          "Dias d'Ávila",
          "Dilermando de Aguiar",
          "Diogo de Vasconcelos",
          "Dionísio",
          "Dionísio Cerqueira",
          "Diorama",
          "Dirce Reis",
          "Dirceu Arcoverde",
          "Divina Pastora",
          "Divino",
          "Divino das Laranjeiras",
          "Divino de São Lourenço",
          "Divinolândia",
          "Divinolândia de Minas",
          "Divinésia",
          "Divinópolis",
          "Divinópolis de Goiás",
          "Divinópolis do Tocantins",
          "Divisa Alegre",
          "Divisa Nova",
          "Divisópolis",
          "Dobrada",
          "Dois Córregos",
          "Dois Irmãos",
          "Dois Irmãos das Missões",
          "Dois Irmãos do Buriti",
          "Dois Irmãos do Tocantins",
          "Dois Lajeados",
          "Dois Riachos",
          "Dois Vizinhos",
          "Dolcinópolis",
          "Dom Aquino",
          "Dom Basílio",
          "Dom Bosco",
          "Dom Cavati",
          "Dom Eliseu",
          "Dom Expedito Lopes",
          "Dom Feliciano",
          "Dom Inocêncio",
          "Dom Joaquim",
          "Dom Macedo Costa",
          "Dom Pedrito",
          "Dom Pedro",
          "Dom Pedro de Alcântara",
          "Dom Silvério",
          "Dom Viçoso",
          "Domingos Martins",
          "Domingos Mourão",
          "Dona Emma",
          "Dona Euzébia",
          "Dona Francisca",
          "Dona Inês",
          "Dores de Campos",
          "Dores de Guanhães",
          "Dores do Indaiá",
          "Dores do Rio Preto",
          "Dores do Turvo",
          "Doresópolis",
          "Dormentes",
          "Douradina",
          "Dourado",
          "Douradoquara",
          "Dourados",
          "Doutor Camargo",
          "Doutor Maurício Cardoso",
          "Doutor Pedrinho",
          "Doutor Ricardo",
          "Doutor Severiano",
          "Doutor Ulysses",
          "Doverlândia",
          "Dracena",
          "Duartina",
          "Duas Barras",
          "Duas Estradas",
          "Dueré",
          "Dumont",
          "Duque Bacelar",
          "Duque de Caxias",
          "Durandé",
          "Dário Meira",
          "Echaporã",
          "Ecoporanga",
          "Edealina",
          "Edéia",
          "Eirunepé",
          "Eldorado",
          "Eldorado do Sul",
          "Eldorado dos Carajás",
          "Elesbão Veloso",
          "Elias Fausto",
          "Eliseu Martins",
          "Elisiário",
          "Elísio Medrado",
          "Elói Mendes",
          "Emas",
          "Embaúba",
          "Embu",
          "Embu-Guaçu",
          "Emilianópolis",
          "Encantado",
          "Encanto",
          "Encruzilhada",
          "Encruzilhada do Sul",
          "Engenheiro Beltrão",
          "Engenheiro Caldas",
          "Engenheiro Coelho",
          "Engenheiro Navarro",
          "Engenheiro Paulo de Frontin",
          "Engenho Velho",
          "Entre Folhas",
          "Entre Rios",
          "Entre Rios de Minas",
          "Entre Rios do Oeste",
          "Entre Rios do Sul",
          "Entre-Ijuís",
          "Envira",
          "Enéas Marques",
          "Epitaciolândia",
          "Equador",
          "Erebango",
          "Erechim",
          "Ererê",
          "Ermo",
          "Ernestina",
          "Erval Grande",
          "Erval Seco",
          "Erval Velho",
          "Ervália",
          "Escada",
          "Esmeralda",
          "Esmeraldas",
          "Espera Feliz",
          "Esperantina",
          "Esperantinópolis",
          "Esperança",
          "Esperança Nova",
          "Esperança do Sul",
          "Espigão Alto do Iguaçu",
          "Espigão d'Oeste",
          "Espinosa",
          "Esplanada",
          "Espumoso",
          "Espírito Santo",
          "Espírito Santo do Dourado",
          "Espírito Santo do Pinhal",
          "Espírito Santo do Turvo",
          "Estação",
          "Esteio",
          "Estiva",
          "Estiva Gerbi",
          "Estreito",
          "Estrela",
          "Estrela Dalva",
          "Estrela Velha",
          "Estrela d'Oeste",
          "Estrela de Alagoas",
          "Estrela do Indaiá",
          "Estrela do Norte",
          "Estrela do Sul",
          "Estância",
          "Estância Velha",
          "Euclides da Cunha",
          "Euclides da Cunha Paulista",
          "Eugenópolis",
          "Eugênio de Castro",
          "Eunápolis",
          "Eusébio",
          "Ewbank da Câmara",
          "Extrema",
          "Extremoz",
          "Exu",
          "Fagundes",
          "Fagundes Varela",
          "Faina",
          "Fama",
          "Faria Lemos",
          "Farias Brito",
          "Faro",
          "Farol",
          "Farroupilha",
          "Fartura",
          "Fartura do Piauí",
          "Faxinal",
          "Faxinal do Soturno",
          "Faxinal dos Guedes",
          "Faxinalzinho",
          "Fazenda Nova",
          "Fazenda Rio Grande",
          "Fazenda Vilanova",
          "Feijó",
          "Feira Grande",
          "Feira Nova",
          "Feira Nova do Maranhão",
          "Feira da Mata",
          "Feira de Santana",
          "Felipe Guerra",
          "Felisburgo",
          "Felixlândia",
          "Feliz",
          "Feliz Deserto",
          "Feliz Natal",
          "Felício dos Santos",
          "Fernandes Pinheiro",
          "Fernandes Tourinho",
          "Fernando Falcão",
          "Fernando Pedroza",
          "Fernando Prestes",
          "Fernando de Noronha",
          "Fernandópolis",
          "Fernão",
          "Ferraz de Vasconcelos",
          "Ferreira Gomes",
          "Ferreiros",
          "Ferros",
          "Fervedouro",
          "Figueira",
          "Figueirópolis",
          "Figueirópolis d'Oeste",
          "Filadélfia",
          "Firmino Alves",
          "Firminópolis",
          "Flexeiras",
          "Flor da Serra do Sul",
          "Flor do Sertão",
          "Flora Rica",
          "Floraí",
          "Floreal",
          "Flores",
          "Flores da Cunha",
          "Flores de Goiás",
          "Flores do Piauí",
          "Floresta",
          "Floresta Azul",
          "Floresta do Araguaia",
          "Floresta do Piauí",
          "Florestal",
          "Florestópolis",
          "Floriano",
          "Floriano Peixoto",
          "Florianópolis",
          "Florânia",
          "Florínia",
          "Flórida",
          "Flórida Paulista",
          "Fonte Boa",
          "Fontoura Xavier",
          "Formiga",
          "Formigueiro",
          "Formosa",
          "Formosa da Serra Negra",
          "Formosa do Oeste",
          "Formosa do Rio Preto",
          "Formosa do Sul",
          "Formoso",
          "Formoso do Araguaia",
          "Forquetinha",
          "Forquilha",
          "Forquilhinha",
          "Fortaleza",
          "Fortaleza de Minas",
          "Fortaleza do Tabocão",
          "Fortaleza dos Nogueiras",
          "Fortaleza dos Valos",
          "Fortim",
          "Fortuna",
          "Fortuna de Minas",
          "Foz do Iguaçu",
          "Foz do Jordão",
          "Fraiburgo",
          "Franca",
          "Francinópolis",
          "Francisco Alves",
          "Francisco Ayres",
          "Francisco Badaró",
          "Francisco Beltrão",
          "Francisco Dantas",
          "Francisco Dumont",
          "Francisco Macedo",
          "Francisco Morato",
          "Francisco Santos",
          "Francisco Sá",
          "Franciscópolis",
          "Franco da Rocha",
          "Frecheirinha",
          "Frederico Westphalen",
          "Frei Gaspar",
          "Frei Inocêncio",
          "Frei Lagonegro",
          "Frei Martinho",
          "Frei Miguelinho",
          "Frei Paulo",
          "Frei Rogério",
          "Fronteira",
          "Fronteira dos Vales",
          "Fronteiras",
          "Fruta de Leite",
          "Frutal",
          "Frutuoso Gomes",
          "Fundão",
          "Funilândia",
          "Fátima",
          "Fátima do Sul",
          "Fênix",
          "Gabriel Monteiro",
          "Gado Bravo",
          "Galiléia",
          "Galinhos",
          "Galvão",
          "Gameleira",
          "Gameleira de Goiás",
          "Gameleiras",
          "Gandu",
          "Garanhuns",
          "Gararu",
          "Garibaldi",
          "Garopaba",
          "Garrafão do Norte",
          "Garruchos",
          "Garuva",
          "Garça",
          "Gaspar",
          "Gastão Vidigal",
          "Gaurama",
          "Gavião",
          "Gavião Peixoto",
          "Gaúcha do Norte",
          "Geminiano",
          "General Carneiro",
          "General Câmara",
          "General Maynard",
          "General Salgado",
          "General Sampaio",
          "Gentil",
          "Gentio do Ouro",
          "Getulina",
          "Getúlio Vargas",
          "Gilbués",
          "Girau do Ponciano",
          "Giruá",
          "Glaucilândia",
          "Glicério",
          "Glorinha",
          "Glória",
          "Glória d'Oeste",
          "Glória de Dourados",
          "Glória do Goitá",
          "Godofredo Viana",
          "Godoy Moreira",
          "Goiabeira",
          "Goiana",
          "Goiandira",
          "Goianinha",
          "Goianira",
          "Goianorte",
          "Goianá",
          "Goianápolis",
          "Goianésia",
          "Goianésia do Pará",
          "Goiatins",
          "Goiatuba",
          "Goioerê",
          "Goioxim",
          "Goiás",
          "Goiânia",
          "Gongogi",
          "Gonzaga",
          "Gonçalves",
          "Gonçalves Dias",
          "Gouveia",
          "Gouvelândia",
          "Governador Archer",
          "Governador Celso Ramos",
          "Governador Dix-Sept Rosado",
          "Governador Edison Lobão",
          "Governador Eugênio Barros",
          "Governador Jorge Teixeira",
          "Governador Lindenberg",
          "Governador Luiz Rocha",
          "Governador Mangabeira",
          "Governador Newton Bello",
          "Governador Nunes Freire",
          "Governador Valadares",
          "Gracho Cardoso",
          "Grajaú",
          "Gramado",
          "Gramado Xavier",
          "Gramado dos Loureiros",
          "Grandes Rios",
          "Granito",
          "Granja",
          "Granjeiro",
          "Gravatal",
          "Gravataí",
          "Gravatá",
          "Graça",
          "Graça Aranha",
          "Groaíras",
          "Grossos",
          "Grupiara",
          "Grão Mogol",
          "Grão Pará",
          "Guabiju",
          "Guabiruba",
          "Guadalupe",
          "Guaimbê",
          "Guairaçá",
          "Guaiçara",
          "Guaiúba",
          "Guajará",
          "Guajará-Mirim",
          "Guajeru",
          "Guamaré",
          "Guamiranga",
          "Guanambi",
          "Guanhães",
          "Guapiara",
          "Guapiaçu",
          "Guapimirim",
          "Guapirama",
          "Guaporema",
          "Guaporé",
          "Guapé",
          "Guapó",
          "Guarabira",
          "Guaraci",
          "Guaraciaba",
          "Guaraciaba do Norte",
          "Guaraciama",
          "Guaramiranga",
          "Guaramirim",
          "Guarani",
          "Guarani d'Oeste",
          "Guarani das Missões",
          "Guarani de Goiás",
          "Guaraniaçu",
          "Guarantã",
          "Guarantã do Norte",
          "Guaranésia",
          "Guarapari",
          "Guarapuava",
          "Guaraqueçaba",
          "Guararapes",
          "Guararema",
          "Guarará",
          "Guaratinga",
          "Guaratinguetá",
          "Guaratuba",
          "Guaraçaí",
          "Guaraí",
          "Guaraíta",
          "Guarda-Mor",
          "Guareí",
          "Guariba",
          "Guaribas",
          "Guarinos",
          "Guarujá",
          "Guarujá do Sul",
          "Guarulhos",
          "Guará",
          "Guatambú",
          "Guatapará",
          "Guaxupé",
          "Guaçuí",
          "Guaíba",
          "Guaíra",
          "Guia Lopes da Laguna",
          "Guidoval",
          "Guimarânia",
          "Guimarães",
          "Guiratinga",
          "Guiricema",
          "Gurinhatã",
          "Gurinhém",
          "Gurjão",
          "Gurupi",
          "Gurupá",
          "Guzolândia",
          "Gália",
          "Harmonia",
          "Heitoraí",
          "Heliodora",
          "Heliópolis",
          "Herculândia",
          "Herval",
          "Herval d'Oeste",
          "Herveiras",
          "Hidrolina",
          "Hidrolândia",
          "Holambra",
          "Honório Serpa",
          "Horizonte",
          "Horizontina",
          "Hortolândia",
          "Hugo Napoleão",
          "Hulha Negra",
          "Humaitá",
          "Humberto de Campos",
          "Iacanga",
          "Iaciara",
          "Iacri",
          "Iapu",
          "Iaras",
          "Iati",
          "Iaçu",
          "Ibaiti",
          "Ibarama",
          "Ibaretama",
          "Ibateguara",
          "Ibatiba",
          "Ibaté",
          "Ibema",
          "Ibertioga",
          "Ibiam",
          "Ibiapina",
          "Ibiara",
          "Ibiassucê",
          "Ibiaçá",
          "Ibiaí",
          "Ibicaraí",
          "Ibicaré",
          "Ibicoara",
          "Ibicuitinga",
          "Ibicuí",
          "Ibimirim",
          "Ibipeba",
          "Ibipitanga",
          "Ibiporã",
          "Ibiquera",
          "Ibiracatu",
          "Ibiraci",
          "Ibiraiaras",
          "Ibirajuba",
          "Ibirama",
          "Ibirapitanga",
          "Ibirapuitã",
          "Ibirapuã",
          "Ibirarema",
          "Ibirataia",
          "Ibiraçu",
          "Ibirité",
          "Ibirubá",
          "Ibirá",
          "Ibitiara",
          "Ibitinga",
          "Ibitirama",
          "Ibititá",
          "Ibitiúra de Minas",
          "Ibituruna",
          "Ibiá",
          "Ibiúna",
          "Ibotirama",
          "Icapuí",
          "Icaraí de Minas",
          "Icaraíma",
          "Icatu",
          "Ichu",
          "Iconha",
          "Icém",
          "Icó",
          "Ielmo Marinho",
          "Iepê",
          "Igaci",
          "Igaporã",
          "Igaracy",
          "Igarapava",
          "Igarapé",
          "Igarapé Grande",
          "Igarapé do Meio",
          "Igarapé-Açu",
          "Igarapé-Miri",
          "Igarassu",
          "Igaratinga",
          "Igaratá",
          "Igaraçu do Tietê",
          "Igrapiúna",
          "Igreja Nova",
          "Igrejinha",
          "Iguaba Grande",
          "Iguape",
          "Iguaraci",
          "Iguaraçu",
          "Iguatama",
          "Iguatemi",
          "Iguatu",
          "Iguaí",
          "Ijaci",
          "Ijuí",
          "Ilha Comprida",
          "Ilha Grande",
          "Ilha Solteira",
          "Ilha das Flores",
          "Ilhabela",
          "Ilhota",
          "Ilhéus",
          "Ilicínea",
          "Ilópolis",
          "Imaculada",
          "Imaruí",
          "Imbaú",
          "Imbituba",
          "Imbituva",
          "Imbuia",
          "Imbé",
          "Imbé de Minas",
          "Imigrante",
          "Imperatriz",
          "Inaciolândia",
          "Inajá",
          "Inconfidentes",
          "Indaiabira",
          "Indaial",
          "Indaiatuba",
          "Independência",
          "Indiana",
          "Indianópolis",
          "Indiaporã",
          "Indiara",
          "Indiaroba",
          "Indiavaí",
          "Ingazeira",
          "Ingaí",
          "Ingá",
          "Inhacorá",
          "Inhambupe",
          "Inhangapi",
          "Inhapi",
          "Inhapim",
          "Inhaúma",
          "Inhuma",
          "Inhumas",
          "Inimutaba",
          "Inocência",
          "Inácio Martins",
          "Inúbia Paulista",
          "Iomerê",
          "Ipaba",
          "Ipameri",
          "Ipanema",
          "Ipanguaçu",
          "Ipaporanga",
          "Ipatinga",
          "Ipaumirim",
          "Ipauçu",
          "Ipecaetá",
          "Iperó",
          "Ipeúna",
          "Ipiaçu",
          "Ipiaú",
          "Ipiguá",
          "Ipira",
          "Ipiranga",
          "Ipiranga de Goiás",
          "Ipiranga do Piauí",
          "Ipiranga do Sul",
          "Ipirá",
          "Ipixuna",
          "Ipixuna do Pará",
          "Ipojuca",
          "Iporanga",
          "Iporá",
          "Iporã",
          "Iporã do Oeste",
          "Ipu",
          "Ipuaçu",
          "Ipubi",
          "Ipueira",
          "Ipueiras",
          "Ipuiúna",
          "Ipumirim",
          "Ipupiara",
          "Ipuã",
          "Ipê",
          "Iracema",
          "Iracema do Oeste",
          "Iraceminha",
          "Iracemápolis",
          "Irajuba",
          "Iramaia",
          "Iranduba",
          "Irani",
          "Irapuru",
          "Irapuã",
          "Iraquara",
          "Irará",
          "Irati",
          "Irauçuba",
          "Iraí",
          "Iraí de Minas",
          "Irecê",
          "Iretama",
          "Irineópolis",
          "Irituia",
          "Irupi",
          "Isaías Coelho",
          "Israelândia",
          "Itaara",
          "Itabaiana",
          "Itabaianinha",
          "Itabela",
          "Itaberaba",
          "Itaberaí",
          "Itaberá",
          "Itabi",
          "Itabira",
          "Itabirinha de Mantena",
          "Itabirito",
          "Itaboraí",
          "Itabuna",
          "Itacajá",
          "Itacambira",
          "Itacarambi",
          "Itacaré",
          "Itacoatiara",
          "Itacuruba",
          "Itacurubi",
          "Itaeté",
          "Itagi",
          "Itagibá",
          "Itagimirim",
          "Itaguajé",
          "Itaguara",
          "Itaguari",
          "Itaguaru",
          "Itaguatins",
          "Itaguaçu",
          "Itaguaçu da Bahia",
          "Itaguaí",
          "Itainópolis",
          "Itaipava do Grajaú",
          "Itaipulândia",
          "Itaipé",
          "Itaitinga",
          "Itaituba",
          "Itaiçaba",
          "Itaiópolis",
          "Itajaí",
          "Itajobi",
          "Itaju",
          "Itaju do Colônia",
          "Itajubá",
          "Itajuípe",
          "Itajá",
          "Italva",
          "Itamaracá",
          "Itamaraju",
          "Itamarandiba",
          "Itamarati",
          "Itamarati de Minas",
          "Itamari",
          "Itambacuri",
          "Itambaracá",
          "Itambé",
          "Itambé do Mato Dentro",
          "Itamogi",
          "Itamonte",
          "Itanagra",
          "Itanhandu",
          "Itanhaém",
          "Itanhomi",
          "Itanhém",
          "Itaobim",
          "Itaocara",
          "Itapaci",
          "Itapagipe",
          "Itapagé",
          "Itaparica",
          "Itapebi",
          "Itapecerica",
          "Itapecerica da Serra",
          "Itapecuru Mirim",
          "Itapejara d'Oeste",
          "Itapema",
          "Itapemirim",
          "Itaperuna",
          "Itaperuçu",
          "Itapetim",
          "Itapetinga",
          "Itapetininga",
          "Itapeva",
          "Itapevi",
          "Itapicuru",
          "Itapipoca",
          "Itapira",
          "Itapiranga",
          "Itapirapuã",
          "Itapirapuã Paulista",
          "Itapiratins",
          "Itapissuma",
          "Itapitanga",
          "Itapiúna",
          "Itaporanga",
          "Itaporanga d'Ajuda",
          "Itapororoca",
          "Itaporã",
          "Itaporã do Tocantins",
          "Itapoá",
          "Itapuca",
          "Itapura",
          "Itapuranga",
          "Itapuã do Oeste",
          "Itapuí",
          "Itapé",
          "Itaquaquecetuba",
          "Itaquara",
          "Itaqui",
          "Itaquiraí",
          "Itaquitinga",
          "Itarana",
          "Itarantim",
          "Itararé",
          "Itarema",
          "Itariri",
          "Itarumã",
          "Itati",
          "Itatiaia",
          "Itatiaiuçu",
          "Itatiba",
          "Itatiba do Sul",
          "Itatim",
          "Itatinga",
          "Itatira",
          "Itatuba",
          "Itaubal",
          "Itaueira",
          "Itauçu",
          "Itaverava",
          "Itaí",
          "Itaíba",
          "Itaóca",
          "Itaú",
          "Itaú de Minas",
          "Itaúba",
          "Itaúna",
          "Itaúna do Sul",
          "Itinga",
          "Itinga do Maranhão",
          "Itiquira",
          "Itirapina",
          "Itirapuã",
          "Itiruçu",
          "Itiúba",
          "Itobi",
          "Itororó",
          "Itu",
          "Ituaçu",
          "Ituberá",
          "Itueta",
          "Ituiutaba",
          "Itumbiara",
          "Itumirim",
          "Itupeva",
          "Itupiranga",
          "Ituporanga",
          "Iturama",
          "Itutinga",
          "Ituverava",
          "Itá",
          "Itápolis",
          "Iuiú",
          "Ivaiporã",
          "Ivatuba",
          "Ivaté",
          "Ivaí",
          "Ivinhema",
          "Ivolândia",
          "Ivorá",
          "Ivoti",
          "Içara",
          "Iúna",
          "Jaboatão dos Guararapes",
          "Jaborandi",
          "Jaborá",
          "Jaboti",
          "Jaboticaba",
          "Jaboticabal",
          "Jaboticatubas",
          "Jacaraci",
          "Jacaraú",
          "Jacareacanga",
          "Jacarezinho",
          "Jacareí",
          "Jacaré dos Homens",
          "Jaci",
          "Jaciara",
          "Jacinto",
          "Jacinto Machado",
          "Jacobina",
          "Jacobina do Piauí",
          "Jacuizinho",
          "Jacundá",
          "Jacupiranga",
          "Jacutinga",
          "Jacuí",
          "Jacuípe",
          "Jaguapitã",
          "Jaguaquara",
          "Jaguarari",
          "Jaguaraçu",
          "Jaguaretama",
          "Jaguari",
          "Jaguariaíva",
          "Jaguaribara",
          "Jaguaribe",
          "Jaguaripe",
          "Jaguariúna",
          "Jaguaruana",
          "Jaguaruna",
          "Jaguarão",
          "Jaguaré",
          "Jaicós",
          "Jales",
          "Jambeiro",
          "Jampruca",
          "Janaúba",
          "Jandaia",
          "Jandaia do Sul",
          "Jandaíra",
          "Jandira",
          "Janduís",
          "Jangada",
          "Janiópolis",
          "Januária",
          "Januário Cicco",
          "Japaratinga",
          "Japaratuba",
          "Japaraíba",
          "Japeri",
          "Japi",
          "Japira",
          "Japoatã",
          "Japonvar",
          "Japorã",
          "Japurá",
          "Jaqueira",
          "Jaquirana",
          "Jaraguari",
          "Jaraguá",
          "Jaraguá do Sul",
          "Jaramataia",
          "Jardim",
          "Jardim Alegre",
          "Jardim Olinda",
          "Jardim de Angicos",
          "Jardim de Piranhas",
          "Jardim do Mulato",
          "Jardim do Seridó",
          "Jardinópolis",
          "Jari",
          "Jarinu",
          "Jaru",
          "Jataizinho",
          "Jataí",
          "Jataúba",
          "Jateí",
          "Jati",
          "Jatobá",
          "Jatobá do Piauí",
          "Jaupaci",
          "Jauru",
          "Jaçanã",
          "Jaíba",
          "Jaú",
          "Jaú do Tocantins",
          "Jeceaba",
          "Jenipapo de Minas",
          "Jenipapo dos Vieiras",
          "Jequeri",
          "Jequitaí",
          "Jequitibá",
          "Jequitinhonha",
          "Jequiá da Praia",
          "Jequié",
          "Jeremoabo",
          "Jericó",
          "Jeriquara",
          "Jerumenha",
          "Jerônimo Monteiro",
          "Jesuânia",
          "Jesuítas",
          "Jesúpolis",
          "Ji-Paraná",
          "Jijoca de Jericoaroara",
          "Jiquiriçá",
          "Jitaúna",
          "Joanésia",
          "Joanópolis",
          "Joaquim Felício",
          "Joaquim Gomes",
          "Joaquim Nabuco",
          "Joaquim Pires",
          "Joaquim Távora",
          "Joaçaba",
          "Joaíma",
          "Joca Marques",
          "Joinville",
          "Jordânia",
          "Jordão",
          "Joselândia",
          "Josenópolis",
          "José Boiteux",
          "José Bonifácio",
          "José Gonçalves de Minas",
          "José Raydan",
          "José da Penha",
          "José de Freitas",
          "Joviânia",
          "João Alfredo",
          "João Costa",
          "João Câmara",
          "João Dias",
          "João Dourado",
          "João Lisboa",
          "João Monlevade",
          "João Neiva",
          "João Pessoa",
          "João Pinheiro",
          "João Ramalho",
          "Juara",
          "Juarez Távora",
          "Juarina",
          "Juatuba",
          "Juazeirinho",
          "Juazeiro",
          "Juazeiro do Norte",
          "Juazeiro do Piauí",
          "Jucati",
          "Jucurutu",
          "Jucuruçu",
          "Jucás",
          "Juiz de Fora",
          "Jumirim",
          "Junco do Maranhão",
          "Junco do Seridó",
          "Jundiaí",
          "Jundiaí do Sul",
          "Jundiá",
          "Junqueiro",
          "Junqueirópolis",
          "Jupi",
          "Jupiá",
          "Juquitiba",
          "Juquiá",
          "Juramento",
          "Juranda",
          "Jurema",
          "Juripiranga",
          "Juru",
          "Juruaia",
          "Juruena",
          "Juruti",
          "Juruá",
          "Juscimeira",
          "Jussara",
          "Jussari",
          "Jussiape",
          "Jutaí",
          "Juti",
          "Juvenília",
          "Juína",
          "Jóia",
          "Júlio Borges",
          "Júlio Mesquita",
          "Júlio de Castilhos",
          "Kaloré",
          "Lacerdópolis",
          "Ladainha",
          "Ladário",
          "Lafaiete Coutinho",
          "Lagamar",
          "Lagarto",
          "Lages",
          "Lago Verde",
          "Lago da Pedra",
          "Lago do Junco",
          "Lago dos Rodrigues",
          "Lagoa",
          "Lagoa Alegre",
          "Lagoa Bonita do Sul",
          "Lagoa Dourada",
          "Lagoa Formosa",
          "Lagoa Grande",
          "Lagoa Grande do Maranhão",
          "Lagoa Nova",
          "Lagoa Real",
          "Lagoa Salgada",
          "Lagoa Santa",
          "Lagoa Seca",
          "Lagoa Vermelha",
          "Lagoa d'Anta",
          "Lagoa da Canoa",
          "Lagoa da Confusão",
          "Lagoa da Prata",
          "Lagoa de Dentro",
          "Lagoa de Pedras",
          "Lagoa de São Francisco",
          "Lagoa de Velhos",
          "Lagoa do Barro do Piauí",
          "Lagoa do Carro",
          "Lagoa do Itaenga",
          "Lagoa do Mato",
          "Lagoa do Ouro",
          "Lagoa do Piauí",
          "Lagoa do Sítio",
          "Lagoa do Tocantins",
          "Lagoa dos Gatos",
          "Lagoa dos Patos",
          "Lagoa dos Três Cantos",
          "Lagoinha",
          "Lagoinha do Piauí",
          "Lagoão",
          "Laguna",
          "Laguna Carapã",
          "Laje",
          "Laje do Muriaé",
          "Lajeado",
          "Lajeado Grande",
          "Lajeado Novo",
          "Lajeado do Bugre",
          "Lajedinho",
          "Lajedo",
          "Lajedo do Tabocal",
          "Lajedão",
          "Lajes",
          "Lajes Pintadas",
          "Lajinha",
          "Lamarão",
          "Lambari",
          "Lambari d'Oeste",
          "Lamim",
          "Landri Sales",
          "Lapa",
          "Lapão",
          "Laranja da Terra",
          "Laranjal",
          "Laranjal Paulista",
          "Laranjal do Jari",
          "Laranjeiras",
          "Laranjeiras do Sul",
          "Lassance",
          "Lastro",
          "Laurentino",
          "Lauro Muller",
          "Lauro de Freitas",
          "Lavandeira",
          "Lavras",
          "Lavras da Mangabeira",
          "Lavras do Sul",
          "Lavrinhas",
          "Lavínia",
          "Leandro Ferreira",
          "Lebon Régis",
          "Leme",
          "Leme do Prado",
          "Lençóis",
          "Lençóis Paulista",
          "Leoberto Leal",
          "Leopoldina",
          "Leopoldo de Bulhões",
          "Leópolis",
          "Liberato Salzano",
          "Liberdade",
          "Licínio de Almeida",
          "Lidianópolis",
          "Lima Campos",
          "Lima Duarte",
          "Limeira",
          "Limeira do Oeste",
          "Limoeiro",
          "Limoeiro de Anadia",
          "Limoeiro do Ajuru",
          "Limoeiro do Norte",
          "Lindoeste",
          "Lindolfo Collor",
          "Lindóia",
          "Lindóia do Sul",
          "Linha Nova",
          "Linhares",
          "Lins",
          "Livramento",
          "Livramento de Nossa Senhora",
          "Lizarda",
          "Loanda",
          "Lobato",
          "Logradouro",
          "Londrina",
          "Lontra",
          "Lontras",
          "Lorena",
          "Loreto",
          "Lourdes",
          "Louveira",
          "Lucas do Rio Verde",
          "Lucena",
          "Lucianópolis",
          "Luciára",
          "Lucrécia",
          "Lucélia",
          "Luisburgo",
          "Luislândia",
          "Luiz Alves",
          "Luiziana",
          "Luiziânia",
          "Luminárias",
          "Lunardelli",
          "Lupionópolis",
          "Lupércio",
          "Lutécia",
          "Luz",
          "Luzerna",
          "Luzilândia",
          "Luzinópolis",
          "Luziânia",
          "Luís Antônio",
          "Luís Correia",
          "Luís Domingues",
          "Luís Eduardo Magalhães",
          "Luís Gomes",
          "Lábrea",
          "Macajuba",
          "Macambira",
          "Macaparana",
          "Macapá",
          "Macarani",
          "Macatuba",
          "Macau",
          "Macaubal",
          "Macaé",
          "Macaíba",
          "Macaúbas",
          "Macedônia",
          "Maceió",
          "Machacalis",
          "Machadinho",
          "Machadinho d'Oeste",
          "Machado",
          "Machados",
          "Macieira",
          "Macuco",
          "Macururé",
          "Madalena",
          "Madeiro",
          "Madre de Deus",
          "Madre de Deus de Minas",
          "Maetinga",
          "Mafra",
          "Magalhães Barata",
          "Magalhães de Almeida",
          "Magda",
          "Magé",
          "Maiquinique",
          "Mairi",
          "Mairinque",
          "Mairiporã",
          "Mairipotaba",
          "Major Gercino",
          "Major Isidoro",
          "Major Sales",
          "Major Vieira",
          "Malacacheta",
          "Malhada",
          "Malhada de Pedras",
          "Malhada dos Bois",
          "Malhador",
          "Mallet",
          "Malta",
          "Mamanguape",
          "Mambaí",
          "Mamborê",
          "Mamonas",
          "Mampituba",
          "Manacapuru",
          "Manaquiri",
          "Manari",
          "Manaus",
          "Manaíra",
          "Mandaguari",
          "Mandaguaçu",
          "Mandirituba",
          "Manduri",
          "Manfrinópolis",
          "Manga",
          "Mangaratiba",
          "Mangueirinha",
          "Manhuaçu",
          "Manhumirim",
          "Manicoré",
          "Manoel Emídio",
          "Manoel Ribas",
          "Manoel Urbano",
          "Manoel Viana",
          "Manoel Vitorino",
          "Mansidão",
          "Mantena",
          "Mantenópolis",
          "Maquiné",
          "Mar Vermelho",
          "Mar de Espanha",
          "Mara Rosa",
          "Marabá",
          "Marabá Paulista",
          "Maracaju",
          "Maracajá",
          "Maracanaú",
          "Maracanã",
          "Maracaçumé",
          "Maracaí",
          "Maracás",
          "Maragogi",
          "Maragogipe",
          "Maraial",
          "Marajá do Sena",
          "Maranguape",
          "Maranhãozinho",
          "Marapanim",
          "Marapoama",
          "Marataizes",
          "Maratá",
          "Marau",
          "Maravilha",
          "Maravilhas",
          "Maraã",
          "Maraú",
          "Marcação",
          "Marcelino Ramos",
          "Marcelino Vieira",
          "Marcelândia",
          "Marcionílio Souza",
          "Marco",
          "Marcolândia",
          "Marcos Parente",
          "Marechal Cândido Rondon",
          "Marechal Deodoro",
          "Marechal Floriano",
          "Marechal Thaumaturgo",
          "Marema",
          "Mari",
          "Maria Helena",
          "Maria da Fé",
          "Marialva",
          "Mariana",
          "Mariana Pimentel",
          "Mariano Moro",
          "Marianópolis do Tocantins",
          "Maribondo",
          "Maricá",
          "Marilac",
          "Marilena",
          "Mariluz",
          "Marilândia",
          "Marilândia do Sul",
          "Maringá",
          "Marinópolis",
          "Maripá",
          "Maripá de Minas",
          "Marituba",
          "Marizópolis",
          "Mariápolis",
          "Mariópolis",
          "Marliéria",
          "Marmeleiro",
          "Marmelópolis",
          "Marques de Souza",
          "Marquinho",
          "Martinho Campos",
          "Martins",
          "Martins Soares",
          "Martinópole",
          "Martinópolis",
          "Maruim",
          "Marumbi",
          "Marzagão",
          "Marília",
          "Mascote",
          "Massapê",
          "Massapê do Piauí",
          "Massaranduba",
          "Mata",
          "Mata Grande",
          "Mata Roma",
          "Mata Verde",
          "Mata de São João",
          "Mataraca",
          "Mateiros",
          "Matelândia",
          "Materlândia",
          "Mateus Leme",
          "Mathias Lobato",
          "Matias Barbosa",
          "Matias Cardoso",
          "Matias Olímpio",
          "Matina",
          "Matinha",
          "Matinhas",
          "Matinhos",
          "Matipó",
          "Mato Castelhano",
          "Mato Grosso",
          "Mato Leitão",
          "Mato Queimado",
          "Mato Rico",
          "Mato Verde",
          "Matos Costa",
          "Matozinhos",
          "Matrinchã",
          "Matriz de Camaragibe",
          "Matupá",
          "Maturéia",
          "Matutina",
          "Matão",
          "Matões",
          "Matões do Norte",
          "Maurilândia",
          "Maurilândia do Tocantins",
          "Mauriti",
          "Mauá",
          "Mauá da Serra",
          "Maués",
          "Maxaranguape",
          "Maximiliano de Almeida",
          "Mazagão",
          "Maçambara",
          "Medeiros",
          "Medeiros Neto",
          "Medianeira",
          "Medicilândia",
          "Medina",
          "Meleiro",
          "Melgaço",
          "Mendes",
          "Mendes Pimentel",
          "Mendonça",
          "Mercedes",
          "Mercês",
          "Meridiano",
          "Meruoca",
          "Mesquita",
          "Messias",
          "Messias Targino",
          "Mesópolis",
          "Miguel Alves",
          "Miguel Calmon",
          "Miguel Leão",
          "Miguel Pereira",
          "Miguelópolis",
          "Milagres",
          "Milagres do Maranhão",
          "Milhã",
          "Milton Brandão",
          "Mimoso de Goiás",
          "Mimoso do Sul",
          "Minador do Negrão",
          "Minas Novas",
          "Minas do Leão",
          "Minaçu",
          "Minduri",
          "Mineiros",
          "Mineiros do Tietê",
          "Ministro Andreazza",
          "Mira Estrela",
          "Mirabela",
          "Miracatu",
          "Miracema",
          "Miracema do Tocantins",
          "Mirador",
          "Miradouro",
          "Miraguaí",
          "Miranda",
          "Miranda do Norte",
          "Mirandiba",
          "Mirandópolis",
          "Mirangaba",
          "Miranorte",
          "Mirante",
          "Mirante da Serra",
          "Mirante do Paranapanema",
          "Miraselva",
          "Mirassol",
          "Mirassol d'Oeste",
          "Mirassolândia",
          "Miravânia",
          "Miraí",
          "Miraíma",
          "Mirim Doce",
          "Mirinzal",
          "Missal",
          "Missão Velha",
          "Mocajuba",
          "Mococa",
          "Modelo",
          "Moeda",
          "Moema",
          "Mogeiro",
          "Mogi das Cruzes",
          "Mogi-Guaçu",
          "Mogi-Mirim",
          "Moiporá",
          "Moita Bonita",
          "Moju",
          "Mombaça",
          "Mombuca",
          "Mondaí",
          "Mongaguá",
          "Monjolos",
          "Monsenhor Gil",
          "Monsenhor Hipólito",
          "Monsenhor Paulo",
          "Monsenhor Tabosa",
          "Montadas",
          "Montalvânia",
          "Montanha",
          "Montanhas",
          "Montauri",
          "Monte Alegre",
          "Monte Alegre de Goiás",
          "Monte Alegre de Minas",
          "Monte Alegre de Sergipe",
          "Monte Alegre do Piauí",
          "Monte Alegre do Sul",
          "Monte Alegre dos Campos",
          "Monte Alto",
          "Monte Aprazível",
          "Monte Azul",
          "Monte Azul Paulista",
          "Monte Belo",
          "Monte Belo do Sul",
          "Monte Carlo",
          "Monte Carmelo",
          "Monte Castelo",
          "Monte Formoso",
          "Monte Horebe",
          "Monte Mor",
          "Monte Negro",
          "Monte Santo",
          "Monte Santo de Minas",
          "Monte Santo do Tocantins",
          "Monte Sião",
          "Monte das Gameleiras",
          "Monte do Carmo",
          "Monteiro",
          "Monteiro Lobato",
          "Monteirópolis",
          "Montenegro",
          "Montes Altos",
          "Montes Claros",
          "Montes Claros de Goiás",
          "Montezuma",
          "Montividiu",
          "Montividiu do Norte",
          "Monção",
          "Monções",
          "Morada Nova",
          "Morada Nova de Minas",
          "Moraújo",
          "Moreilândia",
          "Moreira Sales",
          "Moreno",
          "Mormaço",
          "Morpará",
          "Morretes",
          "Morrinhos",
          "Morrinhos do Sul",
          "Morro Agudo",
          "Morro Agudo de Goiás",
          "Morro Cabeça no Tempo",
          "Morro Grande",
          "Morro Redondo",
          "Morro Reuter",
          "Morro da Fumaça",
          "Morro da Garça",
          "Morro do Chapéu",
          "Morro do Chapéu do Piauí",
          "Morro do Pilar",
          "Morros",
          "Mortugaba",
          "Morungaba",
          "Mossoró",
          "Mossâmedes",
          "Mostardas",
          "Motuca",
          "Mozarlândia",
          "Muaná",
          "Mucajaí",
          "Mucambo",
          "Mucugê",
          "Mucuri",
          "Mucurici",
          "Muitos Capões",
          "Muliterno",
          "Mulungu",
          "Mulungu do Morro",
          "Mundo Novo",
          "Munhoz",
          "Munhoz de Melo",
          "Muniz Ferreira",
          "Muniz Freire",
          "Muqui",
          "Muquém de São Francisco",
          "Muriaé",
          "Muribeca",
          "Murici",
          "Murici dos Portelas",
          "Muricilândia",
          "Muritiba",
          "Murutinga do Sul",
          "Mutum",
          "Mutunópolis",
          "Mutuípe",
          "Muzambinho",
          "Muçum",
          "Mário Campos",
          "Mâncio Lima",
          "Mãe d'Água",
          "Mãe do Rio",
          "Nacip Raydan",
          "Nantes",
          "Nanuque",
          "Naque",
          "Narandiba",
          "Natal",
          "Natalândia",
          "Natividade",
          "Natividade da Serra",
          "Natuba",
          "Natércia",
          "Navegantes",
          "Naviraí",
          "Nazareno",
          "Nazarezinho",
          "Nazaré",
          "Nazaré Paulista",
          "Nazaré da Mata",
          "Nazaré do Piauí",
          "Nazário",
          "Nepomuceno",
          "Nerópolis",
          "Neves Paulista",
          "Neópolis",
          "Nhamundá",
          "Nhandeara",
          "Nicolau Vergueiro",
          "Nilo Peçanha",
          "Nilópolis",
          "Nina Rodrigues",
          "Ninheira",
          "Nioaque",
          "Nipoã",
          "Niquelândia",
          "Niterói",
          "Nobres",
          "Nonoai",
          "Nordestina",
          "Normandia",
          "Nortelândia",
          "Nossa Senhora Aparecida",
          "Nossa Senhora da Glória",
          "Nossa Senhora das Dores",
          "Nossa Senhora das Graças",
          "Nossa Senhora de Lourdes",
          "Nossa Senhora de Nazaré",
          "Nossa Senhora do Livramento",
          "Nossa Senhora do Socorro",
          "Nossa Senhora dos Remédios",
          "Nova Aliança",
          "Nova Aliança do Ivaí",
          "Nova Alvorada",
          "Nova Alvorada do Sul",
          "Nova América",
          "Nova América da Colina",
          "Nova Andradina",
          "Nova Araçá",
          "Nova Aurora",
          "Nova Bandeirantes",
          "Nova Bassano",
          "Nova Belém",
          "Nova Boa Vista",
          "Nova Brasilândia",
          "Nova Brasilândia d'Oeste",
          "Nova Bréscia",
          "Nova Campina",
          "Nova Canaã",
          "Nova Canaã Paulista",
          "Nova Candelária",
          "Nova Cantu",
          "Nova Canãa do Norte",
          "Nova Castilho",
          "Nova Colinas",
          "Nova Crixás",
          "Nova Cruz",
          "Nova Era",
          "Nova Erechim",
          "Nova Esperança",
          "Nova Esperança do Piriá",
          "Nova Esperança do Sudoeste",
          "Nova Esperança do Sul",
          "Nova Europa",
          "Nova Floresta",
          "Nova Friburgo",
          "Nova Fátima",
          "Nova Glória",
          "Nova Granada",
          "Nova Guarita",
          "Nova Guataporanga",
          "Nova Hartz",
          "Nova Ibiá",
          "Nova Iguaçu",
          "Nova Iguaçu de Goiás",
          "Nova Independência",
          "Nova Iorque",
          "Nova Ipixuna",
          "Nova Itaberaba",
          "Nova Itarana",
          "Nova Lacerda",
          "Nova Laranjeiras",
          "Nova Lima",
          "Nova Londrina",
          "Nova Luzitânia",
          "Nova Mamoré",
          "Nova Marilândia",
          "Nova Maringá",
          "Nova Monte Verde",
          "Nova Mutum",
          "Nova Módica",
          "Nova Nazaré",
          "Nova Odessa",
          "Nova Olinda",
          "Nova Olinda do Maranhão",
          "Nova Olinda do Norte",
          "Nova Olímpia",
          "Nova Palma",
          "Nova Palmeira",
          "Nova Petrópolis",
          "Nova Ponte",
          "Nova Porteirinha",
          "Nova Prata",
          "Nova Prata do Iguaçu",
          "Nova Pádua",
          "Nova Ramada",
          "Nova Redenção",
          "Nova Resende",
          "Nova Roma",
          "Nova Roma do Sul",
          "Nova Rosalândia",
          "Nova Russas",
          "Nova Santa Bárbara",
          "Nova Santa Helena",
          "Nova Santa Rita",
          "Nova Santa Rosa",
          "Nova Serrana",
          "Nova Soure",
          "Nova Tebas",
          "Nova Timboteua",
          "Nova Trento",
          "Nova Ubiratã",
          "Nova União",
          "Nova Veneza",
          "Nova Venécia",
          "Nova Viçosa",
          "Nova Xavantina",
          "Novais",
          "Novo Acordo",
          "Novo Airão",
          "Novo Alegre",
          "Novo Aripuanã",
          "Novo Barreiro",
          "Novo Brasil",
          "Novo Cabrais",
          "Novo Cruzeiro",
          "Novo Gama",
          "Novo Hamburgo",
          "Novo Horizonte",
          "Novo Horizonte do Norte",
          "Novo Horizonte do Oeste",
          "Novo Horizonte do Sul",
          "Novo Itacolomi",
          "Novo Jardim",
          "Novo Lino",
          "Novo Machado",
          "Novo Mundo",
          "Novo Oriente",
          "Novo Oriente de Minas",
          "Novo Oriente do Piauí",
          "Novo Planalto",
          "Novo Progresso",
          "Novo Repartimento",
          "Novo Santo Antônio",
          "Novo São Joaquim",
          "Novo Tiradentes",
          "Novo Triunfo",
          "Novo Xingu",
          "Novorizonte",
          "Nuporanga",
          "Não-Me-Toque",
          "Nísia Floresta",
          "Ocara",
          "Ocauçu",
          "Oeiras",
          "Oeiras do Pará",
          "Oiapoque",
          "Olaria",
          "Olho d'Água",
          "Olho d'Água Grande",
          "Olho d'Água das Cunhãs",
          "Olho d'Água das Flores",
          "Olho d'Água do Casado",
          "Olho d'Água do Piauí",
          "Olho-d'Água do Borges",
          "Olhos-d'Água",
          "Olinda",
          "Olinda Nova do Maranhão",
          "Olindina",
          "Olivedos",
          "Oliveira",
          "Oliveira Fortes",
          "Oliveira de Fátima",
          "Oliveira dos Brejinhos",
          "Olivença",
          "Olímpia",
          "Olímpio Noronha",
          "Onda Verde",
          "Onça de Pitangui",
          "Oratórios",
          "Oriente",
          "Orindiúva",
          "Oriximiná",
          "Orizona",
          "Orizânia",
          "Orleans",
          "Orlândia",
          "Orobó",
          "Orocó",
          "Ortigueira",
          "Orós",
          "Osasco",
          "Oscar Bressane",
          "Osvaldo Cruz",
          "Osório",
          "Otacílio Costa",
          "Ouricuri",
          "Ourilândia do Norte",
          "Ourinhos",
          "Ourizona",
          "Ouriçangas",
          "Ouro",
          "Ouro Branco",
          "Ouro Fino",
          "Ouro Preto",
          "Ouro Preto do Oeste",
          "Ouro Velho",
          "Ouro Verde",
          "Ouro Verde de Goiás",
          "Ouro Verde de Minas",
          "Ouro Verde do Oeste",
          "Ouroeste",
          "Ourolândia",
          "Ourém",
          "Ouvidor",
          "Pacaembu",
          "Pacajus",
          "Pacajá",
          "Pacaraima",
          "Pacatuba",
          "Pacoti",
          "Pacujá",
          "Padre Bernardo",
          "Padre Carvalho",
          "Padre Marcos",
          "Padre Paraíso",
          "Paes Landim",
          "Pai Pedro",
          "Paial",
          "Paim Filho",
          "Paineiras",
          "Painel",
          "Pains",
          "Paiva",
          "Paiçandu",
          "Pajeú do Piauí",
          "Palestina",
          "Palestina de Goiás",
          "Palestina do Pará",
          "Palhano",
          "Palhoça",
          "Palma",
          "Palma Sola",
          "Palmares",
          "Palmares Paulista",
          "Palmares do Sul",
          "Palmas",
          "Palmas de Monte Alto",
          "Palmeira",
          "Palmeira d'Oeste",
          "Palmeira das Missões",
          "Palmeira do Piauí",
          "Palmeira dos Índios",
          "Palmeirais",
          "Palmeirante",
          "Palmeiras",
          "Palmeiras de Goiás",
          "Palmeiras do Tocantins",
          "Palmeirina",
          "Palmeirândia",
          "Palmeirópolis",
          "Palmelo",
          "Palminópolis",
          "Palmital",
          "Palmitinho",
          "Palmitos",
          "Palmácia",
          "Palmópolis",
          "Palotina",
          "Panambi",
          "Panamá",
          "Pancas",
          "Panelas",
          "Panorama",
          "Papagaios",
          "Papanduva",
          "Paquetá",
          "Paracambi",
          "Paracatu",
          "Paracuru",
          "Paragominas",
          "Paraguaçu",
          "Paraguaçu Paulista",
          "Paraibano",
          "Paraibuna",
          "Paraipaba",
          "Paraisópolis",
          "Parambu",
          "Paramirim",
          "Paramoti",
          "Paranacity",
          "Paranaguá",
          "Paranaiguara",
          "Paranapanema",
          "Paranapoema",
          "Paranapuã",
          "Paranatama",
          "Paranatinga",
          "Paranavaí",
          "Paranaíba",
          "Paranaíta",
          "Paranhos",
          "Paraná",
          "Paranã",
          "Paraopeba",
          "Parapuã",
          "Parari",
          "Parati",
          "Paratinga",
          "Parauapebas",
          "Parazinho",
          "Paraí",
          "Paraíba do Sul",
          "Paraíso",
          "Paraíso do Norte",
          "Paraíso do Sul",
          "Paraíso do Tocantins",
          "Paraú",
          "Paraúna",
          "Pardinho",
          "Pareci Novo",
          "Parecis",
          "Parelhas",
          "Pariconha",
          "Parintins",
          "Paripiranga",
          "Paripueira",
          "Pariquera-Açu",
          "Parisi",
          "Parnaguá",
          "Parnamirim",
          "Parnarama",
          "Parnaíba",
          "Parobé",
          "Pará de Minas",
          "Passa Quatro",
          "Passa Sete",
          "Passa Tempo",
          "Passa e Fica",
          "Passa-Vinte",
          "Passabém",
          "Passagem",
          "Passagem Franca",
          "Passagem Franca do Piauí",
          "Passira",
          "Passo Fundo",
          "Passo de Camaragibe",
          "Passo de Torres",
          "Passo do Sobrado",
          "Passos",
          "Passos Maia",
          "Pastos Bons",
          "Patis",
          "Pato Bragado",
          "Pato Branco",
          "Patos",
          "Patos de Minas",
          "Patos do Piauí",
          "Patrocínio",
          "Patrocínio Paulista",
          "Patrocínio do Muriaé",
          "Patu",
          "Paty do Alferes",
          "Pau Brasil",
          "Pau d'Arco",
          "Pau d'Arco do Piauí",
          "Pau dos Ferros",
          "Paudalho",
          "Pauini",
          "Paula Cândido",
          "Paula Freitas",
          "Paulicéia",
          "Paulino Neves",
          "Paulista",
          "Paulistana",
          "Paulistas",
          "Paulistânia",
          "Paulo Afonso",
          "Paulo Bento",
          "Paulo Frontin",
          "Paulo Jacinto",
          "Paulo Lopes",
          "Paulo Ramos",
          "Paulo de Faria",
          "Paulínia",
          "Paverama",
          "Pavussu",
          "Pavão",
          "Paço do Lumiar",
          "Peabiru",
          "Pederneiras",
          "Pedra",
          "Pedra Azul",
          "Pedra Bela",
          "Pedra Bonita",
          "Pedra Branca",
          "Pedra Branca do Amapari",
          "Pedra Dourada",
          "Pedra Grande",
          "Pedra Lavrada",
          "Pedra Mole",
          "Pedra Preta",
          "Pedra do Anta",
          "Pedra do Indaiá",
          "Pedralva",
          "Pedranópolis",
          "Pedras Altas",
          "Pedras Grandes",
          "Pedras de Fogo",
          "Pedras de Maria da Cruz",
          "Pedregulho",
          "Pedreira",
          "Pedreiras",
          "Pedrinhas",
          "Pedrinhas Paulista",
          "Pedrinópolis",
          "Pedro Afonso",
          "Pedro Alexandre",
          "Pedro Avelino",
          "Pedro Canário",
          "Pedro Gomes",
          "Pedro II",
          "Pedro Laurentino",
          "Pedro Leopoldo",
          "Pedro Osório",
          "Pedro Régis",
          "Pedro Teixeira",
          "Pedro Velho",
          "Pedro de Toledo",
          "Pedro do Rosário",
          "Pedrão",
          "Peixe",
          "Peixe-Boi",
          "Peixoto de Azevedo",
          "Pejuçara",
          "Pelotas",
          "Penaforte",
          "Penalva",
          "Pendências",
          "Penedo",
          "Penha",
          "Pentecoste",
          "Penápolis",
          "Pequeri",
          "Pequi",
          "Pequizeiro",
          "Perdigão",
          "Perdizes",
          "Perdões",
          "Pereira Barreto",
          "Pereiras",
          "Pereiro",
          "Peri Mirim",
          "Periquito",
          "Peritiba",
          "Peritoró",
          "Perobal",
          "Perolândia",
          "Peruíbe",
          "Pescador",
          "Pesqueira",
          "Petrolina",
          "Petrolina de Goiás",
          "Petrolândia",
          "Petrópolis",
          "Peçanha",
          "Piacatu",
          "Piancó",
          "Piatã",
          "Piau",
          "Piaçabuçu",
          "Picada Café",
          "Picos",
          "Picuí",
          "Piedade",
          "Piedade de Caratinga",
          "Piedade de Ponte Nova",
          "Piedade do Rio Grande",
          "Piedade dos Gerais",
          "Pilar",
          "Pilar de Goiás",
          "Pilar do Sul",
          "Pilão Arcado",
          "Pilões",
          "Pilõezinhos",
          "Pimenta",
          "Pimenta Bueno",
          "Pimenteiras",
          "Pimenteiras do Oeste",
          "Pindamonhangaba",
          "Pindaré Mirim",
          "Pindaí",
          "Pindoba",
          "Pindobaçu",
          "Pindorama",
          "Pindorama do Tocantins",
          "Pindoretama",
          "Pingo-d'Água",
          "Pinhais",
          "Pinhal",
          "Pinhal Grande",
          "Pinhal da Serra",
          "Pinhal de São Bento",
          "Pinhalzinho",
          "Pinhalão",
          "Pinheiral",
          "Pinheirinho do Vale",
          "Pinheiro",
          "Pinheiro Machado",
          "Pinheiro Preto",
          "Pinheiros",
          "Pinhão",
          "Pintadas",
          "Pintópolis",
          "Pio IX",
          "Pio XII",
          "Piquerobi",
          "Piquet Carneiro",
          "Piquete",
          "Piracaia",
          "Piracanjuba",
          "Piracema",
          "Piracicaba",
          "Piracuruca",
          "Piraju",
          "Pirajuba",
          "Pirajuí",
          "Pirambu",
          "Piranga",
          "Pirangi",
          "Piranguinho",
          "Piranguçu",
          "Piranhas",
          "Pirapemas",
          "Pirapetinga",
          "Pirapora",
          "Pirapora do Bom Jesus",
          "Pirapozinho",
          "Pirapó",
          "Piraquara",
          "Piraquê",
          "Pirassununga",
          "Piratini",
          "Piratininga",
          "Piratuba",
          "Piraí",
          "Piraí do Norte",
          "Piraí do Sul",
          "Piraúba",
          "Pirenópolis",
          "Pires Ferreira",
          "Pires do Rio",
          "Piripiri",
          "Piripá",
          "Piritiba",
          "Pirpirituba",
          "Pitanga",
          "Pitangueiras",
          "Pitangui",
          "Pitimbu",
          "Pium",
          "Piumhi",
          "Piçarra",
          "Piçarras",
          "Piên",
          "Piúma",
          "Placas",
          "Planaltina",
          "Planaltina do Paraná",
          "Planaltino",
          "Planalto",
          "Planalto Alegre",
          "Planalto da Serra",
          "Planura",
          "Platina",
          "Plácido de Castro",
          "Pocinhos",
          "Poconé",
          "Pocrane",
          "Pojuca",
          "Poloni",
          "Pombal",
          "Pombos",
          "Pomerode",
          "Pompéia",
          "Pompéu",
          "Pongaí",
          "Ponta Grossa",
          "Ponta Porã",
          "Ponta de Pedras",
          "Pontal",
          "Pontal do Araguaia",
          "Pontal do Paraná",
          "Pontalina",
          "Pontalinda",
          "Ponte Alta",
          "Ponte Alta do Bom Jesus",
          "Ponte Alta do Norte",
          "Ponte Alta do Tocantins",
          "Ponte Branca",
          "Ponte Nova",
          "Ponte Preta",
          "Ponte Serrada",
          "Pontes Gestal",
          "Pontes e Lacerda",
          "Ponto Belo",
          "Ponto Chique",
          "Ponto Novo",
          "Ponto dos Volantes",
          "Pontão",
          "Populina",
          "Poranga",
          "Porangaba",
          "Porangatu",
          "Porciúncula",
          "Porecatu",
          "Portalegre",
          "Porteiras",
          "Porteirinha",
          "Porteirão",
          "Portel",
          "Portelândia",
          "Porto",
          "Porto Acre",
          "Porto Alegre",
          "Porto Alegre do Norte",
          "Porto Alegre do Piauí",
          "Porto Alegre do Tocantins",
          "Porto Amazonas",
          "Porto Barreiro",
          "Porto Belo",
          "Porto Calvo",
          "Porto Esperidião",
          "Porto Estrela",
          "Porto Feliz",
          "Porto Ferreira",
          "Porto Firme",
          "Porto Franco",
          "Porto Grande",
          "Porto Lucena",
          "Porto Mauá",
          "Porto Murtinho",
          "Porto Nacional",
          "Porto Real",
          "Porto Real do Colégio",
          "Porto Rico",
          "Porto Rico do Maranhão",
          "Porto Seguro",
          "Porto União",
          "Porto Velho",
          "Porto Vera Cruz",
          "Porto Vitória",
          "Porto Walter",
          "Porto Xavier",
          "Porto da Folha",
          "Porto de Moz",
          "Porto de Pedras",
          "Porto do Mangue",
          "Porto dos Gaúchos",
          "Portão",
          "Posse",
          "Potengi",
          "Potim",
          "Potiraguá",
          "Potirendaba",
          "Potiretama",
          "Poté",
          "Pouso Alegre",
          "Pouso Alto",
          "Pouso Novo",
          "Pouso Redondo",
          "Poxoréo",
          "Poá",
          "Poço Branco",
          "Poço Dantas",
          "Poço Fundo",
          "Poço Redondo",
          "Poço Verde",
          "Poço das Antas",
          "Poço das Trincheiras",
          "Poço de José de Moura",
          "Poços de Caldas",
          "Poção",
          "Poção de Pedras",
          "Poções",
          "Pracinha",
          "Pracuúba",
          "Prado",
          "Prado Ferreira",
          "Prados",
          "Pradópolis",
          "Praia Grande",
          "Praia Norte",
          "Prainha",
          "Pranchita",
          "Prata",
          "Prata do Piauí",
          "Pratinha",
          "Pratápolis",
          "Pratânia",
          "Presidente Alves",
          "Presidente Bernardes",
          "Presidente Castelo Branco",
          "Presidente Dutra",
          "Presidente Epitácio",
          "Presidente Figueiredo",
          "Presidente Getúlio",
          "Presidente Juscelino",
          "Presidente Jânio Quadros",
          "Presidente Kennedy",
          "Presidente Kubitschek",
          "Presidente Lucena",
          "Presidente Médici",
          "Presidente Nereu",
          "Presidente Olegário",
          "Presidente Prudente",
          "Presidente Sarney",
          "Presidente Tancredo Neves",
          "Presidente Vargas",
          "Presidente Venceslau",
          "Primavera",
          "Primavera de Rondônia",
          "Primavera do Leste",
          "Primeira Cruz",
          "Primeiro de Maio",
          "Princesa",
          "Princesa Isabel",
          "Professor Jamil",
          "Progresso",
          "Promissão",
          "Propriá",
          "Protásio Alves",
          "Prudente de Morais",
          "Prudentópolis",
          "Pugmil",
          "Pureza",
          "Putinga",
          "Puxinanã",
          "Pântano Grande",
          "Pão de Açúcar",
          "Pé de Serra",
          "Pérola",
          "Pérola d'Oeste",
          "Quadra",
          "Quaraí",
          "Quartel Geral",
          "Quarto Centenário",
          "Quatiguá",
          "Quatipuru",
          "Quatis",
          "Quatro Barras",
          "Quatro Irmãos",
          "Quatro Pontes",
          "Quatá",
          "Quebrangulo",
          "Quedas do Iguaçu",
          "Queimada Nova",
          "Queimadas",
          "Queimados",
          "Queiroz",
          "Queluz",
          "Queluzito",
          "Querência",
          "Querência do Norte",
          "Quevedos",
          "Quijingue",
          "Quilombo",
          "Quinta do Sol",
          "Quintana",
          "Quinze de Novembro",
          "Quipapá",
          "Quirinópolis",
          "Quissamã",
          "Quitandinha",
          "Quiterianópolis",
          "Quixaba",
          "Quixabeira",
          "Quixabá",
          "Quixadá",
          "Quixelô",
          "Quixeramobim",
          "Quixeré",
          "Rafael Fernandes",
          "Rafael Godeiro",
          "Rafael Jambeiro",
          "Rafard",
          "Ramilândia",
          "Rancharia",
          "Rancho Alegre",
          "Rancho Alegre d'Oeste",
          "Rancho Queimado",
          "Raposa",
          "Raposos",
          "Raul Soares",
          "Realeza",
          "Rebouças",
          "Recife",
          "Recreio",
          "Recursolândia",
          "Redentora",
          "Redenção",
          "Redenção da Serra",
          "Redenção do Gurguéia",
          "Reduto",
          "Regeneração",
          "Regente Feijó",
          "Reginópolis",
          "Registro",
          "Relvado",
          "Remanso",
          "Remígio",
          "Renascença",
          "Reriutaba",
          "Resende",
          "Resende Costa",
          "Reserva",
          "Reserva do Cabaçal",
          "Reserva do Iguaçu",
          "Resplendor",
          "Ressaquinha",
          "Restinga",
          "Restinga Seca",
          "Retirolândia",
          "Riachinho",
          "Riacho Frio",
          "Riacho da Cruz",
          "Riacho das Almas",
          "Riacho de Santana",
          "Riacho de Santo Antônio",
          "Riacho dos Cavalos",
          "Riacho dos Machados",
          "Riachuelo",
          "Riachão",
          "Riachão das Neves",
          "Riachão do Bacamarte",
          "Riachão do Dantas",
          "Riachão do Jacuípe",
          "Riachão do Poço",
          "Rialma",
          "Rianápolis",
          "Ribamar Fiquene",
          "Ribas do Rio Pardo",
          "Ribeira",
          "Ribeira do Amparo",
          "Ribeira do Piauí",
          "Ribeira do Pombal",
          "Ribeiro Gonçalves",
          "Ribeirão",
          "Ribeirão Bonito",
          "Ribeirão Branco",
          "Ribeirão Cascalheira",
          "Ribeirão Claro",
          "Ribeirão Corrente",
          "Ribeirão Grande",
          "Ribeirão Pires",
          "Ribeirão Preto",
          "Ribeirão Vermelho",
          "Ribeirão das Neves",
          "Ribeirão do Largo",
          "Ribeirão do Pinhal",
          "Ribeirão do Sul",
          "Ribeirão dos Índios",
          "Ribeirãozinho",
          "Ribeirópolis",
          "Rifaina",
          "Rincão",
          "Rinópolis",
          "Rio Acima",
          "Rio Azul",
          "Rio Bananal",
          "Rio Bom",
          "Rio Bonito",
          "Rio Bonito do Iguaçu",
          "Rio Branco",
          "Rio Branco do Ivaí",
          "Rio Branco do Sul",
          "Rio Brilhante",
          "Rio Casca",
          "Rio Claro",
          "Rio Crespo",
          "Rio Doce",
          "Rio Espera",
          "Rio Formoso",
          "Rio Fortuna",
          "Rio Grande",
          "Rio Grande da Serra",
          "Rio Grande do Piauí",
          "Rio Largo",
          "Rio Manso",
          "Rio Maria",
          "Rio Negrinho",
          "Rio Negro",
          "Rio Novo",
          "Rio Novo do Sul",
          "Rio Paranaíba",
          "Rio Pardo",
          "Rio Pardo de Minas",
          "Rio Piracicaba",
          "Rio Pomba",
          "Rio Preto",
          "Rio Preto da Eva",
          "Rio Quente",
          "Rio Real",
          "Rio Rufino",
          "Rio Sono",
          "Rio Tinto",
          "Rio Verde",
          "Rio Verde de Mato Grosso",
          "Rio Vermelho",
          "Rio da Conceição",
          "Rio das Antas",
          "Rio das Flores",
          "Rio das Ostras",
          "Rio das Pedras",
          "Rio de Contas",
          "Rio de Janeiro",
          "Rio do Antônio",
          "Rio do Campo",
          "Rio do Fogo",
          "Rio do Oeste",
          "Rio do Pires",
          "Rio do Prado",
          "Rio do Sul",
          "Rio dos Bois",
          "Rio dos Cedros",
          "Rio dos Índios",
          "Riolândia",
          "Riozinho",
          "Riqueza",
          "Ritápolis",
          "Riversul",
          "Roca Sales",
          "Rochedo",
          "Rochedo de Minas",
          "Rodeio",
          "Rodeio Bonito",
          "Rodeiro",
          "Rodelas",
          "Rodolfo Fernandes",
          "Rodrigues Alves",
          "Rolador",
          "Rolante",
          "Rolim de Moura",
          "Rolândia",
          "Romaria",
          "Romelândia",
          "Roncador",
          "Ronda Alta",
          "Rondinha",
          "Rondolândia",
          "Rondon",
          "Rondon do Pará",
          "Rondonópolis",
          "Roque Gonzales",
          "Rorainópolis",
          "Rosana",
          "Roseira",
          "Rosário",
          "Rosário Oeste",
          "Rosário da Limeira",
          "Rosário do Catete",
          "Rosário do Ivaí",
          "Rosário do Sul",
          "Roteiro",
          "Rubelita",
          "Rubiataba",
          "Rubim",
          "Rubinéia",
          "Rubiácea",
          "Rurópolis",
          "Russas",
          "Ruy Barbosa",
          "Sabará",
          "Sabino",
          "Sabinópolis",
          "Saboeiro",
          "Sabáudia",
          "Sacramento",
          "Sagrada Família",
          "Sagres",
          "Sairé",
          "Saldanha Marinho",
          "Sales",
          "Sales Oliveira",
          "Salesópolis",
          "Salete",
          "Salgadinho",
          "Salgado",
          "Salgado Filho",
          "Salgado de São Félix",
          "Salgueiro",
          "Salinas",
          "Salinas da Margarida",
          "Salinópolis",
          "Salitre",
          "Salmourão",
          "Saloá",
          "Saltinho",
          "Salto",
          "Salto Grande",
          "Salto Veloso",
          "Salto da Divisa",
          "Salto de Pirapora",
          "Salto do Céu",
          "Salto do Itararé",
          "Salto do Jacuí",
          "Salto do Lontra",
          "Salvador",
          "Salvador das Missões",
          "Salvador do Sul",
          "Salvaterra",
          "Sambaíba",
          "Sampaio",
          "Sananduva",
          "Sanclerlândia",
          "Sandolândia",
          "Sandovalina",
          "Sangão",
          "Sanharó",
          "Santa Adélia",
          "Santa Albertina",
          "Santa Amélia",
          "Santa Branca",
          "Santa Brígida",
          "Santa Bárbara",
          "Santa Bárbara d'Oeste",
          "Santa Bárbara de Goiás",
          "Santa Bárbara do Leste",
          "Santa Bárbara do Monte Verde",
          "Santa Bárbara do Pará",
          "Santa Bárbara do Sul",
          "Santa Bárbara do Tugúrio",
          "Santa Carmem",
          "Santa Cecília",
          "Santa Cecília do Pavão",
          "Santa Cecília do Sul",
          "Santa Clara d'Oeste",
          "Santa Clara do Sul",
          "Santa Cruz",
          "Santa Cruz Cabrália",
          "Santa Cruz Monte Castelo",
          "Santa Cruz da Baixa Verde",
          "Santa Cruz da Conceição",
          "Santa Cruz da Esperança",
          "Santa Cruz da Vitória",
          "Santa Cruz das Palmeiras",
          "Santa Cruz de Goiás",
          "Santa Cruz de Minas",
          "Santa Cruz de Salinas",
          "Santa Cruz do Arari",
          "Santa Cruz do Capibaribe",
          "Santa Cruz do Escalvado",
          "Santa Cruz do Piauí",
          "Santa Cruz do Rio Pardo",
          "Santa Cruz do Sul",
          "Santa Cruz do Xingu",
          "Santa Cruz dos Milagres",
          "Santa Efigênia de Minas",
          "Santa Ernestina",
          "Santa Filomena",
          "Santa Filomena do Maranhão",
          "Santa Fé",
          "Santa Fé de Goiás",
          "Santa Fé de Minas",
          "Santa Fé do Araguaia",
          "Santa Fé do Sul",
          "Santa Gertrudes",
          "Santa Helena",
          "Santa Helena de Goiás",
          "Santa Helena de Minas",
          "Santa Inês",
          "Santa Isabel",
          "Santa Isabel do Ivaí",
          "Santa Isabel do Pará",
          "Santa Isabel do Rio Negro",
          "Santa Izabel do Oeste",
          "Santa Juliana",
          "Santa Leopoldina",
          "Santa Luz",
          "Santa Luzia",
          "Santa Luzia d'Oeste",
          "Santa Luzia do Itanhy",
          "Santa Luzia do Norte",
          "Santa Luzia do Paruá",
          "Santa Luzia do Pará",
          "Santa Lúcia",
          "Santa Margarida",
          "Santa Margarida do Sul",
          "Santa Maria",
          "Santa Maria Madalena",
          "Santa Maria da Boa Vista",
          "Santa Maria da Serra",
          "Santa Maria da Vitória",
          "Santa Maria das Barreiras",
          "Santa Maria de Itabira",
          "Santa Maria de Jetibá",
          "Santa Maria do Cambucá",
          "Santa Maria do Herval",
          "Santa Maria do Oeste",
          "Santa Maria do Pará",
          "Santa Maria do Salto",
          "Santa Maria do Suaçuí",
          "Santa Maria do Tocantins",
          "Santa Mariana",
          "Santa Mercedes",
          "Santa Mônica",
          "Santa Quitéria",
          "Santa Quitéria do Maranhão",
          "Santa Rita",
          "Santa Rita d'Oeste",
          "Santa Rita de Caldas",
          "Santa Rita de Cássia",
          "Santa Rita de Ibitipoca",
          "Santa Rita de Jacutinga",
          "Santa Rita de Minas",
          "Santa Rita do Araguaia",
          "Santa Rita do Itueto",
          "Santa Rita do Novo Destino",
          "Santa Rita do Pardo",
          "Santa Rita do Passa Quatro",
          "Santa Rita do Sapucaí",
          "Santa Rita do Tocantins",
          "Santa Rita do Trivelato",
          "Santa Rosa",
          "Santa Rosa da Serra",
          "Santa Rosa de Goiás",
          "Santa Rosa de Lima",
          "Santa Rosa de Viterbo",
          "Santa Rosa do Piauí",
          "Santa Rosa do Purus",
          "Santa Rosa do Sul",
          "Santa Rosa do Tocantins",
          "Santa Salete",
          "Santa Teresa",
          "Santa Teresinha",
          "Santa Tereza",
          "Santa Tereza de Goiás",
          "Santa Tereza do Oeste",
          "Santa Tereza do Tocantins",
          "Santa Terezinha",
          "Santa Terezinha Tocantins",
          "Santa Terezinha de Goiás",
          "Santa Terezinha de Itaipu",
          "Santa Terezinha do Progresso",
          "Santa Vitória",
          "Santa Vitória do Palmar",
          "Santaluz",
          "Santana",
          "Santana da Boa Vista",
          "Santana da Ponte Pensa",
          "Santana da Vargem",
          "Santana de Cataguases",
          "Santana de Mangueira",
          "Santana de Parnaíba",
          "Santana de Pirapama",
          "Santana do Acaraú",
          "Santana do Araguaia",
          "Santana do Cariri",
          "Santana do Deserto",
          "Santana do Garambéu",
          "Santana do Ipanema",
          "Santana do Itararé",
          "Santana do Jacaré",
          "Santana do Livramento",
          "Santana do Manhuaçu",
          "Santana do Maranhão",
          "Santana do Matos",
          "Santana do Mundaú",
          "Santana do Paraíso",
          "Santana do Piauí",
          "Santana do Riacho",
          "Santana do Seridó",
          "Santana do São Francisco",
          "Santana dos Garrotes",
          "Santana dos Montes",
          "Santanópolis",
          "Santarém",
          "Santarém Novo",
          "Santiago",
          "Santiago do Sul",
          "Santo Afonso",
          "Santo Amaro",
          "Santo Amaro da Imperatriz",
          "Santo Amaro das Brotas",
          "Santo Amaro do Maranhão",
          "Santo Anastácio",
          "Santo André",
          "Santo Antônio",
          "Santo Antônio da Alegria",
          "Santo Antônio da Barra",
          "Santo Antônio da Patrulha",
          "Santo Antônio da Platina",
          "Santo Antônio das Missões",
          "Santo Antônio de Goiás",
          "Santo Antônio de Jesus",
          "Santo Antônio de Lisboa",
          "Santo Antônio de Posse",
          "Santo Antônio de Pádua",
          "Santo Antônio do Amparo",
          "Santo Antônio do Aracanguá",
          "Santo Antônio do Aventureiro",
          "Santo Antônio do Caiuá",
          "Santo Antônio do Descoberto",
          "Santo Antônio do Grama",
          "Santo Antônio do Itambé",
          "Santo Antônio do Içá",
          "Santo Antônio do Jacinto",
          "Santo Antônio do Jardim",
          "Santo Antônio do Leste",
          "Santo Antônio do Leverger",
          "Santo Antônio do Monte",
          "Santo Antônio do Palma",
          "Santo Antônio do Paraíso",
          "Santo Antônio do Pinhal",
          "Santo Antônio do Planalto",
          "Santo Antônio do Retiro",
          "Santo Antônio do Rio Abaixo",
          "Santo Antônio do Sudoeste",
          "Santo Antônio do Tauá",
          "Santo Antônio dos Lopes",
          "Santo Antônio dos Milagres",
          "Santo Augusto",
          "Santo Cristo",
          "Santo Estêvão",
          "Santo Expedito",
          "Santo Expedito do Sul",
          "Santo Hipólito",
          "Santo Inácio",
          "Santo Inácio do Piauí",
          "Santo Ângelo",
          "Santos",
          "Santos Dumont",
          "Santópolis do Aguapeí",
          "Sapeaçu",
          "Sapezal",
          "Sapiranga",
          "Sapopema",
          "Sapucaia",
          "Sapucaia do Sul",
          "Sapucaí-Mirim",
          "Sapé",
          "Saquarema",
          "Sarandi",
          "Sarapuí",
          "Sardoá",
          "Sarutaiá",
          "Sarzedo",
          "Satuba",
          "Satubinha",
          "Saubara",
          "Saudade do Iguaçu",
          "Saudades",
          "Saúde",
          "Schroeder",
          "Seabra",
          "Seara",
          "Sebastianópolis do Sul",
          "Sebastião Barros",
          "Sebastião Laranjeiras",
          "Sebastião Leal",
          "Seberi",
          "Sede Nova",
          "Segredo",
          "Selbach",
          "Selvíria",
          "Sem-Peixe",
          "Sena Madureira",
          "Senador Alexandre Costa",
          "Senador Amaral",
          "Senador Canedo",
          "Senador Cortes",
          "Senador Elói de Souza",
          "Senador Firmino",
          "Senador Georgino Avelino",
          "Senador Guiomard",
          "Senador José Bento",
          "Senador José Porfírio",
          "Senador La Rocque",
          "Senador Modestino Gonçalves",
          "Senador Pompeu",
          "Senador Rui Palmeira",
          "Senador Salgado Filho",
          "Senador Sá",
          "Sengés",
          "Senhor do Bonfim",
          "Senhora de Oliveira",
          "Senhora do Porto",
          "Senhora dos Remédios",
          "Sentinela do Sul",
          "Sento Sé",
          "Serafina Corrêa",
          "Sericita",
          "Seridó",
          "Seringueiras",
          "Seritinga",
          "Seropédica",
          "Serra",
          "Serra Alta",
          "Serra Azul",
          "Serra Azul de Minas",
          "Serra Branca",
          "Serra Dourada",
          "Serra Grande",
          "Serra Negra",
          "Serra Negra do Norte",
          "Serra Nova Dourada",
          "Serra Preta",
          "Serra Redonda",
          "Serra Talhada",
          "Serra da Raiz",
          "Serra da Saudade",
          "Serra de São Bento",
          "Serra do Mel",
          "Serra do Navio",
          "Serra do Ramalho",
          "Serra do Salitre",
          "Serra dos Aimorés",
          "Serrana",
          "Serrania",
          "Serrano do Maranhão",
          "Serranos",
          "Serranópolis",
          "Serranópolis de Minas",
          "Serranópolis do Iguaçu",
          "Serraria",
          "Serrinha",
          "Serrinha dos Pintos",
          "Serrita",
          "Serro",
          "Serrolândia",
          "Sertaneja",
          "Sertanópolis",
          "Sertânia",
          "Sertão",
          "Sertão Santana",
          "Sertãozinho",
          "Sete Barras",
          "Sete Lagoas",
          "Sete Quedas",
          "Sete de Setembro",
          "Setubinha",
          "Severiano Melo",
          "Severiano de Almeida",
          "Severínia",
          "Siderópolis",
          "Sidrolândia",
          "Sigefredo Pacheco",
          "Silva Jardim",
          "Silvanópolis",
          "Silveira Martins",
          "Silveiras",
          "Silveirânia",
          "Silves",
          "Silvianópolis",
          "Silvânia",
          "Simolândia",
          "Simonésia",
          "Simplício Mendes",
          "Simão Dias",
          "Simão Pereira",
          "Simões",
          "Simões Filho",
          "Sinimbu",
          "Sinop",
          "Siqueira Campos",
          "Sirinhaém",
          "Siriri",
          "Sobradinho",
          "Sobrado",
          "Sobral",
          "Sobrália",
          "Socorro",
          "Socorro do Piauí",
          "Soledade",
          "Soledade de Minas",
          "Solidão",
          "Solonópole",
          "Solânea",
          "Sombrio",
          "Sonora",
          "Sooretama",
          "Sorocaba",
          "Sorriso",
          "Sossêgo",
          "Soure",
          "Sousa",
          "Souto Soares",
          "Sucupira",
          "Sucupira do Norte",
          "Sucupira do Riachão",
          "Sud Mennucci",
          "Sul Brasil",
          "Sulina",
          "Sumaré",
          "Sumidouro",
          "Sumé",
          "Surubim",
          "Sussuapara",
          "Suzano",
          "Suzanápolis",
          "Sátiro Dias",
          "São Benedito",
          "São Benedito do Rio Preto",
          "São Benedito do Sul",
          "São Bentinho",
          "São Bento",
          "São Bento Abade",
          "São Bento do Norte",
          "São Bento do Sapucaí",
          "São Bento do Sul",
          "São Bento do Tocantins",
          "São Bento do Trairí",
          "São Bento do Una",
          "São Bernardino",
          "São Bernardo",
          "São Bernardo do Campo",
          "São Bonifácio",
          "São Borja",
          "São Braz do Piauí",
          "São Brás",
          "São Brás do Suaçuí",
          "São Caetano de Odivela",
          "São Caetano do Sul",
          "São Caitano",
          "São Carlos",
          "São Carlos do Ivaí",
          "São Cristovão do Sul",
          "São Cristóvão",
          "São Desidério",
          "São Domingos",
          "São Domingos das Dores",
          "São Domingos de Pombal",
          "São Domingos do Araguaia",
          "São Domingos do Azeitão",
          "São Domingos do Capim",
          "São Domingos do Cariri",
          "São Domingos do Maranhão",
          "São Domingos do Norte",
          "São Domingos do Prata",
          "São Domingos do Sul",
          "São Felipe",
          "São Felipe d'Oeste",
          "São Fernando",
          "São Fidélis",
          "São Francisco",
          "São Francisco de Assis",
          "São Francisco de Assis do Piauí",
          "São Francisco de Goiás",
          "São Francisco de Itabapoana",
          "São Francisco de Paula",
          "São Francisco de Sales",
          "São Francisco do Brejão",
          "São Francisco do Conde",
          "São Francisco do Glória",
          "São Francisco do Guaporé",
          "São Francisco do Maranhão",
          "São Francisco do Oeste",
          "São Francisco do Pará",
          "São Francisco do Piauí",
          "São Francisco do Sul",
          "São Félix",
          "São Félix de Balsas",
          "São Félix de Minas",
          "São Félix do Araguaia",
          "São Félix do Coribe",
          "São Félix do Piauí",
          "São Félix do Tocantins",
          "São Félix do Xingu",
          "São Gabriel",
          "São Gabriel da Cachoeira",
          "São Gabriel da Palha",
          "São Gabriel do Oeste",
          "São Geraldo",
          "São Geraldo da Piedade",
          "São Geraldo do Araguaia",
          "São Geraldo do Baixio",
          "São Gonçalo",
          "São Gonçalo do Abaeté",
          "São Gonçalo do Amarante",
          "São Gonçalo do Gurguéia",
          "São Gonçalo do Pará",
          "São Gonçalo do Piauí",
          "São Gonçalo do Rio Abaixo",
          "São Gonçalo do Rio Preto",
          "São Gonçalo do Sapucaí",
          "São Gonçalo dos Campos",
          "São Gotardo",
          "São Jerônimo",
          "São Jerônimo da Serra",
          "São Joaquim",
          "São Joaquim da Barra",
          "São Joaquim de Bicas",
          "São Joaquim do Monte",
          "São Jorge",
          "São Jorge d'Oeste",
          "São Jorge do Ivaí",
          "São Jorge do Patrocínio",
          "São José",
          "São José da Barra",
          "São José da Bela Vista",
          "São José da Boa Vista",
          "São José da Coroa Grande",
          "São José da Lagoa Tapada",
          "São José da Laje",
          "São José da Lapa",
          "São José da Safira",
          "São José da Tapera",
          "São José da Varginha",
          "São José da Vitória",
          "São José das Missões",
          "São José das Palmeiras",
          "São José de Caiana",
          "São José de Espinharas",
          "São José de Mipibu",
          "São José de Piranhas",
          "São José de Princesa",
          "São José de Ribamar",
          "São José de Ubá",
          "São José do Alegre",
          "São José do Barreiro",
          "São José do Belmonte",
          "São José do Bonfim",
          "São José do Brejo do Cruz",
          "São José do Calçado",
          "São José do Campestre",
          "São José do Cedro",
          "São José do Cerrito",
          "São José do Divino",
          "São José do Egito",
          "São José do Goiabal",
          "São José do Herval",
          "São José do Hortêncio",
          "São José do Inhacorá",
          "São José do Jacuri",
          "São José do Jacuípe",
          "São José do Mantimento",
          "São José do Norte",
          "São José do Ouro",
          "São José do Peixe",
          "São José do Piauí",
          "São José do Povo",
          "São José do Rio Claro",
          "São José do Rio Pardo",
          "São José do Rio Preto",
          "São José do Sabugi",
          "São José do Seridó",
          "São José do Sul",
          "São José do Vale do Rio Preto",
          "São José do Xingu",
          "São José dos Ausentes",
          "São José dos Basílios",
          "São José dos Campos",
          "São José dos Cordeiros",
          "São José dos Pinhais",
          "São José dos Quatro Marcos",
          "São José dos Ramos",
          "São João",
          "São João Batista",
          "São João Batista do Glória",
          "São João Evangelista",
          "São João Nepomuceno",
          "São João d'Aliança",
          "São João da Baliza",
          "São João da Barra",
          "São João da Boa Vista",
          "São João da Canabrava",
          "São João da Fronteira",
          "São João da Lagoa",
          "São João da Mata",
          "São João da Paraúna",
          "São João da Ponta",
          "São João da Ponte",
          "São João da Serra",
          "São João da Urtiga",
          "São João da Varjota",
          "São João das Duas Pontes",
          "São João das Missões",
          "São João de Iracema",
          "São João de Meriti",
          "São João de Pirabas",
          "São João del Rei",
          "São João do Araguaia",
          "São João do Arraial",
          "São João do Caiuá",
          "São João do Cariri",
          "São João do Carú",
          "São João do Itaperiú",
          "São João do Ivaí",
          "São João do Jaguaribe",
          "São João do Manhuaçu",
          "São João do Manteninha",
          "São João do Oeste",
          "São João do Oriente",
          "São João do Pacuí",
          "São João do Paraíso",
          "São João do Pau d'Alho",
          "São João do Piauí",
          "São João do Polêsine",
          "São João do Rio do Peixe",
          "São João do Sabugi",
          "São João do Soter",
          "São João do Sul",
          "São João do Tigre",
          "São João do Triunfo",
          "São João dos Patos",
          "São Julião",
          "São Leopoldo",
          "São Lourenço",
          "São Lourenço da Mata",
          "São Lourenço da Serra",
          "São Lourenço do Oeste",
          "São Lourenço do Piauí",
          "São Lourenço do Sul",
          "São Ludgero",
          "São Luis do Piauí",
          "São Luiz",
          "São Luiz Gonzaga",
          "São Luís",
          "São Luís Gonzaga do Maranhão",
          "São Luís de Montes Belos",
          "São Luís do Curu",
          "São Luís do Paraitinga",
          "São Luís do Quitunde",
          "São Luíz do Norte",
          "São Mamede",
          "São Manoel do Paraná",
          "São Manuel",
          "São Marcos",
          "São Martinho",
          "São Martinho da Serra",
          "São Mateus",
          "São Mateus do Maranhão",
          "São Mateus do Sul",
          "São Miguel",
          "São Miguel Arcanjo",
          "São Miguel da Baixa Grande",
          "São Miguel da Boa Vista",
          "São Miguel das Matas",
          "São Miguel das Missões",
          "São Miguel de Taipu",
          "São Miguel de Touros",
          "São Miguel do Aleixo",
          "São Miguel do Anta",
          "São Miguel do Araguaia",
          "São Miguel do Fidalgo",
          "São Miguel do Guamá",
          "São Miguel do Guaporé",
          "São Miguel do Iguaçu",
          "São Miguel do Oeste",
          "São Miguel do Passa Quatro",
          "São Miguel do Tapuio",
          "São Miguel do Tocantins",
          "São Miguel dos Campos",
          "São Miguel dos Milagres",
          "São Nicolau",
          "São Patrício",
          "São Paulo",
          "São Paulo das Missões",
          "São Paulo de Olivença",
          "São Paulo do Potengi",
          "São Pedro",
          "São Pedro da Aldeia",
          "São Pedro da Cipa",
          "São Pedro da Serra",
          "São Pedro da União",
          "São Pedro da Água Branca",
          "São Pedro das Missões",
          "São Pedro de Alcântara",
          "São Pedro do Butiá",
          "São Pedro do Iguaçu",
          "São Pedro do Ivaí",
          "São Pedro do Paraná",
          "São Pedro do Piauí",
          "São Pedro do Suaçuí",
          "São Pedro do Sul",
          "São Pedro do Turvo",
          "São Pedro dos Crentes",
          "São Pedro dos Ferros",
          "São Rafael",
          "São Raimundo Nonato",
          "São Raimundo das Mangabeiras",
          "São Raimundo do Doca Bezerra",
          "São Roberto",
          "São Romão",
          "São Roque",
          "São Roque de Minas",
          "São Roque do Canaã",
          "São Salvador do Tocantins",
          "São Sebastião",
          "São Sebastião da Amoreira",
          "São Sebastião da Bela Vista",
          "São Sebastião da Boa Vista",
          "São Sebastião da Grama",
          "São Sebastião da Vargem Alegre",
          "São Sebastião de Lagoa de Roça",
          "São Sebastião do Alto",
          "São Sebastião do Anta",
          "São Sebastião do Caí",
          "São Sebastião do Maranhão",
          "São Sebastião do Oeste",
          "São Sebastião do Paraíso",
          "São Sebastião do Passé",
          "São Sebastião do Rio Preto",
          "São Sebastião do Rio Verde",
          "São Sebastião do Tocantins",
          "São Sebastião do Uatumã",
          "São Sebastião do Umbuzeiro",
          "São Sepé",
          "São Simão",
          "São Thomé das Letras",
          "São Tiago",
          "São Tomás de Aquino",
          "São Tomé",
          "São Valentim",
          "São Valentim do Sul",
          "São Valério da Natividade",
          "São Valério do Sul",
          "São Vendelino",
          "São Vicente",
          "São Vicente Ferrer",
          "São Vicente de Minas",
          "São Vicente do Sul",
          "Sério",
          "Sítio Novo",
          "Sítio Novo do Tocantins",
          "Sítio d'Abadia",
          "Sítio do Mato",
          "Sítio do Quinto",
          "Tabaporã",
          "Tabapuã",
          "Tabatinga",
          "Tabaí",
          "Tabira",
          "Tabocas do Brejo Velho",
          "Taboleiro Grande",
          "Taboão da Serra",
          "Tabuleiro",
          "Tabuleiro do Norte",
          "Tacaimbó",
          "Tacaratu",
          "Taciba",
          "Tacuru",
          "Taguatinga",
          "Taguaí",
          "Taiaçu",
          "Tailândia",
          "Taiobeiras",
          "Taipas do Tocantins",
          "Taipu",
          "Taió",
          "Taiúva",
          "Talismã",
          "Tamandaré",
          "Tamarana",
          "Tambaú",
          "Tamboara",
          "Tamboril",
          "Tamboril do Piauí",
          "Tanabi",
          "Tangará",
          "Tangará da Serra",
          "Tanguá",
          "Tanhaçu",
          "Tanque Novo",
          "Tanque d'Arca",
          "Tanque do Piauí",
          "Tanquinho",
          "Taparuba",
          "Tapauá",
          "Tapejara",
          "Tapera",
          "Taperoá",
          "Tapes",
          "Tapira",
          "Tapiramutá",
          "Tapiratiba",
          "Tapiraí",
          "Tapurah",
          "Taquara",
          "Taquaral",
          "Taquaral de Goiás",
          "Taquarana",
          "Taquaraçu de Minas",
          "Taquari",
          "Taquaritinga",
          "Taquaritinga do Norte",
          "Taquarituba",
          "Taquarivaí",
          "Taquarussu",
          "Taquaruçu do Sul",
          "Tarabai",
          "Tarauacá",
          "Tarrafas",
          "Tartarugalzinho",
          "Tarumirim",
          "Tarumã",
          "Tasso Fragoso",
          "Tatuí",
          "Taubaté",
          "Tauá",
          "Tavares",
          "Tefé",
          "Teixeira",
          "Teixeira Soares",
          "Teixeira de Freitas",
          "Teixeiras",
          "Teixeirópolis",
          "Tejupá",
          "Tejuçuoca",
          "Telha",
          "Telêmaco Borba",
          "Tenente Ananias",
          "Tenente Laurentino Cruz",
          "Tenente Portela",
          "Tenório",
          "Teodoro Sampaio",
          "Teofilândia",
          "Teolândia",
          "Teotônio Vilela",
          "Terenos",
          "Teresina",
          "Teresina de Goiás",
          "Teresópolis",
          "Terezinha",
          "Terezópolis de Goiás",
          "Terra Alta",
          "Terra Boa",
          "Terra Nova",
          "Terra Nova do Norte",
          "Terra Rica",
          "Terra Roxa",
          "Terra Santa",
          "Terra de Areia",
          "Tesouro",
          "Teutônia",
          "Teófilo Otoni",
          "Theobroma",
          "Tianguá",
          "Tibagi",
          "Tibau",
          "Tibau do Sul",
          "Tietê",
          "Tigrinhos",
          "Tijucas",
          "Tijucas do Sul",
          "Timbaúba",
          "Timbaúba dos Batistas",
          "Timbiras",
          "Timburi",
          "Timbé do Sul",
          "Timbó",
          "Timbó Grande",
          "Timon",
          "Timóteo",
          "Tio Hugo",
          "Tiradentes",
          "Tiradentes do Sul",
          "Tiros",
          "Tobias Barreto",
          "Tocantins",
          "Tocantinópolis",
          "Tocantínia",
          "Tocos do Moji",
          "Toledo",
          "Tomar do Geru",
          "Tomazina",
          "Tombos",
          "Tomé-Açu",
          "Tonantins",
          "Toritama",
          "Torixoréu",
          "Toropi",
          "Torre de Pedra",
          "Torres",
          "Torrinha",
          "Touros",
          "Trabiju",
          "Tracuateua",
          "Tracunhaém",
          "Traipu",
          "Trairi",
          "Trairão",
          "Trajano de Morais",
          "Tramandaí",
          "Travesseiro",
          "Tremedal",
          "Tremembé",
          "Treviso",
          "Treze Tílias",
          "Treze de Maio",
          "Trindade",
          "Trindade do Sul",
          "Triunfo",
          "Triunfo Potiguar",
          "Trizidela do Vale",
          "Trombas",
          "Trombudo Central",
          "Três Arroios",
          "Três Barras",
          "Três Barras do Paraná",
          "Três Cachoeiras",
          "Três Corações",
          "Três Coroas",
          "Três Forquilhas",
          "Três Fronteiras",
          "Três Lagoas",
          "Três Marias",
          "Três Palmeiras",
          "Três Passos",
          "Três Pontas",
          "Três Ranchos",
          "Três Rios",
          "Três de Maio",
          "Tubarão",
          "Tucano",
          "Tucumã",
          "Tucunduva",
          "Tucuruí",
          "Tufilândia",
          "Tuiuti",
          "Tumiritinga",
          "Tunas",
          "Tunas do Paraná",
          "Tuneiras do Oeste",
          "Tuntum",
          "Tunápolis",
          "Tupaciguara",
          "Tupanatinga",
          "Tupanci do Sul",
          "Tupanciretã",
          "Tupandi",
          "Tuparendi",
          "Tuparetama",
          "Tupi Paulista",
          "Tupirama",
          "Tupiratins",
          "Tupã",
          "Tupãssi",
          "Turiaçu",
          "Turilândia",
          "Turiúba",
          "Turmalina",
          "Tururu",
          "Turuçu",
          "Turvelândia",
          "Turvo",
          "Turvolândia",
          "Turvânia",
          "Tutóia",
          "Uarini",
          "Uauá",
          "Ubaitaba",
          "Ubajara",
          "Ubaporanga",
          "Ubarana",
          "Ubatuba",
          "Ubatã",
          "Ubaí",
          "Ubaíra",
          "Uberaba",
          "Uberlândia",
          "Ubirajara",
          "Ubiratã",
          "Ubiretama",
          "Ubá",
          "Uchoa",
          "Uibaí",
          "Uiramutã",
          "Uirapuru",
          "Uiraúna",
          "Ulianópolis",
          "Umari",
          "Umarizal",
          "Umbaúba",
          "Umburanas",
          "Umburatiba",
          "Umbuzeiro",
          "Umirim",
          "Umuarama",
          "Una",
          "Unaí",
          "Uniflor",
          "Unistalda",
          "União",
          "União Paulista",
          "União da Serra",
          "União da Vitória",
          "União de Minas",
          "União do Oeste",
          "União do Sul",
          "União dos Palmares",
          "Upanema",
          "Urandi",
          "Uraí",
          "Urbano Santos",
          "Uru",
          "Uruana",
          "Uruana de Minas",
          "Uruará",
          "Uruaçu",
          "Urubici",
          "Uruburetama",
          "Urucará",
          "Urucuia",
          "Urucurituba",
          "Urucânia",
          "Uruguaiana",
          "Uruoca",
          "Urupema",
          "Urupá",
          "Urupês",
          "Urussanga",
          "Urutaí",
          "Uruçuca",
          "Uruçuí",
          "Urânia",
          "Utinga",
          "Vacaria",
          "Vale Real",
          "Vale Verde",
          "Vale de São Domingos",
          "Vale do Anari",
          "Vale do Paraíso",
          "Vale do Sol",
          "Valente",
          "Valentim Gentil",
          "Valença",
          "Valença do Piauí",
          "Valinhos",
          "Valparaíso",
          "Valparaíso de Goiás",
          "Vanini",
          "Vargem",
          "Vargem Alegre",
          "Vargem Alta",
          "Vargem Bonita",
          "Vargem Grande",
          "Vargem Grande Paulista",
          "Vargem Grande do Rio Pardo",
          "Vargem Grande do Sul",
          "Vargeão",
          "Varginha",
          "Varjota",
          "Varjão",
          "Varjão de Minas",
          "Varre-Sai",
          "Varzedo",
          "Varzelândia",
          "Vassouras",
          "Vazante",
          "Venda Nova do Imigrante",
          "Venha-Ver",
          "Ventania",
          "Venturosa",
          "Venâncio Aires",
          "Vera",
          "Vera Cruz",
          "Vera Cruz do Oeste",
          "Vera Mendes",
          "Veranópolis",
          "Verdejante",
          "Verdelândia",
          "Vereda",
          "Veredinha",
          "Vermelho Novo",
          "Vertente do Lério",
          "Vertentes",
          "Verê",
          "Veríssimo",
          "Vespasiano",
          "Vespasiano Correa",
          "Viadutos",
          "Viamão",
          "Viana",
          "Vianópolis",
          "Vicente Dutra",
          "Vicentina",
          "Vicentinópolis",
          "Victor Graeff",
          "Vicência",
          "Vidal Ramos",
          "Videira",
          "Vieiras",
          "Vieirópolis",
          "Vigia",
          "Vila Alta",
          "Vila Bela da Santíssima Trindade",
          "Vila Boa",
          "Vila Flor",
          "Vila Flores",
          "Vila Lângaro",
          "Vila Maria",
          "Vila Nova do Piauí",
          "Vila Nova do Sul",
          "Vila Nova dos Martírios",
          "Vila Pavão",
          "Vila Propício",
          "Vila Rica",
          "Vila Valério",
          "Vila Velha",
          "Vilhena",
          "Vinhedo",
          "Viradouro",
          "Virgem da Lapa",
          "Virginópolis",
          "Virgolândia",
          "Virgínia",
          "Virmond",
          "Visconde do Rio Branco",
          "Viseu",
          "Vista Alegre",
          "Vista Alegre do Alto",
          "Vista Alegre do Prata",
          "Vista Gaúcha",
          "Vista Serrana",
          "Vitor Meireles",
          "Vitorino",
          "Vitorino Freire",
          "Vitória",
          "Vitória Brasil",
          "Vitória da Conquista",
          "Vitória das Missões",
          "Vitória de Santo Antão",
          "Vitória do Jari",
          "Vitória do Mearim",
          "Vitória do Xingu",
          "Viçosa",
          "Viçosa do Ceará",
          "Volta Grande",
          "Volta Redonda",
          "Votorantim",
          "Votuporanga",
          "Várzea",
          "Várzea Alegre",
          "Várzea Branca",
          "Várzea Grande",
          "Várzea Nova",
          "Várzea Paulista",
          "Várzea da Palma",
          "Várzea da Roça",
          "Várzea do Poço",
          "Wagner",
          "Wall Ferraz",
          "Wanderley",
          "Wanderlândia",
          "Wenceslau Braz",
          "Wenceslau Guimarães",
          "Westfália",
          "Witmarsum",
          "Xambioá",
          "Xambrê",
          "Xangri-lá",
          "Xanxerê",
          "Xapuri",
          "Xavantina",
          "Xaxim",
          "Xexéu",
          "Xinguara",
          "Xique-Xique",
          "Zabelê",
          "Zacarias",
          "Zortéa",
          "Zé Doca",
          "Água Azul do Norte",
          "Água Boa",
          "Água Branca",
          "Água Clara",
          "Água Comprida",
          "Água Doce",
          "Água Doce do Maranhão",
          "Água Doce do Norte",
          "Água Fria",
          "Água Fria de Goiás",
          "Água Limpa",
          "Água Nova",
          "Água Preta",
          "Água Santa",
          "Águas Belas",
          "Águas Formosas",
          "Águas Frias",
          "Águas Lindas de Goiás",
          "Águas Mornas",
          "Águas Vermelhas",
          "Águas da Prata",
          "Águas de Chapecó",
          "Águas de Lindóia",
          "Águas de Santa Bárbara",
          "Águas de São Pedro",
          "Águia Branca",
          "Álvares Florence",
          "Álvares Machado",
          "Álvaro de Carvalho",
          "Áurea",
          "Ângulo",
          "Érico Cardoso",
          "Óbidos",
          "Óleo"
        ],
        "country": [
          "Afeganistão",
          "Albânia",
          "Algéria",
          "Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antígua e Barbuda",
          "Argentina",
          "Armênia",
          "Aruba",
          "Austrália",
          "Áustria",
          "Azerbaijão",
          "Bahamas",
          "Barém",
          "Bangladesh",
          "Barbados",
          "Belgrado",
          "Bélgica",
          "Belize",
          "Benin",
          "Bermuda",
          "Butão",
          "Bolívia",
          "Bôsnia",
          "Batasuna",
          "Ilha Bouvet",
          "Brasil",
          "Arquipélago de Chagos",
          "Ilhas Virgens",
          "Brunei",
          "Bulgária",
          "Burkina Faso",
          "Burundi",
          "Camboja",
          "Camarões",
          "Canadá",
          "Cabo Verde",
          "Ilhas Cayman",
          "República da África Central",
          "Chade",
          "Chile",
          "China",
          "Ilhas do Natal",
          "Ilhas Cocos",
          "Colômbia",
          "Comores",
          "Congo",
          "Ilhas Cook",
          "Costa Rica",
          "Costa do Marfim",
          "Croácia",
          "Cuba",
          "Chipre",
          "República Checa",
          "Dinamarca",
          "Djibouti",
          "Dominica",
          "República Dominicana",
          "Equador",
          "Egito",
          "El Salvador",
          "Guiné Equatorial",
          "Eritreia",
          "Estônia",
          "Etiópia",
          "Ilhas Feroe",
          "Ilhas Malvinas",
          "Fiji",
          "Finlândia",
          "França",
          "Guiné Francesa",
          "Polinésia Francesa",
          "Gabão",
          "Gâmbia",
          "Georgia",
          "Alemanha",
          "Gana",
          "Gibraltar",
          "Grécia",
          "Groelândia",
          "Granada",
          "Guadalupe",
          "Guano",
          "Guatemala",
          "Guernsey",
          "Guiné",
          "Guiné-Bissau",
          "Guiana",
          "Haiti",
          "Ilha Heard e Ilhas McDonald",
          "Vaticano",
          "Honduras",
          "Hong Kong",
          "Hungria",
          "Islândia",
          "Índia",
          "Indonésia",
          "Irã",
          "Iraque",
          "Irlanda",
          "Ilha de Man",
          "Israel",
          "Itália",
          "Jamaica",
          "Japão",
          "Jersey",
          "Jordânia",
          "Cazaquistão",
          "Quênia",
          "Kiribati",
          "Coreia do Norte",
          "Coreia do Sul",
          "Kuwait",
          "Quirguistão",
          "República Democrática Popular Lau",
          "Latvia",
          "Líbano",
          "Lesoto",
          "Libéria",
          "Líbia",
          "Liechtenstein",
          "Lituânia",
          "Luxemburgo",
          "Macau",
          "Macedônia",
          "Madagascar",
          "Malawi",
          "Malásia",
          "Maldivas",
          "Mali",
          "Malta",
          "Ilhas Marshall",
          "Martinica",
          "Mauritânia",
          "Maurícia",
          "Mayotte",
          "México",
          "Micronésia",
          "Moldávia",
          "Mônaco",
          "Mongólia",
          "Montenegro",
          "Montserrat",
          "Marrocos",
          "Moçambique",
          "Myanmar",
          "Namíbia",
          "Nauru",
          "Nepal",
          "Antilhas Holandesas",
          "Holanda",
          "Nova Caledónia",
          "Nova Zelândia",
          "Nicarágua",
          "Nigéria",
          "Niue",
          "Ilha Norfolk",
          "Marianas Setentrionais",
          "Noruega",
          "Omã",
          "Paquistão",
          "Palau",
          "Palestina",
          "Panamá",
          "Papua-Nova Guiné",
          "Paraguai",
          "Peru",
          "Filipinas",
          "Polônia",
          "Portugal",
          "Porto Rico",
          "Catar",
          "Romênia",
          "Rússia",
          "Ruanda",
          "São Bartolomeu",
          "Santa Helena",
          "Santa Lúcia",
          "Ilha de São Martinho",
          "Saint-Pierre e Miquelon",
          "São Vincente e Granadinas",
          "Samoa",
          "San Marino",
          "Sao Tomé e Príncipe",
          "Arábia Saudita",
          "Senegal",
          "Sérvia",
          "Seicheles",
          "Serra Leoa",
          "Singapura",
          "Eslováquia",
          "Eslovênia",
          "Ilhas Salomão",
          "Somália",
          "África do Sul",
          "Geórgia do Sul e Ilhas Sandwich do Sul",
          "Espanha",
          "Sri Lanka",
          "Sudão",
          "Suriname",
          "Ilhas Svalbard e Jan Mayen",
          "Suazilândia",
          "Suécia",
          "Suíça",
          "Síria",
          "Taiwan",
          "Tajiquistão",
          "Tanzânia",
          "Tailândia",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trindade e Tobago",
          "Tunísia",
          "Turquia",
          "Turcomenistão",
          "Ilhas Turcas e Caicos",
          "Tuvalu",
          "Uganda",
          "Ucrânia",
          "Emirados Árabes Unidos",
          "Reino Unido",
          "Estados Unidos da América",
          "Estados Unidos das Ilhas Virgens",
          "Uruguai",
          "Uzbequistão",
          "Vanuatu",
          "Venezuela",
          "Vietnã",
          "Wallis e Futuna",
          "Saara Ocidental",
          "Iémen",
          "Zâmbia",
          "Zimbábue"
        ],
        "default_country": [
          "Brasil"
        ],
        "default_country_code": [
          "BR"
        ],
        "postcode": [
          "#####-###"
        ],
        "postcode_by_state": {
          "AC": "69###-###",
          "AL": "57###-###",
          "AM": "69###-###",
          "AP": "68###-###",
          "BA": [
            "40###-###",
            "41###-###",
            "42###-###",
            "43###-###",
            "44###-###",
            "45###-###",
            "46###-###",
            "47###-###",
            "48###-###"
          ],
          "CE": [
            "60###-###",
            "61###-###",
            "62###-###",
            "63###-###"
          ],
          "DF": [
            "70###-###",
            "71###-###",
            "72###-###",
            "73###-###"
          ],
          "ES": "29###-###",
          "GO": [
            "73###-###",
            "74###-###",
            "75###-###",
            "76###-###"
          ],
          "MA": "65###-###",
          "MG": "3####-###",
          "MS": "79###-###",
          "MT": "78###-###",
          "PA": [
            "66###-###",
            "67###-###"
          ],
          "PB": "58###-###",
          "PE": [
            "50###-###",
            "51###-###",
            "52###-###",
            "53###-###",
            "54###-###",
            "55###-###",
            "56###-###"
          ],
          "PI": "64###-###",
          "PR": [
            "80###-###",
            "81###-###",
            "82###-###",
            "83###-###",
            "84###-###",
            "85###-###",
            "86###-###",
            "87###-###"
          ],
          "RJ": [
            "20###-###",
            "21###-###",
            "22###-###",
            "23###-###",
            "24###-###",
            "25###-###",
            "26###-###",
            "27###-###",
            "28###-###"
          ],
          "RN": "59###-###",
          "RO": [
            "768##-###",
            "769##-###"
          ],
          "RR": "69###-###",
          "RS": "9####-###",
          "SC": [
            "88###-###",
            "89###-###"
          ],
          "SE": "49###-###",
          "SP": [
            "0####-###",
            "1####-###"
          ],
          "TO": "77###-###"
        },
        "secondary_address": [
          "Apto. ###",
          "Sobrado ##",
          "Casa #",
          "Lote ##",
          "Quadra ##"
        ],
        "state": [
          "Acre",
          "Alagoas",
          "Amapá",
          "Amazonas",
          "Bahia",
          "Ceará",
          "Distrito Federal",
          "Espírito Santo",
          "Goiás",
          "Maranhão",
          "Mato Grosso",
          "Mato Grosso do Sul",
          "Minas Gerais",
          "Pará",
          "Paraíba",
          "Paraná",
          "Pernambuco",
          "Piauí",
          "Rio de Janeiro",
          "Rio Grande do Norte",
          "Rio Grande do Sul",
          "Rondônia",
          "Roraima",
          "Santa Catarina",
          "São Paulo",
          "Sergipe",
          "Tocantins"
        ],
        "state_abbr": [
          "AC",
          "AL",
          "AP",
          "AM",
          "BA",
          "CE",
          "DF",
          "ES",
          "GO",
          "MA",
          "MT",
          "MS",
          "PA",
          "PB",
          "PR",
          "PE",
          "PI",
          "RJ",
          "RN",
          "RS",
          "RO",
          "RR",
          "SC",
          "SP",
          "SE",
          "TO"
        ],
        "street_name": [
          "#{street_suffix} #{Name.first_name}",
          "#{street_suffix} #{Name.first_name} #{Name.last_name}"
        ],
        "street_suffix": [
          "Rua",
          "Avenida",
          "Travessa",
          "Ponte",
          "Alameda",
          "Marginal",
          "Viela",
          "Rodovia"
        ]
      },
      "cell_phone": {
        "formats": [
          "(#{PhoneNumber.area_code}) 9#{PhoneNumber.subscriber_number}-#{PhoneNumber.subscriber_number}"
        ]
      },
      "color": {
        "name": [
          "Abóbora",
          "Amaranto",
          "Amarelo",
          "Âmbar",
          "Ameixa",
          "Ardósia",
          "Azul",
          "Azul-bebê",
          "Azul-claro",
          "Azul-cobalto",
          "Azul-esverdeado",
          "Azul-marinho",
          "Azul-persa",
          "Azul-violeta",
          "Bege",
          "Branco",
          "Carmesim",
          "Carmim",
          "Cereja",
          "Cerúleo",
          "Champagne",
          "Chocolate",
          "Cinza",
          "Coral",
          "Escarlate",
          "Framboesa",
          "Índigo",
          "Laranja",
          "Lavanda",
          "Lilás",
          "Lima",
          "Magenta",
          "Marfim",
          "Marrom",
          "Oliva",
          "Ouro",
          "Pêssego",
          "Prata",
          "Preto",
          "Rosa",
          "rosa-arroxeado",
          "Rosa-magenta",
          "Roxo",
          "Salmão",
          "Turquesa",
          "Uva",
          "Verde",
          "Verde-água",
          "Verde-claro",
          "Verde-jade",
          "Verde-limão",
          "Verde-primavera",
          "Vermelho",
          "Violeta"
        ]
      },
      "company": {
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} e #{Name.last_name}"
        ],
        "suffix": [
          "S.A.",
          "LTDA",
          "e Associados",
          "Comércio",
          "EIRELI"
        ]
      },
      "creature": {
        "animal": {
          "name": [
            "Abelha",
            "Abutre",
            "Ácaro",
            "Águia",
            "Albatroz",
            "Alce",
            "Alpaca",
            "Anaconda",
            "Anchova",
            "Andorinha",
            "Anta",
            "Antílope",
            "Aranha",
            "Arara",
            "Asno",
            "Atum",
            "Avestruz",
            "Babuíno",
            "Bacalhau",
            "Bacuri",
            "Badejo",
            "Bagre",
            "Baiacu",
            "Baleia",
            "Barata",
            "Barbo",
            "Barracuda",
            "Beija Flor",
            "Besouro",
            "Bem Te Vi",
            "Bezerro",
            "Bicho da Seda",
            "Bisonte",
            "Boa",
            "Bode",
            "Boi",
            "Borboleta",
            "Boto",
            "Búfalo",
            "Burro",
            "Cabra",
            "Cachalote",
            "Cachorro",
            "Cágado",
            "Camaleão",
            "Camarão",
            "Camelo",
            "Camundongo",
            "Canário",
            "Canguru",
            "Capivara",
            "Caracol",
            "Caranguejo",
            "Carneiro",
            "Carrapato",
            "Cascavel",
            "Castor",
            "Cavalo",
            "Cavalo Marinho",
            "Cegonha",
            "Centopeia",
            "Chimpanzé",
            "Chinchila",
            "Chita",
            "Cigarra",
            "Cisne",
            "Coala",
            "Cobra",
            "Codorna",
            "Coelho",
            "Coiote",
            "Coruja",
            "Corvo",
            "Crocodilo",
            "Cupim",
            "Cutia",
            "Damão",
            "Dançador",
            "Degolado",
            "Degu",
            "Diablotim",
            "Diabo da Tasmânia",
            "Diamante de Gould",
            "Dingo",
            "Dinossauro",
            "Dodô",
            "Doninha",
            "Dourado",
            "Dragão de Komodo",
            "Dragão do Banhado",
            "Dragão Voador",
            "Dromedário",
            "Dugongo",
            "Égua",
            "Elefante",
            "Elefante Marinho",
            "Ema",
            "Enchova",
            "Enferrujado",
            "Enguia",
            "Enho",
            "Escaravelho",
            "Escorpião",
            "Escrevedeira",
            "Esmerilhão",
            "Espadarte",
            "Esponja",
            "Esquilo",
            "Estorninho",
            "Estrela do Mar",
            "Esturjão",
            "Faisão",
            "Falcão",
            "Ferreirinho",
            "Flamingo",
            "Flautim",
            "Foca",
            "Formiga",
            "Fossa",
            "Fraca da Guiné",
            "Freirinha",
            "Fuinha",
            "Furão",
            "Gafanhoto",
            "Gaivota",
            "Galinha",
            "Galo",
            "Gambá",
            "Gamo",
            "Ganso",
            "Garça",
            "Garoupa",
            "Gato",
            "Gavião",
            "Gazela",
            "Geco",
            "Gerbo",
            "Gibão",
            "Girafa",
            "Girino",
            "Gnu",
            "Golfinho",
            "Gorila",
            "Gralha",
            "Grifo",
            "Grilo",
            "Grou",
            "Guará:",
            "Guaxinim",
            "Hadoque",
            "Hamster",
            "Harpia",
            "Hiena",
            "Hipopótamo",
            "Hírax",
            "Iaque",
            "Íbex",
            "Íbis",
            "Iguana",
            "Iguanara",
            "Impala",
            "Indicador",
            "Indri",
            "Inhacoso",
            "Inhala",
            "Inhambu",
            "Irapuã",
            "Irara",
            "Iratim",
            "Itapema",
            "Jabiru",
            "Jabuti",
            "Jaçanã",
            "Jacaré",
            "Jacu",
            "Jacupará",
            "Jaguar",
            "Jamanta",
            "Jararaca",
            "Javali",
            "Jegue",
            "Jiboia",
            "Joaninha",
            "João de Barro",
            "Jumento",
            "Kakapo",
            "Kea",
            "Kinguio",
            "Kiwi",
            "Koala",
            "Kookaburra",
            "Kowari",
            "Krill",
            "Kudu",
            "Lacraia",
            "Lagarta",
            "Lagartixa",
            "Lagarto",
            "Lagosta",
            "Lampreia",
            "Lavadeira",
            "Lavagante",
            "Leão",
            "Leão Marinho",
            "Lebre",
            "Lêmure",
            "Leopardo",
            "Lesma",
            "Lhama",
            "Libélula",
            "Lince",
            "Linguado",
            "Lobo",
            "Lombriga",
            "Lontra",
            "Lula",
            "Macaco",
            "Mamute",
            "Manatim",
            "Mandril",
            "Mangangá",
            "Maracanã",
            "Marimbondo",
            "Mariposa",
            "Marisco",
            "Marmota",
            "Marreco",
            "Marta",
            "Massarongo",
            "Medusa",
            "Melro",
            "Mergulhão",
            "Merluza",
            "Mexilhão",
            "Mico",
            "Milhafre",
            "Mineirinho",
            "Minhoca",
            "Mocho",
            "Mono",
            "Morcego",
            "Moreia",
            "Morsa",
            "Mosca",
            "Mosquito",
            "Muçurana",
            "Mula",
            "Musaranho",
            "Naja",
            "Nambu",
            "Nandaia",
            "Narceja",
            "Narval",
            "Náutilo",
            "Negrinho",
            "Neon",
            "Nhacundá",
            "Nhandiá",
            "Niala",
            "Niquim",
            "Noitibó",
            "Numbat",
            "Nútria",
            "Ocapi",
            "Olho de Boi",
            "Onça",
            "Orangotango",
            "Orca",
            "Órix",
            "Ornitorrinco",
            "Osga",
            "Ostra",
            "Otária",
            "Ouriço",
            "Ouriço do Mar",
            "Ovelha",
            "Panda",
            "Pantera",
            "Papagaio",
            "Pardal",
            "Pássaro",
            "Pato",
            "Pavão",
            "Peixe",
            "Peixe Boi",
            "Pelicano",
            "Percevejo",
            "Perereca",
            "Periquito",
            "Pernilongo",
            "Peru",
            "Pescada",
            "Pica Pau",
            "Pinguim",
            "Piolho",
            "Piranha",
            "Pirarucu",
            "Polvo",
            "Pombo",
            "Pônei",
            "Porco",
            "Porco Espinho",
            "Porquinho da índia",
            "Preá",
            "Preguiça",
            "Pulga",
            "Quati",
            "Quatimirim",
            "Quatipuru",
            "Quebra Nozes",
            "Quebra Ossos",
            "Queixada",
            "Quem Te Vestiu",
            "Quero Quero",
            "Quetzal",
            "Quiriquiri",
            "Rã",
            "Rabudinho",
            "Raia",
            "Raposa",
            "Ratazana",
            "Rato",
            "Rêmora",
            "Rena",
            "Rendeira",
            "Rinoceronte",
            "Robalo",
            "Rouxinol",
            "Sabiá",
            "Sagui",
            "Salamandra",
            "Salmão",
            "Sanguessuga",
            "Sapo",
            "Sardão",
            "Sardinha",
            "Saúva",
            "Seriema",
            "Serpente",
            "Siri",
            "Suçuarana",
            "Sucuri",
            "Suiriri",
            "Suricate",
            "Surubi",
            "Surucucu",
            "Tainha",
            "Tamanduá",
            "Tamboril",
            "Tapir",
            "Tarântula",
            "Tartaruga",
            "Tatu",
            "Tatuí",
            "Tentilhão",
            "Tetra",
            "Texugo",
            "Tico Tico",
            "Tigre",
            "Tilápia",
            "Tordo",
            "Tororó",
            "Toupeira",
            "Touro",
            "Tritão",
            "Truta",
            "Tubarão",
            "Tucano",
            "Tucuxi",
            "Uacari",
            "Unau",
            "Unha Longa",
            "Unicórnio",
            "Urso",
            "Panda",
            "Urso",
            "Uru",
            "Urubu",
            "Urutaurana",
            "Urutu",
            "Vaca",
            "Vaca Marinha",
            "Vaga Lume",
            "Veado",
            "Verdilhão",
            "Verdinho",
            "Vespa",
            "Víbora",
            "Vieira",
            "Vira Bosta",
            "Vison",
            "Vitela",
            "Viúva",
            "Viúva Negra",
            "Wallaby",
            "Weimaraner",
            "Wombat",
            "Xajá",
            "Xangó",
            "Xará",
            "Xarelete",
            "Xaréu",
            "Xaru",
            "Xauim",
            "Xero",
            "Xexéu",
            "Ximango",
            "Ximburé",
            "Xixarro",
            "Xofrango",
            "Xuri",
            "Yak",
            "Ynambu",
            "Yorkshire",
            "Zabelê",
            "Zangão",
            "Zaragateiro",
            "Zarro",
            "Zebra",
            "Zebu",
            "Zidedê",
            "Zombeteiro",
            "Zorrilho"
          ]
        }
      },
      "electrical_components": {
        "active": [
          "Diodo",
          "LED",
          "Retificador",
          "Transistor",
          "JFET",
          "MOSFET",
          " to Integrado",
          "LCD",
          "Tubo de raios catódicos",
          "Tubo de vácuo",
          "Bateria",
          "Célula de combustível",
          "Fonte de alimentação"
        ],
        "electromechanical": [
          "Dispositivo piezoelétrico",
          "Cristal",
          "Motor ultrassônico",
          "Terminal",
          "Soquete",
          "Cabo de alimentação",
          "Chave de alternação",
          "Chave deslizante",
          "Chave DIP",
          "Pedal",
          "Teclado",
          "Disjuntor",
          "Fusível",
          "Placa de circuito impresso"
        ],
        "passive": [
          "Resistor",
          "Potenciômetro",
          "TrimPot",
          "Varistor",
          "Capacitor",
          "Diodo Varicap",
          "Indutor",
          "Transformador",
          "Gerador",
          "Motor",
          "Solenóide",
          "Amplificador magnético",
          "Alto-falante",
          "Sensor de movimento",
          "Acelerômetro",
          "Termopar",
          "Antena",
          "Oscilador",
          "Placa de ensaio"
        ]
      },
      "food": {
        "ingredients": [
          "Abacate",
          "Abacaxi",
          "Abóbora",
          "Açafrão",
          "Achacha",
          "Agar",
          "Água De Côco",
          "Água De Rosas",
          "Aipo",
          "Alcachofra",
          "Alcaçuz",
          "Alcaparras",
          "Alecrim",
          "Alface",
          "Alfafa",
          "Alho",
          "Alho-Poró",
          "Amaranto",
          "Ameixa",
          "Ameixas",
          "Amêndoas",
          "Amendoim",
          "Amora",
          "Anchovas",
          "Anis",
          "Araruta",
          "Arroz",
          "Arroz Integral",
          "Arroz Japonês",
          "Arroz Mascavo",
          "Atum",
          "Aveia",
          "Avelã",
          "Azeite",
          "Azeitonas",
          "Bacalhau",
          "Bacon",
          "Banana",
          "Barramundi",
          "Batata",
          "Bérberis",
          "Beringela",
          "Berinjela",
          "Beterraba",
          "Bicarbonato De Sódio",
          "Brócolis",
          "Broto De Feijão",
          "Brotos",
          "Cacau",
          "Cacau Em Pó",
          "Café",
          "Camarão",
          "Camomila",
          "Canela",
          "Caqui",
          "Carambola",
          "Caranguejo",
          "Cardamomo",
          "Carne",
          "Carne De Porco",
          "Cassia Casca",
          "Castanha De Caju",
          "Castanha Do Pará",
          "Castanha Portuguesa",
          "Cebola",
          "Cebolinha",
          "Cebolinhas",
          "Cenoura",
          "Cenoura Roxa",
          "Centeio",
          "Cevada",
          "Chá Verde",
          "Chagas",
          "Cheddar",
          "Chocolate Amargo",
          "Chuchu",
          "Coco",
          "Coentro",
          "Cogumelo",
          "Cogumelos Porcini",
          "Cominho",
          "Cordeiro",
          "Couve",
          "Couve-Flor",
          "Cravo",
          "Creme De Leite",
          "Creme De Queijo",
          "Damasco",
          "Damascos",
          "Dente-De-Leão",
          "Edamame",
          "Erva-Doce",
          "Ervilha",
          "Eschallots",
          "Espargos",
          "Espinafre",
          "Farinha",
          "Farinha De Arroz",
          "Farinha De Batata",
          "Farinha De Grão-De-Bico",
          "Farinha De Rosca",
          "Farinha De Soja",
          "Farinha De Tapioca",
          "Farinha De Trigo",
          "Feijão",
          "Feijão Branco",
          "Feijão Carioca",
          "Fenacho",
          "Fermento Em Pó",
          "Fígado",
          "Figo",
          "Flocos De Milho",
          "Flores De Lavanda",
          "Framboesa",
          "Frango",
          "Fruta Di Conde",
          "Fruta Do Dragão",
          "Fubá",
          "Geléia",
          "Goiaba",
          "Goiabada",
          "Grão-De-Bico",
          "Groselha",
          "Hortelã",
          "Hummus",
          "Jewfish",
          "Kiwi",
          "Kombu",
          "Lagosta",
          "Laranja",
          "Leite",
          "Leite Condensado",
          "Leite De Arroz",
          "Leite De Cabra",
          "Leite De Soja",
          "Lemongrass",
          "Lentilha",
          "Lentilha Vermelha",
          "Lichia",
          "Limão",
          "Linguado",
          "Linguiça",
          "Linhaça",
          "Lula",
          "Maçã",
          "Maçã",
          "Macadâmia",
          "Macarrão",
          "Macarrão De Arroz",
          "Mamão",
          "Mandarins",
          "Manga",
          "Manjerona",
          "Manteiga",
          "Maracujá",
          "Margarina",
          "Massa De Lasanha",
          "Mel",
          "Melaço",
          "Melão",
          "Mexilhão",
          "Mexilhões",
          "Missô",
          "Molho De Ostras",
          "Molho De Peixe",
          "Molho De Soja",
          "Mostarda",
          "Mussarela",
          "Nectarinas",
          "Noodles Asiáticos",
          "Noz-Moscada",
          "Nozes",
          "Óleo De Amêndoa",
          "Óleo De Cártamo",
          "Óleo De Côco",
          "Óleo De Gergelim",
          "Óleo De Linhaça",
          "Óleo De Macadâmia",
          "Óleo De Milho",
          "Óleo De Oliva",
          "Orégano",
          "Ostras",
          "Ovo",
          "Pão",
          "Pão Da Montanha",
          "Pão De Forma",
          "Pão Integral",
          "Papel De Arroz",
          "Pato",
          "Pepino",
          "Pêra",
          "Pêssego",
          "Picanha",
          "Pimenta",
          "Pimenta Chili",
          "Pimenta Da Jamaica",
          "Pimenta Verde",
          "Pimentão",
          "Pistache",
          "Polenta",
          "Polvo",
          "Queijo Cottage",
          "Queijo De Cabra",
          "Queijo Parmesão",
          "Queijo Prato",
          "Queijo Provolone",
          "Quiabo",
          "Quinoa",
          "Rabanete",
          "Raisin",
          "Raspas De Limão",
          "Repolho",
          "Repolho Vermelho",
          "Ricotta",
          "Rins",
          "Romã",
          "Rúcula",
          "Sábio",
          "Sake",
          "Sal Marinho",
          "Salmão",
          "Salsicha",
          "Salsisha",
          "Sardinha",
          "Semente Ajowan",
          "Semente De Abóbora",
          "Semente De Alcaravia",
          "Semente De Mostarda",
          "Semente De Papoila",
          "Semente De Sésamo",
          "Sementes Chia",
          "Sementes De Gergelim",
          "Semolina",
          "Soja",
          "Soletrado",
          "Soro De Leite",
          "Star Anise",
          "Stevi",
          "Suco De Maçã",
          "Tangerina",
          "Tiras De Banbu",
          "Tortilla De Milho",
          "Truta Defumada",
          "Tubarão",
          "Uva",
          "Vagem",
          "Verdes Asiáticos",
          "Vieiras",
          "Vinagre",
          "Vinagre Balsâmico",
          "Vinagre De Arroz Integral",
          "Vinagre De Malte",
          "Vinagre De Vinho Tinto",
          "Vinho",
          "Xarope De Agave",
          "Xarope De Arroz",
          "Xarope De milho"
        ],
        "measurement_sizes": [
          "Pitada",
          "1/4",
          "1/3",
          "1/2",
          "1",
          "2",
          "3"
        ],
        "measurements": [
          "Colher de Chá",
          "Colher de Sopa",
          "Copo Americano",
          "Xícara",
          "Litro"
        ],
        "spices": [
          "Açafrão",
          "Açafrão-da-Terra ou Cúrcuma",
          "Aceto",
          "Aceto balsamico",
          "Aipo Marrom",
          "Aipo ou Salsão",
          "Aji-no-moto",
          "Albahaca",
          "Alcaparra",
          "Alcarávia",
          "Alecrim",
          "Alecrim (ou rosmarinho)",
          "Alfavaca ou Basilicão",
          "Alho",
          "Alho desidratado",
          "Alho-poró",
          "Allspice",
          "Aneto, Dill ou Endro",
          "Anis",
          "Araruta",
          "Azedinha",
          "Azeite-de-dendê",
          "Basilico",
          "Baunilha",
          "Beldroega",
          "Benishooga",
          "Bouquet-garni",
          "Cajun",
          "Camomila",
          "Canela",
          "Canela em pó",
          "Cardamomo",
          "Cari",
          "Caril",
          "Casca de canela",
          "Cássia",
          "Cebola",
          "Cebola Frita",
          "Cebolinha",
          "Cerefólio",
          "Cheiro-verde",
          "Chili",
          "Chili Powder",
          "Chipotle",
          "Ciboulette",
          "Coentro",
          "Colorau ou Colorífico",
          "Cominho",
          "Cravo",
          "Cravo-da-Índia",
          "Cúrcuma",
          "Curry ou Caril ou Garam Masala",
          "Dente de Alho",
          "Dill",
          "Doenjang",
          "Endro",
          "Erva-doce",
          "Erva-doce de cabeça",
          "Ervas Finas ou Fines Herbes",
          "Essência de amêndoa",
          "Essência de baunilha",
          "Essência de menta",
          "Estragão ou Absinto Russo",
          "Feno Grego",
          "Fines Herbes",
          "Folha de aipo",
          "Folha de coentro",
          "Funcho ou Erva-doce de cabeça",
          "Funghi Secchi",
          "Gengibre",
          "Gergelim",
          "Gochu jan",
          "Herbes de Provence",
          "Hissopo",
          "Hondashi",
          "Hortelã",
          "Jalapeño",
          "Lavanda francesa",
          "Lemon Pepper",
          "Losna",
          "Louro",
          "Ma’ward",
          "Ma’zahr",
          "Macis",
          "Manjericão",
          "Manjerona",
          "Marasquino",
          "Masala (Garam Masala)",
          "Mirim",
          "Misk",
          "Missô",
          "Mistura de cinco especiarias",
          "Mistura de especiarias Dhansak",
          "Molho de ostra",
          "Mostarda",
          "Nirá",
          "Noz-moscada",
          "Óleo de semente de gergelim",
          "Orégano",
          "Papoula",
          "Paprica",
          "Páprica",
          "Pimenta",
          "Pimenta branca",
          "Pimenta Caiena",
          "Pimenta Chili",
          "Pimenta da Jamaica",
          "Pimenta do reino",
          "Pimenta síria ou Bhar",
          "Pimenta Vermelha ou Calabresa",
          "Pimenta-do-reino",
          "Pimento Ground",
          "Pimentões",
          "Pimentón",
          "Pimienta",
          "Pimiento",
          "Piripiri",
          "Pó de mostarda",
          "Quatre épices",
          "Raiz Forte",
          "Raspa de Gendibre",
          "Raspa de limão",
          "Raspa de Noz-moscada",
          "Raspas de laranja",
          "Rosmarino",
          "Ruibarbo",
          "Sal de aipo",
          "Sal de tempero",
          "Sal do himalaia",
          "Sal do mar grosso",
          "Salsa",
          "Salsão",
          "Salsinha",
          "Sálvia",
          "Segurelha ou Alfavaca-do-campo",
          "Semente de aipo",
          "Semente de alcaravia",
          "Semente de coentro",
          "Semente de mostarda Amarelo",
          "Semente de mostarda branca",
          "Semente de mostarda marrom",
          "Semente de mostarda preto",
          "Semente de papoila",
          "Shoga (gengibre)",
          "Shoyu",
          "Summac",
          "Tahine",
          "Tamarindo",
          "Tempero de churrasco",
          "Tempero misto",
          "Tomilho",
          "Urucum",
          "Wasabi",
          "Zeste",
          "Zimbro"
        ]
      },
      "gender": {
        "binary_types": [
          "Feminino",
          "Masculino"
        ],
        "types": [
          "Feminino",
          "Masculino",
          "Não Binário",
          "Agênero",
          "Gênero Fluido",
          "Gênero queer",
          "Bigênero",
          "Poligênero"
        ]
      },
      "internet": {
        "domain_suffix": [
          "br",
          "com",
          "biz",
          "info",
          "name",
          "net",
          "org"
        ]
      },
      "job": {
        "education_level": [
          "Bacharelado",
          "Mestrado",
          "Doutorado",
          "Técnico",
          "Pós-graduação",
          "Pós-doutorado",
          "Licenciatura"
        ],
        "employment_type": [
          "Integral",
          "Meio período",
          "Temporário",
          "Contrato",
          "Estágio",
          "Comissão"
        ],
        "field": [
          "Marketing",
          "TI",
          "Contabilidade",
          "Administração",
          "Propaganda",
          "Bancário",
          "Serviços Comunitários",
          "Construção",
          "Consultoria",
          "Design",
          "Educação",
          "Agricultura",
          "Governamental",
          "Saúde",
          "Hospitalidade",
          "Legal",
          "Industrial",
          "Mineração",
          "Imobiliária",
          "Varejo",
          "Vendas",
          "Tecnologia"
        ],
        "key_skills": [
          "Trabalho em equipe",
          "Comunicação",
          "Resolução de problemas",
          "Liderança",
          "Organização",
          "Trabalhar sobre pressão",
          "Confiança",
          "Auto motivado",
          "Habilidades de networking",
          "Proatividade",
          "Aprendizado rápido",
          "Experiência com tecnologia"
        ],
        "position": [
          "Supervisor",
          "Associado",
          "Executivo",
          "Contato",
          "Oficial",
          "Gerente",
          "Engenheiro",
          "Especialista",
          "Diretor",
          "Coordenador",
          "Administrador",
          "Arquiteto",
          "Analista",
          "Designer",
          "Planejador",
          "Orquestrador",
          "Técnico",
          "Desenvolvedor",
          "Fabricante",
          "Consultor",
          "Assistente",
          "Facilitador",
          "Agente",
          "Representante",
          "Estrategista"
        ],
        "seniority": [
          "Lead",
          "Senior",
          "Nacional",
          "Regional",
          "Distrital",
          "Central",
          "Global",
          "Consumidor",
          "Investidor",
          "Dinâmico",
          "Internacional",
          "Legado",
          "Frente",
          "Interno",
          "Chefe",
          "Corporativo",
          "Futuro",
          "Humano",
          "Principal",
          "Junior",
          "Pleno",
          "Estagiário",
          "Trainee"
        ],
        "title": [
          "#{position} de #{field} #{seniority}",
          "#{position} #{field} #{seniority}",
          "#{seniority} #{position} de #{field}",
          "#{position} de #{field}",
          "#{position} #{seniority}"
        ]
      },
      "lorem": {
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "name": {
        "female_first_name": [
          "Alice",
          "Alícia",
          "Aline",
          "Amanda",
          "Ana",
          "Beatriz",
          "Bianca",
          "Bruna",
          "Carla",
          "Catarina",
          "Cecília",
          "Célia",
          "Clara",
          "Dalila",
          "Eduarda",
          "Emanuelly",
          "Esther",
          "Fabrícia",
          "Felícia",
          "Fernanda",
          "Gabriela",
          "Giovanna",
          "Helena",
          "Heloísa",
          "Isabel",
          "Isabela",
          "Isabella",
          "Isabelly",
          "Isadora",
          "Isis",
          "Janaína",
          "Joana",
          "Júlia",
          "Karla",
          "Lara",
          "Larissa",
          "Laura",
          "Lavínia",
          "Letícia",
          "Lívia",
          "Lorena",
          "Lorraine",
          "Luiza",
          "Manuela",
          "Marcela",
          "Márcia",
          "Margarida",
          "Maria",
          "Mariana",
          "Marina",
          "Marli",
          "Meire",
          "Melissa",
          "Mércia",
          "Morgana",
          "Natália",
          "Nicole",
          "Núbia",
          "Ofélia",
          "Paula",
          "Rafaela",
          "Rebeca",
          "Roberta",
          "Sara",
          "Sarah",
          "Sílvia",
          "Sophia",
          "Suélen",
          "Talita",
          "Valentina",
          "Vitória",
          "Yasmin",
          "Adriana",
          "Agatha",
          "Alessandra",
          "Allana",
          "Ana Beatriz",
          "Ana Cecília",
          "Ana Clara",
          "Ana Júlia",
          "Ana Laura",
          "Ana Lívia",
          "Ana Luiza",
          "Ana Sophia",
          "Ana Vitória",
          "Antonella",
          "Antonia",
          "Aurora",
          "Ayla",
          "Bárbara",
          "Camila",
          "Carolina",
          "Clarice",
          "Elisa",
          "Eloah",
          "Emilly",
          "Francisca",
          "Gabrielly",
          "Giulia",
          "Juliana",
          "Laís",
          "Liz",
          "Louise",
          "Luana",
          "Luna",
          "Maitê",
          "Malu",
          "Marcia",
          "Maria Alice",
          "Maria Cecília",
          "Maria Clara",
          "Maria Eduarda",
          "Maria Fernanda",
          "Maria Flor",
          "Maria Helena",
          "Maria Isis",
          "Maria Júlia",
          "Maria Laura",
          "Maria Luiza",
          "Maria Sophia",
          "Maria Valentina",
          "Maria Vitória",
          "Mariah",
          "Maya",
          "Milena",
          "Mirella",
          "Olívia",
          "Patricia",
          "Pérola",
          "Pietra",
          "Sophie",
          "Stella"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Aguiar",
          "Albuquerque",
          "Almada",
          "Almeida",
          "Álvares",
          "Alves",
          "Ambrósio",
          "Amoreira",
          "Antena",
          "Antunes",
          "Aparício",
          "Aragão",
          "Arantes",
          "Araújo",
          "Aroeira",
          "Arriaga",
          "Assumpção",
          "Banheira",
          "Barata",
          "Barbosa",
          "Barreira",
          "Barreto",
          "Barros",
          "Barroso",
          "Batista",
          "Beltrão",
          "Bentes",
          "Bernardes",
          "Bittencourt",
          "Bomdia",
          "Bonfim",
          "Bouças",
          "Braga",
          "Brites",
          "Brum",
          "Bulhões",
          "Cabreira",
          "Cachoeira",
          "Caldas",
          "Caldeira",
          "Camacho",
          "Campos",
          "Cardoso",
          "Carneiro",
          "Carreira",
          "Carvalheira",
          "Carvalho",
          "Caseira",
          "Casqueira",
          "Castanheira",
          "Castanho",
          "Castelo",
          "Castro",
          "Cavalcanti",
          "Cerqueira",
          "Chaves",
          "Conceição",
          "Coqueiro",
          "Corrêa",
          "Corte",
          "Costa",
          "Coutinho",
          "Crespo",
          "Cruz",
          "Custódio",
          "da Aldeia",
          "da Bandeira",
          "da Barra",
          "da Barranca",
          "da Conceição",
          "da Costa",
          "da Cruz",
          "da Cunha",
          "da Fonseca",
          "da Fontoura",
          "da Fronteira",
          "da Gama",
          "da Luz",
          "da Madureira",
          "da Maia",
          "da Mata",
          "da Mota",
          "da Nóbrega",
          "da Paz",
          "da Penha",
          "da Rocha",
          "da Rosa",
          "da Silva",
          "da Silveira",
          "da Terra",
          "da Veiga",
          "Dantas",
          "das Neves",
          "Datena",
          "de Assunção",
          "de Borba",
          "de Lara",
          "de Lins",
          "de Oliveira",
          "de Quadros",
          "de Sá",
          "Dias",
          "Diegues",
          "do Prado",
          "Domingues",
          "Dorneles",
          "dos Reis",
          "Duarte",
          "Espinheira",
          "Espinhosa",
          "Esteves",
          "Farias",
          "Fernandes",
          "Ferraço",
          "Ferreira",
          "Figueira",
          "Filgueira",
          "Fogaça",
          "Fontes",
          "Fontinhas",
          "Franco",
          "Freitas",
          "Gabeira",
          "Galego",
          "Galvão",
          "Garcês",
          "Garcez",
          "Gentil",
          "Geraldes",
          "Godinho",
          "Godins",
          "Gomes",
          "Gomide",
          "Gonçalves",
          "Goulart",
          "Grotas",
          "Guedes",
          "Guterres",
          "Henriques",
          "Hermingues",
          "Hernandes",
          "Jaques",
          "Jesus",
          "Junqueira",
          "Laranjeira",
          "Leiria",
          "Lessa",
          "Lima",
          "Limeira",
          "Lobos",
          "Longuinho",
          "Lopes",
          "Louzada",
          "Macedo",
          "Macieira",
          "Madeira",
          "Mangueira",
          "Marcondes",
          "Marins",
          "Marques",
          "Martim",
          "Martins",
          "Matoso",
          "Meira",
          "Meireles",
          "Melo",
          "Mendanha",
          "Mendes",
          "Menendes",
          "Modesto",
          "Moniz",
          "Monteira",
          "Monteiro",
          "Moraes",
          "Morais",
          "Moreira",
          "Moreno",
          "Moura",
          "Munhoz",
          "Muniz",
          "Nascimento",
          "Negrão",
          "Neves",
          "Nogueira",
          "Novaes",
          "Nunes",
          "Oliveira",
          "Ordonhes",
          "Ornelas",
          "Ouriques",
          "Paes",
          "Paiva",
          "Palhares",
          "Palmeira",
          "Parreira",
          "Passarinho",
          "Pedroso",
          "Peixoto",
          "Pereira",
          "Peres",
          "Pimenta",
          "Pinheira",
          "Pinto",
          "Pires",
          "Porteira",
          "Porto",
          "Quaresma",
          "Quarteira",
          "Raia",
          "Ramalho",
          "Rameira",
          "Ramires",
          "Ramos",
          "Rebouças",
          "Rêgo",
          "Regueira",
          "Reis",
          "Resende",
          "Rezende",
          "Ribas",
          "Ribeira",
          "Ribeiro",
          "Rios",
          "Rocha",
          "Rodrigues",
          "Rolim",
          "Roriz",
          "Roseira",
          "Sá",
          "Sais",
          "Sales",
          "Sanches",
          "Santana",
          "Santos",
          "Saraiva",
          "Silva",
          "Silveira",
          "Simão",
          "Simões",
          "Siqueira",
          "Siqueiro",
          "Soares",
          "Soeira",
          "Solimões",
          "Souza",
          "Tavares",
          "Taveira",
          "Teixeira",
          "Teles",
          "Vasques",
          "Velasques",
          "Veles",
          "Veloso",
          "Viana",
          "Vidal",
          "Videira",
          "Vieira",
          "Vimaranes",
          "Viveiros",
          "Xavier",
          "Ximenes"
        ],
        "male_first_name": [
          "Alessandro",
          "Alexandre",
          "Antônio",
          "Arthur",
          "Benício",
          "Benjamin",
          "Bernardo",
          "Breno",
          "Bryan",
          "Caio",
          "Carlos",
          "Cauã",
          "César",
          "Daniel",
          "Danilo",
          "Davi",
          "Deneval",
          "Djalma",
          "Eduardo",
          "Elísio",
          "Emanuel",
          "Enrico",
          "Enzo",
          "Fabiano",
          "Fábio",
          "Fabrício",
          "Feliciano",
          "Felipe",
          "Félix",
          "Francisco",
          "Frederico",
          "Gabriel",
          "Gúbio",
          "Guilherme",
          "Gustavo",
          "Heitor",
          "Hélio",
          "Henrique",
          "Hugo",
          "Ígor",
          "Isaac",
          "João",
          "Joaquim",
          "Júlio",
          "Kléber",
          "Ladislau",
          "Leonardo",
          "Lorenzo",
          "Lucas",
          "Lucca",
          "Marcelo",
          "Márcio",
          "Marcos",
          "Matheus",
          "Miguel",
          "Murilo",
          "Nataniel",
          "Nicolas",
          "Norberto",
          "Pablo",
          "Paulo",
          "Pedro",
          "Pietro",
          "Rafael",
          "Raul",
          "Ricardo",
          "Roberto",
          "Salvador",
          "Samuel",
          "Silas",
          "Sirineu",
          "Tertuliano",
          "Theo",
          "Thiago",
          "Thomas",
          "Vicente",
          "Víctor",
          "Vinicius",
          "Vitor",
          "Warley",
          "Washington",
          "Yago",
          "Yango",
          "Yuri",
          "André",
          "Anthony",
          "Arthur Gabriel",
          "Arthur Henrique",
          "Arthur Miguel",
          "Augusto",
          "Bento",
          "Bruno",
          "Calebe",
          "Carlos Eduardo",
          "Davi Lucas",
          "Davi Luca",
          "Davi Lucca",
          "Davi Ludmer",
          "Davi Luiz",
          "Davi Miguel",
          "Enzo Gabriel",
          "Enzo Thiago",
          "Enzo Miguel",
          "Erick",
          "Fernando",
          "Gael",
          "Henry",
          "Ian",
          "Igor",
          "João",
          "João Gabriel",
          "João Guilherme",
          "João Lucas",
          "João Luca",
          "João Miguel",
          "João Samuel",
          "João Pedro",
          "João Felipe",
          "João Vitor",
          "João Victor",
          "José",
          "Kaique",
          "Kauê",
          "Levi",
          "Luan",
          "Lucas Gabriel",
          "Luiz",
          "Luiz Felipe",
          "Luiz Gustavo",
          "Luiz Henrique",
          "Luiz Miguel",
          "Luiz Otávio",
          "Mathias",
          "Nathan",
          "Noah",
          "Oliver",
          "Otávio",
          "Pedro Tobias",
          "Pedro Henrique",
          "Pedro Lucas",
          "Pedro Miguel",
          "Rodrigo",
          "Ruan",
          "Ryan",
          "Tiago",
          "Tomás",
          "Vinícius",
          "Vitor Hugo"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{suffix}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Sr.",
          "Sra.",
          "Srta.",
          "Dr.",
          "Dra."
        ],
        "suffix": [
          "Jr.",
          "Neto",
          "Filho"
        ]
      },
      "phone_number": {
        "area_code": [
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "21",
          "22",
          "24",
          "27",
          "28",
          "31",
          "32",
          "33",
          "34",
          "35",
          "37",
          "38",
          "41",
          "42",
          "43",
          "44",
          "45",
          "46",
          "47",
          "48",
          "49",
          "51",
          "53",
          "54",
          "55",
          "61",
          "62",
          "63",
          "64",
          "65",
          "66",
          "67",
          "68",
          "69",
          "71",
          "73",
          "74",
          "75",
          "77",
          "79",
          "81",
          "82",
          "83",
          "84",
          "85",
          "86",
          "87",
          "88",
          "89",
          "91",
          "92",
          "93",
          "94",
          "95",
          "96",
          "97",
          "98",
          "99"
        ],
        "country_code": [
          "55"
        ],
        "formats": [
          "(#{PhoneNumber.area_code}) #{PhoneNumber.subscriber_number}-#{PhoneNumber.subscriber_number}"
        ],
        "subscriber_number": [
          "####"
        ]
      },
      "science": {
        "element": [
          "Hidrogênio",
          "Hélio",
          "Lítio",
          "Berílio",
          "Boro",
          "Carbono",
          "Nitrogênio",
          "Oxigênio",
          "Flúor",
          "Néon",
          "Sódio",
          "Magnésio",
          "Alumínio",
          "Silício",
          "Fósforo",
          "Enxofre",
          "Cloro",
          "Argônio",
          "Potássio",
          "Cálcio",
          "Escândio",
          "Titânio",
          "Vanádio",
          "Cromo",
          "Manganês",
          "Ferro",
          "Cobalto",
          "Níquel",
          "Cobre",
          "Zinco",
          "Gálio",
          "Germânio",
          "Arsênico",
          "Selênio",
          "Bromo",
          "Criptônio",
          "Rubídio",
          "Estrôncio",
          "Ítrio",
          "Zircônio",
          "Nióbio",
          "Molibdênio",
          "Tecnécio",
          "Rutênio",
          "Ródio",
          "Paládio",
          "Prata",
          "Cádmio",
          "Índio",
          "Estanho",
          "Antimônio",
          "Telúrio",
          "Iodo",
          "Xenônio",
          "Césio",
          "Bário",
          "Lantânio",
          "Cério",
          "Praseodímio",
          "Neodímio",
          "Promécio",
          "Samário",
          "Európio",
          "Gadolínio",
          "Térbio",
          "Disprósio",
          "Hólmio",
          "Érbio",
          "Túlio",
          "Itérbio",
          "Lutécio",
          "Háfnio",
          "Tântalo",
          "Tungstênio",
          "Rênio",
          "Ósmio",
          "Irídio",
          "Platina",
          "Ouro",
          "Mercúrio",
          "Tálio",
          "Chumbo",
          "Bismuto",
          "Polônio",
          "Astatino",
          "Radônio",
          "Frâncio",
          "Rádio",
          "Actínio",
          "Tório",
          "Protactínio",
          "Urânio",
          "Neptúnio",
          "Plutônio",
          "Amerício",
          "Cúrio",
          "Berquélio",
          "Califórnio",
          "Einstênio",
          "Férmio",
          "Mendelévio",
          "Nobélio",
          "Laurêncio",
          "Rutherfórdio",
          "Dúbnio",
          "Seabórgio",
          "Bóhrio",
          "Hássio",
          "Meitnério",
          "Darmstádtio",
          "Roentgênio",
          "Copernício",
          "Nipónio",
          "Fleróvio",
          "Moscóvio",
          "Livermório",
          "Tenesso",
          "Oganesson"
        ]
      },
      "space": {
        "distance_measurement": [
          "anos-luz",
          "AU",
          "parsecs",
          "kiloparsecs",
          "megaparsecs"
        ],
        "moon": [
          "Lua",
          "Fobos",
          "Deimos",
          "Europa",
          "Ganimedes",
          "Io",
          "Calisto",
          "Leda",
          "Himalia",
          "Lisiteia",
          "Mimas",
          "Tétis",
          "Encélado",
          "Dione",
          "Reia",
          "Jápeto",
          "Titã",
          "Cordélia",
          "Ofélia",
          "Miranda",
          "Umbriel",
          "Ariel",
          "Oberon",
          "Titânia",
          "Proteu",
          "Nereida",
          "Galateia",
          "Larissa",
          "Tritão"
        ],
        "planet": [
          "Mercúrio",
          "Vênus",
          "Terra",
          "Marte",
          "Júpiter",
          "Saturno",
          "Urano",
          "Netuno"
        ]
      },
      "subscription": {
        "payment_methods": [
          "Cartão de crédito",
          "Cartão de débito",
          "Paypal",
          "Dinheiro",
          "Transferência de dinheiro",
          "Bitcoins",
          "Cheque",
          "Apple Pay",
          "Google Pay",
          "WeChat Pay",
          "Alipay",
          "Visa Checkout",
          "Pix",
          "Boleto"
        ],
        "payment_terms": [
          "Pagamento antecipado",
          "Mensal",
          "Anual",
          "Assinatura completa"
        ],
        "plans": [
          "Teste gratuito",
          "Básico",
          "Starter",
          "Essencial",
          "Estudante",
          "Bronze",
          "Standard",
          "Prata",
          "Ouro",
          "Platinum",
          "Profissional",
          "Business",
          "Diamante",
          "Premium"
        ],
        "statuses": [
          "Ativo",
          "Inativo",
          "Bloqueado",
          "Pendente"
        ],
        "subscription_terms": [
          "Diária",
          "Semanal",
          "Mensal",
          "Anual",
          "Bienal",
          "Trienal",
          "Quinquenal",
          "Vitalícia"
        ]
      },
      "team": {
        "gentile": [
          "Acriano",
          "Alagoano",
          "Amapaense",
          "Amazonense",
          "Baiano",
          "Cearense",
          "Brasiliense",
          "Capixaba",
          "Goiano",
          "Maranhense",
          "Mato-grossense",
          "Sul-mato-grossense",
          "Mineiro",
          "Paraense",
          "Paraibano",
          "Paranaense",
          "Pernambucano",
          "Piauiense",
          "Fluminense",
          "Carioca",
          "Potiguar",
          "Gaúcho",
          "Rondoniano",
          "Roraimense",
          "Catarinense",
          "Paulista",
          "Paulistano",
          "Sergipano",
          "Tocantinense"
        ],
        "main_teams": [
          "Flamengo",
          "Fluminense",
          "Botafogo",
          "Vasco da Gama",
          "Corinthians",
          "Grêmio",
          "Flamengo",
          "Palmeiras",
          "Santos",
          "Coritiba",
          "Cruzeiro",
          "Ponte Preta",
          "Chapecoense",
          "Sport",
          "São Paulo",
          "Bahia",
          "Vitória",
          "Avaí",
          "América"
        ],
        "name": [
          "#{Team.prefix} #{Team.gentile}",
          "#{Team.main_teams}"
        ],
        "prefix": [
          "Grêmio",
          "Atlético",
          "Clube de Regatas",
          "Esporte"
        ],
        "sport": [
          "handebol",
          "basquete",
          "futebol",
          "UFC",
          "volêi",
          "tênis"
        ]
      },
      "university": {
        "name": [
          "#{University.prefix} #{Name.last_name} #{University.suffix}",
          "#{University.prefix} do(a) #{Address.state} #{University.suffix}",
          "#{University.prefix} do(a) #{Address.state}",
          "#{University.prefix} #{University.region} do(a) #{Address.state}",
          "#{University.prefix} #{University.region} do(a) #{Address.state} #{University.suffix}",
          "#{University.prefix} #{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{Name.last_name}"
        ],
        "prefix": [
          "Universidade",
          "Faculdade",
          "Centro Tecnológico"
        ],
        "region": [
          "Federal",
          "Estadual",
          "Municipal",
          "Rural",
          "Regional",
          "Católica",
          "Metodista"
        ],
        "suffix": [
          "do Sul",
          "do Norte",
          "a Distância",
          "EAD",
          "do Leste",
          "do Oeste",
          "do Nordeste",
          "do Suldeste",
          "da Floresta Amazônica",
          "da Caatinga",
          "Atlântica"
        ]
      },
      "vehicle": {
        "license_plate": [
          "???-####",
          "???#?##",
          "???##?#"
        ],
        "license_plate_by_state": {
          "AC": [
            "MZ[N-Z]-####",
            "NA[A-G]-####",
            "NX[R-T]-####",
            "OVG-####",
            "OXP-####",
            "QL[U-Z]-####"
          ],
          "AL": [
            "MU?-####",
            "MV[A-K]-####",
            "NL[V-Z]-####",
            "NM[A-O]-####",
            "OH[B-K]-####",
            "OR[D-M]-####",
            "OXN-####",
            "QL[A-M]-####"
          ],
          "AM": [
            "JW[F-Z]-####",
            "JX[A-Y]-####",
            "NO[I-Z]-####",
            "NP[A-B]-####",
            "OA[A-O]-####",
            "OXM-####",
            "PH?-####"
          ],
          "AP": [
            "NE[I-Z]-####",
            "NF[A-B]-####",
            "QL[N-T]-####"
          ],
          "BA": [
            "JK[S-Z]-####",
            "J[L-S]?-####",
            "NT[D-W]-####",
            "NY[H-Z]-####",
            "NZ?-####",
            "OK[I-Z]-####",
            "OL[A-G]-####",
            "OU[F-Z]-####",
            "OV[A-D]-####",
            "OZ[C-V]-####",
            "P[J-L]?-####"
          ],
          "CE": [
            "HT[X-Z]-####",
            "H[U-Y]?-####",
            "HZA-####",
            "NQ[L-Z]-####",
            "NR[A-E]-####",
            "NU[M-Z]-####",
            "NV[A-F]-####",
            "OC[B-U]-####",
            "OH[X-Z]-####",
            "OI[A-Q]-####",
            "OR[N-Z]-####",
            "OS[A-V]-####",
            "OZA-####",
            "P[M-O]?-####"
          ],
          "DF": [
            "JD[P-Z]-####",
            "J[E-J]?-####",
            "JK[A-R]-####",
            "OV[M-V]-####",
            "OZ[W-Z]-####",
            "P[A-B]?-####"
          ],
          "ES": [
            "MO[X-Z]-####",
            "M[P-T]?-####",
            "OC[V-Z]-####",
            "OD[A-T]-####",
            "OV[EFH-L]-####",
            "OY[D-K]-####",
            "PP?-####",
            "QR[B-Z]-####"
          ],
          "GO": [
            "KA[V-Z]-####",
            "K[B-E]?-####",
            "KF[A-C]-####",
            "NF[C-Z]-####",
            "NG?-####",
            "NJ[X-Z]-####",
            "NK?-####",
            "NL[A-U]-####",
            "NV[O-Z]-####",
            "NW[A-R]-####",
            "OG[H-Z]-####",
            "OHA-####",
            "OM[I-Z]-####",
            "ON?-####",
            "OO[A-F]-####",
            "P[QR]?-####"
          ],
          "MA": [
            "HO[L-Z]-####",
            "HP?-####",
            "HQ[A-E]-####",
            "NH[A-T]-####",
            "NM[P-Z]-####",
            "NN[A-I]-####",
            "NW[S-Z]-####",
            "NX[A-Q]-####",
            "OI[R-Z]-####",
            "OJ[A-Q]-####",
            "OX[Q-Z]-####",
            "P[ST]?-####"
          ],
          "MG": [
            "GK[J-Z]-####",
            "G[L-Z]?-####",
            "H[A-N]?-####",
            "HO[A-K]-####",
            "NX[X-Z]-####",
            "NY[A-G]-####",
            "OL[O-Z]-####",
            "OM[A-G]-####",
            "OO[V-Z]-####",
            "OR[A-C]-####",
            "OW[H-Z]-####",
            "OX[A-K]-####",
            "P[U-Z]?-####",
            "QM[Q-Z]-####",
            "Q[N-Q]?-####"
          ],
          "MS": [
            "HQ[F-Z]-####",
            "H[RS]?-####",
            "HT[A-W]-####",
            "NR[F-Z]-####",
            "NS[A-D]-####",
            "OO[G-U]-####",
            "QA?-####"
          ],
          "MT": [
            "JXZ-####",
            "J[YZ]?-####",
            "KA[A-U]-####",
            "NI[YZ]-####",
            "NJ[A-W]-####",
            "NP[C-Q]-####",
            "NT[X-Z]-####",
            "NU[A-G]-####",
            "OA[A-P]-####",
            "OB[A-S]-####",
            "Q[BC]?-####"
          ],
          "PA": [
            "J[T-V]?-####",
            "JW[A-E]-####",
            "NS[E-Z]-####",
            "NT[A-C]-####",
            "OB[T-Z]-####",
            "OCA-####",
            "OF[I-W]-####",
            "OS[W-Z]-####",
            "OTZ-####",
            "Q[DE]?-####"
          ],
          "PB": [
            "MM[N-Z]-####",
            "MN?-####",
            "MO[A-W]-####",
            "NP[R-Z]-####",
            "NQ[A-K]-####",
            "OE[T-Z]-####",
            "OF[A-H]-####",
            "OF[X-Z]-####",
            "OG[A-G]-####",
            "OXO-####",
            "QF?-####",
            "QS?-####"
          ],
          "PE": [
            "KF[D-Z]-####",
            "K[G-L]?-####",
            "KM[A-E]-####",
            "NX[U-W]-####",
            "P[C-D]?-####",
            "PE[A-D]-####",
            "PE[E-Z]-####",
            "PF[A-Q]-####",
            "PF[R-Z]-####",
            "PG?-####",
            "OY[L-Z]-####"
          ],
          "PI": [
            "LV[F-Z]-####",
            "LW[A-Q]-####",
            "NH[U-Z]-####",
            "NI[A-X]-####",
            "OD[I-Z]-####",
            "OE[A-I]-####",
            "OU[A-E]-####",
            "OV[W-Y]-####",
            "PI?-####"
          ],
          "PR": [
            "A??-####",
            "B[A-E]?-####"
          ],
          "RJ": [
            "KM[F-Z]-####",
            "K[N-Z]?-####",
            "L[A-U]?-####",
            "LV[A-E]-####",
            "RIO-####"
          ],
          "RN": [
            "MX[H-Z]-####",
            "MY?-####",
            "MZ[A-M]-####",
            "NN[J-Z]-####",
            "NO[A-H]-####",
            "OJ[R-Z]-####",
            "OK[A-C]-####",
            "OVZ-####",
            "OW[A-G]-####",
            "QG?-####"
          ],
          "RO": [
            "NB[B-Z]-####",
            "N[CD]?-####",
            "NE[A-H]-####",
            "OH[L-W]-####",
            "OXL-####",
            "QRA-####",
            "QT[A-B]-####"
          ],
          "RR": [
            "NA[H-Z]-####",
            "NBA-####",
            "NU[H-L]-####"
          ],
          "RS": [
            "IA[Q-Z]-####",
            "I[B-Z]?-####",
            "J[A-C]?-####",
            "JD[A-O]-####"
          ],
          "SC": [
            "LW[R-Z]-####",
            "L[X-Z]?-####",
            "M[A-L]?-####",
            "MM[A-M]-####",
            "OK[D-H]",
            "Q[H-J]?-####"
          ],
          "SE": [
            "HZ[B-Z]-####",
            "IA[A-P]-####",
            "NV[G-N]-####",
            "OE[J-S]-####",
            "OZB-####",
            "QK[N-Z]-####",
            "QM[A-P]-####"
          ],
          "SP": [
            "B[F-Z]?-####",
            "[C-F]??-####",
            "G[A-J]?-####",
            "GK[A-I]-####",
            "SAV-####"
          ],
          "TO": [
            "MV[L-Z]-####",
            "MW?-####",
            "MX[A-G]-####",
            "OL[H-N]-####",
            "OY[A-C]-####",
            "QK[A-M]-####"
          ]
        }
      }
    },
    "hello": "olá",
    "helpers": {
      "select": {
        "prompt": "Por favor selecione"
      },
      "submit": {
        "create": "Criar %{model}",
        "submit": "Salvar %{model}",
        "update": "Atualizar %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u %n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "R$"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "bilhão",
              "other": "bilhões"
            },
            "million": {
              "one": "milhão",
              "other": "milhões"
            },
            "quadrillion": {
              "one": "quatrilhão",
              "other": "quatrilhões"
            },
            "thousand": "mil",
            "trillion": {
              "one": "trilhão",
              "other": "trilhões"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ".",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": "."
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %B de %Y, %H:%M:%S %z",
        "long": "%d de %B de %Y, %H:%M",
        "short": "%d de %B, %H:%M"
      },
      "pm": "pm"
    },
    "welcome": "bem-vindo"
  },
  "pt_BR": {
    "devise": {
      "failure": {
        "invited": "Você tem um convite pendente, aceite para finalizar sua conta."
      },
      "invitations": {
        "edit": {
          "header": "Escolha sua senha",
          "submit_button": "Atualizar minha senha"
        },
        "invitation_removed": "Seu convite foi removido.",
        "invitation_token_invalid": "O código do convite não é válido!",
        "new": {
          "header": "Enviar convite",
          "submit_button": "Enviar um convite"
        },
        "no_invitations_remaining": "Sem convites pendentes",
        "send_instructions": "Um email de convite foi enviado para %{email}.",
        "updated": "Sua senha foi atualizada com sucesso. Você está autenticado agora."
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "Aceitar convite",
          "hello": "Olá %{email}",
          "ignore": "Se você não quer aceitar esse convite, por favor ignore esse e-mail.<br />Sua conta não será criada até você acessar o link abaixo e escolher sua senha.",
          "someone_invited_you": "Alguém convidou você para acessar %{url}, você pode aceitar o convite através do link abaixo.",
          "subject": "Instruções do convite"
        }
      }
    }
  },
  "rm": {
    "date": {
      "abbr_day_names": [
        "du",
        "gli",
        "ma",
        "me",
        "gie",
        "ve",
        "so"
      ],
      "abbr_month_names": [
        null,
        "schan",
        "favr",
        "mars",
        "avr",
        "matg",
        "zercl",
        "fan",
        "avust",
        "sett",
        "oct",
        "nov",
        "dec"
      ],
      "day_names": [
        "dumengia",
        "glindesdi",
        "mardi",
        "mesemna",
        "gievgia",
        "venderdi",
        "sonda"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "schaner",
        "favrer",
        "mars",
        "avrigl",
        "matg",
        "zercladur",
        "fanadur",
        "avust",
        "settember",
        "october",
        "november",
        "december"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "circa %{count} uras",
          "many": "circa %{count} uras",
          "one": "circa in'ura",
          "other": "circa %{count} uras",
          "two": "circa %{count} uras",
          "zero": "circa %{count} uras"
        },
        "about_x_months": {
          "few": "circa %{count} mais",
          "many": "circa %{count} mais",
          "one": "circa in mais",
          "other": "circa %{count} mais",
          "two": "circa %{count} mais",
          "zero": "circa %{count} mais"
        },
        "about_x_years": {
          "few": "circa %{count} onns",
          "many": "circa %{count} onns",
          "one": "circa in onn",
          "other": "circa %{count} onns",
          "two": "circa %{count} onns",
          "zero": "circa %{count} onns"
        },
        "half_a_minute": "ina mesa minuta",
        "less_than_x_minutes": {
          "few": "main che %{count} minutas",
          "many": "main che %{count} minutas",
          "one": "main ch’ina minuta",
          "other": "main che %{count} minutas",
          "two": "main che %{count} minutas",
          "zero": "main che %{count} minutas"
        },
        "less_than_x_seconds": {
          "few": "main che %{count} secundas",
          "many": "main che %{count} secundas",
          "one": "main ch’ina secunda",
          "other": "main che %{count} secundas",
          "two": "main che %{count} secundas",
          "zero": "main che %{count} secundas"
        },
        "over_x_years": {
          "few": "dapli che %{count} onns",
          "many": "dapli che %{count} onns",
          "one": "dapli ch'in onn",
          "other": "dapli che %{count} onns",
          "two": "dapli che %{count} onns",
          "zero": "dapli che %{count} onns"
        },
        "x_days": {
          "few": "%{count} dis",
          "many": "%{count} dis",
          "one": "in di",
          "other": "%{count} dis",
          "two": "%{count} dis",
          "zero": "%{count} dis"
        },
        "x_minutes": {
          "few": "%{count} minutas",
          "many": "%{count} minutas",
          "one": "%{count} minuta",
          "other": "%{count} minutas",
          "two": "%{count} minutas",
          "zero": "%{count} minutas"
        },
        "x_months": {
          "few": "%{count} mais",
          "many": "%{count} mais",
          "one": "in mais",
          "other": "%{count} mais",
          "two": "%{count} mais",
          "zero": "%{count} mais"
        },
        "x_seconds": {
          "few": "%{count} secundas",
          "many": "%{count} secundas",
          "one": "ina secunda",
          "other": "%{count} secundas",
          "two": "%{count} secundas",
          "zero": "%{count} secundas"
        }
      },
      "prompts": {
        "day": "dis",
        "hour": "uras",
        "minute": "minutas",
        "month": "mais",
        "second": "secundas",
        "year": "onns"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "sto vegnir acceptà",
        "blank": "sto vegnir emplenì ora",
        "confirmation": "na correspunda betg al champ da conferma",
        "empty": "sto vegnir emplenì ora",
        "equal_to": "sto esser exact %{count}",
        "even": "sto esser pèr",
        "exclusion": "na stat betg a disposiziun",
        "greater_than": "sto esser pli grond che %{count}",
        "greater_than_or_equal_to": "sto esser pli grond u medem sco %{count}",
        "inclusion": "n'è betg sin la glista",
        "invalid": "n'è betg valid",
        "less_than": "sto esser pli pitschen che %{count}",
        "less_than_or_equal_to": "sto esser pli pitschen u medem sco %{count}",
        "not_a_number": "è betg in dumber",
        "odd": "sto esser spèr",
        "taken": "è gia occupà",
        "too_long": "è memia lung (betg dapli che %{count} caracters)",
        "too_short": "è memia curt (betg pli pauc che %{count} caracters)",
        "wrong_length": "ha la fallida lunghezza (sto avair %{count} caracters)"
      },
      "template": {
        "body": "Faschai uschè bain e controllai ils suandants champs:",
        "header": {
          "few": "Betg pussaivel da memorisar quest %{model}: %{count} errurs.",
          "many": "Betg pussaivel da memorisar quest %{model}: %{count} errurs.",
          "one": "Betg pussaivel da memorisar quest %{model}: %{count} errur.",
          "other": "Betg pussaivel da memorisar quest %{model}: %{count} errurs.",
          "two": "Betg pussaivel da memorisar quest %{model}: %{count} errurs.",
          "zero": "Betg pussaivel da memorisar quest %{model}: %{count} errurs."
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": "'",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "CHF"
        }
      },
      "format": {
        "delimiter": "'",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "bytes",
              "many": "bytes",
              "one": "byte",
              "other": "bytes",
              "two": "bytes",
              "zero": "bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "avantmezdi",
      "formats": {
        "default": "%A, %d. %B %Y, %H:%M Uhr",
        "long": "%A, %d. %B %Y, %H:%M Uhr",
        "short": "%d. %B, %H:%M Uhr"
      },
      "pm": "suentermezdi"
    }
  },
  "ro": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Confirmare trimisă la",
          "confirmation_token": "Cod de confirmare",
          "confirmed_at": "Confirmat la",
          "created_at": "Creat la",
          "current_password": "Parola curentă",
          "current_sign_in_at": "Autentificarea curentă la",
          "current_sign_in_ip": "IP-ul sesiunii curente",
          "email": "Email",
          "encrypted_password": "Parolă criptată",
          "failed_attempts": "Încercări eșuate",
          "last_sign_in_at": "Ultima autentificare la",
          "last_sign_in_ip": "IP-ul ultimei autentificări",
          "locked_at": "Blocat la",
          "password": "Parolă",
          "password_confirmation": "Confirmare parolă",
          "remember_created_at": "Ține minte creat la",
          "remember_me": "Ține-mă minte",
          "reset_password_sent_at": "Resetarea parolei trimisă la",
          "reset_password_token": "Resetează jetonul parolei",
          "sign_in_count": "Contor autentificări",
          "unconfirmed_email": "Email neconfirmat",
          "unlock_token": "Deblochează jetonul",
          "updated_at": "Actualizat la"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validare nereuşită %{errors}"
        }
      },
      "models": {
        "user": {
          "few": "Utilizator",
          "one": "Utilizator",
          "other": "Utilizator"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dum",
        "lun",
        "mar",
        "mie",
        "joi",
        "vin",
        "sâm"
      ],
      "abbr_month_names": [
        null,
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
      ],
      "day_names": [
        "duminică",
        "luni",
        "marți",
        "miercuri",
        "joi",
        "vineri",
        "sâmbătă"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "aproximativ %{count} ore",
          "one": "aproximativ o oră",
          "other": "aproximativ %{count} ore"
        },
        "about_x_months": {
          "few": "aproximativ %{count} luni",
          "one": "aproximativ o lună",
          "other": "aproximativ %{count} luni"
        },
        "about_x_years": {
          "few": "aproximativ %{count} ani",
          "one": "aproximativ un an",
          "other": "aproximativ %{count} ani"
        },
        "almost_x_years": {
          "few": "aproape %{count} ani",
          "one": "aproape %{count} an",
          "other": "aproape %{count} ani"
        },
        "half_a_minute": "jumătate de minut",
        "less_than_x_minutes": {
          "few": "mai puțin de %{count} minute",
          "one": "mai puțin de un minut",
          "other": "mai puțin de %{count} minute"
        },
        "less_than_x_seconds": {
          "few": "mai puțin de %{count} secunde",
          "one": "mai puțin de o secundă",
          "other": "mai puțin de %{count} secunde"
        },
        "over_x_years": {
          "few": "mai mult de %{count} ani",
          "one": "mai mult de un an",
          "other": "mai mult de %{count} ani"
        },
        "x_days": {
          "few": "%{count} zile",
          "one": "%{count} zi",
          "other": "%{count} zile"
        },
        "x_minutes": {
          "few": "%{count} minute",
          "one": "%{count} minut",
          "other": "%{count} minute"
        },
        "x_months": {
          "few": "%{count} luni",
          "one": "%{count} lună",
          "other": "%{count} luni"
        },
        "x_seconds": {
          "few": "%{count} secunde",
          "one": "%{count} secundă",
          "other": "%{count} secunde"
        }
      },
      "prompts": {
        "day": "ziua",
        "hour": "ora",
        "minute": "minutul",
        "month": "luna",
        "second": "secunda",
        "year": "anul"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Contul dvs. a fost confirmat cu succes.",
        "new": {
          "resend_confirmation_instructions": "Retrimite instrucțiunile de confirmare"
        },
        "send_instructions": "Veţi primi un e-mail cu instrucţiuni despre cum să confirmați contul dvs. în câteva minute.",
        "send_paranoid_instructions": "Dacă e-mailul dvs. există în baza noastră de date, veţi primi un e-mail cu instrucţiuni despre cum să vă confirmaţi contul în câteva minute."
      },
      "failure": {
        "already_authenticated": "Sunteţi deja autentificat",
        "inactive": "Contul dvs. nu a fost activat încă.",
        "invalid": "Parolă sau %{authentication_keys}  invalid.",
        "last_attempt": "Mai aveți o șansă până când accountul vă va fi blocat.",
        "locked": "Contul dvs. este blocat.",
        "not_found_in_database": "Parolă sau %{authentication_keys}  invalid.",
        "timeout": "Sesiunea dvs. a expirat, vă rugăm să vă autentificaţi din nou pentru a continua.",
        "unauthenticated": "Trebuie să vă conectaţi sau să vă înscrieţi înainte de a continua.",
        "unconfirmed": "Trebuie să confirmaţi contul dvs. înainte de a continua."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmă accontul meu",
          "confirm_account_link": "Confirmă cont",
          "confirm_link_msg": "Poți confirma contul accesănd link-ul de mai jos:",
          "greeting": "Bine ați venit %{recipient}!",
          "instruction": "Vă puteți confirma emailul prin link-ul de mai jos:",
          "subject": "Instrucţiuni de confirmare"
        },
        "email_changed": {
          "greeting": "Bună %{recipient}!",
          "message": "Te contactăm pentru a te informa că adresa ta de email va fi înlocuită cu %{email}.",
          "message_unconfirmed": null,
          "subject": "Adresă de email actualizată"
        },
        "password_change": {
          "greeting": "Bună %{recipient}!",
          "message": "Vă contactăm pentru a vă anunța ca parola dvs. a fost modificată.",
          "subject": "Parolă Schimbată"
        },
        "reset_password_instructions": {
          "action": "Schimbă parola",
          "greeting": "Bună %{recipient}!",
          "ignore_mail_msg": "Dacă nu ai solicitat această schimbare ignoră acest e-mail.",
          "instruction": "Cineva a cerut un link pentru a schimba parola, puteți să faceți acest lucru prin link-ul de mai jos.",
          "instruction_2": "Dacă nu ați cerut acest lucru, vă rugăm să ignorați acest email.",
          "instruction_3": "Parola dvs. nu se v-a schimba până când nu accesați link-ul de mai sus și setați una nouă.",
          "no_changes_msg": "Parola ta nu se va schimba până când nu vei accesa link-ul de mai sus și vei crea o nouă parolă.",
          "password_change_link": "Schimbă parola",
          "request_reset_link_msg": "Cineva a solicitat un link pentru schimbarea parolei contului tău. Poți face această schimbare accesând link-ul de mai jos.",
          "subject": "Instrucțiuni pentru resetarea parolei"
        },
        "unlock_instructions": {
          "account_lock_msg": "Contul tău a fost blocat din cauză că cineva a încercat accesarea lui de mai mult ori într-un timp foarte scurt.",
          "action": "Deblochează-mi contul",
          "greeting": "Bună %{recipient}!",
          "instruction": "Apăsați pe link-ul de mai jos pentru a vă debloca contul:",
          "message": "Contul dumneavoastră a fost blocat din cauza unui număr ridicat de încercări de autentificare eșuate.",
          "subject": "Instrucțiuni pentru deblocarea contului",
          "unlock_link": "Deblochează contul.",
          "unlock_link_msg": "Click pe acest link pentru a debloca contul:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nu te-am putut autoriza de pe contul de %{kind} pentru că \"%{reason}\".",
        "success": "Autorizat cu success din contul de %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Schimbă parola mea",
          "change_your_password": "Schimbați parola dvs.",
          "confirm_new_password": "Confirmați parola nouă",
          "new_password": "Parolă nouă"
        },
        "new": {
          "forgot_your_password": "Ați uitat parola?",
          "send_me_reset_password_instructions": "Trimiteți instrucțiuni de resetare a parolei"
        },
        "no_token": "Nu puteți accesa această pagină dacă nu veniți de la un email de resetare a parolei. Dacă veniți de la un astfel de email, vă rugăm asigurați-vă că aţi utiliz at URL-ul complet furnizat către dumneavoastră.",
        "send_instructions": "Veţi primi un e-mail cu instrucţiuni pentru resetarea parolei dvs. în câteva minute.",
        "send_paranoid_instructions": "Dacă e-mailul dvs. există în baza noastră de date, veţi primi un link de recuperare a parolei pe adresa de e-mail.",
        "updated": "Parola dvs. a fost schimbată cu succes. Sunteţi autentificat.",
        "updated_not_active": "Parola dvs. a fost schimbată cu succes."
      },
      "registrations": {
        "destroyed": "Adio! Contul dvs. a fost anulat cu succes. Sperăm să vă vedem din nou în curând.",
        "edit": {
          "are_you_sure": "Sunteți sigur?",
          "cancel_my_account": "Anulează contul",
          "currently_waiting_confirmation_for_email": "Se asteaptă confirmare pentru: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lăsați gol dacă nu doriți să schimbați",
          "title": "Editează %{resource}",
          "unhappy": "Nefericit",
          "update": "Actualizați",
          "we_need_your_current_password_to_confirm_your_changes": "avem nevoie de parola curentă pentru a confirma schimbările"
        },
        "new": {
          "sign_up": "Înregistrare"
        },
        "signed_up": "Bine ai venit! V-aţi înscris cu succes.",
        "signed_up_but_inactive": "V-aţi înscris cu succes. Cu toate acestea, nu am putut să vă autentificăm, deoarece contul dvs. nu este încă activată.",
        "signed_up_but_locked": "V-aţi înscris cu succes. Cu toate acestea, nu am putut să vă autentificăm, deoarece contul dvs. este blocat.",
        "signed_up_but_unconfirmed": "Un mesaj cu un link de confirmare a fost trimis la adresa dvs. de e-mail. Vă rugăm sa deschideți link-ul pentru a activa contul.",
        "update_needs_confirmation": "Aţi actualizat contul dvs. de succes, dar avem nevoie să verificăm adresa dvs. de e-mail. Vă rugăm să verificați adresa de email şi faceţi clic pe link-ul de confirmă pentru a finaliza confirmarea adresei dvs. de e-mail.",
        "updated": "Aţi actualizat contul dvs. cu succes.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Deautentificarea s-a efectuat cu success.",
        "new": {
          "sign_in": "Autentificare"
        },
        "signed_in": "Autentificat cu succes.",
        "signed_out": "Deautentificarea s-a efectuat cu success."
      },
      "shared": {
        "links": {
          "back": "Înapoi",
          "didn_t_receive_confirmation_instructions": "Nu ați primit instrucțiuni de confirmare?",
          "didn_t_receive_unlock_instructions": "Nu ați primit instrucțiuni pentru deblocare?",
          "forgot_your_password": "Ați uitat parola?",
          "sign_in": "Autentificare",
          "sign_in_with_provider": "Autentificat cu %{provider}",
          "sign_up": "Înregistrare"
        },
        "minimum_password_length": {
          "few": "(minim %{count} caractere)",
          "one": "(minim %{count} caracter)",
          "other": "(minim %{count} caractere)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Retrimite instrucțiuni pentru deblocare"
        },
        "send_instructions": "Veţi primi un e-mail cu instrucţiuni despre cum să deblocați contul dvs. în câteva minute.",
        "send_paranoid_instructions": "În cazul în care contul dvs. există, veţi primi un e-mail cu instrucţiuni despre cum să-l deblocați în câteva minute.",
        "unlocked": "Contul dvs. a fost deblocat cu succes. Vă rugăm autentificați pentru a continua."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Redirecționarea către '%{redirect_url}' nu este permisă."
      },
      "passwords": {
        "missing_email": "Trebuie să introduci o adresă de e-mail.",
        "missing_passwords": "Cămpurile 'Parolă' și 'Confirmare parolă' trebuiesc completate.",
        "missing_redirect_url": "URL-ul pentru redirecționare lipsește.",
        "not_allowed_redirect_url": "Redirecționarea către '%{redirect_url}' nu este permisă.",
        "password_not_required": "Acest cont nu necesită parolă. Autentifică-te in schimb cu '%{provider}'.",
        "sended": "Un e-mail cu instrucțiuni pentru resetare a parolei a fost trimis către '%{email}'.",
        "successfully_updated": "Parola contului a fost schimbată cu succes.",
        "user_not_found": "Utilizatorul cu email-ul '%{email}' nu a fost găsit."
      },
      "registrations": {
        "account_to_destroy_not_found": "Nu se poate localiza contul pentru ștergere.",
        "account_with_uid_destroyed": "Contul cu UID '%{uid}' a fost șters.",
        "email_already_exists": "Un cont cu email '%{email} deja există.'",
        "missing_confirm_success_url": "Parametrul 'confirm_success_url' lipsește.",
        "redirect_url_not_allowed": "Redirecționarea către '%{redirect_url}' nu este permisă.",
        "user_not_found": "Utilizatorul nu a fost găsit."
      },
      "sessions": {
        "bad_credentials": "Datele introduse sunt incorecte. Te rugăm să incerci din nou.",
        "not_confirmed": "Un email de confirmare a fost trimis către contul tău la '%{email}'. Pentru a-ți activa contul este necesar să urmezi instrucțiunile din acesta.",
        "not_supported": "Folosește functionalitatea POST /sign_in pentru a te autentifica. GET nu este suportat.",
        "user_not_found": "Utilizatorul nu a fost găsit sau nu este logat în cont."
      },
      "token_validations": {
        "invalid": "Datele introduse pentru autentificare sunt invalide."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "trebuie dat acceptul",
        "already_confirmed": "a fost deja confirmat, vă rugăm să încercaţi să vă autentificați",
        "blank": "nu poate fi necompletat",
        "confirmation": "nu este confirmat",
        "confirmation_period_expired": "trebuie să fie confirmat în %{period}, vă rugăm să solicitaţi unul nou",
        "empty": "nu poate fi necompletat",
        "equal_to": "trebuie să fie egal cu %{count}",
        "even": "trebuie să fie impar",
        "exclusion": "este rezervat",
        "expired": "a expirat, vă rugăm să solicitaţi unul nou",
        "greater_than": "trebuie să fie mai mare decât %{count}",
        "greater_than_or_equal_to": "trebuie să fie mai mare sau egal cu %{count}",
        "inclusion": "nu este inclus în listă",
        "invalid": "este invalid",
        "less_than": "trebuie să fie mai mic decât %{count}",
        "less_than_or_equal_to": "trebuie să fie mai mic sau egal cu %{count}",
        "not_a_number": "nu este un număr",
        "not_an_integer": "trebuie să fie un mumăr întreg",
        "not_email": "nu este un email",
        "not_found": "nu există",
        "not_locked": "nu este blocat",
        "not_saved": {
          "few": "%{count} erori nu au permis %{resource} să fie salvat:",
          "one": "1 eroare nu a permis %{resource} să fie salvat:",
          "other": "%{count} erori nu au permis %{resource} să fie salvat:"
        },
        "odd": "trebuie să fie par",
        "taken": "este deja folosit",
        "too_long": "este prea lung (se pot folosi maximum %{count} caractere)",
        "too_short": "este prea scurt (minimum de caractere este %{count})",
        "validate_account_update_params": "Trimite credențiale valide în body-ul request-ului.",
        "validate_sign_up_params": "Trimite credențiale valide în body-ul request-ului.",
        "wrong_length": "nu are lungimea corectă (trebuie să aibă %{count} caractere)"
      },
      "template": {
        "body": "Încearcă să corectezi urmatoarele câmpuri:",
        "header": {
          "few": "Nu am putut salva acest %{model}: %{count} erori.",
          "one": "Nu am putut salva acest %{model}: o eroare",
          "other": "Nu am putut salva acest %{model}: %{count} erori."
        }
      }
    },
    "hello": "salut",
    "helpers": {
      "select": {
        "prompt": "Alegeți"
      },
      "submit": {
        "create": "Creare %{model}",
        "submit": "Salvare %{model}",
        "update": "Modificare %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "Â": "A",
          "Î": "I",
          "â": "a",
          "î": "i",
          "Ă": "A",
          "ă": "a",
          "Ș": "S",
          "ș": "s",
          "Ț": "T",
          "ț": "t"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "RON"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "miliard",
            "million": "milion",
            "quadrillion": "quadrilion",
            "thousand": "mie",
            "trillion": "trilion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "Bytes",
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ","
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " și ",
        "two_words_connector": " și ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "welcome": "bun venit"
  },
  "ru": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Дата отправки подтверждения",
          "confirmation_token": "Токен подтверждения",
          "confirmed_at": "Дата подтверждения",
          "created_at": "Дата создания",
          "current_password": "Текущий пароль",
          "current_sign_in_at": "Дата текущего входа",
          "current_sign_in_ip": "IP текущего входа",
          "email": "Эл. почта",
          "encrypted_password": "Зашифрованный пароль",
          "failed_attempts": "Неудачные попытки",
          "last_sign_in_at": "Дата последнего входа",
          "last_sign_in_ip": "IP последнего входа",
          "locked_at": "Дата блокировки",
          "password": "Пароль",
          "password_confirmation": "Подтверждение пароля",
          "remember_created_at": "Дата создания запоминания",
          "remember_me": "Запомнить меня",
          "reset_password_sent_at": "Дата отправки сброса пароля",
          "reset_password_token": "Токен сброса пароля",
          "sign_in_count": "Количество входов",
          "unconfirmed_email": "Неподтверждённая эл. почта",
          "unlock_token": "Токен разблокировки",
          "updated_at": "Дата обновления"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Возникли ошибки: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Невозможно удалить запись, так как существуют зависимости: %{record}",
            "has_one": "Невозможно удалить запись, так как существует зависимость: %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": "Пользователя",
          "many": "Пользователей",
          "one": "Пользователь",
          "other": "Пользователей"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Вс",
        "Пн",
        "Вт",
        "Ср",
        "Чт",
        "Пт",
        "Сб"
      ],
      "abbr_month_names": [
        null,
        "янв.",
        "февр.",
        "марта",
        "апр.",
        "мая",
        "июня",
        "июля",
        "авг.",
        "сент.",
        "окт.",
        "нояб.",
        "дек."
      ],
      "day_names": [
        "воскресенье",
        "понедельник",
        "вторник",
        "среда",
        "четверг",
        "пятница",
        "суббота"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "около %{count} часов",
          "many": "около %{count} часов",
          "one": "около %{count} часа",
          "other": "около %{count} часов"
        },
        "about_x_months": {
          "few": "около %{count} месяцев",
          "many": "около %{count} месяцев",
          "one": "около %{count} месяца",
          "other": "около %{count} месяцев"
        },
        "about_x_years": {
          "few": "около %{count} лет",
          "many": "около %{count} лет",
          "one": "около %{count} года",
          "other": "около %{count} лет"
        },
        "almost_x_years": {
          "few": "почти %{count} года",
          "many": "почти %{count} лет",
          "one": "почти %{count} год",
          "other": "почти %{count} лет"
        },
        "half_a_minute": "полминуты",
        "less_than_x_minutes": {
          "few": "меньше %{count} минут",
          "many": "меньше %{count} минут",
          "one": "меньше %{count} минуты",
          "other": "меньше %{count} минут"
        },
        "less_than_x_seconds": {
          "few": "меньше %{count} секунд",
          "many": "меньше %{count} секунд",
          "one": "меньше %{count} секунды",
          "other": "меньше %{count} секунд"
        },
        "over_x_years": {
          "few": "больше %{count} лет",
          "many": "больше %{count} лет",
          "one": "больше %{count} года",
          "other": "больше %{count} лет"
        },
        "x_days": {
          "few": "%{count} дня",
          "many": "%{count} дней",
          "one": "%{count} день",
          "other": "%{count} дней"
        },
        "x_minutes": {
          "few": "%{count} минуты",
          "many": "%{count} минут",
          "one": "%{count} минута",
          "other": "%{count} минут"
        },
        "x_months": {
          "few": "%{count} месяца",
          "many": "%{count} месяцев",
          "one": "%{count} месяц",
          "other": "%{count} месяцев"
        },
        "x_seconds": {
          "few": "%{count} секунды",
          "many": "%{count} секунд",
          "one": "%{count} секунда",
          "other": "%{count} секунд"
        },
        "x_years": {
          "few": "%{count} года",
          "many": "%{count} лет",
          "one": "%{count} год",
          "other": "%{count} лет"
        }
      },
      "prompts": {
        "day": "День",
        "hour": "Час",
        "minute": "Минута",
        "month": "Месяц",
        "second": "Секунда",
        "year": "Год"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ваш адрес эл. почты успешно подтверждён.",
        "new": {
          "resend_confirmation_instructions": "Выслать повторно письмо с активацией"
        },
        "send_instructions": "В течение нескольких минут вы получите письмо с инструкциями по подтверждению адреса эл. почты.",
        "send_paranoid_instructions": "Если ваш адрес эл. почты есть в системе, то в течение нескольких минут вы получите письмо с инструкциями по его подтверждению."
      },
      "failure": {
        "already_authenticated": "Вы уже вошли в систему.",
        "inactive": "Ваша учётная запись ещё не активирована.",
        "invalid": "%{authentication_keys} или пароль неверны.",
        "invited": "У вас есть непринятое приглашение, подтвердите его чтобы продолжить создание аккаунта.",
        "last_attempt": "У вас осталась последняя попытка ввода пароля до блокировки учётной записи.",
        "locked": "Ваша учётная запись заблокирована.",
        "not_found_in_database": "%{authentication_keys} или пароль неверны.",
        "timeout": "Ваш сеанс закончился. Пожалуйста, войдите в систему снова.",
        "unauthenticated": "Вам необходимо войти в систему или зарегистрироваться.",
        "unconfirmed": "Вы должны подтвердить вашу учётную запись."
      },
      "invitations": {
        "edit": {
          "header": "Создание пароля",
          "submit_button": "Сохранить"
        },
        "invitation_removed": "Выше приглашение было удалено.",
        "invitation_token_invalid": "Неверный токен приглашения.",
        "new": {
          "header": "Отправить приглашение",
          "submit_button": "Отправить приглашение"
        },
        "no_invitations_remaining": "Приглашений нет",
        "send_instructions": "Письмо с приглашением было отправлено на %{email}.",
        "updated": "Ваш пароль успешно сохранен. Вы вошли в систему."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Активировать",
          "confirm_account_link": "Подтвердить свою учетную запись",
          "confirm_link_msg": "Вы можете подтвердить ваш адрес электронной почты через ссылку ниже :",
          "greeting": "Приветствуем, %{recipient}!",
          "instruction": "Вы можете активировать свою учётную запись, нажав ссылку снизу:",
          "subject": "Инструкции подтверждения"
        },
        "email_changed": {
          "greeting": "Здравствуйте, %{recipient}!",
          "message": "Мы пытаемся связаться с вами, чтобы сообщить, что ваш адрес электронной почты был изменён на %{email}.",
          "message_unconfirmed": "Мы пытаемся связаться с вами, чтобы сообщить, что ваш адрес электронной почты будет изменён на %{email}.",
          "subject": "Эл. адрес изменён"
        },
        "invitation_instructions": {
          "accept": "Создать аккаунт",
          "hello": "Здравствуйте, %{email}",
          "ignore": "Если вы не хотите создавать аккаунт, проигнорируйте это письмо. <br /> Учетная запись не будет создана, пока вы не пройдете по ссылке и не установите пароль.",
          "someone_invited_you": "Это письмо - приглашение стать пользователем сайта %{url}, вы можете создать аккаунт, кликнув по ссылке ниже.",
          "subject": "Инструкции по созданию учетной записи"
        },
        "password_change": {
          "greeting": "Здравствуйте, %{recipient}!",
          "message": "Мы пытаемся связаться с вами, чтобы сообщить, что ваш пароль был изменён.",
          "subject": "Пароль изменён"
        },
        "reset_password_instructions": {
          "action": "Сменить пароль",
          "greeting": "Здравствуйте, %{recipient}!",
          "ignore_mail_msg": "Если Вы не запрашивали это, Вы можете проигнорировать это письмо.",
          "instruction": "Вы (или кто-то ещё) запросили изменение пароля. Для изменения пароля нажмите ссылку ниже:",
          "instruction_2": "Если вы не запрашивали изменение пароля – проигнорируйте это письмо.",
          "instruction_3": "Ваш пароль не изменится, пока вы не нажмёте на ссылку и не введёте новый.",
          "no_changes_msg": "Ваш пароль не изменится, пока вы не откроете ссылку выше и не создадите новый пароль.",
          "password_change_link": "Изменить пароль",
          "request_reset_link_msg": "Кто-то запросил ссылку на изменение пароля. Вы можете сделать это через ссылку ниже.",
          "subject": "Инструкции для восстановления пароля"
        },
        "unlock_instructions": {
          "account_lock_msg": "Ваш аккаунт был заблокирован из-за чрезмерного количества неудачных попыток входа.",
          "action": "Разблокировать учётную запись",
          "greeting": "Здравствуйте, %{recipient}!",
          "instruction": "Нажмите по ссылке для активации учётной записи:",
          "message": "Ваша учётная запись была заблокирована в связи с превышением предела неудачных попыток входа.",
          "subject": "Разблокировать Инструкции",
          "unlock_link": "Разблокировать мою учетную запись",
          "unlock_link_msg": "Нажмите на ссылку ниже, чтобы разблокировать свой аккаунт:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Вы не можете войти под учётной записью из %{kind}, т.к. «%{reason}».",
        "success": "Вход выполнен под учётной записью из %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Изменить мой пароль",
          "change_your_password": "Изменить пароль",
          "confirm_new_password": "Повторите новый пароль",
          "new_password": "Новый пароль"
        },
        "new": {
          "forgot_your_password": "Забыли пароль?",
          "send_me_reset_password_instructions": "Выслать новый пароль"
        },
        "no_token": "Доступ к этой странице возможен только по ссылке из письма о восстановлении пароля. Если вы пришли по такой ссылке, пожалуйста, убедитесь, что вы скопировали всю ссылку целиком.",
        "send_instructions": "В течение нескольких минут вы получите письмо с инструкциями по восстановлению пароля.",
        "send_paranoid_instructions": "Если ваш адрес эл. почты есть в системе, то в течение нескольких минут вы получите письмо с инструкциями по восстановлению пароля.",
        "updated": "Ваш пароль изменён. Теперь вы вошли в систему.",
        "updated_not_active": "Ваш пароль изменён."
      },
      "registrations": {
        "destroyed": "До свидания! Ваша учётная запись удалена. Надеемся снова увидеть вас.",
        "edit": {
          "are_you_sure": "Вы уверены?",
          "cancel_my_account": "Удалить учётную запись",
          "currently_waiting_confirmation_for_email": "Ожидается подтверждение почты: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "оставьте поле пустым, если не хотите его менять",
          "title": "%{resource}: изменение",
          "unhappy": "Разочарованы?",
          "update": "Обновить",
          "we_need_your_current_password_to_confirm_your_changes": "введите текущий пароль для подтверждения изменений"
        },
        "new": {
          "sign_up": "Регистрация"
        },
        "signed_up": "Добро пожаловать! Вы успешно зарегистрировались.",
        "signed_up_but_inactive": "Вы успешно зарегистрированы. Однако, вы не можете войти в систему, потому что ваша учётная запись не активирована.",
        "signed_up_but_locked": "Вы успешно зарегистрированы. Однако, вы не можете войти в систему, потому что ваша учётная запись заблокирована.",
        "signed_up_but_unconfirmed": "Письмо со ссылкой для подтверждения было отправлено на ваш адрес эл. почты. Пожалуйста, перейдите по ссылке, чтобы подтвердить учётную запись.",
        "update_needs_confirmation": "Вы успешно обновили данные учетной записи, но необходимо подтвердить новый адрес эл. почты. Пожалуйста, проверьте почтовый ящик и перейдите по ссылке, чтобы закончить процедуру проверки нового адреса.",
        "updated": "Ваша учётная запись обновлена.",
        "updated_but_not_signed_in": "Ваша учётная запись обновлена, но так как пароль был изменён, необходимо войти в систему снова."
      },
      "sessions": {
        "already_signed_out": "Выход из системы уже выполнен.",
        "new": {
          "sign_in": "Войти"
        },
        "signed_in": "Вход в систему выполнен.",
        "signed_out": "Выход из системы выполнен."
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Не получили подтверждение?",
          "didn_t_receive_unlock_instructions": "Не получили код разблокировки?",
          "forgot_your_password": "Забыли пароль?",
          "sign_in": "Войти",
          "sign_in_with_provider": "Войти с помощью: %{provider}",
          "sign_up": "Регистрация"
        },
        "minimum_password_length": {
          "few": "(минимум символов: %{count})",
          "many": "(минимум символов: %{count})",
          "one": "(минимум %{count} символ)",
          "other": "(минимум символов: %{count})"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Выслать подтверждение заново"
        },
        "send_instructions": "В течение нескольких минут вы получите письмо с инструкциями по разблокировке учётной записи.",
        "send_paranoid_instructions": "Если ваша учётная запись существует, то в течение нескольких минут вы получите письмо с инструкциями по её разблокировке.",
        "unlocked": "Ваша учётная запись разблокирована. Теперь вы можете войти в систему."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Переадресация на '%{redirect_url}' не разрешена."
      },
      "passwords": {
        "missing_email": "Вы должны указать адрес электронной почты.",
        "missing_passwords": "Вы должны заполнить поля 'пароль' и 'повторите пароль'.",
        "missing_redirect_url": "Отсутствует адрес переадресации.",
        "not_allowed_redirect_url": "Переадресация на '%{redirect_url}' не разрешена.",
        "password_not_required": "Эта учетная запись не требует пароля. Войдите используя учетную запись '%{provider}'.",
        "sended": "Инструкция по восстановлению пароля отправлена на Вашу электронную почту '%{email}'.",
        "successfully_updated": "Ваш пароль успешно обновлён.",
        "user_not_found": "Не удается найти пользователя с электронной почтой '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Не удается найти учетную запись для удаления.",
        "account_with_uid_destroyed": "Учетная запись с uid '%{uid}' удалена.",
        "email_already_exists": "Учетная запись для '%{email}' уже существует",
        "missing_confirm_success_url": "Отсутствует параметр 'confirm_success_url'.",
        "redirect_url_not_allowed": "Переадресация на '%{redirect_url}' не разрешена.",
        "user_not_found": "Пользователь не найден."
      },
      "sessions": {
        "bad_credentials": "Неверные логин или пароль. Пожалуйста, попробуйте еще раз.",
        "not_confirmed": "Письмо с подтверждением Вашей учетной записи '%{email}' отправлено на электронную почту. Вы должны следовать инструкциям, приведенным в письме, прежде чем Ваша учетная запись сможет быть активирована",
        "not_supported": "Используйте POST /sign_in для входа. GET запросы не поддерживаются.",
        "user_not_found": "Пользователь не найден или не вошел."
      },
      "token_validations": {
        "invalid": "Неверные логин или пароль."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "нужно подтвердить",
        "already_confirmed": "– уже подтверждено. Пожалуйста, попробуйте войти в систему",
        "blank": "не может быть пустым",
        "confirmation": "не совпадает со значением поля %{attribute}",
        "confirmation_period_expired": "– должно быть подтверждено в течение %{period}, пожалуйста, повторите запрос на подтверждение",
        "empty": "не может быть пустым",
        "equal_to": "может иметь лишь значение, равное %{count}",
        "even": "может иметь лишь четное значение",
        "exclusion": "имеет зарезервированное значение",
        "expired": "– устарело. Пожалуйста, запросите новое",
        "greater_than": "может иметь значение большее %{count}",
        "greater_than_or_equal_to": "может иметь значение большее или равное %{count}",
        "in": "должно быть в диапазоне %{count}",
        "inclusion": "имеет непредусмотренное значение",
        "invalid": "имеет неверное значение",
        "less_than": "может иметь значение меньшее чем %{count}",
        "less_than_or_equal_to": "может иметь значение меньшее или равное %{count}",
        "model_invalid": "Возникли ошибки: %{errors}",
        "not_a_number": "не является числом",
        "not_an_integer": "не является целым числом",
        "not_email": "не является электронной почтой",
        "not_found": "– не найдено",
        "not_locked": "– не заблокировано",
        "not_saved": {
          "few": "%{resource}: сохранение не удалось из-за %{count} ошибок:",
          "many": "%{resource}: сохранение не удалось из-за %{count} ошибок:",
          "one": "%{resource}: сохранение не удалось из-за одной ошибки:",
          "other": "%{resource}: сохранение не удалось из-за %{count} ошибок:"
        },
        "odd": "может иметь лишь нечетное значение",
        "other_than": "должно отличаться от %{count}",
        "present": "нужно оставить пустым",
        "required": "не может отсутствовать",
        "taken": "уже существует",
        "too_long": {
          "few": "слишком большой длины (не может быть больше чем %{count} символа)",
          "many": "слишком большой длины (не может быть больше чем %{count} символов)",
          "one": "слишком большой длины (не может быть больше чем %{count} символ)",
          "other": "слишком большой длины (не может быть больше чем %{count} символа)"
        },
        "too_short": {
          "few": "недостаточной длины (не может быть меньше %{count} символов)",
          "many": "недостаточной длины (не может быть меньше %{count} символов)",
          "one": "недостаточной длины (не может быть меньше %{count} символа)",
          "other": "недостаточной длины (не может быть меньше %{count} символа)"
        },
        "validate_account_update_params": "Пожалуйста, укажите надлежащие данные для обновления учетной записи в теле запроса.",
        "validate_sign_up_params": "Пожалуйста, укажите надлежащие данные для регистрации в теле запроса.",
        "wrong_length": {
          "few": "неверной длины (может быть длиной ровно %{count} символа)",
          "many": "неверной длины (может быть длиной ровно %{count} символов)",
          "one": "неверной длины (может быть длиной ровно %{count} символ)",
          "other": "неверной длины (может быть длиной ровно %{count} символа)"
        }
      },
      "template": {
        "body": "Проблемы возникли со следующими полями:",
        "header": {
          "few": "%{model}: сохранение не удалось из-за %{count} ошибок",
          "many": "%{model}: сохранение не удалось из-за %{count} ошибок",
          "one": "%{model}: сохранение не удалось из-за %{count} ошибки",
          "other": "%{model}: сохранение не удалось из-за %{count} ошибки"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###"
        ],
        "city": [
          "#{Address.city_name}"
        ],
        "city_name": [
          "Москва",
          "Владимир",
          "Санкт-Петербург",
          "Новосибирск",
          "Екатеринбург",
          "Нижний Новгород",
          "Самара",
          "Казань",
          "Омск",
          "Челябинск",
          "Ростов-на-Дону",
          "Уфа",
          "Волгоград",
          "Пермь",
          "Красноярск",
          "Воронеж",
          "Саратов",
          "Краснодар",
          "Тольятти",
          "Ижевск",
          "Барнаул",
          "Ульяновск",
          "Тюмень",
          "Иркутск",
          "Владивосток",
          "Ярославль",
          "Хабаровск",
          "Махачкала",
          "Оренбург",
          "Новокузнецк",
          "Томск",
          "Кемерово",
          "Рязань",
          "Астрахань",
          "Пенза",
          "Липецк",
          "Тула",
          "Киров",
          "Чебоксары",
          "Курск",
          "Брянск",
          "Магнитогорск",
          "Иваново",
          "Тверь",
          "Ставрополь",
          "Белгород",
          "Сочи"
        ],
        "country": [
          "Австралия",
          "Австрия",
          "Азербайджан",
          "Албания",
          "Алжир",
          "Американское Самоа (не признана)",
          "Ангилья",
          "Ангола",
          "Андорра",
          "Антарктика (не признана)",
          "Антигуа и Барбуда",
          "Антильские Острова (не признана)",
          "Аомынь (не признана)",
          "Аргентина",
          "Армения",
          "Афганистан",
          "Багамские Острова",
          "Бангладеш",
          "Барбадос",
          "Бахрейн",
          "Беларусь",
          "Белиз",
          "Бельгия",
          "Бенин",
          "Болгария",
          "Боливия",
          "Босния и Герцеговина",
          "Ботсвана",
          "Бразилия",
          "Бруней",
          "Буркина-Фасо",
          "Бурунди",
          "Бутан",
          "Вануату",
          "Ватикан",
          "Великобритания",
          "Венгрия",
          "Венесуэла",
          "Восточный Тимор",
          "Вьетнам",
          "Габон",
          "Гаити",
          "Гайана",
          "Гамбия",
          "Гана",
          "Гваделупа (не признана)",
          "Гватемала",
          "Гвиана (не признана)",
          "Гвинея",
          "Гвинея-Бисау",
          "Германия",
          "Гондурас",
          "Гренада",
          "Греция",
          "Грузия",
          "Дания",
          "Джибути",
          "Доминика",
          "Доминиканская Республика",
          "Египет",
          "Замбия",
          "Зимбабве",
          "Израиль",
          "Индия",
          "Индонезия",
          "Иордания",
          "Ирак",
          "Иран",
          "Ирландия",
          "Исландия",
          "Испания",
          "Италия",
          "Йемен",
          "Кабо-Верде",
          "Казахстан",
          "Камбоджа",
          "Камерун",
          "Канада",
          "Катар",
          "Кения",
          "Кипр",
          "Кирибати",
          "Китай",
          "Колумбия",
          "Коморские Острова",
          "Конго",
          "Демократическая Республика",
          "Корея (Северная)",
          "Корея (Южная)",
          "Косово",
          "Коста-Рика",
          "Кот-д'Ивуар",
          "Куба",
          "Кувейт",
          "Кука острова",
          "Кыргызстан",
          "Лаос",
          "Латвия",
          "Лесото",
          "Либерия",
          "Ливан",
          "Ливия",
          "Литва",
          "Лихтенштейн",
          "Люксембург",
          "Маврикий",
          "Мавритания",
          "Мадагаскар",
          "Македония",
          "Малави",
          "Малайзия",
          "Мали",
          "Мальдивы",
          "Мальта",
          "Маршалловы Острова",
          "Мексика",
          "Микронезия",
          "Мозамбик",
          "Молдова",
          "Монако",
          "Монголия",
          "Марокко",
          "Мьянма",
          "Намибия",
          "Науру",
          "Непал",
          "Нигер",
          "Нигерия",
          "Нидерланды",
          "Никарагуа",
          "Новая Зеландия",
          "Норвегия",
          "Объединенные Арабские Эмираты",
          "Оман",
          "Пакистан",
          "Палау",
          "Панама",
          "Папуа — Новая Гвинея",
          "Парагвай",
          "Перу",
          "Польша",
          "Португалия",
          "Республика Конго",
          "Россия",
          "Руанда",
          "Румыния",
          "Сальвадор",
          "Самоа",
          "Сан-Марино",
          "Сан-Томе и Принсипи",
          "Саудовская Аравия",
          "Свазиленд",
          "Сейшельские острова",
          "Сенегал",
          "Сент-Винсент и Гренадины",
          "Сент-Киттс и Невис",
          "Сент-Люсия",
          "Сербия",
          "Сингапур",
          "Сирия",
          "Словакия",
          "Словения",
          "Соединенные Штаты Америки",
          "Соломоновы Острова",
          "Сомали",
          "Судан",
          "Суринам",
          "Сьерра-Леоне",
          "Таджикистан",
          "Таиланд",
          "Тайвань (не признана)",
          "Тамил-Илам (не признана)",
          "Танзания",
          "Тёркс и Кайкос (не признана)",
          "Того",
          "Токелау (не признана)",
          "Тонга",
          "Тринидад и Тобаго",
          "Тувалу",
          "Тунис",
          "Турецкая Республика Северного Кипра (не признана)",
          "Туркменистан",
          "Турция",
          "Уганда",
          "Узбекистан",
          "Украина",
          "Уругвай",
          "Фарерские Острова (не признана)",
          "Фиджи",
          "Филиппины",
          "Финляндия",
          "Франция",
          "Французская Полинезия (не признана)",
          "Хорватия",
          "Центральноафриканская Республика",
          "Чад",
          "Черногория",
          "Чехия",
          "Чили",
          "Швейцария",
          "Швеция",
          "Шри-Ланка",
          "Эквадор",
          "Экваториальная Гвинея",
          "Эритрея",
          "Эстония",
          "Эфиопия",
          "Южно-Африканская Республика",
          "Ямайка",
          "Япония"
        ],
        "default_country": [
          "Россия"
        ],
        "default_country_code": [
          "RU"
        ],
        "full_address": [
          "#{postcode} #{default_country}, #{city}, #{street_address}",
          "#{postcode} #{default_country}, #{city}, #{street_address} #{secondary_address}"
        ],
        "postcode": [
          "######"
        ],
        "secondary_address": [
          "кв. ###"
        ],
        "state": [
          "Республика Адыгея",
          "Республика Башкортостан",
          "Республика Бурятия",
          "Республика Алтай",
          "Республика Дагестан",
          "Республика Ингушетия",
          "Кабардино-Балкарская Республика",
          "Республика Калмыкия",
          "Республика Карачаево-Черкессия",
          "Республика Карелия",
          "Республика Коми",
          "Республика Марий Эл",
          "Республика Мордовия",
          "Республика Саха (Якутия)",
          "Республика Северная Осетия-Алания",
          "Республика Татарстан",
          "Республика Тыва",
          "Удмуртская Республика",
          "Республика Хакасия",
          "Чувашская Республика",
          "Алтайский край",
          "Краснодарский край",
          "Красноярский край",
          "Приморский край",
          "Ставропольский край",
          "Хабаровский край",
          "Амурская область",
          "Архангельская область",
          "Астраханская область",
          "Белгородская область",
          "Брянская область",
          "Владимирская область",
          "Волгоградская область",
          "Вологодская область",
          "Воронежская область",
          "Ивановская область",
          "Иркутская область",
          "Калиниградская область",
          "Калужская область",
          "Камчатская область",
          "Кемеровская область",
          "Кировская область",
          "Костромская область",
          "Курганская область",
          "Курская область",
          "Ленинградская область",
          "Липецкая область",
          "Магаданская область",
          "Московская область",
          "Мурманская область",
          "Нижегородская область",
          "Новгородская область",
          "Новосибирская область",
          "Омская область",
          "Оренбургская область",
          "Орловская область",
          "Пензенская область",
          "Пермская область",
          "Псковская область",
          "Ростовская область",
          "Рязанская область",
          "Самарская область",
          "Саратовская область",
          "Сахалинская область",
          "Свердловская область",
          "Смоленская область",
          "Тамбовская область",
          "Тверская область",
          "Томская область",
          "Тульская область",
          "Тюменская область",
          "Ульяновская область",
          "Челябинская область",
          "Читинская область",
          "Ярославская область",
          "Еврейская автономная область",
          "Агинский Бурятский авт. округ",
          "Коми-Пермяцкий автономный округ",
          "Корякский автономный округ",
          "Ненецкий автономный округ",
          "Таймырский (Долгано-Ненецкий) автономный округ",
          "Усть-Ордынский Бурятский автономный округ",
          "Ханты-Мансийский автономный округ",
          "Чукотский автономный округ",
          "Эвенкийский автономный округ",
          "Ямало-Ненецкий автономный округ",
          "Чеченская Республика"
        ],
        "street_address": [
          "#{street_name}, #{building_number}"
        ],
        "street_name": [
          "#{street_suffix} #{Address.street_title}",
          "#{Address.street_title} #{street_suffix}"
        ],
        "street_suffix": [
          "ул.",
          "улица",
          "проспект",
          "пр.",
          "площадь",
          "пл."
        ],
        "street_title": [
          "Советская",
          "Молодежная",
          "Центральная",
          "Школьная",
          "Новая",
          "Садовая",
          "Лесная",
          "Набережная",
          "Ленина",
          "Мира",
          "Октябрьская",
          "Зеленая",
          "Комсомольская",
          "Заречная",
          "Первомайская",
          "Гагарина",
          "Полевая",
          "Луговая",
          "Пионерская",
          "Кирова",
          "Юбилейная",
          "Северная",
          "Пролетарская",
          "Степная",
          "Пушкина",
          "Калинина",
          "Южная",
          "Колхозная",
          "Рабочая",
          "Солнечная",
          "Железнодорожная",
          "Восточная",
          "Заводская",
          "Чапаева",
          "Нагорная",
          "Строителей",
          "Береговая",
          "Победы",
          "Горького",
          "Кооперативная",
          "Красноармейская",
          "Совхозная",
          "Речная",
          "Школьный",
          "Спортивная",
          "Озерная",
          "Строительная",
          "Парковая",
          "Чкалова",
          "Мичурина",
          "Подгорная",
          "Дружбы",
          "Почтовая",
          "Партизанская",
          "Вокзальная",
          "Лермонтова",
          "Свободы",
          "Дорожная",
          "Дачная",
          "Маяковского",
          "Западная",
          "Фрунзе",
          "Дзержинского",
          "Московская",
          "Свердлова",
          "Некрасова",
          "Гоголя",
          "Красная",
          "Трудовая",
          "Шоссейная",
          "Чехова",
          "Коммунистическая",
          "Труда",
          "Комарова",
          "Матросова",
          "Островского",
          "Сосновая",
          "Клубная",
          "Куйбышева",
          "Крупской",
          "Березовая",
          "Карла Маркса",
          "8 Марта",
          "Больничная",
          "Садовый",
          "Интернациональная",
          "Суворова",
          "Цветочная",
          "Трактовая",
          "Ломоносова",
          "Горная",
          "Космонавтов",
          "Энергетиков",
          "Шевченко",
          "Весенняя",
          "Механизаторов",
          "Коммунальная",
          "Лесной",
          "40 лет Победы",
          "Майская"
        ]
      },
      "commerce": {
        "color": [
          "красный",
          "зеленый",
          "синий",
          "желтый",
          "багровый",
          "мятный",
          "зеленовато-голубой",
          "белый",
          "черный",
          "оранжевый",
          "розовый",
          "серый",
          "красно-коричневый",
          "фиолетовый",
          "бирюзовый",
          "желто-коричневый",
          "небесно голубой",
          "оранжево-розовый",
          "темно-фиолетовый",
          "орхидный",
          "оливковый",
          "пурпурный",
          "лимонный",
          "кремовый",
          "сине-фиолетовый",
          "золотой",
          "красно-пурпурный",
          "голубой",
          "лазурный",
          "лиловый",
          "серебряный"
        ],
        "department": [
          "Книги",
          "Фильмы",
          "музыка",
          "игры",
          "Электроника",
          "компьютеры",
          "Дом",
          "садинструмент",
          "Бакалея",
          "здоровье",
          "красота",
          "Игрушки",
          "детское",
          "для малышей",
          "Одежда",
          "обувь",
          "украшения",
          "Спорт",
          "туризм",
          "Автомобильное",
          "промышленное"
        ],
        "product_name": {
          "adjective": [
            "Маленький",
            "Эргономичный",
            "Грубый",
            "Интеллектуальный",
            "Великолепный",
            "Невероятный",
            "Фантастический",
            "Практичный",
            "Лоснящийся",
            "Потрясающий",
            "Огромный",
            "Удовлетворительный",
            "Синергетический",
            "Тяжёлый",
            "Легкий",
            "Аэродинамический",
            "Прочный"
          ],
          "material": [
            "Стальной",
            "Деревянный",
            "Бетонный",
            "Пластиковый",
            "Хлопковый",
            "Гранитный",
            "Резиновый",
            "Кожаный",
            "Шелковый",
            "Шерстяной",
            "Льняной",
            "Мраморный",
            "Железный",
            "Бронзовый",
            "Медный",
            "Алюминиевый",
            "Бумажный"
          ],
          "product": [
            "Стул",
            "Автомобиль",
            "Компьютер",
            "Берет",
            "Кулон",
            "Стол",
            "Свитер",
            "Ремень",
            "Ботинок",
            "Тарелка",
            "Нож",
            "Бутылка",
            "Пальто",
            "Лампа",
            "Клавиатура",
            "Сумка",
            "Скамья",
            "Часы",
            "Бумажник"
          ]
        }
      },
      "company": {
        "name": [
          "#{prefix} #{Name.female_first_name}",
          "#{prefix} #{Name.male_first_name}",
          "#{prefix} #{Name.male_last_name}",
          "#{prefix} #{suffix}#{suffix}",
          "#{prefix} #{suffix}#{suffix}#{suffix}",
          "#{prefix} #{Address.city_name}#{suffix}",
          "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
          "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
        ],
        "prefix": [
          "ИП",
          "ООО",
          "ЗАО",
          "ОАО",
          "НКО",
          "ТСЖ",
          "ОП"
        ],
        "suffix": [
          "Снаб",
          "Торг",
          "Пром",
          "Трейд",
          "Сбыт"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "ru",
          "info",
          "рф",
          "net",
          "org"
        ]
      },
      "name": {
        "female_first_name": [
          "Анна",
          "Алёна",
          "Алевтина",
          "Александра",
          "Алина",
          "Алла",
          "Анастасия",
          "Ангелина",
          "Анжела",
          "Анжелика",
          "Антонида",
          "Антонина",
          "Анфиса",
          "Арина",
          "Валентина",
          "Валерия",
          "Варвара",
          "Василиса",
          "Вера",
          "Вероника",
          "Виктория",
          "Галина",
          "Дарья",
          "Евгения",
          "Екатерина",
          "Елена",
          "Елизавета",
          "Жанна",
          "Зинаида",
          "Зоя",
          "Ирина",
          "Кира",
          "Клавдия",
          "Ксения",
          "Лариса",
          "Лидия",
          "Любовь",
          "Людмила",
          "Маргарита",
          "Марина",
          "Мария",
          "Надежда",
          "Наталья",
          "Нина",
          "Оксана",
          "Ольга",
          "Раиса",
          "Регина",
          "Римма",
          "Светлана",
          "София",
          "Таисия",
          "Тамара",
          "Татьяна",
          "Ульяна",
          "Юлия"
        ],
        "female_last_name": [
          "Смирнова",
          "Иванова",
          "Кузнецова",
          "Попова",
          "Соколова",
          "Лебедева",
          "Козлова",
          "Новикова",
          "Морозова",
          "Петрова",
          "Волкова",
          "Соловьева",
          "Васильева",
          "Зайцева",
          "Павлова",
          "Семенова",
          "Голубева",
          "Виноградова",
          "Богданова",
          "Воробьева",
          "Федорова",
          "Михайлова",
          "Беляева",
          "Тарасова",
          "Белова",
          "Комарова",
          "Орлова",
          "Киселева",
          "Макарова",
          "Андреева",
          "Ковалева",
          "Ильина",
          "Гусева",
          "Титова",
          "Кузьмина",
          "Кудрявцева",
          "Баранова",
          "Куликова",
          "Алексеева",
          "Степанова",
          "Яковлева",
          "Сорокина",
          "Сергеева",
          "Романова",
          "Захарова",
          "Борисова",
          "Королева",
          "Герасимова",
          "Пономарева",
          "Григорьева",
          "Лазарева",
          "Медведева",
          "Ершова",
          "Никитина",
          "Соболева",
          "Рябова",
          "Полякова",
          "Цветкова",
          "Данилова",
          "Жукова",
          "Фролова",
          "Журавлева",
          "Николаева",
          "Крылова",
          "Максимова",
          "Сидорова",
          "Осипова",
          "Белоусова",
          "Федотова",
          "Дорофеева",
          "Егорова",
          "Матвеева",
          "Боброва",
          "Дмитриева",
          "Калинина",
          "Анисимова",
          "Петухова",
          "Антонова",
          "Тимофеева",
          "Никифорова",
          "Веселова",
          "Филиппова",
          "Маркова",
          "Большакова",
          "Суханова",
          "Миронова",
          "Ширяева",
          "Александрова",
          "Коновалова",
          "Шестакова",
          "Казакова",
          "Ефимова",
          "Денисова",
          "Громова",
          "Фомина",
          "Давыдова",
          "Мельникова",
          "Щербакова",
          "Блинова",
          "Колесникова",
          "Карпова",
          "Афанасьева",
          "Власова",
          "Маслова",
          "Исакова",
          "Тихонова",
          "Аксенова",
          "Гаврилова",
          "Родионова",
          "Котова",
          "Горбунова",
          "Кудряшова",
          "Быкова",
          "Зуева",
          "Третьякова",
          "Савельева",
          "Панова",
          "Рыбакова",
          "Суворова",
          "Абрамова",
          "Воронова",
          "Мухина",
          "Архипова",
          "Трофимова",
          "Мартынова",
          "Емельянова",
          "Горшкова",
          "Чернова",
          "Овчинникова",
          "Селезнева",
          "Панфилова",
          "Копылова",
          "Михеева",
          "Галкина",
          "Назарова",
          "Лобанова",
          "Лукина",
          "Белякова",
          "Потапова",
          "Некрасова",
          "Хохлова",
          "Жданова",
          "Наумова",
          "Шилова",
          "Воронцова",
          "Ермакова",
          "Дроздова",
          "Игнатьева",
          "Савина",
          "Логинова",
          "Сафонова",
          "Капустина",
          "Кириллова",
          "Моисеева",
          "Елисеева",
          "Кошелева",
          "Костина",
          "Горбачева",
          "Орехова",
          "Ефремова",
          "Исаева",
          "Евдокимова",
          "Калашникова",
          "Кабанова",
          "Носкова",
          "Юдина",
          "Кулагина",
          "Лапина",
          "Прохорова",
          "Нестерова",
          "Харитонова",
          "Агафонова",
          "Муравьева",
          "Ларионова",
          "Федосеева",
          "Зимина",
          "Пахомова",
          "Шубина",
          "Игнатова",
          "Филатова",
          "Крюкова",
          "Рогова",
          "Кулакова",
          "Терентьева",
          "Молчанова",
          "Владимирова",
          "Артемьева",
          "Гурьева",
          "Зиновьева",
          "Гришина",
          "Кононова",
          "Дементьева",
          "Ситникова",
          "Симонова",
          "Мишина",
          "Фадеева",
          "Комиссарова",
          "Мамонтова",
          "Носова",
          "Гуляева",
          "Шарова",
          "Устинова",
          "Вишнякова",
          "Евсеева",
          "Лаврентьева",
          "Брагина",
          "Константинова",
          "Корнилова",
          "Авдеева",
          "Зыкова",
          "Бирюкова",
          "Шарапова",
          "Никонова",
          "Щукина",
          "Дьячкова",
          "Одинцова",
          "Сазонова",
          "Якушева",
          "Красильникова",
          "Гордеева",
          "Самойлова",
          "Князева",
          "Беспалова",
          "Уварова",
          "Шашкова",
          "Бобылева",
          "Доронина",
          "Белозерова",
          "Рожкова",
          "Самсонова",
          "Мясникова",
          "Лихачева",
          "Бурова",
          "Сысоева",
          "Фомичева",
          "Русакова",
          "Стрелкова",
          "Гущина",
          "Тетерина",
          "Колобова",
          "Субботина",
          "Фокина",
          "Блохина",
          "Селиверстова",
          "Пестова",
          "Кондратьева",
          "Силина",
          "Меркушева",
          "Лыткина",
          "Турова"
        ],
        "female_middle_name": [
          "Александровна",
          "Алексеевна",
          "Альбертовна",
          "Анатольевна",
          "Андреевна",
          "Антоновна",
          "Аркадьевна",
          "Арсеньевна",
          "Артёмовна",
          "Борисовна",
          "Вадимовна",
          "Валентиновна",
          "Валерьевна",
          "Васильевна",
          "Викторовна",
          "Витальевна",
          "Владимировна",
          "Владиславовна",
          "Вячеславовна",
          "Геннадьевна",
          "Георгиевна",
          "Германовна",
          "Григорьевна",
          "Данииловна",
          "Денисовна",
          "Дмитриевна",
          "Евгеньевна",
          "Егоровна",
          "Ивановна",
          "Игнатьевна",
          "Игоревна",
          "Ильинична",
          "Константиновна",
          "Лаврентьевна",
          "Леонидовна",
          "Макаровна",
          "Максимовна",
          "Матвеевна",
          "Михайловна",
          "Никитична",
          "Николаевна",
          "Олеговна",
          "Романовна",
          "Семёновна",
          "Сергеевна",
          "Станиславовна",
          "Степановна",
          "Фёдоровна",
          "Эдуардовна",
          "Юрьевна",
          "Ярославовна"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "#{female_last_name}",
          "#{male_last_name}"
        ],
        "male_first_name": [
          "Александр",
          "Алексей",
          "Альберт",
          "Анатолий",
          "Андрей",
          "Антон",
          "Аркадий",
          "Арсений",
          "Артём",
          "Борис",
          "Вадим",
          "Валентин",
          "Валерий",
          "Василий",
          "Виктор",
          "Виталий",
          "Владимир",
          "Владислав",
          "Вячеслав",
          "Геннадий",
          "Георгий",
          "Герман",
          "Григорий",
          "Даниил",
          "Денис",
          "Дмитрий",
          "Евгений",
          "Егор",
          "Иван",
          "Игнатий",
          "Игорь",
          "Илья",
          "Константин",
          "Лаврентий",
          "Леонид",
          "Лука",
          "Макар",
          "Максим",
          "Матвей",
          "Михаил",
          "Никита",
          "Николай",
          "Олег",
          "Роман",
          "Семён",
          "Сергей",
          "Станислав",
          "Степан",
          "Фёдор",
          "Эдуард",
          "Юрий",
          "Ярослав"
        ],
        "male_last_name": [
          "Смирнов",
          "Иванов",
          "Кузнецов",
          "Попов",
          "Соколов",
          "Лебедев",
          "Козлов",
          "Новиков",
          "Морозов",
          "Петров",
          "Волков",
          "Соловьев",
          "Васильев",
          "Зайцев",
          "Павлов",
          "Семенов",
          "Голубев",
          "Виноградов",
          "Богданов",
          "Воробьев",
          "Федоров",
          "Михайлов",
          "Беляев",
          "Тарасов",
          "Белов",
          "Комаров",
          "Орлов",
          "Киселев",
          "Макаров",
          "Андреев",
          "Ковалев",
          "Ильин",
          "Гусев",
          "Титов",
          "Кузьмин",
          "Кудрявцев",
          "Баранов",
          "Куликов",
          "Алексеев",
          "Степанов",
          "Яковлев",
          "Сорокин",
          "Сергеев",
          "Романов",
          "Захаров",
          "Борисов",
          "Королев",
          "Герасимов",
          "Пономарев",
          "Григорьев",
          "Лазарев",
          "Медведев",
          "Ершов",
          "Никитин",
          "Соболев",
          "Рябов",
          "Поляков",
          "Цветков",
          "Данилов",
          "Жуков",
          "Фролов",
          "Журавлев",
          "Николаев",
          "Крылов",
          "Максимов",
          "Сидоров",
          "Осипов",
          "Белоусов",
          "Федотов",
          "Дорофеев",
          "Егоров",
          "Матвеев",
          "Бобров",
          "Дмитриев",
          "Калинин",
          "Анисимов",
          "Петухов",
          "Антонов",
          "Тимофеев",
          "Никифоров",
          "Веселов",
          "Филиппов",
          "Марков",
          "Большаков",
          "Суханов",
          "Миронов",
          "Ширяев",
          "Александров",
          "Коновалов",
          "Шестаков",
          "Казаков",
          "Ефимов",
          "Денисов",
          "Громов",
          "Фомин",
          "Давыдов",
          "Мельников",
          "Щербаков",
          "Блинов",
          "Колесников",
          "Карпов",
          "Афанасьев",
          "Власов",
          "Маслов",
          "Исаков",
          "Тихонов",
          "Аксенов",
          "Гаврилов",
          "Родионов",
          "Котов",
          "Горбунов",
          "Кудряшов",
          "Быков",
          "Зуев",
          "Третьяков",
          "Савельев",
          "Панов",
          "Рыбаков",
          "Суворов",
          "Абрамов",
          "Воронов",
          "Мухин",
          "Архипов",
          "Трофимов",
          "Мартынов",
          "Емельянов",
          "Горшков",
          "Чернов",
          "Овчинников",
          "Селезнев",
          "Панфилов",
          "Копылов",
          "Михеев",
          "Галкин",
          "Назаров",
          "Лобанов",
          "Лукин",
          "Беляков",
          "Потапов",
          "Некрасов",
          "Хохлов",
          "Жданов",
          "Наумов",
          "Шилов",
          "Воронцов",
          "Ермаков",
          "Дроздов",
          "Игнатьев",
          "Савин",
          "Логинов",
          "Сафонов",
          "Капустин",
          "Кириллов",
          "Моисеев",
          "Елисеев",
          "Кошелев",
          "Костин",
          "Горбачев",
          "Орехов",
          "Ефремов",
          "Исаев",
          "Евдокимов",
          "Калашников",
          "Кабанов",
          "Носков",
          "Юдин",
          "Кулагин",
          "Лапин",
          "Прохоров",
          "Нестеров",
          "Харитонов",
          "Агафонов",
          "Муравьев",
          "Ларионов",
          "Федосеев",
          "Зимин",
          "Пахомов",
          "Шубин",
          "Игнатов",
          "Филатов",
          "Крюков",
          "Рогов",
          "Кулаков",
          "Терентьев",
          "Молчанов",
          "Владимиров",
          "Артемьев",
          "Гурьев",
          "Зиновьев",
          "Гришин",
          "Кононов",
          "Дементьев",
          "Ситников",
          "Симонов",
          "Мишин",
          "Фадеев",
          "Комиссаров",
          "Мамонтов",
          "Носов",
          "Гуляев",
          "Шаров",
          "Устинов",
          "Вишняков",
          "Евсеев",
          "Лаврентьев",
          "Брагин",
          "Константинов",
          "Корнилов",
          "Авдеев",
          "Зыков",
          "Бирюков",
          "Шарапов",
          "Никонов",
          "Щукин",
          "Дьячков",
          "Одинцов",
          "Сазонов",
          "Якушев",
          "Красильников",
          "Гордеев",
          "Самойлов",
          "Князев",
          "Беспалов",
          "Уваров",
          "Шашков",
          "Бобылев",
          "Доронин",
          "Белозеров",
          "Рожков",
          "Самсонов",
          "Мясников",
          "Лихачев",
          "Буров",
          "Сысоев",
          "Фомичев",
          "Русаков",
          "Стрелков",
          "Гущин",
          "Тетерин",
          "Колобов",
          "Субботин",
          "Фокин",
          "Блохин",
          "Селиверстов",
          "Пестов",
          "Кондратьев",
          "Силин",
          "Меркушев",
          "Лыткин",
          "Туров"
        ],
        "male_middle_name": [
          "Александрович",
          "Алексеевич",
          "Альбертович",
          "Анатольевич",
          "Андреевич",
          "Антонович",
          "Аркадьевич",
          "Арсеньевич",
          "Артёмович",
          "Борисович",
          "Вадимович",
          "Валентинович",
          "Валерьевич",
          "Васильевич",
          "Викторович",
          "Витальевич",
          "Владимирович",
          "Владиславович",
          "Вячеславович",
          "Геннадьевич",
          "Георгиевич",
          "Германович",
          "Григорьевич",
          "Даниилович",
          "Денисович",
          "Дмитриевич",
          "Евгеньевич",
          "Егорович",
          "Иванович",
          "Игнатьевич",
          "Игоревич",
          "Ильич",
          "Константинович",
          "Лаврентьевич",
          "Леонидович",
          "Лукич",
          "Макарович",
          "Максимович",
          "Матвеевич",
          "Михайлович",
          "Никитич",
          "Николаевич",
          "Олегович",
          "Романович",
          "Семёнович",
          "Сергеевич",
          "Станиславович",
          "Степанович",
          "Фёдорович",
          "Эдуардович",
          "Юрьевич",
          "Ярославович"
        ],
        "name": [
          "#{male_first_name} #{male_last_name}",
          "#{male_last_name} #{male_first_name}",
          "#{male_first_name} #{male_middle_name} #{male_last_name}",
          "#{male_last_name} #{male_first_name} #{male_middle_name}",
          "#{female_first_name} #{female_last_name}",
          "#{female_last_name} #{female_first_name}",
          "#{female_first_name} #{female_middle_name} #{female_last_name}",
          "#{female_last_name} #{female_first_name} #{female_middle_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "7"
        ],
        "formats": [
          "(9##)###-##-##"
        ]
      },
      "separator": " и ",
      "yoda": {
        "quotes": [
          "Да пребудет с тобой сила",
          "Твоё оружие, оно тебе не понадобится",
          "Меньше нас, но больше ума",
          "Размер не имеет значения. Посмотрите на меня. Судите меня по размеру, не так ли?",
          "Вы найдете только то, что вы принесете",
          "Оставайся в трудном положении, когда должен",
          "Светящиеся существа — это мы… а не эта грубая материя",
          "Вы найдете хорошее в плохом, когда будете спокойны и пассивны",
          "Поистине замечательным ум ребенка является",
          "Почувствуй силу!",
          "В темном месте мы находим себя, и лишь знания освещают наш путь",
          "Смерть — это естественная часть жизни. Радуйся за тех, кто вокруг тебя, кто превращается в Силу. Оплакивать их не надо. Скучать по ним не надо",
          "Секрет должен ли я вам открыть? Великий Магистр Ордена Джедаев я. Выиграл эту работу в лотерее, так вы думаете? «Как вы узнали, как вы узнали, мастер Йода?» Мастер Йода знает все это. Это его работа",
          "Приключение. Азарт. Джедай не жаждет этих вещей",
          "Чтобы отвечать силой на силу, путь джедая не в этом. В этой войне существует опасность потерять того, кем мы являемся",
          "Многое узнать ты еще можешь, мой старый падаван. Это только начало",
          "Быть джедаем — значит смотреть правде в глаза и выбирать. Источай свет или тьму, падаван. Будь свечой или ночью",
          "Я не могу научить его. У мальчика нет терпения",
          "Джедай использует Силу для знания и защиты, а не для атаки",
          "Решить ты должен, как услужить им лучше всего. Если ты уйдешь сейчас, помоги им, чем сможешь; но ты уничтожишь все, за что они сражались и страдали",
          "Контролируй, контролируй, ты должен научиться контролировать!",
          "Всегда делись тем, чему ты научился",
          "Всегда есть два, не больше, не меньше. Мастер и ученик",
          "Вы должны забыть то, что узнали",
          "Если вы не совершили ни единой ошибки, проигрываете вы. В другую игру вы должны играть",
          "Помните, что вы узнали. Сохранить вы это можете",
          "Готов ли ты? Что знаешь ты о готовности? Восемьсот лет я обучал джедаев. Советы давать я продолжу тем, кто обучается",
          "Вы думаете, что Йода прекращает преподавать только потому, что его ученик не хочет слышать? Учителем Йода является. Йода учит, как пьяницы пьют, как убийцы убивают",
          "Когда вы смотрите на Темную сторону, вы должны быть осторожны, потому что Темная сторона оглядывается в ответ",
          "Темная сторона омрачает все. Будущее в том, что невозможно увидеть будущее",
          "Страх — это путь к Темной стороне. Страх ведет к гневу. Гнев ведет к ненависти. Ненависть ведет к страданию",
          "Приучите себя отпускать все, что боитесь потерять",
          "Страх потери — это путь к Темной стороне",
          "Должен быть назван твой страх перед тем, как прогнать его",
          "Если вы закончите свое обучение сейчас, если вы выберете быстрый и легкий путь, как сделал Вейдер, вы станете агентом зла",
          "В конце концов, трусы — это те, кто следует Темной стороне"
        ]
      }
    },
    "hello": "Здравствуйте",
    "helpers": {
      "select": {
        "prompt": "Выберите: "
      },
      "submit": {
        "create": "Создать %{model}",
        "submit": "Сохранить %{model}",
        "update": "Сохранить %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "many",
          "other"
        ]
      },
      "transliterate": {}
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "руб."
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "миллиардов",
              "many": "миллиардов",
              "one": "миллиард",
              "other": "миллиардов"
            },
            "million": {
              "few": "миллионов",
              "many": "миллионов",
              "one": "миллион",
              "other": "миллионов"
            },
            "quadrillion": {
              "few": "квадриллионов",
              "many": "квадриллионов",
              "one": "квадриллион",
              "other": "квадриллионов"
            },
            "thousand": {
              "few": "тысяч",
              "many": "тысяч",
              "one": "тысяча",
              "other": "тысяч"
            },
            "trillion": {
              "few": "триллионов",
              "many": "триллионов",
              "one": "триллион",
              "other": "триллионов"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "байта",
              "many": "байт",
              "one": "байт",
              "other": "байта"
            },
            "eb": "ЭБ",
            "gb": "ГБ",
            "kb": "КБ",
            "mb": "МБ",
            "pb": "ПБ",
            "tb": "ТБ"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " и ",
        "two_words_connector": " и ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "утра",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "вечера"
    },
    "welcome": "Добро пожаловать"
  },
  "sc": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validatzione fallida: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Su registru non si podet iscantzellare ca esitint %{record} chi nde dipendent",
            "has_one": "Su registru non si podet iscantzellare ca esitit unu %{record} chi nde dipendet"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mèr",
        "giò",
        "che",
        "sàb"
      ],
      "abbr_month_names": [
        null,
        "ghe",
        "fre",
        "mar",
        "abr",
        "maj",
        "làm",
        "trì",
        "aus",
        "cab",
        "stG",
        "stA",
        "nad"
      ],
      "day_names": [
        "domìniga",
        "lunis",
        "martis",
        "mèrcuris",
        "giòbia",
        "chenàbura",
        "sàbadu"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "ghennàrgiu",
        "freàrgiu",
        "martzu",
        "abrile",
        "maju",
        "làmpadas",
        "trìulas",
        "austu",
        "cabudanni",
        "santugaine",
        "santandria",
        "nadale"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "pagu prus o mancu un'ora",
          "other": "pagu prus o mancu %{count} oras"
        },
        "about_x_months": {
          "one": "pagu prus o mancu unu mese",
          "other": "pagu prus o mancu %{count} meses"
        },
        "about_x_years": {
          "one": "pagu prus o mancu un'annu",
          "other": "pagu prus o mancu %{count} annos"
        },
        "almost_x_years": {
          "one": "belle un'annu",
          "other": "belle %{count} annos"
        },
        "half_a_minute": "mesu minutu",
        "less_than_x_minutes": {
          "one": "prus pagu de unu minutu",
          "other": "prus pagu de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "prus pagu de unu segundu",
          "other": "prus pagu de %{count} segundos"
        },
        "over_x_years": {
          "one": "prus de un'annu",
          "other": "prus de %{count} annos"
        },
        "x_days": {
          "one": "1 die",
          "other": "%{count} dies"
        },
        "x_minutes": {
          "one": "1 minutu",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "1 mese",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "1 segundu",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "1 annu",
          "other": "%{count} annos"
        }
      },
      "prompts": {
        "day": "Die",
        "hour": "Ora",
        "minute": "Minutu",
        "month": "Mese",
        "second": "Segundu",
        "year": "Annu"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "depet èssere atzetadu",
        "blank": "non podet èssere lassadu in biancu",
        "confirmation": "non currispondet cun %{attribute}",
        "empty": "non pòdet èsser bòidu",
        "equal_to": "depet èssere uguale a %{count}",
        "even": "depet èssere pari",
        "exclusion": "est riservadu",
        "greater_than": "depet èssere prus mannu de %{count}",
        "greater_than_or_equal_to": "depet èssere prus mannu o uguale a %{count}",
        "in": "depet istare intre %{count}",
        "inclusion": "no est inclùdidu in sa lista",
        "invalid": "no est vàlidu",
        "less_than": "depet èssere prus minore de %{count}",
        "less_than_or_equal_to": "depet èssere prus minore o uguale a %{count}",
        "model_invalid": "Validatzione fallida: %{errors}",
        "not_a_number": "no est unu nùmeru",
        "not_an_integer": "no est unu nùmeru intreu",
        "odd": "depet èssere dìspari",
        "other_than": "depet èssere unu nùmeru chi non siat %{count}",
        "present": "depet èssere lassadu in biancu",
        "required": "depet esìstere",
        "taken": "est giai presente",
        "too_long": {
          "one": "est tropu longu (su màssimu est de 1 caràtere)",
          "other": "est tropu longu (su màssimu est de %{count} caràteres)"
        },
        "too_short": {
          "one": "est tropu curtzu (su mìnimu est de 1 caràtere)",
          "other": "est tropu curtzu (su mìnimu est de %{count} caràteres)"
        },
        "wrong_length": {
          "one": "est de sa longària isballiada (depet tènnere 1 caràtere)",
          "other": "est de sa longària isballiada (depet tènnere %{count} caràteres)"
        }
      },
      "template": {
        "body": "Bi sunt istados problemas cun sos campos chi sighint:",
        "header": {
          "one": "Non potzo sarvare custu %{model}: 1 errore",
          "other": "Non potzo sarvare custu %{model}: %{count} errores."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Seletziona..."
      },
      "submit": {
        "create": "Crea %{model}",
        "submit": "Imbia %{model}",
        "update": "Atualiza %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "milliardu",
              "other": "milliardos"
            },
            "million": {
              "one": "millione",
              "other": "milliones"
            },
            "quadrillion": {
              "one": "cuadrillione",
              "other": "cuadrilliones"
            },
            "thousand": "mìgia",
            "trillion": "mìgia milliardos",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Byte"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " e ",
        "two_words_connector": " e ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d de %b de su %Y, %H:%M:%S %z",
        "long": "%d de %B de su %Y %H:%M",
        "short": "%d de %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "si": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "තහවුරු කිරීම යවනු ලැබුවේ",
          "confirmation_token": "තහවුරු ටෝකනය",
          "confirmed_at": "තහවුරු කලේ",
          "created_at": "නිර්මාණය කල අවස්තාව",
          "current_password": "වත්මන් මුරපදය",
          "current_sign_in_at": "වර්තමාන පිවිසුම",
          "current_sign_in_ip": "වර්තමාන පිවිසුම් IP ලිපිනය",
          "email": "විද්යුත් තැපෑල",
          "encrypted_password": "සංකේතාංකන මුරපදය",
          "failed_attempts": "අසාර්ථක ප්රයත්න",
          "last_sign_in_at": "අවසන් පිවිසුම",
          "last_sign_in_ip": "අවසන් පිවිසුම් IP ලිපිනය",
          "locked_at": "අගුළු දමා ඇත",
          "password": "මුරපදය",
          "password_confirmation": "මුරපදය තහවුරු කිරීම",
          "remember_created_at": "මතක තබා ගැනීම නිර්මාණය කල අවස්තාව",
          "remember_me": "මතක තබා ගන්න",
          "reset_password_sent_at": "මුරපදය යළි පිහිටුවන්න යවනු ලැබුවේ",
          "reset_password_token": "මුරපදය ටෝකනය නැවත සකසන්න",
          "sign_in_count": "ඇතුළුවූ වාර ගණන",
          "unconfirmed_email": "තහවුරු නොකළ විද්යුත් තැපෑල",
          "unlock_token": "ටෝකනය ඇවුරුම",
          "updated_at": "යාවත්කාලීන කලේ"
        }
      },
      "models": {
        "user": {
          "one": "පරිශීලක",
          "other": "පරිශීලක"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "ඔබගේ විද්යුත් තැපැල් ලිපිනය සාර්ථක ලෙස තහවුරු කර ඇත.",
        "new": {
          "resend_confirmation_instructions": "නැවත තහවුරු කිරීමේ උපදෙස් එවනු"
        },
        "send_instructions": "මිනිත්තු කිහිපයකින් ඔබගේ විද්යුත් තැපැල් ලිපිනය තහවුරු කරගන්නේ කෙසේද යන්න සඳහා උපදෙස් සහිතව විද්යුත් තැපෑලක් ඔබට ලැබෙනු ඇත.",
        "send_paranoid_instructions": "ඔබගේ ඊමේල් ලිපිනය අපේ දත්ත ගබඩාවේ පවතී නම්, විනාඩි කිහිපයක් ඇතුලත ඔබේ ඊමේල් ලිපිනයට තහවුරු වන්නේ කෙසේදැයි උපදෙස් සහිතව ඊ-තැපෑලක් ඔබට ලැබෙනු ඇත."
      },
      "failure": {
        "already_authenticated": "ඔබ දැනටමත් පුරනය වී ඇත.",
        "inactive": "ඔබගේ ගිණුම තවම සක්රිය කර නැත",
        "invalid": "අවලංගු %{authentication_keys} හෝ මුරපදයකි.",
        "last_attempt": "ඔබගේ ගිණුම අගුළු දැමීමට පෙර තවත් එක් උත්සාහයක් ඔබ සතුව ඇත.",
        "locked": "ඔබගේ ගිණුම අගුලු දමා ඇත.",
        "not_found_in_database": "අවලංගු %{authentication_keys} හෝ මුරපදයකි.",
        "timeout": "ඔබගේ සැසිය කල් ඉකුත් විය. දිගටම කරගෙන යාමට කරුණාකර පුරනය වන්න.",
        "unauthenticated": "දිගටම කරගෙන යෑමට පෙර ඔබ පුරනය වීමට හෝ ලියාපදිංචි විය යුතුය.",
        "unconfirmed": "දිගටම කරගෙන යාමට පෙර ඔබගේ ඊමේල් ලිපිනය තහවුරු කිරීමට සිදු වේ."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "මගේ ගිණුම ස්ථිර කරන්න",
          "greeting": "ආයුබෝවන් %{recipient}!",
          "instruction": "පහත දැක්වෙන සබැඳිය ඔස්සේ ඔබේ ගිණුමේ විද්යුත් තැපැල් ගිණුම තහවුරු කළ හැකිය:",
          "subject": "තහවුරු කිරීමේ උපදෙස්"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "ආයුබෝවන් %{recipient}!",
          "message": "ඔබගේ මුරපදය වෙනස් කර ඇති බව දැනුම් දෙන ලෙස අපි ඔබව අමතන්නෙමු.",
          "subject": "මුරපදය වෙනස් විය"
        },
        "reset_password_instructions": {
          "action": "මගේ මුරපදය වෙනස් කරන්න",
          "greeting": "ආයුබෝවන් %{recipient}!",
          "instruction": "ඔබගේ මුරපදය වෙනස් කිරීමට කිසියම් පුද්ගලයෙකුගේ සබැඳියක් ඉල්ලා සිටින අතර, ඔබට පහත සබැඳිය හරහා මෙය කළ හැකිය.",
          "instruction_2": "ඔබ මෙය ඉල්ලුවේ නැත්නම්, මෙම විද්යුත් තැපෑල නොසලකා හරින්න.",
          "instruction_3": "ඔබ ඉහත සබැඳිය වෙත පිවිස නව මුරයක් නිර්මාණය කරන තුරු ඔබගේ මුරපදය වෙනස් නොවනු ඇත.",
          "subject": "මුරපද යළි පිහුවීම සදහා උපදෙස් "
        },
        "unlock_instructions": {
          "action": "මගේ ගිණුම අගුලු අරින්න",
          "greeting": "ආයුබෝවන් %{recipient}!",
          "instruction": "ඔබගේ ගිණුම අගුළු හැරීම  සඳහා පහත සබැඳිය ක්ලික් කරන්න:",
          "message": "ඔබගේ ගිණුම අගුළුවැටී  ඇති අතර එය අසාර්ථක උත්සහයක් නිසාය.",
          "subject": "අගුළු හැරීමේ උපදෙස් "
        }
      },
      "omniauth_callbacks": {
        "failure": "ඔබට ඔබව සත්යාපනය කිරීමට නොහැකි විය %{kind} නිසා %{reason}.",
        "success": "ගිණුම සාර්ථක ලෙස සහතික කර ඇත %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "මගේ මුරපදය වෙනස් කරන්න",
          "change_your_password": "ඔබේ මුරපදය වෙනස් කරන්න",
          "confirm_new_password": "නව මුරපදය තහවුරු කරන්න",
          "new_password": "නව මුරපදය"
        },
        "new": {
          "forgot_your_password": "මුරපදය අමතක වුනාද?",
          "send_me_reset_password_instructions": "මුරපද උපදෙස් නැවත සැකසීමේ  උපදෙස් එවනු "
        },
        "no_token": "මුරපද යළි පිහිටුවීමේ ඊ-තැපෑලෙන් පැමිණීමෙන් තොරව මෙම පිටුවට පිවිසීමට ඔබට නොහැකි වේ. ඔබ මුරපද යළි පිහිටුවීමේ ඊ-තැපෑලෙන් පැමිණි විට, කරුණාකර ඔබ සම්පුර්ණ URL භාවිතා කළ බව සහතික කරගන්න.",
        "send_instructions": "විනාඩි කිහිපයකින් ඔබගේ රහස් පදය නැවත සකසන්නේ කෙසේද යන්න පිළිබඳ උපදෙස් සමඟ ඔබට ඊමේල් පණිවිඩයක් ලැබෙනු ඇත.",
        "send_paranoid_instructions": "ඔබගේ විද්යුත් තැපැල් ලිපිනය අපගේ දත්තගබඩාවේ පවතී නම්, විනාඩි කිහිපයක් තුළ ඔබේ විද්යුත් තැපැල් ලිපිනයට මුරපද ප්රතිසාධක සබඳතාවක් ලැබෙනු ඇත.",
        "updated": "ඔබගේ මුරපදය සාර්ථක ලෙස වෙනස් කර ඇත. ඔබ දැන් පුරනය වී ඇත.",
        "updated_not_active": "ඔබගේ මුරපදය සාර්ථක ලෙස වෙනස් කර ඇත."
      },
      "registrations": {
        "destroyed": "ඔබගේ ගිණුම සාර්ථකව අවලංගු කර ඇත. අපි ඉක්මනින් නැවත ඔබව දැකීමට බලාපොරොත්තු වෙනවා.",
        "edit": {
          "are_you_sure": "ඔබට විශ්වාසද?",
          "cancel_my_account": "මගේ ගිණුම අවලංගු කරන්න",
          "currently_waiting_confirmation_for_email": "දැනට ස්ථිර කිරීම සඳහා බලා සිටිනා: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "ඔබට එය වෙනස් කිරීමට අවශ්ය නැතිනම් හිස්ව තබන්න",
          "title": "සංස්කරණය කරන්න %{resource}",
          "unhappy": "කණගාටුයි?",
          "update": "යාවත්කාලීන කරන්න",
          "we_need_your_current_password_to_confirm_your_changes": "ඔබගේ වෙනස්කම් තහවුරු කිරීමට ඔබගේ වර්තමාන මුරපදය අවශ්ය වේ"
        },
        "new": {
          "sign_up": "ලියාපදිංචි වන්න"
        },
        "signed_up": "ආයුබෝවන්! ඔබ සාර්ථකව ලියාපදිංචි වී ඇත.",
        "signed_up_but_inactive": "ඔබ සාර්ථකව ලියාපදිංචි වී ඇත. කෙසේවෙතත්, ඔබගේ ගිණුම තවම ක්රියාත්මක වී නොමැති බැවින් අපට ඔබට පුරනය වීමට නොහැකි විය.",
        "signed_up_but_locked": "ඔබ සාර්ථකව ලියාපදිංචි වී ඇත. කෙසේ වෙතත්, ඔබගේ ගිණුම අගුලු දමා ඇති බැවින් පුරණය වීමට නොහැකිය.",
        "signed_up_but_unconfirmed": "තහවුරු කිරීමේ සබැඳියක් සහිත පණිවිඩයක් ඔබගේ ඊමේල් ලිපිනය වෙත යවා ඇත. කරුණාකර ඔබගේ ගිණුම ක්රියාත්මක කිරීම සඳහා සබැඳිය අනුගමනය කරන්න.",
        "update_needs_confirmation": "ඔබගේ ගිණුම සාර්ථකව යාවත්කාලීන කර ඇත, නමුත් අප ඔබගේ නව ඊ-තැපැල් ලිපිනය සත්යාපනය කළ යුතුය. කරුණාකර ඔබගේ ඊමේල් ලිපිනය පරීක්ෂා කර තහවුරු කිරීමේ සබැඳිය අනුගමනය කරන්න.",
        "updated": "ඔබගේ ගිණුම සාර්ථකව යාවත්කාලීන කර ඇත.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "සාර්ථකව ගිණුමෙන් පිටවෙන ලදී.",
        "new": {
          "sign_in": "ගිණුමට ඇතුළුවන්න"
        },
        "signed_in": "සාර්ථකව ගිණුමට පිවිසුණි.",
        "signed_out": "සාර්ථකව ගිණුමෙන් පිටවෙන ලදී."
      },
      "shared": {
        "links": {
          "back": "ආපසු",
          "didn_t_receive_confirmation_instructions": "තහවුරු කිරීම් උපදෙස් ලැබුණේ නැද්ද?",
          "didn_t_receive_unlock_instructions": "අගුළුහැරීමේ උපදෙස් ලැබුණේ නැද්ද? ",
          "forgot_your_password": "මුරපදය අමතක වුනාද?",
          "sign_in": "ගිණුමට ඇතුළුවන්න",
          "sign_in_with_provider": "ඇතුළුවන්න සමගින්  %{provider}",
          "sign_up": "ලියාපදිංචි වන්න"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "ඇගුළු හැරීමේ උපදෙස් නැවත එවන්න "
        },
        "send_instructions": "උපදෙස් සමඟ ඔබට ඔබගේ ගිණුම අරින්නේ කෙසේද යන්න සඳහා  විනාඩි කිහිපයක් තුළ  ඊ-තැපෑලක් ලැබෙනු ඇත.",
        "send_paranoid_instructions": "ඔබගේ ගිණුම පවතින්නේ නම්, විනාඩි කීපයක් තුල එය අගුළ හැරීමට කිරීම සඳහා උපදෙස් සමඟ ඔබට ඊමේල් එකක් ලැබෙනු ඇත.",
        "unlocked": "ඔබගේ ගිණුම සාර්ථකව අගුළු ඇර ඇත. කරුණාකර ඉදිරියට කරගෙන යාමට පුරනය වන්න."
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "දැනටමත් තහවුරු කර ඇත, කරුණාකර පුරනය වන්න උත්සාහ කරන්න",
        "confirmation_period_expired": "%{period} තුල තහවුරු කළ යුතුයි, කරුණාකර නව එකක් ඉල්ලා සිටින්න",
        "expired": "කල් ඉකුත් වී ඇත, කරුණාකර නව එකක් ඉල්ලන්න",
        "not_found": "සොයා ගත නොහැක",
        "not_locked": "අගුළු වැටි නැත ",
        "not_saved": {
          "one": "1 දෝෂයක් නිසා මෙම %{resource} සුරැකීමට නොහැක",
          "other": "%{count} දෝෂ නිසා මෙම %{resource} සුරැකීමට නොහැක"
        }
      }
    }
  },
  "sk": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Potvrdenie poslané",
          "confirmation_token": "Potvrdzovací kľúč",
          "confirmed_at": "Potvrdené",
          "created_at": "Vytvorené",
          "current_password": "Súčasné heslo",
          "current_sign_in_at": "Súčasné prihlásenie",
          "current_sign_in_ip": "IP adresa súčasného prihlásenia",
          "email": "Email",
          "encrypted_password": "Zašifrované heslo",
          "failed_attempts": "Zlé pokusy",
          "last_sign_in_at": "Posledné prihlásenie",
          "last_sign_in_ip": "IP adresa posledného prihlásenia",
          "locked_at": "Zamknuté",
          "password": "Heslo",
          "password_confirmation": "Potvrdenie hesla",
          "remember_created_at": "Pamätanie vytvorené",
          "remember_me": "Zapamätať si ma",
          "reset_password_sent_at": "Reset hesla poslaný",
          "reset_password_token": "Kľúč resetu hesla",
          "sign_in_count": "Počet prihlásení",
          "unconfirmed_email": "Nepotvrdený email",
          "unlock_token": "Odomykací kľúč",
          "updated_at": "Aktualizované"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validácia neúspešná: %{errors}"
        }
      },
      "models": {
        "user": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Ne",
        "Po",
        "Ut",
        "St",
        "Št",
        "Pi",
        "So"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Máj",
        "Jún",
        "Júl",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Nedeľa",
        "Pondelok",
        "Utorok",
        "Streda",
        "Štvrtok",
        "Piatok",
        "Sobota"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d. %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Január",
        "Február",
        "Marec",
        "Apríl",
        "Máj",
        "Jún",
        "Júl",
        "August",
        "September",
        "Október",
        "November",
        "December"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "asi %{count} hodinami",
          "one": "asi hodinou",
          "other": "asi %{count} hodinami"
        },
        "about_x_months": {
          "few": "asi %{count} mesiacmi",
          "one": "asi mesiacom",
          "other": "asi %{count} mesiacmi"
        },
        "about_x_years": {
          "few": "asi %{count} rokmi",
          "one": "asi rokom",
          "other": "asi %{count} rokmi"
        },
        "almost_x_years": {
          "few": "takmer %{count} rokmi",
          "one": "takmer rokom",
          "other": "takmer %{count} rokmi"
        },
        "half_a_minute": "pol minútou",
        "less_than_x_minutes": {
          "few": "necelými %{count} minútami",
          "one": "necelou minútou",
          "other": "necelými %{count} minútami"
        },
        "less_than_x_seconds": {
          "few": "necelými %{count} sekundami",
          "one": "necelou sekundou",
          "other": "necelými %{count} sekundami"
        },
        "over_x_years": {
          "few": "viac ako %{count} rokmi",
          "one": "viac ako rokom",
          "other": "viac ako %{count} rokmi"
        },
        "x_days": {
          "few": "%{count} dňami",
          "one": "dňom",
          "other": "%{count} dňami"
        },
        "x_minutes": {
          "few": "%{count} minútami",
          "one": "minútou",
          "other": "%{count} minútami"
        },
        "x_months": {
          "few": "%{count} mesiacmi",
          "one": "mesiacom",
          "other": "%{count} mesiacmi"
        },
        "x_seconds": {
          "few": "%{count} sekundami",
          "one": "sekundou",
          "other": "%{count} sekundami"
        }
      },
      "prompts": {
        "day": "Deň",
        "hour": "Hodina",
        "minute": "Minúta",
        "month": "Mesiac",
        "second": "Sekunda",
        "year": "Rok"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Váš účet bol úspešne overený. Teraz ste prihlásený.",
        "new": {
          "resend_confirmation_instructions": "Preposlať potvrdzovacie inštrukcie"
        },
        "send_instructions": "O niekoľko minút dostanete email s inštrukciami ako potvrdiť váš účet.",
        "send_paranoid_instructions": "Ak sa váš email nachádza v našej databáze, o niekoľko minút dostanete email s inštrukciami ako potvrdiť váš účet."
      },
      "failure": {
        "already_authenticated": "Už ste prihlásený.",
        "inactive": "Váš účet ešte nebol aktivovaný.",
        "invalid": "Nesprávny %{authentication_keys} alebo heslo.",
        "last_attempt": "Máte ešte posledný pokus pred tým, než sa vám zamkne konto.",
        "locked": "Váš účet je zamknutý.",
        "not_found_in_database": "Nesprávny %{authentication_keys} alebo heslo.",
        "timeout": "Vaša session vypršala. Na pokračovanie sa prosím znovu prihláste.",
        "unauthenticated": "Pred pokračovaním sa musíte zaregistrovať alebo prihlásiť.",
        "unconfirmed": "Pred pokračovaním musíte potvrdiť svoj účet."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potvrdiť môj účet",
          "greeting": "Vitaj %{recipient}!",
          "instruction": "Môžete potvrdiť emailovú adresu vášho účtu pomocou odkazu nižšie:",
          "subject": "Potvrdzovacie inštrukcie"
        },
        "email_changed": {
          "greeting": "Ahoj %{recipient}!",
          "message": "Kontaktujeme Vás aby sme Vám oznámili, že Váš e-mail bol zmenený na %{email}.",
          "message_unconfirmed": null,
          "subject": "Email bol zmenený"
        },
        "password_change": {
          "greeting": "Ahoj %{recipient}!",
          "message": "Upozorňujeme vás, že vaše heslo bolo zmenené.",
          "subject": "Heslo zmenené"
        },
        "reset_password_instructions": {
          "action": "Zmeniť moje heslo",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Niekto požiadal o zmenu vášho hesla a môžete to spraviť pomocou odkazu nižšie.",
          "instruction_2": "Ak ste o toto nepožiadali, prosím ignorujte tento email.",
          "instruction_3": "Vaše heslo sa nezmení, pokým nenavštívite odkaz vyššie a nezadáte nové.",
          "subject": "Inštrukcie na obnovu hesla"
        },
        "unlock_instructions": {
          "action": "Odomknúť môj účet",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Pre odomknutie vášho účtu kliknite na odkaz nižšie:",
          "message": "Vaše konto bolo zamknuté kvôli nadmernému počtu neúspešných prihlásení.",
          "subject": "Inštrukcie na odomknutie účtu"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nebolo možné vás autentifikovať z %{kind} z dôvodu \"%{reason}\".",
        "success": "Úspešne autentifikovaný z účtu %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Zmeniť moje heslo",
          "change_your_password": "Zmeniť vaše heslo",
          "confirm_new_password": "Potvrdiť nové heslo",
          "new_password": "Nové heslo"
        },
        "new": {
          "forgot_your_password": "Zabudli ste heslo?",
          "send_me_reset_password_instructions": "Pošlite mi inštrukcie na obnovu hesla"
        },
        "no_token": "Túto stránku nemôžete navštíviť pokiaľ neprichádzate z emailu s inštrukciami na obnovu hesla. Ak z neho prichádzate, prosím uistite sa, že ste použili z odkazu celú adresu (URL).",
        "send_instructions": "O niekoľko minút dostanete email s inštrukciami ako nastaviť nové heslo.",
        "send_paranoid_instructions": "Ak sa váš email nachádza v našej databáze, o niekoľko minút dostanete na svoju emailovú adresu odkaz na obnovu hesla.",
        "updated": "Vaše heslo bolo úspešne zmenené. Teraz ste prihlásený.",
        "updated_not_active": "Vaše heslo bolo úspešne zmenené."
      },
      "registrations": {
        "destroyed": "Dovidenia! Váš účet bol úspešne zrušený. Dúfame, že sa čoskoro opäť uvidíme.",
        "edit": {
          "are_you_sure": "Ste si istý?",
          "cancel_my_account": "Zrušiť môj účet",
          "currently_waiting_confirmation_for_email": "Momentálne sa čaká na potvrdenie pre: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "nechajte prázdne ak to nechcete zmeniť",
          "title": "Upraviť %{resource}",
          "unhappy": "Nešťastný",
          "update": "Aktualizovať",
          "we_need_your_current_password_to_confirm_your_changes": "na potvrdenie vašich zmien potrebujeme vaše súčasné heslo"
        },
        "new": {
          "sign_up": "Zaregistrovať sa"
        },
        "signed_up": "Vitajte! Registrácia bola úspešná.",
        "signed_up_but_inactive": "Registrácia bola úspešná. Nemohli sme vás ale prihlásiť, lebo váš účet ešte nebol aktivovaný.",
        "signed_up_but_locked": "Registrácia bola úspešná. Nemohli sme vás ale prihlásiť, lebo váš účet je uzamknutý.",
        "signed_up_but_unconfirmed": "Správa s potvrdzovacím odkazom bola odoslaná na vašu emailovú adresu. Aby ste aktivovali váš účet, prosím otvorte odkaz..",
        "update_needs_confirmation": "Váš účet bol úspešne aktualizovaný ale potrebujeme overiť vašu novú emailovú adresu. Prosím skontrolujte si email a kliknite na potvrdzovací odkaz, aby ste potvrdili novú emailovú adresu.",
        "updated": "Úspešne ste aktualizovali váš účet.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Úspešne odhlásený.",
        "new": {
          "sign_in": "Prihlásiť sa"
        },
        "signed_in": "Úspešne prihlásený.",
        "signed_out": "Úspešne odhlásený."
      },
      "shared": {
        "links": {
          "back": "Späť",
          "didn_t_receive_confirmation_instructions": "Nedostali ste potvrdzovacie inštrukcie?",
          "didn_t_receive_unlock_instructions": "Nedostali ste inštrukcie na odomknutie účtu?",
          "forgot_your_password": "Zabudli ste heslo?",
          "sign_in": "Prihlásiť sa",
          "sign_in_with_provider": "Prihlásiť sa cez %{provider}",
          "sign_up": "Zaregistrovať sa"
        },
        "minimum_password_length": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Poslať znovu inštrukcie na odomknutie účtu"
        },
        "send_instructions": "O niekoľko minút dostanete email s inštrukciami ako odomknúť váš účet.",
        "send_paranoid_instructions": "Ak váš účet existuje, o niekoľko minút dostanete email s inštrukciami ako ho odomknúť.",
        "unlocked": "Váš účet bol úspešne odomknutý. Prosím prihláste sa, aby ste mohli pokračovať."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "musí byť potvrdené",
        "already_confirmed": "bol už potvrdený, skúste sa prihlásiť",
        "blank": "je povinná položka",
        "confirmation": "nebolo potvrdené",
        "confirmation_period_expired": "je potrebné overiť do %{period}, prosím vyžiadajte si nové overenie",
        "empty": "nesmie byť prázdny/e",
        "equal_to": "sa musí rovnať %{count}",
        "even": "musí byť párne číslo",
        "exclusion": "je vyhradené pre iný účel",
        "expired": "vypršal, prosím vyžiadajte si nový",
        "greater_than": "musí byť väčšie ako %{count}",
        "greater_than_or_equal_to": "musí byť väčšie alebo rovné %{count}",
        "inclusion": "nie je v zozname povolených hodnôt",
        "invalid": "nie je platná hodnota",
        "less_than": "musí byť menšie ako %{count}",
        "less_than_or_equal_to": "musí byť menšie alebo rovné %{count}",
        "not_a_number": "nie je číslo",
        "not_an_integer": "musí byť celé číslo",
        "not_found": "nenájdený",
        "not_locked": "nebol zamknutý",
        "not_saved": {
          "few": null,
          "many": null,
          "one": null,
          "other": null
        },
        "odd": "musí byť nepárne číslo",
        "required": "musí existovať",
        "taken": "ste už použili",
        "too_long": "je príliš dlhá/ý (max. %{count} znakov)",
        "too_short": "je príliš krátky/a (min. %{count} znakov)",
        "wrong_length": "nemá správnu dĺžku (očakáva sa %{count} znakov)"
      },
      "template": {
        "body": "Nasledujúce polia obsahujú chybne vyplnené údaje:",
        "header": {
          "few": "Pri ukladaní objektu %{model} došlo k %{count} chybám a nebolo ho možné uložiť",
          "one": "Pri ukladaní objektu %{model} došlo k chybám a nebolo ho možné uložiť",
          "other": "Pri ukladaní objektu %{model} došlo k %{count} chybám a nebolo ho možné uložiť"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#",
          "##",
          "###"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Bánovce nad Bebravou",
          "Banská Bystrica",
          "Banská Štiavnica",
          "Bardejov",
          "Bratislava I",
          "Bratislava II",
          "Bratislava III",
          "Bratislava IV",
          "Bratislava V",
          "Brezno",
          "Bytča",
          "Čadca",
          "Detva",
          "Dolný Kubín",
          "Dunajská Streda",
          "Galanta",
          "Gelnica",
          "Hlohovec",
          "Humenné",
          "Ilava",
          "Kežmarok",
          "Komárno",
          "Košice I",
          "Košice II",
          "Košice III",
          "Košice IV",
          "Košice-okolie",
          "Krupina",
          "Kysucké Nové Mesto",
          "Levice",
          "Levoča",
          "Liptovský Mikuláš",
          "Lučenec",
          "Malacky",
          "Martin",
          "Medzilaborce",
          "Michalovce",
          "Myjava",
          "Námestovo",
          "Nitra",
          "Nové Mesto n.Váhom",
          "Nové Zámky",
          "Partizánske",
          "Pezinok",
          "Piešťany",
          "Poltár",
          "Poprad",
          "Považská Bystrica",
          "Prešov",
          "Prievidza",
          "Púchov",
          "Revúca",
          "Rimavská Sobota",
          "Rožňava",
          "Ružomberok",
          "Sabinov",
          "Šaľa",
          "Senec",
          "Senica",
          "Skalica",
          "Snina",
          "Sobrance",
          "Spišská Nová Ves",
          "Stará Ľubovňa",
          "Stropkov",
          "Svidník",
          "Topoľčany",
          "Trebišov",
          "Trenčín",
          "Trnava",
          "Turčianske Teplice",
          "Tvrdošín",
          "Veľký Krtíš",
          "Vranov nad Topľou",
          "Žarnovica",
          "Žiar nad Hronom",
          "Žilina",
          "Zlaté Moravce",
          "Zvolen"
        ],
        "city_prefix": [
          "North",
          "East",
          "West",
          "South",
          "New",
          "Lake",
          "Port"
        ],
        "city_suffix": [
          "town",
          "ton",
          "land",
          "ville",
          "berg",
          "burgh",
          "borough",
          "bury",
          "view",
          "port",
          "mouth",
          "stad",
          "furt",
          "chester",
          "mouth",
          "fort",
          "haven",
          "side",
          "shire"
        ],
        "country": [
          "Afganistan",
          "Afgánsky islamský štát",
          "Albánsko",
          "Albánska republika",
          "Alžírsko",
          "Alžírska demokratická ľudová republika",
          "Andorra",
          "Andorrské kniežatsvo",
          "Angola",
          "Angolská republika",
          "Antigua a Barbuda",
          "Antigua a Barbuda",
          "Argentína",
          "Argentínska republika",
          "Arménsko",
          "Arménska republika",
          "Austrália",
          "Austrálsky zväz",
          "Azerbajdžan",
          "Azerbajdžanská republika",
          "Bahamy",
          "Bahamské spoločenstvo",
          "Bahrajn",
          "Bahrajnské kráľovstvo",
          "Bangladéš",
          "Bangladéšska ľudová republika",
          "Barbados",
          "Barbados",
          "Belgicko",
          "Belgické kráľovstvo",
          "Belize",
          "Belize",
          "Benin",
          "Beninská republika",
          "Bhután",
          "Bhutánske kráľovstvo",
          "Bielorusko",
          "Bieloruská republika",
          "Bolívia",
          "Bolívijská republika",
          "Bosna a Hercegovina",
          "Republika Bosny a Hercegoviny",
          "Botswana",
          "Botswanská republika",
          "Brazília",
          "Brazílska federatívna republika",
          "Brunej",
          "Brunejský sultanát",
          "Bulharsko",
          "Bulharská republika",
          "Burkina Faso",
          "Burkina Faso",
          "Burundi",
          "Burundská republika",
          "Cyprus",
          "Cyperská republika",
          "Čad",
          "Republika Čad",
          "Česko",
          "Česká republika",
          "Čína",
          "Čínska ľudová republika",
          "Dánsko",
          "Dánsko kráľovstvo",
          "Dominika",
          "Spoločenstvo Dominika",
          "Dominikánska republika",
          "Dominikánska republika",
          "Džibutsko",
          "Džibutská republika",
          "Egypt",
          "Egyptská arabská republika",
          "Ekvádor",
          "Ekvádorská republika",
          "Eritrea",
          "Eritrejský štát",
          "Estónsko",
          "Estónska republika",
          "Etiópia",
          "Etiópska federatívna demokratická republika",
          "Fidži",
          "Republika ostrovy Fidži",
          "Filipíny",
          "Filipínska republika",
          "Fínsko",
          "Fínska republika",
          "Francúzsko",
          "Francúzska republika",
          "Gabon",
          "Gabonská republika",
          "Gambia",
          "Gambijská republika",
          "Ghana",
          "Ghanská republika",
          "Grécko",
          "Helénska republika",
          "Grenada",
          "Grenada",
          "Gruzínsko",
          "Gruzínsko",
          "Guatemala",
          "Guatemalská republika",
          "Guinea",
          "Guinejská republika",
          "Guinea-Bissau",
          "Republika Guinea-Bissau",
          "Guayana",
          "Guayanská republika",
          "Haiti",
          "Republika Haiti",
          "Holandsko",
          "Holandské kráľovstvo",
          "Honduras",
          "Honduraská republika",
          "Chile",
          "Čílska republika",
          "Chorvátsko",
          "Chorvátska republika",
          "India",
          "Indická republika",
          "Indonézia",
          "Indonézska republika",
          "Irak",
          "Iracká republika",
          "Irán",
          "Iránska islamská republika",
          "Island",
          "Islandská republika",
          "Izrael",
          "Štát Izrael",
          "Írsko",
          "Írska republika",
          "Jamajka",
          "Jamajka",
          "Japonsko",
          "Japonsko",
          "Jemen",
          "Jemenská republika",
          "Jordánsko",
          "Jordánske hášimovské kráľovstvo",
          "Južná Afrika",
          "Juhoafrická republika",
          "Kambodža",
          "Kambodžské kráľovstvo",
          "Kamerun",
          "Kamerunská republika",
          "Kanada",
          "Kanada",
          "Kapverdy",
          "Kapverdská republika",
          "Katar",
          "Štát Katar",
          "Kazachstan",
          "Kazašská republika",
          "Keňa",
          "Kenská republika",
          "Kirgizsko",
          "Kirgizská republika",
          "Kiribati",
          "Kiribatská republika",
          "Kolumbia",
          "Kolumbijská republika",
          "Komory",
          "Komorská únia",
          "Kongo",
          "Konžská demokratická republika",
          "Kongo (\"Brazzaville\")",
          "Konžská republika",
          "Kórea (\"Južná\")",
          "Kórejská republika",
          "Kórea (\"Severná\")",
          "Kórejská ľudovodemokratická republika",
          "Kostarika",
          "Kostarická republika",
          "Kuba",
          "Kubánska republika",
          "Kuvajt",
          "Kuvajtský štát",
          "Laos",
          "Laoská ľudovodemokratická republika",
          "Lesotho",
          "Lesothské kráľovstvo",
          "Libanon",
          "Libanonská republika",
          "Libéria",
          "Libérijská republika",
          "Líbya",
          "Líbyjská arabská ľudová socialistická džamáhírija",
          "Lichtenštajnsko",
          "Lichtenštajnské kniežatstvo",
          "Litva",
          "Litovská republika",
          "Lotyšsko",
          "Lotyšská republika",
          "Luxembursko",
          "Luxemburské veľkovojvodstvo",
          "Macedónsko",
          "Macedónska republika",
          "Madagaskar",
          "Madagaskarská republika",
          "Maďarsko",
          "Maďarská republika",
          "Malajzia",
          "Malajzia",
          "Malawi",
          "Malawijská republika",
          "Maldivy",
          "Maldivská republika",
          "Mali",
          "Malijská republika",
          "Malta",
          "Malta",
          "Maroko",
          "Marocké kráľovstvo",
          "Marshallove ostrovy",
          "Republika Marshallových ostrovy",
          "Mauritánia",
          "Mauritánska islamská republika",
          "Maurícius",
          "Maurícijská republika",
          "Mexiko",
          "Spojené štáty mexické",
          "Mikronézia",
          "Mikronézske federatívne štáty",
          "Mjanmarsko",
          "Mjanmarský zväz",
          "Moldavsko",
          "Moldavská republika",
          "Monako",
          "Monacké kniežatstvo",
          "Mongolsko",
          "Mongolsko",
          "Mozambik",
          "Mozambická republika",
          "Namíbia",
          "Namíbijská republika",
          "Nauru",
          "Naurská republika",
          "Nemecko",
          "Nemecká spolková republika",
          "Nepál",
          "Nepálske kráľovstvo",
          "Niger",
          "Nigerská republika",
          "Nigéria",
          "Nigérijská federatívna republika",
          "Nikaragua",
          "Nikaragujská republika",
          "Nový Zéland",
          "Nový Zéland",
          "Nórsko",
          "Nórske kráľovstvo",
          "Omán",
          "Ománsky sultanát",
          "Pakistan",
          "Pakistanská islamská republika",
          "Palau",
          "Palauská republika",
          "Panama",
          "Panamská republika",
          "Papua-Nová Guinea",
          "Nezávislý štát Papua-Nová Guinea",
          "Paraguaj",
          "Paraguajská republika",
          "Peru",
          "Peruánska republika",
          "Pobrežie Slonoviny",
          "Republika Pobrežie Slonoviny",
          "Poľsko",
          "Poľská republika",
          "Portugalsko",
          "Portugalská republika",
          "Rakúsko",
          "Rakúska republika",
          "Rovníková Guinea",
          "Republika Rovníková Guinea",
          "Rumunsko",
          "Rumunsko",
          "Rusko",
          "Ruská federácia",
          "Rwanda",
          "Rwandská republika",
          "Salvádor",
          "Salvádorská republika",
          "Samoa",
          "Nezávislý štát Samoa",
          "San Maríno",
          "Sanmarínska republika",
          "Saudská Arábia",
          "Kráľovstvo Saudskej Arábie",
          "Senegal",
          "Senegalská republika",
          "Seychely",
          "Seychelská republika",
          "Sierra Leone",
          "Republika Sierra Leone",
          "Singapur",
          "Singapurska republika",
          "Slovensko",
          "Slovenská republika",
          "Slovinsko",
          "Slovinská republika",
          "Somálsko",
          "Somálska demokratická republika",
          "Spojené arabské emiráty",
          "Spojené arabské emiráty",
          "Spojené štáty americké",
          "Spojené štáty americké",
          "Srbsko a Čierna Hora",
          "Srbsko a Čierna Hora",
          "Srí Lanka",
          "Demokratická socialistická republika Srí Lanka",
          "Stredoafrická republika",
          "Stredoafrická republika",
          "Sudán",
          "Sudánska republika",
          "Surinam",
          "Surinamská republika",
          "Svazijsko",
          "Svazijské kráľovstvo",
          "Svätá Lucia",
          "Svätá Lucia",
          "Svätý Krištof a Nevis",
          "Federácia Svätý Krištof a Nevis",
          "Sv. Tomáš a Princov Ostrov",
          "Demokratická republika Svätý Tomáš a Princov Ostrov",
          "Sv. Vincent a Grenadíny",
          "Svätý Vincent a Grenadíny",
          "Sýria",
          "Sýrska arabská republika",
          "Šalamúnove ostrovy",
          "Šalamúnove ostrovy",
          "Španielsko",
          "Španielske kráľovstvo",
          "Švajčiarsko",
          "Švajčiarska konfederácia",
          "Švédsko",
          "Švédske kráľovstvo",
          "Tadžikistan",
          "Tadžická republika",
          "Taliansko",
          "Talianska republika",
          "Tanzánia",
          "Tanzánijská zjednotená republika",
          "Thajsko",
          "Thajské kráľovstvo",
          "Togo",
          "Tožská republika",
          "Tonga",
          "Tonžské kráľovstvo",
          "Trinidad a Tobago",
          "Republika Trinidad a Tobago",
          "Tunisko",
          "Tuniská republika",
          "Turecko",
          "Turecká republika",
          "Turkménsko",
          "Turkménsko",
          "Tuvalu",
          "Tuvalu",
          "Uganda",
          "Ugandská republika",
          "Ukrajina",
          "Uruguaj",
          "Uruguajská východná republika",
          "Uzbekistan",
          "Vanuatu",
          "Vanuatská republika",
          "Vatikán",
          "Svätá Stolica",
          "Veľká Británia",
          "Spojené kráľovstvo Veľkej Británie a Severného Írska",
          "Venezuela",
          "Venezuelská bolívarovská republika",
          "Vietnam",
          "Vietnamská socialistická republika",
          "Východný Timor",
          "Demokratická republika Východný Timor",
          "Zambia",
          "Zambijská republika",
          "Zimbabwe",
          "Zimbabwianska republika"
        ],
        "default_country": [
          "Slovensko"
        ],
        "default_country_code": [
          "SK"
        ],
        "postcode": [
          "#####",
          "### ##",
          "## ###"
        ],
        "secondary_address": [
          "Apt. ###",
          "Suite ###"
        ],
        "state": [
          "Bratislavský",
          "Trnavský",
          "Trenčiansky",
          "Nitriansky",
          "Žilinský",
          "Banskobystrický",
          "Prešovský",
          "Košický"
        ],
        "state_abbr": [
          "BA",
          "TT",
          "TN",
          "NR",
          "ZA",
          "BB",
          "PO",
          "KI"
        ],
        "street": [
          "Adámiho",
          "Ahoj",
          "Albína Brunovského",
          "Albrechtova",
          "Alejová",
          "Alešova",
          "Alibernetová",
          "Alžbetínska",
          "Alžbety Gwerkovej",
          "Ambroseho",
          "Ambrušova",
          "Americká",
          "Americké námestie",
          "Americké námestie",
          "Andreja Mráza",
          "Andreja Plávku",
          "Andrusovova",
          "Anenská",
          "Anenská",
          "Antolská",
          "Astronomická",
          "Astrová",
          "Azalková",
          "Azovská",
          "Babuškova",
          "Bachova",
          "Bajkalská",
          "Bajkalská",
          "Bajkalská",
          "Bajkalská",
          "Bajkalská",
          "Bajkalská",
          "Bajzova",
          "Bancíkovej",
          "Banícka",
          "Baníkova",
          "Banskobystrická",
          "Banšelova",
          "Bardejovská",
          "Bartókova",
          "Bartoňova",
          "Bartoškova",
          "Baštová",
          "Bazová",
          "Bažantia",
          "Beblavého",
          "Beckovská",
          "Bedľová",
          "Belániková",
          "Belehradská",
          "Belinského",
          "Belopotockého",
          "Beňadická",
          "Bencúrova",
          "Benediktiho",
          "Beniakova",
          "Bernolákova",
          "Beskydská",
          "Betliarska",
          "Bezručova",
          "Biela",
          "Bielkova",
          "Björnsonova",
          "Blagoevova",
          "Blatnická",
          "Blumentálska",
          "Blyskáčová",
          "Bočná",
          "Bohrova",
          "Bohúňova",
          "Bojnická",
          "Borodáčova",
          "Borská",
          "Bosákova",
          "Botanická",
          "Bottova",
          "Boženy Němcovej",
          "Bôrik",
          "Bradáčova",
          "Bradlianska",
          "Brančská",
          "Bratská",
          "Brestová",
          "Brezovská",
          "Briežky",
          "Brnianska",
          "Brodná",
          "Brodská",
          "Broskyňová",
          "Břeclavská",
          "Budatínska",
          "Budatínska",
          "Budatínska",
          "Búdkova  cesta",
          "Budovateľská",
          "Budyšínska",
          "Budyšínska",
          "Buková",
          "Bukureštská",
          "Bulharská",
          "Bulíkova",
          "Bystrého",
          "Bzovícka",
          "Cablkova",
          "Cesta na Červený most",
          "Cesta na Červený most",
          "Cesta na Senec",
          "Cikkerova",
          "Cintorínska",
          "Cintulova",
          "Cukrová",
          "Cyrilova",
          "Čajakova",
          "Čajkovského",
          "Čaklovská",
          "Čalovská",
          "Čapajevova",
          "Čapkova",
          "Čárskeho",
          "Čavojského",
          "Čečinová",
          "Čelakovského",
          "Čerešňová",
          "Černyševského",
          "Červeňova",
          "Česká",
          "Československých par",
          "Čipkárska",
          "Čmelíkova",
          "Čmeľovec",
          "Čulenova",
          "Daliborovo námestie",
          "Dankovského",
          "Dargovská",
          "Ďatelinová",
          "Daxnerovo námestie",
          "Devínska cesta",
          "Dlhé diely I.",
          "Dlhé diely II.",
          "Dlhé diely III.",
          "Dobrovičova",
          "Dobrovičova",
          "Dobrovského",
          "Dobšinského",
          "Dohnalova",
          "Dohnányho",
          "Doležalova",
          "Dolná",
          "Dolnozemská cesta",
          "Domkárska",
          "Domové role",
          "Donnerova",
          "Donovalova",
          "Dostojevského rad",
          "Dr. Vladimíra Clemen",
          "Drevená",
          "Drieňová",
          "Drieňová",
          "Drieňová",
          "Drotárska cesta",
          "Drotárska cesta",
          "Drotárska cesta",
          "Družicová",
          "Družstevná",
          "Dubnická",
          "Dubová",
          "Dúbravská cesta",
          "Dudova",
          "Dulovo námestie",
          "Dulovo námestie",
          "Dunajská",
          "Dvořákovo nábrežie",
          "Edisonova",
          "Einsteinova",
          "Elektrárenská",
          "Exnárova",
          "F. Kostku",
          "Fadruszova",
          "Fajnorovo nábrežie",
          "Fándlyho",
          "Farebná",
          "Farská",
          "Farského",
          "Fazuľová",
          "Fedinova",
          "Ferienčíkova",
          "Fialkové údolie",
          "Fibichova",
          "Filiálne nádražie",
          "Flöglova",
          "Floriánske námestie",
          "Fraňa Kráľa",
          "Francisciho",
          "Francúzskych partizá",
          "Františkánska",
          "Františkánske námest",
          "Furdekova",
          "Furdekova",
          "Gabčíkova",
          "Gagarinova",
          "Gagarinova",
          "Gagarinova",
          "Gajova",
          "Galaktická",
          "Galandova",
          "Gallova",
          "Galvaniho",
          "Gašparíkova",
          "Gaštanová",
          "Gavlovičova",
          "Gemerská",
          "Gercenova",
          "Gessayova",
          "Gettingová",
          "Godrova",
          "Gogoľova",
          "Goláňova",
          "Gondova",
          "Goralská",
          "Gorazdova",
          "Gorkého",
          "Gregorovej",
          "Grösslingova",
          "Gruzínska",
          "Gunduličova",
          "Gusevova",
          "Haanova",
          "Haburská",
          "Halašova",
          "Hálkova",
          "Hálova",
          "Hamuliakova",
          "Hanácka",
          "Handlovská",
          "Hany Meličkovej",
          "Harmanecká",
          "Hasičská",
          "Hattalova",
          "Havlíčkova",
          "Havrania",
          "Haydnova",
          "Herlianska",
          "Herlianska",
          "Heydukova",
          "Hlaváčikova",
          "Hlavatého",
          "Hlavné námestie",
          "Hlboká cesta",
          "Hlboká cesta",
          "Hlivová",
          "Hlučínska",
          "Hodálova",
          "Hodžovo námestie",
          "Holekova",
          "Holíčska",
          "Hollého",
          "Holubyho",
          "Hontianska",
          "Horárska",
          "Horné Židiny",
          "Horská",
          "Horská",
          "Hrad",
          "Hradné údolie",
          "Hrachová",
          "Hraničná",
          "Hrebendova",
          "Hríbová",
          "Hriňovská",
          "Hrobákova",
          "Hrobárska",
          "Hroboňova",
          "Hudecova",
          "Humenské námestie",
          "Hummelova",
          "Hurbanovo námestie",
          "Hurbanovo námestie",
          "Hviezdoslavovo námes",
          "Hýrošova",
          "Chalupkova",
          "Chemická",
          "Chlumeckého",
          "Chorvátska",
          "Chorvátska",
          "Iľjušinova",
          "Ilkovičova",
          "Inovecká",
          "Inovecká",
          "Iskerníková",
          "Ivana Horvátha",
          "Ivánska cesta",
          "J.C.Hronského",
          "Jabloňová",
          "Jadrová",
          "Jakabova",
          "Jakubovo námestie",
          "Jamnického",
          "Jána Stanislava",
          "Janáčkova",
          "Jančova",
          "Janíkove role",
          "Jankolova",
          "Jánošíkova",
          "Jánoškova",
          "Janotova",
          "Jánska",
          "Jantárová cesta",
          "Jarabinková",
          "Jarná",
          "Jaroslavova",
          "Jarošova",
          "Jaseňová",
          "Jasná",
          "Jasovská",
          "Jastrabia",
          "Jašíkova",
          "Javorinská",
          "Javorová",
          "Jazdecká",
          "Jedlíkova",
          "Jégého",
          "Jelačičova",
          "Jelenia",
          "Jesenná",
          "Jesenského",
          "Jiráskova",
          "Jiskrova",
          "Jozefská",
          "Junácka",
          "Jungmannova",
          "Jurigovo námestie",
          "Jurovského",
          "Jurská",
          "Justičná",
          "K lomu",
          "K Železnej studienke",
          "Kalinčiakova",
          "Kamenárska",
          "Kamenné námestie",
          "Kapicova",
          "Kapitulská",
          "Kapitulský dvor",
          "Kapucínska",
          "Kapušianska",
          "Karadžičova",
          "Karadžičova",
          "Karadžičova",
          "Karadžičova",
          "Karloveská",
          "Karloveské rameno",
          "Karpatská",
          "Kašmírska",
          "Kaštielska",
          "Kaukazská",
          "Kempelenova",
          "Kežmarské námestie",
          "Kladnianska",
          "Klariská",
          "Kláštorská",
          "Klatovská",
          "Klatovská",
          "Klemensova",
          "Klincová",
          "Klobučnícka",
          "Klokočova",
          "Kľukatá",
          "Kmeťovo námestie",
          "Koceľova",
          "Kočánkova",
          "Kohútova",
          "Kolárska",
          "Kolískova",
          "Kollárovo námestie",
          "Kollárovo námestie",
          "Kolmá",
          "Komárňanská",
          "Komárnická",
          "Komárnická",
          "Komenského námestie",
          "Kominárska",
          "Komonicová",
          "Konopná",
          "Konvalinková",
          "Konventná",
          "Kopanice",
          "Kopčianska",
          "Koperníkova",
          "Korabinského",
          "Koreničova",
          "Kostlivého",
          "Kostolná",
          "Košická",
          "Košická",
          "Košická",
          "Kováčska",
          "Kovorobotnícka",
          "Kozia",
          "Koziarka",
          "Kozmonautická",
          "Krajná",
          "Krakovská",
          "Kráľovské údolie",
          "Krasinského",
          "Kraskova",
          "Krásna",
          "Krásnohorská",
          "Krasovského",
          "Krátka",
          "Krčméryho",
          "Kremnická",
          "Kresánkova",
          "Krivá",
          "Križkova",
          "Krížna",
          "Krížna",
          "Krížna",
          "Krížna",
          "Krmanova",
          "Krompašská",
          "Krupinská",
          "Krupkova",
          "Kubániho",
          "Kubínska",
          "Kuklovská",
          "Kukučínova",
          "Kukuričná",
          "Kulíškova",
          "Kultúrna",
          "Kupeckého",
          "Kúpeľná",
          "Kutlíkova",
          "Kutuzovova",
          "Kuzmányho",
          "Kvačalova",
          "Kvetná",
          "Kýčerského",
          "Kyjevská",
          "Kysucká",
          "Laborecká",
          "Lackova",
          "Ladislava Sáru",
          "Ľadová",
          "Lachova",
          "Ľaliová",
          "Lamačská cesta",
          "Lamačská cesta",
          "Lamanského",
          "Landererova",
          "Langsfeldova",
          "Ľanová",
          "Laskomerského",
          "Laučekova",
          "Laurinská",
          "Lazaretská",
          "Lazaretská",
          "Legerského",
          "Legionárska",
          "Legionárska",
          "Lehockého",
          "Lehockého",
          "Lenardova",
          "Lermontovova",
          "Lesná",
          "Leškova",
          "Letecká",
          "Letisko M.R.Štefánik",
          "Letná",
          "Levárska",
          "Levická",
          "Levočská",
          "Lidická",
          "Lietavská",
          "Lichardova",
          "Lipová",
          "Lipovinová",
          "Liptovská",
          "Listová",
          "Líščie nivy",
          "Líščie údolie",
          "Litovská",
          "Lodná",
          "Lombardiniho",
          "Lomonosovova",
          "Lopenícka",
          "Lovinského",
          "Ľubietovská",
          "Ľubinská",
          "Ľubľanská",
          "Ľubochnianska",
          "Ľubovnianska",
          "Lúčna",
          "Ľudové námestie",
          "Ľudovíta Fullu",
          "Luhačovická",
          "Lužická",
          "Lužná",
          "Lýcejná",
          "Lykovcová",
          "M. Hella",
          "Magnetová",
          "Macharova",
          "Majakovského",
          "Majerníkova",
          "Májkova",
          "Májová",
          "Makovického",
          "Malá",
          "Malé pálenisko",
          "Malinová",
          "Malý Draždiak",
          "Malý trh",
          "Mamateyova",
          "Mamateyova",
          "Mánesovo námestie",
          "Mariánska",
          "Marie Curie-Sklodows",
          "Márie Medveďovej",
          "Markova",
          "Marótyho",
          "Martákovej",
          "Martinčekova",
          "Martinčekova",
          "Martinengova",
          "Martinská",
          "Mateja Bela",
          "Matejkova",
          "Matičná",
          "Matúšova",
          "Medená",
          "Medzierka",
          "Medzilaborecká",
          "Merlotová",
          "Mesačná",
          "Mestská",
          "Meteorová",
          "Metodova",
          "Mickiewiczova",
          "Mierová",
          "Michalská",
          "Mikovíniho",
          "Mikulášska",
          "Miletičova",
          "Miletičova",
          "Mišíkova",
          "Mišíkova",
          "Mišíkova",
          "Mliekárenská",
          "Mlynarovičova",
          "Mlynská dolina",
          "Mlynská dolina",
          "Mlynská dolina",
          "Mlynské luhy",
          "Mlynské nivy",
          "Mlynské nivy",
          "Mlynské nivy",
          "Mlynské nivy",
          "Mlynské nivy",
          "Mlyny",
          "Modranská",
          "Mojmírova",
          "Mokráň záhon",
          "Mokrohájska cesta",
          "Moldavská",
          "Molecova",
          "Moravská",
          "Moskovská",
          "Most SNP",
          "Mostová",
          "Mošovského",
          "Motýlia",
          "Moyzesova",
          "Mozartova",
          "Mraziarenská",
          "Mudroňova",
          "Mudroňova",
          "Mudroňova",
          "Muchovo námestie",
          "Murgašova",
          "Muškátová",
          "Muštová",
          "Múzejná",
          "Myjavská",
          "Mýtna",
          "Mýtna",
          "Na Baránku",
          "Na Brezinách",
          "Na Hrebienku",
          "Na Kalvárii",
          "Na Kampárke",
          "Na kopci",
          "Na križovatkách",
          "Na lánoch",
          "Na paši",
          "Na piesku",
          "Na Riviére",
          "Na Sitine",
          "Na Slavíne",
          "Na stráni",
          "Na Štyridsiatku",
          "Na úvrati",
          "Na vŕšku",
          "Na výslní",
          "Nábělkova",
          "Nábrežie arm. gen. L",
          "Nábrežná",
          "Nad Dunajom",
          "Nad lomom",
          "Nad lúčkami",
          "Nad lúčkami",
          "Nad ostrovom",
          "Nad Sihoťou",
          "Námestie 1. mája",
          "Námestie Alexandra D",
          "Námestie Biely kríž",
          "Námestie Hraničiarov",
          "Námestie Jána Pavla",
          "Námestie Ľudovíta Št",
          "Námestie Martina Ben",
          "Nám. M.R.Štefánika",
          "Námestie slobody",
          "Námestie slobody",
          "Námestie SNP",
          "Námestie SNP",
          "Námestie sv. Františ",
          "Narcisová",
          "Nedbalova",
          "Nekrasovova",
          "Neronetová",
          "Nerudova",
          "Nevädzová",
          "Nezábudková",
          "Niťová",
          "Nitrianska",
          "Nížinná",
          "Nobelova",
          "Nobelovo námestie",
          "Nová",
          "Nová Rožňavská",
          "Novackého",
          "Nové pálenisko",
          "Nové záhrady I",
          "Nové záhrady II",
          "Nové záhrady III",
          "Nové záhrady IV",
          "Nové záhrady V",
          "Nové záhrady VI",
          "Nové záhrady VII",
          "Novinárska",
          "Novobanská",
          "Novohradská",
          "Novosvetská",
          "Novosvetská",
          "Novosvetská",
          "Obežná",
          "Obchodná",
          "Očovská",
          "Odbojárov",
          "Odborárska",
          "Odborárske námestie",
          "Odborárske námestie",
          "Ohnicová",
          "Okánikova",
          "Okružná",
          "Olbrachtova",
          "Olejkárska",
          "Ondavská",
          "Ondrejovova",
          "Oravská",
          "Orechová cesta",
          "Orechový rad",
          "Oriešková",
          "Ormisova",
          "Osadná",
          "Ostravská",
          "Ostredková",
          "Osuského",
          "Osvetová",
          "Otonelská",
          "Ovručská",
          "Ovsištské námestie",
          "Pajštúnska",
          "Palackého",
          "Palárikova",
          "Palárikova",
          "Pálavská",
          "Palisády",
          "Palisády",
          "Palisády",
          "Palkovičova",
          "Panenská",
          "Pankúchova",
          "Panónska cesta",
          "Panská",
          "Papánkovo námestie",
          "Papraďová",
          "Páričkova",
          "Parková",
          "Partizánska",
          "Pasienky",
          "Paulínyho",
          "Pavlovičova",
          "Pavlovova",
          "Pavlovská",
          "Pažického",
          "Pažítková",
          "Pečnianska",
          "Pernecká",
          "Pestovateľská",
          "Peterská",
          "Petzvalova",
          "Pezinská",
          "Piesočná",
          "Piešťanská",
          "Pifflova",
          "Pilárikova",
          "Pionierska",
          "Pivoňková",
          "Planckova",
          "Planét",
          "Plátenícka",
          "Pluhová",
          "Plynárenská",
          "Plzenská",
          "Pobrežná",
          "Pod Bôrikom",
          "Pod Kalváriou",
          "Pod lesom",
          "Pod Rovnicami",
          "Pod vinicami",
          "Podhorského",
          "Podjavorinskej",
          "Podlučinského",
          "Podniková",
          "Podtatranského",
          "Pohronská",
          "Polárna",
          "Poloreckého",
          "Poľná",
          "Poľská",
          "Poludníková",
          "Porubského",
          "Poštová",
          "Považská",
          "Povraznícka",
          "Povraznícka",
          "Pražská",
          "Predstaničné námesti",
          "Prepoštská",
          "Prešernova",
          "Prešovská",
          "Prešovská",
          "Prešovská",
          "Pri Bielom kríži",
          "Pri dvore",
          "Pri Dynamitke",
          "Pri Habánskom mlyne",
          "Pri hradnej studni",
          "Pri seči",
          "Pri Starej Prachárni",
          "Pri Starom háji",
          "Pri Starom Mýte",
          "Pri strelnici",
          "Pri Suchom mlyne",
          "Pri zvonici",
          "Pribinova",
          "Pribinova",
          "Pribinova",
          "Pribišova",
          "Pribylinská",
          "Priečna",
          "Priekopy",
          "Priemyselná",
          "Priemyselná",
          "Prievozská",
          "Prievozská",
          "Prievozská",
          "Príkopova",
          "Primaciálne námestie",
          "Prístav",
          "Prístavná",
          "Prokofievova",
          "Prokopa Veľkého",
          "Prokopova",
          "Prúdová",
          "Prvosienková",
          "Púpavová",
          "Pustá",
          "Puškinova",
          "Račianska",
          "Račianska",
          "Račianske mýto",
          "Radarová",
          "Rádiová",
          "Radlinského",
          "Radničná",
          "Radničné námestie",
          "Radvanská",
          "Rajská",
          "Raketová",
          "Rákosová",
          "Rastislavova",
          "Rázusovo nábrežie",
          "Repná",
          "Rešetkova",
          "Revolučná",
          "Révová",
          "Revúcka",
          "Rezedová",
          "Riazanská",
          "Riazanská",
          "Ribayová",
          "Riečna",
          "Rigeleho",
          "Rízlingová",
          "Riznerova",
          "Robotnícka",
          "Romanova",
          "Röntgenova",
          "Rosná",
          "Rovná",
          "Rovniankova",
          "Rovníková",
          "Rozmarínová",
          "Rožňavská",
          "Rožňavská",
          "Rožňavská",
          "Rubinsteinova",
          "Rudnayovo námestie",
          "Rumančeková",
          "Rusovská cesta",
          "Ružičková",
          "Ružinovská",
          "Ružinovská",
          "Ružinovská",
          "Ružomberská",
          "Ružová dolina",
          "Ružová dolina",
          "Rybárska brána",
          "Rybné námestie",
          "Rýdziková",
          "Sabinovská",
          "Sabinovská",
          "Sad Janka Kráľa",
          "Sadová",
          "Sartorisova",
          "Sasinkova",
          "Seberíniho",
          "Sečovská",
          "Sedlárska",
          "Sedmokrásková",
          "Segnerova",
          "Sekulská",
          "Semianova",
          "Senická",
          "Senná",
          "Schillerova",
          "Schody pri starej vo",
          "Sibírska",
          "Sienkiewiczova",
          "Silvánska",
          "Sinokvetná",
          "Skalická cesta",
          "Skalná",
          "Sklenárova",
          "Sklenárska",
          "Sládkovičova",
          "Sladová",
          "Slávičie údolie",
          "Slavín",
          "Slepá",
          "Sliačska",
          "Sliezska",
          "Slivková",
          "Slnečná",
          "Slovanská",
          "Slovinská",
          "Slovnaftská",
          "Slowackého",
          "Smetanova",
          "Smikova",
          "Smolenická",
          "Smolnícka",
          "Smrečianska",
          "Soferove schody",
          "Socháňova",
          "Sokolská",
          "Solivarská",
          "Sološnická",
          "Somolického",
          "Somolického",
          "Sosnová",
          "Spišská",
          "Spojná",
          "Spoločenská",
          "Sputniková",
          "Sreznevského",
          "Srnčia",
          "Stachanovská",
          "Stálicová",
          "Staničná",
          "Stará Černicová",
          "Stará Ivánska cesta",
          "Stará Prievozská",
          "Stará Vajnorská",
          "Stará vinárska",
          "Staré Grunty",
          "Staré ihrisko",
          "Staré záhrady",
          "Starhradská",
          "Starohájska",
          "Staromestská",
          "Staroturský chodník",
          "Staviteľská",
          "Stodolova",
          "Stoklasová",
          "Strakova",
          "Strážnická",
          "Strážny dom",
          "Strečnianska",
          "Stredná",
          "Strelecká",
          "Strmá cesta",
          "Strojnícka",
          "Stropkovská",
          "Struková",
          "Studená",
          "Stuhová",
          "Súbežná",
          "Súhvezdná",
          "Suché mýto",
          "Suchohradská",
          "Súkennícka",
          "Súľovská",
          "Sumbalova",
          "Súmračná",
          "Súťažná",
          "Svätého Vincenta",
          "Svätoplukova",
          "Svätoplukova",
          "Svätovojtešská",
          "Svetlá",
          "Svíbová",
          "Svidnícka",
          "Svoradova",
          "Svrčia",
          "Syslia",
          "Šafárikovo námestie",
          "Šafárikovo námestie",
          "Šafránová",
          "Šagátova",
          "Šalviová",
          "Šancová",
          "Šancová",
          "Šancová",
          "Šancová",
          "Šándorova",
          "Šarišská",
          "Šášovská",
          "Šaštínska",
          "Ševčenkova",
          "Šintavská",
          "Šípková",
          "Škarniclova",
          "Školská",
          "Škovránčia",
          "Škultétyho",
          "Šoltésovej",
          "Špieszova",
          "Špitálska",
          "Športová",
          "Šrobárovo námestie",
          "Šťastná",
          "Štedrá",
          "Štefánikova",
          "Štefánikova",
          "Štefánikova",
          "Štefanovičova",
          "Štefunkova",
          "Štetinova",
          "Štiavnická",
          "Štúrova",
          "Štyndlova",
          "Šulekova",
          "Šulekova",
          "Šulekova",
          "Šumavská",
          "Šuňavcova",
          "Šustekova",
          "Švabinského",
          "Tabaková",
          "Tablicova",
          "Táborská",
          "Tajovského",
          "Tallerova",
          "Tehelná",
          "Technická",
          "Tekovská",
          "Telocvičná",
          "Tematínska",
          "Teplická",
          "Terchovská",
          "Teslova",
          "Tetmayerova",
          "Thurzova",
          "Tichá",
          "Tilgnerova",
          "Timravina",
          "Tobrucká",
          "Tokajícka",
          "Tolstého",
          "Tománkova",
          "Tomášikova",
          "Tomášikova",
          "Tomášikova",
          "Tomášikova",
          "Tomášikova",
          "Topoľčianska",
          "Topoľová",
          "Továrenská",
          "Trebišovská",
          "Trebišovská",
          "Trebišovská",
          "Trenčianska",
          "Treskoňova",
          "Trnavská cesta",
          "Trnavská cesta",
          "Trnavská cesta",
          "Trnavská cesta",
          "Trnavská cesta",
          "Trnavské mýto",
          "Tŕňová",
          "Trojdomy",
          "Tučkova",
          "Tupolevova",
          "Turbínova",
          "Turčianska",
          "Turnianska",
          "Tvarožkova",
          "Tylova",
          "Tyršovo nábrežie",
          "Údernícka",
          "Údolná",
          "Uhorková",
          "Ukrajinská",
          "Ulica 29. augusta",
          "Ulica 29. augusta",
          "Ulica 29. augusta",
          "Ulica 29. augusta",
          "Ulica Imricha Karvaš",
          "Ulica Jozefa Krónera",
          "Ulica Viktora Tegelh",
          "Úprkova",
          "Úradnícka",
          "Uránová",
          "Urbánkova",
          "Ursínyho",
          "Uršulínska",
          "Úzka",
          "V záhradách",
          "Vajanského nábrežie",
          "Vajnorská",
          "Vajnorská",
          "Vajnorská",
          "Vajnorská",
          "Vajnorská",
          "Vajnorská",
          "Vajnorská",
          "Vajnorská",
          "Vajnorská",
          "Valašská",
          "Valchárska",
          "Vansovej",
          "Vápenná",
          "Varínska",
          "Varšavská",
          "Varšavská",
          "Vavilovova",
          "Vavrínova",
          "Vazovova",
          "Včelárska",
          "Velehradská",
          "Veltlínska",
          "Ventúrska",
          "Veterná",
          "Veternicová",
          "Vetvová",
          "Viedenská cesta",
          "Viedenská cesta",
          "Vietnamská",
          "Vígľašská",
          "Vihorlatská",
          "Viktorínova",
          "Vilová",
          "Vincenta Hložníka",
          "Vínna",
          "Vlastenecké námestie",
          "Vlčkova",
          "Vlčkova",
          "Vlčkova",
          "Vodný vrch",
          "Votrubova",
          "Vrábeľská",
          "Vrakunská cesta",
          "Vranovská",
          "Vretenová",
          "Vrchná",
          "Vrútocká",
          "Vyhliadka",
          "Vyhnianska cesta",
          "Vysoká",
          "Vyšehradská",
          "Vyšná",
          "Wattova",
          "Wilsonova",
          "Wolkrova",
          "Za Kasárňou",
          "Za sokolovňou",
          "Za Stanicou",
          "Za tehelňou",
          "Záborského",
          "Zadunajská cesta",
          "Záhorácka",
          "Záhradnícka",
          "Záhradnícka",
          "Záhradnícka",
          "Záhradnícka",
          "Záhrebská",
          "Záhrebská",
          "Zálužická",
          "Zámocká",
          "Zámocké schody",
          "Zámočnícka",
          "Západná",
          "Západný rad",
          "Záporožská",
          "Zátišie",
          "Závodníkova",
          "Zelená",
          "Zelinárska",
          "Zimná",
          "Zlaté piesky",
          "Zlaté schody",
          "Znievska",
          "Zohorská",
          "Zochova",
          "Zrinského",
          "Zvolenská",
          "Žabí majer",
          "Žabotova",
          "Žehrianska",
          "Železná",
          "Železničiarska",
          "Žellova",
          "Žiarska",
          "Židovská",
          "Žilinská",
          "Žilinská",
          "Živnostenská",
          "Žižkova",
          "Župné námestie"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street}"
        ],
        "time_zone": [
          "Pacific/Midway",
          "Pacific/Pago_Pago",
          "Pacific/Honolulu",
          "America/Juneau",
          "America/Los_Angeles",
          "America/Tijuana",
          "America/Denver",
          "America/Phoenix",
          "America/Chihuahua",
          "America/Mazatlan",
          "America/Chicago",
          "America/Regina",
          "America/Mexico_City",
          "America/Mexico_City",
          "America/Monterrey",
          "America/Guatemala",
          "America/New_York",
          "America/Indiana/Indianapolis",
          "America/Bogota",
          "America/Lima",
          "America/Lima",
          "America/Halifax",
          "America/Caracas",
          "America/La_Paz",
          "America/Santiago",
          "America/St_Johns",
          "America/Sao_Paulo",
          "America/Argentina/Buenos_Aires",
          "America/Guyana",
          "America/Godthab",
          "Atlantic/South_Georgia",
          "Atlantic/Azores",
          "Atlantic/Cape_Verde",
          "Europe/Dublin",
          "Europe/London",
          "Europe/Lisbon",
          "Europe/London",
          "Africa/Casablanca",
          "Africa/Monrovia",
          "Etc/UTC",
          "Europe/Belgrade",
          "Europe/Bratislava",
          "Europe/Budapest",
          "Europe/Ljubljana",
          "Europe/Prague",
          "Europe/Sarajevo",
          "Europe/Skopje",
          "Europe/Warsaw",
          "Europe/Zagreb",
          "Europe/Brussels",
          "Europe/Copenhagen",
          "Europe/Madrid",
          "Europe/Paris",
          "Europe/Amsterdam",
          "Europe/Berlin",
          "Europe/Berlin",
          "Europe/Rome",
          "Europe/Stockholm",
          "Europe/Vienna",
          "Africa/Algiers",
          "Europe/Bucharest",
          "Africa/Cairo",
          "Europe/Helsinki",
          "Europe/Kiev",
          "Europe/Riga",
          "Europe/Sofia",
          "Europe/Tallinn",
          "Europe/Vilnius",
          "Europe/Athens",
          "Europe/Istanbul",
          "Europe/Minsk",
          "Asia/Jerusalem",
          "Africa/Harare",
          "Africa/Johannesburg",
          "Europe/Moscow",
          "Europe/Moscow",
          "Europe/Moscow",
          "Asia/Kuwait",
          "Asia/Riyadh",
          "Africa/Nairobi",
          "Asia/Baghdad",
          "Asia/Tehran",
          "Asia/Muscat",
          "Asia/Muscat",
          "Asia/Baku",
          "Asia/Tbilisi",
          "Asia/Yerevan",
          "Asia/Kabul",
          "Asia/Yekaterinburg",
          "Asia/Karachi",
          "Asia/Karachi",
          "Asia/Tashkent",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kolkata",
          "Asia/Kathmandu",
          "Asia/Dhaka",
          "Asia/Dhaka",
          "Asia/Colombo",
          "Asia/Almaty",
          "Asia/Novosibirsk",
          "Asia/Rangoon",
          "Asia/Bangkok",
          "Asia/Bangkok",
          "Asia/Jakarta",
          "Asia/Krasnoyarsk",
          "Asia/Shanghai",
          "Asia/Chongqing",
          "Asia/Hong_Kong",
          "Asia/Urumqi",
          "Asia/Kuala_Lumpur",
          "Asia/Singapore",
          "Asia/Taipei",
          "Australia/Perth",
          "Asia/Irkutsk",
          "Asia/Ulaanbaatar",
          "Asia/Seoul",
          "Asia/Tokyo",
          "Asia/Tokyo",
          "Asia/Tokyo",
          "Asia/Yakutsk",
          "Australia/Darwin",
          "Australia/Adelaide",
          "Australia/Melbourne",
          "Australia/Melbourne",
          "Australia/Sydney",
          "Australia/Brisbane",
          "Australia/Hobart",
          "Asia/Vladivostok",
          "Pacific/Guam",
          "Pacific/Port_Moresby",
          "Asia/Magadan",
          "Asia/Magadan",
          "Pacific/Noumea",
          "Pacific/Fiji",
          "Asia/Kamchatka",
          "Pacific/Majuro",
          "Pacific/Auckland",
          "Pacific/Auckland",
          "Pacific/Tongatapu",
          "Pacific/Fakaofo",
          "Pacific/Apia"
        ]
      },
      "company": {
        "bs": [
          [
            "implement",
            "utilize",
            "integrate",
            "streamline",
            "optimize",
            "evolve",
            "transform",
            "embrace",
            "enable",
            "orchestrate",
            "leverage",
            "reinvent",
            "aggregate",
            "architect",
            "enhance",
            "incentivize",
            "morph",
            "empower",
            "envisioneer",
            "monetize",
            "harness",
            "facilitate",
            "seize",
            "disintermediate",
            "synergize",
            "strategize",
            "deploy",
            "brand",
            "grow",
            "target",
            "syndicate",
            "synthesize",
            "deliver",
            "mesh",
            "incubate",
            "engage",
            "maximize",
            "benchmark",
            "expedite",
            "reintermediate",
            "whiteboard",
            "visualize",
            "repurpose",
            "innovate",
            "scale",
            "unleash",
            "drive",
            "extend",
            "engineer",
            "revolutionize",
            "generate",
            "exploit",
            "transition",
            "e-enable",
            "iterate",
            "cultivate",
            "matrix",
            "productize",
            "redefine",
            "recontextualize"
          ],
          [
            "clicks-and-mortar",
            "value-added",
            "vertical",
            "proactive",
            "robust",
            "revolutionary",
            "scalable",
            "leading-edge",
            "innovative",
            "intuitive",
            "strategic",
            "e-business",
            "mission-critical",
            "sticky",
            "one-to-one",
            "24/7",
            "end-to-end",
            "global",
            "B2B",
            "B2C",
            "granular",
            "frictionless",
            "virtual",
            "viral",
            "dynamic",
            "24/365",
            "best-of-breed",
            "killer",
            "magnetic",
            "bleeding-edge",
            "web-enabled",
            "interactive",
            "dot-com",
            "sexy",
            "back-end",
            "real-time",
            "efficient",
            "front-end",
            "distributed",
            "seamless",
            "extensible",
            "turn-key",
            "world-class",
            "open-source",
            "cross-platform",
            "cross-media",
            "synergistic",
            "bricks-and-clicks",
            "out-of-the-box",
            "enterprise",
            "integrated",
            "impactful",
            "wireless",
            "transparent",
            "next-generation",
            "cutting-edge",
            "user-centric",
            "visionary",
            "customized",
            "ubiquitous",
            "plug-and-play",
            "collaborative",
            "compelling",
            "holistic",
            "rich"
          ],
          [
            "synergies",
            "web-readiness",
            "paradigms",
            "markets",
            "partnerships",
            "infrastructures",
            "platforms",
            "initiatives",
            "channels",
            "eyeballs",
            "communities",
            "ROI",
            "solutions",
            "e-tailers",
            "e-services",
            "action-items",
            "portals",
            "niches",
            "technologies",
            "content",
            "vortals",
            "supply-chains",
            "convergence",
            "relationships",
            "architectures",
            "interfaces",
            "e-markets",
            "e-commerce",
            "systems",
            "bandwidth",
            "infomediaries",
            "models",
            "mindshare",
            "deliverables",
            "users",
            "schemas",
            "networks",
            "applications",
            "metrics",
            "e-business",
            "functionalities",
            "experiences",
            "web services",
            "methodologies"
          ]
        ],
        "buzzwords": [
          [
            "Adaptive",
            "Advanced",
            "Ameliorated",
            "Assimilated",
            "Automated",
            "Balanced",
            "Business-focused",
            "Centralized",
            "Cloned",
            "Compatible",
            "Configurable",
            "Cross-group",
            "Cross-platform",
            "Customer-focused",
            "Customizable",
            "Decentralized",
            "De-engineered",
            "Devolved",
            "Digitized",
            "Distributed",
            "Diverse",
            "Down-sized",
            "Enhanced",
            "Enterprise-wide",
            "Ergonomic",
            "Exclusive",
            "Expanded",
            "Extended",
            "Face to face",
            "Focused",
            "Front-line",
            "Fully-configurable",
            "Function-based",
            "Fundamental",
            "Future-proofed",
            "Grass-roots",
            "Horizontal",
            "Implemented",
            "Innovative",
            "Integrated",
            "Intuitive",
            "Inverse",
            "Managed",
            "Mandatory",
            "Monitored",
            "Multi-channelled",
            "Multi-lateral",
            "Multi-layered",
            "Multi-tiered",
            "Networked",
            "Object-based",
            "Open-architected",
            "Open-source",
            "Operative",
            "Optimized",
            "Optional",
            "Organic",
            "Organized",
            "Persevering",
            "Persistent",
            "Phased",
            "Polarised",
            "Pre-emptive",
            "Proactive",
            "Profit-focused",
            "Profound",
            "Programmable",
            "Progressive",
            "Public-key",
            "Quality-focused",
            "Reactive",
            "Realigned",
            "Re-contextualized",
            "Re-engineered",
            "Reduced",
            "Reverse-engineered",
            "Right-sized",
            "Robust",
            "Seamless",
            "Secured",
            "Self-enabling",
            "Sharable",
            "Stand-alone",
            "Streamlined",
            "Switchable",
            "Synchronised",
            "Synergistic",
            "Synergized",
            "Team-oriented",
            "Total",
            "Triple-buffered",
            "Universal",
            "Up-sized",
            "Upgradable",
            "User-centric",
            "User-friendly",
            "Versatile",
            "Virtual",
            "Visionary",
            "Vision-oriented"
          ],
          [
            "24 hour",
            "24/7",
            "3rd generation",
            "4th generation",
            "5th generation",
            "6th generation",
            "actuating",
            "analyzing",
            "asymmetric",
            "asynchronous",
            "attitude-oriented",
            "background",
            "bandwidth-monitored",
            "bi-directional",
            "bifurcated",
            "bottom-line",
            "clear-thinking",
            "client-driven",
            "client-server",
            "coherent",
            "cohesive",
            "composite",
            "context-sensitive",
            "contextually-based",
            "content-based",
            "dedicated",
            "demand-driven",
            "didactic",
            "directional",
            "discrete",
            "disintermediate",
            "dynamic",
            "eco-centric",
            "empowering",
            "encompassing",
            "even-keeled",
            "executive",
            "explicit",
            "exuding",
            "fault-tolerant",
            "foreground",
            "fresh-thinking",
            "full-range",
            "global",
            "grid-enabled",
            "heuristic",
            "high-level",
            "holistic",
            "homogeneous",
            "human-resource",
            "hybrid",
            "impactful",
            "incremental",
            "intangible",
            "interactive",
            "intermediate",
            "leading edge",
            "local",
            "logistical",
            "maximized",
            "methodical",
            "mission-critical",
            "mobile",
            "modular",
            "motivating",
            "multimedia",
            "multi-state",
            "multi-tasking",
            "national",
            "needs-based",
            "neutral",
            "next generation",
            "non-volatile",
            "object-oriented",
            "optimal",
            "optimizing",
            "radical",
            "real-time",
            "reciprocal",
            "regional",
            "responsive",
            "scalable",
            "secondary",
            "solution-oriented",
            "stable",
            "static",
            "systematic",
            "systemic",
            "system-worthy",
            "tangible",
            "tertiary",
            "transitional",
            "uniform",
            "upward-trending",
            "user-facing",
            "value-added",
            "web-enabled",
            "well-modulated",
            "zero administration",
            "zero defect",
            "zero tolerance"
          ],
          [
            "ability",
            "access",
            "adapter",
            "algorithm",
            "alliance",
            "analyzer",
            "application",
            "approach",
            "architecture",
            "archive",
            "artificial intelligence",
            "array",
            "attitude",
            "benchmark",
            "budgetary management",
            "capability",
            "capacity",
            "challenge",
            "circuit",
            "collaboration",
            "complexity",
            "concept",
            "conglomeration",
            "contingency",
            "core",
            "customer loyalty",
            "database",
            "data-warehouse",
            "definition",
            "emulation",
            "encoding",
            "encryption",
            "extranet",
            "firmware",
            "flexibility",
            "focus group",
            "forecast",
            "frame",
            "framework",
            "function",
            "functionalities",
            "Graphic Interface",
            "groupware",
            "Graphical User Interface",
            "hardware",
            "help-desk",
            "hierarchy",
            "hub",
            "implementation",
            "info-mediaries",
            "infrastructure",
            "initiative",
            "installation",
            "instruction set",
            "interface",
            "internet solution",
            "intranet",
            "knowledge user",
            "knowledge base",
            "local area network",
            "leverage",
            "matrices",
            "matrix",
            "methodology",
            "middleware",
            "migration",
            "model",
            "moderator",
            "monitoring",
            "moratorium",
            "neural-net",
            "open architecture",
            "open system",
            "orchestration",
            "paradigm",
            "parallelism",
            "policy",
            "portal",
            "pricing structure",
            "process improvement",
            "product",
            "productivity",
            "project",
            "projection",
            "protocol",
            "secured line",
            "service-desk",
            "software",
            "solution",
            "standardization",
            "strategy",
            "structure",
            "success",
            "superstructure",
            "support",
            "synergy",
            "system engine",
            "task-force",
            "throughput",
            "time-frame",
            "toolset",
            "utilisation",
            "website",
            "workforce"
          ]
        ],
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name} #{suffix}",
          "#{Name.man_last_name} a #{Name.man_last_name} #{suffix}"
        ],
        "suffix": [
          "s.r.o.",
          "a.s.",
          "v.o.s."
        ]
      },
      "internet": {
        "domain_suffix": [
          "sk",
          "com",
          "net",
          "eu",
          "org"
        ]
      },
      "lorem": {
        "supplemental": [
          "abbas",
          "abduco",
          "abeo",
          "abscido",
          "absconditus",
          "absens",
          "absorbeo",
          "absque",
          "abstergo",
          "absum",
          "abundans",
          "abutor",
          "accedo",
          "accendo",
          "acceptus",
          "accipio",
          "accommodo",
          "accusator",
          "acer",
          "acerbitas",
          "acervus",
          "acidus",
          "acies",
          "acquiro",
          "acsi",
          "adamo",
          "adaugeo",
          "addo",
          "adduco",
          "ademptio",
          "adeo",
          "adeptio",
          "adfectus",
          "adfero",
          "adficio",
          "adflicto",
          "adhaero",
          "adhuc",
          "adicio",
          "adimpleo",
          "adinventitias",
          "adipiscor",
          "adiuvo",
          "administratio",
          "admiratio",
          "admitto",
          "admoneo",
          "admoveo",
          "adnuo",
          "adopto",
          "adsidue",
          "adstringo",
          "adsuesco",
          "adsum",
          "adulatio",
          "adulescens",
          "adultus",
          "aduro",
          "advenio",
          "adversus",
          "advoco",
          "aedificium",
          "aeger",
          "aegre",
          "aegrotatio",
          "aegrus",
          "aeneus",
          "aequitas",
          "aequus",
          "aer",
          "aestas",
          "aestivus",
          "aestus",
          "aetas",
          "aeternus",
          "ager",
          "aggero",
          "aggredior",
          "agnitio",
          "agnosco",
          "ago",
          "ait",
          "aiunt",
          "alienus",
          "alii",
          "alioqui",
          "aliqua",
          "alius",
          "allatus",
          "alo",
          "alter",
          "altus",
          "alveus",
          "amaritudo",
          "ambitus",
          "ambulo",
          "amicitia",
          "amiculum",
          "amissio",
          "amita",
          "amitto",
          "amo",
          "amor",
          "amoveo",
          "amplexus",
          "amplitudo",
          "amplus",
          "ancilla",
          "angelus",
          "angulus",
          "angustus",
          "animadverto",
          "animi",
          "animus",
          "annus",
          "anser",
          "ante",
          "antea",
          "antepono",
          "antiquus",
          "aperio",
          "aperte",
          "apostolus",
          "apparatus",
          "appello",
          "appono",
          "appositus",
          "approbo",
          "apto",
          "aptus",
          "apud",
          "aqua",
          "ara",
          "aranea",
          "arbitro",
          "arbor",
          "arbustum",
          "arca",
          "arceo",
          "arcesso",
          "arcus",
          "argentum",
          "argumentum",
          "arguo",
          "arma",
          "armarium",
          "armo",
          "aro",
          "ars",
          "articulus",
          "artificiose",
          "arto",
          "arx",
          "ascisco",
          "ascit",
          "asper",
          "aspicio",
          "asporto",
          "assentator",
          "astrum",
          "atavus",
          "ater",
          "atqui",
          "atrocitas",
          "atrox",
          "attero",
          "attollo",
          "attonbitus",
          "auctor",
          "auctus",
          "audacia",
          "audax",
          "audentia",
          "audeo",
          "audio",
          "auditor",
          "aufero",
          "aureus",
          "auris",
          "aurum",
          "aut",
          "autem",
          "autus",
          "auxilium",
          "avaritia",
          "avarus",
          "aveho",
          "averto",
          "avoco",
          "baiulus",
          "balbus",
          "barba",
          "bardus",
          "basium",
          "beatus",
          "bellicus",
          "bellum",
          "bene",
          "beneficium",
          "benevolentia",
          "benigne",
          "bestia",
          "bibo",
          "bis",
          "blandior",
          "bonus",
          "bos",
          "brevis",
          "cado",
          "caecus",
          "caelestis",
          "caelum",
          "calamitas",
          "calcar",
          "calco",
          "calculus",
          "callide",
          "campana",
          "candidus",
          "canis",
          "canonicus",
          "canto",
          "capillus",
          "capio",
          "capitulus",
          "capto",
          "caput",
          "carbo",
          "carcer",
          "careo",
          "caries",
          "cariosus",
          "caritas",
          "carmen",
          "carpo",
          "carus",
          "casso",
          "caste",
          "casus",
          "catena",
          "caterva",
          "cattus",
          "cauda",
          "causa",
          "caute",
          "caveo",
          "cavus",
          "cedo",
          "celebrer",
          "celer",
          "celo",
          "cena",
          "cenaculum",
          "ceno",
          "censura",
          "centum",
          "cerno",
          "cernuus",
          "certe",
          "certo",
          "certus",
          "cervus",
          "cetera",
          "charisma",
          "chirographum",
          "cibo",
          "cibus",
          "cicuta",
          "cilicium",
          "cimentarius",
          "ciminatio",
          "cinis",
          "circumvenio",
          "cito",
          "civis",
          "civitas",
          "clam",
          "clamo",
          "claro",
          "clarus",
          "claudeo",
          "claustrum",
          "clementia",
          "clibanus",
          "coadunatio",
          "coaegresco",
          "coepi",
          "coerceo",
          "cogito",
          "cognatus",
          "cognomen",
          "cogo",
          "cohaero",
          "cohibeo",
          "cohors",
          "colligo",
          "colloco",
          "collum",
          "colo",
          "color",
          "coma",
          "combibo",
          "comburo",
          "comedo",
          "comes",
          "cometes",
          "comis",
          "comitatus",
          "commemoro",
          "comminor",
          "commodo",
          "communis",
          "comparo",
          "compello",
          "complectus",
          "compono",
          "comprehendo",
          "comptus",
          "conatus",
          "concedo",
          "concido",
          "conculco",
          "condico",
          "conduco",
          "confero",
          "confido",
          "conforto",
          "confugo",
          "congregatio",
          "conicio",
          "coniecto",
          "conitor",
          "coniuratio",
          "conor",
          "conqueror",
          "conscendo",
          "conservo",
          "considero",
          "conspergo",
          "constans",
          "consuasor",
          "contabesco",
          "contego",
          "contigo",
          "contra",
          "conturbo",
          "conventus",
          "convoco",
          "copia",
          "copiose",
          "cornu",
          "corona",
          "corpus",
          "correptius",
          "corrigo",
          "corroboro",
          "corrumpo",
          "coruscus",
          "cotidie",
          "crapula",
          "cras",
          "crastinus",
          "creator",
          "creber",
          "crebro",
          "credo",
          "creo",
          "creptio",
          "crepusculum",
          "cresco",
          "creta",
          "cribro",
          "crinis",
          "cruciamentum",
          "crudelis",
          "cruentus",
          "crur",
          "crustulum",
          "crux",
          "cubicularis",
          "cubitum",
          "cubo",
          "cui",
          "cuius",
          "culpa",
          "culpo",
          "cultellus",
          "cultura",
          "cum",
          "cunabula",
          "cunae",
          "cunctatio",
          "cupiditas",
          "cupio",
          "cuppedia",
          "cupressus",
          "cur",
          "cura",
          "curatio",
          "curia",
          "curiositas",
          "curis",
          "curo",
          "curriculum",
          "currus",
          "cursim",
          "curso",
          "cursus",
          "curto",
          "curtus",
          "curvo",
          "curvus",
          "custodia",
          "damnatio",
          "damno",
          "dapifer",
          "debeo",
          "debilito",
          "decens",
          "decerno",
          "decet",
          "decimus",
          "decipio",
          "decor",
          "decretum",
          "decumbo",
          "dedecor",
          "dedico",
          "deduco",
          "defaeco",
          "defendo",
          "defero",
          "defessus",
          "defetiscor",
          "deficio",
          "defigo",
          "defleo",
          "defluo",
          "defungo",
          "degenero",
          "degero",
          "degusto",
          "deinde",
          "delectatio",
          "delego",
          "deleo",
          "delibero",
          "delicate",
          "delinquo",
          "deludo",
          "demens",
          "demergo",
          "demitto",
          "demo",
          "demonstro",
          "demoror",
          "demulceo",
          "demum",
          "denego",
          "denique",
          "dens",
          "denuncio",
          "denuo",
          "deorsum",
          "depereo",
          "depono",
          "depopulo",
          "deporto",
          "depraedor",
          "deprecator",
          "deprimo",
          "depromo",
          "depulso",
          "deputo",
          "derelinquo",
          "derideo",
          "deripio",
          "desidero",
          "desino",
          "desipio",
          "desolo",
          "desparatus",
          "despecto",
          "despirmatio",
          "infit",
          "inflammatio",
          "paens",
          "patior",
          "patria",
          "patrocinor",
          "patruus",
          "pauci",
          "paulatim",
          "pauper",
          "pax",
          "peccatus",
          "pecco",
          "pecto",
          "pectus",
          "pecunia",
          "pecus",
          "peior",
          "pel",
          "ocer",
          "socius",
          "sodalitas",
          "sol",
          "soleo",
          "solio",
          "solitudo",
          "solium",
          "sollers",
          "sollicito",
          "solum",
          "solus",
          "solutio",
          "solvo",
          "somniculosus",
          "somnus",
          "sonitus",
          "sono",
          "sophismata",
          "sopor",
          "sordeo",
          "sortitus",
          "spargo",
          "speciosus",
          "spectaculum",
          "speculum",
          "sperno",
          "spero",
          "spes",
          "spiculum",
          "spiritus",
          "spoliatio",
          "sponte",
          "stabilis",
          "statim",
          "statua",
          "stella",
          "stillicidium",
          "stipes",
          "stips",
          "sto",
          "strenuus",
          "strues",
          "studio",
          "stultus",
          "suadeo",
          "suasoria",
          "sub",
          "subito",
          "subiungo",
          "sublime",
          "subnecto",
          "subseco",
          "substantia",
          "subvenio",
          "succedo",
          "succurro",
          "sufficio",
          "suffoco",
          "suffragium",
          "suggero",
          "sui",
          "sulum",
          "sum",
          "summa",
          "summisse",
          "summopere",
          "sumo",
          "sumptus",
          "supellex",
          "super",
          "suppellex",
          "supplanto",
          "suppono",
          "supra",
          "surculus",
          "surgo",
          "sursum",
          "suscipio",
          "suspendo",
          "sustineo",
          "suus",
          "synagoga",
          "tabella",
          "tabernus",
          "tabesco",
          "tabgo",
          "tabula",
          "taceo",
          "tactus",
          "taedium",
          "talio",
          "talis",
          "talus",
          "tam",
          "tamdiu",
          "tamen",
          "tametsi",
          "tamisium",
          "tamquam",
          "tandem",
          "tantillus",
          "tantum",
          "tardus",
          "tego",
          "temeritas",
          "temperantia",
          "templum",
          "temptatio",
          "tempus",
          "tenax",
          "tendo",
          "teneo",
          "tener",
          "tenuis",
          "tenus",
          "tepesco",
          "tepidus",
          "ter",
          "terebro",
          "teres",
          "terga",
          "tergeo",
          "tergiversatio",
          "tergo",
          "tergum",
          "termes",
          "terminatio",
          "tero",
          "terra",
          "terreo",
          "territo",
          "terror",
          "tersus",
          "tertius",
          "testimonium",
          "texo",
          "textilis",
          "textor",
          "textus",
          "thalassinus",
          "theatrum",
          "theca",
          "thema",
          "theologus",
          "thermae",
          "thesaurus",
          "thesis",
          "thorax",
          "thymbra",
          "thymum",
          "tibi",
          "timidus",
          "timor",
          "titulus",
          "tolero",
          "tollo",
          "tondeo",
          "tonsor",
          "torqueo",
          "torrens",
          "tot",
          "totidem",
          "toties",
          "totus",
          "tracto",
          "trado",
          "traho",
          "trans",
          "tredecim",
          "tremo",
          "trepide",
          "tres",
          "tribuo",
          "tricesimus",
          "triduana",
          "triginta",
          "tripudio",
          "tristis",
          "triumphus",
          "trucido",
          "truculenter",
          "tubineus",
          "tui",
          "tum",
          "tumultus",
          "tunc",
          "turba",
          "turbo",
          "turpe",
          "turpis",
          "tutamen",
          "tutis",
          "tyrannus",
          "uberrime",
          "ubi",
          "ulciscor",
          "ullus",
          "ulterius",
          "ultio",
          "ultra",
          "umbra",
          "umerus",
          "umquam",
          "una",
          "unde",
          "undique",
          "universe",
          "unus",
          "urbanus",
          "urbs",
          "uredo",
          "usitas",
          "usque",
          "ustilo",
          "ustulo",
          "usus",
          "uter",
          "uterque",
          "utilis",
          "utique",
          "utor",
          "utpote",
          "utrimque",
          "utroque",
          "utrum",
          "uxor",
          "vaco",
          "vacuus",
          "vado",
          "vae",
          "valde",
          "valens",
          "valeo",
          "valetudo",
          "validus",
          "vallum",
          "vapulus",
          "varietas",
          "varius",
          "vehemens",
          "vel",
          "velociter",
          "velum",
          "velut",
          "venia",
          "venio",
          "ventito",
          "ventosus",
          "ventus",
          "venustas",
          "ver",
          "verbera",
          "verbum",
          "vere",
          "verecundia",
          "vereor",
          "vergo",
          "veritas",
          "vero",
          "versus",
          "verto",
          "verumtamen",
          "verus",
          "vesco",
          "vesica",
          "vesper",
          "vespillo",
          "vester",
          "vestigium",
          "vestrum",
          "vetus",
          "via",
          "vicinus",
          "vicissitudo",
          "victoria",
          "victus",
          "videlicet",
          "video",
          "viduata",
          "viduo",
          "vigilo",
          "vigor",
          "vilicus",
          "vilis",
          "vilitas",
          "villa",
          "vinco",
          "vinculum",
          "vindico",
          "vinitor",
          "vinum",
          "vir",
          "virga",
          "virgo",
          "viridis",
          "viriliter",
          "virtus",
          "vis",
          "viscus",
          "vita",
          "vitiosus",
          "vitium",
          "vito",
          "vivo",
          "vix",
          "vobis",
          "vociferor",
          "voco",
          "volaticus",
          "volo",
          "volubilis",
          "voluntarius",
          "volup",
          "volutabrum",
          "volva",
          "vomer",
          "vomica",
          "vomito",
          "vorago",
          "vorax",
          "voro",
          "vos",
          "votum",
          "voveo",
          "vox",
          "vulariter",
          "vulgaris",
          "vulgivagus",
          "vulgo",
          "vulgus",
          "vulnero",
          "vulnus",
          "vulpes",
          "vulticulus",
          "vultuosus",
          "xiphias"
        ],
        "words": [
          "alias",
          "consequatur",
          "aut",
          "perferendis",
          "sit",
          "voluptatem",
          "accusantium",
          "doloremque",
          "aperiam",
          "eaque",
          "ipsa",
          "quae",
          "ab",
          "illo",
          "inventore",
          "veritatis",
          "et",
          "quasi",
          "architecto",
          "beatae",
          "vitae",
          "dicta",
          "sunt",
          "explicabo",
          "aspernatur",
          "aut",
          "odit",
          "aut",
          "fugit",
          "sed",
          "quia",
          "consequuntur",
          "magni",
          "dolores",
          "eos",
          "qui",
          "ratione",
          "voluptatem",
          "sequi",
          "nesciunt",
          "neque",
          "dolorem",
          "ipsum",
          "quia",
          "dolor",
          "sit",
          "amet",
          "consectetur",
          "adipisci",
          "velit",
          "sed",
          "quia",
          "non",
          "numquam",
          "eius",
          "modi",
          "tempora",
          "incidunt",
          "ut",
          "labore",
          "et",
          "dolore",
          "magnam",
          "aliquam",
          "quaerat",
          "voluptatem",
          "ut",
          "enim",
          "ad",
          "minima",
          "veniam",
          "quis",
          "nostrum",
          "exercitationem",
          "ullam",
          "corporis",
          "nemo",
          "enim",
          "ipsam",
          "voluptatem",
          "quia",
          "voluptas",
          "sit",
          "suscipit",
          "laboriosam",
          "nisi",
          "ut",
          "aliquid",
          "ex",
          "ea",
          "commodi",
          "consequatur",
          "quis",
          "autem",
          "vel",
          "eum",
          "iure",
          "reprehenderit",
          "qui",
          "in",
          "ea",
          "voluptate",
          "velit",
          "esse",
          "quam",
          "nihil",
          "molestiae",
          "et",
          "iusto",
          "odio",
          "dignissimos",
          "ducimus",
          "qui",
          "blanditiis",
          "praesentium",
          "laudantium",
          "totam",
          "rem",
          "voluptatum",
          "deleniti",
          "atque",
          "corrupti",
          "quos",
          "dolores",
          "et",
          "quas",
          "molestias",
          "excepturi",
          "sint",
          "occaecati",
          "cupiditate",
          "non",
          "provident",
          "sed",
          "ut",
          "perspiciatis",
          "unde",
          "omnis",
          "iste",
          "natus",
          "error",
          "similique",
          "sunt",
          "in",
          "culpa",
          "qui",
          "officia",
          "deserunt",
          "mollitia",
          "animi",
          "id",
          "est",
          "laborum",
          "et",
          "dolorum",
          "fuga",
          "et",
          "harum",
          "quidem",
          "rerum",
          "facilis",
          "est",
          "et",
          "expedita",
          "distinctio",
          "nam",
          "libero",
          "tempore",
          "cum",
          "soluta",
          "nobis",
          "est",
          "eligendi",
          "optio",
          "cumque",
          "nihil",
          "impedit",
          "quo",
          "porro",
          "quisquam",
          "est",
          "qui",
          "minus",
          "id",
          "quod",
          "maxime",
          "placeat",
          "facere",
          "possimus",
          "omnis",
          "voluptas",
          "assumenda",
          "est",
          "omnis",
          "dolor",
          "repellendus",
          "temporibus",
          "autem",
          "quibusdam",
          "et",
          "aut",
          "consequatur",
          "vel",
          "illum",
          "qui",
          "dolorem",
          "eum",
          "fugiat",
          "quo",
          "voluptas",
          "nulla",
          "pariatur",
          "at",
          "vero",
          "eos",
          "et",
          "accusamus",
          "officiis",
          "debitis",
          "aut",
          "rerum",
          "necessitatibus",
          "saepe",
          "eveniet",
          "ut",
          "et",
          "voluptates",
          "repudiandae",
          "sint",
          "et",
          "molestiae",
          "non",
          "recusandae",
          "itaque",
          "earum",
          "rerum",
          "hic",
          "tenetur",
          "a",
          "sapiente",
          "delectus",
          "ut",
          "aut",
          "reiciendis",
          "voluptatibus",
          "maiores",
          "doloribus",
          "asperiores",
          "repellat"
        ]
      },
      "name": {
        "female_first_name": [
          "Alexandra",
          "Karina",
          "Daniela",
          "Andrea",
          "Antónia",
          "Bohuslava",
          "Dáša",
          "Malvína",
          "Kristína",
          "Nataša",
          "Bohdana",
          "Drahomíra",
          "Sára",
          "Zora",
          "Tamara",
          "Ema",
          "Tatiana",
          "Erika",
          "Veronika",
          "Agáta",
          "Dorota",
          "Vanda",
          "Zoja",
          "Gabriela",
          "Perla",
          "Ida",
          "Liana",
          "Miloslava",
          "Vlasta",
          "Lívia",
          "Eleonóra",
          "Etela",
          "Romana",
          "Zlatica",
          "Anežka",
          "Bohumila",
          "Františka",
          "Angela",
          "Matilda",
          "Svetlana",
          "Ľubica",
          "Alena",
          "Soňa",
          "Vieroslava",
          "Zita",
          "Miroslava",
          "Irena",
          "Milena",
          "Estera",
          "Justína",
          "Dana",
          "Danica",
          "Jela",
          "Jaroslava",
          "Jarmila",
          "Lea",
          "Anastázia",
          "Galina",
          "Lesana",
          "Hermína",
          "Monika",
          "Ingrida",
          "Viktória",
          "Blažena",
          "Žofia",
          "Sofia",
          "Gizela",
          "Viola",
          "Gertrúda",
          "Zina",
          "Júlia",
          "Juliana",
          "Želmíra",
          "Ela",
          "Vanesa",
          "Iveta",
          "Vilma",
          "Petronela",
          "Žaneta",
          "Xénia",
          "Karolína",
          "Lenka",
          "Laura",
          "Stanislava",
          "Margaréta",
          "Dobroslava",
          "Blanka",
          "Valéria",
          "Paulína",
          "Sidónia",
          "Adriána",
          "Beáta",
          "Petra",
          "Melánia",
          "Diana",
          "Berta",
          "Patrícia",
          "Lujza",
          "Amália",
          "Milota",
          "Nina",
          "Margita",
          "Kamila",
          "Dušana",
          "Magdaléna",
          "Oľga",
          "Anna",
          "Hana",
          "Božena",
          "Marta",
          "Libuša",
          "Božidara",
          "Dominika",
          "Hortenzia",
          "Jozefína",
          "Štefánia",
          "Ľubomíra",
          "Zuzana",
          "Darina",
          "Marcela",
          "Milica",
          "Elena",
          "Helena",
          "Lýdia",
          "Anabela",
          "Jana",
          "Silvia",
          "Nikola",
          "Ružena",
          "Nora",
          "Drahoslava",
          "Linda",
          "Melinda",
          "Rebeka",
          "Rozália",
          "Regína",
          "Alica",
          "Marianna",
          "Miriama",
          "Martina",
          "Mária",
          "Jolana",
          "Ľudomila",
          "Ľudmila",
          "Olympia",
          "Eugénia",
          "Ľuboslava",
          "Zdenka",
          "Edita",
          "Michaela",
          "Stela",
          "Viera",
          "Natália",
          "Eliška",
          "Brigita",
          "Valentína",
          "Terézia",
          "Vladimíra",
          "Hedviga",
          "Uršuľa",
          "Alojza",
          "Kvetoslava",
          "Sabína",
          "Dobromila",
          "Klára",
          "Simona",
          "Aurélia",
          "Denisa",
          "Renáta",
          "Irma",
          "Agnesa",
          "Klaudia",
          "Alžbeta",
          "Elvíra",
          "Cecília",
          "Emília",
          "Katarína",
          "Henrieta",
          "Bibiána",
          "Barbora",
          "Marína",
          "Izabela",
          "Hilda",
          "Otília",
          "Lucia",
          "Branislava",
          "Bronislava",
          "Ivica",
          "Albína",
          "Kornélia",
          "Sláva",
          "Slávka",
          "Judita",
          "Dagmara",
          "Adela",
          "Nadežda",
          "Eva",
          "Filoména",
          "Ivana",
          "Milada"
        ],
        "first_name": [
          "#{male_first_name}",
          "#{female_first_name}"
        ],
        "last_name": [
          "#{man_last_name}",
          "#{woman_last_name}"
        ],
        "male_first_name": [
          "Drahoslav",
          "Severín",
          "Alexej",
          "Ernest",
          "Rastislav",
          "Radovan",
          "Dobroslav",
          "Dalibor",
          "Vincent",
          "Miloš",
          "Timotej",
          "Gejza",
          "Bohuš",
          "Alfonz",
          "Gašpar",
          "Emil",
          "Erik",
          "Blažej",
          "Zdenko",
          "Dezider",
          "Arpád",
          "Valentín",
          "Pravoslav",
          "Jaromír",
          "Roman",
          "Matej",
          "Frederik",
          "Viktor",
          "Alexander",
          "Radomír",
          "Albín",
          "Bohumil",
          "Kazimír",
          "Fridrich",
          "Radoslav",
          "Tomáš",
          "Alan",
          "Branislav",
          "Bruno",
          "Gregor",
          "Vlastimil",
          "Boleslav",
          "Eduard",
          "Jozef",
          "Víťazoslav",
          "Blahoslav",
          "Beňadik",
          "Adrián",
          "Gabriel",
          "Marián",
          "Emanuel",
          "Miroslav",
          "Benjamín",
          "Hugo",
          "Richard",
          "Izidor",
          "Zoltán",
          "Albert",
          "Igor",
          "Július",
          "Aleš",
          "Fedor",
          "Rudolf",
          "Valér",
          "Marcel",
          "Ervín",
          "Slavomír",
          "Vojtech",
          "Juraj",
          "Marek",
          "Jaroslav",
          "Žigmund",
          "Florián",
          "Roland",
          "Pankrác",
          "Servác",
          "Bonifác",
          "Svetozár",
          "Bernard",
          "Júlia",
          "Urban",
          "Dušan",
          "Viliam",
          "Ferdinand",
          "Norbert",
          "Róbert",
          "Medard",
          "Zlatko",
          "Anton",
          "Vasil",
          "Vít",
          "Adolf",
          "Vratislav",
          "Alfréd",
          "Alojz",
          "Ján",
          "Tadeáš",
          "Ladislav",
          "Peter",
          "Pavol",
          "Miloslav",
          "Prokop",
          "Cyril",
          "Metod",
          "Patrik",
          "Oliver",
          "Ivan",
          "Kamil",
          "Henrich",
          "Drahomír",
          "Bohuslav",
          "Iľja",
          "Daniel",
          "Vladimír",
          "Jakub",
          "Krištof",
          "Ignác",
          "Gustáv",
          "Jerguš",
          "Dominik",
          "Oskar",
          "Vavrinec",
          "Ľubomír",
          "Mojmír",
          "Leonard",
          "Tichomír",
          "Filip",
          "Bartolomej",
          "Ľudovít",
          "Samuel",
          "Augustín",
          "Belo",
          "Oleg",
          "Bystrík",
          "Ctibor",
          "Ľudomil",
          "Konštantín",
          "Ľuboslav",
          "Matúš",
          "Móric",
          "Ľuboš",
          "Ľubor",
          "Vladislav",
          "Cyprián",
          "Václav",
          "Michal",
          "Jarolím",
          "Arnold",
          "Levoslav",
          "František",
          "Dionýz",
          "Maximilián",
          "Koloman",
          "Boris",
          "Lukáš",
          "Kristián",
          "Vendelín",
          "Sergej",
          "Aurel",
          "Demeter",
          "Denis",
          "Hubert",
          "Karol",
          "Imrich",
          "René",
          "Bohumír",
          "Teodor",
          "Tibor",
          "Maroš",
          "Martin",
          "Svätopluk",
          "Stanislav",
          "Leopold",
          "Eugen",
          "Félix",
          "Klement",
          "Kornel",
          "Milan",
          "Vratko",
          "Ondrej",
          "Andrej",
          "Edmund",
          "Oldrich",
          "Oto",
          "Mikuláš",
          "Ambróz",
          "Radúz",
          "Bohdan",
          "Adam",
          "Štefan",
          "Dávid",
          "Silvester"
        ],
        "man_last_name": [
          "Antal",
          "Babka",
          "Bahna",
          "Bahno",
          "Baláž",
          "Baran",
          "Baranka",
          "Bartovič",
          "Bartoš",
          "Bača",
          "Bernolák",
          "Beňo",
          "Bicek",
          "Bielik",
          "Blaho",
          "Bondra",
          "Bosák",
          "Boška",
          "Brezina",
          "Bukovský",
          "Chalupka",
          "Chudík",
          "Cibula",
          "Cibulka",
          "Cibuľa",
          "Cyprich",
          "Cíger",
          "Danko",
          "Daňko",
          "Daňo",
          "Debnár",
          "Dej",
          "Dekýš",
          "Doležal",
          "Dočolomanský",
          "Droppa",
          "Dubovský",
          "Dudek",
          "Dula",
          "Dulla",
          "Dusík",
          "Dvonč",
          "Dzurjanin",
          "Dávid",
          "Fabian",
          "Fabián",
          "Fajnor",
          "Farkašovský",
          "Fico",
          "Filc",
          "Filip",
          "Finka",
          "Ftorek",
          "Gašpar",
          "Gašparovič",
          "Gocník",
          "Gregor",
          "Greguš",
          "Grznár",
          "Hablák",
          "Habšuda",
          "Halda",
          "Haluška",
          "Halák",
          "Hanko",
          "Hanzal",
          "Haščák",
          "Heretik",
          "Hečko",
          "Hlaváček",
          "Hlinka",
          "Holub",
          "Holuby",
          "Hossa",
          "Hoza",
          "Hraško",
          "Hric",
          "Hrmo",
          "Hrušovský",
          "Huba",
          "Ihnačák",
          "Janeček",
          "Janoška",
          "Jantošovič",
          "Janík",
          "Janček",
          "Jedľovský",
          "Jendek",
          "Jonata",
          "Jurina",
          "Jurkovič",
          "Jurík",
          "Jánošík",
          "Kafenda",
          "Kaliský",
          "Karul",
          "Keníž",
          "Klapka",
          "Kmeť",
          "Kolesár",
          "Kollár",
          "Kolnik",
          "Kolník",
          "Kolár",
          "Korec",
          "Kostka",
          "Kostrec",
          "Kováč",
          "Kováčik",
          "Koza",
          "Kočiš",
          "Krajíček",
          "Krajči",
          "Krajčo",
          "Krajčovič",
          "Krajčír",
          "Králik",
          "Krúpa",
          "Kubík",
          "Kyseľ",
          "Kállay",
          "Labuda",
          "Lepšík",
          "Lipták",
          "Lisický",
          "Lubina",
          "Lukáč",
          "Lupták",
          "Líška",
          "Madej",
          "Majeský",
          "Malachovský",
          "Malíšek",
          "Mamojka",
          "Marcinko",
          "Marián",
          "Masaryk",
          "Maslo",
          "Matiaško",
          "Medveď",
          "Melcer",
          "Mečiar",
          "Michalík",
          "Mihalik",
          "Mihál",
          "Mihálik",
          "Mikloško",
          "Mikulík",
          "Mikuš",
          "Mikúš",
          "Milota",
          "Mináč",
          "Mišík",
          "Mojžiš",
          "Mokroš",
          "Mora",
          "Moravčík",
          "Mydlo",
          "Nemec",
          "Nitra",
          "Novák",
          "Obšut",
          "Ondruš",
          "Otčenáš",
          "Pauko",
          "Pavlikovský",
          "Pavúk",
          "Pašek",
          "Paška",
          "Paško",
          "Pelikán",
          "Petrovický",
          "Petruška",
          "Peško",
          "Plch",
          "Plekanec",
          "Podhradský",
          "Podkonický",
          "Poliak",
          "Pupák",
          "Rak",
          "Repiský",
          "Romančík",
          "Rus",
          "Ružička",
          "Rybníček",
          "Rybár",
          "Rybárik",
          "Samson",
          "Sedliak",
          "Senko",
          "Sklenka",
          "Skokan",
          "Skutecký",
          "Slašťan",
          "Sloboda",
          "Slobodník",
          "Slota",
          "Slovák",
          "Smrek",
          "Stodola",
          "Straka",
          "Strnisko",
          "Svrbík",
          "Sámel",
          "Sýkora",
          "Tatar",
          "Tatarka",
          "Tatár",
          "Tatárka",
          "Thomka",
          "Tomeček",
          "Tomka",
          "Tomko",
          "Truben",
          "Turčok",
          "Uram",
          "Urblík",
          "Vajcík",
          "Vajda",
          "Valach",
          "Valachovič",
          "Valent",
          "Valuška",
          "Vanek",
          "Vesel",
          "Vicen",
          "Višňovský",
          "Vlach",
          "Vojtek",
          "Vydarený",
          "Zajac",
          "Zima",
          "Zimka",
          "Záborský",
          "Zúbrik",
          "Čapkovič",
          "Čaplovič",
          "Čarnogurský",
          "Čierny",
          "Čobrda",
          "Ďaďo",
          "Ďurica",
          "Ďuriš",
          "Šidlo",
          "Šimonovič",
          "Škriniar",
          "Škultéty",
          "Šmajda",
          "Šoltés",
          "Šoltýs",
          "Štefan",
          "Štefanka",
          "Šulc",
          "Šurka",
          "Švehla",
          "Šťastný"
        ],
        "name": [
          "#{prefix} #{male_first_name} #{man_last_name}",
          "#{prefix} #{female_first_name} #{woman_last_name}",
          "#{male_first_name} #{man_last_name} #{suffix}",
          "#{female_first_name} #{woman_last_name} #{suffix}",
          "#{male_first_name} #{man_last_name}",
          "#{male_first_name} #{man_last_name}",
          "#{male_first_name} #{man_last_name}",
          "#{female_first_name} #{woman_last_name}",
          "#{female_first_name} #{woman_last_name}",
          "#{female_first_name} #{woman_last_name}"
        ],
        "prefix": [
          "Ing.",
          "Mgr.",
          "JUDr.",
          "MUDr."
        ],
        "suffix": [
          "Phd."
        ],
        "title": {
          "descriptor": [
            "Lead",
            "Senior",
            "Direct",
            "Corporate",
            "Dynamic",
            "Future",
            "Product",
            "National",
            "Regional",
            "District",
            "Central",
            "Global",
            "Customer",
            "Investor",
            "Dynamic",
            "International",
            "Legacy",
            "Forward",
            "Internal",
            "Human",
            "Chief",
            "Principal"
          ],
          "job": [
            "Supervisor",
            "Associate",
            "Executive",
            "Liaison",
            "Officer",
            "Manager",
            "Engineer",
            "Specialist",
            "Director",
            "Coordinator",
            "Administrator",
            "Architect",
            "Analyst",
            "Designer",
            "Planner",
            "Orchestrator",
            "Technician",
            "Developer",
            "Producer",
            "Consultant",
            "Assistant",
            "Facilitator",
            "Agent",
            "Representative",
            "Strategist"
          ],
          "level": [
            "Solutions",
            "Program",
            "Brand",
            "Security",
            "Research",
            "Marketing",
            "Directives",
            "Implementation",
            "Integration",
            "Functionality",
            "Response",
            "Paradigm",
            "Tactics",
            "Identity",
            "Markets",
            "Group",
            "Division",
            "Applications",
            "Optimization",
            "Operations",
            "Infrastructure",
            "Intranet",
            "Communications",
            "Web",
            "Branding",
            "Quality",
            "Assurance",
            "Mobility",
            "Accounts",
            "Data",
            "Creative",
            "Configuration",
            "Accountability",
            "Interactions",
            "Factors",
            "Usability",
            "Metrics"
          ]
        },
        "woman_last_name": [
          "Antalová",
          "Babková",
          "Bahnová",
          "Balážová",
          "Baranová",
          "Baranková",
          "Bartovičová",
          "Bartošová",
          "Bačová",
          "Bernoláková",
          "Beňová",
          "Biceková",
          "Bieliková",
          "Blahová",
          "Bondrová",
          "Bosáková",
          "Bošková",
          "Brezinová",
          "Bukovská",
          "Chalupková",
          "Chudíková",
          "Cibulová",
          "Cibulková",
          "Cyprichová",
          "Cígerová",
          "Danková",
          "Daňková",
          "Daňová",
          "Debnárová",
          "Dejová",
          "Dekýšová",
          "Doležalová",
          "Dočolomanská",
          "Droppová",
          "Dubovská",
          "Dudeková",
          "Dulová",
          "Dullová",
          "Dusíková",
          "Dvončová",
          "Dzurjaninová",
          "Dávidová",
          "Fabianová",
          "Fabiánová",
          "Fajnorová",
          "Farkašovská",
          "Ficová",
          "Filcová",
          "Filipová",
          "Finková",
          "Ftoreková",
          "Gašparová",
          "Gašparovičová",
          "Gocníková",
          "Gregorová",
          "Gregušová",
          "Grznárová",
          "Habláková",
          "Habšudová",
          "Haldová",
          "Halušková",
          "Haláková",
          "Hanková",
          "Hanzalová",
          "Haščáková",
          "Heretiková",
          "Hečková",
          "Hlaváčeková",
          "Hlinková",
          "Holubová",
          "Holubyová",
          "Hossová",
          "Hozová",
          "Hrašková",
          "Hricová",
          "Hrmová",
          "Hrušovská",
          "Hubová",
          "Ihnačáková",
          "Janečeková",
          "Janošková",
          "Jantošovičová",
          "Janíková",
          "Jančeková",
          "Jedľovská",
          "Jendeková",
          "Jonatová",
          "Jurinová",
          "Jurkovičová",
          "Juríková",
          "Jánošíková",
          "Kafendová",
          "Kaliská",
          "Karulová",
          "Kenížová",
          "Klapková",
          "Kmeťová",
          "Kolesárová",
          "Kollárová",
          "Kolniková",
          "Kolníková",
          "Kolárová",
          "Korecová",
          "Kostkaová",
          "Kostrecová",
          "Kováčová",
          "Kováčiková",
          "Kozová",
          "Kočišová",
          "Krajíčeková",
          "Krajčová",
          "Krajčovičová",
          "Krajčírová",
          "Králiková",
          "Krúpová",
          "Kubíková",
          "Kyseľová",
          "Kállayová",
          "Labudová",
          "Lepšíková",
          "Liptáková",
          "Lisická",
          "Lubinová",
          "Lukáčová",
          "Luptáková",
          "Líšková",
          "Madejová",
          "Majeská",
          "Malachovská",
          "Malíšeková",
          "Mamojková",
          "Marcinková",
          "Mariánová",
          "Masaryková",
          "Maslová",
          "Matiašková",
          "Medveďová",
          "Melcerová",
          "Mečiarová",
          "Michalíková",
          "Mihaliková",
          "Mihálová",
          "Miháliková",
          "Miklošková",
          "Mikulíková",
          "Mikušová",
          "Mikúšová",
          "Milotová",
          "Mináčová",
          "Mišíková",
          "Mojžišová",
          "Mokrošová",
          "Morová",
          "Moravčíková",
          "Mydlová",
          "Nemcová",
          "Nováková",
          "Obšutová",
          "Ondrušová",
          "Otčenášová",
          "Pauková",
          "Pavlikovská",
          "Pavúková",
          "Pašeková",
          "Pašková",
          "Pelikánová",
          "Petrovická",
          "Petrušková",
          "Pešková",
          "Plchová",
          "Plekanecová",
          "Podhradská",
          "Podkonická",
          "Poliaková",
          "Pupáková",
          "Raková",
          "Repiská",
          "Romančíková",
          "Rusová",
          "Ružičková",
          "Rybníčeková",
          "Rybárová",
          "Rybáriková",
          "Samsonová",
          "Sedliaková",
          "Senková",
          "Sklenková",
          "Skokanová",
          "Skutecká",
          "Slašťanová",
          "Slobodová",
          "Slobodníková",
          "Slotová",
          "Slováková",
          "Smreková",
          "Stodolová",
          "Straková",
          "Strnisková",
          "Svrbíková",
          "Sámelová",
          "Sýkorová",
          "Tatarová",
          "Tatarková",
          "Tatárová",
          "Tatárkaová",
          "Thomková",
          "Tomečeková",
          "Tomková",
          "Trubenová",
          "Turčoková",
          "Uramová",
          "Urblíková",
          "Vajcíková",
          "Vajdová",
          "Valachová",
          "Valachovičová",
          "Valentová",
          "Valušková",
          "Vaneková",
          "Veselová",
          "Vicenová",
          "Višňovská",
          "Vlachová",
          "Vojteková",
          "Vydarená",
          "Zajacová",
          "Zimová",
          "Zimková",
          "Záborská",
          "Zúbriková",
          "Čapkovičová",
          "Čaplovičová",
          "Čarnogurská",
          "Čierná",
          "Čobrdová",
          "Ďaďová",
          "Ďuricová",
          "Ďurišová",
          "Šidlová",
          "Šimonovičová",
          "Škriniarová",
          "Škultétyová",
          "Šmajdová",
          "Šoltésová",
          "Šoltýsová",
          "Štefanová",
          "Štefanková",
          "Šulcová",
          "Šurková",
          "Švehlová",
          "Šťastná"
        ]
      },
      "phone_number": {
        "country_code": [
          "421"
        ],
        "formats": [
          "09## ### ###",
          "0## #### ####",
          "0# #### ####",
          "### ### ###"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Prosím vyberte si"
      },
      "submit": {
        "create": "Vytvoriť %{model}",
        "submit": "Uložiť %{model}",
        "update": "Aktualizovať %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miliarda",
            "million": "Milión",
            "quadrillion": "Biliarda",
            "thousand": "Tisíc",
            "trillion": "Bilión",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "B",
              "one": "B",
              "other": "B"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": " "
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " a ",
        "two_words_connector": " a ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "dopoludnia",
      "formats": {
        "default": "%a %e. %B %Y %H:%M %z",
        "long": "%A %e. %B %Y %H:%M",
        "short": "%e. %-m. %H:%M"
      },
      "pm": "popoludní"
    }
  },
  "sl": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Potrditev poslana ob",
          "confirmation_token": "Potrditveni žeton",
          "confirmed_at": "Potrjeno ob",
          "created_at": "Ustvarjeno ob",
          "current_password": "Trenutno geslo",
          "current_sign_in_at": "Trenutna prijava ob",
          "current_sign_in_ip": "Trenutni IP prijave",
          "email": "E-pošta",
          "encrypted_password": "Šifrirano geslo",
          "failed_attempts": "Neuspešni poskusi",
          "last_sign_in_at": "Zadnja prijava ob",
          "last_sign_in_ip": "IP zadnje prijave",
          "locked_at": "Zaklenjeno ob",
          "password": "Geslo",
          "password_confirmation": "Potrditev gesla",
          "remember_created_at": "Zapomnjeno ob",
          "remember_me": "Zapomni si me",
          "reset_password_sent_at": "Poslano za ponastavitev gesla ob",
          "reset_password_token": "Žeton za ponastavitev gesla",
          "sign_in_count": "Število prijav",
          "unconfirmed_email": "Nepotrjen e-poštni naslov",
          "unlock_token": "Žeton za odklep",
          "updated_at": "Posodobljeno ob"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": ""
        }
      },
      "models": {
        "user": {
          "few": "Uporabniki",
          "one": "Uporabnik",
          "other": "Uporabniki",
          "two": "Uporabnika"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ned",
        "pon",
        "tor",
        "sre",
        "čet",
        "pet",
        "sob"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "nedelja",
        "ponedeljek",
        "torek",
        "sreda",
        "četrtek",
        "petek",
        "sobota"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d. %b %Y",
        "short": "%d. %b"
      },
      "month_names": [
        null,
        "januar",
        "februar",
        "marec",
        "april",
        "maj",
        "junij",
        "julij",
        "avgust",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "okoli %{count} ure",
          "one": "okoli %{count} ura",
          "other": "okoli %{count} ur",
          "two": "okoli 2 uri"
        },
        "about_x_months": {
          "few": "okoli %{count} mesece",
          "one": "okoli %{count} mesec",
          "other": "okoli %{count} mesecev",
          "two": "okoli 2 meseca"
        },
        "about_x_years": {
          "few": "okoli %{count} leta",
          "one": "okoli %{count} leto",
          "other": "okoli %{count} let",
          "two": "okoli 2 leti"
        },
        "almost_x_years": {
          "few": "skoraj %{count} leta",
          "one": "skoraj %{count} leto",
          "other": "skoraj %{count} let",
          "two": "skoraj 2 leti"
        },
        "half_a_minute": "pol minute",
        "less_than_x_minutes": {
          "few": "manj kot %{count} minute",
          "one": "manj kot ena minuta",
          "other": "manj kot %{count} minut",
          "two": "manj kot dve minuti"
        },
        "less_than_x_seconds": {
          "few": "manj kot %{count} sekunde",
          "one": "manj kot %{count} sekunda",
          "other": "manj kot %{count} sekund",
          "two": "manj kot 2 sekundi"
        },
        "over_x_years": {
          "few": "več kot %{count} leta",
          "one": "več kot %{count} leto",
          "other": "več kot %{count} let",
          "two": "več kot 2 leti"
        },
        "x_days": {
          "few": "%{count} dnevi",
          "one": "%{count} dan",
          "other": "%{count} dni",
          "two": "2 dneva"
        },
        "x_minutes": {
          "few": "%{count} minute",
          "one": "%{count} minuta",
          "other": "%{count} minut",
          "two": "2 minuti"
        },
        "x_months": {
          "few": "%{count} mesece",
          "one": "%{count} mesec",
          "other": "%{count} mesecev",
          "two": "2 meseca"
        },
        "x_seconds": {
          "few": "%{count} sekunde",
          "one": "%{count} sekunda",
          "other": "%{count} sekund",
          "two": "2 sekundi"
        }
      },
      "prompts": {
        "day": "Dan",
        "hour": "Ura",
        "minute": "Minute",
        "month": "Mesec",
        "second": "Sekunde",
        "year": "Leto"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Vaš e-poštni naslov je bil uspešno potrjen.",
        "new": {
          "resend_confirmation_instructions": "Pošlji navodila za potrditev znova"
        },
        "send_instructions": "V nekaj minutah boste prejeli e-pošto z navodili za potrditev e-poštnega naslova.",
        "send_paranoid_instructions": "Če vaš e-poštni naslov obstaja v naši bazi, boste v nekaj minutah prejeli e-pošto z navodili za potrditev."
      },
      "failure": {
        "already_authenticated": "Ste že prijavljeni.",
        "inactive": "Vaš račun še ni aktiviran.",
        "invalid": "%{authentication_keys} ali geslo napačno.",
        "last_attempt": "Imate še en poskus, preden bo vaš račun zaklenjen.",
        "locked": "Vaš račun je zaklenjen.",
        "not_found_in_database": "%{authentication_keys} ali geslo napačno.",
        "timeout": "Vaša seja je potekla. Prijavite se znova.",
        "unauthenticated": "Pred nadaljevanjem se morate prijaviti ali registrirati.",
        "unconfirmed": "Potrditi morate svoj e-poštni naslov za nadaljevanje."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potrdi moj račun",
          "greeting": "Dobrodošli, %{recipient}!",
          "instruction": "Svoj e-poštni naslov lahko potrdite s spodnjo povezavo:",
          "subject": "Navodila za potrditev"
        },
        "email_changed": {
          "greeting": "Pozdravljeni %{recipient}!",
          "message": "Obveščamo vas, da je bil vaš e-poštni naslov spremenjen na %{email}.",
          "message_unconfirmed": "Obveščamo vas, da bo vaš e-poštni naslov spremenjen na %{email}.",
          "subject": "E-pošta spremenjena"
        },
        "password_change": {
          "greeting": "Pozdravljeni %{recipient}!",
          "message": "Obveščamo vas, da je bilo vaše geslo spremenjeno.",
          "subject": "Geslo spremenjeno"
        },
        "reset_password_instructions": {
          "action": "Spremeni moje geslo",
          "greeting": "Pozdravljeni %{recipient}!",
          "instruction": "Nekdo je zahteval povezavo za spremembo vašega gesla. Spremenite ga lahko s spodnjo povezavo.",
          "instruction_2": "Če niste zahtevali spremembe gesla, prezrite to e-pošto.",
          "instruction_3": "Vaše geslo ne bo spremenjeno, dokler ne uporabite zgornje povezave in ustvarite novega.",
          "subject": "Navodila za ponastavitev gesla"
        },
        "unlock_instructions": {
          "action": "Odkleni moj račun",
          "greeting": "Pozdravljeni %{recipient}!",
          "instruction": "Za odklep računa kliknite spodnjo povezavo:",
          "message": "Zaradi številnih neuspešnih poskusov prijave je bil vaš račun zaklenjen.",
          "subject": "Navodila za odklep računa"
        }
      },
      "omniauth_callbacks": {
        "failure": "Prijava s %{kind} ni bila uspešna zaradi \"%{reason}\".",
        "success": "Uspešno prijavljeni s %{kind} računom."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Spremeni moje geslo",
          "change_your_password": "Spremenite svoje geslo",
          "confirm_new_password": "Potrdi novo geslo",
          "new_password": "Novo geslo"
        },
        "new": {
          "forgot_your_password": "Ste pozabili geslo?",
          "send_me_reset_password_instructions": "Pošlji mi navodila za ponastavitev gesla"
        },
        "no_token": "Do te strani ne morete dostopati brez povezave iz e-pošte za ponastavitev gesla. Prepričajte se, da ste uporabili celoten URL, ki ste ga prejeli v e-pošti.",
        "send_instructions": "V nekaj minutah boste prejeli e-pošto z navodili za ponastavitev gesla.",
        "send_paranoid_instructions": "Če vaš e-poštni naslov obstaja v naši bazi, boste v nekaj minutah prejeli povezavo za obnovitev gesla.",
        "updated": "Geslo je bilo uspešno spremenjeno. Zdaj ste prijavljeni.",
        "updated_not_active": "Geslo je bilo uspešno spremenjeno."
      },
      "registrations": {
        "destroyed": "Vaš račun je bil uspešno ukinjen. Želimo vam vse dobro in upamo, da se še kdaj vidimo.",
        "edit": {
          "are_you_sure": "Ali ste prepričani?",
          "cancel_my_account": "Izbriši moj račun",
          "currently_waiting_confirmation_for_email": "Čaka na potrditev za: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "pustite prazno, če ga ne želite spremeniti.",
          "title": "Uredi %{resource}",
          "unhappy": "Ste nezadovoljni?",
          "update": "Posodobi",
          "we_need_your_current_password_to_confirm_your_changes": "potrebujemo vaše trenutno geslo za potrditev sprememb"
        },
        "new": {
          "sign_up": "Registriraj se"
        },
        "signed_up": "Dobrodošli! Uspešno ste se registrirali.",
        "signed_up_but_inactive": "Uspešno ste se registrirali. Vendar vas nismo mogli prijaviti, ker vaš račun še ni aktiviran.",
        "signed_up_but_locked": "Uspešno ste se registrirali. Vendar vas nismo mogli prijaviti, ker je vaš račun zaklenjen.",
        "signed_up_but_unconfirmed": "Sporočilo s potrditveno povezavo je bilo poslano na vaš e-poštni naslov. Prosimo, odprite povezavo za aktivacijo vašega računa",
        "update_needs_confirmation": "Uspešno ste posodobili svoj račun, vendar moramo potrditi vaš novi e-poštni naslov. Prosimo, preverite e-pošto in kliknite na potrditveno povezavo, da dokončate potrditev novega e-poštnega naslova.",
        "updated": "Vaš račun je bil uspešno posodobljen.",
        "updated_but_not_signed_in": "Vaš račun je bil uspešno posodobljen, vendar se morate zaradi spremembe gesla ponovno prijaviti."
      },
      "sessions": {
        "already_signed_out": "Že ste bili odjavljeni.",
        "new": {
          "sign_in": "Prijava"
        },
        "signed_in": "Uspešno ste prijavljeni.",
        "signed_out": "Uspešno ste se odjavili."
      },
      "shared": {
        "links": {
          "back": "Nazaj",
          "didn_t_receive_confirmation_instructions": "Niste prejeli navodil za potrditev?",
          "didn_t_receive_unlock_instructions": "Niste prejeli navodil za odklepanje?",
          "forgot_your_password": "Ste pozabili geslo?",
          "sign_in": "Prijava",
          "sign_in_with_provider": "Prijava s %{provider}",
          "sign_up": "Registracija"
        },
        "minimum_password_length": {
          "few": "(minimalno %{count} znaki)",
          "one": "(minimalno %{count} znak)",
          "other": "(minimalno %{count} znakov)",
          "two": "(minimalno %{count} znaka)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Ponovno pošlji navodila za odklepanje"
        },
        "send_instructions": "V nekaj minutah boste prejeli e-pošto z navodili za odklep računa.",
        "send_paranoid_instructions": "Če vaš račun obstaja, boste v nekaj minutah prejeli e-pošto z navodili za odklep.",
        "unlocked": "Vaš račun je bil uspešno odklenjen. Prijavite se za nadaljevanje."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "mora biti sprejeto",
        "already_confirmed": "je že bil potrjen, prosimo, da se prijavite",
        "blank": "ne sme biti prazno",
        "confirmation": "se ne ujema z vrednostjo %{attribute}",
        "confirmation_period_expired": "mora biti potrjen v %{period}. Prosimo, pošljite nov zahtevek",
        "empty": "ne sme biti prazno",
        "equal_to": "mora biti enako %{count}",
        "even": "mora biti sodo",
        "exclusion": "je rezervirano",
        "expired": "je poteklo. Prosimo, zahtevajte novo.",
        "greater_than": "mora biti večje kot %{count}",
        "greater_than_or_equal_to": "mora biti večje ali enako %{count}",
        "inclusion": "ni vključeno v seznam",
        "invalid": "je nepravilno",
        "less_than": "mora biti manj kot %{count}",
        "less_than_or_equal_to": "mora biti manj ali enako %{count}",
        "not_a_number": "ni številka",
        "not_found": "ni najdeno",
        "not_locked": "ni zaklenjeno",
        "not_saved": {
          "few": "%{count} napake so onemogočile shraniti %{resource}:",
          "one": "1 napaka je onemogočila shraniti %{resource}:",
          "other": "%{count} napak je onemogočilo shraniti %{resource}:",
          "two": "2 napaki sta onemogočili shraniti %{resource}:"
        },
        "odd": "mora biti liho",
        "taken": "je že zasedeno",
        "too_long": "je predolgo (dovoljeno je do %{count} znakov)",
        "too_short": "je prekratko (zahtevano je najmanj %{count} znakov)",
        "wrong_length": "je napačne dolžine (mora biti natančno %{count} znakov)"
      },
      "template": {
        "body": "Napačno izpolnjena polja:",
        "header": {
          "few": "%{count} napake preprečujejo, da bi shranili %{model}",
          "one": "Ena napaka preprečuje, da bi shranili %{model}",
          "other": "%{count} napak preprečuje, da bi shranili %{model}",
          "two": "Dve napaki preprečujeta, da bi shranili %{model}"
        }
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "two",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "Bytes",
              "one": "Byte",
              "other": "Bytes",
              "two": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " in ",
        "two_words_connector": " in ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "dopoldan",
      "formats": {
        "default": "%A, %d %b %Y ob %H:%M:%S",
        "long": "%d. %B, %Y ob %H:%M",
        "short": "%d. %b ob %H:%M"
      },
      "pm": "popoldan"
    }
  },
  "sq": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Ripohim i dërguar më",
          "confirmation_token": "Token ripohimi",
          "confirmed_at": "Ripohuar më",
          "created_at": "Krijuar më",
          "current_password": "Fjalëkalimi i tanishëm",
          "current_sign_in_at": "Hyrja e tanishme më",
          "current_sign_in_ip": "IP e hyrjes së tanishme",
          "email": "Email",
          "encrypted_password": "Fjalëkalim i fshehtëzuar",
          "failed_attempts": "Përpjekje të dështuara",
          "last_sign_in_at": "Hyrja e fundit më",
          "last_sign_in_ip": "IP e hyrjes së fundit",
          "locked_at": "Kyçur më",
          "password": "Fjalëkalim",
          "password_confirmation": "Ripohim fjalëkalimi",
          "remember_created_at": "Mbajtje mend e krijuar më",
          "remember_me": "Mbamë mend",
          "reset_password_sent_at": "Ricaktim fjalëkalimi dërguar më",
          "reset_password_token": "Riujdisni token fjalëkalimi",
          "sign_in_count": "Numër hyrjesh",
          "unconfirmed_email": "Email i paripohuar",
          "unlock_token": "Shkyçe token-in",
          "updated_at": "Përditësuar më"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Vlerësimi dështoi: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "S’fshihet dot zëri, ngaqë ekzistojnë %{record} që varen prej tij",
            "has_one": "S’fshihet dot zëri, ngaqë ekziston një %{record} që varet prej tij"
          }
        }
      },
      "models": {
        "user": {
          "one": "Përdorues",
          "other": "Përdorues"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Die",
        "Hën",
        "Mar",
        "Mër",
        "Enj",
        "Pre",
        "Sht"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Shk",
        "Mar",
        "Pri",
        "Maj",
        "Qer",
        "Kor",
        "Gus",
        "Sht",
        "Tet",
        "Nën",
        "Dhj"
      ],
      "day_names": [
        "E dielë",
        "E hënë",
        "E martë",
        "E mërkurë",
        "E enjte",
        "E premte",
        "E shtunë"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Janar",
        "Shkurt",
        "Mars",
        "Prill",
        "Maj",
        "Qershor",
        "Korrik",
        "Gusht",
        "Shtator",
        "Tetor",
        "Nëntor",
        "Dhjetor"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "rreth %{count} orë",
          "other": "rreth %{count} orë"
        },
        "about_x_months": {
          "one": "rreth %{count} muaj",
          "other": "rreth %{count} muaj"
        },
        "about_x_years": {
          "one": "rreth %{count} vit",
          "other": "rreth %{count} vjet"
        },
        "almost_x_years": {
          "one": "gati %{count} vit",
          "other": "gati %{count} vjet"
        },
        "half_a_minute": "gjysmë minute",
        "less_than_x_minutes": {
          "one": "më pak se një minutë",
          "other": "më pak se %{count} minuta"
        },
        "less_than_x_seconds": {
          "one": "më pak se %{count} sekondë",
          "other": "më pak se %{count} sekonda"
        },
        "over_x_years": {
          "one": "mbi %{count} vit",
          "other": "mbi %{count} vjet"
        },
        "x_days": {
          "one": "%{count} ditë",
          "other": "%{count} ditë"
        },
        "x_minutes": {
          "one": "%{count} minutë",
          "other": "%{count} minuta"
        },
        "x_months": {
          "one": "%{count} muaj",
          "other": "%{count} muaj"
        },
        "x_years": {
          "one": "%{count} vit",
          "other": "%{count} vjet"
        }
      },
      "prompts": {
        "day": "Ditë",
        "hour": "Orë",
        "minute": "Minutë",
        "month": "Muaj",
        "second": "Sekondë",
        "year": "Vit"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Adresa juaj email u ripohua me sukses.",
        "new": {
          "resend_confirmation_instructions": "Ridërgo udhëzime ripohimi"
        },
        "send_instructions": "Pas pak minutash do të merrni një email me udhëzime se si të ripohoni adresën tuaj email.",
        "send_paranoid_instructions": "Nëse adresa juaj email gjendet në bazën tonë të të dhënave, pas pak minutash do të merrni një email me udhëzime se si të ripohoni adresën tuaj email."
      },
      "failure": {
        "already_authenticated": "E keni bërë hyrjen tashmë.",
        "inactive": "Llogaria juaj s’është ende aktive.",
        "invalid": "%{authentication_keys} ose fjalëkalim i pavlefshëm.",
        "last_attempt": "Keni edhe një provë të fundit, përpara se llogaria juaj të kyçet.",
        "locked": "Llogaria juaj është e kyçur.",
        "not_found_in_database": "%{authentication_keys} ose fjalëkalim i pavlefshëm.",
        "timeout": "Sesioni juaj skadoi. Ju lutemi, që të vazhdohet, ribëni hyrjen.",
        "unauthenticated": "Përpara se të vazhdohet, lypset të bëni hyrjen ose të regjistroheni.",
        "unconfirmed": "Përpara se të vazhdohet, duhet të ripohoni email-in tuaj."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Ripoho llogarinë time",
          "confirm_account_link": "Konfirmo llogarinë time",
          "confirm_link_msg": "Ju mund ta konfirmoni email adresën e llogarisë tuaj përmes lidhjes më poshtë:",
          "greeting": "Mirë se vini %{recipient}!",
          "instruction": "Llogarinë tuaj email mund ta ripohoni përmes lidhjes më poshtë:",
          "subject": "Udhëzime ripohimi"
        },
        "email_changed": {
          "greeting": "Tungjatjeta %{recipient}!",
          "message": "Po lidhemi me ju për t’ju njoftuar se email-i juaj po ndryshohet në %{email}.",
          "message_unconfirmed": null,
          "subject": "Email-i u Ndryshua"
        },
        "password_change": {
          "greeting": "Tungjatjeta %{recipient}!",
          "message": "Po lidhemi me ju për t’ju njoftuar se fjalëkalimi juaj është ndryshuar.",
          "subject": "Fjalëkalimi u Ndryshua"
        },
        "reset_password_instructions": {
          "action": "Ndryshoje fjalëkalimin tim",
          "greeting": "Tungjatjeta %{recipient}!",
          "ignore_mail_msg": "Nëse nuk e keni kërkuar këtë, ju lutemi injorojeni këtë email.",
          "instruction": "Dikush ka kërkuar një lidhje për ndryshim të fjalëkalimit tuaj. Këtë mund ta bëni përmes lidhjes më poshtë.",
          "instruction_2": "Nëse s’e kërkuat një gjë të tillë, ju lutemi, shpërfilleni këtë email.",
          "instruction_3": "Fjalëkalimi juaj nuk do të ndryshohet pa u përdorur lidhja më sipër dhe të krijohet një i ri.",
          "no_changes_msg": "Fjalëkalimi juaj nuk do të ndryshohet derisa t'i qaseni lidhjes më sipër dhe ta krijoni një fjalëkalim të ri.",
          "password_change_link": "Ndrysho fjalëkalimin tim",
          "request_reset_link_msg": "Dikush ka kërkuar një lidhje për të ndryshuar fjalëkalimin tuaj. Ju mund ta bëni këtë përmes lidhjes më poshtë.",
          "subject": "Udhëzime ricaktimi fjalëkalimi"
        },
        "unlock_instructions": {
          "account_lock_msg": "Llogaria juaj është bllokuar për shkak të numrit të tepërt të përpjekjeve të pa suksesshme për t'u kyçur.",
          "action": "Shkyçeni llogarinë time",
          "greeting": "Tungjatjeta %{recipient}!",
          "instruction": "Që të shkyçet llogaria juaj, klikoni mbi lidhjen më poshtë:",
          "message": "Llogaria juaj është kyçur për shkak të një numri të tepruar përpjekjesh të pasuksesshme për hyrje.",
          "subject": "Udhëzime shkyçjeje",
          "unlock_link": "Zhblloko llogarinë time",
          "unlock_link_msg": "Klikoni lidhjen më poshtë për të zhbllokuar llogarinë tuaj:"
        }
      },
      "omniauth_callbacks": {
        "failure": "S’u bë dot mirëfilltësimi për ju prej %{kind} për shkak se \"%{reason}\".",
        "success": "U bë mirëfilltësim me sukses prej llogarisë %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Ndryshoje fjalëkalimin tim",
          "change_your_password": "Ndryshoni fjalëkalimin tuaj",
          "confirm_new_password": "Ripohoni fjalëkalimin e ri",
          "new_password": "Fjalëkalimi i ri"
        },
        "new": {
          "forgot_your_password": "Harruat fjalëkalimin tuaj?",
          "send_me_reset_password_instructions": "Dërgomëni udhëzime ricaktimi fjalëkalimi"
        },
        "no_token": "S’mund të hyni në këtë faqe pa ardhur prej një email-i ricaktimi fjalëkalimi. Nëse po vini prej një email-i ricaktimi fjalëkalimi, ju lutemi, sigurohuni se keni përdorur URL e plotë të furnizuar.",
        "send_instructions": "Pas pak minutash do të merrni një email me udhëzime se si të ricaktoni fjalëkalimin tuaj.",
        "send_paranoid_instructions": "Nëse adresa juaj email gjendet në bazën tonë të të dhënave, pas pak minutash në të do të merrni një lidhje rimarrjeje fjalëkalimi.",
        "updated": "Fjalëkalimi juaj u ndryshua me sukses. Tani jeni i futur.",
        "updated_not_active": "Fjalëkalimi juaj u ndryshua me sukses."
      },
      "registrations": {
        "destroyed": "Shëndet! Llogaria juaj u fshi me sukses. Shpresojmë t’ju shohim sërish së shpejti.",
        "edit": {
          "are_you_sure": "Jeni i sigurt?",
          "cancel_my_account": "Fshijeni llogarinë time",
          "currently_waiting_confirmation_for_email": "Në pritje të ripohimit për: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lëreni të zbrazët nëse s’doni të ndryshohet",
          "title": "Përpunoni %{resource}",
          "unhappy": "I pakënaqur?",
          "update": "Përditësoje",
          "we_need_your_current_password_to_confirm_your_changes": "na duhet fjalëkalimi juaj i tanishëm që të ripohohen ndryshimet tuaja"
        },
        "new": {
          "sign_up": "Regjistrohuni"
        },
        "signed_up": "Mirë se vini! U regjistruat me sukses.",
        "signed_up_but_inactive": "U regjistruat me sukses. Por s’ju futëm dot në llogarinë tuaj, ngaqë ajo s’është ende e aktivizuar.",
        "signed_up_but_locked": "U regjistruat me sukses. Por s’ju futëm dot në llogarinë tuaj, ngaqë ajo është e kyçur.",
        "signed_up_but_unconfirmed": "Te adresa juaj email është dërguar një mesazh me një lidhje ripohimi. Që të aktivizoni llogarinë tuaj, ju lutemi, ndiqni lidhjen.",
        "update_needs_confirmation": "E përditësuat me sukses llogarinë tuaj, por na duhet të verifikojmë adresën tuaj të re email. Ju lutemi, për të ripohuar adresën tuaj të re email, shihni te email-et tuaj dhe ndiqni lidhjen e ripohimit.",
        "updated": "Llogaria juaj u përditësua me sukses.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Dolët me sukses.",
        "new": {
          "sign_in": "Hyni"
        },
        "signed_in": "Hytë me sukses.",
        "signed_out": "Dolët me sukses."
      },
      "shared": {
        "links": {
          "back": "Mbrapsht",
          "didn_t_receive_confirmation_instructions": "Nuk i morët udhëzimet për ripohim?",
          "didn_t_receive_unlock_instructions": "Nuk i morët udhëzimet për shkyçje?",
          "forgot_your_password": "Harruat fjalëkalimin tuaj?",
          "sign_in": "Hyni",
          "sign_in_with_provider": "Hyni me %{provider}",
          "sign_up": "Regjistrohuni"
        },
        "minimum_password_length": {
          "one": "(%{count} shenjë e pakta)",
          "other": "(%{count} shenja e pakta)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Ridërgo udhëzime shkyçjeje"
        },
        "send_instructions": "Pas pak minutash do të merrni një email me udhëzime se si të shkyçni llogarinë tuaj.",
        "send_paranoid_instructions": "Nëse llogaria juaj ekziston, pas pak minutash do të merrni një email me udhëzime se si ta shkyçni.",
        "unlocked": "Llogaria juaj u shkyç me sukses. Ju lutemi, që të vazhdohet, bëni hyrjen."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Nuk lejohet shkuarja tek URL-ja '%{redirect_url}'."
      },
      "passwords": {
        "missing_email": "Ju duhet të jepni një email adresë.",
        "missing_passwords": "Ju duhet t'i mbushni fushat e etiketuara si 'Fjalëkalimi' dhe 'Konfirmo fjalëkalimin'.",
        "missing_redirect_url": "Mungon URL-ja për ridërgim.",
        "not_allowed_redirect_url": "Nuk lejohet shkuarja tek URL-ja '%{redirect_url}'.",
        "password_not_required": "Kjo llogari nuk kërkon fjalëkalim. Në vend të fjalëkalimit, përdorni llogarinë '%{provider}'.",
        "sended": "Një email është dërguar tek email adresa '%{email}' që përmban udhëzime për rikthim të fjalëkalimit tuaj.",
        "successfully_updated": "Fjalëkalimi juaj është ndryshuar me sukses.",
        "user_not_found": "Nuk u gjet përdoruesi me email adresën '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Nuk u gjet llogaria për fshirje.",
        "account_with_uid_destroyed": "Llogaria me UID-në '%{uid}' është fshirë.",
        "email_already_exists": "Një llogari është regjistruar më parë me adresën '%{email}'",
        "missing_confirm_success_url": "Mungon parametri 'confirm_success_url'.",
        "redirect_url_not_allowed": "Nuk lejohet shkuarja tek adresa '%{redirect_url}'.",
        "user_not_found": "Përdoruesi nuk u gjet."
      },
      "sessions": {
        "bad_credentials": "Kredencialet e qasjes nuk janë në rregull. Ju lutemi, provoni përsëri.",
        "not_confirmed": "Një email konfirmues është dërguar tek llogaria juaj '%{email}'. Ju duhet të ndiqni udhëzimet në email përpara se të bëhet aktivizimi i llogarisë tuaj.",
        "not_supported": "Përdorni POST/sign_in për t'u kyçur. GET nuk lejohet në këtë rast.",
        "user_not_found": "Përdoruesi nuk u gjet ose nuk është i kyçur."
      },
      "token_validations": {
        "invalid": "Kredencialet për kyçje nuk janë në rregull."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "duhet pranuar",
        "already_confirmed": "qe ripohuar tashmë, ju lutemi, provoni të bëni hyrjen",
        "blank": "s’mund të jetë i zbrazët",
        "confirmation": "s’përputhet me %{attribute}",
        "confirmation_period_expired": "lypset të ripohohet brenda %{period}, ju lutemi kërkoni një të ri",
        "empty": "s’mund të jetë i zbrazët",
        "equal_to": "duhet të jetë baras me %{count}",
        "even": "duhet të jetë çift",
        "exclusion": "është i rezervuar",
        "expired": "ka skaduar, ju lutemi kërkoni një të ri",
        "greater_than": "duhet të jetë më i madh se %{count}",
        "greater_than_or_equal_to": "duhet të jetë më i madh ose i barabartë me %{count}",
        "inclusion": "s’përfshihet te lista",
        "invalid": "është i pavlefshëm",
        "less_than": "duhet të jetë më i vogël se %{count}",
        "less_than_or_equal_to": "duhet të jetë më i vogël ose i barabartë me %{count}",
        "model_invalid": "Vlerësimi dështoi: %{errors}",
        "not_a_number": "s’është numër",
        "not_an_integer": "duhet të jetë numër i plotë",
        "not_email": "nuk është email",
        "not_found": "s’u gjet",
        "not_locked": "s’qe e kyçur",
        "not_saved": {
          "one": "Ruajtja e këtij %{resource} u pengua nga 1 gabim:",
          "other": "Ruajtja e këtij %{resource} u pengua nga %{count} gabime:"
        },
        "odd": "duhet të jetë tek",
        "other_than": "duhet të jetë më shumë se %{count}",
        "present": "duhet të jetë e zbrazët",
        "required": "duhet të ekzistojë",
        "taken": "është zënë tashmë",
        "too_long": {
          "one": "është shumë i gjatë (maksimumi është %{count} shenjë)",
          "other": "është shumë i gjatë (maksimumi është %{count} shenja)"
        },
        "too_short": {
          "one": "është shumë i shkurtër (minimumi është %{count} shenjë)",
          "other": "është shumë i shkurtër (minimumi është %{count} shenja)"
        },
        "validate_account_update_params": "Ju lutemi, dërgoni të dhëna të duhura për ndryshim në trupin e kërkesës.",
        "validate_sign_up_params": "Ju lutemi, dërgoni të dhëna të duhura në trupin e kërkesës.",
        "wrong_length": {
          "one": "ka gjatësi të gabuar (duhet të jetë %{count} shenjë)",
          "other": "ka gjatësi të gabuar (duhet të jetë %{count} shenja)"
        }
      },
      "template": {
        "body": "Pati probleme me fushat vijuese:",
        "header": {
          "one": "Ruajtja e këtij %{model} u pengua nga %{count} gabim",
          "other": "Ruajtja e këtij %{model} u pengua nga %{count} gabime"
        }
      }
    },
    "hello": "tungjatjeta",
    "helpers": {
      "select": {
        "prompt": "Ju lutemi, përzgjidhni"
      },
      "submit": {
        "create": "Krijoje %{model}",
        "submit": "Ruaje %{model}",
        "update": "Përditësoje %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miliard",
            "million": "Milion",
            "quadrillion": "Kuadrilion",
            "thousand": "Mijë",
            "trillion": "Trilion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Bajt",
              "other": "Bajte"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", dhe ",
        "two_words_connector": " dhe ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "welcome": "mirësevini"
  },
  "sr": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Potvrda poslata u",
          "confirmation_token": "Kod za potvrđivanje",
          "confirmed_at": "Potvrđen u",
          "created_at": "Napravljen u",
          "current_password": "Trenutna lozinka",
          "current_sign_in_at": "Trenutno prijavljen u",
          "current_sign_in_ip": "Trenutno prijavljen sa IP",
          "email": "E-pošta",
          "encrypted_password": "Šifrovana lozinka",
          "failed_attempts": "Neuspeli pokušaji",
          "last_sign_in_at": "Poslednje prijavljivanje u",
          "last_sign_in_ip": "Poslednje prijavljivanje sa IP",
          "locked_at": "Zaključano u",
          "password": "Lozinka",
          "password_confirmation": "Potvrda lozinke",
          "remember_created_at": "Zapamti kreiran u",
          "remember_me": "Zapamti me",
          "reset_password_sent_at": "Obnova lozinke poslata u",
          "reset_password_token": "Kod za obnovu lozinke",
          "sign_in_count": "Broj prijavljivanja",
          "unconfirmed_email": "Nepotvrdjena adresa e-pošte",
          "unlock_token": "Kod za otključavanje",
          "updated_at": "Izmenjeno u"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Валидација није успела: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Није могуће обрисати запис јер постоје зависни %{record}",
            "has_one": "Није могуће обрисати запис јер постоји зависан %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": "Korisnika",
          "one": "Korisnik",
          "other": "Korisnika"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Нед",
        "Пон",
        "Уто",
        "Сре",
        "Чет",
        "Пет",
        "Суб"
      ],
      "abbr_month_names": [
        null,
        "Јан",
        "Феб",
        "Мар",
        "Апр",
        "Мај",
        "Јун",
        "Јул",
        "Авг",
        "Сеп",
        "Окт",
        "Нов",
        "Дец"
      ],
      "day_names": [
        "Недеља",
        "Понедељак",
        "Уторак",
        "Среда",
        "Четвртак",
        "Петак",
        "Субота"
      ],
      "formats": {
        "default": "%d. %m. %Y",
        "long": "%-d. %B %Y",
        "short": "%-d. %b"
      },
      "month_names": [
        null,
        "Јануар",
        "Фебруар",
        "Март",
        "Април",
        "Мај",
        "Јун",
        "Јул",
        "Август",
        "Септембар",
        "Октобар",
        "Новембар",
        "Децембар"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "око %{count} сата",
          "many": "око %{count} сати",
          "one": "око %{count} сат",
          "other": "око %{count} сати"
        },
        "about_x_months": {
          "few": "око %{count} месеца",
          "many": "око %{count} месеци",
          "one": "око %{count} месец",
          "other": "око %{count} месеци"
        },
        "about_x_years": {
          "few": "око %{count} године",
          "many": "око %{count} година",
          "one": "око %{count} године",
          "other": "око %{count} година"
        },
        "almost_x_years": {
          "few": "скоро %{count} године",
          "many": "скоро %{count} година",
          "one": "скоро %{count} година",
          "other": "скоро %{count} година"
        },
        "half_a_minute": "пола минуте",
        "less_than_x_minutes": {
          "few": "мање од %{count} минута",
          "many": "мање од %{count} минута",
          "one": "мање од %{count} минут",
          "other": "мање од %{count} минута"
        },
        "less_than_x_seconds": {
          "few": "мање од %{count} секунде",
          "many": "мање од %{count} секунди",
          "one": "мање од %{count} секунд",
          "other": "мање од %{count} секунди"
        },
        "over_x_years": {
          "few": "преко %{count} године",
          "many": "преко %{count} година",
          "one": "преко %{count} године",
          "other": "преко %{count} година"
        },
        "x_days": {
          "few": "%{count} дана",
          "many": "%{count} дана",
          "one": "%{count} дан",
          "other": "%{count} дана"
        },
        "x_minutes": {
          "few": "%{count} минута",
          "many": "%{count} минута",
          "one": "%{count} минут",
          "other": "%{count} минута"
        },
        "x_months": {
          "few": "%{count} месеца",
          "many": "%{count} месеци",
          "one": "%{count} месец",
          "other": "%{count} месеци"
        },
        "x_seconds": {
          "few": "%{count} секунде",
          "many": "%{count} секунди",
          "one": "%{count} секунда",
          "other": "%{count} секунди"
        }
      },
      "prompts": {
        "day": "Дан",
        "hour": "Сат",
        "minute": "Минут",
        "month": "Месец",
        "second": "Секунд",
        "year": "Година"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Vaš nalog je uspešno potvrđen. Sada ste prijavljeni.",
        "new": {
          "resend_confirmation_instructions": null
        },
        "send_instructions": "U roku od nekoliko minuta primićete ePoruku sa uputstvom za potvrdu Vašeg naloga.",
        "send_paranoid_instructions": "Ukoliko se Vaša adresa ePošte nalazi u našoj bazi u roku od nekoliko minuta primićete ePoruku sa uputstvom kako potvrditi Vaš nalog."
      },
      "failure": {
        "already_authenticated": "Već ste prijavljeni.",
        "inactive": "Vaš nalog još nije aktiviran.",
        "invalid": null,
        "last_attempt": "Imate još jedan pokušaj pre nego što Vaš nalog bude zaključan.",
        "locked": "Vaš nalog je zaključan.",
        "not_found_in_database": null,
        "timeout": "Vreme trajanja Vaše sesije je isteklo. Za nastavak prijavite se ponovo.",
        "unauthenticated": "Za nastavak se morate prijaviti ili registrovati.",
        "unconfirmed": "Pre nastavka morate potvrditi svoj nalog."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potvrdi moj malog",
          "greeting": "Dobrodošli %{recipient}!",
          "instruction": "Možete potvrditi adresu e-pošte za vaš nalog na linku ispod:",
          "subject": "Uputstvo za potvrdu"
        },
        "email_changed": {
          "greeting": "Zdravo %{recipient}!",
          "message": "Obaveštavamo vas da je vaša adresa e-pošte promenjena u %{email}.",
          "message_unconfirmed": "Obaveštavamo vas da je vaša adresa e-pošte promenjena u %{email}.",
          "subject": "Promenjena adresa e-pošte"
        },
        "password_change": {
          "greeting": "Zdravo %{recipient}!",
          "message": "Obaveštavamo vas da je vaša lozinka promenjena.",
          "subject": "Lozinka promenjena"
        },
        "reset_password_instructions": {
          "action": "Promeni moju lozinku",
          "greeting": "Zdravo %{recipient}!",
          "instruction": "Neko je zatražio link za promenu vaše lozinke. To možete učiniti na linku ispod.",
          "instruction_2": "Ukoliko niste vi ovo zatražili, molim vas ignorišite ovu e-poruku.",
          "instruction_3": "Vaša lozinka neće biti promenjena dok ne pristupite linku iznad i napravite novu.",
          "subject": "Uputstvo za promenu lozinke"
        },
        "unlock_instructions": {
          "action": "Otključaj moj nalog",
          "greeting": "Zdravo %{recipient}!",
          "instruction": "Klikni na link ispod za otključavanje svog naloga:",
          "message": null,
          "subject": "Uputstvo za otključavanje korisničkog naloga"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nismo u mogućnosti autorizovati Vas sa %{kind} nalogom zbog \"%{reason}\".",
        "success": "Uspešna autorizacija sa %{kind} naloga."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Izmeni moju lozinku",
          "change_your_password": "Izmeni tvoju lozinku",
          "confirm_new_password": "Potvrdi novu lozinku",
          "new_password": "Nova lozinka"
        },
        "new": {
          "forgot_your_password": "Zaboravljena lozinka?",
          "send_me_reset_password_instructions": null
        },
        "no_token": "Ne možete pristupiti ovoj stranici ako niste škljocnuli na vezu u ePoruci za resetovanje lozinke.",
        "send_instructions": "U roku od nekoliko minuta primitićete ePoruku sa uputstvom za promenu Vaše lozinke.",
        "send_paranoid_instructions": "Ukoliko se Vaša adresa ePošte nalazi u našoj bazi, na istu ćete u roku od nekoliko minuta primiti link za resetovanje lozinke.",
        "updated": "Vaša lozinka je uspešno promenjena. Sada ste prijavljeni.",
        "updated_not_active": "Vaša lozinka je uspešno promenjena."
      },
      "registrations": {
        "destroyed": "Pozdrav! Vaš nalog je uspešno obrisan. Nadamo se da ćete se uskoro vratiti.",
        "edit": {
          "are_you_sure": "Da li ste sigurni?",
          "cancel_my_account": "Otkaži moj nalog",
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": null,
          "title": null,
          "unhappy": "Nezadovoljni?",
          "update": "Izmeni",
          "we_need_your_current_password_to_confirm_your_changes": null
        },
        "new": {
          "sign_up": "Registruj se"
        },
        "signed_up": "Dobrodošli! Uspešno ste se registrovali.",
        "signed_up_but_inactive": "Uspešno ste se registrovali. Doduše, ne možete se prijaviti na sistem zato što Vaš nalog još nije aktiviran.",
        "signed_up_but_locked": "Uspešno ste se registrovali. Nažalost ne možete se prijaviti jer Vam je nalog zaključan.",
        "signed_up_but_unconfirmed": "Poruka s linkom za potvrdu je poslata na Vašu adresu ePošte. Kliknite na vezu da aktivirate svoj nalog.",
        "update_needs_confirmation": "Uspešno ste ažurirali svoj nalog, ali trebamo potvrditi Vašu adresu ePošte. Proverite svoje sanduče sa porukama i kliknite na vezu za potvrdu.",
        "updated": "Uspešno ste izmenili svoj nalog.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": null,
        "new": {
          "sign_in": "Prijavi se"
        },
        "signed_in": "Uspešno ste se prijavili.",
        "signed_out": "Uspešno ste se odjavili."
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": null,
          "didn_t_receive_unlock_instructions": null,
          "forgot_your_password": null,
          "sign_in": "Prijavi se",
          "sign_in_with_provider": null,
          "sign_up": null
        },
        "minimum_password_length": {
          "few": null,
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": null
        },
        "send_instructions": "U roku od nekoliko minuta ćete primiti ePoruku sa uputstvom za otključavanje Vašeg naloga.",
        "send_paranoid_instructions": "Ako Vaš nalog postoji, na adresu svoje ePošte ćete u roku od nekoliko minuta primiti uputstvo kako ga otključati.",
        "unlocked": "Vaš nalog je uspešno otključan. Sada se možete prijaviti."
      }
    },
    "errors": {
      "format": "Поље %{attribute} %{message}",
      "messages": {
        "accepted": "мора бити прихваћено",
        "already_confirmed": "je već potvrđen, molimo pokušajte se prijaviti",
        "blank": "не сме бити празано",
        "confirmation": "се не слаже са потврдом",
        "confirmation_period_expired": "je trebao biti potvrđen tokom perioda %{period}, molim zatražite novi",
        "empty": "не сме бити празано",
        "equal_to": "мора бити једнако %{count}",
        "even": "мора бити парно",
        "exclusion": "је резервисано",
        "expired": "je istekao, molim zatražite novi",
        "greater_than": "мора бити веће од %{count}",
        "greater_than_or_equal_to": "мора бити веће или једнако %{count}",
        "inclusion": "није у листи",
        "invalid": "није исправно",
        "less_than": "мора бити мање од %{count}",
        "less_than_or_equal_to": "мора бити мање или једнако %{count}",
        "model_invalid": "Валидација није успела: %{errors}",
        "not_a_number": "није број",
        "not_an_integer": "није цео број",
        "not_found": "nije pronađeno",
        "not_locked": "nije zaključan",
        "not_saved": {
          "few": "%{count} greške sprečavaju snimanje %{resource}:",
          "one": "1 greška sprečava snimanje %{resource}:",
          "other": "%{count} grešaka sprečavaju snimanje %{resource}:"
        },
        "odd": "мора бити непарно",
        "other_than": "мора бити различито од %{count}",
        "present": "мора бити празно",
        "required": "мора постојати",
        "taken": "је већ заузето",
        "too_long": {
          "few": "је предугачко (максимум је %{count} знака)",
          "many": "је предугачко (максимум је %{count} знакова)",
          "one": "је предугачко (максимум је %{count} знак)",
          "other": "је предугачко (максимум је %{count} знакова)"
        },
        "too_short": {
          "few": "је прекратко (минимум је %{count} знака)",
          "many": "је прекратко (минимум је %{count} знакова)",
          "one": "је прекратко (минимум је %{count} знак)",
          "other": "је прекратко (минимум је %{count} знакова)"
        },
        "wrong_length": {
          "few": "није одговарајуће дужине (треба бити %{count} знака)",
          "many": "није одговарајуће дужине (треба бити %{count} знакова)",
          "one": "није одговарајуће дужине (треба бити %{count} знак)",
          "other": "није одговарајуће дужине (треба бити %{count} знакова)"
        }
      },
      "template": {
        "body": "Молим Вас да проверите следећа поља:",
        "header": {
          "few": "Нисам успео сачувати %{model}: %{count} грешке.",
          "many": "Нисам успео сачувати %{model}: %{count} грешки.",
          "one": "Нисам успео сачувати %{model}: %{count} грешка.",
          "other": "Нисам успео сачувати %{model}: %{count} грешки."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Изаберите"
      },
      "submit": {
        "create": "Направи %{model}",
        "submit": "Сачувај %{model}",
        "update": "Измени %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "РСД"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "милијарде",
              "many": "милијарди",
              "one": "милијарда",
              "other": "милијарди"
            },
            "million": {
              "few": "милиона",
              "many": "милиона",
              "one": "милион",
              "other": "милиона"
            },
            "quadrillion": {
              "few": "квадрилиона",
              "many": "квадрилиона",
              "one": "квадрилион",
              "other": "квадрилиона"
            },
            "thousand": {
              "few": "хиљаде",
              "many": "хиљада",
              "one": "хиљада",
              "other": "хиљада"
            },
            "trillion": {
              "few": "трилиона",
              "many": "трилиона",
              "one": "трилион",
              "other": "трилиона"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "бајта",
              "many": "бајтова",
              "one": "бајт",
              "other": "бајтова"
            },
            "gb": "ГБ",
            "kb": "КБ",
            "mb": "МБ",
            "tb": "ТБ"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", и ",
        "two_words_connector": " и ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "АМ",
      "formats": {
        "default": "%a %d %b %Y %H:%M:%S %Z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "ПМ"
    }
  },
  "sr-RS": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Потврда послата у",
          "confirmation_token": "Код за потврђивање",
          "confirmed_at": "Потврђен у",
          "created_at": "Направљен у",
          "current_password": "Тренутна лозинка",
          "current_sign_in_at": "Тренутно пријављен у",
          "current_sign_in_ip": "Тренутно пријављен са ИП",
          "email": "Е-пошта",
          "encrypted_password": "Шифрована лозинка",
          "failed_attempts": "Неуспешних покушаја",
          "last_sign_in_at": "Последње пријављивање у",
          "last_sign_in_ip": "Последње пријављивање са ИП",
          "locked_at": "Закључан у",
          "password": "Лозинка",
          "password_confirmation": "Потврда лозинке",
          "remember_created_at": "Запамти направљен у",
          "remember_me": "Запамти ме",
          "reset_password_sent_at": "Обнова лозинке послата у",
          "reset_password_token": "Код за обнову лозинке",
          "sign_in_count": "Број пријављивања",
          "unconfirmed_email": "Непотврђена адреса е-поште",
          "unlock_token": "Код за откључавање",
          "updated_at": "Измењено у"
        }
      },
      "models": {
        "user": {
          "few": "Корисника",
          "one": "Корисник",
          "other": "Корисника"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ваш налог је успешно потврђен. Сада сте пријављени.",
        "new": {
          "resend_confirmation_instructions": "Упутство за обнову лозинке"
        },
        "send_instructions": "За неколико минута примићете е-поруку са упутством за потврду вашег налога.",
        "send_paranoid_instructions": "Уколико се ваша адреса е-поште налази у нашој бази, за неколико минута примићете е-поруку са упутством како да потврдите ваш налог."
      },
      "failure": {
        "already_authenticated": "Већ сте пријављени.",
        "inactive": "Ваш налог још није активиран.",
        "invalid": "Неисправни %{authentication_keys} или лозинка.",
        "last_attempt": "Имате још један покушај пре него што Ваш налог буде закључан.",
        "locked": "Ваш налог је закључан.",
        "not_found_in_database": "Неисправни %{authentication_keys} или лозинка.",
        "timeout": "Време трајања ваше сесије је истекло. За наставак пријавите се поново.",
        "unauthenticated": "За наставак се морате пријавити или регистровати.",
        "unconfirmed": "Пре наставка морате потврдити адресу своје е-поште."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Потврди мој налог",
          "greeting": "Добродошао %{recipient}!",
          "instruction": "Можете потврдити адресу е-поште за ваш налог на линку испод:",
          "subject": "Упутство за потврду"
        },
        "email_changed": {
          "greeting": "Здраво %{recipient}!",
          "message": "Обавештавамо вас да је ваша адреса е-поште промењена у %{email}.",
          "message_unconfirmed": "Обавештавамо вас да је ваша адреса е-поште промењена у %{email}.",
          "subject": "Промењена адреса е-поште"
        },
        "password_change": {
          "greeting": "Здраво %{recipient}!",
          "message": "Обавештавамо вас да је ваша лозинка промењена.",
          "subject": "Лозинка промењена"
        },
        "reset_password_instructions": {
          "action": "Промени моју лозинку",
          "greeting": "Здраво %{recipient}!",
          "instruction": "Неко је затражио линк за промену ваше лозинке. То можете учинити на линку испод.",
          "instruction_2": "Уколико нисте ви ово затражили, молим вас игноришите ову е-поруку.",
          "instruction_3": "Ваша лозинка неће бити промењена док не приступите линку изнад и направите нову.",
          "subject": "Упутство за промену лозинке"
        },
        "unlock_instructions": {
          "action": "Откључај мој налог",
          "greeting": "Здраво %{recipient}!",
          "instruction": "Кликни на линк испод за откључавање свог налога:",
          "message": "Ваш налог је закључан због већег броја покушаја неуспешног пријављивања.",
          "subject": "Упутство за откључавање"
        }
      },
      "omniauth_callbacks": {
        "failure": "Нисмо у могућности ауторизовати Вас са %{kind} налогом због \"%{reason}\".",
        "success": "Успешна ауторизација са %{kind} налога."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Промени моју лозинку",
          "change_your_password": "Промени твоју лозинку",
          "confirm_new_password": "Потврди нову лозинку",
          "new_password": "Нова лозинка"
        },
        "new": {
          "forgot_your_password": "Заборављена лозинка?",
          "send_me_reset_password_instructions": "Пошаљи ми упутство за обнову лозинке"
        },
        "no_token": "Не можете приступити овој страници ако нисте дошли кликом на линк у е-поруци за ресетовање лозинке. Уколико ипак долазите из е-поруке за ресетовање лозинке, проверите да ли користите комплетну приложену URL адресу.",
        "send_instructions": "За неколико минута примићете е-поруку са упутством за промену ваше лозинке.",
        "send_paranoid_instructions": "Уколико се ваша адреса е-поште налази у нашој бази, на исту ћете за неколико минута примити линк за ресетовање лозинке.",
        "updated": "Ваша лозинка је успешно промењена. Сада сте пријављени.",
        "updated_not_active": "Ваша лозинка је успешно промењена."
      },
      "registrations": {
        "destroyed": "Поздрав! Ваш налог је успешно обрисан. Надамо се да ћете се ускоро вратити.",
        "edit": {
          "are_you_sure": "Да ли сте сигурни?",
          "cancel_my_account": "Откажи мој налог",
          "currently_waiting_confirmation_for_email": "Тренутно се чека потврда за: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "оставити празно ако се не мења",
          "title": "Измена %{resource}",
          "unhappy": "Незадовољни?",
          "update": "Измена",
          "we_need_your_current_password_to_confirm_your_changes": "потребна је ваша лозинка за потврду измена"
        },
        "new": {
          "sign_up": "Регистрација"
        },
        "signed_up": "Добродошли! Успешно сте се регистровали.",
        "signed_up_but_inactive": "Успешно сте се регистровали. Додуше, не можете се пријавити на систем зато што Ваш налог још није активиран.",
        "signed_up_but_locked": "Успешно сте се регистровали. Нажалост не можете се пријавити јер Вам је налог закључан.",
        "signed_up_but_unconfirmed": "Порука с линком за потврду је послата на вашу адресу е-поште. Кликните на везу да активирате свој налог.",
        "update_needs_confirmation": "Успешно сте ажурирали свој налог, али требамо још потврдити вашу адресу е-поште. Проверите своје сандуче са порукама и кликните на везу за потврду нове адресе е-поште.",
        "updated": "Успешно сте изменили свој налог.",
        "updated_but_not_signed_in": "Ваш налог је успешно измењен али обзиром да је ваша лозинка промењена, морате се поново пријавити."
      },
      "sessions": {
        "already_signed_out": "Успешно сте се одјавили.",
        "new": {
          "sign_in": "Пријави се"
        },
        "signed_in": "Успешно сте се пријавили.",
        "signed_out": "Успешно сте се одјавили."
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Нисте примили упутство за потврђивање?",
          "didn_t_receive_unlock_instructions": "Нисте примили упутство за откључавање?",
          "forgot_your_password": "Заборављена лозинка?",
          "sign_in": "Пријави се",
          "sign_in_with_provider": "Пријављивање са %{provider}",
          "sign_up": "Регистуј се"
        },
        "minimum_password_length": {
          "few": "(%{count} знака минимум)",
          "one": "(%{count} знак минимум)",
          "other": "(%{count} знакова минимум)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Пошаљи упутство за откључавање."
        },
        "send_instructions": "За неколико минута ћете примити е-поруку са упутством за откључавање вашег налога.",
        "send_paranoid_instructions": "Ако ваш налог постоји, на адресу ваше е-поште ћете за неколико минута примити упутство за откључавање.",
        "unlocked": "Ваш налог је успешно откључан. Сада се можете пријавити."
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "је већ потврђен, молимо покушајте се пријавити",
        "confirmation_period_expired": "је требао бити потврђен током периода %{period}, молим тражите нови",
        "expired": "је истекао, молим затражите нови",
        "not_found": "није пронађено",
        "not_locked": "није закључан",
        "not_saved": {
          "few": "%{count} грешке спречавају снимање %{resource}:",
          "one": "1 грешка спречава снимање %{resource}:",
          "other": "%{count} грешака спречавају снимање %{resource}:"
        }
      }
    }
  },
  "st": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Netefatso e fosahetse: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "E ka se hlakolehe hobane kamano tse ngata li teng le %{record}",
            "has_one": "E ka se hlakolehe hobane kamano e le ٰngoe teng le %{record}"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Son",
        "ٰMan",
        "Labob",
        "Labor",
        "Labon",
        "Laboh",
        "Moq"
      ],
      "abbr_month_names": [
        null,
        "Phe",
        "Hlako",
        "Tlha",
        "ٰMes",
        "Motš",
        "Phupt",
        "Phup",
        "Pha",
        "Loe",
        "Mph",
        "Pul",
        "Tši"
      ],
      "day_names": [
        "Sontaha",
        "ٰMantaha",
        "Labobeli",
        "Laboraro",
        "Labone",
        "Labohlano",
        "Moqebelo"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Pherekhong",
        "Hlakola",
        "Hlakubele",
        "ٰMesa",
        "Motšeanong",
        "Phuptjane",
        "Phupu",
        "Phato",
        "Loetse",
        "Mphalane",
        "Pulungoana",
        "Tšitoe"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ekaba hora e le ٰngoe",
          "other": "ekaba hora tse %{count}"
        },
        "about_x_months": {
          "one": "ekaba khoeli e le ٰngoe",
          "other": "ekaba likhoeli tse %{count}"
        },
        "about_x_years": {
          "one": "ekaba selemo se le seng",
          "other": "ekaba lilemo tse %{count}"
        },
        "almost_x_years": {
          "one": "e tlo ba selemo se le seng",
          "other": "e tlo ba lilemo tse %{count}"
        },
        "half_a_minute": "halofo ea motsotso",
        "less_than_x_minutes": {
          "one": "ka tlase ho motsotso",
          "other": "ka tlase ho metsotso e %{count}"
        },
        "less_than_x_seconds": {
          "one": "ka tlase ho motsotsoana",
          "other": "ka tlase ho metsotsoana e %{count}"
        },
        "over_x_years": {
          "one": "ka holimo ho selemo",
          "other": "ka holimo ho lilemo tse %{count}"
        },
        "x_days": {
          "one": "letsatsi le le leng",
          "other": "matsatsi a %{count}"
        },
        "x_minutes": {
          "one": "motsotso o le mong",
          "other": "metsotso e %{count}"
        },
        "x_months": {
          "one": "khoeli e le \\'ngoe",
          "other": "likhoeli tse %{count}"
        },
        "x_seconds": {
          "one": "motsotsoana o le mong",
          "other": "metsotsoana e %{count}"
        },
        "x_years": {
          "one": "selemo se le seng",
          "other": "lilemo tse %{count}"
        }
      },
      "prompts": {
        "day": "Letsatsi",
        "hour": "Hora",
        "minute": "Motsotso",
        "month": "Khoeli",
        "second": "Motsotsoana",
        "year": "Selemo"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "e tlameha ho amoheloa",
        "blank": "e ka se be letho",
        "confirmation": "ha e lumellane le %{attribute}",
        "empty": "e ka se be letho",
        "equal_to": "e tlameha ho lekana le %{count}",
        "even": "e tlameha ho lekana",
        "exclusion": "e bolokiloe",
        "greater_than": "e tlameha e be kholo ho %{count}",
        "greater_than_or_equal_to": "e tlameha e be kholo kapa e lekane le %{count}",
        "inclusion": "ha ea kenyelletsoa lenaneng",
        "invalid": "ha e sebetse",
        "less_than": "e tlameha e be nyane ho %{count}",
        "less_than_or_equal_to": "e tlameha e be nyane kapa e lekane le %{count}",
        "model_invalid": "Liphoso tsa netefatso: %{errors}",
        "not_a_number": "ha se palo",
        "not_an_integer": "e tšoanetse e be palo e felletseng",
        "odd": "e tlameha ho makatsa",
        "other_than": "e tlameha e be kholo ho %{count}",
        "present": "e tlameha ebe ha e na letho",
        "required": "e tlameha ho ba teng",
        "taken": "e sentse e nkuoe",
        "too_long": {
          "one": "e telele haholo (boholo ke semelo se le seng)",
          "other": "e telele haholo (boholo ke limelo tse %{count})"
        },
        "too_short": {
          "one": "e khutšoane haholo (bonyane ke semelo se le seng)",
          "other": "e khutšoane haholo (bonyane ke limelo tse %{count})"
        },
        "wrong_length": {
          "one": "ke bolelele bo fosahetseng (e tšoanetse e be semelo se le seng)",
          "other": "ke bolelele bo fosahetseng (e tšoanetse e be limelo tse %{count})"
        }
      },
      "template": {
        "body": "Ho bile le mathata ka a itseng makaleng a latelang:",
        "header": {
          "one": "phoso e le ٰngoe e thibetse  %{model} ho bolokeha",
          "other": "liphoso tse %{count} li thibetse %{model} ho bolokeha"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Khetha ka kopo"
      },
      "submit": {
        "create": "Bopa %{model}",
        "submit": "Boloka %{model}",
        "update": "Ntjhafatsa %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "M"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Bilione",
            "million": "Milione",
            "quadrillion": "Libilione tse likete",
            "thousand": "Sekete",
            "trillion": "Trilione",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", le ",
        "two_words_connector": " le ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "sv": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Bekräftelse skickad",
          "confirmation_token": "Bekräftelse-token",
          "confirmed_at": "Bekräftat",
          "created_at": "Skapad",
          "current_password": "Nuvarande lösenord",
          "current_sign_in_at": "Nuvarande inloggning vid",
          "current_sign_in_ip": "Nuvarande inloggnings-IP",
          "email": "E-post",
          "encrypted_password": "Krypterat lösenord",
          "failed_attempts": "Misslyckade försök",
          "last_sign_in_at": "Senaste inloggning vid",
          "last_sign_in_ip": "Senaste inloggnings-IP",
          "locked_at": "Låst vid",
          "password": "Lösenord",
          "password_confirmation": "Bekräfta lösenord",
          "remember_created_at": "Kom ihåg skapades vid",
          "remember_me": "Kom ihåg mig",
          "reset_password_sent_at": "Återställ lösenord skickat vid",
          "reset_password_token": "Återställ token för lösenord",
          "sign_in_count": "Antal inloggningar",
          "unconfirmed_email": "Obekräftad e-post",
          "unlock_token": "Token för återaktivering",
          "updated_at": "Uppdaterad"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Ett fel uppstod: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan inte ta bort poster då beroende %{record} finns",
            "has_one": "Kan inte ta bort post då beroende %{record} finns"
          }
        }
      },
      "models": {
        "user": {
          "one": "Användare",
          "other": "Användare"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "sön",
        "mån",
        "tis",
        "ons",
        "tor",
        "fre",
        "lör"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "söndag",
        "måndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lördag"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ungefär en timme",
          "other": "ungefär %{count} timmar"
        },
        "about_x_months": {
          "one": "ungefär en månad",
          "other": "ungefär %{count} månader"
        },
        "about_x_years": {
          "one": "ungefär ett år",
          "other": "ungefär %{count} år"
        },
        "almost_x_years": {
          "one": "nästan ett år",
          "other": "nästan %{count} år"
        },
        "half_a_minute": "en halv minut",
        "less_than_x_minutes": {
          "one": "mindre än en minut",
          "other": "mindre än %{count} minuter"
        },
        "less_than_x_seconds": {
          "one": "mindre än en sekund",
          "other": "mindre än %{count} sekunder"
        },
        "over_x_years": {
          "one": "mer än ett år",
          "other": "mer än %{count} år"
        },
        "x_days": {
          "one": "en dag",
          "other": "%{count} dagar"
        },
        "x_minutes": {
          "one": "en minut",
          "other": "%{count} minuter"
        },
        "x_months": {
          "one": "en månad",
          "other": "%{count} månader"
        },
        "x_seconds": {
          "one": "en sekund",
          "other": "%{count} sekunder"
        },
        "x_years": {
          "one": "ett år",
          "other": "%{count} år"
        }
      },
      "prompts": {
        "day": "Dag",
        "hour": "Timme",
        "minute": "Minut",
        "month": "Månad",
        "second": "Sekund",
        "year": "År"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ditt konto har bekräftats. Du är nu inloggad.",
        "new": {
          "resend_confirmation_instructions": "Skicka instruktioner för att bekräfta konto igen"
        },
        "send_instructions": "Du kommer att få epost med instruktioner om hur du kan bekräfta ditt konto inom några minuter.",
        "send_paranoid_instructions": "Om din epostadress finns i vår databas, kommer du att få ett epost-meddelande inom några minuter med instruktioner om hur du ska göra för att aktivera ditt konto igen."
      },
      "failure": {
        "already_authenticated": "Du är redan inloggad.",
        "inactive": "Ditt konto har inte aktiverats ännu.",
        "invalid": "Ogiltig %{authentication_keys} eller lösenord",
        "last_attempt": "Du har ett försök kvar, sen låser vi ditt konto.",
        "locked": "Ditt konto är låst.",
        "not_found_in_database": "Ogiltig %{authentication_keys} eller lösenord",
        "timeout": "Din session är inte längre giltig, vänligen logga in igen för att fortsätta.",
        "unauthenticated": "Du måste logga in eller skapa ett konto innan du kan fortsätta.",
        "unconfirmed": "Du måste bekräfta ditt konto innan du kan fortsätta."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bekräfta mitt konto",
          "confirm_account_link": "Bekräfta mitt konto",
          "confirm_link_msg": "Du kan bekräfta ditt kontos emailadress genom att besöka länken nedan:",
          "greeting": "Välkommen %{recipient}!",
          "instruction": "Du kan bekräfta ditt konto med länken nedan:",
          "subject": "Instruktioner för bekräftning av konto"
        },
        "email_changed": {
          "greeting": "Hej %{recipient}!",
          "message": "Vi kontaktar dig för att meddela att din e-post ändras till %{email}.",
          "message_unconfirmed": null,
          "subject": "E-post ändrades"
        },
        "password_change": {
          "greeting": "Hej %{recipient}!",
          "message": "Vi kontaktar dig för att meddela dig att att ditt lösenord har blivit ändrat.",
          "subject": "Lösenorded uppdaterades"
        },
        "reset_password_instructions": {
          "action": "Byt lösenord",
          "greeting": "Hej %{recipient}!",
          "ignore_mail_msg": "Om du inte begärt detta, vänligen bortse från detta mail.",
          "instruction": "Någon har begärt att ändra ditt lösenord. Du kan göra det genom länken nedan.",
          "instruction_2": "Om ändringen inte begärdes utav dig, var snäll att ignorera detta email.",
          "instruction_3": "Ditt lösenord ändras ej förrän du följer länken ovan och skapar ett nytt lösenord.",
          "no_changes_msg": "Ditt lösenord kommer inte att ändras förrän du använder länken ovan och skapar ett nytt.",
          "password_change_link": "Byt mitt lösenord",
          "request_reset_link_msg": "Någon har begärt en länk för att ändra ditt lösenord. Du kan göra detta via länken nedan.",
          "subject": "Instruktioner för återställning av lösenord"
        },
        "unlock_instructions": {
          "account_lock_msg": "Ditt konto har låsts efter för många misslyckade loginförsök.",
          "action": "Lås upp mitt konto",
          "greeting": "Hej %{recipient}!",
          "instruction": "Följ länken nedan för att låsa upp ditt konto:",
          "message": "Ditt konto har låsts på grund av för många felaktiga inloggningsförsök.",
          "subject": "Instruktioner för upplåsning av konto",
          "unlock_link": "Lås upp mitt konto",
          "unlock_link_msg": "Klicka på länken nedan för att låsa upp ditt konto:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Kunde inte autentisera dig med %{kind} för \"%{reason}\".",
        "success": "Autentiserat med %{kind}-konto."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Ändra mitt lösenord",
          "change_your_password": "Ändra ditt lösenord",
          "confirm_new_password": "Bekräfta nytt lösenord",
          "new_password": "Nytt lösenord"
        },
        "new": {
          "forgot_your_password": "Glömt ditt lösenord?",
          "send_me_reset_password_instructions": "Skicka instruktion för återställning av lösenord"
        },
        "no_token": "Tillgång till den här sidan kräver att du kommer från ett mejl som sätter tillbaka ditt lösenord. Om du kom hit från ett sånt mejl, säkerställ att du har använt hela URL:en.",
        "send_instructions": "Du kommer få epost med instruktioner för hur du kan återställa ditt lösenord inom några minuter.",
        "send_paranoid_instructions": "Om din epostadress finns i vår databas kommer du att få en lösenordslänk skickad till din epost.",
        "updated": "Ditt lösenord har uppdaterats. Du är nu inloggad.",
        "updated_not_active": "Ditt lösenord uppdaterades."
      },
      "registrations": {
        "destroyed": "Hej då! Ditt konto har avregistrerats. Vi hoppas få se dig snart igen.",
        "edit": {
          "are_you_sure": "Är du säker?",
          "cancel_my_account": "Avsluta mitt konto",
          "currently_waiting_confirmation_for_email": "Väntar på bekräftelse för: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "lämna tomt om du inte vill byta det",
          "title": "Ändra %{resource}",
          "unhappy": "Missnöjd",
          "update": "Uppdatera",
          "we_need_your_current_password_to_confirm_your_changes": "vi behöver ditt nuvarande lösenord för att bekräfta dina ändringar"
        },
        "new": {
          "sign_up": "Registrera dig"
        },
        "signed_up": "Välkommen! Ditt nya konto har skapats.",
        "signed_up_but_inactive": "Du är nu registrerad. Däremot kunde vi inte logga in dig, eftersom ditt konto ännu inte aktiverats.",
        "signed_up_but_locked": "Du är nu registrerad. Däremot kunde vi inte logga in dig, eftersom ditt konto är låst.",
        "signed_up_but_unconfirmed": "Ett meddelande med en länk för att bekräfta din registrering har skickats till din epostadress. Följ länken för att aktivera ditt konto.",
        "update_needs_confirmation": "Ditt konto uppdaterades, men vi behöver verifiera din nya epostadress. Kontrollera din epost och klicka på länken för att bekräfta din nya epostadress.",
        "updated": "Ditt konto har uppdaterats.",
        "updated_but_not_signed_in": "Kontot uppdaterades, men eftersom att lösenordet ändrades behöver ni logga in igen"
      },
      "sessions": {
        "already_signed_out": "Du är nu utloggad.",
        "new": {
          "sign_in": "Logga in"
        },
        "signed_in": "Loggade in.",
        "signed_out": "Loggade ut."
      },
      "shared": {
        "links": {
          "back": "Tillbaka",
          "didn_t_receive_confirmation_instructions": "Fick du inga bekräftelseinstruktioner?",
          "didn_t_receive_unlock_instructions": "Fick du inga instruktioner om hur du låser upp ditt konto?",
          "forgot_your_password": "Glömt ditt lösenord?",
          "sign_in": "Logga in",
          "sign_in_with_provider": "Logga in med %{provider}",
          "sign_up": "Registrera dig"
        },
        "minimum_password_length": {
          "one": "(minst %{count} tecken)",
          "other": "(minst %{count} tecken)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Skicka instruktioner för upplåsning av konto igen"
        },
        "send_instructions": "Du kommer få epost med instruktioner om hur du kan låsa upp ditt konto inom några minuter.",
        "send_paranoid_instructions": "Om ditt konto finns, kommer du att få ett email med instruktioner om hur du låser upp det inom några minuter.",
        "unlocked": "Ditt konto har låsts upp. Du är nu inloggad."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Omdirigering till '%{redirect_url}' ej tillåten."
      },
      "passwords": {
        "missing_email": "Du måste ange en emailadress.",
        "missing_passwords": "Du måste fylla i fälten 'Lösenord' och 'Upprepa lösenord'.",
        "missing_redirect_url": "Saknar en omdirigerings-URL.",
        "not_allowed_redirect_url": "Omdirigering till '%{redirect_url}' ej tillåten.",
        "password_not_required": "Det har kontot kräver inget lösenord. Logga in via ditt '%{provider}'-konto istället.",
        "sended": "Ett email har skickats till '%{email}' med instruktioner för hur du skapar ett nytt lösenord.",
        "successfully_updated": "Ditt lösenord har ändrats.",
        "user_not_found": "Kunde inte hitta användaren med email '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Kunde inte hitta kontot för borttagning.",
        "account_with_uid_destroyed": "Kontot med UID '%{uid}' har tagits bort.",
        "email_already_exists": "Det finns redan ett konto för '%{email}'",
        "missing_confirm_success_url": "Saknar 'confirm_success_url'-parameter.",
        "redirect_url_not_allowed": "Omdirigering till '%{redirect_url}' ej tillåten.",
        "user_not_found": "Användaren hittades ej."
      },
      "sessions": {
        "bad_credentials": "Ogiltig login-information. Vänligen försök igen.",
        "not_confirmed": "Ett bekräftelse-email har skickats till '%{email}'. Följ instruktionerna i emailet så kan ditt konto aktiveras",
        "not_supported": "Använd POST /sign_in för att logga in. GET stöds inte.",
        "user_not_found": "Användaren hittades inte eller var inte inloggad."
      },
      "token_validations": {
        "invalid": "Ogiltig token-information"
      },
      "unlocks": {
        "missing_email": "Du måste ange en emailadress.",
        "sended": "Ett email har skickats till '%{email}' med instruktioner för hur du låser upp ditt konto.",
        "user_not_found": "Kunde inte hitta användaren med emailadressen '%{email}'."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "måste vara accepterad",
        "already_confirmed": "är redan bekräftad, vänligen logga in igen",
        "blank": "måste anges",
        "confirmation": "stämmer inte överens",
        "confirmation_period_expired": "behöver bekräftas inom %{period}. Vänligen begär en ny",
        "empty": "får ej vara tom",
        "equal_to": "måste vara lika med %{count}",
        "even": "måste vara jämnt",
        "exclusion": "är reserverat",
        "expired": "är inte längre giltig. Vänligen begär en ny",
        "greater_than": "måste vara större än %{count}",
        "greater_than_or_equal_to": "måste vara större än eller lika med %{count}",
        "inclusion": "finns inte i listan",
        "invalid": "har fel format",
        "less_than": "måste vara mindre än %{count}",
        "less_than_or_equal_to": "måste vara mindre än eller lika med %{count}",
        "model_invalid": "Validering misslyckades: %{errors}",
        "not_a_number": "är inte ett nummer",
        "not_an_integer": "måste vara ett heltal",
        "not_email": "är inte en emailadress",
        "not_found": "hittades inte",
        "not_locked": "var inte låst",
        "not_saved": {
          "one": "1 fel hindrade denna %{resource} från att sparas:",
          "other": "%{count} fel hindrade denna %{resource} från att sparas:"
        },
        "odd": "måste vara udda",
        "other_than": "måste vara annat än %{count}",
        "present": "får inte anges",
        "required": "måste finnas",
        "taken": "används redan",
        "too_long": "är för lång (maximum är %{count} tecken)",
        "too_short": "är för kort (minimum är %{count} tecken)",
        "validate_account_update_params": "Vänligen skicka giltig data för att uppdatera konto i request-bodyn.",
        "validate_sign_up_params": "Vänligen skicka giltig data för att skapa konto i request-bodyn.",
        "wrong_length": "har fel längd (ska vara %{count} tecken)"
      },
      "template": {
        "body": "Det var problem med följande fält:",
        "header": {
          "one": "Ett fel förhindrade ifrågavarande %{model} från att sparas",
          "other": "%{count} fel förhindrade ifrågavarande %{model} från att sparas"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_prefix}#{city_suffix}"
        ],
        "city_prefix": [
          "Söder",
          "Norr",
          "Väst",
          "Öster",
          "Aling",
          "Ar",
          "Av",
          "Bo",
          "Br",
          "Bå",
          "Ek",
          "En",
          "Esk",
          "Fal",
          "Gäv",
          "Göte",
          "Ha",
          "Helsing",
          "Karl",
          "Krist",
          "Kram",
          "Kung",
          "Kö",
          "Lyck",
          "Ny"
        ],
        "city_suffix": [
          "stad",
          "land",
          "sås",
          "ås",
          "holm",
          "tuna",
          "sta",
          "berg",
          "löv",
          "borg",
          "mora",
          "hamn",
          "fors",
          "köping",
          "by",
          "hult",
          "torp",
          "fred",
          "vik"
        ],
        "common_street_suffix": [
          "s Väg",
          "s Gata"
        ],
        "country": [
          "Ryssland",
          "Kanada",
          "Kina",
          "USA",
          "Brasilien",
          "Australien",
          "Indien",
          "Argentina",
          "Kazakstan",
          "Algeriet",
          "DR Kongo",
          "Danmark",
          "Färöarna",
          "Grönland",
          "Saudiarabien",
          "Mexiko",
          "Indonesien",
          "Sudan",
          "Libyen",
          "Iran",
          "Mongoliet",
          "Peru",
          "Tchad",
          "Niger",
          "Angola",
          "Mali",
          "Sydafrika",
          "Colombia",
          "Etiopien",
          "Bolivia",
          "Mauretanien",
          "Egypten",
          "Tanzania",
          "Nigeria",
          "Venezuela",
          "Namibia",
          "Pakistan",
          "Moçambique",
          "Turkiet",
          "Chile",
          "Zambia",
          "Marocko",
          "Västsahara",
          "Burma",
          "Afghanistan",
          "Somalia",
          "Centralafrikanska republiken",
          "Sydsudan",
          "Ukraina",
          "Botswana",
          "Madagaskar",
          "Kenya",
          "Frankrike",
          "Franska Guyana",
          "Jemen",
          "Thailand",
          "Spanien",
          "Turkmenistan",
          "Kamerun",
          "Papua Nya Guinea",
          "Sverige",
          "Uzbekistan",
          "Irak",
          "Paraguay",
          "Zimbabwe",
          "Japan",
          "Tyskland",
          "Kongo",
          "Finland",
          "Malaysia",
          "Vietnam",
          "Norge",
          "Svalbard",
          "Jan Mayen",
          "Elfenbenskusten",
          "Polen",
          "Italien",
          "Filippinerna",
          "Ecuador",
          "Burkina Faso",
          "Nya Zeeland",
          "Gabon",
          "Guinea",
          "Storbritannien",
          "Ghana",
          "Rumänien",
          "Laos",
          "Uganda",
          "Guyana",
          "Oman",
          "Vitryssland",
          "Kirgizistan",
          "Senegal",
          "Syrien",
          "Kambodja",
          "Uruguay",
          "Tunisien",
          "Surinam",
          "Nepal",
          "Bangladesh",
          "Tadzjikistan",
          "Grekland",
          "Nicaragua",
          "Eritrea",
          "Nordkorea",
          "Malawi",
          "Benin",
          "Honduras",
          "Liberia",
          "Bulgarien",
          "Kuba",
          "Guatemala",
          "Island",
          "Sydkorea",
          "Ungern",
          "Portugal",
          "Jordanien",
          "Serbien",
          "Azerbajdzjan",
          "Österrike",
          "Förenade Arabemiraten",
          "Tjeckien",
          "Panama",
          "Sierra Leone",
          "Irland",
          "Georgien",
          "Sri Lanka",
          "Litauen",
          "Lettland",
          "Togo",
          "Kroatien",
          "Bosnien och Hercegovina",
          "Costa Rica",
          "Slovakien",
          "Dominikanska republiken",
          "Bhutan",
          "Estland",
          "Danmark",
          "Färöarna",
          "Grönland",
          "Nederländerna",
          "Schweiz",
          "Guinea-Bissau",
          "Taiwan",
          "Moldavien",
          "Belgien",
          "Lesotho",
          "Armenien",
          "Albanien",
          "Salomonöarna",
          "Ekvatorialguinea",
          "Burundi",
          "Haiti",
          "Rwanda",
          "Makedonien",
          "Djibouti",
          "Belize",
          "Israel",
          "El Salvador",
          "Slovenien",
          "Fiji",
          "Kuwait",
          "Swaziland",
          "Timor-Leste",
          "Montenegro",
          "Bahamas",
          "Vanuatu",
          "Qatar",
          "Gambia",
          "Jamaica",
          "Kosovo",
          "Libanon",
          "Cypern",
          "Brunei",
          "Trinidad och Tobago",
          "Kap Verde",
          "Samoa",
          "Luxemburg",
          "Komorerna",
          "Mauritius",
          "São Tomé och Príncipe",
          "Kiribati",
          "Dominica",
          "Tonga",
          "Mikronesiens federerade stater",
          "Singapore",
          "Bahrain",
          "Saint Lucia",
          "Andorra",
          "Palau",
          "Seychellerna",
          "Antigua och Barbuda",
          "Barbados",
          "Saint Vincent och Grenadinerna",
          "Grenada",
          "Malta",
          "Maldiverna",
          "Saint Kitts och Nevis",
          "Marshallöarna",
          "Liechtenstein",
          "San Marino",
          "Tuvalu",
          "Nauru",
          "Monaco",
          "Vatikanstaten"
        ],
        "default_country": [
          "Sverige"
        ],
        "default_country_code": [
          "SE"
        ],
        "full_address": [
          "#{street_address}, #{postcode} #{city}"
        ],
        "postcode": [
          "#####"
        ],
        "secondary_address": [
          "Lgh. ###",
          "Hus ###"
        ],
        "state": [
          "Blekinge",
          "Dalarna",
          "Gotland",
          "Gävleborg",
          "Göteborg",
          "Halland",
          "Jämtland",
          "Jönköping",
          "Kalmar",
          "Kronoberg",
          "Norrbotten",
          "Skaraborg",
          "Skåne",
          "Stockholm",
          "Södermanland",
          "Uppsala",
          "Värmland",
          "Västerbotten",
          "Västernorrland",
          "Västmanland",
          "Älvsborg",
          "Örebro",
          "Östergötland"
        ],
        "street_address": [
          "#{street_name} #{building_number}"
        ],
        "street_name": [
          "#{street_root}#{street_suffix}",
          "#{street_prefix} #{street_root}#{street_suffix}",
          "#{Name.first_name}#{common_street_suffix}",
          "#{Name.last_name}#{common_street_suffix}"
        ],
        "street_prefix": [
          "Västra",
          "Östra",
          "Norra",
          "Södra",
          "Övre",
          "Undre"
        ],
        "street_root": [
          "Björk",
          "Järnvägs",
          "Ring",
          "Skol",
          "Skogs",
          "Ny",
          "Gran",
          "Idrotts",
          "Stor",
          "Kyrk",
          "Industri",
          "Park",
          "Strand",
          "Skol",
          "Trädgård",
          "Ängs",
          "Kyrko",
          "Villa",
          "Ek",
          "Kvarn",
          "Stations",
          "Back",
          "Furu",
          "Gen",
          "Fabriks",
          "Åker",
          "Bäck",
          "Asp"
        ],
        "street_suffix": [
          "vägen",
          "gatan",
          "gränden",
          "gärdet",
          "allén"
        ]
      },
      "bank": {
        "name": [
          "Swedbank",
          "Handelsbanken",
          "SEB",
          "Nordea",
          "Danske Bank",
          "Skandiabanken",
          "Länsförsäkringar Bank",
          "Sparbanken Syd",
          "ICA Banken",
          "Forex Bank",
          "Resurs Bank",
          "Avanza Bank",
          "Nordnet Bank",
          "SBAB",
          "Landshypotek Bank"
        ]
      },
      "cell_phone": {
        "formats": [
          "070-###-####",
          "076-###-####",
          "073-###-####"
        ]
      },
      "commerce": {
        "color": [
          "vit",
          "silver",
          "grå",
          "svart",
          "röd",
          "grön",
          "blå",
          "gul",
          "lila",
          "indigo",
          "guld",
          "brun",
          "rosa",
          "purpur",
          "korall"
        ],
        "department": [
          "Böcker",
          "Filmer",
          "Musik",
          "Spel",
          "Elektronik",
          "Datorer",
          "Hem",
          "Trädgård",
          "Verktyg",
          "Livsmedel",
          "Hälsa",
          "Skönhet",
          "Leksaker",
          "Klädsel",
          "Skor",
          "Smycken",
          "Sport"
        ],
        "product_name": {
          "adjective": [
            "Liten",
            "Ergonomisk",
            "Robust",
            "Intelligent",
            "Söt",
            "Otrolig",
            "Fantastisk",
            "Praktisk",
            "Slimmad",
            "Grym",
            "Enorm",
            "Mediokra",
            "Synergistic",
            "Tung",
            "Lätt",
            "Aerodynamisk",
            "Tålig"
          ],
          "material": [
            "Stål",
            "Metall",
            "Trä",
            "Betong",
            "Plast",
            "Bomull",
            "Granit",
            "Gummi",
            "Latex",
            "Läder",
            "Silke",
            "Ull",
            "Linne",
            "Marmor",
            "Järn",
            "Brons",
            "Koppar",
            "Aluminium",
            "Papper"
          ],
          "product": [
            "Stol",
            "Bil",
            "Dator",
            "Handskar",
            "Pants",
            "Shirt",
            "Table",
            "Shoes",
            "Hat",
            "Plate",
            "Kniv",
            "Flaska",
            "Coat",
            "Lampa",
            "Tangentbord",
            "Bag",
            "Bänk",
            "Klocka",
            "Titta",
            "Plånbok"
          ]
        }
      },
      "company": {
        "name": [
          "#{Name.last_name} #{suffix}",
          "#{Name.last_name}-#{Name.last_name}",
          "#{Name.last_name}, #{Name.last_name} #{suffix}"
        ],
        "suffix": [
          "Gruppen",
          "AB",
          "HB",
          "Group",
          "Investment",
          "Kommanditbolag",
          "Aktiebolag"
        ]
      },
      "internet": {
        "domain_suffix": [
          "se",
          "nu",
          "info",
          "com",
          "org"
        ]
      },
      "name": {
        "female_first_name": [
          "Maria",
          "Anna",
          "Margareta",
          "Elisabeth",
          "Eva",
          "Birgitta",
          "Kristina",
          "Karin",
          "Elisabet",
          "Marie",
          "Åsa",
          "Hjördis",
          "Ingegärd"
        ],
        "first_name": [
          "#{female_first_name}",
          "#{male_first_name}"
        ],
        "last_name": [
          "Johansson",
          "Andersson",
          "Karlsson",
          "Nilsson",
          "Eriksson",
          "Larsson",
          "Olsson",
          "Persson",
          "Svensson",
          "Gustafsson",
          "Åslund",
          "Östlund",
          "Änglund"
        ],
        "male_first_name": [
          "Erik",
          "Lars",
          "Karl",
          "Anders",
          "Per",
          "Johan",
          "Nils",
          "Lennart",
          "Emil",
          "Hans",
          "Jörgen",
          "Göran",
          "Håkan",
          "Kåre"
        ],
        "name": [
          "#{first_name} #{last_name}",
          "#{prefix} #{first_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "civ.ek.",
          "civ.ing.",
          "ekon.dr",
          "ekon. mag.",
          "ekon. kand.",
          "fil.dr",
          "fil.lic.",
          "fil.kand.",
          "fil.mag.",
          "jur. kand.",
          "jur.utr.kand.",
          "jur.lic.",
          "jur.dr",
          "med.dr",
          "med.lic.",
          "med.kand.",
          "odont.kand.",
          "odont.lic.",
          "odont.dr",
          "pol.kand.",
          "pol.mag.",
          "pol.dr",
          "tekn.dr",
          "tekn.lic.",
          "teol.kand.",
          "teol.lic.",
          "teol.dr"
        ],
        "title": {
          "descriptor": [
            "Lead",
            "Senior",
            "Direct",
            "Corporate",
            "Dynamic",
            "Future",
            "Product",
            "National",
            "Regional",
            "District",
            "Central",
            "Global",
            "Customer",
            "Investor",
            "Dynamic",
            "International",
            "Legacy",
            "Forward",
            "Internal",
            "Human",
            "Chief",
            "Principal"
          ],
          "job": [
            "Supervisor",
            "Associate",
            "Executive",
            "Liaison",
            "Officer",
            "Manager",
            "Engineer",
            "Specialist",
            "Director",
            "Coordinator",
            "Administrator",
            "Architect",
            "Analyst",
            "Designer",
            "Planner",
            "Orchestrator",
            "Technician",
            "Developer",
            "Producer",
            "Consultant",
            "Assistant",
            "Facilitator",
            "Agent",
            "Representative",
            "Strategist"
          ],
          "level": [
            "Solutions",
            "Program",
            "Brand",
            "Security",
            "Research",
            "Marketing",
            "Directives",
            "Implementation",
            "Integration",
            "Functionality",
            "Response",
            "Paradigm",
            "Tactics",
            "Identity",
            "Markets",
            "Group",
            "Division",
            "Applications",
            "Optimization",
            "Operations",
            "Infrastructure",
            "Intranet",
            "Communications",
            "Web",
            "Branding",
            "Quality",
            "Assurance",
            "Mobility",
            "Accounts",
            "Data",
            "Creative",
            "Configuration",
            "Accountability",
            "Interactions",
            "Factors",
            "Usability",
            "Metrics"
          ]
        }
      },
      "phone_number": {
        "country_code": [
          "46"
        ],
        "formats": [
          "####-#####",
          "####-######"
        ]
      },
      "sport": {
        "summer_olympics": [
          "Badminton",
          "Baseboll/Softboll",
          "Basketboll",
          "Bordtennis",
          "Boxning",
          "Brottning",
          "Bågskytte",
          "Cricket",
          "Cykel",
          "Danssport",
          "Dragkamp",
          "Flaggfotboll",
          "Fotboll",
          "Friidrott",
          "Fäktning",
          "Golf",
          "Gymnastik",
          "Handboll",
          "Judo",
          "Kanot",
          "Karate",
          "Kickboxning",
          "Lacrosse",
          "Landhockey",
          "Modern femkamp",
          "Muay Thai",
          "Padel",
          "Ridsport",
          "Rodd",
          "Rugby",
          "Segling",
          "Simidrott",
          "Skateboard",
          "Skyttesport",
          "Sportklättring",
          "Squash",
          "Surfing",
          "Taekwondo",
          "Tennis",
          "Teqball",
          "Triathlon",
          "Tyngdlyftning",
          "Vattenskidor",
          "Volleyboll"
        ],
        "summer_paralympics": [
          "Badminton",
          "Boccia",
          "Bordtennis",
          "Bågskytte",
          "Bänkpress",
          "Cykel",
          "Fotboll 5-a-side",
          "Friidrott",
          "Fäktning",
          "Goalball",
          "Judo",
          "Kanot",
          "Ridsport",
          "Rodd",
          "Rullstolsbasket",
          "Rullstolsrugby",
          "Rullstolstennis",
          "Simning",
          "Sittande volleyboll",
          "Sportskytte",
          "Taekwondo",
          "Triathlon"
        ],
        "winter_olympics": [
          "Alpint",
          "Backhoppning",
          "Curling",
          "Freeskiing",
          "Freestyle",
          "Ishockey",
          "Konståkning",
          "Kälksport",
          "Längdskidåkning",
          "Nordisk kombination",
          "Skidskytte",
          "Skimo",
          "Skridsko",
          "Snowboard"
        ],
        "winter_paralympics": [
          "Alpin skidåkning",
          "Längdskidor",
          "Paraishockey",
          "Rullstolscurling",
          "Skidskytte",
          "Snowboard"
        ]
      },
      "team": {
        "name": [
          "#{Address.city} #{suffix}"
        ],
        "suffix": [
          "IF",
          "FF",
          "BK",
          "HK",
          "AIF",
          "SK",
          "FC",
          "SK",
          "BoIS",
          "FK",
          "BIS",
          "FIF",
          "IK"
        ]
      }
    },
    "hello": "hej",
    "helpers": {
      "select": {
        "prompt": "Välj"
      },
      "submit": {
        "create": "Skapa %{model}",
        "submit": "Spara %{model}",
        "update": "Ändra %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "kr"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miljard",
            "million": "Miljon",
            "quadrillion": "Biljard",
            "thousand": "Tusen",
            "trillion": "Biljon",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": " ",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " och ",
        "two_words_connector": " och ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %e %b %Y %H:%M:%S %z",
        "long": "%e %B %Y %H:%M",
        "short": "%e %b %H:%M"
      },
      "pm": "pm"
    },
    "welcome": "välkommen"
  },
  "sv-FI": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Ett fel uppstod: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan inte ta bort poster då beroende %{record} finns",
            "has_one": "Kan inte ta bort post då beroende %{record} finns"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "sön",
        "mån",
        "tis",
        "ons",
        "tor",
        "fre",
        "lör"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "söndag",
        "måndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lördag"
      ],
      "formats": {
        "default": "%-d.%-m.%Y",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ungefär en timme",
          "other": "ungefär %{count} timmar"
        },
        "about_x_months": {
          "one": "ungefär en månad",
          "other": "ungefär %{count} månader"
        },
        "about_x_years": {
          "one": "ungefär ett år",
          "other": "ungefär %{count} år"
        },
        "almost_x_years": {
          "one": "nästan ett år",
          "other": "nästan %{count} år"
        },
        "half_a_minute": "en halv minut",
        "less_than_x_minutes": {
          "one": "mindre än en minut",
          "other": "mindre än %{count} minuter"
        },
        "less_than_x_seconds": {
          "one": "mindre än en sekund",
          "other": "mindre än %{count} sekunder"
        },
        "over_x_years": {
          "one": "mer än ett år",
          "other": "mer än %{count} år"
        },
        "x_days": {
          "one": "en dag",
          "other": "%{count} dagar"
        },
        "x_minutes": {
          "one": "en minut",
          "other": "%{count} minuter"
        },
        "x_months": {
          "one": "en månad",
          "other": "%{count} månader"
        },
        "x_seconds": {
          "one": "en sekund",
          "other": "%{count} sekunder"
        }
      },
      "prompts": {
        "day": "Dag",
        "hour": "Timme",
        "minute": "Minut",
        "month": "Månad",
        "second": "Sekund",
        "year": "År"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "måste vara accepterad",
        "blank": "måste anges",
        "confirmation": "stämmer inte överens",
        "empty": "får ej vara tom",
        "equal_to": "måste vara lika med %{count}",
        "even": "måste vara jämnt",
        "exclusion": "är reserverat",
        "greater_than": "måste vara större än %{count}",
        "greater_than_or_equal_to": "måste vara större än eller lika med %{count}",
        "inclusion": "finns inte i listan",
        "invalid": "har fel format",
        "less_than": "måste vara mindre än %{count}",
        "less_than_or_equal_to": "måste vara mindre än eller lika med %{count}",
        "model_invalid": "Validering misslyckades: %{errors}",
        "not_a_number": "är inte ett nummer",
        "not_an_integer": "måste vara ett heltal",
        "odd": "måste vara udda",
        "other_than": "måste vara annat än %{count}",
        "present": "får inte anges",
        "required": "måste finnas",
        "taken": "används redan",
        "too_long": "är för lång (maximum är %{count} tecken)",
        "too_short": "är för kort (minimum är %{count} tecken)",
        "wrong_length": "har fel längd (ska vara %{count} tecken)"
      },
      "template": {
        "body": "Det var problem med följande fält:",
        "header": {
          "one": "Ett fel förhindrade ifrågavarande %{model} från att sparas",
          "other": "%{count} fel förhindrade ifrågavarande %{model} från att sparas"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Välj"
      },
      "submit": {
        "create": "Skapa %{model}",
        "submit": "Spara %{model}",
        "update": "Ändra %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miljard",
            "million": "Miljon",
            "quadrillion": "Biljard",
            "thousand": "Tusen",
            "trillion": "Biljon",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": " ",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " och ",
        "two_words_connector": " och ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %e %b %Y %H:%M:%S %z",
        "long": "%e %B %Y %H:%M",
        "short": "%e %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "sv-SE": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Ett fel uppstod: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Kan inte ta bort poster då beroende %{record} finns",
            "has_one": "Kan inte ta bort post då beroende %{record} finns"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "sön",
        "mån",
        "tis",
        "ons",
        "tor",
        "fre",
        "lör"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      "day_names": [
        "söndag",
        "måndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lördag"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%e %B %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "ungefär en timme",
          "other": "ungefär %{count} timmar"
        },
        "about_x_months": {
          "one": "ungefär en månad",
          "other": "ungefär %{count} månader"
        },
        "about_x_years": {
          "one": "ungefär ett år",
          "other": "ungefär %{count} år"
        },
        "almost_x_years": {
          "one": "nästan ett år",
          "other": "nästan %{count} år"
        },
        "half_a_minute": "en halv minut",
        "less_than_x_minutes": {
          "one": "mindre än en minut",
          "other": "mindre än %{count} minuter"
        },
        "less_than_x_seconds": {
          "one": "mindre än en sekund",
          "other": "mindre än %{count} sekunder"
        },
        "over_x_years": {
          "one": "mer än ett år",
          "other": "mer än %{count} år"
        },
        "x_days": {
          "one": "en dag",
          "other": "%{count} dagar"
        },
        "x_minutes": {
          "one": "en minut",
          "other": "%{count} minuter"
        },
        "x_months": {
          "one": "en månad",
          "other": "%{count} månader"
        },
        "x_seconds": {
          "one": "en sekund",
          "other": "%{count} sekunder"
        },
        "x_years": {
          "one": "ett år",
          "other": "%{count} år"
        }
      },
      "prompts": {
        "day": "Dag",
        "hour": "Timme",
        "minute": "Minut",
        "month": "Månad",
        "second": "Sekund",
        "year": "År"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "måste vara accepterad",
        "blank": "måste anges",
        "confirmation": "stämmer inte överens",
        "empty": "får ej vara tom",
        "equal_to": "måste vara lika med %{count}",
        "even": "måste vara jämnt",
        "exclusion": "är reserverat",
        "greater_than": "måste vara större än %{count}",
        "greater_than_or_equal_to": "måste vara större än eller lika med %{count}",
        "inclusion": "finns inte i listan",
        "invalid": "har fel format",
        "less_than": "måste vara mindre än %{count}",
        "less_than_or_equal_to": "måste vara mindre än eller lika med %{count}",
        "model_invalid": "Validering misslyckades: %{errors}",
        "not_a_number": "är inte ett nummer",
        "not_an_integer": "måste vara ett heltal",
        "odd": "måste vara udda",
        "other_than": "måste vara annat än %{count}",
        "present": "får inte anges",
        "required": "måste finnas",
        "taken": "används redan",
        "too_long": "är för lång (maximum är %{count} tecken)",
        "too_short": "är för kort (minimum är %{count} tecken)",
        "wrong_length": "har fel längd (ska vara %{count} tecken)"
      },
      "template": {
        "body": "Det var problem med följande fält:",
        "header": {
          "one": "Ett fel förhindrade denna %{model} från att sparas",
          "other": "%{count} fel förhindrade denna %{model} från att sparas"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Välj"
      },
      "submit": {
        "create": "Skapa %{model}",
        "submit": "Spara %{model}",
        "update": "Ändra %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "kr"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 2,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Miljard",
            "million": "Miljon",
            "quadrillion": "Biljard",
            "thousand": "Tusen",
            "trillion": "Biljon",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " och ",
        "two_words_connector": " och ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %e %b %Y %H:%M:%S %z",
        "long": "%e %B %Y %H:%M",
        "short": "%e %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "sw": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Uhalalishaji umeshindikana: %{errors}"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "J2",
        "J3",
        "J4",
        "J5",
        "Al",
        "Ij",
        "J1"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mac",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Okt",
        "Nov",
        "Des"
      ],
      "day_names": [
        "Jumapili",
        "Jumatatu",
        "Jumanne",
        "Jumatano",
        "Alhamisi",
        "Ijumaa",
        "Jumamosi"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%e %B, %Y",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "Mwezi wa kwanza",
        "Mwezi wa pili",
        "Mwezi wa tatu",
        "Mwezi wa nne",
        "Mwezi wa tano",
        "Mwezi wa sita",
        "Mwezi wa saba",
        "Mwezi wa nane",
        "Mwezi wa tisa",
        "Mwezi wa kumi",
        "Mwezi wa kumi na moja",
        "Mwezi wa kumi na mbili"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "kama saa limoja",
          "other": "kama masaa %{count}"
        },
        "about_x_months": {
          "one": "kama mwezi %{count}",
          "other": "kama miezi %{count}"
        },
        "about_x_years": {
          "one": "kama mwaka %{count}",
          "other": "kama miaka %{count}"
        },
        "almost_x_years": {
          "one": "karibia mwaka",
          "other": "karibia miaka %{count}"
        },
        "half_a_minute": "nusu dakika",
        "less_than_x_minutes": {
          "one": "chini ya dakika %{count}",
          "other": "chini ya dakika %{count}"
        },
        "less_than_x_seconds": {
          "one": "chini ya sekunde %{count}",
          "other": "chini ya sekunde %{count}"
        },
        "over_x_years": {
          "one": "zaidi ya mwaka %{count}",
          "other": "zaidi ya miaka %{count}"
        },
        "x_days": {
          "one": "siku %{count}",
          "other": "siku %{count}"
        },
        "x_minutes": {
          "one": "dakika %{count}",
          "other": "dakika %{count}"
        },
        "x_months": {
          "one": "mwezi %{count}",
          "other": "miezi %{count}"
        },
        "x_seconds": {
          "one": "sekunde %{count}",
          "other": "sekunde %{count}"
        }
      },
      "prompts": {
        "day": "Siku",
        "hour": "Saa",
        "minute": "Dakika",
        "month": "Mwezi",
        "second": "Sekunde",
        "year": "Mwaka"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "lazima ikubaliwe",
        "blank": "haitakiwi kuwa wazi",
        "confirmation": "haifanani na hapo chini",
        "empty": "haitakiwi kuwa tupu",
        "equal_to": "z/iwe sawa na %{count}",
        "even": "z/iwe shufwa",
        "exclusion": "haiwezi kutumika",
        "greater_than": "z/iwe zaidi ya %{count}",
        "greater_than_or_equal_to": "z/iwe sawa ama zaidi ya %{count}",
        "inclusion": "haipo kwenye orodha",
        "invalid": "haifai",
        "less_than": "z/isizidi %{count}",
        "less_than_or_equal_to": "z/iwe sawa na, ama chini ya %{count}",
        "not_a_number": "inaruhusiwa namba tu",
        "not_an_integer": "inaruhusiwa namba tu",
        "odd": "z/iwe witiri",
        "taken": "imesajiliwa",
        "too_long": "ndefu sana (isizidi herufi %{count})",
        "too_short": "fupi mno (isipungue herufi %{count})",
        "wrong_length": "idadi ya herufi hazilingani (inatakiwa %{count})"
      },
      "template": {
        "body": "Tafadhali kagua sehemu zifuatazo:",
        "header": {
          "one": "%{model} haikuhifadhiwa kwa sababu moja.",
          "other": "%{model} haikuhifadhiwa kwa sababu %{count}."
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Tafadhali teua"
      },
      "submit": {
        "create": "Unda %{model}",
        "submit": "Akibisha %{model}",
        "update": "Sasaisha %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n%u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "/="
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Bilioni",
            "million": "Milioni",
            "quadrillion": "Kuadrilioni",
            "thousand": "Elfu",
            "trillion": "Trilioni",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": "Baiti",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", na ",
        "two_words_connector": " na ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S",
        "long": "%A, %e. %B %Y, %H:%M:%S",
        "short": "%e %b %Y %H:%M"
      },
      "pm": "pm"
    }
  },
  "ta": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "சரிபார்த்தல் தோல்வியுற்றது: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "பதிவை நீக்க முடியாது, ஏனெனில் சார்புகள் %{record} உள்ளது",
            "has_one": "பதிவை நீக்க முடியாது, ஏனெனில் ஒரு சார்பு %{record} உள்ளது"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ஞாயிறு",
        "திங்கள்",
        "செவ்வாய்",
        "புதன்",
        "வியாழன்",
        "வெள்ளி",
        "சனி"
      ],
      "abbr_month_names": [
        null,
        "ஜன",
        "பிப்",
        "மார்ச்",
        "ஏப்",
        "மே",
        "ஜூன்",
        "ஜூலை",
        "ஆக",
        "செப்",
        "அக்",
        "நவ",
        "டிச"
      ],
      "day_names": [
        "ஞாயிற்றுக்கிழமை",
        "திங்கட்கிழமை",
        "செவ்வாய்க்கிழமை",
        "புதன்கிழமை",
        "வியாழக்கிழமை",
        "வெள்ளிக்கிழமை",
        "சனிக்கிழமை"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "ஜனவரி",
        "பிப்ரவரி",
        "மார்ச்",
        "ஏப்ரல்",
        "மே",
        "ஜூன்",
        "ஜூலை",
        "ஆகஸ்ட்",
        "செப்டம்பர்",
        "அக்டோபர்",
        "நவம்பர்",
        "டிசம்பர்"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "சுமார் %{count} மணி நேரம்",
          "other": "சுமார் %{count} மணி"
        },
        "about_x_months": {
          "one": "சுமார் %{count} மாதம்",
          "other": "சுமார் %{count} மாதங்களுக்கு"
        },
        "about_x_years": {
          "one": "சுமார் %{count}  ஆண்டு",
          "other": "சுமார் %{count}  ஆண்டுகள்"
        },
        "almost_x_years": {
          "one": "கிட்டத்தட்ட %{count}  ஆண்டு",
          "other": "கிட்டத்தட்ட %{count}  ஆண்டுகள்"
        },
        "half_a_minute": "அரை நிமிடம்",
        "less_than_x_minutes": {
          "one": "ஒரு நிமிடத்திற்கும் குறைவாக",
          "other": "குறைவாக %{count} நிமிடங்கள்"
        },
        "less_than_x_seconds": {
          "one": "ஒரு வினாடிக்கும் குறைவாக",
          "other": "குறைவாக %{count} வினாடிகள்"
        },
        "over_x_years": {
          "one": "ஒரு  ஆண்டிற்கு மேலாக",
          "other": "%{count}  ஆண்டிற்கு மேலாக"
        },
        "x_days": {
          "one": "%{count} நாள்",
          "other": "%{count} நாட்கள்"
        },
        "x_minutes": {
          "one": "%{count} நிமிடம்",
          "other": "%{count} நிமிடங்கள்"
        },
        "x_months": {
          "one": "%{count} மாதம்",
          "other": "%{count} மாதங்கள்"
        },
        "x_seconds": {
          "one": "%{count} வினாடி",
          "other": "%{count} விநாடிகள்"
        }
      },
      "prompts": {
        "day": "நாள்",
        "hour": "மணி",
        "minute": "நிமிடம்",
        "month": "மாதம்",
        "second": "விநாடிகள்",
        "year": "ஆண்டு"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ஏற்கப்பட வேண்டும்",
        "blank": "காலியாக இருக்க முடியாது",
        "confirmation": "%{attribute}  பொருந்தவில்லை",
        "empty": "வெறுமையாக இருக்க முடியாது",
        "equal_to": "%{count} சமமாக இருக்க வேண்டும்",
        "even": "இரட்டைப்படை இருக்க வேண்டும்",
        "exclusion": "ஒதுக்கப்பட்டுள்ளது",
        "greater_than": "%{count} ஐ விட அதிகமாக இருக்க வேண்டும்",
        "greater_than_or_equal_to": "%{count}  அதிகமாக அல்லது சமமாக இருக்க வேண்டும்",
        "inclusion": "பட்டியலில் சேர்க்கப்படவில்லை",
        "invalid": "செல்லுபடியானதல்ல",
        "less_than": "%{count} ஐ விட குறைவாக இருக்க வேண்டும்",
        "less_than_or_equal_to": "%{count} குறைவாக அல்லது சமமாக இருக்க வேண்டும்",
        "not_a_number": "ஒரு எண் அல்ல",
        "not_an_integer": "ஒரு முழு எண்ணாக இருக்க வேண்டும்",
        "odd": "ஒற்றைப்படை இருக்க வேண்டும்",
        "other_than": "%{count} தவிர வேறு இருக்க வேண்டும்",
        "present": "காலியாக இருக்க வேண்டும்",
        "taken": "ஏற்கனவே எடுத்துகொள்ள பட்டது",
        "too_long": {
          "one": "மிக நீளமாக உள்ளது (அதிகபட்சமாக ஒரு எழுத்து)",
          "other": "மிக நீளமாக உள்ளது (அதிகபட்சமாக %{count} எழுத்துக்கள்)"
        },
        "too_short": {
          "one": "மிகவும் குறுகியதாக உள்ளது (குறைந்தபட்சம் ஒரு எழுத்து)",
          "other": "மிகவும் குறுகியதாக உள்ளது (குறைந்தபட்சம் %{count} எழுத்துக்கள்)"
        },
        "wrong_length": {
          "one": "தவறான நீளம் (%{count} எழுத்து இருக்கவேண்டும்)",
          "other": "தவறான நீளம் (%{count} எழுத்துக்கள் இருக்கவேண்டும்)"
        }
      },
      "template": {
        "body": "பின்வரும் புலங்களில் பிரச்சினைகள் உள்ளது:",
        "header": {
          "one": "%{count} பிழை இந்த %{model} ஐ சேமிக்க தடையாக உள்ளது",
          "other": "%{count} பிழைகள் இந்த %{model} ஐ சேமிக்க தடையாக உள்ளது"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "தேர்வு செய்க"
      },
      "submit": {
        "create": "%{model} ஐ  உருவாக்கு",
        "submit": "%{model} ஐ சேமி",
        "update": "%{model} ஐ புதுப்பி"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "பில்லியன்",
            "million": "மில்லியன்",
            "quadrillion": "குவாட்ரில்லியன்",
            "thousand": "ஆயிரம்",
            "trillion": "டிரில்லியன்",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", மற்றும் ",
        "two_words_connector": " மற்றும் ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "மு.ப.",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "பி.ப."
    }
  },
  "te": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "ధ్రువీకరన విఫలమైనది: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "రికార్డ్ను తొలగించలేరు, ఎందుకంటే ఆధారపడిన %{record} ఉంది",
            "has_one": "రికార్డ్ను తొలగించలేరు, ఎందుకంటే ఒక ఆధారపడిన %{record} ఉంది"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "ఆది",
        "సోమ",
        "మంగళ",
        "బుధ",
        "గురు",
        "శుక్ర",
        "శని"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "ఆదివారం",
        "సోమవారం",
        "మంగళవారం",
        "బుధవారం",
        "గురువారం",
        "శుక్రవారం",
        "శనివారం"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "జనవరి",
        "ఫిబ్రవరి",
        "మార్చి",
        "ఏప్రిల్",
        "మే",
        "జూన్",
        "జూలై",
        "ఆగస్టు",
        "సెప్టెంబరు",
        "అక్టోబరు",
        "నవంబరు",
        "డిసెంబరు"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "సుమారు ఒక గంట",
          "other": "సుమారు %{count} గంటలు"
        },
        "about_x_months": {
          "one": "సుమారు ఒక నెల",
          "other": "సుమారు %{count} నెలలు"
        },
        "about_x_years": {
          "one": "సుమారు ఒక సంవత్సరం",
          "other": "సుమారు %{count} సంవత్సరాలు"
        },
        "almost_x_years": {
          "one": "దాదాపు ఒక సంవత్సరం",
          "other": "దాదాపు %{count} సంవత్సరాలు"
        },
        "half_a_minute": "అర నిమిషం",
        "less_than_x_minutes": {
          "one": "ఒక నిమిషం కన్నా తక్కువ",
          "other": "%{count} నిమిషాల కన్నా తక్కువ"
        },
        "less_than_x_seconds": {
          "one": "ఒక క్షణం కన్నా తక్కువ",
          "other": "%{count} క్షణాలు కన్నా తక్కువ"
        },
        "over_x_years": {
          "one": "ఒక సంవత్సరం పైగా",
          "other": "%{count} సంవత్సరాల పైగా"
        },
        "x_days": {
          "one": "ఒక రోజు",
          "other": "%{count} రోజులు"
        },
        "x_minutes": {
          "one": "ఒక నిమిషం",
          "other": "%{count} నిమిషాలు"
        },
        "x_months": {
          "one": "ఒక నెల",
          "other": "%{count} నెలలు"
        },
        "x_seconds": {
          "one": "ఒక క్షణం",
          "other": "%{count} క్షణాలు"
        },
        "x_years": {
          "one": "ఒక సంవత్సరం",
          "other": "%{count} సంవత్సరాలు"
        }
      },
      "prompts": {
        "day": "రోజు",
        "hour": "గంట",
        "minute": "నిమిషం",
        "month": "నెల",
        "second": "క్షణాలు",
        "year": "సంవత్సరం"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "అంగీకరించి ఉండాలి",
        "blank": "ఖాళీగా ఉండకూడదు",
        "confirmation": "%{attribute} సరిపోలడం లేదు",
        "empty": "శూన్యంగా ఉండకూడదు",
        "equal_to": "%{count}కు సమానంగా ఉండాలి",
        "even": "సరి సంఖ్య అయి ఉండాలి",
        "exclusion": "ప్రత్యేకించబడింది",
        "greater_than": "%{count} కంటే ఎక్కువ ఉండాలి",
        "greater_than_or_equal_to": "%{count} కంటే ఎక్కువ లేదా సమానంగా ఉండాలి",
        "inclusion": "జాబితాలో చేర్చబడలేదు",
        "invalid": "చెల్లనిది",
        "less_than": "%{count} కంటే తక్కువ ఉండాలి",
        "less_than_or_equal_to": "%{count} నాలుగు కంటే తక్కువగా లేదా సమానంగా ఉండాలి",
        "model_invalid": "ధృవీకరణ విఫలమైంది: %{errors}",
        "not_a_number": "సంఖ్య కాదు",
        "not_an_integer": "పూర్ణాంకంగా ఉండాలి",
        "odd": "బేసి సంఖ్య అయి ఉండాలి",
        "other_than": "%{count} కన్నా వేరు ఉండాలి",
        "present": "ఖాళీగా ఉండాలి",
        "required": "ఉనికిలో ఉండాలి",
        "taken": "ఇప్పటికే తీసుకోబడింది",
        "too_long": {
          "one": "చాలా పొడవుగా ఉంది (గరిష్టంగా ఒక అక్షరం)",
          "other": "చాలా పొడవుగా ఉంది (గరిష్టంగా %{count} అక్షరాలు)"
        },
        "too_short": {
          "one": "చాలా తక్కువగా ఉంది (కనీసం ఒక అక్షరం)",
          "other": "చాలా చిన్నది (కనీసం %{count} అక్షరాలు)"
        },
        "wrong_length": {
          "one": "తప్పు పొడవు (ఒక అక్షరం ఉండాలి)",
          "other": "తప్పు పొడవు (%{count} అక్షరాలు ఉండాలి)"
        }
      },
      "template": {
        "body": "కింది రంగాలలో సమస్యలు ఉన్నాయి:",
        "header": {
          "one": "ఒక తప్పు ఈ %{model} ను ఆదా చెయ్యకుండా నిషేదించింది",
          "other": "%{count} తప్పులు ఈ %{model} ను ఆదా చెయ్యకుండా నిషేదించింది"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "దయచేసి ఎంచుకోండి"
      },
      "submit": {
        "create": "%{model} ను సృష్టించండి",
        "submit": "%{model} ను ఆదా చెయ్యండి",
        "update": "%{model} ను నవీకరించండి"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₹"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "బిలియన్",
            "million": "మిలియన్",
            "quadrillion": "క్వాడ్రిలియన్",
            "thousand": "వెయ్యి",
            "trillion": "ట్రిలియన్",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "బైట్",
              "other": "బైట్లు"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", మరియు ",
        "two_words_connector": " మరియు ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "th": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "คำแนะนำในการยืนยันตัวตนถูกส่งไปเมื่อ",
          "confirmation_token": "รหัสลับสำหรับยืนยันตัวตน",
          "confirmed_at": "ยืนยันตัวตนเมื่อ",
          "created_at": "สร้างขึ้นเมื่อ",
          "current_password": "รหัสผ่านปัจจุบัน",
          "current_sign_in_at": "เข้าสู่ระบบเมื่อ",
          "current_sign_in_ip": "IP ที่ใช้เข้าสู่ระบบ",
          "email": "อีเมล",
          "encrypted_password": "รหัสผ่านที่ถูกเข้ารหัส",
          "failed_attempts": "การเข้าสู่ระบบล้มเหลว",
          "last_sign_in_at": "เข้าสู่ระบบล่าสุดเมื่อ",
          "last_sign_in_ip": "IP ที่เข้าสู่ระบบล่าสุด",
          "locked_at": "ถูกล็อกเมื่อ",
          "password": "รหัสผ่าน",
          "password_confirmation": "ยืนยันรหัสผ่าน",
          "remember_created_at": "การจำผู้ใช้ครั้งล่าสุด",
          "remember_me": "จำชื่อผู้ใช้",
          "reset_password_sent_at": "คำสั่งการเปลี่ยนรหัสผ่านถูกส่งไปเมื่อ",
          "reset_password_token": "รหัสลับสำหรับการเปลี่ยนรหัสผ่าน",
          "sign_in_count": "จำนวนครั้งที่เข้าสู่ระบบ",
          "unconfirmed_email": "อีเมลที่ไม่ได้รับการยืนยัน",
          "unlock_token": "รหัสลับสำหรับปลดล็อก",
          "updated_at": "แก้ไขเมื่อ"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "ไม่ผ่านการตรวจสอบ: %{errors}"
        }
      },
      "models": {
        "user": {
          "other": "ผู้ใช้งาน"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "อา",
        "จ",
        "อ",
        "พ",
        "พฤ",
        "ศ",
        "ส"
      ],
      "abbr_month_names": [
        null,
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ],
      "day_names": [
        "อาทิตย์",
        "จันทร์",
        "อังคาร",
        "พุธ",
        "พฤหัสบดี",
        "ศุกร์",
        "เสาร์"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "ประมาณ %{count} ชั่วโมง",
        "about_x_months": "ประมาณ %{count} เดือน",
        "about_x_years": "ประมาณ %{count} ปี",
        "almost_x_years": "เกือบ %{count} ปี",
        "half_a_minute": "ครึ่งนาที",
        "less_than_x_minutes": "น้อยกว่า %{count} นาที",
        "less_than_x_seconds": "น้อยกว่า %{count} วินาที",
        "over_x_years": "มากกว่า %{count} ปี",
        "x_days": "%{count} วัน",
        "x_minutes": "%{count} นาที",
        "x_months": "%{count} เดือน",
        "x_seconds": "%{count} วินาที"
      },
      "prompts": {
        "day": "วัน",
        "hour": "ชั่วโมง",
        "minute": "นาที",
        "month": "เดือน",
        "second": "วินาที",
        "year": "ปี"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "คุณได้ยืนยันบัญชีของคุณเรียบร้อยแล้ว ขณะนี้คุณสามารถเข้าสู่ระบบได้",
        "new": {
          "resend_confirmation_instructions": "ส่งยืนยันคำขออีกครั้ง"
        },
        "send_instructions": "คุณจะได้รับอีเมล์แนะนำวิธีการยืนยันบัญชีภายในไม่ไม่ช้า",
        "send_paranoid_instructions": "หากอีเมล์ของคุณมีอยู่ในฐานข้อมูลในระบบแล้ว คุณจะได้รับอีเมล์แนะนำวิธีการยืนยันบัญชีภายในไม่ช้า"
      },
      "failure": {
        "already_authenticated": "คุณเข้าสู่ระบบแล้ว",
        "inactive": "บัญชีของคุณยังไม่ถูกเปิดใช้งาน",
        "invalid": "%{authentication_keys} หรือรหัสผ่านไม่ถูกต้อง",
        "last_attempt": "คุณสามารถผิดพลาดได้อีกครั้งก่อนที่บัญชีของคุณจะถูกล็อก",
        "locked": "บัญชีของคุณถูกล็อก",
        "not_found_in_database": "%{authentication_keys} หรือรหัสผ่านไม่ถูกต้อง",
        "timeout": "หน้าเว็บเกินระยะเวลาที่กำหนด กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ",
        "unauthenticated": "คุณต้องเข้าสู่ระบบหรือลงทะเบียนก่อนดำเนินการต่อ",
        "unconfirmed": "คุณต้องยืนยันบัญชีก่อนดำเนินการต่อ"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "ยืนยันบัญชีของฉัน",
          "greeting": "ยินดีต้อนรับคุณ %{recipient}!",
          "instruction": "คุณสามารถยืนยันอีเมล์ที่ใช้สมัครสมาชิกได้จากลิงค์ข้างล่างนี้:",
          "subject": "คำแนะนำการยืนยัน"
        },
        "email_changed": {
          "greeting": "สวัสดี %{recipient}",
          "message": "เราติดต่อคุณในครั้งนี้เพื่อแจ้งให้ทราบว่าอีเมลของคุณได้ถูกเปลี่ยนเป็น %{email} สำเร็จแล้ว",
          "message_unconfirmed": "เราติดต่อคุณในครั้งนี้เพื่อแจ้งให้ทราบว่าอีเมลของคุณจะถูกเปลี่ยนเป็น %{email}",
          "subject": "การเปลี่ยนแปลงอีเมลสำเร็จ"
        },
        "password_change": {
          "greeting": "สวัสดี %{recipient}",
          "message": "เราติดต่อคุณในครั้งนี้เพื่อแจ้งให้ทราบว่ารหัสผ่านของคุณได้ถูกเปลี่ยนสำเร็จแล้ว",
          "subject": "การเปลี่ยนแปลงรหัสผ่านสำเร็จ"
        },
        "reset_password_instructions": {
          "action": "เปลี่ยนรหัสผ่านของฉัน",
          "greeting": "สวัสดีคุณ %{recipient}!",
          "instruction": "ทางเวบได้รับคำขอเปลี่ยนรหัสผ่านของคุณ และคุณสามารถตั้งรหัสผ่านใหม่จากลิงค์ข้างล่างนี้",
          "instruction_2": "ถ้าคุณไม่ได้ขอเปลี่ยนรหัสผ่าน กรุณาเพิกเฉยต่อเมล์ฉบับนี้",
          "instruction_3": "รหัสผ่านของคุณยังไม่ได้ถูกเปลี่ยนแปลง จนกว่าคุณจะเข้าลิงค์ด้านบนนี้และตั้งรหัสผ่านใหม่",
          "subject": "คำแนะนำการตั้งค่ารหัสผ่าน"
        },
        "unlock_instructions": {
          "action": "ปลดล็อคบัญชีของฉัน",
          "greeting": "สวัสดีคุณ %{recipient}!",
          "instruction": "คลิกลิงค์ทางด้านล่างนี้เพื่อปลดล็อคบัญชีของคุณ:",
          "message": "บัญชีของคุณโดนล็อค เนื่องจากคุณใส่รหัสผ่านผิดเกินจำนวนครั้งที่ทางเรากำหนด",
          "subject": "คำแนะนำการปลดล็อก"
        }
      },
      "omniauth_callbacks": {
        "failure": "ไม่สามารถยืนยันตัวคุณจาก %{kind} เพราะ \"%{reason}\"",
        "success": "ยืนยันตัวตนจากบัญชี %{kind}"
      },
      "passwords": {
        "edit": {
          "change_my_password": "เปลี่ยนรหัสผ่านของคุณ",
          "change_your_password": "เปลี่ยนรหัสผ่านของคุณ",
          "confirm_new_password": "ยืนยันรหัสผ่านใหม่",
          "new_password": "รหัสผ่านใหม่"
        },
        "new": {
          "forgot_your_password": "ลืมรหัสผ่าน?",
          "send_me_reset_password_instructions": "ส่งคำขอตั้งรหัสผ่านใหม่"
        },
        "no_token": "คุณไม่สามารถเข้าถึงหน้าเว็บนี้โดยไม่ได้คลิกลิงค์จากอีเมล์ตั้งค่ารหัสผ่าน หากคุณคลิกลิงค์จากอีเมล์ตั้งค่ารหัสผ่านกรุณาตรวจสอบให้แน่ใจว่า URL ถูกต้องตามที่เราให้ไว้",
        "send_instructions": "คุณจะได้รับอีเมล์แนะนำการตั้งค่ารหัสผ่านในไม่ช้า",
        "send_paranoid_instructions": "หากอีเมล์ของคุณมีอยู่ในฐานข้อมูลในระบบแล้ว  คุณจะได้รับลิงค์กู้รหัสผ่านคืนในไม่ช้า",
        "updated": "รหัสผ่านของคุณเปลี่ยนแปลงเรียบร้อยแล้ว ขณะนี้คุณสามารถเข้าสู่ระบบโดยใช้รหัสผ่านใหม่ได้",
        "updated_not_active": "รหัสผ่านของคุณเปลี่ยนแปลงเรียบร้อยแล้ว"
      },
      "registrations": {
        "destroyed": "ลาก่อน! บัญชีของคุณถูกยกเลิกเรียบร้อยแล้ว เราหวังว่าจะได้พบคุณใหม่ในไม่ช้า",
        "edit": {
          "are_you_sure": "คุณแน่ใจหรือไม่?",
          "cancel_my_account": "ยกเลิกบัญชีของฉัน",
          "currently_waiting_confirmation_for_email": "ขณะนี้ ระบบรอการยืนยันอีเมล์ %{email} อยู่",
          "leave_blank_if_you_don_t_want_to_change_it": "เว้นว่างไว้ถ้าคุณไม่ต้องการจะเปลี่ยนแปลง",
          "title": "แก้ไข %{resource}",
          "unhappy": "ไม่พอใจ",
          "update": "ปรับข้อมูล",
          "we_need_your_current_password_to_confirm_your_changes": "เราต้องการรหัสผ่านปัจจุบันเพื่อยืนยันการเปลี่ยนรหัสของคุณ"
        },
        "new": {
          "sign_up": "สมัครสมาชิก"
        },
        "signed_up": "ยินดีต้อนรับ! คุณลงทะเบียนเรียบร้อยแล้ว",
        "signed_up_but_inactive": "คุณลงทะเบียนเรียบร้อยแล้ว แต่การเข้าสู่ระบบล้มเหลวเนื่องจากบัญชีของคุณยังไม่ได้เปิดใช้งาน",
        "signed_up_but_locked": "คุณลงทะเบียนเรียบร้อยแล้ว แต่การเข้าสู่ระบบล้มเหลวเนื่องจากบัญชีของคุณล็อก",
        "signed_up_but_unconfirmed": "ข้อความพร้อมลิงค์สำหรับยืนยันได้ส่งไปยังอีเมล์ของคุณแล้ว กรุณาคลิกลิงค์นั้นเพื่อเปิดใช้งานบัญชี",
        "update_needs_confirmation": "คุณได้อัพเดทบัญชีของคุณเรียบร้อยแล้ว แต่คุณต้องทำการยืนยันอีเมล์ใหม่นี้ กรุณาตรวจสอบอีเมล์และคลิกลิงค์เพื่อยืนยันที่อยู่อีเมล์ใหม่",
        "updated": "คุณอัพเดตบัญชีของคุณสำเร็จเรียบร้อยแล้ว",
        "updated_but_not_signed_in": "คุณอัพเดตบัญชีของคุณสำเร็จเรียบร้อยแล้ว แต่เนื่องจากคุณได้เปลี่ยนรหัสผ่าน คุณต้องเข้าสู่ระบบใหม่อีกครั้ง"
      },
      "sessions": {
        "already_signed_out": "ออกจากระบบเรียบร้อยแล้ว",
        "new": {
          "sign_in": "เข้าสู่ระบบ"
        },
        "signed_in": "เข้าสู่ระบบเรียบร้อยแล้ว",
        "signed_out": "ออกจากระบบเรียบร้อยแล้ว"
      },
      "shared": {
        "links": {
          "back": "กลับ",
          "didn_t_receive_confirmation_instructions": "ไม่ได้รับการยืนยันคำขอ?",
          "didn_t_receive_unlock_instructions": "ไม่ได้รับคำขอปลดล็อค?",
          "forgot_your_password": "ลืมรหัสผ่าน?",
          "sign_in": "เข้าสู่ระบบ",
          "sign_in_with_provider": "เข้าสู่ระบบด้วย %{provider}",
          "sign_up": "สมัครสมาชิก"
        },
        "minimum_password_length": {
          "other": "(จำนวนตัวอักษรขั้นต่ำ %{count} ตัวอักษร)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "ส่งคำขอปลดล็อคอีกครั้ง"
        },
        "send_instructions": "คุณจะได้รับอีเมล์แนะนำการปลดล็อกบัญชีในไม่ช้า",
        "send_paranoid_instructions": "หากบัญชีของคุณมีอยู่ในระบบแล้ว คุณจะได้รับอีเมล์แนะนำวิธีการปลดล็อกบัญชีในไม่ช้า",
        "unlocked": "บัญชีของคุณถูกปลดล็อกเรียบร้อยแล้ว กรุณาเข้าสู่ระบบเพื่อดำเนินการต่อ"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "ต้องถูกยอมรับ",
        "already_confirmed": "ยืนยันแล้ว ลองเข้าสู่ระบบ",
        "blank": "ต้องไม่เว้นว่างเอาไว้",
        "confirmation": "ไม่ตรงกับการยืนยัน",
        "confirmation_period_expired": "จำเป็นต้องได้รับการยืนยันในเวลา %{period}, กรุณาทำใหม่อีกครั้ง",
        "empty": "ต้องไม่เว้นว่างเอาไว้",
        "equal_to": "ต้องมีค่าเท่ากับ %{count}",
        "even": "ต้องเป็นจำนวนคู่",
        "exclusion": "ไม่ได้รับอนุญาตให้ใช้",
        "expired": "การยืนยันหมดอายุแล้ว กรุณาขอใหม่อีกครั้ง",
        "greater_than": "ต้องมากกว่า %{count}",
        "greater_than_or_equal_to": "ต้องมากกว่าหรือเท่ากับ %{count}",
        "inclusion": "ไม่ได้อยู่ในรายการ",
        "invalid": "ไม่ถูกต้อง",
        "less_than": "ต้องมีค่าน้อยกว่า %{count}",
        "less_than_or_equal_to": "ต้องมีค่าน้อยกว่าหรือเท่ากับ %{count}",
        "not_a_number": "ไม่ใช่ตัวเลข",
        "not_an_integer": "ไม่ใช่จำนวนเต็ม",
        "not_found": "ไม่พบ",
        "not_locked": "ไม่ถูกล็อก",
        "not_saved": {
          "other": "%{count} ผิดพลาด %{resource} นี้ถูกห้ามบันทึก:"
        },
        "odd": "ต้องเป็นจำนวนคี่",
        "taken": "ถูกใช้ไปแล้ว",
        "too_long": "ยาวเกินไป (ต้องไม่เกิน %{count} ตัวอักษร)",
        "too_short": "สั้นเกินไป (ต้องยาวกว่า %{count} ตัวอักษร)",
        "wrong_length": "มีความยาวไม่ถูกต้อง (ต้องมีความยาว %{count} ตัวอักษร)"
      },
      "template": {
        "body": "โปรดตรวจสอบข้อมูลในช่องต่อไปนี้:",
        "header": "พบข้อผิดพลาด %{count} ประการ ทำให้ไม่สามารถบันทึก%{model}ได้"
      }
    },
    "faker": {
      "name": {
        "first_name": [
          "สิริกิติ์",
          "อภิสิทธิ์",
          "อดิศักดิ์",
          "อักขระ",
          "อริศรา",
          "อมร",
          "อมรรัตน์",
          "อนันต์",
          "อนันตชัย",
          "อาณัติ",
          "อนุชา",
          "อภิชาติ",
          "อภิชาต",
          "อภิรักษ์",
          "อภิศักดิ์",
          "อภิญญา",
          "อารี",
          "อารีพงศ์",
          "อารง",
          "อาทิตย์",
          "อรุณศรี",
          "อัษรา",
          "อัษฎา",
          "บัณฑิตา",
          "บัญญัติ",
          "บุญศรี",
          "บุญรัตน์",
          "บุญเยี่ยม",
          "บุญยง",
          "บุษราคัม",
          "บุศวรรณ",
          "ชัยอนันต์",
          "ชัยพร",
          "จักรี",
          "เฉลิม",
          "ฉลวย",
          "ชนะ",
          "ชาญชัย",
          "ชนินทร์",
          "ชนิภรณ์",
          "จันทร์สิริ",
          "เชาวน์",
          "ชาติชาย",
          "ชาติ",
          "จตุพล",
          "ชิด",
          "ชมเกดุ",
          "ชุ่ม",
          "ชวน",
          "จุลภาส",
          "ชูวิทย์",
          "ดนัย",
          "แดง",
          "ดวงใจ",
          "ดวงกมล",
          "เดือนเพ็ญ",
          "ดุสิต",
          "เอกใหม่",
          "เอกพงษ์",
          "ฟุ้งฟ้า",
          "กานดา",
          "แก้วเก้า",
          "หทัย",
          "จารุวรรณ",
          "เจือ",
          "กมล",
          "กาญจนา",
          "กนกพร",
          "เกษม",
          "ขจี",
          "ขนิษฐา",
          "คลัง",
          "ขวัญจิต",
          "กล้าหาญ",
          "กระสินธ์",
          "กฤษฏิ์",
          "กุมโชค",
          "กุญชนิตา",
          "กุลพันธ์",
          "ขวัญชัย",
          "ขวัญใจ",
          "มาลี",
          "มะลิ",
          "มาณี",
          "มณี",
          "มานิจ",
          "มโน",
          "มณู",
          "มนู",
          "มานิตย์",
          "มารวย",
          "มงคล",
          "มนตรี",
          "มุกดา",
          "นาค",
          "นัยนา",
          "นาก",
          "เนาวรัตน์",
          "นภสร",
          "นรินทร์ศักดิ์",
          "นริศา",
          "ณรงค์ศักดิ์",
          "นฤมล",
          "นววรรณ",
          "ณี",
          "หนิว",
          "นีราชา",
          "นิตยา",
          "นงลักษณ์",
          "นงนุช",
          "นพดล",
          "นพคุณ",
          "นพรัตน์",
          "ณัฎฐา",
          "ณัฐิมา",
          "ไพรัช",
          "ไพฑูรย์",
          "ปานใจ",
          "ผาณิต",
          "พนิต",
          "พรรณี",
          "พนม",
          "ปานเทพ",
          "ภานุพัฒน์",
          "ปาริชาติ",
          "ปริญญา",
          "ภาสุระ",
          "พัชรพร",
          "พาที",
          "ปฐม",
          "ปฏิภาณ",
          "พัฒนา",
          "ปวีณา",
          "เพ็ญสุขภรณ์",
          "ปีย์รติ",
          "เพิ่ม",
          "เผด็จ",
          "ไพบูลย์",
          "ไพศักดิ์",
          "ไพศาล",
          "พาณิชย์",
          "พยนต์",
          "พิชิต",
          "พิจิตร",
          "พิมพ์ใจ",
          "พินิจ",
          "พิภพ",
          "พิริยะ",
          "ภิรมย์",
          "พลเดช",
          "ผ่องเพ็ญ",
          "ภรณ์พรรณ",
          "ภรณ์พันธ์",
          "พรพันธุ์",
          "ภรณ์พันธุ์",
          "พรพรรณ",
          "พรรัมภา",
          "ภุชงค์",
          "ภูมินทร์",
          "ภูมิพัฒน์",
          "พูนศักดิ์",
          "พิกุล",
          "พิมพ์วสี",
          "ปิติ",
          "ปีติ",
          "ปิยบุตร",
          "ปิยะคม",
          "ปิยวรรณ",
          "ป้อง",
          "พรชัย",
          "ประชา",
          "ประดิษฐ์",
          "ประมนต์",
          "ประมุข",
          "ปราณี",
          "ประพันธ์",
          "ประภาส",
          "ประสาน",
          "ประเสริฐ",
          "ประสิทธิ",
          "ประสงค์",
          "ประทีป",
          "ประทุม",
          "ปรัชญา",
          "ประเวช",
          "ประเวศ",
          "ประวิตร",
          "ประวิทย์",
          "ปรีชา",
          "ปรีดา",
          "เปรม",
          "ปัญญา",
          "ราม",
          "รินรดา",
          "รอง",
          "ฤดี",
          "รื่น",
          "รื่นฤดี",
          "รุ่งสิทธิ์",
          "รัตน์",
          "ฤทัย",
          "แสงดาว",
          "สายพิณ",
          "สายสมร",
          "ศักดา",
          "สากล",
          "ศักดิ์ทิพย์",
          "สกุล",
          "สลิลธร",
          "สมัคร",
          "สามารถ",
          "สมร",
          "สนั่น",
          "สังวาล",
          "สนิท",
          "สันติ",
          "สริตา",
          "ศศิธร",
          "สาธิต",
          "สาธิตยัง",
          "สว่าง",
          "สวัสดิ์",
          "สาวิทย์",
          "เสรี",
          "เซติอาวัน",
          "เซติยัง",
          "สิงห์",
          "ศิริ",
          "ศิริโชค",
          "ศิริณี",
          "ศิริพล",
          "ศิริพงศ์",
          "ศิริพร",
          "สิริรักษ์",
          "ศิริรัตน์",
          "ศิริวรรณ",
          "สีห์ศักดิ์",
          "ศรีศักดิ์",
          "สิทธิ",
          "โสภาค",
          "สมบัติ",
          "สมบูรณ์",
          "สมบุญ",
          "สมชาย",
          "สมโชค",
          "สมคิด",
          "สมควร",
          "สมลักษณ์",
          "สมหมาย",
          "สมเพียร",
          "สมภพ",
          "สมพงษ์",
          "สมพร",
          "สมรัตน์",
          "สมศักดิ์",
          "สมทรง",
          "สมศรี",
          "สมยศ",
          "สนธิ",
          "สุนทรี",
          "สุชาดา",
          "สุชาดาจะ",
          "สุชาย",
          "สุชาติ",
          "สุจินดา",
          "สุดา",
          "สุกัญญา",
          "สุหัตถ์",
          "สุจิต",
          "สุเมธ",
          "สุนัย",
          "สุนีย์",
          "สุนี",
          "ศุภชัย",
          "สุภาภรณ์",
          "ศุภวิทย์",
          "สุพรรณ",
          "สุภาพ",
          "ศุภวุฒิ",
          "สุพิชา",
          "สุพิศ",
          "ศุภผล",
          "ศุภรัตน์",
          "สุประภา",
          "สุรัตน์",
          "สุรี",
          "สุริยะ",
          "สุริยา",
          "สุธรรม",
          "สุเทพ",
          "สุทธิพล",
          "สุทธิพงศ์",
          "สุวรรณ",
          "สุวิชา",
          "สุวิทย์",
          "ธเนศ",
          "ตนุพล",
          "ธีรศักดิ์",
          "ทักษิณ",
          "ธนากร",
          "ธนาพร",
          "ถนัด",
          "ทวีฉัตร",
          "ถวิล",
          "ทวีป",
          "ทวีศักดิ์",
          "ทวีวงศ์",
          "ธีรภัทร",
          "ฐิตวรรณ",
          "ฐิติภรณ์",
          "ธงชัย",
          "ทัศนีย์",
          "อุบล",
          "อุบลวรรณ",
          "อุดม",
          "อุกิต",
          "อัญญาณี",
          "วีระ",
          "วิโรจน์",
          "วรภัทร",
          "วานี",
          "วัลลภา",
          "วัลลภ",
          "วรรณ",
          "วรรณา",
          "วันพล",
          "วราภรณ์",
          "วัชราภรณ์",
          "วัฒนา",
          "วิชัย",
          "วิจารณ์",
          "วิเชียร",
          "วิจิตร",
          "วิลาศ",
          "วินัย",
          "วีรยุทธ์",
          "วิภา",
          "วิภาภรณ์",
          "วีระ",
          "วีระชาย",
          "วีระชาติ",
          "วีระพันธุ์",
          "วีระพล",
          "วีรศักดิ์",
          "วีระศักดิ์",
          "วิรัช",
          "วิริยะ",
          "วิเศษ",
          "วิศิษฏ์",
          "วิทยา",
          "วรพร",
          "ญาณิน",
          "ยิ่งยศ",
          "ยุพิน",
          "ยุทธ์",
          "ยุวรัตน์",
          "เยาวพา",
          "อุกฤษฏ์",
          "สุดใจ",
          "สมจิต"
        ],
        "last_name": [
          "เคนเนะดิ",
          "ชินวัตร",
          "ตั้งตระกูล",
          "ติณสูลานนท์",
          "บุตโต",
          "พิศาลบุตร",
          "วอชิงตัน",
          "สมิท",
          "บราวน์",
          "สมิธ",
          "รักไทย",
          "เก่งงาน",
          "หงสกุล",
          "สโตเกอร์",
          "พันธุเมธา"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "โปรดเลือก"
      },
      "submit": {
        "create": "สร้าง%{model}",
        "submit": "บันทึก%{model}",
        "update": "ปรับปรุง%{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "บาท"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "พันล้าน",
            "million": "ล้าน",
            "quadrillion": "พันล้านล้าน",
            "thousand": "พัน",
            "trillion": "ล้านล้าน",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": "ไบต์",
            "gb": "จิกะไบต์",
            "kb": "กิโลไบต์",
            "mb": "เมกะไบต์",
            "tb": "เทระไบต์"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", และ ",
        "two_words_connector": " และ ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "ก่อนเที่ยง",
      "formats": {
        "default": "%a %d %b %Y %H:%M:%S %z",
        "long": "%d %B %Y %H:%M น.",
        "short": "%d %b %H:%M น."
      },
      "pm": "หลังเที่ยง"
    }
  },
  "tl": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": null,
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": null,
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": null,
          "password_confirmation": null,
          "remember_created_at": null,
          "remember_me": null,
          "reset_password_sent_at": null,
          "reset_password_token": null,
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": null,
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Nabigo ang pagpapatunay: %{errors}"
        }
      },
      "models": {
        "user": {
          "one": null,
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Lin",
        "Lun",
        "Mar",
        "Miy",
        "Huw",
        "Biy",
        "Sab"
      ],
      "abbr_month_names": [
        null,
        "Ene",
        "Peb",
        "Mar",
        "Abr",
        "May",
        "Hun",
        "Hul",
        "Ago",
        "Set",
        "Okt",
        "Nob",
        "Dis"
      ],
      "day_names": [
        "Linggo",
        "Lunes",
        "Martes",
        "Miyerkules",
        "Huwebes",
        "Biyernes",
        "Sabado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "ika-%d ng %B, %Y",
        "short": "ika-%d ng %b"
      },
      "month_names": [
        null,
        "Enero",
        "Pebrero",
        "Marso",
        "Abril",
        "Mayo",
        "Hunyo",
        "Hulyo",
        "Agosto",
        "Setyembre",
        "Oktubre",
        "Nobyembre",
        "Disyembre"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "humigit-kumulang isang oras",
          "other": "humigit-kumulang %{count} oras"
        },
        "about_x_months": {
          "one": "humigit-kumulang isang buwan",
          "other": "humigit-kumulang %{count} buwan"
        },
        "about_x_years": {
          "one": "humigit-kumulang isang taon",
          "other": "humigit-kumulang %{count} taon"
        },
        "almost_x_years": {
          "one": "halos isang taon",
          "other": "halos %{count} taon"
        },
        "half_a_minute": "kalahating minuto",
        "less_than_x_minutes": {
          "one": "mas mababa sa isang minuto",
          "other": "mas mababa sa %{count} minuto"
        },
        "less_than_x_seconds": {
          "one": "mas mababa sa isang segundo",
          "other": "mas mababa sa %{count} segundo"
        },
        "over_x_years": {
          "one": "higit sa isang taon",
          "other": "higit %{count} taon"
        },
        "x_days": {
          "one": "isang araw",
          "other": "%{count} araw"
        },
        "x_minutes": {
          "one": "isang minuto",
          "other": "%{count} minuto"
        },
        "x_months": {
          "one": "isang buwan",
          "other": "%{count} buwan"
        },
        "x_seconds": {
          "one": "isang segundo",
          "other": "%{count} segundo"
        }
      },
      "prompts": {
        "day": "araw",
        "hour": "oras",
        "minute": "minuto",
        "month": "buwan",
        "second": "segundo",
        "year": "taon"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ang iyong email address ay matagumpay na nakumpirma.",
        "new": {
          "resend_confirmation_instructions": "Muling ipadala ang mga tagubilin sa pagkumpirma."
        },
        "send_instructions": "Makakatanggap ka ng isang email na may instructions kung paano kukumpirmahin ang iyong email address san loob ng mga ilang minuto.",
        "send_paranoid_instructions": "Kung ang iyong email address ay nakikita sa aming database, makakatanggap ka ng isang email na may instructions kung paano kukumpirmahin ang iyong email address sa loob ng mga ilang minuto."
      },
      "failure": {
        "already_authenticated": "Naka-sign in ka na.",
        "inactive": "Hindi pa na-activate ang iyong account.",
        "invalid": null,
        "last_attempt": "Mayroon kang isa pang pagtatangka bago mai-lock ang iyong account.",
        "locked": "Naka-lock ang iyong account.",
        "not_found_in_database": null,
        "timeout": "Na-expire na ang iyong session. Mag-sign in ulit para magpatuloy.",
        "unauthenticated": "Kailangan mong mag-sign in o mag-sign up bago magpatuloy.",
        "unconfirmed": "Kailangan mong kumpirmahin ang iyong email address bago magpatuloy."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Ikumpirma ang aking account",
          "greeting": "Maligayang pagdating %{recipient}!",
          "instruction": "Maaari mong kumpirmahin ang iyong account email sa pamamagitan ng link sa ibaba:",
          "subject": "Mga Tagubilin ng Pagkumpirma"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Hello %{recipient}!",
          "message": "Kami'y nakikipag-ugnay sa iyo para abisuhan (notify) ka na nabago ang iyong password.",
          "subject": "Nabago ang Password"
        },
        "reset_password_instructions": {
          "action": "Baguhin ang aking password",
          "greeting": "Hello %{recipient}!",
          "instruction": "May isang tao na humiling ng isang link upang baguhin ang iyong password, at magagawa mo ito sa pamamagitan ng link sa ibaba.",
          "instruction_2": "Kung hindi mo hiniling ito, huwag pansinin ang email na ito.",
          "instruction_3": "Ang iyong password ay hindi magbabago hanggang ia-access mo ang link sa itaas at lumikha ng bago.",
          "subject": "I-reset ang mga tagubilin tungkol sa password"
        },
        "unlock_instructions": {
          "action": "I-unlock ang aking account",
          "greeting": "Hello %{recipient}!",
          "instruction": "I-click ang link sa ibaba upang i-unlock ang iyong account:",
          "message": "Na-lock ang iyong account dahil sa labis na dami ng hindi matagumpay na mga pagtatangka sa pag-sign in.",
          "subject": "Mga tagubilin sa pag-unlock"
        }
      },
      "omniauth_callbacks": {
        "failure": "Hindi ka ma-authenticate galing sa %{kind} dahil \"%{reason}\".",
        "success": "Matagumpay na na-authenticate galing sa %{kind} na account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Baguhin ang aking password",
          "change_your_password": "Baguhin ang iyong password",
          "confirm_new_password": "Kumpirmahin ang bagong password",
          "new_password": "Bagong password"
        },
        "new": {
          "forgot_your_password": "Nakalimutang ang iyong password?",
          "send_me_reset_password_instructions": "Padalhan mo ako ng mga tagubilin sa pag-reset ng password"
        },
        "no_token": "Hindi mo ma-access ang pahinang ito nang hindi nanggagaling sa isang email sa pag-reset ng password. Kung ikaw ay nagmula sa isang email ng pag-reset ng password, siguraduhin na ginamit mo ang buong URL na ibinigay.",
        "send_instructions": "Makakatanggap ka ng isang email na may mga tagubilin kung paano i-reset ang iyong password sa loob ng mga ilang minuto.",
        "send_paranoid_instructions": "Kung ang iyong email address ay nakikita sa aming database, makakatanggap ng isang password recovery link sa iyong email address sa loob ng mga ilang minuto.",
        "updated": "Matagumpay na nabago ang iyong password. Naka-sign in ka na ngayon.",
        "updated_not_active": "Matagumpay na nabago ang iyong password."
      },
      "registrations": {
        "destroyed": "Paalam! Matagumpay na na-kansela ang iyong account. Inaasahan naming makita ka muli sa lalong madaling panahon.",
        "edit": {
          "are_you_sure": "Sigurado ka ba?",
          "cancel_my_account": "Ikansela ang aking account",
          "currently_waiting_confirmation_for_email": "Kasalukuyang naghihintay ng kumpirmasyon para kay/sa: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "iwanang blangko kung ayaw mong baguhin ito",
          "title": "I-edit ang %{resource}",
          "unhappy": "Hindi masaya?",
          "update": "I-update",
          "we_need_your_current_password_to_confirm_your_changes": "kailangan namin ang iyong kasalukuyang password para makumpirma ang iyong mga pagbabago"
        },
        "new": {
          "sign_up": "Mag-sign up"
        },
        "signed_up": "Maligayang pagdating! Matagumpay kang nakapag-sign up.",
        "signed_up_but_inactive": "Matagumpay kang nakapag-sign up. Gayunpaman, hindi ka namin mai-sign in dahil hindi pa na-activate ang iyong account.",
        "signed_up_but_locked": "Matagumpay kang nakapag-sign up. Gayunpaman, hindi ka namin mai-sign in dahil naka-lock ang iyong account.",
        "signed_up_but_unconfirmed": "Isang mensahe na may link sa pagkumpirma ay ipinadala sa iyong email address. Paki-sundan ang link upang maisaaktibo ang iyong account.",
        "update_needs_confirmation": "Matagumpay mong na-update ang iyong account, ngunit kailangan naming i-verify ang iyong bagong email address. Paki-suri ng iyong email at sundin ang link ng kumpirmasyon upang kumpirmahin ang iyong bagong email address..",
        "updated": "Matagumpay na na-update ang iyong account.",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "Matagumpay na nakapag-sign out.",
        "new": {
          "sign_in": "Mag-sign in"
        },
        "signed_in": "Matagumpay na nakapag-sign in.",
        "signed_out": "Matagumpay na nakapag-sign out."
      },
      "shared": {
        "links": {
          "back": "Bumalik",
          "didn_t_receive_confirmation_instructions": "Hindi nakatanggap ng mga tagubilin sa pagkumpirma?",
          "didn_t_receive_unlock_instructions": "Hindi nakatanggap ng mga tagubilin sa pag-unlock?",
          "forgot_your_password": "Nakalimutang ang iyong password?",
          "sign_in": "Mag-sign in",
          "sign_in_with_provider": "Mag-sign in gamit ang %{provider}",
          "sign_up": "Mag-sign up"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Muling ipadala ang mga tagubilin sa pag-unlock"
        },
        "send_instructions": "Makakatanggap kayo ng isang email na may tagubilin kung paano i-unlock ang iyong account sa loob ng mga ilang minuto.",
        "send_paranoid_instructions": "Kung ang iyong account ay nag-eexist, makakatanggap kayo ng isang email na may tagubilin kung paano i-unlock ang iyong account sa ilang minuto.",
        "unlocked": "Ang iyong account ay matagumpay na nai-unlock. Mag-sign in para magpatuloy."
      }
    },
    "errors": {
      "format": "%{attribute} ay %{message}",
      "messages": {
        "accepted": "dapat na tanggapin",
        "already_confirmed": "ay nakumpirma na, pakisubukang mag-sign in",
        "blank": "hindi maaaring walang laman",
        "confirmation": "hindi tumutugma ang pagpapatunay",
        "confirmation_period_expired": "kailangang kumpirmahin sa loob %{period}, humiling ng bago",
        "empty": "hindi maaaring walang laman",
        "equal_to": "dapat na katumba sa %{count}",
        "even": "dapat maging even",
        "exclusion": "nakalaan na",
        "expired": "ay na-expire na, humiling ng bago",
        "greater_than": "dapat na mas higit sa %{count}",
        "greater_than_or_equal_to": "dapat na mas higit sa o katumbas ng %{count}",
        "inclusion": "hindi kasama sa listahan",
        "invalid": "hindi wasto",
        "less_than": "dapat na mas mababa sa %{count}",
        "less_than_or_equal_to": "dapat na mas mababa sa o katumbas ng %{count}",
        "not_a_number": "hindi isang numero",
        "not_an_integer": "dapat na isang integer",
        "not_found": "hindi mahanap",
        "not_locked": "ay hindi naka-lock",
        "not_saved": {
          "one": "1 error ay ipinagbawal itong %{resource} mula sa pag-save:",
          "other": "%{count} na mga error ay ipinagbawal itong %{resource} mula sa pag-save:"
        },
        "odd": "dapat maging odd",
        "taken": "ginagamit na",
        "too_long": {
          "one": "masyadong mahaba (pinakamadami ay %{count} character)",
          "other": "masyadong mahaba (pinakamadami ay %{count} character)"
        },
        "too_short": {
          "one": "masyadong maikli (pinakakonti ay %{count} character)",
          "other": "masyadong maikli (pinakakonti ay %{count} character)"
        },
        "wrong_length": {
          "one": "ang maling haba (ito ay dapat eksaktong %{count} character)",
          "other": "ang maling haba (ito ay dapat eksaktong %{count} character)"
        }
      },
      "template": {
        "body": "May mga problema sa mga sumusunod na patlang:",
        "header": {
          "one": "hindi maaaring i-save ang %{model} na ito dahil sa isang error",
          "other": "hindi maaaring i-save ang %{model} na ito dahil sa %{count} error"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Mangyaring pumili"
      },
      "submit": {
        "create": "lumikha ng %{model}",
        "submit": "isumite ang %{model}",
        "update": "i-update ang %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₱"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "bilyon",
            "million": "milyon",
            "quadrillion": "kuwadrilyon",
            "thousand": "libo",
            "trillion": "trilyon",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", at",
        "two_words_connector": " at ",
        "words_connector": ","
      }
    },
    "time": {
      "am": "AM",
      "formats": {
        "default": "%A, ika-%d ng %B ng %Y %H:%M:%S %z",
        "long": "ika-%d ng %B ng %Y %H:%M",
        "short": "%d ng %b %H:%M"
      },
      "pm": "PM"
    }
  },
  "tr": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Onaylama gönderildi",
          "confirmation_token": "Onaylama jetonu",
          "confirmed_at": "Onaylandı",
          "created_at": "Oluşturuldu",
          "current_password": "Geçerli Parola",
          "current_sign_in_at": "Mevcut giriş",
          "current_sign_in_ip": "Mevcut giriş IP",
          "email": "E-Posta",
          "encrypted_password": "Şifrelenmiş parola",
          "failed_attempts": "Başarısız girişler",
          "last_sign_in_at": "Son giriş",
          "last_sign_in_ip": "Son giriş IP",
          "locked_at": "Kilitlendi",
          "password": "Parola",
          "password_confirmation": "Parola Doğrulama",
          "remember_created_at": "Oluşturulma tarihini hatırla",
          "remember_me": "Beni Hatırla",
          "reset_password_sent_at": "Parola sıfırlaması gönderildi",
          "reset_password_token": "Parola sıfırlama jetonu",
          "sign_in_count": "Giriş sayısı",
          "unconfirmed_email": "Onaylanmayan e-posta",
          "unlock_token": "Jetonun kilidini kaldır",
          "updated_at": "Güncellendi"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Doğrulama başarısız oldu: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Bağlı kayıtlar %{record} bulunduğu için kayıt silinemedi",
            "has_one": "Bağlı bir kayıt %{record} bulunduğu için kayıt silinemedi"
          }
        }
      },
      "models": {
        "user": {
          "one": "Kullanıcı",
          "other": "Kullanıcı"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Pzr",
        "Pzt",
        "Sal",
        "Çrş",
        "Prş",
        "Cum",
        "Cts"
      ],
      "abbr_month_names": [
        null,
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
      ],
      "day_names": [
        "Pazar",
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e %B %Y %A",
        "short": "%e %b"
      },
      "month_names": [
        null,
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "yaklaşık %{count} saat",
          "other": "yaklaşık %{count} saat"
        },
        "about_x_months": {
          "one": "yaklaşık %{count} ay",
          "other": "yaklaşık %{count} ay"
        },
        "about_x_years": {
          "one": "yaklaşık %{count} yıl",
          "other": "yaklaşık %{count} yıl"
        },
        "almost_x_years": {
          "one": "neredeyse %{count} yıl",
          "other": "neredeyse %{count} yıl"
        },
        "half_a_minute": "yarım dakika",
        "less_than_x_minutes": {
          "one": "%{count} dakikadan az",
          "other": "%{count} dakikadan az"
        },
        "less_than_x_seconds": {
          "one": "%{count} saniyeden az",
          "other": "%{count} saniyeden az"
        },
        "over_x_years": {
          "one": "%{count} yıldan fazla",
          "other": "%{count} yıldan fazla"
        },
        "x_days": {
          "one": "%{count} gün",
          "other": "%{count} gün"
        },
        "x_minutes": {
          "one": "%{count} dakika",
          "other": "%{count} dakika"
        },
        "x_months": {
          "one": "%{count} ay",
          "other": "%{count} ay"
        },
        "x_seconds": {
          "one": "%{count} saniye",
          "other": "%{count} saniye"
        },
        "x_years": {
          "one": "%{count} yıl",
          "other": "%{count} yıl"
        }
      },
      "prompts": {
        "day": "Gün",
        "hour": "Saat",
        "minute": "Dakika",
        "month": "Ay",
        "second": "Saniye",
        "year": "Yıl"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Hesabınız başarıyla onaylandı. Şu an giriş yapmış bulunuyorsunuz.",
        "new": {
          "resend_confirmation_instructions": "Onaylama talimatlarını tekrar gönder"
        },
        "send_instructions": "Birkaç dakika içinde hesabınızı nasıl onaylayacağınızı anlatan bir e-posta alacaksınız.",
        "send_paranoid_instructions": "Eğer e-posta adresiniz sistemimizde kayıtlı ise, birkaç dakika içinde hesabınızı nasıl onaylayacağınızı anlatan bir e-posta alacaksınız."
      },
      "failure": {
        "already_authenticated": "Zaten giriş yaptınız.",
        "inactive": "Hesabınız daha aktifleştirilmemiş.",
        "invalid": "Geçersiz %{authentication_keys} veya parola.",
        "invited": "Hesap oluşturmak için bekleyen davetiyenizi kabul edin",
        "last_attempt": "Hesabınız askıya alınmadan önce son bir deneme hakkınız kaldı.",
        "locked": "Hesabınız kilitlendi.",
        "not_found_in_database": "Geçersiz %{authentication_keys} veya parola.",
        "timeout": "Oturumunuz sonlandı. Devam etmek için, lütfen yeniden giriş yapınız.",
        "unauthenticated": "Devam etmeden önce giriş yapmanız veya kayıt olmanız gereklidir.",
        "unconfirmed": "Devam etmeden önce hesabınızı onaylamalısınız."
      },
      "invitations": {
        "edit": {
          "header": "Şifre oluştur",
          "submit_button": "Şifremi oluştur"
        },
        "invitation_removed": "Davetiyeniz silindi",
        "invitation_token_invalid": "Davetiye tokenı geçerli değil!",
        "new": {
          "header": "Davetiye gönderildi",
          "submit_button": "Davetiye gönder"
        },
        "no_invitations_remaining": "Davetiye kalmadı",
        "send_instructions": "%{email} adresine davetiye maili gönderildi.",
        "updated": "Şifreniz başarıyla oluşturuldu ve giriş yaptınız",
        "updated_not_active": "Şifreniz başarıyla oluşturuldu."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Hesabımı onayla",
          "greeting": "Hoşgeldiniz %{recipient}!",
          "instruction": "E-postanızı aşağıdaki bağlantıyı takip ederek onaylayabilirsiniz:",
          "subject": "Onaylama talimatları"
        },
        "email_changed": {
          "greeting": "Merhaba %{recipient}!",
          "message": "E-posta adresin %{email} değiştirildiğinde seni bilgilendirmek için iletişime geçeceğiz.",
          "message_unconfirmed": "E-posta adresiniz %{email} olarak değiştirildiğinde sizi bilgilendirmek için iletişime geçeceğiz.",
          "subject": "E-posta Değiştirildi"
        },
        "invitation_instructions": {
          "accept": "Daveti kabul et",
          "hello": "Merhaba %{email}",
          "ignore": "Daveti kabul etmek istemiyorsanız bu maili yoksayabilirsiniz.<br />Aşağıdaki linke tıklayıp şifrenizi oluşturmadan hesabınız oluşturulmayacaktır.",
          "someone_invited_you": "%{url} adresine davet edildiniz. Kabul etmek için aşağıdaki linke tıklayınız.",
          "subject": "Davetiye adımları"
        },
        "password_change": {
          "greeting": "Merhaba %{recipient}!",
          "message": "Parolanız değiştirildiğinde seni bilgilendirmek için iletişime geçeceğiz.",
          "subject": "Parola Değişti"
        },
        "reset_password_instructions": {
          "action": "Parolamı değiştir",
          "greeting": "Merhaba %{recipient}!",
          "instruction": "Birisi parolanızı değiştirmek için bir istek gönderdi, aşağıdaki bağlantıyı kullanarak bunu yapabilirsiniz.",
          "instruction_2": "Eğer bu isteği siz yapmadıysanız, bu e-postayı görmezden gelebilirsiniz.",
          "instruction_3": "Parolanız yukarıdaki bağlantıyı kullanıp, yeni bir parola oluşturmadığınız sürece değişmeyecektir.",
          "subject": "Parola sıfırlama talimatları"
        },
        "unlock_instructions": {
          "action": "Hesabımı geri aç",
          "greeting": "Merhaba %{recipient}!",
          "instruction": "Hesabınızı geri açmak için aşağıdaki bağlantıyı tıklayınız:",
          "message": "Hesabınız çok fazla başarısız giriş denemesinden dolayı kilitlenmiştir.",
          "subject": "Kilit açma talimatları"
        }
      },
      "omniauth_callbacks": {
        "failure": "Sizi %{kind} aracılığıyla tanıyamadık çünkü \"%{reason}\".",
        "success": "%{kind} aracılığıyla onaylandınız."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Parolamı değiştir",
          "change_your_password": "Parolanı değiştir",
          "confirm_new_password": "Yeni parolanı doğrula",
          "new_password": "Yeni Parola"
        },
        "new": {
          "forgot_your_password": "Parolanızı mı unuttunuz?",
          "send_me_reset_password_instructions": "Parola yenileme talimatlarını gönder"
        },
        "no_token": "Bu sayfaya parola sıfırlama e-postasındaki bağlantıya tıklayarak gelmeniz gerekmektedir. Bağlantıya tıklamak yerine kopyaladıysanız, hata yapmış olabilirsiniz. Lütfen parola sıfırlama e-postasındaki bağlantıya tıklayın.",
        "send_instructions": "Birkaç dakika içinde parolanızı nasıl sıfırlayacağınız ile ilgili bir e-posta alacaksınız.",
        "send_paranoid_instructions": "Eğer e-posta adresiniz sistemimizde kayıtlı ise, birkaç dakika içinde parolanızı nasıl sıfırlayacağınız ile ilgili bir e-posta alacaksınız.",
        "updated": "Parolanız başarıyla güncellendi. Şu an giriş yapmış bulunuyorsunuz.",
        "updated_not_active": "Parolanız başarıyla güncellendi."
      },
      "registrations": {
        "destroyed": "Hesabınız başarıyla kapatıldı. En kısa sürede görüşmek üzere!",
        "edit": {
          "are_you_sure": "Emin misiniz?",
          "cancel_my_account": "Hesabımı iptal et",
          "currently_waiting_confirmation_for_email": "Doğrulama için bekleniyor : %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "değiştirmek istemiyorsanız boş bırakın",
          "title": "%{resource} düzenle",
          "unhappy": "Mutsuz",
          "update": "Güncelle",
          "we_need_your_current_password_to_confirm_your_changes": "değişikleri onaylamak için şu anki parolanız gerekli"
        },
        "new": {
          "sign_up": "Kaydol"
        },
        "signed_up": "Başarıyla giriş yaptınız. Hoşgeldiniz!",
        "signed_up_but_inactive": "Kaydınız başarıyla gerçekleşti. Fakat, hesabınız aktifleştirilmediği için siteye giriş yapamadınız.",
        "signed_up_but_locked": "Kaydınız başarıyla gerçekleşti. Fakat, hesabınız kilitlendiği için siteye giriş yapamadınız.",
        "signed_up_but_unconfirmed": "E-posta adresinize hesap aktifleştirme bağlantısını içeren bir e-posta gönderdik. Hesabınızı aktifleştirmek için lütfen e-posta ile gönderdiğimiz bağlantıyı açın.",
        "update_needs_confirmation": "Hesabınızı başarıyla güncellediniz, fakat yeni e-posta adresinizin onaylanması gerek. Yeni e-posta hesabınızın onaylanması için lütfen size gönderdiğimiz e-postada bulunan onay bağlantısını açın.",
        "updated": "Hesabınız başarıyla güncellendi.",
        "updated_but_not_signed_in": "Hesabınız başarıyla güncellendi, ancak parola değiştirildiğinde yeniden giriş yapmalısınız"
      },
      "sessions": {
        "already_signed_out": "Başarıyla çıkış yapıldı.",
        "new": {
          "sign_in": "Giriş yap"
        },
        "signed_in": "Başarıyla giriş yapıldı.",
        "signed_out": "Başarıyla çıkış yapıldı."
      },
      "shared": {
        "links": {
          "back": "Geri",
          "didn_t_receive_confirmation_instructions": "Onaylama talimatlarını almadınız mı?",
          "didn_t_receive_unlock_instructions": "Hesap geri açma talimatlarını almadınız mı?",
          "forgot_your_password": "Parolanızı mı unuttunuz?",
          "sign_in": "Giriş yap",
          "sign_in_with_provider": "%{provider} ile giriş yap",
          "sign_up": "Kaydol"
        },
        "minimum_password_length": {
          "one": "(Minimum %{count} karakter)",
          "other": "(Minimum %{count} karakter)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Hesap geri açma talimatlarını tekrar gönder"
        },
        "send_instructions": "Birkaç dakika içerisinde hesap kilidi açma talimatlarını içeren bir e-posta alacaksınız.",
        "send_paranoid_instructions": "Eğer hesabınız varsa, birkaç dakika içerisinde hesap kilidi açma talimatlarını içeren bir e-posta alacaksınız.",
        "unlocked": "Hesabınızın kilidi başarıyla açıldı. Devam etmek için lütfen giriş yapın."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "kabul edilmeli",
        "already_confirmed": "zaten onaylanmış, lütfen giriş yapmayı deneyin",
        "blank": "doldurulmalı",
        "confirmation": "%{attribute} teyidiyle uyuşmuyor",
        "confirmation_period_expired": "%{period} içinde onaylanması gerekmektedir, lütfen yeni bir tane isteyiniz.",
        "empty": "doldurulmalı",
        "equal_to": "tam olarak %{count} olmalı",
        "even": "çift olmalı",
        "exclusion": "kullanılamaz",
        "expired": "süresi doldu, lütfen yeni bir tane isteyin",
        "greater_than": "%{count} sayısından büyük olmalı",
        "greater_than_or_equal_to": "%{count} sayısına eşit veya büyük olmalı",
        "inclusion": "kabul edilen bir kelime değil",
        "invalid": "geçersiz",
        "less_than": "%{count} sayısından küçük olmalı",
        "less_than_or_equal_to": "%{count} sayısına eşit veya küçük olmalı",
        "model_invalid": "Doğrulama başarısız oldu: %{errors}",
        "not_a_number": "geçerli bir sayı değil",
        "not_an_integer": "tam sayı olmalı",
        "not_found": "bulunamadı",
        "not_locked": "kilitlenmemiş",
        "not_saved": {
          "one": "%{count} tane hata %{resource}'ın kaydını engelledi.",
          "other": "%{count} tane hata %{resource}'ın kaydını engelledi."
        },
        "odd": "tek olmalı",
        "other_than": "%{count} karakterden oluşamaz",
        "present": "boş bırakılmalı",
        "required": "doldurulmalı",
        "taken": "hali hazırda kullanılmakta",
        "too_long": {
          "one": "çok uzun (en fazla %{count} karakter)",
          "other": "çok uzun (en fazla %{count} karakter)"
        },
        "too_short": {
          "one": "çok kısa (en az %{count} karakter)",
          "other": "çok kısa (en az %{count} karakter)"
        },
        "wrong_length": {
          "one": "hatalı uzunlukta (%{count} karakter olmalı)",
          "other": "hatalı uzunlukta (%{count} karakter olmalı)"
        }
      },
      "template": {
        "body": "Lütfen aşağıdaki hataları düzeltiniz:",
        "header": {
          "one": "%{count} hata oluştuğu için %{model} kaydedilemedi",
          "other": "%{count} hata oluştuğu için %{model} kaydedilemedi"
        }
      }
    },
    "faker": {
      "address": {
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "İstanbul",
          "İzmir",
          "Eskişehir",
          "Şırnak",
          "Edirne",
          "Van"
        ],
        "country": [
          "Afganistan",
          "Amerika Birleşik Devletleri",
          "Fransa",
          "Hollanda",
          "Belçika",
          "Nepal",
          "Hindistan",
          "Kuala Lumpur",
          "Rusya"
        ],
        "default_country": [
          "Turkey"
        ],
        "default_country_code": [
          "TR"
        ]
      },
      "book": {
        "author": "#{Name.name}",
        "publisher": [
          "Babıali Kültür Yayıncılığı",
          "İletişim Yayınları",
          "Turkuvaz Kitap",
          "Kaynak Yayınları"
        ],
        "quote": [
          "Sabır acıdır, meyvesi tatlıdır",
          "Dost kara günde belli olur",
          "Çıkmayan candan umit kesilmez",
          "Gözden uzak olan gönülden de uzak olur."
        ],
        "title": [
          "Taht Oyunları",
          "Maymunlar Gezegeni",
          "Benim Adım Kırmızı",
          "Uykuların Doğusu",
          "Yılanların Öcü"
        ]
      },
      "internet": {
        "domain_suffix": [
          "co",
          "com",
          "com.tr",
          "net",
          "org"
        ]
      },
      "name": {
        "first_name": [
          "Mehmet",
          "Yiğit",
          "Batuhan",
          "Burak",
          "İrem",
          "Buse",
          "Selim",
          "Caner"
        ],
        "last_name": [
          "Davut",
          "Sağdıç",
          "Özdemir",
          "Özkanlı",
          "Ekkaldır",
          "Zengel",
          "Eren"
        ],
        "name": [
          "#{prefix} #{first_name} #{last_name}",
          "#{first_name} #{last_name}",
          "#{last_name} #{first_name}"
        ],
        "name_with_middle": [
          "#{prefix} #{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}"
        ],
        "prefix": [
          "Sn.",
          "Av.",
          "Dr."
        ],
        "title": {
          "job": [
            "Müdür",
            "Şef",
            "Koordinatör",
            "Ajan",
            "Hacı",
            "Başkan",
            "Reyiz"
          ]
        }
      },
      "phone_number": {
        "formats": [
          "90-###-###-####",
          "90.###.###.####",
          "90 ### ### ####",
          "90##########"
        ]
      }
    },
    "helpers": {
      "select": {
        "prompt": "Lütfen seçiniz"
      },
      "submit": {
        "create": "%{model} Ekle",
        "submit": "%{model} Kaydet",
        "update": "%{model} Güncelle"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₺"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Milyar",
            "million": "Milyon",
            "quadrillion": "Katrilyon",
            "thousand": "Bin",
            "trillion": "Trilyon",
            "unit": ""
          }
        },
        "format": {
          "delimiter": ".",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Bayt",
              "other": "Bayt"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "nth": {
        "ordinalized": "%{number}.",
        "ordinals": "."
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%%n"
        }
      },
      "precision": {
        "format": {
          "delimiter": "."
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " ve ",
        "two_words_connector": " ve ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "öğleden önce",
      "formats": {
        "default": "%a %d.%b.%y %H:%M",
        "long": "%e %B %Y, %A, %H:%M",
        "short": "%e %B, %H:%M"
      },
      "pm": "öğleden sonra"
    }
  },
  "tt": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Хаталар чыкты: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Язмышны бетереп булмады, чөнки бәйлелекләр табылды: %{record}",
            "has_one": "Язмышны бетереп булмады, чөнки бәйлелек табылды: %{record}"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Якш",
        "Дүш",
        "Сиш",
        "Чәр",
        "Пән",
        "Җом",
        "Шим"
      ],
      "abbr_month_names": [
        null,
        "гыйн.",
        "февр.",
        "март",
        "апр.",
        "май",
        "июнь",
        "июль",
        "авг.",
        "сент.",
        "окт.",
        "нояб.",
        "дек."
      ],
      "day_names": [
        "якшәмбе",
        "дүшәмбе",
        "сишәмбе",
        "чәршәмбе",
        "пәнҗешәмбе",
        "җомга",
        "шимбә"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "гыйнвар",
        "февраль",
        "март",
        "апрель",
        "май",
        "июнь",
        "июль",
        "август",
        "сентябрь",
        "октябрь",
        "ноябрь",
        "декабрь"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "бер сәгать чамасы",
          "other": "%{count} сәгать чамасы"
        },
        "about_x_months": {
          "one": "бер ай чамасы",
          "other": "%{count} ай чамасы"
        },
        "about_x_years": {
          "one": "бер ел чамасы",
          "other": "%{count} ел чамасы"
        },
        "almost_x_years": {
          "one": "бер ел диярлек",
          "other": "%{count} ел диярлек"
        },
        "half_a_minute": "минуттан азрак",
        "less_than_x_minutes": {
          "one": "бер минуттан азрак",
          "other": "%{count} минуттан азрак"
        },
        "less_than_x_seconds": {
          "one": "бер секундтан азрак",
          "other": "%{count} секундтан азрак"
        },
        "over_x_years": {
          "one": "бер ел артык",
          "other": "%{count} ел артык"
        },
        "x_days": {
          "one": "бер көн",
          "other": "%{count} көн"
        },
        "x_minutes": {
          "one": "бер минут",
          "other": "%{count} минут"
        },
        "x_months": {
          "one": "бер ай",
          "other": "%{count} ай"
        },
        "x_seconds": {
          "one": "бер секунд",
          "other": "%{count} секунд"
        }
      },
      "prompts": {
        "day": "Көн",
        "hour": "Сәгать",
        "minute": "Минут",
        "month": "Ай",
        "second": "Секунд",
        "year": "Ел"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "раслау кирәк",
        "blank": "буш була алмый",
        "confirmation": "%{attribute} читнең мәгнәсе белән тигез түгел",
        "empty": "буш була алмый",
        "equal_to": "мәгнәсе %{count} була гына ала",
        "even": "так кына була ала",
        "exclusion": "резервта саклау дигән әһәмияте бар",
        "greater_than": "%{count} мәгнәсеннән зур була ала",
        "greater_than_or_equal_to": "%{count} мәгнәсеннән зур яки тигез була ала",
        "inclusion": "мәгнәсе алдан исәпкә алынган түгел",
        "invalid": "мәгнәсе ялгыш",
        "less_than": "%{count} мәгнәсеннән азрак була ала",
        "less_than_or_equal_to": "%{count} мәгнәсеннән азрак яки тигез була ала",
        "not_a_number": "сан тугел",
        "not_an_integer": "бөтен сан түгел",
        "odd": "җөп кенә була ала",
        "other_than": "%{count} мәгнәсеннән икенче булырга тиеш",
        "present": "буш булырга тиеш",
        "taken": "бар инде",
        "too_long": {
          "one": "бигрәк озын (озынлыгы бердән озынрак була алмый)",
          "other": "бигрәк озын (озынлыгы %{count} мәгнәсеннән озынрак була алмый)"
        },
        "too_short": {
          "one": "бигрәк кыска (озынлыгы бердән кыскарак була алмый)",
          "other": "бигрәк кыска (озынлыгы %{count} мәгнәсеннән кыскарак була алмый)"
        },
        "wrong_length": {
          "one": "озынлыгы ялгыш (озынлыгы бергә тигез булырга тиеш)",
          "other": "озынлыгы ялгыш (озынлыгы %{count} мәгнәгә тигез булырга тиеш)"
        }
      },
      "template": {
        "body": ":",
        "header": {
          "one": "%{model}: %{count} хата аркасында саклау чыкмады",
          "other": "%{model}: %{count} хата аркасында саклау чыкмады"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Сайлагыз: "
      },
      "submit": {
        "create": "%{model} иҗат итергә",
        "submit": "%{model} саклап калырга",
        "update": "%{model} саклап калырга"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "сум"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "миллиард",
              "other": "миллиард"
            },
            "million": {
              "one": "миллион",
              "other": "миллион"
            },
            "quadrillion": {
              "one": "квадриллион",
              "other": "квадриллион"
            },
            "thousand": {
              "one": "мең",
              "other": "мең"
            },
            "trillion": {
              "one": "триллион",
              "other": "триллион"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "байт",
              "other": "байт"
            },
            "gb": "ГБ",
            "kb": "КБ",
            "mb": "МБ",
            "tb": "ТБ"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " һәм ",
        "two_words_connector": " һәм ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "иртәнге",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "кичке"
    }
  },
  "ua": {
    "devise": {
      "failure": {
        "invited": "Вас очікує ще не прийняте запрошення, прийміть його, щоб завершити створення облікового запису."
      },
      "invitations": {
        "edit": {
          "header": "Встановіть ваш пароль",
          "submit_button": "Встановити мій пароль"
        },
        "invitation_removed": "Ваше запрошення було видалено.",
        "invitation_token_invalid": "Передано неправильний токен запрошення!",
        "new": {
          "header": "Надсилання запрошення",
          "submit_button": "Надіслати запрошення"
        },
        "no_invitations_remaining": "Не лишилось запрошень",
        "send_instructions": "Лист з запрошенням було відправлено на %{email}.",
        "updated": "Пароль успішно встановлено. Ви успішно увійшли.",
        "updated_not_active": "Ваш пароль успішно встановлено."
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "Прийняти запрошення",
          "accept_until": "Це запрошення дійсне до %{due_date}.",
          "hello": "Вітаємо, %{email}",
          "ignore": "Якщо ви не хочете приймати запрошення, будь ласка, ігноруйте цього листа.<br />Ваш акаунт не буде створено, доти, доки ви не перейдете за посиланням вище і не встановите свій пароль.",
          "someone_invited_you": "Дехто запросив вас на %{url}, ви можете прийняти запрошення за посиланням нижче.",
          "subject": "Інструкції для запрошення"
        }
      }
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%I:%M %p %B %d, %Y"
            }
          }
        }
      }
    }
  },
  "ug": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "%{errors} دا خاتالىق بار",
          "restrict_dependent_destroy": {
            "has_many": "%{record} بۇ مەلۇماتنى ئىشلىتىدۇ، شۇڭا ئۆچۈرگىلى بولمايدۇ",
            "has_one": "%{record} بۇ مەلۇماتنى ئىشلىتىدۇ، شۇڭا ئۆچۈرگىلى بولمايدۇ"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "يەكشەنبە",
        "دۈشەنبە",
        "سەيشەنبە",
        "چارشەنبە",
        "پەيشەنبە",
        "جۈمە",
        "شەنبە"
      ],
      "abbr_month_names": [
        null,
        "يانۋار",
        "فېۋرال",
        "مارت",
        "ئاپرېل",
        "ماي",
        "ئىيۇن",
        "ئىيۇل",
        "ئاۋغۇست",
        "سېنتەبىر",
        "ئۆكتەبىر",
        "نويابىر",
        "دېكابىر"
      ],
      "day_names": [
        "يەكشەنبە",
        "دۈشەنبە",
        "سەيشەنبە",
        "چارشەنبە",
        "پەيشەنبە",
        "جۈمە",
        "شەنبە"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y-%m-%d",
        "short": "%b%d"
      },
      "month_names": [
        null,
        "يانۋار",
        "فېۋرال",
        "مارت",
        "ئاپرېل",
        "ماي",
        "ئىيۇن",
        "ئىيۇل",
        "ئاۋغۇست",
        "سېنتەبىر",
        "ئۆكتەبىر",
        "نويابىر",
        "دېكابىر"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "تەخمىنەن بىر سائەت",
          "other": "تەخمىنەن %{count} سائەت"
        },
        "about_x_months": {
          "one": "تەخمىنەن بىر ئاي",
          "other": "تەخمىنەن %{count} ئاي"
        },
        "about_x_years": {
          "one": "تەخمىنەن بىر يىل",
          "other": "تەخمىنەن %{count} يىل"
        },
        "almost_x_years": {
          "one": "بىر يىلغا يېقىن",
          "other": "%{count} يىلغا يېقىن"
        },
        "half_a_minute": "يېرىم مىنۇت",
        "less_than_x_minutes": {
          "one": "بىر مىنۇتقا يەتمىگەن",
          "other": "%{count} مىنۇتقا يەتمىگەن"
        },
        "less_than_x_seconds": {
          "one": "بىر سىكۇنتقا يەتمىگەن",
          "other": "%{count} سىكنۇتقا"
        },
        "over_x_years": {
          "one": "بىر يىلدىن ئارتۇق",
          "other": "%{count} يىلدىن ئارتۇق"
        },
        "x_days": {
          "one": "بىر كۈن",
          "other": "%{count} كۈن"
        },
        "x_minutes": {
          "one": "بىر مىنۇت",
          "other": "%{count} مىنۇت"
        },
        "x_months": {
          "one": "بىر ئاي",
          "other": "%{count} ئاي"
        },
        "x_seconds": {
          "one": "بىر سىكنۇت",
          "other": "%{count} سىكنۇت"
        }
      },
      "prompts": {
        "day": "كۈن",
        "hour": "سائەت",
        "minute": "مىنۇت",
        "month": "ئاي",
        "second": "سىكنۇت",
        "year": "يىل"
      }
    },
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "تەستىقلاش كېرەك",
        "blank": "بوش بولماسلىقى كېرەك",
        "confirmation": "تەستىق بىلەن ماس ئەمەس",
        "empty": "بوش بولماسلىقى كېرەك",
        "equal_to": "%{count} غا تەڭ",
        "even": "جۈپ سان",
        "exclusion": "مۇمكىن ئەمەس",
        "greater_than": "%{count} دىن چوڭ",
        "greater_than_or_equal_to": "%{count} دىن چوڭ ياكى تەڭ",
        "inclusion": "كۈتىلمىگەن نەتىجە",
        "invalid": "ئىناۋەتسىز",
        "less_than": "%{count} دىن كىچىك",
        "less_than_or_equal_to": "%{count} دىن كىچىك ياكى تەڭ",
        "not_a_number": "سان ئەمەس",
        "not_an_integer": "پۈتۈن سان ئەمەس",
        "odd": "تاق سان",
        "other_than": "ئىناۋەتسىز ئۇزۇنلۇق (%{count} ھەرىپ بولماسلىقى كېرەك)",
        "present": "بوش بولىشى كېرەك",
        "taken": "ئىشلىتىپ بولۇنغان",
        "too_long": {
          "one": "بەك ئۇزۇن (بىر ھەرىپ)",
          "other": "بەك ئۇزۇن (ئەڭ ئۇزۇن بولغاندا %{count} ھەرىپ)"
        },
        "too_short": {
          "one": "بەك قىسقا (بىر ھەرىپ)",
          "other": "بەك قىسقا (ئەڭ قىسقا بولغاندا %{count} ھەرىپ)"
        },
        "wrong_length": {
          "one": "ئىناۋەتسىز ئۇزۇنلۇق (بىر ھەرىپ)",
          "other": "ئىناۋەتسىز ئۇزۇنلۇق (چوقۇم %{count} ھەرىپ)"
        }
      },
      "template": {
        "body": "تۆۋەندىكى سۆز بۆلەكلىرىدە خاتالىق بار",
        "header": {
          "one": "بىر خاتالىق تۈپەيلىدىن 「%{model}」 ساقلاش مەغلۇب بولدى",
          "other": "%{count} خاتالىق تۈپەيلىدىن 「%{model}」ساقلاش مەغلۇب بولدى"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "تاللاڭ"
      },
      "submit": {
        "create": "%{model} قوشۇش",
        "submit": "%{model} ساقلاش",
        "update": "%{model} يېڭىلاش"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "CN¥"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "مىليارد",
            "million": "مىليون",
            "quadrillion": "گېگابايت",
            "thousand": "مىڭ",
            "trillion": "مېگا",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "بايت",
              "other": "بايت"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " ۋە ",
        "two_words_connector": " ۋە ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "چۈشتىن بۇرۇن",
      "formats": {
        "default": "%Y %b %d %A %H:%M:%S %Z",
        "long": "%Y %b %d %H:%M",
        "short": "%b %d %H:%M"
      },
      "pm": "چۈشتىن كېيىن"
    }
  },
  "uk": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Підтвердження надіслано о",
          "confirmation_token": "Код підтвердження",
          "confirmed_at": "Підтверджено",
          "created_at": "Створено",
          "current_password": "Поточний пароль",
          "current_sign_in_at": "Поточна сесія відкрита",
          "current_sign_in_ip": "IP поточної сесії",
          "email": "Адреса електронної пошти",
          "encrypted_password": "Зашифрований пароль",
          "failed_attempts": "Хибних спроб",
          "last_sign_in_at": "Останній раз заходив",
          "last_sign_in_ip": "IP останнього заходу",
          "locked_at": "Заблокований",
          "password": "Пароль",
          "password_confirmation": "Підтвердження пароля",
          "remember_created_at": "Нагадування створене",
          "remember_me": "Запам'ятати мене",
          "reset_password_sent_at": "Листа для скидання пароля надіслано",
          "reset_password_token": "Посилання на скидання пароля",
          "sign_in_count": "Кількість входів",
          "unconfirmed_email": "Не підтверджений email",
          "unlock_token": "Токен розблокування",
          "updated_at": "Змінений"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Виникли помилки: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Неможливо видалити запис, так як існують залежності: %{record}",
            "has_one": "Неможливо видалити запис, так як існує залежність: %{record}"
          }
        }
      },
      "models": {
        "user": {
          "few": "Користувач",
          "many": "Користувач",
          "one": "Користувач",
          "other": "Користувач"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "нд.",
        "пн.",
        "вт.",
        "ср.",
        "чт.",
        "пт.",
        "сб."
      ],
      "abbr_month_names": [
        null,
        "січ.",
        "лют.",
        "бер.",
        "квіт.",
        "трав.",
        "черв.",
        "лип.",
        "серп.",
        "вер.",
        "жовт.",
        "лист.",
        "груд."
      ],
      "day_names": [
        "неділя",
        "понеділок",
        "вівторок",
        "середа",
        "четвер",
        "п'ятниця",
        "субота"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Січня",
        "Лютого",
        "Березня",
        "Квітня",
        "Травня",
        "Червня",
        "Липня",
        "Серпня",
        "Вересня",
        "Жовтня",
        "Листопада",
        "Грудня"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "близько %{count} годин",
          "many": "близько %{count} годин",
          "one": "близько %{count} години",
          "other": "близько %{count} години"
        },
        "about_x_months": {
          "few": "близько %{count} місяців",
          "many": "близько %{count} місяців",
          "one": "близько %{count} місяця",
          "other": "близько %{count} місяця"
        },
        "about_x_years": {
          "few": "близько %{count} років",
          "many": "близько %{count} років",
          "one": "близько %{count} року",
          "other": "близько %{count} року"
        },
        "almost_x_years": {
          "few": "майже %{count} роки",
          "many": "майже %{count} років",
          "one": "майже %{count} рік",
          "other": "майже %{count} років"
        },
        "half_a_minute": "пів хвилини",
        "less_than_x_minutes": {
          "few": "менше %{count} хвилин",
          "many": "менше %{count} хвилин",
          "one": "менше %{count} хвилини",
          "other": "менше %{count} хвилини"
        },
        "less_than_x_seconds": {
          "few": "менше %{count} секунд",
          "many": "менше %{count} секунд",
          "one": "менше %{count} секунди",
          "other": "менше %{count} секунди"
        },
        "over_x_years": {
          "few": "більше %{count} років",
          "many": "більше %{count} років",
          "one": "більше %{count} року",
          "other": "більше %{count} року"
        },
        "x_days": {
          "few": "%{count} дні",
          "many": "%{count} днів",
          "one": "%{count} день",
          "other": "%{count} дня"
        },
        "x_minutes": {
          "few": "%{count} хвилини",
          "many": "%{count} хвилин",
          "one": "%{count} хвилина",
          "other": "%{count} хвилини"
        },
        "x_months": {
          "few": "%{count} місяці",
          "many": "%{count} місяців",
          "one": "%{count} місяць",
          "other": "%{count} місяця"
        },
        "x_seconds": {
          "few": "%{count} секунди",
          "many": "%{count} секунд",
          "one": "%{count} секунда",
          "other": "%{count} секунди"
        },
        "x_years": {
          "few": "%{count} роки",
          "many": "%{count} років",
          "one": "%{count} рік",
          "other": "%{count} року"
        }
      },
      "prompts": {
        "day": "День",
        "hour": "Година",
        "minute": "Хвилина",
        "month": "Місяць",
        "second": "Секунда",
        "year": "Рік"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Ваш обліковий запис підтверджено. Ви увійшли в систему.",
        "new": {
          "resend_confirmation_instructions": "Повторно надіслати вказівки з підтвердження"
        },
        "send_instructions": "Ви отримаєте листа з вказівками щодо підтвердження вашого облікового запису протягом декількох хвилин.",
        "send_paranoid_instructions": "Якщо Ваша адреса електронної пошти наявна в нашій базі даних, то протягом декількох хвилин Ви отримаєте листа з вказівками щодо підтвердження Вашого облікового запису."
      },
      "failure": {
        "already_authenticated": "Ви вже увійшли в систему.",
        "inactive": "Ваш обліковий запис ще не активовано.",
        "invalid": "Невірні %{authentication_keys} або пароль.",
        "last_attempt": "У вас залишилась ще одна спроба перед блокуванням облікового запису.",
        "locked": "Ваш обліковий запис заблоковано.",
        "not_found_in_database": "Невірні %{authentication_keys} або пароль.",
        "timeout": "Час вашої сесії вичерпано. Будь ласка, увійдіть в систему знову.",
        "unauthenticated": "Вам необхідно увійти в систему чи зареєструватися.",
        "unconfirmed": "Вам потрібно підтвердити Ваш обліковий запис."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Підтвердити мій обліковий запис",
          "confirm_account_link": "Підтвердіть свій обліковий запис",
          "confirm_link_msg": "Ви можете підтвердити вашу адресу електронної пошти через посилання нижче:",
          "greeting": "Ласкаво просимо, %{recipient}!",
          "instruction": "Ви можете підтвердити свою адресу електронної пошти через посилання нижче:",
          "subject": "Інструкції підтвердження"
        },
        "email_changed": {
          "greeting": "Вітаємо, %{recipient}!",
          "message": "Ми звертаємось до вас щоб повідомити про те, що вашу адресу електронної пошти було змінено на %{email}.",
          "message_unconfirmed": "Ми звертаємось до вас щоб повідомити про те, що вашу адресу електронної пошти буде змінено на %{email}.",
          "subject": "Адресу електронної пошти змінено"
        },
        "password_change": {
          "greeting": "Вітаємо, %{recipient}!",
          "message": "Ми намагаємося зв'язатися з Вами, щоб сповістити, що Ваш пароль було змінено.",
          "subject": "Пароль змінено"
        },
        "reset_password_instructions": {
          "action": "Зміна паролю",
          "greeting": "Доброго дня, %{recipient}!",
          "ignore_mail_msg": "Якщо Ви не робили запит на це, Ви можете проігнорувати цей лист.",
          "instruction": "Хтось подав запит на зміну Вашого паролю, Ви можете підтвердити цю зміну через посилання нижче.",
          "instruction_2": "Якщо Ви не робили запит на зміну паролю - проігноруйте це повідомлення.",
          "instruction_3": "Ваш пароль не мінятиметься, доки Ви не перейдете за посиланням вище і не створите новий.",
          "no_changes_msg": "Ваш пароль не зміниться, доки Ви не відкриєте посилання вище і не створите новий пароль.",
          "password_change_link": "Змінити пароль",
          "request_reset_link_msg": "Хтось зробив запит на зміну паролю. Ви можете зробити це через посилання нижче.",
          "subject": "Інструкція по скиданню паролю"
        },
        "unlock_instructions": {
          "account_lock_msg": "Ваш акаунт було заблоковано через надмірну кількість невдалих спроб входу.",
          "action": "Розблокувати мій обліковий запис",
          "greeting": "Доброго дня, %{recipient}!",
          "instruction": "Перейдіть за нижченаведеним посиланням, щоб розблокувати обліковий запис:",
          "message": "Ваш обліковий запис був заблокований через велику кількість невдалих спроб входу.",
          "subject": "Інструкції з розблокування",
          "unlock_link": "Розблокувати мій обліковий запис",
          "unlock_link_msg": "Перейдіть за посиланням нижче, щоб розблокувати свій акаунт:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Ви не можете увійти в систему з обліковим записом %{kind}, тому що \"%{reason}\".",
        "success": "Успішний вхід в систему з обліковим записом %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Змінити мій пароль",
          "change_your_password": "Змінити Ваш пароль",
          "confirm_new_password": "Підтвердьте новий пароль",
          "new_password": "Новий пароль"
        },
        "new": {
          "forgot_your_password": "Забули пароль?",
          "send_me_reset_password_instructions": "Відправити мені вказівки щодо скидання паролю"
        },
        "no_token": "Ця сторінка доступна тільки під час переходу з листа для скидання паролю. Якщо Ви все-таки перейшли через посилання з нього, будь ласка, переконайтесь, що використали повний URL.",
        "send_instructions": "Протягом декількох хвилин Ви отримаєте листа з вказівками щодо скидання Вашого пароля.",
        "send_paranoid_instructions": "Якщо Ваша адреса електронної пошти наявна в нашій базі даних, то протягом декількох хвилин Ви отримаєте листа з вказівками щодо відновлення пароля.",
        "updated": "Ваш пароль змінено. Ви увійшли в систему.",
        "updated_not_active": "Ваш пароль успішно змінено."
      },
      "registrations": {
        "destroyed": "Бувайте! Ваш обліковий запис було успішно видалено. Сподіваємось незабаром побачитись з Вами знову.",
        "edit": {
          "are_you_sure": "Ви впевнені?",
          "cancel_my_account": "Скасувати мій обліковий запис",
          "currently_waiting_confirmation_for_email": "В даний час очікуємо підтвердження від: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "залиште порожнім, якщо ви не хочете змінити його",
          "title": "Редагувати %{resource}",
          "unhappy": "Незадоволені",
          "update": "Оновити",
          "we_need_your_current_password_to_confirm_your_changes": "введіть свій поточний пароль для підтвердження змін"
        },
        "new": {
          "sign_up": "Зареєструватись"
        },
        "signed_up": "Ласкаво просимо! Ви успішно зареєструвалися.",
        "signed_up_but_inactive": "Ви успішно зареєструвалися, але не можете увійти в систему, тому що ваш обліковий запис ще не активовано.",
        "signed_up_but_locked": "Ви успішно зареєструвалися, але не можете увійти в систему, тому що ваш обліковий запис заблоковано.",
        "signed_up_but_unconfirmed": "Ви отримаєте листа з вказівками щодо підтвердження облікового запису протягом декількох хвилин.",
        "update_needs_confirmation": "Ваш обліковий запис оновлено, але необхідно підтвердити нову адресу електронної пошти. Будь ласка, перевірте свою електронну скриньку і перейдіть за посиланням \"Підтвердити\", шоб завершити оновлення адреси електронної пошти.",
        "updated": "Ваш обліковий запис змінено.",
        "updated_but_not_signed_in": "Ваш обліковий запис оновлено, але через зміну паролю вам потрібно знову зайти в систему."
      },
      "sessions": {
        "already_signed_out": "Успішний вихід з системи.",
        "new": {
          "sign_in": "Увійти"
        },
        "signed_in": "Ви увійшли в систему.",
        "signed_out": "Успішний вихід з системи."
      },
      "shared": {
        "links": {
          "back": "Повернутися",
          "didn_t_receive_confirmation_instructions": "Не отримали листа з підтвердженням?",
          "didn_t_receive_unlock_instructions": "Не отримали вказівок з розблокування?",
          "forgot_your_password": "Забули пароль?",
          "sign_in": "Увійти",
          "sign_in_with_provider": "Увійти за допомогою %{provider}",
          "sign_up": "Зареєструватися"
        },
        "minimum_password_length": {
          "few": "(мінімум %{count} символа)",
          "many": "(мінімум %{count} символів)",
          "one": "(мінімум %{count} символ)",
          "other": "(мінімум %{count} символів)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Повторно надіслати вказівки з розблокування"
        },
        "send_instructions": "Протягом декількох хвилин Ви отримаєте лист з вказівками щодо розблокування облікового запису.",
        "send_paranoid_instructions": "Якщо обліковий запис наявний, то протягом декількох хвилин Ви отримаєте листа з вказівками щодо його розблокування.",
        "unlocked": "Обліковий запис розблоковано. Ви увійшли в систему."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Перенаправлення до '%{redirect_url}' не дозволено."
      },
      "passwords": {
        "missing_email": "Ви маєте ввести email адресу.",
        "missing_passwords": "Ви маєте заповнити поля з назвами 'Пароль' та 'Підтвердження паролю'.",
        "missing_redirect_url": "Немає URL для перенаправлення.",
        "not_allowed_redirect_url": "Перенаправлення до '%{redirect_url}' не дозволено.",
        "password_not_required": "Цей акаунт не потребує паролю. Увійдіть використовуючи натомість акаунт провайдера '%{provider}'.",
        "sended": "Лист з інструкціями для скидання паролю відправлено на '%{email}'.",
        "successfully_updated": "Ваш пароль було успішно оновлено.",
        "user_not_found": "Неможливо знайти користувача по email '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Неможливо знайти акаунт для видалення.",
        "account_with_uid_destroyed": "Акаунт з UID '%{uid}' було видалено.",
        "email_already_exists": "Акаунт для емейлу '%{email}' вже існує",
        "missing_confirm_success_url": "Немає параметру 'confirm_success_url'",
        "redirect_url_not_allowed": "Перенаправлення до '%{redirect_url}' не дозволено.",
        "user_not_found": "Користувача не знайдено"
      },
      "sessions": {
        "bad_credentials": "Логін або пароль введені невірно. Будь ласка, спробуйте ще",
        "not_confirmed": "Будь ласка підтвердіть реєстрацію згідно інструкціям як ми вислали на Вашу пошту %{email}",
        "not_supported": "Використовуйте POST /sign_in для входу. GET запити не пітримуються.",
        "user_not_found": "Користувач не знайдений або не увійшов в систему"
      },
      "token_validations": {
        "invalid": "Помилкові дані"
      },
      "unlocks": {
        "missing_email": "Ви маєте вказати адресу електронної пошти.",
        "missing_passwords": "Ви маєте заповнити поля 'пароль' і 'підтвердіть пароль'.",
        "missing_redirect_url": "Відсутня адреса переадресації.",
        "not_allowed_redirect_url": "Переадресація до %{redirect_url} не дозволена.",
        "password_not_required": "Цей обліковий запис не потребує паролю. Увійдіть використовуючи обліковий запис '%{provider}'.",
        "sended": "Інструкція по відновленню паролю відправлена на Вашу електронну адресу.",
        "successfully_updated": "Ваш пароль успішно оновлено.",
        "user_not_found": "Не виходить знайти користувача з електронною адресою %{email}."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "має бути прийнятий",
        "already_confirmed": "вже підтверджено. Будь ласка, спробуйте увійти в систему",
        "blank": "не може бути пустим",
        "confirmation": "не збігається з підтвердженням",
        "confirmation_period_expired": "має бути підтверджено протягом %{period}, будь ласка, подайте запит на підтвердження запису ще раз",
        "empty": "не може бути порожнім",
        "equal_to": "має дорівнювати %{count}",
        "even": "має бути парним",
        "exclusion": "зарезервовано",
        "expired": "застаріла. Будь ласка, спробуйте знову",
        "greater_than": "має бути більше ніж %{count}",
        "greater_than_or_equal_to": "має бути більше ніж або дорівнювати %{count}",
        "inclusion": "не включено до переліку",
        "invalid": "недійсний",
        "less_than": "має бути менше ніж %{count}",
        "less_than_or_equal_to": "має бути менше ніж або дорівнювати %{count}",
        "model_invalid": "Виникли помилки: %{errors}",
        "not_a_number": "не число",
        "not_an_integer": "не є цілим числом",
        "not_email": "не є електронною адресою",
        "not_found": "не знайдено",
        "not_locked": "не заблоковано",
        "not_saved": {
          "few": "%{resource}: не вдалося зберегти через %{count} помилки",
          "many": "%{resource}: не вдалося зберегти через %{count} помилок",
          "one": "%{resource}: не вдалося зберегти через %{count} помилку",
          "other": "%{resource}: не вдалося зберегти через %{count} помилок"
        },
        "odd": "має бути непарним",
        "other_than": "має відрізнятись від %{count}",
        "present": "має бути пустим",
        "required": "не може бути порожнім",
        "taken": "вже зайнятий",
        "too_long": {
          "few": "занадто довгий (максимум %{count} знаки)",
          "many": "занадто довгий (максимум %{count} знаків)",
          "one": "занадто довгий (максимум %{count} знак)",
          "other": "занадто довгий (максимум %{count} знаку)"
        },
        "too_short": {
          "few": "занадто короткий (мінімум %{count} знаки)",
          "many": "занадто короткий (мінімум %{count} знаків)",
          "one": "занадто короткий (мінімум %{count} знак)",
          "other": "занадто короткий (мінімум %{count} знаку)"
        },
        "validate_account_update_params": "Будь ласка, відправте вірні дані для оновлення акаунту в тілі запиту.",
        "validate_sign_up_params": "Будь ласка, відправте вірні дані для реєстрації в тілі запиту.",
        "wrong_length": {
          "few": "неправильна довжина (має бути %{count} знаки)",
          "many": "неправильна довжина (має бути %{count} знаків)",
          "one": "неправильна довжина (має бути %{count} знак)",
          "other": "неправильна довжина (має бути %{count} знаку)"
        }
      },
      "template": {
        "body": "Помилки виявлено в таких полях:",
        "header": {
          "few": "%{model} не збережено через %{count} помилки",
          "many": "%{model} не збережено через %{count} помилок",
          "one": "%{model} не збережено через %{count} помилку",
          "other": "%{model} не збережено через %{count} помилки"
        }
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#",
          "##",
          "1##"
        ],
        "city": [
          "#{city_name}"
        ],
        "city_name": [
          "Алчевськ",
          "Артемівськ",
          "Бердичів",
          "Бердянськ",
          "Біла Церква",
          "Бровари",
          "Вінниця",
          "Горлівка",
          "Дніпродзержинськ",
          "Дніпропетровськ",
          "Донецьк",
          "Євпаторія",
          "Єнакієве",
          "Житомир",
          "Запоріжжя",
          "Івано-Франківськ",
          "Ізмаїл",
          "Кам’янець-Подільський",
          "Керч",
          "Київ",
          "Кіровоград",
          "Конотоп",
          "Краматорськ",
          "Красний Луч",
          "Кременчук",
          "Кривий Ріг",
          "Лисичанськ",
          "Луганськ",
          "Луцьк",
          "Львів",
          "Макіївка",
          "Маріуполь",
          "Мелітополь",
          "Миколаїв",
          "Мукачеве",
          "Нікополь",
          "Одеса",
          "Олександрія",
          "Павлоград",
          "Полтава",
          "Рівне",
          "Севастополь",
          "Сєвєродонецьк",
          "Сімферополь",
          "Слов’янськ",
          "Суми",
          "Тернопіль",
          "Ужгород",
          "Умань",
          "Харків",
          "Херсон",
          "Хмельницький",
          "Черкаси",
          "Чернівці",
          "Чернігів",
          "Шостка",
          "Ялта"
        ],
        "city_prefix": [],
        "city_suffix": [],
        "country": [
          "Австралія",
          "Австрія",
          "Азербайджан",
          "Албанія",
          "Алжир",
          "Ангола",
          "Андорра",
          "Антигуа і Барбуда",
          "Аргентина",
          "Афганістан",
          "Багамські Острови",
          "Бангладеш",
          "Барбадос",
          "Бахрейн",
          "Беліз",
          "Бельгія",
          "Бенін",
          "Білорусь",
          "Болгарія",
          "Болівія",
          "Боснія і Герцеговина",
          "Ботсвана",
          "Бразилія",
          "Бруней",
          "Буркіна-Фасо",
          "Бурунді",
          "Бутан",
          "В’єтнам",
          "Вануату",
          "Ватикан",
          "Велика Британія",
          "Венесуела",
          "Вірменія",
          "Габон",
          "Гаїті",
          "Гайана",
          "Гамбія",
          "Гана",
          "Гватемала",
          "Гвінея",
          "Гвінея-Бісау",
          "Гондурас",
          "Гренада",
          "Греція",
          "Грузія",
          "Данія",
          "Демократична Республіка Конго",
          "Джибуті",
          "Домініка",
          "Домініканська Республіка",
          "Еквадор",
          "Екваторіальна Гвінея",
          "Еритрея",
          "Естонія",
          "Ефіопія",
          "Єгипет",
          "Ємен",
          "Замбія",
          "Зімбабве",
          "Ізраїль",
          "Індія",
          "Індонезія",
          "Ірак",
          "Іран",
          "Ірландія",
          "Ісландія",
          "Іспанія",
          "Італія",
          "Йорданія",
          "Кабо-Верде",
          "Казахстан",
          "Камбоджа",
          "Камерун",
          "Канада",
          "Катар",
          "Кенія",
          "Киргизстан",
          "Китай",
          "Кіпр",
          "Кірибаті",
          "Колумбія",
          "Коморські Острови",
          "Конго",
          "Коста-Рика",
          "Кот-д’Івуар",
          "Куба",
          "Кувейт",
          "Лаос",
          "Латвія",
          "Лесото",
          "Литва",
          "Ліберія",
          "Ліван",
          "Лівія",
          "Ліхтенштейн",
          "Люксембург",
          "Маврикій",
          "Мавританія",
          "Мадаґаскар",
          "Македонія",
          "Малаві",
          "Малайзія",
          "Малі",
          "Мальдіви",
          "Мальта",
          "Марокко",
          "Маршаллові Острови",
          "Мексика",
          "Мозамбік",
          "Молдова",
          "Монако",
          "Монголія",
          "Намібія",
          "Науру",
          "Непал",
          "Нігер",
          "Нігерія",
          "Нідерланди",
          "Нікарагуа",
          "Німеччина",
          "Нова Зеландія",
          "Норвегія",
          "Об’єднані Арабські Емірати",
          "Оман",
          "Пакистан",
          "Палау",
          "Панама",
          "Папуа-Нова Гвінея",
          "Парагвай",
          "Перу",
          "Південна Корея",
          "Південний Судан",
          "Південно-Африканська Республіка",
          "Північна Корея",
          "Польща",
          "Португалія",
          "Російська Федерація",
          "Руанда",
          "Румунія",
          "Сальвадор",
          "Самоа",
          "Сан-Марино",
          "Сан-Томе і Принсіпі",
          "Саудівська Аравія",
          "Свазіленд",
          "Сейшельські Острови",
          "Сенеґал",
          "Сент-Вінсент і Гренадини",
          "Сент-Кітс і Невіс",
          "Сент-Люсія",
          "Сербія",
          "Сирія",
          "Сінгапур",
          "Словаччина",
          "Словенія",
          "Соломонові Острови",
          "Сомалі",
          "Судан",
          "Суринам",
          "Східний Тимор",
          "США",
          "Сьєрра-Леоне",
          "Таджикистан",
          "Таїланд",
          "Танзанія",
          "Того",
          "Тонга",
          "Тринідад і Тобаго",
          "Тувалу",
          "Туніс",
          "Туреччина",
          "Туркменістан",
          "Уганда",
          "Угорщина",
          "Узбекистан",
          "Україна",
          "Уругвай",
          "Федеративні Штати Мікронезії",
          "Фіджі",
          "Філіппіни",
          "Фінляндія",
          "Франція",
          "Хорватія",
          "Центральноафриканська Республіка",
          "Чад",
          "Чехія",
          "Чилі",
          "Чорногорія",
          "Швейцарія",
          "Швеція",
          "Шрі-Ланка",
          "Ямайка",
          "Японія"
        ],
        "default_country": [
          "Україна"
        ],
        "default_country_code": [
          "UA"
        ],
        "feminine_street_prefix": [
          "вул.",
          "вулиця",
          "пл.",
          "площа"
        ],
        "feminine_street_title": [
          "Зелена",
          "Молодіжна",
          "Городоцька",
          "Стрийська",
          "Вузька",
          "Староміська"
        ],
        "full_address": [
          "#{street_address}, #{city}, #{state}, #{postcode}"
        ],
        "masculine_street_prefix": [
          "пр.",
          "проспект",
          "пров.",
          "провулок"
        ],
        "masculine_street_title": [
          "Нижанківського",
          "Ліста",
          "Вічева",
          "Рудного"
        ],
        "postcode": [
          "#####"
        ],
        "secondary_address": [
          "кв. #",
          "кв. ##",
          "кв. ###"
        ],
        "state": [
          "АР Крим",
          "Вінницька область",
          "Волинська область",
          "Дніпропетровська область",
          "Донецька область",
          "Житомирська область",
          "Закарпатська область",
          "Запорізька область",
          "Івано-Франківська область",
          "Київська область",
          "Кіровоградська область",
          "Луганська область",
          "Львівська область",
          "Миколаївська область",
          "Одеська область",
          "Полтавська область",
          "Рівненська область",
          "Сумська область",
          "Тернопільська область",
          "Харківська область",
          "Херсонська область",
          "Хмельницька область",
          "Черкаська область",
          "Чернівецька область",
          "Чернігівська область",
          "Київ",
          "Севастополь"
        ],
        "state_abbr": [],
        "street_address": [
          "#{street_name}, #{building_number}"
        ],
        "street_name": [
          "#{feminine_street_prefix} #{feminine_street_title}",
          "#{masculine_street_prefix} #{masculine_street_title}"
        ],
        "street_prefix": [
          "вул.",
          "вулиця",
          "пр.",
          "проспект",
          "пл.",
          "площа",
          "пров.",
          "провулок"
        ],
        "street_suffix": [],
        "street_title": [
          "Зелена",
          "Молодіжна",
          "Городоцька",
          "Стрийська",
          "Вузька",
          "Нижанківського",
          "Староміська",
          "Ліста",
          "Вічева",
          "Брюховичів",
          "Винників",
          "Рудного",
          "Коліївщини"
        ]
      },
      "artist": {
        "names": [
          "Пабло Пікассо",
          "Поль Сезанн",
          "Густав Клімт",
          "Клод Моне",
          "Марсель Дюшан",
          "Анрі Матісс",
          "Джексон Поллок",
          "Енді Уорхол",
          "Віллем де Кунінг",
          "Пієт Мондріан",
          "Поль Гоген",
          "Френсіс Бекон",
          "Роберт Раушенберг",
          "Жорж Брак",
          "Василь Кандинський",
          "Костянтин Бранкузі",
          "Казимир Малевич",
          "Джаспер Джонс",
          "Фрида Кало",
          "Мартін Кіппенбергер",
          "Вільям Бугро",
          "Сандро Ботічеллі",
          "Ежен Делакруа",
          "Іван Айвазовський",
          "Сальвадор Далі",
          "Рембрант ван Рейн",
          "Мікеланджело",
          "Ілля Рєпін",
          "Петер Пауль Рубенс",
          "Вінсент Ван Гог",
          "Рафаель Санті",
          "Леонардо да Вінчі"
        ]
      },
      "cell_phone": {
        "formats": [
          "(044) ###-##-##",
          "(050) ###-##-##",
          "(063) ###-##-##",
          "(066) ###-##-##",
          "(073) ###-##-##",
          "(091) ###-##-##",
          "(092) ###-##-##",
          "(093) ###-##-##",
          "(094) ###-##-##",
          "(095) ###-##-##",
          "(096) ###-##-##",
          "(097) ###-##-##",
          "(098) ###-##-##",
          "(099) ###-##-##"
        ]
      },
      "commerce": {
        "color": [
          "абрикосовий",
          "аквамариновий",
          "амарантовий",
          "аметистовий",
          "багряний",
          "багряний",
          "баклажановий",
          "барвінковий",
          "бежевий",
          "блаватний",
          "блакитний",
          "блакитно-зелений",
          "блакитно-фіолетовий",
          "блідо-брунатний",
          "блідо-волошковий",
          "блідо-карміновий",
          "блідо-каштановий",
          "блідо-пурпурний",
          "блідо-пісочний",
          "блідо-рожевий",
          "болотний",
          "бронзовий",
          "брунатний",
          "брунатно-малиновий",
          "бузковий",
          "бурий",
          "бурштиновий",
          "білий",
          "бірюзовий",
          "бірюзовий",
          "волошковий",
          "гарбузовий",
          "голубий",
          "гірчичний",
          "джинсовий",
          "жовтий",
          "жовто-зелений",
          "жовто-коричневий",
          "жовто-персиковий",
          "зелений",
          "зеленувато-блакитний",
          "золотаво-березовий",
          "золотий",
          "золотисто-каштановий",
          "каштановий",
          "кобальтовий",
          "кораловий",
          "кремовий",
          "кукурудзяний",
          "лазуровий",
          "лазурово-синій",
          "латунний",
          "лимонний",
          "лимонно-кремовий",
          "ліловий",
          "малахітовий",
          "малиновий",
          "морквяний",
          "мідний",
          "м’ятний",
          "небесно-блакитний",
          "нефритовий",
          "ніжно-блакитний",
          "ніжно-рожевий",
          "оливковий",
          "опівнічно-синій",
          "оранжево-рожевий",
          "пастельно-зелений",
          "пастельно-рожевий",
          "персиковий",
          "помаранчевий",
          "помаранчево-персиковий",
          "пурпурний",
          "пшеничний",
          "рожевий",
          "рожево-ліловий",
          "салатовий",
          "сапфіровий",
          "світло-синій",
          "сиваво-зелений",
          "синьо-фіолетовий",
          "синій",
          "сливовий",
          "смарагдовий",
          "срібний",
          "сірий",
          "темно-брунатний",
          "темно-бірюзовий",
          "темно-зелений",
          "темно-золотий",
          "темно-карміновий",
          "темно-каштановий",
          "темно-кораловий",
          "темно-лососевий",
          "темно-мандариновий",
          "темно-оливковий",
          "темно-персиковий",
          "темно-рожевий",
          "темно-синій",
          "темно-фіолетовий",
          "фіолетовий",
          "червоний",
          "червоно-коричневий",
          "червоно-пурпурний",
          "чорний",
          "шафрановий",
          "шоколадний",
          "яскраво-бурштиновий",
          "яскраво-бірюзовий",
          "яскраво-зелений",
          "яскраво-рожевий",
          "яскраво-фіолетовий",
          "ясно-брунатний",
          "ясно-вишневий"
        ],
        "department": [
          "Книги",
          "Фільми",
          "Музика",
          "Ігри",
          "Електроніка",
          "Комп’ютери",
          "Дім",
          "Садові інструменти",
          "Бакалія",
          "Здоров’я",
          "Краса",
          "Іграшки",
          "Для дітей",
          "Для немовлят",
          "Одяг",
          "Взуття",
          "Прикраси",
          "Спорт",
          "Туризм",
          "Для автомобілів",
          "Промислові інструменти"
        ],
        "product_name": {
          "adjective": [
            "маленький",
            "ергономічний",
            "грубий",
            "інтелектуальний",
            "прекрасний",
            "неймовірний",
            "фантастичний",
            "практичний",
            "блискучий",
            "вражаючий",
            "величезний",
            "важкий",
            "легкий",
            "аеродинамічний",
            "міцний"
          ],
          "material": [
            "стальний",
            "дерев’яний",
            "бетонний",
            "пластиковий",
            "бавовняний",
            "гранітний",
            "гумовий",
            "шкіряний",
            "шовковий",
            "шерстяний",
            "мармуровий",
            "бронзовий",
            "мідний",
            "алюмінієвий",
            "паперовий"
          ],
          "product": [
            "стілець",
            "автомобіль",
            "комп’ютер",
            "берет",
            "кулон",
            "стіл",
            "светр",
            "ремінь",
            "ніж",
            "піджак",
            "годинник",
            "гаманець",
            "планшет",
            "телефон",
            "телевізор",
            "стіл",
            "холодильник",
            "радіатор",
            "молоток",
            "унітаз",
            "диван"
          ]
        }
      },
      "company": {
        "name": [
          "#{prefix} #{Name.female_first_name}",
          "#{prefix} #{Name.male_first_name}",
          "#{prefix} #{Name.male_last_name}",
          "#{prefix} #{Address.city_name}#{product}#{suffix}",
          "#{prefix} #{Address.city_name}#{suffix}"
        ],
        "prefix": [
          "ТОВ",
          "ПАТ",
          "ПрАТ",
          "ТДВ",
          "КТ",
          "ПТ",
          "ДП",
          "ФОП"
        ],
        "product": [
          "вапняк",
          "камінь",
          "цемент",
          "бурштин",
          "пісок",
          "метал",
          "мазут",
          "бітум",
          "цегла",
          "скло",
          "дерево"
        ],
        "suffix": [
          "постач",
          "торг",
          "пром",
          "трейд",
          "збут"
        ]
      },
      "internet": {
        "domain_suffix": [
          "cherkassy.ua",
          "cherkasy.ua",
          "ck.ua",
          "cn.ua",
          "com.ua",
          "crimea.ua",
          "cv.ua",
          "dn.ua",
          "dnepropetrovsk.ua",
          "dnipropetrovsk.ua",
          "donetsk.ua",
          "dp.ua",
          "if.ua",
          "in.ua",
          "ivano-frankivsk.ua",
          "kh.ua",
          "kharkiv.ua",
          "kharkov.ua",
          "kherson.ua",
          "khmelnitskiy.ua",
          "kiev.ua",
          "kirovograd.ua",
          "km.ua",
          "kr.ua",
          "ks.ua",
          "lg.ua",
          "lt.ua",
          "lugansk.ua",
          "lutsk.ua",
          "lutsk.net",
          "lviv.ua",
          "mk.ua",
          "net.ua",
          "nikolaev.ua",
          "od.ua",
          "odessa.ua",
          "org.ua",
          "pl.ua",
          "pl.ua",
          "poltava.ua",
          "rovno.ua",
          "rv.ua",
          "sebastopol.ua",
          "sm.ua",
          "sumy.ua",
          "te.ua",
          "ternopil.ua",
          "ua",
          "uz.ua",
          "uzhgorod.ua",
          "vinnica.ua",
          "vn.ua",
          "volyn.net",
          "volyn.ua",
          "yalta.ua",
          "zaporizhzhe.ua",
          "zhitomir.ua",
          "zp.ua",
          "zt.ua",
          "укр"
        ]
      },
      "music": {
        "instruments": [
          "Електрична гітара",
          "Акустична гітара",
          "Флейта",
          "Труба",
          "Кларнет",
          "Віолончель",
          "Арфа",
          "Ксилофон",
          "Гармоніка",
          "Аккордеон",
          "Орган",
          "Піаніно",
          "Укулеле",
          "Саксофон",
          "Барабан",
          "Скрипка",
          "Бас-гітара"
        ]
      },
      "name": {
        "female_first_name": [
          "Аврелія",
          "Аврора",
          "Агапія",
          "Агата",
          "Агафія",
          "Агнеса",
          "Агнія",
          "Агрипина",
          "Ада",
          "Аделаїда",
          "Аделіна",
          "Адріана",
          "Азалія",
          "Алевтина",
          "Аліна",
          "Алла",
          "Альбіна",
          "Альвіна",
          "Анастасія",
          "Анастасія",
          "Анатолія",
          "Ангеліна",
          "Анжела",
          "Анна",
          "Антонида",
          "Антоніна",
          "Антонія",
          "Анфіса",
          "Аполлінарія",
          "Аполлонія",
          "Аркадія",
          "Артемія",
          "Афанасія",
          "Білослава",
          "Біляна",
          "Благовіста",
          "Богдана",
          "Богуслава",
          "Божена",
          "Болеслава",
          "Борислава",
          "Броніслава",
          "В’ячеслава",
          "Валентина",
          "Валерія",
          "Варвара",
          "Василина",
          "Вікторія",
          "Вілена",
          "Віленіна",
          "Віліна",
          "Віола",
          "Віолетта",
          "Віра",
          "Віргінія",
          "Віта",
          "Віталіна",
          "Влада",
          "Владислава",
          "Власта",
          "Всеслава",
          "Галина",
          "Ганна",
          "Гелена",
          "Далеслава",
          "Дана",
          "Дарина",
          "Дарислава",
          "Діана",
          "Діяна",
          "Добринка",
          "Добромила",
          "Добромира",
          "Добромисла",
          "Доброслава",
          "Долеслава",
          "Доляна",
          "Жанна",
          "Жозефіна",
          "Забава",
          "Звенислава",
          "Зінаїда",
          "Злата",
          "Зореслава",
          "Зорина",
          "Зоряна",
          "Зоя",
          "Іванна",
          "Ілона",
          "Інна",
          "Іннеса",
          "Ірина",
          "Ірма",
          "Калина",
          "Каріна",
          "Катерина",
          "Квітка",
          "Квітослава",
          "Клавдія",
          "Крентта",
          "Ксенія",
          "Купава",
          "Лада",
          "Лариса",
          "Леся",
          "Ликера",
          "Лідія",
          "Лілія",
          "Любава",
          "Любислава",
          "Любов",
          "Любомила",
          "Любомира",
          "Люборада",
          "Любослава",
          "Людмила",
          "Людомила",
          "Майя",
          "Мальва",
          "Мар’яна",
          "Марина",
          "Марічка",
          "Марія",
          "Марта",
          "Меланія",
          "Мечислава",
          "Милодара",
          "Милослава",
          "Мирослава",
          "Мілана",
          "Мокрина",
          "Мотря",
          "Мстислава",
          "Надія",
          "Наталія",
          "Неля",
          "Немира",
          "Ніна",
          "Огняна",
          "Оксана",
          "Олександра",
          "Олена",
          "Олеся",
          "Ольга",
          "Ореста",
          "Орина",
          "Орислава",
          "Орися",
          "Оріяна",
          "Павліна",
          "Палажка",
          "Пелагея",
          "Пелагія",
          "Поліна",
          "Поляна",
          "Потішана",
          "Радміла",
          "Радослава",
          "Раїна",
          "Раїса",
          "Роксолана",
          "Ромена",
          "Ростислава",
          "Руслана",
          "Світлана",
          "Святослава",
          "Слава",
          "Сміяна",
          "Сніжана",
          "Соломія",
          "Соня",
          "Софія",
          "Станислава",
          "Сюзана",
          "Таїсія",
          "Тамара",
          "Тетяна",
          "Устина",
          "Фаїна",
          "Февронія",
          "Федора",
          "Феодосія",
          "Харитина",
          "Христина",
          "Христя",
          "Юліанна",
          "Юлія",
          "Юстина",
          "Юхима",
          "Юхимія",
          "Яна",
          "Ярина",
          "Ярослава"
        ],
        "female_last_name": [
          "Андрухович",
          "Бабух",
          "Балабан",
          "Балабуха",
          "Балакун",
          "Балицька",
          "Бамбула",
          "Бандера",
          "Барановська",
          "Бачей",
          "Башук",
          "Бердник",
          "Білич",
          "Бондаренко",
          "Борецька",
          "Боровська",
          "Борочко",
          "Боярчук",
          "Брицька",
          "Бурмило",
          "Бутько",
          "Василишина",
          "Васильківська",
          "Вергун",
          "Вередун",
          "Верещук",
          "Витребенько",
          "Вітряк",
          "Волощук",
          "Гайдук",
          "Гайова",
          "Гайчук",
          "Галаєнко",
          "Галатей",
          "Галаціон",
          "Гаман",
          "Гамула",
          "Ганич",
          "Гарай",
          "Гарун",
          "Гладківська",
          "Гладух",
          "Глинська",
          "Гнатишина",
          "Гойко",
          "Головець",
          "Горбач",
          "Гордійчук",
          "Горова",
          "Городоцька",
          "Гречко",
          "Григоришина",
          "Гриневецька",
          "Гриневська",
          "Гришко",
          "Громико",
          "Данилишина",
          "Данилко",
          "Демків",
          "Демчишина",
          "Дзюб’як",
          "Дзюба",
          "Дідух",
          "Дмитришина",
          "Дмитрук",
          "Довгалевська",
          "Дурдинець",
          "Євенко",
          "Євпак",
          "Ємець",
          "Єрмак",
          "Забіла",
          "Зварич",
          "Зінкевич",
          "Зленко",
          "Іванишина",
          "Калач",
          "Кандиба",
          "Карпух",
          "Кивач",
          "Коваленко",
          "Ковальська",
          "Коломієць",
          "Коман",
          "Компанієць",
          "Кононець",
          "Кордун",
          "Корецька",
          "Корнїйчук",
          "Коров’як",
          "Коцюбинська",
          "Кулинич",
          "Кульчицька",
          "Лагойда",
          "Лазірко",
          "Ланова",
          "Латан",
          "Латанська",
          "Лахман",
          "Левадовська",
          "Ликович",
          "Линдик",
          "Ліхно",
          "Лобачевська",
          "Ломова",
          "Лугова",
          "Луцька",
          "Луцьків",
          "Лученко",
          "Лучко",
          "Люта",
          "Лящук",
          "Магера",
          "Мазайло",
          "Мазило",
          "Мазун",
          "Майборода",
          "Майстренко",
          "Маковецька",
          "Малкович",
          "Мамій",
          "Маринич",
          "Марієвська",
          "Марків",
          "Махно",
          "Миклашевська",
          "Миклухо",
          "Милославська",
          "Михайлюк",
          "Міняйло",
          "Могилевська",
          "Москаль",
          "Москалюк",
          "Мотрієнко",
          "Негода",
          "Ногачевська",
          "Опенько",
          "Осадко",
          "Павленко",
          "Павлишина",
          "Павлів",
          "Пагутяк",
          "Паламарчук",
          "Палій",
          "Паращук",
          "Пасічник",
          "Пендик",
          "Петик",
          "Петлюра",
          "Петренко",
          "Петрина",
          "Петришина",
          "Петрів",
          "Плаксій",
          "Погиба",
          "Поліщук",
          "Пономарів",
          "Поривай",
          "Поривайло",
          "Потебенько",
          "Потоцька",
          "Пригода",
          "Приймак",
          "Притула",
          "Прядун",
          "Розпутня",
          "Романишина",
          "Ромей",
          "Роменець",
          "Ромочко",
          "Савицька",
          "Саєнко",
          "Свидригайло",
          "Семеночко",
          "Семещук",
          "Сердюк",
          "Силецька",
          "Сідлецька",
          "Сідляк",
          "Сірко",
          "Скиба",
          "Скоропадська",
          "Слободян",
          "Сосюра",
          "Сплюха",
          "Спотикач",
          "Степанець",
          "Стигайло",
          "Сторожук",
          "Сторчак",
          "Стоян",
          "Сучак",
          "Сушко",
          "Тарасюк",
          "Тиндарей",
          "Ткаченко",
          "Третяк",
          "Троян",
          "Трублаєвська",
          "Трясило",
          "Трясун",
          "Уманець",
          "Унич",
          "Усич",
          "Федоришина",
          "Цушко",
          "Червоній",
          "Шамрило",
          "Шевченко",
          "Шестак",
          "Шиндарей",
          "Шиян",
          "Шкараба",
          "Шудрик",
          "Шумило",
          "Шупик",
          "Шухевич",
          "Щербак",
          "Юрчишина",
          "Юхно",
          "Ющик",
          "Ющук",
          "Яворівська",
          "Ялова",
          "Ялюк",
          "Янюк",
          "Ярмак",
          "Яцишина",
          "Яцьків",
          "Ящук"
        ],
        "female_middle_name": [
          "Адамівна",
          "Азарівна",
          "Алевтинівна",
          "Альбертівна",
          "Анастасівна",
          "Анатоліївна",
          "Андріївна",
          "Антонівна",
          "Аркадіївна",
          "Арсенівна",
          "Арсеніївна",
          "Артемівна",
          "Архипівна",
          "Аскольдівна",
          "Афанасіївна",
          "Білославівна",
          "Богданівна",
          "Божемирівна",
          "Боженівна",
          "Болеславівна",
          "Боримирівна",
          "Борисівна",
          "Бориславівна",
          "Братиславівна",
          "В’ячеславівна",
          "Вадимівна",
          "Валентинівна",
          "Валеріївна",
          "Василівна",
          "Вікторівна",
          "Віталіївна",
          "Владиславівна",
          "Володимирівна",
          "Всеволодівна",
          "Всеславівна",
          "Гаврилівна",
          "Гарасимівна",
          "Георгіївна",
          "Гнатівна",
          "Гордіївна",
          "Григоріївна",
          "Данилівна",
          "Даромирівна",
          "Денисівна",
          "Дмитрівна",
          "Добромирівна",
          "Доброславівна",
          "Євгенівна",
          "Захарівна",
          "Захаріївна",
          "Збориславівна",
          "Звенимирівна",
          "Звениславівна",
          "Зеновіївна",
          "Зиновіївна",
          "Златомирівна",
          "Зореславівна",
          "Іванівна",
          "Ігорівна",
          "Ізяславівна",
          "Корнеліївна",
          "Корнилівна",
          "Корніївна",
          "Костянтинівна",
          "Лаврентіївна",
          "Любомирівна",
          "Макарівна",
          "Максимівна",
          "Марківна",
          "Маркіянівна",
          "Матвіївна",
          "Мечиславівна",
          "Микитівна",
          "Миколаївна",
          "Миронівна",
          "Мирославівна",
          "Михайлівна",
          "Мстиславівна",
          "Назарівна",
          "Назаріївна",
          "Натанівна",
          "Немирівна",
          "Несторівна",
          "Олегівна",
          "Олександрівна",
          "Олексіївна",
          "Олельківна",
          "Омелянівна",
          "Орестівна",
          "Орхипівна",
          "Остапівна",
          "Охрімівна",
          "Павлівна",
          "Панасівна",
          "Пантелеймонівна",
          "Петрівна",
          "Пилипівна",
          "Радимирівна",
          "Радимівна",
          "Родіонівна",
          "Романівна",
          "Ростиславівна",
          "Русланівна",
          "Святославівна",
          "Сергіївна",
          "Славутівна",
          "Станіславівна",
          "Степанівна",
          "Стефаніївна",
          "Тарасівна",
          "Тимофіївна",
          "Тихонівна",
          "Устимівна",
          "Юріївна",
          "Юхимівна",
          "Ярославівна"
        ],
        "first_name": [
          "Августин",
          "Аврелій",
          "Адам",
          "Адріян",
          "Азарій",
          "Алевтин",
          "Альберт",
          "Анастас",
          "Анастасій",
          "Анатолій",
          "Андрій",
          "Антін",
          "Антон",
          "Антоній",
          "Аркадій",
          "Арсен",
          "Арсеній",
          "Артем",
          "Архип",
          "Аскольд",
          "Афанасій",
          "Біломир",
          "Білослав",
          "Богдан",
          "Божемир",
          "Божен",
          "Болеслав",
          "Боримир",
          "Боримисл",
          "Борис",
          "Борислав",
          "Братимир",
          "Братислав",
          "Братомил",
          "Братослав",
          "Брячислав",
          "Будимир",
          "Буйтур",
          "Буревіст",
          "В’ячеслав",
          "Вадим",
          "Валентин",
          "Валерій",
          "Василь",
          "Велемир",
          "Віктор",
          "Віталій",
          "Влад",
          "Владислав",
          "Володимир",
          "Володислав",
          "Всевлад",
          "Всеволод",
          "Всеслав",
          "Гаврило",
          "Гарнослав",
          "Геннадій",
          "Георгій",
          "Герасим",
          "Гліб",
          "Гнат",
          "Гордій",
          "Горимир",
          "Горислав",
          "Градимир",
          "Григорій",
          "Далемир",
          "Данило",
          "Дарій",
          "Даромир",
          "Денис",
          "Дмитро",
          "Добромир",
          "Добромисл",
          "Доброслав",
          "Євген",
          "Єремій",
          "Захар",
          "Захарій",
          "Зборислав",
          "Звенигор",
          "Звенимир",
          "Звенислав",
          "Земислав",
          "Зеновій",
          "Зиновій",
          "Злат",
          "Златомир",
          "Зоремир",
          "Зореслав",
          "Зорян",
          "Іван",
          "Ігор",
          "Ізяслав",
          "Ілля",
          "Кий",
          "Корнелій",
          "Корнилій",
          "Корнило",
          "Корній",
          "Костянтин",
          "Кузьма",
          "Лаврентій",
          "Лаврін",
          "Лад",
          "Ладислав",
          "Ладо",
          "Ладомир",
          "Левко",
          "Листвич",
          "Лук’ян",
          "Любодар",
          "Любозар",
          "Любомир",
          "Макар",
          "Максим",
          "Мар’ян",
          "Маркіян",
          "Марко",
          "Матвій",
          "Мечислав",
          "Микита",
          "Микола",
          "Мирон",
          "Мирослав",
          "Михайло",
          "Мстислав",
          "Мусій",
          "Назар",
          "Назарій",
          "Натан",
          "Немир",
          "Нестор",
          "Олег",
          "Олександр",
          "Олексій",
          "Олелько",
          "Олесь",
          "Омелян",
          "Орест",
          "Орхип",
          "Остап",
          "Охрім",
          "Павло",
          "Панас",
          "Пантелеймон",
          "Петро",
          "Пилип",
          "Подолян",
          "Потап",
          "Радим",
          "Радимир",
          "Ратибор",
          "Ратимир",
          "Родіон",
          "Родослав",
          "Роксолан",
          "Роман",
          "Ростислав",
          "Руслан",
          "Святополк",
          "Святослав",
          "Семибор",
          "Сергій",
          "Синьоок",
          "Славолюб",
          "Славомир",
          "Славута",
          "Сніжан",
          "Сологуб",
          "Станіслав",
          "Степан",
          "Стефаній",
          "Стожар",
          "Тарас",
          "Тиміш",
          "Тимофій",
          "Тихон",
          "Тур",
          "Устим",
          "Хвалимир",
          "Хорив",
          "Чорнота",
          "Щастислав",
          "Щек",
          "Юліан",
          "Юрій",
          "Юхим",
          "Ян",
          "Ярема",
          "Яровид",
          "Яромил",
          "Яромир",
          "Ярополк",
          "Ярослав"
        ],
        "last_name": [
          "Андрухович",
          "Бабух",
          "Балабан",
          "Балабух",
          "Балакун",
          "Балицький",
          "Бамбула",
          "Бандера",
          "Барановський",
          "Бачей",
          "Башук",
          "Бердник",
          "Білич",
          "Бондаренко",
          "Борецький",
          "Боровський",
          "Борочко",
          "Боярчук",
          "Брицький",
          "Бурмило",
          "Бутько",
          "Василин",
          "Василишин",
          "Васильківський",
          "Вергун",
          "Вередун",
          "Верещук",
          "Витребенько",
          "Вітряк",
          "Волощук",
          "Гайдук",
          "Гайовий",
          "Гайчук",
          "Галаєнко",
          "Галатей",
          "Галаціон",
          "Гаман",
          "Гамула",
          "Ганич",
          "Гарай",
          "Гарун",
          "Гладківський",
          "Гладух",
          "Глинський",
          "Гнатишин",
          "Гойко",
          "Головець",
          "Горбач",
          "Гордійчук",
          "Горовий",
          "Городоцький",
          "Гречко",
          "Григоришин",
          "Гриневецький",
          "Гриневський",
          "Гришко",
          "Громико",
          "Данилишин",
          "Данилко",
          "Демків",
          "Демчишин",
          "Дзюб’як",
          "Дзюба",
          "Дідух",
          "Дмитришин",
          "Дмитрук",
          "Довгалевський",
          "Дурдинець",
          "Євенко",
          "Євпак",
          "Ємець",
          "Єрмак",
          "Забіла",
          "Зварич",
          "Зінкевич",
          "Зленко",
          "Іванишин",
          "Іванів",
          "Іванців",
          "Калач",
          "Кандиба",
          "Карпух",
          "Каськів",
          "Кивач",
          "Коваленко",
          "Ковальський",
          "Коломієць",
          "Коман",
          "Компанієць",
          "Кононець",
          "Кордун",
          "Корецький",
          "Корнїйчук",
          "Коров’як",
          "Коцюбинський",
          "Кулинич",
          "Кульчицький",
          "Лагойда",
          "Лазірко",
          "Лановий",
          "Латаний",
          "Латанський",
          "Лахман",
          "Левадовський",
          "Ликович",
          "Линдик",
          "Ліхно",
          "Лобачевський",
          "Ломовий",
          "Луговий",
          "Луцький",
          "Луцьків",
          "Лученко",
          "Лучко",
          "Лютий",
          "Лящук",
          "Магера",
          "Мазайло",
          "Мазило",
          "Мазун",
          "Майборода",
          "Майстренко",
          "Маковецький",
          "Малкович",
          "Мамій",
          "Маринич",
          "Марієвський",
          "Марків",
          "Махно",
          "Миклашевський",
          "Миклухо",
          "Милославський",
          "Михайлюк",
          "Міняйло",
          "Могилевський",
          "Москаль",
          "Москалюк",
          "Мотрієнко",
          "Негода",
          "Ногачевський",
          "Опенько",
          "Осадко",
          "Павленко",
          "Павлишин",
          "Павлів",
          "Пагутяк",
          "Паламарчук",
          "Палій",
          "Паращук",
          "Пасічник",
          "Пендик",
          "Петик",
          "Петлюра",
          "Петренко",
          "Петрин",
          "Петришин",
          "Петрів",
          "Плаксій",
          "Погиба",
          "Поліщук",
          "Пономарів",
          "Поривай",
          "Поривайло",
          "Потебенько",
          "Потоцький",
          "Пригода",
          "Приймак",
          "Притула",
          "Прядун",
          "Розпутній",
          "Романишин",
          "Романів",
          "Ромей",
          "Роменець",
          "Ромочко",
          "Савицький",
          "Саєнко",
          "Свидригайло",
          "Семеночко",
          "Семещук",
          "Сердюк",
          "Силецький",
          "Сідлецький",
          "Сідляк",
          "Сірко",
          "Скиба",
          "Скоропадський",
          "Слободян",
          "Сосюра",
          "Сплюх",
          "Спотикач",
          "Стахів",
          "Степанець",
          "Стецьків",
          "Стигайло",
          "Сторожук",
          "Сторчак",
          "Стоян",
          "Сучак",
          "Сушко",
          "Тарасюк",
          "Тиндарей",
          "Ткаченко",
          "Третяк",
          "Троян",
          "Трублаєвський",
          "Трясило",
          "Трясун",
          "Уманець",
          "Унич",
          "Усич",
          "Федоришин",
          "Хитрово",
          "Цимбалістий",
          "Цушко",
          "Червоній",
          "Шамрило",
          "Шевченко",
          "Шестак",
          "Шиндарей",
          "Шиян",
          "Шкараба",
          "Шудрик",
          "Шумило",
          "Шупик",
          "Шухевич",
          "Щербак",
          "Юрчишин",
          "Юхно",
          "Ющик",
          "Ющук",
          "Яворівський",
          "Яловий",
          "Ялюк",
          "Янюк",
          "Ярмак",
          "Яцишин",
          "Яцьків",
          "Ящук"
        ],
        "male_first_name": [
          "Августин",
          "Аврелій",
          "Адам",
          "Адріян",
          "Азарій",
          "Алевтин",
          "Альберт",
          "Анастас",
          "Анастасій",
          "Анатолій",
          "Андрій",
          "Антін",
          "Антон",
          "Антоній",
          "Аркадій",
          "Арсен",
          "Арсеній",
          "Артем",
          "Архип",
          "Аскольд",
          "Афанасій",
          "Біломир",
          "Білослав",
          "Богдан",
          "Божемир",
          "Божен",
          "Болеслав",
          "Боримир",
          "Боримисл",
          "Борис",
          "Борислав",
          "Братимир",
          "Братислав",
          "Братомил",
          "Братослав",
          "Брячислав",
          "Будимир",
          "Буйтур",
          "Буревіст",
          "В’ячеслав",
          "Вадим",
          "Валентин",
          "Валерій",
          "Василь",
          "Велемир",
          "Віктор",
          "Віталій",
          "Влад",
          "Владислав",
          "Володимир",
          "Володислав",
          "Всевлад",
          "Всеволод",
          "Всеслав",
          "Гаврило",
          "Гарнослав",
          "Геннадій",
          "Георгій",
          "Герасим",
          "Гліб",
          "Гнат",
          "Гордій",
          "Горимир",
          "Горислав",
          "Градимир",
          "Григорій",
          "Далемир",
          "Данило",
          "Дарій",
          "Даромир",
          "Денис",
          "Дмитро",
          "Добромир",
          "Добромисл",
          "Доброслав",
          "Євген",
          "Єремій",
          "Захар",
          "Захарій",
          "Зборислав",
          "Звенигор",
          "Звенимир",
          "Звенислав",
          "Земислав",
          "Зеновій",
          "Зиновій",
          "Злат",
          "Златомир",
          "Зоремир",
          "Зореслав",
          "Зорян",
          "Іван",
          "Ігор",
          "Ізяслав",
          "Ілля",
          "Кий",
          "Корнелій",
          "Корнилій",
          "Корнило",
          "Корній",
          "Костянтин",
          "Кузьма",
          "Лаврентій",
          "Лаврін",
          "Лад",
          "Ладислав",
          "Ладо",
          "Ладомир",
          "Левко",
          "Листвич",
          "Лук’ян",
          "Любодар",
          "Любозар",
          "Любомир",
          "Макар",
          "Максим",
          "Мар’ян",
          "Маркіян",
          "Марко",
          "Матвій",
          "Мечислав",
          "Микита",
          "Микола",
          "Мирон",
          "Мирослав",
          "Михайло",
          "Мстислав",
          "Мусій",
          "Назар",
          "Назарій",
          "Натан",
          "Немир",
          "Нестор",
          "Олег",
          "Олександр",
          "Олексій",
          "Олелько",
          "Олесь",
          "Омелян",
          "Орест",
          "Орхип",
          "Остап",
          "Охрім",
          "Павло",
          "Панас",
          "Пантелеймон",
          "Петро",
          "Пилип",
          "Подолян",
          "Потап",
          "Радим",
          "Радимир",
          "Ратибор",
          "Ратимир",
          "Родіон",
          "Родослав",
          "Роксолан",
          "Роман",
          "Ростислав",
          "Руслан",
          "Святополк",
          "Святослав",
          "Семибор",
          "Сергій",
          "Синьоок",
          "Славолюб",
          "Славомир",
          "Славута",
          "Сніжан",
          "Сологуб",
          "Станіслав",
          "Степан",
          "Стефаній",
          "Стожар",
          "Тарас",
          "Тиміш",
          "Тимофій",
          "Тихон",
          "Тур",
          "Устим",
          "Хвалимир",
          "Хорив",
          "Чорнота",
          "Щастислав",
          "Щек",
          "Юліан",
          "Юрій",
          "Юхим",
          "Ян",
          "Ярема",
          "Яровид",
          "Яромил",
          "Яромир",
          "Ярополк",
          "Ярослав"
        ],
        "male_last_name": [
          "Андрухович",
          "Бабух",
          "Балабан",
          "Балабух",
          "Балакун",
          "Балицький",
          "Бамбула",
          "Бандера",
          "Барановський",
          "Бачей",
          "Башук",
          "Бердник",
          "Білич",
          "Бондаренко",
          "Борецький",
          "Боровський",
          "Борочко",
          "Боярчук",
          "Брицький",
          "Бурмило",
          "Бутько",
          "Василин",
          "Василишин",
          "Васильківський",
          "Вергун",
          "Вередун",
          "Верещук",
          "Витребенько",
          "Вітряк",
          "Волощук",
          "Гайдук",
          "Гайовий",
          "Гайчук",
          "Галаєнко",
          "Галатей",
          "Галаціон",
          "Гаман",
          "Гамула",
          "Ганич",
          "Гарай",
          "Гарун",
          "Гладківський",
          "Гладух",
          "Глинський",
          "Гнатишин",
          "Гойко",
          "Головець",
          "Горбач",
          "Гордійчук",
          "Горовий",
          "Городоцький",
          "Гречко",
          "Григоришин",
          "Гриневецький",
          "Гриневський",
          "Гришко",
          "Громико",
          "Данилишин",
          "Данилко",
          "Демків",
          "Демчишин",
          "Дзюб’як",
          "Дзюба",
          "Дідух",
          "Дмитришин",
          "Дмитрук",
          "Довгалевський",
          "Дурдинець",
          "Євенко",
          "Євпак",
          "Ємець",
          "Єрмак",
          "Забіла",
          "Зварич",
          "Зінкевич",
          "Зленко",
          "Іванишин",
          "Іванів",
          "Іванців",
          "Калач",
          "Кандиба",
          "Карпух",
          "Каськів",
          "Кивач",
          "Коваленко",
          "Ковальський",
          "Коломієць",
          "Коман",
          "Компанієць",
          "Кононець",
          "Кордун",
          "Корецький",
          "Корнїйчук",
          "Коров’як",
          "Коцюбинський",
          "Кулинич",
          "Кульчицький",
          "Лагойда",
          "Лазірко",
          "Лановий",
          "Латаний",
          "Латанський",
          "Лахман",
          "Левадовський",
          "Ликович",
          "Линдик",
          "Ліхно",
          "Лобачевський",
          "Ломовий",
          "Луговий",
          "Луцький",
          "Луцьків",
          "Лученко",
          "Лучко",
          "Лютий",
          "Лящук",
          "Магера",
          "Мазайло",
          "Мазило",
          "Мазун",
          "Майборода",
          "Майстренко",
          "Маковецький",
          "Малкович",
          "Мамій",
          "Маринич",
          "Марієвський",
          "Марків",
          "Махно",
          "Миклашевський",
          "Миклухо",
          "Милославський",
          "Михайлюк",
          "Міняйло",
          "Могилевський",
          "Москаль",
          "Москалюк",
          "Мотрієнко",
          "Негода",
          "Ногачевський",
          "Опенько",
          "Осадко",
          "Павленко",
          "Павлишин",
          "Павлів",
          "Пагутяк",
          "Паламарчук",
          "Палій",
          "Паращук",
          "Пасічник",
          "Пендик",
          "Петик",
          "Петлюра",
          "Петренко",
          "Петрин",
          "Петришин",
          "Петрів",
          "Плаксій",
          "Погиба",
          "Поліщук",
          "Пономарів",
          "Поривай",
          "Поривайло",
          "Потебенько",
          "Потоцький",
          "Пригода",
          "Приймак",
          "Притула",
          "Прядун",
          "Розпутній",
          "Романишин",
          "Романів",
          "Ромей",
          "Роменець",
          "Ромочко",
          "Савицький",
          "Саєнко",
          "Свидригайло",
          "Семеночко",
          "Семещук",
          "Сердюк",
          "Силецький",
          "Сідлецький",
          "Сідляк",
          "Сірко",
          "Скиба",
          "Скоропадський",
          "Слободян",
          "Сосюра",
          "Сплюх",
          "Спотикач",
          "Стахів",
          "Степанець",
          "Стецьків",
          "Стигайло",
          "Сторожук",
          "Сторчак",
          "Стоян",
          "Сучак",
          "Сушко",
          "Тарасюк",
          "Тиндарей",
          "Ткаченко",
          "Третяк",
          "Троян",
          "Трублаєвський",
          "Трясило",
          "Трясун",
          "Уманець",
          "Унич",
          "Усич",
          "Федоришин",
          "Хитрово",
          "Цимбалістий",
          "Цушко",
          "Червоній",
          "Шамрило",
          "Шевченко",
          "Шестак",
          "Шиндарей",
          "Шиян",
          "Шкараба",
          "Шудрик",
          "Шумило",
          "Шупик",
          "Шухевич",
          "Щербак",
          "Юрчишин",
          "Юхно",
          "Ющик",
          "Ющук",
          "Яворівський",
          "Яловий",
          "Ялюк",
          "Янюк",
          "Ярмак",
          "Яцишин",
          "Яцьків",
          "Ящук"
        ],
        "male_middle_name": [
          "Адамович",
          "Азарович",
          "Алевтинович",
          "Альбертович",
          "Анастасович",
          "Анатолійович",
          "Андрійович",
          "Антонович",
          "Аркадійович",
          "Арсенійович",
          "Арсенович",
          "Артемович",
          "Архипович",
          "Аскольдович",
          "Афанасійович",
          "Білославович",
          "Богданович",
          "Божемирович",
          "Боженович",
          "Болеславович",
          "Боримирович",
          "Борисович",
          "Бориславович",
          "Братиславович",
          "В’ячеславович",
          "Вадимович",
          "Валентинович",
          "Валерійович",
          "Васильович",
          "Вікторович",
          "Віталійович",
          "Владиславович",
          "Володимирович",
          "Всеволодович",
          "Всеславович",
          "Гаврилович",
          "Герасимович",
          "Георгійович",
          "Гнатович",
          "Гордійович",
          "Григорійович",
          "Данилович",
          "Даромирович",
          "Денисович",
          "Дмитрович",
          "Добромирович",
          "Доброславович",
          "Євгенович",
          "Захарович",
          "Захарійович",
          "Збориславович",
          "Звенимирович",
          "Звениславович",
          "Зеновійович",
          "Зиновійович",
          "Златомирович",
          "Зореславович",
          "Іванович",
          "Ігорович",
          "Ізяславович",
          "Корнелійович",
          "Корнилович",
          "Корнійович",
          "Костянтинович",
          "Лаврентійович",
          "Любомирович",
          "Макарович",
          "Максимович",
          "Маркович",
          "Маркіянович",
          "Матвійович",
          "Мечиславович",
          "Микитович",
          "Миколайович",
          "Миронович",
          "Мирославович",
          "Михайлович",
          "Мстиславович",
          "Назарович",
          "Назарійович",
          "Натанович",
          "Немирович",
          "Несторович",
          "Олегович",
          "Олександрович",
          "Олексійович",
          "Олелькович",
          "Омелянович",
          "Орестович",
          "Орхипович",
          "Остапович",
          "Охрімович",
          "Павлович",
          "Панасович",
          "Пантелеймонович",
          "Петрович",
          "Пилипович",
          "Радимирович",
          "Радимович",
          "Родіонович",
          "Романович",
          "Ростиславович",
          "Русланович",
          "Святославович",
          "Сергійович",
          "Славутович",
          "Станіславович",
          "Степанович",
          "Стефанович",
          "Тарасович",
          "Тимофійович",
          "Тихонович",
          "Устимович",
          "Юрійович",
          "Юхимович",
          "Ярославович"
        ],
        "name": [
          "#{male_first_name} #{male_last_name}",
          "#{male_last_name} #{male_first_name}",
          "#{male_first_name} #{male_middle_name} #{male_last_name}",
          "#{male_last_name} #{male_first_name} #{male_middle_name}",
          "#{female_first_name} #{female_last_name}",
          "#{female_last_name} #{female_first_name}",
          "#{female_first_name} #{female_middle_name} #{female_last_name}",
          "#{female_last_name} #{female_first_name} #{female_middle_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "country_code": [
          "380"
        ],
        "formats": [
          "(044) ###-##-##",
          "(050) ###-##-##",
          "(063) ###-##-##",
          "(066) ###-##-##",
          "(073) ###-##-##",
          "(091) ###-##-##",
          "(092) ###-##-##",
          "(093) ###-##-##",
          "(094) ###-##-##",
          "(095) ###-##-##",
          "(096) ###-##-##",
          "(097) ###-##-##",
          "(098) ###-##-##",
          "(099) ###-##-##"
        ]
      },
      "separator": " та ",
      "yoda": {
        "quotes": [
          "Зброю свою забери! Я тобі не бажаю зла!",
          "Діри? Слизької? Дім мій це!",
          "Сила — спільник мій, і спільник могутній. Життя її створює, вирощує",
          "Готовий ти? Що знаєш про готовність ти?",
          "Відповідальність велику несе джедай, розум мати повинен",
          "За ним довго спостерігав я",
          "Що б він не робив, розум його завжди не з ним, не у вчинках його",
          "Джедаю речі непотрібні ці",
          "Вирішити повинен ти, як їм допомогти краще"
        ]
      }
    },
    "hello": "привіт",
    "helpers": {
      "select": {
        "prompt": "Оберіть: "
      },
      "submit": {
        "create": "Створити %{model}",
        "submit": "Зберегти %{model}",
        "update": "Зберегти %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "few",
          "many",
          "other"
        ]
      },
      "transliterate": {}
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "₴"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "Мільярдів",
              "many": "Мільярдів",
              "one": "Мільярд",
              "other": "Мільярдів"
            },
            "million": {
              "few": "Мільйонів",
              "many": "Мільйонів",
              "one": "Мільйон",
              "other": "Мільйонів"
            },
            "quadrillion": {
              "few": "Квадрильйонів",
              "many": "Квадрильйонів",
              "one": "Квадрильйон",
              "other": "Квадрильйонів"
            },
            "thousand": {
              "few": "Тисяч",
              "many": "Тисяч",
              "one": "Тисяча",
              "other": "Тисяч"
            },
            "trillion": {
              "few": "Трильйонів",
              "many": "Трильйонів",
              "one": "Трильйон",
              "other": "Трильйонів"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "байти",
              "many": "байтів",
              "one": "байт",
              "other": "байту"
            },
            "gb": "ГБ",
            "kb": "кБ",
            "mb": "МБ",
            "tb": "ТБ"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " та ",
        "two_words_connector": " і ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "до полудня",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "по полудні"
    },
    "welcome": "вітаємо"
  },
  "ur": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "تصدیق بیجھنے کا وقت",
          "confirmation_token": "توثیقی ٹوکن",
          "confirmed_at": "تصدیق کا وقت",
          "created_at": "بنانے کا وقت",
          "current_password": "موجودہ خفیہ لفظ",
          "current_sign_in_at": "موجودہ سائن ان کا وقت",
          "current_sign_in_ip": "موجودہ سائن ان کا  آی پی",
          "email": "ای میل",
          "encrypted_password": "خفیہ کردہ لفظ",
          "failed_attempts": "ناکام کوششیں",
          "last_sign_in_at": "آخری سائن ان کا وقت",
          "last_sign_in_ip": "آخری سائن ان کا آی پی",
          "locked_at": "بند ھونے کا وقت",
          "password": "خفیہ لفظ",
          "password_confirmation": "پاسورڈ کی تو ثیق",
          "remember_created_at": "بناۓ کو یاد رکھو",
          "remember_me": "مجھے یاد رکھیں",
          "reset_password_sent_at": "ترتیب شدہ پاسورڈ بیجھے جانے کا وقت",
          "reset_password_token": "ترتیب شدہ پاسورڈ کا ٹوکن",
          "sign_in_count": "سائن ان کا شمار",
          "unconfirmed_email": "غیر مصدقہ ای میل",
          "unlock_token": "غیر مقفل کرنے کا ٹوکن",
          "updated_at": "ترمیم کرنے کا وقت"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "توثیق میں نا کا می: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "چند منحصر %{record}  کی موجودگی کے باعث اس ریکارڈ کو حذف نہیں کیا جا سکتا",
            "has_one": "ایک منحصر %{record} کی موجودگی کے باعث اس ریکارڈ کو حذف نہیں کیا جا سکتا"
          }
        }
      },
      "models": {
        "user": {
          "one": "صارف",
          "other": "صارف"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "اتوار",
        "سوموار",
        "منگل",
        "بدھ",
        "جمعرات",
        "جمعہ",
        "ہفتہ"
      ],
      "abbr_month_names": [
        null,
        "جنوری",
        "فروری",
        "مارچ",
        "اپریل",
        "مئی",
        "جون",
        "جولائی",
        "اگست",
        "ستمبر",
        "اکتوبر",
        "نومبر",
        "دسمبر"
      ],
      "day_names": [
        "اتوار",
        "سوموار",
        "منگل",
        "بدھ",
        "جمعرات",
        "جمعہ",
        "ہفتہ"
      ],
      "formats": {
        "default": "%d %B %Y",
        "long": "%d %B، %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "جنوری",
        "فروری",
        "مارچ",
        "اپریل",
        "مئی",
        "جون",
        "جولائی",
        "اگست",
        "ستمبر",
        "اکتوبر",
        "نومبر",
        "دسمبر"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "تقریبا ایک گھنٹہ",
          "other": "تقریبا %{count} گھنٹے"
        },
        "about_x_months": {
          "one": "تقریبا ایک مہینہ",
          "other": "تقریبا %{count} مہینہ"
        },
        "about_x_years": {
          "one": "تقریبا ایک سال",
          "other": "تقریبا %{count} سال"
        },
        "almost_x_years": {
          "one": "تقریبا ایک سال",
          "other": "تقریبا %{count} سال"
        },
        "half_a_minute": "آدھا منٹ",
        "less_than_x_minutes": {
          "one": "ایک مںٹ سے کم",
          "other": "%{count} مںٹوں سے کم"
        },
        "less_than_x_seconds": {
          "one": "ایک سیکنڈ سے کم",
          "other": "%{count} سیکنڈوں سے کم"
        },
        "over_x_years": {
          "one": "ایک سال سے زیادہ",
          "other": "%{count} سالوں سے زیادہ"
        },
        "x_days": {
          "one": "ایک دن",
          "other": "%{count} دن"
        },
        "x_minutes": {
          "one": "ایک منٹ",
          "other": "%{count} منٹ"
        },
        "x_months": {
          "one": "ایک ماہ",
          "other": "%{count} ماہ"
        },
        "x_seconds": {
          "one": "ایک سیکنڈ",
          "other": "%{count} سیکنڈ"
        }
      },
      "prompts": {
        "day": "دن",
        "hour": "گھنٹہ",
        "minute": "منٹ",
        "month": "ماہ",
        "second": "سیکنڈ",
        "year": "سال"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "آپ کی ای میل کی تصدیق کامیابی سے ھو گئی ہے",
        "new": {
          "resend_confirmation_instructions": "تصدیقی ہدایات دوبارہ بھیجیں"
        },
        "send_instructions": ".آپ کو چند لمحات میں اپنے ای میل ایڈریس کی تصدیق کرنے کے لئے ہدایات کے ساتھ ایک ای میل وصول ھو جائے گا",
        "send_paranoid_instructions": "اگر آپ کا ای میل ایڈریس ہمارے ڈیٹا بیس میں موجود ہوا، تو آپ چند منٹوں میں آپ کے اٰس ای میل ایڈریس کی تصدیق کے لیے ہدایات کے ساتھ ایک ای میل وصول کریں گے۔"
      },
      "failure": {
        "already_authenticated": "آپ پہلے ہی سائن ان ہیں۔",
        "inactive": "آپ کا کھاتہ ابھی تک فعال نہیں ہے۔",
        "invalid": null,
        "last_attempt": "مزید ایک اور کوشش کے بعد آپ کا کھاتا بند ھو جاے گا۔",
        "locked": "آپ کا کھاتا بند کر دیا گیا ہے۔",
        "not_found_in_database": null,
        "timeout": "آپ کا سیشن ختم ہوگیا ھے۔ براے مہربانی دوبارہ لاگ ان کریں۔",
        "unauthenticated": "آپ کو ویب سایٹ میں داخل ھونے سے پہلے سائن ان یا سائن اپ کرنا ہوگا۔",
        "unconfirmed": "آپ کو ویب سایٹ میں داخل ھونے سے پہلے اپنے ای میل ایڈریس کی تصدیق کرنا ہو گی۔"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "کھاتا کی تصدیق کریں",
          "greeting": "!%{recipient} خوش آمدید",
          "instruction": "آپ ذیل میں دیئے گئے لنک کے ذریعہ اپنا اکاؤنٹ ای میل کی تصدیق کرسکتے ہیں",
          "subject": "تصدیقی ہدایات"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "%{recipient} آداب",
          "message": "ہم آپ کو مطلع کرنے کے لئے آپ سے رابطہ کر رہے ہیں کہ آپ کا پاس ورڈ تبدیل ھو چکا ھے۔",
          "subject": "خفیہ لفظ تبدیل ھو چکا ھے۔"
        },
        "reset_password_instructions": {
          "action": "میرا خفیہ لفظ تبدیل کریں۔",
          "greeting": "!%{recipient} آداب",
          "instruction": "کسی نے آپ کا پاس ورڈ تبدیل کرنے کے لئے ایک لنک کی درخواست کی ہے، اور آپ نیچے دئیے گئے لنک کے ذریعے ایسا کر سکتے ہیں۔",
          "instruction_2": "اگر آپ نے اس کی درخواست نہیں کی، تو براہ مہربانی اس ای میل کو نظر انداز کریں۔",
          "instruction_3": "آپ کا پاس ورڈ تبدیل نہیں ہو گا جب تک آپ اوپر لنک پر نہ جایں اور ایک نیا بنائیں۔",
          "subject": "پاسورڈ تبدیل کرنے کی ہدایات۔"
        },
        "unlock_instructions": {
          "action": "میرا اکاؤنٹ فعال کریں",
          "greeting": "!%{recipient} آداب",
          "instruction": "اپنے اکاؤنٹ کو فعال کرنے کے لئے نیچے دیئے گئے لنک پر کلک کریں۔",
          "message": "یکے بعد دیگرے ناکام لاگ ان کوششوں کی وجہ سے آپ کا کھاتا بند کردیا گیا ہے۔",
          "subject": "غیر مقفل کرنے کی ہدایات"
        }
      },
      "omniauth_callbacks": {
        "failure": "سے نہیں ھو سکی۔ %{kind} ،%{reason} آپ کی شناخت بوجہ",
        "success": "اکاونٹ سے کامیابی سے شناخت ھو گی ھے۔ %{kind}"
      },
      "passwords": {
        "edit": {
          "change_my_password": "میرا خفیہ لفظ تبدیل کریں۔",
          "change_your_password": "اپنا خفیہ لفظ تبدیل کریں۔",
          "confirm_new_password": "نئے خفیہ لفظ کی تصدیق کریں۔",
          "new_password": "نیا خفیہ لفظ"
        },
        "new": {
          "forgot_your_password": "اپناخفیہ لفظ بھول گئے ہیں؟",
          "send_me_reset_password_instructions": "مجھے خفیہ لفظ بدلنے کی ھدایات بیجھیں"
        },
        "no_token": "پاس ورڈ کی تبدیلی والی ای میل کے بغیر آپ اس صفحہ تک رسائی حاصل نہیں کرسکتے. اگر آپ پاسورڈ کی تبدیلی  کے ای میل سے آتے ہیں، تو براہ کرم یقینی بنائیں کہ آپ نے پورے یو آر ایل کا استعمال کیا۔",
        "send_instructions": "آپ کو چند لمحات میں اپنے ای میل ایڈریس کی تصدیق کرنے کے لئے ہدایات کے ساتھ ایک ای میل وصول ھو جائے گا۔",
        "send_paranoid_instructions": "اگر آپ کا ای میل ایڈریس ہمارے ڈیٹا بیس میں موجود ہوا، تو آپ چند منٹوں میں آپ کے اٰس ای میل ایڈریس کی تصدیق کے لیے ہدایات کے ساتھ ایک ای میل وصول\" کریں گے۔\"",
        "updated": "آپ کا پاس ورڈ کامیابی سے بدل گیا ہے۔ آپ اب سائن ان ہیں۔",
        "updated_not_active": "آپ کا پاس ورڈ کامیابی سے بدل گیا ہے۔"
      },
      "registrations": {
        "destroyed": "الوداع! آپ کا اکاؤنٹ کامیابی سے منسوخ کردیا گیا ہے. ہمیں آپکی جلد واپسی کی امید ھے۔",
        "edit": {
          "are_you_sure": "کیا آپ پر یقین ہیں؟",
          "cancel_my_account": "میرا اکاؤنٹ منسوخ کریں۔",
          "currently_waiting_confirmation_for_email": "تصدیق کی منتظر ہے %{email} فی الحال",
          "leave_blank_if_you_don_t_want_to_change_it": "اگر آپ اسے تبدیل نہیں کرنا چاہتے تو خالی چھوڑ دیں۔",
          "title": "%{resource} ترمیم کریں",
          "unhappy": "ناخوش؟",
          "update": "بدلیں",
          "we_need_your_current_password_to_confirm_your_changes": "ہمیں آپ کی تبیلیوں کی تصدیق کے لئے آپ کے موجودہ پاسورڈ کی ضرورت ہے۔"
        },
        "new": {
          "sign_up": "سائن اپ کریں"
        },
        "signed_up": "خوش آمدید! آپ نے کامیابی سے سائن اپ کیا ہے۔",
        "signed_up_but_inactive": "آپ نے کامیابی سے سائن اپ کر لیا ہے. تاہم، ہم آپ کو سائن ان نہیں کر سکتے کیونکہ آپ کا اکاؤنٹ ابھی تک فعال نہیں ہے۔",
        "signed_up_but_locked": "آپ نے کامیابی سے سائن اپ کر لیا ہے. تاہم، ہم آپ کو سائن ان نہیں کر سکتے ہیں کیونکہ آپ کا اکاؤنٹ بند ہے۔",
        "signed_up_but_unconfirmed": "ایک توثیقی لنک کے ساتھ ایک پیغام آپ کے ای میل پتہ پر بھیج دیا گیا ہے. اپنا اکاؤنٹ چالو کرنے کے لئے لنک پر عمل کریں۔",
        "update_needs_confirmation": "آپ نے اپنا اکاؤنٹ کامیابی سے اپ ڈیٹ کیا، لیکن ہمیں آپ کے نئے ای میل ایڈریس کی توثیق کرنے کی ضرورت ہے۔ براہ کرم اپنا ای میل دیکھیں اور اپنے نئے ای میل ایڈریس کی تصدیق کے لئے تصدیق شدہ لنک کی پیروی کریں۔",
        "updated": "آپ کا اکاؤنٹ کامیابی سے اپ ڈیٹ ھو چکا ہے۔",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "سائن آؤٹ کامیابی سے ھو چکا۔",
        "new": {
          "sign_in": "سائن ان کریں"
        },
        "signed_in": "کامیابی سے سائن ان ھو چکا۔",
        "signed_out": "سائن آؤٹ کامیابی سے ھو چکا۔"
      },
      "shared": {
        "links": {
          "back": "واپس",
          "didn_t_receive_confirmation_instructions": "تصدیق کی ہدایات نہیں ملی؟",
          "didn_t_receive_unlock_instructions": "انلاک ہدایات موصول نہیں ہوئی؟",
          "forgot_your_password": "اپناخفیہ لفظ بھول گئے ہیں؟",
          "sign_in": "سائن ان کریں",
          "sign_in_with_provider": "کے ساتھ سائن ان کریں %{provider}",
          "sign_up": "سائن اپ کریں"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "انلاک ہدایات دوبارہ بھیجیں"
        },
        "send_instructions": "آپ چند منٹوں میں آپنے اکاؤنٹ کو غیر مقفل کرنے کے طریقے کی ہدایات کے ساتھ ایک ای میل وصول کریں گے۔",
        "send_paranoid_instructions": "اگر آپ کے اکاؤنٹ موجود ہے، تو آپ کو چند منٹ میں اس کو غیر مقفل کرنے کے طریقے کی ہدایات کے ساتھ ایک ای میل وصول ھو گی۔",
        "unlocked": "آپ کا اکاؤنٹ کامیابی سے فعال ہوگیا ہے. برائے مہربانی جاری رکھنے کیلئے سائن ان کریں۔"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "قبول ہونا ضروری ہے",
        "already_confirmed": "پہلے سے ہی تصدیق شدہ، براہ کرم سائن ان کرنے کی کوشش کریں۔",
        "blank": "لازم ہے",
        "confirmation": "%{attribute} میل نہیں رکھتا",
        "confirmation_period_expired": "اندر اندر تصدیق کرنے کی ضرورت ہے، براہ مہربانی ایک نیا درخواست کریں۔ %{period}",
        "empty": "لازم ہے",
        "equal_to": "%{count} کے برابر ہونا چاہیے",
        "even": "جفت ہونا ضروری ہے",
        "exclusion": "مخصوص ہے",
        "expired": "ختم ہو گیا ہے، براہ کرم ایک نیا درخواست کریں۔",
        "greater_than": "%{count} سے زیادہ ہونا چاہیے",
        "greater_than_or_equal_to": "%{count} سے بڑا یا برابر ہونا چاہیے",
        "inclusion": "فہرست میں شامل نہیں ہے",
        "invalid": "باطل ہے",
        "less_than": "%{count} سے کم ہونا چاہیے",
        "less_than_or_equal_to": "%{count} سے کم یا اس کے برابر ہونا چاہیے",
        "not_a_number": "ایک نمبر نہیں ہے",
        "not_an_integer": "ایک عدد صحیح ہونا ضروری ہے",
        "not_found": "نہیں ملا۔",
        "not_locked": "مقفل نہیں کیا گیا تھا۔",
        "not_saved": {
          "one": "محفوظ نہیں کیا جا سکا۔ %{resource} ایک غلطی کی وجہ سے یہ",
          "other": "محفوظ نہیں کیا جا سکا %{resource}غلطیوں کی وجہ سے یہ %{count}"
        },
        "odd": "طاق ہونا ضروری ہے",
        "other_than": "%{count} کے علاوہ کسی اور کا ہونا لازمی ہے",
        "present": "خالی ہونا ضروری ہے",
        "taken": "پہلے سے ہی استعمال میں ہے",
        "too_long": {
          "one": "بہت طویل ہے (زیادہ سے زیادہ ایک حرف)",
          "other": "iبہت طویل ہے (زیادہ سے زیادہ %{count} حروف)"
        },
        "too_short": {
          "one": "بہت چھوٹا ہے (کم از کم اکی حرف)",
          "other": "بہت چھوٹا ہے (کم از کم %{count} حروف)"
        },
        "wrong_length": {
          "one": "غلط طوالت (ایک حرف ہونا چاہئے)",
          "other": "غلط طوالت (%{count} حروف ہونے چاہئے)"
        }
      },
      "template": {
        "body": "مندرجہ ذیل متن کے ساتھ مسائل ہیں:",
        "header": {
          "one": "ایک خرابی کے باعث یہ %{model} محفوظ نہیں کیا جا سکا",
          "other": "%{count} خرابیوں کے باعث یہ %{model} محفوظ نہیں کیا جا سکا"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "منتخب کیجیے"
      },
      "submit": {
        "create": "%{model} تشکیل دیں",
        "submit": "%{model} محفوظ کریں",
        "update": "اپ ڈیٹ %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "Rs"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "بلین",
            "million": "ملین",
            "quadrillion": "کواڈریلن",
            "thousand": "ہزار",
            "trillion": "ٹریلن",
            "unit": "Rs"
          }
        },
        "format": {
          "delimiter": "",
          "precision": 0,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n فیصد"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": "، اور ",
        "two_words_connector": " اور ",
        "words_connector": "، "
      }
    },
    "time": {
      "am": "صبح",
      "formats": {
        "default": "%a، %d %b %Y، %p %l:%M %Z",
        "long": "%d %B، %Y %p %H:%M",
        "short": "%d %b، %H:%M"
      },
      "pm": "شام"
    }
  },
  "uz": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "%{errors}ta hato bor."
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Ya",
        "Du",
        "Sh",
        "Ch",
        "Pa",
        "Ju",
        "Sh"
      ],
      "abbr_month_names": [
        null,
        "yan.",
        "fev.",
        "mart",
        "apr.",
        "may",
        "iyun",
        "iyul",
        "avg.",
        "sen.",
        "okt.",
        "noy.",
        "dek."
      ],
      "day_names": [
        "yakshanba",
        "dushanba",
        "seshanba",
        "chorshanba",
        "payshanba",
        "juma",
        "shanba"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%d %B %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "yanvar",
        "fevral",
        "mart",
        "aprel",
        "may",
        "iyun",
        "iyul",
        "avgust",
        "sentyabr",
        "oktyabr",
        "noyabr",
        "dekabr"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "few": "chamasi %{count} soat",
          "many": "chamasi %{count} soat",
          "one": "chamasi %{count} soat",
          "other": "chamasi %{count} soat"
        },
        "about_x_months": {
          "few": "chamasi %{count} oy",
          "many": "chamasi %{count} oy",
          "one": "chamasi %{count} oy",
          "other": "chamasi %{count} oy"
        },
        "about_x_years": {
          "few": "chamasi %{count} yil",
          "many": "chamasi %{count} yil",
          "one": "chamasi %{count} yil",
          "other": "chamasi %{count} yil"
        },
        "almost_x_years": {
          "few": "deyarli %{count} yil",
          "many": "deyarli %{count} yil",
          "one": "deyarli %{count} yil",
          "other": "deyarli %{count} yil"
        },
        "half_a_minute": "bir daqiqadan kam",
        "less_than_x_minutes": {
          "few": "%{count} daqiqadan kam",
          "many": "%{count} daqiqadan kam",
          "one": "%{count} daqiqadan kam",
          "other": "%{count} daqiqadan kam"
        },
        "less_than_x_seconds": {
          "few": "%{count} soniyadan kam",
          "many": "%{count} soniyadan kam",
          "one": "%{count} soniyadan kam",
          "other": "%{count} soniyadan kam"
        },
        "over_x_years": {
          "few": "%{count} yildan ziyod",
          "many": "%{count} yildan ziyod",
          "one": "%{count} yildan ziyod",
          "other": "%{count} yildan ziyod"
        },
        "x_days": {
          "few": "%{count} kun",
          "many": "%{count} kun",
          "one": "%{count} kun",
          "other": "%{count} kun"
        },
        "x_minutes": {
          "few": "%{count} daqiqa",
          "many": "%{count} daqiqa",
          "one": "%{count} daqiqa",
          "other": "%{count} daqiqa"
        },
        "x_months": {
          "few": "%{count} oy",
          "many": "%{count} oy",
          "one": "%{count} oy",
          "other": "%{count} oy"
        },
        "x_seconds": {
          "few": "%{count} soniya",
          "many": "%{count} soniya",
          "one": "%{count} soniya",
          "other": "%{count} soniya"
        }
      },
      "prompts": {
        "day": "kun",
        "hour": "soat",
        "minute": "daqiqa",
        "month": "oy",
        "second": "soniya",
        "year": "yil"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "tasdiqlash kerak",
        "blank": "bosh bo'lishi mumkin emas",
        "confirmation": "tasdiq bilan mos emas",
        "empty": "bosh bo'lishi mumkin emas",
        "equal_to": "%{count} ga teng",
        "even": "juft sonlar mumkin",
        "exclusion": "mumkin emas",
        "greater_than": "%{count} dan yuqori",
        "greater_than_or_equal_to": "%{count} ga teng yoki yuqori",
        "inclusion": "kutilmagan natija",
        "invalid": "noto'gri",
        "less_than": "%{count} dan kam",
        "less_than_or_equal_to": "%{count} ga teng yoki kam",
        "not_a_number": "son emas",
        "not_an_integer": "butun son emas",
        "odd": "toq sonlar mumkin",
        "taken": "band",
        "too_long": {
          "few": "uzunligi yetarligidan ortiq (%{count} ta simvoldan yuqori mumkin emas)",
          "many": "uzunligi yetarligidan ortiq (%{count} ta simvoldan yuqori mumkin emas)",
          "one": "uzunligi yetarligidan ortiq (%{count} ta simvoldan yuqori mumkin emas)",
          "other": "uzunligi yetarligidan ortiq (%{count} ta simvoldan yuqori mumkin emas)"
        },
        "too_short": {
          "few": "uzunligi yetarli emas (%{count} ta simvoldan kam mumkin emas)",
          "many": "uzunligi yetarli emas (%{count} ta simvoldan kam mumkin emas)",
          "one": "uzunligi yetarli emas (%{count} ta simvoldan kam mumkin emas)",
          "other": "uzunligi yetarli emas (%{count} ta simvoldan kam mumkin emas)"
        },
        "wrong_length": {
          "few": "uzunligi noto'gri (uzunligi %{count} simvolga teng bulishi kerak)",
          "many": "uzunligi noto'gri (uzunligi %{count} simvolga teng bulishi kerak)",
          "one": "uzunligi noto'gri (uzunligi %{count} simvolga teng bulishi kerak)",
          "other": "uzunligi noto'gri (uzunligi %{count} simvolga teng bulishi kerak)"
        }
      },
      "template": {
        "body": "Quyidagilarda hatolar mavjud:",
        "header": {
          "few": "%{count} ta hatolar sababli %{model}:ni saqlab bulmadi",
          "many": "%{count} ta hatolar sababli %{model}:ni saqlab bulmadi",
          "one": "%{count} ta hato sababli %{model}:ni saqlab bulmadi",
          "other": "%{count} ta hatolar sababli %{model}:ni saqlab bulmadi"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Tanlang: "
      },
      "submit": {
        "create": "Yarat %{model}",
        "submit": "Saqla %{model}",
        "update": "Saqla %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "so'm."
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "few": "milliard",
              "many": "milliard",
              "one": "milliard",
              "other": "milliard"
            },
            "million": {
              "few": "million",
              "many": "million",
              "one": "million",
              "other": "million"
            },
            "quadrillion": {
              "few": "kvadrillion",
              "many": "kvadrillion",
              "one": "kvadrillion",
              "other": "kvadrillion"
            },
            "thousand": {
              "few": "ming",
              "many": "ming",
              "one": "ming",
              "other": "ming"
            },
            "trillion": {
              "few": "trillion",
              "many": "trillion",
              "one": "trillion",
              "other": "trillion"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "few": "bayt",
              "many": "bayt",
              "one": "bayt",
              "other": "bayt"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " va ",
        "two_words_connector": " va ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "ertalab",
      "formats": {
        "default": "%a, %d %b %Y, %H:%M:%S %z",
        "long": "%d %B %Y, %H:%M",
        "short": "%d %b, %H:%M"
      },
      "pm": "kechasi"
    }
  },
  "vi": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Xác nhận gửi lúc",
          "confirmation_token": "Mã xác nhận",
          "confirmed_at": "Xác nhận lúc",
          "created_at": "Được tạo lúc",
          "current_password": "Mật khẩu hiện tại",
          "current_sign_in_at": "Đăng nhập lúc",
          "current_sign_in_ip": "Địa chỉ IP đăng nhập",
          "email": "Email",
          "encrypted_password": "Mật khẩu mã hoá",
          "failed_attempts": "Số lần đăng nhập thất bại",
          "last_sign_in_at": "Đăng nhập lần cuối",
          "last_sign_in_ip": "Địa chỉ IP đăng nhập lần cuối",
          "locked_at": "Khoá lúc",
          "password": "Mật khẩu",
          "password_confirmation": "Xác nhận mật khẩu",
          "remember_created_at": "Ghi nhớ được lưu lúc",
          "remember_me": "Ghi nhớ đăng nhập",
          "reset_password_sent_at": "Yêu cầu đặt lại mật khẩu gửi lúc",
          "reset_password_token": "Mã đặt lại mật khẩu",
          "sign_in_count": "Số lần đăng nhập",
          "unconfirmed_email": "Email chưa xác nhận",
          "unlock_token": "Mã mở khoá",
          "updated_at": "Được cập nhật lúc"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Có các lỗi sau: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Không thể xóa do tồn tại một số đối tượng phụ thuộc %{record}",
            "has_one": "Không thể xóa do tồn tại đối tượng phụ thuộc %{record}"
          }
        }
      },
      "models": {
        "user": {
          "other": "Người dùng"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "CN",
        "Thứ 2",
        "Thứ 3",
        "Thứ 4",
        "Thứ 5",
        "Thứ 6",
        "Thứ 7"
      ],
      "abbr_month_names": [
        null,
        "Thg 1",
        "Thg 2",
        "Thg 3",
        "Thg 4",
        "Thg 5",
        "Thg 6",
        "Thg 7",
        "Thg 8",
        "Thg 9",
        "Thg 10",
        "Thg 11",
        "Thg 12"
      ],
      "day_names": [
        "Chủ nhật",
        "Thứ hai",
        "Thứ ba",
        "Thứ tư",
        "Thứ năm",
        "Thứ sáu",
        "Thứ bảy"
      ],
      "formats": {
        "default": "%d-%m-%Y",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Tháng một",
        "Tháng hai",
        "Tháng ba",
        "Tháng tư",
        "Tháng năm",
        "Tháng sáu",
        "Tháng bảy",
        "Tháng tám",
        "Tháng chín",
        "Tháng mười",
        "Tháng mười một",
        "Tháng mười hai"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "khoảng %{count} giờ",
        "about_x_months": "khoảng %{count} tháng",
        "about_x_years": "khoảng %{count} năm",
        "almost_x_years": "gần %{count} năm",
        "half_a_minute": "30 giây",
        "less_than_x_minutes": "chưa tới %{count} phút",
        "less_than_x_seconds": "chưa tới %{count} giây",
        "over_x_years": "hơn %{count} năm",
        "x_days": "%{count} ngày",
        "x_minutes": "%{count} phút",
        "x_months": "%{count} tháng",
        "x_seconds": "%{count} giây"
      },
      "prompts": {
        "day": "Ngày",
        "hour": "Giờ",
        "minute": "Phút",
        "month": "Tháng",
        "second": "Giây",
        "year": "Năm"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Xác nhận tài khoản thành công! Bạn hiện đang đăng nhập.",
        "new": {
          "resend_confirmation_instructions": "Gửi lại hướng dẫn xác nhận tài khoản"
        },
        "send_instructions": "Bạn sẽ nhận được email hướng dẫn xác nhận tài khoản trong vài phút nữa.",
        "send_paranoid_instructions": "Nếu email của bạn có trong hệ thống, bạn sẽ nhận được email hướng dẫn xác nhận tài khoản trong một vài phút nữa."
      },
      "failure": {
        "already_authenticated": "Bạn đã đăng nhập.",
        "inactive": "Tài khoản của bạn chưa được kích hoạt.",
        "invalid": "Tài khoản hay mật khẩu %{authentication_keys} không hợp lệ",
        "invited": "Bạn có một lời mời đang ở trạng thái chờ, hãy xác nhận nó để tạo tài khoản của bạn.",
        "last_attempt": "Bạn còn một lần thử đăng nhập nữa trước khi tài khoản của bạn bị khóa.",
        "locked": "Tài khoản của bạn đã bị khóa.",
        "not_found_in_database": "Tài khoản hay mật khẩu %{authentication_keys} không hợp lệ",
        "timeout": "Phiên làm việc của bạn đã kết thúc, bạn cần đăng nhập lại để tiếp tục.",
        "unauthenticated": "Bạn cần phải đăng nhập hoặc đăng ký trước khi tiếp tục.",
        "unconfirmed": "Bạn cần phải xác nhận tài khoản trước khi tiếp tục."
      },
      "invitations": {
        "edit": {
          "header": "Thiết lập mật khẩu",
          "mess": "Hãy thiết lập mật khẩu của bạn để sử dụng dịch vụ",
          "submit_button": "Đặt mật khẩu"
        },
        "invitation_removed": "Lời mời của bạn đã bị xóa.",
        "invitation_token_invalid": "Mã xác nhận không chính xác!",
        "new": {
          "header": "Gửi lời mời",
          "submit_button": "Gửi thư mời"
        },
        "no_invitations_remaining": "Không còn lời mời nào.",
        "send_instructions": "Một thư mời đã được gửi đến cho   %{email}.",
        "updated": "Mật khẩu của bạn đã được thiết lập thành công. Bạn hiện đang đăng nhập.",
        "updated_not_active": "Mật khẩu của bạn đã được thiết lập thành công."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Xác nhận tài khoản",
          "confirm_account_link": "Xác nhận tài khoản",
          "confirm_link_msg": "Bạn có thể xác nhận tài khoản email bằng đường link dưới đây:",
          "greeting": "Chào mừng %{recipient}!",
          "instruction": "Bạn có thể xác nhận tài khoản email bằng liên kết dưới đây:",
          "subject": "Hướng dẫn xác nhận tài khoản"
        },
        "email_changed": {
          "greeting": "Xin chào %{recipient}!",
          "message": "Chúng tôi liên hệ với bạn để thông báo cho bạn biết rằng email của bạn đang được thay đổi thành %{email}.",
          "message_unconfirmed": "Chúng tôi đang liên hệ với bạn để thông báo rằng email của bạn đang được thay đổi thành %{email}.",
          "subject": "Email đã được thay đổi."
        },
        "invitation_instructions": {
          "accept": "Chấp nhận lời mời",
          "hello": "Xin chào %{email}",
          "ignore": "Nếu bạn không muốn chấp nhận lời mời, xin vui lòng bỏ qua email này.<br />Tài khoản của bạn sẽ không được khởi tạo cho đến khi bạn truy cập vào đường dẫn ở trên và đặt mật khẩu cho tài khoản của bạn.",
          "someone_invited_you": "Có một ai đó đã mời bạn ghé thăm %{url}, Bạn có thể chấp nhận lời mời này thông qua đường dẫn bên dưới.",
          "subject": "Hướng dẫn"
        },
        "password_change": {
          "greeting": "Xin chào %{recipient}!",
          "message": "Chúng tôi thông báo với bạn là mật khẩu của bạn đã được thay đổi. ",
          "subject": "Mật khẩu đã được thay đổi. "
        },
        "reset_password_instructions": {
          "action": "Thay đổi mật khẩu",
          "greeting": "Xin chào %{recipient}!",
          "ignore_mail_msg": "Nếu bạn đã không gửi yêu cầu này, thì vui lòng bỏ qua email này.",
          "instruction": "Có ai đó yêu cầu liên kết thay đổi mật khẩu, bạn có thể thay đổi mật khẩu bằng liên kết dưới đây.",
          "instruction_2": "Nếu bạn không yêu cầu, vui lòng bỏ qua email này.",
          "instruction_3": "Mật khẩu của bạn sẽ không thay đổi cho đến khi bạn ấn vào liên kết trên và tạo mật khẩu mới.",
          "no_changes_msg": "Mật khẩu của bạn sẽ không thay đổi cho đến khi bạn truy cập liên kết ở trên và tạo một mật khẩu mới.",
          "password_change_link": "Đổi mật khẩu của tôi",
          "request_reset_link_msg": "Ai đó đã gửi yêu cầu để đổi mật khẩu của bạn. Bạn có thể thực hiện điều này thông qua đường dẫn bên dưới.",
          "subject": "Hướng dẫn thiết lập lại mật khẩu"
        },
        "unlock_instructions": {
          "account_lock_msg": "Tài khoản của bạn đã bị khóa do có quá nhiều lần đăng nhập không thành công.",
          "action": "Mở khoá tài khoản",
          "greeting": "Xin chào %{recipient}!",
          "instruction": "Hãy nhấn vào liên kết dưới đây để mở khoá tài khoản:",
          "message": "Tài khoản của bạn đã bị khoá do vượt quá giới hạn số lần đăng nhập không thành công.",
          "subject": "Hướng dẫn mở khóa tài khoản",
          "unlock_link": "Mở khóa tài khoản",
          "unlock_link_msg": "Chọn vào đường dẫn bên dưới để mở khóa tài khoản:"
        }
      },
      "omniauth_callbacks": {
        "failure": "Không thể đăng nhập qua tài khoản %{kind} vì \"%{reason}\".",
        "success": "Đăng nhập thành công bằng tài khoản %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Thay đổi mật khẩu",
          "change_your_password": "Thay đổi mật khẩu",
          "confirm_new_password": "Xác nhận mật khẩu mới",
          "new_password": "Mật khẩu mới"
        },
        "new": {
          "forgot_your_password": "Quên mật khẩu?",
          "send_me_reset_password_instructions": "Gửi cho tôi hướng dẫn cài đặt lại mật khẩu"
        },
        "no_token": "Bạn chỉ có thể truy cập trang này từ email đặt lại mật khẩu. Nếu bạn truy cập từ email đặt lại mật khẩu, xin chắc chắn rằng bạn dùng đường dẫn đầy đủ trong email.",
        "send_instructions": "Bạn sẽ nhận được email hướng dẫn thiết lập lại mật khẩu trong vài phút nữa.",
        "send_paranoid_instructions": "Nếu email của bạn có trong hệ thống, bạn sẽ nhận được đường dẫn khôi phục mật khẩu trong vài phút nữa qua email.",
        "updated": "Đổi mật khẩu thành công! Bạn hiện đang đăng nhập.",
        "updated_not_active": "Mật khẩu của bạn đã được thay đổi thành công."
      },
      "registrations": {
        "destroyed": "Tạm biệt! Tài khoản của bạn đã được xóa. Chúng tôi hy vọng sẽ sớm gặp lại bạn.",
        "edit": {
          "are_you_sure": "Bạn có chắc?",
          "cancel_my_account": "Xoá tài khoản",
          "currently_waiting_confirmation_for_email": "Đang đợi xác nhận tài khoản email: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "để trống nếu bạn không muốn thay đổi mật khẩu",
          "title": "Cập nhật %{resource}",
          "unhappy": "Không hài lòng",
          "update": "Cập nhật",
          "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
        },
        "new": {
          "sign_up": "Đăng ký"
        },
        "signed_up": "Xin chào! Bạn đã đăng ký thành công.",
        "signed_up_but_inactive": "Bạn đã đăng ký thành công. Tuy nhiên, bạn cần phải kích hoạt tài khoản trước khi có thể đăng nhập được.",
        "signed_up_but_locked": "Bạn đã đăng ký thành công. Tuy nhiên tài khoản của bạn đã bị khóa nên không thể đăng nhập được.",
        "signed_up_but_unconfirmed": "Một email chứa đường dẫn xác nhận tài khoản đã được gửi cho bạn. Bạn vui lòng kiểm tra email.",
        "update_needs_confirmation": "Tài khoản của bạn được cập nhật thành công, nhưng bạn cần xác nhận địa chỉ email mới. Vui lòng kiểm tra email và nhấn vào đường dẫn xác nhận tài khoản để hoàn tất việc thay đổi địa chỉ email.",
        "updated": "Cập nhật tài khoản thành công.",
        "updated_but_not_signed_in": "Tài khoản của bạn đã được cập nhật thành công, nhưng vì mật khẩu của bạn đã bị thay đổi, bạn cần đăng nhập lại."
      },
      "sessions": {
        "already_signed_out": "Đăng xuất thành công.",
        "new": {
          "sign_in": "Đăng nhập"
        },
        "signed_in": "Đăng nhập thành công.",
        "signed_out": "Đăng xuất thành công."
      },
      "shared": {
        "links": {
          "back": "Trở về",
          "didn_t_receive_confirmation_instructions": "Không nhận được hướng dẫn xác nhận tài khoản?",
          "didn_t_receive_unlock_instructions": "Không nhận được hướng dẫn mở khoá tài khoản?",
          "forgot_your_password": "Quên mật khẩu?",
          "sign_in": "Đăng nhập",
          "sign_in_with_provider": "Đăng nhập với %{provider}",
          "sign_up": "Đăng ký"
        },
        "minimum_password_length": {
          "other": "(Tối thiểu %{count} ký tự)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Gửi lại hướng dẫn mở khoá tài khoản"
        },
        "send_instructions": "Bạn sẽ nhận được email hướng dẫn cách mở khóa tài khoản trong vài phút nữa.",
        "send_paranoid_instructions": "Nếu tài khoản của bạn tồn tại, bạn sẽ nhận được email hướng dẫn cách mở khóa tài khoản trong vài phút nữa.",
        "unlocked": "Tài khoản của bạn đã được mở khóa thành công. Vui lòng đăng nhập để tiếp tục."
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "Chuyển hướng tới '%{redirect_url}' không được phép."
      },
      "passwords": {
        "missing_email": "Bạn cần cung cấp địa chỉ email.",
        "missing_passwords": "Bạn cần điền đủ những trường như 'mật khẩu' và 'xác nhận mật khẩu'.",
        "missing_redirect_url": "Thiếu đường đẫn URL.",
        "not_allowed_redirect_url": "Chuyển hướng tới '%{redirect_url}' không được phép.",
        "password_not_required": "Tài khoản này không yêu cầu mật khẩu. Thay thế đăng nhập bằng cách sử dụng '%{provider}' của tài khoản .",
        "sended": "Mail đã được gửi tới '%{email}' tiếp tục làm theo những hướng dẫn để khởi tạo lại mật khẩu.",
        "successfully_updated": "Mật khẩu của bạn vừa được cập nhật thành công.",
        "user_not_found": "Không thể tìm ra người dùng với email '%{email}'."
      },
      "registrations": {
        "account_to_destroy_not_found": "Không thể xác định tài khoản cho việc phá hủy.",
        "account_with_uid_destroyed": "Tài khoản với UID '%{uid}' vừa bị phá hủy.",
        "email_already_exists": "Tài khoản đã tồn tại của '%{email}'",
        "missing_confirm_success_url": "Thiếu 'confirm_success_url' tham số.",
        "redirect_url_not_allowed": "Chuyển hướng tới '%{redirect_url}' không được phép.",
        "user_not_found": "Người dùng không tìm thấy."
      },
      "sessions": {
        "bad_credentials": "Thông tin đăng nhập không hợp lệ. Xin thử lại.",
        "not_confirmed": "Mail xác nhận tài khoản đã được gửi tới tài khoản của bạn tại '%{email}'. Bận cần phải làm theo những hướng dẫn trong email để tài khoản có thể xác nhận",
        "not_supported": "Sử dụng POST /sign_in để đăng nhập. Phương thức GET không được hỗ trợ.",
        "user_not_found": "Người dùng đã không được tìm thấy hoặc không đăng nhập."
      },
      "token_validations": {
        "invalid": "Thông tin đăng nhập không hợp lệ."
      },
      "unlocks": {
        "missing_email": "Bạn cần phải cung cấp địa chỉ email.",
        "sended": "Mail đã được gửi tới '%{email}' tiếp tục làm theo những hướng đẫn để mở khóa tài khoản.",
        "user_not_found": "Không thể tìm ra người dùng với email '%{email}'."
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "phải được đồng ý",
        "already_confirmed": "đã được xác nhận, vui lòng đăng nhập để tiếp tục.",
        "blank": "không thể để trắng",
        "confirmation": "không khớp với xác nhận",
        "confirmation_period_expired": "cần được xác nhận trong %{period}, xin vui lòng yêu cầu mã mới.",
        "empty": "không thể rỗng",
        "equal_to": "phải bằng %{count}",
        "even": "phải là số chẵn",
        "exclusion": "đã được giành trước",
        "expired": "đã hết hạn, vui lòng gửi yêu cầu mới.",
        "greater_than": "phải lớn hơn %{count}",
        "greater_than_or_equal_to": "phải lớn hơn hoặc bằng %{count}",
        "inclusion": "không có trong danh sách",
        "invalid": "không hợp lệ",
        "less_than": "phải nhỏ hơn %{count}",
        "less_than_or_equal_to": "phải nhỏ hơn hoặc bằng %{count}",
        "not_a_number": "không phải là số",
        "not_an_integer": "phải là một số nguyên",
        "not_email": "không phải là email",
        "not_found": "không tìm thấy",
        "not_locked": "không bị khóa",
        "not_saved": {
          "other": "%{count} lỗi khi lưu %{resource}:"
        },
        "odd": "phải là số lẻ",
        "other_than": "cần phải khác %{count}",
        "present": "cần phải để trắng",
        "required": "phải có",
        "taken": "đã tồn tại",
        "too_long": "quá dài (tối đa %{count} ký tự)",
        "too_short": "quá ngắn (tối thiểu %{count} ký tự)",
        "validate_account_update_params": "Vui lòng gửi đúng dữ liệu cập nhật tài khoản trong phần dữ liệu gửi lên .",
        "validate_sign_up_params": "Vui lòng gửi đúng dữ liệu đăng ký trong phần dữ liệu gửi lên.",
        "wrong_length": "độ dài không đúng (phải là %{count} ký tự)"
      },
      "template": {
        "body": "Có lỗi với các mục sau:",
        "header": "%{count} lỗi ngăn không cho lưu %{model} này"
      }
    },
    "faker": {
      "address": {
        "city": [
          "#{city_root}"
        ],
        "city_root": [
          "Bắc Giang",
          "Bắc Kạn",
          "Bắc Ninh",
          "Cao Bằng",
          "Điện Biên",
          "Hà Giang",
          "Hà Nam",
          "Hà Tây",
          "Hải Dương",
          "TP Hải Phòng",
          "Hòa Bình",
          "Hưng Yên",
          "Lai Châu",
          "Lào Cai",
          "Lạng Sơn",
          "Nam Định",
          "Ninh Bình",
          "Phú Thọ",
          "Quảng Ninh",
          "Sơn La",
          "Thái Bình",
          "Thái Nguyên",
          "Tuyên Quang",
          "Vĩnh Phúc",
          "Yên Bái",
          "TP Đà Nẵng",
          "Bình Định",
          "Đắk Lắk",
          "Đắk Nông",
          "Gia Lai",
          "Hà Tĩnh",
          "Khánh Hòa",
          "Kon Tum",
          "Nghệ An",
          "Phú Yên",
          "Quảng Bình",
          "Quảng Nam",
          "Quảng Ngãi",
          "Quảng Trị",
          "Thanh Hóa",
          "Thừa Thiên Huế",
          "TP TP. Hồ Chí Minh",
          "An Giang",
          "Bà Rịa Vũng Tàu",
          "Bạc Liêu",
          "Bến Tre",
          "Bình Dương",
          "Bình Phước",
          "Bình Thuận",
          "Cà Mau",
          "TP Cần Thơ",
          "Đồng Nai",
          "Đồng Tháp",
          "Hậu Giang",
          "Kiên Giang",
          "Lâm Đồng",
          "Long An",
          "Ninh Thuận",
          "Sóc Trăng",
          "Tây Ninh",
          "Tiền Giang",
          "Trà Vinh",
          "Vĩnh Long"
        ],
        "county": [
          "Avon",
          "Bedfordshire",
          "Berkshire",
          "Borders",
          "Buckinghamshire",
          "Cambridgeshire",
          "Central",
          "Cheshire",
          "Cleveland",
          "Clwyd",
          "Cornwall",
          "County Antrim",
          "County Armagh",
          "County Down",
          "County Fermanagh",
          "County Londonderry",
          "County Tyrone",
          "Cumbria",
          "Derbyshire",
          "Devon",
          "Dorset",
          "Dumfries and Galloway",
          "Durham",
          "Dyfed",
          "East Sussex",
          "Essex",
          "Fife",
          "Gloucestershire",
          "Grampian",
          "Greater Manchester",
          "Gwent",
          "Gwynedd County",
          "Hampshire",
          "Herefordshire",
          "Hertfordshire",
          "Highlands and Islands",
          "Humberside",
          "Isle of Wight",
          "Kent",
          "Lancashire",
          "Leicestershire",
          "Lincolnshire",
          "Lothian",
          "Merseyside",
          "Mid Glamorgan",
          "Norfolk",
          "North Yorkshire",
          "Northamptonshire",
          "Northumberland",
          "Nottinghamshire",
          "Oxfordshire",
          "Powys",
          "Rutland",
          "Shropshire",
          "Somerset",
          "South Glamorgan",
          "South Yorkshire",
          "Staffordshire",
          "Strathclyde",
          "Suffolk",
          "Surrey",
          "Tayside",
          "Tyne and Wear",
          "Việt Nam",
          "Warwickshire",
          "West Glamorgan",
          "West Midlands",
          "West Sussex",
          "West Yorkshire",
          "Wiltshire",
          "Worcestershire"
        ],
        "default_country": [
          "Việt Nam"
        ],
        "default_country_code": [
          "VN"
        ],
        "postcode": "/[A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}/"
      },
      "cell_phone": {
        "formats": [
          "012# ### ####",
          "0162 ### ####",
          "0163 ### ####",
          "0164 ### ####",
          "0165 ### ####",
          "0166 ### ####",
          "0167 ### ####",
          "0168 ### ####",
          "0169 ### ####",
          "0186 ### ####",
          "0188 ### ####",
          "0199 ### ####",
          "0866 ### ###",
          "0868 ### ###",
          "0869 ### ###",
          "088# ### ###",
          "09## ### ###"
        ]
      },
      "company": {
        "name": [
          "#{prefix} #{Name.last_name}"
        ],
        "prefix": [
          "Công ty",
          "Cty TNHH",
          "Cty",
          "Cửa hàng",
          "Trung tâm",
          "Chi nhánh"
        ]
      },
      "internet": {
        "domain_suffix": [
          "com",
          "net",
          "info",
          "vn",
          "com.vn"
        ]
      },
      "lorem": {
        "words": [
          "đã",
          "đang",
          "ừ",
          "ờ",
          "á",
          "không",
          "biết",
          "gì",
          "hết",
          "đâu",
          "nha",
          "thế",
          "thì",
          "là",
          "đánh",
          "đá",
          "đập",
          "phá",
          "viết",
          "vẽ",
          "tô",
          "thuê",
          "mướn",
          "mượn",
          "mua",
          "một",
          "hai",
          "ba",
          "bốn",
          "năm",
          "sáu",
          "bảy",
          "tám",
          "chín",
          "mười",
          "thôi",
          "việc",
          "nghỉ",
          "làm",
          "nhà",
          "cửa",
          "xe",
          "đạp",
          "ác",
          "độc",
          "khoảng",
          "khoan",
          "thuyền",
          "tàu",
          "bè",
          "lầu",
          "xanh",
          "đỏ",
          "tím",
          "vàng",
          "kim",
          "chỉ",
          "khâu",
          "may",
          "vá",
          "em",
          "anh",
          "yêu",
          "thương",
          "thích",
          "con",
          "cái",
          "bàn",
          "ghế",
          "tủ",
          "quần",
          "áo",
          "nón",
          "dép",
          "giày",
          "lỗi",
          "được",
          "ghét",
          "giết",
          "chết",
          "hết",
          "tôi",
          "bạn",
          "tui",
          "trời",
          "trăng",
          "mây",
          "gió",
          "máy",
          "hàng",
          "hóa",
          "leo",
          "núi",
          "bơi",
          "biển",
          "chìm",
          "xuồng",
          "nước",
          "ngọt",
          "ruộng",
          "đồng",
          "quê",
          "hương"
        ]
      },
      "name": {
        "first_name": [
          "Phạm",
          "Nguyễn",
          "Trần",
          "Lê",
          "Lý",
          "Hoàng",
          "Phan",
          "Vũ",
          "Tăng",
          "Đặng",
          "Bùi",
          "Đỗ",
          "Hồ",
          "Ngô",
          "Dương",
          "Đào",
          "Đoàn",
          "Vương",
          "Trịnh",
          "Đinh",
          "Lâm",
          "Phùng",
          "Mai",
          "Tô",
          "Trương",
          "Hà"
        ],
        "last_name": [
          "Nam",
          "Trung",
          "Thanh",
          "Thị",
          "Văn",
          "Dương",
          "Tăng",
          "Quốc",
          "Như",
          "Phạm",
          "Nguyễn",
          "Trần",
          "Lê",
          "Lý",
          "Hoàng",
          "Phan",
          "Vũ",
          "Tăng",
          "Đặng",
          "Bùi",
          "Đỗ",
          "Hồ",
          "Ngô",
          "Dương",
          "Đào",
          "Đoàn",
          "Vương",
          "Trịnh",
          "Đinh",
          "Lâm",
          "Phùng",
          "Mai",
          "Tô",
          "Trương",
          "Hà",
          "Vinh",
          "Nhung",
          "Hòa",
          "Tiến",
          "Tâm",
          "Bửu",
          "Loan",
          "Hiền",
          "Hải",
          "Vân",
          "Kha",
          "Minh",
          "Nhân",
          "Triệu",
          "Tuân",
          "Hữu",
          "Đức",
          "Phú",
          "Khoa",
          "Thắng",
          "Sơn",
          "Dung",
          "Tú",
          "Trinh",
          "Thảo",
          "Sa",
          "Kim",
          "Long",
          "Thi",
          "Cường",
          "Ngọc",
          "Sinh",
          "Khang",
          "Phong",
          "Thắm",
          "Thu",
          "Thủy",
          "Nhàn"
        ],
        "name": [
          "#{first_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name}",
          "#{first_name} #{last_name} #{last_name} #{last_name}"
        ],
        "name_with_middle": [
          "#{first_name} #{last_name} #{last_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "01#### #####",
          "01### ######",
          "01#1 ### ####",
          "011# ### ####",
          "02# #### ####",
          "03## ### ####",
          "055 #### ####",
          "056 #### ####",
          "0800 ### ####",
          "08## ### ####",
          "09## ### ####",
          "016977 ####",
          "01### #####",
          "0500 ######",
          "0800 ######"
        ]
      }
    },
    "hello": "xin chào",
    "helpers": {
      "select": {
        "prompt": "Vui lòng chọn"
      },
      "submit": {
        "create": "Tạo %{model}",
        "submit": "Lưu %{model}",
        "update": "Cập nhật %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Á": "A",
          "Â": "A",
          "Ã": "A",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ì": "I",
          "Í": "I",
          "Ò": "O",
          "Ó": "O",
          "Ô": "O",
          "Õ": "O",
          "Ù": "U",
          "Ú": "U",
          "Ý": "Y",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ì": "i",
          "í": "i",
          "ò": "o",
          "ó": "o",
          "ô": "o",
          "õ": "o",
          "ù": "u",
          "ú": "u",
          "ý": "y",
          "Ă": "A",
          "ă": "a",
          "Đ": "D",
          "đ": "d",
          "Ĩ": "I",
          "ĩ": "i",
          "Ũ": "U",
          "ũ": "u",
          "Ơ": "O",
          "ơ": "o",
          "Ư": "U",
          "ư": "u",
          "Ạ": "A",
          "ạ": "a",
          "Ả": "A",
          "ả": "a",
          "Ấ": "A",
          "ấ": "a",
          "Ầ": "A",
          "ầ": "a",
          "Ẩ": "A",
          "ẩ": "a",
          "Ẫ": "A",
          "ẫ": "a",
          "Ậ": "A",
          "ậ": "a",
          "Ắ": "A",
          "ắ": "a",
          "Ằ": "A",
          "ằ": "a",
          "Ẳ": "A",
          "ẳ": "a",
          "Ẵ": "A",
          "ẵ": "a",
          "Ặ": "A",
          "ặ": "a",
          "Ẹ": "E",
          "ẹ": "e",
          "Ẻ": "E",
          "ẻ": "e",
          "Ẽ": "E",
          "ẽ": "e",
          "Ế": "E",
          "ế": "e",
          "Ề": "E",
          "ề": "e",
          "Ể": "E",
          "ể": "e",
          "Ễ": "E",
          "ễ": "e",
          "Ệ": "E",
          "ệ": "e",
          "Ỉ": "I",
          "ỉ": "i",
          "Ị": "I",
          "ị": "i",
          "Ọ": "O",
          "ọ": "o",
          "Ỏ": "O",
          "ỏ": "o",
          "Ố": "O",
          "ố": "o",
          "Ồ": "O",
          "ồ": "o",
          "Ổ": "O",
          "ổ": "o",
          "Ỗ": "O",
          "ỗ": "o",
          "Ộ": "O",
          "ộ": "o",
          "Ớ": "O",
          "ớ": "o",
          "Ờ": "O",
          "ờ": "o",
          "Ở": "O",
          "ở": "o",
          "Ỡ": "O",
          "ỡ": "o",
          "Ợ": "O",
          "ợ": "o",
          "Ụ": "U",
          "ụ": "u",
          "Ủ": "U",
          "ủ": "u",
          "Ứ": "U",
          "ứ": "u",
          "Ừ": "U",
          "ừ": "u",
          "Ử": "U",
          "ử": "u",
          "Ữ": "U",
          "ữ": "u",
          "Ự": "U",
          "ự": "u",
          "Ỳ": "Y",
          "ỳ": "y",
          "Ỵ": "Y",
          "ỵ": "y",
          "Ỷ": "Y",
          "ỷ": "y",
          "Ỹ": "Y",
          "ỹ": "y"
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 0,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "VNĐ"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Tỷ",
            "million": "Triệu",
            "quadrillion": "Triệu tỷ",
            "thousand": "Nghìn",
            "trillion": "Nghìn tỷ",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Byte"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", và ",
        "two_words_connector": " và ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "sáng",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "chiều"
    },
    "welcome": "chào mừng"
  },
  "wo": {
    "activerecord": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "Dib",
        "Alt",
        "Tal",
        "All",
        "Alx",
        "Ajj",
        "Gaw"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Dibèer",
        "Altine",
        "Talaata",
        "Allarba",
        "Alxamess",
        "Ajjouma",
        "Gaawu"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%d %B, %Y",
        "short": "%d %b"
      },
      "month_names": [
        null,
        "Tamkharit",
        "Digui Gamou",
        "Gamou",
        "Raki Gamou",
        "Rakati Gamou",
        "Mamou Kor",
        "Ndeyou Kor",
        "Baraxlou",
        "Kor",
        "Kori",
        "Digui Tabaski",
        "Tabaski"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about %{count} hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about %{count} month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about %{count} year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost %{count} year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than %{count} second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over %{count} year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "%{count} second",
          "other": "%{count} seconds"
        },
        "x_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Second",
        "year": "Year"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is %{count} character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is %{count} character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be %{count} character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "%{count} error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ""
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%d %B, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "yo": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": "ọ̀rọ̀ aṣínà lọ́wọ́lọ́wọ́",
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "í-meèlì",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "ọ̀rọ̀ aṣínà ",
          "password_confirmation": "ìfàṣẹsí ọ̀rọ̀ aṣínà",
          "remember_created_at": null,
          "remember_me": "Rántí mi",
          "reset_password_sent_at": null,
          "reset_password_token": "Tún ọ̀rọ̀ aṣínà tè",
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": "Síí àmì",
          "updated_at": null
        }
      },
      "models": {
        "user": {
          "one": "aṣàmúlò",
          "other": "aṣàmúlò"
        }
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "ìfàṣẹsí ti wà fún í-meèlì rẹ tí a ti ní ",
        "new": {
          "resend_confirmation_instructions": "Fi ìfàṣẹsí ìlànà ṣọwó"
        },
        "send_instructions": "Wàá gba í-meèlì pẹ̀lú ìlànà bí o se maa fi ìfàṣẹsí ṣí àdírẹ́ẹ̀sì í-meèlì rẹ ní ìṣẹ́jú díẹ̀",
        "send_paranoid_instructions": "Ti àdírẹ́ẹ̀sì í-meèlì rẹ ba wà ní àkójọpọ̀ data wa, ìwọ yóò gba í-meèlì láti ọ̀dọ̀ wa pẹ̀lú ìlànà  bí o se maa fi ìfàṣẹsí ṣí àdírẹ́ẹ̀sì í-meèlì rẹ ní ìṣẹ́jú díẹ̀"
      },
      "failure": {
        "already_authenticated": "ẹ̀ ti wọlé síbẹ́síbẹ́",
        "inactive": "àkántì rẹ  ko ṣiṣẹ síbẹ́síbẹ́",
        "invalid": null,
        "last_attempt": "O ní ànfààní ìgbìnyànjú kan si kí a tó tii àkántì rẹ pa",
        "locked": "àkántì re tii tì pa",
        "not_found_in_database": null,
        "timeout": "ìgbà re tii parí. Jọ̀wọ́ wọlé lẹẹkan si láti tẹ̀síwájú",
        "unauthenticated": "O nílọ̀ láti wọlé kí o tó tẹ̀síwájú",
        "unconfirmed": "Wà ni láti fi àṣẹsí  í-meèlì rẹ kí o tó tẹ̀síwájú"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Fi àṣẹsí àkántì mi",
          "greeting": "Káàbọ̀ %{recipient}!",
          "instruction": "O lé fi àṣẹsí àkántì í-meèlì rẹ pẹ̀lú ìtọ́kasí ni isalẹ",
          "subject": "ìmúdájú ìlànà"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Ẹ ǹlẹ́ o %{recipient}",
          "message": "A n kàn sí yin láti sọ fún yín wípé a ti pa ọ̀rọ̀ aṣínà yín padà",
          "subject": "aṣínà ti yípadà"
        },
        "reset_password_instructions": {
          "action": "ṣàyípadà aṣínà mi",
          "greeting": "Ẹ ǹlẹ́ o %{recipient}!",
          "instruction": "Eni kan bèrè láti yí aṣínà yín padà, ẹ le se eléyi pẹ̀lú ìtọ́kasí ni isalẹ",
          "instruction_2": "í ẹ ko bá bèèrè fun, ejọwọ, ẹ ma tẹ̀lé ìmọ̀ràn inu í-meèlì yi",
          "instruction_3": "Aṣínà yín ko ni yin pada laise pe ẹ tẹ̀lé ìtọ́kasí towa loke ki ẹ to le dá titun",
          "subject": "ṣàtúntò aṣínà ìtọ́sọ́nà"
        },
        "unlock_instructions": {
          "action": "Síí àkántì mi\n",
          "greeting": "Ẹ ǹlẹ́ o %{recipient}!",
          "instruction": "ṣíra tẹ̀ẹ́ ìtọ́kasí isalẹ láti síí àkántì rẹ",
          "message": "àkántì re tii tì pa nítorí ìgbìyànjú ati wọlé nigba púpọ̀ to forí ṣánpọ́n",
          "subject": "Síí ìtọ́sọ́nà"
        }
      },
      "omniauth_callbacks": {
        "failure": "Ko le ṣàrídájú rẹ láti %{kind} nítorítí “%{reason}",
        "success": "áṣeyọrí ìjẹ́rìísí láti %{kind} àkántì"
      },
      "passwords": {
        "edit": {
          "change_my_password": "ṣàyípadà aṣínà mi\n",
          "change_your_password": "ṣàyípadà aṣínà rẹ",
          "confirm_new_password": "Fi àṣẹsí aṣínà tuntun",
          "new_password": "Aṣínà tuntun"
        },
        "new": {
          "forgot_your_password": "Ṣé o gbàgbé aṣínà rẹ? ",
          "send_me_reset_password_instructions": "Fi ṣàtúntò aṣínà ìtọ́sọ́nà ránṣẹ́\n"
        },
        "no_token": "O ko le wọlé síí ìwé yii láì se nípasẹ̀ àtúntò í-meèlì aṣínà re. Tí o bá wá láti aṣínà àtúntò í-meèlì, jọ̀wọ́ rii dáni loju pé o lo URL tí a pèsè",
        "send_instructions": "O gba í-meèlì pelu àlàyé bí o se le ṣàtúntò aṣínà rẹ ní ìṣẹ́jú díẹ̀",
        "send_paranoid_instructions": "Ti àdírẹ́ẹ̀sì í-meèlì rẹ ba wà ní àkójọpọ̀ data wa, ìwọ yóò gba ìtọ́kasí aṣínà ní í-meèlì rẹ ní ìṣẹ́jú díẹ̀",
        "updated": "A ti sàyípadà aṣínà re. ẹ̀ ti wọlé\n",
        "updated_not_active": "A ti sàyípadà aṣínà re"
      },
      "registrations": {
        "destroyed": "òdàbö! A ti fagi lé àkántì re. A léro pé o maa padà wá\n",
        "edit": {
          "are_you_sure": "Ṣé o da ẹ lójú? ",
          "cancel_my_account": "Fagi lé àkántì mi",
          "currently_waiting_confirmation_for_email": "A n dúró lọ́wọ́lọ́wọ́ fún ìfàṣẹsí : %{email}\n",
          "leave_blank_if_you_don_t_want_to_change_it": " Fi sílẹ̀ ti o ko ba fe yi padà",
          "title": "ṣàtúnṣe %{resource}\n",
          "unhappy": "ìbànújẹ́?",
          "update": "ṣàfikùn",
          "we_need_your_current_password_to_confirm_your_changes": "A nilo aṣínà ti o n lo lọ́wọ́lọ́wọ́ láti ṣàrídájú àyípadà rẹ"
        },
        "new": {
          "sign_up": "Forúkọsílẹ̀\n"
        },
        "signed_up": "Káàbọ̀! iforúkọsílẹ̀ rẹ wọlé pẹ̀lú àṣeyọrí",
        "signed_up_but_inactive": " Iforúkọsílẹ̀ rẹ wọlé pẹ̀lú àṣeyọrí. Ṣùgbọ́n, a kò lé jẹ́ kí o wọlé nítoripe àkántì rẹ ko tí sọ di aṣiṣẹ́",
        "signed_up_but_locked": "Iforúkọsílẹ̀ rẹ wọlé pẹ̀lú àṣeyọrí. Ṣùgbọ́n, a kò lé jẹ́ kí o wọlé nítoripe àkántì re tii tì pa\n",
        "signed_up_but_unconfirmed": "O gba í-meèlì pelu àrídájú ìtọ́kasí. Jọ̀wọ́ tẹ̀lẹ́ ìtọ́kasí tí o sọ di aṣiṣẹ́ ki àkántì rẹ to le ṣiṣẹ́\n",
        "update_needs_confirmation": "O ti ṣàfikún àkántì rẹ pẹ̀lú àṣeyọrí, Ṣùgbọ́n, a nilo láti ṣàrídájú í-meèlì tuntun. Jọ̀wọ́ yẹ í-meèlì rẹ ki o si ṣàrídájú ìtọ́kasí láti ṣàrídájú í-meèlì tuntun   ",
        "updated": "A ti ṣàfikún àkántì rẹ pẹ̀lú àṣeyọrí\n",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "O jáde pẹ̀lú àṣeyọrí",
        "new": {
          "sign_in": "Wọlé"
        },
        "signed_in": "O wọlé pẹ̀lú àṣeyọrí",
        "signed_out": "O jáde pẹ̀lú àṣeyọrí"
      },
      "shared": {
        "links": {
          "back": "Padà sẹ́yìn",
          "didn_t_receive_confirmation_instructions": "Ko gba ìmúdájú ilana?",
          "didn_t_receive_unlock_instructions": "Ko gba kọ́kọ́rọ́ ilana?",
          "forgot_your_password": "Gbàgbe aṣínà?",
          "sign_in": "Wọlé",
          "sign_in_with_provider": "Wọlé pẹ̀lú %{provider}",
          "sign_up": "Forúkọsílẹ̀"
        },
        "minimum_password_length": {
          "one": null,
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Fi kọ́kọ́rọ́ ilana ṣọwó lẹ́ẹ̀kàn si\n"
        },
        "send_instructions": "O gba í-meèlì pẹ̀lú ilana bí o ṣe le ṣe ṣi kọ́kọ́rọ́ àkántì rẹ ní ìṣẹ́jú díẹ̀\n",
        "send_paranoid_instructions": "Ti àkántì rẹ bá wà, O gba í-meèlì pẹ̀lú ilana bí o ṣe lè ṣe ṣi kọ́kọ́rọ́ àkántì rẹ ní ìṣẹ́jú díẹ̀",
        "unlocked": "Kọ́kọ́rọ́ àkántì rẹ ti si pẹ̀lú àṣeyọrí. Jọ̀wọ́ wọlé láti tẹ̀ síwájú"
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "A ti ṣe àrídájú, jọ̀wọ́ wọlé",
        "confirmation_period_expired": "A ni láti ṣe àrídájú rẹ %{period}, jọ̀wọ́ béèrè fún tuntun",
        "expired": "O ti kú, Jọ̀wọ́ béèrè fún tuntun\n",
        "not_found": "Kò sí\n",
        "not_locked": "A kò tí",
        "not_saved": {
          "one": "%{count}àsìse sèdíwọ elè yìí %{resource} láti lè fi pamọ́",
          "other": "%{count}àsìse sèdíwọ elè yìí %{resource} láti lè fi pamọ́"
        }
      }
    }
  },
  "zh-CN": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "确认邮件发送于",
          "confirmation_token": "确认令牌",
          "confirmed_at": "确认于",
          "created_at": "创建于",
          "current_password": "当前密码",
          "current_sign_in_at": "最近登录于",
          "current_sign_in_ip": "最近登录 IP",
          "email": "电子邮箱",
          "encrypted_password": "密码被加密",
          "failed_attempts": "失败尝试",
          "last_sign_in_at": "最后登录于",
          "last_sign_in_ip": "最后登录的 IP",
          "locked_at": "锁定于",
          "password": "密码",
          "password_confirmation": "密码确认",
          "remember_created_at": "记住创建于",
          "remember_me": "记住登录信息",
          "reset_password_sent_at": "重置密码发送于",
          "reset_password_token": "密码重置令牌",
          "sign_in_count": "登录次数",
          "unconfirmed_email": "未确认邮件",
          "unlock_token": "帐户解锁令牌",
          "updated_at": "更新于"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "验证失败：%{errors}",
          "restrict_dependent_destroy": {
            "has_many": "由于%{record}需要此记录，所以无法移除记录",
            "has_one": "由于%{record}需要此记录，所以无法移除记录"
          }
        }
      },
      "models": {
        "user": {
          "other": "用户"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六"
      ],
      "abbr_month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "day_names": [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y年%m月%d日",
        "short": "%m月%d日"
      },
      "month_names": [
        null,
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "大约%{count}小时",
        "about_x_months": "大约%{count}个月",
        "about_x_years": "大约%{count}年",
        "almost_x_years": "接近%{count}年",
        "half_a_minute": "半分钟",
        "less_than_x_minutes": "不到%{count}分钟",
        "less_than_x_seconds": "不到%{count}秒",
        "over_x_years": "%{count}年多",
        "x_days": "%{count}天",
        "x_minutes": "%{count}分钟",
        "x_months": "%{count}个月",
        "x_seconds": "%{count}秒",
        "x_years": "%{count}年"
      },
      "prompts": {
        "day": "日",
        "hour": "时",
        "minute": "分",
        "month": "月",
        "second": "秒",
        "year": "年"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "成功验证您的邮箱。",
        "new": {
          "resend_confirmation_instructions": "重新发送确认邮件"
        },
        "send_instructions": "几分钟后，您将收到确认帐户的电子邮件。",
        "send_paranoid_instructions": "如果您的邮箱存在于我们的数据库中，您将在几分钟内收到一封确认帐户的邮件。"
      },
      "failure": {
        "already_authenticated": "您已经登录。",
        "inactive": "您的帐户还未激活。",
        "invalid": "%{authentication_keys}或密码错误。",
        "invited": "您有一封待处理的帐号邀请，请接受邀请完成创建您的帐号。",
        "last_attempt": "您还有最后一次尝试机会，再次失败您的帐户将被锁定。",
        "locked": "您的帐户正被锁定。",
        "not_found_in_database": "%{authentication_keys}或密码错误。",
        "timeout": "登录超时，请重新登录。",
        "unauthenticated": "继续操作前请注册或者登录。",
        "unconfirmed": "继续操作前请先确认您的帐户。"
      },
      "invitations": {
        "edit": {
          "header": "设置您的密码",
          "submit_button": "设置密码"
        },
        "invitation_removed": "您的邀请被删除了。",
        "invitation_token_invalid": "所提供的邀请验证无效！",
        "new": {
          "header": "发送邀请",
          "submit_button": "发送邀请"
        },
        "no_invitations_remaining": "没有待处理的邀请",
        "send_instructions": "邀请电子邮件已发送至 %{email}。",
        "updated": "您的密码已设置成功，。现在您已经登入了。",
        "updated_not_active": "您的密码已设置成功。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "确认我的帐户",
          "confirm_account_link": "确定你的帐号",
          "confirm_link_msg": "可以使用下面的链接确定你的邮箱",
          "greeting": "欢迎 %{recipient}！",
          "instruction": "您可以通过下面的链接确认您的帐户的电子邮件：",
          "subject": "帐户确认信息"
        },
        "email_changed": {
          "greeting": "您好 %{recipient}！",
          "message": "收到此邮件是因为您的电子邮件地址已被更改为 %{email}。",
          "message_unconfirmed": "收到此邮件是因为您的电子邮件地址正被更改为 %{email}。",
          "subject": "电子邮件已被修改"
        },
        "invitation_instructions": {
          "accept": "接受邀请",
          "accept_until": "这封邀请将于 %{due_date} 到期。",
          "hello": "%{email} 您好",
          "ignore": "如果您不想接受邀请，请忽略这封电子邮件。只要未选取上述“接受邀请”的链接并且设置密码，您的帐号就不会成立。",
          "someone_invited_you": "邀请您加入 %{url}，您可以通过以下的网页链接接受邀请，并创设帐号：",
          "subject": "邀请"
        },
        "password_change": {
          "greeting": "您好 %{recipient}！",
          "message": "收到此邮件是因为您的帐户密码已被修改。",
          "subject": "密码已被重置"
        },
        "reset_password_instructions": {
          "action": "更改我的密码",
          "greeting": "您好 %{recipient}！",
          "ignore_mail_msg": "如你没有申请，请忽略",
          "instruction": "有人要求更改密码的链接，您可以通过下面的链接更改密码：",
          "instruction_2": "如果您没有要求请求更改密码，请忽略此电子邮件。",
          "instruction_3": "如果您没有访问上面的链接并更改密码，您的密码就不会被改变。",
          "no_changes_msg": "在你点击上面链接前，你的密码都没有改变",
          "password_change_link": "修改我的密码",
          "request_reset_link_msg": "已申请修改您的密码，你可以用下面的链接进入",
          "subject": "重置密码信息"
        },
        "unlock_instructions": {
          "account_lock_msg": "由于多次登入失败，我们已锁定你的帐号",
          "action": "帐户解锁",
          "greeting": "您好 %{recipient}！",
          "instruction": "点击下面的链接以解锁您的帐户：",
          "message": "由于多次登录失败，您的帐户已被锁定。",
          "subject": "帐户解锁信息",
          "unlock_link": "解锁帐号",
          "unlock_link_msg": "可以使用下面的链接解锁你的帐号"
        }
      },
      "omniauth_callbacks": {
        "failure": "由于%{reason}，无法从%{kind}获得授权。",
        "success": "成功地从%{kind}获得授权。"
      },
      "passwords": {
        "edit": {
          "change_my_password": "更改我的密码",
          "change_your_password": "更改您的密码",
          "confirm_new_password": "确认新密码",
          "new_password": "新密码"
        },
        "new": {
          "forgot_your_password": "忘记密码？",
          "send_me_reset_password_instructions": "请给我发送重设密码的邮件"
        },
        "no_token": "无重置邮件不可访问密码重置页面。如果您是从重置邮件来到了这个页面，请确保您输入的URL完整。",
        "send_instructions": "几分钟后，您将收到重置密码的电子邮件。",
        "send_paranoid_instructions": "如果您的邮箱存在于我们的数据库中，您将收到一封找回密码的邮件。",
        "updated": "您的密码已修改成功，您现在已登录。",
        "updated_not_active": "密码修改成功。"
      },
      "registrations": {
        "destroyed": "再见！您的帐户已成功注销。我们希望很快可以再见到您。",
        "edit": {
          "are_you_sure": "您确定吗？",
          "cancel_my_account": "注销我的帐户",
          "currently_waiting_confirmation_for_email": "等待确认 %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "如不想更改，则无需填写",
          "title": "修改%{resource}",
          "unhappy": "不喜欢",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "我们需要您的当前密码以确认更改"
        },
        "new": {
          "sign_up": "注册"
        },
        "signed_up": "欢迎您！您已注册成功。",
        "signed_up_but_inactive": "您的帐户还未被激活。激活前无法登录。",
        "signed_up_but_locked": "您已成功注册，但帐号被锁定了，因此无法登录。",
        "signed_up_but_unconfirmed": "谢谢您！一封确认邮件已经发至您的邮箱，请点击其中的链接激活您的帐户。",
        "update_needs_confirmation": "新的帐户信息已成功提交，确认邮件已经发至您的邮箱，请点击其中的链接以使您的新电子邮箱地址生效。",
        "updated": "帐户资料更新成功。",
        "updated_but_not_signed_in": "帐号资料更新成功。由于密码已修改，请重新登录。"
      },
      "sessions": {
        "already_signed_out": "您已登出。",
        "new": {
          "sign_in": "登录"
        },
        "signed_in": "登录成功。",
        "signed_out": "登出成功。"
      },
      "shared": {
        "links": {
          "back": "返回",
          "didn_t_receive_confirmation_instructions": "没有收到确认邮件？",
          "didn_t_receive_unlock_instructions": "没有收到解锁邮件？",
          "forgot_your_password": "忘记密码？",
          "sign_in": "登录",
          "sign_in_with_provider": "通过 %{provider} 登录",
          "sign_up": "注册"
        },
        "minimum_password_length": {
          "other": "（最少%{count}个字符）"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "重发解锁邮件"
        },
        "send_instructions": "几分钟后，您将收到一封解锁帐户的邮件。",
        "send_paranoid_instructions": "如果您的邮箱存在于我们的数据库中，您将收到一封解锁帐户的邮件。",
        "unlocked": "您的帐户已成功解锁，现在已登录。"
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "不支持转向到 '%{redirect_url}'"
      },
      "passwords": {
        "missing_email": "必需提供邮箱。",
        "missing_passwords": "必需填写'密码'与'确认密码'。",
        "missing_redirect_url": "欠缺 redirect URL.",
        "not_allowed_redirect_url": "不支持转向到 '%{redirect_url}'",
        "password_not_required": "这不是一个需要密码的帐号. 请使用 '%{provider}' 进行登入",
        "sended": "您将在几分钟后收到一封电子邮件'%{email}，内含可重新设定密码的链接。",
        "successfully_updated": "您的密码已被修改。",
        "user_not_found": "找不到帐号 '%{email}'。"
      },
      "registrations": {
        "account_to_destroy_not_found": "无法找到目标帐号。",
        "account_with_uid_destroyed": "账号 '%{uid}' 已被移除。",
        "email_already_exists": "邮箱'%{email}'已被使用",
        "missing_confirm_success_url": "缺少数据 'confirm_success_url'",
        "redirect_url_not_allowed": "不支持转向到 '%{redirect_url}'",
        "user_not_found": "找不到帐号。"
      },
      "sessions": {
        "bad_credentials": "不正确的登录信息，请重试",
        "not_confirmed": "您将在几分钟后收到一封电子邮件'%{email}',内有验证账号的步骤说明",
        "not_supported": "请使用 POST /sign_in 进行登录. GET 是不支持的.",
        "user_not_found": "没有找到账号或没有成功登录"
      },
      "token_validations": {
        "invalid": "不正确的登录资料"
      }
    },
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "必须是可被接受的",
        "already_confirmed": "已经确认，请重新登录。",
        "blank": "不能为空字符",
        "confirmation": "与%{attribute}不匹配",
        "confirmation_period_expired": "注册帐号后须在%{period}以内确认。请重新注册。",
        "empty": "不能留空",
        "equal_to": "必须等于%{count}",
        "even": "必须为双数",
        "exclusion": "是保留关键字",
        "expired": "邮件确认已过期，请重新注册。",
        "greater_than": "必须大于%{count}",
        "greater_than_or_equal_to": "必须大于或等于%{count}",
        "inclusion": "不包含于列表中",
        "invalid": "是无效的",
        "less_than": "必须小于%{count}",
        "less_than_or_equal_to": "必须小于或等于%{count}",
        "model_invalid": "验证失败：%{errors}",
        "not_a_number": "不是数字",
        "not_an_integer": "必须是整数",
        "not_email": "这不是一个合适的邮箱。",
        "not_found": "找不到",
        "not_locked": "未被锁定",
        "not_saved": {
          "other": "发生 %{count} 个错误，导致%{resource}保存失败："
        },
        "odd": "必须为单数",
        "other_than": "长度非法（不可为%{count}个字符）",
        "present": "必须是空白",
        "required": "必须存在",
        "taken": "已经被使用",
        "too_long": "过长（最长为%{count}个字符）",
        "too_short": "过短（最短为%{count}个字符）",
        "validate_account_update_params": "请在request body中填入有效的更新帐号资料",
        "validate_sign_up_params": "请在request body中填入有效的注册内容",
        "wrong_length": "长度非法（必须为%{count}个字符）"
      },
      "template": {
        "body": "如下字段出现错误：",
        "header": "有%{count}个错误发生导致“%{model}”无法被保存。"
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "#####",
          "####",
          "###",
          "##",
          "#"
        ],
        "city": [
          "海门",
          "鄂尔多斯",
          "招远",
          "舟山",
          "齐齐哈尔",
          "盐城",
          "赤峰",
          "青岛",
          "乳山",
          "金昌",
          "泉州",
          "莱西",
          "日照",
          "胶南",
          "南通",
          "拉萨",
          "云浮",
          "梅州",
          "文登",
          "上海",
          "攀枝花",
          "威海",
          "承德",
          "厦门",
          "汕尾",
          "潮州",
          "丹东",
          "太仓",
          "曲靖",
          "烟台",
          "福州",
          "瓦房店",
          "即墨",
          "抚顺",
          "玉溪",
          "张家口",
          "阳泉",
          "莱州",
          "湖州",
          "汕头",
          "昆山",
          "宁波",
          "湛江",
          "揭阳",
          "荣成",
          "连云港",
          "葫芦岛",
          "常熟",
          "东莞",
          "河源",
          "淮安",
          "泰州",
          "南宁",
          "营口",
          "惠州",
          "江阴",
          "蓬莱",
          "韶关",
          "嘉峪关",
          "广州",
          "延安",
          "太原",
          "清远",
          "中山",
          "昆明",
          "寿光",
          "盘锦",
          "长治",
          "深圳",
          "珠海",
          "宿迁",
          "咸阳",
          "铜川",
          "平度",
          "佛山",
          "海口",
          "江门",
          "章丘",
          "肇庆",
          "大连",
          "临汾",
          "吴江",
          "石嘴山",
          "沈阳",
          "苏州",
          "茂名",
          "嘉兴",
          "长春",
          "胶州",
          "银川",
          "张家港",
          "三门峡",
          "锦州",
          "南昌",
          "柳州",
          "三亚",
          "自贡",
          "吉林",
          "阳江",
          "泸州",
          "西宁",
          "宜宾",
          "呼和浩特",
          "成都",
          "大同",
          "镇江",
          "桂林",
          "张家界",
          "宜兴",
          "北海",
          "西安",
          "金坛",
          "东营",
          "牡丹江",
          "遵义",
          "绍兴",
          "扬州",
          "常州",
          "潍坊",
          "重庆",
          "台州",
          "南京",
          "滨州",
          "贵阳",
          "无锡",
          "本溪",
          "克拉玛依",
          "渭南",
          "马鞍山",
          "宝鸡",
          "焦作",
          "句容",
          "北京",
          "徐州",
          "衡水",
          "包头",
          "绵阳",
          "乌鲁木齐",
          "枣庄",
          "杭州",
          "淄博",
          "鞍山",
          "溧阳",
          "库尔勒",
          "安阳",
          "开封",
          "济南",
          "德阳",
          "温州",
          "九江",
          "邯郸",
          "临安",
          "兰州",
          "沧州",
          "临沂",
          "南充",
          "天津",
          "富阳",
          "泰安",
          "诸暨",
          "郑州",
          "哈尔滨",
          "聊城",
          "芜湖",
          "唐山",
          "平顶山",
          "邢台",
          "德州",
          "济宁",
          "荆州",
          "宜昌",
          "义乌",
          "丽水",
          "洛阳",
          "秦皇岛",
          "株洲",
          "石家庄",
          "莱芜",
          "常德",
          "保定",
          "湘潭",
          "金华",
          "岳阳",
          "长沙",
          "衢州",
          "廊坊",
          "菏泽",
          "合肥",
          "武汉",
          "大庆"
        ],
        "default_country": [
          "中国"
        ],
        "default_country_code": [
          "CN"
        ],
        "postcode": [
          "######"
        ],
        "state": [
          "北京市",
          "上海市",
          "天津市",
          "重庆市",
          "黑龙江省",
          "吉林省",
          "辽宁省",
          "内蒙古",
          "河北省",
          "新疆",
          "甘肃省",
          "青海省",
          "陕西省",
          "宁夏",
          "河南省",
          "山东省",
          "山西省",
          "安徽省",
          "湖北省",
          "湖南省",
          "江苏省",
          "四川省",
          "贵州省",
          "云南省",
          "广西省",
          "西藏",
          "浙江省",
          "江西省",
          "广东省",
          "福建省",
          "海南省",
          "香港",
          "澳门"
        ],
        "state_abbr": [
          "京",
          "沪",
          "津",
          "渝",
          "黑",
          "吉",
          "辽",
          "蒙",
          "冀",
          "新",
          "甘",
          "青",
          "陕",
          "宁",
          "豫",
          "鲁",
          "晋",
          "皖",
          "鄂",
          "湘",
          "苏",
          "川",
          "黔",
          "滇",
          "桂",
          "藏",
          "浙",
          "赣",
          "粤",
          "闽",
          "琼",
          "港",
          "澳"
        ],
        "street_address": [
          "#{street_name}#{building_number}号"
        ],
        "street_name": [
          "#{Name.last_name}#{street_suffix}"
        ],
        "street_suffix": [
          "巷",
          "街",
          "路",
          "桥",
          "侬",
          "旁",
          "中心",
          "栋"
        ]
      },
      "bank": {
        "name": [
          "工商银行",
          "交通银行",
          "招商银行",
          "民生银行",
          "中信银行",
          "浦发银行",
          "兴业银行",
          "光大银行",
          "广发银行",
          "平安银行",
          "建设银行",
          "邮政储蓄银行"
        ]
      },
      "cell_phone": {
        "formats": [
          "13#########",
          "145########",
          "147########",
          "150########",
          "151########",
          "152########",
          "153########",
          "155########",
          "156########",
          "157########",
          "158########",
          "159########",
          "170########",
          "171########",
          "172########",
          "173########",
          "175########",
          "176########",
          "177########",
          "178########",
          "18#########"
        ]
      },
      "name": {
        "first_name": [
          "绍齐",
          "博文",
          "梓晨",
          "胤祥",
          "瑞霖",
          "明哲",
          "天翊",
          "凯瑞",
          "健雄",
          "耀杰",
          "潇然",
          "子涵",
          "越彬",
          "钰轩",
          "智辉",
          "致远",
          "俊驰",
          "雨泽",
          "烨磊",
          "晟睿",
          "文昊",
          "修洁",
          "黎昕",
          "远航",
          "旭尧",
          "鸿涛",
          "伟祺",
          "荣轩",
          "越泽",
          "浩宇",
          "瑾瑜",
          "皓轩",
          "擎苍",
          "擎宇",
          "志泽",
          "子轩",
          "睿渊",
          "弘文",
          "哲瀚",
          "雨泽",
          "楷瑞",
          "建辉",
          "晋鹏",
          "天磊",
          "绍辉",
          "泽洋",
          "鑫磊",
          "鹏煊",
          "昊强",
          "伟宸",
          "博超",
          "君浩",
          "子骞",
          "鹏涛",
          "炎彬",
          "鹤轩",
          "越彬",
          "风华",
          "靖琪",
          "明辉",
          "伟诚",
          "明轩",
          "健柏",
          "修杰",
          "志泽",
          "弘文",
          "峻熙",
          "嘉懿",
          "煜城",
          "懿轩",
          "烨伟",
          "苑博",
          "伟泽",
          "熠彤",
          "鸿煊",
          "博涛",
          "烨霖",
          "烨华",
          "煜祺",
          "智宸",
          "正豪",
          "昊然",
          "明杰",
          "立诚",
          "立轩",
          "立辉",
          "峻熙",
          "弘文",
          "熠彤",
          "鸿煊",
          "烨霖",
          "哲瀚",
          "鑫鹏",
          "昊天",
          "思聪",
          "展鹏",
          "笑愚",
          "志强",
          "炫明",
          "雪松",
          "思源",
          "智渊",
          "思淼",
          "晓啸",
          "天宇",
          "浩然",
          "文轩",
          "鹭洋",
          "振家",
          "乐驹",
          "晓博",
          "文博",
          "昊焱",
          "立果",
          "金鑫",
          "锦程",
          "嘉熙",
          "鹏飞",
          "子默",
          "思远",
          "浩轩",
          "语堂",
          "聪健",
          "明",
          "文",
          "果",
          "思",
          "鹏",
          "驰",
          "涛",
          "琪",
          "浩",
          "航",
          "彬"
        ],
        "last_name": [
          "王",
          "李",
          "张",
          "刘",
          "陈",
          "杨",
          "黄",
          "吴",
          "赵",
          "周",
          "徐",
          "孙",
          "马",
          "朱",
          "胡",
          "林",
          "郭",
          "何",
          "高",
          "罗",
          "郑",
          "梁",
          "谢",
          "宋",
          "唐",
          "许",
          "邓",
          "冯",
          "韩",
          "曹",
          "曾",
          "彭",
          "萧",
          "蔡",
          "潘",
          "田",
          "董",
          "袁",
          "于",
          "余",
          "叶",
          "蒋",
          "杜",
          "苏",
          "魏",
          "程",
          "吕",
          "丁",
          "沈",
          "任",
          "姚",
          "卢",
          "傅",
          "钟",
          "姜",
          "崔",
          "谭",
          "廖",
          "范",
          "汪",
          "陆",
          "金",
          "石",
          "戴",
          "贾",
          "韦",
          "夏",
          "邱",
          "方",
          "侯",
          "邹",
          "熊",
          "孟",
          "秦",
          "白",
          "江",
          "阎",
          "薛",
          "尹",
          "段",
          "雷",
          "黎",
          "史",
          "龙",
          "陶",
          "贺",
          "顾",
          "毛",
          "郝",
          "龚",
          "邵",
          "万",
          "钱",
          "严",
          "赖",
          "覃",
          "洪",
          "武",
          "莫",
          "孔"
        ],
        "name": [
          "#{last_name}#{first_name}"
        ],
        "name_with_middle": [
          "#{last_name}#{first_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "###-########",
          "####-########",
          "###########"
        ]
      },
      "university": {
        "name": [
          "#{University.prefix}#{University.suffix}"
        ],
        "prefix": [
          "东",
          "南",
          "西",
          "北",
          "东南",
          "东北",
          "西南",
          "西北",
          "中国"
        ],
        "suffix": [
          "理工大学",
          "技术大学",
          "艺术大学",
          "体育大学",
          "经贸大学",
          "农业大学",
          "科技大学",
          "大学"
        ]
      }
    },
    "hello": "你好",
    "helpers": {
      "select": {
        "prompt": "请选择"
      },
      "submit": {
        "create": "新增%{model}",
        "submit": "储存%{model}",
        "update": "更新%{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "CN¥"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "十亿",
            "million": "百万",
            "quadrillion": "千兆",
            "thousand": "千",
            "trillion": "兆",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": "字节",
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": "、",
        "two_words_connector": "和",
        "words_connector": "、"
      }
    },
    "time": {
      "am": "上午",
      "formats": {
        "default": "%Y年%m月%d日 %A %H:%M:%S %Z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%Y年%m月%d日 %H:%M",
        "short": "%m月%d日 %H:%M"
      },
      "pm": "下午"
    },
    "welcome": "欢迎"
  },
  "zh-HK": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": null,
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": "電郵",
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": "密碼",
          "password_confirmation": null,
          "remember_created_at": null,
          "remember_me": "記住我",
          "reset_password_sent_at": null,
          "reset_password_token": null,
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": null,
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "驗證失敗：%{errors}",
          "restrict_dependent_destroy": {
            "has_many": "由於%{record}依賴此記錄，無法移除",
            "has_one": "由於%{record}依賴此記錄，無法移除"
          }
        }
      },
      "models": {
        "user": {
          "other": null
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "週日",
        "週一",
        "週二",
        "週三",
        "週四",
        "週五",
        "週六"
      ],
      "abbr_month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "day_names": [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y年%m月%d日",
        "short": "%m月%d日"
      },
      "month_names": [
        null,
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "約%{count}小時",
        "about_x_months": "約%{count}個月",
        "about_x_years": "約%{count}年",
        "almost_x_years": "接近%{count}年",
        "half_a_minute": "半分鐘",
        "less_than_x_minutes": "不到%{count}分鐘",
        "less_than_x_seconds": "不到%{count}秒",
        "over_x_years": "超過%{count}年",
        "x_days": "%{count}天",
        "x_minutes": "%{count}分鐘",
        "x_months": "%{count}個月",
        "x_seconds": "%{count}秒",
        "x_years": "%{count}年"
      },
      "prompts": {
        "day": "日",
        "hour": "時",
        "minute": "分",
        "month": "月",
        "second": "秒",
        "year": "年"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "啟用同埋登入咗帳戶。",
        "new": {
          "resend_confirmation_instructions": null
        },
        "send_instructions": "幾分鐘之後，你會收到一封電郵，入面有啟用帳戶嘅步驟。",
        "send_paranoid_instructions": "如果我哋既紀錄入面有呢個電郵的話，幾分鐘之後，你會收到一封電郵，入面有啟用帳戶嘅步驟。"
      },
      "failure": {
        "already_authenticated": "已經登入咗。",
        "inactive": "帳戶未啟用。",
        "invalid": null,
        "invited": "你有一個待處理的邀請, 請接受它以完成創建您的帳戶。",
        "last_attempt": "你仲有一次嘗試正確密碼嘅機會，過後你嘅帳戶會被鎖住。",
        "locked": "你個帳戶已經鎖咗。",
        "not_found_in_database": null,
        "timeout": "超時，請重新登入。",
        "unauthenticated": "請登入，或者開個帳戶。",
        "unconfirmed": "帳戶未啟用。"
      },
      "invitations": {
        "edit": {
          "header": "設置密碼",
          "submit_button": "設置密碼"
        },
        "invitation_removed": "你嘅邀請已被刪除。",
        "invitation_token_invalid": "提供嘅邀請令牌無效!",
        "new": {
          "header": "發送邀請",
          "submit_button": "發送邀請"
        },
        "no_invitations_remaining": "冇剩餘邀請",
        "send_instructions": "邀請電子郵件已發送到%{email)。",
        "updated": "你嘅密碼設置成功。 你而家已經登錄。",
        "updated_not_active": "你嘅密碼設置成功。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "subject": "啟用帳戶"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "invitation_instructions": {
          "accept": "接受邀請",
          "accept_until": "此邀請就喺%{due_date} 中到期。",
          "hello": "你好%{email}",
          "ignore": "如果你唔想接受邀請, 請忽略此電子郵件。 系你訪問上面的連結並設置密碼之前, 不會創建您的帳戶。",
          "someone_invited_you": "有人邀請你去%{url}, 你可以通過下面嘅連結接受它。",
          "subject": "邀請指示"
        },
        "password_change": {
          "greeting": null,
          "message": null,
          "subject": null
        },
        "reset_password_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "instruction_2": null,
          "instruction_3": null,
          "subject": "重設密碼"
        },
        "unlock_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "message": null,
          "subject": "帳戶解鎖"
        }
      },
      "omniauth_callbacks": {
        "failure": "由%{kind}登入唔到，原因︰%{reason}。",
        "success": "%{kind}登入成功。"
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": null,
          "send_me_reset_password_instructions": null
        },
        "no_token": "請肯定網址係密碼重設電郵入面嗰個。唔經呢封電郵睇唔到呢版。",
        "send_instructions": "幾分鐘之後，你會收到一封電郵，入面有重設密碼嘅步驟。",
        "send_paranoid_instructions": "如果我哋既紀錄入面有呢個電郵的話，幾分鐘之後，你會收到一封電郵，入面有重設密碼嘅步驟。",
        "updated": "成功改咗密碼；重新登入咗。",
        "updated_not_active": "成功改咗密碼。"
      },
      "registrations": {
        "destroyed": "帳戶已經註銷。有緣再會。",
        "edit": {
          "are_you_sure": null,
          "cancel_my_account": null,
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": null,
          "title": null,
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": null
        },
        "new": {
          "sign_up": null
        },
        "signed_up": "註冊咗。歡迎！",
        "signed_up_but_inactive": "註冊咗；不過要啟用埋帳戶先可以登入。",
        "signed_up_but_locked": "註冊咗；不過帳戶鎖咗，未可以登入住。",
        "signed_up_but_unconfirmed": "註冊咗；你會收到封電郵，入面有啟用帳戶嘅步驟。",
        "update_needs_confirmation": "更新咗帳戶。你會喺新電郵地址收到封電郵，入面有確認新電郵步驟。",
        "updated": "更新咗帳戶。",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "登出成功。",
        "new": {
          "sign_in": null
        },
        "signed_in": "登入咗。",
        "signed_out": "登出咗。"
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": null,
          "didn_t_receive_unlock_instructions": null,
          "forgot_your_password": null,
          "sign_in": null,
          "sign_in_with_provider": null,
          "sign_up": null
        },
        "minimum_password_length": {
          "other": null
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": null
        },
        "send_instructions": "幾分鐘之後，你會收到一封電郵，入面有帳戶解鎖嘅步驟。",
        "send_paranoid_instructions": "如果我哋既紀錄入面有呢個帳戶的話，幾分鐘之後，你會收到一封電郵，入面有帳戶解鎖嘅步驟。",
        "unlocked": "帳戶解咗鎖；請重新登入。"
      }
    },
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "必定要被接受",
        "already_confirmed": "已經啟用咗；可以登入。",
        "blank": "不可以是空白",
        "confirmation": "與%{attribute}不一致",
        "confirmation_period_expired": "超時。請重新要過個，然後喺%{period}之內確認。",
        "empty": "不可以留空",
        "equal_to": "必須等於%{count}",
        "even": "必須要是雙數",
        "exclusion": "是被保留的關鍵字",
        "expired": "超時。請重新要過個。",
        "greater_than": "必須大於%{count}",
        "greater_than_or_equal_to": "必須大於或等於%{count}",
        "inclusion": "並非可被接受的內容",
        "invalid": "是無效的",
        "less_than": "必須小於%{count}",
        "less_than_or_equal_to": "必須小於或等於%{count}",
        "model_invalid": "驗證失敗：%{errors}",
        "not_a_number": "必須是數字",
        "not_an_integer": "必須是整數",
        "not_found": "搵唔到",
        "not_locked": "無鎖到",
        "not_saved": {
          "other": "有%{count}個問題，%{resource}儲存唔到。"
        },
        "odd": "必須是單數",
        "other_than": "不可以是%{count}個字",
        "present": "必定要是空白",
        "required": "必須存在",
        "taken": "已被使用",
        "too_long": "太長（最長為%{count}個字元）",
        "too_short": "太短（最少為%{count}個字元）",
        "wrong_length": "字數錯誤（應為%{count}個字元）"
      },
      "template": {
        "body": "以下欄位發生問題：",
        "header": "發生%{count}項錯誤，以致%{model}未能儲存。"
      }
    },
    "helpers": {
      "select": {
        "prompt": "請選擇"
      },
      "submit": {
        "create": "新增%{model}",
        "submit": "儲存%{model}",
        "update": "更新%{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "HK$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "十億",
            "million": "百萬",
            "quadrillion": "千兆",
            "thousand": "千",
            "trillion": "兆",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": "、",
        "two_words_connector": "和",
        "words_connector": "、"
      }
    },
    "time": {
      "am": "上午",
      "formats": {
        "default": "%Y年%m月%d日 %A %H:%M:%S %Z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%Y年%m月%d日 %H:%M",
        "short": "%m月%d日 %H:%M"
      },
      "pm": "下午"
    }
  },
  "zh-TW": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "確認信已寄於",
          "confirmation_token": "確認令牌",
          "confirmed_at": "已確認於",
          "created_at": "建立於",
          "current_password": "原始密碼",
          "current_sign_in_at": "現在登入狀態開始於",
          "current_sign_in_ip": "現在登入中的IP位址",
          "email": "電子信箱",
          "encrypted_password": "加密過的密碼",
          "failed_attempts": "錯誤嘗試次數",
          "last_sign_in_at": "上次登入於",
          "last_sign_in_ip": "上次登入的IP位址",
          "locked_at": "鎖定於",
          "password": "密碼",
          "password_confirmation": "確認密碼",
          "remember_created_at": "記住信息寄於",
          "remember_me": "記住我的資訊",
          "reset_password_sent_at": "密碼重設信寄於",
          "reset_password_token": "密碼重置金鑰",
          "sign_in_count": "登入次數",
          "unconfirmed_email": "電子信箱未確認",
          "unlock_token": "解鎖令牌",
          "updated_at": "更新於"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "校驗失敗：%{errors}",
          "restrict_dependent_destroy": {
            "has_many": "由於%{record}需要此記錄，所以無法移除記錄",
            "has_one": "由於%{record}需要此記錄，所以無法移除記錄"
          }
        }
      },
      "models": {
        "user": {
          "other": "使用者"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "週日",
        "週一",
        "週二",
        "週三",
        "週四",
        "週五",
        "週六"
      ],
      "abbr_month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "day_names": [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y年%m月%d日",
        "short": "%m月%d日"
      },
      "month_names": [
        null,
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "大約%{count}小時",
        "about_x_months": "大約%{count}個月",
        "about_x_years": "大約%{count}年",
        "almost_x_years": "接近%{count}年",
        "half_a_minute": "半分鐘",
        "less_than_x_minutes": "不到%{count}分鐘",
        "less_than_x_seconds": "不到%{count}秒",
        "over_x_years": "%{count}年多",
        "x_days": "%{count}天",
        "x_minutes": "%{count}分鐘",
        "x_months": "%{count}個月",
        "x_seconds": "%{count}秒",
        "x_years": "%{count}年"
      },
      "prompts": {
        "day": "日",
        "hour": "時",
        "minute": "分",
        "month": "月",
        "second": "秒",
        "year": "年"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "您的信箱已通過驗證，現在您已成功登入。",
        "new": {
          "resend_confirmation_instructions": "重新寄送確認信"
        },
        "send_instructions": "您將在幾分鐘後收到一封電子郵件，內有驗證帳號的步驟說明。",
        "send_paranoid_instructions": "如果我們有您的信箱，您將會收到一封驗證您的帳號的電子郵件。"
      },
      "failure": {
        "already_authenticated": "您已經登入。",
        "inactive": "您的帳號尚未被啟用。",
        "invalid": "%{authentication_keys}或密碼錯誤。",
        "invited": "你有一封設立帳號的邀請，請接受邀請來創建你的帳號。",
        "last_attempt": "您還有最後一次嘗試機會，再次失敗您的帳號將會被鎖定。",
        "locked": "您的帳號已被鎖定。",
        "not_found_in_database": "%{authentication_keys}或密碼錯誤。",
        "timeout": "您的登入時效過期，請重新登入。",
        "unauthenticated": "您需要先登入或註冊後才能繼續。",
        "unconfirmed": "您的帳號需要經過驗證後，才能繼續。"
      },
      "invitations": {
        "edit": {
          "header": "設置密碼",
          "submit_button": "設置密碼"
        },
        "invitation_removed": "你的邀請被刪除了",
        "invitation_token_invalid": "所提供的邀請驗證無效！",
        "new": {
          "header": "發送邀請",
          "submit_button": "發送邀請"
        },
        "no_invitations_remaining": "邀請名額已用盡",
        "send_instructions": "邀請已發送至%{email)",
        "updated": "你的密碼已設置成功，現在你已經登入了。",
        "updated_not_active": "密碼設置成功"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "確認帳號",
          "confirm_account_link": "確定你的帳號",
          "confirm_link_msg": "可以使用下面連結確定你的電郵",
          "greeting": "%{recipient} 您好！",
          "instruction": "您可以利用下面的連結確認您的帳戶的電子郵件：",
          "subject": "帳號驗證步驟"
        },
        "email_changed": {
          "greeting": "%{recipient} 您好！",
          "message": "我們寫信是爲了通知您，您的信箱已被修改爲 %{email}。",
          "message_unconfirmed": null,
          "subject": "信箱已被修改"
        },
        "invitation_instructions": {
          "accept": "接受邀請",
          "accept_until": "這封邀請將於 %{due_date} 到期。",
          "hello": "%{email} 你好，",
          "ignore": "如果你不想接受邀請, 請忽略這封電子郵件。只要未選取上述“接受邀請”的連結並且設置密碼，你的帳號就不會成立。",
          "someone_invited_you": "“邀請你加入%{url}。你可以通過以下的網頁連結接受邀請，並創設帳號：\"",
          "subject": "邀請"
        },
        "password_change": {
          "greeting": "%{recipient} 您好！",
          "message": "它會通知您，您的密碼已被更改。",
          "subject": "密碼已更改"
        },
        "reset_password_instructions": {
          "action": "更改我的密碼",
          "greeting": "%{recipient} 您好！",
          "ignore_mail_msg": "如你沒有申請，請忽略",
          "instruction": "有人要求更改密碼的連結，您可以利用下面的連結更改密碼。",
          "instruction_2": "如果您沒有要求，請忽略此電子郵件。",
          "instruction_3": "如果您沒有進入上面的連結，並建立新的密碼，您的密碼不會被改變。",
          "no_changes_msg": "在你點擊上面連結前，你的密碼都沒有改變",
          "password_change_link": "修改我的密碼",
          "request_reset_link_msg": "已申請修改您的密碼，你可以用下面連結進入",
          "subject": "密碼重設步驟"
        },
        "unlock_instructions": {
          "account_lock_msg": "由於多失敗登入，我們已鎖定你的帳號",
          "action": "帳戶解鎖",
          "greeting": "%{recipient} 您好！",
          "instruction": "點擊下面的連結到您的帳戶進行解鎖：",
          "message": "由於多次不成功的登入嘗試，您的帳戶已被鎖定。",
          "subject": "帳號解鎖步驟",
          "unlock_link": "解鎖帳號",
          "unlock_link_msg": "可以使用下面連結解鎖你的帳號"
        }
      },
      "omniauth_callbacks": {
        "failure": "無法從 %{kind} 驗證，因為 \"%{reason}\"。",
        "success": "成功從 %{kind} 驗證。"
      },
      "passwords": {
        "edit": {
          "change_my_password": "更改我的密碼",
          "change_your_password": "更改您的密碼",
          "confirm_new_password": "確認新密碼",
          "new_password": "新密碼"
        },
        "new": {
          "forgot_your_password": "忘記密碼？",
          "send_me_reset_password_instructions": "請寄重設密碼的說明信件給我"
        },
        "no_token": "這是密碼重設頁面，僅能透過密碼重設信件進入。如果您是透過重設信件進入的，請確認您的網址是完整的。",
        "send_instructions": "您將在幾分鐘後收到一封電子郵件，內有重新設定密碼的步驟說明。",
        "send_paranoid_instructions": "如果我們有您的信箱，您將會收到一封內含可重新設定密碼連結的電子郵件。",
        "updated": "您的密碼已被修改，您現在已經登入。",
        "updated_not_active": "您的密碼已被修改。"
      },
      "registrations": {
        "destroyed": "再會！您的帳號已被取消。有緣再會。",
        "edit": {
          "are_you_sure": "您確定嗎？",
          "cancel_my_account": "取消我的帳戶",
          "currently_waiting_confirmation_for_email": "等待 %{email} 的確認",
          "leave_blank_if_you_don_t_want_to_change_it": "不想修改的話就不需要填寫這個欄位",
          "title": "修改 %{resource}",
          "unhappy": "不喜歡",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "我們需要您的目前的密碼以確認您的更改"
        },
        "new": {
          "sign_up": "註冊"
        },
        "signed_up": "註冊成功，歡迎！",
        "signed_up_but_inactive": "您已註冊成功。然而因為您的帳號尚未啓動，暫時無法登入，抱歉！",
        "signed_up_but_locked": "您已註冊成功。 然而因為您的帳號已被鎖定，暫時無法登入，抱歉！",
        "signed_up_but_unconfirmed": "確認信件已送至您的 Email 信箱，請點擊信件內連結以啓動您的帳號。",
        "update_needs_confirmation": "您已經成功的更新帳號資訊，但我們仍需確認您的電子信箱，請至新信箱收信並點擊連結以確認您的新電子郵件帳號。",
        "updated": "您已經成功的更新帳號資訊。",
        "updated_but_not_signed_in": "您已經成功的更新帳號資訊。但因為您變更了密碼，請重新登入。"
      },
      "sessions": {
        "already_signed_out": "成功登出了。",
        "new": {
          "sign_in": "登入"
        },
        "signed_in": "成功登入了。",
        "signed_out": "成功登出了。"
      },
      "shared": {
        "links": {
          "back": "返回",
          "didn_t_receive_confirmation_instructions": "沒有收到確認信件？",
          "didn_t_receive_unlock_instructions": "沒有收到解鎖信件？",
          "forgot_your_password": "忘記密碼？",
          "sign_in": "登入",
          "sign_in_with_provider": "用 %{provider} 登入",
          "sign_up": "註冊"
        },
        "minimum_password_length": {
          "other": "（最少%{count}個字符）"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "重發解鎖說明信件"
        },
        "send_instructions": "您將在幾分鐘後收到一封電子郵件，內有將帳號解除鎖定的步驟說明。",
        "send_paranoid_instructions": "如果您的帳號已存在，您的電子信箱將會收到如何解鎖帳號的指示。",
        "unlocked": "您的帳號已被解鎖，現在已經登入。"
      }
    },
    "devise_token_auth": {
      "omniauth": {
        "not_allowed_redirect_url": "不支援轉向到 '%{redirect_url}'"
      },
      "passwords": {
        "missing_email": "必需提供電郵。",
        "missing_passwords": "必需填寫'密碼'與'確認密碼'。",
        "missing_redirect_url": "欠缺 redirect URL.",
        "not_allowed_redirect_url": "不支援轉向到 '%{redirect_url}'",
        "password_not_required": "這不是一個需要密碼的帳號. 請使用 '%{provider}' 進行登入",
        "sended": "您將在幾分鐘後收到一封電子郵件'%{email}，內含可重新設定密碼連結的電子郵件。",
        "successfully_updated": "您的密碼已被修改。",
        "user_not_found": "找不到帳號 '%{email}'。"
      },
      "registrations": {
        "account_to_destroy_not_found": "無法找到目標帳號。",
        "account_with_uid_destroyed": "帳號 '%{uid}' 已被移除。",
        "email_already_exists": "電郵'%{email}'已被使用",
        "missing_confirm_success_url": "欠缺數值 'confirm_success_url'",
        "redirect_url_not_allowed": "不支援轉向到'%{redirect_url}'",
        "user_not_found": "找不到帳號。"
      },
      "sessions": {
        "bad_credentials": "不正確的登入資料。請重試。",
        "not_confirmed": "您將在幾分鐘後收到一封電子郵件'%{email}'，內有驗證帳號的步驟說明。",
        "not_supported": "請使用 POST /sign_in 進行登入. GET 是不支援的.",
        "user_not_found": "未能找到帳號或未能成功登入。"
      },
      "token_validations": {
        "invalid": "不正確的登入資料。"
      }
    },
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "必須是可被接受的",
        "already_confirmed": "已經驗證，請直接登入。",
        "blank": "不能為空白",
        "confirmation": "與%{attribute}須一致",
        "confirmation_period_expired": "必須在 %{period} 內驗證，請重新申請。",
        "empty": "不能留空",
        "equal_to": "必須等於%{count}",
        "even": "必須是偶數",
        "exclusion": "是被保留的關鍵字",
        "expired": "已經過期，請重新申請。",
        "greater_than": "必須大於%{count}",
        "greater_than_or_equal_to": "必須大於或等於%{count}",
        "inclusion": "沒有包含在列表中",
        "invalid": "是無效的",
        "less_than": "必須小於%{count}",
        "less_than_or_equal_to": "必須小於或等於%{count}",
        "model_invalid": "校驗失敗：%{errors}",
        "not_a_number": "不是數字",
        "not_an_integer": "必須是整數",
        "not_email": "這不是一個合適的電郵。",
        "not_found": "找不到。",
        "not_locked": "並未被鎖定。",
        "not_saved": {
          "other": "有 %{count} 個錯誤導致 %{resource} 不能被儲存："
        },
        "odd": "必須是奇數",
        "other_than": "不可以是%{count}個字",
        "present": "必須是空白",
        "required": "必須存在",
        "taken": "已經被使用",
        "too_long": "過長（最長是%{count}個字）",
        "too_short": "過短（最短是%{count}個字）",
        "validate_account_update_params": "請在request body中填入有效的更新帳號資料",
        "validate_sign_up_params": "請在request body中填入有效的註冊內容",
        "wrong_length": "字數錯誤（必須是%{count}個字）"
      },
      "template": {
        "body": "以下欄位發生問題：",
        "header": "有%{count}個錯誤發生使得「%{model}」無法被儲存。"
      }
    },
    "faker": {
      "address": {
        "building_number": [
          "###",
          "##",
          "#"
        ],
        "city": [
          "#{city_prefix}#{city_suffix}"
        ],
        "city_prefix": [
          "新",
          "竹",
          "竹",
          "新",
          "關",
          "峨",
          "寶",
          "北",
          "橫",
          "芎",
          "湖",
          "新",
          "尖",
          "五",
          "苗",
          "苗",
          "通",
          "苑",
          "竹",
          "頭",
          "後",
          "卓",
          "西",
          "頭",
          "公",
          "銅",
          "三",
          "造",
          "三",
          "南",
          "大",
          "獅",
          "泰",
          "彰",
          "彰",
          "員",
          "和",
          "鹿",
          "溪",
          "二",
          "田",
          "北",
          "花",
          "芬",
          "大",
          "永",
          "伸",
          "線",
          "福",
          "秀",
          "埔",
          "埔",
          "大",
          "芳",
          "竹",
          "社",
          "二",
          "田",
          "埤",
          "溪",
          "南",
          "南",
          "埔",
          "草",
          "竹",
          "集",
          "名",
          "鹿",
          "中",
          "魚",
          "國",
          "水",
          "信",
          "仁",
          "雲",
          "斗",
          "斗",
          "虎",
          "西",
          "土",
          "北",
          "莿",
          "林",
          "古",
          "大",
          "崙",
          "二",
          "麥",
          "臺",
          "東",
          "褒",
          "四",
          "口",
          "水",
          "元",
          "嘉",
          "太",
          "朴",
          "布",
          "大",
          "民",
          "溪",
          "新",
          "六",
          "東",
          "義",
          "鹿",
          "水",
          "中",
          "竹",
          "梅",
          "番",
          "大",
          "阿",
          "屏",
          "屏",
          "潮",
          "東",
          "恆",
          "萬",
          "長",
          "麟",
          "九",
          "里",
          "鹽",
          "高",
          "萬",
          "內",
          "竹",
          "新",
          "枋",
          "新",
          "崁",
          "林",
          "南",
          "佳",
          "琉",
          "車",
          "滿",
          "枋",
          "霧",
          "瑪",
          "泰",
          "來",
          "春",
          "獅",
          "牡",
          "三",
          "宜",
          "宜",
          "羅",
          "蘇",
          "頭",
          "礁",
          "壯",
          "員",
          "冬",
          "五",
          "三",
          "大",
          "南",
          "花",
          "花",
          "鳳",
          "玉",
          "新",
          "吉",
          "壽",
          "秀",
          "光",
          "豐",
          "瑞",
          "萬",
          "富",
          "卓",
          "臺",
          "臺",
          "成",
          "關",
          "長",
          "海",
          "池",
          "東",
          "鹿",
          "延",
          "卑",
          "金",
          "大",
          "達",
          "綠",
          "蘭",
          "太",
          "澎",
          "馬",
          "湖",
          "白",
          "西",
          "望",
          "七",
          "金",
          "金",
          "金",
          "金",
          "金",
          "烈",
          "烏",
          "連",
          "南",
          "北",
          "莒",
          "東"
        ],
        "city_suffix": [
          "竹縣",
          "北市",
          "東鎮",
          "埔鎮",
          "西鎮",
          "眉鄉",
          "山鄉",
          "埔鄉",
          "山鄉",
          "林鄉",
          "口鄉",
          "豐鄉",
          "石鄉",
          "峰鄉",
          "栗縣",
          "栗市",
          "霄鎮",
          "裡鎮",
          "南鎮",
          "份鎮",
          "龍鎮",
          "蘭鎮",
          "湖鄉",
          "屋鄉",
          "館鄉",
          "鑼鄉",
          "義鄉",
          "橋鄉",
          "灣鄉",
          "庄鄉",
          "湖鄉",
          "潭鄉",
          "安鄉",
          "化縣",
          "化市",
          "林鎮",
          "美鎮",
          "港鎮",
          "湖鎮",
          "林鎮",
          "中鎮",
          "斗鎮",
          "壇鄉",
          "園鄉",
          "村鄉",
          "靖鄉",
          "港鄉",
          "西鄉",
          "興鄉",
          "水鄉",
          "心鄉",
          "鹽鄉",
          "城鄉",
          "苑鄉",
          "塘鄉",
          "頭鄉",
          "水鄉",
          "尾鄉",
          "頭鄉",
          "州鄉",
          "投縣",
          "投市",
          "里鎮",
          "屯鎮",
          "山鎮",
          "集鎮",
          "間鄉",
          "谷鄉",
          "寮鄉",
          "池鄉",
          "姓鄉",
          "里鄉",
          "義鄉",
          "愛鄉",
          "林縣",
          "六市",
          "南鎮",
          "尾鎮",
          "螺鎮",
          "庫鎮",
          "港鎮",
          "桐鄉",
          "內鄉",
          "坑鄉",
          "埤鄉",
          "背鄉",
          "崙鄉",
          "寮鄉",
          "西鄉",
          "勢鄉",
          "忠鄉",
          "湖鄉",
          "湖鄉",
          "林鄉",
          "長鄉",
          "義縣",
          "保市",
          "子市",
          "袋鎮",
          "林鎮",
          "雄鄉",
          "口鄉",
          "港鄉",
          "腳鄉",
          "石鄉",
          "竹鄉",
          "草鄉",
          "上鄉",
          "埔鄉",
          "崎鄉",
          "山鄉",
          "路鄉",
          "埔鄉",
          "里山鄉",
          "東縣",
          "東市",
          "州鎮",
          "港鎮",
          "春鎮",
          "丹鄉",
          "治鄉",
          "洛鄉",
          "如鄉",
          "港鄉",
          "埔鄉",
          "樹鄉",
          "巒鄉",
          "埔鄉",
          "田鄉",
          "埤鄉",
          "寮鄉",
          "園鄉",
          "頂鄉",
          "邊鄉",
          "州鄉",
          "冬鄉",
          "球鄉",
          "城鄉",
          "州鄉",
          "山鄉",
          "台鄉",
          "家鄉",
          "武鄉",
          "義鄉",
          "日鄉",
          "子鄉",
          "丹鄉",
          "地門鄉",
          "蘭縣",
          "蘭市",
          "東鎮",
          "澳鎮",
          "城鎮",
          "溪鄉",
          "圍鄉",
          "山鄉",
          "山鄉",
          "結鄉",
          "星鄉",
          "同鄉",
          "澳鄉",
          "蓮縣",
          "蓮市",
          "林鎮",
          "里鎮",
          "城鄉",
          "安鄉",
          "豐鄉",
          "林鄉",
          "復鄉",
          "濱鄉",
          "穗鄉",
          "榮鄉",
          "里鄉",
          "溪鄉",
          "東縣",
          "東市",
          "功鎮",
          "山鎮",
          "濱鄉",
          "端鄉",
          "上鄉",
          "河鄉",
          "野鄉",
          "平鄉",
          "南鄉",
          "峰鄉",
          "武鄉",
          "仁鄉",
          "島鄉",
          "嶼鄉",
          "麻里鄉",
          "湖縣",
          "公市",
          "西鄉",
          "沙鄉",
          "嶼鄉",
          "安鄉",
          "美鄉",
          "門縣",
          "城鎮",
          "湖鎮",
          "沙鎮",
          "寧鄉",
          "嶼鄉",
          "坵鄉",
          "江縣",
          "竿鄉",
          "竿鄉",
          "光鄉",
          "引鄉"
        ],
        "default_country": [
          "台灣"
        ],
        "default_country_code": [
          "TW"
        ],
        "postcode": [
          "#####"
        ],
        "state": [
          "臺北市",
          "新北市",
          "桃園市",
          "臺中市",
          "臺南市",
          "高雄市",
          "基隆市",
          "新竹市",
          "嘉義市",
          "新竹縣",
          "竹北市",
          "苗栗縣",
          "苗栗市",
          "彰化縣",
          "彰化市",
          "南投縣",
          "南投市",
          "雲林縣",
          "斗六市",
          "嘉義縣",
          "太保市",
          "屏東縣",
          "屏東市",
          "宜蘭縣",
          "宜蘭市",
          "臺東縣",
          "臺東市",
          "澎湖縣",
          "金門縣",
          "連江縣"
        ],
        "state_abbr": [
          "北",
          "桃",
          "竹",
          "苗",
          "中",
          "彰",
          "雲",
          "嘉",
          "南",
          "高",
          "屏",
          "東",
          "花",
          "宜",
          "基"
        ],
        "street_address": [
          "#{street_name} #{building_number} 號"
        ],
        "street_name": [
          "#{Name.last_name}#{street_suffix}"
        ],
        "street_suffix": [
          "大道",
          "路",
          "街",
          "巷",
          "弄",
          "衖"
        ]
      },
      "name": {
        "first_name": [
          "怡君",
          "欣怡",
          "雅雯",
          "心怡",
          "志豪",
          "雅婷",
          "雅惠",
          "家豪",
          "雅玲",
          "靜怡",
          "志偉",
          "俊宏",
          "建宏",
          "佩君",
          "怡婷",
          "淑芬",
          "靜宜",
          "俊傑",
          "怡如",
          "家銘",
          "佳玲",
          "慧君",
          "怡伶",
          "雅芳",
          "宗翰",
          "志宏",
          "淑娟",
          "信宏",
          "志強",
          "淑婷",
          "佩珊",
          "佳慧",
          "佳蓉",
          "佳穎",
          "淑惠",
          "智偉",
          "欣儀",
          "嘉玲",
          "雅慧",
          "惠雯",
          "玉婷",
          "惠如",
          "惠君",
          "宜芳",
          "惠婷",
          "淑華",
          "志明",
          "雅芬",
          "家榮",
          "俊賢",
          "俊豪",
          "慧玲",
          "嘉宏",
          "佩芬",
          "佳樺",
          "雅琪",
          "淑萍",
          "淑君",
          "婉婷",
          "佳琪",
          "韻如",
          "詩婷",
          "建良",
          "芳儀",
          "宜君",
          "佩蓉",
          "志銘",
          "雅鈴",
          "建文",
          "佩玲",
          "鈺婷",
          "雅萍",
          "立偉",
          "文傑",
          "慧如",
          "淑慧",
          "佳宏",
          "志遠",
          "靜儀",
          "惠玲",
          "淑玲",
          "美君",
          "怡慧",
          "千慧",
          "馨儀",
          "嘉慧",
          "家瑋",
          "美慧",
          "美玲",
          "建志",
          "宗憲",
          "筱婷",
          "靜雯",
          "雅君",
          "彥廷",
          "怡靜",
          "玉玲",
          "郁婷",
          "俊男"
        ],
        "last_name": [
          "趙",
          "錢",
          "孫",
          "李",
          "周",
          "吳",
          "鄭",
          "王",
          "馮",
          "陳",
          "褚",
          "衛",
          "蔣",
          "沈",
          "韓",
          "楊",
          "朱",
          "秦",
          "尤",
          "許",
          "何",
          "呂",
          "施",
          "張",
          "孔",
          "曹",
          "嚴",
          "華",
          "金",
          "魏",
          "陶",
          "薑",
          "戚",
          "謝",
          "鄒",
          "喻",
          "柏",
          "水",
          "竇",
          "章",
          "雲",
          "蘇",
          "潘",
          "葛",
          "奚",
          "範",
          "彭",
          "郎",
          "魯",
          "韋",
          "昌",
          "馬",
          "苗",
          "鳳",
          "花",
          "方",
          "俞",
          "任",
          "袁",
          "柳",
          "酆",
          "鮑",
          "史",
          "唐",
          "費",
          "廉",
          "岑",
          "薛",
          "雷",
          "賀",
          "倪",
          "湯",
          "滕",
          "殷",
          "羅",
          "畢",
          "郝",
          "鄔",
          "安",
          "常",
          "樂",
          "於",
          "時",
          "傅",
          "皮",
          "卞",
          "齊",
          "康",
          "伍",
          "餘",
          "元",
          "蔔",
          "顧",
          "孟",
          "平",
          "黃",
          "和",
          "穆",
          "蕭",
          "尹",
          "姚",
          "邵",
          "湛",
          "汪",
          "祁",
          "毛",
          "禹",
          "狄",
          "米",
          "貝",
          "明",
          "臧",
          "計",
          "伏",
          "成",
          "戴",
          "談",
          "宋",
          "茅",
          "龐",
          "熊",
          "紀",
          "舒",
          "屈",
          "項",
          "祝",
          "董",
          "梁",
          "杜",
          "阮",
          "藍",
          "閔",
          "席",
          "季",
          "麻",
          "強",
          "賈",
          "路",
          "婁",
          "危",
          "江",
          "童",
          "顏",
          "郭",
          "梅",
          "盛",
          "林",
          "刁",
          "鍾",
          "徐",
          "邱",
          "駱",
          "高",
          "夏",
          "蔡",
          "田",
          "樊",
          "胡",
          "淩",
          "霍",
          "虞",
          "萬",
          "支",
          "柯",
          "昝",
          "管",
          "盧",
          "莫",
          "柯",
          "房",
          "裘",
          "繆",
          "幹",
          "解",
          "應",
          "宗",
          "丁",
          "宣",
          "賁",
          "鄧",
          "鬱",
          "單",
          "杭",
          "洪",
          "包",
          "諸",
          "左",
          "石",
          "崔",
          "吉",
          "鈕",
          "龔",
          "程",
          "嵇",
          "邢",
          "滑",
          "裴",
          "陸",
          "榮",
          "翁",
          "荀",
          "羊",
          "于",
          "惠",
          "甄",
          "曲",
          "家",
          "封",
          "芮",
          "羿",
          "儲",
          "靳",
          "汲",
          "邴",
          "糜",
          "松",
          "井",
          "段",
          "富",
          "巫",
          "烏",
          "焦",
          "巴",
          "弓",
          "牧",
          "隗",
          "山",
          "穀",
          "車",
          "侯",
          "宓",
          "蓬",
          "全",
          "郗",
          "班",
          "仰",
          "秋",
          "仲",
          "伊",
          "宮",
          "甯",
          "仇",
          "欒",
          "暴",
          "甘",
          "鈄",
          "曆",
          "戎",
          "祖",
          "武",
          "符",
          "劉",
          "景",
          "詹",
          "束",
          "龍",
          "葉",
          "幸",
          "司",
          "韶",
          "郜",
          "黎",
          "薊",
          "溥",
          "印",
          "宿",
          "白",
          "懷",
          "蒲",
          "邰",
          "從",
          "鄂",
          "索",
          "鹹",
          "籍",
          "賴",
          "卓",
          "藺",
          "屠",
          "蒙",
          "池",
          "喬",
          "陽",
          "鬱",
          "胥",
          "能",
          "蒼",
          "雙",
          "聞",
          "莘",
          "党",
          "翟",
          "譚",
          "貢",
          "勞",
          "逄",
          "姬",
          "申",
          "扶",
          "堵",
          "冉",
          "宰",
          "酈",
          "雍",
          "卻",
          "璩",
          "桑",
          "桂",
          "濮",
          "牛",
          "壽",
          "通",
          "邊",
          "扈",
          "燕",
          "冀",
          "浦",
          "尚",
          "農",
          "溫",
          "別",
          "莊",
          "晏",
          "柴",
          "瞿",
          "閻",
          "充",
          "慕",
          "連",
          "茹",
          "習",
          "宦",
          "艾",
          "魚",
          "容",
          "向",
          "古",
          "易",
          "慎",
          "戈",
          "廖",
          "庾",
          "終",
          "暨",
          "居",
          "衡",
          "步",
          "都",
          "耿",
          "滿",
          "弘",
          "匡",
          "國",
          "文",
          "寇",
          "廣",
          "祿",
          "闕",
          "東",
          "歐",
          "殳",
          "沃",
          "利",
          "蔚",
          "越",
          "夔",
          "隆",
          "師",
          "鞏",
          "厙",
          "聶",
          "晁",
          "勾",
          "敖",
          "融",
          "冷",
          "訾",
          "辛",
          "闞",
          "那",
          "簡",
          "饒",
          "空",
          "曾",
          "毋",
          "沙",
          "乜",
          "養",
          "鞠",
          "須",
          "豐",
          "巢",
          "關",
          "蒯",
          "相",
          "查",
          "後",
          "荊",
          "紅",
          "遊",
          "竺",
          "權",
          "逮",
          "盍",
          "益",
          "桓",
          "公",
          "萬俟",
          "司馬",
          "上官",
          "歐陽",
          "夏侯",
          "諸葛",
          "聞人",
          "東方",
          "赫連",
          "皇甫",
          "尉遲",
          "公羊",
          "澹台",
          "公冶",
          "宗政",
          "濮陽",
          "淳于",
          "單於",
          "太叔",
          "申屠",
          "公孫",
          "仲孫",
          "軒轅",
          "令狐",
          "徐離",
          "宇文",
          "長孫",
          "慕容",
          "司徒",
          "司空"
        ],
        "name": [
          "#{last_name}#{first_name}"
        ],
        "name_with_middle": [
          "#{last_name}#{first_name}"
        ]
      },
      "phone_number": {
        "formats": [
          "###-########",
          "####-########",
          "###########"
        ]
      }
    },
    "hello": "你好",
    "helpers": {
      "select": {
        "prompt": "請選擇"
      },
      "submit": {
        "create": "新增%{model}",
        "submit": "儲存%{model}",
        "update": "更新%{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "NT$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "十億",
            "million": "百萬",
            "quadrillion": "千兆",
            "thousand": "千",
            "trillion": "兆",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "位元組",
              "other": "位元組"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": "、",
        "two_words_connector": "和",
        "words_connector": "、"
      }
    },
    "time": {
      "am": "上午",
      "formats": {
        "default": "%Y年%m月%d日 %A %H:%M:%S %Z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%Y年%m月%d日 %H:%M",
        "short": "%m月%d日 %H:%M"
      },
      "pm": "下午"
    },
    "welcome": "歡迎"
  },
  "zh-YUE": {
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": null,
          "confirmation_token": null,
          "confirmed_at": null,
          "created_at": null,
          "current_password": null,
          "current_sign_in_at": null,
          "current_sign_in_ip": null,
          "email": null,
          "encrypted_password": null,
          "failed_attempts": null,
          "last_sign_in_at": null,
          "last_sign_in_ip": null,
          "locked_at": null,
          "password": null,
          "password_confirmation": null,
          "remember_created_at": null,
          "remember_me": null,
          "reset_password_sent_at": null,
          "reset_password_token": null,
          "sign_in_count": null,
          "unconfirmed_email": null,
          "unlock_token": null,
          "updated_at": null
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "驗證失敗：%{errors}",
          "restrict_dependent_destroy": {
            "has_many": "唔可以刪除，因為%{record}要用佢",
            "has_one": "唔可以刪除，因為%{record}要用佢"
          }
        }
      },
      "models": {
        "user": null
      }
    },
    "date": {
      "abbr_day_names": [
        "週日",
        "週一",
        "週二",
        "週三",
        "週四",
        "週五",
        "週六"
      ],
      "abbr_month_names": [
        null,
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      "day_names": [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%Y年%b%d日",
        "short": "%b%d日"
      },
      "month_names": [
        null,
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": "大概%{count}個鐘",
        "about_x_months": "大概%{count}個月",
        "about_x_years": "大概%{count}年",
        "almost_x_years": "差唔多%{count}年",
        "half_a_minute": "半分鐘",
        "less_than_x_minutes": "唔夠%{count}分鐘",
        "less_than_x_seconds": "唔夠%{count}秒",
        "over_x_years": "超過%{count}年",
        "x_days": "%{count}日",
        "x_minutes": "%{count}分鐘",
        "x_months": "%{count}個月",
        "x_seconds": "%{count}秒",
        "x_years": "%{count}年"
      },
      "prompts": {
        "day": "日",
        "hour": "點",
        "minute": "分",
        "month": "月",
        "second": "秒",
        "year": "年"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "啟用同埋登入咗帳戶。",
        "new": {
          "resend_confirmation_instructions": null
        },
        "send_instructions": "幾分鐘之後，你會收到一封電郵，入面有啟用帳戶嘅步驟。",
        "send_paranoid_instructions": "如果我哋既紀錄入面有呢個電郵的話，幾分鐘之後，你會收到一封電郵，入面有啟用帳戶嘅步驟。"
      },
      "failure": {
        "already_authenticated": "已經登入咗。",
        "inactive": "帳戶未啟用。",
        "invalid": null,
        "last_attempt": "你仲有一次嘗試正確密碼嘅機會，過後你嘅帳戶會被鎖住。",
        "locked": "你個帳戶已經鎖咗。",
        "not_found_in_database": null,
        "timeout": "超時，請重新登入。",
        "unauthenticated": "請登入，或者開個帳戶。",
        "unconfirmed": "帳戶未啟用。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "subject": "啟用帳戶"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "message_unconfirmed": null,
          "subject": null
        },
        "password_change": {
          "greeting": null,
          "message": null,
          "subject": null
        },
        "reset_password_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "instruction_2": null,
          "instruction_3": null,
          "subject": "重設密碼"
        },
        "unlock_instructions": {
          "action": null,
          "greeting": null,
          "instruction": null,
          "message": null,
          "subject": "帳戶解鎖"
        }
      },
      "omniauth_callbacks": {
        "failure": "由%{kind}登入唔到，原因︰%{reason}。",
        "success": "%{kind}登入成功。"
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": null,
          "send_me_reset_password_instructions": null
        },
        "no_token": "請肯定網址係密碼重設電郵入面嗰個。唔經呢封電郵睇唔到呢版。",
        "send_instructions": "幾分鐘之後，你會收到一封電郵，入面有重設密碼嘅步驟。",
        "send_paranoid_instructions": "如果我哋既紀錄入面有呢個電郵的話，幾分鐘之後，你會收到一封電郵，入面有重設密碼嘅步驟。",
        "updated": "成功改咗密碼；重新登入咗。",
        "updated_not_active": "成功改咗密碼。"
      },
      "registrations": {
        "destroyed": "帳戶已經註銷。有緣再會。",
        "edit": {
          "are_you_sure": null,
          "cancel_my_account": null,
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": null,
          "title": null,
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": null
        },
        "new": {
          "sign_up": null
        },
        "signed_up": "註冊咗。歡迎！",
        "signed_up_but_inactive": "註冊咗；不過要啟用埋帳戶先可以登入。",
        "signed_up_but_locked": "註冊咗；不過帳戶鎖咗，未可以登入住。",
        "signed_up_but_unconfirmed": "註冊咗；你會收到封電郵，入面有啟用帳戶嘅步驟。",
        "update_needs_confirmation": "更新咗帳戶。你會喺新電郵地址收到封電郵，入面有確認新電郵步驟。",
        "updated": "更新咗帳戶。",
        "updated_but_not_signed_in": null
      },
      "sessions": {
        "already_signed_out": "登出成功。",
        "new": {
          "sign_in": null
        },
        "signed_in": "登入咗。",
        "signed_out": "登出咗。"
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": null,
          "didn_t_receive_unlock_instructions": null,
          "forgot_your_password": null,
          "sign_in": null,
          "sign_in_with_provider": null,
          "sign_up": null
        },
        "minimum_password_length": null
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": null
        },
        "send_instructions": "幾分鐘之後，你會收到一封電郵，入面有帳戶解鎖嘅步驟。",
        "send_paranoid_instructions": "如果我哋既紀錄入面有呢個帳戶的話，幾分鐘之後，你會收到一封電郵，入面有帳戶解鎖嘅步驟。",
        "unlocked": "帳戶解咗鎖；請重新登入。"
      }
    },
    "errors": {
      "format": "%{attribute}%{message}",
      "messages": {
        "accepted": "一定要被接受",
        "already_confirmed": "已經啟用咗；可以登入。",
        "blank": "唔可以空白",
        "confirmation": "與%{attribute}唔夾",
        "confirmation_period_expired": "超時。請重新要過個，然後喺%{period}之內確認。",
        "empty": "唔可以漏空",
        "equal_to": "要等於%{count}",
        "even": "要係雙數",
        "exclusion": "唔用得",
        "expired": "超時。請重新要過個。",
        "greater_than": "要大過%{count}",
        "greater_than_or_equal_to": "要大過或者等於%{count}",
        "inclusion": "唔係可被接受嘅內容",
        "invalid": "無效",
        "less_than": "要細過%{count}",
        "less_than_or_equal_to": "要細過或者等於%{count}",
        "model_invalid": "驗證失敗：%{errors}",
        "not_a_number": "唔係一個數字",
        "not_an_integer": "要係整數",
        "not_found": "搵唔到",
        "not_locked": "無鎖到",
        "not_saved": "有%{count}個問題，%{resource}儲存唔到。",
        "odd": "要係單數",
        "other_than": "唔可以係%{count} 個字",
        "present": "一定要空白",
        "required": "必須存在",
        "taken": "已經用緊",
        "too_long": "太長（最多%{count}個字）",
        "too_short": "太短（最少%{count}個字）",
        "wrong_length": "唔啱字數（要係%{count}個字）"
      },
      "template": {
        "body": "呢啲有問題：",
        "header": "有%{count}個問題，%{model}儲存唔到。"
      }
    },
    "helpers": {
      "select": {
        "prompt": "請喺度揀"
      },
      "submit": {
        "create": "新增%{model}",
        "submit": "儲存%{model}",
        "update": "更新%{model}"
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "other"
        ]
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "HK$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "十億",
            "million": "百萬",
            "quadrillion": "千兆",
            "thousand": "千",
            "trillion": "兆",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": false,
          "strip_insignificant_zeros": false
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": "、",
        "two_words_connector": "同",
        "words_connector": "、"
      }
    },
    "time": {
      "am": "上晝",
      "formats": {
        "default": "%Y年%m月%d號 %A %H:%M:%S %Z",
        "long": "%Y年%m月%d號 %H:%M",
        "short": "%m月%d號 %H:%M"
      },
      "pm": "下晝"
    }
  }
}